
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("qrY1c", function(module, exports) {

$parcel$export(module.exports, "getSpaRoutes", () => $d48f2d8fb891a8d9$export$10439de9ce871f28);
/*
 * This file is generated. Do not modify manually
 * If you are adding or deleting a route, please run "yarn dev routes:generate-route-assets"
 * to re-generate this SPA route map and RouteName/RouteGroup types then commit the changes.
 * @generated SignedSource<<ba1725614d968711e65b0c217d090790>>
 * @codegen-command: yarn dev routes:generate-route-map --filter spa
 */ 
var $fJ15R = parcelRequire("fJ15R");

var $4eOkX = parcelRequire("4eOkX");

var $iGXDp = parcelRequire("iGXDp");

var $jMKrp = parcelRequire("jMKrp");

var $gK0o2 = parcelRequire("gK0o2");

var $7WGkO = parcelRequire("7WGkO");

var $aPhVH = parcelRequire("aPhVH");

var $9JhPg = parcelRequire("9JhPg");

var $7y12x = parcelRequire("7y12x");

var $54Mg6 = parcelRequire("54Mg6");

var $kZGLD = parcelRequire("kZGLD");

var $5y94r = parcelRequire("5y94r");

var $3cJRB = parcelRequire("3cJRB");

var $apVTf = parcelRequire("apVTf");

var $2PFkC = parcelRequire("2PFkC");

var $7lkHZ = parcelRequire("7lkHZ");

var $fxZdD = parcelRequire("fxZdD");

var $aCLGk = parcelRequire("aCLGk");

var $eJqY3 = parcelRequire("eJqY3");

var $1lOAz = parcelRequire("1lOAz");

var $eOLN9 = parcelRequire("eOLN9");

var $2bnuQ = parcelRequire("2bnuQ");

var $iDdAu = parcelRequire("iDdAu");

var $3cedS = parcelRequire("3cedS");

var $cLZj8 = parcelRequire("cLZj8");

var $Nhl2o = parcelRequire("Nhl2o");

var $g0EQq = parcelRequire("g0EQq");

var $5NEJc = parcelRequire("5NEJc");

var $9AeX2 = parcelRequire("9AeX2");

var $hjFNU = parcelRequire("hjFNU");

var $9enxs = parcelRequire("9enxs");

var $hMZzF = parcelRequire("hMZzF");

var $jVidq = parcelRequire("jVidq");

var $c7xWN = parcelRequire("c7xWN");

var $bGwGo = parcelRequire("bGwGo");

var $dRVNt = parcelRequire("dRVNt");

var $9qNa5 = parcelRequire("9qNa5");

var $2MZpi = parcelRequire("2MZpi");

var $5JNuq = parcelRequire("5JNuq");

var $1w4c6 = parcelRequire("1w4c6");

var $bP5Jb = parcelRequire("bP5Jb");

var $d065h = parcelRequire("d065h");

var $7O1yF = parcelRequire("7O1yF");

var $66eA2 = parcelRequire("66eA2");

var $5GAw8 = parcelRequire("5GAw8");

var $amJJx = parcelRequire("amJJx");

var $eijnk = parcelRequire("eijnk");

var $fvYEf = parcelRequire("fvYEf");

var $kNuDg = parcelRequire("kNuDg");

var $XhYcm = parcelRequire("XhYcm");

var $4OGAK = parcelRequire("4OGAK");

var $5wrsY = parcelRequire("5wrsY");

var $e2Odp = parcelRequire("e2Odp");

var $djb2Z = parcelRequire("djb2Z");

var $5xUFr = parcelRequire("5xUFr");

var $45FXR = parcelRequire("45FXR");

var $d5FsU = parcelRequire("d5FsU");

var $7kn5P = parcelRequire("7kn5P");

var $gjSfP = parcelRequire("gjSfP");

var $7aHwj = parcelRequire("7aHwj");

var $hULAZ = parcelRequire("hULAZ");

var $8WHEn = parcelRequire("8WHEn");

var $6BJfU = parcelRequire("6BJfU");

var $a7Dk4 = parcelRequire("a7Dk4");

var $eAKSk = parcelRequire("eAKSk");

var $j9RxE = parcelRequire("j9RxE");

var $cprgG = parcelRequire("cprgG");

var $aGmFb = parcelRequire("aGmFb");

var $7x2TW = parcelRequire("7x2TW");

var $d6OfK = parcelRequire("d6OfK");

var $4vMYX = parcelRequire("4vMYX");

var $13I6Z = parcelRequire("13I6Z");

var $5IMFp = parcelRequire("5IMFp");

var $eCSHY = parcelRequire("eCSHY");

var $k7BXo = parcelRequire("k7BXo");

var $5ClpU = parcelRequire("5ClpU");

var $74BfF = parcelRequire("74BfF");

var $2r2Qz = parcelRequire("2r2Qz");

var $cyLCh = parcelRequire("cyLCh");

var $gUidc = parcelRequire("gUidc");

var $6p8i9 = parcelRequire("6p8i9");

var $4RXNm = parcelRequire("4RXNm");

var $94WeZ = parcelRequire("94WeZ");

var $lO0b1 = parcelRequire("lO0b1");

var $81S4s = parcelRequire("81S4s");

var $cGZ5m = parcelRequire("cGZ5m");

var $2BDh0 = parcelRequire("2BDh0");

var $c7HRO = parcelRequire("c7HRO");

var $2wLap = parcelRequire("2wLap");

var $3arhy = parcelRequire("3arhy");

var $9IZNs = parcelRequire("9IZNs");

var $1YKQh = parcelRequire("1YKQh");

var $5vEtc = parcelRequire("5vEtc");

var $l1629 = parcelRequire("l1629");

var $e54wO = parcelRequire("e54wO");

var $ft8RF = parcelRequire("ft8RF");

var $bwD6U = parcelRequire("bwD6U");

var $frNhT = parcelRequire("frNhT");

var $iZ2AQ = parcelRequire("iZ2AQ");

var $2d55w = parcelRequire("2d55w");

var $3bo4c = parcelRequire("3bo4c");

var $kINnF = parcelRequire("kINnF");

var $fkKo1 = parcelRequire("fkKo1");

var $4BD3h = parcelRequire("4BD3h");

var $czPgr = parcelRequire("czPgr");

var $7Zjtg = parcelRequire("7Zjtg");

var $1Jz0d = parcelRequire("1Jz0d");

var $kJhhx = parcelRequire("kJhhx");

var $5Ufi9 = parcelRequire("5Ufi9");

var $l8WGY = parcelRequire("l8WGY");

var $d29rL = parcelRequire("d29rL");

var $47SW5 = parcelRequire("47SW5");

var $jP5bP = parcelRequire("jP5bP");

var $lmaBn = parcelRequire("lmaBn");

var $6egyA = parcelRequire("6egyA");

var $5JjgV = parcelRequire("5JjgV");

var $gTM9q = parcelRequire("gTM9q");

var $bJd2N = parcelRequire("bJd2N");

var $2Q9dT = parcelRequire("2Q9dT");

var $hr8RB = parcelRequire("hr8RB");

var $haVHi = parcelRequire("haVHi");

var $gCQuB = parcelRequire("gCQuB");

var $4gFBe = parcelRequire("4gFBe");

var $dCYpv = parcelRequire("dCYpv");

var $ezywV = parcelRequire("ezywV");

var $iXFOs = parcelRequire("iXFOs");

var $dqsu7 = parcelRequire("dqsu7");

var $j3oaw = parcelRequire("j3oaw");

var $atZb5 = parcelRequire("atZb5");

var $bcSH6 = parcelRequire("bcSH6");

var $L6NLT = parcelRequire("L6NLT");

var $d1pTa = parcelRequire("d1pTa");

var $42xEn = parcelRequire("42xEn");

var $6y1qE = parcelRequire("6y1qE");

var $5UUbR = parcelRequire("5UUbR");

var $djdJN = parcelRequire("djdJN");

var $5ylat = parcelRequire("5ylat");

var $dEChv = parcelRequire("dEChv");

var $7YInD = parcelRequire("7YInD");

var $kXXTW = parcelRequire("kXXTW");

var $6aBHI = parcelRequire("6aBHI");

var $85n74 = parcelRequire("85n74");

var $ekFnU = parcelRequire("ekFnU");

var $3s5Pk = parcelRequire("3s5Pk");

var $Vlf4X = parcelRequire("Vlf4X");

var $7JuWl = parcelRequire("7JuWl");

var $4kc5Q = parcelRequire("4kc5Q");

var $ksM4d = parcelRequire("ksM4d");

var $czFX6 = parcelRequire("czFX6");

var $keKPA = parcelRequire("keKPA");

var $437TO = parcelRequire("437TO");

var $6HVt9 = parcelRequire("6HVt9");

var $7RQxY = parcelRequire("7RQxY");

var $5ZQVr = parcelRequire("5ZQVr");

var $1PFei = parcelRequire("1PFei");

var $11NnB = parcelRequire("11NnB");

var $gRPtE = parcelRequire("gRPtE");

var $4xmZV = parcelRequire("4xmZV");

var $bv6P6 = parcelRequire("bv6P6");

var $lGtFG = parcelRequire("lGtFG");

var $ilnMG = parcelRequire("ilnMG");

var $3baNr = parcelRequire("3baNr");

var $fuBQx = parcelRequire("fuBQx");

var $4Bcd1 = parcelRequire("4Bcd1");

var $flxCZ = parcelRequire("flxCZ");

var $k85NS = parcelRequire("k85NS");

var $dyOQA = parcelRequire("dyOQA");

var $898Bv = parcelRequire("898Bv");

var $2Z13m = parcelRequire("2Z13m");

var $cZnHb = parcelRequire("cZnHb");

var $ExJeP = parcelRequire("ExJeP");

var $5CWoo = parcelRequire("5CWoo");

var $fBUuA = parcelRequire("fBUuA");

var $3WFhy = parcelRequire("3WFhy");

var $7T8Ox = parcelRequire("7T8Ox");

var $8H8bx = parcelRequire("8H8bx");

var $bI8Dj = parcelRequire("bI8Dj");

var $4cnHJ = parcelRequire("4cnHJ");

var $g6DXA = parcelRequire("g6DXA");

var $tNfGA = parcelRequire("tNfGA");

var $4szwi = parcelRequire("4szwi");

var $f7XdL = parcelRequire("f7XdL");

var $goUY1 = parcelRequire("goUY1");

var $cpLuR = parcelRequire("cpLuR");

var $5KbgO = parcelRequire("5KbgO");

var $d3qbB = parcelRequire("d3qbB");

var $kLk7C = parcelRequire("kLk7C");

var $fcC3H = parcelRequire("fcC3H");

var $4CAXG = parcelRequire("4CAXG");

var $kZ7rD = parcelRequire("kZ7rD");

var $dChQF = parcelRequire("dChQF");

var $67YRM = parcelRequire("67YRM");

var $bWzV9 = parcelRequire("bWzV9");

var $aieAu = parcelRequire("aieAu");

var $hEWb7 = parcelRequire("hEWb7");

var $dVpvh = parcelRequire("dVpvh");

var $iLf1F = parcelRequire("iLf1F");

var $2zDjc = parcelRequire("2zDjc");

var $9Isj0 = parcelRequire("9Isj0");

var $bs2w3 = parcelRequire("bs2w3");

var $jlE2b = parcelRequire("jlE2b");

var $kDttK = parcelRequire("kDttK");

var $20DnI = parcelRequire("20DnI");

var $81vTA = parcelRequire("81vTA");

var $f0p1P = parcelRequire("f0p1P");

var $1yaIP = parcelRequire("1yaIP");

var $bksGt = parcelRequire("bksGt");

var $WOvcu = parcelRequire("WOvcu");

var $kaoIS = parcelRequire("kaoIS");

var $1B1tE = parcelRequire("1B1tE");

var $a155r = parcelRequire("a155r");

var $brOp7 = parcelRequire("brOp7");

var $7JuPt = parcelRequire("7JuPt");

var $kTUT3 = parcelRequire("kTUT3");

var $cHL3P = parcelRequire("cHL3P");

var $fSwF2 = parcelRequire("fSwF2");

var $4VbNK = parcelRequire("4VbNK");

var $25Xvp = parcelRequire("25Xvp");

var $5uVut = parcelRequire("5uVut");

var $qU7hK = parcelRequire("qU7hK");

var $9cLPB = parcelRequire("9cLPB");

var $cVu4s = parcelRequire("cVu4s");

var $dceq5 = parcelRequire("dceq5");

var $i1SxF = parcelRequire("i1SxF");

var $64vgo = parcelRequire("64vgo");

var $9hXyI = parcelRequire("9hXyI");

var $1PXic = parcelRequire("1PXic");

var $pX4Kl = parcelRequire("pX4Kl");

var $7lW5H = parcelRequire("7lW5H");

var $7RzXN = parcelRequire("7RzXN");

var $8M7gQ = parcelRequire("8M7gQ");

var $4AyGF = parcelRequire("4AyGF");

var $MBVfl = parcelRequire("MBVfl");

var $4w8EY = parcelRequire("4w8EY");

var $eYdQw = parcelRequire("eYdQw");

var $lOn6l = parcelRequire("lOn6l");

var $37pqk = parcelRequire("37pqk");

var $gymKR = parcelRequire("gymKR");

var $dJkii = parcelRequire("dJkii");

var $7M3Qw = parcelRequire("7M3Qw");

var $kSzi3 = parcelRequire("kSzi3");

var $eIWvD = parcelRequire("eIWvD");

var $5HdwO = parcelRequire("5HdwO");

var $9kaa4 = parcelRequire("9kaa4");

var $7lqd9 = parcelRequire("7lqd9");

var $bxEah = parcelRequire("bxEah");

var $ytX2z = parcelRequire("ytX2z");

var $5rr5U = parcelRequire("5rr5U");

var $fFeTt = parcelRequire("fFeTt");

var $9onbT = parcelRequire("9onbT");

var $i6owk = parcelRequire("i6owk");

var $6tmSj = parcelRequire("6tmSj");

var $2KqMs = parcelRequire("2KqMs");

var $5ZNYc = parcelRequire("5ZNYc");

var $hPiSX = parcelRequire("hPiSX");

var $5JYqa = parcelRequire("5JYqa");

var $ljCsD = parcelRequire("ljCsD");

var $lIqxK = parcelRequire("lIqxK");

var $2Q6z2 = parcelRequire("2Q6z2");

var $c0nCS = parcelRequire("c0nCS");

var $1U37F = parcelRequire("1U37F");

var $3ZA2n = parcelRequire("3ZA2n");

var $ghxYA = parcelRequire("ghxYA");

var $bMvJs = parcelRequire("bMvJs");

var $ffcU3 = parcelRequire("ffcU3");

var $eWBMh = parcelRequire("eWBMh");

var $7lsw4 = parcelRequire("7lsw4");

var $bMj4d = parcelRequire("bMj4d");

var $6XPJ5 = parcelRequire("6XPJ5");

var $1fi5O = parcelRequire("1fi5O");

var $3DoQq = parcelRequire("3DoQq");

var $dpAnL = parcelRequire("dpAnL");

var $20wcj = parcelRequire("20wcj");

var $1lGts = parcelRequire("1lGts");

var $j3R4j = parcelRequire("j3R4j");

var $gG5r4 = parcelRequire("gG5r4");

var $jYWZX = parcelRequire("jYWZX");

var $21gXe = parcelRequire("21gXe");

var $5jjQ1 = parcelRequire("5jjQ1");

var $1MGof = parcelRequire("1MGof");

var $i5Fsz = parcelRequire("i5Fsz");

var $3mrXC = parcelRequire("3mrXC");

var $4SqLF = parcelRequire("4SqLF");

var $bRYwY = parcelRequire("bRYwY");

var $C784O = parcelRequire("C784O");

var $6hSMD = parcelRequire("6hSMD");

var $bWZUz = parcelRequire("bWZUz");

var $ihfrS = parcelRequire("ihfrS");

var $kMe3w = parcelRequire("kMe3w");

var $id9nd = parcelRequire("id9nd");

var $7K8ER = parcelRequire("7K8ER");

var $bIDIn = parcelRequire("bIDIn");

var $iaJjO = parcelRequire("iaJjO");

var $flrMb = parcelRequire("flrMb");

var $10xT1 = parcelRequire("10xT1");

var $5oAgu = parcelRequire("5oAgu");

var $k5e75 = parcelRequire("k5e75");

var $leBbj = parcelRequire("leBbj");

var $jlwtU = parcelRequire("jlwtU");

var $3yeCC = parcelRequire("3yeCC");

var $4FBBR = parcelRequire("4FBBR");

var $d5Bb9 = parcelRequire("d5Bb9");

var $jSGUL = parcelRequire("jSGUL");

var $bJXfU = parcelRequire("bJXfU");

var $k3Rn6 = parcelRequire("k3Rn6");

var $5DVEh = parcelRequire("5DVEh");

var $jJEm7 = parcelRequire("jJEm7");

var $flxMn = parcelRequire("flxMn");

var $iJbtQ = parcelRequire("iJbtQ");

var $98Umx = parcelRequire("98Umx");

var $33RDm = parcelRequire("33RDm");

var $9a7o3 = parcelRequire("9a7o3");

var $7Al9R = parcelRequire("7Al9R");

var $4p5og = parcelRequire("4p5og");

var $01dV2 = parcelRequire("01dV2");

var $eDNar = parcelRequire("eDNar");

var $cWeYh = parcelRequire("cWeYh");

var $0eLvf = parcelRequire("0eLvf");

var $avhOT = parcelRequire("avhOT");

var $jXIBH = parcelRequire("jXIBH");

var $f0kp3 = parcelRequire("f0kp3");

var $1zTPx = parcelRequire("1zTPx");

var $hpFrr = parcelRequire("hpFrr");

var $deNkw = parcelRequire("deNkw");

var $b89Z5 = parcelRequire("b89Z5");

var $i7x71 = parcelRequire("i7x71");

var $iifeU = parcelRequire("iifeU");

var $6szZq = parcelRequire("6szZq");

var $bWhAh = parcelRequire("bWhAh");

var $e8aTE = parcelRequire("e8aTE");

var $iIHov = parcelRequire("iIHov");

var $iuWdX = parcelRequire("iuWdX");

var $1hrj9 = parcelRequire("1hrj9");

var $aanGM = parcelRequire("aanGM");

var $35zIt = parcelRequire("35zIt");

var $7V5F5 = parcelRequire("7V5F5");

var $lAyQF = parcelRequire("lAyQF");

var $9Gw9x = parcelRequire("9Gw9x");

var $uS0Wn = parcelRequire("uS0Wn");

var $3CKd6 = parcelRequire("3CKd6");

var $emNcb = parcelRequire("emNcb");

var $bb3Kz = parcelRequire("bb3Kz");

var $fAxRm = parcelRequire("fAxRm");

var $gLtBa = parcelRequire("gLtBa");

var $3d0g1 = parcelRequire("3d0g1");

var $7mEsO = parcelRequire("7mEsO");

var $j2UMI = parcelRequire("j2UMI");

var $l29cD = parcelRequire("l29cD");

var $eze04 = parcelRequire("eze04");

var $9B4ho = parcelRequire("9B4ho");

var $dMtOC = parcelRequire("dMtOC");

var $2cgig = parcelRequire("2cgig");

var $9GvQT = parcelRequire("9GvQT");

var $65d18 = parcelRequire("65d18");

var $7ucgW = parcelRequire("7ucgW");

var $dVWks = parcelRequire("dVWks");

var $0MUFU = parcelRequire("0MUFU");

var $1yqW3 = parcelRequire("1yqW3");

var $9rb1x = parcelRequire("9rb1x");

var $af0ih = parcelRequire("af0ih");

var $8Qqsd = parcelRequire("8Qqsd");

var $d1As4 = parcelRequire("d1As4");

var $9tjWC = parcelRequire("9tjWC");

var $kwERN = parcelRequire("kwERN");

var $773VE = parcelRequire("773VE");

var $jiUh1 = parcelRequire("jiUh1");

var $8Iv3H = parcelRequire("8Iv3H");

var $f83an = parcelRequire("f83an");

var $cWPJr = parcelRequire("cWPJr");

var $4BOoE = parcelRequire("4BOoE");

var $h7Red = parcelRequire("h7Red");

var $7Pdre = parcelRequire("7Pdre");

var $20zzw = parcelRequire("20zzw");

var $h4zAy = parcelRequire("h4zAy");

var $4WoRT = parcelRequire("4WoRT");

var $im6xk = parcelRequire("im6xk");

var $6P2Hr = parcelRequire("6P2Hr");

var $lJuD5 = parcelRequire("lJuD5");

var $kjUZx = parcelRequire("kjUZx");

var $4yidD = parcelRequire("4yidD");

var $ikmMT = parcelRequire("ikmMT");

var $cw1uU = parcelRequire("cw1uU");

var $3wFf4 = parcelRequire("3wFf4");

var $85Rgm = parcelRequire("85Rgm");

var $2Uft0 = parcelRequire("2Uft0");

var $jCXKu = parcelRequire("jCXKu");

var $k25kz = parcelRequire("k25kz");

var $ebqmN = parcelRequire("ebqmN");

var $43NlL = parcelRequire("43NlL");

var $2LDVV = parcelRequire("2LDVV");

var $9RMhv = parcelRequire("9RMhv");

var $h3kpF = parcelRequire("h3kpF");

var $23ehb = parcelRequire("23ehb");

var $70AS8 = parcelRequire("70AS8");

var $ceWLf = parcelRequire("ceWLf");

var $fKViZ = parcelRequire("fKViZ");

var $5k4zE = parcelRequire("5k4zE");

var $5w2Cj = parcelRequire("5w2Cj");

var $cq7wq = parcelRequire("cq7wq");

var $bBqyO = parcelRequire("bBqyO");

var $cM5pJ = parcelRequire("cM5pJ");

var $95uMc = parcelRequire("95uMc");

var $61kne = parcelRequire("61kne");

var $85bCZ = parcelRequire("85bCZ");

var $ihexr = parcelRequire("ihexr");

var $3jDGC = parcelRequire("3jDGC");

var $kmfhe = parcelRequire("kmfhe");

var $3VkWO = parcelRequire("3VkWO");

var $grzdo = parcelRequire("grzdo");

var $b29TL = parcelRequire("b29TL");

var $csLF9 = parcelRequire("csLF9");

var $dTlAf = parcelRequire("dTlAf");

var $dKx89 = parcelRequire("dKx89");

var $bWmUQ = parcelRequire("bWmUQ");

var $hT9aM = parcelRequire("hT9aM");

var $dpK5U = parcelRequire("dpK5U");

var $f60wn = parcelRequire("f60wn");

var $18Mhr = parcelRequire("18Mhr");

var $iCcmc = parcelRequire("iCcmc");

var $f0hVi = parcelRequire("f0hVi");

var $j9UDw = parcelRequire("j9UDw");

var $fmhFi = parcelRequire("fmhFi");

var $1Zxl4 = parcelRequire("1Zxl4");

var $2rBHC = parcelRequire("2rBHC");

var $lxP9C = parcelRequire("lxP9C");

var $etWAS = parcelRequire("etWAS");

var $lMs1U = parcelRequire("lMs1U");

var $apRSQ = parcelRequire("apRSQ");

var $evzjc = parcelRequire("evzjc");

var $dG9Ao = parcelRequire("dG9Ao");

var $eksQM = parcelRequire("eksQM");

var $a0D4V = parcelRequire("a0D4V");

var $7mKmY = parcelRequire("7mKmY");

var $5UnPY = parcelRequire("5UnPY");

var $fQdWc = parcelRequire("fQdWc");

var $dOUgk = parcelRequire("dOUgk");

var $kxzOk = parcelRequire("kxzOk");

var $3uU32 = parcelRequire("3uU32");

var $bpzvw = parcelRequire("bpzvw");

var $5Ojcr = parcelRequire("5Ojcr");

var $3Yt6X = parcelRequire("3Yt6X");

var $hAJ7N = parcelRequire("hAJ7N");

var $e9fEq = parcelRequire("e9fEq");

var $jxIae = parcelRequire("jxIae");

var $19r4K = parcelRequire("19r4K");

var $1Dztl = parcelRequire("1Dztl");

var $1O3Ea = parcelRequire("1O3Ea");

var $e9Gfy = parcelRequire("e9Gfy");

var $7RDKl = parcelRequire("7RDKl");

var $b2ykh = parcelRequire("b2ykh");

var $g8YQf = parcelRequire("g8YQf");

var $4OHhm = parcelRequire("4OHhm");

var $3qny0 = parcelRequire("3qny0");

var $yk8YA = parcelRequire("yk8YA");

var $kt0QB = parcelRequire("kt0QB");

var $9oXBQ = parcelRequire("9oXBQ");

var $iBuWD = parcelRequire("iBuWD");

var $jLhoT = parcelRequire("jLhoT");

var $6Lgr4 = parcelRequire("6Lgr4");

var $4KZfr = parcelRequire("4KZfr");

var $b7rZt = parcelRequire("b7rZt");

var $5QSRE = parcelRequire("5QSRE");

var $02HAY = parcelRequire("02HAY");

var $9QPcQ = parcelRequire("9QPcQ");

var $aZHdl = parcelRequire("aZHdl");

var $307rd = parcelRequire("307rd");

var $cLEqv = parcelRequire("cLEqv");

var $i0o2E = parcelRequire("i0o2E");

var $fQjCK = parcelRequire("fQjCK");

var $kDBV4 = parcelRequire("kDBV4");

var $3gALM = parcelRequire("3gALM");

var $6l8wI = parcelRequire("6l8wI");

var $kzJod = parcelRequire("kzJod");

var $2jzeY = parcelRequire("2jzeY");

var $80YBd = parcelRequire("80YBd");

var $lfdJB = parcelRequire("lfdJB");

var $d8BX1 = parcelRequire("d8BX1");

var $hDTQX = parcelRequire("hDTQX");

var $3NN4E = parcelRequire("3NN4E");

var $6034y = parcelRequire("6034y");

var $lCqer = parcelRequire("lCqer");

var $4YOsq = parcelRequire("4YOsq");

var $3Rt1x = parcelRequire("3Rt1x");

var $6cbbu = parcelRequire("6cbbu");

var $bSbiO = parcelRequire("bSbiO");

var $2M4fN = parcelRequire("2M4fN");

var $kqm46 = parcelRequire("kqm46");

var $8LN4T = parcelRequire("8LN4T");

var $27YPb = parcelRequire("27YPb");

var $5tYtA = parcelRequire("5tYtA");

var $BcNEN = parcelRequire("BcNEN");

var $2uDzR = parcelRequire("2uDzR");

var $8hfgf = parcelRequire("8hfgf");

var $57C4N = parcelRequire("57C4N");

var $9vC5r = parcelRequire("9vC5r");

var $4XaE0 = parcelRequire("4XaE0");

var $3OnXm = parcelRequire("3OnXm");

var $bGvUH = parcelRequire("bGvUH");

var $aWhYZ = parcelRequire("aWhYZ");

var $6S0Dc = parcelRequire("6S0Dc");

var $hGerI = parcelRequire("hGerI");

var $6mL7K = parcelRequire("6mL7K");

var $5S3BI = parcelRequire("5S3BI");

var $6gpWo = parcelRequire("6gpWo");

var $iUcGR = parcelRequire("iUcGR");

var $2n5BQ = parcelRequire("2n5BQ");

var $fToBW = parcelRequire("fToBW");

var $jcgn0 = parcelRequire("jcgn0");

var $apCqz = parcelRequire("apCqz");

var $lkzh1 = parcelRequire("lkzh1");

var $1tJbT = parcelRequire("1tJbT");

var $1p45F = parcelRequire("1p45F");

var $1IT3x = parcelRequire("1IT3x");

var $eXAfa = parcelRequire("eXAfa");

var $WBDy8 = parcelRequire("WBDy8");

var $d0HTh = parcelRequire("d0HTh");

var $43iIQ = parcelRequire("43iIQ");

var $70DsH = parcelRequire("70DsH");

var $4ZKoO = parcelRequire("4ZKoO");

var $ebcb6 = parcelRequire("ebcb6");

var $7HZi8 = parcelRequire("7HZi8");

var $lw128 = parcelRequire("lw128");

var $hAgX3 = parcelRequire("hAgX3");

var $5xDmP = parcelRequire("5xDmP");

var $fKnCL = parcelRequire("fKnCL");

var $39J1B = parcelRequire("39J1B");

var $7Toln = parcelRequire("7Toln");

var $cTtTO = parcelRequire("cTtTO");

var $dP6oq = parcelRequire("dP6oq");

var $1cWr6 = parcelRequire("1cWr6");

var $e2eAj = parcelRequire("e2eAj");

var $hhVkJ = parcelRequire("hhVkJ");

var $kD0Ge = parcelRequire("kD0Ge");

var $gEBbt = parcelRequire("gEBbt");

var $2PL7S = parcelRequire("2PL7S");

var $agCim = parcelRequire("agCim");

var $cnG0j = parcelRequire("cnG0j");

var $ghBxE = parcelRequire("ghBxE");

var $lMO7Z = parcelRequire("lMO7Z");

var $fvFxE = parcelRequire("fvFxE");

var $dut0s = parcelRequire("dut0s");

var $jUCVx = parcelRequire("jUCVx");

var $fBXou = parcelRequire("fBXou");

var $28WgX = parcelRequire("28WgX");

var $ekqRf = parcelRequire("ekqRf");

var $fPxUZ = parcelRequire("fPxUZ");

var $gqwG0 = parcelRequire("gqwG0");

var $8CLhe = parcelRequire("8CLhe");

var $d3dv3 = parcelRequire("d3dv3");

var $izixQ = parcelRequire("izixQ");

var $gZq43 = parcelRequire("gZq43");

var $9uidf = parcelRequire("9uidf");

var $lHdES = parcelRequire("lHdES");

var $8gAuW = parcelRequire("8gAuW");

var $jgRv0 = parcelRequire("jgRv0");

var $iBcSa = parcelRequire("iBcSa");

var $bJiYi = parcelRequire("bJiYi");

var $9NWq7 = parcelRequire("9NWq7");

var $hnYNr = parcelRequire("hnYNr");

var $gSlgn = parcelRequire("gSlgn");

var $cENRX = parcelRequire("cENRX");

var $f0Lah = parcelRequire("f0Lah");

var $5psoN = parcelRequire("5psoN");

var $1kaFK = parcelRequire("1kaFK");

var $kRlsB = parcelRequire("kRlsB");

var $cK5xr = parcelRequire("cK5xr");

var $43qOr = parcelRequire("43qOr");

var $gYfl3 = parcelRequire("gYfl3");

var $jo8cE = parcelRequire("jo8cE");

var $kKMOG = parcelRequire("kKMOG");

var $aNCbW = parcelRequire("aNCbW");

var $2AYKc = parcelRequire("2AYKc");

var $cJqhS = parcelRequire("cJqhS");

var $ejo5K = parcelRequire("ejo5K");

var $hnRYr = parcelRequire("hnRYr");

var $88nEe = parcelRequire("88nEe");

var $4nTz0 = parcelRequire("4nTz0");

var $8W2c8 = parcelRequire("8W2c8");

var $5gnJR = parcelRequire("5gnJR");

var $gkm2X = parcelRequire("gkm2X");

var $csjBW = parcelRequire("csjBW");

var $lj5Av = parcelRequire("lj5Av");

var $byNoq = parcelRequire("byNoq");

var $lMawn = parcelRequire("lMawn");

var $hK8mq = parcelRequire("hK8mq");

var $33rS9 = parcelRequire("33rS9");

var $6PPxR = parcelRequire("6PPxR");

var $5JTZa = parcelRequire("5JTZa");

var $jSZVk = parcelRequire("jSZVk");

var $8JIqa = parcelRequire("8JIqa");

var $bTXFE = parcelRequire("bTXFE");

var $exjbO = parcelRequire("exjbO");

var $37n4w = parcelRequire("37n4w");

var $l7Kcl = parcelRequire("l7Kcl");

var $kbvuM = parcelRequire("kbvuM");

var $1XNI6 = parcelRequire("1XNI6");

var $8RT9n = parcelRequire("8RT9n");

var $9kqeg = parcelRequire("9kqeg");

var $hRXMa = parcelRequire("hRXMa");

var $lPhuN = parcelRequire("lPhuN");

var $4Cdj7 = parcelRequire("4Cdj7");

var $lxvYO = parcelRequire("lxvYO");

var $6XvFv = parcelRequire("6XvFv");

var $jZv6V = parcelRequire("jZv6V");

var $b5gw6 = parcelRequire("b5gw6");

var $2YbyC = parcelRequire("2YbyC");

var $hykoI = parcelRequire("hykoI");

var $2dAZL = parcelRequire("2dAZL");

var $6Rmp2 = parcelRequire("6Rmp2");

var $3FQCK = parcelRequire("3FQCK");

var $5v5xs = parcelRequire("5v5xs");

var $9vlCj = parcelRequire("9vlCj");

var $algSY = parcelRequire("algSY");

var $chmwv = parcelRequire("chmwv");

var $ilU7w = parcelRequire("ilU7w");

var $1DVzF = parcelRequire("1DVzF");

var $7ccps = parcelRequire("7ccps");

var $1Pj99 = parcelRequire("1Pj99");

var $ff5dM = parcelRequire("ff5dM");

var $aLXiu = parcelRequire("aLXiu");

var $kHsPZ = parcelRequire("kHsPZ");

var $30PHd = parcelRequire("30PHd");

var $aGFMx = parcelRequire("aGFMx");

var $fFZgu = parcelRequire("fFZgu");

var $hAVk6 = parcelRequire("hAVk6");

var $72a1U = parcelRequire("72a1U");

var $luRFY = parcelRequire("luRFY");

var $3dqLQ = parcelRequire("3dqLQ");

var $gxAJV = parcelRequire("gxAJV");

var $dLExR = parcelRequire("dLExR");

var $5zVch = parcelRequire("5zVch");

var $2ZnyJ = parcelRequire("2ZnyJ");

var $lGz7G = parcelRequire("lGz7G");

var $aPs1z = parcelRequire("aPs1z");

var $91LPB = parcelRequire("91LPB");

var $e6ehT = parcelRequire("e6ehT");

var $gAUgF = parcelRequire("gAUgF");

var $7eIYH = parcelRequire("7eIYH");

var $6dPXJ = parcelRequire("6dPXJ");

var $k80dv = parcelRequire("k80dv");

var $dw2ce = parcelRequire("dw2ce");

var $eSIYo = parcelRequire("eSIYo");

var $gLWOL = parcelRequire("gLWOL");

var $YXwcg = parcelRequire("YXwcg");

var $lFKeR = parcelRequire("lFKeR");

var $1xutc = parcelRequire("1xutc");

var $ed2hW = parcelRequire("ed2hW");

var $9iKlG = parcelRequire("9iKlG");

var $dfVfw = parcelRequire("dfVfw");

var $fWDhV = parcelRequire("fWDhV");

var $khKzX = parcelRequire("khKzX");

var $kzxfE = parcelRequire("kzxfE");

var $eF6xc = parcelRequire("eF6xc");

var $7wJLb = parcelRequire("7wJLb");

var $hN6Yh = parcelRequire("hN6Yh");

var $5dzzd = parcelRequire("5dzzd");

var $eyWIM = parcelRequire("eyWIM");

var $5OhH5 = parcelRequire("5OhH5");

var $eOJip = parcelRequire("eOJip");

var $jG7gV = parcelRequire("jG7gV");

var $P4w4L = parcelRequire("P4w4L");

var $8mw4w = parcelRequire("8mw4w");

var $gJeDi = parcelRequire("gJeDi");

var $sK3EH = parcelRequire("sK3EH");

var $cOBeu = parcelRequire("cOBeu");

var $b4ktm = parcelRequire("b4ktm");

var $bbpTw = parcelRequire("bbpTw");

var $hSovm = parcelRequire("hSovm");

var $bwfaS = parcelRequire("bwfaS");

var $3B2tH = parcelRequire("3B2tH");

var $k5ls9 = parcelRequire("k5ls9");

var $4MZMG = parcelRequire("4MZMG");

var $24gKw = parcelRequire("24gKw");

var $g09EF = parcelRequire("g09EF");

var $as2yW = parcelRequire("as2yW");

var $jlw0X = parcelRequire("jlw0X");

var $VMQYl = parcelRequire("VMQYl");

var $8t3Bs = parcelRequire("8t3Bs");

var $gqlkg = parcelRequire("gqlkg");

var $4W2Ve = parcelRequire("4W2Ve");

var $2qWaR = parcelRequire("2qWaR");

var $1rAP5 = parcelRequire("1rAP5");

var $4MsHe = parcelRequire("4MsHe");

var $ASOiD = parcelRequire("ASOiD");

var $bxGoH = parcelRequire("bxGoH");

var $7dAIb = parcelRequire("7dAIb");

var $53Ske = parcelRequire("53Ske");

var $l6W7I = parcelRequire("l6W7I");

var $77YbO = parcelRequire("77YbO");

var $dNIAB = parcelRequire("dNIAB");

var $zhYLc = parcelRequire("zhYLc");

var $kZdpv = parcelRequire("kZdpv");

var $g70C8 = parcelRequire("g70C8");

var $ckYTZ = parcelRequire("ckYTZ");
const $d48f2d8fb891a8d9$export$10439de9ce871f28 = ()=>[
        (0, $fJ15R.aiAnswersRouteEntry),
        (0, $4eOkX.alertPoliciesRouteEntry),
        (0, $iGXDp.applinksAdministrationEditRouteEntry),
        (0, $jMKrp.applinksAdministrationListRouteEntry),
        (0, $gK0o2.applinksExtraAuthHealthcheckRouteEntry),
        (0, $7WGkO.appRequestsRouteEntry),
        (0, $aPhVH.archivedIssuesRedirectRouteEntry),
        (0, $9JhPg.archivedPlansRouteEntry),
        (0, $7y12x.archivedProjectDirectLinkRouteEntry),
        (0, $54Mg6.archivedProjectsDirectoryRouteEntry),
        (0, $kZGLD.archivedWorkItemsJsmRouteEntry),
        (0, $5y94r.archivedWorkItemsJswCompanyRouteEntry),
        (0, $3cJRB.archivedWorkItemsJswRouteEntry),
        (0, $apVTf.archivedWorkItemsJwmRouteEntry),
        (0, $2PFkC.arjCalendarEmbedRouteEntry),
        (0, $7lkHZ.arjDependenciesEmbedRouteEntry),
        (0, $fxZdD.arjIncrementEmbedRouteEntry),
        (0, $aCLGk.arjSettingsDependenciesLegacyRedirectRouteEntry),
        (0, $eJqY3.arjSettingsDependenciesRouteEntry),
        (0, $1lOAz.arjSettingsFinancialYearPageRouteEntry),
        (0, $eOLN9.arjSettingsLoadingLimitsLegacyRedirectRouteEntry),
        (0, $2bnuQ.arjSettingsLoadingLimitsRouteEntry),
        (0, $iDdAu.arjSettingsPermissionsRouteEntry),
        (0, $3cedS.arjSettingsPermissionsRouteLegacyRedirectRouteEntry),
        (0, $cLZj8.arjSummaryEmbedRouteEntry),
        (0, $Nhl2o.arjTimelineEmbedRouteEntry),
        (0, $g0EQq.assetsAnalyticsDataViewCreateRouteEntry),
        (0, $5NEJc.assetsAnalyticsDataViewDetailsRouteEntry),
        (0, $9AeX2.assetsAnalyticsDataViewListRouteEntry),
        (0, $hjFNU.assetsConfigurationRouteEntry),
        (0, $9enxs.assetsDataManagerDataSourceRouteEntry),
        (0, $hMZzF.assetsDataManagerGettingStartedRouteEntry),
        (0, $jVidq.assetsDataManagerObjectClassesRouteEntry),
        (0, $c7xWN.assetsDataManagerObjectClassViewRouteEntry),
        (0, $bGwGo.assetsObjectRouteEntry),
        (0, $dRVNt.assetsObjectTypeConfigurationRouteEntry),
        (0, $9qNa5.assetsReportsRouteEntry),
        (0, $2MZpi.assetsReportsTemplateRouteEntry),
        (0, $5JNuq.assetsReportsUnsubscribeRouteEntry),
        (0, $1w4c6.assetsRouteEntry),
        (0, $bP5Jb.assetsSchemaConfigurationRouteEntry),
        (0, $d065h.assetsSchemaRouteEntry),
        (0, $7O1yF.assetsSearchRouteEntry),
        (0, $66eA2.boardsDirectoryRedirectRouteEntry),
        (0, $5GAw8.boardsDirectoryRouteEntry),
        (0, $amJJx.browseConversationsRouteEntry),
        (0, $eijnk.browseIntentsRouteEntry),
        (0, $fvYEf.browseIssueEmbedRouteEntry),
        (0, $kNuDg.browseIssueRouteEntry),
        (0, $XhYcm.browseProjectRedirectRouteEntry),
        (0, $4OGAK.browseStandardFlowsRouteEntry),
        (0, $5wrsY.classicBusinessOverviewCalendarRouteEntry),
        (0, $e2Odp.classicBusinessOverviewSummaryRouteEntry),
        (0, $djb2Z.classicBusinessOverviewTimelineRouteEntry),
        (0, $5xUFr.classicBusinessProformaIssueFormsDirectEmbedRouteEntry),
        (0, $45FXR.classicBusinessProformaIssueFormsDirectRouteEntry),
        (0, $d5FsU.classicBusinessProjectApprovalsRouteEntry),
        (0, $7kn5P.classicBusinessProjectFormBuilderRouteEntry),
        (0, $gjSfP.classicBusinessProjectFormRouteEntry),
        (0, $7aHwj.classicBusinessProjectFormSubmitEmbedRouteEntry),
        (0, $hULAZ.classicBusinessProjectFormSubmitPublicRouteEntry),
        (0, $8WHEn.classicBusinessProjectFormSubmitRouteEntry),
        (0, $6BJfU.classicBusinessProjectPagesRouteEntry),
        (0, $a7Dk4.classicBusinessProjectShortcutRouteEntry),
        (0, $eAKSk.classicBusinessProjectViewNotFoundRouteEntry),
        (0, $j9RxE.classicProjectSettingsDataClassificationsRouteEntry),
        (0, $cprgG.classicProjectSettingsDetailsRouteEntry),
        (0, $aGmFb.classicProjectSettingsFeaturesRouteEntry),
        (0, $7x2TW.classicProjectSettingsIssueLayoutRouteEntry),
        (0, $d6OfK.classicProjectSettingsOpsgenieRouteEntry),
        (0, $4vMYX.classicProjectSettingsSoftwareNotificationsIssueLogsRouteEntry),
        (0, $13I6Z.classicProjectSettingsSoftwareProformaEditFormsRouteEntry),
        (0, $5IMFp.classicProjectSettingsSoftwareProformaFormsRouteEntry),
        (0, $eCSHY.classicProjectSettingsSoftwareRedirectRouteEntry),
        (0, $k7BXo.classicProjectSettingsToolchainRouteEntry),
        (0, $5ClpU.classicSoftwareBacklogEmbedRouteEntry),
        (0, $74BfF.classicSoftwareBacklogRouteEntry),
        (0, $2r2Qz.classicSoftwareBoardEmbedRouteEntry),
        (0, $cyLCh.classicSoftwareBoardRouteEntry),
        (0, $gUidc.classicSoftwareBoardSettingsInsightsRapidboardBacklogRouteEntry),
        (0, $6p8i9.classicSoftwareBoardSettingsInsightsRapidboardBoardRouteEntry),
        (0, $4RXNm.classicSoftwareBoardSettingsRouteEntry),
        (0, $94WeZ.cmpVelocityRouteEntry),
        (0, $lO0b1.commsStatusPageManageRouteEntry),
        (0, $81S4s.communicationsStakeholderGroupsRouteEntry),
        (0, $cGZ5m.communicationsStakeholdersRouteEntry),
        (0, $2BDh0.compassProductSettingsRouteEntry),
        (0, $c7HRO.connectGeneralInvalidRouteEntry),
        (0, $2wLap.connectGeneralRouteEntry),
        (0, $3arhy.connectGeneralServiceDeskProjectRouteEntry),
        (0, $9IZNs.connectProjectRouteEntry),
        (0, $1YKQh.createProjectRouteEntry),
        (0, $5vEtc.customerServiceEscalationsRouteEntry),
        (0, $l1629.customerServiceProductsRouteEntry),
        (0, $e54wO.customIssueRouteEntry),
        (0, $ft8RF.customPracticeQueueBoardRouteEntry),
        (0, $bwD6U.customPracticeQueueCalendarRouteEntry),
        (0, $frNhT.customPracticeQueueRouteEntry),
        (0, $iZ2AQ.customQueueBoardRouteEntry),
        (0, $2d55w.customQueueCalendarRouteEntry),
        (0, $3bo4c.customQueueRouteEntry),
        (0, $kINnF.dashboardEditRouteEntry),
        (0, $fkKo1.dashboardRouteEntry),
        (0, $4BD3h.dashboardsDirectoryRedirectRouteEntry),
        (0, $czPgr.dashboardsDirectoryRouteEntry),
        (0, $7Zjtg.dashboardViewEmbedRouteEntry),
        (0, $1Jz0d.dashboardViewRouteEntry),
        (0, $kJhhx.dashboardWallboardRouteEntry),
        (0, $5Ufi9.devopsConnectedProjectRouteEntry),
        (0, $l8WGY.digestsNotificationsPersonalSettingsRouteEntry),
        (0, $d29rL.emailNotificationsLogAccessRouteEntry),
        (0, $47SW5.eocAlertIssueSyncingCreateRouteEntry),
        (0, $jP5bP.eocAlertIssueSyncingDetailRouteEntry),
        (0, $lmaBn.eocAlertIssueSyncingRouteEntry),
        (0, $6egyA.eocApiKeyManagementRouteEntry),
        (0, $5JjgV.eocAssignCustomRolesRouteEntry),
        (0, $gTM9q.eocAutomationsRouteEntry),
        (0, $bJd2N.eocCustomRolesRouteEntry),
        (0, $2Q9dT.eocGlobalAlertListRedirectRouteEntry),
        (0, $hr8RB.eocGlobalAlertListRouteEntry),
        (0, $haVHi.eocGlobalAlertsDetailRouteEntry),
        (0, $gCQuB.eocGlobalGroupDetailRouteEntry),
        (0, $4gFBe.eocGlobalHeartbeatsRouteEntry),
        (0, $dCYpv.eocGlobalMaintenanceRouteEntry),
        (0, $ezywV.eocGlobalReportsHomePageNav4RouteEntry),
        (0, $iXFOs.eocGlobalReportsNav4RouteEntry),
        (0, $dqsu7.eocHeartbeatsRouteEntry),
        (0, $j3oaw.eocMaintenanceRouteEntry),
        (0, $atZb5.eocOnCallRedirectRouteEntry),
        (0, $bcSH6.eocOnCallRouteEntry),
        (0, $L6NLT.eocOverviewAllTeamsRouteEntry),
        (0, $d1pTa.eocOverviewRouteEntry),
        (0, $42xEn.eocPermissionsRouteEntry),
        (0, $6y1qE.eocReportsTeamRedirectRouteEntry),
        (0, $5UUbR.eocReportsTeamRouteEntry),
        (0, $djdJN.eocReportsUnsubscribeRouteEntry),
        (0, $5ylat.eocScheduleGlobalRouteEntry),
        (0, $dEChv.eocTeamAlertDetailRouteEntry),
        (0, $7YInD.eocTeamAlertIssueSyncingCreateRouteEntry),
        (0, $kXXTW.eocTeamAlertIssueSyncingDetailRouteEntry),
        (0, $6aBHI.eocTeamAlertIssueSyncingRouteEntry),
        (0, $85n74.eocTeamAlertListRouteEntry),
        (0, $ekFnU.eocTeamCustomerLogsDownloadRouteEntry),
        (0, $3s5Pk.eocTeamCustomerLogsRouteEntry),
        (0, $Vlf4X.eocTeamGroupDetailRouteEntry),
        (0, $7JuWl.eocUserNotificationsRouteEntry),
        (0, $4kc5Q.errorsNotFoundRouteEntry),
        (0, $ksM4d.externalImportRouteEntry),
        (0, $czFX6.filtersDirectoryRedirectRouteEntry),
        (0, $keKPA.filtersDirectoryRouteEntry),
        (0, $437TO.findAppsRouteEntry),
        (0, $6HVt9.forgeAdminRouteEntry),
        (0, $7RQxY.forgeAdminSettingsRouteEntry),
        (0, $5ZQVr.forgeFieldContextualConfigurationRouteEntry),
        (0, $1PFei.forgeGlobalRouteEntry),
        (0, $11NnB.forgePersonalSettingsRouteEntry),
        (0, $gRPtE.forgeProjectRouteEntry),
        (0, $4xmZV.forgeProjectServicedeskRouteEntry),
        (0, $bv6P6.forgeServicedeskQueueRouteEntry),
        (0, $lGtFG.generalPersonalSettingsRouteEntry),
        (0, $ilnMG.globalEscalationsRouteEntry),
        (0, $3baNr.globalIncomingCallDetailRouteEntry),
        (0, $fuBQx.globalIncomingCallRouteEntry),
        (0, $4Bcd1.globalIntegrationCreateRouteEntry),
        (0, $flxCZ.globalIntegrationDetailRouteEntry),
        (0, $k85NS.globalIntegrationListRouteEntry),
        (0, $dyOQA.globalIntegrationLogRouteEntry),
        (0, $898Bv.globalIntegrationsRouteEntry),
        (0, $2Z13m.globalIssueNavigatorBrowseIssueRedirectRouteEntry),
        (0, $cZnHb.globalMailSettingsRouteEntry),
        (0, $ExJeP.globalPoliciesRouteEntry),
        (0, $5CWoo.globalSettingsContactAdministratorRouteEntry),
        (0, $fBUuA.globalSettingsCustomFieldsRouteEntry),
        (0, $3WFhy.globalSettingsEditPermissionSchemesRouteEntry),
        (0, $7T8Ox.globalSettingsFormDataConnectionsRouteEntry),
        (0, $8H8bx.globalSettingsGlobalPermissionsRouteEntry),
        (0, $bI8Dj.globalSettingsIssueFieldSchemeRouteEntry),
        (0, $4cnHJ.globalSettingsIssueFieldSchemesConfigRouteEntry),
        (0, $g6DXA.globalSettingsIssueFieldSchemesRouteEntry),
        (0, $tNfGA.globalSettingsIssueFieldScreensRouteEntry),
        (0, $4szwi.globalSettingsIssueFieldsManagementRouteEntry),
        (0, $f7XdL.globalSettingsIssueHierarchyRedirectRouteEntry),
        (0, $goUY1.globalSettingsIssueHierarchyRouteEntry),
        (0, $cpLuR.globalSettingsIssuesExplicitFieldAssociationRouteEntry),
        (0, $5KbgO.globalSettingsIssuesNewIssueSearchRouteEntry),
        (0, $d3qbB.globalSettingsIssuesPrioritiesRouteEntry),
        (0, $kLk7C.globalSettingsIssuesPrioritySchemesRouteEntry),
        (0, $fcC3H.globalSettingsIssueTypesRouteEntry),
        (0, $4CAXG.globalSettingsIssueTypesSchemesRouteEntry),
        (0, $kZ7rD.globalSettingsIssueTypesScreenSchemesRouteEntry),
        (0, $dChQF.globalSettingsIssueWorkflow1RouteEntry),
        (0, $67YRM.globalSettingsIssueWorkflowEditRouteEntry),
        (0, $bWzV9.globalSettingsLegacyFieldLayoutRouteEntry),
        (0, $aieAu.globalSettingsOptimizeFieldConfigurationSchemeRouteEntry),
        (0, $hEWb7.globalSettingsOptimizeWorkTypeSchemeRouteEntry),
        (0, $dVpvh.globalSettingsPerformanceCustomFieldCleanupRouteEntry),
        (0, $iLf1F.globalSettingsPerformanceCustomFieldProjectLimitRouteEntry),
        (0, $2zDjc.globalSettingsPerformanceCustomFieldRouteEntry),
        (0, $9Isj0.globalSettingsPerformanceIssueArchivalRouteEntry),
        (0, $bs2w3.globalSettingsPerformanceMetricDetailRouteEntry),
        (0, $jlE2b.globalSettingsPerformanceOverviewRouteEntry),
        (0, $kDttK.globalSettingsPerformanceProjectCleanupRouteEntry),
        (0, $20DnI.globalSettingsPerformanceProjectRoleActorRouteEntry),
        (0, $81vTA.globalSettingsPerformanceWorkTypeProjectLimitRouteEntry),
        (0, $f0p1P.globalSettingsPerformanceWorkTypeRouteEntry),
        (0, $1yaIP.globalSettingsPermissionSchemesRouteEntry),
        (0, $bksGt.globalSettingsSystemBulkMailRouteEntry),
        (0, $WOvcu.globalSettingsSystemUiAnnouncementBannerRouteEntry),
        (0, $kaoIS.helpCenterSettingsAgentStudioActionsRouteEntry),
        (0, $1B1tE.helpCenterSettingsAgentStudioChatSimulatorRouteEntry),
        (0, $a155r.helpCenterSettingsAgentStudioConversationReviewRouteEntry),
        (0, $brOp7.helpCenterSettingsAgentStudioHandoffRouteEntry),
        (0, $7JuPt.helpCenterSettingsAgentStudioKnowledgeRouteEntry),
        (0, $kTUT3.helpCenterSettingsAgentStudioRouteEntry),
        (0, $cHL3P.helpCenterSettingsAnalyticsRouteEntry),
        (0, $fSwF2.helpCenterSettingsArticlesRouteEntry),
        (0, $4VbNK.helpCenterSettingsArticlesViewArticleRouteEntry),
        (0, $25Xvp.helpCenterSettingsBrandingRouteEntry),
        (0, $5uVut.helpCenterSettingsCreateArticleRouteEntry),
        (0, $qU7hK.helpCenterSettingsCustomerAccessRouteEntry),
        (0, $9cLPB.helpCenterSettingsCustomerNotificationsRouteEntry),
        (0, $cVu4s.helpCenterSettingsDetailsRouteEntry),
        (0, $dceq5.helpCenterSettingsEmailRouteEntry),
        (0, $i1SxF.helpCenterSettingsFormEditRouteEntry),
        (0, $64vgo.helpCenterSettingsFormsRouteEntry),
        (0, $9hXyI.helpCenterSettingsKbRouteEntry),
        (0, $1PXic.helpCenterSettingsNotFoundRouteEntry),
        (0, $pX4Kl.helpCenterSettingsServiceHubsRouteEntry),
        (0, $7lW5H.helpCenterSettingsSupportWebsiteOverviewRouteEntry),
        (0, $7RzXN.helpCenterSettingsSupportWebsitePagesRouteEntry),
        (0, $8M7gQ.helpCenterSettingsSupportWebsiteRouteEntry),
        (0, $4AyGF.helpCenterSettingsWidgetConfigurationRouteEntry),
        (0, $MBVfl.homeOnboardingRedirectRouteEntry),
        (0, $4w8EY.homeRedirectRouteEntry),
        (0, $eYdQw.issueCreateEmbedRouteEntry),
        (0, $lOn6l.issueNavigatorGlobalJiraRouteEntry),
        (0, $37pqk.issueNavigatorGlobalRouteEntry),
        (0, $gymKR.issueNavigatorProjectBusinessCustomEmbedRouteEntry),
        (0, $dJkii.issueNavigatorProjectBusinessEmbedRouteEntry),
        (0, $7M3Qw.issueNavigatorProjectBusinessRouteEntry),
        (0, $kSzi3.issueNavigatorProjectClassicCustomEmbedRouteEntry),
        (0, $eIWvD.issueNavigatorProjectClassicEmbedRouteEntry),
        (0, $5HdwO.issueNavigatorProjectClassicRouteEntry),
        (0, $9kaa4.issueNavigatorProjectListServicedeskRouteEntry),
        (0, $7lqd9.issueNavigatorProjectServicedeskRouteEntry),
        (0, $bxEah.issueNavigatorProjectSoftwareCustomEmbedRouteEntry),
        (0, $ytX2z.issueNavigatorProjectSoftwareEmbedRouteEntry),
        (0, $5rr5U.issueNavigatorProjectSoftwareRouteEntry),
        (0, $fFeTt.jiraBusinessAttachmentsRouteEntry),
        (0, $9onbT.jiraBusinessBoardCustomEmbedRouteEntry),
        (0, $i6owk.jiraBusinessBoardEmbedRouteEntry),
        (0, $6tmSj.jiraBusinessBoardRouteEntry),
        (0, $2KqMs.jiraBusinessCalendarCustomEmbedRouteEntry),
        (0, $5ZNYc.jiraBusinessCalendarEmbedRouteEntry),
        (0, $hPiSX.jiraBusinessCalendarRouteEntry),
        (0, $5JYqa.jiraBusinessListCustomEmbedRouteEntry),
        (0, $ljCsD.jiraBusinessListEmbedRouteEntry),
        (0, $lIqxK.jiraBusinessListRouteEntry),
        (0, $2Q6z2.jiraBusinessOverviewRedirectRouteEntry),
        (0, $c0nCS.jiraBusinessProjectRedirectRouteEntry),
        (0, $1U37F.jiraBusinessReportsOverviewRouteEntry),
        (0, $3ZA2n.jiraBusinessSummaryEmbedRouteEntry),
        (0, $ghxYA.jiraBusinessSummaryRouteEntry),
        (0, $bMvJs.jiraBusinessTimelineEmbedRouteEntry),
        (0, $ffcU3.jiraBusinessTimelineRouteEntry),
        (0, $eWBMh.jiraHomeRouteEntry),
        (0, $7lsw4.jiraSearchRouteEntry),
        (0, $bMj4d.jsmBoardRouteEntry),
        (0, $6XPJ5.knowledgeHubAllArticlesRouteEntry),
        (0, $1fi5O.knowledgeHubArticleEmbedEditorRouteEntry),
        (0, $3DoQq.knowledgeHubArticleInCategoryRouteEntry),
        (0, $dpAnL.knowledgeHubBrowseAllArticlesRouteEntry),
        (0, $20wcj.knowledgeHubBrowseAllCategoriesRouteEntry),
        (0, $1lGts.knowledgeHubBrowseViewArticleRouteEntry),
        (0, $j3R4j.knowledgeHubCategoryPageRouteEntry),
        (0, $gG5r4.knowledgeHubCategoryRouteEntry),
        (0, $jYWZX.knowledgeHubDraftsRouteEntry),
        (0, $21gXe.knowledgeHubLandingRouteEntry),
        (0, $5jjQ1.knowledgeHubSearchRouteEntry),
        (0, $1MGof.knowledgeHubSetupRouteEntry),
        (0, $i5Fsz.knowledgeHubSuggestedArticlesRouteEntry),
        (0, $3mrXC.landingPageRouteEntry),
        (0, $4SqLF.legacyPlanPageRedirectRouteEntry),
        (0, $bRYwY.legacyPlanReportPageRedirectRouteEntry),
        (0, $C784O.legacyProjectReleasesNoteConfigRouteEntry),
        (0, $6hSMD.legacyProjectReleasesNoteRouteEntry),
        (0, $bWZUz.legacyRapidBoardRouteEntry),
        (0, $ihfrS.legacyRedirectRouteEntry),
        (0, $kMe3w.listRouteEntry),
        (0, $id9nd.loginEmbedRouteEntry),
        (0, $7K8ER.manageProjectsDirectoryRouteEntry),
        (0, $bIDIn.newRovoSearchRouteEntry),
        (0, $iaJjO.notificationLogsRouteEntry),
        (0, $flrMb.notificationsPersonalSettingsRouteEntry),
        (0, $10xT1.oldJiraHomeRouteEntry),
        (0, $5oAgu.opsgenieScheduleRedirectRouteEntry),
        (0, $k5e75.opsgenieScheduleRouteEntry),
        (0, $leBbj.opsNotificationsPersonalSettingsRouteEntry),
        (0, $jlwtU.peopleProfilesRouteEntry),
        (0, $3yeCC.performanceRouteEntry),
        (0, $4FBBR.personalSettingsRouteEntry),
        (0, $d5Bb9.piCreateIssueEmbedRouteEntry),
        (0, $jSGUL.piEditIssueEmbedRouteEntry),
        (0, $bJXfU.planExportPageRouteEntry),
        (0, $k3Rn6.planIncrementRouteEntry),
        (0, $5DVEh.planIncrementsRouteEntry),
        (0, $jJEm7.planPageRouteEntry),
        (0, $flxMn.planPageWithoutScenarioIdRouteEntry),
        (0, $iJbtQ.planReportPageRouteEntry),
        (0, $98Umx.plansDirectoryRouteEntry),
        (0, $33RDm.planSetupPageRouteEntry),
        (0, $9a7o3.planUpsellRouteEntry),
        (0, $7Al9R.planViewNotFoundRouteEntry),
        (0, $4p5og.polarisCollectionsRouteEntry),
        (0, $01dV2.polarisIdeasRouteEntry),
        (0, $eDNar.polarisOnboardingRouteEntry),
        (0, $cWeYh.polarisSettingsAccessRouteEntry),
        (0, $0eLvf.polarisSettingsDatesRouteEntry),
        (0, $avhOT.polarisSettingsEarlyAccessFeaturesRouteEntry),
        (0, $jXIBH.polarisSettingsGlobalFieldsRouteEntry),
        (0, $f0kp3.polarisSettingsViewBlueprintsRouteEntry),
        (0, $1zTPx.polarisUnlicensedRouteEntry),
        (0, $hpFrr.productsJcsCustomerAccessRouteEntry),
        (0, $deNkw.productsJcsFormFieldsRouteEntry),
        (0, $b89Z5.productsJsmAuthenticationSettingsRouteEntry),
        (0, $i7x71.productsJsmChatopsAndVideosToolsRouteEntry),
        (0, $iifeU.productsJsmComplianceRouteEntry),
        (0, $6szZq.productsJsmConfigurationRouteEntry),
        (0, $bWhAh.productsJsmCustomerAccessRouteEntry),
        (0, $e8aTE.productsJsmEmailRequestsRouteEntry),
        (0, $iIHov.productsJsmFeatureUsageRouteEntry),
        (0, $iuWdX.productsJsmGlobalOpsReportsRedirectRouteEntry),
        (0, $1hrj9.productsJsmGlobalOpsReportsRouteEntry),
        (0, $aanGM.productsJsmIncidentManagementToolsRouteEntry),
        (0, $35zIt.productsJsmKbPermissionsRouteEntry),
        (0, $7V5F5.productsJsmOrganizationsDetailsRouteEntry),
        (0, $lAyQF.productsJsmOrganizationsRouteEntry),
        (0, $9Gw9x.productsJswConfigurationRouteEntry),
        (0, $uS0Wn.productsJswStorageManagementRouteEntry),
        (0, $3CKd6.productsOnboardingHubCreateRouteEntry),
        (0, $emNcb.productsOnboardingHubEditRouteEntry),
        (0, $bb3Kz.productsOnboardingHubRouteEntry),
        (0, $fAxRm.proformaExportRouteEntry),
        (0, $gLtBa.proformaIssueFormsGeneralRouteEntry),
        (0, $3d0g1.projectComponentsRedirectRouteEntry),
        (0, $7mEsO.projectComponentsRouteEntry),
        (0, $j2UMI.projectDirectoryRedirectRouteEntry),
        (0, $l29cD.projectIssueNavigatorRouteEntry),
        (0, $eze04.projectNotFoundRouteEntry),
        (0, $9B4ho.projectPagesLegacyRouteEntry),
        (0, $dMtOC.projectPagesRouteEntry),
        (0, $2cgig.projectsDirectoryLegacyPathRedirectRouteEntry),
        (0, $9GvQT.projectsDirectoryManageRedirectRouteEntry),
        (0, $65d18.projectsDirectoryManageRootRedirectRouteEntry),
        (0, $7ucgW.projectsDirectoryRedirectRouteEntry),
        (0, $dVWks.projectsDirectoryRouteEntry),
        (0, $0MUFU.projectServiceDeskRouteEntry),
        (0, $1yqW3.projectSettingsAutomationCRouteEntry),
        (0, $9rb1x.projectSettingsAutomationRouteEntry),
        (0, $af0ih.projectSettingsComponentsRouteEntry),
        (0, $8Qqsd.projectSettingsCoreAccessRedirectRouteEntry),
        (0, $d1As4.projectSettingsCoreAccessRouteEntry),
        (0, $9tjWC.projectSettingsCoreApprovalsRouteEntry),
        (0, $kwERN.projectSettingsCoreAppsFieldsRouteEntry),
        (0, $773VE.projectSettingsCoreAppsRouteEntry),
        (0, $jiUh1.projectSettingsCoreAutomationRouteEntry),
        (0, $8Iv3H.projectSettingsCoreAutomationV2RouteEntry),
        (0, $f83an.projectSettingsCoreDataClassificationsRouteEntry),
        (0, $cWPJr.projectSettingsCoreDefaultRedirectRouteEntry),
        (0, $4BOoE.projectSettingsCoreDetailsRouteEntry),
        (0, $h7Red.projectSettingsCoreFieldsRouteEntry),
        (0, $7Pdre.projectSettingsCoreForgeAppsRouteEntry),
        (0, $20zzw.projectSettingsCoreIssueTypesRouteEntry),
        (0, $h4zAy.projectSettingsCoreIssueTypesWorkflowRouteEntry),
        (0, $4WoRT.projectSettingsCoreNotificationsEmailRouteEntry),
        (0, $im6xk.projectSettingsCoreNotificationsIssueLogsRouteEntry),
        (0, $6P2Hr.projectSettingsCoreNotificationsRouteEntry),
        (0, $lJuD5.projectSettingsCoreProformaJiraFormBuilderRouteEntry),
        (0, $kjUZx.projectSettingsCoreProformaProjectFormsRouteEntry),
        (0, $4yidD.projectSettingsCustomerServiceFeaturesRouteEntry),
        (0, $ikmMT.projectSettingsForgeAppsNextgenRouteEntry),
        (0, $cw1uU.projectSettingsForgeAppsRouteEntry),
        (0, $3wFf4.projectSettingsOpsgenieRouteEntry),
        (0, $85Rgm.projectSettingsServicedeskAccessRedirectRouteEntry),
        (0, $2Uft0.projectSettingsServicedeskAccessRouteEntry),
        (0, $jCXKu.projectSettingsServicedeskAppsFieldsRouteEntry),
        (0, $k25kz.projectSettingsServicedeskAppsRouteEntry),
        (0, $ebqmN.projectSettingsServicedeskAutomationCopyRuleRouteEntry),
        (0, $43NlL.projectSettingsServicedeskAutomationCreateRouteEntry),
        (0, $2LDVV.projectSettingsServicedeskAutomationEditRuleRouteEntry),
        (0, $9RMhv.projectSettingsServicedeskAutomationRouteEntry),
        (0, $h3kpF.projectSettingsServicedeskAutomationSummaryRouteEntry),
        (0, $23ehb.projectSettingsServicedeskAutomationViewLogRouteEntry),
        (0, $70AS8.projectSettingsServicedeskChangeManagementRouteEntry),
        (0, $ceWLf.projectSettingsServicedeskChannelsChatRouteEntry),
        (0, $fKViZ.projectSettingsServicedeskChannelsEmailNextGenRouteEntry),
        (0, $5k4zE.projectSettingsServicedeskChannelsPermissionsNextGenRouteEntry),
        (0, $5w2Cj.projectSettingsServicedeskChannelsPortalRouteEntry),
        (0, $cq7wq.projectSettingsServicedeskChannelsRouteEntry),
        (0, $bBqyO.projectSettingsServicedeskChannelsWidgetRouteEntry),
        (0, $cM5pJ.projectSettingsServicedeskChatRouteEntry),
        (0, $95uMc.projectSettingsServicedeskClassicAppsRouteEntry),
        (0, $61kne.projectSettingsServicedeskCustomerNotificationsRouteEntry),
        (0, $85bCZ.projectSettingsServicedeskCustomerPermissionsRouteEntry),
        (0, $ihexr.projectSettingsServicedeskDataClassificationsRouteEntry),
        (0, $3jDGC.projectSettingsServicedeskDetailsRouteEntry),
        (0, $kmfhe.projectSettingsServicedeskEmailRouteEntry),
        (0, $3VkWO.projectSettingsServicedeskExternalLinksRouteEntry),
        (0, $grzdo.projectSettingsServicedeskFeedbackRouteEntry),
        (0, $b29TL.projectSettingsServicedeskFieldsRouteEntry),
        (0, $csLF9.projectSettingsServicedeskForgeAppsRouteEntry),
        (0, $dTlAf.projectSettingsServicedeskIncidentManagementRouteEntry),
        (0, $dKx89.projectSettingsServicedeskInternalNotificationsNextGenRouteEntry),
        (0, $bWmUQ.projectSettingsServicedeskIssuetypesRouteEntry),
        (0, $hT9aM.projectSettingsServicedeskIssuetypesWorkflowRouteEntry),
        (0, $dpK5U.projectSettingsServicedeskItsmFeaturesRouteEntry),
        (0, $f60wn.projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry),
        (0, $18Mhr.projectSettingsServicedeskItsmTicketTypesConfigRouteEntry),
        (0, $iCcmc.projectSettingsServicedeskJourneyConfigurationEditRouteEntry),
        (0, $f0hVi.projectSettingsServicedeskJourneyConfigurationRouteEntry),
        (0, $j9UDw.projectSettingsServicedeskJourneysRouteEntry),
        (0, $fmhFi.projectSettingsServicedeskKbRouteEntry),
        (0, $1Zxl4.projectSettingsServicedeskLanguageKeyRouteEntry),
        (0, $2rBHC.projectSettingsServicedeskLanguageRouteEntry),
        (0, $lxP9C.projectSettingsServicedeskLegacyAutomationRedirectCopyRouteEntry),
        (0, $etWAS.projectSettingsServicedeskLegacyAutomationRedirectCreateRouteEntry),
        (0, $lMs1U.projectSettingsServicedeskLegacyAutomationRedirectEditRouteEntry),
        (0, $apRSQ.projectSettingsServicedeskLegacyAutomationRedirectSummaryRouteEntry),
        (0, $evzjc.projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry),
        (0, $dG9Ao.projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry),
        (0, $eksQM.projectSettingsServicedeskNotificationsEmailRouteEntry),
        (0, $a0D4V.projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry),
        (0, $7mKmY.projectSettingsServicedeskNotificationsNotificationEmailRouteEntry),
        (0, $5UnPY.projectSettingsServicedeskNotificationsRouteEntry),
        (0, $fQdWc.projectSettingsServicedeskOverviewRouteEntry),
        (0, $dOUgk.projectSettingsServicedeskPortalSettingsRouteEntry),
        (0, $kxzOk.projectSettingsServicedeskProformaJiraFormBuilderRouteEntry),
        (0, $3uU32.projectSettingsServicedeskProformaProjectFormsRouteEntry),
        (0, $bpzvw.projectSettingsServicedeskRedirectRouteEntry),
        (0, $5Ojcr.projectSettingsServicedeskTicketTypeFieldsRouteEntry),
        (0, $3Yt6X.projectSettingsServicedeskTicketTypesConfigRouteEntry),
        (0, $hAJ7N.projectSettingsServicedeskUnassignedTicketTypeFieldsRouteEntry),
        (0, $e9fEq.projectSettingsServicedeskUnassignedTicketTypesConfigRouteEntry),
        (0, $jxIae.projectSettingsServicedeskWidgetRouteEntry),
        (0, $19r4K.projectSettingsSoftwareAccessRedirectRouteEntry),
        (0, $1Dztl.projectSettingsSoftwareAccessRouteEntry),
        (0, $1O3Ea.projectSettingsSoftwareAppsFieldsRouteEntry),
        (0, $e9Gfy.projectSettingsSoftwareAppsRouteEntry),
        (0, $7RDKl.projectSettingsSoftwareAutomationRouteEntry),
        (0, $b2ykh.projectSettingsSoftwareBoardsCardRouteEntry),
        (0, $g8YQf.projectSettingsSoftwareBoardsCsmRouteEntry),
        (0, $4OHhm.projectSettingsSoftwareBoardsCustomFiltersRouteEntry),
        (0, $3qny0.projectSettingsSoftwareBoardsRedirectRouteEntry),
        (0, $yk8YA.projectSettingsSoftwareBoardsRoadmapRouteEntry),
        (0, $kt0QB.projectSettingsSoftwareBoardsTimelineRouteEntry),
        (0, $9oXBQ.projectSettingsSoftwareDataClassificationsRouteEntry),
        (0, $iBuWD.projectSettingsSoftwareDetailsRouteEntry),
        (0, $jLhoT.projectSettingsSoftwareFieldsRouteEntry),
        (0, $6Lgr4.projectSettingsSoftwareIssuetypesRouteEntry),
        (0, $4KZfr.projectSettingsSoftwareIssuetypesWorkflowRouteEntry),
        (0, $b7rZt.projectSettingsSoftwareNextGenFeaturesRouteEntry),
        (0, $5QSRE.projectSettingsSoftwareNotificationEmailCRouteEntry),
        (0, $02HAY.projectSettingsSoftwareNotificationEmailRouteEntry),
        (0, $9QPcQ.projectSettingsSoftwareNotificationsIssueLogsRouteEntry),
        (0, $aZHdl.projectSettingsSoftwareNotificationsRouteEntry),
        (0, $307rd.projectSettingsSoftwareProformaJiraFormBuilderRouteEntry),
        (0, $cLEqv.projectSettingsSoftwareProformaProjectFormsRouteEntry),
        (0, $i0o2E.projectSettingsSoftwareRedirectRouteEntry),
        (0, $fQjCK.projectSettingsToolchainRouteEntry),
        (0, $kDBV4.projectSettingsVersionsRouteEntry),
        (0, $3gALM.projectsRedirectRouteEntry),
        (0, $6l8wI.projectVersionsRouteEntry),
        (0, $kzJod.promotionsRouteEntry),
        (0, $2jzeY.rapidboardBacklog1RouteEntry),
        (0, $80YBd.rapidboardLastVisitedProjectRedirectRouteEntry),
        (0, $lfdJB.rapidboardReport1RouteEntry),
        (0, $d8BX1.rapidboardReportRouteEntry),
        (0, $hDTQX.rapidboardUserBacklogRouteEntry),
        (0, $3NN4E.rapidboardUserReportRouteEntry),
        (0, $6034y.rapidboardUserReportsOverviewRouteEntry),
        (0, $lCqer.roleBasedNotificationDetailRouteEntry),
        (0, $4YOsq.roleBasedNotificationsRouteEntry),
        (0, $3Rt1x.rovoSearchRouteEntry),
        (0, $6cbbu.sandboxBundlerBifrostEntrypointsRouteEntry),
        (0, $bSbiO.sandboxBundlerBifrostRLLRouteEntry),
        (0, $2M4fN.sandboxBundlerRouteEntry),
        (0, $kqm46.sandboxRelayEchoPageUsingEntryPointRouteEntry),
        (0, $8LN4T.sandboxRelayEchoPageUsingRLLRouteEntry),
        (0, $27YPb.sandboxRelayJiraPageRouteEntry),
        (0, $5tYtA.secureFiltersDirectoryRedirectRouteEntry),
        (0, $BcNEN.selectedDashboardRouteEntry),
        (0, $2uDzR.servicedeskAtlassianAnalyticsRouteEntry),
        (0, $8hfgf.servicedeskCalendarRouteEntry),
        (0, $57C4N.servicedeskChangeCalendarRouteEntry),
        (0, $9vC5r.servicedeskCmdbAssetsAnalyticsDataViewCreateRouteEntry),
        (0, $4XaE0.servicedeskCmdbAssetsAnalyticsDataViewDetailsRouteEntry),
        (0, $3OnXm.servicedeskCmdbAssetsAnalyticsDataViewListRouteEntry),
        (0, $bGvUH.servicedeskCmdbAssetsGlobalConfigurationRouteEntry),
        (0, $aWhYZ.servicedeskCmdbAssetsObjectRouteEntry),
        (0, $6S0Dc.servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry),
        (0, $hGerI.servicedeskCmdbAssetsObjectSchemaRouteEntry),
        (0, $6mL7K.servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry),
        (0, $5S3BI.servicedeskCmdbAssetsReportsRouteEntry),
        (0, $6gpWo.servicedeskCmdbAssetsReportsTemplateRouteEntry),
        (0, $iUcGR.servicedeskCmdbAssetsReportsUnsubscribeRouteEntry),
        (0, $2n5BQ.servicedeskCmdbAssetsSchemasRouteEntry),
        (0, $fToBW.servicedeskCmdbInsightConfigureGlobalRouteEntry),
        (0, $jcgn0.servicedeskCmdbInsightConfigureRouteEntry),
        (0, $apCqz.servicedeskCmdbInsightObject4RouteEntry),
        (0, $lkzh1.servicedeskCmdbInsightObjectSchemaConfigurationRouteEntry),
        (0, $1tJbT.servicedeskCmdbInsightObjectSchemaRouteEntry),
        (0, $1p45F.servicedeskCmdbInsightObjectTypeConfigurationRouteEntry),
        (0, $1IT3x.servicedeskCmdbInsightRouteEntry),
        (0, $eXAfa.servicedeskConnectProjectRouteEntry),
        (0, $WBDy8.servicedeskCreateProjectRouteEntry),
        (0, $d0HTh.servicedeskCustomerDetailsRouteEntry),
        (0, $43iIQ.servicedeskCustomersV2RouteEntry),
        (0, $70DsH.servicedeskGettingStartedRouteEntry),
        (0, $4ZKoO.servicedeskIssueRouteEntry),
        (0, $ebcb6.servicedeskItsmSampleSpaceRouteEntry),
        (0, $7HZi8.servicedeskKbRequestsReports2RouteEntry),
        (0, $lw128.servicedeskKbRequestsReportsIssueRouteEntry),
        (0, $hAgX3.servicedeskKbRequestsReportsTimeScaleRouteEntry),
        (0, $5xDmP.servicedeskOncallScheduleRouteEntry),
        (0, $fKnCL.servicedeskOrganizationDetailsRouteEntry),
        (0, $39J1B.servicedeskOrganizationsRouteEntry),
        (0, $7Toln.servicedeskOrganizationV2RouteEntry),
        (0, $cTtTO.servicedeskPlaybooksEditRouteEntry),
        (0, $dP6oq.servicedeskPlaybooksListRouteEntry),
        (0, $1cWr6.servicedeskPracticeEditRouteEntry),
        (0, $e2eAj.servicedeskPracticeIssueRouteEntry),
        (0, $hhVkJ.servicedeskPracticeLandingRouteEntry),
        (0, $kD0Ge.servicedeskPracticeManageViewRouteEntry),
        (0, $gEBbt.servicedeskPracticeNewRouteEntry),
        (0, $2PL7S.servicedeskPracticeViewsConfigRouteEntry),
        (0, $agCim.servicedeskProformaIssueFormsDirectEmbedRouteEntry),
        (0, $cnG0j.servicedeskProformaIssueFormsDirectRouteEntry),
        (0, $ghBxE.servicedeskProjectDashboardsEditableRouteEntry),
        (0, $lMO7Z.servicedeskProjectDashboardsListRouteEntry),
        (0, $fvFxE.servicedeskProjectSummaryRouteEntry),
        (0, $dut0s.servicedeskQueuesAddonRouteEntry),
        (0, $jUCVx.servicedeskQueuesEditRouteEntry),
        (0, $fBXou.servicedeskQueuesIssueRouteEntry),
        (0, $28WgX.servicedeskQueuesLandingRouteEntry),
        (0, $ekqRf.servicedeskQueuesManageViewRouteEntry),
        (0, $fPxUZ.servicedeskQueuesNewRouteEntry),
        (0, $gqwG0.servicedeskQueuesViewsConfigRouteEntry),
        (0, $8CLhe.servicedeskReports1RouteEntry),
        (0, $d3dv3.servicedeskReportsCustom4RouteEntry),
        (0, $izixQ.servicedeskReportsCustomCreateRouteEntry),
        (0, $gZq43.servicedeskReportsCustomEditRouteEntry),
        (0, $9uidf.servicedeskReportsCustomIssueRouteEntry),
        (0, $lHdES.servicedeskReportsCustomTimeScaleRouteEntry),
        (0, $8gAuW.servicedeskReportsSatisfaction2RouteEntry),
        (0, $jgRv0.servicedeskReportsSatisfactionIssueRouteEntry),
        (0, $iBcSa.servicedeskReportsSatisfactionTimeScaleRouteEntry),
        (0, $bJiYi.servicedeskReportsTypeRouteEntry),
        (0, $9NWq7.servicedeskReportsWorkloadRouteEntry),
        (0, $hnYNr.servicedeskServiceDetailsRouteEntry),
        (0, $gSlgn.serviceDeskServiceDetailsWithoutProjectRouteEntry),
        (0, $cENRX.servicedeskServiceModalEditRouteEntry),
        (0, $f0Lah.servicedeskServiceModalNewRouteEntry),
        (0, $5psoN.servicedeskServicesRouteEntry),
        (0, $1kaFK.serviceDeskServicesWithoutProjectRouteEntry),
        (0, $kRlsB.servicedeskSlaSettingsRouteEntry),
        (0, $cK5xr.servicedeskWorkflowConfigRouteEntry),
        (0, $43qOr.settingsAutomationRouteEntry),
        (0, $gYfl3.settingsCmdbFieldConfigRouteEntry),
        (0, $jo8cE.settingsOauthCredentialsRouteEntry),
        (0, $kKMOG.settingsRouteEntry),
        (0, $aNCbW.softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry),
        (0, $2AYKc.softwareBacklogEmbedRouteEntry),
        (0, $cJqhS.softwareBacklogRouteEntry),
        (0, $ejo5K.softwareBoardEmbedRouteEntry),
        (0, $hnRYr.softwareBoardRouteEntry),
        (0, $88nEe.softwareBoardViewNotFoundClassicRouteEntry),
        (0, $4nTz0.softwareBoardViewNotFoundRouteEntry),
        (0, $8W2c8.softwareCalendarClassicCustomEmbedRouteEntry),
        (0, $5gnJR.softwareCalendarClassicEmbedRouteEntry),
        (0, $gkm2X.softwareCalendarClassicRouteEntry),
        (0, $csjBW.softwareCalendarCustomEmbedRouteEntry),
        (0, $lj5Av.softwareCalendarEmbedRouteEntry),
        (0, $byNoq.softwareCalendarRouteEntry),
        (0, $lMawn.softwareCapacityCustomEmbedRouteEntry),
        (0, $hK8mq.softwareCapacityEmbedRouteEntry),
        (0, $33rS9.softwareCapacityRouteEntry),
        (0, $6PPxR.softwareClassicProformaIssueFormsDirectEmbedRouteEntry),
        (0, $5JTZa.softwareClassicProformaIssueFormsDirectRouteEntry),
        (0, $jSZVk.softwareCodeClassicRouteEntry),
        (0, $8JIqa.softwareCodeRouteEntry),
        (0, $bTXFE.softwareDeploymentsClassicRouteEntry),
        (0, $exjbO.softwareDeploymentsNextGenRouteEntry),
        (0, $37n4w.softwareFormBuilderClassicRouteEntry),
        (0, $l7Kcl.softwareFormBuilderRouteEntry),
        (0, $kbvuM.softwareFormClassicRouteEntry),
        (0, $1XNI6.softwareFormRouteEntry),
        (0, $8RT9n.softwareFormSubmitClassicPublicRouteEntry),
        (0, $9kqeg.softwareFormSubmitClassicRouteEntry),
        (0, $hRXMa.softwareFormSubmitEmbedClassicRouteEntry),
        (0, $lPhuN.softwareFormSubmitEmbedRouteEntry),
        (0, $4Cdj7.softwareFormSubmitPublicRouteEntry),
        (0, $lxvYO.softwareFormSubmitRouteEntry),
        (0, $6XvFv.softwareGoalsClassicRouteEntry),
        (0, $jZv6V.softwareGoalsRouteEntry),
        (0, $b5gw6.softwareInboxClassicRouteEntry),
        (0, $2YbyC.softwareInboxNextGenRouteEntry),
        (0, $hykoI.softwareIncidentsClassicRouteEntry),
        (0, $2dAZL.softwareIncidentsNextGenRouteEntry),
        (0, $6Rmp2.softwareListClassicRouteEntry),
        (0, $3FQCK.softwareListCustomEmbedClassicRouteEntry),
        (0, $5v5xs.softwareListCustomEmbedRouteEntry),
        (0, $9vlCj.softwareListEmbedClassicRouteEntry),
        (0, $algSY.softwareListEmbedRouteEntry),
        (0, $chmwv.softwareListRouteEntry),
        (0, $ilU7w.softwareNextgenRedirectRouteEntry),
        (0, $1DVzF.softwareOnboardingRouteEntry),
        (0, $7ccps.softwarePeriscopeClassicRouteEntry),
        (0, $1Pj99.softwarePeriscopeNextGenRouteEntry),
        (0, $ff5dM.softwarePlanCalendarRouteEntry),
        (0, $aLXiu.softwarePlanDependenciesRouteEntry),
        (0, $kHsPZ.softwarePlanReleasesRouteEntry),
        (0, $30PHd.softwarePlanSettingsAutoSchedulerRouteEntry),
        (0, $aGFMx.softwarePlanSettingsCustomFieldsRouteEntry),
        (0, $fFZgu.softwarePlanSettingsExclusionRulesRouteEntry),
        (0, $hAVk6.softwarePlanSettingsFeaturesRouteEntry),
        (0, $72a1U.softwarePlanSettingsFindYourIssueRouteEntry),
        (0, $luRFY.softwarePlanSettingsIssueSourcesRouteEntry),
        (0, $3dqLQ.softwarePlanSettingsPermissionsRouteEntry),
        (0, $gxAJV.softwarePlanSettingsPlanInfoRouteEntry),
        (0, $dLExR.softwarePlanSettingsProgramBoardsRouteEntry),
        (0, $5zVch.softwarePlanSettingsRemovedIssuesRouteEntry),
        (0, $2ZnyJ.softwarePlanSettingsSavedViewsRouteEntry),
        (0, $lGz7G.softwarePlanSettingsScenariosRouteEntry),
        (0, $aPs1z.softwarePlanSettingsSchedulingRouteEntry),
        (0, $91LPB.softwarePlanSummaryRouteEntry),
        (0, $e6ehT.softwarePlanTeamsRouteEntry),
        (0, $gAUgF.softwarePlanTimelineRouteEntry),
        (0, $7eIYH.softwareProformaIssueFormsDirectEmbedRouteEntry),
        (0, $6dPXJ.softwareProformaIssueFormsDirectRouteEntry),
        (0, $k80dv.softwareReleaseNotesRouteEntry),
        (0, $dw2ce.softwareReportsBurndownRouteEntry),
        (0, $eSIYo.softwareReportsBurnupRouteEntry),
        (0, $gLWOL.softwareReportsControlRouteEntry),
        (0, $YXwcg.softwareReportsCumulativeRouteEntry),
        (0, $lFKeR.softwareReportsCycleTimeClassicBoardRouteEntry),
        (0, $1xutc.softwareReportsCycleTimeClassicRouteEntry),
        (0, $ed2hW.softwareReportsCycleTimeRouteEntry),
        (0, $9iKlG.softwareReportsDeploymentFrequencyClassicBoardRouteEntry),
        (0, $dfVfw.softwareReportsDeploymentFrequencyClassicRouteEntry),
        (0, $fWDhV.softwareReportsDeploymentFrequencyRouteEntry),
        (0, $khKzX.softwareReportsOverviewBoardlessRouteEntry),
        (0, $kzxfE.softwareReportsOverviewRouteEntry),
        (0, $eF6xc.softwareReportsRouteEntry),
        (0, $7wJLb.softwareReportsVelocityRouteEntry),
        (0, $hN6Yh.softwareRoadmapClassicRouteEntry),
        (0, $5dzzd.softwareRoadmapRedirectRouteEntry),
        (0, $eyWIM.softwareRoadmapRouteEntry),
        (0, $5OhH5.softwareSecurityClassicRouteEntry),
        (0, $eOJip.softwareSecurityNextGenRouteEntry),
        (0, $jG7gV.softwareStaffingRouteEntry),
        (0, $P4w4L.softwareSummaryClassicRouteEntry),
        (0, $8mw4w.softwareSummaryEmbedClassicRouteEntry),
        (0, $gJeDi.softwareSummaryEmbedRouteEntry),
        (0, $sK3EH.softwareSummaryRouteEntry),
        (0, $cOBeu.softwareTimelineClassicRouteEntry),
        (0, $b4ktm.softwareTimelineRouteEntry),
        (0, $bbpTw.softwareVersionDetailEmbedRouteEntry),
        (0, $hSovm.softwareVersionDetailLegacyRedirectRouteEntry),
        (0, $bwfaS.softwareVersionDetailNoTabPathRedirectRouteEntry),
        (0, $3B2tH.softwareVersionDetailRouteEntry),
        (0, $k5ls9.softwareViewNotFoundClassicRouteEntry),
        (0, $4MZMG.softwareViewNotFoundRouteEntry),
        (0, $24gKw.systemConfigurationRedirectRouteEntry),
        (0, $g09EF.systemConfigurationRouteEntry),
        (0, $as2yW.systemDashboardEditRouteEntry),
        (0, $jlw0X.teamIntegrationCreateRouteEntry),
        (0, $VMQYl.teamIntegrationDetailRouteEntry),
        (0, $8t3Bs.teamIntegrationListRouteEntry),
        (0, $gqlkg.teamIntegrationLogRouteEntry),
        (0, $4W2Ve.teamIntegrationsRouteEntry),
        (0, $2qWaR.trashedPlanDirectLinkRouteEntry),
        (0, $1rAP5.trashPlansRouteEntry),
        (0, $4MsHe.trashProjectsDirectoryRedirectRouteEntry),
        (0, $ASOiD.trashProjectsDirectoryRouteEntry),
        (0, $bxGoH.unlockOperationsRouteEntry),
        (0, $7dAIb.userBoardRouteEntry),
        (0, $53Ske.userBoardSettingsRouteEntry),
        (0, $l6W7I.userBoardVelocityRouteEntry),
        (0, $77YbO.userBoardViewNotFoundRouteEntry),
        (0, $dNIAB.userSegmentationRouteEntry),
        (0, $zhYLc.viewIntentRouteEntry),
        (0, $kZdpv.viewStandardFlowRouteEntry),
        (0, $g70C8.whoIsOnCallRouteEntry),
        (0, $ckYTZ.workItemRouteEntry)
    ];

});
parcelRegister("fJ15R", function(module, exports) {

$parcel$export(module.exports, "aiAnswersRouteEntry", () => $4ac7d6a703d7e8db$export$7aab6c3a99455d30);

var $igNUx = parcelRequire("igNUx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $4AC9x = parcelRequire("4AC9x");

var $cRzUS = parcelRequire("cRzUS");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $7b25q = parcelRequire("7b25q");

var $c6t96 = parcelRequire("c6t96");

var $g8uYY = parcelRequire("g8uYY");

var $cAYFR = parcelRequire("cAYFR");
const $4ac7d6a703d7e8db$var$aiAnswersPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $c6t96.aiAnswersEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $4ac7d6a703d7e8db$export$7aab6c3a99455d30 = (0, $6xToB.createEntry)((0, $cRzUS.aiAnswersRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $igNUx.isFedRamp)()) return undefined;
            return $4ac7d6a703d7e8db$var$aiAnswersPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $7b25q.VirtualAgentAiAnswersSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $4AC9x.servicedeskVirtualAgentAiAnswersKbResource)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_AI_ANSWERS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_AI_ANSWERS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("5RW99", function(module, exports) {

$parcel$export(module.exports, "ADDON_ID", () => $6707b1635af3be3c$export$6c4866a933650d1d);
$parcel$export(module.exports, "MENU_ID", () => $6707b1635af3be3c$export$d4cd258d01c03112);
$parcel$export(module.exports, "SIDEBAR_ID", () => $6707b1635af3be3c$export$adf978edbdfaf080);
const $6707b1635af3be3c$export$6c4866a933650d1d = {
    DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
};
const $6707b1635af3be3c$export$d4cd258d01c03112 = {
    ADDONS: 'ADDONS',
    APP_SWITCHER: 'APP_SWITCHER',
    COMMUNICATIONS: 'COMMUNICATIONS',
    DASHBOARDS: 'DASHBOARDS',
    FILTERS: 'FILTERS',
    HELP: 'HELP',
    HOME: 'HOME',
    INSIGHT: 'INSIGHT',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PEOPLE: 'PEOPLE',
    PLANS: 'PLANS',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    ROADMAPS: 'ROADMAPS',
    SEARCH: 'SEARCH',
    SERVICE_HUB: 'SERVICE_HUB',
    SETTINGS: 'SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
    STATUS_PAGE_MANAGE: 'STATUS_PAGE_MANAGE'
};
const $6707b1635af3be3c$export$adf978edbdfaf080 = {
    BOARD_SETTINGS: 'BOARD_SETTINGS',
    CONTENT: 'CONTENT',
    GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
    GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
    GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
    GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
    GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    PLAN_SETTINGS: 'PLAN_SETTINGS',
    PROJECT_SETTINGS: 'PROJECT_SETTINGS',
    OPERATIONS_GENERAL_CONFIGURATION: 'OPERATIONS_GENERAL_CONFIGURATION'
};

});

parcelRegister("1f2LE", function(module, exports) {

$parcel$export(module.exports, "ForPaintServicedeskSidebar", () => $34d9b7a65dd1d6b8$export$c72ea37d21335def);
$parcel$export(module.exports, "default", () => $34d9b7a65dd1d6b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

var $kfvK2 = parcelRequire("kfvK2");

var $7jTnu = parcelRequire("7jTnu");

var $i67QL = parcelRequire("i67QL");
const $34d9b7a65dd1d6b8$var$routesUsingLazyForPaint = new Set([
    'servicedesk-queues-custom-view',
    'servicedesk-practice-custom-view',
    'issue'
]);

const $34d9b7a65dd1d6b8$export$4553575c70a669bf = (0, $gzcjr.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("9lbXz")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});
const $34d9b7a65dd1d6b8$var$AfterPaintServicedeskSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34d9b7a65dd1d6b8$export$4553575c70a669bf, null)));
const $34d9b7a65dd1d6b8$export$c72ea37d21335def = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i67QL.LazyForPaintServicedeskSidebar), null)));
const $34d9b7a65dd1d6b8$var$ServicedeskSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const isLazyForPaintRoute = (0, $kfvK2.useIsActiveRoute)((0, $7jTnu.fg)('queues_sidebar_lazyafterpaint_to_lazyforpaint') ? $34d9b7a65dd1d6b8$var$routesUsingLazyForPaint : 'issue');
    return isLazyForPaintRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34d9b7a65dd1d6b8$export$c72ea37d21335def, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34d9b7a65dd1d6b8$var$AfterPaintServicedeskSidebar, null);
});
$34d9b7a65dd1d6b8$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
$34d9b7a65dd1d6b8$export$c72ea37d21335def.displayName = 'ServicedeskSidebar';
var $34d9b7a65dd1d6b8$export$2e2bcd8739ae039 = $34d9b7a65dd1d6b8$var$ServicedeskSidebar;

});
parcelRegister("8Dw1w", function(module, exports) {

$parcel$export(module.exports, "SidebarBoundary", () => $b66ffc7f89ff7516$export$1edc778464f08256);

var $eJOHy = parcelRequire("eJOHy");

var $h1VbR = parcelRequire("h1VbR");

var $hOBHo = parcelRequire("hOBHo");

var $03pp6 = parcelRequire("03pp6");

var $ch9En = parcelRequire("ch9En");

var $16sa1 = parcelRequire("16sa1");

var $7jTnu = parcelRequire("7jTnu");

var $dysGT = parcelRequire("dysGT");

var $8Q9Ns = parcelRequire("8Q9Ns");

var $gpE1B = parcelRequire("gpE1B");
const $b66ffc7f89ff7516$export$1edc778464f08256 = ({ children: children, id: id })=>{
    const onFail = (0, $8Q9Ns.useSidebarFail)();
    const onSuccess = (0, $8Q9Ns.useSidebarSuccess)();
    const onError = (0, $eJOHy.useCallback)((location, error)=>{
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error'.
        const { statusCode: statusCode } = error;
        if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
        else onFail(location, error);
    }, [
        onFail,
        onSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysGT.SidebarErrorBoundary), {
        id: id,
        packageName: "jiraSpaAppsSidebarCommon",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceMark), {
        metricKey: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderAttempt
    }), (0, $7jTnu.fg)('jiv-blindspot-fixes-2025-07-01') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav-sidebar",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1VbR.default), {
            name: "nav-sidebar-loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gpE1B.Skeleton), {
            isFull: true
        }))
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav-sidebar",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gpE1B.Skeleton), {
            isFull: true
        })
    }, children));
};

});
parcelRegister("hOBHo", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", () => $f058582c63bdf80a$export$6635720e40ea7a7a);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", () => $f058582c63bdf80a$export$1d3c3cb357af0e86);
$parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", () => $f058582c63bdf80a$export$e7a14fa81b3c6488);
$parcel$export(module.exports, "NAVIGATION_TOP_MARKS", () => $f058582c63bdf80a$export$ad760bb9734bf93f);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", () => $f058582c63bdf80a$export$1d10ee0c85c3cb21);
const $f058582c63bdf80a$export$6635720e40ea7a7a = 'navigation.top';
const $f058582c63bdf80a$export$1d3c3cb357af0e86 = 'navigation.sidebar';
const $f058582c63bdf80a$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
const $f058582c63bdf80a$export$ad760bb9734bf93f = {
    renderStart: 'navigation-top.render.start',
    renderEnd: 'navigation-top.render.end',
    renderSsrStart: 'navigation-top.render.ssr.start',
    renderSsrEnd: 'navigation-top.render.ssr.end',
    bundleLoadStart: 'navigation-top.bundle-load.start'
};
const $f058582c63bdf80a$export$1d10ee0c85c3cb21 = {
    renderAttempt: 'navigation-sidebar.render.attempt',
    renderStart: 'navigation-sidebar.render.start',
    renderEnd: 'navigation-sidebar.render.end',
    renderSsrStart: 'navigation-sidebar.render.ssr.start',
    renderSsrEnd: 'navigation-sidebar.render.ssr.end',
    loadStart: 'navigation-sidebar.load.start',
    loadEnd: 'navigation-sidebar.load.end'
};

});

parcelRegister("03pp6", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_DROPDOWN_MARKS", () => $9b842795409a6159$export$8df02628d98cae7e);
$parcel$export(module.exports, "pageSegmentStore", () => $9b842795409a6159$export$26cadbe0bcaabcde);
$parcel$export(module.exports, "useNavPerformanceMetrics", () => $9b842795409a6159$export$906025848d54198d);
$parcel$export(module.exports, "NavTopPerformanceMark", () => $9b842795409a6159$export$b7f4caa65b0906fc);
$parcel$export(module.exports, "NavTopPerformanceReport", () => $9b842795409a6159$export$c64b31449a6177d);
$parcel$export(module.exports, "NavSidebarPerformanceMark", () => $9b842795409a6159$export$35b2aeea5cbc963e);
$parcel$export(module.exports, "NavSidebarPerformanceReport", () => $9b842795409a6159$export$a018e347341b3640);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $4WXKS = parcelRequire("4WXKS");

var $kQnVX = parcelRequire("kQnVX");

var $6dnL8 = parcelRequire("6dnL8");

var $hOBHo = parcelRequire("hOBHo");

const $9b842795409a6159$var$createTopNavPageSegment = ()=>(0, $4WXKS.metrics).pageSegmentLoad({
        key: (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME),
        timings: [
            {
                key: 'ttic',
                startMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderStart,
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderSsrStart,
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'bundle-load',
                startMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).bundleLoadStart,
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderStart
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $9b842795409a6159$export$8df02628d98cae7e = {
    ADDONS: (0, $4WXKS.metrics).interaction({
        key: 'navigation-top.addons-dropdown-opened'
    })
};
const $9b842795409a6159$var$createSidebarPageSegment = ()=>(0, $4WXKS.metrics).pageSegmentLoad({
        key: (0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME),
        timings: [
            {
                key: 'renderAttempt',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderAttempt
            },
            {
                key: 'ttic',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderStart,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'load',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadStart,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadEnd
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $9b842795409a6159$export$26cadbe0bcaabcde = (()=>{
    const segmentConstructors = {
        [(0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME)]: $9b842795409a6159$var$createTopNavPageSegment,
        [(0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $9b842795409a6159$var$createSidebarPageSegment
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const segments = {};
    return {
        getSegment: (key)=>{
            if (!segments[key]) {
                if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                segments[key] = segmentConstructors[key]();
            }
            return segments[key];
        }
    };
})();
const $9b842795409a6159$export$906025848d54198d = (segmentKey = (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME))=>{
    const startedRef = (0, $eJOHy.useRef)(false);
    const segment = (0, $eJOHy.useRef)($9b842795409a6159$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
    if (!false && !startedRef.current) {
        segment && segment.startFromPageLoad();
        startedRef.current = true;
    }
    return (0, $eJOHy.useMemo)(()=>// object assign here to extend origianl segment object and save prototypes
        Object.assign(segment, {
            markSSR: (metricKey)=>{
                const tmpSsrMetricKey = `${(0, $hOBHo.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                if (window.SPA_STATE) {
                    // @ts-expect-error - TS2339 - Property 'startTime' does not exist on type 'unknown'. | TS2339 - Property 'duration' does not exist on type 'unknown'.
                    const { startTime: startTime = 0, duration: duration = 0 } = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))((0, $6dnL8.getRenderTraceFromSSRGlobal)(), [
                        'traces',
                        `render/${tmpSsrMetricKey}`
                    ]) || {};
                    const markTime = startTime + duration;
                    markTime && markTime > 0 && segment.mark(metricKey, markTime);
                }
            }
        }), [
        segment
    ]);
};
const $9b842795409a6159$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const navSegment = $9b842795409a6159$export$906025848d54198d(segmentKey);
    (0, $eJOHy.useEffect)(()=>navSegment.mark(metricKey), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return null;
};
const $9b842795409a6159$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
    const navSegment = $9b842795409a6159$export$906025848d54198d(segmentKey);
    (0, $eJOHy.useEffect)(()=>{
        navSegment.stop({
            customData: {
                ...customData,
                userLocation: (0, $kQnVX.getUserLocation)()
            }
        });
        navSegment.clear();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $9b842795409a6159$export$b7f4caa65b0906fc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $9b842795409a6159$export$c64b31449a6177d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $9b842795409a6159$export$35b2aeea5cbc963e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $9b842795409a6159$export$a018e347341b3640 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });

});
parcelRegister("6dnL8", function(module, exports) {

$parcel$export(module.exports, "RenderTracerMark", () => $399d856a9213313b$export$54c89059bb435049);
$parcel$export(module.exports, "getRenderTraceFromSSRGlobal", () => $399d856a9213313b$export$345f21b0287f67e5);

var $eJOHy = parcelRequire("eJOHy");

var $Xz6kS = parcelRequire("Xz6kS");

var $9Dhvc = parcelRequire("9Dhvc");

var $QRiTH = parcelRequire("QRiTH");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

const $399d856a9213313b$var$initialState = {
    start: undefined,
    traces: {}
};
let $399d856a9213313b$var$currentTraces = {};
const $399d856a9213313b$export$2365ecd8218e21c7 = ()=>$399d856a9213313b$var$currentTraces;
const $399d856a9213313b$export$5c757eaa1990d0d7 = (key)=>{
    if ($399d856a9213313b$var$currentTraces[key]) return;
    $399d856a9213313b$var$currentTraces[key] = {
        startTime: (0, $QRiTH.performance).now()
    };
};
const $399d856a9213313b$export$16854dc18f8d976 = (key)=>{
    if (!$399d856a9213313b$var$currentTraces[key] || $399d856a9213313b$var$currentTraces[key].duration != null) return;
    $399d856a9213313b$var$currentTraces[key].duration = (0, $QRiTH.performance).now() - $399d856a9213313b$var$currentTraces[key].startTime;
};
const $399d856a9213313b$var$actions = {
    startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            // If <RenderTracerContainer /> has not been setup with a startKey and startTime, return
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            if (traces[key]) return;
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($Xz6kS)))({}, traces, {
                    [key]: {
                        startTime: time
                    }
                })
            });
        },
    endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            const trace = traces[key] || {
                startTime: 0
            };
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($Xz6kS)))({}, traces, {
                    [key]: {
                        ...trace,
                        duration: time - trace.startTime
                    }
                })
            });
            $399d856a9213313b$var$currentTraces = Object.assign($399d856a9213313b$var$currentTraces, getState().traces);
        }
};
const $399d856a9213313b$var$Store = (0, $GtRbT.createStore)({
    name: 'jira-render-tracer',
    initialState: $399d856a9213313b$var$initialState,
    actions: $399d856a9213313b$var$actions
});
const $399d856a9213313b$var$RenderTracerActions = (0, $ht3nQ.createSubscriber)($399d856a9213313b$var$Store, {
    selector: null
});
const $399d856a9213313b$export$719a95758870be58 = (0, $iJq0l.createHook)($399d856a9213313b$var$Store, {
    selector: null
});
const $399d856a9213313b$var$RenderTracerContainerBase = (0, $6E16M.createContainer)($399d856a9213313b$var$Store, {
    onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
            setState({
                start: startTime,
                traces: {
                    [startKey]: {
                        startTime: (0, $QRiTH.performance).now()
                    }
                }
            });
        }
});
const $399d856a9213313b$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($399d856a9213313b$var$RenderTracerContainerBase, {
        startKey: startKey,
        startTime: startTime
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($399d856a9213313b$export$54c89059bb435049, {
        traceKey: startKey,
        type: "end"
    }));
const $399d856a9213313b$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($399d856a9213313b$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
        if (type === 'start') startTrace(traceKey, (0, $QRiTH.performance).now());
        else if (type === 'end') endTrace(traceKey, (0, $QRiTH.performance).now());
        return null;
    });
const $399d856a9213313b$export$cba8addc8743389c = (appName = 'unknown', traces = $399d856a9213313b$var$currentTraces)=>({
        [(0, $6df4e20a5531d5f2$export$3c96fa14fb694e11)]: {
            data: {
                traces: traces,
                routeName: appName
            }
        }
    });
const $399d856a9213313b$export$345f21b0287f67e5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
        (0, $6df4e20a5531d5f2$export$3c96fa14fb694e11),
        'data'
    ], {});

});
parcelRegister("QRiTH", function(module, exports) {

$parcel$export(module.exports, "performance", () => $be16f2b3d59cb675$export$f2d2284f5fec51f8);
const $be16f2b3d59cb675$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
class $be16f2b3d59cb675$export$9a0dbed22cbf63be {
    start() {
        if (false) this.startAt = $be16f2b3d59cb675$var$now();
    }
    now() {
        if (false) return $be16f2b3d59cb675$var$now() - this.startAt;
        return $be16f2b3d59cb675$var$now();
    }
    constructor(){
        this.startAt = $be16f2b3d59cb675$var$now();
    }
}
const $be16f2b3d59cb675$export$f2d2284f5fec51f8 = new $be16f2b3d59cb675$export$9a0dbed22cbf63be();

});

const $6df4e20a5531d5f2$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';



parcelRegister("16sa1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d37a74ca9fa1ecb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cv2et = parcelRequire("cv2et");

var $3TY2E = parcelRequire("3TY2E");

var $gaiLP = parcelRequire("gaiLP");

var $25NU0 = parcelRequire("25NU0");

var $7jTnu = parcelRequire("7jTnu");

var $kn2Rh = parcelRequire("kn2Rh");

var $iU66d = parcelRequire("iU66d");
/** A portion of the page we apply measurement to */ function $7d37a74ca9fa1ecb$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $cv2et.useInteractionContext)();
    const relayProfilerContext = (0, $eJOHy.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $eJOHy.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    if ((0, $kn2Rh.getIsConcurrentEnabled)() && (0, $7jTnu.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    this.getInteractionContext().addPreload((0, $3TY2E.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    if ((0, $kn2Rh.getIsConcurrentEnabled)() && (0, $7jTnu.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    if ((0, $kn2Rh.getIsConcurrentEnabled)() && (0, $7jTnu.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $3TY2E.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $7jTnu.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $7jTnu.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iU66d.default), {
        labelStack: interactionContext.labelStack,
        onRender: (...args)=>interactionContext.onRender(...args)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $25NU0.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children)));
}
function $7d37a74ca9fa1ecb$export$2e2bcd8739ae039({ name: segmentName, children: children, mode: mode = 'single' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gaiLP.default), {
        name: segmentName,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7d37a74ca9fa1ecb$var$JiraUFOSegmentWrapper, null, children));
}

});
parcelRegister("iU66d", function(module, exports) {

$parcel$export(module.exports, "default", () => $577ced15db32032b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");
/**
 * this is a counterpart of the similar component in the .server implementation
 */ const $577ced15db32032b$var$ProfilerMarker = ()=>{
    return null;
};
const $577ced15db32032b$var$SsrRenderProfiler = ({ children: children })=>{
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $7jTnu.fg)('jfp_magma_jira-use-id-sync') && (0, $7jTnu.fg)('jira-ssr-enable-ufo-in-ssr')) // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($577ced15db32032b$var$ProfilerMarker, null), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
var $577ced15db32032b$export$2e2bcd8739ae039 = $577ced15db32032b$var$SsrRenderProfiler;

});


parcelRegister("dysGT", function(module, exports) {

$parcel$export(module.exports, "SidebarErrorBoundary", () => $c7f6dd1cac39f594$export$62853c5766dad0c4);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $kQnVX = parcelRequire("kQnVX");

var $ea4Iz = parcelRequire("ea4Iz");
const $c7f6dd1cac39f594$export$62853c5766dad0c4 = (props)=>{
    const userLocation = (0, $kQnVX.getUserLocation)();
    const extraEventData = (0, $eJOHy.useMemo)(()=>({
            ...props.extraEventData,
            userLocation: userLocation
        }), [
        props.extraEventData,
        userLocation
    ]);
    const fallback = (0, $eJOHy.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ea4Iz.Fallback), {
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        ...props,
        extraEventData: extraEventData,
        fallback: fallback
    });
};

});
parcelRegister("ea4Iz", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $9b4051d45e6e7b1f$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bvFRW = parcelRequire("bvFRW");

var $2HRPu = parcelRequire("2HRPu");

var $lRq8t = parcelRequire("lRq8t");

var $8aXAv = parcelRequire("8aXAv");

var $6aoQW = parcelRequire("6aoQW");
const $9b4051d45e6e7b1f$var$styles = {
    wrapper: "_zulpu2gc _bfhk1jdc _syaz1mjl _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o _1e0c1txw _2lx21bp4",
    error: "_2rko9j3y _11c8dcr7 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
    image: "_4t3i12am"
};
const $9b4051d45e6e7b1f$export$fb8d7f40caaeea67 = (props)=>{
    const { error: error } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $9b4051d45e6e7b1f$var$styles.wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8aXAv))),
        className: (0, $hcewu.default)([
            $9b4051d45e6e7b1f$var$styles.image
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "xsmall"
    }, formatMessage((0, $6aoQW.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $6aoQW.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("code", {
        className: (0, $hcewu.default)([
            $9b4051d45e6e7b1f$var$styles.error
        ])
    }, "ERROR: ", (0, $2HRPu.getErrorHash)(error)));
};

});
parcelRegister("8aXAv", function(module, exports) {
module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();

});

parcelRegister("6aoQW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f850c5d954b638cc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f850c5d954b638cc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorHeading: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("8Q9Ns", function(module, exports) {

$parcel$export(module.exports, "SidebarStart", () => $b1d0fa6e8dcb9f72$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarRenderStart", () => $b1d0fa6e8dcb9f72$export$ba19e3624956e66);
$parcel$export(module.exports, "SidebarReady", () => $b1d0fa6e8dcb9f72$export$a06ecbbe5820282);
$parcel$export(module.exports, "useSidebarFail", () => $b1d0fa6e8dcb9f72$export$661ed14c8f75da9f);
$parcel$export(module.exports, "useSidebarSuccess", () => $b1d0fa6e8dcb9f72$export$ddb17534fdfb7dc6);

var $eJOHy = parcelRequire("eJOHy");

var $hOBHo = parcelRequire("hOBHo");

var $03pp6 = parcelRequire("03pp6");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $XQ5wK = parcelRequire("XQ5wK");

var $hih5V = parcelRequire("hih5V");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $TLYhw = parcelRequire("TLYhw");

var $gCY1z = parcelRequire("gCY1z");

var $eES78 = parcelRequire("eES78");
// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
const { useValue: $b1d0fa6e8dcb9f72$var$useSidebarId } = (0, $XQ5wK.createValueController)('sidebar-id');
const $b1d0fa6e8dcb9f72$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
    experience: (0, $eES78.SIDEBAR_EXPERIENCE),
    attributes: {
        sidebar: 'v3'
    }
};
const $b1d0fa6e8dcb9f72$export$6738d1299dc79710 = ()=>{
    const [{ route: route, match: match }] = (0, $gCY1z.useRouter)();
    const pageId = (0, $TLYhw.usePageId)();
    const startRef = (0, $eJOHy.useRef)(Date.now());
    const onStartExperience = (0, $8Uqf3.useExperienceStart)({
        experienceId: pageId,
        experience: (0, $eES78.SIDEBAR_EXPERIENCE),
        analyticsSource: 'Sidebar'
    });
    (0, $eJOHy.useMemo)(()=>{
        if (route.isRedirect ?? false) return;
        onStartExperience();
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        match
    ]);
    return null;
};
const $b1d0fa6e8dcb9f72$export$ba19e3624956e66 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceMark), {
        metricKey: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderStart
    });
const $b1d0fa6e8dcb9f72$export$a06ecbbe5820282 = ({ id: id })=>{
    const [, setSidebarId] = $b1d0fa6e8dcb9f72$var$useSidebarId();
    const route = (0, $hih5V.useCurrentRoute)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const onSuccess = (0, $4ctwv.useExperienceSuccess)($b1d0fa6e8dcb9f72$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
    (0, $eJOHy.useEffect)(()=>{
        setSidebarId(id);
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        return ()=>setSidebarId();
    }, [
        setSidebarId,
        id
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (route.isRedirect ?? false) return;
        onSuccess();
    }, [
        onSuccess,
        route
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // Why are we injecting the route name into the global window state?
        // We currently don't have any way to get the route name when the sidenav is rendered OUTSIDE of the SPA
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__POLLINATOR__ = {
            ...window.__POLLINATOR__,
            routeName: routeName
        };
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $gCeeo.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        routeName
    ]);
    const customData = (0, $eJOHy.useMemo)(()=>({
            route: routeName,
            sidebarId: id
        }), [
        routeName,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceMark), {
        metricKey: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceReport), {
        customData: customData
    }));
};
const $b1d0fa6e8dcb9f72$export$661ed14c8f75da9f = ()=>{
    const onFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $eES78.SIDEBAR_EXPERIENCE)
    });
    return (0, $eJOHy.useCallback)((location, error)=>{
        onFail(location, error);
    }, [
        onFail
    ]);
};
const $b1d0fa6e8dcb9f72$export$ddb17534fdfb7dc6 = ()=>(0, $4ctwv.useExperienceSuccess)($b1d0fa6e8dcb9f72$var$EXPERIENCE_SUCCESS_ATTRIBUTES);

});
parcelRegister("aqnJa", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $07b7f78d48d39c0c$export$606da7704d8eaf06);

var $eJOHy = parcelRequire("eJOHy");

var $8KUFq = parcelRequire("8KUFq");

var $dSzMM = parcelRequire("dSzMM");

var $hWeHP = parcelRequire("hWeHP");

var $aSmR5 = parcelRequire("aSmR5");
const $07b7f78d48d39c0c$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $aSmR5.useExperienceContext)();
    const self = (0, $eJOHy.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $eJOHy.useCallback)((location, error, extraAttributes = {})=>{
        const { current: current } = self;
        // ignore client side errors from impacting experience metrics
        if ((0, $dSzMM.isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, $8KUFq.isClientFetchError)(error)) return;
        const shardAndRegionAttributes = {
            shard: (0, $hWeHP.default)('ajs-shard'),
            region: (0, $hWeHP.default)('ajs-region')
        };
        current.experienceTracker.fail({
            name: current.name,
            error: error,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes,
                location: location
            }
        });
    }, [
        self
    ]);
};

});
parcelRegister("aSmR5", function(module, exports) {

$parcel$export(module.exports, "useExperienceContext", () => $9e8c86ec8261bcec$export$be8ec22ac9208049);

var $eJOHy = parcelRequire("eJOHy");

var $7H45T = parcelRequire("7H45T");
const $9e8c86ec8261bcec$export$be8ec22ac9208049 = ()=>{
    const context = (0, $eJOHy.useContext)((0, $7H45T.ExperienceTrackerContext));
    return context;
};

});


parcelRegister("8Uqf3", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $7363f384519bbd6b$export$675e0d25df38d426);
$parcel$export(module.exports, "ExperienceStart", () => $7363f384519bbd6b$export$f20b867e738a222c);

var $eJOHy = parcelRequire("eJOHy");

var $hih5V = parcelRequire("hih5V");

var $aSmR5 = parcelRequire("aSmR5");
const $7363f384519bbd6b$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const experienceTracker = (0, $aSmR5.useExperienceContext)();
    const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
    const self = (0, $eJOHy.useRef)({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        experienceTracker: experienceTracker,
        disableSli: disableSli,
        userLocation: userLocation,
        collect: collect
    });
    self.current.experienceId = experienceId;
    self.current.experience = experience;
    self.current.timeout = timeout;
    self.current.analyticsSource = analyticsSource;
    self.current.application = application;
    self.current.edition = edition;
    self.current.experienceTracker = experienceTracker;
    self.current.userLocation = userLocation;
    self.current.collect = collect;
    return (0, $eJOHy.useCallback)(()=>{
        const { current: current } = self;
        current.experienceTracker.start({
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            id: current.experienceId,
            name: current.experience,
            timeout: current.timeout,
            attributes: {
                analyticsSource: current.analyticsSource,
                experience: current.experience,
                experienceId: current.experienceId,
                application: current.application,
                edition: current.edition,
                disableSli: current.disableSli,
                userLocation: current.userLocation
            },
            collect: current.collect,
            onSuccess: ()=>undefined
        });
    }, [
        self
    ]);
};
const $7363f384519bbd6b$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
    const onStart = $7363f384519bbd6b$export$675e0d25df38d426({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        disableSli: disableSli,
        collect: collect
    });
    (0, $eJOHy.useMemo)(()=>{
        onStart();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onStart,
        experienceId,
        experience,
        timeout,
        analyticsSource,
        application,
        edition,
        disableSli,
        collect
    ]);
    return null;
};

});
parcelRegister("hih5V", function(module, exports) {

$parcel$export(module.exports, "useCurrentRoute", () => $0de85b9e16d59246$export$c4b7ea2942f2d0e);
$parcel$export(module.exports, "useRouteByName", () => $0de85b9e16d59246$export$d69a946e2d0a1c12);
$parcel$export(module.exports, "usePreviousRouterState", () => $0de85b9e16d59246$export$1e5fb68306bd0b92);

var $kfvK2 = parcelRequire("kfvK2");
var $gCY1z = parcelRequire("gCY1z");

var $kQnVX = parcelRequire("kQnVX");

const $0de85b9e16d59246$export$c4b7ea2942f2d0e = (0, $kfvK2.createRouterSelector)((state)=>state.route);
const $0de85b9e16d59246$export$d69a946e2d0a1c12 = (0, $kfvK2.createRouterSelector)((state, routeName)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state.routes.find(({ name: name })=>name === routeName) ?? null);
const $0de85b9e16d59246$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
        name: name,
        path: path,
        query: query,
        exact: exact
    });
const $0de85b9e16d59246$export$1e5fb68306bd0b92 = ()=>{
    // Force updates whenever the current route changes
    (0, $gCY1z.useRouter)();
    return (0, $kQnVX.getPreviousRouterState)();
};

});


parcelRegister("4ctwv", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", () => $b1bfd6142c0877bc$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "ExperienceSuccess", () => $b1bfd6142c0877bc$export$4962f3898bd5c829);

var $eJOHy = parcelRequire("eJOHy");

var $hih5V = parcelRequire("hih5V");

var $hWeHP = parcelRequire("hWeHP");

var $aSmR5 = parcelRequire("aSmR5");
const $b1bfd6142c0877bc$var$STABLE_EMPTY_OBJECT = {};
const $b1bfd6142c0877bc$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $b1bfd6142c0877bc$var$STABLE_EMPTY_OBJECT })=>{
    const experienceTracker = (0, $aSmR5.useExperienceContext)();
    const route = (0, $hih5V.useCurrentRoute)();
    const self = (0, $eJOHy.useRef)({
        experience: experience,
        attributes: attributes,
        experienceTracker: experienceTracker,
        route: route
    });
    self.current.route = route;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    self.current.experience = experience;
    return (0, $eJOHy.useCallback)((extraAttributes = {})=>{
        const { current: current } = self;
        if (current.route && current.route.isRedirect === true) return;
        const shardAndRegionAttributes = {
            shard: (0, $hWeHP.default)('ajs-shard'),
            region: (0, $hWeHP.default)('ajs-region')
        };
        current.experienceTracker.succeed({
            name: current.experience,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes
            }
        });
    }, [
        self
    ]);
};
const $b1bfd6142c0877bc$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $b1bfd6142c0877bc$var$STABLE_EMPTY_OBJECT })=>{
    const onExperienceSuccess = $b1bfd6142c0877bc$export$e94f0da4fc0603c6({
        experience: experience,
        attributes: attributes
    });
    (0, $eJOHy.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        attributes,
        onExperienceSuccess
    ]);
    (0, $eJOHy.useMemo)(()=>{
        if (false) onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    return null;
};

});

parcelRegister("XQ5wK", function(module, exports) {

$parcel$export(module.exports, "createValueController", () => $a097180df6b282dc$export$ff0ab9dd4ceb4a93);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $a097180df6b282dc$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
    const actions = {
        setValue: (value)=>({ setState: setState })=>setState({
                    value: value
                })
    };
    const initialState = {
        value: defaultValue
    };
    const store = (0, $GtRbT.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ValueContainer = (0, $6E16M.createContainer)(store);
    const selector = (state)=>state.value;
    const useValueInternal = (0, $iJq0l.createHook)(store, {
        selector: selector
    });
    const useValue = ()=>{
        const [value, { setValue: setValue }] = useValueInternal();
        return [
            value,
            setValue
        ];
    };
    return {
        ValueContainer: ValueContainer,
        useValue: useValue
    };
};

});

parcelRegister("TLYhw", function(module, exports) {

$parcel$export(module.exports, "usePageId", () => $86c78d8a6af84e38$export$3434ba5eadb360dc);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $6XFSq = parcelRequire("6XFSq");
const $86c78d8a6af84e38$var$useSweetStatePageId = (0, $iJq0l.createHook)((0, $6XFSq.default), {
    selector: (state)=>state.currentPage.uuid
});
const $86c78d8a6af84e38$export$3434ba5eadb360dc = ()=>{
    const [pageId] = $86c78d8a6af84e38$var$useSweetStatePageId();
    return pageId;
};

});
parcelRegister("6XFSq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1df37714d7c7aac6$export$2e2bcd8739ae039);

var $aXKmr = parcelRequire("aXKmr");

var $GtRbT = parcelRequire("GtRbT");

var $km1L2 = parcelRequire("km1L2");
const $1df37714d7c7aac6$export$d4c72bab9d6cc13a = {
    transitionCheckTimestamp: -1,
    currentPage: {
        uuid: false ? '' : (0, $aXKmr.v4)(),
        startTime: typeof performance !== 'undefined' && performance.timing !== undefined && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.timing.navigationStart || 0,
        apps: {},
        userLocation: ''
    },
    visitedPages: [],
    navigation: {
        isCollapsed: false,
        viewId: 'noView',
        viewType: '',
        projectType: null,
        isInitialEventSent: false,
        pageId: null,
        nextViewId: ''
    }
};
const $1df37714d7c7aac6$var$store = (0, $GtRbT.createStore)({
    name: 'spa-state',
    initialState: $1df37714d7c7aac6$export$d4c72bab9d6cc13a,
    actions: $km1L2
});
var $1df37714d7c7aac6$export$2e2bcd8739ae039 = $1df37714d7c7aac6$var$store;

});
parcelRegister("km1L2", function(module, exports) {

$parcel$export(module.exports, "setAppStart", () => (parcelRequire("VOBaH")).setAppStart);
$parcel$export(module.exports, "setAppReady", () => (parcelRequire("VOBaH")).setAppReady);
$parcel$export(module.exports, "setAppStartWithAppId", () => (parcelRequire("VOBaH")).setAppStartWithAppId);
$parcel$export(module.exports, "setAppReadyWithAppId", () => (parcelRequire("VOBaH")).setAppReadyWithAppId);
$parcel$export(module.exports, "setAppErrorReady", () => (parcelRequire("VOBaH")).setAppErrorReady);
$parcel$export(module.exports, "setTimeoutReady", () => (parcelRequire("VOBaH")).setTimeoutReady);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => (parcelRequire("VOBaH")).setTimeoutReadyWithAppId);
$parcel$export(module.exports, "resetCurrentPage", () => (parcelRequire("VOBaH")).resetCurrentPage);
$parcel$export(module.exports, "setResourceMetrics", () => (parcelRequire("VOBaH")).setResourceMetrics);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $VOBaH = parcelRequire("VOBaH");

});
parcelRegister("VOBaH", function(module, exports) {

$parcel$export(module.exports, "resetCurrentPage", () => $abd86659006fa64e$export$5639685a1fb81722);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => $abd86659006fa64e$export$8a98548dad2fa97b);
$parcel$export(module.exports, "setTimeoutReady", () => $abd86659006fa64e$export$b9cc4378ea785421);
$parcel$export(module.exports, "setAppStartWithAppId", () => $abd86659006fa64e$export$9d528722f2ff2999);
$parcel$export(module.exports, "setAppStart", () => $abd86659006fa64e$export$71192061050856ad);
$parcel$export(module.exports, "setAppReadyWithAppId", () => $abd86659006fa64e$export$6a25429a42d30f9a);
$parcel$export(module.exports, "setAppReady", () => $abd86659006fa64e$export$fc59cc4ed9bba7cd);
$parcel$export(module.exports, "setAppErrorReady", () => $abd86659006fa64e$export$aff63c1e41443b6a);
$parcel$export(module.exports, "setResourceMetrics", () => $abd86659006fa64e$export$8ad155d489dcf34d);

var $aXKmr = parcelRequire("aXKmr");

var $2NzEL = parcelRequire("2NzEL");

var $gC446 = parcelRequire("gC446");

var $kQnVX = parcelRequire("kQnVX");

var $9kysr = parcelRequire("9kysr");
const $abd86659006fa64e$export$7bd623b29ec8e1eb = 10000;
const $abd86659006fa64e$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        performance.mark('resetCurrentPage');
        (0, $gC446.browserMetrics).startPageLoad({
            isInitial: false
        });
        (0, $2NzEL.default)(nextRouteUfoName, nextRouteName);
        (0, $9kysr.GlobalPageLoadExperience).abort({
            force: true
        });
        (0, $9kysr.GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
            currentPage: {
                uuid: (0, $aXKmr.v4)(),
                apps: {},
                startTime: Date.now(),
                userLocation: ''
            },
            visitedPages: [
                ...currentState.visitedPages,
                {
                    ...currentState.currentPage
                }
            ],
            transitionCheckTimestamp: 0
        });
    };
const $abd86659006fa64e$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
            const apps = {
                ...currentPage.apps
            };
            if (apps[appId] && apps[appId].expectingTimeout) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            timeoutTime: timeoutTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        }
    };
const $abd86659006fa64e$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($abd86659006fa64e$export$8a98548dad2fa97b(appId, timeoutTime));
    };
const $abd86659006fa64e$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
            const timeoutId = setTimeout(()=>{
                dispatch($abd86659006fa64e$export$8a98548dad2fa97b(appId));
            }, $abd86659006fa64e$export$7bd623b29ec8e1eb);
            const updatedPage = {
                ...currentPage,
                userLocation: (0, $kQnVX.getUserLocation)(),
                apps: {
                    ...currentPage.apps,
                    [appId]: {
                        startTime: startTime,
                        expectingTimeout: timeoutId
                    }
                }
            };
            setState({
                // @ts-expect-error - TS2322 - Type '{ userLocation: string; apps: { [x: string]: AppState | { startTime: number; expectingTimeout: NodeJS.Timeout; }; }; uuid: string; startTime: number; resources?: ResourceMetrics[] | undefined; }' is not assignable to type 'PageTiming'.
                currentPage: updatedPage
            });
        }
    };
const $abd86659006fa64e$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($abd86659006fa64e$export$9d528722f2ff2999(appId, startTime));
    };
const $abd86659006fa64e$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
            const apps = {
                ...currentPage.apps
            };
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(currentPage.apps[appId].expectingTimeout);
            const updatedPage = {
                ...currentPage,
                apps: {
                    ...apps,
                    [appId]: {
                        ...apps[appId],
                        endTime: endTime,
                        expectingTimeout: 0
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $abd86659006fa64e$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($abd86659006fa64e$export$6a25429a42d30f9a(appId, endTime));
    };
const $abd86659006fa64e$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
            const updatedPage = {
                ...currentPage,
                apps: {
                    'error-page': {
                        endTime: Date.now()
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $abd86659006fa64e$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            currentPage: {
                ...currentState.currentPage,
                resources: [
                    ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                    resourceMetrics
                ]
            }
        });
    };

});




parcelRegister("eES78", function(module, exports) {

$parcel$export(module.exports, "REPO_TYPE", () => $52e041f2c33cd742$export$399c7e6858236b4);
$parcel$export(module.exports, "LINK_TYPE", () => $52e041f2c33cd742$export$58125ce2bb1c3378);
$parcel$export(module.exports, "EMOJI_REGEX", () => $52e041f2c33cd742$export$c79ed2783644934c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", () => $52e041f2c33cd742$export$25ae65041c800c9);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", () => $52e041f2c33cd742$export$e03c9beea817d44b);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", () => $52e041f2c33cd742$export$3d575bdf28c0d17c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", () => $52e041f2c33cd742$export$af84baced6970a17);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", () => $52e041f2c33cd742$export$c767f253046b1ea7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", () => $52e041f2c33cd742$export$265b9384cc2dfbd4);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", () => $52e041f2c33cd742$export$2de77b357e71c7a7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", () => $52e041f2c33cd742$export$7de7abb92169d6c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", () => $52e041f2c33cd742$export$fd7df8bd7600c65c);
$parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", () => $52e041f2c33cd742$export$dde074e512e80dff);
$parcel$export(module.exports, "REPORTS_IDS", () => $52e041f2c33cd742$export$1f70a76cb421b107);
$parcel$export(module.exports, "SIDEBAR_EXPERIENCE", () => $52e041f2c33cd742$export$71aaf2625ee54d10);
$parcel$export(module.exports, "staticLegacyIds", () => $52e041f2c33cd742$export$f57650e6e7be03dc);
const $52e041f2c33cd742$export$399c7e6858236b4 = 'source.code.link';
const $52e041f2c33cd742$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $52e041f2c33cd742$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
const $52e041f2c33cd742$export$25ae65041c800c9 = 'pin-filter-myopenissues';
const $52e041f2c33cd742$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
const $52e041f2c33cd742$export$3d575bdf28c0d17c = 'pin-filter-allissues';
const $52e041f2c33cd742$export$af84baced6970a17 = 'pin-filter-allopenissues';
const $52e041f2c33cd742$export$c767f253046b1ea7 = 'pin-filter-doneissues';
const $52e041f2c33cd742$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
const $52e041f2c33cd742$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
const $52e041f2c33cd742$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
const $52e041f2c33cd742$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
const $52e041f2c33cd742$export$dde074e512e80dff = 'global-create-spotlight';
const $52e041f2c33cd742$export$1f70a76cb421b107 = {
    REPORTS_ADDONS: 'sd-reports-addons'
};
const $52e041f2c33cd742$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
const $52e041f2c33cd742$export$f57650e6e7be03dc = [
    // Global Settings Static Legacy Ids
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy Ids
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation.moderate__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation',
    'com.codebarrel.addons.automation.moderate__cb-automation'
];

});


parcelRegister("gpE1B", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $65e95951f2fce7be$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $h1VbR = parcelRequire("h1VbR");

var $7Tz5f = parcelRequire("7Tz5f");
var $5RrpQ = parcelRequire("5RrpQ");
const $65e95951f2fce7be$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1VbR.default), {
        name: "sidebar-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($65e95951f2fce7be$var$BackgroundedWrapper, null, isFull && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($65e95951f2fce7be$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5RrpQ.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tz5f.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5RrpQ.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5RrpQ.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5RrpQ.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5RrpQ.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5RrpQ.default), {
        hasIcon: isFull
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $65e95951f2fce7be$var$BackgroundedWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1tem _ca0qidpf _u5f31ejb _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $65e95951f2fce7be$var$HeadingWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1yt41k9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7Tz5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9a0b6ebee2f7c2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7R1al = parcelRequire("7R1al");

var $eGPDm = parcelRequire("eGPDm");
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $ad9a0b6ebee2f7c2$var$Section = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $eGPDm.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7R1al.default), {
        ...props,
        ref: ref,
        isSideNavSection: true
    });
});
var $ad9a0b6ebee2f7c2$export$2e2bcd8739ae039 = $ad9a0b6ebee2f7c2$var$Section;

});

parcelRegister("5RrpQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $03092c8045204279$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $f9Ihw = parcelRequire("f9Ihw");

var $eGPDm = parcelRequire("eGPDm");
/**
 * __Skeleton item__
 *
 * A skeleton item can be used to reduce the perceived loading time.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#loading)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $03092c8045204279$var$SkeletonItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $eGPDm.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f9Ihw.default), {
        isSideNavSkeleton: true,
        ...props
    });
};
var $03092c8045204279$export$2e2bcd8739ae039 = $03092c8045204279$var$SkeletonItem;

});



parcelRegister("7DXwW", function(module, exports) {

$parcel$export(module.exports, "setPerformanceMarkLoadStart", () => $2ebdd972899a51f4$export$4166241bf9111f66);
$parcel$export(module.exports, "setPerformanceMarkLoadEnd", () => $2ebdd972899a51f4$export$edbd543f308bbef5);

var $hOBHo = parcelRequire("hOBHo");

var $03pp6 = parcelRequire("03pp6");
const $2ebdd972899a51f4$export$4166241bf9111f66 = ()=>{
    const sideBarSegment = (0, $03pp6.pageSegmentStore).getSegment((0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadStart);
};
const $2ebdd972899a51f4$export$edbd543f308bbef5 = ()=>{
    const sideBarSegment = (0, $03pp6.pageSegmentStore).getSegment((0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadEnd);
};

});

parcelRegister("i67QL", function(module, exports) {

$parcel$export(module.exports, "LazyForPaintServicedeskSidebar", () => $d27c58e19a795fc8$export$15e3805736f2222d);

var $gzcjr = parcelRequire("gzcjr");

var $7DXwW = parcelRequire("7DXwW");

const $d27c58e19a795fc8$export$15e3805736f2222d = (0, $gzcjr.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("9lbXz")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});

});
parcelRegister("9lbXz", function(module, exports) {

let $6ccf5a35f758ddff$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6ccf5a35f758ddff$var$load("fAbxa"),
    $6ccf5a35f758ddff$var$load("1G8UW"),
    $6ccf5a35f758ddff$var$load("iSk93"),
    $6ccf5a35f758ddff$var$load("hwlgY"),
    $6ccf5a35f758ddff$var$load("k4gbU"),
    $6ccf5a35f758ddff$var$load("1VRB2"),
    $6ccf5a35f758ddff$var$load("bABhq"),
    $6ccf5a35f758ddff$var$load("7vqGd"),
    $6ccf5a35f758ddff$var$load("1Y4bq"),
    $6ccf5a35f758ddff$var$load("7cYIK")
]).then(()=>parcelRequire('eQ0q2'));

});



parcelRegister("6xToB", function(module, exports) {

$parcel$export(module.exports, "createEntry", () => $d82625afc3ab60ed$export$344b9c9ab5e66c9a);

var $cZFiO = parcelRequire("cZFiO");
const $d82625afc3ab60ed$export$344b9c9ab5e66c9a = (0, $cZFiO.createRouteEntry);

});
parcelRegister("cZFiO", function(module, exports) {

$parcel$export(module.exports, "createRouteEntry", () => $afe0694b9341fac8$export$136cc45b1cabb43);
/**
 * Create route entry with entrypoint, resources, etc. override
 *
 * @param baseRoute Base route object that contains matching info
 * @param opts Route definition to fill and override
 */ function $afe0694b9341fac8$export$136cc45b1cabb43(baseRoute, opts) {
    // @ts-expect-error Re-using baseRoute to become the full route Object allows us to optimize
    // route transitions as RRR can directly use the route instead of comparing a separate InvariantRoute
    // against the full route list
    // eslint-disable-next-line no-param-reassign
    baseRoute.lazyOpts = opts;
    // @ts-expect-error TODO
    return baseRoute;
}

});


parcelRegister("4VIcO", function(module, exports) {

$parcel$export(module.exports, "getConsolidationStateResource", () => $f31902774f5ce285$export$a6cf5054d4f9f5dd);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $br21R = parcelRequire("br21R");

var $7jTnu = parcelRequire("7jTnu");

var $l1VxS = parcelRequire("l1VxS");

var $hbF3h = parcelRequire("hbF3h");

var $htDO2 = parcelRequire("htDO2");

const $f31902774f5ce285$export$de6c19ae237c1eb9 = (cloudId, atlassianAccountId, isAnonymous, appPermissions)=>{
    let url = (0, $7jTnu.fg)('operations-tenant-info-endpoint-update') ? '/internal/v1/users/ops-user-info' : '/internal/v1/customers/tenant-info';
    if (cloudId) url = `${url}/${cloudId}`;
    else throw new Error('No tenant info exists.');
    let promise;
    if (appPermissions && appPermissions.hasServiceDeskAccess === false || isAnonymous) {
        promise = new Promise((resolve)=>{
            resolve({
                consolidationState: (0, $htDO2.ConsolidationState).NOT_CONSOLIDATED,
                ...(0, $7jTnu.fg)('operations-tenant-info-endpoint-update') ? {
                    isAdmin: false
                } : {}
            });
        });
        return promise;
    }
    if ((0, $7jTnu.fg)('operations-tenant-info-endpoint-update')) url = `${url}/${atlassianAccountId}`;
    if (false) promise = (0, $br21R.eocFetch)(url, {
        exactUrl: true,
        headers: {
            'x-ssr-service-name': (0, $7jTnu.fg)('operations-tenant-info-endpoint-update') ? 'og-apps-user-int-api' : 'og-customer-int-api'
        }
    });
    else {
        const clientUrl = (0, $7jTnu.fg)('operations-tenant-info-endpoint-update') ? '/v1/users/ops-user-info' : '/v1/customers/tenant-info';
        promise = (0, $br21R.eocFetch)(clientUrl).then(({ data: data })=>data);
    }
    return promise;
};
const $f31902774f5ce285$var$getConsolidationStateResourceFactory = (forceBrowser = false)=>(0, $l1VxS.createResource)({
        type: (0, $f8747ec2695de8a7$export$25ee35b01de9d734),
        getKey: ()=>'tenantInformation',
        getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions, atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>$f31902774f5ce285$export$de6c19ae237c1eb9(cloudId, atlassianAccountId, isAnonymous, appPermissions),
        maxAge: Infinity,
        isBrowserOnly: forceBrowser,
        isCritical: true
    });
const $f31902774f5ce285$var$consolidationResourceForceBrowser = $f31902774f5ce285$var$getConsolidationStateResourceFactory(true);
const $f31902774f5ce285$var$consolidationResourceDontForceBrowser = $f31902774f5ce285$var$getConsolidationStateResourceFactory(false);
const $f31902774f5ce285$var$getConsolidationStateResourceNew = (forceBrowser = false)=>{
    /**
	 * This needs to return the same resource instance each time (based on args) or else we end up with many unnecessary re-renders
	 */ return forceBrowser ? $f31902774f5ce285$var$consolidationResourceForceBrowser : $f31902774f5ce285$var$consolidationResourceDontForceBrowser;
};
const $f31902774f5ce285$export$a6cf5054d4f9f5dd = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'), $f31902774f5ce285$var$getConsolidationStateResourceNew, $f31902774f5ce285$var$getConsolidationStateResourceFactory);

});
parcelRegister("br21R", function(module, exports) {

$parcel$export(module.exports, "eocFetch", () => $c0ce5978aadf71f6$export$212b9c60150b5a0a);

var $8XtVW = parcelRequire("8XtVW");

var $kTF8d = parcelRequire("kTF8d");

var $3TY2E = parcelRequire("3TY2E");

var $b8wNz = parcelRequire("b8wNz");

var $b388R = parcelRequire("b388R");
const $c0ce5978aadf71f6$export$212b9c60150b5a0a = (input, init)=>{
    let headers = init?.headers ?? {};
    let body = init?.body;
    // If there is no Content-Type we should add application/json
    // and if the body is not in the BodyInit format we should stringify it
    // Native fetch accepts headers as [['key1','value1'],['key2', 'value2']] so we don't want to modify header or body in this case
    if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
        body = JSON.stringify(body);
        headers['Content-Type'] = 'application/json';
    }
    if (typeof input === 'string') {
        input = (0, $b388R.withPrefix)(input, init);
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $8XtVW.fg)('trace_id_header_update_in_the_eoc_fetch')) headers = {
            ...(0, $kTF8d.getActiveTraceHttpRequestHeaders)(input),
            ...headers
        };
    } else {
        input = {
            ...input,
            url: (0, $b388R.withPrefix)(input.url, init)
        };
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $8XtVW.fg)('trace_id_header_update_in_the_eoc_fetch')) headers = {
            ...(0, $kTF8d.getActiveTraceHttpRequestHeaders)(input.url),
            ...headers
        };
    }
    const errorTransformer = init?.errorTransformer ?? (0, $b388R.defaultErrorTransformer);
    const startTime = performance.now();
    return fetch(input, {
        headers: headers,
        ...init,
        body: body
    }).catch((error)=>{
        throw new (0, $b8wNz.NetworkError)(error.name, error);
    }).then((response)=>{
        if (!response.ok) throw new (0, $b8wNz.HTTPError)(response);
        const sanitizedUrl = (0, $b388R.sanitizeUrlString)((0, $b388R.getRequestUrl)(input));
        (0, $3TY2E.addSpanToAll)('fetch', sanitizedUrl, [
            {
                name: 'network'
            }
        ], startTime, performance.now());
        switch(init?.responseType){
            case undefined:
            case 'json':
                return response.json();
            case 'blob':
                return response.blob();
            case 'text':
                return response.text();
            case 'headers':
                return response;
        }
    }).catch((error)=>{
        if ((0, $b8wNz.isNetworkError)(error)) {
            // Put it through the transformer and throw it when ready. Note that
            // it is still safe to throw in the transformer, it will just chain up
            // on the following handlers as usual.
            const transformerResult = errorTransformer(error);
            if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                throw finalError;
            });
            else throw transformerResult;
        }
        throw error;
    });
};

});
parcelRegister("b8wNz", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $ca54d0e57d6d71bb$export$bae979e68e4dc802);
$parcel$export(module.exports, "HTTPError", () => $ca54d0e57d6d71bb$export$aa9d629c530f62a7);
$parcel$export(module.exports, "StreamedHTTPError", () => $ca54d0e57d6d71bb$export$c30b5b02747d791c);
$parcel$export(module.exports, "isHTTPError", () => $ca54d0e57d6d71bb$export$6b7a49ce9c98a2f);
$parcel$export(module.exports, "isNetworkError", () => $ca54d0e57d6d71bb$export$476aa014e2fd89d5);
$parcel$export(module.exports, "isStreamedHTTPError", () => $ca54d0e57d6d71bb$export$4f52fcea95c8f97d);

var $iFQzx = parcelRequire("iFQzx");
class $ca54d0e57d6d71bb$export$bae979e68e4dc802 extends Error {
    constructor(name, cause){
        super('Network Error!'), this.name = name, this.cause = cause;
    }
}
class $ca54d0e57d6d71bb$export$aa9d629c530f62a7 extends $ca54d0e57d6d71bb$export$bae979e68e4dc802 {
    constructor(response){
        // It is important to note that this can be shown to the user if the
        // default transformer is not used for some reason and the thrown error's
        // message is left as is.
        super((0, $iFQzx.ERROR_NAMES).HTTPError);
        this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
        this.response = response;
    }
}
class $ca54d0e57d6d71bb$export$c30b5b02747d791c extends $ca54d0e57d6d71bb$export$aa9d629c530f62a7 {
    constructor(cause, data, message){
        super(cause.response), this.cause = cause, this.data = data, this.message = message;
        this.message = message;
        this.name = (0, $iFQzx.ERROR_NAMES).StreamedHTTPError;
    }
}
const $ca54d0e57d6d71bb$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $ca54d0e57d6d71bb$export$aa9d629c530f62a7 || [
        (0, $iFQzx.ERROR_NAMES).HTTPError,
        (0, $iFQzx.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $ca54d0e57d6d71bb$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $ca54d0e57d6d71bb$export$bae979e68e4dc802 || [
        (0, $iFQzx.ERROR_NAMES).NetworkError,
        (0, $iFQzx.ERROR_NAMES).HTTPError,
        (0, $iFQzx.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $ca54d0e57d6d71bb$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $ca54d0e57d6d71bb$export$c30b5b02747d791c || candidate?.name === (0, $iFQzx.ERROR_NAMES).StreamedHTTPError;

});
parcelRegister("iFQzx", function(module, exports) {

$parcel$export(module.exports, "ERROR_NAMES", () => $3792380d7d809e8c$export$daceac3b97803ce1);
var $3792380d7d809e8c$export$daceac3b97803ce1 = /*#__PURE__*/ function(ERROR_NAMES) {
    ERROR_NAMES["HTTPError"] = "HTTPError";
    ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
    ERROR_NAMES["NetworkError"] = "NetworkError";
    return ERROR_NAMES;
}({});

});


parcelRegister("b388R", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $12c58b9043999553$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "withPrefix", () => $12c58b9043999553$export$44188c5f179c4553);
$parcel$export(module.exports, "defaultErrorTransformer", () => $12c58b9043999553$export$270fcc0e5df09fdd);
$parcel$export(module.exports, "jsmErrorTransformer", () => $12c58b9043999553$export$994cc82144d28ded);
$parcel$export(module.exports, "getRequestUrl", () => $12c58b9043999553$export$14619c0eed01a470);
$parcel$export(module.exports, "sanitizeUrlString", () => $12c58b9043999553$export$ceb09b958e605eff);

var $7JjNE = parcelRequire("7JjNE");

var $b8wNz = parcelRequire("b8wNz");

let $12c58b9043999553$var$metaCloudId;
let $12c58b9043999553$var$isJSMAvailable = true;
function $12c58b9043999553$export$c47913ca32a5c6f7(name) {
    const globalVariable = window ?? $parcel$global;
    if ((0, $7JjNE.isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
    if ($12c58b9043999553$var$metaCloudId) return $12c58b9043999553$var$metaCloudId;
    if ($12c58b9043999553$var$isJSMAvailable) {
        const element = document.querySelector(`meta[name="${name}"]`);
        $12c58b9043999553$var$metaCloudId = element?.getAttribute('content') ?? undefined;
        $12c58b9043999553$var$isJSMAvailable = !!$12c58b9043999553$var$metaCloudId;
    }
    return $12c58b9043999553$var$metaCloudId;
}
function $12c58b9043999553$export$5a75f4aeb58ba80f(id) {
    $12c58b9043999553$var$metaCloudId = id;
}
function $12c58b9043999553$export$44188c5f179c4553(input, init) {
    if (init?.exactUrl) return input;
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = $12c58b9043999553$export$c47913ca32a5c6f7('ajs-cloud-id');
    if (cloudId) return (0, $5219dfbbef51607b$export$3414665826fa030e) + cloudId + input;
    return input;
}
// https://www.rfc-editor.org/rfc/rfc9110.html#section-8.3
// This is not a full implementation, but should skip any unknown parameters
// and match the charset if it exists. In case there are multiple (which shouldn't) we still
// match the first occurence. If only application/json is returned, utf-8 is
// assumed as we will try to parse it as utf-8 json. This is probably our best
// guess without too much effort here.
const $12c58b9043999553$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
const $12c58b9043999553$export$270fcc0e5df09fdd = (e)=>{
    if (e instanceof (0, $b8wNz.HTTPError)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $12c58b9043999553$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $b8wNz.StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $b8wNz.StreamedHTTPError)(e, message, message));
    }
    return e;
};
const $12c58b9043999553$export$994cc82144d28ded = (error)=>{
    if (error instanceof (0, $b8wNz.HTTPError)) {
        const contentType = error.response.headers.get('Content-Type');
        if (contentType && $12c58b9043999553$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, $b8wNz.StreamedHTTPError)(error, data, data.errorMessages.join(',')));
        return error.response.text().then((message)=>new (0, $b8wNz.StreamedHTTPError)(error, message, message));
    }
    return error;
};
const $12c58b9043999553$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
const $12c58b9043999553$export$ceb09b958e605eff = (url)=>{
    const urlWithoutQueryParams = url.replace(/\?.*$/, '');
    const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
    return urlWithoutUUIDs;
};

});
parcelRegister("7JjNE", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $b399c7c7103e325e$export$6acf61af03e62db);
const $b399c7c7103e325e$export$6acf61af03e62db = ()=>{
    try {
        //@ts-ignore: It defined from webpack on the Jira
        return false;
    } catch (error) {
        return globalThis.false ?? false;
    }
};

});

const $5219dfbbef51607b$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';



parcelRegister("htDO2", function(module, exports) {

$parcel$export(module.exports, "ConsolidationState", () => $ec93a9f74251e3bc$export$9ef498b0a11fd37d);
const $ec93a9f74251e3bc$export$9ef498b0a11fd37d = {
    NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
    TRANSITIONING: 'TRANSITIONING',
    TRANSITIONED: 'TRANSITIONED',
    CONSOLIDATED: 'CONSOLIDATED'
};

});

const $f8747ec2695de8a7$export$25ee35b01de9d734 = 'EOC_TENANT';


parcelRegister("1PvPk", function(module, exports) {

$parcel$export(module.exports, "getServiceDeskNavigationResources", () => $bd8fec0596296dc8$export$bc0bd65e6da57c1f);
$parcel$export(module.exports, "getServiceDeskNavigationSingleResources", () => $bd8fec0596296dc8$export$41a9145ddbba28e5);
$parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", () => $bd8fec0596296dc8$export$2c543d6accc1eb9b);
$parcel$export(module.exports, "getServiceDeskSettingsResources", () => $bd8fec0596296dc8$export$7bb3c4a2f6b127fb);
$parcel$export(module.exports, "getServicedeskPageContextResources", () => $bd8fec0596296dc8$export$a8b852f03a310dc0);
$parcel$export(module.exports, "getQueuesResources", () => $bd8fec0596296dc8$export$70b97995f4d5ef9f);
$parcel$export(module.exports, "getIssueListSsrResource", () => $bd8fec0596296dc8$export$e1016cce62543991);
$parcel$export(module.exports, "getKnowledgeBaseResources", () => $bd8fec0596296dc8$export$ed87d3b71544c4ef);
$parcel$export(module.exports, "getInsightResources", () => $bd8fec0596296dc8$export$9e0cf1fab0581096);
$parcel$export(module.exports, "getQueueConfigResource", () => $bd8fec0596296dc8$export$5f7bcaa978a3e51);
$parcel$export(module.exports, "getQueueViewConfigResource", () => $bd8fec0596296dc8$export$54079077c6768752);

var $igNUx = parcelRequire("igNUx");

var $7jTnu = parcelRequire("7jTnu");

var $hHbzj = parcelRequire("hHbzj");

var $3qMzf = parcelRequire("3qMzf");

var $gq8OO = parcelRequire("gq8OO");

var $5FSZM = parcelRequire("5FSZM");

var $6zZVV = parcelRequire("6zZVV");

var $dHUNm = parcelRequire("dHUNm");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6zXPf = parcelRequire("6zXPf");

var $85Ze9 = parcelRequire("85Ze9");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $cu1g7 = parcelRequire("cu1g7");

var $kgDPH = parcelRequire("kgDPH");

var $iWhpv = parcelRequire("iWhpv");

var $JHxCO = parcelRequire("JHxCO");

var $h60sh = parcelRequire("h60sh");

var $aGQ56 = parcelRequire("aGQ56");

var $aEWXS = parcelRequire("aEWXS");

var $arxGJ = parcelRequire("arxGJ");

var $g9kBK = parcelRequire("g9kBK");

var $bTfc4 = parcelRequire("bTfc4");

var $5L7qx = parcelRequire("5L7qx");

var $ePaI2 = parcelRequire("ePaI2");

var $27Owl = parcelRequire("27Owl");

var $alzbz = parcelRequire("alzbz");

var $c0h8V = parcelRequire("c0h8V");

var $fbgOh = parcelRequire("fbgOh");

var $lzT4f = parcelRequire("lzT4f");
const $bd8fec0596296dc8$var$getQueueSidebarViewAllQueuesResource = ()=>(0, $5L7qx.resourceWithCondition2)(()=>!(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('migrate_queue_sidebar_all_queues_expansion_to_be'), (0, $aGQ56.queueSidebarViewAllQueuesResource));
const $bd8fec0596296dc8$export$bc0bd65e6da57c1f = ()=>[
        ...(0, $9NmsS.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $bTfc4.incidentExperimentTraitResource),
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...$bd8fec0596296dc8$export$41a9145ddbba28e5()
    ];
const $bd8fec0596296dc8$export$41a9145ddbba28e5 = ()=>[
        // projectContextResource is a dependency to the priorityGroupsResource
        (0, $dZRaT.projectContextResource),
        $bd8fec0596296dc8$var$getQueueSidebarViewAllQueuesResource(),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)(), (0, $aGQ56.queueNav4SidebarSelectionResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)(), (0, $aGQ56.queueSidebarQueuesCategoryStateResource)),
        ...$bd8fec0596296dc8$export$9c1c5e389bd00e56(),
        ...$bd8fec0596296dc8$export$2c543d6accc1eb9b()
    ];
const $bd8fec0596296dc8$export$9c1c5e389bd00e56 = ()=>[
        (0, $aGQ56.priorityGroupByProjectIdResourceSsr),
        (0, $g9kBK.featuresResource),
        (0, $gq8OO.staticSidebarJsmReportsResource),
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $4VIcO.getConsolidationStateResource)()),
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $iWhpv.servicedeskIsItsmProjectResource)),
        (0, $aEWXS.nav3QueueGroupsStateResource)
    ];
const $bd8fec0596296dc8$export$2c543d6accc1eb9b = ()=>[
        (0, $aGQ56.queuesNavigationItems),
        (0, $h60sh.requiredProjectProperties),
        (0, $h60sh.requiredFrontendProperties),
        (0, $hHbzj.forgeServiceDeskQueueModuleResource),
        (0, $3qMzf.staticJSMProjectConnectAddonsNavigationResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        // for Getting Started menu item
        // resourceWithCondition2(isNav4ResourcesFixEnabled, requiredFrontendProperties),
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $dZRaT.projectContextResourceWithCache)),
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $h60sh.firstProjectResource))
    ];
const $bd8fec0596296dc8$export$7bb3c4a2f6b127fb = ()=>[
        ...(0, $9NmsS.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $bTfc4.incidentExperimentTraitResource),
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
        (0, $JHxCO.servicedeskPracticesResource),
        (0, $kgDPH.serviceDeskContextResource),
        (0, $cu1g7.serviceDeskAnalyticsContextResource),
        (0, $5L7qx.resourceWithCondition2)(()=>!(0, $igNUx.isFedRamp)(), (0, $arxGJ.virtualAgentOnboardingResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('fix_getting_started_panel_in_settings'), (0, $h60sh.firstProjectResource))
    ];
const $bd8fec0596296dc8$export$a8b852f03a310dc0 = ()=>[
        (0, $dZRaT.projectContextResourceWithCache),
        (0, $kgDPH.serviceDeskContextResource),
        (0, $cu1g7.serviceDeskAnalyticsContextResource),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_gp_announcements_banner'), (0, $lzT4f.jsmGracePeriodAnnouncementDisplayStateResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_gp_announcements_banner'), (0, $lzT4f.jsmGracePeriodAnnouncementGpEndDateResource))
    ];
const $bd8fec0596296dc8$export$70b97995f4d5ef9f = ()=>[
        ...$bd8fec0596296dc8$export$a8b852f03a310dc0(),
        ...$bd8fec0596296dc8$export$bc0bd65e6da57c1f(),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('corcap-2944-add-jqlbuilder-to-jsm-queues'), (0, $5FSZM.getCalendarFilterFieldsResource)())
    ];
const $bd8fec0596296dc8$export$e1016cce62543991 = ()=>[
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('ssr_view_queues_issuelist'), (0, $aGQ56.issueListSsrResource))
    ];
const $bd8fec0596296dc8$export$ed87d3b71544c4ef = ()=>[
        (0, $85Ze9.kbConfluenceContextResource)
    ];
const $bd8fec0596296dc8$export$9e0cf1fab0581096 = ()=>[
        (0, $ePaI2.workspaceResource)
    ];
const $bd8fec0596296dc8$export$5f7bcaa978a3e51 = ()=>[
        (0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('jsm-views-inside-queues-fastfollow') && (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $aGQ56.priorityGroupByProjectIdResourceSsr)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $dZRaT.projectContextResource))
    ];
const $bd8fec0596296dc8$export$54079077c6768752 = ()=>[
        (0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('jsm-views-inside-queues-fastfollow') && (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $alzbz.getRapidBoardDataResource)()),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $fbgOh.getEditModelResource)()),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $27Owl.getBoardDetailsResource)()),
        (0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('jsm-views-inside-queues-fastfollow') && (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $aGQ56.priorityGroupByProjectIdResourceSsr)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $dZRaT.projectContextResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $c0h8V.uifBoardResource)),
        ...(0, $alzbz.getRapidboardResources)().map((resource)=>(0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), resource))
    ];

});
parcelRegister("hHbzj", function(module, exports) {

$parcel$export(module.exports, "forgeAdminModuleResource", () => $7eeccaa3259d40ce$export$b9489d8c5c5e3626);
$parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", () => $7eeccaa3259d40ce$export$dcc98f4b36ce9223);
$parcel$export(module.exports, "forgeProjectModuleResource", () => $7eeccaa3259d40ce$export$72db683c2914a65e);
$parcel$export(module.exports, "forgeProjectModuleResourceOnNav3Only", () => $7eeccaa3259d40ce$export$9f19b684a7493211);
$parcel$export(module.exports, "forgeBacklogModuleResource", () => $7eeccaa3259d40ce$export$7523db37432ba090);
$parcel$export(module.exports, "forgeBoardModuleResource", () => $7eeccaa3259d40ce$export$cfd99f451b423d3a);
$parcel$export(module.exports, "forgeSprintModuleResource", () => $7eeccaa3259d40ce$export$7b639f33f086f9f1);
$parcel$export(module.exports, "forgePersonalSettingsPageModuleResource", () => $7eeccaa3259d40ce$export$8a5aed164e925eb6);
$parcel$export(module.exports, "getNavigationForgePersonalSettingsPageResources", () => $7eeccaa3259d40ce$export$ec3265610584f9ce);
$parcel$export(module.exports, "forgeProjectSettingsModuleResource", () => $7eeccaa3259d40ce$export$7a928d209faf75f);
$parcel$export(module.exports, "useForgeProjectSettingsModuleResource", () => $7eeccaa3259d40ce$export$e81e11bbc3239153);
$parcel$export(module.exports, "forgeGlobalModuleResource", () => $7eeccaa3259d40ce$export$97b0827022fdafe3);
$parcel$export(module.exports, "getNavigationForgeGlobalPageResources", () => $7eeccaa3259d40ce$export$80b2f91dabb3dd65);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", () => $7eeccaa3259d40ce$export$ebf5369e4dcfad00);
$parcel$export(module.exports, "forgeCustomFieldTypeResource", () => $7eeccaa3259d40ce$export$e6be2f0ca0849869);

var $4sqLM = parcelRequire("4sqLM");

var $7jTnu = parcelRequire("7jTnu");

var $fohjD = parcelRequire("fohjD");

var $dhAnj = parcelRequire("dhAnj");

var $6zXPf = parcelRequire("6zXPf");

var $fcQiO = parcelRequire("fcQiO");

var $5L7qx = parcelRequire("5L7qx");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $aOcSy = parcelRequire("aOcSy");
const $7eeccaa3259d40ce$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
    const isModuleWithAccessNarrowing = [
        (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE),
        (0, $fohjD.PROJECT_PAGE_MODULE),
        (0, $fohjD.PROJECT_SETTINGS_PAGE_MODULE)
    ] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .includes(moduleName);
    const projectIdOrKey = (0, $fcQiO.getProjectKeyOrId)(params);
    if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
        projectIdOrKey: projectIdOrKey
    };
    return null;
};
const $7eeccaa3259d40ce$export$b9489d8c5c5e3626 = (0, $l1VxS.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.ADMIN_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.ADMIN_PAGE_MODULE], (0, $aOcSy.adminPageFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$dcc98f4b36ce9223 = ()=>[
        $7eeccaa3259d40ce$export$b9489d8c5c5e3626
    ];
const $7eeccaa3259d40ce$export$72db683c2914a65e = (0, $l1VxS.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.PROJECT_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.PROJECT_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER,
    isCritical: true
});
const $7eeccaa3259d40ce$export$9f19b684a7493211 = (0, $5L7qx.resourceWithCondition2)(()=>!((0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('perf-push-big-components-nav-remove-resources')), $7eeccaa3259d40ce$export$72db683c2914a65e);
const $7eeccaa3259d40ce$export$7523db37432ba090 = (0, $l1VxS.createResource)({
    type: 'FORGE_BACKLOG_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.BACKLOG_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $fohjD.SOURCE_ROUTER)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.BACKLOG_ACTION_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$cfd99f451b423d3a = (0, $l1VxS.createResource)({
    type: 'FORGE_BOARD_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.BOARD_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $fohjD.SOURCE_ROUTER)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.BOARD_ACTION_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$7b639f33f086f9f1 = (0, $l1VxS.createResource)({
    type: 'FORGE_SPRINT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.SPRINT_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $fohjD.SOURCE_ROUTER)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.SPRINT_ACTION_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$8a5aed164e925eb6 = (0, $l1VxS.createResource)({
    type: 'FORGE_PERSONAL_SETTINGS_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$ec3265610584f9ce = ()=>[
        $7eeccaa3259d40ce$export$8a5aed164e925eb6
    ];
const $7eeccaa3259d40ce$export$7a928d209faf75f = (0, $l1VxS.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.PROJECT_SETTINGS_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.PROJECT_SETTINGS_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER,
    isCritical: true
});
const $7eeccaa3259d40ce$export$e81e11bbc3239153 = ()=>(0, $eJrcF.useResource)($7eeccaa3259d40ce$export$7a928d209faf75f);
const $7eeccaa3259d40ce$export$97b0827022fdafe3 = (0, $l1VxS.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.GLOBAL_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.GLOBAL_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$80b2f91dabb3dd65 = ()=>[
        $7eeccaa3259d40ce$export$97b0827022fdafe3
    ];
const $7eeccaa3259d40ce$export$ebf5369e4dcfad00 = (0, $l1VxS.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$e6be2f0ca0849869 = (0, $l1VxS.createResource)({
    type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
    getKey: ()=>'extensions',
    getData: (_route, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.CUSTOM_FIELD_TYPE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $fohjD.SOURCE_NAVIGATION)
        }).then(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (modules)=>modules[0, $fohjD.CUSTOM_FIELD_TYPE_MODULE]),
    maxAge: Number.MAX_SAFE_INTEGER
});
/**
 * Makes sure modules are filtered out depending on the predicate and sorted alphabetically by title.
 */ function $7eeccaa3259d40ce$var$normalizeModules(modules, filter) {
    return filter(modules).sort((a, b)=>(0, $4sqLM.alphabeticalSort)(a.properties.title, b.properties.title));
}

});
parcelRegister("4sqLM", function(module, exports) {

$parcel$export(module.exports, "alphabeticalSort", () => $b0b7341e5e59d415$export$89a1f01f2a7cb2a1);

var $eSnSE = parcelRequire("eSnSE");
const $b0b7341e5e59d415$export$89a1f01f2a7cb2a1 = (a, b)=>{
    // @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?ts(2774)
    if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
        numeric: true,
        caseFirst: 'upper'
    });
    const typeOfA = a === null ? 'null' : typeof a;
    const typeOfB = b === null ? 'null' : typeof b;
    const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
    (0, $eSnSE.default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
    return 1;
};

});

parcelRegister("fohjD", function(module, exports) {

$parcel$export(module.exports, "STAGING_ENVIRONMENT", () => $21d9ac84d0c10ee4$export$71acbd662c478c42);
$parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", () => $21d9ac84d0c10ee4$export$978072fd3fd149);
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", () => $21d9ac84d0c10ee4$export$ebc15d9cebfd6063);
$parcel$export(module.exports, "BACKLOG_ACTION_MODULE", () => $21d9ac84d0c10ee4$export$516a8fb49ad5d50e);
$parcel$export(module.exports, "BOARD_ACTION_MODULE", () => $21d9ac84d0c10ee4$export$6cc3a1f2111dee11);
$parcel$export(module.exports, "SPRINT_ACTION_MODULE", () => $21d9ac84d0c10ee4$export$cfb15d127f20a01f);
$parcel$export(module.exports, "ISSUE_ACTION_MODULE", () => $21d9ac84d0c10ee4$export$fcc4a18f46f80f16);
$parcel$export(module.exports, "COMMAND_PALETTE_MODULE", () => $21d9ac84d0c10ee4$export$65ebd2e1f63d2992);
$parcel$export(module.exports, "ISSUE_GLANCE_MODULE", () => $21d9ac84d0c10ee4$export$259bab989b0129d0);
$parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", () => $21d9ac84d0c10ee4$export$75f224942f595e13);
$parcel$export(module.exports, "ISSUE_PANEL_MODULE", () => $21d9ac84d0c10ee4$export$ba0968f9752844);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_ACTION_MODULE", () => $21d9ac84d0c10ee4$export$7e2136b4285d29f5);
$parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", () => $21d9ac84d0c10ee4$export$cc20a5638825fbb0);
$parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", () => $21d9ac84d0c10ee4$export$9069d4b945c3d532);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $21d9ac84d0c10ee4$export$811b7f067a43b422);
$parcel$export(module.exports, "CUSTOM_FIELD_MODULE", () => $21d9ac84d0c10ee4$export$e3887d6bafe8a17);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", () => $21d9ac84d0c10ee4$export$7b7866c04a2ad947);
$parcel$export(module.exports, "ADMIN_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$52e4945e96bd2aa0);
$parcel$export(module.exports, "PERSONAL_SETTINGS_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$a8cd23a3cbda9d58);
$parcel$export(module.exports, "PROJECT_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$151b03356f566603);
$parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$ea0d6ac082b0d636);
$parcel$export(module.exports, "GLOBAL_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$31ac745ab2add7cc);
$parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", () => $21d9ac84d0c10ee4$export$353acf28daa75c79);
$parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", () => $21d9ac84d0c10ee4$export$25627f012b21b0b9);
$parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", () => $21d9ac84d0c10ee4$export$42d6a8740fd42e58);
$parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", () => $21d9ac84d0c10ee4$export$a7186e5a73395db4);
$parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", () => $21d9ac84d0c10ee4$export$8fbcfe84dc845d17);
$parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$8af4cb794979f60d);
$parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", () => $21d9ac84d0c10ee4$export$5592ab836d562168);
$parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", () => $21d9ac84d0c10ee4$export$842eb4236828ac9);
$parcel$export(module.exports, "SUPPORTED_MODULES", () => $21d9ac84d0c10ee4$export$9b1a91242ce2a1b7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $21d9ac84d0c10ee4$export$2b8aeda236486576);
$parcel$export(module.exports, "ENTRY_POINT_VIEW", () => $21d9ac84d0c10ee4$export$c41ce1ec1ea6e73d);
$parcel$export(module.exports, "ENTRY_POINT_CREATE", () => $21d9ac84d0c10ee4$export$b37d58c3ed77c139);
$parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", () => $21d9ac84d0c10ee4$export$ab94dbd1d02ac251);
$parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", () => $21d9ac84d0c10ee4$export$b6a67a3131c6c48d);
$parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", () => $21d9ac84d0c10ee4$export$b75dc2bfd20898fe);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", () => $21d9ac84d0c10ee4$export$8e96118a698216cb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", () => $21d9ac84d0c10ee4$export$9b72a8e9b92658fb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", () => $21d9ac84d0c10ee4$export$2d6539e7d0553ae7);
$parcel$export(module.exports, "SOURCE_UNKNOWN", () => $21d9ac84d0c10ee4$export$ecbd7135d66cb322);
$parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", () => $21d9ac84d0c10ee4$export$61d882aa7aba51c);
$parcel$export(module.exports, "SOURCE_NAVIGATION", () => $21d9ac84d0c10ee4$export$fe90e46aea58e30b);
$parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", () => $21d9ac84d0c10ee4$export$c5ccbdb9893f2a6a);
$parcel$export(module.exports, "SOURCE_ROUTER", () => $21d9ac84d0c10ee4$export$eae46a3c13473a8d);
$parcel$export(module.exports, "SOURCE_LEGACY", () => $21d9ac84d0c10ee4$export$ac11ee191d09688f);
$parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", () => $21d9ac84d0c10ee4$export$4346e4e240c84319);
$parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", () => $21d9ac84d0c10ee4$export$d719bb340dc354e4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", () => $21d9ac84d0c10ee4$export$4b6228758e800433);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", () => $21d9ac84d0c10ee4$export$70495c8cc141a7a4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", () => $21d9ac84d0c10ee4$export$bc3d408418fdf9d2);
$parcel$export(module.exports, "getEmptyExtensionsObject", () => $21d9ac84d0c10ee4$export$218a328f66b86f7d);
$parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", () => $21d9ac84d0c10ee4$export$3193d714ab54ee26);
$parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $21d9ac84d0c10ee4$export$df7774a415710cce);
$parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $21d9ac84d0c10ee4$export$51ab2784839ce348);
const $21d9ac84d0c10ee4$export$9af0088c49bdedb = 'PRODUCTION';
const $21d9ac84d0c10ee4$export$71acbd662c478c42 = 'STAGING';
const $21d9ac84d0c10ee4$export$978072fd3fd149 = 'DEVELOPMENT';
const $21d9ac84d0c10ee4$export$ebc15d9cebfd6063 = 'default';
const $21d9ac84d0c10ee4$export$516a8fb49ad5d50e = 'jira:backlogAction';
const $21d9ac84d0c10ee4$export$6cc3a1f2111dee11 = 'jira:boardAction';
const $21d9ac84d0c10ee4$export$cfb15d127f20a01f = 'jira:sprintAction';
const $21d9ac84d0c10ee4$export$fcc4a18f46f80f16 = 'jira:issueAction';
const $21d9ac84d0c10ee4$export$65ebd2e1f63d2992 = 'jira:command';
const $21d9ac84d0c10ee4$export$259bab989b0129d0 = 'jira:issueGlance';
const $21d9ac84d0c10ee4$export$75f224942f595e13 = 'jira:issueContext';
const $21d9ac84d0c10ee4$export$ba0968f9752844 = 'jira:issuePanel';
const $21d9ac84d0c10ee4$export$7e2136b4285d29f5 = 'jira:issueNavigatorAction';
const $21d9ac84d0c10ee4$export$cc20a5638825fbb0 = 'jira:issueActivity';
const $21d9ac84d0c10ee4$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
const $21d9ac84d0c10ee4$export$811b7f067a43b422 = 'jira:uiModifications';
const $21d9ac84d0c10ee4$export$e3887d6bafe8a17 = 'jira:customField';
const $21d9ac84d0c10ee4$export$7b7866c04a2ad947 = 'jira:customFieldType';
const $21d9ac84d0c10ee4$export$52e4945e96bd2aa0 = 'jira:adminPage';
const $21d9ac84d0c10ee4$export$a8cd23a3cbda9d58 = 'jira:personalSettingsPage';
const $21d9ac84d0c10ee4$export$151b03356f566603 = 'jira:projectPage';
const $21d9ac84d0c10ee4$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
const $21d9ac84d0c10ee4$export$31ac745ab2add7cc = 'jira:globalPage';
const $21d9ac84d0c10ee4$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
const $21d9ac84d0c10ee4$export$25627f012b21b0b9 = 'jira:dashboardGadget';
const $21d9ac84d0c10ee4$export$42d6a8740fd42e58 = 'jira:workflowValidator';
const $21d9ac84d0c10ee4$export$a7186e5a73395db4 = 'jira:workflowCondition';
const $21d9ac84d0c10ee4$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
const $21d9ac84d0c10ee4$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
const $21d9ac84d0c10ee4$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
const $21d9ac84d0c10ee4$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
const $21d9ac84d0c10ee4$export$9b1a91242ce2a1b7 = [
    $21d9ac84d0c10ee4$export$516a8fb49ad5d50e,
    $21d9ac84d0c10ee4$export$65ebd2e1f63d2992,
    $21d9ac84d0c10ee4$export$6cc3a1f2111dee11,
    $21d9ac84d0c10ee4$export$cfb15d127f20a01f,
    $21d9ac84d0c10ee4$export$fcc4a18f46f80f16,
    $21d9ac84d0c10ee4$export$259bab989b0129d0,
    $21d9ac84d0c10ee4$export$75f224942f595e13,
    $21d9ac84d0c10ee4$export$7e2136b4285d29f5,
    $21d9ac84d0c10ee4$export$ba0968f9752844,
    $21d9ac84d0c10ee4$export$cc20a5638825fbb0,
    $21d9ac84d0c10ee4$export$9069d4b945c3d532,
    $21d9ac84d0c10ee4$export$811b7f067a43b422,
    $21d9ac84d0c10ee4$export$e3887d6bafe8a17,
    $21d9ac84d0c10ee4$export$7b7866c04a2ad947,
    $21d9ac84d0c10ee4$export$52e4945e96bd2aa0,
    $21d9ac84d0c10ee4$export$a8cd23a3cbda9d58,
    $21d9ac84d0c10ee4$export$151b03356f566603,
    $21d9ac84d0c10ee4$export$ea0d6ac082b0d636,
    $21d9ac84d0c10ee4$export$31ac745ab2add7cc,
    $21d9ac84d0c10ee4$export$353acf28daa75c79,
    $21d9ac84d0c10ee4$export$25627f012b21b0b9,
    $21d9ac84d0c10ee4$export$8af4cb794979f60d,
    $21d9ac84d0c10ee4$export$5592ab836d562168,
    $21d9ac84d0c10ee4$export$842eb4236828ac9,
    $21d9ac84d0c10ee4$export$42d6a8740fd42e58,
    $21d9ac84d0c10ee4$export$a7186e5a73395db4,
    $21d9ac84d0c10ee4$export$8fbcfe84dc845d17
];
const $21d9ac84d0c10ee4$export$2b8aeda236486576 = 'edit';
const $21d9ac84d0c10ee4$export$c41ce1ec1ea6e73d = 'view';
const $21d9ac84d0c10ee4$export$b37d58c3ed77c139 = 'create';
const $21d9ac84d0c10ee4$export$ab94dbd1d02ac251 = 'contextConfig';
const $21d9ac84d0c10ee4$export$b6a67a3131c6c48d = 'none';
const $21d9ac84d0c10ee4$export$b75dc2bfd20898fe = 5;
const $21d9ac84d0c10ee4$export$8e96118a698216cb = 'native';
const $21d9ac84d0c10ee4$export$9b72a8e9b92658fb = 'basic';
const $21d9ac84d0c10ee4$export$2d6539e7d0553ae7 = 'blank';
const $21d9ac84d0c10ee4$export$ecbd7135d66cb322 = 'unknownSource';
const $21d9ac84d0c10ee4$export$61d882aa7aba51c = 'global-issue-create';
const $21d9ac84d0c10ee4$export$46cb92762d68a048 = 'issue-view';
const $21d9ac84d0c10ee4$export$fe90e46aea58e30b = 'navigation';
const $21d9ac84d0c10ee4$export$c5ccbdb9893f2a6a = 'full-page-app';
const $21d9ac84d0c10ee4$export$eae46a3c13473a8d = 'router';
const $21d9ac84d0c10ee4$export$ac11ee191d09688f = 'legacy';
const $21d9ac84d0c10ee4$export$4346e4e240c84319 = 'organization-panel';
const $21d9ac84d0c10ee4$export$d719bb340dc354e4 = 'assets-import-type';
const $21d9ac84d0c10ee4$export$4b6228758e800433 = 'jira';
const $21d9ac84d0c10ee4$export$70495c8cc141a7a4 = 'jsm';
const $21d9ac84d0c10ee4$export$bc3d408418fdf9d2 = 'cmdb';
const $21d9ac84d0c10ee4$export$a48dade1864725a = {
    jiraBacklogAction: [],
    jiraBoardAction: [],
    jiraSprintAction: [],
    jiraIssueAction: [],
    jiraIssueContext: [],
    jiraIssueGlance: [],
    jiraIssuePanel: [],
    jiraIssueNavigatorAction: [],
    jiraIssueActivity: [],
    jiraIssueViewBackgroundScript: [],
    jiraCustomField: [],
    jiraCustomFieldType: [],
    jiraUiModifications: [],
    jiraAdminPage: [],
    jiraGlobalPage: [],
    jiraPersonalSettingsPage: [],
    jiraProjectPage: [],
    jiraProjectSettingsPage: [],
    jiraDashboardBackgroundScript: [],
    jiraDashboardGadget: [],
    jiraServiceManagementQueuePage: [],
    jiraServiceManagementOrganizationPanel: [],
    jiraServiceManagementAssetsImportType: [],
    jiraWorkflowValidator: [],
    jiraWorkflowCondition: [],
    jiraWorkflowPostFunction: [],
    jiraCommand: []
};
/**
 * The above EMPTY_EXTENSIONS_OBJECT sometimes is mutated.
 * @see getEmptyExtensionsObject
 */ const $21d9ac84d0c10ee4$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
    ...$21d9ac84d0c10ee4$export$a48dade1864725a
};
const $21d9ac84d0c10ee4$export$218a328f66b86f7d = ()=>({
        ...$21d9ac84d0c10ee4$var$STABLE_EMPTY_EXTENSIONS_OBJECT
    });
const $21d9ac84d0c10ee4$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $21d9ac84d0c10ee4$export$df7774a415710cce = 'com.atlassian.forge:';
const $21d9ac84d0c10ee4$export$51ab2784839ce348 = `${$21d9ac84d0c10ee4$export$df7774a415710cce}${$21d9ac84d0c10ee4$export$3193d714ab54ee26}`;

});

parcelRegister("dhAnj", function(module, exports) {

$parcel$export(module.exports, "fetchModules", () => $ccf944db3861cc5e$export$24d8e11b15325c53);

var $c8VEk = parcelRequire("c8VEk");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $a1pDt = parcelRequire("a1pDt");

var $ayoPl = parcelRequire("ayoPl");

var $9gq2c = parcelRequire("9gq2c");

var $b6ojT = parcelRequire("b6ojT");

var $fohjD = parcelRequire("fohjD");

var $7zZ4w = parcelRequire("7zZ4w");

var $c8VEk = parcelRequire("c8VEk");

var $lB0Td = parcelRequire("lB0Td");

var $TUft0 = parcelRequire("TUft0");

var $aiU3I = parcelRequire("aiU3I");
const $ccf944db3861cc5e$export$24d8e11b15325c53 = async (params)=>{
    const { types: types, cloudId: cloudId, isAnonymous: isAnonymous, source: source = (0, $fohjD.SOURCE_UNKNOWN) } = params;
    if (!(0, $lB0Td.canFetchForgeModules)({
        cloudId: cloudId,
        isAnonymous: isAnonymous
    })) return (0, $TUft0.toMappedExtensions)(types, []);
    try {
        const extensions = await (0, $ayoPl.measureExecutionTimeMetrics)(()=>$ccf944db3861cc5e$export$9f9fdbce0829073d(params));
        if (Math.random() * 100 < (0, $9gq2c.FORGE_SAMPLING_RATE)) (0, $b6ojT.fireInitializationFetchFinishedEvent)(source);
        return (0, $TUft0.toMappedExtensions)(types, extensions);
    } catch (error) {
        const errorType = (0, $a1pDt.getErrorType)(error);
        (0, $b6ojT.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        if ($ccf944db3861cc5e$export$458cbcb6374269d2.includes(errorType)) return (0, $TUft0.toMappedExtensions)(types, []);
        throw error;
    }
};
function $ccf944db3861cc5e$export$9f9fdbce0829073d(props) {
    const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = false } = props;
    if (types.length === 0) throw new Error('No modules to fetch provided');
    const operationName = (0, $c8VEk.default).params.name;
    const { stopGraphQLErrorTracking: stopGraphQLErrorTracking, getGraphQLError: getGraphQLError } = (0, $aiU3I.trackGraphQLErrors)(operationName);
    let extensions;
    return new Promise((resolve, reject)=>{
        const subscription = (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), /* eslint-disable @atlassian/relay/unused-fields */ (0, $c8VEk.default), /* eslint-enable @atlassian/relay/unused-fields */ {
            cloudId: cloudId,
            context: context,
            types: types,
            includeHidden: includeHidden,
            includeScopes: includeScopes,
            includeModuleId: (0, $7jTnu.fg)('forge-extensions-module-id-for-relay')
        }).subscribe({
            next: (response)=>{
                stopGraphQLErrorTracking();
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const responseExtensions = response.jira?.forge?.extensions;
                // @ts-expect-error - TODO: new genereated type is incompatible with it
                extensions = responseExtensions?.concat().map((ext)=>({
                        ...ext,
                        moduleId: ext.moduleId ?? null
                    })) || null;
            },
            error: (error)=>{
                stopGraphQLErrorTracking();
                reject(error);
                subscription.unsubscribe();
            },
            complete: ()=>{
                // If there is a GraphQL error and extensions are `null`, it means a critical error has happened, and we have to reject the promise.
                // However, if the list of extensions is present in the response, it shouldn't be considered an error.
                const graphQLError = getGraphQLError();
                if (graphQLError) extensions != null ? resolve(extensions || []) : reject(graphQLError);
                else resolve(extensions || []);
                subscription.unsubscribe();
            }
        });
    });
}
const $ccf944db3861cc5e$export$458cbcb6374269d2 = [
    (0, $a1pDt.FAILED_TO_FETCH),
    (0, $a1pDt.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $a1pDt.DATA_CLASSIFICATION_NO_ACCESS)
];

});
parcelRegister("c8VEk", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f691a859de7e35$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<65fdc39e22800ca49612b9334bcb8eee>>
 * @relayHash aa40c90903e47de315699de2ec5782c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b12b6105b2132d43c112090236c6be48401ba3a6ade76a8ddabd15f77ae4e7e2
const $59f691a859de7e35$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeHidden"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeModuleId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeScopes"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "types"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraForgeQuery",
                    "kind": "LinkedField",
                    "name": "forge",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "context"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "includeHidden",
                                    "variableName": "includeHidden"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "types",
                                    "variableName": "types"
                                }
                            ],
                            "concreteType": "JiraForgeExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                {
                                    "condition": "includeHidden",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeScopes",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "condition": "includeModuleId",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "moduleId"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "installationId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "appVersion"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "consentUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "properties"
                                },
                                {
                                    "concreteType": "JiraUserAppAccess",
                                    "kind": "LinkedField",
                                    "name": "userAccess",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasAccess"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeAppEgressDeclaration",
                                    "kind": "LinkedField",
                                    "name": "egress",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "addresses"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "inScopeEUD"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeInstallationConfigExtension",
                                    "kind": "LinkedField",
                                    "name": "installationConfig",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeExtensionLicense",
                                    "kind": "LinkedField",
                                    "name": "license",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "active"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "supportEntitlementNumber"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "trialEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "subscriptionEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEvaluation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "billingPeriod"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementSlug"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "capabilitySet"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchModulesV2Query",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchModulesV2Query",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "id": "b12b6105b2132d43c112090236c6be48401ba3a6ade76a8ddabd15f77ae4e7e2",
            "metadata": {},
            "name": "fetchModulesV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$59f691a859de7e35$var$node.hash = "dc31e587ad9ce88caeb86481fbd6aa8d";
var $59f691a859de7e35$export$2e2bcd8739ae039 = $59f691a859de7e35$var$node;

});

parcelRegister("a1pDt", function(module, exports) {

$parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", () => $418aaf9ffa32ce25$export$23de3198bfe70090);
$parcel$export(module.exports, "FAILED_TO_FETCH", () => $418aaf9ffa32ce25$export$f52aa41ccd776f01);
$parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", () => $418aaf9ffa32ce25$export$31d2ab0be67934f0);
$parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", () => $418aaf9ffa32ce25$export$89a175d4190df42e);
$parcel$export(module.exports, "userConsentErrorRegex", () => $418aaf9ffa32ce25$export$dddade71b333c01d);
$parcel$export(module.exports, "getErrorType", () => $418aaf9ffa32ce25$export$e19f9f08a6d79fd2);


var $8KUFq = parcelRequire("8KUFq");

var $5Z6L0 = parcelRequire("5Z6L0");

var $dSzMM = parcelRequire("dSzMM");
const $418aaf9ffa32ce25$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $418aaf9ffa32ce25$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $418aaf9ffa32ce25$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $418aaf9ffa32ce25$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $418aaf9ffa32ce25$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $418aaf9ffa32ce25$export$89a175d4190df42e = 'Invoke value functions failed:';
const $418aaf9ffa32ce25$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $418aaf9ffa32ce25$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if ((0, $dSzMM.isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $418aaf9ffa32ce25$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $418aaf9ffa32ce25$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    // Tracked GraphQL errors contain useful info about internal errors like status codes
    // We want to categorize them more precisely, because some error types aren't SLO critical.
    if (error instanceof (0, $5Z6L0.TrackedGraphQLError)) {
        if (error.statusCode && error.statusCode >= 400) return error.statusCode === 429 ? $418aaf9ffa32ce25$export$7a1bd8c001e7e9c : `ERROR_SERVER_RESPONSE_${error.statusCode}`;
        return 'TRACKED_GRAPHQL_ERROR';
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $418aaf9ffa32ce25$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.') || /Extension ".*" could not be invoked as it does not reference a function or an endpoint/i.test(message)) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($418aaf9ffa32ce25$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($418aaf9ffa32ce25$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $44ccf6b895337c89$export$9de493bcd9b1d977);
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $44ccf6b895337c89$export$fa405bbf47d510e2);
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
   * 	Whole message:
   *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
   */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
   * 	Whole message:
   *	Invoke value functions failed: Error server response: 429
   */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $418aaf9ffa32ce25$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($418aaf9ffa32ce25$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($418aaf9ffa32ce25$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $8KUFq.isClientFetchError)(error)) return $418aaf9ffa32ce25$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
const $44ccf6b895337c89$export$ff39ebd4bb12b718 = 201;
const $44ccf6b895337c89$export$3288b14b6745c572 = 204;
const $44ccf6b895337c89$export$9de493bcd9b1d977 = 400;
const $44ccf6b895337c89$export$67d19e9a991baa07 = 401;
const $44ccf6b895337c89$export$a3269a3914b007e3 = 403;
const $44ccf6b895337c89$export$8bca792d963eb0ef = 404;
const $44ccf6b895337c89$export$4a3cb39801694eee = 407;
const $44ccf6b895337c89$export$fa405bbf47d510e2 = 408;
const $44ccf6b895337c89$export$c09e7ea0fc79f34f = 409;
const $44ccf6b895337c89$export$5244030134e99 = 412;
const $44ccf6b895337c89$export$f90ac1df0b60853d = 413;
const $44ccf6b895337c89$export$a447d0a965e16776 = 422;
const $44ccf6b895337c89$export$3b48aba8957000cd = 426;
const $44ccf6b895337c89$export$6763168a631449a2 = 429;
const $44ccf6b895337c89$export$e813cd7045fcc98d = 500;
const $44ccf6b895337c89$export$2ce38d41a306034e = 502;
const $44ccf6b895337c89$export$974c37534b0191b1 = 503;
const $44ccf6b895337c89$export$5400e8dddac3fcf3 = 504;

parcelRegister("5Z6L0", function(module, exports) {

$parcel$export(module.exports, "TrackedGraphQLError", () => $4ea9e19fe27d2302$export$f2062ad173e74c75);
class $4ea9e19fe27d2302$export$f2062ad173e74c75 extends Error {
    constructor(errorMessage, errors, traceIds){
        super(errorMessage), this.errorMessage = errorMessage, this.errors = errors, this.traceIds = traceIds;
        this.errors = errors;
        // Get first trace id
        this.traceId = traceIds?.[0];
        // Get first status code
        this.statusCode = errors?.map((graphQLError)=>graphQLError && 'extensions' in graphQLError ? graphQLError?.extensions?.statusCode : null).filter(Boolean)?.[0];
        // Combine error messages
        this.message = errors?.map((graphQLError)=>graphQLError?.message).filter(Boolean).join('; ') ?? errorMessage;
    }
}

});


parcelRegister("ayoPl", function(module, exports) {

$parcel$export(module.exports, "measureExecutionTimeMetrics", () => $8f610b55c617371f$export$a859f6866f4653e0);

var $aXKmr = parcelRequire("aXKmr");

var $9gq2c = parcelRequire("9gq2c");

var $lHD3D = parcelRequire("lHD3D");
const $8f610b55c617371f$export$a859f6866f4653e0 = async (action)=>{
    const concurrentId = (0, $aXKmr.v4)();
    const shouldSendTimeMetric = Math.random() * 100 < (0, $9gq2c.FORGE_SAMPLING_RATE);
    try {
        if (shouldSendTimeMetric) (0, $lHD3D.forgeModulesConcurrentFetchTime)(concurrentId).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $lHD3D.forgeModulesConcurrentFetchTime)(concurrentId).stop({
            stopTime: performance.now()
        });
        return result;
    } catch (error) {
        if (shouldSendTimeMetric) (0, $lHD3D.forgeModulesConcurrentFetchTime)(concurrentId).cancel();
        throw error;
    }
};

});
parcelRegister("9gq2c", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME_GASV3", () => $27592f25cbe551e4$export$f892f621fb508154);
$parcel$export(module.exports, "MODULE_TYPE_TRIGGER", () => $27592f25cbe551e4$export$ed63b053e04e26df);
$parcel$export(module.exports, "MODULE_TYPE_EXTENSION", () => $27592f25cbe551e4$export$725bacc669333eef);
$parcel$export(module.exports, "FORGE_SAMPLING_RATE", () => $27592f25cbe551e4$export$d920cee73ec094d0);
$parcel$export(module.exports, "PERFORMANCE_KEYS", () => $27592f25cbe551e4$export$f048d91ccaf92408);
$parcel$export(module.exports, "UI_ACTIONS", () => $27592f25cbe551e4$export$2b7367f125154866);
$parcel$export(module.exports, "OPERATIONAL_ACTIONS", () => $27592f25cbe551e4$export$42bcca5cae2ce90b);
$parcel$export(module.exports, "TRACK_ACTIONS", () => $27592f25cbe551e4$export$2af0438304d7c4b2);
// TODO ARKEN-359: uniformise GASv3/BM3 keys to use kebab lowercase
const $27592f25cbe551e4$export$f892f621fb508154 = 'jiraForgeUi';
const $27592f25cbe551e4$export$273f5980517336e2 = 'jiraforgeui';
const $27592f25cbe551e4$export$ed63b053e04e26df = 'trigger';
const $27592f25cbe551e4$export$725bacc669333eef = 'extension';
const $27592f25cbe551e4$export$d920cee73ec094d0 = 10;
const $27592f25cbe551e4$export$f048d91ccaf92408 = {
    FORGE_MODULES: {
        FETCH_TIME: `${$27592f25cbe551e4$export$273f5980517336e2}.forge-modules.fetch-time`,
        LOAD_TIME: `${$27592f25cbe551e4$export$273f5980517336e2}.forge-modules.load-time`
    },
    REAL_TIME_ISSUE_EVENTS: {
        INVOKE_TIME: `${$27592f25cbe551e4$export$273f5980517336e2}.real-time-issue-events.invoke-time`
    },
    MARKS: {
        TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
        TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
    }
};
const $27592f25cbe551e4$export$2b7367f125154866 = {
    CLICKED: 'clicked',
    SELECTED: 'selected',
    CANCELED: 'canceled',
    ACTION_CLICKED: 'action clicked',
    COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
    PIN_UNPIN_CLICKED: 'pin-unpin clicked',
    REMOVE_CLICKED: 'remove clicked'
};
const $27592f25cbe551e4$export$42bcca5cae2ce90b = {
    FAILED: 'failed',
    SUCCEEDED: 'succeeded',
    CALLED: 'called',
    INITIALIZED: 'initialized',
    EDIT_FAILED: 'edit failed',
    ACTION_FAILED: 'action failed',
    SAVE_FAILED: 'save failed',
    REMOVE_FAILED: 'remove failed',
    UPDATE_FAILED: 'update failed'
};
const $27592f25cbe551e4$export$2af0438304d7c4b2 = {
    EDITED: 'edited',
    SAVED: 'saved',
    REMOVED: 'removed',
    ACTION_SUCCEED: 'action succeed',
    UPDATE_SUCCEED: 'update succeed'
};

});

parcelRegister("lHD3D", function(module, exports) {

$parcel$export(module.exports, "forgeModulesConcurrentFetchTime", () => $9103e0edbbdf20b7$export$c3d8833fbea3e976);
$parcel$export(module.exports, "forgeModulesConcurrentLoadTime", () => $9103e0edbbdf20b7$export$292f3b557281044f);
$parcel$export(module.exports, "realTimeIssueEventInvokeTime", () => $9103e0edbbdf20b7$export$89ace7e2bb7d7685);
$parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", () => $9103e0edbbdf20b7$export$94f65f3b2556df23);
$parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", () => $9103e0edbbdf20b7$export$116d5e25caf0018d);
$parcel$export(module.exports, "customFieldPageSegmentLoadMetric", () => $9103e0edbbdf20b7$export$3bd38623c2543fc0);
$parcel$export(module.exports, "customFieldInteractionMetric", () => $9103e0edbbdf20b7$export$a318f99472db73c8);

var $4WXKS = parcelRequire("4WXKS");

var $gPCSe = parcelRequire("gPCSe");

var $aRK4c = parcelRequire("aRK4c");
var $9GzfC = parcelRequire("9GzfC");

var $9gq2c = parcelRequire("9gq2c");
const $9103e0edbbdf20b7$export$c3d8833fbea3e976 = (0, $4WXKS.metrics).concurrent.custom({
    key: (0, $9gq2c.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $9103e0edbbdf20b7$export$292f3b557281044f = (0, $4WXKS.metrics).concurrent.custom({
    key: (0, $9gq2c.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
});
const $9103e0edbbdf20b7$export$89ace7e2bb7d7685 = new (0, $9GzfC.UFOExperience)((0, $9gq2c.PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
    type: (0, $aRK4c.ExperienceTypes).Experience,
    performanceType: (0, $aRK4c.ExperiencePerformanceTypes).InlineResult
});
async function $9103e0edbbdf20b7$export$94f65f3b2556df23(startMark, endMark, fn) {
    if (false || (0, $gPCSe.default).getEntriesByName(startMark).length > 0 || (0, $gPCSe.default).getEntriesByName(endMark).length > 0) return fn();
    (0, $gPCSe.default).mark(startMark);
    const result = await fn();
    (0, $gPCSe.default).mark(endMark);
    return result;
}
const $9103e0edbbdf20b7$export$116d5e25caf0018d = (metric, additionalTimings)=>{
    additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
            ...(0, $gPCSe.default).getEntriesByName(startMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: cleanStart,
                    cleanEnd: undefined
                })),
            ...(0, $gPCSe.default).getEntriesByName(endMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: undefined,
                    cleanEnd: cleanEnd
                }))
        ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
        metric.mark(name, startTime);
        if (cleanStart || cleanEnd) (0, $gPCSe.default).clearMarks(name);
    });
};
const $9103e0edbbdf20b7$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, $4WXKS.metrics).pageSegmentLoad({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings,
            {
                key: 'tti',
                startMark: (0, $9gq2c.PERFORMANCE_KEYS).MARKS.TTI_START,
                endMark: (0, $9gq2c.PERFORMANCE_KEYS).MARKS.TTI_END
            }
        ]
    });
const $9103e0edbbdf20b7$export$a318f99472db73c8 = (additionalTimings = [])=>(0, $4WXKS.metrics).interaction({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings
        ]
    });

});


parcelRegister("b6ojT", function(module, exports) {

$parcel$export(module.exports, "fireInitializationFetchFinishedEvent", () => $b46b77cba3fc4937$export$132ca822850e455f);
$parcel$export(module.exports, "fireInitializationFetchFailedEvent", () => $b46b77cba3fc4937$export$b5ca88b1053f1ad0);

var $5IiZP = parcelRequire("5IiZP");

var $1GZq2 = parcelRequire("1GZq2");
const $b46b77cba3fc4937$var$INITIALIZATION_ACTIONS = {
    STARTED: 'started',
    FINISHED: 'finished',
    FAILED: 'failed'
};
const $b46b77cba3fc4937$export$917d0643b0111a02 = (0, $5IiZP.toEventId)('issueViewInitialization');
const $b46b77cba3fc4937$export$43e875fd63e64525 = (0, $5IiZP.toEventId)('fetchModulesInitialization');
const $b46b77cba3fc4937$export$132ca822850e455f = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $b46b77cba3fc4937$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $b46b77cba3fc4937$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $b46b77cba3fc4937$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $b46b77cba3fc4937$export$e914f7df1e4ad79b = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $b46b77cba3fc4937$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });
const $b46b77cba3fc4937$export$b274c658390b491b = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $b46b77cba3fc4937$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });

});
parcelRegister("5IiZP", function(module, exports) {

$parcel$export(module.exports, "toEventId", () => $f4ec6f2be36576de$export$75e84ef5a3771f9a);
const $f4ec6f2be36576de$export$75e84ef5a3771f9a = (value)=>value;

});

parcelRegister("1GZq2", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $08a88d513347b1c2$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireUiEvent", () => $08a88d513347b1c2$export$bed7f228c94e5f2a);
$parcel$export(module.exports, "fireTrackEvent", () => $08a88d513347b1c2$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireInitializationEvent", () => $08a88d513347b1c2$export$390a62413962e4f0);

var $2Mqjh = parcelRequire("2Mqjh");

var $9gq2c = parcelRequire("9gq2c");

var $lHVmb = parcelRequire("lHVmb");

var $e6Fnd = parcelRequire("e6Fnd");

var $esfNg = parcelRequire("esfNg");
const $08a88d513347b1c2$var$createAnalyticsProps = ({ id: id, source: // Since source is required in sendOperationalEvent and sendUIEvent we need to pass here a fallback
// in case source is not provided
source = 'unknownSource', action: action, attributes: attributes })=>({
        actionSubject: `${0, $9gq2c.PACKAGE_NAME_GASV3}.${id}`,
        attributes: (0, $lHVmb.createAttributes)(attributes),
        source: source,
        action: action
    });
const $08a88d513347b1c2$var$getAnalyticsClient = async ()=>(await (0, $2Mqjh.getAnalyticsWebClientPromise)()).getInstance();
const $08a88d513347b1c2$var$sendOperationalEvent = async (props)=>(await $08a88d513347b1c2$var$getAnalyticsClient()).sendOperationalEvent($08a88d513347b1c2$var$createAnalyticsProps(props));
const $08a88d513347b1c2$var$sendUiEvent = async (props)=>(await $08a88d513347b1c2$var$getAnalyticsClient()).sendUIEvent($08a88d513347b1c2$var$createAnalyticsProps(props));
const $08a88d513347b1c2$var$sendTrackEvent = async (props)=>(await $08a88d513347b1c2$var$getAnalyticsClient()).sendTrackEvent($08a88d513347b1c2$var$createAnalyticsProps(props));
const $08a88d513347b1c2$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$08a88d513347b1c2$var$sendOperationalEvent({
        ...eventProps,
        source: (0, $lHVmb.parseSource)(source),
        action: action
    });
const $08a88d513347b1c2$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$08a88d513347b1c2$var$sendUiEvent({
        ...eventProps,
        source: (0, $lHVmb.parseSource)(source),
        action: action
    });
const $08a88d513347b1c2$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$08a88d513347b1c2$var$sendTrackEvent({
        ...eventProps,
        source: (0, $lHVmb.parseSource)(source),
        action: action
    });
const $08a88d513347b1c2$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
        $08a88d513347b1c2$export$a1fb57756f0de62b(action, {
            id: id,
            attributes: attributes,
            source: source
        }),
        attributes?.error && (0, $e6Fnd.logError)((0, $e6Fnd.ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, $esfNg.isSynthetic)().toString()}, id=${id}, source=${(0, $lHVmb.parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
    ]);

});
parcelRegister("lHVmb", function(module, exports) {

$parcel$export(module.exports, "parseSource", () => $9bd51fd7ce296308$export$e98201ef9a88ba70);
$parcel$export(module.exports, "createAttributes", () => $9bd51fd7ce296308$export$c7c9603a6b1fd815);

var $3rsPO = parcelRequire("3rsPO");

var $hWeHP = parcelRequire("hWeHP");

var $bor34 = parcelRequire("bor34");

var $a1pDt = parcelRequire("a1pDt");

var $esfNg = parcelRequire("esfNg");
const $9bd51fd7ce296308$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
const $9bd51fd7ce296308$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $9bd51fd7ce296308$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: (0, $esfNg.isSynthetic)(),
        isOverridingFragments: (0, $bor34.isOverridingFragments)(),
        isSSR: false,
        shard: (0, $hWeHP.default)('ajs-shard') || '',
        region: (0, $hWeHP.default)('ajs-region') || ''
    };
    if (rawAttributes) {
        const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
        if (source) attributes.source = $9bd51fd7ce296308$export$e98201ef9a88ba70(source);
        if (error) {
            attributes.error = $9bd51fd7ce296308$export$78c6267359db7e73(error);
            attributes.errorType = (0, $a1pDt.getErrorType)(error);
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3rsPO)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});
parcelRegister("bor34", function(module, exports) {

$parcel$export(module.exports, "isOverridingFragments", () => $67dfabecb1e685f2$export$1d1321d2b374d697);

var $7jTnu = parcelRequire("7jTnu");
const $67dfabecb1e685f2$export$1d1321d2b374d697 = ()=>{
    if ((0, $7jTnu.fg)('is_overriding_fragments_analytics_prop')) {
        const re = /^(JF-TEST|MRJF-BB(\d+)?-\d+)$/;
        const buildKey = typeof window !== 'undefined' ? window?.BUILD_KEY : globalThis?.BUILD_KEY;
        return buildKey ? re.test(buildKey) : false;
    }
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};

});

parcelRegister("esfNg", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $f87e848916480251$export$947749d756ccb0a);

var $7jTnu = parcelRequire("7jTnu");

var $hWeHP = parcelRequire("hWeHP");
const $f87e848916480251$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $hWeHP.default)('ajs-is-synthetic') === 'true' || (0, $7jTnu.fg)('forge_ui_synthetic_check');

});


parcelRegister("e6Fnd", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_UTIL", () => $f2ad15b7ec81ba1d$export$d1e4f308040bb0d5);
$parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", () => $f2ad15b7ec81ba1d$export$36f315a5c6daf40b);
$parcel$export(module.exports, "logError", () => $f2ad15b7ec81ba1d$export$58da9968c3170cb1);

var $eSnSE = parcelRequire("eSnSE");

var $9gq2c = parcelRequire("9gq2c");
const $f2ad15b7ec81ba1d$export$e31edcd35abe3bb1 = 'environment-mapping';
const $f2ad15b7ec81ba1d$export$d1e4f308040bb0d5 = 'analytics';
const $f2ad15b7ec81ba1d$export$36f315a5c6daf40b = 'custom-field-object-type';
const $f2ad15b7ec81ba1d$export$6ee8198f29fffdb4 = {
    [$f2ad15b7ec81ba1d$export$d1e4f308040bb0d5]: `${(0, $9gq2c.PACKAGE_NAME_GASV3)}.error.utils.analytics`,
    [$f2ad15b7ec81ba1d$export$e31edcd35abe3bb1]: `${(0, $9gq2c.PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
    [$f2ad15b7ec81ba1d$export$36f315a5c6daf40b]: `${(0, $9gq2c.PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
};
const $f2ad15b7ec81ba1d$export$58da9968c3170cb1 = (key, message, event)=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData($f2ad15b7ec81ba1d$export$6ee8198f29fffdb4[key], message, event);
};

});



parcelRegister("7zZ4w", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf162cdbeeb2a572$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/relay-runtime

var $37Ewn = parcelRequire("37Ewn");

var $ecdTx = parcelRequire("ecdTx");
let $cf162cdbeeb2a572$var$relayEnvironment;
function $cf162cdbeeb2a572$export$2e2bcd8739ae039() {
    if (!$cf162cdbeeb2a572$var$relayEnvironment) {
        const environmentConfig = (0, $ecdTx.getRelayEnvironmentConfig)();
        $cf162cdbeeb2a572$var$relayEnvironment = new (0, $37Ewn.Environment)(environmentConfig);
    }
    return $cf162cdbeeb2a572$var$relayEnvironment;
}

});
parcelRegister("ecdTx", function(module, exports) {

$parcel$export(module.exports, "getRelayEnvironmentConfig", () => $3a6af9693868c9f1$export$a451c85db2d1cda3);

var $hUl5a = parcelRequire("hUl5a");

var $fFqgB = parcelRequire("fFqgB");

var $47ykf = parcelRequire("47ykf");
const $3a6af9693868c9f1$export$a451c85db2d1cda3 = ()=>(0, $47ykf.getDefaultRelayEnvironmentConfig)({
        network: (0, $fFqgB.getNetwork)(),
        log: (0, $hUl5a.default),
        requiredFieldLogger: $hUl5a.requiredFieldLogger
    });

});
parcelRegister("hUl5a", function(module, exports) {

$parcel$export(module.exports, "requiredFieldLogger", () => $8e53fb941ae19e72$export$1ab8b98d209afe85);
$parcel$export(module.exports, "default", () => $8e53fb941ae19e72$export$2e2bcd8739ae039);

var $3TY2E = parcelRequire("3TY2E");

var $eSnSE = parcelRequire("eSnSE");

var $7oY9g = parcelRequire("7oY9g");
const $8e53fb941ae19e72$var$RELAY_CLIENT_ID = 'AGG';
const $8e53fb941ae19e72$var$LOG_NAMESPACE = `relay.${$8e53fb941ae19e72$var$RELAY_CLIENT_ID}.error.graphql`;
const $8e53fb941ae19e72$var$requests = {};
const $8e53fb941ae19e72$var$queries = {};
const $8e53fb941ae19e72$var$resources = {};
const $8e53fb941ae19e72$var$executes = {};
const $8e53fb941ae19e72$var$CLEANUP_TIMEOUT = 300000; // 5 minutes
const $8e53fb941ae19e72$export$1ab8b98d209afe85 = (event)=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData($8e53fb941ae19e72$var$LOG_NAMESPACE, '[relay required field error]', {
        kind: event.kind,
        owner: event.owner,
        fieldPath: event.fieldPath,
        message: event.kind === 'relay_resolver.error' ? event.error?.message : null
    });
};
const $8e53fb941ae19e72$var$getResponseSize = (resp)=>{
    if (resp.data === undefined) return 0;
    try {
        return JSON.stringify(resp.data).length;
    } catch (e) {
        return 0;
    }
};
function $8e53fb941ae19e72$export$2e2bcd8739ae039(event) {
    if ((0, $7oY9g.default)('relay_log')) return;
    switch(event.name){
        // NETWORK
        case 'network.start':
            {
                const networkStart = performance.now();
                const { networkRequestId: networkRequestId } = event;
                const { name: name } = event.params;
                const requestInfo = $8e53fb941ae19e72$var$requests[networkRequestId];
                if (requestInfo == null) {
                    const newRequestInfo = {
                        name: name,
                        flushes: [],
                        start: networkStart,
                        networkStart: networkStart
                    };
                    $8e53fb941ae19e72$var$queries[name] = newRequestInfo;
                    $8e53fb941ae19e72$var$requests[networkRequestId] = newRequestInfo;
                    setTimeout(()=>{
                        delete $8e53fb941ae19e72$var$requests[networkRequestId];
                        delete $8e53fb941ae19e72$var$queries[name];
                    }, $8e53fb941ae19e72$var$CLEANUP_TIMEOUT);
                } else requestInfo.networkStart = networkStart;
                break;
            }
        case 'network.next':
            {
                const requestInfo = $8e53fb941ae19e72$var$requests[event.networkRequestId];
                if (requestInfo != null) {
                    const { response: response } = event;
                    const addFlush = (resp)=>{
                        if (resp.data !== null) {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const res = resp;
                            const flush = {
                                label: res.label != null ? res.label : 'root',
                                time: performance.now(),
                                size: $8e53fb941ae19e72$var$getResponseSize(res)
                            };
                            requestInfo.flushes?.push(flush);
                        }
                    };
                    Array.isArray(response) ? response.forEach(addFlush) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    addFlush(response);
                }
                break;
            }
        case 'network.error':
            {
                const info = $8e53fb941ae19e72$var$requests[event.networkRequestId];
                if (info != null) info.error = event.error;
                break;
            }
        case 'network.info':
            break;
        case 'network.complete':
            {
                const requestInfo = $8e53fb941ae19e72$var$requests[event.networkRequestId];
                const networkComplete = performance.now();
                if (requestInfo != null) {
                    const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                    requestInfo.size = size;
                    requestInfo.networkComplete = networkComplete;
                    requestInfo.flushes = [];
                    (0, $3TY2E.addSpanToAll)('relay', requestInfo.name, [
                        {
                            name: 'network'
                        }
                    ], requestInfo.start, requestInfo.networkComplete, size);
                }
                break;
            }
        case 'network.unsubscribe':
            break;
        // SUSPENSE
        case 'suspense.fragment':
            break;
        case 'suspense.query':
            break;
        // QUERY
        case 'queryresource.fetch':
            {
                const { node: node } = event.operation.root;
                const fetchStart = performance.now();
                // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                if (node.name != null) {
                    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                    const { name: name } = node;
                    const requestInfo = $8e53fb941ae19e72$var$queries[name];
                    if (requestInfo != null) {
                        requestInfo.fetchStart = fetchStart;
                        $8e53fb941ae19e72$var$resources[event.resourceID] = requestInfo;
                    } else {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: fetchStart,
                            fetchStart: fetchStart
                        };
                        $8e53fb941ae19e72$var$queries[name] = newRequestInfo;
                        $8e53fb941ae19e72$var$resources[event.resourceID] = newRequestInfo;
                        setTimeout(()=>{
                            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                            delete $8e53fb941ae19e72$var$queries[node.name];
                        }, $8e53fb941ae19e72$var$CLEANUP_TIMEOUT);
                    }
                    setTimeout(()=>{
                        delete $8e53fb941ae19e72$var$resources[event.resourceID];
                    }, $8e53fb941ae19e72$var$CLEANUP_TIMEOUT);
                }
                break;
            }
        case 'queryresource.retain':
            {
                const requestInfo = $8e53fb941ae19e72$var$resources[event.resourceID];
                if (requestInfo != null && event.profilerContext != null) {
                    requestInfo.end = performance.now();
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const context = event.profilerContext;
                    context?.retainQuery?.(requestInfo);
                }
                break;
            }
        // EXECUTE
        case 'execute.start':
            $8e53fb941ae19e72$var$executes[event.executeId] = {
                name: event.params.name,
                kind: event.params.operationKind,
                start: performance.now(),
                duration: 0
            };
            break;
        case 'execute.next.start':
            $8e53fb941ae19e72$var$executes[event.executeId].start = performance.now();
            break;
        case 'execute.next.end':
            {
                const now = performance.now();
                const duration = now - $8e53fb941ae19e72$var$executes[event.executeId].start;
                $8e53fb941ae19e72$var$executes[event.executeId].end = now;
                $8e53fb941ae19e72$var$executes[event.executeId].duration = duration;
                break;
            }
        case 'execute.async.module':
            break;
        case 'execute.error':
            delete $8e53fb941ae19e72$var$executes[event.executeId];
            break;
        case 'execute.complete':
            {
                const op = $8e53fb941ae19e72$var$executes[event.executeId];
                if (op != null) {
                    op.end = performance.now();
                    delete $8e53fb941ae19e72$var$executes[event.executeId];
                }
                break;
            }
        // STORE
        case 'store.publish':
            break;
        case 'store.snapshot':
            break;
        case 'store.restore':
            break;
        case 'store.gc.start':
            break;
        case 'store.gc.end':
            break;
        case 'store.gc.interrupted':
            break;
        // FLUSH
        case 'store.notify.start':
            break;
        case 'store.notify.complete':
            break;
        case 'store.notify.subscription':
            break;
        // ENTRYPOINT
        case 'entrypoint.root.consume':
            break;
        default:
            break;
    }
}

});

parcelRegister("fFqgB", function(module, exports) {

$parcel$export(module.exports, "getNetwork", () => $011c53ed09976f9f$export$7de4970ebfd8206d);

var $37Ewn = parcelRequire("37Ewn");

var $j0pwn = parcelRequire("j0pwn");

var $208o0 = parcelRequire("208o0");

var $lLNFn = parcelRequire("lLNFn");
const $011c53ed09976f9f$export$7de4970ebfd8206d = ()=>{
    if ((0, $lLNFn.isSSR)()) (0, $37Ewn.Network).create((0, $j0pwn.fetch));
    return (0, $37Ewn.Network).create((0, $j0pwn.fetch), (0, $208o0.subscribe));
};

});
parcelRegister("j0pwn", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $8376cd7c57be1686$export$e7aa7bc5c1b3cfb3);

var $7jTnu = parcelRequire("7jTnu");

var $kuzN3 = parcelRequire("kuzN3");

var $kdR84 = parcelRequire("kdR84");
const $8376cd7c57be1686$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    return (0, $7jTnu.fg)('jfp-magma-support-defer') ? (0, $kuzN3.fetch)(request, variables, cacheConfig) : (0, $kdR84.fetch)(request, variables, cacheConfig);
};

});
parcelRegister("kuzN3", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $259e287b96eb4f75$export$e7aa7bc5c1b3cfb3);

var $jPROM = parcelRequire("jPROM");

var $37Ewn = parcelRequire("37Ewn");

var $7jTnu = parcelRequire("7jTnu");

var $hbF3h = parcelRequire("hbF3h");

var $dSA8H = parcelRequire("dSA8H");

var $g1oKu = parcelRequire("g1oKu");

var $7797X = parcelRequire("7797X");

var $iFeTU = parcelRequire("iFeTU");

var $cvB0A = parcelRequire("cvB0A");

var $S8wWU = parcelRequire("S8wWU");

var $lN9MB = parcelRequire("lN9MB");

var $aOk72 = parcelRequire("aOk72");

var $jOs4m = parcelRequire("jOs4m");

var $fGcgi = parcelRequire("fGcgi");

var $1uIew = parcelRequire("1uIew");

var $4Yjc9 = parcelRequire("4Yjc9");

var $jC6NO = parcelRequire("jC6NO");

var $c2hs9 = parcelRequire("c2hs9");

var $ll6Lf = parcelRequire("ll6Lf");
// @ts-expect-error the global is placed there by bifrost SSR. See src/entry-fs/util/render.tsx
const $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $259e287b96eb4f75$var$moduleID = 'relay-fetch';
const $259e287b96eb4f75$export$497933998e10dba1 = (request, variables, cacheConfig)=>{
    if (!(0, $7jTnu.fg)('remove_heartbeat_service_from_jira_relay_fetch')) {
        const redirecting = (0, $ll6Lf.checkAuthentication)();
        if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return (0, $37Ewn.Observable).from(new Promise(()=>{}));
    }
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $c2hs9.getLoggingAndMetricsHelper)(loggingMetadata);
    function augmentResponse(response) {
        (0, $aOk72.addTraceId)(queryName, (0, $ll6Lf.getTraceIdFromExtensions)(response));
        (0, $S8wWU.putExtensions)(queryName, response.extensions);
    }
    function validateResponse(response) {
        // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
        const errors = response.errors || undefined;
        if (errors != null) {
            const requestId = response?.extensions?.gateway?.request_id;
            if (!(0, $ll6Lf.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
            (0, $g1oKu.captureErrors)(errors, {
                operationName: queryName,
                requestId: requestId
            });
            if ((0, $g1oKu.isUnauthenticated)(errors)) return false;
        }
        return true;
    }
    function enforceNonNullability(response) {
        if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    const earlyScriptPromise = !false && (0, $cvB0A.claimEarlyScriptPromise)((0, $cvB0A.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    return (0, $37Ewn.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$259e287b96eb4f75$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) {
                    sink.next(payload);
                    // write cache query response on SSR
                    if (false && requestID != null) (0, $iFeTU.getQueryResponseCache)().appendWithMetadata(requestID, variables, payload, loggingMetadata);
                }
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            (0, $7jTnu.fg)('switch_relay_fetch_to_post_from_get') ? (0, $4Yjc9.buildGraphqlSmartFetch) : (0, $4Yjc9.buildGraphqlFetch);
            // On client...
            if (!false && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = (0, $iFeTU.getQueryResponseCache)().get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(ssrCache)) {
                    (0, $iFeTU.getQueryResponseCache)().delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $fGcgi.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $fGcgi.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                // We didn't receive everything!
                                const err = new (0, $1uIew.default)(424, `Incomplete handover for relay fetch: ${reason}`);
                                err.name = 'ServerToClientError';
                                loggingAndMetrics.logError(err);
                                sink.error(err, false);
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            const endpoint = (0, $lN9MB.getAggEndpoint)(request, cacheConfig);
            const body = (0, $lN9MB.getRequestBody)(request, variables);
            const fetchOverNetwork = (0, $7jTnu.fg)('switch_relay_fetch_to_post_from_get') ? (0, $4Yjc9.buildGraphqlSmartFetch)({
                url: endpoint,
                options: (0, $ll6Lf.generateOptions)({
                    body: body
                }, endpoint),
                variables: variables,
                request: request
            }) : (0, $4Yjc9.buildGraphqlFetch)(endpoint, (0, $ll6Lf.generateOptions)({
                body: body
            }, endpoint));
            const initialSource = ()=>!false && earlyScriptPromise ? (0, $4Yjc9.withErrorHandling)(earlyScriptPromise) : (0, $4Yjc9.withErrorHandling)(fetchOverNetwork());
            const responses = (0, $4Yjc9.processMultipartPromise)(()=>(0, $dSA8H.retryOnError)(initialSource, {
                    retryFunc: ()=>(0, $4Yjc9.withErrorHandling)(fetchOverNetwork()),
                    retryPredicate: (0, $ll6Lf.shouldRetry),
                    retryAttempts: (0, $ll6Lf.getRetryAttemptsForQuery)(queryName, operationKind),
                    onRetry: loggingAndMetrics.logErrorRetry
                }));
            // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
            // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
            let responseShouldHang = false;
            let firstResponseUsed = false;
            let resolveFirstResponse;
            const firstResponse = new Promise((resolve)=>{
                resolveFirstResponse = resolve;
            });
            responses.subscribe({
                start: ()=>{
                    if (requestID != null) {
                        if (false) {
                            // so that SSR SPA knows it is safe to render
                            const renderAfterThisResponse = $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                            (0, $7797X.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                        } else (0, $7797X.QueryPromisesMap).set(requestID, firstResponse);
                        (0, $7797X.CompletedQueryPromisesMap).set(requestID, completedResponse);
                    }
                },
                next: (response)=>{
                    if (false && $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                        // Send the response payload to a side-channel.
                        // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                        (0, $jOs4m.registerEvent)({
                            id: sinkID,
                            name: 'default',
                            args: [
                                response
                            ]
                        });
                        if ('hasNext' in response && response.hasNext === false) finalise();
                        // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                        return;
                    }
                    if (!firstResponseUsed) {
                        firstResponseUsed = true;
                        // according to spec, we can assume the first response is a GraphQLSingularResponse.
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        const singularResponse = response;
                        augmentResponse(singularResponse);
                        if (!validateResponse(singularResponse)) {
                            //  Short circuit operation and handle the unauthorized errors.
                            (0, $jC6NO.showUnauthenticatedFlag)(queryName);
                            responseShouldHang = true;
                            return;
                        }
                        enforceNonNullability(singularResponse);
                    }
                    handleResponse(response);
                    // signal that the initial response has been received
                    resolveFirstResponse();
                    // After the initial response, further responses are sent through a side-channel.
                    if (false && $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                },
                error: (error)=>{
                    if (!firstResponseUsed) firstResponseUsed = true;
                    loggingAndMetrics.logError(error);
                    sink.error(error);
                },
                complete: ()=>{
                    if (responseShouldHang) return;
                    finalise();
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};
const $259e287b96eb4f75$export$ba44fb13c7d47c03 = (request, variables, cacheConfig)=>{
    if (!(0, $7jTnu.fg)('remove_heartbeat_service_from_jira_relay_fetch')) {
        const redirecting = (0, $ll6Lf.checkAuthentication)();
        if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return (0, $37Ewn.Observable).from(new Promise(()=>{}));
    }
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $c2hs9.getLoggingAndMetricsHelper)(loggingMetadata);
    function augmentResponse(response) {
        (0, $aOk72.addTraceId)(queryName, (0, $ll6Lf.getTraceIdFromExtensions)(response));
        (0, $S8wWU.putExtensions)(queryName, response.extensions);
    }
    function validateResponse(response) {
        // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
        const errors = response.errors || undefined;
        if (errors != null) {
            const requestId = response?.extensions?.gateway?.request_id;
            if (!(0, $ll6Lf.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
            (0, $g1oKu.captureErrors)(errors, {
                operationName: queryName,
                requestId: requestId
            });
            if ((0, $g1oKu.isUnauthenticated)(errors)) return false;
        }
        return true;
    }
    function enforceNonNullability(response) {
        if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    const earlyScriptPromise = !false && (0, $cvB0A.claimEarlyScriptPromise)((0, $cvB0A.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    return (0, $37Ewn.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$259e287b96eb4f75$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            (0, $7jTnu.fg)('switch_relay_fetch_to_post_from_get') ? (0, $4Yjc9.buildGraphqlSmartFetch) : (0, $4Yjc9.buildGraphqlFetch);
            // handles getting multipart response
            const getData = ()=>{
                const endpoint = (0, $lN9MB.getAggEndpoint)(request, cacheConfig);
                const body = (0, $lN9MB.getRequestBody)(request, variables);
                const fetchOverNetwork = (0, $7jTnu.fg)('switch_relay_fetch_to_post_from_get') ? (0, $4Yjc9.buildGraphqlSmartFetch)({
                    url: endpoint,
                    options: (0, $ll6Lf.generateOptions)({
                        body: body
                    }, endpoint),
                    variables: variables,
                    request: request
                }) : (0, $4Yjc9.buildGraphqlFetch)(endpoint, (0, $ll6Lf.generateOptions)({
                    body: body
                }, endpoint));
                const initialSource = ()=>!false && earlyScriptPromise ? (0, $4Yjc9.withErrorHandling)(earlyScriptPromise) : (0, $4Yjc9.withErrorHandling)(fetchOverNetwork());
                const responses = (0, $4Yjc9.processMultipartPromise)(()=>(0, $dSA8H.retryOnError)(initialSource, {
                        retryFunc: ()=>(0, $4Yjc9.withErrorHandling)(fetchOverNetwork()),
                        retryPredicate: (0, $ll6Lf.shouldRetry),
                        retryAttempts: (0, $ll6Lf.getRetryAttemptsForQuery)(queryName, operationKind),
                        onRetry: loggingAndMetrics.logErrorRetry
                    }));
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (false) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, $7797X.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, $7797X.QueryPromisesMap).set(requestID, firstResponse);
                            (0, $7797X.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: (response)=>{
                        if (false && $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, $jOs4m.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if (!validateResponse(singularResponse)) {
                                //  Short circuit operation and handle the unauthorized errors.
                                (0, $jC6NO.showUnauthenticatedFlag)(queryName);
                                responseShouldHang = true;
                                return;
                            }
                            enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if (false && requestID != null) (0, $iFeTU.getQueryResponseCache)().appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if (false && $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        loggingAndMetrics.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!false && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = (0, $iFeTU.getQueryResponseCache)().get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(ssrCache)) {
                    (0, $iFeTU.getQueryResponseCache)().delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $fGcgi.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $fGcgi.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                // We didn't receive everything!
                                const err = new (0, $1uIew.default)(424, `Incomplete handover for relay fetch: ${reason}`);
                                err.name = 'ServerToClientError';
                                loggingAndMetrics.logError(err);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};
const $259e287b96eb4f75$export$e7aa7bc5c1b3cfb3 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('relay-defer-retry-support'), $259e287b96eb4f75$export$ba44fb13c7d47c03, $259e287b96eb4f75$export$497933998e10dba1);

});
parcelRegister("dSA8H", function(module, exports) {

$parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", () => $6a9ace25950bdc28$export$81189edc9b923717);
$parcel$export(module.exports, "retryOnError", () => $6a9ace25950bdc28$export$f859c88bfac2cf2c);
const $6a9ace25950bdc28$export$81189edc9b923717 = 1;
const $6a9ace25950bdc28$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $6a9ace25950bdc28$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $6a9ace25950bdc28$export$81189edc9b923717 ? $6a9ace25950bdc28$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};

});

parcelRegister("g1oKu", function(module, exports) {

$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $9437769c7fa7dcb6$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $9437769c7fa7dcb6$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $9437769c7fa7dcb6$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isUnauthenticated", () => $9437769c7fa7dcb6$export$1724ecfee73c4768);
/**
 * Utility methods to capture GraphQl errors and expose them to the frontend for reporting.
 * ```
 * Sample usage:
 * const id = startErrorCapture();
 * ...
 * const errors = stopErrorCapture(id);
 * ```
 */ 
var $aXKmr = parcelRequire("aXKmr");
const $9437769c7fa7dcb6$var$errorCollector = new Map();
const $9437769c7fa7dcb6$export$da396ad2a542b095 = 120000; // 2min
const $9437769c7fa7dcb6$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $9437769c7fa7dcb6$var$errorCollector.delete(key);
    }, $9437769c7fa7dcb6$export$da396ad2a542b095);
};
const $9437769c7fa7dcb6$export$c211170518c6d0f6 = (key = (0, $aXKmr.v4)())=>{
    $9437769c7fa7dcb6$var$errorCollector.set(key, []);
    $9437769c7fa7dcb6$var$scheduleCleanup(key);
    return key;
};
const $9437769c7fa7dcb6$export$e0491a0d974dadfa = (key)=>{
    const errors = $9437769c7fa7dcb6$var$errorCollector.get(key);
    $9437769c7fa7dcb6$var$errorCollector.delete(key);
    return errors || [];
};
const $9437769c7fa7dcb6$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $9437769c7fa7dcb6$var$errorCollector.forEach((value, key)=>{
        $9437769c7fa7dcb6$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $9437769c7fa7dcb6$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};

});

parcelRegister("7797X", function(module, exports) {

$parcel$export(module.exports, "QueryPromisesMap", () => $bf318a7d5922e713$export$607b80f5bc6e396d);
$parcel$export(module.exports, "CompletedQueryPromisesMap", () => $bf318a7d5922e713$export$cdadce6ed6361a2c);
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $bf318a7d5922e713$export$607b80f5bc6e396d = new Map();
const $bf318a7d5922e713$export$cdadce6ed6361a2c = new Map();

});

parcelRegister("iFeTU", function(module, exports) {

$parcel$export(module.exports, "getQueryResponseCache", () => $4724696bda51657e$export$3233e692a93c0cfd);

var $1rzja = parcelRequire("1rzja");

var $9Dhvc = parcelRequire("9Dhvc");

var $LFmXM = parcelRequire("LFmXM");

var $37Ewn = parcelRequire("37Ewn");

var $eSnSE = parcelRequire("eSnSE");

var $1uIew = parcelRequire("1uIew");

var $dJ436 = parcelRequire("dJ436");
function $4724696bda51657e$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $37Ewn.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $4724696bda51657e$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
const $4724696bda51657e$export$da2711d74cd28aed = [
    'fetchModulesV2Query'
];
class $4724696bda51657e$export$be21c283b097d175 extends (0, $37Ewn.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        const cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!false) setTimeout(()=>{
            this.logUnusedPayloadErrors();
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    logUnusedPayloadErrors() {
        const loggedQueries = new Set();
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'. | TS7006 - Parameter 'response' implicitly has an 'any' type. | TS7006 - Parameter 'key' implicitly has an 'any' type.
        this._responses.forEach((response, key)=>{
            const queryID = $4724696bda51657e$export$1e65e863cf3a0f21(key);
            const metadata = this.requestMetadata.get(queryID);
            const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                queryName: 'unknown',
                operationKind: 'unknown'
            };
            if (!loggedQueries.has(queryName) && !$4724696bda51657e$export$da2711d74cd28aed.includes(queryName)) {
                loggedQueries.add(queryName);
                const error = new (0, $dJ436.UnusedRelayResponseError)(queryID);
                const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, $1uIew.default) ? 'network' : 'unknown';
                // Log any errors even in SSR
                (0, $eSnSE.default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                    message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($1rzja)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
                        'name'
                    ], null)
                });
            }
        });
    }
    /**
	 * @deprecated only sets a single response; does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/jira-s2c-server-dispatcher/src/index.tsx"}.
	 */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Stores a GraphQLRepsonse along with metadata about the call.
	 * If called multiple times (such as when incremental payloads are received),
	 * will update the stored response to be an array of GraphQLSingularResponse objects,
	 * which Relay is happy to handle.
	 * @deprecated works, but does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/jira-s2c-server-dispatcher/src/index.tsx"}.
	 */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $4724696bda51657e$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
const $4724696bda51657e$export$3233e692a93c0cfd = (0, $LFmXM.default)(()=>new $4724696bda51657e$export$be21c283b097d175({
        cacheName: 'relay-cache/v2/AGG',
        size: Infinity,
        ttl: Infinity
    }));
const $4724696bda51657e$export$94e535e06b7ade61 = ()=>$4724696bda51657e$export$3233e692a93c0cfd().serialize();

});
parcelRegister("dJ436", function(module, exports) {

$parcel$export(module.exports, "UnusedRelayResponseError", () => $94c71fb7abd30376$export$8431e42d062de453);
class $94c71fb7abd30376$export$8431e42d062de453 extends Error {
    constructor(queryID){
        super(`Relay Query ${queryID} was made during SSR but never used in the browser`), this.name = 'UnusedRelayResponseError';
    }
}

});


parcelRegister("cvB0A", function(module, exports) {

$parcel$export(module.exports, "getEarlyScriptPromiseKey", () => $87a950ddd1dc6c27$export$1102c06c7da91223);
$parcel$export(module.exports, "claimEarlyScriptPromise", () => $87a950ddd1dc6c27$export$828ac0325bce4536);
$parcel$export(module.exports, "putEarlyScriptPromise", () => $87a950ddd1dc6c27$export$e1336d32be02faf4);
const $87a950ddd1dc6c27$export$b5fbc1430cbfd6e1 = (value)=>value;
const $87a950ddd1dc6c27$export$6d670d323806bb37 = new Map();
const $87a950ddd1dc6c27$export$1102c06c7da91223 = (params, variables)=>{
    if (params.name === 'mainIssueAggQuery') return `${params.name}|${params.id}|${variables?.cloudId}|${variables?.issueKey}`;
    const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
    const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
    return `${params.name}|${String(queryId)}|${serializedVariables}`;
};
const $87a950ddd1dc6c27$export$828ac0325bce4536 = (key)=>{
    const result = $87a950ddd1dc6c27$export$6d670d323806bb37.get(key);
    if (result != null) $87a950ddd1dc6c27$export$6d670d323806bb37.delete(key);
    return result;
};
const $87a950ddd1dc6c27$export$e1336d32be02faf4 = (key, promise)=>{
    if (!$87a950ddd1dc6c27$export$6d670d323806bb37.has(key)) $87a950ddd1dc6c27$export$6d670d323806bb37.set(key, promise);
};

});

parcelRegister("jOs4m", function(module, exports) {

$parcel$export(module.exports, "registerEvent", () => $5f3b0214908d5373$export$bd50bc4cd3c601ee);
const $5f3b0214908d5373$var$events = [];
const $5f3b0214908d5373$export$bd50bc4cd3c601ee = (event)=>{
    $5f3b0214908d5373$var$events.push(event);
};
/**
 * Take all events registered so far, return them, and clear the list.
 */ const $5f3b0214908d5373$export$3c7145db84d4587c = ()=>{
    return $5f3b0214908d5373$var$events.splice(0, $5f3b0214908d5373$var$events.length);
};

});

parcelRegister("fGcgi", function(module, exports) {

$parcel$export(module.exports, "getClientDispatcher", () => $9695bc99f48d9222$export$5bb012cf9b3a5452);


var $f3qnT = parcelRequire("f3qnT");
let $9695bc99f48d9222$var$dispatcher;
const $9695bc99f48d9222$export$5bb012cf9b3a5452 = ()=>{
    if (!$9695bc99f48d9222$var$dispatcher) {
        $9695bc99f48d9222$var$dispatcher = new (0, $f3qnT.ClientDispatcher)();
        // Handle the server hangup scenarios
        $9695bc99f48d9222$var$dispatcher.register((0, $a7124bed15c191d7$export$eb5d9c90d65c7fea), $9695bc99f48d9222$var$dispatcher._abort.bind($9695bc99f48d9222$var$dispatcher));
    }
    return $9695bc99f48d9222$var$dispatcher;
};

});
const $a7124bed15c191d7$export$eb5d9c90d65c7fea = 'ClientDispatcher';

parcelRegister("f3qnT", function(module, exports) {

$parcel$export(module.exports, "ClientDispatcher", () => $844caee9d5549f15$export$3f5ba18eb97af725);
class $844caee9d5549f15$export$3f5ba18eb97af725 {
    #handlers;
    #queuedPayloads;
    #abortReason;
    #abortHandlers;
    constructor(){
        this.#handlers = new Map();
        this.#abortHandlers = new Map();
        this.#queuedPayloads = new Map();
    }
    /**
	 * Ingest a payload from the server.
	 * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
	 * @param payload - The payload to ingest.
	 */ ingest(payload) {
        const handler = this.#handlers.get(payload.id);
        if (handler) this.#exec(handler, payload);
        else {
            const queue = this.#queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.#queuedPayloads.set(payload.id, queue);
        }
    }
    /**
	 * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when the event is ingested.
	 */ register(id, callback) {
        this.#handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.#queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.#exec(callback, payload));
            this.#queuedPayloads.delete(id);
        }
    }
    /**
	 * Unregister a callback for a given event.
	 * @param id
	 */ unregister(id) {
        this.#handlers.delete(id);
        this.#queuedPayloads.delete(id);
    }
    /**
	 * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when abort detected.
	 */ onAbort(id, callback) {
        if (this.#abortReason) this.#exec(callback, {
            args: [
                this.#abortReason
            ]
        });
        else this.#abortHandlers.set(id, callback);
    }
    /**
	 * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
	 * @private
	 * @param props
	 */ _abort(props) {
        this.#abortReason = props;
        this.#abortHandlers.forEach((handler)=>{
            this.#exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.#abortHandlers = new Map();
    }
    /**
	 * Execute a callback with the given payload.
	 * @param callback - The callback to execute.
	 * @param payload - The payload to execute the callback with.
	 */ #exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
}

});


parcelRegister("4Yjc9", function(module, exports) {

$parcel$export(module.exports, "processMultipartPromise", () => $c10481344656009f$export$f76505a7f2969e4e);
$parcel$export(module.exports, "withErrorHandling", () => $c10481344656009f$export$c874c20f7c9f97c);
$parcel$export(module.exports, "buildGraphqlFetch", () => $c10481344656009f$export$744180da2870332e);
$parcel$export(module.exports, "buildGraphqlSmartFetch", () => $c10481344656009f$export$33c9c992c7855d86);
/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */ 
var $1O6Yz = parcelRequire("1O6Yz");

var $37Ewn = parcelRequire("37Ewn");

var $i4YfB = parcelRequire("i4YfB");

var $3WOLx = parcelRequire("3WOLx");

var $1oMOM = parcelRequire("1oMOM");


var $jGzN3 = parcelRequire("jGzN3");

var $7jTnu = parcelRequire("7jTnu");

var $hbF3h = parcelRequire("hbF3h");
function $c10481344656009f$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
/**
 * Processes a chunk of multipart data and emits parsed JSON payloads to the observer
 * Uses a more memory-efficient approach by processing chunks directly
 */ function $c10481344656009f$var$processChunkOld(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [, body] = part.split(/\r?\n\r?\n/);
            if (body) try {
                const jsonData = JSON.parse(body.trim());
                observer.next(jsonData);
            } catch (error) {
                observer.error(new Error(`Invalid JSON: ${error instanceof Error ? error.message : String(error)}`));
            }
        }
    }
    // Return the last part which might be incomplete
    return parts[parts.length - 1];
}
function $c10481344656009f$var$processChunkNew(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [part1, part2] = part.split(/\r?\n\r?\n/);
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            const body = part2 ?? part1;
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch (error) {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}
const $c10481344656009f$export$701544522b0c6c99 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('relay-defer-retry-support'), $c10481344656009f$var$processChunkNew, $c10481344656009f$var$processChunkOld);
async function $c10481344656009f$export$efb69f1fe7577739(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = $c10481344656009f$export$701544522b0c6c99(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) $c10481344656009f$export$701544522b0c6c99(incompleteChunk, boundaryString, observer);
    observer.complete();
}
function $c10481344656009f$var$handleMultipartResponse(response, observer) {
    const contentType = response.headers.get('content-type');
    const boundary = $c10481344656009f$var$getBoundary(contentType || '');
    if (!boundary) {
        observer.error(new Error('Invalid multipart boundary'));
        return;
    }
    const decoder = new TextDecoder('utf-8');
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        async function* streamReader() {
            // @ts-expect-error a Response object in Node is streamable
            for await (const chunk of response.body){
                const newText = decoder.decode(chunk, {
                    stream: true
                });
                yield newText;
            }
        }
        $c10481344656009f$export$efb69f1fe7577739(streamReader(), boundary, observer).catch((error)=>observer.error(error));
    } catch (e) {
        observer.error(new Error('Failed to read from response body', {
            cause: e
        }));
    }
}
function $c10481344656009f$var$handleJsonResponse(response, observer) {
    response.json().then((data)=>observer.next(data)).catch((error)=>observer.error(error)).finally(()=>observer.complete());
}
function $c10481344656009f$var$handleTextResponse(response, observer) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((error)=>observer.error(error));
}
function $c10481344656009f$export$f76505a7f2969e4e(source) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $37Ewn.Observable).create((observer)=>{
        result.then((response)=>{
            if (response.status === (0, $44ccf6b895337c89$export$3288b14b6745c572)) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $c10481344656009f$var$handleJsonResponse(response, observer);
            else if (contentType.includes('text/plain')) $c10481344656009f$var$handleTextResponse(response, observer);
            else if (contentType.includes('multipart/mixed')) $c10481344656009f$var$handleMultipartResponse(response, observer);
            else observer.error(new Error(`Unsupported content type: ${contentType}`));
        }).catch((error)=>observer.error(error));
    });
}
function $c10481344656009f$export$c874c20f7c9f97c(source) {
    return source.then((0, $jGzN3.handleErrors)).catch((0, $jGzN3.handleNetworkErrors));
}
const $c10481344656009f$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
function $c10481344656009f$export$744180da2870332e(url, options) {
    const acceptableFormats = [
        'application/graphql-response+json',
        'application/json',
        'multipart/mixed; deferSpec=20220824'
    ];
    const postOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: (0, $7jTnu.fg)('relay-defer-format-header-fix') ? $c10481344656009f$var$relayDeferAcceptableFormats.join(', ') : acceptableFormats.join(', ')
        }
    };
    const composedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))((0, $1oMOM.getDefaultOptions)(url), options, postOptions);
    const fetchUrl = (0, $i4YfB.getReroutableURL)(url);
    const fetchHeaders = (0, $3WOLx.applyObservabilityHeaders)(url, composedOptions);
    return ()=>fetch(fetchUrl, fetchHeaders);
}
const $c10481344656009f$var$MAX_QUERY_LENGTH = 8192; // Maximum allowed query length
const $c10481344656009f$var$MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
// Calculate the size of the headers
function $c10481344656009f$export$dd754c3ef60c6999(headers) {
    let totalBytes = 0;
    const textEncoder = new TextEncoder();
    // Iterate over each header entry (name and value)
    for (const [name, value] of Object.entries(headers)){
        const headerSize = textEncoder.encode(`${name}: ${value}\r\n`).length; // Include CRLF
        totalBytes += headerSize;
    }
    return totalBytes;
}
function $c10481344656009f$export$5ad31d96a9271d42({ url: url, variables: variables, request: request, headers: headers }) {
    if (request.operationKind !== 'query') return false;
    const serializedVariables = JSON.stringify(variables);
    const queryLength = url.length + serializedVariables.length;
    const headersSize = $c10481344656009f$export$dd754c3ef60c6999(headers || {});
    return queryLength <= $c10481344656009f$var$MAX_QUERY_LENGTH && headersSize <= $c10481344656009f$var$MAX_HEADERS_SIZE;
}
function $c10481344656009f$export$33c9c992c7855d86({ url: url, options: options, variables: variables, request: request }) {
    const acceptableFormats = [
        'application/graphql-response+json',
        'application/json',
        'multipart/mixed; deferSpec=20220824'
    ];
    const requestOptions = {
        headers: {
            Accept: (0, $7jTnu.fg)('relay-defer-format-header-fix') ? $c10481344656009f$var$relayDeferAcceptableFormats.join(', ') : acceptableFormats.join(', '),
            'Content-Type': 'application/json'
        }
    };
    const composedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))((0, $1oMOM.getDefaultOptions)(url), options, requestOptions);
    let fetchUrl = (0, $i4YfB.getReroutableURL)(url);
    const fetchOptions = (0, $3WOLx.applyObservabilityHeaders)(url, composedOptions);
    if ($c10481344656009f$export$5ad31d96a9271d42({
        url: fetchUrl,
        variables: variables,
        request: request,
        headers: fetchOptions.headers
    })) {
        fetchOptions.method = 'GET';
        const params = new URLSearchParams();
        params.append('variables', JSON.stringify(variables));
        fetchUrl += `${fetchUrl.includes('?') ? '&' : '?'}${params.toString()}`;
        delete fetchOptions.body; // Not needed for GET
        if (fetchOptions.headers && 'Content-Type' in fetchOptions.headers) delete fetchOptions.headers['Content-Type']; // Not needed for GET
    } else fetchOptions.method = 'POST';
    return ()=>fetch(fetchUrl, fetchOptions);
}
function $c10481344656009f$export$2586da7b5f4b5763(url, options) {
    const fetchFn = $c10481344656009f$export$744180da2870332e(url, options);
    return $c10481344656009f$export$f76505a7f2969e4e(()=>$c10481344656009f$export$c874c20f7c9f97c(fetchFn()));
}
function $c10481344656009f$export$53a48697d787fffd(params) {
    const fetchFn = $c10481344656009f$export$33c9c992c7855d86(params);
    return $c10481344656009f$export$f76505a7f2969e4e(()=>$c10481344656009f$export$c874c20f7c9f97c(fetchFn()));
}

});
parcelRegister("i4YfB", function(module, exports) {

$parcel$export(module.exports, "getReroutableURL", () => $fe763424b1b1bc45$export$23769875e8eebaf6);

var $jknD8 = parcelRequire("jknD8");
// FIXME: Pillar to define entire URL, not just hostname.
const $fe763424b1b1bc45$var$LOCAL_URL = new URL(`${'http'}://${(0, $jknD8.getDevHostname)()}:${(0, $jknD8.getProxyServerPort)()}`);
function $fe763424b1b1bc45$export$23769875e8eebaf6(pathOrURL) {
    // For local development environment only, otherwise removed during the bundling process
    if (globalThis.localDevContext?.PILLAR_LOCAL_DEVELOPMENT ?? false) try {
        const u = new URL(pathOrURL, $fe763424b1b1bc45$var$LOCAL_URL.href);
        u.host = $fe763424b1b1bc45$var$LOCAL_URL.host;
        u.protocol = $fe763424b1b1bc45$var$LOCAL_URL.protocol;
        return u.href;
    } catch (e) {
        // When the URL constructor has `base` set, and `pathOrUrl` is always a string,
        // no string can trigger this catch block.
        // Just in case, log the error to help with debugging.
        // eslint-disable-next-line no-console
        console.error('Failed to parse URL: ', pathOrURL, e);
    }
    return pathOrURL;
}

});
parcelRegister("jknD8", function(module, exports) {

$parcel$export(module.exports, "getDevHostname", () => $5afe5c3b08b92ffc$export$a6aba27c4797e08b);
$parcel$export(module.exports, "getProxyServerPort", () => $5afe5c3b08b92ffc$export$6819122a922c6aaf);
/**
 * Get the hostname for the Pillar development server.
 *
 * In the always-on RDE, it will have a proper DNS name. In local development, it
 * will default to `localhost`.
 *
 * @returns The hostname for the development server.
 */ const $5afe5c3b08b92ffc$export$a6aba27c4797e08b = ()=>{
    const envDns = globalThis.localDevContext?.RDE_DNS ?? undefined;
    return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
};
function $5afe5c3b08b92ffc$export$6819122a922c6aaf() {
    const serverPort = globalThis.localDevContext?.__PILLAR_PROXY_SERVER_PORT ?? undefined;
    return serverPort ? parseInt(serverPort, 10) : 9000;
}

});


parcelRegister("jGzN3", function(module, exports) {

$parcel$export(module.exports, "transformValidationErrorFromServer", () => $3bd0eafe49859925$export$8e9baed7697e4959);
$parcel$export(module.exports, "handleNetworkErrors", () => $3bd0eafe49859925$export$b47ad9bdf9122b88);
$parcel$export(module.exports, "handleErrors", () => $3bd0eafe49859925$export$1e36de371b2e3d5a);
$parcel$export(module.exports, "applyErrorHandling", () => $3bd0eafe49859925$export$e174dc943a170ff);
$parcel$export(module.exports, "performGetRequest", () => $3bd0eafe49859925$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $3bd0eafe49859925$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $3bd0eafe49859925$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $3bd0eafe49859925$export$8ef51cba9d28f819);
$parcel$export(module.exports, "performPatchRequest", () => $3bd0eafe49859925$export$52be6ab13d7e758d);
$parcel$export(module.exports, "performGetRequestWithRetry", () => $3bd0eafe49859925$export$659b5ee69e6eb976);
$parcel$export(module.exports, "performPutRequestWithRetry", () => $3bd0eafe49859925$export$d7b48b2904a5d812);
$parcel$export(module.exports, "performPostRequestWithRetry", () => $3bd0eafe49859925$export$a5717cbee13f28b7);


var $7oY9g = parcelRequire("7oY9g");

var $1oMOM = parcelRequire("1oMOM");

var $1uIew = parcelRequire("1uIew");

var $i4YfB = parcelRequire("i4YfB");

var $3WOLx = parcelRequire("3WOLx");

var $dSA8H = parcelRequire("dSA8H");

var $7AheX = parcelRequire("7AheX");
/**
 * Transform object with field errors from JIRA to an array of FieldValidationErrors
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3bd0eafe49859925$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
            field: field,
            error: fieldErrors[field]
        }));
const $3bd0eafe49859925$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
    const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
    const fieldErrorsJson = json.errors ?? json.fieldErrors;
    const fieldErrors = fieldErrorsJson ? $3bd0eafe49859925$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
    return new (0, $1uIew.ValidationError)(message, fieldErrors, statusCode, traceId, json);
};
const $3bd0eafe49859925$var$putOptions = {
    ...(0, $1oMOM.defaultOptions),
    method: 'PUT'
};
const $3bd0eafe49859925$var$postOptions = {
    ...(0, $1oMOM.defaultOptions),
    method: 'POST'
};
const $3bd0eafe49859925$var$deleteOptions = {
    ...(0, $1oMOM.defaultOptions),
    method: 'DELETE'
};
const $3bd0eafe49859925$var$patchOptions = {
    ...(0, $1oMOM.defaultOptions),
    method: 'PATCH'
};
const $3bd0eafe49859925$export$b47ad9bdf9122b88 = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
const $3bd0eafe49859925$export$1e36de371b2e3d5a = (response)=>{
    const traceId = (0, $7AheX.getTraceId)(response);
    // CONTENT_TOO_LARGE errorMessage is used for Hard Limits and, we don't want to override the error message
    if ((0, $44ccf6b895337c89$export$9de493bcd9b1d977) === response.status || (0, $44ccf6b895337c89$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
        throw $3bd0eafe49859925$export$8e9baed7697e4959(errorContent, response.status, traceId);
    });
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) throw new (0, $1uIew.default)(response.status, `Error server response: ${response.status}`, traceId, response);
        else throw new (0, $1uIew.default)(response.status, `Error server response: ${response.status}`, undefined, response);
    }
    return response;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3bd0eafe49859925$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $44ccf6b895337c89$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $3bd0eafe49859925$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($3bd0eafe49859925$export$1e36de371b2e3d5a).then($3bd0eafe49859925$var$processResponseFromServer).catch($3bd0eafe49859925$export$b47ad9bdf9122b88);
const $3bd0eafe49859925$export$22411cbfb09a5c5c = (url, options)=>{
    const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
    const executeRequest = ()=>$3bd0eafe49859925$export$e174dc943a170ff(fetch((0, $i4YfB.getReroutableURL)(url), (0, $3WOLx.applyObservabilityHeaders)(url, requestOptions)));
    if ((0, $7oY9g.default)('platform_fetch_retries')) return executeRequest();
    return (0, $dSA8H.retryOnError)(executeRequest, {
        retryFunc: executeRequest,
        retryPredicate: retryPredicate,
        retryAttempts: retryAttempts,
        onRetry: onRetry
    });
};
const $3bd0eafe49859925$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $3WOLx.applyObservabilityHeaders)(url, {
        ...(0, $1oMOM.defaultOptions),
        ...options
    })).then($3bd0eafe49859925$export$1e36de371b2e3d5a).then($3bd0eafe49859925$var$processResponseFromServer).catch($3bd0eafe49859925$export$b47ad9bdf9122b88);
const $3bd0eafe49859925$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $3WOLx.applyObservabilityHeaders)(url, {
        ...$3bd0eafe49859925$var$putOptions,
        ...options
    })).then($3bd0eafe49859925$export$1e36de371b2e3d5a).then($3bd0eafe49859925$var$processResponseFromServer).catch($3bd0eafe49859925$export$b47ad9bdf9122b88);
const $3bd0eafe49859925$export$692a4d9808143175 = (url, options = {})=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $3WOLx.applyObservabilityHeaders)(url, {
        ...$3bd0eafe49859925$var$postOptions,
        ...options
    })).then($3bd0eafe49859925$export$1e36de371b2e3d5a).then($3bd0eafe49859925$var$processResponseFromServer).catch($3bd0eafe49859925$export$b47ad9bdf9122b88);
const $3bd0eafe49859925$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $3WOLx.applyObservabilityHeaders)(url, {
        ...$3bd0eafe49859925$var$deleteOptions,
        ...options
    })).then($3bd0eafe49859925$export$1e36de371b2e3d5a).then($3bd0eafe49859925$var$processResponseFromServer).catch($3bd0eafe49859925$export$b47ad9bdf9122b88);
const $3bd0eafe49859925$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $3WOLx.applyObservabilityHeaders)(url, {
        ...$3bd0eafe49859925$var$patchOptions,
        ...options
    })).then($3bd0eafe49859925$export$1e36de371b2e3d5a).then($3bd0eafe49859925$var$processResponseFromServer).catch($3bd0eafe49859925$export$b47ad9bdf9122b88);
const $3bd0eafe49859925$export$659b5ee69e6eb976 = (url, options)=>$3bd0eafe49859925$export$22411cbfb09a5c5c(url, {
        ...(0, $1oMOM.defaultOptions),
        ...options
    });
const $3bd0eafe49859925$export$d7b48b2904a5d812 = (url, options)=>$3bd0eafe49859925$export$22411cbfb09a5c5c(url, {
        ...$3bd0eafe49859925$var$putOptions,
        ...options
    });
const $3bd0eafe49859925$export$a5717cbee13f28b7 = (url, options)=>$3bd0eafe49859925$export$22411cbfb09a5c5c(url, {
        ...$3bd0eafe49859925$var$postOptions,
        ...options
    });
const $3bd0eafe49859925$export$6d01bf1146815b9b = (url, options)=>$3bd0eafe49859925$export$22411cbfb09a5c5c(url, {
        ...$3bd0eafe49859925$var$deleteOptions,
        ...options
    });
const $3bd0eafe49859925$export$560989ee94ad2a20 = (url, options)=>$3bd0eafe49859925$export$22411cbfb09a5c5c(url, {
        ...$3bd0eafe49859925$var$patchOptions,
        ...options
    }); /* eslint-enable @typescript-eslint/no-unnecessary-type-constraint */ 

});
parcelRegister("7AheX", function(module, exports) {

$parcel$export(module.exports, "getTraceId", () => $42a7ebcad5498881$export$e88cb5bfb57ce9c4);
$parcel$export(module.exports, "getTraceIdJq", () => $42a7ebcad5498881$export$b569b31eebca952d);

var $ee0TI = parcelRequire("ee0TI");
const $42a7ebcad5498881$export$e88cb5bfb57ce9c4 = (response)=>{
    const traceIdHeader = (0, $ee0TI.KNOWN_TRACE_ID_HEADERS).find((header)=>response.headers.has(header));
    return traceIdHeader === undefined ? undefined : response.headers.get(traceIdHeader) ?? undefined;
};
const $42a7ebcad5498881$export$b569b31eebca952d = (jqxhr)=>{
    if (!jqxhr || !jqxhr.getResponseHeader) // prefer a silent fail, so we don't accidentally swallow the original error being built
    return undefined;
    const traceIdHeader = (0, $ee0TI.KNOWN_TRACE_ID_HEADERS).find((header)=>jqxhr.getResponseHeader(header) != null);
    return traceIdHeader === undefined ? undefined : jqxhr.getResponseHeader(traceIdHeader);
};

});
parcelRegister("ee0TI", function(module, exports) {

$parcel$export(module.exports, "TRACE_ID_HEADER", () => $f102330ef4989ccd$export$4b69438fb7c7b9b2);
$parcel$export(module.exports, "KNOWN_TRACE_ID_HEADERS", () => $f102330ef4989ccd$export$830a89e935012abe);
const $f102330ef4989ccd$export$4b69438fb7c7b9b2 = 'atl-traceid';
const $f102330ef4989ccd$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $f102330ef4989ccd$export$830a89e935012abe = [
    $f102330ef4989ccd$export$4b69438fb7c7b9b2,
    $f102330ef4989ccd$var$TRACE_ID_HEADER_MICROS
];

});




parcelRegister("jC6NO", function(module, exports) {

$parcel$export(module.exports, "showUnauthenticatedFlag", () => $82aff5bc2beb8971$export$758fcc357484571e);

var $bILK0 = parcelRequire("bILK0");

var $2Mqjh = parcelRequire("2Mqjh");

var $eeSEl = parcelRequire("eeSEl");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $82aff5bc2beb8971$var$reloadPage = ()=>window.location.reload();
const $82aff5bc2beb8971$var$sendAnalyticEvent = (operationName)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'showed',
            actionSubject: 'unauthorizedFlag',
            attributes: {
                operation: operationName
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $82aff5bc2beb8971$var$sendLoginClickEvent = (operationName)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'loginButton',
            attributes: {
                operation: operationName,
                source: globalThis.window?.location?.pathname ?? '',
                referrer: globalThis.document?.referrer ?? '',
                timestamp: new Date().toISOString(),
                userAgent: globalThis.navigator?.userAgent ?? ''
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $82aff5bc2beb8971$export$758fcc357484571e = (operationName)=>{
    (0, $bILK0.showFlag)({
        type: 'error',
        title: (0, $eeSEl.default).title,
        description: (0, $eeSEl.default).description,
        messageId: 'relay-fetch.services.error-flags.show-flag.error.show-unauthenticated-flag',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $eeSEl.default).login,
                onClick: ()=>{
                    $82aff5bc2beb8971$var$sendLoginClickEvent(operationName);
                    $82aff5bc2beb8971$var$reloadPage();
                }
            }
        ]
    });
    $82aff5bc2beb8971$var$sendAnalyticEvent(operationName);
};

});
parcelRegister("bILK0", function(module, exports) {

$parcel$export(module.exports, "showFlag", () => $403f7f6a1013a11d$export$e12b2cc6b75b006b);
$parcel$export(module.exports, "dismissFlag", () => $403f7f6a1013a11d$export$900a08a292ad23cd);
$parcel$export(module.exports, "flagService", () => $403f7f6a1013a11d$export$dbb055af53fd81a0);
$parcel$export(module.exports, "useFlagsService", () => $403f7f6a1013a11d$export$eee61a1aafe3884);
$parcel$export(module.exports, "useFlagService", () => $403f7f6a1013a11d$export$dc4f8132c3090b32);
$parcel$export(module.exports, "isDismissFlag", () => $403f7f6a1013a11d$export$14b1864d9cf0809f);
$parcel$export(module.exports, "isFlagComponent", () => $403f7f6a1013a11d$export$d84ce5adcee46025);
$parcel$export(module.exports, "isBatchAction", () => $403f7f6a1013a11d$export$c126d8b307b8ab86);

var $90d5q = parcelRequire("90d5q");

var $9YEIT = parcelRequire("9YEIT");

var $PC9Lc = parcelRequire("PC9Lc");

var $hrodw = parcelRequire("hrodw");
const $403f7f6a1013a11d$export$e12b2cc6b75b006b = (0, $9YEIT.default)((0, $PC9Lc.store).dispatch);
const $403f7f6a1013a11d$export$900a08a292ad23cd = (0, $90d5q.default)((0, $PC9Lc.store).dispatch);
const $403f7f6a1013a11d$var$dismissFlagById = (id)=>{
    $403f7f6a1013a11d$export$900a08a292ad23cd((0, $90d5q.dismissFlag)(id));
};
const $403f7f6a1013a11d$var$hasFlag = (id)=>Boolean((0, $PC9Lc.store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
const $403f7f6a1013a11d$export$dbb055af53fd81a0 = {
    showFlag: $403f7f6a1013a11d$export$e12b2cc6b75b006b,
    dismissFlag: $403f7f6a1013a11d$export$900a08a292ad23cd
};
const $403f7f6a1013a11d$export$eee61a1aafe3884 = ()=>({
        showFlag: $403f7f6a1013a11d$export$e12b2cc6b75b006b,
        dismissFlag: $403f7f6a1013a11d$var$dismissFlagById,
        hasFlag: $403f7f6a1013a11d$var$hasFlag
    });
const $403f7f6a1013a11d$export$dc4f8132c3090b32 = ()=>$403f7f6a1013a11d$export$dbb055af53fd81a0;
const $403f7f6a1013a11d$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, $hrodw.DISMISS_COMMAND);
const $403f7f6a1013a11d$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
const $403f7f6a1013a11d$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
const $403f7f6a1013a11d$export$63ffd7d99470afd4 = (flag)=>!$403f7f6a1013a11d$export$14b1864d9cf0809f(flag) && !$403f7f6a1013a11d$export$d84ce5adcee46025(flag) && !$403f7f6a1013a11d$export$cd5f9f2b991b82d9(flag);
const $403f7f6a1013a11d$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);

});
parcelRegister("90d5q", function(module, exports) {

$parcel$export(module.exports, "dismissFlag", () => $638868b8945d44f6$export$900a08a292ad23cd);
$parcel$export(module.exports, "default", () => $638868b8945d44f6$export$2e2bcd8739ae039);

var $3SCOM = parcelRequire("3SCOM");

var $hrodw = parcelRequire("hrodw");
const $638868b8945d44f6$export$900a08a292ad23cd = (flagId)=>({
        command: (0, $hrodw.DISMISS_COMMAND),
        id: flagId
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$638868b8945d44f6$export$2e2bcd8739ae039 = (dispatch)=>(action)=>{
        dispatch((0, $3SCOM.dismissFlagAction)(action.id));
    };

});
parcelRegister("3SCOM", function(module, exports) {

$parcel$export(module.exports, "SHOW", () => $ab52ddfb3f71a238$export$9d04158a25ce4cd);
$parcel$export(module.exports, "show", () => $ab52ddfb3f71a238$export$57bf213be019eeb0);
$parcel$export(module.exports, "DISMISS_INSTANCE", () => $ab52ddfb3f71a238$export$b31a07d2e6382678);
$parcel$export(module.exports, "dismiss", () => $ab52ddfb3f71a238$export$abf286bbe7073aba);
$parcel$export(module.exports, "DISMISS_FLAG", () => $ab52ddfb3f71a238$export$1eb56620df104bf);
$parcel$export(module.exports, "dismissFlagAction", () => $ab52ddfb3f71a238$export$4818b3c52448050d);
$parcel$export(module.exports, "RESET", () => $ab52ddfb3f71a238$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $ab52ddfb3f71a238$export$aad8462122ac592b);
const $ab52ddfb3f71a238$export$9d04158a25ce4cd = 'state.SHOW';
const $ab52ddfb3f71a238$export$57bf213be019eeb0 = (payload)=>({
        type: $ab52ddfb3f71a238$export$9d04158a25ce4cd,
        payload: payload
    });
const $ab52ddfb3f71a238$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
const $ab52ddfb3f71a238$export$abf286bbe7073aba = (payload)=>({
        type: $ab52ddfb3f71a238$export$b31a07d2e6382678,
        payload: payload
    });
const $ab52ddfb3f71a238$export$1eb56620df104bf = 'state.DISMISS_FLAG';
const $ab52ddfb3f71a238$export$4818b3c52448050d = (payload)=>({
        type: $ab52ddfb3f71a238$export$1eb56620df104bf,
        payload: payload
    });
const $ab52ddfb3f71a238$export$4a991c87e640ef77 = 'state.RESET';
const $ab52ddfb3f71a238$export$aad8462122ac592b = ()=>({
        type: $ab52ddfb3f71a238$export$4a991c87e640ef77
    });

});

parcelRegister("hrodw", function(module, exports) {

$parcel$export(module.exports, "DISMISS_COMMAND", () => $f63dfcdfd8451c1b$export$e705274c5e156b93);
$parcel$export(module.exports, "toFlagId", () => $f63dfcdfd8451c1b$export$8184bc29de2aea90);
$parcel$export(module.exports, "fromFlagId", () => $f63dfcdfd8451c1b$export$188cdb77b72629d7);
const $f63dfcdfd8451c1b$export$e705274c5e156b93 = 'DISMISS';
const $f63dfcdfd8451c1b$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
const $f63dfcdfd8451c1b$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();

});


parcelRegister("9YEIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bab8f4a2dc29320$export$2e2bcd8739ae039);

var $aXKmr = parcelRequire("aXKmr");

var $3SCOM = parcelRequire("3SCOM");

var $hrodw = parcelRequire("hrodw");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2bab8f4a2dc29320$export$2e2bcd8739ae039 = (dispatch)=>(flag)=>{
        // Flag is of type FlagComponent
        if (typeof flag === 'function') {
            dispatch((0, $3SCOM.show)(flag));
            return undefined;
        }
        const flagId = flag.id || (0, $hrodw.toFlagId)((0, $aXKmr.v4)());
        const newFlag = {
            ...flag,
            id: flagId
        };
        dispatch((0, $3SCOM.show)(newFlag));
        return flagId;
    };

});

parcelRegister("PC9Lc", function(module, exports) {

$parcel$export(module.exports, "store", () => $8b98e66ebdeeac00$export$6f57813fe9f31bf9);

var $eexGj = parcelRequire("eexGj");
const $8b98e66ebdeeac00$export$6f57813fe9f31bf9 = (0, $eexGj.createStore)();

});
parcelRegister("eexGj", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $03757ac17ecb5523$export$f51a9068ac82ea43);

var $gs6vs = parcelRequire("gs6vs");

var $kC33T = parcelRequire("kC33T");
const $03757ac17ecb5523$export$f51a9068ac82ea43 = (rootEpic)=>(0, $gs6vs.default)({
        appName: 'flags',
        rootReducer: $kC33T.default,
        rootEpic: rootEpic
    });

});
parcelRegister("gs6vs", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5fb2723e7e827ee$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7HHI1 = parcelRequire("7HHI1");

var $dFg4o = parcelRequire("dFg4o");

var $4tM8k = parcelRequire("4tM8k");

var $abRw5 = parcelRequire("abRw5");

var $kqAfW = parcelRequire("kqAfW");

var $i1nY5 = parcelRequire("i1nY5");

var /**
 * Initializes a Redux store with configurations for state management and middleware integration.
 * It addresses serialization challenges with non-serializable entities and enhances debugging capabilities.
 * The custom action listener middleware offers additional control over action dispatches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f5fb2723e7e827ee$export$2e2bcd8739ae039 = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
    const actionListenerMiddleware = new (0, $i1nY5.default)();
    middlewares.push(actionListenerMiddleware.perform);
    if ((0, $abRw5.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("f8FDM"));
        middlewares.push(logger);
    }
    if (rootEpic) middlewares.push((0, $4tM8k.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
        dependencies: rootEpicDependencies
    } : undefined));
    const store = (0, $7HHI1.createStore)((0, $dFg4o.enableBatching)(rootReducer), initialState, (0, $kqAfW.default)({
        name: appName,
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; serialize: { replacer: (key: any, value: any) => any; }; }' is not assignable to parameter of type 'DevtoolsConfig'.
        serialize: {
            // Replacer function is necessary to fix redux-devtools because some actions and state are React Elements
            // and the default serialization gets into a loop in a circular dependency somewhere in internal React properties.
            // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#serialize
            // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
            replacer: (key, value)=>{
                if (/*#__PURE__*/ (0, $eJOHy.isValidElement)(value)) {
                    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    if (value.type && value.type.displayName) // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    return `React Element <${value.type.displayName}>`;
                    return 'React Element';
                }
                // The benefit of using React + Redux + declarative API is that there is no more need to save DOM elements in store!
                // ... yet we still do. So when that happens, Redux devtools sometimes crashes because it tries to serialize circular DOM structure.
                if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                return value;
            }
        }
    })((0, $7HHI1.compose)(...enhancers, (0, $7HHI1.applyMiddleware)(...middlewares))));
    store.addActionListener = actionListenerMiddleware.add;
    store.removeActionListener = actionListenerMiddleware.remove;
    return store;
};

});
parcelRegister("abRw5", function(module, exports) {

$parcel$export(module.exports, "debugEnabled", () => $bfde42121ad38c1d$export$342c99cc1e9bc5c6);
const $bfde42121ad38c1d$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);

});

parcelRegister("kqAfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0f35d50b3b5f50f$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");
var // An extended version of redux's 'compose' method, that
// will use redux devtools chrome extension if available
// https://github.com/zalmoxisus/redux-devtools-extension
//
// The 'devtoolsConfig' parameter is an object adhering to the following API:
// https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
// eslint-disable-next-line jira/import/no-anonymous-default-export
$f0f35d50b3b5f50f$export$2e2bcd8739ae039 = (devtoolsConfig = {})=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const config = {
        ...devtoolsConfig
    };
    if (config.name != null && config.instanceId == null) config.instanceId = config.name;
    return 0, $7HHI1.compose;
};

});

parcelRegister("i1nY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d528e7f36d931b18$export$2e2bcd8739ae039);
class $d528e7f36d931b18$export$2e2bcd8739ae039 {
    constructor(){
        this.listeners = [];
        this.add = (listener)=>{
            this.listeners.push(listener);
        };
        this.remove = (listener)=>{
            this.listeners = this.listeners.filter((l)=>l !== listener);
        };
        // @ts-expect-error - TS2315 - Type 'Middleware' is not generic.
        this.perform = (api)=>(next)=>(action)=>{
                    const result = next(action);
                    this.listeners.forEach((listener)=>listener(action, api.getState()));
                    return result;
                };
    }
}

});


parcelRegister("kC33T", function(module, exports) {

$parcel$export(module.exports, "default", () => $cee5563a0f3de215$export$2e2bcd8739ae039);

var $a6gy0 = parcelRequire("a6gy0");

var $aXKmr = parcelRequire("aXKmr");

var $3SCOM = parcelRequire("3SCOM");
const $cee5563a0f3de215$var$defaultState = {
    flags: []
};
var /**
 * Manages the state transitions of a notification system by handling actions such as showing
 * new notifications, dismissing notifications (either individually or by type), and
 * resetting to the default state. It uniquely prioritizes high-priority notifications,
 * ensuring they are displayed before low-priority ones, enhancing the user's
 * attention to critical alerts.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$cee5563a0f3de215$export$2e2bcd8739ae039 = (state = $cee5563a0f3de215$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3SCOM.SHOW:
            {
                // If flag is of type FlagComponent, it is treated as high priority
                const [lowPriorityFlags, highPriorityFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($a6gy0)))([
                    {
                        id: (0, $aXKmr.v4)(),
                        flag: action.payload
                    },
                    ...state.flags
                ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                const flags = [
                    ...highPriorityFlags,
                    ...lowPriorityFlags
                ];
                return {
                    ...state,
                    flags: flags
                };
            }
        case 0, $3SCOM.DISMISS_INSTANCE:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                };
            }
        case 0, $3SCOM.DISMISS_FLAG:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>{
                        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        if (flagInstance.flag.id) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        return flagInstance.flag.id !== id;
                        return true;
                    })
                };
            }
        case 0, $3SCOM.RESET:
            return $cee5563a0f3de215$var$defaultState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});




parcelRegister("eeSEl", function(module, exports) {

$parcel$export(module.exports, "default", () => $97602d570e003f87$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $97602d570e003f87$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "relay-fetch.services.error-flags.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "relay-fetch.services.error-flags.description",
        "defaultMessage": "Looks like you've been signed out. Try logging in again. "
    },
    login: {
        "id": "relay-fetch.services.error-flags.login",
        "defaultMessage": "Log in"
    }
});

});


parcelRegister("c2hs9", function(module, exports) {

$parcel$export(module.exports, "getLoggingAndMetricsHelper", () => $3d28a75f7345d649$export$726e1df8186bb981);

var $1rzja = parcelRequire("1rzja");

var $9Dhvc = parcelRequire("9Dhvc");

var $jPROM = parcelRequire("jPROM");

var $eSnSE = parcelRequire("eSnSE");

var $1uIew = parcelRequire("1uIew");

var $7jTnu = parcelRequire("7jTnu");
const $3d28a75f7345d649$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
const $3d28a75f7345d649$export$726e1df8186bb981 = (graphqlDetails)=>{
    const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
    const logErrorRetry = (error, retryAttempt)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
            'statusCode'
        ], null);
        const errorType = error instanceof (0, $1uIew.default) ? 'network' : 'unknown';
        // Log any errors even in SSR
        (0, $eSnSE.default).safeErrorWithoutCustomerData($3d28a75f7345d649$var$LOG_NAMESPACE, `[${errorType} error]`, {
            message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($1rzja)))(errorType)} error]: ${error?.message ?? ''}`,
            errorType: errorType,
            statusCode: statusCode,
            queryName: queryName,
            operationKind: operationKind,
            errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
                'name'
            ], null),
            retryAttempt: retryAttempt,
            isGetMethodFeatureOn: (0, $7jTnu.fg)('switch_relay_fetch_to_post_from_get')
        });
    };
    return {
        logNonBreakingErrors: (errors, requestId)=>{
            if (false || (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(errors) || !Array.isArray(errors)) return;
            errors.forEach((error)=>{
                error && (0, $eSnSE.default).safeErrorWithoutCustomerData($3d28a75f7345d649$var$LOG_NAMESPACE, '[graphql error]', {
                    queryName: queryName,
                    operationKind: operationKind,
                    errorType: 'graphql',
                    message: error.message,
                    requestId: requestId
                });
            });
        },
        logError: logErrorRetry,
        logErrorRetry: logErrorRetry
    };
};

});

parcelRegister("ll6Lf", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $b1384809f654b8cb$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "blocklist", () => $b1384809f654b8cb$export$c5c28c9e707bcda1);
$parcel$export(module.exports, "getRetryAttemptsForQuery", () => $b1384809f654b8cb$export$9dec0f42cc67f6ab);
$parcel$export(module.exports, "getTraceIdFromExtensions", () => $b1384809f654b8cb$export$eefb7f54c3b07211);
$parcel$export(module.exports, "generateOptions", () => $b1384809f654b8cb$export$c21133b4499f5374);
$parcel$export(module.exports, "shouldRetry", () => $b1384809f654b8cb$export$7bfea3c3d460ecd8);

var $jPROM = parcelRequire("jPROM");

var $1O6Yz = parcelRequire("1O6Yz");

var $7jTnu = parcelRequire("7jTnu");

var $9id36 = parcelRequire("9id36");

var $3Z1SN = parcelRequire("3Z1SN");

var $1uIew = parcelRequire("1uIew");

var $1oMOM = parcelRequire("1oMOM");

var $dSA8H = parcelRequire("dSA8H");

var $kIz4h = parcelRequire("kIz4h");

var $cIIZL = parcelRequire("cIIZL");

var $aYncF = parcelRequire("aYncF");

var $hWeHP = parcelRequire("hWeHP");
let $b1384809f654b8cb$var$redirecting = false;
const $b1384809f654b8cb$export$ae8f795c4c44d494 = ()=>{
    $b1384809f654b8cb$var$redirecting = false;
};
const $b1384809f654b8cb$var$markAsRedirecting = ()=>{
    $b1384809f654b8cb$var$redirecting = true;
};
if (typeof window !== 'undefined') // Mark as redirecting, when we're unloading the page to prevent double/unwatend redirection.
window.addEventListener('beforeunload', ()=>{
    $b1384809f654b8cb$var$markAsRedirecting();
});
const $b1384809f654b8cb$var$redirect = ()=>{
    const identity = (0, $9id36.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href)}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = redirectUrl;
};
const $b1384809f654b8cb$export$b8dbb7d6029c5413 = ()=>{
    if (!false && !$b1384809f654b8cb$var$redirecting) {
        const heartbeatService = (0, $3Z1SN.getInstance)();
        if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
            if (!$b1384809f654b8cb$var$redirecting) $b1384809f654b8cb$var$redirect();
            // Set flag to prevent multiple redirects
            $b1384809f654b8cb$var$markAsRedirecting();
        }
    }
    return $b1384809f654b8cb$var$redirecting;
};
const $b1384809f654b8cb$export$c5c28c9e707bcda1 = [
    'issueAggQuery'
];
const $b1384809f654b8cb$export$9dec0f42cc67f6ab = (queryName, operationKind)=>{
    if (operationKind === 'query') return 0, $dSA8H.RETRY_ATTEMPTS_LIMIT;
    return 0;
};
const $b1384809f654b8cb$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.trace_id;
    return undefined;
};
const $b1384809f654b8cb$export$c21133b4499f5374 = (options = {}, url = null)=>{
    // the token fetcher returns undefined if no cookie value was found, also in SSR cookies are unavailable
    const csrfToken = !false ? (0, $kIz4h.default)() : undefined;
    // If we don't get a token, there is no point trying to add the csrf header
    const csrfTokenHeader = (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(csrfToken) ? {} : {
        'atl-xsrf-token': csrfToken
    };
    let atlAttribution = {};
    if ((0, $7jTnu.fg)('pass_extra_headers_to_agg')) {
        if ((0, $7jTnu.fg)('relay-defer-retry-support')) {
            const avpWorkspaceId = (0, $hWeHP.default)('ajs-avp-workspace-id');
            const cloudId = (0, $hWeHP.default)('ajs-cloud-id');
            atlAttribution = {
                atlWorkspaceId: avpWorkspaceId,
                tenantId: cloudId,
                product: 'Atlassian Jira',
                businessUnit: 'Engineering-Atlassian Jira',
                service: 'afm-frontend',
                team: 'Atlassian Jira'
            };
        } else {
            const tenantContext = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
            atlAttribution = {
                atlWorkspaceId: tenantContext.avpWorkspaceId,
                tenantId: tenantContext.cloudId,
                product: 'Atlassian Jira',
                businessUnit: 'Engineering-Atlassian Jira',
                service: 'afm-frontend',
                team: 'Atlassian Jira'
            };
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, {
        // We have to provide general options here or the headers we provide will override the default ones found
        // here /src/packages/platform/utils/fetch/src/utils/requests.js due to a shallow merge
        ...(0, $1oMOM.getDefaultOptions)(url),
        ...options
    }, {
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $cIIZL.default).join(','),
            'atl-attribution': JSON.stringify(atlAttribution),
            ...csrfTokenHeader
        }
    });
};
const $b1384809f654b8cb$export$7bfea3c3d460ecd8 = (error)=>{
    if (error instanceof (0, $1uIew.default)) return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};

});
parcelRegister("cIIZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c69dc0ed7f858e$export$2e2bcd8739ae039);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $d9c69dc0ed7f858e$export$2e2bcd8739ae039 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});



parcelRegister("kdR84", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $4faf0d1ae15fc4dc$export$e7aa7bc5c1b3cfb3);

var $jPROM = parcelRequire("jPROM");

var $37Ewn = parcelRequire("37Ewn");

var $jGzN3 = parcelRequire("jGzN3");

var $7jTnu = parcelRequire("7jTnu");

var $dSA8H = parcelRequire("dSA8H");

var $g1oKu = parcelRequire("g1oKu");

var $7797X = parcelRequire("7797X");

var $iFeTU = parcelRequire("iFeTU");

var $cvB0A = parcelRequire("cvB0A");

var $S8wWU = parcelRequire("S8wWU");

var $lN9MB = parcelRequire("lN9MB");

var $aOk72 = parcelRequire("aOk72");

var $jC6NO = parcelRequire("jC6NO");

var $c2hs9 = parcelRequire("c2hs9");

var $ll6Lf = parcelRequire("ll6Lf");
const $4faf0d1ae15fc4dc$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    if (!(0, $7jTnu.fg)('remove_heartbeat_service_from_jira_relay_fetch')) {
        const redirecting = (0, $ll6Lf.checkAuthentication)();
        if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return (0, $37Ewn.Observable).from(new Promise(()=>{}));
    }
    const { name: queryName, operationKind: operationKind } = request;
    const earlyScriptPromise = !false && (0, $cvB0A.claimEarlyScriptPromise)((0, $cvB0A.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $c2hs9.getLoggingAndMetricsHelper)(loggingMetadata);
    return (0, $37Ewn.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            const endpoint = (0, $lN9MB.getAggEndpoint)(request, cacheConfig);
            const body = (0, $lN9MB.getRequestBody)(request, variables);
            let ssrCache = null;
            if (!false && requestID != null) ssrCache = (0, $iFeTU.getQueryResponseCache)().get(requestID, variables);
            // On client read cache from window.SPA_STATE if available
            if (!false && !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(ssrCache)) {
                sink.next(ssrCache);
                if (requestID != null) (0, $iFeTU.getQueryResponseCache)().delete(requestID, variables);
                sink.complete();
                return;
            }
            const wrappedEarlyScriptPromise = earlyScriptPromise && (0, $dSA8H.retryOnError)(()=>(0, $jGzN3.applyErrorHandling)(earlyScriptPromise), {
                retryFunc: ()=>(0, $jGzN3.performPostRequest)(endpoint, (0, $ll6Lf.generateOptions)({
                        body: body
                    }, endpoint)),
                retryPredicate: (0, $ll6Lf.shouldRetry),
                retryAttempts: (0, $ll6Lf.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: loggingAndMetrics.logErrorRetry
            });
            // Throws HttpError
            const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, $jGzN3.performPostRequestWithRetry)(endpoint, {
                ...(0, $ll6Lf.generateOptions)({
                    body: body
                }, endpoint),
                retryPredicate: (0, $ll6Lf.shouldRetry),
                retryAttempts: (0, $ll6Lf.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: (error, attempt)=>{
                    loggingAndMetrics.logErrorRetry(error, attempt);
                }
            }));
            promise.then((response)=>{
                (0, $aOk72.addTraceId)(queryName, (0, $ll6Lf.getTraceIdFromExtensions)(response));
                (0, $S8wWU.putExtensions)(queryName, response.extensions);
                // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
                const errors = response.errors || undefined;
                if (errors != null) {
                    const requestId = response?.extensions?.gateway?.request_id;
                    if (!(0, $ll6Lf.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                    (0, $g1oKu.captureErrors)(errors, {
                        operationName: queryName,
                        requestId: requestId
                    });
                    if ((0, $g1oKu.isUnauthenticated)(errors)) {
                        //  Short circuit operation and handle the unauthorized errors.
                        (0, $jC6NO.showUnauthenticatedFlag)(queryName);
                        // Surprise behaviour: the observable should hang indefinitely here!
                        // At least, that is the expectation of existing code; see src/packages/issue/issue-view/src/integration-tests/experience-tracking/view.cy-integration.tsx
                        // Which assumes that the operation never completes, so relay never receives a (null) response, so it never complains about the data.
                        // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                        return;
                    }
                }
                if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
                // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
                // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
                // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
                response.data = null;
                // cache query response on SSR
                if (false && requestID != null) (0, $iFeTU.getQueryResponseCache)().setWithMetadata(requestID, variables, response, loggingMetadata);
                sink.next(response);
                sink.complete();
            })// We don't await the promise so the catch block below is never
            // triggered so we need an independent catch on the promise
            .catch((error)=>{
                loggingAndMetrics.logError(error);
                sink.error(error);
            });
            if (requestID != null) // todo: stop sending the value of the promise to QueryPromisesMap. Might happen as part of cleaning up the feature gate for defer support writ large.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $7797X.QueryPromisesMap).set(requestID, promise);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});


parcelRegister("208o0", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $8a31979205723cc3$export$ec068583843480e7);

var $37Ewn = parcelRequire("37Ewn");

var $gYnSx = parcelRequire("gYnSx");

var $i3pnC = parcelRequire("i3pnC");

var $cgjj3 = parcelRequire("cgjj3");

var $kQnVX = parcelRequire("kQnVX");
const $8a31979205723cc3$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $37Ewn.Observable).create((sink)=>{
        const client = (0, $i3pnC.getClient)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const payload = {
            query: '',
            operationName: operationName,
            variables: variables,
            extensions: {
                pq: id
            }
        };
        let requestId;
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                // @ts-expect-error agg prop is missing on generic "extensions" type
                const aggRequestId = value?.extensions?.gateway?.request_id;
                requestId = aggRequestId ?? requestId;
                // @ts-expect-error incompatible types between two libraries
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = (0, $cgjj3.getSinkError)(sinkError);
                const attributes = {
                    operationName: operationName,
                    requestId: requestId,
                    userLocation: (0, $kQnVX.getUserLocation)()
                };
                sink.error(errorInfo);
                (0, $gYnSx.default)({
                    meta: {
                        id: 'subscription',
                        packageName: 'jiraRelaySubscription',
                        teamName: 'uip-graphql'
                    },
                    error: errorInfo,
                    attributes: attributes,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    });

});
parcelRegister("i3pnC", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $8b503e440384fada$export$6bb76d6eba7e258c);

var $aP5Ku = parcelRequire("aP5Ku");

var $7oY9g = parcelRequire("7oY9g");

var $cIIZL = parcelRequire("cIIZL");


var $lWYYe = parcelRequire("lWYYe");
let $8b503e440384fada$var$client;
const $8b503e440384fada$export$6bb76d6eba7e258c = ()=>{
    if ((0, $lWYYe.isSSR)() || (0, $7oY9g.default)('graphql_subscriptions')) return null;
    if (!$8b503e440384fada$var$client) $8b503e440384fada$var$client = (0, $aP5Ku.createClient)({
        url: (0, $lWYYe.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $4e27773d74c87757$export$8b012b965402e06a),
        retryAttempts: (0, $4e27773d74c87757$export$bf6cd96e19b2987f),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $cIIZL.default).join(',')
        }
    });
    return $8b503e440384fada$var$client;
};
const $8b503e440384fada$export$2f0afd443356d36f = ()=>{
    $8b503e440384fada$var$client = null;
};

});
const $4e27773d74c87757$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $4e27773d74c87757$export$bf6cd96e19b2987f = 100;
const $4e27773d74c87757$export$1ad8434180c5936c = 300000; // 5m

parcelRegister("lWYYe", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $96dd7559b248a0eb$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $96dd7559b248a0eb$export$29a72e89601dfc59);
const $96dd7559b248a0eb$export$48d7c418edadb60c = ()=>false ?? false;
const $96dd7559b248a0eb$export$29a72e89601dfc59 = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    `${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});


parcelRegister("cgjj3", function(module, exports) {

$parcel$export(module.exports, "getSinkError", () => $97d53ef8026102d6$export$ece4736473c28965);

var $eSnSE = parcelRequire("eSnSE");

var $7jTnu = parcelRequire("7jTnu");

var $Bakwk = parcelRequire("Bakwk");
const $97d53ef8026102d6$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (typeof error === 'object' && 'type' in error && error.type === 'error') {
        if ((0, $7jTnu.fg)('issue-jsc-2856-investigate-subscription-undefined')) (0, $eSnSE.default).unsafeErrorWithCustomerData('graphql.subscription.getSinkError', `subscription undefined error ${(0, $Bakwk.stringifyEvent)(error)}`);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const errorEvent = error;
        errorInfo = new Error(`ErrorEvent: "${errorEvent.error}"`);
    } else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};

});
parcelRegister("Bakwk", function(module, exports) {

$parcel$export(module.exports, "stringifyEvent", () => $6d3fbda8473a46a1$export$6b599d9330014be8);
// some logs for investigation purpose, to be removed by 29/07/2025
/* eslint-disable guard-for-in */ function $6d3fbda8473a46a1$export$6b599d9330014be8(object, depth = 0, maxDepth = 2) {
    // go through max 2 levels of circular references
    if (depth > maxDepth) return 'Object';
    const obj = {};
    for(const key in object){
        // @ts-expect-error - TS7053
        let value = object[key];
        // @ts-expect-error - TS2339
        if (value instanceof Node) value = {
            id: value.id
        };
        else if (value instanceof Window) value = 'Window';
        else if (value instanceof Object) value = $6d3fbda8473a46a1$export$6b599d9330014be8(value, depth + 1, maxDepth);
        // @ts-expect-error - TS7053
        obj[key] = value;
    }
    return depth ? obj : JSON.stringify(obj);
}

});



parcelRegister("lLNFn", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $96879960c01891ca$export$48d7c418edadb60c);
const $96879960c01891ca$export$48d7c418edadb60c = ()=>false ?? false;

});




parcelRegister("lB0Td", function(module, exports) {

$parcel$export(module.exports, "canFetchForgeModules", () => $482882859bcd0b72$export$bb3a4a3b8e654c08);
const $482882859bcd0b72$export$bb3a4a3b8e654c08 = ({ isAnonymous: isAnonymous, cloudId: cloudId })=>{
    /**
	 * SMT-1142
	 * A tenant named `bob` is most likely a local/ci instance started with `./jmake run ci`.
	 * It wasn't possible to find the hostname in a reasonable timeframe so this is the most feasible solution.
	 * In case more tenants like this spawn in the future we'd need to mark these instances instead and block here.
	 */ if (String(cloudId) === 'bob') return false;
    /**
	 * Similarly to the `bob` tenant situation above, we don't want to fetch Forge modules on monolith webdriver tests,
	 * that are also started with `./jmake run ci`, but this time with a valid `cloudId`.
	 * The reason for that is the heartbeat service that is not available in there, which leads to the login page redirects.
	 */ if (!false && $482882859bcd0b72$export$489a82a1efc4cd04().endsWith('.atl-test.space')) return false;
    // There is no anonymous access for now
    return !isAnonymous;
};
const $482882859bcd0b72$export$489a82a1efc4cd04 = ()=>window.location.hostname;

});

parcelRegister("TUft0", function(module, exports) {

$parcel$export(module.exports, "toMappedExtensions", () => $e072eb0063339dc0$export$e073e0c0d1c23345);

var $7jTnu = parcelRequire("7jTnu");
function $e072eb0063339dc0$export$e073e0c0d1c23345(requestedModules, returnedExtensions) {
    const result = Object.fromEntries(requestedModules.map((type)=>[
            type,
            []
        ]));
    const extensions = (0, $7jTnu.fg)('forge-extensions-module-id-for-relay') ? $e072eb0063339dc0$export$acd8ca2c14bd2aa4(returnedExtensions) : returnedExtensions;
    extensions.forEach((extension)=>{
        result[extension.type]?.push(extension);
    });
    // There is no better way to work this out and preserve a generic object response
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return result;
}
function $e072eb0063339dc0$export$acd8ca2c14bd2aa4(extensions) {
    return extensions.map(({ moduleId: moduleId, ...rest })=>({
            ...rest,
            id: moduleId ?? rest.id.replace(/-+\d+$/, ''),
            moduleId: moduleId
        }));
}

});

parcelRegister("aiU3I", function(module, exports) {

$parcel$export(module.exports, "trackGraphQLErrors", () => $0e4de19c3dd7a13b$export$a5c00ff206a4c88b);

var $g1oKu = parcelRequire("g1oKu");

var $5Z6L0 = parcelRequire("5Z6L0");

var $aOk72 = parcelRequire("aOk72");
function $0e4de19c3dd7a13b$export$a5c00ff206a4c88b(operationName) {
    const queryId = (0, $g1oKu.startCaptureGraphQlErrors)();
    (0, $aOk72.startCapturingTraceIds)(operationName);
    return {
        stopGraphQLErrorTracking: ()=>(0, $aOk72.stopCapturingTraceIds)(operationName),
        getGraphQLError: ()=>$0e4de19c3dd7a13b$var$getGraphQLError(queryId, operationName)
    };
}
function $0e4de19c3dd7a13b$var$getGraphQLError(key, operationName) {
    const errors = (0, $g1oKu.stopCaptureGraphQlErrors)(key).filter((errorWrapper)=>errorWrapper.meta.operationName === operationName).flatMap((errorWrapper)=>errorWrapper.errors);
    if (errors.length) return new (0, $5Z6L0.TrackedGraphQLError)(`Query ${operationName} had graphql errors`, errors, (0, $aOk72.getTraceIds)(operationName));
    return undefined;
}

});


parcelRegister("fcQiO", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyOrId", () => $45133b0b69e21626$export$43cde151f667c69e);
$parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", () => $45133b0b69e21626$export$b87af5b274141bd6);

var $bBtQo = parcelRequire("bBtQo");
const $45133b0b69e21626$export$43cde151f667c69e = (match)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, match.query);
    return projectKey || projectId || '';
};
const $45133b0b69e21626$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};

});
parcelRegister("bBtQo", function(module, exports) {

$parcel$export(module.exports, "getProjectIdOrKey", () => $0bc483932e4540b9$export$c072f183553fb7ea);
$parcel$export(module.exports, "getProjectKeyId", () => $0bc483932e4540b9$export$1f7213d0f9054f06);
const $0bc483932e4540b9$export$89040d072f281f85 = (query)=>query?.selectedProjectId || query?.pid || query?.projectId || query?.['project.id'];
const $0bc483932e4540b9$export$667f2a0f99c75faa = (match, query)=>match?.params.projectKey || query?.projectKey || query?.['project.key'] || (match.params?.issueKey || '').split('-')[0];
const $0bc483932e4540b9$export$c072f183553fb7ea = (match, query)=>$0bc483932e4540b9$export$89040d072f281f85(query) || $0bc483932e4540b9$export$667f2a0f99c75faa(match, query);
const $0bc483932e4540b9$export$1f7213d0f9054f06 = (match, query)=>{
    // handle reports legacy url or project settings details
    const projectId = $0bc483932e4540b9$export$89040d072f281f85(query);
    const projectKey = $0bc483932e4540b9$export$667f2a0f99c75faa(match, query);
    return {
        projectKey: projectKey,
        projectId: projectId
    };
};

});


parcelRegister("5L7qx", function(module, exports) {

$parcel$export(module.exports, "resourceWithCondition", () => $e024e4a1466467c1$export$cac04afc5a06c544);
$parcel$export(module.exports, "resourceWithCondition2", () => $e024e4a1466467c1$export$78488a529a07cd46);
$parcel$export(module.exports, "browserOnlyResourceWithCondition", () => $e024e4a1466467c1$export$5284559c6d2f1a7b);

var $cJYBV = parcelRequire("cJYBV");
const $e024e4a1466467c1$export$cac04afc5a06c544 = (conditionGetter, resourceTrue)=>resourceTrue && {
        get type () {
            return conditionGetter() ? resourceTrue.type : (0, $cJYBV.RESOURCE_TYPE_NOOP);
        },
        getKey: resourceTrue.getKey,
        get maxAge () {
            return conditionGetter() ? resourceTrue.maxAge : Number.MAX_SAFE_INTEGER;
        },
        getData: (routerContext, storeContext)=>conditionGetter() ? resourceTrue.getData(routerContext, storeContext) : Promise.resolve(null),
        maxCache: resourceTrue.maxCache,
        get isBrowserOnly () {
            return resourceTrue.isBrowserOnly;
        },
        get depends () {
            return resourceTrue.depends;
        },
        get skipBrowser () {
            return resourceTrue.skipBrowser;
        }
    };
const $e024e4a1466467c1$export$fbf6681b373be4c4 = (resource, amendments = {})=>// @ts-expect-error - TS2322 - Type 'Partial<RouteResource<any>>' is not assignable to type 'RouteResource<any>'.
    resource && // IMPORTANT - resources can be falsy in SSR "routes" build
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.defineProperties({}, {
        ...Object.getOwnPropertyDescriptors(resource),
        ...Object.getOwnPropertyDescriptors(amendments)
    });
const $e024e4a1466467c1$export$78488a529a07cd46 = (conditionGetter, itemTrue, itemFalse = $e024e4a1466467c1$export$fbf6681b373be4c4(itemTrue, {
    getKey: ()=>'DEGENERATE_KEY',
    getData: ()=>null,
    maxAge: Number.MAX_SAFE_INTEGER
}))=>// @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'RouteResource<any>': type, getKey, maxAge, getData, and 3 more.
    itemTrue && // IMPORTANT - resources can be falsy in SSR "routes" build
    Object.defineProperties({}, Object.fromEntries([
        ...Object.keys(itemTrue),
        ...Object.keys(itemFalse)
    ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
            key,
            {
                configurable: false,
                enumerable: true,
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'.
                get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
            }
        ])));
const $e024e4a1466467c1$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
        ...resource,
        get isBrowserOnly () {
            return !!conditionGetter();
        }
    };

});
parcelRegister("cJYBV", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NOOP", () => $36187b280b89d04f$export$eb37f5d331ea4de4);
$parcel$export(module.exports, "MIN_MAX_AGE", () => $36187b280b89d04f$export$5664a170ac5a9781);
const $36187b280b89d04f$export$eb37f5d331ea4de4 = 'NOOP';
const $36187b280b89d04f$export$5664a170ac5a9781 = 5000;

});


parcelRegister("aOcSy", function(module, exports) {

$parcel$export(module.exports, "uniqueExtensionsFilter", () => $a0b01b44bfd87d67$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $a0b01b44bfd87d67$export$1eefd1d9cde49fd5);

var $jOCpp = parcelRequire("jOCpp");

var $ePLco = parcelRequire("ePLco");
const $a0b01b44bfd87d67$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($jOCpp)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $a0b01b44bfd87d67$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    return [
        ...$a0b01b44bfd87d67$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
        ...$a0b01b44bfd87d67$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
        ...$a0b01b44bfd87d67$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
    ];
};

});
parcelRegister("jOCpp", function(module, exports) {

var $1lM9j = parcelRequire("1lM9j");

var $1txRh = parcelRequire("1txRh");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $e6d07b03a10f7aee$var$uniqBy(array, iteratee) {
    return array && array.length ? $1txRh(array, $1lM9j(iteratee, 2)) : [];
}
module.exports = $e6d07b03a10f7aee$var$uniqBy;

});

parcelRegister("ePLco", function(module, exports) {

$parcel$export(module.exports, "parseExtensionId", () => $763cc49eecef8327$export$bae42cbaf7fa3e1b);
$parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", () => $763cc49eecef8327$export$a92b17288693d366);
const $763cc49eecef8327$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const [, appId, envId] = extensionId.split('/');
    return {
        appId: appId,
        envId: envId
    };
};
const $763cc49eecef8327$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');

});



parcelRegister("3qMzf", function(module, exports) {

$parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", () => $7b699886fcf4f1e6$export$fab84295e18e9246);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $jfYJb = parcelRequire("jfYJb");
const $7b699886fcf4f1e6$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $7b699886fcf4f1e6$export$fab84295e18e9246 = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
    getKey: ({ match: match, query: query })=>$7b699886fcf4f1e6$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $7b699886fcf4f1e6$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jfYJb.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
        return navInfo;
    },
    maxAge: 300000
});

});
parcelRegister("jfYJb", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", () => $8ad6472209454f53$export$b15f9f5cf6db359e);

var $jGzN3 = parcelRequire("jGzN3");
const $8ad6472209454f53$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
    if (projectKeyOrId == null) throw new Error('invalid identifier specified');
    return (0, $jGzN3.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
};

});


parcelRegister("gq8OO", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJsmReportsResource", () => $e907d070057d33a1$export$ec28065a31cce4ce);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $aGpYW = parcelRequire("aGpYW");
const $e907d070057d33a1$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $e907d070057d33a1$export$ec28065a31cce4ce = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
    getKey: ({ match: match, query: query })=>$e907d070057d33a1$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $e907d070057d33a1$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        return (0, $aGpYW.fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
    },
    maxAge: 300000
});

});
parcelRegister("aGpYW", function(module, exports) {

$parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", () => $2ca8e623397ccc3d$export$c1dd51127051647d);

var $jGzN3 = parcelRequire("jGzN3");
const $2ca8e623397ccc3d$export$c1dd51127051647d = (projectIdOrKey)=>{
    if (projectIdOrKey == null) throw new Error('invalid project id or key');
    return (0, $jGzN3.performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
};

});


parcelRegister("5FSZM", function(module, exports) {

$parcel$export(module.exports, "getCalendarFilterFieldsResource", () => $613ce22e40063fc2$export$5f02bf5f04197ed7);
$parcel$export(module.exports, "useCalendarFilterResource", () => $613ce22e40063fc2$export$70361b748d216408);

var $eJOHy = parcelRequire("eJOHy");

var $8KUFq = parcelRequire("8KUFq");

var $jGzN3 = parcelRequire("jGzN3");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $7jTnu = parcelRequire("7jTnu");

var $7OmKg = parcelRequire("7OmKg");


var $iPdm8 = parcelRequire("iPdm8");
const $613ce22e40063fc2$var$fetchFilterFieldsOld = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $4632d48377e7873d$export$546e90157aa718d4),
                variables: {
                    cloudId: cloudId,
                    contextFieldsFilter: (0, $7jTnu.fg)('corcap-3439-support-sdorigin-jqlbuilder-queue') ? {
                        jqlTerms: [
                            (0, $7OmKg.REQUEST_TYPE_FILTER),
                            (0, $7OmKg.SERVICE_DESK_ORIGIN_FILTER),
                            (0, $7OmKg.SERVICE_DESK_ORIGIN_DUPLICATE_FILTER)
                        ]
                    } : {
                        searchString: (0, $7OmKg.REQUEST_TYPE_FILTER)
                    },
                    jqlContext: jqlContext
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return (0, $iPdm8.transformAndReport)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $8KUFq.isHttpClientErrorResponse)(error)) (0, $iPdm8.reportError)(error);
        return 0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS;
    }
};
const $613ce22e40063fc2$var$fetchFilterFields = async (cloudId)=>{
    try {
        const requestTypeFieldResponse = await (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $4632d48377e7873d$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        const requestTypeField = requestTypeFieldResponse.data?.jira?.requestTypeField;
        if (!requestTypeField) return 0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS;
        return [
            {
                ...requestTypeField,
                searchTemplate: requestTypeField.searchTemplate.key,
                fieldType: requestTypeField.type
            },
            ...(0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS)
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $8KUFq.isHttpClientErrorResponse)(error)) (0, $iPdm8.reportError)(error);
        return 0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS;
    }
};
const $613ce22e40063fc2$var$filterFieldsResource = (0, $l1VxS.createResource)({
    type: (0, $7OmKg.RESOURCE_TYPE_FILTER_FIELD),
    getKey: ({ match: match, query: query })=>{
        if ((0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag')) {
            const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            return (0, $7OmKg.RESOURCE_TYPE_FILTER_FIELD) + projectIdOrKey;
        }
        return 0, $7OmKg.RESOURCE_TYPE_FILTER_FIELD;
    },
    getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        const jqlContext = `project = '${projectIdOrKey}'`;
        return (0, $7jTnu.fg)('move_jsm_views_rt_filter_to_new_query') ? $613ce22e40063fc2$var$fetchFilterFields(cloudId) : $613ce22e40063fc2$var$fetchFilterFieldsOld(cloudId, jqlContext);
    },
    maxAge: Infinity
});
const $613ce22e40063fc2$export$5f02bf5f04197ed7 = ()=>$613ce22e40063fc2$var$filterFieldsResource;
const $613ce22e40063fc2$export$70361b748d216408 = ({ isSimplified: isSimplified })=>{
    const resource = (0, $eJrcF.useResource)($613ce22e40063fc2$var$filterFieldsResource);
    (0, $eJOHy.useEffect)(()=>{
        if (((0, $7jTnu.fg)('corcap-3439-support-sdorigin-jqlbuilder-queue') || (0, $7jTnu.fg)('move_jsm_views_rt_filter_to_new_query')) && !isSimplified && !resource.loading && !resource.error && !resource.data?.find((field)=>typeof field === 'object' && Object.values(field).includes((0, $iPdm8.TARGET_FILTER_TYPE)))) (0, $iPdm8.reportError)(new Error('Unable to prefetch request type'));
    }, [
        isSimplified,
        resource.data,
        resource.error,
        resource.loading
    ]);
    return resource;
};

});
parcelRegister("7OmKg", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NAME", () => $500296557fea2aa7$export$186e93e8ef3f9358);
$parcel$export(module.exports, "PACKAGE_NAME", () => $500296557fea2aa7$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $500296557fea2aa7$export$d57b6b390e78d90f);
$parcel$export(module.exports, "REQUEST_TYPE_FILTER", () => $500296557fea2aa7$export$2c388650eabddf5e);
$parcel$export(module.exports, "SERVICE_DESK_ORIGIN_FILTER", () => $500296557fea2aa7$export$2fcf90614ee15858);
$parcel$export(module.exports, "SERVICE_DESK_ORIGIN_DUPLICATE_FILTER", () => $500296557fea2aa7$export$43482ff574598f59);
$parcel$export(module.exports, "RESOURCE_TYPE_FILTER_FIELD", () => $500296557fea2aa7$export$2019de80301f1da);
$parcel$export(module.exports, "DEFAULT_CALENDAR_FILTER_FIELDS", () => $500296557fea2aa7$export$2912f30d4328fc00);
const $500296557fea2aa7$export$186e93e8ef3f9358 = 'calendarFilterFieldResource';
const $500296557fea2aa7$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskCalendar';
const $500296557fea2aa7$export$d57b6b390e78d90f = 'jsd-shield';
const $500296557fea2aa7$export$2c388650eabddf5e = 'request type';
const $500296557fea2aa7$export$2fcf90614ee15858 = 'service desk origin';
const $500296557fea2aa7$export$43482ff574598f59 = 'cf[10010]';
const $500296557fea2aa7$export$2019de80301f1da = 'RESOURCE_TYPE_FILTER_FIELD';
const $500296557fea2aa7$export$2912f30d4328fc00 = [
    'status',
    'assignee'
];

});

const $4632d48377e7873d$export$546e90157aa718d4 = `
query findRequestTypeCustomFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;
const $4632d48377e7873d$export$2b91517d6d5b4365 = `
query requestTypeFieldQuery($cloudId: ID!) {
  jira {
    requestTypeField(cloudId: $cloudId) {
      displayName
      jqlTerm
      operators
      searchTemplate {
        key
      }
      type
    }
  }
}
`;

parcelRegister("iPdm8", function(module, exports) {

$parcel$export(module.exports, "TARGET_FILTER_TYPE", () => $99c8aba5accb3f4b$export$64f54b13b7aea793);
$parcel$export(module.exports, "reportError", () => $99c8aba5accb3f4b$export$b33b857ad1d9900e);
$parcel$export(module.exports, "transformAndReport", () => $99c8aba5accb3f4b$export$af2aa11c88c551af);

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $7OmKg = parcelRequire("7OmKg");
const $99c8aba5accb3f4b$export$64f54b13b7aea793 = 'com.atlassian.servicedesk:vp-origin';
const $99c8aba5accb3f4b$var$TARGET_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
const $99c8aba5accb3f4b$export$b33b857ad1d9900e = (error)=>{
    (0, $gYnSx.default)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: (0, $7OmKg.RESOURCE_TYPE_NAME),
            packageName: (0, $7OmKg.PACKAGE_NAME),
            teamName: (0, $7OmKg.TEAM_NAME)
        }
    });
};
const $99c8aba5accb3f4b$export$af2aa11c88c551af = (response)=>{
    const edges = response.data?.jira?.jqlBuilder?.fields?.edges;
    // There may be ambigious custom fields with same name, so find the correct one and pass to JQLBuilder
    const requestType = edges?.find((edge)=>edge?.node?.type === $99c8aba5accb3f4b$export$64f54b13b7aea793 && edge?.node?.searchTemplate?.key === $99c8aba5accb3f4b$var$TARGET_FILTER_SEARCH_TEMPLATE)?.node;
    if (!requestType && !(0, $7jTnu.fg)('corcap-3439-support-sdorigin-jqlbuilder-queue')) $99c8aba5accb3f4b$export$b33b857ad1d9900e(new Error('Unable to prefetch request type'));
    // if requestType field found, add it to existing default calendar filter fields
    return requestType ? [
        {
            ...requestType,
            searchTemplate: requestType.searchTemplate.key,
            fieldType: requestType.type
        },
        ...(0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS)
    ] : (0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS);
};

});


parcelRegister("6zZVV", function(module, exports) {

$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", () => $36eb967a9a73fcdf$export$b8c6e2666f12f4bb);
$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only", () => $36eb967a9a73fcdf$export$a799c58e7bee6de4);

var $7jTnu = parcelRequire("7jTnu");

var $6zXPf = parcelRequire("6zXPf");

var $bBtQo = parcelRequire("bBtQo");

var $5L7qx = parcelRequire("5L7qx");

var $l1VxS = parcelRequire("l1VxS");

var $jfYJb = parcelRequire("jfYJb");
const $36eb967a9a73fcdf$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $36eb967a9a73fcdf$export$b8c6e2666f12f4bb = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$36eb967a9a73fcdf$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $36eb967a9a73fcdf$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const projectHomeAddonNavInfo = await (0, $jfYJb.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
        return projectHomeAddonNavInfo;
    },
    maxAge: 300000,
    isCritical: true
});
const $36eb967a9a73fcdf$export$a799c58e7bee6de4 = (0, $5L7qx.resourceWithCondition2)(()=>!((0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('perf-push-big-components-nav-remove-resources')), $36eb967a9a73fcdf$export$b8c6e2666f12f4bb);

});

parcelRegister("dHUNm", function(module, exports) {

$parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", () => $5245c908f3577c91$export$b662f3f877add30d);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $jfYJb = parcelRequire("jfYJb");
const $5245c908f3577c91$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $5245c908f3577c91$export$b662f3f877add30d = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$5245c908f3577c91$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $5245c908f3577c91$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jfYJb.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("9pJMP", function(module, exports) {

$parcel$export(module.exports, "getIdentifier", () => $9620e56412c9e007$export$adb27ddab077e944);
$parcel$export(module.exports, "staticProjectSidebarNavigationResource", () => $9620e56412c9e007$export$f2dfc0f7b2d92691);
$parcel$export(module.exports, "useSidebarNavigationResource", () => $9620e56412c9e007$export$b692cfadccf4e047);

var $7jTnu = parcelRequire("7jTnu");

var $jkKE1 = parcelRequire("jkKE1");

var $2at4v = parcelRequire("2at4v");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $1JhVO = parcelRequire("1JhVO");
const $9620e56412c9e007$export$adb27ddab077e944 = (routeName, match, query)=>{
    /**
	 * `boardId` as an identifier should not be returned for JSM boards route,
	 * skip boards on `SERVICEDESK_BOARDS` or `SERVICEDESK_CALENDAR` route.
	 */ if (routeName === 'servicedesk-boards' || routeName === 'servicedesk-calendar' || query['servicedesk.serviceDeskId'] || (routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-custom-calendar' || routeName === 'servicedesk-queues-practice-custom-board' || routeName === 'servicedesk-queues-practice-custom-calendar' || routeName === 'servicedesk-queues-views-config' || routeName === 'servicedesk-practice-views-config') && (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') || routeName === 'servicedesk-list' && (0, $7jTnu.fg)('jsm_list_view_milestone_1')) {
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        return (0, $jkKE1.getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
    }
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    const boardId = (0, $2at4v.getBoardId)(match, query);
    return (0, $jkKE1.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
};
const $9620e56412c9e007$var$getRouterKey = (routeName, match, query)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = $9620e56412c9e007$export$adb27ddab077e944(routeName, match, query);
    // Next-Gen software projects contain only one board. Hence, using the project key itself
    if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
    return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
};
const $9620e56412c9e007$export$f2dfc0f7b2d92691 = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    getKey: ({ match: match, query: query, route: { name: name } })=>$9620e56412c9e007$var$getRouterKey(name, match, query),
    /**
	 * is called on resource's init fetch, or .refresh()
	 */ getData: async ({ match: match, query: query, route: { name: name } })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const scopeIdentifier = $9620e56412c9e007$export$adb27ddab077e944(name, match, query);
        if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
        const navInfo = await (0, $1JhVO.fetchProjectSidebarNavInfo)(scopeIdentifier);
        return navInfo;
    },
    maxAge: 300000,
    isCritical: true
});
const $9620e56412c9e007$export$b692cfadccf4e047 = ()=>(0, $eJrcF.useResource)($9620e56412c9e007$export$f2dfc0f7b2d92691);

});
parcelRegister("jkKE1", function(module, exports) {

$parcel$export(module.exports, "getScopeIdentifier", () => $fd68a0d085bd7604$export$68278f7cf66944f9);

const $fd68a0d085bd7604$export$68278f7cf66944f9 = (scope)=>{
    // We check for identifiers in order of specificity first. A board ID is more specific than a project key and so on
    const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
    let identifierType = null;
    if (scope.boardId) identifierType = (0, $4a60e80b3610d78a$export$929d50f83189406c);
    else if (scope.projectKey) identifierType = (0, $4a60e80b3610d78a$export$b5a308a17bc991f3);
    else if (scope.projectId) identifierType = (0, $4a60e80b3610d78a$export$da6f46390e1a426f);
    return {
        identifierValue: identifierValue,
        identifierType: identifierType
    };
};

});
const $4a60e80b3610d78a$export$b5a308a17bc991f3 = 'projectKey';
const $4a60e80b3610d78a$export$929d50f83189406c = 'boardId';
const $4a60e80b3610d78a$export$da6f46390e1a426f = 'projectId';


parcelRegister("2at4v", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $68611441a9f8281f$export$557c2f222778cea6);
const $68611441a9f8281f$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];

});

parcelRegister("1JhVO", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarNavInfo", () => $75af829a86061e6c$export$8a51470472777e11);

var $jGzN3 = parcelRequire("jGzN3");
const $75af829a86061e6c$export$8a51470472777e11 = (scopeIdentifier)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
    if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
    let queryParam = '';
    switch(identifierType){
        case 'boardId':
            queryParam = `boardId=${identifierValue}`;
            break;
        case 'projectKey':
        case 'projectId':
            queryParam = `projectIdOrKey=${identifierValue}`;
            break;
        default:
            break;
    }
    return (0, $jGzN3.performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
};

});


parcelRegister("5ddA0", function(module, exports) {

$parcel$export(module.exports, "staticSidebarShortcutsResource", () => $83fdf796383be00f$export$4847c29b4786b3b4);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $24e7X = parcelRequire("24e7X");
const $83fdf796383be00f$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $83fdf796383be00f$export$4847c29b4786b3b4 = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
    getKey: ({ match: match, query: query })=>$83fdf796383be00f$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $83fdf796383be00f$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const shortcuts = await (0, $24e7X.fetchShortcuts)(projectKeyOrId);
        return shortcuts;
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("24e7X", function(module, exports) {

$parcel$export(module.exports, "fetchShortcuts", () => $59a57dc5b45b5a5a$export$49d696bf2525d700);

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");
const $59a57dc5b45b5a5a$export$49d696bf2525d700 = (projectKeyOrId)=>{
    try {
        return (0, $1Ozm9.default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.trackFetchErrors)({
            error: error,
            id: 'fetchProjectShortcuts',
            packageName: 'jiraNavigationAppsResources'
        });
        throw error;
    }
};

});
parcelRegister("1Ozm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ce52bb22689abcd$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $1oMOM = parcelRequire("1oMOM");

var $1uIew = parcelRequire("1uIew");

var $i4YfB = parcelRequire("i4YfB");

var $3WOLx = parcelRequire("3WOLx");

var $7AheX = parcelRequire("7AheX");
var /**
 * Fetch from the given URL, returning the json response.
 * <p>
 * If there are any HTTP errors the promise is rejected with a {@link FetchError}.
 *
 * @param url - to fetch the JSON from
 * @param options - for the fetch call
 * @returns promise containing the JSON
 * @throws {@link FetchError} if there was an HTTP Error. This will reject the promise.
 */ // the `@typescript-eslint/no-unnecessary-type-constraint` rule is disabled because otherwise syntax highlighting breaks with a trailing comma,
// other rules should be fixed ideally.
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export, @typescript-eslint/no-unnecessary-type-constraint
$7ce52bb22689abcd$export$2e2bcd8739ae039 = (url, options = {})=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $3WOLx.applyObservabilityHeaders)(url, (0, $iWqim.merge)((0, $1oMOM.defaultOptions), options))).then((response)=>{
        if (!response.ok) {
            const traceId = (0, $7AheX.getTraceId)(response);
            if (traceId !== undefined && traceId.length > 0) throw new (0, $1uIew.default)(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
            else throw new (0, $1uIew.default)(response.status, undefined, undefined, response);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.json();
    });

});



parcelRegister("85Ze9", function(module, exports) {

$parcel$export(module.exports, "kbConfluenceContextResource", () => $3ddbed7e0cde1711$export$8b58be1423986d17);

var $l1VxS = parcelRequire("l1VxS");


const $3ddbed7e0cde1711$var$getDataLoader = ()=>(parcelRequire("e8zFB"));
const $3ddbed7e0cde1711$export$8b58be1423986d17 = (0, $l1VxS.createResource)({
    type: (0, $146576bfaf2f1c5a$export$54b5a0d1e8c78de6),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $3ddbed7e0cde1711$var$getDataLoader,
    maxAge: Infinity
});

});
const $146576bfaf2f1c5a$export$54b5a0d1e8c78de6 = 'KB_CONFLUENCE_CONTEXT';

parcelRegister("e8zFB", function(module, exports) {

let $a4ad7b604e7261f3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a4ad7b604e7261f3$var$load("1OYxW").then(()=>parcelRequire('inoGB'));

});


parcelRegister("9NmsS", function(module, exports) {

$parcel$export(module.exports, "getModernIssueTransitionResources", () => $740db98e3f182ede$export$e1afa08027b1e44b);
$parcel$export(module.exports, "getNavigationResources", () => $740db98e3f182ede$export$75cffd1aaecf4a2c);
$parcel$export(module.exports, "getUserBoardNavigationResources", () => $740db98e3f182ede$export$c57dc1ea7f76f91f);
$parcel$export(module.exports, "getNavigationSidebarPlanResources", () => $740db98e3f182ede$export$af2259a87f79645d);
$parcel$export(module.exports, "getNavigationSidebarProductsSettingResource", () => $740db98e3f182ede$export$a103e99ad51f7bc3);
$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $740db98e3f182ede$export$808691f5a412afa3);
// eslint-disable-next-line jira/import-whitelist

var $hTrTW = parcelRequire("hTrTW");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $hHbzj = parcelRequire("hHbzj");

var $3luhJ = parcelRequire("3luhJ");

var $4HvIf = parcelRequire("4HvIf");

var $cY5nO = parcelRequire("cY5nO");

var $43SpR = parcelRequire("43SpR");

var $6JmRt = parcelRequire("6JmRt");

var $8J0lu = parcelRequire("8J0lu");

var $6zXPf = parcelRequire("6zXPf");

var $SPYRa = parcelRequire("SPYRa");

var $5MeEd = parcelRequire("5MeEd");

var $9CgFv = parcelRequire("9CgFv");

var $graie = parcelRequire("graie");

var $4VIcO = parcelRequire("4VIcO");


var $7JXbP = parcelRequire("7JXbP");

var $dRfS0 = parcelRequire("dRfS0");

var $7KVqh = parcelRequire("7KVqh");

var $5yVUD = parcelRequire("5yVUD");

var $aYBjl = parcelRequire("aYBjl");

var $1gbqq = parcelRequire("1gbqq");

var $enHI7 = parcelRequire("enHI7");

var $dfh4P = parcelRequire("dfh4P");

var $5zQIb = parcelRequire("5zQIb");

var $cqUpU = parcelRequire("cqUpU");

var $dZRaT = parcelRequire("dZRaT");

var $2emAF = parcelRequire("2emAF");

var $bvwBX = parcelRequire("bvwBX");

var $68g4a = parcelRequire("68g4a");

var $lb6FK = parcelRequire("lb6FK");

var $cxQGT = parcelRequire("cxQGT");

var $aUy7d = parcelRequire("aUy7d");

var $5L7qx = parcelRequire("5L7qx");

var $5fjzQ = parcelRequire("5fjzQ");

var $l1VxS = parcelRequire("l1VxS");

var $hXbwo = parcelRequire("hXbwo");

var $lzT4f = parcelRequire("lzT4f");
const $740db98e3f182ede$var$inExperimentCohortJiraSideNavMSRExperiment = ()=>{
    // We need to use UNSAFE_noExposureExp to check if jira-side-nav experiment is enabled without firing exposure events
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [sideNavExpConfig] = (0, $epTsa.UNSAFE_noExposureExp)('post_office_jira_side_nav_exp_msr_vs_no_rec');
    return sideNavExpConfig.get('isEnabled', false);
};
const $740db98e3f182ede$var$conditionalPostOfficeJiraSideNavResource = (0, $5L7qx.resourceWithCondition2)(()=>!(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('post_office_ssr_jira_side_nav_enabled') && $740db98e3f182ede$var$inExperimentCohortJiraSideNavMSRExperiment(), (0, $5fjzQ.postOfficeJiraSideNavResource));
const $740db98e3f182ede$var$conditionalPostOfficeJiraSideNav4Resource = (0, $5L7qx.resourceWithCondition2)(()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('post_office_ssr_jira_side_nav_enabled') && (0, $7jTnu.fg)('post-office-jira-side-nav-in-nav4'), (0, $5fjzQ.postOfficeJiraSideNavResource));
const $740db98e3f182ede$var$inGrw1672ExperimentCohortExperiment = ()=>{
    // We need to use UNSAFE_noExposureExp to check if experiment is enabled without firing exposure events
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [config] = (0, $epTsa.UNSAFE_noExposureExp)('grw-1672_display_targeted_jsm_template_cta_in_nav4');
    return config.get('cohort', 'not-enrolled') === 'variation';
};
const $740db98e3f182ede$var$conditionalPostOfficeJiraSideNav4ProjectsSectionResource = (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('post-office-jira-nav4-projects-section') && $740db98e3f182ede$var$inGrw1672ExperimentCohortExperiment(), (0, $5fjzQ.postOfficeNav4ProjectsSectionResource));
const $740db98e3f182ede$var$isModernIssueTransitionSettingEnabled = ()=>{
    return (0, $epTsa.expVal)('jira_issue_transition_screen_modernisation_toggle', 'value', 'OFF') !== 'OFF';
};
const $740db98e3f182ede$var$conditionalGicOptInStatusResource = (0, $5L7qx.resourceWithCondition)(()=>(0, $7jTnu.fg)('render_modern_global_issue_create_modal_experience'), (0, $dRfS0.gicOptInStatusResources));
const $740db98e3f182ede$var$conditionalIssueTransitionOptInStatusResource = (0, $5L7qx.resourceWithCondition)($740db98e3f182ede$var$isModernIssueTransitionSettingEnabled, (0, $aYBjl.issueTransitionOptInStatusResource));
const $740db98e3f182ede$export$e1afa08027b1e44b = ()=>[
        $740db98e3f182ede$var$conditionalIssueTransitionOptInStatusResource,
        (0, $5yVUD.issueTransitionChangeboardingPreferencesResource)
    ];
const $740db98e3f182ede$var$getConditionalOperationsJiraSideNavResource = ()=>(0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_ssr_jira_side_nav_enabled'), (0, $4VIcO.getConsolidationStateResource)(), (0, $l1VxS.createResource)({
        type: `${(0, $f8747ec2695de8a7$export$25ee35b01de9d734)}_NOOP`,
        getKey: ()=>`${0, $f8747ec2695de8a7$export$25ee35b01de9d734}_NOOP`,
        getData: async ()=>null,
        maxAge: Number.MAX_SAFE_INTEGER,
        isBrowserOnly: false
    }));
// There is a best effort duplicate removal in the `getRoutes` function but it
// only works if the resources have the same instance. b/c resourceWithCondition2
// will create a new reference each time it is run, by keeping this outside the
// route factory, we can ensure that the duplicate removal works when it is used
// in multiple places.
const $740db98e3f182ede$var$getDedupableConditionalResources = (isUsingSidebarEntrypoint)=>{
    const resources = [
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $43SpR.sidebarNav4UiStateResource)),
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $8J0lu.topNav4UIStateResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('navx-global-side-nav'), (0, $6JmRt.navPlatformSidebarResource)),
        $740db98e3f182ede$var$getConditionalOperationsJiraSideNavResource()
    ];
    if (isUsingSidebarEntrypoint) // We don't want sidebarNav4Resource loaded for entrypoints otherwise we end up with a client side api call
    // when we don't need it as SSR will have loaded the data already.
    return resources;
    resources.push((0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $43SpR.sidebarNav4Resource)));
    return resources;
};
const $740db98e3f182ede$export$75cffd1aaecf4a2c = ({ isUsingSidebarEntrypoint: isUsingSidebarEntrypoint } = {})=>[
        (0, $dfh4P.navigationUiStateResource),
        (0, $SPYRa.navigationPlansVisibilityResource),
        (0, $aUy7d.userHomepageResource),
        $740db98e3f182ede$var$conditionalGicOptInStatusResource,
        (0, $hTrTW.announcementBannerSettingsV4Resource),
        (0, $5MeEd.getConsentBannerUserPreferencesResource)(),
        (0, $graie.consolidationUserStateResource),
        ...$740db98e3f182ede$var$getDedupableConditionalResources(isUsingSidebarEntrypoint),
        (0, $cxQGT.themePreferenceResource),
        ...$740db98e3f182ede$export$e1afa08027b1e44b(),
        (0, $cqUpU.persistentIssueCreateModalViewResource),
        (0, $7JXbP.gicSmartFieldsFeatureResource),
        (0, $7KVqh.incomingMailServerExpiryStatusResource),
        (0, $lb6FK.rovoEntitlementResource),
        (0, $68g4a.jpdRecommendationDismissedResource),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('blu-3929-sidebar-menu-recommended'), (0, $bvwBX.fetchUserTraitsResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('blu-3929-sidebar-menu-recommended'), (0, $2emAF.fetchSiteTraitsResource)),
        $740db98e3f182ede$var$conditionalPostOfficeJiraSideNavResource,
        $740db98e3f182ede$var$conditionalPostOfficeJiraSideNav4Resource,
        $740db98e3f182ede$var$conditionalPostOfficeJiraSideNav4ProjectsSectionResource,
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jira-glance-panel'), (0, $hXbwo.previewPanelStateResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_gp_announcements_banner'), (0, $lzT4f.jsmGracePeriodAnnouncementDisplayStateResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_gp_announcements_banner'), (0, $lzT4f.jsmGracePeriodAnnouncementGpEndDateResource))
    ];
const $740db98e3f182ede$export$c57dc1ea7f76f91f = ()=>[
        (0, $3luhJ.staticJSWUserBoardSidebarNavigationResource)
    ];
const $740db98e3f182ede$export$af2259a87f79645d = ()=>[
        (0, $4HvIf.staticPlanSidebarNavigationResource)
    ];
const $740db98e3f182ede$export$a103e99ad51f7bc3 = ()=>[
        (0, $enHI7.navigationSidebarGlobalResource),
        (0, $4VIcO.getConsolidationStateResource)(),
        (0, $9CgFv.checkApiKeyManagementKeysResource)()
    ];
const $740db98e3f182ede$export$808691f5a412afa3 = ()=>[
        (0, $5zQIb.newIssueViewTransitionLockInStatusResource),
        (0, $1gbqq.navigationSidebarAutomationLegacyEnabledResource),
        (0, $dZRaT.projectContextResourceWithCache),
        (0, $hHbzj.forgeProjectSettingsModuleResource),
        (0, $cY5nO.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

});
parcelRegister("hTrTW", function(module, exports) {

$parcel$export(module.exports, "announcementBannerSettingsV4Resource", () => $fdbec7ae7de702d4$export$8fbe7f8de07afffd);
$parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", () => $fdbec7ae7de702d4$export$6fb72f4a0c177494);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $afWl0 = parcelRequire("afWl0");

var $aNgkQ = parcelRequire("aNgkQ");

var $4m9Yk = parcelRequire("4m9Yk");
const $fdbec7ae7de702d4$export$2a421cd16fa9a95a = (0, $l1VxS.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $aNgkQ.get)(),
            (0, $4m9Yk.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $fdbec7ae7de702d4$export$8fbe7f8de07afffd = (0, $l1VxS.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $afWl0.get)(),
            (0, $4m9Yk.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000,
    isCritical: true
});
const $fdbec7ae7de702d4$export$43d4950a3e443fd3 = ()=>(0, $eJrcF.useResource)($fdbec7ae7de702d4$export$2a421cd16fa9a95a);
const $fdbec7ae7de702d4$export$6fb72f4a0c177494 = ()=>(0, $eJrcF.useResource)($fdbec7ae7de702d4$export$8fbe7f8de07afffd);

});
parcelRegister("afWl0", function(module, exports) {

$parcel$export(module.exports, "get", () => $a655d50edc5c2e0f$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $a655d50edc5c2e0f$export$adaa4cf7ef1b65be);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $a655d50edc5c2e0f$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $jGzN3.performGetRequest)('/rest/internal/4/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            content: '',
            bgColor: 'grey',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $gYnSx.default)({
            meta: {
                id: 'settingsV4Get',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};
const $a655d50edc5c2e0f$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $jGzN3.performPostRequest)('/rest/internal/4/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'settingsV4Set',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};

});

parcelRegister("aNgkQ", function(module, exports) {

$parcel$export(module.exports, "get", () => $9bda889693371947$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $9bda889693371947$export$adaa4cf7ef1b65be);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

const $9bda889693371947$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $jGzN3.performGetRequest)('/rest/internal/3/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            message: '',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $gYnSx.trackFetchErrors)({
            error: error,
            id: 'settingsGet',
            packageName: (0, $51e9357f231e05fa$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $9bda889693371947$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $jGzN3.performPostRequest)('/rest/internal/3/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.trackFetchErrors)({
            error: error,
            id: 'settingsSet',
            packageName: (0, $51e9357f231e05fa$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
const $51e9357f231e05fa$export$b8b9d90f9e5bd72b = '@jira/admin-pages__system-announcement-banner-resources';
const $51e9357f231e05fa$export$5e0c0e8c940630f8 = 'private';
const $51e9357f231e05fa$export$1d5a5b6462188eb3 = 'public';


parcelRegister("4m9Yk", function(module, exports) {

$parcel$export(module.exports, "get", () => $fff37efd18b27481$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $fff37efd18b27481$export$adaa4cf7ef1b65be);

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

const $fff37efd18b27481$var$key = 'announcementBannerDismissedLast';
const $fff37efd18b27481$export$3988ae62b71be9a3 = async (accoundId)=>{
    try {
        return accoundId != null ? (await (0, $FppkK.getUserProperty)(accoundId, $fff37efd18b27481$var$key)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $gYnSx.trackFetchErrors)({
            error: error,
            id: 'userDismissGet',
            packageName: (0, $51e9357f231e05fa$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $fff37efd18b27481$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
    try {
        return await (0, $FppkK.setUserProperties)(accoundId, $fff37efd18b27481$var$key, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.trackFetchErrors)({
            error: error,
            id: 'userDismissSet',
            packageName: (0, $51e9357f231e05fa$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
parcelRegister("FppkK", function(module, exports) {

$parcel$export(module.exports, "getUserPropertiesUrl", () => $0d0742b19f86216d$export$f474e53c8191800a);
$parcel$export(module.exports, "setUserProperties", () => $0d0742b19f86216d$export$d0e176862bf869b8);
$parcel$export(module.exports, "getUserProperty", () => $0d0742b19f86216d$export$b3126db2ef6e34ed);

var $1uIew = parcelRequire("1uIew");

var $jDtQA = parcelRequire("jDtQA");

var $i4YfB = parcelRequire("i4YfB");

var $7jTnu = parcelRequire("7jTnu");
const $0d0742b19f86216d$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $0d0742b19f86216d$var$getUserPropertiesUrlWithReroute = (accountId, propertyKey)=>{
    const path = $0d0742b19f86216d$export$f474e53c8191800a(accountId, propertyKey);
    return (0, $7jTnu.fg)('magma-3429_banners_in_modern_ssr') ? (0, $i4YfB.getReroutableURL)(path) : path;
};
const $0d0742b19f86216d$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>{
    const url = $0d0742b19f86216d$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, {
        ...(0, $jDtQA.getDefaultOptions)(url),
        method: 'PUT',
        body: data
    });
};
const $0d0742b19f86216d$export$b3126db2ef6e34ed = (accountId, propertyKey)=>{
    const url = $0d0742b19f86216d$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, (0, $jDtQA.getDefaultOptions)(url)).then((res)=>{
        if (res.status === 200) return res.json();
        return res.text().then((errResp)=>{
            throw new (0, $1uIew.default)(res.status, errResp);
        });
    }).then((data)=>data.value);
};
const $0d0742b19f86216d$export$4c4183b491dea321 = (accountId, propertyKey)=>{
    const url = $0d0742b19f86216d$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, {
        ...(0, $jDtQA.getDefaultOptions)(url),
        method: 'DELETE'
    });
};

});
parcelRegister("jDtQA", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $ac99da9d2792d561$export$430a3269e24b912e);

var $3WOLx = parcelRequire("3WOLx");
function $ac99da9d2792d561$export$430a3269e24b912e(url) {
    const options = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-force-account-id': 'true',
            // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ]
        }
    };
    return url ? (0, $3WOLx.applyObservabilityHeaders)(url, options) : options;
}
const $ac99da9d2792d561$export$ba43bf67f3d48107 = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'x-atlassian-force-account-id': 'true',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};

});




parcelRegister("3luhJ", function(module, exports) {

$parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", () => $f503c22a7b6ca0ef$export$5839dd8142de842e);

var $eSnSE = parcelRequire("eSnSE");

var $2at4v = parcelRequire("2at4v");

var $l1VxS = parcelRequire("l1VxS");

var $j3MZT = parcelRequire("j3MZT");
const $f503c22a7b6ca0ef$export$5839dd8142de842e = (0, $l1VxS.createResource)({
    type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $2at4v.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $2at4v.getBoardId)(match, query);
        if (boardId == null) return null;
        try {
            const response = await (0, $j3MZT.fetchUserBoardNavigationData)(boardId);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
            return null;
        }
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("j3MZT", function(module, exports) {

$parcel$export(module.exports, "fetchUserBoardNavigationData", () => $071e1177268b0d4d$export$306fb49fca60b34);

var $jGzN3 = parcelRequire("jGzN3");
const $071e1177268b0d4d$export$306fb49fca60b34 = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $jGzN3.performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
};

});


parcelRegister("4HvIf", function(module, exports) {

$parcel$export(module.exports, "staticPlanSidebarNavigationResource", () => $88524b29244ca76c$export$e7e6c1b9d8d5ea7);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $l1VxS = parcelRequire("l1VxS");

var $4q1H4 = parcelRequire("4q1H4");
const $88524b29244ca76c$var$getRouterKey = (match)=>{
    if (match.url.includes('/plans/')) return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
    return 'none';
};
const $88524b29244ca76c$export$e7e6c1b9d8d5ea7 = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
    getKey: ({ match: match })=>$88524b29244ca76c$var$getRouterKey(match),
    getData: async ({ match: { params: { planId: planId, scenarioId: scenarioId } } })=>{
        if (planId == null || scenarioId == null) return null;
        return (0, $4q1H4.fetchPlanSidebarNavInfo)(planId, scenarioId);
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("4q1H4", function(module, exports) {

$parcel$export(module.exports, "fetchPlanSidebarNavInfo", () => $9360532f5ab456b0$export$a49729698cfc5310);

var $jGzN3 = parcelRequire("jGzN3");
const $9360532f5ab456b0$var$requestSideBarInfo = (planId, scenarioId)=>(0, $jGzN3.performGetRequest)(`/rest/jpo/1.0/navigation/plans/${planId}/scenarios/${scenarioId}`);
const $9360532f5ab456b0$export$a49729698cfc5310 = (planId, scenarioId)=>{
    if (planId == null || planId.trim() === '') throw new Error('Plan cannot be loaded without a planId');
    if (scenarioId == null || scenarioId.trim() === '') throw new Error('Plan cannot be loaded without a scenarioId');
    return $9360532f5ab456b0$var$requestSideBarInfo(planId, scenarioId);
};

});


parcelRegister("cY5nO", function(module, exports) {

$parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", () => $8255136ae0c43529$export$e4bf33528101348c);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", () => $8255136ae0c43529$export$2d5a704ae6f6b050);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $jfYJb = parcelRequire("jfYJb");
const $8255136ae0c43529$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $8255136ae0c43529$export$e4bf33528101348c = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$8255136ae0c43529$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $8255136ae0c43529$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jfYJb.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
        return navInfo;
    },
    maxAge: 300000,
    isCritical: true
});
const $8255136ae0c43529$export$2d5a704ae6f6b050 = ()=>(0, $eJrcF.useResource)($8255136ae0c43529$export$e4bf33528101348c);

});

parcelRegister("43SpR", function(module, exports) {

$parcel$export(module.exports, "sidebarNav4Resource", () => $dbd1c384f9b07eb1$export$7648dc6f76f4f83d);
$parcel$export(module.exports, "sidebarNav4UiStateResource", () => $dbd1c384f9b07eb1$export$a46129bd512544d7);

var $h4Bzb = parcelRequire("h4Bzb");

var $kWbWF = parcelRequire("kWbWF");

var $b1DBy = parcelRequire("b1DBy");

var $9FYIg = parcelRequire("9FYIg");

var $bBIDB = parcelRequire("bBIDB");

var $hOoYL = parcelRequire("hOoYL");

var $fKh2A = parcelRequire("fKh2A");

var $7Cu03 = parcelRequire("7Cu03");
const $dbd1c384f9b07eb1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
const $dbd1c384f9b07eb1$export$7648dc6f76f4f83d = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${$dbd1c384f9b07eb1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId, activationId: activationId, atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const initialSelectedPath = (0, $kWbWF.getInitialSelectedPath)(routerContext);
        return {
            parameters: (0, $bBIDB.default),
            variables: {
                cloudId: cloudId,
                isAppsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_APPS)),
                isFiltersExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_OPERATIONS)),
                isOverviewsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_OVERVIEWS)),
                entityAriProjects: (0, $fKh2A.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'projects'
                }).toString(),
                ownerAri: atlassianAccountId && (0, $7Cu03.IdentityUserAri).create({
                    userId: atlassianAccountId
                }).toString(),
                isAnonymous: isAnonymous
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    },
    isCritical: true
});
const $dbd1c384f9b07eb1$export$a46129bd512544d7 = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_SIDEBAR_V2_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $hOoYL.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true
});

});
parcelRegister("h4Bzb", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_APP_MENU_ID", () => $330926e53d81707a$export$1bb3d16bc95080e3);
$parcel$export(module.exports, "GLOBAL_APP_MENU_ID_TO_APS_KEY", () => $330926e53d81707a$export$3b4ca8d4d769a311);
$parcel$export(module.exports, "CONFIGURABLE_MENU_ID", () => $330926e53d81707a$export$7838b734e4cd5e8d);
$parcel$export(module.exports, "ENTITY_ID", () => $330926e53d81707a$export$103ff18fe29ee1b);
$parcel$export(module.exports, "MENU_ID_APPS", () => $330926e53d81707a$export$441cd608ea3204f4);
$parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", () => $330926e53d81707a$export$5baa9c2e3c3931c5);
$parcel$export(module.exports, "MENU_ID_ASSETS", () => $330926e53d81707a$export$75c65bfc98b3a6e1);
$parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", () => $330926e53d81707a$export$8a0af92d49f1d13d);
$parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", () => $330926e53d81707a$export$a09300d15acc958a);
$parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", () => $330926e53d81707a$export$4d718fbd418eef5c);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS", () => $330926e53d81707a$export$dd009509c2dabb5e);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", () => $330926e53d81707a$export$d3da0455b4200fb2);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", () => $330926e53d81707a$export$b9dd2b5309d19763);
$parcel$export(module.exports, "MENU_ID_FILTERS", () => $330926e53d81707a$export$3d81af172a8e3c57);
$parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", () => $330926e53d81707a$export$1e2599eaf0039a97);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", () => $330926e53d81707a$export$53d274d993c9d5b5);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", () => $330926e53d81707a$export$7661ea763be69cfa);
$parcel$export(module.exports, "MENU_ID_GOALS", () => $330926e53d81707a$export$47c6ce6a83a59eab);
$parcel$export(module.exports, "MENU_ID_OPERATIONS", () => $330926e53d81707a$export$ef89639b7d9c162a);
$parcel$export(module.exports, "MENU_ID_OPS_ALERTS", () => $330926e53d81707a$export$af4ab6d4e920522a);
$parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", () => $330926e53d81707a$export$25c40acb2c53a294);
$parcel$export(module.exports, "MENU_ID_OPS_REPORTS", () => $330926e53d81707a$export$c7d8892f1628b844);
$parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", () => $330926e53d81707a$export$bb19a52e3df99541);
$parcel$export(module.exports, "MENU_ID_OVERVIEWS", () => $330926e53d81707a$export$3bd12c092f8db11b);
$parcel$export(module.exports, "MENU_ID_COMMUNICATION", () => $330926e53d81707a$export$feed0c05fb1a4af);
$parcel$export(module.exports, "MENU_ID_PLANS", () => $330926e53d81707a$export$f2533da33c749933);
$parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", () => $330926e53d81707a$export$8468c5b6648f4f1f);
$parcel$export(module.exports, "MENU_ID_PROJECT_APPS", () => $330926e53d81707a$export$fed17b4c0866b97d);
$parcel$export(module.exports, "MENU_ID_PROJECTS", () => $330926e53d81707a$export$9c5278bd360a285);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", () => $330926e53d81707a$export$85389c606bb641dd);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", () => $330926e53d81707a$export$4a1974b63c858e9c);
$parcel$export(module.exports, "MENU_ID_RECENT", () => $330926e53d81707a$export$692b796030a796f3);
$parcel$export(module.exports, "MENU_ID_ROADMAPS", () => $330926e53d81707a$export$cdc80d4b5ce0c6a);
$parcel$export(module.exports, "MENU_ID_ROADMAPS_VIEW_ALL", () => $330926e53d81707a$export$7606c0134aabf3d7);
$parcel$export(module.exports, "MENU_ID_STARRED", () => $330926e53d81707a$export$5637ca42a4d77f32);
$parcel$export(module.exports, "MENU_ID_TEAMS", () => $330926e53d81707a$export$d4f6fcf571f9c50);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE", () => $330926e53d81707a$export$11fcdf33179ef88e);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_HUBS", () => $330926e53d81707a$export$d69bec513af84431);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE_ANALYTICS", () => $330926e53d81707a$export$1d260f51eeaab73d);
$parcel$export(module.exports, "MENU_ID_YOUR_WORK", () => $330926e53d81707a$export$80dc576e446bdb6b);
$parcel$export(module.exports, "MENU_ID_FOR_YOU", () => $330926e53d81707a$export$c68b73f0d8c14f41);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_ASSETS", () => $330926e53d81707a$export$5aa3e4dd37f372d5);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_GOALS", () => $330926e53d81707a$export$7986b535c183c592);
$parcel$export(module.exports, "MENU_ID_COMMUNICATIONS_STAKEHOLDERS", () => $330926e53d81707a$export$784c436fb3f51c19);
$parcel$export(module.exports, "MENU_ID_OPS_STATUS_PAGES", () => $330926e53d81707a$export$151c003f483b38);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_CONFLUENCE", () => $330926e53d81707a$export$c093b87743053085);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_LOOM", () => $330926e53d81707a$export$e316a54b33dbe500);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_PROJECTS", () => $330926e53d81707a$export$8ceb414d866f12fc);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_TEAMS", () => $330926e53d81707a$export$804187987544d0f8);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_OPSGENIE", () => $330926e53d81707a$export$83352ab9064f1723);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", () => $330926e53d81707a$export$79c15668ed799a1b);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", () => $330926e53d81707a$export$e299bb06c4370c0d);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", () => $330926e53d81707a$export$713b9b0a69a79cf9);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", () => $330926e53d81707a$export$f1d9c0f27216aa1c);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", () => $330926e53d81707a$export$45763fa331781074);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", () => $330926e53d81707a$export$6ee20c845dbab3e3);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", () => $330926e53d81707a$export$b3815dd180ce5e61);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", () => $330926e53d81707a$export$100a1a639a0db980);
const $330926e53d81707a$export$1bb3d16bc95080e3 = {
    GLOBAL_APP_GOALS: 'jira.sidebar.globalApp.goals',
    GLOBAL_APP_ASSETS: 'jira.sidebar.globalApp.assets',
    // Global App Shortcuts for Platform Component
    GLOBAL_APP_CONFLUENCE: 'jira.sidebar.globalApp.confluence',
    GLOBAL_APP_LOOM: 'jira.sidebar.globalApp.loom',
    GLOBAL_APP_PROJECTS: 'jira.sidebar.globalApp.projects',
    GLOBAL_APP_TEAMS: 'jira.sidebar.globalApp.teams',
    GLOBAL_APP_OPSGENIE: 'jira.sidebar.globalApp.opsgenie'
};
const $330926e53d81707a$export$3b4ca8d4d769a311 = {
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_CONFLUENCE]: 'CONFLUENCE',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_LOOM]: 'LOOM',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_GOALS]: 'GOALS',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_PROJECTS]: 'PROJECTS',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_TEAMS]: 'TEAMS',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_OPSGENIE]: 'OPSGENIE'
};
const $330926e53d81707a$export$7838b734e4cd5e8d = {
    APPS: 'jira.sidebar.apps',
    ASSETS: 'jira.sidebar.assets',
    DASHBOARDS: 'jira.sidebar.dashboards',
    FILTERS: 'jira.sidebar.filters',
    GOALS: 'jira.sidebar.goals',
    OPERATIONS: 'jira.sidebar.operations',
    COMMUNICATION: 'jira.sidebar.communication',
    OVERVIEWS: 'jira.sidebar.overviews',
    PLANS: 'jira.sidebar.plans',
    PROJECTS: 'jira.sidebar.projects',
    RECENT: 'jira.sidebar.recent',
    STARRED: 'jira.sidebar.starred',
    TEAMS: 'jira.sidebar.teams',
    ROADMAPS: 'jira.sidebar.roadmaps',
    CUSTOMER_SERVICE: 'jira.sidebar.customerService',
    CUSTOMER_HUBS: 'jira.sidebar.customerHubs',
    CUSTOMER_SERVICE_ANALYTICS: 'jira.sidebar.customerServiceAnalytics',
    ...$330926e53d81707a$export$1bb3d16bc95080e3
};
const $330926e53d81707a$export$103ff18fe29ee1b = {
    ALARM_QUEUE: (id)=>`alrm_${id}`,
    APP: (id)=>`app_${id}`,
    BOARD: (id)=>`boar_${id}`,
    DASHBOARD: (id)=>`dash_${id}`,
    FILTER: (id)=>`filt_${id}`,
    FORM: (id)=>`form_${id}`,
    OVERVIEW: (id)=>`over_${id}`,
    PLAN: (id)=>`plan_${id}`,
    PROJECT: (id)=>`proj_${id}`,
    PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
    PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
    PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
    PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
    PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
    PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
    PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
    PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
    PROJECT_OPERATIONS: (projectKey)=>`proj-${projectKey}-ops`,
    PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
    PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
    PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
    PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
    PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
    PROJECT_DASHBOARDS: (projectKey)=>`proj-${projectKey}-dashboards`,
    PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
    PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
    PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
    ROADMAP: (id)=>`roadmap_${id}`,
    QUEUE: (id)=>`queu_${id}`,
    ISSUE: (id)=>`issue_${id}`,
    ARCHIVED_WORK_ITEMS: (id)=>`archived_work_items_${id}`,
    PROJECT_ROVO_AGENT: (projectKey)=>`proj-${projectKey}-rovo-agent`
}; // We MUST use the same IDs for the same components, otherwise we run into trouble (especially with peeking / more-menu)
const $330926e53d81707a$export$441cd608ea3204f4 = $330926e53d81707a$export$7838b734e4cd5e8d.APPS;
const $330926e53d81707a$export$5baa9c2e3c3931c5 = 'app_mrkt';
const $330926e53d81707a$export$75c65bfc98b3a6e1 = $330926e53d81707a$export$7838b734e4cd5e8d.ASSETS;
const $330926e53d81707a$export$8a0af92d49f1d13d = 'asst_schm';
const $330926e53d81707a$export$a09300d15acc958a = 'asst_rprt';
const $330926e53d81707a$export$4d718fbd418eef5c = 'board-view-all';
const $330926e53d81707a$export$dd009509c2dabb5e = $330926e53d81707a$export$7838b734e4cd5e8d.DASHBOARDS;
const $330926e53d81707a$export$d3da0455b4200fb2 = 'dash-view';
const $330926e53d81707a$export$b9dd2b5309d19763 = 'dash-view-starred';
const $330926e53d81707a$export$3d81af172a8e3c57 = $330926e53d81707a$export$7838b734e4cd5e8d.FILTERS;
const $330926e53d81707a$export$1e2599eaf0039a97 = 'filt-search';
const $330926e53d81707a$export$53d274d993c9d5b5 = 'filt-view-all';
const $330926e53d81707a$export$7661ea763be69cfa = 'filt-view-starred';
const $330926e53d81707a$export$47c6ce6a83a59eab = $330926e53d81707a$export$7838b734e4cd5e8d.GOALS;
const $330926e53d81707a$export$ef89639b7d9c162a = $330926e53d81707a$export$7838b734e4cd5e8d.OPERATIONS;
const $330926e53d81707a$export$af4ab6d4e920522a = 'ops-alrt';
const $330926e53d81707a$export$25c40acb2c53a294 = 'ops-over';
const $330926e53d81707a$export$c7d8892f1628b844 = 'ops-rprt';
const $330926e53d81707a$export$bb19a52e3df99541 = 'ops-oncl';
const $330926e53d81707a$export$3bd12c092f8db11b = $330926e53d81707a$export$7838b734e4cd5e8d.OVERVIEWS;
const $330926e53d81707a$export$feed0c05fb1a4af = $330926e53d81707a$export$7838b734e4cd5e8d.COMMUNICATION;
const $330926e53d81707a$export$f2533da33c749933 = $330926e53d81707a$export$7838b734e4cd5e8d.PLANS;
const $330926e53d81707a$export$8468c5b6648f4f1f = 'plan-view-all';
const $330926e53d81707a$export$fed17b4c0866b97d = 'proj-app';
const $330926e53d81707a$export$9c5278bd360a285 = $330926e53d81707a$export$7838b734e4cd5e8d.PROJECTS;
const $330926e53d81707a$export$85389c606bb641dd = 'proj-view-all';
const $330926e53d81707a$export$4a1974b63c858e9c = 'proj-view-starred';
const $330926e53d81707a$export$692b796030a796f3 = $330926e53d81707a$export$7838b734e4cd5e8d.RECENT;
const $330926e53d81707a$export$cdc80d4b5ce0c6a = $330926e53d81707a$export$7838b734e4cd5e8d.ROADMAPS;
const $330926e53d81707a$export$7606c0134aabf3d7 = 'roadmaps-view-all';
const $330926e53d81707a$export$5637ca42a4d77f32 = $330926e53d81707a$export$7838b734e4cd5e8d.STARRED;
const $330926e53d81707a$export$d4f6fcf571f9c50 = $330926e53d81707a$export$7838b734e4cd5e8d.TEAMS;
const $330926e53d81707a$export$11fcdf33179ef88e = $330926e53d81707a$export$7838b734e4cd5e8d.CUSTOMER_SERVICE;
const $330926e53d81707a$export$d69bec513af84431 = $330926e53d81707a$export$7838b734e4cd5e8d.CUSTOMER_HUBS;
const $330926e53d81707a$export$1d260f51eeaab73d = $330926e53d81707a$export$7838b734e4cd5e8d.CUSTOMER_SERVICE_ANALYTICS;
const $330926e53d81707a$export$80dc576e446bdb6b = 'yrwk';
const $330926e53d81707a$export$c68b73f0d8c14f41 = 'for-you';
const $330926e53d81707a$export$5aa3e4dd37f372d5 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_ASSETS;
const $330926e53d81707a$export$7986b535c183c592 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_GOALS;
const $330926e53d81707a$export$784c436fb3f51c19 = 'comm-stkhldr';
const $330926e53d81707a$export$205988f610130417 = 'comm-stkhldr-grp';
const $330926e53d81707a$export$151c003f483b38 = 'ops-status-pages';
const $330926e53d81707a$export$c093b87743053085 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_CONFLUENCE;
const $330926e53d81707a$export$e316a54b33dbe500 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_LOOM;
const $330926e53d81707a$export$8ceb414d866f12fc = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_PROJECTS;
const $330926e53d81707a$export$804187987544d0f8 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_TEAMS;
const $330926e53d81707a$export$83352ab9064f1723 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_OPSGENIE;
const $330926e53d81707a$export$79c15668ed799a1b = 'sd-sett-acc';
const $330926e53d81707a$export$e299bb06c4370c0d = 'sd-sett-req-man';
const $330926e53d81707a$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
const $330926e53d81707a$export$f1d9c0f27216aa1c = 'sd-sett-aut';
const $330926e53d81707a$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
const $330926e53d81707a$export$6ee20c845dbab3e3 = 'sd-sett-not';
const $330926e53d81707a$export$b3815dd180ce5e61 = 'sd-sett-apps';
const $330926e53d81707a$export$100a1a639a0db980 = 'sd-sett-ops';

});

parcelRegister("kWbWF", function(module, exports) {

$parcel$export(module.exports, "getInitialSelectedPath", () => $6793867fe071cdbb$export$39f409bc5f59c5e);
/**
 * Why do we need the initialSelectedPath? It all stems from the workaround that Nav4 uses
 * to SSR the initial sidebar semi-correctly, while pretending to lazy-load everything else.
 *
 * Ideally we would be able to pre-load entrypoints that we know we need to load, and lazy-load
 * the rest. This would support SSR and be performant.
 * Unfortunately, unless all of the Jira routes are loaded via entry-points, we cannot use this approach.
 *
 * The workaround is to use Relay variables to tell Relay what data to preload, and then load
 * the corresponding UI component directly (not via an entrypoint) when we have the data for it.
 * When we don't have the preloaded data, we lazy load __the same component via an entrypoint__.
 * In other words, we sacrifice bundle size (by directly including the component for the data-available
 * case), in order to get SSR benefits.
 *
 * A consequence of this approach is we have two versions of the top-level menu item components - the
 * regular version (called *Landing) and the entrypoint version (called *Default). When navigating,
 * the router's state would change, causing the components to switch around. In the UI, this would
 * cause ExpandableMenuItem components to collapse, when they were open before navigating.
 *
 * To work around THIS problem, we store a computed-version of the initial state of the router, and
 * then query this value when deciding which component to show (the *Landing or the *Default). Because if
 * the initial state doesn't change, our components won't switch around after the first render.
 */ 
var $bx11l = parcelRequire("bx11l");

var $kg9Uh = parcelRequire("kg9Uh");
const $6793867fe071cdbb$export$39f409bc5f59c5e = (0, (/*@__PURE__*/$parcel$interopDefault($bx11l)))((0, $kg9Uh.routeToSelectedPath));

});
parcelRegister("kg9Uh", function(module, exports) {

$parcel$export(module.exports, "routeToSelectedPath", () => $b1359280a8973d4c$export$a92474c098a1fd13);
$parcel$export(module.exports, "useRouteToSelectedPath", () => $b1359280a8973d4c$export$a086f1986cac3253);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $7jTnu = parcelRequire("7jTnu");

var $kfvK2 = parcelRequire("kfvK2");

var $K1AKP = parcelRequire("K1AKP");

var $5APJC = parcelRequire("5APJC");

var $bb1Lz = parcelRequire("bb1Lz");

var $hXLQ4 = parcelRequire("hXLQ4");

var $gUBBs = parcelRequire("gUBBs");

var $7ened = parcelRequire("7ened");

var $kyqLB = parcelRequire("kyqLB");

var $3NLYz = parcelRequire("3NLYz");

var $eC071 = parcelRequire("eC071");

var $3233g = parcelRequire("3233g");

var $nPGhK = parcelRequire("nPGhK");

var $7krAP = parcelRequire("7krAP");

var $6ofXP = parcelRequire("6ofXP");
function $b1359280a8973d4c$export$a92474c098a1fd13(routeContext) {
    const routeName = routeContext.route.name;
    if ((0, $kyqLB.topLevelConverter).routes.has(routeName)) return (0, $kyqLB.topLevelConverter).convert(routeContext);
    if ((0, $K1AKP.appsConverter).routes.has(routeName)) return (0, $K1AKP.appsConverter).convert(routeContext);
    if ((0, $5APJC.assetsConverter).routes.has(routeName)) return (0, $5APJC.assetsConverter).convert(routeContext);
    if ((0, $bb1Lz.dashboardsConverter).routes.has(routeName)) return (0, $bb1Lz.dashboardsConverter).convert(routeContext);
    if ((0, $hXLQ4.filtersConverter).routes.has(routeName)) return (0, $hXLQ4.filtersConverter).convert(routeContext);
    if ((0, $gUBBs.operationsConverter).routes.has(routeName)) return (0, $gUBBs.operationsConverter).convert(routeContext);
    if ((0, $7ened.communicationsConverter).routes.has(routeName)) return (0, $7ened.communicationsConverter).convert(routeContext);
    if ((0, $3NLYz.overviewsConverter).routes.has(routeName)) return (0, $3NLYz.overviewsConverter).convert(routeContext);
    if ((0, $3NLYz.overviewsConverter).routes.has(routeName)) return (0, $3NLYz.overviewsConverter).convert(routeContext);
    if ((0, $eC071.plansConverter).routes.has(routeName)) return (0, $eC071.plansConverter).convert(routeContext);
    if ((0, $3233g.projectsConverter).routes.has(routeName)) return (0, $3233g.projectsConverter).convert(routeContext);
    if ((0, $nPGhK.roadmapsConverter).routes.has(routeName)) return (0, $nPGhK.roadmapsConverter).convert(routeContext);
    if ((0, $7krAP.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $7krAP.serviceManagementProjectSettingsConverter).convert(routeContext);
    if ((0, $7jTnu.fg)('jcs_master_flag')) {
        if ((0, $6ofXP.customerServiceConverter).routes.has(routeName)) return (0, $6ofXP.customerServiceConverter).convert(routeContext);
    }
    return [];
}
function $b1359280a8973d4c$export$216c13b87ae41e0b(state) {
    const routeName = state.route.name;
    const match = state.match;
    const query = state.query;
    if ((0, $kyqLB.topLevelConverter).routes.has(routeName)) return (0, $kyqLB.topLevelConverter).convertNew({
        routeName: routeName
    });
    if ((0, $K1AKP.appsConverter).routes.has(routeName)) return (0, $K1AKP.appsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $5APJC.assetsConverter).routes.has(routeName)) return (0, $5APJC.assetsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $bb1Lz.dashboardsConverter).routes.has(routeName)) return (0, $bb1Lz.dashboardsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $hXLQ4.filtersConverter).routes.has(routeName)) return (0, $hXLQ4.filtersConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $gUBBs.operationsConverter).routes.has(routeName)) return (0, $gUBBs.operationsConverter).convertNew({
        routeName: routeName,
        query: query
    });
    if ((0, $7ened.communicationsConverter).routes.has(routeName)) return (0, $7ened.communicationsConverter).convertNew({
        routeName: routeName,
        query: query
    });
    if ((0, $3NLYz.overviewsConverter).routes.has(routeName)) return (0, $3NLYz.overviewsConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $eC071.plansConverter).routes.has(routeName)) return (0, $eC071.plansConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $3233g.projectsConverter).routes.has(routeName)) return (0, $3233g.projectsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $nPGhK.roadmapsConverter).routes.has(routeName)) return (0, $nPGhK.roadmapsConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $7krAP.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $7krAP.serviceManagementProjectSettingsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $7jTnu.fg)('jcs_master_flag')) {
        if ((0, $6ofXP.customerServiceConverter).routes.has(routeName)) return (0, $6ofXP.customerServiceConverter).convertNew({
            routeName: routeName
        });
    }
    return [];
}
function $b1359280a8973d4c$export$8eb45058a3aef67f() {
    return (0, $eJOHy.useState)(()=>{
        const selectedPath = $b1359280a8973d4c$export$216c13b87ae41e0b((0, $kfvK2.getRouterState)());
        return {
            initialSelectedPath: selectedPath,
            selectedPath: selectedPath
        };
    });
}
function $b1359280a8973d4c$export$a086f1986cac3253() {
    const [selectedPathData, setSelectedPathData] = $b1359280a8973d4c$export$8eb45058a3aef67f();
    (0, $eJOHy.useEffect)(()=>(0, $kfvK2.addRouteListener)((state)=>{
            const nextSelectedPath = $b1359280a8973d4c$export$216c13b87ae41e0b(state);
            const pathIsDifferent = (0, $7jTnu.fg)('jira-concurrent-nav4-fix-selected-path') ? !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(nextSelectedPath, selectedPathData.selectedPath) // Since this is an array and not a primitive, we need to do an isEqual check
             : nextSelectedPath !== selectedPathData.selectedPath;
            if (pathIsDifferent) setSelectedPathData({
                initialSelectedPath: selectedPathData.initialSelectedPath,
                selectedPath: nextSelectedPath
            });
        }), [
        selectedPathData.initialSelectedPath,
        selectedPathData.selectedPath,
        setSelectedPathData
    ]);
    return selectedPathData;
}

});
parcelRegister("K1AKP", function(module, exports) {

$parcel$export(module.exports, "appsConverter", () => $e565dec3d2a1a779$export$d017a63045c88c47);

var $h4Bzb = parcelRequire("h4Bzb");
// TODO: verify these routes
const $e565dec3d2a1a779$var$UNCERTAIN_APPS_SECTION_ROUTES = [
    'connect-general',
    'connect-general-invalid',
    'legacy-connect-general',
    'legacy-connect-project',
    /**
	 * This one tricky, and I wish it was documented somewhere, so here you go:
	 * Among different Connect app types, there are global Connect apps and JSM Connect apps (project apps).
	 * The URL of the global app looks like this:
	 *   `/plugins/servlet/ac/catlassian/catlassian-page?project.key=IP&project.id=10154`
	 * The URL of the JSM project app looks like this (there is also another URL pattern, but it is not relevant to this case):
	 *   `/plugins/servlet/ac/catlassian/catlassian-page-A?project.key=IP&project.id=10154&servicedesk.serviceDeskId=31`
	 * They have different route names and differ only by the `servicedesk.serviceDeskId` query parameter.
	 * But here's the catch: the global app URL can also contain a `servicedesk.serviceDeskId` query parameter,
	 * it is enough for the user to navigate to a specific JSM route in order for that JSM project to be saved as the most recent project,
	 * and it looks like Connect adds that most recent project context to the URL.
	 * Once that happens, the global app route is no longer matched, the JSM one is, which brings a lot of confusion since at this point
	 * we have no idea whether the "Apps" section should be expanded or the "Projects" one, since it is possible the app lives in either of those.
	 * You can navigate to the JSW project in order to override the JSM one and that query param will disappear from the global app URL.
	 * So what we are doing here? We are adding the route to the list of global Connect apps (just like its route name suggests) and potentially return a false positive value.
	 * Later on in the code we are going to check whether the app is global or not based on the data we have (the list of apps) and fix that.
	 */ 'connect-general-service-desk-project',
    'connect-project'
];
const $e565dec3d2a1a779$var$CERTAIN_APPS_SECTION_ROUTES = [
    'forge-spa-global',
    'marketplace-index',
    'forge-spa-personal-settings'
];
const $e565dec3d2a1a779$export$66b32f6f30eb4b4 = new Set([
    ...$e565dec3d2a1a779$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$e565dec3d2a1a779$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $e565dec3d2a1a779$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_APPS)
    ];
    return $e565dec3d2a1a779$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $e565dec3d2a1a779$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_APPS)
    ];
    return $e565dec3d2a1a779$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $e565dec3d2a1a779$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'marketplace-index':
            path.push((0, $h4Bzb.MENU_ID_APP_MARKETPLACE_DISCOVER));
            break;
        case 'connect-general':
        case 'connect-general-invalid':
        case 'forge-spa-global':
        case 'forge-spa-personal-settings':
        case 'legacy-connect-general':
            path.push((0, $h4Bzb.ENTITY_ID).APP(match.url.replace(/\/$/, '')));
            break;
        case 'connect-project':
        case 'legacy-connect-project':
            {
                const { projectKey: projectKey } = match.params;
                return [
                    (0, $h4Bzb.MENU_ID_PROJECTS),
                    (0, $h4Bzb.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        case 'connect-general-service-desk-project':
            {
                const { projectKey: projectKey } = query;
                return [
                    (0, $h4Bzb.MENU_ID_PROJECTS),
                    (0, $h4Bzb.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        default:
            break;
    }
    return path;
}
const $e565dec3d2a1a779$export$d017a63045c88c47 = {
    routes: $e565dec3d2a1a779$export$66b32f6f30eb4b4,
    convert: $e565dec3d2a1a779$var$convert,
    convertNew: $e565dec3d2a1a779$var$convertNew
};

});

parcelRegister("5APJC", function(module, exports) {

$parcel$export(module.exports, "assetsConverter", () => $9795614a2d6fbb83$export$6cfeba0849032a84);

var $h4Bzb = parcelRequire("h4Bzb");
const $9795614a2d6fbb83$var$routes = new Set([
    'assets',
    'assets-configure',
    'assets-data-manager-getting-started',
    'assets-data-manager-object-classes',
    'assets-data-manager-data-source',
    'assets-data-manager-object-class-view',
    'assets-object',
    'assets-schema',
    'assets-schema-configuration',
    'assets-object-type-configuration',
    'assets-reports',
    'assets-reports-default-redirect',
    'assets-reports-unsubscribe',
    'assets-analytics-data-view-create',
    'assets-analytics-data-view-details',
    'assets-analytics-data-view-list',
    'servicedesk-cmdb-assets',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration',
    'servicedesk-cmdb-assets-reports',
    'servicedesk-cmdb-assets-reports-default-redirect',
    'servicedesk-cmdb-assets-reports-unsubscribe',
    'servicedesk-cmdb-insight',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration',
    'servicedesk-cmdb-assets-analytics-data-view-create',
    'servicedesk-cmdb-assets-analytics-data-view-details',
    'servicedesk-cmdb-assets-analytics-data-view-list'
]);
function $9795614a2d6fbb83$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [
        (0, $h4Bzb.MENU_ID_ASSETS)
    ];
    return $9795614a2d6fbb83$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $9795614a2d6fbb83$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_ASSETS)
    ];
    return $9795614a2d6fbb83$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $9795614a2d6fbb83$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'servicedesk-cmdb-assets':
        case 'servicedesk-cmdb-object':
        case 'servicedesk-cmdb-object-schema':
        case 'servicedesk-cmdb-object-schema-configuration':
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $h4Bzb.MENU_ID_ASSETS_SCHEMAS));
            break;
        // Duplicate route-names of the above routes
        // eslint-disable-next-line no-duplicate-case
        case 'servicedesk-cmdb-object':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema-configuration':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $h4Bzb.MENU_ID_ASSETS_SCHEMAS));
            break;
        case 'servicedesk-cmdb-assets-reports':
        case 'servicedesk-cmdb-assets-reports-default-redirect':
        case 'servicedesk-cmdb-assets-reports-unsubscribe':
        case 'servicedesk-cmdb-assets-analytics-data-view-create':
        case 'servicedesk-cmdb-assets-analytics-data-view-details':
        case 'servicedesk-cmdb-assets-analytics-data-view-list':
            path.push((0, $h4Bzb.MENU_ID_ASSETS_REPORTS));
            break;
        default:
            break;
    }
    return path;
}
const $9795614a2d6fbb83$export$6cfeba0849032a84 = {
    routes: $9795614a2d6fbb83$var$routes,
    convert: $9795614a2d6fbb83$var$convert,
    convertNew: $9795614a2d6fbb83$var$convertNew
};

});

parcelRegister("bb1Lz", function(module, exports) {

$parcel$export(module.exports, "dashboardsConverter", () => $6dd0e62f793ca557$export$6468819b4be328b1);

var $h4Bzb = parcelRequire("h4Bzb");
const $6dd0e62f793ca557$var$routes = new Set([
    'dashboards-directory',
    'dashboard-edit',
    'dashboard-view',
    'dashboard-wallboard'
]);
function $6dd0e62f793ca557$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_DASHBOARDS)
    ];
    return $6dd0e62f793ca557$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $6dd0e62f793ca557$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_DASHBOARDS)
    ];
    return $6dd0e62f793ca557$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $6dd0e62f793ca557$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'dashboards-directory':
            path.push((0, $h4Bzb.MENU_ID_DASHBOARDS_VIEW_ALL));
            break;
        case 'dashboard-wallboard':
            query.dashboardId && path.push((0, $h4Bzb.ENTITY_ID).DASHBOARD(query.dashboardId));
            break;
        default:
            {
                const dashboardId = match.params.dashboardId;
                if (dashboardId === 'last-visited') // This is not really correct. The problem is we cannot tell what the true dashboardId is in this case.
                path.push((0, $h4Bzb.MENU_ID_DASHBOARDS_VIEW_ALL));
                else dashboardId && path.push((0, $h4Bzb.ENTITY_ID).DASHBOARD(dashboardId));
                break;
            }
    }
    return path;
}
const $6dd0e62f793ca557$export$6468819b4be328b1 = {
    routes: $6dd0e62f793ca557$var$routes,
    convert: $6dd0e62f793ca557$var$convert,
    convertNew: $6dd0e62f793ca557$var$convertNew
};

});

parcelRegister("hXLQ4", function(module, exports) {

$parcel$export(module.exports, "filtersConverter", () => $54344df55ab10983$export$6e91331b5debb7c8);

var $h4Bzb = parcelRequire("h4Bzb");
const $54344df55ab10983$var$routes = new Set([
    'filters-directory',
    'global-issue-navigator',
    'global-issue-navigator-browse-issue-redirect',
    'issue',
    'legacy-gin',
    'legacy-gin-issue',
    'legacy-gin-subscriptions',
    'work-item'
]);
function $54344df55ab10983$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query, match: match } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_FILTERS)
    ];
    return $54344df55ab10983$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $54344df55ab10983$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_FILTERS)
    ];
    return $54344df55ab10983$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $54344df55ab10983$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'filters-directory':
            path.push((0, $h4Bzb.MENU_ID_FILTERS_VIEW_ALL));
            break;
        case 'issue':
            {
                const filterId = query.filter || query.filterId;
                if (filterId) path.push((0, $h4Bzb.ENTITY_ID).FILTER(filterId));
                else if (match.params?.issueKey) {
                    const [projectKey] = (match.params?.issueKey || '').split('-'); // For this route to match, the issueKey will never be blank
                    return [
                        (0, $h4Bzb.MENU_ID_PROJECTS),
                        (0, $h4Bzb.ENTITY_ID).PROJECT(projectKey)
                    ];
                }
                break;
            }
        default:
            {
                const filterId = query.filter || query.filterId;
                // Search filters URL
                if (filterId === undefined) path.push((0, $h4Bzb.MENU_ID_FILTERS_SEARCH));
                else // The rest of the URLs are using a filter ID.
                // Test this case: https://buglow-jsw.jira-dev.com/secure/ViewSubscriptions.jspa?filterId=10007
                path.push((0, $h4Bzb.ENTITY_ID).FILTER(filterId));
                break;
            }
    }
    return path;
}
const $54344df55ab10983$export$6e91331b5debb7c8 = {
    routes: $54344df55ab10983$var$routes,
    convert: $54344df55ab10983$var$convert,
    convertNew: $54344df55ab10983$var$convertNew
};

});

parcelRegister("gUBBs", function(module, exports) {

$parcel$export(module.exports, "operationsConverter", () => $8e03b266511d8843$export$7fc92455d5020e1);

var $7jTnu = parcelRequire("7jTnu");

var $h4Bzb = parcelRequire("h4Bzb");
const $8e03b266511d8843$var$routes = new Set([
    'eoc-automations',
    'eoc-custom-roles',
    'eoc-global-alerts',
    'eoc-global-alerts-redirect',
    'eoc-global-alert-detail',
    'eoc-global-group-detail',
    'eoc-global-reports',
    'eoc-global-report-dashboard',
    'eoc-heartbeats',
    'eoc-global-heartbeats',
    'eoc-maintenance',
    'eoc-on-call',
    'eoc-on-call-redirect',
    'eoc-overview',
    'eoc-overview-all-teams',
    'eoc-permissions',
    'eoc-reports',
    'eoc-reports-team',
    'eoc-reports-unsubscribe',
    'eoc-schedules',
    'communications-status-page-manage',
    'eoc-team-alerts',
    'eoc-team-alert-detail',
    'eoc-team-alert-issue-syncing',
    'eoc-team-alert-issue-syncing-create',
    'eoc-team-alert-issue-syncing-detail',
    'eoc-team-group-detail',
    'eoc-team-integrations',
    'eoc-team-integration-create',
    'eoc-team-integration-detail',
    'eoc-team-integration-list',
    'eoc-team-integration-log',
    'eoc-team-policies',
    'eoc-who-is-on-call',
    'eoc-global-escalations'
]);
function $8e03b266511d8843$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_OPERATIONS)
    ];
    return $8e03b266511d8843$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $8e03b266511d8843$var$convertNew(args) {
    const { routeName: routeName, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_OPERATIONS)
    ];
    return $8e03b266511d8843$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $8e03b266511d8843$var$convertRouteToPath(args) {
    const { routeName: routeName, query: query, path: path } = args;
    switch(routeName){
        case 'eoc-who-is-on-call':
            path.push((0, $h4Bzb.MENU_ID_OPS_ON_CALL));
            break;
        case 'eoc-global-alerts':
        case 'eoc-global-alerts-redirect':
        case 'eoc-global-alert-detail':
            {
                path.push((0, $h4Bzb.MENU_ID_OPS_ALERTS));
                if ((0, $7jTnu.fg)('operations_nav4_remaining_items')) {
                    const { query: alarmQueue = '', view: view, filter: savedSearchId } = query;
                    view && path.push((0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(savedSearchId || alarmQueue));
                    break;
                }
                const { query: alarmQueue = '', view: view } = query;
                view && path.push((0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(alarmQueue));
                break;
            }
        case 'eoc-global-reports':
        case 'eoc-global-report-dashboard':
        case 'eoc-reports-unsubscribe':
            path.push((0, $h4Bzb.MENU_ID_OPS_REPORTS));
            break;
        case 'communications-status-page-manage':
            path.push((0, $h4Bzb.MENU_ID_OPS_STATUS_PAGES));
            break;
        case 'eoc-automations':
        case 'eoc-global-group-detail':
        case 'eoc-heartbeats':
        case 'eoc-maintenance':
        case 'eoc-permissions':
        case 'eoc-on-call':
        case 'eoc-on-call-redirect':
        case 'eoc-overview':
        case 'eoc-overview-all-teams':
        case 'eoc-reports':
        case 'eoc-reports-team':
        case 'eoc-schedules':
        case 'eoc-team-group-detail':
        case 'eoc-team-alerts':
        case 'eoc-team-alert-detail':
        case 'eoc-team-policies':
        case 'eoc-team-alert-issue-syncing':
        case 'eoc-team-alert-issue-syncing-create':
        case 'eoc-team-alert-issue-syncing-detail':
        case 'eoc-team-integrations':
        case 'eoc-team-integration-create':
        case 'eoc-team-integration-detail':
        case 'eoc-team-integration-list':
        case 'eoc-team-integration-log':
            path.push((0, $h4Bzb.MENU_ID_OPS_OVERVIEW));
            break;
        default:
            break;
    }
    return path;
}
const $8e03b266511d8843$export$7fc92455d5020e1 = {
    routes: $8e03b266511d8843$var$routes,
    convert: $8e03b266511d8843$var$convert,
    convertNew: $8e03b266511d8843$var$convertNew
};

});

parcelRegister("7ened", function(module, exports) {

$parcel$export(module.exports, "communicationsConverter", () => $7c2dc732420a76b8$export$e136020d3142ef55);

var $h4Bzb = parcelRequire("h4Bzb");
const $7c2dc732420a76b8$var$routes = new Set([
    'communications-stakeholder-groups',
    'communications-stakeholders'
]);
function $7c2dc732420a76b8$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_COMMUNICATION)
    ];
    return $7c2dc732420a76b8$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $7c2dc732420a76b8$var$convertNew(args) {
    const { routeName: routeName, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_COMMUNICATION)
    ];
    return $7c2dc732420a76b8$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $7c2dc732420a76b8$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'communications-stakeholder-groups':
            path.push((0, $h4Bzb.MENU_ID_COMMUNICATIONS_STAKEHOLDERS));
            break;
        case 'communications-stakeholders':
            path.push((0, $h4Bzb.MENU_ID_COMMUNICATIONS_STAKEHOLDERS));
            break;
        default:
            break;
    }
    return path;
}
const $7c2dc732420a76b8$export$e136020d3142ef55 = {
    routes: $7c2dc732420a76b8$var$routes,
    convert: $7c2dc732420a76b8$var$convert,
    convertNew: $7c2dc732420a76b8$var$convertNew
};

});

parcelRegister("kyqLB", function(module, exports) {

$parcel$export(module.exports, "topLevelConverter", () => $b77c4adb83be0f6d$export$a33f2d74a674bf8a);

var $h4Bzb = parcelRequire("h4Bzb");
// TODO: Remove your-work when cleaning up blu-7514_update_jira_home_your_work_to_for_you
const $b77c4adb83be0f6d$var$routes = new Set([
    'your-work',
    'for-you',
    'people-index'
]);
function $b77c4adb83be0f6d$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $b77c4adb83be0f6d$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $b77c4adb83be0f6d$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $b77c4adb83be0f6d$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $b77c4adb83be0f6d$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    // TODO: Remove your-work when cleaning up blu-7514_update_jira_home_your_work_to_for_you
    switch(routeName){
        case 'your-work':
            path.push((0, $h4Bzb.MENU_ID_YOUR_WORK));
            break;
        case 'for-you':
            path.push((0, $h4Bzb.MENU_ID_FOR_YOU));
            break;
        case 'people-index':
            path.push((0, $h4Bzb.MENU_ID_TEAMS));
            break;
        default:
    }
    return path;
}
const $b77c4adb83be0f6d$export$a33f2d74a674bf8a = {
    routes: $b77c4adb83be0f6d$var$routes,
    convert: $b77c4adb83be0f6d$var$convert,
    convertNew: $b77c4adb83be0f6d$var$convertNew
};

});

parcelRegister("3NLYz", function(module, exports) {

$parcel$export(module.exports, "overviewsConverter", () => $3ffa2483d2986bd3$export$5469f6c6536ca9c5);

var $h4Bzb = parcelRequire("h4Bzb");
const $3ffa2483d2986bd3$var$routes = new Set([
    'classic-business-overview-calendar',
    'classic-business-overview-redirect',
    'classic-business-overview-summary',
    'classic-business-overview-timeline'
]);
function $3ffa2483d2986bd3$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_OVERVIEWS)
    ];
    return $3ffa2483d2986bd3$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $3ffa2483d2986bd3$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_OVERVIEWS)
    ];
    return $3ffa2483d2986bd3$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $3ffa2483d2986bd3$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    routeName;
    {
        const { overviewId: overviewId } = match.params;
        overviewId && path.push((0, $h4Bzb.ENTITY_ID).OVERVIEW(overviewId));
    }
    return path;
}
const $3ffa2483d2986bd3$export$5469f6c6536ca9c5 = {
    routes: $3ffa2483d2986bd3$var$routes,
    convert: $3ffa2483d2986bd3$var$convert,
    convertNew: $3ffa2483d2986bd3$var$convertNew
};

});

parcelRegister("eC071", function(module, exports) {

$parcel$export(module.exports, "plansConverter", () => $c10f9c452f3404f9$export$3bde637b58016d1);

var $h4Bzb = parcelRequire("h4Bzb");
const $c10f9c452f3404f9$var$routes = new Set([
    'plans-directory',
    'software-advanced-roadmaps',
    'software-advanced-roadmaps-getting-started-redirect',
    'software-advanced-roadmaps-setup',
    'software-plan-calendar',
    'software-plan-dependencies',
    'software-plan-increment',
    'software-plan-increments',
    'software-plan-releases',
    'software-plan-summary',
    'software-plan-teams',
    'software-plan-timeline',
    'trashed-plan-direct-link',
    'software-plan-upsell'
]);
function $c10f9c452f3404f9$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_PLANS)
    ];
    return $c10f9c452f3404f9$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $c10f9c452f3404f9$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_PLANS)
    ];
    return $c10f9c452f3404f9$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $c10f9c452f3404f9$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'plans-directory':
        case 'software-advanced-roadmaps-getting-started-redirect':
            path.push((0, $h4Bzb.MENU_ID_PLANS_VIEW_ALL));
            break;
        case 'trashed-plan-direct-link':
            break;
        default:
            {
                const { planId: planId } = match.params;
                planId && path.push((0, $h4Bzb.ENTITY_ID).PLAN(planId));
            }
    }
    return path;
}
const $c10f9c452f3404f9$export$3bde637b58016d1 = {
    routes: $c10f9c452f3404f9$var$routes,
    convert: $c10f9c452f3404f9$var$convert,
    convertNew: $c10f9c452f3404f9$var$convertNew
};

});

parcelRegister("3233g", function(module, exports) {

$parcel$export(module.exports, "projectsConverter", () => $9cfe72e927f4264e$export$c41b724886e5872b);

var $7jTnu = parcelRequire("7jTnu");

var $h4Bzb = parcelRequire("h4Bzb");
const $9cfe72e927f4264e$var$routes = new Set([
    'browse-project-redirect',
    'legacy-all-reports',
    'projects-directory',
    'issue-navigator',
    'issue-navigator-core',
    'project-components',
    'project-not-found',
    'project-versions',
    'software-version-detail',
    'software-version-detail-no-tab-path',
    'forge-spa-project',
    'forge-spa-project-servicedesk',
    'forge-spa-servicedesk-queue',
    'polaris-ideas',
    'polaris-onboarding',
    'opsgenie-schedule',
    'issue-navigator-classic',
    'project-pages',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-report',
    'software-backlog',
    'software-boards',
    'software-calendar',
    'software-calendar-classic',
    'software-capacity',
    'software-capacity-embed',
    'software-capacity-custom-embed',
    'classic-software-proforma-issue-forms-direct',
    'software-code',
    'software-code-classic',
    'software-deployments',
    'software-deployments-classic',
    'software-form',
    'software-form-classic',
    'software-form-builder',
    'software-form-builder-classic',
    'software-form-submit',
    'software-form-submit-classic',
    'software-form-submit-embed',
    'software-form-submit-public',
    'software-form-submit-classic-embed',
    'software-form-submit-classic-public',
    'software-goals',
    'software-goals-classic',
    'software-incidents',
    'software-incidents-classic',
    'software-issue-navigator',
    'software-list',
    'software-list-classic',
    'software-periscope',
    'software-periscope-classic',
    'software-reports',
    'software-reports-boardless',
    'software-reports-burndown',
    'software-reports-burnup',
    'software-reports-control',
    'software-reports-cumulative',
    'software-reports-cycle-time',
    'software-reports-cycle-time-classic',
    'software-reports-deployment-frequency',
    'software-reports-deployment-frequency-classic',
    'software-reports-velocity',
    'software-reports-velocity-cmp',
    'software-security',
    'software-security-classic',
    'software-summary',
    'software-summary-embed',
    'software-summary-classic',
    'software-summary-classic-embed',
    'software-timeline',
    'software-timeline-classic',
    'software-view-not-found',
    'software-view-not-found-classic',
    'software-board-view-not-found',
    'software-board-view-not-found-classic',
    'knowledge-hub-all-articles',
    'kb-article-embed-editor',
    'knowledge-hub-article-in-category',
    'knowledge-hub-browse-all-articles',
    'knowledge-hub-browse-all-categories',
    'knowledge-hub-browse-view-article',
    'knowledge-hub-category',
    'knowledge-hub-category-page',
    'knowledge-hub-drafts',
    'knowledge-hub-suggested-topics',
    'knowledge-hub-landing',
    'knowledge-hub-search',
    'knowledge-hub-setup',
    'notification-logs',
    'servicedesk-atlassian-analytics',
    'servicedesk-boards',
    'servicedesk-calendar',
    'servicedesk-project-summary',
    'servicedesk-change-calendar',
    'servicedesk-connect-project',
    'servicedesk-customers-v2',
    'servicedesk-customer-details',
    'servicedesk-customer-service-escalations',
    'servicedesk-customer-service-products',
    'servicedesk-getting-started-page',
    'servicedesk-issue',
    'servicedesk-issues',
    'servicedesk-list',
    'servicedesk-kb-requests-reports',
    'servicedesk-kb-requests-reports-time-scale-issue',
    'servicedesk-kb-requests-reports-time-scale',
    'servicedesk-oncall-schedule',
    'servicedesk-organizations',
    'servicedesk-organization-details',
    'servicedesk-organization_v2',
    'servicedesk-queues-practice-custom-board',
    'servicedesk-queues-practice-custom-calendar',
    'servicedesk-practice-custom-and-issue',
    'servicedesk-practice-edit',
    'servicedesk-practice-issue',
    'servicedesk-practice-landing',
    'servicedesk-practice-manage-view',
    'servicedesk-practice-new',
    'servicedesk-queues-addon',
    'servicedesk-queues-custom-board',
    'servicedesk-queues-custom-calendar',
    'servicedesk-queues-custom-view',
    'servicedesk-queues-custom-issue-detail',
    'servicedesk-queues-edit',
    'servicedesk-practice-views-config',
    'servicedesk-queues-views-config',
    'servicedesk-queues-issue',
    'servicedesk-queues-manage-view',
    'servicedesk-queues-new',
    'servicedesk-reports',
    'servicedesk-reports-custom',
    'servicedesk-reports-custom-create',
    'servicedesk-reports-custom-edit',
    'servicedesk-reports-custom-time-scale-issue',
    'servicedesk-reports-custom-time-scale',
    'servicedesk-reports-satisfaction',
    'servicedesk-reports-satisfaction-time-scale-issue',
    'servicedesk-reports-satisfaction-time-scale',
    'servicedesk-reports-type',
    'servicedesk-reports-workload',
    'servicedesk-avp-project-dashboards-editable',
    'servicedesk-avp-project-dashboards-list',
    'servicedesk-services',
    'servicedesk-service-details',
    'classic-business-approvals',
    'classic-business-attachments',
    'classic-business-board',
    'classic-business-calendar',
    'classic-business-form',
    'classic-business-form-builder',
    'classic-business-form-submit',
    'classic-business-form-submit-public',
    'classic-business-list',
    'classic-business-shortcut',
    'classic-business-summary',
    'classic-business-timeline',
    'classic-business-view-not-found',
    'classic-business-redirect',
    'inbox',
    'inbox-classic'
]);
const $9cfe72e927f4264e$var$routesWithArchivedWorkItemsRoute = new Set($9cfe72e927f4264e$var$routes);
$9cfe72e927f4264e$var$routesWithArchivedWorkItemsRoute.add('archived-issues-directory').add('classic-business-archived-work-items').add('servicedesk-archived-work-items').add('software-archived-work-items-classic').add('software-archived-work-items');
function $9cfe72e927f4264e$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_PROJECTS)
    ];
    return $9cfe72e927f4264e$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $9cfe72e927f4264e$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_PROJECTS)
    ];
    return $9cfe72e927f4264e$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $9cfe72e927f4264e$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'polaris-onboarding':
            break;
        case 'projects-directory':
            path.push((0, $h4Bzb.MENU_ID_PROJECTS_VIEW_ALL));
            break;
        case 'forge-spa-project':
        case 'forge-spa-project-servicedesk':
        case 'forge-spa-servicedesk-queue':
            {
                const { projectKey: projectKey, appId: appId } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                path.push((0, $h4Bzb.MENU_ID_PROJECT_APPS));
                appId && path.push((0, $h4Bzb.ENTITY_ID).APP(appId));
                break;
            }
        case 'knowledge-hub-all-articles':
        case 'kb-article-embed-editor':
        case 'knowledge-hub-article-in-category':
        case 'knowledge-hub-browse-all-articles':
        case 'knowledge-hub-browse-all-categories':
        case 'knowledge-hub-browse-view-article':
        case 'knowledge-hub-category':
        case 'knowledge-hub-category-page':
        case 'knowledge-hub-drafts':
        case 'knowledge-hub-suggested-topics':
        case 'knowledge-hub-landing':
        case 'knowledge-hub-search':
        case 'knowledge-hub-setup':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                break;
            }
        case 'servicedesk-getting-started-page':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                break;
            }
        case 'notification-logs':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                break;
            }
        case 'servicedesk-project-summary':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_SUMMARY(projectKey));
                break;
            }
        case 'servicedesk-boards':
            {
                const { projectKey: projectKey, boardId: boardId } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_VIEWS(projectKey));
                boardId && path.push((0, $h4Bzb.ENTITY_ID).BOARD(boardId));
                break;
            }
        case 'servicedesk-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_VIEWS(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-change-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-organizations':
        case 'servicedesk-organization-details':
        case 'servicedesk-organization_v2':
        case 'servicedesk-customers-v2':
        case 'servicedesk-customer-details':
        case 'servicedesk-customer-service-products':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_DIRECTORY(projectKey));
                break;
            }
        case 'servicedesk-customer-service-escalations':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                break;
            }
        case 'servicedesk-kb-requests-reports':
        case 'servicedesk-kb-requests-reports-time-scale-issue':
        case 'servicedesk-kb-requests-reports-time-scale':
        case 'servicedesk-reports':
        case 'servicedesk-reports-custom':
        case 'servicedesk-reports-custom-create':
        case 'servicedesk-reports-custom-edit':
        case 'servicedesk-reports-custom-time-scale-issue':
        case 'servicedesk-reports-custom-time-scale':
        case 'servicedesk-reports-satisfaction':
        case 'servicedesk-reports-satisfaction-time-scale-issue':
        case 'servicedesk-reports-satisfaction-time-scale':
        case 'servicedesk-reports-type':
        case 'servicedesk-reports-workload':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_REPORTS(projectKey));
                break;
            }
        case 'servicedesk-avp-project-dashboards-editable':
        case 'servicedesk-avp-project-dashboards-list':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_DASHBOARDS(projectKey));
                break;
            }
        case 'servicedesk-oncall-schedule':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                break;
            }
        case 'servicedesk-issues':
            {
                const { projectKey: projectKey } = match.params;
                const filterId = query.filter || query.filterId;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                if (projectKey && filterId) {
                    path.push((0, $h4Bzb.ENTITY_ID).PROJECT_FILTERS(projectKey));
                    path.push((0, $h4Bzb.ENTITY_ID).PROJECT_ISSUE_FILTER(projectKey, filterId));
                }
                break;
            }
        case 'servicedesk-queues-practice-custom-board':
        case 'servicedesk-queues-practice-custom-calendar':
        case 'servicedesk-practice-custom-and-issue':
        case 'servicedesk-practice-edit':
        case 'servicedesk-practice-issue':
        case 'servicedesk-practice-landing':
        case 'servicedesk-practice-manage-view':
        case 'servicedesk-practice-views-config':
        case 'servicedesk-practice-new':
            {
                const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && practiceType && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, practiceType));
                queueId && path.push((0, $h4Bzb.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-queues-addon':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-custom-calendar':
        case 'servicedesk-queues-custom-view':
        case 'servicedesk-queues-edit':
        case 'servicedesk-queues-issue':
        case 'servicedesk-queues-manage-view':
        case 'servicedesk-queues-views-config':
        case 'servicedesk-queues-new':
            {
                const { projectKey: projectKey, queueId: queueId } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $h4Bzb.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-queues-custom-issue-detail':
            {
                const { projectKey: projectKey, queueId: queueId, issueKey: issueKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $h4Bzb.ENTITY_ID).QUEUE(queueId));
                issueKey && path.push((0, $h4Bzb.ENTITY_ID).ISSUE(issueKey));
                break;
            }
        case 'servicedesk-services':
        case 'servicedesk-service-details':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_SERVICES(projectKey));
                break;
            }
        default:
            {
                const { projectKey: projectKey, formId: formId } = match.params;
                let { boardId: boardId } = match.params;
                if ((0, $7jTnu.fg)('blu-7733-jracloud-94629-connect-tab')) {
                    const rapidViewBoard = query.rapidView ? query.rapidView : null;
                    boardId = rapidViewBoard || boardId || null;
                }
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                boardId && path.push((0, $h4Bzb.ENTITY_ID).BOARD(boardId));
                formId && path.push((0, $h4Bzb.ENTITY_ID).FORM(formId));
            }
    }
    if ((0, $7jTnu.fg)('fix-operations-menu-item-deselected-bug')) {
        const { projectKey: projectKey } = match.params;
        if ((routeName === 'servicedesk-change-calendar' || routeName === 'servicedesk-services' || routeName === 'servicedesk-service-details') && projectKey) path.push((0, $h4Bzb.ENTITY_ID).PROJECT_OPERATIONS(projectKey));
    }
    return path;
}
const $9cfe72e927f4264e$export$c41b724886e5872b = {
    get routes () {
        return (0, $7jTnu.fg)('ken_1984_archive_route_support_sidebar') ? $9cfe72e927f4264e$var$routesWithArchivedWorkItemsRoute : $9cfe72e927f4264e$var$routes;
    },
    convert: $9cfe72e927f4264e$var$convert,
    convertNew: $9cfe72e927f4264e$var$convertNew
};

});

parcelRegister("nPGhK", function(module, exports) {

$parcel$export(module.exports, "roadmapsConverter", () => $dd242add0bed8a4a$export$5761942b1e0c2dd0);

var $h4Bzb = parcelRequire("h4Bzb");
const $dd242add0bed8a4a$var$routes = new Set([
    'polaris-collections'
]);
function $dd242add0bed8a4a$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_ROADMAPS)
    ];
    return $dd242add0bed8a4a$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $dd242add0bed8a4a$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_ROADMAPS)
    ];
    return $dd242add0bed8a4a$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $dd242add0bed8a4a$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'polaris-collections':
            {
                const collectionId = match.params.collectionUUID;
                if (collectionId) path.push((0, $h4Bzb.ENTITY_ID).ROADMAP(collectionId));
                else path.push((0, $h4Bzb.MENU_ID_ROADMAPS_VIEW_ALL));
                break;
            }
        default:
    }
    return path;
}
const $dd242add0bed8a4a$export$5761942b1e0c2dd0 = {
    routes: $dd242add0bed8a4a$var$routes,
    convert: $dd242add0bed8a4a$var$convert,
    convertNew: $dd242add0bed8a4a$var$convertNew
};

});

parcelRegister("7krAP", function(module, exports) {

$parcel$export(module.exports, "serviceManagementProjectSettingsConverter", () => $7d0a8f331dc5ad04$export$dd307ede503fe0e);

var $7xaze = parcelRequire("7xaze");

var $6WtFe = parcelRequire("6WtFe");

var $iPhgi = parcelRequire("iPhgi");

var $flolB = parcelRequire("flolB");

var $9CHTy = parcelRequire("9CHTy");

var $9zBC5 = parcelRequire("9zBC5");

var $7g1XK = parcelRequire("7g1XK");

var $hCTNK = parcelRequire("hCTNK");

var $kTJYz = parcelRequire("kTJYz");

var $azYhY = parcelRequire("azYhY");

var $cX4Fw = parcelRequire("cX4Fw");

var $eaMHj = parcelRequire("eaMHj");

var $huYm9 = parcelRequire("huYm9");

var $kDkUg = parcelRequire("kDkUg");

var $9Box0 = parcelRequire("9Box0");

var $306id = parcelRequire("306id");

var $2TwJc = parcelRequire("2TwJc");

var $84Gb2 = parcelRequire("84Gb2");

var $499r8 = parcelRequire("499r8");

var $ie5KY = parcelRequire("ie5KY");

var $jUN5r = parcelRequire("jUN5r");

var $buW1x = parcelRequire("buW1x");

var $dOEVM = parcelRequire("dOEVM");

var $7B6GN = parcelRequire("7B6GN");

var $9pooG = parcelRequire("9pooG");

var $ihecD = parcelRequire("ihecD");

var $4XctI = parcelRequire("4XctI");

var $loMl1 = parcelRequire("loMl1");

var $37gZV = parcelRequire("37gZV");

var $azX7D = parcelRequire("azX7D");

var $3EnHO = parcelRequire("3EnHO");

var $cdHCV = parcelRequire("cdHCV");

var $csrcH = parcelRequire("csrcH");

var $idiiX = parcelRequire("idiiX");

var $hsEQN = parcelRequire("hsEQN");

var $jmJlK = parcelRequire("jmJlK");

var $88a5z = parcelRequire("88a5z");

var $jOpgR = parcelRequire("jOpgR");

var $h4Bzb = parcelRequire("h4Bzb");
const $7d0a8f331dc5ad04$var$routes = new Set([
    'legacy-project-settings-fields',
    'legacy-project-settings-issue-security',
    'legacy-project-settings-issue-types',
    'legacy-project-settings-notifications',
    'legacy-project-settings-people',
    'legacy-project-settings-permissions',
    'legacy-project-settings-screens',
    'legacy-project-settings-workflows',
    'legacy-project-settings-workflows-associate',
    'project-settings-automation',
    'servicedesk-sla-settings',
    (0, $flolB.projectSettingsServicedeskAutomationSummaryRoute).name,
    (0, $9CHTy.projectSettingsServicedeskAccessRoute).name,
    (0, $kTJYz.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name,
    (0, $kDkUg.projectSettingsServicedeskCustomerPermissionsRoute).name,
    (0, $2TwJc.projectSettingsServicedeskFeedbackRoute).name,
    (0, $84Gb2.projectSettingsServicedeskFieldsRoute).name,
    (0, $7B6GN.projectSettingsServicedeskProformaProjectFormsRoute).name,
    (0, $9pooG.projectSettingsServicedeskItsmTicketTypesConfigRoute).name,
    (0, $eaMHj.projectSettingsServicedeskChatRoute).name,
    (0, $9Box0.projectSettingsServicedeskEmailRoute).name,
    (0, $306id.projectSettingsServicedeskExternalLinksRoute).name,
    (0, $dOEVM.projectSettingsServicedeskPortalSettingsRoute).name,
    (0, $ihecD.projectSettingsServicedeskWidgetRoute).name,
    (0, $7g1XK.projectSettingsServicedeskChangeManagementRoute).name,
    (0, $499r8.projectSettingsServicedeskIncidentManagementRoute).name,
    (0, $huYm9.projectSettingsServicedeskClassicAppsRoute).name,
    (0, $hCTNK.projectSettingsServicedeskChannelsChatRoute).name,
    (0, $cX4Fw.projectSettingsServicedeskChannelsWidgetRoute).name,
    (0, $6WtFe.projectSettingsServicedeskNotificationsEmailRoute).name,
    (0, $iPhgi.projectSettingsServicedeskNotificationsNotificationEmailRoute).name,
    (0, $buW1x.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name,
    (0, $9zBC5.projectSettingsServicedeskAppsFieldsRoute).name,
    (0, $cdHCV.projectSettingsServicedeskCustomerNotificationsRoute).name,
    (0, $csrcH.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name,
    (0, $idiiX.projectSettingsServicedeskKbRoute).name,
    (0, $jmJlK.projectSettingsServicedeskTicketTypesConfigRoute).name,
    (0, $88a5z.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
    (0, $jOpgR.servicedeskWorkflowConfigRoute).name,
    (0, $jUN5r.projectSettingsServicedeskIssuetypesRoute).name,
    (0, $azYhY.projectSettingsServicedeskChannelsPortalRoute).name,
    (0, $7xaze.projectSettingsServicedeskAutomationRoute).name,
    (0, $hsEQN.servicedeskSlaSettingsRoute).name,
    (0, $ie5KY.projectSettingsServicedeskInternalNotificationsNextGenRoute).name,
    (0, $loMl1.landingPageRoute).name,
    (0, $37gZV.browseConversationsRoute).name,
    (0, $azX7D.browseIntentsRoute).name,
    (0, $3EnHO.browseStandardFlowsRoute).name,
    (0, $4XctI.virtualAgentSettingsRoute).name
]);
function $7d0a8f331dc5ad04$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $7d0a8f331dc5ad04$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $7d0a8f331dc5ad04$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $7d0a8f331dc5ad04$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $7d0a8f331dc5ad04$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        // Access Menu
        case 'legacy-project-settings-people':
        case (0, $9CHTy.projectSettingsServicedeskAccessRoute).name:
        case (0, $kDkUg.projectSettingsServicedeskCustomerPermissionsRoute).name:
        case (0, $kTJYz.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name:
        case 'legacy-project-settings-permissions':
        case 'legacy-project-settings-issue-security':
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_ACCESS));
            break;
        // Request Management -> Request types menu
        case (0, $9pooG.projectSettingsServicedeskItsmTicketTypesConfigRoute).name:
        case (0, $88a5z.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name:
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, $h4Bzb.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES));
            break;
        // Request Management
        case (0, $jmJlK.projectSettingsServicedeskTicketTypesConfigRoute).name:
        case (0, $7B6GN.projectSettingsServicedeskProformaProjectFormsRoute).name:
        case 'legacy-project-settings-workflows':
        case (0, $jOpgR.servicedeskWorkflowConfigRoute).name:
        case 'legacy-project-settings-workflows-associate':
        case 'servicedesk-sla-settings':
        case (0, $hsEQN.servicedeskSlaSettingsRoute).name:
        case (0, $2TwJc.projectSettingsServicedeskFeedbackRoute).name:
        case 'legacy-project-settings-issue-types':
        case (0, $jUN5r.projectSettingsServicedeskIssuetypesRoute).name:
        case 'legacy-project-settings-fields':
        case (0, $84Gb2.projectSettingsServicedeskFieldsRoute).name:
        case 'legacy-project-settings-screens':
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
            break;
        // Automation
        case 'project-settings-automation':
        case (0, $flolB.projectSettingsServicedeskAutomationSummaryRoute).name:
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_AUTOMATION));
            break;
        // Channels and self-service
        case (0, $dOEVM.projectSettingsServicedeskPortalSettingsRoute).name:
        case (0, $azYhY.projectSettingsServicedeskChannelsPortalRoute).name:
        case (0, $9Box0.projectSettingsServicedeskEmailRoute).name:
        case (0, $eaMHj.projectSettingsServicedeskChatRoute).name:
        case (0, $ihecD.projectSettingsServicedeskWidgetRoute).name:
        case (0, $idiiX.projectSettingsServicedeskKbRoute).name:
        case (0, $306id.projectSettingsServicedeskExternalLinksRoute).name:
        case (0, $hCTNK.projectSettingsServicedeskChannelsChatRoute).name:
        case (0, $cX4Fw.projectSettingsServicedeskChannelsWidgetRoute).name:
        case (0, $4XctI.virtualAgentSettingsRoute).name:
        case (0, $loMl1.landingPageRoute).name:
        case (0, $37gZV.browseConversationsRoute).name:
        case (0, $azX7D.browseIntentsRoute).name:
        case (0, $3EnHO.browseStandardFlowsRoute).name:
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
            break;
        // Operations
        case (0, $7g1XK.projectSettingsServicedeskChangeManagementRoute).name:
        case (0, $499r8.projectSettingsServicedeskIncidentManagementRoute).name:
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_OPERATIONS));
            break;
        // Notifications
        case 'legacy-project-settings-notifications':
        case (0, $cdHCV.projectSettingsServicedeskCustomerNotificationsRoute).name:
        case (0, $buW1x.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name:
        case (0, $csrcH.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name:
        case (0, $6WtFe.projectSettingsServicedeskNotificationsEmailRoute).name:
        case (0, $iPhgi.projectSettingsServicedeskNotificationsNotificationEmailRoute).name:
        case (0, $ie5KY.projectSettingsServicedeskInternalNotificationsNextGenRoute).name:
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_NOTIFICATIONS));
            break;
        // Apps
        case (0, $huYm9.projectSettingsServicedeskClassicAppsRoute).name:
        case (0, $9zBC5.projectSettingsServicedeskAppsFieldsRoute).name:
            // ADD rest of the apps here
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_APPS));
            break;
        default:
            break;
    }
    return path;
}
const $7d0a8f331dc5ad04$export$dd307ede503fe0e = {
    routes: $7d0a8f331dc5ad04$var$routes,
    convert: $7d0a8f331dc5ad04$var$convert,
    convertNew: $7d0a8f331dc5ad04$var$convertNew
};

});
parcelRegister("7xaze", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", () => $74c18d3f7e20f44d$export$1a2228d5e07202a0);
const $74c18d3f7e20f44d$export$1a2228d5e07202a0 = {
    name: 'project-settings-automation',
    path: '/jira/servicedesk/projects/:projectKey/settings/automate'
};

});

parcelRegister("6WtFe", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRoute", () => $dd3281251f67d1d8$export$1f37a1aff4f594af);
const $dd3281251f67d1d8$export$1f37a1aff4f594af = {
    name: 'project-settings-servicedesk-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notification-email',
    exact: true
};

});

parcelRegister("iPhgi", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", () => $e2d116eeed869549$export$40539cb16771014e);
const $e2d116eeed869549$export$40539cb16771014e = {
    name: 'project-settings-servicedesk-notifications-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("flolB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationSummaryRoute", () => $e924041ee9cf8148$export$165d82a2618e4d99);
const $e924041ee9cf8148$export$165d82a2618e4d99 = {
    name: 'project-settings-servicedesk-automation-summary',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation'
};

});

parcelRegister("9CHTy", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRoute", () => $494393447df36998$export$6473a81f1ee460ef);
const $494393447df36998$export$6473a81f1ee460ef = {
    name: 'project-settings-servicedesk-access',
    path: '/jira/servicedesk/projects/:projectKey/settings/access',
    exact: true
};

});

parcelRegister("9zBC5", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsFieldsRoute", () => $7eac910e270d98a7$export$bb46672b3fb14eec);
const $7eac910e270d98a7$export$bb46672b3fb14eec = {
    name: 'project-settings-servicedesk-apps-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("7g1XK", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChangeManagementRoute", () => $852fc1870396df0f$export$1444ee3eb63a2ffc);
const $852fc1870396df0f$export$1444ee3eb63a2ffc = {
    name: 'project-settings-servicedesk-change-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/change-management',
    exact: true
};

});

parcelRegister("hCTNK", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsChatRoute", () => $cf62c7fefbad1b1f$export$be5ad475040cd044);
const $cf62c7fefbad1b1f$export$be5ad475040cd044 = {
    name: 'project-settings-servicedesk-channels-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/chat',
    exact: true
};

});

parcelRegister("kTJYz", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPermissionsNextGenRoute", () => $f1625153a3fc4be1$export$5fb39a9d3820886c);
const $f1625153a3fc4be1$export$5fb39a9d3820886c = {
    name: 'project-settings-servicedesk-channels-permissions-next-gen',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/customer-permissions',
    exact: true
};

});

parcelRegister("azYhY", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPortalRoute", () => $bf04ae1978c865f7$export$8f4234e4e79e03);
const $bf04ae1978c865f7$export$8f4234e4e79e03 = {
    name: 'project-settings-servicedesk-channels-portal',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/portal-settings',
    exact: true
};

});

parcelRegister("cX4Fw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsWidgetRoute", () => $bbc98215303aabc7$export$c66db54872d3b51c);
const $bbc98215303aabc7$export$c66db54872d3b51c = {
    name: 'project-settings-servicedesk-channels-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/widget',
    exact: true
};

});

parcelRegister("eaMHj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChatRoute", () => $db76c9323340b2b3$export$b22ac188582d1dbd);
const $db76c9323340b2b3$export$b22ac188582d1dbd = {
    name: 'project-settings-servicedesk-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/chat',
    exact: true
};

});

parcelRegister("huYm9", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskClassicAppsRoute", () => $9871f373036dc5dd$export$2b65324bb87228c5);
const $9871f373036dc5dd$export$2b65324bb87228c5 = {
    name: 'project-settings-servicedesk-classic-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps',
    exact: true
};

});

parcelRegister("kDkUg", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerPermissionsRoute", () => $9ff9cc4235e57156$export$d8ed4a1eb0c01b5a);
const $9ff9cc4235e57156$export$d8ed4a1eb0c01b5a = {
    name: 'project-settings-servicedesk-customer-permissions',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-permissions',
    exact: true
};

});

parcelRegister("9Box0", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskEmailRoute", () => $cc88ee571b3cf336$export$d7d111417bfcd900);
const $cc88ee571b3cf336$export$d7d111417bfcd900 = {
    name: 'project-settings-servicedesk-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/email',
    exact: true
};

});

parcelRegister("306id", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskExternalLinksRoute", () => $e5f40259a6056a55$export$2ec1a0d49a1f6ac2);
const $e5f40259a6056a55$export$2ec1a0d49a1f6ac2 = {
    name: 'project-settings-servicedesk-external-links',
    path: '/jira/servicedesk/projects/:projectKey/settings/external-links',
    exact: true
};

});

parcelRegister("2TwJc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFeedbackRoute", () => $a927b1b6a51288e0$export$f21485e31d7839aa);
const $a927b1b6a51288e0$export$f21485e31d7839aa = {
    name: 'project-settings-servicedesk-feedback',
    path: '/jira/servicedesk/projects/:projectKey/settings/feedback-settings'
};

});

parcelRegister("84Gb2", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFieldsRoute", () => $c2df9347b08a45ce$export$44f665a50373c681);
const $c2df9347b08a45ce$export$44f665a50373c681 = {
    name: 'project-settings-servicedesk-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("499r8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIncidentManagementRoute", () => $2fa916512590f19d$export$f91bd0bb0d4783ff);
const $2fa916512590f19d$export$f91bd0bb0d4783ff = {
    name: 'project-settings-servicedesk-incident-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/incident-management',
    exact: true
};

});

parcelRegister("ie5KY", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskInternalNotificationsNextGenRoute", () => $b1e3a423a8f43b26$export$5db62792327950b4);
const $b1e3a423a8f43b26$export$5db62792327950b4 = {
    name: 'project-settings-servicedesk-internal-notifications-nextGen',
    path: '/jira/servicedesk/projects/:projectKey/settings/internal-notifications'
};

});

parcelRegister("jUN5r", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesRoute", () => $855f65ce7afe991a$export$2ffcb2e92bb4950b);
const $855f65ce7afe991a$export$2ffcb2e92bb4950b = {
    name: 'project-settings-servicedesk-issuetypes',
    path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});

parcelRegister("buW1x", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsInternalNotificationsRoute", () => $691e3ad540e16e7f$export$5108e41f558ecf03);
const $691e3ad540e16e7f$export$5108e41f558ecf03 = {
    name: 'project-settings-servicedesk-notifications-internal-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/internal-notifications'
};

});

parcelRegister("dOEVM", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskPortalSettingsRoute", () => $0a55881c22b9f361$export$7593a7e4a6fc0aaf);
const $0a55881c22b9f361$export$7593a7e4a6fc0aaf = {
    name: 'project-settings-servicedesk-portal-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/portal-settings/:subPath(portal-groups)?',
    exact: true
};

});

parcelRegister("7B6GN", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaProjectFormsRoute", () => $692ad077baa2d08a$export$ee87e5f9754e3600);
const $692ad077baa2d08a$export$ee87e5f9754e3600 = {
    name: 'project-settings-servicedesk-proforma-project-forms',
    path: '/jira/servicedesk/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("9pooG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypesConfigRoute", () => $360e2c2f6b3ef4cd$export$52596d9b432829c);
const $360e2c2f6b3ef4cd$export$52596d9b432829c = {
    exact: true,
    name: 'project-settings-servicedesk-itsm-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice'
};

});

parcelRegister("ihecD", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskWidgetRoute", () => $ebdcd6c0fa97846d$export$ac674ffd39608325);
const $ebdcd6c0fa97846d$export$ac674ffd39608325 = {
    name: 'project-settings-servicedesk-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/widget',
    exact: true
};

});

parcelRegister("4XctI", function(module, exports) {

$parcel$export(module.exports, "virtualAgentSettingsRoute", () => $10f406c20ca6a562$export$80422a49e17dfd6b);
const $10f406c20ca6a562$export$80422a49e17dfd6b = {
    name: 'project-settings-servicedesk-virtual-agent-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings',
    exact: true
};

});

parcelRegister("loMl1", function(module, exports) {

$parcel$export(module.exports, "landingPageRoute", () => $a59bf5c45457fa62$export$8c051c399fd812a5);
const $a59bf5c45457fa62$export$8c051c399fd812a5 = {
    // We name this virtualagentonboarding without the "-" as otherwise it would trigger
    // the nesting stack, which we don't want for onboarding
    name: 'project-settings-servicedesk-virtualagentonboarding',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent'
};

});

parcelRegister("37gZV", function(module, exports) {

$parcel$export(module.exports, "browseConversationsRoute", () => $ceaa8b7bf0ef893e$export$c8ff4cf64e5540ec);
const $ceaa8b7bf0ef893e$export$c8ff4cf64e5540ec = {
    name: 'project-settings-servicedesk-virtualagent-browseconversations',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/conversations'
};

});

parcelRegister("azX7D", function(module, exports) {

$parcel$export(module.exports, "browseIntentsRoute", () => $2161d9d9dd4bb376$export$3e227412713bc57f);
const $2161d9d9dd4bb376$export$3e227412713bc57f = {
    name: 'project-settings-servicedesk-virtualagent-browse-intents',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents'
};

});

parcelRegister("3EnHO", function(module, exports) {

$parcel$export(module.exports, "browseStandardFlowsRoute", () => $5947d66ca945bddb$export$fd091ba8fa858397);
const $5947d66ca945bddb$export$fd091ba8fa858397 = {
    name: 'project-settings-servicedesk-virtualagent-standard-flows',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows'
};

});

parcelRegister("cdHCV", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerNotificationsRoute", () => $3097aecf5b1470cb$export$176d388c5b23978e);
const $3097aecf5b1470cb$export$176d388c5b23978e = {
    name: 'project-settings-servicedesk-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-notifications'
};

});

parcelRegister("csrcH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsCustomerNotificationsRoute", () => $825ea2891dbc89b5$export$6ce57d409e1934f2);
const $825ea2891dbc89b5$export$6ce57d409e1934f2 = {
    name: 'project-settings-servicedesk-notifications-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/customer-notifications'
};

});

parcelRegister("idiiX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskKbRoute", () => $552f05c4b16ed42f$export$725fadff9ae82302);
const $552f05c4b16ed42f$export$725fadff9ae82302 = {
    name: 'project-settings-servicedesk-kb',
    path: '/jira/servicedesk/projects/:projectKey/settings/confluence-kb',
    exact: true
};

});

parcelRegister("hsEQN", function(module, exports) {

$parcel$export(module.exports, "servicedeskSlaSettingsRoute", () => $e9bc452ea345b3c1$export$bfbf66468910573e);
const $e9bc452ea345b3c1$export$bfbf66468910573e = {
    name: 'servicedesk-sla-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?'
};

});

parcelRegister("jmJlK", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypesConfigRoute", () => $439c11180176b27d$export$31f95ad4356ce017);
const $439c11180176b27d$export$31f95ad4356ce017 = {
    exact: true,
    name: 'project-settings-servicedesk-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types'
};

});

parcelRegister("88a5z", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypesConfigRoute", () => $69c1533799a2149a$export$8c897f53ff36fa6b);
const $69c1533799a2149a$export$8c897f53ff36fa6b = {
    exact: true,
    name: 'project-settings-servicedesk-unassigned-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned'
};

});

parcelRegister("jOpgR", function(module, exports) {

$parcel$export(module.exports, "servicedeskWorkflowConfigRoute", () => $7521baf68ef87a51$export$ecc771c0ee86ccb8);
const $7521baf68ef87a51$export$ecc771c0ee86ccb8 = {
    name: 'project-settings-servicedesk-workflow-scheme-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
    exact: true
};

});


parcelRegister("6ofXP", function(module, exports) {

$parcel$export(module.exports, "customerServiceConverter", () => $2cdb1f0dd4092ebc$export$8e632ccd3e33c9f1);

var $7jTnu = parcelRequire("7jTnu");

var $h4Bzb = parcelRequire("h4Bzb");
const $2cdb1f0dd4092ebc$var$routes = new Set([
    'customer-service-helpcenter'
]);
function $2cdb1f0dd4092ebc$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $2cdb1f0dd4092ebc$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $2cdb1f0dd4092ebc$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $2cdb1f0dd4092ebc$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $2cdb1f0dd4092ebc$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'customer-service-helpcenter':
            path.push((0, $7jTnu.fg)('jcs_project_type_m3') ? (0, $h4Bzb.MENU_ID_CUSTOMER_HUBS) : (0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE));
            break;
        default:
    }
    return path;
}
const $2cdb1f0dd4092ebc$export$8e632ccd3e33c9f1 = {
    routes: $2cdb1f0dd4092ebc$var$routes,
    convert: $2cdb1f0dd4092ebc$var$convert,
    convertNew: $2cdb1f0dd4092ebc$var$convertNew
};

});



parcelRegister("b1DBy", function(module, exports) {

$parcel$export(module.exports, "isSelectedPath", () => $7fd392c392ccabb1$export$cdcd6885320eec31);

var $aLENQ = parcelRequire("aLENQ");
function $7fd392c392ccabb1$export$cdcd6885320eec31(path, ...args) {
    const next = (menuId)=>{
        return (0, $aLENQ.isMenuIdList)(menuId) ? (0, $aLENQ.toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
    };
    if (args.length === 0) return next;
    return next(args[0]);
}

});
parcelRegister("aLENQ", function(module, exports) {

$parcel$export(module.exports, "toMenuIdFromMenuIdList", () => $d932814a3842588f$export$253323efd0c41e72);
$parcel$export(module.exports, "isMenuIdList", () => $d932814a3842588f$export$abdb8aa7ce9ed1ed);
$parcel$export(module.exports, "toMenuIdList", () => $d932814a3842588f$export$d8e017f58178e379);
const $d932814a3842588f$var$MENU_ID_DELIM = '   '; // Three spaces
function $d932814a3842588f$export$253323efd0c41e72(menuIds) {
    return menuIds.join($d932814a3842588f$var$MENU_ID_DELIM);
}
function $d932814a3842588f$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
    return maybeMenuIdList.indexOf($d932814a3842588f$var$MENU_ID_DELIM) !== -1;
}
function $d932814a3842588f$export$d8e017f58178e379(menuIdList) {
    return menuIdList.split($d932814a3842588f$var$MENU_ID_DELIM);
}

});


parcelRegister("9FYIg", function(module, exports) {

$parcel$export(module.exports, "RELAY_RESOURCE_TYPE", () => $f6c4de4a04897ac4$export$c6c8c12c0f1d8e54);
$parcel$export(module.exports, "createRelayResource", () => $f6c4de4a04897ac4$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $f6c4de4a04897ac4$export$42ca7b248c7aaee);

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $6uWhG = parcelRequire("6uWhG");

var $7zZ4w = parcelRequire("7zZ4w");

var $g1oKu = parcelRequire("g1oKu");

var $7797X = parcelRequire("7797X");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $aOk72 = parcelRequire("aOk72");
const $f6c4de4a04897ac4$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $f6c4de4a04897ac4$var$getData = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
    const measureName = `relay_resource_get_data:${type}`;
    const startMark = `relay_resource_get_data:${type}:start`;
    const endMark = `relay_resource_get_data:${type}:end`;
    (0, $6uWhG.setMark)(startMark);
    const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
    // loadQuery returns not a Promise, but Observable.
    // Resource waits until query Observable is completed and returns a queryReference
    // later queryReference could be used by usePreloadedQuery
    const queryReference = (0, $6uWhG.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), parameters, variables || {}, options));
    if (false && queryReference.id != null) {
        const promise = (0, $7797X.QueryPromisesMap).get(queryReference.id);
        if (promise) return promise.then(()=>{
            (0, $6uWhG.setMark)(endMark);
            (0, $6uWhG.setMeasure)(measureName, startMark, endMark);
            /**
				 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
				 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
				 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
				 * as well as subsequent fetches made by route transitions between spa-apps.
				 */ if (captureErrors) (0, $g1oKu.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $aOk72.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        });
    }
    if (queryReference.id != null) (0, $7797X.QueryPromisesMap).get(queryReference.id)?.then(()=>{
        (0, $6uWhG.setMark)(endMark);
        (0, $6uWhG.setMeasure)(measureName, startMark, endMark);
    });
    /**
	 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
	 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
	 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
	 * as well as subsequent fetches made by route transitions between spa-apps.
	 */ if (captureErrors) (0, $g1oKu.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
    if (captureTraceIds) (0, $aOk72.startCapturingTraceIds)(queryReference.name);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return queryReference;
};
const $f6c4de4a04897ac4$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false, isCritical: isCritical = false })=>(0, $l1VxS.createResource)({
        type: `${$f6c4de4a04897ac4$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            // sources: https://github.com/facebook/relay/blob/4b78c7dd27b286f9ee8f5b993ccb160163956999/packages/react-relay/relay-hooks/loadQuery.js#L273
            // @ts-expect-error - TS2339 - Property 'kind' does not exist on type 'GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>'.
            if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                const preloadableConcreteRequest = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                preloadableRequest;
                ({ params: params } = preloadableConcreteRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $37Ewn.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: (routerContext, customContext)=>{
            return $f6c4de4a04897ac4$var$getData({
                routerContext: routerContext,
                customContext: customContext,
                type: type,
                getQuery: getQuery,
                captureErrors: captureErrors,
                captureTraceIds: captureTraceIds
            });
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly,
        isCritical: isCritical
    });
const $f6c4de4a04897ac4$export$1cc887c62079ea32 = $f6c4de4a04897ac4$var$createRelayResourceImpl;
const $f6c4de4a04897ac4$export$bbe949b85c06f763 = $f6c4de4a04897ac4$var$createRelayResourceImpl;
const $f6c4de4a04897ac4$export$42ca7b248c7aaee = (resource, options)=>{
    const { data: queryReference, loading: loading, promise: promise } = (0, $eJrcF.useResource)(resource);
    if (options?.suspendWhenLoading && loading) throw promise;
    return {
        queryReference: queryReference
    };
};

});

parcelRegister("bBIDB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c207eec2783a5a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<548dce5f3093a745ef49c84b3ce6ff0a>>
 * @relayHash e4ce9f8843dbdebed75f10b1db93018b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 777e65f3b237e368c899bd286c50fd39a504013d25b78935ab342b7ec78669a4

var $9zQGn = parcelRequire("9zQGn");

var $dtG0v = parcelRequire("dtG0v");

var $cli8x = parcelRequire("cli8x");

var $l5K2d = parcelRequire("l5K2d");

var $5moL7 = parcelRequire("5moL7");

var $7m7yY = parcelRequire("7m7yY");

var $lhtKZ = parcelRequire("lhtKZ");

var $jhhgp = parcelRequire("jhhgp");

var $eSxxM = parcelRequire("eSxxM");

var $em6ga = parcelRequire("em6ga");

var $eEnEt = parcelRequire("eEnEt");
const $9c207eec2783a5a9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOverviewsExpanded"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = {
        "kind": "ScalarField",
        "name": "label"
    }, v15 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v16 = {
        "kind": "ScalarField",
        "name": "url"
    }, v17 = {
        "order": "DESC"
    }, v18 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v19 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v20 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v21 = {
        "kind": "ScalarField",
        "name": "status"
    }, v22 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v23 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "name"
    }, v25 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v27 = [
        v16 /*: any*/ 
    ], v28 = {
        "kind": "InlineFragment",
        "selections": [
            v10 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v29 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v13 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v27 /*: any*/ ,
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v28 /*: any*/ 
        ]
    }, v30 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v31 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v32 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v33 = [
        {
            "kind": "ScalarField",
            "name": "webUrl"
        }
    ], v34 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx",
        "kind": "Condition",
        "passingValue": false,
        "selections": v33 /*: any*/ 
    }, v35 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": v33 /*: any*/ 
    }, v36 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v33 /*: any*/ 
    }, v37 = [
        v10 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ ,
        v22 /*: any*/ ,
        v23 /*: any*/ ,
        v24 /*: any*/ ,
        v25 /*: any*/ ,
        v26 /*: any*/ ,
        v29 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ ,
        v32 /*: any*/ ,
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ 
    ], v38 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v39 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v40 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v37 /*: any*/ 
            }
        ]
    }, v41 = [
        v40 /*: any*/ ,
        v38 /*: any*/ 
    ], v42 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v43 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v44 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v10 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v45 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v13 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v10 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                v26 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v27 /*: any*/ ,
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v28 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v28 /*: any*/ 
            ]
        }
    ], v46 = [
        v10 /*: any*/ ,
        v24 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ConfigurableMenuItems"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v1 /*: any*/ ,
                v9 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudID",
                                            "variableName": "cloudId"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "navKey",
                                            "value": "NAV_SIDEBAR"
                                        }
                                    ],
                                    "concreteType": "JiraUserNavigationConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userNavigationConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraConfigurableNavigationItem",
                                            "kind": "LinkedField",
                                            "name": "navItems",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "menuId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isVisible"
                                                }
                                            ]
                                        },
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isProjectsExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "hasIsProjectsExpanded",
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canCreateProject",
                                    "args": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "CREATE_PROJECT"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "shouldDisplay",
                                            "args": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "VIEW_PROJECT_CREATION_ENTRY"
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isFiltersExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "hasIsFiltersExpanded",
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isAppsExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "globalAppNavigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appType"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v15 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v14 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v14 /*: any*/ ,
                                                                                        v16 /*: any*/ ,
                                                                                        v15 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "settingsUrl"
                                                                        },
                                                                        v16 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                    "kind": "LinkedField",
                                    "name": "jwmOverviews",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isPlansExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "hasIsPlansExpanded",
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraAdvancedRoadmapsNavigation",
                                    "kind": "LinkedField",
                                    "name": "advancedRoadmapsNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasEditPermissions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasCreateSamplePlanPermissions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasGlobalPlansAdminPermissions"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isProjectsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraWorkManagementLicensing",
                                            "kind": "LinkedField",
                                            "name": "jwmLicensing",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "currentUserSeatEdition"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "alias": "favouriteProjects",
                                                    "args": [
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "sort": v17 /*: any*/ ,
                                                                "type": "PROJECT"
                                                            }
                                                        },
                                                        v18 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraFavouriteConnection",
                                                    "kind": "LinkedField",
                                                    "name": "favourites",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraFavouriteEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v37 /*: any*/ ,
                                                                            "type": "JiraProject"
                                                                        },
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v38 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        v11 /*: any*/ ,
                                                        v39 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraProjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "recentProjects",
                                                    "plural": false,
                                                    "selections": v41 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GrowthRecQuery",
                                                    "kind": "LinkedField",
                                                    "name": "growthRecommendations",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "fields": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "product",
                                                                            "value": "jira"
                                                                        },
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "tenantId",
                                                                            "variableName": "cloudId"
                                                                        },
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "useCase",
                                                                            "value": "jiraProjectMenuRecommendations"
                                                                        }
                                                                    ],
                                                                    "kind": "ObjectValue",
                                                                    "name": "context"
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 2
                                                                }
                                                            ],
                                                            "kind": "LinkedField",
                                                            "name": "recommendations",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v13 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "entityId"
                                                                                        }
                                                                                    ],
                                                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "GrowthRecRecommendations"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "entityAri",
                                                            "variableName": "entityAriProjects"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "ownerAri",
                                                            "variableName": "ownerAri"
                                                        }
                                                    ],
                                                    "concreteType": "SettingsNavigationCustomisation",
                                                    "kind": "LinkedField",
                                                    "name": "settings_navigationCustomisation",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "SettingsDisplayPropertyConnection",
                                                            "kind": "LinkedField",
                                                            "name": "properties",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "SettingsDisplayProperty",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "key"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraProjectsSidebarMenu",
                                            "kind": "LinkedField",
                                            "name": "jira_projectsSidebarMenu",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "mostRecent",
                                                    "plural": false,
                                                    "selections": v37 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "mostRecentFromHistory",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v29 /*: any*/ ,
                                                        v30 /*: any*/ ,
                                                        v31 /*: any*/ ,
                                                        v32 /*: any*/ ,
                                                        v34 /*: any*/ ,
                                                        v35 /*: any*/ ,
                                                        v36 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        v18 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraProjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "favourites",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v40 /*: any*/ ,
                                                        v38 /*: any*/ 
                                                    ],
                                                    "storageKey": "favourites(first:15)"
                                                },
                                                {
                                                    "args": [
                                                        v39 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraProjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "recents",
                                                    "plural": false,
                                                    "selections": v41 /*: any*/ ,
                                                    "storageKey": "recents(first:20)"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasMore"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "favouriteLimit"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "recentLimit"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayMode"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isFiltersExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": "favouriteFilters",
                                            "args": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v17 /*: any*/ ,
                                                        "type": "FILTER"
                                                    }
                                                },
                                                v18 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v42 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        v44 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                },
                                                                v28 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v38 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "recentFilters",
                                            "args": [
                                                v11 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "types",
                                                    "value": [
                                                        "FILTER"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "JiraSearchableEntityConnection",
                                            "kind": "LinkedField",
                                            "name": "recentItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSearchableEntityEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v42 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v24 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v43 /*: any*/ ,
                                                                                v44 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraFilter",
                                                                            "abstractKey": "__isJiraFilter"
                                                                        }
                                                                    ],
                                                                    "type": "JiraCustomFilter"
                                                                },
                                                                v28 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v38 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraSystemFilterConnection",
                                            "kind": "LinkedField",
                                            "name": "systemFilters",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilterEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSystemFilter",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        v44 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isPlansExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": "favouritePlans",
                                            "args": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v17 /*: any*/ ,
                                                        "type": "PLAN"
                                                    }
                                                },
                                                v18 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v45 /*: any*/ 
                                                },
                                                v38 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "recentPlans",
                                            "args": [
                                                v11 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "types",
                                                    "value": [
                                                        "PLAN"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "JiraSearchableEntityConnection",
                                            "kind": "LinkedField",
                                            "name": "recentItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSearchableEntityEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v45 /*: any*/ 
                                                },
                                                v38 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isOperationsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "OpsgenieQuery",
                                    "kind": "LinkedField",
                                    "name": "opsgenie",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "OpsgenieSavedSearches",
                                            "kind": "LinkedField",
                                            "name": "savedSearches",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "OpsgenieSavedSearch",
                                                    "kind": "LinkedField",
                                                    "name": "sharedWithMe",
                                                    "plural": true,
                                                    "selections": v46 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "OpsgenieSavedSearch",
                                                    "kind": "LinkedField",
                                                    "name": "createdByMe",
                                                    "plural": true,
                                                    "selections": v46 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isOverviewsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                            "kind": "LinkedField",
                                            "name": "jwmOverviews",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraWorkManagementGiraOverview",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                v24 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "777e65f3b237e368c899bd286c50fd39a504013d25b78935ab342b7ec78669a4",
            "metadata": {},
            "name": "L1MenuItemsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $jhhgp.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $dtG0v.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $cli8x.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": (0, $eEnEt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider": (0, $l5K2d.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $7m7yY.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $lhtKZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": (0, $5moL7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $eSxxM.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": (0, $9zQGn.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": (0, $em6ga.default)
            }
        }
    };
}();
$9c207eec2783a5a9$var$node.hash = "fffe23a56118d84dd30e01387c939a22";
var $9c207eec2783a5a9$export$2e2bcd8739ae039 = $9c207eec2783a5a9$var$node;

});
parcelRegister("9zQGn", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d4cac831a774767$export$2e2bcd8739ae039);

var $epTsa = parcelRequire("epTsa");
var $4d4cac831a774767$export$2e2bcd8739ae039 = {
    get () {
        return (0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false);
    }
};

});

parcelRegister("dtG0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $63f7d731301be654$export$2e2bcd8739ae039);

var $epTsa = parcelRequire("epTsa");
var $63f7d731301be654$export$2e2bcd8739ae039 = {
    get () {
        return (0, $epTsa.expVal)('blu-6315-display-settings-a-part-1', 'isEnabled', false);
    }
};

});

parcelRegister("cli8x", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4603c488541d3d8$export$2e2bcd8739ae039);

var $epTsa = parcelRequire("epTsa");
var $d4603c488541d3d8$export$2e2bcd8739ae039 = {
    get () {
        return (0, $epTsa.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false);
    }
};

});

parcelRegister("l5K2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef97bb84d17cf29$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $3ef97bb84d17cf29$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('blu-7436-separate-growth-rec');
    }
};

});

parcelRegister("5moL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6adb616ba86c8a9a$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $6adb616ba86c8a9a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('blu-8022_refactor_jpd_project_menu_to_common');
    }
};

});

parcelRegister("7m7yY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c894ab891a883b9$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $7jTnu = parcelRequire("7jTnu");
var $7c894ab891a883b9$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('blu-3929-sidebar-menu-recommended');
    }
};

});

parcelRegister("lhtKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a53aade22d0a15d3$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $a53aade22d0a15d3$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jcs_project_type_m3');
    }
};

});

parcelRegister("jhhgp", function(module, exports) {

$parcel$export(module.exports, "default", () => $27d2e2844d6132da$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $27d2e2844d6132da$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('allow_end_users_to_access_custom_templates');
    }
};

});

parcelRegister("eSxxM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f962c415abaf11a$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $6f962c415abaf11a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jsm_aiiy_for_nav_item_sidebar');
    }
};

});

parcelRegister("em6ga", function(module, exports) {

$parcel$export(module.exports, "default", () => $db0bf42d04d7e409$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $7jTnu = parcelRequire("7jTnu");
var $db0bf42d04d7e409$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('project-actions-sync-iv-llc');
    }
};

});

parcelRegister("eEnEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cb512a18f102874$export$2e2bcd8739ae039);

var $epTsa = parcelRequire("epTsa");
var $7cb512a18f102874$export$2e2bcd8739ae039 = {
    get () {
        return (0, $epTsa.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) || (0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false);
    }
};

});


parcelRegister("hOoYL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c09a8bcbde12b5a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5115ff33a71779ea2998875f4e37eb58>>
 * @relayHash 2166d8d37d2e3ef4bf77f06d60ad7574
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9bc3c19d8a70692e667edf5f8ab33de07cbacfb0efd83cfedbe8b4e1690d6c3
const $c09a8bcbde12b5a5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v3 = {
        "kind": "ScalarField",
        "name": "leftSidebarWidth"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b9bc3c19d8a70692e667edf5f8ab33de07cbacfb0efd83cfedbe8b4e1690d6c3",
            "metadata": {},
            "name": "sidebarSelectorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c09a8bcbde12b5a5$var$node.hash = "87261aab5010f6e217d4869107282805";
var $c09a8bcbde12b5a5$export$2e2bcd8739ae039 = $c09a8bcbde12b5a5$var$node;

});

parcelRegister("fKh2A", function(module, exports) {

$parcel$export(module.exports, "JiraNavigationSettingsAri", () => $b7685ed214380de6$export$d53f27b41a9a02bb);

var $02tnb = parcelRequire("02tnb");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/navigation-settings/manifest.ts
var $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $02tnb.JiraNavigationSettingsAriResourceOwner),
    resourceType: (0, $02tnb.JiraNavigationSettingsAriResourceType),
    resourceIdSlug: "activation/{activationId}/{navigationSettingScope}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        navigationSettingScope: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/navigation-settings/index.ts
var $b7685ed214380de6$export$d53f27b41a9a02bb = class _JiraNavigationSettingsAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._navigationSettingScope = opts.resourceIdSegmentValues.navigationSettingScope;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get navigationSettingScope() {
        return this._navigationSettingScope;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts.qualifier,
            platformQualifier: $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts.resourceOwner,
            resourceType: $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.navigationSettingScope}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                navigationSettingScope: opts.navigationSettingScope
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            navigationSettingScope: this.navigationSettingScope
        };
    }
};

});
parcelRegister("02tnb", function(module, exports) {

$parcel$export(module.exports, "JiraNavigationSettingsAriResourceOwner", () => $0076f8d914be1751$export$a71eb7f052c3a8f1);
$parcel$export(module.exports, "JiraNavigationSettingsAriResourceType", () => $0076f8d914be1751$export$8c9eb6c30d1db6dc);
// src/jira/navigation-settings/types.ts
var $0076f8d914be1751$export$a71eb7f052c3a8f1 = "jira", $0076f8d914be1751$export$8c9eb6c30d1db6dc = "navigation-settings";

});


parcelRegister("7Cu03", function(module, exports) {

$parcel$export(module.exports, "IdentityUserAri", () => $58c35a58a97fa779$export$1e9d09c2be53e55e);

var $6A8mn = parcelRequire("6A8mn");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/identity/user/manifest.ts
var $58c35a58a97fa779$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6A8mn.IdentityUserAriResourceOwner),
    resourceType: (0, $6A8mn.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $58c35a58a97fa779$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._userId = opts.resourceIdSegmentValues.userId;
    }
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $58c35a58a97fa779$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $58c35a58a97fa779$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $58c35a58a97fa779$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $58c35a58a97fa779$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $58c35a58a97fa779$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $58c35a58a97fa779$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
};

});
parcelRegister("6A8mn", function(module, exports) {

$parcel$export(module.exports, "IdentityUserAriResourceOwner", () => $4cac96fbba13502a$export$b4c14c54282a779d);
$parcel$export(module.exports, "IdentityUserAriResourceType", () => $4cac96fbba13502a$export$e9b50e20f4fbfb71);
// src/identity/user/types.ts
var $4cac96fbba13502a$export$b4c14c54282a779d = "identity", $4cac96fbba13502a$export$e9b50e20f4fbfb71 = "user";

});



parcelRegister("6JmRt", function(module, exports) {

$parcel$export(module.exports, "navPlatformSidebarResource", () => $096168d79e374d02$export$b22e51bad3fbae1b);

var $h4Bzb = parcelRequire("h4Bzb");

var $kWbWF = parcelRequire("kWbWF");

var $b1DBy = parcelRequire("b1DBy");

var $9FYIg = parcelRequire("9FYIg");

var $fKh2A = parcelRequire("fKh2A");

var $7Cu03 = parcelRequire("7Cu03");

var $goBB5 = parcelRequire("goBB5");

var $QuA6u = parcelRequire("QuA6u");
const $096168d79e374d02$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM = 'RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM';
const $096168d79e374d02$export$b22e51bad3fbae1b = (0, $9FYIg.createRelayResource)({
    type: $096168d79e374d02$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId, activationId: activationId, atlassianAccountId: atlassianAccountId } })=>{
        const initialSelectedPath = (0, $kWbWF.getInitialSelectedPath)(routerContext);
        return {
            parameters: (0, $QuA6u.default),
            variables: {
                cloudId: cloudId,
                entityAriUserSideNavSettings: (0, $goBB5.JiraWorkspaceAri).create({
                    siteId: cloudId,
                    activationId: activationId
                }).toString(),
                isAppsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_APPS)),
                isFiltersExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_OPERATIONS)),
                isOverviewsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_OVERVIEWS)),
                entityAriProjects: (0, $fKh2A.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'projects'
                }).toString(),
                ownerAri: atlassianAccountId && (0, $7Cu03.IdentityUserAri).create({
                    userId: atlassianAccountId
                }).toString()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    },
    isCritical: true
});

});
parcelRegister("goBB5", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAri", () => $befc0d413a701cce$export$d4d0794234e3fd53);

var $1JOdS = parcelRequire("1JOdS");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/workspace/manifest.ts
var $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $1JOdS.JiraWorkspaceAriResourceOwner),
    resourceType: (0, $1JOdS.JiraWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/jira/workspace/index.ts
var $befc0d413a701cce$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
};

});
parcelRegister("1JOdS", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", () => $1440f3a3433d3385$export$e52ccdf6abac8896);
$parcel$export(module.exports, "JiraWorkspaceAriResourceType", () => $1440f3a3433d3385$export$669cd5f7b3746bb);
// src/jira/workspace/types.ts
var $1440f3a3433d3385$export$e52ccdf6abac8896 = "jira", $1440f3a3433d3385$export$669cd5f7b3746bb = "workspace";

});


parcelRegister("QuA6u", function(module, exports) {

$parcel$export(module.exports, "default", () => $765bd4a1f1362765$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e6ee8554f7d50638ea8fb159a878f057>>
 * @relayHash 27dbf40d8bbfe18feb75098a8bfa4551
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b6f73f92775bb639f274c5ff6ae158ae1f4bb39732bbffe65228d1510c12e68

var $9zQGn = parcelRequire("9zQGn");

var $dtG0v = parcelRequire("dtG0v");

var $cli8x = parcelRequire("cli8x");

var $l5K2d = parcelRequire("l5K2d");

var $5moL7 = parcelRequire("5moL7");

var $7m7yY = parcelRequire("7m7yY");

var $lhtKZ = parcelRequire("lhtKZ");

var $jhhgp = parcelRequire("jhhgp");

var $eSxxM = parcelRequire("eSxxM");

var $em6ga = parcelRequire("em6ga");

var $eEnEt = parcelRequire("eEnEt");
const $765bd4a1f1362765$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriUserSideNavSettings"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOverviewsExpanded"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v10 = {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
    }, v11 = {
        "concreteType": "SettingsDisplayPropertyConnection",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsDisplayProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v14 = [
        v13 /*: any*/ 
    ], v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = {
        "kind": "ScalarField",
        "name": "label"
    }, v17 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v18 = {
        "kind": "ScalarField",
        "name": "url"
    }, v19 = {
        "order": "DESC"
    }, v20 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v21 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v23 = {
        "kind": "ScalarField",
        "name": "name"
    }, v24 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v25 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v12 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v28 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v29 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v30 = [
        v12 /*: any*/ ,
        v23 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ], v31 = [
        v18 /*: any*/ 
    ], v32 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v15 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v12 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                v24 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v12 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v31 /*: any*/ ,
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v27 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v27 /*: any*/ 
            ]
        }
    ], v33 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v34 = {
        "kind": "ScalarField",
        "name": "status"
    }, v35 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v36 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v38 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v15 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v31 /*: any*/ ,
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v27 /*: any*/ 
        ]
    }, v39 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v40 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v41 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v42 = [
        {
            "kind": "ScalarField",
            "name": "webUrl"
        }
    ], v43 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx",
        "kind": "Condition",
        "passingValue": false,
        "selections": v42 /*: any*/ 
    }, v44 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": v42 /*: any*/ 
    }, v45 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v42 /*: any*/ 
    }, v46 = [
        v12 /*: any*/ ,
        v33 /*: any*/ ,
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ ,
        v23 /*: any*/ ,
        v37 /*: any*/ ,
        v24 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ ,
        v41 /*: any*/ ,
        v43 /*: any*/ ,
        v44 /*: any*/ ,
        v45 /*: any*/ 
    ], v47 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v46 /*: any*/ 
            }
        ]
    }, v48 = [
        v47 /*: any*/ ,
        v28 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GSNForContentSidebarQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useNetworkSideNavUserData"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Apps"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Filters"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Operations"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Overviews"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Plans"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Projects"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v9 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "GSNForContentSidebarQuery",
            "selections": [
                {
                    "alias": "userSideNavSettings",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "entityAriUserSideNavSettings"
                        },
                        v10 /*: any*/ 
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsMenuItemConnection",
                            "kind": "LinkedField",
                            "name": "sidebar",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SettingsMenuItem",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "menuId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "visible"
                                        }
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ ,
                        v12 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "globalAppNavigationItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "envLabel"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppSection",
                                                                    "kind": "LinkedField",
                                                                    "name": "sections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v16 /*: any*/ ,
                                                                                v18 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "settingsUrl"
                                                                },
                                                                v18 /*: any*/ 
                                                            ],
                                                            "type": "JiraAppNavigationItem"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isFiltersExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsFiltersExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                }
                            ]
                        },
                        {
                            "condition": "isProjectsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsProjectsExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "shouldDisplay",
                                    "args": [
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "VIEW_PROJECT_CREATION_ENTRY"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isPlansExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsPlansExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "JiraAdvancedRoadmapsNavigation",
                            "kind": "LinkedField",
                            "name": "advancedRoadmapsNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasEditPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCreateSamplePlanPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasGlobalPlansAdminPermissions"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v19 /*: any*/ ,
                                                "type": "FILTER"
                                            }
                                        },
                                        v20 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                v23 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v24 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v27 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v28 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentFilters",
                                    "args": [
                                        v13 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "FILTER"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v23 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ],
                                                            "type": "JiraCustomFilter"
                                                        },
                                                        v27 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v28 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraSystemFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "systemFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v23 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v24 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOperationsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "OpsgenieQuery",
                            "kind": "LinkedField",
                            "name": "opsgenie",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "OpsgenieSavedSearches",
                                    "kind": "LinkedField",
                                    "name": "savedSearches",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": v30 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": v30 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOverviewsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                    "kind": "LinkedField",
                                    "name": "jwmOverviews",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraWorkManagementGiraOverview",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v23 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouritePlans",
                                    "args": [
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v19 /*: any*/ ,
                                                "type": "PLAN"
                                            }
                                        },
                                        v20 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v32 /*: any*/ 
                                        },
                                        v28 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentPlans",
                                    "args": [
                                        v13 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PLAN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v32 /*: any*/ 
                                        },
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isProjectsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementLicensing",
                                    "kind": "LinkedField",
                                    "name": "jwmLicensing",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "currentUserSeatEdition"
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "favouriteProjects",
                                            "args": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v19 /*: any*/ ,
                                                        "type": "PROJECT"
                                                    }
                                                },
                                                v20 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v46 /*: any*/ ,
                                                                    "type": "JiraProject"
                                                                },
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v28 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                v13 /*: any*/ ,
                                                v29 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recentProjects",
                                            "plural": false,
                                            "selections": v48 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "GrowthRecQuery",
                                            "kind": "LinkedField",
                                            "name": "growthRecommendations",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "fields": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "product",
                                                                    "value": "jira"
                                                                },
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "tenantId",
                                                                    "variableName": "cloudId"
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "useCase",
                                                                    "value": "jiraProjectMenuRecommendations"
                                                                }
                                                            ],
                                                            "kind": "ObjectValue",
                                                            "name": "context"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 2
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "recommendations",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "entityId"
                                                                                }
                                                                            ],
                                                                            "type": "GrowthRecJiraTemplateRecommendation"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GrowthRecRecommendations"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "entityAri",
                                                    "variableName": "entityAriProjects"
                                                },
                                                v10 /*: any*/ 
                                            ],
                                            "concreteType": "SettingsNavigationCustomisation",
                                            "kind": "LinkedField",
                                            "name": "settings_navigationCustomisation",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraProjectsSidebarMenu",
                                    "kind": "LinkedField",
                                    "name": "jira_projectsSidebarMenu",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "mostRecent",
                                            "plural": false,
                                            "selections": v46 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "mostRecentFromHistory",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                v35 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v37 /*: any*/ ,
                                                v38 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                v40 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                v43 /*: any*/ ,
                                                v44 /*: any*/ ,
                                                v45 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                v20 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                v47 /*: any*/ ,
                                                v28 /*: any*/ 
                                            ],
                                            "storageKey": "favourites(first:15)"
                                        },
                                        {
                                            "args": [
                                                v29 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recents",
                                            "plural": false,
                                            "selections": v48 /*: any*/ ,
                                            "storageKey": "recents(first:20)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasMore"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "favouriteLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "recentLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayMode"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b6f73f92775bb639f274c5ff6ae158ae1f4bb39732bbffe65228d1510c12e68",
            "metadata": {},
            "name": "GSNForContentSidebarQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $jhhgp.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $dtG0v.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $cli8x.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": (0, $eEnEt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider": (0, $l5K2d.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $7m7yY.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $lhtKZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": (0, $5moL7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $eSxxM.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": (0, $9zQGn.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": (0, $em6ga.default)
            }
        }
    };
}();
$765bd4a1f1362765$var$node.hash = "1f851aebed21c153d2ce5eab4dad43e3";
var $765bd4a1f1362765$export$2e2bcd8739ae039 = $765bd4a1f1362765$var$node;

});


parcelRegister("8J0lu", function(module, exports) {

$parcel$export(module.exports, "topNav4UIStateResource", () => $0edd5604b861f0e1$export$2d81c2e40eea9fba);

var $9FYIg = parcelRequire("9FYIg");

var $54NUw = parcelRequire("54NUw");
const $0edd5604b861f0e1$export$2d81c2e40eea9fba = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_TOPNAV_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous, atlassianAccountId: atlassianAccountId } })=>({
            parameters: (0, $54NUw.default),
            variables: {
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                atlassianAccountId: atlassianAccountId ?? ''
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true
});

});
parcelRegister("54NUw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d713ab7eb601b870$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<391e7740c7b99e475c4d071b74c06f09>>
 * @relayHash 43ca389fcb5965c44ec53c6ce4601d19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f8502149e58521990a2dbe3a4c17f2996f15bd289242e8eda23c25e8f61acb3
const $d713ab7eb601b870$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianAccountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AtlassianNavigationNav4Query",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "Nav4Profile"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "Nav4NotificationsData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AtlassianNavigationNav4Query",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "atlassianAccountId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "email"
                                        }
                                    ],
                                    "type": "AtlassianAccountUser"
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "InfluentsNotificationQuery",
                            "kind": "LinkedField",
                            "name": "notifications",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "unseenNotificationCount"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3f8502149e58521990a2dbe3a4c17f2996f15bd289242e8eda23c25e8f61acb3",
            "metadata": {},
            "name": "AtlassianNavigationNav4Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d713ab7eb601b870$var$node.hash = "90dcffc913e3e3d03ddfcca18a50a500";
var $d713ab7eb601b870$export$2e2bcd8739ae039 = $d713ab7eb601b870$var$node;

});


parcelRegister("SPYRa", function(module, exports) {

$parcel$export(module.exports, "navigationPlansVisibilityResource", () => $fdcc63ef33fd0b8d$export$fa475a9581133779);
$parcel$export(module.exports, "useNavigationPlansVisibility", () => $fdcc63ef33fd0b8d$export$4524245d4e74edb2);
$parcel$export(module.exports, "useNavigationViewPlansPermission", () => $fdcc63ef33fd0b8d$export$98eef08fd4586a4);
$parcel$export(module.exports, "useNavigationEditPlansPermission", () => $fdcc63ef33fd0b8d$export$525db876ed776e0d);
$parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", () => $fdcc63ef33fd0b8d$export$54805a2120a31ad0);

var $eSnSE = parcelRequire("eSnSE");

var $1Ozm9 = parcelRequire("1Ozm9");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $fdcc63ef33fd0b8d$export$fa475a9581133779 = (0, $l1VxS.createResource)({
    type: (0, $19cf35753fa41a8f$export$9260ddb6dfeafd7b),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return false;
            const response = await (0, $1Ozm9.default)('/rest/jpo/1.0/navigation/simple');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $19cf35753fa41a8f$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
        }
        return false;
    },
    maxAge: Infinity,
    isCritical: true
});
const $fdcc63ef33fd0b8d$export$4524245d4e74edb2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let isVisible = false;
    if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
    return [
        isVisible
    ];
};
const $fdcc63ef33fd0b8d$export$98eef08fd4586a4 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let hasEditOrViewPermissions = false;
    if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
    return [
        hasEditOrViewPermissions
    ];
};
const $fdcc63ef33fd0b8d$export$525db876ed776e0d = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let canEditPlans = false;
    if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
    return canEditPlans;
};
const $fdcc63ef33fd0b8d$export$54805a2120a31ad0 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let isAdvancedRoadmapsTrial = false;
    if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
    return isAdvancedRoadmapsTrial;
};

});
const $19cf35753fa41a8f$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $19cf35753fa41a8f$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';


parcelRegister("5MeEd", function(module, exports) {

$parcel$export(module.exports, "getConsentBannerUserPreferencesResource", () => $1f6c6844ab578de1$export$a40d52e504d1db7c);
$parcel$export(module.exports, "useConsentBannerUserPreferencesResource", () => $1f6c6844ab578de1$export$5bc7e83e85567fb4);
// eslint-disable-next-line jira/import-whitelist

var $2Z1Gy = parcelRequire("2Z1Gy");

var $9YRcI = parcelRequire("9YRcI");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $7jTnu = parcelRequire("7jTnu");

var $aYncF = parcelRequire("aYncF");

const $1f6c6844ab578de1$var$consentBannerUserPreferencesResourceOld = (0, $l1VxS.createResource)({
    type: (0, $e5cddec8694808c6$export$c5397b7748ed6c7b),
    getKey: ()=>(0, $e5cddec8694808c6$export$4a9dd42dbc707155),
    getData: async ()=>{
        const consentToken = (0, $9YRcI.getCookie)((0, $2Z1Gy.ATLASSIAN_CONSENT_COOKIE_KEY));
        const fallbackConsentToken = (0, $9YRcI.getCookie)((0, $2Z1Gy.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        // If we have cached cookie data, bundle it up, with a potential fallback token
        if (consentToken) return {
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken
        };
        const data = await (0, $jGzN3.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        return data;
    },
    maxAge: 900000,
    isBrowserOnly: true
});
const $1f6c6844ab578de1$var$consentBannerUserPreferencesResourceNew = (0, $l1VxS.createResource)({
    type: (0, $e5cddec8694808c6$export$f0cdd7d2fbfd00ff),
    getKey: ()=>(0, $e5cddec8694808c6$export$4a9dd42dbc707155),
    getData: async ()=>{
        const consentToken = (0, $9YRcI.getCookie)((0, $2Z1Gy.ATLASSIAN_CONSENT_COOKIE_KEY), true);
        const fallbackConsentToken = (0, $9YRcI.getCookie)((0, $2Z1Gy.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), true);
        const shouldShowBannerBit = (0, $9YRcI.getCookie)((0, $2Z1Gy.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), true);
        const shouldShowBanner = shouldShowBannerBit !== undefined && shouldShowBannerBit !== null ? !!Number(shouldShowBannerBit) : undefined;
        // If we have cached cookie data, bundle it up, with a potential fallback token
        if (consentToken) return {
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken,
            shouldShowBanner: shouldShowBanner
        };
        /**
			 * On server we need to request the api using a server to server api (atl-preferences-center-elb)
			 * otherwise the request will not be authenticated correctly.
			 *
			 * However Pillar does not support ASAP, so we need to use the client side api call in local development.
			 *
			 * See https://atlassian.slack.com/archives/C017Y3EPAQ4/p1754626460768439?thread_ts=1754601759.549879&cid=C017Y3EPAQ4
			 */ const isPillarLocalDevelopment = globalThis.localDevContext?.PILLAR_LOCAL_DEVELOPMENT ?? false;
        if (false && !isPillarLocalDevelopment) {
            const hostEnv = (0, $aYncF.getEnvironment)() === 'prod' ? 'prod' : 'staging';
            const userId = (0, $aYncF.getAtlassianAccountId)();
            if (userId) {
                const data = await (0, $jGzN3.performGetRequest)(`https://atl-preferences-center-elb.${hostEnv}.atl-paas.net/rest/user/${userId}/consents/cookies`, {
                    credentials: 'include',
                    headers: {
                        'x-ssr-service-name': 'atl-preferences-center'
                    }
                });
                return data;
            }
        }
        const data = await (0, $jGzN3.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        return data;
    },
    maxAge: 900000,
    isBrowserOnly: false,
    isCritical: true
});
const $1f6c6844ab578de1$export$a40d52e504d1db7c = ()=>{
    if ((0, $7jTnu.fg)('jfp-magma-ssr-iv-cookie-consent-banner')) return $1f6c6844ab578de1$var$consentBannerUserPreferencesResourceNew;
    return $1f6c6844ab578de1$var$consentBannerUserPreferencesResourceOld;
};
const $1f6c6844ab578de1$export$5bc7e83e85567fb4 = ()=>(0, $eJrcF.useResource)($1f6c6844ab578de1$export$a40d52e504d1db7c());

});
parcelRegister("9YRcI", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $cab6b0210ca24ec3$export$4be65e66cfa2648a);

var $apfB4 = parcelRequire("apfB4");
function $cab6b0210ca24ec3$export$4be65e66cfa2648a(key) {
    return key ? (0, $apfB4.getCookie)(key) : (0, $apfB4.getCookie)();
}

});

const $e5cddec8694808c6$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $e5cddec8694808c6$export$f0cdd7d2fbfd00ff = 'CONSENT_BANNER_USER_PREFERENCES_SSR';
const $e5cddec8694808c6$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';


parcelRegister("9CgFv", function(module, exports) {

$parcel$export(module.exports, "checkApiKeyManagementKeysResource", () => $8298e40e8fde4c1d$export$b16eaa5246afc9b6);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $br21R = parcelRequire("br21R");

var $dI30d = parcelRequire("dI30d");


var $l1VxS = parcelRequire("l1VxS");

const $8298e40e8fde4c1d$var$fetchCheckApiKeyManagementKeys = async (accountId, isSiteAdmin, isTransitioning, appPermissions)=>{
    if (!isTransitioning || !isSiteAdmin || appPermissions && appPermissions.hasServiceDeskAccess === false) return Promise.resolve(false);
    return (0, $br21R.eocFetch)(`/api-keys/web/check?accountId=${accountId}`).then(({ data: data })=>data);
};
const $8298e40e8fde4c1d$var$resource = (0, $l1VxS.createResource)({
    type: (0, $f417dca27ced17c4$export$5879151f0d972f18),
    getKey: ()=>'check-api-key-management-keys',
    getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, isSiteAdmin: isSiteAdmin } })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const tenantInfo = await dependencies[0, $f8747ec2695de8a7$export$25ee35b01de9d734]?.promise;
        const isTransitioning = (0, $dI30d.checkIsTransitioning)(tenantInfo);
        return $8298e40e8fde4c1d$var$fetchCheckApiKeyManagementKeys(atlassianAccountId, isSiteAdmin, isTransitioning, appPermissions);
    },
    maxAge: Infinity,
    isBrowserOnly: true,
    depends: [
        (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
    ],
    isCritical: true
});
const $8298e40e8fde4c1d$export$b16eaa5246afc9b6 = ()=>$8298e40e8fde4c1d$var$resource;

});
parcelRegister("dI30d", function(module, exports) {

$parcel$export(module.exports, "checkShouldUseJSM", () => $18fe81d8bf210fd5$export$5e0f3a0d8463fa21);
$parcel$export(module.exports, "checkIsTransitioning", () => $18fe81d8bf210fd5$export$d2f281fd4bf10855);
$parcel$export(module.exports, "checkIsConsolidated", () => $18fe81d8bf210fd5$export$57f75aebff17dd1e);
$parcel$export(module.exports, "checkIsTransitioned", () => $18fe81d8bf210fd5$export$b6461b23ee0e1471);
$parcel$export(module.exports, "checkIsTransitionEligible", () => $18fe81d8bf210fd5$export$24040115cac5fdc3);
$parcel$export(module.exports, "checkShouldAccessUnlockOperations", () => $18fe81d8bf210fd5$export$cd227238525e8d57);
$parcel$export(module.exports, "checkIsOpsAdmin", () => $18fe81d8bf210fd5$export$66a96ac2f07f6730);

var $htDO2 = parcelRequire("htDO2");

const $18fe81d8bf210fd5$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $htDO2.ConsolidationState).NOT_CONSOLIDATED;
};
const $18fe81d8bf210fd5$export$d2f281fd4bf10855 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $htDO2.ConsolidationState).TRANSITIONING;
};
const $18fe81d8bf210fd5$export$57f75aebff17dd1e = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $htDO2.ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, $htDO2.ConsolidationState).CONSOLIDATED;
};
const $18fe81d8bf210fd5$export$b6461b23ee0e1471 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $htDO2.ConsolidationState).TRANSITIONED;
};
const $18fe81d8bf210fd5$export$24040115cac5fdc3 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $htDO2.ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $73b7e0580d88d09b$export$650f6934db1290c1);
};
const $18fe81d8bf210fd5$export$cd227238525e8d57 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $htDO2.ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $73b7e0580d88d09b$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $73b7e0580d88d09b$export$a101f3562b5f0742));
};
const $18fe81d8bf210fd5$export$66a96ac2f07f6730 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? false : Boolean(tenantInfo.isAdmin);
};

});
const $73b7e0580d88d09b$export$650f6934db1290c1 = 'cohort3';
const $73b7e0580d88d09b$export$a101f3562b5f0742 = 'cohort3.5';


const $f417dca27ced17c4$export$5879151f0d972f18 = 'EOC_CHECK_API_KEY';


parcelRegister("graie", function(module, exports) {

$parcel$export(module.exports, "consolidationUserStateResource", () => $eafdd622df1b4c6c$export$4b870505c49999ef);

var $gYnSx = parcelRequire("gYnSx");

var $l1VxS = parcelRequire("l1VxS");

var $6HiIf = parcelRequire("6HiIf");

const $eafdd622df1b4c6c$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
const $eafdd622df1b4c6c$export$4b870505c49999ef = (0, $l1VxS.createResource)({
    type: $eafdd622df1b4c6c$var$RESOURCE_KEY,
    getKey: ()=>$eafdd622df1b4c6c$var$RESOURCE_KEY,
    getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, $6HiIf.getOgConsolidationUserState)(accountId).catch((error)=>{
            (0, $gYnSx.default)({
                meta: {
                    id: 'consolidationUserStateResource',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }),
    maxAge: Infinity,
    isCritical: true
});

});
parcelRegister("6HiIf", function(module, exports) {

$parcel$export(module.exports, "getOgConsolidationUserState", () => $ee117a4359e29127$export$df7594d56c9ebe57);

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

var $1uIew = parcelRequire("1uIew");

var $4I3Mw = parcelRequire("4I3Mw");
const $ee117a4359e29127$export$df7594d56c9ebe57 = (accountId)=>{
    if (!accountId) return Promise.resolve((0, $4I3Mw.ERROR_CONSOLIDATION_USER_STATE));
    return (0, $FppkK.getUserProperty)(accountId, (0, $4I3Mw.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
        if (!val || typeof val !== 'object') {
            (0, $gYnSx.default)({
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: new (0, $1uIew.ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                sendToPrivacyUnsafeSplunk: true
            });
            return 0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE;
        }
        if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
            ...(0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE),
            ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE), key)))
        };
        if (!Object.keys((0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) // Missing properties will happen when adding new properties to the type,
        // we are making sure they are filled in from the defaults
        return {
            ...(0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE),
            ...val
        };
        return val;
    }).catch((error)=>{
        // Property not saved yet, so we return the default values
        if (error instanceof (0, $1uIew.default) && error.statusCode === 404) return 0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE;
        throw error;
    });
};

});
parcelRegister("4I3Mw", function(module, exports) {

$parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", () => $afdd30cff85a4099$export$1980758e2622af02);
$parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", () => $afdd30cff85a4099$export$51d9907e9d716d);
$parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", () => $afdd30cff85a4099$export$23da4710c3a29eae);
const $afdd30cff85a4099$export$1980758e2622af02 = 'eoc_consolidation_user_state';
const $afdd30cff85a4099$export$51d9907e9d716d = {
    isPromotionBannerDismissed: false,
    isWelcomeModalDisplayed: false,
    isTransitionHomeHidden: false,
    isTransitionBannerDismissed: false,
    isBroadcastWidgetDismissed: false,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: false
};
const $afdd30cff85a4099$export$23da4710c3a29eae = {
    isPromotionBannerDismissed: true,
    isWelcomeModalDisplayed: true,
    isTransitionHomeHidden: true,
    isTransitionBannerDismissed: true,
    isBroadcastWidgetDismissed: true,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: true
};

});



parcelRegister("7JXbP", function(module, exports) {

$parcel$export(module.exports, "gicSmartFieldsFeatureResource", () => $be15d6a6239426da$export$ee94bb1f59b07e35);
$parcel$export(module.exports, "useIsSmartFieldsOptIn", () => $be15d6a6239426da$export$3870b1ff1b155c73);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $9DB7T = parcelRequire("9DB7T");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $be15d6a6239426da$export$ee94bb1f59b07e35 = (0, $l1VxS.createResource)({
    type: (0, $a6fb1066b3f16ba9$export$6f0555de4f60e84e),
    getKey: ()=>(0, $a6fb1066b3f16ba9$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            const data = await (0, $9DB7T.userPreferenceAPI).get((0, $a6fb1066b3f16ba9$export$b94951a11282ae6a));
            if (!data) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            };
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If value has never been set, we expect a 404
            if (error.statusCode === 404) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            };
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'gicSmartFieldsFeatureResource',
                    packageName: (0, $a6fb1066b3f16ba9$export$b8b9d90f9e5bd72b),
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            hasUserOptedOut: false,
            hasUserDismissedReadMore: false,
            hasUserDismissedGicOnboarding: false
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
});
const $be15d6a6239426da$export$3870b1ff1b155c73 = ()=>{
    const { data: data, update: update, loading: loading } = (0, $eJrcF.useResource)($be15d6a6239426da$export$ee94bb1f59b07e35);
    const currentOptInStatus = typeof data?.hasUserOptedOut === 'boolean' ? !data.hasUserOptedOut : true;
    const currentDismissedReadMore = typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false;
    const currentDismissedGicOnboarding = typeof data?.hasUserDismissedGicOnboarding === 'boolean' ? data.hasUserDismissedGicOnboarding : false;
    const dismissReadMore = (0, $eJOHy.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                hasUserDismissedReadMore: true,
                ...previousData?.hasUserDismissedGicOnboarding ? {
                    hasUserDismissedGicOnboarding: previousData.hasUserDismissedGicOnboarding
                } : {
                    hasUserDismissedGicOnboarding: false
                }
            }));
    }, [
        update
    ]);
    const dismissGicOnboarding = (0, $eJOHy.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                ...previousData?.hasUserDismissedReadMore ? {
                    hasUserDismissedReadMore: previousData.hasUserDismissedReadMore
                } : {
                    hasUserDismissedReadMore: false
                },
                hasUserDismissedGicOnboarding: true
            }));
    }, [
        update
    ]);
    return {
        isSmartFieldsOptIn: loading ? null : currentOptInStatus,
        isSmartFieldDismissedReadMore: loading ? null : currentDismissedReadMore,
        isSmartFieldsGicOnboardingDismissed: loading ? null : currentDismissedGicOnboarding,
        dismissReadMore: dismissReadMore,
        dismissGicOnboarding: dismissGicOnboarding,
        loading: loading
    };
};

});
parcelRegister("9DB7T", function(module, exports) {

$parcel$export(module.exports, "userPreferenceAPI", () => $0f97d523fbd91473$export$4f7929ca6b50a436);


var $jGzN3 = parcelRequire("jGzN3");
const $0f97d523fbd91473$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
const $0f97d523fbd91473$var$get = async (key)=>{
    try {
        const result = await (0, $jGzN3.performGetRequest)($0f97d523fbd91473$var$url(key));
        return result?.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === (0, $44ccf6b895337c89$export$8bca792d963eb0ef)) return null;
        throw error;
    }
};
const $0f97d523fbd91473$var$set = (key, value)=>(0, $jGzN3.performPutRequest)($0f97d523fbd91473$var$url(key), {
        body: JSON.stringify({
            value: value
        })
    });
const $0f97d523fbd91473$var$remove = (key)=>(0, $jGzN3.performDeleteRequest)($0f97d523fbd91473$var$url(key));
const $0f97d523fbd91473$export$4f7929ca6b50a436 = {
    get: $0f97d523fbd91473$var$get,
    set: $0f97d523fbd91473$var$set,
    remove: $0f97d523fbd91473$var$remove
};

});

const $a6fb1066b3f16ba9$export$6f0555de4f60e84e = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
const $a6fb1066b3f16ba9$export$7e7d7930e22ba39f = 'gsf-opt-out-resource-key'; // value is global for user
const $a6fb1066b3f16ba9$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $a6fb1066b3f16ba9$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGicSmartFields';


parcelRegister("dRfS0", function(module, exports) {

$parcel$export(module.exports, "gicOptInStatusResources", () => $30cdb61faaf8fbb9$export$14c89b6b6a261524);

var $eSnSE = parcelRequire("eSnSE");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");


const $30cdb61faaf8fbb9$export$14c89b6b6a261524 = (0, $l1VxS.createResource)({
    type: (0, $3fe8c5f6b0b2dbf8$export$fe522736b61f6709),
    getKey: ()=>'gic_optin_status',
    getData: async ()=>{
        let gicOptInStatus = null;
        try {
            gicOptInStatus = await (0, $jGzN3.performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.statusCode !== 404) (0, $eSnSE.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
        }
        return {
            gicOptInStatus: gicOptInStatus ?? {
                isEnabled: false
            }
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
});

});
const $3fe8c5f6b0b2dbf8$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';


parcelRegister("7KVqh", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RESPONSE", () => $9ec642d55d80db11$export$32d9db53927095d3);
$parcel$export(module.exports, "incomingMailServerExpiryStatusResource", () => $9ec642d55d80db11$export$369caf52ed1ad2b1);
$parcel$export(module.exports, "useIncomingMailExpiryStatus", () => $9ec642d55d80db11$export$283aa034b7d4e2a0);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $9ec642d55d80db11$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, $jGzN3.performGetRequest)((0, $8e8a9e94fa1c2865$export$5bf8eb915287f5f4));
const $9ec642d55d80db11$export$32d9db53927095d3 = {
    isAdmin: false,
    showBanner: true,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $9ec642d55d80db11$export$369caf52ed1ad2b1 = (0, $l1VxS.createResource)({
    type: (0, $8e8a9e94fa1c2865$export$3b9494e0dfc4de09),
    getKey: ()=>(0, $8e8a9e94fa1c2865$export$f2f2f265ccc09f82),
    getData: async ()=>{
        let incomingMailServerExpiryStatus = null;
        try {
            incomingMailServerExpiryStatus = await $9ec642d55d80db11$var$fetchGetIncomingMailServerExpiryStatus();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'incomingMailServerExpiryStatus',
                    packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                    teamName: 'maverick'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $9ec642d55d80db11$export$32d9db53927095d3
        };
    },
    maxAge: 3600000,
    isCritical: true
});
const $9ec642d55d80db11$export$283aa034b7d4e2a0 = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, $eJrcF.useResource)($9ec642d55d80db11$export$369caf52ed1ad2b1);
    const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $eJOHy.useState)(()=>{
        if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
        return $9ec642d55d80db11$export$32d9db53927095d3;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eJOHy.useState)('not started');
    (0, $eJOHy.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.incomingMailServerExpiryStatus) {
            setResponseStatusGet('success');
            setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.incomingMailServerExpiryStatus
    ]);
    return {
        responseStatus: responseStatusGet,
        state: incomingMailServerExpiryStatus
    };
};

});
const $8e8a9e94fa1c2865$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $8e8a9e94fa1c2865$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $8e8a9e94fa1c2865$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';


parcelRegister("5yVUD", function(module, exports) {

$parcel$export(module.exports, "issueTransitionChangeboardingPreferencesResource", () => $ac40f8141f9f880e$export$1b6468a6eb7d9b09);
$parcel$export(module.exports, "useIssueTransitionChangeboardingPreferences", () => $ac40f8141f9f880e$export$e21c345b2538e96e);

var $eJOHy = parcelRequire("eJOHy");

var $exWdq = parcelRequire("exWdq");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $k1FO2 = parcelRequire("k1FO2");
const $ac40f8141f9f880e$export$1b6468a6eb7d9b09 = (0, $l1VxS.createResource)({
    type: (0, $k1FO2.RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES),
    getKey: ()=>(0, $k1FO2.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY),
    getData: async ()=>{
        let modalViewCount = 0;
        try {
            const apiResult = await (0, $jGzN3.performGetRequest)((0, $k1FO2.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API));
            if ((0, $7jTnu.fg)('modern_issue_transition_enable_benefits_modal')) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(apiResult, 'value') || !(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(apiResult, 'benefitsModalValue')) {
                    const error = new Error('Invalid preference value');
                    (0, $gYnSx.default)({
                        meta: {
                            id: 'issueTransitionChangeboardingPreferencesResource',
                            packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
                return {
                    numberOfTimesUserHasSeenChangeboarding: Number(apiResult.value) || 0,
                    benefitsModal: {
                        isDisabled: apiResult?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: apiResult?.benefitsModal?.nextDateToShowBenefitsModal || null
                    }
                };
            }
            if (typeof apiResult !== 'object' || !(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(apiResult, 'value')) {
                const error = new Error('Invalid preference value');
                (0, $gYnSx.default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesResource',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } else {
                modalViewCount = Number(apiResult.value);
                return {
                    numberOfTimesUserHasSeenChangeboarding: modalViewCount
                };
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) {
                if ((0, $7jTnu.fg)('modern_issue_transition_enable_benefits_modal')) return {
                    numberOfTimesUserHasSeenChangeboarding: 0,
                    benefitsModal: {
                        isDisabled: false,
                        nextDateToShowBenefitsModal: null
                    }
                };
                return {
                    numberOfTimesUserHasSeenChangeboarding: 0
                };
            }
            (0, $gYnSx.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesResource',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            numberOfTimesUserHasSeenChangeboarding: modalViewCount,
            benefitsModal: {
                isDisabled: true,
                nextDateToShowBenefitsModal: null
            }
        };
    },
    isCritical: true
});
const $ac40f8141f9f880e$export$e21c345b2538e96e = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $eJrcF.useResource)($ac40f8141f9f880e$export$1b6468a6eb7d9b09);
    const [issueTransitionChangeboardingPreference, setIssueTransitionChangeboardingPreference] = (0, $eJOHy.useState)(()=>{
        if ((0, $7jTnu.fg)('modern_issue_transition_enable_benefits_modal')) return {
            numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
            benefitsModal: {
                isDisabled: Boolean(data?.benefitsModal?.isDisabled),
                nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
            }
        };
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') return data.numberOfTimesUserHasSeenChangeboarding;
        return 0, $k1FO2.USER_SEEN_CARDINALITY_UNKNOWN;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eJOHy.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $eJOHy.useState)('not started');
    const updateIssueTranstitionChangeboardingPreferences = (0, $eJOHy.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        const body = typeof updates !== 'number' && (0, $7jTnu.fg)('modern_issue_transition_enable_benefits_modal') ? {
            value: updates?.numberOfTimesUserHasSeenChangeboarding,
            benefitsModal: {
                isDisabled: updates?.benefitsModal?.isDisabled,
                nextDateToShowBenefitsModal: updates?.benefitsModal?.nextDateToShowBenefitsModal
            }
        } : {
            value: updates
        };
        try {
            await (0, $jGzN3.performPutRequest)((0, $k1FO2.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API), {
                body: JSON.stringify(body)
            });
            setResponseStatusPut('success');
            let updateData;
            if (typeof updates !== 'number' && (0, $7jTnu.fg)('modern_issue_transition_enable_benefits_modal')) updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates?.numberOfTimesUserHasSeenChangeboarding,
                benefitsModal: {
                    isDisabled: updates?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(updates?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            };
            if (typeof updates === 'number') updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates
            };
            update(()=>updateData);
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if ((0, $7jTnu.fg)('modern_issue_transition_enable_benefits_modal')) {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference({
                numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                benefitsModal: {
                    isDisabled: data?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            });
            return;
        }
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference(data?.numberOfTimesUserHasSeenChangeboarding);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.numberOfTimesUserHasSeenChangeboarding,
        data?.benefitsModal?.isDisabled,
        data?.benefitsModal?.nextDateToShowBenefitsModal
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionChangeboardingPreference
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTranstitionChangeboardingPreferences
        }
    };
};

});
parcelRegister("exWdq", function(module, exports) {

var $1X4n0 = parcelRequire("1X4n0");

var $hnizX = parcelRequire("hnizX");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $a9714e29aa3d67ff$var$has(object, path) {
    return object != null && $hnizX(object, path, $1X4n0);
}
module.exports = $a9714e29aa3d67ff$var$has;

});
parcelRegister("1X4n0", function(module, exports) {
/** Used for built-in method references. */ var $16beb0f0df9137a5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $16beb0f0df9137a5$var$hasOwnProperty = $16beb0f0df9137a5$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $16beb0f0df9137a5$var$baseHas(object, key) {
    return object != null && $16beb0f0df9137a5$var$hasOwnProperty.call(object, key);
}
module.exports = $16beb0f0df9137a5$var$baseHas;

});


parcelRegister("k1FO2", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES", () => $913722475ca36197$export$d66d4b761db3d20f);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY", () => $913722475ca36197$export$79fd70b908f71ddd);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API", () => $913722475ca36197$export$e5007258addba8aa);
$parcel$export(module.exports, "USER_SEEN_CARDINALITY_UNKNOWN", () => $913722475ca36197$export$91880069e7e73b18);
$parcel$export(module.exports, "DURATION_IN_DAYS_DEFAULT", () => $913722475ca36197$export$9ccdfd91f2512a27);
const $913722475ca36197$export$d66d4b761db3d20f = 'issue_transition_changeboarding_preferences';
const $913722475ca36197$export$79fd70b908f71ddd = 'issue_transition_changeboarding_preferences_status';
const $913722475ca36197$export$e5007258addba8aa = '/rest/api/3/mypreferences?key=jira.its.changeboarding.preferences';
const $913722475ca36197$export$91880069e7e73b18 = -1;
const $913722475ca36197$export$9ccdfd91f2512a27 = 14;

});


parcelRegister("aYBjl", function(module, exports) {

$parcel$export(module.exports, "issueTransitionOptInStatusResource", () => $85b874e0c5483f16$export$5fbcf4d7a6d9c477);
$parcel$export(module.exports, "useIssueTransitionLabsOptIn", () => $85b874e0c5483f16$export$bc11d4816053db5c);

var $eJOHy = parcelRequire("eJOHy");

var $igNUx = parcelRequire("igNUx");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


var $804bQ = parcelRequire("804bQ");
/*
 * API Contract: https://hello.atlassian.net/wiki/spaces/JIE/pages/2983777277/Issue+Transition+Jira+Labs+Toggle+for+Legacy+Experience+Backend+API#API-Contract
 */ const $85b874e0c5483f16$var$fetchGetIssueTransitionOptInState = async ()=>(0, $jGzN3.performGetRequest)((0, $873d221d3411e09a$export$466b1c60da56c8ca));
const $85b874e0c5483f16$export$5fbcf4d7a6d9c477 = (0, $l1VxS.createResource)({
    type: (0, $873d221d3411e09a$export$eb01e12fc3db65c0),
    getKey: ()=>(0, $873d221d3411e09a$export$a964df7bc15d81e),
    getData: async ()=>{
        let issueTransitionOptInStatus = null;
        const isModernIssueTransitionSRBCohort = (0, $7jTnu.fg)('issue-transition-customisation-for-srb') || (0, $igNUx.isFedRamp)();
        const isModernITSRenderEnabled = (0, $7jTnu.fg)('render-modern-issue-transition') || (0, $igNUx.isFedRamp)();
        if (!isModernITSRenderEnabled) return {
            issueTransitionOptInStatus: {
                isEnabled: false,
                expiryTime: -1
            }
        };
        if (isModernIssueTransitionSRBCohort) return {
            issueTransitionOptInStatus: {
                isEnabled: true
            }
        };
        try {
            issueTransitionOptInStatus = await $85b874e0c5483f16$var$fetchGetIssueTransitionOptInState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'issueTransitionOptInStatusResource',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, $804bQ.default)()
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
});
const $85b874e0c5483f16$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, $jGzN3.performPutRequest)((0, $873d221d3411e09a$export$466b1c60da56c8ca), {
        body: JSON.stringify(payload)
    });
const $85b874e0c5483f16$export$bc11d4816053db5c = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $eJrcF.useResource)($85b874e0c5483f16$export$5fbcf4d7a6d9c477);
    const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $eJOHy.useState)(()=>{
        if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
        return (0, $804bQ.default)();
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eJOHy.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $eJOHy.useState)('not started');
    const updateIssueTransitionOptInStatus = (0, $eJOHy.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        try {
            const updatedPreferences = await $85b874e0c5483f16$var$fetchModifyIssueTransitionOptInState(updates);
            setResponseStatusPut('success');
            update(()=>({
                    issueTransitionOptInStatus: updatedPreferences
                }));
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $gYnSx.default)({
                error: err,
                meta: {
                    id: 'issueTransitionOptInStatusUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.issueTransitionOptInStatus) {
            setResponseStatusGet('success');
            setIssueTransitionOptInState(data.issueTransitionOptInStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.issueTransitionOptInStatus
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionLabsOptInState
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTransitionOptInStatus
        }
    };
};

});
const $873d221d3411e09a$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $873d221d3411e09a$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $873d221d3411e09a$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $873d221d3411e09a$export$880a78695d76498e = 8;

parcelRegister("804bQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce05f913d0b3b9bd$export$2e2bcd8739ae039);

var $igNUx = parcelRequire("igNUx");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");
const $ce05f913d0b3b9bd$var$getDefaultIssueTransitionLabsOptInState = ()=>{
    const isModernITSRenderEnabled = (0, $7jTnu.fg)('render-modern-issue-transition') || (0, $igNUx.isFedRamp)();
    if (!isModernITSRenderEnabled) return {
        isEnabled: false,
        expiryTime: -1
    };
    const isModernIssueTransitionSRBCohort = (0, $7jTnu.fg)('issue-transition-customisation-for-srb') || (0, $igNUx.isFedRamp)();
    if (isModernIssueTransitionSRBCohort) return {
        isEnabled: true
    };
    return (0, $epTsa.expValEquals)('jira_issue_transition_screen_modernisation_toggle', 'value', 'BY_DEFAULT_USER_OPT_OUT') ? {
        isEnabled: false,
        expiryTime: -1
    } : {
        isEnabled: true
    };
};
var $ce05f913d0b3b9bd$export$2e2bcd8739ae039 = $ce05f913d0b3b9bd$var$getDefaultIssueTransitionLabsOptInState;

});


parcelRegister("1gbqq", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarAutomationLegacyEnabledResource", () => $bc0dbb530def7b92$export$fa191d7d71460a98);

var $aYncF = parcelRequire("aYncF");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");

const $bc0dbb530def7b92$export$fa191d7d71460a98 = (0, $l1VxS.createResource)({
    type: (0, $bb95cd42467ae698$export$fd4fc70ec71927d1),
    getKey: ({ query: query })=>`jsm-legacy-automation-enabled-${query.projectKey}`,
    getData: async (_, { tenantContext: { licensedProducts: licensedProducts } })=>{
        const defaultValue = {
            enabled: true
        };
        if (!licensedProducts || !licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).JIRA_SERVICEDESK]) return defaultValue;
        const { enabled: enabled } = await (0, $jGzN3.performGetRequest)('/rest/servicedesk/automation/1/legacy/state');
        return {
            enabled: enabled
        };
    },
    maxAge: Infinity,
    isCritical: true
});

});
const $bb95cd42467ae698$export$fd4fc70ec71927d1 = 'AUTOMATION_IS_LEGACY_ENABLED';


parcelRegister("enHI7", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarGlobalResource", () => $ef90c1839bc063ef$export$44e7ad3c66a3f25f);

var $i2m1e = parcelRequire("i2m1e");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

const $ef90c1839bc063ef$export$44e7ad3c66a3f25f = (0, $l1VxS.createResource)({
    type: (0, $70d26b9165f63401$export$fa5743fc6a1da5d8),
    getKey: ({ match: match, query: query })=>{
        // Refresh the data if the project key or id changes
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        return projectKey || projectId || '__state';
    },
    getData: async ({ match: match, query: query }, _storeContext)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const scope = {
            projectKey: projectKey,
            projectId: projectId
        };
        const response = await (0, $i2m1e.fetchSidebarConfig)(scope, false);
        return {
            response: response,
            scope: scope
        };
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("i2m1e", function(module, exports) {

$parcel$export(module.exports, "fetchSidebarConfig", () => $fab8a685dab84ca5$export$d1d13c4b972a22f1);

var $eSnSE = parcelRequire("eSnSE");

var $1Ozm9 = parcelRequire("1Ozm9");
const $fab8a685dab84ca5$var$LOGGER_LOCATION = 'navigation-next.baskets.navigation.utils';

const $fab8a685dab84ca5$var$fetchUsingProtobuf = async (url)=>{
    try {
        const fetchProtobuf = await (parcelRequire("7R1Q4"));
        if (!fetchProtobuf) (0, $eSnSE.default).safeErrorWithoutCustomerData($fab8a685dab84ca5$var$LOGGER_LOCATION, 'Error dynamically loading protobuf fetch function');
        return fetchProtobuf.default(url);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData($fab8a685dab84ca5$var$LOGGER_LOCATION, 'Error fetching Sidebar Configuration protocol buffer message', err);
        throw err;
    }
};
const $fab8a685dab84ca5$export$94e808b2557f52e = (requestQuery, version = '2', queryParams)=>{
    const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
    const params = {
        exclude: [
            'webItems.reports',
            'webItems.home',
            'webItems.gin',
            exclude
        ].filter(Boolean).join(',')
    };
    let path = '';
    if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
    else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
    else if (identifierValue != null) path = `project/${identifierValue}`;
    else {
        path = 'product';
        const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
        // Connect apps rely on project context even for the global/product scoped webItems
        const projectIdOrKey = projectId || projectKey;
        if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
    }
    const queryString = [
        new URLSearchParams(params).toString(),
        queryParams
    ].filter(Boolean).join('&');
    return `/rest/navigation/${version}/${path}?${queryString}`;
};
const $fab8a685dab84ca5$export$d1d13c4b972a22f1 = async (requestQuery, isServer, queryParams)=>{
    if (isServer) {
        const protoUrl = $fab8a685dab84ca5$export$94e808b2557f52e(requestQuery, '2.1', queryParams);
        return $fab8a685dab84ca5$var$fetchUsingProtobuf(protoUrl);
    }
    const sidebarUrl = $fab8a685dab84ca5$export$94e808b2557f52e(requestQuery, undefined, queryParams);
    return (0, $1Ozm9.default)(sidebarUrl);
};

});
parcelRegister("7R1Q4", function(module, exports) {

let $5b7ee8d00a04271c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5b7ee8d00a04271c$var$load("9nQx9").then(()=>parcelRequire('fPrr3'));

});


const $70d26b9165f63401$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';


parcelRegister("dfh4P", function(module, exports) {

$parcel$export(module.exports, "navigationUiStateResource", () => $51dec11bee852c78$export$14c178691841b423);
// eslint-disable-next-line jira/import-whitelist

var $LFmXM = parcelRequire("LFmXM");

var $l1VxS = parcelRequire("l1VxS");

var $9uKgD = parcelRequire("9uKgD");

const $51dec11bee852c78$var$getNavigationUiStateMemoized = (0, $LFmXM.default)((atlassianAccountId)=>(0, $9uKgD.getNavigationUiState)({
        tenantContext: {
            atlassianAccountId: atlassianAccountId
        }
    }));
const $51dec11bee852c78$export$14c178691841b423 = (0, $l1VxS.createResource)({
    type: 'RESOURCE_TYPE_NAVIGATION_UI',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$51dec11bee852c78$var$getNavigationUiStateMemoized(atlassianAccountId),
    maxAge: Infinity,
    isCritical: true
});

});
parcelRegister("9uKgD", function(module, exports) {

$parcel$export(module.exports, "getNavigationUiState", () => $c6be53465a9fed60$export$29999268b070c9bd);

var $FppkK = parcelRequire("FppkK");


var $fwMnB = parcelRequire("fwMnB");
const $c6be53465a9fed60$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
    const { atlassianAccountId: accountId } = tenantContext;
    let uiState = await (0, $fwMnB.queryLocalStorage)();
    if (uiState || !accountId) return uiState;
    try {
        uiState = await (0, $FppkK.getUserProperty)(accountId, (0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8));
        // @ts-expect-error - TS2345 - Argument of type 'UIControllerShape | undefined' is not assignable to parameter of type 'UIControllerShape'.
        (0, $fwMnB.updateLocalStorageData)(uiState);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // Don't log the error on purpose. This is very frequent for some reason :(
    }
    return uiState;
};

});
const $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $1ebe0101b6fb87b8$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';

parcelRegister("fwMnB", function(module, exports) {

$parcel$export(module.exports, "queryLocalStorage", () => $04a476f65e66d73c$export$e192dcb908272d5);
$parcel$export(module.exports, "updateLocalStorageData", () => $04a476f65e66d73c$export$ec13c725e067146a);

var $12DRg = parcelRequire("12DRg");

var $7jTnu = parcelRequire("7jTnu");

var $eSnSE = parcelRequire("eSnSE");

var $dnU6V = parcelRequire("dnU6V");

const $04a476f65e66d73c$var$localStorageProvider = (0, $dnU6V.createLocalStorageProvider)('', false);
const $04a476f65e66d73c$export$e7db3fa51c63bc5c = ()=>{
    if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') return window.localStorage;
    return {
        setItem: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        getItem: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    };
};
const $04a476f65e66d73c$var$queryLocalStorageSync = ()=>{
    const localStorage = $04a476f65e66d73c$export$e7db3fa51c63bc5c();
    const item = (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $04a476f65e66d73c$var$localStorageProvider.get((0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8)) : localStorage.getItem((0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8));
    if (!false && item) try {
        return JSON.parse(item);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $1ebe0101b6fb87b8$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
    }
};
const $04a476f65e66d73c$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
        const item = $04a476f65e66d73c$var$queryLocalStorageSync();
        resolve(item);
    });
const $04a476f65e66d73c$export$ec13c725e067146a = (data)=>{
    const localStorage = $04a476f65e66d73c$export$e7db3fa51c63bc5c();
    (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $04a476f65e66d73c$var$localStorageProvider.set((0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8), JSON.stringify(data)) : localStorage.setItem((0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8), JSON.stringify(data));
};

});
parcelRegister("dnU6V", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageProvider", () => $f14a980fc91d9f61$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $f14a980fc91d9f61$export$59acef2b3ab1df90);

var $5PQOA = parcelRequire("5PQOA");

var $iuNRp = parcelRequire("iuNRp");

var $itkIt = parcelRequire("itkIt");
const $f14a980fc91d9f61$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((appPrefix, shouldSerialize = true)=>(0, $iuNRp.createStorageProvider)((0, $iuNRp.WebStorageType).LocalStorage, appPrefix, (0, $itkIt.makeLocalStore)(), shouldSerialize));
const $f14a980fc91d9f61$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((appPrefix)=>{
    return (0, $iuNRp.createExpirableStorageProvider)((0, $iuNRp.WebStorageType).LocalStorage, appPrefix, (0, $itkIt.makeLocalExpirableStore)());
});

});
parcelRegister("iuNRp", function(module, exports) {

$parcel$export(module.exports, "plugins", () => $33d1e266f2cf3989$export$8b3ca321c77fdea6);
$parcel$export(module.exports, "WebStorageType", () => $33d1e266f2cf3989$export$259e3a861f28589b);
$parcel$export(module.exports, "createStorageProvider", () => $33d1e266f2cf3989$export$8441605555fbd60c);
$parcel$export(module.exports, "createExpirableStorageProvider", () => $33d1e266f2cf3989$export$b793a81cf479272a);

var $fsdQg = parcelRequire("fsdQg");

var $76ftm = parcelRequire("76ftm");

var $7jTnu = parcelRequire("7jTnu");

var $fCQ2g = parcelRequire("fCQ2g");
const $33d1e266f2cf3989$export$8b3ca321c77fdea6 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($fsdQg))),
    (0, $fCQ2g.default)
];
const $33d1e266f2cf3989$export$259e3a861f28589b = {
    LocalStorage: 'LocalStorage',
    SessionStorage: 'SessionStorage'
};
const $33d1e266f2cf3989$export$8441605555fbd60c = (storageType, appPrefix = '', // eslint-disable-next-line @typescript-eslint/no-explicit-any
store, shouldSerialize = true)=>{
    const namespacedStore = store.namespace(appPrefix);
    const getKeyWithPrefix = (key)=>appPrefix?.trim().length ? `${appPrefix}.${key}` : key;
    const storageAPI = storageType === $33d1e266f2cf3989$export$259e3a861f28589b.LocalStorage ? (0, $76ftm.AtlBrowserStorageLocal) : (0, $76ftm.AtlBrowserStorageSession);
    const browserStorage = storageType === $33d1e266f2cf3989$export$259e3a861f28589b.LocalStorage ? globalThis.localStorage : globalThis.sessionStorage;
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value)=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    const storageValue = shouldSerialize ? JSON.stringify(value) : value;
                    storageAPI.setItem(prefixedKey, storageValue);
                } else namespacedStore.set(key, value);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error setting item in storage:', err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value)=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    const storageValue = shouldSerialize ? JSON.stringify(value) : value;
                    storageAPI.setStrictlyNecessaryItem(prefixedKey, storageValue);
                } else // this has to be done when setStrictlyNecessaryItem comes into usage, and it should have a fallback when FG is turned off
                namespacedStore.set(key, value);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error setting item in storage:', err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                let item;
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    // When the feature flag is enabled
                    if (appPrefix?.trim().length) {
                        // Case 1: App prefix exists (all the existing usages of jira-browser-storage-providers had app prefix)
                        item = storageAPI.getItem(prefixedKey);
                        if (typeof item === 'undefined' || item === null) {
                            // Check old store when data not found in new storage
                            const itemFromOldStore = namespacedStore.get(key);
                            if (typeof itemFromOldStore !== 'undefined' && itemFromOldStore !== null) {
                                // Migrate data from old store to new storage
                                const stringValue = JSON.stringify(itemFromOldStore);
                                storageAPI.setItem(prefixedKey, stringValue);
                                return itemFromOldStore;
                            }
                        }
                        if (typeof item === 'string') // If data found in new storage, return it
                        return shouldSerialize ? JSON.parse(item) : item;
                    }
                    // Case 2: No app prefix
                    item = storageAPI.getItem(prefixedKey);
                    if (typeof item === 'undefined' || item === null) {
                        // Check browser's localStorage for the key
                        const itemFromNativeBrowserStorage = browserStorage?.getItem(key);
                        if (typeof itemFromNativeBrowserStorage !== 'undefined' && itemFromNativeBrowserStorage !== null) {
                            // Migrate data to new storage
                            storageAPI.setItem(prefixedKey, itemFromNativeBrowserStorage);
                            return itemFromNativeBrowserStorage;
                        }
                    }
                    if (typeof item === 'string') // If data found in new storage, return it
                    return shouldSerialize ? JSON.parse(item) : item;
                } else return namespacedStore.get(key);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting item from storage:', err);
            }
        },
        remove: (key)=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.removeItem(prefixedKey); // remove data from new store
                    namespacedStore.remove(key); // remove data from old store as well
                } else namespacedStore.remove(key);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error removing item from storage:', err);
            }
        },
        // Clears the complete storage
        clearAll: ()=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    storageAPI.clear();
                    // clean up old keys too
                    namespacedStore.clearAll();
                } else namespacedStore.clearAll();
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        // Clears all the keys specific to the appPrefix
        clearStorageValues: ()=>{
            if (!appPrefix) throw Error('appPrefix is necessary to access clearStorageValues method.');
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) for(let i = 0; i < storageAPI.length(); i++){
                    const key = storageAPI.key(i);
                    if (key && key.startsWith(`${appPrefix}.`)) {
                        storageAPI.removeItem(key);
                        i--;
                    }
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        length: ()=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.length();
                return browserStorage?.length || 0;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting storage length:', err);
                return 0;
            }
        },
        // unstable use it only if its absolutely necessary
        getPrefixedKeysLength: ()=>{
            if (!appPrefix) throw Error('appPrefix is necessary to access getNamespaceKeysLength method.');
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    // For browser storage API
                    let count = 0;
                    const totalLength = storageAPI.length() || 0;
                    for(let i = 0; i < totalLength; i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) count++;
                    }
                    return count;
                }
                // For store library using native storage
                let count = 0;
                const totalLength = browserStorage?.length || 0;
                const namespacePrefix = `__storejs_${appPrefix}_`;
                for(let i = 0; i < totalLength; i++){
                    const key = browserStorage?.key(i);
                    if (key && key.startsWith(namespacePrefix)) count++;
                }
                return count;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error counting namespace keys:', error);
                return 0;
            }
        }
    };
};
const $33d1e266f2cf3989$export$b793a81cf479272a = (storageType, appPrefix, // eslint-disable-next-line @typescript-eslint/no-explicit-any
store)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const namespacedStore = store.namespace(appPrefix);
    const getKeyWithPrefix = (key)=>`${appPrefix}.${key}`;
    const storageAPI = storageType === $33d1e266f2cf3989$export$259e3a861f28589b.LocalStorage ? (0, $76ftm.AtlBrowserStorageLocal) : (0, $76ftm.AtlBrowserStorageSession);
    const browserStorage = storageType === $33d1e266f2cf3989$export$259e3a861f28589b.LocalStorage ? globalThis.localStorage : globalThis.sessionStorage;
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value, expiration)=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    const item = {
                        value: value,
                        expiration: expiration
                    };
                    const serializedValue = JSON.stringify(item);
                    storageAPI.setItem(prefixedKey, serializedValue);
                } else namespacedStore.set(key, value, expiration);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value, expiration)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                const item = {
                    value: value,
                    expiration: expiration
                };
                const serializedValue = JSON.stringify(item);
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) storageAPI.setStrictlyNecessaryItem(prefixedKey, serializedValue);
                else // this has to be done when setStrictlyNecessaryItem comes into usage, and it should have a fallback when FG is turned off
                namespacedStore.set(key, value, expiration);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                let itemStr;
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    itemStr = storageAPI.getItem(prefixedKey);
                    if (!itemStr) {
                        // check in the old store
                        const itemFromOldStore = namespacedStore.get(key);
                        if (typeof itemFromOldStore !== 'undefined' && itemFromOldStore !== null) {
                            const item = {
                                value: itemFromOldStore,
                                expiration: namespacedStore.getExpiration(key)
                            };
                            storageAPI.setItem(prefixedKey, JSON.stringify(item)); // migrate to new store with new key
                            return itemFromOldStore;
                        }
                    } else {
                        // check if the item is expired
                        const item = JSON.parse(itemStr);
                        if (item.expiration && item.expiration < Date.now()) {
                            storageAPI.removeItem(prefixedKey);
                            return;
                        }
                        return item.value;
                    }
                } else {
                    itemStr = namespacedStore.get(key);
                    return itemStr;
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error getting item with key=${key}:`, error);
            }
        },
        getExpiration: (key)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                let itemStr;
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    itemStr = storageAPI.getItem(prefixedKey);
                    if (!itemStr) {
                        // check in the old store
                        const itemFromOldStore = namespacedStore.get(key);
                        if (typeof itemFromOldStore !== 'undefined' && itemFromOldStore !== null) {
                            const expiration = namespacedStore.getExpiration(key);
                            const item = {
                                value: itemFromOldStore,
                                expiration: expiration
                            };
                            storageAPI.setItem(prefixedKey, JSON.stringify(item)); // migrate to new store with new key
                            return expiration;
                        }
                    } else {
                        // check if the item is expired
                        const item = JSON.parse(itemStr);
                        if (item.expiration && item.expiration < Date.now()) {
                            storageAPI.removeItem(prefixedKey);
                            return undefined;
                        }
                        return item.expiration;
                    }
                } else return namespacedStore.getExpiration(key);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error getting expiration for item with key=${key}:`, error);
                return undefined;
            }
        },
        remove: (key)=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.removeItem(prefixedKey);
                    namespacedStore.remove(key);
                } else namespacedStore.remove(key);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error removing item with key=${key}:`, error);
            }
        },
        removeExpiredKeys: ()=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    for(let i = 0; i < storageAPI.length(); i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) {
                            const itemStr = storageAPI.getItem(key);
                            if (itemStr) {
                                const item = JSON.parse(itemStr);
                                if (item.expiration && item.expiration < Date.now()) {
                                    storageAPI.removeItem(key);
                                    i--;
                                }
                            }
                        }
                    }
                    namespacedStore.removeExpiredKeys(); // clean up old keys too
                } else namespacedStore.removeExpiredKeys();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error removing expired keys:', error);
            }
        },
        // Clears all the keys specific to the appPrefix
        clearStorageValues: ()=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) for(let i = 0; i < storageAPI.length(); i++){
                    const key = storageAPI.key(i);
                    if (key && key.startsWith(`${appPrefix}.`)) {
                        storageAPI.removeItem(key);
                        i--;
                    }
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage values:', err);
            }
        },
        // Clears the complete storage
        clearAll: ()=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    storageAPI.clear();
                    // clean up old keys too
                    namespacedStore.clearAll();
                } else namespacedStore.clearAll();
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        length: ()=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.length();
                return browserStorage?.length || 0;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting storage length:', err);
                return 0;
            }
        },
        // unstable use it only if its absolutely necessary
        getPrefixedKeysLength: ()=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    // For browser storage API
                    let count = 0;
                    const totalLength = storageAPI.length() || 0;
                    for(let i = 0; i < totalLength; i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) count++;
                    }
                    return count;
                }
                // For store library using native storage
                let count = 0;
                const totalLength = browserStorage?.length || 0;
                const namespacePrefix = `__storejs_${appPrefix}_`;
                for(let i = 0; i < totalLength; i++){
                    const key = browserStorage?.key(i);
                    if (key && key.startsWith(namespacePrefix)) count++;
                }
                return count;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error counting namespace keys:', error);
                return 0;
            }
        }
    };
};

});
parcelRegister("fCQ2g", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f4c9f88e8601068$export$2e2bcd8739ae039);

var $gYnSx = parcelRequire("gYnSx");

var $3YqQf = parcelRequire("3YqQf");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4f4c9f88e8601068$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $3YqQf.NAMESPACE));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $3YqQf.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $3YqQf.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $3YqQf.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $gYnSx.default)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e,
                    skipSentry: true
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $gYnSx.default)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $3YqQf.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $3YqQf.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $3YqQf.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $3YqQf.ONE_WEEK) >= (0, $3YqQf.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $3YqQf.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $4f4c9f88e8601068$export$2e2bcd8739ae039 = $4f4c9f88e8601068$var$cleanUpPlugin;

});
parcelRegister("3YqQf", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE", () => $9a0e43db8e6f79e8$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $9a0e43db8e6f79e8$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $9a0e43db8e6f79e8$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $9a0e43db8e6f79e8$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $9a0e43db8e6f79e8$export$ea28dfd9333cda2d);
const $9a0e43db8e6f79e8$export$6aad947bda0f3f46 = 'timestamps';
const $9a0e43db8e6f79e8$export$8187f416f1cc43d8 = 604800000;
const $9a0e43db8e6f79e8$export$6e952fa7d47190cf = 4 * $9a0e43db8e6f79e8$export$8187f416f1cc43d8;
const $9a0e43db8e6f79e8$export$da99ebca8f453abd = 22;
const $9a0e43db8e6f79e8$export$ea28dfd9333cda2d = 1014;

});



parcelRegister("itkIt", function(module, exports) {

$parcel$export(module.exports, "makeLocalStore", () => $987a5374f8deacb5$export$b2631085fe8db7af);
$parcel$export(module.exports, "isLocalStorageAvailable", () => $987a5374f8deacb5$export$117a30df0da2af20);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $987a5374f8deacb5$export$cf816b43e73de947);

var $fsdQg = parcelRequire("fsdQg");

var $252Bx = parcelRequire("252Bx");

var $02LWr = parcelRequire("02LWr");

var $jdVjN = parcelRequire("jdVjN");

var $jZWi5 = parcelRequire("jZWi5");

var $iuNRp = parcelRequire("iuNRp");
const $987a5374f8deacb5$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($02LWr))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($jdVjN))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jZWi5)))
    ], (0, $iuNRp.plugins));
const $987a5374f8deacb5$export$117a30df0da2af20 = ()=>typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
const $987a5374f8deacb5$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($02LWr))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($jdVjN))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jZWi5)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fsdQg))),
        (0, (/*@__PURE__*/$parcel$interopDefault($252Bx)))
    ]);

});





parcelRegister("5zQIb", function(module, exports) {

$parcel$export(module.exports, "newIssueViewTransitionLockInStatusResource", () => $26da57008bc6c8b7$export$babbf5bfbc4d268c);
$parcel$export(module.exports, "DEFAULT_TO_OLD_ISSUE_VIEW", () => $26da57008bc6c8b7$export$f269c0bf10ad77e2);
$parcel$export(module.exports, "useNewIssueViewLockedInStatus", () => $26da57008bc6c8b7$export$3b09097f2a423abd);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $26da57008bc6c8b7$export$babbf5bfbc4d268c = (0, $l1VxS.createResource)({
    type: (0, $04dbca965a7f77be$export$fdb92aeacda42553),
    getKey: ()=>'newIssueViewTransitionLockingStatus',
    getDataLoader: ()=>(parcelRequire("6yLhq")),
    maxAge: Number.MAX_VALUE,
    isCritical: true
});
const $26da57008bc6c8b7$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $26da57008bc6c8b7$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $26da57008bc6c8b7$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';
const $26da57008bc6c8b7$export$3b09097f2a423abd = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $eJrcF.useResource)($26da57008bc6c8b7$export$babbf5bfbc4d268c);

});
const $04dbca965a7f77be$export$fdb92aeacda42553 = 'NEW_ISSUE_VIEW_LOCK_IN_STATUS';

parcelRegister("6yLhq", function(module, exports) {

let $4c6a97e6506eceec$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4c6a97e6506eceec$var$load("1brjB").then(()=>parcelRequire('1YfCq'));

});


parcelRegister("cqUpU", function(module, exports) {

$parcel$export(module.exports, "persistentIssueCreateModalViewResource", () => $ca7e29547f8b9439$export$266a039a005e8314);

var $l1VxS = parcelRequire("l1VxS");


const $ca7e29547f8b9439$export$266a039a005e8314 = (0, $l1VxS.createResource)({
    type: (0, $0f8f8ea7f8143316$export$f658cfd591eb583e),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("9EtWN")),
    maxAge: Number.MAX_VALUE,
    isCritical: true
});

});
const $0f8f8ea7f8143316$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $0f8f8ea7f8143316$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $0f8f8ea7f8143316$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';

parcelRegister("9EtWN", function(module, exports) {

let $706f1460c3674880$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $706f1460c3674880$var$load("14huQ").then(()=>parcelRequire('9RwzH'));

});


parcelRegister("dZRaT", function(module, exports) {

$parcel$export(module.exports, "projectContextResource", () => $4af98aebc4dee24b$export$27ad0d75c619be68);
$parcel$export(module.exports, "projectContextResourceWithCache", () => $4af98aebc4dee24b$export$d75816e37af81473);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");


const $4af98aebc4dee24b$var$getDataLoader = ()=>(parcelRequire("6grdi"));
const $4af98aebc4dee24b$export$27ad0d75c619be68 = (0, $l1VxS.createResource)({
    type: (0, $c8eeacd6960f72dc$export$80a60a092d9ab81),
    getKey: (matchedRoute)=>(0, $bBtQo.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getDataLoader: $4af98aebc4dee24b$var$getDataLoader,
    maxAge: 1800000,
    isCritical: true
});
const $4af98aebc4dee24b$export$d75816e37af81473 = $4af98aebc4dee24b$export$27ad0d75c619be68;

});
const $c8eeacd6960f72dc$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("6grdi", function(module, exports) {

let $48f958b7206c614e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $48f958b7206c614e$var$load("gbn88").then(()=>parcelRequire('h0bmE'));

});


parcelRegister("2emAF", function(module, exports) {

$parcel$export(module.exports, "fetchSiteTraitsResource", () => $ef9e2dbc0959350e$export$379923e7c903a55d);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");

var $lctcw = parcelRequire("lctcw");


const $ef9e2dbc0959350e$var$getData = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}`;
        const response = false ? (await (0, $jGzN3.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $lctcw.memoizedFetchSitePersonalization)({
            cloudId: cloudId
        });
        if (response) return response;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: (0, $aa00244bb9a84571$export$7f111648ca05f056),
                packageName: (0, $33cafeed9becac72$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $ef9e2dbc0959350e$export$379923e7c903a55d = (0, $l1VxS.createResource)({
    type: (0, $aa00244bb9a84571$export$6f0555de4f60e84e),
    getKey: ()=>(0, $aa00244bb9a84571$export$7e7d7930e22ba39f),
    getData: $ef9e2dbc0959350e$var$getData,
    maxAge: Number.MAX_VALUE,
    isCritical: true
});

});
parcelRegister("lctcw", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSitePersonalization", () => $b8fe630b0608ec20$export$671fb03be30194c3);
$parcel$export(module.exports, "useSitePersonalization", () => $b8fe630b0608ec20$export$58982988039b926f);

var $LFmXM = parcelRequire("LFmXM");

var $hPZg4 = parcelRequire("hPZg4");

var $1Ozm9 = parcelRequire("1Ozm9");
const $b8fe630b0608ec20$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $b8fe630b0608ec20$export$ddf4964d2a406b6a = async ({ cloudId: cloudId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    const { attributes: attributes } = await (0, $1Ozm9.default)($b8fe630b0608ec20$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $b8fe630b0608ec20$export$671fb03be30194c3 = (0, $LFmXM.default)($b8fe630b0608ec20$export$ddf4964d2a406b6a, ([{ cloudId: newCloudId }], [{ cloudId: lastCloudId }])=>newCloudId === lastCloudId);
const $b8fe630b0608ec20$export$58982988039b926f = ()=>(0, $hPZg4.useService)($b8fe630b0608ec20$export$671fb03be30194c3);

});
parcelRegister("hPZg4", function(module, exports) {

$parcel$export(module.exports, "useService", () => $ca6dc04f01b0b806$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $ca6dc04f01b0b806$export$c963713a27525aaf);

var $eJOHy = parcelRequire("eJOHy");
const $ca6dc04f01b0b806$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $eJOHy.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $eJOHy.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $ca6dc04f01b0b806$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $eJOHy.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $ca6dc04f01b0b806$export$6de4685a6c88b4e9(request, initialState);
    (0, $eJOHy.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});


const $33cafeed9becac72$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGrowthRecommendations';

const $aa00244bb9a84571$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_SITE_TRAITS';
const $aa00244bb9a84571$export$7e7d7930e22ba39f = 'recommendations-fetch-site-traits-resource-key';
const $aa00244bb9a84571$export$7f111648ca05f056 = 'useResource.fetchRecommendationsSiteTraits';


parcelRegister("bvwBX", function(module, exports) {

$parcel$export(module.exports, "fetchUserTraitsResource", () => $2d9a8917da259545$export$d5198d02e9089545);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");

var $lFovQ = parcelRequire("lFovQ");


const $2d9a8917da259545$var$getData = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const accountId = tenantContext.atlassianAccountId ?? '';
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const response = false ? (await (0, $jGzN3.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $lFovQ.memoizedFetchSiteUserPersonalization)({
            cloudId: cloudId,
            userId: accountId
        });
        if (response) return response;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: (0, $e2e199d119a9299f$export$7f111648ca05f056),
                packageName: (0, $33cafeed9becac72$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $2d9a8917da259545$export$d5198d02e9089545 = (0, $l1VxS.createResource)({
    type: (0, $e2e199d119a9299f$export$6f0555de4f60e84e),
    getKey: ()=>(0, $e2e199d119a9299f$export$7e7d7930e22ba39f),
    getData: $2d9a8917da259545$var$getData,
    maxAge: Number.MAX_VALUE,
    isCritical: true
});

});
parcelRegister("lFovQ", function(module, exports) {

$parcel$export(module.exports, "fetchSiteUserPersonalization", () => $14b13fbf5780b414$export$8f40704723ec6690);
$parcel$export(module.exports, "memoizedFetchSiteUserPersonalization", () => $14b13fbf5780b414$export$de93ec54b11be450);
$parcel$export(module.exports, "useSiteUserPersonalization", () => $14b13fbf5780b414$export$8dc79ff315095801);

var $LFmXM = parcelRequire("LFmXM");

var $hPZg4 = parcelRequire("hPZg4");

var $1Ozm9 = parcelRequire("1Ozm9");
const $14b13fbf5780b414$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $14b13fbf5780b414$export$8f40704723ec6690 = async ({ cloudId: cloudId, userId: userId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!userId) throw new Error('empty userId');
    const { attributes: attributes } = await (0, $1Ozm9.default)($14b13fbf5780b414$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $14b13fbf5780b414$export$de93ec54b11be450 = (0, $LFmXM.default)($14b13fbf5780b414$export$8f40704723ec6690, ([{ cloudId: newCloudId, userId: newUserId }], [{ cloudId: lastCloudId, userId: lastUserId }])=>newCloudId === lastCloudId && newUserId === lastUserId);
const $14b13fbf5780b414$export$8dc79ff315095801 = ()=>(0, $hPZg4.useService)($14b13fbf5780b414$export$de93ec54b11be450);

});

const $e2e199d119a9299f$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_USER_TRAITS';
const $e2e199d119a9299f$export$7e7d7930e22ba39f = 'recommendations-fetch-traits-resource-key';
const $e2e199d119a9299f$export$7f111648ca05f056 = 'useResource.fetchRecommendationsUserTraits';


parcelRegister("68g4a", function(module, exports) {

$parcel$export(module.exports, "jpdRecommendationDismissedResource", () => $49b8368db856ef30$export$5db7c4562b672f52);

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $jGzN3 = parcelRequire("jGzN3");

var $6zXPf = parcelRequire("6zXPf");

var $5L7qx = parcelRequire("5L7qx");

var $l1VxS = parcelRequire("l1VxS");


const $49b8368db856ef30$export$5db7c4562b672f52 = (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('blu-3929-sidebar-menu-recommended'), (0, $l1VxS.createResource)({
    type: (0, $2600fd317e4ea417$export$6f0555de4f60e84e),
    getKey: ()=>(0, $2600fd317e4ea417$export$7e7d7930e22ba39f),
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return {
                hasDismissed: true
            };
            const accountId = tenantContext.atlassianAccountId;
            const response = await (0, $jGzN3.performGetRequest)(`/rest/api/latest/user/properties/JpdRecommendationDismissed?accountId=${accountId}`);
            return {
                hasDismissed: response?.value ?? false
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
					 * If the user has never set the preference, they have never dismissed.
					 */ return {
                hasDismissed: false
            };
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: (0, $2600fd317e4ea417$export$7f111648ca05f056),
                    packageName: (0, $33cafeed9becac72$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return true - this ensures we don't show the recommendation if we don't know if they have dismissed */ return {
            hasDismissed: true
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
}));

});
const $2600fd317e4ea417$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_DISMISSED_JPD';
const $2600fd317e4ea417$export$7e7d7930e22ba39f = 'recommendations-dismissed-jpd-resource-key';
const $2600fd317e4ea417$export$7f111648ca05f056 = 'useResource.fetchRecommendationsDismissedJpd';


parcelRegister("lb6FK", function(module, exports) {

$parcel$export(module.exports, "rovoEntitlementResource", () => $010e266d7d00b5af$export$a0974cf24d16bc5d);
$parcel$export(module.exports, "useRovoEntitlementResource", () => $010e266d7d00b5af$export$b9cee3799212b85a);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

const $010e266d7d00b5af$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
const $010e266d7d00b5af$var$getRovoEnabledBasedOnExperiment = ({ isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled })=>{
    // if Rovo is not enabled, we don't need to check the experiment
    if (!isRovoEnabled) return {
        isRovoEnabled: isRovoEnabled,
        isRovoLLMEnabled: isRovoLLMEnabled
    };
    // If a user is in the Control cohort we're overriding the entitlement check with false to NOT serve Rovo experience.
    // Test cohort: users who get the new Rovo experience -> do NOT override the TCS entitlement.
    // Control cohort: users who get the legacy experience (the baseline) -> override the TCS entitlement with false.
    if ((0, $epTsa.expValEquals)('rovo_team25_rollout_performance_exp', 'cohort', 'control', 'test')) return {
        isRovoEnabled: false,
        isRovoLLMEnabled: false
    };
    // A repeat of the above as a second expeirmenet
    // Tenants should only be in one or the other, controlled by the targetting gate
    if ((0, $epTsa.expValEquals)('rovo_team25_rollout_perf_b3a_exp', 'cohort', 'control', 'test')) return {
        isRovoEnabled: false,
        isRovoLLMEnabled: false
    };
    return {
        isRovoEnabled: isRovoEnabled,
        isRovoLLMEnabled: isRovoLLMEnabled
    };
};
const $010e266d7d00b5af$var$fetchRovoEntitlement = async (cloudId)=>{
    try {
        const response = await (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $a630de669343b4d7$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    shouldShowRovoLLMEnabled: (0, $7jTnu.fg)('rovo_use_rovo_llm_enabled_check')
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        // handle GraphQL errors
        if (response.errors) (0, $gYnSx.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
            sendToPrivacyUnsafeSplunk: true
        });
        const isRovoEnabled = response.data?.jira?.isRovoEnabled ?? null;
        // defaulting to isRovoEnabled if the feature flag is not enabled
        const isRovoLLMEnabled = (0, $7jTnu.fg)('rovo_use_rovo_llm_enabled_check') ? response.data?.jira_isRovoLLMEnabled ?? null : isRovoEnabled;
        return $010e266d7d00b5af$var$getRovoEnabledBasedOnExperiment({
            isRovoEnabled: isRovoEnabled,
            isRovoLLMEnabled: isRovoLLMEnabled
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return {
        isRovoEnabled: null,
        isRovoLLMEnabled: undefined
    };
};
const $010e266d7d00b5af$export$a0974cf24d16bc5d = (0, $l1VxS.createResource)({
    type: $010e266d7d00b5af$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getKey: ()=>$010e266d7d00b5af$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getData: (_, { tenantContext: { cloudId: cloudId } })=>$010e266d7d00b5af$var$fetchRovoEntitlement(cloudId),
    maxAge: Infinity,
    isCritical: true
});
const $010e266d7d00b5af$export$b9cee3799212b85a = ()=>(0, $eJrcF.useResource)($010e266d7d00b5af$export$a0974cf24d16bc5d);

});
const $a630de669343b4d7$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldShowRovoLLMEnabled: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldShowRovoLLMEnabled)
}
`;


parcelRegister("cxQGT", function(module, exports) {

$parcel$export(module.exports, "themePreferenceResource", () => $5f480f6098caae1f$export$e5a423d1eb1cf1d0);
$parcel$export(module.exports, "useThemePreference", () => $5f480f6098caae1f$export$3416635c8aeb5bab);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


var $fWIQB = parcelRequire("fWIQB");

const $5f480f6098caae1f$var$getDataLoader = ()=>(parcelRequire("7bw1Z"));
const $5f480f6098caae1f$export$e5a423d1eb1cf1d0 = (0, $l1VxS.createResource)({
    type: 'RESOURCE_THEME_PREFERENCE',
    getKey: ()=>'state',
    getDataLoader: $5f480f6098caae1f$var$getDataLoader,
    maxAge: 300000,
    isCritical: true
});
const $5f480f6098caae1f$export$3416635c8aeb5bab = ()=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $eJrcF.useResource)($5f480f6098caae1f$export$e5a423d1eb1cf1d0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const fireThemeAnalytics = (0, $eJOHy.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $256811ed117b45d8$export$89c5cf64ad15c3ea),
            actionSubject: (0, $256811ed117b45d8$export$9e2cc65718a61846)
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $eJOHy.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $fWIQB.setThemePreference)(theme);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};

});
const $256811ed117b45d8$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $256811ed117b45d8$export$9e2cc65718a61846 = 'themePreference';
const $256811ed117b45d8$export$89c5cf64ad15c3ea = 'changed';

parcelRegister("fWIQB", function(module, exports) {

$parcel$export(module.exports, "setThemePreference", () => $43e3efe56f96aef4$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $43e3efe56f96aef4$export$2f7a12048d96237);

var $hzgTF = parcelRequire("hzgTF");

var $gYnSx = parcelRequire("gYnSx");

var $9DB7T = parcelRequire("9DB7T");

const $43e3efe56f96aef4$export$a6b84eebd33787e2 = (theme)=>{
    const promise = (0, $9DB7T.userPreferenceAPI).set((0, $256811ed117b45d8$export$40bd77e1c9f49c27), theme);
    promise.catch((error)=>{
        (0, $gYnSx.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'put',
                errName: String(error.name),
                statusCode: error.statusCode,
                param: `to:${theme}`
            }
        });
    });
    return promise;
};
const $43e3efe56f96aef4$export$2f7a12048d96237 = async ()=>{
    const promise = (0, $9DB7T.userPreferenceAPI).get((0, $256811ed117b45d8$export$40bd77e1c9f49c27));
    promise.catch((error)=>{
        (0, $gYnSx.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'get',
                errName: String(error.name),
                statusCode: error.statusCode
            }
        });
    });
    promise.then((theme)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (theme && !(0, $hzgTF.ThemeOptions).includes(theme)) // very unlikely but…
        (0, $gYnSx.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: new Error('Unrecognized theme!'),
            attributes: {
                op: 'get',
                theme: theme,
                errName: 'unrecognized value!'
            }
        });
    });
    const theme = await promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return theme && (0, $hzgTF.ThemeOptions).includes(theme) ? theme : undefined;
};

});
parcelRegister("hzgTF", function(module, exports) {

$parcel$export(module.exports, "ThemeOptions", () => $e6600b9fe64b6e3b$export$abe7936539cefefe);
$parcel$export(module.exports, "DEFAULT_THEME", () => $e6600b9fe64b6e3b$export$2faeed762aac6741);
// This type inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $e6600b9fe64b6e3b$export$abe7936539cefefe = [
    'light',
    'dark',
    'auto'
];
const $e6600b9fe64b6e3b$export$2faeed762aac6741 = 'light';

});


parcelRegister("7bw1Z", function(module, exports) {

let $53b2682f788a163f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $53b2682f788a163f$var$load("1VRB2"),
    $53b2682f788a163f$var$load("bABhq"),
    $53b2682f788a163f$var$load("flqSQ")
]).then(()=>parcelRequire('fgD68'));

});


parcelRegister("aUy7d", function(module, exports) {

$parcel$export(module.exports, "userHomepageResource", () => $087598b26d31627a$export$16320dd0d1e6c145);

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");

const $087598b26d31627a$export$16320dd0d1e6c145 = (0, $l1VxS.createResource)({
    type: (0, $3eb5263dc85dae9a$export$2026a6db44b15de7),
    getKey: ()=>'state',
    getData: async (_dataContext, _storeContext)=>{
        const { homepagePreference: homepagePreference } = await (0, $jGzN3.performGetRequest)('/rest/internal/3/homepage/');
        return {
            homepagePreference: homepagePreference
        };
    },
    maxAge: Infinity,
    isCritical: true
});

});
const $3eb5263dc85dae9a$export$2026a6db44b15de7 = 'USER_HOMEPAGE';


parcelRegister("5fjzQ", function(module, exports) {

$parcel$export(module.exports, "postOfficeJiraSideNavResource", () => $14f67614a8998d75$export$5fd5ab86e70497f7);
$parcel$export(module.exports, "postOfficeJiraYourWorkResource", () => $14f67614a8998d75$export$5969dfe9b3b29cd3);
$parcel$export(module.exports, "postOfficeJiraTopBannerResource", () => $14f67614a8998d75$export$af242b8c8ffaab42);
$parcel$export(module.exports, "conditionalPostOfficeJiraTopBannerResource", () => $14f67614a8998d75$export$d1df0b3b482d298d);
$parcel$export(module.exports, "postOfficeNav4ProjectsSectionResource", () => $14f67614a8998d75$export$3f8e412b85cb402b);
// eslint-disable-next-line jira/import-whitelist

var $2xVkf = parcelRequire("2xVkf");

var $l1VxS = parcelRequire("l1VxS");

var $5L7qx = parcelRequire("5L7qx");

var $7jTnu = parcelRequire("7jTnu");
const $14f67614a8998d75$export$fd097948b42db8d3 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__SCREEN_SPACE_FLAGS',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('screen-space-flags', tenantContext);
    },
    maxAge: Infinity
});
const $14f67614a8998d75$export$5fd5ab86e70497f7 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_SIDE_NAV',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('jira-side-nav', tenantContext);
    },
    maxAge: Infinity,
    isCritical: true
});
const $14f67614a8998d75$export$5969dfe9b3b29cd3 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_YOUR_WORK',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('jira-your-work', tenantContext);
    },
    maxAge: Infinity
});
const $14f67614a8998d75$export$af242b8c8ffaab42 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_TOP_BANNER',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isSiteAdmin: isSiteAdmin } = tenantContext;
        if (isSiteAdmin) return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('jira-top-banner', tenantContext);
        return null;
    },
    maxAge: Infinity
});
const $14f67614a8998d75$export$d1df0b3b482d298d = (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jira-issue-term-refresh-banner'), $14f67614a8998d75$export$af242b8c8ffaab42);
const $14f67614a8998d75$export$1d4ef0f14729d528 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__NAV_4_SECTION',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('nav-4-section', tenantContext);
    },
    maxAge: Infinity
});
const $14f67614a8998d75$var$nav4ProjectsSectionEnabledGroup = new Set([
    'classic-business',
    'classic-software',
    'home',
    'issue',
    'issue-navigator',
    'legacy',
    'polaris',
    'servicedesk',
    'software',
    'software-reports-boardless'
]);
const $14f67614a8998d75$export$3f8e412b85cb402b = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__NAV_4_PROJECTS_SECTION',
    getKey: ()=>'state',
    getData: async ({ route: { group: group } }, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous, isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = tenantContext;
        if (isAnonymous || !isAdmin || !isSiteAdmin) return null;
        if (!group || !$14f67614a8998d75$var$nav4ProjectsSectionEnabledGroup.has(group)) return null;
        return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('nav-4-projects-section', tenantContext);
    },
    maxAge: Infinity
});

});
parcelRegister("2xVkf", function(module, exports) {

$parcel$export(module.exports, "usePlacementSSRFetch", () => $172104d4dfe494d0$export$420f2f91a928b3b6);
$parcel$export(module.exports, "preloadPostOfficePlacementWithTenantContext", () => $172104d4dfe494d0$export$65b5eab182e1ca6f);

var $eJOHy = parcelRequire("eJOHy");

var $jGzN3 = parcelRequire("jGzN3");

var $fikfn = parcelRequire("fikfn");

var $a9pdq = parcelRequire("a9pdq");

var $eJrcF = parcelRequire("eJrcF");

var $dCq6B = parcelRequire("dCq6B");
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $172104d4dfe494d0$var$preloadPostOfficePlacement = async (placementId, contextOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    const jiraFetcherWithS2SHeaders = async (url)=>{
        let hostEnv = 'prod';
        if (environment.currentEnv !== 'production') hostEnv = 'staging';
        const fetchHeaders = {
            'x-ssr-service-name': 'post-office',
            'x-ssr-service-env': hostEnv
        };
        return (0, $jGzN3.performGetRequest)(url.replace('gateway/api/post-office/', ''), {
            headers: fetchHeaders
        });
    };
    return (0, $a9pdq.requestInitialData)(placementId, postOfficeContext, false ? jiraFetcherWithS2SHeaders : (0, $jGzN3.performGetRequest), (0, $fikfn.buildBasePath)(environment.currentEnv, environment.envConfigs));
};
const $172104d4dfe494d0$export$420f2f91a928b3b6 = (resource)=>{
    const { data: data } = (0, $eJrcF.useResource)(resource);
    return (0, $eJOHy.useCallback)(()=>{
        if (data) {
            /**
			 * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
			 * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
			 */ const init = {
                status: 200,
                statusText: 'ok!'
            };
            return Promise.resolve(new Response(JSON.stringify(data), init));
        }
    }, [
        data
    ]);
};
const $172104d4dfe494d0$export$17b92961ead3f211 = (resource)=>{
    const { data: data } = (0, $eJrcF.useResource)(resource);
    return data;
};
const $172104d4dfe494d0$export$65b5eab182e1ca6f = async (placementId, preloadedTenantContext)=>{
    return $172104d4dfe494d0$var$preloadPostOfficePlacement(placementId, {
        postOfficeContext: (0, $dCq6B.tenantToPostOfficeContext)(preloadedTenantContext),
        environment: {
            currentEnv: (0, $dCq6B.transformJiraEnvToPostOfficeEnvironment)(preloadedTenantContext.environment)
        }
    });
};

});
parcelRegister("fikfn", function(module, exports) {

$parcel$export(module.exports, "buildBasePath", () => $2dda680bd9c70c2a$export$e8b30f9c4a80230f);


var $8OhYX = parcelRequire("8OhYX");
const $2dda680bd9c70c2a$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $8OhYX.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $4a5f9d5e0db62f46$export$d4fe3482c88e73a8);
    return {
        baseUrl: baseUrl,
        path: path
    };
};

});
var $4a5f9d5e0db62f46$exports = {};

$parcel$export($4a5f9d5e0db62f46$exports, "API_ORIGIN_TEST_SERVER", () => $4a5f9d5e0db62f46$export$5ca004be156a127a);
$parcel$export($4a5f9d5e0db62f46$exports, "API_ORIGIN_LOCAL", () => $4a5f9d5e0db62f46$export$1e9fed4c0197724c);
$parcel$export($4a5f9d5e0db62f46$exports, "API_PATHNAME_LOCAL", () => $4a5f9d5e0db62f46$export$919a9569bce66f17);
$parcel$export($4a5f9d5e0db62f46$exports, "API_PATHNAME_STG_PROD", () => $4a5f9d5e0db62f46$export$d4fe3482c88e73a8);
$parcel$export($4a5f9d5e0db62f46$exports, "REMOTE_MODULE_URI_LOCAL", () => $4a5f9d5e0db62f46$export$67be2569ef5d7666);
$parcel$export($4a5f9d5e0db62f46$exports, "REMOTE_MODULE_URI_STG", () => $4a5f9d5e0db62f46$export$b49738b89db261cd);
$parcel$export($4a5f9d5e0db62f46$exports, "REMOTE_MODULE_URI_PROD", () => $4a5f9d5e0db62f46$export$bbd96cd490b0df63);
const $4a5f9d5e0db62f46$export$5ca004be156a127a = 'http://localhost:4224';
const $4a5f9d5e0db62f46$export$a5c5394c951a9848 = '/gateway/api/post-office/api/v1/placements/';
const $4a5f9d5e0db62f46$export$1e9fed4c0197724c = 'http://localhost:8081';
const $4a5f9d5e0db62f46$export$919a9569bce66f17 = '/api/v1/placements/';
const $4a5f9d5e0db62f46$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $4a5f9d5e0db62f46$export$67be2569ef5d7666 = 'http://localhost:9009';
const $4a5f9d5e0db62f46$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $4a5f9d5e0db62f46$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';

parcelRegister("8OhYX", function(module, exports) {

$parcel$export(module.exports, "defaultEnvironmentValues", () => $cc9761a82f52107d$export$b4ede87479bfcf09);
$parcel$export(module.exports, "PostOfficeEnvironmentProvider", () => $cc9761a82f52107d$export$604607f913ef367c);
$parcel$export(module.exports, "usePostOfficeEnvironment", () => $cc9761a82f52107d$export$877b97169cc75e8b);

var $eJOHy = parcelRequire("eJOHy");

const $cc9761a82f52107d$export$b4ede87479bfcf09 = {
    currentEnv: 'local',
    envConfigs: {
        'test-server': {
            remoteModule: {
                origin: (0, $4a5f9d5e0db62f46$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $4a5f9d5e0db62f46$export$5ca004be156a127a),
                pathname: (0, $4a5f9d5e0db62f46$export$5ca004be156a127a),
                searchParams: undefined
            }
        },
        test: {
            remoteModule: {
                origin: (0, $4a5f9d5e0db62f46$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $4a5f9d5e0db62f46$export$1e9fed4c0197724c),
                pathname: (0, $4a5f9d5e0db62f46$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        local: {
            remoteModule: {
                origin: (0, $4a5f9d5e0db62f46$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $4a5f9d5e0db62f46$export$1e9fed4c0197724c),
                pathname: (0, $4a5f9d5e0db62f46$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        dev: {
            remoteModule: {
                origin: (0, $4a5f9d5e0db62f46$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $4a5f9d5e0db62f46$export$1e9fed4c0197724c),
                pathname: (0, $4a5f9d5e0db62f46$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        staging: {
            remoteModule: {
                origin: (0, $4a5f9d5e0db62f46$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $4a5f9d5e0db62f46$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'stg-fedm-east': {
            remoteModule: {
                origin: (0, $4a5f9d5e0db62f46$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $4a5f9d5e0db62f46$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        production: {
            remoteModule: {
                origin: (0, $4a5f9d5e0db62f46$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $4a5f9d5e0db62f46$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'prod-fedm-east': {
            remoteModule: {
                origin: (0, $4a5f9d5e0db62f46$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $4a5f9d5e0db62f46$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        }
    }
};
const $cc9761a82f52107d$export$fceca2c399b32565 = (0, $eJOHy.createContext)($cc9761a82f52107d$export$b4ede87479bfcf09);
const $cc9761a82f52107d$export$604607f913ef367c = $cc9761a82f52107d$export$fceca2c399b32565.Provider;
const $cc9761a82f52107d$export$877b97169cc75e8b = ()=>(0, $eJOHy.useContext)($cc9761a82f52107d$export$fceca2c399b32565);

});


parcelRegister("a9pdq", function(module, exports) {

$parcel$export(module.exports, "requestInitialData", () => $a1451e1b709103de$export$c4c39037cc4b06ab);
const $a1451e1b709103de$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $a1451e1b709103de$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $a1451e1b709103de$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};

});

parcelRegister("dCq6B", function(module, exports) {

$parcel$export(module.exports, "tenantToPostOfficeContext", () => $509e2223bb06925e$export$d8f2c334a0924146);
$parcel$export(module.exports, "subproductToEdition", () => $509e2223bb06925e$export$2d690d13b91ea44f);
$parcel$export(module.exports, "transformJiraEnvToPostOfficeEnvironment", () => $509e2223bb06925e$export$cfacfecb20987ff1);

var $goBB5 = parcelRequire("goBB5");
const $509e2223bb06925e$var$JIRA_PRODUCT = 'jira';
const $509e2223bb06925e$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $509e2223bb06925e$var$JIRA_PRODUCT,
    locale: 'en'
};
const $509e2223bb06925e$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return (0, $goBB5.JiraWorkspaceAri).create({
        activationId: activationId,
        siteId: cloudId
    }).toString();
};
const $509e2223bb06925e$export$d8f2c334a0924146 = (tenantData)=>{
    const { activationId: activationId, cloudId: cloudId, isSiteAdmin: isSiteAdmin, locale: locale, isAdmin: isAdmin } = tenantData;
    const workspaceAri = $509e2223bb06925e$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$509e2223bb06925e$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        isSiteAdmin: isSiteAdmin,
        tenantId: cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        isAdmin: isAdmin,
        orgId: undefined,
        subproduct: undefined,
        productEdition: undefined
    };
};
const $509e2223bb06925e$export$2d690d13b91ea44f = (subproduct, editions)=>{
    switch(subproduct){
        case 'core':
            return editions.core;
        case 'software':
            return editions.software;
        case 'customerService':
            return editions.customerService;
        case 'serviceDesk':
            return editions.serviceDesk;
        default:
            undefined;
    }
};
const $509e2223bb06925e$export$cfacfecb20987ff1 = (environment)=>{
    switch(environment){
        case 'dev':
        case 'staging':
            return 'staging';
        case 'prod':
            return 'production';
        case 'local':
            return 'local';
        default:
            return 'local';
    }
};

});



parcelRegister("hXbwo", function(module, exports) {

$parcel$export(module.exports, "previewPanelStateResource", () => $9c99d47f78a5b0ec$export$c2ef0c3db4ecdea3);

var $9FYIg = parcelRequire("9FYIg");

var $gOhSQ = parcelRequire("gOhSQ");
const $9c99d47f78a5b0ec$export$c2ef0c3db4ecdea3 = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_PREVIEW_PANEL`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $gOhSQ.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true
});

});
parcelRegister("gOhSQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67849424e576d32a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c7608bc86a22fc5b75aa29f223aaf4d1>>
 * @relayHash b395f613968319e8a511c65e3f1ee5fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0bd19038110f3e5bb601e887eb92c999d5f1bd367631b389e79e2bc34a42c0a2
const $67849424e576d32a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "concreteType": "JiraPreviewPanelState",
        "kind": "LinkedField",
        "name": "previewPanel",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "width"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0bd19038110f3e5bb601e887eb92c999d5f1bd367631b389e79e2bc34a42c0a2",
            "metadata": {},
            "name": "PreviewPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$67849424e576d32a$var$node.hash = "7327e4b44435e860a8ce1fbd4e39a463";
var $67849424e576d32a$export$2e2bcd8739ae039 = $67849424e576d32a$var$node;

});


parcelRegister("lzT4f", function(module, exports) {

$parcel$export(module.exports, "jsmGracePeriodAnnouncementDisplayStateResource", () => $20a65304ac3aab9f$export$9c4218ae35fac02e);
$parcel$export(module.exports, "useJsmGracePeriodAnnouncementDisplayStateResource", () => $20a65304ac3aab9f$export$fed541e4e6eb934c);
$parcel$export(module.exports, "jsmGracePeriodAnnouncementGpEndDateResource", () => $20a65304ac3aab9f$export$ee26341514033dab);
$parcel$export(module.exports, "useJsmGracePeriodAnnouncementGpEndDateResource", () => $20a65304ac3aab9f$export$6b1dcceb1bcecc4c);

var $eJOHy = parcelRequire("eJOHy");

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $gCeeo = parcelRequire("gCeeo");

var $22xih = parcelRequire("22xih");

const $20a65304ac3aab9f$export$9c4218ae35fac02e = (0, $l1VxS.createResource)({
    type: 'JSM_GRACE_PERIOD_ANNOUNCEMENT_DISPLAY_STATE',
    getKey: ()=>'JSM_GRACE_PERIOD_ANNOUNCEMENT_DISPLAY_STATE',
    getDataLoader: ()=>(parcelRequire("lB7S3")),
    maxAge: Infinity,
    isCritical: true
});
const $20a65304ac3aab9f$var$getNewAnnouncementDismissState = (bannerType, baseDisplayState, useNewT90State)=>{
    const newT90State = useNewT90State ? 'hideT90BannerNew' : 'hideT90Banner';
    const updatedState = {
        ...baseDisplayState,
        [bannerType === 'T30' ? 'hideT30Banner' : newT90State]: true
    };
    return updatedState;
};
const $20a65304ac3aab9f$export$fed541e4e6eb934c = (accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, $eJrcF.useResource)($20a65304ac3aab9f$export$9c4218ae35fac02e);
    const loadingRef = (0, $eJOHy.useRef)(false);
    const errorRef = (0, $eJOHy.useRef)();
    const [userPropertiesError, setUserPropertiesError] = (0, $eJOHy.useState)();
    errorRef.current = userPropertiesError || error;
    const dismissAnnouncement = (0, $eJOHy.useCallback)((baseState, bannerType, analyticsEvent, useNewT90State)=>{
        update(()=>$20a65304ac3aab9f$var$getNewAnnouncementDismissState(bannerType, baseState, useNewT90State));
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $gYnSx.default)({
                    meta: {
                        id: 'useJsmGracePeriodAnnouncementResource-update',
                        packageName: 'jiraRouterResourcesJsmGracePeriodAnnouncements',
                        teamName: 'Seqouia'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $FppkK.setUserProperties)(accountId, (0, $22xih.JSM_GRACE_PERIOD_ANNOUNCEMENT_USER_STATE_STORAGE_KEY), JSON.stringify($20a65304ac3aab9f$var$getNewAnnouncementDismissState(bannerType, baseState, useNewT90State))).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                (0, $gYnSx.default)({
                    meta: {
                        id: 'useJsmGracePeriodAnnouncementResource-update',
                        packageName: 'jiraRouterResourcesJsmGracePeriodAnnouncements',
                        teamName: 'Sequoia'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                // SQA-804: Add more typeOfUserEngagement attributes when we release the banner to low engaged GPC
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'dismissJsmGracePeriodBanner', {
                    source: 'jsmGracePeriodBanner',
                    bannerType: bannerType,
                    typeOfUserEngagement: 'high'
                });
                loadingRef.current = false;
            });
        }
    }, [
        update,
        accountId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (errorRef.current || loading || !data || !accountId) return {
            loading: loading,
            displayState: {
                hideT30Banner: true,
                hideT90Banner: true,
                hideT90BannerNew: true
            },
            dismissAnnouncement: dismissAnnouncement
        };
        return {
            displayState: data,
            loading: loading,
            dismissAnnouncement: dismissAnnouncement
        };
    }, [
        loading,
        data,
        accountId,
        dismissAnnouncement
    ]);
};

const $20a65304ac3aab9f$export$ee26341514033dab = (0, $l1VxS.createResource)({
    type: 'JSM_GRACE_PERIOD_ANNOUNCEMENT_GP_END_DATE',
    getKey: ()=>'JSM_GRACE_PERIOD_ANNOUNCEMENT_GP_END_DATE',
    getDataLoader: ()=>(parcelRequire("1CACA")),
    maxAge: Infinity,
    isCritical: true
});
const $20a65304ac3aab9f$export$6b1dcceb1bcecc4c = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)($20a65304ac3aab9f$export$ee26341514033dab);
    const errorRef = (0, $eJOHy.useRef)();
    errorRef.current = error;
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (errorRef.current || loading) return {
            loading: loading
        };
        return {
            gpEndDateDetails: data?.gpEndDateDetails,
            gpEndDate: data?.gracePeriodEndDate,
            loading: loading
        };
    }, [
        loading,
        data
    ]);
};

});
parcelRegister("22xih", function(module, exports) {

$parcel$export(module.exports, "JSM_GRACE_PERIOD_ANNOUNCEMENT_USER_STATE_STORAGE_KEY", () => $bbc1e6534917c377$export$7d5b09dea0d101b7);
$parcel$export(module.exports, "DEFAULT_ANNOUNCEMENT_BANNER_DISPLAY_STATE", () => $bbc1e6534917c377$export$3751c4ee78cb739a);
$parcel$export(module.exports, "FALLBACK_GP_END_DATE", () => $bbc1e6534917c377$export$a50854eacfeb5c82);
const $bbc1e6534917c377$export$7d5b09dea0d101b7 = 'jsm-grace-period-announcement-dismiss-state';
const $bbc1e6534917c377$export$3751c4ee78cb739a = {};
const $bbc1e6534917c377$export$a50854eacfeb5c82 = new Date('10/16/2025');

});

parcelRegister("lB7S3", function(module, exports) {

let $fb9328a85c82511d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fb9328a85c82511d$var$load("fM38a").then(()=>parcelRequire('eUCn3'));

});

parcelRegister("1CACA", function(module, exports) {

let $12e5bf51709ff6da$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $12e5bf51709ff6da$var$load("kS36X").then(()=>parcelRequire('3kT7K'));

});



parcelRegister("cu1g7", function(module, exports) {

$parcel$export(module.exports, "serviceDeskAnalyticsContextResource", () => $ad4e7c5cdb1bb62b$export$d6f4f0483916919f);
$parcel$export(module.exports, "useServiceDeskAnalyticsContext", () => $ad4e7c5cdb1bb62b$export$bc2de1c42df30b10);

var $eJOHy = parcelRequire("eJOHy");

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $ad4e7c5cdb1bb62b$var$getDataLoader = ()=>(parcelRequire("bVgah"));
const $ad4e7c5cdb1bb62b$var$ONE_DAY_IN_MILLIS = 86400000;
const $ad4e7c5cdb1bb62b$export$d6f4f0483916919f = (0, $l1VxS.createResource)({
    type: (0, $72fb76455039ad7c$export$285b47583a5bdd0f),
    getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
    getDataLoader: $ad4e7c5cdb1bb62b$var$getDataLoader,
    maxAge: $ad4e7c5cdb1bb62b$var$ONE_DAY_IN_MILLIS
});
const $ad4e7c5cdb1bb62b$export$bc2de1c42df30b10 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)($ad4e7c5cdb1bb62b$export$d6f4f0483916919f);
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
const $72fb76455039ad7c$export$285b47583a5bdd0f = 'SERVICEDESK_ANALYTICS_CONTEXT';

parcelRegister("bVgah", function(module, exports) {

let $8ae18e90a018fb79$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8ae18e90a018fb79$var$load("hwlgY"),
    $8ae18e90a018fb79$var$load("j1RXX")
]).then(()=>parcelRequire('icgY0'));

});


parcelRegister("kgDPH", function(module, exports) {

$parcel$export(module.exports, "serviceDeskContextResource", () => $5ade9d115ab90445$export$5eaaf465969a9171);

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");


const $5ade9d115ab90445$var$getDataLoader = ()=>(parcelRequire("dzGnI"));
const $5ade9d115ab90445$export$5eaaf465969a9171 = (0, $l1VxS.createResource)({
    type: (0, $ae1f145ea4ba545a$export$ac01662d5287bc5c),
    getKey: ({ match: match, query: query })=>(0, $fcQiO.getProjectKeyOrIdFromMatchAndQuery)({
            match: match,
            query: query
        }),
    getDataLoader: $5ade9d115ab90445$var$getDataLoader,
    maxAge: Infinity
});

});
const $ae1f145ea4ba545a$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';

parcelRegister("dzGnI", function(module, exports) {

let $9e1f6b58470203ef$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9e1f6b58470203ef$var$load("iOa7h").then(()=>parcelRequire('c0Tkr'));

});


parcelRegister("iWhpv", function(module, exports) {

$parcel$export(module.exports, "servicedeskIsItsmProjectResource", () => $20362448f0bcac55$export$920308cef4e291b1);
$parcel$export(module.exports, "useIsItsmTemplateProject", () => $20362448f0bcac55$export$7bb46948fb84f164);

var $eJOHy = parcelRequire("eJOHy");

var $bo7Z6 = parcelRequire("bo7Z6");

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");


const $20362448f0bcac55$var$getDataLoader = ()=>(parcelRequire("2PKZn"));
const $20362448f0bcac55$var$ONE_DAY_IN_MILLIS = 86400000;
const $20362448f0bcac55$export$920308cef4e291b1 = (0, $l1VxS.createResource)({
    type: (0, $d87510ea5f50e0bd$export$543a8644640f4092),
    getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
    getDataLoader: $20362448f0bcac55$var$getDataLoader,
    maxAge: $20362448f0bcac55$var$ONE_DAY_IN_MILLIS
});
const $20362448f0bcac55$export$7bb46948fb84f164 = (projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $bo7Z6.useResourceWithCustomRouterContext)($20362448f0bcac55$export$920308cef4e291b1, projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined, {
        shouldPrefetch: true
    });
    return (0, $eJOHy.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("bo7Z6", function(module, exports) {

$parcel$export(module.exports, "useResourceWithCustomRouterContext", () => $293b1501ed0e6af1$export$61dad767cf446185);

var $eA736 = parcelRequire("eA736");
var $eJrcF = parcelRequire("eJrcF");

var $8IXJk = parcelRequire("8IXJk");
/**
 * DUMMY_ROUTE needs to be used by default, because `route` must not be undefined, it is required/used internally by RRR, e.g. in findRouterContext() on createRouterContext() call.
 * If `route` is undefined, those will throw runtime exceptions.
 * `project-sidebar-navigation-resource/software-cmp-nav-synchronizer/index.tsx` uses dummy route as well.
 *
 * Jfyi, createProjectRouteRouterContext() function in JSW uses dummy route, with :projectKey in its path (that resource fetch function uses)
 */ const $293b1501ed0e6af1$var$DUMMY_ROUTE = {
    name: 'DUMMY_ROUTE_NAME',
    path: '/projects/:projectKey/dummyroute'
};
function $293b1501ed0e6af1$export$61dad767cf446185(resource, customRouterContext, options = {}) {
    let resourceOptions;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $293b1501ed0e6af1$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
            routerContext: (0, $eA736.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const { shouldPrefetch: shouldPrefetch } = options;
    const resourceResponse = (0, $eJrcF.useResource)(resource, resourceOptions);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $8IXJk.usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
    return resourceResponse;
}

});
parcelRegister("8IXJk", function(module, exports) {

$parcel$export(module.exports, "usePrefetchableResource", () => $f61fc1df4d840af0$export$99f17ace416cfe75);

var $eJOHy = parcelRequire("eJOHy");
function $f61fc1df4d840af0$export$99f17ace416cfe75(resource, shouldPrefetch) {
    (0, $eJOHy.useEffect)(()=>{
        if (!shouldPrefetch) return;
        // "false" is a valid value for data here. We only want to trigger a refresh if data is null or undefined.
        if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


const $d87510ea5f50e0bd$export$543a8644640f4092 = 'SERVICEDESK_IS_ITSM_PROJECT';

parcelRegister("2PKZn", function(module, exports) {

let $2104cb315ed31048$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $2104cb315ed31048$var$load("hwlgY"),
    $2104cb315ed31048$var$load("juTJF")
]).then(()=>parcelRequire('bJETC'));

});


parcelRegister("JHxCO", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticesResource", () => $446148a1d016b5d1$export$2ae319305481e7de);
$parcel$export(module.exports, "useWorkCategoriesQueueSupported", () => $446148a1d016b5d1$export$a86ac771006f14b3);
$parcel$export(module.exports, "useWorkCategoriesAllSupported", () => $446148a1d016b5d1$export$fe081b1a59d3c818);
$parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", () => $446148a1d016b5d1$export$4d46346ef0bdc6b9);

var $eJOHy = parcelRequire("eJOHy");

var $fcQiO = parcelRequire("fcQiO");

var $jlJsl = parcelRequire("jlJsl");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $446148a1d016b5d1$var$getDataLoader = ()=>(parcelRequire("bM6Yf"));
const $446148a1d016b5d1$var$ONE_DAY_IN_MILLIS = 86400000;
const $446148a1d016b5d1$export$2ae319305481e7de = (0, $l1VxS.createResource)({
    type: (0, $6d5c2d68fdd6fc0f$export$45919c8f50bb1db5),
    getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
    getDataLoader: $446148a1d016b5d1$var$getDataLoader,
    maxAge: $446148a1d016b5d1$var$ONE_DAY_IN_MILLIS
});
const $446148a1d016b5d1$var$queuesOrder = [
    ...(0, $jlJsl.WORK_CATEGORIES_QUEUE_SUPPORTED)
];
const $446148a1d016b5d1$var$workCategoryOrder = [
    ...$446148a1d016b5d1$var$queuesOrder,
    (0, $jlJsl.DEVELOPER_ESCALATION)
];
const $446148a1d016b5d1$var$transformItsmPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $446148a1d016b5d1$var$queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $446148a1d016b5d1$var$transformServiceDeskPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $446148a1d016b5d1$var$workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $446148a1d016b5d1$export$a86ac771006f14b3 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $eJrcF.useResource)($446148a1d016b5d1$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $eJOHy.useMemo)(()=>({
            data: $446148a1d016b5d1$var$transformItsmPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $446148a1d016b5d1$export$fe081b1a59d3c818 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $eJrcF.useResource)($446148a1d016b5d1$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $eJOHy.useMemo)(()=>({
            data: $446148a1d016b5d1$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $446148a1d016b5d1$export$4d46346ef0bdc6b9 = ()=>{
    const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $eJrcF.useResource)($446148a1d016b5d1$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    (0, $eJOHy.useEffect)(()=>{
        if (!loading && !data && !error) refreshPractices();
    }, [
        data,
        error,
        loading,
        refreshPractices
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            data: $446148a1d016b5d1$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};

});
parcelRegister("jlJsl", function(module, exports) {

$parcel$export(module.exports, "CHANGES", () => $4f1e5109a7f57422$export$8598196f74460271);
$parcel$export(module.exports, "INCIDENTS", () => $4f1e5109a7f57422$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "PROBLEMS", () => $4f1e5109a7f57422$export$ceba70db1edb1def);
$parcel$export(module.exports, "SERVICE_REQUEST", () => $4f1e5109a7f57422$export$3d1cda9bd50505e8);
$parcel$export(module.exports, "POST_INCIDENT_REVIEWS", () => $4f1e5109a7f57422$export$6ebf7b6bf1c580f);
$parcel$export(module.exports, "DEVELOPER_ESCALATION", () => $4f1e5109a7f57422$export$81e62964cc725098);
$parcel$export(module.exports, "NO_CATEGORY", () => $4f1e5109a7f57422$export$485b1216c42d8d4);
$parcel$export(module.exports, "NO_PRACTICE", () => $4f1e5109a7f57422$export$52bf3f16b7812704);
$parcel$export(module.exports, "SHORT_FORM_CHANGES", () => $4f1e5109a7f57422$export$a50185c8e9fb007e);
$parcel$export(module.exports, "SHORT_FORM_INCIDENTS", () => $4f1e5109a7f57422$export$a54a30a3c3cce634);
$parcel$export(module.exports, "SHORT_FORM_PROBLEMS", () => $4f1e5109a7f57422$export$354f3a4c6ac0c903);
$parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", () => $4f1e5109a7f57422$export$335d3ac0c367f03f);
$parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", () => $4f1e5109a7f57422$export$7ffd7f2c2ae96b6f);
$parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", () => $4f1e5109a7f57422$export$cb41b99ca54e6bd);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED", () => $4f1e5109a7f57422$export$a2b1f8f055150f02);
$parcel$export(module.exports, "ItsmPracticeToShortForm", () => $4f1e5109a7f57422$export$56c57f7ad650c45c);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP", () => $4f1e5109a7f57422$export$fbf0dfd01228e38d);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", () => $4f1e5109a7f57422$export$45ba5f49e9509c4d);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED_LABELS", () => $4f1e5109a7f57422$export$45952424a7f29b99);
$parcel$export(module.exports, "CHANGES_JQL_NAME", () => $4f1e5109a7f57422$export$6c24c440228eac9c);
$parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", () => $4f1e5109a7f57422$export$3f757c5e00588ffd);
$parcel$export(module.exports, "practiceKeyJqlNameMapping", () => $4f1e5109a7f57422$export$b78213db77524b5b);

var $kF1zg = parcelRequire("kF1zg");

var $ZfaX7 = parcelRequire("ZfaX7");
const $4f1e5109a7f57422$export$8598196f74460271 = 'change-management';
const $4f1e5109a7f57422$export$a50b49a533b5f7bc = 'incident-management';
const $4f1e5109a7f57422$export$ceba70db1edb1def = 'problem-management';
const $4f1e5109a7f57422$export$3d1cda9bd50505e8 = 'service-request';
const $4f1e5109a7f57422$export$6ebf7b6bf1c580f = 'post-incident-review';
const $4f1e5109a7f57422$export$81e62964cc725098 = 'developer-escalation';
const $4f1e5109a7f57422$export$485b1216c42d8d4 = 'no-category';
const $4f1e5109a7f57422$var$NO_CATEGORY_NEW = 'no-category-new';
const $4f1e5109a7f57422$export$52bf3f16b7812704 = 'no-practice'; // BERRY-1358 should consolidate into NO_CATEGORY
const $4f1e5109a7f57422$export$a50185c8e9fb007e = 'changes';
const $4f1e5109a7f57422$export$a54a30a3c3cce634 = 'incidents';
const $4f1e5109a7f57422$export$354f3a4c6ac0c903 = 'problems';
const $4f1e5109a7f57422$export$335d3ac0c367f03f = 'service-requests';
const $4f1e5109a7f57422$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
const $4f1e5109a7f57422$export$cb41b99ca54e6bd = 'developer-escalations';
const $4f1e5109a7f57422$export$a613d808168c7b25 = [
    $4f1e5109a7f57422$export$8598196f74460271,
    $4f1e5109a7f57422$export$a50b49a533b5f7bc,
    $4f1e5109a7f57422$export$ceba70db1edb1def,
    $4f1e5109a7f57422$export$3d1cda9bd50505e8,
    $4f1e5109a7f57422$export$6ebf7b6bf1c580f,
    $4f1e5109a7f57422$export$81e62964cc725098
]; // /!\ defines WorkCategoryApiResource type
const $4f1e5109a7f57422$export$a2b1f8f055150f02 = [
    $4f1e5109a7f57422$export$3d1cda9bd50505e8,
    $4f1e5109a7f57422$export$a50b49a533b5f7bc,
    $4f1e5109a7f57422$export$ceba70db1edb1def,
    $4f1e5109a7f57422$export$8598196f74460271,
    $4f1e5109a7f57422$export$6ebf7b6bf1c580f
]; // /!\ defines WorkCategoryQueueSupported type
const $4f1e5109a7f57422$export$5a9122a4028fb8ef = [
    ...$4f1e5109a7f57422$export$a2b1f8f055150f02,
    $4f1e5109a7f57422$export$485b1216c42d8d4
];
const $4f1e5109a7f57422$export$f1b813cd23817ade = [
    $4f1e5109a7f57422$export$a50185c8e9fb007e,
    $4f1e5109a7f57422$export$a54a30a3c3cce634,
    $4f1e5109a7f57422$export$354f3a4c6ac0c903,
    $4f1e5109a7f57422$export$335d3ac0c367f03f,
    $4f1e5109a7f57422$export$7ffd7f2c2ae96b6f,
    $4f1e5109a7f57422$export$cb41b99ca54e6bd
]; // /!\ defines WorkCategoryShortForm type
const $4f1e5109a7f57422$export$56c57f7ad650c45c = {
    [$4f1e5109a7f57422$export$8598196f74460271]: $4f1e5109a7f57422$export$a50185c8e9fb007e,
    [$4f1e5109a7f57422$export$a50b49a533b5f7bc]: $4f1e5109a7f57422$export$a54a30a3c3cce634,
    [$4f1e5109a7f57422$export$ceba70db1edb1def]: $4f1e5109a7f57422$export$354f3a4c6ac0c903,
    [$4f1e5109a7f57422$export$3d1cda9bd50505e8]: $4f1e5109a7f57422$export$335d3ac0c367f03f,
    [$4f1e5109a7f57422$export$6ebf7b6bf1c580f]: $4f1e5109a7f57422$export$7ffd7f2c2ae96b6f,
    [$4f1e5109a7f57422$export$485b1216c42d8d4]: $4f1e5109a7f57422$var$NO_CATEGORY_NEW
};
const $4f1e5109a7f57422$export$fbf0dfd01228e38d = {
    [$4f1e5109a7f57422$export$8598196f74460271]: (0, $ZfaX7.default).changes,
    [$4f1e5109a7f57422$export$3d1cda9bd50505e8]: (0, $ZfaX7.default).serviceRequests,
    [$4f1e5109a7f57422$export$ceba70db1edb1def]: (0, $ZfaX7.default).problems,
    [$4f1e5109a7f57422$export$a50b49a533b5f7bc]: (0, $ZfaX7.default).incidents,
    [$4f1e5109a7f57422$export$6ebf7b6bf1c580f]: (0, $ZfaX7.default).postIncidentReviews,
    [$4f1e5109a7f57422$export$485b1216c42d8d4]: (0, $ZfaX7.default).queues,
    [$4f1e5109a7f57422$export$81e62964cc725098]: (0, $ZfaX7.default).developerEscalation,
    [$4f1e5109a7f57422$export$52bf3f16b7812704]: (0, $ZfaX7.default).noCategory
};
const $4f1e5109a7f57422$export$45ba5f49e9509c4d = {
    [$4f1e5109a7f57422$export$8598196f74460271]: (0, $ZfaX7.default).changesLower,
    [$4f1e5109a7f57422$export$3d1cda9bd50505e8]: (0, $ZfaX7.default).serviceRequestsLower,
    [$4f1e5109a7f57422$export$ceba70db1edb1def]: (0, $ZfaX7.default).problemsLower,
    [$4f1e5109a7f57422$export$a50b49a533b5f7bc]: (0, $ZfaX7.default).incidentsLower,
    [$4f1e5109a7f57422$export$6ebf7b6bf1c580f]: (0, $ZfaX7.default).postIncidentReviewsLower,
    [$4f1e5109a7f57422$export$485b1216c42d8d4]: (0, $ZfaX7.default).queuesLower,
    [$4f1e5109a7f57422$export$81e62964cc725098]: (0, $ZfaX7.default).developerEscalationLower,
    [$4f1e5109a7f57422$export$52bf3f16b7812704]: (0, $ZfaX7.default).noCategoryLower
};
const $4f1e5109a7f57422$export$45952424a7f29b99 = (0, $kF1zg.getTypedKeys)($4f1e5109a7f57422$export$fbf0dfd01228e38d).reduce((acc, labelMapKey)=>{
    // cannot type .indexOf() as not-string in Ts, therefore need to use .find(). And shows error if `key` in acc[key] being of wider type than the result (than ItsmPracticeCategory), therefore, need to use different keys in the `acc[queueKey] =` line
    const queueKey = $4f1e5109a7f57422$export$a2b1f8f055150f02.find((key)=>key === labelMapKey);
    if (queueKey) acc[queueKey] = $4f1e5109a7f57422$export$fbf0dfd01228e38d[labelMapKey];
    return acc;
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
}, {});
const $4f1e5109a7f57422$export$6c24c440228eac9c = 'Changes';
const $4f1e5109a7f57422$export$5b65d27ec2d28d18 = 'Incidents';
const $4f1e5109a7f57422$var$PROBLEMS_JQL_NAME = 'Problems';
const $4f1e5109a7f57422$var$SERVICE_REQUEST_JQL_NAME = 'Service requests';
const $4f1e5109a7f57422$var$POST_INCIDENT_REVIEWS_JQL_NAME = 'Post-incident reviews';
const $4f1e5109a7f57422$export$3f757c5e00588ffd = 'Developer escalation';
const $4f1e5109a7f57422$export$b78213db77524b5b = {
    [$4f1e5109a7f57422$export$8598196f74460271]: $4f1e5109a7f57422$export$6c24c440228eac9c,
    [$4f1e5109a7f57422$export$a50b49a533b5f7bc]: $4f1e5109a7f57422$export$5b65d27ec2d28d18,
    [$4f1e5109a7f57422$export$ceba70db1edb1def]: $4f1e5109a7f57422$var$PROBLEMS_JQL_NAME,
    [$4f1e5109a7f57422$export$3d1cda9bd50505e8]: $4f1e5109a7f57422$var$SERVICE_REQUEST_JQL_NAME,
    [$4f1e5109a7f57422$export$6ebf7b6bf1c580f]: $4f1e5109a7f57422$var$POST_INCIDENT_REVIEWS_JQL_NAME,
    [$4f1e5109a7f57422$export$81e62964cc725098]: $4f1e5109a7f57422$export$3f757c5e00588ffd
};

});
parcelRegister("kF1zg", function(module, exports) {

$parcel$export(module.exports, "hasProp", () => $0d70700b8179d491$export$dd642ef726dcde21);
$parcel$export(module.exports, "getTypedKeys", () => $0d70700b8179d491$export$5206d47972fefe20);
/**
 * Use to remove `TS2339: Property 'id' does not exist on type 'object'` errors, e.g. when checking/refining variable of `unknown' type
 */ const $0d70700b8179d491$export$dd642ef726dcde21 = (data, prop)=>prop in data;
const $0d70700b8179d491$export$5206d47972fefe20 = (obj)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(obj);
};

});

parcelRegister("ZfaX7", function(module, exports) {

$parcel$export(module.exports, "default", () => $255bf593eeb7a55c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $255bf593eeb7a55c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    queues: {
        "id": "work-category.common.queues",
        "defaultMessage": "Queues"
    },
    serviceRequests: {
        "id": "work-category.common.service-requests",
        "defaultMessage": "Service requests"
    },
    incidents: {
        "id": "work-category.common.incidents",
        "defaultMessage": "Incidents"
    },
    changes: {
        "id": "work-category.common.changes",
        "defaultMessage": "Changes"
    },
    problems: {
        "id": "work-category.common.problems",
        "defaultMessage": "Problems"
    },
    postIncidentReviews: {
        "id": "work-category.common.post-incident-reviews",
        "defaultMessage": "Post-incident reviews"
    },
    noCategory: {
        "id": "work-category.common.no-category",
        "defaultMessage": "General"
    },
    queuesLower: {
        "id": "work-category.common.queues-lower",
        "defaultMessage": "queues"
    },
    serviceRequestsLower: {
        "id": "work-category.common.service-requests-lower",
        "defaultMessage": "service requests"
    },
    incidentsLower: {
        "id": "work-category.common.incidents-lower",
        "defaultMessage": "incidents"
    },
    changesLower: {
        "id": "work-category.common.changes-lower",
        "defaultMessage": "changes"
    },
    problemsLower: {
        "id": "work-category.common.problems-lower",
        "defaultMessage": "problems"
    },
    postIncidentReviewsLower: {
        "id": "work-category.common.post-incident-reviews-lower",
        "defaultMessage": "post-incident reviews"
    },
    noCategoryLower: {
        "id": "work-category.common.no-category-lower",
        "defaultMessage": "general"
    },
    developerEscalation: {
        "id": "work-category.common.developer-escalation",
        "defaultMessage": "Developer escalations"
    },
    developerEscalationLower: {
        "id": "work-category.common.developer-escalation-lower",
        "defaultMessage": "developer escalations"
    }
});

});


const $6d5c2d68fdd6fc0f$export$45919c8f50bb1db5 = 'SERVICEDESK_PRACTICES';

parcelRegister("bM6Yf", function(module, exports) {

let $892995a030236d79$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $892995a030236d79$var$load("fhvu2").then(()=>parcelRequire('4E57L'));

});


parcelRegister("h60sh", function(module, exports) {

$parcel$export(module.exports, "requiredProjectProperties", () => $2793aada3a9f7a33$export$fbeae45a65f4a5a6);
$parcel$export(module.exports, "requiredFrontendProperties", () => $2793aada3a9f7a33$export$47241956725e3029);
$parcel$export(module.exports, "firstProjectResource", () => $2793aada3a9f7a33$export$f620cebb7e8eeeae);

var $9Dhvc = parcelRequire("9Dhvc");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
const $2793aada3a9f7a33$var$getKey = ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
    (0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0];

const $2793aada3a9f7a33$var$getRequiredProjectPropertiesDataLoader = ()=>(parcelRequire("9Fg43"));
const $2793aada3a9f7a33$export$fbeae45a65f4a5a6 = (0, $l1VxS.createResource)({
    type: 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES',
    getKey: $2793aada3a9f7a33$var$getKey,
    getDataLoader: $2793aada3a9f7a33$var$getRequiredProjectPropertiesDataLoader,
    maxAge: 300000
});

const $2793aada3a9f7a33$var$getRequiredFrontendPropertiesDataLoader = ()=>(parcelRequire("4KLKp"));
const $2793aada3a9f7a33$var$ONE_DAY_IN_MILLIS = 86400000;
const $2793aada3a9f7a33$export$47241956725e3029 = (0, $l1VxS.createResource)({
    type: 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES',
    getKey: $2793aada3a9f7a33$var$getKey,
    getDataLoader: $2793aada3a9f7a33$var$getRequiredFrontendPropertiesDataLoader,
    maxAge: $2793aada3a9f7a33$var$ONE_DAY_IN_MILLIS
});

const $2793aada3a9f7a33$var$getFirstProjectDataLoader = ()=>(parcelRequire("jazJg"));
const $2793aada3a9f7a33$var$TWELVE_HOURS_IN_MILLIS = 43200000;
const $2793aada3a9f7a33$export$f620cebb7e8eeeae = (0, $l1VxS.createResource)({
    type: 'JSM_FIRST_PROJECT_RESOURCE',
    // first project is the same for the tenantId (there is also no per-project arg in request url). Therefore, only 1 key value is used.
    getKey: ()=>'none',
    getDataLoader: $2793aada3a9f7a33$var$getFirstProjectDataLoader,
    maxAge: $2793aada3a9f7a33$var$TWELVE_HOURS_IN_MILLIS
});

});
parcelRegister("9Fg43", function(module, exports) {

let $70946776f6f79e9b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $70946776f6f79e9b$var$load("i7E1D").then(()=>parcelRequire('aiZVu'));

});

parcelRegister("4KLKp", function(module, exports) {

let $37607efd880f081b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $37607efd880f081b$var$load("k99II").then(()=>parcelRequire('dcEuZ'));

});

parcelRegister("jazJg", function(module, exports) {

let $df4aaa8dbaa1d2da$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $df4aaa8dbaa1d2da$var$load("4djof").then(()=>parcelRequire('91ovr'));

});


parcelRegister("aGQ56", function(module, exports) {

$parcel$export(module.exports, "queuesNavigationItems", () => $afd2eec712bd1e40$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $afd2eec712bd1e40$export$1f9ab301771fe42e);
$parcel$export(module.exports, "priorityGroupByProjectIdResourceSsr", () => $afd2eec712bd1e40$export$b55fde45b61f13f4);
$parcel$export(module.exports, "priorityGroupCrossProjectResource", () => $afd2eec712bd1e40$export$ce17a222de842d7c);
$parcel$export(module.exports, "issueListSsrResource", () => $afd2eec712bd1e40$export$3d03cbaac8581e65);
$parcel$export(module.exports, "queueSidebarViewAllQueuesResource", () => $afd2eec712bd1e40$export$5b6f88b653545aa1);
$parcel$export(module.exports, "queueNav4SidebarSelectionResource", () => $afd2eec712bd1e40$export$dead630ba04fdfe4);
$parcel$export(module.exports, "queueSidebarQueuesCategoryStateResource", () => $afd2eec712bd1e40$export$9e9033d678058efa);

var $9Dhvc = parcelRequire("9Dhvc");

var $gYnSx = parcelRequire("gYnSx");


var $5j85B = parcelRequire("5j85B");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $FppkK = parcelRequire("FppkK");

var $l9f4K = parcelRequire("l9f4K");

var $dhGgY = parcelRequire("dhGgY");

const $afd2eec712bd1e40$var$getDataLoader = ()=>(parcelRequire("gyI2i"));

const $afd2eec712bd1e40$var$getPriorityGroupDataLoader = ()=>(parcelRequire("cXWnr"));

const $afd2eec712bd1e40$var$fetchIssueListDataLoader = ()=>(parcelRequire("kbFuW"));
const $afd2eec712bd1e40$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0]}-${(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.queueId', '')}`;
const $afd2eec712bd1e40$var$getResourceKeyFromProjectKey = ({ match: match, query: query })=>`${(0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0]}`;
const $afd2eec712bd1e40$export$4fed8be571897bef = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getDataLoader: $afd2eec712bd1e40$var$getDataLoader,
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});
const $afd2eec712bd1e40$export$1f9ab301771fe42e = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getDataLoader: $afd2eec712bd1e40$var$getPriorityGroupDataLoader,
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS),
    /**
	 * This resource will not load in SSR. Because priority group data resides in the JSM Kukama microservice.
	 * If we wanna fetch this resource during SSR, the request we're making from Tesseract -> Kukama is S2S, where Tesseract needs to know cookies information.
	 * We initially skipped SSR for fetching this resource, because we couldn’t retrieve the request cookie from JFE.
	 * Iiuc, the Jira team doesnt doesnt support this due to security concerns (the info is from JSM Queues team).
	 */ isBrowserOnly: true
});
const $afd2eec712bd1e40$var$priorityGroupCrossProjectResourcePayload = {
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const projectKey = (0, $bBtQo.getProjectKeyId)(match, query).projectKey;
        try {
            const projectId = match.params.projectId ? +match.params.projectId : undefined;
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'priorityGroupCrossProjectNoProjectId',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS),
    depends: []
};
const $afd2eec712bd1e40$var$priorityGroupByProjectIdResourcePayload = {
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query, dependencies: dependencies }, { tenantContext: { cloudId: cloudId } })=>{
        (0, $gYnSx.default)({
            meta: {
                id: 'priorityGroupByProjectIdStart',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
        if (!projectKey) (0, $gYnSx.default)({
            meta: {
                id: 'priorityGroupByProjectIdNoProjectKey',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        if (!cloudId) (0, $gYnSx.default)({
            meta: {
                id: 'priorityGroupByProjectIdNoCloudId',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        let data;
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            data = await (0, $5j85B.consumeDependency)(dependencies, (0, $c8eeacd6960f72dc$export$80a60a092d9ab81));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'priorityGroupByProjectIdProjectContextError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        if (!data) (0, $gYnSx.default)({
            meta: {
                id: 'priorityGroupByProjectIdNoProjectContextData',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        const projectId = data?.projectId;
        if (!projectId) (0, $gYnSx.default)({
            meta: {
                id: 'priorityGroupByProjectIdNoProjectContextProjectId',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        try {
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'priorityGroupByProjectIdGettingPriorityGroupsDataError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS),
    depends: [
        (0, $c8eeacd6960f72dc$export$80a60a092d9ab81)
    ]
};
const $afd2eec712bd1e40$export$b55fde45b61f13f4 = (0, $l1VxS.createResource)($afd2eec712bd1e40$var$priorityGroupByProjectIdResourcePayload);
const $afd2eec712bd1e40$export$ce17a222de842d7c = (0, $l1VxS.createResource)({
    ...$afd2eec712bd1e40$var$priorityGroupCrossProjectResourcePayload,
    isBrowserOnly: true
});
const $afd2eec712bd1e40$export$3d03cbaac8581e65 = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
    getKey: $afd2eec712bd1e40$var$getCombinedProjectKeyAndQueueId,
    getDataLoader: $afd2eec712bd1e40$var$fetchIssueListDataLoader,
    maxAge: 0,
    // run this resource from server only
    skipBrowser: true
});
const $afd2eec712bd1e40$export$5b6f88b653545aa1 = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        const projectKey = $afd2eec712bd1e40$var$getResourceKeyFromProjectKey({
            match: match,
            query: query
        });
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $FppkK.getUserProperty)(atlassianAccountId, `jsm-all-queues-state_is-open-${projectKey}`);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'fetchJsmQueueSidebarViewAllQueuesResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});
const $afd2eec712bd1e40$export$dead630ba04fdfe4 = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $FppkK.getUserProperty)(atlassianAccountId, (0, $l9f4K.LOCAL_STORAGE_KEY_NAV_LOCATION));
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'fetchQueueNav4SidebarSelectionResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});
const $afd2eec712bd1e40$export$9e9033d678058efa = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $FppkK.getUserProperty)(atlassianAccountId, (0, $l9f4K.LOCAL_STORAGE_KEY_CATEGORY));
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'fetchJsmQueueSidebarQueuesCategoryStateResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("5j85B", function(module, exports) {

$parcel$export(module.exports, "consumeDependency", () => $9d19e695d8895e78$export$a973ef9e17a326f);
async function $9d19e695d8895e78$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    return dependencies[key]?.data;
}

});

parcelRegister("l9f4K", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $3365e8184adaa319$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $3365e8184adaa319$export$2064262c540606ba);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", () => $3365e8184adaa319$export$2733615da5b906f0);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE", () => $3365e8184adaa319$export$f510a6e9fec0630a);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES", () => $3365e8184adaa319$export$94bda82b7db2173c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION", () => $3365e8184adaa319$export$7e07da72de89b61c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY", () => $3365e8184adaa319$export$5b3a0c7c3b3456f);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_NAV_LOCATION", () => $3365e8184adaa319$export$3c59a089fdd2614a);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_CATEGORY", () => $3365e8184adaa319$export$9b99689db482a6bb);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $3365e8184adaa319$export$5a00268156ea5027);
const $3365e8184adaa319$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $3365e8184adaa319$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $3365e8184adaa319$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
const $3365e8184adaa319$export$f510a6e9fec0630a = 'SERVICEDESK_NAV3_QUEUE_GROUPS_STATE';
const $3365e8184adaa319$export$94bda82b7db2173c = 'SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES';
const $3365e8184adaa319$export$7e07da72de89b61c = 'SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION';
const $3365e8184adaa319$export$5b3a0c7c3b3456f = 'SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY';
const $3365e8184adaa319$export$3c59a089fdd2614a = 'queue-groups-nav-state';
const $3365e8184adaa319$export$9b99689db482a6bb = 'queues-category-state';
const $3365e8184adaa319$export$5a00268156ea5027 = 86400000;

});

parcelRegister("dhGgY", function(module, exports) {

$parcel$export(module.exports, "getPriorityGroupDataByProjectId", () => $3c68df8ab7c5fa41$export$cf2bd2ec601ed920);

var $llUmI = parcelRequire("llUmI");

var $6Abnv = parcelRequire("6Abnv");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");
const $3c68df8ab7c5fa41$var$fetchGroupsByKey = async (projectKey, cloudId)=>{
    return (0, $1Ozm9.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}&operation=fetchPriorityGroups`);
};
const $3c68df8ab7c5fa41$var$fetchGroupsByIdGraphql = async (projectId, cloudId)=>{
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    const result = await (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), (0, $llUmI.default), {
        projectAri: projectAri
    }).toPromise();
    if (!result?.queuesprioritygroups_priorityGroups?.results) (0, $gYnSx.default)({
        meta: {
            id: 'priorityGroupByProjectIdNoPriorityGroupsGraphql',
            packageName: 'jiraRouterResourcesServiceDeskQueues',
            teamName: 'jsm-flash'
        },
        sendToPrivacyUnsafeSplunk: true
    });
    return {
        results: result?.queuesprioritygroups_priorityGroups?.results?.reduce((priorityGroups, priorityGroup)=>{
            // this mapping function is to make types happy
            if (priorityGroup && priorityGroup.id && priorityGroup.name && priorityGroup.category && priorityGroup.queueIds) priorityGroups.push({
                id: priorityGroup.id,
                name: priorityGroup.name,
                category: priorityGroup.category,
                queueIds: priorityGroup.queueIds.reduce((queueIds, queueId)=>{
                    if (queueId !== null && queueId !== undefined) queueIds.push(queueId);
                    return queueIds;
                // we need the below, otherwise reduce things the type is never[]
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                }, []),
                ...priorityGroup.version ? {
                    version: priorityGroup.version
                } : {},
                ...priorityGroup.creationMethod ? {
                    creationMethod: priorityGroup.creationMethod
                } : {}
            });
            return priorityGroups;
        }, // we need the below, otherwise reduce things the type is never[]
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        []) ?? []
    };
};
const $3c68df8ab7c5fa41$export$cf2bd2ec601ed920 = async (projectId, projectKey, cloudId)=>{
    let data;
    if (projectId) data = await $3c68df8ab7c5fa41$var$fetchGroupsByIdGraphql(projectId, cloudId);
    else {
        (0, $gYnSx.default)({
            meta: {
                id: 'fetchPriorityGroupsProjectIdUndefined',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        data = await $3c68df8ab7c5fa41$var$fetchGroupsByKey(projectKey, cloudId);
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const processedData = (0, (/*@__PURE__*/$parcel$interopDefault($6Abnv)))(data.results.map((group)=>({
            ...group,
            queues: group.queueIds || []
        })), 'category');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return processedData;
};

});
parcelRegister("llUmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $49a175edfdfe7540$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<509a54dc797b22dc5439dcc947ec5646>>
 * @relayHash aa856b961b835b1f9323042c281fa03b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530
const $49a175edfdfe7540$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectId",
                    "variableName": "projectAri"
                }
            ],
            "concreteType": "QueuesPriorityGroupsResults",
            "kind": "LinkedField",
            "name": "queuesprioritygroups_priorityGroups",
            "plural": false,
            "selections": [
                {
                    "concreteType": "QueuesPriorityGroupsResultsGroup",
                    "kind": "LinkedField",
                    "name": "results",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "queueIds"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "version"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "creationMethod"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getPriorityGroupDataByProjectIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getPriorityGroupDataByProjectIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530",
            "metadata": {},
            "name": "getPriorityGroupDataByProjectIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$49a175edfdfe7540$var$node.hash = "e99dcef5a507344c549819dcfbf09d31";
var $49a175edfdfe7540$export$2e2bcd8739ae039 = $49a175edfdfe7540$var$node;

});

parcelRegister("6Abnv", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $a9KaZ = parcelRequire("a9KaZ");
/** Used for built-in method references. */ var $4caeee4f6c048b0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4caeee4f6c048b0e$var$hasOwnProperty = $4caeee4f6c048b0e$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $4caeee4f6c048b0e$var$groupBy = $a9KaZ(function(result, value, key) {
    if ($4caeee4f6c048b0e$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $iBJlb(result, key, [
        value
    ]);
});
module.exports = $4caeee4f6c048b0e$var$groupBy;

});


parcelRegister("gyI2i", function(module, exports) {

let $c0e1faefb3facfb8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $c0e1faefb3facfb8$var$load("hwlgY"),
    $c0e1faefb3facfb8$var$load("lTahQ")
]).then(()=>parcelRequire('fIAjW'));

});

parcelRegister("cXWnr", function(module, exports) {

let $9708472d81f0ce88$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9708472d81f0ce88$var$load("j8AmU").then(()=>parcelRequire('9Uve2'));

});

parcelRegister("kbFuW", function(module, exports) {

let $eb250665c381c35a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $eb250665c381c35a$var$load("jANzo").then(()=>parcelRequire('22Hs1'));

});


parcelRegister("aEWXS", function(module, exports) {

$parcel$export(module.exports, "nav3QueueGroupsStateResource", () => $474104609766e589$export$53d0e5294221581);

var $9Dhvc = parcelRequire("9Dhvc");

var $l1VxS = parcelRequire("l1VxS");

var $gYnSx = parcelRequire("gYnSx");

var $bBtQo = parcelRequire("bBtQo");

var $l9f4K = parcelRequire("l9f4K");

var $7KiwK = parcelRequire("7KiwK");
const $474104609766e589$var$getProjectKey = ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
    (0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0];
const $474104609766e589$export$53d0e5294221581 = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE),
    getKey: $474104609766e589$var$getProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        if (!atlassianAccountId) return undefined;
        const projectKey = $474104609766e589$var$getProjectKey({
            match: match,
            query: query
        });
        try {
            return await (0, $7KiwK.getQueueGroupsStateFromUserProperty)(projectKey, atlassianAccountId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'getQueueGroupsStateInUserPropertyResourceError'
                }
            });
            return undefined;
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("7KiwK", function(module, exports) {

$parcel$export(module.exports, "setQueueGroupsStateInUserProperty", () => $7032001ee4a89aff$export$e316bbc9b5e5100d);
$parcel$export(module.exports, "getQueueGroupsStateFromUserProperty", () => $7032001ee4a89aff$export$87bc602eb5671315);

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");
const $7032001ee4a89aff$export$bb10a02fc2feb574 = 'jsm-queue-groups-state-selected-group-id';
const $7032001ee4a89aff$export$e316bbc9b5e5100d = async (projectKey, value, accountId)=>{
    try {
        (0, $FppkK.setUserProperties)(accountId, `${$7032001ee4a89aff$export$bb10a02fc2feb574}_${projectKey}`, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'setQueueGroupsStateInUserPropertyError'
            }
        });
        throw error;
    }
};
const $7032001ee4a89aff$export$87bc602eb5671315 = async (projectKey, accountId)=>{
    try {
        return await (0, $FppkK.getUserProperty)(accountId, `${$7032001ee4a89aff$export$bb10a02fc2feb574}_${projectKey}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'getQueueGroupsStateFromUserPropertyError'
            }
        });
        throw error;
    }
};

});


parcelRegister("arxGJ", function(module, exports) {

$parcel$export(module.exports, "virtualAgentOnboardingResource", () => $43d426eb1ac4453c$export$d39827c053fda3aa);

var $7jTnu = parcelRequire("7jTnu");

var $9FYIg = parcelRequire("9FYIg");

var $kYSzP = parcelRequire("kYSzP");
const $43d426eb1ac4453c$export$d39827c053fda3aa = (0, $9FYIg.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $kYSzP.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $7jTnu.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});
parcelRegister("kYSzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f69717998c70f94$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8391836c727c96074b367b5cee339a0d>>
 * @relayHash a752dde009c93b4975b47e740db8b1bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf

var $bXR9c = parcelRequire("bXR9c");
const $4f69717998c70f94$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf",
        "metadata": {},
        "name": "mainVirtualAgentSidebarQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $4f69717998c70f94$export$2e2bcd8739ae039 = $4f69717998c70f94$var$node;

});
parcelRegister("bXR9c", function(module, exports) {

$parcel$export(module.exports, "default", () => $34b15431a198dc56$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $34b15431a198dc56$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('require_ai_enabled_for_jsm_virtual_agent');
    }
};

});



parcelRegister("g9kBK", function(module, exports) {

$parcel$export(module.exports, "featuresResource", () => $64d699e1b049a1a4$export$16f81cc9da2c6c47);

var $9Dhvc = parcelRequire("9Dhvc");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");


const $64d699e1b049a1a4$var$getDataLoader = ()=>Promise.resolve((parcelRequire("dYpVn")));
const $64d699e1b049a1a4$var$ONE_DAY_IN_MILLIS = 86400000;
const $64d699e1b049a1a4$export$16f81cc9da2c6c47 = (0, $l1VxS.createResource)({
    type: (0, $48cfe47ee1d47a2f$export$3441b129810f29ed),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $64d699e1b049a1a4$var$getDataLoader,
    maxAge: $64d699e1b049a1a4$var$ONE_DAY_IN_MILLIS
});

});
const $48cfe47ee1d47a2f$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';


parcelRegister("bTfc4", function(module, exports) {

$parcel$export(module.exports, "incidentsInitialPageChecksResource", () => $36ca214696dd8d52$export$b2b94ce8ba590cc8);
$parcel$export(module.exports, "incidentsCustomFieldIdResource", () => $36ca214696dd8d52$export$e81d7afef87ae597);
$parcel$export(module.exports, "incidentExperimentTraitResource", () => $36ca214696dd8d52$export$31c6945718067be3);
$parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3Only", () => $36ca214696dd8d52$export$6fc19cf1d90e9453);
$parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes", () => $36ca214696dd8d52$export$2e6b9e6402ff1d9b);

var $7jTnu = parcelRequire("7jTnu");

var $6zXPf = parcelRequire("6zXPf");

var $5L7qx = parcelRequire("5L7qx");

var $l1VxS = parcelRequire("l1VxS");


const $36ca214696dd8d52$export$b2b94ce8ba590cc8 = (0, $l1VxS.createResource)({
    type: (0, $225391858474824e$export$9018fdf9116edd9b),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("604pg"))
});

const $36ca214696dd8d52$export$e81d7afef87ae597 = (0, $l1VxS.createResource)({
    type: (0, $225391858474824e$export$508a7d8e5c6b1bf),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("h1J8j"))
});

const $36ca214696dd8d52$export$31c6945718067be3 = (0, $l1VxS.createResource)({
    type: (0, $225391858474824e$export$1d954e05e596a51e),
    getKey: ()=>'incident_experiment_traits',
    getDataLoader: ()=>(parcelRequire("5cPrQ")),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $36ca214696dd8d52$export$6fc19cf1d90e9453 = (0, $5L7qx.resourceWithCondition2)(()=>!((0, $6zXPf.getWillShowNav4)() && ((0, $7jTnu.fg)('perf-push-big-components-remove-incidents-resource') || (0, $7jTnu.fg)('perf-push-big-components-nav-remove-resources'))), $36ca214696dd8d52$export$31c6945718067be3);
const $36ca214696dd8d52$export$2e6b9e6402ff1d9b = (0, $5L7qx.resourceWithCondition2)(()=>!(0, $6zXPf.getWillShowNav4)(), $36ca214696dd8d52$export$31c6945718067be3);

});
const $225391858474824e$export$9018fdf9116edd9b = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $225391858474824e$export$508a7d8e5c6b1bf = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $225391858474824e$export$1d954e05e596a51e = 'INCIDENT_EXPERIMENT_TRAITS';

parcelRegister("604pg", function(module, exports) {

let $45e62936d6b523a6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $45e62936d6b523a6$var$load("fBKCx").then(()=>parcelRequire('fsQkp'));

});

parcelRegister("h1J8j", function(module, exports) {

let $c6558a203465df5c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c6558a203465df5c$var$load("1pYRz").then(()=>parcelRequire('5DyWZ'));

});

parcelRegister("5cPrQ", function(module, exports) {

let $3ca5fb47cdea5125$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3ca5fb47cdea5125$var$load("1YGRs").then(()=>parcelRequire('cbo1b'));

});


parcelRegister("ePaI2", function(module, exports) {

$parcel$export(module.exports, "workspaceResource", () => $e09848882139baa5$export$2f02c3f971168d17);

var $l1VxS = parcelRequire("l1VxS");

var $jopyG = parcelRequire("jopyG");
const $e09848882139baa5$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $e09848882139baa5$export$2f02c3f971168d17 = (0, $l1VxS.createResource)({
    type: $e09848882139baa5$export$9b3a4d71d46e5ee7,
    getKey: ()=>'state',
    getData: async (_, routerContext)=>{
        const workspaceId = await (0, $jopyG.default)(_, routerContext);
        return workspaceId;
    },
    maxAge: Infinity
});

});
parcelRegister("jopyG", function(module, exports) {

$parcel$export(module.exports, "getUserJsmLicenceState", () => $f9ae8515d7b2e372$export$65bf73aad2afa39);
$parcel$export(module.exports, "isPremiumInstance", () => $f9ae8515d7b2e372$export$abb609d3bcbb74f6);
$parcel$export(module.exports, "isLicensedPremiumUser", () => $f9ae8515d7b2e372$export$d7b4c32773b1c643);
$parcel$export(module.exports, "default", () => $f9ae8515d7b2e372$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $u4YbY = parcelRequire("u4YbY");

var $7cSYk = parcelRequire("7cSYk");

var $4ZeQj = parcelRequire("4ZeQj");

var $a9ldn = parcelRequire("a9ldn");

const $f9ae8515d7b2e372$export$530f260cc76f04ff = ()=>'/rest/servicedesk/cmdb/latest/workspace';
const $f9ae8515d7b2e372$export$65bf73aad2afa39 = (tenantContext)=>{
    const { licensedProducts: licensedProducts, appPermissions: appPermissions } = tenantContext;
    const hasJsmLicence = licensedProducts && licensedProducts[0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61];
    const isJsmLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    if (!hasJsmLicence) return {
        siteHasJsmInstalled: false
    };
    return {
        siteHasJsmInstalled: true,
        siteIsPremium: $f9ae8515d7b2e372$export$abb609d3bcbb74f6(tenantContext),
        userLicensed: isJsmLicensedUser
    };
};
const $f9ae8515d7b2e372$export$abb609d3bcbb74f6 = (tenantContext)=>{
    const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
    const isPremium = serviceDeskAppEdition === (0, $a9ldn.PREMIUM_EDITION);
    return isPremium;
};
const $f9ae8515d7b2e372$export$d7b4c32773b1c643 = (tenantContext)=>{
    const { appPermissions: appPermissions } = tenantContext;
    const isPremium = $f9ae8515d7b2e372$export$abb609d3bcbb74f6(tenantContext);
    const isLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    return isPremium && isLicensedUser;
};
const $f9ae8515d7b2e372$var$transformResponse = (response)=>{
    const ids = response.results ?? [];
    return ids.length ? (0, $4ZeQj.toWorkspaceId)(ids[0].id) : null;
};
const $f9ae8515d7b2e372$export$e1d718dfe6dad973 = (routerContext, { tenantContext: tenantContext })=>{
    if ($f9ae8515d7b2e372$export$d7b4c32773b1c643(tenantContext) === false || !(0, $7cSYk.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP)) return null;
    return (0, $u4YbY.performCmdbGetRequest)($f9ae8515d7b2e372$export$530f260cc76f04ff()).then($f9ae8515d7b2e372$var$transformResponse).catch((error)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('spa.view.routes.servicedesk.workspace-id', 'Error while fetching servicedesk Insight workspace id', error);
        return null;
    });
};
var $f9ae8515d7b2e372$export$2e2bcd8739ae039 = $f9ae8515d7b2e372$export$e1d718dfe6dad973;

});
parcelRegister("u4YbY", function(module, exports) {

$parcel$export(module.exports, "performCmdbGetRequest", () => $97885f5e767a49bb$export$a252413f43ec7247);
$parcel$export(module.exports, "performCmdbPostRequest", () => $97885f5e767a49bb$export$d68a9f67166d25a2);
$parcel$export(module.exports, "performCmdbPutRequest", () => $97885f5e767a49bb$export$326b7407f501f98b);
$parcel$export(module.exports, "performCmdbDeleteRequest", () => $97885f5e767a49bb$export$b198eb14f22c12e6);

var $7jTnu = parcelRequire("7jTnu");

var $1oMOM = parcelRequire("1oMOM");

var $jGzN3 = parcelRequire("jGzN3");
const $97885f5e767a49bb$export$d5e211a0106aa636 = {
    'X-Request-Source': 'cmdb-frontend'
};
const $97885f5e767a49bb$export$a252413f43ec7247 = (url, options)=>(0, $jGzN3.performGetRequest)(url, $97885f5e767a49bb$export$235b7fc70b9fc359(url, options));
const $97885f5e767a49bb$export$d68a9f67166d25a2 = (url, options)=>(0, $jGzN3.performPostRequest)(url, $97885f5e767a49bb$export$235b7fc70b9fc359(url, options));
const $97885f5e767a49bb$export$326b7407f501f98b = (url, options)=>(0, $jGzN3.performPutRequest)(url, $97885f5e767a49bb$export$235b7fc70b9fc359(url, options));
const $97885f5e767a49bb$export$b198eb14f22c12e6 = (url, options)=>(0, $jGzN3.performDeleteRequest)(url, $97885f5e767a49bb$export$235b7fc70b9fc359(url, options));
const $97885f5e767a49bb$export$235b7fc70b9fc359 = (url, options)=>{
    const defaultOptions = (0, $1oMOM.getDefaultOptions)(url);
    return (0, $7jTnu.fg)('fly-2529-cmdb-client-send-request-source-header') ? {
        ...defaultOptions,
        ...options,
        headers: {
            ...defaultOptions.headers,
            ...options?.headers,
            ...$97885f5e767a49bb$export$d5e211a0106aa636
        }
    } : options;
};

});

parcelRegister("7cSYk", function(module, exports) {

$parcel$export(module.exports, "isCMDBEnabledInEnvironment", () => $d8faa2e2692e1ff5$export$6dbfb62369f79a64);

var $igNUx = parcelRequire("igNUx");

var $7jTnu = parcelRequire("7jTnu");
const $d8faa2e2692e1ff5$export$6dbfb62369f79a64 = (cmdbDisabledInFedRAMPForTenant)=>!(0, $igNUx.isFedRamp)() || (0, $igNUx.isFedRamp)() && ((0, $7jTnu.fg)('use_cmdb_scr12_enabled') ? cmdbDisabledInFedRAMPForTenant != null && !cmdbDisabledInFedRAMPForTenant : (0, $7jTnu.fg)('jsm-assets-fedramp-ui'));

});

parcelRegister("4ZeQj", function(module, exports) {

$parcel$export(module.exports, "toSchemaId", () => $a31a1cf0aae81680$export$d577b7f3b832f656);
$parcel$export(module.exports, "toCmdbObjectId", () => $a31a1cf0aae81680$export$1ba342595bc7be13);
$parcel$export(module.exports, "toCmdbObjectTypeId", () => $a31a1cf0aae81680$export$b46e25afa2bab6a);
$parcel$export(module.exports, "toObjectCommentId", () => $a31a1cf0aae81680$export$ece2917434bb0a8c);
$parcel$export(module.exports, "toWorkspaceId", () => $a31a1cf0aae81680$export$d002b8d7821b6b59);
$parcel$export(module.exports, "toObjectTypeAttributeId", () => $a31a1cf0aae81680$export$cfd92c18cee8add7);
const $a31a1cf0aae81680$export$d577b7f3b832f656 = (id)=>id;
const $a31a1cf0aae81680$export$1ba342595bc7be13 = (id)=>id;
const $a31a1cf0aae81680$export$b46e25afa2bab6a = (id)=>id;
const $a31a1cf0aae81680$export$ece2917434bb0a8c = (id)=>id;
const $a31a1cf0aae81680$export$d002b8d7821b6b59 = (id)=>id;
const $a31a1cf0aae81680$export$cfd92c18cee8add7 = (id)=>id;

});

const $e08dff4ae358d899$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $e08dff4ae358d899$export$e9c56aa3b027d98f = 'jira-customer-service';
const $e08dff4ae358d899$export$1346c9aa3cbb477d = 'jira-software';
const $e08dff4ae358d899$export$202f50ee62667e32 = 'jira-product-discovery';
const $e08dff4ae358d899$export$db515c8cec1e6f79 = 'jira-core';
const $e08dff4ae358d899$export$c811f21c9ad05dc2 = 'confluence';
const $e08dff4ae358d899$export$961148c98d198270 = 'opsgenie';



parcelRegister("27Owl", function(module, exports) {

$parcel$export(module.exports, "boardDetailsResource", () => $649dd820db29afaa$export$6c6984c55b171c5d);
$parcel$export(module.exports, "getBoardDetailsResource", () => $649dd820db29afaa$export$b67eabcfc08e7c62);

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");

var $l1VxS = parcelRequire("l1VxS");

var $blWcH = parcelRequire("blWcH");
const $649dd820db29afaa$export$90ce361a5838e31e = async (boardId)=>{
    try {
        return await (0, $1Ozm9.default)(`/rest/agile/1.0/board/${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'getBoardDetailsRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $649dd820db29afaa$export$6c6984c55b171c5d = (0, $l1VxS.createResource)({
    type: 'CLASSIC_BOARD_SETTING_BOARD_DETAILS',
    getKey: (routerContext)=>(0, $blWcH.getConfigFromRouterContext)(routerContext) ? 'cmp-board-settings' : 'not-cmp-board-setting',
    getData: async (routerContext)=>{
        const boardId = routerContext.match.params?.boardId ?? '';
        if ((0, $blWcH.getConfigFromRouterContext)(routerContext)) return $649dd820db29afaa$export$90ce361a5838e31e(boardId);
        return null;
    }
});
const $649dd820db29afaa$export$b67eabcfc08e7c62 = ()=>$649dd820db29afaa$export$6c6984c55b171c5d;

});
parcelRegister("blWcH", function(module, exports) {

$parcel$export(module.exports, "buildAllDataQueryParams", () => $6a4cf61bbd4e46b4$export$487708debaea6de3);
$parcel$export(module.exports, "getInlineScriptData", () => $6a4cf61bbd4e46b4$export$7bd4b867b9305f97);
$parcel$export(module.exports, "getRapidViewConfigFromRouteName", () => $6a4cf61bbd4e46b4$export$62c86c4062215346);
$parcel$export(module.exports, "getRequiredResourceList", () => $6a4cf61bbd4e46b4$export$7bff98a3d459b1b8);
$parcel$export(module.exports, "getConfigFromRouterContext", () => $6a4cf61bbd4e46b4$export$1705c550e5b835bf);

var $7jTnu = parcelRequire("7jTnu");

var $6XhAO = parcelRequire("6XhAO");

var $q8NP8 = parcelRequire("q8NP8");
const $6a4cf61bbd4e46b4$export$487708debaea6de3 = (query, match)=>{
    const { rapidView: rapidView, quickFilter: quickFilter, projectKey: queryProjectKey, etag: etag } = query;
    const boardId = match.params.boardId || rapidView;
    const projectKey = match.params.projectKey || queryProjectKey;
    let activeQuickFilters = '';
    if (quickFilter) activeQuickFilters = Array.isArray(quickFilter) ? quickFilter.reduce((prevFilter, nextFilter)=>`${prevFilter}&activeQuickFilters=${nextFilter}`, activeQuickFilters) : `&activeQuickFilters=${quickFilter}`;
    const etagParam = etag ? `&etag=${etag}` : '';
    const projectKeyParam = projectKey ? `&selectedProjectKey=${projectKey}` : '';
    const { GH: GH } = window;
    const forceConsistency = '&forceConsistency=true';
    GH?.RapidBoard?.State?.setRapidViewIdForEventuallyConsistentBoard(undefined);
    return `rapidViewId=${boardId}${projectKeyParam}${activeQuickFilters}${etagParam}${forceConsistency}`;
};
const $6a4cf61bbd4e46b4$var$cleanUpInlineScript = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window[dataName];
};
const $6a4cf61bbd4e46b4$export$7bd4b867b9305f97 = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const req = window[dataName];
    if (!req) return null;
    if (req.readyState === req.DONE && req.status !== 200) {
        $6a4cf61bbd4e46b4$var$cleanUpInlineScript(dataName);
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise((r)=>{
        if (req.readyState === req.DONE && req.status === 200) {
            $6a4cf61bbd4e46b4$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        } else req.addEventListener('load', ()=>{
            $6a4cf61bbd4e46b4$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        });
    });
};
const $6a4cf61bbd4e46b4$export$62c86c4062215346 = (routeName)=>{
    for (const routeConfig of Object.values((0, $q8NP8.RAPID_VIEW_ROUTE_CONFIG))){
        if (routeConfig.routes?.includes(routeName)) return routeConfig;
    }
    return (0, $q8NP8.RAPID_VIEW_ROUTE_CONFIG).DEFAULT;
};
const $6a4cf61bbd4e46b4$export$7bff98a3d459b1b8 = (view)=>{
    let rapidboardResources = (0, $6XhAO.WRM_RESOURCES_ARRAY);
    if ((0, $7jTnu.fg)('reports-overview-page-migration')) {
        if (view) {
            const routeConfig = $6a4cf61bbd4e46b4$export$62c86c4062215346(view);
            return [
                ...(0, $6XhAO.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
                ...routeConfig.resources
            ];
        }
        return [
            ...(0, $6XhAO.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
            ...(0, $q8NP8.RAPID_VIEW_ROUTE_CONFIG).DEFAULT.resources
        ];
    }
    // eslint-disable-next-line default-case
    switch(view){
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-user-board':
        case 'servicedesk-boards':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-practice-custom-board':
            rapidboardResources = (0, $6XhAO.WRM_BOARD_RESOURCES_FHD_ARRAY);
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-user-backlog':
        case 'rapidboard-backlog-embed':
            rapidboardResources = (0, $6XhAO.WRM_BACKLOG_RESOURCES_FHD_ARRAY);
            break;
    }
    return [
        ...(0, $6XhAO.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
        ...rapidboardResources
    ];
};
function $6a4cf61bbd4e46b4$export$1705c550e5b835bf(routerContext) {
    return routerContext.match?.params.config || routerContext.query?.config || '';
}

});
parcelRegister("6XhAO", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG", () => $a8c4ab1630e67bda$export$88e2a0b89be042c1);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA", () => $a8c4ab1630e67bda$export$ba075d0985968d1c);
$parcel$export(module.exports, "RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS", () => $a8c4ab1630e67bda$export$395f77888d07f2e0);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_RESOURCE", () => $a8c4ab1630e67bda$export$4f7c4e3508fd2a07);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE", () => $a8c4ab1630e67bda$export$3328c8e71fda97bb);
$parcel$export(module.exports, "WRM_RESOURCES_ARRAY", () => $a8c4ab1630e67bda$export$ef21257df3d71188);
$parcel$export(module.exports, "WRM_HERITAGE_RESOURCES_FHD_ARRAY", () => $a8c4ab1630e67bda$export$ccd0929652c235de);
$parcel$export(module.exports, "WRM_BOARD_RESOURCES_FHD_ARRAY", () => $a8c4ab1630e67bda$export$1d16bdcc94a40107);
$parcel$export(module.exports, "WRM_BACKLOG_RESOURCES_FHD_ARRAY", () => $a8c4ab1630e67bda$export$1f599d2eef0a7281);
const $a8c4ab1630e67bda$export$88e2a0b89be042c1 = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
const $a8c4ab1630e67bda$export$ba075d0985968d1c = 'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
const $a8c4ab1630e67bda$export$395f77888d07f2e0 = 'PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS';
const $a8c4ab1630e67bda$export$4f7c4e3508fd2a07 = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';
const $a8c4ab1630e67bda$export$3328c8e71fda97bb = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';
const $a8c4ab1630e67bda$export$ef21257df3d71188 = [
    '_super',
    'wrc!greenhopper-rapid-non-gadget',
    'wrc!gh-rapid',
    'wrc!jira.global',
    'wrc!jira.general',
    'wrc!atl.global',
    // Required to prevent an error on initial loading of reports
    'wrc!jira.webresources:header',
    // Required for Control Chart report page
    'wrc!jira.webresources:calendar',
    'wrc!jira.webresources:calendar-en',
    'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
    // Required for explicit usage of jQuery
    'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
    // Required for the styles of the toggle button when transitioning from reports to board settings
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
    // Required for the profile card in board settings, that doesn't really render because it has wrong
    // parameters and it has been broken for ages, but at least prevents noisy errors
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
    'wrc!gh-rapid-config',
    'wrc!gh-rapid-analytics',
    'wrc!gh-rapid-charts',
    'wrc!jira.webresources:mentions-feature',
    'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx'
];
const $a8c4ab1630e67bda$export$ccd0929652c235de = [];
const $a8c4ab1630e67bda$export$1d16bdcc94a40107 = [
    'wrc!gh-rapid-lwf-board-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];
const $a8c4ab1630e67bda$export$1f599d2eef0a7281 = [
    'wrc!gh-rapid-backlog-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:header',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];

});

parcelRegister("q8NP8", function(module, exports) {

$parcel$export(module.exports, "RAPID_VIEW_ROUTE_CONFIG", () => $388fe636b9cb51cc$export$99d0df2f58f37dfe);

var $6XhAO = parcelRequire("6XhAO");
const $388fe636b9cb51cc$export$99d0df2f58f37dfe = {
    BOARD: {
        routes: [
            'rapidboard-board',
            'rapidboard-board-embed',
            'rapidboard-user-board',
            'servicedesk-boards',
            'servicedesk-queues-custom-board',
            'servicedesk-queues-practice-custom-board'
        ],
        resources: (0, $6XhAO.WRM_BOARD_RESOURCES_FHD_ARRAY),
        stateKey: 'board-state'
    },
    BACKLOG: {
        routes: [
            'rapidboard-backlog',
            'rapidboard-user-backlog',
            'rapidboard-backlog-embed'
        ],
        resources: (0, $6XhAO.WRM_BACKLOG_RESOURCES_FHD_ARRAY),
        stateKey: 'backlog-state'
    },
    DEFAULT: {
        resources: (0, $6XhAO.WRM_RESOURCES_ARRAY),
        stateKey: 'report-state'
    }
};

});



parcelRegister("alzbz", function(module, exports) {

$parcel$export(module.exports, "shouldLoadUIFBoardResources", () => $d3a00a694785eff5$export$d8d4641986a9ac7f);
$parcel$export(module.exports, "getRapidboardResources", () => $d3a00a694785eff5$export$3a5e56bd5231a56b);
$parcel$export(module.exports, "getRapidBoardDataResource", () => $d3a00a694785eff5$export$1c63de7f548f965f);
$parcel$export(module.exports, "getUIFBacklogDataResource", () => $d3a00a694785eff5$export$ee826506b3baa13a);

var $7jTnu = parcelRequire("7jTnu");

var $4kRUy = parcelRequire("4kRUy");

var $5L7qx = parcelRequire("5L7qx");

var $kmK2e = parcelRequire("kmK2e");

var $451Ow = parcelRequire("451Ow");

var $4pqJW = parcelRequire("4pqJW");
const $d3a00a694785eff5$export$d8d4641986a9ac7f = ()=>!false || (0, $7jTnu.fg)('enable_ssr_for_cmp_backlog');
const $d3a00a694785eff5$export$462ca08d6ce67848 = ()=>!$d3a00a694785eff5$export$d8d4641986a9ac7f();
const $d3a00a694785eff5$export$3a5e56bd5231a56b = ()=>[
        (0, $4pqJW.wrmBundleResource),
        (0, $5L7qx.resourceWithCondition2)($d3a00a694785eff5$export$462ca08d6ce67848, (0, $451Ow.rapidboardResource))
    ];
const $d3a00a694785eff5$export$1c63de7f548f965f = ()=>(0, $kmK2e.boardDataResource);
const $d3a00a694785eff5$export$ee826506b3baa13a = ()=>[
        (0, $5L7qx.resourceWithCondition2)(()=>$d3a00a694785eff5$export$d8d4641986a9ac7f() && !(0, $7jTnu.fg)('indexeddb_cache_for_backlog'), (0, $4kRUy.uifBacklogResourceOld)),
        (0, $5L7qx.resourceWithCondition2)(()=>$d3a00a694785eff5$export$d8d4641986a9ac7f() && (0, $7jTnu.fg)('indexeddb_cache_for_backlog'), (0, $4kRUy.uifBacklogResource))
    ];

});
parcelRegister("4kRUy", function(module, exports) {

$parcel$export(module.exports, "uifBacklogResourceOld", () => $c3662b34dad9676c$export$db83ef0443397b85);
$parcel$export(module.exports, "uifBacklogResource", () => $c3662b34dad9676c$export$c182dffb98985208);

var $l1VxS = parcelRequire("l1VxS");


const $c3662b34dad9676c$export$db83ef0443397b85 = (0, $l1VxS.createResource)({
    type: (0, $63ba8ce42e431ec8$export$8f9824ba4409b537),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("aS9dn")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

const $c3662b34dad9676c$export$c182dffb98985208 = (0, $l1VxS.createResource)({
    type: (0, $63ba8ce42e431ec8$export$d15ce4feabd76ea),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("3X4vn")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

});
const $63ba8ce42e431ec8$export$d15ce4feabd76ea = 'NEXTGEN_BACKLOG_REST';
const $63ba8ce42e431ec8$export$8f9824ba4409b537 = 'NEXTGEN_BACKLOG_REST_OLD';

parcelRegister("aS9dn", function(module, exports) {

let $7ea61865cbbaaa55$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7ea61865cbbaaa55$var$load("2WUdK").then(()=>parcelRequire('1WnIl'));

});

parcelRegister("3X4vn", function(module, exports) {

let $2e0a6065d734cd4c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2e0a6065d734cd4c$var$load("87rUb").then(()=>parcelRequire('cvbpu'));

});


parcelRegister("kmK2e", function(module, exports) {

$parcel$export(module.exports, "boardDataResource", () => $7ee5fa79b31b97ea$export$138fa635416978f7);

var $l1VxS = parcelRequire("l1VxS");

var $6XhAO = parcelRequire("6XhAO");

var $8QGVd = parcelRequire("8QGVd");

const $7ee5fa79b31b97ea$export$138fa635416978f7 = (0, $l1VxS.createResource)({
    type: (0, $6XhAO.RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
    getKey: ({ match: match, query: query, route: route })=>{
        const { name: name = '' } = route || {};
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        const { config: config } = query;
        const hasConfig = Boolean(config);
        let key = 'rapidBoardData';
        if ((0, $8QGVd.isBoardRoute)(name)) key = `boardData-${boardId}::hasConfig=${hasConfig}`;
        else if ((0, $8QGVd.isBacklogRoute)(name)) key = `backlogData-${boardId}::hasConfig=${hasConfig}`;
        return key;
    },
    getDataLoader: ()=>(parcelRequire("5Ojhb")),
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("8QGVd", function(module, exports) {

$parcel$export(module.exports, "isBoardRoute", () => $94656fa01dfef750$export$437d4d6e25681588);
$parcel$export(module.exports, "isBacklogRoute", () => $94656fa01dfef750$export$bcb853db5e3e8054);
const $94656fa01dfef750$export$437d4d6e25681588 = (routeName)=>routeName === 'rapidboard-board' || routeName === 'rapidboard-board-embed' || routeName === 'rapidboard-board-settings' || routeName === 'rapidboard-user-board' || routeName === 'rapidboard-user-board-settings' || routeName === 'servicedesk-boards' || routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-practice-custom-board';
const $94656fa01dfef750$export$bcb853db5e3e8054 = (routeName)=>routeName === 'rapidboard-backlog' || routeName === 'rapidboard-user-backlog' || routeName === 'rapidboard-backlog-embed';

});

parcelRegister("5Ojhb", function(module, exports) {

let $43b09320d45478c1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $43b09320d45478c1$var$load("lbwWE").then(()=>parcelRequire('btTZq'));

});


parcelRegister("451Ow", function(module, exports) {

$parcel$export(module.exports, "rapidboardResource", () => $22f6993f0f896f9c$export$d0f42a55e7c5752c);

var $l1VxS = parcelRequire("l1VxS");

var $6XhAO = parcelRequire("6XhAO");

const $22f6993f0f896f9c$export$d0f42a55e7c5752c = (0, $l1VxS.createResource)({
    type: (0, $6XhAO.RESOURCE_TYPE_RAPIDBOARDS_RESOURCE),
    getKey: ({ match: match })=>match.query.rapidView || '',
    getDataLoader: ()=>(parcelRequire("hsn7i")),
    maxAge: Number.MAX_VALUE,
    isBrowserOnly: true
});

});
parcelRegister("hsn7i", function(module, exports) {

let $cb56fbb07934eea7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cb56fbb07934eea7$var$load("kLqYd").then(()=>parcelRequire('a7NHJ'));

});


parcelRegister("4pqJW", function(module, exports) {

$parcel$export(module.exports, "wrmBundleResource", () => $af9fd9dae3624e0c$export$f199d15b7cd18df1);

var $l1VxS = parcelRequire("l1VxS");

var $7jTnu = parcelRequire("7jTnu");

var $6XhAO = parcelRequire("6XhAO");

var $blWcH = parcelRequire("blWcH");

const $af9fd9dae3624e0c$export$f199d15b7cd18df1 = (0, $l1VxS.createResource)({
    type: (0, $6XhAO.RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE),
    getKey: ({ route: route })=>{
        if ((0, $7jTnu.fg)('reports-overview-page-migration')) return (0, $blWcH.getRapidViewConfigFromRouteName)(route.name).stateKey;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("5pLrG")),
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("5pLrG", function(module, exports) {

let $3f14173918cbaa56$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3f14173918cbaa56$var$load("6LWC7").then(()=>parcelRequire('6Y0wG'));

});



parcelRegister("c0h8V", function(module, exports) {

$parcel$export(module.exports, "uifBoardResource", () => $e44f77f60fe564e6$export$b65bcbbccad354ac);

var $l1VxS = parcelRequire("l1VxS");


const $e44f77f60fe564e6$export$b65bcbbccad354ac = (0, $l1VxS.createResource)({
    type: (0, $deaac3eb1a0f3204$export$cfae566ecf2855f8),
    getKey: ({ match: { params: { boardId: boardId } }, route: { name: routeName }, query: { config: config } })=>{
        if (config) return `uif-board::${routeName}::config`;
        if (boardId == null) return `uif-board::${routeName}::not-found`;
        return `uif-board::${routeName}::${boardId}`;
    },
    getDataLoader: ()=>(parcelRequire("jkJMW")),
    maxAge: 0
});

});
const $deaac3eb1a0f3204$export$cfae566ecf2855f8 = 'UIF_BOARD';

parcelRegister("jkJMW", function(module, exports) {

let $e1336731a47f5200$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e1336731a47f5200$var$load("e4xC7").then(()=>parcelRequire('5Uxlx'));

});


parcelRegister("fbgOh", function(module, exports) {

$parcel$export(module.exports, "editModelResource", () => $eeba0f4399f27fcb$export$ab9a4786826fd2d);
$parcel$export(module.exports, "getEditModelResource", () => $eeba0f4399f27fcb$export$5b9bac2cc4bf4511);

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $1Ozm9 = parcelRequire("1Ozm9");

var $5L7qx = parcelRequire("5L7qx");

var $l1VxS = parcelRequire("l1VxS");

var $blWcH = parcelRequire("blWcH");
const $eeba0f4399f27fcb$export$ddbb511f9111736a = async (boardId)=>{
    try {
        return await (0, $1Ozm9.default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel.json?cardLayoutConfig=false&rapidViewId=${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'getEditModelRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $eeba0f4399f27fcb$export$ab9a4786826fd2d = (0, $l1VxS.createResource)({
    type: 'CLASSIC_BOARD_SETTING_EDIT_MODEL',
    getKey: (routerContext)=>(0, $blWcH.getConfigFromRouterContext)(routerContext) ? 'edit-model' : 'not-edit-model',
    getData: async (routerContext)=>{
        if ((0, $blWcH.getConfigFromRouterContext)(routerContext)) {
            const boardId = routerContext.match.params?.boardId ?? '';
            return $eeba0f4399f27fcb$export$ddbb511f9111736a(boardId);
        }
        return null;
    }
});
const $eeba0f4399f27fcb$export$5b9bac2cc4bf4511 = ()=>(0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('board-settings-graphql-refactor_cyvz9'), $eeba0f4399f27fcb$export$ab9a4786826fd2d);

});


parcelRegister("4AC9x", function(module, exports) {

$parcel$export(module.exports, "servicedeskVirtualAgentAiAnswersKbResource", () => $38c41c9fdd9e8b38$export$6aecd43ca01da0d9);

var $l1VxS = parcelRequire("l1VxS");

const $38c41c9fdd9e8b38$var$getDataLoader = ()=>(parcelRequire("2tJJY"));
const $38c41c9fdd9e8b38$export$6aecd43ca01da0d9 = (0, $l1VxS.createResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_AI_ANSWERS_KB_RESOURCE',
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $38c41c9fdd9e8b38$var$getDataLoader,
    isBrowserOnly: true
});

});
parcelRegister("2tJJY", function(module, exports) {

let $1ce1c54a9e519bb3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1ce1c54a9e519bb3$var$load("lcOLg").then(()=>parcelRequire('4gt09'));

});


parcelRegister("cRzUS", function(module, exports) {

$parcel$export(module.exports, "aiAnswersRoute", () => $74c36845f4070411$export$57dc115194d72385);
const $74c36845f4070411$export$57dc115194d72385 = {
    name: 'project-settings-servicedesk-virtualagent-ai-answers',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/ai-answers'
};

});

parcelRegister("aQoXd", function(module, exports) {

$parcel$export(module.exports, "serviceProjectLayout", () => $1fa61a55f28068ec$export$e321cb31c875d1ba);
$parcel$export(module.exports, "rightSidebarsLayout", () => $1fa61a55f28068ec$export$820f9bb834280408);

var $ln6Iy = parcelRequire("ln6Iy");

var $7h3uc = parcelRequire("7h3uc");

var $f61QS = parcelRequire("f61QS");

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");

var $bwUbt = parcelRequire("bwUbt");

var $gzcjr = parcelRequire("gzcjr");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1fa61a55f28068ec$var$withServiceProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $ln6Iy.SERVICE_DESK_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1fa61a55f28068ec$var$ProjectBuilder = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("69T8B")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/project-builder/ProjectBuilderWithQueryParam.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1fa61a55f28068ec$var$Onboarding = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("8drXn")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1fa61a55f28068ec$var$RightSidebars = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("bUNZI")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $1fa61a55f28068ec$export$e321cb31c875d1ba = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout), {
    globalComponents: [
        $1fa61a55f28068ec$var$withServiceProjectContext($1fa61a55f28068ec$var$Onboarding),
        ...(0, $bwUbt.serviceProjectFirstImpressionsLayout).globalComponents.map($1fa61a55f28068ec$var$withServiceProjectContext),
        $1fa61a55f28068ec$var$withServiceProjectContext((0, $f61QS.AsyncJsmCustomDomainChangeBoardingFlag)),
        $1fa61a55f28068ec$var$ProjectBuilder
    ],
    rightSidebars: [
        $1fa61a55f28068ec$var$withServiceProjectContext($1fa61a55f28068ec$var$RightSidebars),
        ...(0, $bwUbt.serviceProjectFirstImpressionsLayout).rightSidebars.map($1fa61a55f28068ec$var$withServiceProjectContext)
    ]
});
const $1fa61a55f28068ec$export$820f9bb834280408 = (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), {
    rightSidebars: [
        $1fa61a55f28068ec$var$RightSidebars
    ]
});

});
parcelRegister("7h3uc", function(module, exports) {

$parcel$export(module.exports, "globalLayout", () => $9f25df309d0ec2b8$export$929cb72e7acb7fd9);

var $6dwgv = parcelRequire("6dwgv");
const $9f25df309d0ec2b8$var$rightSidebars = ()=>[];
const $9f25df309d0ec2b8$export$929cb72e7acb7fd9 = (0, $6dwgv.createLayout)({
    rightSidebars: $9f25df309d0ec2b8$var$rightSidebars()
});

});
parcelRegister("6dwgv", function(module, exports) {

$parcel$export(module.exports, "coalesce", () => $b345ebe3c14918f6$export$6e5538615c060df7);
$parcel$export(module.exports, "renderGlobalComponents", () => $b345ebe3c14918f6$export$fc28c9563350e5b8);
$parcel$export(module.exports, "createLayout", () => $b345ebe3c14918f6$export$3dd437ade36ede40);
$parcel$export(module.exports, "composeLayouts", () => $b345ebe3c14918f6$export$6c041b39c370853f);
$parcel$export(module.exports, "withProjectContext", () => $b345ebe3c14918f6$export$e97a7da67a5b8ce4);

var $eJOHy = parcelRequire("eJOHy");

var $2846K = parcelRequire("2846K");

var $7jTnu = parcelRequire("7jTnu");

var $eWzpp = parcelRequire("eWzpp");

var $ch9En = parcelRequire("ch9En");

const $b345ebe3c14918f6$export$6e5538615c060df7 = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
const $b345ebe3c14918f6$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
        const { displayName: displayName, name: name } = Component;
        const placeholderName = $b345ebe3c14918f6$export$6e5538615c060df7(displayName) ?? $b345ebe3c14918f6$export$6e5538615c060df7(name) ?? i;
        const key = (0, $7jTnu.fg)('jfp_magma_shared-component-perf-1') ? (0, $2846K.uid)(Component) : placeholderName;
        return(// TODO Only add suspense if lazy component, otherwise add suspense within component array
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
            name: String(placeholderName),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, null)));
    });
const $b345ebe3c14918f6$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false } = {})=>({
        isChromeless: isChromeless,
        globalComponents: Array.from(new Set(globalComponents)),
        rightSidebars: Array.from(new Set(rightSidebars))
    });
const $b345ebe3c14918f6$export$6c041b39c370853f = (...layouts)=>{
    if (layouts.length === 1) return $b345ebe3c14918f6$export$3dd437ade36ede40(layouts[0]);
    const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
            isChromeless: isChromeless,
            globalComponents: [
                ...l.globalComponents,
                ...globalComponents
            ],
            rightSidebars: [
                ...l.rightSidebars,
                ...rightSidebars
            ]
        }), {
        globalComponents: [],
        rightSidebars: [],
        isChromeless: false
    });
    return $b345ebe3c14918f6$export$3dd437ade36ede40(layout);
};
const $b345ebe3c14918f6$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
const $b345ebe3c14918f6$var$formatPrefix = (style, type)=>{
    if (!style && !type) return 'Empty';
    if (style === 'any' && type === 'any') return 'Any';
    const formattedStyle = $b345ebe3c14918f6$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
    if (type === 'any') return formattedStyle;
    const formattedType = $b345ebe3c14918f6$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
    if (style === 'any') return formattedType;
    return `${formattedStyle}${formattedType}`;
};
const $b345ebe3c14918f6$export$e97a7da67a5b8ce4 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
Component, options)=>{
    const { project: expectedProject } = options;
    const ScopedComponent = ()=>{
        const { data: project, loading: loading } = (0, $eWzpp.useProject)();
        if (loading) return null;
        if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, null);
    };
    const name = $b345ebe3c14918f6$export$6e5538615c060df7(Component.displayName) ?? $b345ebe3c14918f6$export$6e5538615c060df7(Component.name) ?? 'Component';
    const prefix = $b345ebe3c14918f6$var$formatPrefix(expectedProject?.style, expectedProject?.type);
    ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
    return ScopedComponent;
};

});
parcelRegister("eWzpp", function(module, exports) {

$parcel$export(module.exports, "useProject", () => $b0e367b82a642155$export$51b1383ef8844a7);

var $eJOHy = parcelRequire("eJOHy");

var $imXGf = parcelRequire("imXGf");

var $dSkLG = parcelRequire("dSkLG");
const $b0e367b82a642155$export$51b1383ef8844a7 = (customContext)=>{
    const { data: data, loading: loading, error: error } = (0, $dSkLG.useProjectSidebarNavigation)(customContext);
    const project = (0, $eJOHy.useMemo)(()=>data && (0, $imXGf.extractData)(data), [
        data
    ]);
    return {
        data: project,
        loading: loading,
        error: error
    };
};

});
parcelRegister("imXGf", function(module, exports) {

$parcel$export(module.exports, "getStyle", () => $6f45f52094bb95b1$export$3d2f074408bd1b82);
$parcel$export(module.exports, "extractData", () => $6f45f52094bb95b1$export$9df5fa0a366163d2);

var $ln6Iy = parcelRequire("ln6Iy");

var $7jTnu = parcelRequire("7jTnu");
const $6f45f52094bb95b1$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, $ln6Iy.ProjectStyle).NEXT_GEN : (0, $ln6Iy.ProjectStyle).CLASSIC;
const $6f45f52094bb95b1$var$getProject = (project)=>({
        avatarUrl: project.avatarUrls['48x48'],
        id: Number(project.id),
        isSimplified: project.simplified,
        key: project.key,
        name: project.name,
        style: $6f45f52094bb95b1$export$3d2f074408bd1b82(project.simplified),
        type: project.projectTypeKey,
        ...typeof project.isLiveTemplate === 'boolean' && (0, $7jTnu.fg)('jira_custom_templates_ux') && {
            isLiveTemplate: project.isLiveTemplate
        }
    });
const $6f45f52094bb95b1$export$9df5fa0a366163d2 = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.project ? $6f45f52094bb95b1$var$getProject(jiraWorkManagementNavData.project) : null;
        case 'jira_software':
            return jiraSoftwareNavData?.project ? $6f45f52094bb95b1$var$getProject(jiraSoftwareNavData.project) : null;
        case 'jira_service_management':
        case 'jira_customer_service':
            return jiraServiceManagementNavData?.project ? $6f45f52094bb95b1$var$getProject(jiraServiceManagementNavData.project) : null;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.project ? $6f45f52094bb95b1$var$getProject(jiraProductDiscoveryNavData.project) : null;
        case null:
        default:
            return null;
    }
};

});

parcelRegister("dSkLG", function(module, exports) {

$parcel$export(module.exports, "useProjectSidebarNavigation", () => $305b347fff7113d4$export$5a85006c180fb373);
$parcel$export(module.exports, "useProjectSidebarConnectNavigation", () => $305b347fff7113d4$export$2bed15cd7d167db5);
$parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", () => $305b347fff7113d4$export$a9d05fc2c1d94895);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", () => $305b347fff7113d4$export$d48e3c3556894533);
$parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", () => $305b347fff7113d4$export$24a781cd863077aa);
$parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", () => $305b347fff7113d4$export$e16ecd2512eb0dc7);
$parcel$export(module.exports, "useJiraSoftwareProjectNavigation", () => $305b347fff7113d4$export$68dc0ecbea8211d2);
$parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", () => $305b347fff7113d4$export$5cf90b625d0e1248);
$parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", () => $305b347fff7113d4$export$d63d92edebe543d9);

var $eJOHy = parcelRequire("eJOHy");

var $3qMzf = parcelRequire("3qMzf");

var $6zZVV = parcelRequire("6zZVV");

var $dHUNm = parcelRequire("dHUNm");

var $cY5nO = parcelRequire("cY5nO");

var $9pJMP = parcelRequire("9pJMP");

var $bo7Z6 = parcelRequire("bo7Z6");

var $eJrcF = parcelRequire("eJrcF");

var $9aQsQ = parcelRequire("9aQsQ");
const $305b347fff7113d4$export$5a85006c180fb373 = (customContext)=>{
    const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, $bo7Z6.useResourceWithCustomRouterContext)((0, $9pJMP.staticProjectSidebarNavigationResource), customContext);
    const memoizedResponse = (0, $eJOHy.useMemo)(()=>navResponse, [
        navResponse
    ]);
    (0, $9aQsQ.useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
    return {
        data: memoizedResponse,
        loading: memoizedResponse != null ? false : loading,
        refresh: refresh,
        clearAll: clearAll,
        error: error,
        ...rest
    };
};
const $305b347fff7113d4$export$2bed15cd7d167db5 = ()=>(0, $eJrcF.useResource)((0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource));
const $305b347fff7113d4$export$a9d05fc2c1d94895 = ()=>(0, $eJrcF.useResource)((0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource));
const $305b347fff7113d4$export$d48e3c3556894533 = ()=>(0, $eJrcF.useResource)((0, $cY5nO.staticProjectSettingsSidebarConnectAddonsNavigationResource));
const $305b347fff7113d4$export$24a781cd863077aa = ()=>(0, $eJrcF.useResource)((0, $3qMzf.staticJSMProjectConnectAddonsNavigationResource));
const $305b347fff7113d4$export$e16ecd2512eb0dc7 = ()=>{
    const { data: data, ...rest } = $305b347fff7113d4$export$5a85006c180fb373();
    const response = data?.jiraWorkManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $305b347fff7113d4$export$68dc0ecbea8211d2 = ()=>{
    const { data: data, ...rest } = $305b347fff7113d4$export$5a85006c180fb373();
    const response = data?.jiraSoftwareNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $305b347fff7113d4$export$5cf90b625d0e1248 = (customContext)=>{
    const { data: data, ...rest } = $305b347fff7113d4$export$5a85006c180fb373(customContext);
    const response = data?.jiraServiceManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $305b347fff7113d4$export$d63d92edebe543d9 = ()=>{
    const { data: data, ...rest } = $305b347fff7113d4$export$5a85006c180fb373();
    const response = data?.jiraProductDiscoveryNavData || null;
    return {
        data: response,
        ...rest
    };
};

});
parcelRegister("9aQsQ", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", () => $62cf57129499b564$export$780174995da89d60);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $9pJMP = parcelRequire("9pJMP");

var $eA736 = parcelRequire("eA736");
var $kfvK2 = parcelRequire("kfvK2");
var $eJrcF = parcelRequire("eJrcF");
const $62cf57129499b564$export$90dbde7e33e6e21 = ()=>null;
const $62cf57129499b564$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $eA736.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/:projectKey/dummyroute',
        component: $62cf57129499b564$export$90dbde7e33e6e21
    }, {
        params: {
            projectKey: projectKey
        }
    }) : undefined;
const $62cf57129499b564$export$19001bab9e4b7f8f = (projectKey)=>{
    const { data: data, update: update } = (0, $eJrcF.useResource)((0, $9pJMP.staticProjectSidebarNavigationResource), {
        routerContext: $62cf57129499b564$export$d647718555c2fdd8(projectKey)
    });
    return {
        data: data,
        update: update
    };
};
const $62cf57129499b564$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $eA736.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
        component: $62cf57129499b564$export$90dbde7e33e6e21
    }, {
        params: {
            boardId: `${boardId}`
        }
    }) : undefined;
const $62cf57129499b564$export$e2bb7877e6cec3eb = (boardId)=>{
    const { data: data, update: update } = (0, $eJrcF.useResource)((0, $9pJMP.staticProjectSidebarNavigationResource), {
        routerContext: $62cf57129499b564$export$23dc6491016cabdc(boardId)
    });
    return {
        data: data,
        update: update
    };
};
const $62cf57129499b564$var$useIsOnBoardBasedRoute = (0, $kfvK2.createRouterSelector)(({ route: route, query: query, match: match })=>(0, $9pJMP.getIdentifier)(route.name, match, query)?.identifierType === 'boardId');
const $62cf57129499b564$export$780174995da89d60 = (latestNavInfo)=>{
    const isOnBoardBasedRoute = $62cf57129499b564$var$useIsOnBoardBasedRoute();
    const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
    const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
    const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
    // explicitly get project data by forcing key to be project
    const { data: projectRouteNavInfo, update: updateProjectRoute } = $62cf57129499b564$export$19001bab9e4b7f8f(pKey);
    // explicitly get board data by forcing key to be board
    const { data: boardRouteNavInfo, update: updateBoardRoute } = $62cf57129499b564$export$e2bb7877e6cec3eb(boardId);
    // if software CMP project or board data is not in sync, then force update
    (0, $eJOHy.useEffect)(()=>{
        if (latestNavInfo != null && isSoftwareCMP) {
            if (isOnBoardBasedRoute && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
        }
    }, [
        isOnBoardBasedRoute,
        latestNavInfo,
        updateProjectRoute,
        updateBoardRoute,
        projectRouteNavInfo,
        boardRouteNavInfo,
        isSoftwareCMP
    ]);
};

});





parcelRegister("f61QS", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", () => $1961db39384c0e0d$export$b1ef5e3da6e1959d);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $1961db39384c0e0d$var$LazyJsmCustomDomainChangeBoardingFlag = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("fc2SG")), {
    moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/ui/index.tsx"
});
const $1961db39384c0e0d$export$b1ef5e3da6e1959d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "async-jsm-custom-domain-change-boarding-flag",
        packageName: "jira-help-center-custom-domain-change-boarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jsm-custom-domain-change-boarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1961db39384c0e0d$var$LazyJsmCustomDomainChangeBoardingFlag, null)));

});
parcelRegister("fc2SG", function(module, exports) {

let $b0fa361910880c17$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b0fa361910880c17$var$load("kZY1H").then(()=>parcelRequire('lKRQ7'));

});


parcelRegister("jbfEb", function(module, exports) {

$parcel$export(module.exports, "projectLayout", () => $ca707d874a48fc97$export$204149bac601d20c);

var $h6Od4 = parcelRequire("h6Od4");

var $6dwgv = parcelRequire("6dwgv");

var $gzcjr = parcelRequire("gzcjr");

var $cx2Hn = parcelRequire("cx2Hn");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ca707d874a48fc97$var$withAnyProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: 'any'
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ca707d874a48fc97$var$ProjectTrackers = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("gxC2q")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/project-layout/src/ui/trackers/index.tsx"
});
const $ca707d874a48fc97$var$ProjectFavicon = ()=>{
    (0, $cx2Hn.useProjectFavicon)();
    return null;
};
const $ca707d874a48fc97$var$rightSidebars = ()=>[];
const $ca707d874a48fc97$var$globalComponents = [
    $ca707d874a48fc97$var$withAnyProjectContext($ca707d874a48fc97$var$ProjectFavicon),
    $ca707d874a48fc97$var$withAnyProjectContext($ca707d874a48fc97$var$ProjectTrackers),
    $ca707d874a48fc97$var$withAnyProjectContext((0, $h6Od4.ProjectRouteListener))
];
const $ca707d874a48fc97$export$204149bac601d20c = (0, $6dwgv.createLayout)({
    globalComponents: $ca707d874a48fc97$var$globalComponents,
    rightSidebars: $ca707d874a48fc97$var$rightSidebars()
});

});
parcelRegister("h6Od4", function(module, exports) {

$parcel$export(module.exports, "ProjectRouteListener", () => $759f7c84282a636f$export$159f09d701320911);

var $eJOHy = parcelRequire("eJOHy");

var $dZRaT = parcelRequire("dZRaT");

var $gZTP9 = parcelRequire("gZTP9");

var $eJrcF = parcelRequire("eJrcF");

var $7A5g5 = parcelRequire("7A5g5");
const $759f7c84282a636f$export$159f09d701320911 = ()=>{
    const isSiteAdmin = (0, $gZTP9.useIsAdmin)();
    const { data: data, loading: loading } = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    (0, $eJOHy.useEffect)(()=>{
        if (isSiteAdmin) (0, $7A5g5.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: true
        });
        else if (data != null) (0, $7A5g5.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: data.isProjectAdmin
        });
        else (0, $7A5g5.setIsProjectAdmin)({
            loading: loading,
            isProjectAdmin: null
        });
    }, [
        data,
        loading,
        isSiteAdmin
    ]);
    // Cleanup when component is unmounted. This means we are no longer in a project route
    (0, $eJOHy.useEffect)(()=>()=>(0, $7A5g5.setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: null
            }), []);
    return null;
};

});
parcelRegister("gZTP9", function(module, exports) {

$parcel$export(module.exports, "useIsAdmin", () => $a1219bbbe722b49f$export$99a5e4bc80d231ca);

var $lvKO5 = parcelRequire("lvKO5");
const $a1219bbbe722b49f$export$99a5e4bc80d231ca = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.isAdmin || false;
};

});

parcelRegister("7A5g5", function(module, exports) {

$parcel$export(module.exports, "getIsProjectAdmin", () => $f0c7b3bdfa17e57f$export$34ff06260ad17f2b);
$parcel$export(module.exports, "setIsProjectAdmin", () => $f0c7b3bdfa17e57f$export$d53e6d79d3fa5f31);
let $f0c7b3bdfa17e57f$var$projectAdmin = null;
const $f0c7b3bdfa17e57f$export$34ff06260ad17f2b = ()=>{
    // Initialised as null, this likely means we aren't in a
    // project route and the listener hasn't been rendered
    if ($f0c7b3bdfa17e57f$var$projectAdmin == null || !$f0c7b3bdfa17e57f$var$projectAdmin.loading && $f0c7b3bdfa17e57f$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
    if ($f0c7b3bdfa17e57f$var$projectAdmin.loading === true) return 'LOADING';
    return Boolean($f0c7b3bdfa17e57f$var$projectAdmin.isProjectAdmin);
};
const $f0c7b3bdfa17e57f$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
    $f0c7b3bdfa17e57f$var$projectAdmin = projectAdminState;
};

});


parcelRegister("cx2Hn", function(module, exports) {

$parcel$export(module.exports, "useProjectFavicon", () => $478f39431f2b80dc$export$32abcb1f939de016);

var $eJOHy = parcelRequire("eJOHy");

var $hWeHP = parcelRequire("hWeHP");

var $eWzpp = parcelRequire("eWzpp");

var $7jTnu = parcelRequire("7jTnu");
const $478f39431f2b80dc$export$32abcb1f939de016 = false ? ()=>undefined : ()=>{
    const { data: project } = (0, $eWzpp.useProject)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const iconEle = document.querySelector("link[rel='shortcut icon']");
    // Keep a copy of the default favicon
    const defaultFavicon = (0, $eJOHy.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
        iconEle
    ]);
    const enabled = (0, $eJOHy.useMemo)(()=>(0, $hWeHP.default)('ajs-favicon-use-projecticon') === 'true', []);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $7jTnu.fg)('blu-7193-new-jira-favicons')) {
            const favicon = project ? project.avatarUrl : defaultFavicon;
            if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = favicon;
            // Switch back to default favicon
            return ()=>{
                if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = defaultFavicon;
            };
        }
    }, [
        project,
        iconEle,
        defaultFavicon,
        enabled
    ]);
};

});

parcelRegister("gxC2q", function(module, exports) {

let $c0ad3bff86eda5f2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c0ad3bff86eda5f2$var$load("2gY51").then(()=>parcelRequire('lu6uO'));

});


parcelRegister("bwUbt", function(module, exports) {

$parcel$export(module.exports, "serviceProjectFirstImpressionsLayout", () => $b899726b5c2e771b$export$2562b2d784eadc10);

var $eJOHy = parcelRequire("eJOHy");

var $jmQek = parcelRequire("jmQek");

var $6dwgv = parcelRequire("6dwgv");

var $gzcjr = parcelRequire("gzcjr");
const $b899726b5c2e771b$var$withServiceProjectAccess = (Component)=>{
    const ScopedComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmQek.default), {
            hasServiceDeskAccess: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, null));
    const name = (0, $6dwgv.coalesce)(Component.displayName) ?? (0, $6dwgv.coalesce)(Component.name) ?? 'Component';
    ScopedComponent.displayName = `withServiceProjectAccess(${name})`;
    return ScopedComponent;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b899726b5c2e771b$var$Onboarding = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("9ECtO")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b899726b5c2e771b$var$RightSidebars = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("gmyjC")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $b899726b5c2e771b$export$2562b2d784eadc10 = (0, $6dwgv.createLayout)({
    globalComponents: [
        $b899726b5c2e771b$var$withServiceProjectAccess($b899726b5c2e771b$var$Onboarding)
    ],
    rightSidebars: [
        $b899726b5c2e771b$var$withServiceProjectAccess($b899726b5c2e771b$var$RightSidebars)
    ]
});

});
parcelRegister("jmQek", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7838320445e919b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lvKO5 = parcelRequire("lvKO5");

var $5aeix = parcelRequire("5aeix");
/**
 * Manages the visibility of child components based on user permissions within a multi-tenant environment.
 * It leverages the application's permission settings to determine access rights, ensuring components are only accessible to users with the appropriate permissions.
 * In development environments, it issues a warning when no access-related properties are provided, aiding in debug and development processes.
 */ const $e7838320445e919b$var$AppPermissionsCheck = (props)=>{
    const { appPermissions: appPermissions } = (0, $lvKO5.useTenantContext)();
    if (props.hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    if (props.hasCoreAccess !== undefined && appPermissions.hasCoreAccess === props.hasCoreAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    if (props.hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    if (props.hasServiceDeskAccess === undefined && props.hasCoreAccess === undefined && props.hasSoftwareAccess === undefined) {
        if ((0, $5aeix.isDevelopmentEnv)()) // eslint-disable-next-line no-console
        console.warn('AppPermissionsCheck should have defined at least one of access prop');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    }
    return null;
};
$e7838320445e919b$var$AppPermissionsCheck.defaultProps = {
    hasCoreAccess: undefined,
    hasSoftwareAccess: undefined,
    hasServiceDeskAccess: undefined
};
var $e7838320445e919b$export$2e2bcd8739ae039 = $e7838320445e919b$var$AppPermissionsCheck;

});
parcelRegister("5aeix", function(module, exports) {

$parcel$export(module.exports, "isDevelopmentEnv", () => $b42edb9e31c9a622$export$48e5fb80244b95c5);
const $b42edb9e31c9a622$export$48e5fb80244b95c5 = ()=>false;

});


parcelRegister("9ECtO", function(module, exports) {

let $7075b2cb829254a7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7075b2cb829254a7$var$load("hwlgY"),
    $7075b2cb829254a7$var$load("7vqGd"),
    $7075b2cb829254a7$var$load("1Y4bq"),
    $7075b2cb829254a7$var$load("prUoB")
]).then(()=>parcelRequire('R6Cjs'));

});

parcelRegister("gmyjC", function(module, exports) {

let $be9951ba155affde$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $be9951ba155affde$var$load("hwlgY"),
    $be9951ba155affde$var$load("7vqGd"),
    $be9951ba155affde$var$load("1Y4bq"),
    $be9951ba155affde$var$load("fHzeP")
]).then(()=>parcelRequire('dHOBZ'));

});


parcelRegister("69T8B", function(module, exports) {

let $47be5a87b07e01c8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $47be5a87b07e01c8$var$load("hwlgY"),
    $47be5a87b07e01c8$var$load("ce51P")
]).then(()=>parcelRequire('dQKu6'));

});

parcelRegister("8drXn", function(module, exports) {

let $5fb5393f13aa2997$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5fb5393f13aa2997$var$load("hwlgY"),
    $5fb5393f13aa2997$var$load("7vqGd"),
    $5fb5393f13aa2997$var$load("1Y4bq"),
    $5fb5393f13aa2997$var$load("1VRB2"),
    $5fb5393f13aa2997$var$load("bABhq"),
    $5fb5393f13aa2997$var$load("eHP8U")
]).then(()=>parcelRequire('dln7i'));

});

parcelRegister("bUNZI", function(module, exports) {

let $8acbb4819eafd217$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8acbb4819eafd217$var$load("hwlgY"),
    $8acbb4819eafd217$var$load("7vqGd"),
    $8acbb4819eafd217$var$load("1Y4bq"),
    $8acbb4819eafd217$var$load("1VRB2"),
    $8acbb4819eafd217$var$load("bABhq"),
    $8acbb4819eafd217$var$load("a5JpH")
]).then(()=>parcelRequire('byH1L'));

});


parcelRegister("gy2Qg", function(module, exports) {

$parcel$export(module.exports, "APP_NAMES", () => $85c827d4cf4c7c38$export$4116f3d0d9d6bed7);
$parcel$export(module.exports, "toPackageName", () => $85c827d4cf4c7c38$export$f31a652635bd75fe);
const $85c827d4cf4c7c38$export$4116f3d0d9d6bed7 = {
    ACCOUNTS: 'servicedesk.accounts',
    APP_DISCOVERY: 'servicedesk.app-discovery',
    ATLASSIAN_ANALYTICS: 'servicedesk.atlassian-analytics',
    AUTOMATION_EDIT_RULE: 'servicedesk.automation.edit-rule',
    AUTOMATION_SUMMARY: 'servicedesk.automation.summary',
    AUTOMATION_VIEW_LOG: 'servicedesk.automation.view-log',
    BOARD: 'servicedesk.board',
    BOARD_SETTINGS: 'servicedesk.board-settings',
    CALENDAR: 'servicedesk.calendar',
    PROJECT_SUMMARY: 'servicedesk.project-summary',
    CHANGE_CALENDAR: 'servicedesk.change-calendar',
    CHANGE_MANAGEMENT_SETTINGS: 'servicedesk.change-management.settings',
    CREATE_PROJECT: 'servicedesk.create-project',
    CSAT_CONFIG: 'servicedesk.csat-configuration',
    CUSTOMER_PERMISSIONS: 'servicedesk.customer-permissions',
    CONTACTS: 'servicedesk.contacts',
    CUSTOMERS: 'servicedesk.customers',
    CUSTOMER_DETAILS: 'servicedesk.customer-details',
    CUSTOMER_SERVICE_ESCALATIONS: 'servicedesk.customer-service-escalations',
    CUSTOMER_SERVICE_PRODUCTS: 'servicedesk.customer-service-products',
    CUSTOMER_SERVICE_HELP_CENTER: 'servicedesk.customer-service-help-center',
    INVITE_TEAM_DIALOG: 'servicedesk.invite-team-dialog',
    ISSUE_SCHEDULE_CHANGE: 'servicedesk.issue.schedule-change',
    ITSM_FEATURES_SETTINGS: 'servicedesk.itsm-features.settings',
    ITSM_OVERVIEW_SETTINGS: 'servicedesk.itsm-overview.settings',
    ITSM_SAMPLE_SPACE: 'servicedesk.itsm-sample-space',
    JOURNEYS: 'servicedesk.journeys',
    JOURNEY_CONFIG: 'servicedesk.journey-config',
    GETTING_STARTED_PAGE: 'servicedesk.getting-started-page',
    KB_BROWSE_ARTICLES: 'servicedesk.knowledge-base.browse-articles',
    KB_CATEGORY: 'servicedesk.knowledge-base.category',
    KB_DRAFTS: 'servicedesk.knowledge-base.drafts',
    KB_BROWSE_CATEGORIES: 'servicedesk.knowledge-base.browse-categories',
    KB_SUGGESTED_ARTICLES: 'servicedesk.knowledge-base.suggested-articles',
    KB_EMBED_EDITOR: 'servicedesk.knowledge-article.embed-editor',
    KB_LANDING: 'servicedesk.knowledge-base.landing',
    KB_REPORTS_REQUESTS: 'servicedesk.kb-requests.reports',
    KB_SEARCH: 'servicedesk.knowledge-base.search',
    KB_SETTINGS: 'servicedesk.knowledge.settings',
    KB_SETUP: 'servicedesk.knowledge-base.setup',
    KB_VIEW_ARTICLE: 'servicedesk.knowledge-base.view-article',
    ORGANIZATION: 'servicedesk.organization',
    ORGANIZATIONS: 'servicedesk.organizations',
    ORGANIZATION_DETAILS: 'servicedesk.organization-details',
    PORTAL_SETTINGS: 'servicedesk.portal-settings',
    QUEUES_AGENT_VIEW: 'servicedesk.queues.agent-view',
    QUEUES_EDIT_VIEW: 'servicedesk.queues.edit-view',
    QUEUES_MAIN: 'servicedesk.queues.main',
    REPORTS_CUSTOM: 'servicedesk.reports.custom',
    REPORTS_CUSTOM_CREATE: 'servicedesk.reports.custom-create',
    REPORTS_CUSTOM_EDIT: 'servicedesk.reports.custom-edit',
    REPORTS_HOME_PAGE: 'servicedesk.reports.home-page',
    REPORTS_SATISFACTION: 'servicedesk.reports.satisfaction',
    REPORTS_WORKLOAD: 'servicedesk.reports.workload',
    PROJECT_DASHBOARDS_DASHBOARD_LIST: 'servicedesk.project-dashboards.dashboard-list',
    PROJECT_DASHBOARDS_DASHBOARD_EDITABLE: 'servicedesk.project-dashboards.dashboard-editable',
    REQUEST_TYPES_CONFIG: 'servicedesk.request-types-config',
    REQUEST_TYPE_FIELDS: 'servicedesk.request-type-fields',
    SLA_SETTINGS: 'servicedesk.sla-settings',
    VIRTUAL_AGENT_BROWSE_CONVERSATIONS: 'servicedesk.virtual-agent.browse-conversations',
    VIRTUAL_AGENT_BROWSE_INTENTS: 'servicedesk.virtual-agent.browse-intents',
    VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS: 'servicedesk.virtual-agent.browse-standard-flows',
    VIRTUAL_AGENT_LANDING: 'servicedesk.virtual-agent.landing',
    VIRTUAL_AGENT_SETTINGS: 'servicedesk.virtual-agent.settings',
    VIRTUAL_AGENT_VIEW_INTENT: 'servicedesk.virtual-agent.view-intent',
    VIRTUAL_AGENT_VIEW_STANDARD_FLOW: 'servicedesk.virtual-agent.view-standard-flow',
    VIRTUAL_AGENT_AI_ANSWERS: 'servicedesk.virtual-agent.ai-answers',
    VIRTUAL_AGENT_PERFORMANCE: 'servicedesk.virtual-agent.performance',
    PRACTICE_CONFIG_MODULE: 'servicedesk.practice-config-module',
    CREATE_SERVICE_MODAL: 'servicedesk.create-service-modal',
    UPDATE_SERVICE_MODAL: 'servicedesk.update-service-modal',
    LANGUAGE_SETTINGS: 'servicedesk.language-settings',
    LINKED_ALERTS_MODAL: 'servicedesk.link-alerts-modal',
    INSIGHT_ASSETS_REPORTS: 'servicedesk.insight-cmdb-assets_reports',
    INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT: 'servicedesk.insight-cmdb-assets_reports_default_redirect',
    INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE: 'servicedesk.insight-cmdb-assets_reports_unsubscribe',
    INSIGHT_OBJECT_VIEW: 'servicedesk.insight-cmdb-object',
    INSIGHT_OBJECT_SCHEMA: 'servicedesk.insight-cmdb-object-schema',
    INSIGHT_OBJECT_SCHEMA_CONFIGURATION: 'servicedesk.insight-cmdb-object-schema-configuration',
    INSIGHT_OBJECT_TYPE_CONFIGURATION: 'servicedesk.insight-object-type-configuration',
    INSIGHT_GLOBAL_CONFIGURATION: 'servicedesk.insight-cmdb-global-configuration',
    INSIGHT_LANDING_PAGE: 'servicedesk.insight-cmdb-landing-page',
    CUSTOMER_NOTIFICATIONS_MAIN_VIEW: 'servicedesk.customer-notifications-settings.main-view',
    CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW: 'servicedesk.customer-notifications-settings.invite-customer-view',
    CUSTOMER_NOTIFICATIONS_RULE_VIEW: 'servicedesk.customer-notifications-settings.rule-view',
    CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW: 'servicedesk.customer-notifications-settings.template-view',
    CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW: 'servicedesk.customer-notifications-settings.unknown-view',
    SERVICES_WITHOUT_PROJECT_VIEW: 'servicedesk.services-without-project-view',
    SERVICE_DETAIL_WITHOUT_PROJECT_VIEW: 'servicedesk.service-detail-without-project-view',
    WIDGET_SETTINGS: 'servicedesk.widget-settings',
    ASSETS_APP_SEARCH_RESULTS: 'assets-app.search-results-page',
    ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE: 'assets-app.data-manager.getting-started-page',
    ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE: 'assets-app.data-manager.object-classes-page',
    ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE: 'assets-app.data-manager.data-source',
    ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_VIEW_PAGE: 'assets-app.data-manager.object-class-view',
    ASSETS_APP_ANALYTICS_DATA_VIEW_CREATE_PAGE: 'assets-app.analytics.data-view.create',
    ASSETS_APP_ANALYTICS_DATA_VIEW_DETAILS_PAGE: 'assets-app.analytics.data-view.details',
    ASSETS_APP_ANALYTICS_DATA_VIEW_LIST_PAGE: 'assets-app.analytics.data-view.list'
};
// To match the FE error analytics pipeline convention
const $85c827d4cf4c7c38$var$ANALYTICS_PACKAGE_NAMES = {
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ACCOUNTS]: 'servicedeskAccounts',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.APP_DISCOVERY]: 'serviceDeskAppDiscovery',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ATLASSIAN_ANALYTICS]: 'serviceDeskAtlassianAnalytics',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.AUTOMATION_EDIT_RULE]: 'servicedeskAutomationEditView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.AUTOMATION_SUMMARY]: 'servicedeskAutomationEditRule',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.AUTOMATION_VIEW_LOG]: 'servicedeskAutomationViewLog',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.BOARD]: 'servicedeskBoard',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.BOARD_SETTINGS]: 'servicedeskBoardSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CALENDAR]: 'servicedeskCalendar',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.PROJECT_SUMMARY]: 'servicedeskProjectSummary',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CHANGE_CALENDAR]: 'servicedeskChangeCalendar',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CHANGE_MANAGEMENT_SETTINGS]: 'servicedeskChangeManagementSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CREATE_PROJECT]: 'servicedeskCreateProject',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CSAT_CONFIG]: 'servicedeskCsatConfig',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CONTACTS]: 'servicedeskContacts',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_PERMISSIONS]: 'servicedeskCustomerPermissions',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMERS]: 'servicedeskCustomers',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_DETAILS]: 'servicedeskCustomerDetails',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_ESCALATIONS]: 'servicedeskCustomerServiceEscalations',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_PRODUCTS]: 'servicedeskCustomerServiceProducts',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_HELP_CENTER]: 'servicedeskCustomerServiceHelpCenter',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INVITE_TEAM_DIALOG]: 'servicedeskInviteTeamDialog',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ISSUE_SCHEDULE_CHANGE]: 'servicedeskIssueScheduleChange',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ITSM_FEATURES_SETTINGS]: 'servicedeskItsmFeaturesSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ITSM_OVERVIEW_SETTINGS]: 'servicedeskItsmOverviewSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ITSM_SAMPLE_SPACE]: 'servicedeskItsmSampleSpace',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.JOURNEYS]: 'servicedeskJourneys',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.JOURNEY_CONFIG]: 'servicedeskJourneyConfig',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_BROWSE_ARTICLES]: 'servicedeskKnowledgeBaseBrowseArticles',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_BROWSE_CATEGORIES]: 'servicedeskKnowledgeBaseBrowseCategories',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_CATEGORY]: 'servicedeskKnowledgeBaseCategory',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_DRAFTS]: 'servicedeskKnowledgeBaseDrafts',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_SUGGESTED_ARTICLES]: 'servicedeskKnowledgeBaseSuggestedArticles',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_EMBED_EDITOR]: 'servicedeskKnowledgeBaseEmbedEditor',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_LANDING]: 'servicedeskKnowledgeBaseLanding',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_REPORTS_REQUESTS]: 'servicedeskKbRequestsReports',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_SEARCH]: 'servicedeskKnowledgeBaseSearch',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_SETTINGS]: 'servicedeskKnowledgeSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_SETUP]: 'servicedeskKnowledgeBaseSetup',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_VIEW_ARTICLE]: 'servicedeskKnowledgeBaseViewArticle',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.LANGUAGE_SETTINGS]: 'servicedeskLanguageSettingsTranslations',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ORGANIZATION]: 'servicedeskOrganization',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ORGANIZATIONS]: 'servicedeskOrganizations',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ORGANIZATION_DETAILS]: 'servicedeskOrganizationDetails',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.PORTAL_SETTINGS]: 'servicedeskPortalSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.QUEUES_AGENT_VIEW]: 'servicedeskQueuesAgentView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.QUEUES_EDIT_VIEW]: 'servicedeskQueuesEditView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.QUEUES_MAIN]: 'servicedeskQueuesMain',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REPORTS_CUSTOM]: 'servicedeskReportsCustom',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_CREATE]: 'servicedeskReportsCustomCreate',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_EDIT]: 'servicedeskReportsCustomEdit',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REPORTS_HOME_PAGE]: 'servicedeskReportsHomePage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REPORTS_SATISFACTION]: 'servicedeskReportsSatisfaction',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REPORTS_WORKLOAD]: 'servicedeskReportsWorkload',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.PROJECT_DASHBOARDS_DASHBOARD_EDITABLE]: 'servicedeskProjectDashboardsEditable',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.PROJECT_DASHBOARDS_DASHBOARD_LIST]: 'servicedeskProjectDashboardsList',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REQUEST_TYPES_CONFIG]: 'servicedeskRequestTypesConfig',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REQUEST_TYPE_FIELDS]: 'servicedeskRequestTypeFields',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.SLA_SETTINGS]: 'servicedeskSlaSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_CONVERSATIONS]: 'servicedeskVirtualAgentBrowseConversations',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_INTENTS]: 'servicedeskVirtualAgentBrowseIntents',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS]: 'servicedeskVirtualAgentBrowseStandardFlows',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_LANDING]: 'servicedeskVirtualAgentLanding',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_SETTINGS]: 'servicedeskVirtualAgentSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_INTENT]: 'servicedeskVirtualAgentViewIntent',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_STANDARD_FLOW]: 'servicedeskVirtualAgentViewStandardFlow',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_AI_ANSWERS]: 'servicedeskVirtualAgentAiAnswers',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_PERFORMANCE]: 'servicedeskVirtualAgentPerformance',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.PRACTICE_CONFIG_MODULE]: 'servicedeskPracticeConfigModule',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CREATE_SERVICE_MODAL]: 'servicedeskCreateServiceModal',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.UPDATE_SERVICE_MODAL]: 'servicedeskUpdateServiceModal',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.LINKED_ALERTS_MODAL]: 'servicedeskLinkAlertsModal',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS]: 'servicedeskAssetsReports',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT]: 'servicedeskAssetsReportsDefaultRedirect',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE]: 'servicedeskAssetsReportsUnsubscribe',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_VIEW]: 'servicedeskObjectView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA]: 'servicedeskObjectSchema',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA_CONFIGURATION]: 'servicedeskObjectSchemaConfiguration',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_TYPE_CONFIGURATION]: 'servicedeskObjectTypeConfiguration',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_GLOBAL_CONFIGURATION]: 'servicedeskInsightGlobalConfiguration',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_LANDING_PAGE]: 'servicedeskInsightLandingPage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_MAIN_VIEW]: 'servicedeskCustomerNotificationsMainView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW]: 'servicedeskCustomerNotificationsInviteCustomerView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_RULE_VIEW]: 'servicedeskCustomerNotificationsRuleView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW]: 'servicedeskCustomerNotificationsTemplateView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW]: 'servicedeskCustomerNotificationsUnknownView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.GETTING_STARTED_PAGE]: 'servicedeskGettingStartedPage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.SERVICES_WITHOUT_PROJECT_VIEW]: 'servicedeskServicesWithoutProjectView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.SERVICE_DETAIL_WITHOUT_PROJECT_VIEW]: 'servicedeskServiceDetailWithoutProjectView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.WIDGET_SETTINGS]: 'servicedeskWidgetSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_SEARCH_RESULTS]: 'assetsAppSearchResultsPage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE]: 'assetsAppDataManagerGettingStartedPage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE]: 'assetsAppDataManagerObjectClassesPage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE]: 'assetsAppDataManagerDataSource',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_VIEW_PAGE]: 'assetsAppDataManagerObjectClassView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_ANALYTICS_DATA_VIEW_CREATE_PAGE]: 'assetsAppAnalyticsDataViewCreatePage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_ANALYTICS_DATA_VIEW_DETAILS_PAGE]: 'assetsAppAnalyticsDataViewDetailsPage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_ANALYTICS_DATA_VIEW_LIST_PAGE]: 'assetsAppAnalyticsDataViewListPage'
};
const $85c827d4cf4c7c38$export$f31a652635bd75fe = (appName)=>$85c827d4cf4c7c38$var$ANALYTICS_PACKAGE_NAMES[appName];

});

parcelRegister("7b25q", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentAiAnswersSkeleton", () => $bce0a78f2a17a140$export$5fe1280883d32350);
/* VirtualAgentAiAnswersSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $dj5Zp = parcelRequire("dj5Zp");
const $bce0a78f2a17a140$var$customCssStyles = null;
const $bce0a78f2a17a140$export$5fe1280883d32350 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dj5Zp))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("hwuZ0", function(module, exports) {

$parcel$export(module.exports, "AppSkeletonImage", () => $b5dd2f8be7f8eaf9$export$45b107c5dc7b51a5);
/* AppSkeletonImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $h1VbR = parcelRequire("h1VbR");

var $ft2u5 = parcelRequire("ft2u5");


var $lRq8t = parcelRequire("lRq8t");

var $hkVH5 = parcelRequire("hkVH5");
const $b5dd2f8be7f8eaf9$var$skeletonImageStyles = null;
const $b5dd2f8be7f8eaf9$export$45b107c5dc7b51a5 = /*#__PURE__*/ (0, $eJOHy.memo)(({ src: src, className: className, containerStyles: containerStyles, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1VbR.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b5dd2f8be7f8eaf9$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: src,
        "data-testid": testId,
        alt: `${formatMessage((0, $hkVH5.default).loading)}...`,
        className: (0, $hcewu.default)([
            "_1dqonqa1 _1h6d3acm _1e0c1ule _vchhusvi _1bsb1osq _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            className
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ft2u5.FallbackIndicator), null));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b5dd2f8be7f8eaf9$var$SkeletonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ft2u5", function(module, exports) {

$parcel$export(module.exports, "FallbackIndicator", () => $4d192dc9d4a49414$export$e975518239643357);
/**
 * A declarative component that taints a given location as a "fallback"
 * used to detect SSR success rate and the completeness of the page.
 */ const $4d192dc9d4a49414$export$e975518239643357 = ()=>null;

});

parcelRegister("hkVH5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e046a3f69fb3907$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9e046a3f69fb3907$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    loading: {
        "id": "skeletons.common.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("dj5Zp", function(module, exports) {
module.exports = new URL("virtual-agent-ai-answers-app-skeleton.tpl.283eb0a3.svg", import.meta.url).toString();

});


parcelRegister("c6t96", function(module, exports) {

$parcel$export(module.exports, "aiAnswersEntryPoint", () => $f7deb369b3c292ad$export$5dcf9a7e1076ac6);

var $dyzNj = parcelRequire("dyzNj");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $f7deb369b3c292ad$export$5dcf9a7e1076ac6 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("17gBf")), {
        moduleId: "b474af7a",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $dyzNj.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("dyzNj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a78eded10e1770c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<228f2239cbae33d00d8e63897f96750c>>
 * @relayHash b317a486cf818716fa955809174baed6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aecb078bb42ac99789f2aa91d508e1d81d4288e8ceb828b1c9f3c03242f8f76f

var $bXR9c = parcelRequire("bXR9c");

var $37Ewn = parcelRequire("37Ewn");
const $2a78eded10e1770c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        v2 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v2 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "isAiEnabledInAdminHub"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "srcVirtualAgentAiAnswersQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "virtualAgentConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_servicedeskSettingsVirtualAgentAiAnswers_VirtualAgentAiAnswers_virtualAgentConfiguration"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_servicedeskSettingsVirtualAgentAiAnswers_VirtualAgentAiAnswers_jiraProjectRef"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "VirtualAgentQueryApi",
                        "kind": "LinkedField",
                        "name": "virtualAgent",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "VirtualAgentFeatures",
                                    "kind": "LinkedField",
                                    "name": "virtualAgentEntitlements",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_servicedeskSettingsVirtualAgentAiAnswers_VirtualAgentAiAnswers_virtualAgentFeatures"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "virtualAgent.virtualAgentEntitlements"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "virtualAgent"
                },
                {
                    "args": v7 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "srcVirtualAgentAiAnswersQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "virtualAgentConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isAiResponsesEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "defaultJiraRequestTypeId"
                                                }
                                            ],
                                            "type": "VirtualAgentConfiguration"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "VirtualAgentQueryError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                },
                                v4 /*: any*/ ,
                                {
                                    "args": v7 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "knowledgeBaseArticlesCount",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "count"
                                                }
                                            ],
                                            "type": "KnowledgeBaseArticleCountSource"
                                        }
                                    ]
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isVirtualAgentAvailable"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v10 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "aecb078bb42ac99789f2aa91d508e1d81d4288e8ceb828b1c9f3c03242f8f76f",
            "metadata": {},
            "name": "srcVirtualAgentAiAnswersQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
            }
        }
    };
}();
$2a78eded10e1770c$var$node.hash = "19529bb28005c693e530427ab6ca9cc6";
(0, $37Ewn.PreloadableQueryRegistry).set($2a78eded10e1770c$var$node.params.id, $2a78eded10e1770c$var$node);
var $2a78eded10e1770c$export$2e2bcd8739ae039 = $2a78eded10e1770c$var$node;

});

parcelRegister("17gBf", function(module, exports) {

let $0d035244f80ac0fa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0d035244f80ac0fa$var$load("ftSM7").then(()=>parcelRequire('bP6Tr'));

});


parcelRegister("g8uYY", function(module, exports) {

$parcel$export(module.exports, "createChromelessEntryPoint", () => $d4128f4ca41a15cd$export$56ea489e9d4bfa04);
$parcel$export(module.exports, "createPageEntryPoint", () => $d4128f4ca41a15cd$export$955a7619d2679b4c);

var $8xgJ5 = parcelRequire("8xgJ5");


var $6zXPf = parcelRequire("6zXPf");
const $d4128f4ca41a15cd$export$56ea489e9d4bfa04 = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $ce4cfb37df77ff19$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    }
                }
            }),
        toString: ()=>'ChromelessEntryPoint'
    });
const $d4128f4ca41a15cd$export$955a7619d2679b4c = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $ce4cfb37df77ff19$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    },
                    [(0, $ce4cfb37df77ff19$export$bec6dca2e63de4ae)]: {
                        entryPoint: (0, $8xgJ5.topNavigationEntryPoint),
                        entryPointParams: {
                            menuId: page.topNavigationMenuId
                        }
                    },
                    ...page.leftSidebar ? {
                        [(0, $ce4cfb37df77ff19$export$50ea883ba6f28ff5)]: {
                            entryPoint: page.leftSidebar.sidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                entryPoints: {
                                    ...page.leftSidebar.entryPoints ? $d4128f4ca41a15cd$var$injectEntryPointParams(page.leftSidebar.entryPoints, entryPointParams) : undefined
                                },
                                isAppsExpanded: page.leftSidebar.isAppsExpanded ?? false,
                                isFiltersExpanded: page.leftSidebar.isFiltersExpanded ?? false,
                                isPlansExpanded: page.leftSidebar.isPlansExpanded ?? false,
                                isProjectsExpanded: page.leftSidebar.isProjectsExpanded ?? false,
                                isOperationsExpanded: page.leftSidebar.isOperationsExpanded ?? false,
                                isOverviewsExpanded: page.leftSidebar.isOverviewsExpanded ?? false
                            }
                        }
                    } : undefined,
                    ...page.horizontalNavigation && (0, $6zXPf.getWillShowNav4)() ? {
                        [(0, $ce4cfb37df77ff19$export$948d4d345566aed3)]: {
                            entryPoint: page.horizontalNavigation,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.horizontalNavigationFallback
                            }
                        }
                    } : undefined,
                    ...page.rightSidebar ? {
                        [(0, $ce4cfb37df77ff19$export$7bf43119a6b49ddb)]: {
                            entryPoint: page.rightSidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.rightSidebarFallback
                            }
                        }
                    } : undefined
                }
            }),
        toString: ()=>'PageEntryPoint'
    });
function $d4128f4ca41a15cd$var$injectEntryPointParams(obj, entryPointParams) {
    const newParams = {};
    // https://stackoverflow.com/a/16735184
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) newParams[prop] = {
        entryPoint: obj[prop].entryPoint,
        entryPointParams: entryPointParams
    };
    return newParams;
}

});
parcelRegister("8xgJ5", function(module, exports) {

$parcel$export(module.exports, "topNavigationEntryPoint", () => $bd208b44eaab6db9$export$f780be9e138f456f);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $bd208b44eaab6db9$export$f780be9e138f456f = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("96SSt"))).then(({ AtlassianNavigation: AtlassianNavigation })=>AtlassianNavigation), {
        moduleId: "1f1265b4",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: (extraProps)=>({
            extraProps: extraProps
        })
});

});
parcelRegister("j3Ybe", function(module, exports) {

$parcel$export(module.exports, "JSResourceForUserVisible", () => $856bda59a84a919f$export$58f934f3d33a84b6);

var $9ioOQ = parcelRequire("9ioOQ");

var $kUABJ = parcelRequire("kUABJ");

var $7AEZp = parcelRequire("7AEZp");
const $856bda59a84a919f$var$cache = (0, $9ioOQ.createCache)(new Map());
function $856bda59a84a919f$export$58f934f3d33a84b6(loader, opts) {
    return $856bda59a84a919f$var$cache.get(opts.moduleId, ()=>(0, $kUABJ.PreloadableJSResource)(()=>(0, $7AEZp.postTask)(loader, {
                priority: 'user-blocking'
            }), opts));
}

});


const $ce4cfb37df77ff19$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $ce4cfb37df77ff19$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $ce4cfb37df77ff19$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $ce4cfb37df77ff19$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $ce4cfb37df77ff19$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';


parcelRegister("cAYFR", function(module, exports) {

$parcel$export(module.exports, "FedRAMPFallbackRedirectToProjectSettings", () => $3d6eb1ca1636e510$export$3b12aad1f47d85f8);

var $1DBt0 = parcelRequire("1DBt0");
const $3d6eb1ca1636e510$export$3b12aad1f47d85f8 = (0, $1DBt0.defaultRedirectForSettings)((0, $1DBt0.SERVICE_DESK_PRODUCT));

});
parcelRegister("1DBt0", function(module, exports) {

$parcel$export(module.exports, "SERVICE_DESK_PRODUCT", () => $d050639f5e7918b5$export$5575497f0592ee94);
$parcel$export(module.exports, "defaultRedirectForSettings", () => $d050639f5e7918b5$export$c9b0516439c55d7a);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $d050639f5e7918b5$export$5575497f0592ee94 = 'servicedesk';
const $d050639f5e7918b5$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });

});



parcelRegister("4eOkX", function(module, exports) {

$parcel$export(module.exports, "alertPoliciesRouteEntry", () => $c8e4371804662a65$export$eb1e2324ca2031e2);

var $klg4M = parcelRequire("klg4M");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $foqWb = parcelRequire("foqWb");

var $fIZNm = parcelRequire("fIZNm");
const $c8e4371804662a65$export$eb1e2324ca2031e2 = (0, $6xToB.createEntry)((0, $foqWb.alertPoliciesRoute), ()=>({
        group: 'eoc',
        component: (0, $fIZNm.AlertPoliciesComponent),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $klg4M.resources)(),
            ...(0, $io7oY.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fIZNm.LazyAlertPolicies),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("klg4M", function(module, exports) {

$parcel$export(module.exports, "teamPolicyResource", () => $bc64c974e5cbc105$export$10d7fa513f08ef83);
$parcel$export(module.exports, "notificationPolicyResource", () => $bc64c974e5cbc105$export$6d5f23d9118ad678);
$parcel$export(module.exports, "globalPolicyResource", () => $bc64c974e5cbc105$export$7aed80da979a5112);
$parcel$export(module.exports, "resources", () => $bc64c974e5cbc105$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $5SoLX = parcelRequire("5SoLX");
const $bc64c974e5cbc105$export$10d7fa513f08ef83 = (0, $l1VxS.createResource)({
    type: 'teamPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-policy/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        // if there is no teamId, this means that we are on the global policy page.
        // so we can return null directly, instead of sending fetch request.
        if (!teamId) return null;
        return (0, $5SoLX.getTeamPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $bc64c974e5cbc105$export$6d5f23d9118ad678 = (0, $l1VxS.createResource)({
    type: 'notificationPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `notification-policy/${teamId}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        if (!teamId) return;
        return (0, $5SoLX.getNotificationPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $bc64c974e5cbc105$export$7aed80da979a5112 = (0, $l1VxS.createResource)({
    type: 'globalPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        if (teamId) return `global-policy/${teamId}`;
        return 'global-policy';
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $5SoLX.getGlobalPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $bc64c974e5cbc105$export$4cb385c2db8b1e99 = (0, $l1VxS.createResource)({
    type: 'policyMaintenanceRightsResource',
    getKey: ()=>'policy-maintenance-rights-resource',
    getData: async ()=>{
        return (0, $5SoLX.getPolicyMaintenanceRights)();
    },
    isBrowserOnly: true
});
const $bc64c974e5cbc105$export$bc99aaabaf7b70a7 = ()=>[
        $bc64c974e5cbc105$export$10d7fa513f08ef83,
        $bc64c974e5cbc105$export$7aed80da979a5112,
        $bc64c974e5cbc105$export$4cb385c2db8b1e99,
        $bc64c974e5cbc105$export$6d5f23d9118ad678
    ];

});
parcelRegister("5SoLX", function(module, exports) {

$parcel$export(module.exports, "getTeamPolicies", () => $b799f429216844e4$export$fead0944caa1c797);
$parcel$export(module.exports, "getGlobalPolicies", () => $b799f429216844e4$export$17fc7fbef061a8c3);
$parcel$export(module.exports, "getNotificationPolicies", () => $b799f429216844e4$export$342525d9423e55ad);
$parcel$export(module.exports, "getPolicyMaintenanceRights", () => $b799f429216844e4$export$f630cbf5586dce0a);
$parcel$export(module.exports, "updateUIPreferenceEndpoint", () => $b799f429216844e4$export$6a437b43ab11275d);
$parcel$export(module.exports, "changePolicyOrderEndpoint", () => $b799f429216844e4$export$57186d786c96b52a);
$parcel$export(module.exports, "enablePolicyEndpoint", () => $b799f429216844e4$export$6fecd226d8e55346);
$parcel$export(module.exports, "disablePolicyEndpoint", () => $b799f429216844e4$export$8c0cd218e00b7d9b);
$parcel$export(module.exports, "deletePolicyEndpoint", () => $b799f429216844e4$export$f9feac6c1dcc516f);
$parcel$export(module.exports, "createPolicyEndpoint", () => $b799f429216844e4$export$b0108c51b962e788);
$parcel$export(module.exports, "updatePolicyEndpoint", () => $b799f429216844e4$export$8eabce250a2dd205);

var $br21R = parcelRequire("br21R");
const $b799f429216844e4$export$fead0944caa1c797 = (teamId)=>{
    return (0, $br21R.eocFetch)(`/v1/teams/${teamId}/policies?type=alert`);
};
const $b799f429216844e4$export$17fc7fbef061a8c3 = (teamId)=>{
    if (teamId) return (0, $br21R.eocFetch)(`/v1/alerts/policies?preferredUITeamId=${teamId}`);
    return (0, $br21R.eocFetch)(`/v1/alerts/policies`);
};
const $b799f429216844e4$export$342525d9423e55ad = (teamId)=>{
    return (0, $br21R.eocFetch)(`/v1/teams/${teamId}/policies?type=notification`);
};
const $b799f429216844e4$export$f630cbf5586dce0a = ()=>{
    return (0, $br21R.eocFetch)(`/v1/alerts/ui-preferences/policy-maintenance-rights`);
};
const $b799f429216844e4$export$6a437b43ab11275d = ({ teamId: teamId, ...payload })=>{
    let url = `/v1/alerts/ui-preferences/policies`;
    if (teamId) url = `${url}?teamId=${teamId}`;
    return (0, $br21R.eocFetch)(url, {
        method: 'PATCH',
        body: payload,
        responseType: 'headers'
    });
};
const $b799f429216844e4$export$57186d786c96b52a = (payload)=>{
    return (0, $br21R.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/order`, {
        method: 'PATCH',
        body: {
            after: payload.after
        },
        responseType: 'headers'
    });
};
const $b799f429216844e4$export$6fecd226d8e55346 = (payload)=>{
    return (0, $br21R.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/enable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $b799f429216844e4$export$8c0cd218e00b7d9b = (payload)=>{
    return (0, $br21R.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/disable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $b799f429216844e4$export$f9feac6c1dcc516f = (payload)=>{
    return (0, $br21R.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $b799f429216844e4$export$b0108c51b962e788 = (payload)=>{
    return (0, $br21R.eocFetch)(`/v1/teams/${payload.teamId}/policies`, {
        method: 'POST',
        body: payload
    });
};
const $b799f429216844e4$export$8eabce250a2dd205 = (payload)=>{
    return (0, $br21R.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("io7oY", function(module, exports) {

$parcel$export(module.exports, "teamResource", () => $a4bff350b980f821$export$87453d709b90ccdf);
$parcel$export(module.exports, "sidebarRightsResource", () => $a4bff350b980f821$export$3b3b9a5b0eddde66);
$parcel$export(module.exports, "resources", () => $a4bff350b980f821$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $feIEW = parcelRequire("feIEW");
var $jXKdt = parcelRequire("jXKdt");

var $56lkR = parcelRequire("56lkR");
const $a4bff350b980f821$export$87453d709b90ccdf = (0, $l1VxS.createResource)({
    type: 'teamResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-dashboard/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $feIEW.assert)(!!teamId, new (0, $jXKdt.AssertionError)('teamSidebarResource', 'teamId should be set to fetch team-dashboard'));
        return (0, $56lkR.getTeamByIdEndpoint)(teamId).catch((e)=>{
            e.skipSentry = true;
            throw e;
        });
    },
    maxAge: 300000,
    isBrowserOnly: true
});
const $a4bff350b980f821$export$3b3b9a5b0eddde66 = (0, $l1VxS.createResource)({
    type: 'sidebarRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-dashboard/${teamId ?? ''}/sidebar-rights`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $feIEW.assert)(!!teamId, new (0, $jXKdt.AssertionError)('teamSidebarResource', 'teamId should be set to fetch sidebar rights'));
        return (0, $56lkR.getSidebarRightsEndpoint)(teamId).catch((e)=>{
            e.skipSentry = true;
            throw e;
        });
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $a4bff350b980f821$export$bc99aaabaf7b70a7 = ()=>[
        $a4bff350b980f821$export$87453d709b90ccdf,
        $a4bff350b980f821$export$3b3b9a5b0eddde66
    ];

});
parcelRegister("feIEW", function(module, exports) {

$parcel$export(module.exports, "assert", () => $2fd66e71a654981d$export$a7a9523472993e97);

var $jXKdt = parcelRequire("jXKdt");
/**
 * Throws when the condition is true
 * @param condition Condition to assert - can use type assertions thanks to ts's "asserts condition"
 * @param err An AssertionError object extending js error object
 */ const $2fd66e71a654981d$export$a7a9523472993e97 = function(condition, err) {
    if (!condition) throw err;
};

});
parcelRegister("jXKdt", function(module, exports) {

$parcel$export(module.exports, "AssertionError", () => $4b44ca8a753e56d8$export$7750cdfb4db2c3d);
class $4b44ca8a753e56d8$export$7750cdfb4db2c3d extends Error {
    constructor(id, message){
        super(`[${id}] ${message}`), this.id = id;
    }
}

});


parcelRegister("56lkR", function(module, exports) {

$parcel$export(module.exports, "getTeamByIdEndpoint", () => $026c47d2b6f5aae4$export$bcb25b347f39b3f3);
$parcel$export(module.exports, "getSidebarRightsEndpoint", () => $026c47d2b6f5aae4$export$6f1f62156c62eb91);

var $br21R = parcelRequire("br21R");
const $026c47d2b6f5aae4$export$bcb25b347f39b3f3 = (teamId)=>(0, $br21R.eocFetch)(`/v1/teams/${teamId}?includeImageUrls=true`);
const $026c47d2b6f5aae4$export$6f1f62156c62eb91 = (teamId)=>{
    return (0, $br21R.eocFetch)(`/v1/teams/${teamId}/menu-rights`);
};

});


parcelRegister("kHlOR", function(module, exports) {

$parcel$export(module.exports, "LazyAtlassianNavigation", () => $484a81aa80a53037$export$4caed23aa0274abb);

var $cJAh3 = parcelRequire("cJAh3");

var $dydef = parcelRequire("dydef");

var $gzcjr = parcelRequire("gzcjr");

const $484a81aa80a53037$export$4caed23aa0274abb = (0, $gzcjr.lazyForPaint)(()=>{
    const bundleReady = Promise.resolve((parcelRequire("96SSt"))).then(({ AtlassianNavigation: AtlassianNavigation })=>AtlassianNavigation);
    if (!false) bundleReady.then(()=>{
        (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $cJAh3.JS_EVAL_START))) {
            (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/index.tsx"
});

});
parcelRegister("dydef", function(module, exports) {

$parcel$export(module.exports, "setInitialPageLoadTimingFromPerformanceMarks", () => $b504faf7ce6f0cd0$export$15ca6669ae356831);
$parcel$export(module.exports, "stopInitialPageLoadTimingFromPerformanceMarkStart", () => $b504faf7ce6f0cd0$export$ab75d59423c060f4);
$parcel$export(module.exports, "measureInitialPageLoadTiming", () => $b504faf7ce6f0cd0$export$e18462760bac553c);
$parcel$export(module.exports, "setProductBundleReadyForInitialRender", () => $b504faf7ce6f0cd0$export$de1b4cf109d9ab65);

var $cQGWy = parcelRequire("cQGWy");

var $gC446 = parcelRequire("gC446");
/**
 * `performance.measure` will throw if start/stop aren't set.
 *
 * This call sets a user-timing on the profiler timelines so we can see sections of the load.
 */ const $b504faf7ce6f0cd0$var$safeMeasure = (name, start, stop)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.measure(name, start, stop);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
    } catch (_err) {}
};
const $b504faf7ce6f0cd0$export$15ca6669ae356831 = (name, start, stop, cleanStart = false, cleanStop = false)=>{
    if (false) return;
    $b504faf7ce6f0cd0$var$safeMeasure(name, start, stop);
    (0, $gC446.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stop);
    (0, $cQGWy.addTimingFromPerformanceMark)(name, start, stop, cleanStart, cleanStop);
};
const $b504faf7ce6f0cd0$export$ab75d59423c060f4 = (name, start, cleanStart = false)=>{
    if (false) return;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(stopMark);
    $b504faf7ce6f0cd0$var$safeMeasure(name, start, stopMark);
    (0, $gC446.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stopMark);
    (0, $cQGWy.addTimingFromPerformanceMark)(name, start, stopMark, cleanStart, true);
};
const $b504faf7ce6f0cd0$export$e18462760bac553c = (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = fn();
    performance.mark(stopMark);
    $b504faf7ce6f0cd0$var$safeMeasure(name, startMark, stopMark);
    (0, $gC446.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $cQGWy.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $b504faf7ce6f0cd0$export$53038a2e9d597818 = async (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = await fn();
    performance.mark(stopMark);
    (0, $gC446.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $cQGWy.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $b504faf7ce6f0cd0$export$de1b4cf109d9ab65 = ()=>{
    if (false) return;
    $b504faf7ce6f0cd0$export$ab75d59423c060f4('product.bundle-ready', 'jira-spa.js:eval-stop');
};

});


parcelRegister("c1Kop", function(module, exports) {

$parcel$export(module.exports, "LazyTeamDashboardSidebar", () => $4a26c3dc042851d2$export$a1b7c53ff39475a6);
$parcel$export(module.exports, "default", () => $4a26c3dc042851d2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $4a26c3dc042851d2$export$a1b7c53ff39475a6 = (0, $gzcjr.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("2dCHh")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/eoc-team-dashboard/src/index.tsx"
});
const $4a26c3dc042851d2$var$TeamDashboardSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "eocTeamDashboard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4a26c3dc042851d2$export$a1b7c53ff39475a6, null));
$4a26c3dc042851d2$var$TeamDashboardSidebar.displayName = 'TeamDashboardSidebar';
var $4a26c3dc042851d2$export$2e2bcd8739ae039 = $4a26c3dc042851d2$var$TeamDashboardSidebar;

});
parcelRegister("2dCHh", function(module, exports) {

let $19dad019308120b1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $19dad019308120b1$var$load("1VRB2"),
    $19dad019308120b1$var$load("bABhq"),
    $19dad019308120b1$var$load("iQCsR")
]).then(()=>parcelRequire('5LuJb'));

});


parcelRegister("GnSwp", function(module, exports) {

$parcel$export(module.exports, "LazyHorizontalOperationsNav", () => $ec25041ec319e5b9$export$409c821653bbc63b);
$parcel$export(module.exports, "LazyHorizontalOperationsOverviewNav", () => $ec25041ec319e5b9$export$82108adf6887e32e);
$parcel$export(module.exports, "AsyncHorizontalOperationsNav", () => $ec25041ec319e5b9$export$1eb785f071697cc5);
$parcel$export(module.exports, "AsyncHorizontalOperationsOverviewNav", () => $ec25041ec319e5b9$export$27e50c09ebb514f);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $ec25041ec319e5b9$export$409c821653bbc63b = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("6NN8A")).then(({ HorizontalOperationsNav: HorizontalOperationsNav })=>HorizontalOperationsNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/horizontal-nav-operations/src/ui/index.tsx"
});

const $ec25041ec319e5b9$export$82108adf6887e32e = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("6NN8A")).then(({ OverviewNav: OverviewNav })=>OverviewNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/horizontal-nav-operations/src/ui/index.tsx"
});
const $ec25041ec319e5b9$export$1eb785f071697cc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "horizontal-operations-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "asyncHorizontalOperationsNav",
        packageName: "jiraOperationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec25041ec319e5b9$export$409c821653bbc63b, null)));
const $ec25041ec319e5b9$export$27e50c09ebb514f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "horizontal-operations-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "asyncHorizontalOperationsOverviewNav",
        packageName: "jiraOperationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec25041ec319e5b9$export$82108adf6887e32e, null)));

});
parcelRegister("6NN8A", function(module, exports) {

let $4f3d6f5e70deb98a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4f3d6f5e70deb98a$var$load("9KERI").then(()=>parcelRequire('52F2e'));

});


parcelRegister("igwPu", function(module, exports) {

$parcel$export(module.exports, "opsTeamLayout", () => $7ca1ff23f01b3063$export$53dd27149810df73);

var $6dwgv = parcelRequire("6dwgv");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7ca1ff23f01b3063$var$RightSidebars = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("42OFk")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/right-sidebars/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7ca1ff23f01b3063$var$Onboarding = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("dDvYf")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/onboarding/index.tsx"
});
const $7ca1ff23f01b3063$export$53dd27149810df73 = (0, $6dwgv.createLayout)({
    get globalComponents () {
        return [
            $7ca1ff23f01b3063$var$Onboarding
        ];
    },
    rightSidebars: [
        $7ca1ff23f01b3063$var$RightSidebars
    ]
});

});
parcelRegister("42OFk", function(module, exports) {

let $2f1ea67376dc8945$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2f1ea67376dc8945$var$load("bC5I0").then(()=>parcelRequire('8Yee7'));

});

parcelRegister("dDvYf", function(module, exports) {

let $9ed7b79ab4011f49$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9ed7b79ab4011f49$var$load("tKQOJ").then(()=>parcelRequire('1xWR7'));

});


parcelRegister("foqWb", function(module, exports) {

$parcel$export(module.exports, "alertPoliciesRoute", () => $6e93536b27e73219$export$eab7ea9e54b67f16);
const $6e93536b27e73219$export$eab7ea9e54b67f16 = {
    name: 'eoc-team-policies',
    path: '/jira/ops/teams/:teamId/policies',
    exact: true
};

});

parcelRegister("fIZNm", function(module, exports) {

$parcel$export(module.exports, "LazyAlertPolicies", () => $3fe39b958e365a8c$export$3079046c31ee50f7);
$parcel$export(module.exports, "AlertPoliciesComponent", () => $3fe39b958e365a8c$export$882bdfb7e45bd440);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $3fe39b958e365a8c$export$3079046c31ee50f7 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("6Gyul")), {
    moduleId: "./src/packages/eoc/policies/src/index.tsx"
});
const $3fe39b958e365a8c$export$882bdfb7e45bd440 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3fe39b958e365a8c$export$3079046c31ee50f7,
        pageId: "async-jira-eoc-alert-policies",
        shouldShowSpinner: false
    });

});
parcelRegister("1F9cm", function(module, exports) {

$parcel$export(module.exports, "LazyPage", () => $115917303a5a4975$export$a18c9c3dd309b8e6);

var $eJOHy = parcelRequire("eJOHy");

var $6OSA0 = parcelRequire("6OSA0");

var $eSnSE = parcelRequire("eSnSE");

var $ch9En = parcelRequire("ch9En");

var $hih5V = parcelRequire("hih5V");

var $56O0g = parcelRequire("56O0g");

var $dTqD3 = parcelRequire("dTqD3");

var $lq8Ki = parcelRequire("lq8Ki");
const $115917303a5a4975$var$LOCATION = 'lazy-page';
const $115917303a5a4975$export$fb85bbdbfb3e6869 = ()=>null;
const $115917303a5a4975$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const Skeleton = route.skeleton || (shouldShowSpinner ? (0, $6OSA0.default) : $115917303a5a4975$export$fb85bbdbfb3e6869);
    (0, $eJOHy.useEffect)(()=>{
        if (route.isRedirect) (0, $eSnSE.default).safeWarnWithoutCustomerData($115917303a5a4975$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lq8Ki.ReportSSRFailOnUse), {
        pageId: pageId,
        fallbackId: "LazyPage"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null));
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "lazy_page_redirect",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Page, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $56O0g.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "lazy_page",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lq8Ki.DisableSSRFailDetection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Page, null)))));
};

});
parcelRegister("6OSA0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dece214507286a2$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $h1VbR = parcelRequire("h1VbR");

var $dPlS8 = parcelRequire("dPlS8");
function $9dece214507286a2$export$2e2bcd8739ae039({ testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1VbR.default), {
        name: "legacy-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9dece214507286a2$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9dece214507286a2$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPlS8.default), {
        size: "large",
        testId: testId
    }))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9dece214507286a2$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o _ae4v1h6o _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $9dece214507286a2$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1wpz1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("56O0g", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37d100a906af14f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $662Y6 = parcelRequire("662Y6");

var $6uWhG = parcelRequire("6uWhG");

var $5onjV = parcelRequire("5onjV");

var $2HxHL = parcelRequire("2HxHL");

var $9DwQv = parcelRequire("9DwQv");


var $eeVmH = parcelRequire("eeVmH");

var $dNyX9 = parcelRequire("dNyX9");
class $e37d100a906af14f$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    render() {
        const { children: children, pageId: pageId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eeVmH.default).Provider, {
            // @ts-expect-error - TS2322 - Type '{ pageId: string; onReady: (metricKeyForInitialRender: string, metricKeyForTransition: string, extra: { [key: string]: string | number | boolean; } | undefined, metric: BM3Metric) => void; onCustomMark: (markName: string) => void; }' is not assignable to type 'string'.
            value: {
                pageId: pageId,
                onReady: this.onReady,
                onCustomMark: this.onCustomMark
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5onjV.default), {
            op: this.onStart,
            args: [
                pageId
            ]
        }), children));
    }
    constructor(...args){
        super(...args), this.customMarks = [], this.onStart = ()=>{
            (0, $662Y6.default)((0, $2e47af044bce450a$export$56940a9488e85199));
            (0, $6uWhG.setMark)((0, $2e47af044bce450a$export$45c4b6bf7935c69a));
        }, this.onCustomMark = (markName)=>{
            (0, $6uWhG.setMark)((0, $dNyX9.getPrefixedMarkName)(markName));
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
            this.customMarks.push(markName);
        }, this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
            metric.stop({
                customData: extra
            });
            if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.stopLowPriorityEventDelay)();
        };
    }
}

});
parcelRegister("662Y6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8b8f5b498d09c66$export$2e2bcd8739ae039);

var $gPCSe = parcelRequire("gPCSe");
var /*
 * This utility finds all performance entries that is prefixed
 * with the `prefix` and does clearMarks on each entry.
 * All the entries that are cleared will be returned
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$a8b8f5b498d09c66$export$2e2bcd8739ae039 = (prefix)=>{
    // @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    if ((0, $gPCSe.default) && (0, $gPCSe.default).getEntries && (0, $gPCSe.default).clearMarks) return (0, $gPCSe.default)// @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    .getEntries()// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .filter((mark)=>mark.name.startsWith(prefix))// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .map((mark)=>{
        (0, $gPCSe.default).clearMarks(mark.name);
        return mark;
    });
    return [];
};

});

parcelRegister("5onjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7adc4a77c4e3fb86$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");
// eslint-disable-next-line jira/react/no-class-components
class $7adc4a77c4e3fb86$var$OpTrigger extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(this.props.args, nextProps.args);
    }
    componentDidUpdate() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $7adc4a77c4e3fb86$export$2e2bcd8739ae039 = $7adc4a77c4e3fb86$var$OpTrigger;

});

parcelRegister("2HxHL", function(module, exports) {

$parcel$export(module.exports, "stopLowPriorityEventDelay", () => $0d6f1ba58ae6ece0$export$a928755af449867);
$parcel$export(module.exports, "startLowPriorityEventDelay", () => $0d6f1ba58ae6ece0$export$8bb8df5a93e9525);
$parcel$export(module.exports, "default", () => $0d6f1ba58ae6ece0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $662Y6 = parcelRequire("662Y6");

var $6uWhG = parcelRequire("6uWhG");

var $8MHJG = parcelRequire("8MHJG");

var $2Mqjh = parcelRequire("2Mqjh");

var $jEvkf = parcelRequire("jEvkf");

var $9DwQv = parcelRequire("9DwQv");

const $0d6f1ba58ae6ece0$var$STOP_DELAY_TIMEOUT = 10000;
let $0d6f1ba58ae6ece0$var$stopDelayTimeout;
let $0d6f1ba58ae6ece0$var$lastDelayActionPromise = (0, $2Mqjh.getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
const $0d6f1ba58ae6ece0$export$a928755af449867 = ()=>{
    $0d6f1ba58ae6ece0$var$lastDelayActionPromise = $0d6f1ba58ae6ece0$var$lastDelayActionPromise.then((client)=>{
        if (!(0, $8MHJG.isEventDelayActive)()) return client;
        clearTimeout($0d6f1ba58ae6ece0$var$stopDelayTimeout);
        // stopLowPriorityEventDelay performs a flush of the delayed events,
        // so the delayed period needs to be marked as ended _before_ calling that method.
        (0, $6uWhG.setMark)((0, $f8c82f467f2e47ac$export$2d91d3eed1108e72));
        (0, $8MHJG.setEventDelayActive)(false);
        client.stopLowPriorityEventDelay();
        return client;
    });
};
const $0d6f1ba58ae6ece0$export$8bb8df5a93e9525 = ()=>{
    $0d6f1ba58ae6ece0$var$lastDelayActionPromise = $0d6f1ba58ae6ece0$var$lastDelayActionPromise.then((client)=>{
        // If startLowPriorityEventDelay is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!(0, $8MHJG.isEventDelayActive)()) {
            (0, $662Y6.default)((0, $f8c82f467f2e47ac$export$358721a9d6125914));
            (0, $6uWhG.setMark)((0, $f8c82f467f2e47ac$export$b2122dce85a27912));
        }
        client.startLowPriorityEventDelay();
        (0, $8MHJG.setEventDelayActive)(true);
        clearTimeout($0d6f1ba58ae6ece0$var$stopDelayTimeout);
        $0d6f1ba58ae6ece0$var$stopDelayTimeout = setTimeout($0d6f1ba58ae6ece0$export$a928755af449867, $0d6f1ba58ae6ece0$var$STOP_DELAY_TIMEOUT);
        return client;
    });
};
const $0d6f1ba58ae6ece0$export$778ebe2a4fab1ba7 = ()=>$0d6f1ba58ae6ece0$var$lastDelayActionPromise;
const $0d6f1ba58ae6ece0$var$EventDelayController = ()=>{
    const [loadedState] = (0, $jEvkf.default)();
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * The delay mechanism is currently locked so that only automatic exposure events
		 * can leverage it.
		 * We can remove the performance overhead of starting and stopping critical sections when
		 * these events won't be getting fired.
		 */ if (!loadedState.hasLoaded && (0, $9DwQv.isAutomaticExposureCollectionEnabled)()) $0d6f1ba58ae6ece0$export$8bb8df5a93e9525();
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
var $0d6f1ba58ae6ece0$export$2e2bcd8739ae039 = $0d6f1ba58ae6ece0$var$EventDelayController;

});
parcelRegister("8MHJG", function(module, exports) {

$parcel$export(module.exports, "setEventDelayActive", () => $477d32fa9a5520a7$export$9a4add6d6ddcc1a);
$parcel$export(module.exports, "isEventDelayActive", () => $477d32fa9a5520a7$export$3536b0184fa98d19);
let $477d32fa9a5520a7$var$eventDelayActive = false;
const $477d32fa9a5520a7$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
    $477d32fa9a5520a7$var$eventDelayActive = isEventDelayActive;
};
const $477d32fa9a5520a7$export$3536b0184fa98d19 = ()=>$477d32fa9a5520a7$var$eventDelayActive;

});

parcelRegister("jEvkf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ceb916e99bf85cf$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");


var $6XFSq = parcelRequire("6XFSq");
const $9ceb916e99bf85cf$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    const determineHasLoaded = ()=>{
        /*
		 * During a transition, the top navigation is the only app loading. Additionally, legacy pages generally
		 * render a LegacyPage component, analytics, or nothing at all.
		 *
		 * This code ensures that the page is considered loaded when the content has finished loading in the
		 * SPA, or when the top navigation has finished loading for legacy pages.
		 *
		 * Ideally the LegacyPage component should include an app for the content, but the usage of route components
		 * in legacy routes is inconsistent and would need thorough testing. This should be good enough for now.
		 */ if (appIds.length === 1 && appIds[0] === (0, $ceaa13d70a0542eb$export$3a54edb6ba4daa82)) return !__SPA__;
        return appIds.length ? appIds.filter((id)=>id !== (0, $ceaa13d70a0542eb$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
    };
    const hasLoaded = determineHasLoaded();
    return {
        hasLoaded: hasLoaded
    };
};
const $9ceb916e99bf85cf$var$usePageLoadedSubscriber = (0, $iJq0l.createHook)((0, $6XFSq.default), {
    selector: $9ceb916e99bf85cf$export$4a361c7505f72f5c
});
var $9ceb916e99bf85cf$export$2e2bcd8739ae039 = $9ceb916e99bf85cf$var$usePageLoadedSubscriber;

});
const $ceaa13d70a0542eb$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $ceaa13d70a0542eb$export$2ee9e5a3556c1e43 = 'SIDEBAR';


parcelRegister("9DwQv", function(module, exports) {

$parcel$export(module.exports, "isAutomaticExposureCollectionEnabled", () => $deb32d3e51fbc689$export$cf2aaf3c58e46848);
const $deb32d3e51fbc689$export$c9c75778ebadb3f1 = ()=>100;
const $deb32d3e51fbc689$export$cf2aaf3c58e46848 = ()=>true;

});

const $f8c82f467f2e47ac$export$358721a9d6125914 = 'event-delay-controller.';
const $f8c82f467f2e47ac$export$b2122dce85a27912 = `${$f8c82f467f2e47ac$export$358721a9d6125914}start`;
const $f8c82f467f2e47ac$export$2d91d3eed1108e72 = `${$f8c82f467f2e47ac$export$358721a9d6125914}end`;


const $2e47af044bce450a$export$56940a9488e85199 = 'jira.fe.spa-';
const $2e47af044bce450a$export$45c4b6bf7935c69a = `${$2e47af044bce450a$export$56940a9488e85199}start`;
const $2e47af044bce450a$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $2e47af044bce450a$export$ff834eccc35b9089 = 'appBundleReady';
const $2e47af044bce450a$export$86b05e34d462ead8 = 'prefetchApiReady';
const $2e47af044bce450a$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $2e47af044bce450a$export$3ae43cc1782d058f = 'jswRenderStart';
const $2e47af044bce450a$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $2e47af044bce450a$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $2e47af044bce450a$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $2e47af044bce450a$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $2e47af044bce450a$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $2e47af044bce450a$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $2e47af044bce450a$export$99c08ec92759c71c = 'tti-raf-mark';
const $2e47af044bce450a$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("eeVmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $03af3bc2e4718069$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $03af3bc2e4718069$var$contextName = 'SpaApdexAnalytics';
var $03af3bc2e4718069$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.createContext)($03af3bc2e4718069$var$contextName);

});

parcelRegister("dNyX9", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $63d33e770a180de1$export$c8f0e9837e7e9425);

const $63d33e770a180de1$export$c8f0e9837e7e9425 = (name)=>`${0, $2e47af044bce450a$export$56940a9488e85199}${name}`;

});


parcelRegister("dTqD3", function(module, exports) {

$parcel$export(module.exports, "SpaStateContainer", () => $79922c5ee50c1ff4$export$e9a92b877fe80e80);
$parcel$export(module.exports, "SpaStateAppStart", () => $79922c5ee50c1ff4$export$d18dd27183a635c);
$parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", () => $79922c5ee50c1ff4$export$95a2912d76fb5433);
$parcel$export(module.exports, "SpaStatePageReady", () => $79922c5ee50c1ff4$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $79922c5ee50c1ff4$export$41e70078eeddaddc);
$parcel$export(module.exports, "SpaStatePageErrorReady", () => $79922c5ee50c1ff4$export$2583aa269898885c);
$parcel$export(module.exports, "getSpaStateLastUserLocation", () => $79922c5ee50c1ff4$export$6e9ab893e97cccef);

var $eJOHy = parcelRequire("eJOHy");

var $kfvK2 = parcelRequire("kfvK2");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $14kUX = parcelRequire("14kUX");

var $il8Fk = parcelRequire("il8Fk");

var $6XFSq = parcelRequire("6XFSq");
const $79922c5ee50c1ff4$export$e9a92b877fe80e80 = (0, $6E16M.createContainer)((0, $6XFSq.default));
const $79922c5ee50c1ff4$export$d18dd27183a635c = ()=>{
    const startRef = (0, $eJOHy.useRef)(Date.now());
    const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, $il8Fk.useSpaState)();
    (0, $eJOHy.useMemo)(()=>{
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visitedPages
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        setAppStart(startRef.current);
    }, [
        setAppStart,
        visitedPages
    ]);
    return null;
};
const $79922c5ee50c1ff4$var$useRouterMatchSelector = (0, $kfvK2.createRouterSelector)((state)=>state.match);
const $79922c5ee50c1ff4$var$useSpaStatePagesCount = (0, $iJq0l.createHook)((0, $6XFSq.default), {
    selector: ({ visitedPages: visitedPages })=>visitedPages.length
});
const $79922c5ee50c1ff4$export$95a2912d76fb5433 = ()=>{
    const match = $79922c5ee50c1ff4$var$useRouterMatchSelector();
    const [count, { setAppStart: setAppStart }] = $79922c5ee50c1ff4$var$useSpaStatePagesCount();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($79922c5ee50c1ff4$export$ada7e0ec445851a2, {
        visitedPagesLength: count,
        onSetAppStart: setAppStart,
        match: match
    });
};
function $79922c5ee50c1ff4$export$c34439f945fccbdf() {
    const { setAppReady: setAppReady } = (0, $il8Fk.useSpaStateActions)();
    (0, $eJOHy.useEffect)(()=>{
        setAppReady();
    }, [
        setAppReady
    ]);
    return null;
}
function $79922c5ee50c1ff4$export$41e70078eeddaddc({ updateKey: updateKey }) {
    const { setAppReady: setAppReady } = (0, $il8Fk.useSpaStateActions)();
    (0, $eJOHy.useEffect)(()=>{
        setAppReady();
    }, [
        setAppReady,
        updateKey
    ]);
    return null;
}
function $79922c5ee50c1ff4$export$2583aa269898885c() {
    const { setAppErrorReady: setAppErrorReady } = (0, $il8Fk.useSpaStateActions)();
    (0, $eJOHy.useEffect)(()=>{
        setAppErrorReady();
    }, [
        setAppErrorReady
    ]);
    return null;
}
class $79922c5ee50c1ff4$export$ada7e0ec445851a2 extends (0, $eJOHy.Component) {
    static getDerivedStateFromProps(props, state) {
        const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
        const matchHasChanged = props.match !== state.match;
        const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
        if (setAppStart) props.onSetAppStart(Date.now());
        // On transition visitedPageLength will always change before match, the only exception is when there is page
        // ids (e.g. issue types). When redirecting, the length doesn't change while the match changes (from issuetype to issuetype/xxxxx).
        // so if match changed without visitedPageLength changing, cache the new match and wait for both to update.
        if (setAppStart || !visitedPageLengthHasChanged) return {
            started: true,
            visitedPagesLength: props.visitedPagesLength,
            match: props.match
        };
        // if visitedPageLength changed, ignore and wait for update in match (which will trigger setAppStart next)
        return state;
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args), /** so the challenge we are facing is that, we need to reset page when there's a visitedPagesLength change and a route change,
	 * but they don't always happen at the the same time during the current spa router situation. The following code does this:
	 *
	 * if first render: set app start
	 *
	 * if subsequently render with only visitedPagesLength change, ignore this updates, cache the old visitedPagesLength,
	 * wait for incoming match change
	 *
	 * if subsequently render with only match change, ignore this updates, cache the old match, wait for incoming
	 * visitedPagesLength change
	 *
	 *  if incoming changes contain both route and length change, we update state and start app
	 *
	 */ this.state = {
            visitedPagesLength: 0,
            started: false,
            match: null
        };
    }
}
const $79922c5ee50c1ff4$export$6e9ab893e97cccef = ()=>{
    const { visitedPages: visitedPages } = (0, $14kUX.defaultRegistry).getStore((0, $6XFSq.default)).storeState.getState();
    return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
};

});
parcelRegister("il8Fk", function(module, exports) {

$parcel$export(module.exports, "useSpaState", () => $a57dbe8751758d47$export$a57865516f6345d1);
$parcel$export(module.exports, "useSpaStateActions", () => $a57dbe8751758d47$export$b134752525935b78);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $6XFSq = parcelRequire("6XFSq");
const $a57dbe8751758d47$export$a57865516f6345d1 = (0, $iJq0l.createHook)((0, $6XFSq.default));
const $a57dbe8751758d47$export$b134752525935b78 = (0, $iJq0l.createActionsHook)((0, $6XFSq.default));

});


parcelRegister("lq8Ki", function(module, exports) {

$parcel$export(module.exports, "ReportSSRFailOnUse", () => $3331f614e25114ce$export$daa3f09a96683b19);
$parcel$export(module.exports, "DisableSSRFailDetection", () => $3331f614e25114ce$export$420f5a45dbda6a67);

var $eJOHy = parcelRequire("eJOHy");
const $3331f614e25114ce$export$daa3f09a96683b19 = ()=>{
    // this component does nothing. Its .server. version does
    return null;
};
const $3331f614e25114ce$export$420f5a45dbda6a67 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);

});


parcelRegister("6Gyul", function(module, exports) {

let $4de16b029e879dbf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $4de16b029e879dbf$var$load("1VRB2"),
    $4de16b029e879dbf$var$load("bABhq"),
    $4de16b029e879dbf$var$load("3QXqF")
]).then(()=>parcelRequire('62BDU'));

});



parcelRegister("iGXDp", function(module, exports) {

$parcel$export(module.exports, "applinksAdministrationEditRouteEntry", () => $553281c391405d7c$export$2bedce19ce74cc31);

var $5WMoK = parcelRequire("5WMoK");

var $bEyFu = parcelRequire("bEyFu");

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $7jTnu = parcelRequire("7jTnu");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $5fjzQ = parcelRequire("5fjzQ");
const $553281c391405d7c$export$2bedce19ce74cc31 = (0, $6xToB.createEntry)((0, $bEyFu.applinksAdministrationEditRoute), ()=>({
        group: 'global-settings',
        ufoName: 'applinks-administration',
        component: (0, $bJscI.componentWithFG)('applinks-933-new-applinks-frontend', (0, $5WMoK.default), (0, $9BJU1.default)),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>(0, $7jTnu.fg)('applinks-933-new-applinks-frontend'),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        meta: {
            reporting: {
                id: 'Applinks',
                packageName: 'jiraAdminPagesApplinks',
                teamName: 'olympus'
            }
        }
    }));

});
parcelRegister("5WMoK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5890f8a2a0798b1d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dTqD3 = parcelRequire("dTqD3");

var $16sa1 = parcelRequire("16sa1");

var $aV23b = parcelRequire("aV23b");

var $jJaSe = parcelRequire("jJaSe");

var $iOvkp = parcelRequire("iOvkp");
const $5890f8a2a0798b1d$var$EditPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "applinks-administration-edit-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iOvkp.default), {
        id: props.match.params.applinkId ?? null,
        ...props
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStatePageReady), null)));
var $5890f8a2a0798b1d$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)($5890f8a2a0798b1d$var$EditPage);

});
parcelRegister("aV23b", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $1d4b19068776b455$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "AuthenticationCheck", () => $1d4b19068776b455$export$e9b9096e887386fe);

var $eJOHy = parcelRequire("eJOHy");

var $lvKO5 = parcelRequire("lvKO5");

var $5ya7R = parcelRequire("5ya7R");
const $1d4b19068776b455$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
const $1d4b19068776b455$export$e9b9096e887386fe = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvKO5.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if ($1d4b19068776b455$export$b8dbb7d6029c5413(tenantContext)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5ya7R.RedirectToLoginPage), null);
    });

});
parcelRegister("5ya7R", function(module, exports) {

$parcel$export(module.exports, "RedirectToLoginPage", () => $3692ea1fd0794252$export$938182bd3fddc3a8);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
var $95O7y = parcelRequire("95O7y");
var $gCY1z = parcelRequire("gCY1z");
const $3692ea1fd0794252$export$3da29de62ed7a388 = ({ to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.location.assign("${to}")`
        }
    });
$3692ea1fd0794252$export$3da29de62ed7a388.displayName = 'InlineRedirect';
const $3692ea1fd0794252$export$938182bd3fddc3a8 = ()=>{
    const [{ location: { pathname: pathname, search: search } }] = (0, $gCY1z.useRouter)();
    const redirectUrl = pathname + search;
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    const parentProductQueryName = 'parentProduct';
    const [parentProduct] = (0, $95O7y.useQueryParam)(parentProductQueryName);
    if (pathname.endsWith('/embed')) {
        const searchParams = new URLSearchParams(search);
        // We need to remove parentProduct param as it is only used in embed urls
        searchParams.delete(parentProductQueryName);
        /**
		 * encodedLink is the link to the non embedded version of the embed url.
		 * So, we strip out the /embed suffix from path
		 */ let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
        /**
		 * this is the specific case for create issue embed, where we need to redirect
		 * user to your-work page with create issue as true to open GIC by default.
		 * We will remove this when we FPIC exp implemented for GIC
		 */ if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
        const encodedParentProduct = encodeURIComponent(parentProduct || '');
        path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
    }
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3692ea1fd0794252$export$3da29de62ed7a388, {
        to: path
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: path
    });
};

});


parcelRegister("iOvkp", function(module, exports) {

$parcel$export(module.exports, "default", () => $3679c3a616797707$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jJaSe = parcelRequire("jJaSe");

var $eSnSE = parcelRequire("eSnSE");

var $dk6v8 = parcelRequire("dk6v8");

var $d6B0e = parcelRequire("d6B0e");

var $fiWfm = parcelRequire("fiWfm");
const $3679c3a616797707$export$c2248d8896966a26 = (props)=>{
    const [applinkStatus, setApplinkStatus] = (0, $eJOHy.useState)(null);
    const [applinkEditPageData, setApplinkEditPageData] = (0, $eJOHy.useState)(null);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(true);
    (0, $eJOHy.useEffect)(()=>{
        const fetchApplinkData = async ()=>{
            setIsLoading(true);
            if (props.id === null) {
                (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $d6B0e.LOG_LOCATION), 'No applink ID provided');
                setApplinkEditPageData(null);
                setIsLoading(false);
                return;
            }
            try {
                const applinkData = await (0, $dk6v8.fetchApplink)(props.id);
                if (applinkData.system) {
                    setApplinkEditPageData({
                        kind: 'NOT_EDITABLE',
                        reason: 'This is an internal link created automatically by the system. System internal links are read-only and cannot be edited.'
                    });
                    return;
                }
                if (applinkData.data.isOAuth2) {
                    const configInfo = await (0, $dk6v8.getOAuth2ConfigInfo)(applinkData.id);
                    setApplinkEditPageData({
                        kind: 'OAUTH2',
                        applink: applinkData,
                        oauth2ConfigInfo: configInfo ?? null
                    });
                } else setApplinkEditPageData({
                    kind: 'OAUTH1',
                    applink: applinkData,
                    status: null
                });
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Unknown error');
                (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $d6B0e.LOG_LOCATION), 'Failed to fetch applink data', error);
                setApplinkEditPageData(null);
            } finally{
                setIsLoading(false);
            }
        };
        fetchApplinkData();
    }, [
        props.id
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const fetchStatus = async ()=>{
            if (props.id === null) {
                setApplinkStatus(null);
                return;
            }
            try {
                const status = await (0, $dk6v8.fetchApplinkStatus)(props.id);
                setApplinkStatus(status);
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Unknown error');
                (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $d6B0e.LOG_LOCATION), 'Failed to fetch applink status', error);
                setApplinkStatus(null);
            }
        };
        fetchStatus();
    }, [
        props.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fiWfm.default), {
        isLoading: isLoading,
        data: applinkEditPageData,
        status: applinkStatus
    });
};
var $3679c3a616797707$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)($3679c3a616797707$export$c2248d8896966a26);

});
parcelRegister("dk6v8", function(module, exports) {

$parcel$export(module.exports, "fetchApplinks", () => $2f3ebcd049804547$export$7d33a91e6040b0be);
$parcel$export(module.exports, "fetchApplink", () => $2f3ebcd049804547$export$83c7eee86d1c94d8);
$parcel$export(module.exports, "putApplinkOAuthOne3LOProvider", () => $2f3ebcd049804547$export$3dacb27b68ab90a0);
$parcel$export(module.exports, "putApplinkOAuthOne2LOProvider", () => $2f3ebcd049804547$export$5c11b39b43a73f24);
$parcel$export(module.exports, "putApplinkOAuthTwo3LOProvider", () => $2f3ebcd049804547$export$48939b944008c467);
$parcel$export(module.exports, "putApplinkOAuthTwo2LOProvider", () => $2f3ebcd049804547$export$8c0e2175e965c42f);
$parcel$export(module.exports, "fetchApplinkStatus", () => $2f3ebcd049804547$export$c2ced85273a49248);
$parcel$export(module.exports, "putApplinkOAuth1Config", () => $2f3ebcd049804547$export$6d608f63c710962a);
$parcel$export(module.exports, "fetchApplinkManifestForUrl", () => $2f3ebcd049804547$export$5c23e2a46ea336ab);
$parcel$export(module.exports, "fetchThisManifest", () => $2f3ebcd049804547$export$48b19736241944be);
$parcel$export(module.exports, "putApplink", () => $2f3ebcd049804547$export$a125e209bab7ab22);
$parcel$export(module.exports, "deleteApplink", () => $2f3ebcd049804547$export$feb8ae153e366f15);
$parcel$export(module.exports, "createOAuth2Applink", () => $2f3ebcd049804547$export$66ba448fdbc72aae);
$parcel$export(module.exports, "updateApplinkV3", () => $2f3ebcd049804547$export$56336a061718f25b);
$parcel$export(module.exports, "getOAuth2ConfigInfo", () => $2f3ebcd049804547$export$5647ab3ff2444637);
$parcel$export(module.exports, "putOAuth2ConfigInfo", () => $2f3ebcd049804547$export$d1898e36341527c0);
$parcel$export(module.exports, "autoConfigureApplinkConsumer", () => $2f3ebcd049804547$export$9e76392093878436);

var $1Ozm9 = parcelRequire("1Ozm9");

var $jGzN3 = parcelRequire("jGzN3");

var $d6B0e = parcelRequire("d6B0e");
const $2f3ebcd049804547$export$7d33a91e6040b0be = ()=>(0, $1Ozm9.default)((0, $d6B0e.APPLINKS_V3_QUERY_URL));
const $2f3ebcd049804547$export$83c7eee86d1c94d8 = (id)=>(0, $1Ozm9.default)((0, $d6B0e.APPLINKS_V3_QUERY_SINGULAR_URL)(id));
const $2f3ebcd049804547$var$putApplinkProvider = (id, provider)=>(0, $1Ozm9.default)(`/rest/applinks/3.0/applicationlink/${id}/authentication/provider`, {
        method: 'PUT',
        body: JSON.stringify({
            config: {},
            provider: provider
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$3dacb27b68ab90a0 = (id)=>$2f3ebcd049804547$var$putApplinkProvider(id, 'com.atlassian.applinks.api.auth.types.OAuthAuthenticationProvider');
const $2f3ebcd049804547$export$5c11b39b43a73f24 = (id)=>$2f3ebcd049804547$var$putApplinkProvider(id, 'com.atlassian.applinks.api.auth.types.TwoLeggedOAuthAuthenticationProvider');
const $2f3ebcd049804547$export$48939b944008c467 = (id)=>$2f3ebcd049804547$var$putApplinkProvider(id, 'com.atlassian.applinks.api.auth.types.ThreeLeggedOAuth2AuthenticationProvider');
const $2f3ebcd049804547$export$8c0e2175e965c42f = (id)=>$2f3ebcd049804547$var$putApplinkProvider(id, 'com.atlassian.applinks.api.auth.types.TwoLeggedOAuth2AuthenticationProvider');
const $2f3ebcd049804547$export$c2ced85273a49248 = (id)=>(0, $1Ozm9.default)(`/rest/applinks/3.0/status/${id}`);
const $2f3ebcd049804547$export$6d608f63c710962a = (id, oauthStatus)=>(0, $jGzN3.performPutRequest)(`/rest/applinks/3.0/status/${id}/oauth`, {
        body: JSON.stringify(oauthStatus),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$5c23e2a46ea336ab = (url)=>(0, $1Ozm9.default)(`/rest/applinks/3.0/applicationlinkForm/manifest.json?url=${encodeURIComponent(url)}`);
const $2f3ebcd049804547$export$48b19736241944be = ()=>(0, $1Ozm9.default)('/rest/applinks/3.0/manifest.json');
const $2f3ebcd049804547$export$a125e209bab7ab22 = (entity)=>(0, $1Ozm9.default)('/rest/applinks/3.0/applicationlink', {
        method: 'PUT',
        body: JSON.stringify(entity),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$feb8ae153e366f15 = (id)=>(0, $1Ozm9.default)(`/rest/applinks/3.0/applicationlink/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$66ba448fdbc72aae = (entity)=>(0, $1Ozm9.default)('/rest/applinks/3.0/applinks', {
        method: 'POST',
        body: JSON.stringify(entity),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$56336a061718f25b = (id, entity)=>(0, $jGzN3.performPutRequest)(`/rest/applinks/3.0/applinks/${id}`, {
        body: JSON.stringify(entity),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$5647ab3ff2444637 = (id)=>(0, $1Ozm9.default)(`/rest/applinks/3.0/applinks/${id}/oAuth2ConfigInfo`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$d1898e36341527c0 = (id, config)=>(0, $jGzN3.performPutRequest)(`/rest/applinks/3.0/applinks/${id}/oAuth2ConfigInfo`, {
        body: JSON.stringify(config),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$9e76392093878436 = (id)=>(0, $1Ozm9.default)(`/rest/applinks-oauth/1.0/applicationlink/${id}/authentication/consumer?autoConfigure=true`, {
        method: 'PUT',
        body: JSON.stringify({
            twoLOAllowed: true,
            executingTwoLOUser: null,
            twoLOImpersonationAllowed: false
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });

});
parcelRegister("d6B0e", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $95b0b9f64b46b209$export$25a759e49d5049db);
$parcel$export(module.exports, "APPLINKS_V3_QUERY_URL", () => $95b0b9f64b46b209$export$cb3573e4866c43b5);
$parcel$export(module.exports, "APPLINKS_V3_QUERY_SINGULAR_URL", () => $95b0b9f64b46b209$export$1f3cdd5be8767e2d);
$parcel$export(module.exports, "APPLINKS_LIST_PAGE_URL_LEGACY", () => $95b0b9f64b46b209$export$2802d3ce755ebd3d);
$parcel$export(module.exports, "APPLINKS_LIST_PAGE_URL", () => $95b0b9f64b46b209$export$4b42a32ba8ad826e);
$parcel$export(module.exports, "APPLINKS_EDIT_PAGE_URL_FOR_ID", () => $95b0b9f64b46b209$export$d55239c5fe633298);
$parcel$export(module.exports, "APPLINKS_IS_OAUTH2_SUPPORTED_PROVIDER_CHECK", () => $95b0b9f64b46b209$export$2b004bc5d3a0b021);
const $95b0b9f64b46b209$export$25a759e49d5049db = 'applinks.administration';
const $95b0b9f64b46b209$export$cb3573e4866c43b5 = '/rest/applinks/3.0/applinks?data=applicationVersion&data=atlassian&data=configUrl&data=iconUri&data=editable&data=v3Editable&data=webItems';
const $95b0b9f64b46b209$export$1f3cdd5be8767e2d = (id)=>`/rest/applinks/3.0/applinks/${id}?data=applicationVersion&data=atlassian&data=configUrl&data=iconUri&data=editable&data=v3Editable&data=webItems`;
const $95b0b9f64b46b209$export$2802d3ce755ebd3d = '/plugins/servlet/applinks/listApplicationLinks';
const $95b0b9f64b46b209$export$4b42a32ba8ad826e = '/jira/settings/applinks';
const $95b0b9f64b46b209$export$d55239c5fe633298 = (id)=>`/jira/settings/applinks/${id}/edit`;
const $95b0b9f64b46b209$export$2b004bc5d3a0b021 = 'com.atlassian.applinks.api.auth.types.ThreeLeggedOAuth2AuthenticationProvider';

});


parcelRegister("fiWfm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b549349dad026c92$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $dhRXV = parcelRequire("dhRXV");
var $9M9zY = parcelRequire("9M9zY");
var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");

var $dPlS8 = parcelRequire("dPlS8");

var $6vd3O = parcelRequire("6vd3O");

var $kQDPJ = parcelRequire("kQDPJ");

var $erdIZ = parcelRequire("erdIZ");
var $9bgYW = parcelRequire("9bgYW");

var $gfcvC = parcelRequire("gfcvC");

var $aoTms = parcelRequire("aoTms");

var $1KdDN = parcelRequire("1KdDN");

var $a9cht = parcelRequire("a9cht");

var $i0t2M = parcelRequire("i0t2M");

var $a4pY2 = parcelRequire("a4pY2");

var $d6B0e = parcelRequire("d6B0e");

var $eBoKt = parcelRequire("eBoKt");

var $40lC8 = parcelRequire("40lC8");
const $b549349dad026c92$var$styles = {
    applinksPageContents: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f5o3v _ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
const $b549349dad026c92$var$DisplayError = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $b549349dad026c92$var$styles.applinksPageContents
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6vd3O.default), {
        header: props.header,
        description: props.description,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kQDPJ.default), {
            href: "/plugins/servlet/applinks/listApplicationLinks",
            appearance: "primary"
        }, "See all application links")
    }));
};
const $b549349dad026c92$var$breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9bgYW.default), {
    onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $erdIZ.default), {
    text: "Application Links",
    key: "Application Links",
    href: (0, $d6B0e.APPLINKS_LIST_PAGE_URL)
}));
const $b549349dad026c92$var$ApplinksEditPageContents = (props)=>{
    const [errorFlags, setErrorFlags] = (0, $eJOHy.useState)([]);
    const addFlag = (0, $eJOHy.useCallback)((err)=>{
        const newFlags = errorFlags.slice();
        newFlags.splice(0, 0, err);
        setErrorFlags(newFlags);
    }, [
        errorFlags
    ]);
    const handleDismiss = ()=>{
        setErrorFlags(errorFlags.slice(1));
    };
    const getStatus = (0, $eJOHy.useCallback)(()=>{
        if (props.status === null) return 'loading';
        if (props.status.working) return 'connected';
        if (props.status.error && props.status.error.category === 'PARTIALLY_CONNECTED') return 'partially-connected';
        return 'error';
    }, [
        props.status
    ]);
    const renderContents = (0, $eJOHy.useCallback)(()=>{
        if (props.isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
            alignInline: "center",
            space: "space.100",
            xcss: $b549349dad026c92$var$styles.applinksPageContents
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPlS8.default), null));
        if (props.data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b549349dad026c92$var$DisplayError, {
            header: "Application link not found",
            description: "The application link you are trying to edit does not exist or has been deleted."
        });
        if (props.data.kind === 'NOT_EDITABLE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b549349dad026c92$var$DisplayError, {
            header: "Not Editable",
            description: props.data.reason
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            grow: "fill",
            xcss: $b549349dad026c92$var$styles.applinksPageContents
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gfcvC.default), {
            breadcrumbs: $b549349dad026c92$var$breadcrumbs
        }, "Edit application link"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, "Secured by", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
            as: "strong"
        }, props.data.applink.data.isOAuth2 ? 'OAuth 2.0' : 'OAuth 1.0')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0t2M.default), {
            applicationType: (0, $a4pY2.lookupTypeByTypeId)(props.data.applink.type, false),
            displayUrl: props.data.applink.displayUrl,
            heading: "Linked application",
            connectedStatus: getStatus()
        })), props.data.kind === 'OAUTH2' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eBoKt.default), {
            applink: props.data.applink,
            oauth2ConfigInfo: props.data.oauth2ConfigInfo,
            onDisplayError: addFlag
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $40lC8.default), {
            applink: props.data.applink,
            status: props.status,
            onDisplayError: addFlag
        }));
    }, [
        addFlag,
        getStatus,
        props.data,
        props.isLoading,
        props.status
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "applinks-administration-edit-page",
        teamName: "olympus",
        packageName: "applinksAdministrationEditPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aoTms.ModalContextProvider), null, renderContents()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.FlagGroup), {
        onDismissed: handleDismiss
    }, errorFlags.map((err, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.ErrorFlag), {
            id: `flag-${idx}`,
            key: `flag-${idx}`,
            title: "Failed to update application link",
            description: `An error occurred while updating the application link. ${err}`
        });
    }))));
};
var $b549349dad026c92$export$2e2bcd8739ae039 = $b549349dad026c92$var$ApplinksEditPageContents;

});
parcelRegister("erdIZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f90d63d298f160d2$export$2e2bcd8739ae039);
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8XtVW = parcelRequire("8XtVW");

var $9JB3T = parcelRequire("9JB3T");

var $k6cSv = parcelRequire("k6cSv");

var $hs7nK = parcelRequire("hs7nK");

var $hsfbW = parcelRequire("hsfbW");
const $f90d63d298f160d2$var$itemWrapperStyles = null;
const $f90d63d298f160d2$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $f90d63d298f160d2$var$ICON_WIDTH_ESTIMATE = 24;
const $f90d63d298f160d2$var$staticItemStyles = null;
const $f90d63d298f160d2$var$staticItemWithTruncationStyles = null;
const $f90d63d298f160d2$var$staticItemWithoutTruncationStyles = null;
const $f90d63d298f160d2$var$BreadcrumbsItem = /*#__PURE__*/ (0, $eJOHy.memo)(({ analyticsContext: analyticsContext, component: component, href: // `createAnalyticsEvent` should be here, but throws errors on render since
// it ends up being spread on a DOM element at the very end
href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, ref: // This is overridden by the `buttonRef` below
ref, target: target, testId: testId, text: text, truncationWidth: truncationWidth, // I believe there is only `createAnalyticsEvent` left on here, but leaving
// it here to allow this to be a patch and not a major
...rest })=>{
    const stepTextRef = (0, $eJOHy.useRef)(null);
    // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    let iconWidthAllowance = 0;
    if (iconBefore) iconWidthAllowance += $f90d63d298f160d2$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $f90d63d298f160d2$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, showTooltip] = (0, $hsfbW.default)(truncationWidth, stepTextRef.current, iconWidthAllowance);
    // This should be a part of staticItemStyles but it requires the !important flag to prevent the padding from being overridden by the button styles
    // compiled treats `${token(xxx)} !important` differently when concat !important in es2019 and esm built files
    // the padding and font weight were not sourced correctly in the esm build
    const buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    };
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$f90d63d298f160d2$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = !component && (0, $8XtVW.fg)('platform_dst_breadcrumbs_step_conversion') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6cSv.default), {
        ref: stepTextRef,
        analyticsContext: analyticsContext,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        target: target,
        testId: testId,
        truncationWidth: truncationWidth,
        children: text
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hs7nK.default), {
        ...rest,
        analyticsContext: analyticsContext,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: stepTextRef,
        target: target,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: truncationWidth ? {
            ...dynamicItemStyles,
            ...buttonOverrideStyles
        } : buttonOverrideStyles,
        className: (0, $hcewu.default)([
            "_vwz41txs",
            truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _ect41gqc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _15621n76 _191d1h6o"
        ]),
        children: showTooltip ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9JB3T.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f90d63d298f160d2$export$2e2bcd8739ae039 = $f90d63d298f160d2$var$BreadcrumbsItem;

});
parcelRegister("k6cSv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab70bcb0ecc5d86d$export$2e2bcd8739ae039);
/* step.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j2fEo = parcelRequire("j2fEo");

var $i7XOj = parcelRequire("i7XOj");

var $9pZRF = parcelRequire("9pZRF");

var $dPUtJ = parcelRequire("dPUtJ");
var $hBR2B = parcelRequire("hBR2B");
const $ab70bcb0ecc5d86d$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $ab70bcb0ecc5d86d$var$noop = (0, $9pZRF.default);
const $ab70bcb0ecc5d86d$var$styles = {
    root: "_11c82smr _19itglyw _zulp1b66 _2rkoglpi _4bfu18uv _1hmsglyw _ajmmnqa1 _1rjcv77o _18zrze3t _bfhk1w7a _syaz131l _1e0c116y _4cvr1h6o _1a3b18uv _4fprglyw _5goinqa1 _f8pj131l _9oik18uv _1bnx8stv _jf4cnqa1 _30l3131l _9h8h1fxt",
    withoutTruncation: "_1ul9idpf _1o9zkb7n",
    text: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
}; /**
    * __Step__
    *
    * A button that represents a single step in a breadcrumbs component.
    */ 
const $ab70bcb0ecc5d86d$var$Step = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ analyticsContext: analyticsContext, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $ab70bcb0ecc5d86d$var$noop, target: target, testId: testId, children: children, truncationWidth: truncationWidth }, ref)=>{
    const handleClick = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$ab70bcb0ecc5d86d$var$analyticsAttributes
    });
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            iconBefore,
            /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                ref: ref,
                className: (0, $hcewu.default)([
                    $ab70bcb0ecc5d86d$var$styles.text
                ]),
                children: children
            }),
            iconAfter
        ]
    });
    if (href) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dPUtJ.default), {
        href: href,
        onClick: handleClick,
        target: target,
        testId: testId,
        xcss: (0, $i7XOj.cx)($ab70bcb0ecc5d86d$var$styles.root, !truncationWidth && $ab70bcb0ecc5d86d$var$styles.withoutTruncation),
        style: {
            maxWidth: truncationWidth
        },
        children: content
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hBR2B.default), {
        onClick: handleClick,
        testId: testId,
        xcss: (0, $i7XOj.cx)($ab70bcb0ecc5d86d$var$styles.root, !truncationWidth && $ab70bcb0ecc5d86d$var$styles.withoutTruncation),
        style: {
            maxWidth: truncationWidth
        },
        children: content
    });
});
var $ab70bcb0ecc5d86d$export$2e2bcd8739ae039 = $ab70bcb0ecc5d86d$var$Step;

});

parcelRegister("hs7nK", function(module, exports) {

$parcel$export(module.exports, "default", () => $26b667de16b5b14b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j2fEo = parcelRequire("j2fEo");

var $dKpTa = parcelRequire("dKpTa");

var $9pZRF = parcelRequire("9pZRF");
const $26b667de16b5b14b$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $26b667de16b5b14b$var$noop = (0, $9pZRF.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $26b667de16b5b14b$var$StepOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $26b667de16b5b14b$var$noop, target: target, testId: testId, // Button does not take `createAnalyticsEvent`, but it is spread on anyway
...props }, ref)=>{
    const handleClicked = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$26b667de16b5b14b$var$analyticsAttributes
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dKpTa.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $26b667de16b5b14b$export$2e2bcd8739ae039 = $26b667de16b5b14b$var$StepOld;

});

parcelRegister("hsfbW", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc2c2728a00368cf$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $fc2c2728a00368cf$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $eJOHy.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $eJOHy.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $eJOHy.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});


parcelRegister("9bgYW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a9741bf396c0ef7$export$2e2bcd8739ae039);
/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j2fEo = parcelRequire("j2fEo");

var $i15ln = parcelRequire("i15ln");

var $9pZRF = parcelRequire("9pZRF");

var $8XtVW = parcelRequire("8XtVW");

var $bhefQ = parcelRequire("bhefQ");

var $kG01O = parcelRequire("kG01O");
const $0a9741bf396c0ef7$var$defaultMaxItems = 8;
const $0a9741bf396c0ef7$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $0a9741bf396c0ef7$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $0a9741bf396c0ef7$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children;
const $0a9741bf396c0ef7$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $0a9741bf396c0ef7$var$noop = (0, $9pZRF.default);
const $0a9741bf396c0ef7$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $0a9741bf396c0ef7$var$breadcrumbStyles = null;
const $0a9741bf396c0ef7$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $0a9741bf396c0ef7$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $0a9741bf396c0ef7$var$noop, analyticsContext: analyticsContext, label: label = $0a9741bf396c0ef7$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $0a9741bf396c0ef7$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $eJOHy.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $eJOHy.useState)(false);
    const wrapperRef = (0, $eJOHy.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $0a9741bf396c0ef7$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealed = ()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($0a9741bf396c0ef7$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    };
    const focusFirstRevealedMemoized = (0, $eJOHy.useCallback)(()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($0a9741bf396c0ef7$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $kG01O.useOnRevealed)((0, $8XtVW.fg)('jfp-magma-stability-platform-3') ? focusFirstRevealedMemoized : focusFirstRevealed, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$0a9741bf396c0ef7$var$analyticsAttributes
    });
    const childrenArray = $0a9741bf396c0ef7$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray; // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bhefQ.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("nav", {
        "aria-label": label,
        ref: (0, $i15ln.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("ol", {
            "data-testid": testId,
            className: (0, $hcewu.default)([
                "_1e0c1txw _1n261g80 _syaz1wmz _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
            ]),
            children: breadcrumbsItems
        })
    });
});
const $0a9741bf396c0ef7$var$Breadcrumbs = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)($0a9741bf396c0ef7$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        ref: ref,
        testId: testId
    }))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $0a9741bf396c0ef7$export$2e2bcd8739ae039 = $0a9741bf396c0ef7$var$Breadcrumbs;

});
parcelRegister("bhefQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7db2bba20db3e20$export$2e2bcd8739ae039);
/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dKpTa = parcelRequire("dKpTa");

var $9pZRF = parcelRequire("9pZRF");

var $8XtVW = parcelRequire("8XtVW");

var $hBR2B = parcelRequire("hBR2B");
const $b7db2bba20db3e20$var$noop = (0, $9pZRF.default);
const $b7db2bba20db3e20$var$itemWrapperStyles = null;
const $b7db2bba20db3e20$var$staticItemStyles = null;
const $b7db2bba20db3e20$var$styles = {
    root: "_11c82smr _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _zulp1b66 _2rkoglpi _4bfu18uv _1hmsglyw _ajmmnqa1 _bfhk1w7a _syaz131l _1e0c116y _4cvr1h6o _1a3b18uv _4fprglyw _5goinqa1 _f8pj131l _9oik18uv _1bnx8stv _jf4cnqa1 _30l3131l _9h8h1fxt"
};
const $b7db2bba20db3e20$var$EllipsisItem = /*#__PURE__*/ (0, $eJOHy.memo)(({ label: label, onClick: onClick = $b7db2bba20db3e20$var$noop, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("li", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _15621n76 _191d1h6o"
        ]),
        children: (0, $8XtVW.fg)('platform_dst_breadcrumbs_step_conversion') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hBR2B.default), {
            "aria-label": label,
            onClick: onClick,
            xcss: $b7db2bba20db3e20$var$styles.root,
            testId: testId,
            children: "\u2026"
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dKpTa.default), {
            appearance: "subtle-link",
            "aria-label": label,
            onClick: onClick,
            spacing: "none",
            testId: testId,
            className: (0, $hcewu.default)([
                "_1rjc1tvq _k48p1hhk _vwz41txs"
            ]),
            children: "\u2026"
        })
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b7db2bba20db3e20$export$2e2bcd8739ae039 = $b7db2bba20db3e20$var$EllipsisItem;

});

parcelRegister("kG01O", function(module, exports) {

$parcel$export(module.exports, "useOnRevealed", () => $cbea7544eb538d00$export$e9c4922b2ecf808a);

var $eJOHy = parcelRequire("eJOHy");

var $eRk6W = parcelRequire("eRk6W");
function $cbea7544eb538d00$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $eRk6W.default)(isExpanded);
    (0, $eJOHy.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});


parcelRegister("gfcvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f30f0c90ac1afba$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3P7A4 = parcelRequire("3P7A4");
const $8f30f0c90ac1afba$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3P7A4.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8f30f0c90ac1afba$var$ActionsWrapper, null, actions) : null
    });
var $8f30f0c90ac1afba$export$2e2bcd8739ae039 = $8f30f0c90ac1afba$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f30f0c90ac1afba$var$ActionsWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3P7A4", function(module, exports) {

$parcel$export(module.exports, "default", () => $285666e7de9b730b$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2DD68 = parcelRequire("2DD68");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $285666e7de9b730b$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2DD68.OuterWrapper), {
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2DD68.TitleWrapper), {
                truncateTitle: truncateTitle,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2DD68.TitleContainer), {
                        truncateTitle: truncateTitle,
                        children: disableTitleStyles ? children : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2DD68.StyledTitleWrapper), {
                            ref: innerRef,
                            truncateTitle: truncateTitle,
                            id: id,
                            testId: testId,
                            children: children
                        })
                    }),
                    actions && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2DD68.ActionsWrapper), {
                        children: actions
                    })
                ]
            }),
            bottomBar && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2DD68.BottomBarWrapper), {
                children: [
                    " ",
                    bottomBar,
                    " "
                ]
            })
        ]
    });
};
var $285666e7de9b730b$export$2e2bcd8739ae039 = $285666e7de9b730b$var$PageHeader;

});
parcelRegister("2DD68", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $a40e5ed159c9cc37$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $a40e5ed159c9cc37$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $a40e5ed159c9cc37$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $a40e5ed159c9cc37$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $a40e5ed159c9cc37$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $a40e5ed159c9cc37$export$6330225854c30dc);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $dhRXV = parcelRequire("dhRXV");
const $a40e5ed159c9cc37$var$styles = {
    bottomBar: "_1pfhpxbi"
};
const $a40e5ed159c9cc37$var$truncateStyles = null;
const $a40e5ed159c9cc37$var$outerStyles = null;
const $a40e5ed159c9cc37$var$titleStyles = null;
const $a40e5ed159c9cc37$var$titleWrapperStyles = null;
const $a40e5ed159c9cc37$var$titleWrapperTruncateStyles = null;
const $a40e5ed159c9cc37$var$titleContainerStyles = null;
const $a40e5ed159c9cc37$var$actionStyles = null;
const $a40e5ed159c9cc37$var$titleContainerTruncateStyles = null;
const $a40e5ed159c9cc37$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ]),
        children: children
    });
};
const $a40e5ed159c9cc37$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && `${testId}--title`,
        className: (0, $hcewu.default)([
            "_11c8nf1z _12ji1r31 _1qu2glyw _12y31o36 _syaz1fxt _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]),
        children: children
    });
});
const $a40e5ed159c9cc37$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1y6m _1n261q9c",
            truncateTitle && "_1n261q9c"
        ]),
        children: children
    });
};
const $a40e5ed159c9cc37$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc _1i4q1hna",
            truncateTitle && "_1o9zkb7n"
        ]),
        children: children
    });
};
const $a40e5ed159c9cc37$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ]),
        children: children
    });
};
const $a40e5ed159c9cc37$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
        xcss: $a40e5ed159c9cc37$var$styles.bottomBar,
        children: children
    });
};

});



parcelRegister("a9cht", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $3b59aa1149416ec4$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $3b59aa1149416ec4$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $3b59aa1149416ec4$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $3b59aa1149416ec4$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $3b59aa1149416ec4$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $3b59aa1149416ec4$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $3b59aa1149416ec4$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $3b59aa1149416ec4$export$a2c3479950310d7d);

var $eJOHy = parcelRequire("eJOHy");

var $xvuCV = parcelRequire("xvuCV");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3b59aa1149416ec4$var$ForPaintJiraCommonFlag = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("ist77")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3b59aa1149416ec4$var$AfterPaintJiraCommonFlag = (0, $gzcjr.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("ist77")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $3b59aa1149416ec4$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3b59aa1149416ec4$var$ForPaintFlagGroup = (0, $gzcjr.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("4P7Qq")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3b59aa1149416ec4$var$AfterPaintFlagGroup = (0, $gzcjr.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("4P7Qq")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $3b59aa1149416ec4$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$ForPaintFlagGroup, props);
const $3b59aa1149416ec4$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, props));
const $3b59aa1149416ec4$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $3b59aa1149416ec4$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $3b59aa1149416ec4$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $3b59aa1149416ec4$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $3b59aa1149416ec4$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $3b59aa1149416ec4$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $3b59aa1149416ec4$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$FlagGroupImpl, props));

});
parcelRegister("xvuCV", function(module, exports) {

$parcel$export(module.exports, "FlagsBoundary", () => $04814a5dcc217132$export$8b4a0fffcddd96f4);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");
const $04814a5dcc217132$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "flags",
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, children));

});

parcelRegister("ist77", function(module, exports) {

let $d7016cf1532ed912$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $d7016cf1532ed912$var$load("1VRB2"),
    $d7016cf1532ed912$var$load("bABhq"),
    $d7016cf1532ed912$var$load("7vqGd"),
    $d7016cf1532ed912$var$load("1Y4bq"),
    $d7016cf1532ed912$var$load("6EUYo")
]).then(()=>parcelRequire('jbDfJ'));

});

parcelRegister("4P7Qq", function(module, exports) {

let $3832029f55b3e3a6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3832029f55b3e3a6$var$load("62ZDN").then(()=>parcelRequire('1ZKRU'));

});


parcelRegister("i0t2M", function(module, exports) {

$parcel$export(module.exports, "default", () => $d774d2e7ba6299f2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6alcT = parcelRequire("6alcT");

var $9M9zY = parcelRequire("9M9zY");
var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");

var $bvFRW = parcelRequire("bvFRW");

var $dPlS8 = parcelRequire("dPlS8");
const $d774d2e7ba6299f2$var$styles = {
    productCard: "_2rkoglpi _1h6dmuej _1dqonqa1 _189ee4h9 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $d774d2e7ba6299f2$var$ProductCard = (props)=>{
    const { applicationType: applicationType, displayUrl: displayUrl, heading: heading } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
        xcss: $d774d2e7ba6299f2$var$styles.productCard,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "xxsmall"
    }, heading), props.connectedStatus === 'connected' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        appearance: "success"
    }, "Connected"), props.connectedStatus === 'not-connected' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        appearance: "removed"
    }, "Not Connected"), props.connectedStatus === 'partially-connected' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        appearance: "inprogress"
    }, "Partially Connected"), props.connectedStatus === 'error' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        appearance: "removed"
    }, "Config Error"), props.connectedStatus === 'loading' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPlS8.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        space: "space.100",
        alignBlock: "center"
    }, applicationType.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, displayUrl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
        color: "color.text.subtle",
        size: "small"
    }, applicationType.name))));
};
var $d774d2e7ba6299f2$export$2e2bcd8739ae039 = $d774d2e7ba6299f2$var$ProductCard;

});

parcelRegister("a4pY2", function(module, exports) {

$parcel$export(module.exports, "TypeIdMap", () => $a3964edb777cd90b$export$7b493295b4541cf7);
$parcel$export(module.exports, "lookupType", () => $a3964edb777cd90b$export$dd5c4190ef79bf3f);
$parcel$export(module.exports, "lookupTypeByTypeId", () => $a3964edb777cd90b$export$2d290ec50c4200c5);
$parcel$export(module.exports, "lookupTypeFromV3Data", () => $a3964edb777cd90b$export$2e1f91665918e370);

var $eJOHy = parcelRequire("eJOHy");

var $8uw8h = parcelRequire("8uw8h");

var $L2KhS = parcelRequire("L2KhS");
const $a3964edb777cd90b$export$7b493295b4541cf7 = {
    jira: {
        name: 'Jira',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8uw8h.JiraIcon), {
            size: "small",
            shouldUseNewLogoDesign: true,
            label: "Jira Cloud"
        }),
        category: 'cloud'
    },
    confluence: {
        name: 'Confluence',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8uw8h.ConfluenceIcon), {
            size: "small",
            shouldUseNewLogoDesign: true,
            label: "Confluence Cloud"
        }),
        category: 'cloud'
    },
    'jira-dc': {
        name: 'Jira DC',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8uw8h.JiraDataCenterIcon), {
            size: "small",
            shouldUseNewLogoDesign: true,
            label: "Jira DC"
        }),
        category: 'dc'
    },
    'confluence-dc': {
        name: 'Confluence DC',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8uw8h.ConfluenceDataCenterIcon), {
            size: "small",
            shouldUseNewLogoDesign: true,
            label: "Confluence DC"
        }),
        category: 'dc'
    },
    bitbucket: {
        name: 'Bitbucket DC',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8uw8h.BitbucketDataCenterIcon), {
            size: "small",
            shouldUseNewLogoDesign: true,
            label: "Bitbucket DC"
        }),
        category: 'dc'
    },
    bamboo: {
        name: 'Bamboo',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8uw8h.BambooIcon), {
            size: "small",
            shouldUseNewLogoDesign: true,
            label: "Bamboo"
        }),
        category: 'dc'
    },
    generic: {
        name: 'External Application',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($L2KhS))), {
            label: "External Application"
        }),
        category: 'generic'
    }
};
const $a3964edb777cd90b$export$dd5c4190ef79bf3f = (dcAwareTypeId)=>{
    return $a3964edb777cd90b$export$7b493295b4541cf7[dcAwareTypeId] || $a3964edb777cd90b$export$7b493295b4541cf7.generic;
};
const $a3964edb777cd90b$export$2d290ec50c4200c5 = (typeid, isDataCenter)=>{
    // Handle stash=bitbucket alias
    if (typeid === 'stash') return $a3964edb777cd90b$export$dd5c4190ef79bf3f('bitbucket');
    // Handle DC types
    if ((typeid === 'jira' || typeid === 'confluence') && isDataCenter) return $a3964edb777cd90b$export$dd5c4190ef79bf3f(`${typeid}-dc`);
    return $a3964edb777cd90b$export$dd5c4190ef79bf3f(typeid);
};
const $a3964edb777cd90b$export$2e1f91665918e370 = (link)=>{
    const type = link.type;
    // TODO: We can determine if it's DC, but how?
    // if (link.data.applicationVersion !== undefined) {
    // 	type += '-dc';
    // }
    return $a3964edb777cd90b$export$2d290ec50c4200c5(type, false);
};

});

parcelRegister("eBoKt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cf043cca0be813d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $dhRXV = parcelRequire("dhRXV");
var $9M9zY = parcelRequire("9M9zY");
var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");

var $jtnjR = parcelRequire("jtnjR");
var $1Xk9R = parcelRequire("1Xk9R");
var $emAda = parcelRequire("emAda");

var $pUkPE = parcelRequire("pUkPE");

var $alkjW = parcelRequire("alkjW");
var $kQDPJ = parcelRequire("kQDPJ");

var $6r8zo = parcelRequire("6r8zo");

var $aIgra = parcelRequire("aIgra");

var $51Gwp = parcelRequire("51Gwp");

var $ajkvN = parcelRequire("ajkvN");

var $83DiZ = parcelRequire("83DiZ");

var $7jTnu = parcelRequire("7jTnu");

var $8SMrZ = parcelRequire("8SMrZ");

var $ffsuj = parcelRequire("ffsuj");

var $dk6v8 = parcelRequire("dk6v8");

var $d6B0e = parcelRequire("d6B0e");

var $5zNo1 = parcelRequire("5zNo1");
const $4cf043cca0be813d$var$styles = {
    growField: "_16jlkb7n",
    dividerStyle: "_189ee4h9 _1dqonqa1 _1h6dmuej _1bsb1osq _19pkpxbi",
    formSectionInner: "_19pkpxbi"
};
const $4cf043cca0be813d$var$IncomingCredentialsModalButton = (props)=>{
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            applink: props.applink,
            onDisplayError: props.onDisplayError
        }), [
        props.applink,
        props.onDisplayError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajkvN.ModalButtonTrigger), {
        name: "updateIncomingLinkCredentials",
        entryPoint: (0, $5zNo1.incomingCredentialsModalEntryPoint),
        entryPointProps: entryPointProps,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($6r8zo)))
    }, "Update incoming link credentials");
};
const $4cf043cca0be813d$var$ApplinksOAuth2EditPageContents = (props)=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const getListPageUrl = (0, $eJOHy.useCallback)(()=>{
        if ((0, $7jTnu.fg)('applinks-933-experimental-list-page')) return 0, $d6B0e.APPLINKS_LIST_PAGE_URL;
        return 0, $d6B0e.APPLINKS_LIST_PAGE_URL_LEGACY;
    }, []);
    const onFormSubmit = (0, $eJOHy.useCallback)(async (data)=>{
        try {
            const applinkUpdate = {
                id: props.applink.id,
                type: props.applink.type,
                system: props.applink.system,
                primary: props.applink.primary,
                isExtraAuthRequired: props.applink.isExtraAuthRequired,
                rpcUrl: props.applink.rpcUrl,
                // Only change these properties:
                name: data.displayName,
                displayUrl: data.displayUrl
            };
            const scopes = data.remoteApplicationSupportedScopes ? data.remoteApplicationSupportedScopes.map((scope)=>scope.value) : [];
            const oauth2ConfigUpdate = {
                remoteClientId: data.applicationClientId,
                remoteClientSecret: data.applicationClientSecret,
                remoteRedirectUrl: data.redirectUrl,
                outboundScopes: scopes
            };
            await (0, $dk6v8.updateApplinkV3)(props.applink.id, applinkUpdate);
            await (0, $dk6v8.putOAuth2ConfigInfo)(props.applink.id, oauth2ConfigUpdate);
            push(getListPageUrl());
        } catch (err) {
            props.onDisplayError(err instanceof Error ? err.message : 'Unknown error');
        }
    }, [
        getListPageUrl,
        props,
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtnjR.default), {
        onSubmit: onFormSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emAda.default), {
            title: "Link details"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            space: "space.200",
            xcss: $4cf043cca0be813d$var$styles.formSectionInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.DisplayName), {
            name: "displayName",
            defaultName: props.applink.name
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.DisplayUrl), {
            name: "displayUrl",
            defaultUrl: props.applink.displayUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.ApplicationUrl), {
            name: "rpcUrl",
            defaultUrl: props.applink.rpcUrl,
            disabled: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("hr", {
            role: "presentation",
            className: (0, $hcewu.default)([
                $4cf043cca0be813d$var$styles.dividerStyle
            ])
        }), props.partiallyLinkedMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIgra.default), {
            title: "Continue linking to the external application"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, "In order to complete the link, enter the credentials for the incoming and outgoing links below.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emAda.default), {
            title: "Outgoing link",
            description: "Copy these details to the external application. If you're not an admin of the application, ask an existing admin to make the updates for you."
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            space: "space.200",
            xcss: $4cf043cca0be813d$var$styles.formSectionInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
            xcss: $4cf043cca0be813d$var$styles.growField
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.CopyableApplicationClientID), {
            name: "copyableApplicationClientId",
            clientId: props.oauth2ConfigInfo?.inboundOAuthClientId || ''
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
            xcss: $4cf043cca0be813d$var$styles.growField
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.CopyableApplicationClientSecret), {
            name: "copyableApplicationClientSecret",
            clientSecret: props.oauth2ConfigInfo?.inboundOAuthClientSecret || ''
        }))), !props.oauth2ConfigInfo.isRemoteApplicationCloud && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.RemoteApplicationScopeMultiSelect), {
            name: "remoteApplicationSupportedScopes",
            supportedScopes: props.oauth2ConfigInfo?.remoteApplicationSupportedScopes || [],
            defaultSelected: props.oauth2ConfigInfo?.outboundScopes?.map((scope)=>({
                    label: scope,
                    value: scope
                })) || []
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emAda.default), {
            title: "Incoming link",
            description: "Find these details in the external application and enter them below. You may need to ask an admin of the external application for these details."
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            space: "space.200",
            xcss: $4cf043cca0be813d$var$styles.formSectionInner
        }, props.partiallyLinkedMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
            xcss: $4cf043cca0be813d$var$styles.growField
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.ApplicationClientId), {
            name: "applicationClientId"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
            xcss: $4cf043cca0be813d$var$styles.growField
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.ApplicationClientSecret), {
            name: "applicationClientSecret"
        })))), !props.oauth2ConfigInfo.isRemoteApplicationCloud && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.RedirectUrl), {
            name: "redirectUrl",
            defaultRedirectUrl: props.oauth2ConfigInfo?.inboundRedirectUrl || ''
        }), !props.partiallyLinkedMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4cf043cca0be813d$var$IncomingCredentialsModalButton, {
            applink: props.applink,
            onDisplayError: props.onDisplayError
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
            href: (0, $ffsuj.getApplinksAdminUrl)(props.applink.displayUrl, props.applink.type),
            target: "_blank"
        }, "Go to ", props.applink.displayUrl))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Xk9R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $pUkPE.default), {
            label: "Form submit options"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kQDPJ.default), {
            href: getListPageUrl(),
            appearance: "subtle"
        }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
            type: "submit",
            appearance: "primary",
            isLoading: submitting
        }, "Save")))))));
};
var $4cf043cca0be813d$export$2e2bcd8739ae039 = $4cf043cca0be813d$var$ApplinksOAuth2EditPageContents;

});
parcelRegister("jtnjR", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $bb33f180c6311b07$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $bb33f180c6311b07$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $bb33f180c6311b07$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kOCbD = parcelRequire("kOCbD");

var $dPWTT = parcelRequire("dPWTT");

var $d3vFW = parcelRequire("d3vFW");

var $8XtVW = parcelRequire("8XtVW");
const $bb33f180c6311b07$export$c24727297075ec6a = /*#__PURE__*/ (0, $eJOHy.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $bb33f180c6311b07$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
function $bb33f180c6311b07$export$2e2bcd8739ae039(props) {
    const { formProps: userProvidedFormProps, onSubmit: onSubmit } = props;
    const formRef = (0, $eJOHy.useRef)(null);
    const onSubmitRef = (0, $eJOHy.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, $eJOHy.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $kOCbD.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(values, name, value);
                    }
                }
            }
        });
        (0, $dPWTT.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eJOHy.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eJOHy.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eJOHy.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eJOHy.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: formRef
    };
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        } else return (0, $8XtVW.fg)('platform_design-system-team_form-upgrade') ? /*#__PURE__*/ (0, $gt9Am.jsx)("form", {
            ...formProps,
            ...userProvidedFormProps,
            children: children
        }) : children;
    })();
    return /*#__PURE__*/ (0, $gt9Am.jsx)($bb33f180c6311b07$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($bb33f180c6311b07$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
}

});
parcelRegister("kOCbD", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f276193df2f288e0$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f276193df2f288e0$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f276193df2f288e0$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f276193df2f288e0$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f276193df2f288e0$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f276193df2f288e0$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f276193df2f288e0$export$f681a8129d2e9d28);

var $fpB9r = parcelRequire("fpB9r");

var $2unhp = parcelRequire("2unhp");
//      
var $f276193df2f288e0$var$charCodeOfDot = ".".charCodeAt(0);
var $f276193df2f288e0$var$reEscapeChar = /\\(\\)?/g;
var $f276193df2f288e0$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f276193df2f288e0$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f276193df2f288e0$var$charCodeOfDot) result.push("");
    string.replace($f276193df2f288e0$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f276193df2f288e0$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f276193df2f288e0$var$keysCache = {};
var $f276193df2f288e0$var$keysRegex = /[.[\]]+/;
var $f276193df2f288e0$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f276193df2f288e0$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f276193df2f288e0$var$keysCache[key] = key.split($f276193df2f288e0$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f276193df2f288e0$var$keysCache[key] = $f276193df2f288e0$var$stringToPath(key);
    }
    return $f276193df2f288e0$var$keysCache[key];
};
//      
var $f276193df2f288e0$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f276193df2f288e0$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f276193df2f288e0$var$_toPropertyKey(arg) {
    var key = $f276193df2f288e0$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f276193df2f288e0$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f276193df2f288e0$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $2unhp.default)(current, [
                key
            ].map($f276193df2f288e0$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $fpB9r.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f276193df2f288e0$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f276193df2f288e0$var$setInRecursor(state, 0, $f276193df2f288e0$var$toPath(key), value1, destroyArrays);
};
var $f276193df2f288e0$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f276193df2f288e0$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f276193df2f288e0$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f276193df2f288e0$export$c52e5867d5879e24(values, name);
    var error = $f276193df2f288e0$export$c52e5867d5879e24(errors, name);
    if (error && error[$f276193df2f288e0$export$735bebc8ffabf28a]) error = error[$f276193df2f288e0$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f276193df2f288e0$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f276193df2f288e0$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f276193df2f288e0$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f276193df2f288e0$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f276193df2f288e0$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f276193df2f288e0$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f276193df2f288e0$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f276193df2f288e0$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f276193df2f288e0$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f276193df2f288e0$var$subscriptionFilter(result, state, previousState, subscription, $f276193df2f288e0$export$41e855cb628c1b55, $f276193df2f288e0$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f276193df2f288e0$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f276193df2f288e0$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f276193df2f288e0$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f276193df2f288e0$var$subscriptionFilter(result, state, previousState, subscription, $f276193df2f288e0$export$f1ff97b9d1c7a3c3, $f276193df2f288e0$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f276193df2f288e0$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f276193df2f288e0$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f276193df2f288e0$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f276193df2f288e0$export$83d89fbfd8236492 = "4.20.10";
var $f276193df2f288e0$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f276193df2f288e0$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f276193df2f288e0$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f276193df2f288e0$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f276193df2f288e0$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f276193df2f288e0$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f276193df2f288e0$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f276193df2f288e0$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f276193df2f288e0$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f276193df2f288e0$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $fpB9r.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $fpB9r.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $fpB9r.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $fpB9r.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $fpB9r.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f276193df2f288e0$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f276193df2f288e0$export$e6bdf135a54e021b,
                    shallowEqual: $f276193df2f288e0$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $fpB9r.default)({}, state.formState.values)); // clone to avoid writing
            if ($f276193df2f288e0$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f276193df2f288e0$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f276193df2f288e0$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $fpB9r.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $fpB9r.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f276193df2f288e0$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f276193df2f288e0$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f276193df2f288e0$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f276193df2f288e0$export$735bebc8ffabf28a]) {
                    var existing = $f276193df2f288e0$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f276193df2f288e0$export$735bebc8ffabf28a] = error[$f276193df2f288e0$export$735bebc8ffabf28a];
                    merged = $f276193df2f288e0$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f276193df2f288e0$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f276193df2f288e0$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $fpB9r.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f276193df2f288e0$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f276193df2f288e0$var$notify(fieldSubscriber, fieldState, lastFieldState, $f276193df2f288e0$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f276193df2f288e0$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $fpB9r.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f276193df2f288e0$export$c52e5867d5879e24(formState.values, key), $f276193df2f288e0$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f276193df2f288e0$export$c52e5867d5879e24(formState.values, key), $f276193df2f288e0$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f276193df2f288e0$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f276193df2f288e0$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f276193df2f288e0$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f276193df2f288e0$var$notify(state.subscribers, nextFormState, lastFormState, $f276193df2f288e0$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $fpB9r.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f276193df2f288e0$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $fpB9r.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $fpB9r.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f276193df2f288e0$export$c52e5867d5879e24(formState.values, key), $f276193df2f288e0$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f276193df2f288e0$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f276193df2f288e0$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f276193df2f288e0$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, name) === $f276193df2f288e0$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f276193df2f288e0$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $fpB9r.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $fpB9r.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $fpB9r.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f276193df2f288e0$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f276193df2f288e0$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $fpB9r.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f276193df2f288e0$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f276193df2f288e0$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f276193df2f288e0$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f276193df2f288e0$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("dPWTT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a12dba3049b97319$export$2e2bcd8739ae039);

var $kOCbD = parcelRequire("kOCbD");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $a12dba3049b97319$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $a12dba3049b97319$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($a12dba3049b97319$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $a12dba3049b97319$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $kOCbD.getIn)(errors, input.name);
    });
};
//      
var $a12dba3049b97319$var$noop = function noop() {};
var $a12dba3049b97319$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $a12dba3049b97319$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $a12dba3049b97319$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $a12dba3049b97319$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $a12dba3049b97319$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($a12dba3049b97319$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$a12dba3049b97319$export$2e2bcd8739ae039 = $a12dba3049b97319$var$createDecorator;

});

parcelRegister("d3vFW", function(module, exports) {

var $j4TC7 = parcelRequire("j4TC7");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $981420477fbe9257$var$set(object, path, value) {
    return object == null ? object : $j4TC7(object, path, value);
}
module.exports = $981420477fbe9257$var$set;

});


parcelRegister("1Xk9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a78bcc948ec654c$export$2e2bcd8739ae039);
/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $9a78bcc948ec654c$var$formFooterWrapperStyles = null;
const $9a78bcc948ec654c$var$justifyContentStyles = null;
function $9a78bcc948ec654c$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("footer", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});

parcelRegister("emAda", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdb30c06fb37cc3a$export$2e2bcd8739ae039);
/* form-section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $bvFRW = parcelRequire("bvFRW");
const $bdb30c06fb37cc3a$var$formSectionDescriptionStyles = null;
const $bdb30c06fb37cc3a$var$formSectionWrapperStyles = null;
const $bdb30c06fb37cc3a$var$FormSectionWrapper = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1pfh1ejb"
        ]),
        children: children
    });
};
const $bdb30c06fb37cc3a$var$FormSectionDescription = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1pfhu2gc"
        ]),
        children: children
    });
};
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $bdb30c06fb37cc3a$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)($bdb30c06fb37cc3a$var$FormSectionWrapper, {
        children: [
            title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvFRW.default), {
                size: "medium",
                children: title
            }),
            description && /*#__PURE__*/ (0, $gt9Am.jsx)($bdb30c06fb37cc3a$var$FormSectionDescription, {
                children: description
            }),
            children
        ]
    });
};
var $bdb30c06fb37cc3a$export$2e2bcd8739ae039 = $bdb30c06fb37cc3a$var$FormSection;

});

parcelRegister("6r8zo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4afbe97c2c5abb72$var$_react = $4afbe97c2c5abb72$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4afbe97c2c5abb72$var$_baseNew = $4afbe97c2c5abb72$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $4afbe97c2c5abb72$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4afbe97c2c5abb72$var$EditIcon = (props)=>/*#__PURE__*/ $4afbe97c2c5abb72$var$_react.default.createElement($4afbe97c2c5abb72$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$4afbe97c2c5abb72$var$EditIcon.displayName = 'EditIcon';
var $4afbe97c2c5abb72$var$_default = module.exports.default = $4afbe97c2c5abb72$var$EditIcon;

});

parcelRegister("aIgra", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ee40beb30eb4c49$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4BzUI = parcelRequire("4BzUI");

var $bvFRW = parcelRequire("bvFRW");

var $g17XP = parcelRequire("g17XP");

var $8XtVW = parcelRequire("8XtVW");

var $9M9zY = parcelRequire("9M9zY");
var $aRh7I = parcelRequire("aRh7I");

var $eygST = parcelRequire("eygST");
const $1ee40beb30eb4c49$var$sectionMessageStyles = {
    container: "_2rkoglpi _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_19pk1i6y"
};
const $1ee40beb30eb4c49$var$appearanceStyles = {
    information: "_bfhk33gi",
    warning: "_bfhk1tzq",
    error: "_bfhk1gly",
    success: "_bfhkmv6i",
    discovery: "_bfhk1nvp"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $1ee40beb30eb4c49$var$SectionMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, isDismissible: isDismissible, testId: testId }, ref) {
    const [dismissed, setDismissed] = (0, $eJOHy.useState)(false);
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        setDismissed(true);
    }, []);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $eygST.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, $eJOHy.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $eJOHy.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, $gt9Am.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            $1ee40beb30eb4c49$var$sectionMessageStyles.container,
            $1ee40beb30eb4c49$var$appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9M9zY.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1ee40beb30eb4c49$var$sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $aRh7I.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    xcss: $1ee40beb30eb4c49$var$sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvFRW.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $1ee40beb30eb4c49$var$sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9M9zY.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: (0, $8XtVW.fg)('platform_ads_explicit_font_styles') && $1ee40beb30eb4c49$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9M9zY.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1ee40beb30eb4c49$var$sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
                        testId: testId && `${testId}--dismiss-button`,
                        label: "Dismiss",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g17XP))),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
$1ee40beb30eb4c49$var$SectionMessage.displayName = 'SectionMessage';
var $1ee40beb30eb4c49$export$2e2bcd8739ae039 = $1ee40beb30eb4c49$var$SectionMessage;

});
parcelRegister("eygST", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $6569b34ea74f05a3$export$e9b82d2e21ac0c1f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aVKq8 = parcelRequire("aVKq8");

var $cMyAt = parcelRequire("cMyAt");

var $Svlt9 = parcelRequire("Svlt9");

var $lU1m0 = parcelRequire("lU1m0");

var $gmIOk = parcelRequire("gmIOk");

var $kibFU = parcelRequire("kibFU");

var $8XtVW = parcelRequire("8XtVW");

const $6569b34ea74f05a3$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $135dba7912433cc2$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lU1m0))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $135dba7912433cc2$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $135dba7912433cc2$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kibFU))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $135dba7912433cc2$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $135dba7912433cc2$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($Svlt9))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $135dba7912433cc2$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $135dba7912433cc2$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gmIOk))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $135dba7912433cc2$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $135dba7912433cc2$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cMyAt))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $135dba7912433cc2$export$147899de772240ec)})`
    },
    discoveryUpdated: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $135dba7912433cc2$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aVKq8))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $135dba7912433cc2$export$147899de772240ec)})`
    }
};
function $6569b34ea74f05a3$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $6569b34ea74f05a3$var$appearanceIconSchema[appearance === 'discovery' && (0, $8XtVW.fg)('platform_dst_section_message_discovery_icon') ? 'discoveryUpdated' : appearance] || $6569b34ea74f05a3$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $gt9Am.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("aVKq8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79b7b06346630e2a8502fd6db80f47e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f533c6681701239$var$_react = $7f533c6681701239$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7f533c6681701239$var$_discovery = $7f533c6681701239$var$_interopRequireDefault((parcelRequire("2K8hI")));

var $7f533c6681701239$var$_note = $7f533c6681701239$var$_interopRequireDefault((parcelRequire("khuvd")));
function $7f533c6681701239$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f533c6681701239$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $7f533c6681701239$var$_react.default.createElement($7f533c6681701239$var$_discovery.default, Object.assign({
        LEGACY_fallbackIcon: $7f533c6681701239$var$_note.default
    }, props));
$7f533c6681701239$var$DiscoveryIcon.Name = 'DiscoveryIconMigration';
var $7f533c6681701239$var$_default = module.exports.default = $7f533c6681701239$var$DiscoveryIcon;

});
parcelRegister("2K8hI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffbdc778869407ee1ee67d41c1920845>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ff64dd38f5eb1a5$var$_react = $1ff64dd38f5eb1a5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1ff64dd38f5eb1a5$var$_baseNew = $1ff64dd38f5eb1a5$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $1ff64dd38f5eb1a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1ff64dd38f5eb1a5$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $1ff64dd38f5eb1a5$var$_react.default.createElement($1ff64dd38f5eb1a5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$1ff64dd38f5eb1a5$var$DiscoveryIcon.displayName = 'DiscoveryIcon';
var $1ff64dd38f5eb1a5$var$_default = module.exports.default = $1ff64dd38f5eb1a5$var$DiscoveryIcon;

});

parcelRegister("khuvd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec3d0e502b4f94da$var$_react = $ec3d0e502b4f94da$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $ec3d0e502b4f94da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ec3d0e502b4f94da$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $ec3d0e502b4f94da$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$ec3d0e502b4f94da$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $ec3d0e502b4f94da$var$_default = module.exports.default = $ec3d0e502b4f94da$var$EditorNoteIcon;

});


var $135dba7912433cc2$exports = {};

$parcel$export($135dba7912433cc2$exports, "R50", () => $135dba7912433cc2$export$4b84fd0e2c617bd);
$parcel$export($135dba7912433cc2$exports, "R75", () => $135dba7912433cc2$export$b34b069eff244586);
$parcel$export($135dba7912433cc2$exports, "R100", () => $135dba7912433cc2$export$be802dd0d8b57f35);
$parcel$export($135dba7912433cc2$exports, "R200", () => $135dba7912433cc2$export$60847d42f9da92a6);
$parcel$export($135dba7912433cc2$exports, "R300", () => $135dba7912433cc2$export$4a7404f376229999);
$parcel$export($135dba7912433cc2$exports, "R400", () => $135dba7912433cc2$export$2010d0fb4295b346);
$parcel$export($135dba7912433cc2$exports, "R500", () => $135dba7912433cc2$export$2837b5a1a71d5c02);
$parcel$export($135dba7912433cc2$exports, "Y50", () => $135dba7912433cc2$export$8d9596b529bbb9cf);
$parcel$export($135dba7912433cc2$exports, "Y75", () => $135dba7912433cc2$export$41060a744ab0b7ae);
$parcel$export($135dba7912433cc2$exports, "Y100", () => $135dba7912433cc2$export$1cc05bbbf340e559);
$parcel$export($135dba7912433cc2$exports, "Y200", () => $135dba7912433cc2$export$5aae31392d72caaa);
$parcel$export($135dba7912433cc2$exports, "Y300", () => $135dba7912433cc2$export$c6930421db9fa514);
$parcel$export($135dba7912433cc2$exports, "Y400", () => $135dba7912433cc2$export$59619663aa6500fb);
$parcel$export($135dba7912433cc2$exports, "Y500", () => $135dba7912433cc2$export$874739ea9e379ab6);
$parcel$export($135dba7912433cc2$exports, "G50", () => $135dba7912433cc2$export$8a6341c32b6a3ee6);
$parcel$export($135dba7912433cc2$exports, "G75", () => $135dba7912433cc2$export$69a3bf21b9686c2b);
$parcel$export($135dba7912433cc2$exports, "G100", () => $135dba7912433cc2$export$afbce1382ec95f73);
$parcel$export($135dba7912433cc2$exports, "G200", () => $135dba7912433cc2$export$747d86715d4175de);
$parcel$export($135dba7912433cc2$exports, "G300", () => $135dba7912433cc2$export$940e1f69e873f202);
$parcel$export($135dba7912433cc2$exports, "G400", () => $135dba7912433cc2$export$a49394138f7b8e85);
$parcel$export($135dba7912433cc2$exports, "G500", () => $135dba7912433cc2$export$6fa04827ac68a4fb);
$parcel$export($135dba7912433cc2$exports, "B50", () => $135dba7912433cc2$export$226de0355ed012f8);
$parcel$export($135dba7912433cc2$exports, "B75", () => $135dba7912433cc2$export$8c13c2ee36917869);
$parcel$export($135dba7912433cc2$exports, "B100", () => $135dba7912433cc2$export$ecfc1dff386a3e7a);
$parcel$export($135dba7912433cc2$exports, "B200", () => $135dba7912433cc2$export$215b7063051591f1);
$parcel$export($135dba7912433cc2$exports, "B300", () => $135dba7912433cc2$export$e62e8919cca44969);
$parcel$export($135dba7912433cc2$exports, "B400", () => $135dba7912433cc2$export$b3de0ae08da2ce64);
$parcel$export($135dba7912433cc2$exports, "B500", () => $135dba7912433cc2$export$a6ee3d71bc067634);
$parcel$export($135dba7912433cc2$exports, "B600", () => $135dba7912433cc2$export$67f15409e87642a1);
$parcel$export($135dba7912433cc2$exports, "B700", () => $135dba7912433cc2$export$f0539dbc42dbb067);
$parcel$export($135dba7912433cc2$exports, "P50", () => $135dba7912433cc2$export$363e4475840015bb);
$parcel$export($135dba7912433cc2$exports, "P75", () => $135dba7912433cc2$export$4b0a4417ed59760f);
$parcel$export($135dba7912433cc2$exports, "P100", () => $135dba7912433cc2$export$6011520a64d9a187);
$parcel$export($135dba7912433cc2$exports, "P200", () => $135dba7912433cc2$export$a7175d4e9206bc80);
$parcel$export($135dba7912433cc2$exports, "P300", () => $135dba7912433cc2$export$b48405b95304b5a1);
$parcel$export($135dba7912433cc2$exports, "P400", () => $135dba7912433cc2$export$c71e4279dd54a18d);
$parcel$export($135dba7912433cc2$exports, "P500", () => $135dba7912433cc2$export$147899de772240ec);
$parcel$export($135dba7912433cc2$exports, "T50", () => $135dba7912433cc2$export$2cf711fe14c66f06);
$parcel$export($135dba7912433cc2$exports, "T75", () => $135dba7912433cc2$export$7a8f4d33f6f9772c);
$parcel$export($135dba7912433cc2$exports, "T100", () => $135dba7912433cc2$export$776c9c497ef08533);
$parcel$export($135dba7912433cc2$exports, "T200", () => $135dba7912433cc2$export$69cb3ca10c1e330e);
$parcel$export($135dba7912433cc2$exports, "T300", () => $135dba7912433cc2$export$9dc1ef0f3f48059b);
$parcel$export($135dba7912433cc2$exports, "T400", () => $135dba7912433cc2$export$7c835c78b6fcdef8);
$parcel$export($135dba7912433cc2$exports, "T500", () => $135dba7912433cc2$export$6036577f95c3877e);
$parcel$export($135dba7912433cc2$exports, "N0", () => $135dba7912433cc2$export$29a4f05edc054374);
$parcel$export($135dba7912433cc2$exports, "N10", () => $135dba7912433cc2$export$e655ef011c4aa1a2);
$parcel$export($135dba7912433cc2$exports, "N20", () => $135dba7912433cc2$export$9fdfb749e33cdf97);
$parcel$export($135dba7912433cc2$exports, "N30", () => $135dba7912433cc2$export$3e51e8f1440314ba);
$parcel$export($135dba7912433cc2$exports, "N40", () => $135dba7912433cc2$export$1ce2d1575d444ceb);
$parcel$export($135dba7912433cc2$exports, "N50", () => $135dba7912433cc2$export$8754fc7e6d8b3000);
$parcel$export($135dba7912433cc2$exports, "N60", () => $135dba7912433cc2$export$c2e91cbeada39b8b);
$parcel$export($135dba7912433cc2$exports, "N70", () => $135dba7912433cc2$export$5f71e19f3a7ad9de);
$parcel$export($135dba7912433cc2$exports, "N80", () => $135dba7912433cc2$export$eaa8c8a70ac22806);
$parcel$export($135dba7912433cc2$exports, "N90", () => $135dba7912433cc2$export$7c87d337fb91a97d);
$parcel$export($135dba7912433cc2$exports, "N100", () => $135dba7912433cc2$export$d6447c357493214f);
$parcel$export($135dba7912433cc2$exports, "N200", () => $135dba7912433cc2$export$f563ee71e9ee74cd);
$parcel$export($135dba7912433cc2$exports, "N300", () => $135dba7912433cc2$export$e2ef2124cf4024b1);
$parcel$export($135dba7912433cc2$exports, "N400", () => $135dba7912433cc2$export$eece5f492e429f08);
$parcel$export($135dba7912433cc2$exports, "N500", () => $135dba7912433cc2$export$c39c0fe0f26207ae);
$parcel$export($135dba7912433cc2$exports, "N600", () => $135dba7912433cc2$export$7090862dc3038a9f);
$parcel$export($135dba7912433cc2$exports, "N700", () => $135dba7912433cc2$export$ad0bacf983b7ddaa);
$parcel$export($135dba7912433cc2$exports, "N800", () => $135dba7912433cc2$export$7d61b15e0da132af);
$parcel$export($135dba7912433cc2$exports, "N900", () => $135dba7912433cc2$export$fbda843f0a27fe96);
$parcel$export($135dba7912433cc2$exports, "N10A", () => $135dba7912433cc2$export$791e57b27ca738ef);
$parcel$export($135dba7912433cc2$exports, "N20A", () => $135dba7912433cc2$export$8d43898f60b96a82);
$parcel$export($135dba7912433cc2$exports, "N30A", () => $135dba7912433cc2$export$920c0d5c49070351);
$parcel$export($135dba7912433cc2$exports, "N40A", () => $135dba7912433cc2$export$46987b49aab6d1a8);
$parcel$export($135dba7912433cc2$exports, "N50A", () => $135dba7912433cc2$export$7d3359664e8bb0e5);
$parcel$export($135dba7912433cc2$exports, "N60A", () => $135dba7912433cc2$export$d2d3bedfb276cac0);
$parcel$export($135dba7912433cc2$exports, "N70A", () => $135dba7912433cc2$export$6e5e7499ff054f6d);
$parcel$export($135dba7912433cc2$exports, "N80A", () => $135dba7912433cc2$export$59264b346c877fa7);
$parcel$export($135dba7912433cc2$exports, "N90A", () => $135dba7912433cc2$export$d092757d7c64925c);
$parcel$export($135dba7912433cc2$exports, "N100A", () => $135dba7912433cc2$export$486ab785e4bac3c6);
$parcel$export($135dba7912433cc2$exports, "N200A", () => $135dba7912433cc2$export$fba592bbc6419fea);
$parcel$export($135dba7912433cc2$exports, "N300A", () => $135dba7912433cc2$export$13609db0e6812ab8);
$parcel$export($135dba7912433cc2$exports, "N400A", () => $135dba7912433cc2$export$fbae4efaa892d883);
$parcel$export($135dba7912433cc2$exports, "N500A", () => $135dba7912433cc2$export$f13946d26f440ce6);
$parcel$export($135dba7912433cc2$exports, "N600A", () => $135dba7912433cc2$export$19f58225ac52a306);
$parcel$export($135dba7912433cc2$exports, "N700A", () => $135dba7912433cc2$export$6384f09da70e7b62);
$parcel$export($135dba7912433cc2$exports, "N800A", () => $135dba7912433cc2$export$d0dccc730683edc2);
$parcel$export($135dba7912433cc2$exports, "DN900", () => $135dba7912433cc2$export$2f6319cf7d736c2a);
$parcel$export($135dba7912433cc2$exports, "DN800", () => $135dba7912433cc2$export$95126bc8884d6634);
$parcel$export($135dba7912433cc2$exports, "DN700", () => $135dba7912433cc2$export$8338d8c35d44ff1);
$parcel$export($135dba7912433cc2$exports, "DN600", () => $135dba7912433cc2$export$5368d76ae4fbbda7);
$parcel$export($135dba7912433cc2$exports, "DN500", () => $135dba7912433cc2$export$9f0a771d16ec8d36);
$parcel$export($135dba7912433cc2$exports, "DN400", () => $135dba7912433cc2$export$abcf8c38338b4aa5);
$parcel$export($135dba7912433cc2$exports, "DN300", () => $135dba7912433cc2$export$97e81faa16a182c7);
$parcel$export($135dba7912433cc2$exports, "DN200", () => $135dba7912433cc2$export$bfe21c59123ecf33);
$parcel$export($135dba7912433cc2$exports, "DN100", () => $135dba7912433cc2$export$ee82aa2ea6a1558);
$parcel$export($135dba7912433cc2$exports, "DN90", () => $135dba7912433cc2$export$682927c6ed76be02);
$parcel$export($135dba7912433cc2$exports, "DN80", () => $135dba7912433cc2$export$91fd9994c5be9757);
$parcel$export($135dba7912433cc2$exports, "DN70", () => $135dba7912433cc2$export$d281fbfe3cff2df6);
$parcel$export($135dba7912433cc2$exports, "DN60", () => $135dba7912433cc2$export$3902c91d8b98a753);
$parcel$export($135dba7912433cc2$exports, "DN50", () => $135dba7912433cc2$export$8e8133c1ba5845b5);
$parcel$export($135dba7912433cc2$exports, "DN40", () => $135dba7912433cc2$export$33ff357f6620b39);
$parcel$export($135dba7912433cc2$exports, "DN30", () => $135dba7912433cc2$export$633847cf062b69e0);
$parcel$export($135dba7912433cc2$exports, "DN20", () => $135dba7912433cc2$export$9776a6e503bdbf76);
$parcel$export($135dba7912433cc2$exports, "DN10", () => $135dba7912433cc2$export$6c813d5160dff5db);
$parcel$export($135dba7912433cc2$exports, "DN0", () => $135dba7912433cc2$export$3d4f271a500072a);
$parcel$export($135dba7912433cc2$exports, "DN800A", () => $135dba7912433cc2$export$fe151285c22759ec);
$parcel$export($135dba7912433cc2$exports, "DN700A", () => $135dba7912433cc2$export$a101c6190d0da34);
$parcel$export($135dba7912433cc2$exports, "DN600A", () => $135dba7912433cc2$export$4b16f52932fda51);
$parcel$export($135dba7912433cc2$exports, "DN500A", () => $135dba7912433cc2$export$a74bcd7b9845b0d8);
$parcel$export($135dba7912433cc2$exports, "DN400A", () => $135dba7912433cc2$export$9209c179316d1751);
$parcel$export($135dba7912433cc2$exports, "DN300A", () => $135dba7912433cc2$export$88f55133f636c8dd);
$parcel$export($135dba7912433cc2$exports, "DN200A", () => $135dba7912433cc2$export$51126f85d1009512);
$parcel$export($135dba7912433cc2$exports, "DN100A", () => $135dba7912433cc2$export$a069b547bd23af78);
$parcel$export($135dba7912433cc2$exports, "DN90A", () => $135dba7912433cc2$export$40cce05af3b2600a);
$parcel$export($135dba7912433cc2$exports, "DN80A", () => $135dba7912433cc2$export$b78942185925a0d);
$parcel$export($135dba7912433cc2$exports, "DN70A", () => $135dba7912433cc2$export$e058fb44b8eaafca);
$parcel$export($135dba7912433cc2$exports, "DN60A", () => $135dba7912433cc2$export$92b0b8de26920c18);
$parcel$export($135dba7912433cc2$exports, "DN50A", () => $135dba7912433cc2$export$67564f7459d3fc9e);
$parcel$export($135dba7912433cc2$exports, "DN40A", () => $135dba7912433cc2$export$77868e1ca884ffa3);
$parcel$export($135dba7912433cc2$exports, "DN30A", () => $135dba7912433cc2$export$2afd71d7d3ea2cd5);
$parcel$export($135dba7912433cc2$exports, "DN20A", () => $135dba7912433cc2$export$f2a0acaab9972c70);
$parcel$export($135dba7912433cc2$exports, "DN10A", () => $135dba7912433cc2$export$9ab70e67d6475361);
$parcel$export($135dba7912433cc2$exports, "T30", () => $135dba7912433cc2$export$d2adc5dedf09fced);
$parcel$export($135dba7912433cc2$exports, "L50", () => $135dba7912433cc2$export$f51762073d2bb381);
$parcel$export($135dba7912433cc2$exports, "L75", () => $135dba7912433cc2$export$95e26d54def96891);
// Reds
const $135dba7912433cc2$export$4b84fd0e2c617bd = '#FFEBE6';
const $135dba7912433cc2$export$b34b069eff244586 = '#FFBDAD';
const $135dba7912433cc2$export$be802dd0d8b57f35 = '#FF8F73';
const $135dba7912433cc2$export$60847d42f9da92a6 = '#FF7452';
const $135dba7912433cc2$export$4a7404f376229999 = '#FF5630';
const $135dba7912433cc2$export$2010d0fb4295b346 = '#DE350B';
const $135dba7912433cc2$export$2837b5a1a71d5c02 = '#BF2600';
const $135dba7912433cc2$export$8d9596b529bbb9cf = '#FFFAE6';
const $135dba7912433cc2$export$41060a744ab0b7ae = '#FFF0B3';
const $135dba7912433cc2$export$1cc05bbbf340e559 = '#FFE380';
const $135dba7912433cc2$export$5aae31392d72caaa = '#FFC400';
const $135dba7912433cc2$export$c6930421db9fa514 = '#FFAB00';
const $135dba7912433cc2$export$59619663aa6500fb = '#FF991F';
const $135dba7912433cc2$export$874739ea9e379ab6 = '#FF8B00';
const $135dba7912433cc2$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $135dba7912433cc2$export$69a3bf21b9686c2b = '#ABF5D1';
const $135dba7912433cc2$export$afbce1382ec95f73 = '#79F2C0';
const $135dba7912433cc2$export$747d86715d4175de = '#57D9A3';
const $135dba7912433cc2$export$940e1f69e873f202 = '#36B37E';
const $135dba7912433cc2$export$a49394138f7b8e85 = '#00875A';
const $135dba7912433cc2$export$6fa04827ac68a4fb = '#006644';
const $135dba7912433cc2$export$226de0355ed012f8 = '#DEEBFF';
const $135dba7912433cc2$export$8c13c2ee36917869 = '#B3D4FF';
const $135dba7912433cc2$export$ecfc1dff386a3e7a = '#4C9AFF';
const $135dba7912433cc2$export$215b7063051591f1 = '#2684FF';
const $135dba7912433cc2$export$e62e8919cca44969 = '#0065FF';
const $135dba7912433cc2$export$b3de0ae08da2ce64 = '#0052CC';
const $135dba7912433cc2$export$a6ee3d71bc067634 = '#0747A6';
const $135dba7912433cc2$export$67f15409e87642a1 = '#669DF1';
const $135dba7912433cc2$export$f0539dbc42dbb067 = '#8FB8F6';
const $135dba7912433cc2$export$363e4475840015bb = '#EAE6FF';
const $135dba7912433cc2$export$4b0a4417ed59760f = '#C0B6F2';
const $135dba7912433cc2$export$6011520a64d9a187 = '#998DD9';
const $135dba7912433cc2$export$a7175d4e9206bc80 = '#8777D9';
const $135dba7912433cc2$export$b48405b95304b5a1 = '#6554C0';
const $135dba7912433cc2$export$c71e4279dd54a18d = '#5243AA';
const $135dba7912433cc2$export$147899de772240ec = '#403294';
const $135dba7912433cc2$export$2cf711fe14c66f06 = '#E6FCFF';
const $135dba7912433cc2$export$7a8f4d33f6f9772c = '#B3F5FF';
const $135dba7912433cc2$export$776c9c497ef08533 = '#79E2F2';
const $135dba7912433cc2$export$69cb3ca10c1e330e = '#00C7E6';
const $135dba7912433cc2$export$9dc1ef0f3f48059b = '#00B8D9';
const $135dba7912433cc2$export$7c835c78b6fcdef8 = '#00A3BF';
const $135dba7912433cc2$export$6036577f95c3877e = '#008DA6';
const $135dba7912433cc2$export$29a4f05edc054374 = '#FFFFFF';
const $135dba7912433cc2$export$e655ef011c4aa1a2 = '#FAFBFC';
const $135dba7912433cc2$export$9fdfb749e33cdf97 = '#F4F5F7';
const $135dba7912433cc2$export$3e51e8f1440314ba = '#EBECF0';
const $135dba7912433cc2$export$1ce2d1575d444ceb = '#DFE1E6';
const $135dba7912433cc2$export$8754fc7e6d8b3000 = '#C1C7D0';
const $135dba7912433cc2$export$c2e91cbeada39b8b = '#B3BAC5';
const $135dba7912433cc2$export$5f71e19f3a7ad9de = '#A5ADBA';
const $135dba7912433cc2$export$eaa8c8a70ac22806 = '#97A0AF';
const $135dba7912433cc2$export$7c87d337fb91a97d = '#8993A4';
const $135dba7912433cc2$export$d6447c357493214f = '#7A869A';
const $135dba7912433cc2$export$f563ee71e9ee74cd = '#6B778C';
const $135dba7912433cc2$export$e2ef2124cf4024b1 = '#5E6C84';
const $135dba7912433cc2$export$eece5f492e429f08 = '#505F79';
const $135dba7912433cc2$export$c39c0fe0f26207ae = '#42526E';
const $135dba7912433cc2$export$7090862dc3038a9f = '#344563';
const $135dba7912433cc2$export$ad0bacf983b7ddaa = '#253858';
const $135dba7912433cc2$export$7d61b15e0da132af = '#172B4D';
const $135dba7912433cc2$export$fbda843f0a27fe96 = '#091E42';
const $135dba7912433cc2$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $135dba7912433cc2$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $135dba7912433cc2$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $135dba7912433cc2$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $135dba7912433cc2$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $135dba7912433cc2$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $135dba7912433cc2$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $135dba7912433cc2$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $135dba7912433cc2$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $135dba7912433cc2$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $135dba7912433cc2$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $135dba7912433cc2$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $135dba7912433cc2$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $135dba7912433cc2$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $135dba7912433cc2$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $135dba7912433cc2$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $135dba7912433cc2$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $135dba7912433cc2$export$2f6319cf7d736c2a = '#E6EDFA';
const $135dba7912433cc2$export$95126bc8884d6634 = '#DCE5F5';
const $135dba7912433cc2$export$8338d8c35d44ff1 = '#CED9EB';
const $135dba7912433cc2$export$5368d76ae4fbbda7 = '#B8C7E0';
const $135dba7912433cc2$export$9f0a771d16ec8d36 = '#ABBBD6';
const $135dba7912433cc2$export$abcf8c38338b4aa5 = '#9FB0CC';
const $135dba7912433cc2$export$97e81faa16a182c7 = '#8C9CB8';
const $135dba7912433cc2$export$bfe21c59123ecf33 = '#7988A3';
const $135dba7912433cc2$export$ee82aa2ea6a1558 = '#67758F';
const $135dba7912433cc2$export$682927c6ed76be02 = '#56637A';
const $135dba7912433cc2$export$91fd9994c5be9757 = '#455166';
const $135dba7912433cc2$export$d281fbfe3cff2df6 = '#3B475C';
const $135dba7912433cc2$export$3902c91d8b98a753 = '#313D52';
const $135dba7912433cc2$export$8e8133c1ba5845b5 = '#283447';
const $135dba7912433cc2$export$33ff357f6620b39 = '#202B3D';
const $135dba7912433cc2$export$633847cf062b69e0 = '#1B2638';
const $135dba7912433cc2$export$9776a6e503bdbf76 = '#121A29';
const $135dba7912433cc2$export$6c813d5160dff5db = '#0E1624';
const $135dba7912433cc2$export$3d4f271a500072a = '#0D1424';
const $135dba7912433cc2$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $135dba7912433cc2$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $135dba7912433cc2$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $135dba7912433cc2$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $135dba7912433cc2$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $135dba7912433cc2$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $135dba7912433cc2$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $135dba7912433cc2$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $135dba7912433cc2$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $135dba7912433cc2$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $135dba7912433cc2$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $135dba7912433cc2$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $135dba7912433cc2$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $135dba7912433cc2$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $135dba7912433cc2$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $135dba7912433cc2$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $135dba7912433cc2$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $135dba7912433cc2$export$d2adc5dedf09fced = '#292A2E';
const $135dba7912433cc2$export$f51762073d2bb381 = '#94C748';
const $135dba7912433cc2$export$95e26d54def96891 = '#B3DF72';



parcelRegister("ajkvN", function(module, exports) {

$parcel$export(module.exports, "ModalButtonTrigger", () => $4fb29c3ab918d162$export$156b5756ed7a09ad);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $alkjW = parcelRequire("alkjW");

var $k3Ztu = parcelRequire("k3Ztu");
function $4fb29c3ab918d162$export$156b5756ed7a09ad({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, forwardedRef: forwardedRef, ...buttonProps }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k3Ztu.ModalTrigger), {
        forwardedRef: forwardedRef,
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        Fallback: Fallback,
        title: modalTitle,
        modalProps: modalProps,
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $alkjW.default), {
                ref: ref,
                ...buttonProps,
                children: children
            })
    });
}

});

parcelRegister("8SMrZ", function(module, exports) {

$parcel$export(module.exports, "CopyableApplicationClientID", () => $ae50983c3d3fd402$export$933c655d375093bb);
$parcel$export(module.exports, "CopyableApplicationClientSecret", () => $ae50983c3d3fd402$export$eeaa05b78b5f2773);
$parcel$export(module.exports, "RemoteApplicationScopeMultiSelect", () => $ae50983c3d3fd402$export$e6ea1c895768a29c);
$parcel$export(module.exports, "ApplicationClientId", () => $ae50983c3d3fd402$export$c8399aae3a726af3);
$parcel$export(module.exports, "ApplicationClientSecret", () => $ae50983c3d3fd402$export$f137c4dc8b585189);
$parcel$export(module.exports, "RedirectUrl", () => $ae50983c3d3fd402$export$e0ad63dba68d8cca);
$parcel$export(module.exports, "DisplayName", () => $ae50983c3d3fd402$export$101fbca3a406e1fd);
$parcel$export(module.exports, "DisplayUrl", () => $ae50983c3d3fd402$export$b07e64a5c70fbd11);
$parcel$export(module.exports, "ApplicationUrl", () => $ae50983c3d3fd402$export$5c4f409b6c929d7a);

var $eJOHy = parcelRequire("eJOHy");

var $aRh7I = parcelRequire("aRh7I");

var $i9p2T = parcelRequire("i9p2T");
var $7BnZ9 = parcelRequire("7BnZ9");

var $eKx5I = parcelRequire("eKx5I");

var $7p5if = parcelRequire("7p5if");

var $jiIAQ = parcelRequire("jiIAQ");

var $e7C36 = parcelRequire("e7C36");
const $ae50983c3d3fd402$export$933c655d375093bb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7BnZ9.default), {
        "aria-required": true,
        name: props.name,
        defaultValue: props.clientId,
        label: "Application Client ID",
        isDisabled: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
            isReadOnly: true,
            type: "password",
            ...fieldProps,
            elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jiIAQ.default), {
                label: "Application Client ID",
                value: props.clientId
            })
        }));
const $ae50983c3d3fd402$export$eeaa05b78b5f2773 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7BnZ9.default), {
        "aria-required": true,
        name: props.name,
        defaultValue: props.clientSecret,
        label: "Application Client secret",
        isDisabled: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
            isReadOnly: true,
            type: "password",
            ...fieldProps,
            elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jiIAQ.default), {
                label: "Application Client secret",
                value: props.clientSecret
            })
        }));
const $ae50983c3d3fd402$export$e6ea1c895768a29c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7BnZ9.default), {
        name: props.name,
        label: "Scopes",
        defaultValue: props.defaultSelected,
        validate: (chosenScopes)=>(0, $e7C36.validateSupportedScopes)(chosenScopes ? chosenScopes.map((scope)=>scope.value) : [], props.supportedScopes)
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7p5if.default), {
            placeholder: "Use the same scopes as the remote application",
            ...fieldProps,
            options: props.supportedScopes.map((scope)=>({
                    label: scope,
                    value: scope
                }))
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.ErrorMessage), null, error)));
const $ae50983c3d3fd402$export$c8399aae3a726af3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7BnZ9.default), {
        "aria-required": true,
        name: props.name,
        label: "Application Client ID",
        isRequired: props.isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
            type: "password",
            placeholder: "Client ID",
            ...fieldProps
        }));
const $ae50983c3d3fd402$export$f137c4dc8b585189 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7BnZ9.default), {
        "aria-required": true,
        name: props.name,
        label: "Application Client secret",
        isRequired: props.isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
            type: "password",
            placeholder: "Client secret",
            ...fieldProps
        }));
const $ae50983c3d3fd402$export$e0ad63dba68d8cca = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7BnZ9.default), {
        "aria-required": true,
        name: props.name,
        defaultValue: props.defaultRedirectUrl,
        label: "Redirect URL",
        validate: (redirectUrl)=>(0, $e7C36.validateURLField)(redirectUrl, true, true),
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
            placeholder: "Redirect URL",
            ...fieldProps
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.ErrorMessage), null, error)));
const $ae50983c3d3fd402$export$101fbca3a406e1fd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7BnZ9.default), {
        "aria-required": true,
        name: props.name,
        defaultValue: props.defaultName,
        label: "Display name",
        isRequired: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
            placeholder: "Name for the application link",
            ...fieldProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.HelperMessage), null, "Enter a unique name for the link, for example the name of your external application.")));
const $ae50983c3d3fd402$export$b07e64a5c70fbd11 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7BnZ9.default), {
        "aria-required": true,
        name: props.name,
        defaultValue: props.defaultUrl,
        label: "Display URL",
        isRequired: true,
        validate: (defaultUrl)=>(0, $e7C36.validateURLField)(defaultUrl, true, false)
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
            placeholder: "URL for the application link",
            ...fieldProps
        }), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.HelperMessage), null, "This is the URL that will be displayed to users in Jira."), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.ErrorMessage), null, error)));
const $ae50983c3d3fd402$export$5c4f409b6c929d7a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7BnZ9.default), {
        "aria-required": true,
        name: props.name,
        defaultValue: props.defaultUrl,
        label: "Application URL",
        isDisabled: props.disabled,
        isRequired: !props.disabled,
        validate: (redirectUrl)=>(0, $e7C36.validateURLField)(redirectUrl, true, true)
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
            placeholder: "Application URL for the application link",
            ...fieldProps
        }), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.HelperMessage), null, "This is the URL that Jira will use to communicate with the external application."), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.ErrorMessage), null, error)));

});
parcelRegister("i9p2T", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $b916c0f27ac7e0b0$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $b916c0f27ac7e0b0$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $b916c0f27ac7e0b0$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $b916c0f27ac7e0b0$export$ec445f12f63100a5);
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Svlt9 = parcelRequire("Svlt9");

var $eBkh0 = parcelRequire("eBkh0");

var $8XtVW = parcelRequire("8XtVW");

var $eO1ID = parcelRequire("eO1ID");
const $b916c0f27ac7e0b0$var$messageStyles = null;
const $b916c0f27ac7e0b0$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
const $b916c0f27ac7e0b0$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $b916c0f27ac7e0b0$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            $b916c0f27ac7e0b0$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $b916c0f27ac7e0b0$var$messageIcons = {
    error: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Svlt9))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eBkh0))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success",
        size: "small"
    })
};
const $b916c0f27ac7e0b0$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $b916c0f27ac7e0b0$var$messageIcons[appearance];
    const isFeatureFlagEnabled = (0, $8XtVW.fg)('platform_dst_form_screenreader_message_fix');
    const { isWrapper: isWrapper } = (0, $eJOHy.useContext)($b916c0f27ac7e0b0$var$MessageWrapperContext);
    const [shouldRenderContent, setShouldRenderContent] = (0, $eJOHy.useState)(isWrapper);
    // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
    const messageRef = (0, $eJOHy.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $eJOHy.useState)(isWrapper);
    (0, $eJOHy.useEffect)(()=>{
        if (isFeatureFlagEnabled) {
            if (!isWrapper) {
                // Delay rendering to ensure aria-live announcements work on first render if there is no wrapper
                const timer = setTimeout(()=>{
                    setShouldRenderContent(true);
                }, 10);
                return ()=>clearTimeout(timer);
            } else // When using MessageWrapper, render content immediately since the wrapper handles aria-live
            setShouldRenderContent(true);
        } else // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper,
        isFeatureFlagEnabled
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        children: children
    });
    const childrenToRender = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            icon && /*#__PURE__*/ (0, $gt9Am.jsx)($b916c0f27ac7e0b0$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        id: fieldId,
        // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $hcewu.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $b916c0f27ac7e0b0$var$messageAppearanceStyles[appearance]
        ]),
        children: isFeatureFlagEnabled ? shouldRenderContent && childrenToRender : childrenToRender
    });
};
const $b916c0f27ac7e0b0$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eO1ID.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $gt9Am.jsx)($b916c0f27ac7e0b0$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
const $b916c0f27ac7e0b0$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eO1ID.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $gt9Am.jsx)($b916c0f27ac7e0b0$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
const $b916c0f27ac7e0b0$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eO1ID.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $gt9Am.jsx)($b916c0f27ac7e0b0$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ const $b916c0f27ac7e0b0$var$MessageWrapperContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isWrapper: false
});
const $b916c0f27ac7e0b0$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)($b916c0f27ac7e0b0$var$MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

});
parcelRegister("eBkh0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d11500fc79ac0e5637954a63f0212549>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa143f4272975edb$var$_react = $aa143f4272975edb$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aa143f4272975edb$var$_statusSuccess = $aa143f4272975edb$var$_interopRequireDefault((parcelRequire("g4ST9")));

var $aa143f4272975edb$var$_success = $aa143f4272975edb$var$_interopRequireDefault((parcelRequire("d5XlV")));
function $aa143f4272975edb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aa143f4272975edb$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $aa143f4272975edb$var$_react.default.createElement($aa143f4272975edb$var$_statusSuccess.default, Object.assign({
        LEGACY_fallbackIcon: $aa143f4272975edb$var$_success.default
    }, props));
$aa143f4272975edb$var$StatusSuccessIcon.Name = 'StatusSuccessIconMigration';
var $aa143f4272975edb$var$_default = module.exports.default = $aa143f4272975edb$var$StatusSuccessIcon;

});
parcelRegister("d5XlV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9889c834defd8e3e$var$_react = $9889c834defd8e3e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $9889c834defd8e3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9889c834defd8e3e$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $9889c834defd8e3e$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props));
$9889c834defd8e3e$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $9889c834defd8e3e$var$_default = module.exports.default = $9889c834defd8e3e$var$EditorSuccessIcon;

});


parcelRegister("eO1ID", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $cba6c1401f4a9e39$export$3c4232819458a302);

var $eJOHy = parcelRequire("eJOHy");
const $cba6c1401f4a9e39$export$3c4232819458a302 = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);

});


parcelRegister("7BnZ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6d8b4fb0c7248c5$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
parcelRequire("8GOss");

var $gdEz9 = parcelRequire("gdEz9");

var $eO1ID = parcelRequire("eO1ID");

var $jtnjR = parcelRequire("jtnjR");

var $lx8oo = parcelRequire("lx8oo");

var $15pUD = parcelRequire("15pUD");

var $igDjg = parcelRequire("igDjg");
const $f6d8b4fb0c7248c5$var$fieldWrapperStyles = null;
function $f6d8b4fb0c7248c5$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $f6d8b4fb0c7248c5$var$isFunction(x) {
    return typeof x === 'function';
}
function $f6d8b4fb0c7248c5$var$usePreviousRef(current) {
    const ref = (0, $eJOHy.useRef)(current);
    // will be updated on the next render
    (0, $eJOHy.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $f6d8b4fb0c7248c5$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $f6d8b4fb0c7248c5$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eJOHy.useContext)((0, $jtnjR.FormContext));
    const isDisabled = (0, $eJOHy.useContext)((0, $jtnjR.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $f6d8b4fb0c7248c5$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $f6d8b4fb0c7248c5$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$f6d8b4fb0c7248c5$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eJOHy.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $f6d8b4fb0c7248c5$var$usePreviousRef(state);
    (0, $eJOHy.useEffect)(()=>{
        typeof $igDjg;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $f6d8b4fb0c7248c5$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($f6d8b4fb0c7248c5$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $gdEz9.useId)();
    const fieldId = (0, $eJOHy.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $hcewu.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lx8oo.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $15pUD.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eO1ID.FieldId).Provider, {
                value: fieldId,
                children: props.children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("lx8oo", function(module, exports) {

$parcel$export(module.exports, "Label", () => $c086087ead18dd40$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $c086087ead18dd40$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c086087ead18dd40$var$fieldsetLabelStyles = null;
const $c086087ead18dd40$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $c086087ead18dd40$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("legend", {
        className: (0, $hcewu.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("15pUD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a17fd382c4eafe3$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $0a17fd382c4eafe3$var$requiredIndicatorStyles = null;
function $0a17fd382c4eafe3$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $hcewu.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("eKx5I", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbfd8a7ab9a39c6b$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j2fEo = parcelRequire("j2fEo");

var $8XtVW = parcelRequire("8XtVW");
const $fbfd8a7ab9a39c6b$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
const $fbfd8a7ab9a39c6b$var$inputMediaDisabled = null;
const $fbfd8a7ab9a39c6b$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $fbfd8a7ab9a39c6b$var$disabledStyle = {
    standard: "_1h6dsyzs _bfhksyzs _syaz1lh4 _80om13gf",
    subtle: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf",
    none: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf"
};
const $fbfd8a7ab9a39c6b$var$invalidStyle = null;
const $fbfd8a7ab9a39c6b$var$focusWithinStyle = {
    standard: "_1p9x1p6i _qao9r01l _q433q049",
    subtle: "_1p9x1p6i _qao9r01l _q433q049",
    none: "_1p9x3acm _qao918uv _q433nruj"
};
const $fbfd8a7ab9a39c6b$var$hoverStyle = {
    standard: "_4cvx1elr _irr31d5g",
    subtle: "_4cvx1elr _irr31d5g",
    none: "_4cvx3acm _irr318uv"
};
const $fbfd8a7ab9a39c6b$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6d1elr _1dqonqa1 _syaz1fxt _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d3acm _1dqonqa1 _syaz1fxt _80om1kdv _16hg18uv _msj6gir2",
    none: "_1h6d3acm _1dqoglyw _syaz1fxt _80om1kdv _16hg18uv _msj6gir2"
};
const $fbfd8a7ab9a39c6b$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $fbfd8a7ab9a39c6b$var$getMaxWidth = (width)=>!width ? `100%` : width in $fbfd8a7ab9a39c6b$var$widthMap ? `${$fbfd8a7ab9a39c6b$var$widthMap[width]}px` : `${+width}px`;
const $fbfd8a7ab9a39c6b$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $fbfd8a7ab9a39c6b$var$containerStyles = null;
const $fbfd8a7ab9a39c6b$var$inputDisabledStyle = null;
const $fbfd8a7ab9a39c6b$var$inputCompactStyleWithFg = null;
const $fbfd8a7ab9a39c6b$var$inputCompactStyle = null;
const $fbfd8a7ab9a39c6b$var$inputMonospacedStyle = null;
const $fbfd8a7ab9a39c6b$var$inputFontStyleWithFG = null;
const $fbfd8a7ab9a39c6b$var$inputStyleMonospacedWithFg = null;
const $fbfd8a7ab9a39c6b$var$inputStyleNotDataCompactWithFG = null;
const $fbfd8a7ab9a39c6b$var$inputStyle = null; /**
                          * __Textfield__
                          *
                          * A text field is an input that allows a user to write or edit text.
                          *
                          * - [Examples](https://atlassian.design/components/textfield/examples)
                          * - [Code](https://atlassian.design/components/textfield/code)
                          * - [Usage](https://atlassian.design/components/textfield/usage)
                          */ 
const $fbfd8a7ab9a39c6b$var$Textfield = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eJOHy.useRef)(null);
    const handleOnFocus = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$fbfd8a7ab9a39c6b$var$analyticsParams
    });
    const handleOnBlur = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$fbfd8a7ab9a39c6b$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eJOHy.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eJOHy.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$fbfd8a7ab9a39c6b$var$getMaxWidth(width)}`
        },
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c82smr _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1l7b",
            $fbfd8a7ab9a39c6b$var$getContainerTextBgAndBorderColor[appearance],
            $fbfd8a7ab9a39c6b$var$containerStyleAppearance[appearance],
            !isDisabled && $fbfd8a7ab9a39c6b$var$focusWithinStyle[appearance],
            !isDisabled && $fbfd8a7ab9a39c6b$var$hoverStyle[appearance],
            isDisabled && $fbfd8a7ab9a39c6b$var$containerMedia.disabled,
            isDisabled && $fbfd8a7ab9a39c6b$var$disabledStyle[appearance],
            isInvalid && $fbfd8a7ab9a39c6b$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $hcewu.default)([
                    "_19itidpf _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk18uv _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr131l",
                    isMonospaced && "_ect41odn",
                    isCompact && "_85i51b66 _1q511b66 _y4ti12x7 _bozg12x7",
                    isDisabled && "_syaz1lh4 _1idr1lh4",
                    isDisabled && "_1fnx18qt",
                    !isCompact && (0, $8XtVW.fg)('platform_design_system_team_safari_input_fix') && "_14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
                    (0, $8XtVW.fg)('platform_design_system_team_safari_input_fix') && "_11c81ixg _1tn22smr",
                    isCompact && (0, $8XtVW.fg)('platform_design_system_team_safari_input_fix') && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
                    isMonospaced && (0, $8XtVW.fg)('platform_design_system_team_safari_input_fix') && "_ect41odn _14md1odn"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $fbfd8a7ab9a39c6b$export$2e2bcd8739ae039 = $fbfd8a7ab9a39c6b$var$Textfield;

});

parcelRegister("7p5if", function(module, exports) {

$parcel$export(module.exports, "default", () => $6932e5c3482c33c4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eUb2z = parcelRequire("eUb2z");

var $8TCso = parcelRequire("8TCso");
const $6932e5c3482c33c4$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $eJOHy.useMemo)(()=>({
            ...components,
            Option: (0, $eUb2z.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8TCso.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $6932e5c3482c33c4$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo($6932e5c3482c33c4$var$CheckboxSelectInternal);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6932e5c3482c33c4$export$2e2bcd8739ae039 = $6932e5c3482c33c4$var$CheckboxSelect;

});
parcelRegister("eUb2z", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $1b2b8824e98c54fc$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $1b2b8824e98c54fc$export$82ab7168879267a7);
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $40c79 = parcelRequire("40c79");

var $1DXJJ = parcelRequire("1DXJJ");

var $lb1YQ = parcelRequire("lb1YQ");

var $8XtVW = parcelRequire("8XtVW");
const $1b2b8824e98c54fc$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di61dty",
    focused: "_bfhk166n _16qsn8hf _112ej1ic",
    disabled: "_syaz15gi"
};
// the primary color represents the outer or background element
const $1b2b8824e98c54fc$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #091E4208)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #09326C)";
    else if (isActive) return "var(--ds-background-selected-pressed, #85B8FF)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #0055CC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #0C66E4)";
    return "var(--ds-background-neutral, #091E420F)";
};
// the secondary color represents the radio dot or checkmark
const $1b2b8824e98c54fc$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #091E424F)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $1b2b8824e98c54fc$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1elr _1gqp1elr"
};
const $1b2b8824e98c54fc$var$baseIconStyles = null;
const $1b2b8824e98c54fc$var$baseOptionStyles = null;
const $1b2b8824e98c54fc$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $eJOHy.useState)(false);
    const onMouseDown = (0, $eJOHy.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $eJOHy.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $eJOHy.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $1b2b8824e98c54fc$var$optionStyles.default,
            isFocused && $1b2b8824e98c54fc$var$optionStyles.focused,
            isDisabled && $1b2b8824e98c54fc$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $1b2b8824e98c54fc$var$iconStyles.inherit : $1b2b8824e98c54fc$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                    label: "",
                    primaryColor: $1b2b8824e98c54fc$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $1b2b8824e98c54fc$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $1b2b8824e98c54fc$var$NewCheckboxIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lb1YQ.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
const $1b2b8824e98c54fc$var$NewRadioIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lb1YQ.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
const $1b2b8824e98c54fc$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($1b2b8824e98c54fc$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $8XtVW.fg)('platform-visual-refresh-icons') ? $1b2b8824e98c54fc$var$NewCheckboxIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($40c79))),
        ...props
    });
const $1b2b8824e98c54fc$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $gt9Am.jsx)($1b2b8824e98c54fc$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $8XtVW.fg)('platform-visual-refresh-icons') ? $1b2b8824e98c54fc$var$NewRadioIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($1DXJJ))),
        ...props
    });

});
parcelRegister("40c79", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ea08f2b9404cb6f$var$_react = $2ea08f2b9404cb6f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $2ea08f2b9404cb6f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ea08f2b9404cb6f$var$CheckboxIcon = (props)=>/*#__PURE__*/ $2ea08f2b9404cb6f$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$2ea08f2b9404cb6f$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $2ea08f2b9404cb6f$var$_default = module.exports.default = $2ea08f2b9404cb6f$var$CheckboxIcon;

});

parcelRegister("1DXJJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1327c56dce7e7aee$var$_react = $1327c56dce7e7aee$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $1327c56dce7e7aee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1327c56dce7e7aee$var$RadioIcon = (props)=>/*#__PURE__*/ $1327c56dce7e7aee$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props));
$1327c56dce7e7aee$var$RadioIcon.displayName = 'RadioIcon';
var $1327c56dce7e7aee$var$_default = module.exports.default = $1327c56dce7e7aee$var$RadioIcon;

});


parcelRegister("8TCso", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $6537276317917e0c$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $6537276317917e0c$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $63DI8 = parcelRequire("63DI8");
var $kUIKr = parcelRequire("kUIKr");
var $aN4Pk = parcelRequire("aN4Pk");

var $1zt6p = parcelRequire("1zt6p");

var $5lI1B = parcelRequire("5lI1B");
const $6537276317917e0c$var$packageName = "platform-pkg";
const $6537276317917e0c$var$packageVersion = "0.0.0-use.local";
const $6537276317917e0c$export$d1de3b251ccaa8a3 = (0, $5lI1B.default)((0, $1zt6p.default));
const $6537276317917e0c$var$createAndFireEventOnAtlaskit = (0, $63DI8.default)('atlaskit');
const $6537276317917e0c$var$Select = (0, $kUIKr.default)({
    componentName: 'select',
    packageName: $6537276317917e0c$var$packageName,
    packageVersion: $6537276317917e0c$var$packageVersion
})((0, $aN4Pk.default)({
    onChange: $6537276317917e0c$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $6537276317917e0c$var$packageName,
            packageVersion: $6537276317917e0c$var$packageVersion
        }
    })
})($6537276317917e0c$export$d1de3b251ccaa8a3));
var $6537276317917e0c$export$2e2bcd8739ae039 = $6537276317917e0c$var$Select;

});
parcelRegister("1zt6p", function(module, exports) {

$parcel$export(module.exports, "default", () => $365ac8956e30aa74$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("7F6KA")).default);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $50y9k = parcelRequire("50y9k");

var $7F6KA = parcelRequire("7F6KA");

var $brJma = parcelRequire("brJma");
const $365ac8956e30aa74$var$AsyncSelect = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $7F6KA.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $brJma.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $50y9k.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$365ac8956e30aa74$export$2e2bcd8739ae039 = $365ac8956e30aa74$var$AsyncSelect;

});
parcelRegister("50y9k", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e7f2401405abb51$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gVlse = parcelRequire("gVlse");

var $8XtVW = parcelRequire("8XtVW");

var $4x7Os = parcelRequire("4x7Os");

var $j3gIc = parcelRequire("j3gIc");

var $it5Yo = parcelRequire("it5Yo");
var $htvqm = parcelRequire("htvqm");
var $2EmeP = parcelRequire("2EmeP");

var $4kJdr = parcelRequire("4kJdr");

var $1uib0 = parcelRequire("1uib0");

var $aDCmD = parcelRequire("aDCmD");

var $cy7aP = parcelRequire("cy7aP");

var $1Cwn9 = parcelRequire("1Cwn9");

var $8epPR = parcelRequire("8epPR");
const $1e7f2401405abb51$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $8epPR.isTouchCapable)(),
    captureMenuScroll: !(0, $8epPR.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $cy7aP.createFilter)(),
    formatGroupLabel: (0, $4x7Os.formatGroupLabel),
    getOptionLabel: (0, $4x7Os.getOptionLabel),
    getOptionValue: (0, $4x7Os.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $4x7Os.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $8epPR.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $1e7f2401405abb51$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $1e7f2401405abb51$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $1e7f2401405abb51$var$isOptionSelected(props, option, selectValue);
    const label = $1e7f2401405abb51$var$getOptionLabel(props, option);
    const value = $1e7f2401405abb51$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $1e7f2401405abb51$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$1e7f2401405abb51$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$1e7f2401405abb51$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $1e7f2401405abb51$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $1e7f2401405abb51$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $8epPR.notNullish));
}
function $1e7f2401405abb51$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $1e7f2401405abb51$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $1e7f2401405abb51$var$buildFocusableOptions(props, selectValue) {
    return $1e7f2401405abb51$var$buildFocusableOptionsFromCategorizedOptions($1e7f2401405abb51$var$buildCategorizedOptions(props, selectValue));
}
function $1e7f2401405abb51$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$1e7f2401405abb51$var$shouldHideSelectedOptions(props) || !isSelected) && $1e7f2401405abb51$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $1e7f2401405abb51$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $1e7f2401405abb51$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $1e7f2401405abb51$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $1e7f2401405abb51$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $1e7f2401405abb51$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $1e7f2401405abb51$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $1e7f2401405abb51$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $1e7f2401405abb51$var$getOptionValue(props, option);
    return selectValue.some((i)=>$1e7f2401405abb51$var$getOptionValue(props, i) === candidate);
}
function $1e7f2401405abb51$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $1e7f2401405abb51$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $1e7f2401405abb51$var$instanceId = 1;
class $1e7f2401405abb51$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = $1e7f2401405abb51$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            // for multiple selection options, do not clear the search input value
            if (isMulti && (0, $8XtVW.fg)('platform_do_not_clear_input_for_multiselect')) this.onInputChange(inputValue, {
                action: 'set-value',
                prevInputValue: inputValue
            });
            else this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $8epPR.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $8epPR.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $8epPR.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $8epPR.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $8epPR.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $8epPR.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $8epPR.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $1e7f2401405abb51$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $1e7f2401405abb51$var$buildFocusableOptionsWithIds($1e7f2401405abb51$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $8epPR.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $1e7f2401405abb51$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $1e7f2401405abb51$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = (0, $1Cwn9.defaultStyles)[key](props);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            if (!custom) return base;
            const customStyles = (0, $8epPR.filterUnsupportedSelectors)(custom(base, props));
            return customStyles;
        }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $j3gIc.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$1e7f2401405abb51$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$1e7f2401405abb51$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $8epPR.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $8XtVW.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            this.props.menuIsOpen && this.onMenuClose();
            else this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $1e7f2401405abb51$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus, shouldPreventEscapePropagation: shouldPreventEscapePropagation } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$1e7f2401405abb51$var$instanceId);
        this.state.selectValue = (0, $8epPR.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $1e7f2401405abb51$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $8epPR.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $1e7f2401405abb51$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $1e7f2401405abb51$var$buildFocusableOptionsWithIds($1e7f2401405abb51$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $1e7f2401405abb51$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $1e7f2401405abb51$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $1e7f2401405abb51$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $8epPR.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $8epPR.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $8epPR.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        const focusedOption = focusableOptions[openAtIndex];
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusedOption,
            focusedOptionId: this.getFocusedOptionId(focusedOption)
        }, ()=>this.onMenuOpen());
        (0, $gVlse.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
    }
    updateInputLabel(inputLabel) {
        if (inputLabel) {
            this.inputRef?.setAttribute('aria-label', inputLabel);
            setTimeout(()=>{
                const normalizedLabel = this.props['aria-label'] || this.props.label;
                if (normalizedLabel) this.inputRef?.setAttribute('aria-label', normalizedLabel);
                else this.inputRef?.removeAttribute('aria-label');
            }, 500);
        }
    }
    calculateInputLabel(focusedOption, optionIndex) {
        const { options: options } = this.props;
        const isOptionsGrouped = options?.every((obj)=>typeof obj === 'object' && obj !== null && 'options' in obj);
        let inputLabel = this.getOptionLabel(focusedOption);
        const isOptionFocused = (option)=>{
            return this.getOptionLabel(option) === inputLabel;
        };
        const groupData = options?.find((option)=>{
            const groupCandidate = option;
            return groupCandidate.options?.some(isOptionFocused) ?? false;
        });
        if (isOptionsGrouped) {
            const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
            const totalLength = options?.reduce((acc, currentGroup)=>{
                const group = currentGroup;
                acc += group?.options?.length;
                return acc;
            }, 0);
            inputLabel = `${inputLabel}, ${groupData?.label} (${groupOptionIndex + 1} of ${totalLength})`;
        } else inputLabel = `${inputLabel} (${optionIndex + 1} of ${options?.length})`;
        return inputLabel;
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $1e7f2401405abb51$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $1e7f2401405abb51$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $1e7f2401405abb51$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription() {
        const descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
        const { isMulti: isMulti } = this.props;
        const hasValue = this.state.selectValue.length > 0;
        // Determine base description based on selection state
        const baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
        // Fast path for single select with no description prop
        if (!isMulti && !descriptionProp) return {
            'aria-describedby': baseDescriptionId
        };
        // Build the describedby string efficiently
        let describedBy = baseDescriptionId;
        // Add description prop if it exists
        if (descriptionProp) describedBy = describedBy ? `${descriptionProp} ${describedBy}` : descriptionProp;
        // For multi-select, always add multi-message ID
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            describedBy = describedBy ? `${describedBy} ${multiMessage}` : multiMessage;
        }
        return {
            'aria-describedby': describedBy
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'both',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            // TODO: Might need to remove this
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.calculateDescription()
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $it5Yo.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $8epPR.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $eJOHy.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $eJOHy.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}-remove`
                    },
                    id: `${this.getElementId('selected-value')}-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $gt9Am.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            innerProps: {
                id: this.getElementId('single-value')
            },
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $gt9Am.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled ? undefined : isDisabled,
                'aria-describedby': headingId,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $eJOHy.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $eJOHy.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $gt9Am.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $gt9Am.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aDCmD.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $gt9Am.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2EmeP.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $gt9Am.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    ...this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-labelledby': this.inputRef?.id || this.getElementId('input')
                                    },
                                    'aria-multiselectable': !commonProps.isMulti || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox for safari to announce first option
                                    ...(0, $gVlse.isSafari)() && !this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-describedby': this.inputRef?.id || this.getElementId('input')
                                    }
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            })
                    })
                })
        });
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, $gt9Am.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $htvqm.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1uib0.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions
        });
    }
    renderMultiselectMessage() {
        // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
        // Also, since this is rendered onscreen, it should be transtlated automatically.
        const msg = `, multiple selections available, ${this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : ''}`;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: msg
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $gt9Am.jsxs)(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown,
                ...testId && {
                    'data-testid': testId && `${testId}-select--container`
                }
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            children: [
                this.renderLiveRegion(),
                commonProps.isMulti && this.renderMultiselectMessage(),
                /*#__PURE__*/ (0, $gt9Am.jsxs)(Control, {
                    ...commonProps,
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd,
                        ...testId && {
                            'data-testid': `${testId}-select--control`
                        }
                    },
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsxs)(ValueContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            isCompact: isCompact,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--value-container`
                                },
                                ...commonProps.isMulti && commonProps.hasValue && !(0, $gVlse.isAppleDevice)() && {
                                    // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                    // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                    // DST Accessibility.
                                    role: 'application'
                                }
                            },
                            children: [
                                this.renderPlaceholderOrValue(),
                                this.renderInput()
                            ]
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)(IndicatorsContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--indicators-container`
                                }
                            },
                            children: [
                                this.renderClearIndicator(),
                                this.renderLoadingIndicator(),
                                this.renderDropdownIndicator()
                            ]
                        })
                    ]
                }),
                this.renderMenu(),
                this.renderFormField(),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4kJdr.NotifyOpenLayerObserver), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
}

});
parcelRegister("4x7Os", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $aba71bffce5c1874$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $aba71bffce5c1874$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $aba71bffce5c1874$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $aba71bffce5c1874$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $aba71bffce5c1874$export$f4da216a6ca54656 = (group)=>group.label;
const $aba71bffce5c1874$export$dac6ace3020563ca = (option)=>option.label;
const $aba71bffce5c1874$export$40be908210c5a79c = (option)=>option.value;
const $aba71bffce5c1874$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("j3gIc", function(module, exports) {

$parcel$export(module.exports, "components", () => $6715b02940670574$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $6715b02940670574$export$71abc632aa29e6fe);

var $g9Gxo = parcelRequire("g9Gxo");

var $hY3f4 = parcelRequire("hY3f4");

var $gSw7C = parcelRequire("gSw7C");

var $2gAdz = parcelRequire("2gAdz");

var $a4etB = parcelRequire("a4etB");

var $aDCmD = parcelRequire("aDCmD");

var $fvVLf = parcelRequire("fvVLf");

var $i6ov0 = parcelRequire("i6ov0");

var $fqp3g = parcelRequire("fqp3g");

var $lACl4 = parcelRequire("lACl4");
const $6715b02940670574$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $2gAdz.ClearIndicator),
    Control: (0, $hY3f4.default),
    DropdownIndicator: (0, $2gAdz.DropdownIndicator),
    Group: (0, $gSw7C.default),
    GroupHeading: (0, $gSw7C.GroupHeading),
    IndicatorsContainer: (0, $g9Gxo.IndicatorsContainer),
    Input: (0, $a4etB.default),
    LoadingIndicator: (0, $2gAdz.LoadingIndicator),
    Menu: (0, $aDCmD.default),
    MenuList: (0, $aDCmD.MenuList),
    MenuPortal: (0, $aDCmD.MenuPortal),
    LoadingMessage: (0, $aDCmD.LoadingMessage),
    NoOptionsMessage: (0, $aDCmD.NoOptionsMessage),
    MultiValue: (0, $fvVLf.default),
    MultiValueContainer: (0, $fvVLf.MultiValueContainer),
    MultiValueLabel: (0, $fvVLf.MultiValueLabel),
    MultiValueRemove: (0, $fvVLf.MultiValueRemove),
    Option: (0, $i6ov0.default),
    Placeholder: (0, $fqp3g.default),
    SelectContainer: (0, $g9Gxo.SelectContainer),
    SingleValue: (0, $lACl4.default),
    ValueContainer: (0, $g9Gxo.ValueContainer)
};
const $6715b02940670574$export$71abc632aa29e6fe = (props)=>({
        ...$6715b02940670574$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("g9Gxo", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $27117308313990db$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $27117308313990db$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $27117308313990db$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $27117308313990db$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $27117308313990db$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $27117308313990db$export$d0ffd7e649cab6f);
/* containers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $8XtVW = parcelRequire("8XtVW");

var $8epPR = parcelRequire("8epPR");
const $27117308313990db$export$949392aeaf7d2e3a = ()=>({});
const $27117308313990db$var$containerStyles = {
    default: "_11c82smr _kqswh2mm _lcxv1rj4",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf",
    ff_safari_input_fix: "_11c81ixg _1tn22smr"
};
const $27117308313990db$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $8epPR.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $27117308313990db$var$containerStyles.default,
            isRtl && $27117308313990db$var$containerStyles.rtl,
            isDisabled && $27117308313990db$var$containerStyles.disabled,
            (0, $8XtVW.fg)('platform_design_system_team_safari_input_fix') && $27117308313990db$var$containerStyles.ff_safari_input_fix,
            (0, $k0ahr.cx)(className, xcss, '-container')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
const $27117308313990db$export$47aec73c7aa6b9aa = ()=>({});
const $27117308313990db$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qze3t _u5f312x7 _n3tdze3t _19bv12x7"
};
const $27117308313990db$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $8epPR.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $27117308313990db$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $27117308313990db$var$valueContainerStyles.flex,
            isCompact && $27117308313990db$var$valueContainerStyles.compact,
            (0, $k0ahr.cx)(className, xcss, '-ValueContainer')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
const $27117308313990db$export$9d74e3c8b5868ad7 = ()=>({});
const $27117308313990db$var$indicatorContainerStyles = null;
const $27117308313990db$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $8epPR.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $k0ahr.cx)(className, xcss, '-IndicatorsContainer')
        ]),
        ...innerProps,
        children: children
    });
};

});
parcelRegister("8epPR", function(module, exports) {

$parcel$export(module.exports, "noop", () => $46e429c08f7cfb4f$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $46e429c08f7cfb4f$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $46e429c08f7cfb4f$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $46e429c08f7cfb4f$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $46e429c08f7cfb4f$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $46e429c08f7cfb4f$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $46e429c08f7cfb4f$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $46e429c08f7cfb4f$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $46e429c08f7cfb4f$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $46e429c08f7cfb4f$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $46e429c08f7cfb4f$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $46e429c08f7cfb4f$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $46e429c08f7cfb4f$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $46e429c08f7cfb4f$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $46e429c08f7cfb4f$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $46e429c08f7cfb4f$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $46e429c08f7cfb4f$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $46e429c08f7cfb4f$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $46e429c08f7cfb4f$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $46e429c08f7cfb4f$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $46e429c08f7cfb4f$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $46e429c08f7cfb4f$export$4213b25a1c4e877);
$parcel$export(module.exports, "filterUnsupportedSelectors", () => $46e429c08f7cfb4f$export$bf2eda47afa5f369);
const $46e429c08f7cfb4f$export$8793edee2d425525 = ()=>{};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $46e429c08f7cfb4f$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $46e429c08f7cfb4f$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$46e429c08f7cfb4f$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $46e429c08f7cfb4f$export$33f062f47f21a01 = (value)=>{
    if ($46e429c08f7cfb4f$var$isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $46e429c08f7cfb4f$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $46e429c08f7cfb4f$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $46e429c08f7cfb4f$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $46e429c08f7cfb4f$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $46e429c08f7cfb4f$export$2e0654fad740d2e4(el) {
    if ($46e429c08f7cfb4f$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $46e429c08f7cfb4f$export$c4a223a8ba9e4ea5(el) {
    if ($46e429c08f7cfb4f$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $46e429c08f7cfb4f$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($46e429c08f7cfb4f$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $46e429c08f7cfb4f$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $46e429c08f7cfb4f$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $46e429c08f7cfb4f$export$858c30343199f3af(element, to, duration = 200, callback = $46e429c08f7cfb4f$export$8793edee2d425525) {
    const start = $46e429c08f7cfb4f$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $46e429c08f7cfb4f$var$easeOutCubic(currentTime, start, change, duration);
        $46e429c08f7cfb4f$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $46e429c08f7cfb4f$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $46e429c08f7cfb4f$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $46e429c08f7cfb4f$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $46e429c08f7cfb4f$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $46e429c08f7cfb4f$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $46e429c08f7cfb4f$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $46e429c08f7cfb4f$var$passiveOptionAccessed = false;
const $46e429c08f7cfb4f$var$options = {
    get passive () {
        return $46e429c08f7cfb4f$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $46e429c08f7cfb4f$var$w = typeof window !== 'undefined' ? window : {};
if ($46e429c08f7cfb4f$var$w.addEventListener && $46e429c08f7cfb4f$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $46e429c08f7cfb4f$var$w.addEventListener('p', $46e429c08f7cfb4f$export$8793edee2d425525, $46e429c08f7cfb4f$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $46e429c08f7cfb4f$var$w.removeEventListener('p', $46e429c08f7cfb4f$export$8793edee2d425525, false);
}
const $46e429c08f7cfb4f$export$b0622a6911dbeaf5 = $46e429c08f7cfb4f$var$passiveOptionAccessed;
function $46e429c08f7cfb4f$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $46e429c08f7cfb4f$var$isArray(arg) {
    return Array.isArray(arg);
}
function $46e429c08f7cfb4f$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $46e429c08f7cfb4f$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $46e429c08f7cfb4f$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $46e429c08f7cfb4f$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const $46e429c08f7cfb4f$export$bf2eda47afa5f369 = (styles)=>{
    const unsupportedSelectors = [
        ':',
        '[',
        '>',
        '+',
        '~',
        ' ',
        '*',
        '#',
        '.',
        '@',
        '&',
        '|',
        '^',
        '$',
        '='
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};

});


parcelRegister("hY3f4", function(module, exports) {

$parcel$export(module.exports, "css", () => $fa0dcc37e3c491f7$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $fa0dcc37e3c491f7$export$2e2bcd8739ae039);
/* control.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $8epPR = parcelRequire("8epPR");
const $fa0dcc37e3c491f7$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkosqtm _v564r5cv _1h6d1elr _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _15peftgi _1ke8ftgi _jaboglyw _1u6l1bml _4cvx1elr _123b1h4p _d0altlke _irr31d5g _1oglgxqn",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsq049",
    disabled: "_1h6dsyzs _lcxvglyw _bfhksyzs _1u6llkwx",
    focused: "_1h6d1p6i _bfhkr01l _16qsq049 _1u6lq049 _4cvx1p6i _irr3r01l",
    subtle: "_1h6d3acm _bfhk18uv _1u6lnruj",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d3acm _bfhk18uv _1u6lnruj _4cvx3acm _irr318uv"
};
const $fa0dcc37e3c491f7$export$dbf350e5966cf602 = ()=>({});
const $fa0dcc37e3c491f7$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $8epPR.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $fa0dcc37e3c491f7$var$styles.default,
            isDisabled && $fa0dcc37e3c491f7$var$styles.disabled,
            isInvalid && $fa0dcc37e3c491f7$var$styles.invalid,
            isCompact && $fa0dcc37e3c491f7$var$styles.compact,
            appearance === 'subtle' && $fa0dcc37e3c491f7$var$styles.subtle,
            appearance === 'subtle' && isFocused && $fa0dcc37e3c491f7$var$styles.subtleFocused,
            isFocused && $fa0dcc37e3c491f7$var$styles.focused,
            appearance === 'none' && $fa0dcc37e3c491f7$var$styles.none,
            (0, $k0ahr.cx)(className, xcss, '-control')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        "aria-disabled": isDisabled || undefined,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fa0dcc37e3c491f7$export$2e2bcd8739ae039 = $fa0dcc37e3c491f7$var$Control;

});

parcelRegister("gSw7C", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $27f2d1eb8078b0f1$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $27f2d1eb8078b0f1$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $27f2d1eb8078b0f1$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $27f2d1eb8078b0f1$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $8epPR = parcelRequire("8epPR");
const $27f2d1eb8078b0f1$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
const $27f2d1eb8078b0f1$export$b6794329c1460634 = ()=>({});
const $27f2d1eb8078b0f1$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $8epPR.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $27f2d1eb8078b0f1$var$styles.root,
            (0, $k0ahr.cx)(className, xcss, innerProps?.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, $gt9Am.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                children: children
            })
        ]
    });
};
const $27f2d1eb8078b0f1$var$headingStyles = null;
const $27f2d1eb8078b0f1$export$e5a7fbb542efcb7d = ()=>({});
const $27f2d1eb8078b0f1$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $8epPR.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $8epPR.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            "_11c81o8v _1e0c1ule _syaz1gjq _80om73ad _k48pmoej _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $k0ahr.cx)(className, xcss, '-group')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$27f2d1eb8078b0f1$export$2e2bcd8739ae039 = $27f2d1eb8078b0f1$var$Group;

});

parcelRegister("2gAdz", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $88740c4dc98385b1$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $88740c4dc98385b1$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $88740c4dc98385b1$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $88740c4dc98385b1$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $88740c4dc98385b1$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $88740c4dc98385b1$export$7c20be4c1d342248);
/* indicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $adDYm = parcelRequire("adDYm");

var $iTftd = parcelRequire("iTftd");

var $9M9zY = parcelRequire("9M9zY");
var $hBR2B = parcelRequire("hBR2B");

var $dPlS8 = parcelRequire("dPlS8");

var $8epPR = parcelRequire("8epPR");
// ==============================
// Dropdown & Clear Icons
// ==============================
const $88740c4dc98385b1$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
const $88740c4dc98385b1$var$dropdownWrapperStyles = {
    root: "_ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7"
};
const $88740c4dc98385b1$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1gjq _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf",
    disabled: "_syaz1lh4"
};
const $88740c4dc98385b1$export$e1687335805e1230 = ()=>({});
const $88740c4dc98385b1$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $8epPR.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $88740c4dc98385b1$var$dropdownStyles.default,
            isDisabled && $88740c4dc98385b1$var$dropdownStyles.disabled,
            isCompact && $88740c4dc98385b1$var$dropdownStyles.compact,
            (0, $k0ahr.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: children ? children : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9M9zY.default), {
            as: "span",
            xcss: $88740c4dc98385b1$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adDYm))), {
                color: "currentColor",
                label: "open",
                LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)",
                size: "small"
            })
        })
    });
};
const $88740c4dc98385b1$export$9c0419fd944c1def = ()=>({});
const $88740c4dc98385b1$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz131l _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf"
};
const $88740c4dc98385b1$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $8epPR.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $88740c4dc98385b1$var$clearIndicatorStyles.default,
            isCompact && $88740c4dc98385b1$var$clearIndicatorStyles.compact,
            (0, $k0ahr.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hBR2B.default), {
            xcss: $88740c4dc98385b1$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iTftd))), {
                label: "",
                color: "currentColor",
                LEGACY_size: "small",
                LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)",
                size: "small"
            })
        })
    });
};
const $88740c4dc98385b1$export$1d3f24cde248e6b5 = ()=>({});
const $88740c4dc98385b1$var$loadingIndicatorStyles = {
    default: "_ca0q12x7 _u5f3u2gc _n3td12x7 _19bvu2gc",
    compact: "_ca0qidpf _n3tdidpf"
};
const $88740c4dc98385b1$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $8epPR.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $88740c4dc98385b1$var$loadingIndicatorStyles.default,
            isCompact && $88740c4dc98385b1$var$loadingIndicatorStyles.compact,
            (0, $k0ahr.cx)(className, xcss, '-loadingIndicator')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dPlS8.default), {
            size: "small"
        })
    });
};

});

parcelRegister("a4etB", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $97efc6929b004f4c$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $97efc6929b004f4c$export$2e2bcd8739ae039);
/* input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $8XtVW = parcelRequire("8XtVW");

var $8epPR = parcelRequire("8epPR");
const $97efc6929b004f4c$export$14a7781d0ca7abea = ()=>({});
const $97efc6929b004f4c$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
const $97efc6929b004f4c$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
const $97efc6929b004f4c$var$nativeInputStylesOld = null;
const $97efc6929b004f4c$var$nativeInputStyles = null;
const $97efc6929b004f4c$var$hidden = null;
const $97efc6929b004f4c$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $8epPR.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $8epPR.getStyleProps)(props, 'input', {
        'input-container': true
    });
    if ((0, $8XtVW.fg)('platform_do_not_clear_input_for_multiselect')) return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $97efc6929b004f4c$var$inputStyles.root,
            isDisabled && $97efc6929b004f4c$var$inputStyles.disabled,
            (0, $k0ahr.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $hcewu.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $97efc6929b004f4c$var$inputStylesOld.root,
            isDisabled && $97efc6929b004f4c$var$inputStylesOld.disabled,
            (0, $k0ahr.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $hcewu.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$97efc6929b004f4c$export$2e2bcd8739ae039 = $97efc6929b004f4c$var$Input;

});

parcelRegister("aDCmD", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $ba6e81dcc89f93e2$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $ba6e81dcc89f93e2$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $ba6e81dcc89f93e2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $ba6e81dcc89f93e2$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $ba6e81dcc89f93e2$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $ba6e81dcc89f93e2$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $ba6e81dcc89f93e2$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $ba6e81dcc89f93e2$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $ba6e81dcc89f93e2$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $ba6e81dcc89f93e2$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $ba6e81dcc89f93e2$export$793392f970497feb);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $28gFV = parcelRequire("28gFV");

var $aQK2r = parcelRequire("aQK2r");

var $dsV8x = parcelRequire("dsV8x");

var $h8epd = parcelRequire("h8epd");

var $8epPR = parcelRequire("8epPR");
function $ba6e81dcc89f93e2$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $8epPR.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $8epPR.normalizedHeight)(scrollParent);
    const scrollTop = (0, $8epPR.getScrollTop)(scrollParent);
    const menuTopFromParent = menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $8epPR.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $8epPR.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $8epPR.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $8epPR.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $8epPR.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $ba6e81dcc89f93e2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $ba6e81dcc89f93e2$var$menuStyles = {
    root: "_2rkoglpi _kqswstnw _1bsb1osq _1pbykb7n _otyru2gc _19pku2gc _bfhk1bhr _16qs17uf",
    bottom: "_154i1osq",
    top: "_94n51osq"
};
const $ba6e81dcc89f93e2$export$a228922d5ca42a79 = ()=>({});
const $ba6e81dcc89f93e2$var$PortalPlacementContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $ba6e81dcc89f93e2$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $eJOHy.useContext)($ba6e81dcc89f93e2$var$PortalPlacementContext) || {};
    const ref = (0, $eJOHy.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $eJOHy.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $eJOHy.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $dsV8x.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $ba6e81dcc89f93e2$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $ba6e81dcc89f93e2$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $ba6e81dcc89f93e2$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $8epPR.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $ba6e81dcc89f93e2$var$menuStyles.root,
            $ba6e81dcc89f93e2$var$menuStyles[placement],
            (0, $k0ahr.cx)(xcss, className, '-menu')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ba6e81dcc89f93e2$export$2e2bcd8739ae039 = $ba6e81dcc89f93e2$var$Menu;
const $ba6e81dcc89f93e2$export$abafed69cff95d5e = ()=>({});
const $ba6e81dcc89f93e2$var$menuListStyles = null;
const $ba6e81dcc89f93e2$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $8epPR.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $k0ahr.cx)(className, xcss, '-MenuList')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
// ==============================
// Menu Notices
// ==============================
const $ba6e81dcc89f93e2$var$noticeCSS = ()=>({});
const $ba6e81dcc89f93e2$var$noticeStyles = null;
const $ba6e81dcc89f93e2$export$cf0e22534d8b0074 = $ba6e81dcc89f93e2$var$noticeCSS;
const $ba6e81dcc89f93e2$export$98ec46397a8cb3cd = $ba6e81dcc89f93e2$var$noticeCSS;
const $ba6e81dcc89f93e2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $8epPR.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $k0ahr.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8epd.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
const $ba6e81dcc89f93e2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $8epPR.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $k0ahr.cx)(className, xcss, '-LoadingMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8epd.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
const $ba6e81dcc89f93e2$export$1dbbeb9648d1fdc9 = ()=>({});
const $ba6e81dcc89f93e2$var$menuPortalStyles = {
    root: "_1pbykb7n _1ltva1vk _kqswcp1v _154i1nmo _1bsb1qxj"
};
const $ba6e81dcc89f93e2$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $eJOHy.useRef)(null);
    const cleanupRef = (0, $eJOHy.useRef)(null);
    const [placement, setPortalPlacement] = (0, $eJOHy.useState)($ba6e81dcc89f93e2$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $eJOHy.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $eJOHy.useState)(null);
    const updateComputedPosition = (0, $eJOHy.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $8epPR.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $dsV8x.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $eJOHy.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $28gFV.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $dsV8x.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $eJOHy.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $8epPR.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    });
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $ba6e81dcc89f93e2$var$menuPortalStyles.root,
            (0, $k0ahr.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': `${computedPosition.rect.left}px`,
            '--menu-position': menuPosition,
            '--menu-top': `${computedPosition.offset}px`,
            '--menu-width': `${computedPosition.rect.width}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ba6e81dcc89f93e2$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $aQK2r.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
};

});
parcelRegister("28gFV", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $18d9437f91783eed$export$deee3a793edee05f);

var $lczCq = parcelRequire("lczCq");
var $5WL31 = parcelRequire("5WL31");

var $5WL31 = parcelRequire("5WL31");

var $3rNIs = parcelRequire("3rNIs");
function $18d9437f91783eed$var$getCssDimensions(element) {
    const css = (0, $3rNIs.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $3rNIs.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $5WL31.round)(width) !== offsetWidth || (0, $5WL31.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $18d9437f91783eed$var$unwrapElement(element) {
    return !(0, $3rNIs.isElement)(element) ? element.contextElement : element;
}
function $18d9437f91783eed$var$getScale(element) {
    const domElement = $18d9437f91783eed$var$unwrapElement(element);
    if (!(0, $3rNIs.isHTMLElement)(domElement)) return (0, $5WL31.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $18d9437f91783eed$var$getCssDimensions(domElement);
    let x = ($ ? (0, $5WL31.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $5WL31.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $18d9437f91783eed$var$noOffsets = /*#__PURE__*/ (0, $5WL31.createCoords)(0);
function $18d9437f91783eed$var$getVisualOffsets(element) {
    const win = (0, $3rNIs.getWindow)(element);
    if (!(0, $3rNIs.isWebKit)() || !win.visualViewport) return $18d9437f91783eed$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $18d9437f91783eed$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $3rNIs.getWindow)(element)) return false;
    return isFixed;
}
function $18d9437f91783eed$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $18d9437f91783eed$var$unwrapElement(element);
    let scale = (0, $5WL31.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $3rNIs.isElement)(offsetParent)) scale = $18d9437f91783eed$var$getScale(offsetParent);
        } else scale = $18d9437f91783eed$var$getScale(element);
    }
    const visualOffsets = $18d9437f91783eed$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $18d9437f91783eed$var$getVisualOffsets(domElement) : (0, $5WL31.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $3rNIs.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $3rNIs.isElement)(offsetParent) ? (0, $3rNIs.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $3rNIs.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $18d9437f91783eed$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $3rNIs.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $3rNIs.getWindow)(currentIFrame);
            currentIFrame = (0, $3rNIs.getFrameElement)(currentWin);
        }
    }
    return (0, $5WL31.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $18d9437f91783eed$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $3rNIs.getNodeScroll)(element).scrollLeft;
    if (!rect) return $18d9437f91783eed$var$getBoundingClientRect((0, $3rNIs.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $18d9437f91783eed$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $18d9437f91783eed$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $18d9437f91783eed$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $3rNIs.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $3rNIs.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $5WL31.createCoords)(1);
    const offsets = (0, $5WL31.createCoords)(0);
    const isOffsetParentAnElement = (0, $3rNIs.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3rNIs.getNodeName)(offsetParent) !== 'body' || (0, $3rNIs.isOverflowElement)(documentElement)) scroll = (0, $3rNIs.getNodeScroll)(offsetParent);
        if ((0, $3rNIs.isHTMLElement)(offsetParent)) {
            const offsetRect = $18d9437f91783eed$var$getBoundingClientRect(offsetParent);
            scale = $18d9437f91783eed$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $18d9437f91783eed$var$getHTMLOffset(documentElement, scroll, true) : (0, $5WL31.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $18d9437f91783eed$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $18d9437f91783eed$var$getDocumentRect(element) {
    const html = (0, $3rNIs.getDocumentElement)(element);
    const scroll = (0, $3rNIs.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $5WL31.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $5WL31.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $18d9437f91783eed$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $3rNIs.getComputedStyle)(body).direction === 'rtl') x += (0, $5WL31.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $18d9437f91783eed$var$getViewportRect(element, strategy) {
    const win = (0, $3rNIs.getWindow)(element);
    const html = (0, $3rNIs.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $3rNIs.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $18d9437f91783eed$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $18d9437f91783eed$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $3rNIs.isHTMLElement)(element) ? $18d9437f91783eed$var$getScale(element) : (0, $5WL31.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $18d9437f91783eed$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $18d9437f91783eed$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $18d9437f91783eed$var$getDocumentRect((0, $3rNIs.getDocumentElement)(element));
    else if ((0, $3rNIs.isElement)(clippingAncestor)) rect = $18d9437f91783eed$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $18d9437f91783eed$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $5WL31.rectToClientRect)(rect);
}
function $18d9437f91783eed$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $3rNIs.getParentNode)(element);
    if (parentNode === stopNode || !(0, $3rNIs.isElement)(parentNode) || (0, $3rNIs.isLastTraversableNode)(parentNode)) return false;
    return (0, $3rNIs.getComputedStyle)(parentNode).position === 'fixed' || $18d9437f91783eed$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $18d9437f91783eed$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $3rNIs.getOverflowAncestors)(element, [], false).filter((el)=>(0, $3rNIs.isElement)(el) && (0, $3rNIs.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $3rNIs.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $3rNIs.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $3rNIs.isElement)(currentNode) && !(0, $3rNIs.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $3rNIs.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $3rNIs.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $3rNIs.isOverflowElement)(currentNode) && !currentNodeIsContaining && $18d9437f91783eed$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $3rNIs.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $18d9437f91783eed$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $3rNIs.isTopLayer)(element) ? [] : $18d9437f91783eed$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $18d9437f91783eed$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $5WL31.max)(rect.top, accRect.top);
        accRect.right = (0, $5WL31.min)(rect.right, accRect.right);
        accRect.bottom = (0, $5WL31.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $5WL31.max)(rect.left, accRect.left);
        return accRect;
    }, $18d9437f91783eed$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $18d9437f91783eed$var$getDimensions(element) {
    const { width: width, height: height } = $18d9437f91783eed$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $18d9437f91783eed$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $3rNIs.isHTMLElement)(offsetParent);
    const documentElement = (0, $3rNIs.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $18d9437f91783eed$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $5WL31.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3rNIs.getNodeName)(offsetParent) !== 'body' || (0, $3rNIs.isOverflowElement)(documentElement)) scroll = (0, $3rNIs.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $18d9437f91783eed$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $18d9437f91783eed$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $18d9437f91783eed$var$getHTMLOffset(documentElement, scroll) : (0, $5WL31.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $18d9437f91783eed$var$isStaticPositioned(element) {
    return (0, $3rNIs.getComputedStyle)(element).position === 'static';
}
function $18d9437f91783eed$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $3rNIs.isHTMLElement)(element) || (0, $3rNIs.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $3rNIs.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $18d9437f91783eed$var$getOffsetParent(element, polyfill) {
    const win = (0, $3rNIs.getWindow)(element);
    if ((0, $3rNIs.isTopLayer)(element)) return win;
    if (!(0, $3rNIs.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $3rNIs.getParentNode)(element);
        while(svgOffsetParent && !(0, $3rNIs.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $3rNIs.isElement)(svgOffsetParent) && !$18d9437f91783eed$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $3rNIs.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $18d9437f91783eed$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $3rNIs.isTableElement)(offsetParent) && $18d9437f91783eed$var$isStaticPositioned(offsetParent))offsetParent = $18d9437f91783eed$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $3rNIs.isLastTraversableNode)(offsetParent) && $18d9437f91783eed$var$isStaticPositioned(offsetParent) && !(0, $3rNIs.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $3rNIs.getContainingBlock)(element) || win;
}
const $18d9437f91783eed$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $18d9437f91783eed$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $18d9437f91783eed$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $18d9437f91783eed$var$isRTL(element) {
    return (0, $3rNIs.getComputedStyle)(element).direction === 'rtl';
}
const $18d9437f91783eed$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $18d9437f91783eed$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $3rNIs.getDocumentElement,
    getClippingRect: $18d9437f91783eed$var$getClippingRect,
    getOffsetParent: $18d9437f91783eed$var$getOffsetParent,
    getElementRects: $18d9437f91783eed$var$getElementRects,
    getClientRects: $18d9437f91783eed$var$getClientRects,
    getDimensions: $18d9437f91783eed$var$getDimensions,
    getScale: $18d9437f91783eed$var$getScale,
    isElement: $3rNIs.isElement,
    isRTL: $18d9437f91783eed$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $18d9437f91783eed$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $3rNIs.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $5WL31.floor)(top);
        const insetRight = (0, $5WL31.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $5WL31.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $5WL31.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $5WL31.max)(0, (0, $5WL31.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $18d9437f91783eed$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $18d9437f91783eed$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $3rNIs.getOverflowAncestors)(referenceEl) : [],
        ...(0, $3rNIs.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $18d9437f91783eed$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $18d9437f91783eed$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $18d9437f91783eed$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $18d9437f91783eed$export$37b6bde19b108ecc = (0, $lczCq.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $18d9437f91783eed$export$cc800923e997bb8 = (0, $lczCq.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $18d9437f91783eed$export$91fb6ecbd551914 = (0, $lczCq.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $18d9437f91783eed$export$fba63a578e423eb = (0, $lczCq.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $18d9437f91783eed$export$8a83211c878a3f1f = (0, $lczCq.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $18d9437f91783eed$export$346677f925de839c = (0, $lczCq.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $18d9437f91783eed$export$fe8985bb6374093c = (0, $lczCq.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $18d9437f91783eed$export$f2120bbfa5450bd2 = (0, $lczCq.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $18d9437f91783eed$export$18c8ad048e32c7d5 = (0, $lczCq.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $18d9437f91783eed$export$7bf07e38f3dc4b69 = (0, $lczCq.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $18d9437f91783eed$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $18d9437f91783eed$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $lczCq.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("lczCq", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $f6f6591fac2af23d$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $f6f6591fac2af23d$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $f6f6591fac2af23d$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $f6f6591fac2af23d$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $f6f6591fac2af23d$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $f6f6591fac2af23d$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $f6f6591fac2af23d$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $f6f6591fac2af23d$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $f6f6591fac2af23d$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $f6f6591fac2af23d$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $f6f6591fac2af23d$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("5WL31")).rectToClientRect);

var $5WL31 = parcelRequire("5WL31");
function $f6f6591fac2af23d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $5WL31.getSideAxis)(placement);
    const alignmentAxis = (0, $5WL31.getAlignmentAxis)(placement);
    const alignLength = (0, $5WL31.getAxisLength)(alignmentAxis);
    const side = (0, $5WL31.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $5WL31.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $f6f6591fac2af23d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $f6f6591fac2af23d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $f6f6591fac2af23d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $f6f6591fac2af23d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $5WL31.evaluate)(options, state);
    const paddingObject = (0, $5WL31.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $5WL31.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $5WL31.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f6f6591fac2af23d$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $5WL31.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $5WL31.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $5WL31.getAlignmentAxis)(placement);
            const length = (0, $5WL31.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $5WL31.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $5WL31.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $5WL31.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $5WL31.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $f6f6591fac2af23d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $5WL31.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $5WL31.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $5WL31.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $5WL31.getAlignment)(placement) === alignment || (autoAlignment ? (0, $5WL31.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $f6f6591fac2af23d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $5WL31.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $5WL31.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $5WL31.placements) ? $f6f6591fac2af23d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $f6f6591fac2af23d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $5WL31.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $5WL31.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $5WL31.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $5WL31.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $f6f6591fac2af23d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $5WL31.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $5WL31.getSide)(placement);
            const initialSideAxis = (0, $5WL31.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $5WL31.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $5WL31.getOppositePlacement)(initialPlacement)
            ] : (0, $5WL31.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $5WL31.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $f6f6591fac2af23d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $5WL31.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $5WL31.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $f6f6591fac2af23d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $f6f6591fac2af23d$var$isAnySideFullyClipped(overflow) {
    return (0, $5WL31.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $f6f6591fac2af23d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $5WL31.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $f6f6591fac2af23d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $f6f6591fac2af23d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $f6f6591fac2af23d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $f6f6591fac2af23d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $f6f6591fac2af23d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $f6f6591fac2af23d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $f6f6591fac2af23d$var$getBoundingRect(rects) {
    const minX = (0, $5WL31.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $5WL31.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $5WL31.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $5WL31.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $f6f6591fac2af23d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $5WL31.rectToClientRect)($f6f6591fac2af23d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $f6f6591fac2af23d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $5WL31.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $f6f6591fac2af23d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $5WL31.rectToClientRect)($f6f6591fac2af23d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $5WL31.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $5WL31.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $5WL31.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $5WL31.getSide)(placement) === 'left';
                    const maxRight = (0, $5WL31.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $5WL31.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $f6f6591fac2af23d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $5WL31.getSide)(placement);
    const alignment = (0, $5WL31.getAlignment)(placement);
    const isVertical = (0, $5WL31.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $5WL31.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $f6f6591fac2af23d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $f6f6591fac2af23d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $f6f6591fac2af23d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $5WL31.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $f6f6591fac2af23d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $5WL31.getSideAxis)((0, $5WL31.getSide)(placement));
            const mainAxis = (0, $5WL31.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $5WL31.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $5WL31.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $f6f6591fac2af23d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $5WL31.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $5WL31.getSideAxis)(placement);
            const mainAxis = (0, $5WL31.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $5WL31.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $5WL31.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $f6f6591fac2af23d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $5WL31.evaluate)(options, state);
            const overflow = await $f6f6591fac2af23d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $5WL31.getSide)(placement);
            const alignment = (0, $5WL31.getAlignment)(placement);
            const isYAxis = (0, $5WL31.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $5WL31.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $5WL31.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $5WL31.max)(overflow.left, 0);
                const xMax = (0, $5WL31.max)(overflow.right, 0);
                const yMin = (0, $5WL31.max)(overflow.top, 0);
                const yMax = (0, $5WL31.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $5WL31.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $5WL31.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("5WL31", function(module, exports) {

$parcel$export(module.exports, "sides", () => $4546dd41d380bd3c$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $4546dd41d380bd3c$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $4546dd41d380bd3c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $4546dd41d380bd3c$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $4546dd41d380bd3c$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $4546dd41d380bd3c$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $4546dd41d380bd3c$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $4546dd41d380bd3c$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $4546dd41d380bd3c$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $4546dd41d380bd3c$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $4546dd41d380bd3c$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $4546dd41d380bd3c$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $4546dd41d380bd3c$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $4546dd41d380bd3c$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $4546dd41d380bd3c$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $4546dd41d380bd3c$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $4546dd41d380bd3c$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $4546dd41d380bd3c$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $4546dd41d380bd3c$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $4546dd41d380bd3c$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $4546dd41d380bd3c$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $4546dd41d380bd3c$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $4546dd41d380bd3c$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $4546dd41d380bd3c$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $4546dd41d380bd3c$export$803cd8101b6c182b = /*#__PURE__*/ $4546dd41d380bd3c$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $4546dd41d380bd3c$export$27b07d8a310ed8b5[0], side + "-" + $4546dd41d380bd3c$export$27b07d8a310ed8b5[1]), []);
const $4546dd41d380bd3c$export$96ec731ed4dcb222 = Math.min;
const $4546dd41d380bd3c$export$8960430cfd85939f = Math.max;
const $4546dd41d380bd3c$export$2077e0241d6afd3c = Math.round;
const $4546dd41d380bd3c$export$a3fe094919f356fd = Math.floor;
const $4546dd41d380bd3c$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $4546dd41d380bd3c$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $4546dd41d380bd3c$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $4546dd41d380bd3c$export$7d15b64cf5a3a4c4(start, value, end) {
    return $4546dd41d380bd3c$export$8960430cfd85939f(start, $4546dd41d380bd3c$export$96ec731ed4dcb222(value, end));
}
function $4546dd41d380bd3c$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $4546dd41d380bd3c$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $4546dd41d380bd3c$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $4546dd41d380bd3c$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $4546dd41d380bd3c$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $4546dd41d380bd3c$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($4546dd41d380bd3c$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $4546dd41d380bd3c$export$2b57e0052a6d6d4c(placement) {
    return $4546dd41d380bd3c$export$8a000a963141ac32($4546dd41d380bd3c$export$f28e8f882010718a(placement));
}
function $4546dd41d380bd3c$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $4546dd41d380bd3c$export$f0989780f32bfcda(placement);
    const alignmentAxis = $4546dd41d380bd3c$export$2b57e0052a6d6d4c(placement);
    const length = $4546dd41d380bd3c$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $4546dd41d380bd3c$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $4546dd41d380bd3c$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $4546dd41d380bd3c$export$496432a3699e50b1(placement) {
    const oppositePlacement = $4546dd41d380bd3c$export$9c5e28bad23365fa(placement);
    return [
        $4546dd41d380bd3c$export$2b182c584985588b(placement),
        oppositePlacement,
        $4546dd41d380bd3c$export$2b182c584985588b(oppositePlacement)
    ];
}
function $4546dd41d380bd3c$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$4546dd41d380bd3c$var$oppositeAlignmentMap[alignment]);
}
function $4546dd41d380bd3c$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $4546dd41d380bd3c$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $4546dd41d380bd3c$export$f0989780f32bfcda(placement);
    let list = $4546dd41d380bd3c$var$getSideList($4546dd41d380bd3c$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($4546dd41d380bd3c$export$2b182c584985588b));
    }
    return list;
}
function $4546dd41d380bd3c$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$4546dd41d380bd3c$var$oppositeSideMap[side]);
}
function $4546dd41d380bd3c$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $4546dd41d380bd3c$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $4546dd41d380bd3c$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $4546dd41d380bd3c$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("3rNIs", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $282a7547e1867a69$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $282a7547e1867a69$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $282a7547e1867a69$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $282a7547e1867a69$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $282a7547e1867a69$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $282a7547e1867a69$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $282a7547e1867a69$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $282a7547e1867a69$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $282a7547e1867a69$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $282a7547e1867a69$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $282a7547e1867a69$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $282a7547e1867a69$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $282a7547e1867a69$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $282a7547e1867a69$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $282a7547e1867a69$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $282a7547e1867a69$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $282a7547e1867a69$export$7bf1f8740e3e34af);
function $282a7547e1867a69$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $282a7547e1867a69$export$651544f548703224(node) {
    if ($282a7547e1867a69$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $282a7547e1867a69$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $282a7547e1867a69$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($282a7547e1867a69$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $282a7547e1867a69$export$8ee0fc9ee280b4ee(value) {
    if (!$282a7547e1867a69$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $282a7547e1867a69$export$38b2d434cce3ea22(value).Node;
}
function $282a7547e1867a69$export$45a5e7f76e0caa8d(value) {
    if (!$282a7547e1867a69$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $282a7547e1867a69$export$38b2d434cce3ea22(value).Element;
}
function $282a7547e1867a69$export$1b3bfaa9684536aa(value) {
    if (!$282a7547e1867a69$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $282a7547e1867a69$export$38b2d434cce3ea22(value).HTMLElement;
}
function $282a7547e1867a69$export$af51f0f06c0f328a(value) {
    if (!$282a7547e1867a69$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $282a7547e1867a69$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $282a7547e1867a69$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $282a7547e1867a69$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $282a7547e1867a69$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($282a7547e1867a69$export$651544f548703224(element));
}
function $282a7547e1867a69$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $282a7547e1867a69$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $282a7547e1867a69$export$78551043582a6a98();
    const css = $282a7547e1867a69$export$45a5e7f76e0caa8d(elementOrCss) ? $282a7547e1867a69$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $282a7547e1867a69$export$940d8225183e1404(element) {
    let currentNode = $282a7547e1867a69$export$4e12058fc4d51d56(element);
    while($282a7547e1867a69$export$1b3bfaa9684536aa(currentNode) && !$282a7547e1867a69$export$d1162fb0b6d4cd51(currentNode)){
        if ($282a7547e1867a69$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($282a7547e1867a69$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $282a7547e1867a69$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $282a7547e1867a69$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $282a7547e1867a69$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($282a7547e1867a69$export$651544f548703224(node));
}
function $282a7547e1867a69$export$3735103072e4a80(element) {
    return $282a7547e1867a69$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $282a7547e1867a69$export$dc8fc79fa2800137(element) {
    if ($282a7547e1867a69$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $282a7547e1867a69$export$4e12058fc4d51d56(node) {
    if ($282a7547e1867a69$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $282a7547e1867a69$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $282a7547e1867a69$export$e495491855dc5418(node);
    return $282a7547e1867a69$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $282a7547e1867a69$export$7cd01a57c8ca906c(node) {
    const parentNode = $282a7547e1867a69$export$4e12058fc4d51d56(node);
    if ($282a7547e1867a69$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($282a7547e1867a69$export$1b3bfaa9684536aa(parentNode) && $282a7547e1867a69$export$989e911fa9af580a(parentNode)) return parentNode;
    return $282a7547e1867a69$export$7cd01a57c8ca906c(parentNode);
}
function $282a7547e1867a69$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $282a7547e1867a69$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $282a7547e1867a69$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $282a7547e1867a69$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $282a7547e1867a69$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $282a7547e1867a69$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $282a7547e1867a69$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $282a7547e1867a69$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("dsV8x", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cda3605df4de535$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
var $9cda3605df4de535$export$2e2bcd8739ae039 = (0, $eJOHy.useLayoutEffect);

});


parcelRegister("fvVLf", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $9de7b587512aa326$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $9de7b587512aa326$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $9de7b587512aa326$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $9de7b587512aa326$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $9de7b587512aa326$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $9de7b587512aa326$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $9de7b587512aa326$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $2Eu5z = parcelRequire("2Eu5z");

var $g27F9 = parcelRequire("g27F9");

var $8XtVW = parcelRequire("8XtVW");

var $8epPR = parcelRequire("8epPR");
const $9de7b587512aa326$var$multiValueStyles = {
    root: "_2rkogqwt _1e0c1txw _1ul9ze3t _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _bfhkm7j4 _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1lh4 _bfhkm7j4",
    focused: "_syaz1wum _bfhkfg4m _16qs17si _1aewe4h9 _6up53acm _1xdnnqa1",
    refresh: "_2rkoiti9 _1h6d14je _1dqonqa1 _189ee4h9 _bfhk1j9a"
};
const $9de7b587512aa326$export$23c213f7717186af = ()=>({});
const $9de7b587512aa326$export$f40612612e0af964 = ()=>({});
const $9de7b587512aa326$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkogqwt _11c8dcr7 _o5721q9c _ca0qv77o _u5f3v77o _n3tdv77o _19bv12x7 _syaz1kw7",
    disabled: "_syaz1lh4",
    ellipsis: "_1bto1l2s",
    refresh: "_11c82smr _ca0qidpf _n3tdidpf _19bv1b66"
};
const $9de7b587512aa326$export$283467f6c4ac142b = ()=>({});
const $9de7b587512aa326$var$multiValueRemoveStyles = {
    focused: "_bfhk1km6 _lswu1rrc",
    root: "_2rkovtp2 _4cvr1h6o _1e0c1txw _lswu1dx5 _19bvv77o _u5f3v77o _irr31yvi _13br1jjn _1di61io2 _i5f81jjn",
    refresh: "_19itglyw _2rkoglpi _bfhk1w7a _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _syaz1fxt _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _2hwxv77o _1ah312gs _irr3166n _1di61dty"
};
const $9de7b587512aa326$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $9de7b587512aa326$var$multiValueStyles.root,
            isDisabled && $9de7b587512aa326$var$multiValueStyles.disabled,
            isFocused && $9de7b587512aa326$var$multiValueStyles.focused,
            (0, $8XtVW.fg)('platform-component-visual-refresh') && $9de7b587512aa326$var$multiValueStyles.refresh,
            (0, $k0ahr.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    });
};
const $9de7b587512aa326$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $9de7b587512aa326$var$multiValueLabelStyles.root,
            isDisabled && $9de7b587512aa326$var$multiValueLabelStyles.disabled,
            hasEllipsis && $9de7b587512aa326$var$multiValueLabelStyles.ellipsis,
            (0, $8XtVW.fg)('platform-component-visual-refresh') && $9de7b587512aa326$var$multiValueLabelStyles.refresh,
            (0, $k0ahr.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    });
};
const $9de7b587512aa326$var$disabledStyles = null;
const $9de7b587512aa326$var$enabledStyles = null;
function $9de7b587512aa326$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $9de7b587512aa326$var$multiValueRemoveStyles.root,
            isFocused && $9de7b587512aa326$var$multiValueRemoveStyles.focused,
            (0, $8XtVW.fg)('platform-component-visual-refresh') && $9de7b587512aa326$var$multiValueRemoveStyles.refresh,
            (0, $k0ahr.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $hcewu.default)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Eu5z))), {
                label: "",
                color: "currentColor",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($g27F9))),
                LEGACY_primaryColor: "transparent",
                LEGACY_secondaryColor: "inherit",
                LEGACY_size: "small",
                size: "small"
            })
        })
    });
}
const $9de7b587512aa326$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    const { css: containerCss, className: containerClassName } = (0, $8epPR.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $8epPR.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $8epPR.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${ariaLabel || 'option'}, remove`,
                    ...removeProps
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9de7b587512aa326$export$2e2bcd8739ae039 = $9de7b587512aa326$var$MultiValue;

});

parcelRegister("i6ov0", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $d32c5498d52a8fe1$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $d32c5498d52a8fe1$export$2e2bcd8739ae039);
/* option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $8epPR = parcelRequire("8epPR");
const $d32c5498d52a8fe1$export$ef897119b7e920ba = ()=>({});
const $d32c5498d52a8fe1$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syaz1fxt _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di61dty",
    disabled: "_syaz1lh4 _80om13gf _bfhk18uv _16qsglyw _1di618uv _1pknglyw",
    focused: "_bfhk166n _16qsu4to _1pknj1ic",
    selected: "_syazaqb7 _bfhkfg4m _16qsu4to _1di619ru _1pknj1ic",
    focusedSelected: "_bfhki1yw"
};
const $d32c5498d52a8fe1$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $8epPR.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $d32c5498d52a8fe1$var$optionStyles.root,
            isFocused && $d32c5498d52a8fe1$var$optionStyles.focused,
            isSelected && $d32c5498d52a8fe1$var$optionStyles.selected,
            isFocused && isSelected && $d32c5498d52a8fe1$var$optionStyles.focusedSelected,
            isDisabled && $d32c5498d52a8fe1$var$optionStyles.disabled,
            (0, $k0ahr.cx)(className, xcss, '-option')
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d32c5498d52a8fe1$export$2e2bcd8739ae039 = $d32c5498d52a8fe1$var$Option;

});

parcelRegister("fqp3g", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $e9b59143ec46343e$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $e9b59143ec46343e$export$2e2bcd8739ae039);
/* placeholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $8epPR = parcelRequire("8epPR");
const $e9b59143ec46343e$export$5f3ffacd6594d90f = ()=>({});
const $e9b59143ec46343e$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz131l",
    disabled: "_syaz1lh4"
};
const $e9b59143ec46343e$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $8epPR.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $e9b59143ec46343e$var$placeholderStyles.root,
            isDisabled && $e9b59143ec46343e$var$placeholderStyles.disabled,
            (0, $k0ahr.cx)(className, xcss, '-placeholder')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e9b59143ec46343e$export$2e2bcd8739ae039 = $e9b59143ec46343e$var$Placeholder;

});

parcelRegister("lACl4", function(module, exports) {

$parcel$export(module.exports, "css", () => $2e6c4ac015a53cb6$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $2e6c4ac015a53cb6$export$2e2bcd8739ae039);
/* single-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $8epPR = parcelRequire("8epPR");
const $2e6c4ac015a53cb6$export$dbf350e5966cf602 = ()=>({});
const $2e6c4ac015a53cb6$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1fxt",
    disalbed: "_syaz1lh4"
};
const $2e6c4ac015a53cb6$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $8epPR.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hcewu.default)([
            $2e6c4ac015a53cb6$var$styles.root,
            isDisabled && $2e6c4ac015a53cb6$var$styles.disalbed,
            (0, $k0ahr.cx)(className, xcss, '-singleValue')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2e6c4ac015a53cb6$export$2e2bcd8739ae039 = $2e6c4ac015a53cb6$var$SingleValue;

});


parcelRegister("it5Yo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3b8ce73995af2a1$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8epPR = parcelRequire("8epPR");
const $c3b8ce73995af2a1$var$dummyInputStyles = null;
function $c3b8ce73995af2a1$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $8epPR.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
        ref: innerRef,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d3acm _syaz3acm _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ]),
        ...filteredProps
    });
}

});

parcelRegister("htvqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1ba4510f2ba0fdc$export$2e2bcd8739ae039);
/* required-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9pZRF = parcelRequire("9pZRF");
const $b1ba4510f2ba0fdc$var$styles = null;
const $b1ba4510f2ba0fdc$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $gt9Am.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $9pZRF.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b1ba4510f2ba0fdc$export$2e2bcd8739ae039 = $b1ba4510f2ba0fdc$var$RequiredInput;

});

parcelRegister("2EmeP", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d6c7db6f81008c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $akEMc = parcelRequire("akEMc");

var $68P8N = parcelRequire("68P8N");
const $52d6c7db6f81008c$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $52d6c7db6f81008c$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $akEMc.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $68P8N.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                onClick: $52d6c7db6f81008c$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}

});
parcelRegister("akEMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7afdbd6e04a3891f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8epPR = parcelRequire("8epPR");
const $7afdbd6e04a3891f$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $7afdbd6e04a3891f$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $eJOHy.useRef)(false);
    const isTop = (0, $eJOHy.useRef)(false);
    const touchStart = (0, $eJOHy.useRef)(0);
    const scrollTarget = (0, $eJOHy.useRef)(null);
    const handleEventDelta = (0, $eJOHy.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $7afdbd6e04a3891f$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $eJOHy.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $eJOHy.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $eJOHy.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $eJOHy.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $8epPR.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $eJOHy.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("68P8N", function(module, exports) {

$parcel$export(module.exports, "default", () => $74835699d0eb8615$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $74835699d0eb8615$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $74835699d0eb8615$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $74835699d0eb8615$var$preventTouchMove(e) {
    e.preventDefault();
}
function $74835699d0eb8615$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $74835699d0eb8615$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $74835699d0eb8615$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $74835699d0eb8615$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $74835699d0eb8615$var$activeScrollLocks = 0;
const $74835699d0eb8615$var$listenerOptions = {
    capture: false,
    passive: false
};
function $74835699d0eb8615$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $eJOHy.useRef)({});
    const scrollTarget = (0, $eJOHy.useRef)(null);
    const addScrollLock = (0, $eJOHy.useCallback)((touchScrollTarget)=>{
        if (!$74835699d0eb8615$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $74835699d0eb8615$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $74835699d0eb8615$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($74835699d0eb8615$var$LOCK_STYLES).forEach((key)=>{
                const val = $74835699d0eb8615$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $74835699d0eb8615$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $74835699d0eb8615$var$preventTouchMove, $74835699d0eb8615$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $74835699d0eb8615$var$preventInertiaScroll, $74835699d0eb8615$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $74835699d0eb8615$var$allowTouchMove, $74835699d0eb8615$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $74835699d0eb8615$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $eJOHy.useCallback)((touchScrollTarget)=>{
        if (!$74835699d0eb8615$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $74835699d0eb8615$var$activeScrollLocks = Math.max($74835699d0eb8615$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $74835699d0eb8615$var$activeScrollLocks < 1) $74835699d0eb8615$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $74835699d0eb8615$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $74835699d0eb8615$var$preventTouchMove, $74835699d0eb8615$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $74835699d0eb8615$var$preventInertiaScroll, $74835699d0eb8615$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $74835699d0eb8615$var$allowTouchMove, $74835699d0eb8615$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("4kJdr", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $8fc140437722ecc8$export$17baa7c95b6ba1b8);

var $8c14o = parcelRequire("8c14o");
function $8fc140437722ecc8$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore - hot-116676
    (0, $8c14o.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("1uib0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d53c90f0e3785125$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3x63J = parcelRequire("3x63J");

var $8jZEu = parcelRequire("8jZEu");
const $d53c90f0e3785125$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isOptionDisabled: isOptionDisabled, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, isLoading: isLoading } = selectProps;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $eJOHy.useMemo)(()=>({
            ...(0, $3x63J.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $eJOHy.useMemo)(()=>{
        let message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    const ariaResults = (0, $eJOHy.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ScreenReaderText = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            })
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jZEu.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jZEu.default), {
                "aria-live": ariaLive,
                role: "status",
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d53c90f0e3785125$export$2e2bcd8739ae039 = $d53c90f0e3785125$var$LiveRegion;

});
parcelRegister("3x63J", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $927e44a6f4526091$export$a7265767c78f9bae);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ const $927e44a6f4526091$export$a7265767c78f9bae = {
    onChange: (props)=>{
        const { action: action, label: label = '', isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? `option ${label}, deselected` : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? `option ${label}, selected.` : '';
            default:
                return '';
        }
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return inputValue ? `${resultsMessage} for search term ${inputValue}.` : '';
    }
};

});

parcelRegister("8jZEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd0be9ad3488841d$export$2e2bcd8739ae039);
/* a11y-text.tsx generated by @compiled/babel-plugin v0.36.1 */ // Assistive text to describe visual elements. Hidden for sighted users.

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $cd0be9ad3488841d$var$styles = null;
const $cd0be9ad3488841d$var$A11yText = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ]),
        ...props
    });
var $cd0be9ad3488841d$export$2e2bcd8739ae039 = $cd0be9ad3488841d$var$A11yText;

});


parcelRegister("cy7aP", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $53787bdcec4d8be4$export$5d81789ff4aeccdf);

var $LFmXM = parcelRequire("LFmXM");

var $kZijN = parcelRequire("kZijN");
const $53787bdcec4d8be4$var$memoizedStripDiacriticsForInput = (0, $LFmXM.default)((0, $kZijN.stripDiacritics));
const $53787bdcec4d8be4$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $53787bdcec4d8be4$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $53787bdcec4d8be4$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $53787bdcec4d8be4$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $53787bdcec4d8be4$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $53787bdcec4d8be4$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $53787bdcec4d8be4$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $kZijN.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("kZijN", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $251f4c31eaea6a6c$export$b5bee4b27048330b);
const $251f4c31eaea6a6c$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $251f4c31eaea6a6c$var$anyDiacritic = new RegExp('[' + $251f4c31eaea6a6c$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $251f4c31eaea6a6c$var$diacriticToBase = {};
for(let i = 0; i < $251f4c31eaea6a6c$var$diacritics.length; i++){
    let diacritic = $251f4c31eaea6a6c$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$251f4c31eaea6a6c$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $251f4c31eaea6a6c$export$b5bee4b27048330b = (str)=>{
    return str.replace($251f4c31eaea6a6c$var$anyDiacritic, (match)=>$251f4c31eaea6a6c$var$diacriticToBase[match]);
};

});


parcelRegister("1Cwn9", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $2b81b640e895a543$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $2b81b640e895a543$export$e618dc39ac9ad607);

var $g9Gxo = parcelRequire("g9Gxo");

var $hY3f4 = parcelRequire("hY3f4");

var $gSw7C = parcelRequire("gSw7C");

var $2gAdz = parcelRequire("2gAdz");

var $a4etB = parcelRequire("a4etB");

var $aDCmD = parcelRequire("aDCmD");

var $fvVLf = parcelRequire("fvVLf");

var $i6ov0 = parcelRequire("i6ov0");

var $fqp3g = parcelRequire("fqp3g");

var $lACl4 = parcelRequire("lACl4");
const $2b81b640e895a543$export$214b055320e0bf32 = {
    clearIndicator: (0, $2gAdz.clearIndicatorCSS),
    container: (0, $g9Gxo.containerCSS),
    control: (0, $hY3f4.css),
    dropdownIndicator: (0, $2gAdz.dropdownIndicatorCSS),
    group: (0, $gSw7C.groupCSS),
    groupHeading: (0, $gSw7C.groupHeadingCSS),
    indicatorsContainer: (0, $g9Gxo.indicatorsContainerCSS),
    input: (0, $a4etB.inputCSS),
    loadingIndicator: (0, $2gAdz.loadingIndicatorCSS),
    loadingMessage: (0, $aDCmD.loadingMessageCSS),
    menu: (0, $aDCmD.menuCSS),
    menuList: (0, $aDCmD.menuListCSS),
    menuPortal: (0, $aDCmD.menuPortalCSS),
    multiValue: (0, $fvVLf.multiValueCSS),
    multiValueLabel: (0, $fvVLf.multiValueLabelCSS),
    multiValueRemove: (0, $fvVLf.multiValueRemoveCSS),
    noOptionsMessage: (0, $aDCmD.noOptionsMessageCSS),
    option: (0, $i6ov0.optionCSS),
    placeholder: (0, $fqp3g.placeholderCSS),
    singleValue: (0, $lACl4.css),
    valueContainer: (0, $g9Gxo.valueContainerCSS)
};
function $2b81b640e895a543$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});


parcelRegister("7F6KA", function(module, exports) {

$parcel$export(module.exports, "default", () => $305182d903b89a0a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8epPR = parcelRequire("8epPR");
function $305182d903b89a0a$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $eJOHy.useRef)(undefined);
    const mounted = (0, $eJOHy.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $eJOHy.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $eJOHy.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $eJOHy.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $eJOHy.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $eJOHy.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $eJOHy.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $eJOHy.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $eJOHy.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $eJOHy.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $eJOHy.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $eJOHy.useCallback)((newValue, actionMeta)=>{
        const inputValue = (0, $8epPR.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("brJma", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2773e0ebfc35019$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $a2773e0ebfc35019$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $eJOHy.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $eJOHy.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $eJOHy.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $eJOHy.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $eJOHy.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $eJOHy.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $eJOHy.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("5lI1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $126b66fa9f77441c$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $126b66fa9f77441c$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eJOHy.useRef)(null);
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eJOHy.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});



parcelRegister("jiIAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd8165cdaaceeac8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4BzUI = parcelRequire("4BzUI");

var $9JB3T = parcelRequire("9JB3T");

var $jNgT9 = parcelRequire("jNgT9");

var $7kbZQ = parcelRequire("7kbZQ");
const $bd8165cdaaceeac8$var$TOOLTIP_CONTENT_REFRESH_INTERVAL = 2500;
const $bd8165cdaaceeac8$var$CopyButton = (props)=>{
    const [linkCopied, setLinkCopied] = (0, $eJOHy.useState)(false);
    const [message, setMessage] = (0, $eJOHy.useState)(`Copy ${props.label}`);
    const updateTooltip = (0, $eJOHy.useRef)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        message
    ]);
    const copyLink = (0, $eJOHy.useCallback)(async ()=>{
        if (typeof globalThis !== 'undefined' && globalThis.navigator?.clipboard) try {
            await globalThis.navigator.clipboard.writeText(props.value);
            setLinkCopied(true);
            setMessage('Copied');
            setTimeout(()=>{
                setLinkCopied(false);
                setMessage(`Copy ${props.label}`);
            }, $bd8165cdaaceeac8$var$TOOLTIP_CONTENT_REFRESH_INTERVAL);
        } catch (error) {
        // TODO: Handle error case where clipboard write fails
        }
    }, [
        props.label,
        props.value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return message;
        },
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BzUI.default), {
        appearance: "subtle",
        icon: linkCopied ? (0, (/*@__PURE__*/$parcel$interopDefault($7kbZQ))) : (0, (/*@__PURE__*/$parcel$interopDefault($jNgT9))),
        label: `Copy ${props.label}`,
        isTooltipDisabled: true,
        onClick: copyLink
    }));
};
var $bd8165cdaaceeac8$export$2e2bcd8739ae039 = $bd8165cdaaceeac8$var$CopyButton;

});
parcelRegister("jNgT9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e68fb1a00f2e12e0$var$_react = $e68fb1a00f2e12e0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e68fb1a00f2e12e0$var$_baseNew = $e68fb1a00f2e12e0$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $e68fb1a00f2e12e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e68fb1a00f2e12e0$var$CopyIcon = (props)=>/*#__PURE__*/ $e68fb1a00f2e12e0$var$_react.default.createElement($e68fb1a00f2e12e0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$e68fb1a00f2e12e0$var$CopyIcon.displayName = 'CopyIcon';
var $e68fb1a00f2e12e0$var$_default = module.exports.default = $e68fb1a00f2e12e0$var$CopyIcon;

});


parcelRegister("e7C36", function(module, exports) {

$parcel$export(module.exports, "validateURLField", () => $ff55c6cd2437b378$export$2ad6818b3d68393f);
$parcel$export(module.exports, "validateSupportedScopes", () => $ff55c6cd2437b378$export$7abf746ed63ce29a);

var $8dH3d = parcelRequire("8dH3d");

var $eNS8S = parcelRequire("eNS8S");
const $ff55c6cd2437b378$export$7cc6bb943616cddf = [
    'http:',
    'https:'
];
const $ff55c6cd2437b378$export$2ad6818b3d68393f = (value, isRequired, checkScheme)=>{
    if (!value) return isRequired ? $ff55c6cd2437b378$export$af1e14e964849c8c.empty : undefined;
    const trimmedValue = value?.trim();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(trimmedValue) && isRequired) return $ff55c6cd2437b378$export$af1e14e964849c8c.empty;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(trimmedValue) && !(0, $eNS8S.isValidUrl)(value)) return $ff55c6cd2437b378$export$af1e14e964849c8c.urlInvalid;
    if (checkScheme && !$ff55c6cd2437b378$export$7cc6bb943616cddf.some((scheme)=>value.startsWith(scheme))) return $ff55c6cd2437b378$export$af1e14e964849c8c.urlSchemeInvalid;
    return undefined;
};
const $ff55c6cd2437b378$export$7abf746ed63ce29a = (chosenScopes, supportedScopes)=>{
    const invalidScopes = chosenScopes.filter((scope)=>!supportedScopes.includes(scope));
    if (invalidScopes.length > 0) return $ff55c6cd2437b378$export$af1e14e964849c8c.unsupportedScope;
    return undefined;
};
const $ff55c6cd2437b378$export$af1e14e964849c8c = {
    empty: 'This field is required.',
    urlInvalid: 'Enter a valid URL.',
    urlSchemeInvalid: 'The URL must start with http:// or https://.',
    authTypeInvalid: 'Select a valid authentication type.',
    impersonationNotAllowed: '2LO (impersonation) is deprecated. Please choose another authentication type.',
    unsupportedScope: 'One or more selected scopes are not supported.'
};

});
parcelRegister("eNS8S", function(module, exports) {

$parcel$export(module.exports, "isValidUrl", () => $ae6a7d95440d0325$export$bef94a5618bf18bf);
$parcel$export(module.exports, "default", () => $ae6a7d95440d0325$export$2e2bcd8739ae039);
/**
 * The URL standard regex for spec.: RFC 3986
 * https://tools.ietf.org/html/rfc3986#page-51
 */ const $ae6a7d95440d0325$var$URLStandardRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?');
/**
 * Full Domain name limits as per RFC is 256 characters
 * TLD limit as per RFC 1035 is 63 characters. Although, TLDs can contain numbers, since none of the existing popular TLDs are numbers, we are not allowing numbers in TLD.
 * Any characters allowed in protocol and query string. Domain name needs to be alphanumeric with hyphens allowed.
 */ const $ae6a7d95440d0325$var$stricterURLRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?[-a-zA-Z0-9@:.]{2,256}.[a-z]{2,63}\\b([-a-zA-Z0-9@:%_+.~#?&//=]*)');
const $ae6a7d95440d0325$var$protocolRegex = new RegExp('^(http|https|ftp)://.*|^//[^/]*?');
function $ae6a7d95440d0325$export$bef94a5618bf18bf(string, strict = false) {
    // Have to be string
    if (!string || typeof string !== 'string') return false;
    // Exit early if there is a space, no need to regex that
    if (string.indexOf(' ') >= 0 || string.length === 0) return false;
    // Localhost is bit different, doesn't need a dot but others likely should
    if (string.indexOf('localhost') === -1 && string.indexOf('.') === -1) return false;
    if (strict === true) return $ae6a7d95440d0325$var$stricterURLRegex.test(string) || $ae6a7d95440d0325$var$protocolRegex.test(string);
    return $ae6a7d95440d0325$var$URLStandardRegex.test(string);
}
var $ae6a7d95440d0325$export$2e2bcd8739ae039 = $ae6a7d95440d0325$export$bef94a5618bf18bf;

});



parcelRegister("ffsuj", function(module, exports) {

$parcel$export(module.exports, "STATUS_RECIPROCAL_SUCCESS", () => $a03bf89b29beef2f$export$657b6c684cdb0f25);
$parcel$export(module.exports, "STATUS_RECIPROCAL_INPROGRESS", () => $a03bf89b29beef2f$export$ebb855fc01c4dac8);
$parcel$export(module.exports, "updateStatusLog", () => $a03bf89b29beef2f$export$9f0778ce9e00d11);
$parcel$export(module.exports, "getApplinksAdminUrl", () => $a03bf89b29beef2f$export$78ab2fbb731a208e);
$parcel$export(module.exports, "getDefaultCreationState", () => $a03bf89b29beef2f$export$c97322013e85b0a3);
$parcel$export(module.exports, "generateApplinksCreationRedirectionUrl", () => $a03bf89b29beef2f$export$a227964e32a1613e);
$parcel$export(module.exports, "parseCreationStateFromUrl", () => $a03bf89b29beef2f$export$a3c0d7af5d0c8b3);
// The Applinks Status Log format
// We use this to interchange between the various products
// Refer to `AppLinks.Creation.generateApplinksCreationRedirectionUrl` in
// legacy frontend for more details

var $d6B0e = parcelRequire("d6B0e");
const $a03bf89b29beef2f$export$83a5ccd32faf0509 = 'completed.creation';
const $a03bf89b29beef2f$export$46ec94e31f2d2bee = 'failed.creation';
const $a03bf89b29beef2f$export$9c895fb851e899e2 = 'inprogress.creation';
const $a03bf89b29beef2f$export$4ef4887476a06719 = 'completed.creation.local';
const $a03bf89b29beef2f$export$657b6c684cdb0f25 = 'completed.creation.reciprocal';
const $a03bf89b29beef2f$export$ebb855fc01c4dac8 = 'inprogress.creation.reciprocal';
const $a03bf89b29beef2f$export$a5b9f0b29d12c743 = 'failed.creation.local';
const $a03bf89b29beef2f$export$151e8c78ee009a44 = 'failed.creation.reciprocal';
const $a03bf89b29beef2f$export$ce29b766ff657ea1 = 'failed.registerprovider.2loi';
const $a03bf89b29beef2f$export$a38352a15fd9f0ce = (entries)=>{
    return entries;
};
const $a03bf89b29beef2f$export$9f0778ce9e00d11 = (statusLog, newEntry)=>{
    return [
        ...statusLog,
        newEntry
    ];
};
const $a03bf89b29beef2f$export$78ab2fbb731a208e = (remoteBaseUrl, typeId)=>{
    const suffix = typeId === 'confluence' ? '/admin/listapplicationlinks.action' : (0, $d6B0e.APPLINKS_LIST_PAGE_URL);
    return remoteBaseUrl + suffix;
};
const $a03bf89b29beef2f$export$c97322013e85b0a3 = (startingUrl, startingTypeId, originalCreatedId)=>{
    return {
        applinkCreationStatusLog: $a03bf89b29beef2f$export$a38352a15fd9f0ce([
            {
                status: $a03bf89b29beef2f$export$9c895fb851e899e2
            },
            {
                status: $a03bf89b29beef2f$export$4ef4887476a06719
            },
            {
                status: $a03bf89b29beef2f$export$ebb855fc01c4dac8
            }
        ]),
        applinkOriginalCreatedId: originalCreatedId,
        sharedUserbase: false,
        applinkConfigInUserAuth: true,
        applinkConfigInServerAuth: true,
        applinkConfigInPreAuth: true,
        applinkConfigOutUserAuth: true,
        applinkConfigOutServerAuth: true,
        applinkConfigOutPreAuth: true,
        applinkStartingUrl: startingUrl,
        applinkStartingType: startingTypeId,
        creatingReciprocal: true
    };
};
const $a03bf89b29beef2f$var$generateUrl = (remoteUrl, parametersMap)=>{
    if (!parametersMap || Object.keys(parametersMap).length === 0) return remoteUrl;
    const params = Object.entries(parametersMap).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
    return remoteUrl.includes('?') ? `${remoteUrl}&${params}` : `${remoteUrl}?${params}`;
};
const $a03bf89b29beef2f$export$a227964e32a1613e = (remoteBaseUrl, remoteTypeId, creationState)=>{
    // In the original applinks frontend, the status log was stored as a string. This means in the final URL,
    // the status log is double stringified. This is a hack to maintain compatibility with the legacy frontend.
    const parameterMap = Object.fromEntries(Object.entries(creationState).map(([key, value])=>{
        if (key === 'applinkCreationStatusLog') // Yes, I know it's awful
        return [
            key,
            JSON.stringify(JSON.stringify(creationState.applinkCreationStatusLog))
        ];
        return [
            key,
            JSON.stringify(value)
        ];
    }));
    return $a03bf89b29beef2f$var$generateUrl($a03bf89b29beef2f$export$78ab2fbb731a208e(remoteBaseUrl, remoteTypeId), parameterMap);
};
const $a03bf89b29beef2f$var$getAndDecode = (url, param)=>{
    const value = url.searchParams.get(param);
    if (value !== null) {
        const decodedFieldValue = decodeURIComponent(value);
        try {
            // @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
            return value ? JSON.parse(decodedFieldValue) : null;
        } catch  {
            // If parsing fails, we return the decoded value as-is
            return decodedFieldValue;
        }
    }
    return undefined;
};
const $a03bf89b29beef2f$export$a3c0d7af5d0c8b3 = (url)=>{
    const applinkCreationStatusLog = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkCreationStatusLog');
    if (!applinkCreationStatusLog) return null; // No creation state found
    const applinkStartingUrl = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkStartingUrl');
    const applinkStartingType = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkStartingType');
    const applinkOriginalCreatedId = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkOriginalCreatedId');
    const sharedUserbase = $a03bf89b29beef2f$var$getAndDecode(url, 'sharedUserbase') === 'true';
    const applinkConfigInUserAuth = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkConfigInUserAuth') === 'true';
    const applinkConfigInServerAuth = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkConfigInServerAuth') === 'true';
    const applinkConfigInPreAuth = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkConfigInPreAuth') === 'true';
    const applinkConfigOutUserAuth = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkConfigOutUserAuth') === 'true';
    const applinkConfigOutServerAuth = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkConfigOutServerAuth') === 'true';
    const applinkConfigOutPreAuth = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkConfigOutPreAuth') === 'true';
    const creatingReciprocal = $a03bf89b29beef2f$var$getAndDecode(url, 'creatingReciprocal') === 'true';
    const statusLog = JSON.parse(applinkCreationStatusLog);
    return {
        applinkCreationStatusLog: statusLog,
        applinkOriginalCreatedId: applinkOriginalCreatedId || '',
        sharedUserbase: sharedUserbase,
        applinkConfigInUserAuth: applinkConfigInUserAuth,
        applinkConfigInServerAuth: applinkConfigInServerAuth,
        applinkConfigInPreAuth: applinkConfigInPreAuth,
        applinkConfigOutUserAuth: applinkConfigOutUserAuth,
        applinkConfigOutServerAuth: applinkConfigOutServerAuth,
        applinkConfigOutPreAuth: applinkConfigOutPreAuth,
        applinkStartingUrl: applinkStartingUrl || '',
        applinkStartingType: applinkStartingType || '',
        creatingReciprocal: creatingReciprocal
    };
};

});

parcelRegister("5zNo1", function(module, exports) {

$parcel$export(module.exports, "incomingCredentialsModalEntryPoint", () => $0dc38e9ae2ff4812$export$83a05a90dc4ecbdf);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $0dc38e9ae2ff4812$export$83a05a90dc4ecbdf = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("loxSE")), {
        moduleId: "d157ea8e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("loxSE", function(module, exports) {

let $f9361ed3fa71f06a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f9361ed3fa71f06a$var$load("htcTF").then(()=>parcelRequire('6kVIO'));

});



parcelRegister("40lC8", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa35e4554f311350$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $dhRXV = parcelRequire("dhRXV");
var $9M9zY = parcelRequire("9M9zY");
var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");

var $jtnjR = parcelRequire("jtnjR");
var $7BnZ9 = parcelRequire("7BnZ9");
var $1Xk9R = parcelRequire("1Xk9R");
var $emAda = parcelRequire("emAda");
var $11ahJ = parcelRequire("11ahJ");

var $pUkPE = parcelRequire("pUkPE");

var $alkjW = parcelRequire("alkjW");
var $kQDPJ = parcelRequire("kQDPJ");

var $8TCso = parcelRequire("8TCso");

var $51Gwp = parcelRequire("51Gwp");

var $dPlS8 = parcelRequire("dPlS8");

var $7jTnu = parcelRequire("7jTnu");

var $83DiZ = parcelRequire("83DiZ");

var $8SMrZ = parcelRequire("8SMrZ");

var $d6B0e = parcelRequire("d6B0e");

var $dk6v8 = parcelRequire("dk6v8");

var $a4pY2 = parcelRequire("a4pY2");

var $ffsuj = parcelRequire("ffsuj");

var $6OnPZ = parcelRequire("6OnPZ");
const $aa35e4554f311350$var$styles = {
    growField: "_16jlkb7n",
    dividerStyle: "_189ee4h9 _1dqonqa1 _1h6dmuej _1bsb1osq _19pkpxbi",
    formSectionInner: "_19pkpxbi",
    fieldNegativeMargin: "_19pkx0bf",
    colDirection: "_1bsbx19p",
    colOutgoing: "_1bsbhwvj",
    colIncoming: "_1bsbhwvj"
};
const $aa35e4554f311350$var$AUTH_OAUTH1_IMPERSONATION = {
    label: 'OAuth (impersonation)',
    value: 'oauthWithImpersonation'
};
const $aa35e4554f311350$var$AUTH_OAUTH1 = {
    label: 'OAuth',
    value: 'oauth'
};
const $aa35e4554f311350$var$AUTH_DISABLED = {
    label: 'Disabled',
    value: 'disabled'
};
const $aa35e4554f311350$var$AUTH_UNKNOWN = {
    label: 'Unknown',
    value: 'unknown'
};
// This one should never be shown to the user (as this page is for OAuth 1.0), but
// in the event it is, provides a 'more correct' value for troubleshooting.
const $aa35e4554f311350$var$AUTH_OAUTH2 = {
    label: 'OAuth 2.0',
    value: 'oauth2ThreeLo'
};
const $aa35e4554f311350$var$AUTH_TYPES = [
    $aa35e4554f311350$var$AUTH_OAUTH1,
    $aa35e4554f311350$var$AUTH_OAUTH1_IMPERSONATION,
    $aa35e4554f311350$var$AUTH_DISABLED
];
const $aa35e4554f311350$var$getAuthLevel = (config)=>{
    if (!config) return $aa35e4554f311350$var$AUTH_UNKNOWN;
    if (config.enabled && config.twoLoEnabled && config.twoLoImpersonationEnabled) return $aa35e4554f311350$var$AUTH_OAUTH1_IMPERSONATION;
    if (config.enabled && !config.twoLoImpersonationEnabled) return $aa35e4554f311350$var$AUTH_OAUTH1;
    if (config.oAuth2ThreeLoEnabled) return $aa35e4554f311350$var$AUTH_OAUTH2;
    if (!config.enabled && !config.twoLoEnabled && !config.twoLoImpersonationEnabled && !config.oAuth2ThreeLoEnabled) return $aa35e4554f311350$var$AUTH_DISABLED;
    return $aa35e4554f311350$var$AUTH_UNKNOWN;
};
const $aa35e4554f311350$var$matchOAuthConfigs = (localAuthLevel, remoteAuthLevel)=>{
    if (!localAuthLevel || !remoteAuthLevel) return 'mismatch';
    if (localAuthLevel.value === remoteAuthLevel.value) {
        if (localAuthLevel.value === $aa35e4554f311350$var$AUTH_DISABLED.value) return 'disabled';
        return 'match';
    }
    return 'mismatch';
};
const $aa35e4554f311350$var$ApplinksConnectedArrow = (props)=>{
    // Render the appropriate arrow icon based on the connection state
    return props.isIncoming ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        height: "16px",
        src: (0, $6OnPZ.Arrows).incoming[props.state],
        alt: (0, $6OnPZ.ArrowDescription).incoming[props.state]
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        height: "16px",
        src: (0, $6OnPZ.Arrows).outgoing[props.state],
        alt: (0, $6OnPZ.ArrowDescription).outgoing[props.state]
    });
};
const $aa35e4554f311350$var$ApplinksAuthSelect = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $aa35e4554f311350$var$styles.fieldNegativeMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7BnZ9.default), {
        name: props.name,
        defaultValue: props.defaultValue
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8TCso.default), {
            ...fieldProps,
            inputId: props.name,
            options: $aa35e4554f311350$var$AUTH_TYPES
        })));
};
const $aa35e4554f311350$var$LocalAuthDetails = (props)=>{
    const getAuthOptionFromConfig = (0, $eJOHy.useCallback)(()=>{
        return $aa35e4554f311350$var$getAuthLevel(props.defaultOAuthConfig);
    }, [
        props.defaultOAuthConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $aa35e4554f311350$var$styles.growField
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa35e4554f311350$var$ApplinksAuthSelect, {
        name: props.name,
        defaultValue: getAuthOptionFromConfig()
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa35e4554f311350$var$ApplinksConnectedArrow, {
        isIncoming: props.isIncoming,
        state: props.state
    }));
};
const $aa35e4554f311350$var$RemoteAuthDetails = (props)=>{
    const getAuthDescription = (0, $eJOHy.useCallback)(()=>{
        return $aa35e4554f311350$var$getAuthLevel(props.oauthConfig).label;
    }, [
        props.oauthConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        space: "space.100"
    }, props.type.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
        appearance: "subtle",
        href: props.url
    }, props.type.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, getAuthDescription()));
};
const $aa35e4554f311350$var$ConfigureAuthTable = (props)=>{
    const formState = (0, $11ahJ.useFormState)({
        values: true
    });
    const getApplinkType = (0, $eJOHy.useCallback)(()=>{
        return (0, $a4pY2.lookupTypeFromV3Data)(props.applink);
    }, [
        props.applink
    ]);
    const getOutgoingMatchState = (0, $eJOHy.useCallback)(()=>{
        return $aa35e4554f311350$var$matchOAuthConfigs(formState?.values.outgoingAuth, $aa35e4554f311350$var$getAuthLevel(props.remoteAuth?.incoming));
    }, [
        props.remoteAuth,
        formState?.values.outgoingAuth
    ]);
    const getIncomingMatchState = (0, $eJOHy.useCallback)(()=>{
        return $aa35e4554f311350$var$matchOAuthConfigs(formState?.values.incomingAuth, $aa35e4554f311350$var$getAuthLevel(props.remoteAuth?.outgoing));
    }, [
        props.remoteAuth,
        formState?.values.incomingAuth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("table", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("colgroup", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("col", {
        className: (0, $hcewu.default)([
            $aa35e4554f311350$var$styles.colDirection
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("col", {
        className: (0, $hcewu.default)([
            $aa35e4554f311350$var$styles.colOutgoing
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("col", {
        className: (0, $hcewu.default)([
            $aa35e4554f311350$var$styles.colIncoming
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("th", null, "Direction"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("th", null, "Local authentication"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("th", null, "Remote authentication"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tbody", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", null, "Outgoing"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa35e4554f311350$var$LocalAuthDetails, {
        isIncoming: false,
        state: getOutgoingMatchState(),
        name: "outgoingAuth",
        defaultOAuthConfig: props.localAuth?.outgoing
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa35e4554f311350$var$RemoteAuthDetails, {
        type: getApplinkType(),
        url: props.applink.displayUrl,
        oauthConfig: props.remoteAuth?.incoming
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", null, "Incoming"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa35e4554f311350$var$LocalAuthDetails, {
        isIncoming: true,
        state: getIncomingMatchState(),
        name: "incomingAuth",
        defaultOAuthConfig: props.localAuth?.incoming
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa35e4554f311350$var$RemoteAuthDetails, {
        type: getApplinkType(),
        url: props.applink.displayUrl,
        oauthConfig: props.remoteAuth?.outgoing
    })))));
};
const $aa35e4554f311350$var$buildOAuthConfigFromOption = (option)=>{
    if (option === $aa35e4554f311350$var$AUTH_OAUTH1) return {
        enabled: true,
        twoLoEnabled: true,
        twoLoImpersonationEnabled: false,
        oAuth2ThreeLoEnabled: false
    };
    if (option === $aa35e4554f311350$var$AUTH_OAUTH1_IMPERSONATION) return {
        enabled: true,
        twoLoEnabled: true,
        twoLoImpersonationEnabled: true,
        oAuth2ThreeLoEnabled: false
    };
    return {
        enabled: false,
        twoLoEnabled: false,
        twoLoImpersonationEnabled: false,
        oAuth2ThreeLoEnabled: false
    };
};
const $aa35e4554f311350$var$ApplinksOAuth1EditPageContents = (props)=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const getListPageUrl = (0, $eJOHy.useCallback)(()=>{
        if ((0, $7jTnu.fg)('applinks-933-experimental-list-page')) return 0, $d6B0e.APPLINKS_LIST_PAGE_URL;
        return 0, $d6B0e.APPLINKS_LIST_PAGE_URL_LEGACY;
    }, []);
    const onFormSubmit = (0, $eJOHy.useCallback)(async (data)=>{
        try {
            const applinkUpdate = {
                id: props.applink.id,
                type: props.applink.type,
                system: props.applink.system,
                primary: props.applink.primary,
                isExtraAuthRequired: props.applink.isExtraAuthRequired,
                // Only change these properties:
                name: data.displayName,
                displayUrl: data.displayUrl,
                rpcUrl: data.rpcUrl
            };
            await (0, $dk6v8.updateApplinkV3)(props.applink.id, applinkUpdate);
            await (0, $dk6v8.putApplinkOAuth1Config)(props.applink.id, {
                outgoing: $aa35e4554f311350$var$buildOAuthConfigFromOption(data.outgoingAuth),
                incoming: $aa35e4554f311350$var$buildOAuthConfigFromOption(data.incomingAuth)
            });
            push(getListPageUrl());
        } catch (err) {
            props.onDisplayError(err instanceof Error ? err.message : 'Unknown error');
        }
    }, [
        getListPageUrl,
        props,
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtnjR.default), {
        onSubmit: onFormSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emAda.default), {
            title: "Link details"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            space: "space.200",
            xcss: $aa35e4554f311350$var$styles.formSectionInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.DisplayName), {
            name: "displayName",
            defaultName: props.applink.name
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.DisplayUrl), {
            name: "displayUrl",
            defaultUrl: props.applink.displayUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.ApplicationUrl), {
            name: "rpcUrl",
            defaultUrl: props.applink.rpcUrl,
            disabled: false
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("hr", {
            role: "presentation",
            className: (0, $hcewu.default)([
                $aa35e4554f311350$var$styles.dividerStyle
            ])
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emAda.default), {
            title: "Connections"
        }, props.status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            space: "space.200",
            xcss: $aa35e4554f311350$var$styles.formSectionInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa35e4554f311350$var$ConfigureAuthTable, {
            applink: props.applink,
            localAuth: props.status.localAuthentication,
            remoteAuth: props.status.remoteAuthentication
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
            href: (0, $ffsuj.getApplinksAdminUrl)(props.applink.displayUrl, props.applink.type),
            target: "_blank"
        }, "Go to ", props.applink.displayUrl))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
            space: "space.200",
            xcss: $aa35e4554f311350$var$styles.formSectionInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPlS8.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, "Checking application link status..."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Xk9R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $pUkPE.default), {
            label: "Form submit options"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kQDPJ.default), {
            href: getListPageUrl(),
            appearance: "subtle"
        }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
            type: "submit",
            appearance: "primary",
            isLoading: submitting
        }, "Save")))))));
};
var $aa35e4554f311350$export$2e2bcd8739ae039 = $aa35e4554f311350$var$ApplinksOAuth1EditPageContents;

});
parcelRegister("11ahJ", function(module, exports) {

$parcel$export(module.exports, "useFormState", () => $27dbd182074e91af$export$606f11b2eb45ecc6);

var $eJOHy = parcelRequire("eJOHy");

var $jtnjR = parcelRequire("jtnjR");
// Constantized to avoid a new object reference built every call
const $27dbd182074e91af$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const $27dbd182074e91af$var$getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const $27dbd182074e91af$export$606f11b2eb45ecc6 = (subscriptionConfig = $27dbd182074e91af$var$defaultSubscriptionConfig)=>{
    const { subscribe: subscribe } = (0, $eJOHy.useContext)((0, $jtnjR.FormContext));
    const [state, setState] = (0, $eJOHy.useState)();
    /**
	 * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
	 * We avoid computing the hash if the subscription config has referential equality altogether.
	 */ const subscriptionConfigHash = (0, $eJOHy.useMemo)(()=>$27dbd182074e91af$var$getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
	 * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
	 * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
	 * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
	 */ const config = (0, $eJOHy.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};

});

parcelRegister("6OnPZ", function(module, exports) {

$parcel$export(module.exports, "Arrows", () => $a5d2b3bcc7e3278e$export$b6e350ab9915297a);
$parcel$export(module.exports, "ArrowDescription", () => $a5d2b3bcc7e3278e$export$3a0589d3b45ed836);

var $a4R0x = parcelRequire("a4R0x");

var $4GYnG = parcelRequire("4GYnG");

var $f2MOe = parcelRequire("f2MOe");

var $cxmP4 = parcelRequire("cxmP4");

var $ld3L7 = parcelRequire("ld3L7");

var $c3P86 = parcelRequire("c3P86");
const $a5d2b3bcc7e3278e$export$b6e350ab9915297a = {
    incoming: {
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($a4R0x))),
        match: (0, (/*@__PURE__*/$parcel$interopDefault($4GYnG))),
        mismatch: (0, (/*@__PURE__*/$parcel$interopDefault($f2MOe)))
    },
    outgoing: {
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($cxmP4))),
        match: (0, (/*@__PURE__*/$parcel$interopDefault($ld3L7))),
        mismatch: (0, (/*@__PURE__*/$parcel$interopDefault($c3P86)))
    }
};
const $a5d2b3bcc7e3278e$export$3a0589d3b45ed836 = {
    incoming: {
        disabled: 'Arrow showing incoming auth is disabled',
        match: 'Arrow showing incoming auth is matching',
        mismatch: 'Arrow showing incoming auth is mismatched'
    },
    outgoing: {
        disabled: 'Arrow showing outgoing auth is disabled',
        match: 'Arrow showing outgoing auth is matching',
        mismatch: 'Arrow showing outgoing auth is mismatched'
    }
};

});
parcelRegister("a4R0x", function(module, exports) {
module.exports = new URL("arrow-left-disabled.e64b3d04.svg", import.meta.url).toString();

});

parcelRegister("4GYnG", function(module, exports) {
module.exports = new URL("arrow-left-match.5ea6990b.svg", import.meta.url).toString();

});

parcelRegister("f2MOe", function(module, exports) {
module.exports = new URL("arrow-left-mismatch.14c5dc32.svg", import.meta.url).toString();

});

parcelRegister("cxmP4", function(module, exports) {
module.exports = new URL("arrow-right-disabled.4aa73a65.svg", import.meta.url).toString();

});

parcelRegister("ld3L7", function(module, exports) {
module.exports = new URL("arrow-right-match.0de9f50b.svg", import.meta.url).toString();

});

parcelRegister("c3P86", function(module, exports) {
module.exports = new URL("arrow-right-mismatch.65202d42.svg", import.meta.url).toString();

});






parcelRegister("bEyFu", function(module, exports) {

$parcel$export(module.exports, "applinksAdministrationEditRoute", () => $899c82c3a21534e2$export$25e5ee53e818565e);
const $899c82c3a21534e2$export$25e5ee53e818565e = {
    name: 'global-settings-products-applinks-administration-edit',
    path: '/jira/settings/applinks/:applinkId/edit',
    exact: true
};

});

parcelRegister("yRJUA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsLayout", () => $150f50faaae72217$export$e6aef6083548e882);

var $7h3uc = parcelRequire("7h3uc");

var $6dwgv = parcelRequire("6dwgv");
const $150f50faaae72217$export$e6aef6083548e882 = (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout));

});

parcelRegister("2nHUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c03066d31b31d1d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $7c03066d31b31d1d$var$LazyGlobalSystemSettingsSidebar = (0, $gzcjr.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("ilbbL")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
});
const $7c03066d31b31d1d$var$GlobalSystemSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalSystemSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c03066d31b31d1d$var$LazyGlobalSystemSettingsSidebar, null)));
$7c03066d31b31d1d$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
var $7c03066d31b31d1d$export$2e2bcd8739ae039 = $7c03066d31b31d1d$var$GlobalSystemSettingsSidebar;

});
parcelRegister("ilbbL", function(module, exports) {

let $d5a2de03de8efadd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $d5a2de03de8efadd$var$load("1VRB2"),
    $d5a2de03de8efadd$var$load("bABhq"),
    $d5a2de03de8efadd$var$load("7vqGd"),
    $d5a2de03de8efadd$var$load("1Y4bq"),
    $d5a2de03de8efadd$var$load("dEuXy")
]).then(()=>parcelRequire('cuk8p'));

});


parcelRegister("9BJU1", function(module, exports) {

$parcel$export(module.exports, "LazyNotFoundErrorPage", () => $6c1420c5acf0f215$export$57c5c0b5a0cdb5b7);
$parcel$export(module.exports, "default", () => $6c1420c5acf0f215$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $6c1420c5acf0f215$export$57c5c0b5a0cdb5b7 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8LrCn")), {
    moduleId: "./src/packages/spa-apps/error-pages/not-found/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6c1420c5acf0f215$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6c1420c5acf0f215$export$57c5c0b5a0cdb5b7,
        pageId: "errors-404",
        shouldShowSpinner: false
    });

});
parcelRegister("8LrCn", function(module, exports) {

let $661822e2a3fd109a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $661822e2a3fd109a$var$load("1G8UW"),
    $661822e2a3fd109a$var$load("iSk93"),
    $661822e2a3fd109a$var$load("1VRB2"),
    $661822e2a3fd109a$var$load("bABhq"),
    $661822e2a3fd109a$var$load("fMOSo"),
    $661822e2a3fd109a$var$load("jhiae"),
    $661822e2a3fd109a$var$load("7vqGd"),
    $661822e2a3fd109a$var$load("1Y4bq"),
    $661822e2a3fd109a$var$load("hwlgY"),
    $661822e2a3fd109a$var$load("k4gbU"),
    $661822e2a3fd109a$var$load("44cW4")
]).then(()=>parcelRequire('4534k'));

});



parcelRegister("jMKrp", function(module, exports) {

$parcel$export(module.exports, "applinksAdministrationListRouteEntry", () => $e5caaaa42a42c8ec$export$3303093eb593ff88);

var $b0JRA = parcelRequire("b0JRA");

var $gEhrq = parcelRequire("gEhrq");

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $7jTnu = parcelRequire("7jTnu");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $5fjzQ = parcelRequire("5fjzQ");
const $e5caaaa42a42c8ec$export$3303093eb593ff88 = (0, $6xToB.createEntry)((0, $gEhrq.applinksAdministrationListRoute), ()=>({
        group: 'global-settings',
        ufoName: 'applinks-administration',
        component: (0, $bJscI.componentWithFG)('applinks-933-new-applinks-frontend', (0, $b0JRA.default), (0, $9BJU1.default)),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>(0, $7jTnu.fg)('applinks-933-new-applinks-frontend'),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        meta: {
            reporting: {
                id: 'Applinks',
                packageName: 'jiraAdminPagesApplinks',
                teamName: 'olympus'
            }
        }
    }));

});
parcelRegister("b0JRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a1ba1e1efbdc264$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dTqD3 = parcelRequire("dTqD3");

var $16sa1 = parcelRequire("16sa1");

var $aV23b = parcelRequire("aV23b");

var $8uaaE = parcelRequire("8uaaE");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3a1ba1e1efbdc264$var$ListPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "applinks-administration-list-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8uaaE.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStatePageReady), null)));
var $3a1ba1e1efbdc264$export$2e2bcd8739ae039 = $3a1ba1e1efbdc264$var$ListPage;

});
parcelRegister("8uaaE", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a882bd91925c92c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jJaSe = parcelRequire("jJaSe");

var $eSnSE = parcelRequire("eSnSE");

var $dk6v8 = parcelRequire("dk6v8");

var $d6B0e = parcelRequire("d6B0e");

var $lliUE = parcelRequire("lliUE");
const $1a882bd91925c92c$export$c2248d8896966a26 = ()=>{
    const [applinks, setApplinks] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        (0, $dk6v8.fetchApplinks)().then((data)=>{
            setApplinks(data);
        }).catch((err)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $d6B0e.LOG_LOCATION), 'Failed to fetch applink data', err);
            setApplinks(null);
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lliUE.default), {
        applinks: applinks
    });
};
var $1a882bd91925c92c$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)($1a882bd91925c92c$export$c2248d8896966a26);

});
parcelRegister("lliUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc3a3da1813e1f6b$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $dhRXV = parcelRequire("dhRXV");
var $aRh7I = parcelRequire("aRh7I");

var $dPlS8 = parcelRequire("dPlS8");

var $7jTnu = parcelRequire("7jTnu");

var $1KdDN = parcelRequire("1KdDN");

var $95O7y = parcelRequire("95O7y");
var $83DiZ = parcelRequire("83DiZ");

var $dk6v8 = parcelRequire("dk6v8");

var $ffsuj = parcelRequire("ffsuj");

var $d6B0e = parcelRequire("d6B0e");

var $hZFsF = parcelRequire("hZFsF");

var $4oJke = parcelRequire("4oJke");

var $7tuB3 = parcelRequire("7tuB3");

var $cYu93 = parcelRequire("cYu93");
const $fc3a3da1813e1f6b$var$styles = {
    applinksPageContents: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1fra _ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
const $fc3a3da1813e1f6b$var$getOperationFromCreationState = (creationState)=>{
    if (!creationState) return 'operation-list-applinks';
    const statusLog = creationState.applinkCreationStatusLog;
    if (statusLog.filter((entry)=>entry.status === (0, $ffsuj.STATUS_RECIPROCAL_SUCCESS)).length > 0) return 'operation-oauth1-complete-link';
    if (statusLog.filter((entry)=>entry.status === (0, $ffsuj.STATUS_RECIPROCAL_INPROGRESS)).length > 0) return 'operation-oauth1-reciprocal';
    return 'operation-list-applinks';
};
const $fc3a3da1813e1f6b$var$PartialApplinksPageContents = ()=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const [oauth2RemoteApplicationUrl, _] = (0, $95O7y.useQueryParam)('oauth2RemoteApplication');
    const [localApplinkManifest, setLocalApplinkManifest] = (0, $eJOHy.useState)(null);
    const [remoteApplinkManifest, setRemoteApplinkManifest] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (oauth2RemoteApplicationUrl) {
            (0, $dk6v8.fetchApplinkManifestForUrl)(oauth2RemoteApplicationUrl).then((remoteManifest)=>{
                setRemoteApplinkManifest(remoteManifest);
            });
            (0, $dk6v8.fetchThisManifest)().then((localManifest)=>{
                setLocalApplinkManifest(localManifest);
            });
        }
    }, [
        oauth2RemoteApplicationUrl
    ]);
    const redirectBackToLegacyListPage = (0, $eJOHy.useCallback)(()=>{
        push((0, $d6B0e.APPLINKS_LIST_PAGE_URL_LEGACY));
    }, [
        push
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!oauth2RemoteApplicationUrl) redirectBackToLegacyListPage();
    }, [
        oauth2RemoteApplicationUrl,
        redirectBackToLegacyListPage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "applinks-administration-partial-page",
        teamName: "olympus",
        packageName: "applinksAdministrationPartialPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $fc3a3da1813e1f6b$var$styles.applinksPageContents
    }, localApplinkManifest && remoteApplinkManifest ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7tuB3.CreateFlowDialog), {
        isOpen: true,
        onExit: redirectBackToLegacyListPage,
        startingStage: {
            kind: 'review',
            variant: 'OAUTH2.0',
            localManifest: localApplinkManifest,
            remoteManifest: remoteApplinkManifest
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPlS8.default), {
        interactionName: "load",
        label: "Loading"
    })));
};
const $fc3a3da1813e1f6b$var$FullApplinksPageContents = (props)=>{
    const [createLinkDrawerOpen, setCreateLinkDrawerOpen] = (0, $eJOHy.useState)(false);
    const [creationState] = (0, $eJOHy.useState)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const url = new URL(window.location.href);
        return (0, $ffsuj.parseCreationStateFromUrl)(url);
    });
    const [operation, setOperation] = (0, $eJOHy.useState)('operation-list-applinks');
    const [thisApplicationManifest, setThisApplicationManifest] = (0, $eJOHy.useState)(null);
    const [targetApplicationManifest, setTargetApplicationManifest] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        const op = $fc3a3da1813e1f6b$var$getOperationFromCreationState(creationState);
        setOperation(op);
    }, [
        creationState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (creationState) {
            // We expect to always have an applinkStartingUrl in the creation state for reciprocal review
            if (operation === 'operation-oauth1-reciprocal' && creationState.applinkStartingUrl) {
                (0, $dk6v8.fetchApplinkManifestForUrl)(creationState.applinkStartingUrl).then((remoteManifest)=>{
                    setTargetApplicationManifest(remoteManifest);
                });
                (0, $dk6v8.fetchThisManifest)().then((localManifest)=>{
                    setThisApplicationManifest(localManifest);
                });
            }
            if (operation === 'operation-oauth1-complete-link') setCreateLinkDrawerOpen(true);
        }
    }, [
        creationState,
        operation
    ]);
    const [filter, setFilter] = (0, $eJOHy.useState)(null);
    const [search, setSearch] = (0, $eJOHy.useState)('');
    const closeDrawer = ()=>{
        setCreateLinkDrawerOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "applinks-administration-list-page",
        teamName: "olympus",
        packageName: "applinksAdministrationListPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $fc3a3da1813e1f6b$var$styles.applinksPageContents
    }, operation === 'operation-list-applinks' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
        space: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4oJke.default), {
        onSearch: setSearch,
        onFilterChange: setFilter,
        onCreateLink: ()=>setCreateLinkDrawerOpen(true),
        filter: filter,
        search: search
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
        space: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hZFsF.default), {
        applinks: props.applinks,
        filter: filter,
        search: search
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7tuB3.CreateFlowDialog), {
        isOpen: createLinkDrawerOpen,
        onExit: closeDrawer
    }))), operation === 'operation-oauth1-reciprocal' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), null, (!thisApplicationManifest || !targetApplicationManifest) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPlS8.default), {
        interactionName: "load",
        label: "Loading"
    }), thisApplicationManifest && targetApplicationManifest && creationState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cYu93.default), {
        state: {
            kind: 'reciprocal-review',
            variant: 'OAUTH1.0',
            localManifest: thisApplicationManifest,
            remoteManifest: targetApplicationManifest,
            inboundCreationState: creationState
        },
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onCancel: closeDrawer,
        // TODO: Handle error
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    })), operation === 'operation-oauth1-complete-link' && creationState?.applinkOriginalCreatedId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7tuB3.CreateFlowDialog), {
        isOpen: createLinkDrawerOpen,
        onExit: closeDrawer,
        startingStage: {
            kind: 'confirmation',
            variant: 'OAUTH1.0',
            confirmationApplinkId: creationState?.applinkOriginalCreatedId
        }
    }))));
};
const $fc3a3da1813e1f6b$var$ApplinksPageContents = (props)=>{
    if ((0, $7jTnu.fg)('applinks-933-experimental-list-page')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fc3a3da1813e1f6b$var$FullApplinksPageContents, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fc3a3da1813e1f6b$var$PartialApplinksPageContents, null);
};
var $fc3a3da1813e1f6b$export$2e2bcd8739ae039 = $fc3a3da1813e1f6b$var$ApplinksPageContents;

});
parcelRegister("hZFsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8540b8ed37325dee$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $dhRXV = parcelRequire("dhRXV");
var $9M9zY = parcelRequire("9M9zY");
var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");

var $idcYS = parcelRequire("idcYS");
var $d0tc6 = parcelRequire("d0tc6");
var $aMcQ0 = parcelRequire("aMcQ0");
var $4OieL = parcelRequire("4OieL");
var $6siZI = parcelRequire("6siZI");
var $haRrw = parcelRequire("haRrw");

var $4poV0 = parcelRequire("4poV0");

var $if36D = parcelRequire("if36D");

var $4BzUI = parcelRequire("4BzUI");

var $5UxOh = parcelRequire("5UxOh");

var $6alcT = parcelRequire("6alcT");

var $1AUsu = parcelRequire("1AUsu");
var $apGPk = parcelRequire("apGPk");
var $7R1al = parcelRequire("7R1al");

var $dPlS8 = parcelRequire("dPlS8");

var $bvFRW = parcelRequire("bvFRW");

var $eSnSE = parcelRequire("eSnSE");

var $dk6v8 = parcelRequire("dk6v8");

var $d6B0e = parcelRequire("d6B0e");

var $a4pY2 = parcelRequire("a4pY2");
const $8540b8ed37325dee$var$contentStyles = {
    status: "_bozgpxbi _y4tipxbi _1q51pxbi _85i5pxbi _p12fdgin _1ul9nklw",
    menu: "_p12fdgin _1ul9nklw"
};
const $8540b8ed37325dee$var$ApplicationLinkProduct = (props)=>{
    const typeDef = (0, $a4pY2.lookupTypeFromV3Data)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        alignBlock: "center",
        space: "space.100"
    }, typeDef.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, props.displayUrl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
        color: "color.text.subtle",
        size: "small"
    }, typeDef.name))));
};
const $8540b8ed37325dee$var$ApplicationLinkName = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, props.name);
};
const $8540b8ed37325dee$var$ApplicationLinkType = (props)=>{
    const appendLozenges = (isPrimary, isSystem, isExtraAuthRequired)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isPrimary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
            key: "primary"
        }, "Primary"), isExtraAuthRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
            key: "extra-auth"
        }, "Extra Auth"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        alignBlock: "center",
        space: "space.100"
    }, appendLozenges(props.primary, props.system, props.isExtraAuthRequired));
};
const $8540b8ed37325dee$var$LozengeWithContext = (props)=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        appearance: props.appearance
    }, props.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5UxOh.default), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
                xcss: $8540b8ed37325dee$var$contentStyles.status
            }, props.content),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BzUI.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($if36D))),
                label: `Additional information about ${props.label} status`,
                appearance: "subtle",
                onClick: ()=>setIsOpen(!isOpen)
            })
    }));
};
const $8540b8ed37325dee$var$ApplicationLinkStatus = (props)=>{
    const [applinkStatus, setApplinkStatus] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        // If the applink is a system link, we don't need to fetch its status
        if (props.system) {
            setApplinkStatus('system');
            return;
        }
        // TODO: Properly mock data
        (0, $dk6v8.fetchApplinkStatus)(props.id).then((status)=>{
            setApplinkStatus(status);
        }).catch((err)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $d6B0e.LOG_LOCATION), 'Failed to fetch applink status', err);
        });
    }, [
        props.id,
        props.system
    ]);
    // TODO: Pop-ups
    const createLozenge = (contents)=>{
        if (contents === 'system') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$LozengeWithContext, {
            appearance: "default",
            label: "System",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
                size: "small"
            }, "Internal System Link"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, "This is an internal link to a Cloud server, created automatically by the system. System internal links are read-only and cannot be edited."))
        });
        // First, check if the link is working
        if (contents.working) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
            appearance: "success"
        }, "Connected");
        // Next, check if there is an error
        if (contents.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$LozengeWithContext, {
            appearance: "removed",
            label: "Config Error",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
                size: "small"
            }, "Config Error"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, JSON.stringify(contents.error)))
        });
        // TODO: Others
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), null, "Unknown");
    };
    return applinkStatus ? createLozenge(applinkStatus) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPlS8.default), null);
};
const $8540b8ed37325dee$var$onDeleteButtonClick = (applink)=>{
    (0, $dk6v8.deleteApplink)(applink.id);
};
const $8540b8ed37325dee$var$ApplicationLinkPopupMenuContent = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
        xcss: $8540b8ed37325dee$var$contentStyles.menu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apGPk.default), {
        href: props.data.displayUrl + (0, $d6B0e.APPLINKS_LIST_PAGE_URL)
    }, "Go to remote")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
        title: "Manage link",
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apGPk.default), {
        href: (0, $d6B0e.APPLINKS_EDIT_PAGE_URL_FOR_ID)(props.data.id)
    }, "Edit"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
        onClick: ()=>$8540b8ed37325dee$var$onDeleteButtonClick(props.data)
    }, "Delete"))));
};
const $8540b8ed37325dee$var$ApplicationLinkPopupMenu = (props)=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5UxOh.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$ApplicationLinkPopupMenuContent, {
                data: props.data
            }),
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BzUI.default), {
                ...triggerProps,
                isSelected: isOpen,
                label: "Additional actions",
                onClick: ()=>{
                    setIsOpen(!isOpen);
                },
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4poV0)))
            })
    });
};
const $8540b8ed37325dee$var$convertToArray = (applinks)=>{
    const wrapWithItem = (id, content, hasChildren, children)=>{
        return {
            id: id,
            content: content,
            hasChildren: hasChildren,
            children: children
        };
    };
    return applinks.map((entry, index)=>{
        return wrapWithItem(`entry-${index}`, entry, false);
    });
};
const $8540b8ed37325dee$var$ApplinksTable = (props)=>{
    const applinkItems = props.applinks ? $8540b8ed37325dee$var$convertToArray(props.applinks) : undefined;
    const filteredApplinkItems = applinkItems?.filter((item)=>{
        let passesFilter = true;
        if (props.filter) passesFilter = item.content.type === props.filter;
        let passesSearch = true;
        if (props.search && props.search.length > 0) {
            const nameCondition = item.content.name.toLowerCase().includes(props.search.toLowerCase());
            const urlCondition = item.content.displayUrl.toLowerCase().includes(props.search.toLowerCase());
            passesSearch = nameCondition || urlCondition;
        }
        return passesFilter && passesSearch;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d0tc6.default), {
        label: "Application Links"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4OieL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aMcQ0.default), {
        width: "20%"
    }, "Name"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aMcQ0.default), {
        width: "40%"
    }, "Application"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aMcQ0.default), {
        width: "15%"
    }, "Link properties"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aMcQ0.default), {
        width: "20%"
    }, "Status"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aMcQ0.default), {
        width: "5%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $haRrw.default), {
        items: filteredApplinkItems,
        render: (item)=>{
            const { content: content } = item;
            const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6siZI.default), {
                key: item.id,
                itemId: item.id,
                hasChildren: item.hasChildren
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $idcYS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$ApplicationLinkName, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $idcYS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$ApplicationLinkProduct, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $idcYS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$ApplicationLinkType, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $idcYS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$ApplicationLinkStatus, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $idcYS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$ApplicationLinkPopupMenu, {
                data: item.content
            })));
            return row;
        }
    }));
};
var $8540b8ed37325dee$export$2e2bcd8739ae039 = $8540b8ed37325dee$var$ApplinksTable;

});
parcelRegister("idcYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c782a60fdfa43440$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hbOvM = parcelRequire("hbOvM");

var $b7Gm4 = parcelRequire("b7Gm4");

var $iDUG7 = parcelRequire("iDUG7");
const $c782a60fdfa43440$var$CellComponent = ({ children: children, singleLine: singleLine, indentLevel: indentLevel, width: width, className: className, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hbOvM.default), {
        indent: indentLevel ? `calc(${"var(--ds-space-300, 25px)"} * ${indentLevel})` : undefined,
        width: width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b7Gm4.default), {
            isSingleLine: singleLine,
            children: children
        })
    });
const $c782a60fdfa43440$var$Cell = (0, $iDUG7.default)($c782a60fdfa43440$var$CellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c782a60fdfa43440$export$2e2bcd8739ae039 = $c782a60fdfa43440$var$Cell;

});
parcelRegister("hbOvM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a90c548234f14bf$export$2e2bcd8739ae039);
/* common-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $6a90c548234f14bf$var$commonStyles = null;
/**
 * __Common cell__
 */ const $6a90c548234f14bf$var$CommonCell = ({ indent: indent, width: width, className: className, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "gridcell",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1yt413wy _11c82smr _1e0c1txw _vchhusvi _1tke1ylp _kqswh2mm _4cvr1h6o _syaz1fxt _ct361wug _1nmz1hna",
            className
        ]),
        ...props,
        style: {
            '--indent': indent,
            width: width
        }
    });
var $6a90c548234f14bf$export$2e2bcd8739ae039 = $6a90c548234f14bf$var$CommonCell;

});

parcelRegister("b7Gm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dc5418d24617254$export$2e2bcd8739ae039);
/* overflow-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $0dc5418d24617254$var$overflowContainerStyles = null;
/**
 * __Overflow container__
 */ const $0dc5418d24617254$var$OverflowContainer = ({ isSingleLine: isSingleLine, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            isSingleLine && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    });
var $0dc5418d24617254$export$2e2bcd8739ae039 = $0dc5418d24617254$var$OverflowContainer;

});

parcelRegister("iDUG7", function(module, exports) {

$parcel$export(module.exports, "default", () => $cabda1c9d85aab5c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $91dbz = parcelRequire("91dbz");
function $cabda1c9d85aab5c$export$2e2bcd8739ae039(Cell) {
    return (props)=>{
        const { setColumnWidth: setColumnWidth, getColumnWidth: getColumnWidth } = (0, $eJOHy.useContext)((0, $91dbz.TableTreeContext));
        const { width: width, columnIndex: columnIndex, ...other } = props;
        (0, $eJOHy.useEffect)(()=>{
            if (width !== undefined && columnIndex !== undefined) setColumnWidth(columnIndex, width);
        }, [
            width,
            columnIndex,
            setColumnWidth
        ]);
        let columnWidth;
        if (width !== null && width !== undefined) columnWidth = width;
        else if (columnIndex !== undefined) columnWidth = getColumnWidth(columnIndex);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Cell, {
            width: columnWidth,
            ...other
        });
    };
}

});
parcelRegister("91dbz", function(module, exports) {

$parcel$export(module.exports, "TableTreeContext", () => $b383c1966c34fec6$export$662c2d348d8b71af);

var $eJOHy = parcelRequire("eJOHy");
const $b383c1966c34fec6$export$662c2d348d8b71af = /*#__PURE__*/ (0, $eJOHy.createContext)({
    setColumnWidth: ()=>{},
    getColumnWidth: ()=>null
});

});



parcelRegister("d0tc6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dbc8d650e6263f3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $idcYS = parcelRequire("idcYS");

var $aMcQ0 = parcelRequire("aMcQ0");

var $4OieL = parcelRequire("4OieL");

var $91dbz = parcelRequire("91dbz");

var $6siZI = parcelRequire("6siZI");

var $haRrw = parcelRequire("haRrw");
const $5dbc8d650e6263f3$var$emptyColumnWidths = [];
function $5dbc8d650e6263f3$var$TableTree({ children: children, columns: columns, columnWidths: defaultColumnWidths = $5dbc8d650e6263f3$var$emptyColumnWidths, headers: headers, shouldExpandOnClick: shouldExpandOnClick, items: items, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, label: label, referencedLabel: referencedLabel }) {
    const [columnWidths, setColumnWidths] = (0, $eJOHy.useState)(defaultColumnWidths);
    const setColumnWidth = (0, $eJOHy.useCallback)((columnIndex, width)=>{
        if (width === columnWidths[columnIndex]) return;
        setColumnWidths((columnWidths)=>{
            const newColumnWidths = [
                ...columnWidths
            ];
            newColumnWidths[columnIndex] = width;
            return newColumnWidths;
        });
    }, [
        columnWidths
    ]);
    const getColumnWidth = (0, $eJOHy.useCallback)((columnIndex)=>{
        return columnWidths[columnIndex] || null;
    }, [
        columnWidths
    ]);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            setColumnWidth: setColumnWidth,
            getColumnWidth: getColumnWidth
        }), [
        setColumnWidth,
        getColumnWidth
    ]);
    const heads = headers && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OieL.default), {
        children: headers.map((header, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $aMcQ0.default), {
                columnIndex: index,
                width: columnWidths[index],
                children: header
            }, index))
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $91dbz.TableTreeContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            role: "treegrid",
            "aria-readonly": true,
            "aria-label": label,
            "aria-labelledby": referencedLabel,
            children: [
                heads,
                columns && items && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $haRrw.default), {
                    items: items,
                    render: ({ id: id, children: children, content: content })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6siZI.default), {
                            itemId: id,
                            items: children,
                            hasChildren: !!children && children.length > 0,
                            shouldExpandOnClick: shouldExpandOnClick,
                            mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel,
                            children: columns.map((CellContent, index)=>{
                                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $idcYS.default), {
                                    columnIndex: index,
                                    width: columnWidths[index],
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(CellContent, {
                                        ...content
                                    })
                                }, `cell-${index}`);
                            })
                        })
                }),
                children
            ]
        })
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5dbc8d650e6263f3$export$2e2bcd8739ae039 = $5dbc8d650e6263f3$var$TableTree;

});
parcelRegister("aMcQ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0293745b0605dcc$export$2e2bcd8739ae039);
/* header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $hbOvM = parcelRequire("hbOvM");

var $iDUG7 = parcelRequire("iDUG7");
const $e0293745b0605dcc$var$headerStyles = null;
const $e0293745b0605dcc$var$HeaderComponent = ({ width: width, children: children, onClick: onClick, id: id, role: role = 'columnheader' })=>{
    // TODO: Determine whether proper `th` elements can be used instead of
    // roles (DSP-11588)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hbOvM.default), {
        role: role,
        width: width,
        id: id,
        onClick: onClick,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _syaz1n3s _k48pmoej"
        ]),
        children: children
    });
};
const $e0293745b0605dcc$var$Header = (0, $iDUG7.default)($e0293745b0605dcc$var$HeaderComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e0293745b0605dcc$export$2e2bcd8739ae039 = $e0293745b0605dcc$var$Header;

});

parcelRegister("4OieL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c52b90fd9dd314d9$export$2e2bcd8739ae039);
/* headers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
/* eslint-disable @repo/internal/react/no-clone-element */ const $c52b90fd9dd314d9$var$containerStyles = null;
/**
 * __Headers__
 *
 * Headers component for advanced composition of data, allowing custom data structures.
 *
 * - [Examples](https://atlassian.design/components/table-tree/examples#advanced)
 * - [Code](https://atlassian.design/components/table-tree/code#headers-props)
 */ const $c52b90fd9dd314d9$var$Headers = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "row",
        className: (0, $hcewu.default)([
            "_179r17qy _1e0c1txw"
        ]),
        children: (0, $eJOHy.Children).map(children, (header, index)=>/*#__PURE__*/ (0, $eJOHy.cloneElement)(header, {
                key: index,
                columnIndex: index
            }))
    });
var $c52b90fd9dd314d9$export$2e2bcd8739ae039 = $c52b90fd9dd314d9$var$Headers;

});

parcelRegister("6siZI", function(module, exports) {

$parcel$export(module.exports, "default", () => $442e9e64983f9ffe$export$2e2bcd8739ae039);
/* row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j2fEo = parcelRequire("j2fEo");

var $8lB9d = parcelRequire("8lB9d");

var $27py7 = parcelRequire("27py7");

var $2s1uj = parcelRequire("2s1uj");
const $442e9e64983f9ffe$var$treeRowClickableStyles = null;
const $442e9e64983f9ffe$var$getExtendedLabel = (cellContent, cellIndex, mainColumnForExpandCollapseLabel)=>{
    /**
   * First condition - when we pass data via `items` property in `<TableTree />`
   * Second condition - when we pass data via `<Rows />` as children in `<TableTree />`.
   */ if (cellContent.hasOwnProperty('props')) return cellContent?.props[mainColumnForExpandCollapseLabel?.toLowerCase()];
    else if (cellIndex === mainColumnForExpandCollapseLabel) return cellContent;
    return undefined;
};
function $442e9e64983f9ffe$var$Row({ shouldExpandOnClick: shouldExpandOnClick, hasChildren: hasChildren, depth: depth, renderChildren: renderChildren, isDefaultExpanded: isDefaultExpanded, data: data, onExpand: providedOnExpand, onCollapse: providedOnCollapse, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, expandLabel: expandLabel, collapseLabel: collapseLabel, itemId: itemId, children: children, isExpanded: isProvidedExpanded }) {
    const [isExpandedState, setIsExpandedState] = (0, $eJOHy.useState)(isDefaultExpanded || false);
    (0, $eJOHy.useEffect)(()=>{
        if (isProvidedExpanded === undefined && isDefaultExpanded !== undefined) setIsExpandedState(isDefaultExpanded);
    }, [
        isDefaultExpanded,
        isProvidedExpanded
    ]);
    const onExpand = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnExpand && providedOnExpand(value),
        action: 'expanded',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onCollapse = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnCollapse && providedOnCollapse(value),
        action: 'collapsed',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    }); /**
       * This ensures a user won't trigger a click event and expand the accordion
       * when making a text selection.
       */ 
    const onClickHandler = (e)=>{
        const selection = window.getSelection()?.toString() || '';
        if (selection?.length === 0) onExpandToggle(e);
    };
    const onExpandStateChange = (isExpanded)=>{
        if (data) {
            if (isExpanded && onExpand) onExpand(data);
            else if (!isExpanded && onCollapse) onCollapse(data);
        }
    };
    const onExpandToggle = (e)=>{
        e.stopPropagation();
        if (isProvidedExpanded !== undefined) onExpandStateChange(!isProvidedExpanded);
        else setIsExpandedState((prevState)=>{
            onExpandStateChange(!prevState);
            return !prevState;
        });
    };
    const renderCell = (cell, cellIndex)=>{
        const isFirstCell = cellIndex === 0;
        const indentLevel = isFirstCell ? depth : 0;
        let cellContent = cell.props.children || [];
        const extendedLabel = $442e9e64983f9ffe$var$getExtendedLabel(cellContent, cellIndex, mainColumnForExpandCollapseLabel);
        if (isFirstCell && hasChildren) cellContent = [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $27py7.default), {
                expandLabel: expandLabel,
                collapseLabel: collapseLabel,
                extendedLabel: extendedLabel,
                isExpanded: isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState,
                onExpandToggle: onExpandToggle,
                ariaControls: !!itemId ? (0, $8lB9d.default)(itemId) : undefined,
                rowId: !!itemId ? itemId : ''
            }, "chevron")
        ].concat(cellContent);
         // eslint-disable-next-line @repo/internal/react/no-clone-element
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(cell, {
            key: cellIndex,
            columnIndex: cellIndex,
            indentLevel: indentLevel
        }, cellContent);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2s1uj.TreeRowContainer), {
                onClick: hasChildren && shouldExpandOnClick ? onClickHandler : undefined,
                "aria-expanded": hasChildren ? isExpandedState : undefined,
                "aria-level": depth ? depth : undefined,
                className: (0, $hcewu.default)([
                    hasChildren && shouldExpandOnClick && "_80omtlke"
                ]),
                children: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (cell, index)=>renderCell(cell, index))
            }),
            hasChildren && (isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState) && renderChildren && renderChildren()
        ]
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$442e9e64983f9ffe$export$2e2bcd8739ae039 = $442e9e64983f9ffe$var$Row;

});
parcelRegister("8lB9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e028d7b614e8f19$export$2e2bcd8739ae039);
function $6e028d7b614e8f19$export$2e2bcd8739ae039(id) {
    return `tabletreeitem-${id}`.replace(/[^-_a-zA-Z0-9]/g, '');
}

});

parcelRegister("27py7", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa605feffc05a489$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/consistent-props-definitions */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4BzUI = parcelRequire("4BzUI");

var $9pZRF = parcelRequire("9pZRF");

var $adDYm = parcelRequire("adDYm");

var $fUE0d = parcelRequire("fUE0d");

var $2s1uj = parcelRequire("2s1uj");
/**
 * Internal chevron component.
 */ const $aa605feffc05a489$var$Chevron = ({ isExpanded: isExpanded, ariaControls: ariaControls, collapseLabel: collapseLabel = 'Collapse', expandLabel: expandLabel = 'Expand', rowId: rowId, extendedLabel: extendedLabel, onExpandToggle: onExpandToggle = (0, $9pZRF.default) })=>{
    const getLabel = (defaultLabel)=>extendedLabel ? `${defaultLabel} ${extendedLabel} row` : `${defaultLabel} row ${rowId}`;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2s1uj.ChevronContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
            appearance: "subtle",
            onClick: onExpandToggle,
            spacing: "compact",
            icon: (iconProps)=>isExpanded ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adDYm))), {
                    ...iconProps,
                    size: "small"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fUE0d))), {
                    ...iconProps,
                    size: "small"
                }),
            "aria-controls": isExpanded ? ariaControls : undefined,
            label: isExpanded ? getLabel(collapseLabel) : getLabel(expandLabel)
        })
    });
};
var $aa605feffc05a489$export$2e2bcd8739ae039 = $aa605feffc05a489$var$Chevron;

});
parcelRegister("2s1uj", function(module, exports) {

$parcel$export(module.exports, "TreeRowContainer", () => $c28928479c9322e6$export$802d2031792f9e4);
$parcel$export(module.exports, "ChevronContainer", () => $c28928479c9322e6$export$f25bd028f55b3d30);
$parcel$export(module.exports, "LoaderItemContainer", () => $c28928479c9322e6$export$94ae573de7227397);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c28928479c9322e6$var$treeRowContainerStyles = null;
const $c28928479c9322e6$export$802d2031792f9e4 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "row",
        ...props,
        className: (0, $hcewu.default)([
            "_179r1l7n _1e0c1txw"
        ])
    });
const $c28928479c9322e6$var$commonCellElementStyles = null;
const $c28928479c9322e6$var$commonChevronContainerStyles = null;
const $c28928479c9322e6$export$f25bd028f55b3d30 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswstnw _4cvr1h6o _ahbqf2s7",
            "_1pfhj39m"
        ])
    });
const $c28928479c9322e6$var$loadingItemContainerStyles = null;
const $c28928479c9322e6$var$paddingLeftStyles = null;
const $c28928479c9322e6$export$94ae573de7227397 = ({ isRoot: isRoot, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswstnw _4cvr1h6o _ahbqf2s7",
            "_1bsb1osq",
            isRoot && "_bozg1ssb"
        ])
    });

});



parcelRegister("haRrw", function(module, exports) {

$parcel$export(module.exports, "default", () => $160889079f16fb20$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $dURlu = parcelRequire("dURlu");
function $160889079f16fb20$var$Rows({ items: items, render: render, loadingLabel: loadingLabel = 'Loading' }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "rowgroup",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dURlu.default), {
            items: items,
            loadingLabel: loadingLabel,
            render: render
        })
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$160889079f16fb20$export$2e2bcd8739ae039 = $160889079f16fb20$var$Rows;

});
parcelRegister("dURlu", function(module, exports) {

$parcel$export(module.exports, "default", () => $73d9e6d06ca4c2aa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lgMIh = parcelRequire("lgMIh");

var $65DqD = parcelRequire("65DqD");
function $73d9e6d06ca4c2aa$var$Items({ depth: depth = 0, items: items, loadingLabel: loadingLabel, render: render }) {
    const [isLoaderShown, setIsLoaderShown] = (0, $eJOHy.useState)(false);
    const handleLoaderComplete = ()=>setIsLoaderShown(false);
    return !items || isLoaderShown ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65DqD.default), {
        isCompleting: !!(items && items.length),
        onComplete: handleLoaderComplete,
        depth: depth + 1,
        loadingLabel: loadingLabel
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: items.map((data)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMIh.default), {
                data: data,
                depth: depth + 1,
                render: render,
                loadingLabel: loadingLabel
            }, data.id))
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$73d9e6d06ca4c2aa$export$2e2bcd8739ae039 = $73d9e6d06ca4c2aa$var$Items;

});
parcelRegister("lgMIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3996eec409262067$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-clone-element */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8lB9d = parcelRequire("8lB9d");

var $dURlu = parcelRequire("dURlu");
/**
 * __Item__
 * Internal item component.
 */ function $3996eec409262067$var$Item({ depth: depth = 0, data: data, render: render, loadingLabel: loadingLabel }) {
    const renderedRow = render(data);
    if (!renderedRow) return null;
    // itemId exists on RowProps, but not on RowsProps
    const itemId = 'itemId' in renderedRow.props ? renderedRow.props.itemId : undefined;
    const items = renderedRow.props.items;
    return /*#__PURE__*/ (0, $eJOHy.cloneElement)(renderedRow, {
        depth: depth,
        data: data,
        loadingLabel: loadingLabel,
        renderChildren: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                id: !!itemId ? (0, $8lB9d.default)(itemId) : undefined,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dURlu.default), {
                    depth: depth,
                    items: items,
                    render: render,
                    loadingLabel: loadingLabel
                })
            })
    });
}
var $3996eec409262067$export$2e2bcd8739ae039 = $3996eec409262067$var$Item;

});

parcelRegister("65DqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $017b76ac86e555bc$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $dPlS8 = parcelRequire("dPlS8");

var $hbOvM = parcelRequire("hbOvM");

var $2s1uj = parcelRequire("2s1uj");
const $017b76ac86e555bc$var$LoaderItem = ({ depth: depth = 1, loadingLabel: loadingLabel, isCompleting: isCompleting, onComplete: onComplete })=>{
    const [phase, setPhase] = (0, $eJOHy.useState)('loading');
    (0, $eJOHy.useEffect)(()=>{
        if (phase === 'loading' && isCompleting) setPhase(()=>{
            onComplete();
            return 'complete';
        });
    }, [
        isCompleting,
        onComplete,
        phase
    ]);
    return phase === 'loading' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2s1uj.TreeRowContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hbOvM.default), {
            indent: `calc(${"var(--ds-space-300, 25px)"} * ${depth})`,
            width: "100%",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2s1uj.LoaderItemContainer), {
                isRoot: depth === 1,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dPlS8.default), {
                    size: "small",
                    testId: "table-tree-spinner",
                    label: loadingLabel
                })
            })
        })
    }) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$017b76ac86e555bc$export$2e2bcd8739ae039 = $017b76ac86e555bc$var$LoaderItem;

});





parcelRegister("4oJke", function(module, exports) {

$parcel$export(module.exports, "default", () => $19255e48ef2dd28d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $bvFRW = parcelRequire("bvFRW");

var $dhRXV = parcelRequire("dhRXV");
var $9M9zY = parcelRequire("9M9zY");
var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");

var $alkjW = parcelRequire("alkjW");

var $eKx5I = parcelRequire("eKx5I");

var $8tSIA = parcelRequire("8tSIA");

var $7eM4W = parcelRequire("7eM4W");

var $8JneG = parcelRequire("8JneG");

var $gtHL8 = parcelRequire("gtHL8");
var $7Ga8U = parcelRequire("7Ga8U");
var $lfSKL = parcelRequire("lfSKL");

var $51Gwp = parcelRequire("51Gwp");

var $a4pY2 = parcelRequire("a4pY2");
const $19255e48ef2dd28d$var$styles = {
    searchBox: "_16jlidpf _1o9zidpf _i0dl1mjv"
};
const $19255e48ef2dd28d$var$ApplinksHeader = (props)=>{
    const createFilteredIconButton = ({ triggerRef: triggerRef, ...triggerProps })=>{
        if (props.filter) {
            const typeDef = (0, $a4pY2.lookupType)(props.filter);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
                ...triggerProps,
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($7eM4W))),
                isSelected: true,
                ref: triggerRef
            }, typeDef.name);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
            ...triggerProps,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($7eM4W))),
            ref: triggerRef
        }, "All Apps");
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "large"
    }, "Application Links"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
        appearance: "primary",
        onClick: props.onCreateLink
    }, "Create link")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, "Application links let you integrate Jira with another Atlassian product or external application so they can exchange information, resources, and functionalities. What exactly is exchanged will depend on the applications you link.", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
        href: "https://support.atlassian.com/jira-cloud-administration/docs/use-applinks-to-link-to-atlassian-products/"
    }, "Learn more about application links")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $19255e48ef2dd28d$var$styles.searchBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
        placeholder: "Search application links",
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSIA))), {
            label: "Search application links"
        }),
        onChange: (e)=>{
            props.onSearch(e.currentTarget.value);
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gtHL8.default), {
        trigger: createFilteredIconButton,
        shouldRenderToParent: true
    }, props.filter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lfSKL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Ga8U.default), {
        key: "all",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8JneG))), {
            label: "Clear filter"
        }),
        onClick: ()=>props.onFilterChange(null)
    }, "Clear selection")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lfSKL.default), {
        title: "Cloud"
    }, Object.entries((0, $a4pY2.TypeIdMap)).filter(([key])=>(0, $a4pY2.TypeIdMap)[key].category === 'cloud').map(([key, typeDef])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Ga8U.default), {
            key: key,
            elemBefore: typeDef.icon,
            onClick: ()=>props.onFilterChange(key)
        }, typeDef.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lfSKL.default), {
        title: "Data Center"
    }, Object.entries((0, $a4pY2.TypeIdMap)).filter(([key])=>(0, $a4pY2.TypeIdMap)[key].category === 'dc').map(([key, typeDef])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Ga8U.default), {
            key: key,
            elemBefore: typeDef.icon,
            onClick: ()=>props.onFilterChange(key)
        }, typeDef.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lfSKL.default), {
        title: "Miscellaneous"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Ga8U.default), {
        key: "generic",
        elemBefore: (0, $a4pY2.TypeIdMap).generic.icon,
        onClick: ()=>props.onFilterChange('generic')
    }, (0, $a4pY2.TypeIdMap).generic.name))))));
};
var $19255e48ef2dd28d$export$2e2bcd8739ae039 = $19255e48ef2dd28d$var$ApplinksHeader;

});

parcelRegister("7tuB3", function(module, exports) {

$parcel$export(module.exports, "CreateFlowDialog", () => $e50c2ab5159790fc$export$79c286a92b7787f2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $ckAJd = parcelRequire("ckAJd");
var $ivTBg = parcelRequire("ivTBg");
var $2fsZx = parcelRequire("2fsZx");
var $5xGaI = parcelRequire("5xGaI");

var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");

var $f50CR = parcelRequire("f50CR");

var $a9cht = parcelRequire("a9cht");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $ekP6G = parcelRequire("ekP6G");

var $cYu93 = parcelRequire("cYu93");

var $1E9Rd = parcelRequire("1E9Rd");

var $3DmnW = parcelRequire("3DmnW");

var $4pa0Z = parcelRequire("4pa0Z");
const $e50c2ab5159790fc$var$UNKNOWN_STEP_ORDER = [
    'create',
    'unknown'
];
const $e50c2ab5159790fc$var$OAUTH1_STEP_ORDER = [
    'create',
    'review',
    'reciprocal-prompt',
    'confirmation'
];
const $e50c2ab5159790fc$var$OAUTH2_STEP_ORDER = [
    'create',
    'review',
    'connect'
]; // TODO: Localise these names
const $e50c2ab5159790fc$var$STEP_NAMES = {
    create: 'Create link',
    review: 'Review link',
    'reciprocal-prompt': 'Create reciprocal',
    connect: 'Secure connection',
    confirmation: 'Confirmation',
    unknown: 'Configure link'
};
const $e50c2ab5159790fc$var$determineStepPercentage = (currentStep, targetStep, sequence)=>{
    if (currentStep === 'manual-create' && targetStep === 'create') return 50; // Special case for manual create step
    const currentIndex = sequence.indexOf(currentStep);
    const targetIndex = sequence.indexOf(targetStep);
    if (currentIndex > targetIndex) return 100;
    if (currentIndex === targetIndex) return 0;
    return 0;
};
const $e50c2ab5159790fc$var$determineStepStatus = (currentStep, targetStep, sequence)=>{
    if (currentStep === 'manual-create' && targetStep === 'create') return 'current'; // Special case for manual create step
    const currentIndex = sequence.indexOf(currentStep);
    const targetIndex = sequence.indexOf(targetStep);
    if (currentIndex > targetIndex) return 'visited';
    if (currentIndex === targetIndex) return 'current';
    return 'unvisited';
};
const $e50c2ab5159790fc$var$buildSteps = (step, sequence)=>{
    return sequence.map((s)=>({
            id: s,
            label: $e50c2ab5159790fc$var$STEP_NAMES[s],
            percentageComplete: $e50c2ab5159790fc$var$determineStepPercentage(step, s, sequence),
            status: $e50c2ab5159790fc$var$determineStepStatus(step, s, sequence),
            href: '#'
        }));
};
const $e50c2ab5159790fc$var$buildProgressTrackerItems = (step, variant)=>{
    if (variant === null) return $e50c2ab5159790fc$var$buildSteps(step, $e50c2ab5159790fc$var$UNKNOWN_STEP_ORDER);
    switch(variant){
        case 'OAUTH1.0':
            return $e50c2ab5159790fc$var$buildSteps(step, $e50c2ab5159790fc$var$OAUTH1_STEP_ORDER);
        case 'TUNNEL':
            return $e50c2ab5159790fc$var$buildSteps(step, $e50c2ab5159790fc$var$OAUTH1_STEP_ORDER);
        // Tunnel uses the same steps as OAUTH1.0
        case 'OAUTH2.0':
            return $e50c2ab5159790fc$var$buildSteps(step, $e50c2ab5159790fc$var$OAUTH2_STEP_ORDER);
        default:
            return [];
    }
};
const $e50c2ab5159790fc$var$styles = {
    container: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1c3h"
};
const $e50c2ab5159790fc$var$FlowContent = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    switch(props.state.kind){
        case 'create':
        case 'manual-create':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ekP6G.default), {
                onError: props.onDisplayError,
                onSuccess: props.onStateChange,
                onCancel: props.onCancel
            });
        case 'review':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cYu93.default), {
                state: props.state,
                onSuccess: props.onStateChange,
                onError: props.onDisplayError,
                onCancel: props.onCancel
            });
        case 'reciprocal-prompt':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1E9Rd.default), {
                state: props.state
            });
        case 'connect':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4pa0Z.default), {
                state: props.state,
                onSuccess: props.onStateChange,
                onError: props.onDisplayError
            });
        case 'confirmation':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3DmnW.default), {
                state: props.state
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, "Placeholder");
    }
});
const $e50c2ab5159790fc$var$DEFAULT_CREATE_STAGE = {
    kind: 'create'
};
const $e50c2ab5159790fc$export$79c286a92b7787f2 = (props)=>{
    // Use the provided starting stage or default to the create stage
    const [flowState, setFlowState] = (0, $eJOHy.useState)(props.startingStage || $e50c2ab5159790fc$var$DEFAULT_CREATE_STAGE);
    const onCancel = ()=>{
        props.onExit();
        setFlowState($e50c2ab5159790fc$var$DEFAULT_CREATE_STAGE);
    };
    const [errorFlags, setErrorFlags] = (0, $eJOHy.useState)([]);
    const addFlag = (0, $eJOHy.useCallback)((err)=>{
        const newFlags = errorFlags.slice();
        newFlags.splice(0, 0, err);
        setErrorFlags(newFlags);
    }, [
        errorFlags
    ]);
    const handleDismiss = ()=>{
        setErrorFlags(errorFlags.slice(1));
    };
    (0, $lRq8t.default)();
    if ((0, $7jTnu.fg)('applinks-933-experimental-list-page')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ckAJd.Drawer), {
        testId: "applinks-administration.ui.list.creation-flow-dialog.drawer",
        width: "full",
        onClose: ()=>onCancel(),
        isOpen: props.isOpen,
        label: "Applinks Create Drawer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5xGaI.DrawerSidebar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivTBg.DrawerCloseButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2fsZx.DrawerContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
        space: "space.200",
        xcss: $e50c2ab5159790fc$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f50CR.default), {
        items: $e50c2ab5159790fc$var$buildProgressTrackerItems(flowState.kind, 'variant' in flowState ? flowState.variant : null),
        spacing: "comfortable"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e50c2ab5159790fc$var$FlowContent, {
        state: flowState,
        onCancel: onCancel,
        onStateChange: setFlowState,
        onDisplayError: addFlag
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
        space: "space.200",
        xcss: $e50c2ab5159790fc$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e50c2ab5159790fc$var$FlowContent, {
        state: flowState,
        onCancel: props.onExit,
        onStateChange: setFlowState,
        onDisplayError: addFlag
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.FlagGroup), {
        onDismissed: handleDismiss
    }, errorFlags.map((err, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.ErrorFlag), {
            id: `flag-${idx}`,
            key: `flag-${idx}`,
            title: "Failed to configure application link",
            description: `An error occurred while configuring the application link. ${err}`
        });
    })));
};

});
parcelRegister("ckAJd", function(module, exports) {

$parcel$export(module.exports, "Drawer", () => $f3afa7e7b283db24$export$4071300121a182f5);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2PAgW = parcelRequire("2PAgW");

var $j2fEo = parcelRequire("j2fEo");

var $ijDer = parcelRequire("ijDer");
var $jIaJY = parcelRequire("jIaJY");

var $4ELHx = parcelRequire("4ELHx");

var $9ODnR = parcelRequire("9ODnR");

var $jVgKM = parcelRequire("jVgKM");
// escape close manager for layering
const $f3afa7e7b283db24$var$EscapeCloseManager = ({ onClose: onClose })=>{
    // wrap so that we can cast the event to a React.KeyboardEvent
    const handleClose = (0, $eJOHy.useCallback)((evt)=>{
        onClose && onClose(evt);
    }, [
        onClose
    ]);
    (0, $jIaJY.useCloseOnEscapePress)({
        onClose: handleClose
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {});
};
const $f3afa7e7b283db24$export$4071300121a182f5 = ({ width: width = 'narrow', isOpen: isOpen, isFocusLockEnabled: isFocusLockEnabled = true, shouldReturnFocus: shouldReturnFocus = true, autoFocusFirstElem: autoFocusFirstElem = true, onKeyDown: onKeyDown, testId: testId, children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, zIndex: zIndex = 'unset', label: label, titleId: titleId, enterFrom: enterFrom })=>{
    const handleClose = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'escKey'
        }
    });
    const handleKeyDown = (0, $eJOHy.useCallback)((evt)=>{
        onKeyDown && onKeyDown(evt);
    }, [
        onKeyDown
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isOpen) window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleKeyDown,
        isOpen
    ]);
    const handleBlanketClick = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'blanket'
        }
    });
    const handleBackButtonClick = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'backButton'
        }
    });
    const body = (0, $2PAgW.canUseDOM) ? document.querySelector('body') : undefined;
    if (!body) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $4ELHx.default), {
        zIndex: zIndex,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9ODnR.default), {
                isOpen: isOpen,
                onBlanketClicked: handleBlanketClick,
                testId: testId && `${testId}--blanket`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jVgKM.DrawerPanel), {
                testId: testId,
                isOpen: isOpen,
                onClose: handleBackButtonClick,
                onCloseComplete: onCloseComplete,
                onOpenComplete: onOpenComplete,
                width: width,
                enterFrom: enterFrom,
                label: label,
                titleId: titleId,
                autoFocusFirstElem: autoFocusFirstElem,
                isFocusLockEnabled: isFocusLockEnabled,
                shouldReturnFocus: shouldReturnFocus,
                children: isOpen ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $ijDer.Layering), {
                    isDisabled: false,
                    children: [
                        children,
                        /*#__PURE__*/ (0, $gt9Am.jsx)($f3afa7e7b283db24$var$EscapeCloseManager, {
                            onClose: handleClose
                        })
                    ]
                }) : children
            })
        ]
    });
};

});
parcelRegister("9ODnR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f00e4ca2a000df1d$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");

var $gm1B2 = parcelRequire("gm1B2");

var $eLMgP = parcelRequire("eLMgP");
var $4n9MG = parcelRequire("4n9MG");
const $f00e4ca2a000df1d$var$styles = {
    blanket: "_kqswh2mm"
};
/**
 * A wrapper around `@atlaskit/blanket` that adds a fade in/out transition.
 */ const $f00e4ca2a000df1d$var$Blanket = ({ isOpen: isOpen, onBlanketClicked: onBlanketClicked, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eLMgP.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4n9MG.default), {
            /*
     * The fade out animation uses half the passed duration so it evens out.
     */ duration: "large",
            /**
     * We don't expose this on `FadeIn` but it does get passed down.
     * TODO: figure out how we want to handle this...
     */ // @ts-ignore
            animationTimingFunction: "ease-out",
            children: ({ className: className })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f00e4ca2a000df1d$var$styles.blanket,
                        className
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gm1B2.default), {
                        isTinted: true,
                        onBlanketClicked: onBlanketClicked,
                        testId: testId && testId
                    })
                })
        })
    });
};
var $f00e4ca2a000df1d$export$2e2bcd8739ae039 = $f00e4ca2a000df1d$var$Blanket;

});

parcelRegister("jVgKM", function(module, exports) {

$parcel$export(module.exports, "DrawerPanel", () => $658b5b37a9daa498$export$96114a266f19b4d0);
/* drawer-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eLMgP = parcelRequire("eLMgP");
var $am1Db = parcelRequire("am1Db");

var $62fzi = parcelRequire("62fzi");

var $fAwbQ = parcelRequire("fAwbQ");
const $658b5b37a9daa498$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $658b5b37a9daa498$var$styles = {
    root: "_1reo15vq _18m915vq _1e0c1txw _4t3i1kxc _kqsw1n9t _1pbybfng _bfhk1bhr _1q1l1bhr _152tze3t _1e02ze3t _ect41gqc",
    full: "_1bsbauwl",
    extended: "_1bsb1mwr",
    narrow: "_1bsb1gwv",
    medium: "_1bsb1y37",
    wide: "_1bsb1ogm"
}; /**
    * This wrapper is used to specify separate durations for enter and exit.
    */ 
const $658b5b37a9daa498$var$CustomSlideIn = ({ children: children, onFinish: onFinish, enterFrom: enterFrom })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $am1Db.default), {
        animationTimingFunction: "ease-out",
        duration: "small",
        enterFrom: enterFrom,
        exitTo: enterFrom,
        fade: "none",
        onFinish: onFinish,
        children: children
    });
}; /**
    * __Drawer panel__
    */ 
const $658b5b37a9daa498$export$96114a266f19b4d0 = ({ children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, testId: testId, isOpen: isOpen, shouldReturnFocus: shouldReturnFocus, autoFocusFirstElem: autoFocusFirstElem, isFocusLockEnabled: isFocusLockEnabled, width: width = 'narrow', label: label, titleId: titleId, enterFrom: enterFrom = 'left' })=>{
    /**
   * A ref to point to our wrapper, passed to `onCloseComplete` and `onOpenComplete` callbacks.
   */ const drawerRef = (0, $eJOHy.useRef)(null);
    const onFinish = (0, $eJOHy.useCallback)((state)=>{
        if (state === 'entering') onOpenComplete?.(drawerRef.current);
        else if (state === 'exiting') onCloseComplete?.(drawerRef.current);
    }, [
        onCloseComplete,
        onOpenComplete
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eLMgP.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $gt9Am.jsx)($658b5b37a9daa498$var$CustomSlideIn, {
            onFinish: onFinish,
            enterFrom: enterFrom,
            children: ({ className: className })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fAwbQ.default), {
                    autoFocusFirstElem: autoFocusFirstElem,
                    isFocusLockEnabled: isFocusLockEnabled,
                    shouldReturnFocus: shouldReturnFocus,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    , {
                        className: (0, $hcewu.default)([
                            $658b5b37a9daa498$var$styles.root,
                            $658b5b37a9daa498$var$styles[width],
                            className
                        ]),
                        "data-testid": testId,
                        ref: drawerRef,
                        "aria-modal": true,
                        role: "dialog",
                        "aria-label": label,
                        "aria-labelledby": titleId,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $62fzi.EnsureIsInsideDrawerContext).Provider, {
                            value: true,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $62fzi.OnCloseContext).Provider, {
                                value: onClose,
                                children: children
                            })
                        })
                    })
                })
        })
    });
};

});
parcelRegister("62fzi", function(module, exports) {

$parcel$export(module.exports, "OnCloseContext", () => $a4e1d7e4c8fd0365$export$7376ab1fc7707bdd);
$parcel$export(module.exports, "useOnClose", () => $a4e1d7e4c8fd0365$export$c2b12c82f332a6fb);
$parcel$export(module.exports, "EnsureIsInsideDrawerContext", () => $a4e1d7e4c8fd0365$export$e3662b8677049786);
$parcel$export(module.exports, "useEnsureIsInsideDrawer", () => $a4e1d7e4c8fd0365$export$780b9799f6bfecd8);

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");
const $a4e1d7e4c8fd0365$export$7376ab1fc7707bdd = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $a4e1d7e4c8fd0365$export$c2b12c82f332a6fb = ()=>(0, $eJOHy.useContext)($a4e1d7e4c8fd0365$export$7376ab1fc7707bdd);
const $a4e1d7e4c8fd0365$export$e3662b8677049786 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $a4e1d7e4c8fd0365$export$780b9799f6bfecd8 = ()=>{
    const context = (0, $eJOHy.useContext)($a4e1d7e4c8fd0365$export$e3662b8677049786);
    (0, $8GOss.default)(context, 'Drawer sub-components must be used within a Drawer component.');
};

});

parcelRegister("fAwbQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $422d943c9c1f698d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1Q3jn = parcelRequire("1Q3jn");
/**
 * __Focus lock__
 *
 * Thin wrapper around react-focus-lock.
 */ const $422d943c9c1f698d$var$FocusLock = ({ isFocusLockEnabled: isFocusLockEnabled = true, autoFocusFirstElem: autoFocusFirstElem = true, shouldReturnFocus: shouldReturnFocus = true, children: children })=>{
    const getFocusTarget = ()=>{
        if (typeof shouldReturnFocus === 'boolean') return shouldReturnFocus;
        return false;
    };
    const onDeactivation = ()=>{
        if (typeof shouldReturnFocus !== 'boolean') window.setTimeout(()=>{
            shouldReturnFocus?.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1Q3jn.default), {
        disabled: !isFocusLockEnabled,
        autoFocus: autoFocusFirstElem,
        returnFocus: getFocusTarget(),
        onDeactivation: onDeactivation,
        children: children
    });
};
var $422d943c9c1f698d$export$2e2bcd8739ae039 = $422d943c9c1f698d$var$FocusLock;

});



parcelRegister("ivTBg", function(module, exports) {

$parcel$export(module.exports, "DrawerCloseButton", () => $68e06d74b606efab$export$d0c3a75c17ac0cab);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4BzUI = parcelRequire("4BzUI");

var $bjHew = parcelRequire("bjHew");

var $62fzi = parcelRequire("62fzi");
const $68e06d74b606efab$export$d0c3a75c17ac0cab = ({ icon: Icon, label: label = 'Close drawer', testId: testId = 'DrawerCloseButton' })=>{
    (0, $62fzi.useEnsureIsInsideDrawer)();
    const onClose = (0, $62fzi.useOnClose)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
        onClick: onClose,
        testId: testId,
        icon: Icon ? (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                ...iconProps,
                size: "large",
                LEGACY_size: "large"
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($bjHew))),
        label: label,
        shape: "circle",
        appearance: "subtle"
    });
};

});

parcelRegister("2fsZx", function(module, exports) {

$parcel$export(module.exports, "DrawerContent", () => $b6b8d2b4e45b7ce5$export$57ca055474bc0056);
/* drawer-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ecYd5 = parcelRequire("ecYd5");

var $kmlzw = parcelRequire("kmlzw");

var $62fzi = parcelRequire("62fzi");

var $cPOtR = parcelRequire("cPOtR");
const $b6b8d2b4e45b7ce5$var$styles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug _19pk1ejb"
};
const $b6b8d2b4e45b7ce5$var$DrawerContentBase = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, scrollContentLabel: scrollContentLabel = 'Scrollable content', xcss: xcss }, scrollableRef)=>{
    const [showContentFocus, setContentFocus] = (0, $eJOHy.useState)(false);
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        const setLazyContentFocus = ()=>{
            const target = ref.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        };
        setLazyContentFocus();
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $b6b8d2b4e45b7ce5$var$styles.default,
            xcss
        ]),
        ref: (0, $kmlzw.mergeRefs)([
            ref,
            scrollableRef
        ]),
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? scrollContentLabel : undefined,
        "data-testid": "drawer-contents",
        children: children
    });
});
const $b6b8d2b4e45b7ce5$export$57ca055474bc0056 = ({ children: children, scrollContentLabel: scrollContentLabel, xcss: xcss })=>{
    (0, $62fzi.useEnsureIsInsideDrawer)();
    (0, $cPOtR.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ecYd5))), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($b6b8d2b4e45b7ce5$var$DrawerContentBase, {
            scrollContentLabel: scrollContentLabel,
            xcss: xcss,
            children: children
        })
    });
};

});
parcelRegister("cPOtR", function(module, exports) {

$parcel$export(module.exports, "default", () => $53ecfed965028866$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 * ⚠️ This is copied from `packages/design-system/modal-dialog/src/internal/hooks/use-prevent-programmatic-scroll.tsx`
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $53ecfed965028866$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $53ecfed965028866$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $eJOHy.useState)(0);
    (0, $eJOHy.useLayoutEffect)(()=>{
        setScrollTopOffset($53ecfed965028866$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $eJOHy.useCallback)(()=>{
        if ($53ecfed965028866$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return (0, $4eDgu.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("5xGaI", function(module, exports) {

$parcel$export(module.exports, "DrawerSidebar", () => $31d2e026391fc0b4$export$25c48648e7980210);
/* drawer-sidebar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $62fzi = parcelRequire("62fzi");
const $31d2e026391fc0b4$var$styles = {
    default: "_4cvr1h6o _vchhusvi _syaz1gjq _1e0c1txw _1o9zidpf _2lx21bp4 _4t3i1kxc _n3tdpxbi _ca0q1ejb _1bsbxncg"
};
const $31d2e026391fc0b4$export$25c48648e7980210 = ({ children: children, xcss: xcss })=>{
    (0, $62fzi.useEnsureIsInsideDrawer)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $31d2e026391fc0b4$var$styles.default,
            xcss
        ]),
        "data-testid": "drawer-sidebar",
        children: children
    });
};

});

parcelRegister("f50CR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a276e7eec809b43$export$2e2bcd8739ae039);
/* progress-tracker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $frzOj = parcelRequire("frzOj");

var $6xeUc = parcelRequire("6xeUc");
const $1a276e7eec809b43$var$containerStyles = null;
const $1a276e7eec809b43$var$spacingOptions = {
    comfortable: "var(--ds-space-500, 40px)",
    cozy: "var(--ds-space-200, 16px)",
    // @deprecated left for backwards compatibility
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
/**
 * __Progress tracker__
 *
 * A progress tracker displays the steps and progress through a journey.
 *
 * - [Examples](https://atlassian.design/components/progress-tracker/examples)
 * - [Code](https://atlassian.design/components/progress-tracker/code)
 * - [Usage](https://atlassian.design/components/progress-tracker/usage)
 */ const $1a276e7eec809b43$var$ProgressTracker = ({ items: items = [], spacing: spacing = 'cozy', render: render = {
    link: ({ item: item })=>// Anchor content is coming from another location
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $frzOj.default), {
            ...item
        })
}, animated: animated = true, testId: testId, label: label = 'Progress' })=>{
    const prevItems = (0, $eJOHy.useRef)(items.map((stage)=>({
            ...stage,
            percentageComplete: 0
        })));
    const previousStages = items.map((stage)=>{
        const oldStage = prevItems.current?.find((st)=>st.id === stage.id);
        return !!oldStage ? oldStage : stage;
    });
    (0, $eJOHy.useEffect)(()=>{
        prevItems.current = items;
    }, [
        items
    ]);
    const progressChanges = items.filter((stage, index)=>stage.percentageComplete !== previousStages[index].percentageComplete).length;
    const totalStepsForward = items.filter((stage, index)=>stage.percentageComplete > previousStages[index].percentageComplete).length;
    const totalStepsBack = items.filter((stage, index)=>stage.percentageComplete < previousStages[index].percentageComplete).length;
    let stepsForward = totalStepsForward;
    let stepsBack = totalStepsBack;
    const progressItems = items.map((stage, index)=>{
        let transitionSpeed = 0;
        let transitionDelay = 0;
        const transitionEasing = progressChanges > 1 ? 'linear' : 'cubic-bezier(0.15,1,0.3,1)';
        if (animated) {
            transitionSpeed = progressChanges > 1 ? 50 : 300;
            if (stage.percentageComplete < previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially in reverse.
         */ transitionDelay = (stepsBack - 1) * transitionSpeed;
                stepsBack -= 1;
            } else if (stage.percentageComplete > previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially.
         */ transitionDelay = (totalStepsForward - stepsForward) * transitionSpeed;
                stepsForward -= 1;
            }
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6xeUc.default), {
            transitionSpeed: transitionSpeed,
            transitionDelay: transitionDelay,
            transitionEasing: transitionEasing,
            item: stage,
            render: render
        }, stage.id);
    });
    const listInlineStyles = {
        gridTemplateColumns: `repeat(${items.length}, 1fr)`,
        ['--ds--pt--sp']: $1a276e7eec809b43$var$spacingOptions[spacing],
        maxWidth: 80 * items.length * 2
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)("ol", {
        "data-testid": testId,
        style: listInlineStyles,
        "aria-label": label,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _zulp6odm _1e0c11p5 _1bsb1osq _2mzuglyw _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _rxvc1jfw"
        ]),
        children: progressItems
    });
};
var $1a276e7eec809b43$export$2e2bcd8739ae039 = $1a276e7eec809b43$var$ProgressTracker;

});
parcelRegister("frzOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d62f1cb79484431$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $dPUtJ = parcelRequire("dPUtJ");
const $8d62f1cb79484431$var$styles = {
    anchor: "_4bfu18uv _1hmsglyw _ajmmnqa1 _11c81kw7 _syaz1fxt _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * __Progress tracker link__
 */ const $8d62f1cb79484431$var$Link = ({ href: href, onClick: onClick, label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dPUtJ.default), {
        xcss: $8d62f1cb79484431$var$styles.anchor,
        // TODO: We should not be rendering empty hrefs on anchors. This should be plain text or a button/pressable if `onClick` is provided.
        href: href || '',
        onClick: onClick,
        testId: testId,
        children: label
    });
};
var $8d62f1cb79484431$export$2e2bcd8739ae039 = $8d62f1cb79484431$var$Link;

});

parcelRegister("6xeUc", function(module, exports) {

$parcel$export(module.exports, "default", () => $41bca2d3bd2db161$export$2e2bcd8739ae039);
/* stage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $bmZ1f = parcelRequire("bmZ1f");

var $dhRXV = parcelRequire("dhRXV");


var $fqkJg = parcelRequire("fqkJg");

var $eB3zP = parcelRequire("eB3zP");
const $41bca2d3bd2db161$var$styles = {
    listItemContent: "_1bsb1osq _kqswh2mm"
};
const $41bca2d3bd2db161$var$textColor = {
    unvisited: "_syaz131l",
    current: "_syaz1e6v",
    visited: "_syaz1fxt",
    disabled: "_syaz1lh4"
};
const $41bca2d3bd2db161$var$fontWeight = {
    unvisited: "_k48pi7a9",
    current: "_k48pmoej",
    visited: "_k48pmoej",
    disabled: "_k48pmoej"
};
const $41bca2d3bd2db161$var$getMarkerColor = ({ status: status, percentageCompleted: percentageCompleted })=>{
    switch(status){
        case 'unvisited':
            return `var(--ds-icon-subtle, ${0, $135dba7912433cc2$export$5f71e19f3a7ad9de})`;
        case 'current':
        case 'visited':
            return `var(--ds-icon-brand, ${0, $135dba7912433cc2$export$e62e8919cca44969})`;
        case 'disabled':
            if (percentageCompleted === 0) return `var(--ds-icon-disabled, ${0, $135dba7912433cc2$export$5f71e19f3a7ad9de})`;
            // If the percentage completed is greater than 0, we show the brand colour, so that the marker (circle) blends in with the progress bar.
            // Otherwise, the grey marker would be visible within the progress bar.
            return `var(--ds-icon-brand, ${0, $135dba7912433cc2$export$e62e8919cca44969})`;
        default:
            return;
    }
};
const $41bca2d3bd2db161$var$listItemStyles = null;
const $41bca2d3bd2db161$var$titleStyles = null;
class $41bca2d3bd2db161$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), this.nodeRefMarker = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.nodeRefBar = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.nodeRefTitle = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.onEntered = ()=>{
            this.setState({
                transitioning: false,
                oldMarkerColor: $41bca2d3bd2db161$var$getMarkerColor({
                    status: this.props.item.status,
                    percentageCompleted: this.props.item.percentageComplete
                }),
                oldPercentageComplete: this.props.item.percentageComplete
            });
        };
        this.state = {
            transitioning: false,
            oldMarkerColor: $41bca2d3bd2db161$var$getMarkerColor({
                status: this.props.item.status,
                percentageCompleted: this.props.item.percentageComplete
            }),
            oldPercentageComplete: 0
        };
    }
    UNSAFE_componentWillMount() {
        this.setState({
            ...this.state,
            transitioning: true
        });
    }
    UNSAFE_componentWillReceiveProps() {
        this.setState({
            ...this.state,
            transitioning: true
        });
    }
    shouldShowLink() {
        return this.props.item.status === 'visited' && // TODO: `noLink` is unnecessary as we should just be detecting if the `href` is set...
        !this.props.item.noLink;
    }
    render() {
        const { item: item, render: render, transitionDelay: transitionDelay, transitionSpeed: transitionSpeed, transitionEasing: transitionEasing, testId: testId } = this.props;
        const ariaCurrent = item.status === 'current' ? 'step' : 'false';
        const listInlineStyles = {
            ['--ds--pt--ts']: `${transitionSpeed}ms`,
            ['--ds--pt--td']: `${transitionDelay}ms`,
            ['--ds--pt--te']: transitionEasing,
            ['--ds--pt--mc']: this.state.oldMarkerColor,
            ['--ds--pt--bg']: $41bca2d3bd2db161$var$getMarkerColor({
                status: item.status,
                percentageCompleted: item.percentageComplete
            }),
            listStyleType: 'none'
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: listInlineStyles,
            "aria-current": ariaCurrent,
            className: (0, $hcewu.default)([
                "_6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1i4q1hna"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dhRXV.default), {
                xcss: $41bca2d3bd2db161$var$styles.listItemContent,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmZ1f.default), {
                        appear: true,
                        in: this.state.transitioning,
                        onEntered: this.onEntered,
                        timeout: transitionDelay + transitionSpeed,
                        classNames: "fade",
                        nodeRef: this.nodeRefMarker,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eB3zP.default), {
                            testId: testId && `${testId}-marker`
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmZ1f.default), {
                        appear: true,
                        in: this.state.transitioning,
                        onEntered: this.onEntered,
                        timeout: transitionDelay + transitionSpeed,
                        classNames: "fade",
                        nodeRef: this.nodeRefBar,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqkJg.default), {
                            testId: testId && `${testId}-bar`,
                            percentageComplete: item.percentageComplete
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmZ1f.default), {
                        appear: true,
                        in: this.state.transitioning,
                        onEntered: this.onEntered,
                        timeout: transitionDelay + transitionSpeed,
                        classNames: "fade",
                        nodeRef: this.nodeRefTitle,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            "data-testid": testId && `${testId}-title`,
                            className: (0, $hcewu.default)([
                                "_11c82smr _v564ph28 _1pfhv47k _y3gn1h6o _1t9yph28 _1ez2kb7n _1uuw17dr",
                                $41bca2d3bd2db161$var$textColor[item.status],
                                $41bca2d3bd2db161$var$fontWeight[item.status]
                            ]),
                            children: this.shouldShowLink() ? render.link({
                                item: item
                            }) : item.label
                        })
                    })
                ]
            })
        });
    }
}

});
parcelRegister("fqkJg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e5698ef496934c3$export$2e2bcd8739ae039);
/* bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $6e5698ef496934c3$var$spacing = {
    comfortable: "var(--ds-space-500, 40px)",
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
const $6e5698ef496934c3$var$progressBarStyles = null;
/**
 * __Progress bar__
 *
 * A progress bar describes the horizontal tracking bar that traverses each individual step.
 *
 */ const $6e5698ef496934c3$var$ProgressBar = ({ percentageComplete: percentageComplete, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        style: {
            width: `calc(${percentageComplete}% + ${percentageComplete / 100} * calc(var(--ds--pt--sp, ${$6e5698ef496934c3$var$spacing.cosy}) + ${"var(--ds-space-050, 4px)"}))`
        },
        className: (0, $hcewu.default)([
            "_v564d86a _4t3iu2gc _kqswstnw _bfhkq17z _1einu2gc _5fbcu2gc _1e021ssb _t9ecymk3 _1lww1oqq"
        ])
    });
var $6e5698ef496934c3$export$2e2bcd8739ae039 = $6e5698ef496934c3$var$ProgressBar;

});

parcelRegister("eB3zP", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a13259050ef5b6$export$2e2bcd8739ae039);
/* marker.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $66a13259050ef5b6$var$progressMarkerStyles = null;
/**
 * __Progress marker__
 *
 * Similar to `@atlaskit/progress-indicator`, a small visual circle marker
 */ const $66a13259050ef5b6$var$ProgressMarker = ({ testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_2rkou2gc _v5645rui _1bsbu2gc _4t3iu2gc _kqswstnw _bfhkr3ku _1e021ssb _t9ec157a _1lww1oqq _1uuw17dr _1ez2kb7n _1190pbrw _1ia8r3ku"
        ])
    });
var $66a13259050ef5b6$export$2e2bcd8739ae039 = $66a13259050ef5b6$var$ProgressMarker;

});



parcelRegister("ekP6G", function(module, exports) {

$parcel$export(module.exports, "default", () => $5333e4d79e61181d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dhRXV = parcelRequire("dhRXV");
var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");

var $51Gwp = parcelRequire("51Gwp");

var $pUkPE = parcelRequire("pUkPE");

var $alkjW = parcelRequire("alkjW");

var $jtnjR = parcelRequire("jtnjR");
var $i9p2T = parcelRequire("i9p2T");
var $7BnZ9 = parcelRequire("7BnZ9");
var $1Xk9R = parcelRequire("1Xk9R");
var $j6N1q = parcelRequire("j6N1q");
var $emAda = parcelRequire("emAda");
var $15pUD = parcelRequire("15pUD");

var $eKx5I = parcelRequire("eKx5I");

var $3p4gP = parcelRequire("3p4gP");

var $lRq8t = parcelRequire("lRq8t");

var $dk6v8 = parcelRequire("dk6v8");

var $d6B0e = parcelRequire("d6B0e");

var $cjcvQ = parcelRequire("cjcvQ");
const $5333e4d79e61181d$var$linkTypeRadioOptions = [
    {
        name: 'linkType',
        value: 'OAUTH2.0',
        label: 'Atlassian product via OAuth 2.0'
    },
    {
        name: 'linkType',
        value: 'OAUTH1.0',
        label: 'Direct application link via OAuth 1.0'
    },
    {
        name: 'linkType',
        value: 'TUNNEL',
        label: 'Existing application tunnel'
    }
];
const $5333e4d79e61181d$var$CreateSubpage = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onFormSubmit = async (data)=>{
        try {
            const remoteManifestPromise = (0, $dk6v8.fetchApplinkManifestForUrl)(data.remoteUrl);
            const localManifestPromise = (0, $dk6v8.fetchThisManifest)();
            const remoteManifest = await remoteManifestPromise;
            const localManifest = await localManifestPromise;
            // Check the remote application supports the selected variant type
            if (data.linkType === 'OAUTH2.0' && !remoteManifest.inboundAuthenticationTypes.includes((0, $d6B0e.APPLINKS_IS_OAUTH2_SUPPORTED_PROVIDER_CHECK))) // TODO: Better error message - maybe a custom dialogue?
            throw new Error('The remote application does not support OAuth 2.0 authentication. Please select a different link type.');
            props.onSuccess({
                kind: 'review',
                variant: data.linkType,
                localManifest: localManifest,
                remoteManifest: remoteManifest
            });
        } catch (error) {
            if (data.linkType === 'OAUTH1.0') props.onSuccess({
                kind: 'manual-create',
                variant: 'OAUTH1.0',
                error: error instanceof Error ? error.message : 'An unknown error occurred.'
            });
            else props.onError(error instanceof Error ? error.message : 'An unknown error occurred.');
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtnjR.default), {
        onSubmit: onFormSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j6N1q.default), {
            title: formatMessage((0, $cjcvQ.default).createHeaderText)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), null, `${formatMessage((0, $cjcvQ.default).applicationLinkInformationText)} `, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
            href: "https://support.atlassian.com/jira-cloud-administration/docs/use-applinks-to-link-to-atlassian-products/",
            target: "_blank"
        }, ' ', formatMessage((0, $cjcvQ.default).applicationLinkHowToLinkText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
            size: "small"
        }, "Required fields are marked with an asterisk ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $15pUD.default), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emAda.default), {
            title: "Application link type"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7BnZ9.default), {
            label: "Link type",
            name: "linkType",
            defaultValue: "OAUTH2.0",
            isRequired: true
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3p4gP.default), {
                ...fieldProps,
                options: $5333e4d79e61181d$var$linkTypeRadioOptions
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.HelperMessage), null, "Check the application's documentation for supported link types")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emAda.default), {
            title: "External application details"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7BnZ9.default), {
            "aria-required": true,
            name: "remoteUrl",
            label: "Application URL",
            isRequired: true
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
                autoComplete: "off",
                placeholder: "https://example.atlassian.net",
                ...fieldProps
            }), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.HelperMessage), null, "Enter the URL for the Atlassian product "), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.ErrorMessage), null, "You must enter a valid URL")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Xk9R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $pUkPE.default), {
            label: "Form submit options"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
            appearance: "subtle",
            onClick: props.onCancel
        }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
            type: "submit",
            appearance: "primary",
            isLoading: submitting
        }, "Next")))));
};
var $5333e4d79e61181d$export$2e2bcd8739ae039 = $5333e4d79e61181d$var$CreateSubpage;

});
parcelRegister("j6N1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d94891a5d3369e$export$2e2bcd8739ae039);
/* form-header.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-primitives */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $bvFRW = parcelRequire("bvFRW");
const $d6d94891a5d3369e$var$formHeaderContentStyles = null;
const $d6d94891a5d3369e$var$formHeaderDescriptionStyles = null;
/**
 * __Form header__.
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $d6d94891a5d3369e$var$FormHeader = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        children: [
            title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvFRW.default), {
                size: "large",
                children: title
            }),
            description && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1pfhu2gc"
                ]),
                children: description
            }),
            children && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1ul91osq _1pfhu2gc"
                ]),
                children: children
            })
        ]
    });
};
var $d6d94891a5d3369e$export$2e2bcd8739ae039 = $d6d94891a5d3369e$var$FormHeader;

});

parcelRegister("3p4gP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a9bb6eac93a692a2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9pZRF = parcelRequire("9pZRF");

var $gdEz9 = parcelRequire("gdEz9");

var $XtPks = parcelRequire("XtPks");
const $a9bb6eac93a692a2$var$noOptions = [];
function $a9bb6eac93a692a2$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $a9bb6eac93a692a2$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, $9pZRF.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $gdEz9.useId)();
    const [selectedValue, setSelectedValue] = (0, $eJOHy.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $XtPks.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}

});
parcelRegister("XtPks", function(module, exports) {

$parcel$export(module.exports, "default", () => $e239b0122229064f$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j2fEo = parcelRequire("j2fEo");

var $9pZRF = parcelRequire("9pZRF");

var $8XtVW = parcelRequire("8XtVW");
const $e239b0122229064f$var$packageName = "platform-pkg";
const $e239b0122229064f$var$packageVersion = "0.0.0-use.local";
const $e239b0122229064f$var$noop = (0, $9pZRF.default);
const $e239b0122229064f$var$labelPaddingStyles = null;
const $e239b0122229064f$var$labelStyles = null;
const $e239b0122229064f$var$radioStyles = null;
const $e239b0122229064f$var$newRadioStyles = null;
const $e239b0122229064f$var$InnerRadio = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $e239b0122229064f$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $e239b0122229064f$var$packageName,
        packageVersion: $e239b0122229064f$var$packageVersion
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                "aria-labelledby": labelId || ariaLabelledBy,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $hcewu.default)([
                    "_18s8ze3t _19it3vzd _2rko1q5u _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1q5u _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _4fps13gf _5ry313gf _qep213gf _180n13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _2kbk1y1w _6cyr1y1w _n8t01y1w _1o5r1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1if1zcs9 _bl0ezcs9 _92nazcs9 _awurzcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _wml015t7 _tusm15t7 _1c6f15t7 _qftt15t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvehbj _1bg4jfq9 _6tjkehbj _awqnjfq9 _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
                    (0, $8XtVW.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                className: (0, $hcewu.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $e239b0122229064f$var$Radio = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($e239b0122229064f$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $e239b0122229064f$export$2e2bcd8739ae039 = $e239b0122229064f$var$Radio;

});


parcelRegister("cjcvQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $79ec26d9852ca5f5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $79ec26d9852ca5f5$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    applicationLinkInformationText: {
        "id": "applinks.administration.ui.creation-flow-dialog.application-link-information-text",
        "defaultMessage": "An application link requires an existing application tunnel or the application's URL. We use either one to connect the application to Jira."
    },
    applicationLinkHowToLinkText: {
        "id": "appinks.administration.ui.creation-flow-dialog.application-link-how-to-text",
        "defaultMessage": "How to create an application link"
    },
    cancelButtonText: {
        "id": "applinks.administration.ui.creation-flow-dialog.cancel-form-button-text",
        "defaultMessage": "Cancel"
    },
    createHeaderText: {
        "id": "applinks.administration.ui.creation-flow-dialog.create-header-text",
        "defaultMessage": "Create an application link"
    },
    completeButtonText: {
        "id": "applinks.administration.ui.creation-flow-dialog.create-form-button-text",
        "defaultMessage": "Create"
    },
    nextButtonText: {
        "id": "applinks.administration.ui.creation-flow-dialog.next-form-button-text",
        "defaultMessage": "Next"
    },
    reciprocalRedirectButtonText: {
        "id": "applinks.administration.ui.creation-flow-dialog.reciprocal-redirect-form-button-text",
        "defaultMessage": "Finish Setting Up"
    }
});

});


parcelRegister("cYu93", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0fcb53cb9c822c1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $pUkPE = parcelRequire("pUkPE");

var $alkjW = parcelRequire("alkjW");

var $jtnjR = parcelRequire("jtnjR");
var $1Xk9R = parcelRequire("1Xk9R");
var $j6N1q = parcelRequire("j6N1q");

var $6alcT = parcelRequire("6alcT");

var $f5hWU = parcelRequire("f5hWU");

var $9M9zY = parcelRequire("9M9zY");
var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");

var $lRq8t = parcelRequire("lRq8t");

var $a4pY2 = parcelRequire("a4pY2");

var $i0t2M = parcelRequire("i0t2M");

var $dk6v8 = parcelRequire("dk6v8");

var $ffsuj = parcelRequire("ffsuj");
const $b0fcb53cb9c822c1$var$styles = {
    linkDisplay: "_19pkpxbi _otyrpxbi"
};
const $b0fcb53cb9c822c1$var$ReviewSubpage = (props)=>{
    (0, $lRq8t.default)();
    const reciprocalMode = props.state.kind === 'reciprocal-review';
    const thisApplicationManifest = props.state.localManifest;
    const targetApplicationManifest = props.state.remoteManifest; // TODO: Determine if the type is DC or Cloud
    const thisApplicationType = (0, $a4pY2.lookupTypeByTypeId)(thisApplicationManifest.typeId, false);
    const targetApplicationType = (0, $a4pY2.lookupTypeByTypeId)(targetApplicationManifest.typeId, false);
    const onFormSubmitOAuth1 = async ()=>{
        const applinkCreationEntity = {
            id: targetApplicationManifest.id,
            name: targetApplicationManifest.name,
            displayUrl: targetApplicationManifest.url,
            rpcUrl: targetApplicationManifest.url,
            typeId: targetApplicationManifest.typeId,
            isPrimary: false,
            isSystem: false,
            isOAuth2ThreeLoEnabled: false
        };
        try {
            await (0, $dk6v8.putApplink)(applinkCreationEntity);
            if (props.state.kind === 'reciprocal-review' && props.state.inboundCreationState.applinkOriginalCreatedId) {
                // Configure OAuth
                await (0, $dk6v8.putApplinkOAuthOne3LOProvider)(targetApplicationManifest.id);
                await (0, $dk6v8.autoConfigureApplinkConsumer)(targetApplicationManifest.id);
                await (0, $dk6v8.putApplinkOAuthOne2LOProvider)(targetApplicationManifest.id); // Update status log
                const updatedApplinkCreationStatusLog = (0, $ffsuj.updateStatusLog)(props.state.inboundCreationState.applinkCreationStatusLog, {
                    status: (0, $ffsuj.STATUS_RECIPROCAL_SUCCESS)
                });
                const newCreationState = {
                    applinkCreationStatusLog: updatedApplinkCreationStatusLog,
                    applinkOriginalCreatedId: props.state.inboundCreationState.applinkOriginalCreatedId,
                    sharedUserbase: props.state.inboundCreationState.sharedUserbase,
                    applinkConfigInPreAuth: true,
                    applinkConfigInServerAuth: true,
                    applinkConfigInUserAuth: true,
                    applinkConfigOutPreAuth: true,
                    applinkConfigOutServerAuth: true,
                    applinkConfigOutUserAuth: true
                };
                const newRedirectionUrl = (0, $ffsuj.generateApplinksCreationRedirectionUrl)(targetApplicationManifest.url, targetApplicationManifest.typeId, newCreationState); // TODO: Maybe have a button?
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.location.href = newRedirectionUrl;
                return;
            }
            props.onSuccess({
                kind: 'reciprocal-prompt',
                variant: props.state.variant,
                remoteManifest: targetApplicationManifest,
                localManifest: thisApplicationManifest
            });
        } catch (error) {
            props.onError(error instanceof Error ? error.message : 'An unknown error occurred.');
            return error;
        }
    };
    const onFormSubmitOAuth2 = async ()=>{
        const applinkCreationEntity = {
            id: targetApplicationManifest.id,
            name: targetApplicationManifest.name,
            displayUrl: targetApplicationManifest.url,
            rpcUrl: targetApplicationManifest.url,
            typeId: targetApplicationManifest.typeId,
            isPrimary: false,
            isSystem: false,
            isOAuth2ThreeLoEnabled: true
        }; // In the legacy frontend, we set the following properties. However they do not
        // exist in backend code. I'm confused.
        // applinkCreationEntity.scopes = [ "WRITE" ];
        // applinkCreationEntity.tokenUrl = "tokenUrl";
        // applinkCreationEntity.authorizationUrl = "authorizationUrl";
        try {
            await (0, $dk6v8.createOAuth2Applink)(applinkCreationEntity);
            await (0, $dk6v8.putApplinkOAuthTwo3LOProvider)(targetApplicationManifest.id);
            await (0, $dk6v8.putApplinkOAuthTwo2LOProvider)(targetApplicationManifest.id);
            const ourOAuth2ConfigInfo = await (0, $dk6v8.getOAuth2ConfigInfo)(targetApplicationManifest.id);
            props.onSuccess({
                kind: 'connect',
                variant: props.state.variant,
                remoteManifest: targetApplicationManifest,
                localClientId: ourOAuth2ConfigInfo.inboundOAuthClientId,
                localClientSecret: ourOAuth2ConfigInfo.inboundOAuthClientSecret,
                remoteApplicationSupportedScopes: ourOAuth2ConfigInfo.remoteApplicationSupportedScopes || []
            });
        } catch (error) {
            props.onError(error instanceof Error ? error.message : 'An unknown error occurred.');
            return error;
        }
    };
    const onFormSubmit = async ()=>{
        switch(props.state.variant){
            case 'OAUTH1.0':
            case 'TUNNEL':
                return onFormSubmitOAuth1();
            case 'OAUTH2.0':
                return onFormSubmitOAuth2();
            default:
                props.onError('Unknown link type selected.');
        }
    };
    const getVariantProperName = ()=>{
        switch(props.state.variant){
            case 'OAUTH1.0':
                return 'Review OAuth 1.0 link';
            case 'OAUTH2.0':
                return 'Review OAuth 2.0 link';
            case 'TUNNEL':
            default:
                return 'Review tunnelled link';
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtnjR.default), {
        onSubmit: onFormSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j6N1q.default), {
            title: reciprocalMode ? 'Review incoming link' : getVariantProperName()
        }, !reciprocalMode && (props.state.variant === 'OAUTH1.0' || props.state.variant === 'TUNNEL') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, "Confirm the details of the application link you are creating. This will allow the remote ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
            as: "strong"
        }, targetApplicationType.name), " to access this Jira site. You will later be redirected to ", targetApplicationType.name, " to complete the other side of the link."), !reciprocalMode && props.state.variant === 'OAUTH2.0' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, "Confirm the details of the application link you are creating. In the next step, you will exchange credentials to allow the remote", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
            as: "strong"
        }, targetApplicationType.name), " to communicate with this Jira site."), reciprocalMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, "The remote ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
            as: "strong"
        }, targetApplicationType.name), " application has requested to create a link to this Jira site. Review the details below before completing the link. This will allow the remote ", targetApplicationType.name, " to access this Jira site.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            xcss: $b0fcb53cb9c822c1$var$styles.linkDisplay,
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0t2M.default), {
            applicationType: thisApplicationType,
            displayUrl: thisApplicationManifest.url,
            heading: "This application"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
            space: "space.100",
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f5hWU))), {
            label: "Link icon"
        }), reciprocalMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
            appearance: "inprogress"
        }, "Partially Connected"), !reciprocalMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), null, "Not Connected")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0t2M.default), {
            applicationType: targetApplicationType,
            displayUrl: targetApplicationManifest.url,
            heading: "Remote application"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Xk9R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $pUkPE.default), {
            label: "Form submit options"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
            appearance: "subtle",
            onClick: props.onCancel
        }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
            type: "submit",
            appearance: "primary",
            isLoading: submitting
        }, reciprocalMode ? 'Complete link' : 'Create link')))));
};
var $b0fcb53cb9c822c1$export$2e2bcd8739ae039 = $b0fcb53cb9c822c1$var$ReviewSubpage;

});
parcelRegister("f5hWU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afb53ef3a723fab0$var$_react = $afb53ef3a723fab0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $afb53ef3a723fab0$var$_baseNew = $afb53ef3a723fab0$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $afb53ef3a723fab0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $afb53ef3a723fab0$var$LinkIcon = (props)=>/*#__PURE__*/ $afb53ef3a723fab0$var$_react.default.createElement($afb53ef3a723fab0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$afb53ef3a723fab0$var$LinkIcon.displayName = 'LinkIcon';
var $afb53ef3a723fab0$var$_default = module.exports.default = $afb53ef3a723fab0$var$LinkIcon;

});


parcelRegister("1E9Rd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e05c467f8218d74$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $pUkPE = parcelRequire("pUkPE");

var $alkjW = parcelRequire("alkjW");
var $kQDPJ = parcelRequire("kQDPJ");

var $jtnjR = parcelRequire("jtnjR");
var $1Xk9R = parcelRequire("1Xk9R");
var $j6N1q = parcelRequire("j6N1q");

var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");

var $lRq8t = parcelRequire("lRq8t");

var $a4pY2 = parcelRequire("a4pY2");

var $i0t2M = parcelRequire("i0t2M");

var $ffsuj = parcelRequire("ffsuj");
const $0e05c467f8218d74$var$styles = {
    linkDisplay: "_19pkpxbi _otyrpxbi"
};
const $0e05c467f8218d74$var$ReciprocalPromptSubpage = (props)=>{
    (0, $lRq8t.default)();
    const thisApplicationManifest = props.state.localManifest;
    const targetApplicationManifest = props.state.remoteManifest;
    const targetCloudId = props.state.remoteManifest.id;
    const thisBaseUrl = thisApplicationManifest.url;
    const thisBaseTypeId = thisApplicationManifest.typeId;
    const creationState = (0, $ffsuj.getDefaultCreationState)(thisBaseUrl, thisBaseTypeId, targetCloudId);
    const reciprocalLinkUrl = (0, $ffsuj.generateApplinksCreationRedirectionUrl)(targetApplicationManifest.url, targetApplicationManifest.typeId, creationState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtnjR.default), {
        onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j6N1q.default), {
            title: "Create reciprocal link"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, "A link from Jira to ", targetApplicationManifest.name, " has been established. You will need to navigate to ", targetApplicationManifest.name, " to complete the link.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            xcss: $0e05c467f8218d74$var$styles.linkDisplay,
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0t2M.default // TODO: Determine if the type is DC or Cloud
        ), {
            applicationType: (0, $a4pY2.lookupTypeByTypeId)(targetApplicationManifest.typeId, false),
            displayUrl: targetApplicationManifest.url,
            heading: "Application Link",
            connectedStatus: "partially-connected"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Xk9R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $pUkPE.default), {
            label: "Form submit options"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
            appearance: "subtle"
        }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kQDPJ.default), {
            href: reciprocalLinkUrl,
            appearance: "primary"
        }, `Continue on ${targetApplicationManifest.name}`)))));
};
var $0e05c467f8218d74$export$2e2bcd8739ae039 = $0e05c467f8218d74$var$ReciprocalPromptSubpage;

});

parcelRegister("3DmnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b10a04daded43b37$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $pUkPE = parcelRequire("pUkPE");

var $alkjW = parcelRequire("alkjW");

var $jtnjR = parcelRequire("jtnjR");
var $1Xk9R = parcelRequire("1Xk9R");
var $j6N1q = parcelRequire("j6N1q");

var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");

var $dPlS8 = parcelRequire("dPlS8");

var $lRq8t = parcelRequire("lRq8t");

var $a4pY2 = parcelRequire("a4pY2");

var $i0t2M = parcelRequire("i0t2M");

var $dk6v8 = parcelRequire("dk6v8");

var $d6B0e = parcelRequire("d6B0e");
const $b10a04daded43b37$var$styles = {
    linkDisplay: "_19pkpxbi _otyrpxbi"
};
const $b10a04daded43b37$var$ConfirmationSubpage = (props)=>{
    (0, $lRq8t.default)();
    const [status, setStatus] = (0, $eJOHy.useState)(null);
    const finaliseOAuth1Link = async (confirmationApplinkId)=>{
        await (0, $dk6v8.putApplinkOAuthOne3LOProvider)(confirmationApplinkId);
        await (0, $dk6v8.autoConfigureApplinkConsumer)(confirmationApplinkId);
        await (0, $dk6v8.putApplinkOAuthOne2LOProvider)(confirmationApplinkId);
        setStatus(await (0, $dk6v8.fetchApplinkStatus)(confirmationApplinkId));
    };
    (0, $eJOHy.useEffect)(()=>{
        // TODO: Enforce this using discriminated union types
        if (props.state.variant === 'OAUTH2.0') {
            setStatus(null);
            return;
        }
        finaliseOAuth1Link(props.state.confirmationApplinkId);
    }, [
        props.state.confirmationApplinkId,
        props.state.variant
    ]);
    const determineStatus = ()=>{
        if (status === null) return 'not-connected';
        if (status.working) return 'connected';
        if (status.error) return 'error';
        return 'not-connected';
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtnjR.default), {
        onSubmit: ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.href = (0, $d6B0e.APPLINKS_LIST_PAGE_URL);
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j6N1q.default), {
            title: "Confirmation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, "The application link has been created.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            xcss: $b10a04daded43b37$var$styles.linkDisplay,
            space: "space.200"
        }, status && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0t2M.default // TODO: Determine if the type is DC or Cloud
        ), {
            applicationType: (0, $a4pY2.lookupTypeByTypeId)(status.link.type, false),
            displayUrl: status.link.displayUrl,
            heading: "Application Link",
            connectedStatus: determineStatus()
        }), status === null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPlS8.default), {
            size: "medium"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Xk9R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $pUkPE.default), {
            label: "Form submit options"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
            type: "submit",
            appearance: "primary",
            isLoading: status === null
        }, "Done")))));
};
var $b10a04daded43b37$export$2e2bcd8739ae039 = $b10a04daded43b37$var$ConfirmationSubpage;

});

parcelRegister("4pa0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $de09409d970b1f91$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $pUkPE = parcelRequire("pUkPE");

var $alkjW = parcelRequire("alkjW");

var $jtnjR = parcelRequire("jtnjR");
var $1Xk9R = parcelRequire("1Xk9R");
var $j6N1q = parcelRequire("j6N1q");
var $emAda = parcelRequire("emAda");
var $15pUD = parcelRequire("15pUD");

var $dhRXV = parcelRequire("dhRXV");
var $9M9zY = parcelRequire("9M9zY");
var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");

var $51Gwp = parcelRequire("51Gwp");

var $lRq8t = parcelRequire("lRq8t");

var $83DiZ = parcelRequire("83DiZ");

var $dk6v8 = parcelRequire("dk6v8");

var $ffsuj = parcelRequire("ffsuj");

var $d6B0e = parcelRequire("d6B0e");

var $8SMrZ = parcelRequire("8SMrZ");
const $de09409d970b1f91$var$styles = {
    linkDisplay: "_19pkpxbi _otyrpxbi",
    growField: "_16jlkb7n"
};
const $de09409d970b1f91$var$ConnectSubpage = (props)=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    (0, $lRq8t.default)();
    const onFormSubmit = async (data)=>{
        // TODO: Validate the scopes before proceeding
        const scopes = data.remoteApplicationSupportedScopes ? data.remoteApplicationSupportedScopes.map((scope)=>scope.value) : [];
        const oauth2Config = {
            remoteClientId: data.applicationClientId,
            remoteClientSecret: data.applicationClientSecret,
            remoteRedirectUrl: data.redirectUrl,
            outboundScopes: scopes
        };
        try {
            await (0, $dk6v8.putOAuth2ConfigInfo)(props.state.remoteManifest.id, oauth2Config);
            push((0, $d6B0e.APPLINKS_LIST_PAGE_URL));
        } catch (error) {
            props.onError(error instanceof Error ? error.message : 'An unknown error occurred.');
            return error;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtnjR.default), {
        onSubmit: onFormSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j6N1q.default), {
            title: "Connect to the application"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, "Copy and paste the details below between this page and the settings page of the external application where you configure application links. This creates a secure connection.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
            "aria-hidden": "true",
            size: "small"
        }, "Required fields are marked with an asterisk ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $15pUD.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emAda.default), {
            title: "Outgoing link",
            description: "Copy these details to the external application. If you're not an admin of the application, ask an existing admin to make the updates for you."
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
            xcss: $de09409d970b1f91$var$styles.growField
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.CopyableApplicationClientID), {
            name: "copyableApplicationClientId",
            clientId: props.state.localClientId
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
            xcss: $de09409d970b1f91$var$styles.growField
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.CopyableApplicationClientSecret), {
            name: "copyableApplicationClientSecret",
            clientSecret: props.state.localClientSecret
        }))), !props.state.remoteManifest.isCloud && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.RemoteApplicationScopeMultiSelect), {
            name: "remoteApplicationSupportedScopes",
            supportedScopes: props.state.remoteApplicationSupportedScopes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
            href: (0, $ffsuj.getApplinksAdminUrl)(props.state.remoteManifest.url, props.state.remoteManifest.typeId),
            target: "_blank"
        }, "Go to ", props.state.remoteManifest.url))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emAda.default), {
            title: "Incoming link",
            description: "Find these details in the external application and enter them below. You may need to ask an admin of the external application for these details."
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
            xcss: $de09409d970b1f91$var$styles.growField
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.ApplicationClientId), {
            name: "applicationClientId"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
            xcss: $de09409d970b1f91$var$styles.growField
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.ApplicationClientSecret), {
            name: "applicationClientSecret"
        }))), !props.state.remoteManifest.isCloud && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.RedirectUrl), {
            name: "redirectUrl"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.DisplayName), {
            name: "displayName",
            defaultName: props.state.remoteManifest.name
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Xk9R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $pUkPE.default), {
            label: "Form submit options"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
            appearance: "subtle",
            onClick: ()=>push((0, $d6B0e.APPLINKS_LIST_PAGE_URL))
        }, "Save and exit"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
            type: "submit",
            appearance: "primary",
            isLoading: submitting
        }, "Connect"))))));
};
var $de09409d970b1f91$export$2e2bcd8739ae039 = $de09409d970b1f91$var$ConnectSubpage;

});





parcelRegister("gEhrq", function(module, exports) {

$parcel$export(module.exports, "applinksAdministrationListRoute", () => $d6c98621ea44512b$export$1eaebf5f3954a8b6);
const $d6c98621ea44512b$export$1eaebf5f3954a8b6 = {
    name: 'global-settings-products-applinks-administration-list',
    path: '/jira/settings/applinks',
    exact: true
};

});


parcelRegister("gK0o2", function(module, exports) {

$parcel$export(module.exports, "applinksExtraAuthHealthcheckRouteEntry", () => $bc4c6f2c1f49a0d6$export$cd4854d613a2c404);

var $dihHZ = parcelRequire("dihHZ");

var $9rz9P = parcelRequire("9rz9P");

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $7jTnu = parcelRequire("7jTnu");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $5fjzQ = parcelRequire("5fjzQ");
const $bc4c6f2c1f49a0d6$export$cd4854d613a2c404 = (0, $6xToB.createEntry)((0, $9rz9P.applinksExtraAuthHealthcheckRoute), ()=>({
        group: 'global-settings',
        ufoName: 'applinks-extra-auth-healthcheck',
        component: (0, $bJscI.componentWithFG)('applinks-789-extra-auth-healthcheck-frontend', (0, $dihHZ.default), (0, $9BJU1.default)),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>(0, $7jTnu.fg)('applinks-789-extra-auth-healthcheck-frontend'),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        meta: {
            reporting: {
                id: 'Applinks',
                packageName: 'jiraAdminPagesApplinks',
                teamName: 'olympus'
            }
        }
    }));

});
parcelRegister("dihHZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb99191b62c7837a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dTqD3 = parcelRequire("dTqD3");

var $16sa1 = parcelRequire("16sa1");

var $aV23b = parcelRequire("aV23b");

var $fPApF = parcelRequire("fPApF");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb99191b62c7837a$var$HealthcheckPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "applinks-extra-auth-healthcheck-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fPApF.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStatePageReady), null)));
var $bb99191b62c7837a$export$2e2bcd8739ae039 = $bb99191b62c7837a$var$HealthcheckPage;

});
parcelRegister("fPApF", function(module, exports) {

$parcel$export(module.exports, "default", () => $109b26965435f333$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jJaSe = parcelRequire("jJaSe");

var $eSnSE = parcelRequire("eSnSE");

var $gDywu = parcelRequire("gDywu");


var $fsQ56 = parcelRequire("fsQ56");
const $109b26965435f333$export$7955d5fe058be414 = ()=>{
    const [healthcheck, setHealthcheck] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        (0, $gDywu.getHealthcheck)().then((data)=>{
            setHealthcheck(data);
        }).catch((err)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $f326b3b1ea195b66$export$25a759e49d5049db), 'Failed to fetch healthcheck data', err);
            setHealthcheck(null);
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fsQ56.default), {
        healthcheck: healthcheck
    });
};
var $109b26965435f333$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)($109b26965435f333$export$7955d5fe058be414);

});
parcelRegister("gDywu", function(module, exports) {

$parcel$export(module.exports, "getHealthcheck", () => $1b516a5040c58db6$export$47b0be97eea80dc5);

var $1Ozm9 = parcelRequire("1Ozm9");
const $1b516a5040c58db6$export$47b0be97eea80dc5 = ()=>(0, $1Ozm9.default)('/rest/applinks/latest/applicationlink/extraAuth/healthcheck');

});

const $f326b3b1ea195b66$export$25a759e49d5049db = 'applinks.extra-auth.healthcheck';

parcelRegister("fsQ56", function(module, exports) {

$parcel$export(module.exports, "default", () => $60b25364e5efde30$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");

var $1KdDN = parcelRequire("1KdDN");

var $bZxkZ = parcelRequire("bZxkZ");

var $wZaoO = parcelRequire("wZaoO");
const $60b25364e5efde30$var$HealthcheckPageContents = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "applinks-extra-auth-healthcheck-page",
        teamName: "olympus",
        packageName: "applinksExtraAuthHealthcheckPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.200",
        xcss: $60b25364e5efde30$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $wZaoO.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bZxkZ.default), {
        title: "Prerequisites",
        description: "Ensure that the following prerequisites are met before beginning the setup process.",
        healthcheckEntries: props.healthcheck?.healthcheckPreconditions ?? null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bZxkZ.default), {
        title: "OAuth 2.0 Provider Configuration",
        description: "Extra Authentication uses an external OAuth 2.0 provider, shared by all products within your organization. The provider must be configured correctly before Application Links can be created.",
        healthcheckEntries: props.healthcheck?.healthcheckEntries ?? null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bZxkZ.default), {
        title: "Applink Status",
        description: "Once the authentication provider is configured, you can now create Application Links. All links configured to use Extra Authentication for this site are displayed below.",
        healthcheckEntries: props.healthcheck?.healthcheckStatuses ?? null
    })))));
};
var $60b25364e5efde30$export$2e2bcd8739ae039 = $60b25364e5efde30$var$HealthcheckPageContents;
const $60b25364e5efde30$var$styles = (0, $5Wv5g.xcss)({
    padding: 'space.200'
});

});
parcelRegister("bZxkZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1da49bb1b171b749$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $9LyfF = parcelRequire("9LyfF");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $idcYS = parcelRequire("idcYS");
var $d0tc6 = parcelRequire("d0tc6");
var $aMcQ0 = parcelRequire("aMcQ0");
var $4OieL = parcelRequire("4OieL");
var $6siZI = parcelRequire("6siZI");
var $haRrw = parcelRequire("haRrw");

var $g4ST9 = parcelRequire("g4ST9");

var $8JneG = parcelRequire("8JneG");

var $6MIFG = parcelRequire("6MIFG");

var $bvFRW = parcelRequire("bvFRW");

var $1FZ85 = parcelRequire("1FZ85");
const $1da49bb1b171b749$var$HealthcheckIcon = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.status.statusType === 'SUCCESS' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g4ST9))), {
        color: "var(--ds-icon-success, #22A06B)",
        label: "Success"
    }), props.status.statusType === 'FAILURE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8JneG))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "Unsuccessful"
    }), props.status.statusType === 'NOT_TRIED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6MIFG))), {
        color: "var(--ds-icon, #44546F)",
        label: "Not Tried"
    }));
};
const $1da49bb1b171b749$var$getColorFromStatus = (status)=>{
    if (status.statusType === 'NOT_TRIED') return 'color.text.disabled';
    return 'color.text';
};
const $1da49bb1b171b749$var$HealthcheckTitle = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        color: $1da49bb1b171b749$var$getColorFromStatus(props.status)
    }, props.name);
};
const $1da49bb1b171b749$var$HealthcheckComment = (props)=>{
    const message = 'message' in props.status ? props.status.message : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        color: $1da49bb1b171b749$var$getColorFromStatus(props.status)
    }, message);
};
const $1da49bb1b171b749$var$convertToArray = (healthcheckEntries)=>{
    const wrapWithItem = (id, content, hasChildren, children)=>{
        return {
            id: id,
            content: content,
            hasChildren: hasChildren,
            children: children
        };
    };
    return healthcheckEntries.map((entry, index)=>{
        return wrapWithItem(`entry-${index}`, entry, false);
    });
};
const $1da49bb1b171b749$var$HealthcheckTable = (props)=>{
    const healthcheckItems = props.healthcheckEntries ? $1da49bb1b171b749$var$convertToArray(props.healthcheckEntries) : undefined; // Loading state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "medium"
    }, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), null, props.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d0tc6.default), {
        label: "Healthcheck Table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4OieL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aMcQ0.default), {
        width: "100px"
    }, "Status"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aMcQ0.default), {
        width: "50%"
    }, "Item"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aMcQ0.default), {
        width: "50%"
    }, "Details")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $haRrw.default), {
        items: healthcheckItems,
        render: (item)=>{
            const { content: content } = item;
            const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6siZI.default), {
                key: item.id,
                itemId: item.id,
                hasChildren: item.hasChildren
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $idcYS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1da49bb1b171b749$var$HealthcheckIcon, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $idcYS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1da49bb1b171b749$var$HealthcheckTitle, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $idcYS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1da49bb1b171b749$var$HealthcheckComment, content)));
            if (content.status.statusType === 'FAILURE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, row, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6siZI.default), {
                key: `${item.id}-suggested-action`,
                itemId: `${item.id}-suggested-action`,
                hasChildren: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
                xcss: $1da49bb1b171b749$var$suggestedActionCellStyles,
                role: "cell"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1FZ85.default), {
                error: `Step "${content.name}" failed due to reason: "${content.status.message}".`,
                action: content.suggestedAction ?? null,
                link: content.suggestedActionLink ?? null
            }))));
            return row;
        }
    })));
};
var $1da49bb1b171b749$export$2e2bcd8739ae039 = $1da49bb1b171b749$var$HealthcheckTable;
const $1da49bb1b171b749$var$suggestedActionCellStyles = (0, $5Wv5g.xcss)({
    width: '100%',
    padding: 'space.200'
});

});
parcelRegister("6MIFG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8514ab409cdd1786faf0e15acb24fff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f09e0922382c7b6$var$_react = $4f09e0922382c7b6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4f09e0922382c7b6$var$_baseNew = $4f09e0922382c7b6$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $4f09e0922382c7b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TaskToDo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for to-do task status. Used in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f09e0922382c7b6$var$TaskToDoIcon = (props)=>/*#__PURE__*/ $4f09e0922382c7b6$var$_react.default.createElement($4f09e0922382c7b6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.028 1.5H8V0h.034c1.957.008 3.75.72 5.135 1.894L12.2 3.04A6.47 6.47 0 0 0 8.03 1.5m-2.278.4a6.52 6.52 0 0 0-3.395 2.875l-1.302-.746A8.02 8.02 0 0 1 5.23.493zM14.5 8a6.47 6.47 0 0 0-.856-3.227l1.301-.745A7.97 7.97 0 0 1 16 8q0 .727-.126 1.42l-1.476-.264A6.6 6.6 0 0 0 14.5 8M1.593 6.895A6.6 6.6 0 0 0 1.5 8c0 1.194.321 2.31.882 3.27l-1.296.757A7.97 7.97 0 0 1 0 8q.001-.694.115-1.358zm8.605 7.224a6.52 6.52 0 0 0 3.419-2.845l1.295.757a8.02 8.02 0 0 1-4.208 3.5zm-6.344-1.113A6.47 6.47 0 0 0 8 14.5V16a7.97 7.97 0 0 1-5.104-1.84z" clip-rule="evenodd"/>`
    }, props));
$4f09e0922382c7b6$var$TaskToDoIcon.displayName = 'TaskToDoIcon';
var $4f09e0922382c7b6$var$_default = module.exports.default = $4f09e0922382c7b6$var$TaskToDoIcon;

});

parcelRegister("1FZ85", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b13c44b83e4c961$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aIgra = parcelRequire("aIgra");
var $dWTqn = parcelRequire("dWTqn");

var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");
const $4b13c44b83e4c961$var$HealthcheckSuggestedAction = (props)=>{
    const actions = props.link ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dWTqn.default), {
            key: "action",
            href: props.link.link
        }, props.link.name)
    ] : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIgra.default), {
        title: "Step Failed",
        appearance: "error",
        actions: actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, props.error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, props.action))));
};
var $4b13c44b83e4c961$export$2e2bcd8739ae039 = $4b13c44b83e4c961$var$HealthcheckSuggestedAction;

});
parcelRegister("dWTqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $bba47b39d2a11fc8$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dKpTa = parcelRequire("dKpTa");

var $i7XOj = parcelRequire("i7XOj");

var $51Gwp = parcelRequire("51Gwp");

var $8XtVW = parcelRequire("8XtVW");

var $dPUtJ = parcelRequire("dPUtJ");
var $dhRXV = parcelRequire("dhRXV");
var $hBR2B = parcelRequire("hBR2B");
const $bba47b39d2a11fc8$var$stylesOld = {
    common: "_11c82smr _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik18uv _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1"
};
const $bba47b39d2a11fc8$var$styles = {
    common: "_11c82smr",
    anchor: "_k48pi7a9",
    pressable: "_syaz14q2 _k48p1wq8 _bfhk18uv _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $bba47b39d2a11fc8$var$SectionMessageAction = /*#__PURE__*/ (0, $eJOHy.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target }) {
    if (!linkComponent && (0, $8XtVW.fg)('platform_section_message_action_migration')) {
        if (href) {
            if ((0, $8XtVW.fg)('platform_dst_section_message_actions_as_link')) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                className: (0, $hcewu.default)([
                    $bba47b39d2a11fc8$var$styles.common,
                    $bba47b39d2a11fc8$var$styles.anchor
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $51Gwp.default), {
                    testId: testId,
                    onClick: onClick,
                    href: href,
                    target: target,
                    children: children
                })
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dPUtJ.default), {
                testId: testId,
                onClick: onClick,
                href: href,
                xcss: (0, $i7XOj.cx)($bba47b39d2a11fc8$var$stylesOld.common, $bba47b39d2a11fc8$var$stylesOld.anchor),
                children: children
            });
        }
        if (onClick) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hBR2B.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $i7XOj.cx)((0, $8XtVW.fg)('platform_dst_section_message_actions_as_link') ? $bba47b39d2a11fc8$var$styles.common : $bba47b39d2a11fc8$var$stylesOld.common, (0, $8XtVW.fg)('platform_dst_section_message_actions_as_link') ? $bba47b39d2a11fc8$var$styles.pressable : $bba47b39d2a11fc8$var$stylesOld.pressable),
            children: children
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
            as: "span",
            testId: testId,
            xcss: (0, $8XtVW.fg)('platform_dst_section_message_actions_as_link') && $bba47b39d2a11fc8$var$styles.common,
            children: children
        });
    }
    return onClick || href ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dKpTa.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: children
    });
});
var $bba47b39d2a11fc8$export$2e2bcd8739ae039 = $bba47b39d2a11fc8$var$SectionMessageAction;

});



parcelRegister("wZaoO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a11bdf88d94e006a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bvFRW = parcelRequire("bvFRW");

var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");
const $a11bdf88d94e006a$var$HealthcheckHeader = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "large"
    }, "Extra Auth Healthcheck"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, "Status of Extra Authenticated Application Links for your Jira Cloud site.")));
};
var $a11bdf88d94e006a$export$2e2bcd8739ae039 = $a11bdf88d94e006a$var$HealthcheckHeader;

});




parcelRegister("9rz9P", function(module, exports) {

$parcel$export(module.exports, "applinksExtraAuthHealthcheckRoute", () => $eb57e7adbcd87ce1$export$c92684a6af97ae19);
const $eb57e7adbcd87ce1$export$c92684a6af97ae19 = {
    name: 'global-settings-products-applinks-extra-auth',
    path: '/jira/settings/applinks/extra-auth/healthcheck',
    exact: true
};

});


parcelRegister("7WGkO", function(module, exports) {

$parcel$export(module.exports, "appRequestsRouteEntry", () => $606a2f2e012366e7$export$423a1c80bb2f8b9a);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $gC8Ke = parcelRequire("gC8Ke");

var $ixFkc = parcelRequire("ixFkc");
const $606a2f2e012366e7$export$423a1c80bb2f8b9a = (0, $6xToB.createEntry)((0, $gC8Ke.appRequestsRoute), ()=>({
        group: 'marketplace',
        component: (0, $ixFkc.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $gKFn0.default)
        },
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ixFkc.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace'
    }));

});
parcelRegister("gKFn0", function(module, exports) {

$parcel$export(module.exports, "default", () => $09413d0f48517527$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $09413d0f48517527$var$LazyGlobalAppsSettingsSidebar = (0, $gzcjr.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("depll")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
});
const $09413d0f48517527$var$GlobalAppsSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalAppsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09413d0f48517527$var$LazyGlobalAppsSettingsSidebar, null)));
$09413d0f48517527$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
var $09413d0f48517527$export$2e2bcd8739ae039 = $09413d0f48517527$var$GlobalAppsSettingsSidebar;

});
parcelRegister("depll", function(module, exports) {

let $9a203dd5fbbbd039$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $9a203dd5fbbbd039$var$load("1VRB2"),
    $9a203dd5fbbbd039$var$load("bABhq"),
    $9a203dd5fbbbd039$var$load("1xdeV")
]).then(()=>parcelRequire('a6XIl'));

});


parcelRegister("gC8Ke", function(module, exports) {

$parcel$export(module.exports, "appRequestsRoute", () => $0810f4e967941125$export$df12e2a94e0a971b);
const $0810f4e967941125$export$df12e2a94e0a971b = {
    name: 'marketplace-app-requests',
    path: '/jira/marketplace/manage/app-requests'
};

});

parcelRegister("ixFkc", function(module, exports) {

$parcel$export(module.exports, "LazyMarketplace", () => $3b73073020c2fe89$export$5919da4c9ee4707e);
$parcel$export(module.exports, "MarketplaceComponent", () => $3b73073020c2fe89$export$f0d733b7012e9031);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $3b73073020c2fe89$export$5919da4c9ee4707e = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("6MBLK"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/marketplace/src/index.tsx"
});
const $3b73073020c2fe89$export$f0d733b7012e9031 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3b73073020c2fe89$export$5919da4c9ee4707e,
        pageId: "marketplace",
        shouldShowSpinner: true
    });

});
parcelRegister("2dJFW", function(module, exports) {

$parcel$export(module.exports, "markAsProductBundleReady", () => $ab9e756ab32e8c98$export$ff83c57004505abd);

var $dydef = parcelRequire("dydef");
const $ab9e756ab32e8c98$export$ff83c57004505abd = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        (0, $dydef.setProductBundleReadyForInitialRender)();
    });
    return importedBundle;
};

});

parcelRegister("6MBLK", function(module, exports) {

let $4f0485ec7bbaea82$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $4f0485ec7bbaea82$var$load("1VRB2"),
    $4f0485ec7bbaea82$var$load("bABhq"),
    $4f0485ec7bbaea82$var$load("296jk")
]).then(()=>parcelRequire('fcjmy'));

});



parcelRegister("aPhVH", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesRedirectRouteEntry", () => $0ea68876b7180483$export$f7d3667678a21360);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $c7U4n = parcelRequire("c7U4n");

var $j3sUb = parcelRequire("j3sUb");
const $0ea68876b7180483$export$f7d3667678a21360 = (0, $6xToB.createEntry)((0, $c7U4n.archivedIssuesRedirectRoute), ()=>({
        group: 'archive-issues',
        layout: (0, $ioHIu.genericProjectLayout),
        entryPoint: ()=>(0, $j3sUb.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ]
    }));

});
parcelRegister("ioHIu", function(module, exports) {

$parcel$export(module.exports, "genericProjectLayout", () => $b45ef5b2a7af08eb$export$85dad8e9886563f6);

var $cEBDW = parcelRequire("cEBDW");

var $6dwgv = parcelRequire("6dwgv");

var $aQoXd = parcelRequire("aQoXd");

var $8FCAy = parcelRequire("8FCAy");

var $dkgBy = parcelRequire("dkgBy");
const $b45ef5b2a7af08eb$export$85dad8e9886563f6 = (0, $6dwgv.composeLayouts)((0, $8FCAy.classicSoftwareProjectLayout), (0, $cEBDW.coreProjectLayout), (0, $aQoXd.serviceProjectLayout), (0, $8FCAy.softwareProjectLayout), (0, $dkgBy.userBoardLayout));

});
parcelRegister("cEBDW", function(module, exports) {

$parcel$export(module.exports, "coreProjectLayout", () => $208365a70ac26c02$export$3c06ced9943ca671);

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");
const $208365a70ac26c02$export$3c06ced9943ca671 = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout));

});

parcelRegister("8FCAy", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareProjectLayout", () => $2e2774c38c3e21fa$export$3791efdd32024063);
$parcel$export(module.exports, "softwareProjectLayout", () => $2e2774c38c3e21fa$export$9a918616afa3328c);
$parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", () => $2e2774c38c3e21fa$export$ada52b1309832862);
$parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", () => $2e2774c38c3e21fa$export$6c1958653c44ba37);
$parcel$export(module.exports, "softwareProjectLayoutCode", () => $2e2774c38c3e21fa$export$ab7e607e8441dc61);

var $ln6Iy = parcelRequire("ln6Iy");

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");

var $gzcjr = parcelRequire("gzcjr");

var $bJscI = parcelRequire("bJscI");
// TODO Remove this whenever all software project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2e2774c38c3e21fa$var$withAnySoftwareProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $ln6Iy.SOFTWARE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$OnboardingOld = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("f2GEY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$OnboardingNew = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("f2GEY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});
const $2e2774c38c3e21fa$var$Onboarding = (0, $bJscI.componentWithFG)('onboarding-forpaint-migration-iv-llc', $2e2774c38c3e21fa$var$OnboardingNew, $2e2774c38c3e21fa$var$OnboardingOld);
$2e2774c38c3e21fa$var$Onboarding.displayName = 'Lazy(ui/onboarding/index.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$OnboardingCode = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("e75O3")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding-code/OnboardingCode.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$RightSidebarsOld = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("iDu2v")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$RightSidebarsNew = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("iDu2v")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $2e2774c38c3e21fa$var$RightSidebars = (0, $bJscI.componentWithFG)('onboarding-forpaint-migration-iv-llc', $2e2774c38c3e21fa$var$RightSidebarsNew, $2e2774c38c3e21fa$var$RightSidebarsOld);
$2e2774c38c3e21fa$var$RightSidebars.displayName = 'Lazy(ui/right-sidebars/RightSidebars.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$RightSidebarsCode = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("5uEds")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars-code/RightSidebarsCode.tsx"
});
const $2e2774c38c3e21fa$var$SoftWareOnboarding = $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$Onboarding);
const $2e2774c38c3e21fa$var$SoftWareOnboardingCode = $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$OnboardingCode);
const $2e2774c38c3e21fa$var$nonSettingsRightSidebars = [
    $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$RightSidebars)
];
const $2e2774c38c3e21fa$var$nonSettingsRightSidebarsCode = [
    $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$RightSidebarsCode)
];
const $2e2774c38c3e21fa$var$sharedSoftwareProjectLayout = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout), {});
const $2e2774c38c3e21fa$export$3791efdd32024063 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout, {
    rightSidebars: $2e2774c38c3e21fa$var$nonSettingsRightSidebars,
    globalComponents: [
        $2e2774c38c3e21fa$var$SoftWareOnboarding
    ]
});
const $2e2774c38c3e21fa$export$9a918616afa3328c = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout, {
    rightSidebars: $2e2774c38c3e21fa$var$nonSettingsRightSidebars,
    globalComponents: [
        $2e2774c38c3e21fa$var$SoftWareOnboarding
    ]
});
const $2e2774c38c3e21fa$export$ada52b1309832862 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout);
const $2e2774c38c3e21fa$export$6c1958653c44ba37 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout);
const $2e2774c38c3e21fa$export$ab7e607e8441dc61 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout, {
    rightSidebars: $2e2774c38c3e21fa$var$nonSettingsRightSidebarsCode,
    globalComponents: [
        $2e2774c38c3e21fa$var$SoftWareOnboardingCode
    ]
});

});
parcelRegister("f2GEY", function(module, exports) {

let $af3822492abd7008$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $af3822492abd7008$var$load("hwlgY"),
    $af3822492abd7008$var$load("7vqGd"),
    $af3822492abd7008$var$load("1Y4bq"),
    $af3822492abd7008$var$load("1VRB2"),
    $af3822492abd7008$var$load("bABhq"),
    $af3822492abd7008$var$load("7DG5p")
]).then(()=>parcelRequire('jhc67'));

});

parcelRegister("e75O3", function(module, exports) {

let $a466392d23d96046$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $a466392d23d96046$var$load("hwlgY"),
    $a466392d23d96046$var$load("7vqGd"),
    $a466392d23d96046$var$load("1Y4bq"),
    $a466392d23d96046$var$load("1VRB2"),
    $a466392d23d96046$var$load("bABhq"),
    $a466392d23d96046$var$load("aq8Yb")
]).then(()=>parcelRequire('fpUIa'));

});

parcelRegister("iDu2v", function(module, exports) {

let $d9132bb64fb2fcbb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $d9132bb64fb2fcbb$var$load("hwlgY"),
    $d9132bb64fb2fcbb$var$load("7vqGd"),
    $d9132bb64fb2fcbb$var$load("1Y4bq"),
    $d9132bb64fb2fcbb$var$load("1VRB2"),
    $d9132bb64fb2fcbb$var$load("bABhq"),
    $d9132bb64fb2fcbb$var$load("B3AoS")
]).then(()=>parcelRequire('4mkSU'));

});

parcelRegister("5uEds", function(module, exports) {

let $3ffef32a6caee592$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $3ffef32a6caee592$var$load("hwlgY"),
    $3ffef32a6caee592$var$load("7vqGd"),
    $3ffef32a6caee592$var$load("1Y4bq"),
    $3ffef32a6caee592$var$load("1VRB2"),
    $3ffef32a6caee592$var$load("bABhq"),
    $3ffef32a6caee592$var$load("dcuje")
]).then(()=>parcelRequire('8XVCp'));

});


parcelRegister("dkgBy", function(module, exports) {

$parcel$export(module.exports, "userBoardLayout", () => $cf45c653fc1d9878$export$7092b4ee86ae0b71);

var $6dwgv = parcelRequire("6dwgv");
const $cf45c653fc1d9878$export$7092b4ee86ae0b71 = (0, $6dwgv.createLayout)();

});


parcelRegister("gHEJe", function(module, exports) {

$parcel$export(module.exports, "ForPaintSoftwareProjectSidebar", () => $7ef94f935654f247$export$16261c6a2217f29d);
$parcel$export(module.exports, "default", () => $7ef94f935654f247$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

var $kfvK2 = parcelRequire("kfvK2");

const $7ef94f935654f247$var$LazyAfterPaintClassicSoftwareProjectSidebar = (0, $gzcjr.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("aP05A")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});

const $7ef94f935654f247$var$LazyForPaintClassicSoftwareProjectSidebar = (0, $gzcjr.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("aP05A")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});
const $7ef94f935654f247$var$AfterPaintSoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$var$LazyAfterPaintClassicSoftwareProjectSidebar, null)));
const $7ef94f935654f247$export$16261c6a2217f29d = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$var$LazyForPaintClassicSoftwareProjectSidebar, null)));
const $7ef94f935654f247$var$SoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const isIssueRoute = (0, $kfvK2.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$export$16261c6a2217f29d, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$var$AfterPaintSoftwareProjectSidebar, null);
});
$7ef94f935654f247$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
$7ef94f935654f247$export$16261c6a2217f29d.displayName = 'SoftwareProjectSidebar';
var $7ef94f935654f247$export$2e2bcd8739ae039 = $7ef94f935654f247$var$SoftwareProjectSidebar;

});
parcelRegister("aP05A", function(module, exports) {

let $7e0ebc849138245c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7e0ebc849138245c$var$load("1G8UW"),
    $7e0ebc849138245c$var$load("iSk93"),
    $7e0ebc849138245c$var$load("1VRB2"),
    $7e0ebc849138245c$var$load("bABhq"),
    $7e0ebc849138245c$var$load("7vqGd"),
    $7e0ebc849138245c$var$load("1Y4bq"),
    $7e0ebc849138245c$var$load("dxfZ3")
]).then(()=>parcelRequire('9WRBf'));

});


parcelRegister("c7U4n", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesRedirectRoute", () => $53cb455bac15eae1$export$1bfee70ca366d995);
const $53cb455bac15eae1$export$1bfee70ca366d995 = {
    name: 'archived-issues-directory',
    path: '/jira/issues/archive',
    exact: true
};

});

parcelRegister("j3sUb", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesPageEntryPoint", () => $120f97aff115bbf0$export$e2fa7de87c15a81d);
$parcel$export(module.exports, "archivedIssuesWithoutHorizontalNavPageEntryPoint", () => $120f97aff115bbf0$export$c001d316b1f89101);
$parcel$export(module.exports, "getCommonProjectLayout", () => $120f97aff115bbf0$export$3dbe917a4c13b1e);

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $6dwgv = parcelRequire("6dwgv");

var $9n5I0 = parcelRequire("9n5I0");

var $5RW99 = parcelRequire("5RW99");

var $2cEzx = parcelRequire("2cEzx");
const $120f97aff115bbf0$export$e2fa7de87c15a81d = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $2cEzx.archivedIssuesEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $120f97aff115bbf0$export$c001d316b1f89101 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $2cEzx.archivedIssuesEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $120f97aff115bbf0$export$3dbe917a4c13b1e = ()=>(0, $6dwgv.createLayout)((0, $ioHIu.genericProjectLayout));

});
parcelRegister("9n5I0", function(module, exports) {

$parcel$export(module.exports, "jiraHorizontalNavEntrypoint", () => $c3ab5ab6b7a191f3$export$e9ee9fa1097f370e);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $2kG4d = parcelRequire("2kG4d");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $3osLr = parcelRequire("3osLr");

var $bBtQo = parcelRequire("bBtQo");

var $7Bvm5 = parcelRequire("7Bvm5");

var $7jTnu = parcelRequire("7jTnu");

const $c3ab5ab6b7a191f3$export$e9ee9fa1097f370e = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("gIX1B")), {
        moduleId: "99477251",
        moduleName: "HorizontalNavJiraInner",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true,
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: ({ context: { match: match, query: query }, tenantContext: { cloudId: cloudId } })=>{
        let boardId = match.params.boardId;
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const projectIdOrKey = projectId || projectKey;
        const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
        if (!boardId && (0, $7jTnu.fg)('blu-7733-jracloud-94629-connect-tab')) {
            // If there is no boardId in the URL then we should check to see if it is provided as part of
            // the Connect app rapidView query param. This has been added to address JRACLOUD-94629
            const rapidViewBoard = query.rapidView ? query.rapidView : null;
            boardId = rapidViewBoard || boardId || null;
        }
        const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
        const projectAri = projectId ? (0, $3osLr.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
        let containerNavigationInput;
        if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
            scopeId: boardAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        else containerNavigationInput = boardAri || projectAri ? {
            scopeId: boardAri || projectAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                horizontalNavQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $2kG4d.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        withProject: Boolean(projectIdOrKey),
                        boardId: boardAri,
                        withBoard: Boolean(boardAri),
                        containerNavigationInput: containerNavigationInput,
                        isTMPBoardRoute: isTMPBoardRoute,
                        first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            }
        };
    }
});

});
parcelRegister("2kG4d", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2342b8045233cc3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<64c88cef029bc46fc6a2fe68ac9e0567>>
 * @relayHash cba6ce20d219b60b230ae7abbc8dfbfd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 67688bd785c6b8a973ee02d9f893c0f256281de1c688dcdfbe72361625e99501

var $7KZsS = parcelRequire("7KZsS");

var $7ze1k = parcelRequire("7ze1k");

var $5OxM8 = parcelRequire("5OxM8");

var $gpGBt = parcelRequire("gpGBt");

var $811y8 = parcelRequire("811y8");
const $a2342b8045233cc3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "67688bd785c6b8a973ee02d9f893c0f256281de1c688dcdfbe72361625e99501",
        "metadata": {},
        "name": "HorizontalNavJiraInnerQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $7KZsS.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": (0, $811y8.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider": (0, $7ze1k.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": (0, $gpGBt.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraisfetchaccesslevelforsplitsharebuttonenabledrelayprovider": (0, $5OxM8.default)
        }
    }
};
var $a2342b8045233cc3$export$2e2bcd8739ae039 = $a2342b8045233cc3$var$node;

});
parcelRegister("7KZsS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d80c26e7829d9791$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $d80c26e7829d9791$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jira_custom_templates_ux');
    }
};

});

parcelRegister("7ze1k", function(module, exports) {

$parcel$export(module.exports, "default", () => $938480f2a3a19bc1$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $938480f2a3a19bc1$var$JiraInviteButtonRelayProvider = {
    get () {
        return (0, $7jTnu.fg)('jfind-restore-invite-button-gate');
    }
};
var $938480f2a3a19bc1$export$2e2bcd8739ae039 = $938480f2a3a19bc1$var$JiraInviteButtonRelayProvider;

});

parcelRegister("5OxM8", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd552d5fa5c47576$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $dd552d5fa5c47576$var$ShouldFetchAccessLevelRelayProvider = {
    get () {
        return (0, $7jTnu.fg)('jira_fetch_accesslevel_for_nav4_share_button');
    }
};
var $dd552d5fa5c47576$export$2e2bcd8739ae039 = $dd552d5fa5c47576$var$ShouldFetchAccessLevelRelayProvider;

});

parcelRegister("gpGBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $12dde8e7615a22fe$export$2e2bcd8739ae039);

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");
const $12dde8e7615a22fe$var$JiraTeamButtonTeamCountRelayProvider = {
    get () {
        return !(0, $7jTnu.fg)('team-bi-directional-container-connection-gate') || !(0, $epTsa.expVal)('team-bi-directional-container-connection', 'isEnabled', false);
    }
};
var $12dde8e7615a22fe$export$2e2bcd8739ae039 = $12dde8e7615a22fe$var$JiraTeamButtonTeamCountRelayProvider;

});

parcelRegister("811y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4da679e99462d392$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $4da679e99462d392$var$JiraTeamButtonRelayProvider = {
    get () {
        return(// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $7jTnu.fg)('team-connection-visibility-in-jira'));
    }
};
var $4da679e99462d392$export$2e2bcd8739ae039 = $4da679e99462d392$var$JiraTeamButtonRelayProvider;

});


parcelRegister("3osLr", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAri", () => $2789eceef4467cc4$export$75a0a0a7cb0a58ae);

var $fFcpV = parcelRequire("fFcpV");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/project/manifest.ts
var $2789eceef4467cc4$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fFcpV.JiraProjectAriResourceOwner),
    resourceType: (0, $fFcpV.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $2789eceef4467cc4$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2789eceef4467cc4$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $2789eceef4467cc4$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2789eceef4467cc4$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $2789eceef4467cc4$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $2789eceef4467cc4$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $2789eceef4467cc4$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
};

});
parcelRegister("fFcpV", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAriResourceOwner", () => $b674512659b7f55c$export$99d538a3b04916b1);
$parcel$export(module.exports, "JiraProjectAriResourceType", () => $b674512659b7f55c$export$736763838d3aa22e);
// src/jira/project/types.ts
var $b674512659b7f55c$export$99d538a3b04916b1 = "jira", $b674512659b7f55c$export$736763838d3aa22e = "project";

});


parcelRegister("7Bvm5", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_ITEMS_PAGE_SIZE", () => $adc6a95ef6681603$export$4653cda61a4943d6);
$parcel$export(module.exports, "TAB_UNDERLINE_HEIGHT", () => $adc6a95ef6681603$export$d1b9ea3245b6a5de);
$parcel$export(module.exports, "TAB_HEIGHT", () => $adc6a95ef6681603$export$d07bba395c9390f1);
$parcel$export(module.exports, "TAB_GAP", () => $adc6a95ef6681603$export$b61e6f89a9db76de);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports


const $adc6a95ef6681603$export$4653cda61a4943d6 = 75;
const $adc6a95ef6681603$export$d1b9ea3245b6a5de = 2;
const $adc6a95ef6681603$export$d07bba395c9390f1 = 36;
const $adc6a95ef6681603$export$29911ec08ab2ca2d = 5;
const $adc6a95ef6681603$export$b61e6f89a9db76de = 12;
const $adc6a95ef6681603$export$7fd2e391116c6ef5 = 9;
const $adc6a95ef6681603$export$e1633e494d305bfb = 'MORE';

});

parcelRegister("gIX1B", function(module, exports) {

let $c2ce8a807e0d1647$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $c2ce8a807e0d1647$var$load("k4gbU"),
    $c2ce8a807e0d1647$var$load("1VRB2"),
    $c2ce8a807e0d1647$var$load("bABhq"),
    $c2ce8a807e0d1647$var$load("7vqGd"),
    $c2ce8a807e0d1647$var$load("1Y4bq"),
    $c2ce8a807e0d1647$var$load("cETVs")
]).then(()=>parcelRequire('5Uorw'));

});


parcelRegister("2cEzx", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesEntrypoint", () => $36d58d7b269574ee$export$3f35189530920ce3);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $36d58d7b269574ee$export$3f35189530920ce3 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("9D3zO")), {
        moduleId: "c61780dd",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9D3zO", function(module, exports) {

let $702a87cde2d1614f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $702a87cde2d1614f$var$load("iUqB1").then(()=>parcelRequire('k7LtZ'));

});




parcelRegister("9JhPg", function(module, exports) {

$parcel$export(module.exports, "archivedPlansRouteEntry", () => $5664307c6970e86f$export$b9921058a8a65710);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $bXBC1 = parcelRequire("bXBC1");

var $5nxGF = parcelRequire("5nxGF");
const $5664307c6970e86f$export$b9921058a8a65710 = (0, $6xToB.createEntry)((0, $bXBC1.archivedPlansRoute), ()=>({
        group: 'global-settings',
        component: (0, $5nxGF.ArchivedPlansDirectory),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $5nxGF.LazyArchivedPlans)
        ]
    }));

});
parcelRegister("fc9ma", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97f84d2af4da2a3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $a97f84d2af4da2a3$var$LazyGlobalProductsSettingsSidebar = (0, $gzcjr.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("3xpqm")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-products/src/index.tsx"
});
const $a97f84d2af4da2a3$var$GlobalProductsSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalProductsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a97f84d2af4da2a3$var$LazyGlobalProductsSettingsSidebar, null)));
$a97f84d2af4da2a3$var$GlobalProductsSettingsSidebar.displayName = 'GlobalProductsSettingsSidebar';
var $a97f84d2af4da2a3$export$2e2bcd8739ae039 = $a97f84d2af4da2a3$var$GlobalProductsSettingsSidebar;

});
parcelRegister("3xpqm", function(module, exports) {

let $29382ce3d37a97c7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $29382ce3d37a97c7$var$load("hwlgY"),
    $29382ce3d37a97c7$var$load("1VRB2"),
    $29382ce3d37a97c7$var$load("bABhq"),
    $29382ce3d37a97c7$var$load("7vqGd"),
    $29382ce3d37a97c7$var$load("1Y4bq"),
    $29382ce3d37a97c7$var$load("dwk9K")
]).then(()=>parcelRequire('ixDlv'));

});


parcelRegister("bXBC1", function(module, exports) {

$parcel$export(module.exports, "archivedPlansRoute", () => $6b371cb941630836$export$29647353386ad146);
const $6b371cb941630836$export$29647353386ad146 = {
    name: 'archived-plans-directory',
    path: '/jira/plans/settings/archive',
    exact: true
};

});

parcelRegister("5nxGF", function(module, exports) {

$parcel$export(module.exports, "LazyArchivedPlans", () => $02692f9b8d9b7613$export$cf676f47aba10db8);
$parcel$export(module.exports, "ArchivedPlansDirectory", () => $02692f9b8d9b7613$export$ed59bbc59461c00f);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $02692f9b8d9b7613$export$cf676f47aba10db8 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("6GIu1")).then((module)=>module.ArchivedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages/archived-plans/src/index.tsx"
});
const $02692f9b8d9b7613$export$ed59bbc59461c00f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $02692f9b8d9b7613$export$cf676f47aba10db8,
        pageId: "archived-plans",
        shouldShowSpinner: true
    });

});
parcelRegister("6GIu1", function(module, exports) {

let $4de92bc5f10f5b8c$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $4de92bc5f10f5b8c$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $4de92bc5f10f5b8c$var$load("deNlq")
        ]);
    }),
    $4de92bc5f10f5b8c$var$load("aaCwV")
]).then(()=>parcelRequire('2LlB2'));

});
parcelRegister("g81qY", function(module, exports) {
"use strict";
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            console.error('Conditional dependency was not registered when executing. Falling back to synchronous bundle loading.');
            for (const url of fallback.urls)fallback.loader(url);
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});




parcelRegister("7y12x", function(module, exports) {

$parcel$export(module.exports, "archivedProjectDirectLinkRouteEntry", () => $b09f69ab5f5fe5f3$export$45e68d450757a753);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1jeQz = parcelRequire("1jeQz");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $b09f69ab5f5fe5f3$var$LazyArchivedDirectLink = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("h1KhL"))), {
    moduleId: "./src/packages/project-pages/project-archive/project-archived-direct-link/src/index.tsx"
});
const $b09f69ab5f5fe5f3$var$ArchivedProjectDirectLink = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $b09f69ab5f5fe5f3$var$LazyArchivedDirectLink,
        pageId: "archived-project-direct-link",
        shouldShowSpinner: false
    });
const $b09f69ab5f5fe5f3$export$45e68d450757a753 = (0, $6xToB.createEntry)((0, $1jeQz.archivedProjectDirectLinkRoute), ()=>({
        group: 'redirects',
        component: $b09f69ab5f5fe5f3$var$ArchivedProjectDirectLink,
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $b09f69ab5f5fe5f3$var$LazyArchivedDirectLink
        ],
        ufoName: 'project-archived'
    }));

});
parcelRegister("1jeQz", function(module, exports) {

$parcel$export(module.exports, "archivedProjectDirectLinkRoute", () => $0e540b7438a85254$export$cd3fc26cf9f696e6);
const $0e540b7438a85254$export$cd3fc26cf9f696e6 = {
    name: 'archived-project-direct-link',
    path: '/jira/errors/project-archived',
    exact: true
};

});

parcelRegister("h1KhL", function(module, exports) {

let $c6566efc3cdde50d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c6566efc3cdde50d$var$load("eUGFx").then(()=>parcelRequire('arEu0'));

});


parcelRegister("54Mg6", function(module, exports) {

$parcel$export(module.exports, "archivedProjectsDirectoryRouteEntry", () => $f91c1016b40c2bbf$export$dc5f9e3c3931cc36);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $vJYlr = parcelRequire("vJYlr");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $eD4cF = parcelRequire("eD4cF");

var $jx00M = parcelRequire("jx00M");
const $f91c1016b40c2bbf$export$dc5f9e3c3931cc36 = (0, $6xToB.createEntry)((0, $eD4cF.archivedProjectsDirectoryRoute), ()=>({
        group: 'global-settings',
        component: (0, $jx00M.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $vJYlr.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jx00M.LazyArchivedProjectsAdmin)
        ],
        ufoName: 'admin.archived-projects'
    }));

});
parcelRegister("vJYlr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b77bce2b95f32c3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $5b77bce2b95f32c3$var$LazyGlobalProjectsSettingsSidebar = (0, $gzcjr.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("awuMo")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-projects/src/index.tsx"
});
const $5b77bce2b95f32c3$var$GlobalProjectsSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalProjectsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5b77bce2b95f32c3$var$LazyGlobalProjectsSettingsSidebar, null)));
$5b77bce2b95f32c3$var$GlobalProjectsSettingsSidebar.displayName = 'GlobalProjectsSettingsSidebar';
var $5b77bce2b95f32c3$export$2e2bcd8739ae039 = $5b77bce2b95f32c3$var$GlobalProjectsSettingsSidebar;

});
parcelRegister("awuMo", function(module, exports) {

let $7a94c4b9b50ddd47$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7a94c4b9b50ddd47$var$load("4HZ5t").then(()=>parcelRequire('kdaCi'));

});


parcelRegister("eD4cF", function(module, exports) {

$parcel$export(module.exports, "archivedProjectsDirectoryRoute", () => $c170187e7bac8710$export$b60634d0fa43f719);
const $c170187e7bac8710$export$b60634d0fa43f719 = {
    name: 'archived-projects-directory',
    path: '/jira/settings/projects/archive',
    exact: true
};

});

parcelRegister("jx00M", function(module, exports) {

$parcel$export(module.exports, "LazyArchivedProjectsAdmin", () => $512b503a29fc1a7a$export$b220ffb582ee39aa);
$parcel$export(module.exports, "default", () => $512b503a29fc1a7a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $512b503a29fc1a7a$export$b220ffb582ee39aa = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("eSdTk"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/archived-projects/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$512b503a29fc1a7a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $512b503a29fc1a7a$export$b220ffb582ee39aa,
        pageId: "archived-projects",
        shouldShowSpinner: true
    });

});
parcelRegister("eSdTk", function(module, exports) {

let $ad40e25ba677fae2$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ad40e25ba677fae2$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $ad40e25ba677fae2$var$load("deNlq")
        ]);
    }),
    $ad40e25ba677fae2$var$load("eDzss"),
    $ad40e25ba677fae2$var$load("hrFF3")
]).then(()=>parcelRequire('gXgjG'));

});



parcelRegister("kZGLD", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJsmRouteEntry", () => $5a448b11bd088eba$export$cdfe13bfc51ce940);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $5vGGb = parcelRequire("5vGGb");

var $aQoXd = parcelRequire("aQoXd");

var $j3sUb = parcelRequire("j3sUb");
const $5a448b11bd088eba$export$cdfe13bfc51ce940 = (0, $6xToB.createEntry)((0, $5vGGb.archivedWorkItemsJsmRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectServicedeskRoute from issue-navigator
        layout: (0, $aQoXd.serviceProjectLayout),
        entryPoint: ()=>(0, $j3sUb.archivedIssuesWithoutHorizontalNavPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("5vGGb", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJsmRoute", () => $2fc7bab5d1fd1b68$export$36e9c9de963d9a4f);
const $2fc7bab5d1fd1b68$export$36e9c9de963d9a4f = {
    name: 'servicedesk-archived-work-items',
    path: '/jira/servicedesk/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("5y94r", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJswCompanyRouteEntry", () => $3f25b6f7d5466283$export$5555f344b15f5187);

var $hS1gr = parcelRequire("hS1gr");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $2pKcR = parcelRequire("2pKcR");

var $j3sUb = parcelRequire("j3sUb");
const $3f25b6f7d5466283$export$5555f344b15f5187 = (0, $6xToB.createEntry)((0, $2pKcR.archivedWorkItemsJswCompanyRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectClassicRoute from issue-navigator
        layout: (0, $j3sUb.getCommonProjectLayout)(),
        entryPoint: ()=>(0, $j3sUb.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("hS1gr", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalNavJira", () => $b3848baadec66a18$export$ea83697d960a1a23);

var $eJOHy = parcelRequire("eJOHy");

var $gzcjr = parcelRequire("gzcjr");

var $6zXPf = parcelRequire("6zXPf");

var $f2JN3 = parcelRequire("f2JN3");

var $iX5t3 = parcelRequire("iX5t3");

var $gYW18 = parcelRequire("gYW18");

var $ch9En = parcelRequire("ch9En");

const $b3848baadec66a18$var$LazyHorizontalNavJira = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8QhCi")).then((HorizontalNavJira)=>HorizontalNavJira), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jira/src/ui/HorizontalNavJira.tsx"
});
const $b3848baadec66a18$var$AsyncHorizontalNav = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "horizontal-nav-jira",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iX5t3.HorizontalNavSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b3848baadec66a18$var$LazyHorizontalNavJira, null));
const $b3848baadec66a18$export$ea83697d960a1a23 = (0, $f2JN3.componentWithCondition)(()=>(0, $6zXPf.getWillShowNav4)(), $b3848baadec66a18$var$AsyncHorizontalNav, (0, $gYW18.AsyncHorizontalProjectNav));

});
parcelRegister("iX5t3", function(module, exports) {

$parcel$export(module.exports, "TabsSkeleton", () => $9a24d46adbe633a2$export$807fef2beb9debc2);
$parcel$export(module.exports, "HorizontalNavSkeleton", () => $9a24d46adbe633a2$export$e29d51df5420bf39);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $bL3dk = parcelRequire("bL3dk");
var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");
const $9a24d46adbe633a2$export$807fef2beb9debc2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        xcss: [
            $9a24d46adbe633a2$var$tabsWrapperSkeletonStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }));
const $9a24d46adbe633a2$export$e29d51df5420bf39 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.050",
        alignBlock: "end",
        xcss: $9a24d46adbe633a2$var$horizontalNavWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$breadcrumbStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        spread: "space-between",
        xcss: $9a24d46adbe633a2$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $9a24d46adbe633a2$var$primaryContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$projectTitleStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$squareStyles
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        space: "space.150",
        xcss: $9a24d46adbe633a2$var$actionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$squareStyles
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9a24d46adbe633a2$export$807fef2beb9debc2, null));
const $9a24d46adbe633a2$var$tabsWrapperSkeletonStyles = (0, $5Wv5g.xcss)({
    gap: 'space.150',
    height: '32px',
    paddingInlineStart: 'space.300',
    paddingInlineEnd: 'space.300',
    paddingBlockEnd: 'space.150',
    marginBlockStart: 'space.100',
    position: 'relative',
    '::after': {
        content: '""',
        position: 'absolute',
        bottom: '0',
        backgroundColor: 'color.skeleton',
        height: '2px',
        left: '0',
        right: '0'
    }
});
const $9a24d46adbe633a2$var$tabSkeletonStyles = (0, $5Wv5g.xcss)({
    minWidth: "var(--ds-space-1000, 80px)",
    backgroundColor: 'color.skeleton',
    borderRadius: "var(--ds-border-radius, 4px)"
});
const $9a24d46adbe633a2$var$horizontalNavWrapperStyles = (0, $5Wv5g.xcss)({
    paddingBlockStart: 'space.150',
    blockSize: '104px'
});
const $9a24d46adbe633a2$var$baseSkeletonStyles = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius'
});
const $9a24d46adbe633a2$var$breadcrumbStyles = (0, $5Wv5g.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '60px',
    marginInlineStart: 'space.300',
    marginBlockEnd: 'space.025'
});
const $9a24d46adbe633a2$var$primaryContainerStyles = (0, $5Wv5g.xcss)({
    display: 'flex',
    gap: 'space.100',
    marginInlineStart: 'space.300'
});
const $9a24d46adbe633a2$var$squareStyles = (0, $5Wv5g.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: "var(--ds-space-300, 24px)"
});
const $9a24d46adbe633a2$var$headerWrapperStyles = (0, $5Wv5g.xcss)({
    marginBlockStart: 'space.050'
});
const $9a24d46adbe633a2$var$projectTitleStyles = (0, $5Wv5g.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '180px'
});
const $9a24d46adbe633a2$var$actionStyles = (0, $5Wv5g.xcss)({
    marginInlineEnd: 'space.300'
});

});

parcelRegister("gYW18", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalProjectNav", () => $31220cfbb4b000f2$export$862dd1c0126bb181);
$parcel$export(module.exports, "AsyncHorizontalOverviewNav", () => $31220cfbb4b000f2$export$beabdf5c49f01377);
/* eslint-disable jira/import/webpack-magic-comment-entries */ 
var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $31220cfbb4b000f2$var$LazyHorizontalProjectNav = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("4BkNE")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/project-navigation/index.tsx"
});
const $31220cfbb4b000f2$export$862dd1c0126bb181 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "horizontal-project-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31220cfbb4b000f2$var$LazyHorizontalProjectNav, null));

const $31220cfbb4b000f2$var$LazyHorizontalOverviewNav = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("9yHib")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/overview-navigation/index.tsx"
});
const $31220cfbb4b000f2$export$beabdf5c49f01377 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "horizontal-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31220cfbb4b000f2$var$LazyHorizontalOverviewNav, null));

});
parcelRegister("4BkNE", function(module, exports) {

let $359ac083bf1ca442$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $359ac083bf1ca442$var$load("1G8UW"),
    $359ac083bf1ca442$var$load("iSk93"),
    $359ac083bf1ca442$var$load("hwlgY"),
    $359ac083bf1ca442$var$load("k4gbU"),
    $359ac083bf1ca442$var$load("1VRB2"),
    $359ac083bf1ca442$var$load("bABhq"),
    $359ac083bf1ca442$var$load("7vqGd"),
    $359ac083bf1ca442$var$load("1Y4bq"),
    $359ac083bf1ca442$var$load("39h6x")
]).then(()=>parcelRequire('bId22'));

});

parcelRegister("9yHib", function(module, exports) {

let $6f58def75c7c0fdd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6f58def75c7c0fdd$var$load("hwlgY"),
    $6f58def75c7c0fdd$var$load("k4gbU"),
    $6f58def75c7c0fdd$var$load("1VRB2"),
    $6f58def75c7c0fdd$var$load("bABhq"),
    $6f58def75c7c0fdd$var$load("7nN6f")
]).then(()=>parcelRequire('l3jRL'));

});


parcelRegister("8QhCi", function(module, exports) {

let $6700d8625d9aef21$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6700d8625d9aef21$var$load("k4gbU"),
    $6700d8625d9aef21$var$load("1VRB2"),
    $6700d8625d9aef21$var$load("bABhq"),
    $6700d8625d9aef21$var$load("7vqGd"),
    $6700d8625d9aef21$var$load("1Y4bq"),
    $6700d8625d9aef21$var$load("2458C")
]).then(()=>parcelRequire('3nLhB'));

});


parcelRegister("k6duF", function(module, exports) {

$parcel$export(module.exports, "ForPaintClassicSoftwareProjectSidebar", () => $919301427081454d$export$a70fda37b3fc5365);
$parcel$export(module.exports, "default", () => $919301427081454d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

var $kfvK2 = parcelRequire("kfvK2");

const $919301427081454d$var$LazyAfterPaintClassicSoftwareProjectSidebar = (0, $gzcjr.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("5Zd6b")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});

const $919301427081454d$var$LazyForPaintClassicSoftwareProjectSidebar = (0, $gzcjr.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("5Zd6b")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});
const $919301427081454d$var$AfterPaintClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$var$LazyAfterPaintClassicSoftwareProjectSidebar, null)));
const $919301427081454d$export$a70fda37b3fc5365 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$var$LazyForPaintClassicSoftwareProjectSidebar, null)));
const $919301427081454d$var$ClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const isIssueRoute = (0, $kfvK2.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$export$a70fda37b3fc5365, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$var$AfterPaintClassicSoftwareProjectSidebar, null);
});
$919301427081454d$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
$919301427081454d$export$a70fda37b3fc5365.displayName = 'ClassicSoftwareProjectSidebar';
var $919301427081454d$export$2e2bcd8739ae039 = $919301427081454d$var$ClassicSoftwareProjectSidebar;

});
parcelRegister("5Zd6b", function(module, exports) {

let $45bccf63850ee9c3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $45bccf63850ee9c3$var$load("1G8UW"),
    $45bccf63850ee9c3$var$load("iSk93"),
    $45bccf63850ee9c3$var$load("1VRB2"),
    $45bccf63850ee9c3$var$load("bABhq"),
    $45bccf63850ee9c3$var$load("7vqGd"),
    $45bccf63850ee9c3$var$load("1Y4bq"),
    $45bccf63850ee9c3$var$load("cGJDD")
]).then(()=>parcelRequire('h8X2Q'));

});


parcelRegister("2pKcR", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJswCompanyRoute", () => $d8bb6fa8c300a067$export$d370de0c0b8dc61b);
const $d8bb6fa8c300a067$export$d370de0c0b8dc61b = {
    name: 'software-archived-work-items-classic',
    path: '/jira/software/c/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("3cJRB", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJswRouteEntry", () => $f71c77f19c231728$export$2686cd22a3691dbf);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $gHaIq = parcelRequire("gHaIq");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $j3sUb = parcelRequire("j3sUb");
const $f71c77f19c231728$export$2686cd22a3691dbf = (0, $6xToB.createEntry)((0, $gHaIq.archivedWorkItemsJswRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectSoftwareRoute from issue-navigator
        layout: (0, $6dwgv.createLayout)((0, $8FCAy.softwareProjectLayoutNoOnboarding)),
        entryPoint: ()=>(0, $j3sUb.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("gHaIq", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJswRoute", () => $517c307f7699d330$export$356fe8859732c01b);
const $517c307f7699d330$export$356fe8859732c01b = {
    name: 'software-archived-work-items',
    path: '/jira/software/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("apVTf", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJwmRouteEntry", () => $e122004475a9740a$export$a243ee53747084d5);

var $hS1gr = parcelRequire("hS1gr");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $3belI = parcelRequire("3belI");

var $j3sUb = parcelRequire("j3sUb");
const $e122004475a9740a$export$a243ee53747084d5 = (0, $6xToB.createEntry)((0, $3belI.archivedWorkItemsJwmRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectBusinessRoute from issue-navigator
        layout: (0, $j3sUb.getCommonProjectLayout)(),
        entryPoint: ()=>(0, $j3sUb.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $kRv8K.getBusinessProjectResources)()
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("hiOwQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c48a3c7fb40f9811$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $c48a3c7fb40f9811$var$LazyCoreProjectSidebar = (0, $gzcjr.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("ckmQw")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/business/navigation/sidebar/src/ui/index.tsx"
});
// delete when cleaning up getWillShowNav4
const $c48a3c7fb40f9811$var$CoreProjectSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "coreProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c48a3c7fb40f9811$var$LazyCoreProjectSidebar, null));
var $c48a3c7fb40f9811$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($c48a3c7fb40f9811$var$CoreProjectSidebar);

});
parcelRegister("ckmQw", function(module, exports) {

let $8f9913141cfc2e28$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8f9913141cfc2e28$var$load("1VRB2"),
    $8f9913141cfc2e28$var$load("bABhq"),
    $8f9913141cfc2e28$var$load("7vqGd"),
    $8f9913141cfc2e28$var$load("1Y4bq"),
    $8f9913141cfc2e28$var$load("1FayS")
]).then(()=>parcelRequire('2ZlQu'));

});


parcelRegister("kRv8K", function(module, exports) {

$parcel$export(module.exports, "getBusinessProjectResources", () => $624d2da23216c44c$export$20e8c2951e444b08);
$parcel$export(module.exports, "getProjectViewResources", () => $624d2da23216c44c$export$fcbe882e18ee4a35);
$parcel$export(module.exports, "getOverviewViewResources", () => $624d2da23216c44c$export$21c5527b459d56fe);

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $ebWJz = parcelRequire("ebWJz");

var $6zXPf = parcelRequire("6zXPf");

var $bYpK5 = parcelRequire("bYpK5");

var $cV98p = parcelRequire("cV98p");

var $iXIhG = parcelRequire("iXIhG");

var $ebuR2 = parcelRequire("ebuR2");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $8tbnc = parcelRequire("8tbnc");

var $ho9E1 = parcelRequire("ho9E1");

var $1G20J = parcelRequire("1G20J");
const $624d2da23216c44c$export$20e8c2951e444b08 = ()=>(0, $6zXPf.getWillShowNav4)() ? [
        // eslint-disable-next-line camelcase
        (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $1G20J.projectThemeResource)
    ] : [
        (0, $ho9E1.projectCreatePermissionsResource),
        (0, $cV98p.navigationResource),
        // eslint-disable-next-line camelcase
        (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $bYpK5.businessHorizontalNav3Resource),
        (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
        (0, $1G20J.projectThemeResource)
    ];
const $624d2da23216c44c$export$fcbe882e18ee4a35 = ()=>[
        ...$624d2da23216c44c$export$20e8c2951e444b08(),
        ...(0, $9NmsS.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        (0, $ebWJz.fieldsResource)
    ];
const $624d2da23216c44c$export$46471673e66df5c1 = ()=>[
        (0, $ho9E1.projectCreatePermissionsResource),
        (0, $cV98p.navigationResource),
        (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
        (0, $iXIhG.overviewDetailsResource),
        (0, $1G20J.projectThemeResource)
    ];
const $624d2da23216c44c$export$21c5527b459d56fe = ()=>[
        ...$624d2da23216c44c$export$46471673e66df5c1(),
        ...(0, $9NmsS.getNavigationResources)(),
        (0, $ebWJz.fieldsResource)
    ];

});
parcelRegister("ebWJz", function(module, exports) {

$parcel$export(module.exports, "fieldsResource", () => $f772abfaa17ccd63$export$8bca6c1954ae9308);
$parcel$export(module.exports, "useFieldsResource", () => $f772abfaa17ccd63$export$c0cd85886917fe89);

var $cwZUV = parcelRequire("cwZUV");

var $942wy = parcelRequire("942wy");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


var $9bD5G = parcelRequire("9bD5G");

var $7cmPk = parcelRequire("7cmPk");
const $f772abfaa17ccd63$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f772abfaa17ccd63$var$handleProjectResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, $942wy.GraphQLErrors)(response.errors);
    return (0, $7cmPk.transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f772abfaa17ccd63$var$handleOverviewResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jwmOverview?.fields?.edges == null) throw new (0, $942wy.GraphQLErrors)(response.errors);
    return (0, $7cmPk.transformData)(response.data?.jira?.jwmOverview?.fields?.edges);
};
const $f772abfaa17ccd63$export$8bca6c1954ae9308 = (0, $l1VxS.createResource)({
    type: $f772abfaa17ccd63$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        if (matchedRoute.match.params.overviewId) return `${$f772abfaa17ccd63$var$RESOURCE_TYPE_KEY}_overview_${matchedRoute.match.params.overviewId}`;
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$f772abfaa17ccd63$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        if (match.params.overviewId) return (0, $9bD5G.fetchFields)((0, $d414d4047a262b56$export$c378ca4a0e2c9fec), $f772abfaa17ccd63$var$handleOverviewResponse, {
            overviewAri: (0, $cwZUV.JiraProjectOverviewAri).create({
                siteId: cloudId,
                activationId: activationId,
                overviewId: match.params.overviewId
            }).toString()
        });
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        return (0, $9bD5G.fetchFields)((0, $d414d4047a262b56$export$4d41378da3f70f0f), $f772abfaa17ccd63$var$handleProjectResponse, {
            cloudId: cloudId,
            jqlContext: `project = '${projectIdOrKey}'`
        });
    },
    maxAge: 3600000
});
const $f772abfaa17ccd63$export$c0cd85886917fe89 = ()=>(0, $eJrcF.useResource)($f772abfaa17ccd63$export$8bca6c1954ae9308);

});
parcelRegister("cwZUV", function(module, exports) {

$parcel$export(module.exports, "JiraProjectOverviewAri", () => $91f880a532f2531d$export$714879003922a622);

var $cTkpI = parcelRequire("cTkpI");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/project-overview/manifest.ts
var $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $cTkpI.JiraProjectOverviewAriResourceOwner),
    resourceType: (0, $cTkpI.JiraProjectOverviewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{overviewId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        overviewId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira/project-overview/index.ts
var $91f880a532f2531d$export$714879003922a622 = class _JiraProjectOverviewAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._overviewId = opts.resourceIdSegmentValues.overviewId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get overviewId() {
        return this._overviewId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts.qualifier,
            platformQualifier: $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts.resourceOwner,
            resourceType: $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.overviewId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                overviewId: opts.overviewId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts);
        return new _JiraProjectOverviewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts);
        return new _JiraProjectOverviewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            overviewId: this.overviewId
        };
    }
};

});
parcelRegister("cTkpI", function(module, exports) {

$parcel$export(module.exports, "JiraProjectOverviewAriResourceOwner", () => $962a74da2f17354b$export$d68ef32d028cea3e);
$parcel$export(module.exports, "JiraProjectOverviewAriResourceType", () => $962a74da2f17354b$export$491d1b3b0151dbc4);
// src/jira/project-overview/types.ts
var $962a74da2f17354b$export$d68ef32d028cea3e = "jira", $962a74da2f17354b$export$491d1b3b0151dbc4 = "project-overview";

});


parcelRegister("942wy", function(module, exports) {

$parcel$export(module.exports, "GraphQLErrors", () => $3577b4c37e9af666$export$89c202e66b2de2b6);

var $buoPQ = parcelRequire("buoPQ");

var $4sprp = parcelRequire("4sprp");
// Sets the error message on this error according to the
// the GraphQL errors that are present.
const $3577b4c37e9af666$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `${errorMessage}\n`;
    });
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $3577b4c37e9af666$export$89c202e66b2de2b6 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = graphQLErrors != null ? (0, (/*@__PURE__*/$parcel$interopDefault($buoPQ)))(graphQLErrors) : [];
        this.message = $3577b4c37e9af666$var$generateErrorMessage(this);
        this.cause = this.graphQLErrors?.[0];
        this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
        this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
    }
}

});
parcelRegister("buoPQ", function(module, exports) {

var $4sprp = parcelRequire("4sprp");
/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $85d5c2cbe671e6d1$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $4sprp(value) ? value : [
        value
    ];
}
module.exports = $85d5c2cbe671e6d1$var$castArray;

});


const $d414d4047a262b56$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;
const $d414d4047a262b56$export$c378ca4a0e2c9fec = `
query JWMOverviewFields($overviewAri: ID!, $first: Int) {
  jira {
    jwmOverview(id: $overviewAri) {
      ... on JiraWorkManagementGiraOverview {
        fields (first: $first) {
          ... on JiraJqlFieldConnection {
            edges {
              node {
                jqlTerm
                type
                displayName,
              }
            }
          }
        }
      }
    }
  }
}`;

parcelRegister("9bD5G", function(module, exports) {

$parcel$export(module.exports, "fetchFields", () => $d910ddfedea9b5ee$export$f3ddd735c360919);

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $d910ddfedea9b5ee$var$PAGE_SIZE = 100;
const $d910ddfedea9b5ee$export$f3ddd735c360919 = async (query, handler, params)=>{
    try {
        const promise = (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: $d910ddfedea9b5ee$var$PAGE_SIZE,
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return await handler(promise);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $gYnSx.default)({
            meta: {
                id: 'fieldsResource',
                packageName: 'jiraRouterResourcesBusinessFields',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});

parcelRegister("7cmPk", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $532ac776c238882e$export$3ceb62baab058c6b);
const $532ac776c238882e$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);

});


parcelRegister("bYpK5", function(module, exports) {

$parcel$export(module.exports, "businessHorizontalNav3Resource", () => $de5f5f2174269868$export$b3359003584ee2b0);

var $3osLr = parcelRequire("3osLr");

var $eSnSE = parcelRequire("eSnSE");

var $7jTnu = parcelRequire("7jTnu");

var $hBje1 = parcelRequire("hBje1");

var $7Bvm5 = parcelRequire("7Bvm5");

var $9FYIg = parcelRequire("9FYIg");

var $l58dJ = parcelRequire("l58dJ");

var $bBtQo = parcelRequire("bBtQo");
const $de5f5f2174269868$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_HORIZONTAL_NAVIGATION';
const $de5f5f2174269868$var$getProjectAri = (projectId, cloudId)=>{
    try {
        return projectId ? (0, $3osLr.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
    } catch (err) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesNavigationItems', 'Failed to get project ari');
        return '';
    }
};
const $de5f5f2174269868$export$b3359003584ee2b0 = (0, $hBje1.withGiraAggAnonSsrFix)((0, $9FYIg.createRelayResource)({
    type: $de5f5f2174269868$var$RESOURCE_TYPE_KEY,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        const projectIdOrKey = projectKey || projectId;
        const scopeId = $de5f5f2174269868$var$getProjectAri(projectId, cloudId);
        return {
            parameters: (0, $l58dJ.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectIdOrKey,
                first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE),
                isConsolidatedQuery: false,
                containerNavigationInput: scopeId ? {
                    scopeId: scopeId
                } : {
                    projectKeyQuery: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                useContainerNavigation: false,
                useNewProjectHeader: false,
                projectKey: projectKey,
                projectAri: scopeId,
                useProjectKey: Boolean(projectKey),
                isJiraCustomTemplatesUxEnabled: (0, $7jTnu.fg)('jira_custom_templates_ux')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
}));

});
parcelRegister("hBje1", function(module, exports) {

$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $0507489b8f939505$export$f4b29e78f4c0a526);
const $0507489b8f939505$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});

parcelRegister("l58dJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $94098da9a759e84f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<820042db950ffe26b91d34ffe7050138>>
 * @relayHash bef16a6db03ecc4506e2c317ed3ec3dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c6a8fb0afe8804c6d8b040f3b4ccf6926f7a96b57ad873204c81c3a0ee4ada5
const $94098da9a759e84f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJiraCustomTemplatesUxEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useProjectKey"
    }, v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v9 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v11 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "alias": "canEditProjectConfig",
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v14 = {
        "condition": "isJiraCustomTemplatesUxEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "customTemplateBusinessProjectBanner_businessHorizontalNav"
            }
        ]
    }, v15 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v16 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "projectIdOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "condition": "isJiraCustomTemplatesUxEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLiveTemplate"
                }
            ]
        },
        v18 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "tabs_businessHorizontalNav_TabsContent"
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataByKey.projectId"
                                            },
                                            v11 /*: any*/ ,
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "projectDataById",
                                        "args": v15 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataById.projectId"
                                            },
                                            v11 /*: any*/ ,
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "navigationItems",
                            "args": v16 /*: any*/ ,
                            "concreteType": "JiraNavigationItemConnection",
                            "kind": "LinkedField",
                            "name": "jwmSavedViewsByProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNavigationItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isDefault"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeKey"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraNavigationItem"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canRemove"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canSetAsDefault"
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "navigationItems",
                            "args": v16 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "projectIdOrKey"
                            ],
                            "handle": "connection",
                            "key": "tabs_jiraNavigation__navigationItems",
                            "kind": "LinkedHandle",
                            "name": "jwmSavedViewsByProject"
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "projectDataByKey",
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "projectDataById",
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4c6a8fb0afe8804c6d8b040f3b4ccf6926f7a96b57ad873204c81c3a0ee4ada5",
            "metadata": {},
            "name": "projectNavigation_horizontalNavigationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$94098da9a759e84f$var$node.hash = "73d9509696eb943ac9eaa2deb0444981";
var $94098da9a759e84f$export$2e2bcd8739ae039 = $94098da9a759e84f$var$node;

});


parcelRegister("cV98p", function(module, exports) {

$parcel$export(module.exports, "navigationResource", () => $e93bba7c11632d20$export$62940941ee574cdc);
$parcel$export(module.exports, "useNavigationResource", () => $e93bba7c11632d20$export$c17011c09e042a31);

var $8dH3d = parcelRequire("8dH3d");

var $3osLr = parcelRequire("3osLr");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


var $exaWd = parcelRequire("exaWd");

const $e93bba7c11632d20$export$62940941ee574cdc = (0, $l1VxS.createResource)({
    type: 'BUSINESS_NAVIGATION',
    getKey: ()=>'BUSINESS_NAVIGATION',
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(projectKey)) return (0, $exaWd.fetchNavigation)((0, $facb8b07dec6e94a$export$a40c5d12b8a53ba2), {
            cloudId: cloudId,
            projectKey: projectKey
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(projectId)) return (0, $exaWd.fetchNavigation)((0, $facb8b07dec6e94a$export$7c9197b656229b53), {
            cloudId: cloudId,
            projectId: (0, $3osLr.JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString()
        });
        return (0, $exaWd.fetchNavigation)((0, $facb8b07dec6e94a$export$c378ca4a0e2c9fec), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $e93bba7c11632d20$export$c17011c09e042a31 = ()=>(0, $eJrcF.useResource)($e93bba7c11632d20$export$62940941ee574cdc);

});
const $facb8b07dec6e94a$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $facb8b07dec6e94a$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $facb8b07dec6e94a$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $facb8b07dec6e94a$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $facb8b07dec6e94a$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
}
`;
const $facb8b07dec6e94a$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$facb8b07dec6e94a$var$ProjectFragment}
${$facb8b07dec6e94a$var$ProjectConnectionFragment}
${$facb8b07dec6e94a$var$NavigationDataFragment}
${$facb8b07dec6e94a$var$OverviewFragment}
${$facb8b07dec6e94a$var$OverviewConnectionFragment}
`;
const $facb8b07dec6e94a$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$facb8b07dec6e94a$var$ProjectFragment}
${$facb8b07dec6e94a$var$ProjectConnectionFragment}
${$facb8b07dec6e94a$var$NavigationDataFragment}
${$facb8b07dec6e94a$var$OverviewFragment}
${$facb8b07dec6e94a$var$OverviewConnectionFragment}
`;
const $facb8b07dec6e94a$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$facb8b07dec6e94a$var$ProjectFragment}
${$facb8b07dec6e94a$var$ProjectConnectionFragment}
${$facb8b07dec6e94a$var$NavigationDataFragment}
${$facb8b07dec6e94a$var$OverviewFragment}
${$facb8b07dec6e94a$var$OverviewConnectionFragment}
`;

parcelRegister("exaWd", function(module, exports) {

$parcel$export(module.exports, "fetchNavigation", () => $5a91feaff3ce8435$export$1fc5fff73d9a570c);

var $942wy = parcelRequire("942wy");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");


var $bUjBB = parcelRequire("bUjBB");
const $5a91feaff3ce8435$var$EMPTY_RESPONSE = {
    recents: [],
    favorites: [],
    hasMoreFavorite: false,
    overviews: [],
    overviewsError: null,
    isPremiumUserSeat: false,
    shouldHideOverviews: false
};
const $5a91feaff3ce8435$export$1fc5fff73d9a570c = async (query, params)=>{
    try {
        const response = await (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: (0, $2affa696f349435b$export$3349219a88ac77cd),
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        // checking only for undefined, as null is a valid value (not applicable)
        if (response.data?.jira?.navigation === undefined) throw new (0, $942wy.GraphQLErrors)(response.errors);
        let areOverviewsGone = false;
        if (Array.isArray(response.errors)) // Overviews have been migrated to plans and should no longer be shown to the user
        areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
        return (0, $bUjBB.transformData)(response.data.jira.navigation, areOverviewsGone);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $gYnSx.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesBusinessNavigation',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $5a91feaff3ce8435$var$EMPTY_RESPONSE;
};

});
const $2affa696f349435b$export$3349219a88ac77cd = 10;
const $2affa696f349435b$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';

parcelRegister("bUjBB", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $af6a29813efa9984$export$3ceb62baab058c6b);

var $1uv7v = parcelRequire("1uv7v");


var $9aOeZ = parcelRequire("9aOeZ");
const $af6a29813efa9984$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
const $af6a29813efa9984$var$PREMIUM = 'PREMIUM';
const $af6a29813efa9984$var$mapProjectNode = (node)=>({
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.projectStyle === $af6a29813efa9984$var$SIMPLIFIED_PROJECT_STYLE,
        isFavorite: node.isFavourite,
        permissions: {
            viewIssues: node.viewIssues.canPerform
        },
        defaultView: node.defaultView?.typeKey?.toLowerCase()
    });
const $af6a29813efa9984$var$mapOverviewNode = (node)=>({
        id: node.id,
        name: node.name,
        theme: node?.theme ?? (0, $1uv7v.DEFAULT_BACKGROUND_CONFIG).name
    });
const $af6a29813efa9984$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
    if (navigation == null) // not a JWM context
    return 0, $2affa696f349435b$export$e8958a6508ec5b71;
    let overviews = [];
    let overviewsError = null;
    const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $af6a29813efa9984$var$PREMIUM;
    if (isPremiumUserSeat) {
        if (navigation.overviews?.__typename === (0, $9aOeZ.OVERVIEWS_SUCCESS_RESPONSE_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        overviews = navigation.overviews.edges.map((edge)=>$af6a29813efa9984$var$mapOverviewNode(edge.node));
        else overviewsError = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        navigation.overviews ?? new Error('Unknown overviews error');
    }
    let recents = navigation.recentProjects?.edges?.map((edge)=>$af6a29813efa9984$var$mapProjectNode(edge.node)) ?? [];
    const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$af6a29813efa9984$var$mapProjectNode(edge.node)) ?? [];
    // Remove favorited projects from the recent projects list
    recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
    return {
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
        overviews: overviews,
        overviewsError: overviewsError,
        isPremiumUserSeat: isPremiumUserSeat,
        shouldHideOverviews: areOverviewsGone
    };
};

});
parcelRegister("1uv7v", function(module, exports) {

$parcel$export(module.exports, "STAR_ICON_COLOR", () => $07a7fda3e3bc1ac3$export$9e0962e0cb41695d);
$parcel$export(module.exports, "Variables", () => $07a7fda3e3bc1ac3$export$8bb9d79ea938efc9);
$parcel$export(module.exports, "Tokens", () => $07a7fda3e3bc1ac3$export$8e1e81ac145e31be);
$parcel$export(module.exports, "BASE_THEME", () => $07a7fda3e3bc1ac3$export$8a6e9b3370a0f87a);
$parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", () => $07a7fda3e3bc1ac3$export$f286efa6bd1e8f9d);
$parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", () => $07a7fda3e3bc1ac3$export$97cb21c6432e07e8);
$parcel$export(module.exports, "GRADIENT_THEME", () => $07a7fda3e3bc1ac3$export$b124f62a6aab972);
$parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", () => $07a7fda3e3bc1ac3$export$9441e0d8f766c59a);
$parcel$export(module.exports, "NO_BACKGROUND_CONFIG", () => $07a7fda3e3bc1ac3$export$4c351ec1dc290344);
$parcel$export(module.exports, "ADAPTIVE_IMAGE_BACKGROUND_CONFIG", () => $07a7fda3e3bc1ac3$export$c8033614bd64480d);
$parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", () => $07a7fda3e3bc1ac3$export$34373eced7ee212e);
$parcel$export(module.exports, "FIXED_COLOR_BACKGROUND_CONFIGS", () => $07a7fda3e3bc1ac3$export$bc16bf654619d060);
$parcel$export(module.exports, "ADAPTIVE_COLOR_BACKGROUND_CONFIGS", () => $07a7fda3e3bc1ac3$export$4b188262dd47f902);
$parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", () => $07a7fda3e3bc1ac3$export$242b2d2213fedf27);
$parcel$export(module.exports, "ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS", () => $07a7fda3e3bc1ac3$export$8a6c8dd4a86d3f7d);
$parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", () => $07a7fda3e3bc1ac3$export$fe05a238062e2c3d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", () => $07a7fda3e3bc1ac3$export$cab9d853866386f2);
$parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", () => $07a7fda3e3bc1ac3$export$8e357501548afe78);
$parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", () => $07a7fda3e3bc1ac3$export$baaf8255c30ea280);
$parcel$export(module.exports, "BUSINESS_NAV_HEIGHT", () => $07a7fda3e3bc1ac3$export$d9035bc768f8226d);
$parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", () => $07a7fda3e3bc1ac3$export$4810531e30462f89);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $07a7fda3e3bc1ac3$export$1c0b806722927549);
$parcel$export(module.exports, "NAV4_HORIZONTAL_NAV_HEIGHT", () => $07a7fda3e3bc1ac3$export$2af5673c2fa63c55);
$parcel$export(module.exports, "NAV4_BUSINESS_NAV_HEIGHT", () => $07a7fda3e3bc1ac3$export$5771162cdeebfb85);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_HEIGHT", () => $07a7fda3e3bc1ac3$export$a1626d6d785092a2);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $07a7fda3e3bc1ac3$export$410e3d6221a052e);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", () => $07a7fda3e3bc1ac3$export$77cdace62a821419);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", () => $07a7fda3e3bc1ac3$export$3efe68325dd9dc02);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout



const $07a7fda3e3bc1ac3$export$9e0962e0cb41695d = '#FFAB00';
const $07a7fda3e3bc1ac3$export$8bb9d79ea938efc9 = {
    BACKDROP_FILTER: '--project-backdrop-filter',
    // Delete when business projects are migrated to the new theming
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST: '--project-color-background-neutral-subtle-hovered-contrast',
    COLOR_BACKGROUND_ACCENT_SELECTED: '--project-color-background-accent-selected',
    COLOR_BACKGROUND_BRAND_BOLD: '--project-color-background-brand-bold',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--project-color-background-brand-bold-hovered',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--project-color-background-brand-bold-pressed',
    COLOR_BACKGROUND_DISABLED: '--project-color-background-disabled',
    COLOR_BACKGROUND_INPUT: '--project-background-input',
    COLOR_BACKGROUND_NEUTRAL: '--project-background-neutral',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: '--project-background-neutral-hovered',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: '--project-background-neutral-pressed',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--project-background-neutral-subtle-hovered',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--project-background-neutral-subtle-pressed',
    COLOR_BACKGROUND_SELECTED: '--project-background-selected',
    COLOR_BORDER: '--project-color-border',
    COLOR_BORDER_INPUT: '--project-color-border-input',
    COLOR_BORDER_INVERSE: '--project-color-border-inverse',
    COLOR_BORDER_SELECTED: '--project-color-border-selected',
    COLOR_ELEVATION_SURFACE: '--project-color-elevation-surface',
    COLOR_ELEVATION_SURFACE_SUNKEN: '--project-color-elevation-surface-sunken',
    COLOR_ICON_DANGER: '--project-color-icon-danger',
    COLOR_ICON_INFORMATION: '--project-color-icon-information',
    COLOR_ICON_SUCCESS: '--project-color-icon-success',
    COLOR_ICON_WARNING: '--project-color-icon-warning',
    COLOR_LINK: '--project-color-link',
    COLOR_LINK_PRESSED: '--project-color-link-pressed',
    COLOR_SKELETON: '--project-skeleton',
    COLOR_TEXT: '--project-color-text',
    COLOR_TEXT_ACCENT_SELECTED: '--project-text-accent-selected',
    COLOR_TEXT_DISABLED: '--project-color-text-disabled',
    COLOR_TEXT_INVERSE: '--project-color-text-inverse',
    COLOR_TEXT_SELECTED: '--project-color-text-selected',
    COLOR_TEXT_SUBTLE: '--project-color-text-subtle',
    COLOR_TEXT_SUBTLEST: '--project-color-text-subtlest',
    CONTENT_HEIGHT: '--project-content-height',
    CONTENT_WIDTH: '--project-content-width',
    ELEVATION_SURFACE: '--project-elevation-surface',
    ELEVATION_SURFACE_CONTRAST: '--project-elevation-surface-contrast',
    ELEVATION_SURFACE_CONTRAST_BOLDER: '--project-elevation-surface-contrast-bolder',
    ELEVATION_SURFACE_BLEND_MODE: '--project-elevation-surface-blend-mode',
    WRAPPER_BACKGROUND: '--project-wrapper-background',
    WRAPPER_BORDER_RADIUS: '--project-wrapper-border-radius',
    WRAPPER_HEIGHT: '--project-wrapper-height',
    WRAPPER_PADDING: '--project-wrapper-padding',
    WRAPPER_WIDTH: '--project-wrapper-width'
};
const $07a7fda3e3bc1ac3$export$8e1e81ac145e31be = {
    BACKDROP_FILTER: 'var(--project-backdrop-filter)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST: 'var(--project-color-background-neutral-subtle-hovered-contrast)',
    COLOR_BACKGROUND_ACCENT_SELECTED: 'var(--project-color-background-accent-selected)',
    COLOR_BACKGROUND_BRAND_BOLD: 'var(--project-color-background-brand-bold)',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--project-color-background-brand-bold-hovered)',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--project-color-background-brand-bold-pressed)',
    COLOR_BACKGROUND_DISABLED: 'var(--project-color-background-disabled)',
    COLOR_BACKGROUND_INPUT: 'var(--project-background-input)',
    COLOR_BACKGROUND_NEUTRAL: 'var(--project-background-neutral)',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--project-background-neutral-hovered)',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--project-background-neutral-pressed)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--project-background-neutral-subtle-hovered)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--project-background-neutral-subtle-pressed)',
    COLOR_BACKGROUND_SELECTED: 'var(--project-background-selected)',
    COLOR_BORDER: 'var(--project-color-border)',
    COLOR_BORDER_INPUT: 'var(--project-color-border-input)',
    COLOR_BORDER_INVERSE: 'var(--project-color-border-inverse)',
    COLOR_BORDER_SELECTED: 'var(--project-color-border-selected)',
    COLOR_ELEVATION_SURFACE: 'var(--project-color-elevation-surface)',
    COLOR_ELEVATION_SURFACE_SUNKEN: 'var(--project-color-elevation-surface-sunken)',
    COLOR_ICON_DANGER: 'var(--project-color-icon-danger)',
    COLOR_ICON_INFORMATION: 'var(--project-color-icon-information)',
    COLOR_ICON_SUCCESS: 'var(--project-color-icon-success)',
    COLOR_ICON_WARNING: 'var(--project-color-icon-warning)',
    COLOR_LINK: 'var(--project-color-link)',
    COLOR_LINK_PRESSED: 'var(--project-color-link-pressed)',
    COLOR_SKELETON: 'var(--project-skeleton)',
    COLOR_TEXT: 'var(--project-color-text)',
    COLOR_TEXT_ACCENT_SELECTED: 'var(--project-text-accent-selected)',
    COLOR_TEXT_DISABLED: 'var(--project-color-text-disabled)',
    COLOR_TEXT_INVERSE: 'var(--project-color-text-inverse)',
    COLOR_TEXT_SELECTED: 'var(--project-color-text-selected)',
    COLOR_TEXT_SUBTLE: 'var(--project-color-text-subtle)',
    COLOR_TEXT_SUBTLEST: 'var(--project-color-text-subtlest)',
    CONTENT_HEIGHT: 'var(--project-content-height)',
    CONTENT_WIDTH: 'var(--project-content-width)',
    ELEVATION_SURFACE: 'var(--project-elevation-surface)',
    ELEVATION_SURFACE_CONTRAST: 'var(--project-elevation-surface-contrast)',
    ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--project-elevation-surface-contrast-bolder)',
    ELEVATION_SURFACE_BLEND_MODE: 'var(--project-elevation-surface-blend-mode)',
    WRAPPER_BACKGROUND: 'var(--project-wrapper-background)',
    WRAPPER_BORDER_RADIUS: 'var(--project-wrapper-border-radius)',
    WRAPPER_HEIGHT: 'var(--project-wrapper-height)',
    WRAPPER_PADDING: 'var(--project-wrapper-padding)',
    WRAPPER_WIDTH: 'var(--project-wrapper-width)'
};
const $07a7fda3e3bc1ac3$export$8a6e9b3370a0f87a = {
    'color.background.neutral.subtle.hovered.contrast': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
    'color.background.accent.selected': (0, $135dba7912433cc2$exports).B700,
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0C66E4)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0055CC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
    'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.neutral': "var(--ds-background-neutral, #091E420F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #091E424F)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #091E4224)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FF)",
    'color.elevation.surface': "var(--ds-surface, #FFFFFF)",
    'color.elevation.surface.sunken': "var(--ds-surface-sunken, #F7F8F9)",
    'color.border': "var(--ds-border, #091E4224)",
    'color.border.input': "var(--ds-border-input, #8590A2)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0C66E4)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.information': "var(--ds-icon-information, #1D7AFC)",
    'color.icon.success': "var(--ds-icon-success, #22A06B)",
    'color.icon.warning': "var(--ds-icon-warning, #E56910)",
    'color.link': "var(--ds-link, #0C66E4)",
    'color.link.pressed': "var(--ds-link-pressed, #0055CC)",
    'color.skeleton': "var(--ds-background-neutral, #091E420F)",
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.selected': "var(--ds-text, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0C66E4)",
    'color.text.subtle': "var(--ds-text-subtle, #44546F)",
    'color.text.subtlest': "var(--ds-text-subtlest, #626F86)",
    'elevation.surface.contrast': 'transparent',
    'elevation.surface.contrast.bolder': 'transparent',
    'elevation.surface.blend.mode': 'darken'
};
const $07a7fda3e3bc1ac3$export$f286efa6bd1e8f9d = {
    'color.background.accent.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
    'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
    'color.background.input': 'rgba(255, 255, 255, 0.8)',
    'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.text.selected': "var(--ds-text-inverse, #FFFFFF)"
};
const $07a7fda3e3bc1ac3$export$97cb21c6432e07e8 = {
    'color.background.neutral.subtle.hovered.contrast': 'rgba(255, 255, 255, 0.08)',
    'color.background.accent.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
    'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
    'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
    'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
    'color.background.input': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
    'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
    'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
    'color.background.selected': 'rgba(255, 255, 255, 0.6)',
    'color.elevation.surface': '#172b4d',
    'color.border': 'rgba(255, 255, 255, 0.14)',
    'color.border.input': 'rgba(255, 255, 255, 0.3)',
    'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
    'color.border.selected': (0, $135dba7912433cc2$exports).N0,
    'color.icon.danger': (0, $135dba7912433cc2$exports).N0,
    'color.icon.information': (0, $135dba7912433cc2$exports).N0,
    'color.icon.success': (0, $135dba7912433cc2$exports).N0,
    'color.icon.warning': (0, $135dba7912433cc2$exports).N0,
    'color.skeleton': 'rgba(255,255,255,0.08)',
    'color.text': (0, $135dba7912433cc2$exports).N0,
    'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
    'color.text.inverse': '#172B4D',
    // Neutral 1000
    'color.text.selected': '#172B4D',
    // Neutral 1000
    'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
    'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
};
const $07a7fda3e3bc1ac3$export$b124f62a6aab972 = {
    'color.link': '#CCE0FF',
    // Blue 200
    'color.link.pressed': '#E9F2FF' // Blue 100
};
const $07a7fda3e3bc1ac3$export$9441e0d8f766c59a = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.text.selected': "var(--ds-text-inverse, #FFFFFF)",
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        },
        dark: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.input': 'rgba(34, 39, 43, 0.8)',
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.elevation.surface': '#172b4d',
            'color.border': 'rgba(255, 255, 255, 0.14)',
            'color.border.input': 'rgba(255, 255, 255, 0.3)',
            'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
            'color.icon.danger': (0, $135dba7912433cc2$exports).N0,
            'color.icon.information': (0, $135dba7912433cc2$exports).N0,
            'color.icon.success': (0, $135dba7912433cc2$exports).N0,
            'color.icon.warning': (0, $135dba7912433cc2$exports).N0,
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.skeleton': 'rgba(255,255,255,0.8)',
            'color.text': (0, $135dba7912433cc2$exports).N0,
            'color.text.selected': "var(--ds-text-inverse, #FFFFFF)",
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        }
    }
};
// Old Colors
const $07a7fda3e3bc1ac3$var$WHITE_BACKGROUND_CONFIG = {
    name: 'white'
};
const $07a7fda3e3bc1ac3$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
    name: 'light-purple'
};
const $07a7fda3e3bc1ac3$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
    name: 'light-blue'
};
const $07a7fda3e3bc1ac3$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
    name: 'light-teal'
};
const $07a7fda3e3bc1ac3$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
    name: 'light-green'
};
const $07a7fda3e3bc1ac3$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
    name: 'light-yellow'
};
const $07a7fda3e3bc1ac3$var$LIGHT_RED_BACKGROUND_CONFIG = {
    name: 'light-red'
};
const $07a7fda3e3bc1ac3$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
    name: 'light-magenta'
};
const $07a7fda3e3bc1ac3$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
    name: 'light-orange'
};
const $07a7fda3e3bc1ac3$var$DARK_BACKGROUND_CONFIG = {
    name: 'dark'
};
const $07a7fda3e3bc1ac3$var$PURPLE_BACKGROUND_CONFIG = {
    name: 'purple'
};
const $07a7fda3e3bc1ac3$var$BLUE_BACKGROUND_CONFIG = {
    name: 'blue'
};
const $07a7fda3e3bc1ac3$var$TEAL_BACKGROUND_CONFIG = {
    name: 'teal'
};
const $07a7fda3e3bc1ac3$var$GREEN_BACKGROUND_CONFIG = {
    name: 'green'
};
const $07a7fda3e3bc1ac3$var$YELLOW_BACKGROUND_CONFIG = {
    name: 'yellow'
};
const $07a7fda3e3bc1ac3$var$RED_BACKGROUND_CONFIG = {
    name: 'red'
};
const $07a7fda3e3bc1ac3$var$MAGENTA_BACKGROUND_CONFIG = {
    name: 'magenta'
};
const $07a7fda3e3bc1ac3$var$ORANGE_BACKGROUND_CONFIG = {
    name: 'orange'
};
// New Colors
const $07a7fda3e3bc1ac3$var$DARKER_GRAY_BACKGROUND_CONFIG = {
    name: 'darker-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
    name: 'darker-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_BLUE_BACKGROUND_CONFIG = {
    name: 'darker-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_TEAL_BACKGROUND_CONFIG = {
    name: 'darker-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_GREEN_BACKGROUND_CONFIG = {
    name: 'darker-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_LIME_BACKGROUND_CONFIG = {
    name: 'darker-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
    name: 'darker-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
    name: 'darker-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_RED_BACKGROUND_CONFIG = {
    name: 'darker-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darker-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
    name: 'darkest-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'darkest-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
    name: 'darkest-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
    name: 'darkest-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
    name: 'darkest-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_LIME_BACKGROUND_CONFIG = {
    name: 'darkest-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'darkest-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'darkest-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_RED_BACKGROUND_CONFIG = {
    name: 'darkest-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darkest-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
    name: 'lightest-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F1F2F4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'lightest-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F3F0FF',
            // Purple 100
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
    name: 'lightest-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E9F2FF',
            // Blue 100
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
    name: 'lightest-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E7F9FF',
            // Teal 100
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
    name: 'lightest-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCFFF1',
            // Green 100
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
    name: 'lightest-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#EFFFD6',
            // Lime 100
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'lightest-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF7D6',
            // Yellow 100
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'lightest-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF3EB',
            // Orange 100
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
    name: 'lightest-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECEB',
            // Red 100
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lightest-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECF8',
            // Magenta 100
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
    name: 'lighter-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCDFE4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
    name: 'lighter-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DFD8FD',
            // Purple 200
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
    name: 'lighter-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#CCE0FF',
            // Blue 200
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
    name: 'lighter-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#C6EDFB',
            // Teal 200
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
    name: 'lighter-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#BAF3DB',
            // Green 200
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
    name: 'lighter-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#D3F1A7',
            // Lime 200
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
    name: 'lighter-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F8E6A0',
            // Yellow 200
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
    name: 'lighter-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FEDEC8',
            // Orange 200
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_RED_BACKGROUND_CONFIG = {
    name: 'lighter-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFD5D2',
            // Red 200
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lighter-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FDD0EC',
            // Magenta 200
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $07a7fda3e3bc1ac3$export$4c351ec1dc290344 = {
    name: 'no-background',
    brightness: 'high',
    theme: {
        light: $07a7fda3e3bc1ac3$export$8a6e9b3370a0f87a,
        dark: {
            ...$07a7fda3e3bc1ac3$export$8a6e9b3370a0f87a,
            'color.text.accent.selected': "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $07a7fda3e3bc1ac3$var$ADAPTIVE_CONFIG_BASE = {
    'color.elevation.surface': "var(--ds-surface-hovered, #F1F2F4)",
    'color.background.input': "var(--ds-background-neutral, #091E420F)",
    'color.link': "var(--ds-text, #172B4D)",
    'color.link.pressed': "var(--ds-text, #172B4D)",
    'color.elevation.surface.sunken': "var(--ds-surface-sunken, #F7F8F9)",
    'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
    'color.border.selected': "var(--ds-border-bold, #758195)",
    'color.text.selected': "var(--ds-text, #172B4D)",
    'color.text': "var(--ds-text, #172B4D)",
    'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
    'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
    'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
};
const $07a7fda3e3bc1ac3$export$2ccb37bafb938d85 = ({ name: name, overrides: overrides })=>{
    const adaptiveColorTheme = {
        ...$07a7fda3e3bc1ac3$var$ADAPTIVE_CONFIG_BASE,
        ...overrides
    };
    return {
        name: name,
        brightness: 'high',
        theme: {
            light: adaptiveColorTheme,
            dark: adaptiveColorTheme
        }
    };
};
const $07a7fda3e3bc1ac3$export$18621b73983ebf62 = ({ name: name, overridesAllThemes: overridesAllThemes, overridesLightTheme: overridesLightTheme, overridesDarkTheme: overridesDarkTheme })=>{
    const adaptiveGradientTheme = {
        'elevation.surface': "var(--ds-surface, #FFFFFF)",
        ...$07a7fda3e3bc1ac3$var$ADAPTIVE_CONFIG_BASE,
        ...overridesAllThemes
    };
    return {
        name: name,
        brightness: 'high',
        theme: {
            light: {
                ...adaptiveGradientTheme,
                ...overridesLightTheme
            },
            dark: {
                ...adaptiveGradientTheme,
                ...overridesDarkTheme
            }
        }
    };
};
const $07a7fda3e3bc1ac3$export$c8033614bd64480d = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            ...$07a7fda3e3bc1ac3$var$ADAPTIVE_CONFIG_BASE,
            'elevation.surface.blend.mode': 'normal',
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)'
        },
        dark: {
            ...$07a7fda3e3bc1ac3$var$ADAPTIVE_CONFIG_BASE,
            'elevation.surface.blend.mode': 'darken',
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)'
        }
    }
};
const $07a7fda3e3bc1ac3$export$dbb791a784a1373b = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-gray',
    overrides: {
        'color.elevation.surface.sunken': "var(--ds-surface-pressed, #DCDFE4)"
    }
});
const $07a7fda3e3bc1ac3$export$e013fca1233b4f7f = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-purple',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
        'color.link': "var(--ds-text-accent-purple, #5E4DB2)",
        'color.link.pressed': "var(--ds-text-accent-purple, #5E4DB2)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-purple-subtler, #DFD8FD)"
    }
});
const $07a7fda3e3bc1ac3$export$81ad18a6866e27ad = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-blue',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
        'color.link': "var(--ds-text-accent-blue, #0055CC)",
        'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtler, #CCE0FF)"
    }
});
const $07a7fda3e3bc1ac3$export$e41eaa7177d56baf = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-teal',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        'color.link': "var(--ds-text-accent-teal, #206A83)",
        'color.link.pressed': "var(--ds-text-accent-teal, #206A83)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    }
});
const $07a7fda3e3bc1ac3$export$31b6c9185eea93be = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-green',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        'color.link': "var(--ds-text-accent-green, #216E4E)",
        'color.link.pressed': "var(--ds-text-accent-green, #216E4E)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-green-subtler, #BAF3DB)"
    }
});
const $07a7fda3e3bc1ac3$export$3214417ed3fa0b58 = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-magenta',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
        'color.link': "var(--ds-text-accent-magenta, #943D73)",
        'color.link.pressed': "var(--ds-text-accent-magenta, #943D73)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    }
});
// Gradients
const $07a7fda3e3bc1ac3$var$GRADIENT_GRAY_TO_BLACK_META = {
    name: 'gradient-gray-to-black',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
    name: 'gradient-dark-to-medium-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
    name: 'gradient-light-to-dark-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_BLUE_TO_TEAL_META = {
    name: 'gradient-blue-to-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
    name: 'gradient-purple-to-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
    name: 'gradient-magenta-to-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
    name: 'gradient-dark-to-light-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
    name: 'gradient-dark-to-light-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
    name: 'gradient-dark-green-to-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        },
        dark: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
    name: 'gradient-dark-to-medium-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        },
        dark: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_GRAY_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-gray',
    overridesAllThemes: {},
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #F8F8F8 0%, #B7B9BE 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #292A2E 0%, #6B6E76 100%)'
    }
});
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_PURPLE_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-purple',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-blue, #0055CC)",
        'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
        'color.elevation.surface': "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #CFE1FD 0%, #EED7FC 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #123263 0%, #48245D 100%)'
    }
});
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_BLUE_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-blue',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-blue, #0055CC)",
        'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
        'color.elevation.surface': "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #E9F2FE 0%, #669DF1 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #1C2B42 0%, #1868DB 100%)'
    }
});
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_TEAL_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-teal',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-teal, #206A83)",
        'color.link.pressed': "var(--ds-text-accent-teal, #206A83)",
        'color.elevation.surface': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #E7F9FF 0%, #6CC3E0 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #1E3137 0%, #227D9B 100%)'
    }
});
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_GREEN_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-green',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-green, #216E4E)",
        'color.link.pressed': "var(--ds-text-accent-green, #216E4E)",
        'color.elevation.surface': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #DCFFF1 0%, #4BCE97 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #1C3329 0%, #1F845A 100%)'
    }
});
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_MAGENTA_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-magenta',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-magenta, #943D73)",
        'color.link.pressed': "var(--ds-text-accent-magenta, #943D73)",
        'color.elevation.surface': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #FDD0EC 28.5%, #FD9891 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #50253F 28.5%, #AE2E24 100%)'
    }
});
const $07a7fda3e3bc1ac3$export$34373eced7ee212e = [
    $07a7fda3e3bc1ac3$var$WHITE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARK_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$MAGENTA_BACKGROUND_CONFIG
];
const $07a7fda3e3bc1ac3$export$bc16bf654619d060 = [
    $07a7fda3e3bc1ac3$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_LIME_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_GRAY_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_LIME_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_LIME_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
];
const $07a7fda3e3bc1ac3$export$4b188262dd47f902 = [
    $07a7fda3e3bc1ac3$export$dbb791a784a1373b,
    $07a7fda3e3bc1ac3$export$e013fca1233b4f7f,
    $07a7fda3e3bc1ac3$export$81ad18a6866e27ad,
    $07a7fda3e3bc1ac3$export$e41eaa7177d56baf,
    $07a7fda3e3bc1ac3$export$31b6c9185eea93be,
    $07a7fda3e3bc1ac3$export$3214417ed3fa0b58
];
const $07a7fda3e3bc1ac3$export$242b2d2213fedf27 = [
    $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_LIGHT_RED_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_MAGENTA_TO_ORANGE_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_DARK_GREEN_TO_LIME_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_BLUE_TO_TEAL_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_PURPLE_TO_MAGENTA_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_GRAY_TO_BLACK_META
];
const $07a7fda3e3bc1ac3$export$8a6c8dd4a86d3f7d = [
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_GRAY_META,
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_PURPLE_META,
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_BLUE_META,
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_TEAL_META,
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_GREEN_META,
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_MAGENTA_META
];
const $07a7fda3e3bc1ac3$export$fe05a238062e2c3d = {
    white: $07a7fda3e3bc1ac3$export$4c351ec1dc290344,
    'light-purple': $07a7fda3e3bc1ac3$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    'light-blue': $07a7fda3e3bc1ac3$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    'light-teal': $07a7fda3e3bc1ac3$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    'light-green': $07a7fda3e3bc1ac3$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    'light-yellow': $07a7fda3e3bc1ac3$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    'light-orange': $07a7fda3e3bc1ac3$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    'light-red': $07a7fda3e3bc1ac3$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    'light-magenta': $07a7fda3e3bc1ac3$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    dark: $07a7fda3e3bc1ac3$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    purple: $07a7fda3e3bc1ac3$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    blue: $07a7fda3e3bc1ac3$var$DARKER_BLUE_BACKGROUND_CONFIG,
    teal: $07a7fda3e3bc1ac3$var$DARKER_TEAL_BACKGROUND_CONFIG,
    green: $07a7fda3e3bc1ac3$var$DARKER_GREEN_BACKGROUND_CONFIG,
    yellow: $07a7fda3e3bc1ac3$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    orange: $07a7fda3e3bc1ac3$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    red: $07a7fda3e3bc1ac3$var$DARKER_RED_BACKGROUND_CONFIG,
    magenta: $07a7fda3e3bc1ac3$var$DARKER_MAGENTA_BACKGROUND_CONFIG
};
const $07a7fda3e3bc1ac3$export$cab9d853866386f2 = $07a7fda3e3bc1ac3$export$4c351ec1dc290344;
const $07a7fda3e3bc1ac3$export$8e357501548afe78 = 24;
const $07a7fda3e3bc1ac3$export$baaf8255c30ea280 = 95;
const $07a7fda3e3bc1ac3$export$d9035bc768f8226d = `${$07a7fda3e3bc1ac3$export$baaf8255c30ea280}px`;
const $07a7fda3e3bc1ac3$export$4810531e30462f89 = `calc(100vh - ${(0, $bf1c59a4164b2d18$export$d60454526e2281af)} - ${$07a7fda3e3bc1ac3$export$d9035bc768f8226d})`;
const $07a7fda3e3bc1ac3$export$1c0b806722927549 = `calc(100vh - ${(0, $bf1c59a4164b2d18$export$d60454526e2281af)} - ${$07a7fda3e3bc1ac3$export$d9035bc768f8226d} - ${$07a7fda3e3bc1ac3$export$8e357501548afe78 * 2}px)`;
const $07a7fda3e3bc1ac3$export$2af5673c2fa63c55 = 104;
const $07a7fda3e3bc1ac3$export$5771162cdeebfb85 = `${$07a7fda3e3bc1ac3$export$2af5673c2fa63c55}px`;
const $07a7fda3e3bc1ac3$export$a1626d6d785092a2 = `calc(100vh - ${(0, $bf1c59a4164b2d18$export$d60454526e2281af)} - ${$07a7fda3e3bc1ac3$export$5771162cdeebfb85})`;
const $07a7fda3e3bc1ac3$export$410e3d6221a052e = `calc(100vh - ${(0, $bf1c59a4164b2d18$export$d60454526e2281af)} - ${$07a7fda3e3bc1ac3$export$5771162cdeebfb85} - ${$07a7fda3e3bc1ac3$export$8e357501548afe78 * 2}px)`;
const $07a7fda3e3bc1ac3$export$77cdace62a821419 = `calc(100vw - ${(0, $c6b3f4cb88c9ac2a$export$f963aecf2d4465bd)} - ${(0, $c6b3f4cb88c9ac2a$export$f897e1ed9f8ed251)} - ${(0, $c6b3f4cb88c9ac2a$export$750459958906793)} - ${(0, $c6b3f4cb88c9ac2a$export$b44ab66843c05a69)}) !important`;
const $07a7fda3e3bc1ac3$export$3efe68325dd9dc02 = `calc(100vw - ${(0, $c6b3f4cb88c9ac2a$export$f963aecf2d4465bd)} - ${(0, $c6b3f4cb88c9ac2a$export$f897e1ed9f8ed251)} - ${(0, $c6b3f4cb88c9ac2a$export$750459958906793)} - ${(0, $c6b3f4cb88c9ac2a$export$b44ab66843c05a69)} - ${$07a7fda3e3bc1ac3$export$8e357501548afe78 * 2}px) !important`;
const $07a7fda3e3bc1ac3$export$689a64196408e5c2 = 82;

});
// dimension vars
const $c6b3f4cb88c9ac2a$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $c6b3f4cb88c9ac2a$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $c6b3f4cb88c9ac2a$export$c103b605cd368aed = 'rightSidebarWidth';
const $c6b3f4cb88c9ac2a$export$fa34f417972d6341 = 'rightPanelWidth';
const $c6b3f4cb88c9ac2a$export$3a6a779d9181047c = 'topNavigationHeight';
const $c6b3f4cb88c9ac2a$export$bcd94a6a792e7f96 = 'bannerHeight';
const $c6b3f4cb88c9ac2a$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $c6b3f4cb88c9ac2a$export$344062f7cfc9528e = 'left-panel';
const $c6b3f4cb88c9ac2a$export$c7139cc2d6110b5f = 'right-panel';
const $c6b3f4cb88c9ac2a$export$238d30785c4bca84 = 'banner';
const $c6b3f4cb88c9ac2a$export$bec6dca2e63de4ae = 'top-navigation';
const $c6b3f4cb88c9ac2a$export$d1213e82613ff4df = 'content';
const $c6b3f4cb88c9ac2a$export$be83e7118304b28e = 56;
const $c6b3f4cb88c9ac2a$export$4a98ee0bd1ae362 = 56;
const $c6b3f4cb88c9ac2a$export$539e68c09584883a = 240;
const $c6b3f4cb88c9ac2a$export$b92df8810d2fcd01 = 280;
const $c6b3f4cb88c9ac2a$export$c3e41153b9288bcf = 368;
const $c6b3f4cb88c9ac2a$export$c4d6152f86ea28f6 = 368;
const $c6b3f4cb88c9ac2a$export$46acf8758e9e2636 = 20;
const $c6b3f4cb88c9ac2a$export$70740f5ad8360a78 = 16;
const $c6b3f4cb88c9ac2a$export$991d5285ad765a3d = 240;
const $c6b3f4cb88c9ac2a$export$6949d4f32b161684 = 200;
const $c6b3f4cb88c9ac2a$export$d6e7e8af042815bb = 350;
const $c6b3f4cb88c9ac2a$export$3749e1104328fde4 = 300;
const $c6b3f4cb88c9ac2a$export$1074d925b0b82be5 = 200;
const $c6b3f4cb88c9ac2a$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $c6b3f4cb88c9ac2a$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $c6b3f4cb88c9ac2a$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $c6b3f4cb88c9ac2a$export$70c702a8c5895f03 = 'data-grab-area-line';
const $c6b3f4cb88c9ac2a$export$48a43f91e4becf4e = 'data-grab-area';
const $c6b3f4cb88c9ac2a$export$dac2fb31a9f6844d = 'data-resize-button';
const $c6b3f4cb88c9ac2a$export$9ecd22db14e6c70e = 'data-resize-control';
const $c6b3f4cb88c9ac2a$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $c6b3f4cb88c9ac2a$export$206a08f7f8beb554 = 'Skip to:';
const $c6b3f4cb88c9ac2a$export$659ee746b31b360d = 'data-layout-container';
const $c6b3f4cb88c9ac2a$export$f963aecf2d4465bd = `var(--${$c6b3f4cb88c9ac2a$export$cbfb0f5b2869b17b}, 0px)`;
const $c6b3f4cb88c9ac2a$export$750459958906793 = `var(--${$c6b3f4cb88c9ac2a$export$fa34f417972d6341}, 0px)`;
const $c6b3f4cb88c9ac2a$export$f897e1ed9f8ed251 = `var(--${$c6b3f4cb88c9ac2a$export$a30f2e00489a8957}, 0px)`;
const $c6b3f4cb88c9ac2a$export$b44ab66843c05a69 = `var(--${$c6b3f4cb88c9ac2a$export$c103b605cd368aed}, 0px)`;
const $c6b3f4cb88c9ac2a$export$aeff86a16f13529 = `var(--${$c6b3f4cb88c9ac2a$export$3a6a779d9181047c}, 0px)`;
const $c6b3f4cb88c9ac2a$export$ed7cc0d417ee89e = `var(--${$c6b3f4cb88c9ac2a$export$bcd94a6a792e7f96}, 0px)`;
const $c6b3f4cb88c9ac2a$export$d2fa14f05b61e66 = `var(--${$c6b3f4cb88c9ac2a$export$b6744d31294864fd}, ${$c6b3f4cb88c9ac2a$export$991d5285ad765a3d}px)`;

// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// These variables are inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $bf1c59a4164b2d18$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT = 'var(--bannerHeight, 0px)';
const $bf1c59a4164b2d18$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT = 'var(--topNavigationHeight, 0px)';
const $bf1c59a4164b2d18$export$638757b621fbf475 = `${$bf1c59a4164b2d18$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT} + ${$bf1c59a4164b2d18$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT}`;
const $bf1c59a4164b2d18$export$d60454526e2281af = `(${$bf1c59a4164b2d18$export$638757b621fbf475})`;


parcelRegister("9aOeZ", function(module, exports) {

$parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", () => $02fee4f3a61bd031$export$ddf2fc82885279d);
const $02fee4f3a61bd031$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
const $02fee4f3a61bd031$export$39284f7325536558 = {
    ServiceDesk: 'SERVICE_DESK',
    Business: 'BUSINESS',
    Software: 'SOFTWARE'
};
const $02fee4f3a61bd031$export$1f66f9f05afa05a8 = {
    TeamManagedProject: 'TEAM_MANAGED_PROJECT',
    CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
};

});




parcelRegister("iXIhG", function(module, exports) {

$parcel$export(module.exports, "overviewDetailsResource", () => $3b47543f677664af$export$cd57aa046b167312);
$parcel$export(module.exports, "useOverview", () => $3b47543f677664af$export$626541a5c6f2cfa1);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $336Fd = parcelRequire("336Fd");
const $3b47543f677664af$var$RESOURCE_TYPE_KEY = 'BUSINESS_OVERVIEW_DETAILS';
const $3b47543f677664af$export$cd57aa046b167312 = (0, $l1VxS.createResource)({
    type: $3b47543f677664af$var$RESOURCE_TYPE_KEY,
    getKey: ({ match: match })=>`${$3b47543f677664af$var$RESOURCE_TYPE_KEY}_${match.params.overviewId}`,
    getData: async ({ match: match }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, $336Fd.fetchOverviewDetails)(cloudId, activationId, match.params.overviewId),
    maxAge: 3600000
});
const $3b47543f677664af$export$626541a5c6f2cfa1 = ()=>(0, $eJrcF.useResource)($3b47543f677664af$export$cd57aa046b167312);

});
parcelRegister("336Fd", function(module, exports) {

$parcel$export(module.exports, "fetchOverviewDetails", () => $3b2ca6dca30fb5cf$export$f0395142dbdd6c61);

var $cwZUV = parcelRequire("cwZUV");

var $ejRjJ = parcelRequire("ejRjJ");

var $942wy = parcelRequire("942wy");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $29CL1 = parcelRequire("29CL1");

const $3b2ca6dca30fb5cf$export$f0395142dbdd6c61 = async (cloudId, activationId, overviewId)=>{
    if (!overviewId) return null;
    try {
        const response = await (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $29CL1.QUERY),
                variables: {
                    id: (0, $cwZUV.JiraProjectOverviewAri).create({
                        siteId: cloudId,
                        activationId: activationId,
                        overviewId: overviewId
                    }).toString()
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        if (response?.data?.jira?.overview?.__typename === (0, $5b9dabc66daa95fc$export$62a5da7e3fa5ff88)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $ejRjJ.mapOverviewFragment)(response.data.jira.overview);
        throw new (0, $942wy.GraphQLErrors)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        response?.data?.jira?.overview ?? response.errors);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 410 means that overviews have been migrated to plans and
        // we will show a different message on the not found page.
        if (error?.statusCode === 410) throw error;
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessOverviewDetails', 'Something went wrong while fetching business overview details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'overviewDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessOverviewDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return null;
};

});
parcelRegister("ejRjJ", function(module, exports) {

$parcel$export(module.exports, "mapOverviewFragment", () => $b1720e1416bb124d$export$e79bf238de33eabb);
const $b1720e1416bb124d$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b1720e1416bb124d$var$mapProjectsNode = (edges)=>edges.map((edge)=>{
        const { node: node } = edge || {};
        if (node == null) return null;
        return {
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            isSimplified: node.projectStyle === $b1720e1416bb124d$var$SIMPLIFIED_PROJECT_STYLE,
            isFavorite: node.isFavourite === true,
            permissions: {
                assignIssues: false,
                administerProject: node.administerProject.canPerform,
                createIssues: node.createIssues.canPerform,
                deleteIssues: node.deleteIssues.canPerform,
                editIssues: node.editIssues.canPerform,
                linkIssues: node.linkIssues.canPerform,
                scheduleIssues: node.scheduleIssues.canPerform,
                // remove optional chaining when jwm-use-updated-graphql-querymutation-for-overview is cleaned up
                transitionIssues: node.transitionIssues?.canPerform === true,
                viewIssues: node.viewIssues.canPerform
            }
        };
    }).filter((project)=>project);
const $b1720e1416bb124d$export$e79bf238de33eabb = (overview)=>{
    const { id: id, name: name, theme: theme, projects: projectsData } = overview;
    const projects = $b1720e1416bb124d$var$mapProjectsNode(projectsData.edges);
    const unreachableProjectsCount = projectsData.edges.length - projects.length;
    return {
        id: id,
        name: name,
        theme: theme,
        projects: projects,
        unreachableProjectsCount: unreachableProjectsCount
    };
};

});

parcelRegister("29CL1", function(module, exports) {

$parcel$export(module.exports, "QUERY", () => $0ae7c7b180165261$export$2b91517d6d5b4365);

const $0ae7c7b180165261$export$2b91517d6d5b4365 = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${(0, $bfd590d07d509ee9$export$6f4bda7ea1dcf892)}
`;

});
const $bfd590d07d509ee9$export$6f4bda7ea1dcf892 = `
fragment OverviewGiraFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
  projects {
    edges {
      node {
        key
        projectId
        avatar {
          large
        }
        name
        projectType
        projectStyle
        isFavourite
        administerProject: action(type: EDIT_PROJECT_CONFIG) {
          canPerform
        }
        createIssues: action(type: CREATE_ISSUES) {
          canPerform
        }
        deleteIssues: action(type: DELETE_ISSUES) {
          canPerform
        }
        editIssues: action(type: EDIT_ISSUES) {
          canPerform
        }
        linkIssues: action(type: LINK_ISSUES) {
          canPerform
        }
        scheduleIssues: action(type: SCHEDULE_ISSUES) {
          canPerform
        }
        transitionIssues: action(type: TRANSITION_ISSUES) {
          canPerform
        }
        viewIssues: action(type: VIEW_ISSUES) {
          canPerform
        }
      }
    }
  }
}
`;


const $5b9dabc66daa95fc$export$62a5da7e3fa5ff88 = 'JiraWorkManagementGiraOverview';



parcelRegister("ebuR2", function(module, exports) {

$parcel$export(module.exports, "DEPRECATED_DO_NOT_USE_projectDetailsResource", () => $a81e3a6968ecf224$export$ced53bf9d9551fef);
$parcel$export(module.exports, "useProject_DEPRECATED_DO_NOT_USE", () => $a81e3a6968ecf224$export$97def3841413167f);
/* eslint-disable camelcase */ 
var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $94I3A = parcelRequire("94I3A");
const $a81e3a6968ecf224$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
const $a81e3a6968ecf224$export$ced53bf9d9551fef = (0, $l1VxS.createResource)({
    type: $a81e3a6968ecf224$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$a81e3a6968ecf224$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        return (0, $94I3A.fetchProjectDetails)(cloudId, projectKey, projectId);
    },
    maxAge: 3600000
});
const $a81e3a6968ecf224$export$97def3841413167f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($a81e3a6968ecf224$export$ced53bf9d9551fef);
    return {
        data: data?.currentProject ?? null,
        loading: loading,
        error: error
    };
};

});
parcelRegister("94I3A", function(module, exports) {

$parcel$export(module.exports, "fetchProjectDetails", () => $afb0ef71187f4894$export$78aa221476efa1c6);

var $3osLr = parcelRequire("3osLr");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");


var $52UtB = parcelRequire("52UtB");
const $afb0ef71187f4894$var$EMPTY_VALUE = {};
const $afb0ef71187f4894$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
    const projectIdOrKey = projectId || projectKey;
    if (!projectIdOrKey) return null;
    try {
        const response = await (0, $jGzN3.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
            body: JSON.stringify({
                query: (0, $3833a2a8ead613b5$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    usingProjectKey: projectId == null,
                    projectId: projectId != null ? (0, $3osLr.JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: projectId
                    }).toString() : ''
                }
            })
        });
        return (0, $52UtB.transformData)(response.data, projectIdOrKey);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'projectDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessProjectDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return $afb0ef71187f4894$var$EMPTY_VALUE;
};

});
const $3833a2a8ead613b5$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $3833a2a8ead613b5$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
  }
}
${$3833a2a8ead613b5$var$PROJECT_FRAGMENT}
`;

parcelRegister("52UtB", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $e1a6d24fb0f7d7ff$export$3ceb62baab058c6b);
const $e1a6d24fb0f7d7ff$var$mapProjectNode = (node)=>{
    if (node == null) return null;
    return {
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.simplified,
        isFavorite: node.favorite === true,
        permissions: {
            administerProject: node.administerProject.canPerform,
            createIssues: node.createIssues.canPerform,
            viewIssues: node.viewIssues.canPerform
        }
    };
};
const $e1a6d24fb0f7d7ff$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
        currentProject: $e1a6d24fb0f7d7ff$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $e1a6d24fb0f7d7ff$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
        projectIdOrKey: projectIdOrKey
    });

});



parcelRegister("8tbnc", function(module, exports) {

$parcel$export(module.exports, "licenseDetailsResource_DEPRECATED_DO_NOT_USE", () => $70398e7926820970$export$92c4069b5349d086);
$parcel$export(module.exports, "useIsPremiumUserSeat", () => $70398e7926820970$export$90749419e9042370);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


var $bGJcU = parcelRequire("bGJcU");
const $70398e7926820970$export$92c4069b5349d086 = (0, $l1VxS.createResource)({
    type: 'BUSINESS_LICENSE_DETAILS',
    getKey: ()=>'BUSINESS_LICENSE_DETAILS',
    getData: async (_routerContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        return (0, $bGJcU.fetchLicenseDetails)((0, $ba7d1bcdd3e5eca1$export$2b91517d6d5b4365), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity,
    isCritical: true
});
const $70398e7926820970$export$90749419e9042370 = ()=>{
    const { data: data } = (0, $eJrcF.useResource)($70398e7926820970$export$92c4069b5349d086);
    return Boolean(data?.isPremiumUserSeat);
};

});
const $ba7d1bcdd3e5eca1$export$2b91517d6d5b4365 = `
query JiraBusinessLicenseDetails($cloudId:ID!) {
  jira {
    jwmLicensing(cloudId: $cloudId) {
      currentUserSeatEdition
    }
  }
}
`;

parcelRegister("bGJcU", function(module, exports) {

$parcel$export(module.exports, "fetchLicenseDetails", () => $ebc3c21a42e05a54$export$ec058a82eccb31e);

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $ebc3c21a42e05a54$var$EMPTY_RESPONSE = {
    isPremiumUserSeat: false
};
const $ebc3c21a42e05a54$export$ec058a82eccb31e = async (query, { cloudId: cloudId })=>{
    try {
        const response = await (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        return {
            isPremiumUserSeat: response.data?.jira?.jwmLicensing?.currentUserSeatEdition === 'PREMIUM'
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessLicenseDetails', 'Something went wrong while fetching the license details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $gYnSx.default)({
            meta: {
                id: 'licenseDetailsResource',
                packageName: 'jiraRouterResourcesBusinessLicenseDetails',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $ebc3c21a42e05a54$var$EMPTY_RESPONSE;
};

});


parcelRegister("ho9E1", function(module, exports) {

$parcel$export(module.exports, "projectCreatePermissionsResource", () => $684d3b239b1e0d5f$export$f6c05eaea53ab4ae);
$parcel$export(module.exports, "useProjectCreatePermissionsResource", () => $684d3b239b1e0d5f$export$2bd0d3b374549a68);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $684d3b239b1e0d5f$var$getDataLoader = ()=>(parcelRequire("bGnEW"));
const $684d3b239b1e0d5f$export$f6c05eaea53ab4ae = (0, $l1VxS.createResource)({
    type: (0, $edca60a3af8f4bf8$export$8bc44dee8c6d28f),
    getKey: ()=>'state',
    getDataLoader: $684d3b239b1e0d5f$var$getDataLoader,
    maxAge: Infinity
});
const $684d3b239b1e0d5f$export$2bd0d3b374549a68 = ()=>(0, $eJrcF.useResource)($684d3b239b1e0d5f$export$f6c05eaea53ab4ae);

});
const $edca60a3af8f4bf8$export$8bc44dee8c6d28f = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';

parcelRegister("bGnEW", function(module, exports) {

let $8815f833d22d5050$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8815f833d22d5050$var$load("8k4aQ").then(()=>parcelRequire('jRDDZ'));

});


parcelRegister("1G20J", function(module, exports) {

$parcel$export(module.exports, "projectThemeResource", () => $08721476ea54ea75$export$84730adce8987203);

var $5V48N = parcelRequire("5V48N");

var $bBtQo = parcelRequire("bBtQo");

var $9FYIg = parcelRequire("9FYIg");

var $8Mxto = parcelRequire("8Mxto");
const $08721476ea54ea75$export$84730adce8987203 = (0, $8Mxto.withGiraAggAnonSsrFix)((0, $9FYIg.createRelayResource)({
    type: 'JIRA_PROJECT_THEME',
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $5V48N.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectKey ?? projectId ?? ''
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    },
    isCritical: true
}));

});
parcelRegister("5V48N", function(module, exports) {

$parcel$export(module.exports, "default", () => $d340f7d465945734$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a80e3120b80c99e5f371c683e47c1272>>
 * @relayHash 425f234e57bb5ee35d5bff67f4bb926f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 659f6d85a390f6f3ee8492f86debbfeaed75e90b37b222e25a49822daf422a5a

var $37Ewn = parcelRequire("37Ewn");
const $d340f7d465945734$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaClientId"
            },
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaExternalEndpointUrl"
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ThemeSetterQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v3 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ThemeSetterBackground"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ThemeSetterQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraActiveBackgroundDetailsResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "colorValue"
                                        }
                                    ],
                                    "type": "JiraColorBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "gradientValue"
                                        }
                                    ],
                                    "type": "JiraGradientBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraCustomBackground",
                                            "kind": "LinkedField",
                                            "name": "customBackground",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaApiFileId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "durationInSeconds",
                                                            "value": 900
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "mediaReadToken",
                                                    "storageKey": "mediaReadToken(durationInSeconds:900)"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceIdentifier"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "altText"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "dominantColor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "brightness"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraMediaBackground"
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "659f6d85a390f6f3ee8492f86debbfeaed75e90b37b222e25a49822daf422a5a",
            "metadata": {},
            "name": "ThemeSetterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d340f7d465945734$var$node.hash = "9864ab22015f44482ad59ad489f945e0";
(0, $37Ewn.PreloadableQueryRegistry).set($d340f7d465945734$var$node.params.id, $d340f7d465945734$var$node);
var $d340f7d465945734$export$2e2bcd8739ae039 = $d340f7d465945734$var$node;

});

parcelRegister("8Mxto", function(module, exports) {

$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $0eceed5dfd22dafd$export$f4b29e78f4c0a526);
const $0eceed5dfd22dafd$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});



parcelRegister("3belI", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJwmRoute", () => $f4fce0a70da28628$export$1377e2cf39b3ae6a);
const $f4fce0a70da28628$export$1377e2cf39b3ae6a = {
    name: 'classic-business-archived-work-items',
    path: '/jira/core/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("2PFkC", function(module, exports) {

$parcel$export(module.exports, "arjCalendarEmbedRouteEntry", () => $91f0557b62d46e4c$export$309ed92381819b04);

var $eJOHy = parcelRequire("eJOHy");


var $k8mcw = parcelRequire("k8mcw");

var $g8uYY = parcelRequire("g8uYY");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $cxQGT = parcelRequire("cxQGT");

var $5rPHm = parcelRequire("5rPHm");

var $dsh9d = parcelRequire("dsh9d");

var $i9Kzd = parcelRequire("i9Kzd");
const $91f0557b62d46e4c$var$planCalendarEmbedRouteEntry = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $i9Kzd.calendarEntryPoint)
});
const $91f0557b62d46e4c$export$309ed92381819b04 = (0, $6xToB.createEntry)((0, $5rPHm.arjCalendarEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-calendar-embed',
        skeleton: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dsh9d.CalendarSkeleton), null);
        },
        entryPoint () {
            (0, $k8mcw.setCapability)((0, $652f5f63189f3e2a$export$f999749ac7a2cd1));
            return $91f0557b62d46e4c$var$planCalendarEmbedRouteEntry;
        },
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $cxQGT.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        meta: {
            capability: (0, $652f5f63189f3e2a$export$f999749ac7a2cd1)
        },
        forPaint: []
    }));

});
const $652f5f63189f3e2a$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $652f5f63189f3e2a$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $652f5f63189f3e2a$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $652f5f63189f3e2a$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $652f5f63189f3e2a$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $652f5f63189f3e2a$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $652f5f63189f3e2a$export$4695c1a423ffe431 = 'DASHBOARD';
const $652f5f63189f3e2a$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $652f5f63189f3e2a$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("4KrIc", function(module, exports) {

$parcel$export(module.exports, "advancedRoadmapsReduxStoreStateResource", () => $ec1729c125d0f001$export$6ca262338f199e4b);
$parcel$export(module.exports, "advancedRoadmapsScenarioIdResource", () => $ec1729c125d0f001$export$aec847b4ce72891);
$parcel$export(module.exports, "advancedRoadmapsPlanPageInitialChecksResource", () => $ec1729c125d0f001$export$7431e46c7ad56c3d);
$parcel$export(module.exports, "advancedRoadmapsPlanReportPageInitialChecksResource", () => $ec1729c125d0f001$export$bf0c5395c73cc255);
$parcel$export(module.exports, "advancedRoadmapsLastVisitedProgramBoardIdResource", () => $ec1729c125d0f001$export$f5b159e1fb19e04e);

var $jPROM = parcelRequire("jPROM");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");

var $aV23b = parcelRequire("aV23b");

var $7hVvO = parcelRequire("7hVvO");

const $ec1729c125d0f001$export$6ca262338f199e4b = (0, $l1VxS.createResource)({
    type: 'ADVANCED_ROADMAPS_REDUX_STORE_STATE',
    getKey: ({ match: match })=>{
        const { params: params, query: query } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        if (params.reportId != null) return params.reportId;
        if (query.r != null) return query.r;
        /**
		 * resource getKey will be called whenever URL changes
		 */ return '';
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getData: async ()=>undefined,
    isBrowserOnly: true,
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $ec1729c125d0f001$export$aec847b4ce72891 = (0, $l1VxS.createResource)({
    type: (0, $467ecd9a8a47f90a$export$a0893d695ebee984),
    getKey: ({ query: query })=>`scenarioId_${query.id}`,
    getData: async ({ query: query })=>{
        const planId = query.id;
        const { id: id } = await (0, $jGzN3.performGetRequest)(`/rest/jpo/1.0/scenarios/${planId}`);
        return {
            scenarioId: id
        };
    },
    maxAge: 0
});
const $ec1729c125d0f001$export$7431e46c7ad56c3d = (0, $l1VxS.createResource)({
    type: (0, $467ecd9a8a47f90a$export$68390102872336b6),
    getKey: ({ match: match })=>{
        const { planId: planId, scenarioId: scenarioId } = match.params;
        return `planPageInitialChecks_${planId != null ? planId : ''}_${scenarioId != null ? scenarioId : ''}`;
    },
    getData: async ({ match: match }, { tenantContext: tenantContext })=>{
        if (!(0, $aV23b.checkAuthentication)(tenantContext)) throw (0, $7hVvO.createResourceError)({
            component: 'router-resources.advanced-roadmaps-plan.initial-checks.get-data',
            message: 'Current user is not authenticated',
            name: 'AuthenticationError',
            skipSentry: true
        });
        const { planId: planId, scenarioId: scenarioId } = match.params;
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"null"' and '"undefined"' have no overlap.
        if (planId == null || planId === 'null' && planId === 'undefined' && planId === '') throw new Error('Plan cannot be loaded without a planId');
        let url = `/rest/jpo/1.0/plans/${planId}/checks`;
        if (scenarioId != null && scenarioId !== 'null' && scenarioId !== 'undefined' && scenarioId !== '') url = `${url}?sid=${scenarioId}`;
        const response = await (0, $jGzN3.performGetRequest)(url);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $ec1729c125d0f001$export$bf0c5395c73cc255 = (0, $l1VxS.createResource)({
    type: (0, $467ecd9a8a47f90a$export$a00e869cafd63140),
    getKey: ({ match: match })=>`planReportPageInitialChecks_${match.params.reportId == null ? '' : match.params.reportId}`,
    getData: async ({ match: match }, { tenantContext: tenantContext })=>{
        if (!(0, $aV23b.checkAuthentication)(tenantContext)) throw (0, $7hVvO.createResourceError)({
            component: 'router-resources.advanced-roadmaps-plan.report-initial-checks.get-data',
            message: 'Current user is not authenticated',
            name: 'AuthenticationError',
            skipSentry: true
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const initialPlanChecksPromise = window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        delete window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        if (initialPlanChecksPromise) {
            const response = await initialPlanChecksPromise;
            return response;
        }
        const { reportId: reportId } = match.params;
        const response = await (0, $jGzN3.performGetRequest)(`/rest/jpo/1.0/reportinfo/generic/${reportId == null ? '' : reportId}/checks`);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $ec1729c125d0f001$export$f5b159e1fb19e04e = (0, $l1VxS.createResource)({
    type: (0, $467ecd9a8a47f90a$export$179a0d35e95a4d61),
    getKey: ({ query: query, match: match })=>`lastVisitedProgramBoardId_${query.id}_${match.params.planId}_${match.params.scenarioId}`,
    getData: async ({ match: match })=>{
        // Sometimes currentPlanId isn't yet ready - we retry a few times to check if it has loaded in before making the request
        const RETRIES = 3;
        const DELAY = 500;
        const attemptFetch = async (remainingRetries)=>{
            const currentPlanId = match.params.planId;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(currentPlanId)) {
                const defaultBoardIdResponse = await (0, $jGzN3.performGetRequest)(`/rest/jpo/2.0/plans/${currentPlanId}/increments/default`);
                if (defaultBoardIdResponse === null) return {
                    boardId: null
                };
                const { id: id } = defaultBoardIdResponse;
                return {
                    boardId: id
                };
            }
            if (remainingRetries > 0) {
                await new Promise((resolve)=>setTimeout(resolve, DELAY));
                return attemptFetch(remainingRetries - 1);
            }
            throw new Error('Attempted to get the last visited program board of a plan without a plan id after multiple retries.');
        };
        return attemptFetch(RETRIES);
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});

});
parcelRegister("7hVvO", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $57ba68f5ed9efef2$export$13487d18466bc8a5);

var $eSnSE = parcelRequire("eSnSE");
class $57ba68f5ed9efef2$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $57ba68f5ed9efef2$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $57ba68f5ed9efef2$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});

const $467ecd9a8a47f90a$export$68390102872336b6 = 'ADVANCED_ROADMAPS_PLAN_INITIAL_CHECKS';
const $467ecd9a8a47f90a$export$a00e869cafd63140 = 'ADVANCED_ROADMAPS_REPORT_INITIAL_CHECKS';
const $467ecd9a8a47f90a$export$a0893d695ebee984 = 'ADVANCED_ROADMAPS_SCENARIO_ID';
const $467ecd9a8a47f90a$export$179a0d35e95a4d61 = 'ADVANCED_ROADMAPS_LAST_VISITED_PROGRAM_BOARD_ID';


parcelRegister("5rPHm", function(module, exports) {

$parcel$export(module.exports, "arjCalendarEmbedRoute", () => $1780fc2d96c15a78$export$30779cab3c860456);
const $1780fc2d96c15a78$export$30779cab3c860456 = {
    name: 'software-plan-calendar-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/calendar/embed'
};

});

parcelRegister("dsh9d", function(module, exports) {

$parcel$export(module.exports, "CalendarSkeleton", () => $a30845490434a605$export$ebc7c47cc535837e);
$parcel$export(module.exports, "CalendarEmbedSkeleton", () => $a30845490434a605$export$bf543fe31d33292e);
$parcel$export(module.exports, "CalendarNoHeaderSkeleton", () => $a30845490434a605$export$504e7b05f3c54bf2);
/* CalendarSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $4mymy = parcelRequire("4mymy");

var $cfNRO = parcelRequire("cfNRO");

var $953kO = parcelRequire("953kO");
const $a30845490434a605$var$customCssStyles = null;
const $a30845490434a605$export$ebc7c47cc535837e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4mymy)))
    });
const $a30845490434a605$export$bf543fe31d33292e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cfNRO)))
    });
const $a30845490434a605$export$504e7b05f3c54bf2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($953kO))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("4mymy", function(module, exports) {
module.exports = new URL("calendar-app-skeleton.tpl.77b09222.svg", import.meta.url).toString();

});

parcelRegister("cfNRO", function(module, exports) {
module.exports = new URL("calendar-embed-app-skeleton.tpl.29c9a641.svg", import.meta.url).toString();

});

parcelRegister("953kO", function(module, exports) {
module.exports = new URL("calendar-no-header-skeleton.tpl.d6779107.svg", import.meta.url).toString();

});


parcelRegister("i9Kzd", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $1364aab682a9549d$export$19cf4b398f638dc6);

var $7jTnu = parcelRequire("7jTnu");

var $dW8bA = parcelRequire("dW8bA");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");
const $1364aab682a9549d$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED = 'software-plan-calendar-embed';
const $1364aab682a9549d$var$SETTINGS_STORAGE_KEY = 'plans_calendar_view_settings';
function $1364aab682a9549d$var$getViewSettings(key) {
    try {
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
function $1364aab682a9549d$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
    return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
}
function $1364aab682a9549d$var$getStorageKeyFromScope(context) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
    return `${LOCALSTORAGE_KEY_PREFIX}/plan/${planId}/scenario/${scenarioId}`;
}
function $1364aab682a9549d$var$getStorageValueFromScope(key) {
    const storedData = globalThis.localStorage?.getItem(key) || '';
    return storedData;
}
function $1364aab682a9549d$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $1364aab682a9549d$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $1364aab682a9549d$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const { cloudId: cloudId, activationId: activationId } = tenantContext;
    const planScenarioAri = $1364aab682a9549d$var$toPlanScenarioAri({
        siteId: cloudId,
        activationId: activationId,
        planId: String(planId),
        scenarioId: String(scenarioId)
    });
    return {
        type: 'plan',
        ids: [
            planScenarioAri
        ]
    };
}
function $1364aab682a9549d$var$buildScopeInput(scope) {
    return {
        ids: scope.ids
    };
}
function $1364aab682a9549d$var$buildViewId(scope) {
    // plan scenario ARI is the view id
    return scope.ids?.[0] ?? '';
}
function $1364aab682a9549d$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $1364aab682a9549d$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $1364aab682a9549d$var$toCalendarWeekStart(weekStart) {
    switch(weekStart){
        case 'sunday':
            return 'sunday';
        case 'saturday':
            return 'saturday';
        default:
            return 'monday';
    }
}
function $1364aab682a9549d$var$toCalendarColorBy(colorBy) {
    switch(colorBy){
        case 'none':
            return 'none';
        case 'status':
            return 'status';
        default:
            return 'status';
    }
}
function $1364aab682a9549d$var$toCalendarViewRange(view) {
    switch(view){
        case 'week':
            return 'week';
        default:
            return 'month';
    }
}
function $1364aab682a9549d$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField, viewId: viewId }) {
    return {
        date: $1364aab682a9549d$var$toMidnightUTCString(selectedDate),
        mode: $1364aab682a9549d$var$toViewMode(viewRange),
        weekStart: $1364aab682a9549d$var$toWeekStart(weekStartsOn),
        ...(0, $7jTnu.fg)('jira_calendar_load_more_pagination') ? {
            startDateField: startDateField,
            endDateField: endDateField
        } : {},
        viewId: viewId
    };
}
function $1364aab682a9549d$var$buildIssuesSearchInput(storageKey, filter, isEmbed) {
    return {
        additionalFilterQuery: isEmbed === true ? filter ?? '' : filter || $1364aab682a9549d$var$getStorageValueFromScope(storageKey)
    };
}
function $1364aab682a9549d$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $1364aab682a9549d$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $1364aab682a9549d$var$buildCalendarCrossProjectVersionsInput() {
    return {
        statuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $1364aab682a9549d$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}
function $1364aab682a9549d$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam, colorBy, viewRange) {
    if (hideWeekends || hideSprints || hideVersions || hideIssues || hideIssueKey || weekStartsOnQueryParam || colorBy || viewRange) return {
        hideWeekends: hideWeekends === 'true' || undefined,
        hideSprints: hideSprints === 'true' || undefined,
        hideVersions: hideVersions === 'true' || undefined,
        hideIssues: hideIssues === 'true' || undefined,
        hideIssueKey: hideIssueKey === 'true' || undefined,
        weekStartsOn: $1364aab682a9549d$var$toCalendarWeekStart(weekStartsOnQueryParam),
        colorBy: $1364aab682a9549d$var$toCalendarColorBy(colorBy),
        viewRange: $1364aab682a9549d$var$toCalendarViewRange(viewRange)
    };
    return undefined;
}

const $1364aab682a9549d$export$19cf4b398f638dc6 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("4lo5g")), {
        moduleId: "53aec496",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $1364aab682a9549d$var$createScope(entryPointRouteParams);
        const scopeInput = $1364aab682a9549d$var$buildScopeInput(scope);
        const { date: date, filter: filter, hideWeekends: hideWeekends, hideSprints: hideSprints, hideVersions: hideVersions, hideIssues: hideIssues, hideIssueKey: hideIssueKey, weekStartsOn: weekStartsOnQueryParam, colorBy: colorByQueryParam, viewRange: viewRangeParam } = context.query;
        const selectedDate = $1364aab682a9549d$var$toDate(date);
        const hasFilterQueryParam = Boolean(filter);
        const routeName = context.route.name;
        const settingsQueryParams = $1364aab682a9549d$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam, colorByQueryParam, viewRangeParam);
        const isEmbed = routeName === $1364aab682a9549d$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED;
        const settings = (0, $7jTnu.fg)('jira_calendar_load_more_pagination') ? $1364aab682a9549d$var$getViewSettings($1364aab682a9549d$var$SETTINGS_STORAGE_KEY) : undefined;
        const viewRange = (0, $7jTnu.fg)('enable_week_mode_in_plan_calendar') ? settingsQueryParams?.viewRange ?? settings?.viewRange ?? 'month' : 'month';
        const weekStartsOn = (0, $7jTnu.fg)('jira_calendar_load_more_pagination') ? settingsQueryParams?.weekStartsOn ?? settings?.weekStartsOn ?? 'monday' : 'monday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const storageKey = $1364aab682a9549d$var$getStorageKeyFromScope(context);
        const viewId = $1364aab682a9549d$var$buildViewId(scope);
        const filterQuery = $1364aab682a9549d$var$buildIssuesSearchInput(storageKey, filter, isEmbed);
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $dW8bA.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: scopeInput,
                        configurationInput: $1364aab682a9549d$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField,
                            viewId: viewId
                        }),
                        issuesPageSize: 50,
                        issuesSearchInput: filterQuery,
                        unscheduledIssuesSearchInput: $1364aab682a9549d$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $1364aab682a9549d$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $1364aab682a9549d$var$buildSprintsSearchInput(),
                        crossProjectVersionsSearchInput: $1364aab682a9549d$var$buildCalendarCrossProjectVersionsInput(),
                        viewId: viewId,
                        skipSprintSearch: false,
                        skipPanelIssueSearch: true,
                        skipCrossProjectVersionSearch: false,
                        schedulePermissionsEnabled: (0, $7jTnu.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $7jTnu.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV2Search: false,
                        includeRecurrenceIndicator: false,
                        pageLoadMoreEnabledViewSettings: (0, $7jTnu.fg)('jira_calendar_load_more_pagination_view_settings'),
                        skipUserPreferences: false
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                storageKey: storageKey,
                hasFilterQueryParam: hasFilterQueryParam,
                routeName: routeName,
                settingsQueryParams: settingsQueryParams,
                filterQuery: filterQuery.additionalFilterQuery
            }
        };
    }
});

});
parcelRegister("dW8bA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7093dfa18dad5a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b687ffb017961a48e3144f811f0de4c>>
 * @relayHash ddee55a803a909e0d77e00661d88dad1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7879eefdc45aba56b78d8d929aa3dbf71206455f93a7add99d76a75facdd1c24
const $d7093dfa18dad5a5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7879eefdc45aba56b78d8d929aa3dbf71206455f93a7add99d76a75facdd1c24",
        "metadata": {},
        "name": "ui_jiraCalendarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d7093dfa18dad5a5$export$2e2bcd8739ae039 = $d7093dfa18dad5a5$var$node;

});

parcelRegister("4lo5g", function(module, exports) {

let $329bce21550527c7$var$load = (parcelRequire("gLHA4"))(4);





module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $329bce21550527c7$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $329bce21550527c7$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $329bce21550527c7$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $329bce21550527c7$var$load("kZxiU")
        ]);
    }),
    $329bce21550527c7$var$load("1VRB2"),
    $329bce21550527c7$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("cCx5o"), 4)),
    $329bce21550527c7$var$load("7vqGd"),
    $329bce21550527c7$var$load("1Y4bq"),
    $329bce21550527c7$var$load("eDzss"),
    $329bce21550527c7$var$load("2WMml")
]).then(()=>parcelRequire('7wJ5d'));

});
parcelRegister("c5iyL", function(module, exports) {
"use strict";

var $5VrpE = parcelRequire("5VrpE");
module.exports = $5VrpE(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("5VrpE", function(module, exports) {
"use strict";
let $45078a36e59142a3$var$cachedBundles = {};
let $45078a36e59142a3$var$cachedPreloads = {};
let $45078a36e59142a3$var$cachedPrefetches = {};
function $45078a36e59142a3$var$getCache(type) {
    switch(type){
        case 'preload':
            return $45078a36e59142a3$var$cachedPreloads;
        case 'prefetch':
            return $45078a36e59142a3$var$cachedPrefetches;
        default:
            return $45078a36e59142a3$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $45078a36e59142a3$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});





parcelRegister("7lkHZ", function(module, exports) {

$parcel$export(module.exports, "arjDependenciesEmbedRouteEntry", () => $2378ab8bb8366069$export$2506a377ba649c46);

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $cxQGT = parcelRequire("cxQGT");

var $5R5ZI = parcelRequire("5R5ZI");

var $7jTnu = parcelRequire("7jTnu");

var $g8uYY = parcelRequire("g8uYY");

var $3nt6g = parcelRequire("3nt6g");

var $j66XX = parcelRequire("j66XX");
const $2378ab8bb8366069$var$planDependenciesReportEmbedRouteEntry = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $3nt6g.planDependenciesReportEntryPoint)
});
const $2378ab8bb8366069$export$2506a377ba649c46 = (0, $6xToB.createEntry)((0, $5R5ZI.arjDependenciesEmbedRoute), ()=>({
        group: 'software',
        component: (0, $j66XX.PlanDependenciesReportEmbedPage),
        entryPoint: ()=>(0, $7jTnu.fg)('migrate_plans_to_entrypoints') ? $2378ab8bb8366069$var$planDependenciesReportEmbedRouteEntry : undefined,
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $cxQGT.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $j66XX.LazyPlanDependenciesReportEmbed)
        ]
    }));

});
parcelRegister("5R5ZI", function(module, exports) {

$parcel$export(module.exports, "arjDependenciesEmbedRoute", () => $959c7b2a9e7b4aac$export$96aaf89753980215);
const $959c7b2a9e7b4aac$export$96aaf89753980215 = {
    name: 'software-plan-dependencies-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies/embed'
};

});

parcelRegister("3nt6g", function(module, exports) {

$parcel$export(module.exports, "planDependenciesReportEntryPoint", () => $a2960b3abd5afd4a$export$e4ba4cc5a2304191);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $a2960b3abd5afd4a$export$e4ba4cc5a2304191 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("gwcSN")), {
        moduleId: "1a1a3500",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gwcSN", function(module, exports) {

let $c069a0c74c02efdc$var$load = (parcelRequire("gLHA4"))(4);





module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $c069a0c74c02efdc$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $c069a0c74c02efdc$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $c069a0c74c02efdc$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $c069a0c74c02efdc$var$load("kZxiU")
        ]);
    }),
    $c069a0c74c02efdc$var$load("7vqGd"),
    $c069a0c74c02efdc$var$load("1Y4bq"),
    $c069a0c74c02efdc$var$load("1VRB2"),
    $c069a0c74c02efdc$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("8OTTY"), 4)),
    $c069a0c74c02efdc$var$load("eDzss"),
    $c069a0c74c02efdc$var$load("lnsJE")
]).then(()=>parcelRequire('16LzX'));

});


parcelRegister("j66XX", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSummaryEmbed", () => $15d5d2cd9dd1f407$export$b0feb6e650be3c8c);
$parcel$export(module.exports, "PlanSummaryEmbedPage", () => $15d5d2cd9dd1f407$export$a37f296d90476a73);
$parcel$export(module.exports, "LazyPlanDependenciesReportEmbed", () => $15d5d2cd9dd1f407$export$48681ab0b4246654);
$parcel$export(module.exports, "PlanDependenciesReportEmbedPage", () => $15d5d2cd9dd1f407$export$4ece7fb6c15037f9);
$parcel$export(module.exports, "LazyPlanIncrementEmbed", () => $15d5d2cd9dd1f407$export$51f2083dff1ee684);
$parcel$export(module.exports, "PlanIncrementEmbedPage", () => $15d5d2cd9dd1f407$export$a2ae011b90c17927);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $15d5d2cd9dd1f407$export$b0feb6e650be3c8c = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("21dEL"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
});
const $15d5d2cd9dd1f407$export$a37f296d90476a73 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $15d5d2cd9dd1f407$export$b0feb6e650be3c8c,
        pageId: "plan-summary-embed-old",
        shouldShowSpinner: true
    });

const $15d5d2cd9dd1f407$export$48681ab0b4246654 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("1TpUQ")).then(({ PlanDependenciesReportWithoutPageHeader: PlanDependenciesReportWithoutPageHeader })=>PlanDependenciesReportWithoutPageHeader)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index-old.tsx"
});
const $15d5d2cd9dd1f407$export$4ece7fb6c15037f9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $15d5d2cd9dd1f407$export$48681ab0b4246654,
        pageId: "plan-dependencies-report-embed-old",
        shouldShowSpinner: true
    });

const $15d5d2cd9dd1f407$export$51f2083dff1ee684 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("k6MXE")).then(({ PlanIncrementWithoutPageHeader: PlanIncrementWithoutPageHeader })=>PlanIncrementWithoutPageHeader)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index-old.tsx"
});
const $15d5d2cd9dd1f407$export$a2ae011b90c17927 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $15d5d2cd9dd1f407$export$51f2083dff1ee684,
        pageId: "plan-increment-embed-old",
        shouldShowSpinner: true
    });

});
parcelRegister("21dEL", function(module, exports) {

let $178644af23923f7b$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    $178644af23923f7b$var$load("1VRB2"),
    $178644af23923f7b$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("9XBeg"), 4)),
    $178644af23923f7b$var$load("eFuC9")
]).then(()=>parcelRequire('9l7Vm'));

});

parcelRegister("1TpUQ", function(module, exports) {

let $160f07d8116fc9d3$var$load = (parcelRequire("gLHA4"))(4);





module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $160f07d8116fc9d3$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $160f07d8116fc9d3$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $160f07d8116fc9d3$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $160f07d8116fc9d3$var$load("kZxiU")
        ]);
    }),
    $160f07d8116fc9d3$var$load("7vqGd"),
    $160f07d8116fc9d3$var$load("1Y4bq"),
    $160f07d8116fc9d3$var$load("1VRB2"),
    $160f07d8116fc9d3$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("e7EQd"), 4)),
    $160f07d8116fc9d3$var$load("eDzss"),
    $160f07d8116fc9d3$var$load("g3K1D")
]).then(()=>parcelRequire('5SP4f'));

});

parcelRegister("k6MXE", function(module, exports) {

let $ea3a58da497ce6ca$var$load = (parcelRequire("gLHA4"))(4);






module.exports = Promise.all([
    (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $ea3a58da497ce6ca$var$load("esKGV")
        ]);
    }, function() {
        return Promise.all([
            $ea3a58da497ce6ca$var$load("7uqQP")
        ]);
    }),
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $ea3a58da497ce6ca$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $ea3a58da497ce6ca$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ea3a58da497ce6ca$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $ea3a58da497ce6ca$var$load("kZxiU")
        ]);
    }),
    $ea3a58da497ce6ca$var$load("7vqGd"),
    $ea3a58da497ce6ca$var$load("1Y4bq"),
    $ea3a58da497ce6ca$var$load("k4gbU"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("65NSa"), 4)),
    $ea3a58da497ce6ca$var$load("1VRB2"),
    $ea3a58da497ce6ca$var$load("bABhq"),
    $ea3a58da497ce6ca$var$load("eDzss"),
    $ea3a58da497ce6ca$var$load("2xOw9")
]).then(()=>parcelRequire('6cTeO'));

});



parcelRegister("fxZdD", function(module, exports) {

$parcel$export(module.exports, "arjIncrementEmbedRouteEntry", () => $f68fda2c44f7fd57$export$3feed0b4da010c52);

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $cxQGT = parcelRequire("cxQGT");

var $krd26 = parcelRequire("krd26");

var $7jTnu = parcelRequire("7jTnu");

var $g8uYY = parcelRequire("g8uYY");

var $eDyDZ = parcelRequire("eDyDZ");

var $j66XX = parcelRequire("j66XX");
const $f68fda2c44f7fd57$var$planProgramEmbedRouteEntry = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $eDyDZ.planIncrementEntryPoint)
});
const $f68fda2c44f7fd57$export$3feed0b4da010c52 = (0, $6xToB.createEntry)((0, $krd26.arjIncrementEmbedRoute), ()=>({
        group: 'software',
        component: (0, $j66XX.PlanIncrementEmbedPage),
        entryPoint: ()=>(0, $7jTnu.fg)('migrate_plans_to_entrypoints') ? $f68fda2c44f7fd57$var$planProgramEmbedRouteEntry : undefined,
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $cxQGT.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $j66XX.LazyPlanIncrementEmbed)
        ]
    }));

});
parcelRegister("krd26", function(module, exports) {

$parcel$export(module.exports, "arjIncrementEmbedRoute", () => $841f36b364b459fb$export$88913ef2dfa37bc1);
const $841f36b364b459fb$export$88913ef2dfa37bc1 = {
    name: 'software-plan-increment-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId/embed'
};

});

parcelRegister("eDyDZ", function(module, exports) {

$parcel$export(module.exports, "planIncrementEntryPoint", () => $951d2e71208e83e4$export$72cc8a7d91a08ace);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $951d2e71208e83e4$export$72cc8a7d91a08ace = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("hAc9Y")), {
        moduleId: "6d0a9b0d",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hAc9Y", function(module, exports) {

let $cccf3b2dbde8e10c$var$load = (parcelRequire("gLHA4"))(4);






module.exports = Promise.all([
    (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $cccf3b2dbde8e10c$var$load("esKGV")
        ]);
    }, function() {
        return Promise.all([
            $cccf3b2dbde8e10c$var$load("7uqQP")
        ]);
    }),
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $cccf3b2dbde8e10c$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $cccf3b2dbde8e10c$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $cccf3b2dbde8e10c$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $cccf3b2dbde8e10c$var$load("kZxiU")
        ]);
    }),
    $cccf3b2dbde8e10c$var$load("7vqGd"),
    $cccf3b2dbde8e10c$var$load("1Y4bq"),
    $cccf3b2dbde8e10c$var$load("k4gbU"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("5P7fT"), 4)),
    $cccf3b2dbde8e10c$var$load("1VRB2"),
    $cccf3b2dbde8e10c$var$load("bABhq"),
    $cccf3b2dbde8e10c$var$load("eDzss"),
    $cccf3b2dbde8e10c$var$load("jl3vx")
]).then(()=>parcelRequire('3L39g'));

});



parcelRegister("aCLGk", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesLegacyRedirectRouteEntry", () => $26aabb4118899eb9$export$804f2d81dfbdd5c9);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $6U5mJ = parcelRequire("6U5mJ");

var $9NmsS = parcelRequire("9NmsS");

var $9T7WW = parcelRequire("9T7WW");

var $crpnS = parcelRequire("crpnS");

var $3A1Of = parcelRequire("3A1Of");
const $26aabb4118899eb9$export$804f2d81dfbdd5c9 = (0, $6xToB.createEntry)((0, $9T7WW.arjSettingsDependenciesLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $3A1Of.redirectTo)('/jira/plans/settings/dependencies'),
        isRedirect: true,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $6U5mJ.issueLinkInformationResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $crpnS.LazyArjSettingsDependencies)
        ]
    }));

});
parcelRegister("6U5mJ", function(module, exports) {

$parcel$export(module.exports, "issueLinkInformationResource", () => $dca48e61cf3706a8$export$8d8544ca08d98837);

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");
const $dca48e61cf3706a8$var$body = {
    providers: [
        'issueLinks',
        'dependencySettings'
    ]
};
const $dca48e61cf3706a8$var$url = '/rest/jpo/1.0/info/query';
const $dca48e61cf3706a8$var$fetchIssueLinkInformation = ()=>(0, $jGzN3.performPostRequest)($dca48e61cf3706a8$var$url, {
        body: JSON.stringify($dca48e61cf3706a8$var$body)
    });
const $dca48e61cf3706a8$export$8d8544ca08d98837 = (0, $l1VxS.createResource)({
    type: 'ISSUE_LINK_INFORMATION',
    getKey: ()=>'issue-link-information',
    getData: async ()=>$dca48e61cf3706a8$var$fetchIssueLinkInformation(),
    maxAge: 0
});

});

parcelRegister("9T7WW", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesLegacyRedirectRoute", () => $901796dcf2a308cf$export$f96bfb0a2b0ad0f4);
const $901796dcf2a308cf$export$f96bfb0a2b0ad0f4 = {
    name: 'arj-settings-dependencies-redirect',
    path: '/secure/PortfolioDependencySettings.jspa'
};

});

parcelRegister("crpnS", function(module, exports) {

$parcel$export(module.exports, "LazyArjSettingsDependencies", () => $e671e47effddf844$export$4fcc3c0f6e792efc);
$parcel$export(module.exports, "ArjSettingsDependencies", () => $e671e47effddf844$export$d6f045c7c1aaff50);
$parcel$export(module.exports, "LazyArjSettingsLoadingLimits", () => $e671e47effddf844$export$64761ea1912fdcd9);
$parcel$export(module.exports, "ArjSettingsLoadingLimits", () => $e671e47effddf844$export$7bb4c0f22b467385);
$parcel$export(module.exports, "LazyArjSettingsPermissions", () => $e671e47effddf844$export$edb4ae7e85c7908d);
$parcel$export(module.exports, "ArjSettingsPermissions", () => $e671e47effddf844$export$fa852ea42b98d3de);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $e671e47effddf844$export$4fcc3c0f6e792efc = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("32Vhp"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/dependencies/index.tsx"
});
const $e671e47effddf844$export$d6f045c7c1aaff50 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e671e47effddf844$export$4fcc3c0f6e792efc,
        pageId: "arj-settings-dependencies",
        shouldShowSpinner: true
    });

const $e671e47effddf844$export$64761ea1912fdcd9 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("dvfyz"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/loading-limits/index.tsx"
});
const $e671e47effddf844$export$7bb4c0f22b467385 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e671e47effddf844$export$64761ea1912fdcd9,
        pageId: "arj-settings-loading-limits",
        shouldShowSpinner: true
    });

const $e671e47effddf844$export$edb4ae7e85c7908d = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2L5El"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/permissions/index.tsx"
});
const $e671e47effddf844$export$fa852ea42b98d3de = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e671e47effddf844$export$edb4ae7e85c7908d,
        pageId: "arj-settings-permissions",
        shouldShowSpinner: true
    });

});
parcelRegister("32Vhp", function(module, exports) {

let $237dfd97f5896a66$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $237dfd97f5896a66$var$load("kScMV").then(()=>parcelRequire('b4Lez'));

});

parcelRegister("dvfyz", function(module, exports) {

let $9d4a3cd6ff9f3573$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("hiPFN"), 4)),
    $9d4a3cd6ff9f3573$var$load("WHKZy")
]).then(()=>parcelRequire('azPLx'));

});

parcelRegister("2L5El", function(module, exports) {

let $20245a7fed07037a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $20245a7fed07037a$var$load("9rzk9").then(()=>parcelRequire('7c5Kl'));

});


parcelRegister("3A1Of", function(module, exports) {

$parcel$export(module.exports, "redirectTo", () => $621b7d6c3aba0ef3$export$2d47ce6f15e624e5);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");
const $621b7d6c3aba0ef3$export$2d47ce6f15e624e5 = (redirectUrl)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
            to: redirectUrl
        });

});
parcelRegister("7fTjp", function(module, exports) {

$parcel$export(module.exports, "ScreenRedirect", () => $d4a25a2e90068241$export$fdd3e60cd227c2f7);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $iIqWW = parcelRequire("iIqWW");

var $2mHfh = parcelRequire("2mHfh");
var $gCY1z = parcelRequire("gCY1z");
const $d4a25a2e90068241$export$fdd3e60cd227c2f7 = ({ to: to, persistSearchParams: persistSearchParams = true })=>{
    const [{ route: route, location: location, query: query }] = (0, $gCY1z.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [{ isInitialRender: isInitial }] = (0, $iIqWW.useSpaStateTransition)();
    const eventRef = (0, $eJOHy.useRef)(createAnalyticsEvent({}));
    (0, $eJOHy.useEffect)(()=>{
        if (!route || !eventRef.current) return;
        (0, $gCeeo.fireUIAnalytics)(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        route,
        isInitial
    ]);
    if (Array.isArray(persistSearchParams)) {
        const persistParams = Object.keys(query) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((result, currentKey)=>{
            const shouldPersist = persistSearchParams.some((persistKey)=>currentKey.includes(persistKey));
            if (shouldPersist) result.push(`${currentKey}=${query[currentKey]}`);
            return result;
        }, []).join('&');
        if (persistParams !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `${to}?${persistParams}`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: to
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `${to}${persistSearchParams ? location.search : ''}`
    });
};

});
parcelRegister("iIqWW", function(module, exports) {

$parcel$export(module.exports, "useSpaStateTransition", () => $b8fb9a9aa25a4395$export$4d1974344641a2c9);
$parcel$export(module.exports, "default", () => $b8fb9a9aa25a4395$export$2e2bcd8739ae039);

var $gPCSe = parcelRequire("gPCSe");

var $iJq0l = parcelRequire("iJq0l");
var $ht3nQ = parcelRequire("ht3nQ");

var $6XFSq = parcelRequire("6XFSq");
const $b8fb9a9aa25a4395$var$getNavigationStart = ()=>{
    // @ts-expect-error - TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'. | TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    const timestamp = (0, $gPCSe.default) && (0, $gPCSe.default).timing && (0, $gPCSe.default).timing.navigationStart;
    return timestamp ? new Date(timestamp).toISOString() : undefined;
};
const $b8fb9a9aa25a4395$var$getLastTransition = (currentPage, visitedPages)=>{
    if (visitedPages.length === 0) return undefined;
    const collectAppNames = (page)=>Object.keys(page.apps || {}).sort();
    const appNamesToStr = (appNames)=>appNames.join('+') || '?';
    const prevPage = appNamesToStr(collectAppNames(visitedPages.slice(-1)[0]));
    const currPage = appNamesToStr(collectAppNames(currentPage));
    return `${prevPage} > ${currPage}`;
};
const $b8fb9a9aa25a4395$var$getLastTransitionStartTime = (currentPage, visitedPages)=>{
    // If there are no previously visited pages the transition didn't have a place
    if (visitedPages.length === 0) return undefined;
    return currentPage.startTime;
};
const $b8fb9a9aa25a4395$export$aea217a45095ce11 = ({ visitedPages: visitedPages, currentPage: currentPage })=>({
        isInitialRender: visitedPages.length === 0,
        transitionsCount: visitedPages.length,
        lastTransition: $b8fb9a9aa25a4395$var$getLastTransition(currentPage, visitedPages),
        lastTransitionStartTime: $b8fb9a9aa25a4395$var$getLastTransitionStartTime(currentPage, visitedPages),
        navigationStart: $b8fb9a9aa25a4395$var$getNavigationStart(),
        currentPageId: currentPage.uuid
    });
// @ts-expect-error - TS2322 - Type 'SubscriberComponent<TransitionState, BoundActions<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/controllers/spa-state/src/actions/index")>, Record<...>>' is not assignable to type 'Subscriber'.
const $b8fb9a9aa25a4395$var$SpaStateTransitionStateSubscriber = (0, $ht3nQ.createSubscriber)((0, $6XFSq.default), {
    displayName: 'SpaStateTransitionStateSubscriber',
    selector: $b8fb9a9aa25a4395$export$aea217a45095ce11
});
const $b8fb9a9aa25a4395$export$4d1974344641a2c9 = (0, $iJq0l.createHook)((0, $6XFSq.default), {
    selector: $b8fb9a9aa25a4395$export$aea217a45095ce11
});
var $b8fb9a9aa25a4395$export$2e2bcd8739ae039 = $b8fb9a9aa25a4395$var$SpaStateTransitionStateSubscriber;

});




parcelRegister("eJqY3", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesRouteEntry", () => $2dec85f6387d4de5$export$70386609aff5ba12);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $6U5mJ = parcelRequire("6U5mJ");

var $9NmsS = parcelRequire("9NmsS");

var $3pzsO = parcelRequire("3pzsO");

var $crpnS = parcelRequire("crpnS");
const $2dec85f6387d4de5$export$70386609aff5ba12 = (0, $6xToB.createEntry)((0, $3pzsO.arjSettingsDependenciesRoute), ()=>({
        group: 'software',
        component: (0, $crpnS.ArjSettingsDependencies),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $6U5mJ.issueLinkInformationResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $crpnS.LazyArjSettingsDependencies)
        ]
    }));

});
parcelRegister("3pzsO", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesRoute", () => $ea31bea6e2ac6c5c$export$ff9b90f9d680e34);
const $ea31bea6e2ac6c5c$export$ff9b90f9d680e34 = {
    name: 'arj-settings-dependencies',
    path: '/jira/plans/settings/dependencies'
};

});


parcelRegister("1lOAz", function(module, exports) {

$parcel$export(module.exports, "arjSettingsFinancialYearPageRouteEntry", () => $68e73400ed0dc409$export$b6bba25826e621b9);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $7MNDz = parcelRequire("7MNDz");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $l2CRW = parcelRequire("l2CRW");

var $dVS1R = parcelRequire("dVS1R");
const $68e73400ed0dc409$export$b6bba25826e621b9 = (0, $6xToB.createEntry)((0, $l2CRW.arjSettingsFinancialYearPageRoute), ()=>({
        group: 'software',
        component: (0, $dVS1R.ArjSettingsFinancialYear),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $7MNDz.arjSettingsFinancialYearResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dVS1R.LazyArjSettingsFinancialYear)
        ]
    }));

});
parcelRegister("7MNDz", function(module, exports) {

$parcel$export(module.exports, "arjSettingsFinancialYearResource", () => $a2769854afa61743$export$da45020eede4a793);

var $1Ozm9 = parcelRequire("1Ozm9");

var $l1VxS = parcelRequire("l1VxS");

const $a2769854afa61743$export$da45020eede4a793 = (0, $l1VxS.createResource)({
    type: (0, $81ad417e9e376149$export$e8e0384e95388aa3),
    getKey: ()=>'financial-year-information',
    getData: async ()=>(0, $1Ozm9.default)('/rest/jpo/1.0/fiscalYear'),
    maxAge: 0
});

});
const $81ad417e9e376149$export$e8e0384e95388aa3 = 'RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR';


parcelRegister("l2CRW", function(module, exports) {

$parcel$export(module.exports, "arjSettingsFinancialYearPageRoute", () => $cf264a7b58719d56$export$7208300f00a36a5f);
const $cf264a7b58719d56$export$7208300f00a36a5f = {
    name: 'arj-settings-financial-year',
    path: '/jira/plans/settings/financial-year',
    exact: true
};

});

parcelRegister("dVS1R", function(module, exports) {

$parcel$export(module.exports, "LazyArjSettingsFinancialYear", () => $393ab146b792b775$export$dd67c2f01a58231e);
$parcel$export(module.exports, "ArjSettingsFinancialYear", () => $393ab146b792b775$export$785180185eba7ed9);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $393ab146b792b775$export$dd67c2f01a58231e = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("aZ3dq")).then((module)=>module.ArjSettingsFinancialYear)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/financial-year/index.tsx"
});
const $393ab146b792b775$export$785180185eba7ed9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $393ab146b792b775$export$dd67c2f01a58231e,
        pageId: "arj-settings-financial-year",
        shouldShowSpinner: true
    });

});
parcelRegister("aZ3dq", function(module, exports) {

let $7ff2186a77b509f8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7ff2186a77b509f8$var$load("1P5Vi").then(()=>parcelRequire('hjnLm'));

});



parcelRegister("eOLN9", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsLegacyRedirectRouteEntry", () => $5aa6ef318e96ca1f$export$9f80102c0f64ad9b);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $kAAs1 = parcelRequire("kAAs1");

var $crpnS = parcelRequire("crpnS");

var $3A1Of = parcelRequire("3A1Of");
const $5aa6ef318e96ca1f$export$9f80102c0f64ad9b = (0, $6xToB.createEntry)((0, $kAAs1.arjSettingsLoadingLimitsLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $3A1Of.redirectTo)('/jira/plans/settings/loading-limits'),
        isRedirect: true,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $crpnS.LazyArjSettingsLoadingLimits)
        ]
    }));

});
parcelRegister("kAAs1", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsLegacyRedirectRoute", () => $16fecf79f5f7a09d$export$7c71e235d628daf5);
const $16fecf79f5f7a09d$export$7c71e235d628daf5 = {
    name: 'arj-settings-loading-limits-redirect',
    path: '/secure/PortfolioLoadingLimits.jspa'
};

});


parcelRegister("2bnuQ", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsRouteEntry", () => $d3e0a5fc9eb07ef4$export$6786257309f86d8c);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $eaFxV = parcelRequire("eaFxV");

var $9NmsS = parcelRequire("9NmsS");

var $3daPY = parcelRequire("3daPY");

var $crpnS = parcelRequire("crpnS");
const $d3e0a5fc9eb07ef4$export$6786257309f86d8c = (0, $6xToB.createEntry)((0, $3daPY.arjSettingsLoadingLimitsRoute), ()=>({
        group: 'software',
        component: (0, $crpnS.ArjSettingsLoadingLimits),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $eaFxV.arjSettingsLoadingLimitsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $crpnS.LazyArjSettingsLoadingLimits)
        ]
    }));

});
parcelRegister("eaFxV", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsResource", () => $d4dcf0c9372d183c$export$c9e47fa9b57975f5);

var $1Ozm9 = parcelRequire("1Ozm9");

var $l1VxS = parcelRequire("l1VxS");

const $d4dcf0c9372d183c$export$c9e47fa9b57975f5 = (0, $l1VxS.createResource)({
    type: (0, $723e91a9d7fe9d70$export$cd7bb91dd2e30684),
    getKey: ()=>'loading-limits-information',
    getData: async ()=>(0, $1Ozm9.default)('/rest/jpo/1.0/configuration'),
    maxAge: 0
});

});
const $723e91a9d7fe9d70$export$cd7bb91dd2e30684 = 'RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS';


parcelRegister("3daPY", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsRoute", () => $2d35630067e09e0f$export$f90dc3a45fadc1e2);
const $2d35630067e09e0f$export$f90dc3a45fadc1e2 = {
    name: 'arj-settings-loading-limits',
    path: '/jira/plans/settings/loading-limits'
};

});


parcelRegister("iDdAu", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRouteEntry", () => $2875028c5bfad390$export$4e97658a5cc15eaa);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9K0qt = parcelRequire("9K0qt");

var $9NmsS = parcelRequire("9NmsS");

var $jZJGn = parcelRequire("jZJGn");

var $crpnS = parcelRequire("crpnS");
const $2875028c5bfad390$export$4e97658a5cc15eaa = (0, $6xToB.createEntry)((0, $jZJGn.arjSettingsPermissionsRoute), ()=>({
        group: 'software',
        component: (0, $crpnS.ArjSettingsPermissions),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $9K0qt.getGlobalPermissionPageResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $crpnS.LazyArjSettingsPermissions)
        ]
    }));

});
parcelRegister("9K0qt", function(module, exports) {

$parcel$export(module.exports, "grantedPermissionsResource", () => $9711889877d91aab$export$aa3daf3280e2a2d7);
$parcel$export(module.exports, "permissionGroupsResource", () => $9711889877d91aab$export$950060d83722e3bd);
$parcel$export(module.exports, "getGlobalPermissionPageResources", () => $9711889877d91aab$export$a09a91246a866817);

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");
const $9711889877d91aab$var$fetchGrantedPermissions = ()=>(0, $jGzN3.performPostRequest)('/rest/roadmaps/1.0/info/query', {
        body: JSON.stringify({
            providers: [
                'permissions'
            ]
        })
    });
const $9711889877d91aab$var$fetchPermissionGroups = ()=>(0, $jGzN3.performPostRequest)('/rest/jpo/1.0/groupsandusers', {
        body: JSON.stringify({
            includeUsers: false,
            excludedGroups: [],
            excludedUsers: [],
            query: ''
        })
    });
const $9711889877d91aab$export$aa3daf3280e2a2d7 = (0, $l1VxS.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GRANTED',
    getKey: ()=>'arj-granted-permissions',
    getData: async ()=>$9711889877d91aab$var$fetchGrantedPermissions(),
    maxAge: 0
});
const $9711889877d91aab$export$950060d83722e3bd = (0, $l1VxS.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GROUPS',
    getKey: ()=>'arj-permission-groups',
    getData: async ()=>$9711889877d91aab$var$fetchPermissionGroups(),
    maxAge: 0
});
const $9711889877d91aab$export$a09a91246a866817 = ()=>[
        $9711889877d91aab$export$aa3daf3280e2a2d7,
        $9711889877d91aab$export$950060d83722e3bd
    ];

});

parcelRegister("jZJGn", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRoute", () => $134158516490e58d$export$4501213a8b1d3a10);
const $134158516490e58d$export$4501213a8b1d3a10 = {
    name: 'arj-settings-permissions',
    path: '/jira/plans/settings/permissions'
};

});


parcelRegister("3cedS", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRouteLegacyRedirectRouteEntry", () => $79f26606e812159e$export$949c8177281fcc39);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9K0qt = parcelRequire("9K0qt");

var $9NmsS = parcelRequire("9NmsS");

var $5QuPH = parcelRequire("5QuPH");

var $crpnS = parcelRequire("crpnS");

var $3A1Of = parcelRequire("3A1Of");
const $79f26606e812159e$export$949c8177281fcc39 = (0, $6xToB.createEntry)((0, $5QuPH.arjSettingsPermissionsRouteLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $3A1Of.redirectTo)('/jira/plans/settings/permissions'),
        isRedirect: true,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $9K0qt.getGlobalPermissionPageResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $crpnS.LazyArjSettingsPermissions)
        ]
    }));

});
parcelRegister("5QuPH", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRouteLegacyRedirectRoute", () => $b6d4ff2fbeb5b061$export$24bf73f2d1dbf0db);
const $b6d4ff2fbeb5b061$export$24bf73f2d1dbf0db = {
    name: 'arj-settings-permissions-redirect',
    path: '/secure/PortfolioPermissions.jspa'
};

});


parcelRegister("cLZj8", function(module, exports) {

$parcel$export(module.exports, "arjSummaryEmbedRouteEntry", () => $cb1694a2fa4b6e92$export$bdc2c75e02c29d7);

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $jmv36 = parcelRequire("jmv36");

var $9NmsS = parcelRequire("9NmsS");

var $cxQGT = parcelRequire("cxQGT");

var $cJJhb = parcelRequire("cJJhb");

var $7jTnu = parcelRequire("7jTnu");

var $g8uYY = parcelRequire("g8uYY");

var $legH4 = parcelRequire("legH4");

var $j66XX = parcelRequire("j66XX");
const $cb1694a2fa4b6e92$var$planSummaryEmbedRouteEntry = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $legH4.planSummaryEntryPoint)
});
const $cb1694a2fa4b6e92$export$bdc2c75e02c29d7 = (0, $6xToB.createEntry)((0, $cJJhb.arjSummaryEmbedRoute), ()=>({
        group: 'software',
        component: (0, $j66XX.PlanSummaryEmbedPage),
        entryPoint: ()=>(0, $7jTnu.fg)('migrate_plans_to_entrypoints') ? $cb1694a2fa4b6e92$var$planSummaryEmbedRouteEntry : undefined,
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $jmv36.advancedRoadmapsSummaryDataResource),
            (0, $cxQGT.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $j66XX.LazyPlanSummaryEmbed)
        ]
    }));

});
parcelRegister("jmv36", function(module, exports) {

$parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", () => $fa05b67d71bc9c34$export$f9061628830b5175);
$parcel$export(module.exports, "fetchAdvancedRoadmapsSummaryData", () => $fa05b67d71bc9c34$export$2dfe99460dae6bc6);

var $1Ozm9 = parcelRequire("1Ozm9");

var $l1VxS = parcelRequire("l1VxS");

var $fi0Y9 = parcelRequire("fi0Y9");

var $jqjE2 = parcelRequire("jqjE2");
// we have to use location.search as we want to get params dynamically and rrr doesn't support it
// more info: https://atlassian-labs.github.io/react-resource-router/#/resources/usage?id=accessing-resource-state-for-another-route-or-url
const $fa05b67d71bc9c34$var$getQueryParams = (routerQuery)=>{
    if (typeof window !== 'undefined') return Object.fromEntries(new URLSearchParams(window.location.search));
    return routerQuery;
};
const $fa05b67d71bc9c34$export$f9061628830b5175 = (0, $l1VxS.createResource)({
    type: 'ADVANCED_ROADMAPS_SUMMARY_DATA',
    getKey: ({ match: match })=>{
        const { params: params } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        // Just return fallback string if on a page that doesn't have a planId or scenarioId
        return 'none';
    },
    getData: async ({ match: match, query: query })=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.__ARJ_SUMMARY_PAGE_PROMISE__) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const response = window.__ARJ_SUMMARY_PAGE_PROMISE__;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__ARJ_SUMMARY_PAGE_PROMISE__ = null;
            return response;
        }
        const { params: params } = match;
        return $fa05b67d71bc9c34$export$2dfe99460dae6bc6(params, query, (0, $fi0Y9.AVAILABLE_CHARTS));
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $fa05b67d71bc9c34$export$2dfe99460dae6bc6 = async (params, query, chartTypes)=>{
    if (params.planId == null) throw new Error('Unable to get fetch data for ADVANCED_ROADMAPS_SUMMARY_DATA. planId is not defined');
    const dateRange = (0, $jqjE2.validateDateRange)((0, $jqjE2.parseDateRange)($fa05b67d71bc9c34$var$getQueryParams(query)));
    const data = await (0, $1Ozm9.default)('/rest/jpo/1.0/summary/data', {
        method: 'POST',
        body: JSON.stringify({
            planId: params.planId,
            scenarioId: params.scenarioId,
            chartTypes: chartTypes,
            ...dateRange ? {
                dateRange: dateRange
            } : {}
        })
    });
    return dateRange ? {
        ...data,
        customDateRange: dateRange
    } : data;
};

});
parcelRegister("fi0Y9", function(module, exports) {

$parcel$export(module.exports, "CHART_TYPES", () => $a88f120904847c21$export$3251435144ca69e2);
$parcel$export(module.exports, "AVAILABLE_CHARTS", () => $a88f120904847c21$export$79cf9c14f738d70b);
$parcel$export(module.exports, "SCHEDULING_MODES", () => $a88f120904847c21$export$92daf59e30346cd2);
$parcel$export(module.exports, "CAPACITY_UNIT", () => $a88f120904847c21$export$494e761f17fc60a9);
$parcel$export(module.exports, "SPRINT_STATE", () => $a88f120904847c21$export$38e437924c2adbda);
const $a88f120904847c21$export$3251435144ca69e2 = {
    statusCategory: 'STATUS_CATEGORY',
    issueProgress: 'ISSUE_PROGRESS',
    teamProgress: 'TEAM_PROGRESS',
    teamCapacity: 'TEAM_CAPACITY',
    blockers: 'BLOCKERS',
    highestPriority: 'HIGHEST_PRIORITY',
    unassignedIssues: 'UNASSIGNED_ISSUES',
    overlappingBlockers: 'OVERLAPPING_BLOCKERS',
    overdue: 'OVERDUE'
};
const $a88f120904847c21$export$79cf9c14f738d70b = [
    $a88f120904847c21$export$3251435144ca69e2.statusCategory,
    $a88f120904847c21$export$3251435144ca69e2.issueProgress,
    $a88f120904847c21$export$3251435144ca69e2.teamProgress,
    $a88f120904847c21$export$3251435144ca69e2.teamCapacity,
    $a88f120904847c21$export$3251435144ca69e2.blockers,
    $a88f120904847c21$export$3251435144ca69e2.highestPriority,
    $a88f120904847c21$export$3251435144ca69e2.unassignedIssues,
    $a88f120904847c21$export$3251435144ca69e2.overlappingBlockers,
    $a88f120904847c21$export$3251435144ca69e2.overdue
];
const $a88f120904847c21$export$92daf59e30346cd2 = {
    SCRUM: 'Scrum',
    KANBAN: 'Kanban'
};
const $a88f120904847c21$export$494e761f17fc60a9 = {
    HOURS: 'HOURS',
    POINTS: 'STORY_POINTS',
    DAYS: 'DAYS'
};
const $a88f120904847c21$export$38e437924c2adbda = {
    CLOSED: 'CLOSED',
    ACTIVE: 'ACTIVE',
    FUTURE: 'FUTURE'
};

});

parcelRegister("jqjE2", function(module, exports) {

$parcel$export(module.exports, "parseDateRange", () => $475bbe0973adb452$export$1cd7060bc72a318c);
$parcel$export(module.exports, "validateDateRange", () => $475bbe0973adb452$export$b3e10550232e39db);
/**
 * Most of the code here is duplicated from `@atlassian/portfolio-3-summary-page`. We do not want to depend on all
 * the code from that package, but we want to parse and validate the date range before sending to the backend.
 */ 
var $1PBWh = parcelRequire("1PBWh");
const $475bbe0973adb452$export$637d8b0948b783c7 = {
    [(0, $1PBWh.DATE_UNITS).DAYS]: 3650,
    [(0, $1PBWh.DATE_UNITS).WEEKS]: 520,
    [(0, $1PBWh.DATE_UNITS).MONTHS]: 120
};
const $475bbe0973adb452$export$cf70eebe96d0cb07 = (type)=>{
    switch(type){
        case (0, $1PBWh.CUSTOM_TIME_RANGE_TYPES).FIXED:
        case (0, $1PBWh.CUSTOM_TIME_RANGE_TYPES).RELATIVE:
            return type;
        default:
            return undefined;
    }
};
const $475bbe0973adb452$export$6bf0e8cf8e1d780d = (value)=>{
    if (value === undefined) return undefined;
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
};
const $475bbe0973adb452$export$c777dd44ece05114 = (unit)=>{
    switch(unit){
        case (0, $1PBWh.DATE_UNITS).DAYS:
        case (0, $1PBWh.DATE_UNITS).WEEKS:
        case (0, $1PBWh.DATE_UNITS).MONTHS:
            return unit;
        default:
            return undefined;
    }
};
const $475bbe0973adb452$export$1cd7060bc72a318c = (query)=>{
    const { fromDate: fromDate, toDate: toDate, toNow: toNow, fromNow: fromNow, toNowUnit: toNowUnit, fromNowUnit: fromNowUnit, dateRangeType: dateRangeType } = query;
    return {
        typeOfCustomDateRange: $475bbe0973adb452$export$cf70eebe96d0cb07(dateRangeType),
        fromDate: $475bbe0973adb452$export$6bf0e8cf8e1d780d(fromDate),
        toDate: $475bbe0973adb452$export$6bf0e8cf8e1d780d(toDate),
        fromNowUnitCount: $475bbe0973adb452$export$6bf0e8cf8e1d780d(fromNow),
        toNowUnitCount: $475bbe0973adb452$export$6bf0e8cf8e1d780d(toNow),
        fromNowUnit: $475bbe0973adb452$export$c777dd44ece05114(fromNowUnit),
        toNowUnit: $475bbe0973adb452$export$c777dd44ece05114(toNowUnit)
    };
};
const $475bbe0973adb452$export$68346777682e262 = (count, unit)=>{
    if (count === undefined || unit === undefined) return false;
    return count >= 0 && count <= $475bbe0973adb452$export$637d8b0948b783c7[unit];
};
const $475bbe0973adb452$export$1ba31c57b50b4374 = (timestamp)=>{
    if (timestamp === undefined) return false;
    const date = new Date(timestamp);
    return !Number.isNaN(date.getTime());
};
const $475bbe0973adb452$export$b3e10550232e39db = (dateRange)=>{
    const { fromDate: fromDate, toDate: toDate, toNowUnitCount: toNowUnitCount, toNowUnit: toNowUnit, fromNowUnitCount: fromNowUnitCount, fromNowUnit: fromNowUnit, typeOfCustomDateRange: typeOfCustomDateRange } = dateRange;
    if (typeOfCustomDateRange === (0, $1PBWh.CUSTOM_TIME_RANGE_TYPES).RELATIVE && $475bbe0973adb452$export$68346777682e262(toNowUnitCount, toNowUnit) && $475bbe0973adb452$export$68346777682e262(fromNowUnitCount, fromNowUnit)) return {
        toNowUnitCount: toNowUnitCount,
        toNowUnit: toNowUnit,
        fromNowUnitCount: fromNowUnitCount,
        fromNowUnit: fromNowUnit,
        typeOfCustomDateRange: typeOfCustomDateRange
    };
    if (typeOfCustomDateRange === (0, $1PBWh.CUSTOM_TIME_RANGE_TYPES).FIXED && $475bbe0973adb452$export$1ba31c57b50b4374(fromDate) && $475bbe0973adb452$export$1ba31c57b50b4374(toDate)) return {
        fromDate: fromDate,
        toDate: toDate,
        typeOfCustomDateRange: typeOfCustomDateRange
    };
    return undefined;
};

});
parcelRegister("1PBWh", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_TIME_RANGE_TYPES", () => $edf1e8c098472f89$export$78e07fecfaf51c7b);
$parcel$export(module.exports, "DATE_UNITS", () => $edf1e8c098472f89$export$c99d20cdba4a5739);
$parcel$export(module.exports, "IssueStatus", () => $edf1e8c098472f89$export$559eb15a98685419);
$parcel$export(module.exports, "BlockType", () => $edf1e8c098472f89$export$48808c686fe495c4);
const $edf1e8c098472f89$export$78e07fecfaf51c7b = {
    FIXED: 'fixed',
    RELATIVE: 'relative'
};
const $edf1e8c098472f89$export$c99d20cdba4a5739 = {
    DAYS: 'days',
    MONTHS: 'months',
    WEEKS: 'weeks'
};
const $edf1e8c098472f89$export$559eb15a98685419 = {
    TODO: 'TODO',
    IN_PROGRESS: 'IN_PROGRESS',
    DONE: 'DONE'
};
const $edf1e8c098472f89$export$de194318c6dccbc1 = {
    INITIATIVE: 'INITIATIVE',
    EPIC: 'EPIC'
};
const $edf1e8c098472f89$export$48808c686fe495c4 = {
    DELAY_WORK: 'DELAY_WORK',
    CRITICAL_PATH: 'CRITICAL_PATH',
    BLOCK_WORK: 'BLOCK_WORK'
};

});



parcelRegister("cJJhb", function(module, exports) {

$parcel$export(module.exports, "arjSummaryEmbedRoute", () => $45ec2c02f6f22edd$export$126053e8fb441b66);
const $45ec2c02f6f22edd$export$126053e8fb441b66 = {
    name: 'software-plan-summary-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/summary/embed'
};

});

parcelRegister("legH4", function(module, exports) {

$parcel$export(module.exports, "planSummaryEntryPoint", () => $fcc3180984f3fe8f$export$82d8368ec1a526b);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $fcc3180984f3fe8f$export$82d8368ec1a526b = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("21dEL")), {
        moduleId: "c48db9c0",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("Nhl2o", function(module, exports) {

$parcel$export(module.exports, "arjTimelineEmbedRouteEntry", () => $6174331bc6e649fa$export$a977d398db1904ff);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $cxQGT = parcelRequire("cxQGT");

var $7TB8U = parcelRequire("7TB8U");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $g8uYY = parcelRequire("g8uYY");

var $iyaX4 = parcelRequire("iyaX4");
const $6174331bc6e649fa$var$planTimelineEmbedRouteEntry = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $iyaX4.planTimelineEntryPoint)
});

// Update to default import when cleaning getWillShowNav4
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6174331bc6e649fa$var$LazyPlanTimelineEmbed = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5rLHw")).then(({ PlanTimelineWithoutHeader: PlanTimelineWithoutHeader })=>PlanTimelineWithoutHeader)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index-old.tsx"
});
const $6174331bc6e649fa$var$PlanTimelineEmbedPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6174331bc6e649fa$var$LazyPlanTimelineEmbed,
        pageId: "plan-timeline-embed",
        shouldShowSpinner: true
    });
const $6174331bc6e649fa$export$a977d398db1904ff = (0, $6xToB.createEntry)((0, $7TB8U.arjTimelineEmbedRoute), ()=>({
        group: 'software',
        component: $6174331bc6e649fa$var$PlanTimelineEmbedPage,
        entryPoint: ()=>(0, $7jTnu.fg)('migrate_plans_to_entrypoints') ? $6174331bc6e649fa$var$planTimelineEmbedRouteEntry : undefined,
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $cxQGT.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            $6174331bc6e649fa$var$LazyPlanTimelineEmbed
        ]
    }));

});
parcelRegister("7TB8U", function(module, exports) {

$parcel$export(module.exports, "arjTimelineEmbedRoute", () => $31f6879962c77809$export$aadc28402ef87b84);
const $31f6879962c77809$export$aadc28402ef87b84 = {
    name: 'software-advanced-roadmaps-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/timeline/embed'
};

});

parcelRegister("iyaX4", function(module, exports) {

$parcel$export(module.exports, "planTimelineEntryPoint", () => $e41b801b53bdb78f$export$a36e3fca8afefb5b);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $e41b801b53bdb78f$export$a36e3fca8afefb5b = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("lw6lZ")), {
        moduleId: "0b69767e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lw6lZ", function(module, exports) {

let $faa183da22e89241$var$load = (parcelRequire("gLHA4"))(4);





module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $faa183da22e89241$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $faa183da22e89241$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $faa183da22e89241$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $faa183da22e89241$var$load("kZxiU")
        ]);
    }),
    $faa183da22e89241$var$load("7vqGd"),
    $faa183da22e89241$var$load("1Y4bq"),
    $faa183da22e89241$var$load("1VRB2"),
    $faa183da22e89241$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("lqf7V"), 4)),
    $faa183da22e89241$var$load("eDzss"),
    $faa183da22e89241$var$load("bHkvV")
]).then(()=>parcelRequire('kXJSa'));

});


parcelRegister("5rLHw", function(module, exports) {

let $3f7479cbdb91a7ba$var$load = (parcelRequire("gLHA4"))(4);





module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $3f7479cbdb91a7ba$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $3f7479cbdb91a7ba$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $3f7479cbdb91a7ba$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $3f7479cbdb91a7ba$var$load("kZxiU")
        ]);
    }),
    $3f7479cbdb91a7ba$var$load("7vqGd"),
    $3f7479cbdb91a7ba$var$load("1Y4bq"),
    $3f7479cbdb91a7ba$var$load("1VRB2"),
    $3f7479cbdb91a7ba$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("c62TA"), 4)),
    $3f7479cbdb91a7ba$var$load("eDzss"),
    $3f7479cbdb91a7ba$var$load("eZJtX")
]).then(()=>parcelRequire('7q1Rr'));

});


parcelRegister("g0EQq", function(module, exports) {

$parcel$export(module.exports, "assetsAnalyticsDataViewCreateRouteEntry", () => $f203d46a57fb9840$export$ee75957829357d5d);

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $gHHjw = parcelRequire("gHHjw");

var $gy2Qg = parcelRequire("gy2Qg");

var $af0hI = parcelRequire("af0hI");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $f1zun = parcelRequire("f1zun");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $f203d46a57fb9840$var$assetsAnalyticsDataViewCreatePageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $af0hI.assetsAnalyticsDataViewCreateEntryPoint)
});
const $f203d46a57fb9840$export$ee75957829357d5d = (0, $6xToB.createEntry)((0, $gHHjw.assetsAnalyticsDataViewCreateRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$f203d46a57fb9840$var$assetsAnalyticsDataViewCreatePageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-create-page',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-create',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_CREATE_PAGE),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("gHHjw", function(module, exports) {

$parcel$export(module.exports, "assetsAnalyticsDataViewCreateRoute", () => $d003db8a9df3d9e2$export$4bdd2b973f5ff912);
const $d003db8a9df3d9e2$export$4bdd2b973f5ff912 = {
    name: 'assets-analytics-data-view-create',
    path: '/jira/assets/analytics/data-view/create',
    exact: true
};

});

parcelRegister("af0hI", function(module, exports) {

$parcel$export(module.exports, "assetsAnalyticsDataViewCreateEntryPoint", () => $3a29ae1a3ba9e1c9$export$cfa228728b5a63f4);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $3a29ae1a3ba9e1c9$export$cfa228728b5a63f4 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("xfdZI")).then((module)=>module.AssetsAnalyticsDataViewCreatePage), {
        moduleId: "539b781f",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("xfdZI", function(module, exports) {

let $063ee47e44eaf33f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $063ee47e44eaf33f$var$load("kImgq").then(()=>parcelRequire('l8NK5'));

});


parcelRegister("1qTV8", function(module, exports) {

$parcel$export(module.exports, "LazyAssetsLayout", () => $81786c6b09cb2145$export$6d4ed5b3aae01b61);
$parcel$export(module.exports, "AssetsLayout", () => $81786c6b09cb2145$export$fc69c032e8242676);

var $eJOHy = parcelRequire("eJOHy");

var $gzcjr = parcelRequire("gzcjr");

var $ch9En = parcelRequire("ch9En");

const $81786c6b09cb2145$export$6d4ed5b3aae01b61 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("6tTXi")).then((module)=>module.AssetsLayout), {
    ssr: false,
    moduleId: "./src/packages/assets-app/layout/src/ui/index.tsx"
});
const $81786c6b09cb2145$export$fc69c032e8242676 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "assets-layout-async"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($81786c6b09cb2145$export$6d4ed5b3aae01b61, null, children));

});
parcelRegister("6tTXi", function(module, exports) {

let $4b80db15f31587d8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $4b80db15f31587d8$var$load("1VRB2"),
    $4b80db15f31587d8$var$load("bABhq"),
    $4b80db15f31587d8$var$load("fm51e")
]).then(()=>parcelRequire('8BU3q'));

});


parcelRegister("f1zun", function(module, exports) {

$parcel$export(module.exports, "getCmdbResources", () => $f314548d40a5fcb8$export$850433b0663023b8);
$parcel$export(module.exports, "getAssetsAppResources", () => $f314548d40a5fcb8$export$70fc9421fb71e080);

var $7jTnu = parcelRequire("7jTnu");

var $9NmsS = parcelRequire("9NmsS");

var $5L7qx = parcelRequire("5L7qx");

var $1PvPk = parcelRequire("1PvPk");

var $5MeEd = parcelRequire("5MeEd");

var $ePaI2 = parcelRequire("ePaI2");

var $cxQGT = parcelRequire("cxQGT");

var $lb6FK = parcelRequire("lb6FK");

var $4RTtS = parcelRequire("4RTtS");
function $f314548d40a5fcb8$export$850433b0663023b8() {
    return [
        ...(0, $9NmsS.getNavigationResources)(),
        ...(0, $1PvPk.getServicedeskPageContextResources)(),
        (0, $ePaI2.workspaceResource)
    ];
}
function $f314548d40a5fcb8$export$70fc9421fb71e080() {
    return [
        (0, $ePaI2.workspaceResource),
        (0, $cxQGT.themePreferenceResource),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('aurum-assets-as-a-platform'), (0, $4RTtS.assetsNavigationSettingsResource)),
        (0, $lb6FK.rovoEntitlementResource),
        (0, $5MeEd.getConsentBannerUserPreferencesResource)()
    ];
}

});
parcelRegister("4RTtS", function(module, exports) {

$parcel$export(module.exports, "assetsNavigationSettingsResource", () => $53f3fee9f5775117$export$d72c30b62ce96bca);
$parcel$export(module.exports, "useAssetsNavigationSettingsResource", () => $53f3fee9f5775117$export$59c3c97d1f3b9d94);

var $7jTnu = parcelRequire("7jTnu");

var $l1VxS = parcelRequire("l1VxS");
var $uCHeL = parcelRequire("uCHeL");
var $eJrcF = parcelRequire("eJrcF");

var $4hzWN = parcelRequire("4hzWN");

var $fpGxz = parcelRequire("fpGxz");

var $lStgW = parcelRequire("lStgW");
const $53f3fee9f5775117$var$emptyResponse = {
    backgroundColor: '',
    highlightColor: ''
};
const $53f3fee9f5775117$export$d72c30b62ce96bca = (0, $l1VxS.createResource)({
    type: (0, $fpGxz.RESOURCE_ASSETS_NAVIGATION_SETTINGS),
    getKey: ()=>(0, $fpGxz.RESOURCE_ASSETS_NAVIGATION_SETTINGS_KEY),
    getData: async ()=>{
        if (!(0, $7jTnu.fg)('aurum-assets-as-a-platform')) return $53f3fee9f5775117$var$emptyResponse;
        const navigationSettingsRequest = [
            {
                key: (0, $fpGxz.NAVIGATION_SETTINGS_KEYS).BG_COLOR
            },
            {
                key: (0, $fpGxz.NAVIGATION_SETTINGS_KEYS).HIGHLIGHT_COLOR
            }
        ];
        const { storeState: storeState } = (0, $uCHeL.getResourceStore)();
        const state = storeState.getState();
        try {
            const workspaceId = await (0, $lStgW.extractResourceStatePromise)(state.data);
            if (!workspaceId || typeof workspaceId !== 'string') return $53f3fee9f5775117$var$emptyResponse;
            const navigationSettings = await (0, $4hzWN.getAdminSettingsByKeys)(workspaceId, navigationSettingsRequest);
            return {
                backgroundColor: navigationSettings[(0, $fpGxz.NAVIGATION_SETTINGS_KEYS).BG_COLOR]?.value,
                highlightColor: navigationSettings[(0, $fpGxz.NAVIGATION_SETTINGS_KEYS).HIGHLIGHT_COLOR]?.value
            };
        } catch (error) {
            return $53f3fee9f5775117$var$emptyResponse;
        }
    },
    maxAge: (0, $fpGxz.ASSETS_ADMIN_SETTINGS_MAX_AGE)
});
const $53f3fee9f5775117$export$59c3c97d1f3b9d94 = ()=>{
    return (0, $eJrcF.useResource)($53f3fee9f5775117$export$d72c30b62ce96bca);
};

});
parcelRegister("4hzWN", function(module, exports) {

$parcel$export(module.exports, "getAdminSettingsByKeys", () => $60f92d2211bdde6e$export$55fc3561374ab769);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $lStgW = parcelRequire("lStgW");
const $60f92d2211bdde6e$export$55fc3561374ab769 = async (workspaceId, settingKeys)=>{
    const url = (0, $lStgW.getAdminSettingsUrl)(workspaceId);
    try {
        const response = await (0, $jGzN3.performPostRequest)(url, {
            body: JSON.stringify(settingKeys)
        });
        return (0, $lStgW.transformAdminSettingsResponse)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 403) // Return empty settings array for unauthorized access
        return {};
        (0, $gYnSx.default)({
            meta: {
                id: 'getAdminSettingsByKeys',
                packageName: 'jiraRouterResourcesAssetsAdminNavigationSettings',
                teamName: 'aurum'
            },
            error: error
        });
        throw error;
    }
};

});
parcelRegister("lStgW", function(module, exports) {

$parcel$export(module.exports, "extractResourceStatePromise", () => $b7cc77ac67a88237$export$5e6c0b0c6c71e3a7);
$parcel$export(module.exports, "getAdminSettingsUrl", () => $b7cc77ac67a88237$export$13aeca3ca3499df1);
$parcel$export(module.exports, "transformAdminSettingsResponse", () => $b7cc77ac67a88237$export$c8db903c3984d79e);

var $fpGxz = parcelRequire("fpGxz");
function $b7cc77ac67a88237$export$5e6c0b0c6c71e3a7(resourceState) {
    return resourceState?.[0, $fpGxz.RESOURCE_TYPE_WORKSPACE_CONTEXT]?.state?.promise;
}
const $b7cc77ac67a88237$export$13aeca3ca3499df1 = (workspaceId)=>`/gateway/api/jsm/assets/workspace/${workspaceId}/v1/admin/settings`;
const $b7cc77ac67a88237$export$c8db903c3984d79e = (response)=>{
    return response.reduce((acc, setting)=>{
        acc[setting.key] = setting;
        return acc;
    }, {});
};

});
parcelRegister("fpGxz", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_ASSETS_NAVIGATION_SETTINGS", () => $4d2df6cce256c6c7$export$858084c28938b25c);
$parcel$export(module.exports, "RESOURCE_ASSETS_NAVIGATION_SETTINGS_KEY", () => $4d2df6cce256c6c7$export$6c3a7ac5254a8135);
$parcel$export(module.exports, "NAVIGATION_SETTINGS_KEYS", () => $4d2df6cce256c6c7$export$8a78e43025de1286);
$parcel$export(module.exports, "RESOURCE_TYPE_WORKSPACE_CONTEXT", () => $4d2df6cce256c6c7$export$3f183223d3598a56);
$parcel$export(module.exports, "ASSETS_ADMIN_SETTINGS_MAX_AGE", () => $4d2df6cce256c6c7$export$ce0c7383fedc84ce);
const $4d2df6cce256c6c7$export$858084c28938b25c = 'RESOURCE_ASSETS_NAVIGATION_SETTINGS';
const $4d2df6cce256c6c7$export$6c3a7ac5254a8135 = 'settings';
const $4d2df6cce256c6c7$export$8a78e43025de1286 = {
    BG_COLOR: 'assets.navigation.bgcolour',
    HIGHLIGHT_COLOR: 'assets.navigation.highlightcolour'
};
const $4d2df6cce256c6c7$export$3f183223d3598a56 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $4d2df6cce256c6c7$export$ce0c7383fedc84ce = 900000;

});





parcelRegister("eG7NE", function(module, exports) {

$parcel$export(module.exports, "AssetsPageConfigContainer", () => $8334ac7022e551a5$export$68a74d1b39f069c5);

var $eJOHy = parcelRequire("eJOHy");

var $gzcjr = parcelRequire("gzcjr");

var $ch9En = parcelRequire("ch9En");

const $8334ac7022e551a5$export$606469064c062fcd = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("kPOx6")).then((module)=>module.PageConfigContainer), {
    ssr: false,
    moduleId: "./src/packages/assets-app/page-config-container/src/ui/index.tsx"
});
const $8334ac7022e551a5$export$68a74d1b39f069c5 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "assets-page-config-container-async"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8334ac7022e551a5$export$606469064c062fcd, null, children));

});
parcelRegister("kPOx6", function(module, exports) {

let $f2afc4d92ad0837d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f2afc4d92ad0837d$var$load("jI2m5").then(()=>parcelRequire('3chUb'));

});



parcelRegister("5NEJc", function(module, exports) {

$parcel$export(module.exports, "assetsAnalyticsDataViewDetailsRouteEntry", () => $d6cc74fe3f45a176$export$3a6396cc5491db7c);

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $k1uVB = parcelRequire("k1uVB");

var $gy2Qg = parcelRequire("gy2Qg");

var $9RD0X = parcelRequire("9RD0X");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $f1zun = parcelRequire("f1zun");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $d6cc74fe3f45a176$var$assetsAnalyticsDataViewDetailsPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $9RD0X.assetsAnalyticsDataViewDetailsEntryPoint)
});
const $d6cc74fe3f45a176$export$3a6396cc5491db7c = (0, $6xToB.createEntry)((0, $k1uVB.assetsAnalyticsDataViewDetailsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$d6cc74fe3f45a176$var$assetsAnalyticsDataViewDetailsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-details-page',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-details',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_DETAILS_PAGE),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("k1uVB", function(module, exports) {

$parcel$export(module.exports, "assetsAnalyticsDataViewDetailsRoute", () => $fde8dd13847da101$export$745cfa051b349898);
const $fde8dd13847da101$export$745cfa051b349898 = {
    name: 'assets-analytics-data-view-details',
    path: '/jira/assets/analytics/data-view/:dataViewId',
    exact: true
};

});

parcelRegister("9RD0X", function(module, exports) {

$parcel$export(module.exports, "assetsAnalyticsDataViewDetailsEntryPoint", () => $478f3aecb95ef964$export$2ef63d819083574a);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $478f3aecb95ef964$export$2ef63d819083574a = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("d2NsX")).then((module)=>module.AssetsAnalyticsDataViewDetailsPage), {
        moduleId: "3d6891cf",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("d2NsX", function(module, exports) {

let $97f1d533d247fb5b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $97f1d533d247fb5b$var$load("iLdFo").then(()=>parcelRequire('bi6bT'));

});



parcelRegister("9AeX2", function(module, exports) {

$parcel$export(module.exports, "assetsAnalyticsDataViewListRouteEntry", () => $0186404d4be98625$export$7d8bada2dd6618e9);

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9K4E7 = parcelRequire("9K4E7");

var $gy2Qg = parcelRequire("gy2Qg");

var $2c79B = parcelRequire("2c79B");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $f1zun = parcelRequire("f1zun");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $0186404d4be98625$var$assetsAnalyticsDataViewListPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $2c79B.assetsAnalyticsDataViewListEntryPoint)
});
const $0186404d4be98625$export$7d8bada2dd6618e9 = (0, $6xToB.createEntry)((0, $9K4E7.assetsAnalyticsDataViewListRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$0186404d4be98625$var$assetsAnalyticsDataViewListPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-list-page',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-list',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_LIST_PAGE),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("9K4E7", function(module, exports) {

$parcel$export(module.exports, "assetsAnalyticsDataViewListRoute", () => $a4982b3a2a3ab440$export$40ec17d60854071b);
const $a4982b3a2a3ab440$export$40ec17d60854071b = {
    name: 'assets-analytics-data-view-list',
    path: '/jira/assets/analytics/data-view',
    exact: true
};

});

parcelRegister("2c79B", function(module, exports) {

$parcel$export(module.exports, "assetsAnalyticsDataViewListEntryPoint", () => $dcfdab98db94a139$export$a5faca810df8b234);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $dcfdab98db94a139$export$a5faca810df8b234 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("6S57H")).then((module)=>module.AssetsAnalyticsDataViewListPage), {
        moduleId: "34d60c27",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6S57H", function(module, exports) {

let $500bc2972995a5a9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $500bc2972995a5a9$var$load("iFUof").then(()=>parcelRequire('2To7f'));

});



parcelRegister("hjFNU", function(module, exports) {

$parcel$export(module.exports, "assetsConfigurationRouteEntry", () => $c30f6ede6164eca6$export$1c86de5db8ff2b58);

var $6xToB = parcelRequire("6xToB");

var $73yke = parcelRequire("73yke");

var $gy2Qg = parcelRequire("gy2Qg");

var $f1zun = parcelRequire("f1zun");

var $g8uYY = parcelRequire("g8uYY");

var $j2mgX = parcelRequire("j2mgX");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $c30f6ede6164eca6$var$globalConfigurePageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $j2mgX.assetsGlobalSettingsEntryPoint)
});
const $c30f6ede6164eca6$export$1c86de5db8ff2b58 = (0, $6xToB.createEntry)((0, $73yke.assetsConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        ufoName: 'servicedesk-cmdb-assets-configure',
        entryPoint: ()=>$c30f6ede6164eca6$var$globalConfigurePageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-configure',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'aurum'
            }
        }
    }));

});
parcelRegister("73yke", function(module, exports) {

$parcel$export(module.exports, "assetsConfigurationRoute", () => $85ba62486a8390d7$export$266d00c8001d32ab);
const $85ba62486a8390d7$export$266d00c8001d32ab = {
    name: 'assets-configure',
    path: '/jira/assets/configure/global'
};

});

parcelRegister("j2mgX", function(module, exports) {

$parcel$export(module.exports, "assetsGlobalSettingsEntryPoint", () => $a90979c8a78b4d9d$export$2b083e0274144f1b);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $a90979c8a78b4d9d$export$2b083e0274144f1b = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("kzJFr")), {
        moduleId: "b65d2969",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kzJFr", function(module, exports) {

let $efaa8021cec94ec3$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $efaa8021cec94ec3$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $efaa8021cec94ec3$var$load("deNlq")
        ]);
    }),
    $efaa8021cec94ec3$var$load("5eWXh")
]).then(()=>parcelRequire('1chQi'));

});



parcelRegister("9enxs", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerDataSourceRouteEntry", () => $aba4a8890e7495e9$export$3ca446ebb8517896);

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $3M6LE = parcelRequire("3M6LE");

var $g8uYY = parcelRequire("g8uYY");

var $gy2Qg = parcelRequire("gy2Qg");

var $f1zun = parcelRequire("f1zun");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");

var $gxgQp = parcelRequire("gxgQp");
const $aba4a8890e7495e9$var$assetsDataManagerDataSourcePageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $gxgQp.assetsDataManagerDataSourceEntryPoint)
});
const $aba4a8890e7495e9$export$3ca446ebb8517896 = (0, $6xToB.createEntry)((0, $3M6LE.assetsDataManagerDataSourceRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        perfMetricKey: 'assets-data-manager-data-source',
        pageId: ()=>'spa-apps/assets-data-manager-data-source',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $7jTnu.fg)('assets_data_manager_jira_spa') ? $aba4a8890e7495e9$var$assetsDataManagerDataSourcePageEntryPoint : undefined;
        },
        component: (0, $9BJU1.default),
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE),
                teamName: 'Aurum'
            }
        }
    }));

});
parcelRegister("3M6LE", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerDataSourceRoute", () => $b98159378b020ea1$export$d046531151f2bc80);
const $b98159378b020ea1$export$d046531151f2bc80 = {
    name: 'assets-data-manager-data-source',
    path: '/jira/assets/data-manager/object-classes/data-source/:dataSourceId/:tab(configuration|data|activity)?',
    exact: true
};

});

parcelRegister("gxgQp", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerDataSourceEntryPoint", () => $641e26551df5e4e8$export$bd7cd6f2edc69e5c);

var $3KsPd = parcelRequire("3KsPd");

var $4RYvN = parcelRequire("4RYvN");

var $6fPdh = parcelRequire("6fPdh");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");
const $641e26551df5e4e8$var$TABS = {
    activity: (0, $4RYvN.activityTabEntryPoint),
    configuration: (0, $3KsPd.configurationTabEntryPoint),
    data: (0, $6fPdh.dataTabEntryPoint)
};
const $641e26551df5e4e8$var$DEFAULT_TAB = 'configuration';
const $641e26551df5e4e8$var$isValidTab = (tab)=>typeof tab === 'string' && Object.keys($641e26551df5e4e8$var$TABS).includes(tab);

const $641e26551df5e4e8$export$bd7cd6f2edc69e5c = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("4nAMs")), {
        moduleId: "bcbb9c89",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: { params: params } } })=>{
        const validTab = $641e26551df5e4e8$var$isValidTab(params?.tab) ? params.tab : $641e26551df5e4e8$var$DEFAULT_TAB;
        return {
            entryPoints: {
                [validTab]: {
                    entryPoint: $641e26551df5e4e8$var$TABS[validTab],
                    entryPointParams: {}
                }
            }
        };
    }
});

});
parcelRegister("3KsPd", function(module, exports) {

$parcel$export(module.exports, "configurationTabEntryPoint", () => $4e27342556a4f81a$export$ec8b29e0134d3c80);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $4e27342556a4f81a$export$ec8b29e0134d3c80 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("7LS5H")), {
        moduleId: "8ece29ab",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("7LS5H", function(module, exports) {

let $5a86e188e24cc198$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5a86e188e24cc198$var$load("gdp0d").then(()=>parcelRequire('lknDq'));

});


parcelRegister("4RYvN", function(module, exports) {

$parcel$export(module.exports, "activityTabEntryPoint", () => $055b10c96e643d07$export$1ce14f1f05d013dc);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $055b10c96e643d07$export$1ce14f1f05d013dc = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("6a2LH")), {
        moduleId: "8f8064ae",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("6a2LH", function(module, exports) {

let $47c5d2fab2f3b992$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $47c5d2fab2f3b992$var$load("20Rn5").then(()=>parcelRequire('8ehFz'));

});


parcelRegister("6fPdh", function(module, exports) {

$parcel$export(module.exports, "dataTabEntryPoint", () => $27844a7d253117b1$export$5b828465e64ab503);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $27844a7d253117b1$export$5b828465e64ab503 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("2c8Zd")), {
        moduleId: "824801bf",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("2c8Zd", function(module, exports) {

let $1993ac43d86463d6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1993ac43d86463d6$var$load("ls4Bu").then(()=>parcelRequire('4R9ta'));

});


parcelRegister("4nAMs", function(module, exports) {

let $3305d74965cf23f5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3305d74965cf23f5$var$load("kOtgn").then(()=>parcelRequire('lewnL'));

});



parcelRegister("hMZzF", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerGettingStartedRouteEntry", () => $5897632d2e41489a$export$d9a1c48acd35cf03);

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $7TdbO = parcelRequire("7TdbO");

var $g8uYY = parcelRequire("g8uYY");

var $kAJP5 = parcelRequire("kAJP5");

var $gy2Qg = parcelRequire("gy2Qg");

var $f1zun = parcelRequire("f1zun");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $5897632d2e41489a$var$assetsDataManagerGettingStartedPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $kAJP5.assetsDataManagerGettingStartedEntryPoint)
});
const $5897632d2e41489a$export$d9a1c48acd35cf03 = (0, $6xToB.createEntry)((0, $7TdbO.assetsDataManagerGettingStartedRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        perfMetricKey: 'assets-data-manager-getting-started',
        ufoName: 'assets-data-manager-getting-started',
        pageId: ()=>'spa-apps/assets-data-manager-getting-started',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $7jTnu.fg)('assets_data_manager_jira_spa') ? $5897632d2e41489a$var$assetsDataManagerGettingStartedPageEntryPoint : undefined;
        },
        component: (0, $7jTnu.fg)('assets_data_manager_jira_spa') ? undefined : (0, $9BJU1.default),
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE),
                teamName: 'Aurum'
            }
        }
    }));

});
parcelRegister("7TdbO", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerGettingStartedRoute", () => $28768b4f8a84fec8$export$82de2af972f327f8);
const $28768b4f8a84fec8$export$82de2af972f327f8 = {
    name: 'assets-data-manager-getting-started',
    path: '/jira/assets/data-manager/getting-started',
    exact: true
};

});

parcelRegister("kAJP5", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerGettingStartedEntryPoint", () => $f1038a2d162bd607$export$4f270d89a19b2303);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $f1038a2d162bd607$export$4f270d89a19b2303 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("jbwyK")), {
        moduleId: "69964d1d",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jbwyK", function(module, exports) {

let $df784d01f9298cbf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $df784d01f9298cbf$var$load("5KtUO").then(()=>parcelRequire('aO1kd'));

});



parcelRegister("jVidq", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerObjectClassesRouteEntry", () => $e679bfb714460f6b$export$21baed265eb8be15);

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $8Wz9C = parcelRequire("8Wz9C");

var $g8uYY = parcelRequire("g8uYY");

var $gy2Qg = parcelRequire("gy2Qg");

var $f1zun = parcelRequire("f1zun");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");

var $lIIas = parcelRequire("lIIas");
const $e679bfb714460f6b$var$assetsDataManagerObjectClassesPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $lIIas.assetsDataManagerObjectClassesEntryPoint)
});
const $e679bfb714460f6b$export$21baed265eb8be15 = (0, $6xToB.createEntry)((0, $8Wz9C.assetsDataManagerObjectClassesRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        perfMetricKey: 'assets-data-manager-object-classes',
        pageId: ()=>'spa-apps/assets-data-manager-object-classes',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $7jTnu.fg)('assets_data_manager_jira_spa') ? $e679bfb714460f6b$var$assetsDataManagerObjectClassesPageEntryPoint : undefined;
        },
        component: (0, $7jTnu.fg)('assets_data_manager_jira_spa') ? undefined : (0, $9BJU1.default),
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE),
                teamName: 'Aurum'
            }
        }
    }));

});
parcelRegister("8Wz9C", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerObjectClassesRoute", () => $0ba95430cf0e8191$export$efbc59a0b92a1a13);
const $0ba95430cf0e8191$export$efbc59a0b92a1a13 = {
    name: 'assets-data-manager-object-classes',
    path: '/jira/assets/data-manager/object-classes',
    exact: true
};

});

parcelRegister("lIIas", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerObjectClassesEntryPoint", () => $1c1bed0ca14dbe32$export$c1881c035be68200);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $1c1bed0ca14dbe32$export$c1881c035be68200 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("j34cC")), {
        moduleId: "1ab370bf",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("j34cC", function(module, exports) {

let $dde18ea6551e7c12$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dde18ea6551e7c12$var$load("6sPso").then(()=>parcelRequire('idjoc'));

});



parcelRegister("c7xWN", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerObjectClassViewRouteEntry", () => $036890fedb18aca5$export$f4973dfdf4833835);

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $ll0DL = parcelRequire("ll0DL");

var $g8uYY = parcelRequire("g8uYY");

var $gy2Qg = parcelRequire("gy2Qg");

var $f1zun = parcelRequire("f1zun");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");

var $3cnp7 = parcelRequire("3cnp7");
const $036890fedb18aca5$var$assetsDataManagerObjectClassViewPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $3cnp7.assetsDataManagerObjectClassViewEntryPoint)
});
const $036890fedb18aca5$export$f4973dfdf4833835 = (0, $6xToB.createEntry)((0, $ll0DL.assetsDataManagerObjectClassViewRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        perfMetricKey: 'assets-data-manager-object-class-view',
        pageId: ()=>'spa-apps/assets-data-manager-object-class-view',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $7jTnu.fg)('assets_data_manager_jira_spa') ? $036890fedb18aca5$var$assetsDataManagerObjectClassViewPageEntryPoint : undefined;
        },
        component: (0, $7jTnu.fg)('assets_data_manager_jira_spa') ? undefined : (0, $9BJU1.default),
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_VIEW_PAGE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_VIEW_PAGE),
                teamName: 'Aurum'
            }
        }
    }));

});
parcelRegister("ll0DL", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerObjectClassViewRoute", () => $14649825280192a3$export$88a05b032620e348);
const $14649825280192a3$export$88a05b032620e348 = {
    name: 'assets-data-manager-object-class-view',
    path: '/jira/assets/data-manager/object-classes/view/:objectClassId',
    exact: true,
    query: [
        'tab'
    ]
};

});

parcelRegister("3cnp7", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerObjectClassViewEntryPoint", () => $46d16f65bbfd7d8c$export$a02bbc7f46f6a7cc);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

var $6b7zr = parcelRequire("6b7zr");

var $3vktg = parcelRequire("3vktg");

var $9yo7u = parcelRequire("9yo7u");

const $46d16f65bbfd7d8c$export$a02bbc7f46f6a7cc = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("amZYV")), {
        moduleId: "6716a723",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { query: query } })=>{
        const { tab: tab } = query;
        if (tab === 'saved-search') return {
            entryPoints: {
                savedSearchTabEntryPoint: {
                    entryPoint: (0, $6b7zr.savedSearchTabEntryPoint)
                }
            }
        };
        if (tab === 'tags') return {
            entryPoints: {
                tagsTabEntryPoint: {
                    entryPoint: (0, $3vktg.tagsTabEntryPoint)
                }
            }
        };
        // default to objects tab
        return {
            entryPoints: {
                objectsTabEntryPoint: {
                    entryPoint: (0, $9yo7u.objectsTabEntryPoint)
                }
            }
        };
    }
});

});
parcelRegister("6b7zr", function(module, exports) {

$parcel$export(module.exports, "savedSearchTabEntryPoint", () => $a08ad4c4b241d65a$export$892a185cebc12244);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $a08ad4c4b241d65a$export$892a185cebc12244 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("6KvA1")), {
        moduleId: "ec46ba1c",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("6KvA1", function(module, exports) {

let $4e9f89126fcc14ee$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4e9f89126fcc14ee$var$load("gcNJE").then(()=>parcelRequire('jOpec'));

});


parcelRegister("3vktg", function(module, exports) {

$parcel$export(module.exports, "tagsTabEntryPoint", () => $866793a24aa63e23$export$f5b804ece08cf9c8);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $866793a24aa63e23$export$f5b804ece08cf9c8 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("hSsLg")), {
        moduleId: "23653f96",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("hSsLg", function(module, exports) {

let $d03dca317d5c90f6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d03dca317d5c90f6$var$load("jk9jy").then(()=>parcelRequire('6P642'));

});


parcelRegister("9yo7u", function(module, exports) {

$parcel$export(module.exports, "objectsTabEntryPoint", () => $426598a5e7aac6e1$export$c56ef5bc8d8eca35);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $426598a5e7aac6e1$export$c56ef5bc8d8eca35 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("d7sD9")), {
        moduleId: "3808433e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("d7sD9", function(module, exports) {

let $98d223397c45876f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $98d223397c45876f$var$load("4XWDr").then(()=>parcelRequire('gn51B'));

});


parcelRegister("amZYV", function(module, exports) {

let $78cc09b6fe9879e9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $78cc09b6fe9879e9$var$load("4Okki").then(()=>parcelRequire('2D4CV'));

});



parcelRegister("bGwGo", function(module, exports) {

$parcel$export(module.exports, "assetsObjectRouteEntry", () => $096a76917fab2176$export$17871a1fbc6e31db);

var $6xToB = parcelRequire("6xToB");

var $7PjwP = parcelRequire("7PjwP");

var $PgORA = parcelRequire("PgORA");

var $f1zun = parcelRequire("f1zun");

var $93pOA = parcelRequire("93pOA");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $096a76917fab2176$var$assetsObjectPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $93pOA.assetsObjectViewEntryPoint)
});
const $096a76917fab2176$export$17871a1fbc6e31db = (0, $6xToB.createEntry)((0, $PgORA.assetsObjectRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$096a76917fab2176$var$assetsObjectPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-v2',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            (0, $7PjwP.insightObjectResource)
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    }));

});
parcelRegister("7PjwP", function(module, exports) {

$parcel$export(module.exports, "insightObjectResource", () => $f3a1a368cc3b7c59$export$215464c8085c5e35);

var $l1VxS = parcelRequire("l1VxS");

var $8cp50 = parcelRequire("8cp50");
const $f3a1a368cc3b7c59$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT = 'SERVICEDESK_INSIGHT_OBJECT';
const $f3a1a368cc3b7c59$export$215464c8085c5e35 = (0, $l1VxS.createResource)({
    type: $f3a1a368cc3b7c59$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT,
    getKey: ({ match: match })=>match.params.objectId || '',
    getData: $8cp50.default,
    isBrowserOnly: true
});

});
parcelRegister("8cp50", function(module, exports) {

$parcel$export(module.exports, "default", () => $00665b5d70bca074$export$2e2bcd8739ae039);

var $6uWhG = parcelRequire("6uWhG");

var $eSnSE = parcelRequire("eSnSE");

var $51aj0 = parcelRequire("51aj0");

var $1Ozm9 = parcelRequire("1Ozm9");

var $4kMB4 = parcelRequire("4kMB4");

var $7hVvO = parcelRequire("7hVvO");

var $8rYjX = parcelRequire("8rYjX");

var $jopyG = parcelRequire("jopyG");

var $aV23b = parcelRequire("aV23b");
const $00665b5d70bca074$var$fetchInsightObjectDetails = async (routeDataContext, storeContext)=>{
    try {
        const { match: { params: params } } = routeDataContext;
        const { objectId: objectId } = params;
        if (objectId == null) return null;
        const workspaceId = await (0, $jopyG.default)(routeDataContext, storeContext);
        if (workspaceId == null) return null;
        const data = await (0, $1Ozm9.default)((0, $8rYjX.getCmdbObjectByIdUrl)(workspaceId, objectId));
        (0, $6uWhG.setMark)((0, $4kMB4.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraServicedeskInsightObjectResource', error);
        (0, $51aj0.fireCmdbErrorAnalytics)({
            meta: {
                id: 'jiraServicedeskInsightObjectResource',
                packageName: 'jiraSpa'
            },
            error: error
        });
        throw error;
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$00665b5d70bca074$export$2e2bcd8739ae039 = async (routeDataContext, storeContext)=>{
    const { tenantContext: tenantContext } = storeContext;
    // Early exit on these cases and return a valid response. We don't want to flood sentry.
    if (!(0, $aV23b.checkAuthentication)(tenantContext)) throw (0, $7hVvO.createResourceError)({
        component: 'spa.view.routes.servicedesk.cmdb-object.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    return $00665b5d70bca074$var$fetchInsightObjectDetails(routeDataContext, storeContext);
};

});
parcelRegister("51aj0", function(module, exports) {

$parcel$export(module.exports, "fireCmdbErrorAnalytics", () => $56baf2f8ac73469d$export$50d4fa14efd248c2);

var $gYnSx = parcelRequire("gYnSx");
const $56baf2f8ac73469d$export$50d4fa14efd248c2 = (payload)=>{
    return (0, $gYnSx.default)(payload);
};

});

parcelRegister("4kMB4", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $2b841d37299dd740$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $2b841d37299dd740$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $2b841d37299dd740$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $2b841d37299dd740$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $2b841d37299dd740$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $2b841d37299dd740$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $2b841d37299dd740$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $2b841d37299dd740$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $2b841d37299dd740$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $2b841d37299dd740$export$4eb8d44ddb14424a);


var $dNyX9 = parcelRequire("dNyX9");
const $2b841d37299dd740$export$7e50945a65dd40e = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$ff834eccc35b9089));
const $2b841d37299dd740$export$17cbe723d23101d8 = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$86b05e34d462ead8));
const $2b841d37299dd740$export$887fadb22e7c7735 = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$d6a604a7d9a390fb));
const $2b841d37299dd740$export$bd099c0a906f4b3f = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$3ae43cc1782d058f));
const $2b841d37299dd740$export$d23ef9e7633e30e7 = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$363f6703ffa600be));
const $2b841d37299dd740$export$319da6d901948a6d = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$e87b74567b79c8));
const $2b841d37299dd740$export$f0b6622cdc5c7e4f = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$99fe642459a8b02));
const $2b841d37299dd740$export$37e82663aa1e79a8 = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$ab1f5705fc8e0571));
const $2b841d37299dd740$export$21146514eacceb12 = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$8c3a9046da692c35));
const $2b841d37299dd740$export$4eb8d44ddb14424a = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$5aa497d1efdcc5bf));

});

parcelRegister("8rYjX", function(module, exports) {

$parcel$export(module.exports, "getCmdbObjectByIdUrl", () => $51ae915a9d99dfd8$export$d33c3e25476d091d);
$parcel$export(module.exports, "getCmdbObjectByIdUrlWithoutQueryParams", () => $51ae915a9d99dfd8$export$6ef8997552257871);
$parcel$export(module.exports, "getCmdbObjectByIdActivityUrl", () => $51ae915a9d99dfd8$export$20c207abffb62450);
$parcel$export(module.exports, "getCmdbObjectByIdAvatarUrl", () => $51ae915a9d99dfd8$export$31df868d16d545f8);
$parcel$export(module.exports, "getCmdbObjectByIdReferenceInfoUrl", () => $51ae915a9d99dfd8$export$5044a1e9fc201773);
$parcel$export(module.exports, "getCmdbObjectCloneByIdUrl", () => $51ae915a9d99dfd8$export$d7f6dc1d4f622458);
$parcel$export(module.exports, "getCmdbObjectCreateUrl", () => $51ae915a9d99dfd8$export$9cdc19e8944d38cf);
$parcel$export(module.exports, "getCmdbObjectNavlistUrl", () => $51ae915a9d99dfd8$export$bf9c534c2cd21829);
$parcel$export(module.exports, "getCmdbObjectNavlistQueryLanguageUrl", () => $51ae915a9d99dfd8$export$b35334340ee827fa);
$parcel$export(module.exports, "getCmdbObjectRecentUrl", () => $51ae915a9d99dfd8$export$a0a7c6f22bebdef0);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageTotalCountUrl", () => $51ae915a9d99dfd8$export$ee74f95a469c4433);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageUrl", () => $51ae915a9d99dfd8$export$84a34ee3f18e226);
$parcel$export(module.exports, "getCmdbAsyncObjectExportUrl", () => $51ae915a9d99dfd8$export$878b627ac685384e);
$parcel$export(module.exports, "getCmdbAsyncBulkQrCodeUrl", () => $51ae915a9d99dfd8$export$8eb3a6b36886db0);
$parcel$export(module.exports, "getCmdbAsyncGenerateUaDuplicatesReportUrl", () => $51ae915a9d99dfd8$export$54601fa587b1cebb);
$parcel$export(module.exports, "getCmdbAsyncBulkDeleteUrl", () => $51ae915a9d99dfd8$export$b02201bcaeb75291);
$parcel$export(module.exports, "getCmdbAsyncBulkEditUrl", () => $51ae915a9d99dfd8$export$f4d68a6f0e3217b5);
$parcel$export(module.exports, "getCmdbAsyncCdmBundleInstantiationUrl", () => $51ae915a9d99dfd8$export$ae8f0647f4610496);

var $b5RwB = parcelRequire("b5RwB");

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object
 */ const $51ae915a9d99dfd8$var$getCmdbObjectUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/object`;
const $51ae915a9d99dfd8$export$d33c3e25476d091d = (workspaceId, objectId, includeExtendedInfo = false)=>{
    const path = $51ae915a9d99dfd8$export$6ef8997552257871(workspaceId, objectId);
    if (!includeExtendedInfo) return `${path}?${(0, $b5RwB.stringify)({
        includeExtendedInfo: includeExtendedInfo
    })}`;
    return path;
};
const $51ae915a9d99dfd8$export$6ef8997552257871 = (workspaceId, objectId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/${objectId}`;
const $51ae915a9d99dfd8$export$20c207abffb62450 = (workspaceId, objectId, queryParams)=>`${$51ae915a9d99dfd8$export$6ef8997552257871(workspaceId, objectId)}/activity?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$31df868d16d545f8 = (workspaceId, objectId)=>`${$51ae915a9d99dfd8$export$6ef8997552257871(workspaceId, objectId)}/avatar`;
const $51ae915a9d99dfd8$export$5044a1e9fc201773 = (workspaceId, objectId)=>`${$51ae915a9d99dfd8$export$6ef8997552257871(workspaceId, objectId)}/referenceinfo`;
const $51ae915a9d99dfd8$export$d7f6dc1d4f622458 = (workspaceId, objectId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/clone/${objectId}`;
const $51ae915a9d99dfd8$export$9cdc19e8944d38cf = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/create`;
const $51ae915a9d99dfd8$export$bf9c534c2cd21829 = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/navlist`;
const $51ae915a9d99dfd8$export$b35334340ee827fa = (workspaceId)=>`${$51ae915a9d99dfd8$export$bf9c534c2cd21829(workspaceId)}/aql`;
const $51ae915a9d99dfd8$export$a0a7c6f22bebdef0 = (workspaceId, queryParams)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/recent?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$ee74f95a469c4433 = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/aql/totalcount`;
const $51ae915a9d99dfd8$export$1016ae73c04d9079 = (workspaceId, queryParams)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/search?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$cb41514f2508b033 = (workspaceId, queryParams)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/searchbyattributes?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$84a34ee3f18e226 = (workspaceId, queryParams)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/aql?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$878b627ac685384e = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/bulkexport`;
const $51ae915a9d99dfd8$export$8eb3a6b36886db0 = (workspaceId, queryParams)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/bulkqrcode?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$54601fa587b1cebb = (workspaceId, objectTypeAttributeId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/objecttypeattribute/${objectTypeAttributeId}/generate-ua-duplicates-report`;
const $51ae915a9d99dfd8$export$b02201bcaeb75291 = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/bulkdelete`;
const $51ae915a9d99dfd8$export$f4d68a6f0e3217b5 = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/bulkedit`;
const $51ae915a9d99dfd8$export$ae8f0647f4610496 = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/bundle/instantiate/async`;

});
parcelRegister("1qZG3", function(module, exports) {

$parcel$export(module.exports, "getCmdbRestBaseUrl", () => $b2cddbf560b62359$export$28b6c003daedf1c2);
const $b2cddbf560b62359$export$28b6c003daedf1c2 = (workspaceId)=>`/gateway/api/jsm/assets/workspace/${workspaceId}/v1`;

});




parcelRegister("PgORA", function(module, exports) {

$parcel$export(module.exports, "assetsObjectRoute", () => $8a8f114df4a73d0f$export$8f0b5215230b6dd1);
const $8a8f114df4a73d0f$export$8f0b5215230b6dd1 = {
    name: 'assets-object',
    path: '/jira/assets/object/:objectId'
};

});

parcelRegister("93pOA", function(module, exports) {

$parcel$export(module.exports, "assetsObjectViewEntryPoint", () => $d901c6c7d8ad50f2$export$4311ec530d21ec36);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $d901c6c7d8ad50f2$export$4311ec530d21ec36 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("amEmz")), {
        moduleId: "5026c489",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("amEmz", function(module, exports) {

let $78bb44b4a83a477f$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $78bb44b4a83a477f$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $78bb44b4a83a477f$var$load("deNlq")
        ]);
    }),
    $78bb44b4a83a477f$var$load("1VRB2"),
    $78bb44b4a83a477f$var$load("bABhq"),
    $78bb44b4a83a477f$var$load("k4gbU"),
    $78bb44b4a83a477f$var$load("7vqGd"),
    $78bb44b4a83a477f$var$load("1Y4bq"),
    $78bb44b4a83a477f$var$load("eDzss"),
    $78bb44b4a83a477f$var$load("d77xE")
]).then(()=>parcelRequire('5JaU6'));

});



parcelRegister("dRVNt", function(module, exports) {

$parcel$export(module.exports, "assetsObjectTypeConfigurationRouteEntry", () => $0b4d5812291813b2$export$28b088de21f264eb);

var $6xToB = parcelRequire("6xToB");

var $gc68d = parcelRequire("gc68d");

var $gy2Qg = parcelRequire("gy2Qg");

var $f1zun = parcelRequire("f1zun");

var $9NZbc = parcelRequire("9NZbc");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $0b4d5812291813b2$var$assetsObjectTypeSettingsPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $9NZbc.assetsObjectTypeSettingsEntryPoint)
});
const $0b4d5812291813b2$export$28b088de21f264eb = (0, $6xToB.createEntry)((0, $gc68d.assetsObjectTypeConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$0b4d5812291813b2$var$assetsObjectTypeSettingsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-configure-object-type',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'aurum'
            }
        },
        ufoName: 'service-management.insight-cmdb-object-type-configuration'
    }));

});
parcelRegister("gc68d", function(module, exports) {

$parcel$export(module.exports, "assetsObjectTypeConfigurationRoute", () => $b4132ba2c48128c9$export$fe5957039840ffd3);
const $b4132ba2c48128c9$export$fe5957039840ffd3 = {
    name: 'assets-object-type-configuration',
    path: '/jira/assets/configure/object-type/:objectTypeId'
};

});

parcelRegister("9NZbc", function(module, exports) {

$parcel$export(module.exports, "assetsObjectTypeSettingsEntryPoint", () => $e08925e93db50e8b$export$fab2e471b162aafc);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $e08925e93db50e8b$export$fab2e471b162aafc = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("gYoIL")), {
        moduleId: "b4d985ee",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gYoIL", function(module, exports) {

let $c5b56d083492e7d7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c5b56d083492e7d7$var$load("7s7qP").then(()=>parcelRequire('hKEgw'));

});



parcelRegister("9qNa5", function(module, exports) {

$parcel$export(module.exports, "assetsReportsRouteEntry", () => $9b33e3b8feb155b7$export$dabfe6668c5a0cc4);

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $5ZtxG = parcelRequire("5ZtxG");

var $gy2Qg = parcelRequire("gy2Qg");

var $g28xe = parcelRequire("g28xe");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $f1zun = parcelRequire("f1zun");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $9b33e3b8feb155b7$var$assetsReportsPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $g28xe.assetsReportsNav4HomeEntryPoint)
});
const $9b33e3b8feb155b7$export$dabfe6668c5a0cc4 = (0, $6xToB.createEntry)((0, $5ZtxG.assetsReportsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$9b33e3b8feb155b7$var$assetsReportsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-reports-home-page',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("5ZtxG", function(module, exports) {

$parcel$export(module.exports, "assetsReportsRoute", () => $22aae5a428d1761b$export$b123ccf7df3854f4);
const $22aae5a428d1761b$export$b123ccf7df3854f4 = {
    name: 'assets-reports-default-redirect',
    path: '/jira/assets/reports',
    exact: true
};

});

parcelRegister("g28xe", function(module, exports) {

$parcel$export(module.exports, "assetsReportsNav4HomeEntryPoint", () => $3a38341cab08552f$export$1a891b207b85b219);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $3a38341cab08552f$export$1a891b207b85b219 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("4S7lO")).then((module)=>module.AssetsReportsNav4HomePage), {
        moduleId: "cd1143ba",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4S7lO", function(module, exports) {

let $38c1e84e8b53c1fb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $38c1e84e8b53c1fb$var$load("1VRB2"),
    $38c1e84e8b53c1fb$var$load("bABhq"),
    $38c1e84e8b53c1fb$var$load("fi6my")
]).then(()=>parcelRequire('7O8th'));

});



parcelRegister("2MZpi", function(module, exports) {

$parcel$export(module.exports, "assetsReportsTemplateRouteEntry", () => $c8133c69269b45d5$export$c69d6dbd8091ce7b);

var $5RW99 = parcelRequire("5RW99");

var $5gQb9 = parcelRequire("5gQb9");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $hoXzm = parcelRequire("hoXzm");

var $gy2Qg = parcelRequire("gy2Qg");

var $c1dkq = parcelRequire("c1dkq");

var $f1zun = parcelRequire("f1zun");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $c8133c69269b45d5$export$c69d6dbd8091ce7b = (0, $6xToB.createEntry)((0, $hoXzm.assetsReportsTemplateRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        component: (0, $c1dkq.AssetsReports),
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout),
            (0, $c1dkq.LazyServicedeskCmdbAssetsReports)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $5gQb9.default)
        },
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS),
                teamName: 'ITSM SAGA'
            }
        },
        perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template'
    }));

});
parcelRegister("5gQb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ee3aba4039716b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $59ee3aba4039716b$export$2260a0528570f8da = (0, $gzcjr.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("aE4lz")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/assets-reports/src/index.tsx"
});
const $59ee3aba4039716b$var$AssetsReportsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "assets-reports-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59ee3aba4039716b$export$2260a0528570f8da, null)));
$59ee3aba4039716b$var$AssetsReportsSidebar.displayName = 'AssetsReportsSidebar';
var $59ee3aba4039716b$export$2e2bcd8739ae039 = $59ee3aba4039716b$var$AssetsReportsSidebar;

});
parcelRegister("aE4lz", function(module, exports) {

let $7c0103000ab59b28$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7c0103000ab59b28$var$load("cXFRa").then(()=>parcelRequire('1znBb'));

});


parcelRegister("hoXzm", function(module, exports) {

$parcel$export(module.exports, "assetsReportsTemplateRoute", () => $f304f1ced63507b5$export$4255578ec14d83bb);
const $f304f1ced63507b5$export$4255578ec14d83bb = {
    name: 'assets-reports',
    path: '/jira/assets/reports/:templateId',
    exact: true
};

});

parcelRegister("c1dkq", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReports", () => $4f61b729325f7e0f$export$9f75cdfdfe8c8aaa);
$parcel$export(module.exports, "LazyServicedeskCmdbDefaultReportsRedirect", () => $4f61b729325f7e0f$export$2534c3e9f8e70d0d);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReportsUnsubscribe", () => $4f61b729325f7e0f$export$dec85f15dd805ac4);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReportsNav4HomePage", () => $4f61b729325f7e0f$export$c56cfef9aa68df09);
$parcel$export(module.exports, "AssetsReports", () => $4f61b729325f7e0f$export$d45b40d40442434);
$parcel$export(module.exports, "AssetsReportsUnsubscribe", () => $4f61b729325f7e0f$export$541b39e6d5be07df);
$parcel$export(module.exports, "AssetsReportingDefaultRedirect", () => $4f61b729325f7e0f$export$4155da54bfeacf74);
$parcel$export(module.exports, "AssetsReportsNav4HomePage", () => $4f61b729325f7e0f$export$9d28551695f98cae);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $4f61b729325f7e0f$export$9f75cdfdfe8c8aaa = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("83pJU")).then((exportedMembers)=>exportedMembers.CmdbAssetsReports), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});

const $4f61b729325f7e0f$export$2534c3e9f8e70d0d = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("83pJU")).then((exportedMembers)=>exportedMembers.CmdbDefaultReportsRedirect), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});

const $4f61b729325f7e0f$export$dec85f15dd805ac4 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("hOZIT")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports-unsubscribe/src/index.tsx"
});

const $4f61b729325f7e0f$export$c56cfef9aa68df09 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("83pJU")).then((exportedMembers)=>exportedMembers.CmdbAssetsReportsNav4HomePage), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});
const $4f61b729325f7e0f$export$d45b40d40442434 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4f61b729325f7e0f$export$9f75cdfdfe8c8aaa,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports",
        shouldShowSpinner: true
    });
const $4f61b729325f7e0f$export$541b39e6d5be07df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4f61b729325f7e0f$export$dec85f15dd805ac4,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe",
        shouldShowSpinner: true
    });
const $4f61b729325f7e0f$export$4155da54bfeacf74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4f61b729325f7e0f$export$2534c3e9f8e70d0d,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-default-redirect",
        shouldShowSpinner: true
    });
const $4f61b729325f7e0f$export$9d28551695f98cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4f61b729325f7e0f$export$c56cfef9aa68df09,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-home-page",
        shouldShowSpinner: true
    });

});
parcelRegister("83pJU", function(module, exports) {

let $5dd291deec587832$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("1zzhg"), 4)),
    $5dd291deec587832$var$load("1VRB2"),
    $5dd291deec587832$var$load("bABhq"),
    $5dd291deec587832$var$load("7vqGd"),
    $5dd291deec587832$var$load("1Y4bq"),
    $5dd291deec587832$var$load("iJMrx")
]).then(()=>parcelRequire('a0KLt'));

});

parcelRegister("hOZIT", function(module, exports) {

let $cf96fc1e45ef7672$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    $cf96fc1e45ef7672$var$load("1VRB2"),
    $cf96fc1e45ef7672$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("gSZET"), 4)),
    $cf96fc1e45ef7672$var$load("7vqGd"),
    $cf96fc1e45ef7672$var$load("1Y4bq"),
    $cf96fc1e45ef7672$var$load("3z6FI")
]).then(()=>parcelRequire('coSZV'));

});



parcelRegister("5JNuq", function(module, exports) {

$parcel$export(module.exports, "assetsReportsUnsubscribeRouteEntry", () => $f35349d255ba78de$export$25e4df4267166d6b);

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $1gL8D = parcelRequire("1gL8D");

var $gy2Qg = parcelRequire("gy2Qg");

var $eStGB = parcelRequire("eStGB");

var $g8uYY = parcelRequire("g8uYY");

var $f1zun = parcelRequire("f1zun");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $f35349d255ba78de$var$assetsReportsUnsubscribePageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $eStGB.assetsReportsUnsubscribeEntryPoint)
});
const $f35349d255ba78de$export$25e4df4267166d6b = (0, $6xToB.createEntry)((0, $1gL8D.assetsReportsUnsubscribeRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$f35349d255ba78de$var$assetsReportsUnsubscribePageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("1gL8D", function(module, exports) {

$parcel$export(module.exports, "assetsReportsUnsubscribeRoute", () => $a9678985ec3fd56a$export$2b543c10e2c9e843);
const $a9678985ec3fd56a$export$2b543c10e2c9e843 = {
    name: 'assets-reports-unsubscribe',
    path: '/jira/assets/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});

parcelRegister("eStGB", function(module, exports) {

$parcel$export(module.exports, "assetsReportsUnsubscribeEntryPoint", () => $ce345f15dfec188a$export$d827c87e65bb6e47);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $ce345f15dfec188a$export$d827c87e65bb6e47 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("hOZIT")), {
        moduleId: "fe8b4981",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("1w4c6", function(module, exports) {

$parcel$export(module.exports, "assetsRouteEntry", () => $010b3f3a8e5db0b7$export$7069f3fb497264f1);

var $6xToB = parcelRequire("6xToB");

var $Ca4n2 = parcelRequire("Ca4n2");

var $f1zun = parcelRequire("f1zun");

var $g8uYY = parcelRequire("g8uYY");

var $6rtcv = parcelRequire("6rtcv");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $010b3f3a8e5db0b7$var$assetsPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $6rtcv.landingPageEntryPoint)
});
const $010b3f3a8e5db0b7$export$7069f3fb497264f1 = (0, $6xToB.createEntry)((0, $Ca4n2.assetsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$010b3f3a8e5db0b7$var$assetsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-landing-page',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page',
        ufoName: 'assets-app-landing-page'
    }));

});
parcelRegister("Ca4n2", function(module, exports) {

$parcel$export(module.exports, "assetsRoute", () => $36c01e828318f2e7$export$70dab2ea29192797);
const $36c01e828318f2e7$export$70dab2ea29192797 = {
    name: 'assets',
    path: '/jira/assets',
    exact: true
};

});

parcelRegister("6rtcv", function(module, exports) {

$parcel$export(module.exports, "landingPageEntryPoint", () => $65704b3640e7730a$export$36d88a15c123c06);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $65704b3640e7730a$export$36d88a15c123c06 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("1kNjT")), {
        moduleId: "60961f22",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1kNjT", function(module, exports) {

let $0f8dea9b3a65deb0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $0f8dea9b3a65deb0$var$load("1VRB2"),
    $0f8dea9b3a65deb0$var$load("bABhq"),
    $0f8dea9b3a65deb0$var$load("aoJDF")
]).then(()=>parcelRequire('8KJda'));

});



parcelRegister("bP5Jb", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaConfigurationRouteEntry", () => $6e3ee8fe9879bd63$export$6c9c29c3048f2e2c);

var $6xToB = parcelRequire("6xToB");

var $gBOsl = parcelRequire("gBOsl");

var $blice = parcelRequire("blice");

var $gy2Qg = parcelRequire("gy2Qg");

var $f1zun = parcelRequire("f1zun");

var $4pMHI = parcelRequire("4pMHI");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $6e3ee8fe9879bd63$var$assetsSchemaSettingsPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $4pMHI.assetsSchemaSettingsEntryPoint)
});
const $6e3ee8fe9879bd63$export$6c9c29c3048f2e2c = (0, $6xToB.createEntry)((0, $blice.assetsSchemaConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$6e3ee8fe9879bd63$var$assetsSchemaSettingsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-schema-configuration',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            (0, $gBOsl.serviceDeskAssetsImportTypeForgeDataResource)
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }));

});
parcelRegister("gBOsl", function(module, exports) {

$parcel$export(module.exports, "serviceDeskAssetsImportTypeForgeDataResource", () => $169a2c7b3c726d2d$export$58d2462746e91c7d);

var $l1VxS = parcelRequire("l1VxS");

const $169a2c7b3c726d2d$var$getDataLoader = ()=>(parcelRequire("krm6W"));
const $169a2c7b3c726d2d$export$58d2462746e91c7d = (0, $l1VxS.createResource)({
    type: 'ASSETS_IMPORT_TYPE_FORGE_DATA',
    getKey: ()=>'extensions',
    getDataLoader: $169a2c7b3c726d2d$var$getDataLoader,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("krm6W", function(module, exports) {

let $ee177b0da3c4e789$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ee177b0da3c4e789$var$load("bwTeo").then(()=>parcelRequire('9bIwZ'));

});


parcelRegister("blice", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaConfigurationRoute", () => $a970258c7f6548d8$export$f27e51e1e8d78f80);
const $a970258c7f6548d8$export$f27e51e1e8d78f80 = {
    name: 'assets-schema-configuration',
    path: '/jira/assets/configure/object-schema/:objectSchemaId'
};

});

parcelRegister("4pMHI", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaSettingsEntryPoint", () => $61720552b6a91e52$export$b012e15a5f6394fc);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $61720552b6a91e52$export$b012e15a5f6394fc = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("iG7lW")), {
        moduleId: "c93bb7f3",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iG7lW", function(module, exports) {

let $d991da64741ed527$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d991da64741ed527$var$load("8nyLV").then(()=>parcelRequire('lTK0k'));

});



parcelRegister("d065h", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaRouteEntry", () => $05ce94c1d9ea5a81$export$92c5054123a75324);

var $6xToB = parcelRequire("6xToB");

var $cVSNO = parcelRequire("cVSNO");

var $f1zun = parcelRequire("f1zun");

var $ofVNb = parcelRequire("ofVNb");

var $abvGw = parcelRequire("abvGw");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $05ce94c1d9ea5a81$var$assetsSchemaPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $abvGw.assetsSchemaEntryPoint)
});
const $05ce94c1d9ea5a81$export$92c5054123a75324 = (0, $6xToB.createEntry)((0, $cVSNO.assetsSchemaRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        component: (0, $ofVNb.ObjectSchemaV2),
        entryPoint: ()=>$05ce94c1d9ea5a81$var$assetsSchemaPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-schema',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }));

});
parcelRegister("cVSNO", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaRoute", () => $6c4e152300a1e78b$export$9515b8d2f9c8b12d);
const $6c4e152300a1e78b$export$9515b8d2f9c8b12d = {
    name: 'assets-schema',
    path: '/jira/assets/object-schema/:objectSchemaId'
};

});

parcelRegister("ofVNb", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbObjectSchemaV2", () => $a2f819b490210785$export$1e50d5a65ac4f5fc);
$parcel$export(module.exports, "ObjectSchemaV2", () => $a2f819b490210785$export$f90a4f33c79fd86e);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $a2f819b490210785$export$1e50d5a65ac4f5fc = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("avDVS")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-v2/src/index.tsx"
});
const $a2f819b490210785$export$f90a4f33c79fd86e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a2f819b490210785$export$1e50d5a65ac4f5fc,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema",
        shouldShowSpinner: true
    });
var $a2f819b490210785$export$2e2bcd8739ae039 = $a2f819b490210785$export$f90a4f33c79fd86e;

});
parcelRegister("avDVS", function(module, exports) {

let $7a6bc6614245ed76$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7a6bc6614245ed76$var$load("k4gbU"),
    $7a6bc6614245ed76$var$load("7vqGd"),
    $7a6bc6614245ed76$var$load("1Y4bq"),
    $7a6bc6614245ed76$var$load("8CDdk")
]).then(()=>parcelRequire('8nrlS'));

});


parcelRegister("abvGw", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaEntryPoint", () => $06b5a85ebf1ddb9e$export$bbb96f529694d699);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $06b5a85ebf1ddb9e$export$bbb96f529694d699 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("avDVS")), {
        moduleId: "a9175d64",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("7O1yF", function(module, exports) {

$parcel$export(module.exports, "assetsSearchRouteEntry", () => $b7f81eb0877e64fe$export$2a3cf8cc5b9b7e6);

var $6xToB = parcelRequire("6xToB");

var $f1zun = parcelRequire("f1zun");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $8LNzJ = parcelRequire("8LNzJ");

var $bb4Lw = parcelRequire("bb4Lw");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $b7f81eb0877e64fe$var$assetsSearchPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $bb4Lw.assetsSearchEntryPoint)
});
const $b7f81eb0877e64fe$export$2a3cf8cc5b9b7e6 = (0, $6xToB.createEntry)((0, $8LNzJ.assetsSearchRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$b7f81eb0877e64fe$var$assetsSearchPageEntryPoint,
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        perfMetricKey: 'assets-app.interact-with-search-page'
    }));

});
parcelRegister("8LNzJ", function(module, exports) {

$parcel$export(module.exports, "assetsSearchRoute", () => $75abc948211813a8$export$6d41f99fb1a055c0);
const $75abc948211813a8$export$6d41f99fb1a055c0 = {
    name: 'assets-search-results',
    path: '/jira/assets/search',
    exact: true
};

});

parcelRegister("bb4Lw", function(module, exports) {

$parcel$export(module.exports, "assetsSearchEntryPoint", () => $ab305c5e55ad49e0$export$5752b60b3fc851fc);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $ab305c5e55ad49e0$export$5752b60b3fc851fc = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("jxplW")).then((module)=>module.AssetsAppSearchEntrypointWrapper), {
        moduleId: "49468062",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jxplW", function(module, exports) {

let $e394c3f30fe615bf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $e394c3f30fe615bf$var$load("1VRB2"),
    $e394c3f30fe615bf$var$load("bABhq"),
    $e394c3f30fe615bf$var$load("hwlgY"),
    $e394c3f30fe615bf$var$load("1G8UW"),
    $e394c3f30fe615bf$var$load("iSk93"),
    $e394c3f30fe615bf$var$load("eDzss"),
    $e394c3f30fe615bf$var$load("29LcT")
]).then(()=>parcelRequire('hPrHe'));

});



parcelRegister("66eA2", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRedirectRouteEntry", () => $2ddc4acf7fd93cee$export$2a34d21ecf479c40);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $WCxDe = parcelRequire("WCxDe");

var $9NmsS = parcelRequire("9NmsS");

var $bcpTa = parcelRequire("bcpTa");

var $7fTjp = parcelRequire("7fTjp");

var $iMFdk = parcelRequire("iMFdk");

var $bNZC9 = parcelRequire("bNZC9");
const $2ddc4acf7fd93cee$var$BoardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/boards"
    });
const $2ddc4acf7fd93cee$export$2a34d21ecf479c40 = (0, $6xToB.createEntry)((0, $bcpTa.boardsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        component: $2ddc4acf7fd93cee$var$BoardsDirectoryRedirect,
        skeleton: (0, $iMFdk.BoardsDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $WCxDe.boardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bNZC9.LazyBoardsDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("WCxDe", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryResource", () => $92b2c38ae2ebdd5f$export$2646f173fa2c14f2);

var $cJYBV = parcelRequire("cJYBV");

var $l1VxS = parcelRequire("l1VxS");


const $92b2c38ae2ebdd5f$export$2646f173fa2c14f2 = (0, $l1VxS.createResource)({
    type: (0, $84af832620b9e84d$export$87526c4bd9c78abc),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("d5s9S")),
    maxAge: (0, $cJYBV.MIN_MAX_AGE)
});

});
const $84af832620b9e84d$export$87526c4bd9c78abc = 'BOARDS_DIRECTORY';

parcelRegister("d5s9S", function(module, exports) {

let $987195a4d7cd42b9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $987195a4d7cd42b9$var$load("au7iT").then(()=>parcelRequire('77vyI'));

});


parcelRegister("bcpTa", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRedirectRoute", () => $9c89e26b7d535e6d$export$a4fba1ebd6ba91ee);
const $9c89e26b7d535e6d$export$a4fba1ebd6ba91ee = {
    name: 'boards-directory-redirect',
    path: '/secure/ManageRapidViews.jspa'
};

});

parcelRegister("iMFdk", function(module, exports) {

$parcel$export(module.exports, "BoardsDirectorySkeleton", () => $c389558f405e3cf8$export$8194d6e87709f042);
$parcel$export(module.exports, "DashboardsDirectorySkeleton", () => $c389558f405e3cf8$export$75ef2bfed3801fb1);
$parcel$export(module.exports, "FiltersDirectorySkeleton", () => $c389558f405e3cf8$export$e76f94817327da1);
$parcel$export(module.exports, "ProjectsDirectorySkeleton", () => $c389558f405e3cf8$export$d94befb0e231760c);
$parcel$export(module.exports, "PlansDirectorySkeleton", () => $c389558f405e3cf8$export$6cd26a09efd6d158);

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $cYLgp = parcelRequire("cYLgp");

var $8nEBa = parcelRequire("8nEBa");

var $bydn1 = parcelRequire("bydn1");

var $kvuqG = parcelRequire("kvuqG");
const $c389558f405e3cf8$export$8194d6e87709f042 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cYLgp)))
    });
const $c389558f405e3cf8$export$75ef2bfed3801fb1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8nEBa)))
    });
const $c389558f405e3cf8$export$e76f94817327da1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bydn1)))
    });
const $c389558f405e3cf8$export$d94befb0e231760c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kvuqG)))
    });
const $c389558f405e3cf8$export$6cd26a09efd6d158 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kvuqG)))
    });

});
parcelRegister("cYLgp", function(module, exports) {
module.exports = new URL("boards-directory-app-skeleton.tpl.e4de30a4.svg", import.meta.url).toString();

});

parcelRegister("8nEBa", function(module, exports) {
module.exports = new URL("dashboards-directory-app-skeleton.tpl.eb730072.svg", import.meta.url).toString();

});

parcelRegister("bydn1", function(module, exports) {
module.exports = new URL("filters-directory-app-skeleton.tpl.6583ea61.svg", import.meta.url).toString();

});

parcelRegister("kvuqG", function(module, exports) {
module.exports = new URL("projects-directory-app-skeleton.tpl.a21368f6.svg", import.meta.url).toString();

});


parcelRegister("bNZC9", function(module, exports) {

$parcel$export(module.exports, "LazyBoardsDirectory", () => $5c7a52e194de71ac$export$2826049ae45f4cd);

var $2dJFW = parcelRequire("2dJFW");

var $gzcjr = parcelRequire("gzcjr");

const $5c7a52e194de71ac$export$2826049ae45f4cd = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7W6YV"))), {
    moduleId: "./src/packages/spa-apps/directories/boards/src/index.tsx"
});

});
parcelRegister("7W6YV", function(module, exports) {

let $5c735d99338aedc3$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $5c735d99338aedc3$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $5c735d99338aedc3$var$load("deNlq")
        ]);
    }),
    $5c735d99338aedc3$var$load("2RwAp")
]).then(()=>parcelRequire('hWHpM'));

});



parcelRegister("5GAw8", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRouteEntry", () => $409266e41ca2b14f$export$e78b34c999194638);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $WCxDe = parcelRequire("WCxDe");

var $9NmsS = parcelRequire("9NmsS");

var $3Z5Oj = parcelRequire("3Z5Oj");

var $iMFdk = parcelRequire("iMFdk");

var $1F9cm = parcelRequire("1F9cm");

var $bNZC9 = parcelRequire("bNZC9");
const $409266e41ca2b14f$var$BoardsDirectoryComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $bNZC9.LazyBoardsDirectory),
        pageId: "boards-directory",
        shouldShowSpinner: false
    });
const $409266e41ca2b14f$export$e78b34c999194638 = (0, $6xToB.createEntry)((0, $3Z5Oj.boardsDirectoryRoute), ()=>({
        group: 'directories',
        component: $409266e41ca2b14f$var$BoardsDirectoryComponent,
        skeleton: (0, $iMFdk.BoardsDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $WCxDe.boardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bNZC9.LazyBoardsDirectory)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("3Z5Oj", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRoute", () => $ac00b00f7ddabdfe$export$f0fc6f4e8be87e85);
const $ac00b00f7ddabdfe$export$f0fc6f4e8be87e85 = {
    name: 'boards-directory',
    path: '/jira/boards'
};

});


parcelRegister("amJJx", function(module, exports) {

$parcel$export(module.exports, "browseConversationsRouteEntry", () => $c6a61b8854894e5c$export$b81210c1c5fc2e86);

var $igNUx = parcelRequire("igNUx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $37gZV = parcelRequire("37gZV");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $1eu50 = parcelRequire("1eu50");

var $8PlcH = parcelRequire("8PlcH");

var $g8uYY = parcelRequire("g8uYY");

var $cAYFR = parcelRequire("cAYFR");
const $c6a61b8854894e5c$var$browseConversationsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8PlcH.browseConversationsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $c6a61b8854894e5c$export$b81210c1c5fc2e86 = (0, $6xToB.createEntry)((0, $37gZV.browseConversationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $igNUx.isFedRamp)()) return undefined;
            return $c6a61b8854894e5c$var$browseConversationsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $1eu50.VirtualAgentBrowseConversationsSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("1eu50", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentBrowseConversationsSkeleton", () => $a34e00a133ca52df$export$4a6267fad85ca589);
/* VirtualAgentBrowseConversationsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $4L4Fl = parcelRequire("4L4Fl");
const $a34e00a133ca52df$var$customStyles = null;
const $a34e00a133ca52df$export$4a6267fad85ca589 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4L4Fl))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("4L4Fl", function(module, exports) {
module.exports = new URL("virtual-agent-browse-conversations-app-skeleton.tpl.9f030add.svg", import.meta.url).toString();

});


parcelRegister("8PlcH", function(module, exports) {

$parcel$export(module.exports, "browseConversationsEntryPoint", () => $00b0d2d801d17fa4$export$38549013d5d5a440);

var $9ie1m = parcelRequire("9ie1m");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");
const $00b0d2d801d17fa4$var$DEFAULT_RANGE_DAYS = 14;

const $00b0d2d801d17fa4$export$38549013d5d5a440 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("94Q0W")), {
        moduleId: "1bf85952",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const end = new Date();
        const start = new Date(end);
        start.setDate(start.getDate() - $00b0d2d801d17fa4$var$DEFAULT_RANGE_DAYS);
        return {
            extraProps: {
                initialDateRange: {
                    start: start,
                    end: end
                }
            },
            queries: {
                page: {
                    parameters: (0, $9ie1m.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
                        startDate: start.toISOString(),
                        endDate: end.toISOString()
                    }
                }
            }
        };
    }
});

});
parcelRegister("9ie1m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c1127b61b2404c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<02c49300d32e017d0e309e7838ffebea>>
 * @relayHash 14189d9d29503aa5d6c54415cb832bc3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9413c936e6322a8457d18240233541adc6e2b37156fceda9dbaf7677f8e5299a

var $aSejq = parcelRequire("aSejq");

var $bXR9c = parcelRequire("bXR9c");
const $e1c1127b61b2404c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9413c936e6322a8457d18240233541adc6e2b37156fceda9dbaf7677f8e5299a",
        "metadata": {},
        "name": "srcVirtualAgentBrowseConversationsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcisconversationfilterenabledrelayprovider": (0, $aSejq.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $e1c1127b61b2404c$export$2e2bcd8739ae039 = $e1c1127b61b2404c$var$node;

});
parcelRegister("aSejq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9ed2eeb6b0a8b13$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $f9ed2eeb6b0a8b13$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('expose_channels_on_va_conversation_history');
    }
};

});


parcelRegister("94Q0W", function(module, exports) {

let $69bcd5b619dd62ff$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $69bcd5b619dd62ff$var$load("cWjkA").then(()=>parcelRequire('2dMY7'));

});



parcelRegister("eijnk", function(module, exports) {

$parcel$export(module.exports, "browseIntentsRouteEntry", () => $d27b926fb5493a70$export$da5f3658bd3ecdde);

var $igNUx = parcelRequire("igNUx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $azX7D = parcelRequire("azX7D");

var $gy2Qg = parcelRequire("gy2Qg");

var $fYqi8 = parcelRequire("fYqi8");

var $75uzh = parcelRequire("75uzh");

var $g8uYY = parcelRequire("g8uYY");

var $exc6Q = parcelRequire("exc6Q");

var $cAYFR = parcelRequire("cAYFR");
const $d27b926fb5493a70$var$browseIntentsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $exc6Q.browseIntentsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $d27b926fb5493a70$export$da5f3658bd3ecdde = (0, $6xToB.createEntry)((0, $azX7D.browseIntentsRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $igNUx.isFedRamp)()) return undefined;
            return $d27b926fb5493a70$var$browseIntentsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        layout: (0, $fYqi8.browseIntentsLayout),
        skeleton: (0, $75uzh.VirtualAgentBrowseIntentsSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("fYqi8", function(module, exports) {

$parcel$export(module.exports, "browseIntentsLayout", () => $85a78ec8023d6908$export$6659f41b213bad05);

var $ln6Iy = parcelRequire("ln6Iy");

var $6dwgv = parcelRequire("6dwgv");

var $aQoXd = parcelRequire("aQoXd");

var $jWaie = parcelRequire("jWaie");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $85a78ec8023d6908$var$withServiceProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $ln6Iy.SERVICE_DESK_PROJECT)
        }
    });
const $85a78ec8023d6908$export$6659f41b213bad05 = (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), {
    rightSidebars: [
        $85a78ec8023d6908$var$withServiceProjectContext((0, $jWaie.default))
    ]
});

});
parcelRegister("jWaie", function(module, exports) {

$parcel$export(module.exports, "default", () => $db3ad5812dfff7ce$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $dfP3D = parcelRequire("dfP3D");

var $2aY2d = parcelRequire("2aY2d");

var $dl0y0 = parcelRequire("dl0y0");

var $255VQ = parcelRequire("255VQ");

var $hdDJ2 = parcelRequire("hdDJ2");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");
const $db3ad5812dfff7ce$var$runtimeProps = {};
const $db3ad5812dfff7ce$export$36ad24b9ac79bdc8 = ()=>{
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    const panelId = rightSidebarCurrentState?.panelId ?? '';
    const cloudId = (0, $kEUB1.useCloudId)();
    const { data: projectContextData } = (0, $2aY2d.useProjectContext)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            key: projectContextData?.projectKey ?? '',
            isHideIntentDiscoveryWhenVaNotConfiguredEnabled: (0, $7jTnu.fg)('hide_intent_discovery_copy_when_va_not_configured')
        }), [
        cloudId,
        projectContextData
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $dl0y0.virtualAgentCreateIntentTemplateSidebarEntryPoint), entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (panelId === 'intentTemplate') entryPointActions.load();
        else entryPointActions.unload();
    }, [
        entryPointActions,
        panelId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "createIntentTemplatesSidebar",
        packageName: "jiraServicedeskSettingsVirtualAgentCreateIntentTemplates",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hdDJ2.VirtualAgentIntentTemplateSidebarSkeleton), null),
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($db3ad5812dfff7ce$var$SideBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $255VQ.ErrorDisplay), {
                refetch: ()=>window.location.reload()
            })),
        runtimeProps: $db3ad5812dfff7ce$var$runtimeProps
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $db3ad5812dfff7ce$var$SideBarWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1kl7udwz _1e0c1txw _2lx21bp4 _bfhk1bhr _vchhusvi _1p57u2gc _4t3i1osq _18m91wug",
            __cmplp.className
        ])
    });
});
var $db3ad5812dfff7ce$export$2e2bcd8739ae039 = $db3ad5812dfff7ce$export$36ad24b9ac79bdc8;

});
parcelRegister("cBavF", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $75ab809c2125a8a7$export$ee1e46af8fa2fb93);
$parcel$export(module.exports, "NestedEntryPointContainer", () => $75ab809c2125a8a7$export$54db9e88249c9162);

var $eJOHy = parcelRequire("eJOHy");

var $snbGZ = parcelRequire("snbGZ");

var $5GSFM = parcelRequire("5GSFM");
const $75ab809c2125a8a7$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $snbGZ.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5GSFM.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $75ab809c2125a8a7$export$54db9e88249c9162 = (0, $5GSFM.InternalEntryPointContainer);

});
parcelRegister("snbGZ", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $ad7cb4b936d42fec$export$3cd1c81e13390c49);

var $eJOHy = parcelRequire("eJOHy");
const $ad7cb4b936d42fec$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $eJOHy.useState)(subject.getValue);
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    // We should never provide an entrypoint that has been disposed.
    // This check guards against race conditions that could be triggered by the entrypoint load manager + concurrent rendering.
    if (entryPointReference?.isDisposed) return null;
    return entryPointReference;
};

});

parcelRegister("5GSFM", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $3534dc73cb841369$export$5d4dc37edd8a3adb);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $16sa1 = parcelRequire("16sa1");
const $3534dc73cb841369$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});


parcelRegister("bbdV2", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $8ca00ab1031880fd$export$338256068bc140fb);

var $eJOHy = parcelRequire("eJOHy");

var $hrKgE = parcelRequire("hrKgE");

var $7jTnu = parcelRequire("7jTnu");

var $3LuvQ = parcelRequire("3LuvQ");

var $aeX2M = parcelRequire("aeX2M");

var $9xjtP = parcelRequire("9xjtP");

var $4A4Zy = parcelRequire("4A4Zy");
const $8ca00ab1031880fd$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $3LuvQ.DEFAULT_OPTIONS))=>{
    // TODO: break tests on instability (stableEntryPointParams!==entryPointParams)
    // prevents {} from from triggering updates
    const stableEntryPointParams = (0, $hrKgE.useShallowStableReference)(entryPointParams, (0, $7jTnu.fg)('jfp_magma_entrypoint-stability'));
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $9xjtP.useEntryPointLoadManager)(entryPoint, stableEntryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $4A4Zy.useMetricLogger)(metric);
    const entryPointActions = (0, $aeX2M.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $eJOHy.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("hrKgE", function(module, exports) {

$parcel$export(module.exports, "useShallowStableReference", () => $06a9fa47a6e96bcb$export$cb8a85c49e39f60);
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions */ 
var $eJOHy = parcelRequire("eJOHy");

var $j5V5L = parcelRequire("j5V5L");
const $06a9fa47a6e96bcb$var$STABLE_EMPTY_OBJECT = Object.freeze({});
const $06a9fa47a6e96bcb$var$STABLE_EMPTY_ARRAY = Object.freeze([]);
const $06a9fa47a6e96bcb$export$419c5efa1812e327 = ()=>$06a9fa47a6e96bcb$var$STABLE_EMPTY_OBJECT;
const $06a9fa47a6e96bcb$export$d81919e21b7bcda0 = ()=>$06a9fa47a6e96bcb$var$STABLE_EMPTY_ARRAY;
const $06a9fa47a6e96bcb$export$abf22ef229d645f7 = (value)=>Object.keys(value).length === 0 ? $06a9fa47a6e96bcb$var$STABLE_EMPTY_OBJECT : value;
const $06a9fa47a6e96bcb$export$540f03090e93e8f6 = (value)=>value.length === 0 ? $06a9fa47a6e96bcb$var$STABLE_EMPTY_ARRAY : value;
function $06a9fa47a6e96bcb$export$cb8a85c49e39f60(props, isEnabled = true) {
    const ref = (0, $eJOHy.useRef)(props);
    if (!isEnabled) return props;
    if (!(0, $j5V5L.default)(props, ref.current)) ref.current = props;
    return ref.current;
}

});

parcelRegister("3LuvQ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $e82a6aa1e9c0eb22$export$93ca5d3f8675ae4c);
const $e82a6aa1e9c0eb22$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("aeX2M", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $85e8a52a8265740a$export$90681c8c3a56f09a);

var $eJOHy = parcelRequire("eJOHy");

var $7oY9g = parcelRequire("7oY9g");

var $3LuvQ = parcelRequire("3LuvQ");
const $85e8a52a8265740a$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $85e8a52a8265740a$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $3LuvQ.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $3LuvQ.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $eJOHy.useRef)();
    const preloadMaxAgeTimeout = (0, $eJOHy.useRef)();
    const preloadLastRequested = (0, $eJOHy.useRef)(0);
    const cancelPreload = (0, $eJOHy.useCallback)(()=>{
        if (!(0, $7oY9g.default)($85e8a52a8265740a$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $eJOHy.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $eJOHy.useCallback)(()=>{
        if ((0, $7oY9g.default)($85e8a52a8265740a$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $eJOHy.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("9xjtP", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $447bc9b48f37e295$export$bfae318f9651db2f);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5HFSX = parcelRequire("5HFSX");

var $8aUoh = parcelRequire("8aUoh");
const $447bc9b48f37e295$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $5HFSX.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $eJOHy.useRef)(true);
    const removeInactiveLoadsIdleCallback = (0, $eJOHy.useRef)(null);
    const entryPointReferenceQueue = (0, $eJOHy.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $8aUoh.useEntryPointReferenceSubject)(entryPoint);
    const setNextUpdate = (0, $eJOHy.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        $447bc9b48f37e295$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
        removeInactiveLoadsIdleCallback.current = $447bc9b48f37e295$var$callWhenIdle(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $8aUoh.removeAll)(currentQueue) : (0, $8aUoh.removeInactiveLoads)(currentQueue);
        });
    }, [
        setEntryPointReference
    ]);
    const load = (0, $eJOHy.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $j4oe4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $8aUoh.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $eJOHy.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $eJOHy.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // In concurrent mode especially with strict mode, we would get stuck on canLoad.current = false
        // and it would never be turned back on to true without this
        canLoad.current = true;
        return ()=>{
            $447bc9b48f37e295$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $8aUoh.removeAll)(entryPointReferenceQueue.current);
        };
    }, []);
    return {
        entryPointReferenceSubject: (0, $eJOHy.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};
function $447bc9b48f37e295$var$callWhenIdle(callback) {
    if ('requestIdleCallback' in window && typeof requestIdleCallback === 'function') return requestIdleCallback(callback);
    if ('requestAnimationFrame' in window && typeof requestAnimationFrame === 'function') return requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
function $447bc9b48f37e295$var$maybeCancelIdleCallback(idleCallbackId) {
    if (idleCallbackId === null) return;
    if ('cancelIdleCallback' in window && typeof cancelIdleCallback === 'function') {
        if (typeof idleCallbackId === 'number') return cancelIdleCallback(idleCallbackId);
        return;
    }
    if ('cancelAnimationFrame' in window && typeof cancelAnimationFrame === 'function') {
        if (typeof idleCallbackId === 'number') return cancelAnimationFrame(idleCallbackId);
        return;
    }
    return clearTimeout(idleCallbackId);
}

});
parcelRegister("5HFSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ec104d1917a5703$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useJiraRelayEnvironmentProvider", () => $2ec104d1917a5703$export$83fb48644dee72f0);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");
function $2ec104d1917a5703$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.RelayEnvironmentProvider), {
        environment: (0, $7zZ4w.default)()
    }, children);
}
function $2ec104d1917a5703$export$83fb48644dee72f0() {
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});

parcelRegister("8aUoh", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $e779802cdcfaaa06$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $e779802cdcfaaa06$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $e779802cdcfaaa06$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $e779802cdcfaaa06$export$322c8997d351da6a);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");
const $e779802cdcfaaa06$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $e779802cdcfaaa06$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $e779802cdcfaaa06$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $e779802cdcfaaa06$export$322c8997d351da6a = (entryPoint)=>{
    const value = (0, $eJOHy.useRef)(null);
    const subscribers = (0, $eJOHy.useRef)();
    const unsub = (0, $eJOHy.useRef)(null);
    const subscribe = (0, $eJOHy.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $eJOHy.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        const notifySubscribers = ()=>{
            (0, $aQK2r.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        };
        if ($e779802cdcfaaa06$var$isReactAsyncJSResourceReference(entryPoint?.root)) unsub.current = entryPoint?.root?.onComplete?.(()=>{
            notifySubscribers();
        });
        else notifySubscribers();
    }, [
        entryPoint
    ]);
    const getValue = (0, $eJOHy.useCallback)(()=>value.current, []);
    (0, $eJOHy.useEffect)(()=>()=>{
            subscribers.current?.clear();
            unsub.current?.();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};
/**
 * JSResourceReference's in react-relay don't have an onComplete method,
 * but the version that we actually use from @atlassian/react-async does.
 */ function $e779802cdcfaaa06$var$isReactAsyncJSResourceReference(value) {
    return Boolean(value && 'onComplete' in value && 'getModuleName' in value);
}

});


parcelRegister("4A4Zy", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $d8d6f61443a51422$export$f291ec7cea728e1);

var $eJOHy = parcelRequire("eJOHy");
const $d8d6f61443a51422$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $eJOHy.useRef)(0);
    const loadStartTime = (0, $eJOHy.useRef)(0);
    const startMetric = (0, $eJOHy.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $eJOHy.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("dfP3D", function(module, exports) {

$parcel$export(module.exports, "useActiveRightSidebarState", () => $8534d9cb529d5738$export$ba763ab7661c3103);
$parcel$export(module.exports, "useRightSidebarState", () => $8534d9cb529d5738$export$d1828e7f46a4960b);
$parcel$export(module.exports, "useRightSidebarController", () => $8534d9cb529d5738$export$ebe5e907fb0bb63a);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");

var $3rHRj = parcelRequire("3rHRj");

var $fZsy4 = parcelRequire("fZsy4");
const $8534d9cb529d5738$var$useActiveRightSidebar = (0, $iJq0l.createHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>{
        const rightSidebarState = (0, $3rHRj.selectCurrentRightSidebar)(state.content.rightSidebar);
        if (!rightSidebarState) return null;
        return {
            ...rightSidebarState,
            shouldRender: !state.isChromeless
        };
    }
});
const $8534d9cb529d5738$export$ba763ab7661c3103 = ()=>{
    const [rightSidebar] = $8534d9cb529d5738$var$useActiveRightSidebar();
    return rightSidebar;
};
const $8534d9cb529d5738$var$useRightSidebar = (0, $iJq0l.createHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>state.content.rightSidebar
});
const $8534d9cb529d5738$export$d1828e7f46a4960b = ()=>{
    const [rightSidebarState] = $8534d9cb529d5738$var$useRightSidebar();
    return rightSidebarState;
};
const $8534d9cb529d5738$export$ebe5e907fb0bb63a = ()=>{
    const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $fZsy4.useLayoutStoreActions)();
    return (0, $eJOHy.useMemo)(()=>({
            setRightSidebarState: setRightSidebarState,
            closeRightSidebar: closeRightSidebar,
            openRightSidebar: openRightSidebar,
            closeCurrentRightSidebar: closeCurrentRightSidebar,
            closeAllRightSidebar: closeAllRightSidebar,
            minimiseRightSidebar: minimiseRightSidebar
        }), [
        closeAllRightSidebar,
        closeCurrentRightSidebar,
        closeRightSidebar,
        openRightSidebar,
        setRightSidebarState,
        minimiseRightSidebar
    ]);
};

});
parcelRegister("3rHRj", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $38d64587782ceabb$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $38d64587782ceabb$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $38d64587782ceabb$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $38d64587782ceabb$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $38d64587782ceabb$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $38d64587782ceabb$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $38d64587782ceabb$export$c8dafe074328c4ca);

var $cSmYj = parcelRequire("cSmYj");
const $38d64587782ceabb$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $38d64587782ceabb$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $38d64587782ceabb$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $38d64587782ceabb$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $38d64587782ceabb$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $38d64587782ceabb$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $38d64587782ceabb$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $38d64587782ceabb$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $38d64587782ceabb$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $38d64587782ceabb$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $38d64587782ceabb$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $38d64587782ceabb$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});

parcelRegister("fZsy4", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $00171a4137f359c3$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $00171a4137f359c3$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $00171a4137f359c3$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $00171a4137f359c3$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $00171a4137f359c3$export$99e05a60cac05e86);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4BzWx = parcelRequire("4BzWx");
const $00171a4137f359c3$export$539e68c09584883a = 240;
const $00171a4137f359c3$export$b92df8810d2fcd01 = 0;
const $00171a4137f359c3$export$47a4b4760f306fb9 = 400;
const $00171a4137f359c3$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $00171a4137f359c3$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        },
        previewPanel: {
            width: $00171a4137f359c3$export$47a4b4760f306fb9
        }
    }
};
const $00171a4137f359c3$export$b8cdfd44cddaf07 = (0, $GtRbT.createStore)({
    initialState: $00171a4137f359c3$var$initialState,
    actions: $4BzWx.actions,
    name: 'JiraLayoutStore'
});
const $00171a4137f359c3$export$6136bc3b9858cff4 = (0, $iJq0l.createHook)($00171a4137f359c3$export$b8cdfd44cddaf07, {
    selector: null
});
const $00171a4137f359c3$var$detailPanelWidthStore = (0, $GtRbT.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $00171a4137f359c3$export$95fd7b6da3b9bbb0 = (0, $iJq0l.createHook)($00171a4137f359c3$var$detailPanelWidthStore);
const $00171a4137f359c3$export$99e05a60cac05e86 = (0, $iJq0l.createActionsHook)($00171a4137f359c3$var$detailPanelWidthStore);

});
parcelRegister("4BzWx", function(module, exports) {

$parcel$export(module.exports, "actions", () => $106bfd5c0a8dc2d4$export$e324594224ef24da);

var $iK07n = parcelRequire("iK07n");

var $iCv0U = parcelRequire("iCv0U");

var $71bAj = parcelRequire("71bAj");

var $5BHLU = parcelRequire("5BHLU");

var $kF3cb = parcelRequire("kF3cb");

var $3rHRj = parcelRequire("3rHRj");

var $eFmzH = parcelRequire("eFmzH");
const $106bfd5c0a8dc2d4$export$e324594224ef24da = {
    setIsChromeless: // global
    $71bAj.setIsChromeless,
    setIsFullscreen: $5BHLU.setIsFullscreen,
    showBanner: // banner
    $iK07n.showBanner,
    dismissCurrentBanner: $iK07n.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $kF3cb.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $3rHRj.setRightSidebarState,
    openRightSidebar: $3rHRj.openRightSidebar,
    closeRightSidebar: $3rHRj.closeRightSidebar,
    closeAllRightSidebar: $3rHRj.closeAllRightSidebar,
    closeCurrentRightSidebar: $3rHRj.closeCurrentRightSidebar,
    minimiseRightSidebar: $3rHRj.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $iCv0U.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $iCv0U.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $iCv0U.removeBottomRightCornerPortal,
    setPreviewPanelState: // preview panel
    $eFmzH.setPreviewPanelState
};

});
parcelRegister("iK07n", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $f576dda57f9ab932$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $f576dda57f9ab932$export$a45bccc0cc9ac424);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f576dda57f9ab932$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $f576dda57f9ab932$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($f576dda57f9ab932$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("iCv0U", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $d6992d5ac6ea80d0$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $d6992d5ac6ea80d0$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $d6992d5ac6ea80d0$export$928bf7e228ce06d2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d6992d5ac6ea80d0$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $d6992d5ac6ea80d0$export$3ed25a6bee272520 = (item)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $d6992d5ac6ea80d0$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("71bAj", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $3013b300b3f3be1a$export$1998c4816ad37edb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $3013b300b3f3be1a$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("5BHLU", function(module, exports) {

$parcel$export(module.exports, "setIsFullscreen", () => $49bc45ba37aeb566$export$9c73b2f282069160);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $49bc45ba37aeb566$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("kF3cb", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $03b023977e84cb41$export$3e0fd2d894ef83c8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $03b023977e84cb41$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});

parcelRegister("eFmzH", function(module, exports) {

$parcel$export(module.exports, "setPreviewPanelState", () => $64e9612ff0fed2ac$export$ba6353031892dd17);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $64e9612ff0fed2ac$export$ba6353031892dd17 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                previewPanel: {
                    ...content.previewPanel,
                    ...newState
                }
            }
        });
    };

});




parcelRegister("2aY2d", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $8ba7ca521b299ffc$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $8ba7ca521b299ffc$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $8ba7ca521b299ffc$export$a85f6b5857d2176);

var $eJOHy = parcelRequire("eJOHy");

var $bo7Z6 = parcelRequire("bo7Z6");

var $dZRaT = parcelRequire("dZRaT");
const $8ba7ca521b299ffc$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $bo7Z6.useResourceWithCustomRouterContext)((0, $dZRaT.projectContextResourceWithCache), customContext);
    const updateCache = (0, $eJOHy.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $8ba7ca521b299ffc$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $8ba7ca521b299ffc$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $8ba7ca521b299ffc$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $8ba7ca521b299ffc$export$8f31c2503e1efa93();
    return children(projectContext);
};

});

parcelRegister("dl0y0", function(module, exports) {

$parcel$export(module.exports, "virtualAgentCreateIntentTemplateSidebarEntryPoint", () => $e518e2efada04cf5$export$2b1d9dc27ee42f8f);

var $b26eA = parcelRequire("b26eA");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $e518e2efada04cf5$export$2b1d9dc27ee42f8f = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("fQFmw")), {
        moduleId: "a4e9afeb",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, key: key, isHideIntentDiscoveryWhenVaNotConfiguredEnabled: isHideIntentDiscoveryWhenVaNotConfiguredEnabled })=>({
            queries: {
                intentTemplateQueryReference: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: (0, $b26eA.default),
                    variables: {
                        cloudId: cloudId,
                        key: key,
                        isHideIntentDiscoveryWhenVaNotConfiguredEnabled: isHideIntentDiscoveryWhenVaNotConfiguredEnabled
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("b26eA", function(module, exports) {

$parcel$export(module.exports, "default", () => $918b165ee6b6741b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<68ca1ff3c625c48e3b3f34fcd3122e1a>>
 * @relayHash c3ecae5efac1725022957b3584c6748a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d816bb1396041500986a655dbca037f2dba1138371158641897ea361c6ff7286
const $918b165ee6b6741b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d816bb1396041500986a655dbca037f2dba1138371158641897ea361c6ff7286",
        "metadata": {},
        "name": "uiVirtualAgentIntentTemplatesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $918b165ee6b6741b$export$2e2bcd8739ae039 = $918b165ee6b6741b$var$node;

});

parcelRegister("fQFmw", function(module, exports) {

let $b89bcc05fb48ca3d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $b89bcc05fb48ca3d$var$load("eDzss"),
    $b89bcc05fb48ca3d$var$load("3c5OE")
]).then(()=>parcelRequire('ecUON'));

});


parcelRegister("255VQ", function(module, exports) {

$parcel$export(module.exports, "ErrorDisplay", () => $3c3edb9a3ff3249f$export$d56b0569bceb92ae);

var $eJOHy = parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");

var $6vd3O = parcelRequire("6vd3O");

var $igCP5 = parcelRequire("igCP5");

var $aTJmy = parcelRequire("aTJmy");

var $lRq8t = parcelRequire("lRq8t");

var $jHRC0 = parcelRequire("jHRC0");
const $3c3edb9a3ff3249f$export$d56b0569bceb92ae = ({ refetch: refetch })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6vd3O.default), {
        header: formatMessage((0, $jHRC0.default).errorDisplayHeading),
        description: formatMessage((0, $jHRC0.default).errorDisplayDescription),
        renderImage: (0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $igCP5.default)),
        imageWidth: 160,
        maxImageHeight: 220,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
            onClick: refetch,
            appearance: "link"
        }, formatMessage((0, $jHRC0.default).reloadNowButtonText))
    });
};

});
parcelRegister("igCP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ff71d828dd91298$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("OW6xg")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("j9F20")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = jx8k5z4r4cbqfnn3t56t46v9
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/jx8k5z4r4cbqfnn3t56t46v9

var $c4huj = parcelRequire("c4huj");

var $j9F20 = parcelRequire("j9F20");

var $OW6xg = parcelRequire("OW6xg");
const $0ff71d828dd91298$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($OW6xg)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($j9F20))
});
var $0ff71d828dd91298$export$2e2bcd8739ae039 = $0ff71d828dd91298$var$Illustration;
// for advanced use only
const $0ff71d828dd91298$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("c4huj", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $23ef7a56b51bae71$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $23ef7a56b51bae71$export$4d00e7be716a0093);

var $eJOHy = parcelRequire("eJOHy");

var $7Tdyj = parcelRequire("7Tdyj");
function $23ef7a56b51bae71$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tdyj.AsImg), props);
}
function $23ef7a56b51bae71$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23ef7a56b51bae71$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("7Tdyj", function(module, exports) {

$parcel$export(module.exports, "AsImg", () => $0b0259f6264d72ea$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5M7r5 = parcelRequire("5M7r5");
// Moved to src/packages/illustrations/illustration/src/ui/types.tsx to avoid circular dependency
// export interface AsImgProps extends IllustrationProps, ImgHTMLAttributes<HTMLImageElement>
// suggested defaults, the consumer is free to override
const $0b0259f6264d72ea$var$defaultStyles = null;
const $0b0259f6264d72ea$var$fillStyles = null;
const $0b0259f6264d72ea$var$autoDarkModeStyles = null;
function $0b0259f6264d72ea$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $5M7r5.default)();
    return /*#__PURE__*/ $eJOHy.createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $hcewu.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_1r04idpf _kqswstnw _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("j9F20", function(module, exports) {
module.exports = new URL("generic-error-darkmode.3646797f.svg", import.meta.url).toString();

});

parcelRegister("OW6xg", function(module, exports) {
module.exports = new URL("generic-error.f200ded6.svg", import.meta.url).toString();

});


parcelRegister("aTJmy", function(module, exports) {

$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $484fdcae7d1a2fee$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $3xT3U = parcelRequire("3xT3U");
function $484fdcae7d1a2fee$export$ebf64b9217c1b2a3(JiraIllustration = (0, $3xT3U.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $awdRS.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $awdRS.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $hcewu.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _19pkidpf _2hwx1wug _otyr1ejb _18u01wug",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("3xT3U", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b1b1236d04dc76a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("66yEr")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("8c2v7")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $c4huj = parcelRequire("c4huj");

var $8c2v7 = parcelRequire("8c2v7");

var $66yEr = parcelRequire("66yEr");
const $3b1b1236d04dc76a$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($66yEr)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8c2v7))
});
var $3b1b1236d04dc76a$export$2e2bcd8739ae039 = $3b1b1236d04dc76a$var$Illustration;
// for advanced use only
const $3b1b1236d04dc76a$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("8c2v7", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("66yEr", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



parcelRegister("jHRC0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6adc0017fccf419$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a6adc0017fccf419$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorDisplayHeading: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-heading",
        "defaultMessage": "We couldn\u2019t load intent templates"
    },
    errorDisplayDescription: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-description",
        "defaultMessage": "Wait a moment and then try reloading."
    },
    reloadNowButtonText: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.reload-now-button-text",
        "defaultMessage": "Reload"
    }
});

});


parcelRegister("hdDJ2", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentIntentTemplateSidebarSkeleton", () => $8378e703b6d3ac08$export$fa68b26760d5b66f);
/* VirtualAgentIntentTemplateSidebarSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $l0aSL = parcelRequire("l0aSL");
const $8378e703b6d3ac08$var$customCssStyles = null;
const $8378e703b6d3ac08$export$fa68b26760d5b66f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l0aSL))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("l0aSL", function(module, exports) {
module.exports = new URL("virtual-agent-intent-template-sidebar-app-skeleton.tpl.e2ff8557.svg", import.meta.url).toString();

});


parcelRegister("kEUB1", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $5217c4f42a781287$export$9da0f7c65f28ed16);

var $lvKO5 = parcelRequire("lvKO5");
const $5217c4f42a781287$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});



parcelRegister("75uzh", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentBrowseIntentsSkeleton", () => $e3402caca65ff257$export$444026e4d4f156e4);
$parcel$export(module.exports, "VirtualAgentIntentsTableSkeleton", () => $e3402caca65ff257$export$9dca41144a6398d2);
$parcel$export(module.exports, "VirtualAgentStatisticsSkeleton", () => $e3402caca65ff257$export$538762e63d6466fe);
/* VirtualAgentStatisticsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $dRaLX = parcelRequire("dRaLX");

var $h0deV = parcelRequire("h0deV");

var $4nDWo = parcelRequire("4nDWo");
const $e3402caca65ff257$var$customCssStyles = null;
const $e3402caca65ff257$export$444026e4d4f156e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dRaLX))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
const $e3402caca65ff257$export$9dca41144a6398d2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($h0deV))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
const $e3402caca65ff257$export$538762e63d6466fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4nDWo))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("dRaLX", function(module, exports) {
module.exports = new URL("virtual-agent-browse-intents-app-skeleton.tpl.1eeb33c1.svg", import.meta.url).toString();

});

parcelRegister("h0deV", function(module, exports) {
module.exports = new URL("virtual-agent-intents-table-app-skeleton.tpl.e28c55f7.svg", import.meta.url).toString();

});

parcelRegister("4nDWo", function(module, exports) {
module.exports = new URL("virtual-agent-virtual-agent-statistics-app-skeleton.tpl.19ee5056.svg", import.meta.url).toString();

});


parcelRegister("exc6Q", function(module, exports) {

$parcel$export(module.exports, "browseIntentsEntryPoint", () => $1366f9a5b90d6cc7$export$f19c213ae2d7940f);

var $lXeRJ = parcelRequire("lXeRJ");

var $eaBy9 = parcelRequire("eaBy9");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");
// When changing the default time range, make sure to also update jira/src/packages/servicedesk/virtual-agent/intents/browse-intents/src/ui/index.tsx
const $1366f9a5b90d6cc7$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $1366f9a5b90d6cc7$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10);

const $1366f9a5b90d6cc7$export$f19c213ae2d7940f = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("hZiDY")), {
        moduleId: "85089c8d",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $lXeRJ.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                },
                statistics: {
                    parameters: (0, $eaBy9.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        startDate: $1366f9a5b90d6cc7$var$formatFetchDate(new Date(Date.now() - $1366f9a5b90d6cc7$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $1366f9a5b90d6cc7$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("lXeRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $85e95788c66ab301$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<865219262865f0c2fe60a5d42c5b5ac3>>
 * @relayHash 332a18b0c791d5db703346b792e462c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f9fa1c86914f21c81c9bc463158fa765c0cb8dda8f8846aa2ac249230746d72

var $bXR9c = parcelRequire("bXR9c");
const $85e95788c66ab301$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4f9fa1c86914f21c81c9bc463158fa765c0cb8dda8f8846aa2ac249230746d72",
        "metadata": {},
        "name": "srcVirtualAgentBrowseIntentsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $85e95788c66ab301$export$2e2bcd8739ae039 = $85e95788c66ab301$var$node;

});

parcelRegister("eaBy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $52671fb3cd25cd9a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7de08b41c0233f993e9f465f2b55ff1d>>
 * @relayHash 2abd4ad2e8912c8629a5da83f2373cce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1f5d76d0b50d1729fc79fb483dbf5fd8a89c1dcdb99beeede2b23b9584cca1ac

var $deqPA = parcelRequire("deqPA");
const $52671fb3cd25cd9a$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1f5d76d0b50d1729fc79fb483dbf5fd8a89c1dcdb99beeede2b23b9584cca1ac",
        "metadata": {},
        "name": "srcVirtualAgentBrowseIntentsStatisticsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableperformancepagerelayprovider": (0, $deqPA.default)
        }
    }
};
var $52671fb3cd25cd9a$export$2e2bcd8739ae039 = $52671fb3cd25cd9a$var$node;

});
parcelRegister("deqPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $15a465622d5a2647$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $15a465622d5a2647$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jsm_va_enable_performance_page');
    }
};

});


parcelRegister("hZiDY", function(module, exports) {

let $d186986e5489007f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $d186986e5489007f$var$load("1VRB2"),
    $d186986e5489007f$var$load("bABhq"),
    $d186986e5489007f$var$load("dQvLc")
]).then(()=>parcelRequire('lO3Hd'));

});



parcelRegister("fvYEf", function(module, exports) {

$parcel$export(module.exports, "browseIssueEmbedRouteEntry", () => $31d805b679e7032b$export$e275b3ca0c6ccb5e);


var $7K5Ea = parcelRequire("7K5Ea");

var $1wb5r = parcelRequire("1wb5r");

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $dk4qA = parcelRequire("dk4qA");

var $lPVME = parcelRequire("lPVME");

var $9NmsS = parcelRequire("9NmsS");

var $cxQGT = parcelRequire("cxQGT");

var $fk6FR = parcelRequire("fk6FR");

var $ePaI2 = parcelRequire("ePaI2");

var $4FfIq = parcelRequire("4FfIq");

var $5nfTh = parcelRequire("5nfTh");

var $5L7qx = parcelRequire("5L7qx");

var $6zEUu = parcelRequire("6zEUu");

var $W6cJS = parcelRequire("W6cJS");

var $ebuR2 = parcelRequire("ebuR2");

var $38U18 = parcelRequire("38U18");
const $31d805b679e7032b$export$e275b3ca0c6ccb5e = (0, $6xToB.createEntry)((0, $fk6FR.browseIssueEmbedRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'issue',
        preloadOptions: {
            earlyChunks: [
                'issue-app-early-entry'
            ]
        },
        earlyAssets: (0, $1wb5r.NORMAL_EARLY_ASSET_STRATEGY),
        component: (0, $38U18.IssueEmbedComponent),
        skeleton: (0, $4FfIq.IssueViewSkeleton),
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            ...(0, $9NmsS.getModernIssueTransitionResources)(),
            // delete when cleaning up fun-1924-remove_business_project_resource_from_jiv
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('fun-1924-remove_business_project_resource_from_jiv'), (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource)),
            (0, $lPVME.issueGiraDataResource),
            ...(0, $38U18.removeNonCritialGiraCallFromCriticalPath)(),
            (0, $dk4qA.issueViewRelayResource),
            (0, $ePaI2.workspaceResource),
            (0, $cxQGT.themePreferenceResource),
            ...(0, $5nfTh.getAIContextPanelResources)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jira-project-isglobalcomponent-route-resource'), (0, $6zEUu.projectGlobalComponentsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('magma-3869-jsm-issue-view-sla-panel-fixes'), (0, $W6cJS.getJsmIssueViewSlaPanelResource)())
        ],
        forPaint: [
            (0, $38U18.LazyIssuePage)
        ],
        ufoName: 'issue-view-embed',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$ef94a84e2990361c)
        },
        bifrost: {
            bifrostGroup: 'issue-view',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-entries/src/browseIssueEmbedRouteEntry.tsx',
                whichExportToUse: 'browseIssueEmbedRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-view.json'
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("7K5Ea", function(module, exports) {

$parcel$export(module.exports, "chromelessLayout", () => $4e04f7c98ccdcac5$export$17e73ed8c35891cb);

var $6dwgv = parcelRequire("6dwgv");
const $4e04f7c98ccdcac5$export$17e73ed8c35891cb = (0, $6dwgv.createLayout)({
    isChromeless: true
});

});

parcelRegister("1wb5r", function(module, exports) {

$parcel$export(module.exports, "NORMAL_EARLY_ASSET_STRATEGY", () => $925bce3dc97531be$export$137d6d169f402a59);
$parcel$export(module.exports, "AGGRESSIVE_EARLY_ASSET_STRATEGY", () => $925bce3dc97531be$export$ad16a91905cefb0a);
const $925bce3dc97531be$var$COMMON_ASSET_REGEX = /.*\/commons(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $925bce3dc97531be$var$VENDOR_ASSET_REGEX = /.*\/vendor(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $925bce3dc97531be$var$PARCEL_COMMON_ASSET_REGEX = /.*\/shared~commons(~ar)?(\.[0-9a-z]*)\.js/;
const $925bce3dc97531be$var$PARCEL_VENDOR_ASSET_REGEX = /.*\/shared~vendor(~ar)?(\.[0-9a-z]*)\.js/;
const $925bce3dc97531be$export$137d6d169f402a59 = [
    $925bce3dc97531be$var$VENDOR_ASSET_REGEX,
    $925bce3dc97531be$var$PARCEL_VENDOR_ASSET_REGEX
];
const $925bce3dc97531be$export$ad16a91905cefb0a = [
    $925bce3dc97531be$var$VENDOR_ASSET_REGEX,
    $925bce3dc97531be$var$COMMON_ASSET_REGEX,
    $925bce3dc97531be$var$PARCEL_VENDOR_ASSET_REGEX,
    $925bce3dc97531be$var$PARCEL_COMMON_ASSET_REGEX
];

});

parcelRegister("dk4qA", function(module, exports) {

$parcel$export(module.exports, "issueViewRelayResource", () => $6bf3f1482f81a9c8$export$55131006e6699c0a);
$parcel$export(module.exports, "useIssueViewRelayRouteResource", () => $6bf3f1482f81a9c8$export$252bdba8c8e5f066);

var $48lPN = parcelRequire("48lPN");

var $dNyY6 = parcelRequire("dNyY6");

var $fspIv = parcelRequire("fspIv");

var $9FYIg = parcelRequire("9FYIg");

var $fEInL = parcelRequire("fEInL");

var $eq3q8 = parcelRequire("eq3q8");

var $5L7qx = parcelRequire("5L7qx");


var $epTsa = parcelRequire("epTsa");

var $6NSKd = parcelRequire("6NSKd");
const $6bf3f1482f81a9c8$export$55131006e6699c0a = (0, $5L7qx.browserOnlyResourceWithCondition)(()=>{
    if (0, $9790b8dfe6f31c81$export$19d68f5aa485d903) // not "browser only" if FF is on
    return !(0, $epTsa.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false);
    return true;
}, (0, $6NSKd.createRelayResourceDeprecated)({
    type: 'ISSUE_RELAY_DATA',
    isBrowserOnly: true,
    captureErrors: true,
    captureTraceIds: !false,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
        const { match: match } = routerContext;
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        const siteAri = (0, $48lPN.JiraSiteAri).create({
            siteId: cloudId
        }).toString();
        const projectKey = issueKey ? (0, $dNyY6.extractProjectKey)(issueKey) : '';
        const queryVariables = {
            cloudId: cloudId,
            issueKey: issueKey || '',
            projectKey: projectKey,
            siteAri: siteAri
        };
        return {
            parameters: (0, $fEInL.default),
            variables: {
                ...queryVariables,
                ...(0, $fspIv.getMainIssueViewAggQueryVariables)(issueKey)
            },
            // Pass over the variables that actually would trigger a reload when they are changed=
            keyVariables: {
                ...queryVariables,
                ...(0, $fspIv.getMainIssueViewAggQueryFeatureFlagVariables)()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
}));
const $6bf3f1482f81a9c8$export$252bdba8c8e5f066 = (options)=>(0, $9FYIg.useRelayResource)($6bf3f1482f81a9c8$export$55131006e6699c0a, options);

});
parcelRegister("48lPN", function(module, exports) {

$parcel$export(module.exports, "JiraSiteAri", () => $3028d8a5865a8fff$export$6c0f81f222d09301);

var $jzuB4 = parcelRequire("jzuB4");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/site/manifest.ts
var $3028d8a5865a8fff$var$jiraSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $jzuB4.JiraSiteAriResourceOwner),
    resourceType: (0, $jzuB4.JiraSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/jira/site/index.ts
var $3028d8a5865a8fff$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $3028d8a5865a8fff$var$jiraSiteAriStaticOpts.qualifier,
            platformQualifier: $3028d8a5865a8fff$var$jiraSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $3028d8a5865a8fff$var$jiraSiteAriStaticOpts.resourceOwner,
            resourceType: $3028d8a5865a8fff$var$jiraSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $3028d8a5865a8fff$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $3028d8a5865a8fff$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};

});
parcelRegister("jzuB4", function(module, exports) {

$parcel$export(module.exports, "JiraSiteAriResourceOwner", () => $e3f905208997f6cb$export$b7d590981b504412);
$parcel$export(module.exports, "JiraSiteAriResourceType", () => $e3f905208997f6cb$export$886165a991f21644);
// src/jira/site/types.ts
var $e3f905208997f6cb$export$b7d590981b504412 = "jira", $e3f905208997f6cb$export$886165a991f21644 = "site";

});


parcelRegister("dNyY6", function(module, exports) {

$parcel$export(module.exports, "extractProjectKey", () => $d2a27657f5b202f3$export$f1a2e4721b127828);

var $ljej9 = parcelRequire("ljej9");
const $d2a27657f5b202f3$export$f1a2e4721b127828 = (issueKey)=>(0, $ljej9.toProjectKey)(issueKey.split('-')[0]);

});

parcelRegister("fspIv", function(module, exports) {

$parcel$export(module.exports, "getMainIssueViewAggQueryFeatureFlagVariables", () => $4a9801c17543db4c$export$3dd406718c5846c6);
$parcel$export(module.exports, "getMainIssueViewAggQueryVariables", () => $4a9801c17543db4c$export$5896c8dc13246fe2);
/**
 * @fileOverview
 * All variables that get passed in to the mainIssueAggQuery are defined here.
 * The abstraction is necessary because there are multiple call paths to mainIssueAggQuery,
 * so having a single source of truth for the variables eliminates a vector for
 * bugs and inconsistencies when they are invoked.
 *
 * This file will be removed (and therefore the need for the linting exemption) once we reduce
 * the number of discrete call paths for mainIssueAggQuery to one. That work will be done in
 * https://jira.atlassian.com/browse/JIV-19486.
 *
 * Sorry, Tom.
 *
 * <3 Daz
 */ /* eslint-disable jira/ff/inline-usage */ 
var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $bRJAs = parcelRequire("bRJAs");


var $a9ldn = parcelRequire("a9ldn");

var $aFPNn = parcelRequire("aFPNn");

var $aYncF = parcelRequire("aYncF");

var $hWeHP = parcelRequire("hWeHP");

var $fEInL = parcelRequire("fEInL");

var $fohjD = parcelRequire("fohjD");

var $d60Hm = parcelRequire("d60Hm");
const $4a9801c17543db4c$export$623cfa88de62fcd = ()=>{
    const providerVariables = (0, $fEInL.default)?.params?.providedVariables ?? {};
    return Object.entries(providerVariables).reduce((acc, [key, provider])=>{
        acc[key] = provider.get();
        return acc;
    }, {});
};
const $4a9801c17543db4c$export$3dd406718c5846c6 = ()=>({
        jsmSentimentCustomFieldFlag: true,
        issueViewRelayPriorityFieldFlag: (0, $7jTnu.fg)('relay-migration-issue-fields-priority'),
        issueViewRelayNumberFieldFlag: (0, $7jTnu.fg)('relay-migration-issue-fields-number'),
        issueViewRelayAttachmentsFlag: (0, $7jTnu.fg)('relay-migration-issue-view-attachments-'),
        issueViewRelayResolutionFieldFlag: (0, $7jTnu.fg)('relay-migration-issue-fields-resolution'),
        issueViewRelayParentFieldFlag: (0, $7jTnu.fg)('relay-migration-issue-header-and-parent'),
        issueViewDesignsPanelFlag: (0, $epTsa.expVal)('collapsed_designs_panel', 'isCollapsedDesignsPanelEnabled', false),
        issueViewRemoveCheckboxSelectFieldOptionsFlag: (0, $7jTnu.fg)('remove_issue_field_options_main_query'),
        isFieldsByIdRemoved: (0, $7jTnu.fg)('dfo_remove_fields_by_id'),
        issueViewRelaySummaryFieldFlag: (0, $7jTnu.fg)('relay-migration-issue-fields-summary'),
        issueViewRelayTimeTrackingFieldFlag: (0, $7jTnu.fg)('relay-migration-issue-fields-time-tracking'),
        customFieldConfigurationFlag: (0, $7jTnu.fg)('issue_view_field_config_edit'),
        isPinFieldConfigurabilityEnabled: true,
        jcsFlag: (0, $7jTnu.fg)('jcs_master_flag'),
        isProactiveCommentSummaryPreferenceEnabled: (0, $7jTnu.fg)('proactive_comment_summary_feature_toggle'),
        crossflowBannerDismissedInAggFlag: (0, $7jTnu.fg)('jiv-19897-move-user-prefs-to-mainissueagg'),
        dateFieldsMessageEnabled: (0, $epTsa.expValEquals)('jsw_start_and_due_dates', 'cohort', 'variation'),
        chinEmbedQueryToAgg: (0, $7jTnu.fg)('issue-jiv-19838-chin-api-lookup-through-issue-key'),
        issueViewCollapsibleSectionsFieldEnabled: (0, $7jTnu.fg)('collapsible-sections-in-issue-view-fg'),
        issueViewUserPreferredLayoutFieldEnabled: (0, $7jTnu.fg)('issue_view_layout_experiment_feature_gate'),
        issueViewDetailsPanelFieldsReorderingEnabled: (0, $epTsa.expVal)('issue_view_field_reordering_in_context_panel_v2', 'isReorderingFieldsEnabled', false),
        issueViewRedactionExperience: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $7jTnu.fg)('enable_redaction_support_in_jira_issue_view') && (0, $7jTnu.fg)('relay-migration-issue-header-and-parent'),
        issueViewCoverExperimentEnabled: (0, $7jTnu.fg)('cover_image_issue_view_experiment_kill_switch'),
        isPlaybooksEnabled: (0, $7jTnu.fg)('playbook_in_jsm_ga'),
        isPlaybooksEnabledForSpecificType: (0, $7jTnu.fg)('playbook_visibility_in_service_request'),
        isAutomationDiscoverabilityEnabled: (0, $7jTnu.fg)('automation_discoverability_in_jsm'),
        issueViewRovoDevAgentsPanelEnabled: // These conditions should be included in the conditions for RovodevAgentPanel in content-items-view.tsx
        (0, $7jTnu.fg)('devai-issue-view-main-migration') && (!!(0, $aYncF.getLicensedProducts)((0, $hWeHP.default)).devai || (0, $7jTnu.fg)('rovodev_entitlements_user_access_bypass')),
        issueViewChildIssuesPanelPerformance: (0, $epTsa.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false),
        mentionedConfluencePageLinksV2PaginationFlag: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $7jTnu.fg)('jsw_issue_view_placeholder_template_v2') && (0, $7jTnu.fg)('jiv_confluence_remote_link_critical_query'),
        linkedWorkItemsTableEnabled: (0, $7jTnu.fg)('jira-linked-work-items-table-kill-switch'),
        issueViewCommentAvatarFlag: (0, $7jTnu.fg)('relay-avatar-iv-llc-comments'),
        issueViewSlackSyncInfoEnabled: (0, $7jTnu.fg)('jira_issue_view_show_slack_sync_info'),
        issueViewNextBestActionsEnabled: (0, $7jTnu.fg)('jira_issue_next_best_actions_fg'),
        issueViewAddAttachmentFlag: (0, $7jTnu.fg)('jira-storage-hard-limit-gate'),
        isConfigUrlDefer: (0, $7jTnu.fg)('config-url-defer-iv'),
        isDisableConfigUrlDefer: !(0, $7jTnu.fg)('config-url-defer-iv'),
        issueViewGoalsFieldWithShowAllGoalsFlag: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $7jTnu.fg)('jira_preview_panel_m_1_rollout') && (0, $7jTnu.fg)('jira-glance-panel'),
        isSkipParentVisibility: (0, $7jTnu.fg)('remove-parent-visibility-dfo'),
        relayMigrationWebLinksFlag: (0, $7jTnu.fg)('relay-migration-web-links-fetch'),
        issueViewAttachmentsStripMigrationToRelayEnabled: (0, $7jTnu.fg)('issue_view_attachments_strip_migration_to_relay')
    });
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $4a9801c17543db4c$var$getURLFromWindow = ()=>new URL(window.location.href);
const $4a9801c17543db4c$export$5896c8dc13246fe2 = (issueKey, url = $4a9801c17543db4c$var$getURLFromWindow())=>({
        ...$4a9801c17543db4c$export$623cfa88de62fcd(),
        ...$4a9801c17543db4c$export$3dd406718c5846c6(),
        ...$4a9801c17543db4c$export$e2c3bddbfc195841(url),
        ...$4a9801c17543db4c$var$getStorageBannerVariables(),
        ...$4a9801c17543db4c$var$getIssueSearchForChildIssueQueryVariables(issueKey),
        ...$4a9801c17543db4c$var$getForgeSpecificVariables(),
        ...$4a9801c17543db4c$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables(),
        ...$4a9801c17543db4c$var$getLinkedIssuesTableQueryVariables(issueKey),
        ...$4a9801c17543db4c$var$getStorageHardLimitVariables()
    });
const $4a9801c17543db4c$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables = ()=>{
    if ((0, $epTsa.expValEquals)('jsw_start_and_due_dates', 'cohort', 'variation')) {
        if (typeof window !== 'undefined') {
            const pathname = window.location.pathname;
            const pattern = /^\/jira\/software(?:\/c)?\/projects\/[^/]+\/boards\/\d+\/(calendar|timeline)$/;
            return {
                isInTimelineOrCalendarView: pattern.test(pathname)
            };
        }
    }
    return {
        isInTimelineOrCalendarView: false
    };
};
const $4a9801c17543db4c$export$9f8034ef70f20a00 = ()=>{
    /**
	 * Default fields we're fetching in child issues:
	 * - issuetype: Used to separate base-level and subtasks in epics (see `jira-issue-view-child-issues-panel-merge-subtasks`)
	 */ const childIssuesFieldIds = [
        'issuetype'
    ];
    // If we're not fetching the "Include subtasks" timetracking data through Relay
    // include it in `mainIssueAggQuery` so it can be derived from Redux
    if (!(0, $7jTnu.fg)('relay-migration-edit-worklog')) childIssuesFieldIds.push('timetracking');
    // If we're not fetching the progress summary status data through Relay,
    // include it in `mainIssueAggQuery` so it can be derived from Redux
    if (!(0, $7jTnu.fg)('jira-issue-view-child-issues-panel-realtime-update')) childIssuesFieldIds.push('status');
    const unusedFields = [
        'assignee',
        'created',
        'priority',
        'summary',
        'updated'
    ];
    if (!(0, $epTsa.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false)) // Always include unused fields when GA experiment is OFF
    childIssuesFieldIds.push(...unusedFields);
    return childIssuesFieldIds;
};
const $4a9801c17543db4c$var$getIssueSearchForChildIssueQueryVariables = (issueKey)=>({
        // will have to put jql order by rank later
        issueSearchInput: {
            childIssuesInput: {
                parentIssueKey: issueKey || ''
            }
        },
        amountOfColumns: 500,
        fieldSetsInput: {
            viewInput: {
                namespace: 'CHILD_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        childIssuesFieldIds: $4a9801c17543db4c$export$9f8034ef70f20a00()
    });
const $4a9801c17543db4c$var$getLinkedIssuesTableQueryVariables = (issueKey)=>({
        linkedIssuesSearchInput: {
            jql: `issue in linkedIssues(${issueKey})`
        },
        linkedIssuesViewConfigInput: {
            viewInput: {
                namespace: 'LINKED_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        linkedIssuesFieldSetsInput: {
            viewInput: {
                namespace: 'LINKED_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        }
    });
const $4a9801c17543db4c$export$afa6e4ae995b8926 = ()=>{
    const commentTargetId = (0, $d60Hm.getPermalinkId)((0, $d60Hm.COMMENTS)) || null;
    return {
        commentTargetId: commentTargetId,
        hasCommentTargetId: !!commentTargetId
    };
};
const $4a9801c17543db4c$export$e2c3bddbfc195841 = (url)=>{
    const commentTargetId = (0, $d60Hm.getPermalinkIdFromURL)((0, $d60Hm.COMMENTS), url);
    return {
        commentTargetId: commentTargetId,
        hasCommentTargetId: !!commentTargetId
    };
};
const $4a9801c17543db4c$var$getStorageBannerVariables = ()=>({
        issueViewStorageLimitsBannerFlag: (0, $aFPNn.default)((0, $hWeHP.default)).software === (0, $a9ldn.FREE_EDITION),
        productKey: (0, $e08dff4ae358d899$export$1346c9aa3cbb477d),
        changeOfferingOfferingName: 'standard'
    });
const $4a9801c17543db4c$var$getForgeSpecificVariables = ()=>{
    return {
        forgeTypes: [
            (0, $fohjD.ISSUE_ACTION_MODULE),
            (0, $fohjD.ISSUE_GLANCE_MODULE),
            (0, $fohjD.ISSUE_CONTEXT_MODULE),
            (0, $fohjD.ISSUE_PANEL_MODULE),
            (0, $fohjD.ISSUE_ACTIVITY_MODULE),
            (0, $fohjD.CUSTOM_FIELD_MODULE),
            (0, $fohjD.CUSTOM_FIELD_TYPE_MODULE),
            (0, $fohjD.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
            (0, $fohjD.UI_MODIFICATIONS_MODULE)
        ]
    };
};
const $4a9801c17543db4c$var$getStorageHardLimitVariables = ()=>{
    /* ======================================================================================== */ /* To fetch attachmentStorageUsed from JiraQuery, using applicationKey: JIRA_SOFTWARE is appropriate. */ /* The applicationKey is an enum that specifies the application context, and JIRA_SOFTWARE is commonly */ /* used for Jira Software-related queries. */ /* ======================================================================================== */ return {
        applicationKey: (0, $bRJAs.JIRA_SOFTWARE)
    };
};

});
parcelRegister("fEInL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c51291f3989646ef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<933630e64ea64889f7561f68fecbd0a9>>
 * @relayHash 6bbdc2f69425c0a62833b7b0b05a2fda
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a743f6824ce3774e82d4c74fe69690cc34aad45418721cae3cb073f3aa8fd26

var $ginDg = parcelRequire("ginDg");

var $8FjDB = parcelRequire("8FjDB");

var $gAaux = parcelRequire("gAaux");

var $kZq2R = parcelRequire("kZq2R");

var $l9xWO = parcelRequire("l9xWO");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $gUtTS = parcelRequire("gUtTS");

var $hRj2m = parcelRequire("hRj2m");

var $5nHY8 = parcelRequire("5nHY8");

var $2HLoK = parcelRequire("2HLoK");

var $ePJhs = parcelRequire("ePJhs");

var $84Nve = parcelRequire("84Nve");

var $bU8Sj = parcelRequire("bU8Sj");

var $3fKMz = parcelRequire("3fKMz");

var $clCUA = parcelRequire("clCUA");

var $jLDgo = parcelRequire("jLDgo");

var $84S8I = parcelRequire("84S8I");

var $8Qoc7 = parcelRequire("8Qoc7");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");

var $7lcgt = parcelRequire("7lcgt");

var $iOvkB = parcelRequire("iOvkB");

var $1kOgh = parcelRequire("1kOgh");

var $5KpqZ = parcelRequire("5KpqZ");

var $j9A6z = parcelRequire("j9A6z");

var $2INXH = parcelRequire("2INXH");

var $cI44N = parcelRequire("cI44N");

var $ahbHV = parcelRequire("ahbHV");

var $1iihV = parcelRequire("1iihV");

var $lPtKd = parcelRequire("lPtKd");

var $fLB4a = parcelRequire("fLB4a");

var $goaDN = parcelRequire("goaDN");

var $i3mIO = parcelRequire("i3mIO");

var $5uEG2 = parcelRequire("5uEG2");
const $c51291f3989646ef$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6a743f6824ce3774e82d4c74fe69690cc34aad45418721cae3cb073f3aa8fd26",
        "metadata": {},
        "name": "mainIssueAggQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewredactionexperiencerelayprovider": (0, $84Nve.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraenableclassificationorgdefaultfgrelayprovider": (0, $5nHY8.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldfragmentsrelayprovider": (0, $gUtTS.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud94147hot116492fixattachmentspreviewrelayprovider": (0, $84S8I.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": (0, $2INXH.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsparent": (0, $1iihV.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldstimetrackingrelayprovider": (0, $5uEG2.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscheckboxselectrelayprovider": (0, $j9A6z.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrichtextrelayprovider": (0, $fLB4a.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsassigneerelayprovider": (0, $5KpqZ.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsfieldwithshowallgoalsrelayprovider": (0, $l9xWO.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsheaderactionsrelayprovider": (0, $cI44N.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcconcealitemsintomeatballmenuexperimentrelayprovidertsx": (0, $8FjDB.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud81233fixdisabledvotingoptionrelayprovider": (0, $jLDgo.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuetypeswitcherrelayprovider": (0, $ahbHV.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsresolutionrelayprovider": (0, $lPtKd.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatusrelayprovider": (0, $i3mIO.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatuspanelrelayprovider": (0, $goaDN.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcconfigurldeferivrelayprovider": (0, $gAaux.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $ePJhs.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcmagma3191renderchinskeletoninssrrelayprovider": (0, $1kOgh.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $7lcgt.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": (0, $clCUA.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcboysenberryissueviewagentspanelrelayprovider": (0, $ginDg.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirastoragehardlimitrelayprovidertsx": (0, $3fKMz.default)
        }
    }
};
var $c51291f3989646ef$export$2e2bcd8739ae039 = $c51291f3989646ef$var$node;

});
parcelRegister("ginDg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d37ef2772d46595$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $8d37ef2772d46595$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('bsnbry-rovodev-agents-panel');
    }
};

});

parcelRegister("8FjDB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c331984c62f9b536$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $c331984c62f9b536$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('conceal_items_in_meatball_menu_ga_fg');
    }
};

});

parcelRegister("gAaux", function(module, exports) {

$parcel$export(module.exports, "default", () => $243b733deddf993e$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $243b733deddf993e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('config-url-defer-iv');
    }
};

});

parcelRegister("kZq2R", function(module, exports) {

$parcel$export(module.exports, "default", () => $640947420e48b0a4$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $640947420e48b0a4$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('empanada_remove_singleselect_readview_fieldoptions');
    }
};

});

parcelRegister("l9xWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $eba18a144261330b$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $eba18a144261330b$export$2e2bcd8739ae039 = {
    get () {
        // eslint-disable-next-line jira/ff/no-preconditioning
        return (0, $7jTnu.fg)('jira_preview_panel_m_1_rollout') && (0, $7jTnu.fg)('jira-glance-panel');
    }
};

});

parcelRegister("hHOEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e662ece0a0353288$export$2e2bcd8739ae039);

var $epTsa = parcelRequire("epTsa");
var $e662ece0a0353288$export$2e2bcd8739ae039 = {
    get () {
        return (0, $epTsa.expVal)('jira-itr-m4-exp-3', 'isEnabled', false);
    }
};

});

parcelRegister("2Z4v6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f2f02804d9e4b9e$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $3f2f02804d9e4b9e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jira_inline_field_config_gate');
    }
};

});

parcelRegister("dTrc4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce73a29f5524b92f$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $ce73a29f5524b92f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('issue_table_single_line_row_height_event_delegator');
    }
};

});

parcelRegister("kiE1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ac0088d55ff6e34$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $6ac0088d55ff6e34$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('single_line_row_height_collapsable_fields');
    }
};

});

parcelRegister("gUtTS", function(module, exports) {

$parcel$export(module.exports, "default", () => $004871169600dd58$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $004871169600dd58$var$isRemoveFieldFragmentsEnabled = {
    get () {
        return (0, $7jTnu.fg)('dfo_remove_field_fragments');
    }
};
var $004871169600dd58$export$2e2bcd8739ae039 = $004871169600dd58$var$isRemoveFieldFragmentsEnabled;

});

parcelRegister("hRj2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c7ac58a937df639$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $1c7ac58a937df639$var$isFieldsByIdRemoved = {
    get () {
        return (0, $7jTnu.fg)('dfo_remove_fields_by_id');
    }
};
var $1c7ac58a937df639$export$2e2bcd8739ae039 = $1c7ac58a937df639$var$isFieldsByIdRemoved;

});

parcelRegister("5nHY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $37d4f595332681c2$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $37d4f595332681c2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('enable_classification_org_default');
    }
};

});

parcelRegister("2HLoK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1abdea24f5875b44$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $1abdea24f5875b44$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jira_platform_issue_realtime_updates_used_in_nin');
    }
};

});

parcelRegister("ePJhs", function(module, exports) {

$parcel$export(module.exports, "default", () => $92292d3add361cda$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $92292d3add361cda$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jira-issue-view-child-issues-panel-realtime-update');
    }
};

});

parcelRegister("84Nve", function(module, exports) {

$parcel$export(module.exports, "default", () => $f606be28bbc6fb53$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $f606be28bbc6fb53$export$2e2bcd8739ae039 = {
    get () {
        return(// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $7jTnu.fg)('enable_redaction_support_in_jira_issue_view') && (0, $7jTnu.fg)('relay-migration-issue-header-and-parent'));
    }
};

});

parcelRegister("bU8Sj", function(module, exports) {

$parcel$export(module.exports, "default", () => $748aaaa6a5a84440$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $748aaaa6a5a84440$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('frontier-currency-field-d1');
    }
};

});

parcelRegister("3fKMz", function(module, exports) {

$parcel$export(module.exports, "default", () => $da84f6afe4b6a8f6$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $da84f6afe4b6a8f6$var$JiraStorageHardLimitRelayProvider = {
    get () {
        return (0, $7jTnu.fg)('jira-storage-hard-limit-gate');
    }
};
var $da84f6afe4b6a8f6$export$2e2bcd8739ae039 = $da84f6afe4b6a8f6$var$JiraStorageHardLimitRelayProvider;

});

parcelRegister("clCUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fba3a3b4fa105c7$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $2fba3a3b4fa105c7$var$isQueryByStatusFieldDirectlyEnabled = {
    get () {
        return (0, $7jTnu.fg)('jiv-20953-query-by-status-field-directly');
    }
};
var $2fba3a3b4fa105c7$export$2e2bcd8739ae039 = $2fba3a3b4fa105c7$var$isQueryByStatusFieldDirectlyEnabled;

});

parcelRegister("jLDgo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da0c8b9d8cbd8d6$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $3da0c8b9d8cbd8d6$var$fixDisabledVotingOption = {
    get () {
        return (0, $7jTnu.fg)('jracloud-81233-fix-disabled-voting-option');
    }
};
var $3da0c8b9d8cbd8d6$export$2e2bcd8739ae039 = $3da0c8b9d8cbd8d6$var$fixDisabledVotingOption;

});

parcelRegister("84S8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $3101d160e40b29c6$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $3101d160e40b29c6$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jracloud-94147_hot-116492_fix_attachments_preview');
    }
};

});

parcelRegister("8Qoc7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef773c4214bbea2d$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $ef773c4214bbea2d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jsc_list_reranking_ast_refactor');
    }
};

});

parcelRegister("gCEws", function(module, exports) {

$parcel$export(module.exports, "default", () => $598c4e66c2a0ad5e$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $598c4e66c2a0ad5e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jsc_inline_editing_field_refactor');
    }
};

});

parcelRegister("fHkJz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3afca05a1c108930$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $3afca05a1c108930$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jsc_inline_editing_flag_fix');
    }
};

});

parcelRegister("7lcgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $af7d457213d96242$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $af7d457213d96242$var$JscM2FeChangesRelayProvider = {
    get () {
        return (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes');
    }
};
var $af7d457213d96242$export$2e2bcd8739ae039 = $af7d457213d96242$var$JscM2FeChangesRelayProvider;

});

parcelRegister("iOvkB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1076a5ec945e04c$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $f1076a5ec945e04c$var$JscMergedColumnRelayProvider = {
    get () {
        return (0, $7jTnu.fg)('jira_list_merged_column_gate');
    }
};
var $f1076a5ec945e04c$export$2e2bcd8739ae039 = $f1076a5ec945e04c$var$JscMergedColumnRelayProvider;

});

parcelRegister("1kOgh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d3b9eead2d77881$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $2d3b9eead2d77881$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('magma-3191-render-chin-skeleton-in-ssr');
    }
};

});

parcelRegister("5KpqZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $92b9171d2510de0f$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $92b9171d2510de0f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('relay-migration-issue-fields-assignee-fg');
    }
};

});

parcelRegister("j9A6z", function(module, exports) {

$parcel$export(module.exports, "default", () => $da04c3790a11745f$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $7jTnu = parcelRequire("7jTnu");
var $da04c3790a11745f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('relay-migration-issue-fields-checkbox-select');
    }
};

});

parcelRegister("2INXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d39c348564f268c0$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $d39c348564f268c0$var$isIssueViewFieldConfigEditEnabled = {
    get () {
        return (0, $7jTnu.fg)('issue_view_field_config_edit');
    }
};
var $d39c348564f268c0$export$2e2bcd8739ae039 = $d39c348564f268c0$var$isIssueViewFieldConfigEditEnabled;

});

parcelRegister("cI44N", function(module, exports) {

$parcel$export(module.exports, "default", () => $83d12a35d35efcce$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $83d12a35d35efcce$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("ahbHV", function(module, exports) {

$parcel$export(module.exports, "default", () => $04749856c3bd4104$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $04749856c3bd4104$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("1iihV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab97cfbab222523c$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ab97cfbab222523c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("lPtKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $23f447ad36e40ca2$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $7jTnu = parcelRequire("7jTnu");
var $23f447ad36e40ca2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('relay-migration-issue-fields-resolution');
    }
};

});

parcelRegister("fLB4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c0a8d930c3dea5c$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $7jTnu = parcelRequire("7jTnu");
var $5c0a8d930c3dea5c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('relay-migration-issue-fields-multi-line-text-fg');
    }
};

});

parcelRegister("goaDN", function(module, exports) {

$parcel$export(module.exports, "default", () => $438762f7927744fa$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $438762f7927744fa$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('relay-migration-issue-fields-resolution') || (0, $7jTnu.fg)('relay-migration-issue-fields-status');
    }
};

});

parcelRegister("i3mIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $04cfa17728d241ba$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $7jTnu = parcelRequire("7jTnu");
var $04cfa17728d241ba$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('relay-migration-issue-fields-status');
    }
};

});

parcelRegister("5uEG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cad404c38187d9b$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $7jTnu = parcelRequire("7jTnu");
var $5cad404c38187d9b$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('relay-migration-issue-fields-time-tracking');
    }
};

});


parcelRegister("d60Hm", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $795b06e1e9a5d895$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $795b06e1e9a5d895$export$df36fc05622c402);
$parcel$export(module.exports, "getAllUrlParams", () => $795b06e1e9a5d895$export$dca91ad250f6b082);
$parcel$export(module.exports, "getPermalinkId", () => $795b06e1e9a5d895$export$bf42dbba4c31080e);
$parcel$export(module.exports, "getPermalinkIdFromURL", () => $795b06e1e9a5d895$export$87557f913748dcff);

var $gRw8I = parcelRequire("gRw8I");

var $eSnSE = parcelRequire("eSnSE");
const $795b06e1e9a5d895$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $795b06e1e9a5d895$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $795b06e1e9a5d895$export$df36fc05622c402 = 'WORKLOG';
/**
 * @deprecated this function is unsafe for using on server side code due to `window` object usage
 */ const $795b06e1e9a5d895$export$dca91ad250f6b082 = ()=>{
    (0, $gRw8I.di)(window);
    // get query string from  window
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let queryString = window.location.search.slice(1);
    // we'll store the parameters here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            try {
                const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                obj[paramName] = paramValue;
            } catch (error) {
                (0, $eSnSE.default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
            }
        }
    }
    return obj;
};
const $795b06e1e9a5d895$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$795b06e1e9a5d895$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $795b06e1e9a5d895$export$dca91ad250f6b082();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$795b06e1e9a5d895$export$b18d061fc042df1a[targetPermalinkType]];
};
const $795b06e1e9a5d895$export$87557f913748dcff = (targetPermalinkType, url)=>{
    const queryParamKey = $795b06e1e9a5d895$export$b18d061fc042df1a[targetPermalinkType];
    if (!queryParamKey) return null;
    return url.searchParams.get(queryParamKey);
};

});


parcelRegister("eq3q8", function(module, exports) {

$parcel$export(module.exports, "getIssueKey", () => $f3a8bc7a8cf56aaa$export$4a030f6192bebe03);
const $f3a8bc7a8cf56aaa$export$4a030f6192bebe03 = (match)=>{
    const fromMatch = match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : null;
    return fromMatch;
};

});

// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $9790b8dfe6f31c81$export$19d68f5aa485d903 = false;

parcelRegister("6NSKd", function(module, exports) {

$parcel$export(module.exports, "withResourceEarlyData", () => $551b7a7af70655c3$export$22da5fb8c8200986);
$parcel$export(module.exports, "createRelayResourceDeprecated", () => $551b7a7af70655c3$export$2e279339bedcd427);

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $6uWhG = parcelRequire("6uWhG");

var $7zZ4w = parcelRequire("7zZ4w");

var $g1oKu = parcelRequire("g1oKu");

var $7797X = parcelRequire("7797X");

var $l1VxS = parcelRequire("l1VxS");

var $aOk72 = parcelRequire("aOk72");
const $551b7a7af70655c3$export$5664a170ac5a9781 = 5000;
const $551b7a7af70655c3$export$22da5fb8c8200986 = ({ type: type, getData: next, getDataLoader: getDataLoader, ...rest })=>{
    const getData = (...args)=>{
        performance.mark(`issueViewEarlyScripts:${type}:withResourceEarlyData:called`);
        if (!false && type in window) {
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
            const promise = window[type];
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            delete window[type];
            getDataLoader && promise.then(getDataLoader);
            return promise;
        }
        if (getDataLoader) return getDataLoader().then(({ default: getDataPromise })=>getDataPromise(...args));
        return next && next(...args);
    };
    return {
        ...rest,
        type: type,
        getData: getData
    };
};
const $551b7a7af70655c3$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $551b7a7af70655c3$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false, isCritical: isCritical = false })=>(0, $l1VxS.createResource)({
        type: `${$551b7a7af70655c3$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, storeContext)=>{
            const { parameters: preloadableRequest, variables: queryVariables, keyVariables: keyVariables } = getQuery(routerContext, storeContext);
            // There are some variables that we don't want to trigger a reload even if they are changed, by default use 'variables', or you can also pass over
            // specific keyVariables that will trigger the reload
            const variables = keyVariables || queryVariables;
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            if ('kind' in preloadableRequest && preloadableRequest.kind === 'PreloadableConcreteRequest') {
                ({ params: params } = preloadableRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $37Ewn.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: async (routerContext, storeContext)=>{
            const measureName = `relay_resource_get_data:${type}`;
            const startMark = `relay_resource_get_data:${type}:start`;
            const endMark = `relay_resource_get_data:${type}:end`;
            (0, $6uWhG.setMark)(startMark);
            const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, storeContext);
            // We either have a sync query or an async one from loadParameters. Never neither
            // This is enforced by 2 aliases of this method having different types, but Typescript cannot infer that neatly, so we cast away the nullable case.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const query = parameters ?? await loadParameters?.();
            // loadQuery returns not a Promise, but Observable.
            // Resource waits until query Observable is completed and returns a queryReference
            // later queryReference could be used by usePreloadedQuery
            const queryReference = (0, $6uWhG.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), query, variables || {}, options));
            if (false && queryReference.id != null) await (0, $7797X.QueryPromisesMap).get(queryReference.id);
            if (queryReference.id != null) (0, $7797X.QueryPromisesMap).get(queryReference.id)?.then(()=>{
                (0, $6uWhG.setMark)(endMark);
                (0, $6uWhG.setMeasure)(measureName, startMark, endMark);
            });
            /**
			 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
			 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
			 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
			 * as well as subsequent fetches made by route transitions between spa-apps.
			 */ if (captureErrors) (0, $g1oKu.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $aOk72.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly,
        isCritical: isCritical
    });
const $551b7a7af70655c3$export$2e279339bedcd427 = $551b7a7af70655c3$var$createRelayResourceImpl;

});


parcelRegister("lPVME", function(module, exports) {

$parcel$export(module.exports, "issueGiraDataResource", () => $f496a1a0a8f6865a$export$37badecd288c49f4);

var $eq3q8 = parcelRequire("eq3q8");

var $l1VxS = parcelRequire("l1VxS");

var $5L7qx = parcelRequire("5L7qx");


var $epTsa = parcelRequire("epTsa");

var $6NSKd = parcelRequire("6NSKd");

var $hM5pD = parcelRequire("hM5pD");
const $f496a1a0a8f6865a$export$37badecd288c49f4 = (0, $5L7qx.browserOnlyResourceWithCondition)(()=>{
    if (0, $9790b8dfe6f31c81$export$19d68f5aa485d903) // not "browser only" if FF is on
    return !(0, $epTsa.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false);
    return true;
}, // eslint-disable-next-line @typescript-eslint/no-explicit-any
(0, $l1VxS.createResource)((0, $6NSKd.withResourceEarlyData)({
    type: 'ISSUE_GIRA_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $hM5pD.default)(...args),
    isBrowserOnly: true
})));

});
parcelRegister("hM5pD", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e266f77fd89b5cf$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $2c68b = parcelRequire("2c68b");

var $7hVvO = parcelRequire("7hVvO");

var $eq3q8 = parcelRequire("eq3q8");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2e266f77fd89b5cf$export$2e2bcd8739ae039 = async ({ match: match }, _storeContext)=>{
    const issueKey = (0, $eq3q8.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const data = await (0, $2c68b.default)(issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $7hVvO.createResourceError)({
            component: 'spa.view.routes.issue-view.gira.getData',
            message: 'An error was thrown while prefetching issue gira data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("2c68b", function(module, exports) {

$parcel$export(module.exports, "default", () => $f746cf123483fdb3$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $7jTnu = parcelRequire("7jTnu");

var $4WXKS = parcelRequire("4WXKS");

var $dNyY6 = parcelRequire("dNyY6");

var $8DQlA = parcelRequire("8DQlA");

var $jxCGn = parcelRequire("jxCGn");

var $hWeHP = parcelRequire("hWeHP");

var $6rzJr = parcelRequire("6rzJr");
const $f746cf123483fdb3$var$ISSUE_GIRA_DATA = 'issue-gira-data';
const $f746cf123483fdb3$var$timeToFetchIssueGiraDataMetric = (0, $4WXKS.metrics).custom({
    key: $f746cf123483fdb3$var$ISSUE_GIRA_DATA
});
const $f746cf123483fdb3$var$getCloudId = (0, $LFmXM.default)(()=>(0, $7jTnu.fg)('forge-issue-panel-open-by-default') ? (0, $hWeHP.default)('ajs-cloud-id') : null);
const $f746cf123483fdb3$var$fetchIssueGiraData = async (issueKey)=>{
    const cloudId = $f746cf123483fdb3$var$getCloudId();
    const projectKey = (0, $dNyY6.extractProjectKey)(issueKey);
    const variables = {
        issueKey: issueKey,
        projectKey: projectKey,
        ...cloudId ? {
            cloudId: cloudId
        } : {}
    };
    const payload = {
        query: cloudId ? (0, $8DQlA.buildIssueQueryV2)() : (0, $8DQlA.buildIssueQuery)(),
        variables: variables,
        operationName: (0, $8DQlA.ISSUE_VIEW_INTERACTIVE_QUERY)
    };
    if ((0, $jxCGn.isInSample)()) $f746cf123483fdb3$var$timeToFetchIssueGiraDataMetric.start();
    try {
        const response = await (0, $6rzJr.getClient)('issue-fetch-service/src/services/issue-gira-data/index').query(payload);
        // Best-effort attempt to provide `issueId` and is not guaranteed
        const issueId = response.data?.viewIssue?.issueId;
        $f746cf123483fdb3$var$timeToFetchIssueGiraDataMetric.stop({
            customData: issueId ? {
                issueId: issueId
            } : null
        });
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // Cancel the metric and re-throw the error
        $f746cf123483fdb3$var$timeToFetchIssueGiraDataMetric.cancel();
        throw error;
    }
};
var $f746cf123483fdb3$export$2e2bcd8739ae039 = $f746cf123483fdb3$var$fetchIssueGiraData;

});
parcelRegister("8DQlA", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $2f4d1124325e51fb$export$1780a132c0453fee);
$parcel$export(module.exports, "getGiraUrl", () => $2f4d1124325e51fb$export$aefb19023b2eda55);
$parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", () => $2f4d1124325e51fb$export$79eba9bf6dc9960d);
$parcel$export(module.exports, "buildIssueQuery", () => $2f4d1124325e51fb$export$222ae9aca08830f0);
$parcel$export(module.exports, "buildIssueQueryV2", () => $2f4d1124325e51fb$export$fd751aee2a193083);
$parcel$export(module.exports, "getGiraRequestOptions", () => $2f4d1124325e51fb$export$e1542dc7ff749de8);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $cTI7h = parcelRequire("cTI7h");

var $f8B5B = parcelRequire("f8B5B");

var $c6t82 = parcelRequire("c6t82");

var $lGt35 = parcelRequire("lGt35");

var $l6Jfp = parcelRequire("l6Jfp");

var $avnia = parcelRequire("avnia");

var $efm76 = parcelRequire("efm76");

var $cEdKD = parcelRequire("cEdKD");

var $g6Y30 = parcelRequire("g6Y30");

var $hif4C = parcelRequire("hif4C");

var $7JZFE = parcelRequire("7JZFE");

var $cvLHO = parcelRequire("cvLHO");
const $2f4d1124325e51fb$var$CREATED_ORDER_DESCENDING = '-created';
const $2f4d1124325e51fb$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $2f4d1124325e51fb$export$aefb19023b2eda55 = (operation)=>`/rest/gira/1/${(0, $cTI7h.appendOperationQuery)(operation)}`;
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $2f4d1124325e51fb$var$getURLFromWindow = ()=>new URL(window.location.href);
const $2f4d1124325e51fb$var$viewIssueQuery = (url = $2f4d1124325e51fb$var$getURLFromWindow(), includeForgeQuery = true)=>`
    viewIssue(issueKey: $issueKey) {
        canCreateSubTask
        canExportIssue
        ${/**
					 * THIS QUERY ONLY FETCHES TOTAL COUNT OF COMMENTS
					 * For all other comment related data, use AGG endpoints
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $f8B5B.default)({
        maxResults: (0, $l6Jfp.NUM_INITIAL_COMMENTS_TO_LOAD),
        startAt: 0,
        orderBy: $2f4d1124325e51fb$var$CREATED_ORDER_DESCENDING,
        commentAmount: Math.floor((0, $l6Jfp.NUM_INITIAL_COMMENTS_TO_LOAD)),
        url: url
    })}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $cvLHO.default)({
        startAt: 0,
        worklogAmount: Math.floor((0, $l6Jfp.NUM_INITIAL_WORKLOGS_TO_LOAD)),
        url: url
    })}
        ${(0, $lGt35.getEcosystemQuery)(includeForgeQuery)}
        ${(0, $c6t82.getContentPanelsQuery)()}
        ${(0, $lGt35.getLegacyRightWebPanelsQuery)()}
        totalAttachmentsCount
        ${(0, $efm76.getContainersByTypeQuery)()}
        ${(0, $7JZFE.getRemoteLinksQuery)()}
    }
`;
const $2f4d1124325e51fb$var$getForgeQuery = ()=>`
    forge {
        workItemPanels(
            cloudId: $cloudId,
            context: {
                workItemIdOrKey: $issueKey
            }
        ) {
            moduleId
            pinnedTo
            instances {
                id
                pinnedTo
                collapsed
                added
            }
        }
    }
`;
const $2f4d1124325e51fb$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
const $2f4d1124325e51fb$export$58eaa2ae4a5a410a = (includeForgeQuery = false)=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    	${includeForgeQuery ? $2f4d1124325e51fb$var$getForgeQuery() : ''}
		}
`;
const $2f4d1124325e51fb$export$222ae9aca08830f0 = (url)=>`
query ${$2f4d1124325e51fb$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$2f4d1124325e51fb$export$58eaa2ae4a5a410a()}
        ${(0, $cEdKD.default)()}
        ${$2f4d1124325e51fb$var$viewIssueQuery(url)}
        ${(0, $avnia.getJiraSettingsQuery)()}
        ${(0, $g6Y30.default)()}
        ${(0, $hif4C.default)()}
    }

`;
const $2f4d1124325e51fb$export$fd751aee2a193083 = (url)=>`
query ${$2f4d1124325e51fb$export$1780a132c0453fee}($issueKey: String!, $projectKey: String, $cloudId: ID)  {
        ${$2f4d1124325e51fb$export$58eaa2ae4a5a410a(/* includeForgeQuery */ true)}
        ${(0, $cEdKD.default)()}
        ${$2f4d1124325e51fb$var$viewIssueQuery(url, /* includeForgeQuery */ false)}
        ${(0, $avnia.getJiraSettingsQuery)()}
        ${(0, $g6Y30.default)()}
        ${(0, $hif4C.default)()}
    }
`;
const $2f4d1124325e51fb$export$e1542dc7ff749de8 = (issueKey, projectKey, url)=>{
    const payload = {
        operationName: $2f4d1124325e51fb$export$1780a132c0453fee,
        query: $2f4d1124325e51fb$export$222ae9aca08830f0(url),
        variables: {
            issueKey: issueKey,
            projectKey: projectKey
        }
    };
    return {
        method: 'POST',
        body: JSON.stringify(payload)
    };
};

});
parcelRegister("cTI7h", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $237ed4c9607e5b1c$export$69694c3add0f6058);
const $237ed4c9607e5b1c$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("f8B5B", function(module, exports) {

$parcel$export(module.exports, "default", () => $53da8aef2f05bd3c$export$2e2bcd8739ae039);

var $d60Hm = parcelRequire("d60Hm");
const $53da8aef2f05bd3c$var$createCommentsFragment = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, url: url })=>{
    const commentPermalinkId = url ? (0, $d60Hm.getPermalinkIdFromURL)((0, $d60Hm.COMMENTS), url) : (0, $d60Hm.getPermalinkId)((0, $d60Hm.COMMENTS));
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
    const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
        }
    `;
};
var $53da8aef2f05bd3c$export$2e2bcd8739ae039 = $53da8aef2f05bd3c$var$createCommentsFragment;

});

parcelRegister("c6t82", function(module, exports) {

$parcel$export(module.exports, "getContentPanelsQuery", () => $4249a4b796c65712$export$e6f14eac549b679d);
const $4249a4b796c65712$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $4249a4b796c65712$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$4249a4b796c65712$var$getContentPanelNode()}
            }
        }
    }
`;
const $4249a4b796c65712$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$4249a4b796c65712$var$getContentPanelNode()}
            }
        }
    }
`;
const $4249a4b796c65712$export$e6f14eac549b679d = ()=>`
    ${$4249a4b796c65712$var$getContentPanelsConnectionQuery()}
    ${$4249a4b796c65712$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;

});

parcelRegister("lGt35", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $5d3bcfb4ca889012$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $5d3bcfb4ca889012$export$92c9a3dc7076af51);
const $5d3bcfb4ca889012$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $5d3bcfb4ca889012$export$edefef8c65e08bd2 = (includeForgeQuery = true)=>`
    ecosystem {
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${includeForgeQuery ? $5d3bcfb4ca889012$var$getForgeQuery() : ''}
    }
`;
const $5d3bcfb4ca889012$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("l6Jfp", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $bba965161d9cb764$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $bba965161d9cb764$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $bba965161d9cb764$export$aeae6fc40846cf9f);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports














const $bba965161d9cb764$export$c46d621c29194aa4 = 5;
const $bba965161d9cb764$export$304a6c004edb30d8 = '-created';
const $bba965161d9cb764$export$b2e398ce246f55b3 = 5;
const $bba965161d9cb764$export$1c36ecc9afd61c73 = '-started';
const $bba965161d9cb764$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});

parcelRegister("avnia", function(module, exports) {

$parcel$export(module.exports, "getJiraSettingsQuery", () => $0d65d613f30838ca$export$191f50c0f86b85ec);
const $0d65d613f30838ca$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
const $0d65d613f30838ca$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
const $0d65d613f30838ca$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;

});

parcelRegister("efm76", function(module, exports) {

$parcel$export(module.exports, "getContainersByTypeQuery", () => $ce3bfce6001e529c$export$63131b2831854cc);

var $hbF3h = parcelRequire("hbF3h");

var $7jTnu = parcelRequire("7jTnu");
const $ce3bfce6001e529c$export$e30f32dd3fd26efd = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $ce3bfce6001e529c$export$842411c0b98baa9c = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL, CUSTOMER_CONTEXT], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $ce3bfce6001e529c$export$63131b2831854cc = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('jcs_master_flag'), $ce3bfce6001e529c$export$842411c0b98baa9c, $ce3bfce6001e529c$export$e30f32dd3fd26efd);

});

parcelRegister("cEdKD", function(module, exports) {

$parcel$export(module.exports, "default", () => $8daa13ccb825551d$export$2e2bcd8739ae039);

var $cGVqS = parcelRequire("cGVqS");
const $8daa13ccb825551d$var$createMediaContextFragment = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, $cGVqS.getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;
var $8daa13ccb825551d$export$2e2bcd8739ae039 = $8daa13ccb825551d$var$createMediaContextFragment;

});
parcelRegister("cGVqS", function(module, exports) {

$parcel$export(module.exports, "getMaxTokenLength", () => $fda68ad41e642ef5$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $fda68ad41e642ef5$var$nonIE11MaxTokenLength = 2 ** 16;
const $fda68ad41e642ef5$export$e40f2acaf1a50b00 = ()=>$fda68ad41e642ef5$var$nonIE11MaxTokenLength;

});


parcelRegister("g6Y30", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c20a5fb285246a$export$2e2bcd8739ae039);
// A list of all keys of permissions that this transformer supports.
const $58c20a5fb285246a$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CLONE_ISSUE',
        'ARCHIVE_ISSUES',
        'UNARCHIVE_ISSUES'
    ];
const $58c20a5fb285246a$var$createPermissionsFragment = ()=>`

    permissions(issueKey:$issueKey, keys:["${$58c20a5fb285246a$export$9fc40cb6f3529ef().join('","')}"]) {
        key
        havePermission
    }
`;
var $58c20a5fb285246a$export$2e2bcd8739ae039 = $58c20a5fb285246a$var$createPermissionsFragment;

});

parcelRegister("hif4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ce89c5fc46ec8e1$export$2e2bcd8739ae039);
const $7ce89c5fc46ec8e1$var$createProjectFragment = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;
var $7ce89c5fc46ec8e1$export$2e2bcd8739ae039 = $7ce89c5fc46ec8e1$var$createProjectFragment;

});

parcelRegister("7JZFE", function(module, exports) {

$parcel$export(module.exports, "getRemoteLinksQuery", () => $c94d2c74482f6654$export$6bbc6b72b0b57f25);

var $7jTnu = parcelRequire("7jTnu");
const $c94d2c74482f6654$var$getRemoteLinksQueryNew = ()=>`
    remoteLinks {
        isLinkingEnabled
        confluencePages {
            linkedPages {
				pageCount
				pages {
					... on ConfluencePage {
						id
						globalId
						href
						title
						type
					}
					... on FailedRemoteLink {
						id
						error
						link {
							id
							globalId
							href
						}
						repairLink { href }
					}
				}
            }
        }
		remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;
const $c94d2c74482f6654$var$getRemoteLinksQueryOld = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;
const $c94d2c74482f6654$export$6bbc6b72b0b57f25 = ()=>(0, $7jTnu.fg)('jiv_confluence_remote_link_critical_query') ? $c94d2c74482f6654$var$getRemoteLinksQueryNew() : $c94d2c74482f6654$var$getRemoteLinksQueryOld();

});

parcelRegister("cvLHO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b69391f765eb53b$export$2e2bcd8739ae039);

var $d60Hm = parcelRequire("d60Hm");
const $5b69391f765eb53b$var$createWorklogsFragment = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount, url: url })=>{
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogPermalinkId = url ? (0, $d60Hm.getPermalinkIdFromURL)((0, $d60Hm.WORKLOG), url) : (0, $d60Hm.getPermalinkId)((0, $d60Hm.WORKLOG));
    if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
    const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
};
var $5b69391f765eb53b$export$2e2bcd8739ae039 = $5b69391f765eb53b$var$createWorklogsFragment;

});


parcelRegister("jxCGn", function(module, exports) {

$parcel$export(module.exports, "isInSample", () => $5c228c8a5723854f$export$a994c91d08ead5ff);

const $5c228c8a5723854f$export$a994c91d08ead5ff = (sampleRate = (0, $9ffe3c13ac3aa7ad$export$9fc1f2d681a9e609))=>Math.random() <= 1 / sampleRate;

});
/**
 * Sample rates are defined as the inverse.
 * e.g. a sample rate of 100 = 1 in 100 events are sent.
 */ const $9ffe3c13ac3aa7ad$export$9fc1f2d681a9e609 = 100; // 1%


parcelRegister("6rzJr", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $dc2f954dac87a9b3$export$6bb76d6eba7e258c);

var $4mEPL = parcelRequire("4mEPL");
const $dc2f954dac87a9b3$var$appendOperationQuery = (operation)=>operation ? `?operation=${operation}` : '';
const $dc2f954dac87a9b3$export$aefb19023b2eda55 = (operation)=>`/rest/gira/1/${$dc2f954dac87a9b3$var$appendOperationQuery(operation)}`;
const $dc2f954dac87a9b3$var$makeFetchClient = (path)=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $4mEPL.default)($dc2f954dac87a9b3$export$aefb19023b2eda55(operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            }, path)
    });
let $dc2f954dac87a9b3$var$client;
const $dc2f954dac87a9b3$export$6bb76d6eba7e258c = (path)=>{
    if (!$dc2f954dac87a9b3$var$client) $dc2f954dac87a9b3$var$client = $dc2f954dac87a9b3$var$makeFetchClient(path);
    return $dc2f954dac87a9b3$var$client;
};

});
parcelRegister("4mEPL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d563314f1a32c40$export$2e2bcd8739ae039);

var $3ibpe = parcelRequire("3ibpe");

var $1Ozm9 = parcelRequire("1Ozm9");

var $1uIew = parcelRequire("1uIew");

var $7jTnu = parcelRequire("7jTnu");

var $dxLpE = parcelRequire("dxLpE");
async function $4d563314f1a32c40$export$2e2bcd8739ae039(url, options = {}, path) {
    if (!(0, $7jTnu.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $1Ozm9.default)(url, options);
    const defaultExperienceDescription = {
        experience: (0, $dxLpE.isGiraUrl)(url) ? 'issueGira' : 'issueRest',
        analyticsSource: (0, $dxLpE.isGiraUrl)(url) ? 'issueGira' : 'issueRest',
        application: null,
        edition: null
    };
    try {
        const response = await (0, $1Ozm9.default)(url, {
            ...options
        });
        (0, $3ibpe.sendExperienceAnalytics)({
            ...defaultExperienceDescription,
            action: 'taskSuccess',
            additionalAttributes: {
                path: path
            }
        });
        return response;
    } catch (error) {
        if ((0, $1uIew.isFetchError)(error)) {
            const additionalAttributes = {
                statusCode: error.statusCode || 0,
                errorMessage: error.message || 'unknown',
                traceId: error.traceId || 'unknown',
                path: path
            };
            const statusCode = additionalAttributes.statusCode;
            let action = 'taskFail';
            if (statusCode && statusCode >= 400 && statusCode < 500) action = 'taskAbort';
            (0, $3ibpe.sendExperienceAnalytics)({
                ...defaultExperienceDescription,
                action: action,
                additionalAttributes: additionalAttributes
            });
        }
        throw error;
    }
}

});
parcelRegister("3ibpe", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $b05a2baea0c3ab19$export$4a95ada1b8228562);

var $1O6Yz = parcelRequire("1O6Yz");

var $Buq00 = parcelRequire("Buq00");

var $mjinE = parcelRequire("mjinE");

var $hWeHP = parcelRequire("hWeHP");
const $b05a2baea0c3ab19$var$isSynthetic = ()=>(0, $hWeHP.default)('ajs-is-synthetic') === 'true';
function $b05a2baea0c3ab19$export$4a95ada1b8228562(experienceDescription) {
    const additionalContext = {};
    const shard = (0, $hWeHP.default)('ajs-shard');
    const region = (0, $hWeHP.default)('ajs-region');
    Object.assign(additionalContext, {
        shard: shard,
        region: region
    });
    const enabledFeatureFlags = Object.fromEntries([
        ...(0, $Buq00.allFeatureFlagsAccessed)
    ].filter(([, value])=>value));
    Object.assign(additionalContext, {
        enabledFeatureFlags: enabledFeatureFlags
    });
    const synthetics = {
        additionalAttributes: {
            synthetic: $b05a2baea0c3ab19$var$isSynthetic(),
            ...additionalContext
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(experienceDescription, synthetics);
    (0, $mjinE.default)(experienceDescription);
}

});
parcelRegister("mjinE", function(module, exports) {

$parcel$export(module.exports, "default", () => $65ee89f955c9da99$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");

var $hWeHP = parcelRequire("hWeHP");

var $2Mqjh = parcelRequire("2Mqjh");

var $bRJAs = parcelRequire("bRJAs");

var $a9ldn = parcelRequire("a9ldn");
const $65ee89f955c9da99$var$transformApplication = (application)=>{
    switch(application){
        case 0, $bRJAs.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $bRJAs.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $bRJAs.JIRA_CORE:
            return 'jira-core';
        case 0, $bRJAs.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $bRJAs.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $65ee89f955c9da99$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $a9ldn.FREE_EDITION:
            return 'jedi';
        case 0, $a9ldn.STANDARD_EDITION:
            return 'standard';
        case 0, $a9ldn.PREMIUM_EDITION:
            return 'premium';
        case 0, $a9ldn.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $65ee89f955c9da99$var$transformAction = (action, wasExperienceSuccesful)=>{
    if (action !== undefined) return action;
    return wasExperienceSuccesful ? 'taskSuccess' : 'taskFail';
};
const $65ee89f955c9da99$var$createAnalyticsEvent = ({ experience: experience, wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, field: field, hasEdit: hasEdit, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: $65ee89f955c9da99$var$transformAction(action, wasExperienceSuccesful),
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            task: experience,
            ...location ? {
                reason: location
            } : {},
            ...field ? {
                field: field
            } : {},
            ...typeof hasEdit === 'boolean' ? {
                hasEdit: hasEdit
            } : {},
            analyticsSource: analyticsSource,
            application: $65ee89f955c9da99$var$transformApplication(application),
            edition: $65ee89f955c9da99$var$transformEdition(edition),
            ...!false && (0, $7jTnu.fg)('chronos-add-shard-data-to-operational-metrics') ? {
                shard: (0, $hWeHP.default)('ajs-shard') || '',
                region: (0, $hWeHP.default)('ajs-region') || ''
            } : {}
        }
    });
var /**
 * @param {String} experienceDescription.experience
 * @param {Boolean} experienceDescription.wasExperienceSuccesful - Deprecated: Instead set `action` to `taskSuccess` (previously `true`), `taskFail` (previously `false`) or `taskAbort`
 * @param {Action} experienceDescription.action
 * @param {String} experienceDescription.location
 * @param {String} experienceDescription.field
 * @param {String} experienceDescription.hasEdit
 * @param {String} experienceDescription.analyticsSource
 * @param {String} experienceDescription.application
 * @param {Application} experienceDescription.edition
 * @param {ApplicationEdition} experienceDescription.additionalAttributes
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$65ee89f955c9da99$export$2e2bcd8739ae039 = (experienceDescription)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $65ee89f955c9da99$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};

});


parcelRegister("dxLpE", function(module, exports) {

$parcel$export(module.exports, "isGiraUrl", () => $f1c40d25f35e4f9e$export$ea636743f241905c);
const $f1c40d25f35e4f9e$export$ea636743f241905c = (url)=>url.startsWith('/rest/gira/');

});






parcelRegister("fk6FR", function(module, exports) {

$parcel$export(module.exports, "browseIssueEmbedRoute", () => $973922f52e8ea894$export$240aeec71c480594);
const $973922f52e8ea894$export$240aeec71c480594 = {
    name: 'issue-embed',
    path: '/browse/:issueKey(\\w+-\\d+)/embed'
};

});

parcelRegister("4FfIq", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $68e48e1970e78876$export$49addbcdecb6e6ff);
/* IssueViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $biWZb = parcelRequire("biWZb");

var $hwuZ0 = parcelRequire("hwuZ0");

var $hj1Lc = parcelRequire("hj1Lc");
const $68e48e1970e78876$var$fullpageStyles = null;
const $68e48e1970e78876$var$modalStyles = null;
const $68e48e1970e78876$var$customSpacingStyles = null;
const $68e48e1970e78876$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $68e48e1970e78876$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $68e48e1970e78876$var$fullpageStyles : null,
        isModalView === true ? $68e48e1970e78876$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $biWZb.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hj1Lc))),
        className: (0, $hcewu.default)([
            "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("biWZb", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $b77d47f9e4eb67f9$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $b77d47f9e4eb67f9$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $b77d47f9e4eb67f9$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");


var $8BpnG = parcelRequire("8BpnG");

var $gCY1z = parcelRequire("gCY1z");

var $coXKe = parcelRequire("coXKe");

var $cZpx8 = parcelRequire("cZpx8");
const $b77d47f9e4eb67f9$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const { Provider: $b77d47f9e4eb67f9$var$Provider, Consumer: $b77d47f9e4eb67f9$var$Consumer } = $b77d47f9e4eb67f9$export$37eeac5cc5245b18;
const $b77d47f9e4eb67f9$export$55a90a8e865a39b5 = 700;
const $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$b77d47f9e4eb67f9$export$55a90a8e865a39b5}px)`;
const $b77d47f9e4eb67f9$export$ddd398a95f85cd75 = 850;
const $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL = `(max-width: ${$b77d47f9e4eb67f9$export$ddd398a95f85cd75}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $b77d47f9e4eb67f9$var$useRouteKey() {
    const [routeState] = (0, $gCY1z.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $b77d47f9e4eb67f9$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $b77d47f9e4eb67f9$var$useRouteKey();
    (0, $cZpx8.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $cZpx8.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $548198843509795c$export$ee15e0cd1efafcb4);
        (0, $cZpx8.setCachedIsCompactValue)(defaultState, key);
    }
    const { isInDiscussionLayoutExperiment: isInDiscussionLayoutExperiment } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const query = isInDiscussionLayoutExperiment ? $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL : $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY;
    const [isCompact, setIsCompact] = (0, $eJOHy.useState)(defaultState);
    const onChange = (0, $fAZgY.useCallbackWithCondition)((state)=>{
        (0, $cZpx8.setCachedIsCompactValue)(state, key);
        setIsCompact(state);
    }, [
        key
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b77d47f9e4eb67f9$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8BpnG.ContainerQueryObserver), {
        query: query,
        onChange: onChange,
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b77d47f9e4eb67f9$var$Provider, {
        value: isCompact
    }, children));
};
const $b77d47f9e4eb67f9$export$20feb77b5b617e44 = $b77d47f9e4eb67f9$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b77d47f9e4eb67f9$var$StyledWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fAZgY", function(module, exports) {

$parcel$export(module.exports, "useMemoWithCondition", () => $fad0f5e11c49ca9f$export$ed979cc60a2ab51b);
$parcel$export(module.exports, "useCallbackWithCondition", () => $fad0f5e11c49ca9f$export$a51aeb9e9cb9a97e);
$parcel$export(module.exports, "useEffectWithCondition", () => $fad0f5e11c49ca9f$export$b4e6dcd5702a052c);

var $eJOHy = parcelRequire("eJOHy");
const $fad0f5e11c49ca9f$export$ed979cc60a2ab51b = (fn, deps, condition)=>{
    if (condition()) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $eJOHy.useMemo)(fn, deps);
    return fn();
};
const $fad0f5e11c49ca9f$export$a51aeb9e9cb9a97e = (fn, deps, condition)=>{
    if (condition()) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $eJOHy.useCallback)(fn, deps);
    return fn;
};
const $fad0f5e11c49ca9f$export$b4e6dcd5702a052c = (fn, deps, condition)=>{
    if (condition()) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $eJOHy.useEffect)(fn, deps);
    return fn;
};

});

const $548198843509795c$export$ee15e0cd1efafcb4 = false;

parcelRegister("8BpnG", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $b45aeffccc0e4b84$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

const $b45aeffccc0e4b84$var$QueryContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
let $b45aeffccc0e4b84$var$currentIdSeed = 0;
function $b45aeffccc0e4b84$var$generateAttributeValue() {
    return `indicator-span-${$b45aeffccc0e4b84$var$currentIdSeed++}`;
}
function $b45aeffccc0e4b84$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $548198843509795c$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $eJOHy.useState)(defaultState);
    const handleQueryStatusChange = (0, $eJOHy.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $b45aeffccc0e4b84$export$b66a67697973e01() {
    const currentState = (0, $eJOHy.useContext)($b45aeffccc0e4b84$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $b45aeffccc0e4b84$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $eJOHy.useMemo)(()=>$b45aeffccc0e4b84$var$generateAttributeValue(), []);
    const spanRef = (0, $eJOHy.useRef)(null);
    const containerRef = (0, $eJOHy.useRef)(null);
    const currentState = $b45aeffccc0e4b84$export$b66a67697973e01();
    (0, $eJOHy.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b45aeffccc0e4b84$var$ContainerToBeQueried = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("coXKe", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainers", () => $3b984a26137eed7b$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $3b984a26137eed7b$export$5f49a43487b268);
$parcel$export(module.exports, "useLayoutContainerByTypeMemoised", () => $3b984a26137eed7b$export$ef5966e43b13b4a9);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $3b984a26137eed7b$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $3b984a26137eed7b$export$5962da0433486667);
$parcel$export(module.exports, "useUserPreferredWorkItemLayout", () => $3b984a26137eed7b$export$9889eea62fdfa091);
$parcel$export(module.exports, "useIssueLayoutActions", () => $3b984a26137eed7b$export$1e5e9fc877a47cd9);

var $eJOHy = parcelRequire("eJOHy");

var $fAZgY = parcelRequire("fAZgY");

var $dIBmg = parcelRequire("dIBmg");

var $kfvK2 = parcelRequire("kfvK2");

var $epTsa = parcelRequire("epTsa");

var $cs58I = parcelRequire("cs58I");

var $hbF3h = parcelRequire("hbF3h");

var $bmoS1 = parcelRequire("bmoS1");

var $2cfd4 = parcelRequire("2cfd4");


var $bNexr = parcelRequire("bNexr");

var $7jTnu = parcelRequire("7jTnu");

var $ln6Iy = parcelRequire("ln6Iy");

var $16PQW = parcelRequire("16PQW");

var $eSnSE = parcelRequire("eSnSE");

var $l7Alo = parcelRequire("l7Alo");

var $lpEwy = parcelRequire("lpEwy");

var $co62F = parcelRequire("co62F");
const $3b984a26137eed7b$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $3b984a26137eed7b$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $dIBmg.useEnabledHiddenFields)();
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
        ], [
        container?.items.nodes,
        fieldsHiddenByUim
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $3b984a26137eed7b$export$ef5966e43b13b4a9 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    const fieldsHiddenByUim = (0, $dIBmg.useEnabledHiddenFields)();
    const filteredItems = (0, $eJOHy.useMemo)(()=>{
        return (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim);
    }, [
        container,
        fieldsHiddenByUim
    ]);
    return [
        filteredItems
    ];
};
const $3b984a26137eed7b$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $lpEwy.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $3b984a26137eed7b$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $lpEwy.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
    const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $a85d9f0dd63c9b50$export$39aaf586c7ee5202));
    const isMobile = (0, $l7Alo.default)();
    const locale = (0, $2cfd4.useLocale)();
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $7jTnu.fg)('issue_view_layout_experiment_feature_gate') && !(0, $7jTnu.fg)('issue_view_tab_layout_feature_gate')) {
            if ((0, $7jTnu.fg)('thor_layouts_splunk_logs_enable')) (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `useUserPreferredWorkItemLayout: Kill switch is off with flag values: ${JSON.stringify({
                isMobile: isMobile,
                isFullIssueView: isFullIssueView,
                projectType: projectType,
                isIssueKeyNull: issueKey === null,
                isProjectKeyNull: projectKey === null,
                isProjectTypeNull: projectType === null,
                locale: locale,
                userPreferredLayout: userPreferredLayout,
                isWideLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
                isDiscussionLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
            })}`);
            return {
                isInDiscussionLayoutExperiment: false,
                isInWideLayoutExperiment: false,
                isInLayoutExperiment: false,
                isActivityInVerticalSidePanel: false,
                userPreferredLayout: null
            };
        }
        const isSoftwareOrBusiness = projectType === (0, $ln6Iy.SOFTWARE_PROJECT) || projectType === (0, $ln6Iy.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $7jTnu.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $epTsa.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        if (userLayoutType === null && ((0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false) || (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false)) && (0, $7jTnu.fg)('thor_layouts_splunk_logs_enable')) (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `useUserPreferredWorkItemLayout: User layout type parsing: ${JSON.stringify({
            userPreferredLayout: userPreferredLayout,
            userLayoutType: userLayoutType,
            isMobile: isMobile,
            isIssueKeyNull: issueKey === null,
            isProjectKeyNull: projectKey === null,
            isProjectTypeNull: projectType === null,
            locale: locale,
            isSoftwareOrBusiness: isSoftwareOrBusiness,
            isFullIssueView: isFullIssueView,
            isWideLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
            isDiscussionLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
        })}`);
        let userSelectedLayout = userLayoutType;
        if (!(0, $7jTnu.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        if (userSelectedLayout === null && ((0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false) || (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false)) && (0, $7jTnu.fg)('thor_layouts_splunk_logs_enable')) (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `useUserPreferredWorkItemLayout: User selected layout parsing: ${JSON.stringify({
            userSelectedLayout: userSelectedLayout,
            isInLayoutExperiment: isInLayoutExperiment,
            userPreferredLayout: userPreferredLayout,
            isMobile: isMobile,
            isIssueKeyNull: issueKey === null,
            isProjectKeyNull: projectKey === null,
            isProjectTypeNull: projectType === null,
            locale: locale,
            isSoftwareOrBusiness: isSoftwareOrBusiness,
            isFullIssueView: isFullIssueView,
            isWideLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
            isDiscussionLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
        })}`);
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${JSON.stringify({
            error: error,
            isMobile: isMobile,
            isFullIssueView: isFullIssueView,
            isIssueKeyNull: issueKey === null,
            isProjectKeyNull: projectKey === null,
            isProjectTypeNull: projectType === null,
            userPreferredLayout: userPreferredLayout,
            locale: locale,
            isInWideLayoutExperiment: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
            isInDiscussionLayoutExperiment: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
        })}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff = ()=>{
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $7jTnu.fg)('issue_view_layout_experiment_feature_gate') && !(0, $7jTnu.fg)('issue_view_tab_layout_feature_gate')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        // eslint-disable-next-line react-hooks/react-compiler
        /* eslint-disable react-hooks/rules-of-hooks */ const issueKey = (0, $bmoS1.useIssueKey)();
        const projectKey = (0, $bNexr.useProjectKey)(issueKey);
        const projectType = (0, $bNexr.useProjectType)(projectKey);
        const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
        const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $a85d9f0dd63c9b50$export$39aaf586c7ee5202));
        const isMobile = (0, $l7Alo.default)();
        const isSoftwareOrBusiness = projectType === (0, $ln6Iy.SOFTWARE_PROJECT) || projectType === (0, $ln6Iy.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $7jTnu.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $epTsa.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        /* eslint-enable react-hooks/rules-of-hooks */ let userSelectedLayout = userLayoutType;
        if (!(0, $7jTnu.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${error}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$export$9889eea62fdfa091 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('issue_layout_rule_of_hook_fix'), $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn, $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff);
const $3b984a26137eed7b$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $lpEwy.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $eJOHy.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $eJOHy.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $eJOHy.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};
/**
 * useRouteToGetQueryParams hook
 * This hook retrieves the current query parameters from the router state.
 * It is used to access the active tab and other query parameters in the issue view layout.
 */ const $3b984a26137eed7b$var$useRouteToGetQueryParams = (0, $kfvK2.createRouterSelector)((state)=>{
    return state.query;
});
const $3b984a26137eed7b$export$b027791af8c9b114 = ()=>{
    const { activeTab: activeTab = (0, $16PQW.defaultActiveTab), ...otherQueryParams } = $3b984a26137eed7b$var$useRouteToGetQueryParams();
    const { updateQueryParam: updateQueryParam } = (0, $kfvK2.useRouterStoreActions)();
    const setActiveTab = (0, $eJOHy.useCallback)((tab)=>{
        if (activeTab !== tab) updateQueryParam({
            ...otherQueryParams,
            activeTab: tab
        }, 'replace');
    }, [
        activeTab,
        otherQueryParams,
        updateQueryParam
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            setDescriptionAsActive: ()=>setActiveTab((0, $16PQW.Tabs).Description),
            setWorkItemsAsActive: ()=>setActiveTab((0, $16PQW.Tabs).WorkItems),
            setIntegrationsAsActive: ()=>setActiveTab((0, $16PQW.Tabs).Integrations),
            setResourcesAsActive: ()=>setActiveTab((0, $16PQW.Tabs).Resources),
            currentActiveTab: activeTab
        }), [
        activeTab,
        setActiveTab
    ]);
};

});
parcelRegister("dIBmg", function(module, exports) {

$parcel$export(module.exports, "useEnabledHiddenFields", () => $9bf4a9e7437b106f$export$bb6c2b9159c3f32b);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $k6ouH = parcelRequire("k6ouH");

var $5mbow = parcelRequire("5mbow");
const $9bf4a9e7437b106f$export$bb6c2b9159c3f32b = ()=>{
    (0, $gRw8I.di)((0, $k6ouH.useAdjustmentsEnabled), (0, $5mbow.useHiddenFields));
    const adjustmentsAreEnabled = (0, $k6ouH.useAdjustmentsEnabled)();
    const hiddenFields = (0, $5mbow.useHiddenFields)();
    return (0, $eJOHy.useMemo)(()=>{
        if (!adjustmentsAreEnabled) return [];
        return hiddenFields;
    }, [
        adjustmentsAreEnabled,
        hiddenFields
    ]);
};

});
parcelRegister("k6ouH", function(module, exports) {

$parcel$export(module.exports, "store", () => $3c0afbbac0755842$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $3c0afbbac0755842$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $3c0afbbac0755842$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $3c0afbbac0755842$export$5eb9c167b683d125);

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $3c0afbbac0755842$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $3c0afbbac0755842$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($3c0afbbac0755842$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $3c0afbbac0755842$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-adjustments-context',
    initialState: $3c0afbbac0755842$var$initialState,
    actions: $3c0afbbac0755842$export$e324594224ef24da
});
const $3c0afbbac0755842$export$a12f82a132dee079 = (0, $iJq0l.createHook)($3c0afbbac0755842$export$6f57813fe9f31bf9);
const $3c0afbbac0755842$export$358ad850b2f6d6fe = (0, $iJq0l.createStateHook)($3c0afbbac0755842$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $3c0afbbac0755842$export$4f2729981f4b81d2 = (0, $iJq0l.createActionsHook)($3c0afbbac0755842$export$6f57813fe9f31bf9);
const $3c0afbbac0755842$export$5eb9c167b683d125 = (0, $6E16M.createContainer)($3c0afbbac0755842$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("5mbow", function(module, exports) {

$parcel$export(module.exports, "useHiddenFields", () => $57d5882d471a3edd$export$de6fdc67c945e596);

var $4MchI = parcelRequire("4MchI");
var $iJq0l = parcelRequire("iJq0l");

var $jMGuv = parcelRequire("jMGuv");
const $57d5882d471a3edd$var$selectHiddenFields = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $57d5882d471a3edd$export$de6fdc67c945e596 = (0, $iJq0l.createStateHook)((0, $jMGuv.store), {
    selector: $57d5882d471a3edd$var$selectHiddenFields
});

});
parcelRegister("jMGuv", function(module, exports) {

$parcel$export(module.exports, "store", () => $ba31be2cbcb1c0d4$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $ba31be2cbcb1c0d4$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $ba31be2cbcb1c0d4$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $ba31be2cbcb1c0d4$export$677b3e34bd14c681);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $dDEcF = parcelRequire("dDEcF");

var $lxoXU = parcelRequire("lxoXU");

var $5ytXp = parcelRequire("5ytXp");

var $9iCL6 = parcelRequire("9iCL6");

var $ePF6W = parcelRequire("ePF6W");

var $gHFQk = parcelRequire("gHFQk");

var $2R0pk = parcelRequire("2R0pk");

var $9N3Zu = parcelRequire("9N3Zu");

var $dyTi6 = parcelRequire("dyTi6");

var $ivt8i = parcelRequire("ivt8i");

var $aH4dF = parcelRequire("aH4dF");

var $gUC7k = parcelRequire("gUC7k");

var $5HnXB = parcelRequire("5HnXB");

var $9yT36 = parcelRequire("9yT36");

var $chqNi = parcelRequire("chqNi");
const $ba31be2cbcb1c0d4$var$name = 'issue-adjustments';
const $ba31be2cbcb1c0d4$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $ba31be2cbcb1c0d4$var$triggerFieldInitializationKey, viewType: $ba31be2cbcb1c0d4$var$scopedViewType, numberOfSupportedFields: $ba31be2cbcb1c0d4$var$numberOfSupportedFields, ...$ba31be2cbcb1c0d4$var$stateForResetAllFields } = $ba31be2cbcb1c0d4$export$d4c72bab9d6cc13a;
const $ba31be2cbcb1c0d4$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $ivt8i.processChange,
    setFieldValue: $gUC7k.setFieldValue,
    initializeField: $gHFQk.initializeField,
    initializeFields: $gHFQk.initializeFields,
    startFieldsInitialisationTimeout: $ePF6W.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $ePF6W.successFieldsInitalisation,
    registerFields: $aH4dF.registerFields,
    unregisterFields: $aH4dF.unregisterFields,
    updateFields: $9yT36.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($ba31be2cbcb1c0d4$var$stateForResetAllFields);
        },
    setError: $9iCL6.setError,
    resetError: $9iCL6.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $dDEcF.setAppErrors,
    resetAppErrors: $dDEcF.resetAppErrors,
    addAppsErrors: $dDEcF.addAppsErrors,
    initializeNoScreenTab: $2R0pk.initializeNoScreenTab,
    initializeScreenTabs: $9N3Zu.initializeScreenTabs,
    updateScreenTabs: $chqNi.updateScreenTabs,
    updateActiveScreenTab: $5HnXB.updateActiveScreenTab,
    detectAppliedChangesConflicts: $lxoXU.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $5ytXp.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $5ytXp.collectFieldsAppliedChangesHistory,
    setNotification: $dyTi6.setNotification,
    resetNotification: $dyTi6.resetNotification
};
const $ba31be2cbcb1c0d4$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: $ba31be2cbcb1c0d4$var$name,
    initialState: $ba31be2cbcb1c0d4$export$d4c72bab9d6cc13a,
    actions: $ba31be2cbcb1c0d4$export$e324594224ef24da
});
const $ba31be2cbcb1c0d4$export$37792a602e748c08 = (0, $iJq0l.createHook)($ba31be2cbcb1c0d4$export$6f57813fe9f31bf9);
const $ba31be2cbcb1c0d4$var$stableEmptyFieldFromIframe = {};
const $ba31be2cbcb1c0d4$export$c76e674a29843e21 = (0, $iJq0l.createHook)($ba31be2cbcb1c0d4$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $ba31be2cbcb1c0d4$export$df4b0714e8177e0e = (0, $iJq0l.createHook)($ba31be2cbcb1c0d4$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $ba31be2cbcb1c0d4$var$stableEmptyFieldFromIframe
});
const $ba31be2cbcb1c0d4$export$cb9a014ec14556d8 = (0, $iJq0l.createActionsHook)($ba31be2cbcb1c0d4$export$6f57813fe9f31bf9);
const $ba31be2cbcb1c0d4$export$677b3e34bd14c681 = (0, $iJq0l.createHook)($ba31be2cbcb1c0d4$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("dDEcF", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $3f3311d58f3b432c$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $3f3311d58f3b432c$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $3f3311d58f3b432c$export$24c821207687a907);
const $3f3311d58f3b432c$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $3f3311d58f3b432c$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $3f3311d58f3b432c$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("lxoXU", function(module, exports) {

$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $46c77bf3f9566c1e$export$90d94f20d157e756);

var $gRw8I = parcelRequire("gRw8I");

var $8TRzp = parcelRequire("8TRzp");


var $dDEcF = parcelRequire("dDEcF");

var $dyTi6 = parcelRequire("dyTi6");

var $gue6c = parcelRequire("gue6c");
const $46c77bf3f9566c1e$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $46c77bf3f9566c1e$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $46c77bf3f9566c1e$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $46c77bf3f9566c1e$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gRw8I.di)((0, $8TRzp.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $46c77bf3f9566c1e$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $86752b64b3304f92$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $gue6c.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $8TRzp.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $dDEcF.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $dyTi6.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("8TRzp", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $c6e2725c666d4e94$export$a1fb57756f0de62b);

var $63DI8 = parcelRequire("63DI8");


const $c6e2725c666d4e94$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $63DI8.default)((0, $c1a829681d66d55a$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $1793be513d46f473$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $1793be513d46f473$export$f636b5b56f1d624a = 'Screen';
const $1793be513d46f473$export$9d2de6eebf7462b5 = 'Drawer';
const $1793be513d46f473$export$1171103ea9083ffa = 'Modal';
const $1793be513d46f473$export$cae2783c9279926 = 'InlineDialog';
const $1793be513d46f473$export$d1123261ca8831d2 = 'Dropdown';
const $1793be513d46f473$export$a1562d08625f5d7e = 'UI';
const $1793be513d46f473$export$947dac6c72b26f81 = 'TRACK';
const $1793be513d46f473$export$f1d537d508d2945a = 'SCREEN';
const $1793be513d46f473$export$12346a674644c156 = 'OPERATIONAL';
const $1793be513d46f473$export$2ceccf177fae277c = 'analyticsBridge';

const $c1a829681d66d55a$export$8280e5c6104c5b40 = 'ui-modifications';


const $86752b64b3304f92$export$415cc1afa6445f90 = 'onInitChangeId';
const $86752b64b3304f92$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("dyTi6", function(module, exports) {

$parcel$export(module.exports, "setNotification", () => $38457038d15576f6$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $38457038d15576f6$export$caafa3945f199bc7);
const $38457038d15576f6$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $38457038d15576f6$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("gue6c", function(module, exports) {

$parcel$export(module.exports, "collectConflicts", () => $2e59d61c1a716fbe$export$a06103ec99e4e394);

var $jFHCE = parcelRequire("jFHCE");


var $gxkFa = parcelRequire("gxkFa");

const $2e59d61c1a716fbe$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $2e59d61c1a716fbe$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $4a8d3f67dd6285e8$export$f674b7a3bbd94b5)) return {
            type: (0, $acd9f5fa657c1240$export$2a3fdceaae2188d5),
            cause: (0, $acd9f5fa657c1240$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$2e59d61c1a716fbe$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $gxkFa.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $acd9f5fa657c1240$export$2a3fdceaae2188d5),
            cause: (0, $acd9f5fa657c1240$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$2e59d61c1a716fbe$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $2e59d61c1a716fbe$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $2e59d61c1a716fbe$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
parcelRegister("jFHCE", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $2yYrH = parcelRequire("2yYrH");

var $4qFnH = parcelRequire("4qFnH");

var $inlCv = parcelRequire("inlCv");

var $9Zabf = parcelRequire("9Zabf");

var $3w8z0 = parcelRequire("3w8z0");

var $lgI96 = parcelRequire("lgI96");

var $a5UJr = parcelRequire("a5UJr");
/** Used to compose bitmasks for cloning. */ var $e523af2690bc0ff7$var$CLONE_DEEP_FLAG = 1, $e523af2690bc0ff7$var$CLONE_FLAT_FLAG = 2, $e523af2690bc0ff7$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $e523af2690bc0ff7$var$omit = $lgI96(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $lylkU(paths, function(path) {
        path = $inlCv(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $9Zabf(object, $a5UJr(object), result);
    if (isDeep) result = $2yYrH(result, $e523af2690bc0ff7$var$CLONE_DEEP_FLAG | $e523af2690bc0ff7$var$CLONE_FLAT_FLAG | $e523af2690bc0ff7$var$CLONE_SYMBOLS_FLAG, $3w8z0);
    var length = paths.length;
    while(length--)$4qFnH(result, paths[length]);
    return result;
});
module.exports = $e523af2690bc0ff7$var$omit;

});
parcelRegister("4qFnH", function(module, exports) {

var $inlCv = parcelRequire("inlCv");

var $1ilzu = parcelRequire("1ilzu");

var $cbuUm = parcelRequire("cbuUm");

var $9IlW0 = parcelRequire("9IlW0");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3399b090996478d5$var$baseUnset(object, path) {
    path = $inlCv(path, object);
    object = $cbuUm(object, path);
    return object == null || delete object[$9IlW0($1ilzu(path))];
}
module.exports = $3399b090996478d5$var$baseUnset;

});
parcelRegister("cbuUm", function(module, exports) {

var $5BbSa = parcelRequire("5BbSa");

var $1FqKq = parcelRequire("1FqKq");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $8dee7cd279693843$var$parent(object, path) {
    return path.length < 2 ? object : $5BbSa(object, $1FqKq(path, 0, -1));
}
module.exports = $8dee7cd279693843$var$parent;

});


parcelRegister("3w8z0", function(module, exports) {

var $dtLJW = parcelRequire("dtLJW");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $28fb00d591f4ccb5$var$customOmitClone(value) {
    return $dtLJW(value) ? undefined : value;
}
module.exports = $28fb00d591f4ccb5$var$customOmitClone;

});

parcelRegister("lgI96", function(module, exports) {

var $aX8Tx = parcelRequire("aX8Tx");

var $cMrjq = parcelRequire("cMrjq");

var $hC3zk = parcelRequire("hC3zk");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $f7bd5604b58f6516$var$flatRest(func) {
    return $hC3zk($cMrjq(func, undefined, $aX8Tx), func + '');
}
module.exports = $f7bd5604b58f6516$var$flatRest;

});


const $acd9f5fa657c1240$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $acd9f5fa657c1240$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $acd9f5fa657c1240$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $acd9f5fa657c1240$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $acd9f5fa657c1240$export$e4ac32edd5da2ee7 = 'FIELD';
const $acd9f5fa657c1240$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("gxkFa", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $d9f102cf54492cff$export$e1cc7da28a1c4bb7);
const $d9f102cf54492cff$var$SET_NAME_METHOD = 'setName';
const $d9f102cf54492cff$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $d9f102cf54492cff$var$SET_VISIBLE_METHOD = 'setVisible';
const $d9f102cf54492cff$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $d9f102cf54492cff$var$SET_VALUE_METHOD = 'setValue';
const $d9f102cf54492cff$var$SET_REQUIRED_METHOD = 'setRequired';
const $d9f102cf54492cff$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $d9f102cf54492cff$export$8325709d137b2606 = {
    fieldName: $d9f102cf54492cff$var$SET_NAME_METHOD,
    description: $d9f102cf54492cff$var$SET_DESCRIPTION_METHOD,
    isVisible: $d9f102cf54492cff$var$SET_VISIBLE_METHOD,
    isReadOnly: $d9f102cf54492cff$var$SET_READ_ONLY_METHOD,
    value: $d9f102cf54492cff$var$SET_VALUE_METHOD,
    isRequired: $d9f102cf54492cff$var$SET_REQUIRED_METHOD,
    optionsVisibility: $d9f102cf54492cff$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $d9f102cf54492cff$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $d9f102cf54492cff$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $4a8d3f67dd6285e8$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $4a8d3f67dd6285e8$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("5ytXp", function(module, exports) {

$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $1772c0ee6d771896$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $1772c0ee6d771896$export$7d0f534e5b16dcc9);


var $fKPQA = parcelRequire("fKPQA");
const $1772c0ee6d771896$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $1772c0ee6d771896$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $1772c0ee6d771896$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $4a8d3f67dd6285e8$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $1772c0ee6d771896$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $fKPQA.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $1772c0ee6d771896$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("fKPQA", function(module, exports) {

$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $eb87a5c77a75313d$export$8a23b3e9a1749620);

const $eb87a5c77a75313d$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $4a8d3f67dd6285e8$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $eb87a5c77a75313d$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $eb87a5c77a75313d$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("9iCL6", function(module, exports) {

$parcel$export(module.exports, "setError", () => $b5856e0fc4214afc$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $b5856e0fc4214afc$export$7e5930c6217b1d4e);
const $b5856e0fc4214afc$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $b5856e0fc4214afc$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("ePF6W", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $b3bf9b191d7f1fae$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $b3bf9b191d7f1fae$export$cf768a695e83eefa);

var $gRw8I = parcelRequire("gRw8I");

var $8TRzp = parcelRequire("8TRzp");

var $50WTm = parcelRequire("50WTm");

var $9iCL6 = parcelRequire("9iCL6");
const $b3bf9b191d7f1fae$var$getTimeout = ()=>50000;
const $b3bf9b191d7f1fae$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $b3bf9b191d7f1fae$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $b3bf9b191d7f1fae$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($b3bf9b191d7f1fae$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $b3bf9b191d7f1fae$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $b3bf9b191d7f1fae$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $8TRzp.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($b3bf9b191d7f1fae$var$isFieldInitialisationComplete(status) || (0, $50WTm.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $9iCL6.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $8TRzp.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $b3bf9b191d7f1fae$var$getTimeout(),
                fieldsInitializationTime: $b3bf9b191d7f1fae$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $b3bf9b191d7f1fae$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $8TRzp.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($b3bf9b191d7f1fae$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $8TRzp.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $b3bf9b191d7f1fae$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("50WTm", function(module, exports) {

$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $e4eff3e244d1d00b$export$4cadeedb8c3f31f7);

var $4MchI = parcelRequire("4MchI");
const $e4eff3e244d1d00b$export$4cadeedb8c3f31f7 = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("gHFQk", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $a278e867a1a079df$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $a278e867a1a079df$export$4a6b4707110b0552);

var $6wnll = parcelRequire("6wnll");
const $a278e867a1a079df$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $6wnll.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $a278e867a1a079df$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $6wnll.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("6wnll", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $5f079251e27d586b$export$50806045b617d116);

var $gRw8I = parcelRequire("gRw8I");

var $cTgrm = parcelRequire("cTgrm");

var $fakav = parcelRequire("fakav");
const $5f079251e27d586b$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gRw8I.di)((0, $cTgrm.fireErrorAnalytics), (0, $fakav.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $fakav.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $cTgrm.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("cTgrm", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $94cf15b59f863b8f$export$a27c21aa3ed8f0f1);

var $juuK3 = parcelRequire("juuK3");

var $6gEe6 = parcelRequire("6gEe6");
const $94cf15b59f863b8f$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $94cf15b59f863b8f$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $6gEe6.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $juuK3.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $94cf15b59f863b8f$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("6gEe6", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $5e378eb9982fd577$export$e19f9f08a6d79fd2);

var $b5k0C = parcelRequire("b5k0C");
const $5e378eb9982fd577$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $5e378eb9982fd577$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $5e378eb9982fd577$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $5e378eb9982fd577$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $5e378eb9982fd577$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $5e378eb9982fd577$export$89a175d4190df42e = 'Invoke value functions failed:';
const $5e378eb9982fd577$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $5e378eb9982fd577$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $5e378eb9982fd577$var$BAD_REQUEST = 400;
const $5e378eb9982fd577$var$REQUEST_TIMEOUT = 408;
const $5e378eb9982fd577$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $5e378eb9982fd577$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $5e378eb9982fd577$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $5e378eb9982fd577$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($5e378eb9982fd577$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $5e378eb9982fd577$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($5e378eb9982fd577$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $5e378eb9982fd577$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $5e378eb9982fd577$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $5e378eb9982fd577$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($5e378eb9982fd577$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($5e378eb9982fd577$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $b5k0C.isClientFetchError)(error)) return $5e378eb9982fd577$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("b5k0C", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $918fba215d4cec95$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $918fba215d4cec95$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $918fba215d4cec95$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $918fba215d4cec95$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $918fba215d4cec95$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $918fba215d4cec95$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($918fba215d4cec95$export$3876cb851aa46193.includes(error.name) || $918fba215d4cec95$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($918fba215d4cec95$export$3876cb851aa46193.includes(error.cause.name) || $918fba215d4cec95$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("fakav", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $4ec698847e51bf4d$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $4ec698847e51bf4d$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $4ec698847e51bf4d$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $4ec698847e51bf4d$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $4ec698847e51bf4d$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $4ec698847e51bf4d$export$ef45e4471aa21b27);

var $cTgrm = parcelRequire("cTgrm");

var $3Zx5U = parcelRequire("3Zx5U");
const $4ec698847e51bf4d$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $4ec698847e51bf4d$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $3Zx5U.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $4ec698847e51bf4d$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $4ec698847e51bf4d$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$4ec698847e51bf4d$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $cTgrm.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $4ec698847e51bf4d$export$e4330d77fd93d1de = (viewType)=>$4ec698847e51bf4d$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $4ec698847e51bf4d$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $4ec698847e51bf4d$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $4ec698847e51bf4d$export$20eabd2b3ada6bf3(viewType) {
    return $4ec698847e51bf4d$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $4ec698847e51bf4d$export$b768d6a95f7a930(context) {
    return $4ec698847e51bf4d$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $4ec698847e51bf4d$export$b0297573c90085aa(viewType) {
    return $4ec698847e51bf4d$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $4ec698847e51bf4d$export$c0728caa743a409e(viewType) {
    return $4ec698847e51bf4d$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $4ec698847e51bf4d$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $4ec698847e51bf4d$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("3Zx5U", function(module, exports) {

$parcel$export(module.exports, "getViewConfiguration", () => $a297ce0165fba253$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $a297ce0165fba253$export$f0022a21ccd1f6be);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");
const $a297ce0165fba253$var$VIEW_CONFIGURATIONS = new Map();
const $a297ce0165fba253$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$a297ce0165fba253$var$VIEW_CONFIGURATIONS.has(viewType)) $a297ce0165fba253$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $a297ce0165fba253$export$176b6e68da08ffa2 = (viewType)=>$a297ce0165fba253$var$VIEW_CONFIGURATIONS.get(viewType);
const $a297ce0165fba253$export$e8091eff40c4f16e = ()=>{
    $a297ce0165fba253$var$VIEW_CONFIGURATIONS.clear();
};
const $a297ce0165fba253$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gRw8I.di)($a297ce0165fba253$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $eJOHy.useState)(()=>{
        $a297ce0165fba253$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("2R0pk", function(module, exports) {

$parcel$export(module.exports, "initializeNoScreenTab", () => $8e64e0bc87441f77$export$93459ad9bfd6c380);
const $8e64e0bc87441f77$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("9N3Zu", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $430f0362b1358e83$export$7f7be235f64f029b);
const $430f0362b1358e83$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("ivt8i", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $8afb65cbf3117b60$export$352dfcce04d66748);

var $9UJzd = parcelRequire("9UJzd");

var $gRw8I = parcelRequire("gRw8I");

var $fakav = parcelRequire("fakav");

var $gPb1o = parcelRequire("gPb1o");
const $8afb65cbf3117b60$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($9UJzd))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $fakav.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $gPb1o.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($9UJzd)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("9UJzd", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/** Used to generate unique IDs. */ var $737cb0a939387270$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $737cb0a939387270$var$uniqueId(prefix) {
    var id = ++$737cb0a939387270$var$idCounter;
    return $cz1WF(prefix) + id;
}
module.exports = $737cb0a939387270$var$uniqueId;

});

parcelRegister("gPb1o", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $56f16ea007c19735$export$25441a03bb8f1cb0);

var $cSmYj = parcelRequire("cSmYj");

var $6wnll = parcelRequire("6wnll");
const $56f16ea007c19735$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $6wnll.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("aH4dF", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $094c9adf47fef0eb$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $094c9adf47fef0eb$export$1ca69a85bb7273de);

var $jFHCE = parcelRequire("jFHCE");

var $jvwCK = parcelRequire("jvwCK");
const $094c9adf47fef0eb$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $094c9adf47fef0eb$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("gUC7k", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $d101320b2fc75ead$export$6556d46d2662453c);

var $gPb1o = parcelRequire("gPb1o");
const $d101320b2fc75ead$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $gPb1o.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("5HnXB", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $6daf9f125fd0302a$export$21363496760d39cd);
const $6daf9f125fd0302a$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("9yT36", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $b6815d82a47f25aa$export$cceae62fd4d1ef0a);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $8TRzp = parcelRequire("8TRzp");


var $911uM = parcelRequire("911uM");

var $eoGWQ = parcelRequire("eoGWQ");

var $lkNcT = parcelRequire("lkNcT");

var $bvx33 = parcelRequire("bvx33");

var $2bgGQ = parcelRequire("2bgGQ");

var $dDEcF = parcelRequire("dDEcF");

var $5ytXp = parcelRequire("5ytXp");

var $kPjD8 = parcelRequire("kPjD8");
const $b6815d82a47f25aa$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $5ytXp.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $eoGWQ.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $dDEcF.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $8TRzp.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $709c32cb46cc1bfc$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $709c32cb46cc1bfc$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $709c32cb46cc1bfc$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $kPjD8.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $2bgGQ.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $lkNcT.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(errorsByField)) throw new (0, $911uM.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $bvx33.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $5ytXp.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $709c32cb46cc1bfc$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $709c32cb46cc1bfc$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $709c32cb46cc1bfc$export$f5d5f6bb902f1027 = '-1';
const $709c32cb46cc1bfc$export$106087dcfd4fb129 = 100;

parcelRegister("911uM", function(module, exports) {

$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $cf3bfdbd3088e01b$export$9e8b5e552e255163);

var $6oIbr = parcelRequire("6oIbr");
class $cf3bfdbd3088e01b$export$9e8b5e552e255163 extends (0, $6oIbr.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("6oIbr", function(module, exports) {

$parcel$export(module.exports, "UiModificationsValidationError", () => $4710661e637b576b$export$6e8165c81a6a65df);
class $4710661e637b576b$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("eoGWQ", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegistered", () => $24c4e184a93b40af$export$fbe9157c12cb4e7b);
const $24c4e184a93b40af$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("lkNcT", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $41fb924301283d76$export$460820f27643954e);

var $fakav = parcelRequire("fakav");
const $41fb924301283d76$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $fakav.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("bvx33", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $137a5af6aef2a5ba$export$e1fce51bc5be90b7);
const $137a5af6aef2a5ba$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("2bgGQ", function(module, exports) {

$parcel$export(module.exports, "transformFieldToIframe", () => $91f789d15f0a1905$export$aa453854f74fab);

var $cTgrm = parcelRequire("cTgrm");

var $fakav = parcelRequire("fakav");
const $91f789d15f0a1905$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $fakav.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cTgrm.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cTgrm.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("kPjD8", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $f803ba63040b2269$export$d14f85c01e334a1);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $dYmwL = parcelRequire("dYmwL");

var $fakav = parcelRequire("fakav");


var $gxkFa = parcelRequire("gxkFa");

var $8yXDc = parcelRequire("8yXDc");

var $ir1dW = parcelRequire("ir1dW");
const $f803ba63040b2269$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gRw8I.di)((0, $fakav.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $fakav.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $8yXDc.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $8yXDc.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $dYmwL.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $acd9f5fa657c1240$export$d1996cb46a690190),
                        method: (0, $gxkFa.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $ir1dW.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $ir1dW.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("dYmwL", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $3ef3a444e676453d$export$73c2f0689b6c4a5a);
class $3ef3a444e676453d$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("8yXDc", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $e48b2d14e35e2228$export$ee79e3ab53b8db79);
const $e48b2d14e35e2228$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("ir1dW", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $cd97d85dd7c5393e$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $cd97d85dd7c5393e$export$ddd005554aecd409);
const $cd97d85dd7c5393e$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $cd97d85dd7c5393e$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("chqNi", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $9f64d6fbd8ee4d18$export$131c67fd312b8a11);

var $gRw8I = parcelRequire("gRw8I");

var $bhqSd = parcelRequire("bhqSd");

var $MruMr = parcelRequire("MruMr");

var $5ytXp = parcelRequire("5ytXp");

var $dBy9R = parcelRequire("dBy9R");
const $9f64d6fbd8ee4d18$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gRw8I.di)((0, $5ytXp.collectScreenTabsAppliedChangesHistory), (0, $dBy9R.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $dBy9R.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $dBy9R.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $5ytXp.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $bhqSd.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $dBy9R.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $MruMr.toScreenTabsValidationError))
        });
    };

});
parcelRegister("bhqSd", function(module, exports) {

$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $f8f7d5a046bfc8f1$export$faf1f1824ee0a136);

var $6oIbr = parcelRequire("6oIbr");
class $f8f7d5a046bfc8f1$export$faf1f1824ee0a136 extends (0, $6oIbr.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("MruMr", function(module, exports) {

$parcel$export(module.exports, "toScreenTabsValidationError", () => $ea00ce4de97b5f73$export$b2675440ade984fb);

const $ea00ce4de97b5f73$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $acd9f5fa657c1240$export$fd26696d109785a0)
    });

});

parcelRegister("dBy9R", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $f31484b83f1ee52f$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $f31484b83f1ee52f$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $f31484b83f1ee52f$export$62d63af83dac7315);
const $f31484b83f1ee52f$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $f31484b83f1ee52f$var$isValidScreenTabId = (internalScreenTabs, id)=>$f31484b83f1ee52f$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $f31484b83f1ee52f$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $f31484b83f1ee52f$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $f31484b83f1ee52f$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$f31484b83f1ee52f$var$isValidScreenTabId(internalScreenTabs, id) && $f31484b83f1ee52f$var$isValidScreenTabIsVisible(isVisible) && $f31484b83f1ee52f$var$isValidScreenTabIsActive(isActive);
const $f31484b83f1ee52f$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($f31484b83f1ee52f$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $f31484b83f1ee52f$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($f31484b83f1ee52f$var$isValidScreenTabIsActive(isActive) && isActive && $f31484b83f1ee52f$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $f31484b83f1ee52f$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $f31484b83f1ee52f$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$f31484b83f1ee52f$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($f31484b83f1ee52f$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($f31484b83f1ee52f$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $f31484b83f1ee52f$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if (screenTabsFromApp.reduce($f31484b83f1ee52f$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($f31484b83f1ee52f$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("cs58I", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesValue", () => $22623340bdbf14f6$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $22623340bdbf14f6$export$eefe4b2985e8203e);

var $eJOHy = parcelRequire("eJOHy");

var $jkWf0 = parcelRequire("jkWf0");

var $etbP7 = parcelRequire("etbP7");
const $22623340bdbf14f6$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $jkWf0.useUserPreferencesStoreValue)(userPreferenceKey);
    /**
	 * persist: boolean - if true, save the value to the server ,else just update the local state and return a promise with the new value
	 */ const setValue = (0, $eJOHy.useCallback)((newValue, persist = true)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        if (!persist) return Promise.resolve(newValue);
        return (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, newValue);
    }, [
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $eJOHy.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
    }, [
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    const setUserPreferences = (0, $eJOHy.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue
        }), [
        setValue,
        deleteValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $22623340bdbf14f6$export$eefe4b2985e8203e = ()=>{
    const [, actions] = (0, $jkWf0.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $eJOHy.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("jkWf0", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $97758271cd46a4b8$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $97758271cd46a4b8$export$4d156074562bac9a);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $i64h0 = parcelRequire("i64h0");
const $97758271cd46a4b8$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $i64h0.actions
});
const $97758271cd46a4b8$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $97758271cd46a4b8$export$46e7eeb2fc34fab8 = (0, $iJq0l.createHook)($97758271cd46a4b8$export$6f57813fe9f31bf9, {
    selector: $97758271cd46a4b8$var$getUserPreference
});
const $97758271cd46a4b8$export$4d156074562bac9a = (0, $iJq0l.createHook)($97758271cd46a4b8$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("i64h0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $343d470acbc8bd87$export$e324594224ef24da);
const $343d470acbc8bd87$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $343d470acbc8bd87$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $343d470acbc8bd87$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $343d470acbc8bd87$export$df0a4f67b9888111 = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $343d470acbc8bd87$export$e324594224ef24da = {
    setUserPreferenceValue: $343d470acbc8bd87$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $343d470acbc8bd87$var$deleteUserPreferenceValue,
    setUserPreferences: $343d470acbc8bd87$var$setUserPreferences,
    getUserPreferenceValue: $343d470acbc8bd87$export$df0a4f67b9888111
};

});


parcelRegister("etbP7", function(module, exports) {

$parcel$export(module.exports, "saveUserPreferenceValue", () => $a9cf1c440643deff$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $a9cf1c440643deff$export$a60a810760d07867);

var $keOPi = parcelRequire("keOPi");
const $a9cf1c440643deff$export$bebe1b9e9f4cbf16 = async (userPreferenceKey, value)=>(0, $keOPi.performIssuePutRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    }, 'user-preferences-services/src/utils');
const $a9cf1c440643deff$export$a60a810760d07867 = async (userPreferenceKey)=>(0, $keOPi.performIssueDeleteRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, undefined, 'user-preferences-services/src/utils');

});
parcelRegister("keOPi", function(module, exports) {

$parcel$export(module.exports, "performIssuePostRequest", () => $1d9dfe6a518cff33$export$f0d7c3d034d5811a);
$parcel$export(module.exports, "performIssuePutRequest", () => $1d9dfe6a518cff33$export$2167f099a5e216f1);
$parcel$export(module.exports, "performIssueDeleteRequest", () => $1d9dfe6a518cff33$export$cf3e603eb3bc78ab);
$parcel$export(module.exports, "performIssueGetRequest", () => $1d9dfe6a518cff33$export$36671e08961872af);

var $jGzN3 = parcelRequire("jGzN3");

var $7jTnu = parcelRequire("7jTnu");

var $biGll = parcelRequire("biGll");
const $1d9dfe6a518cff33$export$f0d7c3d034d5811a = async (url, options = {}, path)=>{
    if ((0, $7jTnu.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $jGzN3.performPostRequest), url, options, path);
    return (0, $jGzN3.performPostRequest)(url, options);
};
const $1d9dfe6a518cff33$export$2167f099a5e216f1 = async (url, options = {}, path)=>{
    if ((0, $7jTnu.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $jGzN3.performPutRequest), url, options, path);
    return (0, $jGzN3.performPutRequest)(url, options);
};
const $1d9dfe6a518cff33$export$cf3e603eb3bc78ab = async (url, options = {}, path)=>{
    if ((0, $7jTnu.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $jGzN3.performDeleteRequest), url, options, path);
    return (0, $jGzN3.performDeleteRequest)(url, options);
};
const $1d9dfe6a518cff33$export$36671e08961872af = async (url, options = {}, path)=>{
    if ((0, $7jTnu.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $jGzN3.performGetRequest), url, options, path);
    return (0, $jGzN3.performGetRequest)(url, options);
};

});
parcelRegister("biGll", function(module, exports) {

$parcel$export(module.exports, "performIssueRequest", () => $00dfaa7a2eaf401f$export$2fba6590b0f30cb2);

var $3ibpe = parcelRequire("3ibpe");

var $1uIew = parcelRequire("1uIew");
const $00dfaa7a2eaf401f$var$isGiraUrl = (url)=>url.startsWith('/rest/gira/1/');
const $00dfaa7a2eaf401f$export$2fba6590b0f30cb2 = async (requestFn, url, options = {}, path = 'unknown')=>{
    const defaultExperienceDescription = {
        experience: $00dfaa7a2eaf401f$var$isGiraUrl(url) ? 'issueGira' : 'issueRest',
        analyticsSource: $00dfaa7a2eaf401f$var$isGiraUrl(url) ? 'issue-gira' : 'issue-rest',
        application: null,
        edition: null
    };
    try {
        const response = await requestFn(url, options);
        (0, $3ibpe.sendExperienceAnalytics)({
            ...defaultExperienceDescription,
            action: 'taskSuccess',
            additionalAttributes: {
                path: path
            }
        });
        return response;
    } catch (error) {
        let traceId;
        let statusCode;
        let errorMessage;
        if (error instanceof Error || error instanceof (0, $1uIew.default) || error instanceof (0, $1uIew.ValidationError) || error instanceof TypeError) errorMessage = error.message;
        if (error instanceof (0, $1uIew.default) || error instanceof (0, $1uIew.ValidationError)) {
            traceId = error.traceId;
            statusCode = error.statusCode;
        }
        const additionalAttributes = {
            statusCode: statusCode || 0,
            errorMessage: errorMessage || 'unknown',
            traceId: traceId || 'unknown',
            path: path
        };
        if (statusCode && statusCode >= 400 && statusCode < 500 || error instanceof Error && error.cause instanceof TypeError) {
            (0, $3ibpe.sendExperienceAnalytics)({
                ...defaultExperienceDescription,
                action: 'taskAbort',
                additionalAttributes: additionalAttributes
            });
            throw error;
        }
        (0, $3ibpe.sendExperienceAnalytics)({
            ...defaultExperienceDescription,
            action: 'taskFail',
            additionalAttributes: additionalAttributes
        });
        throw error;
    }
};

});




parcelRegister("bmoS1", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $7e10397d24adf8a0$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $7e10397d24adf8a0$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $7e10397d24adf8a0$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $7e10397d24adf8a0$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $7e10397d24adf8a0$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $7e10397d24adf8a0$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $7e10397d24adf8a0$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $7e10397d24adf8a0$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $7e10397d24adf8a0$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $7e10397d24adf8a0$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $7e10397d24adf8a0$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $7e10397d24adf8a0$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $7e10397d24adf8a0$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $7e10397d24adf8a0$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $7e10397d24adf8a0$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useBoardId", () => $7e10397d24adf8a0$export$b49754504c41149f);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $7e10397d24adf8a0$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $7e10397d24adf8a0$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $7e10397d24adf8a0$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $7e10397d24adf8a0$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $7e10397d24adf8a0$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $7e10397d24adf8a0$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiEnabledForIssue", () => $7e10397d24adf8a0$export$db5174c7538abe4b);
$parcel$export(module.exports, "useIsJiraIssue", () => $7e10397d24adf8a0$export$cf5fc815f761fb4b);

var $eJOHy = parcelRequire("eJOHy");


var $ln6Iy = parcelRequire("ln6Iy");

var $aYncF = parcelRequire("aYncF");

var $bNexr = parcelRequire("bNexr");

var $ljej9 = parcelRequire("ljej9");

var $hmtVp = parcelRequire("hmtVp");

var $8wUZn = parcelRequire("8wUZn");

var $b9nqM = parcelRequire("b9nqM");

var $U4tkh = parcelRequire("U4tkh");
const $7e10397d24adf8a0$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $U4tkh.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $7e10397d24adf8a0$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $U4tkh.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $7e10397d24adf8a0$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $7e10397d24adf8a0$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $7e10397d24adf8a0$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $U4tkh.useIssueContextStoreIsModal)();
    return isModal;
};
const $7e10397d24adf8a0$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $U4tkh.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $7e10397d24adf8a0$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $U4tkh.useIssueContextStoreIssueId)();
    return issueId;
};
const $7e10397d24adf8a0$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $U4tkh.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $7e10397d24adf8a0$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $U4tkh.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $7e10397d24adf8a0$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $U4tkh.useIssueContextStoreIssueKey)();
    return (0, $ljej9.toProjectKey)(issueKey.split('-')[0]);
};
const $7e10397d24adf8a0$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $U4tkh.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $7e10397d24adf8a0$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $U4tkh.useIssueContextStoreActions)() || [
        null,
        {}
    ];
    const actions = (0, $eJOHy.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $7e10397d24adf8a0$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $U4tkh.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $7e10397d24adf8a0$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $U4tkh.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $7e10397d24adf8a0$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $U4tkh.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $7e10397d24adf8a0$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $U4tkh.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $7e10397d24adf8a0$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $U4tkh.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $7e10397d24adf8a0$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $U4tkh.useIssueContextStoreViewMode)();
    return viewMode;
};
const $7e10397d24adf8a0$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $U4tkh.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $7e10397d24adf8a0$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $U4tkh.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $7e10397d24adf8a0$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $U4tkh.useIssueContextStoreBoardId)();
    return boardId;
};
const $7e10397d24adf8a0$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $U4tkh.useIssueContextStoreBoardType)();
    return boardType;
};
const $7e10397d24adf8a0$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $U4tkh.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $7e10397d24adf8a0$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $U4tkh.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $7e10397d24adf8a0$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $U4tkh.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $7e10397d24adf8a0$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $U4tkh.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $7e10397d24adf8a0$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $U4tkh.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $7e10397d24adf8a0$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const licenseStates = (0, $8wUZn.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $hmtVp.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $7e10397d24adf8a0$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $7e10397d24adf8a0$export$aad3917152559b87();
    return analyticsSource === (0, $d851676a1c983028$export$b19f949fb9713614);
};
const $7e10397d24adf8a0$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $7e10397d24adf8a0$export$aad3917152559b87();
    return analyticsSource === (0, $d851676a1c983028$export$a5132300c5214280);
};
const $7e10397d24adf8a0$export$db5174c7538abe4b = ()=>{
    const [isAiEnabledForIssue] = (0, $U4tkh.useIssueContextIsAiEnabledForIssue)();
    return isAiEnabledForIssue;
};
const $7e10397d24adf8a0$export$cf5fc815f761fb4b = ()=>{
    const issueKey = $7e10397d24adf8a0$export$22108eca27445997();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    return [
        (0, $ln6Iy.SOFTWARE_PROJECT),
        (0, $ln6Iy.CORE_PROJECT)
    ].some((type)=>type === projectType);
};

});
const $d851676a1c983028$export$53d41ff2666118e1 = 'agility-backlog';
const $d851676a1c983028$export$7552fe2669628499 = 'bitbucket-issue';
const $d851676a1c983028$export$41a718da0a8636f4 = 'connect-issue';
const $d851676a1c983028$export$cebf0bc8b2ccaf57 = 'core-issue';
const $d851676a1c983028$export$5e91e17726e54450 = 'jiraCalendar';
const $d851676a1c983028$export$2dac1950892123f5 = 'jiraTimeline';
const $d851676a1c983028$export$82540942fb014b0a = 'business-calendar';
const $d851676a1c983028$export$7ca28938a07e0c33 = 'business-list';
const $d851676a1c983028$export$f6cf06aaaeb58a54 = 'business-timeline';
const $d851676a1c983028$export$b2c0462ff17aa26e = 'business-board';
const $d851676a1c983028$export$a607850ebccd28ac = 'business-approvals';
const $d851676a1c983028$export$1da6cede3561048f = 'business-files';
const $d851676a1c983028$export$b19f949fb9713614 = 'full-issue';
const $d851676a1c983028$export$a5132300c5214280 = 'embed-issue';
const $d851676a1c983028$export$710114090a811b37 = 'global-issue-navigator-issue';
const $d851676a1c983028$export$ce88447986394f2d = 'mobile-issue';
const $d851676a1c983028$export$6a90d9196d330040 = 'project-issue-navigator';
const $d851676a1c983028$export$2247c9059c171db1 = 'roadmap-issue';
const $d851676a1c983028$export$cd16d39c55c569d0 = 'simple-software-board';
const $d851676a1c983028$export$f72626bf0d75dfad = 'software-backlog-issue';
const $d851676a1c983028$export$778b4609e784cb27 = 'software-deployments-issue';
const $d851676a1c983028$export$5b73d694a6048002 = 'version-detail-issue';
const $d851676a1c983028$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $d851676a1c983028$export$21b5b7189add7861 = 'software-incidents-issue';
const $d851676a1c983028$export$9c5d81b901471b27 = 'software-issue';
const $d851676a1c983028$export$1735f6ad917dc411 = 'change-calendar';
const $d851676a1c983028$export$7063ee6d0035a982 = 'queues-issue-view';
const $d851676a1c983028$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $d851676a1c983028$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $d851676a1c983028$export$14a8072f422804fd = 'issue-navigator-next';
const $d851676a1c983028$export$cd2e8394c029507b = 'issue-navigator-detail-view';
const $d851676a1c983028$export$5f3c20fe2ff6c0a2 = 'staffing-issue';
const $d851676a1c983028$export$9dac02c804d7acd8 = 'classic-software-board';

parcelRegister("bNexr", function(module, exports) {

$parcel$export(module.exports, "useProjectKey", () => $394a54b0d708bbf0$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $394a54b0d708bbf0$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $394a54b0d708bbf0$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectContext", () => $394a54b0d708bbf0$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $394a54b0d708bbf0$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $394a54b0d708bbf0$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $394a54b0d708bbf0$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $394a54b0d708bbf0$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $394a54b0d708bbf0$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $394a54b0d708bbf0$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $394a54b0d708bbf0$export$af19ad68b52fa1a6);
$parcel$export(module.exports, "useProjectIssueTypes", () => $394a54b0d708bbf0$export$80bef597b440cf71);

var $eJOHy = parcelRequire("eJOHy");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");

var $bRJAs = parcelRequire("bRJAs");

var $a9ldn = parcelRequire("a9ldn");

var $ljej9 = parcelRequire("ljej9");

var $lvKO5 = parcelRequire("lvKO5");

var $b8rQb = parcelRequire("b8rQb");

var $aAqmd = parcelRequire("aAqmd");
const $394a54b0d708bbf0$export$f87be37f8e8be65 = (issueKey)=>(0, $ljej9.toProjectKey)(issueKey.split('-')[0]);
const $394a54b0d708bbf0$export$bd73624ca941f105 = ()=>{
    const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $b8rQb.useProjectContextActionStore)();
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        }), [
        setProjectContext,
        mergeProjectProperty
    ]);
    return [
        null,
        actions
    ];
};
const $394a54b0d708bbf0$export$6de29d851c914935 = (projectKey)=>{
    const [projectType] = (0, $b8rQb.useProjectContextProjectTypeStore)({
        projectKey: projectKey
    });
    return projectType;
};
const $394a54b0d708bbf0$export$27e24febf0f5c3bc = (projectKey)=>{
    const [projectStyle] = (0, $b8rQb.useProjectContextJiraProjectStyleStore)({
        projectKey: projectKey
    });
    return projectStyle;
};
const $394a54b0d708bbf0$export$8f31c2503e1efa93 = (projectKey)=>{
    const [projectContext] = (0, $b8rQb.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext;
};
const $394a54b0d708bbf0$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
    const projectType = $394a54b0d708bbf0$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if (failSafely) return undefined;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    return (0, $bRJAs.getApplicationForProject)(projectType);
};
const $394a54b0d708bbf0$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
    const { appEditions: appEditions } = (0, $lvKO5.useTenantContext)();
    const application = $394a54b0d708bbf0$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return undefined;
    return (0, $a9ldn.getEdition)(application, appEditions);
};
const $394a54b0d708bbf0$export$524ef4f6102ed540 = (projectKey)=>{
    const [projectContext] = (0, $b8rQb.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.isSimplified || false;
};
const $394a54b0d708bbf0$export$e2cf96f40a8867ce = (projectKey)=>{
    const [projectContext] = (0, $b8rQb.useProjectContextStore)({
        projectKey: projectKey
    });
    return !projectContext?.isSimplified;
};
const $394a54b0d708bbf0$export$16d1475ed6c26568 = (projectKey)=>{
    const [projectContext] = (0, $b8rQb.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectId;
};
const $394a54b0d708bbf0$export$30f16f2782a4113b = (projectKey)=>{
    const [projectContext] = (0, $b8rQb.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectStatus;
};
const $394a54b0d708bbf0$export$af19ad68b52fa1a6 = (projectKey)=>{
    const projectType = $394a54b0d708bbf0$export$6de29d851c914935(projectKey);
    const isSimplified = $394a54b0d708bbf0$export$524ef4f6102ed540(projectKey);
    return (0, $fAZgY.useMemoWithCondition)(()=>(0, $aAqmd.getIssueConfiguration)({
            isSimplified: isSimplified,
            projectType: projectType
        }), [
        isSimplified,
        projectType
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $394a54b0d708bbf0$export$654dd2c557853fbe = (projectKey)=>{
    const [projectName] = (0, $b8rQb.useProjectContextProjectNameStore)({
        projectKey: projectKey
    });
    return projectName;
};
const $394a54b0d708bbf0$export$80bef597b440cf71 = (projectKey)=>{
    const [issueTypes] = (0, $b8rQb.useProjectContextIssueTypesStore)({
        projectKey: projectKey
    });
    return issueTypes;
};

});
parcelRegister("b8rQb", function(module, exports) {

$parcel$export(module.exports, "useProjectContextActionStore", () => $9f277dbc5eafd530$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $9f277dbc5eafd530$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $9f277dbc5eafd530$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextJiraProjectStyleStore", () => $9f277dbc5eafd530$export$b291cf203d6481a4);
$parcel$export(module.exports, "useProjectContextProjectNameStore", () => $9f277dbc5eafd530$export$9469fde70658518);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $9f277dbc5eafd530$export$f73e9904779f6be5);

var $ln6Iy = parcelRequire("ln6Iy");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $6KYi0 = parcelRequire("6KYi0");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9f277dbc5eafd530$var$initialState = {};
const $9f277dbc5eafd530$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'project-context',
    initialState: $9f277dbc5eafd530$var$initialState,
    actions: $6KYi0
});
const $9f277dbc5eafd530$export$9afb89c1fe103bbe = (0, $iJq0l.createHook)($9f277dbc5eafd530$export$6f57813fe9f31bf9, {
    selector: null
});
const $9f277dbc5eafd530$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $9f277dbc5eafd530$export$8b09478b33186ec = (0, $iJq0l.createHook)($9f277dbc5eafd530$export$6f57813fe9f31bf9, {
    selector: $9f277dbc5eafd530$var$getProjectContext
});
const $9f277dbc5eafd530$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $9f277dbc5eafd530$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $9f277dbc5eafd530$var$getJiraProjectStyle = (state, { projectKey: projectKey })=>{
    const projectContext = $9f277dbc5eafd530$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.isSimplified ? (0, $ln6Iy.TEAM_MANAGED_PROJECT) : (0, $ln6Iy.COMPANY_MANAGED_PROJECT);
};
const $9f277dbc5eafd530$export$f2e1ed3b2b4707cb = (0, $iJq0l.createHook)($9f277dbc5eafd530$export$6f57813fe9f31bf9, {
    selector: $9f277dbc5eafd530$var$getProjectType
});
const $9f277dbc5eafd530$export$b291cf203d6481a4 = (0, $iJq0l.createHook)($9f277dbc5eafd530$export$6f57813fe9f31bf9, {
    selector: $9f277dbc5eafd530$var$getJiraProjectStyle
});
const $9f277dbc5eafd530$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $9f277dbc5eafd530$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $9f277dbc5eafd530$export$9469fde70658518 = (0, $iJq0l.createHook)($9f277dbc5eafd530$export$6f57813fe9f31bf9, {
    selector: $9f277dbc5eafd530$var$getProjectName
});
const $9f277dbc5eafd530$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $9f277dbc5eafd530$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $9f277dbc5eafd530$export$f73e9904779f6be5 = (0, $iJq0l.createHook)($9f277dbc5eafd530$export$6f57813fe9f31bf9, {
    selector: $9f277dbc5eafd530$var$getIssueTypes
});

});
parcelRegister("6KYi0", function(module, exports) {

$parcel$export(module.exports, "setProjectContext", () => $da8fc507538f01dc$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $da8fc507538f01dc$export$78f1c6052937615f);
const $da8fc507538f01dc$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $da8fc507538f01dc$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("aAqmd", function(module, exports) {

$parcel$export(module.exports, "getIssueConfiguration", () => $260acdbd5c3f4032$export$902f6c5cc939598a);

var $kkiRT = parcelRequire("kkiRT");

var $ln6Iy = parcelRequire("ln6Iy");
const $260acdbd5c3f4032$export$cdbd1eb3b05729e0 = 'flagActions';
const $260acdbd5c3f4032$export$c161a774ec2e7e56 = 'cardCoverActions';
const $260acdbd5c3f4032$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $260acdbd5c3f4032$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $kkiRT.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $260acdbd5c3f4032$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $kkiRT.default).SOFTWARE_ISSUE,
        issueActions: [
            $260acdbd5c3f4032$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $260acdbd5c3f4032$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $kkiRT.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $260acdbd5c3f4032$export$cdbd1eb3b05729e0,
            $260acdbd5c3f4032$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $260acdbd5c3f4032$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $kkiRT.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $260acdbd5c3f4032$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $260acdbd5c3f4032$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $kkiRT.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $260acdbd5c3f4032$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $kkiRT.default).MOBILE_ISSUE,
        issueActions: []
    });
const $260acdbd5c3f4032$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $kkiRT.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $260acdbd5c3f4032$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            if (config.isSimplified) return $260acdbd5c3f4032$export$aebf676dfa727a1c();
            return $260acdbd5c3f4032$export$27e0678365e5dcff();
        case 0, $ln6Iy.CORE_PROJECT:
            return $260acdbd5c3f4032$export$381ce08838c53afa();
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return $260acdbd5c3f4032$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $260acdbd5c3f4032$export$27e0678365e5dcff();
    }
    return $260acdbd5c3f4032$export$27e0678365e5dcff();
};

});
parcelRegister("kkiRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $005a3792ecb89923$export$2e2bcd8739ae039);
const $005a3792ecb89923$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $005a3792ecb89923$export$2e2bcd8739ae039 = $005a3792ecb89923$var$keys;

});



parcelRegister("8wUZn", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $aad4eaa422fd4f11$export$268651a63abe408a);

var $lvKO5 = parcelRequire("lvKO5");
const $aad4eaa422fd4f11$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("b9nqM", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $e7b633a490276fcc$export$54d534cc91e54850);

var $lvKO5 = parcelRequire("lvKO5");
const $e7b633a490276fcc$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("U4tkh", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStore", () => $37a5d4913156d800$export$f6e0a3ee03299fbc);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $37a5d4913156d800$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $37a5d4913156d800$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $37a5d4913156d800$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $37a5d4913156d800$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $37a5d4913156d800$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $37a5d4913156d800$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $37a5d4913156d800$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $37a5d4913156d800$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $37a5d4913156d800$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $37a5d4913156d800$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $37a5d4913156d800$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $37a5d4913156d800$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $37a5d4913156d800$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $37a5d4913156d800$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $37a5d4913156d800$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $37a5d4913156d800$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $37a5d4913156d800$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $37a5d4913156d800$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $37a5d4913156d800$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $37a5d4913156d800$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $37a5d4913156d800$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $37a5d4913156d800$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $37a5d4913156d800$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiEnabledForIssue", () => $37a5d4913156d800$export$455ae7fd9d68b157);
$parcel$export(module.exports, "useIssueTypeName", () => $37a5d4913156d800$export$ec3ac562fe41f8db);
$parcel$export(module.exports, "useIssueHierarchyLevel", () => $37a5d4913156d800$export$c998d5da56eeedf0);
$parcel$export(module.exports, "IssueContextContainer", () => $37a5d4913156d800$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $37a5d4913156d800$export$965360ae27fcae98);

var $ljej9 = parcelRequire("ljej9");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $9CRRg = parcelRequire("9CRRg");

var $2ZenB = parcelRequire("2ZenB");

var $c5gcy = parcelRequire("c5gcy");
const $37a5d4913156d800$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $ljej9.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $c5gcy.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false,
    isAiEnabledForIssue: false,
    issueHierarchyLevel: undefined,
    issueType: undefined
};
const $37a5d4913156d800$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-context',
    initialState: $37a5d4913156d800$export$d4c72bab9d6cc13a,
    actions: $9CRRg.actions
});
const $37a5d4913156d800$var$getIssueContext = (state)=>state;
const $37a5d4913156d800$var$getIsModal = (state)=>state.isModal;
const $37a5d4913156d800$var$getIssueKey = (state)=>state.issueKey;
const $37a5d4913156d800$var$getIsArchived = (state)=>state.isArchived;
const $37a5d4913156d800$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $37a5d4913156d800$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $37a5d4913156d800$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $37a5d4913156d800$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $37a5d4913156d800$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $37a5d4913156d800$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $37a5d4913156d800$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $37a5d4913156d800$var$getIsLoading = (state)=>state.isLoading;
const $37a5d4913156d800$var$getViewMode = (state)=>state.viewMode;
const $37a5d4913156d800$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $37a5d4913156d800$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $37a5d4913156d800$var$getBoardId = (state)=>state.boardId;
const $37a5d4913156d800$var$getBoardType = (state)=>state.boardType;
const $37a5d4913156d800$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $37a5d4913156d800$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $37a5d4913156d800$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $37a5d4913156d800$var$getRapidViewId = (state)=>state.rapidViewId;
const $37a5d4913156d800$var$getViewScreenId = (state)=>state.viewScreenId;
const $37a5d4913156d800$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $37a5d4913156d800$var$getisAiEnabledForIssue = (state)=>Boolean(state.isAiEnabledForIssue);
const $37a5d4913156d800$var$getIssueTypeName = (state)=>state.issueType;
const $37a5d4913156d800$var$getIssueHierarchyLevel = (state)=>state.issueHierarchyLevel;
const $37a5d4913156d800$export$f6e0a3ee03299fbc = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueContext
});
const $37a5d4913156d800$export$abdbea56d86b4aac = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: (0, $2ZenB.getChildIssuesLimit)
});
const $37a5d4913156d800$export$326ff2b963d51c5c = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: (0, $2ZenB.getChildIssuesIssueLimitUrls)
});
const $37a5d4913156d800$export$44bcaaabb74e402b = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueKey
});
const $37a5d4913156d800$export$332dcee0cf9f4e45 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueId
});
const $37a5d4913156d800$export$c940355b1fc6e1c4 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsArchived
});
const $37a5d4913156d800$export$b9eebaa1da421997 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsClassifyEditEnabled
});
const $37a5d4913156d800$export$daa47fd600e43a32 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsModal
});
const $37a5d4913156d800$export$ba2e9546ab5ba6f = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getViewScreenId
});
const $37a5d4913156d800$export$74d38d6c437efc1b = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getAnalyticsSource
});
const $37a5d4913156d800$export$2092528ee170d9e7 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getRapidViewMap
});
const $37a5d4913156d800$export$57898374e6239a5a = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getMaxTokenLength
});
const $37a5d4913156d800$export$ff0264ec4c015dc1 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsLoadedWithPage
});
const $37a5d4913156d800$export$6c8b81f6dca8c23d = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getEstimationStatistic
});
const $37a5d4913156d800$export$fe7085456138f0fc = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsLoading
});
const $37a5d4913156d800$export$c339e36468c12443 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getViewMode
});
const $37a5d4913156d800$export$ef3bfa2642bb98cd = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getBackButtonUrl
});
const $37a5d4913156d800$export$8accd063c74cd455 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueNavigatorData
});
const $37a5d4913156d800$export$e7edffc2a20027e7 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getBoardId
});
const $37a5d4913156d800$export$48aaa3a6bc2085d7 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getBoardType
});
const $37a5d4913156d800$export$4a4b96bcf5166327 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsSpaEnabled
});
const $37a5d4913156d800$export$bbd8ba0180545556 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getLoginRedirectUrl
});
const $37a5d4913156d800$export$aaa89627762c7d00 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getOnIssueKeyChange
});
const $37a5d4913156d800$export$796589b0ec52848a = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getRapidViewId
});
const $37a5d4913156d800$export$7e70ee570119a0a7 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsAiOptInEnabled
});
const $37a5d4913156d800$export$455ae7fd9d68b157 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getisAiEnabledForIssue
});
const $37a5d4913156d800$export$ec3ac562fe41f8db = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueTypeName
});
const $37a5d4913156d800$export$c998d5da56eeedf0 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueHierarchyLevel
});
const $37a5d4913156d800$export$93db6a8f3342dddf = (0, $6E16M.createContainer)($37a5d4913156d800$export$6f57813fe9f31bf9);
const $37a5d4913156d800$export$965360ae27fcae98 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("9CRRg", function(module, exports) {

$parcel$export(module.exports, "actions", () => $37cf6cc1d4339972$export$e324594224ef24da);

var $axSQB = parcelRequire("axSQB");

var $2ZenB = parcelRequire("2ZenB");

var $c5gcy = parcelRequire("c5gcy");
const $37cf6cc1d4339972$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        const currentState = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || currentState.viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || currentState.viewMode
        });
    };
const $37cf6cc1d4339972$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $37cf6cc1d4339972$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $2ZenB.getChildIssuesLimit)(getState());
const $37cf6cc1d4339972$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $37cf6cc1d4339972$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $37cf6cc1d4339972$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $37cf6cc1d4339972$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $37cf6cc1d4339972$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $37cf6cc1d4339972$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $37cf6cc1d4339972$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $axSQB.localStorage).set((0, $axSQB.VIEW_MODE_STORAGE_KEY), 'MODAL');
        setState({
            viewMode: 'MODAL'
        });
    };
const $37cf6cc1d4339972$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $axSQB.localStorage).set((0, $axSQB.VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
        setState({
            viewMode: 'SIDEBAR'
        });
    };
const $37cf6cc1d4339972$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $c5gcy.getViewModeFromLocalStorage)()
        });
    };
/**
 * a special action to "sync" stores
 * @deprecated internal use only
 */ const $37cf6cc1d4339972$var$internalSyncStore = (issueContext)=>({ setState: setState })=>{
        setState(issueContext);
    };
const $37cf6cc1d4339972$export$e324594224ef24da = {
    internalSyncStore: $37cf6cc1d4339972$var$internalSyncStore,
    setIssueContext: $37cf6cc1d4339972$export$784a03c4b74da53e,
    mergeIssueContext: $37cf6cc1d4339972$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $37cf6cc1d4339972$export$89b6937a83edcaa6,
    getMaxTokenLength: $37cf6cc1d4339972$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $37cf6cc1d4339972$export$2fe981b90be13483,
    getBackButtonUrl: $37cf6cc1d4339972$export$afce556782490aae,
    getIsSpaEnabled: $37cf6cc1d4339972$export$711dfa096bf81f2d,
    getIssueKey: $37cf6cc1d4339972$export$4a030f6192bebe03,
    getIsArchived: $37cf6cc1d4339972$export$b41341ac6c74ca6,
    setDetailViewAsModal: $37cf6cc1d4339972$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $37cf6cc1d4339972$export$b303af51de56a0e,
    resetDetailView: $37cf6cc1d4339972$export$75007d125f198b78
};

});
parcelRegister("axSQB", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $13b297323309c4b3$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $13b297323309c4b3$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $13b297323309c4b3$export$a13f7f627010bccd);

var $dnU6V = parcelRequire("dnU6V");
const $13b297323309c4b3$export$25a759e49d5049db = 'issue.issue-context-service';
const $13b297323309c4b3$export$c2ed3351cac403d1 = (0, $dnU6V.createLocalStorageProvider)('jira_issue_view');
const $13b297323309c4b3$export$a13f7f627010bccd = 'view-mode';

});

parcelRegister("2ZenB", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $f915ff48c2d8f087$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $f915ff48c2d8f087$export$8f43520910e8128c);

var $eSnSE = parcelRequire("eSnSE");

var $axSQB = parcelRequire("axSQB");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $f915ff48c2d8f087$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $f915ff48c2d8f087$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData(`${(0, $axSQB.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $f915ff48c2d8f087$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $f915ff48c2d8f087$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $f915ff48c2d8f087$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $f915ff48c2d8f087$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

parcelRegister("c5gcy", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $44ce6f363203119e$export$cae7c4c591dcc261);

var $axSQB = parcelRequire("axSQB");
const $44ce6f363203119e$export$cae7c4c591dcc261 = ()=>{
    if (false) return 'DEFAULT';
    return (0, $axSQB.localStorage).get((0, $axSQB.VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';
};

});




parcelRegister("2cfd4", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $724847ed56dbc347$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $724847ed56dbc347$export$31652d9c30d7d3f3);

var $eJOHy = parcelRequire("eJOHy");

var $4qiFT = parcelRequire("4qiFT");

var $lvKO5 = parcelRequire("lvKO5");
const $724847ed56dbc347$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $4qiFT.defaultLocale);
};
const $724847ed56dbc347$export$31652d9c30d7d3f3 = ()=>{
    const locale = $724847ed56dbc347$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $eJOHy.useMemo)(()=>(0, $4qiFT.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

const $a85d9f0dd63c9b50$export$a763454c55d057f2 = 'jira.user.issue.clickthrough-banner.lastinteracted';
const $a85d9f0dd63c9b50$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $a85d9f0dd63c9b50$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $a85d9f0dd63c9b50$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $a85d9f0dd63c9b50$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $a85d9f0dd63c9b50$export$39aaf586c7ee5202 = 'jira.user.issue.user-preferred-layouts';
const $a85d9f0dd63c9b50$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $a85d9f0dd63c9b50$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $a85d9f0dd63c9b50$export$1a08240e14f65aa = 'jira.user.issue.collapsible-sections-state';
const $a85d9f0dd63c9b50$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';

parcelRegister("16PQW", function(module, exports) {

$parcel$export(module.exports, "Tabs", () => $9af4469a8b4e550d$export$b2539bed5023c21c);
$parcel$export(module.exports, "defaultActiveTab", () => $9af4469a8b4e550d$export$7566e064a478af42);
const $9af4469a8b4e550d$export$b2539bed5023c21c = {
    Description: 'description',
    WorkItems: 'workItems',
    Resources: 'resources',
    Integrations: 'integrations'
};
const $9af4469a8b4e550d$export$7566e064a478af42 = $9af4469a8b4e550d$export$b2539bed5023c21c.Description;
const $9af4469a8b4e550d$export$d07bba395c9390f1 = 42;

});

parcelRegister("lpEwy", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $e029db5d7fe89f63$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $e029db5d7fe89f63$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $e029db5d7fe89f63$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $e029db5d7fe89f63$export$5513f3c310d101f5);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $5TQFX = parcelRequire("5TQFX");
const $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY = [];
const $e029db5d7fe89f63$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY;
const $e029db5d7fe89f63$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
const $e029db5d7fe89f63$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $5TQFX
});
const $e029db5d7fe89f63$export$5c4a1f63cea7b5b3 = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContainers
});
const $e029db5d7fe89f63$export$769bbe2bda9a43ce = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutGlance
});
const $e029db5d7fe89f63$export$3aa9017e11451546 = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel
});
const $e029db5d7fe89f63$export$5513f3c310d101f5 = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("5TQFX", function(module, exports) {

$parcel$export(module.exports, "setIssueViewContainersLayout", () => $1fee7e98aeef55ea$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $1fee7e98aeef55ea$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $1fee7e98aeef55ea$export$9a04e4b958ebc410);
const $1fee7e98aeef55ea$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $1fee7e98aeef55ea$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $1fee7e98aeef55ea$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});


parcelRegister("co62F", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemId", () => $f780ca908cc08c0e$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $f780ca908cc08c0e$export$355607dae809ec65);

var $5OyZl = parcelRequire("5OyZl");
const $f780ca908cc08c0e$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $5OyZl.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $5OyZl.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $5OyZl.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $f780ca908cc08c0e$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($f780ca908cc08c0e$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $5OyZl.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $f780ca908cc08c0e$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});
parcelRegister("5OyZl", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $37dff345eecb4f05$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $37dff345eecb4f05$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $37dff345eecb4f05$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $37dff345eecb4f05$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $37dff345eecb4f05$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $37dff345eecb4f05$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $37dff345eecb4f05$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $37dff345eecb4f05$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $37dff345eecb4f05$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $37dff345eecb4f05$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $37dff345eecb4f05$export$ad3536b13febb432);
const $37dff345eecb4f05$export$99ad62164189f781 = 'ecosystemGlance';
const $37dff345eecb4f05$export$7719ef6e9283671 = 'forgeGlance';
const $37dff345eecb4f05$export$bfebea5ce2e1887a = 'ecosystemContext';
const $37dff345eecb4f05$export$be8e68fb1aed253e = 'forgeContext';
const $37dff345eecb4f05$export$7bf561e6ab380ea1 = 'context';
const $37dff345eecb4f05$export$f42c11634d75863e = 'content';
const $37dff345eecb4f05$export$b38842736b6dbc1d = 'content-request';
const $37dff345eecb4f05$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_TYPE = 'FORGE';
const $37dff345eecb4f05$export$605c43f1b33ab69 = 'SUMMARY';
const $37dff345eecb4f05$export$e655b77b9efe622f = 'CustomItem';
const $37dff345eecb4f05$export$5cf403de05e9bea = 'FieldSectionItem';
const $37dff345eecb4f05$export$30f7f9a86f182492 = 'TabLayout';
const $37dff345eecb4f05$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $37dff345eecb4f05$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $37dff345eecb4f05$export$ad3536b13febb432 = (node)=>node.type === $37dff345eecb4f05$export$5507f31126c8b283.tab;

});



parcelRegister("cZpx8", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $ae6f6bc492f6f5be$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $ae6f6bc492f6f5be$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $ae6f6bc492f6f5be$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $ae6f6bc492f6f5be$var$cachedIsCompactValues = {};
let $ae6f6bc492f6f5be$var$previousRouteKey;
function $ae6f6bc492f6f5be$export$c47621d55d10906c(key) {
    return $ae6f6bc492f6f5be$var$cachedIsCompactValues[key];
}
function $ae6f6bc492f6f5be$export$568b2dd75c2027b4(isCompactValue, key) {
    $ae6f6bc492f6f5be$var$cachedIsCompactValues[key] = isCompactValue;
}
function $ae6f6bc492f6f5be$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $ae6f6bc492f6f5be$var$previousRouteKey) {
        $ae6f6bc492f6f5be$var$previousRouteKey = currentRouteKey;
        delete $ae6f6bc492f6f5be$var$cachedIsCompactValues[$ae6f6bc492f6f5be$var$previousRouteKey];
    }
}

});


parcelRegister("hj1Lc", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});


parcelRegister("5nfTh", function(module, exports) {

$parcel$export(module.exports, "aiContextPanelResource", () => $beffd628552f984a$export$8f6224974184ed8d);
$parcel$export(module.exports, "aiContextPanelResourceWithDependencies", () => $beffd628552f984a$export$70559c909620e4ed);
$parcel$export(module.exports, "getAIContextPanelResources", () => $beffd628552f984a$export$d5bd1af2f373eac4);

var $l1VxS = parcelRequire("l1VxS");

var $7jTnu = parcelRequire("7jTnu");


var $iYKap = parcelRequire("iYKap");


var $dAIVP = parcelRequire("dAIVP");

var $2MCmQ = parcelRequire("2MCmQ");

var $iVFol = parcelRequire("iVFol");

var $3yIzr = parcelRequire("3yIzr");

var $fEqOu = parcelRequire("fEqOu");
const $beffd628552f984a$var$SUPPORTED_PRACTICES = new Set([
    (0, $61012e06080c144d$export$a364d86306d4a6d4),
    (0, $61012e06080c144d$export$31ffe79c2b019cf)
]);
const $beffd628552f984a$export$8f6224974184ed8d = (0, $l1VxS.createResource)({
    type: (0, $2ba002e1dfb362f8$export$57128ea4767a7885),
    getKey: ({ match: match })=>{
        const issueKey = match.params.issueKey || '';
        return `aiContextPanelResource-${issueKey}`;
    },
    getData: async (routerDataContext, resourceStoreContext)=>{
        const { skipChecks: skipChecks, issueKey: issueKey } = routerDataContext.match.params;
        let { issueId: issueId, practice: practice, projectId: projectId } = routerDataContext.match.params;
        const { cloudId: cloudId, locale: locale } = resourceStoreContext.tenantContext;
        if (!issueKey) return null;
        if (skipChecks !== '1') {
            // The suggestions panel is available only on service-desk.
            // Hence filtering them out to reduce the number of calls to AGG and features APIs
            if (!(0, $iYKap.checkLicense)(resourceStoreContext.tenantContext, 'servicedesk') || !(0, $7jTnu.fg)('jsm_issue_view_ai_context')) return null;
            const issueDetails = await (0, $3yIzr.getIssueDetails)(issueKey, cloudId, (0, $7jTnu.fg)('context_panel_state_in_issue_details'));
            const isAIEnabled = issueDetails.isAIEnabled;
            issueId = issueDetails.issueId;
            projectId = issueDetails.projectId;
            practice = issueDetails.practice;
            if (!isAIEnabled || !$beffd628552f984a$var$SUPPORTED_PRACTICES.has(practice)) return null;
            let isAIContextPanelDisabled;
            if ((0, $7jTnu.fg)('context_panel_state_in_issue_details')) isAIContextPanelDisabled = !issueDetails.isAiContextFeatureEnabled;
            else {
                const featureState = await (0, $fEqOu.getFeatureState)(routerDataContext, resourceStoreContext);
                isAIContextPanelDisabled = featureState?.['jsm-ai-context']?.status === (0, $61012e06080c144d$export$8cd212c10b4124d2);
            }
            if (isAIContextPanelDisabled) return null;
        }
        if (!issueId) throw new Error('AI context service panel resource cannot be loaded without an issueId');
        if (practice === (0, $61012e06080c144d$export$a364d86306d4a6d4)) return (0, $2MCmQ.getServiceSuggestionData)(issueId, cloudId);
        if (practice === (0, $61012e06080c144d$export$31ffe79c2b019cf) && (0, $7jTnu.fg)('jsm_issue_view_ai_context_ops')) {
            if (!projectId) throw new Error('AI context ops panel resource cannot be loaded without a projectId');
            return (0, $iVFol.getIncidentSuggestionEndpoint)({
                cloudId: cloudId,
                issueId: issueId,
                projectId: projectId,
                locale: locale
            });
        }
        return null;
    },
    maxAge: 0,
    isBrowserOnly: true
});
const $beffd628552f984a$export$70559c909620e4ed = (0, $l1VxS.createResource)({
    type: (0, $2ba002e1dfb362f8$export$38f892c32d281e99),
    getKey: ({ match: match })=>{
        const issueKey = match.params.issueKey || '';
        return `aiContextPanelResourceWithDependencies-${issueKey}`;
    },
    getData: async (routerDataContext, resourceStoreContext)=>{
        const { issueKey: issueKey } = routerDataContext.match.params;
        let { issueId: issueId, practice: practice, projectId: projectId } = routerDataContext.match.params;
        const { cloudId: cloudId, locale: locale } = resourceStoreContext.tenantContext;
        if (!issueKey) return null;
        if (!(0, $iYKap.checkLicense)(resourceStoreContext.tenantContext, 'servicedesk') || !(0, $7jTnu.fg)('jsm_issue_view_ai_context')) return null;
        let issueDetails = (0, $dAIVP.getDependencyData)(routerDataContext.dependencies, (0, $2ba002e1dfb362f8$export$3e1b459cf14e5bcd));
        if (issueDetails instanceof Promise) issueDetails = await issueDetails;
        if (!issueDetails) return null;
        const { isAIEnabled: isAIEnabled, isAiContextFeatureEnabled: isAiContextFeatureEnabled } = issueDetails;
        issueId = issueDetails.issueId;
        projectId = issueDetails.projectId;
        practice = issueDetails.practice;
        if (!isAIEnabled || !$beffd628552f984a$var$SUPPORTED_PRACTICES.has(practice) || !isAiContextFeatureEnabled) return null;
        if (!issueId) throw new Error('AI context service panel resource cannot be loaded without an issueId');
        if (practice === (0, $61012e06080c144d$export$a364d86306d4a6d4)) return (0, $2MCmQ.getServiceSuggestionData)(issueId, cloudId);
        if (practice === (0, $61012e06080c144d$export$31ffe79c2b019cf) && (0, $7jTnu.fg)('jsm_issue_view_ai_context_ops')) {
            if (!projectId) throw new Error('AI context ops panel resource cannot be loaded without a projectId');
            return (0, $iVFol.getIncidentSuggestionEndpoint)({
                cloudId: cloudId,
                issueId: issueId,
                projectId: projectId,
                locale: locale
            });
        }
        return null;
    },
    maxAge: 0,
    depends: [
        (0, $2ba002e1dfb362f8$export$3e1b459cf14e5bcd)
    ],
    isBrowserOnly: true
});
const $beffd628552f984a$export$d5bd1af2f373eac4 = ()=>{
    return (0, $7jTnu.fg)('ssr_issue_details_for_suggestions_panel') ? [
        (0, $3yIzr.contextPanelIssueDetailsResource),
        $beffd628552f984a$export$70559c909620e4ed
    ] : [
        $beffd628552f984a$export$8f6224974184ed8d
    ];
};

});
const $61012e06080c144d$export$b45a36df7873757 = 'alerts';
const $61012e06080c144d$export$a7952c5a5c371ddd = 'oncall';
const $61012e06080c144d$export$de0bca182bc46c7f = 'services';
const $61012e06080c144d$export$ed849d1eb34423e5 = 'similarIssues';
const $61012e06080c144d$export$d4a1ed8524773042 = 'sentiment-analysis';
const $61012e06080c144d$export$46f600f4680e5fd0 = 'jsm-ai-context';
const $61012e06080c144d$export$3d2ce10d3ca55e3c = 'automaticallySetRequestType';
const $61012e06080c144d$export$cae2404f62c0f4d7 = 'change-management';
const $61012e06080c144d$export$31ffe79c2b019cf = 'incident-management';
const $61012e06080c144d$export$3a20074cc38cbf69 = 'problem-management';
const $61012e06080c144d$export$a364d86306d4a6d4 = 'service-request';
const $61012e06080c144d$export$71f1a79e03f525 = 'post-incident-review';
const $61012e06080c144d$export$6860c7a26d6d6d35 = 'csm-customer-context';
const $61012e06080c144d$export$7c5ee80fcb40e9d3 = 'developer-escalation';
const $61012e06080c144d$export$28fc94ee6c61f632 = 'products-and-entitlements';
const $61012e06080c144d$export$93b42272f76473c9 = 'jsm-views';
const $61012e06080c144d$export$1eb399d8c2d53748 = 'jsm-board';
const $61012e06080c144d$export$abbcecf25bfa1e87 = 'jsm-calendar';
const $61012e06080c144d$export$891877b4a4d60ea2 = 'jsm-project-summary';
const $61012e06080c144d$export$34136c6420474672 = 'journey-builder';
const $61012e06080c144d$export$66ede2c1de447f8f = 'developer-escalation';
const $61012e06080c144d$export$1ee9c534405b9b35 = 'playbooks';
const $61012e06080c144d$export$ac0832132e8992d7 = 'automation-discoverability';
const $61012e06080c144d$export$fc77e86331b0e2c7 = 'jcs-customer-support-escalation';
const $61012e06080c144d$export$e927a5d1b72f0b68 = 'ENABLED';
const $61012e06080c144d$export$8cd212c10b4124d2 = 'DISABLED';

parcelRegister("iYKap", function(module, exports) {

$parcel$export(module.exports, "checkLicense", () => $53e7d1c0d26ba27f$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $53e7d1c0d26ba27f$export$944be0b3bf2a6feb);

var $eJOHy = parcelRequire("eJOHy");

var $lvKO5 = parcelRequire("lvKO5");
const $53e7d1c0d26ba27f$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess',
    customerservice: 'hasCustomerServiceAccess'
};
const $53e7d1c0d26ba27f$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$53e7d1c0d26ba27f$var$appPermissionMapper[type]]);
const $53e7d1c0d26ba27f$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvKO5.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $53e7d1c0d26ba27f$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

const $2ba002e1dfb362f8$export$3e1b459cf14e5bcd = 'CONTEXT_PANEL_ISSUE_DETAILS';
const $2ba002e1dfb362f8$export$57128ea4767a7885 = 'AI-CONTEXT-PANEL-RESOURCE-TYPE';
const $2ba002e1dfb362f8$export$38f892c32d281e99 = 'AI-CONTEXT-PANEL-RESOURCE-TYPE-WITH-DEPENDENCIES';

parcelRegister("dAIVP", function(module, exports) {

$parcel$export(module.exports, "getDependencyData", () => $e40c6d169122cf74$export$c1f67084c4ca42af);

var $5j85B = parcelRequire("5j85B");
const $e40c6d169122cf74$export$c1f67084c4ca42af = (dependencies, key)=>{
    if (dependencies[key]?.loading || dependencies[key]?.error) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $5j85B.consumeDependency)(dependencies, key);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return dependencies[key]?.data;
};

});

parcelRegister("2MCmQ", function(module, exports) {

$parcel$export(module.exports, "getServiceSuggestionData", () => $4dfc8fc8b5116538$export$afab700af9f021de);

var $jGzN3 = parcelRequire("jGzN3");

var $7jTnu = parcelRequire("7jTnu");

var $hH1YR = parcelRequire("hH1YR");

var $3oS2M = parcelRequire("3oS2M");
const $4dfc8fc8b5116538$export$d8192485ee52671b = (issueId)=>`/gateway/api/firebolt/1/context-panel/${issueId}`;
const $4dfc8fc8b5116538$export$afab700af9f021de = (issueId, cloudId)=>{
    if ((0, $7jTnu.fg)('context-panel-graphql-migration')) return (0, $3oS2M.getContextPanelSuggestions)(cloudId, issueId);
    const url = $4dfc8fc8b5116538$export$d8192485ee52671b(issueId);
    return (0, $jGzN3.performGetRequest)(url).then((0, $hH1YR.transformData));
};

});
parcelRegister("hH1YR", function(module, exports) {

$parcel$export(module.exports, "transformContent", () => $e8ab789f25bfc4bf$export$b7cb80c25ebba28e);
$parcel$export(module.exports, "parseAdf", () => $e8ab789f25bfc4bf$export$5659c60045974de9);
$parcel$export(module.exports, "transformData", () => $e8ab789f25bfc4bf$export$3ceb62baab058c6b);
const $e8ab789f25bfc4bf$export$b7cb80c25ebba28e = (content)=>{
    return {
        title: $e8ab789f25bfc4bf$export$5659c60045974de9(content.title),
        description: $e8ab789f25bfc4bf$export$5659c60045974de9(content.description)
    };
};
const $e8ab789f25bfc4bf$export$3ceb62baab058c6b = (data)=>({
        type: 'ServicePanelSuggestions',
        summary: $e8ab789f25bfc4bf$export$5659c60045974de9(data.summary),
        reporterDetails: $e8ab789f25bfc4bf$export$5659c60045974de9(data.reporterDetails),
        nextSteps: $e8ab789f25bfc4bf$export$5659c60045974de9(data.nextSteps),
        suggestedEscalation: $e8ab789f25bfc4bf$export$5659c60045974de9(data.suggestedEscalation),
        suggestedActions: data.suggestedActions ? data.suggestedActions.map((action)=>{
            switch(action.type){
                case 'priority':
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $e8ab789f25bfc4bf$export$b7cb80c25ebba28e(action.content)
                    };
                case 'comment':
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $e8ab789f25bfc4bf$export$b7cb80c25ebba28e(action.content)
                    };
                case 'assignee':
                default:
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $e8ab789f25bfc4bf$export$b7cb80c25ebba28e(action.content)
                    };
            }
        }) : []
    });
const $e8ab789f25bfc4bf$export$5659c60045974de9 = (adfString)=>{
    if (!adfString) return null;
    try {
        return JSON.parse(adfString);
    } catch (_error) {
        return null;
    }
};

});

parcelRegister("3oS2M", function(module, exports) {

$parcel$export(module.exports, "getContextPanelSuggestions", () => $adc9a15d05014044$export$715f8fbc08922943);

var $12ByG = parcelRequire("12ByG");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $aOk72 = parcelRequire("aOk72");

var $8sZMk = parcelRequire("8sZMk");
const $adc9a15d05014044$var$OPERATION_NAME = 'graphqlContextPanelQuery';
const $adc9a15d05014044$var$contextPanelQuery = (0, $12ByG.default);
const $adc9a15d05014044$export$715f8fbc08922943 = async (cloudId, issueId)=>{
    (0, $aOk72.startCapturingTraceIds)($adc9a15d05014044$var$OPERATION_NAME);
    const graphQLResponse = await (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), $adc9a15d05014044$var$contextPanelQuery, {
        cloudId: cloudId,
        issueId: issueId
    }).toPromise().then((data)=>{
        const traceIds = (0, $aOk72.getTraceIds)($adc9a15d05014044$var$OPERATION_NAME);
        return (0, $8sZMk.handleGraphQLresponse)(data, traceIds);
    }).catch((error)=>{
        const traceIds = (0, $aOk72.getTraceIds)($adc9a15d05014044$var$OPERATION_NAME);
        return (0, $8sZMk.handleGraphQLError)(error, traceIds);
    }).finally(()=>{
        (0, $aOk72.stopCapturingTraceIds)($adc9a15d05014044$var$OPERATION_NAME);
    });
    return graphQLResponse;
};

});
parcelRegister("12ByG", function(module, exports) {

$parcel$export(module.exports, "default", () => $48e15bb162ea0470$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2f2296a9e4dc5a9c7f87482d4e72080a>>
 * @relayHash 0b817e9b59a520de5e2b21a42b9e7287
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ac1cbc7f10f7aad403db10ad5ca17c4a01fbe5bf5350fef6f4eaabc1d3faaf9
const $48e15bb162ea0470$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "issueId",
            "variableName": "issueId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "summary"
            },
            {
                "kind": "ScalarField",
                "name": "nextSteps"
            },
            {
                "kind": "ScalarField",
                "name": "reporterDetails"
            },
            {
                "kind": "ScalarField",
                "name": "suggestedEscalation"
            },
            {
                "concreteType": "AgentAISuggestAction",
                "kind": "LinkedField",
                "name": "suggestedActions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "AgentAISuggestedActionContent",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "description"
                            }
                        ]
                    },
                    {
                        "concreteType": "AgentAISuggestedActionContext",
                        "kind": "LinkedField",
                        "name": "context",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "fieldId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "fieldType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "fieldName"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "suggestion"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "AgentAIContextPanelResponse"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlContextPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentAI_contextPanel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlContextPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentAI_contextPanel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3ac1cbc7f10f7aad403db10ad5ca17c4a01fbe5bf5350fef6f4eaabc1d3faaf9",
            "metadata": {},
            "name": "graphqlContextPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$48e15bb162ea0470$var$node.hash = "b52c73d190e18f743ff20687e5b2ced0";
var $48e15bb162ea0470$export$2e2bcd8739ae039 = $48e15bb162ea0470$var$node;

});

parcelRegister("8sZMk", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLresponse", () => $c54e4deedc3837c9$export$f09fdc2e4ab145a5);
$parcel$export(module.exports, "handleGraphQLError", () => $c54e4deedc3837c9$export$3af48ada790caea5);
/* eslint-disable jira/import-whitelist */ 
var $hr3bU = parcelRequire("hr3bU");

var $hH1YR = parcelRequire("hH1YR");
const $c54e4deedc3837c9$export$716425a07890b235 = (graphQLResponse, traceIds)=>{
    const data = graphQLResponse?.agentAI_contextPanel?.__typename === 'AgentAIContextPanelResponse' ? graphQLResponse?.agentAI_contextPanel : null;
    return {
        type: 'ServicePanelSuggestions',
        traceIds: traceIds,
        summary: (0, $hH1YR.parseAdf)(data?.summary),
        reporterDetails: (0, $hH1YR.parseAdf)(data?.reporterDetails),
        nextSteps: (0, $hH1YR.parseAdf)(data?.nextSteps),
        suggestedEscalation: (0, $hH1YR.parseAdf)(data?.suggestedEscalation),
        suggestedActions: data?.suggestedActions ? data?.suggestedActions?.map((action)=>({
                type: action.type,
                context: {
                    ...action.context,
                    suggestion: action.context?.suggestion
                },
                content: (0, $hH1YR.transformContent)(action?.content)
            })) : []
    };
};
const $c54e4deedc3837c9$export$f09fdc2e4ab145a5 = (graphQLResponse, traceIds)=>{
    const responseType = graphQLResponse?.agentAI_contextPanel?.__typename;
    if (responseType === 'AgentAIContextPanelResponse') return $c54e4deedc3837c9$export$716425a07890b235(graphQLResponse, traceIds);
    if (responseType === 'QueryError') {
        const errorMessage = graphQLResponse?.agentAI_contextPanel?.message ?? 'Unknown error';
        const errorStatus = graphQLResponse?.agentAI_contextPanel?.extensions?.[0]?.statusCode ?? 500;
        throw new (0, $hr3bU.FetchError)(errorStatus, `Error processing graphQL query: ${errorMessage}`, traceIds?.[0]);
    }
    throw new (0, $hr3bU.FetchError)(500, 'Failed to fetch data from AGG', traceIds?.[0]);
};
const $c54e4deedc3837c9$export$3af48ada790caea5 = (error, traceIds)=>{
    throw new (0, $hr3bU.FetchError)(500, `Failed to fetch data from AGG : ${error?.message}`, traceIds?.[0]);
};

});
parcelRegister("hr3bU", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $c3479ad131081be1$export$26e841bcf1aeb894);
$parcel$export(module.exports, "ResponseNullError", () => $c3479ad131081be1$export$895e385291c3b753);
/* eslint-disable max-classes-per-file */ class $c3479ad131081be1$var$ExtensibleError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $c3479ad131081be1$export$26e841bcf1aeb894 extends $c3479ad131081be1$var$ExtensibleError {
    constructor(statusCode, message, traceId){
        super(message == null ? `Fetch call failed with status code: ${statusCode}` : message), this.graphQLErrors = [];
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.networkError = {
            statusCode: statusCode
        };
        this.skipSentry = true;
        if (traceId != null) this.traceId = traceId;
    }
}
class $c3479ad131081be1$export$895e385291c3b753 extends $c3479ad131081be1$var$ExtensibleError {
    constructor(message){
        super(message);
        this.name = 'ResponseNullError';
        this.skipSentry = true;
    }
}

});




parcelRegister("iVFol", function(module, exports) {

$parcel$export(module.exports, "getIncidentSuggestionEndpoint", () => $7e9ce5a2037a7c93$export$32b63803a24bceaa);

var $1Ozm9 = parcelRequire("1Ozm9");

var $epTsa = parcelRequire("epTsa");

var $1L12E = parcelRequire("1L12E");
const $7e9ce5a2037a7c93$export$db19de3f154d9918 = ({ cloudId: cloudId, issueId: issueId, projectId: projectId, locale: locale })=>`/gateway/api/jsm/aiops/cloudId/${cloudId}/api/v1/incident-suggestion/${issueId}?projectId=${projectId}&locale=${locale}
`;
const $7e9ce5a2037a7c93$export$32b63803a24bceaa = (reqParams)=>{
    const url = $7e9ce5a2037a7c93$export$db19de3f154d9918(reqParams);
    return (0, $1Ozm9.default)(url, {
        method: 'GET'
    }).then((0, $epTsa.expVal)('aiops_context_panel_ui_update_experiment', 'isEnabled', false) ? (0, $1L12E.transformResponseV2) : (0, $1L12E.transformResponse));
};

});
parcelRegister("1L12E", function(module, exports) {

$parcel$export(module.exports, "transformResponse", () => $c4785b8184d8dce8$export$3361e9be8093ddcc);
$parcel$export(module.exports, "transformResponseV2", () => $c4785b8184d8dce8$export$deb8fcf4bacae588);
// Resource doesn't allow imports of getEmptyADF();
const $c4785b8184d8dce8$var$EMPTY_DOCUMENT = {
    version: 1,
    type: 'doc',
    content: []
};
const $c4785b8184d8dce8$var$parseToADF = (adfString)=>{
    try {
        return JSON.parse(adfString);
    } catch (error) {
        return $c4785b8184d8dce8$var$EMPTY_DOCUMENT;
    }
};
const $c4785b8184d8dce8$var$transformContent = (content)=>{
    return {
        title: $c4785b8184d8dce8$var$parseToADF(content.title),
        description: $c4785b8184d8dce8$var$parseToADF(content.description)
    };
};
const $c4785b8184d8dce8$var$transformMultipleSectionContent = (content)=>{
    return {
        title: $c4785b8184d8dce8$var$parseToADF(content.title),
        description: $c4785b8184d8dce8$var$parseToADF(content.description),
        descriptionList: content.descriptionList ? content.descriptionList.map((suggestion)=>({
                id: suggestion.id,
                description: $c4785b8184d8dce8$var$parseToADF(suggestion.description)
            })) : []
    };
};
const $c4785b8184d8dce8$var$exhaustiveCheck = (_)=>null;
const $c4785b8184d8dce8$export$3361e9be8093ddcc = (response)=>{
    return {
        type: 'OpsPanelSuggestions',
        incidentSummary: {
            ...response.incidentSummary.content,
            description: $c4785b8184d8dce8$var$parseToADF(response.incidentSummary.content.description)
        },
        probableRCA: response.probableRCA?.content ? {
            ...response.probableRCA.content,
            description: $c4785b8184d8dce8$var$parseToADF(response.probableRCA.content.description)
        } : null,
        suggestedActions: response.suggestedActions.map((action)=>{
            switch(action.type){
                case 'SEVERITY':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: {
                                ...action.context.suggestion,
                                value: action.context.suggestion.name
                            }
                        },
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'AFFECTED_SERVICES':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion.map((service)=>({
                                    id: service.id,
                                    name: service.name,
                                    data: service
                                }))
                        },
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'PROBLEM_TICKET':
                case 'MAJOR_INCIDENT':
                case 'PRIORITY':
                case 'RESPONDERS':
                case 'RCA_WITH_AUTOMATION':
                    return {
                        ...action,
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                default:
                    return $c4785b8184d8dce8$var$exhaustiveCheck(action);
            }
        }).filter(Boolean)
    };
};
const $c4785b8184d8dce8$export$deb8fcf4bacae588 = (response)=>{
    return {
        type: 'OpsPanelSuggestions',
        incidentSummary: {
            ...response.incidentSummary.content,
            description: $c4785b8184d8dce8$var$parseToADF(response.incidentSummary.content.description)
        },
        probableRCA: response.probableRCA?.content ? {
            ...response.probableRCA.content,
            description: $c4785b8184d8dce8$var$parseToADF(response.probableRCA.content.description)
        } : null,
        suggestedActions: response.suggestedActions.map((action)=>{
            switch(action.type){
                case 'SEVERITY':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: {
                                ...action.context.suggestion,
                                value: action.context.suggestion.name
                            }
                        },
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'AFFECTED_SERVICES':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion.map((service)=>({
                                    id: service.id,
                                    name: service.name,
                                    data: service
                                }))
                        },
                        content: $c4785b8184d8dce8$var$transformMultipleSectionContent(action.content)
                    };
                case 'PROBLEM_TICKET':
                    return {
                        ...action,
                        context: action.context,
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'MAJOR_INCIDENT':
                    return {
                        ...action,
                        context: action.context,
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'PRIORITY':
                    return {
                        ...action,
                        context: action.context,
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'RESPONDERS':
                    return {
                        ...action,
                        context: action.context,
                        content: $c4785b8184d8dce8$var$transformMultipleSectionContent(action.content)
                    };
                case 'RCA_WITH_AUTOMATION':
                    return {
                        ...action,
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'ASSIGNEE':
                    return {
                        ...action,
                        context: action.context,
                        content: $c4785b8184d8dce8$var$transformMultipleSectionContent(action.content)
                    };
                default:
                    return $c4785b8184d8dce8$var$exhaustiveCheck(action);
            }
        }).filter(Boolean)
    };
};

});


parcelRegister("3yIzr", function(module, exports) {

$parcel$export(module.exports, "getIssueDetails", () => $5e5098c8e0f24a39$export$da0733c355d205d6);
$parcel$export(module.exports, "contextPanelIssueDetailsResource", () => $5e5098c8e0f24a39$export$626ce3b2cb7fb94e);

var $NEgSm = parcelRequire("NEgSm");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $4WXKS = parcelRequire("4WXKS");

var $l1VxS = parcelRequire("l1VxS");

var $iYKap = parcelRequire("iYKap");

const $5e5098c8e0f24a39$var$ISSUE_DETAILS_AGG_METRIC = 'context-panel-issue-details-agg';
const $5e5098c8e0f24a39$var$issueDetailsAggMetric = (0, $4WXKS.metrics).custom({
    key: $5e5098c8e0f24a39$var$ISSUE_DETAILS_AGG_METRIC
});
const $5e5098c8e0f24a39$export$da0733c355d205d6 = async (issueKey, cloudId, includeContextPanelState = false)=>{
    $5e5098c8e0f24a39$var$issueDetailsAggMetric.start();
    const issueDetails = await (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), (0, $NEgSm.default), {
        issueKey: issueKey,
        cloudId: cloudId,
        includeContextPanelState: includeContextPanelState
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise().then((data)=>{
        $5e5098c8e0f24a39$var$issueDetailsAggMetric.stop();
        return data;
    }).catch((e)=>{
        $5e5098c8e0f24a39$var$issueDetailsAggMetric.cancel();
        throw e;
    });
    return {
        issueId: issueDetails?.jira?.issueByKey?.issueId ?? undefined,
        practice: issueDetails?.jira?.issueByKey?.fieldByIdOrAlias?.text ?? undefined,
        projectId: issueDetails?.jira?.issueByKey?.projectField?.project?.projectId ?? undefined,
        isAIEnabled: issueDetails?.jira?.issueByKey?.projectField?.project?.isAIEnabled ?? undefined,
        ...includeContextPanelState && {
            isAiContextFeatureEnabled: issueDetails?.jira?.issueByKey?.projectField?.project?.isAiContextFeatureEnabled ?? undefined
        }
    };
};
const $5e5098c8e0f24a39$export$626ce3b2cb7fb94e = (0, $l1VxS.createResource)({
    type: (0, $2ba002e1dfb362f8$export$3e1b459cf14e5bcd),
    getKey: ({ match: match, query: query })=>{
        const issueKey = match.params.issueKey || query.selectedIssue || '';
        return `contextPanelIssueDetailsResource-${issueKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const issueKey = match.params.issueKey || query.selectedIssue || '';
        const cloudId = tenantContext.cloudId;
        if (!(0, $iYKap.checkLicense)(tenantContext, 'servicedesk')) return null;
        if (!issueKey) throw new Error('Context service issue details cannot be loaded without an issueKey');
        return $5e5098c8e0f24a39$export$da0733c355d205d6(issueKey, cloudId, true);
    },
    maxAge: 3600000
});

});
parcelRegister("NEgSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c8621b016dd1263$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<97b1ac959a33600e23b69a5ece8a9862>>
 * @relayHash f0aba673194e9058619abb300a99e877
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4deac53f2aeea0fe5f4fcf151ec1117fd3c5e9ae76d076f740f109cf10a9df74
const $1c8621b016dd1263$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeContextPanelState"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "idOrAlias",
            "value": "servicedesk-practices"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "text"
            }
        ],
        "type": "JiraSingleLineTextField"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isAIEnabled"
    }, v8 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v9 = {
        "condition": "includeContextPanelState",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isAiContextFeatureEnabled"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueDetailsForAIContextPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fieldByIdOrAlias",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
                                },
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueDetailsForAIContextPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fieldByIdOrAlias",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ],
                                    "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
                                },
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        v10 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4deac53f2aeea0fe5f4fcf151ec1117fd3c5e9ae76d076f740f109cf10a9df74",
            "metadata": {},
            "name": "issueDetailsForAIContextPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1c8621b016dd1263$var$node.hash = "31378fdb45b287b152e0f480c90e621a";
var $1c8621b016dd1263$export$2e2bcd8739ae039 = $1c8621b016dd1263$var$node;

});


parcelRegister("fEqOu", function(module, exports) {

$parcel$export(module.exports, "getFeatureState", () => $06021a236a151e25$export$c8c54cead17ad7fa);
// eslint-disable-next-line jira/import-whitelist

var $4WXKS = parcelRequire("4WXKS");

var $dYpVn = parcelRequire("dYpVn");
const $06021a236a151e25$var$FEATURE_STATE_METRIC = 'context-panel-feature-states';
const $06021a236a151e25$var$featureStateMetric = (0, $4WXKS.metrics).custom({
    key: $06021a236a151e25$var$FEATURE_STATE_METRIC
});
const $06021a236a151e25$export$c8c54cead17ad7fa = (routerDataContext, resourceStoreContext)=>{
    $06021a236a151e25$var$featureStateMetric.start();
    return (0, $dYpVn.featuresResource)(routerDataContext, resourceStoreContext)?.then((data)=>{
        $06021a236a151e25$var$featureStateMetric.stop();
        return data;
    }).catch((e)=>{
        $06021a236a151e25$var$featureStateMetric.cancel();
        throw e;
    });
};

});
parcelRegister("dYpVn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "transformRestData", () => $f8375032ce4d6cb2$export$40da6ae06b8b332e);
$parcel$export(module.exports, "featuresResource", () => $f8375032ce4d6cb2$export$16f81cc9da2c6c47);
$parcel$export(module.exports, "default", () => $f8375032ce4d6cb2$export$2e2bcd8739ae039);

var $9Dhvc = parcelRequire("9Dhvc");

var $6uWhG = parcelRequire("6uWhG");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");

var $4kMB4 = parcelRequire("4kMB4");

var $7hVvO = parcelRequire("7hVvO");

var $bBtQo = parcelRequire("bBtQo");

var $aV23b = parcelRequire("aV23b");
const $f8375032ce4d6cb2$export$40da6ae06b8b332e = (data)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    data.reduce((acc, { feature: feature, status: status, editable: editable })=>Object.assign(acc, {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [feature]: {
                status: status,
                editable: editable
            }
        }), {});
const $f8375032ce4d6cb2$var$getFeatures = async (projectKey)=>{
    try {
        const data = await (0, $1Ozm9.default)(`/rest/servicedesk/1/servicedesk/${projectKey}/features`);
        (0, $6uWhG.setMark)((0, $4kMB4.prefetchApiReadyMark));
        return $f8375032ce4d6cb2$export$40da6ae06b8b332e(data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraServicedeskPracticeFeaturesResource', error);
        (0, $gYnSx.default)({
            meta: {
                id: 'jiraServicedeskPracticeFeaturesResource',
                packageName: 'jiraSpa'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $f8375032ce4d6cb2$export$16f81cc9da2c6c47 = ({ match: match, query: query }, { tenantContext: tenantContext })=>{
    const { params: params } = match;
    if (!(0, $aV23b.checkAuthentication)(tenantContext)) throw (0, $7hVvO.createResourceError)({
        component: 'spa.view.routes.servicedesk.features.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    // projectKey from url path or issueKey
    const projectKey = (0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(params, 'issueKey', '')?.split('-')[0];
    if (projectKey == null) return null;
    return $f8375032ce4d6cb2$var$getFeatures(projectKey);
};
var $f8375032ce4d6cb2$export$2e2bcd8739ae039 = $f8375032ce4d6cb2$export$16f81cc9da2c6c47;

});



parcelRegister("6zEUu", function(module, exports) {

$parcel$export(module.exports, "projectGlobalComponentsResource", () => $dea084457308c93c$export$d2cb7067a31cf873);

var $l1VxS = parcelRequire("l1VxS");

var $bBtQo = parcelRequire("bBtQo");

var $3Is9n = parcelRequire("3Is9n");
const $dea084457308c93c$export$be79e0677801e96e = 'PROJECT_GLOBAL_COMPONENTS';
const $dea084457308c93c$export$d2cb7067a31cf873 = (0, $l1VxS.createResource)({
    type: $dea084457308c93c$export$be79e0677801e96e,
    getKey: (matchedRoute)=>(0, $bBtQo.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getData: (...args)=>(0, $3Is9n.getData)(...args)
});

});
parcelRegister("3Is9n", function(module, exports) {

$parcel$export(module.exports, "getData", () => $c5448ba1b9fac404$export$7a171f172be0782e);

var $bBtQo = parcelRequire("bBtQo");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $c5448ba1b9fac404$export$7a171f172be0782e = async (matchedRoute, _storeContext)=>{
    const projectIdOrKey = (0, $bBtQo.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query);
    if (projectIdOrKey == null || projectIdOrKey === '') return null;
    return $c5448ba1b9fac404$export$1db3503600a1638e(projectIdOrKey);
};
const $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $c5448ba1b9fac404$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $c5448ba1b9fac404$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $c5448ba1b9fac404$var$getProjectId = async (projectKey)=>{
    const project = await (0, $jGzN3.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $c5448ba1b9fac404$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$c5448ba1b9fac404$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $c5448ba1b9fac404$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $c5448ba1b9fac404$var$url(projectId, $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $c5448ba1b9fac404$var$url(projectKey, $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $jGzN3.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $gYnSx.default)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};

});


parcelRegister("W6cJS", function(module, exports) {

$parcel$export(module.exports, "getJsmIssueViewSlaPanelResource", () => $00f5fc4bffd7e9ed$export$31e044b40ecfc470);
$parcel$export(module.exports, "useJsmIssueViewSlaPanelResource", () => $00f5fc4bffd7e9ed$export$cc90b63080792845);

var $1Ozm9 = parcelRequire("1Ozm9");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $eq3q8 = parcelRequire("eq3q8");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");
const $00f5fc4bffd7e9ed$var$jsmIssueViewSlaPanelResource = (0, $l1VxS.createResource)({
    type: 'JSM_ISSUE_VIEW_SLA_PANEL_RESOURCE',
    getKey: ({ match: match })=>{
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        return issueKey || '';
    },
    getData: async ({ match: match }, { tenantContext: tenantContext })=>{
        // ServiceDesk access check is only enforced when jsm-issue-view-sla-panel-high-load-protection fg is enabled,
        // allowing us to restrict access during high load scenarios
        if (!tenantContext.appEditions.serviceDesk && (0, $7jTnu.fg)('jsm-issue-view-sla-panel-high-load-protection')) return null;
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        if (!issueKey) return null;
        try {
            const url = `/rest/servicedesk/1/servicedesk/sla/issue/${issueKey}`;
            const response = await (0, $1Ozm9.default)(url, {
                method: 'GET'
            });
            if (!response.errors) return response;
        } catch (error) {
            (0, $gYnSx.default)({
                error: error instanceof Error ? error : new Error(String(error)),
                sendToPrivacyUnsafeSplunk: true,
                meta: {
                    id: 'jsmIssueViewSlaPanelResource',
                    packageName: 'jiraRouterResourcesJsmIssueView',
                    teamName: 'jsd-shield'
                }
            });
        }
        return null;
    }
});
const $00f5fc4bffd7e9ed$export$31e044b40ecfc470 = ()=>$00f5fc4bffd7e9ed$var$jsmIssueViewSlaPanelResource;
const $00f5fc4bffd7e9ed$export$cc90b63080792845 = ()=>{
    return (0, $eJrcF.useResource)($00f5fc4bffd7e9ed$var$jsmIssueViewSlaPanelResource);
};

});

parcelRegister("38U18", function(module, exports) {

$parcel$export(module.exports, "removeNonCritialGiraCallFromCriticalPath", () => $d4115a80200ae1b5$export$b398e8f4bdfdca6);
$parcel$export(module.exports, "LazyIssuePage", () => $d4115a80200ae1b5$export$3e1d7c9fee0b1f1a);
$parcel$export(module.exports, "IssueComponent", () => $d4115a80200ae1b5$export$c1a868ace2f38803);
$parcel$export(module.exports, "IssueEmbedComponent", () => $d4115a80200ae1b5$export$ef02bcc0eb1d9ded);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $7jTnu = parcelRequire("7jTnu");

var $Xckw8 = parcelRequire("Xckw8");

var $bNexr = parcelRequire("bNexr");

var $2aY2d = parcelRequire("2aY2d");

var $kGR8U = parcelRequire("kGR8U");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $2mHfh = parcelRequire("2mHfh");
var $2FqDG = parcelRequire("2FqDG");

var $1KJUW = parcelRequire("1KJUW");
const $d4115a80200ae1b5$export$b398e8f4bdfdca6 = ()=>(0, $7jTnu.fg)('move_iv_noncriticalgiraquery_out_of_critical_path') ? [] : [
        (0, $1KJUW.issueGiraNonCriticalDataResource)
    ];

const $d4115a80200ae1b5$export$3e1d7c9fee0b1f1a = (0, $gzcjr.lazyForPaint)(()=>(0, $kGR8U.markAsBentoBundleReady)(// chunk name here MUST be kept in sync with TempLazyIssuePageWithSsrAlwaysDisabled below
    (parcelRequire("AORUZ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
});
const $d4115a80200ae1b5$export$c1a868ace2f38803 = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    const [issueKey] = (0, $2FqDG.usePathParam)('issueKey');
    const pageId = 'spa-issue';
    const [projectKey, issueSuffix] = issueKey !== undefined ? issueKey.split('-') : [];
    let actualIssueKey = issueKey;
    if (data?.projectKey && data.projectKey !== projectKey) actualIssueKey = `${data.projectKey}-${issueSuffix}`;
    // special handling for product discovery (=== Polaris) project issues. During the experimental phase of
    // the polaris idea view (product-specific issue view), we will redirect to a polaris-specific issue view
    // page here instead of bento.
    // this will only happen for issues of this specific project type, and only if the switchover FF is enabled
    if (!false && data?.projectType === (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT) && data?.projectKey !== undefined && actualIssueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/polaris/projects/${data.projectKey}/ideas?selectedIssue=${actualIssueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d4115a80200ae1b5$export$3e1d7c9fee0b1f1a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
const $d4115a80200ae1b5$export$ef02bcc0eb1d9ded = ()=>{
    const [issueKey] = (0, $2FqDG.usePathParam)('issueKey');
    const projectKey = (0, $bNexr.useProjectKey)(issueKey || '');
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const projectId = (0, $bNexr.useProjectId)(projectKey);
    // Special handling for product discovery (=== Polaris) project issues in embed mode.
    // We have to redirect to Polaris issue embed view instead of loading Jira issue view.
    if (projectType === (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT) && projectKey !== undefined && projectId !== undefined && issueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/secure/JiraProductDiscoveryEmbedded.jspa?projectId=${projectId}&projectKey=${projectKey}&issueKey=${issueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Xckw8.EmbedModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d4115a80200ae1b5$export$c1a868ace2f38803, null));
};

});
parcelRegister("Xckw8", function(module, exports) {

$parcel$export(module.exports, "EmbedModeContext", () => $afaa80f88033d8aa$export$5eb07b3c7c0b0771);
$parcel$export(module.exports, "EmbedModeProvider", () => $afaa80f88033d8aa$export$9daaf42d62e1c430);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");
const $afaa80f88033d8aa$export$5eb07b3c7c0b0771 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const { Provider: $afaa80f88033d8aa$var$Provider } = $afaa80f88033d8aa$export$5eb07b3c7c0b0771;
const $afaa80f88033d8aa$var$handleEmbedLinkClick = (e)=>{
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $7jTnu.fg)('jira_nin_smart_link') && (0, $7jTnu.fg)('jsc_nin_smart_link_fast_follows')) {
        if (e.target instanceof Element) {
            const anchor = e.target.closest('a'); // Find closest parent anchor (including the target itself)
            if (anchor && anchor.target !== '_blank') // link
            anchor.target = '_blank';
        }
    } else {
        const eventTarget = e.target;
        if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
        eventTarget.target = '_blank';
    }
};
// When issue view is loaded within an iframe, it needs to follow the proper
// element elevation principles, found here: https://hello.atlassian.net/wiki/spaces/~460573267/pages/2355983526/Jira+Dark+Mode+-+UI+Guidelines#Element-elevation-basics
// Unfortunately the current elevation is set in the global-container, which is loaded before this Provider so
// we have to override the overrider to ensure that the proper elevation is set
const $afaa80f88033d8aa$var$DarkModeMonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #jira-frontend {
                        background: ${"var(--ds-surface-overlay, #FFFFFF)"};
                    }
                `
        }
    });
const $afaa80f88033d8aa$export$9daaf42d62e1c430 = ({ children: children })=>{
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('click', $afaa80f88033d8aa$var$handleEmbedLinkClick, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('click', $afaa80f88033d8aa$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($afaa80f88033d8aa$var$DarkModeMonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($afaa80f88033d8aa$var$Provider, {
        value: true
    }, children));
};

});

parcelRegister("kGR8U", function(module, exports) {

$parcel$export(module.exports, "markAsBentoBundleReady", () => $393e398983932379$export$d9ff0b3329728986);

var $cJAh3 = parcelRequire("cJAh3");

var $dydef = parcelRequire("dydef");
let $393e398983932379$var$reportedBentoBundleReady = false;
const $393e398983932379$export$d9ff0b3329728986 = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        // Mutex for reporter
        if ($393e398983932379$var$reportedBentoBundleReady) return;
        $393e398983932379$var$reportedBentoBundleReady = true;
        (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, $cJAh3.JS_EVAL_START))) {
            (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
            break;
        }
    });
    return importedBundle;
};

});

parcelRegister("1KJUW", function(module, exports) {

$parcel$export(module.exports, "issueGiraNonCriticalDataResource", () => $1766f065699969de$export$2d81f7bddf10f49e);

var $eq3q8 = parcelRequire("eq3q8");

var $l1VxS = parcelRequire("l1VxS");

var $6NSKd = parcelRequire("6NSKd");

var $cfoTm = parcelRequire("cfoTm");
const $1766f065699969de$export$2d81f7bddf10f49e = (0, $l1VxS.createResource)((0, $6NSKd.withResourceEarlyData)({
    type: 'ISSUE_GIRA_NON_CRITICAL_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $cfoTm.default)(...args),
    isBrowserOnly: true
}));

});
parcelRegister("cfoTm", function(module, exports) {

$parcel$export(module.exports, "default", () => $145227085098b9a3$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $eFt4R = parcelRequire("eFt4R");

var $7hVvO = parcelRequire("7hVvO");

var $eq3q8 = parcelRequire("eq3q8");

var $7jTnu = parcelRequire("7jTnu");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$145227085098b9a3$export$2e2bcd8739ae039 = async ({ match: match }, _storeContext)=>{
    const issueKey = (0, $eq3q8.getIssueKey)(match);
    if (!issueKey || (0, $7jTnu.fg)('move_iv_noncriticalgiraquery_out_of_critical_path')) return null;
    try {
        const data = await (0, $eFt4R.fetchIssueGiraNonCriticalData)(issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $7hVvO.createResourceError)({
            component: 'spa.view.routes.issue-view.gira-non-critical.getData',
            message: 'An error was thrown while prefetching issue gira non critical data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("eFt4R", function(module, exports) {

$parcel$export(module.exports, "nonCriticalGiraQueryExperienceTracking", () => $375d768f0a07294e$export$f382deefb24f95ae);
$parcel$export(module.exports, "fetchIssueGiraNonCriticalData", () => $375d768f0a07294e$export$58a9221a6c5306db);

var $1uIew = parcelRequire("1uIew");

var $h1DPu = parcelRequire("h1DPu");

var $3ibpe = parcelRequire("3ibpe");

var $fVpjy = parcelRequire("fVpjy");
const $375d768f0a07294e$var$nonCriticalGiraQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId, isEarlyFetch: isEarlyFetch })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: isEarlyFetch ? 'issueEarlyFetchNonCriticalGiraQuery' : 'issueNonCriticalGiraQuery',
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: `Issue View ${isEarlyFetch ? 'Early Fetch ' : ''}Non Critical Gira Query`,
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $375d768f0a07294e$export$f382deefb24f95ae = ({ wasExperienceSuccessful: wasExperienceSuccessful, isEarlyFetch: isEarlyFetch, error: error })=>{
    (0, $3ibpe.sendExperienceAnalytics)($375d768f0a07294e$var$nonCriticalGiraQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error instanceof (0, $1uIew.default) && error.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $1uIew.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {},
        isEarlyFetch: isEarlyFetch
    }));
};
const $375d768f0a07294e$export$58a9221a6c5306db = async (issueKey)=>{
    const variables = {
        issueKey: issueKey
    };
    const payload = {
        query: (0, $h1DPu.buildNonCriticalGiraQuery)(),
        variables: variables,
        operationName: (0, $h1DPu.ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY)
    };
    try {
        const response = await (0, $fVpjy.getClient)().query(payload);
        $375d768f0a07294e$export$f382deefb24f95ae({
            wasExperienceSuccessful: true,
            isEarlyFetch: false
        });
        return response;
    } catch (error) {
        $375d768f0a07294e$export$f382deefb24f95ae({
            wasExperienceSuccessful: false,
            isEarlyFetch: false,
            error: error instanceof (0, $1uIew.default) ? error : undefined
        });
        throw error;
    }
};

});
parcelRegister("h1DPu", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY", () => $0a84e73193f63d04$export$857f1602ca5b9d99);
$parcel$export(module.exports, "buildNonCriticalGiraQuery", () => $0a84e73193f63d04$export$df3c3aa9d6d3f431);
$parcel$export(module.exports, "getNonCriticalGiraQueryRequestOptions", () => $0a84e73193f63d04$export$555194bfc9159fa3);

var $koDmM = parcelRequire("koDmM");
const $0a84e73193f63d04$export$857f1602ca5b9d99 = 'issueViewNonCriticalGiraQuery';
const $0a84e73193f63d04$export$df3c3aa9d6d3f431 = ()=>`
query ${$0a84e73193f63d04$export$857f1602ca5b9d99}($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        ${(0, $koDmM.getEcosystemQuery)()}
        deletableAttachmentsCount
    }
}`;
const $0a84e73193f63d04$export$555194bfc9159fa3 = (issueKey)=>({
        method: 'POST',
        body: JSON.stringify({
            operationName: $0a84e73193f63d04$export$857f1602ca5b9d99,
            query: $0a84e73193f63d04$export$df3c3aa9d6d3f431(),
            variables: {
                issueKey: issueKey
            }
        })
    });

});
parcelRegister("koDmM", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $d1f17046d51783b0$export$edefef8c65e08bd2);
const $d1f17046d51783b0$export$edefef8c65e08bd2 = ()=>`
  ecosystem {
    operations {
      name
      url: href
      tooltip
      styleClass
    }
    backgroundScripts {
      iframe {
        addonKey
        moduleKey
        options
      }
      shouldReloadOnRefresh
    }
  }
`;

});


parcelRegister("fVpjy", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $ef8531d5e19bae40$export$6bb76d6eba7e258c);

var $1Ozm9 = parcelRequire("1Ozm9");

var $8DQlA = parcelRequire("8DQlA");
const $ef8531d5e19bae40$var$makeFetchClient = ()=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $1Ozm9.default)((0, $8DQlA.getGiraUrl)(operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            })
    });
let $ef8531d5e19bae40$var$client;
const $ef8531d5e19bae40$export$6bb76d6eba7e258c = ()=>{
    if (!$ef8531d5e19bae40$var$client) $ef8531d5e19bae40$var$client = $ef8531d5e19bae40$var$makeFetchClient();
    return $ef8531d5e19bae40$var$client;
};

});




parcelRegister("AORUZ", function(module, exports) {

let $06ead25c991bed77$var$load = (parcelRequire("gLHA4"))(4);



















module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $06ead25c991bed77$var$load("99OSb")
                ]);
            }, function() {
                return Promise.all([
                    $06ead25c991bed77$var$load("f87QN")
                ]);
            }),
            $06ead25c991bed77$var$load("9yBEJ"),
            $06ead25c991bed77$var$load("k4gbU")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $06ead25c991bed77$var$load("99OSb")
                ]);
            }, function() {
                return Promise.all([
                    $06ead25c991bed77$var$load("f87QN")
                ]);
            }),
            $06ead25c991bed77$var$load("johxW"),
            $06ead25c991bed77$var$load("k4gbU")
        ]);
    }),
    (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $06ead25c991bed77$var$load("esKGV")
        ]);
    }, function() {
        return Promise.all([
            $06ead25c991bed77$var$load("7uqQP")
        ]);
    }),
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $06ead25c991bed77$var$load("99OSb")
        ]);
    }, function() {
        return Promise.all([
            $06ead25c991bed77$var$load("f87QN")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $06ead25c991bed77$var$load("82rO4"),
            $06ead25c991bed77$var$load("bABhq"),
            $06ead25c991bed77$var$load("1VRB2"),
            $06ead25c991bed77$var$load("1Y4bq"),
            $06ead25c991bed77$var$load("7vqGd"),
            $06ead25c991bed77$var$load("k4gbU"),
            $06ead25c991bed77$var$load("eDzss")
        ]);
    }, function() {
        return Promise.all([
            $06ead25c991bed77$var$load("gKoqO"),
            $06ead25c991bed77$var$load("bABhq"),
            $06ead25c991bed77$var$load("1VRB2"),
            $06ead25c991bed77$var$load("1Y4bq"),
            $06ead25c991bed77$var$load("7vqGd"),
            $06ead25c991bed77$var$load("k4gbU"),
            $06ead25c991bed77$var$load("eDzss")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $06ead25c991bed77$var$load("3PYxn"),
            $06ead25c991bed77$var$load("hwlgY")
        ]);
    }, function() {
        return Promise.all([
            $06ead25c991bed77$var$load("bfWTA")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20455-dev-panel-to-sync', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
                return Promise.all([
                    $06ead25c991bed77$var$load("lEpSD")
                ]);
            }, function() {
                return Promise.all([]);
            }),
            (parcelRequire("g81qY"))('create-branch-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $06ead25c991bed77$var$load("durhZ")
                ]);
            }, function() {
                return Promise.all([
                    $06ead25c991bed77$var$load("c6ADg")
                ]);
            }),
            (parcelRequire("g81qY"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $06ead25c991bed77$var$load("3aKV8")
                ]);
            }, function() {
                return Promise.all([
                    $06ead25c991bed77$var$load("loy87")
                ]);
            }),
            (parcelRequire("g81qY"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $06ead25c991bed77$var$load("3aKV8")
                ]);
            }, function() {
                return Promise.all([
                    $06ead25c991bed77$var$load("loy87")
                ]);
            }),
            $06ead25c991bed77$var$load("7ZkSO"),
            $06ead25c991bed77$var$load("bABhq"),
            $06ead25c991bed77$var$load("1VRB2")
        ]);
    }, function() {
        return Promise.all([
            $06ead25c991bed77$var$load("94VcJ")
        ]);
    }),
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $06ead25c991bed77$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $06ead25c991bed77$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_fg', function() {
        return Promise.all([
            $06ead25c991bed77$var$load("fXvbR")
        ]);
    }, function() {
        return Promise.all([
            $06ead25c991bed77$var$load("ljXya")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $06ead25c991bed77$var$load("4Krss")
        ]);
    }),
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $06ead25c991bed77$var$load("p5whz"),
            $06ead25c991bed77$var$load("1Y4bq"),
            $06ead25c991bed77$var$load("7vqGd")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
                return Promise.all([
                    $06ead25c991bed77$var$load("1o7PN")
                ]);
            }, function() {
                return Promise.all([
                    $06ead25c991bed77$var$load("17HeK"),
                    $06ead25c991bed77$var$load("hwlgY")
                ]);
            }),
            $06ead25c991bed77$var$load("ec3Qz"),
            $06ead25c991bed77$var$load("1Y4bq"),
            $06ead25c991bed77$var$load("7vqGd")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $06ead25c991bed77$var$load("4Krss")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $06ead25c991bed77$var$load("4Krss")
        ]);
    }),
    $06ead25c991bed77$var$load("4v8VH"),
    $06ead25c991bed77$var$load("fh2Sv"),
    $06ead25c991bed77$var$load("k4gbU"),
    $06ead25c991bed77$var$load("hwlgY"),
    $06ead25c991bed77$var$load("1VRB2"),
    $06ead25c991bed77$var$load("bABhq"),
    $06ead25c991bed77$var$load("fAbxa"),
    $06ead25c991bed77$var$load("7vqGd"),
    $06ead25c991bed77$var$load("1Y4bq"),
    $06ead25c991bed77$var$load("fMOSo"),
    $06ead25c991bed77$var$load("jhiae"),
    $06ead25c991bed77$var$load("eDzss"),
    $06ead25c991bed77$var$load("9sT2I")
]).then(()=>parcelRequire('5IVSD'));

});



parcelRegister("kNuDg", function(module, exports) {

$parcel$export(module.exports, "browseIssueRouteEntry", () => $11c6470f77b6dcac$export$cef770e7c16cfcc);

var $kHlOR = parcelRequire("kHlOR");


var $1wb5r = parcelRequire("1wb5r");

var $7jTnu = parcelRequire("7jTnu");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $6zXPf = parcelRequire("6zXPf");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $1G20J = parcelRequire("1G20J");

var $6dwgv = parcelRequire("6dwgv");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dk4qA = parcelRequire("dk4qA");

var $lPVME = parcelRequire("lPVME");

var $9NmsS = parcelRequire("9NmsS");

var $5N1SB = parcelRequire("5N1SB");

var $dZRaT = parcelRequire("dZRaT");

var $aGQ56 = parcelRequire("aGQ56");

var $bTfc4 = parcelRequire("bTfc4");

var $iBSnt = parcelRequire("iBSnt");

var $ePaI2 = parcelRequire("ePaI2");

var $4FfIq = parcelRequire("4FfIq");

var $5nfTh = parcelRequire("5nfTh");

var $5L7qx = parcelRequire("5L7qx");

var $6zEUu = parcelRequire("6zEUu");

var $W6cJS = parcelRequire("W6cJS");

var $38U18 = parcelRequire("38U18");
/**
 * @deprecated delete when cleaning up getWillShowNav4
 */ const $11c6470f77b6dcac$var$getDeprecatedBusinessResources = ()=>(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('fun-1924-remove_business_project_resource_from_jiv') ? [
        (0, $1G20J.projectThemeResource)
    ] : (0, $kRv8K.getBusinessProjectResources)();
const $11c6470f77b6dcac$var$resourcesOld = ()=>[
        // delete when cleaning up getWillShowNav4
        ...$11c6470f77b6dcac$var$getDeprecatedBusinessResources(),
        ...(0, $9NmsS.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $bTfc4.incidentExperimentTraitResourceOnNav3Only),
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResourceOnNav3Only),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $5N1SB.getOfferingCatalogueFeaturesResource)(),
        (0, $lPVME.issueGiraDataResource),
        ...(0, $38U18.removeNonCritialGiraCallFromCriticalPath)(),
        (0, $dk4qA.issueViewRelayResource),
        (0, $aGQ56.queuesNavigationItems),
        (0, $ePaI2.workspaceResource),
        (0, $4VIcO.getConsolidationStateResource)(),
        ...(0, $5nfTh.getAIContextPanelResources)(),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jira-project-isglobalcomponent-route-resource'), (0, $6zEUu.projectGlobalComponentsResource))
    ];
// jfp-magma-3491-reorder-issue-view-route-resources - These resources have been re-ordered. We have a theory that moving the more expensive ones to be first in the list makes them faster in SSR, there some small overhead that compounds over the 30 odd requests that happens.
// Longest poles at the moment are issueViewRelayResource and issueGiraDataResource, so we have moved them to the top of the list.
const $11c6470f77b6dcac$var$resourcesNew = ()=>[
        (0, $dk4qA.issueViewRelayResource),
        (0, $lPVME.issueGiraDataResource),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        ...(0, $9NmsS.getNavigationResources)(),
        // delete when cleaning up getWillShowNav4
        ...$11c6470f77b6dcac$var$getDeprecatedBusinessResources(),
        (0, $bTfc4.incidentExperimentTraitResourceOnNav3Only),
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResourceOnNav3Only),
        (0, $5ddA0.staticSidebarShortcutsResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
        ...(0, $5N1SB.getOfferingCatalogueFeaturesResource)(),
        ...(0, $38U18.removeNonCritialGiraCallFromCriticalPath)(),
        (0, $aGQ56.queuesNavigationItems),
        (0, $ePaI2.workspaceResource),
        (0, $4VIcO.getConsolidationStateResource)(),
        ...(0, $5nfTh.getAIContextPanelResources)(),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jira-project-isglobalcomponent-route-resource'), (0, $6zEUu.projectGlobalComponentsResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('magma-3869-jsm-issue-view-sla-panel-fixes'), (0, $W6cJS.getJsmIssueViewSlaPanelResource)())
    ];
const $11c6470f77b6dcac$export$cef770e7c16cfcc = (0, $6xToB.createEntry)((0, $iBSnt.browseIssueRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'issue',
        isHydrateRootEnabled: (0, $7jTnu.fg)('jfp-magma-issue-view-full-page-hydrate-root'),
        preloadOptions: {
            earlyChunks: [
                'issue-app-early-entry'
            ]
        },
        earlyAssets: (0, $1wb5r.NORMAL_EARLY_ASSET_STRATEGY),
        component: (0, $38U18.IssueComponent),
        skeleton: (0, $4FfIq.IssueViewSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.fullPageIssuePreloadLayout)),
        navigation: {
            sidebar: (0, $aDtWM.genericProjectSidebars),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: (0, $7jTnu.fg)('jfp-magma-3491-reorder-issue-view-route-resources') ? $11c6470f77b6dcac$var$resourcesNew() : $11c6470f77b6dcac$var$resourcesOld(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $38U18.LazyIssuePage)
        ],
        ufoName: 'issue-view',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$ef94a84e2990361c)
        },
        bifrost: {
            bifrostGroup: 'issue-view',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-entries/src/browseIssueRouteEntry.tsx',
                whichExportToUse: 'browseIssueRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-view.json'
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("iIsIs", function(module, exports) {

$parcel$export(module.exports, "fullPageIssuePreloadLayout", () => $5a7a9947a97daa9e$export$98e337c40eb151da);
$parcel$export(module.exports, "embeddedIssuePreloadLayoutBuilder", () => $5a7a9947a97daa9e$export$7b113174a456921a);
$parcel$export(module.exports, "pageLoadIssuePreloadLayoutBuilder", () => $5a7a9947a97daa9e$export$682dcbf7cc80ba11);

var $6dwgv = parcelRequire("6dwgv");

var $kGR8U = parcelRequire("kGR8U");

var $gzcjr = parcelRequire("gzcjr");

var $kfvK2 = parcelRequire("kfvK2");
var $fKdol = parcelRequire("fKdol");

var $1VofM = parcelRequire("1VofM");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5a7a9947a97daa9e$var$LazyIssuePage = (0, $gzcjr.lazyAfterPaint)(()=>(0, $kGR8U.markAsBentoBundleReady)((parcelRequire("AORUZ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5a7a9947a97daa9e$var$AsyncIssueAppComponent = (0, $gzcjr.lazyAfterPaint)(()=>(0, $kGR8U.markAsBentoBundleReady)((parcelRequire("zlPMC"))), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5a7a9947a97daa9e$var$IssueModal = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("1ezJg")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5a7a9947a97daa9e$var$IssueModalContents = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("9Ci5H")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-view.tsx"
});
const $5a7a9947a97daa9e$var$imports = {
    fullPage: ()=>$5a7a9947a97daa9e$var$LazyIssuePage.preload(),
    embedded: ()=>$5a7a9947a97daa9e$var$AsyncIssueAppComponent.preload(),
    pageLoad: (viewModeToPreload)=>{
        // issue view that opens as a modal
        if (viewModeToPreload === 'MODAL' || viewModeToPreload === 'DEFAULT') {
            $5a7a9947a97daa9e$var$IssueModal.preload();
            $5a7a9947a97daa9e$var$IssueModalContents.preload();
        }
        // issue view that opens as a side panel
        if (viewModeToPreload === 'SIDEBAR') $5a7a9947a97daa9e$var$AsyncIssueAppComponent.preload();
    }
};

const $5a7a9947a97daa9e$var$PrefetchCBBResourcesComponent = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("eE9CW")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/prefetch-wrm-bundle/index.tsx"
});
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
if (!false && window.SPA_STATE?.serverIssuePreload) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly fullPage: () => Promise<typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/spa-apps/issue/src/index")>; readonly embedded: () => Promise<...>; }'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const importSupplier = $5a7a9947a97daa9e$var$imports[window.SPA_STATE.serverIssuePreload];
    importSupplier && importSupplier();
}
const $5a7a9947a97daa9e$var$ISSUE_PRELOAD_COMPONENT_MARK = 'IssuePreloadComponent:rendered';
const $5a7a9947a97daa9e$var$useParamsSelector = (0, $kfvK2.createRouterSelector)((state)=>({
        query: state.query,
        params: state.match.params
    }));
const $5a7a9947a97daa9e$var$IssuePreloadComponentBuilder = (identifier, preloadSupplier, preloadContract)=>()=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { query: query, params: params } = $5a7a9947a97daa9e$var$useParamsSelector();
        if (// If we have an undefined contract, assume we want to preload
        !preloadContract || // Preload if we match the contract
        preloadContract.some((preloadingMatch)=>// Match query with router function
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            (!preloadingMatch.query || (0, $fKdol.default)(preloadingMatch.query, query)) && // Match path params with simple object structure, where if value is undefined
            // we assume we match all values
            (!preloadingMatch.params || preloadingMatch.params.every(({ key: key, value: value })=>params && params[key] !== undefined && (value === undefined || params[key] === value))))) {
            if (!false) preloadSupplier();
            if (false) (0, $1VofM.setServerEvaluatedIssuePreload)(identifier);
            else performance.mark($5a7a9947a97daa9e$var$ISSUE_PRELOAD_COMPONENT_MARK);
        }
        return null;
    };
const $5a7a9947a97daa9e$var$FullPageIssuePreloadComponent = $5a7a9947a97daa9e$var$IssuePreloadComponentBuilder('fullPage', $5a7a9947a97daa9e$var$imports.fullPage);
$5a7a9947a97daa9e$var$FullPageIssuePreloadComponent.displayName = 'FullPageIssuePreloadComponent';
const $5a7a9947a97daa9e$export$98e337c40eb151da = (0, $6dwgv.createLayout)({
    globalComponents: [
        $5a7a9947a97daa9e$var$FullPageIssuePreloadComponent,
        $5a7a9947a97daa9e$var$PrefetchCBBResourcesComponent
    ]
});
const $5a7a9947a97daa9e$export$7b113174a456921a = (preloadContract)=>{
    const EmbeddedIssuePreloadComponent = $5a7a9947a97daa9e$var$IssuePreloadComponentBuilder('embedded', $5a7a9947a97daa9e$var$imports.embedded, preloadContract);
    EmbeddedIssuePreloadComponent.displayName = 'EmbeddedIssuePreloadComponent';
    return (0, $6dwgv.createLayout)({
        globalComponents: [
            EmbeddedIssuePreloadComponent
        ]
    });
};
const $5a7a9947a97daa9e$export$682dcbf7cc80ba11 = (preloadContract, viewModeToPreload)=>{
    const PageLoadIssuePreloadComponent = $5a7a9947a97daa9e$var$IssuePreloadComponentBuilder('pageLoad', ()=>$5a7a9947a97daa9e$var$imports.pageLoad(viewModeToPreload || 'DEFAULT'), preloadContract);
    PageLoadIssuePreloadComponent.displayName = 'PageLoadIssuePreloadComponent';
    return (0, $6dwgv.createLayout)({
        globalComponents: [
            PageLoadIssuePreloadComponent
        ]
    });
};

});
parcelRegister("1VofM", function(module, exports) {

$parcel$export(module.exports, "setServerEvaluatedIssuePreload", () => $7af7e490b4f39bb6$export$d2077b3b0eac1c19);
/* eslint-disable jira/filename-case */ // We can start the evaluation at module level if we ran the component in SSR
// This needs to be an empty string because the router breaks if it's null or undefined
let $7af7e490b4f39bb6$var$serverIssuePreloadIdentifier = '';
const $7af7e490b4f39bb6$export$d2077b3b0eac1c19 = (identifier)=>{
    $7af7e490b4f39bb6$var$serverIssuePreloadIdentifier = identifier;
};
const $7af7e490b4f39bb6$export$f55e6973062dc859 = ()=>$7af7e490b4f39bb6$var$serverIssuePreloadIdentifier;

});

parcelRegister("zlPMC", function(module, exports) {

let $06a434d1a13db88a$var$load = (parcelRequire("gLHA4"))(4);



















module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $06a434d1a13db88a$var$load("99OSb")
                ]);
            }, function() {
                return Promise.all([
                    $06a434d1a13db88a$var$load("f87QN")
                ]);
            }),
            $06a434d1a13db88a$var$load("9yBEJ"),
            $06a434d1a13db88a$var$load("k4gbU")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $06a434d1a13db88a$var$load("99OSb")
                ]);
            }, function() {
                return Promise.all([
                    $06a434d1a13db88a$var$load("f87QN")
                ]);
            }),
            $06a434d1a13db88a$var$load("johxW"),
            $06a434d1a13db88a$var$load("k4gbU")
        ]);
    }),
    (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("esKGV")
        ]);
    }, function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("7uqQP")
        ]);
    }),
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("99OSb")
        ]);
    }, function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("f87QN")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("82rO4"),
            $06a434d1a13db88a$var$load("bABhq"),
            $06a434d1a13db88a$var$load("1VRB2"),
            $06a434d1a13db88a$var$load("1Y4bq"),
            $06a434d1a13db88a$var$load("7vqGd"),
            $06a434d1a13db88a$var$load("k4gbU"),
            $06a434d1a13db88a$var$load("eDzss")
        ]);
    }, function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("gKoqO"),
            $06a434d1a13db88a$var$load("bABhq"),
            $06a434d1a13db88a$var$load("1VRB2"),
            $06a434d1a13db88a$var$load("1Y4bq"),
            $06a434d1a13db88a$var$load("7vqGd"),
            $06a434d1a13db88a$var$load("k4gbU"),
            $06a434d1a13db88a$var$load("eDzss")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("3PYxn"),
            $06a434d1a13db88a$var$load("hwlgY")
        ]);
    }, function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("bfWTA")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20455-dev-panel-to-sync', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
                return Promise.all([
                    $06a434d1a13db88a$var$load("lEpSD")
                ]);
            }, function() {
                return Promise.all([]);
            }),
            (parcelRequire("g81qY"))('create-branch-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $06a434d1a13db88a$var$load("durhZ")
                ]);
            }, function() {
                return Promise.all([
                    $06a434d1a13db88a$var$load("c6ADg")
                ]);
            }),
            (parcelRequire("g81qY"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $06a434d1a13db88a$var$load("3aKV8")
                ]);
            }, function() {
                return Promise.all([
                    $06a434d1a13db88a$var$load("loy87")
                ]);
            }),
            (parcelRequire("g81qY"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $06a434d1a13db88a$var$load("3aKV8")
                ]);
            }, function() {
                return Promise.all([
                    $06a434d1a13db88a$var$load("loy87")
                ]);
            }),
            $06a434d1a13db88a$var$load("7ZkSO"),
            $06a434d1a13db88a$var$load("bABhq"),
            $06a434d1a13db88a$var$load("1VRB2")
        ]);
    }, function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("94VcJ")
        ]);
    }),
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_fg', function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("fXvbR")
        ]);
    }, function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("ljXya")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("4Krss")
        ]);
    }),
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("p5whz"),
            $06a434d1a13db88a$var$load("1Y4bq"),
            $06a434d1a13db88a$var$load("7vqGd")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
                return Promise.all([
                    $06a434d1a13db88a$var$load("1o7PN")
                ]);
            }, function() {
                return Promise.all([
                    $06a434d1a13db88a$var$load("17HeK"),
                    $06a434d1a13db88a$var$load("hwlgY")
                ]);
            }),
            $06a434d1a13db88a$var$load("ec3Qz"),
            $06a434d1a13db88a$var$load("1Y4bq"),
            $06a434d1a13db88a$var$load("7vqGd")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("4Krss")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $06a434d1a13db88a$var$load("4Krss")
        ]);
    }),
    $06a434d1a13db88a$var$load("4v8VH"),
    $06a434d1a13db88a$var$load("fh2Sv"),
    $06a434d1a13db88a$var$load("fAbxa"),
    $06a434d1a13db88a$var$load("fMOSo"),
    $06a434d1a13db88a$var$load("jhiae"),
    $06a434d1a13db88a$var$load("eDzss"),
    $06a434d1a13db88a$var$load("hwlgY"),
    $06a434d1a13db88a$var$load("1VRB2"),
    $06a434d1a13db88a$var$load("bABhq"),
    $06a434d1a13db88a$var$load("k4gbU"),
    $06a434d1a13db88a$var$load("7vqGd"),
    $06a434d1a13db88a$var$load("1Y4bq"),
    $06a434d1a13db88a$var$load("jkibY")
]).then(()=>parcelRequire('kq6nk'));

});

parcelRegister("1ezJg", function(module, exports) {

let $0e62d047b52c6bf1$var$load = (parcelRequire("gLHA4"))(4);




module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $0e62d047b52c6bf1$var$load("99OSb")
                ]);
            }, function() {
                return Promise.all([
                    $0e62d047b52c6bf1$var$load("f87QN")
                ]);
            }),
            $0e62d047b52c6bf1$var$load("9yBEJ"),
            $0e62d047b52c6bf1$var$load("k4gbU")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $0e62d047b52c6bf1$var$load("99OSb")
                ]);
            }, function() {
                return Promise.all([
                    $0e62d047b52c6bf1$var$load("f87QN")
                ]);
            }),
            $0e62d047b52c6bf1$var$load("johxW"),
            $0e62d047b52c6bf1$var$load("k4gbU")
        ]);
    }),
    (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $0e62d047b52c6bf1$var$load("esKGV")
        ]);
    }, function() {
        return Promise.all([
            $0e62d047b52c6bf1$var$load("7uqQP")
        ]);
    }),
    $0e62d047b52c6bf1$var$load("1VRB2"),
    $0e62d047b52c6bf1$var$load("bABhq"),
    $0e62d047b52c6bf1$var$load("bMujq")
]).then(()=>parcelRequire('igA3X'));

});

parcelRegister("9Ci5H", function(module, exports) {

let $01ce8b2198857559$var$load = (parcelRequire("gLHA4"))(4);















module.exports = Promise.all([
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $01ce8b2198857559$var$load("99OSb")
        ]);
    }, function() {
        return Promise.all([
            $01ce8b2198857559$var$load("f87QN")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $01ce8b2198857559$var$load("82rO4"),
            $01ce8b2198857559$var$load("bABhq"),
            $01ce8b2198857559$var$load("1VRB2"),
            $01ce8b2198857559$var$load("1Y4bq"),
            $01ce8b2198857559$var$load("7vqGd"),
            $01ce8b2198857559$var$load("k4gbU"),
            $01ce8b2198857559$var$load("eDzss")
        ]);
    }, function() {
        return Promise.all([
            $01ce8b2198857559$var$load("gKoqO"),
            $01ce8b2198857559$var$load("bABhq"),
            $01ce8b2198857559$var$load("1VRB2"),
            $01ce8b2198857559$var$load("1Y4bq"),
            $01ce8b2198857559$var$load("7vqGd"),
            $01ce8b2198857559$var$load("k4gbU"),
            $01ce8b2198857559$var$load("eDzss")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $01ce8b2198857559$var$load("3PYxn"),
            $01ce8b2198857559$var$load("hwlgY")
        ]);
    }, function() {
        return Promise.all([
            $01ce8b2198857559$var$load("bfWTA")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20455-dev-panel-to-sync', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
                return Promise.all([
                    $01ce8b2198857559$var$load("lEpSD")
                ]);
            }, function() {
                return Promise.all([]);
            }),
            (parcelRequire("g81qY"))('create-branch-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $01ce8b2198857559$var$load("durhZ")
                ]);
            }, function() {
                return Promise.all([
                    $01ce8b2198857559$var$load("c6ADg")
                ]);
            }),
            (parcelRequire("g81qY"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $01ce8b2198857559$var$load("3aKV8")
                ]);
            }, function() {
                return Promise.all([
                    $01ce8b2198857559$var$load("loy87")
                ]);
            }),
            (parcelRequire("g81qY"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $01ce8b2198857559$var$load("3aKV8")
                ]);
            }, function() {
                return Promise.all([
                    $01ce8b2198857559$var$load("loy87")
                ]);
            }),
            $01ce8b2198857559$var$load("7ZkSO"),
            $01ce8b2198857559$var$load("bABhq"),
            $01ce8b2198857559$var$load("1VRB2")
        ]);
    }, function() {
        return Promise.all([
            $01ce8b2198857559$var$load("94VcJ")
        ]);
    }),
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $01ce8b2198857559$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $01ce8b2198857559$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_fg', function() {
        return Promise.all([
            $01ce8b2198857559$var$load("fXvbR")
        ]);
    }, function() {
        return Promise.all([
            $01ce8b2198857559$var$load("ljXya")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $01ce8b2198857559$var$load("4Krss")
        ]);
    }),
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $01ce8b2198857559$var$load("p5whz"),
            $01ce8b2198857559$var$load("1Y4bq"),
            $01ce8b2198857559$var$load("7vqGd")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
                return Promise.all([
                    $01ce8b2198857559$var$load("1o7PN")
                ]);
            }, function() {
                return Promise.all([
                    $01ce8b2198857559$var$load("17HeK"),
                    $01ce8b2198857559$var$load("hwlgY")
                ]);
            }),
            $01ce8b2198857559$var$load("ec3Qz"),
            $01ce8b2198857559$var$load("1Y4bq"),
            $01ce8b2198857559$var$load("7vqGd")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $01ce8b2198857559$var$load("4Krss")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $01ce8b2198857559$var$load("4Krss")
        ]);
    }),
    $01ce8b2198857559$var$load("fAbxa"),
    $01ce8b2198857559$var$load("fMOSo"),
    $01ce8b2198857559$var$load("jhiae"),
    $01ce8b2198857559$var$load("eDzss"),
    $01ce8b2198857559$var$load("4v8VH"),
    $01ce8b2198857559$var$load("fh2Sv"),
    $01ce8b2198857559$var$load("hwlgY"),
    $01ce8b2198857559$var$load("1VRB2"),
    $01ce8b2198857559$var$load("bABhq"),
    $01ce8b2198857559$var$load("7vqGd"),
    $01ce8b2198857559$var$load("1Y4bq"),
    $01ce8b2198857559$var$load("k4gbU"),
    $01ce8b2198857559$var$load("i7rUb")
]).then(()=>parcelRequire('hSwWh'));

});

parcelRegister("eE9CW", function(module, exports) {

let $aa9c44d682630d2f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $aa9c44d682630d2f$var$load("9Iee3").then(()=>parcelRequire('3Eb0P'));

});


/**
 * @deprecated sharing routes between products leads to over-fetching resources. Please define
 * routes per-product and only define the resources + navigation components required for that product instead.
 */ const $aa97a50ba70be130$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $aa97a50ba70be130$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';

parcelRegister("aDtWM", function(module, exports) {

$parcel$export(module.exports, "genericProjectSidebars", () => $2441c7e576639e68$export$d88d2d25355bc89a);
$parcel$export(module.exports, "classicBoardSidebars", () => $2441c7e576639e68$export$c04daf123cec1f1e);
$parcel$export(module.exports, "genericConnectSidebars", () => $2441c7e576639e68$export$844d342b575ead35);

var $7zL9d = parcelRequire("7zL9d");

var $hiOwQ = parcelRequire("hiOwQ");

var $gKFn0 = parcelRequire("gKFn0");

var $2nHUF = parcelRequire("2nHUF");

var $gHEJe = parcelRequire("gHEJe");

var $1f2LE = parcelRequire("1f2LE");

var $k6duF = parcelRequire("k6duF");

var $3V6se = parcelRequire("3V6se");
const $2441c7e576639e68$export$d88d2d25355bc89a = [
    // delete when cleaning up getWillShowNav4
    (0, $hiOwQ.default),
    (0, $gHEJe.default),
    (0, $1f2LE.default),
    (0, $k6duF.default),
    (0, $3V6se.default)
];
const $2441c7e576639e68$export$c04daf123cec1f1e = [
    (0, $k6duF.default),
    (0, $3V6se.default)
];
const $2441c7e576639e68$export$844d342b575ead35 = [
    ...$2441c7e576639e68$export$d88d2d25355bc89a,
    (0, $7zL9d.default),
    (0, $gKFn0.default),
    (0, $2nHUF.default)
];

});
parcelRegister("7zL9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5ca43a7cc265a55$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $d5ca43a7cc265a55$var$LazyConnectSidebar = (0, $gzcjr.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("b5B3F")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
});
const $d5ca43a7cc265a55$var$ConnectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "connect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d5ca43a7cc265a55$var$LazyConnectSidebar, null)));
$d5ca43a7cc265a55$var$ConnectSidebar.displayName = 'ConnectSidebar';
var $d5ca43a7cc265a55$export$2e2bcd8739ae039 = $d5ca43a7cc265a55$var$ConnectSidebar;

});
parcelRegister("b5B3F", function(module, exports) {

let $02155e95f84bb2a6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $02155e95f84bb2a6$var$load("1VRB2"),
    $02155e95f84bb2a6$var$load("bABhq"),
    $02155e95f84bb2a6$var$load("7zYGG")
]).then(()=>parcelRequire('9zsf7'));

});


parcelRegister("3V6se", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3a532df6c151ee1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $a3a532df6c151ee1$var$LazyUserSidebar = (0, $gzcjr.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("1Dupo")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
});
const $a3a532df6c151ee1$var$UserSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3a532df6c151ee1$var$LazyUserSidebar, null)));
$a3a532df6c151ee1$var$UserSidebar.displayName = 'UserSidebar';
var $a3a532df6c151ee1$export$2e2bcd8739ae039 = $a3a532df6c151ee1$var$UserSidebar;

});
parcelRegister("1Dupo", function(module, exports) {

let $1311057ccad1bfe5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1311057ccad1bfe5$var$load("hwlgY"),
    $1311057ccad1bfe5$var$load("1VRB2"),
    $1311057ccad1bfe5$var$load("bABhq"),
    $1311057ccad1bfe5$var$load("7vqGd"),
    $1311057ccad1bfe5$var$load("1Y4bq"),
    $1311057ccad1bfe5$var$load("8oIfu")
]).then(()=>parcelRequire('2uIzr'));

});



parcelRegister("5N1SB", function(module, exports) {

$parcel$export(module.exports, "getOfferingCatalogueFeaturesResource", () => $5c6a39299c71dc02$export$d08a9fee651d30b2);

var $l1VxS = parcelRequire("l1VxS");


const $5c6a39299c71dc02$var$getDataLoader = ()=>(parcelRequire("imIdf"));
const $5c6a39299c71dc02$export$ec991c565cf31550 = (0, $l1VxS.createResource)({
    type: (0, $b9e6117892e37693$export$23978b67a6b2068f),
    getKey: ()=>'state',
    getDataLoader: $5c6a39299c71dc02$var$getDataLoader,
    maxAge: 1800000
});
const $5c6a39299c71dc02$export$d08a9fee651d30b2 = ()=>[];

});
const $b9e6117892e37693$export$23978b67a6b2068f = 'RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES';

parcelRegister("imIdf", function(module, exports) {

let $d5ec93c9388e1cbf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d5ec93c9388e1cbf$var$load("11LOM").then(()=>parcelRequire('AFoLQ'));

});


parcelRegister("iBSnt", function(module, exports) {

$parcel$export(module.exports, "browseIssueRoute", () => $c940aca0110ccf9d$export$2c9c7e50a88e588b);
const $c940aca0110ccf9d$export$2c9c7e50a88e588b = {
    name: 'issue',
    path: '/browse/:issueKey(\\w+-\\d+)(.*)?',
    query: [
        'filter?!=(.*)',
        'jql?!=(.*)'
    ]
};

});


parcelRegister("XhYcm", function(module, exports) {

$parcel$export(module.exports, "browseProjectRedirectRouteEntry", () => $95c7eb7b4bd8a104$export$f9891419b34ab305);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $aGQ56 = parcelRequire("aGQ56");

var $d3wpJ = parcelRequire("d3wpJ");

var $hoV2u = parcelRequire("hoV2u");
const $95c7eb7b4bd8a104$export$f9891419b34ab305 = (0, $6xToB.createEntry)((0, $d3wpJ.browseProjectRedirectRoute), ()=>({
        group: 'redirects',
        isRedirect: true,
        component: (0, $hoV2u.RedirectToLastVisitedProjectPage),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $aGQ56.queuesNavigationItems),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("d3wpJ", function(module, exports) {

$parcel$export(module.exports, "browseProjectRedirectRoute", () => $5b577f32c2c2e49a$export$f9cac37753487f39);
const $5b577f32c2c2e49a$export$f9cac37753487f39 = {
    name: 'browse-project-redirect',
    path: "/browse/:projectKey([0-9a-zA-Z_$.+!*']+)",
    exact: true
};

});

parcelRegister("hoV2u", function(module, exports) {

$parcel$export(module.exports, "RedirectToLastVisitedProjectPage", () => $40ea509ff5827a8e$export$86041af020f4c959);

var $eJOHy = parcelRequire("eJOHy");

var $gRw5p = parcelRequire("gRw5p");
const $40ea509ff5827a8e$export$86041af020f4c959 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gRw5p.default), null);

});
parcelRegister("gRw5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff232445e6bd88e3$export$2e2bcd8739ae039);

var $jJaSe = parcelRequire("jJaSe");

var $ddFsg = parcelRequire("ddFsg");
var $ff232445e6bd88e3$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)((0, $ddFsg.default));

});
parcelRegister("ddFsg", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f73f830b21aa26d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $b5RwB = parcelRequire("b5RwB");

var $h1VbR = parcelRequire("h1VbR");

var $cJAh3 = parcelRequire("cJAh3");

var $662Y6 = parcelRequire("662Y6");

var $aYncF = parcelRequire("aYncF");

var $eSnSE = parcelRequire("eSnSE");

var $1Ozm9 = parcelRequire("1Ozm9");

var $7jTnu = parcelRequire("7jTnu");


var $jwGf7 = parcelRequire("jwGf7");
const $0f73f830b21aa26d$var$buildEndpoint = (projectKey, initialRedirect)=>`/rest/internal/2/projectlandingpage/${projectKey}${initialRedirect ? '?initialRedirect=true' : ''}`;
const $0f73f830b21aa26d$var$allowListedSearchParams = [
    (0, $4b966049ad0c2037$export$29d3926e3d72cfb),
    (0, $4b966049ad0c2037$export$b3233b76460c1e7c)
];
const $0f73f830b21aa26d$var$redirectForAnonymousUser = (projectKey, history, startTime)=>{
    const destination = `/projects/${projectKey}/${(0, $7jTnu.fg)('jira_list_nin_merge') ? 'list' : 'issues'}/?filter=allissues`;
    history.replace(destination);
    // Log success
    (0, $eSnSE.default).safeInfoWithoutCustomerData((0, $4b966049ad0c2037$export$25a759e49d5049db), 'History replace correctly triggered for anonymous user', {
        requestTime: (0, $jwGf7.getNow)() - startTime,
        destination: destination
    });
};
const $0f73f830b21aa26d$export$c79af62ad7a1fe8a = (query)=>Object.fromEntries(Object.entries(query).filter(([key])=>$0f73f830b21aa26d$var$allowListedSearchParams.some((allowedParam)=>key === allowedParam) || key.includes((0, $4b966049ad0c2037$export$29d3926e3d72cfb))));
const $0f73f830b21aa26d$export$283f1587d7a5369f = (searchQuery, queryInitializer)=>{
    const queryKeys = new URLSearchParams(searchQuery).toString();
    return queryKeys.length > 0 ? `${queryInitializer}${queryKeys}` : '';
};
class $0f73f830b21aa26d$export$bf8d1fdc3b47a835 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { history: history, location: location, query: query, match: { params: params } } = this.props;
        // First time a project is created
        const { initial: initial } = query;
        // Clear the SSR Ready Mark if present
        (0, $662Y6.default)((0, $cJAh3.SPA_SSR_RENDERED_MARK));
        const startTime = (0, $jwGf7.getNow)();
        const projectKey = // @ts-expect-error - TS2345 - Argument of type 'string | {}' is not assignable to parameter of type 'string'.
        params.projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse((0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(location, 'search', {})).projectKey;
        if (!params.projectKey) (0, $eSnSE.default).safeInfoWithoutCustomerData((0, $4b966049ad0c2037$export$25a759e49d5049db), 'queryString', {
            duration: (0, $jwGf7.getNow)() - startTime
        });
        if (projectKey) (0, $1Ozm9.default)($0f73f830b21aa26d$var$buildEndpoint(projectKey, !!initial)).then((response)=>{
            const endTime = (0, $jwGf7.getNow)();
            let searchQueryParams = '';
            const searchQuery = $0f73f830b21aa26d$export$c79af62ad7a1fe8a(query);
            const queryInitializer = response.data.url.includes('?') ? '&' : '?';
            searchQueryParams = $0f73f830b21aa26d$export$283f1587d7a5369f(searchQuery, queryInitializer);
            const destination = response.data.url + searchQueryParams;
            history.replace(destination);
            // Log success
            (0, $eSnSE.default).safeInfoWithoutCustomerData((0, $4b966049ad0c2037$export$25a759e49d5049db), 'History replace correctly triggered', {
                requestTime: endTime - startTime,
                destination: destination
            });
        }, (error)=>{
            const endTime = (0, $jwGf7.getNow)();
            if ((0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)().isAnonymous) $0f73f830b21aa26d$var$redirectForAnonymousUser(projectKey, history, startTime);
            else // Log failures
            (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $4b966049ad0c2037$export$25a759e49d5049db), `Error on request. Request time: ${endTime - startTime}`, error);
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1VbR.default), {
            name: "last-visited-project-page-redirect"
        });
    }
}
var $0f73f830b21aa26d$export$2e2bcd8739ae039 = $0f73f830b21aa26d$export$bf8d1fdc3b47a835;

});
const $4b966049ad0c2037$export$25a759e49d5049db = 'spa-apps.common.redirect.last-visited-project-page';
const $4b966049ad0c2037$export$29d3926e3d72cfb = 'search';
const $4b966049ad0c2037$export$b3233b76460c1e7c = 'showProjectBuilder';

parcelRegister("jwGf7", function(module, exports) {

$parcel$export(module.exports, "getNow", () => $9dd4f64bbee985ad$export$3991332aae1fc754);
const $9dd4f64bbee985ad$export$3991332aae1fc754 = ()=>Date.now();

});





parcelRegister("4OGAK", function(module, exports) {

$parcel$export(module.exports, "browseStandardFlowsRouteEntry", () => $7a43dbcf0e5e3085$export$6a572c5bc9ffe9da);

var $igNUx = parcelRequire("igNUx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $3EnHO = parcelRequire("3EnHO");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $eISG1 = parcelRequire("eISG1");

var $eVtuK = parcelRequire("eVtuK");

var $g8uYY = parcelRequire("g8uYY");

var $cAYFR = parcelRequire("cAYFR");
const $7a43dbcf0e5e3085$var$browseStandardFlowsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $eVtuK.browseStandardFlowsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $7a43dbcf0e5e3085$export$6a572c5bc9ffe9da = (0, $6xToB.createEntry)((0, $3EnHO.browseStandardFlowsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $igNUx.isFedRamp)()) return undefined;
            return $7a43dbcf0e5e3085$var$browseStandardFlowsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $eISG1.VirtualAgentBrowseStandardFlowsSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("eISG1", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentBrowseStandardFlowsSkeleton", () => $66ba91899626e548$export$c2bd83dd149452bd);
/* VirtualAgentBrowseStandardFlowsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $2saIJ = parcelRequire("2saIJ");
const $66ba91899626e548$var$customCssStyles = null;
const $66ba91899626e548$export$c2bd83dd149452bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2saIJ))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("2saIJ", function(module, exports) {
module.exports = new URL("virtual-agent-browse-standard-flows-app-skeleton.tpl.51e6e95a.svg", import.meta.url).toString();

});


parcelRegister("eVtuK", function(module, exports) {

$parcel$export(module.exports, "browseStandardFlowsEntryPoint", () => $ad83053115311bde$export$f7de8593c7455f1);

var $iTAfj = parcelRequire("iTAfj");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $ad83053115311bde$export$f7de8593c7455f1 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("du5as")), {
        moduleId: "c2d13204",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $iTAfj.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("iTAfj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d4b43bb77bee20b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<33233bbde56426b21cb0cf7548a863c8>>
 * @relayHash 8658a1d9e0b503030f122af7546f7fa3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b2740e61056af93841794a91099e9b96903f93d7fe50bb2475c769a63f9f5288

var $bXR9c = parcelRequire("bXR9c");
const $0d4b43bb77bee20b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b2740e61056af93841794a91099e9b96903f93d7fe50bb2475c769a63f9f5288",
        "metadata": {},
        "name": "srcVirtualAgentBrowseStandardFlowsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $0d4b43bb77bee20b$export$2e2bcd8739ae039 = $0d4b43bb77bee20b$var$node;

});

parcelRegister("du5as", function(module, exports) {

let $9d1215e1cf5adfc7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9d1215e1cf5adfc7$var$load("kYNbf").then(()=>parcelRequire('gWoku'));

});



parcelRegister("5wrsY", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewCalendarRouteEntry", () => $fb28cd738dfd724d$export$93f05037a457ce22);

var $gYW18 = parcelRequire("gYW18");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $eOm20 = parcelRequire("eOm20");

var $g8uYY = parcelRequire("g8uYY");

var $79780 = parcelRequire("79780");
const $fb28cd738dfd724d$var$overviewCalendarPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $79780.overviewCalendarEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $fb28cd738dfd724d$export$93f05037a457ce22 = (0, $6xToB.createEntry)((0, $eOm20.classicBusinessOverviewCalendarRoute), ()=>({
        group: 'classic-business',
        layout: (0, $7h3uc.globalLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $gYW18.AsyncHorizontalOverviewNav)
        },
        resources: (0, $kRv8K.getOverviewViewResources)(),
        entryPoint: ()=>$fb28cd738dfd724d$var$overviewCalendarPageEntrypoint
    }));

});
parcelRegister("kNM5Y", function(module, exports) {

$parcel$export(module.exports, "ThemedLazySkeleton", () => $ec1b330c87eff4aa$export$ddeb5d943c4f17e3);
/* ThemedLazySkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $h1VbR = parcelRequire("h1VbR");

var $5W8uM = parcelRequire("5W8uM");
const $ec1b330c87eff4aa$export$ddeb5d943c4f17e3 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec1b330c87eff4aa$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1VbR.default), {
        name: "themed-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5W8uM.ThemedSpinner), null))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ec1b330c87eff4aa$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5W8uM", function(module, exports) {

$parcel$export(module.exports, "ThemedSpinner", () => $c8343f1bb6fa5b40$export$271c7b154ad6c401);
/* ThemedSpinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dPlS8 = parcelRequire("dPlS8");
const $c8343f1bb6fa5b40$export$271c7b154ad6c401 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c8343f1bb6fa5b40$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPlS8.default), {
        size: "large",
        ...props,
        testId: "project-theme-components.ui.themed-spinner"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c8343f1bb6fa5b40$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1xjgvy9e",
            __cmplp.className
        ])
    });
});

});


parcelRegister("eOm20", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewCalendarRoute", () => $ef2c059f9016923a$export$61383e5418d2ffe3);
const $ef2c059f9016923a$export$61383e5418d2ffe3 = {
    name: 'classic-business-overview-calendar',
    path: '/jira/core/overviews/:overviewId/calendar',
    exact: true
};

});

parcelRegister("79780", function(module, exports) {

$parcel$export(module.exports, "overviewCalendarEntrypoint", () => $39dc7de5f53ab200$export$b7094a9bdb66fbad);

var $j3Ybe = parcelRequire("j3Ybe");

var $1XFDQ = parcelRequire("1XFDQ");

var $4BK1O = parcelRequire("4BK1O");

const $39dc7de5f53ab200$export$b7094a9bdb66fbad = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("gH3wb")), {
        moduleId: "a9cf6a8e",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>{
        return {
            queries: {
                overviewCalendarQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $1XFDQ.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("1XFDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $80276688aa16f701$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e514564c1688822aea8c6efba8699694>>
 * @relayHash 466f1e55c408e59be27b44b8156f9147
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 82d517df2c5a9cef088b63278282f98c94356907ff3ba4c909173bfd3d9477f7
const $80276688aa16f701$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "82d517df2c5a9cef088b63278282f98c94356907ff3ba4c909173bfd3d9477f7",
        "metadata": {},
        "name": "src_jiraBusinessOverviewCalendarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $80276688aa16f701$export$2e2bcd8739ae039 = $80276688aa16f701$var$node;

});

parcelRegister("gH3wb", function(module, exports) {

let $c2736417e3eecc2e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $c2736417e3eecc2e$var$load("1VRB2"),
    $c2736417e3eecc2e$var$load("bABhq"),
    $c2736417e3eecc2e$var$load("7vqGd"),
    $c2736417e3eecc2e$var$load("1Y4bq"),
    $c2736417e3eecc2e$var$load("bm8vd")
]).then(()=>parcelRequire('dlAu1'));

});



parcelRegister("e2Odp", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewSummaryRouteEntry", () => $3bece96b55464b81$export$f8fd32e123428b9a);

var $gYW18 = parcelRequire("gYW18");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $2OYGO = parcelRequire("2OYGO");

var $g8uYY = parcelRequire("g8uYY");

var $aRMaG = parcelRequire("aRMaG");
const $3bece96b55464b81$var$overviewSummaryPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $aRMaG.overviewSummaryEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $3bece96b55464b81$export$f8fd32e123428b9a = (0, $6xToB.createEntry)((0, $2OYGO.classicBusinessOverviewSummaryRoute), ()=>({
        group: 'classic-business',
        layout: (0, $7h3uc.globalLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $gYW18.AsyncHorizontalOverviewNav)
        },
        resources: (0, $kRv8K.getOverviewViewResources)(),
        entryPoint: ()=>$3bece96b55464b81$var$overviewSummaryPageEntrypoint
    }));

});
parcelRegister("2OYGO", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewSummaryRoute", () => $117c4ec1004ed79c$export$4a86e6b12ce49af9);
const $117c4ec1004ed79c$export$4a86e6b12ce49af9 = {
    name: 'classic-business-overview-summary',
    path: '/jira/core/overviews/:overviewId/summary',
    exact: true
};

});

parcelRegister("aRMaG", function(module, exports) {

$parcel$export(module.exports, "overviewSummaryEntrypoint", () => $e51790e51bf8df9e$export$3793bbcc33b62692);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $e51790e51bf8df9e$export$3793bbcc33b62692 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("2Sy7n")), {
        moduleId: "5d9f07b1",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2Sy7n", function(module, exports) {

let $218b170b3356c782$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $218b170b3356c782$var$load("1VRB2"),
    $218b170b3356c782$var$load("bABhq"),
    $218b170b3356c782$var$load("6ww0T")
]).then(()=>parcelRequire('3Ehcx'));

});



parcelRegister("djb2Z", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewTimelineRouteEntry", () => $7c693fbc4b9d58b9$export$9d9d562e489097b3);

var $gYW18 = parcelRequire("gYW18");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $2LUyM = parcelRequire("2LUyM");

var $g8uYY = parcelRequire("g8uYY");

var $42uQ3 = parcelRequire("42uQ3");
const $7c693fbc4b9d58b9$var$overviewTimelinePageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $42uQ3.overviewTimelineEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $7c693fbc4b9d58b9$export$9d9d562e489097b3 = (0, $6xToB.createEntry)((0, $2LUyM.classicBusinessOverviewTimelineRoute), ()=>({
        group: 'classic-business',
        layout: (0, $7h3uc.globalLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $gYW18.AsyncHorizontalOverviewNav)
        },
        resources: (0, $kRv8K.getOverviewViewResources)(),
        entryPoint: ()=>$7c693fbc4b9d58b9$var$overviewTimelinePageEntrypoint
    }));

});
parcelRegister("2LUyM", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewTimelineRoute", () => $175c945c42633bbd$export$13f0c823ff3059c2);
const $175c945c42633bbd$export$13f0c823ff3059c2 = {
    name: 'classic-business-overview-timeline',
    path: '/jira/core/overviews/:overviewId/timeline',
    exact: true
};

});

parcelRegister("42uQ3", function(module, exports) {

$parcel$export(module.exports, "overviewTimelineEntrypoint", () => $4bb940a33304beb0$export$d00505893f9d5d11);

var $j3Ybe = parcelRequire("j3Ybe");

var $1LpQp = parcelRequire("1LpQp");

var $4BK1O = parcelRequire("4BK1O");

const $4bb940a33304beb0$export$d00505893f9d5d11 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("1GJ98")), {
        moduleId: "ae6650bb",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>{
        return {
            queries: {
                overviewTimelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $1LpQp.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("1LpQp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d79ea349716da08d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb4ae6aae065c938f532a846255332dc>>
 * @relayHash 007933a1073bb512097f0e95cf95622d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 554086782541cb72a7484650860ffea7ea940346b5eb77793d5681f9e287d807
const $d79ea349716da08d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "554086782541cb72a7484650860ffea7ea940346b5eb77793d5681f9e287d807",
        "metadata": {},
        "name": "src_jiraBusinessOverviewTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d79ea349716da08d$export$2e2bcd8739ae039 = $d79ea349716da08d$var$node;

});

parcelRegister("1GJ98", function(module, exports) {

let $13acbbd4c13b5038$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $13acbbd4c13b5038$var$load("1VRB2"),
    $13acbbd4c13b5038$var$load("bABhq"),
    $13acbbd4c13b5038$var$load("3hpSV")
]).then(()=>parcelRequire('bqTTp'));

});



parcelRegister("5xUFr", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectEmbedRouteEntry", () => $01226d0edbbe6b2a$export$99ff9a6f448db95c);

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $fXAjm = parcelRequire("fXAjm");

var $kWsG7 = parcelRequire("kWsG7");
const $01226d0edbbe6b2a$export$99ff9a6f448db95c = (0, $6xToB.createEntry)((0, $fXAjm.classicBusinessProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'classic-business',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        component: (0, $kWsG7.default),
        forPaint: [
            (0, $kWsG7.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("fXAjm", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectEmbedRoute", () => $27fe20fca7f8a858$export$92c0120052644a60);
const $27fe20fca7f8a858$export$92c0120052644a60 = {
    name: 'classic-business-proforma-issue-forms-direct-embed',
    path: '/jira/core/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});

parcelRegister("kWsG7", function(module, exports) {

$parcel$export(module.exports, "LazyProformaIssueFormsDirectEmbed", () => $96411853c866acc6$export$22681210aaeb910f);
$parcel$export(module.exports, "default", () => $96411853c866acc6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $96411853c866acc6$export$22681210aaeb910f = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("gcxyH")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$96411853c866acc6$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $96411853c866acc6$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });

});
parcelRegister("gcxyH", function(module, exports) {

let $bcb7cc60d463a56c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $bcb7cc60d463a56c$var$load("7vqGd"),
    $bcb7cc60d463a56c$var$load("1Y4bq"),
    $bcb7cc60d463a56c$var$load("gEr08")
]).then(()=>parcelRequire('3oO3p'));

});



parcelRegister("45FXR", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectRouteEntry", () => $84dab78aea9489c9$export$8aa48763ac761f64);

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $7Ypiw = parcelRequire("7Ypiw");

var $d017r = parcelRequire("d017r");
const $84dab78aea9489c9$export$8aa48763ac761f64 = (0, $6xToB.createEntry)((0, $7Ypiw.classicBusinessProformaIssueFormsDirectRoute), ()=>({
        group: 'classic-business',
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        entryPoint: ()=>(0, $d017r.proformaIssueFormsDirectPageEntryPoint),
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("7Ypiw", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectRoute", () => $6a9b89485b8d2901$export$97a413d49241d03b);
const $6a9b89485b8d2901$export$97a413d49241d03b = {
    name: 'classic-business-proforma-issue-forms-direct',
    path: '/jira/core/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});

parcelRegister("d017r", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsDirectPageEntryPoint", () => $fbe6c0c8c54a20c4$export$dc0bb5719ae7aab4);

var $cZ31R = parcelRequire("cZ31R");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");
const $fbe6c0c8c54a20c4$export$dc0bb5719ae7aab4 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cZ31R.proformaIssueFormsDirectEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("cZ31R", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsDirectEntryPoint", () => $0a4aa1cdbbc0e1e2$export$2a51bba458da5928);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $0a4aa1cdbbc0e1e2$export$2a51bba458da5928 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("9GEao")), {
        moduleId: "3047b51f",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9GEao", function(module, exports) {

let $70d7318e26a376c8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $70d7318e26a376c8$var$load("7vqGd"),
    $70d7318e26a376c8$var$load("1Y4bq"),
    $70d7318e26a376c8$var$load("b1H35")
]).then(()=>parcelRequire('fyq5j'));

});




parcelRegister("d5FsU", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectApprovalsRouteEntry", () => $97c9869878e57b7f$export$563b4fef899fe540);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $iOObx = parcelRequire("iOObx");

var $8cU7c = parcelRequire("8cU7c");
const $97c9869878e57b7f$export$563b4fef899fe540 = (0, $6xToB.createEntry)((0, $iOObx.classicBusinessProjectApprovalsRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.approvals-view',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>(0, $8cU7c.approvalsPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("9eXLI", function(module, exports) {

$parcel$export(module.exports, "businessProjectLayout", () => $a75bb44e672a49d0$export$dfb0c3e0348f4429);

var $ln6Iy = parcelRequire("ln6Iy");

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a75bb44e672a49d0$var$Onboarding = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("e72Ht")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/onboarding/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a75bb44e672a49d0$var$withAnyBusinessProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $ln6Iy.CORE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a75bb44e672a49d0$var$RightSidebars = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("1jM8G")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/right-sidebars/index.tsx"
});
const $a75bb44e672a49d0$var$BusinessOnboarding = $a75bb44e672a49d0$var$withAnyBusinessProjectContext($a75bb44e672a49d0$var$Onboarding);
const $a75bb44e672a49d0$var$nonSettingsRightSidebars = [
    $a75bb44e672a49d0$var$withAnyBusinessProjectContext($a75bb44e672a49d0$var$RightSidebars)
];
const $a75bb44e672a49d0$var$sharedBusinessProjectLayout = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout));
const $a75bb44e672a49d0$export$dfb0c3e0348f4429 = (0, $6dwgv.composeLayouts)($a75bb44e672a49d0$var$sharedBusinessProjectLayout, {
    rightSidebars: $a75bb44e672a49d0$var$nonSettingsRightSidebars,
    globalComponents: [
        $a75bb44e672a49d0$var$BusinessOnboarding
    ]
});

});
parcelRegister("e72Ht", function(module, exports) {

let $a463d05458d624cb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a463d05458d624cb$var$load("g68tM").then(()=>parcelRequire('kLLtw'));

});

parcelRegister("1jM8G", function(module, exports) {

let $0f5ce82e84f13253$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0f5ce82e84f13253$var$load("bYKmU").then(()=>parcelRequire('5w7vf'));

});


parcelRegister("iOObx", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectApprovalsRoute", () => $ed0e8d46d045ddef$export$3109a183a442a02d);
const $ed0e8d46d045ddef$export$3109a183a442a02d = {
    name: 'classic-business-approvals',
    path: '/jira/core/projects/:projectKey/approvals',
    exact: true
};

});

parcelRegister("8cU7c", function(module, exports) {

$parcel$export(module.exports, "approvalsPageEntryPoint", () => $5963acd66baa2380$export$52c40d37705be5fa);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $1EVxe = parcelRequire("1EVxe");

var $9n5I0 = parcelRequire("9n5I0");
const $5963acd66baa2380$export$52c40d37705be5fa = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1EVxe.approvalsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("1EVxe", function(module, exports) {

$parcel$export(module.exports, "approvalsEntryPoint", () => $85218c7331be8151$export$25d4a03de93a440e);

var $k56g6 = parcelRequire("k56g6");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $85218c7331be8151$export$25d4a03de93a440e = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("bauR7")), {
        moduleId: "6a9ba200",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                approvalsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $k56g6.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("k56g6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f89f660ffc3727a4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc6e2d903d7a5160ec3c02b7156848e4>>
 * @relayHash 2cc1b2be473185de0346970d79002539
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a7b24f841e6d55f0b788183900c0f5208b596d9f5efe804ede9c194b19f5e8d
const $f89f660ffc3727a4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2a7b24f841e6d55f0b788183900c0f5208b596d9f5efe804ede9c194b19f5e8d",
        "metadata": {},
        "name": "src_jiraBusinessApprovalsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $f89f660ffc3727a4$export$2e2bcd8739ae039 = $f89f660ffc3727a4$var$node;

});

parcelRegister("bauR7", function(module, exports) {

let $8218902f5a29d278$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8218902f5a29d278$var$load("g7Z3M").then(()=>parcelRequire('jLqzd'));

});




parcelRegister("7kn5P", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormBuilderRouteEntry", () => $772001a4b0ae12c3$export$9eb15893d080e73b);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $egjvs = parcelRequire("egjvs");

var $7OdQF = parcelRequire("7OdQF");
const $772001a4b0ae12c3$export$9eb15893d080e73b = (0, $6xToB.createEntry)((0, $egjvs.classicBusinessProjectFormBuilderRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-view',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>(0, $7OdQF.formBuilderPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("egjvs", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormBuilderRoute", () => $795ebdbfaac46826$export$5f684808e671de5);
const $795ebdbfaac46826$export$5f684808e671de5 = {
    name: 'classic-business-form-builder',
    path: '/jira/core/projects/:projectKey/form/:formId/builder',
    exact: true
};

});

parcelRegister("7OdQF", function(module, exports) {

$parcel$export(module.exports, "formBuilderPageEntrypoint", () => $558f9be903d7366a$export$e0f4bcb9440be5eb);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $72lHW = parcelRequire("72lHW");

var $9n5I0 = parcelRequire("9n5I0");
const $558f9be903d7366a$export$e0f4bcb9440be5eb = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $72lHW.formBuilderEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("72lHW", function(module, exports) {

$parcel$export(module.exports, "formBuilderEntrypoint", () => $7dc7812464505771$export$6d3c9fa7232f412c);

var $lPQ1p = parcelRequire("lPQ1p");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $7dc7812464505771$export$6d3c9fa7232f412c = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("feD18")), {
        moduleId: "86254720",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formBuilderQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $lPQ1p.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("lPQ1p", function(module, exports) {

$parcel$export(module.exports, "default", () => $de92a6254e122590$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f4e5285cf738fae5658c117e04609239>>
 * @relayHash d97c7a633d846788784b53e47412dba2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f1558c868f827e5a17035db5860c9c66151d5a49619d6606fa69856264023f5
const $de92a6254e122590$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4f1558c868f827e5a17035db5860c9c66151d5a49619d6606fa69856264023f5",
        "metadata": {},
        "name": "src_jiraBusinessFormBuilderQuery",
        "operationKind": "query",
        "text": null
    }
};
var $de92a6254e122590$export$2e2bcd8739ae039 = $de92a6254e122590$var$node;

});

parcelRegister("feD18", function(module, exports) {

let $b1766ddcc8cd75af$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $b1766ddcc8cd75af$var$load("1VRB2"),
    $b1766ddcc8cd75af$var$load("bABhq"),
    $b1766ddcc8cd75af$var$load("9RydJ")
]).then(()=>parcelRequire('fuuku'));

});




parcelRegister("gjSfP", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormRouteEntry", () => $50806d420907d462$export$4798edf139084d2e);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $60Tyc = parcelRequire("60Tyc");

var $6Kytx = parcelRequire("6Kytx");
const $50806d420907d462$export$4798edf139084d2e = (0, $6xToB.createEntry)((0, $60Tyc.classicBusinessProjectFormRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-directory-view',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>(0, $6Kytx.formPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("60Tyc", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormRoute", () => $13307bc2c963621c$export$e98776bdf96c88ac);
const $13307bc2c963621c$export$e98776bdf96c88ac = {
    name: 'classic-business-form',
    path: '/jira/core/projects/:projectKey/form',
    exact: true
};

});

parcelRegister("6Kytx", function(module, exports) {

$parcel$export(module.exports, "formPageEntrypoint", () => $bab61c24a59d2af5$export$ebaf30a031a61671);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $bjASA = parcelRequire("bjASA");

var $9n5I0 = parcelRequire("9n5I0");
const $bab61c24a59d2af5$export$ebaf30a031a61671 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $bjASA.formEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("bjASA", function(module, exports) {

$parcel$export(module.exports, "formEntrypoint", () => $130bb9c1c43479e6$export$b931eb60522f687a);

var $c4u59 = parcelRequire("c4u59");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $130bb9c1c43479e6$export$b931eb60522f687a = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("ihI4b")), {
        moduleId: "77eafb5a",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $c4u59.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("c4u59", function(module, exports) {

$parcel$export(module.exports, "default", () => $6add814bcfcd5ee1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f62e7b05d75adf93c826705d7992eb93>>
 * @relayHash 8e0b57fc78588fab5ce6e2ba76089a61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00dfb7b57058946faf78573ea5754789e6b3e2dd7eab0b5c0a813c3db15e260b
const $6add814bcfcd5ee1$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "00dfb7b57058946faf78573ea5754789e6b3e2dd7eab0b5c0a813c3db15e260b",
        "metadata": {},
        "name": "src_jiraBusinessFormQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6add814bcfcd5ee1$export$2e2bcd8739ae039 = $6add814bcfcd5ee1$var$node;

});

parcelRegister("ihI4b", function(module, exports) {

let $d4fbff3aea0a98e2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d4fbff3aea0a98e2$var$load("holy8").then(()=>parcelRequire('5jeMe'));

});




parcelRegister("7aHwj", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitEmbedRouteEntry", () => $86e3e3c8becfd242$export$c2f698be6eedea1a);

var $7K5Ea = parcelRequire("7K5Ea");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $53Dto = parcelRequire("53Dto");

var $iDG9N = parcelRequire("iDG9N");
const $86e3e3c8becfd242$export$c2f698be6eedea1a = (0, $6xToB.createEntry)((0, $53Dto.classicBusinessProjectFormSubmitEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-embed-view',
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>(0, $iDG9N.formSubmitEmbedPageEntrypoint)
    }));

});
parcelRegister("53Dto", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitEmbedRoute", () => $2ea26d09f435f720$export$7e8fd15fdfa29385);
const $2ea26d09f435f720$export$7e8fd15fdfa29385 = {
    name: 'classic-business-form-submit-embed',
    path: '/jira/core/projects/:projectKey/form/:formId/embed',
    exact: true
};

});

parcelRegister("iDG9N", function(module, exports) {

$parcel$export(module.exports, "formSubmitEmbedPageEntrypoint", () => $4c19060df61babf6$export$93f08d580854f4a7);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $bHYrQ = parcelRequire("bHYrQ");

var $9n5I0 = parcelRequire("9n5I0");
const $4c19060df61babf6$export$93f08d580854f4a7 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $bHYrQ.formSubmitEmbedEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("bHYrQ", function(module, exports) {

$parcel$export(module.exports, "formSubmitEmbedEntrypoint", () => $e947ff29e30a76d3$export$4c748d8ca82fc24);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $e947ff29e30a76d3$export$4c748d8ca82fc24 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("cwWA5")), {
        moduleId: "20838510",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cwWA5", function(module, exports) {

let $91f5ea2d47444f0f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $91f5ea2d47444f0f$var$load("1VRB2"),
    $91f5ea2d47444f0f$var$load("bABhq"),
    $91f5ea2d47444f0f$var$load("cwQtN")
]).then(()=>parcelRequire('g1kwn'));

});




parcelRegister("hULAZ", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitPublicRouteEntry", () => $fc17e73a43fddbd9$export$69d2365670c516de);

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $i6nt0 = parcelRequire("i6nt0");

var $epTsa = parcelRequire("epTsa");

var $kSeQy = parcelRequire("kSeQy");

var $cxQGT = parcelRequire("cxQGT");

var $7TTbh = parcelRequire("7TTbh");
const $fc17e73a43fddbd9$export$69d2365670c516de = (0, $6xToB.createEntry)((0, $i6nt0.classicBusinessProjectFormSubmitPublicRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-public-view',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        entryPoint: ()=>(0, $epTsa.expVal)('jira_forms_public_access_experiment', 'isEnabled', 'false') ? (0, $7TTbh.formSubmitPageEntrypoint) : (0, $kSeQy.notFoundPageEntrypoint)
    }));

});
parcelRegister("i6nt0", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitPublicRoute", () => $a76d25dcffedf4b2$export$865063615075df54);
const $a76d25dcffedf4b2$export$865063615075df54 = {
    name: 'classic-business-form-submit-public',
    path: '/jira/core/form/:formUuid',
    exact: true
};

});

parcelRegister("kSeQy", function(module, exports) {

$parcel$export(module.exports, "notFoundPageEntrypoint", () => $cb15b80ff801a631$export$eb748b014da0ac9a);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $8sJsy = parcelRequire("8sJsy");
const $cb15b80ff801a631$export$eb748b014da0ac9a = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8sJsy.notFoundEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).HOME
});

});
parcelRegister("8sJsy", function(module, exports) {

$parcel$export(module.exports, "notFoundEntrypoint", () => $8ba65e49059e1a00$export$7fdee4826a30b643);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $8ba65e49059e1a00$export$7fdee4826a30b643 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("8LrCn")), {
        moduleId: "4e8af128",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("7TTbh", function(module, exports) {

$parcel$export(module.exports, "formSubmitPageEntrypoint", () => $79cfcf554dce6749$export$26755d0805847061);

var $g8uYY = parcelRequire("g8uYY");

var $aiuBl = parcelRequire("aiuBl");
const $79cfcf554dce6749$export$26755d0805847061 = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $aiuBl.formSubmitPublicEntrypoint)
});

});
parcelRegister("aiuBl", function(module, exports) {

$parcel$export(module.exports, "formSubmitPublicEntrypoint", () => $43158b9e29901a2d$export$345530940ab03dbd);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $43158b9e29901a2d$export$345530940ab03dbd = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("78TVR")), {
        moduleId: "d418c43d",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("78TVR", function(module, exports) {

let $5334aab8ac42d766$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5334aab8ac42d766$var$load("1VRB2"),
    $5334aab8ac42d766$var$load("bABhq"),
    $5334aab8ac42d766$var$load("ivhf1")
]).then(()=>parcelRequire('8JOz7'));

});




parcelRegister("8WHEn", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitRouteEntry", () => $e3062b13f5c4ec14$export$bd59a50eb595d1d5);

var $hS1gr = parcelRequire("hS1gr");

var $7K5Ea = parcelRequire("7K5Ea");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $ebtn8 = parcelRequire("ebtn8");

var $f1dLp = parcelRequire("f1dLp");
const $e3062b13f5c4ec14$export$bd59a50eb595d1d5 = (0, $6xToB.createEntry)((0, $ebtn8.classicBusinessProjectFormSubmitRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-view',
        layout: (0, $7K5Ea.chromelessLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>(0, $f1dLp.formSubmitPageEntrypoint)
    }));

});
parcelRegister("ebtn8", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitRoute", () => $f2b1b6e109621185$export$3cd93ff55b29f07f);
const $f2b1b6e109621185$export$3cd93ff55b29f07f = {
    name: 'classic-business-form-submit',
    path: '/jira/core/projects/:projectKey/form/:formId',
    exact: true
};

});

parcelRegister("f1dLp", function(module, exports) {

$parcel$export(module.exports, "formSubmitPageEntrypoint", () => $385bcb6f7896c37e$export$26755d0805847061);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $5te9m = parcelRequire("5te9m");
const $385bcb6f7896c37e$export$26755d0805847061 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $5te9m.formSubmitEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("5te9m", function(module, exports) {

$parcel$export(module.exports, "formSubmitEntrypoint", () => $4fd3364aa5cb94f8$export$d33b8db02e0a0cb5);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $4fd3364aa5cb94f8$export$d33b8db02e0a0cb5 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("fMyn0")), {
        moduleId: "1cf8636b",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fMyn0", function(module, exports) {

let $02f71083c4167f35$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $02f71083c4167f35$var$load("1VRB2"),
    $02f71083c4167f35$var$load("bABhq"),
    $02f71083c4167f35$var$load("6pth9")
]).then(()=>parcelRequire('1Hqud'));

});




parcelRegister("6BJfU", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectPagesRouteEntry", () => $74648e4549871877$export$7a55e12f93813823);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8peAk = parcelRequire("8peAk");

var $85ovz = parcelRequire("85ovz");
const $74648e4549871877$export$7a55e12f93813823 = (0, $6xToB.createEntry)((0, $8peAk.classicBusinessProjectPagesRoute), ()=>({
        group: 'classic-business',
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource)
        ],
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        ufoName: 'jwm.jwm-pages',
        entryPoint: ()=>(0, $85ovz.pagesPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("8peAk", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectPagesRoute", () => $b0c7ef728c8097cb$export$573cc697c2d33124);
const $b0c7ef728c8097cb$export$573cc697c2d33124 = {
    name: 'project-pages',
    path: '/jira/core/projects/:projectKey/pages'
};

});

parcelRegister("85ovz", function(module, exports) {

$parcel$export(module.exports, "pagesPageEntrypoint", () => $662e5e2ed89db107$export$4ce394de88f5b54a);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $GG9qq = parcelRequire("GG9qq");

var $9n5I0 = parcelRequire("9n5I0");
const $662e5e2ed89db107$export$4ce394de88f5b54a = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $GG9qq.pagesEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("GG9qq", function(module, exports) {

$parcel$export(module.exports, "pagesEntrypoint", () => $aa73c40e6977a190$export$49834d404673808c);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $aa73c40e6977a190$export$49834d404673808c = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("jq3g8")), {
        moduleId: "671532d1",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jq3g8", function(module, exports) {

let $e232f944747977f0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $e232f944747977f0$var$load("7vqGd"),
    $e232f944747977f0$var$load("1Y4bq"),
    $e232f944747977f0$var$load("iurgR")
]).then(()=>parcelRequire('el8fJ'));

});




parcelRegister("a7Dk4", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectShortcutRouteEntry", () => $ae7b8140c354f3c9$export$22248cc626626132);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $kpeaX = parcelRequire("kpeaX");

var $1dclZ = parcelRequire("1dclZ");
const $ae7b8140c354f3c9$export$22248cc626626132 = (0, $6xToB.createEntry)((0, $kpeaX.classicBusinessProjectShortcutRoute), ()=>({
        group: 'classic-business',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>(0, $1dclZ.shortcutsPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("kpeaX", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectShortcutRoute", () => $ea7011af4881196b$export$2dd4e8a37d8ac978);
const $ea7011af4881196b$export$2dd4e8a37d8ac978 = {
    name: 'classic-business-shortcut',
    path: '/jira/core/projects/:projectKey/shortcuts',
    exact: true
};

});

parcelRegister("1dclZ", function(module, exports) {

$parcel$export(module.exports, "shortcutsPageEntrypoint", () => $0f7792905aa1bcd2$export$57a2f1af23fcbb8b);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hLAWj = parcelRequire("hLAWj");

var $9n5I0 = parcelRequire("9n5I0");
const $0f7792905aa1bcd2$export$57a2f1af23fcbb8b = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $hLAWj.shortcutsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("hLAWj", function(module, exports) {

$parcel$export(module.exports, "shortcutsEntrypoint", () => $74cc8127d1f5bbb4$export$212fd76838eeb6ad);

var $78bHS = parcelRequire("78bHS");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $74cc8127d1f5bbb4$export$212fd76838eeb6ad = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("6IPXp")), {
        moduleId: "736f6fc2",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                shortcutsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $78bHS.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("78bHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e447bfa04dd0b5f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<571227a0b71f1eebd07db7bde4b71b10>>
 * @relayHash f251714abaead8d7f256f75b2cbcdd4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b84b6702f8ba5906f411cf39e6585519029e426840a702a9fe6d1e6e094c95e
const $e447bfa04dd0b5f8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1b84b6702f8ba5906f411cf39e6585519029e426840a702a9fe6d1e6e094c95e",
        "metadata": {},
        "name": "src_jiraBusinessShortcutsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e447bfa04dd0b5f8$export$2e2bcd8739ae039 = $e447bfa04dd0b5f8$var$node;

});

parcelRegister("6IPXp", function(module, exports) {

let $4e4f27bd611ea628$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $4e4f27bd611ea628$var$load("eDzss"),
    $4e4f27bd611ea628$var$load("bKRyW")
]).then(()=>parcelRequire('fydRE'));

});




parcelRegister("eAKSk", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectViewNotFoundRouteEntry", () => $321698f850da12b4$export$e23e06ae81848c38);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $bk9g2 = parcelRequire("bk9g2");

var $lqm4V = parcelRequire("lqm4V");
const $321698f850da12b4$export$e23e06ae81848c38 = (0, $6xToB.createEntry)((0, $bk9g2.classicBusinessProjectViewNotFoundRoute), ()=>({
        group: 'classic-business',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>(0, $lqm4V.projectViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("bk9g2", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectViewNotFoundRoute", () => $66cd44e5d2928867$export$1194a530fb12fc37);
const $66cd44e5d2928867$export$1194a530fb12fc37 = {
    name: 'classic-business-view-not-found',
    path: '/jira/core/projects/:projectKey/not-found',
    exact: true
};

});

parcelRegister("lqm4V", function(module, exports) {

$parcel$export(module.exports, "projectViewNotFoundPageEntrypoint", () => $af9a408b7801e7b6$export$31e63eef3cc009c6);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $g35Sw = parcelRequire("g35Sw");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

const $af9a408b7801e7b6$var$main = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("jI7YP")), {
        moduleId: "24c3dcc7",
        moduleName: "ProjectViewNotFound",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $g35Sw.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});
const $af9a408b7801e7b6$export$31e63eef3cc009c6 = (0, $g8uYY.createPageEntryPoint)({
    main: $af9a408b7801e7b6$var$main,
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("g35Sw", function(module, exports) {

$parcel$export(module.exports, "default", () => $228f8bc43c71d769$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c9a08656b81123b3a899ed443afd14f3>>
 * @relayHash 4f9cc1b4eefda38b80dcbc5247f75776
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4e080d38c866eb2caaf06903fd96c2653d506a6f20f6ba761d204c141a5466d9
const $228f8bc43c71d769$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4e080d38c866eb2caaf06903fd96c2653d506a6f20f6ba761d204c141a5466d9",
        "metadata": {},
        "name": "ProjectViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $228f8bc43c71d769$export$2e2bcd8739ae039 = $228f8bc43c71d769$var$node;

});

parcelRegister("jI7YP", function(module, exports) {

let $e598511688a6a000$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e598511688a6a000$var$load("3bXsG").then(()=>parcelRequire('jPybt'));

});



parcelRegister("j9RxE", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDataClassificationsRouteEntry", () => $a4b052d9a9bf10aa$export$5b0670f37204a43d);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $8tbnc = parcelRequire("8tbnc");

var $bTfc4 = parcelRequire("bTfc4");

var $QIRn1 = parcelRequire("QIRn1");

var $7OZa1 = parcelRequire("7OZa1");
const $a4b052d9a9bf10aa$export$5b0670f37204a43d = (0, $6xToB.createEntry)((0, $QIRn1.classicProjectSettingsDataClassificationsRoute), ()=>({
        group: 'project-settings-classic',
        component: (0, $7OZa1.default),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7OZa1.LazyDataClassificationsSettings)
        ]
    }));

});
parcelRegister("QIRn1", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDataClassificationsRoute", () => $ee169d7e1ab17d73$export$952eefa1907e877a);
const $ee169d7e1ab17d73$export$952eefa1907e877a = {
    name: 'project-settings-classic-data-classifications',
    path: '/plugins/servlet/project-config/:projectKey/data-classifications',
    exact: true
};

});

parcelRegister("7OZa1", function(module, exports) {

$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $233771e23fdb4e35$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $233771e23fdb4e35$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $233771e23fdb4e35$export$b8abcf8aa8f4df56 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bzxaI"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$233771e23fdb4e35$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $233771e23fdb4e35$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });

});
parcelRegister("bzxaI", function(module, exports) {

let $86ccb1d6fafd37a1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $86ccb1d6fafd37a1$var$load("19HAK").then(()=>parcelRequire('g5gWI'));

});



parcelRegister("cprgG", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDetailsRouteEntry", () => $84946a88159b0a32$export$9391a147c94081db);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $dbqPj = parcelRequire("dbqPj");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $fLSSb = parcelRequire("fLSSb");
const $84946a88159b0a32$export$9391a147c94081db = (0, $6xToB.createEntry)((0, $dbqPj.classicProjectSettingsDetailsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $fLSSb.default),
        skeleton: (0, $bmwpE.ProjectSettingsDetailsSkeleton),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fLSSb.LazyDetailsSettings)
        ]
    }));

});
parcelRegister("dbqPj", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDetailsRoute", () => $288d8d62d5e9a3bd$export$37e0dbac44df25b9);
const $288d8d62d5e9a3bd$export$37e0dbac44df25b9 = {
    name: 'classic-software-details',
    path: '/jira/software/c/projects/:projectKey/settings/details',
    exact: true
};

});

parcelRegister("bmwpE", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsAccessSkeleton", () => $5db067f2e0655363$export$e6cc5ccd52c7fd63);
$parcel$export(module.exports, "ProjectSettingsDetailsSkeleton", () => $5db067f2e0655363$export$bd7fd4005b84aec9);
$parcel$export(module.exports, "ProjectSettingsFeaturesSkeleton", () => $5db067f2e0655363$export$ec1cdd0c8335373c);
/* ProjectSettingsFeaturesSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $lvE3i = parcelRequire("lvE3i");

var $ktMzY = parcelRequire("ktMzY");

var $9qEZJ = parcelRequire("9qEZJ");
const $5db067f2e0655363$var$customCssStyles = null;
const $5db067f2e0655363$var$listOnlyStyles = null;
const $5db067f2e0655363$export$e6cc5ccd52c7fd63 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lvE3i))),
        className: (0, $hcewu.default)([
            "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });
const $5db067f2e0655363$export$bd7fd4005b84aec9 = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ktMzY))),
        className: (0, $hcewu.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });
const $5db067f2e0655363$export$ec1cdd0c8335373c = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9qEZJ))),
        className: (0, $hcewu.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });

});
parcelRegister("lvE3i", function(module, exports) {
module.exports = new URL("project-settings-access-app-skeleton.tpl.21bb94b1.svg", import.meta.url).toString();

});

parcelRegister("ktMzY", function(module, exports) {
module.exports = new URL("project-settings-details-app-skeleton.tpl.c4ebc2fd.svg", import.meta.url).toString();

});

parcelRegister("9qEZJ", function(module, exports) {
module.exports = new URL("project-settings-features-app-skeleton.tpl.b8e7f249.svg", import.meta.url).toString();

});


parcelRegister("fLSSb", function(module, exports) {

$parcel$export(module.exports, "LazyDetailsSettings", () => $1cf3200158e533c3$export$6f16b5efddd5c646);
$parcel$export(module.exports, "default", () => $1cf3200158e533c3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $1cf3200158e533c3$export$6f16b5efddd5c646 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("9Vy7l"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1cf3200158e533c3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1cf3200158e533c3$export$6f16b5efddd5c646,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });

});
parcelRegister("9Vy7l", function(module, exports) {

let $73a3e6ec8c90a079$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $73a3e6ec8c90a079$var$load("7vqGd"),
    $73a3e6ec8c90a079$var$load("1Y4bq"),
    $73a3e6ec8c90a079$var$load("1VRB2"),
    $73a3e6ec8c90a079$var$load("bABhq"),
    $73a3e6ec8c90a079$var$load("eDzss"),
    $73a3e6ec8c90a079$var$load("4koeI")
]).then(()=>parcelRequire('iBX4i'));

});



parcelRegister("aGmFb", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsFeaturesRouteEntry", () => $897e1c0d50761d04$export$b623393adc25556a);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $aPSxl = parcelRequire("aPSxl");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $7jTnu = parcelRequire("7jTnu");

var $5L7qx = parcelRequire("5L7qx");

var $6zEUu = parcelRequire("6zEUu");

var $jjUOC = parcelRequire("jjUOC");
const $897e1c0d50761d04$export$b623393adc25556a = (0, $6xToB.createEntry)((0, $aPSxl.classicProjectSettingsFeaturesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'classic-features-page',
        component: (0, $jjUOC.ClassicFeaturesPage),
        skeleton: (0, $bmwpE.ProjectSettingsFeaturesSkeleton),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jira-project-isglobalcomponent-route-resource'), (0, $6zEUu.projectGlobalComponentsResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jjUOC.LazySoftwareClassicFeatures)
        ]
    }));

});
parcelRegister("aPSxl", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsFeaturesRoute", () => $e7a94da5cb04526c$export$d4bf23ba6f4199d7);
const $e7a94da5cb04526c$export$d4bf23ba6f4199d7 = {
    name: 'classic-software-features',
    path: '/jira/software/c/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("jjUOC", function(module, exports) {

$parcel$export(module.exports, "LazySoftwareClassicFeatures", () => $396c4b5eb8790ea0$export$79fe16f960f3d89f);
$parcel$export(module.exports, "ClassicFeaturesPage", () => $396c4b5eb8790ea0$export$8e6f565615e921dd);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $396c4b5eb8790ea0$export$79fe16f960f3d89f = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lPk81"))), {
    moduleId: "./src/packages/spa-apps/project-settings/classic-features/src/index.tsx"
});
const $396c4b5eb8790ea0$export$8e6f565615e921dd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $396c4b5eb8790ea0$export$79fe16f960f3d89f,
        pageId: "classic-features",
        shouldShowSpinner: true
    });

});
parcelRegister("lPk81", function(module, exports) {

let $fe3df97481870bc0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fe3df97481870bc0$var$load("l1LCc").then(()=>parcelRequire('6At3v'));

});



parcelRegister("7x2TW", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsIssueLayoutRouteEntry", () => $3feaf0637df9894c$export$47b3bdf88a7d176b);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $2WuSE = parcelRequire("2WuSE");

var $9X074 = parcelRequire("9X074");
const $3feaf0637df9894c$export$47b3bdf88a7d176b = (0, $6xToB.createEntry)((0, $2WuSE.classicProjectSettingsIssueLayoutRoute), ()=>({
        group: 'project-settings-classic',
        ufoName: 'project-settings.issue-type.jsw-cmp',
        component: (0, $9X074.default),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9X074.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("2WuSE", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsIssueLayoutRoute", () => $a0ecf27044ced88c$export$c593179674352d0);
const $a0ecf27044ced88c$export$c593179674352d0 = {
    name: 'project-settings-classic-issue-layout',
    path: '/plugins/servlet/project-config/:projectKey/issuelayout',
    query: [
        'screenId'
    ],
    exact: true
};

});

parcelRegister("9X074", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSettings", () => $3566656dc44068ff$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $3566656dc44068ff$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $3566656dc44068ff$export$36dcfb52d47cb93a = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2Qznj"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3566656dc44068ff$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3566656dc44068ff$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

});
parcelRegister("2Qznj", function(module, exports) {

let $212be0d653f2b1af$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $212be0d653f2b1af$var$load("1VRB2"),
    $212be0d653f2b1af$var$load("bABhq"),
    $212be0d653f2b1af$var$load("djogW")
]).then(()=>parcelRequire('5pMQO'));

});



parcelRegister("d6OfK", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsOpsgenieRouteEntry", () => $74e5b93c67733130$export$17e7416abefe91dc);

var $kHlOR = parcelRequire("kHlOR");

var $6qDrV = parcelRequire("6qDrV");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $9BJU1 = parcelRequire("9BJU1");

var $6wqnM = parcelRequire("6wqnM");

var $jom8W = parcelRequire("jom8W");

var $8FCAy = parcelRequire("8FCAy");

var $jLc1n = parcelRequire("jLc1n");
const $74e5b93c67733130$export$17e7416abefe91dc = (0, $6xToB.createEntry)((0, $6wqnM.classicProjectSettingsOpsgenieRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $6qDrV.default)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $jLc1n.default)),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jLc1n.LazyLinkOpsgeniePage)
        ],
        ufoName: 'project-settings.link-opsgenie'
    }));

});
parcelRegister("6qDrV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d62983c7b7a7f090$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
var /**
 * @deprecated this does not support useRef and is being moved into a new package.
 * Use @atlassian/jira-feature-flagging-utils and componentWithCondition instead.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$d62983c7b7a7f090$export$2e2bcd8739ae039 = (conditionGetter, ComponentTrue, ComponentFalse)=>{
    const ComponentWithCondition = (props)=>// @ts-expect-error - TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'. | TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'.
        conditionGetter() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ComponentTrue, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ComponentFalse, props);
    if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
    // @ts-expect-error - TS2322 - Type '{ (props: P): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<P, any>'.
    return ComponentWithCondition;
};

});

parcelRegister("6wqnM", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsOpsgenieRoute", () => $c26b8de24a202a54$export$4e4a4b8762b611);
const $c26b8de24a202a54$export$4e4a4b8762b611 = {
    name: 'classic-software-link-opsgenie',
    path: '/jira/software/c/projects/:projectKey/settings/opsgenie',
    exact: true
};

});

parcelRegister("jom8W", function(module, exports) {

$parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", () => $f1cf95014072f374$export$18bfef4995ec57b7);

var $igNUx = parcelRequire("igNUx");
const $f1cf95014072f374$export$18bfef4995ec57b7 = ()=>(0, $igNUx.isFedRamp)();

});

parcelRegister("jLc1n", function(module, exports) {

$parcel$export(module.exports, "LazyLinkOpsgeniePage", () => $bc2c672bce6647e8$export$ca5dba69148b337);
$parcel$export(module.exports, "default", () => $bc2c672bce6647e8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $bc2c672bce6647e8$export$ca5dba69148b337 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("j8IfW")), {
    moduleId: "./src/packages/spa-apps/project-settings/link-opsgenie/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bc2c672bce6647e8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $bc2c672bce6647e8$export$ca5dba69148b337,
        pageId: "link-opsgenie-page",
        shouldShowSpinner: false
    });

});
parcelRegister("j8IfW", function(module, exports) {

let $def11803818f8eef$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $def11803818f8eef$var$load("dDO0x").then(()=>parcelRequire('3GUgg'));

});



parcelRegister("4vMYX", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareNotificationsIssueLogsRouteEntry", () => $5275a62984855e6a$export$cdc4e64211a34457);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $bGYpj = parcelRequire("bGYpj");

var $8FCAy = parcelRequire("8FCAy");

var $6qzZB = parcelRequire("6qzZB");
const $5275a62984855e6a$export$cdc4e64211a34457 = (0, $6xToB.createEntry)((0, $bGYpj.classicProjectSettingsSoftwareNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.classic-issue-logs-page',
        component: (0, $6qzZB.SoftwareNotificationsIssueLogs),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6qzZB.LazySoftwareNotificationsIssueLogs)
        ],
        entryPoint () {
            return 0, $6qzZB.emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("bGYpj", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareNotificationsIssueLogsRoute", () => $5df01b9dd763cc69$export$5e2e0a895d6a14bd);
const $5df01b9dd763cc69$export$5e2e0a895d6a14bd = {
    name: 'classic-software-notifications-issue-logs',
    path: '/jira/software/c/projects/:projectKey/settings/notifications/issue-logs',
    query: [
        'projectId'
    ]
};

});

parcelRegister("6qzZB", function(module, exports) {

$parcel$export(module.exports, "emailNotificationsLogEntryPointPage", () => $36163c389e27445f$export$cd8964bea0e3c2);
$parcel$export(module.exports, "LazySoftwareNotificationsIssueLogs", () => $36163c389e27445f$export$6960a46ebd209756);
$parcel$export(module.exports, "SoftwareNotificationsIssueLogs", () => $36163c389e27445f$export$4b75df09cc5b4e8e);

var $eJOHy = parcelRequire("eJOHy");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9BdgC = parcelRequire("9BdgC");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");
const $36163c389e27445f$export$cd8964bea0e3c2 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9BdgC.notificationsIssueLogsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

const $36163c389e27445f$export$6960a46ebd209756 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("eE4gG"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
});
const $36163c389e27445f$export$4b75df09cc5b4e8e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $36163c389e27445f$export$6960a46ebd209756,
        pageId: "project-settings-software-notifications-issue-logs",
        shouldShowSpinner: false
    });

});
parcelRegister("9BdgC", function(module, exports) {

$parcel$export(module.exports, "notificationsIssueLogsEntryPoint", () => $3f0806f07fcc5770$export$97bbdefcbe0571ac);

var $aSqTV = parcelRequire("aSqTV");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $3f0806f07fcc5770$export$97bbdefcbe0571ac = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("eE4gG")), {
        moduleId: "b2136a4d",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $aSqTV.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectId: Number(context?.query?.projectId ?? 0),
                        notificationType: 'INTERNAL_NOTIFICATION_ISSUE'
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                projectIds: context?.query?.projectId,
                projectKey: context?.match.params.projectKey
            }
        })
});

});
parcelRegister("aSqTV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7476776357f93963$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a829922c4d7e91622e88a1e75ca9c0ed>>
 * @relayHash ed735b233bfe7d6a34f4765ef97f56e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 28e1d1e9657c726eca51c9d02a4b718874ec12653eea9e5bfcfef82047676924
const $7476776357f93963$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "28e1d1e9657c726eca51c9d02a4b718874ec12653eea9e5bfcfef82047676924",
        "metadata": {},
        "name": "uiIssueNotificationLogsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7476776357f93963$export$2e2bcd8739ae039 = $7476776357f93963$var$node;

});

parcelRegister("eE4gG", function(module, exports) {

let $aa981cab1e601b75$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $aa981cab1e601b75$var$load("eZGfI").then(()=>parcelRequire('9n6Sp'));

});




parcelRegister("13I6Z", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaEditFormsRouteEntry", () => $4e71602b781b7558$export$e730b13555ff0c60);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4vq3o = parcelRequire("4vq3o");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $flSSv = parcelRequire("flSSv");
const $4e71602b781b7558$export$e730b13555ff0c60 = (0, $6xToB.createEntry)((0, $4vq3o.classicProjectSettingsSoftwareProformaEditFormsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $flSSv.default),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $flSSv.LazyProjectSettingsProformaJiraFormBuilder)
        ]
    }));

});
parcelRegister("4vq3o", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaEditFormsRoute", () => $cad0ee66b8925436$export$811ace4fee984f0e);
const $cad0ee66b8925436$export$811ace4fee984f0e = {
    name: 'project-settings-software-proforma-edit-forms',
    path: '/jira/software/c/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});

parcelRegister("5JAAk", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_PRODUCT", () => $6e6276c28e4f3f5a$export$2954328f6207617a);
$parcel$export(module.exports, "getSettingsNavigationResources", () => $6e6276c28e4f3f5a$export$586756e5c0542a50);
$parcel$export(module.exports, "RedirectForSettings", () => $6e6276c28e4f3f5a$export$fb15a6ba8980fdac);
$parcel$export(module.exports, "RedirectForSettingsForClassicProject", () => $6e6276c28e4f3f5a$export$f9befa0a4925b36d);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $dSkLG = parcelRequire("dSkLG");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $2mHfh = parcelRequire("2mHfh");
const $6e6276c28e4f3f5a$export$2954328f6207617a = 'software';
const $6e6276c28e4f3f5a$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $6e6276c28e4f3f5a$export$586756e5c0542a50 = ()=>{
    return [
        ...(0, $9NmsS.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $bTfc4.incidentExperimentTraitResource),
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $6e6276c28e4f3f5a$export$fb15a6ba8980fdac = ({ match: match })=>{
    const { data: data } = (0, $dSkLG.useJiraSoftwareProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
    });
    // the next three if branches do not make a lot of sense for TMP as you always a project admin in TMP
    // however a wrong link is generated by the nav4 navbar for CMP projects which matches to this redirect logic
    // ex: "/jira/software/projects/JSWCMP1/settings"
    // instead it should be "/jira/software/c/projects/JSWCMP1/settings"
    // which matches to CMP redirect logic defined in RedirectForSettingsForClassicProject
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    if ((0, $7jTnu.fg)('vmc-11-manage-versions-permission')) {
        if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/administer-versions`
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
    });
};
const $6e6276c28e4f3f5a$export$f9befa0a4925b36d = ({ match: match })=>{
    const { data: data } = (0, $dSkLG.useJiraSoftwareProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    if ((0, $7jTnu.fg)('vmc-11-manage-versions-permission')) {
        if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/administer-versions`
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
    });
};

});

parcelRegister("flSSv", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaJiraFormBuilder", () => $4dbaf5b5533067a8$export$a7d63246a10aedd);
$parcel$export(module.exports, "default", () => $4dbaf5b5533067a8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $4dbaf5b5533067a8$export$a7d63246a10aedd = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("h6wO6")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4dbaf5b5533067a8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4dbaf5b5533067a8$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });

});
parcelRegister("h6wO6", function(module, exports) {

let $c73c7208cf8b3416$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $c73c7208cf8b3416$var$load("1VRB2"),
    $c73c7208cf8b3416$var$load("bABhq"),
    $c73c7208cf8b3416$var$load("7vqGd"),
    $c73c7208cf8b3416$var$load("1Y4bq"),
    $c73c7208cf8b3416$var$load("eDzss"),
    $c73c7208cf8b3416$var$load("8t4Qa")
]).then(()=>parcelRequire('97MV1'));

});



parcelRegister("5IMFp", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaFormsRouteEntry", () => $413816a91070f678$export$5e67ac6f50ae37e1);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $diIio = parcelRequire("diIio");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $7BRGK = parcelRequire("7BRGK");
const $413816a91070f678$export$5e67ac6f50ae37e1 = (0, $6xToB.createEntry)((0, $diIio.classicProjectSettingsSoftwareProformaFormsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $7BRGK.default),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7BRGK.LazyProjectSettingsProformaProjectForms)
        ]
    }));

});
parcelRegister("diIio", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaFormsRoute", () => $656b6cf425098207$export$2313ca001d58ab27);
const $656b6cf425098207$export$2313ca001d58ab27 = {
    name: 'project-settings-software-proforma-project-forms',
    path: '/jira/software/c/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("7BRGK", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaProjectForms", () => $e36263420d65374a$export$38414b624a749cec);
$parcel$export(module.exports, "default", () => $e36263420d65374a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $e36263420d65374a$export$38414b624a749cec = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("lW6IV")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e36263420d65374a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e36263420d65374a$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });

});
parcelRegister("lW6IV", function(module, exports) {

let $ff843af118cb2e66$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ff843af118cb2e66$var$load("4Mt0x").then(()=>parcelRequire('rxPon'));

});



parcelRegister("eCSHY", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareRedirectRouteEntry", () => $20b7059ced23805e$export$3c7d008bbb14e2b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $gDWl0 = parcelRequire("gDWl0");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");
const $20b7059ced23805e$export$3c7d008bbb14e2b = (0, $6xToB.createEntry)((0, $gDWl0.classicProjectSettingsSoftwareRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $5JAAk.RedirectForSettingsForClassicProject),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("gDWl0", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareRedirectRoute", () => $57cb4e8682dd4709$export$99b695c2b8299b5a);
const $57cb4e8682dd4709$export$99b695c2b8299b5a = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    name: 'classic-software-redirect',
    path: '/jira/software/c/projects/:projectKey/settings'
};

});


parcelRegister("k7BXo", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsToolchainRouteEntry", () => $31f3e2198111a83e$export$1fe479c54f4d7684);

var $kHlOR = parcelRequire("kHlOR");

var $6qDrV = parcelRequire("6qDrV");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $aaqFB = parcelRequire("aaqFB");

var $bTfc4 = parcelRequire("bTfc4");

var $9BJU1 = parcelRequire("9BJU1");

var $davWM = parcelRequire("davWM");

var $jom8W = parcelRequire("jom8W");

var $8FCAy = parcelRequire("8FCAy");

var $1a7Aj = parcelRequire("1a7Aj");
const $31f3e2198111a83e$export$1fe479c54f4d7684 = (0, $6xToB.createEntry)((0, $davWM.classicProjectSettingsToolchainRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $6qDrV.default)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $1a7Aj.default)),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource),
            (0, $aaqFB.projectSettingsToolchainResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1a7Aj.LazyDevOpsConnectionsSettings)
        ],
        ufoName: 'project-settings.devops-connections'
    }));

});
parcelRegister("aaqFB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsToolchainResource", () => $5f2850140c25c0a6$export$182dfe2bc7c28567);

var $9FYIg = parcelRequire("9FYIg");

var $92JCO = parcelRequire("92JCO");
const $5f2850140c25c0a6$export$b8927fea69d9f414 = 'PROJECT_SETTINGS_TOOLCHAIN';
const $5f2850140c25c0a6$export$182dfe2bc7c28567 = (0, $9FYIg.createRelayResource)({
    type: $5f2850140c25c0a6$export$b8927fea69d9f414,
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $92JCO.default),
            variables: {
                cloudId: tenantContext?.cloudId || ''
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("92JCO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d549c2939c3288ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a2c9dc099d3b7d79cd74bd591996a945>>
 * @relayHash f5bf042c501578b47d326c7288427026
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409
const $d549c2939c3288ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "concreteType": "DvcsQuery",
            "kind": "LinkedField",
            "name": "dvcs",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                        }
                    ],
                    "concreteType": "DvcsBitbucketWorkspaceConnection",
                    "kind": "LinkedField",
                    "name": "bitbucketWorkspacesLinkedToSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DvcsBitbucketWorkspaceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_projectSettingsToolchainQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_projectSettingsToolchainQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409",
            "metadata": {},
            "name": "ui_projectSettingsToolchainQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d549c2939c3288ae$var$node.hash = "190735208b3c7baafbfc3c1808fa801b";
var $d549c2939c3288ae$export$2e2bcd8739ae039 = $d549c2939c3288ae$var$node;

});


parcelRegister("davWM", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsToolchainRoute", () => $d1412cf050e832f7$export$7dbc23deac9553d4);
const $d1412cf050e832f7$export$7dbc23deac9553d4 = {
    name: 'project-settings-software-toolchain-company-managed',
    path: '/jira/software/c/projects/:projectKey/settings/toolchain',
    exact: true
};

});

parcelRegister("1a7Aj", function(module, exports) {

$parcel$export(module.exports, "LazyDevOpsConnectionsSettings", () => $7c2ae585b9382004$export$9d468faf674a5201);
$parcel$export(module.exports, "default", () => $7c2ae585b9382004$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $7c2ae585b9382004$export$9d468faf674a5201 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("eTVu9")), {
    moduleId: "./src/packages/spa-apps/project-settings/connections/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7c2ae585b9382004$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $7c2ae585b9382004$export$9d468faf674a5201,
        pageId: "devops-connections-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("eTVu9", function(module, exports) {

let $ad92cb20800f4e24$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ad92cb20800f4e24$var$load("djXZk").then(()=>parcelRequire('d9zBr'));

});



parcelRegister("5ClpU", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogEmbedRouteEntry", () => $10987dab9fcab7e7$export$1a7368427cd23b33);

var $6xToB = parcelRequire("6xToB");

var $iGqPy = parcelRequire("iGqPy");

var $kbZYB = parcelRequire("kbZYB");

var $7K5Ea = parcelRequire("7K5Ea");

var $alzbz = parcelRequire("alzbz");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $fbgOh = parcelRequire("fbgOh");

var $27Owl = parcelRequire("27Owl");

var $cxQGT = parcelRequire("cxQGT");

var $eJe5A = parcelRequire("eJe5A");

var $1wb5r = parcelRequire("1wb5r");

var $9NmsS = parcelRequire("9NmsS");

var $e1vE6 = parcelRequire("e1vE6");

var $kX24C = parcelRequire("kX24C");

var $daiGg = parcelRequire("daiGg");
const $10987dab9fcab7e7$export$1a7368427cd23b33 = (0, $6xToB.createEntry)((0, $iGqPy.classicSoftwareBacklogEmbedRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog-embed',
        component: (0, $kbZYB.RapidBoardSpaPage),
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            ...(0, $alzbz.getUIFBacklogDataResource)(),
            ...(0, $alzbz.getRapidboardResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)(),
            (0, $hHbzj.forgeBacklogModuleResource),
            (0, $hHbzj.forgeSprintModuleResource),
            (0, $cxQGT.themePreferenceResource),
            (0, $e1vE6.aiEntitlementResource)
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kX24C.LazyBacklogPage)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-backlog-early-entry'
            ]
        },
        meta: {
            capability: (0, $daiGg.classicBacklogCapability)
        },
        earlyAssets: (0, $1wb5r.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("iGqPy", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogEmbedRoute", () => $56e657b647700c56$export$e6776ef8123b7136);
const $56e657b647700c56$export$e6776ef8123b7136 = {
    name: 'rapidboard-backlog-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog/embed'
};

});

parcelRegister("kbZYB", function(module, exports) {

$parcel$export(module.exports, "UIFBoardSpa", () => $6177a7a3c7ca9e0e$export$2164de18d39af313);
$parcel$export(module.exports, "RapidBoardSpaPage", () => $6177a7a3c7ca9e0e$export$4ceb6cf2934825b2);
$parcel$export(module.exports, "LazyRapidBoard", () => $6177a7a3c7ca9e0e$export$9de09057ba255cc4);
$parcel$export(module.exports, "LazyRapidBoardWrmBundleResource", () => $6177a7a3c7ca9e0e$export$bcb5bb6438a46dcb);
$parcel$export(module.exports, "LazyRapidBoardDataApiResource", () => $6177a7a3c7ca9e0e$export$d4640ceb9bdd4b4);
$parcel$export(module.exports, "LazyRapidBoardConfigApiResource", () => $6177a7a3c7ca9e0e$export$c96c36c0cbfb2c16);
$parcel$export(module.exports, "LazyRapidBoardResource", () => $6177a7a3c7ca9e0e$export$2ad64ed8eb98d9e);
$parcel$export(module.exports, "LazyRapidBoardApps", () => $6177a7a3c7ca9e0e$export$4a8825f3e310b97);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $6177a7a3c7ca9e0e$export$2164de18d39af313 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("4kmpi")), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
});

const $6177a7a3c7ca9e0e$export$bcc6315cf211edab = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("dQetM")), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});

const $6177a7a3c7ca9e0e$export$a1c59527bd5131cc = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("7Q0qd")).then((module)=>module.BoardConfigSwitcher), {
    moduleId: "./src/packages/router-routes/software/classic/board-settings/switcher/src/index.tsx"
});
const $6177a7a3c7ca9e0e$export$4ceb6cf2934825b2 = (props)=>{
    const { route: route, query: query, match: match } = props;
    const basePageId = route && route.name || 'rapid-board';
    const chartParam = query.chart ? `-${query.chart}` : '';
    const boardId = query.rapidView ?? match.params.boardId;
    const pageId = `${basePageId}-${boardId}${chartParam}`;
    if ([
        'rapidboard-board',
        'rapidboard-board-embed',
        'rapidboard-user-board'
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6177a7a3c7ca9e0e$export$2164de18d39af313,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if ([
        'rapidboard-backlog',
        'rapidboard-user-backlog',
        'rapidboard-backlog-embed'
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6177a7a3c7ca9e0e$export$bcc6315cf211edab,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if ([
        'rapidboard-backlog',
        'rapidboard-user-backlog',
        'rapidboard-board',
        'rapidboard-board-embed',
        'rapidboard-user-board',
        'rapidboard-backlog-embed'
    ].includes(route.name) && query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6177a7a3c7ca9e0e$export$a1c59527bd5131cc,
        pageId: pageId,
        shouldShowSpinner: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6177a7a3c7ca9e0e$export$9de09057ba255cc4,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

const $6177a7a3c7ca9e0e$export$9de09057ba255cc4 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("6NSj9")), {
    moduleId: "./src/packages/spa-apps/rapid-board/src/index-old.tsx"
});

const $6177a7a3c7ca9e0e$export$bcb5bb6438a46dcb = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("5pLrG")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/wrm-bundle/get-data/index.tsx"
});

const $6177a7a3c7ca9e0e$export$d4640ceb9bdd4b4 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("5Ojhb")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/data-api/get-data/index.tsx"
});

const $6177a7a3c7ca9e0e$export$c96c36c0cbfb2c16 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("2QBnf")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/config-api/get-data/index.tsx"
});

const $6177a7a3c7ca9e0e$export$2ad64ed8eb98d9e = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("hsn7i")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/rapidboard-resource/get-data/index.tsx"
});

const $6177a7a3c7ca9e0e$export$4a8825f3e310b97 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("dYIxw")), {
    moduleId: "./src/packages/entry-rapid-board-wrm-apps/src/index.tsx"
});

});
parcelRegister("4kmpi", function(module, exports) {

let $326a693908128589$var$load = (parcelRequire("gLHA4"))(4);




module.exports = Promise.all([
    (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $326a693908128589$var$load("esKGV")
        ]);
    }, function() {
        return Promise.all([
            $326a693908128589$var$load("7uqQP")
        ]);
    }),
    $326a693908128589$var$load("k4gbU"),
    $326a693908128589$var$load("hwlgY"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("iPnFi"), 4)),
    $326a693908128589$var$load("1VRB2"),
    $326a693908128589$var$load("bABhq"),
    $326a693908128589$var$load("hlHEX")
]).then(()=>parcelRequire('gwyFe'));

});

parcelRegister("dQetM", function(module, exports) {

let $a13b5d0207bad370$var$load = (parcelRequire("gLHA4"))(4);






module.exports = Promise.all([
    (parcelRequire("g81qY"))('jsw-backlog-main-component-refactor', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
                return Promise.all([
                    $a13b5d0207bad370$var$load("esKGV")
                ]);
            }, function() {
                return Promise.all([
                    $a13b5d0207bad370$var$load("7uqQP")
                ]);
            }),
            $a13b5d0207bad370$var$load("7QEqb"),
            $a13b5d0207bad370$var$load("bABhq"),
            $a13b5d0207bad370$var$load("1VRB2"),
            $a13b5d0207bad370$var$load("1Y4bq"),
            $a13b5d0207bad370$var$load("7vqGd")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
                return Promise.all([
                    $a13b5d0207bad370$var$load("esKGV")
                ]);
            }, function() {
                return Promise.all([
                    $a13b5d0207bad370$var$load("7uqQP")
                ]);
            }),
            $a13b5d0207bad370$var$load("cbSdN"),
            $a13b5d0207bad370$var$load("bABhq"),
            $a13b5d0207bad370$var$load("1VRB2"),
            $a13b5d0207bad370$var$load("1Y4bq"),
            $a13b5d0207bad370$var$load("7vqGd")
        ]);
    }),
    (parcelRequire("g81qY"))('jsw-backlog-main-component-refactor', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
                return Promise.all([
                    $a13b5d0207bad370$var$load("esKGV")
                ]);
            }, function() {
                return Promise.all([
                    $a13b5d0207bad370$var$load("7uqQP")
                ]);
            }),
            $a13b5d0207bad370$var$load("7QEqb"),
            $a13b5d0207bad370$var$load("bABhq"),
            $a13b5d0207bad370$var$load("1VRB2"),
            $a13b5d0207bad370$var$load("1Y4bq"),
            $a13b5d0207bad370$var$load("7vqGd")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
                return Promise.all([
                    $a13b5d0207bad370$var$load("esKGV")
                ]);
            }, function() {
                return Promise.all([
                    $a13b5d0207bad370$var$load("7uqQP")
                ]);
            }),
            $a13b5d0207bad370$var$load("cbSdN"),
            $a13b5d0207bad370$var$load("bABhq"),
            $a13b5d0207bad370$var$load("1VRB2"),
            $a13b5d0207bad370$var$load("1Y4bq"),
            $a13b5d0207bad370$var$load("7vqGd")
        ]);
    }),
    $a13b5d0207bad370$var$load("k1bZy")
]).then(()=>parcelRequire('2fxgQ'));

});

parcelRegister("7Q0qd", function(module, exports) {

let $5b4db7848921e1ed$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5b4db7848921e1ed$var$load("1VRB2"),
    $5b4db7848921e1ed$var$load("bABhq"),
    $5b4db7848921e1ed$var$load("7CrTb")
]).then(()=>parcelRequire('htWDI'));

});

parcelRegister("6NSj9", function(module, exports) {

let $4f41721d48578163$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4f41721d48578163$var$load("7IYeq").then(()=>parcelRequire('Xu9Uw'));

});

parcelRegister("2QBnf", function(module, exports) {

let $212d6dc7157e542d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $212d6dc7157e542d$var$load("8VAZC").then(()=>parcelRequire('c6bSy'));

});

parcelRegister("dYIxw", function(module, exports) {

let $a2d36d9672733463$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a2d36d9672733463$var$load("16EZJ").then(()=>parcelRequire('6pPz6'));

});


parcelRegister("eJe5A", function(module, exports) {

$parcel$export(module.exports, "LazyIssueApp", () => $80c8b01e8332d190$export$8c70dcc4643464f8);

var $gzcjr = parcelRequire("gzcjr");

const $80c8b01e8332d190$export$8c70dcc4643464f8 = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("zlPMC")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});

});

parcelRegister("e1vE6", function(module, exports) {

$parcel$export(module.exports, "aiEntitlementResource", () => $ca4f246a1c036ca7$export$1d7e36ec4890154f);
$parcel$export(module.exports, "useAiEntitlementResource", () => $ca4f246a1c036ca7$export$58958385d85a6e72);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $9RxtF = parcelRequire("9RxtF");
const $ca4f246a1c036ca7$var$RESOURCE_TYPE_AI_ENTITLEMENT = 'AI_ENTITLEMENT';
const $ca4f246a1c036ca7$export$1d7e36ec4890154f = (0, $l1VxS.createResource)({
    type: $ca4f246a1c036ca7$var$RESOURCE_TYPE_AI_ENTITLEMENT,
    getKey: ()=>$ca4f246a1c036ca7$var$RESOURCE_TYPE_AI_ENTITLEMENT,
    getData: ()=>(0, $9RxtF.fetchAiEnablement)(),
    maxAge: 3600000
});
const $ca4f246a1c036ca7$export$58958385d85a6e72 = ()=>(0, $eJrcF.useResource)($ca4f246a1c036ca7$export$1d7e36ec4890154f);

});
parcelRegister("9RxtF", function(module, exports) {

$parcel$export(module.exports, "fetchAiEnablement", () => $8e5fdc23f4bbfb78$export$ad4105850d0ce824);

var $1Ozm9 = parcelRequire("1Ozm9");
const $8e5fdc23f4bbfb78$var$JIRA_SOFTWARE_AI_ENABLED_URL = '/rest/api/1/aiconfig/ai-enabled/jira-software';
const $8e5fdc23f4bbfb78$export$ad4105850d0ce824 = async ()=>{
    // We could check for other jira products / confluence when we need to
    // Not doing that right now as it adds complexity & we need software only now
    // See `@atlassian/jira-platform-react-hooks-use-is-admin-hub-ai-enabled`
    const entitlementData = {
        isAiEnabledForJiraSoftware: null
    };
    try {
        const response = await (0, $1Ozm9.default)($8e5fdc23f4bbfb78$var$JIRA_SOFTWARE_AI_ENABLED_URL, {
            method: 'GET'
        });
        entitlementData.isAiEnabledForJiraSoftware = response.isEnabled;
    } catch (_) {
        entitlementData.isAiEnabledForJiraSoftware = null;
    }
    return entitlementData;
};

});


parcelRegister("kX24C", function(module, exports) {

$parcel$export(module.exports, "LazyBacklogPage", () => $c5d16d03120ed3fe$export$edb4b8cf67d7d767);

var $gzcjr = parcelRequire("gzcjr");

var $2dJFW = parcelRequire("2dJFW");

const $c5d16d03120ed3fe$export$edb4b8cf67d7d767 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("dQetM"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});

});

parcelRegister("daiGg", function(module, exports) {

$parcel$export(module.exports, "classicBacklogCapability", () => $db679226da4cfc54$export$10a7bb102137d92b);

const $db679226da4cfc54$export$10a7bb102137d92b = !false ? (0, $652f5f63189f3e2a$export$571692eec8a399e1) : (0, $652f5f63189f3e2a$export$93104dc4eba58ba4);

});


parcelRegister("74BfF", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogRouteEntry", () => $0e6a74a0ef9edaac$export$568101ebd359b606);

var $6xToB = parcelRequire("6xToB");

var $aqgqG = parcelRequire("aqgqG");

var $kbZYB = parcelRequire("kbZYB");

var $9ZjGp = parcelRequire("9ZjGp");

var $7jTnu = parcelRequire("7jTnu");

var $6dwgv = parcelRequire("6dwgv");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $alzbz = parcelRequire("alzbz");

var $fbgOh = parcelRequire("fbgOh");

var $27Owl = parcelRequire("27Owl");

var $eJe5A = parcelRequire("eJe5A");

var $kHlOR = parcelRequire("kHlOR");

var $1wb5r = parcelRequire("1wb5r");

var $k6duF = parcelRequire("k6duF");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $e1vE6 = parcelRequire("e1vE6");

var $5vHl0 = parcelRequire("5vHl0");

var $daiGg = parcelRequire("daiGg");

var $kX24C = parcelRequire("kX24C");
const $0e6a74a0ef9edaac$export$568101ebd359b606 = (0, $6xToB.createEntry)((0, $aqgqG.classicSoftwareBacklogRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog',
        component: (0, $kbZYB.RapidBoardSpaPage),
        skeleton: (0, $9ZjGp.NextGenBacklogSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.pageLoadIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ], 'SIDEBAR')),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.ForPaintClassicSoftwareProjectSidebar),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-fix-nav4-sidebar-client-api-call')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getUIFBacklogDataResource)(),
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)(),
            (0, $hHbzj.forgeBacklogModuleResource),
            (0, $hHbzj.forgeSprintModuleResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $e1vE6.aiEntitlementResource)
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kX24C.LazyBacklogPage)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-backlog-early-entry'
            ]
        },
        meta: {
            capability: (0, $daiGg.classicBacklogCapability)
        },
        earlyAssets: (0, $1wb5r.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-classic-backlog-entries/src/classicSoftwareBacklogRouteEntry.tsx',
                whichExportToUse: 'classicSoftwareBacklogRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-software-backlog.json'
        },
        entryPoint: ()=>(0, $5vHl0.classicBacklogPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("aqgqG", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogRoute", () => $94985eb032cc2771$export$9bfa3c0dded1688f);
const $94985eb032cc2771$export$9bfa3c0dded1688f = {
    name: 'rapidboard-backlog',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog'
};

});

parcelRegister("9ZjGp", function(module, exports) {

$parcel$export(module.exports, "NextGenBacklogSkeleton", () => $0d166db2984aa878$export$33cd465913cf178f);
/* NextGenBacklogSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");

var $hwuZ0 = parcelRequire("hwuZ0");

var $2XrCK = parcelRequire("2XrCK");
const $0d166db2984aa878$export$433c2e8574f2e911 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2XrCK)))
    });
const $0d166db2984aa878$export$88189b56881f213e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0d166db2984aa878$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2XrCK)))
    }));
const $0d166db2984aa878$var$BacklogSkeleton = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $0d166db2984aa878$export$88189b56881f213e, $0d166db2984aa878$export$433c2e8574f2e911);
const $0d166db2984aa878$export$33cd465913cf178f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", false ? {
        'data-ssr-placeholder': 'software-backlog-skeleton'
    } : {
        'data-ssr-placeholder-replace': 'software-backlog-skeleton'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0d166db2984aa878$var$BacklogSkeleton, null));
// Adding this wrapper to override the border width from AppSkeletonImage
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $0d166db2984aa878$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6XJko", function(module, exports) {

$parcel$export(module.exports, "isVisualRefreshEnabled", () => $ac9280cd0f5c90b2$export$48345cb467db19b6);

var $6zXPf = parcelRequire("6zXPf");
const $ac9280cd0f5c90b2$export$48345cb467db19b6 = ()=>(0, $6zXPf.getWillShowNav4)();

});

parcelRegister("2XrCK", function(module, exports) {
module.exports = new URL("next-gen-backlog-app-skeleton.tpl.28e29051.svg", import.meta.url).toString();

});


parcelRegister("1302Y", function(module, exports) {

$parcel$export(module.exports, "getIsSoftwareThemingEnabled", () => $02571dfd61e26a65$export$a505f57c5130832f);
$parcel$export(module.exports, "getIsSoftwareThemingM2Enabled", () => $02571dfd61e26a65$export$4fa2eaefe7d59f41);
$parcel$export(module.exports, "getIsSoftwareThemingM2EnabledNoExposure", () => $02571dfd61e26a65$export$8a1bc0266a614408);

var $6zXPf = parcelRequire("6zXPf");

var $epTsa = parcelRequire("epTsa");
const $02571dfd61e26a65$export$a505f57c5130832f = ()=>(0, $6zXPf.getWillShowNav4)() && (0, $epTsa.expVal)('jira_theming_milestone_1', 'isEnabled', false);
const $02571dfd61e26a65$export$4fa2eaefe7d59f41 = ()=>$02571dfd61e26a65$export$a505f57c5130832f() && (0, $epTsa.expVal)('jira_theming_milestone_2', 'isEnabled', false);
const $02571dfd61e26a65$export$8a1bc0266a614408 = ()=>{
    if (!$02571dfd61e26a65$export$a505f57c5130832f()) return false;
    const [expConfig] = (0, $epTsa.UNSAFE_noExposureExp)('jira_theming_milestone_2');
    return expConfig.get('isEnabled', false);
};

});

parcelRegister("5vHl0", function(module, exports) {

$parcel$export(module.exports, "classicBacklogPageEntryPoint", () => $6a9c26c550c58f20$export$e07cd4fec395c8db);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $cw1BI = parcelRequire("cw1BI");

var $5DQfo = parcelRequire("5DQfo");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $9n5I0 = parcelRequire("9n5I0");
const $6a9c26c550c58f20$export$e07cd4fec395c8db = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cw1BI.nextGenBacklogEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("cw1BI", function(module, exports) {

$parcel$export(module.exports, "nextGenBacklogEntryPoint", () => $832138e73fefe1ea$export$377b23d5a7dc4052);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $832138e73fefe1ea$export$377b23d5a7dc4052 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("dQetM")), {
        moduleId: "20e1173f",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});

parcelRegister("5DQfo", function(module, exports) {

$parcel$export(module.exports, "nav4JSWProjectEntryPoint", () => $4c6f2233584e50c1$export$b1c3a10bbf92ce74);

var $gxGDD = parcelRequire("gxGDD");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");
const $4c6f2233584e50c1$var$NO_OF_BOARDS_TO_FETCH = 25;

const $4c6f2233584e50c1$export$b1c3a10bbf92ce74 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("8O79J")).then(({ JswExpandableProjectQuery: JswExpandableProjectQuery })=>JswExpandableProjectQuery), {
        moduleId: "69299f40",
        moduleName: "JswExpandableProjectQuery",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId ?? '';
        const projectKey = params.context?.match.params?.projectKey ?? '';
        return {
            queries: {
                projects: {
                    parameters: $gxGDD.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        noOfBoardsToFetch: $4c6f2233584e50c1$var$NO_OF_BOARDS_TO_FETCH
                    }
                }
            }
        };
    }
});

});
parcelRegister("gxGDD", function(module, exports) {

$parcel$export(module.exports, "default", () => $176b9f9eedc9a42f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e40ded01b81f7feeace8ee5b7256d3ba>>
 * @relayHash 097e9539e9354202b3e97195911da82f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a320080b485b09015939f9500e70d6187724b59304246a0240d200bc037c971

var $37Ewn = parcelRequire("37Ewn");
const $176b9f9eedc9a42f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "noOfBoardsToFetch"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v6 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JswExpandableProjectQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "noOfBoardsToFetch",
                                                    "variableName": "noOfBoardsToFetch"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "JswBoards"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "JswExpandableProjectQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "projectKey",
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "noOfBoardsToFetch"
                                        }
                                    ],
                                    "concreteType": "JiraBoardConnection",
                                    "kind": "LinkedField",
                                    "name": "boards",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraBoard",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraFavouriteValue",
                                                            "kind": "LinkedField",
                                                            "name": "favouriteValue",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canEdit"
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "mostRecentlyViewedBoard",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6a320080b485b09015939f9500e70d6187724b59304246a0240d200bc037c971",
            "metadata": {},
            "name": "JswExpandableProjectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$176b9f9eedc9a42f$var$node.hash = "c86c96423726df260003e830175ef141";
(0, $37Ewn.PreloadableQueryRegistry).set($176b9f9eedc9a42f$var$node.params.id, $176b9f9eedc9a42f$var$node);
var $176b9f9eedc9a42f$export$2e2bcd8739ae039 = $176b9f9eedc9a42f$var$node;

});

parcelRegister("8O79J", function(module, exports) {

let $66988b488cad43d2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $66988b488cad43d2$var$load("21WEI").then(()=>parcelRequire('f9s7v'));

});


parcelRegister("lixcc", function(module, exports) {

$parcel$export(module.exports, "nav4SidebarContentCoreEntryPoint", () => $7fe0cfb4720033ae$export$c5a39ebd1638fa7);

var $bBIDB = parcelRequire("bBIDB");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $7fe0cfb4720033ae$export$c5a39ebd1638fa7 = (0, $4BK1O.createEntryPoint)({
    // sidebar is critical to rendering the initial view of a page
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("iIXZF"))).then(({ SidebarContentForEntryPoint: SidebarContentForEntryPoint })=>SidebarContentForEntryPoint), {
        moduleId: "4c2c284d",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    // Result matches the generics of the async component's EntryPointProps
    // except for TComponentProps which is derived from `root`
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getPreloadProps (params) {
        const { context: context, tenantContext: tenantContext, entryPoints: entryPoints = {}, isAppsExpanded: isAppsExpanded, isFiltersExpanded: isFiltersExpanded, isPlansExpanded: isPlansExpanded, isProjectsExpanded: isProjectsExpanded, isOperationsExpanded: isOperationsExpanded, isOverviewsExpanded: isOverviewsExpanded } = params;
        // The two parameters have been injected by the theme setter, and should
        // not be here. Setting them naively just to be able to use the sidebar entryPoint again.
        const projectAri = '';
        const projectKey = context.match.params.projectKey || '';
        return {
            // Queries your async component uses
            queries: {
                nav4SidebarContentCore: {
                    // generated .graphql
                    parameters: (0, $bBIDB.default),
                    // variables for your query
                    variables: {
                        cloudId: tenantContext.cloudId,
                        isAppsExpanded: isAppsExpanded,
                        isFiltersExpanded: isFiltersExpanded,
                        isPlansExpanded: isPlansExpanded,
                        isProjectsExpanded: isProjectsExpanded,
                        isOperationsExpanded: isOperationsExpanded,
                        isOverviewsExpanded: isOverviewsExpanded,
                        projectAri: projectAri,
                        projectKey: projectKey,
                        entityAriProjects: `ari:cloud:jira:${tenantContext.cloudId}:navigation-settings/activation/${tenantContext.activationId}/projects`,
                        ownerAri: tenantContext.atlassianAccountId && `ari:cloud:identity::user/${tenantContext.atlassianAccountId}`,
                        isAnonymous: tenantContext.isAnonymous
                    },
                    // fetch options
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            entryPoints: entryPoints
        };
    }
});

});
parcelRegister("iIXZF", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $3a09b90cb30ff0be$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "SidebarContentForEntryPoint", () => $3a09b90cb30ff0be$export$ece6bd06aa8b2350);

var $eJOHy = parcelRequire("eJOHy");

var $1Can4 = parcelRequire("1Can4");

var $aasrU = parcelRequire("aasrU");

var $2y3Ci = parcelRequire("2y3Ci");

var $4gQWF = parcelRequire("4gQWF");

var $1KdDN = parcelRequire("1KdDN");

var $7jTnu = parcelRequire("7jTnu");

var $43SpR = parcelRequire("43SpR");

var $8IuE5 = parcelRequire("8IuE5");

var $hyK5y = parcelRequire("hyK5y");

var $eL2Ux = parcelRequire("eL2Ux");

var $ch9En = parcelRequire("ch9En");

var $9FYIg = parcelRequire("9FYIg");

var $cECwI = parcelRequire("cECwI");

var $16sa1 = parcelRequire("16sa1");

var $gCY1z = parcelRequire("gCY1z");

var $24QYf = parcelRequire("24QYf");

var $5IAcG = parcelRequire("5IAcG");
const $3a09b90cb30ff0be$export$49e8f7b58a4df4ea = ()=>{
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $43SpR.sidebarNav4Resource));
    const queryReferenceRef = (0, $eJOHy.useRef)(null);
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a09b90cb30ff0be$export$57e04c8c2365ae3b, null);
    // We don't want to use null query references. So only remember the non-null ones,
    // and pass the non-null query reference to the children.
    // From Slack: https://atlassian.slack.com/archives/C01E2MPPLE4/p1654736794416059?thread_ts=1654051102.548519&cid=C01E2MPPLE4
    if (queryReference) queryReferenceRef.current = queryReference;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a09b90cb30ff0be$export$a18798f247d81ed3, {
        queryReference: queryReferenceRef.current
    });
};
function $3a09b90cb30ff0be$export$ece6bd06aa8b2350({ queries: { nav4SidebarContentCore: nav4SidebarContentCore } }) {
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a09b90cb30ff0be$export$57e04c8c2365ae3b, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a09b90cb30ff0be$export$a18798f247d81ed3, {
        queryReference: nav4SidebarContentCore
    });
}
function $3a09b90cb30ff0be$export$a18798f247d81ed3({ queryReference: queryReference }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4-sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "l1-nav-menu-items",
        packageName: (0, $24QYf.PACKAGE_NAME),
        teamName: (0, $24QYf.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Can4.SideNavContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "l1-nav-menu-items",
        fallback: null
    }, queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5IAcG.L1MenuItems), {
        queryReference: queryReference
    })))), (0, $7jTnu.fg)('blu-2735_nav4_onboarding') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4gQWF.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hyK5y.SidebarReady), null)));
}
function $3a09b90cb30ff0be$export$57e04c8c2365ae3b() {
    const { formattedMessage: projectsMessage, icon: projectsIcon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).PROJECTS);
    const { formattedMessage: dashboardsMessage, icon: dashboardsIcon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).DASHBOARDS);
    const { formattedMessage: filtersMessage, icon: filtersIcon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).FILTERS);
    // We want to remove useRouter but the anonymous path is not as urgent as the authenticated path
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "l1-nav-menu-items",
        packageName: (0, $24QYf.PACKAGE_NAME),
        teamName: (0, $24QYf.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Can4.SideNavContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "l1-nav-menu-items",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aasrU.LinkMenuItem), {
        elemBefore: projectsIcon,
        href: "/jira/projects",
        isSelected: match.path.startsWith('/jira/projects')
    }, projectsMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aasrU.LinkMenuItem), {
        elemBefore: filtersIcon,
        href: "/jira/filters",
        isSelected: match.path === '/jira/filters' || match.path.startsWith('/issues/')
    }, filtersMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aasrU.LinkMenuItem), {
        elemBefore: dashboardsIcon,
        href: "/jira/dashboards",
        isSelected: match.path.startsWith('/jira/dashboards')
    }, dashboardsMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hyK5y.SidebarReady), null));
}

});
parcelRegister("1Can4", function(module, exports) {

$parcel$export(module.exports, "SideNavContent", () => $ec93e96acbf8dfe5$export$babe3c784778f3ba);
/* side-nav-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $ec93e96acbf8dfe5$export$babe3c784778f3ba = /*#__PURE__*/ (0, $eJOHy.forwardRef)($ec93e96acbf8dfe5$var$_SideNavContent);
// Placing this const below the function breaks Compiled!
const $ec93e96acbf8dfe5$var$styles = {
    scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
    paddingContainer: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
function $ec93e96acbf8dfe5$var$_SideNavContent({ children: children, testId: testId }, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            $ec93e96acbf8dfe5$var$styles.scrollContainer
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                $ec93e96acbf8dfe5$var$styles.paddingContainer
            ]),
            children: children
        })
    });
}

});

parcelRegister("aasrU", function(module, exports) {

$parcel$export(module.exports, "LinkMenuItem", () => $64af9b033f42d5ad$export$d2cad7a1cce7b35f);
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $i15ln = parcelRequire("i15ln");

var $bXLyf = parcelRequire("bXLyf");

var $jUTnI = parcelRequire("jUTnI");

var $gX9lg = parcelRequire("gX9lg");

var $l1rJl = parcelRequire("l1rJl");
const $64af9b033f42d5ad$var$listItemStyles = {
    root: "_10m98stt"
};
const $64af9b033f42d5ad$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $eJOHy.useRef)(null);
    (0, $l1rJl.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $eJOHy.useMemo)(()=>{
        return (0, $i15ln.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jUTnI.ListItem), {
        ref: ref,
        xcss: $64af9b033f42d5ad$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gX9lg.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
const $64af9b033f42d5ad$export$d2cad7a1cce7b35f = (0, $bXLyf.forwardRefWithGeneric)($64af9b033f42d5ad$var$LinkMenuItemNoRef);

});
parcelRegister("gX9lg", function(module, exports) {

$parcel$export(module.exports, "MenuItemBase", () => $d7194b1617ea92e3$export$859b390bf71e044e);
/* menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $knRBp = parcelRequire("knRBp");

var $i15ln = parcelRequire("i15ln");

var $dPUtJ = parcelRequire("dPUtJ");
var $hBR2B = parcelRequire("hBR2B");
var $h8epd = parcelRequire("h8epd");

var $9JB3T = parcelRequire("9JB3T");
var $4ZSsl = parcelRequire("4ZSsl");

var $bXLyf = parcelRequire("bXLyf");


var $bkAOK = parcelRequire("bkAOK");

var $fJbMZ = parcelRequire("fJbMZ");

var $9aTgN = parcelRequire("9aTgN");

// Using `lazy` so that only consumers who want drag and drop
// need to include code for the drag handle.
const $d7194b1617ea92e3$var$LazyDragHandle = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4RNrf")));
const $d7194b1617ea92e3$var$tooltipStyles = {
    root: "_2rkoglpi _11c8dcr7 _1e0c1txw _2lx21bp4 _1bah1h6o _1tkezwfg _p12f1pna _vchhusvi _1q51v77o _y4ti12x7 _85i5v77o _bozg12x7 _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _slp31hna"
};
const $d7194b1617ea92e3$var$MenuItemTooltip = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function MenuItemTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4ZSsl.default), {
        ...rest,
        // Manually passing on `className` so it gets merged correctly in the build output.
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $d7194b1617ea92e3$var$tooltipStyles.root,
            className
        ]),
        // "css" does not "exist" - it gets transformed into "className" by compiled
        ref: ref,
        children: children
    });
});
function $d7194b1617ea92e3$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $d7194b1617ea92e3$var$defaultAvatarValues = {
    size: 'small'
};
const $d7194b1617ea92e3$var$elemAfterDisplayVar = '--elem-after-display';
const $d7194b1617ea92e3$var$actionsOnHoverDisplayVar = '--actions-on-hover-display';
const $d7194b1617ea92e3$var$notchColorVar = '--notch-color';
// Note: this is also used in `drag-handle.tsx`
const $d7194b1617ea92e3$var$dragHandleDisplayVar = '--drag-handle-display';
const $d7194b1617ea92e3$var$dragCursorAnimation = null;
/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. drop indicators for drag and drop
 * 3. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */ const $d7194b1617ea92e3$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
};
/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */ const $d7194b1617ea92e3$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
};
const $d7194b1617ea92e3$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup="true"])';
const $d7194b1617ea92e3$var$containerStyles = {
    root: "_2rkoglpi _vchhusvi _1e0c11p5 _yv0e7dup _2z05hkll _1lmcu4vt _1ul9t9kd _4t3iviql _4cvr1h6o _uiztglyw _syaz1gjq _ek6gglyw _1yyu3acm _91ju1txw _1swv108i _1ojv1txw _irr3108i _1brr1txw _109x1txw",
    removeElemAfter: "_91juglyw",
    showHoverActions: "_ek6g1txw",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1djyglyw _1mfcglyw _1sjuglyw",
    selected: "_bfhkfg4m _syazaqb7 _1yyu1fvw _1swvi1yw _30l3aqb7 _irr3i1yw",
    disabled: "_syaz1lh4 _irr3n7od",
    hasDescription: "_4t3i1wto",
    dragging: "_tzy41ou4"
};
const $d7194b1617ea92e3$var$buttonOrAnchorStyles = {
    root: "_2rkoglpi _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _2z05nbh3 _y4ti1b66 _bozg1b66 _1q511b66 _85i51b66 _bfhk18uv _syaz1gjq _4cvr1h6o _y3gnv2br _14iu1ji5",
    selected: "_syazaqb7 _14iu19ru",
    hasDragIndicator: "_1ifmglyw _1cykglyw _x0kw1txw _7psyru3m _11om6b4r _1uy01amc _bir2q7pw"
};
const $d7194b1617ea92e3$var$extendButtonOrAnchorStyles = {
    root: "_1r04ze3t _kqswstnw"
};
const $d7194b1617ea92e3$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
const $d7194b1617ea92e3$var$actionStyles = {
    root: "_zulp1b66 _nd5lbc26 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $d7194b1617ea92e3$var$actionsOnHoverStyles = {
    root: "_nd5l16dh _zulp1b66 _1reo15vq _18m915vq _1e0c1c3z _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $d7194b1617ea92e3$var$textStyles = {
    root: "_zulpv77o _1reo15vq _18m915vq _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
    noElemBeforeIndent: "_bozg12x7"
};
const $d7194b1617ea92e3$var$elemBeforeStyles = {
    root: "_nd5l17zh _1reo15vq _18m915vq _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh18uv _1guo18uv _12s918uv"
};
const $d7194b1617ea92e3$var$elemAfterStyles = {
    root: "_nd5l16dh _1reo15vq _18m915vq _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
/**
 * We are using a wrapping element for our interactive content
 * even though only the `Text` element is the only thing not using `position:absolute`
 *
 * Rationale:
 * - Super clear that everything inside the interactive content should be in a specific slot in the grid
 * - To work around a browser bug in Safari where it does not work well with `position:absolute`
 *   on a subgrid child.
 *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
 */ const $d7194b1617ea92e3$var$interactiveContentStyles = {
    root: "_nd5l19l3 _1e0c1txw _2lx21bp4 _ae4v1h6o"
};
function $d7194b1617ea92e3$var$getTextColor({ isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'color.text.disabled';
    if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
}
/**
 * This is the internal version of the component, to be passed into `forwardRef`.
 *
 * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
 * This can be inferred from the type of the `onClick` prop.
 */ const $d7194b1617ea92e3$var$MenuItemBaseNoRef = ({ id: id, testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const level = (0, $bkAOK.useLevel)();
    const setFlyoutMenuOpen = (0, $fJbMZ.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $fJbMZ.useFlyoutMenuOpen)();
    const isLink = typeof href !== 'undefined';
    const labelRef = (0, $eJOHy.useRef)(null);
    const descriptionRef = (0, $eJOHy.useRef)(null);
    const tooltipOnClick = (0, $eJOHy.useRef)(null);
    const handleClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
        tooltipOnClick.current?.(event);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]);
    /**
   * Show the tooltip if _either_ label or description is truncated
   */ const canTooltipAppear = (0, $eJOHy.useCallback)(()=>{
        if (isContentTooltipDisabled) return false;
        // Show tooltip if _either_ label or description are clamped
        const label = labelRef.current;
        const description = descriptionRef.current;
        if (label && $d7194b1617ea92e3$var$isTextClamped(label)) return true;
        return Boolean(description && $d7194b1617ea92e3$var$isTextClamped(description));
    }, [
        isContentTooltipDisabled
    ]);
    // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $9aTgN.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        className: (0, $hcewu.default)([
            $d7194b1617ea92e3$var$interactiveContentStyles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                // This extends the clickable area of nested menu items to the width
                // of the root level menu items, while being visually indented.
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                style: {
                    insetInlineStart: `calc(-1 * ${level} * ${(0, $b48249e9321e9314$export$d492445a79a49b48)})`
                },
                "aria-hidden": "true",
                className: (0, $hcewu.default)([
                    $d7194b1617ea92e3$var$extendButtonOrAnchorStyles.root
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    $d7194b1617ea92e3$var$textStyles.root,
                    !showElemBefore && $d7194b1617ea92e3$var$textStyles.noElemBeforeIndent
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8epd.default), {
                        weight: "medium",
                        maxLines: 1,
                        color: $d7194b1617ea92e3$var$getTextColor({
                            isDisabled: isDisabled,
                            isSelected: isSelected
                        }),
                        ref: labelRef,
                        children: children
                    }),
                    description && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8epd.default), {
                        color: isDisabled ? 'color.text.disabled' : 'color.text.subtle',
                        size: "small",
                        maxLines: 1,
                        ref: descriptionRef,
                        children: description
                    })
                ]
            }),
            hasDragIndicator ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($d7194b1617ea92e3$var$LazyDragHandle, {})
            }) : null,
            dropIndicator
        ]
    });
    /**
   *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
   *
   * Note: we also remove the `elemAfter` when showing `actionsOnHover`
   */ const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $knRBp.AvatarContext).Provider, {
        value: $d7194b1617ea92e3$var$defaultAvatarValues,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            ref: visualContentRef,
            "data-testid": testId ? `${testId}-container` : undefined,
            "data-selected": isSelected,
            className: (0, $hcewu.default)([
                $d7194b1617ea92e3$var$containerStyles.root,
                isSelected && $d7194b1617ea92e3$var$containerStyles.selected,
                isDragging && $d7194b1617ea92e3$var$containerStyles.dragging,
                description && $d7194b1617ea92e3$var$containerStyles.hasDescription,
                showHoverActionsWhenNotHovered && $d7194b1617ea92e3$var$containerStyles.showHoverActions,
                showHoverActionsWhenNotHovered && elemAfter && $d7194b1617ea92e3$var$containerStyles.removeElemAfter,
                actionsOnHover && elemAfter && $d7194b1617ea92e3$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
                isDisabled && $d7194b1617ea92e3$var$containerStyles.disabled
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9JB3T.default), {
                    content: ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                    children: children
                                }),
                                description ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                    children: description
                                }) : null
                            ]
                        }),
                    position: "right",
                    // NOTE: Types in React 18 have changed and `forwardRef(() => <TooltipPrimitive>)` no longer appears to match 100%
                    component: $d7194b1617ea92e3$var$MenuItemTooltip,
                    ignoreTooltipPointerEvents: true,
                    hideTooltipOnMouseDown: true,
                    // We don't need a duplicate hidden element containing tooltip content
                    // as the content of the tooltip matches what is rendered for the menu item.
                    isScreenReaderAnnouncementDisabled: true,
                    canAppear: canTooltipAppear,
                    children: (tooltipProps)=>{
                        // Putting the tooltip onClick into a ref.
                        // This way we don't need to create a new `onClick` function on each
                        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
                        tooltipOnClick.current = tooltipProps.onClick;
                        const sharedProps = {
                            ...tooltipProps,
                            'aria-controls': ariaControls,
                            'aria-haspopup': ariaHasPopup,
                            ref: (0, $i15ln.default)([
                                forwardedRef,
                                tooltipProps.ref
                            ]),
                            id: id,
                            testId: testId,
                            interactionName: interactionName
                        };
                        return isLink ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dPUtJ.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $k0ahr.cx)($d7194b1617ea92e3$var$buttonOrAnchorStyles.root, $d7194b1617ea92e3$var$topLevelSiblingStyles.root, isSelected && $d7194b1617ea92e3$var$buttonOrAnchorStyles.selected, hasDragIndicator && $d7194b1617ea92e3$var$buttonOrAnchorStyles.hasDragIndicator),
                            // Needed to override Anchor style due to a compiled/emotion conflict
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            style: {
                                textDecoration: 'none'
                            },
                            "aria-current": isSelected ? 'page' : undefined,
                            href: href,
                            target: target,
                            /**
           * For anchors we don't want to have the standard drag and drop behaviour.
           *
           * Thinking on the topic:
           *
           * - Anchors look visually similar to buttons in the sidenav
           * - Why should some menu items be natively draggable, while others are not?
           * - A user cannot know which menu items are "natively" draggable (ie anchors)
           * - If you wire up an anchor to be draggable using our standard affordances
           *   it will have a different preview experience to native anchor dragging.
           *
           * To promote consistency, all elements need to use the same visual affordances.
           *
           * Anchor elements will automatically attach URL information
           * to the native data store.
           *
           * When `hasDragIndicator` is `true` we are expecting consumers to register
           * the element as draggable through the `draggable()` Pragmatic drag and drop function.
           * The `draggable()` function will add `draggable="true"` to the element.
           */ draggable: hasDragIndicator ? undefined : false,
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: (0, $hcewu.default)([
                                        $d7194b1617ea92e3$var$notchStyles.root
                                    ])
                                }),
                                interactiveElemContent
                            ]
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hBR2B.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $k0ahr.cx)($d7194b1617ea92e3$var$buttonOrAnchorStyles.root, $d7194b1617ea92e3$var$topLevelSiblingStyles.root, isSelected && $d7194b1617ea92e3$var$buttonOrAnchorStyles.selected, hasDragIndicator && $d7194b1617ea92e3$var$buttonOrAnchorStyles.hasDragIndicator),
                            "aria-expanded": ariaExpanded,
                            isDisabled: isDisabled,
                            children: interactiveElemContent
                        });
                    }
                }),
                showElemBefore && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $d7194b1617ea92e3$var$elemBeforeStyles.root,
                        $d7194b1617ea92e3$var$topLevelSiblingStyles.root,
                        $d7194b1617ea92e3$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemBefore
                }),
                actionsOnHover && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $d7194b1617ea92e3$var$actionsOnHoverStyles.root
                    ]),
                    children: actionsOnHover
                }),
                elemAfter && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $d7194b1617ea92e3$var$elemAfterStyles.root,
                        $d7194b1617ea92e3$var$topLevelSiblingStyles.root,
                        $d7194b1617ea92e3$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemAfter
                }),
                actions && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $d7194b1617ea92e3$var$actionStyles.root,
                        $d7194b1617ea92e3$var$topLevelSiblingStyles.root,
                        $d7194b1617ea92e3$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: actions
                })
            ]
        })
    });
};
const $d7194b1617ea92e3$export$859b390bf71e044e = (0, $bXLyf.forwardRefWithGeneric)($d7194b1617ea92e3$var$MenuItemBaseNoRef);

});
/**
 * _Internally_ shared value for the menu item indentation. Used in:
 * - Expandable menu item content, to add padding for each expandable level
 * - The base menu item, to set the negative inset to extend the clickable area of nested menu items
 * to the root level menu items.
 *
 * Internal to the package only. Should not be exported from the package.
 *
 * Note: We're unable to use a token() call here, as Compiled complains about function calls in imported
 * values - it requires statically defined values only.
 *
 * @private
 * @internal
 */ const $b48249e9321e9314$export$d492445a79a49b48 = '12px';

parcelRegister("bkAOK", function(module, exports) {

$parcel$export(module.exports, "AreAllAncestorsExpandedContext", () => $bc08710a4ba099d5$export$9c01e0e6a504d553);
$parcel$export(module.exports, "IsExpandedContext", () => $bc08710a4ba099d5$export$c856e5885cc34d81);
$parcel$export(module.exports, "SetIsExpandedContext", () => $bc08710a4ba099d5$export$48cb11cb8691f597);
$parcel$export(module.exports, "OnExpansionToggleContext", () => $bc08710a4ba099d5$export$572ce188c913ceba);
$parcel$export(module.exports, "LevelContext", () => $bc08710a4ba099d5$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "useIsExpanded", () => $bc08710a4ba099d5$export$37e565a09598825e);
$parcel$export(module.exports, "useSetIsExpanded", () => $bc08710a4ba099d5$export$c9a171ea8de5861b);
$parcel$export(module.exports, "useOnExpansionToggle", () => $bc08710a4ba099d5$export$56c8438498b72c7a);
$parcel$export(module.exports, "useLevel", () => $bc08710a4ba099d5$export$fdfe9e5e8183d4f2);
$parcel$export(module.exports, "useAreAllAncestorsExpanded", () => $bc08710a4ba099d5$export$57108b5f08ae5194);

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $cfkQt = parcelRequire("cfkQt");
const $bc08710a4ba099d5$export$9c01e0e6a504d553 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $bc08710a4ba099d5$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $bc08710a4ba099d5$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $bc08710a4ba099d5$export$572ce188c913ceba = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $bc08710a4ba099d5$export$650d12d3c2ddb8fc = (0, $cfkQt.ExpandableMenuItemLevelContext);
const $bc08710a4ba099d5$export$37e565a09598825e = ()=>{
    const context = (0, $eJOHy.useContext)($bc08710a4ba099d5$export$c856e5885cc34d81);
    (0, $8GOss.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $bc08710a4ba099d5$export$c9a171ea8de5861b = ()=>{
    const context = (0, $eJOHy.useContext)($bc08710a4ba099d5$export$48cb11cb8691f597);
    (0, $8GOss.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $bc08710a4ba099d5$export$56c8438498b72c7a = ()=>(0, $eJOHy.useContext)($bc08710a4ba099d5$export$572ce188c913ceba);
const $bc08710a4ba099d5$export$fdfe9e5e8183d4f2 = ()=>(0, $eJOHy.useContext)($bc08710a4ba099d5$export$650d12d3c2ddb8fc);
const $bc08710a4ba099d5$export$57108b5f08ae5194 = ()=>(0, $eJOHy.useContext)($bc08710a4ba099d5$export$9c01e0e6a504d553) ?? true;

});
parcelRegister("cfkQt", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemLevelContext", () => $5aca9187de8ddebb$export$f8d6463f9b5ca897);

var $eJOHy = parcelRequire("eJOHy");
const $5aca9187de8ddebb$export$f8d6463f9b5ca897 = /*#__PURE__*/ (0, $eJOHy.createContext)(0);

});


parcelRegister("fJbMZ", function(module, exports) {

$parcel$export(module.exports, "IsOpenContext", () => $39dccb7cacbe1710$export$efa4d9670e96ac31);
$parcel$export(module.exports, "SetIsOpenContext", () => $39dccb7cacbe1710$export$4c55b1c61a116b42);
$parcel$export(module.exports, "useFlyoutMenuOpen", () => $39dccb7cacbe1710$export$6927118f874a49aa);
$parcel$export(module.exports, "useSetFlyoutMenuOpen", () => $39dccb7cacbe1710$export$538ac1aa421adb94);

var $eJOHy = parcelRequire("eJOHy");

var $9pZRF = parcelRequire("9pZRF");
const $39dccb7cacbe1710$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $39dccb7cacbe1710$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $eJOHy.createContext)((0, $9pZRF.default));
const $39dccb7cacbe1710$export$6927118f874a49aa = ()=>(0, $eJOHy.useContext)($39dccb7cacbe1710$export$efa4d9670e96ac31);
const $39dccb7cacbe1710$export$538ac1aa421adb94 = ()=>(0, $eJOHy.useContext)($39dccb7cacbe1710$export$4c55b1c61a116b42);

});

parcelRegister("9aTgN", function(module, exports) {

$parcel$export(module.exports, "COLLAPSE_ELEM_BEFORE", () => $9fc0f1da2d1585ff$export$f4b8e24fae579c6f);
/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */ const $9fc0f1da2d1585ff$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');

});

parcelRegister("4RNrf", function(module, exports) {

let $38b2761748039e04$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $38b2761748039e04$var$load("bv86X").then(()=>parcelRequire('fC8PD'));

});


parcelRegister("l1rJl", function(module, exports) {

$parcel$export(module.exports, "useScrollMenuItemIntoView", () => $20141269f3604a07$export$2c52ec851fcc6058);

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $bkAOK = parcelRequire("bkAOK");
function $20141269f3604a07$var$scrollMenuItemIntoView(element) {
    /**
	 * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
	 * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
	 * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
	 *
	 * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
	 */ if (typeof element.scrollIntoViewIfNeeded === 'function') {
        element.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $20141269f3604a07$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $bkAOK.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $eJOHy.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $eJOHy.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $8GOss.default)(element, 'Element ref must be set');
            $20141269f3604a07$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}

});


parcelRegister("2y3Ci", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $caf22c06976d8461$export$d4c4e98c5044dc8);

var $jKePJ = parcelRequire("jKePJ");
const $caf22c06976d8461$export$d4c4e98c5044dc8 = (0, $jKePJ.List);

});

parcelRegister("4gQWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f9b14046ba9a98$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $1KdDN = parcelRequire("1KdDN");

var $gzcjr = parcelRequire("gzcjr");

var $7jTnu = parcelRequire("7jTnu");

const $f6f9b14046ba9a98$var$LazyAtlassianOnboardingNav4 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("4ZEYs")).then(({ Nav4Onboarding: Nav4Onboarding })=>Nav4Onboarding), {
    moduleId: "./src/packages/navigation-apps/onboarding-nav4/src/index.tsx"
});
const $f6f9b14046ba9a98$var$AsyncAtlassianOnboardingNav4 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    if ((0, $7jTnu.fg)('jfp-magma-fix-misaligned-suspense-boundaries')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "asyncAtlassianOnboardingNav4",
        packageName: "jiraAtlassianOnboardingNav4",
        teamName: "jira-cosmos",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "lazyAtlassianOnboardingNav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f6f9b14046ba9a98$var$LazyAtlassianOnboardingNav4, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "asyncAtlassianOnboardingNav4",
        packageName: "jiraAtlassianOnboardingNav4",
        teamName: "jira-cosmos",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderUFOMigration), {
        name: "lazyAtlassianOnboardingNav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f6f9b14046ba9a98$var$LazyAtlassianOnboardingNav4, null)));
});
$f6f9b14046ba9a98$var$AsyncAtlassianOnboardingNav4.displayName = 'AsyncAtlassianOnboardingNav4';
var $f6f9b14046ba9a98$export$2e2bcd8739ae039 = $f6f9b14046ba9a98$var$AsyncAtlassianOnboardingNav4;

});
parcelRegister("4ZEYs", function(module, exports) {

let $3a2ca48f3cfed50b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3a2ca48f3cfed50b$var$load("aouA3").then(()=>parcelRequire('7vWRj'));

});


parcelRegister("8IuE5", function(module, exports) {

$parcel$export(module.exports, "L1_MENU_ID", () => $63cd73d0cb684b2a$export$918aea3cf024d90b);

var $h4Bzb = parcelRequire("h4Bzb");
const $63cd73d0cb684b2a$var$OPERATIONS_MENU_ID = {
    OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
    OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
};
const $63cd73d0cb684b2a$export$bb47524d7f3cb1f8 = {
    ...(0, $h4Bzb.CONFIGURABLE_MENU_ID),
    BOARDS: 'jira.sidebar.boards',
    QUEUES: 'jira.sidebar.queues',
    ALL: 'jira.sidebar.all'
};
const $63cd73d0cb684b2a$export$918aea3cf024d90b = {
    YOUR_WORK: 'jira.sidebar.yourWork',
    ...(0, $h4Bzb.CONFIGURABLE_MENU_ID),
    ...$63cd73d0cb684b2a$var$OPERATIONS_MENU_ID
};

});

parcelRegister("hyK5y", function(module, exports) {

$parcel$export(module.exports, "useSidebarExperience", () => $64b27843cfe69100$export$d4fa533dfe4d7583);
$parcel$export(module.exports, "SidebarStart", () => $64b27843cfe69100$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarReady", () => $64b27843cfe69100$export$a06ecbbe5820282);

var $eJOHy = parcelRequire("eJOHy");

var $kfdcR = parcelRequire("kfdcR");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $hih5V = parcelRequire("hih5V");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $TLYhw = parcelRequire("TLYhw");

var $eFrz1 = parcelRequire("eFrz1");
const $64b27843cfe69100$export$d4fa533dfe4d7583 = ()=>{
    const pageId = (0, $TLYhw.usePageId)();
    return (0, $eJOHy.useMemo)(()=>({
            experience: 'viewSidebarNavigation',
            experienceId: pageId,
            analyticsSource: 'Sidebar',
            attributes: {
                sidebar: 'v4'
            }
        }), [
        pageId
    ]);
};
const $64b27843cfe69100$export$6738d1299dc79710 = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const { experience: experience, experienceId: experienceId, analyticsSource: analyticsSource } = $64b27843cfe69100$export$d4fa533dfe4d7583();
    const onStartExperience = (0, $8Uqf3.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource
    });
    (0, $eJOHy.useEffect)(()=>{
        if (route.isRedirect) return;
        onStartExperience();
    }, [
        onStartExperience,
        route
    ]);
    return null;
};
const $64b27843cfe69100$export$a06ecbbe5820282 = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const { experience: experience, attributes: attributes } = $64b27843cfe69100$export$d4fa533dfe4d7583();
    const onSuccessfulExperience = (0, $4ctwv.useExperienceSuccess)({
        experience: experience,
        attributes: attributes
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const doNotRunEffects = route.isRedirect || false;
    const sidebarId = route.navigation?.sidebarId ?? 'default';
    (0, $eFrz1.useEffectWithoutConcurrency)(()=>{
        if (doNotRunEffects) return;
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $gCeeo.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        doNotRunEffects,
        routeName
    ]);
    (0, $eFrz1.useEffectWithoutConcurrency)(()=>{
        if (doNotRunEffects) return;
        onSuccessfulExperience();
    }, [
        doNotRunEffects,
        onSuccessfulExperience,
        route
    ]);
    const customData = (0, $eJOHy.useMemo)(()=>({
            sidebarType: sidebarId
        }), [
        sidebarId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kfdcR.default), {
        data: customData
    });
};

});
parcelRegister("kfdcR", function(module, exports) {

$parcel$export(module.exports, "default", () => $572ba5d513971e9c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $572ba5d513971e9c$export$d12f56a472cdbe6c);

var $eJOHy = parcelRequire("eJOHy");

var $cv2et = parcelRequire("cv2et");

var $1JCFI = parcelRequire("1JCFI");

var $3TY2E = parcelRequire("3TY2E");
function $572ba5d513971e9c$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $cv2et.default));
    (0, $eJOHy.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof globalThis?.structuredClone === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $572ba5d513971e9c$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $1JCFI.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof globalThis?.structuredClone === 'function') (0, $3TY2E.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $3TY2E.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("eFrz1", function(module, exports) {

$parcel$export(module.exports, "useEffectWithoutConcurrency", () => $a5e28192b76c8457$export$e44126cd87ea434);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $8GOss = parcelRequire("8GOss");
function $a5e28192b76c8457$export$e44126cd87ea434(effect, dependencies) {
    const effectCalledRef = (0, $eJOHy.useRef)(false);
    const depsRef = (0, $eJOHy.useRef)(dependencies);
    (0, $eJOHy.useEffect)(()=>{
        // If the dependencies have changed, reset the state of the ref.
        // This is how we catch the strict-mode execution.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(depsRef.current, dependencies)) {
            depsRef.current = dependencies;
            effectCalledRef.current = false;
        }
        // If the effect has already executed, we shouldn't be executing again unless we do a cleanup first.
        // This is the code that ignores the strict-mode update
        if (effectCalledRef.current) return;
        // Set this immediately
        effectCalledRef.current = true;
        const cleanup = effect();
        // If we do get a cleanup function, throw an error
        (0, $8GOss.default)(typeof cleanup !== 'function', 'useEffectWithoutConcurrency() cannot be used with cleanup functions');
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

});


parcelRegister("eL2Ux", function(module, exports) {

$parcel$export(module.exports, "useConfigurableMessageAndIconMap", () => $513523b89184a8db$export$783a136280b37c09);
$parcel$export(module.exports, "getConfigurableMessageAndIcon", () => $513523b89184a8db$export$56ffc7f3df8fae03);

var $7jTnu = parcelRequire("7jTnu");

var $h4Bzb = parcelRequire("h4Bzb");

var $epTsa = parcelRequire("epTsa");

var $5Q9JR = parcelRequire("5Q9JR");

var $2QH3X = parcelRequire("2QH3X");
const $513523b89184a8db$export$783a136280b37c09 = (menuId)=>{
    const { message: message, Icon: Icon } = $513523b89184a8db$export$56ffc7f3df8fae03(menuId);
    return (0, $2QH3X.useFormattedMessageAndIcon)(message, Icon);
};
const $513523b89184a8db$export$56ffc7f3df8fae03 = (menuId)=>{
    // To clean up blu-7649_jira_project_icon_terminology_refresh, replace the Icon in CONFIGURABLE_MESSAGE_AND_ICON_MAP
    // This can't be feature-gated in the module-level constants file.
    const CONFIGURABLE_MESSAGE_AND_ICON_MAP = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $5Q9JR.CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM) : (0, $5Q9JR.CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM);
    const { message: message, Icon: Icon } = menuId === (0, $h4Bzb.CONFIGURABLE_MENU_ID).PROJECTS && (0, $7jTnu.fg)('blu-7649_jira_project_icon_terminology_refresh') ? (0, $5Q9JR.SPACES_MESSAGE_AND_ICON_MAP) : CONFIGURABLE_MESSAGE_AND_ICON_MAP[menuId];
    return {
        message: message,
        Icon: Icon
    };
};

});
parcelRegister("5Q9JR", function(module, exports) {

$parcel$export(module.exports, "MENU_GROUP_MIN_WIDTH", () => $15777f70405f0cfb$export$47f3715a07cde7e8);
$parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", () => $15777f70405f0cfb$export$f5a7bd7eb586e4e8);
$parcel$export(module.exports, "GLOBAL_APP_MENU_IDS_AS_STRINGS", () => $15777f70405f0cfb$export$de634ec0f98ab74b);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM", () => $15777f70405f0cfb$export$9a6cc3b78524c807);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_AND_ICON_MAP", () => $15777f70405f0cfb$export$5034ad0032cd499d);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_STRING", () => $15777f70405f0cfb$export$b66ae8c18ec95bc6);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING_WITHOUT_PROJECT_TERM", () => $15777f70405f0cfb$export$4da83c858d129f7f);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM", () => $15777f70405f0cfb$export$9c99028e1421f69f);
$parcel$export(module.exports, "SPACES_MESSAGE_AND_ICON_MAP", () => $15777f70405f0cfb$export$8dca85fd20e1d57f);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING_WITH_PROJECT_TERM", () => $15777f70405f0cfb$export$a9a6fdcb59a8001e);
$parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", () => $15777f70405f0cfb$export$9fcc53f3b36e0949);
$parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", () => $15777f70405f0cfb$export$2eb8dda9e83d33ff);
$parcel$export(module.exports, "NAV4_OPT_OUT_FEEDBACK_GROUP_ID", () => $15777f70405f0cfb$export$9cf873ba2e9a3ce0);
$parcel$export(module.exports, "NAV4_GENERAL_FEEDBACK_GROUP_ID", () => $15777f70405f0cfb$export$a495ba70b16d4d90);
$parcel$export(module.exports, "NO_OF_BOARDS_TO_SHOW", () => $15777f70405f0cfb$export$89de709e88232646);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_STRING_NEW", () => $15777f70405f0cfb$export$f48a8d7010265bd7);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING_WITHOUT_PROJECT_TERM_NEW", () => $15777f70405f0cfb$export$f13ce1d5efbe11a1);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING_WITH_PROJECT_TERM_NEW", () => $15777f70405f0cfb$export$e4cb30926a9b6ca1);

var $bvCpT = parcelRequire("bvCpT");

var $ee8U1 = parcelRequire("ee8U1");

var $kAGKy = parcelRequire("kAGKy");

var $2IWvf = parcelRequire("2IWvf");

var $ka38s = parcelRequire("ka38s");

var $7eM4W = parcelRequire("7eM4W");

var $HIU94 = parcelRequire("HIU94");

var $4BXjD = parcelRequire("4BXjD");

var $7C6KX = parcelRequire("7C6KX");

var $4CndS = parcelRequire("4CndS");

var $l18LW = parcelRequire("l18LW");

var $eZT0g = parcelRequire("eZT0g");

var $e6kMq = parcelRequire("e6kMq");

var $kTwXj = parcelRequire("kTwXj");

var $474nX = parcelRequire("474nX");

var $33MRY = parcelRequire("33MRY");

var $Apni8 = parcelRequire("Apni8");

var $980v4 = parcelRequire("980v4");

var $1jsTl = parcelRequire("1jsTl");

var $g6zOZ = parcelRequire("g6zOZ");

var $6mPMG = parcelRequire("6mPMG");

var $dieBt = parcelRequire("dieBt");

var $5ukg0 = parcelRequire("5ukg0");

var $lHQXb = parcelRequire("lHQXb");

var $4ioMO = parcelRequire("4ioMO");

var $hgfY7 = parcelRequire("hgfY7");

var $h4Bzb = parcelRequire("h4Bzb");

var $hEgdr = parcelRequire("hEgdr");

var $8IuE5 = parcelRequire("8IuE5");
const $15777f70405f0cfb$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
const $15777f70405f0cfb$export$d57b6b390e78d90f = 'jira-cosmos';
const $15777f70405f0cfb$export$47f3715a07cde7e8 = 250;
const $15777f70405f0cfb$export$421b92818c76ee2d = Object.values((0, $h4Bzb.CONFIGURABLE_MENU_ID));
const $15777f70405f0cfb$export$f5a7bd7eb586e4e8 = $15777f70405f0cfb$export$421b92818c76ee2d;
const $15777f70405f0cfb$export$c52c93cc28495ab0 = Object.values((0, $h4Bzb.GLOBAL_APP_MENU_ID));
const $15777f70405f0cfb$export$de634ec0f98ab74b = $15777f70405f0cfb$export$c52c93cc28495ab0;
const $15777f70405f0cfb$export$9a6cc3b78524c807 = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: {
        message: (0, $hEgdr.default).apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ee8U1)))
    },
    [(0, $8IuE5.L1_MENU_ID).GOALS]: {
        message: (0, $hEgdr.default).goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4BXjD)))
    },
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: {
        message: (0, $hEgdr.default).roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bvCpT)))
    },
    [(0, $8IuE5.L1_MENU_ID).PLANS]: {
        message: (0, $hEgdr.default).plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($980v4)))
    },
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: {
        message: (0, $hEgdr.default).projectsGalaxia,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($33MRY)))
    },
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: {
        message: (0, $hEgdr.default).filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7eM4W)))
    },
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $hEgdr.default).dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ka38s)))
    },
    [(0, $8IuE5.L1_MENU_ID).COMMUNICATION]: {
        message: (0, $hEgdr.default).communication,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4ioMO)))
    },
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $hEgdr.default).overviews,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($HIU94)))
    },
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: {
        message: (0, $hEgdr.default).operations,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hgfY7)))
    },
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: {
        message: (0, $hEgdr.default).assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kAGKy)))
    },
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: {
        message: (0, $hEgdr.default).teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($g6zOZ)))
    },
    [(0, $8IuE5.L1_MENU_ID).RECENT]: {
        message: (0, $hEgdr.default).recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2IWvf)))
    },
    [(0, $8IuE5.L1_MENU_ID).STARRED]: {
        message: (0, $hEgdr.default).starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jsTl)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $hEgdr.default).customerService,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7C6KX)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $hEgdr.default).customerHubs,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4CndS)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $hEgdr.default).customerServiceAnalytics,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lHQXb)))
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $hEgdr.default).assets,
        Icon: (0, $dieBt.AssetsIcon)
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $hEgdr.default).goals,
        Icon: (0, $5ukg0.GoalsIcon)
    },
    // App Shortcuts for Platform Component
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $hEgdr.default).confluence,
        Icon: (0, $l18LW.ConfluenceIcon)
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $hEgdr.default).loom,
        Icon: (0, $eZT0g.LoomIcon)
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $hEgdr.default).projectsGalaxia,
        Icon: (0, $kTwXj.ProjectsIcon)
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $hEgdr.default).teams,
        Icon: (0, $e6kMq.TeamsIcon)
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $hEgdr.default).opsgenie,
        Icon: (0, $474nX.OpsgenieIcon)
    }
};
const $15777f70405f0cfb$export$5034ad0032cd499d = {
    message: (0, $hEgdr.default).forYou,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6mPMG)))
};
const $15777f70405f0cfb$export$b66ae8c18ec95bc6 = {
    message: (0, $hEgdr.default).forYou.defaultMessage
};
const $15777f70405f0cfb$export$4da83c858d129f7f = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: {
        message: (0, $hEgdr.default).apps.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GOALS]: {
        message: (0, $hEgdr.default).goals.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: {
        message: (0, $hEgdr.default).roadmaps.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).PLANS]: {
        message: (0, $hEgdr.default).plans.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: {
        message: (0, $hEgdr.default).projectsGalaxia.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: {
        message: (0, $hEgdr.default).filters.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $hEgdr.default).dashboards.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $hEgdr.default).overviews.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).COMMUNICATION]: {
        message: (0, $hEgdr.default).communication.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: {
        message: (0, $hEgdr.default).operations.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: {
        message: (0, $hEgdr.default).assets.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: {
        message: (0, $hEgdr.default).teams.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).RECENT]: {
        message: (0, $hEgdr.default).recent.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).STARRED]: {
        message: (0, $hEgdr.default).starred.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $hEgdr.default).customerService.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $hEgdr.default).customerHubs.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $hEgdr.default).customerServiceAnalytics.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $hEgdr.default).assets.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $hEgdr.default).goals.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $hEgdr.default).confluence.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $hEgdr.default).loom.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $hEgdr.default).projectsGalaxia.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $hEgdr.default).teams.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $hEgdr.default).opsgenie.defaultMessage
    }
};
const $15777f70405f0cfb$export$9c99028e1421f69f = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: {
        message: (0, $hEgdr.default).apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ee8U1)))
    },
    [(0, $8IuE5.L1_MENU_ID).GOALS]: {
        message: (0, $hEgdr.default).goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4BXjD)))
    },
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: {
        message: (0, $hEgdr.default).roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bvCpT)))
    },
    [(0, $8IuE5.L1_MENU_ID).PLANS]: {
        message: (0, $hEgdr.default).plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($980v4)))
    },
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: {
        message: (0, $hEgdr.default).projects,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($33MRY)))
    },
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: {
        message: (0, $hEgdr.default).filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7eM4W)))
    },
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $hEgdr.default).dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ka38s)))
    },
    [(0, $8IuE5.L1_MENU_ID).COMMUNICATION]: {
        message: (0, $hEgdr.default).communication,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4ioMO)))
    },
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $hEgdr.default).overviews,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($HIU94)))
    },
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: {
        message: (0, $hEgdr.default).operations,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hgfY7)))
    },
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: {
        message: (0, $hEgdr.default).assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kAGKy)))
    },
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: {
        message: (0, $hEgdr.default).teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($g6zOZ)))
    },
    [(0, $8IuE5.L1_MENU_ID).RECENT]: {
        message: (0, $hEgdr.default).recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2IWvf)))
    },
    [(0, $8IuE5.L1_MENU_ID).STARRED]: {
        message: (0, $hEgdr.default).starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jsTl)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $hEgdr.default).customerService,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7C6KX)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $hEgdr.default).customerHubs,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4CndS)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $hEgdr.default).customerServiceAnalytics,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lHQXb)))
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $hEgdr.default).assets,
        Icon: (0, $dieBt.AssetsIcon)
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $hEgdr.default).goals,
        Icon: (0, $5ukg0.GoalsIcon)
    },
    // App Shortcuts for Platform Component
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $hEgdr.default).confluence,
        Icon: (0, $l18LW.ConfluenceIcon)
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $hEgdr.default).loom,
        Icon: (0, $eZT0g.LoomIcon)
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $hEgdr.default).projects,
        Icon: (0, $kTwXj.ProjectsIcon)
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $hEgdr.default).teams,
        Icon: (0, $e6kMq.TeamsIcon)
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $hEgdr.default).opsgenie,
        Icon: (0, $474nX.OpsgenieIcon)
    }
};
const $15777f70405f0cfb$export$8dca85fd20e1d57f = {
    message: (0, $hEgdr.default).projects,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($Apni8)))
};
const $15777f70405f0cfb$export$a9a6fdcb59a8001e = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: {
        message: (0, $hEgdr.default).apps.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GOALS]: {
        message: (0, $hEgdr.default).goals.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: {
        message: (0, $hEgdr.default).roadmaps.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).PLANS]: {
        message: (0, $hEgdr.default).plans.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: {
        message: (0, $hEgdr.default).projects.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: {
        message: (0, $hEgdr.default).filters.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $hEgdr.default).dashboards.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $hEgdr.default).overviews.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).COMMUNICATION]: {
        message: (0, $hEgdr.default).communication.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: {
        message: (0, $hEgdr.default).operations.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: {
        message: (0, $hEgdr.default).assets.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: {
        message: (0, $hEgdr.default).teams.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).RECENT]: {
        message: (0, $hEgdr.default).recent.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).STARRED]: {
        message: (0, $hEgdr.default).starred.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $hEgdr.default).customerService.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $hEgdr.default).customerHubs.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $hEgdr.default).customerServiceAnalytics.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $hEgdr.default).assets.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $hEgdr.default).goals.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $hEgdr.default).confluence.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $hEgdr.default).loom.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $hEgdr.default).projects.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $hEgdr.default).teams.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $hEgdr.default).opsgenie.defaultMessage
    }
};
const $15777f70405f0cfb$export$9fcc53f3b36e0949 = 240; // in pixels
const $15777f70405f0cfb$export$6621cd553335536a = 320; // in pixels
const $15777f70405f0cfb$export$2eb8dda9e83d33ff = false;
const $15777f70405f0cfb$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
const $15777f70405f0cfb$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
const $15777f70405f0cfb$export$9cf873ba2e9a3ce0 = 'nav4-opt-out';
const $15777f70405f0cfb$export$a495ba70b16d4d90 = 'nav4-sidebar';
const $15777f70405f0cfb$export$89de709e88232646 = 25;
const $15777f70405f0cfb$export$f48a8d7010265bd7 = (0, $hEgdr.default).forYou;
const $15777f70405f0cfb$export$f13ce1d5efbe11a1 = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: (0, $hEgdr.default).apps,
    [(0, $8IuE5.L1_MENU_ID).GOALS]: (0, $hEgdr.default).goals,
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: (0, $hEgdr.default).roadmaps,
    [(0, $8IuE5.L1_MENU_ID).PLANS]: (0, $hEgdr.default).plans,
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: (0, $hEgdr.default).projectsGalaxia,
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: (0, $hEgdr.default).filters,
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: (0, $hEgdr.default).dashboards,
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: (0, $hEgdr.default).overviews,
    [(0, $8IuE5.L1_MENU_ID).COMMUNICATION]: (0, $hEgdr.default).communication,
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: (0, $hEgdr.default).operations,
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: (0, $hEgdr.default).assets,
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: (0, $hEgdr.default).teams,
    [(0, $8IuE5.L1_MENU_ID).RECENT]: (0, $hEgdr.default).recent,
    [(0, $8IuE5.L1_MENU_ID).STARRED]: (0, $hEgdr.default).starred,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: (0, $hEgdr.default).customerService,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_HUBS]: (0, $hEgdr.default).customerHubs,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: (0, $hEgdr.default).customerServiceAnalytics,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: (0, $hEgdr.default).assets,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: (0, $hEgdr.default).goals,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: (0, $hEgdr.default).confluence,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: (0, $hEgdr.default).loom,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: (0, $hEgdr.default).projectsGalaxia,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: (0, $hEgdr.default).teams,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: (0, $hEgdr.default).opsgenie
};
const $15777f70405f0cfb$export$e4cb30926a9b6ca1 = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: (0, $hEgdr.default).apps,
    [(0, $8IuE5.L1_MENU_ID).GOALS]: (0, $hEgdr.default).goals,
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: (0, $hEgdr.default).roadmaps,
    [(0, $8IuE5.L1_MENU_ID).PLANS]: (0, $hEgdr.default).plans,
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: (0, $hEgdr.default).projects,
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: (0, $hEgdr.default).filters,
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: (0, $hEgdr.default).dashboards,
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: (0, $hEgdr.default).overviews,
    [(0, $8IuE5.L1_MENU_ID).COMMUNICATION]: (0, $hEgdr.default).communication,
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: (0, $hEgdr.default).operations,
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: (0, $hEgdr.default).assets,
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: (0, $hEgdr.default).teams,
    [(0, $8IuE5.L1_MENU_ID).RECENT]: (0, $hEgdr.default).recent,
    [(0, $8IuE5.L1_MENU_ID).STARRED]: (0, $hEgdr.default).starred,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: (0, $hEgdr.default).customerService,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_HUBS]: (0, $hEgdr.default).customerHubs,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: (0, $hEgdr.default).customerServiceAnalytics,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: (0, $hEgdr.default).assets,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: (0, $hEgdr.default).goals,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: (0, $hEgdr.default).confluence,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: (0, $hEgdr.default).loom,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: (0, $hEgdr.default).projects,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: (0, $hEgdr.default).teams,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: (0, $hEgdr.default).opsgenie
};

});
parcelRegister("hEgdr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcc397343fd47548$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bcc397343fd47548$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projects: {
        "id": "navigation-apps-sidebar-nav4-common.common.projects",
        "defaultMessage": "Projects"
    },
    filters: {
        "id": "navigation-apps-sidebar-nav4-common.common.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "navigation-apps-sidebar-nav4-common.common.dashboards",
        "defaultMessage": "Dashboards"
    },
    overviews: {
        "id": "navigation-apps-sidebar-nav4-common.common.overviews",
        "defaultMessage": "Overviews"
    },
    teams: {
        "id": "navigation-apps-sidebar-nav4-common.common.teams",
        "defaultMessage": "Teams"
    },
    assets: {
        "id": "navigation-apps-sidebar-nav4-common.common.assets",
        "defaultMessage": "Assets"
    },
    plans: {
        "id": "navigation-apps-sidebar-nav4-common.common.plans",
        "defaultMessage": "Plans"
    },
    apps: {
        "id": "navigation-apps-sidebar-nav4-common.common.apps",
        "defaultMessage": "Apps"
    },
    operations: {
        "id": "navigation-apps-sidebar-nav4-common.common.operations",
        "defaultMessage": "Operations"
    },
    goals: {
        "id": "navigation-apps-sidebar-nav4-common.common.goals",
        "defaultMessage": "Goals"
    },
    recent: {
        "id": "navigation-apps-sidebar-nav4-common.common.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-common.common.starred",
        "defaultMessage": "Starred"
    },
    roadmaps: {
        "id": "navigation-apps-sidebar-nav4-common.common.roadmaps",
        "defaultMessage": "Roadmaps"
    },
    customerService: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-service",
        "defaultMessage": "Customer service"
    },
    customerHubs: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-hubs",
        "defaultMessage": "Customer hubs"
    },
    customerServiceAnalytics: {
        "id": "navigation-apps-sidebar-nav4-common.common.customerServiceAnalytics",
        "defaultMessage": "Insights"
    },
    forYou: {
        "id": "navigation-apps-sidebar-nav4-common.common.forYou",
        "defaultMessage": "For you"
    },
    confluence: {
        "id": "navigation-apps-sidebar-nav4-common.common.confluence",
        "defaultMessage": "Confluence"
    },
    loom: {
        "id": "navigation-apps-sidebar-nav4-common.common.loom",
        "defaultMessage": "Loom"
    },
    opsgenie: {
        "id": "navigation-apps-sidebar-nav4-common.common.opsgenie",
        "defaultMessage": "Opsgenie"
    },
    communication: {
        "id": "navigation-apps-sidebar-nav4-common.common.communication",
        "defaultMessage": "Communications"
    },
    projectsGalaxia: {
        "id": "navigation-apps-sidebar-nav4-common.common.projects-galaxia",
        "defaultMessage": "Spaces"
    }
});

});


parcelRegister("2QH3X", function(module, exports) {

$parcel$export(module.exports, "useFormattedMessageAndIcon", () => $e26c3339fdefd88f$export$efa1c7d3cd2d4f5c);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");
const $e26c3339fdefd88f$export$efa1c7d3cd2d4f5c = (message, Icon)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formattedMessage = formatMessage(message);
    const icon = (0, $7jTnu.fg)('blu-8120_a11y_sidebar_menu_icons_remove_labels') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        spacing: "spacious",
        color: "currentColor",
        "aria-hidden": "true"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        label: formattedMessage,
        spacing: "spacious",
        color: "currentColor"
    });
    return {
        formattedMessage: formattedMessage,
        icon: icon
    };
};

});


parcelRegister("cECwI", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $1be319143530f4ed$export$bf7b5d502f6d6d3b);

var $lvKO5 = parcelRequire("lvKO5");
const $1be319143530f4ed$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("24QYf", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $8ca6bb72e2802986$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $8ca6bb72e2802986$export$d57b6b390e78d90f);
$parcel$export(module.exports, "USER_NAVIGATION_CONFIGURATION_DEFAULT", () => $8ca6bb72e2802986$export$6f21b70acbf71216);
$parcel$export(module.exports, "USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS", () => $8ca6bb72e2802986$export$c2614ebabc74446e);

var $8IuE5 = parcelRequire("8IuE5");
const $8ca6bb72e2802986$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4SidebarContent';
const $8ca6bb72e2802986$export$d57b6b390e78d90f = 'jira-cosmos';
const $8ca6bb72e2802986$export$6f21b70acbf71216 = {
    navKey: 'JIRA_SIDEBAR',
    navItems: [
        {
            menuId: (0, $8IuE5.L1_MENU_ID).RECENT,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).STARRED,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).APPS,
            isVisible: true
        },
        // See https://jplat.jira.atlassian.cloud/browse/BLU-3307
        // For the Dogfooding phase of Nav4 we are going to intentionally hide the Goals menu item.
        // Keeping code in comments so it can be easily reintroduced during EAP
        // {
        // 	menuId: L1_MENU_ID.GOALS,
        // 	isVisible: true,
        // },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).ROADMAPS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).OVERVIEWS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).PLANS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).PROJECTS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).FILTERS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).DASHBOARDS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).OPERATIONS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).COMMUNICATION,
            isVisible: true
        },
        {
            /* remove this on
			 * assets_as_an_app_v2 cleanup &&
			 */ menuId: (0, $8IuE5.L1_MENU_ID).ASSETS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).TEAMS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS,
            isVisible: true
        },
        {
            menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS,
            isVisible: true
        }
    ]
};
const $8ca6bb72e2802986$export$c2614ebabc74446e = $8ca6bb72e2802986$export$6f21b70acbf71216.navItems.map(({ menuId: menuId })=>menuId);

});

parcelRegister("5IAcG", function(module, exports) {

$parcel$export(module.exports, "L1MenuItems", () => $183e78c1a23ebd9f$export$a1e3b15bccd7433c);

var $bBIDB = parcelRequire("bBIDB");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jYFjy = parcelRequire("jYFjy");

var $7Rifr = parcelRequire("7Rifr");
function $183e78c1a23ebd9f$export$a1e3b15bccd7433c({ queryReference: queryReference }) {
    // We define a query which requires a few variables: $cloudId and others
    // Looking at https://relay.dev/docs/guided-tour/rendering/variables/, we can either:
    // a) pass these query-level variables down to the fragments as arguments, OR,
    // b) allow the fragments to reference the query-level variables directly.
    // We've chosen b) for now, as it would be a hassle to have to specify 8+ variables
    // at every level of the component tree.
    const l1MenuData = (0, $j4oe4.usePreloadedQuery)((0, $bBIDB.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYFjy.YourWork), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Rifr.ConfigurableMenuItems), {
        menuData: l1MenuData
    }));
}

});
parcelRegister("jYFjy", function(module, exports) {

$parcel$export(module.exports, "YourWork", () => $a0a7650eb46c8e76$export$c7da207c25eb3776);

var $eJOHy = parcelRequire("eJOHy");

var $6mPMG = parcelRequire("6mPMG");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $2QH3X = parcelRequire("2QH3X");

var $iIQmy = parcelRequire("iIQmy");

var $fs2Be = parcelRequire("fs2Be");

var $7jTnu = parcelRequire("7jTnu");

var $6HDkS = parcelRequire("6HDkS");
const $a0a7650eb46c8e76$var$JIRA_HOME_PATH = (0, $iIQmy.jiraHomeRoute).path;
const $a0a7650eb46c8e76$var$JIRA_HOME_PATH_OLD = (0, $fs2Be.oldJiraHomeRoute).path;
const $a0a7650eb46c8e76$var$analytics = {
    actionSubjectId: (0, $a9aec.SECTION_ITEM_YOUR_WORK),
    itemId: 'yourWork',
    level: 1,
    // Note: Your work doesn't seem to be configurable via Customise sidebar - More menu
    isInMore: false
};
const $a0a7650eb46c8e76$export$c7da207c25eb3776 = ()=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $6HDkS.default).forYou, (0, (/*@__PURE__*/$parcel$interopDefault($6mPMG))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        analytics: $a0a7650eb46c8e76$var$analytics,
        elemBefore: icon,
        href: (0, $7jTnu.fg)('blu-7514_update_jira_home_your_work_to_for_you') ? $a0a7650eb46c8e76$var$JIRA_HOME_PATH : $a0a7650eb46c8e76$var$JIRA_HOME_PATH_OLD,
        menuId: (0, $7jTnu.fg)('blu-7514_update_jira_home_your_work_to_for_you') ? (0, $h4Bzb.MENU_ID_FOR_YOU) : (0, $h4Bzb.MENU_ID_YOUR_WORK)
    }, formattedMessage);
};

});
parcelRegister("a9aec", function(module, exports) {

$parcel$export(module.exports, "SECTION_ITEM_RECENT", () => $db3f586753213871$export$ed5276b2863990a4);
$parcel$export(module.exports, "SECTION_ITEM_STARRED", () => $db3f586753213871$export$73b9e2753c0313a);
$parcel$export(module.exports, "SECTION_ITEM_YOUR_WORK", () => $db3f586753213871$export$a7cdcfc40ede2092);
$parcel$export(module.exports, "SECTION_ITEM_APPS", () => $db3f586753213871$export$31b95a89c6fecef5);
$parcel$export(module.exports, "SECTION_ITEM_PLANS", () => $db3f586753213871$export$b8d778ecbc8de386);
$parcel$export(module.exports, "SECTION_ITEM_PROJECTS", () => $db3f586753213871$export$31111a67d393221);
$parcel$export(module.exports, "SECTION_ITEM_FILTERS", () => $db3f586753213871$export$15cffe8e769011f4);
$parcel$export(module.exports, "SECTION_ITEM_DASHBOARDS", () => $db3f586753213871$export$573d88e8f19dee53);
$parcel$export(module.exports, "SECTION_ITEM_OPERATIONS", () => $db3f586753213871$export$4d8d544db40ea55b);
$parcel$export(module.exports, "SECTION_ITEM_TEAMS", () => $db3f586753213871$export$ee4743a74ca6b2b4);
$parcel$export(module.exports, "SECTION_ITEM_ASSETS", () => $db3f586753213871$export$935694b184853c59);
$parcel$export(module.exports, "SECTION_ITEM_MORE", () => $db3f586753213871$export$b0aa6b1b7598bca0);
$parcel$export(module.exports, "SECTION_ITEM_CUSTOMIZE_SIDEBAR", () => $db3f586753213871$export$60a8edfaff189e32);
$parcel$export(module.exports, "SECTION_ITEM_OVERVIEW", () => $db3f586753213871$export$c15c267765b7c087);
$parcel$export(module.exports, "SECTION_ITEM_ROADMAPS", () => $db3f586753213871$export$1e1623e43a47b758);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_ASSETS", () => $db3f586753213871$export$be1ee97c6c39a7a0);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_GOALS", () => $db3f586753213871$export$340dfb7166bc7df6);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_CONFLUENCE", () => $db3f586753213871$export$68f5347447985678);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_LOOM", () => $db3f586753213871$export$1d6ac45ce8d48696);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_TEAMS", () => $db3f586753213871$export$73432842fefef2ac);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_PROJECTS", () => $db3f586753213871$export$3023d22f41447712);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_OPSGENIE", () => $db3f586753213871$export$3cc2573a8cf93a99);
$parcel$export(module.exports, "SECTION_ITEM_MAP", () => $db3f586753213871$export$1a73d7f5e6997c6d);

var $h4Bzb = parcelRequire("h4Bzb");
const $db3f586753213871$export$ed5276b2863990a4 = 'recent';
const $db3f586753213871$export$73b9e2753c0313a = 'starred';
const $db3f586753213871$export$a01a58e0d3083eac = 'yourApps';
const $db3f586753213871$export$a7cdcfc40ede2092 = 'yourWork';
const $db3f586753213871$export$31b95a89c6fecef5 = 'apps';
const $db3f586753213871$export$b8d778ecbc8de386 = 'plans';
const $db3f586753213871$export$31111a67d393221 = 'projects';
const $db3f586753213871$export$15cffe8e769011f4 = 'filters';
const $db3f586753213871$export$573d88e8f19dee53 = 'dashboards';
const $db3f586753213871$export$4d8d544db40ea55b = 'operations';
const $db3f586753213871$export$ee4743a74ca6b2b4 = 'teams';
const $db3f586753213871$export$935694b184853c59 = 'assets';
const $db3f586753213871$export$b0aa6b1b7598bca0 = 'more';
const $db3f586753213871$export$60a8edfaff189e32 = 'customiseSidebar';
const $db3f586753213871$export$c15c267765b7c087 = 'overviews';
const $db3f586753213871$export$e52ffdfdd2f167e7 = 'communication';
const $db3f586753213871$export$61feca79c347b0c7 = 'goals';
const $db3f586753213871$export$1e1623e43a47b758 = 'roadmaps';
const $db3f586753213871$export$99cd56faa69bbbb6 = 'customerService';
const $db3f586753213871$export$f3045e909a12df36 = 'customerHubs';
const $db3f586753213871$export$f780439bdf7412c6 = 'customerServiceAnalytics';
const $db3f586753213871$export$be1ee97c6c39a7a0 = 'assetsGlobalAppShortcut';
const $db3f586753213871$export$340dfb7166bc7df6 = 'goalsGlobalAppShortcut';
const $db3f586753213871$export$68f5347447985678 = 'confluenceGlobalAppShortcut';
const $db3f586753213871$export$1d6ac45ce8d48696 = 'loomGlobalAppShortcut';
const $db3f586753213871$export$73432842fefef2ac = 'teamsGlobalAppShortcut';
const $db3f586753213871$export$3023d22f41447712 = 'projectsGlobalAppShortcut';
const $db3f586753213871$export$3cc2573a8cf93a99 = 'opsgenieGlobalAppShortcut';
const $db3f586753213871$export$1a73d7f5e6997c6d = {
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).APPS]: $db3f586753213871$export$31b95a89c6fecef5,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).ASSETS]: $db3f586753213871$export$935694b184853c59,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).DASHBOARDS]: $db3f586753213871$export$573d88e8f19dee53,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).FILTERS]: $db3f586753213871$export$15cffe8e769011f4,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).OPERATIONS]: $db3f586753213871$export$4d8d544db40ea55b,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).PLANS]: $db3f586753213871$export$b8d778ecbc8de386,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).PROJECTS]: $db3f586753213871$export$31111a67d393221,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).RECENT]: $db3f586753213871$export$ed5276b2863990a4,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).STARRED]: $db3f586753213871$export$73b9e2753c0313a,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).TEAMS]: $db3f586753213871$export$ee4743a74ca6b2b4,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GOALS]: $db3f586753213871$export$61feca79c347b0c7,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).OVERVIEWS]: $db3f586753213871$export$c15c267765b7c087,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).COMMUNICATION]: $db3f586753213871$export$e52ffdfdd2f167e7,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).ROADMAPS]: $db3f586753213871$export$1e1623e43a47b758,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE]: $db3f586753213871$export$99cd56faa69bbbb6,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).CUSTOMER_HUBS]: $db3f586753213871$export$f3045e909a12df36,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: $db3f586753213871$export$f780439bdf7412c6,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_GOALS]: $db3f586753213871$export$340dfb7166bc7df6,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_ASSETS]: $db3f586753213871$export$be1ee97c6c39a7a0,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_CONFLUENCE]: $db3f586753213871$export$68f5347447985678,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_LOOM]: $db3f586753213871$export$1d6ac45ce8d48696,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_TEAMS]: $db3f586753213871$export$73432842fefef2ac,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_PROJECTS]: $db3f586753213871$export$3023d22f41447712,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_OPSGENIE]: $db3f586753213871$export$3cc2573a8cf93a99
};

});

parcelRegister("i0tMD", function(module, exports) {

$parcel$export(module.exports, "Nav4MenuLinkItem", () => $8840a5f52e86652c$export$3253d78f1560490f);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eJOHy = parcelRequire("eJOHy");

var $dpxw4 = parcelRequire("dpxw4");

var $cbCSE = parcelRequire("cbCSE");

var $bo95Y = parcelRequire("bo95Y");

var $azEgq = parcelRequire("azEgq");
const $8840a5f52e86652c$export$3253d78f1560490f = /*#__PURE__*/ (0, $eJOHy.forwardRef)($8840a5f52e86652c$var$Nav4MenuLinkItemContent);
function $8840a5f52e86652c$var$Nav4MenuLinkItemContent(props, ref) {
    const { menuId: menuId } = props;
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const { isControlledPath: isControlledPath } = (0, $cbCSE.useSidebarNav4Controller)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        ref: ref,
        ...props,
        isSelected: isSelectedPath(menuId) || isControlledPath(menuId),
        testId: (0, $azEgq.getTestId)(menuId)
    });
}

});
parcelRegister("dpxw4", function(module, exports) {

$parcel$export(module.exports, "SidebarNav4ContextProvider", () => $9a5158489d715dff$export$ebf7cdfc2e83bcef);
$parcel$export(module.exports, "useSidebarNav4", () => $9a5158489d715dff$export$dc46c14934833db2);

var $eJOHy = parcelRequire("eJOHy");

var $gCY1z = parcelRequire("gCY1z");

var $kWbWF = parcelRequire("kWbWF");

var $b1DBy = parcelRequire("b1DBy");

var $kg9Uh = parcelRequire("kg9Uh");
const $9a5158489d715dff$var$SidebarNav4Context = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
function $9a5158489d715dff$export$2854101beb9a2d8d(props) {
    const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
    const [routerContext] = (0, $gCY1z.useRouter)();
    const initialSelectedPath = (0, $kWbWF.getInitialSelectedPath)(routerContext);
    const [selectedPath, setSelectedPath] = (0, $eJOHy.useState)(initialSelectedPath);
    // When the `routerContext` changes, we need to recalculate the selected path.
    // useLayoutEffect, so this happens before render.
    (0, $eJOHy.useLayoutEffect)(()=>{
        setSelectedPath((currentPath)=>{
            const newPath = (0, $kg9Uh.routeToSelectedPath)(routerContext);
            return currentPath.toString() === newPath.toString() ? currentPath : newPath;
        });
    }, [
        routerContext
    ]);
    const sidebarNav4Controller = (0, $eJOHy.useMemo)(()=>({
            isInitialSelectedPath: isInitialSelectedPath ?? (0, $b1DBy.isSelectedPath)(initialSelectedPath),
            isSelectedPath: (0, $b1DBy.isSelectedPath)(selectedPath)
        }), [
        initialSelectedPath,
        isInitialSelectedPath,
        selectedPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9a5158489d715dff$var$SidebarNav4Context.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $9a5158489d715dff$export$ebf7cdfc2e83bcef(props) {
    const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
    const selectedPathData = (0, $kg9Uh.useRouteToSelectedPath)();
    const sidebarNav4Controller = (0, $eJOHy.useMemo)(()=>({
            isInitialSelectedPath: isInitialSelectedPath ?? (0, $b1DBy.isSelectedPath)(selectedPathData.initialSelectedPath),
            isSelectedPath: (0, $b1DBy.isSelectedPath)(selectedPathData.selectedPath)
        }), [
        isInitialSelectedPath,
        selectedPathData.initialSelectedPath,
        selectedPathData.selectedPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9a5158489d715dff$var$SidebarNav4Context.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $9a5158489d715dff$export$dc46c14934833db2() {
    const context = (0, $eJOHy.useContext)($9a5158489d715dff$var$SidebarNav4Context);
    if (context == null) throw new Error('useSidebarNav4 must be used inside a SidebarNav4ContextProvider');
    return context;
}

});

parcelRegister("cbCSE", function(module, exports) {

$parcel$export(module.exports, "SidebarNav4ControllerProvider", () => $3d5607f673c98260$export$ec25d268893d889d);
$parcel$export(module.exports, "useSidebarNav4Controller", () => $3d5607f673c98260$export$641950c86d73374);

var $eJOHy = parcelRequire("eJOHy");

var $b1DBy = parcelRequire("b1DBy");
const $3d5607f673c98260$var$SidebarNav4ControllerContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
function $3d5607f673c98260$export$ec25d268893d889d(props) {
    const { children: children, controlledPath: initialControlledPath = null } = props;
    const [controlledPath, setControlledPath] = (0, $eJOHy.useState)(initialControlledPath); // null means "not being controlled"
    const sidebarNav4Controller = (0, $eJOHy.useMemo)(()=>({
            // is any path in Navigation a controlled one
            isControlledNav: controlledPath !== null,
            isControlledPath: (0, $b1DBy.isSelectedPath)(controlledPath ?? []),
            setControlledPath: setControlledPath
        }), [
        controlledPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3d5607f673c98260$var$SidebarNav4ControllerContext.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $3d5607f673c98260$export$641950c86d73374() {
    const context = (0, $eJOHy.useContext)($3d5607f673c98260$var$SidebarNav4ControllerContext);
    if (context == null) throw new Error('useSidebarNav4Controller must be used inside a SidebarNav4ControllerContext');
    return context;
}

});

parcelRegister("bo95Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6e941be7dec1b83$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aasrU = parcelRequire("aasrU");


var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $7jTnu = parcelRequire("7jTnu");
function $d6e941be7dec1b83$var$LinkMenuItemWithAnalytics({ analytics: analytics, onClick: onClick, ...rest }, ref) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const handleClick = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        }), actionSubjectId, analyticsAttributes);
    }, [
        analytics,
        createAnalyticsEvent,
        onClick
    ]) : (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        }), actionSubjectId, analyticsAttributes);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aasrU.LinkMenuItem), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
}
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$d6e941be7dec1b83$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.forwardRef)($d6e941be7dec1b83$var$LinkMenuItemWithAnalytics);

});
const $bfc89d778f76f56d$export$6dd9406e478a1fe2 = 'navigationItem';
const $bfc89d778f76f56d$export$b887e88d8d0739f6 = 'button';
const $bfc89d778f76f56d$export$64fed82162bd367 = 'dropdownItem';
const $bfc89d778f76f56d$export$b0a8b257f1f878a2 = 'searchInput';


parcelRegister("azEgq", function(module, exports) {

$parcel$export(module.exports, "getTestId", () => $3b1dd61e34a2731a$export$ec17b125bc42c229);
// By giving all of the Nav4-HTMLElements a test-id prefix, we can find them again,
// and even build a path from each leaf to the root. We do this in Storybook to
// simulate link-click-selection, since we are not using a real router in SB.
function $3b1dd61e34a2731a$export$ec17b125bc42c229(suffix) {
    return `NAV4_${suffix}`;
}

});


parcelRegister("iIQmy", function(module, exports) {

$parcel$export(module.exports, "jiraHomeRoute", () => $abbdc0110c11ea7e$export$11ebbd6d4e57759c);
const $abbdc0110c11ea7e$export$11ebbd6d4e57759c = {
    name: 'for-you',
    path: '/jira/for-you'
};

});

parcelRegister("fs2Be", function(module, exports) {

$parcel$export(module.exports, "oldJiraHomeRoute", () => $7c327ca8835982db$export$81e03d85d70e35e);
const $7c327ca8835982db$export$81e03d85d70e35e = {
    name: 'your-work',
    path: '/jira/your-work'
};

});

parcelRegister("6HDkS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b981196e50bfefe9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b981196e50bfefe9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    yourWork: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-your-work.your-work.your-work",
        "defaultMessage": "Your work"
    },
    forYou: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-your-work.your-work.for-you",
        "defaultMessage": "For you"
    }
});

});


parcelRegister("7Rifr", function(module, exports) {

$parcel$export(module.exports, "ConfigurableMenuItems", () => $dde6c67e1bdac790$export$4aa1992a31b27e16);

var $aWfR3 = parcelRequire("aWfR3");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $hylcg = parcelRequire("hylcg");

var $80rA3 = parcelRequire("80rA3");

var $lxTXK = parcelRequire("lxTXK");

var $dKoLB = parcelRequire("dKoLB");

var $9Byj7 = parcelRequire("9Byj7");

var $dx2Xz = parcelRequire("dx2Xz");

var $7jTnu = parcelRequire("7jTnu");

var $bJscI = parcelRequire("bJscI");

var $fAZgY = parcelRequire("fAZgY");

var $a62R3 = parcelRequire("a62R3");

var $mIeXW = parcelRequire("mIeXW");

var $99tvj = parcelRequire("99tvj");

var $efIGC = parcelRequire("efIGC");

var $kRqOw = parcelRequire("kRqOw");

var $g5qtb = parcelRequire("g5qtb");

var $5kDxs = parcelRequire("5kDxs");

var $6CQFr = parcelRequire("6CQFr");
const $dde6c67e1bdac790$export$4aa1992a31b27e16 = (0, $bJscI.componentWithFG)('jfp-magma-stability-check-nav4-batch-1', /*#__PURE__*/ (0, $eJOHy.memo)($dde6c67e1bdac790$var$ConfigurableMenuItemsInner), $dde6c67e1bdac790$var$ConfigurableMenuItemsInner);
function $dde6c67e1bdac790$var$ConfigurableMenuItemsInner({ menuData: menuData }) {
    const data = (0, $j4oe4.useFragment)((0, $aWfR3.default), menuData);
    // Creates a synced ref to the global app shortcuts to get the response from global app shortcuts component.
    // const getFilteredProductLinks = useRef<fnGetFilteredProductLinks | undefined>(undefined);
    const [getFilteredProductLinks, setGetFilteredProductLinks] = (0, $eJOHy.useState)(undefined);
    const globalAppLicense = (0, $dx2Xz.useGlobalApps)();
    const navItems = (0, $99tvj.useFilterL1MenuItemsByEditionAndLicense)(// Add back any missing menu ids before filtering in case licensing has changed or a new L1 has been created.
    // This also handles when a user has no configuration yet.
    (0, $efIGC.useRefreshL1MenuItems)(data.jira?.userNavigationConfiguration?.navItems));
    const navItemsContext = (0, $eJOHy.useMemo)(()=>({
            navItems: navItems,
            visibleMenuIds: (0, $lxTXK.getConfigurableMenuIds)(navItems, true),
            moreMenuIds: (0, $lxTXK.getConfigurableMenuIds)(navItems, false),
            productItemsData: (0, $dKoLB.getProductItemsData)(navItems)
        }), [
        navItems
    ]);
    const visibleGlobalAppMenuIds = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>(0, $dKoLB.getVisibleAppItemsData)(navItems, globalAppLicense, getFilteredProductLinks), [
        globalAppLicense,
        navItems,
        getFilteredProductLinks
    ]) : (0, $dKoLB.getVisibleAppItemsData)(navItems, globalAppLicense, getFilteredProductLinks);
    const appItemsDataUnstable = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>(0, $dKoLB.getAppItemsData)(navItems, globalAppLicense, getFilteredProductLinks), [
        globalAppLicense,
        navItems,
        getFilteredProductLinks
    ]) : (0, $dKoLB.getAppItemsData)(navItems, globalAppLicense, getFilteredProductLinks);
    /**
   * Unfortunately appItemsDataUnstable is not stable, as setGetFilteredProductLinks gets called later to update getFilteredProductLinks.
   * However, even when getFilteredProductLinks changes, appItemsData does not always change meaningfully (eg same data but new instantiation).
   * This means that we can use a stable ref to avoid unnecessary re-renders of the GlobalShortcuts component.
   */ const [appItemsDataStable, setAppItemsDataStable] = (0, $eJOHy.useState)(appItemsDataUnstable);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-3')) return;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(appItemsDataStable, appItemsDataUnstable)) setAppItemsDataStable(appItemsDataUnstable);
    }, [
        appItemsDataStable,
        appItemsDataUnstable
    ]);
    const appItemsData = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-3') ? appItemsDataStable : appItemsDataUnstable;
    const handleUpdateGetFilteredProductLinks = (0, $fAZgY.useCallbackWithCondition)((fn)=>{
        setGetFilteredProductLinks(()=>fn);
    }, [], ()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-3'));
    // Teams App requires the invite modal context provider to be wrapped around it.
    const globalShortcuts = (0, $eJOHy.useMemo)(()=>{
        if ((0, $7jTnu.fg)('nav4_global_links_jira')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hylcg.TopLevelSpacer), null), (0, $a62R3.isTeamsAppEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6CQFr.GlobalShortcutsWithInvitePeopleProvider), {
            appItemsData: appItemsData,
            handleUpdateGetFilteredProductLinks: handleUpdateGetFilteredProductLinks
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6CQFr.GlobalShortcuts), {
            appItemsData: appItemsData,
            handleUpdateGetFilteredProductLinks: handleUpdateGetFilteredProductLinks
        }));
        return visibleGlobalAppMenuIds.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hylcg.TopLevelSpacer), null), visibleGlobalAppMenuIds.map((menuId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Byj7.GlobalAppShortcuts), {
                menuId: menuId,
                key: menuId
            }))) : null;
    }, [
        visibleGlobalAppMenuIds,
        appItemsData,
        handleUpdateGetFilteredProductLinks
    ]);
    const getAppShortcutURL = (0, $eJOHy.useCallback)((apsKey)=>{
        if (getFilteredProductLinks) {
            const result = getFilteredProductLinks(apsKey);
            return result.promotedLink?.url;
        }
    }, [
        getFilteredProductLinks
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $80rA3.NavItemsContext).Provider, {
        value: navItemsContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kDxs.PeekMenuIdContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kRqOw.MoreMenuIsOpenContextProvider), null, navItemsContext.visibleMenuIds.map((menuId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $mIeXW.ConfigurableMenuItem), {
            key: menuId,
            menuData: data,
            menuId: menuId
        })), globalShortcuts, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hylcg.TopLevelSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g5qtb.SidebarCustomization), {
        navItems: navItems,
        menuData: data,
        productItemsData: navItemsContext.productItemsData,
        appItemsData: appItemsData,
        getAppShortcutURL: getAppShortcutURL
    }))));
}

});
parcelRegister("aWfR3", function(module, exports) {

$parcel$export(module.exports, "default", () => $41b73aa3f4744a63$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<00967a64cef8c686dca07727f080bd28>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $41b73aa3f4744a63$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "ConfigurableMenuItems",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudID",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "navKey",
                            "value": "NAV_SIDEBAR"
                        }
                    ],
                    "concreteType": "JiraUserNavigationConfiguration",
                    "kind": "LinkedField",
                    "name": "userNavigationConfiguration",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraConfigurableNavigationItem",
                            "kind": "LinkedField",
                            "name": "navItems",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "menuId"
                                    },
                                    "action": "THROW",
                                    "path": "jira.userNavigationConfiguration.navItems.menuId"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "isVisible"
                                    },
                                    "action": "THROW",
                                    "path": "jira.userNavigationConfiguration.navItems.isVisible"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ConfigurableMenuItem"
        }
    ],
    "type": "Query"
};
$41b73aa3f4744a63$var$node.hash = "186fc107bcd2a8ade003841f3137d27b";
var $41b73aa3f4744a63$export$2e2bcd8739ae039 = $41b73aa3f4744a63$var$node;

});

parcelRegister("hylcg", function(module, exports) {

$parcel$export(module.exports, "TopLevelSpacer", () => $821f66abeb67f049$export$5776f68925982056);
/* top-level-spacer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $bkAOK = parcelRequire("bkAOK");
const $821f66abeb67f049$var$styles = {
    root: "_4t3iutpp"
};
function $821f66abeb67f049$export$5776f68925982056() {
    const level = (0, $bkAOK.useLevel)();
    (0, $eJOHy.useEffect)(()=>{}, [
        level
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $821f66abeb67f049$var$styles.root
        ])
    });
}

});

parcelRegister("80rA3", function(module, exports) {

$parcel$export(module.exports, "NavItemsContext", () => $9e5d0ca501b91cc9$export$a2018da95558f5c);
$parcel$export(module.exports, "PeekMenuIdContext", () => $9e5d0ca501b91cc9$export$390c771b9e3f4124);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $9e5d0ca501b91cc9$export$a2018da95558f5c = /*#__PURE__*/ (0, $eJOHy.createContext)({
    navItems: [],
    visibleMenuIds: [],
    moreMenuIds: []
});
const $9e5d0ca501b91cc9$export$390c771b9e3f4124 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    peekMenuId: undefined,
    setPeekMenuId: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});

});

parcelRegister("lxTXK", function(module, exports) {

$parcel$export(module.exports, "getConfigurableMenuIds", () => $29158faeed9adf5b$export$6071c13fba14d7fa);

var $d5UZJ = parcelRequire("d5UZJ");
const $29158faeed9adf5b$export$6071c13fba14d7fa = (navItems, isVisible)=>navItems.filter((navItem)=>navItem.isVisible === isVisible).map(({ menuId: menuId })=>menuId).filter((0, $d5UZJ.isConfigurableMenuId));

});
parcelRegister("d5UZJ", function(module, exports) {

$parcel$export(module.exports, "isConfigurableMenuId", () => $16e99cf6579db854$export$454094eefbaf1797);

var $5Q9JR = parcelRequire("5Q9JR");
const $16e99cf6579db854$export$454094eefbaf1797 = (value)=>(0, $5Q9JR.CONFIGURABLE_MENU_IDS_AS_STRINGS).includes(value);

});


parcelRegister("dKoLB", function(module, exports) {

$parcel$export(module.exports, "getProductItemsData", () => $b833e60bf4a8b374$export$92d3bf799aea2628);
$parcel$export(module.exports, "getAppItemsData", () => $b833e60bf4a8b374$export$153d0c6accbfb26a);
$parcel$export(module.exports, "getVisibleAppItemsData", () => $b833e60bf4a8b374$export$b7cc8dd7bef58aa3);

var $7jTnu = parcelRequire("7jTnu");

var $h4Bzb = parcelRequire("h4Bzb");

var $aYncF = parcelRequire("aYncF");

var $a62R3 = parcelRequire("a62R3");

var $8IuE5 = parcelRequire("8IuE5");

var $41vqi = parcelRequire("41vqi");

var $dx2Xz = parcelRequire("dx2Xz");
const $b833e60bf4a8b374$export$92d3bf799aea2628 = (navItems)=>(0, $7jTnu.fg)('nav4_global_links_jira') ? navItems.filter((navItem)=>(0, $dx2Xz.isSupportedMenuId)(navItem.menuId)).filter((navItem)=>!(0, $dx2Xz.isGlobalAppMenuId)(navItem.menuId)).filter((navItem)=>{
        if (!(0, $a62R3.isTeamsAppEnabled)()) return true;
        return navItem.menuId !== (0, $8IuE5.L1_MENU_ID).TEAMS;
    }).map((item)=>{
        return {
            menuId: item.menuId,
            visible: item.isVisible
        };
    }) : navItems.filter((navItem)=>!(0, $dx2Xz.isGlobalAppMenuId)(navItem.menuId)).map((item)=>{
        return {
            menuId: item.menuId,
            visible: item.isVisible
        };
    });
const $b833e60bf4a8b374$export$153d0c6accbfb26a = (navItems, globalAppLicense, getFilteredProductLinks)=>{
    const USER_NAVIGATION_ITEM_LINKS = (0, $41vqi.getUserNavigationItemLinks)();
    return navItems.filter((navItem)=>(0, $dx2Xz.isGlobalAppMenuId)(navItem.menuId)).filter((navItem)=>{
        // TODO: put this under a feature gate
        if (!(0, $7jTnu.fg)('nav4_global_links_jira')) return true;
        // Metadata app licencing check
        if (!$b833e60bf4a8b374$var$isProductSupportedFromMetadata(navItem.menuId)) return false;
        if (getFilteredProductLinks) {
            if (navItem.menuId in (0, $h4Bzb.GLOBAL_APP_MENU_ID_TO_APS_KEY)) {
                const apsKey = (0, $h4Bzb.GLOBAL_APP_MENU_ID_TO_APS_KEY)[navItem.menuId];
                const fallbackUrl = USER_NAVIGATION_ITEM_LINKS[navItem.menuId];
                const filteredProducts = getFilteredProductLinks(apsKey);
                const statusDisabledOrComplete = (0, $7jTnu.fg)('jira-nav4-bugfix-resolve-jira-flicker-gas') ? filteredProducts.status === 'complete' : true;
                if (statusDisabledOrComplete && !fallbackUrl && filteredProducts.links.length === 0) // If there are no filtered links, we don't want to show this item.
                return false;
            }
        }
        return true;
    }).filter((navItem)=>(0, $dx2Xz.hasGlobalAppLicense)(navItem.menuId, globalAppLicense)).map((item)=>{
        return {
            menuId: item.menuId,
            visible: item.isVisible
        };
    });
};
const $b833e60bf4a8b374$export$b7cc8dd7bef58aa3 = (navItems, globalAppLicense, getFilteredProductLinks)=>{
    const USER_NAVIGATION_ITEM_LINKS = (0, $41vqi.getUserNavigationItemLinks)();
    return navItems.filter((navItem)=>navItem.isVisible).map(({ menuId: menuId })=>menuId).filter((0, $dx2Xz.isGlobalAppMenuId)).filter((navItem)=>{
        if (!(0, $7jTnu.fg)('nav4_global_links_jira')) return true;
        // Metadata app licencing check
        if (!$b833e60bf4a8b374$var$isProductSupportedFromMetadata(navItem)) return false;
        if (getFilteredProductLinks) {
            if (navItem in (0, $h4Bzb.GLOBAL_APP_MENU_ID_TO_APS_KEY)) {
                const apsKey = (0, $h4Bzb.GLOBAL_APP_MENU_ID_TO_APS_KEY)[navItem];
                const filteredProducts = getFilteredProductLinks(apsKey);
                const fallbackUrl = USER_NAVIGATION_ITEM_LINKS[navItem];
                const statusDisabledOrComplete = (0, $7jTnu.fg)('jira-nav4-bugfix-resolve-jira-flicker-gas') ? filteredProducts.status === 'complete' : true;
                if (statusDisabledOrComplete && !fallbackUrl && filteredProducts.links.length === 0) // If there are no filtered links, we don't want to show this item.
                return false;
            }
        }
        return true;
    }).filter((menuId)=>(0, $dx2Xz.hasGlobalAppLicense)(menuId, globalAppLicense));
};
const $b833e60bf4a8b374$var$isProductSupportedFromMetadata = (menuId)=>{
    const products = (0, $aYncF.getLicensedProducts)();
    switch(menuId){
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE:
            return !!products[(0, $aYncF.LICENSED_PRODUCTS).CONFLUENCE];
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM:
            return !!products[(0, $aYncF.LICENSED_PRODUCTS).LOOM];
        default:
            return true;
    }
};

});
parcelRegister("a62R3", function(module, exports) {

$parcel$export(module.exports, "useNavigateToTeamsApp", () => $4bdb55387d231b38$export$520a42ab062954ec);
$parcel$export(module.exports, "getNavigateToTeamsApp", () => $4bdb55387d231b38$export$cfadab73fb247145);
$parcel$export(module.exports, "useTransformToTeamsAppUrl", () => $4bdb55387d231b38$export$dc7e633fb6368a43);
$parcel$export(module.exports, "toTeamsAppURL", () => $4bdb55387d231b38$export$196b2cec97b1c87c);
$parcel$export(module.exports, "isTeamsAppEnabled", () => $4bdb55387d231b38$export$5921b2a93a401547);

var $ApPad = parcelRequire("ApPad");

var $iXWR3 = parcelRequire("iXWR3");

var $g9Vr6 = parcelRequire("g9Vr6");

var $kEUB1 = parcelRequire("kEUB1");

var $83DiZ = parcelRequire("83DiZ");

var $6zXPf = parcelRequire("6zXPf");

var $hWeHP = parcelRequire("hWeHP");
const $4bdb55387d231b38$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    if (!orgId && !cloudId) throw new Error('Org ID or Cloud ID is required to navigate to Teams App');
    return (0, $iXWR3.navigateToTeamsApp)({
        push: push,
        hostProduct: 'jira',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)(),
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
const $4bdb55387d231b38$export$cfadab73fb247145 = (navActionPayload, shouldOpenInSameTab)=>{
    const orgId = (0, $hWeHP.default)('ajs-org-id');
    const cloudId = (0, $hWeHP.default)('ajs-cloud-id');
    return (0, $iXWR3.navigateToTeamsApp)({
        hostProduct: 'jira',
        orgId: orgId || '',
        cloudId: cloudId || undefined,
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)(),
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
const $4bdb55387d231b38$export$dc7e633fb6368a43 = (path, search = '')=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    return (0, $iXWR3.toTeamsAppURL)(path, search, {
        orgId: orgId,
        cloudId: cloudId
    });
};
const $4bdb55387d231b38$export$196b2cec97b1c87c = (path, search = '')=>{
    const orgId = (0, $hWeHP.default)('ajs-org-id');
    const cloudId = (0, $hWeHP.default)('ajs-cloud-id');
    return (0, $iXWR3.toTeamsAppURL)(path, search, {
        orgId: orgId ?? '',
        cloudId: cloudId ?? ''
    });
};
const $4bdb55387d231b38$export$5921b2a93a401547 = ()=>{
    return (0, $ApPad.isTeamsAppEnabled)({
        hostProduct: 'jira',
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)()
    });
};

});
parcelRegister("ApPad", function(module, exports) {

$parcel$export(module.exports, "isTeamsAppEnabled", () => $4ba2702b11b2ae0d$export$5921b2a93a401547);

var $igNUx = parcelRequire("igNUx");
var $d9MBC = parcelRequire("d9MBC");

var $21HMC = parcelRequire("21HMC");

var $8XtVW = parcelRequire("8XtVW");
function $4ba2702b11b2ae0d$export$5921b2a93a401547(config) {
    //  Hard kill switch for isolated cloud until Standalone directory is deployed
    if ((0, $d9MBC.isIsolatedCloud)()) return false;
    // Due to experiment exposures, we need to first check if Nav4 is enabled to see if the user is in the cohort
    // In FedRamp, we are ignoring the Nav4 dependency
    if (!(0, $igNUx.isFedRamp)() && config.userHasNav4Enabled !== undefined && !config.userHasNav4Enabled) return false;
    if ((0, $21HMC.default).initializeCompleted()) {
        // Next we check the experiment value based on the host product
        if (config.hostProduct === 'jira' && (0, $21HMC.default).getExperimentValue('migrate-jira-people-directory-to-teams-app', 'isEnabled', false)) return true;
        if (config.hostProduct === 'confluence' && (0, $21HMC.default).getExperimentValue('migrate-confluence-people-directory-to-teams-app', 'isEnabled', false)) return true;
    }
    // Lastly we check the feature gate which we are using for dogfooding, we won't roll this flag out in production.
    return (0, $8XtVW.fg)('should-redirect-directory-to-teams-app');
}

});
parcelRegister("d9MBC", function(module, exports) {

$parcel$export(module.exports, "isIsolatedCloud", () => $79d79b7c3d667e64$export$9186ccba8effc5de);
$parcel$export(module.exports, "isFedrampModerate", () => $79d79b7c3d667e64$export$104cb891a6e90b3a);
$parcel$export(module.exports, "isolatedCloudDomain", () => $79d79b7c3d667e64$export$80638ee198476daf);

var $7sXIy = parcelRequire("7sXIy");

var $ktlk3 = parcelRequire("ktlk3");
function $79d79b7c3d667e64$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInIC;
    const atlCtxCookieValues = (0, $ktlk3.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $7sXIy.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $79d79b7c3d667e64$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInFedramp;
    const atlCtxCookieValues = (0, $ktlk3.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $7sXIy.FEDRAMP_MODERATE);
}
function $79d79b7c3d667e64$export$80638ee198476daf() {
    const atlCtxCookieValues = (0, $ktlk3.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icDomain;
}
function $79d79b7c3d667e64$export$839b022803d38d4d() {
    if (typeof document === 'undefined') // @ts-ignore
    return $79d79b7c3d667e64$export$9186ccba8effc5de() ? globalThis.ssrContext.icName : undefined;
    const atlCtxCookieValues = (0, $ktlk3.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icId;
}

});
parcelRegister("7sXIy", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $1763dadb9435774b$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $1763dadb9435774b$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "STAGING", () => $1763dadb9435774b$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $1763dadb9435774b$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $1763dadb9435774b$export$404582bc18fe4d9e);
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $1763dadb9435774b$export$d8347b4aae768c2d);
$parcel$export(module.exports, "NON_ISOLATED_CLOUD_PERIMETERS", () => $1763dadb9435774b$export$b1b1ccc8f3e7f954);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $1763dadb9435774b$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $1763dadb9435774b$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $1763dadb9435774b$export$a0ffa0598c95dfb7);
const $1763dadb9435774b$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $1763dadb9435774b$export$f005e2e9f707cb5f = 'commercial';
const $1763dadb9435774b$export$a739cd5aac835909 = 'staging';
const $1763dadb9435774b$export$42dd0cdd351a4a9 = 'prod';
const $1763dadb9435774b$export$404582bc18fe4d9e = 'dev';
const $1763dadb9435774b$export$d8347b4aae768c2d = [
    $1763dadb9435774b$export$f005e2e9f707cb5f
];
const $1763dadb9435774b$export$b1b1ccc8f3e7f954 = [
    $1763dadb9435774b$export$f005e2e9f707cb5f,
    $1763dadb9435774b$export$ce553301d55c2fd8
];
const $1763dadb9435774b$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $1763dadb9435774b$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $1763dadb9435774b$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';

});

parcelRegister("ktlk3", function(module, exports) {

$parcel$export(module.exports, "parseAtlCtxCookies", () => $0f0a6af92b57b044$export$3fa7b7af96286cc9);

var $7sXIy = parcelRequire("7sXIy");
/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $0f0a6af92b57b044$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}
function $0f0a6af92b57b044$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = $0f0a6af92b57b044$var$getRawCookieValue((0, $7sXIy.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = $0f0a6af92b57b044$var$getRawCookieValue((0, $7sXIy.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = $0f0a6af92b57b044$var$getRawCookieValue((0, $7sXIy.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});



parcelRegister("iXWR3", function(module, exports) {

$parcel$export(module.exports, "navigateToTeamsApp", () => $1684c3821ddae7b3$export$cd99a4ca8e852372);
$parcel$export(module.exports, "toTeamsAppURL", () => $1684c3821ddae7b3$export$196b2cec97b1c87c);

var $ApPad = parcelRequire("ApPad");

var $97oMO = parcelRequire("97oMO");
const $1684c3821ddae7b3$export$cd99a4ca8e852372 = (action)=>{
    const { hostProduct: hostProduct, shouldOpenInSameTab: shouldOpenInSameTab } = action;
    const actionWithDefaults = {
        ...action,
        /**
		 * If teams app is enabled, default to opening in new tab.
		 */ shouldOpenInSameTab: shouldOpenInSameTab === undefined ? !(0, $ApPad.isTeamsAppEnabled)(action) : shouldOpenInSameTab,
        hostProduct: hostProduct || (0, $97oMO.getHostProductFromPath)()
    };
    const { path: path, query: query } = (0, $97oMO.getPathAndQuery)(actionWithDefaults);
    const href = (0, $97oMO.generatePath)(path, actionWithDefaults, query);
    const onNavigate = (0, $97oMO.onNavigateBase)(href, actionWithDefaults);
    const result = {
        onNavigate: onNavigate,
        href: href,
        target: actionWithDefaults.shouldOpenInSameTab ? '_self' : '_blank'
    };
    return result;
};
const $1684c3821ddae7b3$export$196b2cec97b1c87c = (path, search, config)=>{
    return (0, $97oMO.generateTeamsAppPath)(path, config, new URLSearchParams(search));
};

});
parcelRegister("97oMO", function(module, exports) {

$parcel$export(module.exports, "generateTeamsAppPath", () => $4c78c78fff5a8a38$export$9665cb78fbba2c92);
$parcel$export(module.exports, "generatePath", () => $4c78c78fff5a8a38$export$82476f982757e71e);
$parcel$export(module.exports, "onNavigateBase", () => $4c78c78fff5a8a38$export$39f25014273b0a58);
$parcel$export(module.exports, "getPathAndQuery", () => $4c78c78fff5a8a38$export$b406f12e2156b3fe);
$parcel$export(module.exports, "getHostProductFromPath", () => $4c78c78fff5a8a38$export$a792d22ca73cc3ca);

var $9id36 = parcelRequire("9id36");
var $igNUx = parcelRequire("igNUx");

var $iBNIP = parcelRequire("iBNIP");

var $ApPad = parcelRequire("ApPad");
function $4c78c78fff5a8a38$export$9665cb78fbba2c92(path, config, query = new URLSearchParams(), anchor) {
    if (config.cloudId) query.set('cloudId', config.cloudId);
    const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`;
    const pathWithPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash : `/people${pathWithLeadingSlash}`;
    const pathWithoutPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash.replace(/^\/people\//, '/') : pathWithLeadingSlash;
    // URLSearchParams.size doesn't work in jest
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    // Home & therefore the Teams app, is not deployed to FedRamp, instead we have deployed Standalone directory.
    // At some point, likely both Commercial & FedRamp will follow the same URL convention and we can remove this,
    // but for now, we need to generate a different URL for FedRamp.
    if ((0, $igNUx.isFedRamp)()) // We can't use getATLContextUrl here as the URL doesn't yet exist in commercial. When it does, we should properly define it there.
    return `https://teams${$4c78c78fff5a8a38$export$a9f2c34176fff494() ? '.stg' : ''}.atlassian-us-gov.com${pathWithoutPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
    const orgIdString = config.orgId ? `/o/${config.orgId}` : '';
    return `${(0, $9id36.getATLContextUrl)('home')}${orgIdString}${pathWithPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
}
function $4c78c78fff5a8a38$export$82476f982757e71e(path, config, query = new URLSearchParams(), anchor) {
    if ((0, $ApPad.isTeamsAppEnabled)(config) || config.hostProduct === 'home' || !config.hostProduct) return $4c78c78fff5a8a38$export$9665cb78fbba2c92(path, config, query, anchor);
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    return `${(0, $iBNIP.origin)()}/${config.hostProduct === 'confluence' ? 'wiki' : 'jira'}/people/${path}${queryString}`;
}
const $4c78c78fff5a8a38$export$39f25014273b0a58 = (href, config)=>(e)=>{
        if (e) e.preventDefault();
        if ((0, $ApPad.isTeamsAppEnabled)(config)) {
            if (config.shouldOpenInSameTab) {
                (0, $iBNIP.redirect)(href);
                return;
            }
            (0, $iBNIP.openInNewTab)(href);
            return;
        } else if (config.shouldOpenInSameTab) {
            if (config.push) {
                config.push(href);
                return;
            }
            (0, $iBNIP.redirect)(href);
            return;
        } else {
            (0, $iBNIP.openInNewTab)(href);
            return;
        }
    };
function $4c78c78fff5a8a38$var$stripAriFromId(id) {
    // Return everything after the last slash
    return id.includes('/') ? id.split('/').pop() || '' : id;
}
function $4c78c78fff5a8a38$export$b406f12e2156b3fe(action) {
    switch(action.type){
        case 'LANDING':
        case 'DIRECTORY':
            return {
                path: ''
            };
        case 'USER':
            // Safety check for undefined userId, just redirect to the landing page as the profile redirect will fail
            if (!action.payload?.userId) return {
                path: ''
            };
            return {
                path: `${$4c78c78fff5a8a38$var$stripAriFromId(action.payload.userId)}`,
                anchor: action.payload.section
            };
        case 'TEAM':
            // Safety check for undefined teamId, just redirect to the landing page as the team redirect will fail
            if (!action.payload?.teamId) return {
                path: ''
            };
            return {
                path: `team/${$4c78c78fff5a8a38$var$stripAriFromId(action.payload.teamId)}`
            };
        case 'AGENT':
            // Safety check for undefined agentId, just redirect to the landing page as the agent redirect will fail
            if (!action.payload?.agentId) return {
                path: ''
            };
            return {
                path: `agent/${$4c78c78fff5a8a38$var$stripAriFromId(action.payload.agentId)}`
            };
        case 'KUDOS':
            // Safety check for undefined kudosId, just redirect to the landing page as the kudos redirect will fail
            if (!action.payload?.kudosId) return {
                path: ''
            };
            return {
                path: `kudos/${$4c78c78fff5a8a38$var$stripAriFromId(action.payload.kudosId)}`
            };
        case 'TEAMS_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_TEAMS'
                })
            };
        case 'PEOPLE_DIRECTORY':
            return {
                path: `search/people`,
                query: new URLSearchParams(action.payload.query)
            };
        case 'USER_WORK':
            return {
                path: `${$4c78c78fff5a8a38$var$stripAriFromId(action.payload.userId)}/work`
            };
        case 'CURRENT_USER_PROFILE':
            return {
                path: 'me'
            };
        default:
            return {
                path: ''
            };
    }
}
function $4c78c78fff5a8a38$export$a9f2c34176fff494() {
    const host = (0, $iBNIP.hostname)();
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (host.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return true;
    return false;
}
function $4c78c78fff5a8a38$export$a792d22ca73cc3ca() {
    const path = (0, $iBNIP.pathname)();
    if (path.startsWith('/wiki')) return 'confluence';
    if (path.startsWith('/jira')) return 'jira';
    if ((0, $iBNIP.hostname)().startsWith('home')) return 'home';
    return undefined;
}

});
parcelRegister("iBNIP", function(module, exports) {

$parcel$export(module.exports, "redirect", () => $84d46a6bd0ca0369$export$89e12c5b50f7529d);
$parcel$export(module.exports, "openInNewTab", () => $84d46a6bd0ca0369$export$9e52b10d57ddf9e3);
$parcel$export(module.exports, "hostname", () => $84d46a6bd0ca0369$export$640106f6dc7d2706);
$parcel$export(module.exports, "origin", () => $84d46a6bd0ca0369$export$f710a83a91838a36);
$parcel$export(module.exports, "pathname", () => $84d46a6bd0ca0369$export$7333db99aa99d383);
function $84d46a6bd0ca0369$export$89e12c5b50f7529d(url) {
    window.location.href = url;
}
const $84d46a6bd0ca0369$export$9e52b10d57ddf9e3 = (url)=>window.open(url, '_blank', 'noopener noreferrer');
const $84d46a6bd0ca0369$export$640106f6dc7d2706 = ()=>globalThis.location?.hostname;
const $84d46a6bd0ca0369$export$f710a83a91838a36 = ()=>globalThis.location?.origin;
const $84d46a6bd0ca0369$export$7333db99aa99d383 = ()=>globalThis.location?.pathname;

});




parcelRegister("41vqi", function(module, exports) {

$parcel$export(module.exports, "getUserNavigationItemLinks", () => $991ce81a1da95cb9$export$1ed619da1e21182);

var $epTsa = parcelRequire("epTsa");

var $fuV6j = parcelRequire("fuV6j");

var $8IuE5 = parcelRequire("8IuE5");
const $991ce81a1da95cb9$export$1ed619da1e21182 = ()=>{
    return (0, $epTsa.expVal)('navx-1075-remove-goals-and-projects-fallback-urls', 'isEnabled', false) ? {
        [(0, $8IuE5.L1_MENU_ID).APPS]: '/jira/marketplace/discover?source=apps-menu',
        [(0, $8IuE5.L1_MENU_ID).GOALS]: '/jira/your-work?goals',
        [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: (0, $fuV6j.dashboardsDirectoryRoute).path,
        [(0, $8IuE5.L1_MENU_ID).TEAMS]: '/jira/people/search',
        [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: '/jira/polaris/roadmaps',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: '/jira/assets',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: '',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: '',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: '',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: '',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: ''
    } : {
        [(0, $8IuE5.L1_MENU_ID).APPS]: '/jira/marketplace/discover?source=apps-menu',
        [(0, $8IuE5.L1_MENU_ID).GOALS]: '/jira/your-work?goals',
        [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: (0, $fuV6j.dashboardsDirectoryRoute).path,
        [(0, $8IuE5.L1_MENU_ID).TEAMS]: '/jira/people/search',
        [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: '/jira/polaris/roadmaps',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: '/jira/assets',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: 'https://home.atlassian.com/goals',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: 'https://home.atlassian.com/projects',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: '',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: '',
        [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: ''
    };
};

});
parcelRegister("fuV6j", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $f8f2a1120a41a941$export$41bba408475cab16);
const $f8f2a1120a41a941$export$41bba408475cab16 = {
    name: 'dashboards-directory',
    path: '/jira/dashboards'
};

});


parcelRegister("dx2Xz", function(module, exports) {

$parcel$export(module.exports, "useGlobalApps", () => $0cdfec629a7fe95c$export$3a835823210524f1);
$parcel$export(module.exports, "isSupportedMenuId", () => $0cdfec629a7fe95c$export$54d4b2a367e2f9d);
$parcel$export(module.exports, "isGlobalAppMenuId", () => $0cdfec629a7fe95c$export$4c0a3527505b04c5);
$parcel$export(module.exports, "hasGlobalAppLicense", () => $0cdfec629a7fe95c$export$f97a769ad5c10cb4);

var $eJOHy = parcelRequire("eJOHy");

var $d9MBC = parcelRequire("d9MBC");

var $7jTnu = parcelRequire("7jTnu");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");

var $7cSYk = parcelRequire("7cSYk");

var $lvKO5 = parcelRequire("lvKO5");

var $a62R3 = parcelRequire("a62R3");

var $5Q9JR = parcelRequire("5Q9JR");

var $8IuE5 = parcelRequire("8IuE5");
function $0cdfec629a7fe95c$export$3a835823210524f1() {
    const appEditions = (0, $8vyDv.useAppEditions)();
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const shouldShowGoals = (appEditions.productDiscovery !== (0, $a9ldn.UNLICENSED) || appEditions.software !== (0, $a9ldn.UNLICENSED) || // JSM comes with a free core license. Goals don't display with JSM-only, so checking for unlicensed JSM
    appEditions.core !== (0, $a9ldn.UNLICENSED) && appEditions.serviceDesk === (0, $a9ldn.UNLICENSED)) && !(0, $d9MBC.isFedrampModerate)();
    const shouldShowAssets = appEditions.serviceDesk !== (0, $a9ldn.UNLICENSED) && (0, $7jTnu.fg)('assets_as_an_app_v2') && (0, $7cSYk.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP);
    const shouldShowTeams = (0, $a62R3.isTeamsAppEnabled)();
    const globalAppShortcuts = (0, $eJOHy.useMemo)(()=>{
        if (appEditions.core !== (0, $a9ldn.UNLICENSED)) {
            if (appEditions.serviceDesk !== (0, $a9ldn.UNLICENSED)) return {
                confluence: true,
                loom: true,
                projects: false,
                teams: shouldShowTeams,
                opsgenie: true
            };
            if (appEditions.productDiscovery !== (0, $a9ldn.UNLICENSED)) return {
                confluence: true,
                loom: true,
                projects: false,
                teams: shouldShowTeams,
                opsgenie: false
            };
        } else {
            if (appEditions.serviceDesk !== (0, $a9ldn.UNLICENSED)) return {
                confluence: false,
                loom: false,
                projects: false,
                teams: shouldShowTeams,
                opsgenie: true
            };
            if (appEditions.productDiscovery !== (0, $a9ldn.UNLICENSED)) return {
                confluence: false,
                loom: false,
                projects: false,
                teams: shouldShowTeams,
                opsgenie: false
            };
        }
        return {
            confluence: true,
            loom: true,
            projects: true,
            teams: shouldShowTeams,
            opsgenie: false
        };
    }, [
        appEditions,
        shouldShowTeams
    ]);
    if ((0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $eJOHy.useMemo)(()=>{
        if ((0, $7jTnu.fg)('nav4_global_links_jira')) return {
            goals: shouldShowGoals,
            assets: shouldShowAssets,
            ...globalAppShortcuts
        };
        return {
            goals: shouldShowGoals,
            assets: shouldShowAssets,
            confluence: false,
            loom: false,
            projects: false,
            teams: shouldShowTeams,
            opsgenie: false
        };
    }, [
        globalAppShortcuts,
        shouldShowAssets,
        shouldShowGoals,
        shouldShowTeams
    ]);
    if ((0, $7jTnu.fg)('nav4_global_links_jira')) return {
        goals: shouldShowGoals,
        assets: shouldShowAssets,
        ...globalAppShortcuts
    };
    return {
        goals: shouldShowGoals,
        assets: shouldShowAssets,
        confluence: false,
        loom: false,
        projects: false,
        teams: shouldShowTeams,
        opsgenie: false
    };
}
const $0cdfec629a7fe95c$export$54d4b2a367e2f9d = (value)=>(0, $5Q9JR.CONFIGURABLE_MENU_IDS_AS_STRINGS).includes(value);
const $0cdfec629a7fe95c$export$4c0a3527505b04c5 = (value)=>(0, $5Q9JR.GLOBAL_APP_MENU_IDS_AS_STRINGS).includes(value);
const $0cdfec629a7fe95c$export$f97a769ad5c10cb4 = (value, globalAppLicense)=>{
    switch(value){
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS:
            return globalAppLicense.assets;
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS:
            return globalAppLicense.goals;
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE:
            return globalAppLicense.confluence;
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM:
            return globalAppLicense.loom;
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS:
            return globalAppLicense.projects;
        case (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS:
            return globalAppLicense.teams;
        default:
            return false;
    }
};

});
parcelRegister("8vyDv", function(module, exports) {

$parcel$export(module.exports, "useAppEditions", () => $3e65f3816445db61$export$92ed15881fc090d7);

var $lvKO5 = parcelRequire("lvKO5");
const $3e65f3816445db61$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});



parcelRegister("9Byj7", function(module, exports) {

$parcel$export(module.exports, "GlobalAppShortcuts", () => $a485af5218d0d252$export$69209b4d7b9e00bc);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $95rKK = parcelRequire("95rKK");

const $a485af5218d0d252$export$69209b4d7b9e00bc = ({ menuId: menuId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "global-app-shortcuts-section",
        packageName: (0, $31028703e58eb566$export$b8b9d90f9e5bd72b),
        teamName: (0, $31028703e58eb566$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $95rKK.GlobalAppShortcuts), {
        menuId: menuId
    }));

});
parcelRegister("95rKK", function(module, exports) {

$parcel$export(module.exports, "GlobalAppShortcuts", () => $f7dd192ec4f47404$export$69209b4d7b9e00bc);

var $eJOHy = parcelRequire("eJOHy");

var $h4Bzb = parcelRequire("h4Bzb");

var $qEpp6 = parcelRequire("qEpp6");

var $a9aec = parcelRequire("a9aec");

var $7jTnu = parcelRequire("7jTnu");

var $a62R3 = parcelRequire("a62R3");

var $1aakl = parcelRequire("1aakl");

var $5D4AX = parcelRequire("5D4AX");

var $6RXjp = parcelRequire("6RXjp");
function $f7dd192ec4f47404$export$69209b4d7b9e00bc({ menuId: menuId }) {
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const onClick = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)(()=>{
        sendSectionItemAnalyticsEvent({
            menuId: menuId,
            sectionItem: (0, $a9aec.SECTION_ITEM_MAP)[menuId]
        });
    }, [
        menuId,
        sendSectionItemAnalyticsEvent
    ]) : ()=>{
        sendSectionItemAnalyticsEvent({
            menuId: menuId,
            sectionItem: (0, $a9aec.SECTION_ITEM_MAP)[menuId]
        });
    };
    switch(menuId){
        case (0, $h4Bzb.GLOBAL_APP_MENU_ID).GLOBAL_APP_GOALS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5D4AX.Goals), {
                onClick: onClick
            });
        case (0, $h4Bzb.GLOBAL_APP_MENU_ID).GLOBAL_APP_ASSETS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1aakl.Assets), {
                onClick: onClick
            });
        case (0, $h4Bzb.GLOBAL_APP_MENU_ID).GLOBAL_APP_TEAMS:
            return (0, $a62R3.isTeamsAppEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6RXjp.Teams), {
                onClick: onClick
            }) : null;
        default:
            return null;
    }
}

});
parcelRegister("qEpp6", function(module, exports) {

$parcel$export(module.exports, "useSectionItemAnalytics", () => $4bdc0dcd80ec4722$export$88869d054e1fb00a);

var $eJOHy = parcelRequire("eJOHy");


var $a9aec = parcelRequire("a9aec");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $80rA3 = parcelRequire("80rA3");
const $4bdc0dcd80ec4722$export$ee0f05907a733e87 = ({ sectionItem: sectionItem, menuId: menuId, moreMenuIds: moreMenuIds })=>{
    if (sectionItem === (0, $a9aec.SECTION_ITEM_CUSTOMIZE_SIDEBAR)) return moreMenuIds.length !== 0;
    if (menuId) return moreMenuIds.includes(menuId);
    return false;
};
function $4bdc0dcd80ec4722$export$88869d054e1fb00a() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const sendSectionItemAnalyticsEvent = (0, $eJOHy.useCallback)(({ menuId: menuId, sectionItem: sectionItem })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const isInMore = $4bdc0dcd80ec4722$export$ee0f05907a733e87({
            sectionItem: sectionItem,
            menuId: menuId,
            moreMenuIds: moreMenuIds
        });
        (0, $gCeeo.fireUIAnalytics)(event, sectionItem, {
            isInMore: isInMore
        });
    }, [
        createAnalyticsEvent,
        moreMenuIds
    ]);
    return sendSectionItemAnalyticsEvent;
}

});

parcelRegister("1aakl", function(module, exports) {

$parcel$export(module.exports, "Assets", () => $636a621f455b216e$export$c8eca95e306f7116);

var $eJOHy = parcelRequire("eJOHy");

var $6L9RF = parcelRequire("6L9RF");

var $dieBt = parcelRequire("dieBt");

var $aasrU = parcelRequire("aasrU");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $lRq8t = parcelRequire("lRq8t");

var $8IuE5 = parcelRequire("8IuE5");

var $8vyDv = parcelRequire("8vyDv");

var $6ANkN = parcelRequire("6ANkN");

var $lUto7 = parcelRequire("lUto7");

var $a9ldn = parcelRequire("a9ldn");

var $2sjJ8 = parcelRequire("2sjJ8");
function $636a621f455b216e$export$c8eca95e306f7116({ onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const url = '/jira/assets';
    const appEditions = (0, $8vyDv.useAppEditions)();
    const isNotJsmPremium = appEditions.serviceDesk !== (0, $a9ldn.PREMIUM_EDITION);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    if (isNotJsmPremium) {
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
            serviceDeskEdition: appEditions.serviceDesk,
            isSiteAdmin: isSiteAdmin
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ANkN.AssetsUpsellButton), {
            configurableMenuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS,
            lozengeText: formatMessage((0, $2sjJ8.default).lozenge)
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aasrU.LinkMenuItem), {
        href: url,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6L9RF))), {
            label: "",
            spacing: "spacious",
            size: "small"
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dieBt.AssetsIcon), null),
        target: "_blank",
        onClick: onClick,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.assets.menu-link-item"
    }, formatMessage((0, $2sjJ8.default).assets));
}

});
parcelRegister("6ANkN", function(module, exports) {

$parcel$export(module.exports, "AssetsUpsellButton", () => $225baa7b40f9fb33$export$a04ba1c400e85b23);
$parcel$export(module.exports, "AssetsAppItem", () => $225baa7b40f9fb33$export$5803e5f720bc19ab);

var $eJOHy = parcelRequire("eJOHy");

var $6L9RF = parcelRequire("6L9RF");

var $6alcT = parcelRequire("6alcT");

var $ckAJd = parcelRequire("ckAJd");
var $ivTBg = parcelRequire("ivTBg");
var $2fsZx = parcelRequire("2fsZx");
var $5xGaI = parcelRequire("5xGaI");

var $lRq8t = parcelRequire("lRq8t");

var $2QH3X = parcelRequire("2QH3X");

var $bYOuG = parcelRequire("bYOuG");

var $8IuE5 = parcelRequire("8IuE5");

var $eL2Ux = parcelRequire("eL2Ux");

var $59lfa = parcelRequire("59lfa");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $iIEpz = parcelRequire("iIEpz");

var $8z6Yy = parcelRequire("8z6Yy");

var $6FAEa = parcelRequire("6FAEa");



var $1Q9Vz = parcelRequire("1Q9Vz");
const $225baa7b40f9fb33$var$actionsOnHover = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
    MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
            menuId: (0, $8IuE5.L1_MENU_ID).ASSETS
        })
});
const $225baa7b40f9fb33$var$linkAnalytics = {
    actionSubjectId: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
    itemId: (0, $h4Bzb.MENU_ID_ASSETS),
    level: 1
};
const $225baa7b40f9fb33$var$upsellButtonAnalytics = {
    ...$225baa7b40f9fb33$var$linkAnalytics,
    componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147)
};
const $225baa7b40f9fb33$var$AssetsExternalLink = ()=>{
    const { formattedMessage: assetsMessage, icon: assetsIcon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).ASSETS);
    const { icon: openExternalLinkIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $1Q9Vz.default).openAssetsApp, (0, (/*@__PURE__*/$parcel$interopDefault($6L9RF))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: (0, $bYOuG.getRootPath)(),
        target: "_blank",
        menuId: (0, $h4Bzb.MENU_ID_ASSETS),
        analytics: $225baa7b40f9fb33$var$linkAnalytics,
        elemBefore: assetsIcon,
        elemAfter: openExternalLinkIcon,
        actionsOnHover: $225baa7b40f9fb33$var$actionsOnHover
    }, assetsMessage);
};
const $225baa7b40f9fb33$export$a04ba1c400e85b23 = ({ configurableMenuId: configurableMenuId, lozengeText: lozengeText })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const configurableMessageIcon = configurableMenuId ?? (0, $8IuE5.L1_MENU_ID).ASSETS;
    const { formattedMessage: assetsMessage, icon: assetsIcon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)(configurableMessageIcon);
    const upsellText = lozengeText ?? formatMessage((0, $1Q9Vz.default).upsellLozengeText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iIEpz.default), {
        elemBefore: assetsIcon,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
            testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.upsell-lozenge",
            appearance: "new"
        }, upsellText),
        analytics: $225baa7b40f9fb33$var$upsellButtonAnalytics,
        onClick: ()=>{
            setIsOpen(true);
        },
        actionsOnHover: configurableMessageIcon === (0, $8IuE5.L1_MENU_ID).ASSETS ? $225baa7b40f9fb33$var$actionsOnHover : null,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.nav-4-menu-button-item"
    }, assetsMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ckAJd.Drawer), {
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        width: "full",
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.drawer",
        label: assetsMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5xGaI.DrawerSidebar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivTBg.DrawerCloseButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2fsZx.DrawerContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6FAEa.AsyncCmdbUpsellPage), null))));
};
const $225baa7b40f9fb33$export$5803e5f720bc19ab = ({ showUpsell: showUpsell })=>{
    if (showUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($225baa7b40f9fb33$export$a04ba1c400e85b23, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($225baa7b40f9fb33$var$AssetsExternalLink, null);
};

});
parcelRegister("bYOuG", function(module, exports) {

$parcel$export(module.exports, "ASSETS_APP_ROUTE_PREFIX", () => $59de792af1bc0730$export$42e57fb76a904fc3);
$parcel$export(module.exports, "isInsightRoute", () => $59de792af1bc0730$export$296d80f3ce129968);
$parcel$export(module.exports, "getCreateServiceUrl", () => $59de792af1bc0730$export$1f9b8b558a361aaf);
$parcel$export(module.exports, "getRootPath", () => $59de792af1bc0730$export$5413f45d031c7806);
$parcel$export(module.exports, "getLandingPageUrl", () => $59de792af1bc0730$export$9366da5a373815e5);
$parcel$export(module.exports, "getGlobalConfigUrl", () => $59de792af1bc0730$export$20fd4a0aec335970);
$parcel$export(module.exports, "getAssetsSettingsUrl", () => $59de792af1bc0730$export$15f6d6ab94d89135);
$parcel$export(module.exports, "getDataManagerUrl", () => $59de792af1bc0730$export$c9b27b0d2e19d52f);
$parcel$export(module.exports, "getDataManagerGettingStartedUrl", () => $59de792af1bc0730$export$3d0380185f73b3d);
$parcel$export(module.exports, "getDataManagerObjectClassesUrl", () => $59de792af1bc0730$export$4c9768bc51c7a1a);
$parcel$export(module.exports, "getDataManagerVisualizationUrl", () => $59de792af1bc0730$export$6c3cb6f103b2324);
$parcel$export(module.exports, "getDataManagerAdaptersUrl", () => $59de792af1bc0730$export$cd6b35373ba077a);
$parcel$export(module.exports, "getAssetsReportsUrl", () => $59de792af1bc0730$export$c1909404b7ea317f);
$parcel$export(module.exports, "getAssetsReportUrl", () => $59de792af1bc0730$export$272d35cbff1c220e);
$parcel$export(module.exports, "getAssetsSearchResultsUrl", () => $59de792af1bc0730$export$97bfda8f5f38a121);
$parcel$export(module.exports, "createObjectSchemasUrl", () => $59de792af1bc0730$export$c48ea1282c74411e);
$parcel$export(module.exports, "createObjectSchemaUrl", () => $59de792af1bc0730$export$3a0332e980fe56cf);
$parcel$export(module.exports, "createObjectTypeUrl", () => $59de792af1bc0730$export$cfefb90cfb86b528);
$parcel$export(module.exports, "createObjectSchemaConfigUrl", () => $59de792af1bc0730$export$f02479149ce3cac7);
$parcel$export(module.exports, "createObjectDetailUrl", () => $59de792af1bc0730$export$51e4229f2c7d3866);
$parcel$export(module.exports, "createObjectTypeSettingsUrl", () => $59de792af1bc0730$export$4b4b7d2c3df4fa58);
$parcel$export(module.exports, "createObjectTypeListWithObjectSelectedUrl", () => $59de792af1bc0730$export$c1790fa8f0d8e89a);
$parcel$export(module.exports, "getFeatureUsagePageUrl", () => $59de792af1bc0730$export$5ba89eed0cf60033);
$parcel$export(module.exports, "getFeatureUsageVirtualAgentPageUrl", () => $59de792af1bc0730$export$415502b49e27270d);

var $b5RwB = parcelRequire("b5RwB");

var $7jTnu = parcelRequire("7jTnu");

var $9suIz = parcelRequire("9suIz");
const $59de792af1bc0730$export$ee637ecb2dfa4f6a = '/jira/servicedesk/service-modal';
const $59de792af1bc0730$export$42e57fb76a904fc3 = '/jira/assets';
const $59de792af1bc0730$export$80e512187a5e0d10 = '/jira/servicedesk/assets';
const $59de792af1bc0730$export$6d7574dbda22cf7 = '/jira/servicedesk/insight';
const $59de792af1bc0730$export$296d80f3ce129968 = (pathname)=>pathname.includes($59de792af1bc0730$export$6d7574dbda22cf7);
const $59de792af1bc0730$export$1f9b8b558a361aaf = ()=>$59de792af1bc0730$export$ee637ecb2dfa4f6a;
const $59de792af1bc0730$export$5413f45d031c7806 = ()=>(0, $7jTnu.fg)('assets_as_an_app_v2') ? $59de792af1bc0730$export$42e57fb76a904fc3 : $59de792af1bc0730$export$80e512187a5e0d10;
const $59de792af1bc0730$export$9366da5a373815e5 = ()=>$59de792af1bc0730$export$5413f45d031c7806();
const $59de792af1bc0730$export$20fd4a0aec335970 = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/configure/global`;
const $59de792af1bc0730$export$15f6d6ab94d89135 = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/configure/global`;
const $59de792af1bc0730$export$c9b27b0d2e19d52f = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/data-manager/`;
const $59de792af1bc0730$export$3d0380185f73b3d = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/data-manager/getting-started`;
const $59de792af1bc0730$export$4c9768bc51c7a1a = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/data-manager/object-classes`;
const $59de792af1bc0730$export$6c3cb6f103b2324 = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/data-manager/#/dashboards`;
const $59de792af1bc0730$export$cd6b35373ba077a = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/data-manager/adapters/`;
const $59de792af1bc0730$export$c1909404b7ea317f = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/reports`;
const $59de792af1bc0730$export$771825afb10f956f = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/analytics/data-view/create`;
const $59de792af1bc0730$export$272d35cbff1c220e = (reportId)=>`${$59de792af1bc0730$export$c1909404b7ea317f()}/${reportId}`;
const $59de792af1bc0730$export$97bfda8f5f38a121 = (query)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/search${query ? `?${query}` : ''}`;
const $59de792af1bc0730$export$c48ea1282c74411e = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/object-schemas`;
const $59de792af1bc0730$export$3a0332e980fe56cf = (objectSchemaId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/object-schema/${objectSchemaId}`;
const $59de792af1bc0730$export$cfefb90cfb86b528 = (objectSchemaId, objectTypeId)=>`${$59de792af1bc0730$export$3a0332e980fe56cf(objectSchemaId)}?${(0, $9suIz.SCHEMA_PAGE_QUERY_PARAMS).objectTypeId}=${objectTypeId}`;
const $59de792af1bc0730$export$f02479149ce3cac7 = (objectSchemaId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/configure/object-schema/${objectSchemaId}`;
const $59de792af1bc0730$export$51e4229f2c7d3866 = (objectId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/object/${objectId}`;
const $59de792af1bc0730$export$4b4b7d2c3df4fa58 = (objectTypeId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/configure/object-type/${objectTypeId}`;
const $59de792af1bc0730$export$c1790fa8f0d8e89a = (objectSchemaId, objectTypeId, objectId)=>`${$59de792af1bc0730$export$cfefb90cfb86b528(objectSchemaId, objectTypeId)}&view=list&objectId=${objectId}`;
const $59de792af1bc0730$export$6e21e6efe57484c5 = (queryParams = {})=>{
    const base = `${$59de792af1bc0730$export$42e57fb76a904fc3}/search`;
    if (Object.keys(queryParams).length > 0) {
        const encodedParams = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(queryParams);
        return `${base}?${encodedParams}`;
    }
    return base;
};
const $59de792af1bc0730$export$5ba89eed0cf60033 = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=assets${showChangeLimitModal ? '&changeLimit=true' : ''}`;
const $59de792af1bc0730$export$415502b49e27270d = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=virtual-agent${showChangeLimitModal ? '&changeLimit=true' : ''}`;

});
parcelRegister("9suIz", function(module, exports) {

$parcel$export(module.exports, "SCHEMA_PAGE_QUERY_PARAMS", () => $38b78989e1c789e8$export$a73deb42718b5c4);
$parcel$export(module.exports, "TAB_QUERY_PARAM_REFERENCE_TYPES", () => $38b78989e1c789e8$export$f7855185bab37329);
$parcel$export(module.exports, "TAB_QUERY_PARAM_STATUSES", () => $38b78989e1c789e8$export$3739ebbc7c6e87e8);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ICONS", () => $38b78989e1c789e8$export$2c22dc6c729ae0bd);
$parcel$export(module.exports, "TAB_QUERY_PARAM_DATA_MANAGER", () => $38b78989e1c789e8$export$f37b3a97acf56eaf);
$parcel$export(module.exports, "TAB_QUERY_PARAM_COMMON_DATA_MODEL", () => $38b78989e1c789e8$export$b5445f8b5c64a799);
$parcel$export(module.exports, "TAB_QUERY_PARAM_GENERAL", () => $38b78989e1c789e8$export$12ebb1d5017e1d6d);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ROLES", () => $38b78989e1c789e8$export$a77734d9ea30fe44);
$parcel$export(module.exports, "TAB_QUERY_PARAM_IMPORT", () => $38b78989e1c789e8$export$be37b820df30c947);
$parcel$export(module.exports, "TAB_QUERY_PARAM_INHERITANCE", () => $38b78989e1c789e8$export$670faa8ae93e0903);
$parcel$export(module.exports, "useUpdateQueryParams", () => $38b78989e1c789e8$export$e66acc5f4583ce1c);
$parcel$export(module.exports, "useObjectTypeIdQueryParam", () => $38b78989e1c789e8$export$f5a33d51dd6de08);
$parcel$export(module.exports, "useObjectIdQueryParam", () => $38b78989e1c789e8$export$a6e3187c87554a1e);
$parcel$export(module.exports, "useSchemaViewModeQueryParam", () => $38b78989e1c789e8$export$6abda0ad26022eff);
$parcel$export(module.exports, "useObjectViewModeQueryParam", () => $38b78989e1c789e8$export$1927b50f7d074492);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $4ZeQj = parcelRequire("4ZeQj");

var $95O7y = parcelRequire("95O7y");
var $gCY1z = parcelRequire("gCY1z");
var $83DiZ = parcelRequire("83DiZ");
const $38b78989e1c789e8$export$a73deb42718b5c4 = {
    // Values are 'object' or 'attribute'
    schemaMode: 'mode',
    // Values are 'list' or undefined
    objectViewMode: 'view',
    // Both of these params are supported to set the object type ID. 'typeId' is preferred and is the one that is updated.
    // 'objecttypeid' is only used on initial load to support customers who have bookmarked this URL.
    objectTypeId: 'typeId',
    fallbackObjectTypeId: 'objecttypeid',
    objectId: 'objectId'
};
const $38b78989e1c789e8$export$f7855185bab37329 = 'reference-types';
const $38b78989e1c789e8$export$3739ebbc7c6e87e8 = 'statuses';
const $38b78989e1c789e8$export$2c22dc6c729ae0bd = 'icons';
const $38b78989e1c789e8$export$f37b3a97acf56eaf = 'data-manager';
const $38b78989e1c789e8$export$b5445f8b5c64a799 = 'common-data-model';
const $38b78989e1c789e8$export$12ebb1d5017e1d6d = 'general';
const $38b78989e1c789e8$export$a77734d9ea30fe44 = 'roles';
const $38b78989e1c789e8$export$be37b820df30c947 = 'import';
const $38b78989e1c789e8$export$670faa8ae93e0903 = 'inheritance';
const $38b78989e1c789e8$export$e66acc5f4583ce1c = ()=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const [{ location: location }] = (0, $gCY1z.useRouter)();
    const updateQueryParams = (0, $eJOHy.useCallback)((queryParams = {})=>{
        const { pathname: pathname, search: search } = location;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedQueryParams = {};
        Object.keys(queryParams).forEach((key)=>{
            updatedQueryParams[key] = queryParams[key] ?? undefined;
        });
        return `${pathname}?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(search),
            ...updatedQueryParams
        })}`;
    }, [
        location
    ]);
    const pushRouterAction = (0, $eJOHy.useCallback)((path)=>{
        push(path);
    }, [
        push
    ]);
    return [
        {
            updateQueryParams: updateQueryParams,
            pushRouterAction: pushRouterAction
        }
    ];
};
const $38b78989e1c789e8$export$f5a33d51dd6de08 = ()=>{
    const [objectTypeId, setObjectTypeId] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.objectTypeId);
    const [fallbackObjectTypeId, setFallbackObjectTypeId] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.fallbackObjectTypeId);
    (0, $eJOHy.useEffect)(()=>{
        if (fallbackObjectTypeId !== undefined) {
            setObjectTypeId((0, $4ZeQj.toCmdbObjectTypeId)(fallbackObjectTypeId), 'replace');
            setFallbackObjectTypeId(undefined, 'replace');
        }
    }, [
        fallbackObjectTypeId,
        setObjectTypeId,
        setFallbackObjectTypeId
    ]);
    const nullableMain = objectTypeId !== undefined ? (0, $4ZeQj.toCmdbObjectTypeId)(objectTypeId) : null;
    const nullableFallback = fallbackObjectTypeId !== undefined ? (0, $4ZeQj.toCmdbObjectTypeId)(fallbackObjectTypeId) : null;
    const setter = (newObjectTypeId, updateType)=>{
        setObjectTypeId(newObjectTypeId !== null ? newObjectTypeId : undefined, updateType);
    };
    return [
        nullableMain !== null ? nullableMain : nullableFallback,
        setter
    ];
};
const $38b78989e1c789e8$export$a6e3187c87554a1e = ()=>{
    const [objectId, setObjectId] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.objectId);
    const nullableObjectId = objectId !== undefined ? (0, $4ZeQj.toCmdbObjectId)(objectId) : null;
    const setter = (newObjectId, updateType)=>{
        setObjectId(newObjectId !== null ? newObjectId : undefined, updateType);
    };
    return [
        nullableObjectId,
        setter
    ];
};
const $38b78989e1c789e8$export$6abda0ad26022eff = ()=>{
    const [rawParamValue, setSchemaMode] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.schemaMode);
    const schemaMode = rawParamValue === 'attribute' ? 'attribute' : 'object';
    return [
        schemaMode,
        setSchemaMode
    ];
};
const $38b78989e1c789e8$export$1927b50f7d074492 = ()=>{
    const [rawParamValue, setObjectViewMode] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.objectViewMode);
    const objectViewMode = rawParamValue === 'list' ? 'list' : 'details';
    const setter = (newValue, updateMode)=>{
        setObjectViewMode(newValue === 'list' ? 'list' : undefined, updateMode);
    };
    return [
        objectViewMode,
        setter
    ];
};

});


parcelRegister("59lfa", function(module, exports) {

$parcel$export(module.exports, "HideL1MenuItemSection", () => $87aee0eb86812bcf$export$a6246d2fccf72824);

var $7CMe6 = parcelRequire("7CMe6");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $1AUsu = parcelRequire("1AUsu");
var $7R1al = parcelRequire("7R1al");

var $h8epd = parcelRequire("h8epd");

var $8nw3F = parcelRequire("8nw3F");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");




var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $gCeeo = parcelRequire("gCeeo");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");

var $80rA3 = parcelRequire("80rA3");

var $gJU90 = parcelRequire("gJU90");

var $k3BsH = parcelRequire("k3BsH");

var $i3VM0 = parcelRequire("i3VM0");
const $87aee0eb86812bcf$var$HIDE_ROOT_MENU_ITEM_SUCCESS = 'HIDE_ROOT_MENU_ITEM_SUCCESS';
const $87aee0eb86812bcf$var$RESTORE_ROOT_MENU_ITEM_SUCCESS = 'RESTORE_ROOT_MENU_ITEM_SUCCESS';
function $87aee0eb86812bcf$var$HideL1MenuItemSectionInner(props) {
    const { menuId: menuId } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { navItems: navItems } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const { peekMenuId: peekMenuId } = (0, $eJOHy.useContext)((0, $80rA3.PeekMenuIdContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const cloudID = (0, $kEUB1.useCloudId)();
    const [isHidden, setIsHidden] = (0, $eJOHy.useState)(false);
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const [commit] = (0, $j4oe4.useMutation)((0, $7CMe6.default));
    const onSave = (0, $eJOHy.useCallback)((newNavItems)=>{
        commit({
            variables: {
                input: {
                    cloudID: cloudID,
                    navKey: 'NAV_SIDEBAR',
                    navItems: newNavItems
                }
            }
        });
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebarNavItems changed', {
            originalNavItems: navItems,
            updatedNavItems: newNavItems,
            changedFrom: 'hideFromSidebarButton'
        });
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[menuId],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                parentItemId: (0, $a9aec.SECTION_ITEM_MAP)[menuId],
                itemId: 'hideFromSidebar'
            }
        });
    }, [
        cloudID,
        commit,
        createAnalyticsEvent,
        menuId,
        navItems
    ]);
    const toggleNavItemVisibility = (0, $eJOHy.useCallback)(({ isVisible: isVisible })=>{
        const newNavItems = navItems.map((item)=>{
            if (item.menuId === menuId) return {
                ...item,
                isVisible: isVisible
            };
            return {
                ...item
            };
        });
        return newNavItems;
    }, [
        menuId,
        navItems
    ]);
    const onRestoreRootMenuItem = ()=>{
        if (navItems !== undefined) {
            const newNavItems = toggleNavItemVisibility({
                isVisible: true
            });
            onSave(newNavItems);
            setIsHidden(false);
            showFlag({
                type: 'success',
                id: $87aee0eb86812bcf$var$RESTORE_ROOT_MENU_ITEM_SUCCESS,
                title: (0, $i3VM0.getNavItemRestoredFromSideBarFlagTitle)(menuId),
                isAutoDismiss: true,
                messageId: 'navigation-apps-sidebar-nav4-sidebars-common-core.ui.hide-l1-menu-item-action.show-flag.success.restore-root-menu-item-success',
                messageType: 'transactional'
            });
        }
    };
    const onHideRootMenuItem = ()=>{
        if (navItems !== undefined) {
            const newNavItems = toggleNavItemVisibility({
                isVisible: false
            });
            onSave(newNavItems);
            setIsHidden(true);
            showFlag({
                type: 'success',
                id: $87aee0eb86812bcf$var$HIDE_ROOT_MENU_ITEM_SUCCESS,
                title: (0, $i3VM0.getNavItemHiddenFromSideBarFlagTitle)(menuId),
                isAutoDismiss: true,
                messageId: 'navigation-apps-sidebar-nav4-sidebars-common-core.ui.hide-l1-menu-item-action.show-flag.success.hide-root-menu-item-success',
                messageType: 'transactional',
                actions: [
                    {
                        content: (0, $k3BsH.default).moveBackToSidebar,
                        onClick: ()=>{
                            onRestoreRootMenuItem();
                            dismissFlag($87aee0eb86812bcf$var$HIDE_ROOT_MENU_ITEM_SUCCESS);
                        }
                    }
                ]
            });
        }
    };
    // When the peekend menu id is the same as the menu id, the menu item is disabled because it's not possible
    // to hide an already hidden menu item. Do indicate this we need to both disable the button and set the color
    // of the icon and text appropriately.
    const isDisabled = peekMenuId === menuId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nw3F.AnnouncerV2), {
        message: formatMessage((0, $i3VM0.getA11YAlert)(menuId)),
        shouldAnnounce: isHidden
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
        interactionName: (0, $7jTnu.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-hide-from-sidebar-button' : undefined,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gJU90.HideIcon), {
            label: "",
            primaryColor: isDisabled ? 'color.icon.disabled' : 'color.icon'
        }),
        onClick: onHideRootMenuItem,
        isDisabled: isDisabled,
        "aria-label": formatMessage((0, $i3VM0.getA11YLabel)(menuId))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
        color: isDisabled ? 'color.text.disabled' : 'color.text'
    }, formatMessage((0, $k3BsH.default).hideFromSidebar))));
}
function $87aee0eb86812bcf$export$a6246d2fccf72824(props) {
    const { hasSeparator: hasSeparator = true, hasSection: hasSection = true } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: (0, $427a1e7fccde0648$export$a3821bc63538b210),
        sourceType: (0, $466f60259c330878$export$d1123261ca8831d2),
        containerId: (0, $427a1e7fccde0648$export$3c19576bd92ff564),
        containerType: (0, $427a1e7fccde0648$export$fba7c3adda5094d9)
    }, hasSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
        hasSeparator: hasSeparator
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($87aee0eb86812bcf$var$HideL1MenuItemSectionInner, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($87aee0eb86812bcf$var$HideL1MenuItemSectionInner, props));
}

});
parcelRegister("7CMe6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c48e1cc2de5827$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<051e81191e9528d0339140ee7536941d>>
 * @relayHash 66baa10107c8516c24b8ed85cb97aa27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b23a1defc70b85ce697c0dc1d84377c11fe03c64d3dbd4d0cb309c2158ac9e77
const $c8c48e1cc2de5827$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "JiraConfigurableNavigationItem",
        "kind": "LinkedField",
        "name": "navItems",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "menuId"
            },
            {
                "kind": "ScalarField",
                "name": "isVisible"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "hideL1MenuItemActionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserNavigationConfigurationPayload",
                            "kind": "LinkedField",
                            "name": "updateUserNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraUserNavigationConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userNavigationConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "hideL1MenuItemActionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserNavigationConfigurationPayload",
                            "kind": "LinkedField",
                            "name": "updateUserNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraUserNavigationConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userNavigationConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b23a1defc70b85ce697c0dc1d84377c11fe03c64d3dbd4d0cb309c2158ac9e77",
            "metadata": {},
            "name": "hideL1MenuItemActionMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c8c48e1cc2de5827$var$node.hash = "1b96ba09e281b673ec1bfa126587621b";
var $c8c48e1cc2de5827$export$2e2bcd8739ae039 = $c8c48e1cc2de5827$var$node;

});

parcelRegister("8nw3F", function(module, exports) {

$parcel$export(module.exports, "AnnouncerV2", () => $d17828002089f92c$export$a43c8a2f4981e0e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9cbmy = parcelRequire("9cbmy");
const $d17828002089f92c$var$NON_BREAKING_SPACE = '\u00A0';
const $d17828002089f92c$export$a43c8a2f4981e0e = /*#__PURE__*/ (0, $eJOHy.memo)(({ message: originalMessage, liveMode: liveMode = 'polite', shouldAnnounce: shouldAnnounce = true, testId: testId })=>{
    const previousMessage = (0, $eJOHy.useRef)('');
    const setAlternatePolite = (0, $eJOHy.useRef)(false);
    const addSuffix = (0, $eJOHy.useRef)(false);
    const [oldMessage, setOldMessage] = (0, $eJOHy.useState)('');
    const [newMessage, setNewMessage] = (0, $eJOHy.useState)('');
    (0, $eJOHy.useEffect)(()=>{
        let message = shouldAnnounce ? originalMessage : $d17828002089f92c$var$NON_BREAKING_SPACE;
        if (previousMessage.current === message) {
            addSuffix.current = !addSuffix.current;
            if (addSuffix.current) message += $d17828002089f92c$var$NON_BREAKING_SPACE;
        }
        setOldMessage(setAlternatePolite.current ? '' : message);
        setNewMessage(setAlternatePolite.current ? message : '');
        if (shouldAnnounce) setAlternatePolite.current = !setAlternatePolite.current;
        previousMessage.current = originalMessage;
    }, [
        originalMessage,
        shouldAnnounce
    ]);
    // 2 aria-live containers needed to prevent bugs in browsers that will stop
    // announcing updates to the same div if these are too repetitive.
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $9cbmy.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, oldMessage), /*#__PURE__*/ $eJOHy.createElement((0, $9cbmy.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, newMessage));
});
const $d17828002089f92c$var$positionRelative = null;

});
parcelRegister("9cbmy", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $f808b80c4ecef983$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $f808b80c4ecef983$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $f808b80c4ecef983$export$200c8e5d652aa9af);
$parcel$export(module.exports, "ScreenReaderLegend", () => $f808b80c4ecef983$export$dabfb48aa98ffd97);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Visible only to screenreaders. Use when there is a need
 * to provide more context to a non-sighted user.
 * Styled copied from @atlaskit/visually-hidden
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $f808b80c4ecef983$export$8dd524ceb40e3d16 = {
    width: '1px',
    height: '1px',
    padding: 0,
    position: 'absolute',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};
const $f808b80c4ecef983$export$88fad6aa294f111c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});
const $f808b80c4ecef983$export$200c8e5d652aa9af = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});
const $f808b80c4ecef983$export$dabfb48aa98ffd97 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "legend", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});

});


const $493796f3bdee881c$export$4165a3d0da3bd147 = 'fixedItem';
const $493796f3bdee881c$export$95b0c331af13d819 = 'fixedItemButton';
const $493796f3bdee881c$export$74712b62056d422e = 'fixedItemAction';
const $493796f3bdee881c$export$3ac911b122986477 = 'customItem';
const $493796f3bdee881c$export$9bd6c21d500ae611 = 'customItemButton';
const $493796f3bdee881c$export$5374c2c2d3ece55e = 'customItemAction';
const $493796f3bdee881c$export$56981f28056f258e = 'customItemDropdownAction';
const $493796f3bdee881c$export$17bca95234dea43b = 'fixedItemDropdownAction';

const $427a1e7fccde0648$export$a3821bc63538b210 = 'customiseSidebar';
const $427a1e7fccde0648$export$fba7c3adda5094d9 = 'sidebar-nav4';
const $427a1e7fccde0648$export$3c19576bd92ff564 = 'sidebar-content';

const $4fdd5d9c1b32dd60$export$265c523d1a8f25cf = '1';
const $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1 = '2';
const $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18 = '3';
const $4fdd5d9c1b32dd60$export$35ac629b8b943d5a = '4';

parcelRegister("2LcvY", function(module, exports) {

$parcel$export(module.exports, "getSideNavToggleButtonAnalyticEventPayload", () => $bc37d0e87c8ee0e1$export$7165a1ebf1926b86);
$parcel$export(module.exports, "MENU_ID_ANALYTIC_EVENT_IDS", () => $bc37d0e87c8ee0e1$export$d70e7a5f39328991);

var $h4Bzb = parcelRequire("h4Bzb");





var $a9aec = parcelRequire("a9aec");
const $bc37d0e87c8ee0e1$var$SIDEBAR_TOGGLE = 'sidebarToggle';
const $bc37d0e87c8ee0e1$var$SIDEBAR_TOGGLE_ACTION_COLLAPSE = 'collapse';
const $bc37d0e87c8ee0e1$var$SIDEBAR_TOGGLE_ACTION_EXPAND = 'expand';
const $bc37d0e87c8ee0e1$var$CLICKED = 'clicked';
const $bc37d0e87c8ee0e1$export$7165a1ebf1926b86 = (isSideNavVisible, stage)=>{
    const toggleAction = isSideNavVisible ? $bc37d0e87c8ee0e1$var$SIDEBAR_TOGGLE_ACTION_COLLAPSE : $bc37d0e87c8ee0e1$var$SIDEBAR_TOGGLE_ACTION_EXPAND;
    const payload = {
        action: $bc37d0e87c8ee0e1$var$CLICKED,
        actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
        actionSubjectId: $bc37d0e87c8ee0e1$var$SIDEBAR_TOGGLE,
        attributes: {
            navigationLayer: (0, $002870cfa80d64f4$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $95eb6070d868c1b7$export$793ed84f5e13fedc),
            stage: stage,
            navState: (0, $107c403b1827dc68$export$2bd315ece9f68967),
            toggleAction: toggleAction
        }
    };
    return payload;
};
const $bc37d0e87c8ee0e1$export$d70e7a5f39328991 = {
    [(0, $h4Bzb.MENU_ID_APPS)]: 'appsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_ASSETS)]: 'assetsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_DASHBOARDS)]: 'dashboardsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_FILTERS)]: 'filtersNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_GOALS)]: 'goalsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_OPERATIONS)]: 'operationsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_OVERVIEWS)]: 'overviewsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_COMMUNICATION)]: 'communivationsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_PLANS)]: 'plansNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_PROJECTS)]: 'projectsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_RECENT)]: 'recentNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_STARRED)]: 'starredNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_TEAMS)]: 'teamsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_ROADMAPS)]: 'roadmapsNavigationMenuItem',
    [(0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE)]: 'customerServiceMenuItem',
    [(0, $h4Bzb.MENU_ID_CUSTOMER_HUBS)]: 'customerHubsMenuItem',
    [(0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE_ANALYTICS)]: 'customerServiceAnalyticsMenuItem',
    [(0, $h4Bzb.MENU_ID_GLOBAL_APP_ASSETS)]: (0, $a9aec.GLOBAL_APP_SHORTCUT_ASSETS),
    [(0, $h4Bzb.MENU_ID_GLOBAL_APP_GOALS)]: (0, $a9aec.GLOBAL_APP_SHORTCUT_GOALS),
    [(0, $h4Bzb.MENU_ID_GLOBAL_APP_CONFLUENCE)]: (0, $a9aec.GLOBAL_APP_SHORTCUT_CONFLUENCE),
    [(0, $h4Bzb.MENU_ID_GLOBAL_APP_LOOM)]: (0, $a9aec.GLOBAL_APP_SHORTCUT_LOOM),
    [(0, $h4Bzb.MENU_ID_GLOBAL_APP_TEAMS)]: (0, $a9aec.GLOBAL_APP_SHORTCUT_TEAMS),
    [(0, $h4Bzb.MENU_ID_GLOBAL_APP_PROJECTS)]: (0, $a9aec.GLOBAL_APP_SHORTCUT_PROJECTS),
    [(0, $h4Bzb.MENU_ID_GLOBAL_APP_OPSGENIE)]: (0, $a9aec.GLOBAL_APP_SHORTCUT_OPSGENIE)
};

});
const $107c403b1827dc68$export$d2aa6c54a5925f01 = 'v3';
const $107c403b1827dc68$export$2bd315ece9f68967 = 'v4';

const $95eb6070d868c1b7$export$2ee9e5a3556c1e43 = 'sidebar';
const $95eb6070d868c1b7$export$793ed84f5e13fedc = 'top';
const $95eb6070d868c1b7$export$f1c9dd0f5207dd5e = 'tab';
const $95eb6070d868c1b7$export$b83d0ee9325a2d0a = 'projectTitle';

// TopNav or sidebar
const $002870cfa80d64f4$export$17ff3f7e02c6ac22 = 'global';
const $002870cfa80d64f4$export$33d8c916a600c5e9 = 'container';


// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("gJU90", function(module, exports) {

$parcel$export(module.exports, "HideIcon", () => $3fb30821b73211e6$export$3fa055d21925b0d3);

var $eJOHy = parcelRequire("eJOHy");

var $aCmsU = parcelRequire("aCmsU");
const $3fb30821b73211e6$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        id: "icon <icon>"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        id: "Vector",
        d: "M19.2405 10.6209L18.9347 11.3057C18.734 11.7553 18.3679 12.2877 17.8832 12.8226L18.5909 13.5303C18.8838 13.8232 18.8838 14.2981 18.5909 14.591C18.298 14.8839 17.8231 14.8839 17.5302 14.591L16.7926 13.8534C16.6895 13.9372 16.5839 14.0197 16.4761 14.1004C15.998 14.4583 15.4587 14.795 14.8732 15.0696L15.3415 16.0062C15.5267 16.3767 15.3766 16.8272 15.0061 17.0125C14.6356 17.1977 14.1851 17.0475 13.9999 16.677L13.4486 15.5744C12.9819 15.6864 12.4971 15.75 11.9999 15.75C11.5026 15.75 11.0179 15.6864 10.5512 15.5744L9.99986 16.677C9.81462 17.0475 9.36412 17.1977 8.99363 17.0125C8.62315 16.8272 8.47298 16.3767 8.65822 16.0062L9.12653 15.0696C8.54102 14.795 8.00173 14.4583 7.5236 14.1004C7.41582 14.0197 7.31026 13.9372 7.20713 13.8534L6.46955 14.591C6.17666 14.8839 5.70179 14.8839 5.40889 14.591C5.116 14.2981 5.116 13.8232 5.40889 13.5303L6.11656 12.8227C5.63186 12.2877 5.26571 11.7553 5.06502 11.3057L4.75928 10.6209L6.12898 10.0094L6.43472 10.6943C6.66455 11.2091 7.37568 12.1158 8.42257 12.8996C9.45878 13.6754 10.7174 14.25 11.9999 14.25C13.2823 14.25 14.541 13.6754 15.5772 12.8996C16.6241 12.1158 17.3352 11.2091 17.565 10.6943L17.8708 10.0094L19.2405 10.6209Z",
        fill: "currentColor"
    })));
const $3fb30821b73211e6$export$3fa055d21925b0d3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aCmsU.default), {
        glyph: $3fb30821b73211e6$var$CustomGlyph,
        ...props
    });

});

parcelRegister("k3BsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $595afa4abc0c2509$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $595afa4abc0c2509$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    hideFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.hide-from-sidebar",
        "defaultMessage": "Hide from sidebar"
    },
    a11YAlertHideDefaultFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-default-from-sidebar",
        "defaultMessage": "Menu Item have been hidden from the sidebar"
    },
    // apps
    a11YHideAppsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-apps-from-sidebar",
        "defaultMessage": "Hide apps from sidebar"
    },
    a11YAlertHideAppsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-apps-from-sidebar",
        "defaultMessage": "Apps have been hidden from the sidebar"
    },
    // assets
    a11YHideAssetsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-assets-from-sidebar",
        "defaultMessage": "Hide assets from sidebar"
    },
    a11YAlertHideAssetsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-assets-from-sidebar",
        "defaultMessage": "Assets have been hidden from the sidebar"
    },
    // dashboards
    a11YHideDashboardsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-dashboards-from-sidebar",
        "defaultMessage": "Hide dashboards from sidebar"
    },
    a11YAlertHideDashboardsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-dashboards-from-sidebar",
        "defaultMessage": "Dashboards have been hidden from the sidebar"
    },
    // filters
    a11YHideFiltersFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-filters-from-sidebar",
        "defaultMessage": "Hide filters from sidebar"
    },
    a11YAlertHideFiltersFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-filters-from-sidebar",
        "defaultMessage": "Filters have been hidden from the sidebar"
    },
    // goals
    a11YHideGoalsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-goals-from-sidebar",
        "defaultMessage": "Hide goals from sidebar"
    },
    a11YAlertHideGoalsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-goals-from-sidebar",
        "defaultMessage": "Goals have been hidden from the sidebar"
    },
    // operations
    a11YHideOperationsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-operations-from-sidebar",
        "defaultMessage": "Hide operations from sidebar"
    },
    a11YAlertHideOperationsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-operations-from-sidebar",
        "defaultMessage": "Operations have been hidden from the sidebar"
    },
    // overviews
    a11YHideOverviewsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-overviews-from-sidebar",
        "defaultMessage": "Hide overviews from sidebar"
    },
    a11YAlertHideOverviewsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-overviews-from-sidebar",
        "defaultMessage": "Overviews have been hidden from the sidebar"
    },
    // plans
    a11YHidePlansFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-plans-from-sidebar",
        "defaultMessage": "Hide plans from sidebar"
    },
    a11YAlertHidePlansFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-plans-from-sidebar",
        "defaultMessage": "Plans have been hidden from the sidebar"
    },
    // projects
    a11YHideProjectsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-projects-from-sidebar",
        "defaultMessage": "Hide projects from sidebar"
    },
    a11YAlertHideProjectsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-projects-from-sidebar",
        "defaultMessage": "Projects have been hidden from the sidebar"
    },
    // teams
    a11YHideTeamsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-teams-from-sidebar",
        "defaultMessage": "Hide teams from sidebar"
    },
    a11YAlertHideTeamsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-teams-from-sidebar",
        "defaultMessage": "Teams have been hidden from the sidebar"
    },
    // roadmaps
    a11YHideRoadmapsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-roadmaps-from-sidebar",
        "defaultMessage": "Hide roadmaps from sidebar"
    },
    a11YAlertHideRoadmapsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-roadmaps-from-sidebar",
        "defaultMessage": "Roadmaps have been hidden from the sidebar"
    },
    // flags related texts
    moveBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.move-back-to-sidebar",
        "defaultMessage": "Move back to sidebar"
    },
    defaultHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.default-hidden-from-sidebar",
        "defaultMessage": "Hidden from sidebar"
    },
    appsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.apps-hidden-from-sidebar",
        "defaultMessage": "Apps hidden from sidebar"
    },
    assetsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.assets-hidden-from-sidebar",
        "defaultMessage": "Assets hidden from sidebar"
    },
    dashboardsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.dashboards-hidden-from-sidebar",
        "defaultMessage": "Dashboards hidden from sidebar"
    },
    filtersHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.filters-hidden-from-sidebar",
        "defaultMessage": "Filters hidden from sidebar"
    },
    goalsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.goals-hidden-from-sidebar",
        "defaultMessage": "Goals hidden from sidebar"
    },
    operationsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.operations-hidden-from-sidebar",
        "defaultMessage": "Operations hidden from sidebar"
    },
    overviewsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.overviews-hidden-from-sidebar",
        "defaultMessage": "Overviews hidden from sidebar"
    },
    plansHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.plans-hidden-from-sidebar",
        "defaultMessage": "Plans hidden from sidebar"
    },
    projectsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-hidden-from-sidebar",
        "defaultMessage": "Projects hidden from sidebar"
    },
    teamsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.teams-hidden-from-sidebar",
        "defaultMessage": "Teams hidden from sidebar"
    },
    roadmapsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.roadmaps-hidden-from-sidebar",
        "defaultMessage": "Roadmaps hidden from sidebar"
    },
    defaultMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.default-moved-back-to-sidebar",
        "defaultMessage": "Moved back to sidebar"
    },
    appsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.apps-moved-back-to-sidebar",
        "defaultMessage": "Apps moved back to sidebar"
    },
    assetsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.assets-moved-back-to-sidebar",
        "defaultMessage": "Assets moved back to sidebar"
    },
    dashboardsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.dashboards-moved-back-to-sidebar",
        "defaultMessage": "Dashboards moved back to sidebar"
    },
    filtersMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.filters-moved-back-to-sidebar",
        "defaultMessage": "Filters moved back to sidebar"
    },
    goalsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.goals-moved-back-to-sidebar",
        "defaultMessage": "Goals moved back to sidebar"
    },
    operationsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.operations-moved-back-to-sidebar",
        "defaultMessage": "Operations moved back to sidebar"
    },
    overviewsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.overviews-moved-back-to-sidebar",
        "defaultMessage": "Overviews moved back to sidebar"
    },
    plansMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.plans-moved-back-to-sidebar",
        "defaultMessage": "Plans moved back to sidebar"
    },
    projectsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-moved-back-to-sidebar",
        "defaultMessage": "Projects moved back to sidebar"
    },
    teamsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.teams-moved-back-to-sidebar",
        "defaultMessage": "Teams moved back to sidebar"
    },
    roadmapsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.roadmaps-moved-back-to-sidebar",
        "defaultMessage": "Roadmaps moved back to sidebar"
    },
    a11YHideProjectsFromSidebarGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-projects-from-sidebar-galaxia",
        "defaultMessage": "Hide spaces from sidebar"
    },
    a11YAlertHideProjectsFromSidebarGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-projects-from-sidebar-galaxia",
        "defaultMessage": "Spaces have been hidden from the sidebar"
    },
    projectsHiddenFromSidebarGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-hidden-from-sidebar-galaxia",
        "defaultMessage": "Spaces hidden from sidebar"
    },
    projectsMovedBackToSidebarGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-moved-back-to-sidebar-galaxia",
        "defaultMessage": "Spaces moved back to sidebar"
    }
});

});

parcelRegister("i3VM0", function(module, exports) {

$parcel$export(module.exports, "getA11YLabel", () => $2de70f079af73e1d$export$fcb002b66b92bf50);
$parcel$export(module.exports, "getA11YAlert", () => $2de70f079af73e1d$export$45edd6abaa8989eb);
$parcel$export(module.exports, "getNavItemHiddenFromSideBarFlagTitle", () => $2de70f079af73e1d$export$95caae642a80ad);
$parcel$export(module.exports, "getNavItemRestoredFromSideBarFlagTitle", () => $2de70f079af73e1d$export$d4ad18508eb0e1ec);

var $epTsa = parcelRequire("epTsa");

var $8IuE5 = parcelRequire("8IuE5");

var $k3BsH = parcelRequire("k3BsH");
const $2de70f079af73e1d$export$fcb002b66b92bf50 = (menuId)=>{
    const a11YHideProjectsFromSidebarGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $k3BsH.default).a11YHideProjectsFromSidebarGalaxia : (0, $k3BsH.default).a11YHideProjectsFromSidebar;
    switch(menuId){
        case (0, $8IuE5.L1_MENU_ID).APPS:
            return (0, $k3BsH.default).a11YHideAppsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).GOALS:
            return (0, $k3BsH.default).a11YHideGoalsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).ROADMAPS:
            return (0, $k3BsH.default).a11YHideRoadmapsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).PLANS:
            return (0, $k3BsH.default).a11YHidePlansFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).PROJECTS:
            return a11YHideProjectsFromSidebarGalaxia;
        case (0, $8IuE5.L1_MENU_ID).FILTERS:
            return (0, $k3BsH.default).a11YHideFiltersFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).DASHBOARDS:
            return (0, $k3BsH.default).a11YHideDashboardsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).OVERVIEWS:
            return (0, $k3BsH.default).a11YHideOverviewsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).OPERATIONS:
            return (0, $k3BsH.default).a11YHideOperationsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).ASSETS:
            return (0, $k3BsH.default).a11YHideAssetsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).TEAMS:
            return (0, $k3BsH.default).a11YHideTeamsFromSidebar;
        default:
            return (0, $k3BsH.default).hideFromSidebar;
    }
};
const $2de70f079af73e1d$export$45edd6abaa8989eb = (menuId)=>{
    const a11YAlertHideProjectsFromSidebarGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $k3BsH.default).a11YAlertHideProjectsFromSidebarGalaxia : (0, $k3BsH.default).a11YAlertHideProjectsFromSidebar;
    switch(menuId){
        case (0, $8IuE5.L1_MENU_ID).APPS:
            return (0, $k3BsH.default).a11YAlertHideAppsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).GOALS:
            return (0, $k3BsH.default).a11YAlertHideGoalsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).ROADMAPS:
            return (0, $k3BsH.default).a11YAlertHideRoadmapsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).PLANS:
            return (0, $k3BsH.default).a11YAlertHidePlansFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).PROJECTS:
            return a11YAlertHideProjectsFromSidebarGalaxia;
        case (0, $8IuE5.L1_MENU_ID).FILTERS:
            return (0, $k3BsH.default).a11YAlertHideFiltersFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).DASHBOARDS:
            return (0, $k3BsH.default).a11YAlertHideDashboardsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).OVERVIEWS:
            return (0, $k3BsH.default).a11YAlertHideOverviewsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).OPERATIONS:
            return (0, $k3BsH.default).a11YAlertHideOperationsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).ASSETS:
            return (0, $k3BsH.default).a11YAlertHideAssetsFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).TEAMS:
            return (0, $k3BsH.default).a11YAlertHideTeamsFromSidebar;
        default:
            return (0, $k3BsH.default).a11YAlertHideDefaultFromSidebar;
    }
};
const $2de70f079af73e1d$export$95caae642a80ad = (menuId)=>{
    const projectsHiddenFromSidebarGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $k3BsH.default).projectsHiddenFromSidebarGalaxia : (0, $k3BsH.default).projectsHiddenFromSidebar;
    switch(menuId){
        case (0, $8IuE5.L1_MENU_ID).APPS:
            return (0, $k3BsH.default).appsHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).GOALS:
            return (0, $k3BsH.default).goalsHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).ROADMAPS:
            return (0, $k3BsH.default).roadmapsHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).PLANS:
            return (0, $k3BsH.default).plansHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).PROJECTS:
            return projectsHiddenFromSidebarGalaxia;
        case (0, $8IuE5.L1_MENU_ID).FILTERS:
            return (0, $k3BsH.default).filtersMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).DASHBOARDS:
            return (0, $k3BsH.default).dashboardsHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).OVERVIEWS:
            return (0, $k3BsH.default).overviewsHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).OPERATIONS:
            return (0, $k3BsH.default).operationsHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).ASSETS:
            return (0, $k3BsH.default).assetsHiddenFromSidebar;
        case (0, $8IuE5.L1_MENU_ID).TEAMS:
            return (0, $k3BsH.default).teamsHiddenFromSidebar;
        default:
            return (0, $k3BsH.default).defaultHiddenFromSidebar;
    }
};
const $2de70f079af73e1d$export$d4ad18508eb0e1ec = (menuId)=>{
    const projectsMovedBackToSidebarGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $k3BsH.default).projectsMovedBackToSidebarGalaxia : (0, $k3BsH.default).projectsMovedBackToSidebar;
    switch(menuId){
        case (0, $8IuE5.L1_MENU_ID).APPS:
            return (0, $k3BsH.default).appsMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).GOALS:
            return (0, $k3BsH.default).goalsMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).ROADMAPS:
            return (0, $k3BsH.default).roadmapsMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).PLANS:
            return (0, $k3BsH.default).plansMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).PROJECTS:
            return projectsMovedBackToSidebarGalaxia;
        case (0, $8IuE5.L1_MENU_ID).FILTERS:
            return (0, $k3BsH.default).filtersMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).DASHBOARDS:
            return (0, $k3BsH.default).dashboardsMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).OVERVIEWS:
            return (0, $k3BsH.default).overviewsMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).OPERATIONS:
            return (0, $k3BsH.default).operationsMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).ASSETS:
            return (0, $k3BsH.default).assetsMovedBackToSidebar;
        case (0, $8IuE5.L1_MENU_ID).TEAMS:
            return (0, $k3BsH.default).teamsMovedBackToSidebar;
        default:
            return (0, $k3BsH.default).defaultMovedBackToSidebar;
    }
};

});


parcelRegister("iIEpz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6444ffd590501f9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kRcOu = parcelRequire("kRcOu");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $fAZgY = parcelRequire("fAZgY");

var $hrKgE = parcelRequire("hrKgE");

var $7jTnu = parcelRequire("7jTnu");
const $c6444ffd590501f9$var$ButtonMenuItemWithAnalytics = ({ analytics: analytics, onClick: onClick, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const stableAnalytics = (0, $hrKgE.useShallowStableReference)(analytics, (0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const handleClick = (0, $fAZgY.useCallbackWithCondition)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (!stableAnalytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = stableAnalytics;
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), actionSubjectId, analyticsAttributes);
    }, [
        stableAnalytics,
        createAnalyticsEvent,
        onClick
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kRcOu.ButtonMenuItem), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
};
var $c6444ffd590501f9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.forwardRef)($c6444ffd590501f9$var$ButtonMenuItemWithAnalytics);

});
parcelRegister("kRcOu", function(module, exports) {

$parcel$export(module.exports, "ButtonMenuItem", () => $272ee073bf00d3d0$export$6dc09b7c0ec1dfcd);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gX9lg = parcelRequire("gX9lg");

var $ilbtc = parcelRequire("ilbtc");
const $272ee073bf00d3d0$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $ilbtc.MenuListItem), {
        ref: listItemRef,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gX9lg.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            /**
				 * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
				 * so they aren't rendered in the disabled state.
				 */ actions: isDisabled ? undefined : actions,
            actionsOnHover: isDisabled ? undefined : actionsOnHover,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    }));

});
parcelRegister("ilbtc", function(module, exports) {

$parcel$export(module.exports, "MenuListItem", () => $a32ebcaf492cca41$export$6c2f3257abc4825b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $jUTnI = parcelRequire("jUTnI");
const $a32ebcaf492cca41$export$6c2f3257abc4825b = (0, $jUTnI.ListItem);

});



parcelRegister("8z6Yy", function(module, exports) {

$parcel$export(module.exports, "MoreNavMenuButton", () => $9131585cbd63b3e0$export$df3f5812ef8777cb);

var $eJOHy = parcelRequire("eJOHy");

var $cNe2t = parcelRequire("cNe2t");

var $286cZ = parcelRequire("286cZ");

var $7jTnu = parcelRequire("7jTnu");

var $fAZgY = parcelRequire("fAZgY");

var $he6m3 = parcelRequire("he6m3");

var $hWhA8 = parcelRequire("hWhA8");

var $uUJju = parcelRequire("uUJju");
const $9131585cbd63b3e0$export$df3f5812ef8777cb = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'), ({ MenuItems: MenuItems, name: name, onOpen: onOpen, onClose: onCloseFlyout })=>{
    const { isOpen: isOpen, onClose: onCloseDropdown, onToggle: onToggle } = (0, $he6m3.useOpenable)();
    const content = (0, $fAZgY.useCallbackWithCondition)((contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hWhA8.MoreNavMenuButtonSubmenu), {
            ...contentProps,
            MenuItems: MenuItems
        }), [
        MenuItems
    ], ()=>(0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton'));
    const onClose = (0, $eJOHy.useCallback)((e)=>{
        try {
            onCloseFlyout?.(e);
        } finally{
            onCloseDropdown();
        }
    }, [
        onCloseFlyout,
        onCloseDropdown
    ]);
    const onTriggerClick = (0, $eJOHy.useCallback)(()=>{
        try {
            if (!isOpen) onOpen?.();
        } finally{
            onToggle();
        }
    }, [
        isOpen,
        onOpen,
        onToggle
    ]);
    const trigger = (0, $fAZgY.useCallbackWithCondition)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $uUJju.MoreNavMenuButtonTrigger), {
            ...triggerProps,
            name: name,
            onClick: onTriggerClick,
            isSelected: isOpen,
            testId: "navigation-apps-sidebar-nav4-sidebars-common-core.ui.more-nav-menu-button.more-nav-menu-button-trigger"
        }), [
        isOpen,
        name,
        onTriggerClick
    ], ()=>(0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        content: content,
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        messageId: "navigation-apps-sidebar-nav4-sidebars-common-core.ui.more-nav-menu-button.popup",
        messageType: "transactional",
        trigger: trigger,
        shouldRenderToParent: true
    });
});

});
parcelRegister("cNe2t", function(module, exports) {

$parcel$export(module.exports, "JiraPopup", () => $63f31f3205cf35fe$export$2da4be1e3f9adef3);

var $eJOHy = parcelRequire("eJOHy");

var $5UxOh = parcelRequire("5UxOh");

var $SyPNn = parcelRequire("SyPNn");

var $cYafw = parcelRequire("cYafw");
const $63f31f3205cf35fe$export$2da4be1e3f9adef3 = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cYafw.ChoreographerPopup), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5UxOh.Popup), rest);
};

});
parcelRegister("SyPNn", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $136bce68f4b94682$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "environmentToEnvType", () => $136bce68f4b94682$export$e2cf19200849be9e);

var $h1MRb = parcelRequire("h1MRb");

var $gL5G0 = parcelRequire("gL5G0");
function $136bce68f4b94682$export$a8ba9111c7eec9ac(props) {
    return (0, $gL5G0.shouldBeChoreographed)(props);
}
function $136bce68f4b94682$export$e2cf19200849be9e(environment) {
    switch(environment){
        case 'dev':
            return (0, $h1MRb.envType).DEV;
        case 'staging':
            return (0, $h1MRb.envType).STAGING;
        case 'prod':
            return (0, $h1MRb.envType).PROD;
        default:
            return (0, $h1MRb.envType).LOCAL;
    }
}

});
parcelRegister("gL5G0", function(module, exports) {

$parcel$export(module.exports, "getPendoPlugin", () => $038980df3dc27b63$export$3d3a86b2d636214b);
$parcel$export(module.exports, "shouldBeChoreographed", () => $038980df3dc27b63$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "withChoreographedToggle", () => $038980df3dc27b63$export$a646002207b915ac);
$parcel$export(module.exports, "useChoreographedRender", () => $038980df3dc27b63$export$2cfd68294be82811);
$parcel$export(module.exports, "useDisableInAppMessagesForIframe", () => $038980df3dc27b63$export$a60a99a250d6a89c);

var $eJOHy = parcelRequire("eJOHy");

var $boW0g = parcelRequire("boW0g");
var $cjZ63 = parcelRequire("cjZ63");
var $cnm9v = parcelRequire("cnm9v");
var $2Ervb = parcelRequire("2Ervb");

var $7jTnu = parcelRequire("7jTnu");

var $hWeHP = parcelRequire("hWeHP");

var $c9z5K = parcelRequire("c9z5K");

var $3CprG = parcelRequire("3CprG");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $038980df3dc27b63$var$environment = (0, $c9z5K.toEnvironment)((0, $hWeHP.default)('ajs-environment')) ?? 'prod';
const $038980df3dc27b63$var$createChoreographerFactory = ()=>{
    if (false) return {
        useChoreographer: (..._)=>({
                startMessage: ()=>Promise.resolve((0, $cnm9v.MessageDeliveryStatus).STARTED),
                stopMessage: ()=>Promise.resolve((0, $cnm9v.MessageDeliveryStatus).STOPPED),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                toggleMessage: ()=>Promise.resolve('')
            }),
        withChoreographedToggle: (Component)=>Component,
        shouldBeChoreographed: (props)=>false
    };
    return (0, $cjZ63.choreographerFactory)((0, $cnm9v.ProductIds).JIRA, $038980df3dc27b63$var$environment);
};
let $038980df3dc27b63$var$pendoPlugin;
function $038980df3dc27b63$export$3d3a86b2d636214b(env) {
    if (!$038980df3dc27b63$var$pendoPlugin) $038980df3dc27b63$var$pendoPlugin = new (0, $2Ervb.PendoChoreographerPlugin)(env, {
        sourceProductId: (0, $cnm9v.ProductIds).JIRA
    });
    return $038980df3dc27b63$var$pendoPlugin;
}
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ const { useChoreographer: $038980df3dc27b63$export$9f0e2488ffd90f11, withChoreographedToggle: $038980df3dc27b63$var$withChoreographedToggleFromFactory, shouldBeChoreographed: $038980df3dc27b63$export$a8ba9111c7eec9ac } = $038980df3dc27b63$var$createChoreographerFactory();
const $038980df3dc27b63$export$a646002207b915ac = (Component, toggleableProp, toggleableContentProp)=>{
    const WithChoreographedToggleComponent = (props)=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $3CprG.useChoreographedStatusContext)();
        const ChoreographedComponent = (0, $eJOHy.useMemo)(()=>$038980df3dc27b63$var$withChoreographedToggleFromFactory(Component, toggleableProp), []);
        if (isAlreadyChoreographedAtAncestor || !(0, $7jTnu.fg)('jira_with_choreographed_toggle_fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props);
        const propsWithContextProviderWrapper = {
            ...props
        };
        if (toggleableContentProp) {
            const { [toggleableContentProp]: toggleableContentPropValue } = propsWithContextProviderWrapper;
            if (typeof toggleableContentPropValue === 'function') // @ts-expect-error TS doesn't know this is a callback with variable params that returns ReactNode, but we do
            propsWithContextProviderWrapper[toggleableContentProp] = (...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3CprG.ChoreographerContextProvider), {
                    isChoreographed: true
                }, toggleableContentPropValue(...args));
            else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const content = toggleableContentPropValue;
                // @ts-expect-error TS doesn't know this is a ReactNode, but we do
                propsWithContextProviderWrapper[toggleableContentProp] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3CprG.ChoreographerContextProvider), {
                    isChoreographed: true
                }, content);
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ChoreographedComponent, propsWithContextProviderWrapper);
    };
    WithChoreographedToggleComponent.displayName = `WithChoreographedToggle(${Component.displayName ?? Component.name ?? 'Component'})`;
    return WithChoreographedToggleComponent;
};
const $038980df3dc27b63$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $3CprG.useChoreographedStatusContext)();
    const [shouldRender, setShouldRender] = (0, $eJOHy.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $038980df3dc27b63$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $eJOHy.useEffect)(()=>{
        if (!isAlreadyChoreographedAtAncestor) {
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>{
                stopMessage();
            };
        }
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage,
        isAlreadyChoreographedAtAncestor
    ]);
    return shouldRender || isAlreadyChoreographedAtAncestor;
};
const $038980df3dc27b63$export$a60a99a250d6a89c = ()=>{
    const cleanup = (0, $eJOHy.useRef)();
    const disabled = (0, $eJOHy.useRef)(false);
    if (!disabled.current) {
        cleanup.current = (0, $boW0g.Choreographer).getInstance().disableChoreographerForIframe();
        disabled.current = true;
    }
    (0, $eJOHy.useEffect)(()=>()=>cleanup.current?.(), []);
};

});
parcelRegister("3CprG", function(module, exports) {

$parcel$export(module.exports, "ChoreographerContextProvider", () => $bf177571df54bc6f$export$c3226151caaf2fbf);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $bf177571df54bc6f$export$2eb1efa814fe4a);

var $eJOHy = parcelRequire("eJOHy");
const $bf177571df54bc6f$var$choreographedStatusContextValue = {
    isAlreadyChoreographedAtAncestor: true
};
const $bf177571df54bc6f$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $bf177571df54bc6f$export$2eb1efa814fe4a();
    const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
    return shouldUseChoreographerContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf177571df54bc6f$export$3ff96dbefca6b00d.Provider, {
        value: $bf177571df54bc6f$var$choreographedStatusContextValue
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $bf177571df54bc6f$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $bf177571df54bc6f$export$2eb1efa814fe4a = ()=>(0, $eJOHy.useContext)($bf177571df54bc6f$export$3ff96dbefca6b00d);

});



parcelRegister("cYafw", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopup", () => $888aaeaeeadda171$export$8ecc19d18d3df807);

var $5UxOh = parcelRequire("5UxOh");

var $gL5G0 = parcelRequire("gL5G0");
const $888aaeaeeadda171$export$8ecc19d18d3df807 = (0, $gL5G0.withChoreographedToggle)((0, $5UxOh.Popup), 'isOpen', 'content');

});


parcelRegister("286cZ", function(module, exports) {

$parcel$export(module.exports, "memoWithCondition", () => $cea01c3b12e620fb$export$26f85cb52df6fa94);

var $eJOHy = parcelRequire("eJOHy");

var $f2JN3 = parcelRequire("f2JN3");
const $cea01c3b12e620fb$export$26f85cb52df6fa94 = (condition, Component, propsAreEqual)=>{
    return (0, $f2JN3.componentWithCondition)(condition, /*#__PURE__*/ (0, $eJOHy.memo)(Component, propsAreEqual), Component);
};

});

parcelRegister("he6m3", function(module, exports) {

$parcel$export(module.exports, "useOpenable", () => $40c5fa9f2d8d08c0$export$e07f550759260fd7);

var $eJOHy = parcelRequire("eJOHy");
const $40c5fa9f2d8d08c0$export$e07f550759260fd7 = (initialState = false)=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(initialState);
    const onClose = (0, $eJOHy.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onOpen = (0, $eJOHy.useCallback)(()=>setIsOpen(true), [
        setIsOpen
    ]);
    const onToggle = (0, $eJOHy.useCallback)(()=>setIsOpen((value)=>!value), [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        onOpen: onOpen,
        onToggle: onToggle,
        setIsOpen: setIsOpen
    };
};

});

parcelRegister("hWhA8", function(module, exports) {

$parcel$export(module.exports, "MoreNavMenuButtonSubmenu", () => $c9f675a950e90253$export$ac88f3e136748c4a);

var $eJOHy = parcelRequire("eJOHy");

var $MlWTN = parcelRequire("MlWTN");

var $dhRXV = parcelRequire("dhRXV");

var $5Q9JR = parcelRequire("5Q9JR");
const $c9f675a950e90253$var$stopEventPropagation = (event)=>event.stopPropagation();
const $c9f675a950e90253$export$ac88f3e136748c4a = ({ MenuItems: MenuItems, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        onMouseEnter: $c9f675a950e90253$var$stopEventPropagation,
        onMouseLeave: $c9f675a950e90253$var$stopEventPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), {
        minWidth: (0, $5Q9JR.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MenuItems, {
        onClose: onClose
    })));

});

parcelRegister("uUJju", function(module, exports) {

$parcel$export(module.exports, "MoreNavMenuButtonTrigger", () => $dfbe3a7f7d9c0985$export$c1fd214ac7085e79);

var $eJOHy = parcelRequire("eJOHy");

var $4poV0 = parcelRequire("4poV0");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

var $ajqBI = parcelRequire("ajqBI");

var $fo9o5 = parcelRequire("fo9o5");
const $dfbe3a7f7d9c0985$export$c1fd214ac7085e79 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ name: name, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        ...props,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4poV0))), {
                ...iconProps,
                size: "small"
            }),
        label: name ? formatMessage((0, $fo9o5.default).moreActionsFor, {
            name: name
        }) : formatMessage((0, $fo9o5.default).moreActions),
        ref: ref,
        ...(0, $6XJko.isVisualRefreshEnabled)() ? {
            isTooltipDisabled: false,
            tooltip: {
                content: formatMessage((0, $fo9o5.default).moreActions),
                hideTooltipOnClick: true
            }
        } : {},
        ...(0, $7jTnu.fg)('blu-7837_apply_presstrace_nav4') && {
            interactionName: 'nav4-sidebar-more-actions-button'
        }
    });
});

});
parcelRegister("ajqBI", function(module, exports) {

$parcel$export(module.exports, "CommonNavMenuButton", () => $bf8e167060ed7219$export$358f21998d56a71e);

var $eJOHy = parcelRequire("eJOHy");

var $4BzUI = parcelRequire("4BzUI");
const $bf8e167060ed7219$export$358f21998d56a71e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, icon: icon, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BzUI.default), {
        ...props,
        icon: icon,
        onClick: onClick,
        ref: ref,
        spacing: "compact",
        appearance: "subtle"
    });
});

});

parcelRegister("fo9o5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2728ae4146a63f7b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2728ae4146a63f7b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    moreActions: {
        "id": "navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions",
        "defaultMessage": "More actions"
    },
    moreActionsFor: {
        "id": "navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions-for",
        "defaultMessage": "More actions for {name}"
    }
});

});



parcelRegister("6FAEa", function(module, exports) {

$parcel$export(module.exports, "AsyncCmdbUpsellPage", () => $cfa7297c4bf19653$export$659eb30d49d6ed87);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cfa7297c4bf19653$var$LazyCmdbUpsellPage = (0, $gzcjr.lazy)(()=>(parcelRequire("cDCVH")).then((module)=>module.UpsellPage), {
    moduleId: "./src/packages/servicedesk/cmdb/cmdb-upsell-page/src/ui/index.tsx"
});
const $cfa7297c4bf19653$export$659eb30d49d6ed87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "cmdb-upsell-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cfa7297c4bf19653$var$LazyCmdbUpsellPage, null));

});
parcelRegister("cDCVH", function(module, exports) {

let $93375327a8f74582$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $93375327a8f74582$var$load("2J6EG").then(()=>parcelRequire('4nbVT'));

});


parcelRegister("1Q9Vz", function(module, exports) {

$parcel$export(module.exports, "default", () => $af43f7ce0ae288e9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $af43f7ce0ae288e9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    openAssetsApp: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.open-assets-app",
        "defaultMessage": "Open Assets"
    },
    upsellLozengeText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.upsell-lozenge-text",
        "defaultMessage": "Premium"
    }
});

});


parcelRegister("lUto7", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $b796961f1187e169$export$f9f8a5cdb0c565ef);

var $lvKO5 = parcelRequire("lvKO5");
const $b796961f1187e169$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("2sjJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $64ae120dd99f263f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $64ae120dd99f263f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    lozenge: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.assets.lozenge",
        "defaultMessage": "Try"
    },
    assets: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.assets.assets",
        "defaultMessage": "Assets"
    }
});

});


parcelRegister("5D4AX", function(module, exports) {

$parcel$export(module.exports, "Goals", () => $15fbc6925e70260e$export$3c4000465299790);

var $eJOHy = parcelRequire("eJOHy");

var $6L9RF = parcelRequire("6L9RF");

var $5ukg0 = parcelRequire("5ukg0");

var $aasrU = parcelRequire("aasrU");

var $lRq8t = parcelRequire("lRq8t");

var $9evOq = parcelRequire("9evOq");
function $15fbc6925e70260e$export$3c4000465299790({ onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const url = 'https://home.atlassian.com/goals';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aasrU.LinkMenuItem), {
        href: url,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6L9RF))), {
            label: "",
            spacing: "spacious",
            size: "small"
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5ukg0.GoalsIcon), null),
        target: "_blank",
        onClick: onClick,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.goals.menu-link-item"
    }, formatMessage((0, $9evOq.default).goals));
}

});
parcelRegister("9evOq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f909fda2a05b8e5e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f909fda2a05b8e5e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    goals: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.goals.goals",
        "defaultMessage": "Goals"
    }
});

});


parcelRegister("6RXjp", function(module, exports) {

$parcel$export(module.exports, "Teams", () => $9f47ebf46614467d$export$b3a34d915d8dd11e);

var $eJOHy = parcelRequire("eJOHy");

var $i0ZlX = parcelRequire("i0ZlX");

var $6L9RF = parcelRequire("6L9RF");

var $e6kMq = parcelRequire("e6kMq");

var $1AUsu = parcelRequire("1AUsu");

var $4BzUI = parcelRequire("4BzUI");

var $i140O = parcelRequire("i140O");

var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");

var $aasrU = parcelRequire("aasrU");

var $cNe2t = parcelRequire("cNe2t");


var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $a62R3 = parcelRequire("a62R3");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");


var $cFGzN = parcelRequire("cFGzN");

var $2VH7W = parcelRequire("2VH7W");

var $ccYyA = parcelRequire("ccYyA");


var $7jTnu = parcelRequire("7jTnu");

var $dIJOd = parcelRequire("dIJOd");

var $lRq8t = parcelRequire("lRq8t");

var $8x4C2 = parcelRequire("8x4C2");
const $9f47ebf46614467d$var$CREATE_A_TEAM = 'createATeam';
const $9f47ebf46614467d$var$INVITE_PEOPLE = 'invitePeople';
const $9f47ebf46614467d$var$PopupContent = ({ openTeamsPopup: openTeamsPopup, createTeamModalTrigger: createTeamModalTrigger })=>{
    const invitePeopleModalTrigger = (0, $2VH7W.useInvitePeopleModal)();
    const actionSubjectId = (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_TEAMS];
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const onButtonClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                parentItemId: (0, $a9aec.SECTION_ITEM_TEAMS),
                itemId: $9f47ebf46614467d$var$INVITE_PEOPLE
            }
        });
        invitePeopleModalTrigger();
        openTeamsPopup(false);
    }, [
        createAnalyticsEvent,
        actionSubjectId,
        invitePeopleModalTrigger,
        openTeamsPopup
    ]);
    const onCreateTeamClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                parentItemId: (0, $a9aec.SECTION_ITEM_TEAMS),
                itemId: $9f47ebf46614467d$var$CREATE_A_TEAM
            }
        });
        createTeamModalTrigger();
        openTeamsPopup(false);
    }, [
        createAnalyticsEvent,
        actionSubjectId,
        createTeamModalTrigger,
        openTeamsPopup
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        xcss: $9f47ebf46614467d$var$teamsMenuStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
        onClick: onButtonClick
    }, formatMessage((0, $8x4C2.default).invitePeople)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
        onClick: onCreateTeamClick
    }, formatMessage((0, $8x4C2.default).createTeam)));
};
function $9f47ebf46614467d$var$TeamsInner({ onClick: onClick }) {
    const [isOpenTeamsPopup, openTeamsPopup] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const label = formatMessage((0, $8x4C2.default).teams);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [createTeamModal, createTeamModalTrigger] = (0, $cFGzN.useCreateTeamModal)();
    const actionSubjectId = (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_TEAMS];
    const peopleMenuWrapperRef = (0, $i0ZlX.useRegisterNudgeTarget)((0, $2b839a8453de5367$export$77bc79debbf5c069), (0, $7jTnu.fg)('teams-app-shortcut-nudge')).ref;
    const { href: href } = (0, $a62R3.getNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const onPlusButtonClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                parentItemId: (0, $a9aec.SECTION_ITEM_TEAMS),
                itemId: 'add'
            }
        });
        openTeamsPopup(true);
    }, [
        createAnalyticsEvent,
        actionSubjectId
    ]);
    const renderContent = (0, $eJOHy.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f47ebf46614467d$var$PopupContent, {
            openTeamsPopup: openTeamsPopup,
            createTeamModalTrigger: createTeamModalTrigger
        });
    }, [
        createTeamModalTrigger,
        openTeamsPopup
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, createTeamModal, (0, $7jTnu.fg)('teams-app-shortcut-nudge') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dIJOd.InviteTeamNudgeAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aasrU.LinkMenuItem), {
        ref: (0, $7jTnu.fg)('teams-app-shortcut-nudge') ? peopleMenuWrapperRef : undefined,
        href: href,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6L9RF))), {
            label: "",
            spacing: "spacious",
            size: "small"
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e6kMq.TeamsIcon), null),
        target: "_blank",
        onClick: onClick,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.teams.menu-link-item",
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
            shouldRenderToParent: true,
            placement: "bottom-start",
            messageId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.teams.popup",
            messageType: "transactional",
            onClose: (0, $eJOHy.useCallback)(()=>openTeamsPopup(false), []),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BzUI.default), {
                    ...triggerProps,
                    icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i140O))), {
                            ...iconProps,
                            size: "small"
                        }),
                    appearance: "subtle",
                    spacing: "compact",
                    testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.teams.sidenav-teams-popup-trigger",
                    isSelected: isOpenTeamsPopup,
                    label: label,
                    tooltip: {
                        content: label
                    },
                    isTooltipDisabled: false,
                    onClick: onPlusButtonClick
                }),
            isOpen: isOpenTeamsPopup,
            content: renderContent
        }))
    }, formatMessage((0, $8x4C2.default).teams)));
}
function $9f47ebf46614467d$export$b3a34d915d8dd11e(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ccYyA.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f47ebf46614467d$var$TeamsInner, props));
}
const $9f47ebf46614467d$var$teamsMenuStyle = (0, $5Wv5g.xcss)({
    minWidth: '260px',
    paddingBlock: 'space.100'
});

});
parcelRegister("i0ZlX", function(module, exports) {

$parcel$export(module.exports, "useNudgeController", () => $e41b1a49a3fe0d93$export$9a533735412babca);
$parcel$export(module.exports, "useRegisterNudgeTarget", () => $e41b1a49a3fe0d93$export$eb8a96124d659f2d);

var $eJOHy = parcelRequire("eJOHy");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 *  See some of the history here https://hello.atlassian.net/wiki/spaces/~620663553/pages/2896059847/Shipit+57+-+Out+of+Tree+Nudges
 */ class $e41b1a49a3fe0d93$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $e41b1a49a3fe0d93$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
const $e41b1a49a3fe0d93$export$9a533735412babca = ()=>$e41b1a49a3fe0d93$var$NudgeController.instance;
const $e41b1a49a3fe0d93$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $e41b1a49a3fe0d93$export$9a533735412babca();
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};

});

parcelRegister("cFGzN", function(module, exports) {

$parcel$export(module.exports, "useCreateTeamModal", () => $b040322abcf2ce9b$export$5458b68a653f4bfe);

var $eJOHy = parcelRequire("eJOHy");

var $keNcc = parcelRequire("keNcc");

var $bILK0 = parcelRequire("bILK0");

var $hsAfg = parcelRequire("hsAfg");

var $8w5Cq = parcelRequire("8w5Cq");

var $vr8NS = parcelRequire("vr8NS");

var $lRq8t = parcelRequire("lRq8t");

var $ch9En = parcelRequire("ch9En");

var $3MbOI = parcelRequire("3MbOI");

var $g9Vr6 = parcelRequire("g9Vr6");

var $a62R3 = parcelRequire("a62R3");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $hG8hM = parcelRequire("hG8hM");

var $gzcjr = parcelRequire("gzcjr");

var $83DiZ = parcelRequire("83DiZ");

var $4Goo7 = parcelRequire("4Goo7");

// Relay entry point is not applicable here because this component does not live in jira frontend.
const $b040322abcf2ce9b$var$LazyTeamCreateDialog = (0, $gzcjr.lazy)(()=>(parcelRequire("cMxGi")).then(({ TeamCreateDialog: TeamCreateDialog })=>TeamCreateDialog), {
    moduleId: "../platform/packages/people-and-teams/people-teams/src/index.ts"
});
const $b040322abcf2ce9b$export$5458b68a653f4bfe = ()=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const { locale: locale } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { data: { user: user } } = (0, $3MbOI.useCurrentUser)();
    const atlassianAccountId = (0, $8q7lT.useAccountId)() || user.accountId;
    const navigateTo = (0, $eJOHy.useCallback)((url)=>{
        if ((0, $a62R3.isTeamsAppEnabled)()) (0, $4Goo7.openInNewTab)((0, $a62R3.toTeamsAppURL)(url.replace('/jira', '')));
        else push(url);
    }, [
        push
    ]);
    const addFlag = (0, $eJOHy.useCallback)(({ appearance: appearance, ...flagProps })=>{
        const Flag = $b040322abcf2ce9b$var$getFlagComponent(appearance);
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Flag, {
                ...flagProps,
                ...serviceProps,
                messageId: `navigation-apps-sidebar-nav4-sidebars-content-teams.ui.use-create-team-modal.flag.showFlag.${appearance}.${flagProps.id}`,
                messageType: "engagement"
            }));
    }, [
        showFlag
    ]);
    const callback = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    if (!atlassianAccountId) throw new Error('Missing current user id');
    return [
        isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
            name: "team-create-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hG8hM.PeopleAndTeamsConfigurationProvider), {
            product: "jira",
            locale: (0, $keNcc.default)(locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b040322abcf2ce9b$var$LazyTeamCreateDialog, {
            pushRoute: navigateTo,
            cloudId: cloudId,
            orgId: orgId,
            product: "jira",
            principalId: atlassianAccountId,
            onClose: ()=>setIsOpen(false),
            enableMembershipSettingsChoice: true,
            currentUser: user.accountId ? {
                id: user.accountId,
                fullName: user.userFullname,
                // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                email: user.emailAddress !== undefined ? user.emailAddress : '',
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
                nickname: user.userFullname
            } : undefined,
            addFlag: addFlag
        }))) : null,
        callback
    ];
};
const $b040322abcf2ce9b$var$getFlagComponent = (appearance)=>{
    switch(appearance){
        case 'warning':
            return 0, $vr8NS.default;
        case 'error':
            return 0, $hsAfg.default;
        case 'success':
        case 'normal':
        default:
            return 0, $8w5Cq.default;
    }
};

});
parcelRegister("keNcc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fba0a73bbac7c2ce$export$2e2bcd8739ae039);
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $fba0a73bbac7c2ce$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $fba0a73bbac7c2ce$export$2e2bcd8739ae039 = $fba0a73bbac7c2ce$export$852ff24d0930c62f;

});

parcelRegister("hsAfg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c64177eb36c86852$export$2e2bcd8739ae039);

var $a9cht = parcelRequire("a9cht");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$c64177eb36c86852$export$2e2bcd8739ae039 = (0, $a9cht.ErrorFlag);

});

parcelRegister("8w5Cq", function(module, exports) {

$parcel$export(module.exports, "default", () => $74bba95887526837$export$2e2bcd8739ae039);

var $a9cht = parcelRequire("a9cht");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$74bba95887526837$export$2e2bcd8739ae039 = (0, $a9cht.SuccessFlag);

});

parcelRegister("vr8NS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31717d2796da72$export$2e2bcd8739ae039);

var $a9cht = parcelRequire("a9cht");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$9e31717d2796da72$export$2e2bcd8739ae039 = (0, $a9cht.WarningFlag);

});

parcelRegister("3MbOI", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $cea734a12424bed3$export$3901076af3749fa9);

var $eJOHy = parcelRequire("eJOHy");

var $4qiFT = parcelRequire("4qiFT");

var $lvKO5 = parcelRequire("lvKO5");

var $c9f6v = parcelRequire("c9f6v");
const $cea734a12424bed3$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return (0, $eJOHy.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $4qiFT.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $cea734a12424bed3$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $cea734a12424bed3$var$useCurrentUserBasic();
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $c9f6v.useUserSubscriber)();
    (0, $eJOHy.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $cea734a12424bed3$export$3901076af3749fa9 = ()=>// eslint-disable-next-line react-hooks/react-compiler
    (0, $lvKO5.useTenantContext)().isAnonymous ? $cea734a12424bed3$var$useCurrentUserBasic() : $cea734a12424bed3$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $cea734a12424bed3$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $cea734a12424bed3$export$3901076af3749fa9();
    return children(result);
};

});
parcelRegister("c9f6v", function(module, exports) {

$parcel$export(module.exports, "UserContainer", () => $76dd8ceef4c03a1e$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $76dd8ceef4c03a1e$export$4e61bbf568682a96);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $immvQ = parcelRequire("immvQ");
const $76dd8ceef4c03a1e$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $76dd8ceef4c03a1e$var$Store = (0, $GtRbT.createStore)({
    name: 'user',
    initialState: $76dd8ceef4c03a1e$var$initialState,
    actions: $immvQ
});
const $76dd8ceef4c03a1e$export$7ff085589970ee0a = (0, $6E16M.createContainer)($76dd8ceef4c03a1e$var$Store);
const $76dd8ceef4c03a1e$export$4e61bbf568682a96 = (0, $iJq0l.createHook)($76dd8ceef4c03a1e$var$Store);

});
parcelRegister("immvQ", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $10ab66dafa4344a0$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1s4Nl = parcelRequire("1s4Nl");
const $10ab66dafa4344a0$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $1s4Nl.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("1s4Nl", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $58aa135740e671a3$export$8134c072fddab6a5);

var $b5RwB = parcelRequire("b5RwB");

var $LFmXM = parcelRequire("LFmXM");

var $jGzN3 = parcelRequire("jGzN3");

var $7jTnu = parcelRequire("7jTnu");

var $hbF3h = parcelRequire("hbF3h");

var $fsisP = parcelRequire("fsisP");
const $58aa135740e671a3$export$5e5a6664039ed1cc = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $b5RwB.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $jGzN3.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};
const $58aa135740e671a3$var$fetchDataNew = (0, $LFmXM.default)($58aa135740e671a3$export$5e5a6664039ed1cc, (newArgs, lastArgs)=>// compare params and headers to see if it should be memoised.
    (0, $fsisP.isShallowEqual)(newArgs[0].params, lastArgs[0].params) && (0, $fsisP.isShallowEqual)(newArgs[0].header, lastArgs[0].header));
const $58aa135740e671a3$export$8134c072fddab6a5 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('user-iv-llc-unnecessary-api'), $58aa135740e671a3$var$fetchDataNew, $58aa135740e671a3$export$5e5a6664039ed1cc);

});




parcelRegister("8q7lT", function(module, exports) {

$parcel$export(module.exports, "useAccountId", () => $1bd1fe7fb0bcdb0a$export$e72033e0f5baa3e);

var $lvKO5 = parcelRequire("lvKO5");
const $1bd1fe7fb0bcdb0a$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});

parcelRegister("hG8hM", function(module, exports) {

$parcel$export(module.exports, "PeopleAndTeamsConfigurationProvider", () => $5855a8fb1c58a6ef$export$d3f5bd36d1c6597e);
$parcel$export(module.exports, "usePeopleAndTeamsConfigurationContext", () => $5855a8fb1c58a6ef$export$130340d16a670190);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7GxOn = parcelRequire("7GxOn");

var $2DnR8 = parcelRequire("2DnR8");

var $jp2Nh = parcelRequire("jp2Nh");

var $e8MqD = parcelRequire("e8MqD");
const $5855a8fb1c58a6ef$export$8a37839ac1e08b25 = /*#__PURE__*/ (0, $eJOHy.createContext)((0, $jp2Nh.DEFAULT_CONTEXT));
const $5855a8fb1c58a6ef$export$3bf19eb896b777b8 = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, orgId: orgId, teamPermissionCheckEnabled: teamPermissionCheckEnabled = false })=>{
    const overrides = (0, $e8MqD.usePeopleAndTeamsConfigurationOverrides)(teamPermissionCheckEnabled, orgId, teamPermissions);
    const artifact = (0, $2DnR8.usePeopleAndTeamsRemoteArtifact)(product, locale, overrides);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($5855a8fb1c58a6ef$export$8a37839ac1e08b25.Provider, {
        value: artifact || (0, $jp2Nh.DEFAULT_CONTEXT),
        children: children
    });
};
const $5855a8fb1c58a6ef$export$d3f5bd36d1c6597e = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, teamPermissionCheckEnabled: teamPermissionCheckEnabled, orgId: orgId, ...flightDeckProps })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7GxOn.FlightDeckProvider), {
        product: product,
        ...flightDeckProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($5855a8fb1c58a6ef$export$3bf19eb896b777b8, {
            locale: locale,
            product: product,
            teamPermissions: teamPermissions,
            teamPermissionCheckEnabled: teamPermissionCheckEnabled,
            orgId: orgId,
            children: children
        })
    });
};
const $5855a8fb1c58a6ef$export$130340d16a670190 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($5855a8fb1c58a6ef$export$8a37839ac1e08b25);

});
parcelRegister("7GxOn", function(module, exports) {

$parcel$export(module.exports, "FlightDeckProvider", () => $5986aeeba0f5d97b$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "useFlightDeckContext", () => $5986aeeba0f5d97b$export$73c96350a5e69ec);
$parcel$export(module.exports, "useFlightDeckArtifact", () => $5986aeeba0f5d97b$export$3b241cde208d2c5e);

var $eJOHy = parcelRequire("eJOHy");

var $9nfpX = parcelRequire("9nfpX");
const $5986aeeba0f5d97b$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({
    getArtifact: null
});
function $5986aeeba0f5d97b$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        return new (0, $9nfpX.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            },
            expiryMS: config === null || config === void 0 ? void 0 : config.artifactExpiryMS
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5986aeeba0f5d97b$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $5986aeeba0f5d97b$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($5986aeeba0f5d97b$export$ca1b33377afa620);
function $5986aeeba0f5d97b$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState();
    const { getArtifact: getArtifact } = $5986aeeba0f5d97b$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}

});
parcelRegister("9nfpX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d3238b1152377d9$export$2e2bcd8739ae039);

var $7M3Wu = parcelRequire("7M3Wu");

var $lpAhK = parcelRequire("lpAhK");

var $9uxao = parcelRequire("9uxao");

var $8WFY9 = parcelRequire("8WFY9");
var $cRo5G = parcelRequire("cRo5G");

var $4rQ9F = parcelRequire("4rQ9F");

var $92KTQ = parcelRequire("92KTQ");

var $kELoB = parcelRequire("kELoB");
function $6d3238b1152377d9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6d3238b1152377d9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6d3238b1152377d9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $7M3Wu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6d3238b1152377d9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $6d3238b1152377d9$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $6d3238b1152377d9$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $6d3238b1152377d9$export$2e2bcd8739ae039 {
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $7M3Wu.default)(this, "fallbackArtifactMap", new Map());
        (0, $7M3Wu.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $9uxao.default)($6d3238b1152377d9$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $92KTQ.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $lpAhK.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $8WFY9.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $4rQ9F.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$6d3238b1152377d9$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = Math.random() < 0.001 ? (0, $kELoB.flightDeckClientExperience)() : new (0, $cRo5G.MockExperience)();
        experience.start();
        try {
            const artifactWithKey = $6d3238b1152377d9$var$_objectSpread($6d3238b1152377d9$var$_objectSpread({}, artifact), {}, {
                key: (0, $92KTQ.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $kELoB.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
}

});
parcelRegister("lpAhK", function(module, exports) {

$parcel$export(module.exports, "retryOnException", () => $5019c932326da59b$export$1d94629c94e7a17f);
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("30t78")).default);

var $3bsax = parcelRequire("3bsax");

var $7BjHg = parcelRequire("7BjHg");

var $30t78 = parcelRequire("30t78");
const $5019c932326da59b$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $5019c932326da59b$var$NO_CALLS_ERROR = 'No calls made';
const $5019c932326da59b$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $7BjHg.NO_RETRIES), retryOn: retryOn = [
    (0, $30t78.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($5019c932326da59b$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $5019c932326da59b$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $5019c932326da59b$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $3bsax.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};

});
parcelRegister("3bsax", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b1cdacb0254fac$export$2e2bcd8739ae039);
const $84b1cdacb0254fac$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $84b1cdacb0254fac$export$2e2bcd8739ae039 = $84b1cdacb0254fac$var$convertToError;

});

parcelRegister("7BjHg", function(module, exports) {

$parcel$export(module.exports, "NO_RETRIES", () => $4e76068e6028b444$export$a0a1c8f90becc136);
const $4e76068e6028b444$export$a0a1c8f90becc136 = [];
const $4e76068e6028b444$export$972171517b12aa4 = [
    0,
    0
];
const $4e76068e6028b444$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $4e76068e6028b444$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("30t78", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b3ed783ee7f34bc$export$2e2bcd8739ae039);
class $5b3ed783ee7f34bc$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}

});


parcelRegister("9uxao", function(module, exports) {

$parcel$export(module.exports, "default", () => $f332f68c394c2eb7$export$2e2bcd8739ae039);

var $lWFdw = parcelRequire("lWFdw");
const $f332f68c394c2eb7$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $f332f68c394c2eb7$export$2e2bcd8739ae039 {
    constructor(clientKey, options){
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $f332f68c394c2eb7$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $lWFdw.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
}

});
parcelRegister("lWFdw", function(module, exports) {

$parcel$export(module.exports, "mockWindowStorage", () => $5c882b07adabbfc3$export$efebfe7859cae3c7);
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $5c882b07adabbfc3$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $5c882b07adabbfc3$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else // Fallback for environments where global might not exist
        windowRef = {};
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') windowRef = {};
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$5c882b07adabbfc3$export$c65e688d8b365035
        },
        configurable: true
    });
};

});


parcelRegister("8WFY9", function(module, exports) {

$parcel$export(module.exports, "fetchFlightDeckConfiguration", () => $68344bb5c60b45af$export$6026918e023c9101);

var $keNcc = parcelRequire("keNcc");

var $kPyXb = parcelRequire("kPyXb");

var $idLNY = parcelRequire("idLNY");

var $3ZW4v = parcelRequire("3ZW4v");

var $cfxYZ = parcelRequire("cfxYZ");

var $cRo5G = parcelRequire("cRo5G");

var $bCNf6 = parcelRequire("bCNf6");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $68344bb5c60b45af$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $68344bb5c60b45af$var$defaultPerimeter = "commercial";
async function $68344bb5c60b45af$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter, _dim$impactLevel;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $68344bb5c60b45af$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $68344bb5c60b45af$var$defaultPerimeter;
    // Needed for backwards compatibility with Flight Deck core, reference perimeter
    const impactLevel = (_dim$impactLevel = dim.impactLevel) !== null && _dim$impactLevel !== void 0 ? _dim$impactLevel : perimeter;
    const environment = $68344bb5c60b45af$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $keNcc.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        impactLevel: impactLevel,
        environment: environment,
        locale: locale
    };
    const client = await $68344bb5c60b45af$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $68344bb5c60b45af$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $68344bb5c60b45af$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $68344bb5c60b45af$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $68344bb5c60b45af$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $68344bb5c60b45af$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $cRo5G.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $cRo5G.getVersionMetadataFetchExperience)();
    return new (0, $cfxYZ.ConfigClient)(new (0, $idLNY.BifrostDataSource)(new (0, $3ZW4v.BifrostHttpClientImpl)(env, perimeter), (0, $kPyXb.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $68344bb5c60b45af$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("kPyXb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $41DaG = parcelRequire("41DaG");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $41DaG.Either;
    }
});

var $7DE2w = parcelRequire("7DE2w");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $7DE2w.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $7DE2w.tryGetArtifactData;
    }
});

var $j4V29 = parcelRequire("j4V29");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $j4V29.parseArtifactManifest;
    }
});

var $lQIPi = parcelRequire("lQIPi");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $lQIPi.parseVersionMetadata;
    }
});

var $4Xgo7 = parcelRequire("4Xgo7");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $4Xgo7.checkManifest;
    }
});

var $8kfyr = parcelRequire("8kfyr");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $8kfyr.ConfigRegistryDataSource;
    }
});

var $1XX2B = parcelRequire("1XX2B");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $1XX2B.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $1XX2B.Versions;
    }
});

});
parcelRegister("41DaG", function(module, exports) {
"use strict";
var $2ee5a4067e9aae10$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $2ee5a4067e9aae10$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $2ee5a4067e9aae10$var$Right(value);
    };
    Either.left = function(error) {
        return new $2ee5a4067e9aae10$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $2ee5a4067e9aae10$var$Either;
var $2ee5a4067e9aae10$var$Right = /** @class */ function(_super) {
    $2ee5a4067e9aae10$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $2ee5a4067e9aae10$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $2ee5a4067e9aae10$var$Either.right(this.right);
    };
    return Right;
}($2ee5a4067e9aae10$var$Either);
var $2ee5a4067e9aae10$var$Left = /** @class */ function(_super) {
    $2ee5a4067e9aae10$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $2ee5a4067e9aae10$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $2ee5a4067e9aae10$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $2ee5a4067e9aae10$var$Either.left(f(this.left));
    };
    return Left;
}($2ee5a4067e9aae10$var$Either);

});

parcelRegister("7DE2w", function(module, exports) {
"use strict";
var $58fb3bf8c5aae677$var$__assign = module.exports && module.exports.__assign || function() {
    $58fb3bf8c5aae677$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $58fb3bf8c5aae677$var$__assign.apply(this, arguments);
};
var $58fb3bf8c5aae677$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $58fb3bf8c5aae677$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $58fb3bf8c5aae677$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $58fb3bf8c5aae677$var$tryGetArtifactData;

var $bnWU7 = parcelRequire("bnWU7");

var $kPyXb = parcelRequire("kPyXb");

var $6y2ly = parcelRequire("6y2ly");

var $8OySu = parcelRequire("8OySu");

var $7SeVk = parcelRequire("7SeVk");
function $58fb3bf8c5aae677$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $58fb3bf8c5aae677$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $58fb3bf8c5aae677$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $58fb3bf8c5aae677$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $58fb3bf8c5aae677$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $kPyXb.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $6y2ly.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $58fb3bf8c5aae677$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $8OySu.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $58fb3bf8c5aae677$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $58fb3bf8c5aae677$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $58fb3bf8c5aae677$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $bnWU7.interpolateTagScheme)(manifest.tagScheme, $58fb3bf8c5aae677$var$__assign($58fb3bf8c5aae677$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $58fb3bf8c5aae677$var$__awaiter(_this, void 0, void 0, function() {
                                return $58fb3bf8c5aae677$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $58fb3bf8c5aae677$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $7SeVk.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $7SeVk.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $8OySu.assertUnreachable)(artifact);
    }
}

});
parcelRegister("bnWU7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $849f88d7c1122c02$var$interpolateTagScheme;
module.exports.generateTagScheme = $849f88d7c1122c02$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $849f88d7c1122c02$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $849f88d7c1122c02$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $849f88d7c1122c02$var$getVersionMetadataTag;
const $849f88d7c1122c02$var$TAG_SCHEME_VERSION = 2;
function $849f88d7c1122c02$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($849f88d7c1122c02$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $849f88d7c1122c02$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $849f88d7c1122c02$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $849f88d7c1122c02$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $849f88d7c1122c02$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $849f88d7c1122c02$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $849f88d7c1122c02$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $849f88d7c1122c02$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("6y2ly", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $4c47bd0a8230f9fc$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $4c47bd0a8230f9fc$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("8OySu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $66ae0c412e7ccf70$var$assertUnreachable;
function $66ae0c412e7ccf70$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("7SeVk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $5bb92719109ab370$var$toJson;
module.exports.toPrettyJson = $5bb92719109ab370$var$toPrettyJson;
function $5bb92719109ab370$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $5bb92719109ab370$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});


parcelRegister("j4V29", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $de3aa1b8e712c3e3$var$parseArtifactManifest;

var $2LwBS = parcelRequire("2LwBS");
function $de3aa1b8e712c3e3$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $2LwBS.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $2LwBS.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $de3aa1b8e712c3e3$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $2LwBS.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $de3aa1b8e712c3e3$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $de3aa1b8e712c3e3$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $2LwBS.parseUnknownObject)(dimensions);
    var supported = (0, $2LwBS.parseArray)(unparsedDimensions.supported).map($2LwBS.parseString);
    var fallback = (0, $2LwBS.parseUndefinedOr)($2LwBS.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $de3aa1b8e712c3e3$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $2LwBS.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $de3aa1b8e712c3e3$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $de3aa1b8e712c3e3$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $2LwBS.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $2LwBS.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $2LwBS.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $2LwBS.parseUndefinedOr)($2LwBS.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $de3aa1b8e712c3e3$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $de3aa1b8e712c3e3$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});
parcelRegister("2LwBS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $2039443a032c83e2$var$parseString;
module.exports.parseArray = $2039443a032c83e2$var$parseArray;
module.exports.parseBoolean = $2039443a032c83e2$var$parseBoolean;
module.exports.parseUnknownObject = $2039443a032c83e2$var$parseUnknownObject;
module.exports.parseUndefinedOr = $2039443a032c83e2$var$parseUndefinedOr;
function $2039443a032c83e2$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $2039443a032c83e2$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $2039443a032c83e2$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $2039443a032c83e2$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $2039443a032c83e2$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});


parcelRegister("lQIPi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $fe8139e1b9056a03$var$parseVersionMetadata;

var $2LwBS = parcelRequire("2LwBS");
function $fe8139e1b9056a03$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $2LwBS.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $2LwBS.parseString)(unknownObject.version);
    var publishTime = new Date((0, $2LwBS.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $2LwBS.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("4Xgo7", function(module, exports) {
"use strict";
var $39b9626b06f94152$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $39b9626b06f94152$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $39b9626b06f94152$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $39b9626b06f94152$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("8kfyr", function(module, exports) {
"use strict";
var $60fc41c83b0b42ce$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $60fc41c83b0b42ce$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $bnWU7 = parcelRequire("bnWU7");

var $41DaG = parcelRequire("41DaG");

var $j4V29 = parcelRequire("j4V29");

var $lQIPi = parcelRequire("lQIPi");
var $60fc41c83b0b42ce$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $60fc41c83b0b42ce$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $60fc41c83b0b42ce$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $bnWU7.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($j4V29.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $41DaG.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $60fc41c83b0b42ce$var$__awaiter(this, void 0, void 0, function() {
            return $60fc41c83b0b42ce$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $60fc41c83b0b42ce$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $60fc41c83b0b42ce$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $bnWU7.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $lQIPi.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $60fc41c83b0b42ce$var$ConfigRegistryDataSource;

});

parcelRegister("1XX2B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $16e9197195a917cd$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $16e9197195a917cd$var$BaseUrls;
var $16e9197195a917cd$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $16e9197195a917cd$var$Versions;

});


parcelRegister("idLNY", function(module, exports) {

$parcel$export(module.exports, "BifrostDataSource", () => $d43e85f334e6fa20$export$2cb8d79200775058);

var $kPyXb = parcelRequire("kPyXb");

var $bnWU7 = parcelRequire("bnWU7");
class $d43e85f334e6fa20$export$2cb8d79200775058 {
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
    async getLatestVersionMetadata() {
        const tag = (0, $bnWU7.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $kPyXb.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $kPyXb.parseVersionMetadata)(response);
                return (0, $kPyXb.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $kPyXb.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $bnWU7.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $kPyXb.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $kPyXb.parseArtifactManifest)(response);
                return (0, $kPyXb.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $kPyXb.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
}

});

parcelRegister("3ZW4v", function(module, exports) {

$parcel$export(module.exports, "BifrostHttpClientImpl", () => $2e941d6dd444fd76$export$45c6d12ca9c14f83);

var $kPyXb = parcelRequire("kPyXb");
function $2e941d6dd444fd76$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $2e941d6dd444fd76$export$45c6d12ca9c14f83 {
    constructor(env, perimeter){
        this.baseUrl = $2e941d6dd444fd76$export$f654b28f82155665(env, perimeter);
    }
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $kPyXb.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $kPyXb.Either).right(json)));
            }).catch((error)=>resolve((0, $kPyXb.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
}

});

parcelRegister("cfxYZ", function(module, exports) {

$parcel$export(module.exports, "ConfigClient", () => $8eb13f04a9160464$export$8489e2f039bfcc4c);

var $7M3Wu = parcelRequire("7M3Wu");

var $kPyXb = parcelRequire("kPyXb");

var $5hz9f = parcelRequire("5hz9f");
function $8eb13f04a9160464$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8eb13f04a9160464$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8eb13f04a9160464$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $7M3Wu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8eb13f04a9160464$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $8eb13f04a9160464$export$8489e2f039bfcc4c {
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $5hz9f.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $8eb13f04a9160464$var$_objectSpread($8eb13f04a9160464$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $kPyXb.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $kPyXb.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
}

});
parcelRegister("5hz9f", function(module, exports) {

$parcel$export(module.exports, "ExperienceDataSourceWrapper", () => $3d89cdfd84a360c3$export$1cc944571619e6e8);
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $3d89cdfd84a360c3$export$1cc944571619e6e8 {
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
}

});


parcelRegister("cRo5G", function(module, exports) {

$parcel$export(module.exports, "MockExperience", () => $95cd1f2f3025b40a$export$5e7536cf7bc56fee);
$parcel$export(module.exports, "getFlightDeckFetchExperience", () => $95cd1f2f3025b40a$export$a3006f8f221c0a3b);
$parcel$export(module.exports, "getVersionMetadataFetchExperience", () => $95cd1f2f3025b40a$export$c3ac7702bfd47c1b);
const $95cd1f2f3025b40a$var$SAMPLING_RATE = 10;
class $95cd1f2f3025b40a$var$UFOExperienceWrapper {
    constructor(experience){
        this.experience = experience;
    }
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
}
class $95cd1f2f3025b40a$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $95cd1f2f3025b40a$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $95cd1f2f3025b40a$var$SAMPLING_RATE) return new $95cd1f2f3025b40a$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("fS4SF"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $95cd1f2f3025b40a$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $95cd1f2f3025b40a$export$5e7536cf7bc56fee();
    }
}
const $95cd1f2f3025b40a$export$a3006f8f221c0a3b = ()=>$95cd1f2f3025b40a$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $95cd1f2f3025b40a$export$c3ac7702bfd47c1b = ()=>$95cd1f2f3025b40a$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("fS4SF", function(module, exports) {

let $b8dfaf5aec23a448$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b8dfaf5aec23a448$var$load("h7siB").then(()=>parcelRequire('bsSEQ'));

});


parcelRegister("bCNf6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $4Yw32 = parcelRequire("4Yw32");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $4Yw32.parseConfigWithTargeting;
    }
});

var $2sgKn = parcelRequire("2sgKn");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $2sgKn.TargetedConfig;
    }
});

});
parcelRegister("4Yw32", function(module, exports) {
"use strict";
var $39f5a012e18f7c8d$var$__assign = module.exports && module.exports.__assign || function() {
    $39f5a012e18f7c8d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $39f5a012e18f7c8d$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $39f5a012e18f7c8d$var$parseConfigWithTargeting;

var $2sgKn = parcelRequire("2sgKn");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $39f5a012e18f7c8d$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $39f5a012e18f7c8d$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $2sgKn.TargetedConfig({
                defaultConfig: $39f5a012e18f7c8d$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $39f5a012e18f7c8d$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $2sgKn.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $39f5a012e18f7c8d$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $39f5a012e18f7c8d$var$__assign($39f5a012e18f7c8d$var$__assign({}, accObject), (_a = {}, _a[key] = $39f5a012e18f7c8d$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $39f5a012e18f7c8d$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $39f5a012e18f7c8d$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $39f5a012e18f7c8d$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $39f5a012e18f7c8d$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $39f5a012e18f7c8d$var$parseIdentifierList(target.orgIds),
            siteIds: $39f5a012e18f7c8d$var$parseIdentifierList(target.siteIds),
            userIds: $39f5a012e18f7c8d$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $39f5a012e18f7c8d$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("2sgKn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $1c9b2fe11eb42b78$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $1c9b2fe11eb42b78$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $1c9b2fe11eb42b78$var$TargetedConfig;
function $1c9b2fe11eb42b78$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("4rQ9F", function(module, exports) {

$parcel$export(module.exports, "default", () => $33d223f074a7d29d$export$2e2bcd8739ae039);
class $33d223f074a7d29d$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
        this.perimeter = dimensions === null || dimensions === void 0 ? void 0 : dimensions.perimeter;
    }
}
const $33d223f074a7d29d$export$1d76d155060824c9 = (e)=>e instanceof $33d223f074a7d29d$export$2e2bcd8739ae039;

});

parcelRegister("92KTQ", function(module, exports) {

$parcel$export(module.exports, "artifactKey", () => $6958ae44f34d3a1a$export$e3553dc63541d477);
const $6958ae44f34d3a1a$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("kELoB", function(module, exports) {

$parcel$export(module.exports, "flightDeckClientExperience", () => $f09c4ee659b1cd8d$export$1e3a41a51f6457c5);
$parcel$export(module.exports, "exceptionToMetadata", () => $f09c4ee659b1cd8d$export$f33622abb5224195);

var $7M3Wu = parcelRequire("7M3Wu");

var $aRK4c = parcelRequire("aRK4c");
var $9GzfC = parcelRequire("9GzfC");
function $f09c4ee659b1cd8d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f09c4ee659b1cd8d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f09c4ee659b1cd8d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $7M3Wu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f09c4ee659b1cd8d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f09c4ee659b1cd8d$export$1e3a41a51f6457c5 = ()=>new (0, $9GzfC.UFOExperience)("retrieve-artifact", {
        type: (0, $aRK4c.ExperienceTypes).Operation,
        performanceType: (0, $aRK4c.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $f09c4ee659b1cd8d$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $f09c4ee659b1cd8d$var$_objectSpread($f09c4ee659b1cd8d$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});



parcelRegister("2DnR8", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsRemoteArtifact", () => $052771dceb51ac47$export$233293b7afb7b362);

var $eJOHy = parcelRequire("eJOHy");

var $7GxOn = parcelRequire("7GxOn");

var $3YsuO = parcelRequire("3YsuO");
const $052771dceb51ac47$var$transformArtifactsWithOverrides = (artifact, overrideKeys)=>{
    if (!artifact?.overrides?.length || overrideKeys.length === 0) return artifact;
    return overrideKeys.reduce((acc, overrideKey)=>{
        return {
            ...acc,
            ...artifact.overrides && artifact.overrides.find((override)=>override.key === overrideKey)?.item || null
        };
    }, artifact);
};
const $052771dceb51ac47$export$233293b7afb7b362 = (product, locale, overridesKeys)=>{
    const dimensions = (0, $eJOHy.useMemo)(()=>({
            ...(0, $3YsuO.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        }), [
        locale
    ]);
    const artifact = (0, $7GxOn.useFlightDeckArtifact)((0, $3YsuO.FD_CLIENT_FETCH_PROPS).name, dimensions);
    /**
	 * FlightDeck doesn't allow custom, a 'product', dimension so we must handle this ourselves.
	 * We can probably remove this memo once that functionality is available
	 */ return (0, $eJOHy.useMemo)(()=>{
        const productArtifact = artifact ? product in artifact['people-menu'] ? artifact['people-menu'][product] : artifact['people-menu'].default : null;
        return {
            ['people-menu']: $052771dceb51ac47$var$transformArtifactsWithOverrides(productArtifact, overridesKeys ? overridesKeys['people-menu'] : [])
        };
    }, [
        artifact,
        product,
        overridesKeys
    ]);
};

});
parcelRegister("3YsuO", function(module, exports) {

$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $fb6d04c5805bc5e9$export$c270c412a04ff3e6);

var $igNUx = parcelRequire("igNUx");
const $fb6d04c5805bc5e9$export$953923d576277fd6 = 'people-and-teams-configuration-service';
const $fb6d04c5805bc5e9$export$71f196808ce40e60 = 'prod';
const $fb6d04c5805bc5e9$export$6392ca3738ed1e9 = 'fedramp-moderate';
const $fb6d04c5805bc5e9$export$e836203c1e95eac3 = 'commercial';
const $fb6d04c5805bc5e9$export$c270c412a04ff3e6 = {
    name: $fb6d04c5805bc5e9$export$953923d576277fd6,
    dimensions: {
        environmentType: $fb6d04c5805bc5e9$export$71f196808ce40e60,
        perimeter: (0, $igNUx.isFedRamp)() ? $fb6d04c5805bc5e9$export$6392ca3738ed1e9 : $fb6d04c5805bc5e9$export$e836203c1e95eac3
    }
};

});


parcelRegister("jp2Nh", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $7449b5094e870659$export$9c542858adf7dcd0);
const $7449b5094e870659$export$9c542858adf7dcd0 = {
    ['people-menu']: null
};

});

parcelRegister("e8MqD", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsConfigurationOverrides", () => $efda0b11f4f91fdf$export$66d7d96ce076bcd6);

var $d0bCq = parcelRequire("d0bCq");

var $j5w1g = parcelRequire("j5w1g");
const $efda0b11f4f91fdf$export$66d7d96ce076bcd6 = (teamPermissionCheckEnabled, orgId, teamPermissionsProps)=>{
    const { permissions: teamPermissionsFromHook } = (0, $d0bCq.useTeamsPermissionsService)(orgId, {
        enabled: teamPermissionCheckEnabled && !teamPermissionsProps
    });
    const teamPermissions = teamPermissionsProps || teamPermissionsFromHook;
    return {
        'people-menu': [
            ...!teamPermissions?.canCreateTeams ? [
                (0, $j5w1g.PeopleMenuOverrides).createTeamsDisabled
            ] : [],
            ...!teamPermissions?.canViewTeams ? [
                (0, $j5w1g.PeopleMenuOverrides).viewTeamsDisabled
            ] : []
        ]
    };
};

});
parcelRegister("d0bCq", function(module, exports) {

$parcel$export(module.exports, "useTeamsPermissionsService", () => $bb6b627d5f03819c$export$b24dcbe1ec677a8);

var $eJOHy = parcelRequire("eJOHy");

var $f1Zdy = parcelRequire("f1Zdy");

var $dUDDZ = parcelRequire("dUDDZ");

var $fSenb = parcelRequire("fSenb");
const $bb6b627d5f03819c$export$b24dcbe1ec677a8 = (scope, { enabled: enabled, attributes: attributes } = {
    enabled: false,
    attributes: {}
})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    // backwards compatibility allow orgId to be passed as a string
    const { orgId: orgId, cloudId: cloudId } = typeof scope === 'string' || !scope ? {
        orgId: scope,
        cloudId: undefined
    } : scope;
    const [state, { getPermissions: getPermissions }] = (0, $fSenb.useTeamsPermissionsStore)();
    const fetchData = (0, $eJOHy.useCallback)(async ()=>{
        getPermissions({
            orgId: orgId,
            cloudId: cloudId,
            enabled: enabled
        }, {
            onFetch: ()=>(0, $dUDDZ.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'fetched',
                    actionSubject: 'use-team-permissions',
                    attributes: {
                        userId: attributes?.userId,
                        orgId: orgId,
                        cloudId: cloudId
                    }
                })
        });
    }, [
        orgId,
        cloudId,
        enabled,
        getPermissions,
        createAnalyticsEvent,
        attributes?.userId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissionsResponse,
        error: state.error,
        ...state
    };
};

});
parcelRegister("dUDDZ", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $ec30f2ed6eec287c$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireScreenEvent", () => $ec30f2ed6eec287c$export$59608e0169622110);
$parcel$export(module.exports, "fireTrackEvent", () => $ec30f2ed6eec287c$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireUIEvent", () => $ec30f2ed6eec287c$export$7eca133280843f9e);
$parcel$export(module.exports, "isSeriousError", () => $ec30f2ed6eec287c$export$91c413c8a5c77e19);
const $ec30f2ed6eec287c$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $ec30f2ed6eec287c$var$runItLater = (cb)=>{
    if (window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $ec30f2ed6eec287c$var$fireEvent = (kind)=>(createAnalyticsEvent, body)=>{
        if (!createAnalyticsEvent) return;
        $ec30f2ed6eec287c$var$runItLater(()=>{
            createAnalyticsEvent({
                eventType: kind,
                ...body
            }).fire($ec30f2ed6eec287c$var$ANALYTICS_CHANNEL);
        });
    };
const $ec30f2ed6eec287c$export$a1fb57756f0de62b = $ec30f2ed6eec287c$var$fireEvent('operational');
const $ec30f2ed6eec287c$export$59608e0169622110 = $ec30f2ed6eec287c$var$fireEvent('screen');
const $ec30f2ed6eec287c$export$574d2f19a52d67ca = $ec30f2ed6eec287c$var$fireEvent('track');
const $ec30f2ed6eec287c$export$7eca133280843f9e = $ec30f2ed6eec287c$var$fireEvent('ui');
const $ec30f2ed6eec287c$export$91c413c8a5c77e19 = (error)=>{
    if (!error) return false;
    // Check for ' 403' with space beforehand to not count urls containing 403 in cloud or team id
    if ('status' in error && error['status'] === 403 || error?.message?.includes(' 403')) return false;
    if ('status' in error && error['status'] === 401 || error?.message?.includes(' 401')) return false;
    if ('status' in error && error['status'] === 429 || error?.message?.includes(' 429')) return false;
    if (error.message === 'Failed to fetch') return false;
    return true;
};

});

parcelRegister("fSenb", function(module, exports) {

$parcel$export(module.exports, "useTeamsPermissionsStore", () => $d600202767bb0669$export$4e7a1c55cba5a168);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $d46SR = parcelRequire("d46SR");
var $4cZr6 = parcelRequire("4cZr6");

var $dJPFv = parcelRequire("dJPFv");
const $d600202767bb0669$var$actions = {
    getPermissions: ({ orgId: orgId, cloudId: cloudId, enabled: enabled }, { onFetch: onFetch })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading } = getState();
            if (hasLoaded || isLoading || !enabled || !orgId || !cloudId) return;
            try {
                setState({
                    isLoading: true
                });
                (0, $4cZr6.teamsClient).setContext({
                    orgId: orgId,
                    cloudId: cloudId
                });
                const response = await (0, $4cZr6.teamsClient).getPermissions();
                dispatch($d600202767bb0669$var$actions.setPermissions(response.permissions));
                onFetch?.();
            } catch (error) {
                dispatch($d600202767bb0669$var$actions.setError(error instanceof (0, $d46SR.HttpError) ? error : new Error('Failed to fetch permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: (0, $dJPFv.transformPermissions)(permissions),
                permissionsResponse: {
                    permissions: permissions
                }
            });
        }
};
const $d600202767bb0669$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {
            canCreateTeams: true,
            canViewTeams: true,
            canAdminTeams: false
        }
    },
    actions: $d600202767bb0669$var$actions,
    name: 'teams-permissions'
});
const $d600202767bb0669$export$4e7a1c55cba5a168 = (0, $iJq0l.createHook)($d600202767bb0669$var$Store);

});
parcelRegister("d46SR", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $ba590f7f416d1aa1$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $ba590f7f416d1aa1$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $ba590f7f416d1aa1$export$9677d7c364ada66c);
$parcel$export(module.exports, "DefaultError", () => $ba590f7f416d1aa1$export$c73ca302efeda3b4);
$parcel$export(module.exports, "SLOIgnoreError", () => $ba590f7f416d1aa1$export$d87f401f8106d7a2);
$parcel$export(module.exports, "HttpError", () => $ba590f7f416d1aa1$export$65bd6083489bd8bb);
$parcel$export(module.exports, "SLOIgnoreHttpError", () => $ba590f7f416d1aa1$export$826a3d65b8435adf);
$parcel$export(module.exports, "GraphQLError", () => $ba590f7f416d1aa1$export$92d6ed0888e7cb7f);
$parcel$export(module.exports, "isNetworkError", () => $ba590f7f416d1aa1$export$476aa014e2fd89d5);
var $ba590f7f416d1aa1$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
var $ba590f7f416d1aa1$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $ba590f7f416d1aa1$export$cde1786a482f9a1c(error) {
    return $ba590f7f416d1aa1$export$9677d7c364ada66c(401, error) || $ba590f7f416d1aa1$export$9677d7c364ada66c(403, error);
}
function $ba590f7f416d1aa1$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}
function $ba590f7f416d1aa1$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
var $ba590f7f416d1aa1$export$c33cd4757598521c = /*#__PURE__*/ function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    return TeamErrorType;
}({});
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $ba590f7f416d1aa1$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message || 'UnknownError';
        this.stack = new Error(message).stack || '';
    }
}
class $ba590f7f416d1aa1$export$c73ca302efeda3b4 extends $ba590f7f416d1aa1$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $ba590f7f416d1aa1$export$c73ca302efeda3b4.prototype);
    }
}
class $ba590f7f416d1aa1$export$d87f401f8106d7a2 extends $ba590f7f416d1aa1$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $ba590f7f416d1aa1$export$d87f401f8106d7a2.prototype);
    }
}
class $ba590f7f416d1aa1$export$65bd6083489bd8bb extends $ba590f7f416d1aa1$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId, path: path }){
        super(message);
        Object.setPrototypeOf(this, $ba590f7f416d1aa1$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
        this.path = path;
    }
}
class $ba590f7f416d1aa1$export$826a3d65b8435adf extends $ba590f7f416d1aa1$export$65bd6083489bd8bb {
    constructor(props){
        super(props);
        Object.setPrototypeOf(this, $ba590f7f416d1aa1$export$826a3d65b8435adf.prototype);
    }
}
class $ba590f7f416d1aa1$export$92d6ed0888e7cb7f extends $ba590f7f416d1aa1$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $ba590f7f416d1aa1$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $ba590f7f416d1aa1$export$92d6ed0888e7cb7f(errorData);
        };
    }
}
function $ba590f7f416d1aa1$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}

});

parcelRegister("4cZr6", function(module, exports) {

$parcel$export(module.exports, "teamsClient", () => $49217da929c9bb0b$export$5ed932c3646b89c6);

var $8XtVW = parcelRequire("8XtVW");

var $k0oqb = parcelRequire("k0oqb");

var $jQW28 = parcelRequire("jQW28");

var $eh7bW = parcelRequire("eh7bW");

var $5OnvN = parcelRequire("5OnvN");

var $Dc7Bu = parcelRequire("Dc7Bu");

var $cl86K = parcelRequire("cl86K");

var $5qxB6 = parcelRequire("5qxB6");

var $4uYvS = parcelRequire("4uYvS");

var $djSSl = parcelRequire("djSSl");

var $5BW7H = parcelRequire("5BW7H");

var $43CGC = parcelRequire("43CGC");

var $kkLwi = parcelRequire("kkLwi");

var $kkver = parcelRequire("kkver");

var $bWtrI = parcelRequire("bWtrI");

var $7rZUs = parcelRequire("7rZUs");
class $49217da929c9bb0b$export$db59823f35bf78ce {
    constructor(/**
		 * @param {ClientContextProps} context - Context including CloudId & OrgId to be used for all requests
		 */ context){
        this._aggClient = (0, $jQW28.aggClient);
        this._directoryClient = (0, $5OnvN.directoryClient);
        this._legionClient = (0, $5qxB6.defaultLegionClient);
        this._mutabilityClient = (0, $4uYvS.default);
        this._permsClient = (0, $5BW7H.default);
        this._publicApiClient = (0, $43CGC.default);
        this._invitationsClient = (0, $cl86K.default);
        this._userPreferencesClient = (0, $7rZUs.default);
        this._objectResolverClient = (0, $djSSl.default);
        this._teamsInSlackClient = (0, $bWtrI.default);
        this._collaborationGraphClient = (0, $eh7bW.default);
        this._identityClient = (0, $Dc7Bu.default);
        this._teamCentralClient = (0, $kkver.default);
        this._replinesClient = (0, $kkLwi.default);
        if (context) this.setContext(context);
    }
    async measurePerformance(name, fn) {
        const exp = (0, $k0oqb.TEAMS_CLIENT_EXPERIENCES).get(name);
        if (!exp) return fn();
        exp.start();
        try {
            const result = await fn();
            exp.success();
            return result;
        } catch (e) {
            exp.failWithError(e);
            throw e;
        }
    }
    /**
	 * Sets the base URL to be used in the client requests
	 * @param {string} baseUrl - The new base URL
	 */ setBaseUrl(baseUrl) {
        this._aggClient.setBaseUrl(baseUrl);
        this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Sets context including CloudId & OrgId to be used for all requests
	 */ setContext(context) {
        this._aggClient.setContext(context);
        this._directoryClient.setContext(context);
        this._legionClient.setContext(context);
        this._permsClient.setContext(context);
        this._mutabilityClient.setContext(context);
        this._publicApiClient.setContext(context);
        this._invitationsClient.setContext(context);
        this._replinesClient.setContext(context);
    }
    setTeamCentralContext(baseUrl, context) {
        this._teamCentralClient.setContext(context);
        this._teamCentralClient.setBaseUrl(baseUrl);
    }
    /**
	 * @private
	 * @deprecated use setBaseUrl instead
	 */ setDirectoryBaseUrl(baseUrl) {
        // eslint-disable-next-line no-console
        console.warn('setDirectoryBaseUrl is deprecated, use setBaseUrl instead');
        return this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Fetches Browse user settings
	 */ async querySettings(cloudId, product) {
        if (cloudId) {
            if ((0, $8XtVW.fg)('fix_query_settings_context')) {
                const previousContext = this._legionClient.getContext();
                this.setContext({
                    ...previousContext,
                    cloudId: cloudId
                });
            } else this.setContext({
                cloudId: cloudId
            });
        }
        return this.measurePerformance('querySettings', async ()=>{
            if (!product) throw new Error('Product is required');
            const response = await this._legionClient.retrieveBrowseUserPermission(product);
            return {
                'internal.browse-users-allowed': response.canSearchUsers
            };
        });
    }
    /**
	 * This will return all of the teams-related permissions that your user has for the org and site in the client context.
	 */ async getPermissions() {
        return this.measurePerformance('getPermissions', ()=>this._legionClient.getPermissions());
    }
    /**
	 * Fetches feature flags from Directory
	 * @deprecated As part of decommisioning pf-directoy
	 */ async queryFeatureFlags(...args) {
        return this.measurePerformance('queryFeatureFlags', ()=>this._directoryClient.queryFeatureFlags(...args));
    }
    /**
	 * Get user information of members of a team, paginated
	 * @param {string} teamId
	 * @returns {Promise}
	 */ async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        return this._aggClient.queryTeamMemberships(teamId, membershipState, pageInfo);
    }
    /**
	 * Get user information given an user id
	 * @param {string} userId
	 * @returns {Promise}
	 */ async queryAGGUser(userId) {
        return this._aggClient.queryAGGUser(userId);
    }
    /**
	 * Get the agents associated with the team
	 * @param {string} userId
	 * @returns {Promise}
	 */ async queryTeamHasAgents(teamId) {
        return this._aggClient.queryTeamHasAgents(teamId);
    }
    /**
	 * Get user information of a member of a team
	 * @param {string} userId
	 * @returns {Promise<CloudUser>}
	 */ queryUser(...args) {
        return this.measurePerformance('queryUser', ()=>this._directoryClient.queryUser(...args));
    }
    setLegionRootUrl(url) {
        return this._legionClient.setRootUrl(url);
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<TeamWithImageUrls>}
	 */ async getTeamById(teamId) {
        return this.measurePerformance('getTeamById', ()=>this._legionClient.getTeamById(teamId));
    }
    /**
	 * Search teams based on query
	 */ async getAllTeams(...args) {
        return this.measurePerformance('getAllTeams', ()=>this._legionClient.getAllTeams(...args));
    }
    /**
	 * Update team details
	 */ async updateTeamById(...args) {
        return this.measurePerformance('updateTeamById', ()=>this._legionClient.updateTeamById(...args));
    }
    /**
	 * @private
	 * @deprecated use addUsersToTeam instead
	 */ async inviteUsersToTeam(...args) {
        return this.measurePerformance('inviteUsersToTeam', ()=>this._legionClient.inviteUsersToTeam(...args));
    }
    /**
	 * Get the current user's team membership
	 */ async getMyTeamMembership(...args) {
        return this.measurePerformance('getMyTeamMembership', ()=>this._legionClient.getMyTeamMembership(...args));
    }
    /**
	 * Get a teams "Links"
	 */ async getTeamLinksByTeamId(teamId) {
        return this.measurePerformance('getTeamLinksByTeamId', ()=>this._legionClient.getTeamLinksByTeamId(teamId));
    }
    /**
	 * Create a team link
	 */ async createTeamLink(...args) {
        return this.measurePerformance('createTeamLink', ()=>this._legionClient.createTeamLink(...args));
    }
    /**
	 * Update a team link
	 */ async updateTeamLink(...args) {
        return this.measurePerformance('updateTeamLink', ()=>this._legionClient.updateTeamLink(...args));
    }
    /**
	 * Delete a team link
	 */ async deleteTeamLink(...args) {
        return this.measurePerformance('deleteTeamLink', ()=>this._legionClient.deleteTeamLink(...args));
    }
    /**
	 * Reorder a team link
	 */ async reorderTeamLink(...args) {
        return this.measurePerformance('reorderTeamLink', ()=>this._legionClient.reorderTeamLink(...args));
    }
    /**
	 * Get org's eligibility for managed teams
	 */ async getOrgEligibilityForManagedTeams() {
        return this.measurePerformance('getOrgEligibilityForManagedTeams', ()=>this._legionClient.getOrgEligibilityForManagedTeams());
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Accept a team invitation
	 */ async acceptTeamInvitation(...args) {
        return this.measurePerformance('acceptTeamInvitation', ()=>this._legionClient.acceptTeamInvitation(...args));
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Decline a team invitation
	 */ async declineTeamInvitation(...args) {
        return this.measurePerformance('declineTeamInvitation', ()=>this._legionClient.declineTeamInvitation(...args));
    }
    /**
	 * Add current user to a team
	 */ async selfJoinTeam(...args) {
        return this.measurePerformance('selfJoinTeam', ()=>this._legionClient.selfJoinTeam(...args));
    }
    /**
	 * Add agent to a team
	 */ async addAgentsToTeam(...args) {
        return this.measurePerformance('addAgentToTeam', ()=>this._legionClient.addAgentsToTeam(...args));
    }
    async removeAgentTeamAssociation(...args) {
        return this.measurePerformance('removeAgentTeamAssociation', ()=>this._legionClient.removeAgentTeamAssociation(...args));
    }
    /**
	 * Cancel a join request to a private team
	 */ async cancelJoinRequest(teamId) {
        return this.measurePerformance('cancelJoinRequest', ()=>this._legionClient.cancelJoinRequest(teamId));
    }
    /**
	 * Accept a join request to a private team
	 */ async acceptJoinRequest(...args) {
        return this.measurePerformance('acceptJoinRequest', ()=>this._legionClient.acceptJoinRequest(...args));
    }
    /**
	 * Decline a join request to a private team
	 */ async declineJoinRequest(...args) {
        return this.measurePerformance('declineJoinRequest', ()=>this._legionClient.declineJoinRequest(...args));
    }
    /**
	 * @deprecated use removeTeamMemberships instead
	 */ async deleteTeamMembership(...args) {
        return this.measurePerformance('deleteTeamMembership', ()=>this._legionClient.deleteTeamMembership(...args));
    }
    /**
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(...args) {
        return this.measurePerformance('revokeTeamInvite', ()=>this._legionClient.revokeTeamInvite(...args));
    }
    /**
	 * Delete a team
	 */ async deleteTeam(teamId) {
        return this.measurePerformance('deleteTeam', ()=>this._legionClient.deleteTeam(teamId));
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        return this._legionClient.isSingleFullMemberTeam(teamId);
    }
    /**
	 * Create a team
	 */ async createTeam(...args) {
        return this.measurePerformance('createTeam', ()=>this._legionClient.createTeam(...args));
    }
    /**
	 * Create containers for a team
	 */ async createTeamContainers(...args) {
        return this.measurePerformance('createTeamContainers', ()=>this._legionClient.createTeamContainers(...args));
    }
    /**
	 * Create a external team
	 * @param {string} groupDescription - The description of the group, which will be used as the team description. The group name will be fetched from the identity service, so it does not need to be provided.
	 * @param {ExternalReference} externalReference
	 */ async createExternalTeam(...args) {
        return this.measurePerformance('createExternalTeam', ()=>this._legionClient.createExternalTeam(...args));
    }
    /**
	 * Get linked teams for a groups in bulk
	 * @param {string} groupIds - The group ids to fetch linked teams for
	 */ async getLinkedTeamsBulk(...args) {
        return this.measurePerformance('getLinkedTeamsBulk', ()=>this._legionClient.getLinkedTeamsBulk(...args));
    }
    /**
	 * Get Org scope
	 */ async getOrgScope(...args) {
        return this.measurePerformance('getOrgScope', ()=>this._legionClient.getOrgScope(...args));
    }
    /**
	 * Restore soft-deleted team and sync to group
	 */ async restoreTeamToSyncedGroup(...args) {
        return this.measurePerformance('restoreTeamToSyncedGroup', ()=>this._legionClient.restoreTeamToSyncedGroup(...args));
    }
    /**
	 * Get the difference between a team and a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 * @returns {Promise<TeamAndGroupDifference>}
	 */ async getTeamAndGroupDiff(...args) {
        return this.measurePerformance('getTeamAndGroupDiff', ()=>this._legionClient.getTeamAndGroupDiff(...args));
    }
    /**
	 * Link an existing team to a group
	 * @param teamId
	 * @param {ExternalReference} externalReference
	 */ async linkExistingTeamToGroup(...args) {
        return this.measurePerformance('linkExistingTeamToGroup', ()=>this._legionClient.linkExistingTeamToGroup(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<LinkedTeamsProfileDetails>}
	 */ async getTeamProfileDetailsByTeamId(...args) {
        return this.measurePerformance('getTeamProfileDetails', ()=>this._legionClient.getTeamProfileDetails(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getSoftDeletdTeamById(teamId) {
        return this.measurePerformance('getSoftDeletedTeamById', ()=>this._legionClient.getSoftDeletedTeamById(teamId));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 * @param userId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getUserInSiteUserBase(userId) {
        return this.measurePerformance('getUserInSiteUserBase', ()=>this._legionClient.getUserInSiteUserBase(userId));
    }
    trimTeamARI(teamId = '') {
        return this._legionClient.trimTeamARI(teamId);
    }
    /**
	 * Get user profile with mutability constraints
	 */ async getProfileWithMutability(...args) {
        return this.measurePerformance('getProfileWithMutability', ()=>this._mutabilityClient.getProfileWithMutability(...args));
    }
    /**
	 * Get enabled sites for a team
	 */ async getTeamEnabledSites(...args) {
        return this.measurePerformance('getTeamEnabledSites', ()=>this._legionClient.getTeamEnabledSites(...args));
    }
    /**
	 * Assign teams to sites
	 * @param migrations
	 * @returns {Promise<AssignTeamsToSitesResponse>}
	 */ async assignTeamsToSites(...args) {
        return this.measurePerformance('assignTeamsToSites', ()=>this._legionClient.assignTeamsToSites(...args));
    }
    /**
	 * Get assigned teams
	 * @param orgId
	 * @param cursor
	 * @param displayNameContains
	 * @param count - number of teams to return
	 */ async getAssignedTeams(...args) {
        return this.measurePerformance('getAssignedTeams', ()=>this._legionClient.getAssignedTeams(...args));
    }
    /**
	 * Get unassigned teams
	 * @param orgId
	 * @param count - number of teams to return
	 * @param cursor - cursor to the next page of results
	 * @param query - query to filter teams by
	 */ async getUnassignedTeams(...args) {
        return this.measurePerformance('getUnassignedTeams', ()=>this._legionClient.getUnassignedTeams(...args));
    }
    /**
	 * Set team site assignment permission
	 * @param orgId
	 * @param alignmentPermission - 'ALL_USERS' | 'ORG_ADMIN'
	 */ async setTeamSiteAssignmentPermission(...args) {
        return this.measurePerformance('setTeamSiteAssignmentPermission', ()=>this._legionClient.setTeamSiteAssignmentPermission(...args));
    }
    /**
	 * Is the current user a site admin
	 */ getIsSiteAdmin(...args) {
        return this.measurePerformance('getIsSiteAdmin', ()=>this._permsClient.getIsSiteAdmin(...args));
    }
    /**
	 * Add users to a team
	 */ addUsersToTeam(...args) {
        return this.measurePerformance('addUsersToTeam', ()=>this._publicApiClient.addUsersToTeam(...args));
    }
    /**
	 * Remove users from a team
	 */ removeTeamMemberships(...args) {
        return this.measurePerformance('removeTeamMemberships', ()=>this._publicApiClient.removeTeamMemberships(...args));
    }
    /**
	 * Restore a deleted team
	 */ restoreTeam(...args) {
        return this.measurePerformance('restoreTeam', ()=>this._publicApiClient.restoreTeam(...args));
    }
    getRecommendedProducts(...args) {
        return this.measurePerformance('getRecommendedProducts', ()=>this._invitationsClient.getProductRecommendations(...args));
    }
    joinOrRequestDefaultAccessToProductsBulk(...args) {
        return this.measurePerformance('joinOrRequestDefaultAccessToProductsBulk', ()=>this._invitationsClient.joinOrRequestDefaultAccessToProductsBulk(...args));
    }
    /**
	 * Get token to upload media for a team
	 */ async getWriteTeamMediaToken() {
        return this.measurePerformance('getWriteTeamMediaToken', ()=>this._legionClient.getWriteMediaToken());
    }
    /**
	 * Get token to read media for a user
	 */ async getReadMediaToken(...args) {
        return this.measurePerformance('getReadMediaToken', ()=>this._userPreferencesClient.getReadMediaToken(...args));
    }
    /**
	 * Get token to upload media for a user
	 */ async getWriteUserMediaToken() {
        return this.measurePerformance('getWriteUserMediaToken', ()=>this._userPreferencesClient.getWriteMediaToken());
    }
    /**
	 * Update header image for a user
	 */ async updateUserHeaderImage(headerImageId) {
        return this.measurePerformance('updateUserHeaderImage', ()=>this._userPreferencesClient.updateUserHeaderImage(headerImageId));
    }
    /**
	 * Fetch user containers from collboration graph
	 */ async getUserContainers(...args) {
        return this.measurePerformance('getUserContainers', ()=>this._collaborationGraphClient.getUserContainers(...args));
    }
    /**
	 * Fetch mutatability of external managed user fields
	 */ async getUserManageConfig(...args) {
        return this.measurePerformance('getUserManageConfig', ()=>this._identityClient.getUserManageConfig(...args));
    }
    /**
	 * Fetch user avatar uploaded status
	 */ async getMyAvatarUploadedStatus(...args) {
        return this.measurePerformance('getMyAvatarUploadedStatus', ()=>this._identityClient.getMyAvatarUploadedStatus(...args));
    }
    /**
	 * Delete user avatar
	 */ async deleteAvatar(...args) {
        return this.measurePerformance('deleteUserAvatar', ()=>this._identityClient.deleteAvatar(...args));
    }
    async fetchUserAvatarInfo(...args) {
        return this.measurePerformance('fetchUserAvatarInfo', ()=>this._identityClient.fetchUserAvatarInfo(...args));
    }
    /**
	 * Fetch Team link icons
	 */ async getTeamLinkIcons(...args) {
        return this.measurePerformance('getTeamLinkIcons', ()=>this._objectResolverClient.getTeamLinkIcons(...args));
    }
    /**
	 * Fetch ARI from URL
	 */ async getAriFromUrl(...args) {
        return this.measurePerformance('getAriFromUrl', ()=>this._objectResolverClient.getAriFromUrl(...args));
    }
    /**
	 * Fetch web link title
	 */ async getWebLinkTitle(...args) {
        return this.measurePerformance('getWebLinkTitle', ()=>this._objectResolverClient.getWebLinkTitle(...args));
    }
    /**
	 * Fetch team in slack details
	 */ async getTeamInSlack(...args) {
        return this.measurePerformance('getTeamInSlack', ()=>this._teamsInSlackClient.getTeamInSlack(...args));
    }
    /**
	 * Delete team in slack
	 */ async disconnectTeamInSlack(...args) {
        return this.measurePerformance('disconnectTeamInSlack', ()=>this._teamsInSlackClient.disconnectTeamInSlack(...args));
    }
    /**
	 * Update team in slack
	 */ async updateTeamInSlack(...args) {
        return this.measurePerformance('updateTeamInSlack', ()=>this._teamsInSlackClient.updateTeamInSlack(...args));
    }
    /**
	 * Update user details
	 */ async updateUser(...args) {
        return this.measurePerformance('updateUser', ()=>this._identityClient.updateUser(...args));
    }
    async updateUserAvatar(...args) {
        return this.measurePerformance('updateUserAvatar', ()=>this._identityClient.updateUserAvatar(...args));
    }
    async addTeamWatcher(...args) {
        return this._teamCentralClient.addTeamWatcher(...args);
    }
    async removeTeamWatcher(...args) {
        return this._teamCentralClient.removeTeamWatcher(...args);
    }
    async deleteKudos(...args) {
        return this._teamCentralClient.deleteKudos(...args);
    }
    async queryTagList(...args) {
        return this._teamCentralClient.queryTagList(...args);
    }
    async createTag(...args) {
        return this._teamCentralClient.createTag(...args);
    }
    async createHelpPointer(...args) {
        return this._teamCentralClient.createHelpPointer(...args);
    }
    async updateHelpPointer(...args) {
        return this._teamCentralClient.updateHelpPointer(...args);
    }
    async deleteHelpPointer(...args) {
        return this._teamCentralClient.deleteHelpPointer(...args);
    }
    async getUserTenure(...args) {
        return this.measurePerformance('getUserTenure', ()=>this._replinesClient.getUserTenure(...args));
    }
}
const $49217da929c9bb0b$export$5ed932c3646b89c6 = new $49217da929c9bb0b$export$db59823f35bf78ce();

});
parcelRegister("k0oqb", function(module, exports) {

$parcel$export(module.exports, "TEAMS_CLIENT_EXPERIENCES", () => $6cdd62da12021c02$export$879344107b04120c);

var $dBtrr = parcelRequire("dBtrr");

var $7Pveb = parcelRequire("7Pveb");
const $6cdd62da12021c02$var$TeamsClientExperienceKeyList = [
    'getAllTeams',
    'getTeamById',
    'updateTeamById',
    'querySettings',
    'queryFeatureFlags',
    'queryTeamMemberships',
    'queryUser',
    'inviteUsersToTeam',
    'getMyTeamMembership',
    'getTeamLinksByTeamId',
    'createTeamLink',
    'updateTeamLink',
    'deleteTeamLink',
    'reorderTeamLink',
    'acceptTeamInvitation',
    'declineTeamInvitation',
    'selfJoinTeam',
    'cancelJoinRequest',
    'acceptJoinRequest',
    'declineJoinRequest',
    'deleteTeamMembership',
    'revokeTeamInvite',
    'deleteTeam',
    'isSingleFullMemberTeam',
    'createTeam',
    'createTeamContainers',
    'createExternalTeam',
    'getProfileWithMutability',
    'getIsSiteAdmin',
    'addUsersToTeam',
    'removeTeamMemberships',
    'getRecommendedProducts',
    'joinOrRequestDefaultAccessToProductsBulk',
    'getReadMediaToken',
    'getWriteUserMediaToken',
    'updateUserHeaderImage',
    'getWriteTeamMediaToken',
    'getSoftDeletedTeamById',
    'restoreTeam',
    'getUserInSiteUserBase',
    'getLinkedTeamsBulk',
    'getTeamProfileDetails',
    'getUserContainers',
    'getPermissions',
    'getUserManageConfig',
    'getMyAvatarUploadedStatus',
    'deleteUserAvatar',
    'getTeamLinkIcons',
    'getTeamInSlack',
    'getOrgScope',
    'restoreTeamToSyncedGroup',
    'getTeamAndGroupDiff',
    'linkExistingTeamToGroup',
    'fetchUserAvatarInfo',
    'getOrgEligibilityForManagedTeams',
    'updateUser',
    'updateUserAvatar',
    'disconnectTeamInSlack',
    'updateTeamInSlack',
    'getUserTenure',
    'getAriFromUrl',
    'getWebLinkTitle',
    'addAgentToTeam',
    'getTeamEnabledSites',
    'assignTeamsToSites',
    'removeAgentTeamAssociation',
    'getAssignedTeams',
    'setTeamSiteAssignmentPermission',
    'getUnassignedTeams'
];
const $6cdd62da12021c02$export$879344107b04120c = new Map([
    ...$6cdd62da12021c02$var$TeamsClientExperienceKeyList.map((key)=>[
            key,
            // camelCase to kebab-case
            new (0, $7Pveb.TeamsUFOExperience)(`teams-client-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`, {
                type: (0, $dBtrr.ExperienceTypes).Operation,
                performanceType: (0, $dBtrr.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'people'
                }
            })
        ])
]);

});
parcelRegister("dBtrr", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $d016b68333d00f03$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $d016b68333d00f03$export$cc26007c03242fff);
var $d016b68333d00f03$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $d016b68333d00f03$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("7Pveb", function(module, exports) {

$parcel$export(module.exports, "TeamsUFOExperience", () => $e695299f351f8a22$export$9a18529d1e90e81a);

var $dHVjK = parcelRequire("dHVjK");

var $d46SR = parcelRequire("d46SR");

var $1khUz = parcelRequire("1khUz");
class $e695299f351f8a22$export$9a18529d1e90e81a extends (0, $dHVjK.UFOExperience) {
    abortWithError(error, reason) {
        return super.abort({
            metadata: {
                error: (0, $1khUz.createErrorMetadata)(error),
                reason: reason
            }
        });
    }
    failWithError(error) {
        if (error instanceof Error) {
            if ((0, $d46SR.isAuthError)(error)) return this.abortWithError(error, 'Abort due to user unauthenticated');
            if ((0, $d46SR.isErrorStatusCode)((0, $d46SR.StatusCode).GONE, error)) return this.abortWithError(error, 'Abort due to unavailable resource');
            if ((0, $1khUz.isIgnoredError)(error)) return this.abortWithError(error, 'Abort due to an error in ignore list');
            if ((0, $d46SR.isNetworkError)(error)) return this.abortWithError(error, 'Abort due to network error');
            return super.failure({
                metadata: {
                    error: (0, $1khUz.createErrorMetadata)(error),
                    packageVersion: "0.0.0-use.local",
                    packageName: "platform-pkg"
                }
            });
        }
        return super.failure({
            metadata: {
                error: 'unknown error',
                packageVersion: "0.0.0-use.local",
                packageName: "platform-pkg"
            }
        });
    }
}

});
parcelRegister("dHVjK", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $0d9cdc81d4c2e897$export$c00d22927c60484a);

var $cqyCF = parcelRequire("cqyCF");
class $0d9cdc81d4c2e897$export$c00d22927c60484a extends (0, $cqyCF.UFOAbstractExperience) {
}

});
parcelRegister("cqyCF", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $28652a0d339da7dd$export$d31c89db257648c);

var $aXKmr = parcelRequire("aXKmr");


var $ikTrL = parcelRequire("ikTrL");

var $bjABV = parcelRequire("bjABV");

var $isPRN = parcelRequire("isPRN");

var $lUdKu = parcelRequire("lUdKu");

var $aUnwH = parcelRequire("aUnwH");

var $12tX6 = parcelRequire("12tX6");

var $1i6NW = parcelRequire("1i6NW");

var $hjzXK = parcelRequire("hjzXK");

var $dBtrr = parcelRequire("dBtrr");
const $28652a0d339da7dd$var$getPageVisibleState = ()=>{
    return !(0, $12tX6.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $lUdKu.PageVisibleState).VISIBLE : (0, $lUdKu.PageVisibleState).HIDDEN;
};
const $28652a0d339da7dd$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $aUnwH.roundPerfNow)();
};
class $28652a0d339da7dd$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $1i6NW.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $lUdKu.PageVisibleState).MIXED;
            (0, $isPRN.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $28652a0d339da7dd$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $dBtrr.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $dBtrr.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $bjABV.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $hjzXK.canTransition)(this.state, newState)) {
            (0, $bjABV.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $1i6NW.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $28652a0d339da7dd$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $aXKmr.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $28652a0d339da7dd$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $ikTrL.getGlobalEventStream)().push((0, $ikTrL.unsubscribeEvent)((0, $lUdKu.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $bjABV.ufolog)('this.parent', this.parent);
                (0, $ikTrL.getGlobalEventStream)().push((0, $ikTrL.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $bjABV.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $bjABV.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $1i6NW.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $28652a0d339da7dd$var$getPageVisibleState();
            (0, $isPRN.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $bjABV.ufolog)('subscribed', this.id);
                (0, $ikTrL.getGlobalEventStream)().push((0, $ikTrL.subscribeEvent)((0, $lUdKu.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $lUdKu.FMP_MARK) && name !== (0, $lUdKu.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $bjABV.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $28652a0d339da7dd$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $1i6NW.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $lUdKu.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $lUdKu.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $bjABV.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $isPRN.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $1i6NW.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $1i6NW.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $1i6NW.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $bjABV.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $c7cfccb0000f86d7$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $c7cfccb0000f86d7$export$2295b861f318254a = '0.1.5';

parcelRegister("ikTrL", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $28f6560f8d9def86$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $28f6560f8d9def86$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $28f6560f8d9def86$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $28f6560f8d9def86$export$7c957416596ca127);

var $bjABV = parcelRequire("bjABV");

var $lUdKu = parcelRequire("lUdKu");
const $28f6560f8d9def86$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $28f6560f8d9def86$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $28f6560f8d9def86$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $28f6560f8d9def86$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $bjABV.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $28f6560f8d9def86$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $lUdKu.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $28f6560f8d9def86$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $lUdKu.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $28f6560f8d9def86$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $lUdKu.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("bjABV", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $9479fdf8f4169e9d$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $9479fdf8f4169e9d$export$d53d07b6034c4560);
class $9479fdf8f4169e9d$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($9479fdf8f4169e9d$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($9479fdf8f4169e9d$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $9479fdf8f4169e9d$export$4ab84f6f04f6566d = new $9479fdf8f4169e9d$var$UFOLogger();
const $9479fdf8f4169e9d$export$b4958caff08a0960 = (...args)=>{
    $9479fdf8f4169e9d$export$4ab84f6f04f6566d.log(...args);
};
const $9479fdf8f4169e9d$export$d53d07b6034c4560 = (...args)=>{
    $9479fdf8f4169e9d$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("lUdKu", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $205d0978047ce8eb$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $205d0978047ce8eb$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $205d0978047ce8eb$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $205d0978047ce8eb$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $205d0978047ce8eb$export$837e0f79a8056912);
var $205d0978047ce8eb$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $205d0978047ce8eb$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $205d0978047ce8eb$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $205d0978047ce8eb$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $205d0978047ce8eb$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $205d0978047ce8eb$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $205d0978047ce8eb$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $205d0978047ce8eb$export$9f2bf58999404c75 = 'fmp';
const $205d0978047ce8eb$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("isPRN", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $f53cae22b0934961$export$13e680397ec8f3eb);

var $12tX6 = parcelRequire("12tX6");
class $f53cae22b0934961$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $12tX6.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $f53cae22b0934961$export$13e680397ec8f3eb = new $f53cae22b0934961$var$VisibilityChangeObserver();

});
parcelRegister("12tX6", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $dcf5e078366e9bcd$export$15e172712955e18f);
const $dcf5e078366e9bcd$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("aUnwH", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $f16fb27ef0585f2b$export$5f490af6b2b115cf);
const $f16fb27ef0585f2b$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("1i6NW", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $fa1a3913209957e2$export$81b70111112841a0);
const $fa1a3913209957e2$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("hjzXK", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $53137698087d9354$export$178881f329fdb81f);

var $1i6NW = parcelRequire("1i6NW");
const $53137698087d9354$var$UFOStateAvailableTransitions = {
    [(0, $1i6NW.UFOExperienceState).NOT_STARTED.id]: [
        (0, $1i6NW.UFOExperienceState).STARTED.id
    ],
    [(0, $1i6NW.UFOExperienceState).STARTED.id]: [
        (0, $1i6NW.UFOExperienceState).IN_PROGRESS.id,
        (0, $1i6NW.UFOExperienceState).BLOCKED.id,
        (0, $1i6NW.UFOExperienceState).SUCCEEDED.id,
        (0, $1i6NW.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $1i6NW.UFOExperienceState).FAILED.id,
        (0, $1i6NW.UFOExperienceState).ABORTED.id
    ],
    [(0, $1i6NW.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $1i6NW.UFOExperienceState).BLOCKED.id,
        (0, $1i6NW.UFOExperienceState).SUCCEEDED.id,
        (0, $1i6NW.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $1i6NW.UFOExperienceState).FAILED.id,
        (0, $1i6NW.UFOExperienceState).ABORTED.id
    ],
    [(0, $1i6NW.UFOExperienceState).BLOCKED.id]: [
        (0, $1i6NW.UFOExperienceState).RECOVERED.id,
        (0, $1i6NW.UFOExperienceState).ABORTED.id
    ],
    [(0, $1i6NW.UFOExperienceState).RECOVERED.id]: [
        (0, $1i6NW.UFOExperienceState).STARTED.id,
        (0, $1i6NW.UFOExperienceState).SUCCEEDED.id,
        (0, $1i6NW.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $1i6NW.UFOExperienceState).FAILED.id,
        (0, $1i6NW.UFOExperienceState).ABORTED.id
    ],
    [(0, $1i6NW.UFOExperienceState).SUCCEEDED.id]: [
        (0, $1i6NW.UFOExperienceState).STARTED.id
    ],
    [(0, $1i6NW.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $1i6NW.UFOExperienceState).SUCCEEDED.id,
        (0, $1i6NW.UFOExperienceState).FAILED.id,
        (0, $1i6NW.UFOExperienceState).ABORTED.id
    ],
    [(0, $1i6NW.UFOExperienceState).FAILED.id]: [
        (0, $1i6NW.UFOExperienceState).STARTED.id
    ],
    [(0, $1i6NW.UFOExperienceState).ABORTED.id]: [
        (0, $1i6NW.UFOExperienceState).STARTED.id
    ]
};
const $53137698087d9354$export$178881f329fdb81f = (state1, state2)=>{
    return $53137698087d9354$var$UFOStateAvailableTransitions[state1.id] && $53137698087d9354$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});



parcelRegister("1khUz", function(module, exports) {

$parcel$export(module.exports, "createErrorMetadata", () => $4182c15042b1b0e1$export$7286a0fb7b5aab6b);
$parcel$export(module.exports, "isIgnoredError", () => $4182c15042b1b0e1$export$a8da197a8bcc7e95);

var $d46SR = parcelRequire("d46SR");
const $4182c15042b1b0e1$export$7286a0fb7b5aab6b = (error)=>({
        error: {
            name: error.name,
            message: error.message,
            stack: error.stack,
            traceId: error instanceof (0, $d46SR.HttpError) ? error.traceId : undefined,
            status: error instanceof (0, $d46SR.HttpError) ? error.status : undefined
        }
    });
const $4182c15042b1b0e1$var$ignoredErrors = [
    'SLOIgnoreError',
    'SLOIgnoreHttpError'
];
const $4182c15042b1b0e1$export$a8da197a8bcc7e95 = (error)=>{
    const errorName = error?.constructor.name;
    if (!errorName) return false;
    return $4182c15042b1b0e1$var$ignoredErrors.includes(errorName);
};

});



parcelRegister("jQW28", function(module, exports) {

$parcel$export(module.exports, "aggClient", () => $ca6b32e05760e0e6$export$464c991dbf0b2393);

var $gC1IQ = parcelRequire("gC1IQ");

var $3wIxr = parcelRequire("3wIxr");

var $b0tIZ = parcelRequire("b0tIZ");

var $3lkCh = parcelRequire("3lkCh");

var $5qPkg = parcelRequire("5qPkg");

var $cQT1T = parcelRequire("cQT1T");

var $ekWDk = parcelRequire("ekWDk");

var $gC0Mm = parcelRequire("gC0Mm");
class $ca6b32e05760e0e6$export$b44e5dafe13af7b3 extends (0, $b0tIZ.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/graphql`);
    }
    async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        const response = await this.makeGraphQLRequest({
            query: (0, $cQT1T.default),
            variables: {
                teamId: teamId,
                membershipState: membershipState,
                siteId: this.getCloudId(),
                ...pageInfo
            }
        }, {
            operationName: 'TeamMembership'
        });
        return {
            edges: response.team.teamV2.members.edges.map(({ node: node })=>({
                    membershipId: {
                        teamId: teamId,
                        memberId: (0, $gC1IQ.toUserId)(node.member.id)
                    },
                    state: node.state,
                    role: node.role,
                    user: {
                        id: (0, $gC1IQ.toUserId)(node.member.id),
                        fullName: node.member.name,
                        avatarUrl: node.member.picture,
                        status: node.member.accountStatus,
                        title: node.member.extendedProfile?.jobTitle ?? undefined,
                        userType: (0, $gC0Mm.toUserType)({
                            appType: node.member.appType
                        })
                    }
                })),
            pageInfo: response.team.teamV2.members.pageInfo
        };
    }
    async queryAGGUser(userId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $ekWDk.TeamsUserQuery),
            variables: {
                userId: userId
            }
        }, {
            operationName: 'TeamsUserQuery'
        });
        return response.user;
    }
    async queryTeamHasAgents(teamId) {
        const teamAri = (0, $gC1IQ.toTeamARI)(teamId);
        const response = await this.makeGraphQLRequest({
            query: (0, $5qPkg.TeamHasAgentsQuery),
            variables: {
                id: teamAri
            }
        }, {
            operationName: 'TeamHasAgentsQuery'
        });
        return this.processTeamHasAgentsResponse(teamId, response.graphStore);
    }
    processTeamHasAgentsResponse(teamId, response) {
        return response.teamHasAgents.edges.map(({ node: node })=>({
                associationId: {
                    teamId: teamId,
                    accountId: (0, $gC1IQ.toUserId)(node.id)
                },
                agent: {
                    id: node.id,
                    fullName: node.name,
                    avatarUrl: node.picture
                }
            }));
    }
}
const $ca6b32e05760e0e6$export$464c991dbf0b2393 = new $ca6b32e05760e0e6$export$b44e5dafe13af7b3((0, $3wIxr.DEFAULT_CONFIG).stargateRoot, {
    logException: $3lkCh.logException
});

});
parcelRegister("gC1IQ", function(module, exports) {

$parcel$export(module.exports, "toUserId", () => $5a720d02b3cc31d3$export$1d0eef1d33b05366);
$parcel$export(module.exports, "toUserARI", () => $5a720d02b3cc31d3$export$fca6a88adb58674a);
$parcel$export(module.exports, "toTeamId", () => $5a720d02b3cc31d3$export$e78216c959b9f3af);
$parcel$export(module.exports, "toTeamARI", () => $5a720d02b3cc31d3$export$2bcc6e4924859c6f);

const $5a720d02b3cc31d3$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $a348d3728180c9b8$export$470b0d72e4fdc43a));
const $5a720d02b3cc31d3$export$1d0eef1d33b05366 = (ari)=>{
    if ($5a720d02b3cc31d3$export$caac29844ad91f64(ari)) return ari.replace((0, $a348d3728180c9b8$export$470b0d72e4fdc43a), '');
    throw new Error('Invalid UserARI');
};
const $5a720d02b3cc31d3$export$fca6a88adb58674a = (userId)=>{
    return $5a720d02b3cc31d3$export$caac29844ad91f64(userId) ? userId : `${0, $a348d3728180c9b8$export$470b0d72e4fdc43a}${userId}`;
};
const $5a720d02b3cc31d3$export$7b81d5dfd83c8166 = (ari)=>ari.startsWith((0, $a348d3728180c9b8$export$cfedc369802e0c68));
const $5a720d02b3cc31d3$export$e78216c959b9f3af = (ari)=>{
    if ($5a720d02b3cc31d3$export$7b81d5dfd83c8166(ari)) return ari.replace((0, $a348d3728180c9b8$export$cfedc369802e0c68), '');
    throw new Error('Invalid TeamARI');
};
const $5a720d02b3cc31d3$export$2bcc6e4924859c6f = (teamId)=>{
    return $5a720d02b3cc31d3$export$7b81d5dfd83c8166(teamId) ? teamId : `${0, $a348d3728180c9b8$export$cfedc369802e0c68}${teamId}`;
};

});
const $a348d3728180c9b8$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $a348d3728180c9b8$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';


parcelRegister("3wIxr", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONFIG", () => $a05de541ddf93aae$export$c2f8e0cc249a8d8f);
const $a05de541ddf93aae$export$c2f8e0cc249a8d8f = {
    stargateRoot: '/gateway/api',
    permsServiceUrl: '/gateway/api/permissions',
    publicApiRoot: '/gateway/api/public',
    invitationsServiceUrl: '/gateway/api/invitations',
    collaborationGraphUrl: '/gateway/api/collaboration'
};

});

parcelRegister("b0tIZ", function(module, exports) {

$parcel$export(module.exports, "BaseGraphQlClient", () => $e18221760cf8a1b1$export$42f6d6baced34b2d);

var $d46SR = parcelRequire("d46SR");

var $irfYK = parcelRequire("irfYK");

var $uttR1 = parcelRequire("uttR1");
class $e18221760cf8a1b1$export$42f6d6baced34b2d extends (0, $irfYK.BaseClient) {
    constructor(serviceUrl, config){
        super(config);
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async makeGraphQLRequest(body, options = {}) {
        try {
            return (0, $uttR1.handleGraphQLRequest)(this.serviceUrl, body, options);
        } catch (error) {
            if (error instanceof (0, $d46SR.GraphQLError)) throw error;
            this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
            throw new (0, $d46SR.DefaultError)({});
        }
    }
}

});
parcelRegister("irfYK", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $51f7dd3c6239d20c$export$4f22f74eddb7716a);

var $3lkCh = parcelRequire("3lkCh");
class $51f7dd3c6239d20c$export$4f22f74eddb7716a {
    constructor(config){
        this.cache = {};
        this.logException = (ex, name, context)=>{
            (0, $3lkCh.logException)(ex, name, context);
            this.config.logException(ex, name, context);
        };
        this.config = config;
        this.context = {
            cloudId: 'None'
        };
    }
    setContext(context) {
        this.context = {
            ...context,
            cloudId: context.cloudId || 'None'
        };
    }
    getContext() {
        return this.context;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getOrgId(localValue) {
        const orgId = localValue || this.getContext().orgId;
        if (!orgId) {
            const err = new Error('No orgId set');
            this.logException(err, 'No orgId set');
            throw err;
        }
        return orgId;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getCloudId(localValue) {
        return localValue || this.getContext().cloudId;
    }
    keyWithContext(key) {
        return `${this.getContext().cloudId}-${this.getContext().orgId ?? 'no-org-id'}-${this.getContext().userId ?? 'no-user-id'}-${key}`;
    }
    // Default expiration is 5 minutes
    cacheValue(key, value, expiryMs = 300000) {
        this.cache[this.keyWithContext(key)] = {
            data: value,
            expiration: Date.now() + expiryMs
        };
    }
    getCachedValue(key) {
        const record = this.cache[this.keyWithContext(key)];
        if (record && record.expiration > Date.now()) return record.data;
        return undefined;
    }
}

});
parcelRegister("3lkCh", function(module, exports) {

$parcel$export(module.exports, "logException", () => $26efa9b4926508ba$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $26efa9b4926508ba$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $26efa9b4926508ba$export$386587bcf05ee8ea);
$parcel$export(module.exports, "logExceptionWithPackageContext", () => $26efa9b4926508ba$export$7208e9272a946c36);
$parcel$export(module.exports, "logErrorMessageWithPackageContext", () => $26efa9b4926508ba$export$dbd2da61a76fb8d2);
$parcel$export(module.exports, "logInfoMessageWithPackageContext", () => $26efa9b4926508ba$export$f242834c5699e597);
$parcel$export(module.exports, "createErrorHandlerWithPackageContext", () => $26efa9b4926508ba$export$6b2a307bf7c6c1dc);
$parcel$export(module.exports, "addBreadcrumb", () => $26efa9b4926508ba$export$efda9a273d7a036d);
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript

var $hpvUu = parcelRequire("hpvUu");
function $26efa9b4926508ba$var$decorateScope(scope, context) {
    const { tags: tags, ...otherContext } = context;
    if (tags) scope.setTags(tags);
    if (Object.keys(otherContext).length) scope.setExtras(otherContext);
    return scope;
}
async function $26efa9b4926508ba$export$f86b2a1a2ce291b3(ex, name, context = {}) {
    try {
        const sentryClient = await (0, $hpvUu.getSentryClient)();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            $26efa9b4926508ba$var$decorateScope(scope, context);
            scope.setTag('name', name);
            scope.setTag('packageName', context.packageName ?? 'unknown');
            scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
            sentryClient.captureException(ex, scope);
        });
    } catch  {
    // silence sentry exceptions
    }
}
async function $26efa9b4926508ba$var$logMessage(severity, message, context = {}) {
    const sentryClient = await (0, $hpvUu.getSentryClient)();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        $26efa9b4926508ba$var$decorateScope(scope, context);
        // The Severity enum is being replaced by SeverityLevel type in v7 anyway
        // @ts-ignore - TypeScript 5.9.2 upgrade
        scope.setLevel(severity);
        scope.setTag('packageName', context.packageName ?? 'unknown');
        scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
        sentryClient.captureMessage(message, scope);
    });
}
function $26efa9b4926508ba$export$ece28f5cfa04608(message, context = {}) {
    $26efa9b4926508ba$var$logMessage('error', message, context).catch(()=>{});
}
function $26efa9b4926508ba$export$386587bcf05ee8ea(message, context = {}) {
    $26efa9b4926508ba$var$logMessage('info', message, context).catch(()=>{});
}
const $26efa9b4926508ba$export$9edc7d6f1c33ddc = (details)=>{
    return (error, message, tags = {})=>{
        $26efa9b4926508ba$export$f86b2a1a2ce291b3(error, message, {
            tags: {
                ...details,
                ...tags
            }
        });
    };
};
const $26efa9b4926508ba$export$7208e9272a946c36 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $26efa9b4926508ba$export$f86b2a1a2ce291b3(args[0], args[1], {
            ...args[2],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $26efa9b4926508ba$export$dbd2da61a76fb8d2 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $26efa9b4926508ba$export$ece28f5cfa04608(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $26efa9b4926508ba$export$f242834c5699e597 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $26efa9b4926508ba$export$386587bcf05ee8ea(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $26efa9b4926508ba$export$6b2a307bf7c6c1dc = (packageContext)=>(...args)=>$26efa9b4926508ba$export$9edc7d6f1c33ddc({
            ...args[0],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
async function $26efa9b4926508ba$export$efda9a273d7a036d(crumb) {
    const sentryClient = await (0, $hpvUu.getSentryClient)();
    sentryClient.withScope((scope)=>{
        // @ts-ignore - TypeScript 5.9.2 upgrade
        scope.addBreadcrumb(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
    });
}

});
parcelRegister("hpvUu", function(module, exports) {

$parcel$export(module.exports, "sentryClient", () => $76e0aa2f411cfa76$export$ac71c212168fcd2b);
$parcel$export(module.exports, "setSentryClient", () => $76e0aa2f411cfa76$export$7d446c6f4e54de82);
$parcel$export(module.exports, "getSentryClient", () => $76e0aa2f411cfa76$export$f553e8b08ef59d31);
$parcel$export(module.exports, "setupSentryClient", () => $76e0aa2f411cfa76$export$d8bd0edf6c978788);

var $hivNF = parcelRequire("hivNF");

var $kDBp2 = parcelRequire("kDBp2");
let $76e0aa2f411cfa76$export$ac71c212168fcd2b;
const $76e0aa2f411cfa76$export$7d446c6f4e54de82 = (client)=>{
    $76e0aa2f411cfa76$export$ac71c212168fcd2b = client;
};
const $76e0aa2f411cfa76$export$f553e8b08ef59d31 = async ()=>{
    if (!$76e0aa2f411cfa76$export$ac71c212168fcd2b) await $76e0aa2f411cfa76$export$d8bd0edf6c978788({});
    return $76e0aa2f411cfa76$export$ac71c212168fcd2b;
};
async function $76e0aa2f411cfa76$export$d8bd0edf6c978788({ appName: appName, env: env }) {
    const sentryClient = await $76e0aa2f411cfa76$var$requireSentryLib();
    if (!sentryClient) return;
    // initialiseSentry sets the sentry client
    (0, $kDBp2.initialiseSentry)(sentryClient, {
        initialScope: {
            tags: {
                renderMode: appName || 'unknown',
                productBuild: // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || 'unknown',
                product: $76e0aa2f411cfa76$var$getProduct()
            }
        },
        env: env,
        noGlobals: true,
        dsn: (0, $hivNF.SENTRY_DSN),
        attachStacktrace: true
    });
}

async function $76e0aa2f411cfa76$var$requireSentryLib() {
    // saving ~40K
    try {
        return (parcelRequire("5KAVR"));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Ignoring rejected promise when loading sentry resource.', error);
    }
}
function $76e0aa2f411cfa76$var$getProduct() {
    const path = window.location.pathname;
    if (path.includes('/jira/people')) return 'jira';
    else if (path.includes('/wiki/people')) return 'confluence';
    return 'unknown';
}

});
parcelRegister("hivNF", function(module, exports) {

$parcel$export(module.exports, "SENTRY_DSN", () => $f4ac6e7caf40be7e$export$6faa4a850bc4d0ce);

var $igNUx = parcelRequire("igNUx");
const $f4ac6e7caf40be7e$export$9cf97fd92bea5d81 = '1dc056d49dfe4df8961dc1b810e4620d';
const $f4ac6e7caf40be7e$export$68c35ed3898e185a = '5988845';
const $f4ac6e7caf40be7e$export$b03be5cdb5af5197 = '067abcc494be9a87b3cdf9416f2b97d5';
const $f4ac6e7caf40be7e$export$97db6664a1e55fa6 = '47';
const $f4ac6e7caf40be7e$var$SENTRY_COMMERCIAL_DSN = `https://${$f4ac6e7caf40be7e$export$9cf97fd92bea5d81}@o55978.ingest.sentry.io/${$f4ac6e7caf40be7e$export$68c35ed3898e185a}`;
const $f4ac6e7caf40be7e$var$SENTRY_FEDRAMP_DSN = `https://${$f4ac6e7caf40be7e$export$b03be5cdb5af5197}@sentry.atlassian-us-gov-mod.com/${$f4ac6e7caf40be7e$export$97db6664a1e55fa6}`;
const $f4ac6e7caf40be7e$export$6faa4a850bc4d0ce = (0, $igNUx.isFedRamp)() ? $f4ac6e7caf40be7e$var$SENTRY_FEDRAMP_DSN : $f4ac6e7caf40be7e$var$SENTRY_COMMERCIAL_DSN;

});

parcelRegister("kDBp2", function(module, exports) {

$parcel$export(module.exports, "initialiseSentry", () => $a31d5f667b63a406$export$357606956af25316);

var $aDFHd = parcelRequire("aDFHd");

var $hpvUu = parcelRequire("hpvUu");
const $a31d5f667b63a406$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
async function $a31d5f667b63a406$export$357606956af25316(client, options) {
    if (0, $hpvUu.sentryClient) return;
    if (!client) return;
    (0, $hpvUu.setSentryClient)(client);
    const sentryConfig = (0, $aDFHd.getSentryConfig)(options);
    (0, $hpvUu.sentryClient).init({
        ...sentryConfig,
        integrations: function(integrations) {
            return integrations.filter(function(integration) {
                return $a31d5f667b63a406$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        }
    });
}

});
parcelRegister("aDFHd", function(module, exports) {

$parcel$export(module.exports, "getSentryConfig", () => $43f27b8ea25ad14b$export$5580e6304e95c792);

var $hivNF = parcelRequire("hivNF");
const $43f27b8ea25ad14b$var$DEFAULT_SENTRY_CONFIG = {
    whitelistUrls: [
        /atl-paas.net/,
        // test local host
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/,
        // Network related errors
        'The operation was aborted',
        'Software caused connection abort',
        'GraphQL error: Failed to fetch',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'AbortError: The user aborted a request.',
        /^network error/i,
        /^network failure/i,
        /^NetworkError/i,
        /^Unexpected token ..*/
    ],
    ignoreUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
    ],
    dsn: (0, $hivNF.SENTRY_DSN),
    attachStacktrace: true
};
function $43f27b8ea25ad14b$export$5580e6304e95c792(options) {
    const { env: env, version: version, noGlobals: _, ...otherOptions } = options;
    return {
        ...otherOptions,
        ...$43f27b8ea25ad14b$var$DEFAULT_SENTRY_CONFIG,
        // Standalone __VERSION__ is set from `bin/set-release-version.sh`
        // when building to deploy to production
        release: `${"platform-pkg"}@${"0.0.0-use.local"}` || // @ts-ignore Jira  - window.BUILD_KEY
        window.BUILD_KEY || // @ts-ignore Confluence - window.__buildInfo
        window.__buildInfo?.FRONTEND_VERSION || '---',
        environment: env || 'prod'
    };
}

});


parcelRegister("5KAVR", function(module, exports) {

let $42fde5979cdd4d7e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $42fde5979cdd4d7e$var$load("eIwLe").then(()=>parcelRequire('gdpA5'));

});




parcelRegister("uttR1", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLRequest", () => $29afcf60d93013f2$export$7feffc86760ee7ce);

var $d46SR = parcelRequire("d46SR");

var $EzOWi = parcelRequire("EzOWi");

var $c3wdd = parcelRequire("c3wdd");
async function $29afcf60d93013f2$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
    const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
    const errorPolicy = options.errorPolicy || 'none';
    const url = serviceUrl + operationNameQuery;
    const request = fetch(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        credentials: 'include',
        body: JSON.stringify(body)
    }).then((res)=>{
        if (res.status < 300 || res.status === 400) return res.json();
        else throw res;
    });
    try {
        const response = await request;
        const errors = response.errors;
        if (errors) {
            if (errorPolicy === 'none') throw (0, $d46SR.GraphQLError).from(errors);
            else if (errorPolicy === 'all') // Set timeout will postpone error throwing and de-touch it to another event loop,
            // so we can return data along with throwing error
            return new Promise((resolve, reject)=>{
                setTimeout(()=>{
                    reject((0, $d46SR.GraphQLError).from(errors));
                }, 0);
            });
        }
        return response.data;
    } catch (error) {
        if (error instanceof Response) return {
            response: error
        };
        if (Object(error).hasOwnProperty('response')) throw error;
        return error;
    }
}
async function $29afcf60d93013f2$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
    const makeGraphQLRequestWithRetries = (0, $EzOWi.withExponentialBackoff)($29afcf60d93013f2$export$93d33e3b46bf00e7, {
        initial: (0, $EzOWi.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
        jitter: (0, $EzOWi.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
        max: (0, $EzOWi.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
        retryIf: (data)=>{
            return (0, $EzOWi.isFetchResponse)(data) && (0, $EzOWi.is5xx)(data.response.status);
        }
    });
    const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
    const response = result?.response;
    if (response) {
        const status = response.status;
        const statusText = response.statusText;
        const traceId = response.headers.get('atl-traceid');
        (0, $c3wdd.handleResponse)(response);
        if (status > 400 && status <= 599) throw new (0, $d46SR.HttpError)({
            message: statusText,
            status: status,
            traceId: traceId ?? undefined
        });
    }
    return result;
}

});
parcelRegister("EzOWi", function(module, exports) {

$parcel$export(module.exports, "EXPONENTIAL_BACKOFF_RETRY_POLICY", () => $71b17d0e3f79b821$export$8f4286bf21155381);
$parcel$export(module.exports, "is5xx", () => $71b17d0e3f79b821$export$55b2fbd5d4a32495);
$parcel$export(module.exports, "isFetchResponse", () => $71b17d0e3f79b821$export$81f27058be86d7ea);
$parcel$export(module.exports, "withExponentialBackoff", () => $71b17d0e3f79b821$export$20eaa22f2295996f);
$parcel$export(module.exports, "fetchWithExponentialBackoff", () => $71b17d0e3f79b821$export$b4c0bf5325504bf3);
const $71b17d0e3f79b821$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $71b17d0e3f79b821$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
function $71b17d0e3f79b821$export$81f27058be86d7ea(data) {
    if (!data || !data.hasOwnProperty('response')) return false;
    return data.response instanceof Response;
}
// tslint:disable-next-line no-any
const $71b17d0e3f79b821$var$defaultRetryIfCallback = (a)=>!a;
const $71b17d0e3f79b821$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $71b17d0e3f79b821$var$defaultRetryIfCallback
};
function $71b17d0e3f79b821$export$20eaa22f2295996f(toTry, hofOptions = $71b17d0e3f79b821$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
const $71b17d0e3f79b821$export$b4c0bf5325504bf3 = $71b17d0e3f79b821$export$20eaa22f2295996f((url, init)=>fetch(url, init), {
    initial: $71b17d0e3f79b821$export$8f4286bf21155381.INITIAL_DELAY,
    jitter: $71b17d0e3f79b821$export$8f4286bf21155381.JITTER,
    max: $71b17d0e3f79b821$export$8f4286bf21155381.MAX_RETRIES,
    retryIf: (response)=>$71b17d0e3f79b821$export$55b2fbd5d4a32495(response.status)
});

});

parcelRegister("c3wdd", function(module, exports) {

$parcel$export(module.exports, "handleResponse", () => $e7ce19aae2d84b78$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $e7ce19aae2d84b78$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $e7ce19aae2d84b78$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $e7ce19aae2d84b78$export$8c005e458e12d501.handlers = handlers;
    }
};
function $e7ce19aae2d84b78$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $e7ce19aae2d84b78$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});



parcelRegister("5qPkg", function(module, exports) {

$parcel$export(module.exports, "TeamHasAgentsQuery", () => $b5fbecb64d4614ea$export$5a63c9c7b444f1f5);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $b5fbecb64d4614ea$export$5a63c9c7b444f1f5 = (0, $6NFTG.print)((0, $kuAvn.default)`
	query serviceName_TeamHasAgentsQuery($id: ID!) {
		graphStore @optIn(to: "GraphStore") {
			teamHasAgents(id: $id) @optIn(to: "GraphStoreTeamHasAgents") {
				edges {
					node {
						... on AppUser {
							id
							name
							picture
						}
					}
					cursor
				}
				pageInfo {
					hasNextPage
					endCursor
				}
			}
		}
	}
`);

});
parcelRegister("6NFTG", function(module, exports) {

$parcel$export(module.exports, "print", () => $4f37d191c0ef7631$export$c2d084dc44961371);

var $9E3xk = parcelRequire("9E3xk");

var $l68uS = parcelRequire("l68uS");
function $4f37d191c0ef7631$export$c2d084dc44961371(ast) {
    return (0, $9E3xk.visit)(ast, {
        leave: $4f37d191c0ef7631$var$printDocASTReducer
    });
}
var $4f37d191c0ef7631$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $4f37d191c0ef7631$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $4f37d191c0ef7631$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(node.variableDefinitions, ', '), ')');
        var directives = $4f37d191c0ef7631$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $4f37d191c0ef7631$var$join([
            op,
            $4f37d191c0ef7631$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $4f37d191c0ef7631$var$wrap(' = ', defaultValue) + $4f37d191c0ef7631$var$wrap(' ', $4f37d191c0ef7631$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $4f37d191c0ef7631$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $4f37d191c0ef7631$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')');
        if (argsLine.length > $4f37d191c0ef7631$var$MAX_LINE_LENGTH) argsLine = prefix + $4f37d191c0ef7631$var$wrap('(\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(args, '\n')), '\n)');
        return $4f37d191c0ef7631$var$join([
            argsLine,
            $4f37d191c0ef7631$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $4f37d191c0ef7631$var$wrap(' ', $4f37d191c0ef7631$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $4f37d191c0ef7631$var$join([
            '...',
            $4f37d191c0ef7631$var$wrap('on ', typeCondition),
            $4f37d191c0ef7631$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($4f37d191c0ef7631$var$wrap('', $4f37d191c0ef7631$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $l68uS.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $4f37d191c0ef7631$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $4f37d191c0ef7631$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $4f37d191c0ef7631$var$join([
            'schema',
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $4f37d191c0ef7631$var$join([
            'scalar',
            name,
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $4f37d191c0ef7631$var$join([
            'type',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($4f37d191c0ef7631$var$hasMultilineItems(args) ? $4f37d191c0ef7631$var$wrap('(\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(args, '\n')), '\n)') : $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')')) + ': ' + type + $4f37d191c0ef7631$var$wrap(' ', $4f37d191c0ef7631$var$join(directives, ' '));
    }),
    InputValueDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $4f37d191c0ef7631$var$join([
            name + ': ' + type,
            $4f37d191c0ef7631$var$wrap('= ', defaultValue),
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $4f37d191c0ef7631$var$join([
            'interface',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $4f37d191c0ef7631$var$join([
            'union',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $4f37d191c0ef7631$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $4f37d191c0ef7631$var$join([
            'enum',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $4f37d191c0ef7631$var$join([
            name,
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $4f37d191c0ef7631$var$join([
            'input',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $4f37d191c0ef7631$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($4f37d191c0ef7631$var$hasMultilineItems(args) ? $4f37d191c0ef7631$var$wrap('(\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(args, '\n')), '\n)') : $4f37d191c0ef7631$var$wrap('(', $4f37d191c0ef7631$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $4f37d191c0ef7631$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $4f37d191c0ef7631$var$join([
            'extend schema',
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $4f37d191c0ef7631$var$join([
            'extend scalar',
            name,
            $4f37d191c0ef7631$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $4f37d191c0ef7631$var$join([
            'extend type',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $4f37d191c0ef7631$var$join([
            'extend interface',
            name,
            $4f37d191c0ef7631$var$wrap('implements ', $4f37d191c0ef7631$var$join(interfaces, ' & ')),
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $4f37d191c0ef7631$var$join([
            'extend union',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $4f37d191c0ef7631$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $4f37d191c0ef7631$var$join([
            'extend enum',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $4f37d191c0ef7631$var$join([
            'extend input',
            name,
            $4f37d191c0ef7631$var$join(directives, ' '),
            $4f37d191c0ef7631$var$block(fields)
        ], ' ');
    }
};
function $4f37d191c0ef7631$var$addDescription(cb) {
    return function(node) {
        return $4f37d191c0ef7631$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $4f37d191c0ef7631$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $4f37d191c0ef7631$var$block(array) {
    return $4f37d191c0ef7631$var$wrap('{\n', $4f37d191c0ef7631$var$indent($4f37d191c0ef7631$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $4f37d191c0ef7631$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $4f37d191c0ef7631$var$indent(str) {
    return $4f37d191c0ef7631$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $4f37d191c0ef7631$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $4f37d191c0ef7631$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($4f37d191c0ef7631$var$isMultiline);
}

});
parcelRegister("9E3xk", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $705a97c9b44c8772$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $705a97c9b44c8772$export$bf638b60ea8b89b7);
$parcel$export(module.exports, "getVisitFn", () => $705a97c9b44c8772$export$c9c25cca74db6e70);
$parcel$export(module.exports, "visitInParallel", () => $705a97c9b44c8772$export$728beebeea393478);

var $4QE9P = parcelRequire("4QE9P");

var $19BqA = parcelRequire("19BqA");
var $705a97c9b44c8772$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $705a97c9b44c8772$export$a89c95c098ac2a58 = Object.freeze({});
function $705a97c9b44c8772$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $705a97c9b44c8772$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $19BqA.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $4QE9P.default)(node), "."));
            var visitFn = $705a97c9b44c8772$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $705a97c9b44c8772$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $19BqA.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $705a97c9b44c8772$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $705a97c9b44c8772$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $705a97c9b44c8772$export$a89c95c098ac2a58) skipping[i] = $705a97c9b44c8772$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $705a97c9b44c8772$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $705a97c9b44c8772$export$a89c95c098ac2a58) skipping[i] = $705a97c9b44c8772$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $705a97c9b44c8772$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("4QE9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $387b2b38bb5e6d4b$export$2e2bcd8739ae039);

var $e5Dlp = parcelRequire("e5Dlp");
function $387b2b38bb5e6d4b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $387b2b38bb5e6d4b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $387b2b38bb5e6d4b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $387b2b38bb5e6d4b$var$_typeof(obj);
}
var $387b2b38bb5e6d4b$var$MAX_ARRAY_LENGTH = 10;
var $387b2b38bb5e6d4b$var$MAX_RECURSIVE_DEPTH = 2;
function $387b2b38bb5e6d4b$export$2e2bcd8739ae039(value) {
    return $387b2b38bb5e6d4b$var$formatValue(value, []);
}
function $387b2b38bb5e6d4b$var$formatValue(value, seenValues) {
    switch($387b2b38bb5e6d4b$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $387b2b38bb5e6d4b$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $387b2b38bb5e6d4b$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $387b2b38bb5e6d4b$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $387b2b38bb5e6d4b$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $387b2b38bb5e6d4b$var$formatArray(value, seenValues);
    return $387b2b38bb5e6d4b$var$formatObject(value, seenValues);
}
function $387b2b38bb5e6d4b$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $387b2b38bb5e6d4b$var$MAX_RECURSIVE_DEPTH) return '[' + $387b2b38bb5e6d4b$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $387b2b38bb5e6d4b$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $387b2b38bb5e6d4b$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $387b2b38bb5e6d4b$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($387b2b38bb5e6d4b$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($387b2b38bb5e6d4b$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $387b2b38bb5e6d4b$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $e5Dlp.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $387b2b38bb5e6d4b$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("e5Dlp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4200d41543ce842$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $a4200d41543ce842$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $a4200d41543ce842$export$2e2bcd8739ae039 = $a4200d41543ce842$var$nodejsCustomInspectSymbol;

});


parcelRegister("19BqA", function(module, exports) {

$parcel$export(module.exports, "Location", () => $0d73aa1a6bd3d4cf$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $0d73aa1a6bd3d4cf$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $0d73aa1a6bd3d4cf$export$8ee0fc9ee280b4ee);

var $k3Xa1 = parcelRequire("k3Xa1");
var $0d73aa1a6bd3d4cf$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $k3Xa1.default)($0d73aa1a6bd3d4cf$export$18a2be9195644f38);
var $0d73aa1a6bd3d4cf$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $k3Xa1.default)($0d73aa1a6bd3d4cf$export$50792b0e93539fde);
function $0d73aa1a6bd3d4cf$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("k3Xa1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9b1fa842852583f$export$2e2bcd8739ae039);

var $8oZnC = parcelRequire("8oZnC");

var $e5Dlp = parcelRequire("e5Dlp");
function $e9b1fa842852583f$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $8oZnC.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $e5Dlp.default) classObject.prototype[0, $e5Dlp.default] = fn;
}

});
parcelRegister("8oZnC", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e02d6059f2aabe$export$2e2bcd8739ae039);
function $61e02d6059f2aabe$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("l68uS", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $f5c0bfd4ee7d8292$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $f5c0bfd4ee7d8292$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $f5c0bfd4ee7d8292$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $f5c0bfd4ee7d8292$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $f5c0bfd4ee7d8292$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $f5c0bfd4ee7d8292$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $f5c0bfd4ee7d8292$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $f5c0bfd4ee7d8292$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $f5c0bfd4ee7d8292$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});


parcelRegister("kuAvn", function(module, exports) {

$parcel$export(module.exports, "gql", () => $eeb2ed1fa1f7c351$export$72e4926bf8358653);
$parcel$export(module.exports, "default", () => $eeb2ed1fa1f7c351$export$2e2bcd8739ae039);

var $dnskZ = parcelRequire("dnskZ");

var $f6P3g = parcelRequire("f6P3g");
var $eeb2ed1fa1f7c351$var$docCache = new Map();
var $eeb2ed1fa1f7c351$var$fragmentSourceMap = new Map();
var $eeb2ed1fa1f7c351$var$printFragmentWarnings = true;
var $eeb2ed1fa1f7c351$var$experimentalFragmentVariables = false;
function $eeb2ed1fa1f7c351$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $eeb2ed1fa1f7c351$var$cacheKeyFromLoc(loc) {
    return $eeb2ed1fa1f7c351$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $eeb2ed1fa1f7c351$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $eeb2ed1fa1f7c351$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $eeb2ed1fa1f7c351$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($eeb2ed1fa1f7c351$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $eeb2ed1fa1f7c351$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, ast), {
        definitions: definitions
    });
}
function $eeb2ed1fa1f7c351$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $eeb2ed1fa1f7c351$var$parseDocument(source) {
    var cacheKey = $eeb2ed1fa1f7c351$var$normalize(source);
    if (!$eeb2ed1fa1f7c351$var$docCache.has(cacheKey)) {
        var parsed = (0, $f6P3g.parse)(source, {
            experimentalFragmentVariables: $eeb2ed1fa1f7c351$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $eeb2ed1fa1f7c351$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $eeb2ed1fa1f7c351$var$docCache.set(cacheKey, $eeb2ed1fa1f7c351$var$stripLoc($eeb2ed1fa1f7c351$var$processFragments(parsed)));
    }
    return $eeb2ed1fa1f7c351$var$docCache.get(cacheKey);
}
function $eeb2ed1fa1f7c351$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $eeb2ed1fa1f7c351$var$parseDocument(result);
}
function $eeb2ed1fa1f7c351$export$657554ef4dc7ac2d() {
    $eeb2ed1fa1f7c351$var$docCache.clear();
    $eeb2ed1fa1f7c351$var$fragmentSourceMap.clear();
}
function $eeb2ed1fa1f7c351$export$e4294e638636c6ab() {
    $eeb2ed1fa1f7c351$var$printFragmentWarnings = false;
}
function $eeb2ed1fa1f7c351$export$78cf889af350c840() {
    $eeb2ed1fa1f7c351$var$experimentalFragmentVariables = true;
}
function $eeb2ed1fa1f7c351$export$5290df9bbbd3cfa() {
    $eeb2ed1fa1f7c351$var$experimentalFragmentVariables = false;
}
var $eeb2ed1fa1f7c351$var$extras = {
    gql: $eeb2ed1fa1f7c351$export$72e4926bf8358653,
    resetCaches: $eeb2ed1fa1f7c351$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $eeb2ed1fa1f7c351$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $eeb2ed1fa1f7c351$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $eeb2ed1fa1f7c351$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $eeb2ed1fa1f7c351$var$extras.gql, gql_1.resetCaches = $eeb2ed1fa1f7c351$var$extras.resetCaches, gql_1.disableFragmentWarnings = $eeb2ed1fa1f7c351$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $eeb2ed1fa1f7c351$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $eeb2ed1fa1f7c351$var$extras.disableExperimentalFragmentVariables;
})($eeb2ed1fa1f7c351$export$72e4926bf8358653 || ($eeb2ed1fa1f7c351$export$72e4926bf8358653 = {}));
$eeb2ed1fa1f7c351$export$72e4926bf8358653["default"] = $eeb2ed1fa1f7c351$export$72e4926bf8358653;
var $eeb2ed1fa1f7c351$export$2e2bcd8739ae039 = $eeb2ed1fa1f7c351$export$72e4926bf8358653;

});
parcelRegister("f6P3g", function(module, exports) {

$parcel$export(module.exports, "parse", () => $afff0452d66d5631$export$98e6a39c04603d36);

var $iZFMu = parcelRequire("iZFMu");

var $4oHdA = parcelRequire("4oHdA");

var $19BqA = parcelRequire("19BqA");

var $ePiKI = parcelRequire("ePiKI");

var $6dDiC = parcelRequire("6dDiC");

var $4nWzJ = parcelRequire("4nWzJ");

var $6XgSE = parcelRequire("6XgSE");
function $afff0452d66d5631$export$98e6a39c04603d36(source, options) {
    var parser = new $afff0452d66d5631$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $afff0452d66d5631$export$5303528d1070ff6f(source, options) {
    var parser = new $afff0452d66d5631$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ePiKI.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $ePiKI.TokenKind).EOF);
    return value;
}
function $afff0452d66d5631$export$28b8f402ccc88182(source, options) {
    var parser = new $afff0452d66d5631$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ePiKI.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $ePiKI.TokenKind).EOF);
    return type;
}
var $afff0452d66d5631$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $6dDiC.isSource)(source) ? source : new (0, $6dDiC.Source)(source);
        this._lexer = new (0, $6XgSE.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $ePiKI.TokenKind).NAME);
        return {
            kind: (0, $4oHdA.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).DOCUMENT,
            definitions: this.many((0, $ePiKI.TokenKind).SOF, this.parseDefinition, (0, $ePiKI.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $ePiKI.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $ePiKI.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $ePiKI.TokenKind).BRACE_L)) return {
            kind: (0, $4oHdA.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $ePiKI.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $4oHdA.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $ePiKI.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $ePiKI.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $ePiKI.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $ePiKI.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $ePiKI.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $ePiKI.TokenKind).DOLLAR);
        return {
            kind: (0, $4oHdA.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).SELECTION_SET,
            selections: this.many((0, $ePiKI.TokenKind).BRACE_L, this.parseSelection, (0, $ePiKI.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $ePiKI.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $4oHdA.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $ePiKI.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $ePiKI.TokenKind).PAREN_L, item, (0, $ePiKI.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        return {
            kind: (0, $4oHdA.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $ePiKI.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $ePiKI.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $ePiKI.TokenKind).NAME)) return {
            kind: (0, $4oHdA.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $4oHdA.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $4oHdA.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $4oHdA.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $ePiKI.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $ePiKI.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $ePiKI.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $4oHdA.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $ePiKI.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $4oHdA.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $ePiKI.TokenKind).STRING:
            case (0, $ePiKI.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $ePiKI.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $4oHdA.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $4oHdA.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $4oHdA.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $4oHdA.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $ePiKI.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $4oHdA.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $ePiKI.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $4oHdA.Kind).LIST,
            values: this.any((0, $ePiKI.TokenKind).BRACKET_L, item, (0, $ePiKI.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $4oHdA.Kind).OBJECT,
            fields: this.any((0, $ePiKI.TokenKind).BRACE_L, item, (0, $ePiKI.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        return {
            kind: (0, $4oHdA.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $ePiKI.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $ePiKI.TokenKind).AT);
        return {
            kind: (0, $4oHdA.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $ePiKI.TokenKind).BRACKET_R);
            type = {
                kind: (0, $4oHdA.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).BANG)) return {
            kind: (0, $4oHdA.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $4oHdA.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $ePiKI.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $ePiKI.TokenKind).STRING) || this.peek((0, $ePiKI.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $ePiKI.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $ePiKI.TokenKind).BRACE_R);
        return {
            kind: (0, $4oHdA.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $4oHdA.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $4oHdA.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $ePiKI.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $ePiKI.TokenKind).AMP) || this.peek((0, $ePiKI.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $ePiKI.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $ePiKI.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $ePiKI.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $ePiKI.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $ePiKI.TokenKind).PAREN_L, this.parseInputValueDef, (0, $ePiKI.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $ePiKI.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $ePiKI.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $4oHdA.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $4oHdA.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $ePiKI.TokenKind).EQUALS) ? this.delimitedMany((0, $ePiKI.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $4oHdA.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $ePiKI.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $4oHdA.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $4oHdA.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseInputValueDef, (0, $ePiKI.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $ePiKI.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $ePiKI.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $ePiKI.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $4oHdA.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $ePiKI.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $4oHdA.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $ePiKI.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $4nWzJ.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $19BqA.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $iZFMu.syntaxError)(this._lexer.source, token.start, "Expected ".concat($afff0452d66d5631$var$getTokenKindDesc(kind), ", found ").concat($afff0452d66d5631$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $ePiKI.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $iZFMu.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($afff0452d66d5631$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $ePiKI.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $iZFMu.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($afff0452d66d5631$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $afff0452d66d5631$var$getTokenDesc(token) {
    var value = token.value;
    return $afff0452d66d5631$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $afff0452d66d5631$var$getTokenKindDesc(kind) {
    return (0, $6XgSE.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("iZFMu", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $dd3e555a07a61943$export$bbee0c6176c019d4);

var $eXc8C = parcelRequire("eXc8C");
function $dd3e555a07a61943$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $eXc8C.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("eXc8C", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $ae2ffdc10628e3fd$export$92d6ed0888e7cb7f);

var $fjX8u = parcelRequire("fjX8u");

var $j38tO = parcelRequire("j38tO");

var $3iKxr = parcelRequire("3iKxr");

var $hD37S = parcelRequire("hD37S");

var $1TwT7 = parcelRequire("1TwT7");
function $ae2ffdc10628e3fd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ae2ffdc10628e3fd$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ae2ffdc10628e3fd$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ae2ffdc10628e3fd$var$_typeof(obj);
}
function $ae2ffdc10628e3fd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ae2ffdc10628e3fd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ae2ffdc10628e3fd$var$ownKeys(Object(source), true).forEach(function(key) {
            $ae2ffdc10628e3fd$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ae2ffdc10628e3fd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ae2ffdc10628e3fd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ae2ffdc10628e3fd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ae2ffdc10628e3fd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ae2ffdc10628e3fd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ae2ffdc10628e3fd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ae2ffdc10628e3fd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ae2ffdc10628e3fd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ae2ffdc10628e3fd$var$_setPrototypeOf(subClass, superClass);
}
function $ae2ffdc10628e3fd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ae2ffdc10628e3fd$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ae2ffdc10628e3fd$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ae2ffdc10628e3fd$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ae2ffdc10628e3fd$var$_possibleConstructorReturn(this, result);
    };
}
function $ae2ffdc10628e3fd$var$_possibleConstructorReturn(self, call) {
    if (call && ($ae2ffdc10628e3fd$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $ae2ffdc10628e3fd$var$_assertThisInitialized(self);
}
function $ae2ffdc10628e3fd$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ae2ffdc10628e3fd$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $ae2ffdc10628e3fd$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$ae2ffdc10628e3fd$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $ae2ffdc10628e3fd$var$_construct(Class, arguments, $ae2ffdc10628e3fd$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $ae2ffdc10628e3fd$var$_setPrototypeOf(Wrapper, Class);
    };
    return $ae2ffdc10628e3fd$var$_wrapNativeSuper(Class);
}
function $ae2ffdc10628e3fd$var$_construct(Parent, args, Class) {
    if ($ae2ffdc10628e3fd$var$_isNativeReflectConstruct()) $ae2ffdc10628e3fd$var$_construct = Reflect.construct;
    else $ae2ffdc10628e3fd$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $ae2ffdc10628e3fd$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $ae2ffdc10628e3fd$var$_construct.apply(null, arguments);
}
function $ae2ffdc10628e3fd$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ae2ffdc10628e3fd$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $ae2ffdc10628e3fd$var$_setPrototypeOf(o, p) {
    $ae2ffdc10628e3fd$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ae2ffdc10628e3fd$var$_setPrototypeOf(o, p);
}
function $ae2ffdc10628e3fd$var$_getPrototypeOf(o) {
    $ae2ffdc10628e3fd$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ae2ffdc10628e3fd$var$_getPrototypeOf(o);
}
var $ae2ffdc10628e3fd$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $ae2ffdc10628e3fd$var$_inherits(GraphQLError, _Error);
    var _super = $ae2ffdc10628e3fd$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $ae2ffdc10628e3fd$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $ae2ffdc10628e3fd$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $ae2ffdc10628e3fd$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $hD37S.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $hD37S.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $j38tO.default)(originalExtensions)) _this.extensions = $ae2ffdc10628e3fd$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $ae2ffdc10628e3fd$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($ae2ffdc10628e3fd$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $ae2ffdc10628e3fd$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $ae2ffdc10628e3fd$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $ae2ffdc10628e3fd$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $3iKxr.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $ae2ffdc10628e3fd$var$_wrapNativeSuper(Error));
function $ae2ffdc10628e3fd$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $ae2ffdc10628e3fd$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $1TwT7.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $1TwT7.printSourceLocation)(error.source, location);
    }
    return output;
}
function $ae2ffdc10628e3fd$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $fjX8u.default)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 

});
parcelRegister("fjX8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2768086a269b262$export$2e2bcd8739ae039);
function $b2768086a269b262$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("j38tO", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde4e0129ad4f4db$export$2e2bcd8739ae039);
function $dde4e0129ad4f4db$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $dde4e0129ad4f4db$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $dde4e0129ad4f4db$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dde4e0129ad4f4db$var$_typeof(obj);
}
function $dde4e0129ad4f4db$export$2e2bcd8739ae039(value) {
    return $dde4e0129ad4f4db$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("3iKxr", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_ITERATOR", () => $2677271cc8cb2427$export$f6cdee3c26d6da57);
$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $2677271cc8cb2427$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $2677271cc8cb2427$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $2677271cc8cb2427$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $2677271cc8cb2427$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("hD37S", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $cd5880f6ab51819f$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $cd5880f6ab51819f$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("1TwT7", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $1614705cd80bb521$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $1614705cd80bb521$export$867940333fd9f869);

var $hD37S = parcelRequire("hD37S");
function $1614705cd80bb521$export$96a9681e539deed(location) {
    return $1614705cd80bb521$export$867940333fd9f869(location.source, (0, $hD37S.getLocation)(location.source, location.start));
}
function $1614705cd80bb521$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $1614705cd80bb521$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $1614705cd80bb521$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $1614705cd80bb521$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $1614705cd80bb521$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $1614705cd80bb521$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $1614705cd80bb521$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $1614705cd80bb521$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $1614705cd80bb521$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $1614705cd80bb521$var$leftPad(len, str) {
    return $1614705cd80bb521$var$whitespace(len - str.length) + str;
}

});



parcelRegister("4oHdA", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $333aed883d7e11f5$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $333aed883d7e11f5$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("ePiKI", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $acb45ff744d0f320$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $acb45ff744d0f320$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("6dDiC", function(module, exports) {

$parcel$export(module.exports, "Source", () => $487270f96a0f45cd$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $487270f96a0f45cd$export$75135ee9ed6e435b);

var $3iKxr = parcelRequire("3iKxr");

var $4QE9P = parcelRequire("4QE9P");

var $fjX8u = parcelRequire("fjX8u");

var $9kbnx = parcelRequire("9kbnx");
function $487270f96a0f45cd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $487270f96a0f45cd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $487270f96a0f45cd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $487270f96a0f45cd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $487270f96a0f45cd$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $fjX8u.default)(0, "Body must be a string. Received: ".concat((0, $4QE9P.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $fjX8u.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $fjX8u.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $487270f96a0f45cd$var$_createClass(Source, [
        {
            key: (0, $3iKxr.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $487270f96a0f45cd$export$75135ee9ed6e435b(source) {
    return (0, $9kbnx.default)(source, $487270f96a0f45cd$export$1d2df86270c81ecb);
}

});
parcelRegister("9kbnx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c9ecedfbfa67ab7$export$2e2bcd8739ae039);

function $6c9ecedfbfa67ab7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6c9ecedfbfa67ab7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6c9ecedfbfa67ab7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6c9ecedfbfa67ab7$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$6c9ecedfbfa67ab7$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("4nWzJ", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $3316bf4202cd07db$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $3316bf4202cd07db$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("6XgSE", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $510558e4af143ea3$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $510558e4af143ea3$export$59ac0f4da287406a);

var $iZFMu = parcelRequire("iZFMu");

var $19BqA = parcelRequire("19BqA");

var $ePiKI = parcelRequire("ePiKI");

var $l68uS = parcelRequire("l68uS");
var $510558e4af143ea3$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $19BqA.Token)((0, $ePiKI.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $ePiKI.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $510558e4af143ea3$var$readToken(this, token);
        }while (token.kind === (0, $ePiKI.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $510558e4af143ea3$export$59ac0f4da287406a(kind) {
    return kind === (0, $ePiKI.TokenKind).BANG || kind === (0, $ePiKI.TokenKind).DOLLAR || kind === (0, $ePiKI.TokenKind).AMP || kind === (0, $ePiKI.TokenKind).PAREN_L || kind === (0, $ePiKI.TokenKind).PAREN_R || kind === (0, $ePiKI.TokenKind).SPREAD || kind === (0, $ePiKI.TokenKind).COLON || kind === (0, $ePiKI.TokenKind).EQUALS || kind === (0, $ePiKI.TokenKind).AT || kind === (0, $ePiKI.TokenKind).BRACKET_L || kind === (0, $ePiKI.TokenKind).BRACKET_R || kind === (0, $ePiKI.TokenKind).BRACE_L || kind === (0, $ePiKI.TokenKind).PIPE || kind === (0, $ePiKI.TokenKind).BRACE_R;
}
function $510558e4af143ea3$var$printCharCode(code) {
    return isNaN(code) ? (0, $ePiKI.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $510558e4af143ea3$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $510558e4af143ea3$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $510558e4af143ea3$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $510558e4af143ea3$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $510558e4af143ea3$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $510558e4af143ea3$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $iZFMu.syntaxError)(source, pos, $510558e4af143ea3$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $510558e4af143ea3$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($510558e4af143ea3$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($510558e4af143ea3$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $510558e4af143ea3$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $510558e4af143ea3$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $iZFMu.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
    } else {
        position = $510558e4af143ea3$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $510558e4af143ea3$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $510558e4af143ea3$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $510558e4af143ea3$var$isNameStart(code)) throw (0, $iZFMu.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
    return new (0, $19BqA.Token)(isFloat ? (0, $ePiKI.TokenKind).FLOAT : (0, $ePiKI.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $510558e4af143ea3$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $iZFMu.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $510558e4af143ea3$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $iZFMu.syntaxError)(source, position, "Invalid character within String: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $510558e4af143ea3$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $iZFMu.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $iZFMu.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $iZFMu.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $510558e4af143ea3$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $l68uS.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $iZFMu.syntaxError)(source, position, "Invalid character within String: ".concat($510558e4af143ea3$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $iZFMu.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $510558e4af143ea3$var$uniCharCode(a, b, c, d) {
    return $510558e4af143ea3$var$char2hex(a) << 12 | $510558e4af143ea3$var$char2hex(b) << 8 | $510558e4af143ea3$var$char2hex(c) << 4 | $510558e4af143ea3$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $510558e4af143ea3$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $510558e4af143ea3$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $19BqA.Token)((0, $ePiKI.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $510558e4af143ea3$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});




parcelRegister("cQT1T", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0247fb40c647fe$export$2e2bcd8739ae039);
const $0c0247fb40c647fe$var$TeamMembershipQuery = `query app_user_characteristics($teamId: ID!, $siteId: String!, $membershipState: [TeamMembershipState!]!, $first: Int!, $after: String) {
    team {
      teamV2(
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        members(state: $membershipState, first: $first, after: $after) {
          edges {
            node {
              member {
                id
                name
                picture
                accountStatus
                ... on AtlassianAccountUser {
                  extendedProfile {
                    jobTitle
                  }
                }
                ... on AppUser {
                  appType
                }
              }
              role
              state
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }`;
var $0c0247fb40c647fe$export$2e2bcd8739ae039 = $0c0247fb40c647fe$var$TeamMembershipQuery;

});

parcelRegister("ekWDk", function(module, exports) {

$parcel$export(module.exports, "TeamsUserQuery", () => $a4932a27ca8acdaf$export$9963ed3cbf7b791c);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $a4932a27ca8acdaf$export$9963ed3cbf7b791c = (0, $6NFTG.print)((0, $kuAvn.default)`
	query TeamsUserQuery($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				locale
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					department
					location
					phoneNumbers {
						type
						value
					}
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				locale
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`);

});

parcelRegister("gC0Mm", function(module, exports) {

$parcel$export(module.exports, "toUserType", () => $521dd2deb1072eda$export$6b53fef091c7e27d);
function $521dd2deb1072eda$export$6b53fef091c7e27d({ isBot: isBot, appType: appType }) {
    // Note, the order of these checks is important
    if (appType?.toLocaleLowerCase() === 'agent') return 'agent';
    if (isBot) return 'bot';
    return 'user';
}

});


parcelRegister("eh7bW", function(module, exports) {

$parcel$export(module.exports, "default", () => $25b2fec9c33df014$export$2e2bcd8739ae039);

var $3wIxr = parcelRequire("3wIxr");

var $7thXS = parcelRequire("7thXS");
var $25b2fec9c33df014$var$CONTAINER_TYPE = /*#__PURE__*/ function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CONTAINER_TYPE;
}($25b2fec9c33df014$var$CONTAINER_TYPE || {});
var $25b2fec9c33df014$var$ENTITY_TYPE = /*#__PURE__*/ function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
    return ENTITY_TYPE;
}($25b2fec9c33df014$var$ENTITY_TYPE || {});
class $25b2fec9c33df014$export$cd5b4a06db0ea4e2 extends (0, $7thXS.RestClient) {
    getUserContainers({ userId: userId, principalId: principalId, siteId: siteId, sessionId: sessionId, maxNumberOfResults: maxNumberOfResults }) {
        return this.postResource('/v1/collaborationgraph/user/container', {
            context: {
                contextType: 'atlassianDirectory',
                principalId: principalId,
                siteId: siteId,
                sessionId: sessionId
            },
            containerTypes: [
                'confluenceSpace',
                'jiraProject'
            ],
            maxNumberOfResults: maxNumberOfResults,
            userId: userId,
            expanded: true
        });
    }
}
var $25b2fec9c33df014$export$2e2bcd8739ae039 = new $25b2fec9c33df014$export$cd5b4a06db0ea4e2({
    serviceUrl: (0, $3wIxr.DEFAULT_CONFIG).collaborationGraphUrl
});

});
parcelRegister("7thXS", function(module, exports) {

$parcel$export(module.exports, "RestClient", () => $37a127043e5667cc$export$ea8b5b3aea9558ce);

var $bx11l = parcelRequire("bx11l");

var $d46SR = parcelRequire("d46SR");

var $EzOWi = parcelRequire("EzOWi");

var $c3wdd = parcelRequire("c3wdd");

var $irfYK = parcelRequire("irfYK");

var $13PFg = parcelRequire("13PFg");

var $a52e0 = parcelRequire("a52e0");

var $ghhaM = parcelRequire("ghhaM");

var $3QG0g = parcelRequire("3QG0g");
const $37a127043e5667cc$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
let $37a127043e5667cc$var$incrementRedirectCount;
let $37a127043e5667cc$var$clearRedirectCount;
$37a127043e5667cc$export$7a0fc52d8c359feb();
function $37a127043e5667cc$export$7a0fc52d8c359feb() {
    $37a127043e5667cc$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bx11l)))(()=>(0, $13PFg.setCookie)((0, $13PFg.REDIRECT_COUNT), (0, $13PFg.getCookieAsInteger)((0, $13PFg.REDIRECT_COUNT)) + 1));
    $37a127043e5667cc$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bx11l)))(()=>(0, $13PFg.clearCookie)((0, $13PFg.REDIRECT_COUNT)));
}
class $37a127043e5667cc$export$ea8b5b3aea9558ce extends (0, $irfYK.BaseClient) {
    constructor({ serviceUrl: serviceUrl = '', config: config = {
        logException: ()=>{}
    } }){
        super(config), /**
	 * This function is necessary for if `statusCodeHandler` prescribes a login
	 * redirect upon a 401 response.
	 * While the default redirect behaviour may be overriden, this function has
	 * been kept separate to ensure it cannot be overriden, lest a host
	 * application supply embeddable-directory with a custom handler that suffers
	 * the infinite redirect bug.
	 */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $37a127043e5667cc$var$incrementRedirectCount();
            } else $37a127043e5667cc$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async getResource(path, fetchOptions = {}) {
        return this.makeRequest(path, fetchOptions);
    }
    async getResourceCached(path, fetchOptions = {}, cacheOptions) {
        const cacheKey = path;
        const cacheRecord = this.getCachedValue(cacheKey);
        if (cacheRecord) return cacheRecord;
        const response = await this.getResource(path, fetchOptions);
        this.cacheValue(cacheKey, response, cacheOptions?.expiration);
        return response;
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
			 * PATCH must be uppercase as per fetch spec only
			 * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
			 * are normalised to uppercase.
			 *
			 * https://github.com/github/fetch/issues/37
			 * https://fetch.spec.whatwg.org/#methods
			 */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {
        shouldLogError: (e)=>e.status !== 429
    }) {
        const url = this.serviceUrl + path;
        const options = {
            ...$37a127043e5667cc$var$defaultFetchOptions,
            ...additionalFetchOptions
        };
        const response = await (0, $EzOWi.fetchWithExponentialBackoff)(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $c3wdd.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $d46SR.SLOIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await (0, $a52e0.parseErrorMessage)(response);
                const httpError = new (0, $d46SR.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined,
                    path: path
                });
                if (options.shouldLogError && options.shouldLogError(httpError)) this.logException(httpError, (0, $3QG0g.stripUUIDFromPath)(path), {
                    method: options.method || 'GET',
                    url: url,
                    status: responseStatusCode
                });
                throw httpError;
            }
        }
        // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
        return additionalFetchOptions.ignoreResponse ? null : (0, $ghhaM.parseResponse)(response);
    }
}

});
parcelRegister("13PFg", function(module, exports) {

$parcel$export(module.exports, "REDIRECT_COUNT", () => $13a9736632883eef$export$f6101897f0230549);
$parcel$export(module.exports, "setCookie", () => $13a9736632883eef$export$110700823644f4a6);
$parcel$export(module.exports, "getCookieAsInteger", () => $13a9736632883eef$export$6a289e5003f59269);
$parcel$export(module.exports, "clearCookie", () => $13a9736632883eef$export$ad3506281d5a5e5d);
const $13a9736632883eef$export$f6101897f0230549 = 'redirectCount';
const $13a9736632883eef$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $13a9736632883eef$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $13a9736632883eef$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $13a9736632883eef$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});

parcelRegister("a52e0", function(module, exports) {

$parcel$export(module.exports, "parseErrorMessage", () => $a671220cb8ac5833$export$91c32f1b22d29b2d);
async function $a671220cb8ac5833$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.error) return `${json.status || 'UNKNOWN_STATUS'} ${json.error || 'MISSING_ERROR_MESSAGE'}`;
    else if (json.status) return `${json.status} MISSING_ERROR_MESSAGE`;
    else if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || 'MISSING_ERROR_MESSAGE');
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}

});

parcelRegister("ghhaM", function(module, exports) {

$parcel$export(module.exports, "parseResponse", () => $de5cf538dc078fb5$export$ba14d9a5a581e827);
function $de5cf538dc078fb5$export$ba14d9a5a581e827(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}

});

parcelRegister("3QG0g", function(module, exports) {

$parcel$export(module.exports, "stripUUIDFromPath", () => $6f45aafbb67e4a9c$export$6bd073e2c6dda996);
const $6f45aafbb67e4a9c$var$UUID_REGEX = new RegExp(/((\w{4,12}-?)){5}/g);
const $6f45aafbb67e4a9c$export$6bd073e2c6dda996 = (path)=>{
    return path.replace($6f45aafbb67e4a9c$var$UUID_REGEX, '<UUID>');
};

});



parcelRegister("5OnvN", function(module, exports) {

$parcel$export(module.exports, "directoryClient", () => $f6e4ce9aa2cd9e58$export$ead519165de472de);

var $3wIxr = parcelRequire("3wIxr");

var $b0tIZ = parcelRequire("b0tIZ");

var $3lkCh = parcelRequire("3lkCh");
const $f6e4ce9aa2cd9e58$export$28456d095a642fd = 'internal.browse-users-allowed';
const $f6e4ce9aa2cd9e58$var$buildTeamMembershipQuery = (teamId, membershipState)=>({
        query: `query TeamMembership($teamId: String!, $membershipState: [TeamMembershipStatus]) {
    TeamMembership: TeamMembership(teamId: $teamId, membershipStates: $membershipState) {
      user: profile {
        id,
        fullName,
        title,
        avatarUrl,
        timezone,
        status
      },
      state:membershipStatus,
      role,
      membershipId {
        teamId, memberId
      }
    }
  }`,
        variables: {
            teamId: teamId,
            membershipState: membershipState
        }
    });
const $f6e4ce9aa2cd9e58$var$buildUserQuery = (userId, cloudId)=>({
        query: `query CloudUser($userId: String!, $cloudId: String!) {
    CloudUser(userId: $userId, cloudId: $cloudId) {
      avatarUrl
      id
      fullName
      title
    }
  }`,
        variables: {
            userId: userId,
            cloudId: cloudId
        }
    });
const $f6e4ce9aa2cd9e58$var$delay = (millis)=>new Promise((resolve)=>{
        setTimeout(resolve, millis);
    });
class $f6e4ce9aa2cd9e58$export$c8a50bf6c196fc10 extends (0, $b0tIZ.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/directory/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/directory/graphql`);
    }
    async queryFeatureFlags(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId, flags) {
        const queryFeatureFlags = {
            query: `query FeatureFlags($cloudId: String!, $flags: [String]!) {
        FeatureFlags(cloudId: $cloudId, flags: $flags) {
          flag
          enabled
        }
      }`,
            variables: {
                cloudId: this.getCloudId(cloudId),
                flags: flags
            }
        };
        const { FeatureFlags: FeatureFlags } = await this.makeGraphQLRequest(queryFeatureFlags, {
            operationName: 'FeatureFlags'
        });
        return FeatureFlags.map(({ flag: flag, enabled: enabled })=>[
                flag,
                enabled
            ]).reduce((acc, val)=>(acc[val[0]] = val[1], acc), {});
    }
    canRetryError(pendingRetries, error) {
        return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
    }
    /**
   * Get user information of all members of a team
   * @param {string} teamId
   * @returns {Promise}
   * @private
   * @deprecated use AGG instead
   */ queryTeamMemberships(teamId, membershipStatus = [
        'FULL_MEMBER'
    ]) {
        // eslint-disable-next-line no-console
        console.warn('Directory queryTeamMemberships is deprecated, use AGG instead');
        const teamMembershipsQuery = $f6e4ce9aa2cd9e58$var$buildTeamMembershipQuery(teamId, membershipStatus);
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(teamMembershipsQuery, {
                    operationName: 'TeamMembership'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $f6e4ce9aa2cd9e58$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest().then(({ TeamMembership: TeamMembership })=>TeamMembership);
    }
    /**
   * Get user information of all members of a team
   * @param {string} userId
   * @returns {Promise}
   */ queryUser(userId, /**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId) {
        const userQuery = $f6e4ce9aa2cd9e58$var$buildUserQuery(userId, this.getCloudId(cloudId));
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(userQuery, {
                    operationName: 'CloudUser'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $f6e4ce9aa2cd9e58$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest();
    }
}
const $f6e4ce9aa2cd9e58$export$ead519165de472de = new $f6e4ce9aa2cd9e58$export$c8a50bf6c196fc10((0, $3wIxr.DEFAULT_CONFIG).stargateRoot, {
    logException: $3lkCh.logException
});

});

parcelRegister("Dc7Bu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c93517b28564103f$export$2e2bcd8739ae039);

var $3wIxr = parcelRequire("3wIxr");

var $7thXS = parcelRequire("7thXS");

var $3UcgW = parcelRequire("3UcgW");
const $c93517b28564103f$var$defaultConfig = {
    serviceUrl: `${(0, $3wIxr.DEFAULT_CONFIG).stargateRoot}/users`
};
class $c93517b28564103f$export$f9c003efee04f318 extends (0, $7thXS.RestClient) {
    constructor(config = {}){
        super({
            ...$c93517b28564103f$var$defaultConfig,
            ...config
        });
    }
    async getUserManageConfig(userId) {
        return this.getResourceCached(`/${userId}/manage`).then((resp)=>{
            return (0, $3UcgW.transformUserManageConfig)(resp);
        });
    }
    /**
	 * @deprecated
	 * User fetchUserAvatarInfo instead
	 */ async getMyAvatarUploadedStatus(userId) {
        return this.fetchUserAvatarInfo(userId);
    }
    async deleteAvatar(userId) {
        return this.deleteResource(`/${userId}/manage/avatar`);
    }
    async fetchUserAvatarInfo(userId) {
        return this.getResource(`/${userId}/manage/avatar`);
    }
    async updateUser({ id: id, ...user }) {
        return this.patchResource(`/${id}/manage/profile`, (0, $3UcgW.toManageAPIInput)(user));
    }
    async updateUserAvatar({ id: id, fileURI: fileURI }) {
        const fileObject = (0, $3UcgW.dataURItoFile)(fileURI);
        const formData = new FormData();
        formData.append('file', fileObject);
        const response = await this.makeRequest(`/${id}/manage/avatar`, {
            method: 'PUT',
            body: formData
        });
        return response.url;
    }
}
var $c93517b28564103f$export$2e2bcd8739ae039 = new $c93517b28564103f$export$f9c003efee04f318();

});
parcelRegister("3UcgW", function(module, exports) {

$parcel$export(module.exports, "transformUserManageConfig", () => $0db264f6ce4514ab$export$d7725d3d27b80a68);
$parcel$export(module.exports, "toManageAPIInput", () => $0db264f6ce4514ab$export$7b103107c889cb67);
$parcel$export(module.exports, "dataURItoFile", () => $0db264f6ce4514ab$export$80d19edb7b1ae293);
parcelRequire("lUu20");
var $4E860 = parcelRequire("4E860");
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $0db264f6ce4514ab$var$PROFILE_PROPS_MAP = new Map([
    [
        'id',
        'account_id'
    ],
    [
        'fullName',
        'name'
    ],
    [
        'nickname',
        'nickname'
    ],
    [
        'timezone',
        'zoneinfo'
    ],
    [
        'locale',
        'locale'
    ],
    [
        'avatarUrl',
        'picture'
    ],
    [
        'email',
        'email'
    ]
]);
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $0db264f6ce4514ab$var$EXTENDED_PROFILE_PROPS_MAP = new Map([
    [
        'title',
        'job_title'
    ],
    [
        'department',
        'department'
    ],
    [
        'companyName',
        'organization'
    ],
    [
        'location',
        'location'
    ],
    [
        'phoneNumber',
        'phone_number'
    ]
]);
const $0db264f6ce4514ab$export$5299664357e4f3dd = (res)=>{
    const data = res.account;
    const extendedData = data && data.extended_profile || {};
    if (!data) return null;
    const timeZone = data.zoneinfo;
    const localTime = ({ format: format })=>{
        if (!timeZone) return null;
        try {
            return (0, $4E860.default)(new Date(), timeZone, format);
        } catch (error) {
            // TODO: PTC-4908 send error to sentry for reporting
            return null;
        }
    };
    const profileProps = Array.from($0db264f6ce4514ab$var$PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($0db264f6ce4514ab$var$PROFILE_PROPS_MAP.has(key)) acc[key] = data[$0db264f6ce4514ab$var$PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    const extendedProfileProps = Array.from($0db264f6ce4514ab$var$EXTENDED_PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($0db264f6ce4514ab$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) acc[key] = extendedData[$0db264f6ce4514ab$var$EXTENDED_PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    return {
        ...profileProps,
        ...extendedProfileProps,
        localTime: localTime
    };
};
var $0db264f6ce4514ab$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType["FullName"] = "fullName";
    FieldType["Nickname"] = "nickname";
    FieldType["Title"] = "title";
    FieldType["Department"] = "department";
    FieldType["CompanyName"] = "companyName";
    FieldType["Location"] = "location";
    FieldType["Timezone"] = "timezone";
    FieldType["Email"] = "email";
    FieldType["PhoneNumber"] = "phoneNumber";
    FieldType["Avatar"] = "picture";
    FieldType["Language"] = "language";
    FieldType["LocalTime"] = "localTime";
    FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
    FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
    FieldType["RemoteTimeString"] = "remoteTimeString";
    return FieldType;
}({});
const $0db264f6ce4514ab$export$78158d2c2c6998d9 = {
    fullName: 'name',
    nickname: 'nickname',
    timezone: 'zoneinfo',
    locale: 'locale',
    email: 'email',
    // extended profile
    title: 'extended_profile.job_title',
    phoneNumber: 'extended_profile.phone_number',
    companyName: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $0db264f6ce4514ab$export$2ff7b92b9e1bb4d2 = {
    email: 'email.initiateChange',
    picture: 'avatar'
};
const $0db264f6ce4514ab$var$getFieldConfig = (data, field)=>{
    if ((field === 'email' || field === 'picture') && $0db264f6ce4514ab$export$2ff7b92b9e1bb4d2[field]) return data[$0db264f6ce4514ab$export$2ff7b92b9e1bb4d2[field]];
    const mappedFieldKey = field in $0db264f6ce4514ab$export$78158d2c2c6998d9 ? $0db264f6ce4514ab$export$78158d2c2c6998d9[field] : undefined;
    if (!mappedFieldKey) return undefined;
    const profileWrite = data['profile.write'];
    return profileWrite[mappedFieldKey];
};
const $0db264f6ce4514ab$var$convertFieldKeyToFieldType = (key)=>{
    // Check if the key can be mapped to a FieldType value
    if (Object.values($0db264f6ce4514ab$export$ed12481c953b8653).includes(key)) return key;
    return undefined;
};
const $0db264f6ce4514ab$var$getMutabilityConstraintFor = (data, field)=>{
    const fieldConfig = $0db264f6ce4514ab$var$getFieldConfig(data, field);
    if (!fieldConfig || fieldConfig.allowed) return undefined;
    const convertedField = $0db264f6ce4514ab$var$convertFieldKeyToFieldType(field);
    if (!convertedField) return undefined;
    const reason = fieldConfig.reason;
    return {
        field: convertedField,
        reason: reason && reason.key || null
    };
};
const $0db264f6ce4514ab$export$d7725d3d27b80a68 = (data)=>({
        mutabilityConstraints: Object.keys($0db264f6ce4514ab$export$78158d2c2c6998d9).map((field)=>$0db264f6ce4514ab$var$getMutabilityConstraintFor(data, field)).filter((constraint)=>constraint !== undefined)
    });
const $0db264f6ce4514ab$export$7b103107c889cb67 = (input)=>{
    const output = {
        extended_profile: {}
    };
    Object.keys(input).forEach((key)=>{
        if ($0db264f6ce4514ab$var$PROFILE_PROPS_MAP.has(key)) output[$0db264f6ce4514ab$var$PROFILE_PROPS_MAP.get(key)] = input[key];
        if ($0db264f6ce4514ab$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) output.extended_profile[$0db264f6ce4514ab$var$EXTENDED_PROFILE_PROPS_MAP.get(key)] = input[key];
    });
    return output;
};
function $0db264f6ce4514ab$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const byteString = dataURI.split(',')[0].includes('base64') ? atob(dataURI.split(',')[1]) : decodeURIComponent(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        mimeString = 'unknown';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 and Safari does not support the File constructor.
        return blob;
    }
}

});
parcelRegister("lUu20", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("4E860")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $4E860 = parcelRequire("4E860");





});
parcelRegister("4E860", function(module, exports) {

$parcel$export(module.exports, "default", () => $36212d84df4289d0$export$2e2bcd8739ae039);

var $7noXc = parcelRequire("7noXc");

var $gI2XZ = parcelRequire("gI2XZ");

var $liyYd = parcelRequire("liyYd");
function $36212d84df4289d0$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($7noXc)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $gI2XZ.default)((0, $liyYd.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("7noXc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $55ee09b25d235297$var$cloneObject;

var $55ee09b25d235297$var$_index = $55ee09b25d235297$var$_interopRequireDefault((parcelRequire("kLhoC")));
function $55ee09b25d235297$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $55ee09b25d235297$var$cloneObject(dirtyObject) {
    return (0, $55ee09b25d235297$var$_index.default)({}, dirtyObject);
}
module.exports = module.exports.default;

});
parcelRegister("kLhoC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1d5b0ef828f96ec$var$assign;
function $f1d5b0ef828f96ec$var$assign(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}
module.exports = module.exports.default;

});


parcelRegister("gI2XZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2a30e7dbdc306a5$export$2e2bcd8739ae039);

var $47etr = parcelRequire("47etr");

var $aKisS = parcelRequire("aKisS");

var $f0JT9 = parcelRequire("f0JT9");
var $c2a30e7dbdc306a5$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $c2a30e7dbdc306a5$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($c2a30e7dbdc306a5$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $f0JT9.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $aKisS.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($47etr)))(dirtyDate, formatStr, options);
}

});
parcelRegister("47etr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ff30b0f5d6c94be$var$format;

var $2ff30b0f5d6c94be$var$_index = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("9ATkL")));

var $2ff30b0f5d6c94be$var$_index2 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("5Ex2M")));

var $2ff30b0f5d6c94be$var$_index3 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("9e8fk")));

var $2ff30b0f5d6c94be$var$_index4 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("411TS")));

var $2ff30b0f5d6c94be$var$_index5 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("1S5cf")));

var $2ff30b0f5d6c94be$var$_index6 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("3f2WU")));

var $2ff30b0f5d6c94be$var$_index7 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("ejJXr")));

var $7AKXx = parcelRequire("7AKXx");

var $2ff30b0f5d6c94be$var$_index9 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("a04h3")));

var $2ff30b0f5d6c94be$var$_index10 = $2ff30b0f5d6c94be$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $2ff30b0f5d6c94be$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $2ff30b0f5d6c94be$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $2ff30b0f5d6c94be$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $2ff30b0f5d6c94be$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $2ff30b0f5d6c94be$var$doubleQuoteRegExp = /''/g;
var $2ff30b0f5d6c94be$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $2ff30b0f5d6c94be$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $2ff30b0f5d6c94be$var$_index10.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || $2ff30b0f5d6c94be$var$_index2.default;
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $2ff30b0f5d6c94be$var$_index9.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $2ff30b0f5d6c94be$var$_index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $2ff30b0f5d6c94be$var$_index9.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $2ff30b0f5d6c94be$var$_index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $2ff30b0f5d6c94be$var$_index4.default)(dirtyDate);
    if (!(0, $2ff30b0f5d6c94be$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $2ff30b0f5d6c94be$var$_index7.default)(originalDate);
    var utcDate = (0, $2ff30b0f5d6c94be$var$_index3.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($2ff30b0f5d6c94be$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $2ff30b0f5d6c94be$var$_index6.default[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($2ff30b0f5d6c94be$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $2ff30b0f5d6c94be$var$cleanEscapedString(substring);
        var formatter = $2ff30b0f5d6c94be$var$_index5.default[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $7AKXx.isProtectedWeekYearToken)(substring)) (0, $7AKXx.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $7AKXx.isProtectedDayOfYearToken)(substring)) (0, $7AKXx.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($2ff30b0f5d6c94be$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $2ff30b0f5d6c94be$var$cleanEscapedString(input) {
    return input.match($2ff30b0f5d6c94be$var$escapedStringRegExp)[1].replace($2ff30b0f5d6c94be$var$doubleQuoteRegExp, "'");
}
module.exports = module.exports.default;

});
parcelRegister("9ATkL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6fc265fbf88f3fb2$var$isValid;

var $6fc265fbf88f3fb2$var$_index = $6fc265fbf88f3fb2$var$_interopRequireDefault((parcelRequire("411TS")));

var $6fc265fbf88f3fb2$var$_index2 = $6fc265fbf88f3fb2$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $6fc265fbf88f3fb2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */ function $6fc265fbf88f3fb2$var$isValid(dirtyDate) {
    (0, $6fc265fbf88f3fb2$var$_index2.default)(1, arguments);
    var date = (0, $6fc265fbf88f3fb2$var$_index.default)(dirtyDate);
    return !isNaN(date);
}
module.exports = module.exports.default;

});
parcelRegister("411TS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ec8bac3829b5d77$var$toDate;

var $2ec8bac3829b5d77$var$_index = $2ec8bac3829b5d77$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $2ec8bac3829b5d77$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $2ec8bac3829b5d77$var$toDate(argument) {
    (0, $2ec8bac3829b5d77$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});
parcelRegister("4YZVX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3a0ccec6969661ab$var$requiredArgs;
function $3a0ccec6969661ab$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});



parcelRegister("5Ex2M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41da51fb3f7f2e9e$var$_index = $41da51fb3f7f2e9e$var$_interopRequireDefault((parcelRequire("j0Eie")));

var $41da51fb3f7f2e9e$var$_index2 = $41da51fb3f7f2e9e$var$_interopRequireDefault((parcelRequire("hCaWU")));

var $41da51fb3f7f2e9e$var$_index3 = $41da51fb3f7f2e9e$var$_interopRequireDefault((parcelRequire("grk3U")));

var $41da51fb3f7f2e9e$var$_index4 = $41da51fb3f7f2e9e$var$_interopRequireDefault((parcelRequire("36Npg")));

var $41da51fb3f7f2e9e$var$_index5 = $41da51fb3f7f2e9e$var$_interopRequireDefault((parcelRequire("72ljP")));
function $41da51fb3f7f2e9e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $41da51fb3f7f2e9e$var$locale = {
    code: 'en-US',
    formatDistance: $41da51fb3f7f2e9e$var$_index.default,
    formatLong: $41da51fb3f7f2e9e$var$_index2.default,
    formatRelative: $41da51fb3f7f2e9e$var$_index3.default,
    localize: $41da51fb3f7f2e9e$var$_index4.default,
    match: $41da51fb3f7f2e9e$var$_index5.default,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $41da51fb3f7f2e9e$var$_default = $41da51fb3f7f2e9e$var$locale;
module.exports.default = $41da51fb3f7f2e9e$var$_default;
module.exports = module.exports.default;

});
parcelRegister("j0Eie", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd6d45c5fb0de521$var$formatDistance;
var $dd6d45c5fb0de521$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function $dd6d45c5fb0de521$var$formatDistance(token, count, options) {
    options = options || {};
    var result;
    if (typeof $dd6d45c5fb0de521$var$formatDistanceLocale[token] === 'string') result = $dd6d45c5fb0de521$var$formatDistanceLocale[token];
    else if (count === 1) result = $dd6d45c5fb0de521$var$formatDistanceLocale[token].one;
    else result = $dd6d45c5fb0de521$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
}
module.exports = module.exports.default;

});

parcelRegister("hCaWU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd2e7a8b4adafb98$var$_index = $cd2e7a8b4adafb98$var$_interopRequireDefault((parcelRequire("1KaiK")));
function $cd2e7a8b4adafb98$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cd2e7a8b4adafb98$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $cd2e7a8b4adafb98$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $cd2e7a8b4adafb98$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $cd2e7a8b4adafb98$var$formatLong = {
    date: (0, $cd2e7a8b4adafb98$var$_index.default)({
        formats: $cd2e7a8b4adafb98$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $cd2e7a8b4adafb98$var$_index.default)({
        formats: $cd2e7a8b4adafb98$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $cd2e7a8b4adafb98$var$_index.default)({
        formats: $cd2e7a8b4adafb98$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $cd2e7a8b4adafb98$var$_default = $cd2e7a8b4adafb98$var$formatLong;
module.exports.default = $cd2e7a8b4adafb98$var$_default;
module.exports = module.exports.default;

});
parcelRegister("1KaiK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $145213f5e2256761$var$buildFormatLongFn;
function $145213f5e2256761$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("grk3U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf7ebae278921a82$var$formatRelative;
var $bf7ebae278921a82$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
function $bf7ebae278921a82$var$formatRelative(token, _date, _baseDate, _options) {
    return $bf7ebae278921a82$var$formatRelativeLocale[token];
}
module.exports = module.exports.default;

});

parcelRegister("36Npg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $243841b569f75983$var$_index = $243841b569f75983$var$_interopRequireDefault((parcelRequire("4Oo0u")));
function $243841b569f75983$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $243841b569f75983$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $243841b569f75983$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $243841b569f75983$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $243841b569f75983$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $243841b569f75983$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $243841b569f75983$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
function $243841b569f75983$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
}
var $243841b569f75983$var$localize = {
    ordinalNumber: $243841b569f75983$var$ordinalNumber,
    era: (0, $243841b569f75983$var$_index.default)({
        values: $243841b569f75983$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $243841b569f75983$var$_index.default)({
        values: $243841b569f75983$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $243841b569f75983$var$_index.default)({
        values: $243841b569f75983$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $243841b569f75983$var$_index.default)({
        values: $243841b569f75983$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $243841b569f75983$var$_index.default)({
        values: $243841b569f75983$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $243841b569f75983$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $243841b569f75983$var$_default = $243841b569f75983$var$localize;
module.exports.default = $243841b569f75983$var$_default;
module.exports = module.exports.default;

});
parcelRegister("4Oo0u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $380e7433bb720b67$var$buildLocalizeFn;
function $380e7433bb720b67$var$buildLocalizeFn(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("72ljP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $51f941c45a4dfa75$var$_index = $51f941c45a4dfa75$var$_interopRequireDefault((parcelRequire("04buv")));

var $51f941c45a4dfa75$var$_index2 = $51f941c45a4dfa75$var$_interopRequireDefault((parcelRequire("eVPlb")));
function $51f941c45a4dfa75$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $51f941c45a4dfa75$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $51f941c45a4dfa75$var$parseOrdinalNumberPattern = /\d+/i;
var $51f941c45a4dfa75$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $51f941c45a4dfa75$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $51f941c45a4dfa75$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $51f941c45a4dfa75$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $51f941c45a4dfa75$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $51f941c45a4dfa75$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $51f941c45a4dfa75$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $51f941c45a4dfa75$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $51f941c45a4dfa75$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $51f941c45a4dfa75$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $51f941c45a4dfa75$var$match = {
    ordinalNumber: (0, $51f941c45a4dfa75$var$_index.default)({
        matchPattern: $51f941c45a4dfa75$var$matchOrdinalNumberPattern,
        parsePattern: $51f941c45a4dfa75$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $51f941c45a4dfa75$var$_index2.default)({
        matchPatterns: $51f941c45a4dfa75$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $51f941c45a4dfa75$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $51f941c45a4dfa75$var$_index2.default)({
        matchPatterns: $51f941c45a4dfa75$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $51f941c45a4dfa75$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $51f941c45a4dfa75$var$_index2.default)({
        matchPatterns: $51f941c45a4dfa75$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $51f941c45a4dfa75$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $51f941c45a4dfa75$var$_index2.default)({
        matchPatterns: $51f941c45a4dfa75$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $51f941c45a4dfa75$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $51f941c45a4dfa75$var$_index2.default)({
        matchPatterns: $51f941c45a4dfa75$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $51f941c45a4dfa75$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $51f941c45a4dfa75$var$_default = $51f941c45a4dfa75$var$match;
module.exports.default = $51f941c45a4dfa75$var$_default;
module.exports = module.exports.default;

});
parcelRegister("04buv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $00c949bab0549061$var$buildMatchPatternFn;
function $00c949bab0549061$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});

parcelRegister("eVPlb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adee36c0e746269c$var$buildMatchFn;
function $adee36c0e746269c$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $adee36c0e746269c$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $adee36c0e746269c$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $adee36c0e746269c$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $adee36c0e746269c$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});



parcelRegister("9e8fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b7bd16a2a6c1a1e$var$subMilliseconds;

var $6b7bd16a2a6c1a1e$var$_index = $6b7bd16a2a6c1a1e$var$_interopRequireDefault((parcelRequire("a04h3")));

var $6b7bd16a2a6c1a1e$var$_index2 = $6b7bd16a2a6c1a1e$var$_interopRequireDefault((parcelRequire("9ZBzx")));

var $6b7bd16a2a6c1a1e$var$_index3 = $6b7bd16a2a6c1a1e$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $6b7bd16a2a6c1a1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $6b7bd16a2a6c1a1e$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $6b7bd16a2a6c1a1e$var$_index3.default)(2, arguments);
    var amount = (0, $6b7bd16a2a6c1a1e$var$_index.default)(dirtyAmount);
    return (0, $6b7bd16a2a6c1a1e$var$_index2.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("a04h3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $747d383b4b873594$var$toInteger;
function $747d383b4b873594$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});

parcelRegister("9ZBzx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7466f4a04eca45f4$var$addMilliseconds;

var $7466f4a04eca45f4$var$_index = $7466f4a04eca45f4$var$_interopRequireDefault((parcelRequire("a04h3")));

var $7466f4a04eca45f4$var$_index2 = $7466f4a04eca45f4$var$_interopRequireDefault((parcelRequire("411TS")));

var $7466f4a04eca45f4$var$_index3 = $7466f4a04eca45f4$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $7466f4a04eca45f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $7466f4a04eca45f4$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $7466f4a04eca45f4$var$_index3.default)(2, arguments);
    var timestamp = (0, $7466f4a04eca45f4$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $7466f4a04eca45f4$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});


parcelRegister("1S5cf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $15cedd7f8242ee45$var$_index = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("a9DiA")));

var $15cedd7f8242ee45$var$_index2 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("8aeCZ")));

var $15cedd7f8242ee45$var$_index3 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("5sEnr")));

var $15cedd7f8242ee45$var$_index4 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("iA62f")));

var $15cedd7f8242ee45$var$_index5 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("ldYz2")));

var $15cedd7f8242ee45$var$_index6 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("lc9Za")));

var $15cedd7f8242ee45$var$_index7 = $15cedd7f8242ee45$var$_interopRequireDefault((parcelRequire("lYG1t")));
function $15cedd7f8242ee45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $15cedd7f8242ee45$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $15cedd7f8242ee45$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $15cedd7f8242ee45$var$_index.default.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $15cedd7f8242ee45$var$_index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $15cedd7f8242ee45$var$_index7.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $15cedd7f8242ee45$var$_index7.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $15cedd7f8242ee45$var$_index4.default)(date); // Padding
        return (0, $15cedd7f8242ee45$var$_index7.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $15cedd7f8242ee45$var$_index7.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $15cedd7f8242ee45$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $15cedd7f8242ee45$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $15cedd7f8242ee45$var$_index.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $15cedd7f8242ee45$var$_index7.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $15cedd7f8242ee45$var$_index5.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $15cedd7f8242ee45$var$_index7.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $15cedd7f8242ee45$var$_index3.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $15cedd7f8242ee45$var$_index7.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $15cedd7f8242ee45$var$_index.default.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $15cedd7f8242ee45$var$_index2.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $15cedd7f8242ee45$var$_index7.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $15cedd7f8242ee45$var$_index7.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $15cedd7f8242ee45$var$_index7.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $15cedd7f8242ee45$var$_index7.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $15cedd7f8242ee45$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $15cedd7f8242ee45$var$_index.default.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $15cedd7f8242ee45$var$_index.default.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $15cedd7f8242ee45$var$_index7.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $15cedd7f8242ee45$var$_index7.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $15cedd7f8242ee45$var$_index.default.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $15cedd7f8242ee45$var$_index.default.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $15cedd7f8242ee45$var$_index.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $15cedd7f8242ee45$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $15cedd7f8242ee45$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $15cedd7f8242ee45$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $15cedd7f8242ee45$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $15cedd7f8242ee45$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $15cedd7f8242ee45$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $15cedd7f8242ee45$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $15cedd7f8242ee45$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $15cedd7f8242ee45$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $15cedd7f8242ee45$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $15cedd7f8242ee45$var$_index7.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $15cedd7f8242ee45$var$_index7.default)(timestamp, token.length);
    }
};
function $15cedd7f8242ee45$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $15cedd7f8242ee45$var$_index7.default)(minutes, 2);
}
function $15cedd7f8242ee45$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $15cedd7f8242ee45$var$_index7.default)(Math.abs(offset) / 60, 2);
    }
    return $15cedd7f8242ee45$var$formatTimezone(offset, dirtyDelimiter);
}
function $15cedd7f8242ee45$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $15cedd7f8242ee45$var$_index7.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $15cedd7f8242ee45$var$_index7.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $15cedd7f8242ee45$var$_default = $15cedd7f8242ee45$var$formatters;
module.exports.default = $15cedd7f8242ee45$var$_default;
module.exports = module.exports.default;

});
parcelRegister("a9DiA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76493a941b8ff202$var$_index = $76493a941b8ff202$var$_interopRequireDefault((parcelRequire("lYG1t")));
function $76493a941b8ff202$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $76493a941b8ff202$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $76493a941b8ff202$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $76493a941b8ff202$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $76493a941b8ff202$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $76493a941b8ff202$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $76493a941b8ff202$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $76493a941b8ff202$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $76493a941b8ff202$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $76493a941b8ff202$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $76493a941b8ff202$var$_default = $76493a941b8ff202$var$formatters;
module.exports.default = $76493a941b8ff202$var$_default;
module.exports = module.exports.default;

});
parcelRegister("lYG1t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ffffcc6552a18812$var$addLeadingZeros;
function $ffffcc6552a18812$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});


parcelRegister("8aeCZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f1a9aac6c7c6a94$var$getUTCDayOfYear;

var $5f1a9aac6c7c6a94$var$_index = $5f1a9aac6c7c6a94$var$_interopRequireDefault((parcelRequire("411TS")));

var $5f1a9aac6c7c6a94$var$_index2 = $5f1a9aac6c7c6a94$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $5f1a9aac6c7c6a94$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5f1a9aac6c7c6a94$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $5f1a9aac6c7c6a94$var$getUTCDayOfYear(dirtyDate) {
    (0, $5f1a9aac6c7c6a94$var$_index2.default)(1, arguments);
    var date = (0, $5f1a9aac6c7c6a94$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $5f1a9aac6c7c6a94$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("5sEnr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f9ee3540ad931d2$var$getUTCISOWeek;

var $3f9ee3540ad931d2$var$_index = $3f9ee3540ad931d2$var$_interopRequireDefault((parcelRequire("411TS")));

var $3f9ee3540ad931d2$var$_index2 = $3f9ee3540ad931d2$var$_interopRequireDefault((parcelRequire("i0cv4")));

var $3f9ee3540ad931d2$var$_index3 = $3f9ee3540ad931d2$var$_interopRequireDefault((parcelRequire("guQGo")));

var $3f9ee3540ad931d2$var$_index4 = $3f9ee3540ad931d2$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $3f9ee3540ad931d2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3f9ee3540ad931d2$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $3f9ee3540ad931d2$var$getUTCISOWeek(dirtyDate) {
    (0, $3f9ee3540ad931d2$var$_index4.default)(1, arguments);
    var date = (0, $3f9ee3540ad931d2$var$_index.default)(dirtyDate);
    var diff = (0, $3f9ee3540ad931d2$var$_index2.default)(date).getTime() - (0, $3f9ee3540ad931d2$var$_index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $3f9ee3540ad931d2$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("i0cv4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d1b1ec55b955b3ea$var$startOfUTCISOWeek;

var $d1b1ec55b955b3ea$var$_index = $d1b1ec55b955b3ea$var$_interopRequireDefault((parcelRequire("411TS")));

var $d1b1ec55b955b3ea$var$_index2 = $d1b1ec55b955b3ea$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $d1b1ec55b955b3ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $d1b1ec55b955b3ea$var$startOfUTCISOWeek(dirtyDate) {
    (0, $d1b1ec55b955b3ea$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $d1b1ec55b955b3ea$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("guQGo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c028505fe514d6e3$var$startOfUTCISOWeekYear;

var $c028505fe514d6e3$var$_index = $c028505fe514d6e3$var$_interopRequireDefault((parcelRequire("iA62f")));

var $c028505fe514d6e3$var$_index2 = $c028505fe514d6e3$var$_interopRequireDefault((parcelRequire("i0cv4")));

var $c028505fe514d6e3$var$_index3 = $c028505fe514d6e3$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $c028505fe514d6e3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $c028505fe514d6e3$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $c028505fe514d6e3$var$_index3.default)(1, arguments);
    var year = (0, $c028505fe514d6e3$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $c028505fe514d6e3$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("iA62f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d870453ff24bf26d$var$getUTCISOWeekYear;

var $d870453ff24bf26d$var$_index = $d870453ff24bf26d$var$_interopRequireDefault((parcelRequire("411TS")));

var $d870453ff24bf26d$var$_index2 = $d870453ff24bf26d$var$_interopRequireDefault((parcelRequire("i0cv4")));

var $d870453ff24bf26d$var$_index3 = $d870453ff24bf26d$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $d870453ff24bf26d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $d870453ff24bf26d$var$getUTCISOWeekYear(dirtyDate) {
    (0, $d870453ff24bf26d$var$_index3.default)(1, arguments);
    var date = (0, $d870453ff24bf26d$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $d870453ff24bf26d$var$_index2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $d870453ff24bf26d$var$_index2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("ldYz2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f739caa789a1bb9b$var$getUTCWeek;

var $f739caa789a1bb9b$var$_index = $f739caa789a1bb9b$var$_interopRequireDefault((parcelRequire("411TS")));

var $f739caa789a1bb9b$var$_index2 = $f739caa789a1bb9b$var$_interopRequireDefault((parcelRequire("geMjG")));

var $f739caa789a1bb9b$var$_index3 = $f739caa789a1bb9b$var$_interopRequireDefault((parcelRequire("kpxoI")));

var $f739caa789a1bb9b$var$_index4 = $f739caa789a1bb9b$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $f739caa789a1bb9b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f739caa789a1bb9b$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $f739caa789a1bb9b$var$getUTCWeek(dirtyDate, options) {
    (0, $f739caa789a1bb9b$var$_index4.default)(1, arguments);
    var date = (0, $f739caa789a1bb9b$var$_index.default)(dirtyDate);
    var diff = (0, $f739caa789a1bb9b$var$_index2.default)(date, options).getTime() - (0, $f739caa789a1bb9b$var$_index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $f739caa789a1bb9b$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("geMjG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bd236ec50df9f54c$var$startOfUTCWeek;

var $bd236ec50df9f54c$var$_index = $bd236ec50df9f54c$var$_interopRequireDefault((parcelRequire("a04h3")));

var $bd236ec50df9f54c$var$_index2 = $bd236ec50df9f54c$var$_interopRequireDefault((parcelRequire("411TS")));

var $bd236ec50df9f54c$var$_index3 = $bd236ec50df9f54c$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $bd236ec50df9f54c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $bd236ec50df9f54c$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
    (0, $bd236ec50df9f54c$var$_index3.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $bd236ec50df9f54c$var$_index.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $bd236ec50df9f54c$var$_index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $bd236ec50df9f54c$var$_index2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("kpxoI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $edc00c8c056e63ce$var$startOfUTCWeekYear;

var $edc00c8c056e63ce$var$_index = $edc00c8c056e63ce$var$_interopRequireDefault((parcelRequire("a04h3")));

var $edc00c8c056e63ce$var$_index2 = $edc00c8c056e63ce$var$_interopRequireDefault((parcelRequire("lc9Za")));

var $edc00c8c056e63ce$var$_index3 = $edc00c8c056e63ce$var$_interopRequireDefault((parcelRequire("geMjG")));

var $edc00c8c056e63ce$var$_index4 = $edc00c8c056e63ce$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $edc00c8c056e63ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $edc00c8c056e63ce$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $edc00c8c056e63ce$var$_index4.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $edc00c8c056e63ce$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $edc00c8c056e63ce$var$_index.default)(options.firstWeekContainsDate);
    var year = (0, $edc00c8c056e63ce$var$_index2.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $edc00c8c056e63ce$var$_index3.default)(firstWeek, dirtyOptions);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("lc9Za", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f6e276e76c61e58d$var$getUTCWeekYear;

var $f6e276e76c61e58d$var$_index = $f6e276e76c61e58d$var$_interopRequireDefault((parcelRequire("a04h3")));

var $f6e276e76c61e58d$var$_index2 = $f6e276e76c61e58d$var$_interopRequireDefault((parcelRequire("411TS")));

var $f6e276e76c61e58d$var$_index3 = $f6e276e76c61e58d$var$_interopRequireDefault((parcelRequire("geMjG")));

var $f6e276e76c61e58d$var$_index4 = $f6e276e76c61e58d$var$_interopRequireDefault((parcelRequire("4YZVX")));
function $f6e276e76c61e58d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $f6e276e76c61e58d$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $f6e276e76c61e58d$var$_index4.default)(1, arguments);
    var date = (0, $f6e276e76c61e58d$var$_index2.default)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $f6e276e76c61e58d$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $f6e276e76c61e58d$var$_index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $f6e276e76c61e58d$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $f6e276e76c61e58d$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});




parcelRegister("3f2WU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $25c50f6d9939631e$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $25c50f6d9939631e$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $25c50f6d9939631e$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $25c50f6d9939631e$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $25c50f6d9939631e$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $25c50f6d9939631e$var$timeLongFormatter(timePattern, formatLong));
}
var $25c50f6d9939631e$var$longFormatters = {
    p: $25c50f6d9939631e$var$timeLongFormatter,
    P: $25c50f6d9939631e$var$dateTimeLongFormatter
};
var $25c50f6d9939631e$var$_default = $25c50f6d9939631e$var$longFormatters;
module.exports.default = $25c50f6d9939631e$var$_default;
module.exports = module.exports.default;

});

parcelRegister("ejJXr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6c67d4b841f38e8$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $a6c67d4b841f38e8$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("7AKXx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProtectedDayOfYearToken = $58705255ffd27ebc$var$isProtectedDayOfYearToken;
module.exports.isProtectedWeekYearToken = $58705255ffd27ebc$var$isProtectedWeekYearToken;
module.exports.throwProtectedError = $58705255ffd27ebc$var$throwProtectedError;
var $58705255ffd27ebc$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $58705255ffd27ebc$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $58705255ffd27ebc$var$isProtectedDayOfYearToken(token) {
    return $58705255ffd27ebc$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $58705255ffd27ebc$var$isProtectedWeekYearToken(token) {
    return $58705255ffd27ebc$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $58705255ffd27ebc$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}

});


parcelRegister("aKisS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d2c85f504020c75$export$2e2bcd8739ae039);

var $hTtKe = parcelRequire("hTtKe");

var $9hBXD = parcelRequire("9hBXD");
var $7d2c85f504020c75$var$MILLISECONDS_IN_MINUTE = 60000;
var $7d2c85f504020c75$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $7d2c85f504020c75$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $7d2c85f504020c75$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $7d2c85f504020c75$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $7d2c85f504020c75$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $7d2c85f504020c75$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $7d2c85f504020c75$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $7d2c85f504020c75$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $7d2c85f504020c75$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $7d2c85f504020c75$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $7d2c85f504020c75$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $7d2c85f504020c75$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $hTtKe.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $hTtKe.default)('long', date, options);
        }
    }
};
function $7d2c85f504020c75$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $9hBXD.default)(timeZone, originalDate, true) / $7d2c85f504020c75$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $7d2c85f504020c75$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $7d2c85f504020c75$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $7d2c85f504020c75$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $7d2c85f504020c75$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $7d2c85f504020c75$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $7d2c85f504020c75$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $7d2c85f504020c75$var$formatTimezone(offset, dirtyDelimeter);
}
function $7d2c85f504020c75$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $7d2c85f504020c75$var$addLeadingZeros(minutes, 2);
}
var $7d2c85f504020c75$export$2e2bcd8739ae039 = $7d2c85f504020c75$var$formatters;

});
parcelRegister("hTtKe", function(module, exports) {

$parcel$export(module.exports, "default", () => $d06ea5690246ce75$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $d06ea5690246ce75$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $d06ea5690246ce75$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $d06ea5690246ce75$var$partsTimeZone(dtf, date) : $d06ea5690246ce75$var$hackyTimeZone(dtf, date);
}
function $d06ea5690246ce75$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $d06ea5690246ce75$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $d06ea5690246ce75$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("9hBXD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c2325d4e20eb9d1$export$2e2bcd8739ae039);

var $70EVG = parcelRequire("70EVG");

var $9bxwD = parcelRequire("9bxwD");
var $6c2325d4e20eb9d1$var$MILLISECONDS_IN_HOUR = 3600000;
var $6c2325d4e20eb9d1$var$MILLISECONDS_IN_MINUTE = 60000;
var $6c2325d4e20eb9d1$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $6c2325d4e20eb9d1$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $6c2325d4e20eb9d1$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $6c2325d4e20eb9d1$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$6c2325d4e20eb9d1$var$validateTimezone(hours)) return NaN;
        return -(hours * $6c2325d4e20eb9d1$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $6c2325d4e20eb9d1$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$6c2325d4e20eb9d1$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $6c2325d4e20eb9d1$var$MILLISECONDS_IN_HOUR + minutes * $6c2325d4e20eb9d1$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($6c2325d4e20eb9d1$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $6c2325d4e20eb9d1$var$toUtcDate(date);
        var offset = $6c2325d4e20eb9d1$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $6c2325d4e20eb9d1$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $6c2325d4e20eb9d1$var$toUtcDate(date) {
    return (0, $9bxwD.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $6c2325d4e20eb9d1$var$calcOffset(date, timezoneString) {
    var tokens = (0, $70EVG.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $9bxwD.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $6c2325d4e20eb9d1$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $6c2325d4e20eb9d1$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $6c2325d4e20eb9d1$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $6c2325d4e20eb9d1$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $6c2325d4e20eb9d1$var$validIANATimezoneCache = {};
function $6c2325d4e20eb9d1$var$isValidTimezoneIANAString(timeZoneString) {
    if ($6c2325d4e20eb9d1$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $6c2325d4e20eb9d1$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("70EVG", function(module, exports) {

$parcel$export(module.exports, "default", () => $51a8483a0cbf9fa0$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $51a8483a0cbf9fa0$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $51a8483a0cbf9fa0$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $51a8483a0cbf9fa0$var$partsOffset(dtf, date) : $51a8483a0cbf9fa0$var$hackyOffset(dtf, date);
}
var $51a8483a0cbf9fa0$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $51a8483a0cbf9fa0$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $51a8483a0cbf9fa0$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $51a8483a0cbf9fa0$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $51a8483a0cbf9fa0$var$dtfCache = {};
function $51a8483a0cbf9fa0$var$getDateTimeFormat(timeZone) {
    if (!$51a8483a0cbf9fa0$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $51a8483a0cbf9fa0$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $51a8483a0cbf9fa0$var$dtfCache[timeZone];
}

});

parcelRegister("9bxwD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aff25952e78362b$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $6aff25952e78362b$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("f0JT9", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeda739565ea016f$export$2e2bcd8739ae039);

var $a04h3 = parcelRequire("a04h3");

var $ejJXr = parcelRequire("ejJXr");

var $9hBXD = parcelRequire("9hBXD");

var $jDeNG = parcelRequire("jDeNG");
var $aeda739565ea016f$var$MILLISECONDS_IN_HOUR = 3600000;
var $aeda739565ea016f$var$MILLISECONDS_IN_MINUTE = 60000;
var $aeda739565ea016f$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $aeda739565ea016f$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $jDeNG.default)
};
function $aeda739565ea016f$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $aeda739565ea016f$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($a04h3)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $aeda739565ea016f$var$splitDateString(argument);
    var parseYearResult = $aeda739565ea016f$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $aeda739565ea016f$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $aeda739565ea016f$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $9hBXD.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $aeda739565ea016f$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $aeda739565ea016f$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $aeda739565ea016f$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $aeda739565ea016f$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $aeda739565ea016f$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $aeda739565ea016f$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $aeda739565ea016f$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $aeda739565ea016f$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $aeda739565ea016f$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $aeda739565ea016f$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $aeda739565ea016f$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$aeda739565ea016f$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $aeda739565ea016f$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$aeda739565ea016f$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $aeda739565ea016f$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$aeda739565ea016f$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $aeda739565ea016f$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$aeda739565ea016f$var$validateWeekDate(year, week)) return new Date(NaN);
        return $aeda739565ea016f$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $aeda739565ea016f$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$aeda739565ea016f$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $aeda739565ea016f$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $aeda739565ea016f$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $aeda739565ea016f$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$aeda739565ea016f$var$validateTime(hours)) return NaN;
        return hours % 24 * $aeda739565ea016f$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $aeda739565ea016f$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$aeda739565ea016f$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $aeda739565ea016f$var$MILLISECONDS_IN_HOUR + minutes * $aeda739565ea016f$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $aeda739565ea016f$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$aeda739565ea016f$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $aeda739565ea016f$var$MILLISECONDS_IN_HOUR + minutes * $aeda739565ea016f$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $aeda739565ea016f$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $aeda739565ea016f$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $aeda739565ea016f$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $aeda739565ea016f$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $aeda739565ea016f$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $aeda739565ea016f$var$isLeapYearIndex(year);
        if (isLeapYear && date > $aeda739565ea016f$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $aeda739565ea016f$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $aeda739565ea016f$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $aeda739565ea016f$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $aeda739565ea016f$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $aeda739565ea016f$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("jDeNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ad23dcb817ee75$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $e4ad23dcb817ee75$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $e4ad23dcb817ee75$export$2e2bcd8739ae039 = $e4ad23dcb817ee75$var$tzPattern;

});



parcelRegister("liyYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f81667c1f5e3eea1$export$2e2bcd8739ae039);

var $9hBXD = parcelRequire("9hBXD");

var $f0JT9 = parcelRequire("f0JT9");
function $f81667c1f5e3eea1$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $f0JT9.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $9hBXD.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});





parcelRegister("cl86K", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbca91ac5b39f2d2$export$2e2bcd8739ae039);

var $3wIxr = parcelRequire("3wIxr");

var $7thXS = parcelRequire("7thXS");

var $3lkCh = parcelRequire("3lkCh");

var $9jO4o = parcelRequire("9jO4o");
const $fbca91ac5b39f2d2$var$PRODUCT_RECCOMENDATIONS = '/v1/product-recommendations';
const $fbca91ac5b39f2d2$var$PRODUCT_JOIN_OR_REQUEST_BULK = '/v1/access-requests/bulk/request';
const $fbca91ac5b39f2d2$var$ALL_SUPPORTED_PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-servicedesk',
    'jira-software',
    'jira-incident-manager',
    'jira-product-discovery',
    'opsgenie',
    'statuspage',
    'avocado',
    'townsquare',
    'compass',
    'avp',
    'beacon',
    'mercury'
];
class $fbca91ac5b39f2d2$export$3209eb31343f39d extends (0, $7thXS.RestClient) {
    constructor(serviceUrl, config){
        super({
            serviceUrl: serviceUrl,
            config: config
        });
    }
    async getProductRecommendationsInner(supportedProducts = $fbca91ac5b39f2d2$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        try {
            const orgId = this.getOrgId();
            const queryProducts = supportedProducts && supportedProducts.length > 0 ? supportedProducts : $fbca91ac5b39f2d2$var$ALL_SUPPORTED_PRODUCTS;
            const productQueryParams = queryProducts.map((product)=>`product=${product}`).join('&');
            const capabilityQueryParams = capabilities && capabilities.length > 0 ? '&' + capabilities.map((capability)=>`capability=${capability}`).join('&') : '';
            const url = `${$fbca91ac5b39f2d2$var$PRODUCT_RECCOMENDATIONS}?orgId=${orgId}&${productQueryParams}${capabilityQueryParams}`;
            return await this.getResource(url);
        } catch (error) {
            this.logException(error, 'An error occurred while getting product recommendations.');
            throw error;
        }
    }
    async getProductRecommendations(supportedProducts = $fbca91ac5b39f2d2$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        // This endpoint may return duplicate resource ARIs with a different mode.
        const result = await this.getProductRecommendationsInner(supportedProducts, capabilities);
        try {
            const deduplicatedResult = (0, $9jO4o.removeDuplicateRecommendations)(result);
            return deduplicatedResult;
        } catch (error) {
            this.logException(error, 'An error occurred while deduplicating product recommendations.');
            throw error;
        }
    }
    async joinOrRequestDefaultAccessToProductsBulk(simplifiedRequest) {
        if (simplifiedRequest.productAris.length === 0) return Promise.resolve([]);
        try {
            const resources = simplifiedRequest.productAris.map((ari)=>({
                    ari: ari,
                    role: 'product/member'
                }));
            const request = {
                resources: resources,
                note: simplifiedRequest.note,
                accessMode: simplifiedRequest.accessMode,
                source: simplifiedRequest.source
            };
            return await this.postResource($fbca91ac5b39f2d2$var$PRODUCT_JOIN_OR_REQUEST_BULK, request);
        } catch (error) {
            this.logException(error, 'An error occurred while joining or requesting access to products.');
            throw error;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$fbca91ac5b39f2d2$export$2e2bcd8739ae039 = new $fbca91ac5b39f2d2$export$3209eb31343f39d((0, $3wIxr.DEFAULT_CONFIG).invitationsServiceUrl, {
    logException: $3lkCh.logException
});

});
parcelRegister("9jO4o", function(module, exports) {

$parcel$export(module.exports, "removeDuplicateRecommendations", () => $d7aaa271ddd30b70$export$d9d1c981635dd213);
/**
 * Determines which capability is more desirable.
 * Users desire direct access over request access since it's instant.
 * @returns 0 if equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $d7aaa271ddd30b70$var$compareCapability = (a, b)=>{
    if (a === b) return 0;
    return a === 'DIRECT_ACCESS' ? -1 : 1;
};
/**
 * Determines which mode is more desirable.
 * Atlassian prefers to provide open access over domain restricted access.
 * Both of these modes have already been enabled by an admin.
 * If mode is undefined, it is deemed least desirable.
 * @returns 0 if equal, -1 if a is more open, 1 if b is more open.
 */ const $d7aaa271ddd30b70$var$compareMode = (a, b)=>{
    if (a === b) return 0;
    if (!a) return 1;
    if (!b) return -1;
    return a === 'OPEN' ? -1 : 1;
};
/**
 * Determine if a recommendation is more desirable than another.
 * Atlassian prefers a better capability over any mode setting.
 * The mode will only be compared if the capabilities are equal.
 * If both capability and mode are equal, the recommendations are considered the same.
 *
 * Assumes recommendations have the same resource ID.
 * Do not compare recommendations with different resource IDs, as it does not make sense.
 *
 * @returns 0 if capability and mode are equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $d7aaa271ddd30b70$var$compareRecommendations = (a, b)=>{
    if (a.resourceId !== b.resourceId) throw new Error('Recommendations must have the same resource ID');
    if ($d7aaa271ddd30b70$var$compareCapability(a.capability, b.capability) < 0) return -1;
    else if ($d7aaa271ddd30b70$var$compareCapability(a.capability, b.capability) > 0) return 1;
    else if ($d7aaa271ddd30b70$var$compareMode(a.mode, b.mode) < 0) return -1;
    else if ($d7aaa271ddd30b70$var$compareMode(a.mode, b.mode) > 0) return 1;
    return 0;
};
const $d7aaa271ddd30b70$var$toRecommendation = (recommendation)=>{
    const { capability: capability, ...rest } = recommendation;
    return {
        ...rest
    };
};
const $d7aaa271ddd30b70$export$d9d1c981635dd213 = (recommendations)=>{
    const { DIRECT_ACCESS: DIRECT_ACCESS, REQUEST_ACCESS: REQUEST_ACCESS } = recommendations.capability;
    const uniqueRecommendations = {};
    const allRecommendations = [
        ...DIRECT_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'DIRECT_ACCESS'
            })),
        ...REQUEST_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'REQUEST_ACCESS'
            }))
    ];
    allRecommendations.forEach((recommendation)=>{
        const existing = uniqueRecommendations[recommendation.resourceId];
        if (existing && $d7aaa271ddd30b70$var$compareRecommendations(existing, recommendation) <= 0) return;
        uniqueRecommendations[recommendation.resourceId] = recommendation;
    });
    const allUniqueRecommendations = Object.values(uniqueRecommendations);
    return {
        capability: {
            DIRECT_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'DIRECT_ACCESS').map($d7aaa271ddd30b70$var$toRecommendation),
            REQUEST_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'REQUEST_ACCESS').map($d7aaa271ddd30b70$var$toRecommendation)
        }
    };
};

});


parcelRegister("5qxB6", function(module, exports) {

$parcel$export(module.exports, "defaultLegionClient", () => $d09ae57f90eb8f8f$export$95c697fe95d86a77);

var $3wIxr = parcelRequire("3wIxr");

var $7thXS = parcelRequire("7thXS");
const $d09ae57f90eb8f8f$var$v3UrlPath = `/v3/teams`;
const $d09ae57f90eb8f8f$var$v4UrlPath = `/v4/teams`;
class $d09ae57f90eb8f8f$export$68a6a391e3cf23be extends (0, $7thXS.RestClient) {
    constructor(serviceUrl){
        super({
            serviceUrl: serviceUrl
        });
        this.serviceUrlRoot = serviceUrl;
    }
    setRootUrl(url) {
        if (url === this.serviceUrlRoot) return;
        this.serviceUrlRoot = url;
        this.setServiceUrl(url);
    }
    async getTeamById(teamId) {
        const siteId = this.getCloudId();
        const teamResponse = await this.getResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}?siteId=${siteId}`);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    async getAllTeams(allTeamsQuery) {
        try {
            const orgId = this.getOrgId(allTeamsQuery.orgId);
            const siteId = this.getCloudId();
            const { entities: entities, cursor: cursor } = await this.postResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/search`, {
                organizationId: orgId,
                siteId: siteId,
                limit: allTeamsQuery.limit,
                query: allTeamsQuery.searchQuery,
                cursor: allTeamsQuery.cursor || '',
                sortBy: allTeamsQuery.useDefaultSort ? null : allTeamsQuery.sortBy && allTeamsQuery.sortBy.length > 0 ? allTeamsQuery.sortBy : [
                    {
                        field: 'displayName',
                        order: 'asc'
                    }
                ],
                membership: {
                    memberAccountIds: allTeamsQuery.memberAccountIds
                },
                showEmptyTeams: allTeamsQuery.showEmptyTeams
            });
            const teams = entities.map((t)=>this.mapTeamSearchResponseV4ToTeamWithMembership(t));
            return {
                cursor: cursor,
                teams: teams
            };
        } catch (error) {
            this.logException(error, 'getAllTeams');
            return {
                cursor: '',
                teams: [],
                error: error instanceof Error ? error : undefined
            };
        }
    }
    async updateTeamById(teamId, data) {
        const teamResponse = await this.patchResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, data);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.addUsersToTeam instead
	 */ async inviteUsersToTeam(teamId, users, originQuery) {
        if (!users || users.length === 0) return Promise.resolve([]);
        const emails = [];
        const ids = [];
        users.forEach((user)=>{
            if (user.id) ids.push(user.id);
            else if (user.email) emails.push(user.email);
        });
        const url = `${$d09ae57f90eb8f8f$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/invite?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url, {
            emailAddresses: emails,
            atlassianAccounts: ids
        });
    }
    async getMyTeamMembership(teamId) {
        return this.getResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/me?siteId=${this.getCloudId()}`, {
            shouldLogError: (e)=>e.status !== 400
        });
    }
    async getTeamLinksByTeamId(teamId) {
        let siteId = this.getCloudId();
        let response = await this.getResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links?siteId=${siteId}`);
        return this.mapLegionTeamLinksResponseV4ToTeamLinkResponse(response);
    }
    async createTeamLink(teamId, link) {
        const sanitisedTeamLink = {
            contentTitle: link.contentTitle.trim(),
            linkUri: link.linkUri.trim(),
            description: link.description.trim(),
            ...link.creationTime ? {
                creationTime: link.creationTime.trim()
            } : {},
            ...link.teamId ? {
                teamId: link.teamId.trim()
            } : {}
        };
        const response = await this.postResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links`, sanitisedTeamLink);
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async updateTeamLink(teamId, linkId, { linkUri: linkUri, ...linkFields }) {
        const response = await this.putResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`, {
            linkUri: linkUri.trim(),
            ...linkFields
        });
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async deleteTeamLink(teamId, linkId) {
        return this.deleteResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`);
    }
    async reorderTeamLink(teamId, linkId, newPosition) {
        const queryArgs = `?linkId=${linkId}&newPosition=${newPosition}`;
        return this.postResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/order${queryArgs}`);
    }
    async getOrgEligibilityForManagedTeams() {
        const orgId = this.getOrgId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgEligibilityForManagedTeams');
            throw err;
        }
        return this.getResourceCached(`${$d09ae57f90eb8f8f$var$v4UrlPath}/org/${orgId}/premium/eligibility`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async acceptTeamInvitation(teamId) {
        return this.postResource(`${$d09ae57f90eb8f8f$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/accept`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async declineTeamInvitation(teamId) {
        return this.postResource(`${$d09ae57f90eb8f8f$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/decline`);
    }
    async selfJoinTeam(// TODO Test me
    teamId, originQuery) {
        const url = `${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/join?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url);
    }
    async addAgentsToTeam(teamId, agents) {
        if (!agents || agents.length === 0) {
            const missingAgentsError = new Error('Missing agents to add');
            this.logException(missingAgentsError, 'addAgentToTeam');
            throw missingAgentsError;
        }
        try {
            const url = `${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}/agents`;
            return this.postResource(url, {
                agents: agents
            });
        } catch (e) {
            this.logException(e, 'addAgentToTeam');
            throw e;
        }
    }
    async removeAgentTeamAssociation(teamId, agentId) {
        try {
            const url = `${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}/agents/${agentId}`;
            return this.deleteResource(url);
        } catch (e) {
            this.logException(e, 'removeAgentTeamAssociation');
            throw e;
        }
    }
    async cancelJoinRequest(teamId) {
        return this.deleteResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/request`);
    }
    async acceptJoinRequest(teamId, memberId) {
        return this.postResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/accept`);
    }
    async declineJoinRequest(teamId, memberId) {
        return this.postResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/decline`);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.removeTeamMemberships instead
	 */ async deleteTeamMembership(teamId, memberId) {
        return this.deleteResource(`${$d09ae57f90eb8f8f$var$v3UrlPath}/${this.trimTeamARI(teamId)}/members/${memberId}`);
    }
    /**
	 * @private
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(teamId, memberId) {
        return this.deleteResource(`${$d09ae57f90eb8f8f$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/${memberId}/revoke`);
    }
    async deleteTeam(teamId) {
        return this.deleteResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}`);
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        // This is still not working...
        const members = await this.getResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}/members?size=2&membershipState=FULL_MEMBER&siteId=${this.getCloudId()}`);
        return members.entities.length === 1;
    }
    async createTeam(displayName, originQuery, members, membershipSettings = 'OPEN') {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$d09ae57f90eb8f8f$var$v4UrlPath}?${this.constructProductOriginParams(originQuery)}`;
        const legionTeam = await this.postResource(url, {
            displayName: displayName,
            description: '',
            membershipSettings: membershipSettings,
            siteId: this.getCloudId(),
            organizationId: organizationId,
            members: [
                ...new Set(members)
            ]
        });
        return this.mapTeamCreateResponseV4ToTeam(legionTeam);
    }
    async createExternalTeam(description, externalReference, teamName, siteId) {
        const organizationId = this.getContext().orgId;
        const cloudId = this.getContext().cloudId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$d09ae57f90eb8f8f$var$v4UrlPath}/external?origin.cloudId=${encodeURIComponent(this.getCloudId(siteId || cloudId))}`;
        const legionExternalTeam = await this.postResource(url, {
            description: description,
            externalReference: externalReference,
            organizationId: organizationId,
            siteId: siteId || cloudId,
            displayName: teamName
        });
        return this.mapTeamCreateResponseV4ToTeam(legionExternalTeam);
    }
    async getTeamAndGroupDiff(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/diff`, {
            siteId: siteId,
            externalReference: externalReference
        });
    }
    async linkExistingTeamToGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/link`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async getWriteMediaToken() {
        return this.getResource('/v4/teams/header-image/media-upload').then((response)=>({
                ...response,
                baseUrl: response.baseUrl?.endsWith('/') ? response.baseUrl.slice(0, -1) : response.baseUrl
            }));
    }
    async getSoftDeletedTeamById(teamId) {
        const orgId = this.getOrgId();
        const siteId = this.getCloudId();
        return this.getResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/org/${orgId}/soft-deleted/${this.trimTeamARI(teamId)}?siteId=${siteId}`).then((response)=>({
                ...response.teamResponse,
                id: teamId
            }));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 */ async getUserInSiteUserBase(userId) {
        const siteId = this.getCloudId();
        return this.getResource(`/teams/site/${siteId}/users/${userId}/exists`, {
            headers: {
                Accept: 'application/json',
                'X-header-client-id': 'ptc-fe'
            }
        });
    }
    async retrieveBrowseUserPermission(product) {
        return this.getResourceCached(`/teams/site/${this.getCloudId()}/canSearchUsers?product=${product}`, undefined, // 2 minute expiration, resolves duplicate calls in initial load
        {
            expiration: 120000
        });
    }
    async getPermissions() {
        const orgId = this.getContext().orgId;
        const siteId = this.getCloudId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getPermissions');
            throw err;
        }
        return this.getResourceCached(`${$d09ae57f90eb8f8f$var$v4UrlPath}/permission/self/organization/${orgId}?siteId=${siteId}`);
    }
    async getLinkedTeamsBulk(groupIds) {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getLinkedTeamsBulk');
            throw err;
        }
        const legionExternalTeam = await this.postResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/external/bulk`, {
            organizationId: organizationId,
            source: 'ATLASSIAN_GROUP',
            externalIds: groupIds
        });
        return legionExternalTeam;
    }
    async getTeamProfileDetails(teamId) {
        const siteId = this.getCloudId();
        if (!siteId) {
            const err = new Error('Site ID is required');
            this.logException(err, 'getTeamProfileDetails');
            throw err;
        }
        const linkedTeamsProfileDetails = await this.getResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${teamId}/profile?siteId=${this.getCloudId()}`);
        return linkedTeamsProfileDetails;
    }
    async getOrgScope() {
        const orgId = this.getContext().orgId;
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgScope');
            throw err;
        }
        const orgScope = await this.getResourceCached(`${$d09ae57f90eb8f8f$var$v4UrlPath}/org/${orgId}/scope`);
        return orgScope;
    }
    async restoreTeamToSyncedGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return await this.postResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/${teamId}/external/restore`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async createTeamContainers(payload) {
        return this.postResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/containers`, {
            ...payload
        });
    }
    async getTeamEnabledSites(teamId) {
        const teamEnabledSites = await this.getResourceCached(`${$d09ae57f90eb8f8f$var$v4UrlPath}/migrations/scope/${teamId}`);
        return teamEnabledSites;
    }
    async assignTeamsToSites(migrations) {
        const assignTeamsToSitesResponse = await this.postResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/migrations/scope`, {
            originOrgId: this.getContext().orgId,
            migrations: migrations
        });
        return assignTeamsToSitesResponse;
    }
    async setTeamSiteAssignmentPermission(orgId, alignmentPermission) {
        return this.postResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/migrations/scope/permissions`, {
            orgId: orgId,
            alignmentPermission: alignmentPermission
        });
    }
    async getAssignedTeams(orgId, count, cursor, displayNameContains) {
        const assignedTeamsResponse = await this.postResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/migrations/scope/aligned/search`, {
            orgId: orgId,
            count: count,
            cursor: cursor,
            displayNameContains: displayNameContains
        });
        return assignedTeamsResponse;
    }
    async getUnassignedTeams(orgId, count, cursor, query) {
        const unassignedTeamsResponse = await this.postResource(`${$d09ae57f90eb8f8f$var$v4UrlPath}/migrations/scope/unaligned/search`, {
            orgId: orgId,
            count: count,
            cursor: cursor,
            query: query
        });
        return unassignedTeamsResponse;
    }
    // some Legion APIs return team id with the team ARI
    trimTeamARI(teamId = '') {
        const OLD_TEAM_ARI_PREFIX = 'ari:cloud:teams::team/';
        const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
        return teamId.replace(TEAM_ARI_PREFIX, '').replace(OLD_TEAM_ARI_PREFIX, ''); // PTC-4213 will remove the references to the old team ARI
    }
    constructProductOriginParams(originQuery) {
        const product = (originQuery.product || '').toUpperCase();
        const queries = [
            `origin.cloudId=${encodeURIComponent(this.getCloudId(originQuery.cloudId))}`
        ];
        if (product) queries.push(`origin.product=${encodeURIComponent(product)}`);
        return queries.join('&');
    }
    mapTeamResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            scopeMode: teamResponse.scopeMode,
            isVerified: teamResponse.isVerified,
            ...teamResponse.externalReference && {
                externalReference: {
                    id: teamResponse.externalReference.id,
                    source: teamResponse.externalReference.source
                }
            }
        };
    }
    mapTeamCreateResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            memberIds: teamResponse.membership?.members?.map((m)=>m.membershipId.memberId) || [],
            membership: teamResponse.membership
        };
    }
    mapTeamSearchResponseV4ToTeamWithMembership(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            memberCount: teamResponse.memberCount,
            includesYou: teamResponse.includesYou,
            memberIds: [],
            members: [],
            membership: {
                members: [],
                errors: []
            },
            isVerified: teamResponse.isVerified
        };
    }
    mapLegionTeamLinksResponseV3ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV3ToTeamLink)
        };
    }
    mapLegionTeamLinksResponseV4ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV4ToTeamLink)
        };
    }
    mapLegionTeamLinkResponseV3ToTeamLink(legionLinkResponseV3) {
        return {
            contentTitle: legionLinkResponseV3.contentTitle,
            description: legionLinkResponseV3.description,
            creationTime: legionLinkResponseV3.creationTime,
            linkUri: legionLinkResponseV3.linkUri,
            linkId: legionLinkResponseV3.linkId,
            teamId: legionLinkResponseV3.teamId
        };
    }
    mapLegionTeamLinkResponseV4ToTeamLink(legionLinkResponseV4) {
        return {
            contentTitle: legionLinkResponseV4.contentTitle,
            description: legionLinkResponseV4.description,
            linkUri: legionLinkResponseV4.linkUri,
            linkId: legionLinkResponseV4.linkId,
            teamId: legionLinkResponseV4.teamId
        };
    }
}
const $d09ae57f90eb8f8f$export$95c697fe95d86a77 = new $d09ae57f90eb8f8f$export$68a6a391e3cf23be((0, $3wIxr.DEFAULT_CONFIG).stargateRoot);

});

parcelRegister("4uYvS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad6f8c0018d85636$export$2e2bcd8739ae039);

var $d46SR = parcelRequire("d46SR");

var $3wIxr = parcelRequire("3wIxr");

var $7thXS = parcelRequire("7thXS");
const $ad6f8c0018d85636$var$defaultConfig = {
    serviceUrl: `${(0, $3wIxr.DEFAULT_CONFIG).stargateRoot}/users/manage`
};
const $ad6f8c0018d85636$var$NOT_EDITABLE = 'not_editable';
const $ad6f8c0018d85636$var$NOT_EDITABLE_FIELD = 'field';
const $ad6f8c0018d85636$var$NOT_EDITABLE_REASON = 'reason';
class $ad6f8c0018d85636$export$1f387592ab3ca6d0 extends (0, $7thXS.RestClient) {
    constructor(config = {}){
        super({
            ...$ad6f8c0018d85636$var$defaultConfig,
            ...config
        });
    }
    async getProfileWithMutability(userId) {
        return this.getResource(`/${userId}/profile`).then((resp)=>{
            return $ad6f8c0018d85636$var$mapToMutabilityConstraints(resp);
        });
    }
}
function $ad6f8c0018d85636$var$mapToMutabilityConstraints(json) {
    let constraints = [];
    if (json[$ad6f8c0018d85636$var$NOT_EDITABLE] != null) for (const value of json[$ad6f8c0018d85636$var$NOT_EDITABLE])constraints = constraints.concat({
        field: value[$ad6f8c0018d85636$var$NOT_EDITABLE_FIELD],
        reason: $ad6f8c0018d85636$var$determineReason(value[$ad6f8c0018d85636$var$NOT_EDITABLE_REASON])
    });
    return constraints;
}
function $ad6f8c0018d85636$var$determineReason(value) {
    switch(value){
        case 'managed':
        case 'ext.dir.scim':
        case 'ext.dir.google':
            return value;
        default:
            throw new (0, $d46SR.DefaultError)({
                message: `Unknown mutability constraint reason: ${value}`
            });
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$ad6f8c0018d85636$export$2e2bcd8739ae039 = new $ad6f8c0018d85636$export$1f387592ab3ca6d0();

});

parcelRegister("djSSl", function(module, exports) {

$parcel$export(module.exports, "default", () => $05acaed6a3bcc607$export$2e2bcd8739ae039);

var $3wIxr = parcelRequire("3wIxr");

var $7thXS = parcelRequire("7thXS");

var $gOsz6 = parcelRequire("gOsz6");
const $05acaed6a3bcc607$var$defaultConfig = {
    serviceUrl: `${(0, $3wIxr.DEFAULT_CONFIG).stargateRoot}`
};
class $05acaed6a3bcc607$export$a78b00aedb6cb3e9 extends (0, $7thXS.RestClient) {
    constructor(config = {}){
        super({
            ...$05acaed6a3bcc607$var$defaultConfig,
            ...config
        });
    }
    async getTeamLinkIcons(teamLinkUrls) {
        const requestBody = teamLinkUrls.map((url)=>({
                resourceUrl: url
            }));
        return this.postResourceRaw(`/object-resolver/resolve/batch`, JSON.stringify(requestBody)).then((0, $gOsz6.transformIconData));
    }
    async getAriFromUrl(url) {
        return this.postResourceRaw(`/object-resolver/converter/toAri`, JSON.stringify({
            resourceUrl: url
        })).then((response)=>response?.data?.ari);
    }
    async getWebLinkTitle(webLinkUrl) {
        try {
            const response = await this.postResourceRaw('/object-resolver/resolve', JSON.stringify({
                resourceUrl: webLinkUrl
            }));
            if (response && 'data' in response) {
                if (response.data?.name) return response.data.name;
            }
            if (response && 'meta' in response && (response.meta?.visibility === 'restricted' || response.meta?.visibility === 'unauthorized')) {
                const auth = response.meta.auth?.[0];
                if (auth?.displayName) return auth.displayName;
            }
            return;
        } catch (error) {
            return;
        }
    }
}
var $05acaed6a3bcc607$export$2e2bcd8739ae039 = new $05acaed6a3bcc607$export$a78b00aedb6cb3e9();

});
parcelRegister("gOsz6", function(module, exports) {

$parcel$export(module.exports, "transformIconData", () => $7b31c8389126a075$export$39f4468adf4cb57c);

var $cmOWn = parcelRequire("cmOWn");
const $7b31c8389126a075$export$c64ca1c808335e8b = (jsonLd)=>{
    const { url: url, generator: { name: name, icon: icon } } = jsonLd;
    switch(name){
        case (0, $cmOWn.ProviderNames).CONFLUENCE:
            return {
                linkUrl: url,
                iconUrl: $7b31c8389126a075$var$getConfluenceFavicon(url),
                productName: name
            };
        case (0, $cmOWn.ProviderNames).JIRA:
            return {
                linkUrl: url,
                iconUrl: $7b31c8389126a075$var$getJiraFavicon(url),
                productName: name
            };
        default:
            return {
                linkUrl: url,
                iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                productName: name
            };
    }
};
const $7b31c8389126a075$var$isIconItemSuccess = (response)=>{
    return response.status === 200;
};
const $7b31c8389126a075$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($7b31c8389126a075$var$isIconItemSuccess).map((resp)=>resp.body.data).map($7b31c8389126a075$export$c64ca1c808335e8b).filter((linkIconData)=>linkIconData.iconUrl !== undefined);
const $7b31c8389126a075$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
const $7b31c8389126a075$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;

});
parcelRegister("cmOWn", function(module, exports) {

$parcel$export(module.exports, "ProviderNames", () => $28e53770cbcb96bf$export$132d457a8475f4c8);
/**
 * This type matches the props for the TeamLinkIcon component in embeddable-directory
 */ var $28e53770cbcb96bf$export$132d457a8475f4c8 = /*#__PURE__*/ function(ProviderNames) {
    ProviderNames["CONFLUENCE"] = "Confluence";
    ProviderNames["JIRA"] = "Jira";
    return ProviderNames;
}({});

});



parcelRegister("5BW7H", function(module, exports) {

$parcel$export(module.exports, "default", () => $c407ba67220f21af$export$2e2bcd8739ae039);

var $3wIxr = parcelRequire("3wIxr");

var $7thXS = parcelRequire("7thXS");
class $c407ba67220f21af$export$23820d8d740dd467 extends (0, $7thXS.RestClient) {
    getIsSiteAdmin(/**
		 * @private
		 * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
		 */ cloudId) {
        return this.postResource('/permitted', {
            permissionId: 'manage',
            resourceId: `ari:cloud:platform::site/${this.getCloudId(cloudId)}`
        }).then((response)=>response.permitted);
    }
}
var /**
 * REST Client to make calls to resources on the activity service.
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
$c407ba67220f21af$export$2e2bcd8739ae039 = new $c407ba67220f21af$export$23820d8d740dd467({
    serviceUrl: (0, $3wIxr.DEFAULT_CONFIG).permsServiceUrl
});

});

parcelRegister("43CGC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e0428ba57883fc5$export$2e2bcd8739ae039);

var $d46SR = parcelRequire("d46SR");

var $3wIxr = parcelRequire("3wIxr");

var $7thXS = parcelRequire("7thXS");
const $6e0428ba57883fc5$var$V1_URL = '/teams/v1';
const $6e0428ba57883fc5$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE = [
    'TEAM_NOT_FOUND'
];
class $6e0428ba57883fc5$export$38575d07403d67c extends (0, $7thXS.RestClient) {
    constructor(serviceUrlRoot){
        super({
            serviceUrl: serviceUrlRoot
        });
    }
    async addUsersToTeam(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to add');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$6e0428ba57883fc5$var$V1_URL}/org/${orgId}/teams/${teamId}/members/add`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'addUsersToTeam');
            if (e instanceof (0, $d46SR.HttpError) && $6e0428ba57883fc5$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE.includes(e.message)) throw new (0, $d46SR.SLOIgnoreHttpError)(e);
            throw e;
        }
    }
    async removeTeamMemberships(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to remove');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$6e0428ba57883fc5$var$V1_URL}/org/${orgId}/teams/${teamId}/members/remove`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'removeTeamMemberships');
            throw e;
        }
    }
    async getTeamDetails(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$6e0428ba57883fc5$var$V1_URL}/org/${orgId}/teams/${teamId}`;
            const response = await this.getResource(url);
            return response;
        } catch (e) {
            this.logException(e, 'getTeamDetails');
            throw e;
        }
    }
    async getTeamMembers(teamId, first = 50, after) {
        try {
            const orgId = this.getOrgId();
            const url = `${$6e0428ba57883fc5$var$V1_URL}/org/${orgId}/teams/${teamId}/members`;
            const response = await this.postResource(url, {
                after: after,
                first: first
            });
            return response;
        } catch (e) {
            this.logException(e, 'getTeamMembers');
            throw e;
        }
    }
    async restoreTeam(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$6e0428ba57883fc5$var$V1_URL}/org/${orgId}/teams/${teamId}/restore`;
            return this.postResource(url);
        } catch (e) {
            this.logException(e, 'restoreTeam');
            throw e;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$6e0428ba57883fc5$export$2e2bcd8739ae039 = new $6e0428ba57883fc5$export$38575d07403d67c((0, $3wIxr.DEFAULT_CONFIG).publicApiRoot);

});

parcelRegister("kkLwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbfd4df956031511$export$2e2bcd8739ae039);

var $3wIxr = parcelRequire("3wIxr");

var $7thXS = parcelRequire("7thXS");
const $dbfd4df956031511$var$defaultConfig = {
    serviceUrl: `${(0, $3wIxr.DEFAULT_CONFIG).stargateRoot}/user-tenure/v1`
};
class $dbfd4df956031511$export$e019a6241c871c27 extends (0, $7thXS.RestClient) {
    constructor(config = {}){
        super({
            ...$dbfd4df956031511$var$defaultConfig,
            ...config
        });
    }
    async getUserTenure(userId) {
        const orgId = this.getOrgId();
        return this.getResource(`/${orgId}/${userId}`).then((response)=>({
                ...response,
                userHireDate: new Date(response.userHireDate)
            })).catch((error)=>{
            throw new Error('Failed to fetch user tenure');
        });
    }
}
var $dbfd4df956031511$export$2e2bcd8739ae039 = new $dbfd4df956031511$export$e019a6241c871c27();

});

parcelRegister("kkver", function(module, exports) {

$parcel$export(module.exports, "default", () => $49c1005ef159bd71$export$2e2bcd8739ae039);

var $3wIxr = parcelRequire("3wIxr");

var $b0tIZ = parcelRequire("b0tIZ");

var $3lkCh = parcelRequire("3lkCh");

var $2swtl = parcelRequire("2swtl");

var $kjySs = parcelRequire("kjySs");

var $8rivz = parcelRequire("8rivz");

var $hxYb0 = parcelRequire("hxYb0");

var $adiVY = parcelRequire("adiVY");

var $iaBBZ = parcelRequire("iaBBZ");

var $8xRFJ = parcelRequire("8xRFJ");

var $9oJQG = parcelRequire("9oJQG");

var $51xZ9 = parcelRequire("51xZ9");
class $49c1005ef159bd71$export$de0359e19b851166 extends (0, $b0tIZ.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super((0, $51xZ9.getUnshardedTeamCentralGraphqlUrl)(baseUrl), config);
    }
    // Team central url is a bit special, that it depends on cloudId.
    setBaseUrl(baseUrl) {
        const cloudId = this.getCloudId();
        this.setServiceUrl(cloudId && cloudId !== 'None' ? (0, $51xZ9.getTeamCentralGraphqlUrl)(baseUrl, cloudId) : (0, $51xZ9.getUnshardedTeamCentralGraphqlUrl)(baseUrl));
    }
    async addTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $2swtl.AddTeamWatcherMutation),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'addTeamWatcher'
        });
        return response.addTeamWatcher;
    }
    async removeTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $8xRFJ.RemoveTeamWatcherMutation),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'removeTeamWatcher'
        });
        return response.removeTeamWatcher;
    }
    async deleteKudos(id) {
        const response = await this.makeGraphQLRequest({
            query: (0, $iaBBZ.KudosDeleteMutation),
            variables: {
                id: id
            }
        }, {
            operationName: 'DeleteKudos'
        });
        return response.deleteKudos;
    }
    async queryTagList(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $9oJQG.TagListQuery),
            variables: variables
        }, {
            operationName: 'TagListByCloudId'
        });
        return response.tagSearchByCloudId;
    }
    async createTag(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $kjySs.CreateTagMutation),
            variables: variables
        }, {
            operationName: 'createTagForCloudId'
        });
        return response.createTagForCloudId;
    }
    async createHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $8rivz.HelpPointerCreateMutation),
            variables: variables
        }, {
            operationName: 'CreateHelpPointer'
        });
        return response.createHelpPointer;
    }
    async updateHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $adiVY.HelpPointerUpdateMutation),
            variables: variables
        }, {
            operationName: 'UpdateHelpPointer'
        });
        return response.updateHelpPointer;
    }
    async deleteHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $hxYb0.HelpPointerDeleteMutation),
            variables: variables
        }, {
            operationName: 'DeleteHelpPointer'
        });
        return response.deleteHelpPointer;
    }
}
var $49c1005ef159bd71$export$2e2bcd8739ae039 = new $49c1005ef159bd71$export$de0359e19b851166((0, $3wIxr.DEFAULT_CONFIG).stargateRoot, {
    logException: $3lkCh.logException
});

});
parcelRegister("2swtl", function(module, exports) {

$parcel$export(module.exports, "AddTeamWatcherMutation", () => $ea2e0a91f4cf662e$export$2af9f827ad8bcf83);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $ea2e0a91f4cf662e$export$2af9f827ad8bcf83 = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation addTeamWatcher($teamId: String!, $cloudId: String) {
		addTeamWatcher(input: { teamId: $teamId, cloudId: $cloudId }) {
			isWatching
			__typename
		}
	}
`);

});

parcelRegister("kjySs", function(module, exports) {

$parcel$export(module.exports, "CreateTagMutation", () => $ab0b12fb23f5dd55$export$5e59562b4f09e8ef);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $ab0b12fb23f5dd55$export$5e59562b4f09e8ef = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation createTagForCloudId($name: String!, $cloudId: String!) {
		createTagForCloudId(input: { name: $name, cloudId: $cloudId }) {
			tag {
				id
				uuid
				name
			}
		}
	}
`);

});

parcelRegister("8rivz", function(module, exports) {

$parcel$export(module.exports, "HelpPointerCreateMutation", () => $8e5a225381183d6f$export$a563da8c932d52b1);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $8e5a225381183d6f$export$a563da8c932d52b1 = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation CreateHelpPointer(
		$cloudId: String!
		$description: String
		$icon: IconInput
		$tagUuids: [UUID]
		$link: String!
		$name: String!
		$teamId: String!
		$type: HelpPointerType!
	) {
		createHelpPointer(
			input: {
				cloudId: $cloudId
				description: $description
				icon: $icon
				tagUuids: $tagUuids
				link: $link
				name: $name
				teamId: $teamId
				type: $type
			}
		) {
			helpPointer {
				id
			}
		}
	}
`);

});

parcelRegister("hxYb0", function(module, exports) {

$parcel$export(module.exports, "HelpPointerDeleteMutation", () => $1711afd552c828ec$export$558c9434019572a1);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $1711afd552c828ec$export$558c9434019572a1 = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation DeleteHelpPointer($id: ID!) {
		deleteHelpPointer(input: { id: $id }) {
			success
		}
	}
`);

});

parcelRegister("adiVY", function(module, exports) {

$parcel$export(module.exports, "HelpPointerUpdateMutation", () => $24caf4f08ec8403a$export$95b572ae48a37250);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $24caf4f08ec8403a$export$95b572ae48a37250 = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation UpdateHelpPointer(
		$id: ID!
		$description: String
		$teamId: String
		$newTeamName: String
		$icon: IconInput
		$tagUuids: [UUID]
		$link: String
		$name: String
		$type: HelpPointerType
	) {
		updateHelpPointer(
			input: {
				id: $id
				description: $description
				icon: $icon
				tagUuids: $tagUuids
				link: $link
				teamId: $teamId
				newTeamName: $newTeamName
				name: $name
				type: $type
			}
		) {
			helpPointer {
				id
			}
		}
	}
`);

});

parcelRegister("iaBBZ", function(module, exports) {

$parcel$export(module.exports, "KudosDeleteMutation", () => $aa3d12f08598435c$export$fc4c702e715ad2a4);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $aa3d12f08598435c$export$fc4c702e715ad2a4 = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation DeleteKudos($id: ID!) {
		deleteKudos(input: { id: $id }) {
			success
			kudos {
				id
			}
		}
	}
`);

});

parcelRegister("8xRFJ", function(module, exports) {

$parcel$export(module.exports, "RemoveTeamWatcherMutation", () => $bcf7d1fd8b9859e2$export$d1957676c49feb6a);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $bcf7d1fd8b9859e2$export$d1957676c49feb6a = (0, $6NFTG.print)((0, $kuAvn.default)`
	mutation removeTeamWatcher($teamId: String!, $cloudId: String) {
		removeTeamWatcher(input: { teamId: $teamId, cloudId: $cloudId }) {
			isWatching
			__typename
		}
	}
`);

});

parcelRegister("9oJQG", function(module, exports) {

$parcel$export(module.exports, "TagListQuery", () => $c9b62af1af5f0f2d$export$2c592b5c06672873);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");
const $c9b62af1af5f0f2d$export$2c592b5c06672873 = (0, $6NFTG.print)((0, $kuAvn.default)`
	query TagListByCloudId($q: String!, $cloudId: String!, $first: Int) {
		tagSearchByCloudId(q: $q, cloudId: $cloudId, first: $first) {
			edges {
				node {
					id
					uuid
					name
					projects {
						count
					}

					goals {
						count
					}

					helpLinks {
						count
					}
				}
			}
		}
	}
`);

});

parcelRegister("51xZ9", function(module, exports) {

$parcel$export(module.exports, "getTeamCentralGraphqlUrl", () => $805d1bcf88295157$export$ada1892306a6b676);
$parcel$export(module.exports, "getUnshardedTeamCentralGraphqlUrl", () => $805d1bcf88295157$export$71356c4826ea823a);
const $805d1bcf88295157$export$ada1892306a6b676 = (baseUrl, cloudId)=>`${baseUrl}/townsquare/s/${cloudId}/graphql`;
const $805d1bcf88295157$export$71356c4826ea823a = (baseUrl)=>`${baseUrl}/watermelon/graphql`;

});


parcelRegister("bWtrI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a214dbc049d4e9c0$export$2e2bcd8739ae039);

var $3wIxr = parcelRequire("3wIxr");

var $7thXS = parcelRequire("7thXS");
const $a214dbc049d4e9c0$var$defaultConfig = {
    serviceUrl: `${(0, $3wIxr.DEFAULT_CONFIG).stargateRoot}/teamsslack/api/team`
};
class $a214dbc049d4e9c0$export$9509cbc6b0605446 extends (0, $7thXS.RestClient) {
    constructor(config = {}){
        super({
            ...$a214dbc049d4e9c0$var$defaultConfig,
            ...config
        });
    }
    async getTeamInSlack(teamId, teamName) {
        return this.getResource(`/${teamId}?teamName=${encodeURIComponent(teamName)}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async disconnectTeamInSlack(teamId) {
        return this.deleteResource(`/${teamId}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async updateTeamInSlack(teamId, channelId, usergroupHandle) {
        return this.postResource(`/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
}
var $a214dbc049d4e9c0$export$2e2bcd8739ae039 = new $a214dbc049d4e9c0$export$9509cbc6b0605446();

});

parcelRegister("7rZUs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d519244f4768f878$export$2e2bcd8739ae039);

var $3wIxr = parcelRequire("3wIxr");

var $7thXS = parcelRequire("7thXS");
const $d519244f4768f878$var$buildGetReadTokenURL = (accountId)=>`/api/user-image/${accountId}/header-image/read`;
class $d519244f4768f878$export$3c27e20d1b94924 extends (0, $7thXS.RestClient) {
    async getReadMediaToken(accountId) {
        return this.getResource($d519244f4768f878$var$buildGetReadTokenURL(accountId)).then((response)=>response);
    }
    async getWriteMediaToken() {
        return this.getResource('/api/user-image/header-image/write').then((response)=>response);
    }
    async updateUserHeaderImage(headerImageId) {
        return await this.putResource('/api/user-image/self/header-image', {
            headerImageId: headerImageId
        });
    }
}
var $d519244f4768f878$export$2e2bcd8739ae039 = new $d519244f4768f878$export$3c27e20d1b94924({
    serviceUrl: (0, $3wIxr.DEFAULT_CONFIG).stargateRoot
});

});


parcelRegister("dJPFv", function(module, exports) {

$parcel$export(module.exports, "transformPermissions", () => $92973d925c6e954d$export$7fe0bfa353103198);
const $92973d925c6e954d$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        switch(permission){
            case 'CAN_CREATE_TEAMS':
                return {
                    ...acc,
                    canCreateTeams: true
                };
            case 'CAN_VIEW_TEAMS':
                return {
                    ...acc,
                    canViewTeams: true
                };
            case 'CAN_ADMIN_TEAMS':
                return {
                    ...acc,
                    canAdminTeams: true
                };
            default:
                return acc;
        }
    }, {
        canCreateTeams: false,
        canViewTeams: false,
        canAdminTeams: false
    });
};

});



parcelRegister("j5w1g", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuOverrides", () => $f277d80a5b8e6b44$export$c6e6fe52d34907dc);
var $f277d80a5b8e6b44$export$c6e6fe52d34907dc = /*#__PURE__*/ function(PeopleMenuOverrides) {
    PeopleMenuOverrides["createTeamsDisabled"] = "create-teams-disabled";
    PeopleMenuOverrides["viewTeamsDisabled"] = "view-teams-disabled";
    return PeopleMenuOverrides;
}({});

});



parcelRegister("4Goo7", function(module, exports) {

$parcel$export(module.exports, "openInNewTab", () => $f97e399efeb29f2c$export$9e52b10d57ddf9e3);
const $f97e399efeb29f2c$export$9e52b10d57ddf9e3 = (url)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.open(url, '_blank');
};

});

parcelRegister("cMxGi", function(module, exports) {

let $94e4181cfeeb8f07$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $94e4181cfeeb8f07$var$load("co6GU").then(()=>parcelRequire('d0BUb'));

});


parcelRegister("2VH7W", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $f30d0544b33f01e8$export$b9ec44715ae5ad99);

var $eJOHy = parcelRequire("eJOHy");

var $bILK0 = parcelRequire("bILK0");

var $hsAfg = parcelRequire("hsAfg");

var $8w5Cq = parcelRequire("8w5Cq");

var $vr8NS = parcelRequire("vr8NS");

var $g32Ua = parcelRequire("g32Ua");

var $dSkLG = parcelRequire("dSkLG");

var $g9Vr6 = parcelRequire("g9Vr6");

var $8vyDv = parcelRequire("8vyDv");

var $kEUB1 = parcelRequire("kEUB1");

var $3MbOI = parcelRequire("3MbOI");

var $2UBs9 = parcelRequire("2UBs9");

var $7jTnu = parcelRequire("7jTnu");

var $crZ8w = parcelRequire("crZ8w");

var $lRq8t = parcelRequire("lRq8t");

var $4yUYS = parcelRequire("4yUYS");

var $ccYyA = parcelRequire("ccYyA");

var $k8PfX = parcelRequire("k8PfX");
const $f30d0544b33f01e8$export$b9ec44715ae5ad99 = ()=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { data: projectSidebarNavigationData } = (0, $dSkLG.useProjectSidebarNavigation)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { software: software } = (0, $8vyDv.useAppEditions)();
    const { data: currentUser } = (0, $3MbOI.useCurrentUser)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    let fetchInviteRecommendationsService = (0, $eJOHy.useCallback)((_)=>Promise.resolve([]), []);
    let mapToFeaturedUserService = (0, $eJOHy.useCallback)((_)=>[], []);
    if ((0, $7jTnu.fg)('tepi-3p-core-invites-slack-rec-ux')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        fetchInviteRecommendationsService = (0, $2UBs9.useService)((0, $crZ8w.fetch3PInviteRecommendations));
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        mapToFeaturedUserService = (0, $2UBs9.useService)((0, $crZ8w.mapToFeaturedUser));
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let continueUrl = window.location.href;
    if (currentUser?.user?.accountId) {
        const url = new URL(continueUrl);
        url.searchParams.append('inviterId', currentUser.user.accountId);
        continueUrl = url.toString();
    }
    const subProduct = (0, $g32Ua.projectTypeToSubProduct)(projectSidebarNavigationData?.projectType);
    if (subProduct === 'software') continueUrl = (0, $4yUYS.getContinueUrlWithWelcomeModal)(continueUrl);
    const fetchInviteRecommendations = (0, $eJOHy.useCallback)(async ()=>{
        if ((0, $7jTnu.fg)('tepi-3p-core-invites-slack-rec-ux')) {
            const inviteRecommendationsFromSlack = await fetchInviteRecommendationsService({
                limit: 10
            }).then((recommendations)=>{
                return mapToFeaturedUserService({
                    userInfo: recommendations,
                    tooltipRenderer: (user)=>formatMessage((0, $k8PfX.default).inviteRecommendationsFromSlack, {
                            email: user.email
                        })
                });
            });
            return inviteRecommendationsFromSlack;
        }
        return [];
    }, [
        fetchInviteRecommendationsService,
        mapToFeaturedUserService,
        formatMessage
    ]);
    const addFlag = (0, $eJOHy.useCallback)(({ appearance: appearance, ...flagProps })=>{
        const Flag = $f30d0544b33f01e8$var$getFlagComponent(appearance);
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Flag, {
                ...flagProps,
                ...serviceProps,
                messageId: `navigation-apps-sidebar-nav4-sidebars-content-teams.ui.flag.showFlag.${appearance}.${flagProps.id}`,
                messageType: "transactional"
            }));
    }, [
        showFlag
    ]);
    const { openModal: invitePeopleModalTrigger } = (0, $ccYyA.useInvitePeopleModal)({
        continueUrl: continueUrl,
        enableThirdParty: true,
        displayInfiSpotlight: true,
        orgId: orgId,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        showFlag: addFlag,
        source: 'peopleMenu',
        subProduct: subProduct,
        experimental_applicationEdition: software,
        navigation: {
            directoryContextEntryPoint: '/jira'
        },
        onSubmit: async (data)=>{
            await data.defaultOnSubmit();
        },
        experimental_featuredUsers: fetchInviteRecommendations
    });
    return invitePeopleModalTrigger;
};
const $f30d0544b33f01e8$var$getFlagComponent = (appearance)=>{
    switch(appearance){
        case 'warning':
            return 0, $vr8NS.default;
        case 'error':
            return 0, $hsAfg.default;
        case 'success':
        case 'normal':
        default:
            return 0, $8w5Cq.default;
    }
};

});
parcelRegister("g32Ua", function(module, exports) {

$parcel$export(module.exports, "stripUrlToIssueKey", () => $cab6d9604eb8817d$export$1f3c6284caef177b);
$parcel$export(module.exports, "useInvitePeopleFlags", () => $cab6d9604eb8817d$export$ab5fb7206b83c9ad);
$parcel$export(module.exports, "projectTypeToSubProduct", () => $cab6d9604eb8817d$export$3500077858760067);
$parcel$export(module.exports, "jiraProjectTypeToSubProduct", () => $cab6d9604eb8817d$export$9ce9c3ad0c2c5c71);

var $eJOHy = parcelRequire("eJOHy");

var $bILK0 = parcelRequire("bILK0");

var $hsAfg = parcelRequire("hsAfg");

var $gCMUf = parcelRequire("gCMUf");

var $8w5Cq = parcelRequire("8w5Cq");

var $vr8NS = parcelRequire("vr8NS");
const $cab6d9604eb8817d$var$ISSUE_KEY_REGEXP = /(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
const $cab6d9604eb8817d$export$1f3c6284caef177b = (candidateUrl)=>{
    const match = candidateUrl.match($cab6d9604eb8817d$var$ISSUE_KEY_REGEXP);
    return match && match[1];
};
const $cab6d9604eb8817d$export$ab5fb7206b83c9ad = ()=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const addFlag = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        let FlagComponent = (0, $gCMUf.default);
        // eslint-disable-next-line default-case
        switch(appearance){
            case 'success':
            case 'normal':
                FlagComponent = (0, $8w5Cq.default);
                break;
            case 'warning':
                FlagComponent = (0, $vr8NS.default);
                break;
            case 'error':
                FlagComponent = (0, $hsAfg.default);
                break;
        }
        showFlag((serviceProps)=>{
            const props = {
                ...flagProps,
                ...serviceProps,
                messageId: `invite-people-drawer.ui.content.flag-component.${appearance}.${flagProps.id}`,
                messageType: 'transactional'
            };
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FlagComponent, props);
        });
    }, [
        showFlag
    ]);
    return {
        addFlag: addFlag
    };
};
const $cab6d9604eb8817d$export$3500077858760067 = (projectType)=>{
    switch(projectType){
        case 'jira_software':
            return 'software';
        case 'jira_service_management':
            return 'servicedesk';
        case 'jira_work_management':
            return 'core';
        case 'jira_product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};
const $cab6d9604eb8817d$export$9ce9c3ad0c2c5c71 = (projectType)=>{
    switch(projectType){
        case 'software':
            return 'software';
        case 'service_desk':
            return 'servicedesk';
        case 'business':
            return 'core';
        case 'product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};

});
parcelRegister("gCMUf", function(module, exports) {

$parcel$export(module.exports, "default", () => $222ec082ddcdfa74$export$2e2bcd8739ae039);

var $a9cht = parcelRequire("a9cht");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$222ec082ddcdfa74$export$2e2bcd8739ae039 = (0, $a9cht.InfoFlag);

});


parcelRegister("2UBs9", function(module, exports) {

$parcel$export(module.exports, "useService", () => $97d3dd764d989814$export$6de4685a6c88b4e9);

var $eJOHy = parcelRequire("eJOHy");

var $kEUB1 = parcelRequire("kEUB1");

var $8q7lT = parcelRequire("8q7lT");

var $eTw5X = parcelRequire("eTw5X");

var $gYnSx = parcelRequire("gYnSx");

var $804Kx = parcelRequire("804Kx");

var $i1bbF = parcelRequire("i1bbF");

var $4HZCb = parcelRequire("4HZCb");
const $97d3dd764d989814$var$useEnvironmentDeps = ()=>{
    // Use product's hooks to build a bag of dependencies
    // that the product environment will provide to the services.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $804Kx.useAnalyticsEvents)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const product = (0, $4HZCb.useJiraCurrentProduct)();
    const atlassianAccountId = (0, $8q7lT.useAccountId)();
    return (0, $eJOHy.useMemo)(()=>({
            createAnalyticsEvent: createAnalyticsEvent,
            fetchJSON: (0, $i1bbF.jiraFetchJson),
            getCurrentCloudId: ()=>cloudId,
            getCurrentProduct: ()=>product,
            getCurrentUserId: ()=>atlassianAccountId,
            fireErrorAnalytics: $gYnSx.default
        }), [
        createAnalyticsEvent,
        cloudId,
        product,
        atlassianAccountId
    ]);
};
const $97d3dd764d989814$export$6de4685a6c88b4e9 = (service, providedDeps)=>{
    const environmentDeps = $97d3dd764d989814$var$useEnvironmentDeps();
    const deps = (0, $eJOHy.useMemo)(()=>({
            ...environmentDeps,
            ...providedDeps
        }), [
        environmentDeps,
        providedDeps
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $eTw5X.useService)(service, deps);
};

});
parcelRegister("804Kx", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $c21c35fb8e0a29fe$export$5bf35293e545f20c);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");
const $c21c35fb8e0a29fe$var$AnalyticsWebClientTypeToJiraEventType = {
    sendTrackEvent: 'TRACK',
    sendUIEvent: 'UI',
    sendScreenEvent: 'SCREEN',
    sendOperationalEvent: 'OPERATIONAL'
};
const $c21c35fb8e0a29fe$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEventNotFireable } = (0, $f1Zdy.useAnalyticsEvents)();
    return (0, $eJOHy.useMemo)(()=>{
        const createAnalyticsEvent = (payload)=>{
            const event = createAnalyticsEventNotFireable(payload);
            // event.fire() coming from `createAnalyticsEvent` does not actually send the event in Jira,
            // so we need to patch it here, ensuring it goes throught the analytics bridge correctly
            event.fire = ()=>{
                const awcType = payload.type;
                const jiraBridgeEventType = $c21c35fb8e0a29fe$var$AnalyticsWebClientTypeToJiraEventType[awcType];
                if (!jiraBridgeEventType) return;
                (0, $gCeeo.fireAnalytics)(event, jiraBridgeEventType, payload.data);
            };
            return event;
        };
        return {
            createAnalyticsEvent: createAnalyticsEvent
        };
    }, [
        createAnalyticsEventNotFireable
    ]);
};

});

parcelRegister("i1bbF", function(module, exports) {

$parcel$export(module.exports, "jiraFetchJson", () => $ed8c3e541183e2e1$export$a1dfe802bc656913);

var $1Ozm9 = parcelRequire("1Ozm9");
const $ed8c3e541183e2e1$export$a1dfe802bc656913 = (input)=>{
    const url = input.url;
    const options = input;
    return (0, $1Ozm9.default)(url, options);
};

});

parcelRegister("4HZCb", function(module, exports) {

$parcel$export(module.exports, "useJiraCurrentProduct", () => $4ce1f4f52831212e$export$47a383c930365f5d);

var $eNgPF = parcelRequire("eNgPF");
const $4ce1f4f52831212e$export$47a383c930365f5d = ()=>{
    const productName = (0, $eNgPF.useProductName)();
    switch(productName){
        case 'core':
            return 'jira-core';
        case 'jira':
            return 'jira-software';
        case 'serviceDesk':
            return 'jira-servicedesk';
        case 'product-discovery':
            return 'jira-product-discovery';
        default:
            return 'jira-core';
    }
};

});
parcelRegister("eNgPF", function(module, exports) {

$parcel$export(module.exports, "useProductName", () => $5964e911466bfcfe$export$dde400a84de238be);

var $iW0U8 = parcelRequire("iW0U8");

var $fkuMr = parcelRequire("fkuMr");
const $5964e911466bfcfe$export$dde400a84de238be = ()=>{
    const appPermissions = (0, $iW0U8.useApplicationPermissions)();
    return (0, $fkuMr.getProductName)(appPermissions);
};

});
parcelRegister("iW0U8", function(module, exports) {

$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $bdcb134d679d4aa6$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $bdcb134d679d4aa6$export$4d9cadb4042acc1b);

var $ahm5r = parcelRequire("ahm5r");

var $ht3nQ = parcelRequire("ht3nQ");

var $7NgPv = parcelRequire("7NgPv");

var $lvKO5 = parcelRequire("lvKO5");
const $bdcb134d679d4aa6$var$selector = (0, $ahm5r.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $bdcb134d679d4aa6$export$d8c76f7e52d0a856 = (0, $ht3nQ.createSubscriber)((0, $7NgPv.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $bdcb134d679d4aa6$var$selector
});
const $bdcb134d679d4aa6$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});

parcelRegister("fkuMr", function(module, exports) {

$parcel$export(module.exports, "getProductName", () => $b02787b405cc91ae$export$aa3f36fe5dd1f237);

var $7jTnu = parcelRequire("7jTnu");
const $b02787b405cc91ae$export$aa3f36fe5dd1f237 = (permissions)=>{
    if ((0, $7jTnu.fg)('jcs_master_flag')) {
        const { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCustomerServiceAccess: hasCustomerServiceAccess, hasCoreAccess: hasCoreAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = permissions;
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProductName'.
        return ([
            {
                condition: hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
                value: 'software'
            },
            {
                condition: hasServiceDeskAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
                value: 'serviceDesk'
            },
            {
                condition: hasCoreAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
                value: 'core'
            },
            {
                condition: hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasCustomerServiceAccess,
                value: 'product-discovery'
            },
            {
                condition: hasCustomerServiceAccess && !hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess,
                value: 'customer-service'
            }
        ].find((item)=>item.condition) || {
            value: 'jira'
        }).value;
    }
    const { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = permissions;
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProductName'.
    return ([
        {
            condition: hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess,
            value: 'software'
        },
        {
            condition: hasServiceDeskAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess,
            value: 'serviceDesk'
        },
        {
            condition: hasCoreAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess,
            value: 'core'
        },
        {
            condition: hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess,
            value: 'product-discovery'
        }
    ].find((item)=>item.condition) || {
        value: 'jira'
    }).value;
};

});




parcelRegister("crZ8w", function(module, exports) {

$parcel$export(module.exports, "fetch3PInviteRecommendations", () => $d7ba0a38e5c924d3$export$fe357fea13f62bfe);
$parcel$export(module.exports, "mapToFeaturedUser", () => $d7ba0a38e5c924d3$export$44d2a44df9cb01bb);
/**
 * This file defines the recommendations3P() service.
 */ 
var $3MKOV = parcelRequire("3MKOV");

var $eOyXs = parcelRequire("eOyXs");
const $d7ba0a38e5c924d3$var$dependencies = {
    fetchJSON: $eOyXs.fetchJSON,
    createAnalyticsEvent: $3MKOV.createAnalyticsEvent,
    fireErrorAnalytics: $3MKOV.fireErrorAnalytics,
    getCurrentCloudId: $3MKOV.getCurrentCloudId,
    getCurrentProduct: $3MKOV.getCurrentProduct
};
const $d7ba0a38e5c924d3$export$fe357fea13f62bfe = Object.assign($d7ba0a38e5c924d3$export$828ff91521f41431, {
    dependencies: $d7ba0a38e5c924d3$var$dependencies
});
async function $d7ba0a38e5c924d3$export$828ff91521f41431(input, context) {
    const deps = context.dependencies();
    const cloudId = input.targetCloudId ?? deps.getCurrentCloudId();
    const limit = input.limit;
    const product = input.targetProduct ?? deps.getCurrentProduct();
    try {
        const response = await deps.fetchJSON({
            url: `/gateway/api/pi-gateway/frontend/api/1/recommend/invite-users?limit=${limit}&targetCloudId=${cloudId}&targetProduct=${product}`,
            method: 'GET'
        });
        return response.recommendations;
    } catch (error) {
        deps.fireErrorAnalytics({
            meta: {
                id: 'fetchInviteRecommendations3P',
                packageName: 'expansion-services',
                teamName: 'Groot'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return [];
    }
}
const $d7ba0a38e5c924d3$var$mapToFeaturedUserImpl = (input)=>{
    return input.userInfo.map((user, index)=>({
            email: user.email,
            name: user.displayName,
            avatarUrl: user.avatarUrl,
            source: user.source,
            tooltip: input.tooltipRenderer(user),
            id: user.atlassianAccountId ?? user.thirdPartyUserId
        }));
};
const $d7ba0a38e5c924d3$export$44d2a44df9cb01bb = Object.assign($d7ba0a38e5c924d3$var$mapToFeaturedUserImpl, {
    dependencies: {}
});

});

parcelRegister("4yUYS", function(module, exports) {

$parcel$export(module.exports, "isValidNthUserWelcomePath", () => $4ebbd9b96095663b$export$9d8d745dc961cc24);
$parcel$export(module.exports, "getContinueUrlWithWelcomeModal", () => $4ebbd9b96095663b$export$30a1130917ef5d13);

var $7jTnu = parcelRequire("7jTnu");
const $4ebbd9b96095663b$export$dc90482e4ef07afd = ()=>{
    if (typeof window !== 'undefined') return window.location.href;
    return '';
};
const $4ebbd9b96095663b$export$9d8d745dc961cc24 = (path)=>{
    try {
        const url = new URL(path);
        const pathname = url.pathname;
        const regex = /^(?:\/jira\/[^/]+\/(?:c\/)?projects\/[^/]+\/(board|boards(?:\/[^/]+(?:\/backlog)?)?|board\/[^/]+\/backlog)\/?|\/browse\/[^/]+\/?)$/;
        return regex.test(pathname);
    } catch  {
        return false;
    }
};
const $4ebbd9b96095663b$export$30a1130917ef5d13 = (path)=>{
    const currentUrl = path || $4ebbd9b96095663b$export$dc90482e4ef07afd();
    if (!(0, $7jTnu.fg)('jira_nth_user_workitem_recommendation_killswitch') || !$4ebbd9b96095663b$export$9d8d745dc961cc24(currentUrl)) return currentUrl;
    const url = new URL(currentUrl);
    url.searchParams.append('showNthUserWelcomeModal', 'true');
    return url.toString();
};

});

parcelRegister("ccYyA", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $02b82ccba94e9abb$export$b9ec44715ae5ad99);
$parcel$export(module.exports, "InvitePeopleModalContextProvider", () => $02b82ccba94e9abb$export$496e4f58036bb94d);

var $eJOHy = parcelRequire("eJOHy");

var $031lN = parcelRequire("031lN");

var $kJYSe = parcelRequire("kJYSe");
var $1tjhr = parcelRequire("1tjhr");

var $epTsa = parcelRequire("epTsa");

var $hbF3h = parcelRequire("hbF3h");
/*
 * When we cleaning up experiment 'jira-invite-people-to-project-modal', this file should be removed.
 * Depending on the success / failure of the expirement we can replace the import of the modal context and hook
 * with the one from the invite-people package or keep using the one from jira-invite-people-modal-context.
 */ const $02b82ccba94e9abb$var$isJiraInvitePeopleModalEnabled = ()=>{
    const [config] = (0, $epTsa.UNSAFE_noExposureExp)('jira-invite-people-to-project-modal');
    return config.get('isEnabled', false);
};
// this ensures we only load one instance of the hook
const $02b82ccba94e9abb$var$useConditionalInvitePeopleModal = (0, $hbF3h.functionWithCondition)(()=>$02b82ccba94e9abb$var$isJiraInvitePeopleModalEnabled(), ({ resourceAri: resourceAri, onSubmit: onSubmit, ...props })=>(0, $031lN.useJiraInvitePeopleModalBound)(props), (0, $1tjhr.useInvitePeopleModal));
const $02b82ccba94e9abb$export$b9ec44715ae5ad99 = (props)=>{
    const [, fireExposure] = (0, $epTsa.UNSAFE_noExposureExp)('jira-invite-people-to-project-modal');
    const { openModal: openModal } = $02b82ccba94e9abb$var$useConditionalInvitePeopleModal(props);
    const openModalWithExposure = (0, $eJOHy.useCallback)(()=>{
        fireExposure();
        openModal();
    }, [
        openModal,
        fireExposure
    ]);
    return {
        openModal: openModalWithExposure
    };
};
const $02b82ccba94e9abb$export$496e4f58036bb94d = ({ children: children })=>{
    if ($02b82ccba94e9abb$var$isJiraInvitePeopleModalEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $031lN.JiraInvitePeopleModalContextProvider), {
        renderedInProjectContext: false,
        shouldDisplaySuccessModal: false
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJYSe.InvitePeopleModalContextProvider), null, children);
};

});
parcelRegister("031lN", function(module, exports) {

$parcel$export(module.exports, "JiraInvitePeopleModalContextProvider", () => $2f00f50b3eae428f$export$cdc03757c913ed0);
$parcel$export(module.exports, "useJiraInvitePeopleModalBound", () => $2f00f50b3eae428f$export$569fef33efef0114);

var $eJOHy = parcelRequire("eJOHy");

var $2KNf7 = parcelRequire("2KNf7");

var $5j5eL = parcelRequire("5j5eL");

var $8vyDv = parcelRequire("8vyDv");

var $lUto7 = parcelRequire("lUto7");

var $kEUB1 = parcelRequire("kEUB1");

var $bJscI = parcelRequire("bJscI");
/*
 * We are merging all the changes made in @atlassian/jira-invite-people-modal into @atlassian/jira-project-invite-people-modal
 * so the forked modal can be deprecated and removed
 */ const $2f00f50b3eae428f$var$InvitePeopleModalAsync = (0, $bJscI.componentWithFG)('unify-jira-project-invite-people-modal', (0, $5j5eL.default), (0, $2KNf7.default));
const $2f00f50b3eae428f$var$noop = ()=>null;
const $2f00f50b3eae428f$var$JiraInvitePeopleModalContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isOpen: false,
    onOpen: $2f00f50b3eae428f$var$noop,
    onClose: $2f00f50b3eae428f$var$noop
});
const $2f00f50b3eae428f$export$cdc03757c913ed0 = ({ children: children, ...props })=>{
    // new invite people modal requirements
    const cloudId = (0, $kEUB1.useCloudId)();
    const appEditions = (0, $8vyDv.useAppEditions)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const [providerState, setProviderState] = (0, $eJOHy.useState)({
        props: {},
        isOpen: false
    });
    const onClose = (0, $eJOHy.useCallback)(()=>{
        setProviderState({
            props: {},
            isOpen: false
        });
    }, []);
    const onOpen = (0, $eJOHy.useCallback)((state)=>{
        setProviderState({
            props: state ?? {},
            isOpen: true
        });
    }, []);
    const value = (0, $eJOHy.useMemo)(()=>({
            isOpen: providerState.isOpen,
            onOpen: onOpen,
            onClose: onClose
        }), [
        providerState.isOpen,
        onOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f00f50b3eae428f$var$JiraInvitePeopleModalContext.Provider, {
        value: value
    }, providerState.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f00f50b3eae428f$var$InvitePeopleModalAsync, {
        appEdition: appEditions.software,
        cloudId: cloudId,
        isOpen: providerState.isOpen,
        onClose: onClose,
        isSiteAdmin: isSiteAdmin,
        ...props,
        ...providerState.props
    }) : null, children);
};
const $2f00f50b3eae428f$export$39f09976987c1e17 = ()=>(0, $eJOHy.useContext)($2f00f50b3eae428f$var$JiraInvitePeopleModalContext);
const $2f00f50b3eae428f$export$569fef33efef0114 = (props)=>{
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose } = (0, $eJOHy.useContext)($2f00f50b3eae428f$var$JiraInvitePeopleModalContext);
    const openModal = (0, $eJOHy.useCallback)(()=>onOpen(props), [
        onOpen,
        props
    ]);
    return {
        isOpen: isOpen,
        openModal: openModal,
        closeModal: onClose
    };
};

});
parcelRegister("2KNf7", function(module, exports) {

$parcel$export(module.exports, "default", () => $eeaa6f26a62c6207$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $eeaa6f26a62c6207$var$LazyComponent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("4vzAT")), {
    ssr: false,
    moduleId: "./src/packages/project-settings/jira-invite-people-modal/src/ui/index.tsx"
});
const $eeaa6f26a62c6207$export$65d7b8c193fa4f41 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "async-invite-people-modal",
        packageName: "jira-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jira-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eeaa6f26a62c6207$var$LazyComponent, props)));
var $eeaa6f26a62c6207$export$2e2bcd8739ae039 = $eeaa6f26a62c6207$export$65d7b8c193fa4f41;

});
parcelRegister("4vzAT", function(module, exports) {

let $3485aaebdfd34a7f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $3485aaebdfd34a7f$var$load("1VRB2"),
    $3485aaebdfd34a7f$var$load("bABhq"),
    $3485aaebdfd34a7f$var$load("hwlgY"),
    $3485aaebdfd34a7f$var$load("7vqGd"),
    $3485aaebdfd34a7f$var$load("1Y4bq"),
    $3485aaebdfd34a7f$var$load("fq6Yx")
]).then(()=>parcelRequire('9XqPT'));

});


parcelRegister("5j5eL", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a9828feebf714b5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7a9828feebf714b5$var$LazyComponent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("em0Et")), {
    ssr: false,
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/ui/index.tsx"
});
const $7a9828feebf714b5$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7a9828feebf714b5$var$LazyComponent, props)));
var $7a9828feebf714b5$export$2e2bcd8739ae039 = $7a9828feebf714b5$export$6a02a79fa2b0ddab;

});
parcelRegister("em0Et", function(module, exports) {

let $a733a030eeb181f5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $a733a030eeb181f5$var$load("hwlgY"),
    $a733a030eeb181f5$var$load("1VRB2"),
    $a733a030eeb181f5$var$load("bABhq"),
    $a733a030eeb181f5$var$load("k4gbU"),
    $a733a030eeb181f5$var$load("7vqGd"),
    $a733a030eeb181f5$var$load("1Y4bq"),
    $a733a030eeb181f5$var$load("iDn62")
]).then(()=>parcelRequire('2FJIe'));

});



parcelRegister("kJYSe", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModalContext", () => $6a709dc1c29c4fbb$export$be58429061ae5194);
$parcel$export(module.exports, "InvitePeopleModalContextProvider", () => $6a709dc1c29c4fbb$export$496e4f58036bb94d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

const $6a709dc1c29c4fbb$var$AKInvitePeopleModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1435p")));

const $6a709dc1c29c4fbb$var$AKModalTransition = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("ckW88")).then((module)=>({
            default: module.ModalTransition
        })));
const $6a709dc1c29c4fbb$export$be58429061ae5194 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isOpen: false,
    openModal: ()=>undefined,
    closeModal: ()=>undefined
});
const $6a709dc1c29c4fbb$export$496e4f58036bb94d = (invitePeopleModalContextProviderProps)=>{
    const { children: children } = invitePeopleModalContextProviderProps;
    const [invitePeopleState, setInvitePeopleState] = (0, $eJOHy.useState)({
        isOpen: false
    });
    const openModal = (invitePeopleProps, onClose)=>{
        setInvitePeopleState({
            isOpen: true,
            props: invitePeopleProps,
            onClose: onClose
        });
    };
    const closeModal = (0, $eJOHy.useCallback)((trigger)=>{
        if (!invitePeopleState.isOpen) return;
        invitePeopleState.onClose?.(trigger);
        setInvitePeopleState({
            previousProps: invitePeopleState.props,
            isOpen: false
        });
    }, [
        invitePeopleState
    ]);
    const reopenModal = (0, $eJOHy.useCallback)(()=>{
        // Reopen function can only reopen invite people if openModal has been called once with props
        setInvitePeopleState((prevState)=>!prevState.isOpen && prevState.previousProps ? {
                props: prevState.previousProps,
                isOpen: true
            } : prevState);
    }, []);
    const context = (0, $eJOHy.useMemo)(()=>({
            openModal: openModal,
            closeModal: closeModal,
            isOpen: invitePeopleState.isOpen
        }), [
        closeModal,
        invitePeopleState.isOpen
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)($6a709dc1c29c4fbb$export$be58429061ae5194.Provider, {
        value: context,
        children: [
            children,
            invitePeopleState.isOpen && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($6a709dc1c29c4fbb$var$AKModalTransition, {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($6a709dc1c29c4fbb$var$AKInvitePeopleModal, {
                        onCloseHandler: closeModal,
                        experimental_onReopenHandler: reopenModal,
                        ...invitePeopleState.props
                    })
                })
            })
        ]
    });
};

});
parcelRegister("1435p", function(module, exports) {

let $0c688f04059946d5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $0c688f04059946d5$var$load("7vqGd"),
    $0c688f04059946d5$var$load("1Y4bq"),
    $0c688f04059946d5$var$load("8t24q")
]).then(()=>parcelRequire('29FLc'));

});

parcelRegister("ckW88", function(module, exports) {

let $8fb471bffe673966$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8fb471bffe673966$var$load("QJOHy").then(()=>parcelRequire('7W2iB'));

});


parcelRegister("1tjhr", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $80b9f24e7a8c447c$export$b9ec44715ae5ad99);

var $eJOHy = parcelRequire("eJOHy");

var $kJYSe = parcelRequire("kJYSe");
const $80b9f24e7a8c447c$export$b9ec44715ae5ad99 = (useInvitePeopleModalProps)=>{
    const { onClose: onClose, ...invitePeopleProps } = useInvitePeopleModalProps;
    const { openModal: openModal, closeModal: closeModal, isOpen: isOpen } = (0, $eJOHy.useContext)((0, $kJYSe.InvitePeopleModalContext));
    return {
        // this is experimental only and should not be used without consulting !core-invtes in #groot-techops
        experimental_openModal: (propsOverride)=>openModal({
                ...invitePeopleProps,
                ...propsOverride
            }, onClose),
        openModal: ()=>openModal(invitePeopleProps, onClose),
        closeModal: closeModal,
        isOpen: isOpen
    };
};

});


parcelRegister("k8PfX", function(module, exports) {

$parcel$export(module.exports, "default", () => $528ccfb044e31568$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $528ccfb044e31568$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    addButton: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.add-button",
        "defaultMessage": "Create or invite"
    },
    createTeam: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.create-team",
        "defaultMessage": "Create a team"
    },
    invitePeople: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.invite-people",
        "defaultMessage": "Invite people"
    },
    inviteRecommendationsFromSlack: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.invite-recommendations-from-slack",
        "defaultMessage": "{email} (Found in slack)"
    }
});

});


// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $2b839a8453de5367$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $2b839a8453de5367$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $2b839a8453de5367$export$e3884212029f7bef = 'should-show-welcome-modal';
const $2b839a8453de5367$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $2b839a8453de5367$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $2b839a8453de5367$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $2b839a8453de5367$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $2b839a8453de5367$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $2b839a8453de5367$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $2b839a8453de5367$export$6e69f8dc03075ef8 = 'team-type';
const $2b839a8453de5367$export$c06666264cd35603 = 'team-type-shorthand';
const $2b839a8453de5367$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $2b839a8453de5367$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $2b839a8453de5367$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $2b839a8453de5367$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $2b839a8453de5367$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $2b839a8453de5367$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $2b839a8453de5367$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $2b839a8453de5367$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $2b839a8453de5367$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $2b839a8453de5367$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $2b839a8453de5367$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $2b839a8453de5367$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $2b839a8453de5367$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $2b839a8453de5367$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $2b839a8453de5367$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $2b839a8453de5367$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $2b839a8453de5367$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $2b839a8453de5367$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $2b839a8453de5367$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $2b839a8453de5367$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $2b839a8453de5367$export$468488291ccd988 = 'timelineAddItemNudge';
const $2b839a8453de5367$export$7a33548109ac931d = 'createFormNudge';
const $2b839a8453de5367$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $2b839a8453de5367$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $2b839a8453de5367$export$594d3436316492be = 'summaryViewNudge';
const $2b839a8453de5367$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $2b839a8453de5367$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $2b839a8453de5367$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $2b839a8453de5367$export$699265ec8ad9a740 = 'Software Development';
const $2b839a8453de5367$export$e07d1fa2da8ed874 = 'Customer Service';
const $2b839a8453de5367$export$76dcec3f438d9e56 = 'IT Support';
const $2b839a8453de5367$export$9a574c301f67ba30 = 'Human Resources';
const $2b839a8453de5367$export$363ec144a94029c8 = 'Finance';
const $2b839a8453de5367$export$df0fb32d68ae1e78 = 'Legal';
const $2b839a8453de5367$export$d9c0e3e59442fb4 = 'Marketing';
const $2b839a8453de5367$export$27dbc7d7ce66e6e3 = 'Operations';
const $2b839a8453de5367$export$a5dce388adf922bd = 'Sales';
const $2b839a8453de5367$export$e1473b31a257caff = 'Data Science';
const $2b839a8453de5367$export$85657457db93c2c2 = 'Product Management';
const $2b839a8453de5367$export$c0c2d1dfaeba89dd = 'Project Management';
const $2b839a8453de5367$export$2e6a7ad3ab9c82a3 = 'Design';
const $2b839a8453de5367$export$7b60378c3b4372e9 = 'Other or Personal';
const $2b839a8453de5367$export$572242e58bd07594 = 'CS';
const $2b839a8453de5367$export$d7de553940261eba = 'ITS';
const $2b839a8453de5367$export$4c29d0d04c15e55d = 'HR';
const $2b839a8453de5367$export$3950f7f841bf94b6 = 'FNC';
const $2b839a8453de5367$export$881249b988b6030f = 'LGL';
const $2b839a8453de5367$export$e4824f74b9879164 = 'MKT';
const $2b839a8453de5367$export$4f3cb0844009af52 = 'OPS';
const $2b839a8453de5367$export$1a65d50c4a641bb4 = 'SAL';
const $2b839a8453de5367$export$9ee64e8fbd8b03a2 = 'DS';
const $2b839a8453de5367$export$b8b1ac856ba1434b = 'DEV';
const $2b839a8453de5367$export$4f54a09a24fd1d74 = 'PDM';
const $2b839a8453de5367$export$79685802e8ff1098 = 'PJM';
const $2b839a8453de5367$export$e5c438b7501b5a24 = 'DES';
const $2b839a8453de5367$export$cbc0e551d91a692d = 'OTR';

parcelRegister("dIJOd", function(module, exports) {

$parcel$export(module.exports, "InviteTeamNudgeAsync", () => $a0e00efc1118bc6b$export$a4b4061b22dbc897);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");


var $gxP9D = parcelRequire("gxP9D");


var $45qbN = parcelRequire("45qbN");
const $a0e00efc1118bc6b$var$runtimeProps = {};
const $a0e00efc1118bc6b$var$entryPointParams = {};
const $a0e00efc1118bc6b$export$a4b4061b22dbc897 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $45qbN.inviteTeamNudgeEntryPoint), $a0e00efc1118bc6b$var$entryPointParams);
    const [nudgeStep] = (0, $gxP9D.useNudgeStep)();
    const [hasNudgeActive] = (0, $gxP9D.useHasNudgeActive)();
    const firstLoadRef = (0, $eJOHy.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $2b839a8453de5367$export$77bc79debbf5c069)) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: (0, $44259bc988b99eaa$export$3bc551fe07069f89),
        packageName: "jiraInviteTeamOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        runtimeProps: $a0e00efc1118bc6b$var$runtimeProps
    });
};

});
parcelRegister("gxP9D", function(module, exports) {

$parcel$export(module.exports, "useJswOnboarding", () => $ef5cbf2537a08e24$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $ef5cbf2537a08e24$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $ef5cbf2537a08e24$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $ef5cbf2537a08e24$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $ef5cbf2537a08e24$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useInviteToProject", () => $ef5cbf2537a08e24$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $ef5cbf2537a08e24$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $ef5cbf2537a08e24$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $ef5cbf2537a08e24$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $ef5cbf2537a08e24$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $ef5cbf2537a08e24$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $ef5cbf2537a08e24$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $ef5cbf2537a08e24$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $ef5cbf2537a08e24$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $ef5cbf2537a08e24$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $ef5cbf2537a08e24$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $ef5cbf2537a08e24$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", () => $ef5cbf2537a08e24$export$a823278ac9d1112b);
$parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", () => $ef5cbf2537a08e24$export$cb9e0e8fe4df8490);
$parcel$export(module.exports, "useHasNudgeActive", () => $ef5cbf2537a08e24$export$521909e3dc7ab811);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("9ycBx")).QUICKSTART_UI_STATUS);

var $dhdXs = parcelRequire("dhdXs");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

var $9ycBx = parcelRequire("9ycBx");

var $4NsfZ = parcelRequire("4NsfZ");

var $1KmSm = parcelRequire("1KmSm");

var $6R6zv = parcelRequire("6R6zv");

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");

const $ef5cbf2537a08e24$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $6R6zv.initialState,
    actions: $4NsfZ.actions
});
const $ef5cbf2537a08e24$export$1cbc60d8dd921852 = (0, $ht3nQ.createSubscriber)($ef5cbf2537a08e24$export$390f32400eaf98c9);
const $ef5cbf2537a08e24$export$7d91c0af4772787a = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9);
const $ef5cbf2537a08e24$export$638bfcfce1254bb8 = (0, $6E16M.createContainer)($ef5cbf2537a08e24$export$390f32400eaf98c9, {});
const $ef5cbf2537a08e24$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, $3XHRA.getQuickstartTypeSelector)(state)] === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $ef5cbf2537a08e24$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $ef5cbf2537a08e24$export$594f006fa6a1b2e5 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: $ef5cbf2537a08e24$export$ea14030920a5d8e6
});
const $ef5cbf2537a08e24$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $ef5cbf2537a08e24$export$c5e63e44ad178ae8 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: $ef5cbf2537a08e24$export$a943afa434e9487a
});
const $ef5cbf2537a08e24$export$2c3cd14fff9d6e43 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: null
});
const $ef5cbf2537a08e24$export$b0db7e46e369e1d9 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: $ef5cbf2537a08e24$export$9d731f44f82af09f
});
const $ef5cbf2537a08e24$export$71de79653346a1ea = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $ef5cbf2537a08e24$export$61185a9266f1f57a = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN || userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $ef5cbf2537a08e24$export$ef4747ba36826d6a = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $ef5cbf2537a08e24$export$522993b46d9f8266 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        if (state.shouldRenderComponent === false) return (0, $uMSsJ.getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED;
        return state.visibility[quickstartType];
    }
});
const $ef5cbf2537a08e24$export$aa4ba29241532382 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $ef5cbf2537a08e24$export$ed5c755b733bf2b1 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $ef5cbf2537a08e24$export$35fe0366802512dd = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        const visibility = state.visibility[(0, $3XHRA.getQuickstartTypeSelector)(state)];
        return visibility === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED;
    }
});
const $ef5cbf2537a08e24$export$a41ee0d3b6938099 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $ef5cbf2537a08e24$export$4ae7b465b076be9 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $ef5cbf2537a08e24$export$bf6e646c0476acad = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $ef5cbf2537a08e24$export$6b706bff94798d11 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $ef5cbf2537a08e24$export$c98db656edc5b3e1 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $ef5cbf2537a08e24$export$a823278ac9d1112b = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $dhdXs.SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN)
});
const $ef5cbf2537a08e24$export$cb9e0e8fe4df8490 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $dhdXs.KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN && // edge case - if e.g. welcome modal failed to load, and user completed task by themself, then the welcome modal should be skipped on subsequent page loads.
        !state.completedTaskList.includes((0, $9ycBx.KANBAN_ONBOARDING_TASK)))
});
const $ef5cbf2537a08e24$export$521909e3dc7ab811 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $ef5cbf2537a08e24$export$f4a2be940259bf95 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});

});
parcelRegister("dhdXs", function(module, exports) {

$parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$f40a08fc76eb112d);
$parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$e3844688f2693533);
$parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$e3cec071fcb2fbd3);
$parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$21783d461e3ef6d);
$parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$6cd1c1b2ba0f6e2d);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$6f4213a3addc3fdb);
$parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", () => $d4b4552e4689d7b3$export$7492b6cc3ef89883);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$7d9a4e0ef5194fe1);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$477ca3550da12e43);
$parcel$export(module.exports, "BLANK_TEMPLATE_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$7c0307155b744916);
$parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$b5ab111fb8825075);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$14139f0ec41d437e);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$ebf7af45376deb8b);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$7b6945581ccdab4a);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$310a9ac5c28d65f6);
$parcel$export(module.exports, "TASK_TRACKING_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$136d17feb2f4285d);
$parcel$export(module.exports, "DOCUMENT_APPROVAL_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$e288f4758e94a8cc);
$parcel$export(module.exports, "PROCESS_CONTROL_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$4e9ac1417ba54bba);
$parcel$export(module.exports, "POLICY_MANAGEMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$560c9f6765bf9af4);
$parcel$export(module.exports, "SALES_PIPELINE_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$14d4c6dbbb62a127);
$parcel$export(module.exports, "PROCUREMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$1367ee12532c525f);
$parcel$export(module.exports, "WEB_DESIGN_PROCESS_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$278632cc7ed9a312);
$parcel$export(module.exports, "BUDGET_CREATION_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$594d0d4f5ecbf4c7);
$parcel$export(module.exports, "EMPLOYEE_ONBOARDING_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$dda85c7a8278e495);
$parcel$export(module.exports, "RECRUITMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$b92c431651f9ee91);
$parcel$export(module.exports, "LEAD_TRACKING_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$d72d75d9d0e071fc);
$parcel$export(module.exports, "IP_INFRINGEMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$753322ed1c32ff89);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$4d29ee0c00eb5df4);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$6278b41164dbde6c);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$17a2f771efabf02f);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_OPERATIONS_TEMPLATE_KEY", () => $d4b4552e4689d7b3$export$df7d1440e0a80c03);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$bd14946bcde77195);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", () => $d4b4552e4689d7b3$export$e8df553a3f519284);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", () => $d4b4552e4689d7b3$export$97fc32bd703bb4d1);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", () => $d4b4552e4689d7b3$export$8eecdf6acea9494);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", () => $d4b4552e4689d7b3$export$ff16be7794ed4222);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$9917830b560a2f4);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$b0928b02ffab3875);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$fd75f6abc7861439);
$parcel$export(module.exports, "HR_SERVICE_PROJECT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$2bc7db2da3df8313);
$parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", () => $d4b4552e4689d7b3$export$87a8fff98b5bc81);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$7c567eb725bd36f);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_ROADMAP_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$f9776303073903dd);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_PRIORITIZE_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$b7c4ca557ac2074e);
$parcel$export(module.exports, "getIsJsmBlankProjectTemplate", () => $d4b4552e4689d7b3$export$73fd025e86012868);
$parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", () => $d4b4552e4689d7b3$export$a062badd78c9993);
// Project template type keys are used to create projects.
// TODO: KURO-1818 consolidate keys from `project-template-keys` in this file.
// Software template keys
const $d4b4552e4689d7b3$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $d4b4552e4689d7b3$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $d4b4552e4689d7b3$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $d4b4552e4689d7b3$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $d4b4552e4689d7b3$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
const $d4b4552e4689d7b3$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $d4b4552e4689d7b3$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
const $d4b4552e4689d7b3$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
const $d4b4552e4689d7b3$export$7d9a4e0ef5194fe1 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
const $d4b4552e4689d7b3$export$477ca3550da12e43 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
const $d4b4552e4689d7b3$export$7c0307155b744916 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
const $d4b4552e4689d7b3$export$b5ab111fb8825075 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
const $d4b4552e4689d7b3$export$14139f0ec41d437e = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
const $d4b4552e4689d7b3$export$ebf7af45376deb8b = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
const $d4b4552e4689d7b3$export$7b6945581ccdab4a = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
const $d4b4552e4689d7b3$export$310a9ac5c28d65f6 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
const $d4b4552e4689d7b3$export$136d17feb2f4285d = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
const $d4b4552e4689d7b3$export$e288f4758e94a8cc = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
const $d4b4552e4689d7b3$export$4e9ac1417ba54bba = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
const $d4b4552e4689d7b3$export$560c9f6765bf9af4 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
const $d4b4552e4689d7b3$export$14d4c6dbbb62a127 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
const $d4b4552e4689d7b3$export$1367ee12532c525f = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
const $d4b4552e4689d7b3$export$278632cc7ed9a312 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-web-design-process-team-managed`;
const $d4b4552e4689d7b3$export$594d0d4f5ecbf4c7 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-budget-creation-team-managed`;
const $d4b4552e4689d7b3$export$dda85c7a8278e495 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-employee-onboarding-team-managed`;
const $d4b4552e4689d7b3$export$b92c431651f9ee91 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-recruitment-team-managed`;
const $d4b4552e4689d7b3$export$d72d75d9d0e071fc = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-lead-tracking-team-managed`;
const $d4b4552e4689d7b3$export$753322ed1c32ff89 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-ip-infringement-team-managed`;
const $d4b4552e4689d7b3$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
const $d4b4552e4689d7b3$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
const $d4b4552e4689d7b3$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $d4b4552e4689d7b3$export$df7d1440e0a80c03 = 'com.atlassian.servicedesk:simplified-it-service-management-operations';
const $d4b4552e4689d7b3$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
const $d4b4552e4689d7b3$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
const $d4b4552e4689d7b3$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
const $d4b4552e4689d7b3$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
const $d4b4552e4689d7b3$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
const $d4b4552e4689d7b3$export$9e38ad41d19608ee = 'jsm.blank-service-management';
const $d4b4552e4689d7b3$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
const $d4b4552e4689d7b3$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
const $d4b4552e4689d7b3$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
const $d4b4552e4689d7b3$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
const $d4b4552e4689d7b3$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
const $d4b4552e4689d7b3$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
const $d4b4552e4689d7b3$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $d4b4552e4689d7b3$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
const $d4b4552e4689d7b3$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
const $d4b4552e4689d7b3$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
const $d4b4552e4689d7b3$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
const $d4b4552e4689d7b3$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
const $d4b4552e4689d7b3$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
const $d4b4552e4689d7b3$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
const $d4b4552e4689d7b3$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
const $d4b4552e4689d7b3$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
const $d4b4552e4689d7b3$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
const $d4b4552e4689d7b3$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
const $d4b4552e4689d7b3$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
const $d4b4552e4689d7b3$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
const $d4b4552e4689d7b3$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
const $d4b4552e4689d7b3$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
const $d4b4552e4689d7b3$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
const $d4b4552e4689d7b3$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
const $d4b4552e4689d7b3$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
const $d4b4552e4689d7b3$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
const $d4b4552e4689d7b3$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
const $d4b4552e4689d7b3$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
const $d4b4552e4689d7b3$export$87a8fff98b5bc81 = 'initial.project.template.name';
const $d4b4552e4689d7b3$export$7c567eb725bd36f = 'jira.polaris:discovery';
const $d4b4552e4689d7b3$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
const $d4b4552e4689d7b3$export$f9776303073903dd = 'jira.polaris:roadmap';
const $d4b4552e4689d7b3$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
const $d4b4552e4689d7b3$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $d4b4552e4689d7b3$export$e8df553a3f519284 || T4JTemplateKey === $d4b4552e4689d7b3$export$8eecdf6acea9494 || T4JTemplateKey === $d4b4552e4689d7b3$export$9e38ad41d19608ee;
const $d4b4552e4689d7b3$export$a062badd78c9993 = {
    [$d4b4552e4689d7b3$export$e82092c4fb277f9b]: $d4b4552e4689d7b3$export$b0928b02ffab3875,
    [$d4b4552e4689d7b3$export$fd75f6abc7861439]: $d4b4552e4689d7b3$export$b0928b02ffab3875,
    [$d4b4552e4689d7b3$export$5eddf3b31dd1858f]: $d4b4552e4689d7b3$export$50478ee5ecbf7a4d,
    [$d4b4552e4689d7b3$export$fb658bddae7f81bb]: $d4b4552e4689d7b3$export$50478ee5ecbf7a4d
};

});

parcelRegister("9ycBx", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $9b4ef256583f1ea3$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $9b4ef256583f1ea3$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $9b4ef256583f1ea3$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $9b4ef256583f1ea3$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $9b4ef256583f1ea3$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $9b4ef256583f1ea3$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $9b4ef256583f1ea3$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $9b4ef256583f1ea3$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $9b4ef256583f1ea3$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $9b4ef256583f1ea3$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $9b4ef256583f1ea3$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $9b4ef256583f1ea3$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $9b4ef256583f1ea3$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $9b4ef256583f1ea3$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $9b4ef256583f1ea3$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $9b4ef256583f1ea3$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $9b4ef256583f1ea3$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "ADD_COLUMNS_TASK", () => $9b4ef256583f1ea3$export$cbeb719208f32c8a);
$parcel$export(module.exports, "CREATE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$88c918f2cfaff86);
$parcel$export(module.exports, "CREATE_ISSUE_TASK", () => $9b4ef256583f1ea3$export$abbbea7c37c93cb5);
$parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", () => $9b4ef256583f1ea3$export$2a0253cb20f48a8);
$parcel$export(module.exports, "INVITE_TEAMMATES_TASK", () => $9b4ef256583f1ea3$export$f97428bb4b1991ec);
$parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", () => $9b4ef256583f1ea3$export$45eaf4204fcc7);
$parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", () => $9b4ef256583f1ea3$export$af57685e201438e8);
$parcel$export(module.exports, "FIND_HELP_TASK", () => $9b4ef256583f1ea3$export$d6c67e9aab4e2b26);
$parcel$export(module.exports, "SET_UP_BOARD_TASK", () => $9b4ef256583f1ea3$export$3de8c242d2b82f26);
$parcel$export(module.exports, "GET_MOBILE_APP_TASK", () => $9b4ef256583f1ea3$export$a01fa44f793dbfac);
$parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", () => $9b4ef256583f1ea3$export$6a4507e462fd41da);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", () => $9b4ef256583f1ea3$export$e64c1dced6ac4458);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $9b4ef256583f1ea3$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", () => $9b4ef256583f1ea3$export$c1effb1c8979fe22);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $9b4ef256583f1ea3$export$d97d31d934dbb194);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", () => $9b4ef256583f1ea3$export$cafb5bd13b02056b);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", () => $9b4ef256583f1ea3$export$e55c18b809946e72);
$parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", () => $9b4ef256583f1ea3$export$de5640b9ae8140a7);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $9b4ef256583f1ea3$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $9b4ef256583f1ea3$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $9b4ef256583f1ea3$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $9b4ef256583f1ea3$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $9b4ef256583f1ea3$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", () => $9b4ef256583f1ea3$export$3e2776d61f3662dc);
$parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", () => $9b4ef256583f1ea3$export$9048315f2c03fd9d);
$parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", () => $9b4ef256583f1ea3$export$4145c2cec2da6f9b);
$parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", () => $9b4ef256583f1ea3$export$4957a1ad203cf6dd);
$parcel$export(module.exports, "CALENDAR_VIEW_TASK", () => $9b4ef256583f1ea3$export$190b5dd0a1322552);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $9b4ef256583f1ea3$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $9b4ef256583f1ea3$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $9b4ef256583f1ea3$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $9b4ef256583f1ea3$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $9b4ef256583f1ea3$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $9b4ef256583f1ea3$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $9b4ef256583f1ea3$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $9b4ef256583f1ea3$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $9b4ef256583f1ea3$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $9b4ef256583f1ea3$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $9b4ef256583f1ea3$export$3380e677209260fe);
$parcel$export(module.exports, "GET_STARTED_LIST_TASK", () => $9b4ef256583f1ea3$export$7a2fcaad1564e6b7);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $9b4ef256583f1ea3$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $9b4ef256583f1ea3$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $9b4ef256583f1ea3$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $9b4ef256583f1ea3$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $9b4ef256583f1ea3$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $9b4ef256583f1ea3$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $9b4ef256583f1ea3$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $9b4ef256583f1ea3$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $9b4ef256583f1ea3$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $9b4ef256583f1ea3$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $9b4ef256583f1ea3$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $9b4ef256583f1ea3$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $9b4ef256583f1ea3$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $9b4ef256583f1ea3$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $9b4ef256583f1ea3$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $9b4ef256583f1ea3$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $9b4ef256583f1ea3$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $9b4ef256583f1ea3$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $9b4ef256583f1ea3$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $9b4ef256583f1ea3$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $9b4ef256583f1ea3$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $9b4ef256583f1ea3$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $9b4ef256583f1ea3$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $9b4ef256583f1ea3$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $9b4ef256583f1ea3$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $9b4ef256583f1ea3$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $9b4ef256583f1ea3$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $9b4ef256583f1ea3$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $9b4ef256583f1ea3$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $9b4ef256583f1ea3$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $9b4ef256583f1ea3$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $9b4ef256583f1ea3$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $9b4ef256583f1ea3$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $9b4ef256583f1ea3$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $9b4ef256583f1ea3$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $9b4ef256583f1ea3$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $9b4ef256583f1ea3$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $9b4ef256583f1ea3$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $9b4ef256583f1ea3$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $9b4ef256583f1ea3$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $9b4ef256583f1ea3$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $9b4ef256583f1ea3$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $9b4ef256583f1ea3$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $9b4ef256583f1ea3$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $9b4ef256583f1ea3$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $9b4ef256583f1ea3$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $9b4ef256583f1ea3$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $9b4ef256583f1ea3$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $9b4ef256583f1ea3$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $9b4ef256583f1ea3$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $9b4ef256583f1ea3$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $9b4ef256583f1ea3$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $9b4ef256583f1ea3$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $9b4ef256583f1ea3$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $9b4ef256583f1ea3$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $9b4ef256583f1ea3$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $9b4ef256583f1ea3$export$1de5766b7e640d6b);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $9b4ef256583f1ea3$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $9b4ef256583f1ea3$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $9b4ef256583f1ea3$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $9b4ef256583f1ea3$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $9b4ef256583f1ea3$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $9b4ef256583f1ea3$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $9b4ef256583f1ea3$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $9b4ef256583f1ea3$export$7578902c7f420a3);
$parcel$export(module.exports, "SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON", () => $9b4ef256583f1ea3$export$5980f41aa657f9c7);

var $ljej9 = parcelRequire("ljej9");
const $9b4ef256583f1ea3$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $9b4ef256583f1ea3$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $9b4ef256583f1ea3$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $9b4ef256583f1ea3$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $9b4ef256583f1ea3$export$2b3151a089bc8780 = 'jlove-makkuro';
const $9b4ef256583f1ea3$export$6826d33e9a2c0119 = 320;
const $9b4ef256583f1ea3$export$b580da85daad7757 = 'root';
const $9b4ef256583f1ea3$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $9b4ef256583f1ea3$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $9b4ef256583f1ea3$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $9b4ef256583f1ea3$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $9b4ef256583f1ea3$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $9b4ef256583f1ea3$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $9b4ef256583f1ea3$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $9b4ef256583f1ea3$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $9b4ef256583f1ea3$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $9b4ef256583f1ea3$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $9b4ef256583f1ea3$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $9b4ef256583f1ea3$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $9b4ef256583f1ea3$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $9b4ef256583f1ea3$export$cbeb719208f32c8a = $9b4ef256583f1ea3$var$completeJswTaskName('add-columns-task');
const $9b4ef256583f1ea3$export$88c918f2cfaff86 = $9b4ef256583f1ea3$var$completeJswTaskName('create-project-task');
const $9b4ef256583f1ea3$export$abbbea7c37c93cb5 = $9b4ef256583f1ea3$var$completeJswTaskName('create-issue-task');
const $9b4ef256583f1ea3$export$2a0253cb20f48a8 = $9b4ef256583f1ea3$var$completeJswTaskName('create-issue-task-simplified');
const $9b4ef256583f1ea3$export$f97428bb4b1991ec = $9b4ef256583f1ea3$var$completeJswTaskName('invite-teammates-task');
const $9b4ef256583f1ea3$export$45eaf4204fcc7 = $9b4ef256583f1ea3$var$completeJswTaskName('invite-teammates-video-task');
const $9b4ef256583f1ea3$export$af57685e201438e8 = $9b4ef256583f1ea3$var$completeJswTaskName('capture-integrations-task');
const $9b4ef256583f1ea3$export$d6c67e9aab4e2b26 = $9b4ef256583f1ea3$var$completeJswTaskName('find-help-task');
const $9b4ef256583f1ea3$export$3de8c242d2b82f26 = $9b4ef256583f1ea3$var$completeJswTaskName('set-up-board-task');
const $9b4ef256583f1ea3$export$a01fa44f793dbfac = $9b4ef256583f1ea3$var$completeJswTaskName('get-mobile-app-task');
const $9b4ef256583f1ea3$export$6a4507e462fd41da = $9b4ef256583f1ea3$var$completeJswTaskName('map-out-your-project-goals');
const $9b4ef256583f1ea3$export$e64c1dced6ac4458 = $9b4ef256583f1ea3$var$completeJswTaskName('identify-small-chunks-of-work');
const $9b4ef256583f1ea3$export$63b0e55f9c6454ac = $9b4ef256583f1ea3$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $9b4ef256583f1ea3$export$c1effb1c8979fe22 = $9b4ef256583f1ea3$var$completeJswTaskName('monitor-manage-risk');
const $9b4ef256583f1ea3$export$d97d31d934dbb194 = $9b4ef256583f1ea3$var$completeJswTaskName('premium-reverse-trial-task');
const $9b4ef256583f1ea3$export$cafb5bd13b02056b = $9b4ef256583f1ea3$var$completeJswTaskName('premium-edition-overview-task');
const $9b4ef256583f1ea3$export$e55c18b809946e72 = $9b4ef256583f1ea3$var$completeJswTaskName('premium-edition-overview-task-non-admin');
const $9b4ef256583f1ea3$export$de5640b9ae8140a7 = $9b4ef256583f1ea3$var$completeJswTaskName('standard-edition-overview-task');
const $9b4ef256583f1ea3$export$540b5c3c4b6ce459 = $9b4ef256583f1ea3$var$completeJswTaskName('advanced-roadmaps-task');
const $9b4ef256583f1ea3$export$6f71dff531ff592 = $9b4ef256583f1ea3$var$completeJswTaskName('change-control-task');
const $9b4ef256583f1ea3$export$83255ab79e45f34f = $9b4ef256583f1ea3$var$completeJswTaskName('automations-task');
const $9b4ef256583f1ea3$export$b57d172af9ad7647 = $9b4ef256583f1ea3$var$completeJswTaskName('site-administrations-task');
const $9b4ef256583f1ea3$export$ff4c933c1fe90b68 = $9b4ef256583f1ea3$var$completeJswTaskName('user-management-task');
const $9b4ef256583f1ea3$export$3e2776d61f3662dc = $9b4ef256583f1ea3$var$completeJswTaskName('scrum-onboarding-task');
const $9b4ef256583f1ea3$export$9048315f2c03fd9d = $9b4ef256583f1ea3$var$completeJswTaskName('customize-site-name-task');
const $9b4ef256583f1ea3$export$4145c2cec2da6f9b = $9b4ef256583f1ea3$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
const $9b4ef256583f1ea3$export$4957a1ad203cf6dd = $9b4ef256583f1ea3$var$completeJswTaskName('try-atlassian-university-task');
const $9b4ef256583f1ea3$export$190b5dd0a1322552 = $9b4ef256583f1ea3$var$completeJswTaskName('calendar-view-task');
const $9b4ef256583f1ea3$export$501166b25f254aab = $9b4ef256583f1ea3$var$completeJwmTaskName('jwm-project-summary-task');
const $9b4ef256583f1ea3$export$94ad6507a703f4eb = $9b4ef256583f1ea3$var$completeJwmTaskName('jwm-create-sample-project-task');
const $9b4ef256583f1ea3$export$be1c522400a1bd7c = $9b4ef256583f1ea3$var$completeJwmTaskName('background-color-task');
const $9b4ef256583f1ea3$export$2aa6e7b6e24a04f5 = $9b4ef256583f1ea3$var$completeJwmTaskName('calendar-task');
const $9b4ef256583f1ea3$export$f3b53199b07af2a1 = $9b4ef256583f1ea3$var$completeJwmTaskName('timeline-task');
const $9b4ef256583f1ea3$export$d37415ffddcf2142 = $9b4ef256583f1ea3$var$completeJwmTaskName('build-form-task');
const $9b4ef256583f1ea3$export$2ae00586da7cb606 = $9b4ef256583f1ea3$var$completeJwmTaskName('feedback-task');
const $9b4ef256583f1ea3$export$b86266e6594a97bb = $9b4ef256583f1ea3$var$completeJwmTaskName('feedback-sample-project-task');
const $9b4ef256583f1ea3$export$20bc3dc137ac1c38 = $9b4ef256583f1ea3$var$completeJwmTaskName('create-your-own-project-task');
const $9b4ef256583f1ea3$export$77071b77e2801b18 = $9b4ef256583f1ea3$var$completeJwmTaskName('jwm-create-project-task');
const $9b4ef256583f1ea3$export$9c89f946f05d884a = $9b4ef256583f1ea3$var$completeJwmTaskName('share-project-task');
const $9b4ef256583f1ea3$export$b52a7c936684cfc5 = $9b4ef256583f1ea3$var$completeJwmTaskName('trello-crossflow-import');
const $9b4ef256583f1ea3$export$b5555f24061f9fb = $9b4ef256583f1ea3$var$completeJwmTaskName('summary-and-reports-task');
const $9b4ef256583f1ea3$export$ff25449f34b8abf = $9b4ef256583f1ea3$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $9b4ef256583f1ea3$export$3380e677209260fe = $9b4ef256583f1ea3$var$completeJwmTaskName('trello-crossflow-key-differences');
const $9b4ef256583f1ea3$export$7a2fcaad1564e6b7 = $9b4ef256583f1ea3$var$completeJwmTaskName('get-started-list-task');
const $9b4ef256583f1ea3$export$da23b72d32bfad9e = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $9b4ef256583f1ea3$export$4b064659282e0238 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $9b4ef256583f1ea3$export$3ab51851f6d823e = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $9b4ef256583f1ea3$export$e4a1a37a9a1350ad = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $9b4ef256583f1ea3$export$b7f7da5e795f0327 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $9b4ef256583f1ea3$export$80a401c1aa47a377 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $9b4ef256583f1ea3$export$934ac7a251b26dc7 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $9b4ef256583f1ea3$export$4634f6395df3ebbe = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $9b4ef256583f1ea3$export$768fb41107a1e8d7 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $9b4ef256583f1ea3$export$d797a81bace17184 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $9b4ef256583f1ea3$export$746102c94db9df1f = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $9b4ef256583f1ea3$export$5f1efd797d65e349 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $9b4ef256583f1ea3$export$cccc812ccafbf11f = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $9b4ef256583f1ea3$export$64822db87abd8a47 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $9b4ef256583f1ea3$export$64f764d8be495c82 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $9b4ef256583f1ea3$export$24eae23dc1c68bbd = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $9b4ef256583f1ea3$export$50fa92eba6f82feb = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $9b4ef256583f1ea3$export$4155d22fe3f14cd6 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $9b4ef256583f1ea3$export$76813cbead887191 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $9b4ef256583f1ea3$export$90aab2ff89daf770 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $9b4ef256583f1ea3$export$a2bc0cbad2e6e605 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $9b4ef256583f1ea3$export$f90872a1280728bb = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $9b4ef256583f1ea3$export$bce644e96518cbd2 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $9b4ef256583f1ea3$export$241aaebffac0a3e5 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $9b4ef256583f1ea3$export$f9dfc43b5b31c4b7 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $9b4ef256583f1ea3$export$79759e9e62fb9312 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $9b4ef256583f1ea3$export$992d1e0dce255d19 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $9b4ef256583f1ea3$export$d28c1b0e5b3e768 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $9b4ef256583f1ea3$export$ca714ee197bed4ec = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $9b4ef256583f1ea3$export$faae55ceea4b6073 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $9b4ef256583f1ea3$export$200bc24cd120667e = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $9b4ef256583f1ea3$export$a0d784a48b4e886c = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $9b4ef256583f1ea3$export$baf5bd09b4b33b8a = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $9b4ef256583f1ea3$export$4702007eedbca8ab = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $9b4ef256583f1ea3$export$aa9d2d635ea63898 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $9b4ef256583f1ea3$export$2ea449225c1f6cac = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $9b4ef256583f1ea3$export$deb8b557e735e26a = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $9b4ef256583f1ea3$export$d45754df44e4c309 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $9b4ef256583f1ea3$export$78b2913b550edbb = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $9b4ef256583f1ea3$export$71243272608c58ab = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $9b4ef256583f1ea3$export$39a08f215c33bc39 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $9b4ef256583f1ea3$export$d2377f6a6fa3b49c = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $9b4ef256583f1ea3$export$befa8f6533309779 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $9b4ef256583f1ea3$export$736b40db8701ba6c = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $9b4ef256583f1ea3$export$11eff6ae2f70b67b = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $9b4ef256583f1ea3$export$fb2d23e5315a67a9 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $9b4ef256583f1ea3$export$32e794bb49d60b6 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $9b4ef256583f1ea3$export$fed256238b27db06 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $9b4ef256583f1ea3$export$132eecb4d35a590d = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $9b4ef256583f1ea3$export$2579c51cadd45eca = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $9b4ef256583f1ea3$export$4b1a0cefa966ea0 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $9b4ef256583f1ea3$export$f6558daacc312a65 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $9b4ef256583f1ea3$export$925efa2e24e86b88 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $9b4ef256583f1ea3$export$40454d3e062dcd44 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $9b4ef256583f1ea3$export$99b0e09ff6f00490 = $9b4ef256583f1ea3$var$completeJsmTaskName('customize-your-request-types-task');
const $9b4ef256583f1ea3$export$2a82344eb273eeff = $9b4ef256583f1ea3$var$completeJsmTaskName('review-your-channels-task');
const $9b4ef256583f1ea3$export$1de5766b7e640d6b = $9b4ef256583f1ea3$var$completeJsmTaskName('invite-your-team-task');
const $9b4ef256583f1ea3$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $9b4ef256583f1ea3$export$c8ab6996f562d0db = (0, $ljej9.toAccountId)('accountId');
const $9b4ef256583f1ea3$export$2b5f951ad8e70cfe = $9b4ef256583f1ea3$var$completeJswTaskName('kanban-onboarding-task');
const $9b4ef256583f1ea3$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $9b4ef256583f1ea3$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $9b4ef256583f1ea3$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $9b4ef256583f1ea3$export$38fbac7a5bf4aa33 = [
    $9b4ef256583f1ea3$export$2a82344eb273eeff,
    $9b4ef256583f1ea3$export$99b0e09ff6f00490,
    $9b4ef256583f1ea3$export$1de5766b7e640d6b
];
const $9b4ef256583f1ea3$export$7578902c7f420a3 = [
    $9b4ef256583f1ea3$export$88c918f2cfaff86,
    $9b4ef256583f1ea3$export$6a4507e462fd41da,
    $9b4ef256583f1ea3$export$e64c1dced6ac4458,
    $9b4ef256583f1ea3$export$63b0e55f9c6454ac,
    $9b4ef256583f1ea3$export$c1effb1c8979fe22,
    $9b4ef256583f1ea3$export$cbeb719208f32c8a,
    $9b4ef256583f1ea3$export$abbbea7c37c93cb5,
    $9b4ef256583f1ea3$export$2a0253cb20f48a8,
    $9b4ef256583f1ea3$export$f97428bb4b1991ec,
    $9b4ef256583f1ea3$export$d6c67e9aab4e2b26,
    $9b4ef256583f1ea3$export$3de8c242d2b82f26,
    $9b4ef256583f1ea3$export$a01fa44f793dbfac,
    $9b4ef256583f1ea3$export$45eaf4204fcc7,
    $9b4ef256583f1ea3$export$af57685e201438e8,
    $9b4ef256583f1ea3$export$d97d31d934dbb194,
    $9b4ef256583f1ea3$export$cafb5bd13b02056b,
    $9b4ef256583f1ea3$export$e55c18b809946e72,
    $9b4ef256583f1ea3$export$de5640b9ae8140a7,
    $9b4ef256583f1ea3$export$540b5c3c4b6ce459,
    $9b4ef256583f1ea3$export$6f71dff531ff592,
    $9b4ef256583f1ea3$export$83255ab79e45f34f,
    $9b4ef256583f1ea3$export$b57d172af9ad7647,
    $9b4ef256583f1ea3$export$ff4c933c1fe90b68,
    $9b4ef256583f1ea3$export$77071b77e2801b18,
    $9b4ef256583f1ea3$export$94ad6507a703f4eb,
    $9b4ef256583f1ea3$export$501166b25f254aab,
    $9b4ef256583f1ea3$export$be1c522400a1bd7c,
    $9b4ef256583f1ea3$export$2aa6e7b6e24a04f5,
    $9b4ef256583f1ea3$export$f3b53199b07af2a1,
    $9b4ef256583f1ea3$export$d37415ffddcf2142,
    $9b4ef256583f1ea3$export$2ae00586da7cb606,
    $9b4ef256583f1ea3$export$9c89f946f05d884a,
    $9b4ef256583f1ea3$export$20bc3dc137ac1c38,
    $9b4ef256583f1ea3$export$b52a7c936684cfc5,
    $9b4ef256583f1ea3$export$b5555f24061f9fb,
    $9b4ef256583f1ea3$export$ff25449f34b8abf,
    $9b4ef256583f1ea3$export$3380e677209260fe,
    $9b4ef256583f1ea3$export$b86266e6594a97bb,
    $9b4ef256583f1ea3$export$3e2776d61f3662dc,
    $9b4ef256583f1ea3$export$2b5f951ad8e70cfe,
    $9b4ef256583f1ea3$export$9048315f2c03fd9d,
    $9b4ef256583f1ea3$export$4145c2cec2da6f9b,
    $9b4ef256583f1ea3$export$4957a1ad203cf6dd,
    $9b4ef256583f1ea3$export$7a2fcaad1564e6b7,
    $9b4ef256583f1ea3$export$190b5dd0a1322552,
    $9b4ef256583f1ea3$export$da23b72d32bfad9e,
    $9b4ef256583f1ea3$export$4b064659282e0238,
    $9b4ef256583f1ea3$export$3ab51851f6d823e,
    $9b4ef256583f1ea3$export$e4a1a37a9a1350ad,
    $9b4ef256583f1ea3$export$b7f7da5e795f0327,
    $9b4ef256583f1ea3$export$80a401c1aa47a377,
    $9b4ef256583f1ea3$export$934ac7a251b26dc7,
    $9b4ef256583f1ea3$export$4634f6395df3ebbe,
    $9b4ef256583f1ea3$export$768fb41107a1e8d7,
    $9b4ef256583f1ea3$export$d797a81bace17184,
    $9b4ef256583f1ea3$export$746102c94db9df1f,
    $9b4ef256583f1ea3$export$5f1efd797d65e349,
    $9b4ef256583f1ea3$export$cccc812ccafbf11f,
    $9b4ef256583f1ea3$export$64822db87abd8a47,
    $9b4ef256583f1ea3$export$64f764d8be495c82,
    $9b4ef256583f1ea3$export$24eae23dc1c68bbd,
    $9b4ef256583f1ea3$export$50fa92eba6f82feb,
    $9b4ef256583f1ea3$export$4155d22fe3f14cd6,
    $9b4ef256583f1ea3$export$76813cbead887191,
    $9b4ef256583f1ea3$export$90aab2ff89daf770,
    $9b4ef256583f1ea3$export$a2bc0cbad2e6e605,
    $9b4ef256583f1ea3$export$f90872a1280728bb,
    $9b4ef256583f1ea3$export$bce644e96518cbd2,
    $9b4ef256583f1ea3$export$241aaebffac0a3e5,
    $9b4ef256583f1ea3$export$f9dfc43b5b31c4b7,
    $9b4ef256583f1ea3$export$79759e9e62fb9312,
    $9b4ef256583f1ea3$export$992d1e0dce255d19,
    $9b4ef256583f1ea3$export$d28c1b0e5b3e768,
    $9b4ef256583f1ea3$export$ca714ee197bed4ec,
    $9b4ef256583f1ea3$export$faae55ceea4b6073,
    $9b4ef256583f1ea3$export$200bc24cd120667e,
    $9b4ef256583f1ea3$export$a0d784a48b4e886c,
    $9b4ef256583f1ea3$export$baf5bd09b4b33b8a,
    $9b4ef256583f1ea3$export$4702007eedbca8ab,
    $9b4ef256583f1ea3$export$aa9d2d635ea63898,
    $9b4ef256583f1ea3$export$2ea449225c1f6cac,
    $9b4ef256583f1ea3$export$deb8b557e735e26a,
    $9b4ef256583f1ea3$export$d45754df44e4c309,
    $9b4ef256583f1ea3$export$78b2913b550edbb,
    $9b4ef256583f1ea3$export$71243272608c58ab,
    $9b4ef256583f1ea3$export$39a08f215c33bc39,
    $9b4ef256583f1ea3$export$d2377f6a6fa3b49c,
    $9b4ef256583f1ea3$export$befa8f6533309779,
    $9b4ef256583f1ea3$export$736b40db8701ba6c,
    // Tailored onboarding M3
    $9b4ef256583f1ea3$export$11eff6ae2f70b67b,
    $9b4ef256583f1ea3$export$fb2d23e5315a67a9,
    $9b4ef256583f1ea3$export$32e794bb49d60b6,
    $9b4ef256583f1ea3$export$fed256238b27db06,
    $9b4ef256583f1ea3$export$132eecb4d35a590d,
    $9b4ef256583f1ea3$export$2579c51cadd45eca,
    $9b4ef256583f1ea3$export$4b1a0cefa966ea0,
    $9b4ef256583f1ea3$export$f6558daacc312a65,
    $9b4ef256583f1ea3$export$925efa2e24e86b88,
    $9b4ef256583f1ea3$export$40454d3e062dcd44
];
const $9b4ef256583f1ea3$export$5980f41aa657f9c7 = [
    'SAM1'
];

});

parcelRegister("4NsfZ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $39220db316456429$export$e324594224ef24da);

var $9w2jV = parcelRequire("9w2jV");

var $9jCgU = parcelRequire("9jCgU");

var $bc2a8 = parcelRequire("bc2a8");

var $kpUPF = parcelRequire("kpUPF");

var $b6yo1 = parcelRequire("b6yo1");

var $iTkHr = parcelRequire("iTkHr");

var $VrLd0 = parcelRequire("VrLd0");

var $hc2fd = parcelRequire("hc2fd");

var $7BMTT = parcelRequire("7BMTT");

var $27SP3 = parcelRequire("27SP3");

var $DHvqm = parcelRequire("DHvqm");

var $gWAj1 = parcelRequire("gWAj1");

var $4u1bX = parcelRequire("4u1bX");

var $9Zwvs = parcelRequire("9Zwvs");

var $jIA25 = parcelRequire("jIA25");

var $4RIzA = parcelRequire("4RIzA");

var $1ntUB = parcelRequire("1ntUB");

var $hcEqM = parcelRequire("hcEqM");

var $4AM50 = parcelRequire("4AM50");

var $b1NgJ = parcelRequire("b1NgJ");

var $75ZOj = parcelRequire("75ZOj");

var $4ewzp = parcelRequire("4ewzp");

var $STfOf = parcelRequire("STfOf");

var $6wCHd = parcelRequire("6wCHd");
const $39220db316456429$export$e324594224ef24da = {
    changeTaskGroupParent: $9w2jV.nextChangeTaskGroupParent,
    goBackToPreviousTaskGroup: $9w2jV.nextGoBackToPreviousTaskGroup,
    setIsOpen: $9jCgU.setIsOpen,
    refreshAppState: $bc2a8.refreshAppState,
    setNudgeStep: $kpUPF.setNudgeStep,
    addMountedNudge: $b6yo1.addMountedNudge,
    removeMountedNudge: $b6yo1.removeMountedNudge,
    setShouldRenderComponent: $iTkHr.setShouldRenderComponent,
    setProjectState: $VrLd0.setProjectState,
    setHasNudgeActive: $hc2fd.setHasNudgeActive,
    forceHideNudge: $7BMTT.forceHideNudge,
    setHasEverSeenRoute: $27SP3.setHasEverSeenRoute,
    setRoadmapIsCreateEnabled: $DHvqm.setRoadmapIsCreateEnabled,
    setRoadmapIsListEmpty: $DHvqm.setRoadmapIsListEmpty,
    openNextTask: $gWAj1.openNextTask,
    resetIsQuickstartLoaded: $4u1bX.resetIsQuickstartLoaded,
    refreshAppStateUiStatusOnly: $9Zwvs.refreshAppStateUiStatusOnly,
    nextMarkAsCompletedTask: $jIA25.nextMarkAsCompletedTask,
    nextSetChecklistItemSeen: $4RIzA.nextSetChecklistItemSeen,
    nextSetChecklistIsDismissed: $1ntUB.nextSetChecklistIsDismissed,
    nextSetChecklistIsOpen: $hcEqM.nextSetChecklistIsOpen,
    nextOpenTask: $4AM50.nextOpenTask,
    nextAutoExpand: $b1NgJ.nextAutoExpand,
    nextShouldShowNudgeAfterNavigation: $75ZOj.nextShouldShowNudgeAfterNavigation,
    nextGetTasks: $4ewzp.nextGetTasks,
    syncVisibilityWithLocal: $STfOf.syncVisibilityWithLocal,
    universalDispatch: $6wCHd.universalDispatch
};

});
parcelRegister("9w2jV", function(module, exports) {

$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $c67ac35b88465cb8$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $c67ac35b88465cb8$export$57534cbc400a434c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7jTnu = parcelRequire("7jTnu");

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");
const $c67ac35b88465cb8$var$setTaskGroup = (taskGroup, openTask)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: openTask || ''
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $c67ac35b88465cb8$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($c67ac35b88465cb8$var$setTaskGroup(taskGroup));
    };
const $c67ac35b88465cb8$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        if ((0, $7jTnu.fg)('jira_a11y_fix_returning_focus')) {
            const { previousTaskGroupParents: previousTaskGroupParents, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
            const lastIndexOfPreviousTaskGroupParents = previousTaskGroupParents.length - 1;
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $9ycBx.ROOT_TASK) : previousTaskGroupParents[lastIndexOfPreviousTaskGroupParents];
            const newPreviousTaskGroupParents = previousTaskGroupParents.slice(0, lastIndexOfPreviousTaskGroupParents);
            const taskGroup = {
                previousTaskGroupParents: newPreviousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            dispatch($c67ac35b88465cb8$var$setTaskGroup(taskGroup, currentTriggerForTaskGroupParent));
        } else {
            const { previousTaskGroupParents: previousTaskGroupParents } = getState();
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $9ycBx.ROOT_TASK) : previousTaskGroupParents.pop();
            const taskGroup = {
                previousTaskGroupParents: previousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            // @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
            dispatch($c67ac35b88465cb8$var$setTaskGroup(taskGroup));
        }
    };

});
parcelRegister("6d5N9", function(module, exports) {

$parcel$export(module.exports, "pushToBackend", () => $968fd65112be9cd3$export$583b2d2422a6757f);

var $FppkK = parcelRequire("FppkK");

var $aYncF = parcelRequire("aYncF");

var $gYnSx = parcelRequire("gYnSx");

var $1uIew = parcelRequire("1uIew");
const $968fd65112be9cd3$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $968fd65112be9cd3$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $FppkK.setUserProperties)($968fd65112be9cd3$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $1uIew.default)(response.status, response.statusText);
    });
const $968fd65112be9cd3$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $968fd65112be9cd3$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $968fd65112be9cd3$export$583b2d2422a6757f = async (props)=>{
    const success = await $968fd65112be9cd3$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $968fd65112be9cd3$var$trySetUserProperties(props, 2);
};

});


parcelRegister("9jCgU", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $d6b89ce939fd1abc$export$dcf23146e0a40195);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $3XHRA = parcelRequire("3XHRA");
const $d6b89ce939fd1abc$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            }
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        // Delete code below when cleaning up isOpen in state
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: isOpen
        });
    };
var $d6b89ce939fd1abc$export$2e2bcd8739ae039 = $d6b89ce939fd1abc$export$dcf23146e0a40195;

});
parcelRegister("3XHRA", function(module, exports) {

$parcel$export(module.exports, "getQuickstartTypeSelector", () => $5e767603cbb6a27b$export$eae834ce0286017a);

var $ln6Iy = parcelRequire("ln6Iy");

var $9ycBx = parcelRequire("9ycBx");
const $5e767603cbb6a27b$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT);
const $5e767603cbb6a27b$export$eae834ce0286017a = (state)=>{
    if ($5e767603cbb6a27b$export$6f17f2cb816105eb(state)) return (0, $9ycBx.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $9ycBx.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("bc2a8", function(module, exports) {

$parcel$export(module.exports, "refreshAppState", () => $f970723875566945$export$797c35e2e1d0d014);


var $z1I7k = parcelRequire("z1I7k");

var $gCeeo = parcelRequire("gCeeo");

var $31GRl = parcelRequire("31GRl");

var $a9ldn = parcelRequire("a9ldn");

var $7jTnu = parcelRequire("7jTnu");

var $9ycBx = parcelRequire("9ycBx");

var $79a1F = parcelRequire("79a1F");

var $6d5N9 = parcelRequire("6d5N9");

var $dELL6 = parcelRequire("dELL6");

var $8hqW7 = parcelRequire("8hqW7");

var $86LDA = parcelRequire("86LDA");

var $uMSsJ = parcelRequire("uMSsJ");

var $1ntUB = parcelRequire("1ntUB");

var $hcEqM = parcelRequire("hcEqM");

var $jIA25 = parcelRequire("jIA25");

var $9w2jV = parcelRequire("9w2jV");
const $f970723875566945$var$allTasks = [
    ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks),
    ...(0, $9ycBx.JSM_BUSINESS_TASKS)
];
const $f970723875566945$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const hasSeenTasks = [
            (0, $9ycBx.convertToHaveSeenItTask)((0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK)),
            (0, $9ycBx.convertToHaveSeenItTask)((0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
            (0, $9ycBx.convertToHaveSeenItTask)((0, $9ycBx.STANDARD_EDITION_OVERVIEW_TASK))
        ];
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectType;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $9ycBx.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $9ycBx.QUICKSTART_TYPE)).map((type)=>(0, $9ycBx.getBackendVisibilityKey)(type));
        if (projectState?.projectId) jsmTaskProjectKeys = (0, $9ycBx.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        const backendState = await (0, $79a1F.pollBackend)({
            keys: [
                (0, $9ycBx.KEY_OPEN),
                (0, $9ycBx.KEY_DISMISSED),
                (0, $9ycBx.KEY_OPEN_TASK),
                (0, $9ycBx.KEY_TASK_GROUP),
                (0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $9ycBx.KEY_JSW_ONBOARDING),
                (0, $9ycBx.KEY_PREMIUM_TRIAL_REOPENED),
                ...$f970723875566945$var$allTasks,
                ...hasSeenTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks),
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true);
            updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
            Object.values((0, $9ycBx.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $9ycBx.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $9ycBx.getBackendVisibilityKey)(type)];
                else if ((0, $9ycBx.KEY_DISMISSED) in backendState && backendState[0, $9ycBx.KEY_DISMISSED]) updatedState.visibility[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $9ycBx.KEY_OPEN] ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
                (0, $uMSsJ.setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
            });
            // Delete when cleaning up isDismissed in state
            if ((0, $9ycBx.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $9ycBx.KEY_DISMISSED];
            // Delete when cleaning up isOpen in state
            if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $9ycBx.KEY_OPEN];
            if ((0, $9ycBx.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $9ycBx.KEY_OPEN_TASK];
            if ((0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $9ycBx.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $9ycBx.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $9ycBx.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $9ycBx.KEY_JSW_ONBOARDING] !== null && (0, $2b839a8453de5367$export$8a00ecf6498ee2fe) in backendState[0, $9ycBx.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $9ycBx.KEY_JSW_ONBOARDING][0, $2b839a8453de5367$export$8a00ecf6498ee2fe];
            }
        }
        // Important that this call is before the dismiss migration logic and the premium card permission migration, otherwise it would
        // override the dismiss and currentTaskGroupParent
        setState(updatedState);
        // Bit of a migration
        // Handles case where non-admin premium users have a premium card child open which they can no longer access as we added more permission checks
        // Or, if a user was on a premium trial and saw premium content but is now free,
        // We take them to the root instead
        if ((updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, $a9ldn.PREMIUM_EDITION)) {
            dispatch((0, $9w2jV.nextGoBackToPreviousTaskGroup)());
            const analyticsEvent = createAnalyticsEvent({});
            (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
        }
        if (!(backendStateExists && (0, $9ycBx.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $86LDA.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $1ntUB.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $dELL6.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const jswTrackDeferSitenameSiteTrait = await (0, $z1I7k.getJswTrackDeferSitenameSiteTrait)(cloudId, {
            packageName: (0, $9ycBx.PACKAGE_NAME),
            teamName: (0, $9ycBx.PACKAGE_TEAM_NAME)
        });
        setState({
            isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
        });
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $8hqW7.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $a9ldn.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
        // If the user is on a JSW Premium instance, perform a fetch to check that they signed up with a Premium Reverse Trial.
        let isReverseTrialForJSW;
        if (isTargetedForReverseTrials) {
            const isOnboardingPremiumTrial = await (0, $31GRl.getOnboardingPremiumTrial)();
            isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
        }
        /**
		 * Re-open QS for:
		 *  - admins on an AdvancedRoadmaps trial who haven't had it re-opened for them yet
		 *  - non-admins on an AdvancedRoadmaps trial with isCrossProjectBoardToPlanUpsell trait
		 */ if (!(0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name') && !isReverseTrialForJSW && appEditions.software === (0, $a9ldn.PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, $9ycBx.KEY_PREMIUM_TRIAL_REOPENED]) {
            // Re-open QS if not already opened
            dispatch((0, $hcEqM.nextSetChecklistIsOpen)(true));
            dispatch((0, $1ntUB.nextSetChecklistIsDismissed)(false));
            const taskToDispatch = isAdmin ? (0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK) : (0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
            // Go to advanced roadmaps task
            dispatch((0, $jIA25.nextMarkAsCompletedTask)(taskToDispatch));
            dispatch((0, $9w2jV.nextChangeTaskGroupParent)(taskToDispatch));
            await (0, $6d5N9.pushToBackend)({
                key: (0, $9ycBx.KEY_PREMIUM_TRIAL_REOPENED),
                value: true
            });
            const analyticsEvent = createAnalyticsEvent({});
            (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                isAdmin: isAdmin
            });
        }
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
parcelRegister("z1I7k", function(module, exports) {

$parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", () => $016ff2d2518db69d$export$686752df505238be);
$parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", () => $016ff2d2518db69d$export$6da79f996c267010);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $016ff2d2518db69d$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $016ff2d2518db69d$var$SITE_PERSONALIZATION_ENDPOINT = `${$016ff2d2518db69d$var$PERSONALIZATION_ENDPOINT}/site/`;
const $016ff2d2518db69d$var$USER_PERSONALIZATION_ENDPOINT = `${$016ff2d2518db69d$var$PERSONALIZATION_ENDPOINT}/user/`;
const $016ff2d2518db69d$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
const $016ff2d2518db69d$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
const $016ff2d2518db69d$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
        try {
            const url = endpoint + id;
            return await (0, $jGzN3.performGetRequest)(url);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'onboarding',
                    teamName: 'jlove-makkuro',
                    ...meta
                },
                attributes: {
                    subject: subject
                },
                error: error
            });
            return undefined;
        }
    };
const $016ff2d2518db69d$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
        const personalization = await fetch(id, meta);
        return personalization?.attributes?.find((att)=>att.name === traitName);
    };
const $016ff2d2518db69d$export$686752df505238be = $016ff2d2518db69d$var$getTraits($016ff2d2518db69d$var$fetchPersonalization($016ff2d2518db69d$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $016ff2d2518db69d$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
const $016ff2d2518db69d$export$6da79f996c267010 = $016ff2d2518db69d$var$getTraits($016ff2d2518db69d$var$fetchPersonalization($016ff2d2518db69d$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $016ff2d2518db69d$var$JSW_TRACK_DEFER_SITENAME_TRAIT);

});

parcelRegister("31GRl", function(module, exports) {

$parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", () => $8ddabc55934459cc$export$d9a9dd6206da5bef);
$parcel$export(module.exports, "getOnboardingPremiumTrial", () => $8ddabc55934459cc$export$ef676f7f369f74fe);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $iCPdV = parcelRequire("iCPdV");
const $8ddabc55934459cc$var$endpoint = '/rest/onboarding/1.0/premium-trial';
const $8ddabc55934459cc$export$d9a9dd6206da5bef = async ()=>{
    try {
        // Attempt to get from localStorage
        const localStorageOnboardingPremiumTrial = (0, $iCPdV.localStorageGetOnboardingPremiumTrial)();
        const localStorageOnboardingPremiumTrialCohort = (0, $iCPdV.localStorageGetOnboardingPremiumTrialCohort)();
        if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
            premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
            reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
        };
        const response = await (0, $jGzN3.performGetRequestWithRetry)($8ddabc55934459cc$var$endpoint);
        const premiumTrialOnSignup = response?.premiumTrialOnSignup;
        const reverseTrialCohort = response?.reverseTrialCohort;
        if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
            // Set into localStorage
            (0, $iCPdV.localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
            (0, $iCPdV.localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
            return {
                premiumTrialOnSignup: premiumTrialOnSignup,
                reverseTrialCohort: reverseTrialCohort
            };
        }
        throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'getOnboardingPremiumTrialWithRethrow',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $8ddabc55934459cc$export$ef676f7f369f74fe = async ()=>{
    try {
        return await $8ddabc55934459cc$export$d9a9dd6206da5bef();
    } catch (e) {
    // ignored
    }
};

});
parcelRegister("iCPdV", function(module, exports) {

$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", () => $880bf1d3001e9a60$export$782df5489e5cfd1e);
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", () => $880bf1d3001e9a60$export$c3378895d06b5528);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", () => $880bf1d3001e9a60$export$f83a7a49524e74ad);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", () => $880bf1d3001e9a60$export$f389f8ca168b4a3a);

var $dnU6V = parcelRequire("dnU6V");

var $gYnSx = parcelRequire("gYnSx");
const $880bf1d3001e9a60$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
const $880bf1d3001e9a60$export$2f93fdc3330233dc = 'reverseTrialCohort';
const $880bf1d3001e9a60$var$localStorage = (0, $dnU6V.createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
const $880bf1d3001e9a60$export$782df5489e5cfd1e = ()=>{
    try {
        const value = $880bf1d3001e9a60$var$localStorage.get($880bf1d3001e9a60$export$3538ee3f5c6c8b5c);
        // localStorage.get is able to return proper booleans and not stringified booleans like "true"/"false"
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $880bf1d3001e9a60$export$c3378895d06b5528 = ()=>{
    try {
        const value = $880bf1d3001e9a60$var$localStorage.get($880bf1d3001e9a60$export$2f93fdc3330233dc);
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $880bf1d3001e9a60$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
    try {
        $880bf1d3001e9a60$var$localStorage.set($880bf1d3001e9a60$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $880bf1d3001e9a60$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
    try {
        $880bf1d3001e9a60$var$localStorage.set($880bf1d3001e9a60$export$2f93fdc3330233dc, reverseTrialCohort);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("79a1F", function(module, exports) {

$parcel$export(module.exports, "pollBackend", () => $a820ac7275a95d77$export$8420ef0cee98de);

var $fnu0d = parcelRequire("fnu0d");

var $9ycBx = parcelRequire("9ycBx");
const $a820ac7275a95d77$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $fnu0d.get)({
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $9ycBx.PACKAGE_NAME),
            teamName: (0, $9ycBx.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("fnu0d", function(module, exports) {

$parcel$export(module.exports, "get", () => $c086e1f54a79cb95$export$3988ae62b71be9a3);

var $5spib = parcelRequire("5spib");

var $4CEkC = parcelRequire("4CEkC");

var $gYnSx = parcelRequire("gYnSx");

var $8KUFq = parcelRequire("8KUFq");

var $jGzN3 = parcelRequire("jGzN3");

var $2Mqjh = parcelRequire("2Mqjh");

var $aRK4c = parcelRequire("aRK4c");
var $9GzfC = parcelRequire("9GzfC");
let $c086e1f54a79cb95$var$ufoExperiencesMap = {};
const $c086e1f54a79cb95$var$getUfoExperience = (key)=>{
    if (!$c086e1f54a79cb95$var$ufoExperiencesMap[key]) $c086e1f54a79cb95$var$ufoExperiencesMap[key] = new (0, $9GzfC.UFOExperience)(key, {
        type: (0, $aRK4c.ExperienceTypes).Operation,
        performanceType: (0, $aRK4c.ExperiencePerformanceTypes).Custom
    });
    return $c086e1f54a79cb95$var$ufoExperiencesMap[key];
};
const $c086e1f54a79cb95$export$c907f169d33b2e25 = ()=>{
    $c086e1f54a79cb95$var$ufoExperiencesMap = {};
};
const $c086e1f54a79cb95$export$a5b7a8c3b1c6e775 = ({ userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c086e1f54a79cb95$var$patchProperties = (response, propertiesPath)=>response && (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $c086e1f54a79cb95$export$3988ae62b71be9a3 = async (options)=>{
    const ufoExperience = $c086e1f54a79cb95$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($4CEkC)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($4CEkC)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $c086e1f54a79cb95$export$a5b7a8c3b1c6e775(options);
        const response = await (0, $jGzN3.performGetRequest)(url);
        if (response === null) (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'succeeded',
                actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                source: 'frontendConfigProperties',
                attributes: {
                    package: consumerMeta.packageName,
                    id: consumerMeta.id,
                    isNullResponse: true
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        $c086e1f54a79cb95$var$patchProperties(response, 'user');
        $c086e1f54a79cb95$var$patchProperties(response, 'instance');
        $c086e1f54a79cb95$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return response || {
            user: {},
            instance: {},
            project: {}
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $8KUFq.isClientFetchError)(error) && (0, $gYnSx.default)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});


parcelRegister("dELL6", function(module, exports) {

$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $c95fada5ff0e59fd$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $c95fada5ff0e59fd$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $c95fada5ff0e59fd$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $c95fada5ff0e59fd$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $c95fada5ff0e59fd$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $c95fada5ff0e59fd$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $c95fada5ff0e59fd$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $c95fada5ff0e59fd$export$6ccbe54cd3a5a12);
$parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", () => $c95fada5ff0e59fd$export$6c39ca65ca354e59);

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");

var $9ycBx = parcelRequire("9ycBx");

var $46NrI = parcelRequire("46NrI");
const $c95fada5ff0e59fd$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $9ycBx.ACTION_SUBJECT_ID), attributes);
};
const $c95fada5ff0e59fd$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $c95fada5ff0e59fd$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $c95fada5ff0e59fd$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $c95fada5ff0e59fd$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $46NrI.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $c95fada5ff0e59fd$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $gYnSx.default)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $c95fada5ff0e59fd$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $c95fada5ff0e59fd$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $c95fada5ff0e59fd$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("46NrI", function(module, exports) {

$parcel$export(module.exports, "getProductType", () => $220645f5a7e2c3df$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $220645f5a7e2c3df$export$3b914201960fa7a6);

var $7mF43 = parcelRequire("7mF43");

var $ln6Iy = parcelRequire("ln6Iy");
const $220645f5a7e2c3df$export$d64a7dd8c7cd80e0 = {
    [(0, $ln6Iy.CORE_PROJECT)]: 'workManagement',
    [(0, $ln6Iy.SOFTWARE_PROJECT)]: 'software',
    [(0, $ln6Iy.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $220645f5a7e2c3df$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $220645f5a7e2c3df$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(projectType);
    return null;
};
const $220645f5a7e2c3df$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(taskId.split('.').pop());
};

});


parcelRegister("8hqW7", function(module, exports) {

$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $53b23fbdedb29316$export$7f2186c37a3d095d);

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $jGzN3 = parcelRequire("jGzN3");

var $gCeeo = parcelRequire("gCeeo");

var $9ycBx = parcelRequire("9ycBx");

var $cCGZI = parcelRequire("cCGZI");
const $53b23fbdedb29316$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $53b23fbdedb29316$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $53b23fbdedb29316$var$ONE_DAY = 86400000;
const $53b23fbdedb29316$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$53b23fbdedb29316$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $jGzN3.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $7jTnu.fg)('is_synthetic_tenant')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $9ycBx.PACKAGE_NAME),
                teamName: (0, $9ycBx.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $7jTnu.fg)('is_synthetic_tenant')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $53b23fbdedb29316$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $cCGZI.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $53b23fbdedb29316$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $7jTnu.fg)('is_synthetic_tenant')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $53b23fbdedb29316$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $53b23fbdedb29316$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("cCGZI", function(module, exports) {

$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $c5da128a7c764253$export$99f3e48748c2a8c3);

var $4elgJ = parcelRequire("4elgJ");

const $c5da128a7c764253$var$crossProjectBoardTraitSessionProvider = (0, $4elgJ.createSessionExpirableStorageProvider)((0, $70024ada6ee08235$export$fac14ff24e5b1e7a));
const $c5da128a7c764253$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        $c5da128a7c764253$var$crossProjectBoardTraitSessionProvider.set((0, $70024ada6ee08235$export$fac14ff24e5b1e7a), toPersist);
    };
    const get = ()=>$c5da128a7c764253$var$crossProjectBoardTraitSessionProvider.get((0, $70024ada6ee08235$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
parcelRegister("4elgJ", function(module, exports) {

$parcel$export(module.exports, "createSessionStorageProvider", () => $f208fb4d7830e639$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $f208fb4d7830e639$export$e0a2e9a062c6a695);

var $5PQOA = parcelRequire("5PQOA");

var $iuNRp = parcelRequire("iuNRp");

var $agkTI = parcelRequire("agkTI");
const $f208fb4d7830e639$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((appPrefix, shouldSerialize = true)=>(0, $iuNRp.createStorageProvider)((0, $iuNRp.WebStorageType).SessionStorage, appPrefix, (0, $agkTI.makeSessionStore)(), shouldSerialize));
const $f208fb4d7830e639$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    return (0, $iuNRp.createExpirableStorageProvider)((0, $iuNRp.WebStorageType).SessionStorage, appPrefix, (0, $agkTI.makeSessionExpirableStore)());
});

});
parcelRegister("agkTI", function(module, exports) {

$parcel$export(module.exports, "makeSessionStore", () => $a7c3f7fc6c065ac0$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $a7c3f7fc6c065ac0$export$a8f626c8ded9a06c);

var $fsdQg = parcelRequire("fsdQg");

var $252Bx = parcelRequire("252Bx");

var $02LWr = parcelRequire("02LWr");

var $jZWi5 = parcelRequire("jZWi5");

var $asupr = parcelRequire("asupr");

var $iuNRp = parcelRequire("iuNRp");
const $a7c3f7fc6c065ac0$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($02LWr))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($asupr))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jZWi5)))
    ], (0, $iuNRp.plugins));
const $a7c3f7fc6c065ac0$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($02LWr))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($asupr))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jZWi5)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fsdQg))),
        (0, (/*@__PURE__*/$parcel$interopDefault($252Bx)))
    ]);

});


const $70024ada6ee08235$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("86LDA", function(module, exports) {

$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $d056ac553c2189c1$export$980c26b6f100081d);

var $jGzN3 = parcelRequire("jGzN3");
const $d056ac553c2189c1$export$980c26b6f100081d = ()=>(0, $jGzN3.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("uMSsJ", function(module, exports) {

$parcel$export(module.exports, "getNextNonCompleteTask", () => $d41b9686fb79c7bc$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $d41b9686fb79c7bc$export$404421ce8f3cbf9a);
$parcel$export(module.exports, "setLocalStorageItem", () => $d41b9686fb79c7bc$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $d41b9686fb79c7bc$export$93d719890ad66653);

var $dnU6V = parcelRequire("dnU6V");

var $gZkaf = parcelRequire("gZkaf");
const $d41b9686fb79c7bc$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $gZkaf.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $d41b9686fb79c7bc$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $gZkaf.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};
const $d41b9686fb79c7bc$var$store = (0, $dnU6V.createLocalStorageProvider)('quickstart');
const $d41b9686fb79c7bc$export$5aa524d86254b4f = (key, value)=>{
    $d41b9686fb79c7bc$var$store.set(key, value);
};
const $d41b9686fb79c7bc$export$93d719890ad66653 = (key)=>$d41b9686fb79c7bc$var$store.get(key);

});
parcelRegister("gZkaf", function(module, exports) {

$parcel$export(module.exports, "getTaskIndex", () => $e5e0a63f9d11b989$export$9ba3adcb1954c00);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", () => $e5e0a63f9d11b989$export$9711f11998d5795c);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", () => $e5e0a63f9d11b989$export$995248f3b43d8505);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", () => $e5e0a63f9d11b989$export$293f6b2affa6ea5a);

var $46NrI = parcelRequire("46NrI");







const $e5e0a63f9d11b989$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};
const $e5e0a63f9d11b989$export$9711f11998d5795c = (taskId)=>`${(0, $46NrI.convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
const $e5e0a63f9d11b989$export$995248f3b43d8505 = (taskId)=>`${(0, $46NrI.convertTaskIdToActionSubjectId)(taskId)}Link`;
const $e5e0a63f9d11b989$export$293f6b2affa6ea5a = (taskId)=>`${(0, $46NrI.convertTaskIdToActionSubjectId)(taskId)}Cta`;

});


parcelRegister("1ntUB", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $90c4f819f308a0de$export$f24c05f83b880547);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");
const $90c4f819f308a0de$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED : (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $uMSsJ.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isDismissed in state
        if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: true
        });
        else // When setting IsDismissed, also toggle the open state of the checklist to match.
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: false
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_DISMISSED),
            value: isDismissed
        });
    };

});

parcelRegister("hcEqM", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $4e92599f1808f020$export$4249eabbb34e2e69);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");
const $4e92599f1808f020$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
        const currentIsMinimised = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
        if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $uMSsJ.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isOpen in state
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: isOpen
        });
    };

});

parcelRegister("jIA25", function(module, exports) {

$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $53dc3dee14098ca0$export$d6628d41a3bec42d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6d5N9 = parcelRequire("6d5N9");
const $53dc3dee14098ca0$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $6d5N9.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});


parcelRegister("kpUPF", function(module, exports) {

$parcel$export(module.exports, "setNudgeStep", () => $4ac0db746ee3e19c$export$4debc323813b6997);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $4ac0db746ee3e19c$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $4ac0db746ee3e19c$export$2e2bcd8739ae039 = $4ac0db746ee3e19c$export$4debc323813b6997;

});

parcelRegister("b6yo1", function(module, exports) {

$parcel$export(module.exports, "addMountedNudge", () => $a7896299b4c2538c$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $a7896299b4c2538c$export$748f4cda8ab98c91);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $a7896299b4c2538c$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $a7896299b4c2538c$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("iTkHr", function(module, exports) {

$parcel$export(module.exports, "setShouldRenderComponent", () => $9e529cdb63511cc5$export$1f9c6770ed938b6e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $9e529cdb63511cc5$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $9e529cdb63511cc5$export$2e2bcd8739ae039 = $9e529cdb63511cc5$export$1f9c6770ed938b6e;

});

parcelRegister("VrLd0", function(module, exports) {

$parcel$export(module.exports, "setProjectState", () => $fb6d4843482b7a21$export$1ba498e440c0a1e4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $fb6d4843482b7a21$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $fb6d4843482b7a21$export$2e2bcd8739ae039 = $fb6d4843482b7a21$export$1ba498e440c0a1e4;

});

parcelRegister("hc2fd", function(module, exports) {

$parcel$export(module.exports, "setHasNudgeActive", () => $655ce5c27a1ef578$export$497c281e6eb0786e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $655ce5c27a1ef578$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $655ce5c27a1ef578$export$2e2bcd8739ae039 = $655ce5c27a1ef578$export$497c281e6eb0786e;

});

parcelRegister("7BMTT", function(module, exports) {

$parcel$export(module.exports, "forceHideNudge", () => $748cd7120d515b8c$export$6d1ed97b83a62e8e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
// We use this action in cases where we want to hide the nudge no matter what.
const $748cd7120d515b8c$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("27SP3", function(module, exports) {

$parcel$export(module.exports, "setHasEverSeenRoute", () => $8cdbd8bb590a918c$export$28e0a4314a1ce52f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");
const $8cdbd8bb590a918c$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $8cdbd8bb590a918c$export$2e2bcd8739ae039 = $8cdbd8bb590a918c$export$28e0a4314a1ce52f;

});

parcelRegister("DHvqm", function(module, exports) {

$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $f78d96b92dcbe1de$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $f78d96b92dcbe1de$export$932967764e7a0b31);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f78d96b92dcbe1de$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $f78d96b92dcbe1de$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("gWAj1", function(module, exports) {

$parcel$export(module.exports, "openNextTask", () => $163de5e21e24ce13$export$867dbb6d61569ae9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $uMSsJ = parcelRequire("uMSsJ");

var $4AM50 = parcelRequire("4AM50");
const $163de5e21e24ce13$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $uMSsJ.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $4AM50.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("4AM50", function(module, exports) {

$parcel$export(module.exports, "nextOpenTask", () => $b3d3db0c7001002a$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $b3d3db0c7001002a$export$cc5f3544a6cb2922);


var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $kpUPF = parcelRequire("kpUPF");

var $hc2fd = parcelRequire("hc2fd");
const $b3d3db0c7001002a$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $b3d3db0c7001002a$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($b3d3db0c7001002a$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $hc2fd.setHasNudgeActive)(false, taskId));
        else dispatch((0, $hc2fd.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        // This is a temporary solution for Scrum Onboarding.
        // See https://hello.atlassian.net/wiki/spaces/agile/pages/1321008806/Draft+Quickstart+Nudge+Interaction for details
        if (taskIdExistsAndIsNotCompleted && taskId === (0, $9ycBx.SCRUM_ONBOARDING_TASK)) dispatch((0, $kpUPF.setNudgeStep)((0, $2b839a8453de5367$export$b1a6ab17737f33e)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $9ycBx.KANBAN_ONBOARDING_TASK)) dispatch((0, $kpUPF.setNudgeStep)((0, $2b839a8453de5367$export$3366ddefe77d5112)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $9ycBx.ADD_COLUMNS_TASK)) dispatch((0, $kpUPF.setNudgeStep)((0, $2b839a8453de5367$export$3366ddefe77d5112)));
        else dispatch((0, $kpUPF.setNudgeStep)(''));
    };
const $b3d3db0c7001002a$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($b3d3db0c7001002a$var$openTask(taskId));
        dispatch((0, $hc2fd.setHasNudgeActive)(false, taskId));
        dispatch((0, $kpUPF.setNudgeStep)(''));
    };

});


parcelRegister("4u1bX", function(module, exports) {

$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $01d5b170ba597bd8$export$bda085a823763e5a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $3XHRA = parcelRequire("3XHRA");
const $01d5b170ba597bd8$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("9Zwvs", function(module, exports) {

$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => $865d905b5ed9ce34$export$87fe8079a4ed9766);


var $9ycBx = parcelRequire("9ycBx");

var $79a1F = parcelRequire("79a1F");

var $dELL6 = parcelRequire("dELL6");

var $86LDA = parcelRequire("86LDA");

var $1ntUB = parcelRequire("1ntUB");
const $865d905b5ed9ce34$export$87fe8079a4ed9766 = ({ taskList: taskList })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState } = getState();
        if (!projectState) return;
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectState.projectType;
        let backendVisibilityKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $9ycBx.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $9ycBx.QUICKSTART_TYPE)).map((type)=>(0, $9ycBx.getBackendVisibilityKey)(type));
        const backendState = await (0, $79a1F.pollBackend)({
            keys: [
                (0, $9ycBx.KEY_OPEN),
                (0, $9ycBx.KEY_DISMISSED),
                (0, $9ycBx.KEY_OPEN_TASK),
                (0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $9ycBx.KEY_JSW_ONBOARDING),
                ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks),
                ...backendVisibilityKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks)
                ].includes(key) && backendState[key] === true);
            Object.values((0, $9ycBx.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $9ycBx.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $9ycBx.getBackendVisibilityKey)(type)];
                else if ((0, $9ycBx.KEY_DISMISSED) in backendState && backendState[0, $9ycBx.KEY_DISMISSED]) updatedState.visibility[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $9ycBx.KEY_OPEN] ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $9ycBx.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $9ycBx.KEY_DISMISSED];
            if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $9ycBx.KEY_OPEN];
            if ((0, $9ycBx.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $9ycBx.KEY_OPEN_TASK];
            if ((0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $9ycBx.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $9ycBx.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $9ycBx.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $9ycBx.KEY_JSW_ONBOARDING] !== null && (0, $2b839a8453de5367$export$8a00ecf6498ee2fe) in backendState[0, $9ycBx.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $9ycBx.KEY_JSW_ONBOARDING][0, $2b839a8453de5367$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $9ycBx.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $86LDA.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $1ntUB.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $dELL6.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        setState({
            taskList: taskList
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});

parcelRegister("4RIzA", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $d99f03d4977e428c$export$4eac017dcde0be8f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");
const $d99f03d4977e428c$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
        const hasSeenTaskId = (0, $9ycBx.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.convertToHaveSeenItTask)(taskId),
            value: true
        });
    };

});

parcelRegister("b1NgJ", function(module, exports) {

$parcel$export(module.exports, "nextAutoExpand", () => $940a31066334aca1$export$3d24e97d30cfd09e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7jTnu = parcelRequire("7jTnu");

var $9ycBx = parcelRequire("9ycBx");

var $5JVW2 = parcelRequire("5JVW2");

var $uMSsJ = parcelRequire("uMSsJ");

var $4AM50 = parcelRequire("4AM50");
const $940a31066334aca1$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $5JVW2.localStorageProvider)().get({
            accountId: (0, $9ycBx.ACCOUNT_ID),
            key: (0, $9ycBx.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $uMSsJ.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        // If the openTask is the same as the currentTriggerForTaskGroupParent, we just returned back from a sub menu and don't need to auto open the next task
        if ((0, $7jTnu.fg)('jira_a11y_fix_returning_focus')) {
            if (openTask === currentTriggerForTaskGroupParent) return;
        }
        dispatch((0, $4AM50.nextAutoOpenTask)(taskIdToExpand));
    };

});
parcelRegister("5JVW2", function(module, exports) {

$parcel$export(module.exports, "localStorageProvider", () => $8f126aa766b95c06$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $8f126aa766b95c06$export$f2666fae743fa5f);

var $4elgJ = parcelRequire("4elgJ");

var $gYnSx = parcelRequire("gYnSx");

var $9ycBx = parcelRequire("9ycBx");
const $8f126aa766b95c06$var$DAYS_BEFORE_EXPIRY = 1;
const $8f126aa766b95c06$var$DAY = 86400000;
const $8f126aa766b95c06$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $8f126aa766b95c06$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $8f126aa766b95c06$var$DAYS_BEFORE_EXPIRY * $8f126aa766b95c06$var$DAY;
};
let $8f126aa766b95c06$var$localStorage;
const $8f126aa766b95c06$export$aa821bfb3308a1f5 = ()=>{
    if ($8f126aa766b95c06$var$localStorage) return $8f126aa766b95c06$var$localStorage;
    const provider = (0, $4elgJ.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gYnSx.default)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($8f126aa766b95c06$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>provider.set($8f126aa766b95c06$var$getKey({
            accountId: accountId,
            key: key
        }), value, $8f126aa766b95c06$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($8f126aa766b95c06$var$getKey({
            accountId: accountId,
            key: key
        }));
    $8f126aa766b95c06$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    return $8f126aa766b95c06$var$localStorage;
};
const $8f126aa766b95c06$export$f2666fae743fa5f = (value)=>{
    $8f126aa766b95c06$export$aa821bfb3308a1f5().set({
        accountId: (0, $9ycBx.ACCOUNT_ID),
        key: (0, $9ycBx.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});


parcelRegister("75ZOj", function(module, exports) {

$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $ef47ceb0db6e67e3$export$6f336ccb6432fcd0);
// Special case for nudges that need to show after a navigation.
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $5JVW2 = parcelRequire("5JVW2");

var $hc2fd = parcelRequire("hc2fd");
const $ef47ceb0db6e67e3$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $9ycBx.ACCOUNT_ID),
            key: (0, $9ycBx.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $5JVW2.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $hc2fd.setHasNudgeActive)(true));
            (0, $5JVW2.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("4ewzp", function(module, exports) {

$parcel$export(module.exports, "nextGetTasks", () => $58d7175ee2e35561$export$15d877e1f3abf489);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7jTnu = parcelRequire("7jTnu");

var $6P4lT = parcelRequire("6P4lT");

var $4AM50 = parcelRequire("4AM50");
const $58d7175ee2e35561$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { taskList: taskList, completedTaskList: completedTaskList, openTask: openTask, isQuickstartLoaded: isQuickstartLoaded } = getState();
        const tasks = (0, $6P4lT.getAllTasks)({
            ...props,
            taskList: taskList
        });
        setState({
            tasks: tasks
        });
        // Auto-open the first incomplete task if no task is currently open
        // Note: nextGetTasks and refreshAppState can in theory happen in any order
        // Only do this if the quickstart is fully loaded (isQuickstartLoaded = true)
        // This ensures backend state has been restored before we auto-open
        if (tasks?.items && tasks.items.length > 0 && isQuickstartLoaded && (0, $7jTnu.fg)('jira-fix-qs-first-card-opening-on-land')) {
            const firstIncompleteTask = tasks.items.find((taskId)=>!completedTaskList.includes(taskId));
            // If we found a first incomplete task and no task is currently open, open it
            if (firstIncompleteTask && !openTask) dispatch((0, $4AM50.nextOpenTask)(firstIncompleteTask));
        }
    };

});
parcelRegister("6P4lT", function(module, exports) {

$parcel$export(module.exports, "getAllTasks", () => $888e4567977ab846$export$d1f442602a91e7cc);

var $epTsa = parcelRequire("epTsa");

var $igNUx = parcelRequire("igNUx");

var $7jTnu = parcelRequire("7jTnu");


var $a9ldn = parcelRequire("a9ldn");

var $LFsl3 = parcelRequire("LFsl3");

var $gYnSx = parcelRequire("gYnSx");

var $9ycBx = parcelRequire("9ycBx");

var $dt54n = parcelRequire("dt54n");

var $1KmSm = parcelRequire("1KmSm");

var $koyuo = parcelRequire("koyuo");

var $7y7co = parcelRequire("7y7co");

var $8rJAF = parcelRequire("8rJAF");

var $cYgSg = parcelRequire("cYgSg");

var $emLqf = parcelRequire("emLqf");

var $c4gw9 = parcelRequire("c4gw9");

var $eUvg6 = parcelRequire("eUvg6");

var $feWch = parcelRequire("feWch");

var $7A9H8 = parcelRequire("7A9H8");
const $888e4567977ab846$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    const [expConfig] = (0, $epTsa.UNSAFE_noExposureExp)('jira_rt_quickstart_m1');
    if (variants.includes((0, $7y7co.JSW).experiment.jswReverseTrial) && !expConfig.get('isEnabled', false)) {
        const { title: title, items: items } = taskList[taskGroupParent === (0, $9ycBx.ROOT_TASK) ? (0, $9ycBx.REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, $9ycBx.REVERSE_TRIAL_ROOT_TASK];
        return {
            title: title,
            items: (0, $cYgSg.getTasks)(variants, taskVariants, items)
        };
    }
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $9ycBx.ROOT_TASK];
    return {
        title: title,
        items: (0, $cYgSg.getTasks)(variants, taskVariants, items)
    };
};
const $888e4567977ab846$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup)=>{
    const variants = new Set();
    const isTmpScrumWithSprintPermission = mountedNudges.includes((0, $9ycBx.BACKLOG_CREATE_SPRINT_NUDGE_ID));
    const isEligibleForKanbanTour = mountedNudges.includes((0, $2b839a8453de5367$export$3366ddefe77d5112));
    if ((0, $igNUx.isFedRamp)()) variants.add((0, $7y7co.JSW).experience.fedRamp);
    if (premiumTrialOnSignup) {
        variants.add((0, $7y7co.JSW).experiment.jswReverseTrial);
        (0, $epTsa.expValEquals)('jira_rt_quickstart_m1', 'isEnabled', true) && variants.add((0, $7y7co.JSW).experiment.rtQuickstartM1);
    }
    if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, $7y7co.JSW).experiment.scrumOnboarding);
    if (isCrossProjectBoardToPlanUpsell) variants.add((0, $7y7co.JSW).trait.crossProjectBoardToPlanUpsell);
    if (canEditPlans) variants.add((0, $7y7co.JSW).permissions.hasPlanEditPermissions);
    if (isEligibleForKanbanTour || routeName !== 'software-boards') variants.add((0, $7y7co.JSW).experience.kanbanOnboarding);
    if (canCreateProject === false) variants.add((0, $7y7co.JSW).permissions.notCanCreateProject);
    if (projectState?.isNextGen) variants.add((0, $7y7co.JSW).projectStyle.teamManaged);
    else variants.add((0, $7y7co.JSW).projectStyle.companyManaged);
    if (projectState?.isProjectAdmin) variants.add((0, $7y7co.JSW).userRole.projectAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN) {
        variants.add((0, $7y7co.JSW).userRole.jiraAdmin);
        variants.add((0, $7y7co.JSW).userRole.admin);
    }
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN) {
        variants.add((0, $7y7co.JSW).userRole.siteAdmin);
        variants.add((0, $7y7co.JSW).userRole.admin);
    }
    if (projectState?.edition === (0, $a9ldn.FREE_EDITION)) variants.add((0, $7y7co.JSW).edition.free);
    else if (projectState?.edition === (0, $a9ldn.STANDARD_EDITION)) variants.add((0, $7y7co.JSW).edition.standard);
    else if (projectState?.edition === (0, $a9ldn.PREMIUM_EDITION)) variants.add((0, $7y7co.JSW).edition.premium);
    if ((0, $dt54n.isRoadmapRoute)(routeName)) variants.add((0, $7y7co.JSW).route.softwareRoadmap);
    else if (routeName === 'software-backlog') variants.add((0, $7y7co.JSW).route.softwareBacklog);
    else if (routeName === 'software-boards') variants.add((0, $7y7co.JSW).route.softwareBoard);
    else if (routeName === 'software-list' || routeName === 'software-list-classic') variants.add((0, $7y7co.JSW).route.softwareList);
    else if (routeName === 'project-settings-software-access') variants.add((0, $7y7co.JSW).route.projectSettingsSoftwareAccess);
    else if (routeName === 'issue') variants.add((0, $7y7co.JSW).route.issue);
    else if ((routeName === 'software-calendar' || routeName === 'software-calendar-classic') && (0, $7jTnu.fg)('software_calendar_quickstart_onboarding')) variants.add((0, $7y7co.JSW).route.softwareCalendar);
    if (isEligibleToUpdateSitename) variants.add((0, $7y7co.JSW).experiment.customizeSiteName);
    return $888e4567977ab846$var$getTaskListItem({
        variants: Array.from(variants.values()),
        taskVariants: (0, $7y7co.JSW).taskVariants,
        taskList: (0, $7y7co.JSW).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$var$createJwmTasks = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5 })=>{
    const variants = [];
    variants.push((0, $8rJAF.JWM).experiments.projectTheming);
    // No longer reference isEligibleForTailoredOnboardingM2P5 before showing TO cards
    // isEligibleForTailoredOnboardingM2P5 has checks for trello/site admin and team type but these are now built into the config (admin check is removed)
    if ((0, $7jTnu.fg)('to-cleanup-release-business-cards-to-nth-users')) return $888e4567977ab846$export$568bd601466cd235({
        taskGroupParent: taskGroupParent,
        teamType: teamType,
        projectState: projectState,
        taskList: taskList
    });
    // TODO: Remove below logic when cleaning up to-cleanup-release-business-cards-to-nth-users
    // Old JWM config cards can also be removed
    // We have confirmation to remove old cards https://hello.atlassian.net/wiki/spaces/~620663553/pages/5628213263/Quickstart+cards+to+check
    if (isEligibleForTailoredOnboardingM2P5) return $888e4567977ab846$export$e21b96de210942({
        taskGroupParent: taskGroupParent,
        teamType: teamType
    });
    if (projectState?.isProjectAdmin) variants.push((0, $8rJAF.JWM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN) variants.push((0, $8rJAF.JWM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN) variants.push((0, $8rJAF.JWM).userRole.siteAdmin);
    if (projectState?.isSampleProject) variants.push((0, $8rJAF.JWM).experiments.isSampleProject);
    else variants.push((0, $8rJAF.JWM).experiments.isNotSampleProject);
    if (projectState?.isTrelloCrossflow) variants.push((0, $8rJAF.JWM).experiments.trelloCrossflow);
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $8rJAF.JWM).taskVariants,
        taskList: taskList ?? (0, $8rJAF.JWM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $koyuo.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $koyuo.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN) variants.push((0, $koyuo.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN) variants.push((0, $koyuo.JSM).userRole.siteAdmin);
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $koyuo.JSM).taskVariants,
        taskList: (0, $koyuo.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$export$d9d83c8e96505820 = (taskGroupParent, teamType, features, isEligibleForTailoredOnboardingScrumAndSoftwareKanban)=>{
    const variants = [];
    if (features?.hasBacklog) variants.push((0, $feWch.Feature).hasBacklog);
    if (features?.hasSprint) variants.push((0, $feWch.Feature).hasSprint);
    if (features?.hasSummaryPage && (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasSummaryPage);
    if (features?.hasRoadmap && (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasRoadmap);
    if (features?.hasList && (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasList);
    if (features?.hasCalendar && (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasCalendar);
    if (features?.hasCode && (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasCode);
    if (features?.hasForms && (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasForms);
    if (features?.hasPages && (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasPages);
    if (!(0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name') && isEligibleForTailoredOnboardingScrumAndSoftwareKanban) variants.push((0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible);
    if ((0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $eUvg6.FeatureGate).removeInitialProjectTemplateName);
    if (teamType && (0, $LFsl3.isTailoredOnboardingTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name') ? (0, $c4gw9.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariants : (0, $c4gw9.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariantsOld,
        taskList: (0, $c4gw9.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$export$e21b96de210942 = ({ taskGroupParent: taskGroupParent, teamType: teamType })=>{
    const variants = [];
    if (teamType && (0, $LFsl3.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $c4gw9.TAILORED_ONBOARDING_M2P5).getM2P5TaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $c4gw9.TAILORED_ONBOARDING_M2P5).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$export$568bd601466cd235 = ({ taskGroupParent: taskGroupParent, teamType: teamType, projectState: projectState, taskList: taskList })=>{
    const variants = [];
    // When cleaning up M2 and consolidating configs, this team type check should just be updated to include MKT & OPS
    if (teamType && (0, $LFsl3.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    if (projectState?.isTrelloCrossflow) variants.push((0, $8rJAF.JWM).experiments.trelloCrossflow);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN) variants.push((0, $8rJAF.JWM).userRole.siteAdmin);
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $7A9H8.TAILORED_ONBOARDING_BUSINESS_CONFIG),
        // This should be cleaned up when M2 is cleaned up. Currently it's like this because M2 populates taskList via the BE
        // and then the FE uses it here, ideally M2 cards are in the business config following conventions so they don't get extra priority bypassing other stuff in the config
        // For now there is also an extra check here to show the trello task list for Trello Crossflow users over M2 https://atlassian.slack.com/archives/C082QR7B16Z/p1755066367960509?thread_ts=1755064885.015779&cid=C082QR7B16Z
        taskList: !projectState?.isTrelloCrossflow && taskList ? taskList : (0, $c4gw9.TAILORED_ONBOARDING_BUSINESS).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$export$d1f442602a91e7cc = ({ projectState: projectState, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5, isEligibleForTailoredOnboardingM3: isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban: isEligibleForTailoredOnboardingScrumAndSoftwareKanban, features: features })=>{
    if ((0, $emLqf.isJwmProject)(projectState)) return $888e4567977ab846$var$createJwmTasks({
        projectState: projectState,
        taskGroupParent: taskGroupParent,
        taskList: taskList,
        teamType: teamType,
        isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5
    });
    if ((0, $emLqf.isJsmProject)(projectState)) return $888e4567977ab846$var$createJsmTasks(projectState, taskGroupParent);
    // We cannot do these in the config itself as we need to fallback to createJswTasks for other users
    // And unlike previous QS experiments, we want to change the entire QS for these users so a new config makes sense over variants to the existing JSW one
    if (!(0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) {
        if (isEligibleForTailoredOnboardingM3 || isEligibleForTailoredOnboardingScrumAndSoftwareKanban) return $888e4567977ab846$export$d9d83c8e96505820(taskGroupParent, teamType, features, isEligibleForTailoredOnboardingScrumAndSoftwareKanban);
    }
    if ((0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) {
        const tailoredOnboardingTasks = $888e4567977ab846$export$d9d83c8e96505820(taskGroupParent, teamType, features);
        // TODO: Remove length check on cleanup of to-cleanup-remove-initial-project-template-name
        // It is just a safety fallback if tailored onboarding tasks are empty but this should never happen
        if (tailoredOnboardingTasks.items.length > 0) return tailoredOnboardingTasks;
        // TODO: Remove this error on cleanup of to-cleanup-remove-initial-project-template-name
        // This should never happen
        (0, $gYnSx.default)({
            error: new Error('tailored onboarding tasks are empty'),
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $9ycBx.PACKAGE_NAME),
                teamName: (0, $9ycBx.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: 'tailored onboarding tasks are empty',
                teamType: teamType,
                hasBacklog: features?.hasBacklog,
                hasSprint: features?.hasSprint,
                hasSummaryPage: features?.hasSummaryPage,
                hasRoadmap: features?.hasRoadmap,
                hasList: features?.hasList,
                hasCalendar: features?.hasCalendar,
                hasCode: features?.hasCode,
                hasForms: features?.hasForms,
                hasPages: features?.hasPages
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $888e4567977ab846$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup);
};

});
parcelRegister("LFsl3", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingTeamType", () => $2b571464d35dbda4$export$b924c0b3ec4d268e);
$parcel$export(module.exports, "isTailoredOnboardingM2P5TailoredTeamType", () => $2b571464d35dbda4$export$26c385918d734203);

var $8IjPx = parcelRequire("8IjPx");
const $2b571464d35dbda4$export$b924c0b3ec4d268e = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8IjPx.tailoredTeamTypes).includes(teamType);
};
const $2b571464d35dbda4$export$26c385918d734203 = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8IjPx.tailoredM2P5TeamTypes).includes(teamType);
};

});
parcelRegister("8IjPx", function(module, exports) {

$parcel$export(module.exports, "tailoredTeamTypes", () => $568d03b0884f9ed5$export$a1fbb7d965e15a39);
$parcel$export(module.exports, "tailoredM2P5TeamTypes", () => $568d03b0884f9ed5$export$52c5394d6e6cfcf3);

const $568d03b0884f9ed5$export$a1fbb7d965e15a39 = [
    (0, $2b839a8453de5367$export$e5c438b7501b5a24),
    (0, $2b839a8453de5367$export$d7de553940261eba),
    (0, $2b839a8453de5367$export$e4824f74b9879164),
    (0, $2b839a8453de5367$export$4f3cb0844009af52),
    (0, $2b839a8453de5367$export$cbc0e551d91a692d),
    (0, $2b839a8453de5367$export$4f54a09a24fd1d74),
    (0, $2b839a8453de5367$export$79685802e8ff1098),
    (0, $2b839a8453de5367$export$b8b1ac856ba1434b)
];
const $568d03b0884f9ed5$export$52c5394d6e6cfcf3 = [
    (0, $2b839a8453de5367$export$e5c438b7501b5a24),
    (0, $2b839a8453de5367$export$d7de553940261eba),
    (0, $2b839a8453de5367$export$cbc0e551d91a692d),
    (0, $2b839a8453de5367$export$4f54a09a24fd1d74),
    (0, $2b839a8453de5367$export$79685802e8ff1098),
    (0, $2b839a8453de5367$export$b8b1ac856ba1434b)
];

});


parcelRegister("dt54n", function(module, exports) {

$parcel$export(module.exports, "isRoadmapRoute", () => $dbcd2c9ba5e49677$export$d1fa67c1ffb68871);
const $dbcd2c9ba5e49677$export$d1fa67c1ffb68871 = (routeName)=>{
    if (routeName === undefined) return false;
    return routeName === 'software-timeline' || routeName === 'software-timeline-classic';
};

});

parcelRegister("1KmSm", function(module, exports) {

$parcel$export(module.exports, "USER_ROLE", () => $2ef1b0f2207fd5ce$export$8eeb199b23203523);
const $2ef1b0f2207fd5ce$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("koyuo", function(module, exports) {

$parcel$export(module.exports, "JSM", () => $2c85504c5ef985eb$export$63f289f2da861d35);

var $dmVCq = parcelRequire("dmVCq");
const $2c85504c5ef985eb$export$63f289f2da861d35 = {
    taskList: (0, $dmVCq.JSM_TASK_LIST),
    taskVariants: (0, $dmVCq.JSM_TASK_VARIANTS),
    userRole: (0, $dmVCq.UserRole),
    experiments: (0, $dmVCq.Experiments)
};

});
parcelRegister("dmVCq", function(module, exports) {

$parcel$export(module.exports, "JSM_TASK_LIST", () => $39979c1b128d3c9a$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $39979c1b128d3c9a$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $39979c1b128d3c9a$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $39979c1b128d3c9a$export$5b68aef408c932d9);

var $9ycBx = parcelRequire("9ycBx");

var $8pEHr = parcelRequire("8pEHr");
const $39979c1b128d3c9a$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: (0, $8pEHr.messages).rootTitle,
        items: [
            (0, $9ycBx.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $9ycBx.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $9ycBx.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $39979c1b128d3c9a$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $39979c1b128d3c9a$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $39979c1b128d3c9a$export$5b68aef408c932d9 = {
    [(0, $9ycBx.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("8pEHr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ffaf571352a2cc1d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $ffaf571352a2cc1d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("7y7co", function(module, exports) {

$parcel$export(module.exports, "JSW", () => $69137b6bfd6791a4$export$4cfe6e52f2e72a54);

var $eUvg6 = parcelRequire("eUvg6");
const $69137b6bfd6791a4$export$4cfe6e52f2e72a54 = {
    taskList: (0, $eUvg6.TASK_LIST),
    taskVariants: (0, $eUvg6.TASK_VARIANTS),
    experiment: (0, $eUvg6.Experiment),
    experience: (0, $eUvg6.Experience),
    projectStyle: (0, $eUvg6.ProjectStyle),
    userRole: (0, $eUvg6.UserRole),
    edition: (0, $eUvg6.Edition),
    route: (0, $eUvg6.Route),
    permissions: (0, $eUvg6.Permissions),
    trait: (0, $eUvg6.Trait)
};

});
parcelRegister("eUvg6", function(module, exports) {

$parcel$export(module.exports, "FeatureGate", () => $b0c17d2eb7065ae3$export$d4ba9a3e7000cca8);
$parcel$export(module.exports, "Experiment", () => $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "Experience", () => $b0c17d2eb7065ae3$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "ProjectStyle", () => $b0c17d2eb7065ae3$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "UserRole", () => $b0c17d2eb7065ae3$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "Edition", () => $b0c17d2eb7065ae3$export$6f4a0f769e61929);
$parcel$export(module.exports, "Route", () => $b0c17d2eb7065ae3$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Permissions", () => $b0c17d2eb7065ae3$export$2d41982586bbb6be);
$parcel$export(module.exports, "Trait", () => $b0c17d2eb7065ae3$export$2d08cfa40d69142e);
$parcel$export(module.exports, "TASK_LIST", () => $b0c17d2eb7065ae3$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $b0c17d2eb7065ae3$export$36f4d47dfe11b613);

var $9ycBx = parcelRequire("9ycBx");

var $4J9Xs = parcelRequire("4J9Xs");
const $b0c17d2eb7065ae3$export$d4ba9a3e7000cca8 = {
    removeInitialProjectTemplateName: 'to-cleanup-remove-initial-project-template-name'
};
const $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    customizeSiteName: 'experiment.customizeSiteName',
    jswReverseTrial: 'experiment.jswReverseTrial',
    rtQuickstartM1: 'experiment.rtQuickstartM1',
    tailoredOnboardingScrumAndSoftwareKanbanEligible: 'experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible'
};
const $b0c17d2eb7065ae3$export$c90b54e658fc4d7c = {
    kanbanOnboarding: 'experience.kanbanOnboarding',
    fedRamp: 'experience.fedRamp'
};
const $b0c17d2eb7065ae3$export$1f66f9f05afa05a8 = {
    teamManaged: 'projectStyle.teamManaged',
    companyManaged: 'projectStyle.companyManaged'
};
const $b0c17d2eb7065ae3$export$eb3485a690c2f0b8 = {
    siteAdmin: 'userRole.siteAdmin',
    jiraAdmin: 'userRole.jiraAdmin',
    admin: 'userRole.admin',
    projectAdmin: 'userRole.projectAdmin'
};
const $b0c17d2eb7065ae3$export$6f4a0f769e61929 = {
    free: 'productEdition.free',
    standard: 'productEdition.standard',
    premium: 'productEdition.premium'
};
const $b0c17d2eb7065ae3$export$e7b0ac011bb776c6 = {
    softwareRoadmap: 'route.softwareRoadmap',
    softwareBacklog: 'route.softwareBacklog',
    softwareBoard: 'route.softwareBoard',
    softwareList: 'route.softwareList',
    projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
    issue: 'route.issue',
    softwareCalendar: 'route.softwareCalendar'
};
const $b0c17d2eb7065ae3$export$2d41982586bbb6be = {
    notCanCreateProject: 'permissions.notCanCreateProject',
    hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
};
const $b0c17d2eb7065ae3$export$2d08cfa40d69142e = {
    crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
};
const $b0c17d2eb7065ae3$var$DEFAULT_TASK_LIST = [
    (0, $9ycBx.ADD_COLUMNS_TASK),
    (0, $9ycBx.CREATE_PROJECT_TASK),
    (0, $9ycBx.CREATE_ISSUE_TASK),
    (0, $9ycBx.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $9ycBx.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $9ycBx.INVITE_TEAMMATES_TASK),
    (0, $9ycBx.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $9ycBx.CAPTURE_INTEGRATIONS_TASK),
    (0, $9ycBx.FIND_HELP_TASK),
    (0, $9ycBx.SET_UP_BOARD_TASK),
    (0, $9ycBx.GET_MOBILE_APP_TASK),
    (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $9ycBx.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $9ycBx.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $9ycBx.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $9ycBx.MONITOR_MANAGE_RISK_TASK),
    (0, $9ycBx.SCRUM_ONBOARDING_TASK),
    (0, $9ycBx.CUSTOMIZE_SITE_NAME_TASK),
    (0, $9ycBx.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $9ycBx.GET_STARTED_LIST_TASK),
    (0, $9ycBx.CALENDAR_VIEW_TASK)
];
const $b0c17d2eb7065ae3$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $4J9Xs.messages).rootTitle,
        items: $b0c17d2eb7065ae3$var$DEFAULT_TASK_LIST
    },
    reverseTrialRoot: {
        title: (0, $4J9Xs.messages).reverseTrialRootTitle,
        items: $b0c17d2eb7065ae3$var$DEFAULT_TASK_LIST
    },
    [(0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)]: {
        title: (0, $4J9Xs.messages).reverseTrialCardTitle,
        items: [
            (0, $9ycBx.ADVANCED_ROADMAPS_TASK),
            (0, $9ycBx.CHANGE_CONTROL_TASK),
            (0, $9ycBx.AUTOMATIONS_TASK),
            (0, $9ycBx.SITE_ADMINISTRATIONS_TASK),
            (0, $9ycBx.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        title: (0, $4J9Xs.messages).premiumPlanTitle,
        items: [
            (0, $9ycBx.ADVANCED_ROADMAPS_TASK),
            (0, $9ycBx.CHANGE_CONTROL_TASK),
            (0, $9ycBx.AUTOMATIONS_TASK),
            (0, $9ycBx.SITE_ADMINISTRATIONS_TASK),
            (0, $9ycBx.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        title: (0, $4J9Xs.messages).premiumPlanTitle,
        items: [
            (0, $9ycBx.ADVANCED_ROADMAPS_TASK),
            (0, $9ycBx.AUTOMATIONS_TASK)
        ]
    },
    [(0, $9ycBx.STANDARD_EDITION_OVERVIEW_TASK)]: {
        title: (0, $4J9Xs.messages).standardPlanTitle,
        items: [
            (0, $9ycBx.AUTOMATIONS_TASK),
            (0, $9ycBx.USER_MANAGEMENT_TASK),
            (0, $9ycBx.SITE_ADMINISTRATIONS_TASK)
        ]
    }
});
const $b0c17d2eb7065ae3$var$PLAN_ONBOARDING_TASKS = {
    [(0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.rtQuickstartM1,
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    // This condition needs to be the opposite condition to PREMIUM_EDITION_OVERVIEW_TASK
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $b0c17d2eb7065ae3$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.STANDARD_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.standard,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.ADVANCED_ROADMAPS_TASK)]: {
        position: {
            default: 105
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $b0c17d2eb7065ae3$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.AUTOMATIONS_TASK)]: {
        position: {
            default: 110
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $b0c17d2eb7065ae3$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.standard,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.USER_MANAGEMENT_TASK)]: {
        position: {
            default: 115
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.standard,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.CHANGE_CONTROL_TASK)]: {
        position: {
            default: 120
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.SITE_ADMINISTRATIONS_TASK)]: {
        position: {
            default: 125
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.standard,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $b0c17d2eb7065ae3$export$36f4d47dfe11b613 = {
    ...$b0c17d2eb7065ae3$var$PLAN_ONBOARDING_TASKS,
    [(0, $9ycBx.CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.CUSTOMIZE_SITE_NAME_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin,
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.customizeSiteName
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.CALENDAR_VIEW_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    value: true,
                    condition: [
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareCalendar
                    ]
                }
            ]
        }
    },
    [(0, $9ycBx.SCRUM_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin,
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.scrumOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBacklog
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.MONITOR_MANAGE_RISK_TASK)]: {
        position: {
            default: 152
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.SET_UP_BOARD_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.projectAdmin,
                        $b0c17d2eb7065ae3$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.CREATE_ISSUE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.CREATE_ISSUE_TASK_SIMPLIFIED)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.ADD_COLUMNS_TASK)]: {
        position: {
            default: 310
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 320
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.projectAdmin,
                        $b0c17d2eb7065ae3$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin,
                        $b0c17d2eb7065ae3$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.INVITE_TEAMMATES_VIDEO_TASK)]: {
        position: {
            default: 400,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.projectAdmin,
                        $b0c17d2eb7065ae3$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin,
                        $b0c17d2eb7065ae3$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.GET_MOBILE_APP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.FIND_HELP_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    }
};

});
parcelRegister("4J9Xs", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3416e8428d224ccf$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3416e8428d224ccf$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
        "defaultMessage": "Quickstart"
    },
    premiumPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
        "defaultMessage": "Included in your Premium plan"
    },
    standardPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
        "defaultMessage": "Your Standard plan"
    },
    reverseTrialRootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    reverseTrialCardTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
        "defaultMessage": "Included in your Premium trial"
    }
});

});



parcelRegister("8rJAF", function(module, exports) {

$parcel$export(module.exports, "JWM", () => $77b9f961c5c24ac0$export$3ff26c80cb588e12);

var $4PmHv = parcelRequire("4PmHv");

var $7BHaP = parcelRequire("7BHaP");

var $5ImmZ = parcelRequire("5ImmZ");
const $77b9f961c5c24ac0$export$3ff26c80cb588e12 = {
    taskList: (0, $4PmHv.TASK_LIST),
    taskVariants: (0, $4PmHv.TASK_VARIANTS),
    userRole: (0, $5ImmZ.UserRole),
    experiments: (0, $7BHaP.Experiments)
};

});
parcelRegister("4PmHv", function(module, exports) {

$parcel$export(module.exports, "TASK_LIST", () => $a08aca66351aa30d$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "OPS_TAILORED_ONBOARDING_TASK_VARIANTS", () => $a08aca66351aa30d$export$db06b8e338ba9c65);
$parcel$export(module.exports, "MKT_TAILORED_ONBOARDING_TASK_VARIANTS", () => $a08aca66351aa30d$export$bda7075f98246874);
$parcel$export(module.exports, "TASK_VARIANTS", () => $a08aca66351aa30d$export$36f4d47dfe11b613);

var $9ycBx = parcelRequire("9ycBx");

var $7BHaP = parcelRequire("7BHaP");

var $dj1vQ = parcelRequire("dj1vQ");

var $5ImmZ = parcelRequire("5ImmZ");
const $a08aca66351aa30d$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $dj1vQ.messages).rootTitle,
        items: [
            (0, $9ycBx.JWM_CREATE_PROJECT_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $9ycBx.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $9ycBx.JWM_CREATE_SAMPLE_PROJECT_TASK),
            (0, $9ycBx.JWM_PROJECT_SUMMARY_TASK),
            (0, $9ycBx.GET_STARTED_LIST_TASK),
            (0, $9ycBx.JWM_CALENDAR_TASK),
            (0, $9ycBx.JWM_TIMELINE_TASK),
            (0, $9ycBx.JWM_BUILD_FORM_TASK),
            (0, $9ycBx.JWM_BACKGROUND_COLOR_TASK),
            (0, $9ycBx.JWM_FEEDBACK_TASK),
            (0, $9ycBx.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
            (0, $9ycBx.JWM_SHARE_PROJECT_TASK),
            (0, $9ycBx.JWM_CREATE_YOUR_OWN_PROJECT_TASK)
        ]
    }
});
const $a08aca66351aa30d$export$db06b8e338ba9c65 = {
    [(0, $9ycBx.OPS_JTBD_3_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $9ycBx.OPS_JTBD_3_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $9ycBx.OPS_JTBD_3_PAGES)]: {
        position: {
            default: 300
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_LIST)]: {
        position: {
            default: 400
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_CALENDAR)]: {
        position: {
            default: 500
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_TIMELINE)]: {
        position: {
            default: 600
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_SUMMARY)]: {
        position: {
            default: 700
        }
    },
    [(0, $9ycBx.OPS_JTBD_5_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $9ycBx.OPS_JTBD_5_TIMELINE)]: {
        position: {
            default: 900
        }
    },
    [(0, $9ycBx.OPS_JTBD_5_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $9ycBx.OPS_JTBD_7_LIST)]: {
        position: {
            default: 1100
        }
    },
    [(0, $9ycBx.OPS_JTBD_7_CALENDAR)]: {
        position: {
            default: 1200
        }
    },
    [(0, $9ycBx.OPS_JTBD_2_BOARD)]: {
        position: {
            default: 1300
        }
    },
    [(0, $9ycBx.OPS_JTBD_2_FORMS)]: {
        position: {
            default: 1400
        }
    },
    [(0, $9ycBx.OPS_JTBD_2_SUMMARY)]: {
        position: {
            default: 1500
        }
    },
    [(0, $9ycBx.OPS_JTBD_1_LIST)]: {
        position: {
            default: 1600
        }
    },
    [(0, $9ycBx.OPS_JTBD_6_PAGES)]: {
        position: {
            default: 1700
        }
    },
    [(0, $9ycBx.OPS_JTBD_0_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $9ycBx.OPS_JTBD_0_TIMELINE)]: {
        position: {
            default: 1900
        }
    },
    [(0, $9ycBx.OPS_JTBD_0_PAGES)]: {
        position: {
            default: 2000
        }
    },
    [(0, $9ycBx.OPS_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 2100
        }
    },
    [(0, $9ycBx.OPS_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 2200
        }
    },
    [(0, $9ycBx.OPS_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2300
        }
    }
};
const $a08aca66351aa30d$export$bda7075f98246874 = {
    [(0, $9ycBx.MKT_JTBD_1_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $9ycBx.MKT_JTBD_1_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $9ycBx.MKT_JTBD_1_TIMELINE)]: {
        position: {
            default: 300
        }
    },
    [(0, $9ycBx.MKT_JTBD_2_CALENDAR)]: {
        position: {
            default: 400
        }
    },
    [(0, $9ycBx.MKT_JTBD_2_PAGES)]: {
        position: {
            default: 500
        }
    },
    [(0, $9ycBx.MKT_JTBD_3_PAGES)]: {
        position: {
            default: 600
        }
    },
    [(0, $9ycBx.MKT_JTBD_3_TIMELINE)]: {
        position: {
            default: 700
        }
    },
    [(0, $9ycBx.MKT_JTBD_4_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $9ycBx.MKT_JTBD_4_SUMMARY)]: {
        position: {
            default: 900
        }
    },
    [(0, $9ycBx.MKT_JTBD_4_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $9ycBx.MKT_JTBD_5_TIMELINE)]: {
        position: {
            default: 1100
        }
    },
    [(0, $9ycBx.MKT_JTBD_5_SUMMARY)]: {
        position: {
            default: 1200
        }
    },
    [(0, $9ycBx.MKT_JTBD_6_FORMS)]: {
        position: {
            default: 1300
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_LIST)]: {
        position: {
            default: 1400
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_CALENDAR)]: {
        position: {
            default: 1500
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_TIMELINE)]: {
        position: {
            default: 1600
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_SUMMARY)]: {
        position: {
            default: 1700
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 1900
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_PROJECT)]: {
        position: {
            default: 2000
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2100
        }
    }
};
const $a08aca66351aa30d$export$36f4d47dfe11b613 = {
    ...$a08aca66351aa30d$export$db06b8e338ba9c65,
    ...$a08aca66351aa30d$export$bda7075f98246874,
    [(0, $9ycBx.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_PROJECT_SUMMARY_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_CALENDAR_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TIMELINE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_BACKGROUND_COLOR_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).projectTheming,
                        (0, $5ImmZ.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).projectTheming,
                        (0, $5ImmZ.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).projectTheming,
                        (0, $5ImmZ.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_SHARE_PROJECT_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow,
                        (0, $5ImmZ.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_FEEDBACK_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject,
                        (0, $5ImmZ.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject,
                        (0, $5ImmZ.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject,
                        (0, $5ImmZ.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("7BHaP", function(module, exports) {

$parcel$export(module.exports, "Experiments", () => $57326be2952b3617$export$c8d6ffd15214553a);
const $57326be2952b3617$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow'
};

});

parcelRegister("dj1vQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6ba3f21c8d7d2fe3$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $6ba3f21c8d7d2fe3$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("5ImmZ", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $0235b2ed52c10505$export$eb3485a690c2f0b8);
const $0235b2ed52c10505$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("cYgSg", function(module, exports) {

$parcel$export(module.exports, "getTasks", () => $298a0d20f3b1d08a$export$20b82b4a32771893);

var $iyRnt = parcelRequire("iyRnt");
const $298a0d20f3b1d08a$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $iyRnt.getConditional)(visibility, variants) : true;
const $298a0d20f3b1d08a$var$getTaskPosition = (variants, position)=>(0, $iyRnt.getConditional)(position, variants);
const $298a0d20f3b1d08a$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$298a0d20f3b1d08a$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$298a0d20f3b1d08a$var$getTaskPosition(variants, taskVariants[taskA].position) - $298a0d20f3b1d08a$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("iyRnt", function(module, exports) {

$parcel$export(module.exports, "getConditional", () => $80dfc494f4751e25$export$fe3161cde0106bba);
const $80dfc494f4751e25$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("emLqf", function(module, exports) {

$parcel$export(module.exports, "isJwmProject", () => $99044a2d2d5f79ec$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $99044a2d2d5f79ec$export$a972ed853ed1d469);

var $ln6Iy = parcelRequire("ln6Iy");
const $99044a2d2d5f79ec$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $ln6Iy.CORE_PROJECT);
const $99044a2d2d5f79ec$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT);

});

parcelRegister("c4gw9", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_WITH_SINGLE_CONFIG", () => $9c945d174f9c912a$export$83849aa73c0a20db);
$parcel$export(module.exports, "TAILORED_ONBOARDING_M2P5", () => $9c945d174f9c912a$export$eb17ad7838835d2a);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BUSINESS", () => $9c945d174f9c912a$export$fe6b8880a507b306);


var $9ycBx = parcelRequire("9ycBx");

var $iKhBT = parcelRequire("iKhBT");

var $8sWUb = parcelRequire("8sWUb");

var $5shRe = parcelRequire("5shRe");

var $a1b8c = parcelRequire("a1b8c");

var $mLM2w = parcelRequire("mLM2w");

var $i5ttL = parcelRequire("i5ttL");

var $e8Fhw = parcelRequire("e8Fhw");

var $fHbA0 = parcelRequire("fHbA0");

var $ifDp7 = parcelRequire("ifDp7");

var $7OyjZ = parcelRequire("7OyjZ");
const $9c945d174f9c912a$export$2757f7b23d120b9b = Object.freeze({
    root: {
        title: (0, $iKhBT.messages).rootTitle,
        items: [
            (0, $9ycBx.TAILORED_ONBOARDING_SUMMARY),
            (0, $9ycBx.TAILORED_ONBOARDING_CALENDAR),
            (0, $9ycBx.TAILORED_ONBOARDING_LIST),
            (0, $9ycBx.TAILORED_ONBOARDING_TIMELINE),
            (0, $9ycBx.TAILORED_ONBOARDING_PAGES),
            (0, $9ycBx.TAILORED_ONBOARDING_FORM),
            (0, $9ycBx.TAILORED_ONBOARDING_INVITE),
            (0, $9ycBx.TAILORED_ONBOARDING_BOARD),
            (0, $9ycBx.TAILORED_ONBOARDING_BACKLOG),
            (0, $9ycBx.TAILORED_ONBOARDING_CODE)
        ]
    }
});
const $9c945d174f9c912a$export$83849aa73c0a20db = {
    taskList: $9c945d174f9c912a$export$2757f7b23d120b9b,
    taskVariants: (0, $ifDp7.TAILORED_ONBOARDING_SINGLE_CONFIG),
    // todo: remove this on `to-cleanup-remove-initial-project-template-name` cleanup
    taskVariantsOld: (0, $7OyjZ.TAILORED_ONBOARDING_SINGLE_CONFIG)
};
const $9c945d174f9c912a$export$fd94bb9b6d992528 = Object.freeze({
    root: {
        title: (0, $iKhBT.messages).rootTitle,
        items: [
            (0, $9ycBx.TAILORED_ONBOARDING_SUMMARY),
            (0, $9ycBx.TAILORED_ONBOARDING_CALENDAR),
            (0, $9ycBx.TAILORED_ONBOARDING_LIST),
            (0, $9ycBx.TAILORED_ONBOARDING_TIMELINE),
            (0, $9ycBx.TAILORED_ONBOARDING_PAGES),
            (0, $9ycBx.TAILORED_ONBOARDING_FORM),
            (0, $9ycBx.TAILORED_ONBOARDING_INVITE),
            (0, $9ycBx.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $9c945d174f9c912a$export$3c409334669aec75 = (teamType)=>{
    switch(teamType){
        case 0, $2b839a8453de5367$export$4f54a09a24fd1d74:
            return 0, $5shRe.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $2b839a8453de5367$export$79685802e8ff1098:
            return 0, $8sWUb.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $2b839a8453de5367$export$e5c438b7501b5a24:
            return 0, $a1b8c.DESIGN_VARIANTS;
        case 0, $2b839a8453de5367$export$d7de553940261eba:
            return 0, $mLM2w.IT_SUPPORT_VARIANTS;
        case 0, $2b839a8453de5367$export$cbc0e551d91a692d:
            return 0, $i5ttL.OTHER_PERSONAL_VARIANTS;
        case 0, $2b839a8453de5367$export$b8b1ac856ba1434b:
            return 0, $fHbA0.SOFTWARE_VARIANTS;
        default:
            return 0, $e8Fhw.EVERYTHING_ELSE_VARIANTS;
    }
};
const $9c945d174f9c912a$export$cb2285c4be67df48 = Object.freeze({
    root: {
        title: (0, $iKhBT.messages).rootTitle,
        items: [
            // JWM Trello Crossflow Tasks
            (0, $9ycBx.JWM_CREATE_PROJECT_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $9ycBx.JWM_BUILD_FORM_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $9ycBx.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            // JSW Tailored Onboarding Tasks
            (0, $9ycBx.TAILORED_ONBOARDING_SUMMARY),
            (0, $9ycBx.TAILORED_ONBOARDING_LIST),
            (0, $9ycBx.TAILORED_ONBOARDING_TIMELINE),
            (0, $9ycBx.TAILORED_ONBOARDING_BOARD),
            (0, $9ycBx.TAILORED_ONBOARDING_CALENDAR),
            (0, $9ycBx.TAILORED_ONBOARDING_PAGES),
            (0, $9ycBx.TAILORED_ONBOARDING_FORM),
            (0, $9ycBx.TAILORED_ONBOARDING_INVITE)
        ]
    }
});
const $9c945d174f9c912a$export$eb17ad7838835d2a = {
    taskList: $9c945d174f9c912a$export$fd94bb9b6d992528,
    getM2P5TaskVariants: $9c945d174f9c912a$export$3c409334669aec75
};
const $9c945d174f9c912a$export$fe6b8880a507b306 = {
    taskList: $9c945d174f9c912a$export$cb2285c4be67df48
};

});
parcelRegister("iKhBT", function(module, exports) {

$parcel$export(module.exports, "messages", () => $47efb1049993f4e6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $47efb1049993f4e6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.tailored-onboarding.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("8sWUb", function(module, exports) {

$parcel$export(module.exports, "PROJECT_MANAGEMENT_VARIANTS", () => $d1467d7397e68eff$export$bdd338c80f8962df);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $d1467d7397e68eff$export$bdd338c80f8962df = {
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("feWch", function(module, exports) {

$parcel$export(module.exports, "TeamType", () => $404e322e3706479c$export$26bc40b960693765);
$parcel$export(module.exports, "Feature", () => $404e322e3706479c$export$6e91cf7616333d5);

const $404e322e3706479c$export$26bc40b960693765 = {
    productManagement: `teamType.${(0, $2b839a8453de5367$export$4f54a09a24fd1d74)}`,
    projectManagement: `teamType.${(0, $2b839a8453de5367$export$79685802e8ff1098)}`,
    design: `teamType.${(0, $2b839a8453de5367$export$e5c438b7501b5a24)}`,
    itSupport: `teamType.${(0, $2b839a8453de5367$export$d7de553940261eba)}`,
    otherPersonal: `teamType.${(0, $2b839a8453de5367$export$cbc0e551d91a692d)}`,
    marketing: `teamType.${(0, $2b839a8453de5367$export$e4824f74b9879164)}`,
    operations: `teamType.${(0, $2b839a8453de5367$export$4f3cb0844009af52)}`,
    software: `teamType.${(0, $2b839a8453de5367$export$b8b1ac856ba1434b)}`,
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'teamType.everythingElse'
};
const $404e322e3706479c$export$6e91cf7616333d5 = {
    hasBacklog: 'feature.hasBacklog',
    hasSprint: 'feature.hasSprint',
    hasSummaryPage: 'feature.hasSummaryPage',
    hasRoadmap: 'feature.hasRoadmap',
    hasList: 'feature.hasList',
    hasCalendar: 'feature.hasCalendar',
    hasCode: 'feature.hasCode',
    hasForms: 'feature.hasForms',
    hasPages: 'feature.hasPages'
};

});


parcelRegister("5shRe", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_MANAGEMENT_VARIANTS", () => $443b90c91e3360e2$export$b07ea6a2d29f9c08);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $443b90c91e3360e2$export$b07ea6a2d29f9c08 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("a1b8c", function(module, exports) {

$parcel$export(module.exports, "DESIGN_VARIANTS", () => $4acbe4cfde2344f9$export$a3c4cd8e420f13a);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $4acbe4cfde2344f9$export$a3c4cd8e420f13a = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("mLM2w", function(module, exports) {

$parcel$export(module.exports, "IT_SUPPORT_VARIANTS", () => $cf156d50ed1f640d$export$a25e809b52945082);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $cf156d50ed1f640d$export$a25e809b52945082 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("i5ttL", function(module, exports) {

$parcel$export(module.exports, "OTHER_PERSONAL_VARIANTS", () => $120d7baa5e5f9d4d$export$916be3c140ae8c0);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $120d7baa5e5f9d4d$export$916be3c140ae8c0 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("e8Fhw", function(module, exports) {

$parcel$export(module.exports, "EVERYTHING_ELSE_VARIANTS", () => $7c6363b0cc97119f$export$7a0daeb069f34de3);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $7c6363b0cc97119f$export$7a0daeb069f34de3 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("fHbA0", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_VARIANTS", () => $9fc06aa003a906e0$export$76a143792cc73994);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $9fc06aa003a906e0$export$76a143792cc73994 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("ifDp7", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $e8b95d7a0e5bd991$export$64855550cee11b78);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $e8b95d7a0e5bd991$export$64855550cee11b78 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasList
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasCode
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("7OyjZ", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $a2f5344c5d0d5ba3$export$64855550cee11b78);

var $9ycBx = parcelRequire("9ycBx");

var $eUvg6 = parcelRequire("eUvg6");

var $feWch = parcelRequire("feWch");
const $a2f5344c5d0d5ba3$export$64855550cee11b78 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});


parcelRegister("7A9H8", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_BUSINESS_CONFIG", () => $e3c54a7acd454a57$export$474323a35aa36586);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");

var $7BHaP = parcelRequire("7BHaP");

var $5ImmZ = parcelRequire("5ImmZ");

var $4PmHv = parcelRequire("4PmHv");
const $e3c54a7acd454a57$export$474323a35aa36586 = {
    ...(0, $4PmHv.OPS_TAILORED_ONBOARDING_TASK_VARIANTS),
    ...(0, $4PmHv.MKT_TAILORED_ONBOARDING_TASK_VARIANTS),
    // Trello Crossflow Cards - These take priority when trelloCrossflow experiment is active
    [(0, $9ycBx.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 10
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow,
                        (0, $5ImmZ.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    // Regular Tailored Onboarding Cards - These are hidden when trelloCrossflow is active
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});



parcelRegister("STfOf", function(module, exports) {

$parcel$export(module.exports, "syncVisibilityWithLocal", () => $f389d77cde532ebe$export$4aab9a98fc53b894);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");
const $f389d77cde532ebe$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const visibilityLocal = (0, $uMSsJ.getLocalStorageItem)(`${quickstartType}.visibility`);
        if (visibilityLocal === state.visibility[quickstartType]) return;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: visibilityLocal
            }
        });
    };

});

parcelRegister("6wCHd", function(module, exports) {

$parcel$export(module.exports, "universalDispatch", () => $2ed3eacefc81a47a$export$efe980271ca9cc08);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2ed3eacefc81a47a$export$efe980271ca9cc08 = ({ fn: fn })=>({ dispatch: dispatch })=>{
        dispatch(fn());
    };

});


parcelRegister("6R6zv", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $59fafcb385977eac$export$d4c72bab9d6cc13a);

var $9ycBx = parcelRequire("9ycBx");
const $59fafcb385977eac$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $9ycBx.ROOT_TASK),
    currentTriggerForTaskGroupParent: '',
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isEligibleToUpdateSitename: false,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $9ycBx.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $9ycBx.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED
    }
};

});


const $44259bc988b99eaa$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $44259bc988b99eaa$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $44259bc988b99eaa$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $44259bc988b99eaa$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $44259bc988b99eaa$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $44259bc988b99eaa$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $44259bc988b99eaa$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $44259bc988b99eaa$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $44259bc988b99eaa$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $44259bc988b99eaa$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $44259bc988b99eaa$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $44259bc988b99eaa$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $44259bc988b99eaa$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $44259bc988b99eaa$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $44259bc988b99eaa$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $44259bc988b99eaa$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $44259bc988b99eaa$export$f8bf435a6066832c = 'button clicked';
const $44259bc988b99eaa$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $44259bc988b99eaa$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $44259bc988b99eaa$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $44259bc988b99eaa$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $44259bc988b99eaa$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $44259bc988b99eaa$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $44259bc988b99eaa$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $44259bc988b99eaa$export$5908fa8acd2c0739 = 'filterListNudge';
const $44259bc988b99eaa$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $44259bc988b99eaa$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $44259bc988b99eaa$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $44259bc988b99eaa$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $44259bc988b99eaa$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $44259bc988b99eaa$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $44259bc988b99eaa$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $44259bc988b99eaa$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $44259bc988b99eaa$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $44259bc988b99eaa$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $44259bc988b99eaa$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $44259bc988b99eaa$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $44259bc988b99eaa$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $44259bc988b99eaa$export$a1be34032ee24f78 = 'shareProjectNudge';
const $44259bc988b99eaa$export$29fe6611cc093756 = 'summaryTabNudge';
const $44259bc988b99eaa$export$f107c06c0830f09d = 'reportsTabNudge';
const $44259bc988b99eaa$export$9749a972a54ad7ba = 'boardContainerNudge';
const $44259bc988b99eaa$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $44259bc988b99eaa$export$b7fd448c62b5fb97 = 'listview';
const $44259bc988b99eaa$export$10c63dc5c09466d2 = 'boardview';
const $44259bc988b99eaa$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $44259bc988b99eaa$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $44259bc988b99eaa$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $44259bc988b99eaa$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $44259bc988b99eaa$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $44259bc988b99eaa$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $44259bc988b99eaa$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $44259bc988b99eaa$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $44259bc988b99eaa$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $44259bc988b99eaa$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $44259bc988b99eaa$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';
const $44259bc988b99eaa$export$63a886637b84800 = 'sampleProjectNavTourNudge';
const $44259bc988b99eaa$export$bb40993d16db4a4b = 'SampleProjectNavNudge';
const $44259bc988b99eaa$export$8c300ac9d8c53332 = 'SampleProjectNavNudgeErrorBoundary';

parcelRegister("45qbN", function(module, exports) {

$parcel$export(module.exports, "inviteTeamNudgeEntryPoint", () => $59baba99bbabf31e$export$ff76bc343b4103b1);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $59baba99bbabf31e$export$ff76bc343b4103b1 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("9a9W8")), {
        moduleId: "4ca4d8af",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9a9W8", function(module, exports) {

let $6abcc16d6e2a07b7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6abcc16d6e2a07b7$var$load("fZBNv").then(()=>parcelRequire('FRRBu'));

});



parcelRegister("8x4C2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ddbbaeea9c744c6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5ddbbaeea9c744c6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    teams: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.teams.teams",
        "defaultMessage": "Teams"
    },
    invitePeople: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.teams.invite-people",
        "defaultMessage": "Invite people"
    },
    createTeam: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.teams.create-team",
        "defaultMessage": "Create a team"
    },
    createOrInvite: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.teams.create-or-invite",
        "defaultMessage": "Create or invite"
    }
});

});



const $31028703e58eb566$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4GlobalAppShortcuts';
const $31028703e58eb566$export$d57b6b390e78d90f = 'jira-cosmos';


parcelRegister("mIeXW", function(module, exports) {

$parcel$export(module.exports, "ConfigurableMenuItem", () => $16fb26002390f463$export$5de02966decf8405);

var $7X4e3 = parcelRequire("7X4e3");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $8IuE5 = parcelRequire("8IuE5");

var $41vqi = parcelRequire("41vqi");

var $2wp9U = parcelRequire("2wp9U");

var $4P1EM = parcelRequire("4P1EM");

var $hcSA5 = parcelRequire("hcSA5");

var $7u7ku = parcelRequire("7u7ku");

var $gk3Hc = parcelRequire("gk3Hc");

var $5n5Xi = parcelRequire("5n5Xi");

var $49MXG = parcelRequire("49MXG");

var $9VG2G = parcelRequire("9VG2G");

var $eJYI8 = parcelRequire("eJYI8");

var $iPxs6 = parcelRequire("iPxs6");

var $2geah = parcelRequire("2geah");

var $cRvJm = parcelRequire("cRvJm");

var $cRLIL = parcelRequire("cRLIL");

var $iFx8E = parcelRequire("iFx8E");

var $g0Ue2 = parcelRequire("g0Ue2");

var $i8N06 = parcelRequire("i8N06");

var $bJscI = parcelRequire("bJscI");

var $a62R3 = parcelRequire("a62R3");

var $753q2 = parcelRequire("753q2");
const $16fb26002390f463$export$5de02966decf8405 = (0, $bJscI.componentWithFG)('jfp-magma-stability-check-nav4-batch-1', /*#__PURE__*/ (0, $eJOHy.memo)($16fb26002390f463$var$ConfigurableMenuItemInner), $16fb26002390f463$var$ConfigurableMenuItemInner);
function $16fb26002390f463$var$ConfigurableMenuItemInner({ isDefaultOpen: isDefaultOpen = false, menuData: menuData, menuId: menuId }) {
    const data = (0, $j4oe4.useFragment)((0, $7X4e3.default), menuData);
    const shouldRenderOverviews = (0, $eJYI8.useShouldRenderOverviews)();
    const USER_NAVIGATION_ITEM_LINKS = (0, $41vqi.getUserNavigationItemLinks)();
    switch(menuId){
        case (0, $8IuE5.L1_MENU_ID).APPS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wp9U.Nav4Apps), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $8IuE5.L1_MENU_ID).ASSETS:
            /* remove this case on
       * assets_as_an_app_v2 cleanup &&
       */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4P1EM.Nav4Assets), {
                isExpanded: isDefaultOpen
            });
        case (0, $8IuE5.L1_MENU_ID).DASHBOARDS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gk3Hc.Nav4Dashboards), {
                isExpanded: isDefaultOpen
            });
        case (0, $8IuE5.L1_MENU_ID).FILTERS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5n5Xi.Nav4Filters), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $8IuE5.L1_MENU_ID).GOALS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $753q2.Stub), {
                menuId: (0, $8IuE5.L1_MENU_ID).GOALS,
                href: USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GOALS]
            });
        case (0, $8IuE5.L1_MENU_ID).OPERATIONS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $49MXG.Nav4Operations), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $8IuE5.L1_MENU_ID).COMMUNICATION:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9VG2G.Nav4Communications), {
                isExpanded: isDefaultOpen
            });
        case (0, $8IuE5.L1_MENU_ID).PLANS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2geah.Nav4Plans), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $8IuE5.L1_MENU_ID).OVERVIEWS:
            return shouldRenderOverviews && (0, $7jTnu.fg)('blu-2858-sidebar-menu-overviews') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iPxs6.Nav4Overviews), {
                isExpanded: isDefaultOpen,
                queryRef: data
            }) : null;
        case (0, $8IuE5.L1_MENU_ID).PROJECTS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cRvJm.Nav4Projects), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $8IuE5.L1_MENU_ID).RECENT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cRLIL.Recent), null);
        case (0, $8IuE5.L1_MENU_ID).ROADMAPS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iFx8E.Nav4Roadmaps), {
                isExpanded: isDefaultOpen
            });
        case (0, $8IuE5.L1_MENU_ID).STARRED:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g0Ue2.Starred), null);
        case (0, $8IuE5.L1_MENU_ID).TEAMS:
            return !(0, $a62R3.isTeamsAppEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8N06.Teams), null) : null;
        case (0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE:
            return (0, $7jTnu.fg)('jcs_master_flag') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7u7ku.CustomerService), null) : null;
        case (0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS:
            return (0, $7jTnu.fg)('jcs-analytics-page') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hcSA5.CustomerServiceAnalytics), null) : null;
        default:
            return null;
    }
}

});
parcelRegister("7X4e3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3da5f33e4d22ad2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<237b885497b658573d984371ca06695a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f3da5f33e4d22ad2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfigurableMenuItem",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4Projects"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Filters"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Plans"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Apps"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Operations"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Overviews"
        }
    ],
    "type": "Query"
};
$f3da5f33e4d22ad2$var$node.hash = "5c4da86f47569a65309ccf227624f58f";
var $f3da5f33e4d22ad2$export$2e2bcd8739ae039 = $f3da5f33e4d22ad2$var$node;

});

parcelRegister("2wp9U", function(module, exports) {

$parcel$export(module.exports, "Nav4Apps", () => $fbaf54bbcaffccb8$export$8473036ee9e92881);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $eYuVr = parcelRequire("eYuVr");

var $16sa1 = parcelRequire("16sa1");


var $669uo = parcelRequire("669uo");
const $fbaf54bbcaffccb8$export$8473036ee9e92881 = (props)=>{
    const getAttributes = (0, $eJOHy.useCallback)((error)=>(0, $669uo.createAttributes)({
            error: error,
            component: 'Nav4Apps'
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4-sidebar-apps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "apps-section",
        attributes: getAttributes,
        packageName: (0, $a9b3358f09bdf564$export$b8b9d90f9e5bd72b),
        teamName: (0, $a9b3358f09bdf564$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eYuVr.Nav4Apps), props)));
};

});
parcelRegister("eYuVr", function(module, exports) {

$parcel$export(module.exports, "Nav4Apps", () => $2fefbbb2634a89d7$export$8473036ee9e92881);

var $4LpT6 = parcelRequire("4LpT6");

var $gFCSI = parcelRequire("gFCSI");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $8y6Xv = parcelRequire("8y6Xv");

var $2LOiu = parcelRequire("2LOiu");

var $hAiyG = parcelRequire("hAiyG");

var $dDuGq = parcelRequire("dDuGq");

var $7adq7 = parcelRequire("7adq7");

var $6HiqT = parcelRequire("6HiqT");
function $2fefbbb2634a89d7$export$8473036ee9e92881(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6HiqT.Nav4AppsSpotlightWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2fefbbb2634a89d7$var$Nav4AppsInner, props));
}
function $2fefbbb2634a89d7$var$Nav4AppsInner({ isExpanded: isExpanded, queryRef: queryRef }) {
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const data = (0, $j4oe4.useFragment)((0, $gFCSI.default), queryRef);
    /* eslint-disable @atlassian/relay/unused-fields */ const globalAppNavigationItems = (0, $j4oe4.useFragment)((0, $4LpT6.default), data.jira);
    /* eslint-enable @atlassian/relay/unused-fields */ // $isAppsExpanded (in the query) is based on the same logic as in isInitialSelectedPath(MENU_ID_APPS).
    // However, below we filter out false positives based on extra data we retrieve from GraphQL.
    // We simply can't determine whether the general Connect app is a part of the "Apps" section or not without that extra data.
    // And we would like to avoid situations where the "Apps" section is expanded when it shouldn't be.
    // Keep in mind that global Connect app != general Connect app. Global app is a subset of the general app.
    // General app can be rendered in various contexts, while the global one only under the "Apps" section.
    const isMaybeAppsSectionRoute = isInitialSelectedPath((0, $h4Bzb.MENU_ID_APPS));
    const isGeneralConnectRoute = (0, $8y6Xv.useIsGeneralConnectRoute)();
    const isGlobalConnectAppRoute = (0, $hAiyG.useIsGlobalConnectAppRoute)({
        data: globalAppNavigationItems
    });
    const isAppsSectionExpanded = isMaybeAppsSectionRoute && (isGeneralConnectRoute ? isGlobalConnectAppRoute : true);
    const sectionActions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2LOiu.SectionActions), null);
    return isAppsSectionExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7adq7.Nav4AppsForLanding), {
        actionsOnHover: sectionActions,
        isExpanded: isExpanded,
        queryRef: data.jira
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dDuGq.Nav4AppsDefault), {
        actionsOnHover: sectionActions,
        isExpanded: isExpanded
    });
}

});
parcelRegister("4LpT6", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a821507588a0da1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b841eae00c140d0fa10ac87feab52bf9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7a821507588a0da1$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "isAppsExpanded"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4Apps_GlobalAppsFragment",
        "selections": [
            {
                "condition": "isAppsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraNavigationItemConnection",
                        "kind": "LinkedField",
                        "name": "globalAppNavigationItems",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraNavigationItemEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "appType"
                                                    },
                                                    v0 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraAppSection",
                                                        "kind": "LinkedField",
                                                        "name": "sections",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraAppNavigationItemNestedLink",
                                                                "kind": "LinkedField",
                                                                "name": "links",
                                                                "plural": true,
                                                                "selections": [
                                                                    v0 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraAppNavigationItem"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$7a821507588a0da1$var$node.hash = "fcee4331eb5ce6a0f2c7ee593634458d";
var $7a821507588a0da1$export$2e2bcd8739ae039 = $7a821507588a0da1$var$node;

});

parcelRegister("gFCSI", function(module, exports) {

$parcel$export(module.exports, "default", () => $640d0996091eb87b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf10716a4c00972068007e73ef5b1c3f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $640d0996091eb87b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isAppsExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Apps",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "isAppsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "Nav4AppsForLanding"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4Apps_GlobalAppsFragment"
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$640d0996091eb87b$var$node.hash = "c3df504da3663fd99ebe67a0d32de67f";
var $640d0996091eb87b$export$2e2bcd8739ae039 = $640d0996091eb87b$var$node;

});

parcelRegister("8y6Xv", function(module, exports) {

$parcel$export(module.exports, "useIsGeneralConnectRoute", () => $d961b38f2598891f$export$db179b21b0be87a1);

var $QaFzq = parcelRequire("QaFzq");
const $d961b38f2598891f$var$GENERAL_CONNECT_ROUTES = new Set([
    'connect-general',
    'connect-general-invalid',
    'legacy-connect-general',
    'connect-general-service-desk-project'
]);
const $d961b38f2598891f$var$UNCERTAIN_APPS_SECTION_ROUTES = $d961b38f2598891f$var$GENERAL_CONNECT_ROUTES;
const $d961b38f2598891f$var$CERTAIN_APPS_SECTION_ROUTES = new Set([
    'forge-spa-global',
    'marketplace-index'
]);
const $d961b38f2598891f$export$22e210b2ba662e30 = new Set([
    ...$d961b38f2598891f$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$d961b38f2598891f$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $d961b38f2598891f$export$db179b21b0be87a1() {
    const route = (0, $QaFzq.useRoute)();
    return $d961b38f2598891f$var$GENERAL_CONNECT_ROUTES.has(route.name);
}

});
parcelRegister("QaFzq", function(module, exports) {

$parcel$export(module.exports, "useRoute", () => $57ba212b9ebdebd8$export$3f79f0b98112cf57);

var $kfvK2 = parcelRequire("kfvK2");
const $57ba212b9ebdebd8$export$3f79f0b98112cf57 = (0, $kfvK2.createRouterSelector)((state)=>state.route);

});


parcelRegister("2LOiu", function(module, exports) {

$parcel$export(module.exports, "SectionActions", () => $9b4eb16222e1d46d$export$51f8029abf8c56ce);

var $eJOHy = parcelRequire("eJOHy");

var $L2KhS = parcelRequire("L2KhS");

var $ejfxj = parcelRequire("ejfxj");

var $apGPk = parcelRequire("apGPk");
var $7R1al = parcelRequire("7R1al");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $9id36 = parcelRequire("9id36");



var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $6naEG = parcelRequire("6naEG");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $2Clab = parcelRequire("2Clab");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $lvKO5 = parcelRequire("lvKO5");

var $fwwjt = parcelRequire("fwwjt");
function $9b4eb16222e1d46d$export$51f8029abf8c56ce({ onClose: onClose }) {
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = tenantContext;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const showManageApps = isAdmin || isSiteAdmin;
    const showAppAuditLogs = (0, $7jTnu.fg)('show_app_audit_logs_upm_dep') && (isAdmin || isSiteAdmin);
    const showViewAppRequests = (0, $epTsa.expVal)('enduser-emcee-discover', 'value', true) && isSiteAdmin;
    const fireOpenEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_APPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: 'meatballDropdown'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        MenuItems: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b4eb16222e1d46d$var$MoreMenuItems, {
                showManageApps: showManageApps,
                showViewAppRequests: showViewAppRequests,
                showAppAuditLogs: showAppAuditLogs,
                ...props
            }),
        onOpen: fireOpenEvent,
        onClose: onClose
    });
}
function $9b4eb16222e1d46d$var$MoreMenuItems({ onClose: onClose, showManageApps: showManageApps, showViewAppRequests: showViewAppRequests, showAppAuditLogs: showAppAuditLogs }) {
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { cloudId: cloudId } = tenantContext;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const adminHubAppRequestsUrl = `https://${(0, $9id36.getATLContextDomain)('admin')}/s/${cloudId}/user-connected-apps/tab/requested`;
    const viewAppRequestsLink = (0, $eJOHy.useMemo)(()=>(0, $7jTnu.fg)('should_redirect_to_admin-hub_for_app_requests') ? adminHubAppRequestsUrl : (0, $2Clab.getAppRequestsLink)(), [
        adminHubAppRequestsUrl
    ]);
    const onCloseWithStopPropagation = (0, $6naEG.useStopPropagation)(onClose);
    const showTopSection = showManageApps || showViewAppRequests;
    const fireClickEvent = (0, $eJOHy.useCallback)((itemId)=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_APPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$74712b62056d422e),
                itemId: itemId,
                parentItemId: (0, $a9aec.SECTION_ITEM_APPS)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showTopSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), null, showManageApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apGPk.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ejfxj))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/plugins/servlet/upm",
        target: "_blank",
        onClick: (...args)=>{
            fireClickEvent('manageApps');
            onCloseWithStopPropagation(...args);
        }
    }, formatMessage((0, $fwwjt.default).manageApps)), showAppAuditLogs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apGPk.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ejfxj))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/plugins/servlet/upm/log",
        onClick: (...args)=>{
            onCloseWithStopPropagation(...args);
        },
        target: "_blank"
    }, formatMessage((0, $fwwjt.default).appAuditLogs)), showViewAppRequests && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apGPk.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($L2KhS))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: viewAppRequestsLink,
        target: "_blank",
        onClick: (...args)=>{
            fireClickEvent('viewAppRequests');
            onCloseWithStopPropagation(...args);
        }
    }, formatMessage((0, $fwwjt.default).viewAppRequests))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).APPS,
        hasSeparator: showTopSection
    }));
}

});
parcelRegister("6naEG", function(module, exports) {

$parcel$export(module.exports, "useStopPropagation", () => $021cd548567896d7$export$f7bb512e68bcecd9);

var $eJOHy = parcelRequire("eJOHy");
const $021cd548567896d7$export$f7bb512e68bcecd9 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
onEvent)=>(0, $eJOHy.useCallback)((e, ...args)=>{
        try {
            onEvent?.(e, ...args);
        } finally{
            e?.stopPropagation();
        }
    }, [
        onEvent
    ]);

});

parcelRegister("2Clab", function(module, exports) {

$parcel$export(module.exports, "getEmceeDiscoverLink", () => $04a896ce17590d9a$export$f26dabf284aefb17);
$parcel$export(module.exports, "getEmceeAppListingLink", () => $04a896ce17590d9a$export$eb09695b9e9f6a3);
$parcel$export(module.exports, "getAppRequestsLink", () => $04a896ce17590d9a$export$7ab8c48f9081e976);
$parcel$export(module.exports, "getManagePromotionsLink", () => $04a896ce17590d9a$export$350ca33eed6a2742);
const $04a896ce17590d9a$var$sanitiseParams = (params)=>params ? Object.entries(params).reduce((res, [key, value])=>{
        if (value) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'EmceeQueryParams | JiraQueryParams'.
        res[key] = params[key];
        return res;
    }, {}) : {};
const $04a896ce17590d9a$var$addQueryParamsToLink = (params, link)=>{
    // @ts-expect-error - TS2345 - Argument of type 'EmceeQueryParams | JiraQueryParams | null | undefined' is not assignable to parameter of type 'EmceeQueryParams | JiraQueryParams | undefined'.
    const queryParams = $04a896ce17590d9a$var$sanitiseParams(params);
    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `${link}?${queryString}` : link;
};
const $04a896ce17590d9a$export$f26dabf284aefb17 = (params)=>{
    const link = '/jira/marketplace/discover';
    return $04a896ce17590d9a$var$addQueryParamsToLink(params, link);
};
const $04a896ce17590d9a$export$eb09695b9e9f6a3 = (appKey, params, jiraQueryParams)=>$04a896ce17590d9a$var$addQueryParamsToLink({
        ...jiraQueryParams,
        ...params
    }, `/jira/marketplace/discover/app/${appKey}`);
const $04a896ce17590d9a$export$7ab8c48f9081e976 = (params)=>{
    const link = '/jira/marketplace/manage/app-requests';
    return $04a896ce17590d9a$var$addQueryParamsToLink(params, link);
};
const $04a896ce17590d9a$export$350ca33eed6a2742 = (params)=>{
    const link = '/jira/marketplace/manage/promotions';
    return $04a896ce17590d9a$var$addQueryParamsToLink(params, link);
};

});

parcelRegister("fwwjt", function(module, exports) {

$parcel$export(module.exports, "default", () => $681b6aa609615fc4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $681b6aa609615fc4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    manageApps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.manage-apps",
        "defaultMessage": "Manage apps"
    },
    appAuditLogs: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.app-audit-logs",
        "defaultMessage": "App audit logs"
    },
    viewAppRequests: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.view-app-requests",
        "defaultMessage": "View app requests"
    }
});

});


parcelRegister("hAiyG", function(module, exports) {

$parcel$export(module.exports, "useIsGlobalConnectAppRoute", () => $83ce8240ea1dfa36$export$32897ea1251cd6aa);

var $eJOHy = parcelRequire("eJOHy");

var $3Q6BV = parcelRequire("3Q6BV");

var $8xDPn = parcelRequire("8xDPn");

var $jRu18 = parcelRequire("jRu18");

var $eYtNM = parcelRequire("eYtNM");

var $jJqSP = parcelRequire("jJqSP");
const $83ce8240ea1dfa36$export$32897ea1251cd6aa = ({ data: data })=>{
    const location = (0, $jRu18.useLocation)();
    const query = (0, $eYtNM.useQuery)();
    const locations = (0, $eJOHy.useMemo)(()=>(data?.globalAppNavigationItems?.edges || []).filter((edge)=>edge?.node?.appType === 'CONNECT').flatMap((edge)=>(edge?.node && (0, $jJqSP.canHaveSubpages)(edge?.node) && edge?.node?.sections || [
                {
                    links: [
                        {
                            url: edge?.node?.url
                        }
                    ]
                }
            ]).flatMap((section)=>(section?.links || []).map((link)=>(0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(link?.url || '/', true)))), [
        data
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        const matcher = (0, $8xDPn.matchUrlExact)();
        const currentLocation = {
            ...location,
            query: query
        };
        // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
        return locations.some((loc)=>matcher(currentLocation, loc));
    }, [
        locations,
        location,
        query
    ]);
};

});
parcelRegister("8xDPn", function(module, exports) {

$parcel$export(module.exports, "matchPathname", () => $d5c7bfee55dffd85$export$b71b01274a8bb9ec);
$parcel$export(module.exports, "matchUrlPathname", () => $d5c7bfee55dffd85$export$6bfcf8859d3bc51c);
$parcel$export(module.exports, "matchPartialUrlPathname", () => $d5c7bfee55dffd85$export$9870a2fa97808ed7);
$parcel$export(module.exports, "matchUrlExact", () => $d5c7bfee55dffd85$export$422d2a799c6e30b8);
$parcel$export(module.exports, "matchUrlParams", () => $d5c7bfee55dffd85$export$63fdecce99465869);

var $ee5Jg = parcelRequire("ee5Jg");
// Jira url paths are messy, so we have to try to clean them to avoid missing matches
// - pages urls sometimes have /secure, sometimes they don't
// - jspa pages urls sometimes have !action, sometimes they don't
const $d5c7bfee55dffd85$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
const $d5c7bfee55dffd85$export$b71b01274a8bb9ec = (currentUrlPath, itemUrlPath)=>$d5c7bfee55dffd85$var$cleanPath(currentUrlPath) === $d5c7bfee55dffd85$var$cleanPath(itemUrlPath);
const $d5c7bfee55dffd85$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$d5c7bfee55dffd85$export$b71b01274a8bb9ec(currentLocation.pathname, itemLocation.pathname);
const $d5c7bfee55dffd85$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
const $d5c7bfee55dffd85$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$d5c7bfee55dffd85$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, (/*@__PURE__*/$parcel$interopDefault($ee5Jg)))(currentLocation.query, itemLocation.query);
const $d5c7bfee55dffd85$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $d5c7bfee55dffd85$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);

});

parcelRegister("jRu18", function(module, exports) {

$parcel$export(module.exports, "useLocation", () => $a841cad6e309fab1$export$45d76561a5302f2b);

var $kfvK2 = parcelRequire("kfvK2");
const $a841cad6e309fab1$export$45d76561a5302f2b = (0, $kfvK2.createRouterSelector)((state)=>state.location);

});

parcelRegister("eYtNM", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $841534f2cec37f8c$export$dd0a697e1782aedd);

var $kfvK2 = parcelRequire("kfvK2");
const $841534f2cec37f8c$export$dd0a697e1782aedd = (0, $kfvK2.createRouterSelector)((state)=>state.query);

});

parcelRegister("jJqSP", function(module, exports) {

$parcel$export(module.exports, "canHaveSubpages", () => $e87c0b6415eacf4c$export$352a285d5cb56873);
/**
 * The magic is copied from jira/src/packages/navigation-apps/sidebar/connect/src/common/utils/find-item-stack/index.tsx
 * No clue what that `s` query param stands for, just keeping the link comparison logic 1:1 to avoid regressions.
 */ 
var $cSmYj = parcelRequire("cSmYj");
// JSPA-1062 remove qs items that might not always be there
const $e87c0b6415eacf4c$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $e87c0b6415eacf4c$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $e87c0b6415eacf4c$var$parseUrl = (url = '')=>{
    const [pathname, qs = ''] = url.split('#')[0].split('?');
    return {
        pathname: pathname,
        query: $e87c0b6415eacf4c$var$splitRelevantQs(qs)
    };
};
function $e87c0b6415eacf4c$export$352a285d5cb56873(data) {
    const sections = data.sections || [];
    const { pathname: rootPagePathname, query: rootPageQuery } = $e87c0b6415eacf4c$var$parseUrl(data.url || '');
    for (const section of sections){
        if ((section?.links || []).some((link)=>{
            const { pathname: pathname, query: query } = $e87c0b6415eacf4c$var$parseUrl(link?.url || '');
            return rootPagePathname === pathname && $e87c0b6415eacf4c$var$isSameQuery(rootPageQuery, query);
        })) return true;
    }
    return false;
}

});


parcelRegister("dDuGq", function(module, exports) {

$parcel$export(module.exports, "Nav4AppsDefault", () => $87eab69501cb8c56$export$3732a771b6ecd66d);

var $eJOHy = parcelRequire("eJOHy");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");


var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $80rA3 = parcelRequire("80rA3");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $if69u = parcelRequire("if69u");

var $azEgq = parcelRequire("azEgq");

var $eL2Ux = parcelRequire("eL2Ux");

var $hPlDs = parcelRequire("hPlDs");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");

var $hHXEn = parcelRequire("hHXEn");


var $669uo = parcelRequire("669uo");

var $cjf2i = parcelRequire("cjf2i");
function $87eab69501cb8c56$export$3732a771b6ecd66d(props) {
    const { actionsOnHover: actionsOnHover, simulateLoading: simulateLoading = false, isExpanded: isExpanded = simulateLoading } = props;
    const cloudId = (0, $kEUB1.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $cjf2i.asyncNav4AppsContentViewQuery), entryPointParams);
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).APPS);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const getAttributes = (0, $eJOHy.useCallback)((error)=>(0, $669uo.createAttributes)({
            error: error,
            component: 'Nav4AppsDefault'
        }), []);
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    const menuId = (0, $h4Bzb.MENU_ID_APPS);
    const onSystemToggle = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const onExpansionToggle = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $8IuE5.L1_MENU_ID).APPS);
            (0, $gCeeo.fireUIAnalytics)(event, (0, $a9aec.SECTION_ITEM_APPS), {
                isInMore: isInMore
            });
        }
    }, [
        createAnalyticsEvent,
        entryPointActions,
        moreMenuIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? onSystemToggle : (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? onExpansionToggle : (hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                const event = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
                });
                const isInMore = moreMenuIds.includes((0, $8IuE5.L1_MENU_ID).APPS);
                (0, $gCeeo.fireUIAnalytics)(event, (0, $a9aec.SECTION_ITEM_APPS), {
                    isInMore: isInMore
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-apps-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $azEgq.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-apps-default",
        errorAttributes: getAttributes,
        packageName: (0, $a9b3358f09bdf564$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $a9b3358f09bdf564$export$d57b6b390e78d90f),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hHXEn.ExploreMoreApps), null)));
}

});
parcelRegister("yAFiV", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemContent", () => $3f28455c02fe4317$export$bd680a81504a92e9);
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $jKePJ = parcelRequire("jKePJ");

var $bkAOK = parcelRequire("bkAOK");
const $3f28455c02fe4317$var$styles = {
    content: "_bozg1crf",
    collapsedContent: "_1e0cglyw"
};
const $3f28455c02fe4317$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $bkAOK.useIsExpanded)();
    const level = (0, $bkAOK.useLevel)();
    const hasExpanded = (0, $eJOHy.useRef)(false);
    const areAllAncestorsExpanded = (0, $bkAOK.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bkAOK.LevelContext).Provider, {
        value: level + 1,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bkAOK.AreAllAncestorsExpandedContext).Provider, {
            value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jKePJ.List), {
                ref: forwardedRef,
                xcss: (0, $k0ahr.cx)($3f28455c02fe4317$var$styles.content, !isExpanded && $3f28455c02fe4317$var$styles.collapsedContent),
                children: children
            })
        })
    });
});

});

parcelRegister("3HUFo", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemTrigger", () => $bc19b603b1d36ec3$export$fe6fe51056867f4d);
/* expandable-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $4BzUI = parcelRequire("4BzUI");

var $FO5HY = parcelRequire("FO5HY");

var $abxMj = parcelRequire("abxMj");

var $8XtVW = parcelRequire("8XtVW");

var $gX9lg = parcelRequire("gX9lg");

var $l1rJl = parcelRequire("l1rJl");

var $bkAOK = parcelRequire("bkAOK");
// Widening type to `string` to side-step Compiled cssMap typescript warnings with unknown properties
const $bc19b603b1d36ec3$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $bc19b603b1d36ec3$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $bc19b603b1d36ec3$var$wrapperStyles = {
    root: "_1mmi1txw _165nglyw",
    showProvidedElemBefore: "_1mmiglyw _165n1bgi _v9u71txw _1hl9glyw _b31z1txw _1vnl1txw _12xsglyw _p8btglyw"
};
const $bc19b603b1d36ec3$var$iconStyles = {
    chevron: "_1e0ciw0t _1tz3r0mg",
    providedElemBefore: "_1e0c1xb2",
    providedElemBeforeSelected: "_syaz1qo3"
};
const $bc19b603b1d36ec3$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($FO5HY))) : (0, (/*@__PURE__*/$parcel$interopDefault($abxMj)));
    const chevronElem = /*#__PURE__*/ (0, $gt9Am.jsx)(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #0C66E4)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $bc19b603b1d36ec3$var$iconStyles.chevron
                ]),
                children: chevronElem
            }),
            providedElemBefore && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $bc19b603b1d36ec3$var$iconStyles.providedElemBefore,
                    isSelected && $bc19b603b1d36ec3$var$iconStyles.providedElemBeforeSelected
                ]),
                children: providedElemBefore
            })
        ]
    });
};
const $bc19b603b1d36ec3$export$fe6fe51056867f4d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const id = (0, $eJOHy.useId)();
    const onExpansionToggle = (0, $bkAOK.useOnExpansionToggle)();
    const isExpanded = (0, $bkAOK.useIsExpanded)();
    const setIsExpanded = (0, $bkAOK.useSetIsExpanded)();
    const itemRef = (0, $eJOHy.useRef)(null);
    const handleIconClick = (0, $eJOHy.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $l1rJl.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    });
    // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)($bc19b603b1d36ec3$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // We are labelling the icon button using the containing menu item's content, to provide context to
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": (0, $8XtVW.fg)('platform_dst_expandable_menu_item_elembefore_label') ? id : undefined,
        // IconButton requires a label prop, however it will not be used by screen readers as we are setting
        // `aria-labelledby`, which will be used instead.
        label: (0, $8XtVW.fg)('platform_dst_expandable_menu_item_elembefore_label') ? '' : isExpanded ? 'Collapse' : 'Expand',
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($bc19b603b1d36ec3$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    });
    // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: itemRef,
        className: (0, $hcewu.default)([
            $bc19b603b1d36ec3$var$wrapperStyles.root,
            providedElemBefore && $bc19b603b1d36ec3$var$wrapperStyles.showProvidedElemBefore
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gX9lg.MenuItemBase), {
            id: id,
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: elemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            testId: testId,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});

});

parcelRegister("lvrbL", function(module, exports) {

$parcel$export(module.exports, "Nav4ExpandableMenuItem", () => $c2485168c972a927$export$3c0db18b09c9af3e);

var $eJOHy = parcelRequire("eJOHy");

var $fHvuI = parcelRequire("fHvuI");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $dpxw4 = parcelRequire("dpxw4");

var $cbCSE = parcelRequire("cbCSE");

var $286cZ = parcelRequire("286cZ");

var $jd93d = parcelRequire("jd93d");
const $c2485168c972a927$export$3c0db18b09c9af3e = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'), /*#__PURE__*/ (0, $eJOHy.forwardRef)($c2485168c972a927$var$Nav4ExpandableMenuItemView));
function $c2485168c972a927$var$Nav4ExpandableMenuItemView(props, ref) {
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const { isSelectedPath: isSelectedPath, isInitialSelectedPath: isInitialSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const { isControlledNav: isControlledNav, isControlledPath: isControlledPath } = (0, $cbCSE.useSidebarNav4Controller)();
    const { children: children, menuId: menuId, onExpansionToggle: onExpansionToggle, isExpanded: isExpanded = false, onSystemToggle: onSystemToggle, expandedRef: expandedRef, collapsedRef: collapsedRef, dropIndicator: dropIndicator = null, dropTargetRef: dropTargetRef = null, isDragging: isDragging = false } = props;
    // controlled state, `isActuallyExpanded` decides whether the component is expanded or not (based on logic in this component and props.isExpanded)
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const [isActuallyExpanded, setActuallyExpanded] = (0, $eJOHy.useState)(isInitialSelectedPath(menuId) || isExpanded);
    // By default, the expandable component is closed. When we want it to be initially open, we also need to trigger onExpansionToggle().
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    (0, $eJOHy.useEffect)(()=>{
        if (isActuallyExpanded === true && isExpanded === false) onSystemToggle?.(isActuallyExpanded);
    // We want to run this only once, on init.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If isSelectedPath changes (external change), update our internal state.
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    (0, $eJOHy.useEffect)(()=>{
        // Fyi, the following logic causes the component to _collapse_ when the selectedPath changes (preserved here for posterity):
        //   const localIsExpanded = isSelectedPath(menuId);
        // ...but this logic _keeps the component expanded_ (if it is) when the selectedPath changes. We can only auto-expand component, not auto-collapse it though (which is fine, for current UX):
        const localIsExpanded = isSelectedPath(menuId) || isActuallyExpanded;
        // Trigger the callbacks ONLY when the previous state doesn't match the new state.
        if (localIsExpanded !== isActuallyExpanded) {
            setActuallyExpanded(localIsExpanded);
            onSystemToggle?.(localIsExpanded);
        }
    // We only want to run this when isSelectedPath() changes, not when isActuallyExpanded changes.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSelectedPath
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    (0, $eJOHy.useEffect)(()=>{
        if (!isControlledNav) return;
        const localIsExpanded = isControlledPath(menuId);
        if (localIsExpanded !== isActuallyExpanded) {
            setActuallyExpanded(localIsExpanded);
            onSystemToggle?.(localIsExpanded);
        }
    // We only want to run this when isControlledPath() changes, not when isActuallyExpanded changes.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isControlledPath
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    const expandableMenuItemRef = (0, $eJOHy.useMemo)(()=>{
        if (isActuallyExpanded) return expandedRef ?? ref;
        return collapsedRef ?? ref;
    }, [
        collapsedRef,
        expandedRef,
        isActuallyExpanded,
        ref
    ]);
    const onExpandableMenuItemToggle = (0, $eJOHy.useCallback)((hasExpanded)=>{
        // Since we are controlling `isExpanded` state in this component (via `isActuallyExpanded`), we need to change it on onExpansionToggle user-event too.
        setActuallyExpanded(hasExpanded);
        onExpansionToggle?.(hasExpanded);
    }, [
        onExpansionToggle
    ]);
    if ((0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fHvuI.ExpandableMenuItem), {
        ref: (0, $jd93d.mergeRefs)(expandableMenuItemRef, dropTargetRef),
        dropIndicator: dropIndicator,
        isExpanded: isActuallyExpanded && !isDragging,
        onExpansionToggle: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? onExpandableMenuItemToggle : (hasExpanded)=>{
            // Since we are controlling `isExpanded` state in this component (via `isActuallyExpanded`), we need to change it on onExpansionToggle user-event too.
            setActuallyExpanded(hasExpanded);
            onExpansionToggle?.(hasExpanded);
        }
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fHvuI.ExpandableMenuItem), {
        ref: expandableMenuItemRef,
        isExpanded: isActuallyExpanded,
        onExpansionToggle: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? onExpandableMenuItemToggle : (hasExpanded)=>{
            // Since we are controlling `isExpanded` state in this component (via `isActuallyExpanded`), we need to change it on onExpansionToggle user-event too.
            setActuallyExpanded(hasExpanded);
            onExpansionToggle?.(hasExpanded);
        }
    }, children);
}

});
parcelRegister("fHvuI", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItem", () => $6898915650abcfe7$export$341dea48c30b36ff);
/* expandable-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ieBWZ = parcelRequire("ieBWZ");

var $ilbtc = parcelRequire("ilbtc");

var $bkAOK = parcelRequire("bkAOK");
const $6898915650abcfe7$var$relativeStyles = {
    root: "_kqswh2mm"
};
const $6898915650abcfe7$export$341dea48c30b36ff = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $ieBWZ.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bkAOK.IsExpandedContext).Provider, {
        value: isExpanded,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bkAOK.SetIsExpandedContext).Provider, {
            value: setIsExpanded,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bkAOK.OnExpansionToggleContext).Provider, {
                value: onExpansionToggle ?? null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ilbtc.MenuListItem), {
                    ref: forwardedRef,
                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                        className: (0, $hcewu.default)([
                            dropIndicator && $6898915650abcfe7$var$relativeStyles.root
                        ]),
                        children: [
                            children,
                            dropIndicator
                        ]
                    })
                })
            })
        })
    });
});

});

parcelRegister("jd93d", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $03c18883e9007fda$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $03c18883e9007fda$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $03c18883e9007fda$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $03c18883e9007fda$export$2e2bcd8739ae039(...refs) {
    return (0, $eJOHy.useMemo)(()=>$03c18883e9007fda$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});


parcelRegister("if69u", function(module, exports) {

$parcel$export(module.exports, "SkeletonNavMenuItems", () => $bf75cc4d36608b74$export$c3a3a246584433d7);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $73M1Y = parcelRequire("73M1Y");

var $f9Ihw = parcelRequire("f9Ihw");

var $ilbtc = parcelRequire("ilbtc");

var $h1VbR = parcelRequire("h1VbR");

var $dhRXV = parcelRequire("dhRXV");
var $gPqEA = parcelRequire("gPqEA");

var $7jTnu = parcelRequire("7jTnu");

var $f2JN3 = parcelRequire("f2JN3");
const $bf75cc4d36608b74$var$styles = {
    flyoutWrapper: "_c71lr5sb _ca0q1b66 _n3td1b66 _19bv1b66 _u5f31b66",
    menuWrapper: "_ca0q1b66 _n3td1b66 _19bv1b66",
    projectAvatar: "_2rkoiti9 _bfhkn82g _1bsb1tcg _4t3i1tcg",
    flyoutMenuItem: "_2rkoiti9 _bfhkn82g _4t3izwfg _1bsb1osq _19pk12x7 _otyr12x7",
    menuItem: "_2rkoiti9 _bfhkn82g _4t3i1tcg _1bsb1osq",
    flyoutHeading: "_2rkoiti9 _bfhkn82g _4t3i7vkz _1bsbckbl _19pku2gc _otyrutpp",
    menuHeading: "_2rkoiti9 _bfhkn82g _4t3i7vkz _1bsbckbl _18u01b66 _19pku2gc _otyru2gc",
    bigSearch: "_2rkoiti9 _4t3i14no _bfhkn82g _1bsb1osq _19pk1b66 _otyrutpp _2hwx12x7",
    search: "_2rkoiti9 _bfhkn82g _4t3izwfg _1bsb1osq _19pk1b66 _otyrutpp _2hwx12x7",
    overflowingSection: "_18m91wug"
};
const $bf75cc4d36608b74$var$Heading = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $bf75cc4d36608b74$var$styles.menuHeading
    });
const $bf75cc4d36608b74$var$FlyoutHeading = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $bf75cc4d36608b74$var$styles.flyoutHeading
    });
const $bf75cc4d36608b74$export$36e4ba43c9afd7b0 = ({ withSubTitle: withSubTitle = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPqEA.default), {
        gap: "space.050",
        alignItems: "center",
        justifyContent: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $bf75cc4d36608b74$var$styles.projectAvatar
    }), withSubTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $bf75cc4d36608b74$var$styles.flyoutMenuItem
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $bf75cc4d36608b74$var$styles.menuItem
    }));
const $bf75cc4d36608b74$var$L2MenuItemSectionSkeleton = ({ withHeading: withHeading, count: count = 5 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, withHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$var$Heading, null), (0, (/*@__PURE__*/$parcel$interopDefault($73M1Y)))(0, count).map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
            xcss: $bf75cc4d36608b74$var$styles.menuWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$export$36e4ba43c9afd7b0, null)))));
};
const $bf75cc4d36608b74$var$Search = ({ isBig: isBig })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: isBig ? $bf75cc4d36608b74$var$styles.bigSearch : $bf75cc4d36608b74$var$styles.search
    });
const $bf75cc4d36608b74$var$FlyoutSkeleton = ({ withHeading: withHeading, count: count = 5, withSearch: withSearch = false, withSubTitle: withSubTitle = false, withSubHeading: withSubHeading = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $bf75cc4d36608b74$var$styles.flyoutWrapper
    }, withHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$var$FlyoutHeading, null), withSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$var$Search, {
        isBig: withSubTitle
    }), withSubHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$var$FlyoutHeading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPqEA.default), {
        xcss: $bf75cc4d36608b74$var$styles.overflowingSection,
        gap: withSubTitle ? 'space.050' : 'space.100',
        direction: "column",
        justifyContent: "start"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($73M1Y)))(0, count).map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$export$36e4ba43c9afd7b0, {
            key: index,
            withSubTitle: withSubTitle
        }))));
};
const $bf75cc4d36608b74$var$FancySkeleton = ({ count: count = 5, withHeading: withHeading, isFlyout: isFlyout, withSearch: withSearch, withSubTitle: withSubTitle, withSubHeading: withSubHeading })=>isFlyout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$var$FlyoutSkeleton, {
        withHeading: withHeading,
        count: count,
        withSearch: withSearch,
        withSubTitle: withSubTitle,
        withSubHeading: withSubHeading
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$var$L2MenuItemSectionSkeleton, {
        withHeading: withHeading,
        count: count
    });
const $bf75cc4d36608b74$var$SkeletonNavMenuItemsNew = ({ count: count = 5, withHeading: withHeading, isFlyout: isFlyout, withSearch: withSearch, withSubTitle: withSubTitle, withSubHeading: withSubHeading })=>(0, $7jTnu.fg)('blu-7837_apply_presstrace_nav4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1VbR.default), {
        name: "nav4-sidebar-menu-items-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$var$FancySkeleton, {
        count: count,
        withHeading: withHeading,
        isFlyout: isFlyout,
        withSearch: withSearch,
        withSubTitle: withSubTitle,
        withSubHeading: withSubHeading
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf75cc4d36608b74$var$FancySkeleton, {
        count: count,
        withHeading: withHeading,
        isFlyout: isFlyout,
        withSearch: withSearch,
        withSubTitle: withSubTitle,
        withSubHeading: withSubHeading
    });
const $bf75cc4d36608b74$var$SkeletonNavMenuItemsOld = ({ count: count = 5 })=>(0, $7jTnu.fg)('blu-7837_apply_presstrace_nav4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1VbR.default), {
        name: "nav4-sidebar-menu-items-loading"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($73M1Y)))(0, count).map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), {
            isShimmering: true
        })))) : (0, (/*@__PURE__*/$parcel$interopDefault($73M1Y)))(0, count).map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), {
            isShimmering: true
        })));
const $bf75cc4d36608b74$export$c3a3a246584433d7 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-proj-menu-fix'), $bf75cc4d36608b74$var$SkeletonNavMenuItemsNew, $bf75cc4d36608b74$var$SkeletonNavMenuItemsOld);

});
parcelRegister("73M1Y", function(module, exports) {

var $dyMwB = parcelRequire("dyMwB");

var $523e121d9c22ed5d$var$func = $dyMwB('range', (parcelRequire("tGEEK")));

$523e121d9c22ed5d$var$func.placeholder = (parcelRequire("k1T10"));
module.exports = $523e121d9c22ed5d$var$func;

});
parcelRegister("dyMwB", function(module, exports) {

var $cfbha = parcelRequire("cfbha");

var $dcquX = parcelRequire("dcquX");
/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $9df4175bd7cbb7da$var$convert(name, func, options) {
    return $cfbha($dcquX, name, func, options);
}
module.exports = $9df4175bd7cbb7da$var$convert;

});
parcelRegister("cfbha", function(module, exports) {

var $gb01y = parcelRequire("gb01y");

var $k1T10 = parcelRequire("k1T10");
/** Built-in value reference. */ var $8e9fa1ed117843de$var$push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function $8e9fa1ed117843de$var$baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function $8e9fa1ed117843de$var$baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function $8e9fa1ed117843de$var$cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function $8e9fa1ed117843de$var$createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function $8e9fa1ed117843de$var$flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) $8e9fa1ed117843de$var$push.apply(otherArgs, array);
        if (start != lastIndex) $8e9fa1ed117843de$var$push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function $8e9fa1ed117843de$var$wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $8e9fa1ed117843de$var$baseConvert(util, name, func, options) {
    var isLib = typeof name == 'function', isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        'cap': 'cap' in options ? options.cap : true,
        'curry': 'curry' in options ? options.curry : true,
        'fixed': 'fixed' in options ? options.fixed : true,
        'immutable': 'immutable' in options ? options.immutable : true,
        'rearg': 'rearg' in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : $k1T10, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        'ary': util.ary,
        'assign': util.assign,
        'clone': util.clone,
        'curry': util.curry,
        'forEach': util.forEach,
        'isArray': util.isArray,
        'isError': util.isError,
        'isFunction': util.isFunction,
        'isWeakMap': util.isWeakMap,
        'iteratee': util.iteratee,
        'keys': util.keys,
        'rearg': util.rearg,
        'toInteger': util.toInteger,
        'toPath': util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys($gb01y.aryMethod);
    var wrappers = {
        'castArray': function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray($8e9fa1ed117843de$var$cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        'iteratee': function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == 'number') {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : $8e9fa1ed117843de$var$baseAry(result, arity);
                }
                return result;
            };
        },
        'mixin': function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        'nthArg': function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        'rearg': function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        'runInContext': function(runInContext) {
            return function(context) {
                return $8e9fa1ed117843de$var$baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = $gb01y.iterateeRearg[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && $gb01y.iterateeAry[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !$gb01y.skipFixed[name])) {
            var data = $gb01y.methodSpread[name], start = data && data.start;
            return start === undefined ? ary(func, n) : $8e9fa1ed117843de$var$flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !$gb01y.skipRearg[name]) ? rearg(func, $gb01y.methodRearg[name] || $gb01y.aryRearg[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = $gb01y.aliasToReal[name] || name, methodName = $gb01y.remap[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return $8e9fa1ed117843de$var$baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == 'function' ? $8e9fa1ed117843de$var$baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return $8e9fa1ed117843de$var$baseArity(rearg($8e9fa1ed117843de$var$baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = $gb01y.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if ($gb01y.mutate.array[realName]) wrapped = $8e9fa1ed117843de$var$wrapImmutable(func, $8e9fa1ed117843de$var$cloneArray);
            else if ($gb01y.mutate.object[realName]) wrapped = $8e9fa1ed117843de$var$wrapImmutable(func, $8e9fa1ed117843de$var$createCloner(func));
            else if ($gb01y.mutate.set[realName]) wrapped = $8e9fa1ed117843de$var$wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each($gb01y.aryMethod[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = $gb01y.methodSpread[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each($gb01y.aryMethod[aryKey], function(key) {
            var func = _[$gb01y.remap[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == 'function') {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each($gb01y.realToAlias[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
module.exports = $8e9fa1ed117843de$var$baseConvert;

});
parcelRegister("gb01y", function(module, exports) {

$parcel$export(module.exports, "aliasToReal", () => $bc6db136e0262c52$export$bd0f5e6e44efa6b4, (v) => $bc6db136e0262c52$export$bd0f5e6e44efa6b4 = v);
$parcel$export(module.exports, "aryMethod", () => $bc6db136e0262c52$export$85c665b4d7da9cb4, (v) => $bc6db136e0262c52$export$85c665b4d7da9cb4 = v);
$parcel$export(module.exports, "aryRearg", () => $bc6db136e0262c52$export$42564e045b285e32, (v) => $bc6db136e0262c52$export$42564e045b285e32 = v);
$parcel$export(module.exports, "iterateeAry", () => $bc6db136e0262c52$export$81e17196e6a22b07, (v) => $bc6db136e0262c52$export$81e17196e6a22b07 = v);
$parcel$export(module.exports, "iterateeRearg", () => $bc6db136e0262c52$export$30975ceb42167ebd, (v) => $bc6db136e0262c52$export$30975ceb42167ebd = v);
$parcel$export(module.exports, "methodRearg", () => $bc6db136e0262c52$export$8ceb0ad7e94d3801, (v) => $bc6db136e0262c52$export$8ceb0ad7e94d3801 = v);
$parcel$export(module.exports, "methodSpread", () => $bc6db136e0262c52$export$fbaeb3f87df3cf26, (v) => $bc6db136e0262c52$export$fbaeb3f87df3cf26 = v);
$parcel$export(module.exports, "mutate", () => $bc6db136e0262c52$export$57e795267c26e600, (v) => $bc6db136e0262c52$export$57e795267c26e600 = v);
$parcel$export(module.exports, "realToAlias", () => $bc6db136e0262c52$export$1eb71a7e27943e71, (v) => $bc6db136e0262c52$export$1eb71a7e27943e71 = v);
$parcel$export(module.exports, "remap", () => $bc6db136e0262c52$export$aee1dbae5de2db9d, (v) => $bc6db136e0262c52$export$aee1dbae5de2db9d = v);
$parcel$export(module.exports, "skipFixed", () => $bc6db136e0262c52$export$87ffbe4821a5d5e0, (v) => $bc6db136e0262c52$export$87ffbe4821a5d5e0 = v);
$parcel$export(module.exports, "skipRearg", () => $bc6db136e0262c52$export$b4d07413ce528c90, (v) => $bc6db136e0262c52$export$b4d07413ce528c90 = v);
/** Used to map aliases to their real names. */ var $bc6db136e0262c52$export$bd0f5e6e44efa6b4;
/** Used to map ary to method names. */ var $bc6db136e0262c52$export$85c665b4d7da9cb4;
/** Used to map ary to rearg configs. */ var $bc6db136e0262c52$export$42564e045b285e32;
/** Used to map method names to their iteratee ary. */ var $bc6db136e0262c52$export$81e17196e6a22b07;
/** Used to map method names to iteratee rearg configs. */ var $bc6db136e0262c52$export$30975ceb42167ebd;
/** Used to map method names to rearg configs. */ var $bc6db136e0262c52$export$8ceb0ad7e94d3801;
/** Used to map method names to spread configs. */ var $bc6db136e0262c52$export$fbaeb3f87df3cf26;
/** Used to identify methods which mutate arrays or objects. */ var $bc6db136e0262c52$export$57e795267c26e600;
/** Used to map real names to their aliases. */ var $bc6db136e0262c52$export$1eb71a7e27943e71;
/** Used to map method names to other names. */ var $bc6db136e0262c52$export$aee1dbae5de2db9d;
/** Used to track methods that skip fixing their arity. */ var $bc6db136e0262c52$export$87ffbe4821a5d5e0;
/** Used to track methods that skip rearranging arguments. */ var $bc6db136e0262c52$export$b4d07413ce528c90;
$bc6db136e0262c52$export$bd0f5e6e44efa6b4 = {
    // Lodash aliases.
    'each': 'forEach',
    'eachRight': 'forEachRight',
    'entries': 'toPairs',
    'entriesIn': 'toPairsIn',
    'extend': 'assignIn',
    'extendAll': 'assignInAll',
    'extendAllWith': 'assignInAllWith',
    'extendWith': 'assignInWith',
    'first': 'head',
    // Methods that are curried variants of others.
    'conforms': 'conformsTo',
    'matches': 'isMatch',
    'property': 'get',
    // Ramda aliases.
    '__': 'placeholder',
    'F': 'stubFalse',
    'T': 'stubTrue',
    'all': 'every',
    'allPass': 'overEvery',
    'always': 'constant',
    'any': 'some',
    'anyPass': 'overSome',
    'apply': 'spread',
    'assoc': 'set',
    'assocPath': 'set',
    'complement': 'negate',
    'compose': 'flowRight',
    'contains': 'includes',
    'dissoc': 'unset',
    'dissocPath': 'unset',
    'dropLast': 'dropRight',
    'dropLastWhile': 'dropRightWhile',
    'equals': 'isEqual',
    'identical': 'eq',
    'indexBy': 'keyBy',
    'init': 'initial',
    'invertObj': 'invert',
    'juxt': 'over',
    'omitAll': 'omit',
    'nAry': 'ary',
    'path': 'get',
    'pathEq': 'matchesProperty',
    'pathOr': 'getOr',
    'paths': 'at',
    'pickAll': 'pick',
    'pipe': 'flow',
    'pluck': 'map',
    'prop': 'get',
    'propEq': 'matchesProperty',
    'propOr': 'getOr',
    'props': 'at',
    'symmetricDifference': 'xor',
    'symmetricDifferenceBy': 'xorBy',
    'symmetricDifferenceWith': 'xorWith',
    'takeLast': 'takeRight',
    'takeLastWhile': 'takeRightWhile',
    'unapply': 'rest',
    'unnest': 'flatten',
    'useWith': 'overArgs',
    'where': 'conformsTo',
    'whereEq': 'isMatch',
    'zipObj': 'zipObject'
};
$bc6db136e0262c52$export$85c665b4d7da9cb4 = {
    '1': [
        'assignAll',
        'assignInAll',
        'attempt',
        'castArray',
        'ceil',
        'create',
        'curry',
        'curryRight',
        'defaultsAll',
        'defaultsDeepAll',
        'floor',
        'flow',
        'flowRight',
        'fromPairs',
        'invert',
        'iteratee',
        'memoize',
        'method',
        'mergeAll',
        'methodOf',
        'mixin',
        'nthArg',
        'over',
        'overEvery',
        'overSome',
        'rest',
        'reverse',
        'round',
        'runInContext',
        'spread',
        'template',
        'trim',
        'trimEnd',
        'trimStart',
        'uniqueId',
        'words',
        'zipAll'
    ],
    '2': [
        'add',
        'after',
        'ary',
        'assign',
        'assignAllWith',
        'assignIn',
        'assignInAllWith',
        'at',
        'before',
        'bind',
        'bindAll',
        'bindKey',
        'chunk',
        'cloneDeepWith',
        'cloneWith',
        'concat',
        'conformsTo',
        'countBy',
        'curryN',
        'curryRightN',
        'debounce',
        'defaults',
        'defaultsDeep',
        'defaultTo',
        'delay',
        'difference',
        'divide',
        'drop',
        'dropRight',
        'dropRightWhile',
        'dropWhile',
        'endsWith',
        'eq',
        'every',
        'filter',
        'find',
        'findIndex',
        'findKey',
        'findLast',
        'findLastIndex',
        'findLastKey',
        'flatMap',
        'flatMapDeep',
        'flattenDepth',
        'forEach',
        'forEachRight',
        'forIn',
        'forInRight',
        'forOwn',
        'forOwnRight',
        'get',
        'groupBy',
        'gt',
        'gte',
        'has',
        'hasIn',
        'includes',
        'indexOf',
        'intersection',
        'invertBy',
        'invoke',
        'invokeMap',
        'isEqual',
        'isMatch',
        'join',
        'keyBy',
        'lastIndexOf',
        'lt',
        'lte',
        'map',
        'mapKeys',
        'mapValues',
        'matchesProperty',
        'maxBy',
        'meanBy',
        'merge',
        'mergeAllWith',
        'minBy',
        'multiply',
        'nth',
        'omit',
        'omitBy',
        'overArgs',
        'pad',
        'padEnd',
        'padStart',
        'parseInt',
        'partial',
        'partialRight',
        'partition',
        'pick',
        'pickBy',
        'propertyOf',
        'pull',
        'pullAll',
        'pullAt',
        'random',
        'range',
        'rangeRight',
        'rearg',
        'reject',
        'remove',
        'repeat',
        'restFrom',
        'result',
        'sampleSize',
        'some',
        'sortBy',
        'sortedIndex',
        'sortedIndexOf',
        'sortedLastIndex',
        'sortedLastIndexOf',
        'sortedUniqBy',
        'split',
        'spreadFrom',
        'startsWith',
        'subtract',
        'sumBy',
        'take',
        'takeRight',
        'takeRightWhile',
        'takeWhile',
        'tap',
        'throttle',
        'thru',
        'times',
        'trimChars',
        'trimCharsEnd',
        'trimCharsStart',
        'truncate',
        'union',
        'uniqBy',
        'uniqWith',
        'unset',
        'unzipWith',
        'without',
        'wrap',
        'xor',
        'zip',
        'zipObject',
        'zipObjectDeep'
    ],
    '3': [
        'assignInWith',
        'assignWith',
        'clamp',
        'differenceBy',
        'differenceWith',
        'findFrom',
        'findIndexFrom',
        'findLastFrom',
        'findLastIndexFrom',
        'getOr',
        'includesFrom',
        'indexOfFrom',
        'inRange',
        'intersectionBy',
        'intersectionWith',
        'invokeArgs',
        'invokeArgsMap',
        'isEqualWith',
        'isMatchWith',
        'flatMapDepth',
        'lastIndexOfFrom',
        'mergeWith',
        'orderBy',
        'padChars',
        'padCharsEnd',
        'padCharsStart',
        'pullAllBy',
        'pullAllWith',
        'rangeStep',
        'rangeStepRight',
        'reduce',
        'reduceRight',
        'replace',
        'set',
        'slice',
        'sortedIndexBy',
        'sortedLastIndexBy',
        'transform',
        'unionBy',
        'unionWith',
        'update',
        'xorBy',
        'xorWith',
        'zipWith'
    ],
    '4': [
        'fill',
        'setWith',
        'updateWith'
    ]
};
$bc6db136e0262c52$export$42564e045b285e32 = {
    '2': [
        1,
        0
    ],
    '3': [
        2,
        0,
        1
    ],
    '4': [
        3,
        2,
        0,
        1
    ]
};
$bc6db136e0262c52$export$81e17196e6a22b07 = {
    'dropRightWhile': 1,
    'dropWhile': 1,
    'every': 1,
    'filter': 1,
    'find': 1,
    'findFrom': 1,
    'findIndex': 1,
    'findIndexFrom': 1,
    'findKey': 1,
    'findLast': 1,
    'findLastFrom': 1,
    'findLastIndex': 1,
    'findLastIndexFrom': 1,
    'findLastKey': 1,
    'flatMap': 1,
    'flatMapDeep': 1,
    'flatMapDepth': 1,
    'forEach': 1,
    'forEachRight': 1,
    'forIn': 1,
    'forInRight': 1,
    'forOwn': 1,
    'forOwnRight': 1,
    'map': 1,
    'mapKeys': 1,
    'mapValues': 1,
    'partition': 1,
    'reduce': 2,
    'reduceRight': 2,
    'reject': 1,
    'remove': 1,
    'some': 1,
    'takeRightWhile': 1,
    'takeWhile': 1,
    'times': 1,
    'transform': 2
};
$bc6db136e0262c52$export$30975ceb42167ebd = {
    'mapKeys': [
        1
    ],
    'reduceRight': [
        1,
        0
    ]
};
$bc6db136e0262c52$export$8ceb0ad7e94d3801 = {
    'assignInAllWith': [
        1,
        0
    ],
    'assignInWith': [
        1,
        2,
        0
    ],
    'assignAllWith': [
        1,
        0
    ],
    'assignWith': [
        1,
        2,
        0
    ],
    'differenceBy': [
        1,
        2,
        0
    ],
    'differenceWith': [
        1,
        2,
        0
    ],
    'getOr': [
        2,
        1,
        0
    ],
    'intersectionBy': [
        1,
        2,
        0
    ],
    'intersectionWith': [
        1,
        2,
        0
    ],
    'isEqualWith': [
        1,
        2,
        0
    ],
    'isMatchWith': [
        2,
        1,
        0
    ],
    'mergeAllWith': [
        1,
        0
    ],
    'mergeWith': [
        1,
        2,
        0
    ],
    'padChars': [
        2,
        1,
        0
    ],
    'padCharsEnd': [
        2,
        1,
        0
    ],
    'padCharsStart': [
        2,
        1,
        0
    ],
    'pullAllBy': [
        2,
        1,
        0
    ],
    'pullAllWith': [
        2,
        1,
        0
    ],
    'rangeStep': [
        1,
        2,
        0
    ],
    'rangeStepRight': [
        1,
        2,
        0
    ],
    'setWith': [
        3,
        1,
        2,
        0
    ],
    'sortedIndexBy': [
        2,
        1,
        0
    ],
    'sortedLastIndexBy': [
        2,
        1,
        0
    ],
    'unionBy': [
        1,
        2,
        0
    ],
    'unionWith': [
        1,
        2,
        0
    ],
    'updateWith': [
        3,
        1,
        2,
        0
    ],
    'xorBy': [
        1,
        2,
        0
    ],
    'xorWith': [
        1,
        2,
        0
    ],
    'zipWith': [
        1,
        2,
        0
    ]
};
$bc6db136e0262c52$export$fbaeb3f87df3cf26 = {
    'assignAll': {
        'start': 0
    },
    'assignAllWith': {
        'start': 0
    },
    'assignInAll': {
        'start': 0
    },
    'assignInAllWith': {
        'start': 0
    },
    'defaultsAll': {
        'start': 0
    },
    'defaultsDeepAll': {
        'start': 0
    },
    'invokeArgs': {
        'start': 2
    },
    'invokeArgsMap': {
        'start': 2
    },
    'mergeAll': {
        'start': 0
    },
    'mergeAllWith': {
        'start': 0
    },
    'partial': {
        'start': 1
    },
    'partialRight': {
        'start': 1
    },
    'without': {
        'start': 1
    },
    'zipAll': {
        'start': 0
    }
};
$bc6db136e0262c52$export$57e795267c26e600 = {
    'array': {
        'fill': true,
        'pull': true,
        'pullAll': true,
        'pullAllBy': true,
        'pullAllWith': true,
        'pullAt': true,
        'remove': true,
        'reverse': true
    },
    'object': {
        'assign': true,
        'assignAll': true,
        'assignAllWith': true,
        'assignIn': true,
        'assignInAll': true,
        'assignInAllWith': true,
        'assignInWith': true,
        'assignWith': true,
        'defaults': true,
        'defaultsAll': true,
        'defaultsDeep': true,
        'defaultsDeepAll': true,
        'merge': true,
        'mergeAll': true,
        'mergeAllWith': true,
        'mergeWith': true
    },
    'set': {
        'set': true,
        'setWith': true,
        'unset': true,
        'update': true,
        'updateWith': true
    }
};
$bc6db136e0262c52$export$1eb71a7e27943e71 = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = $bc6db136e0262c52$export$bd0f5e6e44efa6b4, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
$bc6db136e0262c52$export$aee1dbae5de2db9d = {
    'assignAll': 'assign',
    'assignAllWith': 'assignWith',
    'assignInAll': 'assignIn',
    'assignInAllWith': 'assignInWith',
    'curryN': 'curry',
    'curryRightN': 'curryRight',
    'defaultsAll': 'defaults',
    'defaultsDeepAll': 'defaultsDeep',
    'findFrom': 'find',
    'findIndexFrom': 'findIndex',
    'findLastFrom': 'findLast',
    'findLastIndexFrom': 'findLastIndex',
    'getOr': 'get',
    'includesFrom': 'includes',
    'indexOfFrom': 'indexOf',
    'invokeArgs': 'invoke',
    'invokeArgsMap': 'invokeMap',
    'lastIndexOfFrom': 'lastIndexOf',
    'mergeAll': 'merge',
    'mergeAllWith': 'mergeWith',
    'padChars': 'pad',
    'padCharsEnd': 'padEnd',
    'padCharsStart': 'padStart',
    'propertyOf': 'get',
    'rangeStep': 'range',
    'rangeStepRight': 'rangeRight',
    'restFrom': 'rest',
    'spreadFrom': 'spread',
    'trimChars': 'trim',
    'trimCharsEnd': 'trimEnd',
    'trimCharsStart': 'trimStart',
    'zipAll': 'zip'
};
$bc6db136e0262c52$export$87ffbe4821a5d5e0 = {
    'castArray': true,
    'flow': true,
    'flowRight': true,
    'iteratee': true,
    'mixin': true,
    'rearg': true,
    'runInContext': true
};
$bc6db136e0262c52$export$b4d07413ce528c90 = {
    'add': true,
    'assign': true,
    'assignIn': true,
    'bind': true,
    'bindKey': true,
    'concat': true,
    'difference': true,
    'divide': true,
    'eq': true,
    'gt': true,
    'gte': true,
    'isEqual': true,
    'lt': true,
    'lte': true,
    'matchesProperty': true,
    'merge': true,
    'multiply': true,
    'overArgs': true,
    'partial': true,
    'partialRight': true,
    'propertyOf': true,
    'random': true,
    'range': true,
    'rangeRight': true,
    'subtract': true,
    'zip': true,
    'zipObject': true,
    'zipObjectDeep': true
};

});

parcelRegister("k1T10", function(module, exports) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

});


parcelRegister("dcquX", function(module, exports) {














module.exports = {
    'ary': (parcelRequire("k13ij")),
    'assign': (parcelRequire("aahcv")),
    'clone': (parcelRequire("1LiX8")),
    'curry': (parcelRequire("fLExA")),
    'forEach': (parcelRequire("ez1ap")),
    'isArray': (parcelRequire("4sprp")),
    'isError': (parcelRequire("cvRyD")),
    'isFunction': (parcelRequire("dCU5j")),
    'isWeakMap': (parcelRequire("9CL26")),
    'iteratee': (parcelRequire("c4kBg")),
    'keys': (parcelRequire("jAnCu")),
    'rearg': (parcelRequire("7GIya")),
    'toInteger': (parcelRequire("c9FP3")),
    'toPath': (parcelRequire("lDisb"))
};

});
parcelRegister("k13ij", function(module, exports) {

var $5rOR1 = parcelRequire("5rOR1");
/** Used to compose bitmasks for function metadata. */ var $e92674d98e82f1d7$var$WRAP_ARY_FLAG = 128;
/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function $e92674d98e82f1d7$var$ary(func, n, guard) {
    n = guard ? undefined : n;
    n = func && n == null ? func.length : n;
    return $5rOR1(func, $e92674d98e82f1d7$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}
module.exports = $e92674d98e82f1d7$var$ary;

});
parcelRegister("5rOR1", function(module, exports) {

var $a2rYh = parcelRequire("a2rYh");

var $g2n0U = parcelRequire("g2n0U");

var $c4AZN = parcelRequire("c4AZN");

var $cH1gk = parcelRequire("cH1gk");

var $jvtoE = parcelRequire("jvtoE");

var $2GK2O = parcelRequire("2GK2O");

var $cwwEL = parcelRequire("cwwEL");

var $aaQGq = parcelRequire("aaQGq");

var $9Xy53 = parcelRequire("9Xy53");

var $c9FP3 = parcelRequire("c9FP3");
/** Error message constants. */ var $3f76ebf31bc08fc6$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $3f76ebf31bc08fc6$var$WRAP_BIND_FLAG = 1, $3f76ebf31bc08fc6$var$WRAP_BIND_KEY_FLAG = 2, $3f76ebf31bc08fc6$var$WRAP_CURRY_FLAG = 8, $3f76ebf31bc08fc6$var$WRAP_CURRY_RIGHT_FLAG = 16, $3f76ebf31bc08fc6$var$WRAP_PARTIAL_FLAG = 32, $3f76ebf31bc08fc6$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3f76ebf31bc08fc6$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $3f76ebf31bc08fc6$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $3f76ebf31bc08fc6$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($3f76ebf31bc08fc6$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($3f76ebf31bc08fc6$var$WRAP_PARTIAL_FLAG | $3f76ebf31bc08fc6$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $3f76ebf31bc08fc6$var$nativeMax($c9FP3(ary), 0);
    arity = arity === undefined ? arity : $c9FP3(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $3f76ebf31bc08fc6$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $2GK2O(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $cwwEL(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $3f76ebf31bc08fc6$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($3f76ebf31bc08fc6$var$WRAP_CURRY_FLAG | $3f76ebf31bc08fc6$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($3f76ebf31bc08fc6$var$WRAP_CURRY_FLAG | $3f76ebf31bc08fc6$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $3f76ebf31bc08fc6$var$WRAP_BIND_FLAG) var result = $g2n0U(func, bitmask, thisArg);
    else if (bitmask == $3f76ebf31bc08fc6$var$WRAP_CURRY_FLAG || bitmask == $3f76ebf31bc08fc6$var$WRAP_CURRY_RIGHT_FLAG) result = $c4AZN(func, bitmask, arity);
    else if ((bitmask == $3f76ebf31bc08fc6$var$WRAP_PARTIAL_FLAG || bitmask == ($3f76ebf31bc08fc6$var$WRAP_BIND_FLAG | $3f76ebf31bc08fc6$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $jvtoE(func, bitmask, thisArg, partials);
    else result = $cH1gk.apply(undefined, newData);
    var setter = data ? $a2rYh : $aaQGq;
    return $9Xy53(setter(result, newData), func, bitmask);
}
module.exports = $3f76ebf31bc08fc6$var$createWrap;

});
parcelRegister("a2rYh", function(module, exports) {

var $d7YnM = parcelRequire("d7YnM");

var $giyy7 = parcelRequire("giyy7");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $74efc9cc506f79cd$var$baseSetData = !$giyy7 ? $d7YnM : function(func, data) {
    $giyy7.set(func, data);
    return func;
};
module.exports = $74efc9cc506f79cd$var$baseSetData;

});
parcelRegister("giyy7", function(module, exports) {

var $hWTvf = parcelRequire("hWTvf");
/** Used to store function metadata. */ var $bdd9209418d26c19$var$metaMap = $hWTvf && new $hWTvf;
module.exports = $bdd9209418d26c19$var$metaMap;

});


parcelRegister("g2n0U", function(module, exports) {

var $9Ynu7 = parcelRequire("9Ynu7");

var $NROo8 = parcelRequire("NROo8");
/** Used to compose bitmasks for function metadata. */ var $baceaf422ce07d2d$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $baceaf422ce07d2d$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $baceaf422ce07d2d$var$WRAP_BIND_FLAG, Ctor = $9Ynu7(func);
    function wrapper() {
        var fn = this && this !== $NROo8 && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $baceaf422ce07d2d$var$createBind;

});
parcelRegister("9Ynu7", function(module, exports) {

var $b7PJS = parcelRequire("b7PJS");

var $546O5 = parcelRequire("546O5");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $742bef398141d3e4$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $b7PJS(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $546O5(result) ? result : thisBinding;
    };
}
module.exports = $742bef398141d3e4$var$createCtor;

});


parcelRegister("c4AZN", function(module, exports) {

var $euhRr = parcelRequire("euhRr");

var $9Ynu7 = parcelRequire("9Ynu7");

var $cH1gk = parcelRequire("cH1gk");

var $2Dlwo = parcelRequire("2Dlwo");

var $2Vf2k = parcelRequire("2Vf2k");

var $igl1D = parcelRequire("igl1D");

var $NROo8 = parcelRequire("NROo8");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $8ca28e5b53e280b6$var$createCurry(func, bitmask, arity) {
    var Ctor = $9Ynu7(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $2Vf2k(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $igl1D(args, placeholder);
        length -= holders.length;
        if (length < arity) return $2Dlwo(func, bitmask, $cH1gk, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $NROo8 && this instanceof wrapper ? Ctor : func;
        return $euhRr(fn, this, args);
    }
    return wrapper;
}
module.exports = $8ca28e5b53e280b6$var$createCurry;

});
parcelRegister("cH1gk", function(module, exports) {

var $ezJMS = parcelRequire("ezJMS");

var $4rcUK = parcelRequire("4rcUK");

var $k5Khj = parcelRequire("k5Khj");

var $9Ynu7 = parcelRequire("9Ynu7");

var $2Dlwo = parcelRequire("2Dlwo");

var $2Vf2k = parcelRequire("2Vf2k");

var $a7b4m = parcelRequire("a7b4m");

var $igl1D = parcelRequire("igl1D");

var $NROo8 = parcelRequire("NROo8");
/** Used to compose bitmasks for function metadata. */ var $93da7ad8a7a42da4$var$WRAP_BIND_FLAG = 1, $93da7ad8a7a42da4$var$WRAP_BIND_KEY_FLAG = 2, $93da7ad8a7a42da4$var$WRAP_CURRY_FLAG = 8, $93da7ad8a7a42da4$var$WRAP_CURRY_RIGHT_FLAG = 16, $93da7ad8a7a42da4$var$WRAP_ARY_FLAG = 128, $93da7ad8a7a42da4$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $93da7ad8a7a42da4$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $93da7ad8a7a42da4$var$WRAP_ARY_FLAG, isBind = bitmask & $93da7ad8a7a42da4$var$WRAP_BIND_FLAG, isBindKey = bitmask & $93da7ad8a7a42da4$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($93da7ad8a7a42da4$var$WRAP_CURRY_FLAG | $93da7ad8a7a42da4$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $93da7ad8a7a42da4$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $9Ynu7(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $2Vf2k(wrapper), holdersCount = $k5Khj(args, placeholder);
        if (partials) args = $ezJMS(args, partials, holders, isCurried);
        if (partialsRight) args = $4rcUK(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $igl1D(args, placeholder);
            return $2Dlwo(func, bitmask, $93da7ad8a7a42da4$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $a7b4m(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $NROo8 && this instanceof wrapper) fn = Ctor || $9Ynu7(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $93da7ad8a7a42da4$var$createHybrid;

});
parcelRegister("ezJMS", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a9c7d9f99568bc42$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $a9c7d9f99568bc42$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $a9c7d9f99568bc42$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $a9c7d9f99568bc42$var$composeArgs;

});

parcelRegister("4rcUK", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $33b3b387df37c056$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $33b3b387df37c056$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $33b3b387df37c056$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $33b3b387df37c056$var$composeArgsRight;

});

parcelRegister("k5Khj", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $ea082c2a0ce7847e$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $ea082c2a0ce7847e$var$countHolders;

});

parcelRegister("2Dlwo", function(module, exports) {

var $74osV = parcelRequire("74osV");

var $aaQGq = parcelRequire("aaQGq");

var $9Xy53 = parcelRequire("9Xy53");
/** Used to compose bitmasks for function metadata. */ var $1eafeafeb1f19224$var$WRAP_BIND_FLAG = 1, $1eafeafeb1f19224$var$WRAP_BIND_KEY_FLAG = 2, $1eafeafeb1f19224$var$WRAP_CURRY_BOUND_FLAG = 4, $1eafeafeb1f19224$var$WRAP_CURRY_FLAG = 8, $1eafeafeb1f19224$var$WRAP_PARTIAL_FLAG = 32, $1eafeafeb1f19224$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $1eafeafeb1f19224$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $1eafeafeb1f19224$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $1eafeafeb1f19224$var$WRAP_PARTIAL_FLAG : $1eafeafeb1f19224$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $1eafeafeb1f19224$var$WRAP_PARTIAL_RIGHT_FLAG : $1eafeafeb1f19224$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $1eafeafeb1f19224$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($1eafeafeb1f19224$var$WRAP_BIND_FLAG | $1eafeafeb1f19224$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($74osV(func)) $aaQGq(result, newData);
    result.placeholder = placeholder;
    return $9Xy53(result, func, bitmask);
}
module.exports = $1eafeafeb1f19224$var$createRecurry;

});
parcelRegister("74osV", function(module, exports) {

var $ab1mA = parcelRequire("ab1mA");

var $2GK2O = parcelRequire("2GK2O");

var $asy1v = parcelRequire("asy1v");

var $4ODiF = parcelRequire("4ODiF");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function $525be278ce84eab2$var$isLaziable(func) {
    var funcName = $asy1v(func), other = $4ODiF[funcName];
    if (typeof other != 'function' || !(funcName in $ab1mA.prototype)) return false;
    if (func === other) return true;
    var data = $2GK2O(other);
    return !!data && func === data[0];
}
module.exports = $525be278ce84eab2$var$isLaziable;

});
parcelRegister("ab1mA", function(module, exports) {

var $b7PJS = parcelRequire("b7PJS");

var $iSWBo = parcelRequire("iSWBo");
/** Used as references for the maximum length and index of an array. */ var $768bfd3243192c62$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function $768bfd3243192c62$var$LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = $768bfd3243192c62$var$MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
$768bfd3243192c62$var$LazyWrapper.prototype = $b7PJS($iSWBo.prototype);
$768bfd3243192c62$var$LazyWrapper.prototype.constructor = $768bfd3243192c62$var$LazyWrapper;
module.exports = $768bfd3243192c62$var$LazyWrapper;

});
parcelRegister("iSWBo", function(module, exports) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function $dbfaba4a3b3a815b$var$baseLodash() {
// No operation performed.
}
module.exports = $dbfaba4a3b3a815b$var$baseLodash;

});


parcelRegister("2GK2O", function(module, exports) {

var $giyy7 = parcelRequire("giyy7");

var $12DRg = parcelRequire("12DRg");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var $1f533870d3d62e5d$var$getData = !$giyy7 ? $12DRg : function(func) {
    return $giyy7.get(func);
};
module.exports = $1f533870d3d62e5d$var$getData;

});

parcelRegister("asy1v", function(module, exports) {

var $lPnRE = parcelRequire("lPnRE");
/** Used for built-in method references. */ var $79d6e934e9859363$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $79d6e934e9859363$var$hasOwnProperty = $79d6e934e9859363$var$objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function $79d6e934e9859363$var$getFuncName(func) {
    var result = func.name + '', array = $lPnRE[result], length = $79d6e934e9859363$var$hasOwnProperty.call($lPnRE, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = $79d6e934e9859363$var$getFuncName;

});
parcelRegister("lPnRE", function(module, exports) {
/** Used to lookup unminified function names. */ var $fe40df58a594c3c0$var$realNames = {};
module.exports = $fe40df58a594c3c0$var$realNames;

});


parcelRegister("4ODiF", function(module, exports) {

var $ab1mA = parcelRequire("ab1mA");

var $iTpII = parcelRequire("iTpII");

var $iSWBo = parcelRequire("iSWBo");

var $4sprp = parcelRequire("4sprp");

var $7gKgM = parcelRequire("7gKgM");

var $8gTTQ = parcelRequire("8gTTQ");
/** Used for built-in method references. */ var $381a5122a63b198d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $381a5122a63b198d$var$hasOwnProperty = $381a5122a63b198d$var$objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function $381a5122a63b198d$var$lodash(value) {
    if ($7gKgM(value) && !$4sprp(value) && !(value instanceof $ab1mA)) {
        if (value instanceof $iTpII) return value;
        if ($381a5122a63b198d$var$hasOwnProperty.call(value, '__wrapped__')) return $8gTTQ(value);
    }
    return new $iTpII(value);
}
// Ensure wrappers are instances of `baseLodash`.
$381a5122a63b198d$var$lodash.prototype = $iSWBo.prototype;
$381a5122a63b198d$var$lodash.prototype.constructor = $381a5122a63b198d$var$lodash;
module.exports = $381a5122a63b198d$var$lodash;

});
parcelRegister("iTpII", function(module, exports) {

var $b7PJS = parcelRequire("b7PJS");

var $iSWBo = parcelRequire("iSWBo");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function $dc11508658975546$var$LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
$dc11508658975546$var$LodashWrapper.prototype = $b7PJS($iSWBo.prototype);
$dc11508658975546$var$LodashWrapper.prototype.constructor = $dc11508658975546$var$LodashWrapper;
module.exports = $dc11508658975546$var$LodashWrapper;

});

parcelRegister("8gTTQ", function(module, exports) {

var $ab1mA = parcelRequire("ab1mA");

var $iTpII = parcelRequire("iTpII");

var $k4ZVz = parcelRequire("k4ZVz");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function $605b2de1cde3289a$var$wrapperClone(wrapper) {
    if (wrapper instanceof $ab1mA) return wrapper.clone();
    var result = new $iTpII(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = $k4ZVz(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = $605b2de1cde3289a$var$wrapperClone;

});



parcelRegister("aaQGq", function(module, exports) {

var $a2rYh = parcelRequire("a2rYh");

var $lwJMm = parcelRequire("lwJMm");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $7683b460bcb9d85a$var$setData = $lwJMm($a2rYh);
module.exports = $7683b460bcb9d85a$var$setData;

});

parcelRegister("9Xy53", function(module, exports) {

var $203bp = parcelRequire("203bp");

var $3MdBK = parcelRequire("3MdBK");

var $hC3zk = parcelRequire("hC3zk");

var $ir5Tb = parcelRequire("ir5Tb");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $74040f7269ff23b2$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $hC3zk(wrapper, $3MdBK(source, $ir5Tb($203bp(source), bitmask)));
}
module.exports = $74040f7269ff23b2$var$setWrapToString;

});
parcelRegister("203bp", function(module, exports) {
/** Used to match wrap detail comments. */ var $174e0cec8eb70bd8$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $174e0cec8eb70bd8$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $174e0cec8eb70bd8$var$getWrapDetails(source) {
    var match = source.match($174e0cec8eb70bd8$var$reWrapDetails);
    return match ? match[1].split($174e0cec8eb70bd8$var$reSplitDetails) : [];
}
module.exports = $174e0cec8eb70bd8$var$getWrapDetails;

});

parcelRegister("3MdBK", function(module, exports) {
/** Used to match wrap detail comments. */ var $2c0069004514128b$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $2c0069004514128b$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($2c0069004514128b$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = $2c0069004514128b$var$insertWrapDetails;

});

parcelRegister("ir5Tb", function(module, exports) {

var $ez1ap = parcelRequire("ez1ap");

var $40QQB = parcelRequire("40QQB");
/** Used to compose bitmasks for function metadata. */ var $d6bf510ea94c7fd0$var$WRAP_BIND_FLAG = 1, $d6bf510ea94c7fd0$var$WRAP_BIND_KEY_FLAG = 2, $d6bf510ea94c7fd0$var$WRAP_CURRY_FLAG = 8, $d6bf510ea94c7fd0$var$WRAP_CURRY_RIGHT_FLAG = 16, $d6bf510ea94c7fd0$var$WRAP_PARTIAL_FLAG = 32, $d6bf510ea94c7fd0$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $d6bf510ea94c7fd0$var$WRAP_ARY_FLAG = 128, $d6bf510ea94c7fd0$var$WRAP_REARG_FLAG = 256, $d6bf510ea94c7fd0$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $d6bf510ea94c7fd0$var$wrapFlags = [
    [
        'ary',
        $d6bf510ea94c7fd0$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $d6bf510ea94c7fd0$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $d6bf510ea94c7fd0$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $d6bf510ea94c7fd0$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $d6bf510ea94c7fd0$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $d6bf510ea94c7fd0$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $d6bf510ea94c7fd0$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $d6bf510ea94c7fd0$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $d6bf510ea94c7fd0$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $d6bf510ea94c7fd0$var$updateWrapDetails(details, bitmask) {
    $ez1ap($d6bf510ea94c7fd0$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$40QQB(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $d6bf510ea94c7fd0$var$updateWrapDetails;

});



parcelRegister("2Vf2k", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $220c9196afcdb55f$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $220c9196afcdb55f$var$getHolder;

});

parcelRegister("a7b4m", function(module, exports) {

var $k4ZVz = parcelRequire("k4ZVz");

var $cn6El = parcelRequire("cn6El");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $75d324f3b7911cb9$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $75d324f3b7911cb9$var$reorder(array, indexes) {
    var arrLength = array.length, length = $75d324f3b7911cb9$var$nativeMin(indexes.length, arrLength), oldArray = $k4ZVz(array);
    while(length--){
        var index = indexes[length];
        array[length] = $cn6El(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $75d324f3b7911cb9$var$reorder;

});

parcelRegister("igl1D", function(module, exports) {
/** Used as the internal argument placeholder. */ var $d4ba07cf1f9b78fa$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $d4ba07cf1f9b78fa$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $d4ba07cf1f9b78fa$var$PLACEHOLDER) {
            array[index] = $d4ba07cf1f9b78fa$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $d4ba07cf1f9b78fa$var$replaceHolders;

});



parcelRegister("jvtoE", function(module, exports) {

var $euhRr = parcelRequire("euhRr");

var $9Ynu7 = parcelRequire("9Ynu7");

var $NROo8 = parcelRequire("NROo8");
/** Used to compose bitmasks for function metadata. */ var $e337b71cb44dfaa7$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $e337b71cb44dfaa7$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $e337b71cb44dfaa7$var$WRAP_BIND_FLAG, Ctor = $9Ynu7(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $NROo8 && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $euhRr(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $e337b71cb44dfaa7$var$createPartial;

});

parcelRegister("cwwEL", function(module, exports) {

var $ezJMS = parcelRequire("ezJMS");

var $4rcUK = parcelRequire("4rcUK");

var $igl1D = parcelRequire("igl1D");
/** Used as the internal argument placeholder. */ var $91e1ce1c3a678ca9$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $91e1ce1c3a678ca9$var$WRAP_BIND_FLAG = 1, $91e1ce1c3a678ca9$var$WRAP_BIND_KEY_FLAG = 2, $91e1ce1c3a678ca9$var$WRAP_CURRY_BOUND_FLAG = 4, $91e1ce1c3a678ca9$var$WRAP_CURRY_FLAG = 8, $91e1ce1c3a678ca9$var$WRAP_ARY_FLAG = 128, $91e1ce1c3a678ca9$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $91e1ce1c3a678ca9$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $91e1ce1c3a678ca9$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($91e1ce1c3a678ca9$var$WRAP_BIND_FLAG | $91e1ce1c3a678ca9$var$WRAP_BIND_KEY_FLAG | $91e1ce1c3a678ca9$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $91e1ce1c3a678ca9$var$WRAP_ARY_FLAG && bitmask == $91e1ce1c3a678ca9$var$WRAP_CURRY_FLAG || srcBitmask == $91e1ce1c3a678ca9$var$WRAP_ARY_FLAG && bitmask == $91e1ce1c3a678ca9$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($91e1ce1c3a678ca9$var$WRAP_ARY_FLAG | $91e1ce1c3a678ca9$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $91e1ce1c3a678ca9$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $91e1ce1c3a678ca9$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $91e1ce1c3a678ca9$var$WRAP_BIND_FLAG ? 0 : $91e1ce1c3a678ca9$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $ezJMS(partials, value, source[4]) : value;
        data[4] = partials ? $igl1D(data[3], $91e1ce1c3a678ca9$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $4rcUK(partials, value, source[6]) : value;
        data[6] = partials ? $igl1D(data[5], $91e1ce1c3a678ca9$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $91e1ce1c3a678ca9$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $91e1ce1c3a678ca9$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $91e1ce1c3a678ca9$var$mergeData;

});



parcelRegister("1LiX8", function(module, exports) {

var $2yYrH = parcelRequire("2yYrH");
/** Used to compose bitmasks for cloning. */ var $1488e1dd9ca91d5e$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $1488e1dd9ca91d5e$var$clone(value) {
    return $2yYrH(value, $1488e1dd9ca91d5e$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $1488e1dd9ca91d5e$var$clone;

});

parcelRegister("fLExA", function(module, exports) {

var $5rOR1 = parcelRequire("5rOR1");
/** Used to compose bitmasks for function metadata. */ var $b7aab1547651f449$var$WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function $b7aab1547651f449$var$curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $5rOR1(func, $b7aab1547651f449$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $b7aab1547651f449$var$curry.placeholder;
    return result;
}
// Assign default placeholders.
$b7aab1547651f449$var$curry.placeholder = {};
module.exports = $b7aab1547651f449$var$curry;

});

parcelRegister("cvRyD", function(module, exports) {

var $1O9y6 = parcelRequire("1O9y6");

var $7gKgM = parcelRequire("7gKgM");

var $dtLJW = parcelRequire("dtLJW");
/** `Object#toString` result references. */ var $91c1ecb3cf661a45$var$domExcTag = '[object DOMException]', $91c1ecb3cf661a45$var$errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $91c1ecb3cf661a45$var$isError(value) {
    if (!$7gKgM(value)) return false;
    var tag = $1O9y6(value);
    return tag == $91c1ecb3cf661a45$var$errorTag || tag == $91c1ecb3cf661a45$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$dtLJW(value);
}
module.exports = $91c1ecb3cf661a45$var$isError;

});

parcelRegister("9CL26", function(module, exports) {

var $PodIB = parcelRequire("PodIB");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $701c256fde753cf0$var$weakMapTag = '[object WeakMap]';
/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function $701c256fde753cf0$var$isWeakMap(value) {
    return $7gKgM(value) && $PodIB(value) == $701c256fde753cf0$var$weakMapTag;
}
module.exports = $701c256fde753cf0$var$isWeakMap;

});

parcelRegister("c4kBg", function(module, exports) {

var $2yYrH = parcelRequire("2yYrH");

var $1lM9j = parcelRequire("1lM9j");
/** Used to compose bitmasks for cloning. */ var $8c95d67d9a1a04e2$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function $8c95d67d9a1a04e2$var$iteratee(func) {
    return $1lM9j(typeof func == 'function' ? func : $2yYrH(func, $8c95d67d9a1a04e2$var$CLONE_DEEP_FLAG));
}
module.exports = $8c95d67d9a1a04e2$var$iteratee;

});

parcelRegister("7GIya", function(module, exports) {

var $5rOR1 = parcelRequire("5rOR1");

var $lgI96 = parcelRequire("lgI96");
/** Used to compose bitmasks for function metadata. */ var $598f035cd6aae5ff$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var $598f035cd6aae5ff$var$rearg = $lgI96(function(func, indexes) {
    return $5rOR1(func, $598f035cd6aae5ff$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});
module.exports = $598f035cd6aae5ff$var$rearg;

});

parcelRegister("lDisb", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $k4ZVz = parcelRequire("k4ZVz");

var $4sprp = parcelRequire("4sprp");

var $9D78T = parcelRequire("9D78T");

var $Kx0EO = parcelRequire("Kx0EO");

var $9IlW0 = parcelRequire("9IlW0");

var $cz1WF = parcelRequire("cz1WF");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $fbfb8df8d599b4dd$var$toPath(value) {
    if ($4sprp(value)) return $lylkU(value, $9IlW0);
    return $9D78T(value) ? [
        value
    ] : $k4ZVz($Kx0EO($cz1WF(value)));
}
module.exports = $fbfb8df8d599b4dd$var$toPath;

});



parcelRegister("tGEEK", function(module, exports) {

var $9aiYx = parcelRequire("9aiYx");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $0593cbe44b472276$var$range = $9aiYx();
module.exports = $0593cbe44b472276$var$range;

});
parcelRegister("9aiYx", function(module, exports) {

var $8diOj = parcelRequire("8diOj");

var $eA1it = parcelRequire("eA1it");

var $dbRic = parcelRequire("dbRic");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $6ac3c455ec7464cf$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $eA1it(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $dbRic(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $dbRic(end);
        step = step === undefined ? start < end ? 1 : -1 : $dbRic(step);
        return $8diOj(start, end, step, fromRight);
    };
}
module.exports = $6ac3c455ec7464cf$var$createRange;

});
parcelRegister("8diOj", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5fae20fab3dfdbe9$var$nativeCeil = Math.ceil, $5fae20fab3dfdbe9$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $5fae20fab3dfdbe9$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $5fae20fab3dfdbe9$var$nativeMax($5fae20fab3dfdbe9$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $5fae20fab3dfdbe9$var$baseRange;

});





parcelRegister("hPlDs", function(module, exports) {

$parcel$export(module.exports, "useExpandableEntryPointTrigger", () => $e9a162c6ea5442b5$export$569294f6ae10bba9);

var $eJOHy = parcelRequire("eJOHy");

var $ciFJV = parcelRequire("ciFJV");
const $e9a162c6ea5442b5$export$569294f6ae10bba9 = (actions, isActive = true)=>{
    // We don't want the click-handler, as ExpandableMenuItem handles the entry-point loading itself
    const eventMap = (0, $eJOHy.useMemo)(()=>Object.fromEntries(Object.entries((0, $ciFJV.getDefaultEntrypointActionEventMap)(actions)).filter(([key])=>key !== 'click')), [
        actions
    ]);
    return (0, $ciFJV.useEntryPointButtonTrigger)(actions, isActive, eventMap);
};

});
parcelRegister("ciFJV", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $a303ea90dc94fcd0$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $a303ea90dc94fcd0$export$5f13515bd3a35325);

var $eJOHy = parcelRequire("eJOHy");

var $5uU9O = parcelRequire("5uU9O");
const $a303ea90dc94fcd0$export$25d2524a63315ed = (actions, isActive = true, eventMap)=>{
    const removePreviousListeners = (0, $eJOHy.useRef)(null);
    const isMounted = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $eJOHy.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        const elementEventMap = eventMap || $a303ea90dc94fcd0$export$5f13515bd3a35325(actions);
        if (element && isActive) {
            (0, $5uU9O.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: elementEventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $5uU9O.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: elementEventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        actions,
        eventMap,
        isActive
    ]);
};
const $a303ea90dc94fcd0$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("5uU9O", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $c2dcdcc6b465938f$export$15257a36a7e3f9d6);
function $c2dcdcc6b465938f$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});



parcelRegister("hHXEn", function(module, exports) {

$parcel$export(module.exports, "ExploreMoreApps", () => $05fadd606d9b1924$export$e3e10d2adcb07330);

var $eJOHy = parcelRequire("eJOHy");

var $ee8U1 = parcelRequire("ee8U1");



var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $2QH3X = parcelRequire("2QH3X");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $lvKO5 = parcelRequire("lvKO5");

var $epTsa = parcelRequire("epTsa");

var $jTGoK = parcelRequire("jTGoK");
const $05fadd606d9b1924$var$pathToNavigate = '/jira/marketplace/discover';
function $05fadd606d9b1924$export$e3e10d2adcb07330() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = tenantContext;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $jTGoK.default).exploreMoreApps, (0, (/*@__PURE__*/$parcel$interopDefault($ee8U1))));
    const onClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_APPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                itemId: 'exploreMoreApps'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const showExploreMoreApps = isAdmin || isSiteAdmin ? (0, $epTsa.expVal)('emcee-discover', 'value', true) : (0, $epTsa.expVal)('enduser-emcee-discover', 'value', true);
    if (!showExploreMoreApps) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        elemBefore: icon,
        href: $05fadd606d9b1924$var$pathToNavigate,
        menuId: (0, $h4Bzb.MENU_ID_APP_MARKETPLACE_DISCOVER),
        onClick: onClick
    }, formattedMessage);
}

});
parcelRegister("jTGoK", function(module, exports) {

$parcel$export(module.exports, "default", () => $314a228bd353c42e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $314a228bd353c42e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    exploreMoreApps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.explore-more-apps.explore-more-apps",
        "defaultMessage": "Explore more apps"
    }
});

});


const $a9b3358f09bdf564$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Apps';
const $a9b3358f09bdf564$export$d57b6b390e78d90f = 'smite';

parcelRegister("669uo", function(module, exports) {

$parcel$export(module.exports, "createAttributes", () => $058f0c753f7617b4$export$c7c9603a6b1fd815);

var $7jTnu = parcelRequire("7jTnu");

var $8KUFq = parcelRequire("8KUFq");

var $hWeHP = parcelRequire("hWeHP");
const $058f0c753f7617b4$var$isSynthetic = ()=>// Filter out synthetic tests using all known ways
    (0, $hWeHP.default)('ajs-is-synthetic') === 'true' || (0, $7jTnu.fg)('forge_ui_synthetic_check');
const $058f0c753f7617b4$var$FAILED_TO_FETCH = 'FAILED_TO_FETCH';
const $058f0c753f7617b4$var$getErrorType = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ((0, $8KUFq.isClientFetchError)(error)) return $058f0c753f7617b4$var$FAILED_TO_FETCH;
    return 'OTHER';
};
const $058f0c753f7617b4$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $058f0c753f7617b4$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: $058f0c753f7617b4$var$isSynthetic(),
        isSSR: false
    };
    if (rawAttributes) {
        const { error: error } = rawAttributes;
        if (error) {
            attributes.error = $058f0c753f7617b4$export$78c6267359db7e73(error);
            attributes.errorType = $058f0c753f7617b4$var$getErrorType(error);
        }
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});

parcelRegister("cjf2i", function(module, exports) {

$parcel$export(module.exports, "asyncNav4AppsContentViewQuery", () => $957f8b09c88792fa$export$3cc582e017e659a5);

var $1Iuce = parcelRequire("1Iuce");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $957f8b09c88792fa$export$3cc582e017e659a5 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("c12Ma")).then(({ Nav4AppsContentViewQuery: Nav4AppsContentViewQuery })=>Nav4AppsContentViewQuery), {
        moduleId: "5e1e3d10",
        moduleName: "Nav4AppsContentViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                apps: {
                    parameters: $1Iuce.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("1Iuce", function(module, exports) {

$parcel$export(module.exports, "default", () => $86bfdbbb9ef5550d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a797f95d565e272b64c867b7e10016a>>
 * @relayHash 3ad9de847a73c165c119877312ac8b41
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7e949716a36a3b7276a3e0c3e396a35d07392bc693f41443586e94aec2d3222b
const $86bfdbbb9ef5550d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "label"
    }, v2 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v3 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4AppsContentViewQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "Nav4AppsContent"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4AppsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraNavigationItemConnection",
                            "kind": "LinkedField",
                            "name": "globalAppNavigationItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNavigationItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "envLabel"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "iconUrl"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraAppSection",
                                                            "kind": "LinkedField",
                                                            "name": "sections",
                                                            "plural": true,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "links",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v3 /*: any*/ ,
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "settingsUrl"
                                                        },
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "JiraAppNavigationItem"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7e949716a36a3b7276a3e0c3e396a35d07392bc693f41443586e94aec2d3222b",
            "metadata": {},
            "name": "Nav4AppsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$86bfdbbb9ef5550d$var$node.hash = "157a8cfe104b1d671cc09c5f8aee481a";
var $86bfdbbb9ef5550d$export$2e2bcd8739ae039 = $86bfdbbb9ef5550d$var$node;

});

parcelRegister("c12Ma", function(module, exports) {

let $8bf7bb3e37a25e0d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8bf7bb3e37a25e0d$var$load("byoKo").then(()=>parcelRequire('5PH0x'));

});



parcelRegister("7adq7", function(module, exports) {

$parcel$export(module.exports, "Nav4AppsForLanding", () => $0c6527fdf5cdadff$export$889c9c34c80104b2);

var $9kXcU = parcelRequire("9kXcU");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");


var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $80rA3 = parcelRequire("80rA3");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $azEgq = parcelRequire("azEgq");

var $eL2Ux = parcelRequire("eL2Ux");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $16sa1 = parcelRequire("16sa1");

var $7jTnu = parcelRequire("7jTnu");

var $hHXEn = parcelRequire("hHXEn");

var $83taL = parcelRequire("83taL");
function $0c6527fdf5cdadff$export$889c9c34c80104b2(props) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).APPS);
    const data = (0, $j4oe4.useFragment)((0, $9kXcU.default), queryRef);
    const menuId = (0, $h4Bzb.MENU_ID_APPS);
    const handleExpansionToggle = (hasExpanded)=>{
        if (hasExpanded) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $8IuE5.L1_MENU_ID).APPS);
            (0, $gCeeo.fireUIAnalytics)(event, (0, $a9aec.SECTION_ITEM_APPS), {
                isInMore: isInMore
            });
        }
    };
    // Feature gate: wrap with useCallback if enabled
    const onExpansionToggle = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)(handleExpansionToggle, [
        createAnalyticsEvent,
        moreMenuIds
    ]) : handleExpansionToggle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon + text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $azEgq.getTestId)(menuId),
        interactionName: (0, $7jTnu.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-apps-landing' : undefined
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4-sidebar-apps-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $83taL.Nav4AppsContent), {
        queryRef: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hHXEn.ExploreMoreApps), null))));
}

});
parcelRegister("9kXcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e9bcd8f158b38c0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<43a8cee8bfdf430e242ac6d6e2f5e807>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3e9bcd8f158b38c0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4AppsForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4AppsContent"
        }
    ],
    "type": "JiraQuery"
};
$3e9bcd8f158b38c0$var$node.hash = "9c28cb4a0c92a920a58010f91f4f4f0e";
var $3e9bcd8f158b38c0$export$2e2bcd8739ae039 = $3e9bcd8f158b38c0$var$node;

});

parcelRegister("83taL", function(module, exports) {

$parcel$export(module.exports, "Nav4AppsContent", () => $030ccf9c6a99c297$export$aaf45d195a81792d);

var $fB4IQ = parcelRequire("fB4IQ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2y3Ci = parcelRequire("2y3Ci");
var $ilbtc = parcelRequire("ilbtc");
var $1swHh = parcelRequire("1swHh");
var $jLuq7 = parcelRequire("jLuq7");

var $7jTnu = parcelRequire("7jTnu");

var $aeOhE = parcelRequire("aeOhE");

var $1DW20 = parcelRequire("1DW20");

var $fohjD = parcelRequire("fohjD");

var $lRq8t = parcelRequire("lRq8t");

var $5RW99 = parcelRequire("5RW99");

var $bCMeR = parcelRequire("bCMeR");

var $d51SR = parcelRequire("d51SR");

var $ja8Li = parcelRequire("ja8Li");

var $diXvx = parcelRequire("diXvx");
function $030ccf9c6a99c297$export$aaf45d195a81792d({ queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $fB4IQ.default), queryRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const menuItemNodes = (0, $eJOHy.useMemo)(()=>(data?.globalAppNavigationItems?.edges || []).filter((edge)=>{
            // Keep only Forge and Connect apps on the list
            if (edge?.node?.appType !== 'CONNECT' && edge?.node?.appType !== 'FORGE') return false;
            // Filter out system apps just like it was done in the old navigation
            return edge?.node?.appId !== (0, $5RW99.ADDON_ID).DISCOVER;
        }).map((edge)=>edge?.node).sort((a, b)=>(a?.label || '').localeCompare(b?.label || '')) || [], [
        data?.globalAppNavigationItems
    ]);
    const renderedMenuItems = (0, $eJOHy.useMemo)(()=>menuItemNodes.map((node)=>{
            switch(node?.appType){
                case 'CONNECT':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d51SR.Nav4ConnectMenuItem), {
                        key: node.id,
                        queryRef: node
                    });
                case 'FORGE':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ja8Li.Nav4ForgeMenuItem), {
                        key: node.id,
                        queryRef: node
                    });
                default:
                    return null;
            }
        }).filter(Boolean), [
        menuItemNodes
    ]);
    const hasForgeApps = (0, $eJOHy.useMemo)(()=>menuItemNodes.some((node)=>node?.appType === 'FORGE'), [
        menuItemNodes
    ]);
    return renderedMenuItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($030ccf9c6a99c297$var$ForgeAnalyticsWrapper, {
        shouldReport: hasForgeApps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLuq7.MenuSectionHeading), null, formatMessage((0, $diXvx.default).yourApps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, renderedMenuItems, hasForgeApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $fohjD.GLOBAL_PAGE_MODULE)
        }
    })))), (0, $7jTnu.fg)('jira_nav4_apps_menu_recommend') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bCMeR.AsyncDiscoverSection), null) : null) : null;
}
function $030ccf9c6a99c297$var$ForgeAnalyticsWrapper({ shouldReport: shouldReport, children: children }) {
    return shouldReport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1DW20.TriggerAnalyticsWrapper), null, children) : children;
}

});
parcelRegister("fB4IQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5cd2f0149ca9216$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ddb8a1bbce6fff611878abb761dbf404>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d5cd2f0149ca9216$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4AppsContent",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraNavigationItemConnection",
            "kind": "LinkedField",
            "name": "globalAppNavigationItems",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraNavigationItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            "action": "THROW",
                                            "path": "globalAppNavigationItems.edges.node.id"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appType"
                                                }
                                            ],
                                            "type": "JiraAppNavigationItem"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "Nav4ConnectMenuItem"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "Nav4ForgeMenuItem"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "globalAppNavigationItems.edges.node"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "globalAppNavigationItems.edges"
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$d5cd2f0149ca9216$var$node.hash = "6074e52ca012374d836fe32977dd1a14";
var $d5cd2f0149ca9216$export$2e2bcd8739ae039 = $d5cd2f0149ca9216$var$node;

});

parcelRegister("1swHh", function(module, exports) {

$parcel$export(module.exports, "MenuSection", () => $717ed09abd1646e2$export$4b1545b4f2016d26);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gdEz9 = parcelRequire("gdEz9");

var $ilbtc = parcelRequire("ilbtc");

var $6wTpU = parcelRequire("6wTpU");
const $717ed09abd1646e2$export$4b1545b4f2016d26 = ({ children: children, testId: testId, isMenuListItem: isMenuListItem = false })=>{
    const id = (0, $gdEz9.useId)();
    const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6wTpU.MenuSectionContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            role: "group",
            "aria-labelledby": `${id}-heading`,
            children: children
        })
    });
    if (isMenuListItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ilbtc.MenuListItem), {
        testId: testId,
        children: content
    });
    // Legacy. isMenuListItem should become default.
    return content;
};

});
parcelRegister("6wTpU", function(module, exports) {

$parcel$export(module.exports, "MenuSectionContext", () => $f6807208f6895935$export$728ac99b9c7eea8a);
$parcel$export(module.exports, "useMenuSectionContext", () => $f6807208f6895935$export$8100cda602411810);

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");
const $f6807208f6895935$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $f6807208f6895935$export$8100cda602411810 = ()=>{
    const context = (0, $eJOHy.useContext)($f6807208f6895935$export$728ac99b9c7eea8a);
    (0, $8GOss.default)(context, 'useMenuSectionContext must be used within a MenuSection');
    return context;
};

});


parcelRegister("jLuq7", function(module, exports) {

$parcel$export(module.exports, "MenuSectionHeading", () => $3bb96527dbb0c9a7$export$5d3acdbf9237a364);
/* menu-section-heading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6wTpU = parcelRequire("6wTpU");
const $3bb96527dbb0c9a7$var$styles = {
    root: "_11c81vhk _1rjcu2gc _syaz131l _bozg12x7"
};
const $3bb96527dbb0c9a7$export$5d3acdbf9237a364 = ({ children: children })=>{
    const id = (0, $6wTpU.useMenuSectionContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("h2", {
        id: `${id}-heading`,
        className: (0, $hcewu.default)([
            $3bb96527dbb0c9a7$var$styles.root
        ]),
        children: children
    });
};

});

parcelRegister("aeOhE", function(module, exports) {

$parcel$export(module.exports, "ForgeScreenEvent", () => $4abbcb40e7d1f348$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $4abbcb40e7d1f348$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $4abbcb40e7d1f348$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $4abbcb40e7d1f348$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $4abbcb40e7d1f348$export$14e56d7f5d3f917c);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $fohjD = parcelRequire("fohjD");

var $av1az = parcelRequire("av1az");

var $cud6T = parcelRequire("cud6T");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");
var $8Plmb = parcelRequire("8Plmb");

var $7jTnu = parcelRequire("7jTnu");

var $9gq2c = parcelRequire("9gq2c");

var $lHVmb = parcelRequire("lHVmb");

var $33OIs = parcelRequire("33OIs");

var $52lsd = parcelRequire("52lsd");

var $ibOCX = parcelRequire("ibOCX");

var $lHD3D = parcelRequire("lHD3D");
const $4abbcb40e7d1f348$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
        attributes: (0, $lHVmb.createAttributes)(attributes)
    });
const $4abbcb40e7d1f348$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $33OIs.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $4abbcb40e7d1f348$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $cud6T.useHasForgeAccess)();
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>(0, $lHVmb.createAttributes)({
            ...attributes,
            hasForgeAccess: hasForgeAccess
        }), [
        attributes,
        hasForgeAccess
    ]);
    const fireEvent = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, (0, $ibOCX.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Plmb.MountEvent), {
        onMount: fireEvent
    });
};
const $4abbcb40e7d1f348$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: `${(0, $9gq2c.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
const $4abbcb40e7d1f348$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $eJOHy.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $eJOHy.useCallback)((error)=>(0, $lHVmb.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $9gq2c.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
const $4abbcb40e7d1f348$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $9gq2c.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    }) : (0, $ibOCX.getEventIdOld)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>(0, $lHVmb.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4abbcb40e7d1f348$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4abbcb40e7d1f348$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4abbcb40e7d1f348$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
function $4abbcb40e7d1f348$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    if ((extensionModule === (0, $fohjD.CUSTOM_FIELD_MODULE) || extensionModule === (0, $fohjD.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $fohjD.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
        (0, $fohjD.GLOBAL_PAGE_MODULE),
        (0, $fohjD.ISSUE_ACTION_MODULE),
        (0, $fohjD.ISSUE_ACTIVITY_MODULE),
        (0, $fohjD.ISSUE_CONTEXT_MODULE),
        (0, $fohjD.ISSUE_GLANCE_MODULE),
        (0, $fohjD.ISSUE_NAVIGATOR_ACTION_MODULE),
        (0, $fohjD.ISSUE_PANEL_MODULE),
        (0, $fohjD.CUSTOM_FIELD_MODULE),
        (0, $fohjD.CUSTOM_FIELD_TYPE_MODULE),
        (0, $fohjD.PROJECT_PAGE_MODULE),
        (0, $fohjD.ADMIN_PAGE_MODULE),
        (0, $fohjD.PROJECT_SETTINGS_PAGE_MODULE),
        (0, $fohjD.BACKLOG_ACTION_MODULE),
        (0, $fohjD.BOARD_ACTION_MODULE),
        (0, $fohjD.SPRINT_ACTION_MODULE),
        (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE)
    ].includes(extensionModule);
}
const $4abbcb40e7d1f348$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const startTime = (0, $eJOHy.useRef)(performance.now());
        const isCustomUI = (0, $av1az.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $eJOHy.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: module,
            entryPoint: entryPoint
        }) : (0, $ibOCX.getEventIdOld)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $av1az.getForgeUIType)(extension, entryPoint)
        }) : (0, $ibOCX.getBrowserMetricsEventIdOld)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $av1az.getForgeUIType)(extension, entryPoint)
        });
        const attributes = (0, $eJOHy.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $52lsd.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        (0, $eJOHy.useEffect)(()=>{
            if (!$4abbcb40e7d1f348$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, $lHD3D.forgeModulesConcurrentLoadTime)(extensionId).start({
                startTime: startTime.current
            });
        }, // We want to run this code only once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
        const onError = (0, $eJOHy.useCallback)(()=>{
            extensionId && (0, $lHD3D.forgeModulesConcurrentLoadTime)(extensionId).cancel();
        }, [
            extensionId
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $eJOHy.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                extensionId && (0, $lHD3D.forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            } else {
                onError();
                (0, $33OIs.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            browserMetricsEventId,
            onError,
            eventId,
            attributes
        ]);
        const onLoadCustomUiWithMetrics = (0, $eJOHy.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            extensionId && (0, $lHD3D.forgeModulesConcurrentLoadTime)(extensionId).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
        // SMT-1418
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            analyticsAttributes,
            extensionId,
            localId,
            onLoad
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4abbcb40e7d1f348$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4abbcb40e7d1f348$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("av1az", function(module, exports) {

$parcel$export(module.exports, "getForgeUIType", () => $8a41fb63fc571efc$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $8a41fb63fc571efc$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $8a41fb63fc571efc$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $8a41fb63fc571efc$export$42b85bc9b386c977);

var $8dH3d = parcelRequire("8dH3d");
const $8a41fb63fc571efc$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $8a41fb63fc571efc$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$8a41fb63fc571efc$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $8a41fb63fc571efc$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$8a41fb63fc571efc$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $8a41fb63fc571efc$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(propsToOverride)) return extension;
    const { resource: resource } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        }
    }; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (resource != null) extensionCopy.properties.resource = resource;
    return extensionCopy;
};

});

parcelRegister("cud6T", function(module, exports) {

$parcel$export(module.exports, "useHasForgeAccess", () => $5053d91b1becffd4$export$fd7f94d3d2bac7f2);

var $cECwI = parcelRequire("cECwI");
const $5053d91b1becffd4$export$fd7f94d3d2bac7f2 = ()=>{
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    return !isAnonymous;
};

});

parcelRegister("iqtgH", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $57f94b33c65bff71$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $57f94b33c65bff71$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $57f94b33c65bff71$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $57f94b33c65bff71$export$2ccf161b817b43b);

var $eJOHy = parcelRequire("eJOHy");

var $aN4Pk = parcelRequire("aN4Pk");


var $gCeeo = parcelRequire("gCeeo");
// eslint-disable-next-line jira/react/no-class-components
class $57f94b33c65bff71$var$FireComponent extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $gCeeo.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $57f94b33c65bff71$export$64eb47d7b94ba089 = (0, $aN4Pk.default)()($57f94b33c65bff71$var$FireComponent);
const $57f94b33c65bff71$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($57f94b33c65bff71$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $466f60259c330878$export$a1562d08625f5d7e)
    });
const $57f94b33c65bff71$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($57f94b33c65bff71$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $466f60259c330878$export$947dac6c72b26f81)
    });
const $57f94b33c65bff71$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($57f94b33c65bff71$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $466f60259c330878$export$12346a674644c156)
    });
const $57f94b33c65bff71$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($57f94b33c65bff71$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $466f60259c330878$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});

parcelRegister("8Plmb", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $f3ba52c72c0dd7e4$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $aN4Pk = parcelRequire("aN4Pk");
// eslint-disable-next-line jira/react/no-class-components
class $f3ba52c72c0dd7e4$var$MountEventComponent extends (0, $eJOHy.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $f3ba52c72c0dd7e4$export$2c6963927dbc68f1 = (0, $aN4Pk.default)()($f3ba52c72c0dd7e4$var$MountEventComponent);

});

parcelRegister("33OIs", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $e7e060e319be1e54$export$add44f896fb31ba3);

var $9gq2c = parcelRequire("9gq2c");

var $1GZq2 = parcelRequire("1GZq2");
const $e7e060e319be1e54$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $1GZq2.fireOperationalEvent)((0, $9gq2c.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});

parcelRegister("52lsd", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $002703e17238e395$export$5d3b06ab08af139e);

var $av1az = parcelRequire("av1az");

var $ePLco = parcelRequire("ePLco");
const $002703e17238e395$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $av1az.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType
    };
};

});

parcelRegister("ibOCX", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $0853041cadec7561$export$5639f6a927500d9);
$parcel$export(module.exports, "getEventIdOld", () => $0853041cadec7561$export$b2919e256f1e5dfc);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $0853041cadec7561$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getBrowserMetricsEventIdOld", () => $0853041cadec7561$export$66db5d4145894f38);
$parcel$export(module.exports, "getEventActionName", () => $0853041cadec7561$export$644ccb9a67b9a9c1);

var $fohjD = parcelRequire("fohjD");

var $5IiZP = parcelRequire("5IiZP");

var $9gq2c = parcelRequire("9gq2c");
const $0853041cadec7561$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $0853041cadec7561$var$prepareModuleMode = (entryPoint)=>`${$0853041cadec7561$var$capitalizeFirstLetter(entryPoint)}`;
const $0853041cadec7561$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $0853041cadec7561$var$prepareModuleName = (moduleName)=>(0, $fohjD.SUPPORTED_MODULES).includes(moduleName) ? $0853041cadec7561$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $0853041cadec7561$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $9gq2c.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}${eventNamePostfix}`);
    return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}${$0853041cadec7561$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $0853041cadec7561$export$b2919e256f1e5dfc = ({ module: module, moduleType: moduleType = (0, $9gq2c.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}${$0853041cadec7561$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $0853041cadec7561$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}-${forgeUiType}`);
    return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}${$0853041cadec7561$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $0853041cadec7561$export$66db5d4145894f38 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}${$0853041cadec7561$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $0853041cadec7561$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $9gq2c.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});


parcelRegister("1DW20", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $e508c293944e9913$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $e508c293944e9913$export$e1a79e3d472c925a);

var $eJOHy = parcelRequire("eJOHy");

var $fohjD = parcelRequire("fohjD");

var $aeOhE = parcelRequire("aeOhE");

var $9gq2c = parcelRequire("9gq2c");
const $e508c293944e9913$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.GLOBAL_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $e508c293944e9913$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.GLOBAL_PAGE_MODULE),
        moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("bCMeR", function(module, exports) {

$parcel$export(module.exports, "AsyncDiscoverSection", () => $ba34a7ae9f3d559d$export$45fe6164578a6f29);

var $gzcjr = parcelRequire("gzcjr");

const $ba34a7ae9f3d559d$export$45fe6164578a6f29 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("eAgHZ")).then((module)=>module.DiscoverSection), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/marketplace-recommendations/src/ui/discover-section/DiscoverSection.tsx"
});

});
parcelRegister("eAgHZ", function(module, exports) {

let $a9e16370d09d44cb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a9e16370d09d44cb$var$load("eFsEw").then(()=>parcelRequire('4ftBy'));

});


parcelRegister("d51SR", function(module, exports) {

$parcel$export(module.exports, "Nav4ConnectMenuItem", () => $eb1ed74423963f34$export$d311b4cb0fdc0b92);

var $7A6yc = parcelRequire("7A6yc");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jUPZ1 = parcelRequire("jUPZ1");

var $cGvTS = parcelRequire("cGvTS");

var $d9FRf = parcelRequire("d9FRf");

var $jJqSP = parcelRequire("jJqSP");
function $eb1ed74423963f34$export$d311b4cb0fdc0b92({ queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $7A6yc.default), queryRef);
    const { addNew: addNew } = (0, $jUPZ1.useConnectItemClickHistory)();
    const onClick = (0, $eJOHy.useCallback)((e, target, styleClass, url)=>{
        if (url == null) return;
        addNew(url);
        if (target == null) return;
        (0, $cGvTS.withConnectHost)((connectHost)=>{
            connectHost.triggerWebItem(target, styleClass, url);
        });
        if ((0, $cGvTS.isConnectDialogWebItem)(styleClass)) e.preventDefault();
    }, [
        addNew
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9FRf.Nav4AppMenuItem), {
        queryRef: data,
        onData: $eb1ed74423963f34$var$transformData,
        onClick: onClick
    });
}
/**
 * Data transformer for Connect.
 * We are going to convert multi-page Connect apps into single-page ones in case their subpages don't contain a url that matches the root one.
 * For more details, see {@link canHaveSubpages}.
 */ function $eb1ed74423963f34$var$transformData(data) {
    return (0, $jJqSP.canHaveSubpages)(data) ? data : {
        ...data,
        sections: null
    };
}

});
parcelRegister("7A6yc", function(module, exports) {

$parcel$export(module.exports, "default", () => $42c3c7e893b95b9e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f245c96814deb8f505d2b497ec43b86d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $42c3c7e893b95b9e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4ConnectMenuItem",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4AppMenuItem"
        }
    ],
    "type": "JiraAppNavigationItem"
};
$42c3c7e893b95b9e$var$node.hash = "76baf08d707245f4a5aadd384fd44056";
var $42c3c7e893b95b9e$export$2e2bcd8739ae039 = $42c3c7e893b95b9e$var$node;

});

parcelRegister("jUPZ1", function(module, exports) {

$parcel$export(module.exports, "useConnectItemClickHistory", () => $ae247c3dbe9b1cab$export$c251e3fda1cce4a3);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");
// A single instance for the entire SPA session
const $ae247c3dbe9b1cab$var$history = {
    unique: []
};
const $ae247c3dbe9b1cab$export$c251e3fda1cce4a3 = ()=>{
    (0, $gRw8I.di)(window);
    const addNew = (0, $eJOHy.useCallback)((historyItem)=>{
        // Here we want to store only unique items. For example, if the add-on updates Jira hash
        // and user clicks the same navigation link we consider it as a unique navigation action
        // so we can use this info later on to rerender the iframe
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.location.href.endsWith(historyItem) === false) // @ts-expect-error - TS2339 - Property 'push' does not exist on type 'readonly []'.
        $ae247c3dbe9b1cab$var$history.unique.push(historyItem);
    }, []);
    return (0, $eJOHy.useMemo)(()=>({
            history: $ae247c3dbe9b1cab$var$history,
            addNew: addNew
        }), [
        addNew
    ]);
};
const $ae247c3dbe9b1cab$export$ef04cd58bebb0345 = ()=>{
    // @ts-expect-error TS2540: Cannot assign to 'length' because it is a read-only property.
    $ae247c3dbe9b1cab$var$history.unique.length = 0;
};

});

parcelRegister("cGvTS", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $48374095cc5f91cb$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $48374095cc5f91cb$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $48374095cc5f91cb$export$920fb4b46d4f2eec);

var $tTBSc = parcelRequire("tTBSc");
const $48374095cc5f91cb$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $tTBSc.setupConnectJs)();
    action(connectHost);
};
const $48374095cc5f91cb$export$186d423c00af146c = ()=>window.connectHost;
const $48374095cc5f91cb$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("tTBSc", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $c81546dab89b45de$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $gjeS9 = parcelRequire("gjeS9");
var $4T9yL = parcelRequire("4T9yL");

var $4ayON = parcelRequire("4ayON");

const $c81546dab89b45de$var$installConnectJs = async ()=>{
    // we need the heritage to load in order for WRM core and jQuery to exist.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $4T9yL.waitForHeritage)();
    await (0, $4ayON.waitForJQuery)();
    const loader = await (parcelRequire("jafIT"));
    await loader.performSideEffects();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};
let $c81546dab89b45de$var$installConnectJsPromise = null;
const $c81546dab89b45de$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__SPA__) {
        if ($c81546dab89b45de$var$installConnectJsPromise === null) $c81546dab89b45de$var$installConnectJsPromise = $c81546dab89b45de$var$installConnectJs();
        return $c81546dab89b45de$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $gjeS9.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};

});
parcelRegister("gjeS9", function(module, exports) {

$parcel$export(module.exports, "loadBridge", () => $b5b36a00cf4f19d9$export$df8409da353bde5a);

var $ej5JA = parcelRequire("ej5JA");
var $1HTZw = parcelRequire("1HTZw");
var $agkbU = parcelRequire("agkbU");
var $97BGz = parcelRequire("97BGz");

var $agkbU = parcelRequire("agkbU");
var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");
var $ligZL = parcelRequire("ligZL");
var $jb3ni = parcelRequire("jb3ni");
const $b5b36a00cf4f19d9$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $ej5JA.MAX_RETRIES), timeout: timeout = (0, $ej5JA.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $97BGz.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $1HTZw.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $agkbU.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("ej5JA", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $98246445188fd0a7$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $98246445188fd0a7$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $98246445188fd0a7$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $98246445188fd0a7$export$37f20f0ff732fcd7);

var $eSnSE = parcelRequire("eSnSE");
const { safeErrorWithoutCustomerData: $98246445188fd0a7$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $98246445188fd0a7$export$ea810ce67e3c8eac } = (0, $eSnSE.default);
const $98246445188fd0a7$export$1f86472c1374185a = 40;
const $98246445188fd0a7$export$7bd623b29ec8e1eb = 500;
const $98246445188fd0a7$export$37f20f0ff732fcd7 = true;

});

parcelRegister("1HTZw", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $d7bbb28cab06ad5d$export$a036f92c2465504e);

var $4Uno7 = parcelRequire("4Uno7");

var $ej5JA = parcelRequire("ej5JA");
const $d7bbb28cab06ad5d$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $ej5JA.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $4Uno7.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $4Uno7.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("4Uno7", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $d05d3ad813870ea5$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d05d3ad813870ea5$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("agkbU", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $224e973e4c93da11$export$20c32b4579d78b92);

var $1HTZw = parcelRequire("1HTZw");

var $iyT45 = parcelRequire("iyT45");

var $ej5JA = parcelRequire("ej5JA");
const $224e973e4c93da11$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $ej5JA.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $iyT45.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $1HTZw.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("iyT45", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $f6004e9afa2128c3$export$3cefda82396756a1);

var $6M1XZ = parcelRequire("6M1XZ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $f6004e9afa2128c3$var$pollingSingleton = null;
const $f6004e9afa2128c3$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $f6004e9afa2128c3$var$pollingSingleton ?? (0, $6M1XZ.createPollingCollection)((v)=>window.require(v), 100);
    $f6004e9afa2128c3$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("6M1XZ", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $0a667df7ad6c937e$export$f163446a982a8077);

var $gRw8I = parcelRequire("gRw8I");

var $2oJXr = parcelRequire("2oJXr");
const $0a667df7ad6c937e$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gRw8I.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $2oJXr.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $2oJXr.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("2oJXr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7015c609345acf$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $3b7015c609345acf$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $3b7015c609345acf$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $3b7015c609345acf$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




parcelRegister("97BGz", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $32e00fb40c944769$export$eba600d28decc4ac);

var $bXaxC = parcelRequire("bXaxC");

var $agkbU = parcelRequire("agkbU");

var $7rBE0 = parcelRequire("7rBE0");

var $ej5JA = parcelRequire("ej5JA");
const $32e00fb40c944769$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>{
    (0, $bXaxC.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $7rBE0.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $agkbU.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("bXaxC", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $f1ca263307f66278$export$9ea3ff7978093559);
const $f1ca263307f66278$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $f1ca263307f66278$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $f1ca263307f66278$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $f1ca263307f66278$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $f1ca263307f66278$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $f1ca263307f66278$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $f1ca263307f66278$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $f1ca263307f66278$var$initStats();
        // stop accumulating stats at TTI mark
        if ($f1ca263307f66278$var$isPageInteractive()) return;
        stats.requests += 1;
        $f1ca263307f66278$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$f1ca263307f66278$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $f1ca263307f66278$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("7rBE0", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $09f989d08b38b1cb$export$6cda16b6eff75f59);

var $4Uno7 = parcelRequire("4Uno7");

var $b6X3x = parcelRequire("b6X3x");

var $iyT45 = parcelRequire("iyT45");

var $ej5JA = parcelRequire("ej5JA");
const $09f989d08b38b1cb$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $iyT45.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $b6X3x.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $ej5JA.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $4Uno7.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("b6X3x", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $aa5ee41b24db8c96$export$93d9db5fbabad1b0);

var $avFP5 = parcelRequire("avFP5");
let $aa5ee41b24db8c96$var$isSuperBatchDependenciesLoaded = false;
const $aa5ee41b24db8c96$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $aa5ee41b24db8c96$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($aa5ee41b24db8c96$var$isSuperBatchDependenciesLoaded || $aa5ee41b24db8c96$var$isOnRapidBoardsPage()) return wrmKeys;
    $aa5ee41b24db8c96$var$isSuperBatchDependenciesLoaded = true;
    return (0, $avFP5.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("avFP5", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $00f9be664c96bf5d$export$f14a6b583ce9e077);
const $00f9be664c96bf5d$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});




parcelRegister("4T9yL", function(module, exports) {

$parcel$export(module.exports, "waitForHeritage", () => $ba1950b07a7f2989$export$c61060338d026f78);

var $hpZoI = parcelRequire("hpZoI");

var $2oJXr = parcelRequire("2oJXr");
const $ba1950b07a7f2989$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $2oJXr.default)();
        (0, $hpZoI.bootstrapWrmClient)().then(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("hpZoI", function(module, exports) {

$parcel$export(module.exports, "bootstrapWrmClient", () => $027e7c56f31b7541$export$d001f71dd306cb0c);

var $1Ozm9 = parcelRequire("1Ozm9");

var $4Uno7 = parcelRequire("4Uno7");

var $gYnSx = parcelRequire("gYnSx");
const $027e7c56f31b7541$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $027e7c56f31b7541$var$fetchSpaWrmContext = async ()=>{
    return (0, $1Ozm9.default)($027e7c56f31b7541$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $027e7c56f31b7541$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $027e7c56f31b7541$var$hasWrmInitialised;
const $027e7c56f31b7541$var$runBootstrap = ()=>{
    const spaWrmContext = $027e7c56f31b7541$var$fetchSpaWrmContext();
    return new Promise((resolve, reject)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // eslint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($027e7c56f31b7541$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        }).catch((error)=>{
            (0, $gYnSx.default)({
                error: new Error((0, $4Uno7.safeStringify)(error)),
                meta: {
                    id: 'bootstrap-wrm-client',
                    packageName: 'common-bridge',
                    teamName: 'jfp-magma'
                }
            });
            reject(new Error('Failed to fetch the spa wrm context'));
        });
    });
};
const $027e7c56f31b7541$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($027e7c56f31b7541$var$hasWrmInitialised) return $027e7c56f31b7541$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $027e7c56f31b7541$var$hasWrmInitialised = Promise.resolve();
    else $027e7c56f31b7541$var$hasWrmInitialised = $027e7c56f31b7541$var$runBootstrap();
    return $027e7c56f31b7541$var$hasWrmInitialised;
};

});


parcelRegister("ligZL", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $cfd4a2a9e13f6c24$export$cc9d8f51375ef66a);

var $7rBE0 = parcelRequire("7rBE0");

var $ej5JA = parcelRequire("ej5JA");
const $cfd4a2a9e13f6c24$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR))=>(0, $7rBE0.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("jb3ni", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $4b0178a6bf26b876$export$e53a5db19a39ed2f);

var $7rBE0 = parcelRequire("7rBE0");

var $ej5JA = parcelRequire("ej5JA");
const $4b0178a6bf26b876$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR))=>(0, $7rBE0.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});


parcelRegister("4ayON", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $3de54a49c8727908$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $3de54a49c8727908$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $3de54a49c8727908$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $3de54a49c8727908$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $3de54a49c8727908$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $3de54a49c8727908$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $3de54a49c8727908$export$d690da9bc8146677);

var $gYnSx = parcelRequire("gYnSx");

const $3de54a49c8727908$export$c47913ca32a5c6f7 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $3de54a49c8727908$export$7232a6dc780f9887 = ()=>AJS.$;
const $3de54a49c8727908$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public @atlassian/atlassian-connect-js library.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window._AP;
const $3de54a49c8727908$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $3de54a49c8727908$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $3de54a49c8727908$var$FIVE_MINUTES = 300000;
const $3de54a49c8727908$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $gYnSx.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $3de54a49c8727908$var$FIVE_MINUTES);
    });
const $3de54a49c8727908$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $3de54a49c8727908$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $3de54a49c8727908$export$d690da9bc8146677 = [
    $3de54a49c8727908$export$cb954c21735b28e4,
    $3de54a49c8727908$export$7315c38dc71bd41f
];

});

parcelRegister("jafIT", function(module, exports) {

let $df3b25c2656421e0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $df3b25c2656421e0$var$load("38NXY").then(()=>parcelRequire('jh0iZ'));

});



parcelRegister("d9FRf", function(module, exports) {

$parcel$export(module.exports, "Nav4AppMenuItem", () => $1ba52292ee1c4fde$export$549160040f86c542);

var $anFKT = parcelRequire("anFKT");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $feav5 = parcelRequire("feav5");
var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");
var $2y3Ci = parcelRequire("2y3Ci");
var $ilbtc = parcelRequire("ilbtc");
var $1swHh = parcelRequire("1swHh");




var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $aLENQ = parcelRequire("aLENQ");

var $lvrbL = parcelRequire("lvrbL");

var $i0tMD = parcelRequire("i0tMD");

var $azEgq = parcelRequire("azEgq");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $7jTnu = parcelRequire("7jTnu");

var $fAZgY = parcelRequire("fAZgY");

var $9ziuH = parcelRequire("9ziuH");

var $e5n8k = parcelRequire("e5n8k");

var $4qOre = parcelRequire("4qOre");
function $1ba52292ee1c4fde$export$549160040f86c542({ queryRef: queryRef, onData: onData, onClick: onClick }) {
    const rawData = (0, $j4oe4.useFragment)((0, $anFKT.default), queryRef);
    const data = (0, $eJOHy.useMemo)(()=>onData ? onData($1ba52292ee1c4fde$var$normalizeData(rawData)) : $1ba52292ee1c4fde$var$normalizeData(rawData), [
        onData,
        rawData
    ]);
    const icon = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e5n8k.AppIcon), {
            shouldChangeFillColor: !(0, $7jTnu.fg)('jira-nav-addon-icon-disable-color-filter'),
            iconUrl: data.iconUrl || ''
        }), [
        data.iconUrl
    ]);
    const withSeparators = (0, $eJOHy.useMemo)(()=>$1ba52292ee1c4fde$var$shouldUseSeparators(data), [
        data
    ]);
    const envLozenge = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ziuH.EnvLozenge), {
            label: data.envLabel || ''
        }), [
        data.envLabel
    ]);
    const actionsOnHover = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4qOre.AppActions), {
            settingsUrl: data.settingsUrl || '',
            appId: data.appId || ''
        }), [
        data.settingsUrl,
        data.appId
    ]);
    const expandable = (0, $eJOHy.useMemo)(()=>{
        if ((data.sections || []).length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ba52292ee1c4fde$var$MaybeExpandable, {
            actionsOnHover: actionsOnHover,
            appId: data.appId || '',
            envLozenge: envLozenge,
            icon: icon,
            label: data.label || 'Unknown app',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            menuIds: $1ba52292ee1c4fde$var$toExpandableMenuId(data.sections),
            itemId: data.appId || '',
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf)
        }, (data.sections || []).map((section, sectionIndex)=>(section?.links || []).length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), {
                key: `${sectionIndex}-${section?.label}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, withSeparators && sectionIndex > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $feav5.Divider), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ba52292ee1c4fde$var$MaybeExpandable, {
                appId: data.appId || '',
                label: section?.label || '',
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                menuIds: $1ba52292ee1c4fde$var$toExpandableMenuId([
                    {
                        links: section?.links
                    }
                ]),
                itemId: `section/${sectionIndex}`,
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1)
            }, (section?.links || []).map((link, linkIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ba52292ee1c4fde$var$SimpleItem, {
                    appId: data.appId || '',
                    key: link?.url || '',
                    label: link?.label || '',
                    onClick: onClick,
                    styleClass: link?.styleClass || '',
                    url: link?.url == null ? null : $1ba52292ee1c4fde$var$removeTrailingSlash(link?.url),
                    itemId: `section/${sectionIndex}/link/${linkIndex}`,
                    level: section?.label ? (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18) : (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1)
                })))))) : null));
    }, [
        data.sections,
        data.label,
        data.appId,
        icon,
        envLozenge,
        actionsOnHover,
        withSeparators,
        onClick
    ]);
    if (expandable) return expandable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ba52292ee1c4fde$var$SimpleItem, {
        actionsOnHover: actionsOnHover,
        appId: data.appId || '',
        envLozenge: envLozenge,
        icon: icon,
        label: data.label || 'Unknown app',
        onClick: onClick,
        styleClass: data.styleClass || '',
        url: data.url == null ? null : $1ba52292ee1c4fde$var$removeTrailingSlash(data.url || ''),
        itemId: data.appId || '',
        level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf)
    });
}
function $1ba52292ee1c4fde$var$SimpleItem({ actionsOnHover: actionsOnHover, appId: appId, envLozenge: envLozenge, icon: icon, label: label, onClick: onClick, styleClass: styleClass, url: url, itemId: itemId, level: level }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const anchorElement = (0, $eJOHy.useRef)(null);
    const onItemClick = (0, $eJOHy.useCallback)((e)=>{
        $1ba52292ee1c4fde$var$fireAppClickEvent({
            event: createAnalyticsEvent({}),
            itemId: itemId,
            appId: appId,
            level: level
        });
        onClick?.(e, anchorElement.current, styleClass || '', url);
    }, [
        url,
        onClick,
        itemId,
        appId,
        level,
        styleClass,
        createAnalyticsEvent
    ]);
    // If a Connect app does NOT have a URL, we should use a MenuButtonItem instead.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: $1ba52292ee1c4fde$var$removeTrailingSlash(url ?? ''),
        elemBefore: icon,
        elemAfter: envLozenge,
        actionsOnHover: actionsOnHover,
        menuId: $1ba52292ee1c4fde$export$171d73a56172dba4(url ?? ''),
        ref: anchorElement,
        onClick: onItemClick
    }, label);
}
function $1ba52292ee1c4fde$var$MaybeExpandable(params) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { actionsOnHover: actionsOnHover, children: children, envLozenge: envLozenge, icon: icon, label: label, menuIds: menuIds, itemId: itemId, appId: appId, level: level } = params;
    const menuId = (0, $aLENQ.toMenuIdFromMenuIdList)(menuIds);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        $1ba52292ee1c4fde$var$fireAppClickEvent({
            event: createAnalyticsEvent({}),
            itemId: itemId,
            appId: appId,
            level: level,
            isExpandable: true
        });
    }, [
        createAnalyticsEvent,
        itemId,
        appId,
        level
    ]);
    const onExpansionToggle = (0, $fAZgY.useCallbackWithCondition)((hasExpanded)=>{
        if (hasExpanded) onClick();
    }, [
        onClick
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'));
    return label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: menuId,
        isExpanded: level !== (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        elemBefore: icon,
        elemAfter: envLozenge,
        testId: (0, $azEgq.getTestId)(menuId),
        interactionName: (0, $7jTnu.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-apps' : undefined
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
}
function $1ba52292ee1c4fde$var$fireAppClickEvent(params) {
    const { event: event, itemId: itemId, appId: appId, level: level, isExpandable: isExpandable } = params;
    (0, $gCeeo.fireUIAnalytics)(event, {
        action: 'clicked',
        actionSubject: 'navigationItem',
        actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_APPS],
        attributes: {
            level: level,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemId: itemId,
            isExpandable: isExpandable,
            section: 'yourApps',
            ...level === (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf) ? {
                itemType: (0, $6bf6536f83c22cfe$export$c3d83ca6855fa0d0)
            } : {
                itemType: (0, $6bf6536f83c22cfe$export$509e83d3c8d91279),
                parentItemId: appId,
                parentItemType: (0, $6bf6536f83c22cfe$export$c3d83ca6855fa0d0)
            }
        }
    });
}
function $1ba52292ee1c4fde$var$shouldUseSeparators(data) {
    for (const section of data.sections || []){
        if (section?.label) return false;
    }
    return true;
}
/**
 * Common data transformer.
 * Filters out sections with empty links.
 */ function $1ba52292ee1c4fde$var$normalizeData(data) {
    return {
        ...data,
        sections: (data.sections || []).filter((section)=>(section?.links || []).length > 0)
    };
}
const $1ba52292ee1c4fde$var$removeTrailingSlash = (url = '')=>url.replace(/\/$/, '');
const $1ba52292ee1c4fde$var$removeQueryParams = (url)=>url.split('?')[0];
const $1ba52292ee1c4fde$var$removeHash = (url)=>url.split('#')[0];
const $1ba52292ee1c4fde$export$171d73a56172dba4 = (path_ = '')=>{
    let path = path_;
    // This is the format we ask Connect vendors to use: /plugins/servlet/ac/:addonKey/:moduleKey
    // However, there are Connect apps that do not follow our recommendations and add extra path segments.
    // As result they might look like this: /plugins/servlet/ac/:addonKey/:moduleKey/:extraPathSegment
    // Because of that we have issues with menu ids matching since the path created out of current route differs from the actual url.
    // To fix this we remove those extra path segments from the url.
    if (path.startsWith('/plugins/servlet/ac/')) path = path.split('/').slice(0, 6).join('/');
    return (0, $h4Bzb.ENTITY_ID).APP($1ba52292ee1c4fde$var$removeTrailingSlash($1ba52292ee1c4fde$var$removeQueryParams($1ba52292ee1c4fde$var$removeHash(path))));
};
// Because of the apps nature, the parent url may differ from the child url.
// And if we want to make sure the expand state is properly calculated, we must pass down children menu ids.
const $1ba52292ee1c4fde$var$toExpandableMenuId = (sections)=>(sections || []).flatMap(({ links: links })=>(links || []).map((link)=>$1ba52292ee1c4fde$export$171d73a56172dba4(link.url)));

});
parcelRegister("anFKT", function(module, exports) {

$parcel$export(module.exports, "default", () => $633ea1bc46f9ad5a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f1dd304f2b2075cf9083f0c067a308e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $633ea1bc46f9ad5a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "label"
    }, v1 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4AppMenuItem",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "appId"
            },
            {
                "kind": "ScalarField",
                "name": "envLabel"
            },
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "concreteType": "JiraAppSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "concreteType": "JiraAppNavigationItemNestedLink",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            v2 /*: any*/ ,
                            v1 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "settingsUrl"
            },
            v2 /*: any*/ 
        ],
        "type": "JiraAppNavigationItem"
    };
}();
$633ea1bc46f9ad5a$var$node.hash = "fe622bd16e14b11ec5e3f21d8553bac3";
var $633ea1bc46f9ad5a$export$2e2bcd8739ae039 = $633ea1bc46f9ad5a$var$node;

});

parcelRegister("feav5", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $011cc2faeed11726$export$2e0a83ec2e27ecbb);
/* divider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $011cc2faeed11726$var$styles = null;
const $011cc2faeed11726$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("hr", {
        /**
 * The existing usage of these dividers is presentational,
 * so we are removing the separator semantics by default.
 *
 * In the future we may consider allowing opt-in separator semantics,
 * but it probably isn't necessary.
 */ role: "none",
        className: (0, $hcewu.default)([
            "_h7alglyw _179rglyw _mqm2zgxb _1bsb1osq"
        ])
    });

});

const $6bf6536f83c22cfe$export$9b8283d5878d2491 = 'board';
const $6bf6536f83c22cfe$export$c3d83ca6855fa0d0 = 'app';
const $6bf6536f83c22cfe$export$c1c49903035a02df = 'filter';
const $6bf6536f83c22cfe$export$6deee0e4f2fb784e = 'defaultFilter';
const $6bf6536f83c22cfe$export$4695c1a423ffe431 = 'dashboard';
const $6bf6536f83c22cfe$export$5828682c822c26e7 = 'queue';
const $6bf6536f83c22cfe$export$fe791c4fa892e400 = 'project';
const $6bf6536f83c22cfe$export$c303e491e026ebc6 = 'plan';
const $6bf6536f83c22cfe$export$509e83d3c8d91279 = 'appSubpage';
const $6bf6536f83c22cfe$export$a2e7d1d0a3d169f4 = 'asset';
const $6bf6536f83c22cfe$export$b56168d831461ce2 = 'operation';
const $6bf6536f83c22cfe$export$499a3e77858b7713 = 'translationGroup';
const $6bf6536f83c22cfe$export$bb8a37ab8d9ba82b = 'roadmap';
const $6bf6536f83c22cfe$export$9a778ca616c24a93 = 'projectRecommendation';
const $6bf6536f83c22cfe$export$9cbb0f231a0ab7ea = 'overview';
const $6bf6536f83c22cfe$export$119dad133da0b4a = 'changeView';

parcelRegister("9ziuH", function(module, exports) {

$parcel$export(module.exports, "EnvLozenge", () => $aa2d3153d967637d$export$61c90f482f9775c6);

var $eJOHy = parcelRequire("eJOHy");

var $6alcT = parcelRequire("6alcT");
function $aa2d3153d967637d$export$61c90f482f9775c6({ label: label }) {
    return label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        appearance: label === 'Dev' ? 'default' : 'moved'
    }, label) : null;
}

});

parcelRegister("e5n8k", function(module, exports) {

$parcel$export(module.exports, "AppIcon", () => $dede81b109af0626$export$5153830bdfb71453);

var $eJOHy = parcelRequire("eJOHy");

var $L2KhS = parcelRequire("L2KhS");

var $aNxjx = parcelRequire("aNxjx");
function $dede81b109af0626$export$5153830bdfb71453({ iconUrl: iconUrl, shouldChangeFillColor: shouldChangeFillColor }) {
    return iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNxjx.IconCustom), {
        url: iconUrl,
        shouldChangeFillColor: shouldChangeFillColor
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($L2KhS))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    });
}

});
parcelRegister("aNxjx", function(module, exports) {

$parcel$export(module.exports, "IconCustom", () => $af7800a3ad437605$export$5b6504ec6adf0047);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $bnf52 = parcelRequire("bnf52");
// got this value through trial and error
// in the long term, we should change the color of icon generated for the conntect apps
const $af7800a3ad437605$var$colorMatrixValues = '0.08, 0, 0, 0, 0, 0, 0.1, 0, 0, 0, 0, 0,0.2, 0, 0, 0, 0, 0, 1, 0';
const $af7800a3ad437605$export$5b6504ec6adf0047 = ({ url: url, shouldChangeFillColor: shouldChangeFillColor = true, ariaLabelledBy: ariaLabelledBy })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $af7800a3ad437605$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        viewBox: "0 0 20 20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("filter", {
        id: "changeFillColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("feColorMatrix", {
        type: "matrix",
        values: $af7800a3ad437605$var$colorMatrixValues
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("image", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xlinkHref: url,
        width: "20",
        height: "20",
        x: "0",
        y: "0",
        filter: shouldChangeFillColor && (0, $bnf52.checkForSvg)(url) ? 'url(#changeFillColor)' : '',
        "aria-labelledby": ariaLabelledBy
    })));
};
const $af7800a3ad437605$var$styles = (0, $5Wv5g.xcss)({
    display: 'inline-block',
    margin: 'space.025',
    height: "var(--ds-space-250, 20px)",
    width: "var(--ds-space-250, 20px)"
});

});
parcelRegister("bnf52", function(module, exports) {

$parcel$export(module.exports, "checkForSvg", () => $92e7a4811c111a7f$export$9a369805b0fabb72);
const $92e7a4811c111a7f$export$9a369805b0fabb72 = (url)=>{
    const fileType = url.split(/#|\?/)[0].split('.').pop();
    // falsey check is for Ts
    return fileType ? fileType.trim() === 'svg' : false;
};

});



parcelRegister("4qOre", function(module, exports) {

$parcel$export(module.exports, "AppActions", () => $faae41806519ec51$export$6b031ef628e5f9c2);

var $eJOHy = parcelRequire("eJOHy");

var $ejfxj = parcelRequire("ejfxj");

var $apGPk = parcelRequire("apGPk");
var $7R1al = parcelRequire("7R1al");

var $lRq8t = parcelRequire("lRq8t");




var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $8z6Yy = parcelRequire("8z6Yy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $7jTnu = parcelRequire("7jTnu");

var $03ZmM = parcelRequire("03ZmM");
const $faae41806519ec51$var$NavMenuItems = ({ onClose: onClose, onTrackClick: onTrackClick, settingsUrl: settingsUrl })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleClick = (0, $eJOHy.useCallback)((event)=>{
        onTrackClick();
        onClose?.(event);
    }, [
        onClose,
        onTrackClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apGPk.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ejfxj))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }),
        href: settingsUrl,
        target: "_blank",
        onClick: handleClick
    }, formatMessage((0, $03ZmM.default).appSettings)));
};
function $faae41806519ec51$export$6b031ef628e5f9c2({ settingsUrl: settingsUrl, appId: appId, onClose: onClose }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const fireOpenEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_APPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$9bd6c21d500ae611),
                itemId: 'meatballDropdown',
                section: 'yourApps'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireClickEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_APPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                componentType: (0, $493796f3bdee881c$export$5374c2c2d3ece55e),
                parentItemId: appId,
                parentItemType: (0, $6bf6536f83c22cfe$export$c3d83ca6855fa0d0),
                itemId: 'appSettings',
                section: 'yourApps'
            }
        });
    }, [
        createAnalyticsEvent,
        appId
    ]);
    const MenuItems = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($faae41806519ec51$var$NavMenuItems, {
            onClose: props.onClose,
            onTrackClick: fireOpenEvent,
            settingsUrl: settingsUrl
        }), [
        fireOpenEvent,
        settingsUrl
    ]);
    if (!settingsUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        MenuItems: (0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton') ? MenuItems : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apGPk.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ejfxj))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
                href: settingsUrl,
                target: "_blank",
                onClick: (...args)=>{
                    fireClickEvent();
                    props.onClose?.(...args);
                }
            }, formatMessage((0, $03ZmM.default).appSettings))),
        onOpen: fireOpenEvent,
        onClose: onClose
    });
}

});
parcelRegister("03ZmM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b933410087aba60$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0b933410087aba60$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    appSettings: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.app-actions.app-settings",
        "defaultMessage": "App settings"
    }
});

});




parcelRegister("ja8Li", function(module, exports) {

$parcel$export(module.exports, "Nav4ForgeMenuItem", () => $ce65831c25c6979c$export$9d5c2149f38ae387);

var $883ZT = parcelRequire("883ZT");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $d9FRf = parcelRequire("d9FRf");
function $ce65831c25c6979c$export$9d5c2149f38ae387({ queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $883ZT.default), queryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9FRf.Nav4AppMenuItem), {
        queryRef: data
    });
}

});
parcelRegister("883ZT", function(module, exports) {

$parcel$export(module.exports, "default", () => $74cb1553dc0c6328$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3988ad3da7c9b5f6abf2f3718a010e31>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $74cb1553dc0c6328$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4ForgeMenuItem",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4AppMenuItem"
        }
    ],
    "type": "JiraAppNavigationItem"
};
$74cb1553dc0c6328$var$node.hash = "e6f8d3ee567e6cd74addae3ad5622034";
var $74cb1553dc0c6328$export$2e2bcd8739ae039 = $74cb1553dc0c6328$var$node;

});


parcelRegister("diXvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdff9f38b459b2b0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cdff9f38b459b2b0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    yourApps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.content.your-apps",
        "defaultMessage": "Your apps"
    }
});

});



parcelRegister("6HiqT", function(module, exports) {

$parcel$export(module.exports, "Nav4AppsSpotlightWrapper", () => $7f16a884d0b673ca$export$d148eb6657a374a);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $6SybE = parcelRequire("6SybE");

var $9ycBx = parcelRequire("9ycBx");

var $gxP9D = parcelRequire("gxP9D");

var $dyM1L = parcelRequire("dyM1L");

var $5Xqpk = parcelRequire("5Xqpk");

var $7jTnu = parcelRequire("7jTnu");
function $7f16a884d0b673ca$export$d148eb6657a374a({ children: children }) {
    const [{ hasOpened: shouldShowNudge }] = (0, $5Xqpk.useHasOpened)();
    const [isUnloaded] = (0, $gxP9D.useIsDismissed)();
    const expandSideNav = (0, $6SybE.useExpandSideNav)();
    const [openTask] = (0, $gxP9D.useOpenTask)();
    const [, { setHasNudgeActive: setHasNudgeActive }] = (0, $gxP9D.useQuickstartActions)();
    (0, $eJOHy.useEffect)(()=>{
        if (!isUnloaded && openTask === (0, $9ycBx.CAPTURE_INTEGRATIONS_TASK) && shouldShowNudge) {
            expandSideNav();
            setHasNudgeActive(true); // This re-shows the button-highlight, which can be hidden if the user tries to hide the sidebar
        }
    }, [
        isUnloaded,
        openTask,
        shouldShowNudge,
        setHasNudgeActive,
        expandSideNav
    ]);
    if ((0, $7jTnu.fg)('jira_onboarding_experiences_a11y_fixes')) return !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $7f16a884d0b673ca$var$fullWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyM1L.NavigationAppsNavItemWrapperNudgeAsync), null, children)) : children;
    return !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyM1L.NavigationAppsNavItemWrapperNudgeAsync), null, children) : children;
}
const $7f16a884d0b673ca$var$fullWidthStyles = (0, $5Wv5g.xcss)({
    width: '100%'
});

});
parcelRegister("dyM1L", function(module, exports) {

$parcel$export(module.exports, "NavigationAppsNavItemWrapperNudgeAsync", () => $c11b16e6136d5661$export$c143067f544307f);

var $eJOHy = parcelRequire("eJOHy");


var $kMreM = parcelRequire("kMreM");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c11b16e6136d5661$var$NavigationAppsNavItemLazy = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("gielL")).then((exportedModule)=>exportedModule.NavigationAppsNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-apps/index.tsx"
});
const $c11b16e6136d5661$export$c143067f544307f = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kMreM.OnboardingNudgeErrorBoundary), {
        id: (0, $2b839a8453de5367$export$dd63d0099d95ba4f),
        fallback: children,
        attributes: {
            nudgeId: (0, $2b839a8453de5367$export$dd63d0099d95ba4f)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "navigation-apps-nav-item-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c11b16e6136d5661$var$NavigationAppsNavItemLazy, {
        nudgeId: (0, $2b839a8453de5367$export$dd63d0099d95ba4f),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("kMreM", function(module, exports) {

$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $373b41d996461548$export$3915a8814b99f0b);

var $eJOHy = parcelRequire("eJOHy");

var $hLlIx = parcelRequire("hLlIx");

var $9ycBx = parcelRequire("9ycBx");
const $373b41d996461548$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hLlIx.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $9ycBx.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};

});
parcelRegister("hLlIx", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $8e7d43321aea4f70$export$9171acf2e93b7d4d);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $eYe3w = parcelRequire("eYe3w");
const $8e7d43321aea4f70$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $eYe3w.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};

});
parcelRegister("eYe3w", function(module, exports) {

$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $638881997835b97e$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $638881997835b97e$export$807be5f3f1ea996);

var $eJOHy = parcelRequire("eJOHy");

var $dSzMM = parcelRequire("dSzMM");
const $638881997835b97e$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $dSzMM.isLoaderError)(error)
    });
const $638881997835b97e$export$807be5f3f1ea996 = (attributes = {})=>(0, $eJOHy.useCallback)((error)=>({
            ...attributes,
            ...$638881997835b97e$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});



parcelRegister("gielL", function(module, exports) {

let $bdc97560b52fbac9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bdc97560b52fbac9$var$load("h9gth").then(()=>parcelRequire('iyJtd'));

});


parcelRegister("5Xqpk", function(module, exports) {

$parcel$export(module.exports, "useHasOpened", () => $4d9973b57b668a8c$export$cbaabcded53b5c1f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $eqSON = parcelRequire("eqSON");
const $4d9973b57b668a8c$var$actions = {
    setHasOpened: $eqSON.setHasOpened
};
const $4d9973b57b668a8c$var$initialState = {
    hasOpened: false
};
const $4d9973b57b668a8c$var$Store = (0, $GtRbT.createStore)({
    initialState: $4d9973b57b668a8c$var$initialState,
    actions: $4d9973b57b668a8c$var$actions,
    name: 'jsw-onboarding-quickstart-has-opened'
});
const $4d9973b57b668a8c$export$cbaabcded53b5c1f = (0, $iJq0l.createHook)($4d9973b57b668a8c$var$Store);

});
parcelRegister("eqSON", function(module, exports) {

$parcel$export(module.exports, "setHasOpened", () => $7ce6edfb96d1ed93$export$c4743c64a7c42294);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $7ce6edfb96d1ed93$export$c4743c64a7c42294 = ()=>({ getState: getState, setState: setState })=>{
        const { hasOpened: hasOpened } = getState();
        if (hasOpened === true) // if state has been updated already return
        return;
        setState({
            hasOpened: true
        });
    };
var $7ce6edfb96d1ed93$export$2e2bcd8739ae039 = $7ce6edfb96d1ed93$export$c4743c64a7c42294;

});





parcelRegister("4P1EM", function(module, exports) {

$parcel$export(module.exports, "Nav4Assets", () => $d0b0fde800fdbbb7$export$ae278c7655ee6005);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $8XHsn = parcelRequire("8XHsn");

var $jopyG = parcelRequire("jopyG");

var $gfvms = parcelRequire("gfvms");

var $lvKO5 = parcelRequire("lvKO5");

var $7jTnu = parcelRequire("7jTnu");

var $b2MSM = parcelRequire("b2MSM");

var $6ANkN = parcelRequire("6ANkN");
function $d0b0fde800fdbbb7$export$ae278c7655ee6005({ isExpanded: isExpanded }) {
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    // useInsightVisibility can help fetch WorkspaceId
    const _ = (0, $8XHsn.useInsightVisibility)();
    const isPremiumUser = (0, $jopyG.isLicensedPremiumUser)(tenantContext);
    const { workspaceId: workspaceId } = (0, $8XHsn.useWorkspaceContext)();
    if (!isPremiumUser) {
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
            serviceDeskEdition: tenantContext.appEditions?.serviceDesk,
            isSiteAdmin: tenantContext.isSiteAdmin
        });
        if ((0, $7jTnu.fg)('assets_as_an_app_v2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ANkN.AssetsAppItem), {
            showUpsell: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2MSM.AssetsSingleMenuItem), {
            showUpsellLozenge: true
        });
    }
    if ((0, $7jTnu.fg)('assets_as_an_app_v2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ANkN.AssetsAppItem), {
        showUpsell: false
    });
    return workspaceId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gfvms.InsightGlobalConfigContainer), {
        isGlobal: true,
        workspaceId: workspaceId,
        createAnalyticsEvent: createAnalyticsEvent,
        disableOnInit: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2MSM.AssetsMenu), {
        isExpanded: isExpanded
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2MSM.AssetsSingleMenuItem), {
        showUpsellLozenge: false
    });
}

});
parcelRegister("8XHsn", function(module, exports) {

$parcel$export(module.exports, "useWorkspaceContext", () => $5dc043f4942dc6a4$export$827d903316fc333c);
$parcel$export(module.exports, "useInsightVisibility", () => $5dc043f4942dc6a4$export$74ebc9a49f60d38a);

var $eJOHy = parcelRequire("eJOHy");

var $7cSYk = parcelRequire("7cSYk");

var $lvKO5 = parcelRequire("lvKO5");

var $eJrcF = parcelRequire("eJrcF");

var $jopyG = parcelRequire("jopyG");

var $ePaI2 = parcelRequire("ePaI2");
const $5dc043f4942dc6a4$export$a0002067fa97246a = '/rest/servicedesk/cmdb/latest/workspace';
const $5dc043f4942dc6a4$export$122fccf0bbbc9acc = 30000;
const $5dc043f4942dc6a4$export$827d903316fc333c = ()=>{
    const { data: data, loading: loading, error: error, refresh: fetchWorkspaceId } = (0, $eJrcF.useResource)((0, $ePaI2.workspaceResource));
    const workspaceId = data ?? undefined;
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null | undefined'.
        error,
        workspaceId: workspaceId,
        fetchWorkspaceId: fetchWorkspaceId
    };
};
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
const $5dc043f4942dc6a4$var$useInterval = (callback, delay)=>{
    const savedCallback = (0, $eJOHy.useRef)(callback);
    // Remember the latest callback.
    (0, $eJOHy.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, $eJOHy.useEffect)(()=>{
        const tick = ()=>{
            savedCallback.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
        return undefined;
    }, [
        delay
    ]);
};
const $5dc043f4942dc6a4$export$74ebc9a49f60d38a = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { workspaceId: workspaceId, fetchWorkspaceId: fetchWorkspaceId, loading: loading } = $5dc043f4942dc6a4$export$827d903316fc333c();
    // Optimistically set this true if user is premium and CMDB is enabled in environment - which will prevent a flash for the majority of users
    const [isVisible, setIsVisible] = (0, $eJOHy.useState)((0, $7cSYk.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP) && (0, $jopyG.isLicensedPremiumUser)(tenantContext));
    const [shouldPollForWorkspaceId, setShouldPollForWorkspaceId] = (0, $eJOHy.useState)(false);
    const [hasFetchedWorkspaceId, setHasFetchedWorkspaceId] = (0, $eJOHy.useState)(false);
    // Can't test this component without a rerender on each poll — so am just increment a counter with each poll
    const [, setPollCount] = (0, $eJOHy.useState)(0);
    // Run an initial fetch of the workspaceId if the resource wasn't already fetched as
    // part of the route definition (like for the Insight menu in the global nav)
    (0, $eJOHy.useEffect)(()=>{
        if (!hasFetchedWorkspaceId && !workspaceId && (0, $jopyG.isLicensedPremiumUser)(tenantContext) && (0, $7cSYk.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP)) {
            fetchWorkspaceId();
            setHasFetchedWorkspaceId(true);
        }
    }, [
        fetchWorkspaceId,
        hasFetchedWorkspaceId,
        tenantContext,
        workspaceId
    ]);
    // Starts/stops the polling of workspaceId
    $5dc043f4942dc6a4$var$useInterval(()=>{
        fetchWorkspaceId();
        setPollCount((a)=>a + 1);
    }, shouldPollForWorkspaceId ? $5dc043f4942dc6a4$export$122fccf0bbbc9acc : null);
    // Main check to see if insight should be visible
    // If user has premium subscription but no workspace ID, we begin polling for the
    // workspace ID as it means their Insight instance hasn’t completed provisioning yet
    (0, $eJOHy.useEffect)(()=>{
        if (hasFetchedWorkspaceId && !loading) {
            if ((0, $jopyG.isLicensedPremiumUser)(tenantContext)) {
                if (workspaceId !== undefined) {
                    setIsVisible(true);
                    setShouldPollForWorkspaceId(false);
                } else {
                    setIsVisible(false);
                    setShouldPollForWorkspaceId(true);
                }
            } else {
                setIsVisible(false);
                setShouldPollForWorkspaceId(false);
            }
        }
    }, [
        tenantContext,
        workspaceId,
        loading,
        hasFetchedWorkspaceId
    ]);
    return isVisible;
};

});

parcelRegister("gfvms", function(module, exports) {

$parcel$export(module.exports, "useInsightGlobalConfig", () => $f3f6dcb6436f3bd8$export$ee996472bb397b41);
$parcel$export(module.exports, "useInsightReferenceTypes", () => $f3f6dcb6436f3bd8$export$efb93af726a65b26);
$parcel$export(module.exports, "useInsightStatusTypes", () => $f3f6dcb6436f3bd8$export$7eefa9cea32e596a);
$parcel$export(module.exports, "useInsightIcons", () => $f3f6dcb6436f3bd8$export$8336b36336c9f3c8);
$parcel$export(module.exports, "useDataManager", () => $f3f6dcb6436f3bd8$export$143bcc72da01e561);
$parcel$export(module.exports, "useCommonDataModel", () => $f3f6dcb6436f3bd8$export$a6f0c60c6d8cb283);
$parcel$export(module.exports, "useNamedInsightIcons", () => $f3f6dcb6436f3bd8$export$979b264266dab4ed);
$parcel$export(module.exports, "useIsRestrictedSchema", () => $f3f6dcb6436f3bd8$export$d07372ba961b2bc5);
$parcel$export(module.exports, "InsightGlobalConfigContainer", () => $f3f6dcb6436f3bd8$export$c4c69c73d422ea06);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7jTnu = parcelRequire("7jTnu");

var $1oAOi = parcelRequire("1oAOi");

var $3rcO4 = parcelRequire("3rcO4");
const $f3f6dcb6436f3bd8$export$d4c72bab9d6cc13a = {
    loading: false,
    error: undefined,
    config: undefined,
    referenceTypes: {
        data: undefined,
        createLoading: false,
        createError: undefined,
        deleteLoading: false,
        deleteError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    statusTypes: {
        data: undefined,
        createLoading: false,
        createError: undefined,
        deleteLoading: false,
        deleteError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    icons: {
        data: undefined,
        deleteLoading: false,
        deleteError: undefined,
        addLoading: false,
        addError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    dataManager: {
        rolesData: undefined,
        rolesError: undefined,
        rolesLoading: false,
        rolesUpdateLoading: false,
        rolesUpdateError: undefined,
        tokensLoading: false,
        tokensData: undefined,
        tokensError: undefined,
        tokenRevokeLoading: false,
        tokenRevokeError: undefined,
        isProvisioned: undefined,
        provisioningLoading: false,
        provisioningError: undefined,
        provisioningUpdateLoading: false,
        provisioningUpdateError: undefined,
        myRoles: undefined,
        myRolesError: undefined,
        myRolesLoading: false
    },
    cdm: {
        instantiations: [],
        tasks: []
    }
};
const $f3f6dcb6436f3bd8$var$Store = (0, $GtRbT.createStore)({
    initialState: $f3f6dcb6436f3bd8$export$d4c72bab9d6cc13a,
    actions: $1oAOi.actions
});
const $f3f6dcb6436f3bd8$export$ee996472bb397b41 = (0, $iJq0l.createHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: (state)=>state
});
const $f3f6dcb6436f3bd8$export$efb93af726a65b26 = (0, $iJq0l.createHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: ({ referenceTypes: referenceTypes })=>({
            ...referenceTypes,
            data: referenceTypes.data ? (0, $3rcO4.sortReferenceTypes)(referenceTypes.data) : undefined
        })
});
const $f3f6dcb6436f3bd8$export$7eefa9cea32e596a = (0, $iJq0l.createHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: ({ statusTypes: statusTypes })=>({
            ...statusTypes,
            data: statusTypes.data ? (0, $3rcO4.sortStatusTypes)(statusTypes.data) : undefined
        })
});
const $f3f6dcb6436f3bd8$export$8336b36336c9f3c8 = (0, $iJq0l.createHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: ({ icons: icons })=>icons
});
const $f3f6dcb6436f3bd8$export$143bcc72da01e561 = (0, $iJq0l.createHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: ({ dataManager: dataManager })=>dataManager
});
const $f3f6dcb6436f3bd8$export$a6f0c60c6d8cb283 = (0, $iJq0l.createHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: ({ cdm: cdm })=>cdm
});
const $f3f6dcb6436f3bd8$export$979b264266dab4ed = (0, $iJq0l.createStateHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: ({ icons: icons })=>{
        const map = {};
        (icons.data ?? []).forEach((icon)=>{
            map[icon.name] = icon;
        });
        return map;
    }
});
const $f3f6dcb6436f3bd8$export$9c8eee3abcaa634e = (state, schemaId)=>{
    const restrictedObjectSchemaIds = state.config?.restrictedObjectSchemaIds ?? [];
    return restrictedObjectSchemaIds.includes(parseInt(schemaId, 10));
};
const $f3f6dcb6436f3bd8$export$d07372ba961b2bc5 = (0, $iJq0l.createHook)($f3f6dcb6436f3bd8$var$Store, {
    selector: $f3f6dcb6436f3bd8$export$9c8eee3abcaa634e
});
const $f3f6dcb6436f3bd8$var$autoFetchGlobalConfig = ()=>({ dispatch: dispatch, getState: getState }, { disableOnInit: disableOnInit })=>{
        const { loading: loading, error: error, config: config } = getState();
        if (!disableOnInit && !loading && !error && !config) {
            dispatch((0, $1oAOi.actions).fetchGlobalConfig());
            if ((0, $7jTnu.fg)('assets_cdm_ui_flow')) dispatch((0, $1oAOi.actions).fetchCdm());
            if ((0, $7jTnu.fg)('assets_as_an_app_v2')) {
                dispatch((0, $1oAOi.actions).fetchProvisioningStatus());
                dispatch((0, $1oAOi.actions).fetchMyDataManagerRoles());
            }
        }
    };
const $f3f6dcb6436f3bd8$export$c4c69c73d422ea06 = (0, $6E16M.createContainer)($f3f6dcb6436f3bd8$var$Store, {
    onInit: $f3f6dcb6436f3bd8$var$autoFetchGlobalConfig
});

});
parcelRegister("1oAOi", function(module, exports) {

$parcel$export(module.exports, "actions", () => $9296c6c643eaa82b$export$e324594224ef24da);

var $fIoaM = parcelRequire("fIoaM");

var $iJT9U = parcelRequire("iJT9U");

var $2C4Rj = parcelRequire("2C4Rj");

var $h47uz = parcelRequire("h47uz");

var $cV2bE = parcelRequire("cV2bE");

var $iPKXq = parcelRequire("iPKXq");

var $By5DJ = parcelRequire("By5DJ");

var $6Cb8J = parcelRequire("6Cb8J");

var $lGsG0 = parcelRequire("lGsG0");

var $5bX6s = parcelRequire("5bX6s");

var $gZE7d = parcelRequire("gZE7d");

var $4rYWs = parcelRequire("4rYWs");

var $gD7PH = parcelRequire("gD7PH");

var $2DRSe = parcelRequire("2DRSe");

var $fiFnI = parcelRequire("fiFnI");

var $fHTJ8 = parcelRequire("fHTJ8");

var $3Zqe3 = parcelRequire("3Zqe3");

var $2La61 = parcelRequire("2La61");

var $gVUS4 = parcelRequire("gVUS4");
const $9296c6c643eaa82b$export$e324594224ef24da = {
    addIcon: $fIoaM.addIcon,
    createReferenceType: $iJT9U.createReferenceType,
    createStatusType: $2C4Rj.createStatusType,
    deleteIcon: $h47uz.deleteIcon,
    deleteReferenceType: $cV2bE.deleteReferenceType,
    deleteStatusType: $iPKXq.deleteStatusType,
    fetchCdm: $4rYWs.fetchCdm,
    fetchDataManagerTokens: $gZE7d.fetchDataManagerTokens,
    fetchGlobalConfig: $By5DJ.fetchGlobalConfig,
    fetchMyDataManagerRoles: $6Cb8J.fetchMyDataManagerRoles,
    fetchPrincipalsForRoles: $lGsG0.fetchPrincipalsForRoles,
    fetchProvisioningStatus: $5bX6s.fetchProvisioningStatus,
    installCdm: $gD7PH.installCdm,
    removeCdm: $2DRSe.removeCdm,
    setIcon: $fHTJ8.setIcon,
    setReferenceType: $2La61.setReferenceType,
    setStatusType: $gVUS4.setStatusType,
    updateDataManagerRole: $fiFnI.updateDataManagerRole,
    updateIcon: $fHTJ8.updateIcon,
    updateProvisioningStatus: $3Zqe3.updateProvisioningStatus,
    updateReferenceType: $2La61.updateReferenceType,
    updateStatusType: $gVUS4.updateStatusType
};

});
parcelRegister("fIoaM", function(module, exports) {

$parcel$export(module.exports, "addIcon", () => $d0ee33600976fc3c$export$3488242433cbedb);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $4ZeQj = parcelRequire("4ZeQj");

var $5HQxN = parcelRequire("5HQxN");

var $6hqfW = parcelRequire("6hqfW");
const $d0ee33600976fc3c$export$3488242433cbedb = (newIcon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                addLoading: true
            }
        });
        try {
            const uploadCredentials = await (0, $6hqfW.mediaInfoForUpload)((0, $4ZeQj.toWorkspaceId)(workspaceId));
            const uploadMediaResult = await (0, $6hqfW.mediaUploadFile)({
                mediaBaseUrl: (0, $5HQxN.toMediaBaseUrl)(uploadCredentials.mediaBaseUrl),
                collectionId: (0, $5HQxN.toCollectionId)(uploadCredentials.collectionId),
                fileName: (0, $5HQxN.toFileName)(newIcon.fileName),
                clientId: (0, $5HQxN.toMediaClientId)(uploadCredentials.clientId),
                mediaJwtToken: (0, $5HQxN.toMediaJwt)(uploadCredentials.mediaJwtToken),
                blob: newIcon.blob
            });
            const mediaInfoForPullingResult = await (0, $6hqfW.mediaInfoForPulling)((0, $4ZeQj.toWorkspaceId)(workspaceId), (0, $5HQxN.toMediaFileUuid)(uploadMediaResult.data.id));
            const pollMediaFileReady = ()=>{
                const getMediaFileStatus = ()=>(0, $6hqfW.mediaGetFileInfo)({
                        mediaBaseUrl: (0, $5HQxN.toMediaBaseUrl)(mediaInfoForPullingResult.mediaBaseUrl),
                        mediaFileUuid: (0, $5HQxN.toMediaFileUuid)(uploadMediaResult.data.id),
                        clientId: (0, $5HQxN.toMediaClientId)(uploadCredentials.clientId),
                        mediaJwtToken: (0, $5HQxN.toMediaJwt)(mediaInfoForPullingResult.mediaJwtToken)
                    });
                return new Promise((resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
                reject)=>{
                    const poll = (attempt = 0)=>{
                        const statusPromise = getMediaFileStatus();
                        statusPromise.then((response)=>{
                            const status = response.data.processingStatus;
                            switch(status){
                                default:
                                case (0, $5HQxN.MEDIA_PROCESS_STATUS).PENDING:
                                case (0, $5HQxN.MEDIA_PROCESS_STATUS).RUNNING:
                                    return setTimeout(()=>{
                                        // 20 tries before throwing an error
                                        if (attempt > 20) return reject(new Error('Failed to add icon after 10 tries'));
                                        return poll(attempt + 1);
                                    }, 5000);
                                case (0, $5HQxN.MEDIA_PROCESS_STATUS).SUCCEEDED:
                                    // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                                    return resolve();
                                case (0, $5HQxN.MEDIA_PROCESS_STATUS).FAILED:
                                    return reject(new Error('Media services failed to process file!'));
                            }
                        }).catch((error)=>reject(new Error(error)));
                    };
                    poll();
                });
            };
            await pollMediaFileReady();
            const savedIconEntry = await (0, $6hqfW.publishNewIcon)((0, $4ZeQj.toWorkspaceId)(workspaceId), (0, $5HQxN.toIconName)(newIcon.iconName), (0, $5HQxN.toMediaFileUuid)(uploadMediaResult.data.id));
            // Make flow happy
            if (!Array.isArray(state.icons.data)) throw new Error('Invalid state! Icons data is not array!');
            const newIconsData = state.icons.data.slice(0);
            newIconsData.unshift(savedIconEntry);
            const newState = {
                ...state,
                icons: {
                    ...state.icons,
                    addLoading: false,
                    data: newIconsData
                }
            };
            setState(newState);
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'addIcon succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    addLoading: false,
                    addError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'addIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("5HQxN", function(module, exports) {

$parcel$export(module.exports, "MEDIA_PROCESS_STATUS", () => $687072a3a8f399e1$export$a760cae7c12e7f51);
$parcel$export(module.exports, "toMediaBaseUrl", () => $687072a3a8f399e1$export$342e5c2fdd47297c);
$parcel$export(module.exports, "toCollectionId", () => $687072a3a8f399e1$export$59b8a2c37e183bf5);
$parcel$export(module.exports, "toIconName", () => $687072a3a8f399e1$export$41540e96af228b1a);
$parcel$export(module.exports, "toFileName", () => $687072a3a8f399e1$export$249aa0c12095aafd);
$parcel$export(module.exports, "toMediaJwt", () => $687072a3a8f399e1$export$dce78fe68aa68f20);
$parcel$export(module.exports, "toMediaFileUuid", () => $687072a3a8f399e1$export$79083a8ab294d28e);
$parcel$export(module.exports, "toMediaClientId", () => $687072a3a8f399e1$export$b105972f97cb69fa);
const $687072a3a8f399e1$export$a760cae7c12e7f51 = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    PENDING: 'pending',
    RUNNING: 'running'
};
const $687072a3a8f399e1$export$342e5c2fdd47297c = (url)=>url;
const $687072a3a8f399e1$export$59b8a2c37e183bf5 = (uuid)=>uuid;
const $687072a3a8f399e1$export$41540e96af228b1a = (iconName)=>iconName;
const $687072a3a8f399e1$export$249aa0c12095aafd = (fileName)=>fileName;
const $687072a3a8f399e1$export$9dd52a3c923cba73 = (mediaIssuer)=>mediaIssuer;
const $687072a3a8f399e1$export$dce78fe68aa68f20 = (mediaIssuer)=>mediaIssuer;
const $687072a3a8f399e1$export$79083a8ab294d28e = (mediaFileUuid)=>mediaFileUuid;
const $687072a3a8f399e1$export$b105972f97cb69fa = (mediaClientId)=>mediaClientId;

});

parcelRegister("6hqfW", function(module, exports) {

$parcel$export(module.exports, "mediaInfoForUpload", () => $5faeeb81fc4d556d$export$c7944179dc1cb15d);
$parcel$export(module.exports, "mediaUploadFile", () => $5faeeb81fc4d556d$export$6fba374ded90c76b);
$parcel$export(module.exports, "mediaInfoForPulling", () => $5faeeb81fc4d556d$export$4138ca7fa1c5dcbc);
$parcel$export(module.exports, "mediaGetFileInfo", () => $5faeeb81fc4d556d$export$c607c6f99a3a53ca);
$parcel$export(module.exports, "publishNewIcon", () => $5faeeb81fc4d556d$export$a7fc7d8db8ccf9da);

var $jGzN3 = parcelRequire("jGzN3");

var $u4YbY = parcelRequire("u4YbY");

var $lqJW7 = parcelRequire("lqJW7");
const $5faeeb81fc4d556d$export$336c36f125eba39c = ({ clientId: clientId, mediaJwtToken: mediaJwtToken })=>{
    return {
        'X-Client-Id': clientId,
        Authorization: `Bearer ${mediaJwtToken}`
    };
};
const $5faeeb81fc4d556d$export$c7944179dc1cb15d = (workspaceId)=>(0, $u4YbY.performCmdbGetRequest)((0, $lqJW7.getCmdbIconTokenUploadingUrl)(workspaceId));
const $5faeeb81fc4d556d$export$6fba374ded90c76b = ({ mediaBaseUrl: mediaBaseUrl, collectionId: collectionId, fileName: fileName, mediaJwtToken: mediaJwtToken, blob: blob, clientId: clientId })=>(0, $jGzN3.performPostRequest)(`${String(mediaBaseUrl)}/file/binary?collection=${String(collectionId)}&name=${String(fileName)}&deletable=true`, {
        headers: {
            ...$5faeeb81fc4d556d$export$336c36f125eba39c({
                clientId: clientId,
                mediaJwtToken: mediaJwtToken
            }),
            'Content-Type': blob.type
        },
        body: blob
    });
const $5faeeb81fc4d556d$export$4138ca7fa1c5dcbc = (workspaceId, fileUuid)=>(0, $u4YbY.performCmdbGetRequest)((0, $lqJW7.getCmdbIconTokenFetchingUrl)(workspaceId, fileUuid));
const $5faeeb81fc4d556d$export$c607c6f99a3a53ca = ({ mediaBaseUrl: mediaBaseUrl, mediaFileUuid: mediaFileUuid, mediaJwtToken: mediaJwtToken, clientId: clientId })=>(0, $jGzN3.performGetRequest)(`${String(mediaBaseUrl)}/file/${String(mediaFileUuid)}`, {
        headers: $5faeeb81fc4d556d$export$336c36f125eba39c({
            clientId: clientId,
            mediaJwtToken: mediaJwtToken
        })
    });
const $5faeeb81fc4d556d$export$a7fc7d8db8ccf9da = (workspaceId, iconName, mediaFileUuid)=>(0, $u4YbY.performCmdbPostRequest)((0, $lqJW7.getCmdbIconCreateUrl)(workspaceId), {
        body: JSON.stringify({
            name: iconName,
            mediaFileUuid: mediaFileUuid
        })
    });

});
parcelRegister("lqJW7", function(module, exports) {

$parcel$export(module.exports, "getCmdbIconCreateUrl", () => $20ff293724bf60de$export$4c6ff27b48881aba);
$parcel$export(module.exports, "getCmdbIconTokenFetchingUrl", () => $20ff293724bf60de$export$39e83f10cc93fe99);
$parcel$export(module.exports, "getCmdbIconTokenUploadingUrl", () => $20ff293724bf60de$export$7fdc9cd59a492763);
$parcel$export(module.exports, "getCmdbIconByIdUrl", () => $20ff293724bf60de$export$b881a625e1bc4876);

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/icon
 */ const $20ff293724bf60de$var$getCmdbIconUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/icon`;
const $20ff293724bf60de$export$4c6ff27b48881aba = (workspaceId)=>`${$20ff293724bf60de$var$getCmdbIconUrl(workspaceId)}/create`;
const $20ff293724bf60de$export$39e83f10cc93fe99 = (workspaceId, fileUuid)=>`${$20ff293724bf60de$var$getCmdbIconUrl(workspaceId)}/token-for-fetching-icon/${fileUuid}`;
const $20ff293724bf60de$export$7fdc9cd59a492763 = (workspaceId)=>`${$20ff293724bf60de$var$getCmdbIconUrl(workspaceId)}/token-for-uploading-icon`;
const $20ff293724bf60de$export$b881a625e1bc4876 = (workspaceId, iconId)=>`${$20ff293724bf60de$var$getCmdbIconUrl(workspaceId)}/${iconId}`;

});



parcelRegister("iJT9U", function(module, exports) {

$parcel$export(module.exports, "createReferenceType", () => $64fa609e4fb44864$export$ac28770630794807);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $64fa609e4fb44864$export$ac28770630794807 = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                createLoading: true
            }
        });
        try {
            const response = await (0, $u4YbY.performCmdbPostRequest)((0, $fKDKn.getCmdbConfigReferenceTypeUrl)(workspaceId), {
                body: JSON.stringify({
                    ...data,
                    color: data.color.replace('#', '')
                })
            });
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    createLoading: false,
                    data: [
                        ...state.referenceTypes.data ?? [],
                        response
                    ]
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'createReferenceType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    createLoading: false,
                    createError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'createReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("fKDKn", function(module, exports) {

$parcel$export(module.exports, "getCmdbConfigStatusTypeUrl", () => $d87cbbb4189fe650$export$3269d36b59c9d27f);
$parcel$export(module.exports, "getCmdbConfigStatusTypeByIdUrl", () => $d87cbbb4189fe650$export$229964acb6a55e5);
$parcel$export(module.exports, "getCmdbConfigStatusTypePickerUrl", () => $d87cbbb4189fe650$export$1991fb4d07b18469);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeUrl", () => $d87cbbb4189fe650$export$ad07341c88d2bbab);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeByIdUrl", () => $d87cbbb4189fe650$export$293e2bfa6752a2aa);
$parcel$export(module.exports, "getCmdbConfigRoleByIdUrl", () => $d87cbbb4189fe650$export$225d5f547cc90d86);
$parcel$export(module.exports, "getCmdbConfigRoleObjectSchemaByIdUrl", () => $d87cbbb4189fe650$export$9c1d73050da32aae);
$parcel$export(module.exports, "getCmdbConfigRoleObjectTypeByIdUrl", () => $d87cbbb4189fe650$export$6583ed007df50d2b);
$parcel$export(module.exports, "getCmdbPermsPrincipalUrl", () => $d87cbbb4189fe650$export$a635e2e9382b1621);
$parcel$export(module.exports, "getCmdbPermsRoleAssignmentUrl", () => $d87cbbb4189fe650$export$b3cb4590859563b0);
$parcel$export(module.exports, "getCmdbPermsTokenStatusUrl", () => $d87cbbb4189fe650$export$8ae00db5fd7218c5);
$parcel$export(module.exports, "getMyDataManagerRolesUrl", () => $d87cbbb4189fe650$export$794aa3ae46133f30);

var $b5RwB = parcelRequire("b5RwB");

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/config
 */ const $d87cbbb4189fe650$var$getCmdbConfigUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/config`;
const $d87cbbb4189fe650$export$3269d36b59c9d27f = (workspaceId, queryParams)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/statustype${queryParams ? `?${(0, $b5RwB.stringify)(queryParams)}` : ''}`;
const $d87cbbb4189fe650$export$229964acb6a55e5 = (workspaceId, statusTypeId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/statustype/${statusTypeId}`;
const $d87cbbb4189fe650$export$1991fb4d07b18469 = (workspaceId, queryParams)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/statustype/picker?${(0, $b5RwB.stringify)(queryParams)}`;
const $d87cbbb4189fe650$export$ad07341c88d2bbab = (workspaceId, queryParams)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/referencetype${queryParams ? `?${(0, $b5RwB.stringify)(queryParams)}` : ''}`;
const $d87cbbb4189fe650$export$293e2bfa6752a2aa = (workspaceId, referenceTypeId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/referencetype/${referenceTypeId}`;
const $d87cbbb4189fe650$export$225d5f547cc90d86 = (workspaceId, roleId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/role/${roleId}`;
const $d87cbbb4189fe650$export$9c1d73050da32aae = (workspaceId, objectSchemaId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/role/objectschema/${objectSchemaId}`;
const $d87cbbb4189fe650$export$6583ed007df50d2b = (workspaceId, objectTypeId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/role/objecttype/${objectTypeId}`;
const $d87cbbb4189fe650$export$a635e2e9382b1621 = (workspaceId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/perms/principal`;
const $d87cbbb4189fe650$export$b3cb4590859563b0 = (workspaceId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/perms/role-assignment`;
const $d87cbbb4189fe650$export$8ae00db5fd7218c5 = (workspaceId, token)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/perms/token-status?token=${token}`;
const $d87cbbb4189fe650$export$794aa3ae46133f30 = (workspaceId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/perms/my-roles`;

});


parcelRegister("2C4Rj", function(module, exports) {

$parcel$export(module.exports, "createStatusType", () => $1bd01e2f5ad92599$export$8c874b16a69a1b9d);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $1bd01e2f5ad92599$export$8c874b16a69a1b9d = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                createLoading: true
            }
        });
        try {
            const response = await (0, $u4YbY.performCmdbPostRequest)((0, $fKDKn.getCmdbConfigStatusTypeUrl)(workspaceId), {
                body: JSON.stringify(data)
            });
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    createLoading: false,
                    data: [
                        ...state.statusTypes.data ?? [],
                        response
                    ]
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({
                source: 'insightGlobalConfigStatuses',
                action: 'created',
                actionSubject: 'insightGlobalConfigStatuses'
            }), 'insightGlobalConfigStatuses created');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    createLoading: false,
                    createError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'createStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("h47uz", function(module, exports) {

$parcel$export(module.exports, "deleteIcon", () => $58a614888a6e10f0$export$12d45ee5c2161b75);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $lqJW7 = parcelRequire("lqJW7");
const $58a614888a6e10f0$export$12d45ee5c2161b75 = (icon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                deleteLoading: true
            }
        });
        try {
            await (0, $u4YbY.performCmdbDeleteRequest)((0, $lqJW7.getCmdbIconByIdUrl)(workspaceId, icon.id));
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    deleteLoading: false,
                    data: state.icons.data ? state.icons.data.filter(({ id: id })=>id !== icon.id) : undefined
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteIcon succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("cV2bE", function(module, exports) {

$parcel$export(module.exports, "deleteReferenceType", () => $3ce5070dcba7feb3$export$432ee1f3819316e5);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $3ce5070dcba7feb3$export$432ee1f3819316e5 = (referenceType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                deleteLoading: true
            }
        });
        try {
            await (0, $u4YbY.performCmdbDeleteRequest)((0, $fKDKn.getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceType.id));
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    deleteLoading: false,
                    data: state.referenceTypes.data ? state.referenceTypes.data.filter(({ id: id })=>id !== referenceType.id) : undefined
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteReferenceType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("iPKXq", function(module, exports) {

$parcel$export(module.exports, "deleteStatusType", () => $39c0952453d37c81$export$812423dc05f0fc3d);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $39c0952453d37c81$export$812423dc05f0fc3d = (statusType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                deleteLoading: true
            }
        });
        try {
            await (0, $u4YbY.performCmdbDeleteRequest)((0, $fKDKn.getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusType.id));
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    deleteLoading: false,
                    data: state.statusTypes.data ? state.statusTypes.data.filter(({ id: id })=>id !== statusType.id) : undefined
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteStatusType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("By5DJ", function(module, exports) {

$parcel$export(module.exports, "fetchGlobalConfig", () => $34c4cb0969790d4d$export$14c75ba3f0e48e21);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $9VcRq = parcelRequire("9VcRq");
const $34c4cb0969790d4d$export$14c75ba3f0e48e21 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().loading || !shouldRefetch && getState().config) return;
        setState({
            loading: true,
            error: undefined
        });
        try {
            const response = await (0, $u4YbY.performCmdbGetRequest)((0, $9VcRq.getCmdbGlobalConfigUrl)(workspaceId));
            const iconListWithServiceOTEntriesRemoved = response ? response.icons.filter((item)=>item.name !== 'Applications' && item.name !== 'Business Services' && item.name !== 'Capabilities' && item.name !== 'Software Services') : undefined;
            setState({
                ...getState(),
                loading: false,
                config: {
                    ...response,
                    restrictedObjectSchemaIds: response?.restrictedObjectSchemaIds ?? [],
                    icons: iconListWithServiceOTEntriesRemoved || []
                },
                referenceTypes: {
                    ...getState().referenceTypes,
                    data: response ? response.referenceTypes : undefined
                },
                statusTypes: {
                    ...getState().statusTypes,
                    data: response ? response.statusTypes : undefined
                },
                icons: {
                    ...getState().icons,
                    data: iconListWithServiceOTEntriesRemoved
                },
                dataManager: {
                    ...getState().dataManager
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchInsightGlobalConfig succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchInsightGlobalConfig',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("9VcRq", function(module, exports) {

$parcel$export(module.exports, "getCmdbGlobalConfigUrl", () => $4638d838a8d16ed5$export$50437136a9a5e2d3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectUrl", () => $4638d838a8d16ed5$export$73e58b72a1074528);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdUrl", () => $4638d838a8d16ed5$export$e2019224257efde3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdPropertyUrl", () => $4638d838a8d16ed5$export$d1b25f8feb06db8a);

var $b5RwB = parcelRequire("b5RwB");

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/global
 */ const $4638d838a8d16ed5$var$getCmdbGlobalUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/global`;
const $4638d838a8d16ed5$export$50437136a9a5e2d3 = (workspaceId)=>`${$4638d838a8d16ed5$var$getCmdbGlobalUrl(workspaceId)}/config`;
const $4638d838a8d16ed5$export$73e58b72a1074528 = (workspaceId, queryParams)=>`${$4638d838a8d16ed5$var$getCmdbGlobalUrl(workspaceId)}/config/object?${(0, $b5RwB.stringify)(queryParams)}`;
const $4638d838a8d16ed5$export$e2019224257efde3 = (workspaceId, objectSchemaId)=>`${$4638d838a8d16ed5$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}`;
const $4638d838a8d16ed5$export$d1b25f8feb06db8a = (workspaceId, objectSchemaId)=>`${$4638d838a8d16ed5$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}/property`;

});


parcelRegister("6Cb8J", function(module, exports) {

$parcel$export(module.exports, "fetchMyDataManagerRoles", () => $e94c5c24a8debe33$export$2211f294ebd95b92);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $e94c5c24a8debe33$export$2211f294ebd95b92 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().dataManager.myRolesLoading || !shouldRefetch && getState().dataManager.myRoles) return;
        setState({
            dataManager: {
                ...getState().dataManager,
                myRolesLoading: true,
                myRolesError: undefined
            }
        });
        try {
            const myRoles = await (0, $u4YbY.performCmdbGetRequest)((0, $fKDKn.getMyDataManagerRolesUrl)(workspaceId));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    myRoles: myRoles.results,
                    myRolesLoading: false
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchMyDataManagerRoles succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                dataManager: {
                    ...getState().dataManager,
                    myRolesLoading: false,
                    myRolesError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchMyDataManagerRoles',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("lGsG0", function(module, exports) {

$parcel$export(module.exports, "fetchPrincipalsForRoles", () => $a296a821a7b7673f$export$9c5110cfdcb72b5);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $a296a821a7b7673f$export$9c5110cfdcb72b5 = (roleIds)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.rolesLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                rolesLoading: true
            }
        });
        try {
            const requestBody = {
                roleIds: roleIds,
                resourceId: `ari:cloud:cmdb::workspace/${workspaceId}`
            };
            const principalIdsForRoles = await (0, $u4YbY.performCmdbPostRequest)((0, $fKDKn.getCmdbPermsPrincipalUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            setState({
                dataManager: {
                    ...state.dataManager,
                    rolesData: principalIdsForRoles.results,
                    rolesLoading: false
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchPrincipalsForRoles succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesLoading: false,
                    rolesError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchPrincipalsForRoles',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("5bX6s", function(module, exports) {

$parcel$export(module.exports, "fetchProvisioningStatus", () => $2e05b752de2d55a4$export$aa3ea988cce42be1);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $5Up1u = parcelRequire("5Up1u");
const $2e05b752de2d55a4$export$aa3ea988cce42be1 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().dataManager.provisioningLoading || !shouldRefetch && // isProvisioned is a boolean so needs to specifically check undefined
        getState().dataManager.isProvisioned !== undefined) return;
        setState({
            dataManager: {
                ...getState().dataManager,
                provisioningLoading: true,
                provisioningError: undefined
            }
        });
        try {
            const result = await (0, $u4YbY.performCmdbGetRequest)((0, $5Up1u.getDataManagerProvisioningStatusUrl)(workspaceId));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    isProvisioned: $2e05b752de2d55a4$var$isProvisioned(result.enabled),
                    provisioningLoading: false
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchProvisioningStatus succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                dataManager: {
                    ...getState().dataManager,
                    provisioningLoading: false,
                    provisioningError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchProvisioningStatus',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };
const $2e05b752de2d55a4$var$isProvisioned = (status)=>status === 'ON';

});
parcelRegister("5Up1u", function(module, exports) {

$parcel$export(module.exports, "getDataManagerGenerateContainerTokenUrl", () => $7015e8b3da3717eb$export$5f42b4e80a66d7c);
$parcel$export(module.exports, "delDataManagerContainerTokenUrl", () => $7015e8b3da3717eb$export$ddc5a4cb751fae27);
$parcel$export(module.exports, "getDataManagerFetchContainerTokenUrl", () => $7015e8b3da3717eb$export$591d877d695dbd95);
$parcel$export(module.exports, "getDataManagerProvisioningStatusUrl", () => $7015e8b3da3717eb$export$1dd01c50c7948938);

var $1qZG3 = parcelRequire("1qZG3");
const $7015e8b3da3717eb$export$5f42b4e80a66d7c = (workspaceId, label, type, duration)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${type}?label=${label}&duration=${duration}`;
const $7015e8b3da3717eb$export$ddc5a4cb751fae27 = (workspaceId, tokenID)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${tokenID}`;
const $7015e8b3da3717eb$export$591d877d695dbd95 = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token`;
const $7015e8b3da3717eb$export$1dd01c50c7948938 = (workspaceId)=>`${$7015e8b3da3717eb$var$getAirtrackAppRestBaseUrl(workspaceId)}/config/sync/provisioningstatus`;
const $7015e8b3da3717eb$var$getAirtrackAppRestBaseUrl = (workspaceId)=>`/gateway/api/jsm/data-manager/workspace/${workspaceId}/app`;

});


parcelRegister("gZE7d", function(module, exports) {

$parcel$export(module.exports, "fetchDataManagerTokens", () => $c1827c9da32df0ba$export$c6b3de84befa4259);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $5Up1u = parcelRequire("5Up1u");
const $c1827c9da32df0ba$export$c6b3de84befa4259 = ()=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.tokensLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                tokensLoading: true
            }
        });
        try {
            const tokenDetails = await (0, $u4YbY.performCmdbGetRequest)((0, $5Up1u.getDataManagerFetchContainerTokenUrl)(workspaceId));
            setState({
                dataManager: {
                    ...state.dataManager,
                    tokensData: tokenDetails.tokens,
                    tokensLoading: false
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchDataManagerTokens succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    tokensLoading: false,
                    tokensError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchDataManagerTokens',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("4rYWs", function(module, exports) {

$parcel$export(module.exports, "fetchCdm", () => $f04409399df93f85$export$dc14adeb4c2a88f9);
const $f04409399df93f85$export$dc14adeb4c2a88f9 = ()=>async ({ setState: setState, getState: getState })=>{
        // eslint-disable-next-line no-console
        console.log('fetchCdm action called');
        // Mock API calls - returning empty arrays for now
        const [instantiationsResponse, tasksResponse] = await Promise.all([
            // TODO: Replace with actual endpoint calls
            // performCmdbGetRequest('/v1/bundle/instantiated/list'),
            // performCmdbGetRequest('/v1/tasks'),
            Promise.resolve([]),
            Promise.resolve([])
        ]);
        const state = getState();
        // Update CDM state with fetched data
        setState({
            ...state,
            cdm: {
                instantiations: instantiationsResponse,
                tasks: tasksResponse
            }
        });
    };

});

parcelRegister("gD7PH", function(module, exports) {

$parcel$export(module.exports, "installCdm", () => $dba6d3d189b95432$export$2f65091e2af212f7);
const $dba6d3d189b95432$export$2f65091e2af212f7 = ()=>async ({ setState: setState, getState: getState })=>{
        // TODO: Implement the actual CDM instantiation logic here
        // submitAsyncCdmBundleInstantiationTask
        // useCmdbAsyncBundleInstantiation
        const state = getState();
        // Fake CDM instantiation task
        setState({
            ...state,
            cdm: {
                ...state.cdm,
                tasks: [
                    ...state.cdm.tasks,
                    'instantiateBundle'
                ]
            }
        });
        // Wait 2 seconds
        await new Promise((resolve)=>setTimeout(resolve, 2000));
        // Remove the task and add mock instantiation
        setState({
            ...getState(),
            cdm: {
                instantiations: [
                    {
                        something: 'something'
                    }
                ],
                tasks: []
            }
        });
    };

});

parcelRegister("2DRSe", function(module, exports) {

$parcel$export(module.exports, "removeCdm", () => $f2cd334432cbf621$export$b5d0396f9158511d);
const $f2cd334432cbf621$export$b5d0396f9158511d = ()=>async ({ setState: setState, getState: getState })=>{
        // eslint-disable-next-line no-console
        console.log('removeCdm action called');
        const state = getState();
        // Add removing task
        setState({
            ...state,
            cdm: {
                ...state.cdm,
                tasks: [
                    ...state.cdm.tasks,
                    'deleteBundle'
                ]
            }
        });
        // Wait 2 seconds
        await new Promise((resolve)=>setTimeout(resolve, 2000));
        // Remove the task and add mock instantiation
        setState({
            ...getState(),
            cdm: {
                instantiations: [],
                tasks: []
            }
        });
    };

});

parcelRegister("fiFnI", function(module, exports) {

$parcel$export(module.exports, "updateDataManagerRole", () => $3b770298be73ab3a$export$314337b594e79a51);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $3b770298be73ab3a$export$93aad6482f82f57d = 5000;
const $3b770298be73ab3a$export$214f23982cabf5f8 = 1000;
const $3b770298be73ab3a$export$314337b594e79a51 = ({ principalIds: principalIds, roleId: roleId })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.rolesUpdateLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                rolesUpdateLoading: true
            }
        });
        try {
            const requestBody = {
                principalIds: principalIds,
                roleId: roleId,
                resourceType: 'workspace'
            };
            const updateRolesResponse = await (0, $u4YbY.performCmdbPutRequest)((0, $fKDKn.getCmdbPermsRoleAssignmentUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            const pollTimeoutTime = new Date(Date.now() + $3b770298be73ab3a$export$93aad6482f82f57d).getTime();
            // poll the checking of the token status for 5 seconds as updating of
            // Identity role assignments have eventually consistency
            const tryPollTokenStatus = async (resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
            reject)=>{
                if (Date.now() > pollTimeoutTime) {
                    reject(new Error('Some role assignments have failed or is still in progress'));
                    return;
                }
                try {
                    const url = (0, $fKDKn.getCmdbPermsTokenStatusUrl)(workspaceId, updateRolesResponse.tokens[updateRolesResponse.tokens.length - 1]);
                    const updateRoleAssignmentToken = await (0, $u4YbY.performCmdbGetRequest)(url);
                    if (updateRoleAssignmentToken.isSuccessful) {
                        resolve();
                        return;
                    }
                    setTimeout(()=>{
                        tryPollTokenStatus(resolve, reject);
                    }, $3b770298be73ab3a$export$214f23982cabf5f8);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    // Ignore unexpected network/server error and quickly retry
                    setTimeout(()=>{
                        tryPollTokenStatus(resolve, reject);
                    }, $3b770298be73ab3a$export$214f23982cabf5f8);
                }
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            await new Promise((res, rej)=>tryPollTokenStatus(res, rej));
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesUpdateLoading: false
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateDataManagerRole succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesUpdateLoading: false,
                    rolesUpdateError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateDataManagerRole',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'data-manager'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("fHTJ8", function(module, exports) {

$parcel$export(module.exports, "setIcon", () => $45b1977ec6542cfd$export$33914de34c28be6c);
$parcel$export(module.exports, "updateIcon", () => $45b1977ec6542cfd$export$89ea7ff652eb14dd);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $lqJW7 = parcelRequire("lqJW7");
const $45b1977ec6542cfd$export$33914de34c28be6c = (updatedIcon)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.icons.data?.map((icon)=>icon.id === updatedIcon.id ? updatedIcon : icon);
        setState({
            ...state,
            icons: {
                ...state.icons,
                data: updatedData
            }
        });
    };
const $45b1977ec6542cfd$export$89ea7ff652eb14dd = ({ iconId: iconId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $u4YbY.performCmdbPutRequest)((0, $lqJW7.getCmdbIconByIdUrl)(workspaceId, iconId), {
                body: JSON.stringify(updatedProperties)
            });
            const updatedState = getState();
            const updatedData = updatedState.icons.data?.map((icon)=>icon.id === response.id ? response : icon);
            setState({
                ...updatedState,
                icons: {
                    ...updatedState.icons,
                    updateLoading: false,
                    data: updatedData
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateIcon succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                icons: {
                    ...updatedState.icons,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("3Zqe3", function(module, exports) {

$parcel$export(module.exports, "updateProvisioningStatus", () => $606e8565e91a4fc0$export$ae3c5292a85a06f4);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $5Up1u = parcelRequire("5Up1u");
const $606e8565e91a4fc0$export$ae3c5292a85a06f4 = ({ isEnabled: isEnabled })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.provisioningUpdateLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                isProvisioned: isEnabled,
                provisioningUpdateLoading: true
            }
        });
        try {
            const requestBody = {
                enabled: isEnabled
            };
            await (0, $u4YbY.performCmdbPutRequest)((0, $5Up1u.getDataManagerProvisioningStatusUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            const result = await (0, $u4YbY.performCmdbGetRequest)((0, $5Up1u.getDataManagerProvisioningStatusUrl)(workspaceId));
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    isProvisioned: result.enabled === 'ON',
                    provisioningUpdateLoading: false
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateProvisioningStatus succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    provisioningUpdateLoading: false,
                    provisioningUpdateError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateProvisioningStatus',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("2La61", function(module, exports) {

$parcel$export(module.exports, "setReferenceType", () => $343eae8ce4ee1012$export$7c6efce0302318d);
$parcel$export(module.exports, "updateReferenceType", () => $343eae8ce4ee1012$export$f9e29a0f21a33136);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $343eae8ce4ee1012$export$7c6efce0302318d = (updatedReferenceType)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.referenceTypes.data?.map((referenceType)=>referenceType.id === updatedReferenceType.id ? updatedReferenceType : referenceType);
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                data: updatedData
            }
        });
    };
const $343eae8ce4ee1012$export$f9e29a0f21a33136 = ({ referenceTypeId: referenceTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $u4YbY.performCmdbPutRequest)((0, $fKDKn.getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceTypeId), {
                body: JSON.stringify({
                    ...updatedProperties,
                    color: updatedProperties.color !== undefined ? updatedProperties.color.replace('#', '') : undefined
                })
            });
            const updatedState = getState();
            const updatedData = updatedState.referenceTypes.data?.map((referenceType)=>referenceType.id === response.id ? response : referenceType);
            setState({
                ...updatedState,
                referenceTypes: {
                    ...updatedState.referenceTypes,
                    updateLoading: false,
                    data: updatedData || undefined
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateReferenceType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                referenceTypes: {
                    ...updatedState.referenceTypes,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("gVUS4", function(module, exports) {

$parcel$export(module.exports, "setStatusType", () => $a16b97a1719c03fb$export$80a24939e43be67c);
$parcel$export(module.exports, "updateStatusType", () => $a16b97a1719c03fb$export$2174575c3f57e8f8);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $a16b97a1719c03fb$export$80a24939e43be67c = (updatedStatusType)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.statusTypes.data?.map((statusType)=>statusType.id === updatedStatusType.id ? updatedStatusType : statusType);
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                data: updatedData
            }
        });
    };
const $a16b97a1719c03fb$export$2174575c3f57e8f8 = ({ statusTypeId: statusTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $u4YbY.performCmdbPutRequest)((0, $fKDKn.getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusTypeId), {
                body: JSON.stringify(updatedProperties)
            });
            const updatedState = getState();
            const updatedData = updatedState.statusTypes.data?.map((statusType)=>statusType.id === response.id ? response : statusType);
            setState({
                ...updatedState,
                statusTypes: {
                    ...updatedState.statusTypes,
                    updateLoading: false,
                    data: updatedData || undefined
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateStatusType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                statusTypes: {
                    ...updatedState.statusTypes,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };

});


parcelRegister("3rcO4", function(module, exports) {

$parcel$export(module.exports, "sortReferenceTypes", () => $ee8651402384f062$export$7e55dd84e7cc0829);
$parcel$export(module.exports, "sortStatusTypes", () => $ee8651402384f062$export$5f25bb3183b5823d);
const $ee8651402384f062$export$7e55dd84e7cc0829 = (referenceTypes)=>referenceTypes.sort((a, b)=>a.name.localeCompare(b.name)).sort((a, b)=>{
        if (a.removable === b.removable) return 0;
        return a.removable ? 1 : -1;
    });
const $ee8651402384f062$export$5f25bb3183b5823d = (statusTypes)=>statusTypes.sort((a, b)=>a.name.localeCompare(b.name));

});


parcelRegister("b2MSM", function(module, exports) {

$parcel$export(module.exports, "AssetsMenu", () => $2906ec36ee6b82b1$export$a578a9f5b9517a27);
$parcel$export(module.exports, "AssetsSingleMenuItem", () => $2906ec36ee6b82b1$export$252d7ffe38b4e8ef);

var $eJOHy = parcelRequire("eJOHy");

var $aGdf8 = parcelRequire("aGdf8");

var $6alcT = parcelRequire("6alcT");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $lRq8t = parcelRequire("lRq8t");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $i0tMD = parcelRequire("i0tMD");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $20Nt8 = parcelRequire("20Nt8");

var $gfvms = parcelRequire("gfvms");

var $bYOuG = parcelRequire("bYOuG");

var $lUto7 = parcelRequire("lUto7");

var $7jTnu = parcelRequire("7jTnu");

var $lvaGv = parcelRequire("lvaGv");

var $khwZc = parcelRequire("khwZc");

var $8GMYA = parcelRequire("8GMYA");

var $iXbCd = parcelRequire("iXbCd");
function $2906ec36ee6b82b1$export$a578a9f5b9517a27({ isExpanded: isExpanded }) {
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).ASSETS);
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const { isByokCustomer: isByokCustomer } = (0, $aGdf8.useByokComplianceSettingWithInitialisation)();
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const [{ config: config, dataManager: dataManager, loading: loading }, { fetchGlobalConfig: fetchGlobalConfig, fetchProvisioningStatus: fetchProvisioningStatus, fetchMyDataManagerRoles: fetchMyDataManagerRoles }] = (0, $gfvms.useInsightGlobalConfig)();
    const fetchAssetsConfig = (0, $eJOHy.useCallback)(async ()=>{
        fetchGlobalConfig(false);
        fetchProvisioningStatus(false);
        fetchMyDataManagerRoles(false);
    }, [
        fetchGlobalConfig,
        fetchMyDataManagerRoles,
        fetchProvisioningStatus
    ]);
    const menuId = (0, $h4Bzb.MENU_ID_ASSETS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).ASSETS,
                sectionItem: (0, $a9aec.SECTION_ITEM_ASSETS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iXbCd.SectionActions), {
            isInsightAdministrator: config?.insightAdministrator
        }),
        testId: (0, $azEgq.getTestId)(menuId),
        onClick: (_e, _a, { isExpanded: hasExpanded })=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).ASSETS,
                sectionItem: (0, $a9aec.SECTION_ITEM_ASSETS)
            });
        },
        interactionName: (0, $7jTnu.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-assets' : undefined
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8GMYA.HeaderSchemasMenuItems), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $20Nt8.L1ExpandableMenuItemSubmenu), {
        fetch: fetchAssetsConfig,
        isFetching: loading || dataManager.provisioningLoading || dataManager.myRolesLoading,
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvaGv.AssetsMenuItems), {
                dataManagerIsProvisioned: dataManager.isProvisioned,
                dataManagerMyRoles: dataManager.myRoles,
                isSiteAdmin: isSiteAdmin,
                insightAdministrator: config?.insightAdministrator,
                insightReporting: config?.insightReporting,
                isByokCustomer: isByokCustomer
            }),
        skeletonCount: 2
    })));
}
const $2906ec36ee6b82b1$export$252d7ffe38b4e8ef = ({ showUpsellLozenge: showUpsellLozenge = false })=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).ASSETS);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        onClick: ()=>{
            sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).ASSETS,
                sectionItem: (0, $a9aec.SECTION_ITEM_ASSETS)
            });
        },
        menuId: (0, $h4Bzb.MENU_ID_ASSETS),
        elemBefore: icon,
        href: (0, $bYOuG.getLandingPageUrl)(),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iXbCd.SectionActions), {
            isInsightAdministrator: false
        })
    }, `${formattedMessage} `, showUpsellLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-menu.upsell-lozenge",
        appearance: "new"
    }, formatMessage((0, $khwZc.default).upsellLozengeText)));
};

});
parcelRegister("aGdf8", function(module, exports) {

$parcel$export(module.exports, "useByokComplianceSettingWithInitialisation", () => $e5376e96309d515a$export$fb68f4844474e7cb);

var $eJOHy = parcelRequire("eJOHy");

var $jGzN3 = parcelRequire("jGzN3");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $lvKO5 = parcelRequire("lvKO5");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7jTnu = parcelRequire("7jTnu");

var $7qGN1 = parcelRequire("7qGN1");
const $e5376e96309d515a$var$messages = (0, $7qGN1.defineMessages)({
    byokComplianceSettingEnabledSuccessTitle: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.byok-compliance-setting-enabled-success-title",
        "defaultMessage": "HIPAA-compliant alert notifications turned on"
    },
    byokComplianceSettingEnabledSuccessDescription: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.byok-compliance-setting-enabled-success-description",
        "defaultMessage": "Let your team admins know about the recommended actions they can take."
    },
    flagOk: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.flag-ok",
        "defaultMessage": "Ok"
    },
    flagLearnMore: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.flag-learn-more",
        "defaultMessage": "Learn more"
    }
});
const $e5376e96309d515a$export$f907f15fb3e7d5a9 = (0, $hrodw.toFlagId)('byok-settings-enabled-success-flag-key');
const $e5376e96309d515a$var$LEARN_MORE_ABOUT_BYOK_COMPLIANCE_SETTING_LINK = 'https://support.atlassian.com/security-and-access-policies/docs/data-managed-with-byok-encryption/24h';
const $e5376e96309d515a$var$actions = {
    fetchByokComplianceSetting: (cloudId)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.loading === true) return;
            setState({
                ...state,
                loading: true
            });
            try {
                const { data: data } = await (0, $jGzN3.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/byok-setting`);
                setState({
                    ...state,
                    data: data,
                    loading: false,
                    error: undefined
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...state,
                    loading: false,
                    error: error
                });
            }
        },
    updateByokComplianceSetting: (option, cloudId)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.loading === true) return;
            const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
            setState({
                ...state,
                loading: true
            });
            try {
                await (0, $jGzN3.performPatchRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/byok-setting`, {
                    body: JSON.stringify({
                        ugcPrimaryLogEnabledForByok: option
                    })
                });
                if (option) showFlag({
                    id: $e5376e96309d515a$export$f907f15fb3e7d5a9,
                    title: $e5376e96309d515a$var$messages.byokComplianceSettingEnabledSuccessTitle,
                    type: 'success',
                    description: $e5376e96309d515a$var$messages.byokComplianceSettingEnabledSuccessDescription,
                    messageId: 'products-jsm-compliance.services.byok-compliance-setting.show-flag.success',
                    messageType: 'transactional',
                    actions: [
                        {
                            content: $e5376e96309d515a$var$messages.flagOk,
                            onClick: ()=>{
                                dismissFlag($e5376e96309d515a$export$f907f15fb3e7d5a9);
                            }
                        },
                        {
                            content: $e5376e96309d515a$var$messages.flagLearnMore,
                            href: $e5376e96309d515a$var$LEARN_MORE_ABOUT_BYOK_COMPLIANCE_SETTING_LINK,
                            target: '_blank'
                        }
                    ]
                });
                setState({
                    ...state,
                    data: {
                        byokCustomer: state.data?.byokCustomer ?? false,
                        ugcPrimaryLogEnabledForByok: option
                    },
                    loading: false,
                    error: undefined
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...state,
                    loading: false,
                    error: error
                });
            }
        }
};
const $e5376e96309d515a$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        data: null,
        loading: false,
        error: undefined
    },
    actions: $e5376e96309d515a$var$actions,
    name: 'BYOKComplianceSetting'
});
const $e5376e96309d515a$var$useByokComplianceSettingData = (0, $iJq0l.createHook)($e5376e96309d515a$var$Store);
const $e5376e96309d515a$export$fb68f4844474e7cb = ()=>{
    const [ByokComplianceSettingState, { fetchByokComplianceSetting: fetchByokComplianceSetting, updateByokComplianceSetting: updateByokComplianceSetting }] = $e5376e96309d515a$var$useByokComplianceSettingData();
    const { cloudId: cloudId } = (0, $lvKO5.useTenantContext)();
    (0, $eJOHy.useEffect)(()=>{
        if (!ByokComplianceSettingState.data && (0, $7jTnu.fg)('audit-logs-byok-encrypted-data')) fetchByokComplianceSetting(cloudId);
    }, [
        ByokComplianceSettingState.data,
        cloudId,
        fetchByokComplianceSetting
    ]);
    return {
        loading: ByokComplianceSettingState.loading,
        error: ByokComplianceSettingState.error,
        data: ByokComplianceSettingState.data,
        isByokComplianceSettingEnabled: ByokComplianceSettingState.data?.ugcPrimaryLogEnabledForByok ?? false,
        isByokCustomer: ByokComplianceSettingState.data?.byokCustomer ?? false,
        enableSetting: ()=>updateByokComplianceSetting(true, cloudId),
        disableSetting: ()=>updateByokComplianceSetting(false, cloudId)
    };
};

});

parcelRegister("20Nt8", function(module, exports) {

$parcel$export(module.exports, "L1ExpandableMenuItemSubmenu", () => $0eaaeada2f8e329b$export$a0d95f81c9ddf0e9);

var $eJOHy = parcelRequire("eJOHy");

var $5dX0w = parcelRequire("5dX0w");
const $0eaaeada2f8e329b$export$a0d95f81c9ddf0e9 = (props)=>{
    const { fetch: fetch, Footer: Footer, isFetching: isFetching, MenuItems: MenuItems, skeletonCount: skeletonCount } = props;
    const expandableMenuItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MenuItems, null);
    const expandableFooter = Footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Footer, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5dX0w.ExpandableMenuItemSubmenu), {
        fetch: fetch,
        footer: expandableFooter,
        isFetching: isFetching,
        menuItems: expandableMenuItems,
        skeletonCount: skeletonCount
    });
};

});
parcelRegister("5dX0w", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemSubmenu", () => $a2a3e2e1b2e30e86$export$216998a85b3335a2);

var $eJOHy = parcelRequire("eJOHy");

var $bkAOK = parcelRequire("bkAOK");

var $kxtq7 = parcelRequire("kxtq7");

var $if69u = parcelRequire("if69u");
const $a2a3e2e1b2e30e86$export$216998a85b3335a2 = (props)=>{
    const { fetch: fetchMaybe, footer: footer, isFetching: isFetchingMaybe, menuItems: menuItems, skeletonCount: skeletonCount } = props;
    const { isFetching: isFetching, fetch: fetch } = (0, $kxtq7.useFetchActual)(isFetchingMaybe, fetchMaybe);
    const isExpanded = (0, $bkAOK.useIsExpanded)();
    // Fetch on open to refresh.
    (0, $eJOHy.useEffect)(()=>{
        if (isExpanded && !isFetching) fetch();
    }, // Don't include `isFetching` or this effect will go into an endless loop.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isExpanded,
        fetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
        count: skeletonCount
    }) : menuItems, footer);
};

});
parcelRegister("kxtq7", function(module, exports) {

$parcel$export(module.exports, "useFetchActual", () => $859196bfa2c1b457$export$49f3bd519990bec7);

var $eJOHy = parcelRequire("eJOHy");
const $859196bfa2c1b457$export$49f3bd519990bec7 = (isFetchingMaybe, fetchMaybe)=>{
    const [isFetching, setIsFetching] = (0, $eJOHy.useState)(false);
    const fetch = (0, $eJOHy.useCallback)(async ()=>{
        if (!fetchMaybe) return;
        setIsFetching(true);
        try {
            await fetchMaybe();
        } finally{
            setIsFetching(false);
        }
    }, [
        fetchMaybe,
        setIsFetching
    ]);
    return {
        isFetching: !!isFetchingMaybe || isFetching,
        fetch: fetch
    };
};

});



parcelRegister("lvaGv", function(module, exports) {

$parcel$export(module.exports, "AssetsMenuItems", () => $8f756fb22181b2c2$export$eca9d73b7de13f6a);

var $eJOHy = parcelRequire("eJOHy");

var $17vsL = parcelRequire("17vsL");

var $igNUx = parcelRequire("igNUx");

var $7jTnu = parcelRequire("7jTnu");

var $dMNPP = parcelRequire("dMNPP");

var $kTXsx = parcelRequire("kTXsx");

var $7TbyK = parcelRequire("7TbyK");
const $8f756fb22181b2c2$export$eca9d73b7de13f6a = ({ dataManagerIsProvisioned: dataManagerIsProvisioned, dataManagerMyRoles: dataManagerMyRoles, isSiteAdmin: isSiteAdmin, insightAdministrator: insightAdministrator, insightReporting: insightReporting, isByokCustomer: isByokCustomer })=>{
    const showDataManagerLink = (0, $eJOHy.useCallback)(()=>{
        if (dataManagerIsProvisioned && dataManagerMyRoles) {
            const hasDMRoles = dataManagerMyRoles.some((myRole)=>(0, $17vsL.DATA_MANAGER_ROLES).includes(myRole));
            const hasAdapterRoles = dataManagerMyRoles.some((myRole)=>(0, $17vsL.DATA_MANAGER_ADAPTERS_ROLES).includes(myRole));
            if (hasDMRoles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kTXsx.DataManagerMenuItems), null);
            if (hasAdapterRoles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMNPP.DataManagerAdapterMenuItems), null);
        }
    }, [
        dataManagerIsProvisioned,
        dataManagerMyRoles
    ]);
    const isAssetsReportsByokSupported = isByokCustomer ? (0, $7jTnu.fg)('assets_reports_enabled_for_byok_customers') : true;
    const isInsightReportsEnabled = (0, $eJOHy.useCallback)(()=>(isSiteAdmin || insightAdministrator) && isAssetsReportsByokSupported && insightReporting, [
        insightAdministrator,
        insightReporting,
        isSiteAdmin,
        isAssetsReportsByokSupported
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isInsightReportsEnabled() && !(0, $igNUx.isFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7TbyK.ReportsMenuItem), null), showDataManagerLink());
};

});
parcelRegister("17vsL", function(module, exports) {

$parcel$export(module.exports, "DATA_MANAGER_ADMIN", () => $ba27e3658ead8687$export$48abe9ccfdd98170);
$parcel$export(module.exports, "DATA_MANAGER_REPORT_VIEWER", () => $ba27e3658ead8687$export$8939b849d295aa4c);
$parcel$export(module.exports, "DATA_MANAGER_REPORT_EDITOR", () => $ba27e3658ead8687$export$4ca2081d195ddbdb);
$parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ADMIN", () => $ba27e3658ead8687$export$4c3d5fe6bdc107f1);
$parcel$export(module.exports, "DATA_MANAGER_ROLES", () => $ba27e3658ead8687$export$48703faa5030b273);
$parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ROLES", () => $ba27e3658ead8687$export$8b2dfd13f5f35ee4);
$parcel$export(module.exports, "ORDERED_ASSETS_DATA_MANAGER_ROLES", () => $ba27e3658ead8687$export$1d276f65230af2e);
const $ba27e3658ead8687$export$48abe9ccfdd98170 = 'ari:cloud:cmdb::role/airtrack/admin';
const $ba27e3658ead8687$export$8939b849d295aa4c = 'ari:cloud:cmdb::role/airtrack/report-viewer';
const $ba27e3658ead8687$export$4ca2081d195ddbdb = 'ari:cloud:cmdb::role/airtrack/report-editor';
const $ba27e3658ead8687$export$4c3d5fe6bdc107f1 = 'ari:cloud:cmdb::role/airtrack-buoy/admin';
const $ba27e3658ead8687$export$48703faa5030b273 = [
    $ba27e3658ead8687$export$48abe9ccfdd98170,
    $ba27e3658ead8687$export$8939b849d295aa4c,
    $ba27e3658ead8687$export$4ca2081d195ddbdb
];
const $ba27e3658ead8687$export$8b2dfd13f5f35ee4 = [
    $ba27e3658ead8687$export$4c3d5fe6bdc107f1
];
const $ba27e3658ead8687$export$1d276f65230af2e = [
    $ba27e3658ead8687$export$48abe9ccfdd98170,
    $ba27e3658ead8687$export$4c3d5fe6bdc107f1,
    $ba27e3658ead8687$export$4ca2081d195ddbdb,
    $ba27e3658ead8687$export$8939b849d295aa4c
];

});

parcelRegister("dMNPP", function(module, exports) {

$parcel$export(module.exports, "DataManagerAdapterMenuItems", () => $301fb1cb4cf3d2af$export$f74d67a8d693b664);

var $eJOHy = parcelRequire("eJOHy");

var $1c7vV = parcelRequire("1c7vV");

var $6alcT = parcelRequire("6alcT");

var $9M9zY = parcelRequire("9M9zY");

var $aasrU = parcelRequire("aasrU");

var $lRq8t = parcelRequire("lRq8t");


var $2QH3X = parcelRequire("2QH3X");

var $i79tC = parcelRequire("i79tC");

var $bYOuG = parcelRequire("bYOuG");

var $6FvEx = parcelRequire("6FvEx");

var $6Awzl = parcelRequire("6Awzl");
const $301fb1cb4cf3d2af$export$f74d67a8d693b664 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { icon: formattedAdapterIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $6Awzl.default).jsmAssetsDataManagerAdapters, (0, $i79tC.DataManagerAdaptersGlyph));
    const { icon: formattedOpenIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $6Awzl.default).jsmAssetsOpenDataManager, (0, (/*@__PURE__*/$parcel$interopDefault($1c7vV))));
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $6FvEx.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aasrU.LinkMenuItem), {
        elemBefore: formattedAdapterIcon,
        elemAfter: formattedOpenIcon,
        href: (0, $bYOuG.getDataManagerAdaptersUrl)(),
        target: "_blank",
        onClick: ()=>fireUINavigationItemAnalytics((0, $bc40578f06d7846b$export$ee52916f9ebd8000))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        space: "space.050",
        alignBlock: "baseline"
    }, formatMessage((0, $6Awzl.default).jsmAssetsDataManagerAdapters), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        appearance: "new"
    }, formatMessage((0, $6Awzl.default).assetsDataManagerBeta))));
};

});
parcelRegister("1c7vV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2acc08ab6395d499b2798249d78c49fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0decbd8d1b521990$var$_react = $0decbd8d1b521990$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0decbd8d1b521990$var$_arrowUpRight = $0decbd8d1b521990$var$_interopRequireDefault((parcelRequire("casRM")));

var $0decbd8d1b521990$var$_open = $0decbd8d1b521990$var$_interopRequireDefault((parcelRequire("jdJl0")));
function $0decbd8d1b521990$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowUpRightIcon.
 * This component is ArrowUpRightIcon, with `UNSAFE_fallbackIcon` set to "OpenIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0decbd8d1b521990$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $0decbd8d1b521990$var$_react.default.createElement($0decbd8d1b521990$var$_arrowUpRight.default, Object.assign({
        LEGACY_fallbackIcon: $0decbd8d1b521990$var$_open.default
    }, props));
$0decbd8d1b521990$var$ArrowUpRightIcon.Name = 'ArrowUpRightIconMigration';
var $0decbd8d1b521990$var$_default = module.exports.default = $0decbd8d1b521990$var$ArrowUpRightIcon;

});
parcelRegister("casRM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa37e7fb05387379200e2a91e20ea76e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8dbccf7818bd71e9$var$_react = $8dbccf7818bd71e9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8dbccf7818bd71e9$var$_baseNew = $8dbccf7818bd71e9$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $8dbccf7818bd71e9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8dbccf7818bd71e9$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $8dbccf7818bd71e9$var$_react.default.createElement($8dbccf7818bd71e9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$8dbccf7818bd71e9$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $8dbccf7818bd71e9$var$_default = module.exports.default = $8dbccf7818bd71e9$var$ArrowUpRightIcon;

});

parcelRegister("jdJl0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $039c6d016c2249fc$var$_react = $039c6d016c2249fc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $039c6d016c2249fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $039c6d016c2249fc$var$OpenIcon = (props)=>/*#__PURE__*/ $039c6d016c2249fc$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.031 7A1.03 1.03 0 0 0 10 8.036a1.05 1.05 0 0 0 1.044 1.045l3.121.014.014 3.121a1.05 1.05 0 0 0 1.045 1.044 1.03 1.03 0 0 0 1.036-1.035l-.019-4.161a1.053 1.053 0 0 0-1.045-1.045L11.035 7z"/><path d="m13.364 8.292-7.071 7.071a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0l7.071-7.071A1.002 1.002 0 0 0 14.071 8a1 1 0 0 0-.707.292"/></g></svg>`
    }, props));
$039c6d016c2249fc$var$OpenIcon.displayName = 'OpenIcon';
var $039c6d016c2249fc$var$_default = module.exports.default = $039c6d016c2249fc$var$OpenIcon;

});


const $bc40578f06d7846b$export$f06dfcec5ff912e = 'meatballDropdown';
const $bc40578f06d7846b$export$7ae7abcf2c19d3e5 = 'removeFromStarred';
const $bc40578f06d7846b$export$78fd0bd637fe1684 = 'addToStarred';
const $bc40578f06d7846b$export$c540230986f848f6 = 'addPeople';
const $bc40578f06d7846b$export$44d67b522cbcce6d = 'projects';
const $bc40578f06d7846b$export$3cc9ab700c406a19 = 'projectSettings';
const $bc40578f06d7846b$export$dc23a793cf9e9de8 = 'archiveProject';
const $bc40578f06d7846b$export$a68d619e7022f2c3 = 'deleteBoard';
const $bc40578f06d7846b$export$22748439827110a4 = 'deleteProject';
const $bc40578f06d7846b$export$192d610b0b7719f4 = 'boardSettings';
const $bc40578f06d7846b$export$a65812b4aab631bb = 'alertSettings';
const $bc40578f06d7846b$export$36b5d4d0cb4e437 = 'moveInSidebar';
const $bc40578f06d7846b$export$ca6db12118be69a1 = 'schemas';
const $bc40578f06d7846b$export$f2eca6cf19c9a973 = 'reports';
const $bc40578f06d7846b$export$147264622218a553 = 'dataManager';
const $bc40578f06d7846b$export$ee52916f9ebd8000 = 'adapters';
const $bc40578f06d7846b$export$83d40997eb7cc5b7 = 'assetsGlobalConfiguration';
const $bc40578f06d7846b$export$5c09fa42f8d45ed8 = 'dismissRecommendation';
const $bc40578f06d7846b$export$de9ad1ebeca97ec1 = 'newDiscoveryProject';
const $bc40578f06d7846b$export$27e4092edca7bb97 = 'jwmSampleProject';
const $bc40578f06d7846b$export$ce0bea1467165424 = 'whyAmISeeingThis';
const $bc40578f06d7846b$export$98d08638c2a90c44 = 'starredAndRecentProjects';
const $bc40578f06d7846b$export$ed36b1ade72db400 = 'starredProjectsOnly';
const $bc40578f06d7846b$export$f8a73cc0211412ca = 'mostRecentProjectOnly';
const $bc40578f06d7846b$export$3e2efdbdb3eed97e = 'moreProjects';
const $bc40578f06d7846b$export$2de7e56f66635690 = 'viewAllProjects';
const $bc40578f06d7846b$export$e338c40e64df0640 = 'projectsSearch';
const $bc40578f06d7846b$export$5ff59e4f08b9b299 = 'moveToTop';
const $bc40578f06d7846b$export$9964b4a63620a911 = 'moveUp';
const $bc40578f06d7846b$export$2692a384035c5ef7 = 'moveDown';
const $bc40578f06d7846b$export$a5a45050b97fca24 = 'moveToBottom';

parcelRegister("i79tC", function(module, exports) {

$parcel$export(module.exports, "DataManagerAdaptersGlyph", () => $7f477d6058758a60$export$cff497901afe8164);
$parcel$export(module.exports, "DataManagerLink", () => $7f477d6058758a60$export$905e681c1cad3de);

var $eJOHy = parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");

var $aCmsU = parcelRequire("aCmsU");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $6alcT = parcelRequire("6alcT");

var $c9uTK = parcelRequire("c9uTK");
const $7f477d6058758a60$export$fb5ad6208dd8d5f1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 6.5C7.5 7.05228 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5C7.05228 5.5 7.5 5.94772 7.5 6.5ZM7.5 17.5C7.5 18.0523 7.05228 18.5 6.5 18.5C5.94772 18.5 5.5 18.0523 5.5 17.5C5.5 16.9477 5.94772 16.5 6.5 16.5C7.05228 16.5 7.5 16.9477 7.5 17.5ZM18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11C18.0523 11 18.5 11.4477 18.5 12ZM8.88555 7.25C8.56698 8.26428 7.61941 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.61941 4 8.56698 4.73572 8.88555 5.75H10.5523C11.697 5.75 12.625 6.67797 12.625 7.82267V11.25H14.5H15.1145C15.433 10.2357 16.3806 9.5 17.5 9.5C18.8807 9.5 20 10.6193 20 12C20 13.3807 18.8807 14.5 17.5 14.5C16.3806 14.5 15.433 13.7643 15.1145 12.75H14.5H12.625V16.1773C12.625 17.322 11.697 18.25 10.5523 18.25H8.88555C8.56698 19.2643 7.61941 20 6.5 20C5.11929 20 4 18.8807 4 17.5C4 16.1193 5.11929 15 6.5 15C7.61941 15 8.56698 15.7357 8.88555 16.75H10.5523C10.8686 16.75 11.125 16.4936 11.125 16.1773V12.75V12V11.25V7.82267C11.125 7.50639 10.8686 7.25 10.5523 7.25H8.88555Z",
        fill: "#44546F"
    }));
const $7f477d6058758a60$export$cff497901afe8164 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        clipPath: "url(#clip0_2374_102539)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5076 15.8019C10.8212 16.0862 11 16.4898 11 16.913V18.5H13V16.913C13 16.4898 13.1788 16.0862 13.4924 15.8019L16.5 13.0745V9.5H7.5V13.0745L10.5076 15.8019ZM6 13.7391V9C6 8.44771 6.44772 8 7 8H17C17.5523 8 18 8.44772 18 9V13.7391L14.5 16.913V19C14.5 19.5523 14.0523 20 13.5 20H10.5C9.94772 20 9.5 19.5523 9.5 19V16.913L6 13.7391Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 9L9 4L10.5 4V9H9Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5 9V4L15 4V9H13.5Z",
        fill: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("clipPath", {
        id: "clip0_2374_102539"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "currentColor"
    }))));
const $7f477d6058758a60$export$905e681c1cad3de = ({ children: children, onClick: onClick, testId: testId, to: to, app: app })=>{
    const getIcon = ()=>{
        if (app === 'data-manager') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aCmsU.default), {
            glyph: $7f477d6058758a60$export$fb5ad6208dd8d5f1,
            label: "Data manager icon",
            size: "medium"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aCmsU.default), {
            glyph: $7f477d6058758a60$export$cff497901afe8164,
            label: "Adapters icon",
            size: "medium"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $7f477d6058758a60$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        href: to,
        component: (0, $c9uTK.Link),
        appearance: "subtle",
        iconBefore: getIcon(),
        testId: testId,
        onClick: (event, analyticsEvent)=>{
            onClick?.(analyticsEvent);
        },
        target: "_blank"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $7f477d6058758a60$var$lozengeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        appearance: "new"
    }, "BETA"))));
};
const $7f477d6058758a60$var$lozengeStyles = (0, $5Wv5g.xcss)({
    display: 'inline-block',
    marginLeft: 'space.050'
});
const $7f477d6058758a60$var$wrapperStyles = (0, $5Wv5g.xcss)({});

});

parcelRegister("6FvEx", function(module, exports) {

$parcel$export(module.exports, "useAssetsUIAnalytics", () => $99fa744738885014$export$2eb4a7a38c92c87f);

var $eJOHy = parcelRequire("eJOHy");




var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");
const $99fa744738885014$export$2eb4a7a38c92c87f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const fireUINavigationItemAnalytics = (0, $eJOHy.useCallback)((analyticsItemId)=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        }), (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_ASSETS], {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            itemId: analyticsItemId
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireUINavigationItemAnalytics: fireUINavigationItemAnalytics
    };
};

});

parcelRegister("6Awzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $544582b8551893f8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $544582b8551893f8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    jsmAssetsDataManagerAdapters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.jsm-assets-data-manager-adapters",
        "defaultMessage": "Adapters"
    },
    jsmAssetsOpenDataManager: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.jsm-assets-open-data-manager",
        "defaultMessage": "Open data manager"
    },
    assetsDataManagerBeta: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.assets-data-manager-beta",
        "defaultMessage": "Beta"
    }
});

});


parcelRegister("kTXsx", function(module, exports) {

$parcel$export(module.exports, "DataManagerMenuItems", () => $27fa01bc6587f493$export$34300598ca712097);

var $eJOHy = parcelRequire("eJOHy");

var $1c7vV = parcelRequire("1c7vV");

var $9M9zY = parcelRequire("9M9zY");

var $6alcT = parcelRequire("6alcT");

var $aasrU = parcelRequire("aasrU");

var $964c7 = parcelRequire("964c7");

var $lRq8t = parcelRequire("lRq8t");


var $2QH3X = parcelRequire("2QH3X");

var $bYOuG = parcelRequire("bYOuG");

var $6FvEx = parcelRequire("6FvEx");

var $5vsGO = parcelRequire("5vsGO");
const $27fa01bc6587f493$export$34300598ca712097 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { icon: formattedOpenIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $5vsGO.default).assetsOpenDataManager, (0, (/*@__PURE__*/$parcel$interopDefault($1c7vV))));
    const { icon: formattedDataManagerIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $5vsGO.default).assetsDataManager, (0, $964c7.default));
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $6FvEx.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aasrU.LinkMenuItem), {
        elemBefore: formattedDataManagerIcon,
        elemAfter: formattedOpenIcon,
        href: (0, $bYOuG.getDataManagerUrl)(),
        target: "_blank",
        onClick: ()=>fireUINavigationItemAnalytics((0, $bc40578f06d7846b$export$147264622218a553))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        space: "space.050",
        alignBlock: "baseline"
    }, formatMessage((0, $5vsGO.default).assetsDataManager), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        appearance: "new"
    }, formatMessage((0, $5vsGO.default).assetsDataManagerBeta))));
};

});
parcelRegister("964c7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bcb30f45b8daa78$export$2e2bcd8739ae039);
/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $aCmsU = parcelRequire("aCmsU");
const $3bcb30f45b8daa78$var$JSMAssetsDataManagerGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 6.5C7.5 7.05228 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5C7.05228 5.5 7.5 5.94772 7.5 6.5ZM8.88555 7.25C8.56698 8.26428 7.61941 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.61941 4 8.56698 4.73572 8.88555 5.75H10.5523C11.697 5.75 12.625 6.67797 12.625 7.82267V8.5V11.25H14.5H15.1145C15.433 10.2357 16.3806 9.5 17.5 9.5C18.8807 9.5 20 10.6193 20 12C20 13.3807 18.8807 14.5 17.5 14.5C16.3806 14.5 15.433 13.7643 15.1145 12.75H14.5H12.625V15.5V16.1773C12.625 17.322 11.697 18.25 10.5523 18.25H8.88555C8.56698 19.2643 7.61941 20 6.5 20C5.11929 20 4 18.8807 4 17.5C4 16.1193 5.11929 15 6.5 15C7.61941 15 8.56698 15.7357 8.88555 16.75H10.5523C10.8686 16.75 11.125 16.4936 11.125 16.1773V15.5V12.75V12V11.25V8.5V7.82267C11.125 7.50639 10.8686 7.25 10.5523 7.25H8.88555ZM6.5 18.5C7.05228 18.5 7.5 18.0523 7.5 17.5C7.5 16.9477 7.05228 16.5 6.5 16.5C5.94772 16.5 5.5 16.9477 5.5 17.5C5.5 18.0523 5.94772 18.5 6.5 18.5ZM18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11C18.0523 11 18.5 11.4477 18.5 12Z",
        fill: "currentColor"
    }));
const $3bcb30f45b8daa78$var$JSMAssetsDataManagerIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aCmsU.default), {
        ...props,
        glyph: $3bcb30f45b8daa78$var$JSMAssetsDataManagerGlyph
    });
var $3bcb30f45b8daa78$export$2e2bcd8739ae039 = $3bcb30f45b8daa78$var$JSMAssetsDataManagerIcon;

});

parcelRegister("5vsGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5f92d968ddaa577$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a5f92d968ddaa577$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    assetsDataManager: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-data-manager",
        "defaultMessage": "Data Manager"
    },
    assetsOpenDataManager: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-open-data-manager",
        "defaultMessage": "Open Data Manager"
    },
    assetsDataManagerBeta: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-data-manager-beta",
        "defaultMessage": "Beta"
    }
});

});


parcelRegister("7TbyK", function(module, exports) {

$parcel$export(module.exports, "ReportsMenuItem", () => $bfca800aee13c0bd$export$156f96ce3bb16879);

var $eJOHy = parcelRequire("eJOHy");

var $eXXLY = parcelRequire("eXXLY");

var $lRq8t = parcelRequire("lRq8t");


var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $bYOuG = parcelRequire("bYOuG");

var $6FvEx = parcelRequire("6FvEx");

var $1klfV = parcelRequire("1klfV");
const $bfca800aee13c0bd$export$156f96ce3bb16879 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const reportsLink = (0, $eJOHy.useMemo)(()=>(0, $bYOuG.getAssetsReportsUrl)(), []);
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $6FvEx.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXXLY))), {
            label: formatMessage((0, $1klfV.default).jsmAssetsReports),
            color: "currentColor",
            spacing: "spacious"
        }),
        href: reportsLink,
        menuId: (0, $h4Bzb.MENU_ID_ASSETS_REPORTS),
        onClick: ()=>fireUINavigationItemAnalytics((0, $bc40578f06d7846b$export$f2eca6cf19c9a973))
    }, formatMessage((0, $1klfV.default).jsmAssetsReports));
};

});
parcelRegister("eXXLY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f75e2054943fb775b789c9f2b57e27>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae54f0fe7e6ff407$var$_react = $ae54f0fe7e6ff407$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ae54f0fe7e6ff407$var$_baseNew = $ae54f0fe7e6ff407$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $ae54f0fe7e6ff407$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ae54f0fe7e6ff407$var$ChartBarIcon = (props)=>/*#__PURE__*/ $ae54f0fe7e6ff407$var$_react.default.createElement($ae54f0fe7e6ff407$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$ae54f0fe7e6ff407$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $ae54f0fe7e6ff407$var$_default = module.exports.default = $ae54f0fe7e6ff407$var$ChartBarIcon;

});

parcelRegister("1klfV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fb32e4afb1e817e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3fb32e4afb1e817e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    jsmAssetsReports: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.reports.jsm-assets-reports",
        "defaultMessage": "Reports"
    }
});

});



parcelRegister("khwZc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d51d281a3494d6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a7d51d281a3494d6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    upsellLozengeText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.upsell-lozenge-text",
        "defaultMessage": "Premium"
    }
});

});

parcelRegister("8GMYA", function(module, exports) {

$parcel$export(module.exports, "HeaderSchemasMenuItems", () => $1c2c24180176eb43$export$7243359973253e5);

var $eJOHy = parcelRequire("eJOHy");

var $4yUIq = parcelRequire("4yUIq");

var $lRq8t = parcelRequire("lRq8t");


var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $2QH3X = parcelRequire("2QH3X");

var $bYOuG = parcelRequire("bYOuG");

var $6FvEx = parcelRequire("6FvEx");

var $18OH6 = parcelRequire("18OH6");
const $1c2c24180176eb43$export$7243359973253e5 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const schemasLink = (0, $eJOHy.useMemo)(()=>(0, $bYOuG.getLandingPageUrl)(), []);
    const { icon: formattedSchemasIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $18OH6.default).jsmAssetsSchemas, (0, $4yUIq.default));
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $6FvEx.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        menuId: (0, $h4Bzb.MENU_ID_ASSETS_SCHEMAS),
        elemBefore: formattedSchemasIcon,
        href: schemasLink,
        onClick: ()=>fireUINavigationItemAnalytics((0, $bc40578f06d7846b$export$ca6db12118be69a1))
    }, formatMessage((0, $18OH6.default).jsmAssetsSchemas));
};

});
parcelRegister("4yUIq", function(module, exports) {

$parcel$export(module.exports, "default", () => $174d58feef21d039$export$2e2bcd8739ae039);
/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $aCmsU = parcelRequire("aCmsU");
const $174d58feef21d039$var$JSMAssetsSchemasGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 7.5C8.05228 7.5 8.5 7.05228 8.5 6.5C8.5 5.94772 8.05228 5.5 7.5 5.5C6.94772 5.5 6.5 5.94772 6.5 6.5C6.5 7.05228 6.94772 7.5 7.5 7.5ZM10 6.5C10 7.61941 9.26428 8.56698 8.25 8.88555V10.5H14.1145C14.433 9.48572 15.3806 8.75 16.5 8.75C17.8807 8.75 19 9.86929 19 11.25C19 12.6307 17.8807 13.75 16.5 13.75C15.3806 13.75 14.433 13.0143 14.1145 12H8.25V16.25C8.25 16.6642 8.58579 17 9 17H14.05C14.2816 15.8589 15.2905 15 16.5 15C17.8807 15 19 16.1193 19 17.5C19 18.8807 17.8807 20 16.5 20C15.4748 20 14.5938 19.383 14.208 18.5H9C7.75736 18.5 6.75 17.4926 6.75 16.25V12V10.5V8.88555C5.73572 8.56698 5 7.61941 5 6.5C5 5.11929 6.11929 4 7.5 4C8.88071 4 10 5.11929 10 6.5ZM16.5 18.5C17.0523 18.5 17.5 18.0523 17.5 17.5C17.5 16.9477 17.0523 16.5 16.5 16.5C15.9477 16.5 15.5 16.9477 15.5 17.5C15.5 18.0523 15.9477 18.5 16.5 18.5ZM17.5 11.25C17.5 11.8023 17.0523 12.25 16.5 12.25C15.9477 12.25 15.5 11.8023 15.5 11.25C15.5 10.6977 15.9477 10.25 16.5 10.25C17.0523 10.25 17.5 10.6977 17.5 11.25Z",
        fill: "currentColor"
    }));
const $174d58feef21d039$var$JSMAssetsSchemasIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aCmsU.default), {
        ...props,
        glyph: $174d58feef21d039$var$JSMAssetsSchemasGlyph
    });
var $174d58feef21d039$export$2e2bcd8739ae039 = $174d58feef21d039$var$JSMAssetsSchemasIcon;

});

parcelRegister("18OH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14e9f6a98bbe18a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a14e9f6a98bbe18a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    jsmAssetsSchemas: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.schemas.jsm-assets-schemas",
        "defaultMessage": "Schemas"
    }
});

});


parcelRegister("iXbCd", function(module, exports) {

$parcel$export(module.exports, "SectionActions", () => $bd7dfdfa6a70aa5f$export$51f8029abf8c56ce);

var $eJOHy = parcelRequire("eJOHy");

var $ejfxj = parcelRequire("ejfxj");

var $apGPk = parcelRequire("apGPk");
var $7R1al = parcelRequire("7R1al");

var $9M9zY = parcelRequire("9M9zY");

var $lRq8t = parcelRequire("lRq8t");




var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $6naEG = parcelRequire("6naEG");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $bYOuG = parcelRequire("bYOuG");

var $kaLPl = parcelRequire("kaLPl");
function $bd7dfdfa6a70aa5f$export$51f8029abf8c56ce({ onClose: onClose, isInsightAdministrator: isInsightAdministrator = false }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const onOpen = ()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_ASSETS], {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
            itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        MenuItems: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd7dfdfa6a70aa5f$var$MoreMenuItems, {
                ...props,
                isInsightAdministrator: isInsightAdministrator
            }),
        onClose: onClose,
        onOpen: ()=>onOpen()
    });
}
function $bd7dfdfa6a70aa5f$var$MoreMenuItems({ onClose: onClose, isInsightAdministrator: isInsightAdministrator = false }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const configLink = (0, $eJOHy.useMemo)(()=>(0, $bYOuG.getGlobalConfigUrl)(), []);
    const onCloseWithStopPropagation = (0, $6naEG.useStopPropagation)(onClose);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const onClick = (e)=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_ASSETS], {
            level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
            componentType: (0, $493796f3bdee881c$export$74712b62056d422e),
            parentItemId: (0, $a9aec.SECTION_ITEM_ASSETS),
            itemId: (0, $bc40578f06d7846b$export$83d40997eb7cc5b7)
        });
        onCloseWithStopPropagation(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isInsightAdministrator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apGPk.default), {
        href: configLink,
        onClick: (e)=>onClick(e)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ejfxj))), {
        label: formatMessage((0, $kaLPl.default).jsmAssetsSettingsIcon),
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }), formatMessage((0, $kaLPl.default).jsmAssetsGlobalConfiguration)))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).ASSETS
    }));
}

});
parcelRegister("kaLPl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f4acb85ba46ccfc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2f4acb85ba46ccfc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    jsmAssetsGlobalConfiguration: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.section-actions.jsm-assets-global-configuration",
        "defaultMessage": "General configuration"
    },
    jsmAssetsSettingsIcon: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.section-actions.jsm-assets-settings-icon",
        "defaultMessage": "Settings"
    }
});

});




parcelRegister("hcSA5", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceAnalytics", () => $6ef470fbb79a00a2$export$5b58aa15c2701e8);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $jyIAe = parcelRequire("jyIAe");
const $6ef470fbb79a00a2$export$5b58aa15c2701e8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "assets",
        packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCustomerService",
        teamName: "Kalari"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jyIAe.CustomerServiceAnalyticsMenuLinkItem), null));

});
parcelRegister("jyIAe", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceAnalyticsMenuLinkItem", () => $ceb5d334a4e24ed4$export$d4508bff4cbbd271);

var $eJOHy = parcelRequire("eJOHy");

var $MlWTN = parcelRequire("MlWTN");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $i0tMD = parcelRequire("i0tMD");

var $eL2Ux = parcelRequire("eL2Ux");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $7jTnu = parcelRequire("7jTnu");
const $ceb5d334a4e24ed4$export$df8bbcec1e54e3c3 = '/jira/helpcenter/analytics';
const $ceb5d334a4e24ed4$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE_ANALYTICS),
        hasSeparator: false
    }));
const $ceb5d334a4e24ed4$export$d4508bff4cbbd271 = ()=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-customer-service-analytics.ui.sidenav-customer-service",
        href: $ceb5d334a4e24ed4$export$df8bbcec1e54e3c3,
        menuId: (0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE_ANALYTICS),
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
            MenuItems: (0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton') ? $ceb5d334a4e24ed4$var$MenuItems : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
                    menuId: (0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE_ANALYTICS),
                    hasSeparator: false
                }))
        })
    }, formattedMessage);
};

});


parcelRegister("7u7ku", function(module, exports) {

$parcel$export(module.exports, "CustomerService", () => $357d76dab5b061c6$export$5c26f0ffd7a4820d);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $d47rS = parcelRequire("d47rS");
const $357d76dab5b061c6$export$5c26f0ffd7a4820d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "assets",
        packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCustomerService",
        teamName: "Boysenberry"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d47rS.CustomerServiceMenuLinkItem), null));

});
parcelRegister("d47rS", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceMenuLinkItem", () => $963944c3e5e8eb01$export$276375fee74f0f11);

var $eJOHy = parcelRequire("eJOHy");

var $MlWTN = parcelRequire("MlWTN");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $i0tMD = parcelRequire("i0tMD");

var $eL2Ux = parcelRequire("eL2Ux");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $7jTnu = parcelRequire("7jTnu");
const $963944c3e5e8eb01$export$208752a9164e5a6d = '/jira/helpcenter';
const $963944c3e5e8eb01$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $7jTnu.fg)('jcs_project_type_m3') ? (0, $h4Bzb.MENU_ID_CUSTOMER_HUBS) : (0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE),
        hasSeparator: false
    }));
const $963944c3e5e8eb01$export$276375fee74f0f11 = ()=>{
    const customerServiceMenuId = (0, $7jTnu.fg)('jcs_project_type_m3') ? (0, $8IuE5.L1_MENU_ID).CUSTOMER_HUBS : (0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)(customerServiceMenuId);
    const menuId = (0, $7jTnu.fg)('jcs_project_type_m3') ? (0, $h4Bzb.MENU_ID_CUSTOMER_HUBS) : (0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.ui.sidenav-customer-service",
        href: $963944c3e5e8eb01$export$208752a9164e5a6d,
        menuId: menuId,
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
            MenuItems: (0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton') ? $963944c3e5e8eb01$var$MenuItems : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
                    menuId: menuId,
                    hasSeparator: false
                }))
        })
    }, formattedMessage);
};

});


parcelRegister("gk3Hc", function(module, exports) {

$parcel$export(module.exports, "Nav4Dashboards", () => $869f94794192c56b$export$14aa7c6c8f362b5b);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $16sa1 = parcelRequire("16sa1");

var $iDV0Y = parcelRequire("iDV0Y");

var $kJJos = parcelRequire("kJJos");

const $869f94794192c56b$export$14aa7c6c8f362b5b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4-sidebar-dashboards"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "dashboards-section",
        packageName: (0, $e6bca68b75395543$export$b8b9d90f9e5bd72b),
        teamName: (0, $e6bca68b75395543$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJJos.AnalyticContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iDV0Y.Nav4Dashboards), props))));

});
parcelRegister("iDV0Y", function(module, exports) {

$parcel$export(module.exports, "Nav4Dashboards", () => $b60eeac2b786e888$export$14aa7c6c8f362b5b);

var $eJOHy = parcelRequire("eJOHy");

var $d5muJ = parcelRequire("d5muJ");

var $idh5p = parcelRequire("idh5p");
function $b60eeac2b786e888$export$14aa7c6c8f362b5b({ isExpanded: isExpanded }) {
    const actionButtons = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d5muJ.ActionButtons), null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $idh5p.DashboardsDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
}

});
parcelRegister("d5muJ", function(module, exports) {

$parcel$export(module.exports, "ActionButtons", () => $6611df09e6aa64ec$export$88c65d2d98aab183);

var $eJOHy = parcelRequire("eJOHy");

var $i140O = parcelRequire("i140O");

var $MlWTN = parcelRequire("MlWTN");

var $9JB3T = parcelRequire("9JB3T");

var $kO1ht = parcelRequire("kO1ht");

var $7EgC9 = parcelRequire("7EgC9");

var $lRq8t = parcelRequire("lRq8t");

var $8IuE5 = parcelRequire("8IuE5");

var $ajqBI = parcelRequire("ajqBI");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $hih5V = parcelRequire("hih5V");

var $9o3jI = parcelRequire("9o3jI");

var $02kpm = parcelRequire("02kpm");
var $83DiZ = parcelRequire("83DiZ");

var $7jTnu = parcelRequire("7jTnu");

var $fAZgY = parcelRequire("fAZgY");


var $kJJos = parcelRequire("kJJos");

var $3hxrg = parcelRequire("3hxrg");
function $6611df09e6aa64ec$export$88c65d2d98aab183() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [, { off: modalClose }] = (0, $9o3jI.useSwitchModals)((0, $kO1ht.MODAL_ID).DASHBOARD_CREATE);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const { path: path } = (0, $hih5V.useRouteByName)('dashboard-edit') ?? {};
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const onSuccess = (0, $eJOHy.useCallback)((_, { id: id })=>{
        path && push((0, $02kpm.generatePath)(path, {
            dashboardId: id
        }));
        setIsOpen(false);
        modalClose();
    }, [
        modalClose,
        path,
        push
    ]);
    const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton } = (0, $eJOHy.useContext)((0, $kJJos.AnalyticContext));
    const onCancelCreateDashboardModal = (0, $fAZgY.useCallbackWithCondition)(()=>{
        setIsOpen(false);
        modalClose();
    }, [
        modalClose
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const onClickCommonNavMenuButton = (0, $fAZgY.useCallbackWithCondition)(()=>{
        fireUIAnalyticForFixButton({
            itemId: (0, $e6bca68b75395543$export$7be02fe416808d26)
        });
        setIsOpen(true);
    }, [
        fireUIAnalyticForFixButton
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const onOpenMoreNavMenuButton = (0, $fAZgY.useCallbackWithCondition)(()=>fireUIAnalyticForFixButton({
            itemId: (0, $e6bca68b75395543$export$f06dfcec5ff912e)
        }), [
        fireUIAnalyticForFixButton
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7EgC9.default), {
        onSuccess: onSuccess,
        onCancel: onCancelCreateDashboardModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: formatMessage((0, $3hxrg.default).createDashboard)
    }, (0, $7jTnu.fg)('blu-7837_apply_presstrace_nav4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        interactionName: "nav4-sidebar-dashboards-create-button",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i140O))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $3hxrg.default).createDashboard),
        onClick: onClickCommonNavMenuButton
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i140O))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $3hxrg.default).createDashboard),
        onClick: onClickCommonNavMenuButton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: onOpenMoreNavMenuButton,
        MenuItems: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? $6611df09e6aa64ec$var$MenuItems : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
                menuId: (0, $8IuE5.L1_MENU_ID).DASHBOARDS,
                hasSeparator: false
            }))
    }));
}
const $6611df09e6aa64ec$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).DASHBOARDS,
        hasSeparator: false
    }));

});
parcelRegister("kO1ht", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $817604bc75ee0b6b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $817604bc75ee0b6b$export$d57b6b390e78d90f);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_FAV", () => $817604bc75ee0b6b$export$ea341e6cc435ed40);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_VIEWED", () => $817604bc75ee0b6b$export$cb66c02d110b1531);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_RECENT", () => $817604bc75ee0b6b$export$22ea57e66775a6b2);
$parcel$export(module.exports, "TOP_LEVEL_ERROR_BOUNDARY_ID", () => $817604bc75ee0b6b$export$4766f0c4b6fe35dc);
$parcel$export(module.exports, "NAVIGATION_ITEM_ID", () => $817604bc75ee0b6b$export$1a9b265c626e9d44);
$parcel$export(module.exports, "MODAL_ID", () => $817604bc75ee0b6b$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "PROFILE_SPOTLIGHT_KEY", () => $817604bc75ee0b6b$export$6037915bf3452cf3);
$parcel$export(module.exports, "HELP_SPOTLIGHT_KEY", () => $817604bc75ee0b6b$export$286c2faa2103eb9c);
$parcel$export(module.exports, "SEARCH_SPOTLIGHT_KEY", () => $817604bc75ee0b6b$export$c0d6ac131d4391b9);
$parcel$export(module.exports, "PROJECTS_SPOTLIGHT_KEY", () => $817604bc75ee0b6b$export$8d9442dfaec4086f);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MAIN", () => $817604bc75ee0b6b$export$3014c5ec440d8824);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MENU", () => $817604bc75ee0b6b$export$69cbedccc0df48);
$parcel$export(module.exports, "YOUR_WORK_DROPDOWN_TAB_ID", () => $817604bc75ee0b6b$export$1935aad1d702494c);
$parcel$export(module.exports, "JSW_TMP_BACKLOG_BOARD_REGEXP", () => $817604bc75ee0b6b$export$cc578bc72d7a7308);
const $817604bc75ee0b6b$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
const $817604bc75ee0b6b$export$d57b6b390e78d90f = 'navigation';
const $817604bc75ee0b6b$export$ea341e6cc435ed40 = 15;
const $817604bc75ee0b6b$export$cb66c02d110b1531 = 10;
const $817604bc75ee0b6b$export$22ea57e66775a6b2 = 5;
const $817604bc75ee0b6b$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $817604bc75ee0b6b$export$1a9b265c626e9d44 = {
    ADDONS: 'apps',
    CREATE: 'createIssue',
    APP_SWITCHER: 'atlassianSwitcher',
    DASHBOARDS: 'dashboards',
    FILTERS: 'filters',
    HELP: 'help',
    HELP_BADGE: 'helpBadge',
    HOME: 'home',
    INSIGHT: 'insight',
    LOGO: 'productLogo',
    NOTIFICATIONS: 'notifications',
    PEOPLE: 'people',
    PLANS: 'plans',
    PROFILE: 'profile',
    PROJECTS: 'projects',
    ROADMAPS: 'roadmaps',
    SEARCH: 'search',
    SERVICE_HUB: 'services',
    SETTINGS: 'settings',
    SIGN_IN: 'signIn',
    YOUR_WORK_DROPDOWN: 'yourWorkDropdown',
    CONVERSATION_ASSISTANT: 'conversationAssistant',
    ROVO_DEMAND_TESTS: 'rovoDemandTests'
};
const $817604bc75ee0b6b$export$ebdd5a8e5b1c2de5 = {
    DASHBOARD_CREATE: 'DASHBOARD_CREATE',
    KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
    PROJECT_CREATE: 'PROJECT_CREATE'
};
const $817604bc75ee0b6b$export$6037915bf3452cf3 = 'profile-spotlight';
const $817604bc75ee0b6b$export$286c2faa2103eb9c = 'help-spotlight';
const $817604bc75ee0b6b$export$c0d6ac131d4391b9 = 'search-spotlight';
const $817604bc75ee0b6b$export$8d9442dfaec4086f = 'projects-spotlight';
const $817604bc75ee0b6b$export$3014c5ec440d8824 = 'viewAtlassianNavigation';
const $817604bc75ee0b6b$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $817604bc75ee0b6b$export$1935aad1d702494c = {
    RECENT: 'RECENT',
    BOARDS: 'BOARDS',
    QUEUES: 'QUEUES',
    ASSIGNED_TO_ME: 'ASSIGNED_TO_ME',
    ADD_FILTER: 'ADD_FILTER',
    ALERTS: 'ALERTS'
};
const $817604bc75ee0b6b$export$cc578bc72d7a7308 = /jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;

});

parcelRegister("7EgC9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8304d348e8f763ab$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8304d348e8f763ab$var$AsyncCreateDashboardModal = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("cv7WX")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/create-dashboard-modal/src/index.tsx"
});
const $8304d348e8f763ab$var$AsyncCreateDashboardModalContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "create-dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8304d348e8f763ab$var$AsyncCreateDashboardModal, props));
var $8304d348e8f763ab$export$2e2bcd8739ae039 = $8304d348e8f763ab$var$AsyncCreateDashboardModalContainer;

});
parcelRegister("cv7WX", function(module, exports) {

let $919e8bfd8f3039a5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $919e8bfd8f3039a5$var$load("1VRB2"),
    $919e8bfd8f3039a5$var$load("bABhq"),
    $919e8bfd8f3039a5$var$load("iPRjh")
]).then(()=>parcelRequire('5CafV'));

});


parcelRegister("9o3jI", function(module, exports) {

$parcel$export(module.exports, "useSwitchModals", () => $72b2d0fa90dcdffb$export$5ed4b99cbad4ebd6);

var $dA7TN = parcelRequire("dA7TN");
const { useSwitch: $72b2d0fa90dcdffb$var$useSwitch } = (0, $dA7TN.createSwitchController)('jira-switch-modals');
const $72b2d0fa90dcdffb$export$5ed4b99cbad4ebd6 = $72b2d0fa90dcdffb$var$useSwitch;

});
parcelRegister("dA7TN", function(module, exports) {

$parcel$export(module.exports, "createSwitchController", () => $3d9c3bd86080b366$export$1856548326159ec8);

var $eJOHy = parcelRequire("eJOHy");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $3d9c3bd86080b366$export$1856548326159ec8 = (name, activeByDefault)=>{
    const actions = {
        on: (active)=>({ setState: setState })=>setState({
                    active: active
                }),
        off: (active)=>({ setState: setState, getState: getState })=>{
                if (getState().active === active || active === undefined) setState({
                    active: undefined
                });
            },
        toggle: (active)=>({ getState: getState, dispatch: dispatch })=>{
                if (getState().active === active) dispatch(actions.off(active));
                else dispatch(actions.on(active));
            }
    };
    const initialState = {
        active: activeByDefault
    };
    const store = (0, $GtRbT.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    const SwitchContainer = (0, $6E16M.createContainer)(store);
    const selector = (state, key)=>state.active === key;
    const useSwitchInternal = (0, $iJq0l.createHook)(store, {
        selector: selector
    });
    const useSwitch = (active)=>{
        const [isActive, { on: onSwitch, off: offSwitch, toggle: toggleSwitch }] = useSwitchInternal(active);
        const on = (0, $eJOHy.useCallback)(()=>onSwitch(active), [
            onSwitch,
            active
        ]);
        const off = (0, $eJOHy.useCallback)(()=>offSwitch(active), [
            active,
            offSwitch
        ]);
        const toggle = (0, $eJOHy.useCallback)(()=>toggleSwitch(active), [
            toggleSwitch,
            active
        ]);
        return [
            isActive,
            {
                on: on,
                off: off,
                toggle: toggle
            }
        ];
    };
    return {
        SwitchContainer: SwitchContainer,
        useSwitch: useSwitch
    };
};

});


const $e6bca68b75395543$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Dashboards';
const $e6bca68b75395543$export$d57b6b390e78d90f = 'jira-cosmos';
const $e6bca68b75395543$export$65b778215f917c60 = 'viewAllDashboards';
const $e6bca68b75395543$export$7be02fe416808d26 = 'createDashboard';
const $e6bca68b75395543$export$f06dfcec5ff912e = 'meatballDropdown';

parcelRegister("kJJos", function(module, exports) {

$parcel$export(module.exports, "AnalyticContext", () => $235568eca06a9a9f$export$da0556bf821b3494);
$parcel$export(module.exports, "AnalyticContextProvider", () => $235568eca06a9a9f$export$aea8e3edcdec81e3);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");




var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

const $235568eca06a9a9f$export$da0556bf821b3494 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    fireUIAnalyticForFixMenuItem: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    fireUIAnalyticForFixButton: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    fireUIAnalyticForFavouriteToggle: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    fireUIAnalyticForDashboardItems: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});
const $235568eca06a9a9f$export$aea8e3edcdec81e3 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const fireUIAnalyticForFixMenuItem = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                itemId: (0, $e6bca68b75395543$export$65b778215f917c60)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFixButton = (0, $eJOHy.useCallback)(({ itemId: itemId })=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: itemId
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFavouriteToggle = (0, $eJOHy.useCallback)(({ starType: starType, parentItemId: parentItemId })=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$74712b62056d422e),
                parentItemId: parentItemId,
                parentItemType: 'dashboard',
                itemId: starType
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForDashboardItems = (0, $eJOHy.useCallback)(({ itemId: itemId, section: section })=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
                itemType: (0, $6bf6536f83c22cfe$export$4695c1a423ffe431).toLowerCase(),
                itemId: itemId,
                section: section
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const memoValue = (0, $eJOHy.useMemo)(()=>({
            fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem,
            fireUIAnalyticForFixButton: fireUIAnalyticForFixButton,
            fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle,
            fireUIAnalyticForDashboardItems: fireUIAnalyticForDashboardItems
        }), [
        fireUIAnalyticForDashboardItems,
        fireUIAnalyticForFavouriteToggle,
        fireUIAnalyticForFixButton,
        fireUIAnalyticForFixMenuItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($235568eca06a9a9f$export$da0556bf821b3494.Provider, {
        value: memoValue
    }, children);
};

});

parcelRegister("3hxrg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4099873d99178e32$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4099873d99178e32$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createDashboard: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.action-buttons.create-dashboard",
        "defaultMessage": "Create dashboard"
    }
});

});


parcelRegister("idh5p", function(module, exports) {

$parcel$export(module.exports, "DashboardsDefault", () => $9e2134a56ceba433$export$bffc92c7e4f51e0b);

var $eJOHy = parcelRequire("eJOHy");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $bbdV2 = parcelRequire("bbdV2");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $if69u = parcelRequire("if69u");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $hPlDs = parcelRequire("hPlDs");

var $kEUB1 = parcelRequire("kEUB1");


var $jrulJ = parcelRequire("jrulJ");

var $eApSa = parcelRequire("eApSa");


var $4LPom = parcelRequire("4LPom");

var $hUpHQ = parcelRequire("hUpHQ");
const $9e2134a56ceba433$export$bffc92c7e4f51e0b = /*#__PURE__*/ (0, $eJOHy.memo)($9e2134a56ceba433$var$_DashboardsDefault);
function $9e2134a56ceba433$var$_DashboardsDefault(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded } = props;
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const cloudId = (0, $kEUB1.useCloudId)();
    // Ignore this error as our component does not need the context.
    // @ts-expect-error - Property 'context' is missing in type '{ tenantContext: { cloudId: string; }; }' but required in type 'EntryPointRouteParams'.ts(2741)
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId
            }
        }), [
        cloudId
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, react-hooks/rules-of-hooks
    const leftSidebarEPRef = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$50ea883ba6f28ff5));
    const dashboardsEPRef = leftSidebarEPRef?.entryPoints?.dashboards;
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $hUpHQ.nav4DashboardsContentEntryPoint), entryPointParams);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).DASHBOARDS);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const epContainerProps = (0, $eJOHy.useMemo)(()=>({
            id: 'nav4-sidebar-dashboards-default',
            packageName: (0, $e6bca68b75395543$export$b8b9d90f9e5bd72b),
            teamName: (0, $e6bca68b75395543$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
                withHeading: true
            }),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            runtimeProps: entryPointParams
        }), [
        entryPointParams
    ]);
    // This callback makes sure that the EP is loaded when the _system_ determines that the expandable
    // should be open.
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const onSystemToggleFn = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const onExpansionToggleFn = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).DASHBOARDS,
                sectionItem: (0, $a9aec.SECTION_ITEM_DASHBOARDS)
            });
        }
    }, [
        entryPointActions,
        sendSectionItemAnalyticsEvent
    ]);
    const menuId = (0, $h4Bzb.MENU_ID_DASHBOARDS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: onSystemToggleFn,
        onExpansionToggle: onExpansionToggleFn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-dashboards-default",
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $azEgq.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eApSa.RouteEntryPointContainer), {
        epContainerProps: epContainerProps,
        jiraEPRef: entryPointReferenceSubject,
        nestedEPRef: dashboardsEPRef,
        placeholderEntryPoint: (0, $hUpHQ.nav4DashboardsContentEntryPoint)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4LPom.Footer), null)));
}

});
parcelRegister("jrulJ", function(module, exports) {

$parcel$export(module.exports, "usePageLayoutEntryPoint", () => $176e6598597033a8$export$fe1c839e8baf4110);

var $bOCnJ = parcelRequire("bOCnJ");

var $hih5V = parcelRequire("hih5V");
const $176e6598597033a8$export$fe1c839e8baf4110 = (layoutField)=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const entryPointReference = (0, $bOCnJ.useRouteEntryPoint)({
        route: route
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return entryPointReference?.entryPoints[layoutField];
};

});
parcelRegister("bOCnJ", function(module, exports) {

$parcel$export(module.exports, "useRouteEntryPoint", () => $f5fa505b42a47760$export$c96377f800cdddb4);

var $jgV2J = parcelRequire("jgV2J");
const $f5fa505b42a47760$export$c96377f800cdddb4 = ({ route: route })=>{
    const [lastLoadedRoute] = (0, $jgV2J.useLastLoadedRoute)();
    // route.entryPoint is already loaded
    if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) return lastLoadedRoute.entryPointReference;
    return null;
};

});
parcelRegister("jgV2J", function(module, exports) {

$parcel$export(module.exports, "useLastLoadedRoute", () => $998a919eec0f86c9$export$895238443fc3eae4);
$parcel$export(module.exports, "getEntryPointsStore", () => $998a919eec0f86c9$export$fe654a734624d17f);
$parcel$export(module.exports, "getLastLoadedRoute", () => $998a919eec0f86c9$export$5763b2305b3056df);
$parcel$export(module.exports, "getPrefetchingRoute", () => $998a919eec0f86c9$export$7e18f3e3cbd04326);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $14kUX = parcelRequire("14kUX");
const $998a919eec0f86c9$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
        setState({
            lastLoadedRoute: {
                route: route,
                entryPointReference: entryPointReference
            }
        });
    };
const $998a919eec0f86c9$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
        setState({
            prefetchingRoute: {
                routerContext: routerContext,
                expiresAt: expiresAt,
                entryPointReference: entryPointReference
            }
        });
    };
const $998a919eec0f86c9$var$actions = {
    setLastLoadedRoute: $998a919eec0f86c9$export$1cec83a23d40a9fa,
    setPrefetchingRoute: $998a919eec0f86c9$export$bb3dc9c55f78173e
};
const $998a919eec0f86c9$var$EntryPointsStore = (0, $GtRbT.createStore)({
    initialState: {
        lastLoadedRoute: null,
        prefetchingRoute: null
    },
    actions: $998a919eec0f86c9$var$actions,
    name: 'react-resource-router/entry-points'
});
const $998a919eec0f86c9$export$895238443fc3eae4 = (0, $iJq0l.createHook)($998a919eec0f86c9$var$EntryPointsStore, {
    selector: (state)=>state.lastLoadedRoute
});
const $998a919eec0f86c9$export$fe654a734624d17f = ()=>(0, $14kUX.defaultRegistry).getStore($998a919eec0f86c9$var$EntryPointsStore);
const $998a919eec0f86c9$export$b28ecd0e4705f6b7 = ()=>$998a919eec0f86c9$export$fe654a734624d17f().storeState.getState();
const $998a919eec0f86c9$export$5763b2305b3056df = ()=>$998a919eec0f86c9$export$b28ecd0e4705f6b7().lastLoadedRoute;
const $998a919eec0f86c9$export$7e18f3e3cbd04326 = ()=>$998a919eec0f86c9$export$b28ecd0e4705f6b7().prefetchingRoute;

});



parcelRegister("eApSa", function(module, exports) {

$parcel$export(module.exports, "RouteEntryPointContainer", () => $3d3c8b1ee7532595$export$3e4cdfb894377bc9);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2dBpR = parcelRequire("2dBpR");

var $cBavF = parcelRequire("cBavF");

var $1KdDN = parcelRequire("1KdDN");

var $16sa1 = parcelRequire("16sa1");
const $3d3c8b1ee7532595$export$3e4cdfb894377bc9 = /*#__PURE__*/ (0, $eJOHy.memo)(({ epContainerProps: epContainerProps, jiraEPRef: jiraEPRef, nestedEPRef: nestedEPRef, shouldRenderNestedEntryPoint: shouldRenderNestedEntryPoint = true })=>{
    // If the route is an entryPoint, and the initialRoute was an entryPoint, use EntryPointContainer.
    // Otherwise, use the JiraEntryPointContainer.
    return shouldRenderNestedEntryPoint && nestedEPRef ? // eslint-disable-next-line jira/ufo/valid-labels
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: `${epContainerProps.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        attributes: epContainerProps.errorAttributes,
        fallback: epContainerProps.errorFallback,
        id: epContainerProps.id,
        packageName: epContainerProps.packageName,
        teamName: epContainerProps.teamName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        name: `${epContainerProps.id || 'route-entrypoint-adapter'}-entrypoint-placeholder`,
        fallback: epContainerProps.fallback,
        entryPointReference: nestedEPRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: nestedEPRef,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        ...epContainerProps,
        entryPointReferenceSubject: jiraEPRef
    });
});

});
parcelRegister("2dBpR", function(module, exports) {

$parcel$export(module.exports, "getPlaceholdersFromHTML", () => $8022a3e2b790699e$export$9e9f35acc3af3a9a);
$parcel$export(module.exports, "EntryPointPlaceholderContext", () => $8022a3e2b790699e$export$b5b377bb81310c48);
$parcel$export(module.exports, "EntryPointReferencePlaceholder", () => $8022a3e2b790699e$export$35247b69e0cfe74);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $7jTnu = parcelRequire("7jTnu");

var $f2JN3 = parcelRequire("f2JN3");
const $8022a3e2b790699e$var$styles = {
    root: "_1e0c1bgi"
};
const $8022a3e2b790699e$var$Placeholder = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-concurrent-fix-entrypoint-placeholder'), (0, $ch9En.PlaceholderWithNativeSuspense), (0, $ch9En.default));
function $8022a3e2b790699e$export$9e9f35acc3af3a9a() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return new Map(Array.from(placeholders, (el)=>[
            el.dataset.epPlaceholderId,
            el.innerHTML
        ]));
}
const $8022a3e2b790699e$export$b5b377bb81310c48 = /*#__PURE__*/ (0, $eJOHy.createContext)(new Map());
function $8022a3e2b790699e$export$35247b69e0cfe74({ children: children, entryPointReference: entryPointReference, fallback: originalFallback, name: name, ...placeholderProps }) {
    const hasMounted = (0, $eJOHy.useRef)(false);
    // using useState to ensure the entryPointReference is loaded synchronously
    // for the initial render (enabling SSR)
    const [component] = (0, $eJOHy.useState)(()=>{
        if (entryPointReference) try {
            return entryPointReference.getComponent();
        } catch (thrown) {
            return undefined;
        }
    });
    const placeholders = (0, $eJOHy.useContext)($8022a3e2b790699e$export$b5b377bb81310c48);
    const ssrFallback = placeholders.get(name);
    const [fallback, setFallback] = (0, $eJOHy.useState)(!ssrFallback || component ? originalFallback : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: ssrFallback
        },
        "data-ep-placeholder-id": name,
        className: (0, $hcewu.default)([
            $8022a3e2b790699e$var$styles.root
        ])
    }));
    const lastOriginalFallback = (0, $eJOHy.useRef)(originalFallback);
    lastOriginalFallback.current = originalFallback;
    const resetFallback = (0, $eJOHy.useCallback)(()=>{
        if (placeholders.has(name)) {
            placeholders.delete(name);
            setFallback(lastOriginalFallback.current);
        }
    }, [
        name,
        placeholders,
        setFallback
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // reset the fallback when the entrypoint reference changes
        if (hasMounted.current) resetFallback();
    }, [
        entryPointReference,
        resetFallback
    ]);
    (0, $eJOHy.useEffect)(()=>{
        hasMounted.current = true;
        // reset fallback on unmount
        return resetFallback;
    }, [
        resetFallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8022a3e2b790699e$var$Placeholder, {
        fallback: fallback,
        name: name,
        ...placeholderProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-ep-placeholder-id": name,
        className: (0, $hcewu.default)([
            $8022a3e2b790699e$var$styles.root
        ])
    }, children));
}

});


parcelRegister("4LPom", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $43066705c12c7d2f$export$a06f1c675e846f6f);

var $eJOHy = parcelRequire("eJOHy");

var $2y3Ci = parcelRequire("2y3Ci");
var $ilbtc = parcelRequire("ilbtc");
var $1swHh = parcelRequire("1swHh");

var $lRq8t = parcelRequire("lRq8t");

var $h4Bzb = parcelRequire("h4Bzb");

var $1Ce3C = parcelRequire("1Ce3C");

var $fuV6j = parcelRequire("fuV6j");

var $kJJos = parcelRequire("kJJos");

var $1TJWv = parcelRequire("1TJWv");
const $43066705c12c7d2f$var$VIEW_ALL_DASHBOARDS_HREF = (0, $fuV6j.dashboardsDirectoryRoute).path;
const $43066705c12c7d2f$export$a06f1c675e846f6f = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem } = (0, $eJOHy.useContext)((0, $kJJos.AnalyticContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Ce3C.ViewAllEntityMenuItem), {
        href: $43066705c12c7d2f$var$VIEW_ALL_DASHBOARDS_HREF,
        menuId: (0, $h4Bzb.MENU_ID_DASHBOARDS_VIEW_ALL),
        onClick: (e)=>{
            fireUIAnalyticForFixMenuItem();
            onClose?.(e);
        }
    }, formatMessage((0, $1TJWv.default).viewAllDashboards)))));
};

});
parcelRegister("1Ce3C", function(module, exports) {

$parcel$export(module.exports, "ViewAllEntityMenuItem", () => $6b70189709783932$export$505e81ff2081288b);

var $eJOHy = parcelRequire("eJOHy");

var $lers0 = parcelRequire("lers0");

var $i0tMD = parcelRequire("i0tMD");
function $6b70189709783932$export$505e81ff2081288b(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        ...props,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lers0))), {
            label: "",
            color: "currentColor"
        })
    });
}

});
parcelRegister("lers0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8c17960d483820ffdc74817869db42b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f75032e615ed61f1$var$_react = $f75032e615ed61f1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f75032e615ed61f1$var$_baseNew = $f75032e615ed61f1$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $f75032e615ed61f1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f75032e615ed61f1$var$AlignTextLeftIcon = (props)=>/*#__PURE__*/ $f75032e615ed61f1$var$_react.default.createElement($f75032e615ed61f1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM8 14H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$f75032e615ed61f1$var$AlignTextLeftIcon.displayName = 'AlignTextLeftIcon';
var $f75032e615ed61f1$var$_default = module.exports.default = $f75032e615ed61f1$var$AlignTextLeftIcon;

});


parcelRegister("1TJWv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2276efb8df1b227f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2276efb8df1b227f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewAllDashboards: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.footer.view-all-dashboards",
        "defaultMessage": "View all dashboards"
    }
});

});


parcelRegister("hUpHQ", function(module, exports) {

$parcel$export(module.exports, "nav4DashboardsContentEntryPoint", () => $b7477b456fabc7f8$export$d6e6956d3748383b);

var $hGie9 = parcelRequire("hGie9");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $b7477b456fabc7f8$export$d6e6956d3748383b = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("fKubF")).then(({ DashboardsContentViewQuery: DashboardsContentViewQuery })=>DashboardsContentViewQuery), {
        moduleId: "d524dcfe",
        moduleName: "DashboardsContentViewQuery",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId || '';
        return {
            queries: {
                queryRef: {
                    parameters: $hGie9.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("hGie9", function(module, exports) {

$parcel$export(module.exports, "default", () => $21b0fdb40b894199$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6793555e2dbfaf8db2fe4c7edd9d81f4>>
 * @relayHash 9a58486151638f4e45660f746394b248
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 187971dfb7440b89eb5a98f67e766ec91b921dc8dd450612125a7211123e347d
const $21b0fdb40b894199$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "187971dfb7440b89eb5a98f67e766ec91b921dc8dd450612125a7211123e347d",
        "metadata": {},
        "name": "DashboardsContentViewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $21b0fdb40b894199$export$2e2bcd8739ae039 = $21b0fdb40b894199$var$node;

});

parcelRegister("fKubF", function(module, exports) {

let $b77291700686f81d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b77291700686f81d$var$load("gBxkr").then(()=>parcelRequire('bwe76'));

});





parcelRegister("5n5Xi", function(module, exports) {

$parcel$export(module.exports, "Nav4Filters", () => $49cceca1658c509f$export$caf6e58bb8560bb2);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $jqMKi = parcelRequire("jqMKi");

var $16sa1 = parcelRequire("16sa1");

const $49cceca1658c509f$export$caf6e58bb8560bb2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4-sidebar-filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "filters-section",
        packageName: (0, $2ae2c8b27c911905$export$b8b9d90f9e5bd72b),
        teamName: (0, $2ae2c8b27c911905$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jqMKi.Nav4Filters), props)));

});
parcelRegister("jqMKi", function(module, exports) {

$parcel$export(module.exports, "Nav4Filters", () => $86fa36ef170147e1$export$caf6e58bb8560bb2);

var $dG4lF = parcelRequire("dG4lF");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $8mGa3 = parcelRequire("8mGa3");

var $fhtBG = parcelRequire("fhtBG");

var $3E5ko = parcelRequire("3E5ko");
function $86fa36ef170147e1$export$caf6e58bb8560bb2({ isExpanded: isExpanded, queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $dG4lF.default), queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const actionButtons = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8mGa3.ActionButtons), null), []);
    if (!data.jira?.hasIsFiltersExpanded && isInitialSelectedPath((0, $h4Bzb.MENU_ID_FILTERS))) // We need to make sure that we're only passing the conditionalal fragment when it is actually
    // available. Due to a lack of support the @alias Relay directive, we need to use another mechanism
    // and in this case we're using a hardcoded __typename to check if the fragment is available.
    // This is a workaround until we can use the @alias directive in Relay. If the hasIsProjectsExpanded
    // attribute is not available, then the fragment won't be either and we shouldn't pass it.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3E5ko.Nav4FiltersDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
    return isInitialSelectedPath((0, $h4Bzb.MENU_ID_FILTERS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fhtBG.Nav4FiltersForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3E5ko.Nav4FiltersDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
}

});
parcelRegister("dG4lF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dbff990dd23a4a7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca5697fbb6a29ad933542b5ec3a3de2d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4dbff990dd23a4a7$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isFiltersExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Filters",
    "selections": [
        {
            "condition": "isFiltersExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4FiltersForLanding"
                }
            ]
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "hasIsFiltersExpanded",
                            "kind": "ScalarField",
                            "name": "__typename"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$4dbff990dd23a4a7$var$node.hash = "3df2d83f4108ed18026f86044ce6e248";
var $4dbff990dd23a4a7$export$2e2bcd8739ae039 = $4dbff990dd23a4a7$var$node;

});

parcelRegister("8mGa3", function(module, exports) {

$parcel$export(module.exports, "ActionButtons", () => $c42e29f2711fde62$export$88c65d2d98aab183);

var $eJOHy = parcelRequire("eJOHy");

var $MlWTN = parcelRequire("MlWTN");





var $8IuE5 = parcelRequire("8IuE5");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $286cZ = parcelRequire("286cZ");

var $7jTnu = parcelRequire("7jTnu");

var $1TzuH = parcelRequire("1TzuH");
const $c42e29f2711fde62$export$88c65d2d98aab183 = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'), ({ onClose: onClose })=>{
    const sendFilterAnalytics = (0, $1TzuH.useFilterActionsAnalytics)();
    const sendMeatballAnalytics = (0, $eJOHy.useCallback)(()=>{
        sendFilterAnalytics((0, $bfc89d778f76f56d$export$b887e88d8d0739f6), {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e)
        });
    }, [
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: sendMeatballAnalytics,
        MenuItems: $c42e29f2711fde62$var$MoreMenuItems,
        onClose: onClose
    });
});
function $c42e29f2711fde62$var$MoreMenuItems(_) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).FILTERS,
        hasSeparator: false
    }));
}

});
parcelRegister("1TzuH", function(module, exports) {

$parcel$export(module.exports, "useFilterActionsAnalytics", () => $e5be81988b092880$export$97e99df7fbddf9f6);
$parcel$export(module.exports, "getFilterActionAttributes", () => $e5be81988b092880$export$b06742bfd24ebf9f);
$parcel$export(module.exports, "getFilterMeatBallAttributes", () => $e5be81988b092880$export$b8e6b9b84ba340a2);
$parcel$export(module.exports, "getRecentAndFavouriteFilterAttributes", () => $e5be81988b092880$export$2108e20c9691c7e4);
$parcel$export(module.exports, "getDefaulFilterAttributes", () => $e5be81988b092880$export$15e07b997aa6036a);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");





var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");
const $e5be81988b092880$export$97e99df7fbddf9f6 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const fireFilterActionAnalytics = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)((actionSubject, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: actionSubject
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_FILTERS], attributes);
    }, [
        createAnalyticsEvent
    ]) : (actionSubject, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: actionSubject
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_FILTERS], attributes);
    };
    return fireFilterActionAnalytics;
};
const $e5be81988b092880$var$systemFilterNameMap = [
    {
        name: 'myOpenIssues',
        id: '-1'
    },
    {
        name: 'reportedByMe',
        id: '-2'
    },
    {
        name: 'allIssues',
        id: '-4'
    },
    {
        name: 'openIssues',
        id: '-5'
    },
    {
        name: 'doneIssues',
        id: '-9'
    },
    {
        name: 'viewedRecently',
        id: '-3'
    },
    {
        name: 'resolvedRecently',
        id: '-7'
    },
    {
        name: 'updatedRecently',
        id: '-8'
    },
    {
        name: 'createdRecently',
        id: '-6'
    }
];
const $e5be81988b092880$export$c8c77a62dd73e040 = (id)=>{
    const systemFilter = $e5be81988b092880$var$systemFilterNameMap.find((filter)=>filter.id === id);
    return systemFilter?.name || '';
};
const $e5be81988b092880$var$getSection = (isCustom, isFavourite)=>{
    let section;
    if (!isCustom && !isFavourite) section = 'defaultFilters';
    else if (isFavourite) section = (0, $a9aec.SECTION_ITEM_STARRED);
    else section = (0, $a9aec.SECTION_ITEM_RECENT);
    return section;
};
const $e5be81988b092880$var$getFilterId = (isCustom, filterId)=>{
    if (!filterId) return null;
    return (0, $h4Bzb.ENTITY_ID).FILTER(isCustom ? filterId : $e5be81988b092880$export$c8c77a62dd73e040(filterId));
};
const $e5be81988b092880$export$b06742bfd24ebf9f = ({ itemId: itemId, isCustom: isCustom, isFavourite: isFavourite, filterId: filterId })=>{
    const section = $e5be81988b092880$var$getSection(isCustom, Boolean(isFavourite));
    return {
        itemId: itemId,
        section: section,
        level: section === 'defaultFilters' ? (0, $4fdd5d9c1b32dd60$export$35ac629b8b943d5a) : (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
        componentType: isCustom ? (0, $493796f3bdee881c$export$5374c2c2d3ece55e) : (0, $493796f3bdee881c$export$74712b62056d422e),
        parentItemType: isCustom ? (0, $6bf6536f83c22cfe$export$c1c49903035a02df) : (0, $6bf6536f83c22cfe$export$6deee0e4f2fb784e),
        parentItemId: $e5be81988b092880$var$getFilterId(isCustom, filterId)
    };
};
const $e5be81988b092880$export$b8e6b9b84ba340a2 = ({ isCustom: isCustom, isFavourite: isFavourite, filterId: filterId })=>{
    const section = $e5be81988b092880$var$getSection(isCustom, Boolean(isFavourite));
    return {
        section: section,
        level: section === 'defaultFilters' ? (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18) : (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
        componentType: isCustom ? (0, $493796f3bdee881c$export$9bd6c21d500ae611) : (0, $493796f3bdee881c$export$95b0c331af13d819),
        itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e),
        parentItemType: isCustom ? (0, $6bf6536f83c22cfe$export$c1c49903035a02df) : (0, $6bf6536f83c22cfe$export$6deee0e4f2fb784e),
        parentItemId: $e5be81988b092880$var$getFilterId(isCustom, filterId)
    };
};
const $e5be81988b092880$export$2108e20c9691c7e4 = ({ isCustom: isCustom, filterId: filterId, section: section })=>{
    return {
        level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
        section: section,
        componentType: isCustom ? (0, $493796f3bdee881c$export$3ac911b122986477) : (0, $493796f3bdee881c$export$4165a3d0da3bd147),
        itemId: $e5be81988b092880$var$getFilterId(isCustom, filterId),
        itemType: isCustom ? (0, $6bf6536f83c22cfe$export$c1c49903035a02df) : (0, $6bf6536f83c22cfe$export$6deee0e4f2fb784e)
    };
};
const $e5be81988b092880$export$15e07b997aa6036a = ({ filterId: filterId })=>{
    return {
        level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
        itemId: $e5be81988b092880$var$getFilterId(false, filterId),
        section: 'defaultFilters',
        componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
        itemType: (0, $6bf6536f83c22cfe$export$6deee0e4f2fb784e)
    };
};

});


parcelRegister("fhtBG", function(module, exports) {

$parcel$export(module.exports, "Nav4FiltersForLanding", () => $50bd50e1c8f32fbc$export$90658bd06cecabd4);

var $68RLL = parcelRequire("68RLL");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $1KdDN = parcelRequire("1KdDN");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $16sa1 = parcelRequire("16sa1");

var $7jTnu = parcelRequire("7jTnu");

var $4yn0c = parcelRequire("4yn0c");


var $lRTqK = parcelRequire("lRTqK");

var $44iMp = parcelRequire("44iMp");
function $50bd50e1c8f32fbc$export$90658bd06cecabd4(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).FILTERS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const data = (0, $j4oe4.useFragment)((0, $68RLL.default), queryRef);
    const menuId = (0, $h4Bzb.MENU_ID_FILTERS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).FILTERS,
                sectionItem: (0, $a9aec.SECTION_ITEM_FILTERS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        interactionName: (0, $7jTnu.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-filters-landing' : undefined,
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon + text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $azEgq.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $44iMp.Header), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4-sidebar-filters-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "nav4-sidebar-filters-landing",
        packageName: (0, $2ae2c8b27c911905$export$b8b9d90f9e5bd72b),
        teamName: (0, $2ae2c8b27c911905$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4yn0c.Nav4FiltersContent), {
        queryRef: data
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRTqK.Footer), null)));
}

});
parcelRegister("68RLL", function(module, exports) {

$parcel$export(module.exports, "default", () => $982db24ca69b6fc2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e3cce317c9d4d64ec51601d1438d8020>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $982db24ca69b6fc2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FiltersForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4FiltersContent"
        }
    ],
    "type": "Query"
};
$982db24ca69b6fc2$var$node.hash = "6171665054b4de86e6a0c40316984aba";
var $982db24ca69b6fc2$export$2e2bcd8739ae039 = $982db24ca69b6fc2$var$node;

});

parcelRegister("4yn0c", function(module, exports) {

$parcel$export(module.exports, "Nav4FiltersContent", () => $94ac381b9a46e100$export$e0cd6afcf36dd0ac);

var $7QKYs = parcelRequire("7QKYs");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $fHvuI = parcelRequire("fHvuI");
var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");
var $2y3Ci = parcelRequire("2y3Ci");
var $ilbtc = parcelRequire("ilbtc");
var $1swHh = parcelRequire("1swHh");
var $jLuq7 = parcelRequire("jLuq7");

var $6rSB4 = parcelRequire("6rSB4");

var $lRq8t = parcelRequire("lRq8t");




var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $hc6Nm = parcelRequire("hc6Nm");

var $i0tMD = parcelRequire("i0tMD");

var $h3HFC = parcelRequire("h3HFC");

var $3uQAw = parcelRequire("3uQAw");

var $6z0UB = parcelRequire("6z0UB");

var $kEUB1 = parcelRequire("kEUB1");

var $cECwI = parcelRequire("cECwI");

var $7jTnu = parcelRequire("7jTnu");

var $fAZgY = parcelRequire("fAZgY");

var $f7RmV = parcelRequire("f7RmV");

var $1TzuH = parcelRequire("1TzuH");

var $8aXvZ = parcelRequire("8aXvZ");
const $94ac381b9a46e100$var$MAX_RECENT_FILTERS = 5;
const $94ac381b9a46e100$export$1f869c99ead9db5f = 15;
const $94ac381b9a46e100$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
const $94ac381b9a46e100$var$defaultFiltersRequiringLogin = [
    {
        id: '-1'
    },
    {
        id: '-2'
    },
    {
        id: '-3'
    }
];
const $94ac381b9a46e100$var$entityTypenames = [
    'JiraCustomFilter',
    'JiraSystemFilter'
];
function $94ac381b9a46e100$export$e0cd6afcf36dd0ac({ queryRef: queryRef }) {
    const cloudId = (0, $kEUB1.useCloudId)();
    const { getStableItems: getStableItems } = (0, $3uQAw.useStableItems)();
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    // We intentionally request 15 starred and 20 recent filters.
    // Recent filters should exclude system/default filters.
    // Then, if all 15 starred filters were recently visited, we still show 5 recent filters as well.
    const [fragmentData, refetch] = (0, $j4oe4.useRefetchableFragment)((0, $7QKYs.default), queryRef);
    const { jira: { favouriteFilters: favouriteFilters, recentFilters: recentFilters, systemFilters: systemFilters } } = fragmentData;
    (0, $hc6Nm.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $6z0UB.default,
        refetch: refetch,
        menuId: (0, $h4Bzb.MENU_ID_FILTERS)
    });
    const refetchOnChange = (0, $eJOHy.useCallback)(({ onComplete: onComplete })=>{
        refetch({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        cloudId,
        refetch
    ]);
    (0, $h3HFC.useSubscribeAndUpdateFavorites)({
        entityTypename: $94ac381b9a46e100$var$entityTypenames,
        favouriteConnectionId: favouriteFilters.__id,
        recentConnectionId: recentFilters.__id,
        refetch: refetchOnChange
    });
    const { subscribe: subscribe, unsubscribe: unsubscribe } = (0, $6rSB4.useDeleteChangeActions)();
    // allows the sidebar to reflect filter changes when a filter is deleted from the filters directory page
    (0, $eJOHy.useEffect)(()=>{
        subscribe(refetchOnChange);
        return ()=>{
            unsubscribe(refetchOnChange);
        };
    }, [
        refetchOnChange,
        subscribe,
        unsubscribe
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const starred = formatMessage((0, $8aXvZ.default).starred);
    const recent = formatMessage((0, $8aXvZ.default).recent);
    const sendFilterAnalytics = (0, $1TzuH.useFilterActionsAnalytics)();
    const favorites = (0, $eJOHy.useMemo)(()=>{
        const ids = favouriteFilters.edges?.map((edge)=>edge?.node.filterId).filter(Boolean) ?? [];
        const list = favouriteFilters.edges?.filter(Boolean).map((edge)=>{
            const isCustom = edge.node.__typename === 'JiraCustomFilter';
            const sendFavouriteFilterAnalytics = ()=>sendFilterAnalytics((0, $bfc89d778f76f56d$export$6dd9406e478a1fe2), (0, $1TzuH.getRecentAndFavouriteFilterAttributes)({
                    isCustom: isCustom,
                    filterId: edge.node.filterId,
                    section: (0, $a9aec.SECTION_ITEM_STARRED)
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7RmV.Nav4FilterMenuItem), {
                key: edge.node.filterId,
                queryRef: edge.node,
                onRefetch: refetchOnChange,
                onClick: sendFavouriteFilterAnalytics
            });
        }) ?? [];
        return {
            idSet: new Set(ids),
            list: list.slice(0, $94ac381b9a46e100$export$1f869c99ead9db5f),
            hasItems: Boolean(list.length),
            hasMore: favouriteFilters.pageInfo?.hasNextPage || list.length > $94ac381b9a46e100$export$1f869c99ead9db5f
        };
    }, [
        favouriteFilters,
        refetchOnChange,
        sendFilterAnalytics
    ]);
    const recentItems = (0, $eJOHy.useMemo)(()=>{
        const nodes = recentFilters.edges?.filter(Boolean).filter((edge)=>edge.node.filterId && !favorites.idSet.has(edge.node.filterId)).map((edge)=>edge.node).slice(0, $94ac381b9a46e100$var$MAX_RECENT_FILTERS) ?? [];
        const stableOrderedNodes = getStableItems({
            nodes: nodes,
            idKey: 'filterId'
        });
        const list = stableOrderedNodes.map((node)=>{
            const sendRecentFilterAnalytics = ()=>sendFilterAnalytics((0, $bfc89d778f76f56d$export$6dd9406e478a1fe2), (0, $1TzuH.getRecentAndFavouriteFilterAttributes)({
                    isCustom: true,
                    filterId: node.filterId,
                    section: (0, $a9aec.SECTION_ITEM_RECENT)
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7RmV.Nav4FilterMenuItem), {
                key: node.filterId,
                queryRef: node,
                onRefetch: refetchOnChange,
                onClick: sendRecentFilterAnalytics
            });
        });
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        recentFilters.edges,
        getStableItems,
        favorites.idSet,
        refetchOnChange,
        sendFilterAnalytics
    ]);
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const defaultItems = (0, $eJOHy.useMemo)(()=>{
        const filterIds = [];
        const list = systemFilters.edges?.filter((edge)=>edge?.node?.filterId && !favorites.idSet.has(edge.node.filterId))?.filter((edge)=>edge?.node?.filterId && (!isAnonymous || !$94ac381b9a46e100$var$defaultFiltersRequiringLogin.find((filter)=>filter.id === edge.node.filterId))).map((edge)=>{
            edge?.node && filterIds.push(edge?.node.filterId);
            return edge;
        }).map((edge)=>{
            if (!edge?.node) return null;
            const sendDefaultFilterAnalytics = ()=>sendFilterAnalytics((0, $bfc89d778f76f56d$export$6dd9406e478a1fe2), (0, $1TzuH.getDefaulFilterAttributes)({
                    filterId: edge.node.filterId
                }));
            return edge?.node ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7RmV.Nav4FilterMenuItem), {
                key: edge.node.filterId,
                queryRef: edge.node,
                onRefetch: refetchOnChange,
                onClick: sendDefaultFilterAnalytics
            }) : null;
        }) || [];
        return {
            list: list,
            hasItems: Boolean(list.length),
            filterIds: filterIds
        };
    }, [
        systemFilters.edges,
        favorites.idSet,
        isAnonymous,
        refetchOnChange,
        sendFilterAnalytics
    ]);
    const sendViewAllStarredAnalytics = (0, $eJOHy.useCallback)(()=>{
        sendFilterAnalytics((0, $bfc89d778f76f56d$export$6dd9406e478a1fe2), {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            itemId: 'viewAllStarred'
        });
    }, [
        sendFilterAnalytics
    ]);
    const sendDefaultFilterDropdownAnalytics = (0, $eJOHy.useCallback)(()=>{
        sendFilterAnalytics((0, $bfc89d778f76f56d$export$b887e88d8d0739f6), {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
            itemId: 'defaultFilters'
        });
    }, [
        sendFilterAnalytics
    ]);
    const onExpansionToggle = (0, $fAZgY.useCallbackWithCondition)((hasExpanded)=>{
        if (hasExpanded) sendDefaultFilterDropdownAnalytics();
    }, [
        sendDefaultFilterDropdownAnalytics
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLuq7.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, favorites.list))), favouriteFilters.pageInfo?.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: $94ac381b9a46e100$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $h4Bzb.MENU_ID_FILTERS_VIEW_ALL_STARRED),
        onClick: sendViewAllStarredAnalytics
    }, formatMessage((0, $8aXvZ.default).viewAllStarred))), recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLuq7.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, recentItems.list))), defaultItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fHvuI.ExpandableMenuItem), {
        isDefaultExpanded: true,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        interactionName: (0, $7jTnu.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-filters-default-filters' : undefined
    }, formatMessage((0, $8aXvZ.default).defaultFilters)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, defaultItems.list)));
}

});
parcelRegister("7QKYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1d57770e701dfe1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ffa5b5733326eabb56fcfb6e2f05b1d3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $6z0UB = parcelRequire("6z0UB");
const $a1d57770e701dfe1$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v2 = {
        "kind": "FragmentSpread",
        "name": "Nav4FilterMenuItem"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        v2 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $6z0UB.default)
            }
        },
        "name": "Nav4FiltersContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "favouriteFilters",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "FILTER"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v1 /*: any*/ ,
                                                                v2 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.favouriteFilters.edges.node"
                                            }
                                        ]
                                    },
                                    v3 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.favouriteFilters"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "recentFilters",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "currentURL",
                                        "variableName": "currentURL"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "FILTER"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v4 /*: any*/ ,
                                                            "type": "JiraCustomFilter"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.recentFilters.edges.node"
                                            }
                                        ]
                                    },
                                    v3 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.recentFilters"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    v0 /*: any*/ 
                                ],
                                "concreteType": "JiraSystemFilterConnection",
                                "kind": "LinkedField",
                                "name": "systemFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSystemFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": v4 /*: any*/ 
                                                },
                                                "action": "THROW",
                                                "path": "jira.systemFilters.edges.node"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.systemFilters"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$a1d57770e701dfe1$var$node.hash = "3f2ab01091a0154bb13d2ed1b15e13ef";
var $a1d57770e701dfe1$export$2e2bcd8739ae039 = $a1d57770e701dfe1$var$node;

});
parcelRegister("6z0UB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d11286d5269ae73a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e4100b4266ad9f2bb1c31ed34ee8522f>>
 * @relayHash 99bea4c9d007a836d2f2aee3f9d2e63e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7050d00d8eefcfbd4847d47076260938acf8d0a28ab345db32aaed09d76e8fc5
const $d11286d5269ae73a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v8 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v6 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v11 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4FiltersContentQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "Nav4FiltersContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4FiltersContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouriteFilters",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "FILTER"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentFilters",
                            "args": [
                                v2 /*: any*/ ,
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "FILTER"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v2 /*: any*/ 
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7050d00d8eefcfbd4847d47076260938acf8d0a28ab345db32aaed09d76e8fc5",
            "metadata": {},
            "name": "Nav4FiltersContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d11286d5269ae73a$var$node.hash = "3f2ab01091a0154bb13d2ed1b15e13ef";
var $d11286d5269ae73a$export$2e2bcd8739ae039 = $d11286d5269ae73a$var$node;

});


parcelRegister("6rSB4", function(module, exports) {

$parcel$export(module.exports, "useDeleteChangeActions", () => $0a3ddf754bc07ef4$export$ebbca0408972222d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $0a3ddf754bc07ef4$var$initialState = {
    callbacks: []
};
const $0a3ddf754bc07ef4$export$e324594224ef24da = {
    subscribe: (callback)=>({ getState: getState, setState: setState })=>{
            if (!getState().callbacks.includes(callback)) setState({
                callbacks: [
                    ...getState().callbacks,
                    callback
                ]
            });
        },
    unsubscribe: (callback)=>({ getState: getState, setState: setState })=>{
            if (getState().callbacks.includes(callback)) setState({
                callbacks: getState().callbacks.filter((item)=>item !== callback)
            });
        },
    publish: ()=>({ getState: getState })=>{
            getState().callbacks.forEach((callback)=>callback({
                    onComplete: ()=>undefined
                }));
        }
};
const $0a3ddf754bc07ef4$var$Store = (0, $GtRbT.createStore)({
    initialState: $0a3ddf754bc07ef4$var$initialState,
    actions: $0a3ddf754bc07ef4$export$e324594224ef24da
});
const $0a3ddf754bc07ef4$export$440b46140bc86b64 = (0, $iJq0l.createStateHook)($0a3ddf754bc07ef4$var$Store);
const $0a3ddf754bc07ef4$export$ebbca0408972222d = (0, $iJq0l.createActionsHook)($0a3ddf754bc07ef4$var$Store);

});

parcelRegister("hc6Nm", function(module, exports) {

$parcel$export(module.exports, "useRefetchWhenIsSelected", () => $479f4d04b1a0398e$export$ed209ae428704c56);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $49s4h = parcelRequire("49s4h");
function $479f4d04b1a0398e$export$ed209ae428704c56(params) {
    const { cloudId: cloudId, isSelectedPath: isSelectedPath, menuId: menuId, refetch: refetch, queryVariables: queryVariables, QUERY: QUERY } = params;
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const currentURL = (0, $49s4h.useGetCurrentUrl)();
    const currentURLPath = (0, $49s4h.useGetCurrentUrlPath)();
    (0, $eJOHy.useEffect)(()=>{
        if (isSelectedPath(menuId)) (0, $j4oe4.fetchQuery)(environment, QUERY, {
            cloudId: cloudId,
            currentURL: currentURL,
            currentURLPath: currentURLPath,
            ...queryVariables
        }).subscribe({
            complete: ()=>{
                refetch({
                    cloudId: cloudId,
                    currentURL: currentURL,
                    ...queryVariables
                }, {
                    fetchPolicy: 'store-only'
                });
            }
        });
    }, [
        cloudId,
        isSelectedPath,
        menuId,
        refetch,
        currentURL,
        currentURLPath,
        environment,
        queryVariables,
        QUERY
    ]);
}

});
parcelRegister("49s4h", function(module, exports) {

$parcel$export(module.exports, "useGetCurrentUrl", () => $e46a1c7752182346$export$d758ec3f153761c1);
$parcel$export(module.exports, "useGetCurrentUrlPath", () => $e46a1c7752182346$export$f61d14d754da11cc);

var $kfvK2 = parcelRequire("kfvK2");

var $7jTnu = parcelRequire("7jTnu");

var $eSnSE = parcelRequire("eSnSE");

var $lODoh = parcelRequire("lODoh");

var $eYtNM = parcelRequire("eYtNM");
function $e46a1c7752182346$export$d758ec3f153761c1() {
    const match = (0, $lODoh.useMatch)();
    const query = (0, $eYtNM.useQuery)();
    const searchParams = new URLSearchParams(query ?? {});
    const url = new URL(`http://example.com${match.url}/?${searchParams.toString()}`);
    return url.toString();
}
const $e46a1c7752182346$export$f61d14d754da11cc = (0, $kfvK2.createRouterSelector)((routerContext)=>{
    if ((0, $7jTnu.fg)('chronos-extra-logging-for-url-path')) try {
        const url = new URL(`http://example.com${routerContext.match.url}`);
        return url.toString();
    } catch (error) {
        (0, $eSnSE.default).unsafeErrorWithCustomerData('navigation-apps.sidebar-nav4.use-get-current-url', 'Failed to construct URL', {
            urlPath: routerContext.match.url
        });
        throw error;
    }
    const url = new URL(`http://example.com${routerContext.match.url}`);
    return url.toString();
});

});
parcelRegister("lODoh", function(module, exports) {

$parcel$export(module.exports, "useMatch", () => $373c1c8ef52d25bc$export$6c330e8992e8a295);

var $kfvK2 = parcelRequire("kfvK2");
const $373c1c8ef52d25bc$export$6c330e8992e8a295 = (0, $kfvK2.createRouterSelector)((state)=>state.match);

});



parcelRegister("h3HFC", function(module, exports) {

$parcel$export(module.exports, "useSubscribeAndUpdateFavorites", () => $abef8e2423cc41df$export$1032774f8dab9cec);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $8Umc4 = parcelRequire("8Umc4");

var $7jTnu = parcelRequire("7jTnu");
const $abef8e2423cc41df$export$923c488bb9fac2df = (favouriteConnectionId, recentConnectionId)=>(0, $eJOHy.useCallback)(({ store: store, dataId: dataId, isFavourite: isFavourite })=>{
        const node = store.get(dataId);
        const favorites = store.get(favouriteConnectionId);
        // Exit if we can't find the relevant data to optimistically update
        if (!node || !favorites) return false;
        if (isFavourite) {
            const recentEdges = store.get(recentConnectionId)?.getLinkedRecords('edges') ?? [];
            const existingEdge = recentEdges.find((edge)=>edge.getLinkedRecord('node')?.getDataID() === dataId);
            // Only optimistically insert a new favorite edge if it exists in the recent connection so we know it
            // has required fragment data.
            if (!existingEdge) return false;
            const edge = (0, $37Ewn.ConnectionHandler).createEdge(store, favorites, node, 'JiraFavouriteEdge');
            (0, $37Ewn.ConnectionHandler).insertEdgeBefore(favorites, edge);
        } else (0, $37Ewn.ConnectionHandler).deleteNode(favorites, dataId);
        return true;
    }, [
        favouriteConnectionId,
        recentConnectionId
    ]);
const $abef8e2423cc41df$export$1032774f8dab9cec = ({ entityTypename: entityTypename, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId, refetch: refetch })=>{
    const updateFavoriteConnection = $abef8e2423cc41df$export$923c488bb9fac2df(favouriteConnectionId, recentConnectionId);
    const pendingRefetch = (0, $eJOHy.useRef)(false); // Track in-flight refetch requests
    const trailingRefetch = (0, $eJOHy.useRef)(false); // Track queued refetch requests
    const onRefetch = (0, $eJOHy.useCallback)(()=>{
        // If there is already an in-flight refetch then wait until the request is complete before fetching again
        // Relay will dedupe refetch calls with matching variables. Therefore, we need to wait until any pending request
        // has finished before executing the latest refetch
        if (pendingRefetch.current) {
            trailingRefetch.current = true;
            return;
        }
        pendingRefetch.current = true;
        trailingRefetch.current = false;
        refetch({
            onComplete: ()=>{
                pendingRefetch.current = false;
                // Recursively refetch if it has been queued while a request was in-flight.
                if (trailingRefetch.current) // Wait for Relay to delete the cached request before refetching
                setTimeout(onRefetch, 0);
            }
        });
    }, [
        refetch
    ]);
    const subscriber = (0, $eJOHy.useCallback)((payload)=>{
        if (payload.type === 'MUTATION') {
            // If we successfully updated the connection or it's an optimistic update, exit without further action
            const success = updateFavoriteConnection(payload);
            if (payload.isOptimistic) return;
            if (success) {
                // If un-starring and not optimistic, trigger a refetch to update sidebar content
                if (!payload.isFavourite && (0, $7jTnu.fg)('blu-7738_refetch_after_unstarring_nav4')) onRefetch();
                return;
            }
        }
        // If we can't update the record directly in the Relay store then perform a refetch
        onRefetch();
    }, [
        onRefetch,
        updateFavoriteConnection
    ]);
    (0, $8Umc4.useSubscribeToFavorite)(entityTypename, subscriber);
};

});
parcelRegister("8Umc4", function(module, exports) {

$parcel$export(module.exports, "publishFavorite", () => $f8b4daedecded9d4$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $f8b4daedecded9d4$export$eb04bf805f6b8fb2);

var $eJOHy = parcelRequire("eJOHy");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $f8b4daedecded9d4$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
// Singleton to emit and listen to events
const $f8b4daedecded9d4$var$favoritePubSub = new $f8b4daedecded9d4$var$FavoritePubSub();
const $f8b4daedecded9d4$export$229a24253fb568e1 = $f8b4daedecded9d4$var$favoritePubSub.publish;
const $f8b4daedecded9d4$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $eJOHy.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$f8b4daedecded9d4$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});


parcelRegister("3uQAw", function(module, exports) {

$parcel$export(module.exports, "useStableItems", () => $1956bcd4a532a153$export$cb9e0e36b6d0277e);

var $eJOHy = parcelRequire("eJOHy");
const $1956bcd4a532a153$export$cb9e0e36b6d0277e = ()=>{
    const stableIdMapRef = (0, $eJOHy.useRef)(new Map());
    const getStableItems = (0, $eJOHy.useCallback)(({ nodes: nodes, idKey: idKey })=>{
        const getStringId = (node)=>`${node[idKey]}`;
        const intersectedNodes = nodes.filter((node)=>stableIdMapRef.current.has(getStringId(node))).sort((nodeA, nodeB)=>{
            const indexA = stableIdMapRef.current.get(getStringId(nodeA)) ?? 0;
            const indexB = stableIdMapRef.current.get(getStringId(nodeB)) ?? 0;
            return indexA - indexB;
        });
        const hasIntersectedNodes = Boolean(intersectedNodes.length);
        const stableOrderedNodes = hasIntersectedNodes ? nodes.reduceRight((acc, node, index, array)=>{
            if (!stableIdMapRef.current.has(getStringId(node))) {
                const addToStart = index + 1 !== array.length;
                addToStart ? acc.unshift(node) : acc.push(node);
            }
            return acc;
        }, intersectedNodes) : nodes;
        stableIdMapRef.current = new Map(stableOrderedNodes.map((node, index)=>[
                getStringId(node),
                index
            ]));
        return stableOrderedNodes;
    }, []);
    return {
        getStableItems: getStableItems
    };
};

});

parcelRegister("f7RmV", function(module, exports) {

$parcel$export(module.exports, "Nav4FilterMenuItem", () => $30ce7f9cc176a122$export$6c93ee534b1d4d10);

var $eW3g1 = parcelRequire("eW3g1");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cECwI = parcelRequire("cECwI");

var $6f5GW = parcelRequire("6f5GW");

var $2wv1t = parcelRequire("2wv1t");
function $30ce7f9cc176a122$export$6c93ee534b1d4d10({ queryRef: queryRef, onRefetch: onRefetch, onClick: onClick }) {
    const data = (0, $j4oe4.useFragment)((0, $eW3g1.default), queryRef);
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wv1t.SimpleFilterMenuItem), {
        actionsOnHover: !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6f5GW.Nav4FilterActions), {
            queryRef: data,
            onRefetch: onRefetch
        }),
        filterId: data.filterId,
        name: data.name,
        onClick: onClick
    });
}

});
parcelRegister("eW3g1", function(module, exports) {

$parcel$export(module.exports, "default", () => $83612eb7635e2960$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6139076109a0e91490e1fa3e8272c1fa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $83612eb7635e2960$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FilterMenuItem",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4FilterActions"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$83612eb7635e2960$var$node.hash = "db4e5c3fb6fe1fa05a10eea572e428b4";
var $83612eb7635e2960$export$2e2bcd8739ae039 = $83612eb7635e2960$var$node;

});

parcelRegister("6f5GW", function(module, exports) {

$parcel$export(module.exports, "Nav4FilterActions", () => $917ca28248f66d7e$export$7077dee41f8ad33d);

var $ovBfn = parcelRequire("ovBfn");

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $j4oe4 = parcelRequire("j4oe4");

var $jNgT9 = parcelRequire("jNgT9");

var $iv2Ch = parcelRequire("iv2Ch");

var $6r8zo = parcelRequire("6r8zo");

var $leOqD = parcelRequire("leOqD");

var $3LBL1 = parcelRequire("3LBL1");

var $1AUsu = parcelRequire("1AUsu");
var $apGPk = parcelRequire("apGPk");
var $7R1al = parcelRequire("7R1al");

var $h8epd = parcelRequire("h8epd");

var $fdFXd = parcelRequire("fdFXd");

var $lRq8t = parcelRequire("lRq8t");



var $6Hwhu = parcelRequire("6Hwhu");

var $8z6Yy = parcelRequire("8z6Yy");

var $kIz4h = parcelRequire("kIz4h");

var $7aUkH = parcelRequire("7aUkH");

var $j0saC = parcelRequire("j0saC");

var $8q7lT = parcelRequire("8q7lT");

var $gZTP9 = parcelRequire("gZTP9");

var $83DiZ = parcelRequire("83DiZ");

var $7jTnu = parcelRequire("7jTnu");

var $kEUB1 = parcelRequire("kEUB1");

var $4ihOZ = parcelRequire("4ihOZ");

var $8oKDI = parcelRequire("8oKDI");

var $f7Yza = parcelRequire("f7Yza");

var $KwCgo = parcelRequire("KwCgo");

var $dMOn8 = parcelRequire("dMOn8");

var $1TzuH = parcelRequire("1TzuH");

var $8e5rx = parcelRequire("8e5rx");

var $au0VK = parcelRequire("au0VK");

var $dv92c = parcelRequire("dv92c");

var $6hubO = parcelRequire("6hubO");
const $917ca28248f66d7e$export$7077dee41f8ad33d = ({ queryRef: queryRef, onRefetch: onRefetch })=>{
    const { __typename: __typename, isEditable: isEditable, isFavourite: isFavourite, name: name, owner: owner, id: id, filterId: filterId, jql: jql } = (0, $j4oe4.useFragment)((0, $ovBfn.default), queryRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const accountId = (0, $8q7lT.useAccountId)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const sendFilterAnalytics = (0, $1TzuH.useFilterActionsAnalytics)();
    const { isOpen: isCopyFilterModalOpen, onOpen: openCopyFilterModal, onClose: closeCopyFilterModal } = (0, $6hubO.useModalState)(false);
    const { isOpen: isEditFilterModalOpen, onOpen: openEditFilterModal, onClose: closeEditFilterModal } = (0, $6hubO.useModalState)(false);
    const { isOpen: isChangeOwnerModalOpen, onOpen: openChangeOwnerModal, onClose: closeChangeOwnerModal } = (0, $6hubO.useModalState)(false);
    const { isOpen: isDeleteFilterModalOpen, onOpen: openDeleteFilterModal, onClose: closeDeleteFilterModal } = (0, $6hubO.useModalState)(false);
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const onFilterSave = (0, $eJOHy.useCallback)((copiedFilterId)=>{
        push(`/issues/?filter=${copiedFilterId}`);
    }, [
        push
    ]);
    const isCustom = __typename === 'JiraCustomFilter';
    const isOwner = owner?.accountId && owner.accountId === accountId;
    const sendFilterActionAnalytics = (0, $eJOHy.useCallback)((itemId)=>{
        sendFilterAnalytics((0, $bfc89d778f76f56d$export$64fed82162bd367), (0, $1TzuH.getFilterActionAttributes)({
            itemId: itemId,
            isCustom: isCustom,
            isFavourite: isFavourite,
            filterId: filterId
        }));
    }, [
        filterId,
        isCustom,
        isFavourite,
        sendFilterAnalytics
    ]);
    let modalProps;
    let saveFilterEntryPointProps;
    let updateFilterEntryPointProps;
    let entryPointParams;
    if ((0, $7jTnu.fg)('nin-save-filter-dialog-entry-point')) {
        modalProps = {
            width: 'medium',
            shouldScrollInViewport: true
        };
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        saveFilterEntryPointProps = (0, $eJOHy.useMemo)(()=>({
                jql: jql,
                filterId: filterId,
                onFilterSave: onFilterSave,
                title: formatMessage((0, $dv92c.default).copyFilterDialogTitle)
            }), [
            jql,
            filterId,
            onFilterSave,
            formatMessage
        ]);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        updateFilterEntryPointProps = (0, $eJOHy.useMemo)(()=>({
                filterId: filterId ?? ''
            }), [
            filterId
        ]);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const cloudId = (0, $kEUB1.useCloudId)();
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const activationId = (0, $4ihOZ.useActivationId)();
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        entryPointParams = (0, $eJOHy.useMemo)(()=>({
                filterAri: filterId !== null && filterId !== undefined ? (0, $8oKDI.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }) : undefined
            }), [
            filterId,
            cloudId,
            activationId
        ]);
    }
    const MenuItems = (0, $eJOHy.useCallback)(({ onClose: onClose })=>{
        const getManageSubscriptionsUrl = (actionType)=>{
            const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
                atl_token: (0, $kIz4h.default)(),
                returnUrl: 'ManageFilters.jspa',
                filterId: filterId
            });
            return `/${actionType}!default.jspa?${parsed}`;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
            isList: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Hwhu.FavoriteToggleButton), {
            entityId: id,
            defaultIsStarred: Boolean(isFavourite),
            entityTypeName: (0, $fdFXd.isFavoritableItemTypename)(__typename) ? __typename : 'JiraCustomFilter',
            onClick: ()=>sendFilterActionAnalytics(isFavourite ? (0, $bc40578f06d7846b$export$7ae7abcf2c19d3e5) : (0, $bc40578f06d7846b$export$78fd0bd637fe1684)),
            name: name
        }), isCustom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apGPk.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($leOqD))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            href: getManageSubscriptionsUrl('ViewSubscriptions'),
            "aria-label": formatMessage((0, $dv92c.default).manageSubscriptionWithName, {
                name: name
            }),
            onClick: ()=>sendFilterActionAnalytics('manageSubscription')
        }, formatMessage((0, $dv92c.default).manageSubscription)), (0, $7jTnu.fg)('nin-save-filter-dialog-entry-point') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
            modalProps: modalProps,
            entryPoint: (0, $KwCgo.saveFilterDialogEntryPoint),
            entryPointProps: saveFilterEntryPointProps,
            entryPointParams: entryPointParams,
            interactionName: "jiraSaveFilterDialog.SaveFilter",
            useInternalModal: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
                onClick: (e)=>{
                    sendFilterActionAnalytics('copyFilter');
                    onClose && onClose(e);
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jNgT9))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                "aria-label": formatMessage((0, $dv92c.default).copyFilterWithName, {
                    name: name
                }),
                ref: ref
            }, formatMessage((0, $dv92c.default).copyFilter))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
            onClick: (e)=>{
                openCopyFilterModal();
                sendFilterActionAnalytics('copyFilter');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jNgT9))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            "aria-label": formatMessage((0, $dv92c.default).copyFilterWithName, {
                name: name
            })
        }, formatMessage((0, $dv92c.default).copyFilter)), isCustom && (isOwner || isEditable) && ((0, $7jTnu.fg)('nin-save-filter-dialog-entry-point') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
            modalProps: modalProps,
            entryPoint: (0, $dMOn8.updateFilterDialogEntryPoint),
            entryPointProps: updateFilterEntryPointProps,
            entryPointParams: entryPointParams,
            interactionName: "jiraSaveFilterDialog.UpdateFilterDetails",
            useInternalModal: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
                onClick: (e)=>{
                    sendFilterActionAnalytics('editFilter');
                    onClose && onClose(e);
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6r8zo))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                "aria-label": formatMessage((0, $dv92c.default).editWithName, {
                    name: name
                }),
                ref: ref
            }, formatMessage((0, $dv92c.default).edit))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6r8zo))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            onClick: (e)=>{
                openEditFilterModal();
                sendFilterActionAnalytics('editFilter');
                onClose && onClose(e);
            },
            "aria-label": formatMessage((0, $dv92c.default).editWithName, {
                name: name
            })
        }, formatMessage((0, $dv92c.default).edit))), isCustom && (isOwner || isAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
            onClick: (e)=>{
                openChangeOwnerModal();
                sendFilterActionAnalytics('changeOwner');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3LBL1))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            "aria-label": formatMessage((0, $dv92c.default).changeOwnerWithName, {
                name: name
            })
        }, formatMessage((0, $dv92c.default).changeOwner))), isCustom && (isOwner || isAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
            onClick: (e)=>{
                openDeleteFilterModal();
                sendFilterActionAnalytics('deleteFilter');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iv2Ch))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            }),
            "aria-label": formatMessage((0, $dv92c.default).deleteWithName, {
                name: name
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
            color: "color.text.danger"
        }, formatMessage((0, $dv92c.default).delete)))));
    }, [
        id,
        isFavourite,
        __typename,
        name,
        isCustom,
        formatMessage,
        isOwner,
        isEditable,
        isAdmin,
        filterId,
        sendFilterActionAnalytics,
        openCopyFilterModal,
        openEditFilterModal,
        openChangeOwnerModal,
        openDeleteFilterModal,
        modalProps,
        saveFilterEntryPointProps,
        updateFilterEntryPointProps,
        entryPointParams
    ]);
    const sendMeatballAnalytics = (0, $eJOHy.useCallback)(()=>{
        sendFilterAnalytics((0, $bfc89d778f76f56d$export$b887e88d8d0739f6), (0, $1TzuH.getFilterMeatBallAttributes)({
            isCustom: isCustom,
            isFavourite: isFavourite,
            filterId: filterId
        }));
    }, [
        filterId,
        isCustom,
        isFavourite,
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: sendMeatballAnalytics,
        MenuItems: MenuItems,
        name: name
    }), !(0, $7jTnu.fg)('nin-save-filter-dialog-entry-point') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7aUkH.AsyncSaveFilterDialogContent), {
        isOpen: isCopyFilterModalOpen,
        filterId: filterId,
        jql: jql,
        title: formatMessage((0, $dv92c.default).copyFilterDialogTitle),
        onClose: closeCopyFilterModal,
        onFilterSave: onFilterSave
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j0saC.AsyncUpdateFilterDialog), {
        isOpen: isEditFilterModalOpen,
        filterId: filterId ?? '',
        onClose: closeEditFilterModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8e5rx.ChangeOwnerModal), {
        isOpen: isChangeOwnerModalOpen,
        filterId: filterId,
        onRefetch: onRefetch,
        onClose: closeChangeOwnerModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $au0VK.DeleteFilterModal), {
        isOpen: isDeleteFilterModalOpen,
        name: name,
        filterId: filterId,
        onRefetch: onRefetch,
        onClose: closeDeleteFilterModal
    }));
};

});
parcelRegister("ovBfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $01792db0f3e3a1c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b02630a993ab57f513c5d9a5a5ea9816>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $01792db0f3e3a1c3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FilterActions",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        }
                    ]
                }
            ],
            "type": "JiraCustomFilter"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$01792db0f3e3a1c3$var$node.hash = "ceac0ec9e5b4a025e25fe096d35c5d3b";
var $01792db0f3e3a1c3$export$2e2bcd8739ae039 = $01792db0f3e3a1c3$var$node;

});

parcelRegister("iv2Ch", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32784ef133e6e682f32ae3035edbf69e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d77d26d5b9382892$var$_react = $d77d26d5b9382892$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d77d26d5b9382892$var$_baseNew = $d77d26d5b9382892$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $d77d26d5b9382892$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d77d26d5b9382892$var$DeleteIcon = (props)=>/*#__PURE__*/ $d77d26d5b9382892$var$_react.default.createElement($d77d26d5b9382892$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$d77d26d5b9382892$var$DeleteIcon.displayName = 'DeleteIcon';
var $d77d26d5b9382892$var$_default = module.exports.default = $d77d26d5b9382892$var$DeleteIcon;

});

parcelRegister("leOqD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19440c8dd0e3db5766add744ad314d45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f76205dd0b8fad5e$var$_react = $f76205dd0b8fad5e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f76205dd0b8fad5e$var$_baseNew = $f76205dd0b8fad5e$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $f76205dd0b8fad5e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f76205dd0b8fad5e$var$EmailIcon = (props)=>/*#__PURE__*/ $f76205dd0b8fad5e$var$_react.default.createElement($f76205dd0b8fad5e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$f76205dd0b8fad5e$var$EmailIcon.displayName = 'EmailIcon';
var $f76205dd0b8fad5e$var$_default = module.exports.default = $f76205dd0b8fad5e$var$EmailIcon;

});

parcelRegister("fdFXd", function(module, exports) {

$parcel$export(module.exports, "isFavoritableItemTypename", () => $4758998caa92e434$export$2bcd2af12bfc25b5);

var $aMJA4 = parcelRequire("aMJA4");
const $4758998caa92e434$export$2bcd2af12bfc25b5 = (typename)=>(0, $aMJA4.VALID_ITEM_TYPENAMES).some((itemTypename)=>itemTypename === typename);

});
parcelRegister("aMJA4", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $f0683f65a0acafa7$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $f0683f65a0acafa7$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $f0683f65a0acafa7$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $f0683f65a0acafa7$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $f0683f65a0acafa7$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $f0683f65a0acafa7$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $f0683f65a0acafa7$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $f0683f65a0acafa7$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $f0683f65a0acafa7$export$2d63a9c2e78633c8);
const $f0683f65a0acafa7$export$aade82542e73ffc8 = 'boards';
const $f0683f65a0acafa7$export$a448ebfa10cebc74 = 'filters';
const $f0683f65a0acafa7$export$f8099f229527572c = 'dashboards';
const $f0683f65a0acafa7$export$8e58083dcbb878d = 'issues';
const $f0683f65a0acafa7$export$2fd44a6cb58b66cb = 'plans';
const $f0683f65a0acafa7$export$8e2cd98172988d7e = 'projects';
const $f0683f65a0acafa7$export$6b0c8e47d2c7f1d9 = 'queues';
const $f0683f65a0acafa7$export$9c8cfad65800ddfb = [
    $f0683f65a0acafa7$export$aade82542e73ffc8,
    $f0683f65a0acafa7$export$f8099f229527572c,
    $f0683f65a0acafa7$export$a448ebfa10cebc74,
    $f0683f65a0acafa7$export$8e58083dcbb878d,
    $f0683f65a0acafa7$export$2fd44a6cb58b66cb,
    $f0683f65a0acafa7$export$8e2cd98172988d7e,
    $f0683f65a0acafa7$export$6b0c8e47d2c7f1d9
];
const $f0683f65a0acafa7$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue'
];

});


parcelRegister("6Hwhu", function(module, exports) {

$parcel$export(module.exports, "FavoriteToggleButton", () => $a01ae8b753a38de5$export$b01f3062fe4ad89b);

var $eJOHy = parcelRequire("eJOHy");

var $jw5Dj = parcelRequire("jw5Dj");

var $1jsTl = parcelRequire("1jsTl");

var $1AUsu = parcelRequire("1AUsu");

var $h8epd = parcelRequire("h8epd");

var $beI5n = parcelRequire("beI5n");

var $lRq8t = parcelRequire("lRq8t");

var $6naEG = parcelRequire("6naEG");

var $3LdGv = parcelRequire("3LdGv");
const $a01ae8b753a38de5$var$UnstarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jsTl))), {
    label: "",
    color: "currentColor",
    spacing: "spacious"
});
const $a01ae8b753a38de5$var$StarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jw5Dj))), {
    label: "",
    color: "var(--ds-icon-accent-yellow, #B38600)",
    spacing: "spacious"
});
const $a01ae8b753a38de5$export$b01f3062fe4ad89b = ({ entityId: entityId, entityTypeName: entityTypeName, defaultIsStarred: defaultIsStarred = false, name: name, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isStarred, setIsStarred] = (0, $eJOHy.useState)(defaultIsStarred);
    const { changeFavoriteMutation: changeFavoriteMutation } = (0, $beI5n.useChangeFavorite)();
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        setIsStarred((prevIsStarred)=>!prevIsStarred);
        onClick?.();
    }, [
        onClick
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isStarred !== defaultIsStarred) changeFavoriteMutation({
            id: entityId,
            typename: entityTypeName,
            value: isStarred
        });
    }, [
        entityId,
        entityTypeName,
        isStarred,
        defaultIsStarred,
        changeFavoriteMutation
    ]);
    const handleOnClickWithStopPropagation = (0, $6naEG.useStopPropagation)(handleOnClick);
    return isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
        iconBefore: $a01ae8b753a38de5$var$StarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage((0, $3LdGv.default).removeFromStarredWithName, {
            name: name
        }) : formatMessage((0, $3LdGv.default).removeFromStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
        color: "color.text"
    }, formatMessage((0, $3LdGv.default).removeFromStarred))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
        iconBefore: $a01ae8b753a38de5$var$UnstarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage((0, $3LdGv.default).addToStarredWithName, {
            name: name
        }) : formatMessage((0, $3LdGv.default).addToStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
        color: "color.text"
    }, formatMessage((0, $3LdGv.default).addToStarred)));
};

});
parcelRegister("jw5Dj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e355601c327fe778$var$_react = $e355601c327fe778$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e355601c327fe778$var$_baseNew = $e355601c327fe778$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $e355601c327fe778$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e355601c327fe778$var$StarStarredIcon = (props)=>/*#__PURE__*/ $e355601c327fe778$var$_react.default.createElement($e355601c327fe778$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$e355601c327fe778$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $e355601c327fe778$var$_default = module.exports.default = $e355601c327fe778$var$StarStarredIcon;

});

parcelRegister("beI5n", function(module, exports) {

$parcel$export(module.exports, "FavoriteChangeContext", () => $37b7ccfff905baa2$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $37b7ccfff905baa2$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $37b7ccfff905baa2$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $37b7ccfff905baa2$export$cfa169f3278459e8);

var $lJqEJ = parcelRequire("lJqEJ");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $gYnSx = parcelRequire("gYnSx");

var $8oKDI = parcelRequire("8oKDI");

var $gCeeo = parcelRequire("gCeeo");

var $kEUB1 = parcelRequire("kEUB1");

var $f4KdE = parcelRequire("f4KdE");

var $5QYf0 = parcelRequire("5QYf0");

var $8Umc4 = parcelRequire("8Umc4");

var $aMJA4 = parcelRequire("aMJA4");

var $ayzwX = parcelRequire("ayzwX");

var $By8f4 = parcelRequire("By8f4");
const $37b7ccfff905baa2$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $37b7ccfff905baa2$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $37b7ccfff905baa2$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $37b7ccfff905baa2$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $eJOHy.createContext)($37b7ccfff905baa2$export$b212ddc707077772);
// supports project types only for now
const $37b7ccfff905baa2$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const commitUpdate = (0, $eJOHy.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $aMJA4.PROJECTS_ITEM_TYPE)) (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $f4KdE.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $37b7ccfff905baa2$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $37b7ccfff905baa2$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $eJOHy.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const onChangeStart = (0, $eJOHy.useCallback)((item)=>{
        setItems($37b7ccfff905baa2$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $eJOHy.useCallback)((item, analyticsEvent)=>{
        setItems($37b7ccfff905baa2$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $eJOHy.useCallback)((item, analyticsId, error)=>{
        setItems($37b7ccfff905baa2$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $By8f4.errorFlag)());
        (0, $gYnSx.default)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $eJOHy.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $ayzwX.default)(item);
                const typename = (0, $5QYf0.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $8Umc4.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $lJqEJ.default));
    const changeFavoriteMutation = (0, $eJOHy.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $f4KdE.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $5QYf0.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $8Umc4.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    entityId: payload.id,
                    isFavourite: payload.value,
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $eJOHy.useCallback)((item)=>{
        setItems($37b7ccfff905baa2$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $eJOHy.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $5QYf0.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $8Umc4.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $f4KdE.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $5QYf0.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $8Umc4.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $eJOHy.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b7ccfff905baa2$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
const $37b7ccfff905baa2$export$f227cdfbb355444a = $37b7ccfff905baa2$export$a5d258b9665ce94b.Consumer;
const $37b7ccfff905baa2$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b7ccfff905baa2$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $37b7ccfff905baa2$export$cfa169f3278459e8 = ()=>(0, $eJOHy.useContext)($37b7ccfff905baa2$export$a5d258b9665ce94b);

});
parcelRegister("lJqEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f558064ead53275$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<581ee8573bf9ee1f32ccc64539d4c7bc>>
 * @relayHash 6de546c6546651e6c4572b78dca9bcd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f
const $6f558064ead53275$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
            "metadata": {},
            "name": "viewSetFavouriteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$6f558064ead53275$var$node.hash = "af74e48c451986374e11a5b801d5009f";
var $6f558064ead53275$export$2e2bcd8739ae039 = $6f558064ead53275$var$node;

});

parcelRegister("8oKDI", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $250d353c2bab97a6$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $250d353c2bab97a6$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $250d353c2bab97a6$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $250d353c2bab97a6$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $250d353c2bab97a6$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $250d353c2bab97a6$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $250d353c2bab97a6$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $250d353c2bab97a6$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $250d353c2bab97a6$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $250d353c2bab97a6$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $250d353c2bab97a6$export$8e68286aef4c3a8b = (ari)=>$250d353c2bab97a6$var$ARI_REG_EXP.test(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_WORKSPACE.test(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_ACTIVATION.test(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $250d353c2bab97a6$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $250d353c2bab97a6$export$24b47820a324e614 = (ari)=>{
    if ($250d353c2bab97a6$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $250d353c2bab97a6$export$e2789192113e8b07 = (ari, defaultValue = '')=>$250d353c2bab97a6$export$24b47820a324e614(ari) ?? defaultValue;
const $250d353c2bab97a6$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($250d353c2bab97a6$export$8e68286aef4c3a8b(ari)) {
        const parts = $250d353c2bab97a6$var$ARI_REG_EXP.exec(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $250d353c2bab97a6$export$3d8d7031a11613fd = (ari)=>{
    const config = $250d353c2bab97a6$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("5QYf0", function(module, exports) {

$parcel$export(module.exports, "favoriteTypeToTypename", () => $60086272c670daaa$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $60086272c670daaa$export$717886a1047f1287);

var $2BUDW = parcelRequire("2BUDW");

var $bu8Y7 = parcelRequire("bu8Y7");

var $27lFN = parcelRequire("27lFN");

var $4NoAT = parcelRequire("4NoAT");

var $3mjHQ = parcelRequire("3mjHQ");

var $3osLr = parcelRequire("3osLr");
function $60086272c670daaa$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $60086272c670daaa$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $60086272c670daaa$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $60086272c670daaa$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        default:
            return undefined;
    }
};
const $60086272c670daaa$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $3osLr.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $4NoAT.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $27lFN.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $3mjHQ.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $bu8Y7.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $2BUDW.JiraServicedeskQueueAri).parse(ari).queueId;
        default:
            $60086272c670daaa$var$assertUnreachable(typename);
    }
};
const $60086272c670daaa$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        default:
            $60086272c670daaa$var$assertUnreachable(typename);
    }
};
const $60086272c670daaa$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $60086272c670daaa$var$favoriteAriToId(typename, id),
        type: $60086272c670daaa$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $60086272c670daaa$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $60086272c670daaa$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});
parcelRegister("2BUDW", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAri", () => $1e6af9a211751f7e$export$555c8ae00f64ebff);

var $7OueV = parcelRequire("7OueV");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira-servicedesk/queue/manifest.ts
var $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $7OueV.JiraServicedeskQueueAriResourceOwner),
    resourceType: (0, $7OueV.JiraServicedeskQueueAriResourceType),
    resourceIdSlug: "activation/{activationId}/{queueId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        queueId: /[0-9]+/
    }
};
// src/jira-servicedesk/queue/index.ts
var $1e6af9a211751f7e$export$555c8ae00f64ebff = class _JiraServicedeskQueueAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._queueId = opts.resourceIdSegmentValues.queueId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get queueId() {
        return this._queueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts.qualifier,
            platformQualifier: $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts.resourceOwner,
            resourceType: $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.queueId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                queueId: opts.queueId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            queueId: this.queueId
        };
    }
};

});
parcelRegister("7OueV", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAriResourceOwner", () => $5b04a8e3ed2a9dde$export$704112eeb385ceab);
$parcel$export(module.exports, "JiraServicedeskQueueAriResourceType", () => $5b04a8e3ed2a9dde$export$6adb8c07b8bc2c5a);
// src/jira-servicedesk/queue/types.ts
var $5b04a8e3ed2a9dde$export$704112eeb385ceab = "jira-servicedesk", $5b04a8e3ed2a9dde$export$6adb8c07b8bc2c5a = "queue";

});


parcelRegister("bu8Y7", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAri", () => $85c9740b1cb0c1f8$export$fcd404066e55a7a8);

var $5SaHf = parcelRequire("5SaHf");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira-software/board/manifest.ts
var $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $5SaHf.JiraSoftwareBoardAriResourceOwner),
    resourceType: (0, $5SaHf.JiraSoftwareBoardAriResourceType),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira-software/board/index.ts
var $85c9740b1cb0c1f8$export$fcd404066e55a7a8 = class _JiraSoftwareBoardAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts.qualifier,
            platformQualifier: $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts.resourceOwner,
            resourceType: $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
};

});
parcelRegister("5SaHf", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAriResourceOwner", () => $011a7d14b4d4d4ec$export$d716ba4f5572ec86);
$parcel$export(module.exports, "JiraSoftwareBoardAriResourceType", () => $011a7d14b4d4d4ec$export$d4b70c04cf2221a5);
// src/jira-software/board/types.ts
var $011a7d14b4d4d4ec$export$d716ba4f5572ec86 = "jira-software", $011a7d14b4d4d4ec$export$d4b70c04cf2221a5 = "board";

});


parcelRegister("27lFN", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAri", () => $18ad0c083fb9a182$export$b7d4016f0f5da5b8);

var $lScrX = parcelRequire("lScrX");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/dashboard/manifest.ts
var $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $lScrX.JiraDashboardAriResourceOwner),
    resourceType: (0, $lScrX.JiraDashboardAriResourceType),
    resourceIdSlug: "activation/{activationId}/{dashboardId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        dashboardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/dashboard/index.ts
var $18ad0c083fb9a182$export$b7d4016f0f5da5b8 = class _JiraDashboardAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._dashboardId = opts.resourceIdSegmentValues.dashboardId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get dashboardId() {
        return this._dashboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts.qualifier,
            platformQualifier: $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts.resourceOwner,
            resourceType: $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.dashboardId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                dashboardId: opts.dashboardId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            dashboardId: this.dashboardId
        };
    }
};

});
parcelRegister("lScrX", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAriResourceOwner", () => $fec84c706c93f2bd$export$62c1deae25c41d24);
$parcel$export(module.exports, "JiraDashboardAriResourceType", () => $fec84c706c93f2bd$export$e4e3a57a5e435aff);
// src/jira/dashboard/types.ts
var $fec84c706c93f2bd$export$62c1deae25c41d24 = "jira", $fec84c706c93f2bd$export$e4e3a57a5e435aff = "dashboard";

});


parcelRegister("3mjHQ", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAri", () => $2722b66e28c1c3b7$export$6d2eb3641569f26);

var $6LPOd = parcelRequire("6LPOd");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/plan/manifest.ts
var $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6LPOd.JiraPlanAriResourceOwner),
    resourceType: (0, $6LPOd.JiraPlanAriResourceType),
    resourceIdSlug: "activation/{activationId}/{planId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        planId: /[0-9]+/
    }
};
// src/jira/plan/index.ts
var $2722b66e28c1c3b7$export$6d2eb3641569f26 = class _JiraPlanAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._planId = opts.resourceIdSegmentValues.planId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get planId() {
        return this._planId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts.qualifier,
            platformQualifier: $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts.resourceOwner,
            resourceType: $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.planId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                planId: opts.planId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            planId: this.planId
        };
    }
};

});
parcelRegister("6LPOd", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAriResourceOwner", () => $4edf520e7fc401d3$export$bfd26af3c5e1b90d);
$parcel$export(module.exports, "JiraPlanAriResourceType", () => $4edf520e7fc401d3$export$d6abe08eb30f433d);
// src/jira/plan/types.ts
var $4edf520e7fc401d3$export$bfd26af3c5e1b90d = "jira", $4edf520e7fc401d3$export$d6abe08eb30f433d = "plan";

});



parcelRegister("ayzwX", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb247c6ff9b78be8$export$2e2bcd8739ae039);

var $hz0hv = parcelRequire("hz0hv");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cb247c6ff9b78be8$export$2e2bcd8739ae039 = async (request)=>(0, $hz0hv.updateFavorite)(request);

});
parcelRegister("hz0hv", function(module, exports) {

$parcel$export(module.exports, "updateFavorite", () => $8db6e70766c67090$export$8c2f00130cc945dc);

var $jGzN3 = parcelRequire("jGzN3");
const $8db6e70766c67090$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $jGzN3.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $jGzN3.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("By8f4", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $f3b3cf3c0fd288e5$export$b9a7f1ebeaa76953);

var $bYxGO = parcelRequire("bYxGO");
const $f3b3cf3c0fd288e5$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $bYxGO.default)
    });

});
parcelRegister("bYxGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b97d317b0fde95f0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b97d317b0fde95f0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("3LdGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e474b4faf2fbb323$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e474b4faf2fbb323$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    addToStarred: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred",
        "defaultMessage": "Add to starred"
    },
    removeFromStarred: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred",
        "defaultMessage": "Remove from starred"
    },
    addToStarredWithName: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred-with-name",
        "defaultMessage": "Add \"{name}\" to starred"
    },
    removeFromStarredWithName: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred-with-name",
        "defaultMessage": "Remove \"{name}\" from starred"
    }
});

});


parcelRegister("7aUkH", function(module, exports) {

$parcel$export(module.exports, "AsyncSaveFilterDialogContent", () => $1333398ce66ec2b7$export$e0d40cb0f88fa57d);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1333398ce66ec2b7$var$SaveFilterDialogContent = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("cgbGK")).then((module)=>({
            default: module.OldSaveFilterDialogContent
        })), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/save-filter-dialog/save-filter-dialog-content/index.tsx"
});
const $1333398ce66ec2b7$export$e0d40cb0f88fa57d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-save-filters-dialog-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1333398ce66ec2b7$var$SaveFilterDialogContent, props));

});
parcelRegister("cgbGK", function(module, exports) {

let $8ed00bc22c6b6cf9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8ed00bc22c6b6cf9$var$load("1VRB2"),
    $8ed00bc22c6b6cf9$var$load("bABhq"),
    $8ed00bc22c6b6cf9$var$load("77K82")
]).then(()=>parcelRequire('1Dpmk'));

});


parcelRegister("j0saC", function(module, exports) {

$parcel$export(module.exports, "AsyncUpdateFilterDialog", () => $d7076eb3b3592d80$export$8692e2751472dade);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d7076eb3b3592d80$var$UpdateFilterDialog = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("5j4i8")).then((module)=>({
            default: module.OldUpdateFilterDialog
        })), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/update-filter-dialog/index.tsx"
});
const $d7076eb3b3592d80$export$8692e2751472dade = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-update-filter-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d7076eb3b3592d80$var$UpdateFilterDialog, props));

});
parcelRegister("5j4i8", function(module, exports) {

let $3dd20e4d67f8b83e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $3dd20e4d67f8b83e$var$load("1VRB2"),
    $3dd20e4d67f8b83e$var$load("bABhq"),
    $3dd20e4d67f8b83e$var$load("5tmvo")
]).then(()=>parcelRequire('f4oZQ'));

});


parcelRegister("4ihOZ", function(module, exports) {

$parcel$export(module.exports, "useActivationId", () => $00d1e918c26592e9$export$43686faa787c943);

var $lvKO5 = parcelRequire("lvKO5");
const $00d1e918c26592e9$export$43686faa787c943 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.activationId;
};

});

parcelRegister("f7Yza", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointPressableTrigger", () => $559e9a3ae3197c55$export$defad645fcc21c0a);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $f9Ihw = parcelRequire("f9Ihw");

var $6sWr0 = parcelRequire("6sWr0");
var $3Zn1o = parcelRequire("3Zn1o");
var $15cpG = parcelRequire("15cpG");
var $i237T = parcelRequire("i237T");

var $aRh7I = parcelRequire("aRh7I");

var $lbvZy = parcelRequire("lbvZy");

var $aC4Bh = parcelRequire("aC4Bh");

var $2ZGUP = parcelRequire("2ZGUP");

var $5GSFM = parcelRequire("5GSFM");

var $jd93d = parcelRequire("jd93d");

var $7lK6t = parcelRequire("7lK6t");

var $5HFSX = parcelRequire("5HFSX");

var $SUi50 = parcelRequire("SUi50");
const $559e9a3ae3197c55$var$emptyObject = {};
const $559e9a3ae3197c55$export$defad645fcc21c0a = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, title: title, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef })=>{
    const { openModal: openModal } = (0, $eJOHy.useContext)((0, $7lK6t.ModalContext));
    const environmentProvider = (0, $5HFSX.useJiraRelayEnvironmentProvider)();
    const metricName = (0, $eJOHy.useMemo)(()=>{
        if (interactionName) return interactionName;
        // @ts-expect-error Need to fix the types on this
        return entryPoint?.root?.getModuleName() ?? 'unknown';
    }, [
        entryPoint,
        interactionName
    ]);
    // eslint-disable-next-line jira/ufo/valid-labels
    const pressTracing = (0, $lbvZy.default)(metricName);
    const load = (0, $eJOHy.useCallback)(()=>(0, $j4oe4.loadEntryPoint)(environmentProvider, entryPoint, // @ts-expect-error TS cannot infer that emptyObject is the correct params
        // type for TEntryPoint even when performing an explicit undefined check
        entryPointParams ?? $559e9a3ae3197c55$var$emptyObject), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onBeforeLoad = (0, $eJOHy.useCallback)(()=>{
        if (interactionName) pressTracing();
    }, [
        interactionName,
        pressTracing
    ]);
    const onLoad = (0, $eJOHy.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = ()=>{
                entryPointProps?.onClose?.();
                closeModal();
                dispose();
            };
            const defaultFallbackInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $15cpG.default), null, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i237T.default), null, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
                grow: "fill"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6sWr0.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Zn1o.default), null));
            const defaultFallback = useInternalModal ? defaultFallbackInner : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
                messageId: "modal-entry-point-pressable-trigger.modal.fallback",
                messageType: "transactional",
                onClose: closeModal,
                width: modalProps?.width,
                height: modalProps?.height
            }, defaultFallbackInner);
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5GSFM.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorAttributes: errorAttributes,
                errorFallback: "flag",
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                // @ts-expect-error Some type mismatch, should fix it one day
                runtimeProps: {
                    ...entryPointProps ?? $559e9a3ae3197c55$var$emptyObject,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return useInternalModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
                ...modalProps,
                messageId: "modal-entry-point-pressable-trigger.modal",
                messageType: "transactional",
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress
            }, container)) : container;
        });
    }, [
        openModal,
        title,
        useInternalModal,
        modalProps,
        errorAttributes,
        Fallback,
        metricName,
        entryPointProps
    ]);
    const triggerRef = (0, $SUi50.usePressablePreloadRef)({
        load: load,
        onBeforeLoad: onBeforeLoad,
        onLoad: onLoad
    });
    if (forwardedRef != null) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const ref = (0, $jd93d.default)(triggerRef, forwardedRef);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return children({
            ref: ref
        });
    }
    return children({
        ref: triggerRef
    });
};

});
parcelRegister("lbvZy", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa0a5ed8272e63eb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ih0uO = parcelRequire("ih0uO");
function $aa0a5ed8272e63eb$export$2e2bcd8739ae039(name) {
    const context = (0, $eJOHy.useContext)((0, $ih0uO.default));
    const handleClick = (0, $eJOHy.useCallback)((timeStamp)=>{
        if (context) {
            const time = timeStamp || performance.now();
            context.tracePress(name, time);
        }
    }, [
        context,
        name
    ]);
    return handleClick;
}

});

parcelRegister("aC4Bh", function(module, exports) {

$parcel$export(module.exports, "JiraModal", () => $1ed06102d0e4c7bf$export$3782fcca1f68992e);

var $eJOHy = parcelRequire("eJOHy");

var $jdbsD = parcelRequire("jdbsD");

var $SyPNn = parcelRequire("SyPNn");

var $fYeTG = parcelRequire("fYeTG");

var $3tIRK = parcelRequire("3tIRK");
const $1ed06102d0e4c7bf$export$3782fcca1f68992e = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3tIRK.ChoreographerModal), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdbsD.default), rest);
};
$1ed06102d0e4c7bf$export$3782fcca1f68992e.displayName = 'JiraModal';

});
parcelRegister("3tIRK", function(module, exports) {

$parcel$export(module.exports, "ChoreographerModal", () => $448662a8fa007f74$export$3f5d627caa6fc630);
// eslint-disable-next-line @typescript-eslint/no-restricted-imports

var $jdbsD = parcelRequire("jdbsD");

var $1pkzT = parcelRequire("1pkzT");
const $448662a8fa007f74$export$3f5d627caa6fc630 = (0, $1pkzT.withChoreographedRender)((0, $jdbsD.default));

});
parcelRegister("1pkzT", function(module, exports) {

$parcel$export(module.exports, "withChoreographedRender", () => $8aa717e7fe718299$export$c1160fdac17030e);

var $eJOHy = parcelRequire("eJOHy");

var $3CprG = parcelRequire("3CprG");

var $gL5G0 = parcelRequire("gL5G0");
function $8aa717e7fe718299$export$c1160fdac17030e(Component) {
    function ChoreographedComponent(props) {
        const { messageId: messageId, onMessageDisposition: onMessageDisposition } = props;
        const shouldRender = (0, $gL5G0.useChoreographedRender)({
            messageId: messageId,
            onMessageDisposition: onMessageDisposition
        });
        if (shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3CprG.ChoreographerContextProvider), {
            isChoreographed: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props));
        return null;
    }
    ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
    function WithChoreographedRenderComponent(props) {
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $3CprG.useChoreographedStatusContext)();
        if (isAlreadyChoreographedAtAncestor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ChoreographedComponent, props);
    }
    WithChoreographedRenderComponent.displayName = `WithChoreographedRender${Component.displayName ?? 'Component'}`;
    return WithChoreographedRenderComponent;
}

});



parcelRegister("2ZGUP", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $a9b037182c8fe3f4$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $a9b037182c8fe3f4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dM9A7 = parcelRequire("dM9A7");
const $a9b037182c8fe3f4$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eJOHy.createContext)((0, $dM9A7.rootRegistry));
const $a9b037182c8fe3f4$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eJOHy.useMemo)(()=>new (0, $dM9A7.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eJOHy.useContext)($a9b037182c8fe3f4$export$ebbb59327adb551a) || (0, $dM9A7.rootRegistry);
    (0, $eJOHy.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a9b037182c8fe3f4$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $a9b037182c8fe3f4$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : $a9b037182c8fe3f4$var$ShortcutScope;

});
parcelRegister("dM9A7", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $7a2bff04dfa089d2$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $7a2bff04dfa089d2$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $5spib = parcelRequire("5spib");

var $exWdq = parcelRequire("exWdq");

var $jPROM = parcelRequire("jPROM");

var $f6sJp = parcelRequire("f6sJp");

var $aBrUN = parcelRequire("aBrUN");
const $7a2bff04dfa089d2$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $aBrUN.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $aBrUN.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $aBrUN.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $7a2bff04dfa089d2$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $7a2bff04dfa089d2$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($f6sJp)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($f6sJp)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$7a2bff04dfa089d2$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $7a2bff04dfa089d2$export$1dd4c61d1ce1fa15 = new $7a2bff04dfa089d2$export$ca1c75b575abf5ff();

});
parcelRegister("f6sJp", function(module, exports) {

var $l76qh = parcelRequire("l76qh");

var $d3H6Y = parcelRequire("d3H6Y");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $afedb3fdd807fe80$var$pull = $l76qh($d3H6Y);
module.exports = $afedb3fdd807fe80$var$pull;

});
parcelRegister("d3H6Y", function(module, exports) {

var $6zP82 = parcelRequire("6zP82");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $981cff3a37d3b5ca$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $6zP82(array, values) : array;
}
module.exports = $981cff3a37d3b5ca$var$pullAll;

});
parcelRegister("6zP82", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $kEE3x = parcelRequire("kEE3x");

var $8sQvY = parcelRequire("8sQvY");

var $cUaWv = parcelRequire("cUaWv");

var $k4ZVz = parcelRequire("k4ZVz");
/** Used for built-in method references. */ var $4c9dac120c4a59a8$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $4c9dac120c4a59a8$var$splice = $4c9dac120c4a59a8$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $4c9dac120c4a59a8$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $8sQvY : $kEE3x, index = -1, length = values.length, seen = array;
    if (array === values) values = $k4ZVz(values);
    if (iteratee) seen = $lylkU(array, $cUaWv(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $4c9dac120c4a59a8$var$splice.call(seen, fromIndex, 1);
            $4c9dac120c4a59a8$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $4c9dac120c4a59a8$var$basePullAll;

});
parcelRegister("8sQvY", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6299ac99ae510342$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $6299ac99ae510342$var$baseIndexOfWith;

});




parcelRegister("aBrUN", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $fc8b52be7fea903e$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $fc8b52be7fea903e$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $fc8b52be7fea903e$export$4add9e50cb49d130);

var $7jTnu = parcelRequire("7jTnu");
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+alt+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is now supported in modern browsers by using event.code
 * to extract the base character when alt modifies the character output.
 * On Mac, alt changes the character input (e.g. 'alt+z' displays 'Ω'),
 * but we extract the base character 'z' for consistent keyboard shortcuts.
 * For older browsers without event.code support, alt shortcuts will still
 * have the original limitation where modified characters are used.
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $fc8b52be7fea903e$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
// Base modifiers without alt (old behavior)
const $fc8b52be7fea903e$var$baseModifiersOld = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $fc8b52be7fea903e$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
// Base modifiers with alt support (new behavior)
const $fc8b52be7fea903e$var$baseModifiers = [
    {
        name: 'ctrl',
        test: (e)=>e.ctrlKey
    },
    {
        name: 'alt',
        test: (e)=>e.altKey
    },
    {
        name: 'shift',
        test: (e)=>e.shiftKey && $fc8b52be7fea903e$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $fc8b52be7fea903e$var$toKey = (e)=>{
    if ($fc8b52be7fea903e$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Handle alt-modified characters by using the base character (feature gated)
    // On Mac, alt+z produces 'ω' but we want 'z' for consistent shortcuts
    if ((0, $7jTnu.fg)('jira-full-screen')) {
        if (e.altKey && e.code && e.code.startsWith('Key')) {
            // Extract the base character from the code (e.g., 'KeyZ' -> 'z')
            const baseChar = e.code.substring(3).toLowerCase();
            return e.shiftKey ? baseChar.toUpperCase() : baseChar;
        }
    }
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $fc8b52be7fea903e$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    if ((0, $7jTnu.fg)('jira-full-screen')) return {
        sequence: $fc8b52be7fea903e$var$baseModifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($fc8b52be7fea903e$var$toKey(e)).join('+'),
        e: e
    };
    return {
        sequence: $fc8b52be7fea903e$var$baseModifiersOld.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($fc8b52be7fea903e$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $fc8b52be7fea903e$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $fc8b52be7fea903e$var$singleShortcutEntry = `(ctrl\\+)?(alt\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$fc8b52be7fea903e$var$orSpecialChars}))))?(meta\\+)?(${$fc8b52be7fea903e$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $fc8b52be7fea903e$var$shortcutRegex = RegExp(`^${$fc8b52be7fea903e$var$singleShortcutEntry}( ${$fc8b52be7fea903e$var$singleShortcutEntry})*$`);
const $fc8b52be7fea903e$export$8e231506c5580162 = (shortcut)=>$fc8b52be7fea903e$var$shortcutRegex.test(shortcut);
const $fc8b52be7fea903e$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("7lK6t", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $da1586d597fd06a3$export$ab57792b9b6974a6);

var $eJOHy = parcelRequire("eJOHy");
const $da1586d597fd06a3$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openModal: ()=>{}
});

});

parcelRegister("SUi50", function(module, exports) {

$parcel$export(module.exports, "usePressablePreloadRef", () => $91d1c65011bcb349$export$1ff47f24e06a5d2d);

var $eJOHy = parcelRequire("eJOHy");
const $91d1c65011bcb349$var$PRELOAD_MAX_AGE = 2000;
const $91d1c65011bcb349$var$TIME_TO_INTENT = 200;
function $91d1c65011bcb349$export$1ff47f24e06a5d2d({ load: load, onBeforeLoad: onBeforeLoad, onLoad: onLoad }) {
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $91d1c65011bcb349$var$PRELOAD_MAX_AGE);
            }, $91d1c65011bcb349$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    return ref;
}

});


parcelRegister("KwCgo", function(module, exports) {

$parcel$export(module.exports, "saveFilterDialogEntryPoint", () => $9103cab9c638489c$export$7485e0220e11838f);

var $16SHk = parcelRequire("16SHk");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $9103cab9c638489c$export$7485e0220e11838f = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("cgbGK")), {
        moduleId: "6b7b6fa9",
        priority: "interaction"
    }),
    getPreloadProps: ({ filterAri: filterAri })=>({
            queries: {
                filterDataQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $16SHk.default,
                    variables: {
                        filterAri: filterAri ?? '',
                        includeFilter: !!filterAri,
                        // includeJql and corresponding @include directive in SAVE_FILTER_DIALOG_BASE_QUERY should be removed when cleaning up nin-save-filter-dialog-entry-point
                        includeJql: true
                    }
                }
            }
        })
});

});
parcelRegister("16SHk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6dfdf4811cfbb5a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<859d5d47a2c5fd97dab556bccf43d2f6>>
 * @relayHash 9c75ea8fdeeedc74876715a276898be1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a9131294f7520ff6e6fa2cec7e3807675422ef52957aa4c5c395456e61f0d67b
const $e6dfdf4811cfbb5a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeJql"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v7 = {
        "kind": "RequiredField",
        "field": {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v2 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira.filter.shareGrants.edges.node.project.id"
                },
                v3 /*: any*/ ,
                v6 /*: any*/ 
            ]
        },
        "action": "THROW",
        "path": "jira.filter.shareGrants.edges.node.project"
    }, v8 = {
        "kind": "ScalarField",
        "name": "roleId"
    }, v9 = {
        "concreteType": "JiraRole",
        "kind": "LinkedField",
        "name": "role",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v3 /*: any*/ 
        ]
    }, v10 = {
        "concreteType": "JiraGroup",
        "kind": "LinkedField",
        "name": "group",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v3 /*: any*/ 
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v13 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v3 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v14 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v6 /*: any*/ 
        ]
    }, v15 = {
        "kind": "RequiredField",
        "field": v14 /*: any*/ ,
        "action": "THROW",
        "path": "jira.filter.editGrants.edges.node.project"
    }, v16 = {
        "condition": "includeJql",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jql"
            }
        ]
    }, v17 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v5 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v14 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityProjectGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v14 /*: any*/ ,
                        {
                            "concreteType": "JiraRole",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v3 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraShareableEntityProjectRoleGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v10 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityGroupGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v11 /*: any*/ ,
                                v3 /*: any*/ ,
                                v12 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraShareableEntityUserGrant"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "saveFilterDialogBaseQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraShareableEntityShareGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "shareGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityShareGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v9 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.shareGrants.edges.node.role"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectRoleGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v10 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.shareGrants.edges.node.group"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityGroupGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v13 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.shareGrants.edges.node.user"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityUserGrant"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraShareableEntityEditGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "editGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityEditGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v15 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v15 /*: any*/ ,
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v9 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.editGrants.edges.node.role"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectRoleGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v10 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.editGrants.edges.node.group"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityGroupGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v13 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.editGrants.edges.node.user"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityUserGrant"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v16 /*: any*/ 
                                            ],
                                            "type": "JiraCustomFilter"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "saveFilterDialogBaseQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraShareableEntityShareGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "shareGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityShareGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": v17 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraShareableEntityEditGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "editGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityEditGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": v17 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                v16 /*: any*/ 
                                            ],
                                            "type": "JiraCustomFilter"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a9131294f7520ff6e6fa2cec7e3807675422ef52957aa4c5c395456e61f0d67b",
            "metadata": {},
            "name": "saveFilterDialogBaseQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e6dfdf4811cfbb5a$var$node.hash = "fb88c153bbc55aa009b87c70f71b97cc";
var $e6dfdf4811cfbb5a$export$2e2bcd8739ae039 = $e6dfdf4811cfbb5a$var$node;

});


parcelRegister("dMOn8", function(module, exports) {

$parcel$export(module.exports, "updateFilterDialogEntryPoint", () => $b90eb94a1ca61cce$export$89f63332d1b5f8db);

var $16SHk = parcelRequire("16SHk");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $b90eb94a1ca61cce$export$89f63332d1b5f8db = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("5j4i8")), {
        moduleId: "a40748cc",
        priority: "interaction"
    }),
    getPreloadProps: ({ filterAri: filterAri })=>({
            queries: {
                filterDataQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $16SHk.default,
                    variables: {
                        filterAri: filterAri ?? '',
                        includeFilter: !!filterAri,
                        // includeJql and corresponding @include directive in SAVE_FILTER_DIALOG_BASE_QUERY should be removed when cleaning up nin-save-filter-dialog-entry-point
                        includeJql: true
                    }
                }
            }
        })
});

});

parcelRegister("8e5rx", function(module, exports) {

$parcel$export(module.exports, "ChangeOwnerModal", () => $2dd1356b8c93878e$export$fe3f500d38bfe0df);

var $eJOHy = parcelRequire("eJOHy");

var $9hEC7 = parcelRequire("9hEC7");
const $2dd1356b8c93878e$export$fe3f500d38bfe0df = ({ isOpen: isOpen, filterId: filterId, onRefetch: onRefetch, onClose: onClose })=>{
    const onSuccess = (0, $eJOHy.useCallback)(()=>{
        onRefetch({
            onComplete: ()=>undefined
        });
        onClose();
    }, [
        onRefetch,
        onClose
    ]);
    return isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9hEC7.default), {
        id: filterId,
        onInitiateSuccess: ()=>undefined,
        onSuccess: onSuccess,
        onCancel: onClose,
        onInitiateFailed: ()=>undefined
    });
};

});
parcelRegister("9hEC7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f27077d8818225af$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gm1B2 = parcelRequire("gm1B2");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f27077d8818225af$var$NoLazyAsyncChangeOwnerFilterModal = (0, $gzcjr.lazy)(()=>(parcelRequire("eS1kd")), {
    moduleId: "./src/packages/global-pages/directories/filters-directory-v2/change-owner-filter-modal/src/index.tsx"
});
const $f27077d8818225af$var$AsyncChangeOwnerFilterModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "configure-owner-modal",
        packageName: "filter",
        fallback: "flag",
        teamName: "endeavour"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "change-owner-filter-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gm1B2.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f27077d8818225af$var$NoLazyAsyncChangeOwnerFilterModal, props)));
var $f27077d8818225af$export$2e2bcd8739ae039 = $f27077d8818225af$var$AsyncChangeOwnerFilterModal;

});
parcelRegister("eS1kd", function(module, exports) {

let $ad3722f7abfe07a9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ad3722f7abfe07a9$var$load("3Zcaf").then(()=>parcelRequire('226GG'));

});



parcelRegister("au0VK", function(module, exports) {

$parcel$export(module.exports, "DeleteFilterModal", () => $4951716b62339191$export$7eeb027d3dbb72df);

var $eJOHy = parcelRequire("eJOHy");

var $7NseJ = parcelRequire("7NseJ");

var $bILK0 = parcelRequire("bILK0");

var $95O7y = parcelRequire("95O7y");
var $83DiZ = parcelRequire("83DiZ");

var $6Ibih = parcelRequire("6Ibih");
const $4951716b62339191$export$7eeb027d3dbb72df = ({ isOpen: isOpen, name: name, filterId: filterId, onClose: onClose, onRefetch: onRefetch })=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const [filterQueryParam] = (0, $95O7y.useQueryParam)('filter');
    const onSuccess = (0, $eJOHy.useCallback)(()=>{
        onRefetch({
            onComplete: ()=>undefined
        });
        if (filterQueryParam === filterId) push('/jira/filters');
        onClose();
        showFlag({
            id: 'filter-deleted',
            title: [
                (0, $6Ibih.default).filterDeletedModalTitleSuccessNonFinal,
                {
                    name: name
                }
            ],
            type: 'success',
            messageId: 'navigation-apps-sidebar-nav4-sidebars-content-filters.common.ui.filter-actions.delete-filter-modal.show-flag.success',
            messageType: 'transactional'
        });
    }, [
        filterId,
        filterQueryParam,
        name,
        onClose,
        onRefetch,
        push,
        showFlag
    ]);
    const onFailure = (0, $eJOHy.useCallback)(()=>{
        onClose();
        showFlag({
            id: 'filter-delete-failed',
            title: (0, $6Ibih.default).filterDeletedModalTitleErrorNonFinal,
            description: (0, $6Ibih.default).filterDeletedModalDescriptionErrorNonFinal,
            type: 'error',
            messageId: 'navigation-apps-sidebar-nav4-sidebars-content-filters.common.ui.filter-actions.delete-filter-modal.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        onClose,
        showFlag
    ]);
    const filter = {
        name: name,
        id: filterId
    };
    return isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7NseJ.default), {
        filter: filter,
        onFilterDeleted: onSuccess,
        onFilterDeleteFailed: onFailure,
        onFilterInitiateFailed: onFailure,
        onCancel: onClose
    });
};

});
parcelRegister("7NseJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9b2891cb52bc300$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $BwaQq = parcelRequire("BwaQq");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");

var $5kYyR = parcelRequire("5kYyR");


var $1sfij = parcelRequire("1sfij");

var $5w3Ve = parcelRequire("5w3Ve");

var $lDUyj = parcelRequire("lDUyj");

var $iW3eZ = parcelRequire("iW3eZ");

// eslint-disable-next-line jira/react/no-class-components
class $b9b2891cb52bc300$var$DeleteModal extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onInitialised: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onFilterDeleted: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $lDUyj.default)((0, $1sfij.default));
        this.store.dispatch((0, $5w3Ve.setAppProps)(this.props));
        this.store.dispatch((0, $5w3Ve.getAssociatedItems)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store,
            hasErrorBoundary: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
            id: "unhandled",
            packageName: "jiraDeleteFiltersModal",
            teamName: "jira-cosmos"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iW3eZ.default), null))));
    }
}
var $b9b2891cb52bc300$export$2e2bcd8739ae039 = (0, $BwaQq.AnalyticsSource)('deleteFilter', (0, $466f60259c330878$export$1171103ea9083ffa))($b9b2891cb52bc300$var$DeleteModal);

});
parcelRegister("BwaQq", function(module, exports) {

$parcel$export(module.exports, "AnalyticsSource", () => $38148dc6317877af$export$6890652a1aff7d1c);
$parcel$export(module.exports, "AnalyticsSubject", () => $38148dc6317877af$export$ec9f54bd4341ceb);

var $kUIKr = parcelRequire("kUIKr");
const $38148dc6317877af$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, $kUIKr.default)({
            source: `${name}${type}`
        })(WrappedComponent);
const $38148dc6317877af$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, $kUIKr.default)({
            actionSubject: name,
            attributes: attributes
        })(WrappedComponent);

});

parcelRegister("aP411", function(module, exports) {

$parcel$export(module.exports, "default", () => $02914045d75bc0a9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $02914045d75bc0a9$var$AppStyle = ({ children: children })=>/*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            "_11c82smr _4t3i1kw7"
        ])
    }, children);
const $02914045d75bc0a9$var$appStyles = null;
var $02914045d75bc0a9$export$2e2bcd8739ae039 = $02914045d75bc0a9$var$AppStyle;

});

parcelRegister("1sfij", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ab053264faf65c2$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $id9Ha = parcelRequire("id9Ha");

var $5vAkc = parcelRequire("5vAkc");
var // @ts-expect-error - TS2769 - No overload matches this call.
$2ab053264faf65c2$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $id9Ha.default), (0, $5vAkc.default));

});
parcelRegister("id9Ha", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7137a58c450d3a4$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $6zXPf = parcelRequire("6zXPf");

var $3dBDK = parcelRequire("3dBDK");

var $5w3Ve = parcelRequire("5w3Ve");

var $fOU2r = parcelRequire("fOU2r");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a7137a58c450d3a4$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $5w3Ve.DELETE_FILTER)).mergeMap(({ onComplete: onComplete })=>{
        const state = store.getState();
        const filter = (0, $fOU2r.getFilter)(state);
        return (0, $7kixv.Observable).fromPromise((0, $3dBDK.default)(filter.id)).mergeMap(()=>{
            (0, $fOU2r.getOnFilterDeleted)(state)(filter);
            (0, $6zXPf.getWillShowNav4)() && onComplete?.();
            return (0, $7kixv.Observable).of((0, $5w3Ve.filterDeleted)());
        }).catch((error)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData('directories.filters-v2.delete-modal.ops.delete-filter', error.message, error);
            (0, $fOU2r.getOnFilterDeleteFailed)(state)(filter);
            return (0, $7kixv.Observable).of((0, $5w3Ve.deleteFilterFailed)());
        });
    });

});
parcelRegister("3dBDK", function(module, exports) {

$parcel$export(module.exports, "default", () => $857ba0747d5aea43$export$2e2bcd8739ae039);

var $br11A = parcelRequire("br11A");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$857ba0747d5aea43$export$2e2bcd8739ae039 = (filterId)=>(0, $br11A.default)(filterId);

});
parcelRegister("br11A", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d8327b93b7e8d49$export$2e2bcd8739ae039);

var $jGzN3 = parcelRequire("jGzN3");
const $9d8327b93b7e8d49$export$7138c24907de3954 = (filterId)=>`/rest/api/3/filter/${filterId}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9d8327b93b7e8d49$export$2e2bcd8739ae039 = (filterId)=>(0, $jGzN3.performDeleteRequest)($9d8327b93b7e8d49$export$7138c24907de3954(filterId));

});


parcelRegister("5w3Ve", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $0c5106eda7f98a90$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $0c5106eda7f98a90$export$cfda7627848a58cd);
$parcel$export(module.exports, "GET_ASSOCIATED_ITEMS", () => $0c5106eda7f98a90$export$30d51c320095bdf2);
$parcel$export(module.exports, "getAssociatedItems", () => $0c5106eda7f98a90$export$41e54fd4a1e5f9ba);
$parcel$export(module.exports, "ASSOCIATED_ITEMS_RETRIEVED", () => $0c5106eda7f98a90$export$ba1e7147572f059);
$parcel$export(module.exports, "associatedItemsRetrieved", () => $0c5106eda7f98a90$export$25e9475c64e5eda0);
$parcel$export(module.exports, "GET_ASSOCIATED_ITEMS_FAILED", () => $0c5106eda7f98a90$export$4c7da338bde02996);
$parcel$export(module.exports, "getAssociatedItemsFailed", () => $0c5106eda7f98a90$export$bc1efa3ceb08db7b);
$parcel$export(module.exports, "DELETE_FILTER", () => $0c5106eda7f98a90$export$c90b00f6f11adca7);
$parcel$export(module.exports, "deleteFilter", () => $0c5106eda7f98a90$export$d80cc0328fcc6685);
$parcel$export(module.exports, "DELETE_FILTER_FAILED", () => $0c5106eda7f98a90$export$d3f2a09b0efe5b07);
$parcel$export(module.exports, "deleteFilterFailed", () => $0c5106eda7f98a90$export$e303ddf5f6d63378);
$parcel$export(module.exports, "FILTER_DELETED", () => $0c5106eda7f98a90$export$c8cf94be5a7baff9);
$parcel$export(module.exports, "filterDeleted", () => $0c5106eda7f98a90$export$9411fafcb56b5a87);
const $0c5106eda7f98a90$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $0c5106eda7f98a90$export$cfda7627848a58cd = (payload)=>({
        type: $0c5106eda7f98a90$export$8aefe701a6f431e0,
        payload: payload
    });
const $0c5106eda7f98a90$export$30d51c320095bdf2 = 'state.GET_ASSOCIATED_ITEMS';
const $0c5106eda7f98a90$export$41e54fd4a1e5f9ba = ()=>({
        type: $0c5106eda7f98a90$export$30d51c320095bdf2
    });
const $0c5106eda7f98a90$export$ba1e7147572f059 = 'state.ASSOCIATED_ITEMS_RETRIEVED';
const $0c5106eda7f98a90$export$25e9475c64e5eda0 = (payload)=>({
        type: $0c5106eda7f98a90$export$ba1e7147572f059,
        payload: payload
    });
const $0c5106eda7f98a90$export$4c7da338bde02996 = 'state.GET_ASSOCIATED_ITEMS_FAILED';
const $0c5106eda7f98a90$export$bc1efa3ceb08db7b = ()=>({
        type: $0c5106eda7f98a90$export$4c7da338bde02996
    });
const $0c5106eda7f98a90$export$c90b00f6f11adca7 = 'state.DELETE_FILTER';
const $0c5106eda7f98a90$export$d80cc0328fcc6685 = (onComplete)=>({
        type: $0c5106eda7f98a90$export$c90b00f6f11adca7,
        onComplete: onComplete
    });
const $0c5106eda7f98a90$export$d3f2a09b0efe5b07 = 'state.DELETE_FILTER_FAILED';
const $0c5106eda7f98a90$export$e303ddf5f6d63378 = ()=>({
        type: $0c5106eda7f98a90$export$d3f2a09b0efe5b07
    });
const $0c5106eda7f98a90$export$c8cf94be5a7baff9 = 'state.FILTER_DELETED';
const $0c5106eda7f98a90$export$9411fafcb56b5a87 = ()=>({
        type: $0c5106eda7f98a90$export$c8cf94be5a7baff9
    });

});

parcelRegister("fOU2r", function(module, exports) {

$parcel$export(module.exports, "getFilter", () => $a3b86ee3a8758336$export$61ec8404f465cd36);
$parcel$export(module.exports, "getFilterName", () => $a3b86ee3a8758336$export$b055b0a980ec5c8b);
$parcel$export(module.exports, "getOnInitialised", () => $a3b86ee3a8758336$export$47263859bc15a8b8);
$parcel$export(module.exports, "getOnFilterDeleted", () => $a3b86ee3a8758336$export$f5f4c932a633fd32);
$parcel$export(module.exports, "getOnFilterDeleteFailed", () => $a3b86ee3a8758336$export$eb50a3cf06607a3c);
$parcel$export(module.exports, "getOnFilterInitiateFailed", () => $a3b86ee3a8758336$export$9ef18d2a82ac120);
$parcel$export(module.exports, "getOnCancel", () => $a3b86ee3a8758336$export$2c6267c00ffc9906);
$parcel$export(module.exports, "isDeleteInProgress", () => $a3b86ee3a8758336$export$906c0d65e4ece39d);
$parcel$export(module.exports, "isDataRetrieved", () => $a3b86ee3a8758336$export$a9211cdc0a6969f);
$parcel$export(module.exports, "getAssociatedBoards", () => $a3b86ee3a8758336$export$2de9e9ee805a66);
$parcel$export(module.exports, "getAssociatedUsers", () => $a3b86ee3a8758336$export$4004cc0feaedb1d1);
$parcel$export(module.exports, "getAssociatedGroups", () => $a3b86ee3a8758336$export$4f21761c9913ab49);
$parcel$export(module.exports, "getCanDelete", () => $a3b86ee3a8758336$export$e31d21defdc79bd5);
const $a3b86ee3a8758336$export$61ec8404f465cd36 = (state)=>state.appProps.filter;
const $a3b86ee3a8758336$export$b055b0a980ec5c8b = (state)=>state.appProps.filter.name;
const $a3b86ee3a8758336$export$47263859bc15a8b8 = (state)=>state.appProps.onInitialised;
const $a3b86ee3a8758336$export$f5f4c932a633fd32 = (state)=>state.appProps.onFilterDeleted;
const $a3b86ee3a8758336$export$eb50a3cf06607a3c = (state)=>state.appProps.onFilterDeleteFailed;
const $a3b86ee3a8758336$export$9ef18d2a82ac120 = (state)=>state.appProps.onFilterInitiateFailed;
const $a3b86ee3a8758336$export$2c6267c00ffc9906 = (state)=>state.appProps.onCancel;
const $a3b86ee3a8758336$export$906c0d65e4ece39d = (state)=>state.isDeleteInProgress;
const $a3b86ee3a8758336$export$a9211cdc0a6969f = (state)=>state.isDataRetrieved;
const $a3b86ee3a8758336$export$2de9e9ee805a66 = (state)=>state.boards;
const $a3b86ee3a8758336$export$4004cc0feaedb1d1 = (state)=>state.users;
const $a3b86ee3a8758336$export$4f21761c9913ab49 = (state)=>state.groups;
const $a3b86ee3a8758336$export$e31d21defdc79bd5 = (state)=>Array.isArray(state.boards) && state.boards.length === 0;

});


parcelRegister("5vAkc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0416b34426e91322$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("fu6rs");
parcelRequire("1o2WJ");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $hG5l5 = parcelRequire("hG5l5");

var $j7QHh = parcelRequire("j7QHh");

var $5w3Ve = parcelRequire("5w3Ve");

var $fOU2r = parcelRequire("fOU2r");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0416b34426e91322$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $5w3Ve.GET_ASSOCIATED_ITEMS)).mergeMap(()=>{
        const state = store.getState();
        const filter = (0, $fOU2r.getFilter)(state);
        return (0, $7kixv.Observable).forkJoin((0, $7kixv.Observable).fromPromise((0, $hG5l5.default)(filter.id)), (0, $7kixv.Observable).fromPromise((0, $j7QHh.default)(filter.id))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .map(([boards, subscriptions])=>{
            const { users: users, groups: groups } = subscriptions;
            (0, $fOU2r.getOnInitialised)(state)();
            return (0, $5w3Ve.associatedItemsRetrieved)({
                boards: boards,
                users: users,
                groups: groups
            });
        }).catch((error)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData('directories.filters-v2.delete-modal.ops.get-associated-items', error.message, error);
            (0, $fOU2r.getOnFilterInitiateFailed)(state)(filter);
            return (0, $7kixv.Observable).of((0, $5w3Ve.getAssociatedItemsFailed)());
        });
    });

});
parcelRegister("hG5l5", function(module, exports) {

$parcel$export(module.exports, "default", () => $45baed30f738a43a$export$2e2bcd8739ae039);

var $ik39t = parcelRequire("ik39t");

var $gJXHu = parcelRequire("gJXHu");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$45baed30f738a43a$export$2e2bcd8739ae039 = async (filterId)=>{
    const response = await (0, $ik39t.default)(filterId);
    return (0, $gJXHu.transformResponse)(response);
};

});
parcelRegister("ik39t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bbce76cac17ef78$export$2e2bcd8739ae039);

var $1Ozm9 = parcelRequire("1Ozm9");
const $7bbce76cac17ef78$export$7138c24907de3954 = (filterId)=>`/rest/agile/1.0/board/filter/${filterId}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7bbce76cac17ef78$export$2e2bcd8739ae039 = (filterId)=>(0, $1Ozm9.default)($7bbce76cac17ef78$export$7138c24907de3954(filterId));

});

parcelRegister("gJXHu", function(module, exports) {

$parcel$export(module.exports, "transformResponse", () => $d296ce64ddb1511c$export$3361e9be8093ddcc);
const $d296ce64ddb1511c$export$b708cb7873d8352c = (id)=>`/secure/RapidBoard.jspa?rapidView=${id}&useStoredSettings=true`;
const $d296ce64ddb1511c$export$3361e9be8093ddcc = (response)=>{
    const boards = response && response.values || [];
    return boards.map((board)=>{
        const { name: name, id: id } = board;
        const href = $d296ce64ddb1511c$export$b708cb7873d8352c(id);
        return {
            name: name,
            id: id,
            href: href
        };
    });
};

});


parcelRegister("j7QHh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6a0e330f474a56f$export$2e2bcd8739ae039);

var $3GJlE = parcelRequire("3GJlE");

var $3rsCf = parcelRequire("3rsCf");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a6a0e330f474a56f$export$2e2bcd8739ae039 = async (filterId)=>{
    const response = await (0, $3GJlE.default)(filterId);
    return (0, $3rsCf.transformResponse)(response);
};

});
parcelRegister("3GJlE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bc27b55f2b87a6b$export$2e2bcd8739ae039);

var $1Ozm9 = parcelRequire("1Ozm9");
const $9bc27b55f2b87a6b$export$7138c24907de3954 = (filterId)=>`/rest/api/3/filter/${filterId}?expand=subscriptions`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9bc27b55f2b87a6b$export$2e2bcd8739ae039 = (filterId)=>(0, $1Ozm9.default)($9bc27b55f2b87a6b$export$7138c24907de3954(filterId));

});

parcelRegister("3rsCf", function(module, exports) {

$parcel$export(module.exports, "transformResponse", () => $1b8678ffcc2768c4$export$3361e9be8093ddcc);

var $a62R3 = parcelRequire("a62R3");

var $7jTnu = parcelRequire("7jTnu");
const $1b8678ffcc2768c4$export$d62b55bf0ad74ba2 = (id)=>{
    if ((0, $7jTnu.fg)('jira-adopt-teams-nav-config')) {
        const { href: href } = (0, $a62R3.getNavigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: id
            }
        });
        return href;
    }
    return `/jira/people/${id}`;
};
const $1b8678ffcc2768c4$export$3361e9be8093ddcc = (response)=>{
    const subscriptions = response && response.subscriptions && response.subscriptions.items || [];
    const users = [];
    const groups = [];
    subscriptions.forEach((subscription)=>{
        const { user: user, group: group } = subscription;
        if (group) return groups.push({
            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'never'.
            name: group.name
        });
        // @ts-expect-error - TS2339 - Property 'accountId' does not exist on type 'never'.
        const href = $1b8678ffcc2768c4$export$d62b55bf0ad74ba2(user.accountId);
        return user && users.push({
            // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'never'.
            displayName: user.displayName,
            href: href
        });
    });
    return {
        users: users,
        groups: groups
    };
};

});




parcelRegister("lDUyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $278ffdd193870a27$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $geiGp = parcelRequire("geiGp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$278ffdd193870a27$export$2e2bcd8739ae039 = (rootEpic)=>(0, $gs6vs.default)({
        appName: 'directories/filters-v2/delete-modal',
        rootReducer: $geiGp.default,
        rootEpic: rootEpic
    });

});
parcelRegister("geiGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f1da0e6466ee8eb$export$2e2bcd8739ae039);

var $5w3Ve = parcelRequire("5w3Ve");
const $0f1da0e6466ee8eb$export$49d5fc8cba920a0 = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    appProps: undefined,
    boards: [],
    users: [],
    groups: [],
    isDataRetrieved: false,
    isDeleteInProgress: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0f1da0e6466ee8eb$export$2e2bcd8739ae039 = (state = $0f1da0e6466ee8eb$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $5w3Ve.SET_APP_PROPS:
            return {
                ...state,
                appProps: action.payload
            };
        case 0, $5w3Ve.DELETE_FILTER:
            return {
                ...state,
                isDeleteInProgress: true
            };
        case 0, $5w3Ve.FILTER_DELETED:
        case 0, $5w3Ve.DELETE_FILTER_FAILED:
            return {
                ...state,
                isDeleteInProgress: false
            };
        case 0, $5w3Ve.ASSOCIATED_ITEMS_RETRIEVED:
            {
                const { boards: boards, users: users, groups: groups } = action.payload;
                return {
                    ...state,
                    isDataRetrieved: true,
                    ...boards ? {
                        boards: boards
                    } : undefined,
                    ...users ? {
                        users: users
                    } : undefined,
                    ...groups ? {
                        groups: groups
                    } : undefined
                };
            }
        case 0, $5w3Ve.GET_ASSOCIATED_ITEMS_FAILED:
        case 0, $5w3Ve.GET_ASSOCIATED_ITEMS:
            return state;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("iW3eZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4321da6e267e1d94$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $fOU2r = parcelRequire("fOU2r");

var $6LbeH = parcelRequire("6LbeH");

var $b9s6a = parcelRequire("b9s6a");

var $969je = parcelRequire("969je");
const $4321da6e267e1d94$var$mapStateToProps = (state)=>({
        Content: $6LbeH.default,
        Footer: $b9s6a.default,
        name: (0, $fOU2r.getFilterName)(state),
        onCancel: (0, $fOU2r.getOnCancel)(state),
        isOpen: (0, $fOU2r.isDataRetrieved)(state)
    });
var $4321da6e267e1d94$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($4321da6e267e1d94$var$mapStateToProps, {})((0, $969je.default));

});
parcelRegister("6LbeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bc62c5a1417fdf7$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $fOU2r = parcelRequire("fOU2r");

var $gsnIW = parcelRequire("gsnIW");
const $3bc62c5a1417fdf7$var$mapStateToProps = (state)=>({
        filter: (0, $fOU2r.getFilter)(state),
        boards: (0, $fOU2r.getAssociatedBoards)(state),
        users: (0, $fOU2r.getAssociatedUsers)(state),
        groups: (0, $fOU2r.getAssociatedGroups)(state)
    });
var $3bc62c5a1417fdf7$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($3bc62c5a1417fdf7$var$mapStateToProps, {})((0, $gsnIW.default));

});
parcelRegister("gsnIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $406b9af348575917$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $51Gwp = parcelRequire("51Gwp");

var $lRq8t = parcelRequire("lRq8t");

var $2FeHb = parcelRequire("2FeHb");
const $406b9af348575917$var$ContentWithoutBoardsAndSubscriptions = ({ formatMessage: formatMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).noSubscriptionsAndBoards));
const $406b9af348575917$var$ContentWithAssociatedSubscriptions = ({ formatMessage: formatMessage, groups: groups, users: users })=>users.length === 1 && groups.length === 0 || users.length === 0 && groups.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).singleSubscription), users.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
        href: users[0].href
    }, `${users[0].displayName}.`) : null, groups.length === 1 ? `${groups[0].name}.` : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).multipleBoardsWarning))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).multipleSubscriptions, {
        number: users.length + groups.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ul", null, users.map(({ displayName: displayName, href: href }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
            href: href
        }, displayName))), groups.map(({ name: name }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
            key: index
        }, name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).multipleSubscriptionsWarning)));
const $406b9af348575917$var$ContentWithAssociatedBoards = ({ boards: boards, formatMessage: formatMessage })=>boards.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).singleBoard), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
        href: boards[0].href
    }, `${boards[0].name}.`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).multipleBoardsWarning))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).multipleBoards, {
        number: boards.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ul", null, boards.map(({ name: name, href: href }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
            href: href
        }, name)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).multipleBoardsWarning)));
const $406b9af348575917$export$7c6e2c02157bb7d2 = ({ boards: boards, groups: groups, users: users })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (users.length === 0 && groups.length === 0 && boards.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($406b9af348575917$var$ContentWithoutBoardsAndSubscriptions, {
        formatMessage: formatMessage
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2FeHb.default).associatedItems)), boards.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($406b9af348575917$var$ContentWithAssociatedBoards, {
        boards: boards,
        formatMessage: formatMessage
    }) : null, users.length > 0 || groups.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($406b9af348575917$var$ContentWithAssociatedSubscriptions, {
        users: users,
        groups: groups,
        formatMessage: formatMessage
    }) : null);
};
var $406b9af348575917$export$2e2bcd8739ae039 = $406b9af348575917$export$7c6e2c02157bb7d2;

});
parcelRegister("2FeHb", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e11a255e2bc2b8b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4e11a255e2bc2b8b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noSubscriptionsAndBoards: {
        "id": "directories.filters-v2.delete-modal.content.no-subscriptions-and-boards",
        "defaultMessage": "Are you sure you want to delete this filter?"
    },
    associatedItems: {
        "id": "directories.filters-v2.delete-modal.content.associated-items",
        "defaultMessage": "This filter is used elsewhere. Deleting it may impact other people's work."
    },
    multipleSubscriptions: {
        "id": "directories.filters-v2.delete-modal.content.multiple-subscriptions",
        "defaultMessage": "This filter has currently {number} subscriptions:"
    },
    singleSubscription: {
        "id": "directories.filters-v2.delete-modal.content.single-subscription",
        "defaultMessage": "This filter has a subscription for "
    },
    multipleSubscriptionsWarning: {
        "id": "directories.filters-v2.delete-modal.content.multiple-subscriptions-warning",
        "defaultMessage": "Deleting this filter will cause subscription emails for these users and groups to no longer be delivered."
    },
    multipleBoards: {
        "id": "directories.filters-v2.delete-modal.content.multiple-boards",
        "defaultMessage": "This filter is currently being used by {number} boards:"
    },
    singleBoard: {
        "id": "directories.filters-v2.delete-modal.content.single-board",
        "defaultMessage": "This filter is currently being used by "
    },
    multipleBoardsWarning: {
        "id": "directories.filters-v2.delete-modal.content.multiple-boards-warning",
        "defaultMessage": "You'll need to remove this filters associations to the boards before it can be removed."
    }
});

});



parcelRegister("b9s6a", function(module, exports) {

$parcel$export(module.exports, "default", () => $9efd33015b5c7148$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $l5htz = parcelRequire("l5htz");

var $gnQAk = parcelRequire("gnQAk");

var $5w3Ve = parcelRequire("5w3Ve");

var $fOU2r = parcelRequire("fOU2r");

var $hpOVf = parcelRequire("hpOVf");
const $9efd33015b5c7148$var$mapStateToProps = (state)=>({
        filter: (0, $fOU2r.getFilter)(state),
        canDelete: (0, $fOU2r.getCanDelete)(state),
        deleteInProgress: (0, $fOU2r.isDeleteInProgress)(state),
        onCancel: (0, $fOU2r.getOnCancel)(state)
    });
var $9efd33015b5c7148$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $l5htz.default)({
    onDelete: 'filterDeleted',
    onCancel: 'filterDeleteCanceled'
}), (0, $gnQAk.connect)($9efd33015b5c7148$var$mapStateToProps, {
    onDelete: (0, $5w3Ve.deleteFilter)
}))((0, $hpOVf.default));

});
parcelRegister("eq3Hf", function(module, exports) {

var $lH6wc = parcelRequire("lH6wc");
/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */ var $a7f65c72bfe5b7ea$var$flow = $lH6wc();
module.exports = $a7f65c72bfe5b7ea$var$flow;

});
parcelRegister("lH6wc", function(module, exports) {

var $iTpII = parcelRequire("iTpII");

var $lgI96 = parcelRequire("lgI96");

var $2GK2O = parcelRequire("2GK2O");

var $asy1v = parcelRequire("asy1v");

var $4sprp = parcelRequire("4sprp");

var $74osV = parcelRequire("74osV");
/** Error message constants. */ var $fcb2ab89fd3879f0$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $fcb2ab89fd3879f0$var$WRAP_CURRY_FLAG = 8, $fcb2ab89fd3879f0$var$WRAP_PARTIAL_FLAG = 32, $fcb2ab89fd3879f0$var$WRAP_ARY_FLAG = 128, $fcb2ab89fd3879f0$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */ function $fcb2ab89fd3879f0$var$createFlow(fromRight) {
    return $lgI96(function(funcs) {
        var length = funcs.length, index = length, prereq = $iTpII.prototype.thru;
        if (fromRight) funcs.reverse();
        while(index--){
            var func = funcs[index];
            if (typeof func != 'function') throw new TypeError($fcb2ab89fd3879f0$var$FUNC_ERROR_TEXT);
            if (prereq && !wrapper && $asy1v(func) == 'wrapper') var wrapper = new $iTpII([], true);
        }
        index = wrapper ? index : length;
        while(++index < length){
            func = funcs[index];
            var funcName = $asy1v(func), data = funcName == 'wrapper' ? $2GK2O(func) : undefined;
            if (data && $74osV(data[0]) && data[1] == ($fcb2ab89fd3879f0$var$WRAP_ARY_FLAG | $fcb2ab89fd3879f0$var$WRAP_CURRY_FLAG | $fcb2ab89fd3879f0$var$WRAP_PARTIAL_FLAG | $fcb2ab89fd3879f0$var$WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[$asy1v(data[0])].apply(wrapper, data[3]);
            else wrapper = func.length == 1 && $74osV(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
        return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && $4sprp(value)) return wrapper.plant(value).value();
            var index = 0, result = length ? funcs[index].apply(this, args) : value;
            while(++index < length)result = funcs[index].call(this, result);
            return result;
        };
    });
}
module.exports = $fcb2ab89fd3879f0$var$createFlow;

});


parcelRegister("l5htz", function(module, exports) {

$parcel$export(module.exports, "default", () => $647ecf3cf7b12c9d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $iM63C = parcelRequire("iM63C");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $647ecf3cf7b12c9d$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $iM63C.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $iM63C.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $eJOHy.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $647ecf3cf7b12c9d$export$2e2bcd8739ae039 = $647ecf3cf7b12c9d$var$fireWithUIAnalytics;

});

parcelRegister("hpOVf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e9e4b2ef7f05ae8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $dKpTa = parcelRequire("dKpTa");

var $pUkPE = parcelRequire("pUkPE");

var $3Zn1o = parcelRequire("3Zn1o");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $dPlS8 = parcelRequire("dPlS8");

var $idGBm = parcelRequire("idGBm");

var $6zXPf = parcelRequire("6zXPf");

var $6rSB4 = parcelRequire("6rSB4");

var $cN96O = parcelRequire("cN96O");
const $3e9e4b2ef7f05ae8$var$Footer = ({ intl: { formatMessage: formatMessage }, canDelete: canDelete, deleteInProgress: deleteInProgress, onCancel: onCancel, onDelete: onDelete })=>{
    const { publish: publish } = (0, $6rSB4.useDeleteChangeActions)();
    const onDeleteWithEvent = (event, analyticsEvent)=>{
        // additional args aside from event & analyticsEvent that you wish to pass down needs to be passed as the first argument
        onDelete(publish, event, analyticsEvent);
    };
    const onDeleteOld = (event, analyticsEvent)=>{
        onDelete(undefined, event, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Zn1o.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3e9e4b2ef7f05ae8$var$Container, null, deleteInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $3e9e4b2ef7f05ae8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPlS8.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $pUkPE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        appearance: "danger",
        type: "submit",
        isDisabled: !canDelete,
        onClick: (0, $6zXPf.getWillShowNav4)() ? onDeleteWithEvent : onDeleteOld
    }, formatMessage((0, $cN96O.default).delete)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        appearance: "subtle-link",
        isDisabled: deleteInProgress,
        onClick: onCancel
    }, formatMessage((0, $cN96O.default).cancelButtonCaption)))));
};
$3e9e4b2ef7f05ae8$var$Footer.defaultProps = {
    onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    deleteInProgress: false,
    canDelete: true
};
var $3e9e4b2ef7f05ae8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($3e9e4b2ef7f05ae8$var$Footer);
const $3e9e4b2ef7f05ae8$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $3e9e4b2ef7f05ae8$var$spinnerContainerStyles = (0, $5Wv5g.xcss)({
    marginRight: 'space.200'
});

});
parcelRegister("idGBm", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $c35e98ccc24112a8$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eJOHy = parcelRequire("eJOHy");

var $cjwij = parcelRequire("cjwij");

var $lRq8t = parcelRequire("lRq8t");
const $c35e98ccc24112a8$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $c35e98ccc24112a8$var$getDisplayName(Component) {
    if ($c35e98ccc24112a8$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($c35e98ccc24112a8$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $c35e98ccc24112a8$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $lRq8t.default)();
        const intlRef = (0, $eJOHy.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$c35e98ccc24112a8$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($cjwij)))(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cjwij)))(WithIntl, WrappedComponent);
};

});

parcelRegister("cN96O", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a2cb6409b3bb641$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9a2cb6409b3bb641$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    delete: {
        "id": "directories.filters-v2.delete-modal.footer.delete",
        "defaultMessage": "Delete"
    },
    cancelButtonCaption: {
        "id": "directories.filters-v2.delete-modal.footer.cancel-button-caption",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("969je", function(module, exports) {

$parcel$export(module.exports, "default", () => $163c7a032dd631c0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6sWr0 = parcelRequire("6sWr0");
var $15cpG = parcelRequire("15cpG");
var $i237T = parcelRequire("i237T");
var $jC5ye = parcelRequire("jC5ye");

var $jtIA2 = parcelRequire("jtIA2");

var $2ZGUP = parcelRequire("2ZGUP");

var $idGBm = parcelRequire("idGBm");

var $fgJkD = parcelRequire("fgJkD");

var $i65VJ = parcelRequire("i65VJ");
const $163c7a032dd631c0$var$DeleteModal = ({ intl: { formatMessage: formatMessage }, isOpen: isOpen, Content: Content, Footer: Footer, onCancel: onCancel, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jC5ye.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgJkD.ModalDialog), {
        messageId: "delete-filters-modal.modal-dialog",
        messageType: "transactional",
        width: "small",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $15cpG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i237T.default), {
        appearance: "danger"
    }, formatMessage((0, $i65VJ.default).title, {
        name: name
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6sWr0.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtIA2.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Footer, {
        onClose: onCancel
    }))));
var $163c7a032dd631c0$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($163c7a032dd631c0$var$DeleteModal);

});
parcelRegister("jtIA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1b00c14168b4301$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $kUIKr = parcelRequire("kUIKr");
var $aN4Pk = parcelRequire("aN4Pk");

var $iM63C = parcelRequire("iM63C");
// eslint-disable-next-line jira/react/no-class-components
class $d1b00c14168b4301$var$ViewTracker extends (0, $eJOHy.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $d1b00c14168b4301$var$ViewTrackerWithAnalytics = (0, $kUIKr.default)({
    componentName: 'view-tracker'
})((0, $aN4Pk.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $iM63C.PAGE_EVENT_ACTION)
        }).fire()
})($d1b00c14168b4301$var$ViewTracker));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d1b00c14168b4301$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d1b00c14168b4301$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    });

});

parcelRegister("fgJkD", function(module, exports) {

$parcel$export(module.exports, "ModalDialog", () => $dfae8fefc4710a7e$export$1fa217be60c2f188);

var $eJOHy = parcelRequire("eJOHy");

var $aC4Bh = parcelRequire("aC4Bh");

var $4aSRi = parcelRequire("4aSRi");
const $dfae8fefc4710a7e$export$1fa217be60c2f188 = ({ shouldReturnFocus: shouldReturnFocus, ...rest })=>{
    const returnFocusTarget = (0, $4aSRi.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $4aSRi.useModalDialogActions)();
    (0, $eJOHy.useEffect)(()=>()=>{
            if (returnFocusTarget?.current) {
                !shouldReturnFocus && returnFocusTarget.current.focus();
                setReturnFocusTo(null);
            }
        }, [
        returnFocusTarget,
        setReturnFocusTo,
        shouldReturnFocus
    ]);
    /**
	 *  when shouldReturnFocus is defined,
	 * 	we won't handle passing focus back to this element
	 *	we will ignore the returnFocusTarget
	 */ const returnFocus = shouldReturnFocus ?? !returnFocusTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        shouldReturnFocus: returnFocus,
        ...rest,
        messageId: rest.messageId ?? 'software.modal-dialog.ui.ak-modal-dialog',
        messageType: rest.messageType ?? 'transactional'
    });
};

});
parcelRegister("4aSRi", function(module, exports) {

$parcel$export(module.exports, "useModalDialogActions", () => $0b2a666031d89d51$export$3cf2e4b6d3541465);
$parcel$export(module.exports, "useReturnFocusTo", () => $0b2a666031d89d51$export$217308a4ece853b2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $gnlW1 = parcelRequire("gnlW1");

var $4CmBA = parcelRequire("4CmBA");

var $ik5fE = parcelRequire("ik5fE");
const $0b2a666031d89d51$var$Store = (0, $GtRbT.createStore)({
    name: 'JiraSoftwareModalDialog',
    initialState: $gnlW1.initialState,
    actions: $4CmBA.actions
});
const $0b2a666031d89d51$export$3cf2e4b6d3541465 = (0, $iJq0l.createActionsHook)($0b2a666031d89d51$var$Store);
const $0b2a666031d89d51$export$217308a4ece853b2 = (0, $iJq0l.createStateHook)($0b2a666031d89d51$var$Store, {
    selector: (0, $ik5fE.getReturnFocusTo)
});

});
parcelRegister("gnlW1", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $155a858c98d12eaf$export$d4c72bab9d6cc13a);
const $155a858c98d12eaf$export$d4c72bab9d6cc13a = {
    returnFocusTo: null
};

});

parcelRegister("4CmBA", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d6a92026239e37f0$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d6a92026239e37f0$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
        setState({
            returnFocusTo: returnFocusTo
        });
    };
const $d6a92026239e37f0$export$e324594224ef24da = {
    setReturnFocusTo: $d6a92026239e37f0$export$b263d1e638b131c2
};

});

parcelRegister("ik5fE", function(module, exports) {

$parcel$export(module.exports, "getReturnFocusTo", () => $c992da1452d2469a$export$d5f8692765ccd209);
const $c992da1452d2469a$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;

});



parcelRegister("i65VJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f03eecefd6f88a19$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f03eecefd6f88a19$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.filters-v2.delete-modal.title",
        "defaultMessage": "Delete {name}"
    }
});

});




parcelRegister("6Ibih", function(module, exports) {

$parcel$export(module.exports, "default", () => $d00a29012bc8be70$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d00a29012bc8be70$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    filterDeletedModalTitleSuccessNonFinal: {
        "id": "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-title-success-non-final",
        "defaultMessage": "{name} was deleted"
    },
    filterDeletedModalTitleErrorNonFinal: {
        "id": "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-title-error-non-final",
        "defaultMessage": "We couldn't delete filter"
    },
    filterDeletedModalDescriptionErrorNonFinal: {
        "id": "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-description-error-non-final",
        "defaultMessage": "There was an error, please try again."
    }
});

});


parcelRegister("dv92c", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d4385cd16397b6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $88d4385cd16397b6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    manageSubscription: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.manage-subscription",
        "defaultMessage": "Manage subscriptions"
    },
    copyFilter: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter",
        "defaultMessage": "Copy filter"
    },
    copyFilterDialogTitle: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    },
    edit: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.edit",
        "defaultMessage": "Edit filter"
    },
    changeOwner: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.change-owner",
        "defaultMessage": "Change owner"
    },
    delete: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.delete",
        "defaultMessage": "Delete filter"
    },
    manageSubscriptionWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.manage-subscription-with-name",
        "defaultMessage": "Manage subscriptions for {name}"
    },
    copyFilterWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter-with-name",
        "defaultMessage": "Copy filter {name}"
    },
    editWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.edit-with-name",
        "defaultMessage": "Edit filter {name}"
    },
    changeOwnerWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.change-owner-with-name",
        "defaultMessage": "Change owner for {name}"
    },
    deleteWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.delete-with-name",
        "defaultMessage": "Delete filter {name}"
    }
});

});

parcelRegister("6hubO", function(module, exports) {

$parcel$export(module.exports, "useModalState", () => $3d7fe49201b62c8d$export$baa48889c42cc6cb);

var $eJOHy = parcelRequire("eJOHy");
const $3d7fe49201b62c8d$export$baa48889c42cc6cb = (defaultOpen = false)=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultOpen);
    const onClose = (0, $eJOHy.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onOpen = (0, $eJOHy.useCallback)(()=>setIsOpen(true), [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        onOpen: onOpen
    };
};

});


parcelRegister("2wv1t", function(module, exports) {

$parcel$export(module.exports, "SimpleFilterMenuItem", () => $0ce274b803741a48$export$608d42ceb4060968);

var $eJOHy = parcelRequire("eJOHy");

var $7eM4W = parcelRequire("7eM4W");

var $iVTd6 = parcelRequire("iVTd6");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");
function $0ce274b803741a48$export$608d42ceb4060968({ actionsOnHover: actionsOnHover, filterId: filterId, name: name, onClick: onClick }) {
    const handlOnClick = (0, $eJOHy.useCallback)((e)=>{
        onClick?.();
        (0, $iVTd6.handleGinSPAClick)(e);
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        actionsOnHover: actionsOnHover,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7eM4W))), {
            label: "",
            color: "currentColor"
        }),
        href: `/issues/?filter=${filterId}`,
        menuId: (0, $h4Bzb.ENTITY_ID).FILTER(filterId),
        onClick: handlOnClick
    }, name);
}

});
parcelRegister("iVTd6", function(module, exports) {

$parcel$export(module.exports, "handleGinSPAClick", () => $79fca746cf96b384$export$f74673b086629362);
const $79fca746cf96b384$export$f74673b086629362 = (e)=>{
    const href = // @ts-expect-error - TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'. | TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'.
    typeof e.currentTarget.href === 'string' ? e.currentTarget.href : undefined;
    const openInNewTab = // @ts-expect-error - TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'. | TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'.
    e.metaKey || e.altKey || e.ctrlKey || e.shiftKey || e.button != null && e.button === 1;
    if (href == null || href === '' || e.defaultPrevented || openInNewTab) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JIRA?.Issues?.Application) {
        e.preventDefault();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.JIRA.Issues.Application.execute('navigation:navigateToUrl', href, {
            forceRefresh: true,
            checkPermission: true,
            replace: false,
            reset: true,
            routerEvent: true
        });
    }
};

});



parcelRegister("8aXvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $50f1db071d06f5a0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $50f1db071d06f5a0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.starred",
        "defaultMessage": "Starred"
    },
    viewAllStarred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.view-all-starred",
        "defaultMessage": "View all starred items"
    },
    defaultFilters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.default-filters",
        "defaultMessage": "Default filters"
    }
});

});


const $2ae2c8b27c911905$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Filters';
const $2ae2c8b27c911905$export$d57b6b390e78d90f = 'empanada';

parcelRegister("lRTqK", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $ee6fb28b46ca9a53$export$a06f1c675e846f6f);

var $eJOHy = parcelRequire("eJOHy");

var $2y3Ci = parcelRequire("2y3Ci");
var $ilbtc = parcelRequire("ilbtc");
var $1swHh = parcelRequire("1swHh");

var $lRq8t = parcelRequire("lRq8t");




var $h4Bzb = parcelRequire("h4Bzb");

var $1Ce3C = parcelRequire("1Ce3C");

var $bxSuo = parcelRequire("bxSuo");

var $1TzuH = parcelRequire("1TzuH");

var $eltxi = parcelRequire("eltxi");
const $ee6fb28b46ca9a53$var$VIEW_ALL_FILTERS_PATH = (0, $bxSuo.filtersDirectoryRoute).path;
function $ee6fb28b46ca9a53$export$a06f1c675e846f6f() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const sendFilterAnalytics = (0, $1TzuH.useFilterActionsAnalytics)();
    const sendDefaultFilterDropdownAnalytics = (0, $eJOHy.useCallback)(()=>{
        sendFilterAnalytics((0, $bfc89d778f76f56d$export$6dd9406e478a1fe2), {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            itemId: 'viewAllFilters'
        });
    }, [
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Ce3C.ViewAllEntityMenuItem), {
        onClick: sendDefaultFilterDropdownAnalytics,
        href: $ee6fb28b46ca9a53$var$VIEW_ALL_FILTERS_PATH,
        menuId: (0, $h4Bzb.MENU_ID_FILTERS_VIEW_ALL)
    }, formatMessage((0, $eltxi.default).viewAllFilters)))));
}

});
parcelRegister("bxSuo", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRoute", () => $6ecabfb97a89b10c$export$6350f52c8b40042d);
const $6ecabfb97a89b10c$export$6350f52c8b40042d = {
    name: 'filters-directory',
    path: '/jira/filters'
};

});

parcelRegister("eltxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $be05a80503601f1f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $be05a80503601f1f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewAllFilters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.footer.view-all-filters",
        "defaultMessage": "View all filters"
    }
});

});


parcelRegister("44iMp", function(module, exports) {

$parcel$export(module.exports, "Header", () => $173ede2a30c7ec81$export$8b251419efc915eb);

var $eJOHy = parcelRequire("eJOHy");

var $8tSIA = parcelRequire("8tSIA");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");




var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $1TzuH = parcelRequire("1TzuH");

var $eEz35 = parcelRequire("eEz35");
const $173ede2a30c7ec81$export$8b251419efc915eb = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const sendFilterAnalytics = (0, $1TzuH.useFilterActionsAnalytics)();
    const handleOnClick = (0, $eJOHy.useCallback)((event)=>{
        sendFilterAnalytics((0, $bfc89d778f76f56d$export$6dd9406e478a1fe2), {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            itemId: 'searchAllIssues'
        });
        onClose?.(event);
    }, [
        onClose,
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: "/issues/?jql=created%20%3E%3D%20-30d%20order%20by%20created%20DESC",
        onClick: handleOnClick,
        menuId: (0, $h4Bzb.MENU_ID_FILTERS_SEARCH),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSIA))), {
            label: "",
            color: "currentColor"
        })
    }, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $eEz35.default).searchAllIssuesIssueTermRefresh : (0, $eEz35.default).searchAllIssues));
};

});
parcelRegister("eEz35", function(module, exports) {

$parcel$export(module.exports, "default", () => $35766b87ba0a44bb$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $35766b87ba0a44bb$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    searchAllIssues: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.header.search-all-issues",
        "defaultMessage": "Search issues"
    },
    searchAllIssuesIssueTermRefresh: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.header.search-all-issues-issue-term-refresh",
        "defaultMessage": "Search work items"
    }
});

});



parcelRegister("3E5ko", function(module, exports) {

$parcel$export(module.exports, "Nav4FiltersDefault", () => $d07e6adb4b7a82c3$export$c9a2a24425c3fa5e);

var $eJOHy = parcelRequire("eJOHy");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $49s4h = parcelRequire("49s4h");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $if69u = parcelRequire("if69u");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $hPlDs = parcelRequire("hPlDs");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");


var $lRTqK = parcelRequire("lRTqK");

var $44iMp = parcelRequire("44iMp");

var $aG79I = parcelRequire("aG79I");
function $d07e6adb4b7a82c3$export$c9a2a24425c3fa5e(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, simulateLoading: simulateLoading = false } = props;
    const cloudId = (0, $kEUB1.useCloudId)();
    const currentURL = (0, $49s4h.useGetCurrentUrl)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            currentURL: currentURL
        }), [
        cloudId,
        currentURL
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $aG79I.asyncFiltersContentViewQuery), entryPointParams);
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).FILTERS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    const menuId = (0, $h4Bzb.MENU_ID_FILTERS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useCallback)((hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        }, [
            entryPointActions
        ]) : (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useCallback)((hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $8IuE5.L1_MENU_ID).FILTERS,
                    sectionItem: (0, $a9aec.SECTION_ITEM_FILTERS)
                });
            }
        }, [
            entryPointActions,
            sendSectionItemAnalyticsEvent
        ]) : (hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $8IuE5.L1_MENU_ID).FILTERS,
                    sectionItem: (0, $a9aec.SECTION_ITEM_FILTERS)
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-filters-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $azEgq.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $44iMp.Header), null), simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-filters-default",
        packageName: (0, $2ae2c8b27c911905$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $2ae2c8b27c911905$export$d57b6b390e78d90f),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRTqK.Footer), null)));
}

});
parcelRegister("aG79I", function(module, exports) {

$parcel$export(module.exports, "asyncFiltersContentViewQuery", () => $2134863cb1748a97$export$fae48e64221e5e6e);

var $87dvF = parcelRequire("87dvF");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $2134863cb1748a97$export$fae48e64221e5e6e = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("iubDK")).then(({ Nav4FiltersContentViewQuery: Nav4FiltersContentViewQuery })=>Nav4FiltersContentViewQuery), {
        moduleId: "efb9eb25",
        moduleName: "Nav4FiltersContentViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                filters: {
                    parameters: $87dvF.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("87dvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cec722350e78899$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b09b73015f6d4eda410be086a0ec06e>>
 * @relayHash c3bc46f986acdf13f968e5919fcd2d52
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c97505ceda772c1ff0a6ccf4c08e12237f9f7d57f5f99db7c9b61da8af86b7e
const $5cec722350e78899$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v7 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v5 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v10 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4FiltersContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4FiltersContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4FiltersContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouriteFilters",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "FILTER"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentFilters",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "FILTER"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v1 /*: any*/ 
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3c97505ceda772c1ff0a6ccf4c08e12237f9f7d57f5f99db7c9b61da8af86b7e",
            "metadata": {},
            "name": "Nav4FiltersContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5cec722350e78899$var$node.hash = "9218fd54b0172bf14bf1082dd5032107";
var $5cec722350e78899$export$2e2bcd8739ae039 = $5cec722350e78899$var$node;

});

parcelRegister("iubDK", function(module, exports) {

let $d7540ed4b53ccd60$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d7540ed4b53ccd60$var$load("hvvab").then(()=>parcelRequire('OD8to'));

});





parcelRegister("49MXG", function(module, exports) {

$parcel$export(module.exports, "Nav4Operations", () => $4fe48fbe78cc0860$export$bc4d01c843cee95e);

var $eQU2i = parcelRequire("eQU2i");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $7jTnu = parcelRequire("7jTnu");

var $70xty = parcelRequire("70xty");

var $iUGpu = parcelRequire("iUGpu");

var $ih7sC = parcelRequire("ih7sC");
const $4fe48fbe78cc0860$export$bc4d01c843cee95e = ({ isExpanded: isExpanded, queryRef: queryRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $eQU2i.default), queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const contents = isInitialSelectedPath((0, $h4Bzb.MENU_ID_OPERATIONS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iUGpu.OperationsMenuForLanding), {
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $70xty.OperationsMenuDefault), {
        isExpanded: isExpanded
    });
    if ((0, $7jTnu.fg)('operations_nav4_remaining_items')) /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih7sC.AlertsPopoutStoreContainer), {
        isGlobal: true
    }, contents);
    return contents;
};

});
parcelRegister("eQU2i", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fee22be20527b6a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3902b07ebd67a0b3cbf092c1d6ea3a35>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0fee22be20527b6a$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isOperationsExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Operations",
    "selections": [
        {
            "condition": "isOperationsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "OperationsMenuForLanding"
                }
            ]
        }
    ],
    "type": "Query"
};
$0fee22be20527b6a$var$node.hash = "1d297012078c362907ac313c8068c25a";
var $0fee22be20527b6a$export$2e2bcd8739ae039 = $0fee22be20527b6a$var$node;

});

parcelRegister("70xty", function(module, exports) {

$parcel$export(module.exports, "OperationsMenuDefault", () => $64a8751d864bf09b$export$ef19d9521d85a60a);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $if69u = parcelRequire("if69u");

var $hPlDs = parcelRequire("hPlDs");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");

var $iS6LA = parcelRequire("iS6LA");

var $5JDqh = parcelRequire("5JDqh");

var $ih7sC = parcelRequire("ih7sC");
function $64a8751d864bf09b$export$ef19d9521d85a60a(props) {
    const { isExpanded: isExpanded } = props;
    const cloudId = (0, $kEUB1.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $iS6LA.asyncAlertsContentViewQuery), entryPointParams);
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    const { state: { lastVisitedSearch: lastVisitedSearch }, setContent: setContent } = (0, $ih7sC.useAlertsPopoutStore)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (lastVisitedSearch && (0, $7jTnu.fg)('operations_nav4_remaining_items')) setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubject,
            // Required props for error JSErrorBoundary.
            id: "operations-menu-default",
            packageName: "jiraNavigationAppsSidebarNav4Operations",
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: "platform-united",
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: {
                ...entryPointParams,
                location: 'popOutPanel'
            }
        }));
    }, [
        entryPointParams,
        entryPointReferenceSubject,
        lastVisitedSearch,
        setContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5JDqh.OperationsExpandableMenuItem), {
        isExpanded: props.isExpanded,
        onSystemToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        triggerRef: triggerRef,
        AlertsMenuItemContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubject,
            // Required props for error JSErrorBoundary.
            id: "operations-menu-default",
            packageName: "jiraNavigationAppsSidebarNav4Operations",
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: "platform-united",
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
                ...entryPointParams,
                location: 'sidenav'
            } : entryPointParams
        })
    });
}

});
parcelRegister("iS6LA", function(module, exports) {

$parcel$export(module.exports, "asyncAlertsContentViewQuery", () => $aa406a9c2bfab3e5$export$182f7de76119e38a);

var $2Bhdi = parcelRequire("2Bhdi");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $aa406a9c2bfab3e5$export$182f7de76119e38a = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("kjmjr")).then(({ AlertsContentViewQuery: AlertsContentViewQuery })=>AlertsContentViewQuery), {
        moduleId: "4fcb17ab",
        moduleName: "AlertsContentViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryRef: {
                    parameters: $2Bhdi.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("2Bhdi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3057b2da4cf98574$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d8f87fd6efcb3b2793833812a581fd4f>>
 * @relayHash 539d81342bcb3bdab170556f3882c1e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1354395b89d1b40a39f597c3f378eb87813ab2626873be265cad98b57286915d
const $3057b2da4cf98574$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AlertsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "AlertsMenuItemContentNew"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "AlertsMenuItemContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AlertsContentViewQuery",
            "selections": [
                {
                    "concreteType": "OpsgenieQuery",
                    "kind": "LinkedField",
                    "name": "opsgenie",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "OpsgenieSavedSearches",
                            "kind": "LinkedField",
                            "name": "savedSearches",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "OpsgenieSavedSearch",
                                    "kind": "LinkedField",
                                    "name": "sharedWithMe",
                                    "plural": true,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "OpsgenieSavedSearch",
                                    "kind": "LinkedField",
                                    "name": "createdByMe",
                                    "plural": true,
                                    "selections": v1 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1354395b89d1b40a39f597c3f378eb87813ab2626873be265cad98b57286915d",
            "metadata": {},
            "name": "AlertsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3057b2da4cf98574$var$node.hash = "879968e67a244943ed377d7fb5da054d";
var $3057b2da4cf98574$export$2e2bcd8739ae039 = $3057b2da4cf98574$var$node;

});

parcelRegister("kjmjr", function(module, exports) {

let $ec96e3cdbe8ba55b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ec96e3cdbe8ba55b$var$load("9ye3N").then(()=>parcelRequire('24U8y'));

});


parcelRegister("5JDqh", function(module, exports) {

$parcel$export(module.exports, "OperationsExpandableMenuItem", () => $22c563c3801cdcdd$export$a04d9e9cc5ec19d3);

var $eJOHy = parcelRequire("eJOHy");

var $8oToa = parcelRequire("8oToa");

var $lers0 = parcelRequire("lers0");

var $eXXLY = parcelRequire("eXXLY");

var $d4QLY = parcelRequire("d4QLY");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");




var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $i0tMD = parcelRequire("i0tMD");

var $azEgq = parcelRequire("azEgq");

var $2QH3X = parcelRequire("2QH3X");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $kfvK2 = parcelRequire("kfvK2");

var $7jTnu = parcelRequire("7jTnu");

var $jn07M = parcelRequire("jn07M");

var $igYXn = parcelRequire("igYXn");

var $fAZgY = parcelRequire("fAZgY");

var $1Cl4r = parcelRequire("1Cl4r");

var $73hOC = parcelRequire("73hOC");

var $5rZKK = parcelRequire("5rZKK");

var $kG8Ic = parcelRequire("kG8Ic");

var $ih7sC = parcelRequire("ih7sC");
function $22c563c3801cdcdd$export$a04d9e9cc5ec19d3(props) {
    const isAlertsRoute = (0, $kfvK2.useIsActiveRoute)(new Set([
        (0, $jn07M.eocGlobalAlertListRoute).name,
        (0, $igYXn.eocTeamAlertDetailRoute).name
    ]));
    const { AlertsMenuItemContent: AlertsMenuItemContent, isExpanded: isExpanded, onExpansionToggle: onExpansionToggle, onSystemToggle: onSystemToggle, triggerRef: triggerRef } = props;
    const { hasReports: hasReports } = (0, $73hOC.useFeatures)();
    const { icon: alertsIcon, formattedMessage: alertsMessage } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $1Cl4r.default).alerts, (0, (/*@__PURE__*/$parcel$interopDefault($8oToa))));
    const { icon: overviewIcon, formattedMessage: overviewMessage } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $5rZKK.default).overview, (0, (/*@__PURE__*/$parcel$interopDefault($lers0))));
    const { icon: oncallSchedulesIcon, formattedMessage: oncallSchedulesMessage } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $5rZKK.default).onCallSchedules, (0, (/*@__PURE__*/$parcel$interopDefault($d4QLY))));
    const { icon: reportsIcon, formattedMessage: reportsMessage } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $5rZKK.default).reports, (0, (/*@__PURE__*/$parcel$interopDefault($eXXLY))));
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).OPERATIONS);
    const { icon: statusPageIcon, formattedMessage: statusPageMessage } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $5rZKK.default).statusPages, (0, (/*@__PURE__*/$parcel$interopDefault($eXXLY))));
    const { state: { lastVisitedSearch: lastVisitedSearch }, syncLastVisitedSearch: syncLastVisitedSearch } = (0, $ih7sC.useAlertsPopoutStore)();
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $7jTnu.fg)('operations_nav4_remaining_items')) syncLastVisitedSearch();
    }, [
        syncLastVisitedSearch
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const menuId = (0, $h4Bzb.MENU_ID_OPERATIONS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const onClickAlerts = (0, $fAZgY.useCallbackWithCondition)((_e, _a, { isExpanded: hasExpanded })=>{
        if (hasExpanded) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                itemId: 'alerts'
            }
        });
    }, [
        createAnalyticsEvent
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const alertsChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, lastVisitedSearch && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kG8Ic.PopoutToggleButton), null),
        elemBefore: alertsIcon,
        href: lastVisitedSearch,
        menuId: (0, $h4Bzb.MENU_ID_OPS_OVERVIEW)
    }, alertsMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        interactionName: (0, $7jTnu.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-operations-alerts' : undefined,
        actions: isAlertsRoute && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kG8Ic.PopoutToggleButton), null) : undefined,
        onClick: onClickAlerts,
        elemBefore: alertsIcon,
        testId: (0, $azEgq.getTestId)((0, $h4Bzb.MENU_ID_OPS_ALERTS))
    }, alertsMessage), !(lastVisitedSearch && (0, $7jTnu.fg)('operations_nav4_remaining_items')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, AlertsMenuItemContent));
    const handleOnExpansionToggle = (0, $fAZgY.useCallbackWithCondition)((hasExpanded)=>{
        if (hasExpanded) sendSectionItemAnalyticsEvent({
            menuId: (0, $8IuE5.L1_MENU_ID).OPERATIONS,
            sectionItem: (0, $a9aec.SECTION_ITEM_OPERATIONS)
        });
        onExpansionToggle?.(hasExpanded);
    }, [
        onExpansionToggle,
        sendSectionItemAnalyticsEvent
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const onClickOverview = (0, $fAZgY.useCallbackWithCondition)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                itemId: 'overview'
            }
        });
    }, [
        createAnalyticsEvent
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const onClickOnCallSchedules = (0, $fAZgY.useCallbackWithCondition)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                itemId: 'onCallSchedules'
            }
        });
    }, [
        createAnalyticsEvent
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const onClickReports = (0, $fAZgY.useCallbackWithCondition)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                itemId: 'reports'
            }
        });
    }, [
        createAnalyticsEvent
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: handleOnExpansionToggle,
        onSystemToggle: onSystemToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        interactionName: (0, $7jTnu.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-operations' : undefined,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kG8Ic.ActionButtons), null),
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $azEgq.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        elemBefore: overviewIcon,
        href: "/jira/ops/overview",
        menuId: (0, $h4Bzb.MENU_ID_OPS_OVERVIEW),
        onClick: onClickOverview
    }, overviewMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: (0, $h4Bzb.MENU_ID_OPS_ALERTS)
    }, alertsChildren), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        elemBefore: oncallSchedulesIcon,
        href: "/jira/ops/who-is-on-call",
        menuId: (0, $h4Bzb.MENU_ID_OPS_ON_CALL),
        onClick: onClickOnCallSchedules
    }, oncallSchedulesMessage), (0, $7jTnu.fg)('communications_status_page_manage_platform') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        elemBefore: statusPageIcon,
        href: "/jira/ops/status-page-manage",
        menuId: (0, $h4Bzb.MENU_ID_OPS_STATUS_PAGES)
    }, statusPageMessage), hasReports && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        elemBefore: reportsIcon,
        href: "/jira/ops/reports",
        menuId: (0, $h4Bzb.MENU_ID_OPS_REPORTS),
        onClick: onClickReports
    }, reportsMessage)));
}

});
parcelRegister("8oToa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76f067d08aa7c324d1505318ade2e26f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61db87b08d88be31$var$_react = $61db87b08d88be31$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $61db87b08d88be31$var$_baseNew = $61db87b08d88be31$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $61db87b08d88be31$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Alert".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for alerts in JSM and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61db87b08d88be31$var$AlertIcon = (props)=>/*#__PURE__*/ $61db87b08d88be31$var$_react.default.createElement($61db87b08d88be31$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 0v3h-1.5V0zM2.123 1.063 4.172 3.11 3.11 4.17 1.063 2.124zm12.814 1.06L12.89 4.172 11.83 3.11l2.047-2.048zM4.195 5.875A1.5 1.5 0 0 1 5.69 4.5h4.62a1.5 1.5 0 0 1 1.495 1.375l.635 7.625H14V15H2v-1.5h1.56zm.87 7.625h5.87L10.31 6H5.69z" clip-rule="evenodd"/>`
    }, props));
$61db87b08d88be31$var$AlertIcon.displayName = 'AlertIcon';
var $61db87b08d88be31$var$_default = module.exports.default = $61db87b08d88be31$var$AlertIcon;

});

parcelRegister("d4QLY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b34e6857b52d4ec156a688609aa0810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $985495a3876fe447$var$_react = $985495a3876fe447$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $985495a3876fe447$var$_baseNew = $985495a3876fe447$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $985495a3876fe447$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Phone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call us, phone number input.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $985495a3876fe447$var$PhoneIcon = (props)=>/*#__PURE__*/ $985495a3876fe447$var$_react.default.createElement($985495a3876fe447$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L4.29 7.86c.975 1.55 2.3 2.875 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 1 1.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM3.56 6.516 5.27 5.09a.25.25 0 0 0 .08-.261L4.684 2.5H2.525A11.4 11.4 0 0 0 3.56 6.516" clip-rule="evenodd"/>`
    }, props));
$985495a3876fe447$var$PhoneIcon.displayName = 'PhoneIcon';
var $985495a3876fe447$var$_default = module.exports.default = $985495a3876fe447$var$PhoneIcon;

});

parcelRegister("jn07M", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertListRoute", () => $b4a1382b4bc0e083$export$29721341dde2ed3d);
const $b4a1382b4bc0e083$export$29721341dde2ed3d = {
    name: 'eoc-global-alerts',
    path: '/jira/ops/alerts',
    exact: true
};

});

parcelRegister("igYXn", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertDetailRoute", () => $8561130b2d4adb16$export$ac102dc13a0f4aff);
const $8561130b2d4adb16$export$ac102dc13a0f4aff = {
    name: 'eoc-team-alert-detail',
    path: '/jira/ops/teams/:teamId/alerts/:id',
    exact: true
};

});

parcelRegister("1Cl4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $f32e43648f7339d4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f32e43648f7339d4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    alerts: {
        "id": "navigation-apps-sidebar-nav4-operations.alerts",
        "defaultMessage": "Alerts"
    }
});

});

parcelRegister("73hOC", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $0a2af14ce88ae59f$export$4a39035bacc4ed76);

var $aGdf8 = parcelRequire("aGdf8");

var $gDXSd = parcelRequire("gDXSd");


var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");

var $gZTP9 = parcelRequire("gZTP9");

var $lUto7 = parcelRequire("lUto7");

var $b9nqM = parcelRequire("b9nqM");
const $0a2af14ce88ae59f$export$4a39035bacc4ed76 = ()=>{
    const { isByokCustomer: isByokCustomer } = (0, $aGdf8.useByokComplianceSettingWithInitialisation)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const { shouldUseJSM: shouldUseJSM, loading: ogTenantInfoLoading } = (0, $gDXSd.useOgTenantInfo)();
    const appEditions = (0, $8vyDv.useAppEditions)();
    const hasReports = !ogTenantInfoLoading && (isSiteAdmin || isAdmin) && !isByokCustomer && shouldUseJSM && !!licensedProducts[0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61] && appEditions.serviceDesk !== (0, $a9ldn.FREE_EDITION);
    return {
        hasReports: hasReports
    };
};

});
parcelRegister("gDXSd", function(module, exports) {

$parcel$export(module.exports, "useOgTenantInfo", () => $e758b04b403662eb$export$990ea9ff15ca04f7);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $4VIcO = parcelRequire("4VIcO");

var $iW0U8 = parcelRequire("iW0U8");

var $eJrcF = parcelRequire("eJrcF");

var $dI30d = parcelRequire("dI30d");
/**
 * This hook is used to refresh the tenant info resource when the server side
 * rendering fails due to an error or never actually happens.
 */ const $e758b04b403662eb$var$useConsolidationStateResourceRefresh = (tenantInfoResource)=>{
    // It is important that this ff should stop any new behaviour except for
    // safe hook calls. That's why we only do very minimal stuff here.
    const { data: data, loading: loading, refresh: refresh } = tenantInfoResource;
    const isRefreshed = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $7jTnu.fg)('refresh_tenant_info_on_client_for_ssr_error') && data === null && loading === false && isRefreshed.current === false) {
            refresh();
            isRefreshed.current = true;
        }
    }, [
        data,
        loading,
        refresh
    ]);
};
const $e758b04b403662eb$export$990ea9ff15ca04f7 = ()=>{
    const tenantInfoResource = (0, $eJrcF.useResource)((0, $4VIcO.getConsolidationStateResource)());
    const applicationPermissions = (0, $iW0U8.useApplicationPermissions)();
    $e758b04b403662eb$var$useConsolidationStateResourceRefresh(tenantInfoResource);
    if (// TODO: Remove this check after the feature flag is removed
    // The refresh is handled in useConsolidationStateResourceRefresh
    // and this one is only for the old behaviour.
    !(0, $7jTnu.fg)('refresh_tenant_info_on_client_for_ssr_error') && tenantInfoResource.data === null && tenantInfoResource.loading === false && tenantInfoResource.error === null) tenantInfoResource.refresh();
    return {
        loading: tenantInfoResource.loading,
        error: tenantInfoResource.error,
        shouldUseJSM: (0, $dI30d.checkShouldUseJSM)(tenantInfoResource.data),
        isConsolidated: (0, $dI30d.checkIsConsolidated)(tenantInfoResource.data),
        isOpsAdmin: (0, $7jTnu.fg)('operations-tenant-info-endpoint-update') && (0, $dI30d.checkIsOpsAdmin)(tenantInfoResource.data),
        isTransitioning: (0, $dI30d.checkIsTransitioning)(tenantInfoResource.data),
        isTransitioned: (0, $dI30d.checkIsTransitioned)(tenantInfoResource.data),
        isTransitionEligible: applicationPermissions.hasServiceDeskAccess && (0, $dI30d.checkIsTransitionEligible)(tenantInfoResource.data),
        shouldAccessUnlockOperations: applicationPermissions.hasServiceDeskAccess && (0, $dI30d.checkShouldAccessUnlockOperations)(tenantInfoResource.data),
        cohort: typeof tenantInfoResource.data === 'string' ? undefined : tenantInfoResource.data?.cohortInfo
    };
};

});


parcelRegister("5rZKK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbeef9b012ab94c7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bbeef9b012ab94c7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    overview: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.overview",
        "defaultMessage": "Overview"
    },
    alerts: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts",
        "defaultMessage": "Alerts"
    },
    onCallSchedules: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.on-call-schedules",
        "defaultMessage": "On-call schedules"
    },
    generalConfiguration: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.general-configuration",
        "defaultMessage": "General configuration"
    },
    reports: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.reports",
        "defaultMessage": "Reports"
    },
    defaultFilters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.default-filters",
        "defaultMessage": "Default filters"
    },
    sharedWithMe: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.shared-with-me",
        "defaultMessage": "Shared with me"
    },
    createdByMe: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.created-by-me",
        "defaultMessage": "Created by me"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.starred",
        "defaultMessage": "Starred"
    },
    allAlerts: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.all-alerts",
        "defaultMessage": "All alerts"
    },
    myAlerts: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.my-alerts",
        "defaultMessage": "My alerts"
    },
    viewAllFiltersPopupMenuButtonText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.view-all-filters-popup-menu-button-text",
        "defaultMessage": "View all"
    },
    viewAllFiltersSearchPlaceholder: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.view-all-filters-search-placeholder",
        "defaultMessage": "Search"
    },
    viewAllFiltersNoResultsFoundText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.view-all-filters-no-results-found-text",
        "defaultMessage": "No search results found"
    },
    allSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.all-search",
        "defaultMessage": "All"
    },
    openSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.open-search",
        "defaultMessage": "Open"
    },
    closedSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.closed-search",
        "defaultMessage": "Closed"
    },
    unackedSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.unacked-search",
        "defaultMessage": "Unacknowledged"
    },
    notSeenSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.not-seen-search",
        "defaultMessage": "Not seen"
    },
    assignedToMeSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.assigned-to-me-search",
        "defaultMessage": "Assigned to me"
    },
    statusPages: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.status-pages",
        "defaultMessage": "Status pages"
    }
});

});

parcelRegister("kG8Ic", function(module, exports) {

$parcel$export(module.exports, "ActionButtons", () => $df8b828fd54e6f26$export$88c65d2d98aab183);
$parcel$export(module.exports, "PopoutToggleButton", () => $df8b828fd54e6f26$export$a9edf85e3b30c33a);

var $eJOHy = parcelRequire("eJOHy");

var $ejfxj = parcelRequire("ejfxj");

var $apGPk = parcelRequire("apGPk");
var $7R1al = parcelRequire("7R1al");

var $9JB3T = parcelRequire("9JB3T");

var $4BzUI = parcelRequire("4BzUI");

var $gDXSd = parcelRequire("gDXSd");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");





var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");


var $lvKO5 = parcelRequire("lvKO5");

var $kfvK2 = parcelRequire("kfvK2");

var $6naEG = parcelRequire("6naEG");

var $5DCnD = parcelRequire("5DCnD");

var $8rgh1 = parcelRequire("8rgh1");

var $ih7sC = parcelRequire("ih7sC");
function $df8b828fd54e6f26$export$88c65d2d98aab183({ onClose: onClose }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const handleNavMenuOpen = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: (0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton') ? handleNavMenuOpen : ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6),
                actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                    level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                    itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e)
                }
            });
        },
        MenuItems: $df8b828fd54e6f26$var$MoreMenuItems,
        onClose: onClose
    });
}
function $df8b828fd54e6f26$var$MoreMenuItems({ onClose: onClose }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onCloseWithStopPropagation = (0, $6naEG.useStopPropagation)((event)=>{
        onClose?.(event);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                itemId: 'generalConfiguration',
                parentItemId: (0, $a9aec.SECTION_ITEM_OPERATIONS)
            }
        });
    });
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { isOpsAdmin: isOpsAdmin } = (0, $gDXSd.useOgTenantInfo)();
    const shouldShowGeneralConfiguration = (0, $7jTnu.fg)('operations-tenant-info-endpoint-update') ? (tenantContext.isAdmin || isOpsAdmin) && tenantContext.licensedProducts[0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61] : tenantContext.isAdmin && tenantContext.licensedProducts[0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, shouldShowGeneralConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apGPk.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ejfxj))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/jira/settings/products/ops/jira-service-management-audit-logs",
        onClick: onCloseWithStopPropagation
    }, formatMessage((0, $8rgh1.default).generalConfiguration))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).OPERATIONS,
        hasSeparator: shouldShowGeneralConfiguration
    }));
}
const $df8b828fd54e6f26$var$usePath = (0, $kfvK2.createRouterSelector)((state)=>`${state.location.pathname}${state.location.search}`);
const $df8b828fd54e6f26$export$a9edf85e3b30c33a = ({ onClick: onClick })=>{
    const { state: { lastVisitedSearch: lastVisitedSearch }, togglePoppedOut: togglePoppedOut } = (0, $ih7sC.useAlertsPopoutStore)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const path = $df8b828fd54e6f26$var$usePath();
    const handleToggle = (_, analyticsEvent)=>{
        onClick?.();
        if ((0, $7jTnu.fg)('operations_nav4_remaining_items')) {
            togglePoppedOut(path);
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'jsmOperationsAlertsPopoutButtonToggle', {
                isPoppedOut: lastVisitedSearch
            });
        }
    };
    const iconButtonLabel = lastVisitedSearch ? formatMessage((0, $8rgh1.default).popInLabel) : formatMessage((0, $8rgh1.default).popOutLabel);
    const tooltipContent = lastVisitedSearch ? formatMessage((0, $8rgh1.default).popInTooltip) : formatMessage((0, $8rgh1.default).popOutTooltip);
    const Icon = lastVisitedSearch ? (0, $5DCnD.PopinIcon) : (0, $5DCnD.PopoutIcon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: tooltipContent
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BzUI.default), {
            ...tooltipProps,
            label: iconButtonLabel,
            onClick: handleToggle,
            icon: Icon,
            spacing: "compact",
            appearance: "subtle"
        }));
};

});
parcelRegister("5DCnD", function(module, exports) {

$parcel$export(module.exports, "PopoutIcon", () => $93c1416fae8a9416$export$a837275bb5fcc92e);
$parcel$export(module.exports, "PopinIcon", () => $93c1416fae8a9416$export$5b106f296c88ef0);

var $eJOHy = parcelRequire("eJOHy");

var $aCmsU = parcelRequire("aCmsU");

var $lRq8t = parcelRequire("lRq8t");

var $5O9Jh = parcelRequire("5O9Jh");
const $93c1416fae8a9416$var$PoputGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 4L19.25 4C19.4489 4 19.6397 4.07902 19.7803 4.21967C19.921 4.36032 20 4.55109 20 4.75V9H18.5V6.56066L15.0303 10.0303L13.9697 8.96967L17.4393 5.5L15 5.5V4ZM7 7.5C6.72386 7.5 6.5 7.72386 6.5 8L6.5 10.5H11.5C12.6046 10.5 13.5 11.3954 13.5 12.5L13.5 17.5H16C16.2761 17.5 16.5 17.2761 16.5 17V12H18V17C18 18.1046 17.1046 19 16 19H12.7512C12.7508 19 12.7504 19 12.75 19L7 19C5.89543 19 5 18.1046 5 17L5 11.25C5 11.2498 5 11.2497 5 11.2495L5 8C5 6.89543 5.89543 6 7 6L12 6V7.5L7 7.5ZM7 17.5L12 17.5L12 12.5C12 12.2239 11.7761 12 11.5 12H6.5L6.5 17C6.5 17.2761 6.72386 17.5 7 17.5Z"
    }));
const $93c1416fae8a9416$var$PopinGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 4L18 4C19.1046 4 20 4.89543 20 6V10C20 11.1046 19.1046 12 18 12H14C13.7229 12 13.4589 11.9436 13.2189 11.8417L11.0607 14H13.5V15.5H9.25C8.83579 15.5 8.5 15.1642 8.5 14.75L8.5 10.5H10L10 12.9393L12.1583 10.7811C12.0564 10.5411 12 10.2771 12 10V6C12 4.89543 12.8954 4 14 4ZM18 5.5L14 5.5C13.7239 5.5 13.5 5.72386 13.5 6V10C13.5 10.2761 13.7239 10.5 14 10.5H18C18.2761 10.5 18.5 10.2761 18.5 10V6C18.5 5.72386 18.2761 5.5 18 5.5ZM7 6L10 6V7.5H7C6.72386 7.5 6.5 7.72386 6.5 8L6.5 17C6.5 17.2761 6.72386 17.5 7 17.5L16 17.5C16.2761 17.5 16.5 17.2761 16.5 17V14H18V17C18 18.1046 17.1046 19 16 19L7 19C5.89543 19 5 18.1046 5 17L5 8C5 6.89543 5.89543 6 7 6Z"
    }));
const $93c1416fae8a9416$export$a837275bb5fcc92e = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aCmsU.default), {
        glyph: $93c1416fae8a9416$var$PoputGlyph,
        label: formatMessage((0, $5O9Jh.messages).popoutIconLabel)
    });
};
const $93c1416fae8a9416$export$5b106f296c88ef0 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aCmsU.default), {
        glyph: $93c1416fae8a9416$var$PopinGlyph,
        label: formatMessage((0, $5O9Jh.messages).popinIconLabel)
    });
};

});
parcelRegister("5O9Jh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $372ba0bd810eef72$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $372ba0bd810eef72$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    popoutIconLabel: {
        "id": "servicedesk-queues-nav4.common.popout-toggle-button.icons.popout-icon-label",
        "defaultMessage": "Pop out icon"
    },
    popinIconLabel: {
        "id": "servicedesk-queues-nav4.common.popout-toggle-button.icons.popin-icon-label",
        "defaultMessage": "Pop in icon"
    }
});

});


parcelRegister("8rgh1", function(module, exports) {

$parcel$export(module.exports, "default", () => $18062289ae5e8932$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $18062289ae5e8932$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    generalConfiguration: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.general-configuration",
        "defaultMessage": "General configuration"
    },
    popOutLabel: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-out-label",
        "defaultMessage": "Pop out operations alert searches"
    },
    popOutTooltip: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-out-tooltip",
        "defaultMessage": "Pop out from sidebar"
    },
    popInLabel: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-in-label",
        "defaultMessage": "Pop in operations alert searches"
    },
    popInTooltip: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-in-tooltip",
        "defaultMessage": "Move back to sidebar"
    }
});

});

parcelRegister("ih7sC", function(module, exports) {

$parcel$export(module.exports, "AlertsPopoutStoreContainer", () => $a7d00ec95bd37dbc$export$c37792f744809959);
$parcel$export(module.exports, "useAlertsPopoutStore", () => $a7d00ec95bd37dbc$export$f89494880a713101);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $dnU6V = parcelRequire("dnU6V");
const $a7d00ec95bd37dbc$var$LOCAL_STORAGE_KEY_LAST_VISITED_SEARCH = 'jira-ops-alert-filters-last-visited-search';
const $a7d00ec95bd37dbc$var$localStorageProvider = (0, $dnU6V.createLocalStorageProvider)('alert_filters_popout');
const $a7d00ec95bd37dbc$var$setAlertFiltersLastVisitedInLocalStorage = (value)=>{
    try {
        $a7d00ec95bd37dbc$var$localStorageProvider.set($a7d00ec95bd37dbc$var$LOCAL_STORAGE_KEY_LAST_VISITED_SEARCH, value);
    } catch (_) {
        return false;
    }
    return true;
};
const $a7d00ec95bd37dbc$var$getAlertFiltersLastVisitedFromLocalStorage = ()=>{
    let item;
    try {
        item = $a7d00ec95bd37dbc$var$localStorageProvider.get($a7d00ec95bd37dbc$var$LOCAL_STORAGE_KEY_LAST_VISITED_SEARCH);
    } catch (_) {
        return undefined;
    }
    return item;
};
const $a7d00ec95bd37dbc$var$getOnInit = ()=>{
    return {
        lastVisitedSearch: $a7d00ec95bd37dbc$var$getAlertFiltersLastVisitedFromLocalStorage()
    };
};
const $a7d00ec95bd37dbc$var$actions = {
    setLastVisitedSearch: (value)=>({ getState: getState, setState: setState })=>{
            if (getState().lastVisitedSearch) {
                setState({
                    ...getState(),
                    lastVisitedSearch: value
                });
                $a7d00ec95bd37dbc$var$setAlertFiltersLastVisitedInLocalStorage(value);
            }
        },
    togglePoppedOut: (value)=>({ getState: getState, setState: setState })=>{
            if (!getState().lastVisitedSearch) {
                setState({
                    ...getState(),
                    lastVisitedSearch: value
                });
                $a7d00ec95bd37dbc$var$setAlertFiltersLastVisitedInLocalStorage(value);
            } else {
                setState({
                    ...getState(),
                    lastVisitedSearch: null
                });
                $a7d00ec95bd37dbc$var$setAlertFiltersLastVisitedInLocalStorage(null);
            }
        },
    syncLastVisitedSearch: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                lastVisitedSearch: $a7d00ec95bd37dbc$var$getAlertFiltersLastVisitedFromLocalStorage()
            });
        },
    setContent: (content)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                content: content
            });
        }
};
const $a7d00ec95bd37dbc$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        content: null,
        lastVisitedSearch: ' '
    },
    actions: $a7d00ec95bd37dbc$var$actions,
    name: 'AlertsPopoutStore'
});
const $a7d00ec95bd37dbc$export$c37792f744809959 = (0, $6E16M.createContainer)($a7d00ec95bd37dbc$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState($a7d00ec95bd37dbc$var$getOnInit());
        }
});
const $a7d00ec95bd37dbc$var$useHook = (0, $iJq0l.createHook)($a7d00ec95bd37dbc$var$Store);
const $a7d00ec95bd37dbc$export$f89494880a713101 = ()=>{
    const [state, hookActions] = $a7d00ec95bd37dbc$var$useHook();
    return {
        state: state,
        ...hookActions
    };
};

});




parcelRegister("iUGpu", function(module, exports) {

$parcel$export(module.exports, "OperationsMenuForLanding", () => $413ecd110b26d409$export$b37dd5cf3b893940);

var $emr2v = parcelRequire("emr2v");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $16sa1 = parcelRequire("16sa1");

var $f5a85 = parcelRequire("f5a85");

var $5JDqh = parcelRequire("5JDqh");

var $dzn9I = parcelRequire("dzn9I");

var $ih7sC = parcelRequire("ih7sC");
const $413ecd110b26d409$export$b37dd5cf3b893940 = ({ isExpanded: isExpanded, queryRef: queryRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $emr2v.default), queryRef);
    const { state: { lastVisitedSearch: lastVisitedSearch }, setContent: setContent } = (0, $ih7sC.useAlertsPopoutStore)();
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $7jTnu.fg)('operations_nav4_remaining_items') ? lastVisitedSearch : false) setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5a85.AlertsMenuItemContent), {
            queryRef: data
        }));
        if (!(0, $7jTnu.fg)('operations_nav4_remaining_items')) return ()=>{
            setContent(null);
        };
    }, [
        data,
        lastVisitedSearch,
        setContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4-sidebar-operations-trigger-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5JDqh.OperationsExpandableMenuItem), {
        isExpanded: isExpanded,
        AlertsMenuItemContent: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
            name: "nav4-sidebar-operations-expanded-items"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzn9I.AlertsMenuItemContentNew), {
            queryRef: data
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5a85.AlertsMenuItemContent), {
            queryRef: data
        })
    }));
};

});
parcelRegister("emr2v", function(module, exports) {

$parcel$export(module.exports, "default", () => $411580bc907501fc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4581c0468a5d4ef30519c5609a70ff06>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $411580bc907501fc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "OperationsMenuForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "AlertsMenuItemContentNew"
        },
        {
            "kind": "FragmentSpread",
            "name": "AlertsMenuItemContent"
        }
    ],
    "type": "Query"
};
$411580bc907501fc$var$node.hash = "539a9dffb7945e99bc6a650607eca8e4";
var $411580bc907501fc$export$2e2bcd8739ae039 = $411580bc907501fc$var$node;

});

parcelRegister("f5a85", function(module, exports) {

$parcel$export(module.exports, "AlertsMenuItemContent", () => $83e5ea77dd60932b$export$fcbb0679bb6c6da1);

var $bwwrE = parcelRequire("bwwrE");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $dNSuS = parcelRequire("dNSuS");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $7jTnu = parcelRequire("7jTnu");

var $5qy8V = parcelRequire("5qy8V");

var $lRq8t = parcelRequire("lRq8t");




var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $aLENQ = parcelRequire("aLENQ");

var $dpxw4 = parcelRequire("dpxw4");

var $lvrbL = parcelRequire("lvrbL");

var $i0tMD = parcelRequire("i0tMD");

var $azEgq = parcelRequire("azEgq");

var $2QH3X = parcelRequire("2QH3X");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $8q7lT = parcelRequire("8q7lT");

var $16sa1 = parcelRequire("16sa1");

var $95O7y = parcelRequire("95O7y");

var $c6ZDX = parcelRequire("c6ZDX");

var $1Cl4r = parcelRequire("1Cl4r");

var $5rZKK = parcelRequire("5rZKK");

var $ih7sC = parcelRequire("ih7sC");

var $3y8cO = parcelRequire("3y8cO");
function $83e5ea77dd60932b$export$fcbb0679bb6c6da1({ queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $bwwrE.default), queryRef);
    const [selectedFilter, setSelectedFilter] = (0, $eJOHy.useState)('');
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const { sharedWithMe: sharedWithMe, createdByMe: createdByMe } = data?.opsgenie?.savedSearches || {};
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const accountId = (0, $8q7lT.useAccountId)();
    const [savedSearchIdFromURL] = (0, $95O7y.useQueryParam)('filter');
    const [viewType] = (0, $95O7y.useQueryParam)('view');
    const { icon: pagesIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $1Cl4r.default).alerts, (0, (/*@__PURE__*/$parcel$interopDefault($dNSuS))));
    const { setLastVisitedSearch: setLastVisitedSearch } = (0, $ih7sC.useAlertsPopoutStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const defaultFilters = [
        {
            id: 'all',
            name: formatMessage((0, $5rZKK.default).allSearch),
            alertSearchQuery: ''
        },
        {
            id: 'open',
            name: formatMessage((0, $5rZKK.default).openSearch),
            alertSearchQuery: `${(0, $5qy8V.IDENTIFIER_STATUS)}${(0, $5qy8V.OPERATOR_EQUAL_TO)} ${(0, $5qy8V.STRING_LITERAL_STATUS_OPEN)}`
        },
        {
            id: 'closed',
            name: formatMessage((0, $5rZKK.default).closedSearch),
            alertSearchQuery: `${(0, $5qy8V.IDENTIFIER_STATUS)}${(0, $5qy8V.OPERATOR_EQUAL_TO)} ${(0, $5qy8V.STRING_LITERAL_STATUS_CLOSED)}`
        },
        {
            id: 'unacked',
            name: formatMessage((0, $5rZKK.default).unackedSearch),
            alertSearchQuery: `${(0, $5qy8V.IDENTIFIER_STATUS)}${(0, $5qy8V.OPERATOR_EQUAL_TO)} ${(0, $5qy8V.STRING_LITERAL_STATUS_OPEN)} ${(0, $5qy8V.LOGICAL_OPERATOR_AND)} ${(0, $5qy8V.IDENTIFIER_ACKNOWLEDGED)}${(0, $5qy8V.OPERATOR_EQUAL_TO)} ${(0, $5qy8V.BOOLEAN_LITERAL_FALSE)}`
        },
        {
            id: 'notSeen',
            name: formatMessage((0, $5rZKK.default).notSeenSearch),
            alertSearchQuery: `${(0, $5qy8V.IDENTIFIER_IS_SEEN)}${(0, $5qy8V.OPERATOR_EQUAL_TO)} ${(0, $5qy8V.BOOLEAN_LITERAL_FALSE)}`
        },
        {
            id: 'assignedToMe',
            name: formatMessage((0, $5rZKK.default).assignedToMeSearch),
            alertSearchQuery: `${(0, $5qy8V.IDENTIFIER_ASSIGNEE)}${(0, $5qy8V.OPERATOR_EQUAL_TO)} "${accountId || 'me'}"`
        }
    ];
    const defaultFilterMenuIds = $83e5ea77dd60932b$var$getParentMenuId(defaultFilters);
    const sharedWithMeMenuIds = $83e5ea77dd60932b$var$getParentMenuId(sharedWithMe, savedSearchIdFromURL);
    const createdByMeMenuIds = $83e5ea77dd60932b$var$getParentMenuId(createdByMe, savedSearchIdFromURL);
    (0, $eJOHy.useEffect)(()=>{
        if (!isSelectedPath((0, $h4Bzb.MENU_ID_OPS_ALERTS)) && selectedFilter !== '') setSelectedFilter('');
    }, [
        isSelectedPath,
        selectedFilter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4.sidebar.operations.alerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: defaultFilterMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                    level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                    itemId: 'defaultFilters',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        testId: (0, $azEgq.getTestId)(defaultFilterMenuIds),
        interactionName: (0, $7jTnu.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-operations-alerts' : undefined
    }, formatMessage((0, $5rZKK.default).defaultFilters)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, defaultFilters.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            key: item.id,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`,
            menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter(item.id);
                if ((0, $7jTnu.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}${item.alertSearchQuery ? `&query=${item.alertSearchQuery}` : ''}`);
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                        level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        parentItemId: 'defaultFilters',
                        itemType: 'defaultFilter'
                    }
                });
            }
        }, item.name)))), sharedWithMe && sharedWithMe.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: sharedWithMeMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                    level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                    itemId: 'sharedWithMe',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        testId: (0, $azEgq.getTestId)(sharedWithMeMenuIds),
        interactionName: (0, $7jTnu.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-operations-alerts-shared-with-me' : undefined
    }, formatMessage((0, $5rZKK.default).sharedWithMe), sharedWithMe.some((filter)=>isSelectedPath(filter.alertSearchQuery))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, sharedWithMe.map((item)=>{
        if ((0, $7jTnu.fg)('operations_nav4_remaining_items')) {
            const savedSearchId = item.id ? (0, $c6ZDX.OpsgenieSavedSearchAri).parse(item.id).savedSearchId : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
                key: item.id,
                elemBefore: pagesIcon,
                href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`,
                menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(savedSearchIdFromURL ? savedSearchId : item.alertSearchQuery),
                onClick: ()=>{
                    setSelectedFilter('');
                    if ((0, $7jTnu.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`);
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                        action: 'clicked',
                        actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                        actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                        attributes: {
                            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
                            level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                            itemId: item.id,
                            itemType: 'savedSearch',
                            parentItemId: 'sharedWithMe'
                        }
                    });
                }
            }, item.name);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`,
            key: item.id,
            menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter('');
                if ((0, $7jTnu.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`);
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
                        level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        itemType: 'savedSearch',
                        parentItemId: 'sharedWithMe'
                    }
                });
            }
        }, item.name);
    }))), createdByMe && createdByMe.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: createdByMeMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                    level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                    itemId: 'createdByMe',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        testId: (0, $azEgq.getTestId)(createdByMeMenuIds)
    }, formatMessage((0, $5rZKK.default).createdByMe)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, createdByMe.map((item)=>{
        if ((0, $7jTnu.fg)('operations_nav4_remaining_items')) {
            const savedSearchId = item.id ? (0, $c6ZDX.OpsgenieSavedSearchAri).parse(item.id).savedSearchId : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
                key: item.id,
                elemBefore: pagesIcon,
                href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`,
                menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(savedSearchIdFromURL ? savedSearchId : item.alertSearchQuery),
                onClick: ()=>{
                    setSelectedFilter('');
                    if ((0, $7jTnu.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${item.id ? `&filter=${savedSearchId}` : ''}`);
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                        action: 'clicked',
                        actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                        actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                        attributes: {
                            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
                            level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                            itemId: item.id,
                            itemType: 'savedSearch',
                            parentItemId: 'createdByMe'
                        }
                    });
                },
                actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3y8cO.SavedSearchActionButtons), {
                    savedSearch: item
                })
            }, item.name);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`,
            key: item.id,
            menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter('');
                if ((0, $7jTnu.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(`/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`);
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
                        level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        itemType: 'savedSearch',
                        parentItemId: 'createdByMe'
                    }
                });
            },
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3y8cO.SavedSearchActionButtons), {
                savedSearch: item
            })
        }, item.name);
    }))));
}
function $83e5ea77dd60932b$var$getParentMenuId(arr, savedSearchId) {
    return (0, $aLENQ.toMenuIdFromMenuIdList)((arr || []).map((i)=>(0, $7jTnu.fg)('operations_nav4_remaining_items') ? (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(savedSearchId ? (0, $c6ZDX.OpsgenieSavedSearchAri).parse(i.id).savedSearchId : i.alertSearchQuery) : (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(i.alertSearchQuery)));
}

});
parcelRegister("bwwrE", function(module, exports) {

$parcel$export(module.exports, "default", () => $84745fac6227ed20$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d1bb40d3f14284ac71e150506c3a9894>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $84745fac6227ed20$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    }, v2 = {
        "kind": "ScalarField",
        "name": "alertSearchQuery"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "AlertsMenuItemContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "OpsgenieQuery",
                    "kind": "LinkedField",
                    "name": "opsgenie",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "OpsgenieSavedSearches",
                                "kind": "LinkedField",
                                "name": "savedSearches",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "opsgenie.savedSearches.sharedWithMe"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "LOG",
                                        "path": "opsgenie.savedSearches.createdByMe"
                                    }
                                ]
                            },
                            "action": "LOG",
                            "path": "opsgenie.savedSearches"
                        }
                    ]
                },
                "action": "LOG",
                "path": "opsgenie"
            }
        ],
        "type": "Query"
    };
}();
$84745fac6227ed20$var$node.hash = "a105f985be669906c4ceff76a45b11bc";
var $84745fac6227ed20$export$2e2bcd8739ae039 = $84745fac6227ed20$var$node;

});

parcelRegister("dNSuS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff4cd926156d74fe58acdf2d87dd6f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0ca1ff31fcc6a03$var$_react = $a0ca1ff31fcc6a03$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a0ca1ff31fcc6a03$var$_baseNew = $a0ca1ff31fcc6a03$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $a0ca1ff31fcc6a03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0ca1ff31fcc6a03$var$PagesIcon = (props)=>/*#__PURE__*/ $a0ca1ff31fcc6a03$var$_react.default.createElement($a0ca1ff31fcc6a03$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$a0ca1ff31fcc6a03$var$PagesIcon.displayName = 'PagesIcon';
var $a0ca1ff31fcc6a03$var$_default = module.exports.default = $a0ca1ff31fcc6a03$var$PagesIcon;

});

parcelRegister("5qy8V", function(module, exports) {

$parcel$export(module.exports, "TOKEN_TYPES", () => $94348a923c5baf97$export$e92b897d610f2aba);
$parcel$export(module.exports, "LEFT_PARENTHESIS", () => $94348a923c5baf97$export$9ce7f372949a1546);
$parcel$export(module.exports, "RIGHT_PARENTHESIS", () => $94348a923c5baf97$export$bbbb3f477a9839e0);
$parcel$export(module.exports, "OPERATOR_EQUAL_TO", () => $94348a923c5baf97$export$ea7497008076d6d2);
$parcel$export(module.exports, "OPERATOR_GROUP_FOR_ASSISTANT", () => $94348a923c5baf97$export$e75c84803c67e1f4);
$parcel$export(module.exports, "LOGICAL_OPERATOR_AND", () => $94348a923c5baf97$export$61308b2610174a70);
$parcel$export(module.exports, "LOGICAL_OPERATOR_OR", () => $94348a923c5baf97$export$1de654320eb3e523);
$parcel$export(module.exports, "BOOLEAN_LITERAL_TRUE", () => $94348a923c5baf97$export$ff7eed6ac2251302);
$parcel$export(module.exports, "BOOLEAN_LITERAL_FALSE", () => $94348a923c5baf97$export$4b436fec6f13b741);
$parcel$export(module.exports, "BOOLEAN_LITERAL_GROUP", () => $94348a923c5baf97$export$8cbc171ac4843075);
$parcel$export(module.exports, "STRING_LITERAL_DOUBLE_QUOTE", () => $94348a923c5baf97$export$347c7cb6285a1d61);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_OPEN", () => $94348a923c5baf97$export$910131ff5cd3d496);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_CLOSED", () => $94348a923c5baf97$export$2aa0d26cb4549272);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_ACKED", () => $94348a923c5baf97$export$572cec90aa166025);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_SNOOZED", () => $94348a923c5baf97$export$f94109650ec67751);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_GROUP", () => $94348a923c5baf97$export$3a3a37e9da45a2a4);
$parcel$export(module.exports, "STRING_LITERAL_PRIORITY_GROUP", () => $94348a923c5baf97$export$9ef3f42fa10fce44);
$parcel$export(module.exports, "NULL_LITERAL", () => $94348a923c5baf97$export$c2b6d31a7a2d40ba);
$parcel$export(module.exports, "IDENTIFIER_ALIAS", () => $94348a923c5baf97$export$21c480ed86e9d13);
$parcel$export(module.exports, "IDENTIFIER_CLOSED_BY", () => $94348a923c5baf97$export$534c195089710c34);
$parcel$export(module.exports, "IDENTIFIER_DEDUPLICATION", () => $94348a923c5baf97$export$4699ad3805947d4d);
$parcel$export(module.exports, "IDENTIFIER_ENTITY", () => $94348a923c5baf97$export$2a30b5099ba66c99);
$parcel$export(module.exports, "IDENTIFIER_IS_SEEN", () => $94348a923c5baf97$export$7926b4c2836db847);
$parcel$export(module.exports, "IDENTIFIER_MESSAGE", () => $94348a923c5baf97$export$5a8895646b1d5248);
$parcel$export(module.exports, "IDENTIFIER_ASSIGNEE", () => $94348a923c5baf97$export$4047502bdab1e205);
$parcel$export(module.exports, "IDENTIFIER_PRIORITY", () => $94348a923c5baf97$export$5922c06b76ebb57d);
$parcel$export(module.exports, "IDENTIFIER_COMPONENTS", () => $94348a923c5baf97$export$1122634b5d555f05);
$parcel$export(module.exports, "IDENTIFIER_SERVICES", () => $94348a923c5baf97$export$ec912454cd7d858a);
$parcel$export(module.exports, "IDENTIFIER_RESPONDERS", () => $94348a923c5baf97$export$44673ddac1790242);
$parcel$export(module.exports, "IDENTIFIER_SOURCE", () => $94348a923c5baf97$export$f250d53474e801dc);
$parcel$export(module.exports, "IDENTIFIER_STATUS", () => $94348a923c5baf97$export$43181828ba8680e4);
$parcel$export(module.exports, "IDENTIFIER_TAG", () => $94348a923c5baf97$export$8242733866920892);
$parcel$export(module.exports, "IDENTIFIER_TINY_ID", () => $94348a923c5baf97$export$c833829cf31052f0);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED", () => $94348a923c5baf97$export$5f1e5c89a704810f);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED_BY", () => $94348a923c5baf97$export$89d93eb7117999c0);
$parcel$export(module.exports, "IDENTIFIER_TEAMS", () => $94348a923c5baf97$export$a79eb1864dd7b745);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALERT", () => $94348a923c5baf97$export$888a9cda49b5e18c);
$parcel$export(module.exports, "IDENTIFIER_BOOLEAN_GROUP", () => $94348a923c5baf97$export$60745b712d37edf9);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALL", () => $94348a923c5baf97$export$b38df7dc61d42293);
$parcel$export(module.exports, "splitToTokensRegex", () => $94348a923c5baf97$export$28041d1d2a85f002);
$parcel$export(module.exports, "isKeywordRegex", () => $94348a923c5baf97$export$290f3472231a2ca1);
$parcel$export(module.exports, "isModifierRegex", () => $94348a923c5baf97$export$56079d3966b6b26c);
$parcel$export(module.exports, "isComplexOperatorRegex", () => $94348a923c5baf97$export$3f6ac43c2355116b);
$parcel$export(module.exports, "isWSRegex", () => $94348a923c5baf97$export$b1b0fc0dc5c83a12);
$parcel$export(module.exports, "isIdentifierRegex", () => $94348a923c5baf97$export$218cf3eb73c65394);
$parcel$export(module.exports, "isLogicalOperatorRegex", () => $94348a923c5baf97$export$a46484930d6fa80f);
$parcel$export(module.exports, "isOperatorRegex", () => $94348a923c5baf97$export$d48805fc5b137dc9);
/**
 * Token types
 */ const $94348a923c5baf97$export$e92b897d610f2aba = [
    'WHITE_SPACE',
    'SEPARATOR',
    'IDENTIFIER',
    'MODIFIER',
    'KEYWORD',
    'LOGICAL_OPERATOR',
    'STRING_LITERAL',
    'NUMBER_LITERAL',
    'BOOLEAN_LITERAL',
    'NULL_LITERAL',
    'OPERATOR'
];
const $94348a923c5baf97$export$9ce7f372949a1546 = '(';
const $94348a923c5baf97$export$bbbb3f477a9839e0 = ')';
const $94348a923c5baf97$export$adbc66edc544fda9 = '=';
const $94348a923c5baf97$export$fbd271ef020db0c = '!=';
const $94348a923c5baf97$export$ea7497008076d6d2 = ':';
const $94348a923c5baf97$export$6d44219c9e0c2567 = '!:';
const $94348a923c5baf97$export$f8636d23c210043c = '<';
const $94348a923c5baf97$export$1892bd0c818db570 = '<=';
const $94348a923c5baf97$export$386b1ae18a32d690 = '>';
const $94348a923c5baf97$export$44a62afa61d82568 = '>=';
const $94348a923c5baf97$export$e75c84803c67e1f4 = [
    $94348a923c5baf97$export$adbc66edc544fda9,
    $94348a923c5baf97$export$f8636d23c210043c,
    $94348a923c5baf97$export$1892bd0c818db570,
    $94348a923c5baf97$export$386b1ae18a32d690,
    $94348a923c5baf97$export$44a62afa61d82568
];
const $94348a923c5baf97$export$61308b2610174a70 = 'AND';
const $94348a923c5baf97$export$1de654320eb3e523 = 'OR';
const $94348a923c5baf97$export$184522872a5410fc = 'not';
const $94348a923c5baf97$export$ff7eed6ac2251302 = 'true';
const $94348a923c5baf97$export$4b436fec6f13b741 = 'false';
const $94348a923c5baf97$export$8cbc171ac4843075 = [
    $94348a923c5baf97$export$ff7eed6ac2251302,
    $94348a923c5baf97$export$4b436fec6f13b741
];
const $94348a923c5baf97$export$347c7cb6285a1d61 = '"';
const $94348a923c5baf97$export$d84ab70dc909b702 = "'";
const $94348a923c5baf97$export$910131ff5cd3d496 = `${$94348a923c5baf97$export$347c7cb6285a1d61}open${$94348a923c5baf97$export$347c7cb6285a1d61}`;
const $94348a923c5baf97$export$2aa0d26cb4549272 = `${$94348a923c5baf97$export$347c7cb6285a1d61}closed${$94348a923c5baf97$export$347c7cb6285a1d61}`;
const $94348a923c5baf97$export$572cec90aa166025 = `${$94348a923c5baf97$export$347c7cb6285a1d61}acknowledged${$94348a923c5baf97$export$347c7cb6285a1d61}`;
const $94348a923c5baf97$export$f94109650ec67751 = `${$94348a923c5baf97$export$347c7cb6285a1d61}snoozed${$94348a923c5baf97$export$347c7cb6285a1d61}`;
const $94348a923c5baf97$export$3a3a37e9da45a2a4 = [
    $94348a923c5baf97$export$910131ff5cd3d496,
    $94348a923c5baf97$export$2aa0d26cb4549272,
    $94348a923c5baf97$export$572cec90aa166025,
    $94348a923c5baf97$export$f94109650ec67751
];
const $94348a923c5baf97$export$928c1edd572e94f0 = 'P1';
const $94348a923c5baf97$export$22202070e5f64c55 = 'P2';
const $94348a923c5baf97$export$537865d58d2072a3 = 'P3';
const $94348a923c5baf97$export$3d5cfea3feefee83 = 'P4';
const $94348a923c5baf97$export$fe945cac89cd21a5 = 'P5';
const $94348a923c5baf97$export$9ef3f42fa10fce44 = [
    $94348a923c5baf97$export$928c1edd572e94f0,
    $94348a923c5baf97$export$22202070e5f64c55,
    $94348a923c5baf97$export$537865d58d2072a3,
    $94348a923c5baf97$export$3d5cfea3feefee83,
    $94348a923c5baf97$export$fe945cac89cd21a5
];
const $94348a923c5baf97$export$c2b6d31a7a2d40ba = 'null';
const $94348a923c5baf97$export$5a484b762b542c13 = 'actions';
const $94348a923c5baf97$export$21c480ed86e9d13 = 'alias';
const $94348a923c5baf97$export$534c195089710c34 = 'closedBy';
const $94348a923c5baf97$export$4699ad3805947d4d = 'count';
const $94348a923c5baf97$export$7c3401d7874d69f5 = 'createdAt';
const $94348a923c5baf97$export$afffcbd5b444e040 = 'description';
const $94348a923c5baf97$export$e1e61c3bf43fff11 = 'details.key';
const $94348a923c5baf97$export$aa35da9746edbfe2 = 'details.value';
const $94348a923c5baf97$export$b620b7163533b409 = 'detailsPair';
const $94348a923c5baf97$export$2a30b5099ba66c99 = 'entity';
const $94348a923c5baf97$export$2bfb49435a331d16 = 'integration.name';
const $94348a923c5baf97$export$feced558810f4b3e = 'integration.type';
const $94348a923c5baf97$export$7926b4c2836db847 = 'isSeen';
const $94348a923c5baf97$export$5a8895646b1d5248 = 'message';
const $94348a923c5baf97$export$4047502bdab1e205 = 'owner';
const $94348a923c5baf97$export$5922c06b76ebb57d = 'priority';
const $94348a923c5baf97$export$1122634b5d555f05 = 'components';
const $94348a923c5baf97$export$ec912454cd7d858a = 'services';
const $94348a923c5baf97$export$44673ddac1790242 = 'responders';
const $94348a923c5baf97$export$f250d53474e801dc = 'source';
const $94348a923c5baf97$export$43181828ba8680e4 = 'status';
const $94348a923c5baf97$export$a1959e1b76e880dd = 'sync.name';
const $94348a923c5baf97$export$8417ff61f7a57db6 = 'sync.type';
const $94348a923c5baf97$export$8242733866920892 = 'tags';
const $94348a923c5baf97$export$c833829cf31052f0 = 'tinyId';
const $94348a923c5baf97$export$78d4faf48faf13c2 = 'updatedAt';
const $94348a923c5baf97$export$5f1e5c89a704810f = 'acknowledged';
const $94348a923c5baf97$export$89d93eb7117999c0 = 'acknowledgedBy';
const $94348a923c5baf97$export$1ee0ad656333fc23 = 'aggregatorIds';
const $94348a923c5baf97$export$d42da2034504d6de = 'alertId';
const $94348a923c5baf97$export$8464a15b62fb09bb = 'alertType';
const $94348a923c5baf97$export$2f7ba2848fc019c6 = 'encrypted';
const $94348a923c5baf97$export$86e4b68c61c8cca5 = 'encryptionId';
const $94348a923c5baf97$export$cd9dc7ab4d04d11c = 'lastOccurredAt';
const $94348a923c5baf97$export$8508b76d4c14d7e = 'notify';
const $94348a923c5baf97$export$e73ddf8d219f28b7 = 'snoozedUntil';
const $94348a923c5baf97$export$a79eb1864dd7b745 = 'teams';
const $94348a923c5baf97$export$888a9cda49b5e18c = [
    $94348a923c5baf97$export$5f1e5c89a704810f,
    $94348a923c5baf97$export$89d93eb7117999c0,
    $94348a923c5baf97$export$1ee0ad656333fc23,
    $94348a923c5baf97$export$d42da2034504d6de,
    $94348a923c5baf97$export$8464a15b62fb09bb,
    $94348a923c5baf97$export$2f7ba2848fc019c6,
    $94348a923c5baf97$export$86e4b68c61c8cca5,
    $94348a923c5baf97$export$cd9dc7ab4d04d11c,
    $94348a923c5baf97$export$8508b76d4c14d7e,
    $94348a923c5baf97$export$e73ddf8d219f28b7,
    $94348a923c5baf97$export$a79eb1864dd7b745,
    $94348a923c5baf97$export$5a484b762b542c13,
    $94348a923c5baf97$export$21c480ed86e9d13,
    $94348a923c5baf97$export$534c195089710c34,
    $94348a923c5baf97$export$4699ad3805947d4d,
    $94348a923c5baf97$export$7c3401d7874d69f5,
    $94348a923c5baf97$export$afffcbd5b444e040,
    $94348a923c5baf97$export$e1e61c3bf43fff11,
    $94348a923c5baf97$export$aa35da9746edbfe2,
    $94348a923c5baf97$export$b620b7163533b409,
    $94348a923c5baf97$export$2a30b5099ba66c99,
    $94348a923c5baf97$export$2bfb49435a331d16,
    $94348a923c5baf97$export$feced558810f4b3e,
    $94348a923c5baf97$export$7926b4c2836db847,
    $94348a923c5baf97$export$5a8895646b1d5248,
    $94348a923c5baf97$export$4047502bdab1e205,
    $94348a923c5baf97$export$5922c06b76ebb57d,
    $94348a923c5baf97$export$44673ddac1790242,
    $94348a923c5baf97$export$1122634b5d555f05,
    $94348a923c5baf97$export$ec912454cd7d858a,
    $94348a923c5baf97$export$f250d53474e801dc,
    $94348a923c5baf97$export$43181828ba8680e4,
    $94348a923c5baf97$export$a1959e1b76e880dd,
    $94348a923c5baf97$export$8417ff61f7a57db6,
    $94348a923c5baf97$export$8242733866920892,
    $94348a923c5baf97$export$c833829cf31052f0,
    $94348a923c5baf97$export$78d4faf48faf13c2
];
const $94348a923c5baf97$export$60745b712d37edf9 = [
    $94348a923c5baf97$export$5f1e5c89a704810f,
    $94348a923c5baf97$export$7926b4c2836db847
];
const $94348a923c5baf97$export$b38df7dc61d42293 = [
    ...$94348a923c5baf97$export$888a9cda49b5e18c
];
/**
 * Regex definitions
 */ // The main regex to split any given query into smaller tokens.
// Please be aware that token order has a meaning here.
const $94348a923c5baf97$var$splitToTokensCases = [
    // 1. Split single and double quotes
    ...[
        $94348a923c5baf97$export$d84ab70dc909b702,
        $94348a923c5baf97$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*?${i})`),
    ...[
        $94348a923c5baf97$export$d84ab70dc909b702,
        $94348a923c5baf97$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*)`),
    // 2. Split operators and separators
    ...[
        $94348a923c5baf97$export$9ce7f372949a1546,
        $94348a923c5baf97$export$bbbb3f477a9839e0,
        $94348a923c5baf97$export$adbc66edc544fda9,
        $94348a923c5baf97$export$fbd271ef020db0c,
        $94348a923c5baf97$export$ea7497008076d6d2,
        $94348a923c5baf97$export$6d44219c9e0c2567,
        $94348a923c5baf97$export$44a62afa61d82568,
        $94348a923c5baf97$export$386b1ae18a32d690,
        $94348a923c5baf97$export$1892bd0c818db570,
        $94348a923c5baf97$export$f8636d23c210043c
    ].map((i)=>`(\\${i})`),
    // 3. Split the exact keywords when it's a known literal
    // Known issue: The word boundary in the beginning does not capture letters except latin chars, digits and underscore, i.e. "+and" results to STRING_LITERAL + BOOLEAN_LITERAL
    ...[
        $94348a923c5baf97$export$61308b2610174a70,
        $94348a923c5baf97$export$1de654320eb3e523,
        $94348a923c5baf97$export$ff7eed6ac2251302,
        $94348a923c5baf97$export$4b436fec6f13b741,
        $94348a923c5baf97$export$184522872a5410fc,
        `is\\s*null`,
        `is\\s*not\\s*null`
    ].map((i)=>`(\\b${i}(?=\\s|$))`),
    // 4. Empty spaces
    '(\\s+)'
];
const $94348a923c5baf97$export$28041d1d2a85f002 = new RegExp($94348a923c5baf97$var$splitToTokensCases.join('|'), 'gi');
const $94348a923c5baf97$export$290f3472231a2ca1 = /^(is(  *)not(  *)null)$|^(is(  *)null)$/i;
const $94348a923c5baf97$export$56079d3966b6b26c = /^not$/i;
const $94348a923c5baf97$export$3f6ac43c2355116b = /^<=$|^>=$|^!=$|^!:$/;
const $94348a923c5baf97$export$b1b0fc0dc5c83a12 = /^\s+$/;
const $94348a923c5baf97$export$218cf3eb73c65394 = new RegExp($94348a923c5baf97$export$b38df7dc61d42293.map((i)=>`^${i}$`).join('|'));
const $94348a923c5baf97$export$a46484930d6fa80f = /^and$|^or$/i;
const $94348a923c5baf97$export$d48805fc5b137dc9 = /^[=:<>]$/;

});

parcelRegister("c6ZDX", function(module, exports) {

$parcel$export(module.exports, "OpsgenieSavedSearchAri", () => $8d15dcae9045c8f1$export$1dc7f741fb628a10);

var $1Q6nC = parcelRequire("1Q6nC");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/opsgenie/saved-search/manifest.ts
var $8d15dcae9045c8f1$var$opsgenieSavedSearchAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $1Q6nC.OpsgenieSavedSearchAriResourceOwner),
    resourceType: (0, $1Q6nC.OpsgenieSavedSearchAriResourceType),
    resourceIdSlug: "{workspaceId}/{savedSearchId}",
    resourceIdSegmentFormats: {
        workspaceId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        savedSearchId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/opsgenie/saved-search/index.ts
var $8d15dcae9045c8f1$export$1dc7f741fb628a10 = class _OpsgenieSavedSearchAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._workspaceId = opts.resourceIdSegmentValues.workspaceId, this._savedSearchId = opts.resourceIdSegmentValues.savedSearchId;
    }
    get workspaceId() {
        return this._workspaceId;
    }
    get savedSearchId() {
        return this._savedSearchId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $8d15dcae9045c8f1$var$opsgenieSavedSearchAriStaticOpts.qualifier,
            platformQualifier: $8d15dcae9045c8f1$var$opsgenieSavedSearchAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $8d15dcae9045c8f1$var$opsgenieSavedSearchAriStaticOpts.resourceOwner,
            resourceType: $8d15dcae9045c8f1$var$opsgenieSavedSearchAriStaticOpts.resourceType,
            resourceId: `${opts.workspaceId}/${opts.savedSearchId}`,
            resourceIdSegmentValues: {
                workspaceId: opts.workspaceId,
                savedSearchId: opts.savedSearchId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $8d15dcae9045c8f1$var$opsgenieSavedSearchAriStaticOpts);
        return new _OpsgenieSavedSearchAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $8d15dcae9045c8f1$var$opsgenieSavedSearchAriStaticOpts);
        return new _OpsgenieSavedSearchAri(opts);
    }
    getVariables() {
        return {
            workspaceId: this.workspaceId,
            savedSearchId: this.savedSearchId
        };
    }
};

});
parcelRegister("1Q6nC", function(module, exports) {

$parcel$export(module.exports, "OpsgenieSavedSearchAriResourceOwner", () => $156f98ac86d14414$export$7416cc1df15f6b85);
$parcel$export(module.exports, "OpsgenieSavedSearchAriResourceType", () => $156f98ac86d14414$export$1db52fe39936618e);
// src/opsgenie/saved-search/types.ts
var $156f98ac86d14414$export$7416cc1df15f6b85 = "opsgenie", $156f98ac86d14414$export$1db52fe39936618e = "saved-search";

});


parcelRegister("3y8cO", function(module, exports) {

$parcel$export(module.exports, "SavedSearchActionButtons", () => $627e034906c9d6ce$export$78ee2939aff842cb);

var $eJOHy = parcelRequire("eJOHy");

var $24gpd = parcelRequire("24gpd");

var $1AUsu = parcelRequire("1AUsu");
var $7R1al = parcelRequire("7R1al");

var $c6ZDX = parcelRequire("c6ZDX");

var $hk2FL = parcelRequire("hk2FL");

var $duG08 = parcelRequire("duG08");
var $Emlg0 = parcelRequire("Emlg0");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");





var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $6naEG = parcelRequire("6naEG");

var $8z6Yy = parcelRequire("8z6Yy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");


var $5A7zz = parcelRequire("5A7zz");
const $627e034906c9d6ce$var$deleteModalMessageDescriptors = {
    title: (0, $5A7zz.default).confirmTrashHeading,
    description: (0, $5A7zz.default).confirmTrashMessage
};
const $627e034906c9d6ce$export$78ee2939aff842cb = ({ onClose: onClose, savedSearch: savedSearch })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const handleNavMenuOpen = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                itemId: (0, $bc40578f06d7846b$export$a65812b4aab631bb),
                parentItemType: 'savedSearch',
                parentItemId: savedSearch.id
            }
        });
    }, [
        createAnalyticsEvent,
        savedSearch.id
    ]);
    const MenuItems = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($627e034906c9d6ce$var$MoreMenuItems, {
            onClose: props.onClose,
            savedSearch: savedSearch
        }), [
        savedSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: (0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton') ? handleNavMenuOpen : ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6),
                actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                    level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                    itemId: (0, $bc40578f06d7846b$export$a65812b4aab631bb),
                    parentItemType: 'savedSearch',
                    parentItemId: savedSearch.id
                }
            });
        },
        MenuItems: (0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton') ? MenuItems : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($627e034906c9d6ce$var$MoreMenuItems, {
                ...props,
                savedSearch: savedSearch
            }),
        onClose: onClose
    });
};
const $627e034906c9d6ce$var$MoreMenuItems = ({ onClose: onClose, savedSearch: savedSearch })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [modalType, setModalType] = (0, $eJOHy.useState)(undefined);
    const onCloseWithStopPropagation = (0, $6naEG.useStopPropagation)(onClose);
    const { removeSavedSearchFromCreatedByMe: removeSavedSearchFromCreatedByMe } = (0, $Emlg0.useSavedSearchRelayUtils)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const deleteSavedSearch = (0, $eJOHy.useCallback)((e)=>{
        setIsLoading(true);
        const savedSearchId = (0, $c6ZDX.OpsgenieSavedSearchAri).parse(savedSearch.id).savedSearchId;
        (0, $duG08.deleteSearchEndpoint)(savedSearchId).then(()=>{
            removeSavedSearchFromCreatedByMe(savedSearch.id);
        }).catch(()=>{
            showFlag({
                key: (0, $hrodw.toFlagId)((0, $a04b23a4cdb2ecf7$export$337d30e19f17af0f)),
                type: 'error',
                title: (0, $5A7zz.default).errorTitle,
                description: (0, $5A7zz.default).errorMessage,
                messageId: 'navigation-apps-sidebar-nav4-sidebars-content-operations.ui.alerts-content.alerts-menu-item.action-button.show-flag.error',
                messageType: 'transactional'
            });
        }).finally(()=>{
            setIsLoading(false);
            if (onClose) onClose(e);
        });
    }, [
        savedSearch,
        onClose,
        removeSavedSearchFromCreatedByMe,
        showFlag
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const handleClick = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        setModalType('delete');
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $493796f3bdee881c$export$56981f28056f258e),
                level: (0, $4fdd5d9c1b32dd60$export$35ac629b8b943d5a),
                itemId: 'deleteSavedSearch',
                parentItemType: 'savedSearch',
                parentItemId: savedSearch.id
            }
        });
    }, [
        createAnalyticsEvent,
        savedSearch.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24gpd))), {
            LEGACY_size: "small",
            color: "var(--ds-icon-danger, #C9372C)",
            label: ""
        }),
        onClick: (0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton') ? handleClick : (e)=>{
            e.preventDefault();
            setModalType('delete');
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367),
                actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $493796f3bdee881c$export$56981f28056f258e),
                    level: (0, $4fdd5d9c1b32dd60$export$35ac629b8b943d5a),
                    itemId: 'deleteSavedSearch',
                    parentItemType: 'savedSearch',
                    parentItemId: savedSearch.id
                }
            });
        }
    }, formatMessage((0, $5A7zz.default).deleteSavedSearch))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hk2FL.DeleteModal), {
        messageDescriptors: (0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton') ? $627e034906c9d6ce$var$deleteModalMessageDescriptors : {
            title: (0, $5A7zz.default).confirmTrashHeading,
            description: (0, $5A7zz.default).confirmTrashMessage
        },
        isDeleteDialogOpen: modalType === 'delete',
        onDeleteAttemptCancel: onCloseWithStopPropagation,
        isLoading: isLoading,
        onDelete: (0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton') ? deleteSavedSearch : (e)=>deleteSavedSearch(e)
    }));
};

});
parcelRegister("24gpd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aba66ada45c058f49805b51f0ffb84ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1818ae563448797c$var$_react = $1818ae563448797c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1818ae563448797c$var$_delete = $1818ae563448797c$var$_interopRequireDefault((parcelRequire("iv2Ch")));

var $1818ae563448797c$var$_trash = $1818ae563448797c$var$_interopRequireDefault((parcelRequire("hxiWd")));
function $1818ae563448797c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DeleteIcon.
 * This component is DeleteIcon, with `UNSAFE_fallbackIcon` set to "TrashIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1818ae563448797c$var$DeleteIcon = (props)=>/*#__PURE__*/ $1818ae563448797c$var$_react.default.createElement($1818ae563448797c$var$_delete.default, Object.assign({
        LEGACY_fallbackIcon: $1818ae563448797c$var$_trash.default
    }, props));
$1818ae563448797c$var$DeleteIcon.Name = 'DeleteIconMigration';
var $1818ae563448797c$var$_default = module.exports.default = $1818ae563448797c$var$DeleteIcon;

});
parcelRegister("hxiWd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc443569cd9f7629$var$_react = $cc443569cd9f7629$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $cc443569cd9f7629$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cc443569cd9f7629$var$TrashIcon = (props)=>/*#__PURE__*/ $cc443569cd9f7629$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5a1 1 0 0 0-1 1v1h16V6a1 1 0 0 0-1-1zm11.15 15h-8.3a1 1 0 0 1-.99-.83L5 8h14l-1.86 11.17a1 1 0 0 1-.99.83M9 4.5a.5.5 0 0 1 .49-.5h5.02a.5.5 0 0 1 .49.5V5H9z"/></svg>`
    }, props));
$cc443569cd9f7629$var$TrashIcon.displayName = 'TrashIcon';
var $cc443569cd9f7629$var$_default = module.exports.default = $cc443569cd9f7629$var$TrashIcon;

});


parcelRegister("hk2FL", function(module, exports) {

$parcel$export(module.exports, "DeleteModal", () => $b6e5123536c59a53$export$73392e09138fecd6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $dKpTa = parcelRequire("dKpTa");
var $OgPfS = parcelRequire("OgPfS");

var $jdbsD = parcelRequire("jdbsD");
var $6sWr0 = parcelRequire("6sWr0");
var $3Zn1o = parcelRequire("3Zn1o");
var $15cpG = parcelRequire("15cpG");
var $i237T = parcelRequire("i237T");
var $jC5ye = parcelRequire("jC5ye");

var $fybih = parcelRequire("fybih");
const $b6e5123536c59a53$export$73392e09138fecd6 = ({ isDeleteDialogOpen: isDeleteDialogOpen, onDeleteAttemptCancel: onDeleteAttemptCancel, onDelete: onDelete, isLoading: isLoading, messageDescriptors: messageDescriptors, returnFocusRef: returnFocusRef })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jC5ye.default), {
        children: isDeleteDialogOpen && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $jdbsD.default), {
            shouldCloseOnOverlayClick: !isLoading,
            onClose: onDeleteAttemptCancel,
            shouldReturnFocus: returnFocusRef,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $15cpG.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i237T.default), {
                        appearance: "danger",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...messageDescriptors.title
                        })
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6sWr0.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...messageDescriptors.description
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Zn1o.default), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dKpTa.default), {
                            isDisabled: isLoading,
                            appearance: "subtle",
                            onClick: onDeleteAttemptCancel,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $fybih.messages).cancelButton
                            })
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $OgPfS.default), {
                            appearance: "danger",
                            onClick: onDelete,
                            autoFocus: true,
                            isLoading: isLoading,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $fybih.messages).deleteButton
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("fybih", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7af4a54852a1771b$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $7af4a54852a1771b$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    cancelButton: {
        id: 'eoc.alert-detail.delete-modal.cancel-button.no-translate',
        defaultMessage: 'Cancel',
        description: 'The text will be displayed in the delete modal footer for cancel button.'
    },
    deleteButton: {
        id: 'eoc.alert-detail.extra-property.delete-modal.delete-button.no-translate',
        defaultMessage: 'Delete',
        description: 'The text will be displayed in the delete modal footer for delete button.'
    }
});

});


parcelRegister("duG08", function(module, exports) {

$parcel$export(module.exports, "getSavedSearchesEndpoint", () => $3fcf1288c837c5db$export$3b7b44889eb94cd0);
$parcel$export(module.exports, "createSavedSearchEndpoint", () => $3fcf1288c837c5db$export$4976332c0ec66407);
$parcel$export(module.exports, "deleteSearchEndpoint", () => $3fcf1288c837c5db$export$401da4a793944201);

var $br21R = parcelRequire("br21R");
const $3fcf1288c837c5db$export$3b7b44889eb94cd0 = ()=>{
    return (0, $br21R.eocFetch)('/v1/alerts/saved-searches');
};
const $3fcf1288c837c5db$export$4976332c0ec66407 = (data)=>{
    return (0, $br21R.eocFetch)('/v1/alerts/saved-searches', {
        method: 'POST',
        body: data
    });
};
const $3fcf1288c837c5db$export$401da4a793944201 = (id)=>{
    return (0, $br21R.eocFetch)(`/v1/alerts/saved-searches/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};

});

parcelRegister("Emlg0", function(module, exports) {

$parcel$export(module.exports, "useSavedSearchRelayUtils", () => $5fbca0d03088cb95$export$e07c40a7acca4305);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $c6ZDX = parcelRequire("c6ZDX");

var $feIEW = parcelRequire("feIEW");
var $jXKdt = parcelRequire("jXKdt");

var $b388R = parcelRequire("b388R");

var $jhAUc = parcelRequire("jhAUc");
const $5fbca0d03088cb95$export$e07c40a7acca4305 = ()=>{
    const relayEnvironment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $b388R.getMeta)('ajs-cloud-id') ?? (0, $jhAUc.getCloudIdForDevEnvironment)();
    (0, $feIEW.assert)(!!cloudId, new (0, $jXKdt.AssertionError)('cloudId', 'useSavedSarchRelayUtils: cloudId is undefined'));
    const removeSavedSearch = (0, $eJOHy.useCallback)((savedSearchId, key)=>{
        (0, $j4oe4.commitLocalUpdate)(relayEnvironment, (store)=>{
            const root = store.getRoot();
            const opsgenieRecord = root.getLinkedRecord('opsgenie');
            if (opsgenieRecord) {
                const savedSearches = opsgenieRecord.getLinkedRecord('savedSearches', {
                    cloudId: cloudId
                });
                if (savedSearches) {
                    const removeItem = savedSearches.getLinkedRecords(key);
                    if (removeItem) {
                        const filteredItems = removeItem.filter((record)=>record.getValue('id') !== savedSearchId);
                        savedSearches.setLinkedRecords(filteredItems, key);
                    }
                }
            }
        });
    }, [
        cloudId,
        relayEnvironment
    ]);
    const addSavedSearch = (0, $eJOHy.useCallback)((savedSearch, key)=>{
        (0, $j4oe4.commitLocalUpdate)(relayEnvironment, (store)=>{
            const newSavedSearchId = (0, $c6ZDX.OpsgenieSavedSearchAri).create({
                workspaceId: cloudId,
                savedSearchId: savedSearch.id
            }).toString();
            const newSavedSearch = store.create(newSavedSearchId, 'OpsgenieSavedSearch');
            newSavedSearch.setValue(newSavedSearchId, 'id');
            newSavedSearch.setValue(savedSearch.name, 'name');
            newSavedSearch.setValue(savedSearch.query, 'alertSearchQuery');
            const root = store.getRoot();
            const opsgenieRecord = root.getLinkedRecord('opsgenie');
            if (opsgenieRecord) {
                const savedSearches = opsgenieRecord.getLinkedRecord('savedSearches', {
                    cloudId: cloudId
                });
                if (savedSearches) {
                    const savedSearchesList = savedSearches.getLinkedRecords(key) || [];
                    const updatedSavedSearches = [
                        ...savedSearchesList,
                        newSavedSearch
                    ];
                    savedSearches.setLinkedRecords(updatedSavedSearches, key);
                }
            }
        });
    }, [
        cloudId,
        relayEnvironment
    ]);
    const addSavedSearchToCreatedByMe = (0, $eJOHy.useCallback)((savedSearch)=>{
        addSavedSearch(savedSearch, 'createdByMe');
    }, [
        addSavedSearch
    ]);
    const removeSavedSearchFromCreatedByMe = (0, $eJOHy.useCallback)((savedSearchId)=>{
        removeSavedSearch(savedSearchId, 'createdByMe');
    }, [
        removeSavedSearch
    ]);
    return {
        addSavedSearchToCreatedByMe: addSavedSearchToCreatedByMe,
        removeSavedSearchFromCreatedByMe: removeSavedSearchFromCreatedByMe
    };
};

});
parcelRegister("jhAUc", function(module, exports) {

$parcel$export(module.exports, "validateTimeInput", () => $68a7c16dde295984$export$8880da3ae4274888);
$parcel$export(module.exports, "validateBetweenInput", () => $68a7c16dde295984$export$57c3e855fbf300fa);
$parcel$export(module.exports, "isInvalidDateValue", () => $68a7c16dde295984$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "removeQuotes", () => $68a7c16dde295984$export$dd2bdf5049bf0915);
$parcel$export(module.exports, "withQuote", () => $68a7c16dde295984$export$8708814d32e406db);
$parcel$export(module.exports, "calculateTimes", () => $68a7c16dde295984$export$b362bc6892126b7a);
$parcel$export(module.exports, "getDefaultFilterQuery", () => $68a7c16dde295984$export$16cce822d8159876);
$parcel$export(module.exports, "isResponderAlert", () => $68a7c16dde295984$export$78656db4ffc3ccd8);
$parcel$export(module.exports, "isGroupAlert", () => $68a7c16dde295984$export$be2243d4df51c704);
$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $68a7c16dde295984$export$81c70e0016508593);
$parcel$export(module.exports, "getCloudIdForDevEnvironment", () => $68a7c16dde295984$export$fc6ce7ac2248d7f5);

var $dBLX0 = parcelRequire("dBLX0");

var $kQ82p = parcelRequire("kQ82p");

var $8XZn3 = parcelRequire("8XZn3");

var $b388R = parcelRequire("b388R");

var $irJ8N = parcelRequire("irJ8N");
var $5qy8V = parcelRequire("5qy8V");

var $cOrDe = parcelRequire("cOrDe");

var $igDjg = parcelRequire("igDjg");
const $68a7c16dde295984$export$8880da3ae4274888 = (intl, timeDigits, timeUnit)=>{
    if (!timeDigits) return;
    const timeDigitsNumber = parseInt(timeDigits);
    if (isNaN(timeDigitsNumber)) return intl.formatMessage((0, $cOrDe.default).validNumber);
    if (timeUnit === 'hours' && (timeDigitsNumber < 1 || timeDigitsNumber > 99999)) return intl.formatMessage((0, $cOrDe.default).hoursNotInRange);
    if (timeUnit === 'days' && (timeDigitsNumber < 1 || timeDigitsNumber > 9999)) return intl.formatMessage((0, $cOrDe.default).daysNotInRange);
    if (timeUnit === 'weeks' && (timeDigitsNumber < 1 || timeDigitsNumber > 999)) return intl.formatMessage((0, $cOrDe.default).weeksNotInRange);
    if (timeUnit === 'months' && (timeDigitsNumber < 1 || timeDigitsNumber > 99)) return intl.formatMessage((0, $cOrDe.default).monthsNotInRange);
    if (timeUnit === 'years' && (timeDigitsNumber < 1 || timeDigitsNumber > 9)) return intl.formatMessage((0, $cOrDe.default).yearsNotInRange);
};
const $68a7c16dde295984$export$57c3e855fbf300fa = (intl, value)=>{
    if (value) {
        const { startDate: startDate, endDate: endDate } = value;
        if (!startDate && !endDate) return;
        if (startDate && endDate && new Date(startDate) > new Date(endDate)) return intl.formatMessage((0, $cOrDe.default).validationMessageBeforeGreaterThanAfter);
        if (value && (startDate !== '' && !(0, $dBLX0.default)(new Date(startDate)) || endDate !== '' && !(0, $dBLX0.default)(new Date(endDate)))) return intl.formatMessage((0, $cOrDe.default).validationMessageInvalidDateFormat);
    }
    return;
};
const $68a7c16dde295984$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $dBLX0.default)((0, $kQ82p.default)(value)) && value !== '';
};
const $68a7c16dde295984$export$dd2bdf5049bf0915 = (value)=>{
    return value.replace(/^"(.*)"$/, '$1');
};
const $68a7c16dde295984$export$d4aae9ad13afd6c = (data)=>{
    return {
        ...data,
        label: data.name,
        value: data.id
    };
};
const $68a7c16dde295984$export$8708814d32e406db = (value)=>{
    if ((0, $irJ8N.hasSpaceRegEx).test(value) || (0, $irJ8N.hasColonRegex).test(value)) return `${0, $5qy8V.STRING_LITERAL_DOUBLE_QUOTE}${value}${0, $5qy8V.STRING_LITERAL_DOUBLE_QUOTE}`;
    else return value;
};
const $68a7c16dde295984$export$b362bc6892126b7a = (time)=>{
    if (!time) return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'all') return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'custom') return {
        from: time.from,
        to: time.to
    };
    const now = new Date();
    const subAmount = {
        [time.range]: time.value
    };
    return {
        from: (0, $8XZn3.default)(now, subAmount).getTime(),
        to: now.getTime()
    };
};
const $68a7c16dde295984$export$16cce822d8159876 = (query, teamId)=>{
    if (teamId) {
        if (query) return `${0, $5qy8V.IDENTIFIER_RESPONDERS}: ${teamId} ${0, $5qy8V.LOGICAL_OPERATOR_AND} ${query}`;
        return `${0, $5qy8V.IDENTIFIER_RESPONDERS}: ${teamId}`;
    }
    return query;
};
const $68a7c16dde295984$export$78656db4ffc3ccd8 = (alert)=>alert && alert.alertType === 'responder';
const $68a7c16dde295984$export$be2243d4df51c704 = (alert)=>alert.entityType === 'group';
const $68a7c16dde295984$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $b388R.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};
const $68a7c16dde295984$var$isDevEnvironment = ()=>{
    return typeof $igDjg !== 'undefined' && ($igDjg?.env?.STORYBOOK === 'true' || $igDjg?.env?.NODE_ENV === 'development') || window.location.hostname === 'localhost';
};
const $68a7c16dde295984$export$fc6ce7ac2248d7f5 = ()=>{
    if ($68a7c16dde295984$var$isDevEnvironment()) return 'abc-def-ghi-jkl';
    return undefined;
};

});
parcelRegister("irJ8N", function(module, exports) {

$parcel$export(module.exports, "TAB_KEY", () => $146f64ab05499d33$export$da8c7facc28740b1);
$parcel$export(module.exports, "ENTER_KEY", () => $146f64ab05499d33$export$4162dbd8c730437);
$parcel$export(module.exports, "ESCAPE_KEY", () => $146f64ab05499d33$export$728705b4513abbb5);
$parcel$export(module.exports, "SPACE_KEY", () => $146f64ab05499d33$export$a47625ee19580f99);
$parcel$export(module.exports, "LEFT_KEY", () => $146f64ab05499d33$export$ba950c21a0561bed);
$parcel$export(module.exports, "UP_KEY", () => $146f64ab05499d33$export$16859d5882a95fea);
$parcel$export(module.exports, "RIGHT_KEY", () => $146f64ab05499d33$export$4b96cad863d88376);
$parcel$export(module.exports, "DOWN_KEY", () => $146f64ab05499d33$export$fc0cf2556509233e);
$parcel$export(module.exports, "SUGGESTION_CARD_Y_POS", () => $146f64ab05499d33$export$87b2b08fc4c97f78);
$parcel$export(module.exports, "hasSpaceRegEx", () => $146f64ab05499d33$export$a07ca273fbeffcb8);
$parcel$export(module.exports, "hasStartingQuotesRegex", () => $146f64ab05499d33$export$a3aaedcec21ac282);
$parcel$export(module.exports, "hasEndingQuotesRegex", () => $146f64ab05499d33$export$e5ad519d04ef012a);
$parcel$export(module.exports, "hasNewLinesRegex", () => $146f64ab05499d33$export$7645e556e9948ecd);
$parcel$export(module.exports, "EMAIL_REGEX", () => $146f64ab05499d33$export$7b7637218245c8a);
$parcel$export(module.exports, "hasColonRegex", () => $146f64ab05499d33$export$65a2b373cb60e599);
const $146f64ab05499d33$export$da8c7facc28740b1 = 'Tab';
const $146f64ab05499d33$export$4162dbd8c730437 = 'Enter';
const $146f64ab05499d33$export$728705b4513abbb5 = 'Escape';
const $146f64ab05499d33$export$a47625ee19580f99 = ' ';
const $146f64ab05499d33$export$ba950c21a0561bed = 'ArrowLeft';
const $146f64ab05499d33$export$16859d5882a95fea = 'ArrowUp';
const $146f64ab05499d33$export$4b96cad863d88376 = 'ArrowRight';
const $146f64ab05499d33$export$fc0cf2556509233e = 'ArrowDown';
const $146f64ab05499d33$export$87b2b08fc4c97f78 = 28;
const $146f64ab05499d33$export$a07ca273fbeffcb8 = /\s/;
const $146f64ab05499d33$export$8866d083cd03ffd7 = /^\s|\s$/;
const $146f64ab05499d33$export$a3aaedcec21ac282 = /^('|")/;
const $146f64ab05499d33$export$e5ad519d04ef012a = /('|")$/;
const $146f64ab05499d33$export$7645e556e9948ecd = /(\r\n|\n|\r)/gm;
const $146f64ab05499d33$export$7b7637218245c8a = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $146f64ab05499d33$export$65a2b373cb60e599 = /:/;

});

parcelRegister("cOrDe", function(module, exports) {

$parcel$export(module.exports, "default", () => $2305f9109a978b85$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $2305f9109a978b85$var$messages = (0, $7qGN1.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.alert-list.common.utils.validation-message-before-greater-than-after.no-translate`,
        defaultMessage: "'Before' field cannot be later than 'After' field.",
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.alert-list.common.utils.validation-message-invalid-date-format.no-translate`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validNumber: {
        id: `eoc.alert-list.common.utils.validation-not-number.no-translate`,
        defaultMessage: 'Enter a valid number.',
        description: 'The error message that shown when user write different chars other than numeric chars.'
    },
    hoursNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-hours-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-99999.',
        description: 'Message displayed to the user when hours value is not in range'
    },
    daysNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-days-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-9999.',
        description: 'Message displayed to the user when days value is not in range'
    },
    weeksNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-weeks-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-999.',
        description: 'Message displayed to the user when weeks value is not in range'
    },
    monthsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-months-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-99.',
        description: 'Message displayed to the user when months value is not in range'
    },
    yearsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-years-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-9.',
        description: 'Message displayed to the user when years value is not in range'
    }
});
var $2305f9109a978b85$export$2e2bcd8739ae039 = $2305f9109a978b85$var$messages;

});



const $a04b23a4cdb2ecf7$export$337d30e19f17af0f = 'fetchError';

parcelRegister("5A7zz", function(module, exports) {

$parcel$export(module.exports, "default", () => $515a66b922a4bf80$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $515a66b922a4bf80$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    deleteSavedSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.delete-saved-search",
        "defaultMessage": "Delete"
    },
    confirmTrashHeading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.confirm-trash-heading",
        "defaultMessage": "Delete saved search"
    },
    confirmTrashMessage: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.confirm-trash-message",
        "defaultMessage": "Are you sure you want to delete this saved search?"
    },
    errorTitle: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.error-title",
        "defaultMessage": "Error"
    },
    errorMessage: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.error-message",
        "defaultMessage": "Something went wrong. Please try again."
    }
});

});



parcelRegister("dzn9I", function(module, exports) {

$parcel$export(module.exports, "AlertsMenuItemContentNew", () => $59dfc06b1c57cbd1$export$f0f13aaf6210507e);

var $ezeWP = parcelRequire("ezeWP");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $dNSuS = parcelRequire("dNSuS");

var $gbiVe = parcelRequire("gbiVe");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $7jTnu = parcelRequire("7jTnu");

var $5qy8V = parcelRequire("5qy8V");

var $lRq8t = parcelRequire("lRq8t");




var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $aLENQ = parcelRequire("aLENQ");

var $lvrbL = parcelRequire("lvrbL");

var $i0tMD = parcelRequire("i0tMD");

var $azEgq = parcelRequire("azEgq");

var $2QH3X = parcelRequire("2QH3X");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $8q7lT = parcelRequire("8q7lT");

var $16sa1 = parcelRequire("16sa1");

var $kfvK2 = parcelRequire("kfvK2");
var $95O7y = parcelRequire("95O7y");

var $c6ZDX = parcelRequire("c6ZDX");

var $gaz9I = parcelRequire("gaz9I");

var $jn07M = parcelRequire("jn07M");

var $igYXn = parcelRequire("igYXn");

var $1Cl4r = parcelRequire("1Cl4r");

var $5rZKK = parcelRequire("5rZKK");

var $ih7sC = parcelRequire("ih7sC");

var $aQAXU = parcelRequire("aQAXU");

var $3y8cO = parcelRequire("3y8cO");
function $59dfc06b1c57cbd1$export$f0f13aaf6210507e({ queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $ezeWP.default), queryRef);
    const [savedSearchIdFromURL] = (0, $95O7y.useQueryParam)('filter');
    const [alertSearchQueryFromURL] = (0, $95O7y.useQueryParam)('query');
    const [selectedFilter, setSelectedFilter] = (0, $eJOHy.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const accountId = (0, $8q7lT.useAccountId)();
    const [viewType] = (0, $95O7y.useQueryParam)('view');
    const { icon: pagesIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $1Cl4r.default).alerts, (0, (/*@__PURE__*/$parcel$interopDefault($dNSuS))));
    const isAlertsRoute = (0, $kfvK2.useIsActiveRoute)(new Set([
        (0, $jn07M.eocGlobalAlertListRoute).name,
        (0, $igYXn.eocTeamAlertDetailRoute).name
    ]));
    const { setLastVisitedSearch: setLastVisitedSearch } = (0, $ih7sC.useAlertsPopoutStore)();
    const { sharedWithMe: sharedWithMe, createdByMe: createdByMe } = data?.opsgenie?.savedSearches || {};
    const defaultFilters = (0, $eJOHy.useMemo)(()=>[
            {
                id: 'all',
                name: formatMessage((0, $5rZKK.default).allSearch),
                alertSearchQuery: ''
            },
            {
                id: 'open',
                name: formatMessage((0, $5rZKK.default).openSearch),
                alertSearchQuery: `${(0, $5qy8V.IDENTIFIER_STATUS)}${(0, $5qy8V.OPERATOR_EQUAL_TO)} ${(0, $5qy8V.STRING_LITERAL_STATUS_OPEN)}`
            },
            {
                id: 'closed',
                name: formatMessage((0, $5rZKK.default).closedSearch),
                alertSearchQuery: `${(0, $5qy8V.IDENTIFIER_STATUS)}${(0, $5qy8V.OPERATOR_EQUAL_TO)} ${(0, $5qy8V.STRING_LITERAL_STATUS_CLOSED)}`
            },
            {
                id: 'unacked',
                name: formatMessage((0, $5rZKK.default).unackedSearch),
                alertSearchQuery: `${(0, $5qy8V.IDENTIFIER_STATUS)}${(0, $5qy8V.OPERATOR_EQUAL_TO)} ${(0, $5qy8V.STRING_LITERAL_STATUS_OPEN)} ${(0, $5qy8V.LOGICAL_OPERATOR_AND)} ${(0, $5qy8V.IDENTIFIER_ACKNOWLEDGED)}${(0, $5qy8V.OPERATOR_EQUAL_TO)} ${(0, $5qy8V.BOOLEAN_LITERAL_FALSE)}`
            },
            {
                id: 'notSeen',
                name: formatMessage((0, $5rZKK.default).notSeenSearch),
                alertSearchQuery: `${(0, $5qy8V.IDENTIFIER_IS_SEEN)}${(0, $5qy8V.OPERATOR_EQUAL_TO)} ${(0, $5qy8V.BOOLEAN_LITERAL_FALSE)}`
            },
            {
                id: 'assignedToMe',
                name: formatMessage((0, $5rZKK.default).assignedToMeSearch),
                alertSearchQuery: `${(0, $5qy8V.IDENTIFIER_ASSIGNEE)}${(0, $5qy8V.OPERATOR_EQUAL_TO)} "${accountId || 'me'}"`
            }
        ], [
        formatMessage,
        accountId
    ]);
    const defaultFilterMenuIds = $59dfc06b1c57cbd1$var$getParentMenuId(defaultFilters);
    const defaultFilterWithComponentList = $59dfc06b1c57cbd1$var$getComponentAddedSearchObjects(defaultFilters, pagesIcon, viewType, 'default', savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute);
    const sharedWithMeWithComponentList = $59dfc06b1c57cbd1$var$getComponentAddedSearchObjects(sharedWithMe || [], pagesIcon, viewType, 'sharedWithMe', savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute);
    const createdByMeWithComponentList = $59dfc06b1c57cbd1$var$getComponentAddedSearchObjects(createdByMe || [], pagesIcon, viewType, 'createdByMe', savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute);
    const allFiltersWithComponentList = (0, $eJOHy.useMemo)(()=>[
            ...defaultFilterWithComponentList,
            ...sharedWithMeWithComponentList,
            ...createdByMeWithComponentList
        ], [
        createdByMeWithComponentList,
        defaultFilterWithComponentList,
        sharedWithMeWithComponentList
    ]);
    const getSelectedFilterComponentIfNotDefault = (0, $eJOHy.useMemo)(()=>(filterId)=>{
            if (defaultFilters.find((item)=>item.id === filterId)) return;
            const foundComponent = [
                ...sharedWithMeWithComponentList,
                ...createdByMeWithComponentList
            ].find((item)=>item.id === filterId)?.component;
            return foundComponent;
        }, [
        createdByMeWithComponentList,
        defaultFilters,
        sharedWithMeWithComponentList
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $7jTnu.fg)('operations_nav4_remaining_items')) {
            if (selectedFilter === '') {
                const customSearches = [
                    ...createdByMeWithComponentList,
                    ...sharedWithMeWithComponentList
                ];
                if (savedSearchIdFromURL) {
                    const matchedItem = customSearches.find((item)=>(0, $c6ZDX.OpsgenieSavedSearchAri).parse(item.id).savedSearchId === savedSearchIdFromURL);
                    if (matchedItem) {
                        setSelectedFilter(matchedItem.id);
                        return;
                    }
                }
                if (alertSearchQueryFromURL) {
                    const matchedItem = customSearches.find((item)=>item.alertSearchQuery === alertSearchQueryFromURL);
                    if (matchedItem) setSelectedFilter(matchedItem.id);
                }
            }
        }
        if (!(0, $7jTnu.fg)('operations_nav4_remaining_items')) {
            if (selectedFilter === '') {
                for (const item of allFiltersWithComponentList)// FIXME: This approach is not ideal. We should somehow use id instead of the alertSearchQuery.
                // https://ifountain.atlassian.net/browse/ALX-9535
                if (item.alertSearchQuery === alertSearchQueryFromURL) {
                    setSelectedFilter(item.id);
                    break;
                }
            }
        }
    }, [
        alertSearchQueryFromURL,
        allFiltersWithComponentList,
        createdByMeWithComponentList,
        savedSearchIdFromURL,
        selectedFilter,
        sharedWithMeWithComponentList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4.sidebar.operations.alerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), {
        name: (0, $gaz9I.ALERT_LIST_SPOTLIGHT_TARGETS).sidebar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: defaultFilterMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                    level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                    itemId: 'defaultFilters',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        testId: (0, $azEgq.getTestId)(defaultFilterMenuIds),
        interactionName: (0, $7jTnu.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-operations-alerts' : undefined
    }, formatMessage((0, $5rZKK.default).defaultFilters)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, defaultFilters.map((item)=>{
        const href = `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            key: item.id,
            href: href,
            menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter(item.id);
                if ((0, $7jTnu.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(href);
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                        level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        parentItemId: 'defaultFilters',
                        itemType: 'defaultFilter'
                    }
                });
            }
        }, item.name);
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, getSelectedFilterComponentIfNotDefault(selectedFilter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aQAXU.AlertsFlyoutMenuItem), {
        defaultFilterWithComponentList: defaultFilterWithComponentList,
        sharedWithMeWithComponentList: sharedWithMeWithComponentList,
        createdByMeWithComponentList: createdByMeWithComponentList,
        allFiltersWithComponentList: allFiltersWithComponentList
    }))));
}
function $59dfc06b1c57cbd1$var$getParentMenuId(arr) {
    return (0, $aLENQ.toMenuIdFromMenuIdList)((arr || []).map((i)=>(0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(i.alertSearchQuery)));
}
function $59dfc06b1c57cbd1$var$getComponentAddedSearchObjects(arrayList, pagesIcon, viewType, savedSearchType, savedSearchIdFromURL, setSelectedFilter, createAnalyticsEvent, setLastVisitedSearch, isAlertsRoute) {
    return arrayList.map((item)=>{
        if ((0, $7jTnu.fg)('operations_nav4_remaining_items')) {
            const requiresSavedSearchId = item.id && savedSearchType !== 'default';
            const savedSearchId = requiresSavedSearchId ? (0, $c6ZDX.OpsgenieSavedSearchAri).parse(item.id).savedSearchId : '';
            const href = `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}${requiresSavedSearchId ? `&filter=${savedSearchId}` : ''}`;
            return {
                ...item,
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
                    elemBefore: pagesIcon,
                    key: item.id,
                    href: href,
                    menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(savedSearchIdFromURL ? savedSearchId : item.alertSearchQuery),
                    onClick: ()=>{
                        setSelectedFilter(item.id);
                        if (isAlertsRoute && (0, $7jTnu.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(href);
                        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                            attributes: {
                                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                                level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                                itemId: item.id,
                                parentItemId: 'defaultFilters',
                                itemType: 'defaultFilter'
                            }
                        });
                    },
                    ...savedSearchType === 'createdByMe' && {
                        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3y8cO.SavedSearchActionButtons), {
                            savedSearch: item
                        })
                    }
                }, item.name)
            };
        }
        return {
            ...item,
            component: (()=>{
                const href = `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
                    elemBefore: pagesIcon,
                    key: item.id,
                    href: href,
                    menuId: (0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
                    onClick: ()=>{
                        setSelectedFilter(item.id);
                        if (isAlertsRoute && (0, $7jTnu.fg)('operations_nav4_remaining_items')) setLastVisitedSearch(href);
                        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OPERATIONS],
                            attributes: {
                                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                                level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
                                itemId: item.id,
                                parentItemId: 'defaultFilters',
                                itemType: 'defaultFilter'
                            }
                        });
                    },
                    ...savedSearchType === 'createdByMe' && {
                        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3y8cO.SavedSearchActionButtons), {
                            savedSearch: item
                        })
                    }
                }, item.name);
            })()
        };
    });
}

});
parcelRegister("ezeWP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6b6aa5efb718a3a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e5396e4ff48992f40c4331cd3bb4c1bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a6b6aa5efb718a3a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    }, v2 = {
        "kind": "ScalarField",
        "name": "alertSearchQuery"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "AlertsMenuItemContentNew",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "OpsgenieQuery",
                    "kind": "LinkedField",
                    "name": "opsgenie",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "OpsgenieSavedSearches",
                                "kind": "LinkedField",
                                "name": "savedSearches",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "opsgenie.savedSearches.sharedWithMe"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "opsgenie.savedSearches.createdByMe"
                                    }
                                ]
                            },
                            "action": "LOG",
                            "path": "opsgenie.savedSearches"
                        }
                    ]
                },
                "action": "LOG",
                "path": "opsgenie"
            }
        ],
        "type": "Query"
    };
}();
$a6b6aa5efb718a3a$var$node.hash = "639a282aa854558238900abb0fd76b71";
var $a6b6aa5efb718a3a$export$2e2bcd8739ae039 = $a6b6aa5efb718a3a$var$node;

});

parcelRegister("gaz9I", function(module, exports) {

$parcel$export(module.exports, "QUERY_PARAMETER_QUERY_LABEL", () => $036a544eb821db42$export$19f7845e9b507cf2);
$parcel$export(module.exports, "QUERY_PARAMETER_VIEW_LABEL", () => $036a544eb821db42$export$8540b2e79718c77f);
$parcel$export(module.exports, "QUERY_PARAMETER_ONLY_ALERTS_LABEL", () => $036a544eb821db42$export$d0190736add6775e);
$parcel$export(module.exports, "BASE_URL", () => $036a544eb821db42$export$ca6dda5263526f75);
$parcel$export(module.exports, "ALERT_LIST_SPOTLIGHT_TARGETS", () => $036a544eb821db42$export$84fe9cd6ee892532);
const $036a544eb821db42$export$19f7845e9b507cf2 = 'query';
const $036a544eb821db42$export$8540b2e79718c77f = 'view';
const $036a544eb821db42$export$d0190736add6775e = 'onlyAlerts';
const $036a544eb821db42$export$ca6dda5263526f75 = '/jira/ops';
const $036a544eb821db42$export$84fe9cd6ee892532 = {
    sidebar: 'operations-alert-sidebar-target',
    alertHeader: 'operations-alert-header-target',
    alertActions: 'operations-alert-actions-target',
    alertSources: 'operations-alert-sources-target',
    alertResponders: 'operations-alert-responders-target'
};

});

parcelRegister("aQAXU", function(module, exports) {

$parcel$export(module.exports, "AlertsFlyoutMenuItem", () => $4286108fe5e6c6ed$export$22af2a033e73b845);

var $eJOHy = parcelRequire("eJOHy");

var $eKx5I = parcelRequire("eKx5I");

var $bxHeV = parcelRequire("bxHeV");
var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");

var $8tSIA = parcelRequire("8tSIA");

var $lers0 = parcelRequire("lers0");

var $bvFRW = parcelRequire("bvFRW");

var $d9oCz = parcelRequire("d9oCz");
var $5jwgZ = parcelRequire("5jwgZ");
var $63KSu = parcelRequire("63KSu");
var $1swHh = parcelRequire("1swHh");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $7jTnu = parcelRequire("7jTnu");

var $5rZKK = parcelRequire("5rZKK");
const $4286108fe5e6c6ed$export$22af2a033e73b845 = ({ defaultFilterWithComponentList: defaultFilterWithComponentList, sharedWithMeWithComponentList: sharedWithMeWithComponentList, createdByMeWithComponentList: createdByMeWithComponentList, allFiltersWithComponentList: allFiltersWithComponentList })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [textFilterValue, setTextFilterValue] = (0, $eJOHy.useState)('');
    const [foundItems, setFoundItems] = (0, $eJOHy.useState)([]);
    const handleChange = (0, $eJOHy.useCallback)((event)=>{
        const value = event.currentTarget.value;
        setTextFilterValue(value);
        const foundItemsList = allFiltersWithComponentList.filter((item)=>item.name.toLowerCase().includes(value.toLowerCase()));
        const components = foundItemsList.map((item)=>item.component);
        setFoundItems(components);
    }, [
        allFiltersWithComponentList
    ]);
    const onStopSavedSearch = (0, $eJOHy.useCallback)(()=>{
        const savedSearchesEvent = createAnalyticsEvent({
            action: 'blurred',
            actionSubject: 'jsmViewAllSavedSearchesFlyoutSearch'
        });
        (0, $gCeeo.fireUIAnalytics)(savedSearchesEvent, 'stopViewAllQueueSearch');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9oCz.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $63KSu.FlyoutMenuItemTrigger), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lers0))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        })
    }, formatMessage((0, $5rZKK.default).viewAllFiltersPopupMenuButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5jwgZ.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, (0, $7jTnu.fg)('operations_nav4_remaining_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $4286108fe5e6c6ed$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "xsmall"
    }, formatMessage((0, $5rZKK.default).alerts))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $4286108fe5e6c6ed$var$textfieldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
        isCompact: true,
        value: textFilterValue,
        onChange: handleChange,
        "aria-label": formatMessage((0, $5rZKK.default).viewAllFiltersSearchPlaceholder),
        placeholder: formatMessage((0, $5rZKK.default).viewAllFiltersSearchPlaceholder),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSIA))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }),
        onBlur: onStopSavedSearch
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.050",
        xcss: $4286108fe5e6c6ed$var$flyoutContentStyles
    }, !textFilterValue.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "xxsmall"
    }, formatMessage((0, $5rZKK.default).defaultFilters))), defaultFilterWithComponentList.map((item)=>item.component), sharedWithMeWithComponentList && sharedWithMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "xxsmall"
    }, formatMessage((0, $5rZKK.default).sharedWithMe))), sharedWithMeWithComponentList.map((item)=>item.component)), createdByMeWithComponentList && createdByMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "xxsmall"
    }, formatMessage((0, $5rZKK.default).createdByMe))), createdByMeWithComponentList.map((item)=>item.component))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, foundItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        key: "no-item-found",
        paddingBlock: "space.100",
        xcss: $4286108fe5e6c6ed$var$noSearchResultsFoundStyles
    }, formatMessage((0, $5rZKK.default).viewAllFiltersNoResultsFoundText)) : foundItems))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.050",
        xcss: $4286108fe5e6c6ed$var$flyoutContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $4286108fe5e6c6ed$var$stickyBarOldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "xsmall"
    }, formatMessage((0, $5rZKK.default).alerts))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $4286108fe5e6c6ed$var$textfieldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
        isCompact: true,
        value: textFilterValue,
        onChange: handleChange,
        "aria-label": formatMessage((0, $5rZKK.default).viewAllFiltersSearchPlaceholder),
        placeholder: formatMessage((0, $5rZKK.default).viewAllFiltersSearchPlaceholder),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSIA))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }),
        onBlur: onStopSavedSearch
    }))), !textFilterValue.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "xxsmall"
    }, formatMessage((0, $5rZKK.default).defaultFilters))), defaultFilterWithComponentList.map((item)=>item.component), sharedWithMeWithComponentList && sharedWithMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "xxsmall"
    }, formatMessage((0, $5rZKK.default).sharedWithMe))), sharedWithMeWithComponentList.map((item)=>item.component)), createdByMeWithComponentList && createdByMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "xxsmall"
    }, formatMessage((0, $5rZKK.default).createdByMe))), createdByMeWithComponentList.map((item)=>item.component))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, foundItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        key: "no-item-found",
        paddingBlock: "space.100",
        xcss: $4286108fe5e6c6ed$var$noSearchResultsFoundStyles
    }, formatMessage((0, $5rZKK.default).viewAllFiltersNoResultsFoundText)) : foundItems)))));
};
const $4286108fe5e6c6ed$var$headerStyles = (0, $5Wv5g.xcss)({
    marginBottom: 'space.150',
    backgroundColor: 'utility.elevation.surface.current'
});
const $4286108fe5e6c6ed$var$stickyBarOldStyles = (0, $5Wv5g.xcss)({
    position: 'sticky',
    top: '0',
    backgroundColor: 'utility.elevation.surface.current',
    zIndex: 'navigation'
});
const $4286108fe5e6c6ed$var$textfieldStyles = (0, $5Wv5g.xcss)({
    paddingRight: 'space.100'
});
const $4286108fe5e6c6ed$var$noSearchResultsFoundStyles = (0, $5Wv5g.xcss)({
    fontStyle: 'italic'
});
const $4286108fe5e6c6ed$var$flyoutContentStyles = (0, $5Wv5g.xcss)({
    maxHeight: '500px',
    overflowY: 'auto'
});

});
parcelRegister("d9oCz", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuItem", () => $9d194069e867233f$export$34e3b4eaa687835);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ieBWZ = parcelRequire("ieBWZ");

var $eRk6W = parcelRequire("eRk6W");

var $42Y7K = parcelRequire("42Y7K");

var $ilbtc = parcelRequire("ilbtc");

var $fJbMZ = parcelRequire("fJbMZ");
const $9d194069e867233f$export$34e3b4eaa687835 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, id: id, isOpen: isOpenControlled, isDefaultOpen: isDefaultOpen = false, onOpenChange: onOpenChange }, forwardedRef)=>{
    const [isOpen, setIsOpen] = (0, $ieBWZ.default)(isOpenControlled, ()=>isDefaultOpen);
    const previousIsOpen = (0, $eRk6W.default)(isOpen);
    (0, $eJOHy.useEffect)(()=>{
        if (previousIsOpen === undefined || previousIsOpen === isOpen) /**
				 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
				 *
				 * The previous value can be equal to the current one if the component re-renders due to something else changing.
				 *
				 * In both cases the value hasn't changed and we don't want to notify consumers.
				 */ return;
        onOpenChange?.(isOpen);
    }, [
        isOpen,
        onOpenChange,
        previousIsOpen
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJbMZ.IsOpenContext).Provider, {
        value: isOpen,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJbMZ.SetIsOpenContext).Provider, {
            value: setIsOpen,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ilbtc.MenuListItem), {
                ref: forwardedRef,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $42Y7K.Popup), {
                    id: id,
                    isOpen: isOpen,
                    children: children
                })
            })
        })
    });
});

});
parcelRegister("42Y7K", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $51da6e3652a91a82$export$129a32eedafa97c5);
$parcel$export(module.exports, "PopupTrigger", () => $51da6e3652a91a82$export$95d4acdbab2fc6ef);
$parcel$export(module.exports, "PopupContent", () => $51da6e3652a91a82$export$2a2c7ba12d3231e3);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $9pZRF = parcelRequire("9pZRF");

var $gdEz9 = parcelRequire("gdEz9");

var $ijDer = parcelRequire("ijDer");

var $8c14o = parcelRequire("8c14o");

var $dCPMq = parcelRequire("dCPMq");
var $c89uy = parcelRequire("c89uy");

var $4ELHx = parcelRequire("4ELHx");

var $erwEt = parcelRequire("erwEt");

var $94c4p = parcelRequire("94c4p");

var $g4Uon = parcelRequire("g4Uon");
const $51da6e3652a91a82$var$IsOpenContext = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $51da6e3652a91a82$var$IdContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $51da6e3652a91a82$var$TriggerRefContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $51da6e3652a91a82$var$SetTriggerRefContext = /*#__PURE__*/ (0, $eJOHy.createContext)((0, $9pZRF.default));
const $51da6e3652a91a82$var$EnsureIsInsidePopupContext = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
// Used to ensure popup sub-components are used within a Popup
// and provide a useful error message if not.
const $51da6e3652a91a82$var$useEnsureIsInsidePopup = ()=>{
    const context = (0, $eJOHy.useContext)($51da6e3652a91a82$var$EnsureIsInsidePopupContext);
    (0, $8GOss.default)(context, 'PopupTrigger and PopupContent components must be used within a Popup');
};
const $51da6e3652a91a82$export$129a32eedafa97c5 = ({ children: children, id: providedId, isOpen: isOpen = false })=>{
    const [triggerRef, setTriggerRef] = (0, $eJOHy.useState)(null);
    const generatedId = (0, $gdEz9.useId)();
    const id = providedId || generatedId;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($51da6e3652a91a82$var$EnsureIsInsidePopupContext.Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($51da6e3652a91a82$var$IdContext.Provider, {
            value: id,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($51da6e3652a91a82$var$TriggerRefContext.Provider, {
                value: triggerRef,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($51da6e3652a91a82$var$SetTriggerRefContext.Provider, {
                    value: setTriggerRef,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($51da6e3652a91a82$var$IsOpenContext.Provider, {
                        value: isOpen,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dCPMq.Manager), {
                            children: children
                        })
                    })
                })
            })
        })
    });
};
const $51da6e3652a91a82$export$95d4acdbab2fc6ef = ({ children: children })=>{
    $51da6e3652a91a82$var$useEnsureIsInsidePopup();
    const isOpen = (0, $eJOHy.useContext)($51da6e3652a91a82$var$IsOpenContext);
    const id = (0, $eJOHy.useContext)($51da6e3652a91a82$var$IdContext);
    const setTriggerRef = (0, $eJOHy.useContext)($51da6e3652a91a82$var$SetTriggerRefContext);
    const getMergedTriggerRef = (0, $g4Uon.useGetMemoizedMergedTriggerRef)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c89uy.Reference), {
        children: ({ ref: ref })=>children({
                ref: getMergedTriggerRef(ref, setTriggerRef, isOpen),
                'aria-controls': id,
                'aria-expanded': isOpen,
                'aria-haspopup': true
            })
    });
};
const $51da6e3652a91a82$var$defaultLayer = 400;
/**
 * Disables popper.js GPU acceleration for this popup.
 * This means only positioning will be used, without any transforms.
 *
 * Performance will be degraded if the popup is expected to move.
 */ const $51da6e3652a91a82$var$shouldDisableGpuAccelerationModifiers = [
    {
        name: 'computeStyles',
        options: {
            gpuAcceleration: false
        }
    }
];
const $51da6e3652a91a82$export$2a2c7ba12d3231e3 = ({ xcss: xcss, appearance: inAppearance = 'default', children: children, boundary: boundary, offset: offset, strategy: strategy, onClose: onClose, testId: testId, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: popupComponent, autoFocus: autoFocus = true, zIndex: zIndex = $51da6e3652a91a82$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, shouldDisableGpuAcceleration: shouldDisableGpuAcceleration = false })=>{
    $51da6e3652a91a82$var$useEnsureIsInsidePopup();
    const isOpen = (0, $eJOHy.useContext)($51da6e3652a91a82$var$IsOpenContext);
    const id = (0, $eJOHy.useContext)($51da6e3652a91a82$var$IdContext);
    const triggerRef = (0, $eJOHy.useContext)($51da6e3652a91a82$var$TriggerRefContext);
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $94c4p.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const handleOpenLayerObserverCloseSignal = (0, $eJOHy.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $8c14o.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    if (!isOpen) return null;
    const popperWrapper = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ijDer.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $erwEt.default), {
            xcss: xcss,
            appearance: appearance,
            content: children,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: popupComponent,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldFitContainer: shouldFitContainer,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent,
            shouldDisableFocusLock: shouldDisableFocusLock,
            triggerRef: triggerRef,
            strategy: strategy,
            shouldFitViewport: shouldFitViewport,
            modifiers: shouldDisableGpuAcceleration ? $51da6e3652a91a82$var$shouldDisableGpuAccelerationModifiers : undefined
        })
    });
    if (shouldRenderToParent) return popperWrapper;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4ELHx.default), {
        zIndex: zIndex,
        children: popperWrapper
    });
};

});


parcelRegister("5jwgZ", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuItemContent", () => $55a9f7f75fda1e18$export$2ca9a13c57a8839a);
/* flyout-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $i15ln = parcelRequire("i15ln");

var $8XtVW = parcelRequire("8XtVW");

var $42Y7K = parcelRequire("42Y7K");

var $fJbMZ = parcelRequire("fJbMZ");
const $55a9f7f75fda1e18$var$flyoutMenuItemContentStyles = {
    root: "_1q51u2gc _85i5u2gc _bozgu2gc _y4tiu2gc _14b51kdj"
};
const $55a9f7f75fda1e18$export$2ca9a13c57a8839a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, containerTestId: containerTestId, onClose: onClose, autoFocus: autoFocus }, forwardedRef)=>{
    const setIsOpen = (0, $eJOHy.useContext)((0, $fJbMZ.SetIsOpenContext));
    const handleClose = (0, $eJOHy.useCallback)(()=>{
        onClose?.();
        setIsOpen(false);
    }, [
        setIsOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $42Y7K.PopupContent), {
        appearance: "UNSAFE_modal-below-sm",
        onClose: handleClose,
        placement: "right-start",
        // Using a capture event listener so that we are more resilient against
        // code that stops events. We _really_ want to close the flyout whenever
        // user user clicks outside the flyout content
        shouldUseCaptureOnOutsideClick: (0, $8XtVW.fg)('platform_dst_nav4_flyout_use_capture_outside'),
        shouldFitViewport: true,
        testId: containerTestId,
        xcss: $55a9f7f75fda1e18$var$flyoutMenuItemContentStyles.root,
        autoFocus: autoFocus,
        /**
   * Disabling GPU acceleration removes the use of `transform` by popper.js for this popup.
   *
   * This allows makers to use popups with `shouldRenderToParent` inside the flyout.
   *
   * Without this, the `transform` makes the flyout the containing element for fixed positioning.
   * Because the flyout is also a scroll container then any nested, layered element is unable to
   * escape the flyout.
   *
   * Disabling the `transform` is the simplest way to resolve this layering issue,
   * and should have negligible performance impacts, because the flyout menus should rarely
   * need to be repositioned.
   */ shouldDisableGpuAcceleration: true,
        children: ({ update: update })=>/*#__PURE__*/ (0, $gt9Am.jsx)($55a9f7f75fda1e18$var$UpdatePopperOnContentResize, {
                ref: forwardedRef,
                update: update,
                children: children
            })
    });
});
function $55a9f7f75fda1e18$var$createResizeObserver(update) {
    return new ResizeObserver(update);
}
/**
 * Will call the Popper.js `update()` method to recalculate positioning, when the flyout menu changes size.
 * This is the size of the scroll container, NOT the scroll content.
 *
 * We could potentially bake this into `@atlaskit/popup` or `@atlaskit/popper` but there are a few
 * reasons to keep it scoped to flyout menus for now:
 *
 * 1. It's easier to unwind
 * 2. We've only had bug reports for flyout menus
 * 3. Popup exposes the `update` function so consumers can already do this themselves if necessary
 * 4. Flyout menus are a lot more restricted to other popups, it might not make sense more generally
 */ const $55a9f7f75fda1e18$var$UpdatePopperOnContentResize = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ update: update, children: children }, forwardedRef)=>{
    /**
   * Storing our `update` function in a ref so that we have a stable reference to it.
   * We need this because our `ResizeObserver` callback cannot be changed after creating it.
   */ const updateRef = (0, $eJOHy.useRef)(update);
    (0, $eJOHy.useEffect)(()=>{
        updateRef.current = update;
    }, [
        update
    ]);
    /**
   * Stable function that calls the latest `update` function by calling it through the stable ref.
   */ const triggerUpdate = (0, $eJOHy.useCallback)(()=>{
        updateRef.current?.();
    }, []);
    const [resizeObserver] = (0, $eJOHy.useState)(()=>$55a9f7f75fda1e18$var$createResizeObserver(triggerUpdate));
    /**
   * This is a callback ref that will update which `HTMLElement` we are observing,
   * if or when the underlying `HTMLElement` changes or unmounts.
   */ const observeCallbackRef = (0, $eJOHy.useCallback)((element)=>{
        /**
     * Unobserves all observed elements.
     * Allows us to cleanup without needing to store a reference to the previous element.
     */ resizeObserver.disconnect();
        if (!element) return;
        resizeObserver.observe(element);
    }, [
        resizeObserver
    ]);
    /**
   * We need to memoize the ref otherwise `triggerUpdate` is repeatedly called.
   *
   * This stems from ResizeObserver firing once after calling `.observe()` even if there
   * was no resize.
   *
   * Without memoizing the ref, the update causes a rerender, which causes the ref to
   * get recreated, which triggers an update and so on in a loop.
   */ const ref = (0, $eJOHy.useMemo)(()=>{
        return (0, $i15ln.default)([
            forwardedRef,
            observeCallbackRef
        ]);
    }, [
        forwardedRef,
        observeCallbackRef
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        children: children
    });
});

});

parcelRegister("63KSu", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuItemTrigger", () => $c8f78472f606cb63$export$9f59f399fe37b6ca);
/* flyout-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $i15ln = parcelRequire("i15ln");

var $abxMj = parcelRequire("abxMj");

var $42Y7K = parcelRequire("42Y7K");

var $gX9lg = parcelRequire("gX9lg");
const $c8f78472f606cb63$var$elemAfterStyles = {
    root: "_18zr12x7 _1tz3r0mg"
};
const $c8f78472f606cb63$export$9f59f399fe37b6ca = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, elemBefore: elemBefore, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $42Y7K.PopupTrigger), {
        children: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $gX9lg.MenuItemBase), {
                testId: testId,
                ref: (0, $i15ln.default)([
                    ref,
                    forwardedRef
                ]),
                visualContentRef: visualContentRef,
                elemBefore: elemBefore,
                elemAfter: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $c8f78472f606cb63$var$elemAfterStyles.root
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($abxMj))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)",
                        size: "small"
                    })
                }),
                onClick: onClick,
                ariaControls: ariaControls,
                ariaExpanded: ariaExpanded,
                ariaHasPopup: ariaHasPopup,
                interactionName: interactionName,
                isContentTooltipDisabled: isContentTooltipDisabled,
                isSelected: isSelected,
                isDragging: isDragging,
                hasDragIndicator: hasDragIndicator,
                dropIndicator: dropIndicator,
                children: children
            })
    }));

});





parcelRegister("9VG2G", function(module, exports) {

$parcel$export(module.exports, "Nav4Communications", () => $46c1c00f0333754c$export$2d3b6d12e7bc4c2d);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $16sa1 = parcelRequire("16sa1");

var $bA5FY = parcelRequire("bA5FY");

const $46c1c00f0333754c$export$2d3b6d12e7bc4c2d = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4-sidebar-communications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "communications-section",
        packageName: (0, $a37711eec4b49670$export$b8b9d90f9e5bd72b),
        teamName: (0, $a37711eec4b49670$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bA5FY.Nav4Communications), props)));
};

});
parcelRegister("bA5FY", function(module, exports) {

$parcel$export(module.exports, "Nav4Communications", () => $fb93c017070dea7b$export$2d3b6d12e7bc4c2d);

var $eJOHy = parcelRequire("eJOHy");

var $262zM = parcelRequire("262zM");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $2QH3X = parcelRequire("2QH3X");

var $lvrbL = parcelRequire("lvrbL");

var $i0tMD = parcelRequire("i0tMD");


var $h4Bzb = parcelRequire("h4Bzb");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $2LcvY = parcelRequire("2LcvY");



var $azEgq = parcelRequire("azEgq");

var $eL2Ux = parcelRequire("eL2Ux");

var $8IuE5 = parcelRequire("8IuE5");

var $7jTnu = parcelRequire("7jTnu");

var $EH2nX = parcelRequire("EH2nX");
const $fb93c017070dea7b$export$2d3b6d12e7bc4c2d = ({ isExpanded: isExpanded = false })=>{
    const { icon: stakeholdersIcon, formattedMessage: stakeholdersMessage } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $EH2nX.default).stakeholders, (0, (/*@__PURE__*/$parcel$interopDefault($262zM))));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { formattedMessage: triggerFormattedMessage, icon: triggerIcon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).COMMUNICATION);
    const menuId = (0, $h4Bzb.MENU_ID_COMMUNICATION);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: menuId,
        isExpanded: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        testId: (0, $azEgq.getTestId)(menuId),
        elemBefore: triggerIcon,
        interactionName: (0, $7jTnu.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-communication' : undefined
    }, triggerFormattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        menuId: (0, $h4Bzb.MENU_ID_COMMUNICATIONS_STAKEHOLDERS),
        href: "/jira/communications/stakeholders",
        elemBefore: stakeholdersIcon,
        onClick: ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_COMMUNICATION],
                attributes: {
                    componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                    level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                    itemId: 'stakeholders'
                }
            });
        }
    }, stakeholdersMessage)));
};

});
parcelRegister("EH2nX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3519775a011f003$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f3519775a011f003$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    communication: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-communications.communications.non-final",
        "defaultMessage": "Communications"
    },
    overview: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-communications.overview.non-final",
        "defaultMessage": "Overview"
    },
    statusPages: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-communications.status-pages.non-final",
        "defaultMessage": "Status Pages"
    },
    communicationPlans: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-communications.communication-plans.non-final",
        "defaultMessage": "Communication Plans"
    },
    stakeholders: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-communications.stakeholders.non-final",
        "defaultMessage": "Stakeholders"
    },
    channels: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-communications.channels.non-final",
        "defaultMessage": "Channels"
    },
    reports: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-communications.reports.non-final",
        "defaultMessage": "Reports"
    }
});

});


const $a37711eec4b49670$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Communications';
const $a37711eec4b49670$export$d57b6b390e78d90f = 'Alexstrasza';


parcelRegister("eJYI8", function(module, exports) {

$parcel$export(module.exports, "useShouldRenderOverviews", () => $3b05ddd8a3a311d9$export$4ce95cd18a7f8574);

var $7jTnu = parcelRequire("7jTnu");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");
const $3b05ddd8a3a311d9$export$4ce95cd18a7f8574 = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    if (!(0, $7jTnu.fg)('blu-2858-sidebar-menu-overviews')) return false;
    // JSW Premium does not have Overviews because it has the newer Plans feature available
    if (appEditions.software === (0, $a9ldn.PREMIUM_EDITION)) return false;
    // JWM Premium has Overviews if JSW Premium is not also present
    // Note: This means there are some cases where both the Plans and Overviews menu items will be available;
    // in these cases it's because the user should see the Plans upsell (that logic is taken care of within the Plans menu item)
    if (appEditions.core === (0, $a9ldn.PREMIUM_EDITION)) return true;
    // JSM Premium has Overviews if any edition of JWM is also present
    if (appEditions.serviceDesk === (0, $a9ldn.PREMIUM_EDITION) && (appEditions.core === (0, $a9ldn.FREE_EDITION) || appEditions.core === (0, $a9ldn.STANDARD_EDITION))) return true;
    return false;
};

});

parcelRegister("iPxs6", function(module, exports) {

$parcel$export(module.exports, "Nav4Overviews", () => $b6c1a8194153adf9$export$2c62779314f9754a);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $16sa1 = parcelRequire("16sa1");


var $3xLqx = parcelRequire("3xLqx");
function $b6c1a8194153adf9$export$2c62779314f9754a(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4-sidebar-overviews"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "overviews-section",
        packageName: (0, $f060c5ec297fdc54$export$b8b9d90f9e5bd72b),
        teamName: (0, $f060c5ec297fdc54$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3xLqx.Nav4Overviews), props)));
}

});
const $f060c5ec297fdc54$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Overviews';
const $f060c5ec297fdc54$export$d57b6b390e78d90f = 'jira-cosmos';

parcelRegister("3xLqx", function(module, exports) {

$parcel$export(module.exports, "Nav4Overviews", () => $569981bb8bec455b$export$2c62779314f9754a);

var $dRFH5 = parcelRequire("dRFH5");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $jW3GZ = parcelRequire("jW3GZ");

var $4JO6s = parcelRequire("4JO6s");

var $j9mbP = parcelRequire("j9mbP");
function $569981bb8bec455b$export$2c62779314f9754a({ isExpanded: isExpanded, queryRef: queryRef }) {
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const data = (0, $j4oe4.useFragment)((0, $dRFH5.default), queryRef);
    const actionButtons = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jW3GZ.SectionActions), {
            totalCount: data?.jira?.jwmOverviews?.totalCount ?? 0
        }), [
        data?.jira?.jwmOverviews?.totalCount
    ]);
    return isInitialSelectedPath((0, $h4Bzb.MENU_ID_OVERVIEWS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j9mbP.Nav4OverviewsForLanding), {
        isExpanded: isExpanded,
        queryRef: data,
        actionsOnHover: actionButtons
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4JO6s.Nav4OverviewsDefault), {
        isExpanded: isExpanded,
        actionsOnHover: actionButtons
    });
}

});
parcelRegister("dRFH5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e63127712a98485$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d103d7389206befab32513e4690206a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5e63127712a98485$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "isOverviewsExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Overviews",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraWorkManagementGiraOverviewConnection",
                    "kind": "LinkedField",
                    "name": "jwmOverviews",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "isOverviewsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4OverviewsForLanding"
                }
            ]
        }
    ],
    "type": "Query"
};
$5e63127712a98485$var$node.hash = "49456eee5b5999aee543e784e4db7323";
var $5e63127712a98485$export$2e2bcd8739ae039 = $5e63127712a98485$var$node;

});

parcelRegister("jW3GZ", function(module, exports) {

$parcel$export(module.exports, "SectionActions", () => $232158f00e33113a$export$51f8029abf8c56ce);

var $eJOHy = parcelRequire("eJOHy");

var $i140O = parcelRequire("i140O");

var $6CZxU = parcelRequire("6CZxU");

var $jC5ye = parcelRequire("jC5ye");

var $dhRXV = parcelRequire("dhRXV");
var $9M9zY = parcelRequire("9M9zY");
var $h8epd = parcelRequire("h8epd");

var $9JB3T = parcelRequire("9JB3T");

var $3KGIw = parcelRequire("3KGIw");

var $lRq8t = parcelRequire("lRq8t");



var $2LcvY = parcelRequire("2LcvY");

var $2raQl = parcelRequire("2raQl");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $ajqBI = parcelRequire("ajqBI");

var $he6m3 = parcelRequire("he6m3");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $cNe2t = parcelRequire("cNe2t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $7jTnu = parcelRequire("7jTnu");

var $6bfva = parcelRequire("6bfva");
function $232158f00e33113a$export$51f8029abf8c56ce({ totalCount: totalCount }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isOpen: isOpen, onClose: onClose, onOpen: onOpen, onToggle: onToggle } = (0, $he6m3.useOpenable)();
    const { sendCreateOverviewAnalyticsEvent: sendCreateOverviewAnalyticsEvent } = (0, $2raQl.useOverviewsAnalyticsL1)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const fireOpenEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_OVERVIEWS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: 'meatballDropdown'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onCreateOverviewHandler = (0, $eJOHy.useCallback)(()=>{
        sendCreateOverviewAnalyticsEvent({
            overviewLimitReached: false
        });
        onOpen();
    }, [
        onOpen,
        sendCreateOverviewAnalyticsEvent
    ]);
    const onToggleOverviewHandler = (0, $eJOHy.useCallback)(()=>{
        sendCreateOverviewAnalyticsEvent({
            overviewLimitReached: true
        });
        onToggle();
    }, [
        onToggle,
        sendCreateOverviewAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, totalCount < 10 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jC5ye.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3KGIw.default), {
        onClose: onClose
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: formatMessage((0, $6bfva.default).createOverview)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i140O))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $6bfva.default).createOverview),
        onClick: onCreateOverviewHandler
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "right",
        messageId: "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.ui.section-actions.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
                padding: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
                space: "space.200",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6CZxU))), {
                spacing: "none",
                label: "",
                color: "var(--ds-icon-warning, #E56910)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, formatMessage((0, $6bfva.default).moreThanTenWarning)))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
                content: formatMessage((0, $6bfva.default).createOverview)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i140O))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: formatMessage((0, $6bfva.default).createOverview),
                onClick: onToggleOverviewHandler,
                ...triggerProps
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        MenuItems: (0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton') ? $232158f00e33113a$var$MoreMenuItems : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($232158f00e33113a$var$MoreMenuItems, null),
        onOpen: fireOpenEvent
    }));
}
function $232158f00e33113a$var$MoreMenuItems() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).OVERVIEWS
    });
}

});
parcelRegister("3KGIw", function(module, exports) {

$parcel$export(module.exports, "default", () => $550c3cd60bca5208$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3JNvy = parcelRequire("3JNvy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $fKhwG = parcelRequire("fKhwG");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $550c3cd60bca5208$var$LazyCreateOverviewModal = (0, $gzcjr.lazy)(()=>(parcelRequire("ivRrY")), {
    ssr: false,
    moduleId: "./src/packages/business/entity/overview/src/ui/create-overview-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$550c3cd60bca5208$export$2e2bcd8739ae039 = ({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3JNvy.ExperienceErrorBoundary), {
        experience: (0, $fKhwG.CREATE_OVERVIEW_EXPERIENCE),
        fallback: "unmount",
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "overview-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($550c3cd60bca5208$var$LazyCreateOverviewModal, {
        onClose: onClose
    })));

});
parcelRegister("3JNvy", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $6bb002e078714392$export$675e0d25df38d426);
$parcel$export(module.exports, "useExperienceAbort", () => $6bb002e078714392$export$cc92b7ce453f4403);
$parcel$export(module.exports, "useExperienceSuccess", () => $6bb002e078714392$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceFail", () => $6bb002e078714392$export$606da7704d8eaf06);
$parcel$export(module.exports, "useQueryBasedViewAutomaticTracking", () => $6bb002e078714392$export$8ca25d6ff1437be3);
$parcel$export(module.exports, "ExperienceStart", () => $6bb002e078714392$export$f20b867e738a222c);
$parcel$export(module.exports, "ExperienceFailed", () => $6bb002e078714392$export$ae65a9e09c4516b3);
$parcel$export(module.exports, "ExperienceErrorBoundary", () => $6bb002e078714392$export$139c4a4ad101c3c5);
$parcel$export(module.exports, "ExperienceSuccess", () => $6bb002e078714392$export$4962f3898bd5c829);
$parcel$export(module.exports, "ExperienceAbort", () => $6bb002e078714392$export$c9b6bcd70239a39c);

var $eJOHy = parcelRequire("eJOHy");

var $cnosT = parcelRequire("cnosT");

var $hWeHP = parcelRequire("hWeHP");

var $4FduV = parcelRequire("4FduV");

var $1KdDN = parcelRequire("1KdDN");

var $gYnSx = parcelRequire("gYnSx");

var $bFY6o = parcelRequire("bFY6o");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $1uIew = parcelRequire("1uIew");
const $6bb002e078714392$export$675e0d25df38d426 = ({ experience: experience, experienceId: experienceId, packageName: packageName })=>(0, $8Uqf3.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: packageName
    });
const $6bb002e078714392$export$cc92b7ce453f4403 = ({ experience: experience }, attributes)=>(0, $bFY6o.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
const $6bb002e078714392$var$shard = (0, $hWeHP.default)('ajs-shard');
const $6bb002e078714392$var$region = (0, $hWeHP.default)('ajs-region');
const $6bb002e078714392$export$e94f0da4fc0603c6 = ({ experience: experience })=>(0, $4ctwv.useExperienceSuccess)({
        experience: experience,
        attributes: {
            shard: $6bb002e078714392$var$shard,
            region: $6bb002e078714392$var$region
        }
    });
const $6bb002e078714392$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, packageName: packageName, teamName: teamName })=>{
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: experience,
        attributes: {
            shard: $6bb002e078714392$var$shard,
            region: $6bb002e078714392$var$region
        }
    });
    const onFail = (0, $eJOHy.useCallback)((location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, extraAttributes)=>{
        const relevantError = error?.networkError ?? error;
        if (relevantError instanceof (0, $1uIew.ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
        extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
        (0, $gYnSx.default)({
            meta: {
                id: `experience-tracker-${experienceId ?? experience}`,
                packageName: packageName,
                teamName: teamName
            },
            attributes: {
                location: location
            },
            error: relevantError,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail,
        experienceId,
        experience,
        packageName,
        teamName
    ]);
    return onFail;
};
const $6bb002e078714392$export$8ca25d6ff1437be3 = (experience, { loading: loading, error: error, shouldStartExperience: shouldStartExperience })=>{
    const [hasStarted, setHasStarted] = (0, $eJOHy.useState)(loading);
    const [hasCompleted, setHasCompleted] = (0, $eJOHy.useState)(false);
    const [hasExperienceBeenTracked, setHasExperienceBeenTracked] = (0, $eJOHy.useState)(false);
    const startExperience = $6bb002e078714392$export$675e0d25df38d426(experience);
    const onFail = $6bb002e078714392$export$606da7704d8eaf06(experience);
    const onSuccess = $6bb002e078714392$export$e94f0da4fc0603c6(experience);
    (0, $eJOHy.useEffect)(()=>{
        if (shouldStartExperience === true) startExperience();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldStartExperience
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (hasStarted === false && loading === true) setHasStarted(true);
        if (hasStarted === true && loading === false) {
            setHasCompleted(true);
            setHasExperienceBeenTracked(false);
        }
    }, [
        hasStarted,
        loading
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (hasCompleted && !hasExperienceBeenTracked) {
            // make sure experience is tracked once despite re-rendering of the view
            setHasExperienceBeenTracked(true);
            if (typeof error !== 'undefined') {
                onFail(`${experience.experience} ${experience.experienceId || ''} useEffect error handling`, error, (0, $cnosT.getGraphqlErrorAttributes)(error));
                return;
            }
            onSuccess({
                loaded: true
            });
        }
    }, [
        error,
        experience,
        hasCompleted,
        hasExperienceBeenTracked,
        onFail,
        onSuccess
    ]);
};
const $6bb002e078714392$export$f20b867e738a222c = /*#__PURE__*/ (0, $eJOHy.memo)(({ experience: experience })=>{
    const start = $6bb002e078714392$export$675e0d25df38d426(experience);
    (0, $eJOHy.useEffect)(()=>{
        start();
    }, [
        start
    ]);
    return null;
});
const $6bb002e078714392$export$ae65a9e09c4516b3 = /*#__PURE__*/ (0, $eJOHy.memo)(({ experience: experience, error: error, attributes: attributes })=>{
    const onFail = $6bb002e078714392$export$606da7704d8eaf06(experience);
    (0, $eJOHy.useEffect)(()=>{
        onFail(experience.experience, error, attributes);
    }, [
        attributes,
        error,
        experience,
        onFail
    ]);
    return null;
});
const $6bb002e078714392$export$139c4a4ad101c3c5 = ({ experience: experience, shouldStartExperience: shouldStartExperience, fallback: fallback = (0, $4FduV.ErrorPage), children: children })=>{
    const onFail = $6bb002e078714392$export$606da7704d8eaf06(experience);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: experience.packageName,
        teamName: experience.teamName,
        id: experience.experience,
        onError: onFail,
        fallback: fallback
    }, shouldStartExperience === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bb002e078714392$export$f20b867e738a222c, {
        experience: experience
    }), children);
};
const $6bb002e078714392$export$4962f3898bd5c829 = /*#__PURE__*/ (0, $eJOHy.memo)(({ experience: experience, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: experience.experience,
        attributes: {
            ...experience.experienceId == null ? undefined : {
                experienceId: experience.experienceId
            },
            ...attributes
        }
    }));
const $6bb002e078714392$export$c9b6bcd70239a39c = /*#__PURE__*/ (0, $eJOHy.memo)(({ experience: experience, error: error })=>{
    const onAbort = $6bb002e078714392$export$cc92b7ce453f4403(experience);
    (0, $eJOHy.useEffect)(()=>{
        onAbort(experience.experience, {
            error: error.message
        });
    }, [
        error,
        experience,
        onAbort
    ]);
    return null;
});

});
parcelRegister("cnosT", function(module, exports) {

$parcel$export(module.exports, "shouldHandleTheError", () => $37d219879073095e$export$47770c8b6d645cdb);
$parcel$export(module.exports, "getGraphqlErrorAttributes", () => $37d219879073095e$export$b19e649eafc62480);

var $eezJL = parcelRequire("eezJL");
const $37d219879073095e$var$errorWhitelist = [
    'EXPERIENCE_UNAVAILABLE',
    'FIELD_UNAVAILABLE',
    'ISSUE_UNAVAILABLE'
];
const $37d219879073095e$export$47770c8b6d645cdb = (error)=>{
    if (error?.networkError) return true;
    // when issue links are disabled at the instance level and we request it, it throws an error but we still get the whole response
    // There is a issue links perm check that happens after loading the list so the UI already deals with this properly and we can ignore it
    // similarly, even when issue links are enabled, but the field itself is hidden in every screen it will throw an error but we'll still get the whole response
    const filterIssueLinksDisabledErrors = (graphQLError)=>{
        const isWhitelisted = $37d219879073095e$var$errorWhitelist.includes(graphQLError?.extensions?.errorType);
        return !isWhitelisted;
    };
    const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueLinksDisabledErrors);
    return errorsToShow.length > 0;
};
const $37d219879073095e$export$b19e649eafc62480 = (error)=>{
    const isApolloError = error instanceof (0, $eezJL.ApolloError);
    if (!isApolloError) return {};
    const getErrorAttribute = (graphQLErrors, errorAttribute)=>{
        const errors = graphQLErrors.map((graphQLError)=>graphQLError?.extensions?.[errorAttribute]).filter(Boolean);
        return JSON.stringify(errors);
    };
    return {
        statusCodes: getErrorAttribute(error?.graphQLErrors || [], 'statusCode'),
        errorTypes: getErrorAttribute(error?.graphQLErrors || [], 'errorType')
    };
};

});
parcelRegister("eezJL", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $a5ce1825a60c4eb2$export$bd096ddbd246c79c);
$parcel$export(module.exports, "isApolloError", () => $a5ce1825a60c4eb2$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "ApolloError", () => $a5ce1825a60c4eb2$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $a5ce1825a60c4eb2$export$13f5a5f0f1dbab88);

var $dnskZ = parcelRequire("dnskZ");

var $jFDfc = parcelRequire("jFDfc");
var $hR4hP = parcelRequire("hR4hP");

var $7oe8F = parcelRequire("7oe8F");
var $1ZCcZ = parcelRequire("1ZCcZ");

var $2KZeD = parcelRequire("2KZeD");

var $lDEi6 = parcelRequire("lDEi6");

var $9E3xk = parcelRequire("9E3xk");
var $a5ce1825a60c4eb2$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($a5ce1825a60c4eb2$export$bd096ddbd246c79c || ($a5ce1825a60c4eb2$export$bd096ddbd246c79c = {}));
function $a5ce1825a60c4eb2$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $a5ce1825a60c4eb2$var$Observable = function(_super) {
    (0, $dnskZ.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $2KZeD.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $1ZCcZ.default));
function $a5ce1825a60c4eb2$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $a5ce1825a60c4eb2$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $a5ce1825a60c4eb2$var$generateErrorMessage = function(err) {
    var message = '';
    if ($a5ce1825a60c4eb2$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $a5ce1825a60c4eb2$export$26a337512320b8c6 = function(_super) {
    (0, $dnskZ.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $a5ce1825a60c4eb2$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $a5ce1825a60c4eb2$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($a5ce1825a60c4eb2$export$160bafb6ac1e0641 || ($a5ce1825a60c4eb2$export$160bafb6ac1e0641 = {}));
var $a5ce1825a60c4eb2$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $a5ce1825a60c4eb2$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $a5ce1825a60c4eb2$export$6c1b56eac59c9584 = function(_super) {
    (0, $dnskZ.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $jFDfc.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $a5ce1825a60c4eb2$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($a5ce1825a60c4eb2$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $a5ce1825a60c4eb2$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $a5ce1825a60c4eb2$export$bd096ddbd246c79c.loading : $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
            stale: false
        }));
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $hR4hP.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $lDEi6.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $hR4hP.equal)(this.variables, variables)) this.variables = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.variables), variables);
        if (!(0, $hR4hP.equal)(this.options.variables, this.variables)) this.options.variables = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $a5ce1825a60c4eb2$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $lDEi6.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $dnskZ.__assign)((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $a5ce1825a60c4eb2$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $hR4hP.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $jFDfc.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $a5ce1825a60c4eb2$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $jFDfc.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $a5ce1825a60c4eb2$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $a5ce1825a60c4eb2$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $a5ce1825a60c4eb2$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $a5ce1825a60c4eb2$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $hR4hP.equal)(previousVariables, variables)) _this.refetch();
                        else $a5ce1825a60c4eb2$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $a5ce1825a60c4eb2$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($a5ce1825a60c4eb2$var$Observable);
function $a5ce1825a60c4eb2$var$defaultSubscriptionObserverErrorCallback(error) {}
function $a5ce1825a60c4eb2$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $a5ce1825a60c4eb2$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $lDEi6.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $a5ce1825a60c4eb2$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $a5ce1825a60c4eb2$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $lDEi6.invariant)(!previousQuery || previousQuery.document === query.document || (0, $hR4hP.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $a5ce1825a60c4eb2$export$bd096ddbd246c79c.loading) {
            if (!(0, $hR4hP.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.refetch;
        else networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $a5ce1825a60c4eb2$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $a5ce1825a60c4eb2$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $a5ce1825a60c4eb2$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $a5ce1825a60c4eb2$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $jFDfc.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $jFDfc.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            return (0, $dnskZ.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $jFDfc.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $jFDfc.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $lDEi6.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            return (0, $dnskZ.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $dnskZ.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $9E3xk.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $9E3xk.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $jFDfc.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $dnskZ.__generator)(this, function(_b) {
                mainDefinition = (0, $jFDfc.getMainDefinition)(document);
                fragments = (0, $jFDfc.getFragmentDefinitions)(document);
                fragmentMap = (0, $jFDfc.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $a5ce1825a60c4eb2$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $dnskZ.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $dnskZ.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $dnskZ.__generator)(this, function(_a) {
                            if (!(0, $jFDfc.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $jFDfc.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $jFDfc.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $jFDfc.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $lDEi6.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $jFDfc.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $dnskZ.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $jFDfc.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $jFDfc.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $a5ce1825a60c4eb2$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $a5ce1825a60c4eb2$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $a5ce1825a60c4eb2$var$asyncMap(observable, mapFn) {
    return new $a5ce1825a60c4eb2$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $a5ce1825a60c4eb2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $a5ce1825a60c4eb2$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $a5ce1825a60c4eb2$var$MutationStore();
        this.queryStore = new $a5ce1825a60c4eb2$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $jFDfc.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $a5ce1825a60c4eb2$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $lDEi6.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $dnskZ.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $lDEi6.invariant)(mutation, 9);
                        (0, $lDEi6.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $a5ce1825a60c4eb2$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $jFDfc.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($a5ce1825a60c4eb2$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $jFDfc.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $dnskZ.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $dnskZ.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $jFDfc.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $a5ce1825a60c4eb2$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $a5ce1825a60c4eb2$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($a5ce1825a60c4eb2$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $a5ce1825a60c4eb2$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $a5ce1825a60c4eb2$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $jFDfc.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $jFDfc.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $jFDfc.getDefaultValues)((0, $jFDfc.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $lDEi6.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $dnskZ.__assign)({}, options);
        return new $a5ce1825a60c4eb2$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $lDEi6.invariant)(options.query, 12);
        (0, $lDEi6.invariant)(options.query.kind === 'Document', 13);
        (0, $lDEi6.invariant)(!options.returnPartialData, 14);
        (0, $lDEi6.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $lDEi6.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $jFDfc.graphQLResultHasError)(result)) throw new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $a5ce1825a60c4eb2$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $lDEi6.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $jFDfc.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $a5ce1825a60c4eb2$var$multiplex((0, $7oe8F.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $a5ce1825a60c4eb2$var$multiplex((0, $7oe8F.execute)(link, operation));
        } else {
            observable = $a5ce1825a60c4eb2$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $a5ce1825a60c4eb2$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $a5ce1825a60c4eb2$var$isNonEmptyArray(result.errors)) return reject(new $a5ce1825a60c4eb2$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $a5ce1825a60c4eb2$export$bd096ddbd246c79c.ready && query.networkStatus !== $a5ce1825a60c4eb2$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $lDEi6.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $a5ce1825a60c4eb2$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $a5ce1825a60c4eb2$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $jFDfc.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $jFDfc.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $jFDfc.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $jFDfc.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $jFDfc.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $jFDfc.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $jFDfc.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $a5ce1825a60c4eb2$var$version = "2.6.10";
var $a5ce1825a60c4eb2$var$hasSuggestedDevtools = false;
var $a5ce1825a60c4eb2$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $7oe8F.ApolloLink).empty();
        if (!link || !cache) throw new (0, $lDEi6.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $a5ce1825a60c4eb2$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $a5ce1825a60c4eb2$var$version;
        this.localState = new $a5ce1825a60c4eb2$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $a5ce1825a60c4eb2$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.defaultOptions.query), options);
        (0, $lDEi6.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $7oe8F.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $a5ce1825a60c4eb2$export$2e2bcd8739ae039 = $a5ce1825a60c4eb2$export$13f5a5f0f1dbab88;

});
parcelRegister("jFDfc", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $e52049bf830e5717$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $e52049bf830e5717$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $e52049bf830e5717$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $e52049bf830e5717$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $e52049bf830e5717$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $e52049bf830e5717$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $e52049bf830e5717$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $e52049bf830e5717$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $e52049bf830e5717$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $e52049bf830e5717$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $e52049bf830e5717$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $e52049bf830e5717$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $e52049bf830e5717$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $e52049bf830e5717$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $e52049bf830e5717$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $e52049bf830e5717$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $e52049bf830e5717$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $e52049bf830e5717$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $e52049bf830e5717$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $e52049bf830e5717$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $e52049bf830e5717$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $e52049bf830e5717$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $e52049bf830e5717$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $e52049bf830e5717$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $e52049bf830e5717$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $e52049bf830e5717$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $e52049bf830e5717$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $e52049bf830e5717$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $e52049bf830e5717$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $e52049bf830e5717$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $e52049bf830e5717$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $e52049bf830e5717$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $e52049bf830e5717$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $e52049bf830e5717$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $e52049bf830e5717$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $e52049bf830e5717$export$160070228be94b08);

var $9E3xk = parcelRequire("9E3xk");

var $lDEi6 = parcelRequire("lDEi6");

var $dnskZ = parcelRequire("dnskZ");

var $5OKCR = parcelRequire("5OKCR");

var $hR4hP = parcelRequire("hR4hP");

var $igDjg = parcelRequire("igDjg");
function $e52049bf830e5717$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $e52049bf830e5717$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $e52049bf830e5717$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $e52049bf830e5717$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $e52049bf830e5717$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $e52049bf830e5717$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $e52049bf830e5717$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $e52049bf830e5717$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $e52049bf830e5717$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $e52049bf830e5717$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $e52049bf830e5717$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $e52049bf830e5717$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($e52049bf830e5717$var$isIntValue(value) || $e52049bf830e5717$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($e52049bf830e5717$var$isBooleanValue(value) || $e52049bf830e5717$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($e52049bf830e5717$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $e52049bf830e5717$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($e52049bf830e5717$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($e52049bf830e5717$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $e52049bf830e5717$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($e52049bf830e5717$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($e52049bf830e5717$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $lDEi6.InvariantError)(17);
}
function $e52049bf830e5717$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e52049bf830e5717$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e52049bf830e5717$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $e52049bf830e5717$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $e52049bf830e5717$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $e52049bf830e5717$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($5OKCR)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($e52049bf830e5717$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $e52049bf830e5717$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e52049bf830e5717$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $e52049bf830e5717$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $e52049bf830e5717$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $e52049bf830e5717$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $e52049bf830e5717$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $e52049bf830e5717$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $dnskZ.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $e52049bf830e5717$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $e52049bf830e5717$var$defaultValueFromVariable(node) {
    throw new (0, $lDEi6.InvariantError)(18);
}
function $e52049bf830e5717$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $e52049bf830e5717$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $e52049bf830e5717$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $e52049bf830e5717$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $e52049bf830e5717$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $e52049bf830e5717$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $e52049bf830e5717$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $e52049bf830e5717$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $lDEi6.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $e52049bf830e5717$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $9E3xk.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $e52049bf830e5717$export$2dafb573e282fe8d(names, doc) {
    return $e52049bf830e5717$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $e52049bf830e5717$export$8d1e9e5bbfa5d09a(document) {
    return document && $e52049bf830e5717$export$2dafb573e282fe8d([
        'client'
    ], document) && $e52049bf830e5717$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $e52049bf830e5717$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $e52049bf830e5717$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($e52049bf830e5717$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $lDEi6.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $lDEi6.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $lDEi6.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $e52049bf830e5717$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $lDEi6.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $lDEi6.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, document), {
        definitions: (0, $dnskZ.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $e52049bf830e5717$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $e52049bf830e5717$export$a92e7a440b22bdf0(doc) {
    $e52049bf830e5717$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $lDEi6.invariant)(mutationDef, 1);
    return mutationDef;
}
function $e52049bf830e5717$export$a7d0d8111d2386df(doc) {
    (0, $lDEi6.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $lDEi6.InvariantError)(3);
        return definition;
    });
    (0, $lDEi6.invariant)(operations.length <= 1, 4);
    return doc;
}
function $e52049bf830e5717$export$7a5b1fa979d2c158(doc) {
    $e52049bf830e5717$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $e52049bf830e5717$export$78a8e95d8d43ad7f(document) {
    var def = $e52049bf830e5717$export$7a5b1fa979d2c158(document);
    (0, $lDEi6.invariant)(def, 5);
    return def;
}
function $e52049bf830e5717$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $e52049bf830e5717$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $e52049bf830e5717$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $e52049bf830e5717$export$7a5b1fa979d2c158(doc);
    (0, $lDEi6.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $e52049bf830e5717$export$772111caef41b3f5(doc) {
    (0, $lDEi6.invariant)(doc.kind === 'Document', 7);
    (0, $lDEi6.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $lDEi6.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $e52049bf830e5717$export$f431198736b7f96d(queryDoc) {
    $e52049bf830e5717$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $lDEi6.InvariantError)(10);
}
function $e52049bf830e5717$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $e52049bf830e5717$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $e52049bf830e5717$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $e52049bf830e5717$export$e6e34fd1f2686227.apply(void 0, (0, $dnskZ.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $e52049bf830e5717$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $e52049bf830e5717$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $e52049bf830e5717$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $e52049bf830e5717$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $e52049bf830e5717$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $e52049bf830e5717$var$nullIfDocIsEmpty(doc) {
    return $e52049bf830e5717$var$isEmpty($e52049bf830e5717$export$7a5b1fa979d2c158(doc) || $e52049bf830e5717$export$772111caef41b3f5(doc), $e52049bf830e5717$export$193789b4c8246dd4($e52049bf830e5717$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $e52049bf830e5717$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $e52049bf830e5717$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $e52049bf830e5717$var$nullIfDocIsEmpty((0, $9E3xk.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($e52049bf830e5717$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $e52049bf830e5717$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($e52049bf830e5717$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $e52049bf830e5717$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $e52049bf830e5717$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $e52049bf830e5717$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $e52049bf830e5717$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $e52049bf830e5717$export$43b332f87950a467(doc) {
    return (0, $9E3xk.visit)($e52049bf830e5717$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $e52049bf830e5717$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($e52049bf830e5717$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, node), {
                    selections: (0, $dnskZ.__spreadArrays)(selections, [
                        $e52049bf830e5717$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $e52049bf830e5717$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $e52049bf830e5717$export$74985f3324559867(doc) {
    return $e52049bf830e5717$export$e5ae0530da5fe96c([
        $e52049bf830e5717$var$connectionRemoveConfig
    ], $e52049bf830e5717$export$a7d0d8111d2386df(doc));
}
function $e52049bf830e5717$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $e52049bf830e5717$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $e52049bf830e5717$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$e52049bf830e5717$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($e52049bf830e5717$var$getDirectiveMatcher(directives)) || nestedCheck && $e52049bf830e5717$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $e52049bf830e5717$export$deed3420cb5d2e1d(directives, doc) {
    $e52049bf830e5717$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $e52049bf830e5717$var$nullIfDocIsEmpty((0, $9E3xk.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $e52049bf830e5717$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($e52049bf830e5717$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $e52049bf830e5717$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $e52049bf830e5717$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $e52049bf830e5717$var$getArgumentMatcher(config);
    return $e52049bf830e5717$var$nullIfDocIsEmpty((0, $9E3xk.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $e52049bf830e5717$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $e52049bf830e5717$var$nullIfDocIsEmpty((0, $9E3xk.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $e52049bf830e5717$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($e52049bf830e5717$export$fb56ad75dd311c12(selection) || $e52049bf830e5717$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $e52049bf830e5717$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $e52049bf830e5717$export$57c368c23873f32b(document) {
    var definition = $e52049bf830e5717$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $9E3xk.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $e52049bf830e5717$export$8eae69e876ee321e(document) {
    $e52049bf830e5717$export$a7d0d8111d2386df(document);
    var modifiedDoc = $e52049bf830e5717$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $9E3xk.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $e52049bf830e5717$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $e52049bf830e5717$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $e52049bf830e5717$var$toString = Object.prototype.toString;
function $e52049bf830e5717$export$629a2bd3f5a49ecc(value) {
    return $e52049bf830e5717$var$cloneDeepHelper(value, new Map());
}
function $e52049bf830e5717$var$cloneDeepHelper(val, seen) {
    switch($e52049bf830e5717$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $e52049bf830e5717$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $e52049bf830e5717$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $e52049bf830e5717$export$4bd44a2aa29d3d6e() {
    if (typeof $igDjg !== 'undefined' && "production") return "production";
    return 'development';
}
function $e52049bf830e5717$export$f0cb0fda19c18b37(env) {
    return $e52049bf830e5717$export$4bd44a2aa29d3d6e() === env;
}
function $e52049bf830e5717$export$f15d00aa73aafac4() {
    return $e52049bf830e5717$export$f0cb0fda19c18b37('production') === true;
}
function $e52049bf830e5717$export$df77466336fe5355() {
    return $e52049bf830e5717$export$f0cb0fda19c18b37('development') === true;
}
function $e52049bf830e5717$export$410cbc2864fa25b5() {
    return $e52049bf830e5717$export$f0cb0fda19c18b37('test') === true;
}
function $e52049bf830e5717$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $e52049bf830e5717$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $e52049bf830e5717$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $e52049bf830e5717$var$deepFreeze(o[prop]);
    });
    return o;
}
function $e52049bf830e5717$export$7f9c177735b71f18(obj) {
    if ($e52049bf830e5717$export$df77466336fe5355() || $e52049bf830e5717$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $e52049bf830e5717$var$deepFreeze(obj);
    }
    return obj;
}
var $e52049bf830e5717$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e52049bf830e5717$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $e52049bf830e5717$export$160070228be94b08(sources);
}
function $e52049bf830e5717$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $e52049bf830e5717$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $e52049bf830e5717$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $e52049bf830e5717$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $e52049bf830e5717$var$mergeHelper(target, source, pastCopies) {
    if ($e52049bf830e5717$var$isObject(source) && $e52049bf830e5717$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $e52049bf830e5717$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($e52049bf830e5717$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $e52049bf830e5717$var$mergeHelper($e52049bf830e5717$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $e52049bf830e5717$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $dnskZ.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $e52049bf830e5717$var$haveWarned = Object.create({});
function $e52049bf830e5717$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$e52049bf830e5717$export$f15d00aa73aafac4() && !$e52049bf830e5717$var$haveWarned[msg]) {
        if (!$e52049bf830e5717$export$410cbc2864fa25b5()) $e52049bf830e5717$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $e52049bf830e5717$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("lDEi6", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $fc0c7e72915b693a$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $fc0c7e72915b693a$export$f5708dca728d7177);

var $dnskZ = parcelRequire("dnskZ");

var $igDjg = parcelRequire("igDjg");
var $fc0c7e72915b693a$var$genericMessage = "Invariant Violation";
var $fc0c7e72915b693a$var$_a = Object.setPrototypeOf, $fc0c7e72915b693a$var$setPrototypeOf = $fc0c7e72915b693a$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $fc0c7e72915b693a$var$_a;
var $fc0c7e72915b693a$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $fc0c7e72915b693a$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $fc0c7e72915b693a$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $fc0c7e72915b693a$var$genericMessage;
        $fc0c7e72915b693a$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $fc0c7e72915b693a$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $fc0c7e72915b693a$export$cea12affaee22fe8(message);
}
function $fc0c7e72915b693a$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $fc0c7e72915b693a$var$wrapConsoleMethod("warn");
    invariant.error = $fc0c7e72915b693a$var$wrapConsoleMethod("error");
})($fc0c7e72915b693a$export$f5708dca728d7177 || ($fc0c7e72915b693a$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $fc0c7e72915b693a$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $igDjg === "object") $fc0c7e72915b693a$export$e54fe5b0f43758f7 = $igDjg;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($fc0c7e72915b693a$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $fc0c7e72915b693a$var$invariant$1 = $fc0c7e72915b693a$export$f5708dca728d7177;
var $fc0c7e72915b693a$export$2e2bcd8739ae039 = $fc0c7e72915b693a$var$invariant$1;

});

parcelRegister("5OKCR", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("hR4hP", function(module, exports) {

$parcel$export(module.exports, "equal", () => $cffab61c3f329eee$export$411ce8e5a71e3069);
var $cffab61c3f329eee$var$_a = Object.prototype, $cffab61c3f329eee$var$toString = $cffab61c3f329eee$var$_a.toString, $cffab61c3f329eee$var$hasOwnProperty = $cffab61c3f329eee$var$_a.hasOwnProperty;
var $cffab61c3f329eee$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $cffab61c3f329eee$export$411ce8e5a71e3069(a, b) {
    try {
        return $cffab61c3f329eee$var$check(a, b);
    } finally{
        $cffab61c3f329eee$var$previousComparisons.clear();
    }
}
function $cffab61c3f329eee$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $cffab61c3f329eee$var$toString.call(a);
    var bTag = $cffab61c3f329eee$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($cffab61c3f329eee$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$cffab61c3f329eee$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$cffab61c3f329eee$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($cffab61c3f329eee$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$cffab61c3f329eee$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $cffab61c3f329eee$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $cffab61c3f329eee$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $cffab61c3f329eee$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $cffab61c3f329eee$export$2e2bcd8739ae039 = $cffab61c3f329eee$export$411ce8e5a71e3069;

});


parcelRegister("7oe8F", function(module, exports) {

$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("1ZCcZ")).default);

var $1ZCcZ = parcelRequire("1ZCcZ");

var $lDEi6 = parcelRequire("lDEi6");

var $dnskZ = parcelRequire("dnskZ");

var $jFDfc = parcelRequire("jFDfc");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $lDEi6.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $dnskZ.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $1ZCcZ.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $1ZCcZ.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $jFDfc.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $dnskZ.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $dnskZ.__assign)({}, context, next(context));
        else context = (0, $dnskZ.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $dnskZ.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $1ZCcZ.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $1ZCcZ.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $1ZCcZ.default).of() : rightLink.request(operation) || (0, $1ZCcZ.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $1ZCcZ.default).of() : rightLink.request(operation, forward) || (0, $1ZCcZ.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $1ZCcZ.default).of();
        }) || (0, $1ZCcZ.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $1ZCcZ.default).of();
        }) || (0, $1ZCcZ.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $lDEi6.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $1ZCcZ.default).of();
}

});
parcelRegister("1ZCcZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1739205cd9dd2c7e$export$2e2bcd8739ae039);

var $f2glY = parcelRequire("f2glY");
var $1739205cd9dd2c7e$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($f2glY)));
var $1739205cd9dd2c7e$export$2e2bcd8739ae039 = $1739205cd9dd2c7e$export$77cea355fa80b5f4;

});
parcelRegister("f2glY", function(module, exports) {

module.exports = (parcelRequire("kWUY2")).Observable;

});
parcelRegister("kWUY2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $f40569f3cd93f27d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f40569f3cd93f27d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f40569f3cd93f27d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f40569f3cd93f27d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f40569f3cd93f27d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $f40569f3cd93f27d$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $f40569f3cd93f27d$var$hasSymbol = function(name) {
    return $f40569f3cd93f27d$var$hasSymbols() && Boolean(Symbol[name]);
};
var $f40569f3cd93f27d$var$getSymbol = function(name) {
    return $f40569f3cd93f27d$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($f40569f3cd93f27d$var$hasSymbols() && !$f40569f3cd93f27d$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $f40569f3cd93f27d$var$SymbolIterator = $f40569f3cd93f27d$var$getSymbol('iterator');
var $f40569f3cd93f27d$var$SymbolObservable = $f40569f3cd93f27d$var$getSymbol('observable');
var $f40569f3cd93f27d$var$SymbolSpecies = $f40569f3cd93f27d$var$getSymbol('species'); // === Abstract Operations ===
function $f40569f3cd93f27d$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $f40569f3cd93f27d$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$f40569f3cd93f27d$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $f40569f3cd93f27d$var$Observable;
}
function $f40569f3cd93f27d$var$isObservable(x) {
    return x instanceof $f40569f3cd93f27d$var$Observable; // SPEC: Brand check
}
function $f40569f3cd93f27d$var$hostReportError(e) {
    if ($f40569f3cd93f27d$var$hostReportError.log) $f40569f3cd93f27d$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $f40569f3cd93f27d$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $f40569f3cd93f27d$var$hostReportError(e);
        }
    });
}
function $f40569f3cd93f27d$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $f40569f3cd93f27d$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $f40569f3cd93f27d$var$hostReportError(e);
    }
}
function $f40569f3cd93f27d$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $f40569f3cd93f27d$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $f40569f3cd93f27d$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $f40569f3cd93f27d$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $f40569f3cd93f27d$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $f40569f3cd93f27d$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $f40569f3cd93f27d$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $f40569f3cd93f27d$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $f40569f3cd93f27d$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $f40569f3cd93f27d$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $f40569f3cd93f27d$var$enqueue(function() {
            return $f40569f3cd93f27d$var$flushSubscription(subscription);
        });
        return;
    }
    $f40569f3cd93f27d$var$notifySubscription(subscription, type, value);
}
var $f40569f3cd93f27d$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $f40569f3cd93f27d$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $f40569f3cd93f27d$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $f40569f3cd93f27d$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $f40569f3cd93f27d$var$closeSubscription(this);
                    $f40569f3cd93f27d$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $f40569f3cd93f27d$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $f40569f3cd93f27d$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $f40569f3cd93f27d$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $f40569f3cd93f27d$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $f40569f3cd93f27d$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $f40569f3cd93f27d$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $f40569f3cd93f27d$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $f40569f3cd93f27d$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $f40569f3cd93f27d$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $f40569f3cd93f27d$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f40569f3cd93f27d$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f40569f3cd93f27d$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f40569f3cd93f27d$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $f40569f3cd93f27d$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f40569f3cd93f27d$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $f40569f3cd93f27d$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $f40569f3cd93f27d$var$getMethod(x, $f40569f3cd93f27d$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($f40569f3cd93f27d$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($f40569f3cd93f27d$var$hasSymbol('iterator')) {
                    method = $f40569f3cd93f27d$var$getMethod(x, $f40569f3cd93f27d$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $f40569f3cd93f27d$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $f40569f3cd93f27d$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $f40569f3cd93f27d$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $f40569f3cd93f27d$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $f40569f3cd93f27d$var$Observable;
if ($f40569f3cd93f27d$var$hasSymbols()) Object.defineProperty($f40569f3cd93f27d$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $f40569f3cd93f27d$var$SymbolObservable,
        hostReportError: $f40569f3cd93f27d$var$hostReportError
    },
    configurable: true
});

});






parcelRegister("4FduV", function(module, exports) {

$parcel$export(module.exports, "ErrorPage", () => $5a9f2d684a64d722$export$c120a0e80fd44ca6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cOy0I = parcelRequire("cOy0I");
const $5a9f2d684a64d722$export$c120a0e80fd44ca6 = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5a9f2d684a64d722$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cOy0I.JSErrorPageAsync), {
        error: error
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5a9f2d684a64d722$var$ErrorWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_bfhkvuon _syaz1fxt",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bFY6o", function(module, exports) {

$parcel$export(module.exports, "useExperienceAbort", () => $668c094dfa849c1f$export$cc92b7ce453f4403);

var $eJOHy = parcelRequire("eJOHy");

var $aSmR5 = parcelRequire("aSmR5");
const $668c094dfa849c1f$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $aSmR5.useExperienceContext)();
    const self = (0, $eJOHy.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $eJOHy.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};

});


parcelRegister("fKhwG", function(module, exports) {

$parcel$export(module.exports, "CREATE_OVERVIEW_EXPERIENCE", () => $553d93db7e345e1e$export$9b5e8e07ff330ef2);
$parcel$export(module.exports, "EDIT_OVERVIEW_EXPERIENCE", () => $553d93db7e345e1e$export$a58227116ceb8b81);
$parcel$export(module.exports, "DELETE_OVERVIEW_EXPERIENCE", () => $553d93db7e345e1e$export$e17a11e4247a14f7);
$parcel$export(module.exports, "MODAL_WIDTH", () => $553d93db7e345e1e$export$3d931b64f46140b3);

var $dPMMf = parcelRequire("dPMMf");
const $553d93db7e345e1e$var$PACKAGE_NAME = 'jiraBusinessEntityOverview';
const $553d93db7e345e1e$export$9b5e8e07ff330ef2 = {
    experience: 'create-overview',
    packageName: $553d93db7e345e1e$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $553d93db7e345e1e$export$a58227116ceb8b81 = {
    experience: 'edit-overview',
    packageName: $553d93db7e345e1e$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $553d93db7e345e1e$export$e17a11e4247a14f7 = {
    experience: 'delete-overview',
    packageName: $553d93db7e345e1e$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $553d93db7e345e1e$export$d03d4e78ea5b909a = (0, $dPMMf.gridSize) * 2;
const $553d93db7e345e1e$export$57ee5df6bad94642 = 400;
const $553d93db7e345e1e$export$7c9c92ba6b198ac4 = (0, $dPMMf.gridSize) * 3;
const $553d93db7e345e1e$export$c4232794452dc6e3 = 480;
const $553d93db7e345e1e$export$3d931b64f46140b3 = $553d93db7e345e1e$export$c4232794452dc6e3 + $553d93db7e345e1e$export$57ee5df6bad94642 + $553d93db7e345e1e$export$7c9c92ba6b198ac4 * 2 + $553d93db7e345e1e$export$d03d4e78ea5b909a * 2;
const $553d93db7e345e1e$var$MODAL_DIALOG_MARGIN = 120;
const $553d93db7e345e1e$export$68bc124b0fa13de0 = $553d93db7e345e1e$export$3d931b64f46140b3 + $553d93db7e345e1e$var$MODAL_DIALOG_MARGIN;

});
parcelRegister("dPMMf", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $5368467aa3534c05$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $5368467aa3534c05$export$7a57f79000377ca2);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $5368467aa3534c05$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $5368467aa3534c05$export$7be255094ccdc533);

var $408ts = parcelRequire("408ts");
const $5368467aa3534c05$export$6d8204c2cb2e06b8 = 8;
const $5368467aa3534c05$export$7a57f79000377ca2 = (0, $408ts.borderRadius)();
const $5368467aa3534c05$export$22dec01f2c854397 = 40;
const $5368467aa3534c05$export$dab5ea164c6f81a = 100;
const $5368467aa3534c05$export$7be255094ccdc533 = {
    banner: (0, $408ts.layers).navigation(),
    card: (0, $408ts.layers).card(),
    dialog: (0, $408ts.layers).dialog(),
    navigation: (0, $408ts.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $408ts.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $408ts.layers).navigation() - 1,
    layer: (0, $408ts.layers).layer(),
    blanket: (0, $408ts.layers).blanket(),
    modal: (0, $408ts.layers).modal(),
    flag: (0, $408ts.layers).flag(),
    spotlight: (0, $408ts.layers).spotlight(),
    tooltip: (0, $408ts.layers).tooltip(),
    mobileBanner: $5368467aa3534c05$export$dab5ea164c6f81a
};
const $5368467aa3534c05$export$b3219800bda33a1f = {
    issueIconSize: 16
};

});


parcelRegister("ivRrY", function(module, exports) {

let $d7a495515ba77718$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $d7a495515ba77718$var$load("k4gbU"),
    $d7a495515ba77718$var$load("1VRB2"),
    $d7a495515ba77718$var$load("bABhq"),
    $d7a495515ba77718$var$load("dOgQA")
]).then(()=>parcelRequire('h6nOp'));

});


parcelRegister("2raQl", function(module, exports) {

$parcel$export(module.exports, "useOverviewsAnalyticsL1", () => $b37d66aa4727c27d$export$209953a8bcc0c02c);

var $eJOHy = parcelRequire("eJOHy");



var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");



const $b37d66aa4727c27d$var$OVERVIEWS_NAVIGATION_MENU_ITEM = 'overviewsNavigationMenuItem';
const $b37d66aa4727c27d$export$209953a8bcc0c02c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const commonAttributes = (0, $eJOHy.useMemo)(()=>({
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            navigationLayer: (0, $002870cfa80d64f4$export$17ff3f7e02c6ac22)
        }), []);
    // fixed item - create overview (+) button on overviews menu (top level)
    const sendCreateOverviewAnalyticsEvent = (0, $eJOHy.useCallback)(({ overviewLimitReached: overviewLimitReached })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
            itemId: 'createOverview',
            overviewLimitReached: overviewLimitReached
        };
        (0, $gCeeo.fireUIAnalytics)(event, $b37d66aa4727c27d$var$OVERVIEWS_NAVIGATION_MENU_ITEM, attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // custom item - overview menu item that displays overview name (can be expandable menu or a link)
    const sendOverviewMenuItemAnalyticsEvent = (0, $eJOHy.useCallback)(({ overviewId: overviewId })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemType: (0, $6bf6536f83c22cfe$export$9cbb0f231a0ab7ea),
            itemId: overviewId
        };
        (0, $gCeeo.fireUIAnalytics)(event, $b37d66aa4727c27d$var$OVERVIEWS_NAVIGATION_MENU_ITEM, attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendOverviewMenuItemAnalyticsEvent: sendOverviewMenuItemAnalyticsEvent,
        sendCreateOverviewAnalyticsEvent: sendCreateOverviewAnalyticsEvent
    };
};

});

parcelRegister("6bfva", function(module, exports) {

$parcel$export(module.exports, "default", () => $05ea857bacda538a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $05ea857bacda538a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createOverview: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.section-actions.create-overview",
        "defaultMessage": "Create overview"
    },
    moreThanTenWarning: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.section-actions.more-than-ten-warning",
        "defaultMessage": "You\u2019ve reached the limit of 10 overviews."
    }
});

});


parcelRegister("4JO6s", function(module, exports) {

$parcel$export(module.exports, "Nav4OverviewsDefault", () => $3c6252c72160dfb4$export$b582325fc571fa20);

var $eJOHy = parcelRequire("eJOHy");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $if69u = parcelRequire("if69u");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $hPlDs = parcelRequire("hPlDs");

var $kEUB1 = parcelRequire("kEUB1");


var $bHvjm = parcelRequire("bHvjm");
function $3c6252c72160dfb4$export$b582325fc571fa20({ isExpanded: isExpanded, actionsOnHover: actionsOnHover }) {
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).OVERVIEWS);
    const cloudId = (0, $kEUB1.useCloudId)();
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $bHvjm.asyncOverviewsContentViewQuery), entryPointParams);
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: (0, $h4Bzb.MENU_ID_OVERVIEWS),
        onSystemToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $8IuE5.L1_MENU_ID).OVERVIEWS,
                    sectionItem: (0, $a9aec.SECTION_ITEM_OVERVIEW)
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-overviews-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $azEgq.getTestId)((0, $h4Bzb.MENU_ID_OVERVIEWS))
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-overviews-default",
        packageName: (0, $f060c5ec297fdc54$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $f060c5ec297fdc54$export$d57b6b390e78d90f),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    })));
}

});
parcelRegister("bHvjm", function(module, exports) {

$parcel$export(module.exports, "asyncOverviewsContentViewQuery", () => $27656ec5ceb1cafd$export$355176fbb80f2347);

var $jRrGZ = parcelRequire("jRrGZ");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $27656ec5ceb1cafd$export$355176fbb80f2347 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("pq4qs")).then(({ OverviewsContentViewQuery: OverviewsContentViewQuery })=>OverviewsContentViewQuery), {
        moduleId: "6f0ac280",
        moduleName: "OverviewsContentViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryRef: {
                    parameters: $jRrGZ.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("jRrGZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b6c34534cc18246$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<560d7e5e0cd70de1d6c924f49a1b8b29>>
 * @relayHash cf2a8f845ae7c967ae307cc40eb4b07f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e61d234924072f4c43fcca2a72d097f86d33239be52bd1855eefa77b25c7cd4c
const $4b6c34534cc18246$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "OverviewsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4OverviewsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "OverviewsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverview",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e61d234924072f4c43fcca2a72d097f86d33239be52bd1855eefa77b25c7cd4c",
            "metadata": {},
            "name": "OverviewsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4b6c34534cc18246$var$node.hash = "5c526a403c104de05313b5b30d6f67e2";
var $4b6c34534cc18246$export$2e2bcd8739ae039 = $4b6c34534cc18246$var$node;

});

parcelRegister("pq4qs", function(module, exports) {

let $04c68ef2df7b55c0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $04c68ef2df7b55c0$var$load("cq7e3").then(()=>parcelRequire('lyW48'));

});



parcelRegister("j9mbP", function(module, exports) {

$parcel$export(module.exports, "Nav4OverviewsForLanding", () => $05487267dc5385dd$export$a2711da4a3d7eaa1);

var $6bM9G = parcelRequire("6bM9G");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $1KdDN = parcelRequire("1KdDN");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $16sa1 = parcelRequire("16sa1");


var $2oZun = parcelRequire("2oZun");
function $05487267dc5385dd$export$a2711da4a3d7eaa1({ isExpanded: isExpanded, queryRef: queryRef, actionsOnHover: actionsOnHover }) {
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).OVERVIEWS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const data = (0, $j4oe4.useFragment)((0, $6bM9G.default), queryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).OVERVIEWS,
                sectionItem: (0, $a9aec.SECTION_ITEM_OVERVIEW)
            });
        },
        isExpanded: isExpanded,
        menuId: (0, $h4Bzb.MENU_ID_OVERVIEWS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-overviews-landing",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        // ref={triggerRef}
        testId: (0, $azEgq.getTestId)((0, $h4Bzb.MENU_ID_OVERVIEWS))
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4-sidebar-overviews-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "nav4-sidebar-overviews-landing",
        packageName: (0, $f060c5ec297fdc54$export$b8b9d90f9e5bd72b),
        teamName: (0, $f060c5ec297fdc54$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2oZun.Nav4OverviewsContent), {
        queryRef: data
    })))));
}

});
parcelRegister("6bM9G", function(module, exports) {

$parcel$export(module.exports, "default", () => $de48e0be3e8a7658$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<24c44c1cc97a0ce676ed07f685505cfc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $de48e0be3e8a7658$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4OverviewsForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4OverviewsContent"
        }
    ],
    "type": "Query"
};
$de48e0be3e8a7658$var$node.hash = "dca06bec8549dba3e1ff2c708224de6f";
var $de48e0be3e8a7658$export$2e2bcd8739ae039 = $de48e0be3e8a7658$var$node;

});

parcelRegister("2oZun", function(module, exports) {

$parcel$export(module.exports, "Nav4OverviewsContent", () => $48b6fab1134858a2$export$50145651ea4a827);

var $ifc1S = parcelRequire("ifc1S");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2y3Ci = parcelRequire("2y3Ci");
var $ilbtc = parcelRequire("ilbtc");
var $1swHh = parcelRequire("1swHh");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $hc6Nm = parcelRequire("hc6Nm");

var $7qpY8 = parcelRequire("7qpY8");

var $kEUB1 = parcelRequire("kEUB1");

var $8MqB9 = parcelRequire("8MqB9");

var $jBdlB = parcelRequire("jBdlB");
function $48b6fab1134858a2$export$50145651ea4a827({ queryRef: queryRef }) {
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const [{ jira: { jwmOverviews: jwmOverviews } }, refetch] = (0, $j4oe4.useRefetchableFragment)((0, $ifc1S.default), queryRef);
    (0, $hc6Nm.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $7qpY8.default,
        refetch: refetch,
        menuId: (0, $h4Bzb.MENU_ID_OVERVIEWS)
    });
    const items = (0, $eJOHy.useMemo)(()=>{
        const nodes = jwmOverviews?.edges?.filter(Boolean).map((edge)=>edge.node) || [];
        const list = nodes.filter(Boolean).map((node)=>node.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jBdlB.OverviewsMenuItem), {
                key: node.id,
                id: node.id,
                name: node.name
            }) : null).filter(Boolean) ?? [];
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        jwmOverviews
    ]);
    if (!items.hasItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8MqB9.OverviewsEmptyState), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, items.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, items.list))));
}

});
parcelRegister("ifc1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc1ea2f6b96985ce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36e48bbc800f6fcd05f9ae0af54e02a8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $7qpY8 = parcelRequire("7qpY8");
const $cc1ea2f6b96985ce$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $7qpY8.default)
        }
    },
    "name": "Nav4OverviewsContent",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraWorkManagementGiraOverviewConnection",
                        "kind": "LinkedField",
                        "name": "jwmOverviews",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraWorkManagementGiraOverview",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$cc1ea2f6b96985ce$var$node.hash = "e24d9b35e956ee89177e09fcc3033bc6";
var $cc1ea2f6b96985ce$export$2e2bcd8739ae039 = $cc1ea2f6b96985ce$var$node;

});
parcelRegister("7qpY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1eb1cf2fb88c14cb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<abb8f4cb57d30ce17b791d146f8f5c1e>>
 * @relayHash 89a071a83d7086613e54267a83ad5589
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e49fb6b80c74d3109cdaeee9b0845e45ba88362a09ef2d27ffccd0095c0d334
const $1eb1cf2fb88c14cb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4OverviewsContentQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4OverviewsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4OverviewsContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverview",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3e49fb6b80c74d3109cdaeee9b0845e45ba88362a09ef2d27ffccd0095c0d334",
            "metadata": {},
            "name": "Nav4OverviewsContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1eb1cf2fb88c14cb$var$node.hash = "e24d9b35e956ee89177e09fcc3033bc6";
var $1eb1cf2fb88c14cb$export$2e2bcd8739ae039 = $1eb1cf2fb88c14cb$var$node;

});


parcelRegister("8MqB9", function(module, exports) {

$parcel$export(module.exports, "OverviewsEmptyState", () => $0909d7b141b6d4e6$export$84d2991bdf490d9e);

var $eJOHy = parcelRequire("eJOHy");

var $h8epd = parcelRequire("h8epd");

var $lRq8t = parcelRequire("lRq8t");

var $eLY13 = parcelRequire("eLY13");

var $ddGCu = parcelRequire("ddGCu");
function $0909d7b141b6d4e6$export$84d2991bdf490d9e() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eLY13.EmptyContentMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
        size: "small",
        align: "center",
        color: "color.text.subtlest"
    }, formatMessage((0, $ddGCu.messages).noOverviews)));
}

});
parcelRegister("eLY13", function(module, exports) {

$parcel$export(module.exports, "EmptyContentMenuItem", () => $75c7d02bb13e7406$export$1d5b0e5e21ec7e84);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $dhRXV = parcelRequire("dhRXV");

var $ilbtc = parcelRequire("ilbtc");
const $75c7d02bb13e7406$var$styles = {
    box: "_18u01b66"
};
function $75c7d02bb13e7406$export$1d5b0e5e21ec7e84({ children: children }) {
    return /*#__PURE__*/ $eJOHy.createElement((0, $ilbtc.MenuListItem), null, /*#__PURE__*/ $eJOHy.createElement((0, $dhRXV.default), {
        paddingInline: "space.050",
        xcss: $75c7d02bb13e7406$var$styles.box
    }, children));
}

});

parcelRegister("ddGCu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $353b77fe11b3d064$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $353b77fe11b3d064$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    noOverviews: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.empty-state.no-overviews",
        "defaultMessage": "Once you create an overview, it'll show up here."
    }
});

});


parcelRegister("jBdlB", function(module, exports) {

$parcel$export(module.exports, "OverviewsMenuItem", () => $15dafb87ae9f2178$export$1110bfd7980f0ad5);

var $eJOHy = parcelRequire("eJOHy");

var $2raQl = parcelRequire("2raQl");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $i0tMD = parcelRequire("i0tMD");

var $eL2Ux = parcelRequire("eL2Ux");
function $15dafb87ae9f2178$export$1110bfd7980f0ad5({ id: id, name: name }) {
    const { icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).OVERVIEWS);
    const { sendOverviewMenuItemAnalyticsEvent: sendOverviewMenuItemAnalyticsEvent } = (0, $2raQl.useOverviewsAnalyticsL1)();
    const overviewUrl = `/jira/core/overviews/${id}/summary`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        onClick: ()=>{
            sendOverviewMenuItemAnalyticsEvent({
                overviewId: id
            });
        },
        href: overviewUrl,
        menuId: (0, $h4Bzb.ENTITY_ID).OVERVIEW(String(id)),
        elemBefore: icon
    }, name);
}

});





parcelRegister("2geah", function(module, exports) {

$parcel$export(module.exports, "Nav4Plans", () => $7b7c333549724e84$export$a9599e1720ee6c82);

var $eJOHy = parcelRequire("eJOHy");

var $j2LFL = parcelRequire("j2LFL");

var $1KdDN = parcelRequire("1KdDN");

var $16sa1 = parcelRequire("16sa1");


var $b4whf = parcelRequire("b4whf");

var $iiV6w = parcelRequire("iiV6w");
function $7b7c333549724e84$export$a9599e1720ee6c82(props) {
    const isStandardOrFree = (0, $j2LFL.useIsStandardOrFreeJSW)();
    const isUnlicensedJsw = (0, $j2LFL.useIsUnlicensedJSW)();
    if (isUnlicensedJsw) return null;
    if (isStandardOrFree) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iiV6w.Nav4PlansPremiumUpsellFeatureGate), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4.sidebar.plans"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "plans-section",
        packageName: (0, $5db379f8ce110c55$export$b8b9d90f9e5bd72b),
        teamName: (0, $5db379f8ce110c55$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b4whf.Nav4Plans), props)));
}

});
parcelRegister("j2LFL", function(module, exports) {

$parcel$export(module.exports, "useIsStandardOrFreeJSW", () => $5529ca801e310c63$export$5edaea31b41b30b);
$parcel$export(module.exports, "useIsPremiumJSW", () => $5529ca801e310c63$export$d245a3118a8b4004);
$parcel$export(module.exports, "useIsUnlicensedJSW", () => $5529ca801e310c63$export$47ec61465121ff53);

var $bRJAs = parcelRequire("bRJAs");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");
const $5529ca801e310c63$export$a2bbf41e67157372 = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    const jswEdition = appEditions ? (0, $a9ldn.getEdition)((0, $bRJAs.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $a9ldn.STANDARD_EDITION);
};
const $5529ca801e310c63$export$a55cc88b2381611c = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    const jswEdition = appEditions ? (0, $a9ldn.getEdition)((0, $bRJAs.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $a9ldn.FREE_EDITION);
};
const $5529ca801e310c63$export$5edaea31b41b30b = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    const jswEdition = appEditions ? (0, $a9ldn.getEdition)((0, $bRJAs.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $a9ldn.STANDARD_EDITION) || jswEdition === (0, $a9ldn.FREE_EDITION);
};
const $5529ca801e310c63$export$d245a3118a8b4004 = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    const jswEdition = appEditions ? (0, $a9ldn.getEdition)((0, $bRJAs.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $a9ldn.PREMIUM_EDITION);
};
const $5529ca801e310c63$export$47ec61465121ff53 = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    const jswEdition = appEditions ? (0, $a9ldn.getEdition)((0, $bRJAs.JIRA_SOFTWARE), appEditions) : undefined;
    return !jswEdition || jswEdition === (0, $a9ldn.UNLICENSED);
};

});

const $5db379f8ce110c55$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Plans';
const $5db379f8ce110c55$export$d57b6b390e78d90f = 'jet-chronos-team';

parcelRegister("b4whf", function(module, exports) {

$parcel$export(module.exports, "Nav4Plans", () => $72dd6c0b6b95f0ea$export$a9599e1720ee6c82);

var $cywsi = parcelRequire("cywsi");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $j2LFL = parcelRequire("j2LFL");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $SPYRa = parcelRequire("SPYRa");

var $d4Xb7 = parcelRequire("d4Xb7");

var $7jTnu = parcelRequire("7jTnu");

var $5Xqpk = parcelRequire("5Xqpk");

var $dOtq4 = parcelRequire("dOtq4");

var $1F4Iy = parcelRequire("1F4Iy");

var $fCbwo = parcelRequire("fCbwo");

var $iiV6w = parcelRequire("iiV6w");
function $72dd6c0b6b95f0ea$export$a9599e1720ee6c82({ isExpanded: isExpanded, queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $cywsi.default), queryRef);
    const hasEditPermissions = data.jira?.advancedRoadmapsNavigation?.hasEditPermissions ?? false;
    const hasCreateSamplePlanPermissions = data.jira?.advancedRoadmapsNavigation?.hasCreateSamplePlanPermissions ?? false;
    const hasGlobalPlansAdminPermissions = data.jira?.advancedRoadmapsNavigation?.hasGlobalPlansAdminPermissions ?? false;
    const actionButtons = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dOtq4.Nav4PlansActionButtons), {
            hasEditPermissions: hasEditPermissions,
            hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
            hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
        }), [
        hasEditPermissions,
        hasCreateSamplePlanPermissions,
        hasGlobalPlansAdminPermissions
    ]);
    const [shouldRender] = (0, $SPYRa.useNavigationPlansVisibility)();
    const isPremium = (0, $j2LFL.useIsPremiumJSW)();
    const [{ hasOpened: shouldShowNudge }] = (0, $5Xqpk.useHasOpened)();
    if (!shouldRender) return null;
    if (!isPremium) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iiV6w.Nav4PlansPremiumUpsellFeatureGate), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($72dd6c0b6b95f0ea$var$Nav4PlansComponent, {
        actionButtons: actionButtons,
        isExpanded: isExpanded,
        hasFragment: data.jira?.hasIsPlansExpanded === 'JiraQuery',
        data: data,
        shouldShowNudge: shouldShowNudge
    });
}
const $72dd6c0b6b95f0ea$var$Nav4PlansComponent = (props)=>{
    const { actionButtons: actionButtons, isExpanded: isExpanded, data: data, hasFragment: hasFragment, shouldShowNudge: shouldShowNudge = true } = props;
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    if (!false && shouldShowNudge && (0, $7jTnu.fg)('jira_onboarding_experiences_a11y_fixes')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $72dd6c0b6b95f0ea$var$fullWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d4Xb7.NavigationPlansNavItemWrapperNudgeAsync), null, isInitialSelectedPath((0, $h4Bzb.MENU_ID_PLANS)) && hasFragment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fCbwo.Nav4PlansForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F4Iy.Nav4PlansDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    })));
    return isInitialSelectedPath((0, $h4Bzb.MENU_ID_PLANS)) && hasFragment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fCbwo.Nav4PlansForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F4Iy.Nav4PlansDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
};
const $72dd6c0b6b95f0ea$var$fullWidthStyles = (0, $5Wv5g.xcss)({
    width: '100%'
});

});
parcelRegister("cywsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $001a05c2e2503785$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5de776fd06dc4f3b32e6bbfba7f1ef8e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $001a05c2e2503785$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "isPlansExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Plans",
    "selections": [
        {
            "condition": "isPlansExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4PlansForLanding"
                }
            ]
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "hasIsPlansExpanded",
                            "kind": "ScalarField",
                            "name": "__typename"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraAdvancedRoadmapsNavigation",
                    "kind": "LinkedField",
                    "name": "advancedRoadmapsNavigation",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasEditPermissions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCreateSamplePlanPermissions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasGlobalPlansAdminPermissions"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$001a05c2e2503785$var$node.hash = "d94bdd2f938a10104ed5834debf9b43c";
var $001a05c2e2503785$export$2e2bcd8739ae039 = $001a05c2e2503785$var$node;

});

parcelRegister("d4Xb7", function(module, exports) {

$parcel$export(module.exports, "NavigationPlansNavItemWrapperNudgeAsync", () => $4c582040f2cb585b$export$e2e248a8ac2b2891);

var $eJOHy = parcelRequire("eJOHy");


var $kMreM = parcelRequire("kMreM");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4c582040f2cb585b$var$NavigationPlansNavItemLazy = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("8nK6l")).then((exportedModule)=>exportedModule.NavigationPlansNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-plans/index.tsx"
});
const $4c582040f2cb585b$export$e2e248a8ac2b2891 = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kMreM.OnboardingNudgeErrorBoundary), {
        id: (0, $2b839a8453de5367$export$46d9a3d441dfd22b),
        fallback: children,
        attributes: {
            nudgeId: (0, $2b839a8453de5367$export$46d9a3d441dfd22b)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "software-onboarding-navigation-plans-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4c582040f2cb585b$var$NavigationPlansNavItemLazy, {
        nudgeId: (0, $2b839a8453de5367$export$46d9a3d441dfd22b),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("8nK6l", function(module, exports) {

let $61a43b7eb557d18b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $61a43b7eb557d18b$var$load("eqrM9").then(()=>parcelRequire('4Pup2'));

});


parcelRegister("dOtq4", function(module, exports) {

$parcel$export(module.exports, "Nav4PlansActionButtons", () => $52b359437cc8ffb5$export$a7d6536605f62394);

var $eJOHy = parcelRequire("eJOHy");

var $9J5C2 = parcelRequire("9J5C2");

var $cU43W = parcelRequire("cU43W");
const $52b359437cc8ffb5$export$a7d6536605f62394 = ({ hasEditPermissions: hasEditPermissions, hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, hasEditPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9J5C2.CreatePlanMenuButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cU43W.MoreMenuButton), {
        hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
        hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
    }));
};

});
parcelRegister("9J5C2", function(module, exports) {

$parcel$export(module.exports, "CreatePlanMenuButton", () => $93648edde94420aa$export$fd3582c8dd19f9f6);

var $eJOHy = parcelRequire("eJOHy");

var $i140O = parcelRequire("i140O");

var $9JB3T = parcelRequire("9JB3T");

var $lRq8t = parcelRequire("lRq8t");



var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $ajqBI = parcelRequire("ajqBI");

var $6c6vC = parcelRequire("6c6vC");

var $f1Zdy = parcelRequire("f1Zdy");

var $gCeeo = parcelRequire("gCeeo");

var $jU4e3 = parcelRequire("jU4e3");
const $93648edde94420aa$export$fd3582c8dd19f9f6 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [, { openDrawer: openCreateNewPlanWizardDrawer }] = (0, $6c6vC.useCreateNewPlanWizardDrawer)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const clickHandler = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_PLANS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: 'createPlan'
            }
        });
        openCreateNewPlanWizardDrawer();
    }, [
        openCreateNewPlanWizardDrawer,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: formatMessage((0, $jU4e3.default).createPlan)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i140O))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $jU4e3.default).createPlan),
        onClick: clickHandler
    }));
};

});
parcelRegister("6c6vC", function(module, exports) {

$parcel$export(module.exports, "useCreateNewPlanWizardDrawer", () => $e513a240a32c48cc$export$f3e7d3fc94eda89a);
$parcel$export(module.exports, "useImportedMessagesForLocale", () => $e513a240a32c48cc$export$52303468eeac3ad0);

var $eJOHy = parcelRequire("eJOHy");

var $7bnK6 = parcelRequire("7bnK6");

var $lRq8t = parcelRequire("lRq8t");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7jTnu = parcelRequire("7jTnu");
const $e513a240a32c48cc$var$CONTROLLER_NAME = 'create-new-plan-wizard-drawer';
const $e513a240a32c48cc$var$initialState = {
    isOpen: false,
    plan: undefined,
    isPlanCreationComplete: false
};
const $e513a240a32c48cc$var$Store = (0, $GtRbT.createStore)({
    name: $e513a240a32c48cc$var$CONTROLLER_NAME,
    initialState: $e513a240a32c48cc$var$initialState,
    actions: {
        openDrawer: (plan)=>{
            (0, $7bnK6.default)('arj-create-plan-wizard-drawer');
            return (0, $7jTnu.fg)('ensure_plan_create_ufo_event_fires_successfully') ? ({ setState: setState })=>setState({
                    isOpen: true,
                    plan: plan,
                    isPlanCreationComplete: false
                }) : ({ setState: setState })=>setState({
                    isOpen: true,
                    plan: plan
                });
        },
        closeDrawer: ()=>({ setState: setState })=>setState({
                    isOpen: false,
                    plan: undefined
                }),
        setIsPlanCreationComplete: (isPlanCreationComplete = true)=>({ setState: setState })=>(0, $7jTnu.fg)('ensure_plan_create_ufo_event_fires_successfully') ? setState({
                    isPlanCreationComplete: isPlanCreationComplete
                }) : undefined
    }
});
const $e513a240a32c48cc$export$f3e7d3fc94eda89a = (0, $iJq0l.createHook)($e513a240a32c48cc$var$Store);
const $e513a240a32c48cc$export$9ec7b5762fb72de2 = (0, $6E16M.createContainer)($e513a240a32c48cc$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen, plan: plan })=>{
            setState({
                isOpen: isOpen,
                plan: plan
            });
        }
});
const $e513a240a32c48cc$var$EXCLUDED_I18N_FILES = [
    'index',
    'languages',
    'en'
];
const $e513a240a32c48cc$var$FALLBACK_INTL_MESSAGES = Object.freeze({});
const $e513a240a32c48cc$export$19442c17ab279a67 = async (rawlocale = 'en')=>{
    // Filter out country code as the AFE i18n does not use them e.g en => en-US
    const locale = rawlocale.split('-')[0];
    if (!locale || $e513a240a32c48cc$var$EXCLUDED_I18N_FILES.includes(locale)) return {
        default: $e513a240a32c48cc$var$FALLBACK_INTL_MESSAGES
    };
    const packageName = (0, $7jTnu.fg)('finish_jira-portfolio-3-plan-wizard_migration') ? 'jira-portfolio-3-plan-wizard' : 'jira-portfolio-plan-wizard';
    try {
        {
            // eslint-disable-next-line jira/import/webpack-magic-comment-entries
            const i18nModule = await import(`@atlassian/${packageName}/dist/esm/i18n/*.js`);
            const result = i18nModule[locale]();
            return result;
        }
        // eslint-disable-next-line jira/import/webpack-magic-comment-entries
        const result = await import(`@atlassian/${packageName}/dist/cjs/i18n/${locale}`);
        return result;
    } catch  {
        return {
            default: $e513a240a32c48cc$var$FALLBACK_INTL_MESSAGES
        };
    }
};
const $e513a240a32c48cc$export$52303468eeac3ad0 = ()=>{
    const { locale: locale } = (0, $lRq8t.default)();
    const [state, setState] = (0, $eJOHy.useState)({
        locale: locale,
        loading: true,
        intlMessages: undefined
    });
    (0, $eJOHy.useEffect)(()=>{
        let mounted = true;
        const load = async ()=>{
            setState((messageState)=>({
                    ...messageState,
                    loading: true
                }));
            const { default: intlMessages } = await $e513a240a32c48cc$export$19442c17ab279a67(locale);
            if (!mounted) return;
            setState((messageState)=>({
                    ...messageState,
                    loading: false,
                    intlMessages: intlMessages
                }));
        };
        load();
        return ()=>{
            mounted = false;
        };
    }, [
        locale
    ]);
    return state;
};

});

parcelRegister("jU4e3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3f41557b11b332a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b3f41557b11b332a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createPlan: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.create-plan-menu-button.create-plan",
        "defaultMessage": "Create plan"
    }
});

});


parcelRegister("cU43W", function(module, exports) {

$parcel$export(module.exports, "MoreMenuButton", () => $e022ee98d829959b$export$b13d6ccdb9a8b0c5);

var $eJOHy = parcelRequire("eJOHy");

var $i140O = parcelRequire("i140O");

var $ejfxj = parcelRequire("ejfxj");

var $1AUsu = parcelRequire("1AUsu");
var $apGPk = parcelRequire("apGPk");
var $MlWTN = parcelRequire("MlWTN");
var $7R1al = parcelRequire("7R1al");

var $lRq8t = parcelRequire("lRq8t");



var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $5BAEL = parcelRequire("5BAEL");

var $f1Zdy = parcelRequire("f1Zdy");

var $gCeeo = parcelRequire("gCeeo");

var $7jTnu = parcelRequire("7jTnu");

var $6ClQD = parcelRequire("6ClQD");
const $e022ee98d829959b$var$MoreMenuItems = ({ hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [, { open: openCreateSamplePlanModal }] = (0, $5BAEL.useCreateSamplePlan)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const createDemoPlanClickHandler = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_PLANS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: 'createDemoPlan'
            }
        });
        openCreateSamplePlanModal();
    }, [
        openCreateSamplePlanModal,
        createAnalyticsEvent
    ]);
    const adminSettingsClickHandler = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_PLANS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: 'adminSettings'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), null, (hasCreateSamplePlanPermissions || hasGlobalPlansAdminPermissions) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
        isList: true
    }, hasCreateSamplePlanPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i140O))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        onClick: createDemoPlanClickHandler
    }, formatMessage((0, $6ClQD.default).createDemoPlan)), hasGlobalPlansAdminPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apGPk.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ejfxj))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/jira/plans/settings/permissions",
        onClick: adminSettingsClickHandler
    }, formatMessage((0, $6ClQD.default).adminSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).PLANS
    }));
};
const $e022ee98d829959b$export$b13d6ccdb9a8b0c5 = ({ hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const clickHandler = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_PLANS],
            attributes: {
                level: '1',
                componentType: 'fixedItemButton',
                itemId: 'meatballDropdown'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const MenuItems = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e022ee98d829959b$var$MoreMenuItems, {
            hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
            hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
        }), [
        hasCreateSamplePlanPermissions,
        hasGlobalPlansAdminPermissions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        MenuItems: (0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton') ? MenuItems : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e022ee98d829959b$var$MoreMenuItems, {
                hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
                hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
            }),
        name: formatMessage((0, $6ClQD.default).plansMoreMenu),
        onOpen: clickHandler
    });
};

});
parcelRegister("5BAEL", function(module, exports) {

$parcel$export(module.exports, "useCreateSamplePlan", () => $f8bfe53c17b60173$export$53d6fde96f096b86);
$parcel$export(module.exports, "CreateSamplePlanProvider", () => $f8bfe53c17b60173$export$88b99aa46c223622);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7woBL = parcelRequire("7woBL");

var $eImml = parcelRequire("eImml");
const $f8bfe53c17b60173$var$CONTROLLER_NAME = 'create-sample-plan';
const $f8bfe53c17b60173$var$initialState = {
    /**
	 * This field controls modal dismissible status
	 */ isOpen: false,
    /**
	 * This field is only used to redirect the user to plan page if the modal is not closed.
	 */ planId: null,
    /**
	 * This field is used to detect the correct redirection creation session,
	 * without this field, we don't know which creation session needs to be redirected
	 * e.g. the user started multiple sample creation and stays on the last one - in this case,
	 * only the last creation needs to be redirected.
	 */ taskId: null,
    /**
	 * Progress of the ongoing task
	 */ progressPercentage: null,
    /**
	 * Once this field has been set to `true`, we'll know we can call the actions returned
	 * by our useCreateSamplePlan hook.
	 */ hasBeenInitialised: false
};
const $f8bfe53c17b60173$var$actions = {
    open: ()=>({ setState: setState })=>{
            setState({
                isOpen: true
            });
        },
    close: ()=>({ setState: setState })=>{
            const nextState = (({ hasBeenInitialised: hasBeenInitialised, ...rest })=>rest)($f8bfe53c17b60173$var$initialState);
            setState(nextState);
        },
    setPlanId: (planId)=>({ setState: setState })=>{
            setState({
                planId: planId
            });
        },
    setTaskId: (taskId)=>({ setState: setState })=>{
            setState({
                taskId: taskId
            });
        },
    setProgressPercentage: (progressPercentage)=>({ setState: setState })=>{
            setState({
                progressPercentage: progressPercentage
            });
        },
    submitSamplePlan: ({ planName: planName, flags: { success: SuccessFlag, error: ErrorFlag } })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { showFlag: showFlag, redirectToPlan: redirectToPlan, leadAccountId: leadAccountId })=>{
            try {
                const taskId = await (0, $eImml.createSamplePlanAsync)({
                    body: JSON.stringify({
                        title: planName,
                        leadAccountId: leadAccountId
                    })
                });
                setState({
                    taskId: taskId
                });
                const response = await (0, $eImml.pollCreateSamplePlan)(taskId, (progressPercentage)=>{
                    const { taskId: latestTaskId } = getState();
                    // progressPercentage should reflect the progress of the most recent taskId
                    // If they don't match, skip updating
                    if (taskId !== latestTaskId) return;
                    setState({
                        progressPercentage: progressPercentage
                    });
                });
                const { plan: plan } = response.samplePlan;
                const currentState = getState();
                // We only want to redirect them if the taskId for the current modal is the same as the one for this request
                // Else it might belong to a previous modal
                if (currentState.isOpen && taskId === currentState.taskId) {
                    redirectToPlan(plan.id);
                    dispatch($f8bfe53c17b60173$var$actions.close());
                } else {
                    const flagId = (0, $7woBL.CREATE_SUCCESS_FLAG_ID) + plan.id;
                    showFlag({
                        id: flagId,
                        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SuccessFlag, {
                                id: flagId,
                                planName: plan.name,
                                planId: plan.id
                            })
                    });
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                // we only want to track errors unrelated to user settings
                if (!(0, $7woBL.USER_SETTINGS_ERRORS).includes(err.message)) (0, $gYnSx.default)({
                    error: err,
                    meta: {
                        id: `${(0, $7woBL.ERROR_REPORTING_PACKAGE)}SubmitFailed`,
                        packageName: (0, $7woBL.ERROR_REPORTING_PACKAGE),
                        teamName: (0, $7woBL.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                const props = {
                    id: (0, $7woBL.CREATE_ERROR_FLAG_ID),
                    errorCode: err.message
                };
                showFlag({
                    id: (0, $7woBL.CREATE_ERROR_FLAG_ID),
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ErrorFlag, props)
                });
                dispatch($f8bfe53c17b60173$var$actions.close());
            }
        }
};
const $f8bfe53c17b60173$var$Store = (0, $GtRbT.createStore)({
    name: $f8bfe53c17b60173$var$CONTROLLER_NAME,
    initialState: $f8bfe53c17b60173$var$initialState,
    actions: $f8bfe53c17b60173$var$actions
});
const $f8bfe53c17b60173$export$53d6fde96f096b86 = (0, $iJq0l.createHook)($f8bfe53c17b60173$var$Store);
const $f8bfe53c17b60173$export$88b99aa46c223622 = (0, $6E16M.createContainer)($f8bfe53c17b60173$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen = false })=>{
            setState({
                isOpen: isOpen,
                hasBeenInitialised: true
            });
        }
});

});
parcelRegister("7woBL", function(module, exports) {

$parcel$export(module.exports, "ERROR_REPORTING_PACKAGE", () => $4806c29065fbc432$export$f27a837467ec20e5);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $4806c29065fbc432$export$cfeee2ee86ead336);
$parcel$export(module.exports, "MAX_PLAN_NAME_LENGTH", () => $4806c29065fbc432$export$62da4a2465b3b309);
$parcel$export(module.exports, "CREATE_SUCCESS_FLAG_ID", () => $4806c29065fbc432$export$d526356745046017);
$parcel$export(module.exports, "CREATE_ERROR_FLAG_ID", () => $4806c29065fbc432$export$abd17266df221a92);
$parcel$export(module.exports, "UNKNOWN_EXCEPTION", () => $4806c29065fbc432$export$cfba07bc71f884c1);
$parcel$export(module.exports, "USER_SETTINGS_ERRORS", () => $4806c29065fbc432$export$4a3e779cd3c10125);
$parcel$export(module.exports, "ERROR_CODE_TITLE_MAPPING", () => $4806c29065fbc432$export$91ec80863c2c2030);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING", () => $4806c29065fbc432$export$c43e20911e13ca0);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING_ISSUE_TERM_REFRESH", () => $4806c29065fbc432$export$525cba92c9b435f4);
$parcel$export(module.exports, "ERROR_LINK_MAPPING", () => $4806c29065fbc432$export$2c5a783ab3215ce1);

var $6OQ8o = parcelRequire("6OQ8o");
const $4806c29065fbc432$export$f27a837467ec20e5 = 'jiraPortfolio3CreateSamplePlan';
const $4806c29065fbc432$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $4806c29065fbc432$var$CONTACT_SUPPORT_URL = 'https://support.atlassian.com/contact';
const $4806c29065fbc432$var$LEARN_MORE_URL = 'https://support.atlassian.com/jira-software-cloud/docs/view-a-sample-advanced-roadmaps-plan/';
const $4806c29065fbc432$export$62da4a2465b3b309 = 255;
const $4806c29065fbc432$export$d526356745046017 = 'samplePlanCreatedSuccessfully';
const $4806c29065fbc432$export$abd17266df221a92 = 'samplePlanError';
const $4806c29065fbc432$export$e6515d2009b1dba7 = 'REQUIRED_FIELDS_CONFIGURED_ON_ISSUE';
const $4806c29065fbc432$var$EMPTY_ISSUE_LINKS = 'EMPTY_ISSUE_LINKS';
const $4806c29065fbc432$var$NO_BROWSE_PROJECTS_PERMISSION = 'NO_BROWSE_PROJECTS_PERMISSION';
const $4806c29065fbc432$var$NO_CREATE_ISSUES_PERMISSION = 'NO_CREATE_ISSUES_PERMISSION';
const $4806c29065fbc432$var$NO_TRANSITION_ISSUES_PERMISSION = 'NO_TRANSITION_ISSUES_PERMISSION';
const $4806c29065fbc432$var$NO_EDIT_ISSUES_PERMISSION = 'NO_EDIT_ISSUES_PERMISSION';
const $4806c29065fbc432$var$WATCHING_DISABLED = 'WATCHING_DISABLED';
const $4806c29065fbc432$export$cfba07bc71f884c1 = 'UNKNOWN_EXCEPTION';
const $4806c29065fbc432$export$4a3e779cd3c10125 = [
    $4806c29065fbc432$export$e6515d2009b1dba7,
    $4806c29065fbc432$var$EMPTY_ISSUE_LINKS,
    $4806c29065fbc432$var$NO_BROWSE_PROJECTS_PERMISSION,
    $4806c29065fbc432$var$NO_CREATE_ISSUES_PERMISSION,
    $4806c29065fbc432$var$NO_TRANSITION_ISSUES_PERMISSION,
    $4806c29065fbc432$var$NO_EDIT_ISSUES_PERMISSION,
    $4806c29065fbc432$var$WATCHING_DISABLED
];
const $4806c29065fbc432$export$91ec80863c2c2030 = {
    [$4806c29065fbc432$export$e6515d2009b1dba7]: (0, $6OQ8o.default).configurationErrorTitle,
    [$4806c29065fbc432$var$EMPTY_ISSUE_LINKS]: (0, $6OQ8o.default).configurationErrorTitle,
    [$4806c29065fbc432$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $6OQ8o.default).permissionErrorTitle,
    [$4806c29065fbc432$var$NO_CREATE_ISSUES_PERMISSION]: (0, $6OQ8o.default).permissionErrorTitle,
    [$4806c29065fbc432$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $6OQ8o.default).permissionErrorTitle,
    [$4806c29065fbc432$var$NO_EDIT_ISSUES_PERMISSION]: (0, $6OQ8o.default).permissionErrorTitle,
    [$4806c29065fbc432$var$WATCHING_DISABLED]: (0, $6OQ8o.default).configurationErrorTitle,
    [$4806c29065fbc432$export$cfba07bc71f884c1]: (0, $6OQ8o.default).tryAgainErrorTitle
};
const $4806c29065fbc432$export$c43e20911e13ca0 = {
    [$4806c29065fbc432$export$e6515d2009b1dba7]: (0, $6OQ8o.default).requiredFieldsConfiguredOnIssueError,
    [$4806c29065fbc432$var$EMPTY_ISSUE_LINKS]: (0, $6OQ8o.default).emptyIssueLinksError,
    [$4806c29065fbc432$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $6OQ8o.default).noBrowseProjectsPermissionError,
    [$4806c29065fbc432$var$NO_CREATE_ISSUES_PERMISSION]: (0, $6OQ8o.default).noCreateIssuesPermissionError,
    [$4806c29065fbc432$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $6OQ8o.default).noTransitionIssuesPermissionError,
    [$4806c29065fbc432$var$NO_EDIT_ISSUES_PERMISSION]: (0, $6OQ8o.default).noEditIssuesPermissionError,
    [$4806c29065fbc432$var$WATCHING_DISABLED]: (0, $6OQ8o.default).watchingDisabledError,
    [$4806c29065fbc432$export$cfba07bc71f884c1]: (0, $6OQ8o.default).unknownExceptionError
};
const $4806c29065fbc432$export$525cba92c9b435f4 = {
    [$4806c29065fbc432$export$e6515d2009b1dba7]: (0, $6OQ8o.default).requiredFieldsConfiguredOnIssueErrorIssueTermRefresh,
    [$4806c29065fbc432$var$EMPTY_ISSUE_LINKS]: (0, $6OQ8o.default).emptyIssueLinksErrorIssueTermRefresh,
    [$4806c29065fbc432$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $6OQ8o.default).noBrowseProjectsPermissionError,
    [$4806c29065fbc432$var$NO_CREATE_ISSUES_PERMISSION]: (0, $6OQ8o.default).noCreateIssuesPermissionErrorIssueTermRefresh,
    [$4806c29065fbc432$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $6OQ8o.default).noTransitionIssuesPermissionErrorIssueTermRefresh,
    [$4806c29065fbc432$var$NO_EDIT_ISSUES_PERMISSION]: (0, $6OQ8o.default).noEditIssuesPermissionErrorIssueTermRefresh,
    [$4806c29065fbc432$var$WATCHING_DISABLED]: (0, $6OQ8o.default).watchingDisabledErrorIssueTermRefresh,
    [$4806c29065fbc432$export$cfba07bc71f884c1]: (0, $6OQ8o.default).unknownExceptionError
};
const $4806c29065fbc432$export$2c5a783ab3215ce1 = {
    [$4806c29065fbc432$export$e6515d2009b1dba7]: {
        text: (0, $6OQ8o.default).learnMore,
        href: $4806c29065fbc432$var$LEARN_MORE_URL
    },
    [$4806c29065fbc432$var$EMPTY_ISSUE_LINKS]: {
        text: (0, $6OQ8o.default).learnMore,
        href: $4806c29065fbc432$var$LEARN_MORE_URL
    },
    [$4806c29065fbc432$var$NO_BROWSE_PROJECTS_PERMISSION]: {
        text: (0, $6OQ8o.default).learnMore,
        href: $4806c29065fbc432$var$LEARN_MORE_URL
    },
    [$4806c29065fbc432$var$NO_CREATE_ISSUES_PERMISSION]: {
        text: (0, $6OQ8o.default).learnMore,
        href: $4806c29065fbc432$var$LEARN_MORE_URL
    },
    [$4806c29065fbc432$var$NO_TRANSITION_ISSUES_PERMISSION]: {
        text: (0, $6OQ8o.default).learnMore,
        href: $4806c29065fbc432$var$LEARN_MORE_URL
    },
    [$4806c29065fbc432$var$NO_EDIT_ISSUES_PERMISSION]: {
        text: (0, $6OQ8o.default).learnMore,
        href: $4806c29065fbc432$var$LEARN_MORE_URL
    },
    [$4806c29065fbc432$var$WATCHING_DISABLED]: {
        text: (0, $6OQ8o.default).learnMore,
        href: $4806c29065fbc432$var$LEARN_MORE_URL
    },
    [$4806c29065fbc432$export$cfba07bc71f884c1]: {
        text: (0, $6OQ8o.default).contactSupport,
        href: $4806c29065fbc432$var$CONTACT_SUPPORT_URL
    }
};

});
parcelRegister("6OQ8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f42e9d3b5d8f745$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9f42e9d3b5d8f745$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    configurationErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.configuration-error-title",
        "defaultMessage": "Your demo plan couldn't be created because of a configuration error"
    },
    permissionErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.permission-error-title",
        "defaultMessage": "Your demo plan couldn't be created because you\u2019re missing a required permission"
    },
    tryAgainErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.try-again-error-title",
        "defaultMessage": "Try to create your demo plan again"
    },
    requiredFieldsConfiguredOnIssueError: {
        "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error",
        "defaultMessage": "Your issues have required fields which blocked your demo plan from being created. {readMoreLink}"
    },
    emptyIssueLinksError: {
        "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error",
        "defaultMessage": "Your site doesn't have issue links configured, which are required to create a demo plan. {readMoreLink}"
    },
    noBrowseProjectsPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-browse-projects-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Browse Projects</permission-type> permission. {readMoreLink}"
    },
    noCreateIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create Issues</permission-type> permission. {readMoreLink}"
    },
    noTransitionIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition Issues</permission-type> permission. {readMoreLink}"
    },
    noEditIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit Issues</permission-type> permission. {readMoreLink}"
    },
    watchingDisabledError: {
        "id": "portfolio-3-create-sample-plan.common.watching-disabled-error",
        "defaultMessage": "Your demo plan couldn't be created because you have issue watching disabled. {readMoreLink}"
    },
    unknownExceptionError: {
        "id": "portfolio-3-create-sample-plan.common.unknown-exception-error",
        "defaultMessage": "Your demo plan couldn't be created, but we\u2019re not sure why. If the problem persists, contact Atlassian support. {readMoreLink}"
    },
    learnMore: {
        "id": "portfolio-3-create-sample-plan.common.learn-more",
        "defaultMessage": "Learn more"
    },
    contactSupport: {
        "id": "portfolio-3-create-sample-plan.common.contact-support",
        "defaultMessage": "Contact Atlassian support"
    },
    requiredFieldsConfiguredOnIssueErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error-issue-term-refresh",
        "defaultMessage": "Your work items have required fields which blocked your demo plan from being created. {readMoreLink}"
    },
    emptyIssueLinksErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error-issue-term-refresh",
        "defaultMessage": "Your site doesn't have work item links configured, which are required to create a demo plan. {readMoreLink}"
    },
    noCreateIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create work items</permission-type> permission. {readMoreLink}"
    },
    noTransitionIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition work items</permission-type> permission. {readMoreLink}"
    },
    noEditIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit work items</permission-type> permission. {readMoreLink}"
    },
    watchingDisabledErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.watching-disabled-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you have work item watching disabled. {readMoreLink}"
    },
    noBrowseProjectsPermissionErrorGalaxia: {
        "id": "portfolio-3-create-sample-plan.common.no-browse-projects-permission-error-galaxia",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Browse spaces</permission-type> permission. {readMoreLink}"
    }
});

});


parcelRegister("eImml", function(module, exports) {

$parcel$export(module.exports, "createSamplePlanAsync", () => $6c1e76ff051f12fd$export$fed9130b90cf6213);
$parcel$export(module.exports, "pollCreateSamplePlan", () => $6c1e76ff051f12fd$export$5d240a69af545c0d);
/**
 * Consider moving into service
 */ 
var $gYnSx = parcelRequire("gYnSx");

var $ee0TI = parcelRequire("ee0TI");

var $1uIew = parcelRequire("1uIew");

var $jGzN3 = parcelRequire("jGzN3");

var $7woBL = parcelRequire("7woBL");
const $6c1e76ff051f12fd$var$throwIfNotOk = async (response)=>{
    if (response.ok) return response;
    if (response.status === 500) throw new (0, $1uIew.default)(response.status, (0, $7woBL.UNKNOWN_EXCEPTION), response.headers.get((0, $ee0TI.TRACE_ID_HEADER)) ?? undefined, response);
};
const $6c1e76ff051f12fd$var$throwIfFailed = (result)=>{
    if (result.samplePlan && !result.samplePlan.success) throw new Error(result.samplePlan.error);
};
const $6c1e76ff051f12fd$var$delay = (ms = 3000)=>new Promise((res)=>setTimeout(res, ms));
const $6c1e76ff051f12fd$export$fed9130b90cf6213 = async (data)=>{
    const response = await (0, $jGzN3.performPostRequest)('/rest/jpo/1.0/plans/sampleplan/async', data);
    const { taskId: taskId } = response;
    if (!taskId) throw new Error('Invalid response from createSamplePlan');
    return taskId;
};
const $6c1e76ff051f12fd$export$5d240a69af545c0d = async (taskId, onUpdate)=>{
    const url = `/rest/jpo/1.0/plans/sampleplan/async/${taskId}`;
    try {
        const response = await fetch(url);
        await $6c1e76ff051f12fd$var$throwIfNotOk(response);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const raw = await response.json();
        $6c1e76ff051f12fd$var$throwIfFailed(raw);
        onUpdate(raw.progressPercent);
        if (raw.done) return raw;
        await $6c1e76ff051f12fd$var$delay();
        return $6c1e76ff051f12fd$export$5d240a69af545c0d(taskId, onUpdate);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // we only want to track errors unrelated to user settings
        if (!(0, $7woBL.USER_SETTINGS_ERRORS).includes(error.message)) (0, $gYnSx.default)({
            meta: {
                id: `${(0, $7woBL.ERROR_REPORTING_PACKAGE)}PollingFailed`,
                packageName: (0, $7woBL.ERROR_REPORTING_PACKAGE),
                teamName: (0, $7woBL.ERROR_REPORTING_TEAM)
            },
            attributes: {
                message: 'Polling create sample plan failed'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: error?.statusCode === 500
        });
        throw error;
    }
};

});


parcelRegister("6ClQD", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb6a4d4e9598542f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fb6a4d4e9598542f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    adminSettings: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.admin-settings",
        "defaultMessage": "Admin configuration"
    },
    plansMoreMenu: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.plans-more-menu",
        "defaultMessage": "Plans"
    },
    createDemoPlan: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.create-demo-plan",
        "defaultMessage": "Create demo plan"
    }
});

});



parcelRegister("1F4Iy", function(module, exports) {

$parcel$export(module.exports, "Nav4PlansDefault", () => $84739ac349d0e6ea$export$8edda76b63bd4bcb);

var $eJOHy = parcelRequire("eJOHy");

var $gPqEA = parcelRequire("gPqEA");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $if69u = parcelRequire("if69u");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $hPlDs = parcelRequire("hPlDs");


var $kEUB1 = parcelRequire("kEUB1");

var $jLR6z = parcelRequire("jLR6z");

var $b1Zrw = parcelRequire("b1Zrw");

var $7jTnu = parcelRequire("7jTnu");

var $fd8kn = parcelRequire("fd8kn");

var $hVzbe = parcelRequire("hVzbe");
const $84739ac349d0e6ea$export$8edda76b63bd4bcb = ({ actionsOnHover: actionsOnHover, isExpanded: isExpanded })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $hVzbe.asyncPlansSectionPlanListViewQuery), entryPointParams);
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).PLANS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const menuId = (0, $h4Bzb.MENU_ID_PLANS);
    // remove the entire useEffect when cleaning up nav4-show-plans-when-hidden-by-default
    // we should be using the route based entry point approach instead
    // https://hello.atlassian.net/wiki/spaces/UAF/pages/2754170095/Tutorial+EntryPoints+in+Routing
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        isExpanded,
        entryPointActions
    ]);
    const onSystemToggleCallBack = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const onExpansionToggleCallBack = (0, $eJOHy.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).PLANS,
                sectionItem: (0, $a9aec.SECTION_ITEM_PLANS)
            });
        }
    }, [
        entryPointActions,
        sendSectionItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        onSystemToggle: onSystemToggleCallBack,
        onExpansionToggle: onExpansionToggleCallBack,
        menuId: menuId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        interactionName: (0, $7jTnu.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-plans-default' : undefined,
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $azEgq.getTestId)(menuId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPqEA.default), {
        gap: "space.100",
        alignItems: "center"
    }, formattedMessage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLR6z.PaidFeatureAwarenessRenderer), {
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b1Zrw.PaidFeatureAwarenessPremiumLozenge), null),
        placement: "navigation.plans"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-plans-default",
        packageName: (0, $5db379f8ce110c55$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $5db379f8ce110c55$export$d57b6b390e78d90f),
        // Fallback for Suspense
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null),
        // Props for the root component
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fd8kn.Nav4PlansFooter), null)));
};

});
parcelRegister("jLR6z", function(module, exports) {

$parcel$export(module.exports, "PaidFeatureAwarenessRenderer", () => $63719b54b04d612e$export$64aa988820df8e0f);

var $1UwN8 = parcelRequire("1UwN8");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $ch9En = parcelRequire("ch9En");

var $8vyDv = parcelRequire("8vyDv");

var $9HmCl = parcelRequire("9HmCl");

var $a9ldn = parcelRequire("a9ldn");


var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $kEUB1 = parcelRequire("kEUB1");

var $1KdDN = parcelRequire("1KdDN");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
const $63719b54b04d612e$export$dc50189dfb775e17 = (props)=>{
    const { component: component } = props;
    const cloudId = (0, $kEUB1.useCloudId)();
    const data = (0, $j4oe4.useLazyLoadQuery)((0, $1UwN8.default), {
        cloudId: cloudId
    });
    const transactionAccounts = data?.tenantContexts?.[0]?.transactionAccounts;
    const hasPaymentDetails = transactionAccounts?.some((account)=>account?.isBillToPresent === true);
    if (hasPaymentDetails !== false) return props.fallback;
    return (0, $epTsa.expValEquals)('persistent_paid_feature_awareness_ab', 'cohort', 'variation', 'not-enrolled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: "paidFeatureAwareness",
        attributes: {
            placement: props.placement
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null), component) : props.fallback;
};
const $63719b54b04d612e$export$43f5a9f3669b7084 = (props)=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    const jswEdition = appEditions.software;
    const productEntitlementDetails = (0, $9HmCl.useProductEntitlementDetails)();
    const jswEntitlementDetails = productEntitlementDetails?.[0, $e08dff4ae358d899$export$1346c9aa3cbb477d];
    const trialEndTime = jswEntitlementDetails?.trialEndTime;
    const currentDate = (0, $eJOHy.useMemo)(()=>Date.now(), []);
    const isOnJSWTrial = Boolean(trialEndTime && currentDate < trialEndTime);
    /** Eligibility criteria (in order of evaluation)
   * - FG must be on
   * - Must be on JSW Premium Trial
   * - Must not have payment details entered (obtained via query)
   * - Must be in variation for experiment (fire exposure at this point)
   */ const isOnJswPremiumTrial = jswEdition === (0, $a9ldn.PREMIUM_EDITION) && isOnJSWTrial;
    return isOnJswPremiumTrial ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($63719b54b04d612e$export$dc50189dfb775e17, props) : props.fallback;
};
const $63719b54b04d612e$export$64aa988820df8e0f = (props)=>{
    const { fallback: fallback = null, ...rest } = props;
    return (0, $7jTnu.fg)('persistent_paid_feature_awareness') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "paidFeatureAwarenessBoundary",
        packageName: "@atlassian/jira-paid-feature-awareness-renderer",
        fallback: fallback ? ()=>fallback : 'unmount',
        teamName: "growth-tako",
        sendToPrivacyUnsafeSplunk: true,
        attributes: {
            placement: props.placement
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderUFOMigration), {
        name: "paid-feature-awareness-renderer-placeholder",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($63719b54b04d612e$export$43f5a9f3669b7084, {
        fallback: fallback,
        ...rest
    }))) : fallback;
};

});
parcelRegister("1UwN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bde50053bde33d4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ea135c05b9a14af72a5d22620c9f0fb3>>
 * @relayHash c016556e72569ab657c5e3a254837505
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 21f327fb0e284e5d01ec30368cc8072723b032febd2d59391a7592ddfc308efe
const $3bde50053bde33d4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiGetPaymentDetailsEnteredQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "transactionAccounts",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiGetPaymentDetailsEnteredQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "transactionAccounts",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "21f327fb0e284e5d01ec30368cc8072723b032febd2d59391a7592ddfc308efe",
            "metadata": {},
            "name": "uiGetPaymentDetailsEnteredQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3bde50053bde33d4$var$node.hash = "bf1b0ce0772fcd76c5314e9d886ff131";
var $3bde50053bde33d4$export$2e2bcd8739ae039 = $3bde50053bde33d4$var$node;

});

parcelRegister("9HmCl", function(module, exports) {

$parcel$export(module.exports, "useProductEntitlementDetails", () => $73f38ffaa065b746$export$e02d6385b5d47f5d);

var $lvKO5 = parcelRequire("lvKO5");
const $73f38ffaa065b746$export$e02d6385b5d47f5d = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.productEntitlementDetails || null;
};

});


parcelRegister("b1Zrw", function(module, exports) {

$parcel$export(module.exports, "PaidFeatureAwarenessStandardLozenge", () => $da72e8f8e3012e93$export$7ffe6b10a925635e);
$parcel$export(module.exports, "PaidFeatureAwarenessPremiumLozenge", () => $da72e8f8e3012e93$export$c759caf4220d9852);

var $eJOHy = parcelRequire("eJOHy");

var $6alcT = parcelRequire("6alcT");

var $9JB3T = parcelRequire("9JB3T");

var $lRq8t = parcelRequire("lRq8t");

var $b8Zvn = parcelRequire("b8Zvn");
const $da72e8f8e3012e93$export$7ffe6b10a925635e = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: formatMessage((0, $b8Zvn.default).standardTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        appearance: "new"
    }, formatMessage((0, $b8Zvn.default).standardLozenge)));
};
const $da72e8f8e3012e93$export$c759caf4220d9852 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: formatMessage((0, $b8Zvn.default).premiumTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        appearance: "new"
    }, formatMessage((0, $b8Zvn.default).premiumLozenge)));
};

});
parcelRegister("b8Zvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c5951706de9b4c3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4c5951706de9b4c3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    standardLozenge: {
        "id": "paid-feature-awareness.standard-lozenge",
        "defaultMessage": "Standard"
    },
    premiumLozenge: {
        "id": "paid-feature-awareness.premium-lozenge",
        "defaultMessage": "Premium"
    },
    standardGemTooltip: {
        "id": "paid-feature-awareness.standard-gem-tooltip",
        "defaultMessage": "This is a Standard and Premium plan feature"
    },
    standardTooltip: {
        "id": "paid-feature-awareness.standard-lozenge-tooltip",
        "defaultMessage": "This is a Standard plan feature"
    },
    premiumTooltip: {
        "id": "paid-feature-awareness.premium-tooltip",
        "defaultMessage": "This is a Premium plan feature"
    },
    automationTooltip: {
        "id": "paid-feature-awareness.automation-tooltip",
        "defaultMessage": "Automations varies by plan. Free: 100 rule runs/mo; Standard: 1,700 rule runs/mo; Premium: 1000 rule runs per user/mo"
    }
});

});


parcelRegister("fd8kn", function(module, exports) {

$parcel$export(module.exports, "Nav4PlansFooter", () => $cb07aa13b68a1bb1$export$484b1d8ed55fea0a);

var $eJOHy = parcelRequire("eJOHy");

var $2y3Ci = parcelRequire("2y3Ci");
var $ilbtc = parcelRequire("ilbtc");
var $1swHh = parcelRequire("1swHh");

var $lRq8t = parcelRequire("lRq8t");



var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $1Ce3C = parcelRequire("1Ce3C");

var $f1Zdy = parcelRequire("f1Zdy");

var $gCeeo = parcelRequire("gCeeo");

var $fZoD8 = parcelRequire("fZoD8");

var $g42he = parcelRequire("g42he");
const $cb07aa13b68a1bb1$var$VIEW_ALL_PLANS_HREF = (0, $fZoD8.plansDirectoryRoute).path;
const $cb07aa13b68a1bb1$export$484b1d8ed55fea0a = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const viewAllPlansClickHandler = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_PLANS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                itemId: 'viewAllPlans'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Ce3C.ViewAllEntityMenuItem), {
        href: $cb07aa13b68a1bb1$var$VIEW_ALL_PLANS_HREF,
        menuId: (0, $h4Bzb.MENU_ID_PLANS_VIEW_ALL),
        onClick: viewAllPlansClickHandler
    }, formatMessage((0, $g42he.default).viewAllPlans)))));
};

});
parcelRegister("fZoD8", function(module, exports) {

$parcel$export(module.exports, "plansDirectoryRoute", () => $5e7673d2f94ce53a$export$143b4a1ef2ffc051);
const $5e7673d2f94ce53a$export$143b4a1ef2ffc051 = {
    name: 'plans-directory',
    path: '/jira/plans'
};

});

parcelRegister("g42he", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9bc0b6814d36290$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d9bc0b6814d36290$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewAllPlans: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.footer.view-all-plans",
        "defaultMessage": "View all plans"
    }
});

});


parcelRegister("hVzbe", function(module, exports) {

$parcel$export(module.exports, "asyncPlansSectionPlanListViewQuery", () => $075e17faa67f98c3$export$c2f76ac2cce77bea);

var $g2qHb = parcelRequire("g2qHb");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $075e17faa67f98c3$export$c2f76ac2cce77bea = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("qOsRO")).then((module)=>module.Nav4PlansListViewQuery), {
        moduleId: "90d35cd1",
        moduleName: "Nav4PlansListViewQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryRef: {
                    parameters: $g2qHb.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("g2qHb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f2af00999dde6c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<93d8926ce1193d9492d811ae578a60d8>>
 * @relayHash 2fab10c560160e66c9c146c94b56414c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f627cf35f2198f57ba8db16ad1ccb78207462df7062fd3f61aeb4c5a785a8922
const $1f2af00999dde6c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v5 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ],
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v4 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v4 /*: any*/ 
            ]
        }
    ], v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4PlansListViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "PlansList"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4PlansListViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouritePlans",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "PLAN"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v5 /*: any*/ 
                                },
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentPlans",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "PLAN"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v5 /*: any*/ 
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f627cf35f2198f57ba8db16ad1ccb78207462df7062fd3f61aeb4c5a785a8922",
            "metadata": {},
            "name": "Nav4PlansListViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1f2af00999dde6c4$var$node.hash = "e67bfd2d42ed8352fb6fada08981300c";
var $1f2af00999dde6c4$export$2e2bcd8739ae039 = $1f2af00999dde6c4$var$node;

});

parcelRegister("qOsRO", function(module, exports) {

let $0509930a58bc93b0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0509930a58bc93b0$var$load("1h75B").then(()=>parcelRequire('040p3'));

});



parcelRegister("fCbwo", function(module, exports) {

$parcel$export(module.exports, "Nav4PlansForLanding", () => $f2fdbac9b082c572$export$5e6b364538aa2f20);

var $549xW = parcelRequire("549xW");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gPqEA = parcelRequire("gPqEA");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $jLR6z = parcelRequire("jLR6z");

var $b1Zrw = parcelRequire("b1Zrw");

var $7jTnu = parcelRequire("7jTnu");

var $fd8kn = parcelRequire("fd8kn");

var $5GUrh = parcelRequire("5GUrh");
function $f2fdbac9b082c572$export$5e6b364538aa2f20(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).PLANS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const data = (0, $j4oe4.useFragment)((0, $549xW.default), queryRef);
    const menuId = (0, $h4Bzb.MENU_ID_PLANS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).PLANS,
                sectionItem: (0, $a9aec.SECTION_ITEM_PLANS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        interactionName: (0, $7jTnu.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-plans-landing' : undefined,
        actionsOnHover: actionsOnHover,
        elemBefore: icon,
        testId: (0, $azEgq.getTestId)(menuId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPqEA.default), {
        gap: "space.100",
        alignItems: "center"
    }, formattedMessage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLR6z.PaidFeatureAwarenessRenderer), {
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b1Zrw.PaidFeatureAwarenessPremiumLozenge), null),
        placement: "navigation.plans"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5GUrh.PlansList), {
        fragmentRef: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fd8kn.Nav4PlansFooter), null)));
}

});
parcelRegister("549xW", function(module, exports) {

$parcel$export(module.exports, "default", () => $15115ea609ce9775$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc8f47418a0aaa6d19370311cfed6f24>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $15115ea609ce9775$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4PlansForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PlansList"
        }
    ],
    "type": "Query"
};
$15115ea609ce9775$var$node.hash = "4a68bb76768003096c8b0a4da492d88a";
var $15115ea609ce9775$export$2e2bcd8739ae039 = $15115ea609ce9775$var$node;

});

parcelRegister("5GUrh", function(module, exports) {

$parcel$export(module.exports, "PlansList", () => $9ebbc5a5a6019aa3$export$610289543b80d1e7);

var $bRuTL = parcelRequire("bRuTL");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2y3Ci = parcelRequire("2y3Ci");
var $ilbtc = parcelRequire("ilbtc");
var $1swHh = parcelRequire("1swHh");
var $jLuq7 = parcelRequire("jLuq7");

var $lRq8t = parcelRequire("lRq8t");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $hc6Nm = parcelRequire("hc6Nm");

var $h3HFC = parcelRequire("h3HFC");

var $3uQAw = parcelRequire("3uQAw");

var $9Vlwp = parcelRequire("9Vlwp");

var $kEUB1 = parcelRequire("kEUB1");

var $99ZuM = parcelRequire("99ZuM");

var $9HcBU = parcelRequire("9HcBU");

var $8c9ds = parcelRequire("8c9ds");
const $9ebbc5a5a6019aa3$var$MAX_RECENT_PLANS = 5;
const $9ebbc5a5a6019aa3$export$610289543b80d1e7 = ({ fragmentRef: fragmentRef })=>{
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { getStableItems: getStableItems } = (0, $3uQAw.useStableItems)();
    const [data, refetch] = (0, $j4oe4.useRefetchableFragment)((0, $bRuTL.default), fragmentRef);
    (0, $hc6Nm.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $9Vlwp.default,
        refetch: refetch,
        menuId: (0, $h4Bzb.MENU_ID_PLANS)
    });
    const refetchOnChange = (0, $eJOHy.useCallback)(({ onComplete: onComplete })=>{
        refetch({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        cloudId,
        refetch
    ]);
    (0, $h3HFC.useSubscribeAndUpdateFavorites)({
        entityTypename: 'JiraPlan',
        favouriteConnectionId: data?.jira.favouritePlans.__id || '',
        recentConnectionId: data?.jira.recentPlans.__id || '',
        refetch: refetchOnChange
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const starred = formatMessage((0, $9HcBU.default).starred);
    const recent = formatMessage((0, $9HcBU.default).recent);
    const favorites = (0, $eJOHy.useMemo)(()=>{
        if (!data) return {
            idSet: new Set(),
            list: [],
            hasItems: false
        };
        const ids = data.jira.favouritePlans.edges?.map((edge)=>edge?.node.id).filter(Boolean) ?? [];
        const list = data.jira.favouritePlans.edges?.filter(Boolean).map((edge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8c9ds.PlanMenuItem), {
                key: edge.node.planId,
                fragmentRef: edge.node,
                favouriteConnectionId: data.jira.favouritePlans.__id
            })) ?? [];
        return {
            idSet: new Set(ids),
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        data
    ]);
    const recentPlans = (0, $eJOHy.useMemo)(()=>{
        if (!data) return {
            list: [],
            hasItems: false
        };
        const nodes = data.jira.recentPlans.edges?.filter(Boolean).filter((edge)=>edge.node.id && !favorites.idSet.has(edge.node.id)).map((edge)=>edge.node).slice(0, $9ebbc5a5a6019aa3$var$MAX_RECENT_PLANS) ?? [];
        const stableOrderedNodes = getStableItems({
            nodes: nodes,
            idKey: 'id'
        });
        const list = stableOrderedNodes.map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8c9ds.PlanMenuItem), {
                key: node.planId,
                fragmentRef: node,
                favouriteConnectionId: data.jira.favouritePlans.__id
            }));
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        data,
        favorites.idSet,
        getStableItems
    ]);
    if (!favorites.hasItems && !recentPlans.hasItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99ZuM.PlansEmptyContent), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLuq7.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, favorites.list))), recentPlans.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLuq7.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, recentPlans.list))));
};

});
parcelRegister("bRuTL", function(module, exports) {

$parcel$export(module.exports, "default", () => $75c592d69bcdcde1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8ff8a16a0bcc9abd1a27e939d9b4ea35>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $9Vlwp = parcelRequire("9Vlwp");
const $75c592d69bcdcde1$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "planId"
    }, v3 = {
        "kind": "FragmentSpread",
        "name": "PlanMenuItem"
    }, v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURLPath"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $9Vlwp.default)
            }
        },
        "name": "PlansList",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "favouritePlans",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "PLAN"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "LOG",
                                                                    "path": "jira.favouritePlans.edges.node.id"
                                                                },
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraPlan"
                                                        }
                                                    ]
                                                },
                                                "action": "LOG",
                                                "path": "jira.favouritePlans.edges.node"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "LOG",
                            "path": "jira.favouritePlans"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "recentPlans",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "currentURL",
                                        "variableName": "currentURLPath"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "PLAN"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "LOG",
                                                                    "path": "jira.recentPlans.edges.node.id"
                                                                },
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraPlan"
                                                        }
                                                    ]
                                                },
                                                "action": "LOG",
                                                "path": "jira.recentPlans.edges.node"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "LOG",
                            "path": "jira.recentPlans"
                        }
                    ]
                },
                "action": "LOG",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$75c592d69bcdcde1$var$node.hash = "e819441248aed1e08c25170c0c3e028c";
var $75c592d69bcdcde1$export$2e2bcd8739ae039 = $75c592d69bcdcde1$var$node;

});
parcelRegister("9Vlwp", function(module, exports) {

$parcel$export(module.exports, "default", () => $22648146ace329aa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<64bf4ac654605737b12d7b087e6fb9b3>>
 * @relayHash eecc443da9da01f9535127750ac236d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3454b9464b520488623119e6651ec1783a9e4c433c78e509cc9dccb4cd715f77
const $22648146ace329aa$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURLPath"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v5 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ],
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v4 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v4 /*: any*/ 
            ]
        }
    ], v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PlanListQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "currentURLPath",
                            "variableName": "currentURLPath"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "PlansList"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PlanListQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouritePlans",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "PLAN"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v5 /*: any*/ 
                                },
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentPlans",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "currentURL",
                                    "variableName": "currentURLPath"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "PLAN"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v5 /*: any*/ 
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3454b9464b520488623119e6651ec1783a9e4c433c78e509cc9dccb4cd715f77",
            "metadata": {},
            "name": "PlanListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$22648146ace329aa$var$node.hash = "e819441248aed1e08c25170c0c3e028c";
var $22648146ace329aa$export$2e2bcd8739ae039 = $22648146ace329aa$var$node;

});


parcelRegister("99ZuM", function(module, exports) {

$parcel$export(module.exports, "PlansEmptyContent", () => $dee7b3e3d817c033$export$2b2efe96e6f14be5);

var $eJOHy = parcelRequire("eJOHy");

var $h8epd = parcelRequire("h8epd");

var $lRq8t = parcelRequire("lRq8t");

var $eLY13 = parcelRequire("eLY13");

var $2pVMc = parcelRequire("2pVMc");
function $dee7b3e3d817c033$export$2b2efe96e6f14be5() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eLY13.EmptyContentMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $2pVMc.default).noPlans)));
}

});
parcelRegister("2pVMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $27b44f5ba68d266f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $27b44f5ba68d266f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noPlans: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.empty-content.no-plans",
        "defaultMessage": "Once you open or create plans, they'll show up here."
    }
});

});


parcelRegister("9HcBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc0cdc4787bee15f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bc0cdc4787bee15f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.plans-list.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.plans-list.starred",
        "defaultMessage": "Starred"
    }
});

});

parcelRegister("8c9ds", function(module, exports) {

$parcel$export(module.exports, "PlanMenuItem", () => $44ffd312fec5241a$export$5805f023607bba3d);

var $hXxGK = parcelRequire("hXxGK");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $980v4 = parcelRequire("980v4");



var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $iArJs = parcelRequire("iArJs");

var $fZoD8 = parcelRequire("fZoD8");

var $02kpm = parcelRequire("02kpm");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $lQ7DI = parcelRequire("lQ7DI");


var $crJvX = parcelRequire("crJvX");
const $44ffd312fec5241a$var$VIEW_ALL_PLANS_HREF = (0, $fZoD8.plansDirectoryRoute).path;
const $44ffd312fec5241a$export$5805f023607bba3d = ({ fragmentRef: fragmentRef, favouriteConnectionId: favouriteConnectionId })=>{
    const data = (0, $j4oe4.useFragment)((0, $hXxGK.default), fragmentRef);
    const planId = data?.planId;
    const isStarred = data?.favouriteValue?.isFavourite ?? false;
    const scenarioId = data.scenario.scenarioId;
    const planTitle = data.title || '';
    const planUrl = data.defaultNavigationItem?.url || (0, $02kpm.generatePath)((0, $iArJs.softwarePlanTimelineRoute).path, {
        planId: planId,
        scenarioId: scenarioId
    });
    const isReadOnly = data.isReadOnly || false;
    const isArchived = data.planStatus === 'ARCHIVED';
    const analytics = (0, $eJOHy.useMemo)(()=>({
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_PLANS],
            level: 1,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemId: (0, $6bf6536f83c22cfe$export$c303e491e026ebc6),
            planId: planId ?? undefined,
            // TODO BLU-5544 send section via a single <ContextualAnalyticsData instead (which wraps the Starred or Recent panel). Use static object or useMemo, not to have rerendering issues.
            section: isStarred ? (0, $a9aec.SECTION_ITEM_STARRED) : (0, $a9aec.SECTION_ITEM_RECENT)
        }), [
        planId,
        isStarred
    ]);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            planId: planId,
            scenarioId: scenarioId,
            planTitle: planTitle,
            isReadOnly: isReadOnly,
            isArchived: isArchived,
            isStarred: isStarred,
            isUsedForSidebarNav: true,
            favouriteConnectionId: favouriteConnectionId
        }), [
        planId,
        scenarioId,
        planTitle,
        isReadOnly,
        isArchived,
        isStarred,
        favouriteConnectionId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $crJvX.asyncPlanActionMenu), entryPointParams);
    const triggerRef = (0, $lQ7DI.useHoverEntryPointTrigger)(entryPointActions);
    if (!data) return null;
    return planId && scenarioId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        analytics: analytics,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($980v4))), {
            label: "",
            color: "currentColor"
        }),
        href: planUrl || $44ffd312fec5241a$var$VIEW_ALL_PLANS_HREF,
        menuId: (0, $h4Bzb.ENTITY_ID).PLAN(String(planId)),
        ref: triggerRef,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-sidebar-plan-action-menu",
            packageName: (0, $5db379f8ce110c55$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $5db379f8ce110c55$export$d57b6b390e78d90f),
            runtimeProps: entryPointParams
        })
    }, planTitle);
};

});
parcelRegister("hXxGK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b67a7d7bc791adf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a6b8325f7e108ead155e56050c8d0ced>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5b67a7d7bc791adf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PlanMenuItem",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "planId"
            },
            "action": "THROW",
            "path": "planId"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "isReadOnly"
        },
        {
            "kind": "ScalarField",
            "name": "planStatus"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                }
            ]
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraScenario",
                "kind": "LinkedField",
                "name": "scenario",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "scenarioId"
                        },
                        "action": "THROW",
                        "path": "scenario.scenarioId"
                    }
                ]
            },
            "action": "THROW",
            "path": "scenario"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraSoftwareBuiltInNavigationItem"
                }
            ]
        }
    ],
    "type": "JiraPlan"
};
$5b67a7d7bc791adf$var$node.hash = "5ad97e2574c3a67e40c4df744d53456b";
var $5b67a7d7bc791adf$export$2e2bcd8739ae039 = $5b67a7d7bc791adf$var$node;

});

parcelRegister("iArJs", function(module, exports) {

$parcel$export(module.exports, "softwarePlanTimelineRoute", () => $0f106aba29264ba4$export$61abeb6a03d23dd3);
const $0f106aba29264ba4$export$61abeb6a03d23dd3 = {
    name: 'software-plan-timeline',
    path: '/jira/plans/:planId/scenarios/:scenarioId/timeline'
};

});

parcelRegister("lQ7DI", function(module, exports) {

$parcel$export(module.exports, "useHoverEntryPointTrigger", () => $0d56f31f523e32ec$export$129b8109f51bc05b);

var $eJOHy = parcelRequire("eJOHy");

var $ciFJV = parcelRequire("ciFJV");
const $0d56f31f523e32ec$export$129b8109f51bc05b = (actions, isActive = true)=>{
    const eventMap = (0, $eJOHy.useMemo)(()=>({
            mouseenter: actions.load,
            focusin: actions.load
        }), [
        actions
    ]);
    return (0, $ciFJV.useEntryPointButtonTrigger)(actions, isActive, eventMap);
};

});

parcelRegister("crJvX", function(module, exports) {

$parcel$export(module.exports, "asyncPlanActionMenu", () => $1b2b1800722bec48$export$62f1bed3a2f7698);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $1b2b1800722bec48$export$62f1bed3a2f7698 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("fH6QD")).then(({ AsyncPlanActionMenuContent: AsyncPlanActionMenuContent })=>AsyncPlanActionMenuContent), {
        moduleId: "3038e241",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fH6QD", function(module, exports) {

let $b6d02f02b9154b8b$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    $b6d02f02b9154b8b$var$load("1VRB2"),
    $b6d02f02b9154b8b$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("bvO4l"), 4)),
    $b6d02f02b9154b8b$var$load("8O9ev")
]).then(()=>parcelRequire('8FiQk'));

});





parcelRegister("iiV6w", function(module, exports) {

$parcel$export(module.exports, "Nav4PlansPremiumUpsellFeatureGate", () => $e9197baf79ea0d94$export$87c172423f26b2a0);
/* Nav4PlansPremiumUpsellFeatureGate.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $d9oCz = parcelRequire("d9oCz");
var $5jwgZ = parcelRequire("5jwgZ");
var $63KSu = parcelRequire("63KSu");

var $abxMj = parcelRequire("abxMj");

var $aJ2YU = parcelRequire("aJ2YU");

var $8IuE5 = parcelRequire("8IuE5");

var $7jTnu = parcelRequire("7jTnu");

var $eL2Ux = parcelRequire("eL2Ux");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $bbdV2 = parcelRequire("bbdV2");

var $ciFJV = parcelRequire("ciFJV");

var $8QNrG = parcelRequire("8QNrG");

var $8ETQ8 = parcelRequire("8ETQ8");

var $epTsa = parcelRequire("epTsa");
const $e9197baf79ea0d94$var$EMPTY_OBJECT = {};
const $e9197baf79ea0d94$var$elemAfterStyles = {
    root: "_18zr12x7 _1tz3r0mg"
};
const $e9197baf79ea0d94$export$87c172423f26b2a0 = ()=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).PLANS);
    const { entryPointActions: entryPointActions } = (0, $bbdV2.useEntryPoint)((0, $8QNrG.planUpsellEntryPoint), (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? $e9197baf79ea0d94$var$EMPTY_OBJECT : {});
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    if ((0, $7jTnu.fg)('supercharge_timelines_with_plans_kill_switch')) {
        const [stwpConfig, fireStwpExposure] = (0, $epTsa.UNSAFE_noExposureExp)('supercharge_timelines_with_plans_experiment');
        const stwpCohort = stwpConfig.get('cohort', 'not-enrolled');
        if (stwpCohort === 'variation') {
            const { path: path } = (0, $8ETQ8.planUpsellRoute);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
                menuId: (0, $h4Bzb.MENU_ID_PLANS),
                elemBefore: icon,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                    className: (0, $hcewu.default)([
                        $e9197baf79ea0d94$var$elemAfterStyles.root
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($abxMj))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)",
                    size: "small"
                })),
                href: path,
                ref: triggerRef,
                onClick: fireStwpExposure
            }, formattedMessage);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9oCz.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $63KSu.FlyoutMenuItemTrigger), {
            interactionName: (0, $7jTnu.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-plans-premium-upsell' : undefined,
            elemBefore: icon,
            onClick: fireStwpExposure
        }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5jwgZ.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aJ2YU.default), null)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9oCz.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $63KSu.FlyoutMenuItemTrigger), {
        interactionName: (0, $7jTnu.fg)('blu-7837_apply_presstrace_nav4') ? 'nav4-sidebar-plans-premium-upsell' : undefined,
        elemBefore: icon
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5jwgZ.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aJ2YU.default), null)));
};

});
parcelRegister("aJ2YU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d697aed929871a35$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $iTElX = parcelRequire("iTElX");

var $bvFRW = parcelRequire("bvFRW");

var $aymPs = parcelRequire("aymPs");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $5M7r5 = parcelRequire("5M7r5");

var $aZg1w = parcelRequire("aZg1w");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $bTM76 = parcelRequire("bTM76");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");
var $f1Zdy = parcelRequire("f1Zdy");

var $6XJko = parcelRequire("6XJko");

var $6zXPf = parcelRequire("6zXPf");

var $7jTnu = parcelRequire("7jTnu");

var $aH1Gm = parcelRequire("aH1Gm");

var $ggYw9 = parcelRequire("ggYw9");

var $kEUB1 = parcelRequire("kEUB1");

var $kO1ht = parcelRequire("kO1ht");

var $8Q8RO = parcelRequire("8Q8RO");

var $2lxyv = parcelRequire("2lxyv");
const $d697aed929871a35$var$LEARN_MORE_LINK = 'https://www.atlassian.com/software/jira/guides/advanced-roadmaps/overview#what-are-advanced-roadmaps'; // Statsig experiment `plans_menu_try_it_free_one_stop_shop_modal`
// the control cohort will be shown the modal, whereas the test cohort will be redirected to the billing page instead.
// if the check errors for whatever reason, we still want to show the modal, hence why it defaults to true
const $d697aed929871a35$var$PremiumFeatureGate = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { colorMode: colorMode } = (0, $5M7r5.default)();
    const { data: { premiumTrialUpgradeLink: premiumTrialUpgradeLink } } = (0, $epTsa.expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? {
        data: {
            premiumTrialUpgradeLink: undefined
        }
    } : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $aZg1w.useJswPremiumTrialUpgradeLink)({
        caller: (0, $kO1ht.PACKAGE_NAME)
    });
    const onStartTrialClick = (_, analyticsEvent)=>{
        if ((0, $6XJko.isVisualRefreshEnabled)()) (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'tryItFree'
        });
        else (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'navigationUpgradeToPremiumFromPlansMenu');
    };
    const onLearnMoreClick = (_, analyticsEvent)=>{
        if ((0, $6XJko.isVisualRefreshEnabled)()) (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'readTheGuide'
        });
        else (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'navigationLearnMoreAboutPremiumFromPlansMenu');
    };
    // We expect all tenants to be "control" or "not-enrolled" if they see this modal, we are firing exposure (again) and including cohort in analytics for safety
    const stwpCohort = (0, $eJOHy.useMemo)(()=>{
        return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('supercharge_timelines_with_plans_kill_switch') ? (0, $epTsa.expVal)('supercharge_timelines_with_plans_experiment', 'cohort', 'not-enrolled') : undefined;
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (stwpCohort) Promise.all([
            (0, $aH1Gm.getTrialSprintBoardProjectId)(cloudId),
            (0, $ggYw9.getNumProjects)(cloudId)
        ]).then(([trialSprintBoardProjectId, numProjects])=>{
            if (typeof numProjects === 'number') {
                const numProjectsExcludingTrial = trialSprintBoardProjectId ? numProjects - 1 : numProjects;
                (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'plansPremiumFeatureGate rendered', {
                    stwpCohort: stwpCohort,
                    numProjectsExcludingTrial: numProjectsExcludingTrial
                });
            }
        });
    }, [
        stwpCohort,
        cloudId,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "plansPremiumFeatureGate",
        sourceType: "Modal",
        attributes: {
            stwpCohort: stwpCohort
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d697aed929871a35$var$MenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d697aed929871a35$var$MenuHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Q8RO.FeatureGateLogo), {
        alt: "",
        colorMode: colorMode
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d697aed929871a35$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $2lxyv.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $d697aed929871a35$var$contentDescriptionStyles
    }, formatMessage((0, $2lxyv.default).description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d697aed929871a35$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d697aed929871a35$var$LearnMoreButton, {
        appearance: "link",
        href: $d697aed929871a35$var$LEARN_MORE_LINK,
        target: "_blank",
        onClick: onLearnMoreClick
    }, formatMessage((0, $2lxyv.default).learnMoreLink)), (0, $epTsa.expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d697aed929871a35$var$TryPremiumButton, {
        onClick: onStartTrialClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aymPs))), {
            LEGACY_size: "small",
            label: formatMessage((0, $2lxyv.default).imageAlt),
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    }, formatMessage((0, $2lxyv.default).startTrialButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d697aed929871a35$var$TryPremiumButtonDirectLink, {
        href: premiumTrialUpgradeLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aymPs))), {
            LEGACY_size: "small",
            label: formatMessage((0, $2lxyv.default).imageAlt),
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    }, formatMessage((0, $2lxyv.default).startTrialButton)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null));
};
var $d697aed929871a35$export$2e2bcd8739ae039 = $d697aed929871a35$var$PremiumFeatureGate;
const $d697aed929871a35$var$TryPremiumButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bTM76.PremiumUpgradeModalEntryPointButton), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
const $d697aed929871a35$var$TryPremiumButtonDirectLink = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iTElX.default), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
const $d697aed929871a35$var$LearnMoreButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iTElX.default), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    maxWidth: '250px',
                    marginRight: "var(--ds-space-200, 16px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d697aed929871a35$var$MenuContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1b66 _11q717kt _189ee4h9 _1dqonqa1 _1h6d3acm _vchhusvi _qjkjusvi _1y1m18uv _p12f4lgm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d697aed929871a35$var$MenuHeaderContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11q7gup1 _2rko1xsr _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3il1r9 _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d697aed929871a35$var$ContentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11q7vuon _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $d697aed929871a35$var$contentDescriptionStyles = (0, $5Wv5g.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d697aed929871a35$var$FooterContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11q7vuon _2rko4dok _ca0qidpf _u5f31ejb _n3td1ejb _19bv1ejb _1e0c1txw _4cvr1h6o _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aymPs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b007f69ad81895a86b02f3ac63c0846>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aeec9bb76eb06ed$var$_react = $7aeec9bb76eb06ed$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7aeec9bb76eb06ed$var$_premium = $7aeec9bb76eb06ed$var$_interopRequireDefault((parcelRequire("a8kHz")));

var $7aeec9bb76eb06ed$var$_premium2 = $7aeec9bb76eb06ed$var$_interopRequireDefault((parcelRequire("eoVJw")));
function $7aeec9bb76eb06ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PremiumIcon.
 * This component is PremiumIcon, with `UNSAFE_fallbackIcon` set to "PremiumIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aeec9bb76eb06ed$var$PremiumIcon = (props)=>/*#__PURE__*/ $7aeec9bb76eb06ed$var$_react.default.createElement($7aeec9bb76eb06ed$var$_premium.default, Object.assign({
        LEGACY_fallbackIcon: $7aeec9bb76eb06ed$var$_premium2.default
    }, props));
$7aeec9bb76eb06ed$var$PremiumIcon.Name = 'PremiumIconMigration';
var $7aeec9bb76eb06ed$var$_default = module.exports.default = $7aeec9bb76eb06ed$var$PremiumIcon;

});
parcelRegister("a8kHz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::821d8a868bec01d1b9c95a45239911fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $760ab5ab1a755f70$var$_react = $760ab5ab1a755f70$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $760ab5ab1a755f70$var$_baseNew = $760ab5ab1a755f70$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $760ab5ab1a755f70$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Premium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $760ab5ab1a755f70$var$PremiumIcon = (props)=>/*#__PURE__*/ $760ab5ab1a755f70$var$_react.default.createElement($760ab5ab1a755f70$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 3v1.5H3V3h1.5V1.5H3V0H1.5v1.5H0V3zM8 1c.31 0 .587.19.699.478l1.63 4.193 4.193 1.63a.75.75 0 0 1 0 1.398l-4.193 1.63-1.63 4.193a.75.75 0 0 1-1.398 0l-1.63-4.193L1.478 8.7a.75.75 0 0 1 0-1.398l4.193-1.63L7.3 1.478A.75.75 0 0 1 8 1m0 2.82L6.949 6.521a.75.75 0 0 1-.427.427L3.819 8l2.703 1.051a.75.75 0 0 1 .427.427L8 12.181l1.051-2.703a.75.75 0 0 1 .427-.427L12.181 8 9.478 6.949a.75.75 0 0 1-.427-.427zm5 10.68V16h1.5v-1.5H16V13h-1.5v-1.5H13V13h-1.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$760ab5ab1a755f70$var$PremiumIcon.displayName = 'PremiumIcon';
var $760ab5ab1a755f70$var$_default = module.exports.default = $760ab5ab1a755f70$var$PremiumIcon;

});

parcelRegister("eoVJw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7c0172e8a878053$var$_react = $a7c0172e8a878053$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $a7c0172e8a878053$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a7c0172e8a878053$var$PremiumIcon = (props)=>/*#__PURE__*/ $a7c0172e8a878053$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.276 4.382 7.357 9.247l-4.863 1.917a.78.78 0 0 0 0 1.45l4.863 1.918 1.919 4.863a.78.78 0 0 0 1.45 0h-.001l1.918-4.863 4.864-1.919a.781.781 0 0 0 0-1.45l-4.864-1.916-1.918-4.865a.78.78 0 0 0-.44-.438.78.78 0 0 0-1.01.438m8.297-2.03-.743 1.886-1.884.743a.56.56 0 0 0 0 1.038l1.884.743.743 1.886a.558.558 0 0 0 1.038 0l.745-1.886 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.743-.745-1.885a.55.55 0 0 0-.314-.314.56.56 0 0 0-.724.314m-.704 13.003-.744 1.883-1.883.744a.55.55 0 0 0-.316.314.56.56 0 0 0 .316.724l1.883.743.744 1.884c.057.144.17.258.314.315a.56.56 0 0 0 .724-.315l.744-1.884 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.744-.744-1.883a.55.55 0 0 0-.315-.316.56.56 0 0 0-.723.316"/></svg>`
    }, props));
$a7c0172e8a878053$var$PremiumIcon.displayName = 'PremiumIcon';
var $a7c0172e8a878053$var$_default = module.exports.default = $a7c0172e8a878053$var$PremiumIcon;

});


parcelRegister("aZg1w", function(module, exports) {

$parcel$export(module.exports, "useJswPremiumTrialUpgradeLink", () => $a48f7635d074a309$export$645eda3f5f2163ec);

var $ln6Iy = parcelRequire("ln6Iy");


var $a9ldn = parcelRequire("a9ldn");

var $lvKO5 = parcelRequire("lvKO5");

var $i66VH = parcelRequire("i66VH");
const $a48f7635d074a309$export$645eda3f5f2163ec = ({ deepLink: deepLink = true, skip: skip = false, caller: caller })=>{
    const { productEntitlementDetails: productEntitlementDetails } = (0, $lvKO5.useTenantContext)();
    const jswEntitlement = productEntitlementDetails?.[0, $e08dff4ae358d899$export$1346c9aa3cbb477d];
    const isJswUsingCcp = jswEntitlement?.billingSourceSystem === 'CCP';
    const { data: data, ...rest } = (0, $i66VH.useGetBillingPageUrl)({
        isUsingCcp: isJswUsingCcp,
        editionToUpgradeTo: deepLink ? (0, $a9ldn.PREMIUM_EDITION) : undefined,
        caller: caller,
        skip: skip,
        subProduct: (0, $ln6Iy.SOFTWARE_PROJECT)
    });
    return {
        data: {
            premiumTrialUpgradeLink: data.billingPageUrl
        },
        ...rest
    };
};

});
parcelRegister("i66VH", function(module, exports) {

$parcel$export(module.exports, "useGetBillingPageUrl", () => $97dc3778f6a7c40c$export$7b1495b7581dcd01);

var $eJOHy = parcelRequire("eJOHy");

var $kFw1p = parcelRequire("kFw1p");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $g9Vr6 = parcelRequire("g9Vr6");


var $a9ldn = parcelRequire("a9ldn");

var $figsJ = parcelRequire("figsJ");

var $lvKO5 = parcelRequire("lvKO5");

var $lB9yu = parcelRequire("lB9yu");

var $iVQXn = parcelRequire("iVQXn");

var $ccm7u = parcelRequire("ccm7u");

var $gvwWc = parcelRequire("gvwWc");
const $97dc3778f6a7c40c$export$7b1495b7581dcd01 = ({ isUsingCcp: isUsingCcp, editionToUpgradeTo: editionToUpgradeTo, caller: caller, skip: skip = false, subProduct: subProduct, onError: onError })=>{
    const [billingPageUrl, setBillingPageUrl] = (0, $eJOHy.useState)();
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const contextSubProduct = (0, $figsJ.useSubProduct)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const subProductToUse = subProduct || contextSubProduct;
    (0, $eJOHy.useEffect)(()=>{
        if (skip) return;
        const loadBillingInfo = async ()=>{
            try {
                const explicitlyLicensedProducts = (0, $kFw1p.default)(tenantContext);
                const productKey = (0, $gvwWc.getProductKey)(subProductToUse, explicitlyLicensedProducts);
                const referrerKey = (0, $iVQXn.getProductReferrerKey)(productKey);
                // The product key as used by Commerce.
                // JPD product key as used by Commerce does not include .ondemand
                const commerceProductKey = productKey === (0, $e08dff4ae358d899$export$202f50ee62667e32) ? productKey : `${productKey}.ondemand`;
                const entitlementId = productKey ? tenantContext.productEntitlementDetails?.[productKey]?.entitlementId : null;
                if (isUsingCcp) {
                    if (!entitlementId) {
                        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'RetrieveEntitlementId failed', {
                            caller: caller,
                            productKey: productKey,
                            productEntitlementDetails: JSON.stringify(tenantContext.productEntitlementDetails),
                            subProduct: subProductToUse
                        });
                        throw new Error('Empty entitlement ID');
                    }
                    const ccpTransactionAccountId = await (0, $iVQXn.getCcpTransactionAccountId)(entitlementId);
                    // List of valid referrer values
                    // https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2652063891/How+to+Deeplink+to+BAC+s+change+plan#How-to-use-this-deeplink%3F
                    const ccpBaseUrl = `${(0, $ccm7u.getAdminBaseUrl)()}/billing/o/${orgId}/${ccpTransactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=${referrerKey}&enableMpucup=true`;
                    switch(editionToUpgradeTo){
                        case 0, $a9ldn.STANDARD_EDITION:
                        case 0, $a9ldn.PREMIUM_EDITION:
                            setBillingPageUrl(`${ccpBaseUrl}&offeringName=${(0, $lB9yu.EDITION_KEY)[editionToUpgradeTo]}`);
                            break;
                        default:
                            setBillingPageUrl(ccpBaseUrl);
                    }
                } else // HAMS Billing System
                switch(editionToUpgradeTo){
                    case 0, $a9ldn.STANDARD_EDITION:
                    case 0, $a9ldn.PREMIUM_EDITION:
                        setBillingPageUrl(`${(0, $ccm7u.getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}/${(0, $lB9yu.EDITION_KEY)[editionToUpgradeTo]}`);
                        break;
                    default:
                        setBillingPageUrl(`${(0, $ccm7u.getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}`);
                }
            } catch (e) {
                setError(e);
                if (onError && e instanceof Error) onError(e);
            } finally{
                setLoading(false);
            }
        };
        loadBillingInfo();
    }, [
        caller,
        createAnalyticsEvent,
        editionToUpgradeTo,
        isUsingCcp,
        onError,
        orgId,
        skip,
        subProduct,
        subProductToUse,
        tenantContext,
        tenantContext.cloudId
    ]);
    return {
        data: {
            billingPageUrl: billingPageUrl
        },
        loading: loading,
        error: error
    };
};

});
parcelRegister("kFw1p", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb1246aba5ea09ac$export$2e2bcd8739ae039);

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bb1246aba5ea09ac$export$2e2bcd8739ae039 = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const result = [];
    licensedProducts[0, $e08dff4ae358d899$export$db515c8cec1e6f79] && result.push((0, $e08dff4ae358d899$export$db515c8cec1e6f79));
    licensedProducts[0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61] && result.push((0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61));
    licensedProducts[0, $e08dff4ae358d899$export$1346c9aa3cbb477d] && result.push((0, $e08dff4ae358d899$export$1346c9aa3cbb477d));
    licensedProducts[0, $e08dff4ae358d899$export$202f50ee62667e32] && result.push((0, $e08dff4ae358d899$export$202f50ee62667e32));
    return result;
};

});

parcelRegister("figsJ", function(module, exports) {

$parcel$export(module.exports, "useSubProduct", () => $eeb1612abd150435$export$16aa2ad52cd8992a);
$parcel$export(module.exports, "subProductFromProjectTypeForAnalytics", () => $eeb1612abd150435$export$9243583e56af95f6);
$parcel$export(module.exports, "useSubProductForAnalytics", () => $eeb1612abd150435$export$cbfa57dd4a0c679e);

var $6nVJI = parcelRequire("6nVJI");
const $eeb1612abd150435$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 'business':
            return 'core';
        case 'product_discovery':
        case 'software':
            return 'software';
        case 'service_desk':
            return 'serviceDesk';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            projectType;
            return 'unknown';
    }
};
const $eeb1612abd150435$export$16aa2ad52cd8992a = ()=>{
    const [{ data: data }] = (0, $6nVJI.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data?.project) return null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return $eeb1612abd150435$export$246e1e2a5c86a633(data.project.type);
};
const $eeb1612abd150435$export$9243583e56af95f6 = (projectType)=>{
    if (projectType === 'product_discovery') return 'polaris';
    return $eeb1612abd150435$export$246e1e2a5c86a633(projectType);
};
const $eeb1612abd150435$export$cbfa57dd4a0c679e = ()=>{
    const [{ data: data }] = (0, $6nVJI.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data?.project) return null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return $eeb1612abd150435$export$9243583e56af95f6(data.project.type);
};

});
parcelRegister("6nVJI", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $6342ac67d1a862a1$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $6342ac67d1a862a1$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $3luhJ = parcelRequire("3luhJ");

var $9pJMP = parcelRequire("9pJMP");

var $eJrcF = parcelRequire("eJrcF");

var $kQSJV = parcelRequire("kQSJV");
const $6342ac67d1a862a1$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)((0, $9pJMP.staticProjectSidebarNavigationResource));
    const projectContext = (0, $eJOHy.useMemo)(()=>data && (0, $kQSJV.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $6342ac67d1a862a1$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)((0, $3luhJ.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $eJOHy.useMemo)(()=>data && (0, $kQSJV.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $6342ac67d1a862a1$export$c7066c2d215990cf = ()=>{
    const projectContext = $6342ac67d1a862a1$var$useProjectContext();
    const userBoardContext = $6342ac67d1a862a1$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $6342ac67d1a862a1$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $6342ac67d1a862a1$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$6342ac67d1a862a1$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("kQSJV", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $3546d4ad536b057d$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $3546d4ad536b057d$export$d17fffd59c7b3c60);

var $7jTnu = parcelRequire("7jTnu");

var $ln6Iy = parcelRequire("ln6Iy");

var $imXGf = parcelRequire("imXGf");
const $3546d4ad536b057d$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $3546d4ad536b057d$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $3546d4ad536b057d$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $7jTnu.fg)('jcs_project_type_m3')) return 0, $ln6Iy.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $ln6Iy.CORE_PROJECT;
        case 'software':
            return 0, $ln6Iy.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $ln6Iy.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $3546d4ad536b057d$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $imXGf.extractData)(projectNavInfo);
    const scope = $3546d4ad536b057d$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $3546d4ad536b057d$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $imXGf.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("lB9yu", function(module, exports) {

$parcel$export(module.exports, "EDITION_KEY", () => $be8e62b37240bbc2$export$d73720c31c622c1f);

var $a9ldn = parcelRequire("a9ldn");
const $be8e62b37240bbc2$export$d73720c31c622c1f = {
    STANDARD_EDITION: (0, $a9ldn.STANDARD_EDITION_KEY),
    PREMIUM_EDITION: (0, $a9ldn.PREMIUM_EDITION_KEY)
};

});

parcelRegister("iVQXn", function(module, exports) {

$parcel$export(module.exports, "getProductReferrerKey", () => $15ad553fd61d4764$export$b4fb3304d5d8fc5f);
$parcel$export(module.exports, "getCcpTransactionAccountId", () => $15ad553fd61d4764$export$5186b9d213f626fd);

var $1Ozm9 = parcelRequire("1Ozm9");

const $15ad553fd61d4764$export$b4fb3304d5d8fc5f = (productKey)=>{
    if (productKey === (0, $e08dff4ae358d899$export$1346c9aa3cbb477d)) return 'jsw';
    if (productKey === (0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61)) return 'jsm';
    if (productKey === (0, $e08dff4ae358d899$export$202f50ee62667e32)) return 'jpd';
    if (productKey === (0, $e08dff4ae358d899$export$db515c8cec1e6f79)) return 'jwm';
    return null;
};
const $15ad553fd61d4764$export$5186b9d213f626fd = async (entitlementId)=>{
    const entitlementDetails = await (0, $1Ozm9.default)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`);
    if (!entitlementDetails?.transactionAccountId) // TODO: Handle errors properly
    throw Error('Could not get transactionAccountId');
    return (entitlementDetails ?? {}).transactionAccountId;
};

});

parcelRegister("ccm7u", function(module, exports) {

$parcel$export(module.exports, "getAdminBaseUrl", () => $ccf3c5523a755393$export$76bb37a926058cca);

var $9id36 = parcelRequire("9id36");
const $ccf3c5523a755393$export$76bb37a926058cca = ()=>`https://${(0, $9id36.getATLContextDomain)('admin')}`;

});

parcelRegister("gvwWc", function(module, exports) {

$parcel$export(module.exports, "getProductKey", () => $393097453086ea59$export$d0b7f02493f85477);

const $393097453086ea59$export$d0b7f02493f85477 = (subProduct, explicitlyLicensedProducts)=>{
    if (subProduct === 'software') return 0, $e08dff4ae358d899$export$1346c9aa3cbb477d;
    if (subProduct === 'serviceDesk') return 0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61;
    // useSubProduct currently doesn't support polaris
    // JPD's subproduct currently falls under to 'software'
    // https://hello.atlassian.net/wiki/spaces/STAR/pages/2940457206/Detach+from+JSW+analytics+subproduct
    if (subProduct === 'polaris') return 0, $e08dff4ae358d899$export$202f50ee62667e32;
    if (subProduct === 'core') return 0, $e08dff4ae358d899$export$db515c8cec1e6f79;
    // If subProduct is null, we may be on a product-agnostic page e.g. "Your Work".
    // If there is only one licensed product, we can infer what the user is using.
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};

});



parcelRegister("bTM76", function(module, exports) {

$parcel$export(module.exports, "PremiumUpgradeModalEntryPointButton", () => $162fa162a8030292$export$9901be7804227da7);

var $eJOHy = parcelRequire("eJOHy");

var $iTElX = parcelRequire("iTElX");

var $ciFJV = parcelRequire("ciFJV");

var $cystD = parcelRequire("cystD");

var $bbdV2 = parcelRequire("bbdV2");

var $jM5Jy = parcelRequire("jM5Jy");
const $162fa162a8030292$var$entryPointParams = {};
const $162fa162a8030292$export$9901be7804227da7 = (buttonProps)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $jM5Jy.entryPointPremiumUpgradeModal), $162fa162a8030292$var$entryPointParams);
    const buttonTrigger = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iTElX.default), {
        ...buttonProps,
        ref: buttonTrigger
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cystD.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jira-premium-upgrade-modal",
        packageName: "jiraPremiumUpgradeModal",
        errorFallback: "flag",
        runtimeProps: {
            onClose: entryPointActions.unload
        },
        entryPointActions: entryPointActions
    }));
};

});
parcelRegister("cystD", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointContainer", () => $769130408c5d1c36$export$4d67c6ee49f3d14d);

var $eJOHy = parcelRequire("eJOHy");

var $jC5ye = parcelRequire("jC5ye");

var $snbGZ = parcelRequire("snbGZ");

var $5GSFM = parcelRequire("5GSFM");
const $769130408c5d1c36$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
    const entryPointReference = (0, $snbGZ.useEntryPointSubscription)(entryPointReferenceSubject);
    const props = (0, $eJOHy.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            ...runtimeProps,
            onClose () {
                runtimeProps.onClose?.();
                unload();
            }
        }), [
        runtimeProps,
        unload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jC5ye.default), null, entryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5GSFM.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        errorFallback: errorFallback || 'flag',
        placeholderName: "modal-entry-point-container",
        runtimeProps: props
    }));
};

});

parcelRegister("jM5Jy", function(module, exports) {

$parcel$export(module.exports, "entryPointPremiumUpgradeModal", () => $ff67c1d5e3e2bfd0$export$7116d5b1a93db8d6);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $ff67c1d5e3e2bfd0$export$7116d5b1a93db8d6 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("59Vez")).then((module)=>module.PremiumUpgradeModalEntryPoint), {
        moduleId: "1102b440",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("59Vez", function(module, exports) {

let $3c1a308343b279c0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $3c1a308343b279c0$var$load("1VRB2"),
    $3c1a308343b279c0$var$load("bABhq"),
    $3c1a308343b279c0$var$load("k4gbU"),
    $3c1a308343b279c0$var$load("lyURz")
]).then(()=>parcelRequire('dx6ox'));

});



parcelRegister("aH1Gm", function(module, exports) {

$parcel$export(module.exports, "getTrialSprintBoardProjectId", () => $73e8b5416b2b188d$export$dca4afd9682f517e);

var $lctcw = parcelRequire("lctcw");

var $gYnSx = parcelRequire("gYnSx");

const $73e8b5416b2b188d$export$dca4afd9682f517e = async (cloudId)=>{
    try {
        const siteTraits = await (0, $lctcw.memoizedFetchSitePersonalization)({
            cloudId: cloudId
        });
        const trialSprintBoardTrait = siteTraits.find((traits)=>traits.name === (0, $fc7a5393316802ea$export$cf8de4fabae858f0));
        if (typeof trialSprintBoardTrait?.value !== 'string') return undefined;
        return trialSprintBoardTrait.value;
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'fetchTrialSprintBoardProjectId',
                packageName: (0, $fc7a5393316802ea$export$b8b9d90f9e5bd72b),
                teamName: (0, $fc7a5393316802ea$export$d57b6b390e78d90f)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});
const $fc7a5393316802ea$export$b8b9d90f9e5bd72b = 'jira-plans-banners';
const $fc7a5393316802ea$export$d57b6b390e78d90f = 'growth-tako';
const $fc7a5393316802ea$export$cf8de4fabae858f0 = 'jira_premium_sample_project_id';


parcelRegister("ggYw9", function(module, exports) {

$parcel$export(module.exports, "getNumProjects", () => $b6f3b8b23fd6b9e2$export$ec937392490def10);

var $dbBnI = parcelRequire("dbBnI");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $gYnSx = parcelRequire("gYnSx");

const $b6f3b8b23fd6b9e2$export$ec937392490def10 = async (cloudId)=>{
    try {
        return await (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), (0, $dbBnI.default), {
            cloudId: cloudId
        }).toPromise().then((data)=>data?.jira?.allJiraProjects?.totalCount);
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('getNumProjects failed');
        (0, $gYnSx.default)({
            meta: {
                id: 'fetchNumProjects',
                packageName: (0, $fc7a5393316802ea$export$b8b9d90f9e5bd72b),
                teamName: (0, $fc7a5393316802ea$export$d57b6b390e78d90f)
            },
            sendToPrivacyUnsafeSplunk: true,
            error: typeGuardedError
        });
        return null;
    }
};

});
parcelRegister("dbBnI", function(module, exports) {

$parcel$export(module.exports, "default", () => $abf79b849effcd52$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<beeb6eb5abb0dddd6270d6c8fd8e3f6b>>
 * @relayHash dd3946513cb4a6664dfc08bfd9b0ab23
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9aaecc14f5181b304672459af4e7026818b4c4d74d26e40adbbe80c967c46288
const $abf79b849effcd52$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {}
                        }
                    ],
                    "concreteType": "JiraProjectConnection",
                    "kind": "LinkedField",
                    "name": "allJiraProjects",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getNumProjectsJPBQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getNumProjectsJPBQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "9aaecc14f5181b304672459af4e7026818b4c4d74d26e40adbbe80c967c46288",
            "metadata": {},
            "name": "getNumProjectsJPBQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$abf79b849effcd52$var$node.hash = "e6cc3e7bbc5fdfe0dcb1b02c4dd70ebb";
var $abf79b849effcd52$export$2e2bcd8739ae039 = $abf79b849effcd52$var$node;

});


parcelRegister("8Q8RO", function(module, exports) {

$parcel$export(module.exports, "FeatureGateLogo", () => $9df4824909321a97$export$83d4ce06fb8c3c0);

var $eJOHy = parcelRequire("eJOHy");

var $eFc5v = parcelRequire("eFc5v");

var $j3e4y = parcelRequire("j3e4y");

var $g1Km9 = parcelRequire("g1Km9");
const $9df4824909321a97$export$83d4ce06fb8c3c0 = ({ colorMode: colorMode, alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eFc5v.default), {
        src: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($j3e4y))) : (0, (/*@__PURE__*/$parcel$interopDefault($g1Km9))),
        alt: alt
    });

});
parcelRegister("eFc5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $f740e380abc3ebd1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dOd8C = parcelRequire("dOd8C");

var $5M7r5 = parcelRequire("5M7r5");
const $f740e380abc3ebd1$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $f740e380abc3ebd1$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $eJOHy.useRef)(null);
    const providedColorMode = (0, $dOd8C.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $5M7r5.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $eJOHy.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $hcewu.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("dOd8C", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $1e4c7df6ffb480fd$export$ce91654eb9fea460);
$parcel$export(module.exports, "default", () => $1e4c7df6ffb480fd$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $ib39d = parcelRequire("ib39d");
var $fyago = parcelRequire("fyago");
var $fM88h = parcelRequire("fM88h");
const $1e4c7df6ffb480fd$var$defaultThemeSettings = ()=>({
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: 'typography'
    });
const $1e4c7df6ffb480fd$var$ColorModeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $1e4c7df6ffb480fd$var$SetColorModeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $1e4c7df6ffb480fd$var$ThemeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $1e4c7df6ffb480fd$var$SetThemeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
function $1e4c7df6ffb480fd$export$ce91654eb9fea460() {
    const value = (0, $eJOHy.useContext)($1e4c7df6ffb480fd$var$ColorModeContext);
    return value;
}
function $1e4c7df6ffb480fd$export$20f3076712c8dfa() {
    const value = (0, $eJOHy.useContext)($1e4c7df6ffb480fd$var$ColorModeContext);
    const { colorMode: colorMode } = (0, $ib39d.default)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $eJOHy.useState)(colorMode || 'light');
    (0, $eJOHy.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $fM88h.default)((theme)=>{
            setResolvedColorMode(theme.colorMode || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}
function $1e4c7df6ffb480fd$export$e2afe7397c3d11c7() {
    const value = (0, $eJOHy.useContext)($1e4c7df6ffb480fd$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
}
function $1e4c7df6ffb480fd$export$93d4e7f90805808f() {
    const theme = (0, $eJOHy.useContext)($1e4c7df6ffb480fd$var$ThemeContext);
    const [resolvedTheme, setResolvedTheme] = (0, $eJOHy.useState)(theme || (0, $ib39d.default)());
    (0, $eJOHy.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        const observer = new (0, $fM88h.default)(setResolvedTheme);
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    return theme ? theme : resolvedTheme;
}
function $1e4c7df6ffb480fd$export$501aa0dcd5527a48() {
    const value = (0, $eJOHy.useContext)($1e4c7df6ffb480fd$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $1e4c7df6ffb480fd$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $1e4c7df6ffb480fd$var$prefersDarkModeMql = $1e4c7df6ffb480fd$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $1e4c7df6ffb480fd$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $1e4c7df6ffb480fd$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 *
 * @internal
 */ function $1e4c7df6ffb480fd$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode, defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $eJOHy.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $eJOHy.useState)($1e4c7df6ffb480fd$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $eJOHy.useState)(()=>({
            ...$1e4c7df6ffb480fd$var$defaultThemeSettings(),
            ...defaultTheme
        }));
    const setColorMode = (0, $eJOHy.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($1e4c7df6ffb480fd$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $eJOHy.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        /**
     * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
     * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
     * `data-color-mode` attribute on the root element).
     *
     * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
     * applying the new theme.
     *
     * Without this, we can end up in the following scenario:
     * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
     * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
     * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
     * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
     */ const cleanupLastFnCall = async ()=>{
            if (lastSetGlobalThemePromiseRef.current) {
                const unbindFn = await lastSetGlobalThemePromiseRef.current;
                unbindFn();
                lastSetGlobalThemePromiseRef.current = null;
            }
        };
        const safelySetGlobalTheme = async ()=>{
            await cleanupLastFnCall();
            const promise = (0, $fyago.default)({
                ...theme,
                colorMode: reconciledColorMode
            });
            lastSetGlobalThemePromiseRef.current = promise;
        };
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!$1e4c7df6ffb480fd$var$prefersDarkModeMql) return;
        const unbindListener = (0, $4eDgu.bind)($1e4c7df6ffb480fd$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($1e4c7df6ffb480fd$var$ColorModeContext.Provider, {
        value: reconciledColorMode,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($1e4c7df6ffb480fd$var$SetColorModeContext.Provider, {
            value: setColorMode,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($1e4c7df6ffb480fd$var$ThemeContext.Provider, {
                value: theme,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($1e4c7df6ffb480fd$var$SetThemeContext.Provider, {
                    value: setPartialTheme,
                    children: children
                })
            })
        })
    });
}
var $1e4c7df6ffb480fd$export$2e2bcd8739ae039 = $1e4c7df6ffb480fd$var$ThemeProvider;

});


parcelRegister("j3e4y", function(module, exports) {
module.exports = new URL("plans-standard-dark.fce82c99.svg", import.meta.url).toString();

});

parcelRegister("g1Km9", function(module, exports) {
module.exports = new URL("plans-standard-light.fde35b0d.svg", import.meta.url).toString();

});


parcelRegister("2lxyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $548889fe000ec202$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $548889fe000ec202$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.title",
        "defaultMessage": "Unlock advanced planning tools"
    },
    imageAlt: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.image-alt",
        "defaultMessage": "Upgrade to Jira Premium"
    },
    description: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.description",
        "defaultMessage": "Boost agility with capacity planning, dependency mapping, and more. Try Jira Premium's high-level cross-team planning tools."
    },
    learnMoreLink: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.learn-more-link",
        "defaultMessage": "Read the guide"
    },
    startTrialButton: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.start-trial-button",
        "defaultMessage": "Try it free"
    }
});

});


parcelRegister("8QNrG", function(module, exports) {

$parcel$export(module.exports, "planUpsellEntryPoint", () => $806a1861d52f428e$export$2fc05036b41321cf);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $806a1861d52f428e$export$2fc05036b41321cf = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("emvhV9")), {
        moduleId: "8a4ffc36",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("emvhV9", function(module, exports) {

let $a74b63e9db672d0a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $a74b63e9db672d0a$var$load("eDzss"),
    $a74b63e9db672d0a$var$load("9FC4P")
]).then(()=>parcelRequire('8FBSU'));

});


parcelRegister("8ETQ8", function(module, exports) {

$parcel$export(module.exports, "planUpsellRoute", () => $ec51e5c95e8e72d8$export$bda76e09a8dec9a0);
const $ec51e5c95e8e72d8$export$bda76e09a8dec9a0 = {
    name: 'software-plan-upsell',
    path: '/jira/plans/getting-started'
};

});




parcelRegister("cRvJm", function(module, exports) {

$parcel$export(module.exports, "Nav4Projects", () => $afb39020d8dd9a2c$export$5baf9fa0c4742f3f);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $gOGK2 = parcelRequire("gOGK2");

var $16sa1 = parcelRequire("16sa1");

const $afb39020d8dd9a2c$export$5baf9fa0c4742f3f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4-sidebar-projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "projects-section",
        packageName: (0, $6764ca6ce23ee75f$export$b8b9d90f9e5bd72b),
        teamName: (0, $6764ca6ce23ee75f$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gOGK2.Nav4Projects), props)));

});
parcelRegister("gOGK2", function(module, exports) {

$parcel$export(module.exports, "Nav4Projects", () => $8f448c55bed481b6$export$5baf9fa0c4742f3f);

var $gtz5l = parcelRequire("gtz5l");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $3dC7Q = parcelRequire("3dC7Q");

var $c16ff = parcelRequire("c16ff");

var $cXi8d = parcelRequire("cXi8d");

var $54VT4 = parcelRequire("54VT4");
function $8f448c55bed481b6$export$5baf9fa0c4742f3f({ isExpanded: isExpanded, queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $gtz5l.default), queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const canCreateProject = !!data?.jira?.canCreateProject;
    const shouldDisplayCreateProject = !!data?.jira?.shouldDisplay;
    const actionButtons = (0, $fAZgY.useMemoWithCondition)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c16ff.ActionButtons), {
            canCreateProject: canCreateProject,
            ...(0, $7jTnu.fg)('allow_end_users_to_access_custom_templates') ? {
                shouldDisplayCreateProject: shouldDisplayCreateProject
            } : {}
        }), [
        canCreateProject,
        shouldDisplayCreateProject
    ], ()=>(0, $7jTnu.fg)('jfp_magma_jsm-perf-improvement-batch-1'));
    (0, $3dC7Q.useCreateProjectCheckPermissions)();
    if (!data.jira?.hasIsProjectsExpanded && isInitialSelectedPath((0, $h4Bzb.MENU_ID_PROJECTS))) // We need to make sure that we're only passing the conditionalal fragment when it is actually
    // available. Due to a lack of support the @alias Relay directive, we need to use another mechanism
    // and in this case we're using a hardcoded __typename to check if the fragment is available.
    // This is a workaround until we can use the @alias directive in Relay. If the hasIsProjectsExpanded
    // attribute is not available, then the fragment won't be either and we shouldn't pass it.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cXi8d.Nav4ProjectsDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
    return isInitialSelectedPath((0, $h4Bzb.MENU_ID_PROJECTS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54VT4.Nav4ProjectsForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cXi8d.Nav4ProjectsDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
}

});
parcelRegister("gtz5l", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc58dd7864d72016$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9f941ff862d2764358520de269768f5d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fc58dd7864d72016$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "isProjectsExpanded"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4Projects",
        "selections": [
            {
                "condition": "isProjectsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4ProjectsForLanding"
                    }
                ]
            },
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "isProjectsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "alias": "hasIsProjectsExpanded",
                                "kind": "ScalarField",
                                "name": "__typename"
                            }
                        ]
                    },
                    {
                        "alias": "canCreateProject",
                        "args": [
                            v0 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "CREATE_PROJECT"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "canPerform"
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "alias": "shouldDisplay",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "VIEW_PROJECT_CREATION_ENTRY"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "canPerform"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$fc58dd7864d72016$var$node.hash = "428884bcc8ab2cce6e9121035fe9e8b6";
var $fc58dd7864d72016$export$2e2bcd8739ae039 = $fc58dd7864d72016$var$node;

});

parcelRegister("3dC7Q", function(module, exports) {

$parcel$export(module.exports, "useCreateProjectCheckPermissions", () => $dd6e1f8764742d42$export$1fb28f66ef08585d);

var $89jZD = parcelRequire("89jZD");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $dnU6V = parcelRequire("dnU6V");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $gZTP9 = parcelRequire("gZTP9");

var $kEUB1 = parcelRequire("kEUB1");
const $dd6e1f8764742d42$var$localStorageProvider = (0, $dnU6V.createLocalStorageProvider)('analytics-permission-check');
const $dd6e1f8764742d42$export$1fb28f66ef08585d = ()=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (!$dd6e1f8764742d42$var$localStorageProvider.get('complete') && (0, $7jTnu.fg)('groot-create-team-project-permission-check')) {
            (0, $j4oe4.fetchQuery)(environment, (0, $89jZD.default), {
                cloudId: cloudId
            }).subscribe({
                next: (data)=>{
                    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'createProject userPermissions', {
                        canCreateProject: !!data?.jira?.canCreateProject,
                        canCreateTeamManagedProject: !!data?.jira?.canCreateTeamManagedProject,
                        canCreateCompanyManagedProject: !!data?.jira?.canCreateCompanyManagedProject,
                        isAdmin: isAdmin
                    });
                }
            });
            $dd6e1f8764742d42$var$localStorageProvider.set('complete', true);
        }
    });
};

});
parcelRegister("89jZD", function(module, exports) {

$parcel$export(module.exports, "default", () => $71f56317a51cb6ce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c93e540d636d0b392cdbbee73a0755ce>>
 * @relayHash 62bedc769e6bd9abd36363472bc29495
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b61f743a91e56bc00fd4727121e1381902c2c173f101c226049470d68a35783
const $71f56317a51cb6ce$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "alias": "canCreateProject",
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                },
                {
                    "alias": "canCreateTeamManagedProject",
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_TEAM_MANAGED_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                },
                {
                    "alias": "canCreateCompanyManagedProject",
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_COMPANY_MANAGED_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "analyticsPermissionCheckCreateProjectQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "analyticsPermissionCheckCreateProjectQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "1b61f743a91e56bc00fd4727121e1381902c2c173f101c226049470d68a35783",
            "metadata": {},
            "name": "analyticsPermissionCheckCreateProjectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$71f56317a51cb6ce$var$node.hash = "5895b8dfd4b6785a379d210f5d735279";
var $71f56317a51cb6ce$export$2e2bcd8739ae039 = $71f56317a51cb6ce$var$node;

});


parcelRegister("c16ff", function(module, exports) {

$parcel$export(module.exports, "ActionButtons", () => $823a7cf09c8a263e$export$88c65d2d98aab183);

var $eJOHy = parcelRequire("eJOHy");

var $ejfxj = parcelRequire("ejfxj");

var $i140O = parcelRequire("i140O");

var $apGPk = parcelRequire("apGPk");
var $MlWTN = parcelRequire("MlWTN");
var $7R1al = parcelRequire("7R1al");

var $9JB3T = parcelRequire("9JB3T");

var $kO1ht = parcelRequire("kO1ht");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $33Xtl = parcelRequire("33Xtl");

var $k4qPj = parcelRequire("k4qPj");

var $1pmgP = parcelRequire("1pmgP");

var $dN2O6 = parcelRequire("dN2O6");

var $lHnXI = parcelRequire("lHnXI");

var $1OC2y = parcelRequire("1OC2y");


var $8IuE5 = parcelRequire("8IuE5");

var $ajqBI = parcelRequire("ajqBI");

var $6naEG = parcelRequire("6naEG");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $9o3jI = parcelRequire("9o3jI");

var $7jTnu = parcelRequire("7jTnu");

var $5Ld7K = parcelRequire("5Ld7K");
function $823a7cf09c8a263e$export$88c65d2d98aab183({ onClose: onClose, canCreateProject: canCreateProject, shouldDisplayCreateProject: shouldDisplayCreateProject }) {
    const projectsGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $5Ld7K.default).projectsGalaxia : (0, $5Ld7K.default).projects;
    const createProjectGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $5Ld7K.default).createProjectGalaxia : (0, $5Ld7K.default).createProject;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [, { on: openProjectCreateDrawer }] = (0, $9o3jI.useSwitchModals)((0, $kO1ht.MODAL_ID).PROJECT_CREATE);
    const { sendMeatBallDropDownAnalyticsEvent: sendMeatBallDropDownAnalyticsEvent, sendCreateProjectAnalyticsEvent: sendCreateProjectAnalyticsEvent } = (0, $dN2O6.useProjectsAnalyticsL1)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        openProjectCreateDrawer();
        sendCreateProjectAnalyticsEvent();
    }, [
        openProjectCreateDrawer,
        sendCreateProjectAnalyticsEvent
    ]);
    const onOpen = (0, $eJOHy.useCallback)(()=>{
        sendMeatBallDropDownAnalyticsEvent();
    }, [
        sendMeatBallDropDownAnalyticsEvent
    ]);
    const showProjectCreateButton = (0, $7jTnu.fg)('allow_end_users_to_access_custom_templates') ? shouldDisplayCreateProject : canCreateProject;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showProjectCreateButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: formatMessage(createProjectGalaxia)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i140O))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage(createProjectGalaxia),
        onClick: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? onClick : ()=>{
            openProjectCreateDrawer();
            sendCreateProjectAnalyticsEvent();
        }
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        ...(0, $7jTnu.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
            name: formatMessage(projectsGalaxia)
        } : {},
        onOpen: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? onOpen : ()=>{
            sendMeatBallDropDownAnalyticsEvent();
        },
        MenuItems: $823a7cf09c8a263e$var$MoreMenuItems,
        onClose: onClose
    }));
}
function $823a7cf09c8a263e$var$MoreMenuItems({ onClose: onClose }) {
    const manageProjectsGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $5Ld7K.default).manageProjectsGalaxia : (0, $5Ld7K.default).manageProjects;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const href = (0, $eJOHy.useMemo)(()=>(0, $33Xtl.getProjectsNavigationPaths)().projectsViewProjects, []);
    const { sendMeatBallDropDownManageProjectsAnalyticsEvent: sendMeatBallDropDownManageProjectsAnalyticsEvent, sendChangeViewAnalyticsEvent: sendChangeViewAnalyticsEvent } = (0, $lHnXI.useProjectsAnalyticsL2)();
    const { sendChangeViewViewOptionAnalyticsEvent: sendChangeViewViewOptionAnalyticsEvent } = (0, $1OC2y.useProjectsAnalyticsL3)();
    const onCloseWithStopPropagation = (0, $6naEG.useStopPropagation)((e)=>{
        sendMeatBallDropDownManageProjectsAnalyticsEvent();
        onClose?.(e);
    });
    const onChangeViewOptionChange = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)((viewOptionValue)=>{
        const getItemId = ()=>{
            switch(viewOptionValue){
                case (0, $1pmgP.ViewOptions).STARRED:
                    return 0, $bc40578f06d7846b$export$ed36b1ade72db400;
                case (0, $1pmgP.ViewOptions).STARRED_AND_RECENT:
                    return 0, $bc40578f06d7846b$export$98d08638c2a90c44;
                case (0, $1pmgP.ViewOptions).MOST_RECENT_ONLY:
                    return 0, $bc40578f06d7846b$export$f8a73cc0211412ca;
                default:
                    return 0, $bc40578f06d7846b$export$98d08638c2a90c44;
            }
        };
        sendChangeViewViewOptionAnalyticsEvent({
            itemId: getItemId()
        });
    }, [
        sendChangeViewViewOptionAnalyticsEvent
    ]) : (viewOptionValue)=>{
        const getItemId = ()=>{
            switch(viewOptionValue){
                case (0, $1pmgP.ViewOptions).STARRED:
                    return 0, $bc40578f06d7846b$export$ed36b1ade72db400;
                case (0, $1pmgP.ViewOptions).STARRED_AND_RECENT:
                    return 0, $bc40578f06d7846b$export$98d08638c2a90c44;
                case (0, $1pmgP.ViewOptions).MOST_RECENT_ONLY:
                    return 0, $bc40578f06d7846b$export$f8a73cc0211412ca;
                default:
                    return 0, $bc40578f06d7846b$export$98d08638c2a90c44;
            }
        };
        sendChangeViewViewOptionAnalyticsEvent({
            itemId: getItemId()
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apGPk.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ejfxj))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: href,
        onClick: onCloseWithStopPropagation
    }, formatMessage(manageProjectsGalaxia))), (0, $epTsa.expVal)('blu-6315-display-settings-a-part-1', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
        hasSeparator: true,
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k4qPj.ChangeViewMenuItem), {
        onOpen: sendChangeViewAnalyticsEvent,
        onChange: onChangeViewOptionChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        hasSeparator: false,
        menuId: (0, $8IuE5.L1_MENU_ID).PROJECTS,
        hasSection: false
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).PROJECTS,
        hasSection: true
    }));
}

});
parcelRegister("33Xtl", function(module, exports) {

$parcel$export(module.exports, "getProjectsNavigationPaths", () => $bd7b21fc4d3ba3ed$export$5b37488a9fd89879);
const $bd7b21fc4d3ba3ed$export$5b37488a9fd89879 = ()=>({
        projectsViewProjects: '/jira/settings/projects/manage',
        projectsViewCategories: '/secure/admin/projectcategories/ViewProjectCategories!default.jspa',
        projectsTrashedProjects: '/jira/settings/projects/trash',
        projectsArchivedProjects: '/jira/settings/projects/archive'
    });

});

parcelRegister("k4qPj", function(module, exports) {

$parcel$export(module.exports, "ChangeViewMenuItem", () => $a05c6654b9badc12$export$3bc1c3c28804a19b);

var $eJOHy = parcelRequire("eJOHy");

var $abxMj = parcelRequire("abxMj");

var $dbtUh = parcelRequire("dbtUh");

var $1AUsu = parcelRequire("1AUsu");

var $jd93d = parcelRequire("jd93d");

var $lRq8t = parcelRequire("lRq8t");

var $cNe2t = parcelRequire("cNe2t");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $ciFJV = parcelRequire("ciFJV");

var $kEUB1 = parcelRequire("kEUB1");

var $epTsa = parcelRequire("epTsa");

var $f2JN3 = parcelRequire("f2JN3");

var $jMoKX = parcelRequire("jMoKX");

var $1wuuz = parcelRequire("1wuuz");

var $4ivVe = parcelRequire("4ivVe");

var $i0gEO = parcelRequire("i0gEO");

var $k6xks = parcelRequire("k6xks");
const $a05c6654b9badc12$export$3bc1c3c28804a19b = (0, $f2JN3.componentWithCondition)(()=>(0, $epTsa.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false), $a05c6654b9badc12$var$ChangeViewMenuItemNew, $a05c6654b9badc12$var$ChangeViewMenuItemOld);
function $a05c6654b9badc12$var$ChangeViewMenuItemOld({ onOpen: onOpen, onChange: onChange }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const onChangeViewMenuItemClick = ()=>{
        if (!isOpen && onOpen) onOpen();
        setIsOpen(!isOpen);
    };
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $i0gEO.ViewOptionsMenuPopupContentEntrypoint), {
        scope: (0, $jMoKX.DisplaySettingsScope).PROJECTS,
        onChange: onChange
    });
    const entrypointRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "display-settings-menu-popup-content",
                packageName: "jira-navigation-apps-sidebar-nav4-display-settings",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1wuuz.Skeleton), null),
                runtimeProps: {}
            }),
        placement: "right-start",
        messageId: "navigation-apps-sidebar-nav4-display-settings.ui.change-view-menu-item.popup",
        messageType: "transactional",
        shouldRenderToParent: true,
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
                ...triggerProps,
                ref: (0, $jd93d.default)(ref, entrypointRef),
                isSelected: isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dbtUh))), {
                    label: formatMessage((0, $4ivVe.default).listBulletedIcon),
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($abxMj))), {
                    label: formatMessage((0, $4ivVe.default).chevronRightIcon),
                    size: "small"
                }),
                onClick: onChangeViewMenuItemClick,
                "aria-label": formatMessage((0, $4ivVe.default).changeViewMenuItemLabel),
                "aria-expanded": isOpen,
                "aria-haspopup": "true"
            }, formatMessage((0, $4ivVe.default).changeViewMenuItemLabel))
    });
}
function $a05c6654b9badc12$var$ChangeViewMenuItemNew({ onOpen: onOpen, onChange: onChange }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const cloudId = (0, $kEUB1.useCloudId)();
    const onChangeViewMenuItemClick = ()=>{
        if (!isOpen && onOpen) onOpen();
        setIsOpen(!isOpen);
    };
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $k6xks.ProjectsViewOptionsEntrypoint), {
        cloudId: cloudId,
        onChange: onChange
    });
    const entrypointRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "display-settings-menu-popup-content",
                packageName: "jira-navigation-apps-sidebar-nav4-display-settings",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1wuuz.Skeleton), null),
                runtimeProps: {},
                errorFallback: "flag"
            }),
        placement: "right-start",
        // Duplicate messageId due to experiment conditional component
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: "navigation-apps-sidebar-nav4-display-settings.ui.change-view-menu-item.popup",
        messageType: "transactional",
        shouldRenderToParent: true,
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
                ...triggerProps,
                ref: (0, $jd93d.default)(ref, entrypointRef),
                isSelected: isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dbtUh))), {
                    label: formatMessage((0, $4ivVe.default).listBulletedIcon),
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($abxMj))), {
                    label: formatMessage((0, $4ivVe.default).chevronRightIcon),
                    size: "small"
                }),
                onClick: onChangeViewMenuItemClick,
                "aria-label": formatMessage((0, $4ivVe.default).changeViewMenuItemLabel),
                "aria-expanded": isOpen,
                "aria-haspopup": "true",
                testId: "navigation-apps-sidebar-nav4-display-settings.ui.change-view-menu-item.button"
            }, formatMessage((0, $4ivVe.default).changeViewMenuItemLabel))
    });
}

});
parcelRegister("dbtUh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9993804d6bf4a0ef$var$_react = $9993804d6bf4a0ef$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9993804d6bf4a0ef$var$_baseNew = $9993804d6bf4a0ef$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $9993804d6bf4a0ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9993804d6bf4a0ef$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $9993804d6bf4a0ef$var$_react.default.createElement($9993804d6bf4a0ef$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$9993804d6bf4a0ef$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $9993804d6bf4a0ef$var$_default = module.exports.default = $9993804d6bf4a0ef$var$ListBulletedIcon;

});

parcelRegister("jMoKX", function(module, exports) {

$parcel$export(module.exports, "DisplaySettingsScope", () => $6db3a664fc2e02d9$export$5df97773a9667af8);
$parcel$export(module.exports, "DisplaySettingsPropertyKeys", () => $6db3a664fc2e02d9$export$5d9ca2391194d3c8);
$parcel$export(module.exports, "DisplaySettingsAllowedValuesMap", () => $6db3a664fc2e02d9$export$3938c8b7d6f592c);

var $1pmgP = parcelRequire("1pmgP");
const $6db3a664fc2e02d9$var$PROJECTS = 'projects';
const $6db3a664fc2e02d9$export$5df97773a9667af8 = {
    PROJECTS: $6db3a664fc2e02d9$var$PROJECTS
};
const $6db3a664fc2e02d9$var$VIEW_OPTION = 'VIEW_OPTION';
const $6db3a664fc2e02d9$export$5d9ca2391194d3c8 = {
    VIEW_OPTION: $6db3a664fc2e02d9$var$VIEW_OPTION
};
const $6db3a664fc2e02d9$export$3938c8b7d6f592c = {
    [$6db3a664fc2e02d9$export$5d9ca2391194d3c8.VIEW_OPTION]: Object.values((0, $1pmgP.ViewOptions))
};

});
parcelRegister("1pmgP", function(module, exports) {

$parcel$export(module.exports, "ViewOptions", () => $b7f6e74014e3545d$export$8cd3967b7c246658);
$parcel$export(module.exports, "DefaultViewOption", () => $b7f6e74014e3545d$export$8df870734bca67fa);
const $b7f6e74014e3545d$var$STARRED_AND_RECENT = 'STARRED_AND_RECENT';
const $b7f6e74014e3545d$var$STARRED = 'STARRED';
const $b7f6e74014e3545d$var$MOST_RECENT_ONLY = 'MOST_RECENT_ONLY';
const $b7f6e74014e3545d$export$8cd3967b7c246658 = {
    STARRED_AND_RECENT: $b7f6e74014e3545d$var$STARRED_AND_RECENT,
    STARRED: $b7f6e74014e3545d$var$STARRED,
    MOST_RECENT_ONLY: $b7f6e74014e3545d$var$MOST_RECENT_ONLY
};
const $b7f6e74014e3545d$export$8df870734bca67fa = $b7f6e74014e3545d$export$8cd3967b7c246658.STARRED_AND_RECENT;

});


parcelRegister("1wuuz", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $5012924f9d39438e$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $MlWTN = parcelRequire("MlWTN");
var $7R1al = parcelRequire("7R1al");
var $f9Ihw = parcelRequire("f9Ihw");

var $5Q9JR = parcelRequire("5Q9JR");

var $epTsa = parcelRequire("epTsa");
const $5012924f9d39438e$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), {
        minWidth: (0, $5Q9JR.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), null), (0, $epTsa.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), null)));

});

parcelRegister("4ivVe", function(module, exports) {

$parcel$export(module.exports, "default", () => $d94c98e54cebca34$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d94c98e54cebca34$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    changeViewMenuItemLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.change-view-menu-item-label",
        "defaultMessage": "Change view"
    },
    starredAndRecentProjectsLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.starred-and-recent-projects-label",
        "defaultMessage": "Starred and recent projects"
    },
    starredProjectsLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.starred-projects-label",
        "defaultMessage": "Starred projects only"
    },
    mostRecentOnlyLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.most-recent-only-label",
        "defaultMessage": "Most recent project only"
    },
    listBulletedIcon: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.list-bulleted-icon",
        "defaultMessage": "List bulleted icon"
    },
    chevronRightIcon: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.chevron-right-icon",
        "defaultMessage": "Chevron right icon"
    },
    starredAndRecentProjectsLabelGalaxia: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.starred-and-recent-projects-label-galaxia",
        "defaultMessage": "Starred and recent spaces"
    },
    starredProjectsLabelGalaxia: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.starred-projects-label-galaxia",
        "defaultMessage": "Starred spaces only"
    },
    mostRecentOnlyLabelGalaxia: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.most-recent-only-label-galaxia",
        "defaultMessage": "Most recent space only"
    }
});

});

parcelRegister("i0gEO", function(module, exports) {

$parcel$export(module.exports, "ViewOptionsMenuPopupContentEntrypoint", () => $966531b6e1190649$export$ebd1be9f4df3fdb7);

var $4BK1O = parcelRequire("4BK1O");

var $2aGAf = parcelRequire("2aGAf");

const $966531b6e1190649$export$ebd1be9f4df3fdb7 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("iPmjG")).then(({ ViewOptionsWithDisplaySettings: ViewOptionsWithDisplaySettings })=>ViewOptionsWithDisplaySettings), {
        moduleId: "846bfedf",
        priority: "interaction"
    }),
    getPreloadProps: (extraProps)=>({
            queries: {},
            extraProps: extraProps
        })
});

});
parcelRegister("iPmjG", function(module, exports) {

let $db4e4d04e983b900$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $db4e4d04e983b900$var$load("83Qmd").then(()=>parcelRequire('kUWXo'));

});


parcelRegister("k6xks", function(module, exports) {

$parcel$export(module.exports, "ProjectsViewOptionsEntrypoint", () => $70054cf664938c26$export$cd53b98c3c72dc78);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

var $zR6Vp = parcelRequire("zR6Vp");

const $70054cf664938c26$export$cd53b98c3c72dc78 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("kLjZc")).then(({ ProjectsViewOptions: ProjectsViewOptions })=>ProjectsViewOptions), {
        moduleId: "bd6faa13",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, onChange: onChange })=>({
            queries: {
                projectsViewOptions: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $zR6Vp.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            },
            extraProps: {
                onChange: onChange
            }
        })
});

});
parcelRegister("zR6Vp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6feec2afe92b3468$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4a7eabd336a54085b12e6024b67b0182>>
 * @relayHash 367268a979a58b37662cf273a88851ee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dd468ae0c857364119a123f5e1f38c418844966a4acd4018dddf66eb56286f0b
const $6feec2afe92b3468$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "displayMode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "projectsViewOptionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "projectsViewOptionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dd468ae0c857364119a123f5e1f38c418844966a4acd4018dddf66eb56286f0b",
            "metadata": {},
            "name": "projectsViewOptionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6feec2afe92b3468$var$node.hash = "fc0b49221c780edfae3aba8b40f0e778";
var $6feec2afe92b3468$export$2e2bcd8739ae039 = $6feec2afe92b3468$var$node;

});

parcelRegister("kLjZc", function(module, exports) {

let $f1d7b33ac3c80862$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f1d7b33ac3c80862$var$load("hxaLh").then(()=>parcelRequire('kKeoa'));

});



parcelRegister("dN2O6", function(module, exports) {

$parcel$export(module.exports, "useProjectsAnalyticsL1", () => $8304076209d0ee21$export$7d9a1a79b1bd1338);

var $eJOHy = parcelRequire("eJOHy");




var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");




var $ujg1l = parcelRequire("ujg1l");
const $8304076209d0ee21$export$7d9a1a79b1bd1338 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const commonAttributes = (0, $eJOHy.useMemo)(()=>({
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            navigationLayer: (0, $002870cfa80d64f4$export$17ff3f7e02c6ac22)
        }), []);
    // fixed item - view all projects link
    const sendViewAllProjectsAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            itemId: (0, $bc40578f06d7846b$export$2de7e56f66635690)
        };
        (0, $gCeeo.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - more projects flyout trigger
    const sendMoreProjectsAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            parentItemId: (0, $bc40578f06d7846b$export$44d67b522cbcce6d),
            itemId: (0, $bc40578f06d7846b$export$3e2efdbdb3eed97e)
        };
        (0, $gCeeo.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - meatball icon button on projects menu (top level)
    const sendMeatBallDropDownAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
            itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e)
        };
        (0, $gCeeo.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - create project (+) button on projects menu (top level)
    const sendCreateProjectAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
            itemId: 'createProject'
        };
        (0, $gCeeo.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // custom item - project menu item that displays project name (can be expandable menu or a link)
    const sendProjectMenuItemAnalyticsEvent = (0, $eJOHy.useCallback)(({ starred: starred, recent: recent, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            itemId: projectId,
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $gCeeo.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendProjectMenuContentAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemId: 'projectsNavigationMenuItemContent'
        };
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'projectsNavigationMenuItemContent rendered', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendViewAllProjectsAnalyticsEvent: sendViewAllProjectsAnalyticsEvent,
        sendMoreProjectsAnalyticsEvent: sendMoreProjectsAnalyticsEvent,
        sendMeatBallDropDownAnalyticsEvent: sendMeatBallDropDownAnalyticsEvent,
        sendCreateProjectAnalyticsEvent: sendCreateProjectAnalyticsEvent,
        sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent,
        sendProjectMenuContentAnalyticsEvent: sendProjectMenuContentAnalyticsEvent
    };
};

});
parcelRegister("ujg1l", function(module, exports) {

$parcel$export(module.exports, "getSectionByStarredOrRecent", () => $9ade126550411160$export$542854f16c0127e7);

var $a9aec = parcelRequire("a9aec");
const $9ade126550411160$export$542854f16c0127e7 = ({ starred: starred, recent: recent })=>{
    if (starred) return 0, $a9aec.SECTION_ITEM_STARRED;
    if (recent) return 0, $a9aec.SECTION_ITEM_RECENT;
    return '';
};

});


parcelRegister("lHnXI", function(module, exports) {

$parcel$export(module.exports, "useProjectsAnalyticsL2", () => $2630d05d0f768e9d$export$1e04fadc2cea284c);

var $eJOHy = parcelRequire("eJOHy");






var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");


var $ujg1l = parcelRequire("ujg1l");
const $2630d05d0f768e9d$export$1e04fadc2cea284c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const commonAttributes = (0, $eJOHy.useMemo)(()=>({
            level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1)
        }), []);
    const sendMeatBallDropDownManageProjectsAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
            itemId: 'manageProjects',
            parentItemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e)
        };
        (0, $gCeeo.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // board navigation item under each project when project is expandable menu
    const sendBoardNavigationItemInsideProjectsAnalyticsEvent = (0, $eJOHy.useCallback)(({ boardId: boardId, projectId: projectId, recent: recent, starred: starred, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemId: boardId,
            itemType: (0, $6bf6536f83c22cfe$export$9b8283d5878d2491),
            parentItemId: projectId,
            parentItemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $gCeeo.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // meatball menu on projects
    const getMeatBallDropDownOnProjectsAnalytics = (0, $eJOHy.useCallback)(({ recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        return {
            ...commonAttributes,
            actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524),
            componentType: (0, $493796f3bdee881c$export$9bd6c21d500ae611),
            itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e),
            parentItemId: projectId,
            parentItemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
    }, [
        commonAttributes
    ]);
    /** @deprecated, replace with getMeatBallDropDownOnProjectsAnalytics  */ const sendMeatBallDropDownOnProjectsAnalyticsEvent = (0, $eJOHy.useCallback)((params)=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6)
        });
        const { actionSubjectId: actionSubjectId, ...attributes } = getMeatBallDropDownOnProjectsAnalytics(params);
        (0, $gCeeo.fireUIAnalytics)(event, actionSubjectId, attributes);
    }, [
        createAnalyticsEvent,
        getMeatBallDropDownOnProjectsAnalytics
    ]);
    // create board button
    const sendCreateBoardOnBoardMenuItemAnalyticsEvent = (0, $eJOHy.useCallback)(({ recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$9bd6c21d500ae611),
            itemId: 'createBoard',
            parentItemId: projectId,
            parentItemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $gCeeo.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - view all boards link
    const sendViewAllBoardsAnalyticsEvent = (0, $eJOHy.useCallback)(({ projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
            itemId: 'viewAllBoards',
            parentItemId: projectId,
            parentItemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            projectType: projectType
        };
        (0, $gCeeo.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - Change View in Meatball Menu on Projects section
    const sendChangeViewAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
            parentItemId: (0, $bc40578f06d7846b$export$44d67b522cbcce6d),
            itemId: (0, $6bf6536f83c22cfe$export$119dad133da0b4a)
        };
        (0, $gCeeo.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - View All Projects in More Projects flyout
    const sendViewAllProjectsAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
            parentItemId: (0, $bc40578f06d7846b$export$3e2efdbdb3eed97e),
            itemId: (0, $bc40578f06d7846b$export$2de7e56f66635690)
        };
        (0, $gCeeo.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // custom item - project in More Projects flyout
    const sendMoreProjectsFlyoutProjectAnalyticsEvent = (0, $eJOHy.useCallback)(({ projectId: projectId, sectionType: sectionType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            parentItemId: (0, $bc40578f06d7846b$export$3e2efdbdb3eed97e),
            itemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            itemId: projectId,
            moreProjectsSection: sectionType
        };
        (0, $gCeeo.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendProjectMenuContentSectionAnalyticsEvent = (0, $eJOHy.useCallback)(({ projectSection: projectSection })=>{
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemId: projectSection
        };
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'projectsNavigationContentSection rendered', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendMoreProjectsFlyoutProjectsSearchEnteredAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'entered',
            actionSubject: (0, $bfc89d778f76f56d$export$b0a8b257f1f878a2)
        });
        const attributes = {
            ...commonAttributes,
            parentItemId: (0, $bc40578f06d7846b$export$3e2efdbdb3eed97e),
            itemId: (0, $bc40578f06d7846b$export$e338c40e64df0640)
        };
        (0, $gCeeo.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8ebfc84e07851700), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownManageProjectsAnalyticsEvent: sendMeatBallDropDownManageProjectsAnalyticsEvent,
        sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent,
        sendBoardNavigationItemInsideProjectsAnalyticsEvent: sendBoardNavigationItemInsideProjectsAnalyticsEvent,
        sendCreateBoardOnBoardMenuItemAnalyticsEvent: sendCreateBoardOnBoardMenuItemAnalyticsEvent,
        sendViewAllBoardsAnalyticsEvent: sendViewAllBoardsAnalyticsEvent,
        sendChangeViewAnalyticsEvent: sendChangeViewAnalyticsEvent,
        sendViewAllProjectsAnalyticsEvent: sendViewAllProjectsAnalyticsEvent,
        sendMoreProjectsFlyoutProjectAnalyticsEvent: sendMoreProjectsFlyoutProjectAnalyticsEvent,
        sendProjectMenuContentSectionAnalyticsEvent: sendProjectMenuContentSectionAnalyticsEvent,
        sendMoreProjectsFlyoutProjectsSearchEnteredAnalyticsEvent: sendMoreProjectsFlyoutProjectsSearchEnteredAnalyticsEvent
    };
};

});
const $16a7021d28f78da7$export$8d155d2412839524 = 'projectsNavigationMenuItem';
const $16a7021d28f78da7$export$13171e509c859bbf = 'projectSettingsNavigationMenuItem';
const $16a7021d28f78da7$export$8ebfc84e07851700 = 'moreProjectsSearch';


parcelRegister("1OC2y", function(module, exports) {

$parcel$export(module.exports, "useProjectsAnalyticsL3", () => $2cddfe1614034325$export$619b8904be99ed7c);

var $eJOHy = parcelRequire("eJOHy");




var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");



var $ujg1l = parcelRequire("ujg1l");

const $2cddfe1614034325$export$619b8904be99ed7c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const commonAttributes = (0, $eJOHy.useMemo)(()=>({
            level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18)
        }), []);
    // actions inside meatball menu on projects
    const sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent = (0, $eJOHy.useCallback)(({ itemId: itemId, recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: projectId,
            parentItemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $gCeeo.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // meatball menu on boards
    const sendMeatBallDropDownOnBoardsAnalyticsEvent = (0, $eJOHy.useCallback)(({ recent: recent, starred: starred, boardId: boardId, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$9bd6c21d500ae611),
            itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e),
            projectId: projectId,
            parentItemId: boardId,
            parentItemType: (0, $6bf6536f83c22cfe$export$9b8283d5878d2491),
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $gCeeo.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendChangeViewViewOptionAnalyticsEvent = (0, $eJOHy.useCallback)(({ itemId: itemId })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
            itemId: itemId,
            parentItemId: (0, $6bf6536f83c22cfe$export$119dad133da0b4a)
        };
        (0, $gCeeo.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent: sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent,
        sendMeatBallDropDownOnBoardsAnalyticsEvent: sendMeatBallDropDownOnBoardsAnalyticsEvent,
        sendChangeViewViewOptionAnalyticsEvent: sendChangeViewViewOptionAnalyticsEvent
    };
};

});

parcelRegister("5Ld7K", function(module, exports) {

$parcel$export(module.exports, "default", () => $38d821cc83ce3ef8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $38d821cc83ce3ef8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createProject: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.create-project",
        "defaultMessage": "Create project"
    },
    manageProjects: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.manage-projects",
        "defaultMessage": "Manage projects"
    },
    projects: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.projects",
        "defaultMessage": "projects"
    },
    createProjectGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.create-project-galaxia",
        "defaultMessage": "Create space"
    },
    manageProjectsGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.manage-projects-galaxia",
        "defaultMessage": "Manage spaces"
    },
    projectsGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.projects-galaxia",
        "defaultMessage": "spaces"
    }
});

});


parcelRegister("cXi8d", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsDefault", () => $7e3659a4805a6da9$export$373934ae259d74df);

var $eJOHy = parcelRequire("eJOHy");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $bbdV2 = parcelRequire("bbdV2");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $49s4h = parcelRequire("49s4h");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $if69u = parcelRequire("if69u");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $hPlDs = parcelRequire("hPlDs");

var $8q7lT = parcelRequire("8q7lT");

var $4ihOZ = parcelRequire("4ihOZ");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");

var $jrulJ = parcelRequire("jrulJ");


var $eApSa = parcelRequire("eApSa");

var $epTsa = parcelRequire("epTsa");


var $bUY1i = parcelRequire("bUY1i");

var $baOTS = parcelRequire("baOTS");
function $7e3659a4805a6da9$export$373934ae259d74df(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, simulateLoading: simulateLoading = false } = props;
    const cloudId = (0, $kEUB1.useCloudId)();
    const activationId = (0, $4ihOZ.useActivationId)();
    const atlassianAccountId = (0, $8q7lT.useAccountId)();
    const currentURL = (0, $49s4h.useGetCurrentUrl)();
    const entryPointParamsOld = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            currentURL: currentURL,
            activationId: activationId,
            atlassianAccountId: atlassianAccountId
        }), [
        cloudId,
        currentURL,
        activationId,
        atlassianAccountId
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId,
                activationId: activationId,
                atlassianAccountId: atlassianAccountId
            }
        }), [
        cloudId,
        activationId,
        atlassianAccountId
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const leftSidebarEPRef = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$50ea883ba6f28ff5));
    const projectsEPRef = leftSidebarEPRef?.entryPoints?.projects;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $baOTS.nav4ProjectsContentEntryPoint), entryPointParams);
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).PROJECTS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        // We intentionally won't re-evaluate this if the route changes.
        if (!projectsEPRef && isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        projectsEPRef,
        isExpanded
    ]);
    const menuId = (0, $h4Bzb.MENU_ID_PROJECTS);
    // Create this component once, then keep using it FOREVER.
    // We don't want to keep switching the implementation as the user does SPA transitions.
    // We set the state this to cater for components that may be an entrypoint so that we don't keep switching between the entryPoint version and the non-entryPoint version
    const [entryPointConfig] = (0, $eJOHy.useState)(()=>{
        const epContainerProps = {
            id: 'nav4-sidebar-projects-default',
            packageName: (0, $6764ca6ce23ee75f$export$b8b9d90f9e5bd72b),
            teamName: (0, $6764ca6ce23ee75f$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
                count: 6,
                withHeading: true
            }),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            runtimeProps: entryPointParamsOld
        };
        return {
            Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eApSa.RouteEntryPointContainer), {
                    epContainerProps: epContainerProps,
                    jiraEPRef: entryPointReferenceSubject,
                    nestedEPRef: projectsEPRef,
                    placeholderEntryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
                })
        };
    });
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(entryPointConfig.Component, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useCallback)((hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        }, [
            entryPointActions
        ]) : (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useCallback)((hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $8IuE5.L1_MENU_ID).PROJECTS,
                    sectionItem: (0, $a9aec.SECTION_ITEM_PROJECTS)
                });
            }
        }, [
            entryPointActions,
            sendSectionItemAnalyticsEvent
        ]) : (hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $8IuE5.L1_MENU_ID).PROJECTS,
                    sectionItem: (0, $a9aec.SECTION_ITEM_PROJECTS)
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-projects-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $azEgq.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
        count: 6,
        withHeading: true
    }) : content(), !(0, $epTsa.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bUY1i.Footer), null)));
}

});
const $6764ca6ce23ee75f$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Projects';
const $6764ca6ce23ee75f$export$d57b6b390e78d90f = 'jira-cosmos';

parcelRegister("bUY1i", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $fa9b5b5e50de6182$export$a06f1c675e846f6f);

var $eJOHy = parcelRequire("eJOHy");

var $2y3Ci = parcelRequire("2y3Ci");
var $ilbtc = parcelRequire("ilbtc");
var $1swHh = parcelRequire("1swHh");

var $286cZ = parcelRequire("286cZ");

var $lRq8t = parcelRequire("lRq8t");

var $dN2O6 = parcelRequire("dN2O6");

var $h4Bzb = parcelRequire("h4Bzb");

var $1Ce3C = parcelRequire("1Ce3C");

var $lWdYg = parcelRequire("lWdYg");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $9IxJM = parcelRequire("9IxJM");

var $e09p3 = parcelRequire("e09p3");
const $fa9b5b5e50de6182$var$VIEW_ALL_PROJECTS_HREF = (0, $lWdYg.projectsDirectoryRoute).path;
function $fa9b5b5e50de6182$var$FooterInternal({ hasMore: hasMore = false }) {
    const moreProjectsGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $e09p3.default).moreProjectsGalaxia : (0, $e09p3.default).moreProjects;
    const viewAllProjectsGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $e09p3.default).viewAllProjectsGalaxia : (0, $e09p3.default).viewAllProjects;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { sendViewAllProjectsAnalyticsEvent: sendViewAllProjectsAnalyticsEvent, sendMoreProjectsAnalyticsEvent: sendMoreProjectsAnalyticsEvent } = (0, $dN2O6.useProjectsAnalyticsL1)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, (0, $epTsa.expVal)('blu-7465-projects-search-in-sidebar', 'isEnabled', false) || hasMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9IxJM.MoreProjectsFlyout), {
        onClick: sendMoreProjectsAnalyticsEvent
    }, formatMessage(moreProjectsGalaxia)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Ce3C.ViewAllEntityMenuItem), {
        onClick: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? sendViewAllProjectsAnalyticsEvent : ()=>{
            sendViewAllProjectsAnalyticsEvent();
        },
        href: $fa9b5b5e50de6182$var$VIEW_ALL_PROJECTS_HREF,
        menuId: (0, $h4Bzb.MENU_ID_PROJECTS_VIEW_ALL)
    }, formatMessage(viewAllProjectsGalaxia)))));
}
const $fa9b5b5e50de6182$export$a06f1c675e846f6f = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp_magma_jsm-perf-improvement-batch-1'), $fa9b5b5e50de6182$var$FooterInternal);

});
parcelRegister("lWdYg", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRoute", () => $80e3307949c1173b$export$74114064f06cd71b);
const $80e3307949c1173b$export$74114064f06cd71b = {
    name: 'projects-directory',
    path: '/jira/projects',
    exact: true
};

});

parcelRegister("9IxJM", function(module, exports) {

$parcel$export(module.exports, "MoreProjectsFlyout", () => $50e48b93fa2c22db$export$35a66c7368b171ff);

var $eJOHy = parcelRequire("eJOHy");

var $lers0 = parcelRequire("lers0");

var $d9oCz = parcelRequire("d9oCz");
var $5jwgZ = parcelRequire("5jwgZ");
var $63KSu = parcelRequire("63KSu");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $ciFJV = parcelRequire("ciFJV");

var $epTsa = parcelRequire("epTsa");

var $49s4h = parcelRequire("49s4h");

var $if69u = parcelRequire("if69u");

var $kEUB1 = parcelRequire("kEUB1");

var $e1Shq = parcelRequire("e1Shq");

function $50e48b93fa2c22db$export$35a66c7368b171ff(props) {
    const cloudId = (0, $kEUB1.useCloudId)();
    const currentURL = (0, $49s4h.useGetCurrentUrl)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $e1Shq.MoreProjectsEntrypoint), {
        cloudId: cloudId,
        currentURL: currentURL
    });
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9oCz.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $63KSu.FlyoutMenuItemTrigger), {
        ...props,
        ref: triggerRef,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lers0))), {
            label: "",
            color: "currentColor"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5jwgZ.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "sidebar-nav4-more-projects-flyout",
        packageName: (0, $6e43f8f0593b946f$export$b8b9d90f9e5bd72b),
        teamName: (0, $6e43f8f0593b946f$export$d57b6b390e78d90f),
        errorFallback: "flag",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
            withSearch: true,
            withSubHeading: true,
            isFlyout: true,
            count: (0, $epTsa.expVal)('blu-7465-projects-search-in-sidebar', 'isEnabled', false) ? 10 : 5
        }),
        runtimeProps: {}
    })));
}

});
parcelRegister("e1Shq", function(module, exports) {

$parcel$export(module.exports, "MoreProjectsEntrypoint", () => $ce34d6191f33c697$export$40b84ce4e7e6a96a);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

var $epTsa = parcelRequire("epTsa");

var $aICGH = parcelRequire("aICGH");

const $ce34d6191f33c697$export$40b84ce4e7e6a96a = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("bt5Td")).then(({ MoreProjects: MoreProjects })=>MoreProjects), {
        moduleId: "d4fec86b",
        moduleName: "MoreProjects",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, currentURL: currentURL })=>({
            queries: {
                moreProjects: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $aICGH.default,
                    variables: {
                        cloudId: cloudId,
                        currentURL: currentURL,
                        isProjectsSearchInSidebarEnabled: (0, $epTsa.expVal)('blu-7465-projects-search-in-sidebar', 'isEnabled', false)
                    }
                }
            },
            extraProps: {}
        })
});

});
parcelRegister("aICGH", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd598ffe9ba2b8d9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e22fccae2dd071e44f7f857a55202a7>>
 * @relayHash da733dd711e8de9cafbe0491586c07de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e510066e0ee04ed0000c02a643b8112ba7e700b1ff47c67a7fd623019609fe1e
const $cd598ffe9ba2b8d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isProjectsSearchInSidebarEnabled"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "alias": "canBrowseProjects",
                "args": [
                    v1 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "BROWSE_PROJECTS"
                    }
                ],
                "concreteType": "JiraPermission",
                "kind": "LinkedField",
                "name": "permission",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "hasPermission"
                    }
                ]
            }
        ]
    }, v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "currentURL",
            "variableName": "currentURL"
        }
    ], v4 = [
        {
            "concreteType": "JiraProjectEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ProjectSection_projectNode"
                }
            ]
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "concreteType": "JiraProjectEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        },
                        {
                            "alias": "projectKey",
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ],
                                    "type": "JiraNavigationItem",
                                    "abstractKey": "__isJiraNavigationItem"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoreProjectsQuery",
            "selections": [
                v2 /*: any*/ ,
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreFavourites",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreRecents",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "condition": "isProjectsSearchInSidebarEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "otherItems",
                                    "plural": false,
                                    "selections": v4 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoreProjectsQuery",
            "selections": [
                v2 /*: any*/ ,
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreFavourites",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        },
                        {
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "moreRecents",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        },
                        {
                            "condition": "isProjectsSearchInSidebarEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "otherItems",
                                    "plural": false,
                                    "selections": v6 /*: any*/ 
                                }
                            ]
                        },
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "e510066e0ee04ed0000c02a643b8112ba7e700b1ff47c67a7fd623019609fe1e",
            "metadata": {},
            "name": "MoreProjectsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cd598ffe9ba2b8d9$var$node.hash = "2706305e7b01e5ae823b2256bf00da6b";
var $cd598ffe9ba2b8d9$export$2e2bcd8739ae039 = $cd598ffe9ba2b8d9$var$node;

});

parcelRegister("bt5Td", function(module, exports) {

let $8596f8b590c5823a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8596f8b590c5823a$var$load("ll4Yz").then(()=>parcelRequire('aHUge'));

});


const $6e43f8f0593b946f$export$b8b9d90f9e5bd72b = 'jira-navigation-apps-sidebar-nav4-more-projects';
const $6e43f8f0593b946f$export$d57b6b390e78d90f = 'jira-cosmos';


parcelRegister("e09p3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b67c63ac89ee8a7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8b67c63ac89ee8a7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewAllProjects: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.view-all-projects",
        "defaultMessage": "View all projects"
    },
    moreProjects: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.more-projects",
        "defaultMessage": "More projects"
    },
    viewAllProjectsGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.view-all-projects-galaxia",
        "defaultMessage": "View all spaces"
    },
    moreProjectsGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.more-projects-galaxia",
        "defaultMessage": "More spaces"
    }
});

});


parcelRegister("baOTS", function(module, exports) {

$parcel$export(module.exports, "nav4ProjectsContentEntryPoint", () => $41d3bb508d1a3a61$export$a457f9fdcd1ea5d3);

var $gy8uL = parcelRequire("gy8uL");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $fKh2A = parcelRequire("fKh2A");

var $7Cu03 = parcelRequire("7Cu03");

const $41d3bb508d1a3a61$export$a457f9fdcd1ea5d3 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("y77Id")).then(({ Nav4ProjectsContentViewQuery: Nav4ProjectsContentViewQuery })=>Nav4ProjectsContentViewQuery), {
        moduleId: "90670c8d",
        moduleName: "Nav4ProjectsContentViewQuery",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId || '';
        const activationId = params.tenantContext.activationId;
        const atlassianAccountId = params.tenantContext.atlassianAccountId;
        return {
            queries: {
                projects: {
                    parameters: $gy8uL.default,
                    variables: {
                        cloudId: cloudId,
                        entityAriProjects: (0, $fKh2A.JiraNavigationSettingsAri).create({
                            siteId: cloudId,
                            activationId: activationId,
                            navigationSettingScope: 'projects'
                        }).toString(),
                        ownerAri: atlassianAccountId && (0, $7Cu03.IdentityUserAri).create({
                            userId: atlassianAccountId
                        }).toString()
                    }
                }
            }
        };
    }
});

});
parcelRegister("gy8uL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2af61e473b25b8b7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<804ca32b61c24a0eb1dd276270fa35c0>>
 * @relayHash 4e084cda508e1d59491a1e6ad4152aa6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 93a9b7409d6cc6b08e1a3a4ed989177bbbd9b88b94c8a5c7a237d57bce09cf98

var $9zQGn = parcelRequire("9zQGn");

var $dtG0v = parcelRequire("dtG0v");

var $cli8x = parcelRequire("cli8x");

var $l5K2d = parcelRequire("l5K2d");

var $5moL7 = parcelRequire("5moL7");

var $7m7yY = parcelRequire("7m7yY");

var $lhtKZ = parcelRequire("lhtKZ");

var $eSxxM = parcelRequire("eSxxM");

var $em6ga = parcelRequire("em6ga");

var $eEnEt = parcelRequire("eEnEt");

var $37Ewn = parcelRequire("37Ewn");
const $2af61e473b25b8b7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = [
        v3 /*: any*/ 
    ], v5 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v12 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v17 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v16 /*: any*/ 
        ]
    }, v18 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v19 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v20 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v21 = [
        {
            "kind": "ScalarField",
            "name": "webUrl"
        }
    ], v22 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx",
        "kind": "Condition",
        "passingValue": false,
        "selections": v21 /*: any*/ 
    }, v23 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": v21 /*: any*/ 
    }, v24 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v21 /*: any*/ 
    }, v25 = [
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        v22 /*: any*/ ,
        v23 /*: any*/ ,
        v24 /*: any*/ 
    ], v26 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v27 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v28 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v25 /*: any*/ 
            }
        ]
    }, v29 = [
        v28 /*: any*/ ,
        v26 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4ProjectsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4ProjectsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "Nav4ProjectsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteProjects",
                                    "args": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "PROJECT"
                                            }
                                        },
                                        v5 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v25 /*: any*/ ,
                                                            "type": "JiraProject"
                                                        },
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v26 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v3 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recentProjects",
                                    "plural": false,
                                    "selections": v29 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "canCreateProject",
                                    "args": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "CREATE_PROJECT"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "GrowthRecQuery",
                                    "kind": "LinkedField",
                                    "name": "growthRecommendations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "fields": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "product",
                                                            "value": "jira"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "tenantId",
                                                            "variableName": "cloudId"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "useCase",
                                                            "value": "jiraProjectMenuRecommendations"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "context"
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 2
                                                }
                                            ],
                                            "kind": "LinkedField",
                                            "name": "recommendations",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": true,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "entityId"
                                                                        }
                                                                    ],
                                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "GrowthRecRecommendations"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriProjects"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "ownerAri",
                                            "variableName": "ownerAri"
                                        }
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "SettingsDisplayPropertyConnection",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SettingsDisplayProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecent",
                                    "plural": false,
                                    "selections": v25 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecentFromHistory",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v5 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ],
                                    "storageKey": "favourites(first:15)"
                                },
                                {
                                    "args": [
                                        v27 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recents",
                                    "plural": false,
                                    "selections": v29 /*: any*/ ,
                                    "storageKey": "recents(first:20)"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasMore"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "favouriteLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "recentLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayMode"
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "93a9b7409d6cc6b08e1a3a4ed989177bbbd9b88b94c8a5c7a237d57bce09cf98",
            "metadata": {},
            "name": "Nav4ProjectsContentViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $dtG0v.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $cli8x.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": (0, $eEnEt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider": (0, $l5K2d.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $7m7yY.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $lhtKZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": (0, $5moL7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $eSxxM.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": (0, $9zQGn.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": (0, $em6ga.default)
            }
        }
    };
}();
$2af61e473b25b8b7$var$node.hash = "147c5d1f620c190c7d67a3ae20325c0e";
(0, $37Ewn.PreloadableQueryRegistry).set($2af61e473b25b8b7$var$node.params.id, $2af61e473b25b8b7$var$node);
var $2af61e473b25b8b7$export$2e2bcd8739ae039 = $2af61e473b25b8b7$var$node;

});

parcelRegister("y77Id", function(module, exports) {

let $0668b3a5a999117e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0668b3a5a999117e$var$load("ki5fy").then(()=>parcelRequire('9U2Pr'));

});



parcelRegister("54VT4", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsForLanding", () => $bb1c1df194be44d4$export$8c948b59812f90e9);

var $7p2eI = parcelRequire("7p2eI");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $1KdDN = parcelRequire("1KdDN");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $16sa1 = parcelRequire("16sa1");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $DCnR7 = parcelRequire("DCnR7");


var $bUY1i = parcelRequire("bUY1i");
function $bb1c1df194be44d4$export$8c948b59812f90e9(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).PROJECTS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const data = (0, $j4oe4.useFragment)((0, $7p2eI.default), queryRef);
    const menuId = (0, $h4Bzb.MENU_ID_PROJECTS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useCallback)((hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).PROJECTS,
                sectionItem: (0, $a9aec.SECTION_ITEM_PROJECTS)
            });
        }, [
            sendSectionItemAnalyticsEvent
        ]) : (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).PROJECTS,
                sectionItem: (0, $a9aec.SECTION_ITEM_PROJECTS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon + text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $azEgq.getTestId)(menuId),
        interactionName: (0, $7jTnu.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-projects-landing' : undefined
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4-sidebar-projects-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "nav4-sidebar-projects-landing",
        packageName: (0, $6764ca6ce23ee75f$export$b8b9d90f9e5bd72b),
        teamName: (0, $6764ca6ce23ee75f$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $DCnR7.Nav4ProjectsContent), {
        queryRef: data
    }))), !(0, $epTsa.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bUY1i.Footer), null)));
}

});
parcelRegister("7p2eI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8240088ccf69328$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c21586a3492cb3ed09327f8fd2de9ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e8240088ccf69328$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4ProjectsForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4ProjectsContent"
        }
    ],
    "type": "Query"
};
$e8240088ccf69328$var$node.hash = "4d3bdf6d5d5d912aac0901d592694d15";
var $e8240088ccf69328$export$2e2bcd8739ae039 = $e8240088ccf69328$var$node;

});

parcelRegister("DCnR7", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsContent", () => $1e642b891e9b9fa0$export$74ce18a8a4837259);

var $gEhIi = parcelRequire("gEhIi");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2KtJf = parcelRequire("2KtJf");

var $jC5ye = parcelRequire("jC5ye");

var $epTsa = parcelRequire("epTsa");

var $1qb7e = parcelRequire("1qb7e");

var $2Of18 = parcelRequire("2Of18");

var $isd83 = parcelRequire("isd83");

var $h4Bzb = parcelRequire("h4Bzb");

var $286cZ = parcelRequire("286cZ");

var $dpxw4 = parcelRequire("dpxw4");

var $hc6Nm = parcelRequire("hc6Nm");

var $h3HFC = parcelRequire("h3HFC");

var $3uQAw = parcelRequire("3uQAw");

var $kwzsh = parcelRequire("kwzsh");

var $1pmgP = parcelRequire("1pmgP");

var $a8Wkt = parcelRequire("a8Wkt");

var $9N2D6 = parcelRequire("9N2D6");

var $iXgs9 = parcelRequire("iXgs9");

var $kEUB1 = parcelRequire("kEUB1");

var $dN2O6 = parcelRequire("dN2O6");

var $idwl9 = parcelRequire("idwl9");

var $7jTnu = parcelRequire("7jTnu");

var $4g876 = parcelRequire("4g876");

var $lnXOC = parcelRequire("lnXOC");

var $bUY1i = parcelRequire("bUY1i");

var $2VWNN = parcelRequire("2VWNN");

var $jHZN8 = parcelRequire("jHZN8");
const $1e642b891e9b9fa0$var$MAX_RECENT_PROJECTS = 5;
const $1e642b891e9b9fa0$export$4319a8d1db123861 = 15;
function $1e642b891e9b9fa0$var$Nav4ProjectsContentInternal({ queryRef: queryRef }) {
    const cloudId = (0, $kEUB1.useCloudId)();
    const { getStableItems: getStableItems } = (0, $3uQAw.useStableItems)();
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const [projectToRestore, setProjectToRestore] = (0, $eJOHy.useState)(null);
    const { sendProjectMenuContentAnalyticsEvent: sendProjectMenuContentAnalyticsEvent } = (0, $dN2O6.useProjectsAnalyticsL1)();
    const { shouldSuppress: shouldSuppress } = (0, $2KtJf.useYbrCrossFlowSuppression)();
    (0, $eJOHy.useEffect)(()=>{
        sendProjectMenuContentAnalyticsEvent();
    }, [
        sendProjectMenuContentAnalyticsEvent
    ]);
    // https://jplat.jira.atlassian.cloud/browse/BLU-2719
    // We intentionally request 10 starred and 15 recent projects.
    // Then, if all 10 starred projects were recently visited, we still show 5 recent projects as well.
    const data = (0, $j4oe4.useRefetchableFragment)((0, $gEhIi.default), queryRef);
    const [{ jira: jira, jira_projectsSidebarMenu: projectsSidebarMenu }, refetch] = data;
    const { jwmLicensing: jwmLicensing } = jira;
    const favouriteLimit = (0, $epTsa.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) ? projectsSidebarMenu?.favouriteLimit : $1e642b891e9b9fa0$export$4319a8d1db123861;
    const recentLimit = (0, $epTsa.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) ? projectsSidebarMenu?.recentLimit : $1e642b891e9b9fa0$var$MAX_RECENT_PROJECTS;
    const favouriteProjects = $1e642b891e9b9fa0$var$isJiraProjectsSidebarMenuEnabled() ? projectsSidebarMenu?.favourites : jira.favouriteProjects;
    const recentProjects = $1e642b891e9b9fa0$var$isJiraProjectsSidebarMenuEnabled() ? projectsSidebarMenu?.recents : jira.recentProjects;
    // throwing here enforces the mutually exclusive @include/@skip directives which otherwise would be handled by @required
    if (!favouriteProjects || !recentProjects) throw new Error('JiraProjectConnection is missing in Nav4ProjectsContent for favourite or recent projects');
    const mostRecentProject = projectsSidebarMenu?.mostRecent;
    /** Using `mostRecentFromHistory` for the cases where we don't send `currentURL` (see L1MenuItemsQuery)
   * as a temporary fix to correctly display the projects in the sidebar, by checking the `displayMode`
   * and adding `mostRecentFromHistory` to the lists if necessary
   * More info here: https://jplat.atlassian.net/browse/BLU-6987 */ const mostRecentFromHistory = projectsSidebarMenu?.mostRecentFromHistory;
    const displayMode = projectsSidebarMenu?.displayMode;
    const isMostRecentFromHistorySelected = mostRecentFromHistory && isSelectedPath((0, $h4Bzb.ENTITY_ID).PROJECT(mostRecentFromHistory.projectKey));
    const entityAriProjects = (0, $a8Wkt.useSidebarSettingsAri)('projects');
    const ownerAri = (0, $a8Wkt.useOwnerAri)();
    const queryVariables = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            entityAriProjects: entityAriProjects,
            ownerAri: ownerAri
        }), [
        cloudId,
        entityAriProjects,
        ownerAri
    ]);
    (0, $hc6Nm.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $iXgs9.default,
        refetch: refetch,
        menuId: (0, $h4Bzb.MENU_ID_PROJECTS),
        queryVariables: queryVariables
    });
    const refetchOnChange = (0, $eJOHy.useCallback)(({ onComplete: onComplete })=>{
        refetch(queryVariables, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        queryVariables,
        refetch
    ]);
    (0, $h3HFC.useSubscribeAndUpdateFavorites)({
        entityTypename: 'JiraProject',
        favouriteConnectionId: favouriteProjects.__id,
        recentConnectionId: recentProjects.__id,
        refetch: refetchOnChange
    });
    (0, $kwzsh.useSyncChangeFavourites)();
    const favorites = (0, $eJOHy.useMemo)(()=>{
        const favoritesList = favouriteProjects.edges?.filter(Boolean).map((edge)=>edge.node) ?? [];
        const isMostRecentFromHistoryInFavoritesList = favoritesList.some((project)=>project.id === mostRecentFromHistory?.id);
        const shouldShowStarredSection = displayMode === (0, $1pmgP.ViewOptions).STARRED_AND_RECENT || displayMode === (0, $1pmgP.ViewOptions).STARRED;
        const shouldAddMostRecentFromHistoryToFavouritesList = $1e642b891e9b9fa0$var$isJiraProjectsSidebarMenuEnabled() && mostRecentFromHistory && mostRecentFromHistory.isFavourite && shouldShowStarredSection && isMostRecentFromHistorySelected && favoritesList.length > 0 && !isMostRecentFromHistoryInFavoritesList;
        /** `currentURL` is not sent in L1MenuItemsQuery which might re-write projects wrong in the sidebar in some cases
     * i.e. when the user visits Starred project which order # is more than the starred limit
     * so the project should be displayed as the last Starred one
     * With this fix we keep the sidebar in the correct state according to the current route performing
     * the same logic that BE does when it is aware of the `currentURL` */ if (shouldAddMostRecentFromHistoryToFavouritesList) {
            favoritesList.pop();
            favoritesList.push(mostRecentFromHistory);
        }
        const ids = favoritesList.map((project)=>project.id).filter(Boolean) ?? [];
        const list = favoritesList.map((project)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4g876.Nav4ProjectMenuItem), {
                key: project.projectKey,
                queryRef: project,
                isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === 'PREMIUM',
                setProjectToRestore: setProjectToRestore,
                // Show onboarding spotlight on the first item
                spotlight: project.id === ids[0] ? (0, $1qb7e.Nav4OnboardingComponentNames).SIDEBAR_PROJECT_SPOTLIGHT : undefined
            });
        }) ?? [];
        const hasNextPage = favouriteProjects.pageInfo?.hasNextPage || (favouriteLimit ? list.length > favouriteLimit : false);
        return {
            idSet: new Set(ids),
            list: list.slice(0, favouriteLimit ?? Infinity),
            hasItems: Boolean(list.length),
            hasNextPage: hasNextPage
        };
    }, [
        favouriteProjects,
        jwmLicensing,
        favouriteLimit,
        displayMode,
        mostRecentFromHistory,
        isMostRecentFromHistorySelected
    ]);
    const recentItems = (0, $eJOHy.useMemo)(()=>{
        const isStarredOnlyMode = displayMode === (0, $1pmgP.ViewOptions).STARRED;
        const shouldAddMostRecentFromHistoryToRecentList = $1e642b891e9b9fa0$var$isJiraProjectsSidebarMenuEnabled() && mostRecentFromHistory && !mostRecentFromHistory.isFavourite && isStarredOnlyMode && isMostRecentFromHistorySelected && (recentProjects.edges?.length ?? 0) === 0;
        /** `currentURL` is not sent in L1MenuItemsQuery which might re-write projects wrong in the sidebar in some cases
     * i.e. when Display Mode is STARRED only and the user visits a Recent project
     * so the project should be displayed as the only one in the Recent section
     * With this fix we keep the sidebar in the correct state according to the current route performing
     * the same logic that BE does when it is aware of the `currentURL` */ const nodes = shouldAddMostRecentFromHistoryToRecentList ? [
            mostRecentFromHistory
        ] : recentProjects.edges?.filter(Boolean).filter((edge)=>edge.node.id && !favorites.idSet.has(edge.node.id)).map((edge)=>edge.node).slice(0, recentLimit ?? Infinity) ?? [];
        const stableOrderedNodes = getStableItems({
            nodes: nodes,
            idKey: 'id'
        });
        const firstItemKey = stableOrderedNodes[0]?.projectKey;
        const list = stableOrderedNodes.map((node)=>{
            // Show onboarding spotlight on the first item if there are no favorites
            const showSpotlight = !favorites.hasItems && node.projectKey === firstItemKey;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4g876.Nav4ProjectMenuItem), {
                key: node.projectKey,
                queryRef: node,
                isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === 'PREMIUM',
                setProjectToRestore: setProjectToRestore,
                spotlight: showSpotlight ? (0, $1qb7e.Nav4OnboardingComponentNames).SIDEBAR_PROJECT_SPOTLIGHT : undefined
            });
        });
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        recentProjects.edges,
        getStableItems,
        favorites.idSet,
        jwmLicensing?.currentUserSeatEdition,
        favorites.hasItems,
        recentLimit,
        displayMode,
        mostRecentFromHistory,
        isMostRecentFromHistorySelected
    ]);
    const mostRecentProjectItem = (0, $eJOHy.useMemo)(()=>mostRecentProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4g876.Nav4ProjectMenuItem), {
            key: mostRecentProject.projectKey,
            queryRef: mostRecentProject,
            isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === 'PREMIUM',
            setProjectToRestore: setProjectToRestore,
            spotlight: (0, $1qb7e.Nav4OnboardingComponentNames).SIDEBAR_PROJECT_SPOTLIGHT
        }) : null, [
        mostRecentProject,
        jwmLicensing?.currentUserSeatEdition
    ]);
    const restoreProjectModal = (0, $eJOHy.useCallback)(()=>{
        if (projectToRestore) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jC5ye.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9N2D6.default), {
            ...projectToRestore,
            onProjectRestoreSuccess: ()=>{
                setProjectToRestore(null);
                refetch(queryVariables, {
                    fetchPolicy: 'store-and-network'
                });
            },
            onProjectRestoreFailure: ()=>{
                setProjectToRestore(null);
            },
            onClose: ()=>setProjectToRestore(null)
        }));
    }, [
        queryVariables,
        projectToRestore,
        refetch
    ]);
    const recommendations = (0, $eJOHy.useMemo)(()=>{
        if (shouldSuppress()) return null;
        if ((0, $7jTnu.fg)('blu-7436-separate-growth-rec')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $idwl9.Nav4Recommendations), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $idwl9.Nav4RecommendationsOld), {
            queryRef: data[0]
        });
    }, [
        data,
        shouldSuppress
    ]);
    if (!favorites.hasItems && !recentItems.hasItems && !mostRecentProject) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Of18.OnboardingSpotlightMaybe), {
        spotlight: (0, $1qb7e.Nav4OnboardingComponentNames).SIDEBAR_PROJECT_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lnXOC.Nav4ProjectsEmptyContent), null), recommendations, restoreProjectModal(), (0, $epTsa.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bUY1i.Footer), {
        hasMore: projectsSidebarMenu?.hasMore
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $isd83.UpdateProjectsProvider), {
        favouriteConnectionId: favouriteProjects.__id,
        recentConnectionId: recentProjects.__id
    }, !(0, $epTsa.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && (0, $epTsa.expVal)('blu-6315-display-settings-a-part-1', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jHZN8.Nav4ProjectsSectionsWithDisplaySettings), {
        favoriteItems: favorites,
        recentItems: recentItems,
        queryRef: data[0]
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2VWNN.Nav4ProjectsSections), {
        favoriteItems: favorites,
        recentItems: recentItems,
        mostRecentProjectItem: mostRecentProjectItem
    }), recommendations, restoreProjectModal(), (0, $epTsa.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bUY1i.Footer), {
        hasMore: projectsSidebarMenu?.hasMore
    }));
}
const $1e642b891e9b9fa0$export$74ce18a8a4837259 = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp_magma_jsm-perf-improvement-batch-1'), $1e642b891e9b9fa0$var$Nav4ProjectsContentInternal);
function $1e642b891e9b9fa0$var$isJiraProjectsSidebarMenuEnabled() {
    return (0, $epTsa.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) || (0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false);
}

});
parcelRegister("gEhIi", function(module, exports) {

$parcel$export(module.exports, "default", () => $145c8e8c89619dfc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b585887dd261359fd46545ef482c3c32>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $iXgs9 = parcelRequire("iXgs9");
const $145c8e8c89619dfc$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v2 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "FragmentSpread",
        "name": "Nav4ProjectMenuItem"
    }, v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v7 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v8 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            },
            {
                "kind": "RootArgument",
                "name": "entityAriProjects"
            },
            {
                "kind": "RootArgument",
                "name": "ownerAri"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $iXgs9.default)
            }
        },
        "name": "Nav4ProjectsContent",
        "selections": [
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4RecommendationsOld"
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "entityAri",
                                        "variableName": "entityAriProjects"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "ownerAri",
                                        "variableName": "ownerAri"
                                    }
                                ],
                                "kind": "FragmentSpread",
                                "name": "Nav4ProjectsSectionsWithDisplaySettings"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "alias": "favouriteProjects",
                                        "args": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": {
                                                        "order": "DESC"
                                                    },
                                                    "type": "PROJECT"
                                                }
                                            },
                                            v1 /*: any*/ 
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ ,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v3 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "jira.favouriteProjects.edges.node.id"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v4 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "jira.favouriteProjects.edges.node.projectKey"
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraProject"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.favouriteProjects.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.favouriteProjects"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": [
                                            v0 /*: any*/ ,
                                            v7 /*: any*/ ,
                                            v8 /*: any*/ 
                                        ],
                                        "concreteType": "JiraProjectConnection",
                                        "kind": "LinkedField",
                                        "name": "recentProjects",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.recentProjects.edges.node.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.recentProjects.edges.node.projectKey"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.recentProjects.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.recentProjects"
                                }
                            ]
                        },
                        {
                            "args": [
                                v0 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                v0 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecent",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira_projectsSidebarMenu.mostRecent.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira_projectsSidebarMenu.mostRecent.projectKey"
                                        },
                                        v5 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecentFromHistory",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira_projectsSidebarMenu.mostRecentFromHistory.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira_projectsSidebarMenu.mostRecentFromHistory.projectKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        v5 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": [
                                            v1 /*: any*/ 
                                        ],
                                        "concreteType": "JiraProjectConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ ,
                                            {
                                                "concreteType": "JiraProjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.favourites.edges.node.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.favourites.edges.node.projectKey"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira_projectsSidebarMenu.favourites.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ],
                                        "storageKey": "favourites(first:15)"
                                    },
                                    "action": "THROW",
                                    "path": "jira_projectsSidebarMenu.favourites"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": [
                                            v8 /*: any*/ 
                                        ],
                                        "concreteType": "JiraProjectConnection",
                                        "kind": "LinkedField",
                                        "name": "recents",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.recents.edges.node.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.recents.edges.node.projectKey"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira_projectsSidebarMenu.recents.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ],
                                        "storageKey": "recents(first:20)"
                                    },
                                    "action": "THROW",
                                    "path": "jira_projectsSidebarMenu.recents"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasMore"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "favouriteLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "recentLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayMode"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira_projectsSidebarMenu"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$145c8e8c89619dfc$var$node.hash = "7509ad6a441a847a4ac6547b12d9c450";
var $145c8e8c89619dfc$export$2e2bcd8739ae039 = $145c8e8c89619dfc$var$node;

});
parcelRegister("iXgs9", function(module, exports) {

$parcel$export(module.exports, "default", () => $456273f1e51934e1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ef7c5b170b8302f9cf563c9ee86c1997>>
 * @relayHash 482fd1eaf2c7be17c5138ecdcc4b2572
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea3642e6555a179481081ac80a7e31572da36f24c9423ae468398ebf09e6ef6c

var $9zQGn = parcelRequire("9zQGn");

var $dtG0v = parcelRequire("dtG0v");

var $cli8x = parcelRequire("cli8x");

var $l5K2d = parcelRequire("l5K2d");

var $5moL7 = parcelRequire("5moL7");

var $7m7yY = parcelRequire("7m7yY");

var $lhtKZ = parcelRequire("lhtKZ");

var $eSxxM = parcelRequire("eSxxM");

var $em6ga = parcelRequire("em6ga");

var $eEnEt = parcelRequire("eEnEt");
const $456273f1e51934e1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "currentURL"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "displaySettingsAPart1Enabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "displaySettingsPostGaEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraProjectsSidebarMenuEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "separateGrowthRecEnabled"
    }, v8 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v9 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v10 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v11 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "status"
    }, v16 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v17 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v22 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v21 /*: any*/ 
        ]
    }, v23 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v24 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v25 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v26 = [
        {
            "kind": "ScalarField",
            "name": "webUrl"
        }
    ], v27 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx",
        "kind": "Condition",
        "passingValue": false,
        "selections": v26 /*: any*/ 
    }, v28 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": v26 /*: any*/ 
    }, v29 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v26 /*: any*/ 
    }, v30 = [
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        v22 /*: any*/ ,
        v23 /*: any*/ ,
        v24 /*: any*/ ,
        v25 /*: any*/ ,
        v27 /*: any*/ ,
        v28 /*: any*/ ,
        v29 /*: any*/ 
    ], v31 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v32 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v33 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v30 /*: any*/ 
            }
        ]
    }, v34 = [
        v33 /*: any*/ ,
        v31 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4ProjectsContentQuery",
            "selections": [
                {
                    "args": [
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "Nav4ProjectsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "Nav4ProjectsContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v9 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteProjects",
                                    "args": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "PROJECT"
                                            }
                                        },
                                        v10 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v30 /*: any*/ ,
                                                            "type": "JiraProject"
                                                        },
                                                        v21 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v31 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v9 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recentProjects",
                                    "plural": false,
                                    "selections": v34 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "canCreateProject",
                                    "args": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "CREATE_PROJECT"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "GrowthRecQuery",
                                    "kind": "LinkedField",
                                    "name": "growthRecommendations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "fields": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "product",
                                                            "value": "jira"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "tenantId",
                                                            "variableName": "cloudId"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "useCase",
                                                            "value": "jiraProjectMenuRecommendations"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "context"
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 2
                                                }
                                            ],
                                            "kind": "LinkedField",
                                            "name": "recommendations",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": true,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "entityId"
                                                                        }
                                                                    ],
                                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "GrowthRecRecommendations"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriProjects"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "ownerAri",
                                            "variableName": "ownerAri"
                                        }
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "SettingsDisplayPropertyConnection",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SettingsDisplayProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v9 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecent",
                                    "plural": false,
                                    "selections": v30 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecentFromHistory",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v10 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v31 /*: any*/ 
                                    ],
                                    "storageKey": "favourites(first:15)"
                                },
                                {
                                    "args": [
                                        v32 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recents",
                                    "plural": false,
                                    "selections": v34 /*: any*/ ,
                                    "storageKey": "recents(first:20)"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasMore"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "favouriteLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "recentLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayMode"
                                },
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ea3642e6555a179481081ac80a7e31572da36f24c9423ae468398ebf09e6ef6c",
            "metadata": {},
            "name": "Nav4ProjectsContentQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "displaySettingsAPart1Enabled": (0, $dtG0v.default),
                "displaySettingsPostGaEnabled": (0, $cli8x.default),
                "jiraProjectsSidebarMenuEnabled": (0, $eEnEt.default),
                "separateGrowthRecEnabled": (0, $l5K2d.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $dtG0v.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $cli8x.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": (0, $eEnEt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider": (0, $l5K2d.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $7m7yY.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $lhtKZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": (0, $5moL7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $eSxxM.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": (0, $9zQGn.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": (0, $em6ga.default)
            }
        }
    };
}();
$456273f1e51934e1$var$node.hash = "7509ad6a441a847a4ac6547b12d9c450";
var $456273f1e51934e1$export$2e2bcd8739ae039 = $456273f1e51934e1$var$node;

});


parcelRegister("2KtJf", function(module, exports) {

$parcel$export(module.exports, "useYbrCrossFlowSuppression", () => $5f6a0f0f8349a119$export$346e48c47f93909);

var $eJOHy = parcelRequire("eJOHy");

var $epTsa = parcelRequire("epTsa");

var $grVjp = parcelRequire("grVjp");
const $5f6a0f0f8349a119$export$346e48c47f93909 = ()=>{
    const [userIsWithin30Days] = (0, $grVjp.useIsJiraUserFirstActiveWithinXDays)(30);
    const shouldSuppress = (0, $eJOHy.useCallback)(()=>{
        if ((0, $epTsa.expVal)('jira_ybr_second_batch', 'isYBREnabled', false)) return userIsWithin30Days;
        return false;
    }, [
        userIsWithin30Days
    ]);
    return {
        shouldSuppress: shouldSuppress
    };
};

});
parcelRegister("grVjp", function(module, exports) {

$parcel$export(module.exports, "useIsJiraUserFirstActiveWithinXDays", () => $35444ee2c525c06b$export$cb5802762e78c9fd);

var $eJOHy = parcelRequire("eJOHy");

var $ea0Pc = parcelRequire("ea0Pc");

var $kEUB1 = parcelRequire("kEUB1");

var $8q7lT = parcelRequire("8q7lT");

var $58aKG = parcelRequire("58aKG");

var $2yivS = parcelRequire("2yivS");
const $35444ee2c525c06b$export$cb5802762e78c9fd = (xDays)=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const accountId = (0, $8q7lT.useAccountId)();
    const { fetchTraits: fetchTraits } = (0, $ea0Pc.useTraitsActions)();
    (0, $eJOHy.useEffect)(()=>{
        fetchTraits([
            (0, $58aKG.SITE_USER)
        ], {
            cloudId: cloudId,
            accountId: accountId
        });
    }, [
        cloudId,
        accountId,
        fetchTraits
    ]);
    return (0, $2yivS.useIsJiraUserFirstActiveWithinXDaysTraitSelector)(xDays);
};

});
parcelRegister("ea0Pc", function(module, exports) {

$parcel$export(module.exports, "useTraits", () => $e2b3b7a3a420087e$export$243330301a7ccf01);
$parcel$export(module.exports, "useTraitsActions", () => $e2b3b7a3a420087e$export$87f1d888def9d5a0);
$parcel$export(module.exports, "createTraitsSelector", () => $e2b3b7a3a420087e$export$fb8309e220d0dd3b);
$parcel$export(module.exports, "composeTraitsSelectors", () => $e2b3b7a3a420087e$export$e653f602b87eec56);

var $jGzN3 = parcelRequire("jGzN3");

var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $lctcw = parcelRequire("lctcw");

var $lFovQ = parcelRequire("lFovQ");

var $58aKG = parcelRequire("58aKG");

var $19QQ8 = parcelRequire("19QQ8");
const $e2b3b7a3a420087e$var$addTrait = (traitType, trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        const state = currentUserTraits[traitType];
        if (!state.attributes) {
            setState({
                ...currentUserTraits,
                [traitType]: {
                    attributes: [
                        trait
                    ]
                }
            });
            return;
        }
        if (state.attributes.some((existingTrait)=>existingTrait.name === trait.name)) setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: state.attributes.map((existingTrait)=>existingTrait.name === trait.name ? trait : existingTrait)
            }
        });
        else setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: [
                    ...state.attributes,
                    trait
                ]
            }
        });
    };
const $e2b3b7a3a420087e$var$fetchTraits = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].loaded || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $19QQ8.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $58aKG.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                let fetchedTraits = null;
                // TODO: in the future, we will need to also memoise site user trait and user trait here
                // Thus, we need to add FG at each conditions to fetch if we should use the memoised fetcher
                if (traitType === (0, $58aKG.SITE) && cloudId) fetchedTraits = {
                    attributes: await (0, $lctcw.memoizedFetchSitePersonalization)({
                        cloudId: cloudId
                    })
                };
                else if (traitType === (0, $58aKG.SITE_USER) && cloudId && accountId) fetchedTraits = {
                    attributes: await (0, $lFovQ.memoizedFetchSiteUserPersonalization)({
                        cloudId: cloudId,
                        userId: accountId
                    })
                };
                else fetchedTraits = await (0, $jGzN3.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false,
                        loaded: true
                    }
                });
            } catch  {
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: null,
                        loading: false,
                        loaded: true
                    }
                });
            }
        }));
    };
const $e2b3b7a3a420087e$var$actions = {
    fetchTraits: $e2b3b7a3a420087e$var$fetchTraits,
    addTrait: $e2b3b7a3a420087e$var$addTrait
};
const $e2b3b7a3a420087e$var$initialState = {
    ATLASSIAN_ACCOUNT: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE_USER: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG_USER: {
        attributes: null,
        loading: false,
        loaded: false
    }
};
const $e2b3b7a3a420087e$export$5b11e13f463f4eb = (0, $GtRbT.createStore)({
    initialState: $e2b3b7a3a420087e$var$initialState,
    actions: $e2b3b7a3a420087e$var$actions,
    name: 'TraitsStore'
});
const $e2b3b7a3a420087e$export$243330301a7ccf01 = (0, $iJq0l.createHook)($e2b3b7a3a420087e$export$5b11e13f463f4eb);
const $e2b3b7a3a420087e$export$87f1d888def9d5a0 = (0, $iJq0l.createActionsHook)($e2b3b7a3a420087e$export$5b11e13f463f4eb);
const $e2b3b7a3a420087e$var$defaultSelector = (traitsType, selector)=>(0, $4MchI.createSelector)((state)=>({
            loading: !!state[traitsType]?.loading,
            loaded: state[traitsType]?.loaded || false,
            attributes: state[traitsType]?.attributes,
            userCreatedAfter: (date)=>state[traitsType].loaded ? (0, $19QQ8.userCreatedAfter)(state, date) : false,
            userCreatedBefore: (date)=>state[traitsType].loaded ? (0, $19QQ8.userCreatedBefore)(state, date) : false,
            getTraitByName: (name)=>state[traitsType].loaded ? (0, $19QQ8.getTraitByName)(state, name) : null,
            hasTrait: (name)=>state[traitsType].loaded ? (0, $19QQ8.hasTrait)(state, name) : false,
            getTraitValue: (name)=>state[traitsType].loaded ? (0, $19QQ8.getTraitValue)(state, name) : null
        }), selector);
const $e2b3b7a3a420087e$export$fb8309e220d0dd3b = (traitsType, selector)=>(0, $iJq0l.createHook)($e2b3b7a3a420087e$export$5b11e13f463f4eb, {
        selector: $e2b3b7a3a420087e$var$defaultSelector(traitsType, selector)
    });
const $e2b3b7a3a420087e$export$e653f602b87eec56 = (traitTypes, hooks)=>({
        traitTypes: traitTypes,
        hooks: hooks
    });

});
parcelRegister("58aKG", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_ACCOUNT", () => $6bc297d84ad0ac90$export$eac8289d83d13c9e);
$parcel$export(module.exports, "SITE", () => $6bc297d84ad0ac90$export$1f4740cb59ea887e);
$parcel$export(module.exports, "SITE_USER", () => $6bc297d84ad0ac90$export$2b629adc0b711448);
$parcel$export(module.exports, "ORG", () => $6bc297d84ad0ac90$export$c7bc89c720838974);
$parcel$export(module.exports, "ORG_USER", () => $6bc297d84ad0ac90$export$872e93425a929c06);
$parcel$export(module.exports, "TRAIT_ENDPOINT_STARTING_FRAGMENT", () => $6bc297d84ad0ac90$export$ff5c5bd50c21e9a4);
const $6bc297d84ad0ac90$export$eac8289d83d13c9e = 'ATLASSIAN_ACCOUNT';
const $6bc297d84ad0ac90$export$1f4740cb59ea887e = 'SITE';
const $6bc297d84ad0ac90$export$2b629adc0b711448 = 'SITE_USER';
const $6bc297d84ad0ac90$export$c7bc89c720838974 = 'ORG';
const $6bc297d84ad0ac90$export$872e93425a929c06 = 'ORG_USER';
const $6bc297d84ad0ac90$export$ff5c5bd50c21e9a4 = '/gateway/api/tap-delivery/api/v3/personalization/';
const $6bc297d84ad0ac90$export$ab3e7784d2a104d4 = [
    $6bc297d84ad0ac90$export$eac8289d83d13c9e,
    $6bc297d84ad0ac90$export$1f4740cb59ea887e,
    $6bc297d84ad0ac90$export$2b629adc0b711448,
    $6bc297d84ad0ac90$export$c7bc89c720838974,
    $6bc297d84ad0ac90$export$872e93425a929c06
];

});

parcelRegister("19QQ8", function(module, exports) {

$parcel$export(module.exports, "buildTraitEndpointEndingFragment", () => $487f20fc6a559fdc$export$118c30eb4b4c51e8);
$parcel$export(module.exports, "getTraitByName", () => $487f20fc6a559fdc$export$e5b0d140cf11f46a);
$parcel$export(module.exports, "hasTrait", () => $487f20fc6a559fdc$export$252a469687875173);
$parcel$export(module.exports, "getTraitValue", () => $487f20fc6a559fdc$export$43a43c2e6ec7b13);
$parcel$export(module.exports, "userCreatedAfter", () => $487f20fc6a559fdc$export$8388eb33623a9cff);
$parcel$export(module.exports, "userCreatedBefore", () => $487f20fc6a559fdc$export$da1e8ce191f01409);

var $58aKG = parcelRequire("58aKG");
const $487f20fc6a559fdc$export$e320a062b20fddc3 = (traitsData)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(traitsData).reduce((acc, [, val])=>{
        if (val?.attributes) acc.push(...val.attributes.map((singleTrait)=>singleTrait));
        return acc;
    }, []);
const $487f20fc6a559fdc$export$118c30eb4b4c51e8 = ({ traitType: traitType, accountId: accountId, cloudId: cloudId, orgId: orgId })=>{
    switch(traitType){
        case 0, $58aKG.ATLASSIAN_ACCOUNT:
            return `user/${accountId}`;
        case 0, $58aKG.SITE:
            return `site/${cloudId}`;
        case 0, $58aKG.SITE_USER:
            return `site/${cloudId}/user/${accountId}`;
        case 0, $58aKG.ORG:
            return `org/${orgId}`;
        case 0, $58aKG.ORG_USER:
            return `org/${orgId}/user/${accountId}`;
        default:
            return null;
    }
};
function $487f20fc6a559fdc$export$e5b0d140cf11f46a(traitsData, traitName) {
    return $487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName);
}
function $487f20fc6a559fdc$export$252a469687875173(traitsData, traitName) {
    return $487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName) !== undefined;
}
function $487f20fc6a559fdc$export$43a43c2e6ec7b13(traitsData, traitName) {
    return $487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName)?.value ?? null;
}
const $487f20fc6a559fdc$export$d2a3b2f9735b6874 = (traitsData, traitNames)=>$487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.filter((trait)=>traitNames.includes(trait.name));
const $487f20fc6a559fdc$export$8388eb33623a9cff = (traitsData, date)=>{
    const accountCreationDate = $487f20fc6a559fdc$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) > date;
};
const $487f20fc6a559fdc$export$da1e8ce191f01409 = (traitsData, date)=>{
    const accountCreationDate = $487f20fc6a559fdc$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) < date;
};

});


parcelRegister("2yivS", function(module, exports) {

$parcel$export(module.exports, "useIsJiraUserFirstActiveWithinXDaysTraitSelector", () => $1d67cd7fb8cad7e9$export$845fb1e1db406170);

var $ea0Pc = parcelRequire("ea0Pc");
const $1d67cd7fb8cad7e9$var$isFirstActiveWithinXDays = (firstActiveDate, xDays)=>{
    const date = new Date(firstActiveDate);
    if (Number.isNaN(date.getTime())) return false;
    const xDaysAgo = new Date();
    xDaysAgo.setDate(xDaysAgo.getDate() - xDays);
    // Set milliseconds to the same as the date to avoid timing issues, remove this will fail the unit test
    xDaysAgo.setMilliseconds(date.getMilliseconds());
    return date >= xDaysAgo;
};
const $1d67cd7fb8cad7e9$export$845fb1e1db406170 = (xDays)=>(0, $ea0Pc.createTraitsSelector)('SITE_USER', ({ getTraitByName: getTraitByName })=>{
        const firstActiveTrait = getTraitByName('jira_first_active');
        if (!firstActiveTrait || !(typeof firstActiveTrait.value === 'string')) return false;
        if ($1d67cd7fb8cad7e9$var$isFirstActiveWithinXDays(firstActiveTrait.value, xDays)) return true;
        return false;
    })();

});



parcelRegister("1qb7e", function(module, exports) {

$parcel$export(module.exports, "Nav4OnboardingComponentNames", () => $7e33c213883ad026$export$f813aeb3fcf8b623);
$parcel$export(module.exports, "COMPONENT_TAP_TRAIT_MAP", () => $7e33c213883ad026$export$c1a4e03cc30032f5);
const $7e33c213883ad026$export$f813aeb3fcf8b623 = {
    GLOBAL_MODAL: 'nav4GlobalOnboardingModal',
    JIRA_SIDEBAR_TOGGLE_SPOTLIGHT: 'nav4SidebarToggleOnboardingSpotlight',
    // CONFLUENCE_SIDEBAR_TOGGLE_SPOTLIGHT: 'nav4ConfluenceSidebarToggleOnboardingSpotlight', // TODO: Spotlight has not been implemented in Confluence yet so this may change
    SIDEBAR_PROJECT_SPOTLIGHT: 'nav4SidebarProjectsOnboardingSpotlight',
    TAB_NAV_SPOTLIGHT: 'nav4TabNavigationOnboardingSpotlight',
    ATLAS_GLOBAL_MODAL: 'nav4AtlasGlobalOnboardingModal',
    ATLAS_GLOBAL_MODAL2: 'nav4AtlasGlobalOnboardingModal2'
};
const $7e33c213883ad026$export$c1a4e03cc30032f5 = {
    nav4GlobalOnboardingModal: 'jira-platform_ui_nav4globalonboardingmodal_dismissed_jiraatlassianonboardingnav4_changed',
    nav4SidebarToggleOnboardingSpotlight: 'jira-platform_ui_nav4sidebartoggleonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    // nav4ConfluenceSidebarToggleOnboardingSpotlight: '', // TODO: Add when Confluence spotlight is implemented
    nav4SidebarProjectsOnboardingSpotlight: 'jira-platform_ui_nav4sidebarprojectsonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    nav4TabNavigationOnboardingSpotlight: 'jira-platform_ui_nav4tabnavigationonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    nav4AtlasGlobalOnboardingModal: 'townsquare_ui_atlassianhomeonboardingnav4_dismissed_teamcentral_changed'
};

});

parcelRegister("2Of18", function(module, exports) {

$parcel$export(module.exports, "OnboardingSpotlightMaybe", () => $32e9311523cdc66f$export$77e61d078c8501ca);

var $eJOHy = parcelRequire("eJOHy");

var $gbiVe = parcelRequire("gbiVe");

var $7jTnu = parcelRequire("7jTnu");
function $32e9311523cdc66f$export$77e61d078c8501ca({ children: children, spotlight: spotlight }) {
    if (!(0, $7jTnu.fg)('blu-2735_nav4_onboarding')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return spotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), {
        name: spotlight
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
}

});

parcelRegister("isd83", function(module, exports) {

$parcel$export(module.exports, "UpdateProjectsProvider", () => $cac46ec6f320ae76$export$a50917f7cd2aeeda);
$parcel$export(module.exports, "useUpdateProjectsInRelayStoreContext", () => $cac46ec6f320ae76$export$5105901d98bfdbf1);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");
const $cac46ec6f320ae76$var$UpdateProjectsContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $cac46ec6f320ae76$export$c80374615e2c5b2 = ({ environment: environment, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId })=>{
    const removeProjectRecord = (projectDataId)=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            const favorites = store.get(favouriteConnectionId);
            const recents = store.get(recentConnectionId);
            if (favorites && projectDataId) (0, $j4oe4.ConnectionHandler).deleteNode(favorites, projectDataId);
            if (recents && projectDataId) (0, $j4oe4.ConnectionHandler).deleteNode(recents, projectDataId);
        });
    };
    const archiveProject = (projectDataId)=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            store.get(projectDataId)?.setValue('ARCHIVED', 'status');
        });
    };
    return {
        deleteProject: removeProjectRecord,
        archiveProject: archiveProject
    };
};
const $cac46ec6f320ae76$export$a50917f7cd2aeeda = ({ children: children, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const updateRelayStore = $cac46ec6f320ae76$export$c80374615e2c5b2({
        environment: environment,
        favouriteConnectionId: favouriteConnectionId,
        recentConnectionId: recentConnectionId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cac46ec6f320ae76$var$UpdateProjectsContext.Provider, {
        value: updateRelayStore
    }, children);
};
const $cac46ec6f320ae76$export$5105901d98bfdbf1 = ()=>(0, $eJOHy.useContext)($cac46ec6f320ae76$var$UpdateProjectsContext);

});

parcelRegister("kwzsh", function(module, exports) {

$parcel$export(module.exports, "useSyncChangeFavourites", () => $a6f5b670fcfacba3$export$5f8a0bc021135735);

var $bsT4W = parcelRequire("bsT4W");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $hbF3h = parcelRequire("hbF3h");

var $epTsa = parcelRequire("epTsa");

var $3osLr = parcelRequire("3osLr");

var $8Umc4 = parcelRequire("8Umc4");

var $kEUB1 = parcelRequire("kEUB1");
/*
Hook to trigger a mutation to reorder the projects in the sidebar when a project is starred.
This is used to ensure that the newly starred project is placed at the top of the custom order.
*/ function $a6f5b670fcfacba3$var$useSyncChangeFavouritesConditionally() {
    const cloudId = (0, $kEUB1.useCloudId)();
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $bsT4W.default));
    const moveFavouriteToTop = (0, $eJOHy.useCallback)((payload)=>{
        // Prevent optimistic updates from triggering setting custom order
        if (payload.type === 'MUTATION' && payload.isOptimistic) return;
        if (payload.isFavourite) {
            const itemId = (0, $3osLr.JiraProjectAri).parse(payload.entityId).projectId;
            commitMutation({
                variables: {
                    input: {
                        cloudId: cloudId,
                        reorderMode: 'MOVE_TO_TOP',
                        menuItem: {
                            itemId: itemId
                        }
                    }
                }
            });
        }
    }, [
        cloudId,
        commitMutation
    ]);
    (0, $8Umc4.useSubscribeToFavorite)('JiraProject', moveFavouriteToTop);
}
const $a6f5b670fcfacba3$export$5f8a0bc021135735 = (0, $hbF3h.functionWithCondition)(()=>(0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false), $a6f5b670fcfacba3$var$useSyncChangeFavouritesConditionally, ()=>null);

});
parcelRegister("bsT4W", function(module, exports) {

$parcel$export(module.exports, "default", () => $266cc8f9fe794aab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d176b4581fcf0be783cf10565b5b141b>>
 * @relayHash 0208b878af55b00264f8644b0df098c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 60b49c169fa333de0eb4673b99a7bf5474c1518d35b3d087ef1900fe0802b44d

var $9zQGn = parcelRequire("9zQGn");

var $5moL7 = parcelRequire("5moL7");

var $lhtKZ = parcelRequire("lhtKZ");

var $eSxxM = parcelRequire("eSxxM");

var $em6ga = parcelRequire("em6ga");
const $266cc8f9fe794aab$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 15
        }
    ], v4 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v5 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "webUrl"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "syncChangeFavouritesMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "Nav4ProjectMenuItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "syncChangeFavouritesMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "large"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "defaultNavigationItem",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "url"
                                                                }
                                                            ],
                                                            "type": "JiraNavigationItem",
                                                            "abstractKey": "__isJiraNavigationItem"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v2 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "softwareBoardCount"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": v7 /*: any*/ 
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": v7 /*: any*/ 
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": v7 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "60b49c169fa333de0eb4673b99a7bf5474c1518d35b3d087ef1900fe0802b44d",
            "metadata": {},
            "name": "syncChangeFavouritesMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $lhtKZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": (0, $5moL7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $eSxxM.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": (0, $9zQGn.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": (0, $em6ga.default)
            }
        }
    };
}();
$266cc8f9fe794aab$var$node.hash = "386bc86a3d207190cfd88ada4281e551";
var $266cc8f9fe794aab$export$2e2bcd8739ae039 = $266cc8f9fe794aab$var$node;

});


parcelRegister("a8Wkt", function(module, exports) {

$parcel$export(module.exports, "useSidebarSettingsAri", () => $28d3622341d60d9c$export$c020d957682d50c);
$parcel$export(module.exports, "useOwnerAri", () => $28d3622341d60d9c$export$7eaf80e428ccd5b3);

var $eJOHy = parcelRequire("eJOHy");

var $kEUB1 = parcelRequire("kEUB1");

var $8q7lT = parcelRequire("8q7lT");

var $4ihOZ = parcelRequire("4ihOZ");

var $a2f5K = parcelRequire("a2f5K");
const $28d3622341d60d9c$export$c020d957682d50c = (menuName, parentType, parentId)=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const activationId = (0, $4ihOZ.useActivationId)();
    return (0, $eJOHy.useMemo)(()=>(0, $a2f5K.createSidebarSettingsAri)(cloudId, activationId, menuName, parentType, parentId), [
        cloudId,
        activationId,
        menuName,
        parentType,
        parentId
    ]);
};
const $28d3622341d60d9c$export$7eaf80e428ccd5b3 = ()=>{
    const accountId = (0, $8q7lT.useAccountId)() || 'unidentified';
    return (0, $eJOHy.useMemo)(()=>(0, $a2f5K.createIdentityUserAri)(accountId), [
        accountId
    ]);
};

});
parcelRegister("a2f5K", function(module, exports) {

$parcel$export(module.exports, "createSidebarSettingsAri", () => $b66a5747a6ef1c56$export$53e9bd7d6d946a5d);
$parcel$export(module.exports, "createIdentityUserAri", () => $b66a5747a6ef1c56$export$caf08cda0abeee7a);

var $fKh2A = parcelRequire("fKh2A");

var $7Cu03 = parcelRequire("7Cu03");
const $b66a5747a6ef1c56$export$1fd3c0096c24b2bb = (menuName, parentType, parentId)=>{
    if (parentType === undefined !== (parentId === undefined)) throw new Error('Invalid Navigation Setting Scope parentType and parentId must be defined together');
    if (parentType !== undefined && parentId !== undefined) return `${parentType}/${parentId}/${menuName}`;
    return menuName;
};
const $b66a5747a6ef1c56$export$b1bae424ff62eaf3 = (scope)=>{
    const [parentTypeOrMenuName, parentId, menuName] = scope.split('/');
    if (parentTypeOrMenuName && !parentId && !menuName) return {
        menuName: parentTypeOrMenuName
    };
    if (parentTypeOrMenuName && parentId && menuName) return {
        parentType: parentTypeOrMenuName,
        parentId: parentId,
        menuName: menuName
    };
    throw new Error('Invalid Navigation Setting Scope format');
};
const $b66a5747a6ef1c56$export$53e9bd7d6d946a5d = (cloudId, activationId, menuName, parentType, parentId)=>{
    return (0, $fKh2A.JiraNavigationSettingsAri).create({
        siteId: cloudId,
        activationId: activationId,
        navigationSettingScope: $b66a5747a6ef1c56$export$1fd3c0096c24b2bb(menuName, parentType, parentId)
    }).toString();
};
const $b66a5747a6ef1c56$export$cc210794adbf70e7 = (ariLikeString)=>{
    const ari = (0, $fKh2A.JiraNavigationSettingsAri).parse(ariLikeString);
    return $b66a5747a6ef1c56$export$b1bae424ff62eaf3(ari.navigationSettingScope);
};
const $b66a5747a6ef1c56$export$caf08cda0abeee7a = (userId)=>{
    return (0, $7Cu03.IdentityUserAri).create({
        userId: userId
    }).toString();
};

});


parcelRegister("9N2D6", function(module, exports) {

$parcel$export(module.exports, "default", () => $53296ce4e01ee7cd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $f1Zdy = parcelRequire("f1Zdy");

var $dKpTa = parcelRequire("dKpTa");
var $OgPfS = parcelRequire("OgPfS");

var $6sWr0 = parcelRequire("6sWr0");
var $3Zn1o = parcelRequire("3Zn1o");
var $15cpG = parcelRequire("15cpG");
var $i237T = parcelRequire("i237T");

var $epTsa = parcelRequire("epTsa");

var $2ZGUP = parcelRequire("2ZGUP");

var $ln6Iy = parcelRequire("ln6Iy");

var $bdG9p = parcelRequire("bdG9p");

var $idGBm = parcelRequire("idGBm");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");

var $fgJkD = parcelRequire("fgJkD");

var $3BME1 = parcelRequire("3BME1");

var $dVWFb = parcelRequire("dVWFb");

var $4xqwG = parcelRequire("4xqwG");

var $ci7Vl = parcelRequire("ci7Vl");
const $53296ce4e01ee7cd$export$a43ae427db1e9df7 = 'restore-from-trash';
const $53296ce4e01ee7cd$export$ec2a19e79c04c9d2 = 'restore-from-archive';
const $53296ce4e01ee7cd$export$cee26a329c363b31 = (props)=>{
    const jsmModalHeaderGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dVWFb.default).jsmModalHeaderGalaxia : (0, $dVWFb.default).jsmModalHeader;
    const modalHeaderGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dVWFb.default).modalHeaderGalaxia : (0, $dVWFb.default).modalHeader;
    const { isProjectSimplified: isProjectSimplified, projectType: projectType, projectName: projectName, projectId: projectId, projectKey: projectKey, projectInactiveDate: projectInactiveDate, intl: { formatMessage: formatMessage }, onClose: onClose, onProjectRestoreSuccess: onProjectRestoreSuccess, onProjectRestoreFailure: onProjectRestoreFailure, flagService: { showFlag: showFlag } } = props;
    const [isRestoring, restoreProject] = (0, $3BME1.useProjectRestoreService)({
        projectId: projectId
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const attributes = {
        projectType: projectType,
        isProjectSimplified: isProjectSimplified
    };
    const onSuccess = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'restored'
        });
        (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'project restored', projectId.toString(), {
            ...attributes,
            durationInTrash: projectInactiveDate ? (0, $ci7Vl.getDurationInTrash)(projectInactiveDate) : undefined
        });
        onProjectRestoreSuccess();
        if (projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT)) showFlag({
            messageId: 'project-restore-modal.ui.show-flag.success.restore-service-desk-success',
            messageType: 'transactional',
            type: 'success',
            title: (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dVWFb.default).restoreServiceDeskSuccessMessageTitleGalaxia : (0, $dVWFb.default).restoreServiceDeskSuccessMessageTitle,
            description: (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dVWFb.default).restoreServiceDeskSuccessMessageContentGalaxia : (0, $dVWFb.default).restoreServiceDeskSuccessMessageContent,
            testId: 'project-restore-modal.ui.flags.success-flag',
            actions: [
                {
                    content: (0, $dVWFb.default).restoreServiceDeskSuccessMessageActionEmailSettings,
                    href: `/jira/servicedesk/projects/${projectKey}/settings/email`
                }
            ]
        });
        else showFlag({
            messageId: 'project-restore-modal.ui.show-flag.success.restore-success',
            messageType: 'transactional',
            type: 'success',
            title: (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dVWFb.default).restoreSuccessMessageTitleGalaxia : (0, $dVWFb.default).restoreSuccessMessageTitle,
            testId: 'project-restore-modal.ui.flags.success-flag'
        });
    };
    const onFailure = (error)=>{
        onProjectRestoreFailure(error);
        if (// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        error.statusCode?.toString().startsWith('4') && error.message) showFlag({
            messageId: 'project-restore-modal.ui.show-flag.error.restore-error',
            messageType: 'transactional',
            type: 'error',
            title: [
                (0, $dVWFb.default).restoreErrorMessageTitle,
                {
                    projectName: projectName
                }
            ],
            description: [
                (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dVWFb.default).restoreErrorMessageDescriptionRenderErrorNonFinalGalaxia : (0, $dVWFb.default).restoreErrorMessageDescriptionRenderErrorNonFinal,
                {
                    projectName: projectName,
                    error: error.message,
                    br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null)
                }
            ],
            testId: 'project-restore-modal.ui.flags.failure-flag'
        });
        else showFlag({
            messageId: 'project-restore-modal.ui.show-flag.error.restore-error.1',
            messageType: 'transactional',
            type: 'error',
            title: [
                (0, $dVWFb.default).restoreErrorMessageTitle,
                {
                    projectName: projectName
                }
            ],
            description: [
                (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dVWFb.default).restoreErrorMessageDescriptionGalaxia : (0, $dVWFb.default).restoreErrorMessageDescription,
                {
                    projectName: projectName
                }
            ],
            testId: 'project-restore-modal.ui.flags.failure-flag'
        });
    };
    const onRestore = (e, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'restoreProjectButton');
        restoreProject({
            onSuccess: onSuccess,
            onFailure: onFailure
        });
    };
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const ModalDialogDescription = ()=>// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xqwG.ModalMessageContent), {
            projectType: projectType
        }));
    const onCancelOrNoop = !isRestoring ? onClose : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "restoreProject",
        sourceType: (0, $466f60259c330878$export$1171103ea9083ffa),
        attributes: attributes,
        containerId: `${projectId}`,
        containerType: "project"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgJkD.ModalDialog), {
        messageId: "project-restore-modal.ui.modal-dialog",
        messageType: "transactional",
        onClose: onCancelOrNoop,
        autoFocus: false,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $15cpG.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i237T.default), null, formatMessage(projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT) ? jsmModalHeaderGalaxia : modalHeaderGalaxia, {
        projectName: projectName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6sWr0.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ModalDialogDescription, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Zn1o.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        appearance: "subtle-link",
        onClick: onCancelOrNoop,
        isDisabled: isRestoring,
        testId: "project-restore-modal.ui.close-button-wrapper"
    }, formatMessage((0, $dVWFb.default).cancelRestoreButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $OgPfS.default), {
        appearance: "primary",
        onClick: onRestore,
        isDisabled: isRestoring,
        isLoading: isRestoring,
        testId: "project-restore-modal.ui.restore-button-wrapper"
    }, formatMessage((0, $dVWFb.default).confirmRestoreButton))))));
};
const $53296ce4e01ee7cd$export$9c21a3269931e1e6 = {
    isRestoring: false,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
var $53296ce4e01ee7cd$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)((0, $bdG9p.default)($53296ce4e01ee7cd$export$cee26a329c363b31));

});
parcelRegister("bdG9p", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eb30b9664410926$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bILK0 = parcelRequire("bILK0");
const $8eb30b9664410926$var$withFlagService = (WrappedComponent)=>{
    return (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $bILK0.flagService)
        });
};
var $8eb30b9664410926$export$2e2bcd8739ae039 = $8eb30b9664410926$var$withFlagService;

});

parcelRegister("3BME1", function(module, exports) {

$parcel$export(module.exports, "useProjectRestoreService", () => $4d38ecb8649063f2$export$3726936b35df382d);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $7jTnu = parcelRequire("7jTnu");

var $3UU1D = parcelRequire("3UU1D");
const $4d38ecb8649063f2$export$3726936b35df382d = ({ projectId: projectId })=>{
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const restoreProject = ({ onSuccess: onSuccess, onFailure: onFailure })=>{
        const url = (0, $3UU1D.getProjectRestoreUrl)(projectId);
        setLoading(true);
        (0, $jGzN3.performPostRequest)(url).then(()=>{
            setLoading(false);
            onSuccess();
        }).catch((error)=>{
            if (!(error.statusCode === 409 && (0, $7jTnu.fg)('hix-6266_-_no_error_fired_for_409_project_restore'))) (0, $gYnSx.default)({
                meta: {
                    id: 'useProjectRestoreService',
                    packageName: 'jiraProjectRestoreModal'
                },
                error: error,
                attributes: {
                    projectId: projectId,
                    errorStatusCode: error.statusCode
                }
            });
            setLoading(false);
            onFailure(error);
        });
    };
    return [
        loading,
        restoreProject
    ];
};

});
parcelRegister("3UU1D", function(module, exports) {

$parcel$export(module.exports, "getProjectRestoreUrl", () => $22968aa618e6a50b$export$f120ca318b319edc);
const $22968aa618e6a50b$export$f120ca318b319edc = (projectId)=>`/rest/api/2/project/${projectId}/restore`;

});


parcelRegister("dVWFb", function(module, exports) {

$parcel$export(module.exports, "default", () => $899d0f26d696eae6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $899d0f26d696eae6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    modalHeader: {
        "id": "project-restore-modal.modal-header",
        "defaultMessage": "Restore project?"
    },
    jsmModalHeader: {
        "id": "project-restore-modal.jsm-modal-header",
        "defaultMessage": "Restore this service project?"
    },
    jsmExplainWhatProjectRestoreDoes: {
        "id": "project-restore-modal.jsm-explain-what-project-restore-does",
        "defaultMessage": "Once restored, this service project will work as normal. It will appear in directories and requests will appear in search results."
    },
    confirmRestoreButton: {
        "id": "project-restore-modal.confirm-restore-button",
        "defaultMessage": "Restore"
    },
    cancelRestoreButton: {
        "id": "project-restore-modal.cancel-restore-button",
        "defaultMessage": "Cancel"
    },
    restoreSuccessMessageTitle: {
        "id": "project-restore-modal.restore-success-message-title",
        "defaultMessage": "Project successfully restored"
    },
    restoreServiceDeskSuccessMessageTitle: {
        "id": "project-restore-modal.restore-service-desk-success-message-title",
        "defaultMessage": "Service project restored"
    },
    restoreServiceDeskSuccessMessageContent: {
        "id": "project-restore-modal.restore-service-desk-success-message-content",
        "defaultMessage": "You may need to turn on email support for your service project to work as normal."
    },
    restoreServiceDeskSuccessMessageActionEmailSettings: {
        "id": "project-restore-modal.restore-service-desk-success-message-action-email-settings",
        "defaultMessage": "Go to email settings"
    },
    restoreErrorMessageTitle: {
        "id": "project-restore-modal.restore-error-message-title",
        "defaultMessage": "Something went wrong"
    },
    restoreErrorMessageDescription: {
        "id": "project-restore-modal.restore-error-message-description",
        "defaultMessage": "We couldn\u2019t restore the \u201C{projectName}\u201D project. Try again."
    },
    restoreErrorMessageDescriptionRenderErrorNonFinal: {
        "id": "project-restore-modal.restore-error-message-description-render-error-non-final",
        "defaultMessage": "We couldn\u2019t restore the \u201C{projectName}\u201D project.{br}{error}"
    },
    restoreSuccessMessageTitleGalaxia: {
        "id": "project-restore-modal.restore-success-message-title-galaxia",
        "defaultMessage": "Space successfully restored"
    },
    restoreServiceDeskSuccessMessageTitleGalaxia: {
        "id": "project-restore-modal.restore-service-desk-success-message-title-galaxia",
        "defaultMessage": "Service space restored"
    },
    restoreServiceDeskSuccessMessageContentGalaxia: {
        "id": "project-restore-modal.restore-service-desk-success-message-content-galaxia",
        "defaultMessage": "You may need to turn on email support for your service space to work as normal."
    },
    restoreErrorMessageDescriptionGalaxia: {
        "id": "project-restore-modal.restore-error-message-description-galaxia",
        "defaultMessage": "We couldn\u2019t restore the \u201C{projectName}\u201D space. Try again."
    },
    restoreErrorMessageDescriptionRenderErrorNonFinalGalaxia: {
        "id": "project-restore-modal.restore-error-message-description-render-error-non-final-galaxia",
        "defaultMessage": "We couldn\u2019t restore the \u201C{projectName}\u201D space.{br}{error}"
    },
    modalHeaderGalaxia: {
        "id": "project-restore-modal.modal-header-galaxia",
        "defaultMessage": "Restore space?"
    },
    jsmModalHeaderGalaxia: {
        "id": "project-restore-modal.jsm-modal-header-galaxia",
        "defaultMessage": "Restore this service space?"
    }
});

});

parcelRegister("4xqwG", function(module, exports) {

$parcel$export(module.exports, "ModalMessageContent", () => $f1396f5a72f0c09b$export$6c33ff8e4ab0adf4);

var $eJOHy = parcelRequire("eJOHy");

var $hdC3k = parcelRequire("hdC3k");

var $ln6Iy = parcelRequire("ln6Iy");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");


var $fdCYx = parcelRequire("fdCYx");
const $f1396f5a72f0c09b$var$isServiceDesk = (projectType)=>projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT);
const $f1396f5a72f0c09b$export$49587436f0d2c314 = ({ projectType: projectType })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getMessage = ()=>{
        const jsmExplainWhatProjectRestoreDoesIssueTermRefreshGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $fdCYx.default).jsmExplainWhatProjectRestoreDoesIssueTermRefreshGalaxia : (0, $fdCYx.default).jsmExplainWhatProjectRestoreDoesIssueTermRefresh;
        const explainWhatProjectRestoreDoesPart1IssueTermRefreshGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $fdCYx.default).explainWhatProjectRestoreDoesPart1IssueTermRefreshGalaxia : (0, $fdCYx.default).explainWhatProjectRestoreDoesPart1IssueTermRefresh;
        let message;
        if ((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) message = $f1396f5a72f0c09b$var$isServiceDesk(projectType) ? jsmExplainWhatProjectRestoreDoesIssueTermRefreshGalaxia : explainWhatProjectRestoreDoesPart1IssueTermRefreshGalaxia;
        else message = $f1396f5a72f0c09b$var$isServiceDesk(projectType) ? (0, $fdCYx.default).jsmExplainWhatProjectRestoreDoes : (0, $fdCYx.default).explainWhatProjectRestoreDoesPart1;
        return message;
    };
    const formattedMessage = formatMessage(getMessage());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, formattedMessage, "\xa0");
};
const $f1396f5a72f0c09b$export$d608ae2ec728a3cf = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hdC3k.default), {
        href: (0, $158f8dea36e8141e$export$367c841df4ac5730),
        target: "_blank"
    }, formatMessage((0, $fdCYx.default).jsmLearnMoreAboutTrashAndRestore));
};
const $f1396f5a72f0c09b$export$6c33ff8e4ab0adf4 = ({ projectType: projectType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1396f5a72f0c09b$export$49587436f0d2c314, {
        projectType: projectType
    }), $f1396f5a72f0c09b$var$isServiceDesk(projectType) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1396f5a72f0c09b$export$d608ae2ec728a3cf, null));

});
parcelRegister("hdC3k", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c40284cc2b86752$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aBFKZ = parcelRequire("aBFKZ");

var $c9uTK = parcelRequire("c9uTK");
function $9c40284cc2b86752$var$Link(props) {
    const { children: children, ...rest } = props;
    // eslint-disable-next-line react-hooks/react-compiler
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), rest, children);
}
var $9c40284cc2b86752$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('link', {
    onClick: 'clicked'
})($9c40284cc2b86752$var$Link);

});
parcelRegister("aBFKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $86225f230220e152$export$2e2bcd8739ae039);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $kUIKr = parcelRequire("kUIKr");
var $aN4Pk = parcelRequire("aN4Pk");
const $86225f230220e152$export$871de8747c9eaa88 = (props)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            ...result,
            [key]: {
                action: props[key]
            }
        }), {});
/**
 * Augments component's callbacks with analytics event as the last attribute, but does fires them
 * @example
 * ```tsx
 * // adds componentName into AnalyticsContext and adds pre-backed 'clicked' event to onClick arguments
 *  const componentWithAnalytics('FooComponent', { onClick: 'clicked' })(Foo)
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $86225f230220e152$var$componentWithAnalytics(componentName, eventActions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(WrappedComponent) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $kUIKr.default)({
            componentName: componentName
        })((0, $aN4Pk.default)($86225f230220e152$export$871de8747c9eaa88(eventActions))(WrappedComponent));
    };
}
var $86225f230220e152$export$2e2bcd8739ae039 = $86225f230220e152$var$componentWithAnalytics;

});


const $158f8dea36e8141e$export$37312a67c3e314c6 = 'PROJECT_RESTORE_MODAL_LOAD_START_MARK_KEY';
const $158f8dea36e8141e$export$367c841df4ac5730 = 'https://support.atlassian.com/jira-service-management-cloud/docs/trash-and-restore-a-project/';

parcelRegister("fdCYx", function(module, exports) {

$parcel$export(module.exports, "default", () => $03db4a4caab7353a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $03db4a4caab7353a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    explainWhatProjectRestoreDoesPart1: {
        "id": "project-restore-modal.modal-message.explain-what-project-restore-does-part-1",
        "defaultMessage": "The project along with its issues, Jira components, attachments, and versions will be restored."
    },
    jsmExplainWhatProjectRestoreDoes: {
        "id": "project-restore-modal.modal-message.jsm-explain-what-project-restore-does",
        "defaultMessage": "Once restored, this service project will appear in directories and its issues will appear in search results. You may need to turn on email support for this service project to work as normal."
    },
    jsmLearnMoreAboutTrashAndRestore: {
        "id": "project-restore-modal.modal-message.jsm-learn-more-about-trash-and-restore",
        "defaultMessage": "Learn more about trash and restore."
    },
    explainWhatProjectRestoreDoesPart1IssueTermRefresh: {
        "id": "project-restore-modal.modal-message.explain-what-project-restore-does-part-1-issue-term-refresh",
        "defaultMessage": "The project along with its work items, Jira components, attachments, and versions will be restored"
    },
    jsmExplainWhatProjectRestoreDoesIssueTermRefresh: {
        "id": "project-restore-modal.modal-message.jsm-explain-what-project-restore-does-issue-term-refresh",
        "defaultMessage": "Once restored, this service project will appear in directories and its work items will appear in search results. You may need to turn on email support for this service project to work as normal."
    },
    explainWhatProjectRestoreDoesPart1IssueTermRefreshGalaxia: {
        "id": "project-restore-modal.modal-message.explain-what-project-restore-does-part-1-issue-term-refresh-galaxia",
        "defaultMessage": "The space along with its work items, Jira components, attachments, and versions will be restored"
    },
    jsmExplainWhatProjectRestoreDoesIssueTermRefreshGalaxia: {
        "id": "project-restore-modal.modal-message.jsm-explain-what-project-restore-does-issue-term-refresh-galaxia",
        "defaultMessage": "Once restored, this service space will appear in directories and its work items will appear in search results. You may need to turn on email support for this service space to work as normal."
    }
});

});


parcelRegister("ci7Vl", function(module, exports) {

$parcel$export(module.exports, "getDurationInTrash", () => $e037765542359a31$export$d40938201f7514c5);

var $lw3Pj = parcelRequire("lw3Pj");

var $dBLX0 = parcelRequire("dBLX0");

var $kQ82p = parcelRequire("kQ82p");
const $e037765542359a31$export$d40938201f7514c5 = (projectTrashedDate)=>{
    const parsedProjectTrashedDate = (0, $dBLX0.default)((0, $kQ82p.default)(projectTrashedDate)) ? (0, $kQ82p.default)(projectTrashedDate) : new Date(projectTrashedDate);
    return (0, $lw3Pj.default)(new Date(), parsedProjectTrashedDate);
};

});


parcelRegister("idwl9", function(module, exports) {

$parcel$export(module.exports, "Nav4Recommendations", () => $b84878005942956c$export$dfe7a31b75b5edeb);
$parcel$export(module.exports, "Nav4RecommendationsOld", () => $b84878005942956c$export$69b3eee550308510);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");


var $9Wrvz = parcelRequire("9Wrvz");

var $4NICj = parcelRequire("4NICj");
const $b84878005942956c$export$dfe7a31b75b5edeb = /*#__PURE__*/ (0, $eJOHy.memo)($b84878005942956c$var$RecommendationsQuery);
const $b84878005942956c$export$69b3eee550308510 = /*#__PURE__*/ (0, $eJOHy.memo)($b84878005942956c$var$RecommendationsOld);
function $b84878005942956c$var$RecommendationsOld({ queryRef: queryRef }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "growth-recommendation-old",
        fallback: "flag",
        packageName: (0, $f9370b6235f53e1a$export$b8b9d90f9e5bd72b),
        teamName: (0, $f9370b6235f53e1a$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "recommendations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Wrvz.Nav4RecommendationsOld), {
        queryRef: queryRef
    })));
}
function $b84878005942956c$var$RecommendationsQuery() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "growth-recommendations",
        fallback: "unmount",
        packageName: (0, $f9370b6235f53e1a$export$b8b9d90f9e5bd72b),
        teamName: (0, $f9370b6235f53e1a$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "recommendations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NICj.Nav4Recommendations), null)));
}

});
const $f9370b6235f53e1a$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4GrowthRecommendations';
const $f9370b6235f53e1a$export$d57b6b390e78d90f = 'jira-cosmos';
const $f9370b6235f53e1a$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';

parcelRegister("9Wrvz", function(module, exports) {

$parcel$export(module.exports, "Nav4RecommendationsOld", () => $852463353975ad42$export$69b3eee550308510);

var $3ztLf = parcelRequire("3ztLf");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $6qOE4 = parcelRequire("6qOE4");
/*
At the moment, growthRecommendations fragment in GQL returns different response each time. This results in a behaviour where recommendation component in UI sometimes appear and disappear
as user interacts with the page.

Further observations were:
1) User clicks on a page. It may causes a change in url. this results in the refetch of Nav4ProjectsContent fragment to keep projects recent section up-to-date.
As part of this refetch, growthRecommendations is also refetched as it is part of the same fragment.

2) On each refetch, backend returns different entity ids for recommendations.
3) As a result, It causes the behavior where a recommendation appears and then disappears on different user interactions.

In order to solve it, a below cache is implemented. The purpose of which is to cache the first response and then use it to render the recommendations component which will also be wrapped
in a memo to avoid further re-renders.
*/ const $852463353975ad42$var$cache = {
    growthRecommendations: []
};
function $852463353975ad42$export$69b3eee550308510({ queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $3ztLf.default), queryRef);
    const canCreateProject = data?.jira?.canCreateProject ?? false;
    const recommendations = (0, $eJOHy.useMemo)(()=>{
        const appRecommendations = data?.growthRecommendations?.recommendations?.data?.map((item)=>item.entityId).filter(Boolean) ?? [];
        if ($852463353975ad42$var$cache.growthRecommendations.length === 0 && appRecommendations.length > 0) // eslint-disable-next-line react-hooks/react-compiler
        $852463353975ad42$var$cache.growthRecommendations = appRecommendations;
        /*
    	if user has no permission for creating a project, then we want early return to performance benefit.
    	This is because, currently there are only one recommendations 1) JPD Recommendation
    	Which requires create project permission before user can be considered eligible
    */ return Boolean(canCreateProject) && $852463353975ad42$var$cache.growthRecommendations.length > 0 && (0, $7jTnu.fg)('blu-3929-sidebar-menu-recommended') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6qOE4.Recommendations), {
            appRecommendations: $852463353975ad42$var$cache.growthRecommendations
        }) : null;
    }, [
        canCreateProject,
        data
    ]);
    return recommendations;
}

});
parcelRegister("3ztLf", function(module, exports) {

$parcel$export(module.exports, "default", () => $261ce9a29ca103c6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<023ac434f8b5307ab82de3d83e0915ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $261ce9a29ca103c6$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4RecommendationsOld",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "alias": "canCreateProject",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Literal",
                                            "name": "product",
                                            "value": "jira"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "tenantId",
                                            "variableName": "cloudId"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "useCase",
                                            "value": "jiraProjectMenuRecommendations"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "context"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 2
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "entityId"
                                                        }
                                                    ],
                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$261ce9a29ca103c6$var$node.hash = "17bec39a2107f352a24536084815accc";
var $261ce9a29ca103c6$export$2e2bcd8739ae039 = $261ce9a29ca103c6$var$node;

});

parcelRegister("6qOE4", function(module, exports) {

$parcel$export(module.exports, "Recommendations", () => $fd064e8a228e9597$export$ebd86fc7badb9a5d);

var $eJOHy = parcelRequire("eJOHy");

var $2y3Ci = parcelRequire("2y3Ci");
var $ilbtc = parcelRequire("ilbtc");
var $1swHh = parcelRequire("1swHh");
var $jLuq7 = parcelRequire("jLuq7");

var $lRq8t = parcelRequire("lRq8t");

var $4ViLY = parcelRequire("4ViLY");

var $jC4hB = parcelRequire("jC4hB");

var $8UGYZ = parcelRequire("8UGYZ");
const $fd064e8a228e9597$export$ebd86fc7badb9a5d = ({ appRecommendations: appRecommendations })=>{
    const [isDismissed, setIsDismissed] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selectedRecommendationState = (0, $4ViLY.useSelectedRecommendation)({
        appRecommendations: appRecommendations
    });
    const onDismissRecommendation = (0, $eJOHy.useCallback)(()=>{
        setIsDismissed(true);
    }, []);
    if (!selectedRecommendationState?.recommendationKey) return null;
    const selectedRecommendation = (0, $8UGYZ.recommendationsList).find((recommendation)=>recommendation.key === selectedRecommendationState.recommendationKey);
    return selectedRecommendation && !isDismissed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLuq7.MenuSectionHeading), null, formatMessage((0, $jC4hB.default).sectionTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(selectedRecommendation.Component, {
        recommendationKey: selectedRecommendation.key,
        dismissRecommendation: onDismissRecommendation
    })))));
};

});
parcelRegister("4ViLY", function(module, exports) {

$parcel$export(module.exports, "useSelectedRecommendation", () => $e4b27151a084729d$export$6a60b75e3f5ce2aa);
// import shuffle from 'lodash/shuffle';

var $eJOHy = parcelRequire("eJOHy");

var $f1Zdy = parcelRequire("f1Zdy");

var $8UGYZ = parcelRequire("8UGYZ");

var $83AMS = parcelRequire("83AMS");
const $e4b27151a084729d$export$6a60b75e3f5ce2aa = ({ appRecommendations: appRecommendations })=>{
    const recommendationContext = (0, $83AMS.useRecommendationContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    // NOTE: having shufle here will cause different order of data on SSR and client resulting in a UI change after first render
    // which may not seem like a good UX
    // const shuffledRecommendations = shuffle(recommendations);
    /* 	useMemo here prevents running this code each time user navigates a different route which triggers
		re-render of projects which then re-renders Recommendations component.
		memoisation also prevents sending operational analytics on each re-render
	*/ const recommendationStatus = (0, $eJOHy.useMemo)(()=>(0, $8UGYZ.recommendationsList).map((recommendation)=>{
            if (!recommendationContext) return {
                key: recommendation.key,
                isEnabled: false
            };
            const isEnabled = recommendation.shouldRender(recommendationContext, createAnalyticsEvent({}), appRecommendations);
            return {
                key: recommendation.key,
                isEnabled: isEnabled
            };
        }), [
        appRecommendations,
        createAnalyticsEvent,
        recommendationContext
    ]);
    if (!recommendationContext) return {
        recommendationKey: null
    };
    const selectedRecommendation = recommendationStatus.find((result)=>result.isEnabled);
    return {
        recommendationKey: selectedRecommendation?.key || null
    };
};

});
parcelRegister("8UGYZ", function(module, exports) {

$parcel$export(module.exports, "recommendationsList", () => $f089b324e4d1757e$export$2ff783c2bb2ac3b1);

var $61zru = parcelRequire("61zru");
const $f089b324e4d1757e$var$createRecommendationsList = ()=>{
    const recommendationsList = [];
    recommendationsList.push((0, $61zru.jpdRecommendation));
    // Add your own templates
    return recommendationsList;
};
const $f089b324e4d1757e$export$2ff783c2bb2ac3b1 = $f089b324e4d1757e$var$createRecommendationsList();

});
parcelRegister("61zru", function(module, exports) {

$parcel$export(module.exports, "jpdRecommendation", () => $2b389bdc8044134d$export$f0837513113a320d);

var $eJOHy = parcelRequire("eJOHy");

var $73iKQ = parcelRequire("73iKQ");

var $givfd = parcelRequire("givfd");
var $lbX5P = parcelRequire("lbX5P");

var $dKpTa = parcelRequire("dKpTa");

var $6alcT = parcelRequire("6alcT");

var $h8epd = parcelRequire("h8epd");

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");







var $i0tMD = parcelRequire("i0tMD");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $8q7lT = parcelRequire("8q7lT");

var $g1NZW = parcelRequire("g1NZW");

var $1q7fs = parcelRequire("1q7fs");

var $7jTnu = parcelRequire("7jTnu");

var $a9ldn = parcelRequire("a9ldn");

var $bO0cE = parcelRequire("bO0cE");


var $h1sdf = parcelRequire("h1sdf");

var $9WdeT = parcelRequire("9WdeT");

var $gj96A = parcelRequire("gj96A");

var $8RtfX = parcelRequire("8RtfX");
const $2b389bdc8044134d$export$da956fe610b96f73 = ({ recommendationKey: recommendationKey, dismissRecommendation: dismissRecommendation })=>{
    const reasonsModalBulletTwoAppify = (0, $7jTnu.fg)('product-terminology-refresh') ? (0, $9WdeT.default).reasonsModalBulletTwoAppify : (0, $9WdeT.default).reasonsModalBulletTwo;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const crossFlow = (0, $givfd.useCrossFlow)();
    const accountId = (0, $8q7lT.useAccountId)();
    const environment = (0, $g1NZW.useEnvironment)();
    const jpdCloudCCPProductID = (0, $h1sdf.getProductTypeCcpReferenceIdMapForEnv)(environment).PRODUCT_DISCOVERY;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $1q7fs.useFireCrossFlowAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (crossFlow.isEnabled) fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'projectsMenu'
        }, {
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            source: 'projectsMenuSection'
        }, {
            navigationVersion: 'v4',
            projectKey: (0, $h1sdf.JPD_ROADMAP_KEY)
        });
        else (0, $gYnSx.default)({
            error: new Error(crossFlow.reason),
            meta: {
                id: crossFlow.reason,
                packageName: 'jiraAtlassianNavigationRecommendations'
            }
        });
    }, [
        createAnalyticsEvent,
        crossFlow,
        fireViewedUIEvent,
        jpdCloudCCPProductID
    ]);
    const jpdRecommendationContent = (0, $eJOHy.useMemo)(()=>{
        return {
            projectTitle: (0, $9WdeT.default).projectTitleProductRoadmap,
            projectKey: (0, $h1sdf.JPD_ROADMAP_KEY),
            projectAvatar: (0, $8RtfX.default)
        };
    }, []);
    const onLearnMoreClicked = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367),
            action: 'clicked'
        }), (0, $16a7021d28f78da7$export$8d155d2412839524), {
            level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
            componentType: (0, $493796f3bdee881c$export$56981f28056f258e),
            parentItemType: (0, $6bf6536f83c22cfe$export$9a778ca616c24a93),
            parentItemId: (0, $bc40578f06d7846b$export$de9ad1ebeca97ec1),
            itemId: (0, $bc40578f06d7846b$export$ce0bea1467165424),
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v4'
        });
    }, [
        createAnalyticsEvent,
        fireInteractedUIEvent,
        jpdCloudCCPProductID
    ]);
    const onDismissClicked = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367),
            action: 'clicked'
        }), (0, $16a7021d28f78da7$export$8d155d2412839524), {
            level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18),
            componentType: (0, $493796f3bdee881c$export$56981f28056f258e),
            parentItemType: (0, $6bf6536f83c22cfe$export$9a778ca616c24a93),
            parentItemId: (0, $bc40578f06d7846b$export$de9ad1ebeca97ec1),
            itemId: (0, $bc40578f06d7846b$export$5c09fa42f8d45ed8),
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'dismissRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v4'
        });
        dismissRecommendation();
        if (accountId) (0, $FppkK.setUserProperties)(accountId, (0, $h1sdf.JPD_RECOMMENDATION_DISMISS_USER_PROPERTY), 'true').catch((error)=>{
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'dismissJpdRecommendation',
                    packageName: (0, $f9370b6235f53e1a$export$b8b9d90f9e5bd72b),
                    teamName: 'navigation'
                }
            });
        });
    }, [
        accountId,
        createAnalyticsEvent,
        dismissRecommendation,
        fireInteractedUIEvent,
        jpdCloudCCPProductID
    ]);
    const openCrossFlow = (0, $eJOHy.useCallback)(async (templateId)=>{
        const extensions = (0, $73iKQ.createProvisioningPageExtensions)({
            actions: {
                primary: {
                    behaviour: (0, $73iKQ.Behaviours).LAND,
                    prompt: (0, $73iKQ.Prompts).NEXT,
                    options: {
                        targetTab: (0, $73iKQ.TargetTabs).SAME,
                        urlParams: {
                            templateId: templateId
                        }
                    }
                }
            }
        });
        if (crossFlow.isEnabled) // eslint-disable-next-line @atlassian/growth/no-deprecated-apis
        crossFlow.api.open({
            journey: (0, $givfd.Journeys).GET_STARTED,
            targetProduct: (0, $lbX5P.Targets).JIRA_PRODUCT_DISCOVERY,
            sourceComponent: 'projectsMenu',
            sourceContext: 'tryThisRecommendation',
            extensions: extensions
        });
    }, [
        crossFlow
    ]);
    const onRecommendationClicked = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
            action: 'clicked'
        }), (0, $16a7021d28f78da7$export$8d155d2412839524), {
            level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            itemType: (0, $6bf6536f83c22cfe$export$9a778ca616c24a93),
            itemId: (0, $bc40578f06d7846b$export$de9ad1ebeca97ec1),
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryThisRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v4'
        });
        openCrossFlow(jpdRecommendationContent.projectKey);
    }, [
        createAnalyticsEvent,
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        jpdRecommendationContent.projectKey,
        openCrossFlow
    ]);
    const recommendationActionMenuClickHandler = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), (0, $16a7021d28f78da7$export$8d155d2412839524), {
            level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
            componentType: (0, $493796f3bdee881c$export$9bd6c21d500ae611),
            parentItemType: (0, $6bf6536f83c22cfe$export$9a778ca616c24a93),
            parentItemId: (0, $bc40578f06d7846b$export$de9ad1ebeca97ec1),
            itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e)
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(jpdRecommendationContent.projectAvatar, null),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
            appearance: "new",
            isBold: false
        }, formatMessage((0, $9WdeT.default).lozengeText)),
        href: "",
        menuId: recommendationKey,
        onClick: onRecommendationClicked,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bO0cE.RecommendationActionMenu), {
            onClick: recommendationActionMenuClickHandler,
            onLearnMoreClicked: onLearnMoreClicked,
            onDismissClicked: onDismissClicked,
            primaryCta: formatMessage((0, $9WdeT.default).reasonsModalButtonOk),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $9WdeT.default).reasonsModalExplanation, {
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
                        as: "strong"
                    }, chunks)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", null, formatMessage((0, $9WdeT.default).reasonsModalBulletOneSpork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", null, formatMessage(reasonsModalBulletTwoAppify))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
                appearance: "link",
                spacing: "none",
                href: (0, $f9370b6235f53e1a$export$aefe1c8741b24a28),
                target: "_blank"
            }, formatMessage((0, $9WdeT.default).privacyPolicy))),
            title: formatMessage((0, $9WdeT.default).reasonsModalTitle)
        })
    }, formatMessage(jpdRecommendationContent.projectTitle)));
};
const $2b389bdc8044134d$var$checkEligibility = (recommendationContext, appRecommendations)=>{
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled, licensedProducts: licensedProducts, accountId: accountId, edition: edition, jsmEdition: jsmEdition, coreEdition: coreEdition, customerServiceEdition: customerServiceEdition, jpdRecommendationDismissed: jpdRecommendationDismissed } = recommendationContext;
    if ((0, $7jTnu.fg)('grw-1467_jpd_reco_eligibility_override_gate')) return {
        isEligible: true,
        reason: 'Eligibility override gate is enabled'
    };
    if (!accountId) return {
        isEligible: false,
        reason: 'Account Id is null'
    };
    if (!areProductSuggestionsEnabled) return {
        isEligible: false,
        reason: 'Product suggestions are disabled'
    };
    if ((0, $gj96A.hasJpdLicense)(licensedProducts)) return {
        isEligible: false,
        reason: 'Instance has JPD license'
    };
    if (jpdRecommendationDismissed) return {
        isEligible: false,
        reason: 'JPD recommendation dismissed'
    };
    if (!appRecommendations?.some((entityId)=>entityId === (0, $h1sdf.JPD_ENTITY_ID))) return {
        isEligible: false,
        reason: 'JPD was not in the recommend apps'
    };
    const hasStandardOrPremiumEditions = [
        edition ?? (0, $a9ldn.UNLICENSED),
        jsmEdition ?? (0, $a9ldn.UNLICENSED),
        coreEdition ?? (0, $a9ldn.UNLICENSED),
        customerServiceEdition ?? (0, $a9ldn.UNLICENSED)
    ].some((ed)=>ed === (0, $a9ldn.STANDARD_EDITION) || ed === (0, $a9ldn.PREMIUM_EDITION));
    if (hasStandardOrPremiumEditions && !(0, $7jTnu.fg)('grw-997_-_jpd_recommendation_nav_4_paid_users')) return {
        isEligible: false,
        reason: 'User has paid edition but failed grw-997_-_jpd_recommendation_nav_4_paid_users gate'
    };
    return {
        isEligible: true,
        reason: 'Pass all checks'
    };
};
const $2b389bdc8044134d$export$f0837513113a320d = {
    key: (0, $h1sdf.JPD_RECOMMENDATION_KEY),
    shouldRender: (recommendationContext, analyticsEvent, appRecommendations)=>{
        const { isEligible: isEligible, reason: reason } = $2b389bdc8044134d$var$checkEligibility(recommendationContext, appRecommendations);
        if ((0, $7jTnu.fg)('pm_jpd_reco_operational_event_activated')) (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.loadJpdRecommendation succeeded', {
            reason: reason,
            isEligible: isEligible
        });
        return isEligible;
    },
    Component: $2b389bdc8044134d$export$da956fe610b96f73
};

});
parcelRegister("g1NZW", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $11c20b02a2daf18d$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $11c20b02a2daf18d$export$b0d8f74f433a09c9);

var $lvKO5 = parcelRequire("lvKO5");
const $11c20b02a2daf18d$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $11c20b02a2daf18d$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext?.environment || $11c20b02a2daf18d$var$ENVIRONMENT.PROD;
};
const $11c20b02a2daf18d$export$b0d8f74f433a09c9 = ()=>{
    const env = $11c20b02a2daf18d$export$ea7ed2425832167d();
    return env === $11c20b02a2daf18d$var$ENVIRONMENT.STAGING || env === $11c20b02a2daf18d$var$ENVIRONMENT.DEV || env === $11c20b02a2daf18d$var$ENVIRONMENT.LOCAL;
};

});

parcelRegister("bO0cE", function(module, exports) {

$parcel$export(module.exports, "RecommendationActionMenu", () => $b977177bf32101c2$export$ff27431731859712);

var $eJOHy = parcelRequire("eJOHy");

var $4poV0 = parcelRequire("4poV0");

var $apGPk = parcelRequire("apGPk");
var $MlWTN = parcelRequire("MlWTN");
var $7R1al = parcelRequire("7R1al");

var $9JB3T = parcelRequire("9JB3T");

var $lRq8t = parcelRequire("lRq8t");

var $f7Yza = parcelRequire("f7Yza");

var $dFdj2 = parcelRequire("dFdj2");

var $i0Ev8 = parcelRequire("i0Ev8");

var $g3C06 = parcelRequire("g3C06");

var $cJEMq = parcelRequire("cJEMq");

var $6XJko = parcelRequire("6XJko");

var $7WFmW = parcelRequire("7WFmW");
const $b977177bf32101c2$var$MENU_TEST_ID = 'recommendations-common.ui.recommendation-popup-menu.menu-group';
const $b977177bf32101c2$var$CustomTrigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isVisualRefresh = (0, $6XJko.isVisualRefreshEnabled)();
    if (isVisualRefresh) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        hideTooltipOnClick: true,
        content: formatMessage((0, $7WFmW.default).moreActions),
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJEMq.ThemedButton), {
        ...props,
        ref: ref,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4poV0))), {
            label: formatMessage((0, $7WFmW.default).moreActions),
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "navigation-apps-sidebar-nav4-sidebars-content-growth-recommendations.common.ui.recommendation-action-menu.themed-button"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJEMq.ThemedButton), {
        ...props,
        ref: ref,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4poV0))), {
            label: formatMessage((0, $7WFmW.default).moreActions),
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "navigation-apps-sidebar-nav4-sidebars-content-growth-recommendations.common.ui.recommendation-action-menu.themed-button"
    }));
});
const $b977177bf32101c2$var$LearnMoreTrigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onLearnMoreClicked: onLearnMoreClicked }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apGPk.default), {
        ref: ref,
        onClick: onLearnMoreClicked
    }, formatMessage((0, $7WFmW.default).whyAmISeeingThis));
});
const $b977177bf32101c2$export$ff27431731859712 = ({ onClick: onClick, onLearnMoreClicked: onLearnMoreClicked, onDismissClicked: onDismissClicked, body: body, primaryCta: primaryCta, title: title })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            body: body,
            primaryCta: primaryCta,
            title: title
        }), [
        body,
        primaryCta,
        title
    ]);
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: 400,
            height: 440
        }), []);
    const MenuItems = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), {
            testId: $b977177bf32101c2$var$MENU_TEST_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
            isList: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apGPk.default), {
            onClick: ()=>onDismissClicked()
        }, formatMessage((0, $7WFmW.default).dismissButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
            entryPoint: (0, $dFdj2.GrowthRecommendationsEntrypoint),
            entryPointProps: entryPointParams,
            modalProps: modalProps,
            useInternalModal: false
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b977177bf32101c2$var$LearnMoreTrigger, {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ref: ref,
                onLearnMoreClicked: onLearnMoreClicked
            })))), [
        entryPointParams,
        formatMessage,
        modalProps,
        onDismissClicked,
        onLearnMoreClicked
    ]);
    const content = (contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g3C06.MenuContent), {
            ...contentProps,
            MenuItems: MenuItems
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0Ev8.MenuContainer), {
        content: content,
        onClick: onClick,
        CustomTrigger: $b977177bf32101c2$var$CustomTrigger
    });
};

});
parcelRegister("dFdj2", function(module, exports) {

$parcel$export(module.exports, "GrowthRecommendationsEntrypoint", () => $8809b280bf872a7b$export$f926c2f51211d688);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $8809b280bf872a7b$export$f926c2f51211d688 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("7ILMi")).then(({ GrowthRecommendationModal: GrowthRecommendationModal })=>GrowthRecommendationModal), {
        moduleId: "356e09a2",
        moduleName: "GrowthRecommendationModal",
        priority: "interaction"
    }),
    getPreloadProps: (props)=>({
            queries: {},
            props: props
        })
});

});
parcelRegister("7ILMi", function(module, exports) {

let $59f1b42b23431063$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $59f1b42b23431063$var$load("Urhra").then(()=>parcelRequire('wiDoP'));

});


parcelRegister("i0Ev8", function(module, exports) {

$parcel$export(module.exports, "MenuContainer", () => $3a1ab3ba3bb2ee1c$export$b286f91cddfedb5a);

var $eJOHy = parcelRequire("eJOHy");

var $6zXPf = parcelRequire("6zXPf");

var $he6m3 = parcelRequire("he6m3");

var $hih5V = parcelRequire("hih5V");

var $cNe2t = parcelRequire("cNe2t");

var $7jTnu = parcelRequire("7jTnu");

var $6Vosf = parcelRequire("6Vosf");
const $3a1ab3ba3bb2ee1c$export$b286f91cddfedb5a = ({ content: content, CustomTrigger: CustomTrigger, onClick: onClick, onClose: onCloseCustom, buttonTriggerRef: buttonTriggerRef, shouldRenderToParent: shouldRenderToParent = true, projectName: projectName })=>{
    const { isOpen: isOpen, onClose: onClose, onToggle: onToggle } = (0, $he6m3.useOpenable)();
    const route = (0, $hih5V.useCurrentRoute)();
    const handleClose = (0, $eJOHy.useCallback)((e)=>{
        try {
            onCloseCustom?.(e);
        } finally{
            onClose();
        }
    }, [
        onCloseCustom,
        onClose
    ]);
    const onClickHandler = (0, $eJOHy.useCallback)(()=>{
        onToggle();
        onClick?.();
    }, [
        onClick,
        onToggle
    ]);
    const trigger = (triggerProps)=>{
        const { ref: ref, ...restTriggerProps } = triggerProps;
        return CustomTrigger ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CustomTrigger, {
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Vosf.MenuTriggerButton), {
            ...(0, $7jTnu.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
                name: projectName
            } : {},
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        content: content,
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-start",
        messageId: "navigation-project-action-menu.ui.menu-container.popup",
        messageType: "transactional",
        trigger: trigger,
        shouldRenderToParent: // eslint-disable-next-line no-nested-ternary
        (0, $6zXPf.getWillShowNav4)() ? route.name.includes('legacy') ? false : shouldRenderToParent : true,
        strategy: (0, $6zXPf.getWillShowNav4)() ? 'absolute' : 'fixed'
    });
};

});
parcelRegister("6Vosf", function(module, exports) {

$parcel$export(module.exports, "MenuTriggerButton", () => $dda383502f47ef3e$export$a24e6f6ddd974e33);

var $eJOHy = parcelRequire("eJOHy");

var $4poV0 = parcelRequire("4poV0");

var $4BzUI = parcelRequire("4BzUI");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

var $c5ZPx = parcelRequire("c5ZPx");
const $dda383502f47ef3e$export$a24e6f6ddd974e33 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, name: name, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BzUI.default), {
        ...props,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4poV0))), {
                ...iconProps,
                color: "var(--ds-icon, #44546F)",
                size: "small"
            }),
        label: (0, $7jTnu.fg)('jsm_aiiy_for_nav_item_sidebar') ? formatMessage((0, $c5ZPx.default).projectActionsMenuName, {
            name: name
        }) : formatMessage((0, $c5ZPx.default).projectActionsMenu),
        onClick: onClick,
        ref: ref,
        spacing: "compact",
        appearance: "subtle",
        testId: "navigation-project-action-menu.ui.menu-container.themed-button",
        ...(0, $6XJko.isVisualRefreshEnabled)() ? {
            isTooltipDisabled: false,
            tooltip: {
                content: formatMessage((0, $c5ZPx.default).projectActionsMenu),
                hideTooltipOnClick: true
            }
        } : {}
    });
});

});
parcelRegister("c5ZPx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c00dd7908288fb54$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c00dd7908288fb54$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projectActionsMenu: {
        "id": "navigation-project-action-menu.menu-container.project-actions-menu",
        "defaultMessage": "More actions"
    },
    projectActionsMenuName: {
        "id": "navigation-project-action-menu.menu-container.project-actions-menu-name",
        "defaultMessage": "More actions for {name}"
    }
});

});



parcelRegister("g3C06", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $d0ffa4011c91f6be$export$479f0f2f71193efe);

var $eJOHy = parcelRequire("eJOHy");

var $MlWTN = parcelRequire("MlWTN");

var $dhRXV = parcelRequire("dhRXV");

var $5Q9JR = parcelRequire("5Q9JR");
const $d0ffa4011c91f6be$var$stopEventPropagation = (event)=>event.stopPropagation();
const $d0ffa4011c91f6be$export$479f0f2f71193efe = ({ MenuItems: MenuItems, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        onMouseEnter: $d0ffa4011c91f6be$var$stopEventPropagation,
        onMouseLeave: $d0ffa4011c91f6be$var$stopEventPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), {
        minWidth: (0, $5Q9JR.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MenuItems, {
        onClose: onClose
    })));

});

parcelRegister("cJEMq", function(module, exports) {

$parcel$export(module.exports, "ThemedButton", () => $a37d1ebc6d556273$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $OgPfS = parcelRequire("OgPfS");
const $a37d1ebc6d556273$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a37d1ebc6d556273$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a37d1ebc6d556273$var$CustomButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $OgPfS.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7WFmW", function(module, exports) {

$parcel$export(module.exports, "default", () => $732fd70691af7f1b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $732fd70691af7f1b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    whyAmISeeingThis: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.why-am-i-seeing-this",
        "defaultMessage": "Why am I seeing this?"
    },
    moreActions: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.more-actions",
        "defaultMessage": "More actions"
    },
    dismissButtonText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.dismiss-button-text",
        "defaultMessage": "Not interested"
    },
    reasonsModalTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOneSpork: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
        "defaultMessage": "the tools you use (Jira)"
    },
    reasonsModalBulletTwo: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
        "defaultMessage": "the way you use your existing tools and products"
    },
    privacyPolicy: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    reasonsModalButtonOk: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
        "defaultMessage": "Ok"
    }
});

});


parcelRegister("h1sdf", function(module, exports) {

$parcel$export(module.exports, "JPD_RECOMMENDATION_KEY", () => $d777c06b0a0e69ef$export$3e6ff24c4f517c4f);
$parcel$export(module.exports, "JPD_ROADMAP_KEY", () => $d777c06b0a0e69ef$export$c11145b8eb60b18b);
$parcel$export(module.exports, "JPD_RECOMMENDATION_DISMISS_USER_PROPERTY", () => $d777c06b0a0e69ef$export$52b9dedc0088f8);
$parcel$export(module.exports, "JPD_ENTITY_ID", () => $d777c06b0a0e69ef$export$909712ccf16883d);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $d777c06b0a0e69ef$export$29629758934356a6);

var $jaw0k = parcelRequire("jaw0k");
const $d777c06b0a0e69ef$export$3e6ff24c4f517c4f = 'jpd-recommendation';
const $d777c06b0a0e69ef$export$a9c4e38d8a74acd2 = 'jpd.product-discovery';
const $d777c06b0a0e69ef$export$c11145b8eb60b18b = 'jpd.product-roadmap';
const $d777c06b0a0e69ef$export$52b9dedc0088f8 = 'JpdRecommendationDismissed';
const $d777c06b0a0e69ef$export$909712ccf16883d = 'jira.polaris:discovery';
const $d777c06b0a0e69ef$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $jaw0k.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $jaw0k.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $jaw0k.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $jaw0k.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("9WdeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd08661f82921fe$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9fd08661f82921fe$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projectTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title",
        "defaultMessage": "New discovery project"
    },
    projectTitleProductRoadmap: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title-product-roadmap",
        "defaultMessage": "Create a roadmap"
    },
    lozengeText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.lozenge-text",
        "defaultMessage": "try"
    },
    reasonsModalTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOneSpork: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
        "defaultMessage": "the tools you use (Jira)"
    },
    reasonsModalBulletTwo: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
        "defaultMessage": "the way you use your existing tools and products"
    },
    privacyPolicy: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    reasonsModalButtonOk: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
        "defaultMessage": "Ok"
    },
    reasonsModalBulletTwoAppify: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two-appify",
        "defaultMessage": "the way you use your existing tools and apps"
    }
});

});

parcelRegister("gj96A", function(module, exports) {

$parcel$export(module.exports, "hasJpdLicense", () => $926e07c6e6e2bfbd$export$2ea69a0925803655);
const $926e07c6e6e2bfbd$export$2ea69a0925803655 = (licensedProducts)=>licensedProducts['jira-product-discovery'] === true;

});

parcelRegister("8RtfX", function(module, exports) {

$parcel$export(module.exports, "default", () => $713e113ae3c5e3c6$export$2e2bcd8739ae039);
/* product-roadmap-project-avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6q0fu = parcelRequire("6q0fu");

var $4aR29 = parcelRequire("4aR29");
const $713e113ae3c5e3c6$var$ProductRoadmapProjectAvatar = ()=>{
    return /*#__PURE__*/ $eJOHy.createElement((0, $6q0fu.default), {
        appearance: "square",
        borderColor: "transparent",
        size: "small",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4aR29)))
    });
};
var $713e113ae3c5e3c6$export$2e2bcd8739ae039 = $713e113ae3c5e3c6$var$ProductRoadmapProjectAvatar;

});
parcelRegister("4aR29", function(module, exports) {
module.exports = new URL("template-roadmap-icon.72864c5e.svg", import.meta.url).toString();

});




parcelRegister("83AMS", function(module, exports) {

$parcel$export(module.exports, "useRecommendationContext", () => $0fabb5ff905086b8$export$3321c0b02f750bcc);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2emAF = parcelRequire("2emAF");

var $bvwBX = parcelRequire("bvwBX");

var $68g4a = parcelRequire("68g4a");

var $8q7lT = parcelRequire("8q7lT");

var $8vyDv = parcelRequire("8vyDv");

var $2cfd4 = parcelRequire("2cfd4");

var $lvKO5 = parcelRequire("lvKO5");

var $eJrcF = parcelRequire("eJrcF");

var $5L7qx = parcelRequire("5L7qx");

var $7jTnu = parcelRequire("7jTnu");

var $6zXPf = parcelRequire("6zXPf");

var $fAZgY = parcelRequire("fAZgY");
const $0fabb5ff905086b8$export$3321c0b02f750bcc = ()=>{
    const locale = (0, $2cfd4.useLocale)();
    const accountId = (0, $8q7lT.useAccountId)();
    const { cloudId: cloudId, licensedProducts: licensedProducts, firstActivationDateMs: firstActivationDateMs, areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $lvKO5.useTenantContext)();
    const { software: edition, serviceDesk: jsmEdition, customerService: customerServiceEdition, core: coreEdition } = (0, $8vyDv.useAppEditions)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const jpdRecommendationDismissedResourceData = (0, $eJrcF.useResource)((0, $68g4a.jpdRecommendationDismissedResource));
    const jpdRecommendationDismissed = jpdRecommendationDismissedResourceData?.data?.hasDismissed ?? false;
    const userTraitsResource = (0, $fAZgY.useMemoWithCondition)(()=>(0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('blu-3929-sidebar-menu-recommended'), (0, $bvwBX.fetchUserTraitsResource)), [], ()=>(0, $7jTnu.fg)('jfp-magma-concurrent-nav4-1'));
    const { data: userTraitsData } = (0, $eJrcF.useResource)(userTraitsResource);
    const siteTraitsResource = (0, $fAZgY.useMemoWithCondition)(()=>(0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('blu-3929-sidebar-menu-recommended'), (0, $2emAF.fetchSiteTraitsResource)), [], ()=>(0, $7jTnu.fg)('jfp-magma-concurrent-nav4-1'));
    const { data: siteTraitsData } = (0, $eJrcF.useResource)(siteTraitsResource);
    return (0, $eJOHy.useMemo)(()=>({
            locale: locale,
            cloudId: cloudId,
            accountId: accountId,
            licensedProducts: licensedProducts,
            edition: edition,
            jsmEdition: jsmEdition,
            coreEdition: coreEdition,
            customerServiceEdition: customerServiceEdition,
            firstActivationDateMs: firstActivationDateMs,
            areProductSuggestionsEnabled: areProductSuggestionsEnabled,
            environment: environment,
            jpdRecommendationDismissed: jpdRecommendationDismissed,
            userTraitsData: userTraitsData,
            siteTraitsData: siteTraitsData
        }), [
        locale,
        cloudId,
        accountId,
        licensedProducts,
        edition,
        jsmEdition,
        coreEdition,
        customerServiceEdition,
        firstActivationDateMs,
        areProductSuggestionsEnabled,
        environment,
        jpdRecommendationDismissed,
        userTraitsData,
        siteTraitsData
    ]);
};

});


parcelRegister("jC4hB", function(module, exports) {

$parcel$export(module.exports, "default", () => $5758fb1ef965254d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5758fb1ef965254d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    sectionTitle: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-growth-recommendations.section-title",
        "defaultMessage": "Recommended"
    }
});

});



parcelRegister("4NICj", function(module, exports) {

$parcel$export(module.exports, "Nav4Recommendations", () => $d8d6394c34d5997c$export$dfe7a31b75b5edeb);

var $fX4ye = parcelRequire("fX4ye");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $fX4ye = parcelRequire("fX4ye");

var $bgyM1 = parcelRequire("bgyM1");

var $kEUB1 = parcelRequire("kEUB1");

var $8q7lT = parcelRequire("8q7lT");

var $6qOE4 = parcelRequire("6qOE4");
/*
At the moment, growthRecommendations fragment in GQL returns different response each time. This results in a behaviour where recommendation component in UI sometimes appear and disappear
as user interacts with the page.

Further observations were:
1) User clicks on a page. It may causes a change in url. this results in the refetch of Nav4ProjectsContent fragment to keep projects recent section up-to-date.
As part of this refetch, growthRecommendations is also refetched as it is part of the same fragment.

2) On each refetch, backend returns different entity ids for recommendations.
3) As a result, It causes the behavior where a recommendation appears and then disappears on different user interactions.

In order to solve it, a below cache is implemented. The purpose of which is to cache the first response and then use it to render the recommendations component which will also be wrapped
in a memo to avoid further re-renders.
*/ const $d8d6394c34d5997c$var$cache = {
    growthRecommendations: []
};
function $d8d6394c34d5997c$export$dfe7a31b75b5edeb() {
    const [queryRef, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $fX4ye.default));
    const cloudId = (0, $kEUB1.useCloudId)();
    const userId = (0, $8q7lT.useAccountId)();
    (0, $eJOHy.useEffect)(()=>{
        if (cloudId) loadQuery({
            cloudId: cloudId
        });
    }, [
        cloudId,
        loadQuery
    ]);
    if (!queryRef) return null;
    if (!(0, $7jTnu.fg)('optout_all_messages_grw-1467')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d8d6394c34d5997c$var$Nav4RecommendationsInner, {
        queryRef: queryRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bgyM1.default), {
        touchpointId: "grw-1467-jpd-recommendation-nav4",
        cloudId: cloudId,
        userId: userId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d8d6394c34d5997c$var$Nav4RecommendationsInner, {
        queryRef: queryRef
    }));
}
const $d8d6394c34d5997c$var$Nav4RecommendationsInner = ({ queryRef: queryRef })=>{
    const data = (0, $j4oe4.usePreloadedQuery)((0, $fX4ye.default), queryRef);
    const canCreateProject = data?.jira?.canCreateProject ?? false;
    const recommendations = (0, $eJOHy.useMemo)(()=>{
        const appRecommendations = data?.growthRecommendations?.recommendations?.data?.map((item)=>item.entityId).filter(Boolean) ?? [];
        if ($d8d6394c34d5997c$var$cache.growthRecommendations.length === 0 && appRecommendations.length > 0) // eslint-disable-next-line react-hooks/react-compiler
        $d8d6394c34d5997c$var$cache.growthRecommendations = appRecommendations;
        /*
    	if user has no permission for creating a project, then we want early return to performance benefit.
    	This is because, currently there are only one recommendations 1) JPD Recommendation
    	Which requires create project permission before user can be considered eligible
    */ return Boolean(canCreateProject) && $d8d6394c34d5997c$var$cache.growthRecommendations.length > 0 && (0, $7jTnu.fg)('blu-3929-sidebar-menu-recommended') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6qOE4.Recommendations), {
            appRecommendations: $d8d6394c34d5997c$var$cache.growthRecommendations
        }) : null;
    }, [
        canCreateProject,
        data
    ]);
    return recommendations;
};

});
parcelRegister("fX4ye", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d8adea202607370$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fca34214df57e91bcc6b333185773418>>
 * @relayHash 60d19155b9cdae4e64b4f7c449f4752d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ae6071654511a4527a0abd92d665dfad5552a83d6d7c2b1c9bb45d8c1b6d8eb
const $3d8adea202607370$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "alias": "canCreateProject",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    },
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "CREATE_PROJECT"
                    }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ]
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "product",
                    "value": "jira"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Literal",
                    "name": "useCase",
                    "value": "jiraProjectMenuRecommendations"
                }
            ],
            "kind": "ObjectValue",
            "name": "context"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 2
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "entityId"
            }
        ],
        "type": "GrowthRecJiraTemplateRecommendation"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4RecommendationsQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4RecommendationsQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2ae6071654511a4527a0abd92d665dfad5552a83d6d7c2b1c9bb45d8c1b6d8eb",
            "metadata": {},
            "name": "Nav4RecommendationsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3d8adea202607370$var$node.hash = "37e580905a6bb12dfab4ae64833a88d6";
var $3d8adea202607370$export$2e2bcd8739ae039 = $3d8adea202607370$var$node;

});

parcelRegister("bgyM1", function(module, exports) {

$parcel$export(module.exports, "default", () => $10f7a5073c84e06f$export$2e2bcd8739ae039);

var $7Upta = parcelRequire("7Upta");
function $10f7a5073c84e06f$export$2e2bcd8739ae039({ touchpointId: touchpointId, cloudId: cloudId, userId: userId, children: children, fallback: fallback, options: options }) {
    const { optoutStatus: optoutStatus } = (0, $7Upta.useIsOptoutAllMessages)(touchpointId, cloudId, userId, options);
    if (options?.isDisabled) return children;
    if (optoutStatus !== 'no-opt-out') {
        if (fallback) {
            if (typeof fallback === 'function') return fallback({
                optoutStatus: optoutStatus
            });
            return fallback;
        }
        return null;
    }
    return children;
}

});



parcelRegister("4g876", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectMenuItem", () => $061bcf51dedf1b27$export$6a41b9c2eac627cc);

var $d7EDy = parcelRequire("d7EDy");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $ln6Iy = parcelRequire("ln6Iy");

var $1kUQ7 = parcelRequire("1kUQ7");

var $4lj4q = parcelRequire("4lj4q");

var $1v9jo = parcelRequire("1v9jo");

var $3VmU5 = parcelRequire("3VmU5");

var $3Nj6K = parcelRequire("3Nj6K");

var $1gN9e = parcelRequire("1gN9e");

var $286cZ = parcelRequire("286cZ");

var $kOdRG = parcelRequire("kOdRG");
const $061bcf51dedf1b27$export$6a41b9c2eac627cc = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'), ({ queryRef: queryRef, setProjectToRestore: setProjectToRestore, isCorePremiumUserSeat: isCorePremiumUserSeat = false, spotlight: spotlight })=>{
    const data = (0, $j4oe4.useFragment)((0, $d7EDy.default), queryRef);
    if (!data) return null;
    if (data.status === 'ARCHIVED') return null;
    const renderMenuItem = ()=>{
        if ((0, $7jTnu.fg)('jcs_project_type_m3')) switch(data.projectType){
            case 0, $ln6Iy.JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1v9jo.AsyncJsmProjectMenu), {
                    projectData: data,
                    spotlight: spotlight
                });
            case 0, $ln6Iy.JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VmU5.AsyncJcsProjectMenu), {
                    projectData: data,
                    spotlight: spotlight
                });
            case 0, $ln6Iy.JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4lj4q.AsyncJpdProjectMenu), {
                    projectData: data,
                    spotlight: spotlight
                });
            case 0, $ln6Iy.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Nj6K.JswProjectMenu), {
                    projectData: data,
                    spotlight: spotlight
                });
            case 0, $ln6Iy.JIRA_PROJECT_TYPE_CORE_PROJECT:
            default:
                // TODO: One day, we will call this JwmProjectMenu, and subsequently JiraProjectMenu (Spork!)
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1kUQ7.JiraBusinessProjectMenu), {
                    projectData: data,
                    isCorePremiumUserSeat: isCorePremiumUserSeat,
                    spotlight: spotlight
                });
        }
        switch(data.projectType){
            case 0, $ln6Iy.JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT:
            case 0, $ln6Iy.JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1v9jo.AsyncJsmProjectMenu), {
                    projectData: data,
                    spotlight: spotlight
                });
            case 0, $ln6Iy.JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4lj4q.AsyncJpdProjectMenu), {
                    projectData: data,
                    spotlight: spotlight
                });
            case 0, $ln6Iy.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Nj6K.JswProjectMenu), {
                    projectData: data,
                    spotlight: spotlight
                });
            case 0, $ln6Iy.JIRA_PROJECT_TYPE_CORE_PROJECT:
            default:
                // TODO: One day, we will call this JwmProjectMenu, and subsequently JiraProjectMenu (Spork!)
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1kUQ7.JiraBusinessProjectMenu), {
                    projectData: data,
                    isCorePremiumUserSeat: isCorePremiumUserSeat,
                    spotlight: spotlight
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1gN9e.ProjectRestoreContext).Provider, {
        value: setProjectToRestore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kOdRG.ContentWithDragAndDrop), null, renderMenuItem()));
});

});
parcelRegister("d7EDy", function(module, exports) {

$parcel$export(module.exports, "default", () => $930054dc6bd68cca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<82f72868142182d7bec84a3af22b9063>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $930054dc6bd68cca$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4ProjectMenuItem",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "status"
            },
            "action": "THROW",
            "path": "status"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraBusinessProjectMenu"
        },
        {
            "kind": "FragmentSpread",
            "name": "JsmProjectMenu"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JpdProjectMenu"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JpdProjectMenuOld"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "JswProjectMenu"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JcsProjectMenu"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$930054dc6bd68cca$var$node.hash = "e5d92308b1343c66a0448432cc4640b4";
var $930054dc6bd68cca$export$2e2bcd8739ae039 = $930054dc6bd68cca$var$node;

});

parcelRegister("1kUQ7", function(module, exports) {

$parcel$export(module.exports, "JiraBusinessProjectMenu", () => $097954739b6f31e0$export$6145b58afae943e6);

var $dw8e4 = parcelRequire("dw8e4");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7IJ7W = parcelRequire("7IJ7W");

var $2Of18 = parcelRequire("2Of18");

var $lHnXI = parcelRequire("lHnXI");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $bS07j = parcelRequire("bS07j");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $1NfYk = parcelRequire("1NfYk");

var $jd93d = parcelRequire("jd93d");
const $097954739b6f31e0$export$6145b58afae943e6 = ({ projectData: projectData, isCorePremiumUserSeat: isCorePremiumUserSeat = false, spotlight: spotlight, menuItemAnchorRef: menuItemAnchorRef })=>{
    const { sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent } = (0, $lHnXI.useProjectsAnalyticsL2)();
    const project = (0, $j4oe4.useFragment)((0, $dw8e4.default), projectData);
    const routerLinkConfig = (0, $eJOHy.useMemo)(()=>({
            to: project.defaultNavigationItem?.url ?? `/browse/${project.projectKey}`,
            prefetch: 'hover'
        }), [
        project.defaultNavigationItem?.url,
        project.projectKey
    ]);
    const projectActionMenuOnClickHandler = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)(()=>{
        const isFavourite = project.isFavourite;
        const projectId = project.projectId;
        const projectType = project.projectType;
        sendMeatBallDropDownOnProjectsAnalyticsEvent({
            // TODO BLU-5544 send section via <ContextualAnalyticsData instead (which wraps the Starred or Recent panel; and each project). Use static object or useMemo, not to have rerendering issues. Then you can also use static object for meatBallDropDownOnProjectsAnalytics. See Jsm and Wanjel components
            starred: isFavourite ?? false,
            recent: !isFavourite,
            projectId: projectId,
            projectType: projectType
        });
    }, [
        project.isFavourite,
        project.projectId,
        project.projectType,
        sendMeatBallDropDownOnProjectsAnalyticsEvent
    ]) : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)(()=>{
        const { isFavourite: isFavourite, projectId: projectId, projectType: projectType } = project;
        sendMeatBallDropDownOnProjectsAnalyticsEvent({
            // TODO BLU-5544 send section via <ContextualAnalyticsData instead (which wraps the Starred or Recent panel; and each project). Use static object or useMemo, not to have rerendering issues. Then you can also use static object for meatBallDropDownOnProjectsAnalytics. See Jsm and Wanjel components
            starred: isFavourite ?? false,
            recent: !isFavourite,
            projectId: projectId,
            projectType: projectType
        });
    }, [
        project,
        sendMeatBallDropDownOnProjectsAnalyticsEvent
    ]);
    const { projectId: projectId, projectKey: projectKey, isFavourite: isFavourite, name: name, avatar: avatar } = project;
    const { state: state, draggableAnchorRef: draggableAnchorRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, dragPreview: dragPreview, hasDragIndicator: hasDragIndicator } = (0, $1NfYk.useProjectMenuItemDragAndDrop)({
        projectId: projectId,
        projectKey: projectKey,
        isFavourite: isFavourite,
        name: name,
        avatar: avatar,
        isEnabled: !!isFavourite && (0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Of18.OnboardingSpotlightMaybe), {
        key: project.projectKey,
        spotlight: spotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        ref: (0, $jd93d.mergeRefs)(menuItemAnchorRef || null, draggableAnchorRef),
        visualContentRef: dropTargetRef,
        dropIndicator: dropIndicator,
        isDragging: state.type === 'dragging',
        hasDragIndicator: hasDragIndicator,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7IJ7W.ContainerAvatar), {
            src: project.avatar.large || ''
        }),
        href: routerLinkConfig,
        menuId: (0, $h4Bzb.ENTITY_ID).PROJECT(project.projectKey),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bS07j.ProjectActionMenu), {
            isProjectMenuReorderingEnabled: Boolean(project.isFavourite) && (0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false),
            projectKey: project.projectKey,
            isCorePremiumUserSeat: isCorePremiumUserSeat,
            onClick: projectActionMenuOnClickHandler
        })
    }, project.name), dragPreview);
};

});
parcelRegister("dw8e4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ed9376a9395992a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f8261c1d4ea8b98e7cad6afaa53ee9a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9ed9376a9395992a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraBusinessProjectMenu",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW",
                        "path": "avatar.large"
                    }
                ]
            },
            "action": "THROW",
            "path": "avatar"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraNavigationItem",
                    "abstractKey": "__isJiraNavigationItem"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$9ed9376a9395992a$var$node.hash = "3aeeb5d636ce6b2eb00fc0375929c8cb";
var $9ed9376a9395992a$export$2e2bcd8739ae039 = $9ed9376a9395992a$var$node;

});

parcelRegister("7IJ7W", function(module, exports) {

$parcel$export(module.exports, "ContainerAvatar", () => $ca6a63dcce81f026$export$f35a2d11bd6ae97);
/* container-avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $ca6a63dcce81f026$var$styles = {
    root: "_2rkoiti9 _vchhusvi _4t3igktf _1bsbgktf"
};
const $ca6a63dcce81f026$export$f35a2d11bd6ae97 = ({ src: src })=>/*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        src: src,
        alt: "",
        className: (0, $hcewu.default)([
            $ca6a63dcce81f026$var$styles.root
        ])
    });

});

parcelRegister("bS07j", function(module, exports) {

$parcel$export(module.exports, "ProjectActionMenu", () => $38a903ab1d7ae22b$export$b71a0a4e7f29cfd6);

var $eJOHy = parcelRequire("eJOHy");

var $4poV0 = parcelRequire("4poV0");

var $9JB3T = parcelRequire("9JB3T");

var $lRq8t = parcelRequire("lRq8t");

var $6zXPf = parcelRequire("6zXPf");

var $cJEMq = parcelRequire("cJEMq");

var $7jTnu = parcelRequire("7jTnu");

var $6XJko = parcelRequire("6XJko");

var $dEoQI = parcelRequire("dEoQI");

var $ce73j = parcelRequire("ce73j");
const $38a903ab1d7ae22b$var$CustomTrigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const triggerButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJEMq.ThemedButton), {
        ...props,
        ref: ref,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4poV0))), {
            label: formatMessage((0, $ce73j.default).moreActions),
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "navigation-project-action-menu.ui.themed-button"
    });
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: formatMessage((0, $ce73j.default).moreActions),
        hideTooltipOnClick: true
    }, triggerButton) : triggerButton;
});
const $38a903ab1d7ae22b$export$b71a0a4e7f29cfd6 = ({ additionalMenuItems: additionalMenuItems, isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled = false, isCorePremiumUserSeat: isCorePremiumUserSeat = false, withThemedTrigger: withThemedTrigger = false, projectKey: projectKey, onClick: onClick, shouldRenderToParent: shouldRenderToParent, projectName: projectName })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dEoQI.EntryPointContent), {
        ...(0, $7jTnu.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
            projectName: projectName
        } : {},
        isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
        additionalMenuItems: additionalMenuItems,
        onClick: onClick,
        isCorePremiumUserSeat: isCorePremiumUserSeat,
        CustomTrigger: withThemedTrigger && (0, $6zXPf.getWillShowNav4)() ? $38a903ab1d7ae22b$var$CustomTrigger : undefined,
        projectKey: projectKey,
        shouldRenderToParent: shouldRenderToParent,
        source: withThemedTrigger ? 'horizontal-nav' : 'sidebar-nav'
    });
};

});
parcelRegister("dEoQI", function(module, exports) {

$parcel$export(module.exports, "EntryPointContent", () => $fabe5cda70e02c8e$export$912f81dce8d58e46);

var $eJOHy = parcelRequire("eJOHy");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");

var $efhF3 = parcelRequire("efhF3");

var $i0Ev8 = parcelRequire("i0Ev8");

var $gcYED = parcelRequire("gcYED");
const $fabe5cda70e02c8e$export$912f81dce8d58e46 = ({ CustomTrigger: CustomTrigger, onClick: onClick, additionalMenuItems: additionalMenuItems, isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled = false, isCorePremiumUserSeat: isCorePremiumUserSeat = false, projectKey: projectKey, shouldRenderToParent: shouldRenderToParent, projectName: projectName, source: source })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $efhF3.projectActionMenuEntryPoint), (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]));
    const buttonTriggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    const content = (0, $eJOHy.useCallback)((contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "project-actions-menu-popup-content",
            packageName: "jira-navigation-apps-project-action-menu",
            runtimeProps: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $eJOHy.useMemo)(()=>({
                    isCorePremiumUserSeat: isCorePremiumUserSeat,
                    additionalMenuItems: additionalMenuItems,
                    isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
                    contentProps: contentProps,
                    source: source
                }), [
                contentProps
            ]) : {
                isCorePremiumUserSeat: isCorePremiumUserSeat,
                additionalMenuItems: additionalMenuItems,
                isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
                contentProps: contentProps,
                source: source
            },
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gcYED.Skeleton), null)
        }), [
        entryPointReferenceSubject,
        additionalMenuItems,
        isCorePremiumUserSeat,
        isProjectMenuReorderingEnabled,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0Ev8.MenuContainer), {
        ...(0, $7jTnu.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
            projectName: projectName
        } : {},
        content: content,
        CustomTrigger: CustomTrigger,
        onClick: onClick,
        buttonTriggerRef: buttonTriggerRef,
        shouldRenderToParent: shouldRenderToParent
    });
};

});
parcelRegister("efhF3", function(module, exports) {

$parcel$export(module.exports, "projectActionMenuEntryPoint", () => $f137ce769a6a6e13$export$30ec6de22da54fa0);

var $huuzO = parcelRequire("huuzO");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $f137ce769a6a6e13$export$30ec6de22da54fa0 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("iN66f")).then((module)=>module.AsyncMenuWithQuery), {
        moduleId: "eb74dcae",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>{
        const projectActionMenuQuery = {
            parameters: (0, $huuzO.default),
            variables: {
                cloudId: cloudId,
                projectKey: projectKey
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
        return {
            queries: {
                projectActionMenuQuery: projectActionMenuQuery
            }
        };
    }
});

});
parcelRegister("huuzO", function(module, exports) {

$parcel$export(module.exports, "default", () => $72a5c7cd3356ba54$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<66474dbd2796df141bd06ebac84678df>>
 * @relayHash 3b300d9db15ab0bcc9e6fd4faf68fd66
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c1cea8ee89608e6a77d110730b741ce6aaabd0ad933c6c3505a14cb43e016ae6
const $72a5c7cd3356ba54$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c1cea8ee89608e6a77d110730b741ce6aaabd0ad933c6c3505a14cb43e016ae6",
        "metadata": {},
        "name": "async_AsyncMenuContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $72a5c7cd3356ba54$export$2e2bcd8739ae039 = $72a5c7cd3356ba54$var$node;

});

parcelRegister("iN66f", function(module, exports) {

let $dae188e1308069b3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $dae188e1308069b3$var$load("7vqGd"),
    $dae188e1308069b3$var$load("1Y4bq"),
    $dae188e1308069b3$var$load("1VRB2"),
    $dae188e1308069b3$var$load("bABhq"),
    $dae188e1308069b3$var$load("6WGAw")
]).then(()=>parcelRequire('6RVGd'));

});


parcelRegister("gcYED", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $8d45d921416e6533$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $MlWTN = parcelRequire("MlWTN");
var $7R1al = parcelRequire("7R1al");
var $f9Ihw = parcelRequire("f9Ihw");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $5Wv5g = parcelRequire("5Wv5g");

var $5Q9JR = parcelRequire("5Q9JR");
const $8d45d921416e6533$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $8d45d921416e6533$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), {
        minWidth: (0, $5Q9JR.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $8d45d921416e6533$var$projectTileSkeleton
    }))));
const $8d45d921416e6533$var$wrapperStyles = (0, $5Wv5g.xcss)({
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $5Q9JR.MENU_GROUP_MIN_WIDTH)}px`
});
const $8d45d921416e6533$var$projectTileSkeleton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-600, 48px)",
    flex: 1
});

});


parcelRegister("ce73j", function(module, exports) {

$parcel$export(module.exports, "default", () => $fac621ca9c21a200$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fac621ca9c21a200$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projectSettings: {
        "id": "navigation-project-action-menu.project-settings",
        "defaultMessage": "Project settings"
    },
    moreActions: {
        "id": "navigation-project-action-menu.more-actions",
        "defaultMessage": "More actions"
    }
});

});


parcelRegister("1NfYk", function(module, exports) {

$parcel$export(module.exports, "useProjectMenuItemDragAndDrop", () => $fc6dd0c2bc0ef4cd$export$1496323130e2da11);

var $eJOHy = parcelRequire("eJOHy");

var $2GdJz = parcelRequire("2GdJz");

var $7IJ7W = parcelRequire("7IJ7W");

var $3X9cT = parcelRequire("3X9cT");

var $fpJnI = parcelRequire("fpJnI");
const $fc6dd0c2bc0ef4cd$export$1496323130e2da11 = (props)=>{
    const focusRestorationContext = (0, $eJOHy.useContext)((0, $fpJnI.FocusRestorationContext));
    const { shouldRestoreFocusRef: shouldRestoreFocusRef, clearRestoreFocus: clearRestoreFocus } = focusRestorationContext;
    const { projectId: projectId, projectKey: projectKey, isFavourite: isFavourite, name: name, avatar: avatar, isEnabled: isEnabled = false } = props;
    /* isEnabled is used to determine if drag and drop functionality should be enabled – this is used to turn on the feature only for starred projects.
	By using this to pass undefined to draggable and dropTarget the useMenuItemDragAndDrop hook does not run its effects to attach event listeners.
	The drag and drop functionality is effectively disabled, while still setting up the refs which are required for consistent rendering. */ const { state: state, draggableButtonRef: draggableButtonRef, dropTargetRef: dropTargetRef, draggableAnchorRef: draggableAnchorRef, dragPreview: dragPreview, dropIndicator: dropIndicator } = (0, $2GdJz.useMenuItemDragAndDrop)({
        draggable: isEnabled ? {
            getInitialData: ()=>({
                    id: projectId,
                    key: projectKey,
                    isFavourite: isFavourite,
                    name: name,
                    avatar: avatar.large || '',
                    type: (0, $3X9cT.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP)
                }),
            getDragPreviewPieces: ()=>({
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7IJ7W.ContainerAvatar), {
                        src: avatar.large || ''
                    }),
                    content: name
                })
        } : undefined,
        dropTarget: isEnabled ? {
            getData: ()=>({
                    id: projectId,
                    key: projectKey,
                    isFavourite: isFavourite,
                    name: name,
                    avatar: avatar.large || '',
                    type: (0, $3X9cT.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP)
                }),
            getOperations: ()=>({
                    'reorder-after': 'available',
                    'reorder-before': 'available'
                }),
            canDrop: ({ source: source })=>source.data.type === (0, $3X9cT.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP)
        } : undefined
    });
    (0, $eJOHy.useEffect)(()=>{
        if (shouldRestoreFocusRef.current && isEnabled) // .focus() seems to be more reliable in the next task when used with VoiceOver
        setTimeout(()=>{
            (draggableButtonRef.current ?? draggableAnchorRef.current)?.focus();
            clearRestoreFocus?.();
        });
    }, [
        shouldRestoreFocusRef,
        clearRestoreFocus,
        draggableButtonRef,
        draggableAnchorRef,
        isEnabled
    ]);
    return {
        state: state,
        draggableButtonRef: draggableButtonRef,
        dropTargetRef: dropTargetRef,
        draggableAnchorRef: draggableAnchorRef,
        dragPreview: isEnabled ? dragPreview : null,
        dropIndicator: isEnabled ? dropIndicator : null,
        hasDragIndicator: isEnabled
    };
};

});
parcelRegister("2GdJz", function(module, exports) {

$parcel$export(module.exports, "useMenuItemDragAndDrop", () => $310ab8735626d48f$export$fe281fdb09fbf0c8);
/* use-menu-item-drag-and-drop.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $8GOss = parcelRequire("8GOss");

var $dv8dh = parcelRequire("dv8dh");
parcelRequire("jFRPQ");
var $1vOZc = parcelRequire("1vOZc");
parcelRequire("2N1E3");
var $5B3tD = parcelRequire("5B3tD");

var $gggyC = parcelRequire("gggyC");

var $3IPzf = parcelRequire("3IPzf");

var $omzn0 = parcelRequire("omzn0");
const $310ab8735626d48f$var$idle = {
    type: 'idle'
};
function $310ab8735626d48f$export$fe281fdb09fbf0c8({ draggable: draggableArgs, dropTarget: dropTargetArgs }) {
    const draggableAnchorRef = (0, $eJOHy.useRef)(null);
    const draggableButtonRef = (0, $eJOHy.useRef)(null);
    const dropTargetRef = (0, $eJOHy.useRef)(null);
    const [internalState, setInternalState] = (0, $eJOHy.useState)($310ab8735626d48f$var$idle);
    const getDraggableElement = (0, $eJOHy.useCallback)(()=>{
        return draggableAnchorRef.current ?? draggableButtonRef.current ?? null;
    }, []);
    // Set up draggable
    (0, $eJOHy.useEffect)(()=>{
        // Don't set up a draggable if there are no draggable args
        if (!draggableArgs) return;
        const element = getDraggableElement();
        (0, $8GOss.default)(element, `draggableAnchorRef or draggableButtonRef not set`);
        return (0, $dv8dh.draggable)({
            element: element,
            getInitialData: draggableArgs.getInitialData,
            canDrag: draggableArgs.canDrag,
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage, source: source, location: location }) {
                (0, $5B3tD.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $1vOZc.pointerOutsideOfPreview)({
                        x: "var(--ds-space-200, 16px)",
                        y: "var(--ds-space-100, 8px)"
                    }),
                    render ({ container: container }) {
                        const args = {
                            dragHandle: source.dragHandle,
                            element: source.element,
                            input: location.current.input
                        };
                        setInternalState({
                            type: 'preview',
                            container: container,
                            ui: draggableArgs.getDragPreviewPieces(args)
                        });
                    }
                });
            },
            onDragStart () {
                setInternalState({
                    type: 'dragging'
                });
            },
            onDrop () {
                setInternalState($310ab8735626d48f$var$idle);
            }
        });
    }, [
        draggableArgs,
        getDraggableElement
    ]);
    // Set up drop target
    (0, $eJOHy.useEffect)(()=>{
        if (!dropTargetArgs) return;
        // Don't need to provide a draggable element to have a drop target.
        // Using this element in our `canDrop` check
        const draggableElement = getDraggableElement();
        const dropTarget = dropTargetRef.current;
        (0, $8GOss.default)(dropTarget, `dropTargetRef was not set`);
        return (0, $dv8dh.dropTargetForElements)({
            element: dropTarget,
            // cannot drop on self
            canDrop: (args)=>{
                // cannot drop on self
                if (args.source.element === draggableElement) return false;
                if (dropTargetArgs.canDrop) return dropTargetArgs.canDrop(args);
                return true;
            },
            // menu items are always sticky, and the GroupDropIndicator should clear stickiness
            getIsSticky: ()=>true,
            getData (args) {
                const data = dropTargetArgs.getData?.(args) ?? {};
                const operations = dropTargetArgs.getOperations(args);
                return (0, $omzn0.attachInstruction)(data, {
                    input: args.input,
                    element: args.element,
                    operations: operations
                });
            },
            onDragStart ({ self: self }) {
                const instruction = (0, $omzn0.extractInstruction)(self.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction
                });
            },
            onDrag ({ self: self }) {
                const instruction = (0, $omzn0.extractInstruction)(self.data);
                setInternalState((current)=>{
                    if (current.type === 'is-over' && instruction?.operation === current.instruction?.operation && instruction?.blocked === current.instruction?.blocked) return current;
                    return {
                        type: 'is-over',
                        instruction: instruction
                    };
                });
            },
            onDragLeave () {
                setInternalState($310ab8735626d48f$var$idle);
            },
            onDrop () {
                setInternalState($310ab8735626d48f$var$idle);
            },
            onDragEnter ({ self: self }) {
                const instruction = (0, $omzn0.extractInstruction)(self.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction
                });
            }
        });
    }, [
        dropTargetArgs,
        getDraggableElement
    ]);
    const dragPreview = (()=>{
        if (internalState.type !== 'preview') return null;
        return /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $gggyC.DragPreview), {
            elemBefore: internalState.ui.elemBefore,
            children: internalState.ui.content
        }), internalState.container);
    })();
    const dropIndicator = internalState.type === 'is-over' && internalState.instruction && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3IPzf.DropIndicator), {
        instruction: internalState.instruction
    });
    const state = (0, $eJOHy.useMemo)(()=>{
        if (internalState.type === 'preview') return {
            type: 'preview'
        };
        // returning a new object to avoid modification of our `internalState` object
        return {
            ...internalState
        };
    }, [
        internalState
    ]);
    return {
        state: state,
        draggableButtonRef: draggableButtonRef,
        dropTargetRef: dropTargetRef,
        draggableAnchorRef: draggableAnchorRef,
        dragPreview: dragPreview,
        dropIndicator: dropIndicator
    };
}

});
parcelRegister("jFRPQ", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("1vOZc")).pointerOutsideOfPreview);

var $1vOZc = parcelRequire("1vOZc");

});
parcelRegister("1vOZc", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => $e8a6222b486cb49e$export$427e20518819fabc);

var $fxcUL = parcelRequire("fxcUL");

var $3ETtx = parcelRequire("3ETtx");

var $kP8J6 = parcelRequire("kP8J6");
function $e8a6222b486cb49e$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $3ETtx.isSafariOnIOS)() || (0, $fxcUL.isAndroid)()) return (0, $kP8J6.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}

});
parcelRegister("3ETtx", function(module, exports) {

$parcel$export(module.exports, "isSafariOnIOS", () => $85cc3d8d307588ec$export$52fc40c68fea4952);

var $9TlpJ = parcelRequire("9TlpJ");

var $c9PHh = parcelRequire("c9PHh");
const $85cc3d8d307588ec$export$52fc40c68fea4952 = (0, $9TlpJ.once)(function isSafariOnIOS() {
    return (0, $c9PHh.isSafari)() && 'ontouchend' in document;
});

});

parcelRegister("kP8J6", function(module, exports) {

$parcel$export(module.exports, "centerUnderPointer", () => $dc9788f143143c16$export$81d8e72a15eef435);
const $dc9788f143143c16$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};

});



parcelRegister("2N1E3", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("5B3tD")).setCustomNativeDragPreview);

var $5B3tD = parcelRequire("5B3tD");

});
parcelRegister("5B3tD", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $b62b0546b9786574$export$52d889c66db0f96e);

var $4ldIH = parcelRequire("4ldIH");

var $c9PHh = parcelRequire("c9PHh");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $b62b0546b9786574$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $b62b0546b9786574$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $b62b0546b9786574$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $00fece08cc7e857c$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $c9PHh.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $4ldIH.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $00fece08cc7e857c$export$7d0a15ee70427305 = 2147483647;



parcelRegister("gggyC", function(module, exports) {

$parcel$export(module.exports, "DragPreview", () => $ce7f247bf032786a$export$905ab40ac2179daa);
/* drag-preview.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cfkQt = parcelRequire("cfkQt");

var $gX9lg = parcelRequire("gX9lg");

var $9aTgN = parcelRequire("9aTgN");
// Using JavaScript for detecting Safari, as I could not find a reliable way to do it with CSS.
function $ce7f247bf032786a$var$isSafari() {
    if (typeof window === 'undefined') return false;
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
}
const $ce7f247bf032786a$var$dragPreviewStyles = {
    root: "_2rkoglpi _189ee4h9 _1h6dmuej _1dqonqa1 _bfhkvuon _y4ti1b66 _p12fgx0z",
    safariFix: "_1ul9uuw1"
};
function $ce7f247bf032786a$export$905ab40ac2179daa({ elemBefore: elemBefore, children: children }) {
    return(// Resetting the expandable menu items to 0.
    // This is to prevent our hidden element from pushing
    // the drag preview further away from the users pointer
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cfkQt.ExpandableMenuItemLevelContext).Provider, {
        value: 0,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                $ce7f247bf032786a$var$dragPreviewStyles.root,
                $ce7f247bf032786a$var$isSafari() && $ce7f247bf032786a$var$dragPreviewStyles.safariFix
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gX9lg.MenuItemBase), {
                elemBefore: elemBefore ?? (0, $9aTgN.COLLAPSE_ELEM_BEFORE),
                children: children
            })
        })
    }));
}

});

parcelRegister("3IPzf", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $04c4207ad950acbf$export$62ed72bc21f6b8a6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gM2Nj = parcelRequire("gM2Nj");

var $9aInq = parcelRequire("9aInq");
const $04c4207ad950acbf$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom'
    },
    horizontal: {
        start: 'left',
        end: 'right'
    }
};
function $04c4207ad950acbf$export$62ed72bc21f6b8a6({ instruction: instruction, lineGap: lineGap, lineType: lineType }) {
    const appearance = instruction.blocked ? 'warning' : 'default';
    const axis = $04c4207ad950acbf$var$axisLookup[instruction.axis];
    if (instruction.operation === 'combine') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gM2Nj.DropIndicator), {
        appearance: appearance
    });
    if (instruction.operation === 'reorder-before') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9aInq.DropIndicator), {
        edge: axis.start,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    if (instruction.operation === 'reorder-after') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9aInq.DropIndicator), {
        edge: axis.end,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    return null;
}

});
parcelRegister("gM2Nj", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $d4fb1a05e0292bb1$export$62ed72bc21f6b8a6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8Hgbv = parcelRequire("8Hgbv");

var $9xsmz = parcelRequire("9xsmz");
function $d4fb1a05e0292bb1$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', indent: indent }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Hgbv.Border), {
        strokeColor: (0, $9xsmz.presetStrokeColors)[appearance],
        indent: indent
    });
}
var // For React.lazy
$d4fb1a05e0292bb1$export$2e2bcd8739ae039 = $d4fb1a05e0292bb1$export$62ed72bc21f6b8a6;

});
parcelRegister("8Hgbv", function(module, exports) {

$parcel$export(module.exports, "Border", () => $ba8ff1a77e289ff4$export$d8e9c9d63e86d41e);
/* border.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9xsmz = parcelRequire("9xsmz");
const $ba8ff1a77e289ff4$var$styles = null;
function $ba8ff1a77e289ff4$export$d8e9c9d63e86d41e({ strokeColor: strokeColor = (0, $9xsmz.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9xsmz.presetStrokeWidth), borderRadius: borderRadius = '3px', indent: // TODO: update to border.radius (4px) token
indent = '0px' }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            '--border-radius': borderRadius,
            '--indent': indent
        },
        className: (0, $hcewu.default)([
            "_19it1ebc _2rko1koq _kqswstnw _152tidpf _u7coidpf _rjxpidpf _1e02armj _lcxvglyw"
        ])
    });
}
var // For React.lazy
$ba8ff1a77e289ff4$export$2e2bcd8739ae039 = $ba8ff1a77e289ff4$export$d8e9c9d63e86d41e;

});
parcelRegister("9xsmz", function(module, exports) {

$parcel$export(module.exports, "presetStrokeColors", () => $afce33dbf6297866$export$477fafec326bfca0);
$parcel$export(module.exports, "presetStrokeWidth", () => $afce33dbf6297866$export$45db03aa04b685e3);
const $afce33dbf6297866$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #0C66E4)",
    warning: "var(--ds-border-warning, #E56910)"
};
const $afce33dbf6297866$export$45db03aa04b685e3 = "var(--ds-border-width-outline, 2px)";

});



parcelRegister("9aInq", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $cc5a8531ae7ed789$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $cc5a8531ae7ed789$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $abtQu = parcelRequire("abtQu");

var $9xsmz = parcelRequire("9xsmz");
function $cc5a8531ae7ed789$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $abtQu.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $9xsmz.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$cc5a8531ae7ed789$export$2e2bcd8739ae039 = $cc5a8531ae7ed789$export$62ed72bc21f6b8a6;

});
parcelRegister("abtQu", function(module, exports) {

$parcel$export(module.exports, "Line", () => $7d916a678ac0fedc$export$17d680238e50603e);
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9xsmz = parcelRequire("9xsmz");
const $7d916a678ac0fedc$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $7d916a678ac0fedc$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $7d916a678ac0fedc$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $7d916a678ac0fedc$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $7d916a678ac0fedc$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $7d916a678ac0fedc$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $9xsmz.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9xsmz.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $7d916a678ac0fedc$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $7d916a678ac0fedc$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $hcewu.default)([
            $7d916a678ac0fedc$var$baseStyles.root,
            $7d916a678ac0fedc$var$orientationStyles[orientation],
            $7d916a678ac0fedc$var$edgeStyles[edge]
        ])
    });
}
var // For React.lazy
$7d916a678ac0fedc$export$2e2bcd8739ae039 = $7d916a678ac0fedc$export$17d680238e50603e;

});



parcelRegister("omzn0", function(module, exports) {

$parcel$export(module.exports, "attachInstruction", () => $5e7076b64f0dd931$export$267ad49d812c2c7f);
$parcel$export(module.exports, "extractInstruction", () => $5e7076b64f0dd931$export$c8ffecbe249dc8f8);

var $8miEn = parcelRequire("8miEn");
// using a symbol so we can guarantee a key with a unique value
const $5e7076b64f0dd931$var$uniqueKey = Symbol('list-item-instruction');
const $5e7076b64f0dd931$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom',
        size: 'height',
        point: 'y'
    },
    horizontal: {
        start: 'left',
        end: 'right',
        size: 'width',
        point: 'x'
    }
};
function $5e7076b64f0dd931$var$reorderAndCombine({ client: client, borderBox: borderBox, axis: axis }) {
    const quarterOfSize = borderBox[axis.size] / 4;
    // In the top 1/4: reorder-before
    // On the line: reorder-before to give a slight preference to reordering
    if (client[axis.point] <= borderBox[axis.start] + quarterOfSize) return 'reorder-before';
    // In the bottom 1/4: reorder-after
    // On the line: reorder-after to give a slight preference to reordering
    if (client[axis.point] >= borderBox[axis.end] - quarterOfSize) return 'reorder-after';
    return 'combine';
}
function $5e7076b64f0dd931$var$reorder({ client: client, borderBox: borderBox, axis: axis }) {
    const halfSize = borderBox[axis.size] / 2;
    // In the top 1/2: reorder-before
    // On the line: reorder-after to give a slight preference to moving forward
    if (client[axis.point] < borderBox[axis.start] + halfSize) return 'reorder-before';
    return 'reorder-after';
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $5e7076b64f0dd931$var$memoizeInstruction = (0, $8miEn.stable)();
function $5e7076b64f0dd931$var$isPossible(...values) {
    return values.every((value)=>value === 'available' || value === 'blocked');
}
function $5e7076b64f0dd931$var$isNotAvailable(...values) {
    return values.every((value)=>value === 'not-available');
}
function $5e7076b64f0dd931$export$267ad49d812c2c7f(userData, { operations: operations, element: element, input: input, axis: axisValue = 'vertical' }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    const axis = $5e7076b64f0dd931$var$axisLookup[axisValue];
    const combine = operations.combine ?? 'not-available';
    const reorderAbove = operations['reorder-before'] ?? 'not-available';
    const reorderBelow = operations['reorder-after'] ?? 'not-available';
    const operation = (()=>{
        // Combining not possible
        if (!$5e7076b64f0dd931$var$isPossible(combine)) {
            // can reorder above and below
            if ($5e7076b64f0dd931$var$isPossible(reorderAbove, reorderBelow)) return $5e7076b64f0dd931$var$reorder({
                client: client,
                borderBox: borderBox,
                axis: axis
            });
            // can only reorder above
            if ($5e7076b64f0dd931$var$isPossible(reorderAbove)) return 'reorder-before';
            // can only reorder below
            if ($5e7076b64f0dd931$var$isPossible(reorderBelow)) return 'reorder-after';
            // no `true` values - no Outcome available.
            return null;
        }
        // combining is available
        const result = $5e7076b64f0dd931$var$reorderAndCombine({
            client: client,
            borderBox: borderBox,
            axis: axis
        });
        if (result === 'reorder-after') return $5e7076b64f0dd931$var$isNotAvailable(reorderBelow) ? 'combine' : result;
        if (result === 'reorder-before') return $5e7076b64f0dd931$var$isNotAvailable(reorderAbove) ? 'combine' : result;
        return result;
    })();
    // We cannot attach an instruction - all values passed where `false` or no values passed
    if (!operation) return userData;
    const instruction = {
        operation: operation,
        blocked: operations[operation] === 'blocked',
        axis: axisValue
    };
    const memoized = $5e7076b64f0dd931$var$memoizeInstruction(instruction);
    return {
        ...userData,
        [$5e7076b64f0dd931$var$uniqueKey]: memoized
    };
}
function $5e7076b64f0dd931$export$c8ffecbe249dc8f8(userData) {
    return userData[$5e7076b64f0dd931$var$uniqueKey] ?? null;
}

});
parcelRegister("8miEn", function(module, exports) {

$parcel$export(module.exports, "isShallowEqual", () => $5240ee93e867690d$export$2225b4c39d37f8b3);
$parcel$export(module.exports, "stable", () => $5240ee93e867690d$export$3f55479a3469259f);
function $5240ee93e867690d$export$2225b4c39d37f8b3(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>Object.is(a[key], b[key]));
}
function $5240ee93e867690d$export$3f55479a3469259f(isEqual = $5240ee93e867690d$export$2225b4c39d37f8b3) {
    let cache = null;
    return (value)=>{
        if (cache && isEqual(cache.value, value)) return cache.value;
        cache = {
            value: value
        };
        return cache.value;
    };
}

});



parcelRegister("3X9cT", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $7ca8841fadbc0582$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $7ca8841fadbc0582$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ANALYTIC_PAYLOAD", () => $7ca8841fadbc0582$export$4a2242445a67aef7);
$parcel$export(module.exports, "NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP", () => $7ca8841fadbc0582$export$e320e335fe38c28a);




var $a9aec = parcelRequire("a9aec");


const $7ca8841fadbc0582$export$b8b9d90f9e5bd72b = 'jira-navigation-apps-sidebar-nav4-projects-customise-order';
const $7ca8841fadbc0582$export$d57b6b390e78d90f = 'jira-cosmos';
const $7ca8841fadbc0582$export$4a2242445a67aef7 = {
    UPDATED_ORDER: {
        action: 'updated',
        actionSubject: 'sidebarNavigationItems',
        actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524)
    },
    ATTRIBUTES: {
        level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
        componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
        itemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
        section: (0, $a9aec.SECTION_ITEM_STARRED)
    },
    DRAG_STARTED: {
        action: 'dragStarted',
        actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
        actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524)
    },
    DRAG_LEFT: {
        action: 'dragLeft',
        actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
        actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524)
    },
    DRAG_ENTERED: {
        action: 'dragEntered',
        actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
        actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524)
    },
    DRAG_ENDED: {
        action: 'dragEnded',
        actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2),
        actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524)
    }
};
const $7ca8841fadbc0582$export$e320e335fe38c28a = 'nav4-sidebar-project-menu-item-drag-and-drop';

});

parcelRegister("fpJnI", function(module, exports) {

$parcel$export(module.exports, "FocusRestorationContext", () => $72b8cfa15fa83210$export$ee843363a931c6f7);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $72b8cfa15fa83210$export$ee843363a931c6f7 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    shouldRestoreFocusRef: {
        current: false
    },
    clearRestoreFocus: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});

});



parcelRegister("4lj4q", function(module, exports) {

$parcel$export(module.exports, "AsyncJpdProjectMenu", () => $9e4adbd9d5aff3a9$export$b446e65eeda5c1fb);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $if69u = parcelRequire("if69u");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");
const $9e4adbd9d5aff3a9$var$SingleMenuItemSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
        count: 1
    });
const $9e4adbd9d5aff3a9$var$Skeleton = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-proj-menu-fix'), $9e4adbd9d5aff3a9$var$SingleMenuItemSkeleton, (0, $8vXrD.Skeleton));

const $9e4adbd9d5aff3a9$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("5Mu1U")).then(({ JpdProjectMenu: JpdProjectMenu })=>JpdProjectMenu), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/projects/jpd-project-menu/src/ui/index.tsx"
});
const $9e4adbd9d5aff3a9$export$b446e65eeda5c1fb = /*#__PURE__*/ (0, $eJOHy.memo)(({ projectData: projectData, spotlight: spotlight, menuItemButtonRef: menuItemButtonRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.jpd-project-menu",
        packageName: "jiraNavigationAppsSidebarNav4JPDProjectMenu",
        ufoName: "nav4.sidebar.jpd-project-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.jpd-project-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9e4adbd9d5aff3a9$var$Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9e4adbd9d5aff3a9$var$LazySidebarContent, {
        projectData: projectData,
        spotlight: spotlight,
        menuItemButtonRef: menuItemButtonRef
    }))));

});
parcelRegister("2hZzG", function(module, exports) {

$parcel$export(module.exports, "SidebarBoundary", () => $5ef1da860dc7aac4$export$1edc778464f08256);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $bFY6o = parcelRequire("bFY6o");

var $aqnJa = parcelRequire("aqnJa");

var $kQnVX = parcelRequire("kQnVX");

var $16sa1 = parcelRequire("16sa1");

var $hyK5y = parcelRequire("hyK5y");

var $gaosd = parcelRequire("gaosd");
const $5ef1da860dc7aac4$export$1edc778464f08256 = ({ children: children, id: id, packageName: packageName, teamName: teamName, ufoName: ufoName = '' })=>{
    const { experience: experience, attributes: attributes } = (0, $hyK5y.useSidebarExperience)();
    const onFail = (0, $aqnJa.useExperienceFail)({
        experience: experience,
        attributes: attributes
    });
    const onAbort = (0, $bFY6o.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
    const userLocation = (0, $kQnVX.getUserLocation)();
    const isNotSSR = !false;
    const extraEventData = (0, $eJOHy.useMemo)(()=>({
            userLocation: userLocation
        }), [
        userLocation
    ]);
    const fallback = (0, $eJOHy.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gaosd.Fallback), {
            error: error
        }), []);
    const handleError = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (location, error)=>{
        const { statusCode: statusCode } = error;
        if (statusCode >= 400 && statusCode < 500) onAbort('Sidebar failed with validation error', {
            error: error
        });
        else onFail(location, error);
    }, [
        onAbort,
        onFail
    ]);
    const UFOSegmentORFragment = ufoName ? (0, $16sa1.default) : (0, $eJOHy.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(UFOSegmentORFragment, {
        name: ufoName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        extraEventData: extraEventData,
        fallback: fallback,
        teamName: teamName,
        onError: handleError
    }, isNotSSR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hyK5y.SidebarStart), null), children));
};

});
parcelRegister("gaosd", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $f3c22cd43bba1219$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $bvFRW = parcelRequire("bvFRW");

var $dhRXV = parcelRequire("dhRXV");
var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");

var $2HRPu = parcelRequire("2HRPu");

var $igCP5 = parcelRequire("igCP5");

var $lRq8t = parcelRequire("lRq8t");

var $aFnM0 = parcelRequire("aFnM0");
const $f3c22cd43bba1219$var$styles = {
    wrapper: "_zulpu2gc _bfhkm7j4 _syaz1gjq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o",
    error: "_2rkogqwt _bfhk1v33 _syaz131l _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66"
};
const $f3c22cd43bba1219$export$fb8d7f40caaeea67 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
        xcss: $f3c22cd43bba1219$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $igCP5.default), {
        width: "40px",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "xsmall"
    }, formatMessage((0, $aFnM0.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, formatMessage((0, $aFnM0.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $f3c22cd43bba1219$var$styles.error
    }, "ERROR: ", (0, $2HRPu.getErrorHash)(error)));
};

});
parcelRegister("aFnM0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4902ad1ceed26b1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b4902ad1ceed26b1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorHeading: {
        "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("8vXrD", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $af680c8fbb6b6aab$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $dtyGQ = parcelRequire("dtyGQ");
var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");
const $af680c8fbb6b6aab$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.200",
        xcss: $af680c8fbb6b6aab$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $af680c8fbb6b6aab$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $af680c8fbb6b6aab$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dtyGQ.default), {
        columnGap: "space.100",
        rowGap: "space.050",
        alignItems: "center",
        templateAreas: [
            'avatar name',
            'avatar type'
        ],
        templateColumns: "min-content 1fr",
        xcss: $af680c8fbb6b6aab$var$projectHeading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $af680c8fbb6b6aab$var$projectAvatar,
        style: {
            gridArea: 'avatar'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $af680c8fbb6b6aab$var$projectName,
        style: {
            gridArea: 'name'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $af680c8fbb6b6aab$var$projectType,
        style: {
            gridArea: 'type'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $af680c8fbb6b6aab$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $af680c8fbb6b6aab$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $af680c8fbb6b6aab$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $af680c8fbb6b6aab$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $af680c8fbb6b6aab$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $af680c8fbb6b6aab$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $af680c8fbb6b6aab$var$menuItem
    })));
const $af680c8fbb6b6aab$var$containerStyles = (0, $5Wv5g.xcss)({
    height: '100%',
    padding: 'space.200'
});
const $af680c8fbb6b6aab$var$backButton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $af680c8fbb6b6aab$var$headingSkeleton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $af680c8fbb6b6aab$var$projectHeading = (0, $5Wv5g.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $af680c8fbb6b6aab$var$projectAvatar = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $af680c8fbb6b6aab$var$projectName = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100'
});
const $af680c8fbb6b6aab$var$projectType = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-100, 8px)",
    borderRadius: 'border.radius.100'
});
const $af680c8fbb6b6aab$var$menuItem = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("5Mu1U", function(module, exports) {

let $4358babae6e84ecd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $4358babae6e84ecd$var$load("fAbxa"),
    $4358babae6e84ecd$var$load("k5mGc")
]).then(()=>parcelRequire('f5jWz'));

});


parcelRegister("1v9jo", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmProjectMenu", () => $df580e6e6daeb9c1$export$bf0d7afec25f82d7);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $gzcjr = parcelRequire("gzcjr");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $if69u = parcelRequire("if69u");
const $df580e6e6daeb9c1$var$SingleMenuItemSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
        count: 1
    });
const $df580e6e6daeb9c1$var$Skeleton = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-proj-menu-fix'), $df580e6e6daeb9c1$var$SingleMenuItemSkeleton, (0, $8vXrD.Skeleton));

const $df580e6e6daeb9c1$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("5NROp")).then(({ JsmProjectMenu: JsmProjectMenu })=>JsmProjectMenu), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/projects/jsm-project-menu/src/ui/project-menu/index.tsx"
});
const $df580e6e6daeb9c1$export$bf0d7afec25f82d7 = /*#__PURE__*/ (0, $eJOHy.memo)(({ projectData: projectData, spotlight: spotlight, menuItemButtonRef: menuItemButtonRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.jsm-project-menu",
        packageName: "jiraNavigationAppsSidebarNav4JsmProjectMenu",
        teamName: "jsm-getting-started",
        ufoName: "nav4.sidebar.jsm-project-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderUFOMigration), {
        name: "nav4.sidebar.jsm-project-menu.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df580e6e6daeb9c1$var$Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df580e6e6daeb9c1$var$LazySidebarContent, {
        projectData: projectData,
        spotlight: spotlight,
        menuItemButtonRef: menuItemButtonRef
    }))));

});
parcelRegister("5NROp", function(module, exports) {

let $439b455201e54af2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $439b455201e54af2$var$load("7vqGd"),
    $439b455201e54af2$var$load("1Y4bq"),
    $439b455201e54af2$var$load("jtk5u")
]).then(()=>parcelRequire('aNYOV'));

});


parcelRegister("3VmU5", function(module, exports) {

$parcel$export(module.exports, "AsyncJcsProjectMenu", () => $df7bf058fd9c7924$export$30175e6def84a269);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $8vXrD = parcelRequire("8vXrD");

var $if69u = parcelRequire("if69u");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");
const $df7bf058fd9c7924$var$SingleMenuItemSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
        count: 1
    });
const $df7bf058fd9c7924$var$Skeleton = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-proj-menu-fix'), $df7bf058fd9c7924$var$SingleMenuItemSkeleton, (0, $8vXrD.Skeleton));

const $df7bf058fd9c7924$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("iabau")).then(({ JcsProjectMenu: JcsProjectMenu })=>JcsProjectMenu), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/projects/jcs-project-menu/src/ui/project-menu/JcsProjectMenu.tsx"
});
const $df7bf058fd9c7924$export$30175e6def84a269 = /*#__PURE__*/ (0, $eJOHy.memo)(({ projectData: projectData, spotlight: spotlight, menuItemButtonRef: menuItemButtonRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.jcs-project-menu",
        packageName: "jiraNavigationAppsSidebarNav4JcsProjectMenu",
        teamName: "Boysenberry",
        ufoName: "nav4.sidebar.jcs-project-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.jcs-project-menu.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df7bf058fd9c7924$var$Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df7bf058fd9c7924$var$LazySidebarContent, {
        projectData: projectData,
        spotlight: spotlight,
        menuItemButtonRef: menuItemButtonRef
    }))));

});
parcelRegister("iabau", function(module, exports) {

let $d391d2f238c81a53$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d391d2f238c81a53$var$load("hGSh0").then(()=>parcelRequire('e5DTv'));

});


parcelRegister("3Nj6K", function(module, exports) {

$parcel$export(module.exports, "JswProjectMenu", () => $4cc1c0fd5218172a$export$6bfce83b67850c4);

var $a7ted = parcelRequire("a7ted");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $ln6Iy = parcelRequire("ln6Iy");

var $3yuGT = parcelRequire("3yuGT");

var $gT0jg = parcelRequire("gT0jg");
const $4cc1c0fd5218172a$export$6bfce83b67850c4 = ({ projectData: projectData, spotlight: spotlight, menuItemAnchorRef: menuItemAnchorRef, menuItemButtonRef: menuItemButtonRef })=>{
    const project = (0, $j4oe4.useFragment)((0, $a7ted.default), projectData);
    if (project.softwareBoardCount && project.softwareBoardCount > 0 && project.projectStyle === (0, $ln6Iy.COMPANY_MANAGED_PROJECT)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3yuGT.JswExpandableProject), {
        projectData: project,
        spotlight: spotlight,
        menuItemButtonRef: menuItemButtonRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gT0jg.JswNonExpandableProject), {
        projectData: project,
        spotlight: spotlight,
        menuItemAnchorRef: menuItemAnchorRef
    });
};

});
parcelRegister("a7ted", function(module, exports) {

$parcel$export(module.exports, "default", () => $deeb8c7e29322855$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<142350677583825fa114d01e8067ae41>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $deeb8c7e29322855$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "JswProjectMenu",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "FragmentSpread",
            "name": "JswNonExpandableProject"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JswExpandableProject"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JswExpandableProjectNew"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$deeb8c7e29322855$var$node.hash = "ef673d7daab31033c619bf95c78cd4b4";
var $deeb8c7e29322855$export$2e2bcd8739ae039 = $deeb8c7e29322855$var$node;

});

parcelRegister("3yuGT", function(module, exports) {

$parcel$export(module.exports, "JswExpandableProject", () => $5988c926da25ecd5$export$a77599e713340697);

var $fLIwo = parcelRequire("fLIwo");

var $60YqG = parcelRequire("60YqG");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7IJ7W = parcelRequire("7IJ7W");
var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $2Of18 = parcelRequire("2Of18");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $762yz = parcelRequire("762yz");

var $dN2O6 = parcelRequire("dN2O6");

var $h4Bzb = parcelRequire("h4Bzb");

var $lvrbL = parcelRequire("lvrbL");

var $if69u = parcelRequire("if69u");

var $206hf = parcelRequire("206hf");

var $azEgq = parcelRequire("azEgq");

var $hPlDs = parcelRequire("hPlDs");

var $iKXaJ = parcelRequire("iKXaJ");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $lQ7DI = parcelRequire("lQ7DI");

var $eApSa = parcelRequire("eApSa");


var $jrulJ = parcelRequire("jrulJ");

var $2FqDG = parcelRequire("2FqDG");

var $bJscI = parcelRequire("bJscI");

var $7fbRv = parcelRequire("7fbRv");

var $jd93d = parcelRequire("jd93d");

var $fAZgY = parcelRequire("fAZgY");

var $1NfYk = parcelRequire("1NfYk");


var $5DQfo = parcelRequire("5DQfo");

var $cMFhN = parcelRequire("cMFhN");
const $5988c926da25ecd5$var$JswExpandableProjectOld = ({ projectData: projectData, spotlight: spotlight, menuItemButtonRef: menuItemButtonRef })=>{
    const { sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent } = (0, $dN2O6.useProjectsAnalyticsL1)();
    const project = (0, $j4oe4.useFragment)((0, $60YqG.default), projectData);
    const cloudId = (0, $kEUB1.useCloudId)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId
            },
            context: {
                match: {
                    params: {
                        projectKey: project.projectKey
                    }
                }
            }
        }), [
        cloudId,
        project.projectKey
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const leftSidebarEPRef = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$50ea883ba6f28ff5));
    const boardsEPRef = leftSidebarEPRef?.entryPoints?.boards;
    const [projectKey] = (0, $2FqDG.usePathParam)('projectKey');
    const shouldRenderBoardsEntryPoint = project.projectKey === projectKey;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $5DQfo.nav4JSWProjectEntryPoint), entryPointParams);
    const actionsOnHoverEntryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectId: project.id
        }), [
        cloudId,
        project.id
    ]);
    const { entryPointActions: actionsOnHoverEntryPointActions, entryPointReferenceSubject: actionsOnHoverEntryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $cMFhN.asyncActionsOnHover), actionsOnHoverEntryPointParams);
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    const actionsOnHoverCollapsedRef = (0, $lQ7DI.useHoverEntryPointTrigger)(actionsOnHoverEntryPointActions);
    const { getLinkProps: getLinkProps } = (0, $206hf.useGetLinkProps)();
    // Create this component once, then keep using it FOREVER.
    // We don't want to keep switching the implementation as the user does SPA transitions.
    const [entryPointConfig] = (0, $eJOHy.useState)(()=>{
        const epContainerProps = {
            id: 'jsw-expandable-project',
            packageName: (0, $62baa2e6fd157602$export$b8b9d90f9e5bd72b),
            teamName: (0, $62baa2e6fd157602$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            runtimeProps: entryPointParams
        };
        return {
            Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eApSa.RouteEntryPointContainer), {
                    epContainerProps: epContainerProps,
                    jiraEPRef: entryPointReferenceSubject,
                    nestedEPRef: boardsEPRef,
                    placeholderEntryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint),
                    shouldRenderNestedEntryPoint: shouldRenderBoardsEntryPoint
                })
        };
    });
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(entryPointConfig.Component, null);
    const onSystemToggle = (0, $fAZgY.useCallbackWithCondition)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            actionsOnHoverEntryPointActions.load();
        }
    }, [
        actionsOnHoverEntryPointActions,
        entryPointActions
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const onExpansionToggle = (0, $fAZgY.useCallbackWithCondition)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            actionsOnHoverEntryPointActions.load();
            sendProjectMenuItemAnalyticsEvent({
                starred: project.isFavourite ?? false,
                recent: !project.isFavourite,
                projectId: project.projectId,
                projectType: project.projectType
            });
        }
    }, [
        actionsOnHoverEntryPointActions,
        entryPointActions,
        project.isFavourite,
        project.projectId,
        project.projectType,
        sendProjectMenuItemAnalyticsEvent
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const onClick = (0, $fAZgY.useCallbackWithCondition)((ev)=>{
        if ((0, $762yz.isNormalClick)(ev)) ev.preventDefault();
    }, [], ()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const { state: state, draggableAnchorRef: draggableAnchorRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, dragPreview: dragPreview, hasDragIndicator: hasDragIndicator } = (0, $1NfYk.useProjectMenuItemDragAndDrop)({
        projectId: project.projectId,
        projectKey: project.projectKey,
        isFavourite: project.isFavourite,
        name: project.name,
        avatar: project.avatar,
        isEnabled: !!project.isFavourite && (0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false)
    });
    if (!project) return null;
    const menuId = (0, $h4Bzb.ENTITY_ID).PROJECT(project.projectKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: menuId,
        onSystemToggle: onSystemToggle,
        collapsedRef: actionsOnHoverCollapsedRef,
        onExpansionToggle: onExpansionToggle,
        dropIndicator: dropIndicator,
        dropTargetRef: dropTargetRef,
        isDragging: state.type === 'dragging'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Of18.OnboardingSpotlightMaybe), {
        key: project.projectKey,
        spotlight: spotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        ...getLinkProps((0, $iKXaJ.removeBaseUrl)(project.webUrl)),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: actionsOnHoverEntryPointReferenceSubject,
            id: "jsw-expandable-project-actions",
            packageName: (0, $62baa2e6fd157602$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $62baa2e6fd157602$export$d57b6b390e78d90f),
            runtimeProps: actionsOnHoverEntryPointParams
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7IJ7W.ContainerAvatar), {
            src: project.avatar.large
        }),
        ref: (0, $jd93d.mergeRefs)(draggableAnchorRef, ...[
            triggerRef,
            menuItemButtonRef
        ].filter(Boolean)),
        onClick: onClick,
        testId: (0, $azEgq.getTestId)(menuId),
        hasDragIndicator: hasDragIndicator,
        isDragging: state.type === 'dragging'
    }, project.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, content())), dragPreview);
};
const $5988c926da25ecd5$var$JswExpandableProjectNew = ({ projectData: projectData, spotlight: spotlight, menuItemButtonRef: menuItemButtonRef })=>{
    const { sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent } = (0, $dN2O6.useProjectsAnalyticsL1)();
    const project = (0, $j4oe4.useFragment)((0, $fLIwo.default), projectData);
    const cloudId = (0, $kEUB1.useCloudId)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId
            },
            context: {
                match: {
                    params: {
                        projectKey: project.projectKey
                    }
                }
            }
        }), [
        cloudId,
        project.projectKey
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const leftSidebarEPRef = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$50ea883ba6f28ff5));
    const boardsEPRef = leftSidebarEPRef?.entryPoints?.boards;
    const [projectKey] = (0, $2FqDG.usePathParam)('projectKey');
    const shouldRenderBoardsEntryPoint = project.projectKey === projectKey;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $5DQfo.nav4JSWProjectEntryPoint), entryPointParams);
    const triggerRef = (0, $hPlDs.useExpandableEntryPointTrigger)(entryPointActions);
    const { getLinkProps: getLinkProps } = (0, $206hf.useGetLinkProps)();
    // Create this component once, then keep using it FOREVER.
    // We don't want to keep switching the implementation as the user does SPA transitions.
    const [entryPointConfig] = (0, $eJOHy.useState)(()=>{
        const epContainerProps = {
            id: 'jsw-expandable-project',
            packageName: (0, $62baa2e6fd157602$export$b8b9d90f9e5bd72b),
            teamName: (0, $62baa2e6fd157602$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            runtimeProps: entryPointParams
        };
        return {
            Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eApSa.RouteEntryPointContainer), {
                    epContainerProps: epContainerProps,
                    jiraEPRef: entryPointReferenceSubject,
                    nestedEPRef: boardsEPRef,
                    placeholderEntryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint),
                    shouldRenderNestedEntryPoint: shouldRenderBoardsEntryPoint
                })
        };
    });
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(entryPointConfig.Component, null);
    const onSystemToggle = (0, $fAZgY.useCallbackWithCondition)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const onExpansionToggle = (0, $fAZgY.useCallbackWithCondition)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            sendProjectMenuItemAnalyticsEvent({
                starred: project.isFavourite ?? false,
                recent: !project.isFavourite,
                projectId: project.projectId,
                projectType: project.projectType
            });
        }
    }, [
        entryPointActions,
        project.isFavourite,
        project.projectId,
        project.projectType,
        sendProjectMenuItemAnalyticsEvent
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const onClick = (0, $fAZgY.useCallbackWithCondition)((ev)=>{
        if ((0, $762yz.isNormalClick)(ev)) ev.preventDefault();
    }, [], ()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const { state: state, draggableAnchorRef: draggableAnchorRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, dragPreview: dragPreview, hasDragIndicator: hasDragIndicator } = (0, $1NfYk.useProjectMenuItemDragAndDrop)({
        projectId: project.projectId,
        projectKey: project.projectKey,
        isFavourite: project.isFavourite,
        name: project.name,
        avatar: project.avatar,
        isEnabled: !!project.isFavourite && (0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false)
    });
    if (!project) return null;
    const menuId = (0, $h4Bzb.ENTITY_ID).PROJECT(project.projectKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        menuId: menuId,
        onSystemToggle: onSystemToggle,
        onExpansionToggle: onExpansionToggle,
        dropIndicator: dropIndicator,
        dropTargetRef: dropTargetRef,
        isDragging: state.type === 'dragging'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Of18.OnboardingSpotlightMaybe), {
        key: project.projectKey,
        spotlight: spotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        ...getLinkProps((0, $iKXaJ.removeBaseUrl)(project.webUrl)),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fbRv.ProjectActions), {
            projectFragment: project
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7IJ7W.ContainerAvatar), {
            src: project.avatar.large
        }),
        ref: (0, $jd93d.mergeRefs)(draggableAnchorRef, ...[
            triggerRef,
            menuItemButtonRef
        ].filter(Boolean)),
        onClick: onClick,
        testId: (0, $azEgq.getTestId)(menuId),
        hasDragIndicator: hasDragIndicator,
        isDragging: state.type === 'dragging',
        interactionName: (0, $7jTnu.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-jsw-project' : undefined
    }, project.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, content())), dragPreview);
};
const $5988c926da25ecd5$export$a77599e713340697 = (0, $bJscI.componentWithFG)('project-actions-sync-iv-llc', $5988c926da25ecd5$var$JswExpandableProjectNew, $5988c926da25ecd5$var$JswExpandableProjectOld);

});
parcelRegister("fLIwo", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfe04c9e74f24511$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b0539709d32aef0321d580c26487ecb9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dfe04c9e74f24511$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JswExpandableProjectNew",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW",
                        "path": "avatar.large"
                    }
                ]
            },
            "action": "THROW",
            "path": "avatar"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "webUrl"
            },
            "action": "THROW",
            "path": "webUrl"
        },
        {
            "kind": "FragmentSpread",
            "name": "ProjectActions"
        }
    ],
    "type": "JiraProject"
};
$dfe04c9e74f24511$var$node.hash = "10a0c9f1c3e33b86d8b25d5721530355";
var $dfe04c9e74f24511$export$2e2bcd8739ae039 = $dfe04c9e74f24511$var$node;

});

parcelRegister("60YqG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee7950a6fbc6db3a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9727aa71a5cdff573b12535f712a837b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ee7950a6fbc6db3a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JswExpandableProject",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW",
                        "path": "avatar.large"
                    }
                ]
            },
            "action": "THROW",
            "path": "avatar"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "webUrl"
            },
            "action": "THROW",
            "path": "webUrl"
        }
    ],
    "type": "JiraProject"
};
$ee7950a6fbc6db3a$var$node.hash = "bc82624e777151d194c0c11c3eca6c58";
var $ee7950a6fbc6db3a$export$2e2bcd8739ae039 = $ee7950a6fbc6db3a$var$node;

});

parcelRegister("762yz", function(module, exports) {

$parcel$export(module.exports, "isNormalClick", () => $79b800b4de890321$export$729f3684d5c2b9b9);
const $79b800b4de890321$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);

});

parcelRegister("206hf", function(module, exports) {

$parcel$export(module.exports, "useGetLinkProps", () => $2cc0385e8de7b401$export$a3307878c8496d13);

var $eJOHy = parcelRequire("eJOHy");

var $02kpm = parcelRequire("02kpm");

var $jRu18 = parcelRequire("jRu18");
const $2cc0385e8de7b401$export$a3307878c8496d13 = ()=>{
    const location = (0, $jRu18.useLocation)();
    const getLinkProps = (0, $eJOHy.useCallback)((menuItemPath, options)=>$2cc0385e8de7b401$var$getMenuLinkPropsFromUrlPath({
            currentPath: location.pathname,
            menuItemPath: menuItemPath,
            options: options
        }), [
        location.pathname
    ]);
    const getLinkPropsFromRoute = (0, $eJOHy.useCallback)((menuItemRoute, pathParamValues = {}, options)=>{
        const menuItemPath = (0, $02kpm.generatePath)(menuItemRoute.path, pathParamValues);
        return getLinkProps(menuItemPath, options);
    }, [
        getLinkProps
    ]);
    return {
        getLinkPropsFromRoute: getLinkPropsFromRoute,
        getLinkProps: /**
		 * Consider using getLinkPropsFromRoute instead, to be able to reuse the page route object, rather than copying its url path around.
		 */ getLinkProps
    };
};
const $2cc0385e8de7b401$var$defaultOptions = {
    shouldMatchExactPath: true
};
const $2cc0385e8de7b401$var$getMenuLinkPropsFromUrlPath = ({ currentPath: currentPath, menuItemPath: menuItemPath, options: options })=>{
    const { shouldMatchExactPath: shouldMatchExactPath } = {
        ...$2cc0385e8de7b401$var$defaultOptions,
        ...options
    };
    return {
        href: menuItemPath,
        isSelected: shouldMatchExactPath ? currentPath.replace(/\/$/, '') === menuItemPath.replace(/\/$/, '') : currentPath.includes(menuItemPath.replace(/\/$/, ''))
    };
};

});

parcelRegister("iKXaJ", function(module, exports) {

$parcel$export(module.exports, "removeBaseUrl", () => $77577f77d57d6c9b$export$d401b6140b158f69);
/**
 * Removes the base URL from the given URL string.
 *
 * @param url - The URL string from which to remove the base URL.
 * @returns The URL string with the base URL removed.
 */ const $77577f77d57d6c9b$export$d401b6140b158f69 = (url)=>url.replace(/https?:\/\/[^/]+/, '');

});

parcelRegister("7fbRv", function(module, exports) {

$parcel$export(module.exports, "ProjectActions", () => $8ba2842cf1fe0c21$export$7f68bfd3564d5c6f);

var $ewTnc = parcelRequire("ewTnc");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $i140O = parcelRequire("i140O");

var $gPqEA = parcelRequire("gPqEA");

var $9JB3T = parcelRequire("9JB3T");

var $lRq8t = parcelRequire("lRq8t");

var $lHnXI = parcelRequire("lHnXI");

var $ajqBI = parcelRequire("ajqBI");

var $bS07j = parcelRequire("bS07j");

var $1vZwP = parcelRequire("1vZwP");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $c9EyR = parcelRequire("c9EyR");

var $iBeto = parcelRequire("iBeto");
const $8ba2842cf1fe0c21$var$Trigger = ({ triggerRef: triggerRef, isFavourite: isFavourite, projectId: projectId, projectType: projectType, setCreateBoardButtonRef: setCreateBoardButtonRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { sendCreateBoardOnBoardMenuItemAnalyticsEvent: sendCreateBoardOnBoardMenuItemAnalyticsEvent } = (0, $lHnXI.useProjectsAnalyticsL2)();
    // callback to set button element to local ref.
    // to be used as prop for setting focus back to button after modal close.
    const setRef = (0, $eJOHy.useCallback)((buttonElement)=>{
        setCreateBoardButtonRef(buttonElement);
        if (typeof triggerRef === 'function') triggerRef(buttonElement);
    }, [
        setCreateBoardButtonRef,
        triggerRef
    ]);
    const onCommonNavMenuButtonClick = (0, $eJOHy.useCallback)((event)=>{
        const { onClick: onClick } = props;
        onClick?.(event);
        sendCreateBoardOnBoardMenuItemAnalyticsEvent({
            starred: isFavourite ?? false,
            recent: !isFavourite,
            projectId: projectId,
            projectType: projectType
        });
    }, [
        isFavourite,
        projectId,
        projectType,
        props,
        sendCreateBoardOnBoardMenuItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: formatMessage((0, $iBeto.default).createBoard)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        ...props,
        onClick: onCommonNavMenuButtonClick,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i140O))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $iBeto.default).createBoard),
        ref: setRef
    }));
};
const $8ba2842cf1fe0c21$export$7f68bfd3564d5c6f = ({ projectFragment: projectFragment, isCorePremiumUserSeat: isCorePremiumUserSeat = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent, sendCreateBoardOnBoardMenuItemAnalyticsEvent: sendCreateBoardOnBoardMenuItemAnalyticsEvent } = (0, $lHnXI.useProjectsAnalyticsL2)();
    const createBoardButtonRef = (0, $eJOHy.useRef)(null);
    const project = (0, $j4oe4.useFragment)((0, $ewTnc.default), projectFragment);
    const onProjectActionMenuClick = (0, $eJOHy.useCallback)(()=>{
        sendMeatBallDropDownOnProjectsAnalyticsEvent({
            starred: project.isFavourite ?? false,
            recent: !project.isFavourite,
            projectId: project.projectId,
            projectType: project.projectType
        });
    }, [
        project.isFavourite,
        project.projectId,
        project.projectType,
        sendMeatBallDropDownOnProjectsAnalyticsEvent
    ]);
    const projectActionMenu = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bS07j.ProjectActionMenu), {
            ...(0, $7jTnu.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
                projectName: project.name
            } : {},
            onClick: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? onProjectActionMenuClick : ()=>{
                sendMeatBallDropDownOnProjectsAnalyticsEvent({
                    starred: project.isFavourite ?? false,
                    recent: !project.isFavourite,
                    projectId: project.projectId,
                    projectType: project.projectType
                });
            },
            projectKey: project.projectKey,
            isCorePremiumUserSeat: isCorePremiumUserSeat,
            isProjectMenuReorderingEnabled: project?.isFavourite === true && (0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false)
        });
    }, [
        project.name,
        project.projectKey,
        project.projectId,
        project.isFavourite,
        project.projectType,
        onProjectActionMenuClick,
        isCorePremiumUserSeat,
        sendMeatBallDropDownOnProjectsAnalyticsEvent
    ]);
    const setCreateBoardButtonRef = (0, $eJOHy.useCallback)((instance)=>{
        createBoardButtonRef.current = instance;
    }, [
        createBoardButtonRef
    ]);
    const renderTrigger = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ba2842cf1fe0c21$var$Trigger, {
            ...props,
            isFavourite: project.isFavourite ?? false,
            projectId: project.projectId,
            projectType: project.projectType,
            setCreateBoardButtonRef: setCreateBoardButtonRef
        }), [
        project.isFavourite,
        project.projectId,
        project.projectType,
        setCreateBoardButtonRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPqEA.default), {
        gap: "space.050",
        alignItems: "center"
    }, (0, $c9EyR.isCompanyManagedSoftwareProject)(project.projectStyle, project.projectType) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1vZwP.BoardCreate), {
        projectId: project.projectId,
        projectAvatar: project.avatar?.large || undefined,
        triggerRef: createBoardButtonRef,
        renderTrigger: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? renderTrigger : ({ triggerRef: triggerRef, ...props })=>{
            // callback to set button element to local ref.
            // to be used as prop for setting focus back to button after modal close.
            const setRef = (buttonElement)=>{
                createBoardButtonRef.current = buttonElement;
                if (typeof triggerRef === 'function') triggerRef(buttonElement);
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
                content: formatMessage((0, $iBeto.default).createBoard)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
                ...props,
                onClick: (event)=>{
                    const { onClick: onClick } = props;
                    onClick?.(event);
                    sendCreateBoardOnBoardMenuItemAnalyticsEvent({
                        starred: project.isFavourite ?? false,
                        recent: !project.isFavourite,
                        projectId: project.projectId,
                        projectType: project.projectType
                    });
                },
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i140O))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: formatMessage((0, $iBeto.default).createBoard),
                ref: setRef
            }));
        }
    })), projectActionMenu);
};

});
parcelRegister("ewTnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $27697303e42019e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<94412159ecf4c6719e0b693430702470>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $27697303e42019e8$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "ProjectActions",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$27697303e42019e8$var$node.hash = "9dfad03558453fb6e77a8bab64d959e3";
var $27697303e42019e8$export$2e2bcd8739ae039 = $27697303e42019e8$var$node;

});

parcelRegister("1vZwP", function(module, exports) {

$parcel$export(module.exports, "BoardCreate", () => $724aa2c910f9e79e$export$c753ba73bc24874c);

var $eJOHy = parcelRequire("eJOHy");

var $gHO4S = parcelRequire("gHO4S");

var $s6xA3 = parcelRequire("s6xA3");
const $724aa2c910f9e79e$export$c753ba73bc24874c = ({ projectId: projectId, projectAvatar: projectAvatar, renderTrigger: renderTrigger, triggerRef: triggerRef })=>{
    if (!projectId) {
        (0, $gHO4S.fireBoardCreateErrorAnalytics)({
            error: new Error('Failed to load board create flyout menu: projectId undefined'),
            attributes: {
                projectId: projectId
            },
            id: 'loadFlyoutMenu'
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $s6xA3.BoardCreateFlyoutMenu), {
        renderTrigger: renderTrigger,
        projectId: projectId,
        projectAvatar: projectAvatar,
        triggerRef: triggerRef
    });
};

});
parcelRegister("gHO4S", function(module, exports) {

$parcel$export(module.exports, "fireBoardCreateErrorAnalytics", () => $61df6e2e77086e7b$export$77dbc1f87d29b068);
$parcel$export(module.exports, "descriptionMapping", () => $61df6e2e77086e7b$export$56900bfb74887fe8);

var $gYnSx = parcelRequire("gYnSx");

var $2pys5 = parcelRequire("2pys5");

var $pkfsB = parcelRequire("pkfsB");
const $61df6e2e77086e7b$export$77dbc1f87d29b068 = ({ attributes: attributes, id: id, error: error })=>{
    (0, $gYnSx.default)({
        error: error,
        attributes: attributes,
        meta: {
            id: `jiraSoftwareBoardCreate_${id}`,
            packageName: (0, $2pys5.BOARD_CREATE_PACKAGE_NAME),
            teamName: (0, $2pys5.TEAM_NAME)
        }
    });
};
const $61df6e2e77086e7b$export$56900bfb74887fe8 = {
    [(0, $2pys5.BOARD_TYPES).KANBAN]: (0, $pkfsB.default).kanbanBoardCreationDescription,
    [(0, $2pys5.BOARD_TYPES).SCRUM]: (0, $pkfsB.default).scrumBoardCreationDescription
};

});
parcelRegister("2pys5", function(module, exports) {

$parcel$export(module.exports, "FLYOUT_MENU_CONTENT_ID", () => $8c7271f72bf58c54$export$ff67d81ebedcc801);
$parcel$export(module.exports, "BOARD_CREATE_PACKAGE_NAME", () => $8c7271f72bf58c54$export$3df8123340981894);
$parcel$export(module.exports, "TEAM_NAME", () => $8c7271f72bf58c54$export$d57b6b390e78d90f);
$parcel$export(module.exports, "BOARD_TYPES", () => $8c7271f72bf58c54$export$165dc6fdd115b0c1);
$parcel$export(module.exports, "BOARD_SOURCE_FIELDS", () => $8c7271f72bf58c54$export$318250ad9945de5c);
$parcel$export(module.exports, "BOARD_SOURCE_FIELDS_JQLTERM", () => $8c7271f72bf58c54$export$9f85086c10bd31f5);
$parcel$export(module.exports, "PICKER_SEARCH_DEBOUNCE_TIME", () => $8c7271f72bf58c54$export$f487cf015ececc3a);
$parcel$export(module.exports, "VALIDATION_ERROR_EMPTY", () => $8c7271f72bf58c54$export$7b060a5763a6e199);
$parcel$export(module.exports, "BOARD_NAME_LIMIT", () => $8c7271f72bf58c54$export$d760e95d248dc3a3);
const $8c7271f72bf58c54$export$edded98b84a6f50f = 'jsw-board-create';
const $8c7271f72bf58c54$export$ff67d81ebedcc801 = 'jsw-board-create-flyout-menu-content';
const $8c7271f72bf58c54$export$3df8123340981894 = 'jiraSoftwareBoardCreate';
const $8c7271f72bf58c54$export$d57b6b390e78d90f = 'a4t-pandora';
const $8c7271f72bf58c54$export$165dc6fdd115b0c1 = {
    KANBAN: 'KANBAN',
    SCRUM: 'SCRUM'
};
const $8c7271f72bf58c54$export$318250ad9945de5c = {
    TEAM: 'team',
    ISSUE_TYPES: 'issueTypes',
    LABELS: 'labels',
    SAVED_FILTER: 'savedFilter'
};
const $8c7271f72bf58c54$export$9f85086c10bd31f5 = {
    [$8c7271f72bf58c54$export$318250ad9945de5c.ISSUE_TYPES]: 'type',
    [$8c7271f72bf58c54$export$318250ad9945de5c.LABELS]: 'labels'
};
const $8c7271f72bf58c54$export$f487cf015ececc3a = 500;
const $8c7271f72bf58c54$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
const $8c7271f72bf58c54$export$d760e95d248dc3a3 = 155;

});

parcelRegister("pkfsB", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d0bbdf347baf74e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1d0bbdf347baf74e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    boardCreationTitle: {
        "id": "software-board-create.common.board-creation-title",
        "defaultMessage": "Create a board"
    },
    scrumBoardCreationHeader: {
        "id": "software-board-create.common.scrum-board-creation-header",
        "defaultMessage": "Scrum"
    },
    scrumBoardCreationDescription: {
        "id": "software-board-create.common.scrum-board-creation-description",
        "defaultMessage": "Sprint towards your team objectives with a board, backlog, and reports."
    },
    kanbanBoardCreationHeader: {
        "id": "software-board-create.common.kanban-board-creation-header",
        "defaultMessage": "Kanban"
    },
    kanbanBoardCreationDescription: {
        "id": "software-board-create.common.kanban-board-creation-description",
        "defaultMessage": "Manage a continuous delivery of work with a kanban board and reports."
    },
    loadSavedFiltersErrorTitle: {
        "id": "software-board-create.common.load-saved-filters-error-title",
        "defaultMessage": "We can\u2019t load saved filters right now"
    },
    loadSavedFiltersErrorDescription: {
        "id": "software-board-create.common.load-saved-filters-error-description",
        "defaultMessage": "Refresh the page and try again."
    },
    requiredFieldsHeader: {
        "id": "software-board-create.common.required-fields-header",
        "defaultMessage": "Required fields are marked with an asterisk *"
    }
});

});


parcelRegister("s6xA3", function(module, exports) {

$parcel$export(module.exports, "BoardCreateFlyoutMenu", () => $7a6ae5b5b2b1e183$export$6a893f4168172b4e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $4BzUI = parcelRequire("4BzUI");

var $gtHL8 = parcelRequire("gtHL8");

var $i140O = parcelRequire("i140O");

var $3Xinh = parcelRequire("3Xinh");
const $7a6ae5b5b2b1e183$export$a27652ddcad2c9dc = ({ triggerRef: triggerRef, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BzUI.default), {
        ...props,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i140O))),
        label: "create board",
        ref: triggerRef,
        testId: "software-board-create.ui.flyout-menu.trigger"
    });
};
const $7a6ae5b5b2b1e183$export$6a893f4168172b4e = ({ renderTrigger: Trigger = $7a6ae5b5b2b1e183$export$a27652ddcad2c9dc, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gtHL8.default), {
        trigger: Trigger,
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Xinh.AsyncFlyoutMenuContent), props));

});
parcelRegister("3Xinh", function(module, exports) {

$parcel$export(module.exports, "AsyncFlyoutMenuContent", () => $daa7d9cc53a0d5d2$export$3f0e1916911c9d6a);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $2pys5 = parcelRequire("2pys5");

var $c4dwE = parcelRequire("c4dwE");

var $dFmiu = parcelRequire("dFmiu");
const $daa7d9cc53a0d5d2$var$entryPointParams = {};
const $daa7d9cc53a0d5d2$export$3f0e1916911c9d6a = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $c4dwE.flyoutMenuContentEntryPoint), $daa7d9cc53a0d5d2$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: (0, $2pys5.FLYOUT_MENU_CONTENT_ID),
        packageName: (0, $2pys5.BOARD_CREATE_PACKAGE_NAME),
        teamName: (0, $2pys5.TEAM_NAME),
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFmiu.FlyoutMenuContentFallback), null),
        errorFallback: "flag",
        runtimeProps: props
    });
};

});
parcelRegister("c4dwE", function(module, exports) {

$parcel$export(module.exports, "flyoutMenuContentEntryPoint", () => $6e0d67a33165eb27$export$e6b36ab0519985d7);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $6e0d67a33165eb27$export$e6b36ab0519985d7 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("9KojZ"))), {
        moduleId: "53a3dd04",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9KojZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "FlyoutContentContainer", () => $842059c90f492bbb$export$b7a36d8992ebabdb);
$parcel$export(module.exports, "default", () => $842059c90f492bbb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lfSKL = parcelRequire("lfSKL");

var $kkAKd = parcelRequire("kkAKd");

var $7WlWj = parcelRequire("7WlWj");

var $jkibc = parcelRequire("jkibc");
var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $lRq8t = parcelRequire("lRq8t");

var $2pys5 = parcelRequire("2pys5");

var $pkfsB = parcelRequire("pkfsB");

var $gXjgd = parcelRequire("gXjgd");
const $842059c90f492bbb$export$b7a36d8992ebabdb = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $842059c90f492bbb$var$menuContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $842059c90f492bbb$var$headerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $842059c90f492bbb$var$headerStyles
    }, formatMessage((0, $pkfsB.default).boardCreationTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jkibc.default), {
        block: "space.050"
    }, children));
};
const $842059c90f492bbb$var$BoardCreateFlyoutMenuContent = ({ props: { projectId: projectId, projectAvatar: projectAvatar, triggerRef: triggerRef } })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const dropdownItems = (0, $eJOHy.useMemo)(()=>{
        const items = [
            {
                boardType: (0, $2pys5.BOARD_TYPES).SCRUM,
                title: formatMessage((0, $pkfsB.default).scrumBoardCreationHeader),
                description: formatMessage((0, $pkfsB.default).scrumBoardCreationDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7WlWj))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })
            },
            {
                boardType: (0, $2pys5.BOARD_TYPES).KANBAN,
                title: formatMessage((0, $pkfsB.default).kanbanBoardCreationHeader),
                description: formatMessage((0, $pkfsB.default).kanbanBoardCreationDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkAKd))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })
            }
        ];
        return items.map(({ boardType: boardType, ...props }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gXjgd.DropdownItemContainer), {
                key: boardType,
                entryPointProps: {
                    boardType: boardType,
                    projectId: projectId,
                    projectAvatar: projectAvatar,
                    triggerRef: triggerRef
                },
                index: index,
                ...props
            }));
    }, [
        formatMessage,
        projectId,
        projectAvatar,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($842059c90f492bbb$export$b7a36d8992ebabdb, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lfSKL.default), null, dropdownItems));
};
var $842059c90f492bbb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($842059c90f492bbb$var$BoardCreateFlyoutMenuContent);
const $842059c90f492bbb$var$headerStyles = (0, $5Wv5g.xcss)({
    font: 'font.heading.xxsmall',
    color: 'color.text.subtlest'
});
const $842059c90f492bbb$var$menuContainerStyles = (0, $5Wv5g.xcss)({
    width: '273px',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $842059c90f492bbb$var$headerContainerStyles = (0, $5Wv5g.xcss)({
    height: 'space.200',
    padding: 'space.200',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});
parcelRegister("kkAKd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ecd22d9929db0338$var$_react = $ecd22d9929db0338$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ecd22d9929db0338$var$_baseNew = $ecd22d9929db0338$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $ecd22d9929db0338$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ecd22d9929db0338$var$BoardIcon = (props)=>/*#__PURE__*/ $ecd22d9929db0338$var$_react.default.createElement($ecd22d9929db0338$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$ecd22d9929db0338$var$BoardIcon.displayName = 'BoardIcon';
var $ecd22d9929db0338$var$_default = module.exports.default = $ecd22d9929db0338$var$BoardIcon;

});

parcelRegister("7WlWj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3028194b67909de4178ae7b995e8e7b7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c7ef7e967b91881$var$_react = $5c7ef7e967b91881$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5c7ef7e967b91881$var$_baseNew = $5c7ef7e967b91881$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $5c7ef7e967b91881$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c7ef7e967b91881$var$SprintIcon = (props)=>/*#__PURE__*/ $5c7ef7e967b91881$var$_react.default.createElement($5c7ef7e967b91881$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A4.75 4.75 0 0 0 8 11h5.44l-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H0V11h3.938A6.25 6.25 0 1 1 14.25 6.25h-1.5A4.75 4.75 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$5c7ef7e967b91881$var$SprintIcon.displayName = 'SprintIcon';
var $5c7ef7e967b91881$var$_default = module.exports.default = $5c7ef7e967b91881$var$SprintIcon;

});

parcelRegister("jkibc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a22c55b172b35410$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $5Wv5g = parcelRequire("5Wv5g");
function $a22c55b172b35410$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a22c55b172b35410$var$baseStyles = {
    name: "1khn195",
    styles: "box-sizing:border-box"
};
const $a22c55b172b35410$var$blockBleedMap = {
    'space.025': {
        name: "9w2fxh",
        styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "1qhe0y6",
        styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "s0o2nz",
        styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "151e4o3",
        styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "16sn062",
        styles: "margin-block:var(--ds-space-negative-200, -1rem)"
    }
};
const $a22c55b172b35410$var$inlineBleedMap = {
    'space.025': {
        name: "16oxh68",
        styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "tdc6fz",
        styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "crujrn",
        styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "y28d58",
        styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "1vfkteg",
        styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
    }
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $a22c55b172b35410$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    const resolvedStyles = (0, $5Wv5g.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $a22c55b172b35410$var$baseStyles,
            (inline || all) && $a22c55b172b35410$var$inlineBleedMap[inline || all],
            (block || all) && $a22c55b172b35410$var$blockBleedMap[block || all],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
});
$a22c55b172b35410$var$Bleed.displayName = 'Bleed';
var $a22c55b172b35410$export$2e2bcd8739ae039 = $a22c55b172b35410$var$Bleed;

});

parcelRegister("gXjgd", function(module, exports) {

$parcel$export(module.exports, "DropdownItemContainer", () => $38d7182a72bcfdd6$export$cfb1162696b4c012);

var $eJOHy = parcelRequire("eJOHy");

var $bvFRW = parcelRequire("bvFRW");

var $bL3dk = parcelRequire("bL3dk");
var $9LyfF = parcelRequire("9LyfF");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $lRq8t = parcelRequire("lRq8t");

var $d1S9l = parcelRequire("d1S9l");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $2pys5 = parcelRequire("2pys5");

var $8zVFR = parcelRequire("8zVFR");

var $lA5Hv = parcelRequire("lA5Hv");

var $8ySo1 = parcelRequire("8ySo1");
const $38d7182a72bcfdd6$export$cfb1162696b4c012 = ({ entryPointProps: entryPointProps, title: title, description: description, icon: icon, index: index })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const triggerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (index === 0 && triggerRef.current) triggerRef.current.focus();
    }, [
        index
    ]);
    const handleOnDropdownItemClick = (0, $eJOHy.useCallback)(()=>{
        const boardTypePascalCase = entryPointProps.boardType === (0, $2pys5.BOARD_TYPES).SCRUM ? 'Scrum' : 'Kanban';
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'dropdownItem',
            action: 'clicked'
        }), `create${boardTypePascalCase}Board`);
    }, [
        createAnalyticsEvent,
        entryPointProps.boardType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d1S9l.ModalEntryPointDropdownItemTrigger), {
        "aria-label": formatMessage((0, $8ySo1.default).createBoardLabel, {
            boardType: entryPointProps.boardType.toLowerCase()
        }),
        forwardedRef: triggerRef,
        entryPoint: (0, $8zVFR.boardCreateModalEntryPoint),
        testId: "software-board-create.ui.flyout-menu.flyout-menu-content.dropdown-item-container.dropdown-item-trigger",
        interactionName: "open-create-board-modal",
        entryPointProps: entryPointProps,
        Fallback: (0, $lA5Hv.BoardCreateModalFallback),
        onClick: handleOnDropdownItemClick,
        useInternalModal: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $38d7182a72bcfdd6$var$itemIconBackgroundStyles
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "xsmall"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        size: "medium"
    }, description))));
};
const $38d7182a72bcfdd6$var$ICON_BACKGROUND_CONTAINER_SIZE = '32px';
const $38d7182a72bcfdd6$var$itemIconBackgroundStyles = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.background.neutral',
    width: $38d7182a72bcfdd6$var$ICON_BACKGROUND_CONTAINER_SIZE,
    height: $38d7182a72bcfdd6$var$ICON_BACKGROUND_CONTAINER_SIZE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "2px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius-050, 3px)",
    padding: 'space.050',
    flexShrink: 0
});

});
parcelRegister("d1S9l", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointDropdownItemTrigger", () => $7b82c672bd4705e6$export$82b29db923c97084);

var $eJOHy = parcelRequire("eJOHy");

var $7Ga8U = parcelRequire("7Ga8U");

var $f7Yza = parcelRequire("f7Yza");
const $7b82c672bd4705e6$export$82b29db923c97084 = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, modalTitle: modalTitle, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef, ...dropdownProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
        forwardedRef: forwardedRef,
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        errorAttributes: errorAttributes,
        Fallback: Fallback,
        interactionName: interactionName,
        title: modalTitle,
        modalProps: modalProps,
        useInternalModal: useInternalModal
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Ga8U.default), {
            ref: ref,
            ...dropdownProps
        }, children));
};

});

parcelRegister("8zVFR", function(module, exports) {

$parcel$export(module.exports, "boardCreateModalEntryPoint", () => $6bb36caa19afd500$export$ae34a65266b8e906);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $6bb36caa19afd500$export$ae34a65266b8e906 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("lA5Hv"))), {
        moduleId: "6c073853",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lA5Hv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "BoardCreateModalFallback", () => $77703aafca192cbf$export$303db58b19f6b446);
$parcel$export(module.exports, "default", () => $77703aafca192cbf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $2ZGUP = parcelRequire("2ZGUP");

var $lRq8t = parcelRequire("lRq8t");

var $aC4Bh = parcelRequire("aC4Bh");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $pkfsB = parcelRequire("pkfsB");

var $gHO4S = parcelRequire("gHO4S");

var $iunk7 = parcelRequire("iunk7");

var $lQM4J = parcelRequire("lQM4J");

var $62xU6 = parcelRequire("62xU6");
const $77703aafca192cbf$var$MODAL_WIDTH = 1000;
const $77703aafca192cbf$var$MODAL_HEIGHT = 551;
const $77703aafca192cbf$export$303db58b19f6b446 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        height: $77703aafca192cbf$var$MODAL_HEIGHT,
        width: $77703aafca192cbf$var$MODAL_WIDTH,
        label: formatMessage((0, $62xU6.default).loadingLabel),
        messageId: "software-board-create.ui.modal.modal.board-create-modal-fallback",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lQM4J.BoardCreateFormFallback), null));
};
const $77703aafca192cbf$var$BoardCreateModal = ({ boardType: boardType, projectId: projectId, onClose: onClose, triggerRef: triggerRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleOnClose = (_mouseEvent, _analyticEvent, didSubmit)=>{
        const event = createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'modalDialog'
        });
        (0, $gCeeo.fireUIAnalytics)(event, 'createNewBoardModal', {
            didSubmit: !!didSubmit,
            boardType: boardType.toLowerCase()
        });
        onClose?.();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        testId: "software-board-create.ui.modal",
        onClose: handleOnClose,
        width: $77703aafca192cbf$var$MODAL_WIDTH,
        height: $77703aafca192cbf$var$MODAL_HEIGHT,
        messageId: "software-board-create.ui.modal.modal.board-create-modal",
        messageType: "transactional",
        label: `${formatMessage((0, $pkfsB.default).boardCreationTitle)}. ${formatMessage((0, $gHO4S.descriptionMapping)[boardType])}`,
        shouldReturnFocus: triggerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lQM4J.BoardCreateForm), {
        projectId: projectId,
        boardType: boardType,
        onClose: handleOnClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
        attributes: {
            boardType: boardType.toLowerCase()
        }
    }));
};
const $77703aafca192cbf$var$BoardCreateModalWithContext = ({ props: { projectAvatar: projectAvatar, ...restProps } })=>{
    const value = (0, $eJOHy.useMemo)(()=>({
            projectId: restProps.projectId,
            projectAvatar: projectAvatar
        }), [
        restProps.projectId,
        projectAvatar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iunk7.BoardCreateContext).Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "createNewBoard",
        sourceType: (0, $466f60259c330878$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77703aafca192cbf$var$BoardCreateModal, restProps))));
};
var $77703aafca192cbf$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($77703aafca192cbf$var$BoardCreateModalWithContext);

});
parcelRegister("iunk7", function(module, exports) {

$parcel$export(module.exports, "BoardCreateContext", () => $9b85d2de53abb4dd$export$5169319147995508);
$parcel$export(module.exports, "useBoardCreateContext", () => $9b85d2de53abb4dd$export$768ffccd7d71d6d9);

var $eJOHy = parcelRequire("eJOHy");
const $9b85d2de53abb4dd$var$initialContext = {
    projectId: undefined,
    projectAvatar: undefined
};
const $9b85d2de53abb4dd$export$5169319147995508 = /*#__PURE__*/ (0, $eJOHy.createContext)($9b85d2de53abb4dd$var$initialContext);
const $9b85d2de53abb4dd$export$768ffccd7d71d6d9 = ()=>(0, $eJOHy.useContext)($9b85d2de53abb4dd$export$5169319147995508);

});

parcelRegister("lQM4J", function(module, exports) {

$parcel$export(module.exports, "BoardCreateFormFallback", () => $ab5891a65cb0c148$export$efb232229a99ba7b);
$parcel$export(module.exports, "BoardCreateForm", () => $ab5891a65cb0c148$export$bc90d453a0e513ff);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jtnjR = parcelRequire("jtnjR");
var $1Xk9R = parcelRequire("1Xk9R");
var $emAda = parcelRequire("emAda");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");

var $aVwGC = parcelRequire("aVwGC");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $5nydL = parcelRequire("5nydL");

var $a8589 = parcelRequire("a8589");

var $4SlPH = parcelRequire("4SlPH");

var $kHJve = parcelRequire("kHJve");

var $hPEYy = parcelRequire("hPEYy");

var $kaWPn = parcelRequire("kaWPn");

var $bpQ9z = parcelRequire("bpQ9z");

var $6HOlT = parcelRequire("6HOlT");
const $ab5891a65cb0c148$export$efb232229a99ba7b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        xcss: $ab5891a65cb0c148$var$formContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.1000",
        xcss: $ab5891a65cb0c148$var$formContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        xcss: $ab5891a65cb0c148$var$columnStyles,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
        width: "150px",
        height: "20px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
        width: "100%",
        height: "12px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
        width: "20%",
        height: "12px",
        borderRadius: "3px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
        width: "100px",
        height: "12px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
        width: "100%",
        height: "30px",
        borderRadius: "3px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
        width: "200px",
        height: "12px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
        width: "100%",
        height: "30px",
        borderRadius: "3px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
        width: "70px",
        height: "32px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
        width: "70px",
        height: "32px",
        borderRadius: "3px"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        xcss: $ab5891a65cb0c148$var$columnStyles,
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
        width: "150px",
        height: "20px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
        width: "412px",
        height: "307px",
        borderRadius: "16px"
    }))));
};
const $ab5891a65cb0c148$export$bc90d453a0e513ff = ({ boardType: boardType, projectId: projectId, onClose: onClose })=>{
    const { submit: submit } = (0, $5nydL.useBoardCreateController)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const handleOnSubmit = (0, $eJOHy.useCallback)(async (data)=>{
        const errors = (0, $6HOlT.validateFormData)(data);
        const hasValidationErrors = errors.boardName || errors.sourceType || errors.sourceValue;
        let sourceValueLength = 0;
        if (data.sourceValue != null) sourceValueLength = Array.isArray(data.sourceValue) ? data.sourceValue.length : 1;
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $gCeeo.fireUIAnalytics)(event, 'createNewBoard', {
            sourceType: data.sourceType,
            sourceValueLength: sourceValueLength,
            errors: hasValidationErrors && errors
        });
        if (hasValidationErrors) return errors;
        await submit({
            boardType: boardType,
            formValues: data,
            locationProjectId: projectId ?? '',
            onSuccess: ()=>onClose(undefined, undefined, true)
        });
    }, [
        createAnalyticsEvent,
        submit,
        boardType,
        projectId,
        onClose
    ]);
    const resetSourceValue = (0, $eJOHy.useCallback)((setFieldValue)=>()=>setFieldValue((0, $bpQ9z.SOURCE_VALUE_FIELD_NAME), undefined), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        xcss: $ab5891a65cb0c148$var$formContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtnjR.default), {
        onSubmit: handleOnSubmit
    }, ({ formProps: formProps, submitting: submitting, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", {
            ...formProps,
            noValidate: true,
            className: (0, $hcewu.default)([
                "_18m91wug _1bsb1osq"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
            gap: "space.1000",
            xcss: $ab5891a65cb0c148$var$formContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
            xcss: $ab5891a65cb0c148$var$columnStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a8589.ModalHeader), {
            type: boardType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
            xcss: $ab5891a65cb0c148$var$formFieldsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emAda.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hPEYy.BoardNameField), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emAda.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kaWPn.SourceTypePicker), {
            resetSourceValue: resetSourceValue(setFieldValue)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bpQ9z.SourceValuePicker), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
            xcss: $ab5891a65cb0c148$var$buttonGroupContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Xk9R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kHJve.FormActions), {
            submitting: submitting,
            onClose: onClose
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
            xcss: $ab5891a65cb0c148$var$columnStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4SlPH.ModalIllustration), null))))));
};
const $ab5891a65cb0c148$var$formStyles = null;
const $ab5891a65cb0c148$var$formContentStyles = (0, $5Wv5g.xcss)({
    height: '100%',
    width: '100%'
});
const $ab5891a65cb0c148$var$columnStyles = (0, $5Wv5g.xcss)({
    width: 'calc(50% - 40px)',
    // space.1000 is 80px, thus 40px is the space on each side
    flex: 'none',
    paddingTop: 'space.200'
});
const $ab5891a65cb0c148$var$formFieldsContainerStyles = (0, $5Wv5g.xcss)({
    flexGrow: 1
});
const $ab5891a65cb0c148$var$buttonGroupContainerStyles = (0, $5Wv5g.xcss)({
    alignSelf: 'end',
    justifySelf: 'end'
});
const $ab5891a65cb0c148$var$formContainerStyles = (0, $5Wv5g.xcss)({
    paddingTop: 'space.600',
    paddingLeft: 'space.600',
    paddingRight: 'space.600',
    paddingBottom: 'space.500',
    height: '100%'
});

});
parcelRegister("5nydL", function(module, exports) {

$parcel$export(module.exports, "useBoardCreateController", () => $7434764e075e537a$export$b1247ee6c4be437f);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3osLr = parcelRequire("3osLr");

var $lRq8t = parcelRequire("lRq8t");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $aqnJa = parcelRequire("aqnJa");

var $5Q9JR = parcelRequire("5Q9JR");

var $fz6nu = parcelRequire("fz6nu");

var $kEUB1 = parcelRequire("kEUB1");

var $83DiZ = parcelRequire("83DiZ");

var $f4KdE = parcelRequire("f4KdE");

var $4SjAP = parcelRequire("4SjAP");

var $gHO4S = parcelRequire("gHO4S");

var $2pys5 = parcelRequire("2pys5");

var $9eT6w = parcelRequire("9eT6w");

var $3P2eB = parcelRequire("3P2eB");

var $hSFmR = parcelRequire("hSFmR");

var $Vd1v0 = parcelRequire("Vd1v0");
const $7434764e075e537a$var$EXPERIENCE = 'createBoard';
const $7434764e075e537a$export$43cdff4ae424f89f = ()=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $kEUB1.useCloudId)();
    return (0, $eJOHy.useCallback)(({ id: id, projectId: projectId })=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            try {
                if (!id) throw new Error('Failed to add board to project, missing id');
                if (!projectId) throw new Error('Failed to add board to project, missing projectId');
                const projectRelayDataId = (0, $f4KdE.default)({
                    id: (0, $3osLr.JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: String(projectId)
                    })
                }, 'JiraProject');
                if (!projectRelayDataId) throw new Error(`Failed to create project relay data id, projectId: ${projectId}`);
                const project = store.get(projectRelayDataId);
                if (!project) throw new Error(`Failed to find the project, projectId: ${projectId}`);
                const projectBoardsConnection = project.getLinkedRecord('boards', {
                    first: (0, $5Q9JR.NO_OF_BOARDS_TO_SHOW)
                });
                if (!projectBoardsConnection) throw new Error('Failed to find the project-boards connection');
                const newNode = store.get(id);
                if (!newNode) throw new Error(`Failed to find the new board, id: ${id}`);
                const newEdge = (0, $j4oe4.ConnectionHandler).createEdge(store, projectBoardsConnection, newNode, 'JiraBoardEdge');
                (0, $j4oe4.ConnectionHandler).insertEdgeBefore(projectBoardsConnection, newEdge);
            } catch (error) {
                (0, $gHO4S.fireBoardCreateErrorAnalytics)({
                    id: 'addBoardToProject',
                    error: error instanceof Error ? error : new Error(`Failed to add board to project: ${error}`)
                });
            }
        });
    }, [
        environment,
        cloudId
    ]);
};
const $7434764e075e537a$export$b1247ee6c4be437f = ()=>{
    const { handleMutation: handleMutation } = (0, $9eT6w.useBoardCreateMutation)();
    const { showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag } = (0, $3P2eB.useBoardCreateFlag)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const addBoardToProject = $7434764e075e537a$export$43cdff4ae424f89f();
    const isBacklogRoute = (0, $fz6nu.useIsBacklogRoute)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: $7434764e075e537a$var$EXPERIENCE,
        analyticsSource: (0, $2pys5.BOARD_CREATE_PACKAGE_NAME)
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: $7434764e075e537a$var$EXPERIENCE
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: $7434764e075e537a$var$EXPERIENCE
    });
    const submit = (0, $eJOHy.useCallback)(async ({ boardType: boardType, locationProjectId: locationProjectId, formValues: formValues, onSuccess: onSuccess, onError: onError })=>{
        const input = (0, $Vd1v0.transformInput)({
            boardType: boardType,
            locationProjectId: locationProjectId,
            formValues: formValues
        });
        try {
            onExperienceStart();
            const result = await handleMutation(input);
            if (!result?.jira?.createBoard?.success) throw result?.jira?.createBoard?.errors?.length ? new (0, $4SjAP.MutationError)(result?.jira?.createBoard?.errors?.[0]) : new Error('Failed to create board');
            onSuccess?.(result);
            showSuccessFlag({
                title: formatMessage((0, $hSFmR.default).successTitle)
            });
            addBoardToProject({
                projectId: locationProjectId,
                id: result.jira?.createBoard?.board?.__id
            });
            onExperienceSuccess();
            const resultBoardId = result?.jira?.createBoard?.board?.boardId;
            const resultBoardType = result?.jira?.createBoard?.board?.boardType;
            const boardUrl = (0, $Vd1v0.buildBoardUrl)(result?.jira?.createBoard?.board?.boardUrl, resultBoardType);
            if (!boardUrl) (0, $gHO4S.fireBoardCreateErrorAnalytics)({
                error: new Error('Failed to generate board URL after board creation'),
                attributes: {
                    boardId: resultBoardId,
                    boardType: resultBoardType
                },
                id: 'generateUrl'
            });
            else resultBoardType === 'SCRUM' && isBacklogRoute ? (0, $Vd1v0.redirectToBacklog)(boardUrl) : push(boardUrl);
        } catch (error) {
            let errMsg;
            if (error instanceof (0, $4SjAP.MutationError) && error.message) errMsg = error.message;
            onError?.(errMsg || error);
            showErrorFlag({
                title: formatMessage((0, $hSFmR.default).errorTitle),
                description: errMsg || formatMessage((0, $hSFmR.default).errorDescription)
            });
            (0, $gHO4S.fireBoardCreateErrorAnalytics)({
                error: new Error(`Failed to create board: ${errMsg || error}`),
                id: 'createBoard'
            });
            onExperienceFail((0, $2pys5.BOARD_CREATE_PACKAGE_NAME), // eslint-disable-next-line no-nested-ternary
            errMsg ? new Error(errMsg) : error instanceof Error ? error : new Error(String(error)));
        }
    }, [
        onExperienceStart,
        handleMutation,
        showSuccessFlag,
        formatMessage,
        addBoardToProject,
        onExperienceSuccess,
        isBacklogRoute,
        push,
        showErrorFlag,
        onExperienceFail
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("fz6nu", function(module, exports) {

$parcel$export(module.exports, "useIsBacklogRoute", () => $9731385da4d79637$export$1894da4846b402db);

var $eJOHy = parcelRequire("eJOHy");

var $hih5V = parcelRequire("hih5V");
const $9731385da4d79637$export$1894da4846b402db = ()=>{
    const { name: name } = (0, $hih5V.useCurrentRoute)();
    return (0, $eJOHy.useMemo)(()=>name === 'rapidboard-backlog' || name === 'rapidboard-user-backlog' || name === 'rapidboard-backlog-embed', [
        name
    ]);
};

});

parcelRegister("4SjAP", function(module, exports) {

$parcel$export(module.exports, "MutationError", () => $354f7d6d59497f5a$export$10c788363424e94e);
class $354f7d6d59497f5a$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
        this.errorType = payload.extensions?.errorType ?? null;
    }
}

});

parcelRegister("9eT6w", function(module, exports) {

$parcel$export(module.exports, "useBoardCreateMutation", () => $05321493561a882b$export$99c7414664697f66);

var $emzXy = parcelRequire("emzXy");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kEUB1 = parcelRequire("kEUB1");
const $05321493561a882b$export$99c7414664697f66 = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const [commit] = (0, $j4oe4.useMutation)((0, $emzXy.default));
    const handleMutation = (0, $eJOHy.useCallback)(async (input)=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    cloudId: cloudId,
                    input: input
                },
                onCompleted: (result)=>{
                    resolve(result);
                },
                onError: (error)=>{
                    reject(error);
                }
            });
        }), [
        cloudId,
        commit
    ]);
    return {
        handleMutation: handleMutation
    };
};

});
parcelRegister("emzXy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7356c11ac73e5487$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<96b4cce51ba6e0ff7c8004e93170ae98>>
 * @relayHash f07c5fbb5fc9fda47c89b1ea4e0b6538
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 39733200dfeb8f5ca8e119e986adf5ee373acba404794290d4a84a17b45673c2
const $7356c11ac73e5487$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "JiraBoard",
        "kind": "LinkedField",
        "name": "board",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "boardId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "boardType"
            },
            {
                "kind": "ScalarField",
                "name": "boardUrl"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useBoardCreateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCreateBoardPayload",
                            "kind": "LinkedField",
                            "name": "createBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useBoardCreateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCreateBoardPayload",
                            "kind": "LinkedField",
                            "name": "createBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "39733200dfeb8f5ca8e119e986adf5ee373acba404794290d4a84a17b45673c2",
            "metadata": {},
            "name": "useBoardCreateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$7356c11ac73e5487$var$node.hash = "6559f8aeeafe0e444aad2224af38c3cb";
var $7356c11ac73e5487$export$2e2bcd8739ae039 = $7356c11ac73e5487$var$node;

});


parcelRegister("3P2eB", function(module, exports) {

$parcel$export(module.exports, "useBoardCreateFlag", () => $be4214ea2d2fbd87$export$b93e10fcc9489915);

var $eJOHy = parcelRequire("eJOHy");

var $bILK0 = parcelRequire("bILK0");
const $be4214ea2d2fbd87$export$b93e10fcc9489915 = ()=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const showSuccessFlag = (0, $eJOHy.useCallback)(({ title: title, description: description })=>{
        showFlag({
            type: 'success',
            title: title,
            description: description,
            isAutoDismiss: true,
            messageId: 'software-board-create.controllers.use-board-create-flag.show-flag.success',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    const showErrorFlag = (0, $eJOHy.useCallback)(({ title: title, description: description })=>{
        showFlag({
            type: 'error',
            title: title,
            description: description,
            isAutoDismiss: true,
            messageId: 'software-board-create.controllers.use-board-create-flag.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    return {
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag
    };
};

});

parcelRegister("hSFmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $542f182ab8f7e79d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $542f182ab8f7e79d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    successTitle: {
        "id": "software-board-create.controllers.use-board-create-controller.success-title",
        "defaultMessage": "Board successfully created"
    },
    errorTitle: {
        "id": "software-board-create.controllers.use-board-create-controller.error-title",
        "defaultMessage": "We couldn\u2019t create the board"
    },
    errorDescription: {
        "id": "software-board-create.controllers.use-board-create-controller.error-description",
        "defaultMessage": "Refresh the page and try again."
    }
});

});

parcelRegister("Vd1v0", function(module, exports) {

$parcel$export(module.exports, "transformInput", () => $9d0fad3291600b6f$export$28b8f0b21b2796a2);
$parcel$export(module.exports, "buildBoardUrl", () => $9d0fad3291600b6f$export$d807737c3f4eaba6);
$parcel$export(module.exports, "redirectToBacklog", () => $9d0fad3291600b6f$export$594b405ab77720dc);

var $2pys5 = parcelRequire("2pys5");
const $9d0fad3291600b6f$var$formatFieldInput = (input)=>{
    if (!input.sourceType || input.sourceType === (0, $2pys5.BOARD_SOURCE_FIELDS).SAVED_FILTER || !input.sourceValue) return null;
    const { sourceType: sourceType, sourceValue: sourceValue } = input;
    switch(sourceType){
        case (0, $2pys5.BOARD_SOURCE_FIELDS).TEAM:
            return {
                teams: [
                    {
                        teamId: sourceValue.id
                    }
                ]
            };
        case (0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES:
            return {
                issueTypes: sourceValue.map(({ value: value })=>({
                        issueTypeId: value
                    }))
            };
        case (0, $2pys5.BOARD_SOURCE_FIELDS).LABELS:
            return {
                labels: sourceValue.map(({ value: value })=>({
                        name: value
                    }))
            };
        default:
            {
                const _exhaustiveCheck = sourceType;
                return null;
            }
    }
};
const $9d0fad3291600b6f$var$getCreateBoardSource = (formValues, locationProjectId)=>{
    if (formValues?.sourceType === (0, $2pys5.BOARD_SOURCE_FIELDS).SAVED_FILTER) return {
        savedFilterId: formValues.sourceValue?.value ? Number(formValues.sourceValue.value) : null
    };
    return {
        fieldInput: {
            projects: [
                {
                    projectId: locationProjectId
                }
            ],
            ...formValues.sourceType && formValues.sourceValue && $9d0fad3291600b6f$var$formatFieldInput(formValues)
        }
    };
};
const $9d0fad3291600b6f$export$28b8f0b21b2796a2 = ({ boardType: boardType, locationProjectId: locationProjectId, formValues: formValues })=>({
        createBoardSource: $9d0fad3291600b6f$var$getCreateBoardSource(formValues, locationProjectId),
        location: {
            locationId: locationProjectId,
            locationType: 'PROJECT'
        },
        name: formValues.boardName,
        preset: boardType
    });
const $9d0fad3291600b6f$export$d807737c3f4eaba6 = (boardUrl, boardType)=>{
    if (!boardUrl) return null;
    return `${boardUrl}${boardType === 'SCRUM' ? '/backlog' : ''}`;
};
const $9d0fad3291600b6f$export$594b405ab77720dc = (backlogUrl)=>{
    // This is a temporary fix for the redirection issue and will be addressed in BLU-5254
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = backlogUrl;
};

});


parcelRegister("a8589", function(module, exports) {

$parcel$export(module.exports, "ModalHeader", () => $2df745d30354834c$export$f50a68e3694789ee);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");

var $lRq8t = parcelRequire("lRq8t");

var $pkfsB = parcelRequire("pkfsB");

var $gHO4S = parcelRequire("gHO4S");
const $2df745d30354834c$export$f50a68e3694789ee = ({ type: type })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ $eJOHy.createElement((0, $aRh7I.default), {
        space: "space.100"
    }, /*#__PURE__*/ $eJOHy.createElement("h4", {
        className: (0, $hcewu.default)([
            "_11c8lodh _k48pmoej _syaz1fxt"
        ])
    }, formatMessage((0, $pkfsB.default).boardCreationTitle)), /*#__PURE__*/ $eJOHy.createElement((0, $h8epd.default), {
        size: "medium",
        color: "color.text.accent.gray.bolder"
    }, (0, $gHO4S.descriptionMapping)[type] && formatMessage((0, $gHO4S.descriptionMapping)[type])), /*#__PURE__*/ $eJOHy.createElement((0, $h8epd.default), {
        as: "em",
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $pkfsB.default).requiredFieldsHeader)));
};
const $2df745d30354834c$var$modalHeaderStyles = null;

});

parcelRegister("4SlPH", function(module, exports) {

$parcel$export(module.exports, "ModalIllustration", () => $0ce458cdd2e51714$export$dc26d3e21d436b08);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $11ahJ = parcelRequire("11ahJ");

var $aRh7I = parcelRequire("aRh7I");

var $3Yo2k = parcelRequire("3Yo2k");

var $lRq8t = parcelRequire("lRq8t");

var $cLQj5 = parcelRequire("cLQj5");
const $0ce458cdd2e51714$export$dc26d3e21d436b08 = ()=>{
    const state = (0, $11ahJ.useFormState)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("h5", {
        className: (0, $hcewu.default)([
            "_11c8nbxd _1reo15vq _18m915vq _k48p1pd9 _syaz1gjq _18u01axu _1bto1l2s _o5721q9c _p12fp3fh"
        ])
    }, state?.values.boardName?.trim() || formatMessage((0, $cLQj5.default).illustrationPlaceHolderHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Yo2k.default), {
        alt: formatMessage((0, $cLQj5.default).illustrationAltText),
        height: "334px"
    })));
};
const $0ce458cdd2e51714$var$modalIllustrationHeaderStyles = null;

});
parcelRegister("3Yo2k", function(module, exports) {

$parcel$export(module.exports, "default", () => $135b4187d8ccfd88$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $4palu = parcelRequire("4palu");
const $135b4187d8ccfd88$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4palu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($4palu))
});
var $135b4187d8ccfd88$export$2e2bcd8739ae039 = $135b4187d8ccfd88$var$Illustration;
const $135b4187d8ccfd88$export$a179c88182cb9d56 = [
    0,
    0,
    448,
    334
];

});
parcelRegister("4palu", function(module, exports) {
module.exports = new URL("bug-and-task-cards-in-a-column.455dfa61.svg", import.meta.url).toString();

});


parcelRegister("cLQj5", function(module, exports) {

$parcel$export(module.exports, "default", () => $cae77acd59a2e3e9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cae77acd59a2e3e9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    illustrationPlaceHolderHeader: {
        "id": "software-board-create.modal.illustration.illustration-place-holder-header",
        "defaultMessage": "New board"
    },
    illustrationAltText: {
        "id": "software-board-create.modal.illustration.illustration-alt-text",
        "defaultMessage": "Bug and task cards in a board column"
    }
});

});


parcelRegister("kHJve", function(module, exports) {

$parcel$export(module.exports, "FormActions", () => $9518fde6d5692310$export$9494d5a5e5299081);

var $eJOHy = parcelRequire("eJOHy");

var $pUkPE = parcelRequire("pUkPE");

var $alkjW = parcelRequire("alkjW");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $lRq8t = parcelRequire("lRq8t");

var $loxVz = parcelRequire("loxVz");
const $9518fde6d5692310$export$9494d5a5e5299081 = ({ onClose: onClose, submitting: submitting })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $9518fde6d5692310$var$buttonGroupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $pUkPE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
        appearance: "subtle",
        isDisabled: submitting,
        onClick: onClose,
        testId: "software-board-create.ui.modal.form.actions.board-create-cancel-button"
    }, formatMessage((0, $loxVz.default).modalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
        appearance: "primary",
        type: "submit",
        isLoading: submitting,
        testId: "software-board-create.ui.modal.form.actions.board-create-confirm-button"
    }, formatMessage((0, $loxVz.default).modalConfirmButton))));
};
const $9518fde6d5692310$var$buttonGroupContainerStyles = (0, $5Wv5g.xcss)({
    paddingBottom: 'space.100'
});

});
parcelRegister("loxVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ede517f5c9e6f3aa$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ede517f5c9e6f3aa$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    modalConfirmButton: {
        "id": "software-board-create.modal.form.actions.modal-confirm-button",
        "defaultMessage": "Create"
    },
    modalCancelButton: {
        "id": "software-board-create.modal.form.actions.modal-cancel-button",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("hPEYy", function(module, exports) {

$parcel$export(module.exports, "BoardNameField", () => $b24858a6d43afd4b$export$f710d048b5529d22);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $i9p2T = parcelRequire("i9p2T");
var $7BnZ9 = parcelRequire("7BnZ9");
var $11ahJ = parcelRequire("11ahJ");

var $eKx5I = parcelRequire("eKx5I");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $2pys5 = parcelRequire("2pys5");

var $ho2vK = parcelRequire("ho2vK");
const $b24858a6d43afd4b$export$f710d048b5529d22 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formState = (0, $11ahJ.useFormState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [value, setValue] = (0, $eJOHy.useState)('');
    const hasEdited = (0, $eJOHy.useRef)(false);
    const debouncedHandleOnChange = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
        if (!hasEdited.current) {
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'input'
            }), 'boardName');
            hasEdited.current = true;
        }
    }, 300)).current;
    const handleOnChange = (0, $eJOHy.useCallback)((event)=>{
        setValue(event.currentTarget.value);
        const newValue = event.currentTarget.value;
        setValue(newValue);
        debouncedHandleOnChange();
    }, [
        debouncedHandleOnChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7BnZ9.default), {
        label: formatMessage((0, $ho2vK.default).boardNameFieldLabel),
        name: "boardName",
        isRequired: true
    }, ({ fieldProps: { onChange: onChange, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
            ...rest,
            placeholder: formatMessage((0, $ho2vK.default).boardNameFieldPlaceholder),
            maxLength: (0, $2pys5.BOARD_NAME_LIMIT),
            testId: "software-board-create.ui.modal.form.board-name.board-name-input",
            value: value,
            onChange: (event)=>{
                handleOnChange(event);
                onChange(event);
            }
        }), error === (0, $2pys5.VALIDATION_ERROR_EMPTY) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.ErrorMessage), {
            testId: "software-board-create.ui.modal.form.board-name.board-name-error"
        }, formatMessage((0, $ho2vK.default).boardNameEmptyError)), formState?.values.boardName && formState.values.boardName.length >= (0, $2pys5.BOARD_NAME_LIMIT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.HelperMessage), null, formatMessage((0, $ho2vK.default).boardNameMaxChars, {
            maxLength: (0, $2pys5.BOARD_NAME_LIMIT)
        }))));
};

});
parcelRegister("ho2vK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f508a9d654a1f3ea$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f508a9d654a1f3ea$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    boardNameFieldLabel: {
        "id": "software-board-create.modal.form.board-name.board-name-field-label",
        "defaultMessage": "Name this board"
    },
    boardNameFieldPlaceholder: {
        "id": "software-board-create.modal.form.board-name.board-name-field-placeholder",
        "defaultMessage": "Enter a name for this board"
    },
    boardNameEmptyError: {
        "id": "software-board-create.modal.form.board-name.board-name-empty-error",
        "defaultMessage": "Enter a board name"
    },
    boardNameMaxChars: {
        "id": "software-board-create.modal.form.board-name.board-name-max-chars",
        "defaultMessage": "Maximum {maxLength, plural, one {# character} other {# characters}}"
    }
});

});


parcelRegister("kaWPn", function(module, exports) {

$parcel$export(module.exports, "SourceTypePicker", () => $21828c79c23c48b5$export$879aac32ab2e56ba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $aX8Tx = parcelRequire("aX8Tx");

var $12DRg = parcelRequire("12DRg");

var $6q0fu = parcelRequire("6q0fu");

var $i9p2T = parcelRequire("i9p2T");
var $7BnZ9 = parcelRequire("7BnZ9");

var $i8x5n = parcelRequire("i8x5n");
var $9LyfF = parcelRequire("9LyfF");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $j3gIc = parcelRequire("j3gIc");
var $8TCso = parcelRequire("8TCso");

var $f5dwt = parcelRequire("f5dwt");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $iunk7 = parcelRequire("iunk7");

var $8EXfh = parcelRequire("8EXfh");

var $2WGTE = parcelRequire("2WGTE");
const $21828c79c23c48b5$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
const $21828c79c23c48b5$var$formatOptionLabel = (option)=>{
    const { icon: Icon, title: title, description: description } = option;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        alignItems: "center",
        gap: "space.150",
        xcss: $21828c79c23c48b5$var$optionStyles
    }, typeof Icon === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6q0fu.default), {
        src: Icon,
        size: "xsmall",
        appearance: "square",
        borderColor: "transparent"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        label: "",
        name: "projectIcon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), null, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        size: "UNSAFE_small",
        color: "color.text.subtlest"
    }, description)));
};
const $21828c79c23c48b5$var$SingleValue = (props)=>{
    const { data: { selectedTitle: selectedTitle, icon: Icon } } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3gIc.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        alignItems: "center",
        gap: "space.100"
    }, typeof Icon === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6q0fu.default), {
        src: Icon,
        size: "xsmall",
        appearance: "square",
        name: "avatar"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), null, formatMessage(selectedTitle, {
        strong: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
                as: "strong"
            }, children)
    }))));
};
const $21828c79c23c48b5$export$77e74af9508bfdeb = ()=>(0, $eJOHy.useState)();
const $21828c79c23c48b5$var$controlStyles = {
    focused: "_1u6l142n _4cvx1p6i _1dbzzucj"
};
const $21828c79c23c48b5$var$groupStyles = {
    root: "_1vedyh40 _fgngnqa1 _1itxmuej"
};
const $21828c79c23c48b5$export$879aac32ab2e56ba = ({ resetSourceValue: resetSourceValue })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [selected, setSelected] = $21828c79c23c48b5$export$77e74af9508bfdeb();
    const { projectAvatar: projectAvatar } = (0, $iunk7.useBoardCreateContext)();
    const optionGroups = (0, $eJOHy.useMemo)(()=>(0, $2WGTE.getOptionGroups)({
            formatMessage: formatMessage,
            projectAvatar: projectAvatar
        }), [
        formatMessage,
        projectAvatar
    ]);
    const flattenedOptions = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))(optionGroups.map((group)=>group.options)), [
        optionGroups
    ]);
    const handleChange = (0, $eJOHy.useCallback)((onFieldChange)=>(value)=>{
            const option = value?.value || null;
            resetSourceValue();
            setSelected(option);
            onFieldChange(option);
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'select',
                action: 'changed'
            }), 'boardSourceType', {
                sourceType: option
            });
        }, [
        createAnalyticsEvent,
        resetSourceValue,
        setSelected
    ]);
    const handleOnMenuOpen = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'select',
            action: 'opened'
        }), 'boardSourceType');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7BnZ9.default), {
        name: "sourceType",
        label: formatMessage((0, $8EXfh.default).sourceTypeFieldLabel),
        defaultValue: undefined,
        isRequired: true
    }, ({ fieldProps: { onChange: onFieldChange, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5dwt.default), {
            onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8TCso.default), {
            ...rest,
            "aria-label": formatMessage((0, $8EXfh.default).sourceTypePickerAriaLabel),
            options: optionGroups,
            isSearchable: false,
            formatOptionLabel: $21828c79c23c48b5$var$formatOptionLabel,
            components: {
                SingleValue: $21828c79c23c48b5$var$SingleValue,
                Control: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3gIc.components).Control, {
                        ...props,
                        xcss: props.isFocused && $21828c79c23c48b5$var$controlStyles.focused
                    }),
                Group: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3gIc.components).Group, {
                        ...props,
                        xcss: $21828c79c23c48b5$var$groupStyles.root
                    })
            },
            placeholder: formatMessage((0, $8EXfh.default).selectPlaceholder),
            menuPosition: "fixed",
            classNamePrefix: "source-type-picker",
            onChange: handleChange(onFieldChange),
            value: flattenedOptions.find((option)=>option.value === selected),
            styles: {
                control: (base, state)=>({
                        ...base,
                        borderColor: state.isFocused ? "var(--ds-border-focused, #388BFF)" : base.borderColor,
                        ':focus-within': {
                            boxShadow: state.isFocused ? `inset 0px 0px 0px 1px ${"var(--ds-border-focused, #388BFF)"}` : base.boxShadow
                        },
                        ':hover': {
                            borderColor: state.isFocused ? "var(--ds-border-focused, #388BFF)" : base.borderColor,
                            boxShadow: state.isFocused ? 'elevation.shadow.raised' : base.boxShadow
                        }
                    }),
                option: (base)=>({
                        ...base,
                        // padding inside the option so hover covers the element
                        padding: `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-300, 24px)"}`
                    }),
                group: (base)=>({
                        ...base,
                        padding: 0,
                        ':not(:last-of-type)': {
                            borderBottomWidth: '2px',
                            borderBottomStyle: 'solid',
                            borderBottomColor: "var(--ds-border, #091E4224)"
                        }
                    }),
                groupHeading: (base)=>({
                        ...base,
                        margin: 0
                    }),
                menuList: (base)=>({
                        ...base,
                        padding: 0,
                        maxHeight: 325
                    })
            },
            onMenuOpen: handleOnMenuOpen
        })), error === $21828c79c23c48b5$export$7b060a5763a6e199 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.ErrorMessage), {
            testId: "software-board-create.ui.modal.form.source-type-picker.error"
        }, formatMessage((0, $8EXfh.default).sourceTypeEmptyError))));
};
const $21828c79c23c48b5$var$optionStyles = (0, $5Wv5g.xcss)({
    minHeight: '40px'
});

});
parcelRegister("f5dwt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ac00be16f50b3ce$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6S4l2 = parcelRequire("6S4l2");
class $4ac00be16f50b3ce$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onEscape: null,
            onEnter: null,
            onBlur: null,
            className: undefined
        };
    }
    componentDidMount() {
        // AK Modal uses document.addEventListener() so we also have to use addEventListener.
        // We can't rely on React Synthetic events as stopPropagation won't work
        // This is due to the way React handles events
        // https://github.com/facebook/react/issues/7094
        if (this.ref) this.ref.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        if (this.ref) this.ref.removeEventListener('keydown', this.handleKeyDown);
    }
    render() {
        return(// @ts-expect-error - TS2322 - Type '(() => void) | null' is not assignable to type 'FocusEventHandler<HTMLDivElement> | undefined'.
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            onBlur: this.props.onBlur,
            ref: this.setRef,
            className: this.props.className
        }, this.props.children));
    }
    constructor(...args){
        super(...args), this.setRef = (ref)=>{
            this.ref = ref;
        }, this.handleKeyDown = (event)=>{
            switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('escape'):
                    if (this.props.onEscape) {
                        this.props.onEscape(event);
                        event.stopPropagation();
                    }
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter'):
                    if (this.props.onEnter) {
                        this.props.onEnter(event);
                        event.stopPropagation();
                    }
                    break;
                default:
                    break;
            }
        };
    }
}

});
parcelRegister("6S4l2", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});


parcelRegister("8EXfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6929e4f8ce96994e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6929e4f8ce96994e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    selectPlaceholder: {
        "id": "software-board-create.modal.form.source-type-picker.select-placeholder",
        "defaultMessage": "Select"
    },
    sourceTypeFieldLabel: {
        "id": "software-board-create.modal.form.source-type-picker.source-type-field-label",
        "defaultMessage": "Choose what to include in this board"
    },
    teamTitle: {
        "id": "software-board-create.modal.form.source-type-picker.team-title",
        "defaultMessage": "Team"
    },
    teamSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.team-selected-title",
        "defaultMessage": "Issues based on <strong>Team</strong>"
    },
    teamDescription: {
        "id": "software-board-create.modal.form.source-type-picker.team-description",
        "defaultMessage": "Show all issues assigned to a team"
    },
    issueTypesTitle: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-title",
        "defaultMessage": "Issue type"
    },
    issueTypesSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-selected-title",
        "defaultMessage": "Issues based on <strong>Issue type</strong>"
    },
    issueTypesDescription: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-description",
        "defaultMessage": "Show all issues associated with an issue type"
    },
    labelsTitle: {
        "id": "software-board-create.modal.form.source-type-picker.labels-title",
        "defaultMessage": "Label"
    },
    labelsSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.labels-selected-title",
        "defaultMessage": "Issues based on <strong>Label</strong>"
    },
    labelsDescription: {
        "id": "software-board-create.modal.form.source-type-picker.labels-description",
        "defaultMessage": "Show all issues tagged with a specific label"
    },
    allIssuesFromProjectTitle: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-title",
        "defaultMessage": "All issues from your project"
    },
    allIssuesFromProjectSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title",
        "defaultMessage": "Issues based on <strong>All issues from your project</strong>"
    },
    savedFilterTitle: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-title",
        "defaultMessage": "Advanced"
    },
    savedFilterSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-selected-title",
        "defaultMessage": "Issues based on a <strong>Saved filter</strong>"
    },
    savedFilterDescription: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-description",
        "defaultMessage": "Show issues from a saved JQL filter"
    },
    sourceTypePickerAriaLabel: {
        "id": "software-board-create.modal.form.source-type-picker.source-type-picker-aria-label",
        "defaultMessage": "Select what to include in this board"
    },
    sourceTypeEmptyError: {
        "id": "software-board-create.modal.form.source-type-picker.source-type-empty-error",
        "defaultMessage": "Select what to include in this board"
    },
    teamSelectedTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.team-selected-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work items based on <strong>Team</strong>"
    },
    teamDescriptionIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.team-description-issue-terminology-refresh-m4",
        "defaultMessage": "Show all work items assigned to a team"
    },
    issueTypesTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work type"
    },
    issueTypesSelectedTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-selected-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work items based on <strong>work type</strong>"
    },
    issueTypesDescriptionIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-description-issue-terminology-refresh-m4",
        "defaultMessage": "Show all work items associated with a work type"
    },
    labelsSelectedTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.labels-selected-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work items based on <strong>label</strong>"
    },
    labelsDescriptionIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.labels-description-issue-terminology-refresh-m4",
        "defaultMessage": "Show all work items tagged with a specific label"
    },
    allIssuesFromProjectTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-title-issue-terminology-refresh-m4",
        "defaultMessage": "All work items from your project"
    },
    allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work items based on <strong>All work items from your project</strong>"
    },
    savedFilterSelectedTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-selected-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work items based on a <strong>Saved filter</strong>"
    },
    savedFilterDescriptionIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-description-issue-terminology-refresh-m4",
        "defaultMessage": "Show work items from a saved JQL filter"
    },
    allIssuesFromProjectTitleIssueTerminologyRefreshM4Galaxia: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-title-issue-terminology-refresh-m4-galaxia",
        "defaultMessage": "All work items from your space"
    },
    allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Galaxia: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title-issue-terminology-refresh-m4-galaxia",
        "defaultMessage": "Work items based on <strong>All work items from your space</strong>"
    }
});

});

parcelRegister("2WGTE", function(module, exports) {

$parcel$export(module.exports, "getOptionGroups", () => $caceeacc3effebad$export$eec1253b95a159cc);

var $gX1bZ = parcelRequire("gX1bZ");

var $efzee = parcelRequire("efzee");

var $3y1Y5 = parcelRequire("3y1Y5");

var $8G3gB = parcelRequire("8G3gB");

var $33MRY = parcelRequire("33MRY");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $2pys5 = parcelRequire("2pys5");

var $8EXfh = parcelRequire("8EXfh");
const $caceeacc3effebad$export$eec1253b95a159cc = ({ formatMessage: formatMessage, projectAvatar: projectAvatar })=>{
    const allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Replacement = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $8EXfh.default).allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Galaxia : (0, $8EXfh.default).allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4;
    const allIssuesFromProjectTitleIssueTerminologyRefreshM4Replacement = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $8EXfh.default).allIssuesFromProjectTitleIssueTerminologyRefreshM4Galaxia : (0, $8EXfh.default).allIssuesFromProjectTitleIssueTerminologyRefreshM4;
    const allIssuesFromProjectTitleMessage = (0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? allIssuesFromProjectTitleIssueTerminologyRefreshM4Replacement : (0, $8EXfh.default).allIssuesFromProjectTitle;
    const allIssuesFromProjectSelectedTitleMessage = (0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Replacement : (0, $8EXfh.default).allIssuesFromProjectSelectedTitle;
    const teamSelectedTitleMessage = (0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).teamSelectedTitleIssueTerminologyRefreshM4 : (0, $8EXfh.default).teamSelectedTitle;
    const teamDescriptionMessage = (0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).teamDescriptionIssueTerminologyRefreshM4 : (0, $8EXfh.default).teamDescription;
    const issueTypesTitleMessage = (0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).issueTypesTitleIssueTerminologyRefreshM4 : (0, $8EXfh.default).issueTypesTitle;
    const issueTypesSelectedTitleMessage = (0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).issueTypesSelectedTitleIssueTerminologyRefreshM4 : (0, $8EXfh.default).issueTypesSelectedTitle;
    const issueTypesDescriptionMessage = (0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).issueTypesDescriptionIssueTerminologyRefreshM4 : (0, $8EXfh.default).issueTypesDescription;
    const labelsSelectedTitleMessage = (0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).labelsSelectedTitleIssueTerminologyRefreshM4 : (0, $8EXfh.default).labelsSelectedTitle;
    const labelsDescriptionMessage = (0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).labelsDescriptionIssueTerminologyRefreshM4 : (0, $8EXfh.default).labelsDescription;
    const savedFilterSelectedTitleMessage = (0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).savedFilterSelectedTitleIssueTerminologyRefreshM4 : (0, $8EXfh.default).savedFilterSelectedTitle;
    const savedFilterDescriptionMessage = (0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $8EXfh.default).savedFilterDescriptionIssueTerminologyRefreshM4 : (0, $8EXfh.default).savedFilterDescription;
    return [
        {
            options: [
                {
                    label: formatMessage(allIssuesFromProjectTitleMessage),
                    title: formatMessage(allIssuesFromProjectTitleMessage),
                    selectedTitle: allIssuesFromProjectSelectedTitleMessage,
                    value: null,
                    icon: projectAvatar || (0, (/*@__PURE__*/$parcel$interopDefault($33MRY)))
                }
            ]
        },
        {
            options: [
                {
                    label: formatMessage((0, $8EXfh.default).teamTitle),
                    title: formatMessage((0, $8EXfh.default).teamTitle),
                    selectedTitle: teamSelectedTitleMessage,
                    description: formatMessage(teamDescriptionMessage),
                    value: (0, $2pys5.BOARD_SOURCE_FIELDS).TEAM,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($8G3gB)))
                },
                {
                    label: formatMessage(issueTypesTitleMessage),
                    title: formatMessage(issueTypesTitleMessage),
                    selectedTitle: issueTypesSelectedTitleMessage,
                    description: formatMessage(issueTypesDescriptionMessage),
                    value: (0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($efzee)))
                },
                {
                    label: formatMessage((0, $8EXfh.default).labelsTitle),
                    title: formatMessage((0, $8EXfh.default).labelsTitle),
                    selectedTitle: labelsSelectedTitleMessage,
                    description: formatMessage(labelsDescriptionMessage),
                    value: (0, $2pys5.BOARD_SOURCE_FIELDS).LABELS,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3y1Y5)))
                }
            ]
        },
        {
            options: [
                {
                    label: formatMessage((0, $8EXfh.default).savedFilterTitle),
                    title: formatMessage((0, $8EXfh.default).savedFilterTitle),
                    selectedTitle: savedFilterSelectedTitleMessage,
                    description: formatMessage(savedFilterDescriptionMessage),
                    value: (0, $2pys5.BOARD_SOURCE_FIELDS).SAVED_FILTER,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gX1bZ)))
                }
            ]
        }
    ];
};

});
parcelRegister("gX1bZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::289d4f542a1ed26db6d28b87ad2efcf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c57314d4eaffb54a$var$_react = $c57314d4eaffb54a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c57314d4eaffb54a$var$_filter = $c57314d4eaffb54a$var$_interopRequireDefault((parcelRequire("7eM4W")));

var $c57314d4eaffb54a$var$_filter2 = $c57314d4eaffb54a$var$_interopRequireDefault((parcelRequire("cZ5nn")));
function $c57314d4eaffb54a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FilterIcon.
 * This component is FilterIcon, with `UNSAFE_fallbackIcon` set to "FilterIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c57314d4eaffb54a$var$FilterIcon = (props)=>/*#__PURE__*/ $c57314d4eaffb54a$var$_react.default.createElement($c57314d4eaffb54a$var$_filter.default, Object.assign({
        LEGACY_fallbackIcon: $c57314d4eaffb54a$var$_filter2.default
    }, props));
$c57314d4eaffb54a$var$FilterIcon.Name = 'FilterIconMigration';
var $c57314d4eaffb54a$var$_default = module.exports.default = $c57314d4eaffb54a$var$FilterIcon;

});
parcelRegister("cZ5nn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $973f5a1965114dd5$var$_react = $973f5a1965114dd5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $973f5a1965114dd5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $973f5a1965114dd5$var$FilterIcon = (props)=>/*#__PURE__*/ $973f5a1965114dd5$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
    }, props));
$973f5a1965114dd5$var$FilterIcon.displayName = 'FilterIcon';
var $973f5a1965114dd5$var$_default = module.exports.default = $973f5a1965114dd5$var$FilterIcon;

});


parcelRegister("efzee", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb8f7b91262d340d7e94aafcc4e8657b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a5fdcb13425c1bee$var$_react = $a5fdcb13425c1bee$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a5fdcb13425c1bee$var$_workItems = $a5fdcb13425c1bee$var$_interopRequireDefault((parcelRequire("l3qRn")));

var $a5fdcb13425c1bee$var$_issues = $a5fdcb13425c1bee$var$_interopRequireDefault((parcelRequire("6Q8z6")));
function $a5fdcb13425c1bee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WorkItemsIcon.
 * This component is WorkItemsIcon, with `UNSAFE_fallbackIcon` set to "IssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a5fdcb13425c1bee$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $a5fdcb13425c1bee$var$_react.default.createElement($a5fdcb13425c1bee$var$_workItems.default, Object.assign({
        LEGACY_fallbackIcon: $a5fdcb13425c1bee$var$_issues.default
    }, props));
$a5fdcb13425c1bee$var$WorkItemsIcon.Name = 'WorkItemsIconMigration';
var $a5fdcb13425c1bee$var$_default = module.exports.default = $a5fdcb13425c1bee$var$WorkItemsIcon;

});
parcelRegister("l3qRn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fa0a7a20e9878c1f12b50feba4970dc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f53eb69c69c6d5ae$var$_react = $f53eb69c69c6d5ae$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f53eb69c69c6d5ae$var$_baseNew = $f53eb69c69c6d5ae$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $f53eb69c69c6d5ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f53eb69c69c6d5ae$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $f53eb69c69c6d5ae$var$_react.default.createElement($f53eb69c69c6d5ae$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM9.448 5.608l-3.167 3.75a.75.75 0 0 1-1.09.061l-.055-.06-1.584-1.876 1.146-.966 1.01 1.196 2.594-3.071zM13 10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 11.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$f53eb69c69c6d5ae$var$WorkItemsIcon.displayName = 'WorkItemsIcon';
var $f53eb69c69c6d5ae$var$_default = module.exports.default = $f53eb69c69c6d5ae$var$WorkItemsIcon;

});

parcelRegister("6Q8z6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4fae3e442d7b03f4$var$_react = $4fae3e442d7b03f4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $4fae3e442d7b03f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4fae3e442d7b03f4$var$IssuesIcon = (props)=>/*#__PURE__*/ $4fae3e442d7b03f4$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 12.99C5 13 19.01 13 19.01 13 19 13 19 5.01 19 5.01 19 5 5 5 5 5zM3 5.01C3 3.9 3.89 3 5 3h14.01A2 2 0 0 1 21 5.01v7.98A2 2 0 0 1 19.01 15H5a2 2 0 0 1-2-2.01zM19 19c0 1.11-.9 2-2.01 2H7.01A2.01 2.01 0 0 1 5 19zm1-3a2 2 0 0 1-1.99 2H5.99A2 2 0 0 1 4 16z"/><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props));
$4fae3e442d7b03f4$var$IssuesIcon.displayName = 'IssuesIcon';
var $4fae3e442d7b03f4$var$_default = module.exports.default = $4fae3e442d7b03f4$var$IssuesIcon;

});


parcelRegister("3y1Y5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f496fbd618fe5795b7e6b61ffefa90fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $295612e6cdbd1d69$var$_react = $295612e6cdbd1d69$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $295612e6cdbd1d69$var$_tag = $295612e6cdbd1d69$var$_interopRequireDefault((parcelRequire("9OJYA")));

var $295612e6cdbd1d69$var$_label = $295612e6cdbd1d69$var$_interopRequireDefault((parcelRequire("h0Wxe")));
function $295612e6cdbd1d69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TagIcon.
 * This component is TagIcon, with `UNSAFE_fallbackIcon` set to "LabelIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $295612e6cdbd1d69$var$TagIcon = (props)=>/*#__PURE__*/ $295612e6cdbd1d69$var$_react.default.createElement($295612e6cdbd1d69$var$_tag.default, Object.assign({
        LEGACY_fallbackIcon: $295612e6cdbd1d69$var$_label.default
    }, props));
$295612e6cdbd1d69$var$TagIcon.Name = 'TagIconMigration';
var $295612e6cdbd1d69$var$_default = module.exports.default = $295612e6cdbd1d69$var$TagIcon;

});
parcelRegister("9OJYA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::338651941b03ec38a528c6808ae2ffcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $725c727dbed59950$var$_react = $725c727dbed59950$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $725c727dbed59950$var$_baseNew = $725c727dbed59950$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $725c727dbed59950$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $725c727dbed59950$var$TagIcon = (props)=>/*#__PURE__*/ $725c727dbed59950$var$_react.default.createElement($725c727dbed59950$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentcolor" fill-rule="evenodd" d="M9.286 1a3.25 3.25 0 0 0-2.299.952L1.604 7.336a2 2 0 0 0 0 2.828l4.232 4.232a2 2 0 0 0 2.828 0l5.384-5.383A3.25 3.25 0 0 0 15 6.714V3a2 2 0 0 0-2-2zM8.048 3.013A1.75 1.75 0 0 1 9.286 2.5H13a.5.5 0 0 1 .5.5v3.714c0 .465-.184.91-.513 1.238l-5.383 5.384a.5.5 0 0 1-.708 0L2.664 9.104a.5.5 0 0 1 0-.708z" clip-rule="evenodd"/>`
    }, props));
$725c727dbed59950$var$TagIcon.displayName = 'TagIcon';
var $725c727dbed59950$var$_default = module.exports.default = $725c727dbed59950$var$TagIcon;

});

parcelRegister("h0Wxe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c62fd79c0497729f$var$_react = $c62fd79c0497729f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $c62fd79c0497729f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c62fd79c0497729f$var$LabelIcon = (props)=>/*#__PURE__*/ $c62fd79c0497729f$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.433 5.428-4.207.6A2 2 0 0 0 5.53 7.727l-.6 4.207a1 1 0 0 0 .281.849l6.895 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283m-.647 5.858A1.666 1.666 0 1 1 8.43 8.929a1.666 1.666 0 0 1 2.357 2.357"/></svg>`
    }, props));
$c62fd79c0497729f$var$LabelIcon.displayName = 'LabelIcon';
var $c62fd79c0497729f$var$_default = module.exports.default = $c62fd79c0497729f$var$LabelIcon;

});


parcelRegister("8G3gB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e476e34ec44b4dd59a1269a5572f39d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6514c7aa8d945e99$var$_react = $6514c7aa8d945e99$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6514c7aa8d945e99$var$_teams = $6514c7aa8d945e99$var$_interopRequireDefault((parcelRequire("g6zOZ")));

var $6514c7aa8d945e99$var$_teams2 = $6514c7aa8d945e99$var$_interopRequireDefault((parcelRequire("9Eylx")));
function $6514c7aa8d945e99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TeamsIcon.
 * This component is TeamsIcon, with `UNSAFE_fallbackIcon` set to "TeamsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6514c7aa8d945e99$var$TeamsIcon = (props)=>/*#__PURE__*/ $6514c7aa8d945e99$var$_react.default.createElement($6514c7aa8d945e99$var$_teams.default, Object.assign({
        LEGACY_fallbackIcon: $6514c7aa8d945e99$var$_teams2.default
    }, props));
$6514c7aa8d945e99$var$TeamsIcon.Name = 'TeamsIconMigration';
var $6514c7aa8d945e99$var$_default = module.exports.default = $6514c7aa8d945e99$var$TeamsIcon;

});
parcelRegister("9Eylx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70727df6417f418c$var$_react = $70727df6417f418c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $70727df6417f418c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $70727df6417f418c$var$TeamsIcon = (props)=>/*#__PURE__*/ $70727df6417f418c$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9 7.2a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m7.8 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m1.2 9.3a4.5 4.5 0 0 0-4.5-4.5h-1.378c-.484 0-1.275.127-1.875.41l.77 1.627c.14-.066.342-.129.566-.174s.421-.063.539-.063H17.1a2.7 2.7 0 0 1 2.7 2.7V18a.6.6 0 0 1-.6.6h-3.478a2.7 2.7 0 0 1-2.538-1.777l-.676-1.86A4.5 4.5 0 0 0 8.278 12H6.9a4.5 4.5 0 0 0-4.5 4.5V18a2.4 2.4 0 0 0 2.4 2.4h4.8v-1.8H4.8a.6.6 0 0 1-.6-.6v-1.5a2.7 2.7 0 0 1 2.7-2.7h1.378a2.7 2.7 0 0 1 2.538 1.777l.676 1.86a4.5 4.5 0 0 0 4.23 2.963H19.2a2.4 2.4 0 0 0 2.4-2.4z" clip-rule="evenodd"/></svg>`
    }, props));
$70727df6417f418c$var$TeamsIcon.displayName = 'TeamsIcon';
var $70727df6417f418c$var$_default = module.exports.default = $70727df6417f418c$var$TeamsIcon;

});




parcelRegister("bpQ9z", function(module, exports) {

$parcel$export(module.exports, "SOURCE_VALUE_FIELD_NAME", () => $58dade0b85ab53a7$export$2acdb7270c211b02);
$parcel$export(module.exports, "SourceValuePicker", () => $58dade0b85ab53a7$export$427e84d70337182b);

var $eJOHy = parcelRequire("eJOHy");

var $i9p2T = parcelRequire("i9p2T");
var $7BnZ9 = parcelRequire("7BnZ9");
var $11ahJ = parcelRequire("11ahJ");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $gHO4S = parcelRequire("gHO4S");

var $ajbQE = parcelRequire("ajbQE");

var $gHRV5 = parcelRequire("gHRV5");
const $58dade0b85ab53a7$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
const $58dade0b85ab53a7$export$2acdb7270c211b02 = 'sourceValue';
const $58dade0b85ab53a7$export$427e84d70337182b = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formState = (0, $11ahJ.useFormState)();
    const sourceType = formState?.values.sourceType;
    if (!sourceType) return null;
    const boardSource = (0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $gHRV5.boardSourceFieldComponentMap) : (0, $gHRV5.boardSourceFieldComponentMapOld);
    const mappedSource = boardSource[sourceType];
    if (!mappedSource) {
        (0, $gHO4S.fireBoardCreateErrorAnalytics)({
            error: new Error(`No source field component found for ${sourceType}`),
            id: 'unmappedSourceType'
        });
        return null;
    }
    const { component: PickerComponent, extraProps: extraProps, label: label } = mappedSource;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7BnZ9.default), {
        key: `sourceValue-${sourceType}`,
        name: $58dade0b85ab53a7$export$2acdb7270c211b02,
        label: formatMessage(label),
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PickerComponent, {
            key: `sourceValue-${sourceType}-picker`,
            label: formatMessage(label),
            ...fieldProps,
            ...extraProps
        }), error === $58dade0b85ab53a7$export$7b060a5763a6e199 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.ErrorMessage), {
            testId: "software-board-create.ui.modal.form.source-value-picker.error"
        }, formatMessage((0, $ajbQE.default).sourceValueEmptyError))));
};

});
parcelRegister("ajbQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fab6ecb2cf3f7acb$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fab6ecb2cf3f7acb$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    issueTypeFieldLabel: {
        "id": "software-board-create.modal.form.source-value-picker.issue-type-field-label",
        "defaultMessage": "Issue type"
    },
    teamFieldLabel: {
        "id": "software-board-create.modal.form.source-value-picker.team-field-label",
        "defaultMessage": "Team"
    },
    labelsFieldLabel: {
        "id": "software-board-create.modal.form.source-value-picker.labels-field-label",
        "defaultMessage": "Label"
    },
    savedFilterLabel: {
        "id": "software-board-create.modal.form.source-value-picker.saved-filter-label",
        "defaultMessage": "Select a saved filter"
    },
    sourceValueEmptyError: {
        "id": "software-board-create.modal.form.source-value-picker.source-value-empty-error",
        "defaultMessage": "Please select a value"
    },
    issueTypeFieldLabelIssueTerminologyRefreshM4: {
        "id": "software-board-create.modal.form.source-value-picker.issue-type-field-label-issue-terminology-refresh-m4",
        "defaultMessage": "Work type"
    }
});

});

parcelRegister("gHRV5", function(module, exports) {

$parcel$export(module.exports, "boardSourceFieldComponentMap", () => $5a412a9801090202$export$69996e7483e1a92f);
$parcel$export(module.exports, "boardSourceFieldComponentMapOld", () => $5a412a9801090202$export$c6355b6dd89ea597);

var $2pys5 = parcelRequire("2pys5");

var $kvpRX = parcelRequire("kvpRX");

var $ajbQE = parcelRequire("ajbQE");

var $68asf = parcelRequire("68asf");

var $kfYKF = parcelRequire("kfYKF");
const $5a412a9801090202$export$69996e7483e1a92f = {
    [(0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES]: {
        component: (0, $kvpRX.GenericPicker),
        label: (0, $ajbQE.default).issueTypeFieldLabelIssueTerminologyRefreshM4,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES,
        extraProps: {
            jqlTerm: (0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES]
        }
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS).TEAM]: {
        component: (0, $kfYKF.TeamPicker),
        label: (0, $ajbQE.default).teamFieldLabel,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).TEAM
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS).LABELS]: {
        component: (0, $kvpRX.GenericPicker),
        label: (0, $ajbQE.default).labelsFieldLabel,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).LABELS,
        extraProps: {
            jqlTerm: (0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).LABELS]
        }
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS).SAVED_FILTER]: {
        component: (0, $68asf.SavedFilterPicker),
        label: (0, $ajbQE.default).savedFilterLabel,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).SAVED_FILTER
    }
};
const $5a412a9801090202$export$c6355b6dd89ea597 = {
    [(0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES]: {
        component: (0, $kvpRX.GenericPicker),
        label: (0, $ajbQE.default).issueTypeFieldLabel,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES,
        extraProps: {
            jqlTerm: (0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES]
        }
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS).TEAM]: {
        component: (0, $kfYKF.TeamPicker),
        label: (0, $ajbQE.default).teamFieldLabel,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).TEAM
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS).LABELS]: {
        component: (0, $kvpRX.GenericPicker),
        label: (0, $ajbQE.default).labelsFieldLabel,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).LABELS,
        extraProps: {
            jqlTerm: (0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).LABELS]
        }
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS).SAVED_FILTER]: {
        component: (0, $68asf.SavedFilterPicker),
        label: (0, $ajbQE.default).savedFilterLabel,
        id: (0, $2pys5.BOARD_SOURCE_FIELDS).SAVED_FILTER
    }
};

});
parcelRegister("kvpRX", function(module, exports) {

$parcel$export(module.exports, "GenericPicker", () => $8d19e9ecef07e669$export$37d6fee5be00e6be);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $12DRg = parcelRequire("12DRg");

var $6q0fu = parcelRequire("6q0fu");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $5Wv5g = parcelRequire("5Wv5g");

var $aAdFp = parcelRequire("aAdFp");

var $f5dwt = parcelRequire("f5dwt");

var $lRq8t = parcelRequire("lRq8t");

var $2pys5 = parcelRequire("2pys5");

var $7Clq0 = parcelRequire("7Clq0");

var $huR0u = parcelRequire("huR0u");
const $8d19e9ecef07e669$var$formatOptionLabel = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        alignItems: "center"
    }, option.avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        xcss: $8d19e9ecef07e669$var$imgStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6q0fu.default), {
        appearance: "square",
        size: "xsmall",
        src: option.avatar,
        borderColor: "transparent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $8d19e9ecef07e669$var$optionStyles
    }, option.label));
const $8d19e9ecef07e669$export$37d6fee5be00e6be = ({ onChange: onChange, value: value, jqlTerm: jqlTerm, isInvalid: isInvalid, label: label })=>{
    const { loadOptions: loadOptions, isLoading: isLoading } = (0, $7Clq0.useLoadOptionsController)();
    const [defaultOptions, setDefaultOptions] = (0, $eJOHy.useState)();
    const [menuIsOpen, setMenuIsOpen] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        loadOptions(jqlTerm)('').then((options)=>setDefaultOptions(options));
    }, [
        jqlTerm,
        loadOptions
    ]);
    const debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((searchString, callback)=>loadOptions(jqlTerm)(searchString).then((options)=>callback(options)), (0, $2pys5.PICKER_SEARCH_DEBOUNCE_TIME));
    const handleOnKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (!menuIsOpen && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) setMenuIsOpen(true);
        // close the menu when focusing on multi value to prevent enter key from propagating
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') setMenuIsOpen(false);
        // prevent form submission error
        if (event.key === 'Enter' && !menuIsOpen) event.preventDefault();
    }, [
        menuIsOpen
    ]);
    return /* Prevent ESC press on Select bubbling up to the modal */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5dwt.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aAdFp.default), {
        "aria-label": label,
        isMulti: true,
        isLoading: isLoading,
        formatOptionLabel: $8d19e9ecef07e669$var$formatOptionLabel,
        defaultOptions: defaultOptions,
        loadOptions: debouncedLoadOptions,
        onChange: onChange,
        value: value,
        placeholder: formatMessage((0, $huR0u.default).genericPickerPlaceholder),
        menuPosition: "fixed",
        classNamePrefix: "source-value-picker",
        isInvalid: isInvalid,
        onFocus: ()=>setMenuIsOpen(true),
        onBlur: ()=>setMenuIsOpen(false),
        menuIsOpen: menuIsOpen,
        blurInputOnSelect: false,
        onKeyDown: handleOnKeyDown
    }));
};
const $8d19e9ecef07e669$var$imgStyles = (0, $5Wv5g.xcss)({
    paddingRight: 'space.100'
});
const $8d19e9ecef07e669$var$optionStyles = (0, $5Wv5g.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});

});
parcelRegister("aAdFp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2c4e486d74aff83$export$2e2bcd8739ae039);

var $1zt6p = parcelRequire("1zt6p");

var $5lI1B = parcelRequire("5lI1B");
const $d2c4e486d74aff83$var$AsyncSelect = (0, $5lI1B.default)((0, $1zt6p.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d2c4e486d74aff83$export$2e2bcd8739ae039 = $d2c4e486d74aff83$var$AsyncSelect;

});

parcelRegister("7Clq0", function(module, exports) {

$parcel$export(module.exports, "useLoadOptionsController", () => $32f9bdcaef059b2a$export$50422aa3bb02e176);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $2pys5 = parcelRequire("2pys5");

var $gHO4S = parcelRequire("gHO4S");

var $dCPq9 = parcelRequire("dCPq9");

var $iunk7 = parcelRequire("iunk7");

var $3P2eB = parcelRequire("3P2eB");

var $eUw8F = parcelRequire("eUw8F");
const $32f9bdcaef059b2a$var$errorMessageMapOld = {
    [(0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES]]: {
        title: (0, $eUw8F.default).failedToLoadIssueTypesTitle,
        description: (0, $eUw8F.default).failedToLoadIssueTypesDescription
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).LABELS]]: {
        title: (0, $eUw8F.default).failedToLoadLabelsTitle,
        description: (0, $eUw8F.default).failedToLoadLabelsDescription
    },
    DEFAULT: {
        title: (0, $eUw8F.default).failedToLoadOptionsTitle,
        description: (0, $eUw8F.default).failedToLoadOptionsTitle
    }
};
const $32f9bdcaef059b2a$var$errorMessageMap = {
    [(0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).ISSUE_TYPES]]: {
        title: (0, $eUw8F.default).failedToLoadIssueTypesTitleIssueTerminologyRefreshM4,
        description: (0, $eUw8F.default).failedToLoadIssueTypesDescription
    },
    [(0, $2pys5.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $2pys5.BOARD_SOURCE_FIELDS).LABELS]]: {
        title: (0, $eUw8F.default).failedToLoadLabelsTitle,
        description: (0, $eUw8F.default).failedToLoadLabelsDescription
    },
    DEFAULT: {
        title: (0, $eUw8F.default).failedToLoadOptionsTitle,
        description: (0, $eUw8F.default).failedToLoadOptionsTitle
    }
};
const $32f9bdcaef059b2a$export$4dface15d86304a4 = ()=>(0, $eJOHy.useState)(false);
const $32f9bdcaef059b2a$export$50422aa3bb02e176 = ()=>{
    const { projectId: projectId } = (0, $iunk7.useBoardCreateContext)();
    const jqlBuilderFetch = (0, $dCPq9.useJQLBuilderFetch)({
        projectId: projectId
    });
    const [isLoading, setIsLoading] = $32f9bdcaef059b2a$export$4dface15d86304a4();
    const { showErrorFlag: showErrorFlag } = (0, $3P2eB.useBoardCreateFlag)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const loadOptions = (0, $eJOHy.useCallback)((jqlTerm)=>async (searchString)=>{
            setIsLoading(true);
            const errorMessages = (0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? $32f9bdcaef059b2a$var$errorMessageMap : $32f9bdcaef059b2a$var$errorMessageMapOld;
            return jqlBuilderFetch(jqlTerm, searchString).catch((error)=>{
                const errorText = errorMessages[jqlTerm] || errorMessages.DEFAULT;
                showErrorFlag({
                    title: formatMessage(errorText.title),
                    description: formatMessage(errorText.description)
                });
                (0, $gHO4S.fireBoardCreateErrorAnalytics)({
                    error: new Error(`Failed to fetch picker options: ${error}`),
                    attributes: {
                        jqlTerm: jqlTerm
                    },
                    id: 'fetchPickerOptions'
                });
                return [];
            }).finally(()=>{
                setIsLoading(false);
            });
        }, [
        formatMessage,
        jqlBuilderFetch,
        setIsLoading,
        showErrorFlag
    ]);
    return {
        loadOptions: loadOptions,
        isLoading: isLoading
    };
};

});
parcelRegister("dCPq9", function(module, exports) {

$parcel$export(module.exports, "useJQLBuilderFetch", () => $93ff7cde30d073c9$export$a8efb2384cee4751);

var $7Ontj = parcelRequire("7Ontj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kEUB1 = parcelRequire("kEUB1");
const $93ff7cde30d073c9$export$a8efb2384cee4751 = ({ projectId: projectId })=>{
    if (projectId === undefined) throw new Error('Project ID is undefined');
    const cloudId = (0, $kEUB1.useCloudId)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)(async (jqlTerm, searchString)=>(0, $j4oe4.fetchQuery)(environment, (0, $7Ontj.default), {
            cloudId: cloudId,
            jqlTerm: jqlTerm,
            jql: `project = ${projectId}`,
            searchString: searchString
        }).toPromise().then((response)=>{
            if (response?.jira?.jqlBuilder?.fieldValues?.edges) {
                const data = response.jira.jqlBuilder.fieldValues.edges.map((edge)=>{
                    if (jqlTerm === 'type') return {
                        label: edge?.node?.displayName || '',
                        value: edge?.node?.issueTypes && edge?.node?.issueTypes[0]?.issueTypeId || '',
                        avatar: edge?.node?.issueTypes && edge?.node?.issueTypes[0].avatar?.small || ''
                    };
                    return {
                        label: edge?.node?.displayName || '',
                        value: edge?.node?.displayName || ''
                    };
                }) || [];
                return data;
            }
            throw new Error('No response');
        }), [
        cloudId,
        environment,
        projectId
    ]);
};

});
parcelRegister("7Ontj", function(module, exports) {

$parcel$export(module.exports, "default", () => $4930c793f6c89516$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<88e6b74d9cd0f6199e352d7287cdc139>>
 * @relayHash 550be86a84988bdbd21f24b80ceb24b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c1b5bc55b0e3a4a61ff20a7b89ec0bf355a6530849d7e75a79eb5d499feda60
const $4930c793f6c89516$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v8 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ 
        ],
        "type": "JiraJqlLabelFieldValue"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useJqlBuilderFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useJqlBuilderFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9c1b5bc55b0e3a4a61ff20a7b89ec0bf355a6530849d7e75a79eb5d499feda60",
            "metadata": {},
            "name": "useJqlBuilderFetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4930c793f6c89516$var$node.hash = "f9c373fe0144a8b52692f108c8ed6461";
var $4930c793f6c89516$export$2e2bcd8739ae039 = $4930c793f6c89516$var$node;

});


parcelRegister("eUw8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $32ef22841ea31b57$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $32ef22841ea31b57$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    failedToLoadIssueTypesTitle: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-title",
        "defaultMessage": "We can\u2019t load issue types right now"
    },
    failedToLoadIssueTypesDescription: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-description",
        "defaultMessage": "Refresh the page and try again."
    },
    failedToLoadLabelsTitle: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-labels-title",
        "defaultMessage": "We can\u2019t load labels right now"
    },
    failedToLoadLabelsDescription: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-labels-description",
        "defaultMessage": "Refresh the page and try again."
    },
    failedToLoadOptionsTitle: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-options-title",
        "defaultMessage": "Something went wrong"
    },
    failedToLoadOptionsDescription: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-options-description",
        "defaultMessage": "Refresh the page and try again."
    },
    failedToLoadIssueTypesTitleIssueTerminologyRefreshM4: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-title-issue-terminology-refresh-m4",
        "defaultMessage": "We can\u2019t load work types right now"
    }
});

});


parcelRegister("huR0u", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a7c686b0777e4b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $56a7c686b0777e4b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    // Delete genericPickerAriaLabel when cleaning up nav4_simplified_board_create_beta
    genericPickerAriaLabel: {
        "id": "software-board-create.modal.form.source-value-picker.generic-picker.generic-picker-aria-label",
        "defaultMessage": "Select an option"
    },
    genericPickerPlaceholder: {
        "id": "software-board-create.modal.form.source-value-picker.generic-picker.generic-picker-placeholder",
        "defaultMessage": "Select"
    }
});

});


parcelRegister("68asf", function(module, exports) {

$parcel$export(module.exports, "SavedFilterPicker", () => $bed3cbcdd08188c1$export$7408ad1ebc985020);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $12DRg = parcelRequire("12DRg");

var $gX1bZ = parcelRequire("gX1bZ");

var $gPqEA = parcelRequire("gPqEA");

var $aAdFp = parcelRequire("aAdFp");

var $f5dwt = parcelRequire("f5dwt");

var $lRq8t = parcelRequire("lRq8t");

var $2pys5 = parcelRequire("2pys5");

var $hCtwH = parcelRequire("hCtwH");

var $abTcx = parcelRequire("abTcx");
const $bed3cbcdd08188c1$var$formatOptionLabel = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPqEA.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gX1bZ))), {
        spacing: "spacious",
        label: option.label
    }), option.label);
const $bed3cbcdd08188c1$export$7408ad1ebc985020 = ({ onChange: onChange, value: value, isInvalid: isInvalid, label: label })=>{
    const { loadOptions: loadOptions, isLoading: isLoading } = (0, $hCtwH.useLoadSavedFiltersController)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((searchString, callback)=>loadOptions(searchString).then((options)=>callback(options)), (0, $2pys5.PICKER_SEARCH_DEBOUNCE_TIME));
    return /* Prevent ESC press on Select bubbling up to the modal */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5dwt.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aAdFp.default), {
        "aria-label": label,
        isLoading: isLoading,
        formatOptionLabel: $bed3cbcdd08188c1$var$formatOptionLabel,
        defaultOptions: true,
        loadOptions: debouncedLoadOptions,
        onChange: onChange,
        value: value,
        placeholder: formatMessage((0, $abTcx.default).savedFilterPickerPlaceholder),
        menuPosition: "fixed",
        classNamePrefix: "source-value-picker",
        isInvalid: isInvalid
    }));
};

});
parcelRegister("hCtwH", function(module, exports) {

$parcel$export(module.exports, "useLoadSavedFiltersController", () => $c44248c8e05d6a45$export$bb3a63b49faf836c);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $pkfsB = parcelRequire("pkfsB");

var $gHO4S = parcelRequire("gHO4S");

var $4dYZT = parcelRequire("4dYZT");

var $3P2eB = parcelRequire("3P2eB");
const $c44248c8e05d6a45$export$4dface15d86304a4 = ()=>(0, $eJOHy.useState)(false);
const $c44248c8e05d6a45$export$bb3a63b49faf836c = ()=>{
    const savedFiltersFetch = (0, $4dYZT.useSavedFiltersFetch)();
    const [isLoading, setIsLoading] = $c44248c8e05d6a45$export$4dface15d86304a4();
    const { showErrorFlag: showErrorFlag } = (0, $3P2eB.useBoardCreateFlag)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const loadOptions = (0, $eJOHy.useCallback)(async (searchString)=>{
        setIsLoading(true);
        return savedFiltersFetch(searchString).catch((error)=>{
            showErrorFlag({
                title: formatMessage((0, $pkfsB.default).loadSavedFiltersErrorTitle),
                description: formatMessage((0, $pkfsB.default).loadSavedFiltersErrorDescription)
            });
            (0, $gHO4S.fireBoardCreateErrorAnalytics)({
                error: new Error(`Failed to fetch saved filters: ${error}`),
                id: 'fetchSavedFilters'
            });
            return [];
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        formatMessage,
        savedFiltersFetch,
        setIsLoading,
        showErrorFlag
    ]);
    return {
        loadOptions: loadOptions,
        isLoading: isLoading
    };
};

});
parcelRegister("4dYZT", function(module, exports) {

$parcel$export(module.exports, "useSavedFiltersFetch", () => $123ee8bdfae8ae40$export$919a4c273fb6b0e5);

var $7qlZj = parcelRequire("7qlZj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");
const $123ee8bdfae8ae40$var$UNSUPPORTED_CHARACTERS = /[+\-&|!(){}[\]^~*?\\:]/g;
const $123ee8bdfae8ae40$var$removeUnsupportedCharacters = (text)=>text.replace($123ee8bdfae8ae40$var$UNSUPPORTED_CHARACTERS, ' ').trim();
const $123ee8bdfae8ae40$export$919a4c273fb6b0e5 = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)(async (searchString)=>{
        const sanitizedSearchString = (0, $7jTnu.fg)('saved_filter_string_sanitize') ? $123ee8bdfae8ae40$var$removeUnsupportedCharacters(searchString) : searchString;
        return (0, $j4oe4.fetchQuery)(environment, (0, $7qlZj.default), {
            cloudId: cloudId,
            searchString: sanitizedSearchString
        }).toPromise().then((response)=>{
            if (response?.jira?.savedFilters?.edges) {
                const data = response.jira.savedFilters.edges.map((edge)=>{
                    return {
                        label: edge?.node?.name || '',
                        value: edge?.node?.filterId || ''
                    };
                }) || [];
                return data;
            }
            throw new Error('No response');
        });
    }, [
        cloudId,
        environment
    ]);
};

});
parcelRegister("7qlZj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e3daef4886882d8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7661fff4909318f923a859e991c3f990>>
 * @relayHash 6e5fec99171872e06e6faef5354994ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c54fe404b07b4a4533c203ab6c68bf936d5a086953aa1a446da9bec5a0a67f5
const $9e3daef4886882d8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchString"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "keyword",
            "variableName": "searchString"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "filterId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ],
        "type": "JiraCustomFilter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSavedFiltersFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraFilterConnection",
                                "kind": "LinkedField",
                                "name": "savedFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.savedFilters.edges.node"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.savedFilters"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSavedFiltersFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraFilterConnection",
                            "kind": "LinkedField",
                            "name": "savedFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1c54fe404b07b4a4533c203ab6c68bf936d5a086953aa1a446da9bec5a0a67f5",
            "metadata": {},
            "name": "useSavedFiltersFetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9e3daef4886882d8$var$node.hash = "69a6cd0661c8d852b37f79d9513a1db0";
var $9e3daef4886882d8$export$2e2bcd8739ae039 = $9e3daef4886882d8$var$node;

});



parcelRegister("abTcx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcacd017b79250d6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fcacd017b79250d6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    // Delete savedFilterPickerAriaLabel when cleaning up nav4_simplified_board_create_beta
    savedFilterPickerAriaLabel: {
        "id": "software-board-create.modal.form.source-value-picker.saved-filter-picker.saved-filter-picker-aria-label",
        "defaultMessage": "Select an option"
    },
    savedFilterPickerPlaceholder: {
        "id": "software-board-create.modal.form.source-value-picker.saved-filter-picker.saved-filter-picker-placeholder",
        "defaultMessage": "Select"
    }
});

});


parcelRegister("kfYKF", function(module, exports) {

$parcel$export(module.exports, "TeamPicker", () => $7a758e3289699058$export$3529dc978be43e9d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $9cbmy = parcelRequire("9cbmy");

var $f5dwt = parcelRequire("f5dwt");

var $h47gY = parcelRequire("h47gY");

var $lRq8t = parcelRequire("lRq8t");

var $2NDyQ = parcelRequire("2NDyQ");

var $7ws3M = parcelRequire("7ws3M");

var $kEUB1 = parcelRequire("kEUB1");

var $dId76 = parcelRequire("dId76");
const $7a758e3289699058$var$TEAM_A11Y_LABEL_ID = 'software-board-create.source-value.team';
const $7a758e3289699058$export$3529dc978be43e9d = ({ onChange: onChange, value: value, isInvalid: isInvalid, label: label })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const handleOnCreate = (0, $eJOHy.useCallback)((team)=>{
        if (!team) return;
        // wait for the team to be created before updating the value
        setTimeout(()=>{
            onChange(team);
        }, 1000);
    }, [
        onChange
    ]);
    const [createTeamDialog, createTeamDialogTrigger] = (0, $2NDyQ.useCreateTeamDialog)({
        onCreate: handleOnCreate
    });
    const handleChange = (team)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange?.(team || null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7a758e3289699058$var$TeamPickerEditWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), {
        id: $7a758e3289699058$var$TEAM_A11Y_LABEL_ID
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5dwt.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ws3M.TeamPickerEdit), {
        siteId: cloudId,
        isCompact: false,
        hasNoTeamOption: false,
        createTeamDialogTrigger: createTeamDialogTrigger,
        placeholder: formatMessage((0, $dId76.default).placeholder),
        onChange: handleChange,
        defaultValue: value,
        isDropdownMenuFixedAndLayered: true,
        isInvalid: isInvalid,
        isClearable: false,
        "aria-labelledby": $7a758e3289699058$var$TEAM_A11Y_LABEL_ID
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "board-create-team-create-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", {
        tabIndex: -1,
        name: "create-team-dialog-form",
        onSubmit: (e)=>{
            e.stopPropagation();
        },
        className: (0, $hcewu.default)([
            "_1e0cglyw"
        ])
    }, createTeamDialog)));
};
const $7a758e3289699058$var$removeFormSpaceStyle = null; // TODO: remove this after select compiled migration
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7a758e3289699058$var$TeamPickerEditWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_b9cj1fu0 _t0z71fu0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2NDyQ", function(module, exports) {

$parcel$export(module.exports, "useCreateTeamDialog", () => $bce71092fd38d67f$export$e8b8170429d616be);

var $eJOHy = parcelRequire("eJOHy");

var $keNcc = parcelRequire("keNcc");

var $bILK0 = parcelRequire("bILK0");

var $hsAfg = parcelRequire("hsAfg");

var $8w5Cq = parcelRequire("8w5Cq");

var $vr8NS = parcelRequire("vr8NS");

var $lRq8t = parcelRequire("lRq8t");

var $ch9En = parcelRequire("ch9En");

var $3MbOI = parcelRequire("3MbOI");

var $g9Vr6 = parcelRequire("g9Vr6");

var $lvKO5 = parcelRequire("lvKO5");

var $hG8hM = parcelRequire("hG8hM");

var $gzcjr = parcelRequire("gzcjr");

var $7jTnu = parcelRequire("7jTnu");

const $bce71092fd38d67f$export$75096afde50756fd = (0, $gzcjr.lazy)(()=>(parcelRequire("cMxGi")).then((module)=>module.TeamCreateDialog), {
    moduleId: "../platform/packages/people-and-teams/people-teams/src/index.ts"
});
const $bce71092fd38d67f$export$e8b8170429d616be = (props = {})=>{
    const { locale: locale } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [inputTeamName, setInputTeamName] = (0, $eJOHy.useState)('');
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = tenantContext;
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { data: { user: user } } = (0, $3MbOI.useCurrentUser)();
    if (!atlassianAccountId && !user.accountId) throw new Error('Missing current user id');
    const addFlag = (0, $eJOHy.useCallback)(({ appearance: appearance, ...flagProps })=>{
        if (appearance === 'success' || appearance === 'normal') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8w5Cq.default), {
                messageId: "issue-field-create-team-dialog.ui.use-create-team-dialog.success-flag",
                messageType: "transactional",
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'warning') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $vr8NS.default), {
                messageId: "issue-field-create-team-dialog.ui.use-create-team-dialog.warning-flag",
                messageType: "transactional",
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'error') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hsAfg.default), {
                messageId: "issue-field-create-team-dialog.ui.use-create-team-dialog.error-flag",
                messageType: "transactional",
                ...flagProps,
                ...serviceProps
            }));
    }, [
        showFlag
    ]);
    const { onCancel: onCancel } = {
        onCancel: ()=>null,
        ...props
    };
    const callback = (0, $eJOHy.useCallback)((teamName)=>{
        setInputTeamName(teamName);
        setIsOpen(true);
    }, []);
    const handleOnClose = ()=>{
        setIsOpen(false);
        onCancel();
    };
    const handleOnCreate = (team)=>{
        const formattedTeam = {
            ...team,
            name: team.displayName
        };
        props.onCreate?.(formattedTeam);
    };
    return [
        isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
            name: "team-create-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hG8hM.PeopleAndTeamsConfigurationProvider), {
            product: "jira",
            locale: (0, $keNcc.default)(locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bce71092fd38d67f$export$75096afde50756fd, {
            cloudId: cloudId,
            orgId: orgId,
            product: "jira",
            principalId: atlassianAccountId || user.accountId || '',
            onClose: handleOnClose,
            onCreateTeamSuccess: handleOnCreate,
            extraAnalyticsAttrs: props.analyticsCtx,
            enableMembershipSettingsChoice: true,
            currentUser: user.accountId ? {
                id: user.accountId,
                fullName: user.userFullname,
                avatarUrl: (0, $7jTnu.fg)('jira_team_experience_improvements_feature_gate') ? 'avatarUrls' in user && user.avatarUrls && user.avatarUrls['48x48'] : // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                user.avatarUrls && user.avatarUrls['48x48'],
                email: 'emailAddress' in user && user.emailAddress && (0, $7jTnu.fg)('jira_team_experience_improvements_feature_gate') ? user.emailAddress : undefined,
                ...user
            } : undefined,
            prepopulatedFields: {
                teamName: inputTeamName
            },
            addFlag: addFlag
        }))) : null,
        callback
    ];
};

});

parcelRegister("7ws3M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "TeamPickerEdit", () => $1d5d6d31869ab81e$export$cb5f622bec189851);
$parcel$export(module.exports, "TeamPickerEditEntryPointContent", () => $1d5d6d31869ab81e$export$93a79bad2594cfb5);
$parcel$export(module.exports, "default", () => $1d5d6d31869ab81e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cUw3R = parcelRequire("cUw3R");

var $8qxeT = parcelRequire("8qxeT");

var $lRq8t = parcelRequire("lRq8t");

var $aUMMA = parcelRequire("aUMMA");

var $g9Vr6 = parcelRequire("g9Vr6");

var $7jTnu = parcelRequire("7jTnu");


var $aeZ5Y = parcelRequire("aeZ5Y");

var $eQtse = parcelRequire("eQtse");

var $hVanD = parcelRequire("hVanD");
// FIXME: These are overrides for @atlaskit/select@15.6 -> react-select@4.3.x
//        Once @atlaskit/select@15.6 resolution has been removed from package.json
//        these should be removed as well. See PTC-6238.
const $1d5d6d31869ab81e$var$stylesOverrides = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    valueContainer: (base)=>({
            ...base,
            display: 'grid'
        }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    placeholder: (base)=>({
            ...base,
            position: undefined,
            top: undefined,
            left: undefined,
            transform: undefined
        })
};
const $1d5d6d31869ab81e$export$cb5f622bec189851 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { siteId: siteId, defaultValue: defaultValue, isClearable: isClearable = true, isDisabled: isDisabled = false, isInvalid: isInvalid = false, autoFocus: autoFocus = false, width: width = '100%', debounceTime: debounceTime = 300, onChange: onChange, placeholder: placeholder = formatMessage((0, $aeZ5Y.default).placeholderTeamEditSelector), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, styles: styles, noValueText: noValueText, createTeamDialogTrigger: createTeamDialogTrigger, isCompact: isCompact = true, hasNoTeamOption: hasNoTeamOption = true, description: description, ...fieldProps } = props;
    const [isCreateButtonFocused, setIsCreateButtonFocused] = (0, $eJOHy.useState)(false);
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const [hasTeams, setHasTeams] = (0, $eJOHy.useState)(true);
    const formattedNoValueText = formatMessage((0, $aeZ5Y.default).defaultNoValueText);
    const [updatedPlaceholder, setUpdatedPlaceholder] = (0, $eJOHy.useState)(placeholder);
    const [inputQuery, setInputQuery] = (0, $eJOHy.useState)('');
    const finalStyles = {
        ...(0, $aUMMA.defaultSelectStyles),
        ...styles || {},
        ...$1d5d6d31869ab81e$var$stylesOverrides
    };
    const maybeAddNoTeamOption = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'users' implicitly has an 'any' type.
    (users, query)=>{
        setHasTeams(!(users.length === 0 && query.length === 0));
        if (query === '' && !!defaultValue && hasNoTeamOption) {
            if ((0, $7jTnu.fg)('twcj-37_update_team_icons_and_avatars_in_jira')) return [
                {
                    id: (0, $3ddfbe531e9e128a$export$53782b65600ab96d),
                    name: noValueText ?? formattedNoValueText,
                    isVerified: false,
                    type: 'team'
                }
            ].concat(users);
            return [
                {
                    avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8qxeT))),
                    id: (0, $3ddfbe531e9e128a$export$53782b65600ab96d),
                    name: noValueText ?? formattedNoValueText,
                    isVerified: false
                }
            ].concat(users);
        }
        setIsCreateButtonFocused(query.length > 0 && users.length === 0);
        return users;
    }, [
        defaultValue,
        noValueText,
        formattedNoValueText,
        hasNoTeamOption
    ]);
    const handleOnChange = (newValue, actionType)=>{
        if (Array.isArray(newValue)) return;
        if (onChange) {
            onChange(newValue?.id === (0, $3ddfbe531e9e128a$export$53782b65600ab96d) || !newValue ? null : newValue, actionType);
            setUpdatedPlaceholder(newValue?.id === (0, $3ddfbe531e9e128a$export$53782b65600ab96d) || !newValue ? formattedNoValueText : placeholder);
        }
    };
    const handleCreateTeam = (0, $eJOHy.useCallback)(()=>{
        createTeamDialogTrigger(inputQuery);
    }, [
        inputQuery,
        createTeamDialogTrigger
    ]);
    const handleOnKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (isCreateButtonFocused && event.key === 'Enter') handleCreateTeam();
    }, [
        isCreateButtonFocused,
        handleCreateTeam
    ]);
    const handleOnInputChange = (0, $eJOHy.useCallback)((query)=>{
        setInputQuery(query || '');
    }, [
        setInputQuery
    ]);
    const footer = (0, $eJOHy.useMemo)(()=>hasTeams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eQtse.CreateTeamOption), {
            isFocused: isCreateButtonFocused,
            onClick: handleCreateTeam
        }), [
        hasTeams,
        handleCreateTeam,
        isCreateButtonFocused
    ]);
    const noOptionsMessage = (0, $eJOHy.useMemo)(()=>!hasTeams ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hVanD.TeamPickerEmptyState), {
                onActionClick: handleCreateTeam
            }) : undefined, [
        hasTeams,
        handleCreateTeam
    ]);
    const menuListStyle = (0, $eJOHy.useMemo)(()=>!hasTeams ? {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            menuList: (base)=>({
                    ...base,
                    maxHeight: '350px'
                })
        } : {}, [
        hasTeams
    ]);
    const getMenuPosition = ()=>{
        if ((0, $7jTnu.fg)('fix_all_dropdown_options_not_visible_in_gic')) return isDropdownMenuFixedAndLayered ? 'absolute' : undefined;
        return isDropdownMenuFixedAndLayered ? 'fixed' : undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cUw3R.default), {
        // Setting width=100% will allow dropdown to size correctly
        width: width,
        autoFocus: autoFocus,
        appearance: isCompact ? 'compact' : 'normal',
        debounceTime: debounceTime,
        fieldId: "team",
        filterOptions: maybeAddNoTeamOption,
        footer: footer,
        includeGroups: false,
        includeTeams: true,
        includeUsers: false,
        isClearable: isClearable,
        isMulti: false,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        productKey: "jira",
        siteId: siteId,
        value: defaultValue,
        onChange: handleOnChange,
        orgId: orgId,
        placeholder: updatedPlaceholder,
        menuPosition: getMenuPosition(),
        styles: {
            ...finalStyles,
            ...menuListStyle
        },
        onInputChange: handleOnInputChange,
        onKeyDown: handleOnKeyDown,
        noOptionsMessage: noOptionsMessage,
        ariaLabel: (0, $7jTnu.fg)('jfp_a11y_issue_create_form_field_with_description') ? `${updatedPlaceholder} ${description}` : updatedPlaceholder,
        ariaLabelledBy: fieldProps['aria-labelledby'],
        placeholderAvatar: "team"
    });
};
const $1d5d6d31869ab81e$export$93a79bad2594cfb5 = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1d5d6d31869ab81e$export$cb5f622bec189851, props);
var $1d5d6d31869ab81e$export$2e2bcd8739ae039 = $1d5d6d31869ab81e$export$cb5f622bec189851;

});
parcelRegister("cUw3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bba94a7bcc93e17$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2TO0y = parcelRequire("2TO0y");

var $gqDgk = parcelRequire("gqDgk");

var $jnhBq = parcelRequire("jnhBq");
const $3bba94a7bcc93e17$var$SmartUserPickerWithIntlProvider = (props)=>{
    const ufoId = props.inputId || props.fieldId;
    (0, $jnhBq.useUFOConcurrentExperience)((0, $jnhBq.smartUserPickerRenderedUfoExperience), ufoId);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jnhBq.UfoErrorBoundary), {
        id: ufoId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gqDgk.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2TO0y.SmartUserPicker), {
                ...props
            })
        })
    });
};
var $3bba94a7bcc93e17$export$2e2bcd8739ae039 = $3bba94a7bcc93e17$var$SmartUserPickerWithIntlProvider;

});
parcelRegister("2TO0y", function(module, exports) {

$parcel$export(module.exports, "SmartUserPicker", () => $314c0a7ef0072994$export$9eedb6e5d313efdb);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $aXKmr = parcelRequire("aXKmr");

var $aN4Pk = parcelRequire("aN4Pk");

var $LFmXM = parcelRequire("LFmXM");

var $6YFG2 = parcelRequire("6YFG2");

var $1i6NW = parcelRequire("1i6NW");

var $gQu7b = parcelRequire("gQu7b");
var $jgqXv = parcelRequire("jgqXv");

var $8XtVW = parcelRequire("8XtVW");

var $lW3rH = parcelRequire("lW3rH");

var $gqDgk = parcelRequire("gqDgk");

var $9bHxY = parcelRequire("9bHxY");
var $dOjMC = parcelRequire("dOjMC");

var $jnhBq = parcelRequire("jnhBq");
const $314c0a7ef0072994$var$DEFAULT_DEBOUNCE_TIME_MS = 150;
const $314c0a7ef0072994$var$ufoEndStateConfig = (fieldId)=>{
    return {
        metadata: {
            contextType: fieldId
        }
    };
};
const $314c0a7ef0072994$var$hasContextChanged = (oldContext, newContext)=>oldContext.siteId !== newContext.siteId || oldContext.orgId !== newContext.orgId || oldContext.productKey !== newContext.productKey || oldContext.principalId !== newContext.principalId || oldContext.containerId !== newContext.containerId || oldContext.objectId !== newContext.objectId || oldContext.childObjectId !== newContext.childObjectId;
const $314c0a7ef0072994$var$stringContains = (str, substr)=>{
    if (str === null || str === undefined) return false;
    if (substr === null || substr === '' || substr === undefined) return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $314c0a7ef0072994$var$getUsersForAnalytics = (users)=>(users || []).map(({ id: id, type: type })=>({
            id: id,
            type: type
        }));
const $314c0a7ef0072994$var$checkIf500Event = (statusCode)=>500 <= statusCode && statusCode < 600;
class $314c0a7ef0072994$export$9b9bd453d1d4e4ce extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            baseUrl: '',
            includeUsers: true,
            includeGroups: false,
            includeTeams: false,
            includeNonLicensedUsers: false,
            prefetch: false,
            principalId: 'Context',
            debounceTime: $314c0a7ef0072994$var$DEFAULT_DEBOUNCE_TIME_MS,
            userResolvers: []
        };
    }
    constructor(props){
        super(props), this.state = {
            users: [],
            loading: false,
            closed: true,
            query: '',
            defaultValue: [],
            bootstrapOptions: []
        }, this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $1i6NW.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $lW3rH.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, ...args))(createAnalyticsEvent);
        }, this.filterOptions = (users, query, propFilterOptions)=>propFilterOptions ? propFilterOptions(users, query) : users, this.memoizedFilterOptions = (0, $LFmXM.default)(this.filterOptions), this.getUsers = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(async ()=>{
            const { query: query, sessionId: sessionId, closed: closed } = this.state;
            const { baseUrl: baseUrl, childObjectId: childObjectId, containerId: containerId, fieldId: fieldId, includeGroups: includeGroups, includeTeams: includeTeams, includeUsers: includeUsers, includeNonLicensedUsers: includeNonLicensedUsers, intl: intl, maxOptions: maxOptions, objectId: objectId, onEmpty: onEmpty, onError: onError, overrideByline: overrideByline, orgId: orgId, principalId: principalId, productAttributes: productAttributes, productKey: productKey, searchQueryFilter: searchQueryFilter, siteId: siteId, transformOptions: transformOptions, userResolvers: userResolvers } = this.props;
            const maxNumberOfResults = maxOptions || 100;
            const startTime = window.performance.now();
            const recommendationsRequest = {
                baseUrl: baseUrl,
                context: {
                    containerId: containerId,
                    contextType: fieldId,
                    objectId: objectId,
                    principalId: principalId,
                    productKey: productKey,
                    siteId: siteId,
                    organizationId: orgId,
                    childObjectId: childObjectId,
                    sessionId: sessionId,
                    productAttributes: productAttributes
                },
                includeUsers: includeUsers,
                includeGroups: includeGroups,
                includeTeams: includeTeams,
                includeNonLicensedUsers: includeNonLicensedUsers,
                maxNumberOfResults: maxNumberOfResults,
                query: query,
                searchQueryFilter: searchQueryFilter
            };
            try {
                const { query: query } = this.state;
                this.fireEvent((0, $lW3rH.requestUsersEvent));
                let recommendedUsers;
                if ((0, $8XtVW.fg)('twcg-444-invite-usd-improvements-m2-gate')) {
                    const userRecommendationsPromise = (0, $9bHxY.default)(recommendationsRequest, intl);
                    const userResolversPromises = (userResolvers ?? []).map((resolver)=>resolver(query).catch((error)=>{
                            this.fireEvent((0, $lW3rH.failedUserResolversEvent), {
                                resolverName: resolver.name,
                                error: error
                            });
                            return [];
                        }));
                    const [mainRecommendations, ...userResolverResults] = await Promise.all([
                        userRecommendationsPromise,
                        ...userResolversPromises
                    ]);
                    recommendedUsers = [
                        mainRecommendations,
                        ...userResolverResults
                    ].flat();
                } else recommendedUsers = await (0, $9bHxY.default)(recommendationsRequest, intl);
                if (overrideByline) {
                    for (let option of recommendedUsers)if ((0, $jgqXv.isUser)(option) || (0, $jgqXv.isExternalUser)(option) || (0, $jgqXv.isTeam)(option)) option.byline = overrideByline(option);
                }
                const elapsedTimeMilli = window.performance.now() - startTime;
                const transformedOptions = transformOptions ? await transformOptions(recommendedUsers, query) : recommendedUsers;
                const displayedUsers = transformedOptions.length === 0 && onEmpty ? await onEmpty(query) ?? [] : transformedOptions;
                this.setState((state)=>{
                    const applicable = state.query === query;
                    const users = applicable ? displayedUsers : state.users;
                    const loading = !applicable;
                    this.fireEvent((0, $lW3rH.successfulRequestUsersEvent), {
                        users: $314c0a7ef0072994$var$getUsersForAnalytics(recommendedUsers),
                        elapsedTimeMilli: elapsedTimeMilli,
                        displayedUsers: $314c0a7ef0072994$var$getUsersForAnalytics(displayedUsers),
                        productAttributes: productAttributes,
                        applicable: applicable,
                        ...(0, $8XtVW.fg)('twcg-444-invite-usd-improvements-m2-gate') && {
                            userResolvers: Array.isArray(userResolvers) ? userResolvers.map((resolver)=>resolver.name) : []
                        }
                    });
                    return {
                        users: users,
                        loading: loading
                    };
                });
            } catch (e) {
                const is5xxEvent = $314c0a7ef0072994$var$checkIf500Event(e.statusCode);
                if (!closed && !onError && is5xxEvent) // If the user lookup fails while the menu is open, and the consumer is not providing a
                // fallback data source via the onError prop, then send UFO failure
                this.optionsShownUfoExperienceInstance.failure($314c0a7ef0072994$var$ufoEndStateConfig(this.props.fieldId));
                this.setState({
                    users: []
                });
                let onErrorProducedError = false;
                let defaultUsers = [];
                try {
                    defaultUsers = onError ? await onError(e, recommendationsRequest) || [] : [];
                } catch (error) {
                    onErrorProducedError = true;
                }
                if (onErrorProducedError && is5xxEvent) // Log error from fallback data source `onError` to UFO
                this.optionsShownUfoExperienceInstance.failure($314c0a7ef0072994$var$ufoEndStateConfig(this.props.fieldId));
                if (!is5xxEvent && (!onError && !closed || onErrorProducedError)) this.abortOptionsShownUfoExperience();
                this.setState({
                    users: defaultUsers,
                    loading: false
                });
                const elapsedTimeMilli = window.performance.now() - startTime;
                this.fireEvent((0, $lW3rH.failedRequestUsersEvent), {
                    elapsedTimeMilli: elapsedTimeMilli,
                    productAttributes: productAttributes
                });
            }
        }, this.props.debounceTime ?? 0), this.onInputChange = (newQuery, sessionId)=>{
            const query = newQuery || '';
            const { closed: closed } = this.state;
            if (query === this.state.query) return;
            if (!closed) {
                // If the input has been typed into and the dropdown has not been closed
                // (i.e. input blurred) then start the UFO timer.
                // If there's a previous UFO timer running for the same "options shown" experience,
                // it will be aborted first.
                this.startOptionsShownUfoExperience();
                this.setState({
                    loading: true,
                    query: query,
                    sessionId: sessionId
                });
                if (this.props.onInputChange) this.props.onInputChange(query, sessionId);
            }
        }, this.filterUsers = ()=>{
            const { loading: loading, users: users, query: query } = this.state;
            const filteredUsers = this.memoizedFilterOptions(users, query, this.props.filterOptions);
            //If bootstrapOptions have been passed in and it is bootstrap
            if (this.props.bootstrapOptions && this.props.bootstrapOptions.length !== 0 && query === '') {
                const bootstrapFilteredUsers = this.memoizedFilterOptions(this.props.bootstrapOptions, query, this.props.filterOptions);
                this.fireEvent((0, $lW3rH.filterUsersEvent), {
                    filtered: $314c0a7ef0072994$var$getUsersForAnalytics(bootstrapFilteredUsers),
                    all: $314c0a7ef0072994$var$getUsersForAnalytics(this.props.bootstrapOptions)
                });
                return bootstrapFilteredUsers;
            }
            // while when not loading just return already filtered result from server.
            if (!loading) return filteredUsers;
            const queryFilteredUsers = filteredUsers.filter((user)=>$314c0a7ef0072994$var$stringContains(user.name, query));
            this.fireEvent((0, $lW3rH.filterUsersEvent), {
                filtered: $314c0a7ef0072994$var$getUsersForAnalytics(queryFilteredUsers),
                all: $314c0a7ef0072994$var$getUsersForAnalytics(users)
            });
            // when loading filter previous result.
            return filteredUsers;
        }, this.onFocus = (sessionId)=>{
            const state = {
                query: '',
                closed: false
            };
            this.startOptionsShownUfoExperience();
            if (this.state.users.length === 0) {
                state.sessionId = sessionId;
                state.loading = true;
            } else this.fireEvent((0, $lW3rH.preparedUsersLoadedEvent), {
                users: $314c0a7ef0072994$var$getUsersForAnalytics(this.state.users),
                preparedSessionId: this.state.sessionId,
                sessionId: sessionId
            });
            this.setState((currentState)=>({
                    ...currentState,
                    ...state
                }));
            if (this.props.onFocus) this.props.onFocus(sessionId);
        }, this.onBlur = (sessionId)=>{
            this.getUsers.cancel();
            this.abortOptionsShownUfoExperience();
            // clear old users if query is populated so that on refocus,
            // the old list is not shown
            const users = this.state.query.length === 0 ? this.state.users : [];
            this.setState({
                loading: false,
                closed: true,
                users: users
            });
            if (this.props.onBlur) this.props.onBlur(sessionId);
        };
        this.optionsShownUfoExperienceInstance = (0, $jnhBq.smartUserPickerOptionsShownUfoExperience).getInstance(props.inputId || props.fieldId);
    }
    async componentDidMount() {
        try {
            const value = await (0, $dOjMC.default)(this.props.baseUrl, this.props.defaultValue, this.props.productKey, this.props.siteId);
            this.setState({
                defaultValue: value
            });
        } catch (e) {
            const defaultValue = await (this.props.onValueError ? this.props.onValueError(e, this.props.defaultValue) || Promise.resolve([]) : Promise.resolve([]));
            this.setState({
                defaultValue: defaultValue
            });
        }
        const { prefetch: prefetch } = this.props;
        if (prefetch) {
            const sessionId = (0, $aXKmr.v4)();
            this.fireEvent((0, $lW3rH.mountedWithPrefetchEvent), {
                sessionId: sessionId
            });
            this.setState({
                sessionId: sessionId
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if ($314c0a7ef0072994$var$hasContextChanged(prevProps, this.props) || this.props.fieldId !== prevProps.fieldId) this.setState({
            users: []
        });
        if ((this.state.sessionId !== prevState.sessionId || this.state.query !== prevState.query) && (this.state.query !== '' || !this.props.bootstrapOptions)) this.getUsers();
        else if (!this.state.closed && !this.state.loading) // If the component has rendered (including its dropdown list) and it
        // is not loading anything further, send the success UFO event
        {
            if (![
                (0, $1i6NW.UFOExperienceState).FAILED.id,
                (0, $1i6NW.UFOExperienceState).SUCCEEDED.id,
                (0, $1i6NW.UFOExperienceState).ABORTED.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success($314c0a7ef0072994$var$ufoEndStateConfig(this.props.fieldId));
        }
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gqDgk.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gQu7b.UserPicker), {
                ...this.props,
                onInputChange: this.onInputChange,
                onBlur: this.onBlur,
                onFocus: this.onFocus,
                defaultValue: this.state.defaultValue,
                isLoading: this.props.isLoading || this.state.loading && !this.state.closed && (!this.props.bootstrapOptions || this.state.query !== ''),
                options: this.filterUsers()
            })
        });
    }
}
const $314c0a7ef0072994$export$9eedb6e5d313efdb = (0, $aN4Pk.default)()((0, $6YFG2.default)($314c0a7ef0072994$export$9b9bd453d1d4e4ce));

});
parcelRegister("gQu7b", function(module, exports) {

$parcel$export(module.exports, "UserPicker", () => $eb51edcc6d35014e$export$83e0c73b09b3a9cd);
/* UserPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $aN4Pk = parcelRequire("aN4Pk");

var $dPBl9 = parcelRequire("dPBl9");
var $8TCso = parcelRequire("8TCso");

var $1i6NW = parcelRequire("1i6NW");

var $eJOHy = parcelRequire("eJOHy");

var $3z7JK = parcelRequire("3z7JK");

var $9shHz = parcelRequire("9shHz");

var $fx4It = parcelRequire("fx4It");

var $fUqVE = parcelRequire("fUqVE");

var $8Z00l = parcelRequire("8Z00l");

var $aLb6P = parcelRequire("aLb6P");

var $hhQWA = parcelRequire("hhQWA");

var $gWW8Y = parcelRequire("gWW8Y");

var $aXKmr = parcelRequire("aXKmr");

var $8XtVW = parcelRequire("8XtVW");
class $eb51edcc6d35014e$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.ufoId = (0, $aXKmr.v4)();
        const experienceForId = (0, $gWW8Y.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $1i6NW.UFOExperienceState).IN_PROGRESS.id,
            (0, $1i6NW.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
    static{
        this.defaultProps = {
            width: 350,
            isMulti: false
        };
    }
    componentDidMount() {
        const experienceForId = (0, $gWW8Y.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $1i6NW.UFOExperienceState).IN_PROGRESS.id,
            (0, $1i6NW.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false, showClearIndicator: showClearIndicator = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $dPBl9.default) : (0, $8TCso.default);
        const creatableProps = suggestEmailsForDomain ? (0, $8Z00l.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $fUqVE.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gWW8Y.UfoErrorBoundary), {
            id: this.ufoId,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLb6P.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hhQWA.ExusUserSourceProvider), {
                    fetchUserSource: loadUserSource,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3z7JK.BaseUserPickerWithoutAnalytics), {
                        ...this.props,
                        forwardedRef: this.props.forwardedRef,
                        width: width,
                        SelectComponent: SelectComponent,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        styles: (0, $9shHz.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, this.props.isInvalid, // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                        (0, $8XtVW.fg)('platform-component-visual-refresh'), false, (0, $8XtVW.fg)('jifjam_bulk_operations') ? this.props.height : undefined),
                        components: (0, $fx4It.getComponents)(isMulti, anchor, showClearIndicator, this.props?.components ? this.props.components : {}),
                        pickerProps: pickerProps
                    })
                })
            })
        });
    }
}
const $eb51edcc6d35014e$export$83e0c73b09b3a9cd = (0, $aN4Pk.default)()($eb51edcc6d35014e$export$164f4d95e5d7e2f5);

});
parcelRegister("dPBl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $95c79da22b184616$export$2e2bcd8739ae039);

var $aXWLo = parcelRequire("aXWLo");

var $5lI1B = parcelRequire("5lI1B");
const $95c79da22b184616$var$CreatableSelect = (0, $5lI1B.default)((0, $aXWLo.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$95c79da22b184616$export$2e2bcd8739ae039 = $95c79da22b184616$var$CreatableSelect;

});
parcelRegister("aXWLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0604100aa56403bd$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("2BWzN")).default);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $50y9k = parcelRequire("50y9k");

var $2BWzN = parcelRequire("2BWzN");

var $brJma = parcelRequire("brJma");
const $0604100aa56403bd$var$CreatableSelect = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const creatableProps = (0, $brJma.default)(props);
    const selectProps = (0, $2BWzN.default)(creatableProps);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $50y9k.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0604100aa56403bd$export$2e2bcd8739ae039 = $0604100aa56403bd$var$CreatableSelect;

});
parcelRegister("2BWzN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f282a1047e9732c4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4x7Os = parcelRequire("4x7Os");

var $8epPR = parcelRequire("8epPR");
const $f282a1047e9732c4$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $f282a1047e9732c4$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$f282a1047e9732c4$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$f282a1047e9732c4$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $f282a1047e9732c4$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $f282a1047e9732c4$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $f282a1047e9732c4$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $f282a1047e9732c4$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $4x7Os.getOptionValue), getOptionLabel: getOptionLabel = (0, $4x7Os.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $eJOHy.useMemo)(()=>isValidNewOption(inputValue, (0, $8epPR.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $eJOHy.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $eJOHy.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $8epPR.valueTernary)(isMulti, [
                    ...(0, $8epPR.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});



parcelRegister("3z7JK", function(module, exports) {

$parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", () => $7178ca7a7a90cbac$export$b4ff48c8d43b18c3);

var $gt9Am = parcelRequire("gt9Am");

var $aN4Pk = parcelRequire("aN4Pk");

var $1i6NW = parcelRequire("1i6NW");

var $3s8bj = parcelRequire("3s8bj");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $aXKmr = parcelRequire("aXKmr");

var $OZHYU = parcelRequire("OZHYU");

var $cKSXK = parcelRequire("cKSXK");

var $as5UH = parcelRequire("as5UH");

var $jgqXv = parcelRequire("jgqXv");

var $7MV0T = parcelRequire("7MV0T");

var $gWW8Y = parcelRequire("gWW8Y");
const $7178ca7a7a90cbac$var$loadingMessage = ()=>null;
const $7178ca7a7a90cbac$var$classNamePrefix = 'fabric-user-picker';
class $7178ca7a7a90cbac$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isMulti: false,
            subtle: false,
            noBorder: false,
            textFieldBackgroundColor: false,
            isClearable: true,
            loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $as5UH.messages).errorMessage
                }),
            openMenuOnClick: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $jgqXv.optionToSelectableOptions)(nextProps.value);
        else if ((0, $jgqXv.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $jgqXv.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    constructor(props){
        super(props), this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined, this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            }, this.nextOption = this.withSelectRef((select)=>select.focusOption('down')), this.previousOption = this.withSelectRef((select)=>select.focusOption('up')), this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        }, this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        }, this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        }), // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $jgqXv.callCallback)(onChange, (0, $jgqXv.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $jgqXv.callCallback)(onSelection, (0, $jgqXv.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $OZHYU.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $OZHYU.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $jgqXv.callCallback)(onClear);
                    this.fireEvent((0, $OZHYU.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $OZHYU.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $OZHYU.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        }, this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        }, this.addOptions = (0, $cKSXK.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        }), this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $OZHYU.failedEvent));
        }, this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $jgqXv.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200), this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $1i6NW.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        }, this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $jgqXv.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $jgqXv.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        }, this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $jgqXv.callCallback)(this.props.onInputChange, '', this.getSessionId());
        }, this.handleBlur = ()=>{
            (0, $jgqXv.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $jgqXv.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        }, this.handleOpen = ()=>{
            (0, $jgqXv.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        }, this.handleClose = ()=>{
            this.resetInputState();
            (0, $jgqXv.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }, this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $jgqXv.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $OZHYU.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        }, this.startSession = ()=>{
            this.session = (0, $OZHYU.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $OZHYU.focusEvent));
        }, this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
        }, this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        }, this.getOptions = ()=>{
            const options = (0, $jgqXv.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder ? (0, $7MV0T.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder ? (0, $7MV0T.groupOptionsByType)(options, groupByTypeOrder) : options;
        }, this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal', this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = (0, $gWW8Y.userPickerOptionsShownUfoExperience).getInstance((0, $aXKmr.v4)());
        if (this.props.forwardedRef) {
            const refValue = {
                focus: this.focus,
                blur: this.blur
            };
            if (typeof this.props.forwardedRef === 'function') this.props.forwardedRef(refValue);
            else this.props.forwardedRef.current = refValue;
        }
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(_, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $OZHYU.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $OZHYU.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $1i6NW.UFOExperienceState).STARTED.id,
            (0, $1i6NW.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            "aria-labelledby": ariaLabelledBy,
            "aria-describedby": ariaDescribedBy,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $7178ca7a7a90cbac$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $as5UH.messages).placeholder
            }),
            label: ariaLabel,
            addMoreMessage: addMoreMessage,
            classNamePrefix: $7178ca7a7a90cbac$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...this.ariaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
}
const $7178ca7a7a90cbac$export$d099ade7b4f4d2a4 = (0, $aN4Pk.default)()($7178ca7a7a90cbac$export$b4ff48c8d43b18c3);

});
parcelRegister("OZHYU", function(module, exports) {

$parcel$export(module.exports, "startSession", () => $e24f55d67e649efa$export$c0d84948cecf78d8);
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $e24f55d67e649efa$export$53eef0dcd9611650);
$parcel$export(module.exports, "focusEvent", () => $e24f55d67e649efa$export$e7818c470f37c4bd);
$parcel$export(module.exports, "clearEvent", () => $e24f55d67e649efa$export$7b5800e732182efb);
$parcel$export(module.exports, "deleteEvent", () => $e24f55d67e649efa$export$95711ec6c6227e9a);
$parcel$export(module.exports, "cancelEvent", () => $e24f55d67e649efa$export$e9caaaecfee38128);
$parcel$export(module.exports, "selectEvent", () => $e24f55d67e649efa$export$48143d759475d90f);
$parcel$export(module.exports, "searchedEvent", () => $e24f55d67e649efa$export$911fb7184b6037eb);
$parcel$export(module.exports, "failedEvent", () => $e24f55d67e649efa$export$c2aec355fef65c9c);
$parcel$export(module.exports, "userInfoEvent", () => $e24f55d67e649efa$export$f541f04954b0c11e);

var $63DI8 = parcelRequire("63DI8");

var $aXKmr = parcelRequire("aXKmr");

var $jgqXv = parcelRequire("jgqXv");
const $e24f55d67e649efa$var$packageName = "platform-pkg";
const $e24f55d67e649efa$var$packageVersion = "0.0.0-use.local";
const $e24f55d67e649efa$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $e24f55d67e649efa$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $e24f55d67e649efa$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $e24f55d67e649efa$export$c0d84948cecf78d8 = ()=>({
        id: (0, $aXKmr.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $e24f55d67e649efa$export$53eef0dcd9611650 = (0, $63DI8.default)('fabric-elements');
const $e24f55d67e649efa$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $e24f55d67e649efa$var$packageName,
            packageVersion: $e24f55d67e649efa$var$packageVersion,
            ...attributes
        }
    });
const $e24f55d67e649efa$var$checkValidId = (id)=>{
    return $e24f55d67e649efa$var$UUID_REGEXP_NEW_AAID.test(id) || $e24f55d67e649efa$var$UUID_REGEXP_OLD_AAID.test(id) || $e24f55d67e649efa$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $e24f55d67e649efa$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $e24f55d67e649efa$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $jgqXv.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $jgqXv.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $e24f55d67e649efa$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$e24f55d67e649efa$var$optionData2Analytics(data));
    }
    return [];
};
const $e24f55d67e649efa$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $e24f55d67e649efa$var$sessionId(session),
        pickerType: $e24f55d67e649efa$var$pickerType(props),
        journeyId: journeyId
    });
const $e24f55d67e649efa$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$e24f55d67e649efa$var$createEvent('ui', 'focused', 'userPicker', {
        ...$e24f55d67e649efa$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $e24f55d67e649efa$var$buildValueForAnalytics(state.value)
    });
const $e24f55d67e649efa$export$7b5800e732182efb = (props, state, session, journeyId)=>$e24f55d67e649efa$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$e24f55d67e649efa$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $e24f55d67e649efa$var$values(state)
    });
const $e24f55d67e649efa$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$e24f55d67e649efa$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $e24f55d67e649efa$var$sessionId(session),
        journeyId: journeyId,
        value: $e24f55d67e649efa$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $e24f55d67e649efa$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$e24f55d67e649efa$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$e24f55d67e649efa$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $e24f55d67e649efa$var$sessionDuration(session),
        queryLength: $e24f55d67e649efa$var$queryLength(args[0]),
        spaceInQuery: $e24f55d67e649efa$var$spaceInQuery(args[0]),
        upKeyCount: $e24f55d67e649efa$var$upKeyCount(session),
        downKeyCount: $e24f55d67e649efa$var$downKeyCount(session)
    });
const $e24f55d67e649efa$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $e24f55d67e649efa$var$createEvent('ui', $e24f55d67e649efa$var$selectEventType(session), 'userPicker', {
        ...$e24f55d67e649efa$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $e24f55d67e649efa$var$sessionDuration(session),
        position: $e24f55d67e649efa$var$position(state, args[0]),
        queryLength: $e24f55d67e649efa$var$queryLength(state),
        spaceInQuery: $e24f55d67e649efa$var$spaceInQuery(state),
        upKeyCount: $e24f55d67e649efa$var$upKeyCount(session),
        downKeyCount: $e24f55d67e649efa$var$downKeyCount(session),
        result: $e24f55d67e649efa$var$result(args[0]),
        numberOfResults: $e24f55d67e649efa$var$numberOfResults(state)
    });
};
const $e24f55d67e649efa$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $e24f55d67e649efa$var$results(state);
    return $e24f55d67e649efa$var$createEvent('operational', 'searched', 'userPicker', {
        ...$e24f55d67e649efa$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $e24f55d67e649efa$var$sessionDuration(session),
        durationSinceInputChange: $e24f55d67e649efa$var$durationSinceInputChange(session),
        queryLength: $e24f55d67e649efa$var$queryLength(state),
        isLoading: $e24f55d67e649efa$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $e24f55d67e649efa$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$e24f55d67e649efa$var$createEvent('operational', 'failed', 'userPicker', {
        ...$e24f55d67e649efa$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $e24f55d67e649efa$export$f541f04954b0c11e = (sources, accountId)=>$e24f55d67e649efa$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $e24f55d67e649efa$var$checkValidId(accountId) ? accountId : null
    });
function $e24f55d67e649efa$var$queryLength(state) {
    return state.inputValue.length;
}
function $e24f55d67e649efa$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $e24f55d67e649efa$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $e24f55d67e649efa$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $e24f55d67e649efa$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $e24f55d67e649efa$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $e24f55d67e649efa$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $e24f55d67e649efa$var$sessionId(session) {
    return session && session.id;
}
function $e24f55d67e649efa$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $e24f55d67e649efa$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $e24f55d67e649efa$var$result(option) {
    return option ? $e24f55d67e649efa$var$optionData2Analytics(option.data) : null;
}
function $e24f55d67e649efa$var$results(state) {
    return (state.options || []).map($e24f55d67e649efa$var$optionData2Analytics);
}
function $e24f55d67e649efa$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $e24f55d67e649efa$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$e24f55d67e649efa$var$optionData2Analytics(option.data)) : [
        $e24f55d67e649efa$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $e24f55d67e649efa$var$numberOfResults(state) {
    return (state.options || []).length;
}

});
parcelRegister("jgqXv", function(module, exports) {

$parcel$export(module.exports, "isExternalUser", () => $5b75dd932945a16a$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $5b75dd932945a16a$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $5b75dd932945a16a$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $5b75dd932945a16a$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $5b75dd932945a16a$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $5b75dd932945a16a$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $5b75dd932945a16a$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $5b75dd932945a16a$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $5b75dd932945a16a$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $5b75dd932945a16a$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $5b75dd932945a16a$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $5b75dd932945a16a$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $5b75dd932945a16a$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $5b75dd932945a16a$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $5b75dd932945a16a$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $5b75dd932945a16a$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $5b75dd932945a16a$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $5b75dd932945a16a$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $5b75dd932945a16a$export$5419897287f5f1c7);

var $LFmXM = parcelRequire("LFmXM");


var $i5VqT = parcelRequire("i5VqT");
const $5b75dd932945a16a$export$f6058dbcb5980cb = (option)=>option.type === (0, $cb1feb1cecd2f1cc$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $5b75dd932945a16a$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $cb1feb1cecd2f1cc$export$8436e53e45ffe15b);
const $5b75dd932945a16a$export$f8c4277cb588611f = (option)=>option.type === (0, $cb1feb1cecd2f1cc$export$26bc40b960693765);
const $5b75dd932945a16a$export$d7976824e9f55785 = (option)=>option.type === (0, $cb1feb1cecd2f1cc$export$d460f747b73abb10);
const $5b75dd932945a16a$export$7fbbfbca30081d0 = (option)=>option.type === (0, $cb1feb1cecd2f1cc$export$6662b3461398ef8c);
const $5b75dd932945a16a$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $cb1feb1cecd2f1cc$export$eafd0979afa5b224);
const $5b75dd932945a16a$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $5b75dd932945a16a$var$isOptionData = (option)=>option.name !== undefined;
const $5b75dd932945a16a$export$3f993c492bd6c728 = (option)=>{
    if ($5b75dd932945a16a$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $5b75dd932945a16a$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $5b75dd932945a16a$export$9652023d9040757 = (a)=>typeof a?.[Symbol.iterator] === 'function';
const $5b75dd932945a16a$export$d2312e68e1f5ad00 = (0, $LFmXM.default)((options)=>options.map($5b75dd932945a16a$export$3f993c492bd6c728));
const $5b75dd932945a16a$export$e6fda14a194bcbcc = (0, $LFmXM.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($5b75dd932945a16a$export$3f993c492bd6c728);
    return $5b75dd932945a16a$export$3f993c492bd6c728(defaultValue);
});
const $5b75dd932945a16a$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $5b75dd932945a16a$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $5b75dd932945a16a$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $5b75dd932945a16a$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $5b75dd932945a16a$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
};
const $5b75dd932945a16a$export$b4f8f1f54acec99b = (optionData)=>{
    if ($5b75dd932945a16a$export$2e44165f1da65304(optionData) || $5b75dd932945a16a$export$f8c4277cb588611f(optionData) || $5b75dd932945a16a$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $5b75dd932945a16a$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $i5VqT.default);
const $5b75dd932945a16a$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $5b75dd932945a16a$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $cb1feb1cecd2f1cc$export$8436e53e45ffe15b = 'user';
const $cb1feb1cecd2f1cc$export$50042ec1d2e00e63 = 'external_user';
const $cb1feb1cecd2f1cc$export$26bc40b960693765 = 'team';
const $cb1feb1cecd2f1cc$export$d460f747b73abb10 = 'group';
const $cb1feb1cecd2f1cc$export$6662b3461398ef8c = 'email';
const $cb1feb1cecd2f1cc$export$eafd0979afa5b224 = 'custom';

parcelRegister("i5VqT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8c924780110b813$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $aQK2r = parcelRequire("aQK2r");

var $1Q3jn = parcelRequire("1Q3jn");

var $bI4U6 = parcelRequire("bI4U6");
var $fEyIQ = parcelRequire("fEyIQ");
var $bbkSN = parcelRequire("bbkSN");

var $5yteI = parcelRequire("5yteI");

var $gdEz9 = parcelRequire("gdEz9");

var $8XtVW = parcelRequire("8XtVW");

var $1Cwn9 = parcelRequire("1Cwn9");


var $8TCso = parcelRequire("8TCso");

var $iDDai = parcelRequire("iDDai");

var $eYrYU = parcelRequire("eYrYU");
/**
 * Are we rendering on the client or server?
 */ const $d8c924780110b813$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $d8c924780110b813$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
/**
 * The new defaults match the default modifiers of `@atlaskit/popper`.
 *
 * In the future we should investigate using `@atlaskit/popper` instead of
 * consuming `react-popper` directly.
 *
 * Previously the select popup would slide over the trigger to try to stay visible.
 * This behavior could actually cause it to go offscreen.
 *
 * Now it will stay anchored above / below the trigger and cause the
 * clipping parent to scroll if necessary. This aligns with other popups.
 */ const $d8c924780110b813$var$newDefaultModifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            rootBoundary: 'document'
        }
    },
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: 5,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
const $d8c924780110b813$var$defaultPopperProps = {
    modifiers: $d8c924780110b813$var$modifiers,
    placement: 'bottom-start'
};
const $d8c924780110b813$var$newDefaultPopperProps = {
    modifiers: $d8c924780110b813$var$newDefaultModifiers,
    placement: 'bottom-start'
};
const $d8c924780110b813$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $d8c924780110b813$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...(0, $8XtVW.fg)('platform_dst_nav4_layering_in_main_slot_fixes') ? $d8c924780110b813$var$newDefaultPopperProps : $d8c924780110b813$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $5yteI.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $iDDai.defaultComponents),
            ...props.components
        };
        if (!(0, $5yteI.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$d8c924780110b813$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $4eDgu.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bI4U6.Manager), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gdEz9.IdProvider), {
                    postfix: "-popup-select",
                    children: ({ id: id })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bbkSN.Reference), {
                                    children: ({ ref: ref })=>target && target({
                                            isOpen: isOpen,
                                            onKeyDown: this.handleTargetKeyDown,
                                            ref: this.resolveTargetRef(ref),
                                            // Should technically be 'dialog' by default instead of 'true' via AriaAttributes, but will require further changes.
                                            // See go/DSP-22283
                                            'aria-haspopup': 'true',
                                            'aria-expanded': isOpen,
                                            'aria-controls': isOpen ? id : undefined
                                        })
                                }),
                                this.renderSelect(id)
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eYrYU.NotifyOpenLayerObserver), {
                    isOpen: this.state.isOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $135dba7912433cc2$export$eaa8c8a70ac22806})`
                })
        }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $iDDai.defaultComponents),
            mergedPopperProps: (0, $8XtVW.fg)('platform_dst_nav4_layering_in_main_slot_fixes') ? $d8c924780110b813$var$newDefaultPopperProps : $d8c924780110b813$var$defaultPopperProps
        }, // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        }, this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        }, this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        }, this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        }, this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        }, // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $4eDgu.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        }, /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }, // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            }, this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        }, // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        }, this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        }, // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        }, // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $d8c924780110b813$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $iDDai.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const popper = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fEyIQ.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                },
                children: ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $iDDai.MenuDialog), {
                        // There is not a limited amount of values for the widths, so they need to remain dynamic.
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            ...style,
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-placement": placement,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref),
                        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1Q3jn.default), {
                            disabled: !focusLockEnabled,
                            returnFocus: true,
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8TCso.default), {
                                    label: getLabel(),
                                    backspaceRemovesValue: false,
                                    controlShouldRenderValue: false,
                                    isClearable: false,
                                    tabSelectsValue: false,
                                    menuIsOpen: true,
                                    placeholder: placeholder,
                                    ref: this.getSelectRef,
                                    ...props,
                                    isSearchable: showSearchControl,
                                    styles: (0, $1Cwn9.mergeStyles)(this.defaultStyles, props.styles || {}),
                                    maxMenuHeight: this.getMaxHeight(),
                                    components: selectComponents,
                                    onChange: this.handleSelectChange,
                                    testId: testId
                                }),
                                footer
                            ]
                        })
                    })
            });
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $aQK2r.createPortal)(popper, portalDestination);
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.close();
        };
    }
}

});
parcelRegister("bI4U6", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $88679b98ee054c8e$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $88679b98ee054c8e$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $88679b98ee054c8e$export$d0d38e7dec7a1a61);

var $eJOHy = parcelRequire("eJOHy");
var $88679b98ee054c8e$export$3dbd3405086fec7b = $eJOHy.createContext();
var $88679b98ee054c8e$export$cbabb21c2529b130 = $eJOHy.createContext();
function $88679b98ee054c8e$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eJOHy.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eJOHy.useRef(false);
    $eJOHy.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eJOHy.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eJOHy.createElement($88679b98ee054c8e$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eJOHy.createElement($88679b98ee054c8e$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("fEyIQ", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $b655868b2b842e30$export$badac9ada3a0bdf9);

var $eJOHy = parcelRequire("eJOHy");

var $bI4U6 = parcelRequire("bI4U6");

var $gEsU4 = parcelRequire("gEsU4");

var $6Kvc7 = parcelRequire("6Kvc7");
var $b655868b2b842e30$var$NOOP = function NOOP() {
    return void 0;
};
var $b655868b2b842e30$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $b655868b2b842e30$var$EMPTY_MODIFIERS = [];
function $b655868b2b842e30$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $b655868b2b842e30$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eJOHy.useContext((0, $bI4U6.ManagerReferenceNodeContext));
    var _React$useState = $eJOHy.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eJOHy.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eJOHy.useEffect(function() {
        (0, $gEsU4.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eJOHy.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $6Kvc7.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eJOHy.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $b655868b2b842e30$var$NOOP,
            update: update || $b655868b2b842e30$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $gEsU4.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("gEsU4", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $c1f6cd6418656974$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $c1f6cd6418656974$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $c1f6cd6418656974$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $c1f6cd6418656974$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $c1f6cd6418656974$export$700979bc83e7db82);

var $eJOHy = parcelRequire("eJOHy");
var $c1f6cd6418656974$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $c1f6cd6418656974$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $c1f6cd6418656974$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $c1f6cd6418656974$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $c1f6cd6418656974$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $c1f6cd6418656974$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eJOHy.useLayoutEffect : $eJOHy.useEffect;

});

parcelRegister("6Kvc7", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $4e9f3c82ab722f06$export$f4d5bf230a36dd6e);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $jOusu = parcelRequire("jOusu");

var $aVrYR = parcelRequire("aVrYR");

var $gEsU4 = parcelRequire("gEsU4");
var $4e9f3c82ab722f06$var$EMPTY_MODIFIERS = [];
var $4e9f3c82ab722f06$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eJOHy.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $4e9f3c82ab722f06$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eJOHy.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eJOHy.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $aQK2r.flushSync(function() {
                    setState({
                        styles: (0, $gEsU4.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $gEsU4.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eJOHy.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($aVrYR)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eJOHy.useRef();
    (0, $gEsU4.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $gEsU4.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $jOusu.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("jOusu", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $e6ca50443044ecf9$export$8f7491d57c8f97a9);

var $hoWIl = parcelRequire("hoWIl");

var $fXIWX = parcelRequire("fXIWX");

var $bWvF6 = parcelRequire("bWvF6");

var $7zGNN = parcelRequire("7zGNN");

var $e3Etl = parcelRequire("e3Etl");

var $inAr1 = parcelRequire("inAr1");

var $6sk3g = parcelRequire("6sk3g");

var $9t0eK = parcelRequire("9t0eK");

var $fZPgL = parcelRequire("fZPgL");

var $lGkc5 = parcelRequire("lGkc5");


var $e6ca50443044ecf9$export$d34966752335dd47 = [
    (0, $fXIWX.default),
    (0, $bWvF6.default),
    (0, $7zGNN.default),
    (0, $e3Etl.default),
    (0, $inAr1.default),
    (0, $6sk3g.default),
    (0, $9t0eK.default),
    (0, $fZPgL.default),
    (0, $lGkc5.default)
];
var $e6ca50443044ecf9$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $hoWIl.popperGenerator)({
    defaultModifiers: $e6ca50443044ecf9$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("hoWIl", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $cab239004fedb240$export$ed5e13716264f202);

var $hCni9 = parcelRequire("hCni9");

var $etkCM = parcelRequire("etkCM");

var $9TWyu = parcelRequire("9TWyu");

var $3n7LB = parcelRequire("3n7LB");

var $f9Nsz = parcelRequire("f9Nsz");

var $64H9j = parcelRequire("64H9j");

var $efnN5 = parcelRequire("efnN5");


var $234Lh = parcelRequire("234Lh");
var $cab239004fedb240$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $cab239004fedb240$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $cab239004fedb240$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $cab239004fedb240$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $cab239004fedb240$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $234Lh.isElement)(reference) ? (0, $9TWyu.default)(reference) : reference.contextElement ? (0, $9TWyu.default)(reference.contextElement) : [],
                    popper: (0, $9TWyu.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $f9Nsz.default)((0, $efnN5.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$cab239004fedb240$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $hCni9.default)(reference, (0, $3n7LB.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $etkCM.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $64H9j.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$cab239004fedb240$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $cab239004fedb240$export$8f7491d57c8f97a9 = /*#__PURE__*/ $cab239004fedb240$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("hCni9", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd380d857381fcb8$export$2e2bcd8739ae039);

var $2iVEr = parcelRequire("2iVEr");

var $i81bQ = parcelRequire("i81bQ");

var $irmjg = parcelRequire("irmjg");

var $234Lh = parcelRequire("234Lh");

var $h3Cd3 = parcelRequire("h3Cd3");

var $gcaAc = parcelRequire("gcaAc");

var $9P1pg = parcelRequire("9P1pg");

var $eJzui = parcelRequire("eJzui");
function $cd380d857381fcb8$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $eJzui.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $eJzui.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $cd380d857381fcb8$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $234Lh.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $234Lh.isHTMLElement)(offsetParent) && $cd380d857381fcb8$var$isElementScaled(offsetParent);
    var documentElement = (0, $gcaAc.default)(offsetParent);
    var rect = (0, $2iVEr.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $irmjg.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9P1pg.default)(documentElement)) scroll = (0, $i81bQ.default)(offsetParent);
        if ((0, $234Lh.isHTMLElement)(offsetParent)) {
            offsets = (0, $2iVEr.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $h3Cd3.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("2iVEr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ad9fb8ec08b83ef$export$2e2bcd8739ae039);

var $234Lh = parcelRequire("234Lh");

var $eJzui = parcelRequire("eJzui");

var $fAgXJ = parcelRequire("fAgXJ");

var $hGUiW = parcelRequire("hGUiW");
function $1ad9fb8ec08b83ef$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $234Lh.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $eJzui.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $eJzui.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $234Lh.isElement)(element) ? (0, $fAgXJ.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $hGUiW.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("234Lh", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $17df8e2364a45005$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $17df8e2364a45005$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $17df8e2364a45005$export$af51f0f06c0f328a);

var $fAgXJ = parcelRequire("fAgXJ");
function $17df8e2364a45005$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $fAgXJ.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $17df8e2364a45005$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $fAgXJ.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $17df8e2364a45005$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $fAgXJ.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("fAgXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b58760311df5b65b$export$2e2bcd8739ae039);
function $b58760311df5b65b$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("eJzui", function(module, exports) {

$parcel$export(module.exports, "max", () => $aba0cbc273bcd493$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $aba0cbc273bcd493$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $aba0cbc273bcd493$export$2077e0241d6afd3c);
var $aba0cbc273bcd493$export$8960430cfd85939f = Math.max;
var $aba0cbc273bcd493$export$96ec731ed4dcb222 = Math.min;
var $aba0cbc273bcd493$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("hGUiW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce1208d359384545$export$2e2bcd8739ae039);

var $1Pt7c = parcelRequire("1Pt7c");
function $ce1208d359384545$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $1Pt7c.default)());
}

});
parcelRegister("1Pt7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $1551238047236e3f$export$2e2bcd8739ae039);
function $1551238047236e3f$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("i81bQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d329e5aca91e6c1d$export$2e2bcd8739ae039);

var $iygGi = parcelRequire("iygGi");

var $fAgXJ = parcelRequire("fAgXJ");

var $234Lh = parcelRequire("234Lh");

var $88U83 = parcelRequire("88U83");
function $d329e5aca91e6c1d$export$2e2bcd8739ae039(node) {
    if (node === (0, $fAgXJ.default)(node) || !(0, $234Lh.isHTMLElement)(node)) return (0, $iygGi.default)(node);
    else return (0, $88U83.default)(node);
}

});
parcelRegister("iygGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8185786dcd001bb$export$2e2bcd8739ae039);

var $fAgXJ = parcelRequire("fAgXJ");
function $d8185786dcd001bb$export$2e2bcd8739ae039(node) {
    var win = (0, $fAgXJ.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("88U83", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eda9c207ac5601e$export$2e2bcd8739ae039);
function $5eda9c207ac5601e$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("irmjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6cc0de025fe5bc3$export$2e2bcd8739ae039);
function $d6cc0de025fe5bc3$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("h3Cd3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6b05b173b1eefad$export$2e2bcd8739ae039);

var $2iVEr = parcelRequire("2iVEr");

var $gcaAc = parcelRequire("gcaAc");

var $iygGi = parcelRequire("iygGi");
function $c6b05b173b1eefad$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2iVEr.default)((0, $gcaAc.default)(element)).left + (0, $iygGi.default)(element).scrollLeft;
}

});
parcelRegister("gcaAc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bca5f9d9f939cd58$export$2e2bcd8739ae039);

var $234Lh = parcelRequire("234Lh");
function $bca5f9d9f939cd58$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $234Lh.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("9P1pg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7269f7c2afce9601$export$2e2bcd8739ae039);

var $3Mv9B = parcelRequire("3Mv9B");
function $7269f7c2afce9601$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3Mv9B.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("3Mv9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c0e054dbc83f34a$export$2e2bcd8739ae039);

var $fAgXJ = parcelRequire("fAgXJ");
function $2c0e054dbc83f34a$export$2e2bcd8739ae039(element) {
    return (0, $fAgXJ.default)(element).getComputedStyle(element);
}

});



parcelRegister("etkCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a893c5b4bc6bc4d5$export$2e2bcd8739ae039);

var $2iVEr = parcelRequire("2iVEr");
function $a893c5b4bc6bc4d5$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2iVEr.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("9TWyu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7356abf92fed02f6$export$2e2bcd8739ae039);

var $isCUv = parcelRequire("isCUv");

var $FcGOY = parcelRequire("FcGOY");

var $fAgXJ = parcelRequire("fAgXJ");

var $9P1pg = parcelRequire("9P1pg");
function $7356abf92fed02f6$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $isCUv.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $fAgXJ.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9P1pg.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($7356abf92fed02f6$export$2e2bcd8739ae039((0, $FcGOY.default)(target)));
}

});
parcelRegister("isCUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d709064a10f3f1cb$export$2e2bcd8739ae039);

var $FcGOY = parcelRequire("FcGOY");

var $9P1pg = parcelRequire("9P1pg");

var $irmjg = parcelRequire("irmjg");

var $234Lh = parcelRequire("234Lh");
function $d709064a10f3f1cb$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $irmjg.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $234Lh.isHTMLElement)(node) && (0, $9P1pg.default)(node)) return node;
    return $d709064a10f3f1cb$export$2e2bcd8739ae039((0, $FcGOY.default)(node));
}

});
parcelRegister("FcGOY", function(module, exports) {

$parcel$export(module.exports, "default", () => $07bdac5a5c5f742f$export$2e2bcd8739ae039);

var $irmjg = parcelRequire("irmjg");

var $gcaAc = parcelRequire("gcaAc");

var $234Lh = parcelRequire("234Lh");
function $07bdac5a5c5f742f$export$2e2bcd8739ae039(element) {
    if ((0, $irmjg.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $234Lh.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $gcaAc.default)(element) // fallback
    );
}

});



parcelRegister("3n7LB", function(module, exports) {

$parcel$export(module.exports, "default", () => $27498b6498024d5a$export$2e2bcd8739ae039);

var $fAgXJ = parcelRequire("fAgXJ");

var $irmjg = parcelRequire("irmjg");

var $3Mv9B = parcelRequire("3Mv9B");

var $234Lh = parcelRequire("234Lh");

var $kbzZR = parcelRequire("kbzZR");

var $FcGOY = parcelRequire("FcGOY");

var $1Pt7c = parcelRequire("1Pt7c");
function $27498b6498024d5a$var$getTrueOffsetParent(element) {
    if (!(0, $234Lh.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3Mv9B.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $27498b6498024d5a$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $1Pt7c.default)());
    var isIE = /Trident/i.test((0, $1Pt7c.default)());
    if (isIE && (0, $234Lh.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3Mv9B.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $FcGOY.default)(element);
    if ((0, $234Lh.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $234Lh.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $irmjg.default)(currentNode)) < 0){
        var css = (0, $3Mv9B.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $27498b6498024d5a$export$2e2bcd8739ae039(element) {
    var window = (0, $fAgXJ.default)(element);
    var offsetParent = $27498b6498024d5a$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $kbzZR.default)(offsetParent) && (0, $3Mv9B.default)(offsetParent).position === 'static')offsetParent = $27498b6498024d5a$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $irmjg.default)(offsetParent) === 'html' || (0, $irmjg.default)(offsetParent) === 'body' && (0, $3Mv9B.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $27498b6498024d5a$var$getContainingBlock(element) || window;
}

});
parcelRegister("kbzZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb20c1ed77751690$export$2e2bcd8739ae039);

var $irmjg = parcelRequire("irmjg");
function $eb20c1ed77751690$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $irmjg.default)(element)) >= 0;
}

});


parcelRegister("f9Nsz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b08e0ffc3ff9bc87$export$2e2bcd8739ae039);

var $ivtFp = parcelRequire("ivtFp");
function $b08e0ffc3ff9bc87$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $b08e0ffc3ff9bc87$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $b08e0ffc3ff9bc87$var$order(modifiers); // order based on phase
    return (0, $ivtFp.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("ivtFp", function(module, exports) {

$parcel$export(module.exports, "top", () => $d7922276b6d4d746$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $d7922276b6d4d746$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $d7922276b6d4d746$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $d7922276b6d4d746$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $d7922276b6d4d746$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $d7922276b6d4d746$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $d7922276b6d4d746$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $d7922276b6d4d746$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $d7922276b6d4d746$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $d7922276b6d4d746$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $d7922276b6d4d746$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $d7922276b6d4d746$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $d7922276b6d4d746$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $d7922276b6d4d746$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $d7922276b6d4d746$export$d087d3878fdf71d5);
var $d7922276b6d4d746$export$1e95b668f3b82d = 'top';
var $d7922276b6d4d746$export$40e543e69a8b3fbb = 'bottom';
var $d7922276b6d4d746$export$79ffe56a765070d2 = 'right';
var $d7922276b6d4d746$export$eabcd2c8791e7bf4 = 'left';
var $d7922276b6d4d746$export$dfb5619354ba860 = 'auto';
var $d7922276b6d4d746$export$aec2ce47c367b8c3 = [
    $d7922276b6d4d746$export$1e95b668f3b82d,
    $d7922276b6d4d746$export$40e543e69a8b3fbb,
    $d7922276b6d4d746$export$79ffe56a765070d2,
    $d7922276b6d4d746$export$eabcd2c8791e7bf4
];
var $d7922276b6d4d746$export$b3571188c770cc5a = 'start';
var $d7922276b6d4d746$export$bd5df0f255a350f8 = 'end';
var $d7922276b6d4d746$export$390fd549c5303b4d = 'clippingParents';
var $d7922276b6d4d746$export$d7b7311ec04a3e8f = 'viewport';
var $d7922276b6d4d746$export$ae5ab1c730825774 = 'popper';
var $d7922276b6d4d746$export$ca50aac9f3ba507f = 'reference';
var $d7922276b6d4d746$export$368f9a87e87fa4e1 = /*#__PURE__*/ $d7922276b6d4d746$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $d7922276b6d4d746$export$b3571188c770cc5a,
        placement + "-" + $d7922276b6d4d746$export$bd5df0f255a350f8
    ]);
}, []);
var $d7922276b6d4d746$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($d7922276b6d4d746$export$aec2ce47c367b8c3, [
    $d7922276b6d4d746$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $d7922276b6d4d746$export$b3571188c770cc5a,
        placement + "-" + $d7922276b6d4d746$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $d7922276b6d4d746$export$421679a7c3d56e = 'beforeRead';
var $d7922276b6d4d746$export$aafa59e2e03f2942 = 'read';
var $d7922276b6d4d746$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $d7922276b6d4d746$export$c65e99957a05207c = 'beforeMain';
var $d7922276b6d4d746$export$f22da7240b7add18 = 'main';
var $d7922276b6d4d746$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $d7922276b6d4d746$export$8d4d2d70e7d46032 = 'beforeWrite';
var $d7922276b6d4d746$export$68d8715fc104d294 = 'write';
var $d7922276b6d4d746$export$70a6e5159acce2e6 = 'afterWrite';
var $d7922276b6d4d746$export$d087d3878fdf71d5 = [
    $d7922276b6d4d746$export$421679a7c3d56e,
    $d7922276b6d4d746$export$aafa59e2e03f2942,
    $d7922276b6d4d746$export$6964f6c886723980,
    $d7922276b6d4d746$export$c65e99957a05207c,
    $d7922276b6d4d746$export$f22da7240b7add18,
    $d7922276b6d4d746$export$bab79516f2d662fe,
    $d7922276b6d4d746$export$8d4d2d70e7d46032,
    $d7922276b6d4d746$export$68d8715fc104d294,
    $d7922276b6d4d746$export$70a6e5159acce2e6
];

});


parcelRegister("64H9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $46c496510ad6b568$export$2e2bcd8739ae039);
function $46c496510ad6b568$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("efnN5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5f4ebbfeaf615af$export$2e2bcd8739ae039);
function $a5f4ebbfeaf615af$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("fXIWX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ef3bd6ffca4da9$export$2e2bcd8739ae039);

var $fAgXJ = parcelRequire("fAgXJ");
var $b9ef3bd6ffca4da9$var$passive = {
    passive: true
};
function $b9ef3bd6ffca4da9$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $fAgXJ.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $b9ef3bd6ffca4da9$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $b9ef3bd6ffca4da9$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $b9ef3bd6ffca4da9$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $b9ef3bd6ffca4da9$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $b9ef3bd6ffca4da9$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $b9ef3bd6ffca4da9$var$effect,
    data: {}
};

});

parcelRegister("bWvF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b1dabe2cb57aea6$export$2e2bcd8739ae039);

var $cN4br = parcelRequire("cN4br");
function $8b1dabe2cb57aea6$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $cN4br.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8b1dabe2cb57aea6$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8b1dabe2cb57aea6$var$popperOffsets,
    data: {}
};

});
parcelRegister("cN4br", function(module, exports) {

$parcel$export(module.exports, "default", () => $94fd4e6be101e59b$export$2e2bcd8739ae039);

var $5d5pC = parcelRequire("5d5pC");

var $5gfhk = parcelRequire("5gfhk");

var $9ZH25 = parcelRequire("9ZH25");

var $ivtFp = parcelRequire("ivtFp");
function $94fd4e6be101e59b$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $5d5pC.default)(placement) : null;
    var variation = placement ? (0, $5gfhk.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $ivtFp.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $ivtFp.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $ivtFp.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $ivtFp.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $9ZH25.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $ivtFp.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $ivtFp.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("5d5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cb25d6a517fae0f$export$2e2bcd8739ae039);

function $3cb25d6a517fae0f$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("5gfhk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d4a4c57ee599d3f$export$2e2bcd8739ae039);
function $3d4a4c57ee599d3f$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("9ZH25", function(module, exports) {

$parcel$export(module.exports, "default", () => $746b30eff0e5997e$export$2e2bcd8739ae039);
function $746b30eff0e5997e$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("7zGNN", function(module, exports) {

$parcel$export(module.exports, "default", () => $583d00ea42591d69$export$2e2bcd8739ae039);

var $ivtFp = parcelRequire("ivtFp");

var $3n7LB = parcelRequire("3n7LB");

var $fAgXJ = parcelRequire("fAgXJ");

var $gcaAc = parcelRequire("gcaAc");

var $3Mv9B = parcelRequire("3Mv9B");

var $5d5pC = parcelRequire("5d5pC");

var $5gfhk = parcelRequire("5gfhk");

var $eJzui = parcelRequire("eJzui");
var $583d00ea42591d69$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $583d00ea42591d69$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $eJzui.round)(x * dpr) / dpr || 0,
        y: (0, $eJzui.round)(y * dpr) / dpr || 0
    };
}
function $583d00ea42591d69$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $ivtFp.left);
    var sideY = (0, $ivtFp.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3n7LB.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $fAgXJ.default)(popper)) {
            offsetParent = (0, $gcaAc.default)(popper);
            if ((0, $3Mv9B.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $ivtFp.top) || (placement === (0, $ivtFp.left) || placement === (0, $ivtFp.right)) && variation === (0, $ivtFp.end)) {
            sideY = (0, $ivtFp.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $ivtFp.left) || (placement === (0, $ivtFp.top) || placement === (0, $ivtFp.bottom)) && variation === (0, $ivtFp.end)) {
            sideX = (0, $ivtFp.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $583d00ea42591d69$var$unsetSides);
    var _ref4 = roundOffsets === true ? $583d00ea42591d69$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $fAgXJ.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $583d00ea42591d69$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $5d5pC.default)(state.placement),
        variation: (0, $5gfhk.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $583d00ea42591d69$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $583d00ea42591d69$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $583d00ea42591d69$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $583d00ea42591d69$var$computeStyles,
    data: {}
};

});

parcelRegister("e3Etl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3c0bd73dd767291$export$2e2bcd8739ae039);

var $irmjg = parcelRequire("irmjg");

var $234Lh = parcelRequire("234Lh");
// and applies them to the HTMLElements such as popper and arrow
function $a3c0bd73dd767291$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $234Lh.isHTMLElement)(element) || !(0, $irmjg.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $a3c0bd73dd767291$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $234Lh.isHTMLElement)(element) || !(0, $irmjg.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $a3c0bd73dd767291$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $a3c0bd73dd767291$var$applyStyles,
    effect: $a3c0bd73dd767291$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("inAr1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d616a3276d6aa49a$export$2e2bcd8739ae039);

var $5d5pC = parcelRequire("5d5pC");

var $ivtFp = parcelRequire("ivtFp");
function $d616a3276d6aa49a$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $5d5pC.default)(placement);
    var invertDistance = [
        (0, $ivtFp.left),
        (0, $ivtFp.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $ivtFp.left),
        (0, $ivtFp.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $d616a3276d6aa49a$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $ivtFp.placements).reduce(function(acc, placement) {
        acc[placement] = $d616a3276d6aa49a$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $d616a3276d6aa49a$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $d616a3276d6aa49a$var$offset
};

});

parcelRegister("6sk3g", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b34e96b9d87c54a$export$2e2bcd8739ae039);

var $fi9T6 = parcelRequire("fi9T6");

var $5d5pC = parcelRequire("5d5pC");

var $7iu2V = parcelRequire("7iu2V");

var $5Rfne = parcelRequire("5Rfne");

var $718iU = parcelRequire("718iU");

var $ivtFp = parcelRequire("ivtFp");

var $5gfhk = parcelRequire("5gfhk");
function $4b34e96b9d87c54a$var$getExpandedFallbackPlacements(placement) {
    if ((0, $5d5pC.default)(placement) === (0, $ivtFp.auto)) return [];
    var oppositePlacement = (0, $fi9T6.default)(placement);
    return [
        (0, $7iu2V.default)(placement),
        oppositePlacement,
        (0, $7iu2V.default)(oppositePlacement)
    ];
}
function $4b34e96b9d87c54a$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $5d5pC.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $fi9T6.default)(preferredPlacement)
    ] : $4b34e96b9d87c54a$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $5d5pC.default)(placement) === (0, $ivtFp.auto) ? (0, $718iU.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $5d5pC.default)(placement);
        var isStartVariation = (0, $5gfhk.default)(placement) === (0, $ivtFp.start);
        var isVertical = [
            (0, $ivtFp.top),
            (0, $ivtFp.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $5Rfne.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $ivtFp.right) : (0, $ivtFp.left) : isStartVariation ? (0, $ivtFp.bottom) : (0, $ivtFp.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $fi9T6.default)(mainVariationSide);
        var altVariationSide = (0, $fi9T6.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4b34e96b9d87c54a$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $4b34e96b9d87c54a$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("fi9T6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b22034f98abe3e2e$export$2e2bcd8739ae039);
var $b22034f98abe3e2e$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $b22034f98abe3e2e$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $b22034f98abe3e2e$var$hash[matched];
    });
}

});

parcelRegister("7iu2V", function(module, exports) {

$parcel$export(module.exports, "default", () => $55018565d2234548$export$2e2bcd8739ae039);
var $55018565d2234548$var$hash = {
    start: 'end',
    end: 'start'
};
function $55018565d2234548$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $55018565d2234548$var$hash[matched];
    });
}

});

parcelRegister("5Rfne", function(module, exports) {

$parcel$export(module.exports, "default", () => $443dd3e7e47efdf9$export$2e2bcd8739ae039);

var $7LNnj = parcelRequire("7LNnj");

var $gcaAc = parcelRequire("gcaAc");

var $2iVEr = parcelRequire("2iVEr");

var $cN4br = parcelRequire("cN4br");

var $6NsEN = parcelRequire("6NsEN");

var $ivtFp = parcelRequire("ivtFp");

var $234Lh = parcelRequire("234Lh");

var $9CCJ4 = parcelRequire("9CCJ4");

var $fne5j = parcelRequire("fne5j");
function $443dd3e7e47efdf9$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $ivtFp.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $ivtFp.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $ivtFp.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $9CCJ4.default)(typeof padding !== 'number' ? padding : (0, $fne5j.default)(padding, (0, $ivtFp.basePlacements)));
    var altContext = elementContext === (0, $ivtFp.popper) ? (0, $ivtFp.reference) : (0, $ivtFp.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $7LNnj.default)((0, $234Lh.isElement)(element) ? element : element.contextElement || (0, $gcaAc.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2iVEr.default)(state.elements.reference);
    var popperOffsets = (0, $cN4br.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $6NsEN.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $ivtFp.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $ivtFp.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $ivtFp.right),
                (0, $ivtFp.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $ivtFp.top),
                (0, $ivtFp.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("7LNnj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a83390bebc527aa$export$2e2bcd8739ae039);

var $ivtFp = parcelRequire("ivtFp");

var $8GyPk = parcelRequire("8GyPk");

var $gClCL = parcelRequire("gClCL");

var $9TWyu = parcelRequire("9TWyu");

var $3n7LB = parcelRequire("3n7LB");

var $gcaAc = parcelRequire("gcaAc");

var $3Mv9B = parcelRequire("3Mv9B");

var $234Lh = parcelRequire("234Lh");

var $2iVEr = parcelRequire("2iVEr");

var $FcGOY = parcelRequire("FcGOY");

var $92oHa = parcelRequire("92oHa");

var $irmjg = parcelRequire("irmjg");

var $6NsEN = parcelRequire("6NsEN");

var $eJzui = parcelRequire("eJzui");
function $5a83390bebc527aa$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2iVEr.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $5a83390bebc527aa$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $ivtFp.viewport) ? (0, $6NsEN.default)((0, $8GyPk.default)(element, strategy)) : (0, $234Lh.isElement)(clippingParent) ? $5a83390bebc527aa$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $6NsEN.default)((0, $gClCL.default)((0, $gcaAc.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $5a83390bebc527aa$var$getClippingParents(element) {
    var clippingParents = (0, $9TWyu.default)((0, $FcGOY.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $3Mv9B.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $234Lh.isHTMLElement)(element) ? (0, $3n7LB.default)(element) : element;
    if (!(0, $234Lh.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $234Lh.isElement)(clippingParent) && (0, $92oHa.default)(clippingParent, clipperElement) && (0, $irmjg.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $5a83390bebc527aa$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $5a83390bebc527aa$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $5a83390bebc527aa$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $eJzui.max)(rect.top, accRect.top);
        accRect.right = (0, $eJzui.min)(rect.right, accRect.right);
        accRect.bottom = (0, $eJzui.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $eJzui.max)(rect.left, accRect.left);
        return accRect;
    }, $5a83390bebc527aa$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("8GyPk", function(module, exports) {

$parcel$export(module.exports, "default", () => $652d42de27adefba$export$2e2bcd8739ae039);

var $fAgXJ = parcelRequire("fAgXJ");

var $gcaAc = parcelRequire("gcaAc");

var $h3Cd3 = parcelRequire("h3Cd3");

var $hGUiW = parcelRequire("hGUiW");
function $652d42de27adefba$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $fAgXJ.default)(element);
    var html = (0, $gcaAc.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $hGUiW.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $h3Cd3.default)(element),
        y: y
    };
}

});

parcelRegister("gClCL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c190f8160515cdde$export$2e2bcd8739ae039);

var $gcaAc = parcelRequire("gcaAc");

var $3Mv9B = parcelRequire("3Mv9B");

var $h3Cd3 = parcelRequire("h3Cd3");

var $iygGi = parcelRequire("iygGi");

var $eJzui = parcelRequire("eJzui");
function $c190f8160515cdde$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $gcaAc.default)(element);
    var winScroll = (0, $iygGi.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $eJzui.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $eJzui.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $h3Cd3.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3Mv9B.default)(body || html).direction === 'rtl') x += (0, $eJzui.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("92oHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $694774e6c70fd3a5$export$2e2bcd8739ae039);

var $234Lh = parcelRequire("234Lh");
function $694774e6c70fd3a5$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $234Lh.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("6NsEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f2d8c5f02690712$export$2e2bcd8739ae039);
function $4f2d8c5f02690712$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("9CCJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7015b3d377306cb2$export$2e2bcd8739ae039);

var $dCF6W = parcelRequire("dCF6W");
function $7015b3d377306cb2$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $dCF6W.default)(), paddingObject);
}

});
parcelRegister("dCF6W", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eaeb6bb314dcda6$export$2e2bcd8739ae039);
function $9eaeb6bb314dcda6$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("fne5j", function(module, exports) {

$parcel$export(module.exports, "default", () => $b313edeeea28bc37$export$2e2bcd8739ae039);
function $b313edeeea28bc37$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("718iU", function(module, exports) {

$parcel$export(module.exports, "default", () => $51bf11646e64b837$export$2e2bcd8739ae039);

var $5gfhk = parcelRequire("5gfhk");

var $ivtFp = parcelRequire("ivtFp");

var $5Rfne = parcelRequire("5Rfne");

var $5d5pC = parcelRequire("5d5pC");
function $51bf11646e64b837$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $ivtFp.placements) : _options$allowedAutoP;
    var variation = (0, $5gfhk.default)(placement);
    var placements = variation ? flipVariations ? (0, $ivtFp.variationPlacements) : (0, $ivtFp.variationPlacements).filter(function(placement) {
        return (0, $5gfhk.default)(placement) === variation;
    }) : (0, $ivtFp.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $5Rfne.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $5d5pC.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("9t0eK", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e47018547559b34$export$2e2bcd8739ae039);

var $ivtFp = parcelRequire("ivtFp");

var $5d5pC = parcelRequire("5d5pC");

var $9ZH25 = parcelRequire("9ZH25");

var $6RHtq = parcelRequire("6RHtq");

var $gF5R4 = parcelRequire("gF5R4");

var $etkCM = parcelRequire("etkCM");

var $3n7LB = parcelRequire("3n7LB");

var $5Rfne = parcelRequire("5Rfne");

var $5gfhk = parcelRequire("5gfhk");

var $dCF6W = parcelRequire("dCF6W");

var $eJzui = parcelRequire("eJzui");
function $6e47018547559b34$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $5Rfne.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $5d5pC.default)(state.placement);
    var variation = (0, $5gfhk.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $9ZH25.default)(basePlacement);
    var altAxis = (0, $6RHtq.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $ivtFp.top) : (0, $ivtFp.left);
        var altSide = mainAxis === 'y' ? (0, $ivtFp.bottom) : (0, $ivtFp.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $ivtFp.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $ivtFp.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $etkCM.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $dCF6W.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $gF5R4.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3n7LB.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $gF5R4.within)(tether ? (0, $eJzui.min)(min, tetherMin) : min, offset, tether ? (0, $eJzui.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $ivtFp.top) : (0, $ivtFp.left);
        var _altSide = mainAxis === 'x' ? (0, $ivtFp.bottom) : (0, $ivtFp.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $ivtFp.top),
            (0, $ivtFp.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $gF5R4.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $gF5R4.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $6e47018547559b34$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $6e47018547559b34$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("6RHtq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ff96a453fdd79b4$export$2e2bcd8739ae039);
function $4ff96a453fdd79b4$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("gF5R4", function(module, exports) {

$parcel$export(module.exports, "within", () => $c215045e280da603$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $c215045e280da603$export$86c8af6d3ef0b4a);

var $eJzui = parcelRequire("eJzui");
function $c215045e280da603$export$f28d906d67a997f3(min, value, max) {
    return (0, $eJzui.max)(min, (0, $eJzui.min)(value, max));
}
function $c215045e280da603$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $c215045e280da603$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("fZPgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba545286fdfaf967$export$2e2bcd8739ae039);

var $5d5pC = parcelRequire("5d5pC");

var $etkCM = parcelRequire("etkCM");

var $92oHa = parcelRequire("92oHa");

var $3n7LB = parcelRequire("3n7LB");

var $9ZH25 = parcelRequire("9ZH25");

var $gF5R4 = parcelRequire("gF5R4");

var $9CCJ4 = parcelRequire("9CCJ4");

var $fne5j = parcelRequire("fne5j");

var $ivtFp = parcelRequire("ivtFp");
var $ba545286fdfaf967$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $9CCJ4.default)(typeof padding !== 'number' ? padding : (0, $fne5j.default)(padding, (0, $ivtFp.basePlacements)));
};
function $ba545286fdfaf967$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $5d5pC.default)(state.placement);
    var axis = (0, $9ZH25.default)(basePlacement);
    var isVertical = [
        (0, $ivtFp.left),
        (0, $ivtFp.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $ba545286fdfaf967$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $etkCM.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $ivtFp.top) : (0, $ivtFp.left);
    var maxProp = axis === 'y' ? (0, $ivtFp.bottom) : (0, $ivtFp.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3n7LB.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $gF5R4.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $ba545286fdfaf967$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $92oHa.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $ba545286fdfaf967$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $ba545286fdfaf967$var$arrow,
    effect: $ba545286fdfaf967$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("lGkc5", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc8d2f4bd4a32835$export$2e2bcd8739ae039);

var $ivtFp = parcelRequire("ivtFp");

var $5Rfne = parcelRequire("5Rfne");
function $fc8d2f4bd4a32835$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $fc8d2f4bd4a32835$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $ivtFp.top),
        (0, $ivtFp.right),
        (0, $ivtFp.bottom),
        (0, $ivtFp.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $fc8d2f4bd4a32835$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $5Rfne.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $5Rfne.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $fc8d2f4bd4a32835$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $fc8d2f4bd4a32835$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $fc8d2f4bd4a32835$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $fc8d2f4bd4a32835$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $fc8d2f4bd4a32835$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $fc8d2f4bd4a32835$var$hide
};

});




parcelRegister("bbkSN", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $8240ebad618848be$export$e0be378c32fb70a7);

var $eJOHy = parcelRequire("eJOHy");

var $9Hk5t = parcelRequire("9Hk5t");

var $bI4U6 = parcelRequire("bI4U6");

var $gEsU4 = parcelRequire("gEsU4");
function $8240ebad618848be$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eJOHy.useContext((0, $bI4U6.ManagerReferenceNodeSetterContext));
    var refHandler = $eJOHy.useCallback(function(node) {
        (0, $gEsU4.setRef)(innerRef, node);
        (0, $gEsU4.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eJOHy.useEffect(function() {
        return function() {
            return (0, $gEsU4.setRef)(innerRef, null);
        };
    }, []);
    $eJOHy.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9Hk5t)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $gEsU4.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("5yteI", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $40b6ce70abc0b2ca$export$3e67810a3f0e9f1c);
function $40b6ce70abc0b2ca$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $40b6ce70abc0b2ca$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $40b6ce70abc0b2ca$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $40b6ce70abc0b2ca$export$967a6b9924a689f7(a, b);
    return $40b6ce70abc0b2ca$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("iDDai", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $7bfc5f3b3b9d8c9d$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $7bfc5f3b3b9d8c9d$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $7bfc5f3b3b9d8c9d$export$71abc632aa29e6fe);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $hJ5hq = parcelRequire("hJ5hq");

var $j3gIc = parcelRequire("j3gIc");

var $1otFb = parcelRequire("1otFb");
const $7bfc5f3b3b9d8c9d$var$menuDialogStyles = null;
const $7bfc5f3b3b9d8c9d$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, id: id, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, $hcewu.default)([
            "_2rkoiti9 _1pby16oo _bfhk1bhr _16qseva7"
        ]),
        children: children
    });
});
// ==============================
// Custom Components
// ==============================
const $7bfc5f3b3b9d8c9d$var$dropdownStyles = null;
const $7bfc5f3b3b9d8c9d$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1bsbzwfg _12l2v77o _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hJ5hq))), {
            color: "currentColor",
            label: ""
        })
    });
const $7bfc5f3b3b9d8c9d$var$controlStyles = null;
const $7bfc5f3b3b9d8c9d$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: innerRef,
        className: (0, $hcewu.default)([
            "_85i51b66 _1q51u2gc _y4tiu2gc _bozgu2gc"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j3gIc.components).Control, {
            ...props,
            innerProps: innerProps
        })
    });
const $7bfc5f3b3b9d8c9d$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $1otFb.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j3gIc.components).Control, {
            ...props
        })
    });
// NOTE `props` intentionally omitted from `Fragment`
const $7bfc5f3b3b9d8c9d$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...innerProps,
        children: children
    });
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
const $7bfc5f3b3b9d8c9d$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $j3gIc.components).ClearIndicator, {
        ...props
    });
const $7bfc5f3b3b9d8c9d$var$MultiValueRemove = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j3gIc.components).MultiValueRemove, {
        ...props
    });
const $7bfc5f3b3b9d8c9d$export$71abc632aa29e6fe = {
    Control: $7bfc5f3b3b9d8c9d$var$Control,
    DropdownIndicator: $7bfc5f3b3b9d8c9d$var$DropdownIndicator,
    Menu: $7bfc5f3b3b9d8c9d$var$Menu,
    ClearIndicator: $7bfc5f3b3b9d8c9d$var$ClearIndicator,
    MultiValueRemove: $7bfc5f3b3b9d8c9d$var$MultiValueRemove
};

});
parcelRegister("hJ5hq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd994b90fa78030d2d1c292998636115>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce7abc282cb2b24b$var$_react = $ce7abc282cb2b24b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ce7abc282cb2b24b$var$_search = $ce7abc282cb2b24b$var$_interopRequireDefault((parcelRequire("8tSIA")));

var $ce7abc282cb2b24b$var$_search2 = $ce7abc282cb2b24b$var$_interopRequireDefault((parcelRequire("hn0Su")));
function $ce7abc282cb2b24b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce7abc282cb2b24b$var$SearchIcon = (props)=>/*#__PURE__*/ $ce7abc282cb2b24b$var$_react.default.createElement($ce7abc282cb2b24b$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $ce7abc282cb2b24b$var$_search2.default
    }, props));
$ce7abc282cb2b24b$var$SearchIcon.Name = 'SearchIconMigration';
var $ce7abc282cb2b24b$var$_default = module.exports.default = $ce7abc282cb2b24b$var$SearchIcon;

});
parcelRegister("hn0Su", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $034370947410ee29$var$_react = $034370947410ee29$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $034370947410ee29$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $034370947410ee29$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $034370947410ee29$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props));
$034370947410ee29$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $034370947410ee29$var$_default = module.exports.default = $034370947410ee29$var$EditorSearchIcon;

});



parcelRegister("eYrYU", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $098d0e81f0367aa7$export$17baa7c95b6ba1b8);

var $8c14o = parcelRequire("8c14o");
function $098d0e81f0367aa7$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore error TS2353: Object literal may only specify known properties, and &#39;onClose&#39; does not exist in type &#39;{ isOpen?: boolean | undefined; }&#39;.
    (0, $8c14o.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});




parcelRegister("cKSXK", function(module, exports) {

$parcel$export(module.exports, "batchByKey", () => $238a814e7bdab532$export$da86c38211c1c0a8);
function $238a814e7bdab532$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("as5UH", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cbb9b836498ff5b3$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $cbb9b836498ff5b3$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    placeholder: {
        id: 'fabric.elements.user-picker.placeholder',
        defaultMessage: 'Enter people or teams...',
        description: 'Placeholder description for empty user/team/email select field.'
    },
    addMore: {
        id: 'fabric.elements.user-picker.placeholder.add-more',
        defaultMessage: 'add more people...',
        description: 'Placeholder for multi user picker when the field is not empty.'
    },
    remove: {
        id: 'fabric.elements.user-picker.multi.remove-item',
        defaultMessage: 'Remove',
        description: 'Tooltip for the single item remove button in a multi user select field.'
    },
    clear: {
        id: 'fabric.elements.user-picker.single.clear',
        defaultMessage: 'Clear',
        description: 'Tooltip for clear button in the single user select field.'
    },
    errorMessage: {
        id: 'fabric.elements.user-picker.error.message',
        defaultMessage: 'Something went wrong',
        description: 'Error message to display when options fail to load.'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.including.you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    addEmail: {
        id: 'fabric.elements.user-picker.email.add',
        defaultMessage: 'Add user',
        description: 'Byline for valid email option.'
    },
    selectToAddEmail: {
        id: 'fabric.elements.user-picker.email.select.to.add',
        defaultMessage: 'Select an email address',
        description: 'Byline for valid email option.'
    },
    continueToAddEmail: {
        id: 'fabric.elements.user-picker.email.add.potential',
        defaultMessage: 'Enter an email address',
        description: 'Byline for a potentially valid email option.'
    },
    groupByline: {
        id: 'fabric.elements.user-picker.group.byline',
        defaultMessage: 'Admin-managed group',
        description: 'Byline for admin-managed groups'
    },
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    externalUserSourcesError: {
        id: 'fabric.elements.user-picker.external.sourced.error',
        defaultMessage: "We can't connect you right now.",
        description: "Error message when we can't fetch a user's import sources"
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    jiraSource: {
        id: 'fabric.elements.user-picker.source.jira',
        defaultMessage: 'Jira',
        description: 'This external user is sourced from Jira'
    },
    confluenceSource: {
        id: 'fabric.elements.user-picker.source.confluence',
        defaultMessage: 'Confluence',
        description: 'This external user is sourced from Confluence'
    },
    otherAtlassianSource: {
        id: 'fabric.elements.user-picker.source.other-atlassian',
        defaultMessage: 'Other Atlassian products',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    otherAtlassianSourceAppify: {
        id: 'fabric.elements.user-picker.source.other-atlassian-appify',
        defaultMessage: 'Other Atlassian apps',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    },
    userTypeLabel: {
        id: 'fabric.elements.user-picker.user.type.label',
        defaultMessage: 'People',
        description: 'Label for user type'
    },
    teamTypeLabel: {
        id: 'fabric.elements.user-picker.team.type.label',
        defaultMessage: 'Teams',
        description: 'Label for team type'
    },
    emailTypeLabel: {
        id: 'fabric.elements.user-picker.email.type.label',
        defaultMessage: 'Emails',
        description: 'Label for email type'
    },
    groupTypeLabel: {
        id: 'fabric.elements.user-picker.group.type.label',
        defaultMessage: 'Groups',
        description: 'Label for group type'
    },
    externalUserTypeLabel: {
        id: 'fabric.elements.user-picker.external.user.type.label',
        defaultMessage: 'External Users',
        description: 'Label for external user type'
    },
    customTypeLabel: {
        id: 'fabric.elements.user-picker.custom.type.label',
        defaultMessage: 'Customs',
        description: 'Label for custom type'
    },
    otherTypeLabel: {
        id: 'fabric.elements.user-picker.other.type.label',
        defaultMessage: 'Others',
        description: 'Label for other type'
    }
});

});

parcelRegister("7MV0T", function(module, exports) {

$parcel$export(module.exports, "groupOptionsByType", () => $eb07fd96af571ce6$export$393a985f7dd07cfe);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $LFmXM = parcelRequire("LFmXM");

var $as5UH = parcelRequire("as5UH");
const $eb07fd96af571ce6$var$getLabelForType = (type)=>{
    switch(type){
        case 'user':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $as5UH.messages).userTypeLabel
            });
        case 'team':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $as5UH.messages).teamTypeLabel
            });
        case 'group':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $as5UH.messages).groupTypeLabel
            });
        case 'custom':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $as5UH.messages).customTypeLabel
            });
        case 'external_user':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $as5UH.messages).externalUserTypeLabel
            });
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $as5UH.messages).otherTypeLabel
            });
    }
};
const $eb07fd96af571ce6$export$393a985f7dd07cfe = (0, $LFmXM.default)((options, groupByTypeOrder)=>{
    // If groupByTypeOrder is empty, just return the original options
    if (groupByTypeOrder.length === 0) return options;
    const groupedMap = new Map();
    options.forEach((option)=>{
        const type = option.data.type || 'other';
        if (!groupedMap.has(type)) groupedMap.set(type, []);
        groupedMap.get(type).push(option);
    });
    const result = [];
    // add groups in the specified order
    // type is not in groupByTypeOrder, don't add it to the result
    groupByTypeOrder.forEach((type)=>{
        if (groupedMap.has(type)) {
            result.push({
                label: $eb07fd96af571ce6$var$getLabelForType(type),
                options: groupedMap.get(type)
            });
            groupedMap.delete(type);
        }
    });
    return result;
});

});

parcelRegister("gWW8Y", function(module, exports) {

$parcel$export(module.exports, "userPickerRenderedUfoExperience", () => $f5330bdac54e208f$export$b49757166e1acfc2);
$parcel$export(module.exports, "userPickerOptionsShownUfoExperience", () => $f5330bdac54e208f$export$135a264e0da507ae);
$parcel$export(module.exports, "UfoErrorBoundary", () => $f5330bdac54e208f$export$5ef1c2550074a375);

var $eJOHy = parcelRequire("eJOHy");

var $5tvS9 = parcelRequire("5tvS9");
var $dBtrr = parcelRequire("dBtrr");
var $1i6NW = parcelRequire("1i6NW");
const $f5330bdac54e208f$export$b49757166e1acfc2 = new (0, $5tvS9.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $dBtrr.ExperienceTypes).Load,
    performanceType: (0, $dBtrr.ExperiencePerformanceTypes).PageSegmentLoad
});
const $f5330bdac54e208f$export$135a264e0da507ae = new (0, $5tvS9.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $dBtrr.ExperienceTypes).Operation,
    performanceType: (0, $dBtrr.ExperiencePerformanceTypes).InlineResult
});
class $f5330bdac54e208f$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch() {
        const instance = $f5330bdac54e208f$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $1i6NW.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}

});
parcelRegister("5tvS9", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $1c1f31029ad90ee0$export$ac1cddfee07ba6ac);

var $bjABV = parcelRequire("bjABV");

var $dHVjK = parcelRequire("dHVjK");
class $1c1f31029ad90ee0$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $dHVjK.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $bjABV.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});



parcelRegister("9shHz", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $1b20b76af0b55d39$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "getPopupStyles", () => $1b20b76af0b55d39$export$4e983f376ad8a3af);


var $LFmXM = parcelRequire("LFmXM");

var $1Cwn9 = parcelRequire("1Cwn9");

var $8XtVW = parcelRequire("8XtVW");
const $1b20b76af0b55d39$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $1b20b76af0b55d39$export$53937c04f7dfc2ae = 6;
const $1b20b76af0b55d39$export$2c62ba763e976c54 = 39;
const $1b20b76af0b55d39$export$ffd58b7f6f099a57 = (0, $LFmXM.default)((width, isMulti, isCompact, overrideStyles, isInvalid, isVisualRefresh, isPopupStyles, height)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: isInvalid ? `var(--ds-border-danger, ${0, $135dba7912433cc2$export$2010d0fb4295b346})` : state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $135dba7912433cc2$export$7c87d337fb91a97d})`,
                backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $135dba7912433cc2$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $135dba7912433cc2$export$9fdfb749e33cdf97})`,
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: isInvalid ? `var(--ds-border-danger, ${0, $135dba7912433cc2$export$2010d0fb4295b346})` : state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $135dba7912433cc2$export$ecfc1dff386a3e7a})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $135dba7912433cc2$export$7c87d337fb91a97d})`,
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $135dba7912433cc2$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $135dba7912433cc2$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $135dba7912433cc2$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $135dba7912433cc2$export$3e51e8f1440314ba})`
                },
                padding: 0,
                minHeight: height && (0, $8XtVW.fg)('jifjam_bulk_operations') || isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: height && (0, $8XtVW.fg)('jifjam_bulk_operations') ? height : isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: `var(--ds-icon-danger, ${0, $135dba7912433cc2$export$2010d0fb4295b346})`
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $1b20b76af0b55d39$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $1b20b76af0b55d39$export$59c188914e58c94b,
                paddingLeft: isMulti ? $1b20b76af0b55d39$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$1b20b76af0b55d39$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $1b20b76af0b55d39$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $1b20b76af0b55d39$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: `var(--ds-text-subtlest, ${0, $135dba7912433cc2$export$d6447c357493214f})`,
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: `var(--ds-text-subtlest, ${0, $135dba7912433cc2$export$d6447c357493214f})`
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $1Cwn9.mergeStyles)(styles, overrideStyles) : styles;
});
const $1b20b76af0b55d39$export$4e983f376ad8a3af = (0, $LFmXM.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$1b20b76af0b55d39$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, false, isVisualRefresh, true)
    }));

});

parcelRegister("fx4It", function(module, exports) {

$parcel$export(module.exports, "getComponents", () => $a6744362ca392aa1$export$4e811121b221213b);
$parcel$export(module.exports, "getPopupComponents", () => $a6744362ca392aa1$export$19205fd341a6bb08);

var $LFmXM = parcelRequire("LFmXM");

var $dluo7 = parcelRequire("dluo7");

var $kesGT = parcelRequire("kesGT");

var $hLXdX = parcelRequire("hLXdX");

var $iDiYD = parcelRequire("iDiYD");

var $h3G7a = parcelRequire("h3G7a");

var $hkkP2 = parcelRequire("hkkP2");

var $9dKpJ = parcelRequire("9dKpJ");

var $5IPqE = parcelRequire("5IPqE");

var $kbjyE = parcelRequire("kbjyE");

var $44N7c = parcelRequire("44N7c");

var $kxlkL = parcelRequire("kxlkL");
const $a6744362ca392aa1$export$4e811121b221213b = (0, $LFmXM.default)((multi, anchor, showClearIndicator, customComponents)=>{
    if (anchor) return {
        Control: anchor,
        Option: $iDiYD.Option
    };
    else return {
        MultiValue: $kesGT.MultiValue,
        DropdownIndicator: null,
        SingleValue: $h3G7a.SingleValue,
        ClearIndicator: showClearIndicator || !multi ? (0, $dluo7.ClearIndicator) : null,
        Option: $iDiYD.Option,
        ValueContainer: multi ? (0, $hLXdX.MultiValueContainer) : (0, $9dKpJ.SingleValueContainer),
        Input: $hkkP2.Input,
        Menu: $44N7c.Menu,
        Control: $kxlkL.default,
        ...customComponents ? customComponents : {}
    };
});
const $a6744362ca392aa1$export$19205fd341a6bb08 = (0, $LFmXM.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $h3G7a.SingleValue,
        ClearIndicator: $dluo7.ClearIndicator,
        Option: $iDiYD.Option,
        ValueContainer: (0, $9dKpJ.SingleValueContainer),
        Input: (0, $5IPqE.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $kbjyE.PopupControl)
    };
    return baseProps;
});

});
parcelRegister("dluo7", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $aed6707e6e1a505e$export$ecf9cf59142dd54a);
/* ClearIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j3gIc = parcelRequire("j3gIc");

const $aed6707e6e1a505e$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("89Hyr")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $aed6707e6e1a505e$var$clearIndicatorStyles = {
    root: "_v5641ppt _tzy4kb7n _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _30l3s4qr _1mhjgrf3"
};
class $aed6707e6e1a505e$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j3gIc.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            },
            xcss: $aed6707e6e1a505e$var$clearIndicatorStyles.root
        });
        return clearValueLabel ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
            fallback: Indicator,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($aed6707e6e1a505e$var$AsyncTooltip, {
                content: clearValueLabel,
                children: Indicator
            })
        }) : Indicator;
    }
    constructor(...args){
        super(...args), this.handleMouseDown = (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            //@ts-ignore react-select unsupported props
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        };
    }
}

});
parcelRegister("89Hyr", function(module, exports) {

let $5f00f308d917e816$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5f00f308d917e816$var$load("1DGkI").then(()=>parcelRequire('hLWON'));

});


parcelRegister("kesGT", function(module, exports) {

$parcel$export(module.exports, "MultiValue", () => $0492843039fcbf6f$export$419cdf50db8b579);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $bL3dk = parcelRequire("bL3dk");
var $5Wv5g = parcelRequire("5Wv5g");

var $j3gIc = parcelRequire("j3gIc");

var $1NIU8 = parcelRequire("1NIU8");

var $1plXi = parcelRequire("1plXi");

var $b19Si = parcelRequire("b19Si");

var $jgqXv = parcelRequire("jgqXv");

var $bY9p9 = parcelRequire("bY9p9");

var $2KvAN = parcelRequire("2KvAN");
function $0492843039fcbf6f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0492843039fcbf6f$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $0492843039fcbf6f$var$groupTagContainer = (0, $5Wv5g.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $0492843039fcbf6f$var$nameWrapper = {
    name: "1ebbz80",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
class $0492843039fcbf6f$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props), this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $jgqXv.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1plXi.AddOptionAvatar), {
                isLozenge: true,
                isPendingAction: data.isPendingAction
            });
            if ((0, $jgqXv.isGroup)(data)) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bxHeV.default), {
                xcss: $0492843039fcbf6f$var$groupTagContainer
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bY9p9))), {
                LEGACY_margin: "-2px 0 0 0",
                color: "currentColor",
                label: "" // This element is a decorative icon and does not require a label
                ,
                LEGACY_size: "small"
            }));
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $b19Si.SizeableAvatar), {
                appearance: "multi",
                src: (0, $jgqXv.getAvatarUrl)(data),
                type: (0, $jgqXv.isTeam)(data) ? 'team' : 'person'
            });
        }, this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $jgqXv.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2KvAN.VerifiedTeamIcon), null);
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef();
    }
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $0492843039fcbf6f$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $j3gIc.components).MultiValue, {
            ...rest,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bL3dk.default), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $0492843039fcbf6f$var$nameWrapper
        }, children), this.getElemAfter()));
    }
}

});
parcelRegister("1plXi", function(module, exports) {

$parcel$export(module.exports, "AddOptionAvatar", () => $06fa5b71e1993e91$export$df396db45e491922);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $hdeP0 = parcelRequire("hdeP0");


var $1NIU8 = parcelRequire("1NIU8");
parcelRequire("eJOHy");

var $8XtVW = parcelRequire("8XtVW");
const $06fa5b71e1993e91$var$getEmailAvatarWrapperStyle = (isLozenge, isPendingAction)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    const backgroundColor = isPendingAction && (0, $8XtVW.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-background-warning, #FFF7D6)" : `var(--ds-background-neutral, ${0, $135dba7912433cc2$export$1ce2d1575d444ceb})`;
    return /*#__PURE__*/ (0, $1NIU8.css)({
        padding: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding,
        backgroundColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $06fa5b71e1993e91$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label, isPendingAction: isPendingAction })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $06fa5b71e1993e91$var$getEmailAvatarWrapperStyle(isLozenge, isPendingAction)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hdeP0))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        LEGACY_size: isLozenge ? 'small' : 'medium',
        LEGACY_margin: "0 0 0 -2px",
        color: isPendingAction && (0, $8XtVW.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-text-warning, #A54800)" : `var(--ds-text-subtle, ${0, $135dba7912433cc2$export$c39c0fe0f26207ae})`
    })));
};

});
parcelRegister("hdeP0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2014ecb862bd114df9c4eca3bb7d0c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c87f25dd33e6b55b$var$_react = $c87f25dd33e6b55b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c87f25dd33e6b55b$var$_email = $c87f25dd33e6b55b$var$_interopRequireDefault((parcelRequire("leOqD")));

var $c87f25dd33e6b55b$var$_email2 = $c87f25dd33e6b55b$var$_interopRequireDefault((parcelRequire("i1UrP")));
function $c87f25dd33e6b55b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c87f25dd33e6b55b$var$EmailIcon = (props)=>/*#__PURE__*/ $c87f25dd33e6b55b$var$_react.default.createElement($c87f25dd33e6b55b$var$_email.default, Object.assign({
        LEGACY_fallbackIcon: $c87f25dd33e6b55b$var$_email2.default
    }, props));
$c87f25dd33e6b55b$var$EmailIcon.Name = 'EmailIconMigration';
var $c87f25dd33e6b55b$var$_default = module.exports.default = $c87f25dd33e6b55b$var$EmailIcon;

});
parcelRegister("i1UrP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2041b5ab1131f92$var$_react = $d2041b5ab1131f92$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $d2041b5ab1131f92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d2041b5ab1131f92$var$EmailIcon = (props)=>/*#__PURE__*/ $d2041b5ab1131f92$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props));
$d2041b5ab1131f92$var$EmailIcon.displayName = 'EmailIcon';
var $d2041b5ab1131f92$var$_default = module.exports.default = $d2041b5ab1131f92$var$EmailIcon;

});



parcelRegister("b19Si", function(module, exports) {

$parcel$export(module.exports, "SizeableAvatar", () => $ef4d80afb63dab14$export$44d81a88129649da);

var $gt9Am = parcelRequire("gt9Am");

var $6q0fu = parcelRequire("6q0fu");

var $gGdVw = parcelRequire("gGdVw");

var $eJOHy = parcelRequire("eJOHy");

var $jgqXv = parcelRequire("jgqXv");
class $ef4d80afb63dab14$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person' } = this.props;
        const props = {
            size: (0, $jgqXv.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence
        };
        return type === 'team' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gGdVw.default), {
            ...props
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6q0fu.default), {
            ...props
        });
    }
}

});
parcelRegister("gGdVw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c999cbe871cd13d5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6q0fu = parcelRequire("6q0fu");


var $1cGyI = parcelRequire("1cGyI");

var $l05W3 = parcelRequire("l05W3");
const $c999cbe871cd13d5$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $135dba7912433cc2$export$29a4f05edc054374)})`;
const $c999cbe871cd13d5$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $135dba7912433cc2$export$7c87d337fb91a97d)})`;
function $c999cbe871cd13d5$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', teamId: teamId = '', ...props }) {
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6q0fu.default), {
        appearance: (0, $l05W3.isSquareIcon)(src) ? 'square' : 'circle',
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1cGyI.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            teamId: teamId
        })
    });
}

});
parcelRegister("1cGyI", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $a58b6e9c7fdf7014$export$ac3673635a5387be);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $9yGqR = parcelRequire("9yGqR");
var $hoFhq = parcelRequire("hoFhq");

var $262zM = parcelRequire("262zM");

var $8HKig = parcelRequire("8HKig");

var $8XtVW = parcelRequire("8XtVW");


var $4Fxpk = parcelRequire("4Fxpk");

var $aICB8 = parcelRequire("aICB8");
function $a58b6e9c7fdf7014$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a58b6e9c7fdf7014$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $135dba7912433cc2$export$29a4f05edc054374)})`;
const $a58b6e9c7fdf7014$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $135dba7912433cc2$export$7c87d337fb91a97d)})`;
// used in a size calculation so can't be a token. Without this the avatar looks very squished
const $a58b6e9c7fdf7014$var$ICON_PADDING = 4;
const $a58b6e9c7fdf7014$var$avatarDefaultIconStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    backgroundColor: $a58b6e9c7fdf7014$var$ICON_COLOR,
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
});
const $a58b6e9c7fdf7014$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $a58b6e9c7fdf7014$var$nestedAvatarStyles = Object.entries((0, $9yGqR.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $1NIU8.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`,
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: `${size - $a58b6e9c7fdf7014$var$ICON_PADDING}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: `${size - $a58b6e9c7fdf7014$var$ICON_PADDING}px`
            }
        })
    };
}, {});
const $a58b6e9c7fdf7014$var$avatarImageStyles = {
    name: "n68006",
    styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
};
const $a58b6e9c7fdf7014$export$9cfabd93718c0a2e = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If src changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        if ((0, $8XtVW.fg)('enable-team-avatar-switch')) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4Fxpk.FallbackAvatar), {
            "aria-label": alt,
            width: $a58b6e9c7fdf7014$var$SIZES[size],
            height: $a58b6e9c7fdf7014$var$SIZES[size],
            "data-testid": testId
        });
        return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: [
                $a58b6e9c7fdf7014$var$avatarDefaultIconStyles,
                $a58b6e9c7fdf7014$var$nestedAvatarStyles[size]
            ]
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($262zM))), {
            label: alt,
            color: $a58b6e9c7fdf7014$var$ICON_BACKGROUND,
            LEGACY_secondaryColor: $a58b6e9c7fdf7014$var$ICON_COLOR,
            testId: testId && `${testId}--team`,
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8HKig)))
        }));
    }
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $hoFhq.AvatarContent), null, /*#__PURE__*/ (0, $1NIU8.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $a58b6e9c7fdf7014$var$avatarImageStyles,
        onError: ()=>setHasImageErrored(true)
    }));
};
const $a58b6e9c7fdf7014$export$ac3673635a5387be = (props)=>{
    if ((0, $8XtVW.fg)('team-avatar-radii')) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $aICB8.TeamAvatarImage), props);
    return /*#__PURE__*/ (0, $1NIU8.jsx)($a58b6e9c7fdf7014$export$9cfabd93718c0a2e, props);
};

});
parcelRegister("9yGqR", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", () => $265f94954baece45$export$9a270941bcff7e77);
$parcel$export(module.exports, "AVATAR_RADIUS", () => $265f94954baece45$export$e6da6efe4d1a5c9b);
$parcel$export(module.exports, "BORDER_WIDTH", () => $265f94954baece45$export$e2bd4c1faded7921);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $408ts = parcelRequire("408ts");
const $265f94954baece45$export$9a270941bcff7e77 = {
    xsmall: (0, $408ts.gridSize)() * 2,
    small: (0, $408ts.gridSize)() * 3,
    medium: (0, $408ts.gridSize)() * 4,
    large: (0, $408ts.gridSize)() * 5,
    xlarge: (0, $408ts.gridSize)() * 12,
    xxlarge: (0, $408ts.gridSize)() * 16
};
const $265f94954baece45$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
const $265f94954baece45$export$e2bd4c1faded7921 = 2;
const $265f94954baece45$export$89a980dfdf90df51 = 0.9;
const $265f94954baece45$export$3c061e31594ebabe = '--avatar-background-color';
const $265f94954baece45$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
const $265f94954baece45$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});

parcelRegister("8HKig", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65663fcdd14e48f2$var$_react = $65663fcdd14e48f2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $65663fcdd14e48f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $65663fcdd14e48f2$var$PeopleIcon = (props)=>/*#__PURE__*/ $65663fcdd14e48f2$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props));
$65663fcdd14e48f2$var$PeopleIcon.displayName = 'PeopleIcon';
var $65663fcdd14e48f2$var$_default = module.exports.default = $65663fcdd14e48f2$var$PeopleIcon;

});

parcelRegister("4Fxpk", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $0e7104ca2ab28484$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $dhRXV = parcelRequire("dhRXV");
const $0e7104ca2ab28484$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $0e7104ca2ab28484$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
        xcss: $0e7104ca2ab28484$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});

parcelRegister("aICB8", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $5f9ddb7b3b3fc9b9$export$ac3673635a5387be);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kL8dS = parcelRequire("kL8dS");

var $4uDx2 = parcelRequire("4uDx2");
const $5f9ddb7b3b3fc9b9$var$boxShadowCssVar = '--avatar-box-shadow';
const $5f9ddb7b3b3fc9b9$var$bgColorCssVar = '--avatar-bg-color';
/**
 * We need to maintan the container styles manually until Avatar provides the correct border radius.
 * After that we can return to wrapping in <AvatarContent> rather than span
 */ const $5f9ddb7b3b3fc9b9$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw",
    circle: "_2rko1q5u _14mj1q5u",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $5f9ddb7b3b3fc9b9$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $5f9ddb7b3b3fc9b9$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $5f9ddb7b3b3fc9b9$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $5f9ddb7b3b3fc9b9$var$borderRadiusMap = {
    xsmall: "_2rko1y44",
    small: "_2rkoi2wt",
    medium: "_2rkopd34",
    large: "_2rko19bv",
    xlarge: "_2rko1tcg",
    xxlarge: "_2rkozwfg"
};
const $5f9ddb7b3b3fc9b9$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $5f9ddb7b3b3fc9b9$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, teamId: teamId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    const avatarSrc = (0, $4uDx2.getTeamAvatarSrc)(src, teamId);
    // If src changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        avatarSrc
    ]);
    if (!avatarSrc || hasImageErrored) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kL8dS.FallbackAvatar), {
        "aria-label": alt,
        width: $5f9ddb7b3b3fc9b9$var$SIZES[size],
        height: $5f9ddb7b3b3fc9b9$var$SIZES[size],
        "data-testid": testId
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $hcewu.default)([
            $5f9ddb7b3b3fc9b9$var$unboundStyles.root,
            $5f9ddb7b3b3fc9b9$var$containerStyles.root,
            $5f9ddb7b3b3fc9b9$var$borderRadiusMap[size],
            $5f9ddb7b3b3fc9b9$var$widthHeightMap[size]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            src: avatarSrc,
            alt: alt,
            "data-testId": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $hcewu.default)([
                $5f9ddb7b3b3fc9b9$var$avatarImageStyles.image
            ])
        })
    });
};

});
parcelRegister("kL8dS", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $6f510684031275a5$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $dhRXV = parcelRequire("dhRXV");
const $6f510684031275a5$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $6f510684031275a5$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
        xcss: $6f510684031275a5$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});

parcelRegister("4uDx2", function(module, exports) {

$parcel$export(module.exports, "getTeamAvatarSrc", () => $a851b43d370e4c99$export$59ff7d19feb890b6);
/**
 * If a src value is given, we'll use that directly.
 * Otherwise we'll generate a static URL from the teamId.
 * If neither are provided, return undefined so that the fallback will be used.
 */ function $a851b43d370e4c99$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return `/gateway/api/v4/teams/${teamId}/avatar`;
    return undefined;
}

});



parcelRegister("l05W3", function(module, exports) {

$parcel$export(module.exports, "isSquareIcon", () => $9f7925ade5bb42cc$export$d5a05ffb65695bc0);

var $8XtVW = parcelRequire("8XtVW");
function $9f7925ade5bb42cc$export$d5a05ffb65695bc0(src) {
    if (!src) return false;
    try {
        const url = new URL(src);
        const host = url.host;
        const path = url.pathname;
        if ((host.startsWith('ptc-directory-sited-static') || host.startsWith('teams-directory-frontend')) && path.includes('teams/avatars/v4') && (0, $8XtVW.fg)('enable-team-avatar-switch')) return true;
    } catch  {
    // The src wasn't a URL, so it's obviously not the refreshed avatar.
    }
    return false;
}

});



parcelRegister("bY9p9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff23a711b4b109cded01cd0a5945034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b6c97da0e825456$var$_react = $8b6c97da0e825456$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8b6c97da0e825456$var$_peopleGroup = $8b6c97da0e825456$var$_interopRequireDefault((parcelRequire("262zM")));

var $8b6c97da0e825456$var$_people = $8b6c97da0e825456$var$_interopRequireDefault((parcelRequire("8HKig")));
function $8b6c97da0e825456$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b6c97da0e825456$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $8b6c97da0e825456$var$_react.default.createElement($8b6c97da0e825456$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $8b6c97da0e825456$var$_people.default
    }, props));
$8b6c97da0e825456$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $8b6c97da0e825456$var$_default = module.exports.default = $8b6c97da0e825456$var$PeopleGroupIcon;

});

parcelRegister("2KvAN", function(module, exports) {

$parcel$export(module.exports, "VerifiedTeamIcon", () => $0e9fe3dc2f726084$export$d7949f68d31e5edd);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $jgvyK = parcelRequire("jgvyK");

var $cz1Ua = parcelRequire("cz1Ua");

var $9JB3T = parcelRequire("9JB3T");

var $af9xS = parcelRequire("af9xS");
const $0e9fe3dc2f726084$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $af9xS.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9JB3T.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jgvyK))), {
                    color: "var(--ds-icon-accent-blue, #1D7AFC)",
                    LEGACY_size: "medium",
                    label: tooltipContent,
                    spacing: "spacious",
                    LEGACY_fallbackIcon: (0, $cz1Ua.default)
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jgvyK))), {
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: label,
        LEGACY_fallbackIcon: (0, $cz1Ua.default)
    });
};

});
parcelRegister("jgvyK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e3a26defb7fafbfaa404238ab66b0242>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e067fe00ee8864cd$var$_react = $e067fe00ee8864cd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e067fe00ee8864cd$var$_baseNew = $e067fe00ee8864cd$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $e067fe00ee8864cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
Filled status icons provide higher visual contrast draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e067fe00ee8864cd$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $e067fe00ee8864cd$var$_react.default.createElement($e067fe00ee8864cd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.85.444a1.713 1.713 0 0 1 2.301 0L10.3 1.486a.2.2 0 0 0 .15.055L12 1.48a1.71 1.71 0 0 1 1.762 1.479l.21 1.537a.2.2 0 0 0 .081.139l1.226.95c.696.54.87 1.52.4 2.266l-.828 1.312a.2.2 0 0 0-.027.158l.328 1.516a1.713 1.713 0 0 1-1.151 1.993l-1.477.474a.2.2 0 0 0-.123.103l-.723 1.372a1.713 1.713 0 0 1-2.162.787l-1.435-.587a.2.2 0 0 0-.161 0l-1.436.587a1.713 1.713 0 0 1-2.162-.787l-.723-1.372a.22.22 0 0 0-.124-.103L2 12.83a1.713 1.713 0 0 1-1.15-1.993l.327-1.516a.2.2 0 0 0-.027-.158L.322 7.852a1.713 1.713 0 0 1 .4-2.266l1.225-.95a.2.2 0 0 0 .081-.14l.21-1.536a1.71 1.71 0 0 1 1.763-1.48l1.55.06a.2.2 0 0 0 .15-.055zm-.1 9.384L4.826 7.519l-1.152.961 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$e067fe00ee8864cd$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $e067fe00ee8864cd$var$_default = module.exports.default = $e067fe00ee8864cd$var$StatusVerifiedIcon;

});

parcelRegister("cz1Ua", function(module, exports) {

$parcel$export(module.exports, "default", () => $07566fbc0b917e2b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aCmsU = parcelRequire("aCmsU");
const $07566fbc0b917e2b$var$VerifiedIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.6666 6.65507C17.7592 4.89362 15.2407 4.89362 14.3332 6.65507C13.7879 7.7135 12.5577 8.22306 11.4237 7.86022C9.53648 7.25639 7.75565 9.03721 8.35949 10.9244C8.72232 12.0584 8.21276 13.2886 7.15434 13.8339C5.39289 14.7414 5.39289 17.2599 7.15434 18.1674C8.21276 18.7127 8.72232 19.9429 8.35949 21.0769C7.75565 22.9641 9.53648 24.7449 11.4237 24.1411C12.5577 23.7783 13.7879 24.2878 14.3332 25.3462C15.2407 27.1077 17.7592 27.1077 18.6666 25.3462C19.212 24.2878 20.4421 23.7783 21.5761 24.1411C23.4634 24.7449 25.2442 22.9641 24.6404 21.0769C24.2775 19.9429 24.7871 18.7127 25.8455 18.1674C27.607 17.2599 27.607 14.7414 25.8455 13.8339C24.7871 13.2886 24.2775 12.0584 24.6404 10.9244C25.2442 9.03721 23.4634 7.25639 21.5761 7.86022C20.4421 8.22306 19.212 7.7135 18.6666 6.65507ZM20.7898 12.7002L20.8932 12.7923C21.323 13.2221 21.3537 13.8998 20.9853 14.365L20.8932 14.4684L16.1524 19.2091C15.7226 19.6389 15.0449 19.6696 14.5797 19.3012L14.4764 19.2091L12.106 16.8388C11.6431 16.3759 11.6431 15.6255 12.106 15.1627C12.5358 14.7329 13.2135 14.7022 13.6787 15.0706L13.7821 15.1627L15.3146 16.6944L19.2171 12.7923C19.6469 12.3625 20.3246 12.3318 20.7898 12.7002Z",
            fill: "currentColor"
        })
    });
/**
 * __VerifiedIcon__
 */ const $07566fbc0b917e2b$var$VerifiedIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $aCmsU.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $07566fbc0b917e2b$var$VerifiedIconGlyph
    });
var $07566fbc0b917e2b$export$2e2bcd8739ae039 = $07566fbc0b917e2b$var$VerifiedIcon;

});

parcelRegister("af9xS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $27ee7e9131c5edbe$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $27ee7e9131c5edbe$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
        defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
        description: 'Tooltip text for the verified team icon'
    }
});

});



parcelRegister("hLXdX", function(module, exports) {

$parcel$export(module.exports, "MultiValueContainer", () => $79c07b0a3a92514f$export$cf9cf2a30a59265c);
/* MultiValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $j3gIc = parcelRequire("j3gIc");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $kDaaB = parcelRequire("kDaaB");

var $as5UH = parcelRequire("as5UH");

var $jgqXv = parcelRequire("jgqXv");

var $itwaQ = parcelRequire("itwaQ");
const $79c07b0a3a92514f$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bv12x7 _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf"
};
class $79c07b0a3a92514f$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    constructor(props){
        super(props), this.timeoutId = null, this.scrollToBottom = ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) {
                    const container = (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).findDOMNode(current);
                    if (container instanceof HTMLDivElement) container.scrollTop = container.scrollHeight;
                }
                this.timeoutId = null;
            });
        }, this.showPlaceholder = ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        }, this.addPlaceholder = (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(this.props.children, (child)=>(0, $jgqXv.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
                children: children
            });
        }, this.renderChildren = ()=>{
            const { //@ts-ignore react-select unsupported props
            selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
            // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $as5UH.messages).addMore,
                children: (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                }
            });
            return this.addPlaceholder(addMoreMessage);
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef()
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        //@ts-ignore react-select unsupported props
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $itwaQ.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j3gIc.components).ValueContainer, {
                ...props,
                xcss: $79c07b0a3a92514f$var$valueContainerStyles.root,
                children: this.renderChildren()
            })
        });
    }
}

});
parcelRegister("itwaQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $447e0312ec69c800$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $447e0312ec69c800$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $447e0312ec69c800$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $447e0312ec69c800$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $447e0312ec69c800$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $447e0312ec69c800$export$2e2bcd8739ae039 = $447e0312ec69c800$var$ValueContainerWrapper;

});


parcelRegister("iDiYD", function(module, exports) {

$parcel$export(module.exports, "Option", () => $95508e9cb7b8e315$export$36d18380658d5d20);

var $gt9Am = parcelRequire("gt9Am");

var $dhRXV = parcelRequire("dhRXV");

var $j3gIc = parcelRequire("j3gIc");

var $9JB3T = parcelRequire("9JB3T");

var $eJOHy = parcelRequire("eJOHy");

var $vLLl5 = parcelRequire("vLLl5");

var $k15zD = parcelRequire("k15zD");

var $3pwtU = parcelRequire("3pwtU");

var $1sTpz = parcelRequire("1sTpz");

var $pb1dC = parcelRequire("pb1dC");

var $kfJF8 = parcelRequire("kfJF8");

var $jgqXv = parcelRequire("jgqXv");

var $8HpSd = parcelRequire("8HpSd");
const $95508e9cb7b8e315$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vLLl5.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $95508e9cb7b8e315$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $jgqXv.isExternalUser)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k15zD.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $jgqXv.isUser)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vLLl5.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $jgqXv.isEmail)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $pb1dC.default), {
        email: data,
        emailValidity: (0, $8HpSd.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $jgqXv.isTeam)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pwtU.default), {
        team: data,
        isSelected: isSelected
    });
    if ((0, $jgqXv.isGroup)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1sTpz.default), {
        group: data,
        isSelected: isSelected
    });
    if ((0, $jgqXv.isCustom)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kfJF8.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $95508e9cb7b8e315$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9JB3T.default), {
        content: props.data?.data?.tooltip,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
                ...tooltipProps,
                children: $95508e9cb7b8e315$var$dataOption(props)
            })
    });
    return $95508e9cb7b8e315$var$dataOption(props);
};
const $95508e9cb7b8e315$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $j3gIc.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
            fallback: $95508e9cb7b8e315$var$defaultOption(props),
            children: $95508e9cb7b8e315$var$dataOptionWithTooltip(props)
        })
    });

});
parcelRegister("vLLl5", function(module, exports) {

$parcel$export(module.exports, "UserOption", () => $fdeb2b3f772dbc21$export$8e59f78010871662);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $4FhDX = parcelRequire("4FhDX");

var $irfdF = parcelRequire("irfdF");

var $b19Si = parcelRequire("b19Si");

var $jgqXv = parcelRequire("jgqXv");

var $8XtVW = parcelRequire("8XtVW");
class $fdeb2b3f772dbc21$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4FhDX.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args), this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $4FhDX.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $135dba7912433cc2$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $135dba7912433cc2$export$7d61b15e0da132af})`)
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $irfdF.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $jgqXv.hasValue)(publicName) && name.trim() !== publicName.trim()) result.push(/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                key: "publicName"
            }, ' ', /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $4FhDX.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $135dba7912433cc2$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $135dba7912433cc2$export$f563ee71e9ee74cd})`)
            }, "(", /*#__PURE__*/ (0, $1NIU8.jsx)((0, $irfdF.HighlightText), {
                highlights: highlight && highlight.publicName
            }, publicName), ")")));
            return result;
        }, this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $4FhDX.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $135dba7912433cc2$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $135dba7912433cc2$export$f563ee71e9ee74cd})`)
            }, this.props.user.byline) : undefined, this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl }, status: status } = this.props;
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $b19Si.SizeableAvatar), {
                appearance: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $8XtVW.fg)('platform-component-visual-refresh') ? 'medium' : 'big',
                src: avatarUrl,
                presence: status
            });
        }, this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}

});
parcelRegister("4FhDX", function(module, exports) {

$parcel$export(module.exports, "textWrapper", () => $988b0daf4e29d258$export$aa6223da92b253dd);
$parcel$export(module.exports, "AvatarItemOption", () => $988b0daf4e29d258$export$164a9d9b3b86dd0c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6alcT = parcelRequire("6alcT");

var $jgqXv = parcelRequire("jgqXv");
function $988b0daf4e29d258$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $988b0daf4e29d258$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("89Hyr")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $988b0daf4e29d258$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $1NIU8.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $988b0daf4e29d258$var$optionWrapper = {
    name: "13552d7",
    styles: "max-width:100%;min-width:0;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $988b0daf4e29d258$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    return /*#__PURE__*/ (0, $1NIU8.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $988b0daf4e29d258$var$additionalInfo = {
    name: "1hvgowa",
    styles: "float:right;margin-left:var(--ds-space-100, 8px)"
};
const $988b0daf4e29d258$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $1NIU8.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $988b0daf4e29d258$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $jgqXv.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
                fallback: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6alcT.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $1NIU8.jsx)($988b0daf4e29d258$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6alcT.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6alcT.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $988b0daf4e29d258$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $988b0daf4e29d258$var$optionWrapper
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", null, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $988b0daf4e29d258$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $988b0daf4e29d258$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $988b0daf4e29d258$var$additionalInfo
    }, renderLozenge())));
};

});

parcelRegister("irfdF", function(module, exports) {

$parcel$export(module.exports, "HighlightText", () => $15b6b418cfc9567f$export$bb02e7bc6e1a7119);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
class $15b6b418cfc9567f$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                children: part.value
            }, index);
            return part.value;
        });
    }
}

});


parcelRegister("k15zD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7192177e4035ffca$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $7192177e4035ffca$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("emqbg")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $7192177e4035ffca$export$2e2bcd8739ae039 = $7192177e4035ffca$var$AsyncExternalUserOption;

});
parcelRegister("emqbg", function(module, exports) {

let $a7476db3cd9b1c0c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $a7476db3cd9b1c0c$var$load("7vqGd"),
    $a7476db3cd9b1c0c$var$load("1Y4bq"),
    $a7476db3cd9b1c0c$var$load("1VRB2"),
    $a7476db3cd9b1c0c$var$load("bABhq"),
    $a7476db3cd9b1c0c$var$load("7a8OK")
]).then(()=>parcelRequire('kFHLq'));

});


parcelRegister("3pwtU", function(module, exports) {

$parcel$export(module.exports, "default", () => $91918c16f22953c8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $91918c16f22953c8$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("dsXD7")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $91918c16f22953c8$export$2e2bcd8739ae039 = $91918c16f22953c8$var$AsyncTeamOption;

});
parcelRegister("dsXD7", function(module, exports) {

let $9cdc25288db15b0f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9cdc25288db15b0f$var$load("1qvxz").then(()=>parcelRequire('4c7Jq'));

});


parcelRegister("1sTpz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a193ba6ac1f6ea50$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $a193ba6ac1f6ea50$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("9tlV7")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $a193ba6ac1f6ea50$export$2e2bcd8739ae039 = $a193ba6ac1f6ea50$var$AsyncGroupOption;

});
parcelRegister("9tlV7", function(module, exports) {

let $6e57d35fc0c43a5f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6e57d35fc0c43a5f$var$load("dxazE").then(()=>parcelRequire('igNuV'));

});


parcelRegister("pb1dC", function(module, exports) {

$parcel$export(module.exports, "default", () => $de0c4136905248ed$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $de0c4136905248ed$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("7LL05")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $de0c4136905248ed$export$2e2bcd8739ae039 = $de0c4136905248ed$var$AsyncEmailOption;

});
parcelRegister("7LL05", function(module, exports) {

let $5a8161812665e49a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5a8161812665e49a$var$load("3pKXQ").then(()=>parcelRequire('h5tnL'));

});


parcelRegister("kfJF8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f1d60731fe7d8d0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $8f1d60731fe7d8d0$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("eRLLG")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $8f1d60731fe7d8d0$export$2e2bcd8739ae039 = $8f1d60731fe7d8d0$var$AsyncCustomOption;

});
parcelRegister("eRLLG", function(module, exports) {

let $ad2b11acf20b2672$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ad2b11acf20b2672$var$load("7xL9P").then(()=>parcelRequire('9evFj'));

});


parcelRegister("8HpSd", function(module, exports) {

$parcel$export(module.exports, "isValidEmail", () => $b60913055a3f3e76$export$371e338370561054);
const $b60913055a3f3e76$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $b60913055a3f3e76$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $b60913055a3f3e76$export$371e338370561054 = (inputText)=>{
    if (inputText.match($b60913055a3f3e76$var$validRegex)) return 'VALID';
    if (inputText.match($b60913055a3f3e76$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});


parcelRegister("h3G7a", function(module, exports) {

$parcel$export(module.exports, "SingleValue", () => $4f558eb96610a47e$export$1949dac661ba6e3a);
/* SingleValue.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j3gIc = parcelRequire("j3gIc");

var $b19Si = parcelRequire("b19Si");

var $jgqXv = parcelRequire("jgqXv");

var $2KvAN = parcelRequire("2KvAN");

var $dhRXV = parcelRequire("dhRXV");
var $gPqEA = parcelRequire("gPqEA");
var $9M9zY = parcelRequire("9M9zY");
const $4f558eb96610a47e$var$styles = {
    avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
    avatarItemText: "_syaz1fxt _1reo15vq _1bto1l2s _o5721q9c"
};
const $4f558eb96610a47e$var$ElementAfter = (props)=>{
    const { data: { data: data } } = props;
    if ((0, $jgqXv.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2KvAN.VerifiedTeamIcon), {});
    return null;
};
const $4f558eb96610a47e$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, //@ts-ignore react-select unsupported props
    selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j3gIc.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gPqEA.default), {
            xcss: $4f558eb96610a47e$var$styles.avatarItem,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b19Si.SizeableAvatar), {
                    src: (0, $jgqXv.getAvatarUrl)(data),
                    appearance: appearance,
                    type: (0, $jgqXv.isTeam)(data) ? 'team' : 'person'
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
                    xcss: $4f558eb96610a47e$var$styles.avatarItem,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $4f558eb96610a47e$var$styles.avatarItemTextWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
                            xcss: $4f558eb96610a47e$var$styles.avatarItemText,
                            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9M9zY.default), {
                                alignBlock: "center",
                                children: [
                                    label,
                                    /*#__PURE__*/ (0, $gt9Am.jsx)($4f558eb96610a47e$var$ElementAfter, {
                                        ...props
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    }) : null;
};

});

parcelRegister("hkkP2", function(module, exports) {

$parcel$export(module.exports, "Input", () => $969dabe2ffcd2d77$export$f5b8910cec6cf069);
/* Input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j3gIc = parcelRequire("j3gIc");
const $969dabe2ffcd2d77$var$inputStyles = {
    root: "_5ce6131l _1ir3kb7n _h5gq131l"
};
class $969dabe2ffcd2d77$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    /**
   * Overrides the default behaviour of react-select lib
   *
   * The getter is a workaround for original behaviour of the react-select lib.
   * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
   * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
   * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
   */ get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j3gIc.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress,
            xcss: $969dabe2ffcd2d77$var$inputStyles.root
        });
    }
    constructor(...args){
        super(...args), // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        this.handleKeyPress = (e)=>{
            if (e.key === 'Enter') e.preventDefault();
            //@ts-ignore react-select unsupported props
            if (this.props.selectProps?.disableInput) e.preventDefault();
        };
    }
}

});

parcelRegister("9dKpJ", function(module, exports) {

$parcel$export(module.exports, "SingleValueContainer", () => $88aea93090c9e272$export$afa5f855316c6a48);
/* SingleValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j3gIc = parcelRequire("j3gIc");

var $b19Si = parcelRequire("b19Si");

var $itwaQ = parcelRequire("itwaQ");
const $88aea93090c9e272$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bvze3t _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf"
};
const $88aea93090c9e272$var$placeholderIconContainer = null;
const $88aea93090c9e272$var$wrapperStyle = null;
const $88aea93090c9e272$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
class $88aea93090c9e272$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $itwaQ.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $j3gIc.components).ValueContainer, {
                ...valueContainerProps,
                xcss: $88aea93090c9e272$var$valueContainerStyles.root,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            "_nd5l1kqh _19bv12x7 _vwz4idpf"
                        ]),
                        children: this.renderAvatar()
                    }),
                    children
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.renderAvatar = ()=>{
            const { hasValue: hasValue, //@ts-ignore react-select unsupported props
            selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b19Si.SizeableAvatar), {
                appearance: appearance,
                type: placeholderAvatar,
                src: $88aea93090c9e272$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
            });
            return null;
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick, this.Wrapper = ({ children: children })=>{
            return this.onValueContainerClick ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                onMouseDown: this.onValueContainerClick,
                className: (0, $hcewu.default)([
                    "_16jlkb7n"
                ]),
                children: children
            }) : children;
        };
    }
}

});

parcelRegister("5IPqE", function(module, exports) {

$parcel$export(module.exports, "PopupInput", () => $7bc286abbc8c781c$export$d8edbfd510a7db82);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hkkP2 = parcelRequire("hkkP2");
class $7bc286abbc8c781c$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hkkP2.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args), this.ref = null, this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}

});

parcelRegister("kbjyE", function(module, exports) {

$parcel$export(module.exports, "PopupControl", () => $30a1e6bf9dff05cc$export$a0cb1b4352357fcc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");


var $kxlkL = parcelRequire("kxlkL");
const $30a1e6bf9dff05cc$var$controlWrapper = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $30a1e6bf9dff05cc$var$labelStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    color: `var(--ds-text-subtlest, ${(0, $135dba7912433cc2$export$f563ee71e9ee74cd)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    paddingBottom: "var(--ds-space-050, 4px)",
    paddingLeft: "var(--ds-space-0, 0px)",
    paddingRight: "var(--ds-space-0, 0px)",
    paddingTop: "var(--ds-space-250, 20px)"
});
class $30a1e6bf9dff05cc$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $30a1e6bf9dff05cc$var$controlWrapper
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $30a1e6bf9dff05cc$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kxlkL.default), this.props));
    }
}

});
parcelRegister("kxlkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a962b0f6395ef26a$export$2e2bcd8739ae039);
/* Control.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $j3gIc = parcelRequire("j3gIc");

var $k0ahr = parcelRequire("k0ahr");
const $a962b0f6395ef26a$var$controlStyles = {
    invalid: "_1h6d1bqt _4cvx1bqt",
    focused: "_1h6d1p6i _bfhk1j9a _4cvx1p6i _irr31j9a",
    disabled: "_irr3syzs",
    subtle: "_1h6d3acm _bfhk18uv _4cvx3acm _irr31gly",
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1h6d1elr _bfhk1j9a _p12f1osq _14regrf3 _4cvx1elr _irr31d5g _1a98zg3v",
    compact: "_1tke1wug"
};
const $a962b0f6395ef26a$var$Control = (props)=>{
    const isCompact = props.appearance === 'compact';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j3gIc.components).Control, {
        ...props,
        xcss: (0, $k0ahr.cx)($a962b0f6395ef26a$var$controlStyles.root, isCompact && $a962b0f6395ef26a$var$controlStyles.compact, (props.selectProps.subtle || props.selectProps.noBorder) && $a962b0f6395ef26a$var$controlStyles.subtle, props.isFocused && $a962b0f6395ef26a$var$controlStyles.focused, props.isInvalid && $a962b0f6395ef26a$var$controlStyles.invalid, props.isDisabled && $a962b0f6395ef26a$var$controlStyles.disabled)
    });
};
var $a962b0f6395ef26a$export$2e2bcd8739ae039 = $a962b0f6395ef26a$var$Control;

});


parcelRegister("44N7c", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $0183de6ec82858ad$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $j3gIc = parcelRequire("j3gIc");

var $1NIU8 = parcelRequire("1NIU8");
const $0183de6ec82858ad$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $0183de6ec82858ad$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $j3gIc.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $0183de6ec82858ad$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}

});


parcelRegister("fUqVE", function(module, exports) {

$parcel$export(module.exports, "getCreatableProps", () => $6b7bc7f18710a0e2$export$36f97d8afa97203d);

var $LFmXM = parcelRequire("LFmXM");


var $8HpSd = parcelRequire("8HpSd");

var $jgqXv = parcelRequire("jgqXv");
const $6b7bc7f18710a0e2$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $6b7bc7f18710a0e2$var$isValidNewOption = (isValidEmail = (0, $8HpSd.isValidEmail))=>(inputValue)=>inputValue && $6b7bc7f18710a0e2$var$validOption.includes(isValidEmail(inputValue));
const $6b7bc7f18710a0e2$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $cb1feb1cecd2f1cc$export$6662b3461398ef8c)
        }
    });
const $6b7bc7f18710a0e2$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $6b7bc7f18710a0e2$var$isOptionDisabled = (isValidEmail = (0, $8HpSd.isValidEmail))=>(option)=>{
        if ((0, $jgqXv.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $6b7bc7f18710a0e2$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $6b7bc7f18710a0e2$var$isValidNewOption(isValidEmail),
        getNewOptionData: $6b7bc7f18710a0e2$var$getNewOptionData,
        formatCreateLabel: $6b7bc7f18710a0e2$var$formatCreateLabel,
        isOptionDisabled: $6b7bc7f18710a0e2$var$isOptionDisabled(isValidEmail)
    };
}
const $6b7bc7f18710a0e2$export$36f97d8afa97203d = (0, $LFmXM.default)($6b7bc7f18710a0e2$var$creatableProps);

});

parcelRegister("8Z00l", function(module, exports) {

$parcel$export(module.exports, "getCreatableSuggestedEmailProps", () => $7f9a77526a65608b$export$34b9dd2dd6a225e5);

var $LFmXM = parcelRequire("LFmXM");


var $8HpSd = parcelRequire("8HpSd");

var $jgqXv = parcelRequire("jgqXv");
const $7f9a77526a65608b$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $7f9a77526a65608b$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $7f9a77526a65608b$var$getNewOptionData = (isValidEmail = (0, $8HpSd.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $7f9a77526a65608b$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $cb1feb1cecd2f1cc$export$6662b3461398ef8c),
                suggestion: true
            }
        };
    };
const $7f9a77526a65608b$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $7f9a77526a65608b$var$isOptionDisabled = (isValidEmail = (0, $8HpSd.isValidEmail))=>(option)=>{
        if ((0, $jgqXv.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $7f9a77526a65608b$export$34b9dd2dd6a225e5 = (0, $LFmXM.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $7f9a77526a65608b$var$isValidNewOption,
        getNewOptionData: $7f9a77526a65608b$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $7f9a77526a65608b$var$formatCreateLabel,
        isOptionDisabled: $7f9a77526a65608b$var$isOptionDisabled(isValidEmail)
    }));

});

parcelRegister("aLb6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2bf36343253b3e9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
var $lRq8t = parcelRequire("lRq8t");

var $eu9i4 = parcelRequire("eu9i4");
const $d2bf36343253b3e9$var$EMPTY = {};
const $d2bf36343253b3e9$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState($d2bf36343253b3e9$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        let aborted = false;
        setMessages($d2bf36343253b3e9$var$EMPTY);
        (0, $eu9i4.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $d2bf36343253b3e9$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $lRq8t.default)();
    const { children: children } = props;
    const messages = $d2bf36343253b3e9$var$useI18n(intl.locale);
    const mergedMessages = (0, $eJOHy.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $d2bf36343253b3e9$export$2e2bcd8739ae039 = $d2bf36343253b3e9$var$MessagesIntlProvider;

});
parcelRegister("eu9i4", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $8a7572576651e592$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $8a7572576651e592$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("6wKJ4")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("hrvGK")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("3RuFq")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("dNsQ0")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("5dRrV")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("5m6uQ")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("l7WzJ")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("aChK2")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("a7Jzc")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("6rINP")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("5IfAC")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("bfjSA")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("7wNgo")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("5ewcn")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("6rYM5")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("7V7Uj")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("c59Ge")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("it08K")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("lp44U")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("12dAt")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("eeTpm")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("aTVJ5")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("z0OvH")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("kaEOd")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("4fKGJ")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("iFSwW")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("fpelj")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("iJNKu")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("fTXEF")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("1ZMdf")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $8a7572576651e592$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("dNsQ0")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("6wKJ4", function(module, exports) {

let $4c09fa02df083047$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4c09fa02df083047$var$load("dD6ge").then(()=>parcelRequire('jHK9y'));

});

parcelRegister("hrvGK", function(module, exports) {

let $cb2d89fb883fee1d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cb2d89fb883fee1d$var$load("jeaq4").then(()=>parcelRequire('gC1Z8'));

});

parcelRegister("3RuFq", function(module, exports) {

let $2cfe1c2b253bec4c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2cfe1c2b253bec4c$var$load("23JoI").then(()=>parcelRequire('ejC36'));

});

parcelRegister("dNsQ0", function(module, exports) {

let $a0b6388c30032f44$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a0b6388c30032f44$var$load("aZl7k").then(()=>parcelRequire('56Cr7'));

});

parcelRegister("5dRrV", function(module, exports) {

let $3cd7a09985e661c3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3cd7a09985e661c3$var$load("fzgYT").then(()=>parcelRequire('g9ihS'));

});

parcelRegister("5m6uQ", function(module, exports) {

let $3e640be0b30fd8c9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3e640be0b30fd8c9$var$load("8rxng").then(()=>parcelRequire('hyUVS'));

});

parcelRegister("l7WzJ", function(module, exports) {

let $f617b043fe45e656$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f617b043fe45e656$var$load("lxDJr").then(()=>parcelRequire('eGTGc'));

});

parcelRegister("aChK2", function(module, exports) {

let $01fea1ebd66687ee$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $01fea1ebd66687ee$var$load("7ho24").then(()=>parcelRequire('hRHVp'));

});

parcelRegister("a7Jzc", function(module, exports) {

let $75ede76f8929c377$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $75ede76f8929c377$var$load("8B6GW").then(()=>parcelRequire('abgdu'));

});

parcelRegister("6rINP", function(module, exports) {

let $4b1804923eb86392$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4b1804923eb86392$var$load("fsPat").then(()=>parcelRequire('7SVqy'));

});

parcelRegister("5IfAC", function(module, exports) {

let $428d279a3aa588d3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $428d279a3aa588d3$var$load("jl3im").then(()=>parcelRequire('8ZyfN'));

});

parcelRegister("bfjSA", function(module, exports) {

let $8300840eb40ddd10$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8300840eb40ddd10$var$load("gk6QA").then(()=>parcelRequire('5ZgIm'));

});

parcelRegister("7wNgo", function(module, exports) {

let $57b1bc3c5f3b416b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $57b1bc3c5f3b416b$var$load("c2HK9").then(()=>parcelRequire('iN0Gb'));

});

parcelRegister("5ewcn", function(module, exports) {

let $3cf73c82730c6ef7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3cf73c82730c6ef7$var$load("6nMZK").then(()=>parcelRequire('gryOD'));

});

parcelRegister("6rYM5", function(module, exports) {

let $4b24683f38d75d33$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4b24683f38d75d33$var$load("8zqaJ").then(()=>parcelRequire('e9zUt'));

});

parcelRegister("7V7Uj", function(module, exports) {

let $5c43fd7bb4096718$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5c43fd7bb4096718$var$load("ferro").then(()=>parcelRequire('kIGWT'));

});

parcelRegister("c59Ge", function(module, exports) {

let $8cbd75f58af7b6b6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8cbd75f58af7b6b6$var$load("a4zXj").then(()=>parcelRequire('fKSJQ'));

});

parcelRegister("it08K", function(module, exports) {

let $d71b0b3e0b3b6968$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d71b0b3e0b3b6968$var$load("2MiXf").then(()=>parcelRequire('QK4KG'));

});

parcelRegister("lp44U", function(module, exports) {

let $f94f189eae5c5ee8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f94f189eae5c5ee8$var$load("d8BZd").then(()=>parcelRequire('hkUMb'));

});

parcelRegister("12dAt", function(module, exports) {

let $0c1084821917482d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0c1084821917482d$var$load("ab3iQ").then(()=>parcelRequire('9SWPt'));

});

parcelRegister("eeTpm", function(module, exports) {

let $a5dd5a65badd410c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a5dd5a65badd410c$var$load("iisOM").then(()=>parcelRequire('bwYcr'));

});

parcelRegister("aTVJ5", function(module, exports) {

let $7efbd1a6809cb38c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7efbd1a6809cb38c$var$load("lLjnd").then(()=>parcelRequire('dSRLc'));

});

parcelRegister("z0OvH", function(module, exports) {

let $0693e6945c53c163$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0693e6945c53c163$var$load("gudJB").then(()=>parcelRequire('1OlZ8'));

});

parcelRegister("kaEOd", function(module, exports) {

let $eaf465a09a2bede8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $eaf465a09a2bede8$var$load("cH4RB").then(()=>parcelRequire('6TFUK'));

});

parcelRegister("4fKGJ", function(module, exports) {

let $318cc771778df9b4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $318cc771778df9b4$var$load("efGyB").then(()=>parcelRequire('jBCIX'));

});

parcelRegister("iFSwW", function(module, exports) {

let $d9865ae649bad8bc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d9865ae649bad8bc$var$load("3CVU0").then(()=>parcelRequire('7J505'));

});

parcelRegister("fpelj", function(module, exports) {

let $b37450fcb13a2bac$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b37450fcb13a2bac$var$load("cXJM4").then(()=>parcelRequire('78mwQ'));

});

parcelRegister("iJNKu", function(module, exports) {

let $da43050e7cb6d130$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $da43050e7cb6d130$var$load("eeYre").then(()=>parcelRequire('4yT7A'));

});

parcelRegister("fTXEF", function(module, exports) {

let $b93a444f7d079838$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b93a444f7d079838$var$load("evu71").then(()=>parcelRequire('ef4Cc'));

});

parcelRegister("1ZMdf", function(module, exports) {

let $1740e2fcd7d4da89$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1740e2fcd7d4da89$var$load("i3OIF").then(()=>parcelRequire('l5j4R'));

});



parcelRegister("hhQWA", function(module, exports) {

$parcel$export(module.exports, "ExusUserSourceProvider", () => $69287237861b02c0$export$bcd5c65b586ee3c3);
$parcel$export(module.exports, "useUserSource", () => $69287237861b02c0$export$c6c0c1a2bac363f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $69287237861b02c0$var$ExusUserSourceContext = /*#__PURE__*/ (0, $eJOHy.createContext)({});
const $69287237861b02c0$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)($69287237861b02c0$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        },
        children: children
    });
const $69287237861b02c0$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $eJOHy.useContext)($69287237861b02c0$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $eJOHy.useState)([]);
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const abortController = (0, $eJOHy.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};

});


parcelRegister("lW3rH", function(module, exports) {

$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $06773110081a72c7$export$53eef0dcd9611650);
$parcel$export(module.exports, "preparedUsersLoadedEvent", () => $06773110081a72c7$export$185f4c3d9b7ef9bf);
$parcel$export(module.exports, "mountedWithPrefetchEvent", () => $06773110081a72c7$export$9cfb4251e50d7b91);
$parcel$export(module.exports, "filterUsersEvent", () => $06773110081a72c7$export$fbba77127d7cb173);
$parcel$export(module.exports, "requestUsersEvent", () => $06773110081a72c7$export$1762ed8845ff2d9b);
$parcel$export(module.exports, "successfulRequestUsersEvent", () => $06773110081a72c7$export$bfc020018aa738d0);
$parcel$export(module.exports, "failedRequestUsersEvent", () => $06773110081a72c7$export$738aca68b593db8e);
$parcel$export(module.exports, "failedUserResolversEvent", () => $06773110081a72c7$export$b9358131e14a4b0b);

var $63DI8 = parcelRequire("63DI8");

var $aXKmr = parcelRequire("aXKmr");
const $06773110081a72c7$var$packageName = "platform-pkg";
const $06773110081a72c7$var$packageVersion = "0.0.0-use.local";
const $06773110081a72c7$export$c0d84948cecf78d8 = ()=>({
        id: (0, $aXKmr.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $06773110081a72c7$export$53eef0dcd9611650 = (0, $63DI8.default)('fabric-elements');
const $06773110081a72c7$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $06773110081a72c7$var$packageName,
            packageVersion: $06773110081a72c7$var$packageVersion,
            ...attributes
        }
    });
const $06773110081a72c7$var$createDefaultSmartPickerAttributes = (props, state)=>{
    const { fieldId: fieldId, objectId: objectId, containerId: containerId, childObjectId: childObjectId, prefetch: prefetch, maxOptions: maxOptions, includeTeams: includeTeams, productKey: productKey, principalId: principalId, siteId: siteId, orgId: orgId, filterOptions: filterOptions } = props;
    const { sessionId: sessionId, query: query } = state;
    const maxNumberOfResults = maxOptions || 100;
    return {
        context: fieldId,
        childObjectId: childObjectId,
        containerId: containerId,
        hasFilterOptions: Boolean(filterOptions),
        includeTeams: includeTeams,
        maxNumberOfResults: maxNumberOfResults,
        objectId: objectId,
        prefetch: prefetch,
        principalId: principalId,
        productKey: productKey,
        queryLength: (query || '').length,
        siteId: siteId,
        orgId: orgId,
        sessionId: sessionId
    };
};
const $06773110081a72c7$var$createSmartUserPickerEvent = (action, actionSubect, attributes = {})=>({
        source: 'smart-user-picker',
        ...$06773110081a72c7$var$createEvent('operational', action, actionSubect, attributes)
    });
const $06773110081a72c7$export$185f4c3d9b7ef9bf = (props, state, attributes = {})=>$06773110081a72c7$var$createSmartUserPickerEvent('loaded', 'preparedUsers', {
        ...$06773110081a72c7$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $06773110081a72c7$export$9cfb4251e50d7b91 = (props, state, attributes = {})=>$06773110081a72c7$var$createSmartUserPickerEvent('mounted', 'prefetch', {
        ...$06773110081a72c7$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $06773110081a72c7$export$fbba77127d7cb173 = (props, state, attributes = {})=>$06773110081a72c7$var$createSmartUserPickerEvent('filtered', 'users', {
        ...$06773110081a72c7$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $06773110081a72c7$export$1762ed8845ff2d9b = (props, state, attributes = {})=>$06773110081a72c7$var$createSmartUserPickerEvent('requested', 'users', {
        ...$06773110081a72c7$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $06773110081a72c7$export$bfc020018aa738d0 = (props, state, attributes = {})=>$06773110081a72c7$var$createSmartUserPickerEvent('successful', 'usersRequest', {
        ...$06773110081a72c7$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $06773110081a72c7$export$738aca68b593db8e = (props, state, attributes = {})=>$06773110081a72c7$var$createSmartUserPickerEvent('failed', 'usersRequest', {
        ...$06773110081a72c7$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $06773110081a72c7$export$b9358131e14a4b0b = (props, state, attributes = {})=>$06773110081a72c7$var$createSmartUserPickerEvent('failed', 'userResolversRequest', {
        ...$06773110081a72c7$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });

});

parcelRegister("gqDgk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc7250254707029d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");
var $4nehu = parcelRequire("4nehu");

var $kCS7d = parcelRequire("kCS7d");
const $dc7250254707029d$var$EMPTY = {};
const $dc7250254707029d$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState($dc7250254707029d$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        let aborted = false;
        setMessages($dc7250254707029d$var$EMPTY);
        (0, $kCS7d.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $dc7250254707029d$var$MessagesIntlProvider = (props)=>{
    const { intl: intl, children: children } = props;
    const messages = $dc7250254707029d$var$useI18n(intl.locale);
    const mergedMessages = (0, $eJOHy.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $dc7250254707029d$export$2e2bcd8739ae039 = (0, $6YFG2.default)($dc7250254707029d$var$MessagesIntlProvider);

});
parcelRegister("kCS7d", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $aa6ac9deab9e5cb1$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $aa6ac9deab9e5cb1$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("iqNUH")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("9bfDq")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("iI6GL")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("9UNNj")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("cDPtQ")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("fZH59")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("lOB4T")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("1D3XY")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("eZr3y")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("4SMIk")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("84DK6")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("dqGjc")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("i1hoj")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("edo4p")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("544V3")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("23yRL")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("epF6c")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("9GNJD")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("G2Wz7")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("4ioJ8")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("hyAh3")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("7uGYi")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("6G1Fh")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("bDAZh")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("4TU7k")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("l8L4k")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("3oqP2")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("04K2u")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("kPc30")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $aa6ac9deab9e5cb1$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("9UNNj")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("iqNUH", function(module, exports) {

let $d6b15f8221ce74a3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d6b15f8221ce74a3$var$load("aqasE").then(()=>parcelRequire('8OVCi'));

});

parcelRegister("9bfDq", function(module, exports) {

let $6af144e49a71babc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6af144e49a71babc$var$load("e4J3D").then(()=>parcelRequire('ePtGh'));

});

parcelRegister("iI6GL", function(module, exports) {

let $d9f1864d0fa08fb2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d9f1864d0fa08fb2$var$load("buAY2").then(()=>parcelRequire('cHigA'));

});

parcelRegister("9UNNj", function(module, exports) {

let $737ff829ab817e32$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $737ff829ab817e32$var$load("99oeH").then(()=>parcelRequire('iq86X'));

});

parcelRegister("cDPtQ", function(module, exports) {

let $93410f7b0521453e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $93410f7b0521453e$var$load("TVRu3").then(()=>parcelRequire('5V2Ax'));

});

parcelRegister("fZH59", function(module, exports) {

let $ba4df8bc173bb634$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ba4df8bc173bb634$var$load("h440i").then(()=>parcelRequire('9zUfv'));

});

parcelRegister("lOB4T", function(module, exports) {

let $fe1b07612706860e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fe1b07612706860e$var$load("e9JlR").then(()=>parcelRequire('dLoxR'));

});

parcelRegister("1D3XY", function(module, exports) {

let $12fc829678a035f4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $12fc829678a035f4$var$load("7QRdk").then(()=>parcelRequire('d8E9E'));

});

parcelRegister("eZr3y", function(module, exports) {

let $ae9bc00624eaf0c8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ae9bc00624eaf0c8$var$load("6hzWp").then(()=>parcelRequire('5rvrP'));

});

parcelRegister("4SMIk", function(module, exports) {

let $38e1fe22975d8489$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $38e1fe22975d8489$var$load("2tAWX").then(()=>parcelRequire('7qV1u'));

});

parcelRegister("84DK6", function(module, exports) {

let $5e0d86829ccaffb7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5e0d86829ccaffb7$var$load("6kxyq").then(()=>parcelRequire('hm6CX'));

});

parcelRegister("dqGjc", function(module, exports) {

let $9c6e85b02ec2c241$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9c6e85b02ec2c241$var$load("dup4E").then(()=>parcelRequire('dMpyo'));

});

parcelRegister("i1hoj", function(module, exports) {

let $d1e5cf85bd63ea29$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d1e5cf85bd63ea29$var$load("1OtNW").then(()=>parcelRequire('gw0lK'));

});

parcelRegister("edo4p", function(module, exports) {

let $a594f36c13c2f959$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a594f36c13c2f959$var$load("kejQP").then(()=>parcelRequire('fzEg1'));

});

parcelRegister("544V3", function(module, exports) {

let $3b01245a731651ca$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3b01245a731651ca$var$load("kjDkc").then(()=>parcelRequire('cXDnZ'));

});

parcelRegister("23yRL", function(module, exports) {

let $17f6e8473ca89fbf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $17f6e8473ca89fbf$var$load("9xCSz").then(()=>parcelRequire('bUzjo'));

});

parcelRegister("epF6c", function(module, exports) {

let $a7e347e6bbd57a48$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a7e347e6bbd57a48$var$load("6dTUg").then(()=>parcelRequire('dUBgg'));

});

parcelRegister("9GNJD", function(module, exports) {

let $70de9da9030d924b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $70de9da9030d924b$var$load("hgqt4").then(()=>parcelRequire('kM4tJ'));

});

parcelRegister("G2Wz7", function(module, exports) {

let $07e634e58ec228c0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $07e634e58ec228c0$var$load("bF2d0").then(()=>parcelRequire('1HUbS'));

});

parcelRegister("4ioJ8", function(module, exports) {

let $320c062599d70c30$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $320c062599d70c30$var$load("hckyR").then(()=>parcelRequire('4TCaG'));

});

parcelRegister("hyAh3", function(module, exports) {

let $cc81bfe543eb73b6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cc81bfe543eb73b6$var$load("59jQg").then(()=>parcelRequire('6zvS7'));

});

parcelRegister("7uGYi", function(module, exports) {

let $574cab04bfb09a81$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $574cab04bfb09a81$var$load("9gfmP").then(()=>parcelRequire('cvmWA'));

});

parcelRegister("6G1Fh", function(module, exports) {

let $4dc7f4e7459827f7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4dc7f4e7459827f7$var$load("eM7U9").then(()=>parcelRequire('hRxTa'));

});

parcelRegister("bDAZh", function(module, exports) {

let $8790072698eb100a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8790072698eb100a$var$load("lsPXL").then(()=>parcelRequire('2fmBe'));

});

parcelRegister("4TU7k", function(module, exports) {

let $3917d429ce8f8ba5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3917d429ce8f8ba5$var$load("jxE7h").then(()=>parcelRequire('3ZRwD'));

});

parcelRegister("l8L4k", function(module, exports) {

let $f63edb3bc8fd2af5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f63edb3bc8fd2af5$var$load("hNXor").then(()=>parcelRequire('9sX2V'));

});

parcelRegister("3oqP2", function(module, exports) {

let $27886b4ca9f9fcf3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $27886b4ca9f9fcf3$var$load("hMLvD").then(()=>parcelRequire('cZBth'));

});

parcelRegister("04K2u", function(module, exports) {

let $00e4163ba553d548$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $00e4163ba553d548$var$load("jbmVc").then(()=>parcelRequire('dK9Y8'));

});

parcelRegister("kPc30", function(module, exports) {

let $f291ea77c665650f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f291ea77c665650f$var$load("8XdHq").then(()=>parcelRequire('wEvFi'));

});



parcelRegister("9bHxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d71a94e09fa10570$export$2e2bcd8739ae039);

var $bYxAL = parcelRequire("bYxAL");

var $eBoda = parcelRequire("eBoda");
const $d71a94e09fa10570$var$getUserRecommendations = (request, intl)=>{
    const url = (0, $eBoda.config).getRecommendationServiceUrl(request.baseUrl || '');
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            includeNonLicensedUsers: request.includeNonLicensedUsers,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                ...request.context?.productAttributes?.isEntitledConfluenceExternalCollaborator && {
                    productAccessPermissionIds: [
                        'write',
                        'external-collaborator-write'
                    ]
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
            statusCode: response.status
        });
    }).then((response)=>(0, $bYxAL.transformUsers)(response, intl));
};
var $d71a94e09fa10570$export$2e2bcd8739ae039 = $d71a94e09fa10570$var$getUserRecommendations;

});
parcelRegister("bYxAL", function(module, exports) {

$parcel$export(module.exports, "transformUsers", () => $a72c5618e0a54dc3$export$fb8c90bfc4beaa59);


var $gRkg3 = parcelRequire("gRkg3");

var $fmtxs = parcelRequire("fmtxs");
const $a72c5618e0a54dc3$var$getLozenzeProperties = (entity, intl)=>{
    if (entity.attributes?.workspaceMember) return intl.formatMessage((0, $gRkg3.messages).memberLozengeText);
    if (entity.attributes?.isConfluenceExternalCollaborator) {
        const lozengeTooltipMessage = entity.entityType === (0, $fmtxs.EntityType).GROUP ? (0, $gRkg3.messages).guestGroupLozengeTooltip : (0, $gRkg3.messages).guestUserLozengeTooltip;
        return {
            text: intl.formatMessage((0, $gRkg3.messages).guestLozengeText),
            tooltip: intl.formatMessage(lozengeTooltipMessage),
            appearance: 'default'
        };
    }
    return undefined;
};
const $a72c5618e0a54dc3$var$transformUser = (item, intl)=>{
    const type = item.entityType;
    if (type === (0, $fmtxs.EntityType).USER) {
        const user = item;
        const lozenge = $a72c5618e0a54dc3$var$getLozenzeProperties(user, intl);
        return {
            id: user.id,
            type: user.nonLicensedUser ? (0, $cb1feb1cecd2f1cc$export$50042ec1d2e00e63) : (0, $cb1feb1cecd2f1cc$export$8436e53e45ffe15b),
            avatarUrl: user.avatarUrl,
            name: user.name,
            email: user.email,
            title: user.title,
            lozenge: lozenge,
            tooltip: user.name,
            isExternal: Boolean(user.nonLicensedUser),
            sources: user.nonLicensedUser ? [
                'other-atlassian'
            ] : undefined
        };
    }
    if (type === (0, $fmtxs.EntityType).TEAM) {
        const team = item;
        return {
            id: team.id,
            type: (0, $cb1feb1cecd2f1cc$export$26bc40b960693765),
            description: team.description || '',
            name: team.displayName || '',
            memberCount: team.memberCount,
            members: team.members,
            includesYou: team.includesYou,
            avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
            tooltip: team.displayName,
            verified: team.verified
        };
    }
    if (type === (0, $fmtxs.EntityType).GROUP) {
        const group = item;
        const lozenge = $a72c5618e0a54dc3$var$getLozenzeProperties(group, intl);
        return {
            id: group.id,
            type: (0, $cb1feb1cecd2f1cc$export$d460f747b73abb10),
            name: group.name || '',
            lozenge: lozenge
        };
    }
    return;
};
const $a72c5618e0a54dc3$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$a72c5618e0a54dc3$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);

});
parcelRegister("gRkg3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $254da141f685e75f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $254da141f685e75f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});

parcelRegister("fmtxs", function(module, exports) {

$parcel$export(module.exports, "EntityType", () => $937bfbe287d4fdf9$export$8eda7e02f8f033b2);
var $937bfbe287d4fdf9$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});

});


parcelRegister("eBoda", function(module, exports) {

$parcel$export(module.exports, "config", () => $0b7f4a486828e01d$export$e506a1d27d1eaa20);
const $0b7f4a486828e01d$export$e506a1d27d1eaa20 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey, baseUrl = '') {
        return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (id, baseUrl, siteId) {
        return baseUrl ? `${baseUrl}/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}` : `/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}`;
    }
};

});


parcelRegister("dOjMC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7019a255436cfeb4$export$2e2bcd8739ae039);


var $eBoda = parcelRequire("eBoda");

var $b7YkJ = parcelRequire("b7YkJ");

var $3n286 = parcelRequire("3n286");

var $dM6Ac = parcelRequire("dM6Ac");
const $7019a255436cfeb4$var$getHydratedUsersFromProducts = (request)=>{
    const url = `${(0, $eBoda.config).getUsersServiceUrl(request.productKey, request.baseUrl)}`;
    let params = new URLSearchParams();
    request.accountIds.map((id)=>params.append('accountId', id));
    params.append('maxResults', '2000');
    return fetch(`${url}?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling users service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then(request.productKey === 'jira' ? $7019a255436cfeb4$var$transformJiraUsers : $7019a255436cfeb4$var$transformConfluenceUsers);
};
const $7019a255436cfeb4$var$transformJiraUsers = (userResponse)=>userResponse.values.map($7019a255436cfeb4$var$transformJiraUser).filter((user)=>!!user).map((user)=>user);
const $7019a255436cfeb4$var$transformJiraUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $cb1feb1cecd2f1cc$export$8436e53e45ffe15b),
        avatarUrl: item.avatarUrls ? item.avatarUrls['16x16'] : '',
        name: item.displayName,
        email: item.emailAddress
    };
};
const $7019a255436cfeb4$var$transformConfluenceUsers = (userResponse)=>userResponse.results.map($7019a255436cfeb4$var$transformConfluenceUser).filter((user)=>!!user).map((user)=>user);
const $7019a255436cfeb4$var$transformConfluenceUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $cb1feb1cecd2f1cc$export$8436e53e45ffe15b),
        avatarUrl: item.profilePicture ? item.profilePicture.path : '',
        name: item.publicName,
        email: item.email
    };
};
const $7019a255436cfeb4$var$sortResults = (options, sortIds)=>{
    const resultsMap = new Map(options.map((option)=>[
            option && option.id,
            option
        ]));
    return sortIds.map((option)=>{
        const user = resultsMap.get(option.id);
        if (user) return user;
        return {
            id: option.id,
            type: option.type,
            name: (0, $dM6Ac.UNKNOWN)
        };
    });
};
const $7019a255436cfeb4$var$isOptionData = (option)=>{
    return option.name !== undefined;
};
const $7019a255436cfeb4$var$hydrateTeamIds = async (baseUrl, values, siteId)=>{
    if (values.length === 0) return [];
    const legionPromises = values.map((value)=>(0, $3n286.default)({
            baseUrl: baseUrl,
            id: value.id,
            siteId: siteId
        }));
    return await Promise.all(legionPromises);
};
const $7019a255436cfeb4$var$hydrateAccountIds = async (baseUrl, productKey, values)=>{
    if (values.length === 0) return [];
    const accountIds = values.map((val)=>val.id);
    //if we are not jira or confluence then use PRS platform hydration
    return productKey === 'jira' || productKey === 'confluence' ? await $7019a255436cfeb4$var$getHydratedUsersFromProducts({
        baseUrl: baseUrl,
        productKey: productKey,
        accountIds: accountIds
    }) : await (0, $b7YkJ.default)(baseUrl, accountIds);
};
async function $7019a255436cfeb4$var$hydrateDefaultValues(baseUrl, value, productKey, siteId) {
    //return if no value
    if (!value || Array.isArray(value) && value.length === 0) return [];
    const values = Array.isArray(value) ? value : [
        value
    ];
    // return if all hydrated
    if (!values.some((val)=>!$7019a255436cfeb4$var$isOptionData(val))) return value;
    const [hydratedUsers, hydratedTeams] = await Promise.all([
        $7019a255436cfeb4$var$hydrateAccountIds(baseUrl, productKey, values.filter((val)=>!$7019a255436cfeb4$var$isOptionData(val) && val.type === 'user')),
        $7019a255436cfeb4$var$hydrateTeamIds(baseUrl, values.filter((val)=>!$7019a255436cfeb4$var$isOptionData(val) && val.type === 'team'), siteId)
    ]);
    const hydratedOptions = values.filter((val)=>$7019a255436cfeb4$var$isOptionData(val)).map((val)=>val).concat(hydratedUsers).concat(hydratedTeams);
    return $7019a255436cfeb4$var$sortResults(hydratedOptions, values);
}
var $7019a255436cfeb4$export$2e2bcd8739ae039 = $7019a255436cfeb4$var$hydrateDefaultValues;

});
parcelRegister("b7YkJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9aa4a992ac1b629$export$2e2bcd8739ae039);

var $dM6Ac = parcelRequire("dM6Ac");

var $kpHY7 = parcelRequire("kpHY7");

var $eBoda = parcelRequire("eBoda");
/**
 * @param  {string} accountIds ids to hydrate
 * @return GraphQL Query
 */ const $a9aa4a992ac1b629$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
      picture
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $a9aa4a992ac1b629$var$makeRequest = async (url, accountIds)=>{
    const query = $a9aa4a992ac1b629$var$buildUsersQuery(accountIds);
    return await (0, $kpHY7.graphqlQuery)(url, query);
};
const $a9aa4a992ac1b629$var$modifyResponse = (users)=>users.map(({ accountId: accountId, name: name, picture: picture })=>({
            avatarUrl: picture,
            id: accountId,
            name: name,
            type: 'user'
        }));
const $a9aa4a992ac1b629$var$getHydratedUsers = (baseUrl, userIds)=>{
    const url = (0, $eBoda.config).getGraphQLUrl(baseUrl);
    return new Promise((resolve)=>{
        $a9aa4a992ac1b629$var$makeRequest(url, userIds).then((data)=>{
            resolve($a9aa4a992ac1b629$var$modifyResponse(data.users));
        }).catch(()=>{
            // on network error, return original list with label 'Unknown'
            resolve(userIds.map((id)=>({
                    ...(0, $dM6Ac.UNKNOWN_USER),
                    id: id
                })));
        });
    });
};
var $a9aa4a992ac1b629$export$2e2bcd8739ae039 = $a9aa4a992ac1b629$var$getHydratedUsers;

});
parcelRegister("dM6Ac", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN", () => $ce2b495d94257caa$export$78244dbb77cfa6b6);
$parcel$export(module.exports, "UNKNOWN_USER", () => $ce2b495d94257caa$export$d1f5101c0939e3fe);
$parcel$export(module.exports, "UNKNOWN_TEAM", () => $ce2b495d94257caa$export$8144dcfc9025ca57);
const $ce2b495d94257caa$export$78244dbb77cfa6b6 = 'Unknown';
const $ce2b495d94257caa$export$d1f5101c0939e3fe = {
    id: $ce2b495d94257caa$export$78244dbb77cfa6b6,
    name: $ce2b495d94257caa$export$78244dbb77cfa6b6,
    type: 'user'
};
const $ce2b495d94257caa$export$8144dcfc9025ca57 = {
    id: $ce2b495d94257caa$export$78244dbb77cfa6b6,
    name: $ce2b495d94257caa$export$78244dbb77cfa6b6,
    type: 'team'
};

});

parcelRegister("kpHY7", function(module, exports) {

$parcel$export(module.exports, "graphqlQuery", () => $59a5c34aebbeb1de$export$74eb8d79ae3e02b5);
const $59a5c34aebbeb1de$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
function $59a5c34aebbeb1de$export$74eb8d79ae3e02b5(serviceUrl, query) {
    const headers = $59a5c34aebbeb1de$var$buildHeaders();
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}

});


parcelRegister("3n286", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e990283c3a126e6$export$2e2bcd8739ae039);

var $eBoda = parcelRequire("eBoda");

var $dM6Ac = parcelRequire("dM6Ac");
const $3e990283c3a126e6$var$transformTeam = (team, id)=>{
    return {
        id: id,
        name: team.displayName,
        type: 'team',
        avatarUrl: team.smallAvatarImageUrl
    };
};
const $3e990283c3a126e6$var$hydrateTeamFromLegion = (request)=>{
    const url = (0, $eBoda.config).getTeamsUrl(request.id, request.baseUrl, request.siteId);
    return fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>{
        return $3e990283c3a126e6$var$transformTeam(response, request.id);
    }).catch(()=>({
            ...(0, $dM6Ac.UNKNOWN_TEAM),
            id: request.id
        }));
};
var $3e990283c3a126e6$export$2e2bcd8739ae039 = $3e990283c3a126e6$var$hydrateTeamFromLegion;

});


parcelRegister("jnhBq", function(module, exports) {

$parcel$export(module.exports, "smartUserPickerRenderedUfoExperience", () => $e69b57eda9470640$export$df77da4c0210f1c1);
$parcel$export(module.exports, "smartUserPickerOptionsShownUfoExperience", () => $e69b57eda9470640$export$a0e7cca3ab9586eb);
$parcel$export(module.exports, "useUFOConcurrentExperience", () => $e69b57eda9470640$export$e5e0512991825310);
$parcel$export(module.exports, "UfoErrorBoundary", () => $e69b57eda9470640$export$5ef1c2550074a375);

var $eJOHy = parcelRequire("eJOHy");

var $5tvS9 = parcelRequire("5tvS9");
var $dBtrr = parcelRequire("dBtrr");
var $1i6NW = parcelRequire("1i6NW");
const $e69b57eda9470640$var$COMPONENT_NAME = 'smart-user-picker';
const $e69b57eda9470640$export$df77da4c0210f1c1 = new (0, $5tvS9.ConcurrentExperience)('smart-user-picker-rendered', {
    platform: {
        component: $e69b57eda9470640$var$COMPONENT_NAME
    },
    type: (0, $dBtrr.ExperienceTypes).Load,
    performanceType: (0, $dBtrr.ExperiencePerformanceTypes).PageSegmentLoad
});
const $e69b57eda9470640$export$a0e7cca3ab9586eb = new (0, $5tvS9.ConcurrentExperience)('smart-user-picker-options-shown', {
    platform: {
        component: $e69b57eda9470640$var$COMPONENT_NAME
    },
    type: (0, $dBtrr.ExperienceTypes).Operation,
    performanceType: (0, $dBtrr.ExperiencePerformanceTypes).InlineResult
});
const $e69b57eda9470640$export$e5e0512991825310 = (experience, id)=>{
    const experienceForId = experience.getInstance(id);
    // Equivalent to componentWillMount - replace with @atlaskit/ufo's
    // useUFOComponentExperience when it supports ConcurrentExperience.
    (0, $eJOHy.useState)(()=>{
        experienceForId.start();
    });
    // Replace with @atlaskit/ufo's <ExperienceSuccess> when it supports ConcurrentExperience
    (0, $eJOHy.useEffect)(()=>{
        if (experienceForId.state !== (0, $1i6NW.UFOExperienceState)['FAILED']) experienceForId.success();
        return ()=>{
            if ([
                (0, $1i6NW.UFOExperienceState)['STARTED'],
                (0, $1i6NW.UFOExperienceState)['IN_PROGRESS']
            ].includes(experienceForId.state)) experienceForId.abort();
        };
    // We only want this useEffect to run once after component mount, so no deps are needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
class $e69b57eda9470640$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch() {
        $e69b57eda9470640$export$df77da4c0210f1c1.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});



parcelRegister("8qxeT", function(module, exports) {
module.exports = new URL("team-two-people.dd270d21.svg", import.meta.url).toString();

});

parcelRegister("aUMMA", function(module, exports) {

$parcel$export(module.exports, "defaultSelectStyles", () => $a277234cf6edc8cd$export$b12192ea1a215e5f);
$parcel$export(module.exports, "indicatorFixSelectStyles", () => $a277234cf6edc8cd$export$eca30945eaf474dd);

var $dPMMf = parcelRequire("dPMMf");
const $a277234cf6edc8cd$export$b12192ea1a215e5f = {
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $dPMMf.layers).modal
        }),
    menu: (base)=>({
            ...base,
            zIndex: (0, $dPMMf.layers).modal
        })
};
const $a277234cf6edc8cd$var$inputIconPaddingLeft = "var(--ds-space-025, 2px)";
const $a277234cf6edc8cd$var$inputIconPaddingRight = "var(--ds-space-050, 4px)";
const $a277234cf6edc8cd$export$eca30945eaf474dd = {
    // need to apply same padding to both loadingIndicator and clearIndicator - not to have input query jumping between lines e.g. in multi-select
    loadingIndicator: (base)=>({
            ...base,
            paddingLeft: $a277234cf6edc8cd$var$inputIconPaddingLeft,
            paddingRight: $a277234cf6edc8cd$var$inputIconPaddingRight
        }),
    clearIndicator: (base)=>({
            ...base,
            paddingLeft: $a277234cf6edc8cd$var$inputIconPaddingLeft,
            paddingRight: $a277234cf6edc8cd$var$inputIconPaddingRight
        })
};
const $a277234cf6edc8cd$export$a9f371909ef7b4d6 = {
    container: (base)=>({
            ...base,
            border: `${"var(--ds-space-025, 2px)"} solid ${"var(--ds-border-danger, #E2483D)"}`,
            borderRadius: "var(--ds-space-050, 4px)"
        })
};

});

const $3ddfbe531e9e128a$export$53782b65600ab96d = '__UNASSIGNED_TEAM__';
const $3ddfbe531e9e128a$export$3f4352abc4ee4b48 = '__CREATE_TEAM__';

parcelRegister("aeZ5Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $8775808672087359$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8775808672087359$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "issue-field-team.error-title",
        "defaultMessage": "We couldn't set the team value"
    },
    errorMessage: {
        "id": "issue-field-team.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    teamErrorViewTooltip: {
        "id": "issue-field-team.team-error-view-tooltip",
        "defaultMessage": "This team may have been deleted, or you do not have access"
    },
    teamErrorViewText: {
        "id": "issue-field-team.team-error-view-text",
        "defaultMessage": "Not available"
    },
    placeholderTeamEditSelector: {
        "id": "issue-field-team.placeholder-team-edit-selector",
        "defaultMessage": "Choose a team"
    },
    defaultNoValueText: {
        "id": "issue-field-team.default-no-value-text",
        "defaultMessage": "None"
    },
    noValueTextExperiment: {
        "id": "issue-field-team.no-value-text-experiment",
        "defaultMessage": "Add team"
    },
    createTeamButtonText: {
        "id": "issue-field-team.create-team-button-text",
        "defaultMessage": "Create a team"
    },
    emptyStateDescription: {
        "id": "issue-field-team.empty-state-description",
        "defaultMessage": "Create a team to assign work across Jira and track it on your team\u2019s profile"
    },
    noOptionsMessage: {
        "id": "issue-field-team.no-options-message",
        "defaultMessage": "No options"
    }
});

});

parcelRegister("eQtse", function(module, exports) {

$parcel$export(module.exports, "CreateTeamOption", () => $71956e47e75e50a5$export$8920795307e75f7e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lv5Uf = parcelRequire("lv5Uf");
var $dhRXV = parcelRequire("dhRXV");
var $9M9zY = parcelRequire("9M9zY");

var $kfJF8 = parcelRequire("kfJF8");

var $i140O = parcelRequire("i140O");

var $dWg5G = parcelRequire("dWg5G");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $7jTnu = parcelRequire("7jTnu");


var $aeZ5Y = parcelRequire("aeZ5Y");

var $aj4ju = parcelRequire("aj4ju");
const $71956e47e75e50a5$var$styles = {
    iconWrapper: "_1e0c1txw _4cvr1h6o _1bah1h6o _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7",
    optionWrapper: "_80omtlke"
};
function $71956e47e75e50a5$export$8920795307e75f7e({ onClick: onClick, isFocused: isFocused }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formattedCreateTeamText = formatMessage((0, $aeZ5Y.default).createTeamButtonText);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const handleCreateTeamOptionClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createTeamInline', {
            teamsFieldEmptyState: false
        });
        onClick();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const { canCreateTeams: canCreateTeams } = (0, $aj4ju.useTeamPermissions)();
    if ((0, $7jTnu.fg)('twcj-37_update_team_icons_and_avatars_in_jira')) return canCreateTeams ? // eslint-disable-next-line jira/restricted/react-suspense
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lv5Uf.default), {
        inline: "space.200",
        block: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($71956e47e75e50a5$var$CreateButtonBorder, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($71956e47e75e50a5$var$Container, {
        onClick: handleCreateTeamOptionClick,
        isFocused: isFocused,
        "data-testid": "issue-field-team.ui.edit-mode.create-team-option.create-team-inline-option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($71956e47e75e50a5$var$OptionDataWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        xcss: $71956e47e75e50a5$var$styles.optionWrapper,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $71956e47e75e50a5$var$styles.iconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i140O))), {
        label: "",
        spacing: "spacious"
    })), formattedCreateTeamText))))) : null;
    return canCreateTeams ? // eslint-disable-next-line jira/restricted/react-suspense
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lv5Uf.default), {
        inline: "space.200",
        block: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($71956e47e75e50a5$var$CreateButtonBorder, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($71956e47e75e50a5$var$Container, {
        onClick: handleCreateTeamOptionClick,
        isFocused: isFocused,
        "data-testid": "issue-field-team.ui.edit-mode.create-team-option.create-team-inline-option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($71956e47e75e50a5$var$OptionDataWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kfJF8.default), {
        isSelected: false,
        data: {
            id: (0, $3ddfbe531e9e128a$export$3f4352abc4ee4b48),
            name: formattedCreateTeamText,
            type: 'custom',
            avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($dWg5G)))
        }
    }))))) : null;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $71956e47e75e50a5$var$CreateButtonBorder = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dozgxb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $71956e47e75e50a5$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkv77o _1bsb1osq _4t3i1osq _irr3166n _1dbzu4to",
            __cmplp.isFocused ? "_bfhk166n" : "_bfhk18uv",
            __cmplp.isFocused ? "_16qsu4to" : "_16qsglyw",
            __cmplp.className
        ])
    });
}); // Matching spacing of other options
const $71956e47e75e50a5$var$OptionDataWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lv5Uf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7c82d2ced030667$export$2e2bcd8739ae039);
/* bleed.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
// NOTE: This maintains a full map of 10 styles as Bleed is a bit of a semantic outlier
const $b7c82d2ced030667$var$styles = {
    root: "_vchhusvi",
    'inline.space.025': "_195g4pxn",
    'inline.space.050': "_195ggp71",
    'inline.space.100': "_195gtdkl",
    'inline.space.150': "_195gkqjj",
    'inline.space.200': "_195g1e8l",
    'block.space.025': "_1mou4pxn",
    'block.space.050': "_1mougp71",
    'block.space.100': "_1moutdkl",
    'block.space.150': "_1moukqjj",
    'block.space.200': "_1mou1e8l"
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $b7c82d2ced030667$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $b7c82d2ced030667$var$styles.root,
            all && $b7c82d2ced030667$var$styles[`inline.${all}`],
            inline && $b7c82d2ced030667$var$styles[`inline.${inline}`],
            all && $b7c82d2ced030667$var$styles[`block.${all}`],
            block && $b7c82d2ced030667$var$styles[`block.${block}`],
            xcss
        ]),
        "data-testid": testId,
        children: children
    });
});
$b7c82d2ced030667$var$Bleed.displayName = 'Bleed';
var $b7c82d2ced030667$export$2e2bcd8739ae039 = $b7c82d2ced030667$var$Bleed;

});

parcelRegister("dWg5G", function(module, exports) {
module.exports = new URL("team-two-people-with-plus.5493a468.svg", import.meta.url).toString();

});

parcelRegister("aj4ju", function(module, exports) {

$parcel$export(module.exports, "useTeamPermissions", () => $03d8176dd2b72f29$export$8cbbe0c59dd60253);

var $g9Vr6 = parcelRequire("g9Vr6");

var $lvKO5 = parcelRequire("lvKO5");

var $d0bCq = parcelRequire("d0bCq");
const $03d8176dd2b72f29$export$8cbbe0c59dd60253 = ()=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { cloudId: cloudId } = (0, $lvKO5.useTenantContext)();
    const { permissions: permissions } = (0, $d0bCq.useTeamsPermissionsService)({
        orgId: orgId,
        cloudId: cloudId
    }, {
        enabled: false
    });
    return permissions;
};

});


parcelRegister("hVanD", function(module, exports) {

$parcel$export(module.exports, "TeamPickerEmptyState", () => $9cad0eefc6b06595$export$f53d61da818dafb4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dKpTa = parcelRequire("dKpTa");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $jsfEw = parcelRequire("jsfEw");

var $kDaaB = parcelRequire("kDaaB");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $aeZ5Y = parcelRequire("aeZ5Y");

var $aj4ju = parcelRequire("aj4ju");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9cad0eefc6b06595$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1fxt _otyr1ejb _19pkze3t",
            __cmplp.className
        ])
    });
});
const $9cad0eefc6b06595$var$imageWrapperStyles = (0, $5Wv5g.xcss)({
    marginBottom: 'space.200'
});
const $9cad0eefc6b06595$export$f53d61da818dafb4 = ({ onActionClick: onActionClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { canCreateTeams: canCreateTeams } = (0, $aj4ju.useTeamPermissions)();
    const handleCreateTeamOptionClick = ()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createTeamInline', {
            teamsFieldEmptyState: true
        });
        onActionClick();
    };
    return canCreateTeams ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        paddingBlock: "space.200",
        testId: "issue-field-team.ui.edit-mode.team-picker-empty-state.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $9cad0eefc6b06595$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jsfEw.default), {
        alt: "",
        width: 130,
        height: 122
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9cad0eefc6b06595$var$Description, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $aeZ5Y.default).emptyStateDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        appearance: "primary",
        onClick: handleCreateTeamOptionClick,
        testId: "issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button",
        interactionName: "auto-generated.issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $aeZ5Y.default).createTeamButtonText))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $aeZ5Y.default).noOptionsMessage);
};

});
parcelRegister("jsfEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d56532f96b609464$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $8QYCl = parcelRequire("8QYCl");
const $d56532f96b609464$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8QYCl)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8QYCl))
});
var $d56532f96b609464$export$2e2bcd8739ae039 = $d56532f96b609464$var$Illustration;
// for advanced use only
const $d56532f96b609464$export$a179c88182cb9d56 = [
    0,
    0,
    130,
    122
];

});
parcelRegister("8QYCl", function(module, exports) {
module.exports = new URL("people-and-tasks.dedc2456.svg", import.meta.url).toString();

});




parcelRegister("dId76", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38883ade94e7992$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a38883ade94e7992$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "software-board-create.modal.form.source-value-picker.team-picker.placeholder",
        "defaultMessage": "Select"
    }
});

});




parcelRegister("6HOlT", function(module, exports) {

$parcel$export(module.exports, "validateFormData", () => $20ee2345600a4a64$export$cc0ea38c9ab56613);

var $2pys5 = parcelRequire("2pys5");
const $20ee2345600a4a64$var$validateBoardName = (value)=>{
    return !value || value.trim().length === 0 ? (0, $2pys5.VALIDATION_ERROR_EMPTY) : undefined;
};
const $20ee2345600a4a64$var$validateSourceType = (value)=>{
    return value === undefined ? (0, $2pys5.VALIDATION_ERROR_EMPTY) : undefined;
};
const $20ee2345600a4a64$var$validateSourceValue = (value)=>{
    if (Array.isArray(value) && !value.length || !Array.isArray(value) && !value) return 0, $2pys5.VALIDATION_ERROR_EMPTY;
};
const $20ee2345600a4a64$export$cc0ea38c9ab56613 = (data)=>({
        boardName: $20ee2345600a4a64$var$validateBoardName(data.boardName),
        sourceType: $20ee2345600a4a64$var$validateSourceType(data.sourceType),
        sourceValue: data.sourceType ? $20ee2345600a4a64$var$validateSourceValue(data.sourceValue) : undefined
    });

});


parcelRegister("62xU6", function(module, exports) {

$parcel$export(module.exports, "default", () => $daefe98e1819e72e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $daefe98e1819e72e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    // Delete createBoardDialogLabel when cleaning up nav4_simplified_board_create_beta
    createBoardDialogLabel: {
        "id": "software-board-create.modal.create-board-dialog-label",
        "defaultMessage": "Create board dialog, {boardDescription}"
    },
    loadingLabel: {
        "id": "software-board-create.modal.loading-label",
        "defaultMessage": "Loading"
    }
});

});



parcelRegister("8ySo1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7831b220ce74fe3a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7831b220ce74fe3a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createBoardLabel: {
        "id": "software-board-create.flyout-menu.flyout-menu-content.dropdown-item-container.create-board-label",
        "defaultMessage": "Create a {boardType} board"
    }
});

});




parcelRegister("dFmiu", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuContentFallback", () => $be78f9bf5dc2ec0e$export$aad294dc6c6989e8);

var $eJOHy = parcelRequire("eJOHy");

var $f9Ihw = parcelRequire("f9Ihw");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $lRq8t = parcelRequire("lRq8t");

var $9KojZ = parcelRequire("9KojZ");

var $PtTbh = parcelRequire("PtTbh");
const $be78f9bf5dc2ec0e$export$aad294dc6c6989e8 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9KojZ.FlyoutContentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        paddingBlockStart: "space.100",
        xcss: $be78f9bf5dc2ec0e$var$skeletonItemContainerStyles,
        role: "menuitem",
        "aria-label": formatMessage((0, $PtTbh.default).loadingLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), {
        hasIcon: true,
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        paddingBlockStart: "space.100",
        xcss: $be78f9bf5dc2ec0e$var$skeletonItemContainerStyles,
        role: "menuitem",
        "aria-label": formatMessage((0, $PtTbh.default).loadingLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), {
        hasIcon: true,
        width: "100%"
    })));
};
const $be78f9bf5dc2ec0e$var$skeletonItemContainerStyles = (0, $5Wv5g.xcss)({
    height: '56px'
});

});
parcelRegister("PtTbh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e69595c09d795e3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8e69595c09d795e3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    loadingLabel: {
        "id": "software-board-create.flyout-menu.flyout-menu-content.flyout-menu-content-fallback.loading-label",
        "defaultMessage": "Loading"
    }
});

});





parcelRegister("c9EyR", function(module, exports) {

$parcel$export(module.exports, "isCompanyManagedSoftwareProject", () => $b41834aef3246560$export$531964df831b0883);

var $ln6Iy = parcelRequire("ln6Iy");
const $b41834aef3246560$export$531964df831b0883 = (projectStyle, projectType)=>projectStyle === 'COMPANY_MANAGED_PROJECT' && projectType === (0, $ln6Iy.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT);

});

parcelRegister("iBeto", function(module, exports) {

$parcel$export(module.exports, "default", () => $be8366a143aa7534$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $be8366a143aa7534$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createBoard: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-common.project-actions.create-board",
        "defaultMessage": "Create board"
    }
});

});


const $62baa2e6fd157602$export$b8b9d90f9e5bd72b = '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-jsw-project-menu';
const $62baa2e6fd157602$export$d57b6b390e78d90f = 'jira-cosmos';
const $62baa2e6fd157602$export$420a3ee5deb615a9 = 25;
const $62baa2e6fd157602$export$99240e55cc48c47e = 5;

parcelRegister("cMFhN", function(module, exports) {

$parcel$export(module.exports, "asyncActionsOnHover", () => $9063ae307ee7ca5e$export$4e4f732777dcde68);

var $aviZk = parcelRequire("aviZk");

var $4BK1O = parcelRequire("4BK1O");

var $2aGAf = parcelRequire("2aGAf");

const $9063ae307ee7ca5e$export$4e4f732777dcde68 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("7SQGd")).then(({ ActionsOnHoverQuery: ActionsOnHoverQuery })=>ActionsOnHoverQuery), {
        moduleId: "3853243e",
        moduleName: "ActionsOnHoverQuery",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectId: projectId })=>({
            queries: {
                projects: {
                    parameters: $aviZk.default,
                    variables: {
                        cloudId: cloudId,
                        projectId: projectId
                    }
                }
            }
        })
});

});
parcelRegister("aviZk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fc23416c12abea5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6729ed9445dc3b69da8c03759de9ef94>>
 * @relayHash ee368cb08817c3cbc908ad8e6c9607e1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9a24768373875dd0840974520367c6e7462893ac63a5588b8bb10e67b3b7e596

var $eSxxM = parcelRequire("eSxxM");
const $2fc23416c12abea5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ActionsOnHoverQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectActions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ActionsOnHoverQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        }
                                    ]
                                },
                                {
                                    "alias": "projectKey",
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9a24768373875dd0840974520367c6e7462893ac63a5588b8bb10e67b3b7e596",
            "metadata": {},
            "name": "ActionsOnHoverQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $eSxxM.default)
            }
        }
    };
}();
$2fc23416c12abea5$var$node.hash = "f0643500ca76c97a30caef500db5e047";
var $2fc23416c12abea5$export$2e2bcd8739ae039 = $2fc23416c12abea5$var$node;

});

parcelRegister("7SQGd", function(module, exports) {

let $5bd670b46c9e270f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5bd670b46c9e270f$var$load("lnZcA").then(()=>parcelRequire('2jfvo'));

});



parcelRegister("gT0jg", function(module, exports) {

$parcel$export(module.exports, "JswNonExpandableProject", () => $9e988fcc2af9c12b$export$cbea0eaf70f0156d);

var $1vWHP = parcelRequire("1vWHP");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7IJ7W = parcelRequire("7IJ7W");

var $2Of18 = parcelRequire("2Of18");

var $dN2O6 = parcelRequire("dN2O6");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $7fbRv = parcelRequire("7fbRv");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $jd93d = parcelRequire("jd93d");

var $1NfYk = parcelRequire("1NfYk");
const $9e988fcc2af9c12b$export$cbea0eaf70f0156d = ({ projectData: projectData, spotlight: spotlight, menuItemAnchorRef: menuItemAnchorRef })=>{
    const { sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent } = (0, $dN2O6.useProjectsAnalyticsL1)();
    const project = (0, $j4oe4.useFragment)((0, $1vWHP.default), projectData);
    const routerLinkConfig = (0, $eJOHy.useMemo)(()=>({
            to: project.defaultNavigationItem?.url ?? `/browse/${project.projectKey}`,
            prefetch: 'hover'
        }), [
        project.defaultNavigationItem?.url,
        project.projectKey
    ]);
    const { projectId: projectId, projectKey: projectKey, isFavourite: isFavourite, name: name, avatar: avatar } = project;
    const { state: state, draggableAnchorRef: draggableAnchorRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, dragPreview: dragPreview, hasDragIndicator: hasDragIndicator } = (0, $1NfYk.useProjectMenuItemDragAndDrop)({
        projectId: projectId,
        projectKey: projectKey,
        isFavourite: isFavourite,
        name: name,
        avatar: avatar,
        isEnabled: !!isFavourite && (0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Of18.OnboardingSpotlightMaybe), {
        key: project.projectKey,
        spotlight: spotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        ref: (0, $jd93d.mergeRefs)(menuItemAnchorRef || null, draggableAnchorRef || null),
        visualContentRef: dropTargetRef,
        dropIndicator: dropIndicator,
        isDragging: state.type === 'dragging',
        hasDragIndicator: hasDragIndicator,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7IJ7W.ContainerAvatar), {
            src: project.avatar.large || ''
        }),
        href: routerLinkConfig,
        menuId: (0, $h4Bzb.ENTITY_ID).PROJECT(project.projectKey),
        onClick: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useCallback)(()=>{
            sendProjectMenuItemAnalyticsEvent({
                starred: project.isFavourite ?? false,
                recent: !project.isFavourite,
                projectId: project.projectId,
                projectType: project.projectType
            });
        }, [
            project.isFavourite,
            project.projectId,
            project.projectType,
            sendProjectMenuItemAnalyticsEvent
        ]) : ()=>{
            sendProjectMenuItemAnalyticsEvent({
                starred: project.isFavourite ?? false,
                recent: !project.isFavourite,
                projectId: project.projectId,
                projectType: project.projectType
            });
        },
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fbRv.ProjectActions), {
            projectFragment: project
        })
    }, project.name), dragPreview);
};

});
parcelRegister("1vWHP", function(module, exports) {

$parcel$export(module.exports, "default", () => $af7e71c0db1dc015$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec9c647dc6ce90744c0c4748168b513d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $af7e71c0db1dc015$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JswNonExpandableProject",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW",
                        "path": "avatar.large"
                    }
                ]
            },
            "action": "THROW",
            "path": "avatar"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraNavigationItem",
                    "abstractKey": "__isJiraNavigationItem"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ProjectActions"
        }
    ],
    "type": "JiraProject"
};
$af7e71c0db1dc015$var$node.hash = "1c2cfe3c81902a2ea33e2fc3b9f6c4bb";
var $af7e71c0db1dc015$export$2e2bcd8739ae039 = $af7e71c0db1dc015$var$node;

});



parcelRegister("1gN9e", function(module, exports) {

$parcel$export(module.exports, "ProjectRestoreContext", () => $d1c79f8e50a8c788$export$bc50e4f0d149dd7c);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $d1c79f8e50a8c788$export$bc50e4f0d149dd7c = /*#__PURE__*/ (0, $eJOHy.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));

});

parcelRegister("kOdRG", function(module, exports) {

$parcel$export(module.exports, "ContentWithDragAndDrop", () => $bb87ea96315e5006$export$97d3213e96ec57ec);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $f2JN3 = parcelRequire("f2JN3");

var $fAZgY = parcelRequire("fAZgY");

var $fpJnI = parcelRequire("fpJnI");
// The idea of this component is to provide a focus restoration context for the project menu items.
// The context will be read deep down the tree where the menuItem which supports drag-and-drop is rendered.
function $bb87ea96315e5006$var$ContentWithDragAndDropEnabled({ children: children }) {
    const shouldRestoreFocusRef = (0, $eJOHy.useRef)(false);
    const clearRestoreFocus = (0, $fAZgY.useCallbackWithCondition)(()=>{
        shouldRestoreFocusRef.current = false;
    }, [], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const contextValue = (0, $fAZgY.useMemoWithCondition)(()=>({
            shouldRestoreFocusRef: shouldRestoreFocusRef,
            clearRestoreFocus: clearRestoreFocus
        }), [
        clearRestoreFocus
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fpJnI.FocusRestorationContext).Provider, {
        value: contextValue
    }, children);
}
const $bb87ea96315e5006$export$97d3213e96ec57ec = (0, $f2JN3.componentWithCondition)(()=>(0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false), $bb87ea96315e5006$var$ContentWithDragAndDropEnabled, ({ children: children })=>children);

});


parcelRegister("lnXOC", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsEmptyContent", () => $70a70150fb5a67f9$export$7a7cd6cdc84cf8eb);
/* Nav4ProjectsEmptyContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $h8epd = parcelRequire("h8epd");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $eLY13 = parcelRequire("eLY13");

var $fGy7n = parcelRequire("fGy7n");
function $70a70150fb5a67f9$export$7a7cd6cdc84cf8eb() {
    const emptyProjectsMessageGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $fGy7n.default).emptyProjectsMessageGalaxia : (0, $fGy7n.default).emptyProjectsMessage;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ $eJOHy.createElement((0, $eLY13.EmptyContentMenuItem), null, /*#__PURE__*/ $eJOHy.createElement((0, $h8epd.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage(emptyProjectsMessageGalaxia)));
}

});
parcelRegister("fGy7n", function(module, exports) {

$parcel$export(module.exports, "default", () => $29a1b7d01b16a112$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $29a1b7d01b16a112$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyProjectsMessage: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.empty-content.empty-projects-message",
        "defaultMessage": "Once you visit or create projects, they'll show up here."
    },
    emptyProjectsMessageGalaxia: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.empty-content.empty-projects-message-galaxia",
        "defaultMessage": "Once you visit or create spaces, they'll show up here."
    }
});

});


parcelRegister("2VWNN", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsSections", () => $86a5717ed87aea81$export$f0f2073bdea7c56e);

var $eJOHy = parcelRequire("eJOHy");

var $286cZ = parcelRequire("286cZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXQx2 = parcelRequire("fXQx2");

var $aJgGb = parcelRequire("aJgGb");

var $68QJy = parcelRequire("68QJy");
const $86a5717ed87aea81$var$Nav4ProjectsSectionsInternal = ({ favoriteItems: favoriteItems, recentItems: recentItems, mostRecentProjectItem: mostRecentProjectItem })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aJgGb.RenderStarredSection), {
        favoriteItems: favoriteItems
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fXQx2.RenderRecentSection), {
        recentItems: recentItems
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $68QJy.RenderMostRecentProjectSection), {
        projectItem: mostRecentProjectItem
    }));
const $86a5717ed87aea81$export$f0f2073bdea7c56e = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp_magma_jsm-perf-improvement-batch-1'), $86a5717ed87aea81$var$Nav4ProjectsSectionsInternal);

});
parcelRegister("fXQx2", function(module, exports) {

$parcel$export(module.exports, "RenderRecentSection", () => $b5bcadbb40afeb96$export$d2b3549b269002a1);

var $eJOHy = parcelRequire("eJOHy");

var $2y3Ci = parcelRequire("2y3Ci");
var $ilbtc = parcelRequire("ilbtc");
var $1swHh = parcelRequire("1swHh");
var $jLuq7 = parcelRequire("jLuq7");

var $lRq8t = parcelRequire("lRq8t");

var $lHnXI = parcelRequire("lHnXI");


var $42Jy1 = parcelRequire("42Jy1");
function $b5bcadbb40afeb96$export$d2b3549b269002a1({ recentItems: recentItems }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { sendProjectMenuContentSectionAnalyticsEvent: sendProjectMenuContentSectionAnalyticsEvent } = (0, $lHnXI.useProjectsAnalyticsL2)();
    (0, $eJOHy.useEffect)(()=>{
        sendProjectMenuContentSectionAnalyticsEvent({
            projectSection: (0, $a2a58ce6d289b621$export$66f42658510ce4ab)
        });
    }, [
        sendProjectMenuContentSectionAnalyticsEvent
    ]);
    return recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.recent-section.recent-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLuq7.MenuSectionHeading), null, formatMessage((0, $42Jy1.default).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, recentItems.list)));
}

});
const $a2a58ce6d289b621$export$3086f5b2b9faf5ae = 'starred';
const $a2a58ce6d289b621$export$66f42658510ce4ab = 'recent';

parcelRegister("42Jy1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebcbff926ef04adf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ebcbff926ef04adf$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.starred",
        "defaultMessage": "Starred"
    },
    viewAllStarred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.view-all-starred",
        "defaultMessage": "View all starred"
    }
});

});


parcelRegister("aJgGb", function(module, exports) {

$parcel$export(module.exports, "RenderStarredSection", () => $b6c933b8e36d38d1$export$e2cc6b3e240d5148);

var $eJOHy = parcelRequire("eJOHy");

var $2y3Ci = parcelRequire("2y3Ci");
var $ilbtc = parcelRequire("ilbtc");
var $1swHh = parcelRequire("1swHh");
var $jLuq7 = parcelRequire("jLuq7");

var $lRq8t = parcelRequire("lRq8t");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $f2JN3 = parcelRequire("f2JN3");

var $epTsa = parcelRequire("epTsa");

var $98PI1 = parcelRequire("98PI1");

var $lHnXI = parcelRequire("lHnXI");


var $42Jy1 = parcelRequire("42Jy1");
const $b6c933b8e36d38d1$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
const $b6c933b8e36d38d1$export$e2cc6b3e240d5148 = (0, $f2JN3.componentWithCondition)(()=>(0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false), $b6c933b8e36d38d1$var$StarredSectionWithFocusRestoration, $b6c933b8e36d38d1$var$StarredSection);
function $b6c933b8e36d38d1$var$StarredSectionWithFocusRestoration({ favoriteItems: favoriteItems }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { sendProjectMenuContentSectionAnalyticsEvent: sendProjectMenuContentSectionAnalyticsEvent } = (0, $lHnXI.useProjectsAnalyticsL2)();
    (0, $eJOHy.useEffect)(()=>{
        sendProjectMenuContentSectionAnalyticsEvent({
            projectSection: (0, $a2a58ce6d289b621$export$3086f5b2b9faf5ae)
        });
    }, [
        sendProjectMenuContentSectionAnalyticsEvent
    ]);
    return favoriteItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $98PI1.ProjectsDroppableGroupIndicator), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.starred-section.starred-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLuq7.MenuSectionHeading), null, formatMessage((0, $42Jy1.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, favoriteItems.list))), favoriteItems.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: $b6c933b8e36d38d1$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $h4Bzb.MENU_ID_PROJECTS_VIEW_ALL_STARRED)
    }, formatMessage((0, $42Jy1.default).viewAllStarred)));
}
function $b6c933b8e36d38d1$var$StarredSection({ favoriteItems: favoriteItems }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { sendProjectMenuContentSectionAnalyticsEvent: sendProjectMenuContentSectionAnalyticsEvent } = (0, $lHnXI.useProjectsAnalyticsL2)();
    (0, $eJOHy.useEffect)(()=>{
        sendProjectMenuContentSectionAnalyticsEvent({
            projectSection: (0, $a2a58ce6d289b621$export$3086f5b2b9faf5ae)
        });
    }, [
        sendProjectMenuContentSectionAnalyticsEvent
    ]);
    return favoriteItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.starred-section.starred-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLuq7.MenuSectionHeading), null, formatMessage((0, $42Jy1.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, favoriteItems.list))), favoriteItems.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: $b6c933b8e36d38d1$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $h4Bzb.MENU_ID_PROJECTS_VIEW_ALL_STARRED)
    }, formatMessage((0, $42Jy1.default).viewAllStarred)));
}

});
parcelRegister("98PI1", function(module, exports) {

$parcel$export(module.exports, "ProjectsDroppableGroupIndicator", () => $813c8d28ccd84f19$export$2fb821b6490fad6e);

var $eJOHy = parcelRequire("eJOHy");

var $8aRgF = parcelRequire("8aRgF");

var $fabzX = parcelRequire("fabzX");
const $813c8d28ccd84f19$export$2fb821b6490fad6e = (props)=>{
    const { children: children } = props;
    const dropTarget = (0, $fabzX.useDropTargetForProjects)();
    const { ref: ref, state: state } = dropTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8aRgF.GroupDropIndicator), {
        isActive: state === 'is-over',
        ref: ref
    }, children);
};

});
parcelRegister("8aRgF", function(module, exports) {

$parcel$export(module.exports, "GroupDropIndicator", () => $ab7663630ebff90c$export$cb7fd016127fc6fc);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $ab7663630ebff90c$var$activeStyles = null;
const $ab7663630ebff90c$export$cb7fd016127fc6fc = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function GroupDropIndicator({ children: children, isActive: isActive, testId: testId }, forwardedRef) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: forwardedRef,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            isActive && "_2rkogqwt _bfhk33gi _1cwg12x7 _12y31bk5 _1qu2nqa1 _12ji1yqz"
        ]),
        children: children
    });
});

});

parcelRegister("fabzX", function(module, exports) {

$parcel$export(module.exports, "useDropTargetForProjects", () => $68abf6fb5fc583f0$export$bf27ec69454698cb);

var $eJOHy = parcelRequire("eJOHy");

var $dv8dh = parcelRequire("dv8dh");

var $hSKbU = parcelRequire("hSKbU");

var $omzn0 = parcelRequire("omzn0");

var $epTsa = parcelRequire("epTsa");

var $hbF3h = parcelRequire("hbF3h");

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $guiPE = parcelRequire("guiPE");


var $hBBFp = parcelRequire("hBBFp");

var $3X9cT = parcelRequire("3X9cT");
const $68abf6fb5fc583f0$var$useDropTargetForProjectsConditionally = ()=>{
    const ref = (0, $eJOHy.useRef)(null);
    const [state, setState] = (0, $eJOHy.useState)();
    const updateFavouriteOrder = (0, $hBBFp.useUpdateFavouriteOrder)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({});
    (0, $eJOHy.useEffect)(()=>{
        const element = ref.current;
        // might have no projects
        if (!element) return;
        return (0, $dv8dh.dropTargetForElements)({
            element: element,
            canDrop: ({ source: source })=>{
                return (0, $guiPE.isDraggableProject)(source.data);
            },
            onDragStart ({ source: source }) {
                setState('is-over');
                const dragging = source.data;
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, {
                    ...(0, $3X9cT.ANALYTIC_PAYLOAD).DRAG_STARTED,
                    attributes: {
                        ...(0, $3X9cT.ANALYTIC_PAYLOAD).ATTRIBUTES,
                        itemId: dragging.id
                    }
                });
            },
            onDragEnter ({ source: source }) {
                setState('is-over');
                const dragging = source.data;
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, {
                    ...(0, $3X9cT.ANALYTIC_PAYLOAD).DRAG_ENTERED,
                    attributes: {
                        ...(0, $3X9cT.ANALYTIC_PAYLOAD).ATTRIBUTES,
                        itemId: dragging.id
                    }
                });
            },
            onDragLeave ({ source: source }) {
                setState('idle');
                const dragging = source.data;
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, {
                    ...(0, $3X9cT.ANALYTIC_PAYLOAD).DRAG_LEFT,
                    attributes: {
                        ...(0, $3X9cT.ANALYTIC_PAYLOAD).ATTRIBUTES,
                        itemId: dragging.id
                    }
                });
            },
            onDrop ({ source: source, location: location }) {
                setState('idle');
                let successfulReorder = false;
                const dragging = source.data;
                const [innerMost] = location.current.dropTargets;
                const dropTargetData = innerMost.data;
                if (!(0, $guiPE.isDraggableProject)(dragging) || !(0, $guiPE.isDraggableProject)(dropTargetData)) {
                    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, {
                        ...(0, $3X9cT.ANALYTIC_PAYLOAD).DRAG_ENDED,
                        attributes: {
                            ...(0, $3X9cT.ANALYTIC_PAYLOAD).ATTRIBUTES,
                            itemId: dragging.id,
                            successfulReorder: successfulReorder
                        }
                    });
                    return;
                }
                const instruction = (0, $omzn0.extractInstruction)(dropTargetData);
                const operation = instruction && $68abf6fb5fc583f0$var$instructionToOperation(instruction);
                if (operation) {
                    updateFavouriteOrder(operation, dragging.id, dropTargetData.id);
                    successfulReorder = true;
                    if ((0, $7jTnu.fg)('blu-8056-dnd-post-move-flash')) {
                        if (!source.element) return;
                        (0, $hSKbU.triggerPostMoveFlash)(source.element);
                    }
                }
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, {
                    ...(0, $3X9cT.ANALYTIC_PAYLOAD).DRAG_ENDED,
                    attributes: {
                        ...(0, $3X9cT.ANALYTIC_PAYLOAD).ATTRIBUTES,
                        itemId: dragging.id,
                        successfulReorder: successfulReorder
                    }
                });
            }
        });
    });
    return {
        ref: ref,
        state: state
    };
};
const $68abf6fb5fc583f0$export$bf27ec69454698cb = (0, $hbF3h.functionWithCondition)(()=>(0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false), $68abf6fb5fc583f0$var$useDropTargetForProjectsConditionally, ()=>({
        ref: {
            current: null
        },
        state: undefined
    }));
const $68abf6fb5fc583f0$var$instructionToOperation = (instruction)=>{
    switch(instruction?.operation){
        case 'reorder-before':
            return 0, $58939448f7663ec8$export$4cff6e48b6cc73b5;
        case 'reorder-after':
            return 0, $58939448f7663ec8$export$e0420f7fed62e74b;
        default:
            return null;
    }
};

});
parcelRegister("hSKbU", function(module, exports) {

$parcel$export(module.exports, "triggerPostMoveFlash", () => $6966b8759b36f89d$export$f5b5f29328df2633);

var $h9yln = parcelRequire("h9yln");
function $6966b8759b36f89d$export$f5b5f29328df2633(element) {
    element.animate([
        {
            backgroundColor: "var(--ds-background-selected, #E9F2FF)"
        },
        {}
    ], {
        duration: (0, $h9yln.durations).large,
        /**
     * This is equivalent to the browser default, but we are making it
     * explicit to avoid relying on implicit behavior.
     *
     * This curve is not part of `@atlaskit/motion` but it was an intentional
     * design decision to use this curve.
     */ easing: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)',
        iterations: 1
    });
}

});

parcelRegister("guiPE", function(module, exports) {

$parcel$export(module.exports, "isDraggableProject", () => $f587f4d548e70ca9$export$1338b07381f36262);

var $3X9cT = parcelRequire("3X9cT");
const $f587f4d548e70ca9$export$1338b07381f36262 = (data)=>{
    return Boolean(data.type === (0, $3X9cT.NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP));
};

});

const $58939448f7663ec8$export$5ff59e4f08b9b299 = 'MOVE_TO_TOP';
const $58939448f7663ec8$export$9964b4a63620a911 = 'MOVE_UP';
const $58939448f7663ec8$export$2692a384035c5ef7 = 'MOVE_DOWN';
const $58939448f7663ec8$export$a5a45050b97fca24 = 'MOVE_TO_BOTTOM';
const $58939448f7663ec8$export$e0420f7fed62e74b = 'AFTER';
const $58939448f7663ec8$export$4cff6e48b6cc73b5 = 'BEFORE';

parcelRegister("hBBFp", function(module, exports) {

$parcel$export(module.exports, "useUpdateFavouriteOrder", () => $6cca638fba2d1bf8$export$63ac7262a5a1464f);

var $izvyp = parcelRequire("izvyp");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kEUB1 = parcelRequire("kEUB1");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $4SjAP = parcelRequire("4SjAP");

var $3X9cT = parcelRequire("3X9cT");

var $kSw1o = parcelRequire("kSw1o");

var $lGgUK = parcelRequire("lGgUK");

var $cBksI = parcelRequire("cBksI");
const $6cca638fba2d1bf8$export$63ac7262a5a1464f = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $izvyp.default));
    const handleError = (0, $lGgUK.useHandleError)();
    const updateFavouriteOrder = (0, $eJOHy.useCallback)((operation, projectId, relativeProjectId)=>{
        commitMutation({
            variables: {
                input: {
                    cloudId: cloudId,
                    reorderMode: operation,
                    menuItem: {
                        itemId: projectId
                    },
                    // include relative menu item if provided
                    ...relativeProjectId && {
                        relativeMenuItem: {
                            itemId: relativeProjectId
                        }
                    }
                }
            },
            optimisticUpdater: (store)=>{
                (0, $cBksI.optimisticUpdater)(store, operation, projectId, cloudId, relativeProjectId);
            },
            onCompleted: (_, errors)=>{
                if (errors && errors.length > 0) {
                    const error = new (0, $4SjAP.MutationError)(errors[0]);
                    handleError(error);
                } else {
                    const analyticsEvent = createAnalyticsEvent({});
                    (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, {
                        ...(0, $3X9cT.ANALYTIC_PAYLOAD).UPDATED_ORDER,
                        attributes: {
                            ...(0, $3X9cT.ANALYTIC_PAYLOAD).ATTRIBUTES,
                            itemId: projectId,
                            action: (0, $kSw1o.menuItemReorderOperationToAction)(operation)
                        }
                    });
                }
            },
            onError: (error)=>{
                handleError(new (0, $4SjAP.MutationError)(error));
            }
        });
    }, [
        commitMutation,
        cloudId,
        handleError,
        createAnalyticsEvent
    ]);
    return updateFavouriteOrder;
};

});
parcelRegister("izvyp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f1fd223e2642466$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<26b810892d78885ca631c16e3fa8e8b0>>
 * @relayHash 2e74f891a48718cb67357935018bda1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID de54102e89fd92c2f9fcf18dc5a40c774bcb13f98c93f5523460461f3164e052

var $9zQGn = parcelRequire("9zQGn");

var $5moL7 = parcelRequire("5moL7");

var $lhtKZ = parcelRequire("lhtKZ");

var $eSxxM = parcelRequire("eSxxM");

var $em6ga = parcelRequire("em6ga");
const $6f1fd223e2642466$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 15
        }
    ], v4 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v5 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "webUrl"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "updateFavouriteOrderMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "Nav4ProjectMenuItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "updateFavouriteOrderMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_reorderProjectsSidebarMenuItem",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "large"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "defaultNavigationItem",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "url"
                                                                }
                                                            ],
                                                            "type": "JiraNavigationItem",
                                                            "abstractKey": "__isJiraNavigationItem"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v2 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "softwareBoardCount"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": v7 /*: any*/ 
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": v7 /*: any*/ 
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": v7 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ],
                            "storageKey": "favourites(first:15)"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "de54102e89fd92c2f9fcf18dc5a40c774bcb13f98c93f5523460461f3164e052",
            "metadata": {},
            "name": "updateFavouriteOrderMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $lhtKZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": (0, $5moL7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $eSxxM.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": (0, $9zQGn.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": (0, $em6ga.default)
            }
        }
    };
}();
$6f1fd223e2642466$var$node.hash = "3fb3d322be947c54af429676ea108ccc";
var $6f1fd223e2642466$export$2e2bcd8739ae039 = $6f1fd223e2642466$var$node;

});

parcelRegister("kSw1o", function(module, exports) {

$parcel$export(module.exports, "menuItemReorderOperationToAction", () => $dcdcdec54e56df56$export$8357c82608ac73da);

const $dcdcdec54e56df56$export$8357c82608ac73da = (operation)=>{
    switch(operation){
        case 0, $58939448f7663ec8$export$5ff59e4f08b9b299:
            return 'moveToTop';
        case 0, $58939448f7663ec8$export$9964b4a63620a911:
            return 'moveUp';
        case 0, $58939448f7663ec8$export$2692a384035c5ef7:
            return 'moveDown';
        case 0, $58939448f7663ec8$export$a5a45050b97fca24:
            return 'moveToBottom';
        case 0, $58939448f7663ec8$export$e0420f7fed62e74b:
            return 'dragged';
        case 0, $58939448f7663ec8$export$4cff6e48b6cc73b5:
            return 'dragged';
        default:
            return '';
    }
};

});

parcelRegister("lGgUK", function(module, exports) {

$parcel$export(module.exports, "useHandleError", () => $5fdf767729540de6$export$7ab84fea33af0d21);

var $eJOHy = parcelRequire("eJOHy");

var $bILK0 = parcelRequire("bILK0");

var $gYnSx = parcelRequire("gYnSx");

var $3X9cT = parcelRequire("3X9cT");

var $au9J4 = parcelRequire("au9J4");
const $5fdf767729540de6$var$FLAG = {
    type: 'error',
    title: (0, $au9J4.default).defaultErrorTitle,
    description: (0, $au9J4.default).defaultErrorMessage,
    messageId: 'navigation-apps-sidebar-nav4-projects-customise-order.services.update-favourite-order.flag.error',
    messageType: 'transactional'
};
function $5fdf767729540de6$export$7ab84fea33af0d21() {
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        (0, $gYnSx.default)({
            meta: {
                id: 'useUpdateFavouriteOrder',
                packageName: (0, $3X9cT.PACKAGE_NAME),
                teamName: (0, $3X9cT.TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag($5fdf767729540de6$var$FLAG);
    }, [
        showFlag
    ]);
    return handleError;
}

});
parcelRegister("au9J4", function(module, exports) {

$parcel$export(module.exports, "default", () => $08446bd95fbf50bf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $08446bd95fbf50bf$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    defaultErrorMessage: {
        "id": "jira-navigation-apps-sidebar-nav4-projects-customise-order.default-error-message",
        "defaultMessage": "Check your connection and try again."
    },
    defaultErrorTitle: {
        "id": "jira-navigation-apps-sidebar-nav4-projects-customise-order.default-error-title",
        "defaultMessage": "We couldn't update your view."
    }
});

});


parcelRegister("cBksI", function(module, exports) {

$parcel$export(module.exports, "optimisticUpdater", () => $1a914a13909655a2$export$32fd5c97e0eb451);

var $8Rclc = parcelRequire("8Rclc");
function $1a914a13909655a2$export$32fd5c97e0eb451(store, operation, targetProjectId, cloudId, relativeProjectId) {
    const sidebarMenuRecord = store.getRoot().getLinkedRecord('jira_projectsSidebarMenu', {
        cloudId: cloudId
    });
    const favoriteConnection = sidebarMenuRecord && sidebarMenuRecord.getLinkedRecord('favourites', {
        first: 15
    });
    if (!favoriteConnection) return;
    const edges = favoriteConnection.getLinkedRecords('edges') ?? [];
    if (!edges.length || edges.length <= 1) return;
    const projectIdToEdgeMap = edges.reduce((map, edge)=>{
        const projectId = edge.getLinkedRecord('node')?.getValue('projectId')?.toString();
        return projectId ? map.set(projectId, edge) : map;
    }, new Map());
    const projectIds = Array.from(projectIdToEdgeMap.keys());
    const sortedProjectIds = (0, $8Rclc.reorder)(operation, projectIds, targetProjectId, relativeProjectId);
    const sortedEdges = sortedProjectIds.map((projectId)=>projectIdToEdgeMap.get(projectId) ?? null);
    favoriteConnection.setLinkedRecords(sortedEdges, 'edges');
}

});
parcelRegister("8Rclc", function(module, exports) {

$parcel$export(module.exports, "reorder", () => $46eba235655f55e9$export$fc77a6137e3f91c);

const $46eba235655f55e9$export$f2c5cc4c3f787c3e = (projectsList, projectId)=>{
    const filteredList = projectsList.filter((id)=>id !== projectId);
    return [
        projectId,
        ...filteredList
    ];
};
const $46eba235655f55e9$export$8ff471d483515a76 = (projectsList, projectId)=>{
    const filteredList = projectsList.filter((id)=>id !== projectId);
    return [
        ...filteredList,
        projectId
    ];
};
const $46eba235655f55e9$export$44935f8a884b57b9 = (projectsList, projectId)=>{
    const index = projectsList.indexOf(projectId);
    if (index > 0) {
        const newList = [
            ...projectsList
        ];
        newList.splice(index, 1);
        newList.splice(index - 1, 0, projectId);
        return newList;
    }
    return projectsList;
};
const $46eba235655f55e9$export$8eba228b343b3599 = (projectsList, projectId)=>{
    const index = projectsList.indexOf(projectId);
    if (index >= 0) {
        const newList = [
            ...projectsList
        ];
        newList.splice(index, 1);
        newList.splice(index + 1, 0, projectId);
        return newList;
    }
    return projectsList;
};
const $46eba235655f55e9$export$86b68c7dbeb53c22 = (projectsList, projectId, relativeProject)=>{
    const index = projectsList.indexOf(relativeProject);
    if (index >= 0) {
        const filteredList = projectsList.filter((id)=>id !== projectId);
        const newList = [
            ...filteredList
        ];
        newList.splice(filteredList.indexOf(relativeProject), 0, projectId);
        return newList;
    }
    return projectsList;
};
const $46eba235655f55e9$export$c4f94c8b3850a5a9 = (projectsList, projectId, relativeProject)=>{
    const index = projectsList.indexOf(relativeProject);
    if (index >= 0) {
        const filteredList = projectsList.filter((id)=>id !== projectId);
        const newList = [
            ...filteredList
        ];
        newList.splice(filteredList.indexOf(relativeProject) + 1, 0, projectId);
        return newList;
    }
    return projectsList;
};
const $46eba235655f55e9$export$4583b779aad6d7dc = (projectsList, projectId)=>{
    return [
        projectId,
        ...projectsList
    ];
};
const $46eba235655f55e9$export$a7bc06cf61a60193 = (projectsList, projectId)=>{
    return [
        ...projectsList,
        projectId
    ];
};
const $46eba235655f55e9$export$fc77a6137e3f91c = (operation, projectIds, projectId, relativeId)=>{
    switch(operation){
        case 0, $58939448f7663ec8$export$5ff59e4f08b9b299:
            return $46eba235655f55e9$export$f2c5cc4c3f787c3e(projectIds, projectId);
        case 0, $58939448f7663ec8$export$9964b4a63620a911:
            return $46eba235655f55e9$export$44935f8a884b57b9(projectIds, projectId);
        case 0, $58939448f7663ec8$export$2692a384035c5ef7:
            return $46eba235655f55e9$export$8eba228b343b3599(projectIds, projectId);
        case 0, $58939448f7663ec8$export$a5a45050b97fca24:
            return $46eba235655f55e9$export$8ff471d483515a76(projectIds, projectId);
        case 0, $58939448f7663ec8$export$4cff6e48b6cc73b5:
            return relativeId ? $46eba235655f55e9$export$86b68c7dbeb53c22(projectIds, projectId, relativeId) : projectIds;
        case 0, $58939448f7663ec8$export$e0420f7fed62e74b:
            return relativeId ? $46eba235655f55e9$export$c4f94c8b3850a5a9(projectIds, projectId, relativeId) : projectIds;
        default:
            return projectIds;
    }
};

});






parcelRegister("68QJy", function(module, exports) {

$parcel$export(module.exports, "RenderMostRecentProjectSection", () => $6b2dbc7a24198ca5$export$6269b4a1c127cf98);

var $eJOHy = parcelRequire("eJOHy");

var $ilbtc = parcelRequire("ilbtc");
var $1swHh = parcelRequire("1swHh");
const $6b2dbc7a24198ca5$export$6269b4a1c127cf98 = ({ projectItem: projectItem })=>{
    return !!projectItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.most-recent-project-section.most-recent-project-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, projectItem));
};

});


parcelRegister("jHZN8", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsSectionsWithDisplaySettings", () => $ce1351e532e3e285$export$f5fa44865e47a204);

var $kwEcQ = parcelRequire("kwEcQ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $286cZ = parcelRequire("286cZ");

var $h4Bzb = parcelRequire("h4Bzb");

var $1pmgP = parcelRequire("1pmgP");

var $dpxw4 = parcelRequire("dpxw4");

var $jMoKX = parcelRequire("jMoKX");

var $aJgGb = parcelRequire("aJgGb");

var $fXQx2 = parcelRequire("fXQx2");
const $ce1351e532e3e285$var$isDisplaySettingsKey = (value)=>{
    const keys = Object.values((0, $jMoKX.DisplaySettingsPropertyKeys));
    return keys.includes(value);
};
const $ce1351e532e3e285$var$getNavigationCustomisation = (nodes, viewOption, defaultValue)=>{
    return nodes?.find((node)=>node?.key && $ce1351e532e3e285$var$isDisplaySettingsKey(node.key) && (0, $jMoKX.DisplaySettingsPropertyKeys)[node.key] === viewOption)?.value || defaultValue;
};
const $ce1351e532e3e285$var$Nav4ProjectsSectionsWithDisplaySettingsInternal = ({ favoriteItems: favoriteItems, recentItems: recentItems, queryRef: queryRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $kwEcQ.default), queryRef);
    const selectedViewOption = $ce1351e532e3e285$var$getNavigationCustomisation(data.settings_navigationCustomisation?.properties?.nodes, (0, $jMoKX.DisplaySettingsPropertyKeys).VIEW_OPTION, (0, $1pmgP.DefaultViewOption));
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const isStarredViewOptionSelected = selectedViewOption === (0, $1pmgP.ViewOptions).STARRED;
    const isStarredAndRecentViewOptionSelected = selectedViewOption === (0, $1pmgP.ViewOptions).STARRED_AND_RECENT;
    // If the current project is not starred, display it under the Recent section.
    // Once navigated away from the current non-starred project, it should disappear from the sidebar,
    // along with the Recent section
    const currentRecentItem = recentItems.list.find((item)=>item.key && isSelectedPath((0, $h4Bzb.ENTITY_ID).PROJECT(item.key)));
    const displayedRecentItems = (0, $eJOHy.useMemo)(()=>isStarredViewOptionSelected ? {
            list: currentRecentItem ? [
                currentRecentItem
            ] : [],
            hasItems: Boolean(currentRecentItem)
        } : recentItems, [
        currentRecentItem,
        isStarredViewOptionSelected,
        recentItems
    ]);
    const shouldShowStarredSection = isStarredAndRecentViewOptionSelected || isStarredViewOptionSelected;
    const shouldShowRecentSection = isStarredAndRecentViewOptionSelected || displayedRecentItems.hasItems;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, shouldShowStarredSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aJgGb.RenderStarredSection), {
        favoriteItems: favoriteItems
    }), shouldShowRecentSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fXQx2.RenderRecentSection), {
        recentItems: displayedRecentItems
    }));
};
const $ce1351e532e3e285$export$f5fa44865e47a204 = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp_magma_jsm-perf-improvement-batch-1'), $ce1351e532e3e285$var$Nav4ProjectsSectionsWithDisplaySettingsInternal);

});
parcelRegister("kwEcQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c832a1769d3b81a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<db313e78bd4577e1f34af3f48f590ec2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6c832a1769d3b81a$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ownerAri"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4ProjectsSectionsWithDisplaySettings",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAri"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                }
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsDisplayPropertyConnection",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsDisplayProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$6c832a1769d3b81a$var$node.hash = "e6e0f204dff7282a7c0aeb808efb30c6";
var $6c832a1769d3b81a$export$2e2bcd8739ae039 = $6c832a1769d3b81a$var$node;

});






parcelRegister("cRLIL", function(module, exports) {

$parcel$export(module.exports, "Recent", () => $8f7109c8820f0bf6$export$1147d6e1036afec);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $16sa1 = parcelRequire("16sa1");


var $dk46D = parcelRequire("dk46D");
const $8f7109c8820f0bf6$export$1147d6e1036afec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4-sidebar-recent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "recent",
        packageName: (0, $48cae6cf1c387d08$export$b8b9d90f9e5bd72b),
        teamName: (0, $48cae6cf1c387d08$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dk46D.RecentMenu), null)));

});
const $48cae6cf1c387d08$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Recent';
const $48cae6cf1c387d08$export$d57b6b390e78d90f = 'jira-cosmos';
const $48cae6cf1c387d08$export$56ff071570537731 = 15;
const $48cae6cf1c387d08$export$fe791c4fa892e400 = 'PROJECT';
const $48cae6cf1c387d08$export$c303e491e026ebc6 = 'PLAN';
const $48cae6cf1c387d08$export$c1c49903035a02df = 'FILTER';
const $48cae6cf1c387d08$export$4695c1a423ffe431 = 'DASHBOARD';
const $48cae6cf1c387d08$export$9b8283d5878d2491 = 'BOARD';
const $48cae6cf1c387d08$export$5828682c822c26e7 = 'QUEUE';
const $48cae6cf1c387d08$export$76a449e52fa0e1e8 = 'ISSUE';
const $48cae6cf1c387d08$export$fd6cd74eeb4b51a7 = 'searchRecentItems';
const $48cae6cf1c387d08$export$f91d73dc0ffb6584 = 'viewAllRecentItems';
const $48cae6cf1c387d08$export$ee6bbe0a973ca0e8 = 'today';
const $48cae6cf1c387d08$export$91c1c08ffbb5f1be = 'yesterday';
const $48cae6cf1c387d08$export$4bada75a9cb45bec = 'thisWeek';
const $48cae6cf1c387d08$export$1385d821597ee807 = 'thisMonth';
const $48cae6cf1c387d08$export$d64d14c448d5a065 = 'moreThanAMonth';

parcelRegister("dk46D", function(module, exports) {

$parcel$export(module.exports, "RecentMenu", () => $95e7d3aea52996e1$export$9051cd0d0927b696);

var $eJOHy = parcelRequire("eJOHy");

var $2IWvf = parcelRequire("2IWvf");

var $d9oCz = parcelRequire("d9oCz");
var $5jwgZ = parcelRequire("5jwgZ");
var $63KSu = parcelRequire("63KSu");

var $31HYi = parcelRequire("31HYi");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $7jTnu = parcelRequire("7jTnu");


var $a9aec = parcelRequire("a9aec");

var $80rA3 = parcelRequire("80rA3");

var $8IuE5 = parcelRequire("8IuE5");

var $if69u = parcelRequire("if69u");

var $2QH3X = parcelRequire("2QH3X");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $kEUB1 = parcelRequire("kEUB1");


var $jDnzy = parcelRequire("jDnzy");

var $hX5Oa = parcelRequire("hX5Oa");
const $95e7d3aea52996e1$var$EMPTY_OBJECT = {};
function $95e7d3aea52996e1$export$9051cd0d0927b696() {
    const cloudId = (0, $kEUB1.useCloudId)();
    const { formattedMessage: formattedMessage, icon: icon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $jDnzy.default).recent, (0, (/*@__PURE__*/$parcel$interopDefault($2IWvf))));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $hX5Oa.sidebarRecentMenuEntryPoint), (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            count: (0, $48cae6cf1c387d08$export$56ff071570537731)
        }), [
        cloudId
    ]) : {
        cloudId: cloudId,
        count: (0, $48cae6cf1c387d08$export$56ff071570537731)
    });
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const onOpenChange = (0, $eJOHy.useCallback)((isMenuOpen)=>{
        if (isMenuOpen) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $8IuE5.L1_MENU_ID).RECENT);
            (0, $gCeeo.fireUIAnalytics)(event, (0, $a9aec.SECTION_ITEM_RECENT), {
                isInMore: isInMore
            });
        }
    }, [
        moreMenuIds,
        createAnalyticsEvent
    ]);
    return (0, $7jTnu.fg)('jira_global_recent_menu_item') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $31HYi.GlobalRecentMenuItem), {
        triggerRef: triggerRef,
        onOpenChange: onOpenChange
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9oCz.FlyoutMenuItem), {
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $63KSu.FlyoutMenuItemTrigger), {
        interactionName: "nav4-sidebar-recent",
        ref: triggerRef,
        elemBefore: icon
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5jwgZ.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "nav4-sidebar-recent-default",
        packageName: (0, $48cae6cf1c387d08$export$b8b9d90f9e5bd72b),
        teamName: (0, $48cae6cf1c387d08$export$d57b6b390e78d90f),
        errorFallback: "flag",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
            withHeading: true,
            withSearch: true,
            withSubHeading: true,
            withSubTitle: true,
            isFlyout: true
        }),
        runtimeProps: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? $95e7d3aea52996e1$var$EMPTY_OBJECT : {}
    })));
}

});
parcelRegister("31HYi", function(module, exports) {

$parcel$export(module.exports, "GlobalRecentMenuItem", () => $4f39acbae29a28c2$export$c58a64243715c6bf);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $2IWvf = parcelRequire("2IWvf");

var $d9oCz = parcelRequire("d9oCz");
var $5jwgZ = parcelRequire("5jwgZ");
var $63KSu = parcelRequire("63KSu");

var $kjSpv = parcelRequire("kjSpv");

var $lt51e = parcelRequire("lt51e");
const $4f39acbae29a28c2$export$1a14f8e769122bb2 = (Content)=>({ onOpenChange: onOpenChange, isDefaultOpen: isDefaultOpen, triggerRef: triggerRef })=>{
        const { formatMessage: formatMessage } = (0, $lRq8t.default)();
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $d9oCz.FlyoutMenuItem), {
            onOpenChange: onOpenChange,
            isDefaultOpen: isDefaultOpen,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $63KSu.FlyoutMenuItemTrigger), {
                    ref: triggerRef,
                    elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2IWvf))), {
                        label: "",
                        color: "currentColor"
                    }),
                    children: formatMessage((0, $lt51e.messages).flyoutMenuItemTriggerTitle)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5jwgZ.FlyoutMenuItemContent), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Content, {})
                })
            ]
        });
    };
const $4f39acbae29a28c2$export$c58a64243715c6bf = $4f39acbae29a28c2$export$1a14f8e769122bb2((0, $kjSpv.GlobalRecentMenuContent));
var // This is only needed to support the Atlaskit docs. See https://hello.atlassian.net/wiki/spaces/navx/pages/5305993008/Platform+Guide#Atlaskit-%3CProps%3E-component-not-rendering
$4f39acbae29a28c2$export$2e2bcd8739ae039 = (props)=>{
    throw new Error('This default export is only used for Atlaskit documentation. Do not use!');
};

});
parcelRegister("kjSpv", function(module, exports) {

$parcel$export(module.exports, "GlobalRecentMenuContent", () => $6416ee129fe9a2da$export$29802207e0d6c9fc);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $lRq8t = parcelRequire("lRq8t");

var $bvFRW = parcelRequire("bvFRW");

var $lers0 = parcelRequire("lers0");

var $aasrU = parcelRequire("aasrU");

var $2y3Ci = parcelRequire("2y3Ci");

var $feav5 = parcelRequire("feav5");

var $bxHeV = parcelRequire("bxHeV");
var $9LyfF = parcelRequire("9LyfF");

var $iHPVu = parcelRequire("iHPVu");

var $eyn9v = parcelRequire("eyn9v");

var $lt51e = parcelRequire("lt51e");
const $6416ee129fe9a2da$var$VIEW_ALL_LINK = 'https://home.atlassian.com/recents';

const $6416ee129fe9a2da$var$LazyGlobalRecentItems = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("frRkE")));
const $6416ee129fe9a2da$export$29802207e0d6c9fc = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9LyfF.default), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.default), {
                paddingInline: "space.075",
                paddingBlock: "space.100",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvFRW.default), {
                    size: "xsmall",
                    children: formatMessage((0, $lt51e.messages).flyoutMenuItemTriggerTitle)
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iHPVu.ErrorState), {}),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                    fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eyn9v.LoadingState), {}),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($6416ee129fe9a2da$var$LazyGlobalRecentItems, {})
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $feav5.Divider), {}),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2y3Ci.MenuList), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aasrU.LinkMenuItem), {
                    elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lers0))), {
                        label: "",
                        spacing: "spacious",
                        color: "currentColor"
                    }),
                    href: $6416ee129fe9a2da$var$VIEW_ALL_LINK,
                    children: formatMessage((0, $lt51e.messages).viewAllRecentItems)
                })
            })
        ]
    });
};
var $6416ee129fe9a2da$export$2e2bcd8739ae039 = $6416ee129fe9a2da$export$29802207e0d6c9fc;

});
parcelRegister("iHPVu", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $c20967af6a7f5928$export$c1ed4f415b9e7023);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bvFRW = parcelRequire("bvFRW");

var $bxHeV = parcelRequire("bxHeV");
var $9LyfF = parcelRequire("9LyfF");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $lt51e = parcelRequire("lt51e");
const $c20967af6a7f5928$export$c1ed4f415b9e7023 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.default), {
        xcss: $c20967af6a7f5928$var$styles,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9LyfF.default), {
            alignInline: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvFRW.default), {
                    size: "xsmall",
                    children: formatMessage((0, $lt51e.messages).errorStateHeading)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jvsV6.default), {
                    size: "small",
                    align: "center",
                    color: "color.text.subtle",
                    children: formatMessage((0, $lt51e.messages).errorStateDescription)
                })
            ]
        })
    });
};
const $c20967af6a7f5928$var$styles = (0, $5Wv5g.xcss)({
    paddingBlock: 'space.1000',
    paddingInline: 'space.100'
});

});
parcelRegister("lt51e", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d1da43650bb85142$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d1da43650bb85142$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    flyoutMenuItemTriggerTitle: {
        id: 'navigation.global-recent.flyout-menu-item-trigger-title.non-final',
        description: 'Label of the control that triggers the flyout menu.',
        defaultMessage: 'Recent'
    },
    viewAllRecentItems: {
        id: 'navigation.global-recent.view-all-recent-items.non-final',
        description: 'Label of the control that links to a page with all of the recent items.',
        defaultMessage: 'View all recent items'
    },
    menuSectionHeadingToday: {
        id: 'navigation.global-recent.menu-section-heading-today.non-final',
        description: "Heading of the section rendering today's items.",
        defaultMessage: 'Today'
    },
    menuSectionHeadingYesterday: {
        id: 'navigation.global-recent.menu-section-heading-yesterday.non-final',
        description: "Heading of the section rendering yesterday's items.",
        defaultMessage: 'Yesterday'
    },
    menuSectionHeadingThisWeek: {
        id: 'navigation.global-recent.menu-section-heading-this-week.non-final',
        description: 'Heading of the section rendering items for the current week.',
        defaultMessage: 'This week'
    },
    menuSectionHeadingThisMonth: {
        id: 'navigation.global-recent.menu-section-heading-this-month.non-final',
        description: 'Heading of the section rendering items for the current month.',
        defaultMessage: 'This Month'
    },
    menuSectionHeadingMoreThanAMonthAgo: {
        id: 'navigation.global-recent.menu-section-heading-this-month.non-final',
        description: 'Heading of the section rendering items older than a month ago.',
        defaultMessage: 'More than a month ago'
    },
    errorStateHeading: {
        id: 'navigation.global-recent.error-state-heading.non-final',
        description: "Heading of the error state UI indicating we couldn't load the data.",
        defaultMessage: "Can't load items"
    },
    errorStateDescription: {
        id: 'navigation.global-recent.error-state-description.non-final',
        description: "Description of the error state UI indicating we couldn't load the data.",
        defaultMessage: "We're having trouble loading your data. Please try again later."
    },
    emptyStateHeading: {
        id: 'navigation.global-recent.empty-state-heading.non-final',
        description: "Heading of the empty state UI indicating there's no content available.",
        defaultMessage: 'Nothing to see here!'
    },
    emptyStateDescription: {
        id: 'navigation.global-recent.empty-state-description.non-final',
        description: "Description of the empty state UI indicating there's no content available.",
        defaultMessage: "Once you visit, edit, or create items, they'll show up here."
    },
    loadingStateVisuallyHiddenLabel: {
        id: 'navigation.global-recent.loading-state-visually-hidden-label.non-final',
        description: 'Label of the loading state UI only available to screen reader users.',
        defaultMessage: 'Loading recent content'
    },
    confluenceDraftDefaultTitle: {
        id: 'navigation.global-recent.confluence-item-draft-title.non-final',
        description: 'Default title for draft pages and blog posts in Confluence.',
        defaultMessage: 'Untitled'
    },
    confluenceDraftLabel: {
        id: 'navigation.global-recent.confluence-item-draft-label.non-final',
        description: 'Label of the lozenge indicating a Confluence item is a draft.',
        defaultMessage: 'Draft'
    }
});

});


parcelRegister("eyn9v", function(module, exports) {

$parcel$export(module.exports, "LoadingState", () => $17bc36f581efe036$export$62aa48085237e36f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $f9Ihw = parcelRequire("f9Ihw");

var $2y3Ci = parcelRequire("2y3Ci");

var $ilbtc = parcelRequire("ilbtc");

var $1otFb = parcelRequire("1otFb");

var $lt51e = parcelRequire("lt51e");
const $17bc36f581efe036$export$62aa48085237e36f = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const items = Array.from({
        length: 5
    }, (_, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $ilbtc.MenuListItem), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f9Ihw.default), {
                isShimmering: true,
                width: "100%"
            })
        }, index));
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1otFb.default), {
                children: formatMessage((0, $lt51e.messages).loadingStateVisuallyHiddenLabel)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2y3Ci.MenuList), {
                children: items
            })
        ]
    });
};

});

parcelRegister("frRkE", function(module, exports) {

let $b3f2bf488e8dfba8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b3f2bf488e8dfba8$var$load("29FvR").then(()=>parcelRequire('2xG9Z'));

});



parcelRegister("jDnzy", function(module, exports) {

$parcel$export(module.exports, "default", () => $771c13e93e04295b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $771c13e93e04295b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-recent.recent",
        "defaultMessage": "Recent"
    }
});

});

parcelRegister("hX5Oa", function(module, exports) {

$parcel$export(module.exports, "sidebarRecentMenuEntryPoint", () => $a77dfaba95034dd7$export$52be5f9ca0100885);

var $qL0sN = parcelRequire("qL0sN");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $a77dfaba95034dd7$export$52be5f9ca0100885 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("dMPim")), {
        moduleId: "1a0fa847",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, count: count })=>({
            queries: {
                recentMenuData: {
                    parameters: $qL0sN.default,
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        count: count,
                        keyword: ''
                    }
                }
            }
        })
});

});
parcelRegister("qL0sN", function(module, exports) {

$parcel$export(module.exports, "default", () => $77644fce84214bd6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b419a047cdf1d84819532a8450f2373a>>
 * @relayHash 2bf261fc9e503f19a16072abc8ff3bb0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 855172207100d7942753caadb5bb595995ca2328e35845d9cb3c8f297f5e2ce4

var $37Ewn = parcelRequire("37Ewn");
const $77644fce84214bd6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "keyword"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "fields": [
            {
                "kind": "Variable",
                "name": "keyword",
                "variableName": "keyword"
            }
        ],
        "kind": "ObjectValue",
        "name": "filter"
    }, v5 = {
        "kind": "Literal",
        "name": "types",
        "value": [
            "PROJECT",
            "FILTER",
            "DASHBOARD",
            "BOARD",
            "QUEUE",
            "ISSUE",
            "PLAN"
        ]
    }, v6 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        v5 /*: any*/ 
    ], v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v8 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        v5 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v10 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = [
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": "filterName",
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterId"
                }
            ],
            "type": "JiraFilter",
            "abstractKey": "__isJiraFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "recentMenuQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "recent",
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v7 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.recent.pageInfo"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.recent"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "recentMenu_navigationAppsSidebarNav4SidebarsContentRecent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "recentMenuQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "recent",
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "issueWebUrl",
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v12 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        }
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v8 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "types",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "RecentMenuContent__recentItems",
                            "kind": "LinkedHandle",
                            "name": "recentItems"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "855172207100d7942753caadb5bb595995ca2328e35845d9cb3c8f297f5e2ce4",
            "metadata": {},
            "name": "recentMenuQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$77644fce84214bd6$var$node.hash = "b81d123360d86456f0af905baa34e827";
(0, $37Ewn.PreloadableQueryRegistry).set($77644fce84214bd6$var$node.params.id, $77644fce84214bd6$var$node);
var $77644fce84214bd6$export$2e2bcd8739ae039 = $77644fce84214bd6$var$node;

});

parcelRegister("dMPim", function(module, exports) {

let $a0978c35819979d0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a0978c35819979d0$var$load("8sYjU").then(()=>parcelRequire('babwp'));

});




parcelRegister("iFx8E", function(module, exports) {

$parcel$export(module.exports, "Nav4Roadmaps", () => $b89bfd91b699c398$export$257bbde911c73386);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $if69u = parcelRequire("if69u");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $7i4qI = parcelRequire("7i4qI");

var $4bCl7 = parcelRequire("4bCl7");

var $3n4ak = parcelRequire("3n4ak");

var $fqYMs = parcelRequire("fqYMs");

const $b89bfd91b699c398$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("1Pdwr")).then(({ Nav4RoadmapsContainer: Nav4RoadmapsContainer })=>Nav4RoadmapsContainer), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/roadmaps/src/ui/roadmaps/index.tsx"
});
const $b89bfd91b699c398$export$257bbde911c73386 = /*#__PURE__*/ (0, $eJOHy.memo)(({ isExpanded: isExpanded })=>{
    const isCollectionSelected = (0, $fqYMs.useIsCollectionSelected)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.roadmaps",
        packageName: (0, $7i4qI.PACKAGE_NAME),
        teamName: (0, $7i4qI.TEAM_NAME),
        ufoName: "nav4-sidebar-roadmaps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4-sidebar-roadmaps",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4bCl7.RoadmapsStatic), {
            isExpanded: isExpanded,
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3n4ak.ActionButtonsStatic), null)
        }, isCollectionSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b89bfd91b699c398$var$LazySidebarContent, {
        isExpanded: isExpanded
    })));
});

});
parcelRegister("7i4qI", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $4d5b43a119b93be9$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $4d5b43a119b93be9$export$d57b6b390e78d90f);
$parcel$export(module.exports, "VIEW_ALL_ROADMAPS", () => $4d5b43a119b93be9$export$3fc15b6d7f7757ac);
$parcel$export(module.exports, "CREATE_ROADMAP", () => $4d5b43a119b93be9$export$862abc666c31a61a);
$parcel$export(module.exports, "MEATBALL_DROPDOWN", () => $4d5b43a119b93be9$export$f06dfcec5ff912e);
$parcel$export(module.exports, "PERMISSIONS_CACHE_TTL", () => $4d5b43a119b93be9$export$5448370085586a5f);
const $4d5b43a119b93be9$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Roadmaps';
const $4d5b43a119b93be9$export$d57b6b390e78d90f = 'jpd-horizon';
const $4d5b43a119b93be9$export$3fc15b6d7f7757ac = 'viewAllRoadmaps';
const $4d5b43a119b93be9$export$862abc666c31a61a = 'createRoadmaps';
const $4d5b43a119b93be9$export$f06dfcec5ff912e = 'meatballDropdown';
const $4d5b43a119b93be9$export$5448370085586a5f = 600000; // 10 minutes

});

parcelRegister("4bCl7", function(module, exports) {

$parcel$export(module.exports, "RoadmapsStatic", () => $a4c37ce13b3d657d$export$4c4071eb62c5e1cf);

var $eJOHy = parcelRequire("eJOHy");

var $gbiVe = parcelRequire("gbiVe");

var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $lvrbL = parcelRequire("lvrbL");

var $azEgq = parcelRequire("azEgq");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $8lgoE = parcelRequire("8lgoE");

var $gdBMj = parcelRequire("gdBMj");

var $bQoR3 = parcelRequire("bQoR3");

var $9Ku9P = parcelRequire("9Ku9P");

var $fqYMs = parcelRequire("fqYMs");

var $jThqL = parcelRequire("jThqL");
const $a4c37ce13b3d657d$export$4c4071eb62c5e1cf = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const { isExpanded: isExpanded, onExpansionToggle: onExpansionToggle, actionsOnHover: actionsOnHover, children: children } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).ROADMAPS);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const isJpdProjectView = (0, $fqYMs.useIsJpdProjectView)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), {
        name: (0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvrbL.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: (0, $h4Bzb.MENU_ID_ROADMAPS),
        onExpansionToggle: (hasExpanded)=>{
            onExpansionToggle?.(hasExpanded);
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).ROADMAPS,
                sectionItem: (0, $a9aec.SECTION_ITEM_ROADMAPS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HUFo.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-roadmaps-default",
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Ku9P.PremiumLozenge), null),
        testId: (0, $azEgq.getTestId)((0, $h4Bzb.MENU_ID_ROADMAPS))
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yAFiV.ExpandableMenuItemContent), null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jThqL.Footer), null))), isJpdProjectView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gdBMj.RoadmapIntroductionSpotlight), {
        collectionsUrl: (0, $bQoR3.getCollectionsPageUrl)(),
        placement: "right middle"
    }));
});

});
parcelRegister("8lgoE", function(module, exports) {

$parcel$export(module.exports, "GO_TO_PROJECT_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$d4b65c1c7753dab5);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_DISMISSED", () => $512de23a1d0d4ccd$export$5ca3ca33630ba93c);
$parcel$export(module.exports, "EXPLORE_SECTION_MESSAGE_DISMISSED", () => $512de23a1d0d4ccd$export$a81698c00c65eb4a);
$parcel$export(module.exports, "SEEN_PULSATING_FIELDS_BUTTON", () => $512de23a1d0d4ccd$export$3085446206860099);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_DISMISSED", () => $512de23a1d0d4ccd$export$d32c1bbde6ae670d);
$parcel$export(module.exports, "PROJECT_FIELDS_PAGE_VIEWED", () => $512de23a1d0d4ccd$export$ca2e8a74c8b43637);
$parcel$export(module.exports, "TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED", () => $512de23a1d0d4ccd$export$c6877be73b5f3d5a);
$parcel$export(module.exports, "COLLECTIONS_TOUR_DISMISSED", () => $512de23a1d0d4ccd$export$9a1ee3e31621d60);
$parcel$export(module.exports, "PREMIUM_MODAL_DISMISSED", () => $512de23a1d0d4ccd$export$522f4dc72dc494f2);
$parcel$export(module.exports, "PREMIUM_LAST_VISIT", () => $512de23a1d0d4ccd$export$34f7000ddecc0e7f);
$parcel$export(module.exports, "CROSS_PROJECT_VIEW_TOUR_DISMISSED", () => $512de23a1d0d4ccd$export$1be797d9a57b42ac);
$parcel$export(module.exports, "CROSS_PROJECT_LIST_VIEW_FIELDS_DISMISSED_KEY", () => $512de23a1d0d4ccd$export$c176277d0ae24685);
$parcel$export(module.exports, "CROSS_PROJECT_TIMELINE_VIEW_FIELDS_DISMISSED_KEY", () => $512de23a1d0d4ccd$export$dc14a417cdf40a4e);
$parcel$export(module.exports, "CROSS_PROJECT_BOARD_VIEW_FIELDS_DISMISSED_KEY", () => $512de23a1d0d4ccd$export$76d94539e8fefb4a);
$parcel$export(module.exports, "CROSS_PROJECT_MATRIX_VIEW_FIELDS_DISMISSED_KEY", () => $512de23a1d0d4ccd$export$c98b8b1065f15440);
$parcel$export(module.exports, "USER_PROPERTY_BY_STATE_KEY", () => $512de23a1d0d4ccd$export$61a0683bfb4060d7);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_1", () => $512de23a1d0d4ccd$export$34cb8e95f71c5026);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_2", () => $512de23a1d0d4ccd$export$7f842ac8d21dd77c);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_3", () => $512de23a1d0d4ccd$export$bd207a2522aeeba4);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_4", () => $512de23a1d0d4ccd$export$204b6702ab1fae0e);
$parcel$export(module.exports, "GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_LAST", () => $512de23a1d0d4ccd$export$14b1ce7029803351);
$parcel$export(module.exports, "GLOBAL_FIELDS_GO_TO_PROJECT_SPOTLIGHT", () => $512de23a1d0d4ccd$export$4aa3d2e1dc759f3c);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_1", () => $512de23a1d0d4ccd$export$c1ff7f4df78bdbc4);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_2", () => $512de23a1d0d4ccd$export$465e1e9058d0a33e);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_3", () => $512de23a1d0d4ccd$export$22cb3b19b9a67a4);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_4", () => $512de23a1d0d4ccd$export$639255389f81ee25);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_5", () => $512de23a1d0d4ccd$export$5420b6f468b681cb);
$parcel$export(module.exports, "PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_LAST", () => $512de23a1d0d4ccd$export$b51c0dd69192efcd);
$parcel$export(module.exports, "COLLECTIONS_CREATE_ROADMAP_SPOTLIGHT", () => $512de23a1d0d4ccd$export$1e3c409324b9e1c8);
$parcel$export(module.exports, "COLLECTIONS_CREATE_ROADMAP_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$960902aa280e7c02);
$parcel$export(module.exports, "CROSS_PROJECT_VIEW_TOUR_SPOTLIGHTS_STEP_1", () => $512de23a1d0d4ccd$export$a2cbd84444b19ad9);
$parcel$export(module.exports, "CROSS_PROJECT_VIEW_TOUR_SPOTLIGHTS_STEP_LAST", () => $512de23a1d0d4ccd$export$1ecd157040cc790b);
$parcel$export(module.exports, "NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$6e3db205cdfcc126);
$parcel$export(module.exports, "PRIORITIZATION_VIEW_TOUR_DISMISSED", () => $512de23a1d0d4ccd$export$2c379250399a65);
$parcel$export(module.exports, "ROADMAP_VIEW_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$6ec637a8d4b52e12);
$parcel$export(module.exports, "ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$4c25160b46095f67);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT", () => $512de23a1d0d4ccd$export$ec0f5ceae1abcc93);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$4aa206dd068119fd);
$parcel$export(module.exports, "ROADMAP_INTRODUCTION_SPOTLIGHT_PREREQUISITE_DISMISSALS", () => $512de23a1d0d4ccd$export$84d5c6b713e2a436);
$parcel$export(module.exports, "PRODUCT_START_TIMESTAMP", () => $512de23a1d0d4ccd$export$810ba1749ac4ea65);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS", () => $512de23a1d0d4ccd$export$bc58a8e989fbe3bc);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_1", () => $512de23a1d0d4ccd$export$414ec9dafc5e9628);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_2", () => $512de23a1d0d4ccd$export$a546fb30dcbeb6b5);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_3", () => $512de23a1d0d4ccd$export$dc3c81a11cac598);
$parcel$export(module.exports, "VIEW_CREATOR_TOUR_SPOTLIGHTS_STEP_4", () => $512de23a1d0d4ccd$export$620c0e8c369ed103);
$parcel$export(module.exports, "BLUEPRINTS_TOUR_SPOTLIGHTS", () => $512de23a1d0d4ccd$export$979841afe77608d2);
$parcel$export(module.exports, "BLUEPRINTS_TOUR_SPOTLIGHTS_STEP_1", () => $512de23a1d0d4ccd$export$54f2fcb05cde1625);
$parcel$export(module.exports, "BLUEPRINTS_TOUR_SPOTLIGHTS_STEP_2", () => $512de23a1d0d4ccd$export$61b8070a65644ed3);
$parcel$export(module.exports, "IMPORT_BULK_CREATE_ONBOARDING", () => $512de23a1d0d4ccd$export$e65d607810623c19);
$parcel$export(module.exports, "CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT", () => $512de23a1d0d4ccd$export$89ec57c839f38d47);
$parcel$export(module.exports, "CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED", () => $512de23a1d0d4ccd$export$d39bf566f27a11d7);
// User property names
const $512de23a1d0d4ccd$export$d4b65c1c7753dab5 = 'polaris.global-fields.go-to-project-spotlight-dismissed';
const $512de23a1d0d4ccd$export$5ca3ca33630ba93c = 'polaris.global-fields.tour-dismissed';
const $512de23a1d0d4ccd$export$a81698c00c65eb4a = 'polaris.project-fields.explore-section-message-dismissed';
const $512de23a1d0d4ccd$export$3085446206860099 = 'polaris.project-fields.seen-pulsating-fields-button';
const $512de23a1d0d4ccd$export$d32c1bbde6ae670d = 'polaris.project-fields.tour-dismissed';
const $512de23a1d0d4ccd$export$ca2e8a74c8b43637 = 'polaris.project-fields.page-viewed';
const $512de23a1d0d4ccd$export$c6877be73b5f3d5a = 'polaris.timeline.dates-config-section-message-dismissed';
const $512de23a1d0d4ccd$export$9a1ee3e31621d60 = 'polaris.collections.tour-dismissed';
const $512de23a1d0d4ccd$export$522f4dc72dc494f2 = 'polaris.premium.modal-dismissed';
const $512de23a1d0d4ccd$export$34f7000ddecc0e7f = 'polaris.premium.last-visit';
const $512de23a1d0d4ccd$export$1be797d9a57b42ac = 'polaris.cross-project-view.tour-dismissed';
const $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_LIST_FIELDS_DISMISSED = 'polaris.cross-project-view.list-fields-dismissed';
const $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_TIMELINE_FIELDS_DISMISSED = 'polaris.cross-project-view.timeline-fields-dismissed';
const $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_BOARD_FIELDS_DISMISSED = 'polaris.cross-project-view.board-fields-dismissed';
const $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_MATRIX_FIELDS_DISMISSED = 'polaris.cross-project-view.matrix-fields-dismissed';
const $512de23a1d0d4ccd$export$c176277d0ae24685 = 'listViewfieldsDismissed';
const $512de23a1d0d4ccd$export$dc14a417cdf40a4e = 'timelineViewfieldsDismissed';
const $512de23a1d0d4ccd$export$76d94539e8fefb4a = 'boardViewfieldsDismissed';
const $512de23a1d0d4ccd$export$c98b8b1065f15440 = 'matrixViewfieldsDismissed';
const $512de23a1d0d4ccd$export$61a0683bfb4060d7 = {
    [$512de23a1d0d4ccd$export$c176277d0ae24685]: $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_LIST_FIELDS_DISMISSED,
    [$512de23a1d0d4ccd$export$dc14a417cdf40a4e]: $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_TIMELINE_FIELDS_DISMISSED,
    [$512de23a1d0d4ccd$export$76d94539e8fefb4a]: $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_BOARD_FIELDS_DISMISSED,
    [$512de23a1d0d4ccd$export$c98b8b1065f15440]: $512de23a1d0d4ccd$var$CROSS_PROJECT_VIEW_MATRIX_FIELDS_DISMISSED
};
const $512de23a1d0d4ccd$export$34cb8e95f71c5026 = 'global-fields.tour.spotlights.step-1';
const $512de23a1d0d4ccd$export$7f842ac8d21dd77c = 'global-fields.tour.spotlights.step-2';
const $512de23a1d0d4ccd$export$bd207a2522aeeba4 = 'global-fields.tour.spotlights.step-3';
const $512de23a1d0d4ccd$export$204b6702ab1fae0e = 'global-fields.tour.spotlights.step-4';
const $512de23a1d0d4ccd$export$14b1ce7029803351 = 'global-fields.tour.spotlights.step-last';
const $512de23a1d0d4ccd$export$4aa3d2e1dc759f3c = 'global-fields.go-to-project.spotlight';
const $512de23a1d0d4ccd$export$c1ff7f4df78bdbc4 = 'project-fields.tour.spotlights.step-1';
const $512de23a1d0d4ccd$export$465e1e9058d0a33e = 'project-fields.tour.spotlights.step-2';
const $512de23a1d0d4ccd$export$22cb3b19b9a67a4 = 'project-fields.tour.spotlights.step-3';
const $512de23a1d0d4ccd$export$639255389f81ee25 = 'project-fields.tour.spotlights.step-4';
const $512de23a1d0d4ccd$export$5420b6f468b681cb = 'project-fields.tour.spotlights.step-5';
const $512de23a1d0d4ccd$export$b51c0dd69192efcd = 'project-fields.tour.spotlights.step-last';
const $512de23a1d0d4ccd$export$1e3c409324b9e1c8 = 'collections.create-roadmap.spotlight';
const $512de23a1d0d4ccd$export$960902aa280e7c02 = 'collections.create-roadmap.spotlight-dismissed';
const $512de23a1d0d4ccd$export$a2cbd84444b19ad9 = 'cross-project-view.tour.spotlights.step-1';
const $512de23a1d0d4ccd$export$1ecd157040cc790b = 'cross-project-view.tour.spotlights.step-last';
const $512de23a1d0d4ccd$export$f0a483c398048551 = 'jpd-nav-views.spotlight';
const $512de23a1d0d4ccd$export$6e3db205cdfcc126 = 'polaris.nav-jpd-views.spotlight-dismissed';
const $512de23a1d0d4ccd$export$6231ca46e95bc736 = 'prioritization-view.tour.spotlights.step-1';
const $512de23a1d0d4ccd$export$cd247efd7ec3525c = 'prioritization-view.tour.spotlights.step-last';
const $512de23a1d0d4ccd$export$2c379250399a65 = 'polaris.prioritization-view.tour-dismissed';
const $512de23a1d0d4ccd$export$3134ae340fb4ae39 = 'roadmap-view.spotlight';
const $512de23a1d0d4ccd$export$6ec637a8d4b52e12 = 'polaris.roadmap-view.spotlight-dismissed';
const $512de23a1d0d4ccd$export$10bda8c91e48ff2c = 'roadmap-view.column-config.spotlight';
const $512de23a1d0d4ccd$export$4c25160b46095f67 = 'polaris.roadmap-view.column-config-spotlight-dismissed';
const $512de23a1d0d4ccd$export$ec0f5ceae1abcc93 = 'roadmap.introduction.spotlight';
const $512de23a1d0d4ccd$export$4aa206dd068119fd = 'roadmap.introduction.spotlight.dismissed';
const $512de23a1d0d4ccd$export$ef2e4b0f650c3249 = 'roadmap-view.initial-prompt.spotlight';
const $512de23a1d0d4ccd$export$84d5c6b713e2a436 = [
    $512de23a1d0d4ccd$export$522f4dc72dc494f2,
    $512de23a1d0d4ccd$export$6e3db205cdfcc126
];
const $512de23a1d0d4ccd$export$810ba1749ac4ea65 = 'polaris.product-start-timestamp';
const $512de23a1d0d4ccd$export$bc58a8e989fbe3bc = 'polaris.view-creator.spotlight';
const $512de23a1d0d4ccd$export$414ec9dafc5e9628 = 'view-creator.tour.spotlights.step-1';
const $512de23a1d0d4ccd$export$a546fb30dcbeb6b5 = 'view-creator.tour.spotlights.step-2';
const $512de23a1d0d4ccd$export$dc3c81a11cac598 = 'view-creator.tour.spotlights.step-3';
const $512de23a1d0d4ccd$export$620c0e8c369ed103 = 'view-creator.tour.spotlights.step-4';
const $512de23a1d0d4ccd$export$979841afe77608d2 = 'polaris.blueprints.tour.spotlights';
const $512de23a1d0d4ccd$export$54f2fcb05cde1625 = `${$512de23a1d0d4ccd$export$979841afe77608d2}.step-1`;
const $512de23a1d0d4ccd$export$61b8070a65644ed3 = `${$512de23a1d0d4ccd$export$979841afe77608d2}.step-2`;
const $512de23a1d0d4ccd$export$ae0700c970c493ac = 'polaris.import.bulk-create.spotlight';
const $512de23a1d0d4ccd$export$e65d607810623c19 = 'polaris.import.bulk-create';
const $512de23a1d0d4ccd$export$89ec57c839f38d47 = 'polaris.custom-dates.customize.spotlight';
const $512de23a1d0d4ccd$export$d39bf566f27a11d7 = 'polaris.custom-dates.customize.spotlight-dismissed';

});

parcelRegister("gdBMj", function(module, exports) {

$parcel$export(module.exports, "RoadmapIntroductionSpotlight", () => $0da5bb5e44df65a0$export$71e9b7b9d410b300);

var $eJOHy = parcelRequire("eJOHy");

var $REcGP = parcelRequire("REcGP");

var $6SybE = parcelRequire("6SybE");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $9HHOs = parcelRequire("9HHOs");

var $83DiZ = parcelRequire("83DiZ");

var $8lgoE = parcelRequire("8lgoE");

var $4l17z = parcelRequire("4l17z");

var $4V76I = parcelRequire("4V76I");

var $a6k1J = parcelRequire("a6k1J");

var $cLtfY = parcelRequire("cLtfY");

var $fU6b0 = parcelRequire("fU6b0");
const $0da5bb5e44df65a0$export$71e9b7b9d410b300 = ({ collectionsUrl: collectionsUrl, placement: placement })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isLicensedUser = (0, $fU6b0.useIsLicensedUser)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const expandSideNav = (0, $6SybE.useExpandSideNav)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const isAlreadyInRoadmaps = window?.location.href.includes('roadmap');
    const { loadRoadmapIntroductionDismissed: loadRoadmapIntroductionDismissed, loadRoadmapIntroductionPrerequisiteDismissalsMet: loadRoadmapIntroductionPrerequisiteDismissalsMet, loadProductUsageStartTimestamp: loadProductUsageStartTimestamp, setRoadmapIntroductionDismissed: setRoadmapIntroductionDismissed } = (0, $4l17z.useOnboardingFlowsActions)();
    (0, $eJOHy.useEffect)(()=>{
        // we can prevent unnecessary calls in these cases
        if (isAlreadyInRoadmaps || !isLicensedUser) return;
        loadRoadmapIntroductionDismissed();
        loadRoadmapIntroductionPrerequisiteDismissalsMet();
        loadProductUsageStartTimestamp();
    }, [
        isAlreadyInRoadmaps,
        isLicensedUser,
        loadProductUsageStartTimestamp,
        loadRoadmapIntroductionDismissed,
        loadRoadmapIntroductionPrerequisiteDismissalsMet
    ]);
    const isIntroductionDismissed = (0, $4V76I.useCollectionsIntroductionDismissed)();
    const arePrerequisiteDismissalsMet = (0, $4V76I.useCollectionsIntroductionPrerequisiteDismissalsMet)();
    const productUsageStartTimestamp = (0, $a6k1J.useProductUsageStartTimestamp)();
    if (isAlreadyInRoadmaps || !isLicensedUser || isIntroductionDismissed === undefined || isIntroductionDismissed || !arePrerequisiteDismissalsMet || !(0, $fU6b0.checkIfOlderThanNDays)(productUsageStartTimestamp)) return null;
    const dismiss = (analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'dismiss');
        setRoadmapIntroductionDismissed();
    };
    const openRoadmaps = (analyticsEvent)=>{
        if (analyticsEvent) (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'openRoadmaps');
        else (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'openRoadmaps');
        setRoadmapIntroductionDismissed();
        push(collectionsUrl);
    };
    expandSideNav();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $REcGP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), {
        actions: [
            {
                onClick: (_, analyticsEvent)=>dismiss(analyticsEvent),
                text: formatMessage((0, $cLtfY.messages).dismiss),
                testId: 'roadmap-introduction-spotlight-dismiss-button'
            },
            {
                onClick: (_, analyticsEvent)=>openRoadmaps(analyticsEvent),
                text: formatMessage((0, $cLtfY.messages).giveItATry)
            }
        ],
        dialogPlacement: placement,
        dialogWidth: 275,
        target: (0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT),
        key: (0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT),
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetOnClick: (_event)=>openRoadmaps(),
        messageId: "polaris-lib-onboarding-flows.ui.collections.tour.roadmap-introduction-spotlight.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $cLtfY.messages).messageGalaxia : (0, $cLtfY.messages).message)));
};

});
parcelRegister("9HHOs", function(module, exports) {

$parcel$export(module.exports, "JiraSpotlight", () => $b2828503f90b4495$export$e209c6be9ab8c4f4);

var $eJOHy = parcelRequire("eJOHy");

var $dA96w = parcelRequire("dA96w");

var $SyPNn = parcelRequire("SyPNn");

var $b45q9 = parcelRequire("b45q9");
const $b2828503f90b4495$export$e209c6be9ab8c4f4 = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b45q9.ChoreographerSpotlight), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dA96w.default), rest);
};

});
parcelRegister("b45q9", function(module, exports) {

$parcel$export(module.exports, "ChoreographerSpotlight", () => $c0041397fe07e86b$export$e01943d134357d00);

var $dA96w = parcelRequire("dA96w");

var $1pkzT = parcelRequire("1pkzT");
const $c0041397fe07e86b$export$e01943d134357d00 = (0, $1pkzT.withChoreographedRender)((0, $dA96w.default));

});


parcelRegister("4l17z", function(module, exports) {

$parcel$export(module.exports, "useOnboardingFlowsActions", () => $8b28f138eeffe50d$export$e3d86ac85365138c);
$parcel$export(module.exports, "createHook", () => $8b28f138eeffe50d$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "OnboardingFlowsContainer", () => $8b28f138eeffe50d$export$214c4fcbf19b9a1d);

var $eJOHy = parcelRequire("eJOHy");

var $hZUwi = parcelRequire("hZUwi");

var $YvHeB = parcelRequire("YvHeB");

var $GtRbT = parcelRequire("GtRbT");

var $keeNI = parcelRequire("keeNI");

var $9dAsI = parcelRequire("9dAsI");
const $8b28f138eeffe50d$export$46c52354b8798e89 = (0, $GtRbT.createStore)({
    name: 'PolarisLibOnboardingFlowsStore',
    initialState: {
        containerProps: {
            accountId: undefined
        },
        productUsageStartTimestamp: undefined,
        globalFields: {
            goToProjectSpotlightDismissed: undefined,
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        projectFields: {
            exploreSectionMessageDismissed: undefined,
            seenPulsatingFieldsButton: undefined,
            tourDismissed: undefined,
            tourSpotlightStep: null,
            pageViewed: undefined
        },
        collections: {
            tourDismissed: undefined,
            tourSpotlightStep: null,
            introductionDismissed: undefined,
            introductionPrerequisiteDismissalsMet: undefined
        },
        crossProjectView: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        import: {
            spotlightDismissed: undefined,
            successNotificationViewed: undefined
        },
        timeline: {
            sectionMessageDismissed: undefined
        },
        allViews: {
            spotlightDismissed: undefined
        },
        prioritizationView: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        roadmapView: {
            spotlightDismissed: undefined,
            columnConfigSpotlightDismissed: undefined
        },
        viewCreator: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        blueprints: {
            tourDismissed: undefined,
            tourSpotlightStep: null
        },
        premium: {
            modalDismissed: undefined,
            lastVisit: {
                isPremium: undefined,
                updated: undefined
            },
            promise: (0, $keeNI.createDeferredPromise)()
        },
        customDates: {
            customizeSpotlightDismissed: undefined
        }
    },
    actions: $9dAsI.default
});
const { Container: $8b28f138eeffe50d$export$2e28a971a45925e3, useActions: $8b28f138eeffe50d$export$e3d86ac85365138c, createHook: $8b28f138eeffe50d$export$e7f733c8fc2b8a24, createHigherLevelHook: $8b28f138eeffe50d$export$757252247e722815 } = (0, $YvHeB.createJpdContainer)($8b28f138eeffe50d$export$46c52354b8798e89);
const $8b28f138eeffe50d$export$214c4fcbf19b9a1d = ({ accountId: accountId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hZUwi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b28f138eeffe50d$export$2e28a971a45925e3, {
        isGlobal: true,
        accountId: accountId
    }, children));

});
parcelRegister("YvHeB", function(module, exports) {

$parcel$export(module.exports, "createJpdContainer", () => $7499141d40d19115$export$7ed5db99dcc39128);

var $5PQOA = parcelRequire("5PQOA");

var $3degy = parcelRequire("3degy");

var $iJq0l = parcelRequire("iJq0l");

var $9bKio = parcelRequire("9bKio");
const $7499141d40d19115$var$createSelectorHook = (store, selector)=>{
    const innerHook = (0, $iJq0l.createHook)(store, {
        selector: (state)=>selector(state, state.containerProps)
    });
    return ()=>{
        const [val] = innerHook();
        return val;
    };
};
const $7499141d40d19115$export$757252247e722815 = (store, selectorCreator)=>{
    // TODO POL-2195 memoize one is not suitable for this task, as it will only memoize the last invocation. while this
    //               improves subsequent calls with the same argument set, it does not improve calls with different args
    //               this case should be solved with a generic memoization lib, e.g. reselect (4.1+) or moize
    //               discussion: https://hello.atlassian.net/wiki/spaces/TGR/pages/1416371989/Dependency+review+moize
    const memoizedSelectorCreator = (0, $3degy.cacheSelectorCreator)(selectorCreator);
    // TODO POL-2195 in the meantime, we can use lodash/memoize to at least solve the 1-ary case,
    //               which should be 99% of our selector creators anyway
    const monadicSelectorCreatorMemoized = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))(selectorCreator);
    const rssHook = (0, $iJq0l.createHook)(store, {
        selector: (state, args)=>{
            if (args.length <= 1) return monadicSelectorCreatorMemoized(...args)(state, state.containerProps);
            return memoizedSelectorCreator(...args)(state, state.containerProps);
        }
    });
    return (...args)=>{
        // @ts-expect-error - TS2345 - Argument of type 'SelectorCreatorArgs' is not assignable to parameter
        const [val] = rssHook(args);
        return val;
    };
};
const $7499141d40d19115$export$7ed5db99dcc39128 = (store, options)=>{
    const Container = (0, $9bKio.createContainerWithContext)(store, options);
    const useEmptyState = (0, $iJq0l.createHook)(store, {
        selector: null
    });
    const useActions = ()=>{
        const [, actions] = useEmptyState();
        return actions;
    };
    return {
        createHook: (selector)=>$7499141d40d19115$var$createSelectorHook(store, selector),
        createHigherLevelHook: (selectorCreator)=>$7499141d40d19115$export$757252247e722815(store, selectorCreator),
        useActions: useActions,
        Container: Container
    };
};

});
parcelRegister("3degy", function(module, exports) {

$parcel$export(module.exports, "cacheSelectorCreator", () => $5efa69f054078620$export$413433974f0869c3);
$parcel$export(module.exports, "getCacheValue", () => $5efa69f054078620$export$e15acfbd8ab989dd);
let $5efa69f054078620$var$cache = new WeakMap();
let $5efa69f054078620$var$jsonEqualityMap = new WeakMap();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5efa69f054078620$var$getValueFromJsonEqualityCache = (f, value, options)=>{
    if (options?.useJsonEquality !== true) return value;
    if (!$5efa69f054078620$var$jsonEqualityMap.has(f)) $5efa69f054078620$var$jsonEqualityMap.set(f, new Map());
    const storage = $5efa69f054078620$var$jsonEqualityMap.get(f);
    try {
        const key = JSON.stringify(value);
        if (storage.has(key)) return storage.get(key);
        storage.set(key, value);
    } catch  {
    // do nothing
    }
    return value;
};
function $5efa69f054078620$export$413433974f0869c3(f, options) {
    if (f.__isCachedSelectorCreator === true) return f;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cacheFunction = (...args)=>{
        if ($5efa69f054078620$var$cache.has(f)) {
            let lastNode = $5efa69f054078620$var$cache.get(f);
            for(let i = 0; i < args.length; i += 1){
                const value = $5efa69f054078620$var$getValueFromJsonEqualityCache(f, args[i], options);
                if (!lastNode.args.has(value)) {
                    lastNode = null;
                    break;
                }
                lastNode = lastNode.args.get(value);
            }
            if (lastNode?.selector) return lastNode.selector;
        }
        const maybeSelector = f(...args);
        if (typeof maybeSelector?.resultFunc === 'function' || typeof maybeSelector === 'function') {
            if (!$5efa69f054078620$var$cache.has(f)) $5efa69f054078620$var$cache.set(f, {
                args: new Map(),
                selector: null
            });
            let lastNode = $5efa69f054078620$var$cache.get(f);
            for(let i = 0; i < args.length; i += 1){
                const value = $5efa69f054078620$var$getValueFromJsonEqualityCache(f, args[i], options);
                if (!lastNode.args.has(value)) lastNode.args.set(value, {
                    args: new Map(),
                    selector: null
                });
                lastNode = lastNode.args.get(value);
            }
            lastNode.selector = maybeSelector;
        }
        return maybeSelector;
    };
    cacheFunction.__isCachedSelectorCreator = true;
    cacheFunction.__origin = f;
    cacheFunction.displayName = f.name || f.displayName;
    return cacheFunction;
}
const $5efa69f054078620$export$e2575ed62a2f107b = ()=>$5efa69f054078620$var$cache;
const $5efa69f054078620$export$e15acfbd8ab989dd = (key)=>$5efa69f054078620$var$cache.get(key);
const $5efa69f054078620$export$6e5dca841bdf93e3 = ()=>{
    $5efa69f054078620$var$cache = new WeakMap();
    $5efa69f054078620$var$jsonEqualityMap = new WeakMap();
};

});

parcelRegister("9bKio", function(module, exports) {

$parcel$export(module.exports, "createContainerWithContext", () => $5c9c76096353f4fd$export$ce6d80db779db7dc);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");

var $kBbPj = parcelRequire("kBbPj");
const $5c9c76096353f4fd$export$ce6d80db779db7dc = (store, options)=>(0, $6E16M.createContainer)(store, {
        ...options,
        onInit: ()=>(api, containerProps)=>{
                (0, $kBbPj.batchStateUpdates)(({ dispatch: dispatch, setState: setState }, props)=>{
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props
                    });
                    options?.onInit && dispatch(options.onInit());
                })(api, containerProps);
            },
        onUpdate: ()=>(api, containerProps)=>{
                (0, $kBbPj.batchStateUpdates)(({ dispatch: dispatch, setState: setState, getState: getState }, props)=>{
                    const prevContainerProps = getState().containerProps;
                    // @ts-expect-error - TS2345 - Argument of type '{ containerProps: TContainerProps; }' is not assignable to parameter of type 'Partial<TState>'.
                    setState({
                        containerProps: props,
                        prevContainerProps: prevContainerProps
                    });
                    options?.onUpdate && dispatch(options.onUpdate());
                })(api, containerProps);
            }
    });

});
parcelRegister("kBbPj", function(module, exports) {

$parcel$export(module.exports, "batchStateUpdates", () => $bb22704e5822629d$export$4f8b20404a906ca3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $bb22704e5822629d$export$4f8b20404a906ca3 = (cb)=>(api, containerProps)=>{
        let finalized = false;
        let localState = api.getState();
        const setState = (newState)=>{
            if (finalized) {
                api.setState(newState);
                return;
            }
            localState = {
                ...localState,
                ...newState
            };
        };
        const getState = ()=>finalized ? api.getState() : localState;
        const dispatch = (action)=>finalized ? action(api, containerProps) : action({
                dispatch: dispatch,
                setState: setState,
                getState: getState
            }, containerProps);
        const patchedApi = {
            setState: setState,
            getState: getState,
            dispatch: dispatch
        };
        cb(patchedApi, containerProps);
        finalized = true;
        api.setState({
            ...localState
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        localState = null;
    };

});



parcelRegister("keeNI", function(module, exports) {

$parcel$export(module.exports, "checkIfActivatedMoreThanFourDays", () => $a0445579fc070562$export$562701f849a0aba7);
$parcel$export(module.exports, "normalizeError", () => $a0445579fc070562$export$e7bd538fb0c5db1a);
$parcel$export(module.exports, "createDeferredPromise", () => $a0445579fc070562$export$87a845ded7190bfc);
$parcel$export(module.exports, "checkPrerequisiteDismissals", () => $a0445579fc070562$export$b20d00c7cb810f65);

var $ltT7m = parcelRequire("ltT7m");

var $FppkK = parcelRequire("FppkK");
const $a0445579fc070562$export$562701f849a0aba7 = (productUsageStartTimestamp)=>{
    const diffInDays = (0, $ltT7m.default)(new Date(), new Date(productUsageStartTimestamp));
    return diffInDays >= 4;
};
const $a0445579fc070562$export$e7bd538fb0c5db1a = (error)=>{
    if (error instanceof Error) return error;
    return new Error('Unknown error');
};
function $a0445579fc070562$export$87a845ded7190bfc() {
    // These will be properly initialized in the Promise constructor
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
const $a0445579fc070562$export$b20d00c7cb810f65 = async (prerequisiteDismissals, accountId)=>{
    if (!accountId) return;
    const prerequisiteDismissalsPromises = prerequisiteDismissals.map((prerequisite)=>{
        return (0, $FppkK.getUserProperty)(accountId, prerequisite);
    });
    return Promise.all(prerequisiteDismissalsPromises);
};

});

parcelRegister("9dAsI", function(module, exports) {

$parcel$export(module.exports, "default", () => $86ee4bbffd878936$export$2e2bcd8739ae039);

var $4cu2f = parcelRequire("4cu2f");

var $4wy8S = parcelRequire("4wy8S");

var $44DL8 = parcelRequire("44DL8");

var $pSAW0 = parcelRequire("pSAW0");

var $eEmTF = parcelRequire("eEmTF");

var $i0Ba0 = parcelRequire("i0Ba0");

var $kGCNw = parcelRequire("kGCNw");

var $5kTW7 = parcelRequire("5kTW7");

var $1E16I = parcelRequire("1E16I");

var $iUnS8 = parcelRequire("iUnS8");

var $1mj6M = parcelRequire("1mj6M");

var $brsgS = parcelRequire("brsgS");

var $2t7P4 = parcelRequire("2t7P4");

var $1BMqo = parcelRequire("1BMqo");

var $k2Yjr = parcelRequire("k2Yjr");

var $88hWw = parcelRequire("88hWw");

var $2atAT = parcelRequire("2atAT");

var $luGqn = parcelRequire("luGqn");

var $aCR1B = parcelRequire("aCR1B");

var $efRp8 = parcelRequire("efRp8");

var $80clw = parcelRequire("80clw");

var $2QyGs = parcelRequire("2QyGs");

var $8iz9g = parcelRequire("8iz9g");

var $2Ir1d = parcelRequire("2Ir1d");
const $86ee4bbffd878936$var$actions = {
    loadProductUsageStartTimestamp: $2QyGs.loadProductUsageStartTimestamp,
    loadGoToProjectSpotlightDismissed: $kGCNw.loadGoToProjectSpotlightDismissed,
    setGoToProjectSpotlightDismissed: $kGCNw.setGoToProjectSpotlightDismissed,
    setGlobalFieldsTourSpotlightStep: $5kTW7.setGlobalFieldsTourSpotlightStep,
    loadGlobalFieldsTourDismissed: $1E16I.loadGlobalFieldsTourDismissed,
    setGlobalFieldsTourDismissed: $1E16I.setGlobalFieldsTourDismissed,
    loadExploreSectionMessageDismissed: $iUnS8.loadExploreSectionMessageDismissed,
    setExploreSectionMessageDismissed: $iUnS8.setExploreSectionMessageDismissed,
    loadProjectFieldsPageViewed: $1mj6M.loadProjectFieldsPageViewed,
    setProjectFieldsPageViewed: $1mj6M.setProjectFieldsPageViewed,
    loadSeenPulsatingFieldsButton: $brsgS.loadSeenPulsatingFieldsButton,
    setSeenPulsatingFieldsButton: $brsgS.setSeenPulsatingFieldsButton,
    loadProjectFieldsTourDismissed: $1BMqo.loadProjectFieldsTourDismissed,
    setProjectFieldsTourDismissed: $1BMqo.setProjectFieldsTourDismissed,
    setProjectFieldsTourSpotlightStep: $2t7P4.setProjectFieldsTourSpotlightStep,
    loadCollectionsTourDismissed: $4wy8S.loadCollectionsTourDismissed,
    loadRoadmapIntroductionPrerequisiteDismissalsMet: $i0Ba0.loadRoadmapIntroductionPrerequisiteDismissalsMet,
    setCollectionsTourDismissed: $4wy8S.setCollectionsTourDismissed,
    setCollectionsTourSpotlightStep: $4cu2f.setCollectionsTourSpotlightStep,
    loadRoadmapIntroductionDismissed: $i0Ba0.loadRoadmapIntroductionDismissed,
    setRoadmapIntroductionDismissed: $i0Ba0.setRoadmapIntroductionDismissed,
    loadCrossProjectViewTourDismissed: $eEmTF.loadCrossProjectViewTourDismissed,
    setCrossProjectViewTourDismissed: $eEmTF.setCrossProjectViewTourDismissed,
    setCrossProjectViewTourSpotlightStep: $pSAW0.setCrossProjectViewTourSpotlightStep,
    loadTimelineSectionMessageDismissed: $k2Yjr.loadTimelineSectionMessageDismissed,
    setTimelineSectionMessageDismissed: $k2Yjr.setTimelineSectionMessageDismissed,
    loadCrossProjectViewFieldsDismissed: $44DL8.loadCrossProjectViewFieldsDismissed,
    setCrossProjectViewFieldsDismissed: $44DL8.setCrossProjectViewFieldsDismissed,
    loadAllViewsSpotlightDismissed: $88hWw.loadAllViewsSpotlightDismissed,
    setAllViewsSpotlightDismissed: $88hWw.setAllViewsSpotlightDismissed,
    loadRoadmapViewSpotlightDismissed: $luGqn.loadRoadmapViewSpotlightDismissed,
    setRoadmapViewSpotlightDismissed: $luGqn.setRoadmapViewSpotlightDismissed,
    loadRoadmapColumnConfigSpotlightDismissed: $luGqn.loadRoadmapColumnConfigSpotlightDismissed,
    setRoadmapColumnConfigSpotlightDismissed: $luGqn.setRoadmapColumnConfigSpotlightDismissed,
    loadPrioritizationViewTourDismissed: $2atAT.loadPrioritizationViewTourDismissed,
    setPrioritizationViewTourDismissed: $2atAT.setPrioritizationViewTourDismissed,
    setPrioritizationViewTourSpotlightStep: $2atAT.setPrioritizationViewTourSpotlightStep,
    setViewCreatorSpotlightDismissed: $aCR1B.setViewCreatorSpotlightDismissed,
    setViewCreatorSpotlightTourStep: $aCR1B.setViewCreatorSpotlightTourStep,
    loadViewCreatorSpotlightState: $aCR1B.loadViewCreatorSpotlightState,
    setBlueprintsTourDismissed: $efRp8.setBlueprintsTourDismissed,
    setBlueprintsTourStep: $efRp8.setBlueprintsTourStep,
    loadBlueprintsState: $efRp8.loadBlueprintsState,
    loadPremiumLastVisit: $80clw.loadPremiumLastVisit,
    loadPremiumModalDismissed: $80clw.loadPremiumModalDismissed,
    setPremiumLastVisit: $80clw.setPremiumLastVisit,
    setPremiumModalDismissed: $80clw.setPremiumModalDismissed,
    loadCustomDatesCustomizeSpotlightDismissed: $8iz9g.loadCustomDatesCustomizeSpotlightDismissed,
    setCustomDatesCustomizeSpotlightDismissed: $8iz9g.setCustomDatesCustomizeSpotlightDismissed,
    unlockOnboardingFlow: $80clw.unlockOnboardingFlow,
    loadImportState: $2Ir1d.loadImportState,
    setImportSpotlightDismissed: $2Ir1d.setImportSpotlightDismissed,
    setSuccessNotificationViewed: $2Ir1d.setSuccessNotificationViewed
};
var $86ee4bbffd878936$export$2e2bcd8739ae039 = $86ee4bbffd878936$var$actions;

});
parcelRegister("4cu2f", function(module, exports) {

$parcel$export(module.exports, "setCollectionsTourSpotlightStep", () => $337ddd2af5646587$export$501a98d23141dc4d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $337ddd2af5646587$export$501a98d23141dc4d = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("4wy8S", function(module, exports) {

$parcel$export(module.exports, "loadCollectionsTourDismissed", () => $8bfed876c1634222$export$c7e2395278267e1d);
$parcel$export(module.exports, "setCollectionsTourDismissed", () => $8bfed876c1634222$export$2a7240b702e8d617);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $8bfed876c1634222$export$c7e2395278267e1d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().collections.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.COLLECTIONS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                collections: {
                    ...state.collections,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    collections: {
                        ...state.collections,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $8lgoE.COLLECTIONS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().collections.tourDismissed;
    };
const $8bfed876c1634222$export$2a7240b702e8d617 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                tourDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.COLLECTIONS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $8lgoE.COLLECTIONS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});
parcelRegister("6Yd06", function(module, exports) {

$parcel$export(module.exports, "logSafeErrorWithoutCustomerDataWrapper", () => $010050cb32520e49$export$ebd6466ba18b2f3a);

var $eSnSE = parcelRequire("eSnSE");

var $7jTnu = parcelRequire("7jTnu");

var $1uIew = parcelRequire("1uIew");




const $010050cb32520e49$export$ebd6466ba18b2f3a = async (location, message, event)=>{
    const modifiedEvent = event;
    if ((0, $7jTnu.fg)('jpd_sentry_fetch_error_fix')) {
        if (modifiedEvent instanceof (0, $1uIew.default) && modifiedEvent.originalResponse && // We can't guarantee that response object is always in unread state when we try to log it
        !modifiedEvent.originalResponse?.bodyUsed) {
            const originalResponseText = await modifiedEvent.originalResponse.text();
            modifiedEvent.message = `${modifiedEvent.message} - ${originalResponseText}`;
            delete modifiedEvent.originalResponse;
        }
    } else if (modifiedEvent instanceof (0, $1uIew.default) && modifiedEvent.originalResponse) {
        const originalResponseText = await modifiedEvent.originalResponse.text();
        modifiedEvent.message = `${modifiedEvent.message} - ${originalResponseText}`;
        delete modifiedEvent.originalResponse;
    }
    (0, $eSnSE.default).safeErrorWithoutCustomerData(location, message, modifiedEvent);
    // Returning the modified error so the original response text can be used in the error handler
    return modifiedEvent;
};

});

parcelRegister("4y7gv", function(module, exports) {

$parcel$export(module.exports, "maybeWaitForPremiumModal", () => $15fa1fe3cb150362$export$b797d1ff3b371e8a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $15fa1fe3cb150362$export$b797d1ff3b371e8a = async (getState)=>{
    // Await the resolution of the deferred promise associated with the premium modal.
    // This ensures that the premium modal has either never been displayed or has already been closed.
    // This mechanism allows for seamless orchestration of all spotlights within a single package,
    // ensuring they are postponed until the premium modal can be displayed and is dismissed.
    // Treat this similar to the `!accountId`, as every loading action
    // in the `onboarding-flow` package should incorporate this check.
    await getState().premium.promise.promise;
};

});


parcelRegister("44DL8", function(module, exports) {

$parcel$export(module.exports, "loadCrossProjectViewFieldsDismissed", () => $c0a2d5af7a4e4247$export$e6e8b16aaeac983b);
$parcel$export(module.exports, "setCrossProjectViewFieldsDismissed", () => $c0a2d5af7a4e4247$export$2468c71857d0e133);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $c0a2d5af7a4e4247$export$e6e8b16aaeac983b = (viewKindStateKey)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().crossProjectView[viewKindStateKey] === 'boolean') return;
        const userProperty = (0, $8lgoE.USER_PROPERTY_BY_STATE_KEY)[viewKindStateKey];
        try {
            const viewfieldsDismissed = await (0, $FppkK.getUserProperty)(accountId, userProperty);
            const state = getState();
            setState({
                ...state,
                crossProjectView: {
                    ...state.crossProjectView,
                    [viewKindStateKey]: viewfieldsDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    crossProjectView: {
                        ...state.crossProjectView,
                        [viewKindStateKey]: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)(userProperty, `Failed to get user property with key: ${userProperty}`, error instanceof Error ? error : undefined);
        }
        return getState().crossProjectView[viewKindStateKey];
    };
const $c0a2d5af7a4e4247$export$2468c71857d0e133 = (viewKindStateKey)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                [viewKindStateKey]: true
            }
        });
        const userProperty = (0, $8lgoE.USER_PROPERTY_BY_STATE_KEY)[viewKindStateKey];
        try {
            await (0, $FppkK.setUserProperties)(accountId, userProperty, 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)(userProperty, `Failed to set user property with key: ${userProperty}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("pSAW0", function(module, exports) {

$parcel$export(module.exports, "setCrossProjectViewTourSpotlightStep", () => $5278fe8d5b2abd77$export$7e29b1ed314f9b12);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $5278fe8d5b2abd77$export$7e29b1ed314f9b12 = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("eEmTF", function(module, exports) {

$parcel$export(module.exports, "loadCrossProjectViewTourDismissed", () => $ad3986fdda27241d$export$24c1a2fce44090f2);
$parcel$export(module.exports, "setCrossProjectViewTourDismissed", () => $ad3986fdda27241d$export$d25b2932701a97e6);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $ad3986fdda27241d$export$24c1a2fce44090f2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().crossProjectView.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.CROSS_PROJECT_VIEW_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                crossProjectView: {
                    ...state.crossProjectView,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    crossProjectView: {
                        ...state.crossProjectView,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $8lgoE.CROSS_PROJECT_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().crossProjectView.tourDismissed;
    };
const $ad3986fdda27241d$export$d25b2932701a97e6 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            crossProjectView: {
                ...state.crossProjectView,
                tourDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.CROSS_PROJECT_VIEW_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $8lgoE.CROSS_PROJECT_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("i0Ba0", function(module, exports) {

$parcel$export(module.exports, "loadRoadmapIntroductionDismissed", () => $e751a19bbce1b2fa$export$1a7b263d41622a5b);
$parcel$export(module.exports, "loadRoadmapIntroductionPrerequisiteDismissalsMet", () => $e751a19bbce1b2fa$export$de983a99630cdc7d);
$parcel$export(module.exports, "setRoadmapIntroductionDismissed", () => $e751a19bbce1b2fa$export$19c464c17f9739ab);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");

var $keeNI = parcelRequire("keeNI");
const $e751a19bbce1b2fa$export$1a7b263d41622a5b = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().collections.introductionDismissed === 'boolean') return;
        try {
            const introductionDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                collections: {
                    ...state.collections,
                    introductionDismissed: introductionDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    collections: {
                        ...state.collections,
                        introductionDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to get user property with key: ${(0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().collections.introductionDismissed;
    };
const $e751a19bbce1b2fa$export$de983a99630cdc7d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        let dismissals = [];
        try {
            dismissals = await (0, $keeNI.checkPrerequisiteDismissals)((0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT_PREREQUISITE_DISMISSALS), accountId);
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.prerequisites', 'Failed to get user properties for roadmap introduction spotlight prerequisites', error instanceof Error ? error : undefined);
        }
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                introductionPrerequisiteDismissalsMet: dismissals?.every((dismissal)=>dismissal) ?? false
            }
        });
        return getState().collections.introductionPrerequisiteDismissalsMet;
    };
const $e751a19bbce1b2fa$export$19c464c17f9739ab = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            collections: {
                ...state.collections,
                introductionDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to set user property with key: ${(0, $8lgoE.ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("kGCNw", function(module, exports) {

$parcel$export(module.exports, "loadGoToProjectSpotlightDismissed", () => $7e92ee6e9ce54663$export$4c8d16771ecf8930);
$parcel$export(module.exports, "setGoToProjectSpotlightDismissed", () => $7e92ee6e9ce54663$export$3ea7a545c4faccd4);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $7e92ee6e9ce54663$export$4c8d16771ecf8930 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().globalFields.goToProjectSpotlightDismissed === 'boolean') return;
        try {
            const goToProjectSpotlightDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.GO_TO_PROJECT_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                globalFields: {
                    ...state.globalFields,
                    goToProjectSpotlightDismissed: goToProjectSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    globalFields: {
                        ...state.globalFields,
                        goToProjectSpotlightDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.go-to-project-spotlight', `Failed to get user property with key: ${(0, $8lgoE.GO_TO_PROJECT_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $7e92ee6e9ce54663$export$3ea7a545c4faccd4 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                goToProjectSpotlightDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.GO_TO_PROJECT_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.go-to-project-spotlight', `Failed to set user property with key: ${(0, $8lgoE.GO_TO_PROJECT_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("5kTW7", function(module, exports) {

$parcel$export(module.exports, "setGlobalFieldsTourSpotlightStep", () => $74e9f8408e6aebf6$export$71a13f0fff467880);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $74e9f8408e6aebf6$export$71a13f0fff467880 = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("1E16I", function(module, exports) {

$parcel$export(module.exports, "loadGlobalFieldsTourDismissed", () => $31cd8322bb9c2805$export$6dbef36cf5394497);
$parcel$export(module.exports, "setGlobalFieldsTourDismissed", () => $31cd8322bb9c2805$export$7ddbf8611b7a51e2);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $31cd8322bb9c2805$export$6dbef36cf5394497 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().globalFields.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.GLOBAL_FIELDS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                globalFields: {
                    ...state.globalFields,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    globalFields: {
                        ...state.globalFields,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.tour', `Failed to get user property with key: ${(0, $8lgoE.GLOBAL_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $31cd8322bb9c2805$export$7ddbf8611b7a51e2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            globalFields: {
                ...state.globalFields,
                tourDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.GLOBAL_FIELDS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.global-fields.tour', `Failed to set user property with key: ${(0, $8lgoE.GLOBAL_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("iUnS8", function(module, exports) {

$parcel$export(module.exports, "loadExploreSectionMessageDismissed", () => $b6ca0042c14d53cf$export$178c75cc028231a2);
$parcel$export(module.exports, "setExploreSectionMessageDismissed", () => $b6ca0042c14d53cf$export$994e754bbe4537c1);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $b6ca0042c14d53cf$export$178c75cc028231a2 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.exploreSectionMessageDismissed === 'boolean') return;
        try {
            const exploreSectionMessageDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.EXPLORE_SECTION_MESSAGE_DISMISSED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    exploreSectionMessageDismissed: exploreSectionMessageDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        exploreSectionMessageDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.explore-section-message', `Failed to get user property with key: ${(0, $8lgoE.EXPLORE_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $b6ca0042c14d53cf$export$994e754bbe4537c1 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                exploreSectionMessageDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.EXPLORE_SECTION_MESSAGE_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.explore-section-message', `Failed to set user property with key: ${(0, $8lgoE.EXPLORE_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("1mj6M", function(module, exports) {

$parcel$export(module.exports, "loadProjectFieldsPageViewed", () => $92e44813ece466e3$export$2932bbb803f6ab52);
$parcel$export(module.exports, "setProjectFieldsPageViewed", () => $92e44813ece466e3$export$5425efd17972eca4);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $92e44813ece466e3$export$2932bbb803f6ab52 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.pageViewed === 'boolean') return;
        try {
            const pageViewed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.PROJECT_FIELDS_PAGE_VIEWED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    pageViewed: pageViewed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        pageViewed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.page-viewed', `Failed to get user property with key: ${(0, $8lgoE.PROJECT_FIELDS_PAGE_VIEWED)}`, error instanceof Error ? error : undefined);
        }
    };
const $92e44813ece466e3$export$5425efd17972eca4 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                pageViewed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.PROJECT_FIELDS_PAGE_VIEWED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.page-viewed', `Failed to set user property with key: ${(0, $8lgoE.PROJECT_FIELDS_PAGE_VIEWED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("brsgS", function(module, exports) {

$parcel$export(module.exports, "loadSeenPulsatingFieldsButton", () => $bba4b2cb8118275c$export$4248149cb54f9a58);
$parcel$export(module.exports, "setSeenPulsatingFieldsButton", () => $bba4b2cb8118275c$export$ef1450ffea0c5a63);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $bba4b2cb8118275c$export$4248149cb54f9a58 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.seenPulsatingFieldsButton === 'boolean') return;
        try {
            const seenPulsatingFieldsButton = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.SEEN_PULSATING_FIELDS_BUTTON));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    seenPulsatingFieldsButton: seenPulsatingFieldsButton
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        seenPulsatingFieldsButton: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.pulsating-fields-button', `Failed to get user property with key: ${(0, $8lgoE.SEEN_PULSATING_FIELDS_BUTTON)}`, error instanceof Error ? error : undefined);
        }
    };
const $bba4b2cb8118275c$export$ef1450ffea0c5a63 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                seenPulsatingFieldsButton: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.SEEN_PULSATING_FIELDS_BUTTON), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.pulsating-fields-button', `Failed to set user property with key: ${(0, $8lgoE.SEEN_PULSATING_FIELDS_BUTTON)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("2t7P4", function(module, exports) {

$parcel$export(module.exports, "setProjectFieldsTourSpotlightStep", () => $ab42590d16599840$export$a6b8eee670a4eb2f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $ab42590d16599840$export$a6b8eee670a4eb2f = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("1BMqo", function(module, exports) {

$parcel$export(module.exports, "loadProjectFieldsTourDismissed", () => $1bbcc7a51fb67314$export$9be5e6fba10e92ef);
$parcel$export(module.exports, "setProjectFieldsTourDismissed", () => $1bbcc7a51fb67314$export$2ad2aec3cf81b681);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $1bbcc7a51fb67314$export$9be5e6fba10e92ef = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().projectFields.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.PROJECT_FIELDS_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                projectFields: {
                    ...state.projectFields,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    projectFields: {
                        ...state.projectFields,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to get user property with key: ${(0, $8lgoE.PROJECT_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $1bbcc7a51fb67314$export$2ad2aec3cf81b681 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            projectFields: {
                ...state.projectFields,
                tourDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.PROJECT_FIELDS_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.project-fields.tour', `Failed to set user property with key: ${(0, $8lgoE.PROJECT_FIELDS_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("k2Yjr", function(module, exports) {

$parcel$export(module.exports, "loadTimelineSectionMessageDismissed", () => $0de0ee4c7481d644$export$85213c72021b1243);
$parcel$export(module.exports, "setTimelineSectionMessageDismissed", () => $0de0ee4c7481d644$export$f5452ae8fa9e3836);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $0de0ee4c7481d644$export$85213c72021b1243 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().timeline.sectionMessageDismissed === 'boolean') return;
        try {
            const timelineSectionMessageDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED));
            const state = getState();
            setState({
                ...state,
                timeline: {
                    sectionMessageDismissed: timelineSectionMessageDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    timeline: {
                        sectionMessageDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.spotlight', `Failed to get user property with key: ${(0, $8lgoE.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $0de0ee4c7481d644$export$f5452ae8fa9e3836 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            timeline: {
                sectionMessageDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.timeline.spotlight', `Failed to set user property with key: ${(0, $8lgoE.TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("88hWw", function(module, exports) {

$parcel$export(module.exports, "loadAllViewsSpotlightDismissed", () => $959017c40970db3b$export$73f482a9822cc952);
$parcel$export(module.exports, "setAllViewsSpotlightDismissed", () => $959017c40970db3b$export$84df3d965709961e);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $959017c40970db3b$export$73f482a9822cc952 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().allViews.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                allViews: {
                    ...state.allViews,
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    allViews: {
                        ...state.allViews,
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to get user property with key: ${(0, $8lgoE.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $959017c40970db3b$export$84df3d965709961e = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            allViews: {
                ...state.allViews,
                spotlightDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to set user property with key: ${(0, $8lgoE.NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };

});

parcelRegister("2atAT", function(module, exports) {

$parcel$export(module.exports, "loadPrioritizationViewTourDismissed", () => $31e722a54000eaf1$export$f610fdf8823d3e34);
$parcel$export(module.exports, "setPrioritizationViewTourDismissed", () => $31e722a54000eaf1$export$a72bdc987d4b2c7d);
$parcel$export(module.exports, "setPrioritizationViewTourSpotlightStep", () => $31e722a54000eaf1$export$a76ccd1e602a886c);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $31e722a54000eaf1$export$f610fdf8823d3e34 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().prioritizationView.tourDismissed === 'boolean') return;
        try {
            const tourDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.PRIORITIZATION_VIEW_TOUR_DISMISSED));
            const state = getState();
            setState({
                ...state,
                prioritizationView: {
                    ...state.prioritizationView,
                    tourDismissed: tourDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    prioritizationView: {
                        ...state.prioritizationView,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.prioritization-view.tour', `Failed to get user property with key: ${(0, $8lgoE.PRIORITIZATION_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $31e722a54000eaf1$export$a72bdc987d4b2c7d = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            prioritizationView: {
                ...state.prioritizationView,
                tourDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.PRIORITIZATION_VIEW_TOUR_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.prioritization-view.tour', `Failed to set user property with key: ${(0, $8lgoE.PRIORITIZATION_VIEW_TOUR_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $31e722a54000eaf1$export$a76ccd1e602a886c = (step)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            prioritizationView: {
                ...state.prioritizationView,
                tourSpotlightStep: step
            }
        });
    };

});

parcelRegister("luGqn", function(module, exports) {

$parcel$export(module.exports, "loadRoadmapViewSpotlightDismissed", () => $c53ea0c719db929a$export$7efa8325e0de15f);
$parcel$export(module.exports, "setRoadmapViewSpotlightDismissed", () => $c53ea0c719db929a$export$b55083c189662aa5);
$parcel$export(module.exports, "loadRoadmapColumnConfigSpotlightDismissed", () => $c53ea0c719db929a$export$9e6f136ba325b100);
$parcel$export(module.exports, "setRoadmapColumnConfigSpotlightDismissed", () => $c53ea0c719db929a$export$866ee7083694a75f);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $c53ea0c719db929a$export$7efa8325e0de15f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().roadmapView.spotlightDismissed === 'boolean') return;
        try {
            const spotlightDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.ROADMAP_VIEW_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                roadmapView: {
                    ...state.roadmapView,
                    spotlightDismissed: spotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    roadmapView: {
                        ...state.roadmapView,
                        spotlightDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-spotlight', `Failed to get user property with key: ${(0, $8lgoE.ROADMAP_VIEW_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $c53ea0c719db929a$export$b55083c189662aa5 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            roadmapView: {
                ...state.roadmapView,
                spotlightDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.ROADMAP_VIEW_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-spotlight', `Failed to set user property with key: ${(0, $8lgoE.ROADMAP_VIEW_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $c53ea0c719db929a$export$9e6f136ba325b100 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().roadmapView.columnConfigSpotlightDismissed === 'boolean') return;
        try {
            const columnConfigSpotlightDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                roadmapView: {
                    ...state.roadmapView,
                    columnConfigSpotlightDismissed: columnConfigSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    roadmapView: {
                        ...state.roadmapView,
                        columnConfigSpotlightDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.all-views-spotlight', `Failed to get user property with key: ${(0, $8lgoE.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $c53ea0c719db929a$export$866ee7083694a75f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            roadmapView: {
                ...state.roadmapView,
                columnConfigSpotlightDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmap-view-column-config-spotlight', `Failed to set user property with key: ${(0, $8lgoE.ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };

});

parcelRegister("aCR1B", function(module, exports) {

$parcel$export(module.exports, "loadViewCreatorSpotlightState", () => $0e81337bd100462e$export$9a1628c8a6cce5a8);
$parcel$export(module.exports, "setViewCreatorSpotlightTourStep", () => $0e81337bd100462e$export$55b6ef0c08b2c8bc);
$parcel$export(module.exports, "setViewCreatorSpotlightDismissed", () => $0e81337bd100462e$export$b883437f952d9bab);

var $k4x9q = parcelRequire("k4x9q");

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $gYnSx = parcelRequire("gYnSx");

var $7e8wG = parcelRequire("7e8wG");

var $4y7gv = parcelRequire("4y7gv");

var $8lgoE = parcelRequire("8lgoE");

var $keeNI = parcelRequire("keeNI");
const $0e81337bd100462e$export$9a1628c8a6cce5a8 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().viewCreator.tourDismissed === 'boolean') return;
        try {
            const remoteState = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.VIEW_CREATOR_TOUR_SPOTLIGHTS));
            const state = getState();
            setState({
                ...state,
                viewCreator: {
                    ...state.viewCreator,
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($k4x9q)))(remoteState, {
                        tourSpotlightStep: null,
                        tourDismissed: false
                    })
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    viewCreator: {
                        ...state.viewCreator,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.view-creator-spotlight', `Failed to get user property with key: ${(0, $8lgoE.VIEW_CREATOR_TOUR_SPOTLIGHTS)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $0e81337bd100462e$export$55b6ef0c08b2c8bc = (step)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newViewCreatorState = {
            ...state.viewCreator,
            tourSpotlightStep: step
        };
        setState({
            ...state,
            viewCreator: newViewCreatorState
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.VIEW_CREATOR_TOUR_SPOTLIGHTS), JSON.stringify(newViewCreatorState));
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.onboarding.view-creator-spotlight', (0, $keeNI.normalizeError)(error)));
        }
    };
const $0e81337bd100462e$export$b883437f952d9bab = (tourDismissed = true)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newViewCreatorState = {
            ...state.viewCreator,
            tourDismissed: tourDismissed
        };
        setState({
            ...state,
            viewCreator: newViewCreatorState
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.VIEW_CREATOR_TOUR_SPOTLIGHTS), JSON.stringify(newViewCreatorState));
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.onboarding.view-creator-spotlight', (0, $keeNI.normalizeError)(error)));
        }
    };

});
parcelRegister("k4x9q", function(module, exports) {

var $euhRr = parcelRequire("euhRr");

var $l76qh = parcelRequire("l76qh");

var $1sE4t = parcelRequire("1sE4t");

var $16aVR = parcelRequire("16aVR");
/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */ var $e9cde5728a228935$var$defaultsDeep = $l76qh(function(args) {
    args.push(undefined, $1sE4t);
    return $euhRr($16aVR, undefined, args);
});
module.exports = $e9cde5728a228935$var$defaultsDeep;

});
parcelRegister("1sE4t", function(module, exports) {

var $9AWD2 = parcelRequire("9AWD2");

var $546O5 = parcelRequire("546O5");
/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */ function $11077d499fdbf4a3$var$customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if ($546O5(objValue) && $546O5(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        $9AWD2(objValue, srcValue, undefined, $11077d499fdbf4a3$var$customDefaultsMerge, stack);
        stack['delete'](srcValue);
    }
    return objValue;
}
module.exports = $11077d499fdbf4a3$var$customDefaultsMerge;

});

parcelRegister("16aVR", function(module, exports) {

var $9AWD2 = parcelRequire("9AWD2");

var $kBNXn = parcelRequire("kBNXn");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $0cced4e66601137e$var$mergeWith = $kBNXn(function(object, source, srcIndex, customizer) {
    $9AWD2(object, source, srcIndex, customizer);
});
module.exports = $0cced4e66601137e$var$mergeWith;

});


parcelRegister("7e8wG", function(module, exports) {

$parcel$export(module.exports, "createErrorAnalytics", () => $85bd9b8631bfa06e$export$9841879b4fea885b);
$parcel$export(module.exports, "useErrorHandlers", () => $85bd9b8631bfa06e$export$e0b4869c7401cacb);
$parcel$export(module.exports, "useOnCyclicFormulaFieldError", () => $85bd9b8631bfa06e$export$4e01d30cacaf82b8);

var $eJOHy = parcelRequire("eJOHy");

var $Svlt9 = parcelRequire("Svlt9");

var $6alcT = parcelRequire("6alcT");

var $epTsa = parcelRequire("epTsa");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");

var $6x8n3 = parcelRequire("6x8n3");

var $fljS9 = parcelRequire("fljS9");

var $95Ew5 = parcelRequire("95Ew5");

var $fVlmn = parcelRequire("fVlmn");
const $85bd9b8631bfa06e$export$9841879b4fea885b = (id, error, options)=>({
        meta: {
            id: id
        },
        error: error,
        sendToPrivacyUnsafeSplunk: options?.sendToPrivacyUnsafeSplunk ?? true,
        skipSentry: options?.skipSentry ?? false
    });
const $85bd9b8631bfa06e$var$handleCallback = (errorObject, callback)=>{
    callback && callback((0, $fVlmn.getMetadata)(errorObject));
};
const $85bd9b8631bfa06e$var$useGeneralDataLoadingFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $6x8n3.useNotifications)();
    return (0, $eJOHy.useCallback)((errorObject, callback)=>{
        $85bd9b8631bfa06e$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).serverLoadFailedDescription)
        });
        (0, $gYnSx.default)($85bd9b8631bfa06e$export$9841879b4fea885b('polaris.error.generalDataLoadingFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $85bd9b8631bfa06e$var$useGeneralDataUpdateFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { error: error, errorWithRefresh: errorWithRefresh, customFlag: customFlag } = (0, $6x8n3.useNotifications)();
    return (0, $eJOHy.useCallback)((errorObject, callback)=>{
        $85bd9b8631bfa06e$var$handleCallback(errorObject, callback);
        (0, $gYnSx.default)($85bd9b8631bfa06e$export$9841879b4fea885b('polaris.error.generalDataUpdateFailed', errorObject));
        const entityLimitError = (0, $fljS9.getEntityLimitError)(errorObject);
        if (entityLimitError) {
            const errorMessage = (0, $fljS9.getErrorMessageDescriptor)(entityLimitError);
            return errorMessage ? customFlag({
                title: formatMessage((0, $95Ew5.default).entityLimitErrorTitle),
                description: formatMessage(errorMessage, {
                    item: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), null, chunks)
                }),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Svlt9))), {
                    spacing: "spacious",
                    label: "Error",
                    color: "var(--ds-icon-danger, #C9372C)"
                })
            }) : null;
        }
        if ((0, $fVlmn.isPermissionError)(errorObject)) return error({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).permissionErrorDescription)
        });
        if ((0, $fVlmn.isConfigError)(errorObject)) return error({
            title: formatMessage((0, $95Ew5.default).configErrorTitle),
            description: formatMessage((0, $95Ew5.default).configErrorDescription)
        });
        errorWithRefresh({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).serverUpdateFailedDescription)
        });
    }, [
        customFlag,
        error,
        errorWithRefresh,
        formatMessage
    ]);
};
const $85bd9b8631bfa06e$var$useGeneralActionFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $6x8n3.useNotifications)();
    return (0, $eJOHy.useCallback)((errorObject, callback)=>{
        $85bd9b8631bfa06e$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).errorDescription)
        });
        (0, $gYnSx.default)($85bd9b8631bfa06e$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $85bd9b8631bfa06e$var$usePossibleAccessLossError = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $6x8n3.useNotifications)();
    return (0, $eJOHy.useCallback)((errorObject, callback)=>{
        $85bd9b8631bfa06e$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $95Ew5.default).errorPossibleAccessLossGalaxia : (0, $95Ew5.default).errorPossibleAccessLoss)
        });
        (0, $gYnSx.default)($85bd9b8631bfa06e$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $85bd9b8631bfa06e$export$e0b4869c7401cacb = ()=>{
    const possibleAccessLossError = $85bd9b8631bfa06e$var$usePossibleAccessLossError();
    const generalActionFailedError = $85bd9b8631bfa06e$var$useGeneralActionFailedHandling();
    const generalDataUpdateFailedError = $85bd9b8631bfa06e$var$useGeneralDataUpdateFailedHandling();
    const generalDataLoadingFailedError = $85bd9b8631bfa06e$var$useGeneralDataLoadingFailedHandling();
    return (0, $eJOHy.useMemo)(()=>({
            possibleAccessLossError: possibleAccessLossError,
            generalActionFailedError: generalActionFailedError,
            generalDataUpdateFailedError: generalDataUpdateFailedError,
            generalDataLoadingFailedError: generalDataLoadingFailedError
        }), [
        possibleAccessLossError,
        generalActionFailedError,
        generalDataUpdateFailedError,
        generalDataLoadingFailedError
    ]);
};
const $85bd9b8631bfa06e$export$4e01d30cacaf82b8 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { error: error } = (0, $6x8n3.useNotifications)();
    return (0, $eJOHy.useCallback)((fieldLabels)=>{
        error({
            title: formatMessage((0, $95Ew5.default).errorTitle),
            description: formatMessage((0, $95Ew5.default).cyclicFormulaFieldDescription, {
                fieldLabels: fieldLabels.join(', ')
            })
        });
        (0, $gYnSx.default)($85bd9b8631bfa06e$export$9841879b4fea885b('polaris.error.cyclicFormula', new Error('Cyclic formula field')));
    }, [
        error,
        formatMessage
    ]);
};

});
parcelRegister("6x8n3", function(module, exports) {

$parcel$export(module.exports, "useNotifications", () => $3e2a0a021f792948$export$53d5ca6c3f53e109);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $gmIOk = parcelRequire("gmIOk");

var $Svlt9 = parcelRequire("Svlt9");

var $aMGpU = parcelRequire("aMGpU");
var $22c3C = parcelRequire("22c3C");
var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");
const $3e2a0a021f792948$var$customFlagCommon = (notification, onDismiss, AkFlagComponent)=>{
    const id = (0, $aXKmr.v4)();
    return {
        id: id,
        render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AkFlagComponent, {
                id: id,
                ...notification,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onDismissed: (flagId)=>onDismiss(flagId),
                ...props,
                messageId: notification.messageId ?? `polaris-lib-notifications.controllers.ak-flag-component.${id}`,
                messageType: notification.messageType ?? 'transactional'
            })
    };
};
const $3e2a0a021f792948$var$customFlag = (notification, onDismiss)=>$3e2a0a021f792948$var$customFlagCommon(notification, onDismiss, (0, $22c3C.default));
const $3e2a0a021f792948$var$customAutoDismissFlag = (notification, onDismiss)=>$3e2a0a021f792948$var$customFlagCommon(notification, onDismiss, (0, $aMGpU.default));
const $3e2a0a021f792948$var$success = (notification, onDismiss)=>$3e2a0a021f792948$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.success.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gmIOk))), {
            spacing: "spacious",
            label: "Success icon",
            color: "var(--ds-icon-success, #22A06B)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.success',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.success',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e2a0a021f792948$var$errorWithRefresh = (notification, onDismiss)=>$3e2a0a021f792948$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: [
            ...notification.actions || [],
            {
                content: 'Refresh',
                testId: 'refresh',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.reload()
            }
        ].map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error-refresh.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Svlt9))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error-refresh',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.errorWithRefresh',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e2a0a021f792948$var$error = (notification, onDismiss)=>$3e2a0a021f792948$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Svlt9))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.error',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e2a0a021f792948$export$53d5ca6c3f53e109 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    return (0, $eJOHy.useMemo)(()=>({
            customFlag: (notification)=>{
                const flagId = showFlag($3e2a0a021f792948$var$customFlag(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            success: (notification)=>{
                const flagId = showFlag($3e2a0a021f792948$var$success(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            errorWithRefresh: (notification)=>{
                const flagId = showFlag($3e2a0a021f792948$var$errorWithRefresh(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            error: (notification)=>{
                const flagId = showFlag($3e2a0a021f792948$var$error(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $hrodw.toFlagId)((0, $aXKmr.v4)());
                const flagId = showFlag({
                    ...flag,
                    id: id,
                    key: id,
                    messageId: flag.messageId ?? `polaris-lib-notifications.controllers.showFlag.${id}`,
                    messageType: flag.messageType ?? 'transactional'
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showCustomFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $hrodw.toFlagId)((0, $aXKmr.v4)());
                const flagId = showFlag({
                    messageId: `polaris-lib-notifications.controllers.showCustomFlag.${id}`,
                    messageType: 'transactional',
                    ...flag,
                    id: id
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            dismissFlag: dismissFlag
        }), [
        showFlag,
        dismissFlag
    ]);
};

});
parcelRegister("aMGpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $de87e4d7cff07061$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $xvuCV = parcelRequire("xvuCV");

var $a9cht = parcelRequire("a9cht");
const $de87e4d7cff07061$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.CommonFlag), {
        isAutoDismiss: true,
        ...props,
        flagType: "info"
    }));
var $de87e4d7cff07061$export$2e2bcd8739ae039 = $de87e4d7cff07061$var$AkAutoDismissFlag;

});

parcelRegister("22c3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd84232d8ddd3e42$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $xvuCV = parcelRequire("xvuCV");

var $a9cht = parcelRequire("a9cht");
const $fd84232d8ddd3e42$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $fd84232d8ddd3e42$export$2e2bcd8739ae039 = $fd84232d8ddd3e42$var$AkFlag;

});


parcelRegister("fljS9", function(module, exports) {

$parcel$export(module.exports, "EntityLimitError", () => $0eae3c589bda6c5f$export$c4e01b2c2ba95919);
$parcel$export(module.exports, "getEntityLimitError", () => $0eae3c589bda6c5f$export$13f6f9a6b905ebbd);
$parcel$export(module.exports, "getErrorMessageDescriptor", () => $0eae3c589bda6c5f$export$cf58cbb2768ea4f);

var $eezJL = parcelRequire("eezJL");

var $fJuTR = parcelRequire("fJuTR");

var $epTsa = parcelRequire("epTsa");

var $ivX8j = parcelRequire("ivX8j");

var $aqxDR = parcelRequire("aqxDR");
class $0eae3c589bda6c5f$export$c4e01b2c2ba95919 extends (0, $fJuTR.default) {
    constructor(message, errors = [], statusCode = null, type){
        super(message, {
            cause: errors[0]
        }), this.name = 'EntityLimitError';
        this.errors = errors;
        this.statusCode = statusCode;
        this.type = type;
    }
}
const $0eae3c589bda6c5f$export$13f6f9a6b905ebbd = (error)=>{
    // If already an EntityLimitError, return it
    if (error instanceof $0eae3c589bda6c5f$export$c4e01b2c2ba95919) return error;
    // If not an ApolloError, return null as we can't handle it
    if (!(error instanceof (0, $eezJL.ApolloError))) return null;
    // Get first entity limit error
    const entityLimitError = error.graphQLErrors?.filter((err)=>err.extensions?.limitType)[0];
    // If no entity limit error or no extensions, return null
    if (!entityLimitError?.extensions) return null;
    const { statusCode: statusCode, limitType: limitType } = entityLimitError.extensions;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entityLimitErrorType = (0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE)[limitType];
    return new $0eae3c589bda6c5f$export$c4e01b2c2ba95919(entityLimitError.message, [
        {
            error: entityLimitError.message
        }
    ], statusCode, entityLimitErrorType);
};
const $0eae3c589bda6c5f$export$cf58cbb2768ea4f = (error)=>{
    if (error.type === (0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT && (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false)) return (0, $ivX8j.default)[`${error.type}Galaxia`];
    return (0, $ivX8j.default)[error.type] || null;
};

});
parcelRegister("ivX8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fb7ce4790658e33$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");

var $aqxDR = parcelRequire("aqxDR");
var $6fb7ce4790658e33$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    /* eslint-disable jira/i18n/id-named-by-package */ [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).COMMENTS_PER_VIEW]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.comments-per-view",
        "defaultMessage": "We couldn\u2019t create a new <item>comment</item> because this <item>view</item> has reached its limit for <item>comments</item>. Remove <item>comment</item> to create a new <item>comment</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_VIEW]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-view",
        "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>view</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>project</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_IDEA]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-idea",
        "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>idea</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>project</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).LABELS_PER_SNIPPET]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.labels-per-snippet",
        "defaultMessage": "We couldn\u2019t create a new <item>label</item> because this <item>snippet</item> has reached its limit for <item>labels</item>. Remove <item>label</item> to create a new <item>label</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).OPTIONS_PER_FIELD]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.options-per-field",
        "defaultMessage": "We couldn\u2019t create a new <item>option</item> because this <item>field</item> has reached its limit for <item>options</item>. Remove <item>option</item> to create a new <item>option</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PLAY]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-play",
        "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>vote</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>project</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).PLAYS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.plays-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>vote</item> because this <item>project</item> has reached its limit for <item>votes</item>. Remove <item>vote</item> to create a new <item>vote</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).SNIPPETS_PER_INSIGHT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.snippets-per-insight",
        "defaultMessage": "We couldn\u2019t create a new <item>snippet</item> because this <item>insight</item> has reached its limit for <item>snippets</item>. Remove <item>snippet</item> to create a new <item>snippet</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).VIEWS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.views-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>view</item> because this <item>project</item> has reached its limit for <item>views</item>. Remove <item>view</item> to create a new <item>view</item>"
    },
    [(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>section</item> because this <item>project</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
    },
    [`${(0, $aqxDR.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT}Galaxia`]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-project-galaxia",
        "defaultMessage": "We couldn\u2019t create a new <item>section</item> because this <item>space</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
    }
});

});
parcelRegister("aqxDR", function(module, exports) {

$parcel$export(module.exports, "ENTITY_LIMIT_ERROR_TYPE", () => $ef36341caf3b8cc4$export$a197d88688faa32c);
const $ef36341caf3b8cc4$export$a197d88688faa32c = {
    COMMENTS_PER_VIEW: 'commentsPerView',
    FIELDS_PER_VIEW: 'fieldsPerView',
    FIELDS_PER_PROJECT: 'fieldsPerProject',
    INSIGHTS_PER_IDEA: 'insightsPerIdea',
    INSIGHTS_PER_PROJECT: 'insightsPerProject',
    LABELS_PER_SNIPPET: 'labelsPerSnippet',
    OPTIONS_PER_FIELD: 'optionsPerField',
    PLAY_CONTRIBUTIONS_PER_PLAY: 'playContributionsPerPlay',
    PLAY_CONTRIBUTIONS_PER_PROJECT: 'playContributionsPerProject',
    PLAYS_PER_PROJECT: 'playsPerProject',
    SNIPPETS_PER_INSIGHT: 'snippetsPerInsight',
    VIEWS_PER_PROJECT: 'viewsPerProject',
    VIEWSETS_PER_PROJECT: 'viewsetsPerProject'
};

});



parcelRegister("95Ew5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7342b98ba959b1d3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7342b98ba959b1d3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "polaris-lib-errors.controllers.error-title",
        "defaultMessage": "Something went wrong."
    },
    permissionErrorDescription: {
        "id": "polaris-lib-errors.controllers.permission-error-description",
        "defaultMessage": "You may not have the permissions required to perform this operation."
    },
    configErrorTitle: {
        "id": "polaris-lib-errors.controllers.config-error-title",
        "defaultMessage": "We couldn't save that."
    },
    configErrorDescription: {
        "id": "polaris-lib-errors.controllers.config-error-description",
        "defaultMessage": "This usually happens because the configuration data on this field is too big. Contact support for more details"
    },
    serverLoadFailedDescription: {
        "id": "polaris-lib-errors.controllers.server-load-failed-description",
        "defaultMessage": "We had difficulties to fetch some data from the server. Please refresh the page."
    },
    serverUpdateFailedDescription: {
        "id": "polaris-lib-errors.controllers.server-update-failed-description",
        "defaultMessage": "We had some difficulties to save some data to the server. Please try again or refresh the page."
    },
    errorDescription: {
        "id": "polaris-lib-errors.controllers.error-description",
        "defaultMessage": "We failed to execute your last operation. Our team has been notified. Please refresh the page to try again."
    },
    workflowLoadingFailedDescription: {
        "id": "polaris-lib-errors.controllers.workflow-loading-failed-description",
        "defaultMessage": "We had some difficulties to load some workflow data from the server. Please refresh the page."
    },
    errorPossibleAccessLoss: {
        "id": "polaris-lib-errors.controllers.error-possible-access-loss",
        "defaultMessage": "You may have lost access to the project or site. Please refresh the page."
    },
    cyclicFormulaFieldDescription: {
        "id": "polaris-lib-errors.controllers.cyclic-formula-field-description",
        "defaultMessage": "We cannot calculate the value of some fields because they contain a cyclic formula. Please edit the field configurations and refresh: {fieldLabels}"
    },
    entityLimitErrorTitle: {
        "id": "polaris-lib-errors.controllers.entity-limit-error-title",
        "defaultMessage": "You\u2019ve hit a limit"
    },
    errorPossibleAccessLossGalaxia: {
        "id": "polaris-lib-errors.controllers.error-possible-access-loss-galaxia",
        "defaultMessage": "You may have lost access to the space or site. Please refresh the page."
    }
});

});

parcelRegister("fVlmn", function(module, exports) {

$parcel$export(module.exports, "isPermissionError", () => $bff2287ffa2d3eb9$export$e11674744930cd15);
$parcel$export(module.exports, "isRateLimitError", () => $bff2287ffa2d3eb9$export$a8908c3867f6f20b);
$parcel$export(module.exports, "isAccessForbiddenError", () => $bff2287ffa2d3eb9$export$443ae86cf12ba84);
$parcel$export(module.exports, "isNotFoundError", () => $bff2287ffa2d3eb9$export$6ccdb59d3479f4f1);
$parcel$export(module.exports, "isClientClosedError", () => $bff2287ffa2d3eb9$export$ce14333297f1d017);
$parcel$export(module.exports, "isBadRequest", () => $bff2287ffa2d3eb9$export$9ec5d1f0bf2939c);
$parcel$export(module.exports, "isConflictError", () => $bff2287ffa2d3eb9$export$b43c7b888ac6458);
$parcel$export(module.exports, "isConfigError", () => $bff2287ffa2d3eb9$export$5e48c9e1c3c8f299);
$parcel$export(module.exports, "getMetadata", () => $bff2287ffa2d3eb9$export$8548546c0aa631e6);

var $exWdq = parcelRequire("exWdq");

var $4sprp = parcelRequire("4sprp");

var $jUVzX = parcelRequire("jUVzX");
const $bff2287ffa2d3eb9$export$e11674744930cd15 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 401 || errorObject.statusCode === 403;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'graphQLErrors') && (0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(errorObject.graphQLErrors)) // graphql response error, check polaris-specific payload
    return (0, (/*@__PURE__*/$parcel$interopDefault($jUVzX)))(errorObject.graphQLErrors, (error)=>{
        const safeMessage = error.message || '';
        return error.extensions?.statusCode === 403 || error.extensions?.statusCode === 401 || safeMessage.includes('JIRA_ACCESS_NOT_PERMITTED') || safeMessage.includes('RequestStatus: 401') || safeMessage.includes('RequestStatus: 403') || safeMessage.includes('status code 401') || // that's probably obsolete
        safeMessage.includes('status code 403') // that's probably obsolete
        ;
    });
    return false;
};
const $bff2287ffa2d3eb9$var$checkRateLimitErrorMatch = (error)=>{
    const safeMessage = error?.message || '';
    return error && 'statusCode' in error && error?.statusCode === 429 || error && 'extensions' in error && error.extensions?.statusCode === 429 || safeMessage.includes('RequestStatus: 429') || safeMessage.includes('status code 429');
};
const $bff2287ffa2d3eb9$export$a8908c3867f6f20b = (errorObject)=>{
    return $bff2287ffa2d3eb9$var$checkRateLimitErrorMatch(errorObject) || errorObject.networkError && $bff2287ffa2d3eb9$var$checkRateLimitErrorMatch(errorObject.networkError) || errorObject?.graphQLErrors?.some((error)=>$bff2287ffa2d3eb9$var$checkRateLimitErrorMatch(error)) || false;
};
const $bff2287ffa2d3eb9$export$443ae86cf12ba84 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 403;
    return false;
};
const $bff2287ffa2d3eb9$export$6ccdb59d3479f4f1 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 404;
    return false;
};
const $bff2287ffa2d3eb9$export$ce14333297f1d017 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 499;
    return false;
};
const $bff2287ffa2d3eb9$export$9ec5d1f0bf2939c = (errorObject)=>{
    if (errorObject?.statusCode) // http response error, check status code
    return errorObject?.statusCode >= 400 && errorObject?.statusCode < 500;
    return false;
};
const $bff2287ffa2d3eb9$export$b43c7b888ac6458 = (errorObject)=>errorObject.statusCode === 409;
const $bff2287ffa2d3eb9$export$5e48c9e1c3c8f299 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'statusCode') && (0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(errorObject, 'message')) return errorObject.statusCode === 500 && errorObject.message === 'Property is too long';
    return false;
};
const $bff2287ffa2d3eb9$export$8548546c0aa631e6 = (errorObject)=>({
        metadata: {
            error: errorObject.message
        }
    });

});
parcelRegister("jUVzX", function(module, exports) {

var $202ak = parcelRequire("202ak");

var $1lM9j = parcelRequire("1lM9j");

var $2DwDI = parcelRequire("2DwDI");

var $4sprp = parcelRequire("4sprp");

var $eA1it = parcelRequire("eA1it");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $e7ffe9447e10a1ca$var$some(collection, predicate, guard) {
    var func = $4sprp(collection) ? $202ak : $2DwDI;
    if (guard && $eA1it(collection, predicate, guard)) predicate = undefined;
    return func(collection, $1lM9j(predicate, 3));
}
module.exports = $e7ffe9447e10a1ca$var$some;

});
parcelRegister("2DwDI", function(module, exports) {

var $c3u3c = parcelRequire("c3u3c");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $1eb88ace25f55b0d$var$baseSome(collection, predicate) {
    var result;
    $c3u3c(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $1eb88ace25f55b0d$var$baseSome;

});





parcelRegister("efRp8", function(module, exports) {

$parcel$export(module.exports, "loadBlueprintsState", () => $ad220cbfca68d842$export$104ee4f3e9ddc3c4);
$parcel$export(module.exports, "setBlueprintsTourStep", () => $ad220cbfca68d842$export$1b9ba94b448264d2);
$parcel$export(module.exports, "setBlueprintsTourDismissed", () => $ad220cbfca68d842$export$13d121276e063a92);

var $k4x9q = parcelRequire("k4x9q");

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $gYnSx = parcelRequire("gYnSx");

var $7e8wG = parcelRequire("7e8wG");

var $4y7gv = parcelRequire("4y7gv");

var $8lgoE = parcelRequire("8lgoE");

var $keeNI = parcelRequire("keeNI");
const $ad220cbfca68d842$export$104ee4f3e9ddc3c4 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().blueprints.tourDismissed === 'boolean') return;
        try {
            const remoteState = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.BLUEPRINTS_TOUR_SPOTLIGHTS));
            const state = getState();
            setState({
                ...state,
                blueprints: {
                    ...state.blueprints,
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($k4x9q)))(remoteState, {
                        tourSpotlightStep: null,
                        tourDismissed: false
                    })
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    blueprints: {
                        ...state.blueprints,
                        tourDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.blueprints-spotlight', `Failed to get user property with key: ${(0, $8lgoE.BLUEPRINTS_TOUR_SPOTLIGHTS)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $ad220cbfca68d842$export$1b9ba94b448264d2 = (step)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newBlueprintsState = {
            ...state.blueprints,
            tourSpotlightStep: step
        };
        setState({
            ...state,
            blueprints: newBlueprintsState
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.BLUEPRINTS_TOUR_SPOTLIGHTS), JSON.stringify(newBlueprintsState));
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.onboarding.blueprints-spotlight', (0, $keeNI.normalizeError)(error)));
        }
    };
const $ad220cbfca68d842$export$13d121276e063a92 = (tourDismissed)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newBlueprintsState = {
            ...state.blueprints,
            tourDismissed: tourDismissed
        };
        setState({
            ...state,
            blueprints: newBlueprintsState
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.BLUEPRINTS_TOUR_SPOTLIGHTS), JSON.stringify(newBlueprintsState));
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.onboarding.blueprints-spotlight', (0, $keeNI.normalizeError)(error)));
        }
    };

});

parcelRegister("80clw", function(module, exports) {

$parcel$export(module.exports, "loadPremiumModalDismissed", () => $72d34c3285be8d90$export$f4ca311cb4b4350f);
$parcel$export(module.exports, "setPremiumModalDismissed", () => $72d34c3285be8d90$export$99d8813bb6724f28);
$parcel$export(module.exports, "loadPremiumLastVisit", () => $72d34c3285be8d90$export$6825e78fd5bc05f5);
$parcel$export(module.exports, "setPremiumLastVisit", () => $72d34c3285be8d90$export$c2d4fef533f3196c);
$parcel$export(module.exports, "unlockOnboardingFlow", () => $72d34c3285be8d90$export$f92cc7ff16154919);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $8lgoE = parcelRequire("8lgoE");
const $72d34c3285be8d90$export$f4ca311cb4b4350f = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().premium.modalDismissed === 'boolean') return;
        try {
            const modalDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.PREMIUM_MODAL_DISMISSED));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    modalDismissed: modalDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    premium: {
                        ...state.premium,
                        modalDismissed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.modal-dismissed', `Failed to get user property with key: ${(0, $8lgoE.PREMIUM_MODAL_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
        return getState().premium.modalDismissed;
    };
const $72d34c3285be8d90$export$99d8813bb6724f28 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        // we need to pass isPremium to the lastVisit object to ensure that the modal is dismissed
        // when the user is on the premium edition and the last visit was on the free edition
        setState({
            premium: {
                ...state.premium,
                modalDismissed: true,
                lastVisit: {
                    ...state.premium.lastVisit,
                    isPremium: true
                }
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.PREMIUM_MODAL_DISMISSED), 'true');
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.modal-dismissed', `Failed to set user property with key: ${(0, $8lgoE.PREMIUM_MODAL_DISMISSED)}`, error instanceof Error ? error : undefined);
        }
    };
const $72d34c3285be8d90$export$6825e78fd5bc05f5 = (isPremiumEdition)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // User property is already loaded
        if (typeof getState().premium.lastVisit.isPremium === 'boolean') return;
        try {
            const lastVisitOnPremium = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.PREMIUM_LAST_VISIT));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    lastVisit: {
                        ...state.premium.lastVisit,
                        isPremium: lastVisitOnPremium
                    }
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    premium: {
                        ...state.premium,
                        lastVisit: {
                            ...state.premium.lastVisit,
                            isPremium: isPremiumEdition
                        }
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.last-visit', `Failed to get user property with key: ${(0, $8lgoE.PREMIUM_LAST_VISIT)}`, error instanceof Error ? error : undefined);
        }
        return getState().premium.modalDismissed;
    };
const $72d34c3285be8d90$export$c2d4fef533f3196c = (isPremium)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        if (getState().premium.lastVisit.updated) // If lastVisit has been updated already
        // then don't do it again
        return;
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.PREMIUM_LAST_VISIT), String(isPremium));
            const state = getState();
            setState({
                premium: {
                    ...state.premium,
                    lastVisit: {
                        ...state.premium.lastVisit,
                        updated: true
                    }
                }
            });
        } catch (error) {
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.premium.last-visit', `Failed to set user property with key: ${(0, $8lgoE.PREMIUM_LAST_VISIT)}`, error instanceof Error ? error : undefined);
        }
    };
const $72d34c3285be8d90$export$f92cc7ff16154919 = ()=>async ({ getState: getState })=>{
        getState().premium.promise.resolve();
    };

});

parcelRegister("2QyGs", function(module, exports) {

$parcel$export(module.exports, "loadProductUsageStartTimestamp", () => $771f783e12ff8fa1$export$7cb2c6cd0d7c32c0);

var $FppkK = parcelRequire("FppkK");

var $6Yd06 = parcelRequire("6Yd06");

var $8KUFq = parcelRequire("8KUFq");

var $1uIew = parcelRequire("1uIew");

var $8lgoE = parcelRequire("8lgoE");
const $771f783e12ff8fa1$export$7cb2c6cd0d7c32c0 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        // usage timestamp already loaded
        if (getState().productUsageStartTimestamp) return;
        try {
            const { isoDateString: productUsageStartTimestamp } = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.PRODUCT_START_TIMESTAMP));
            const state = getState();
            setState({
                ...state,
                productUsageStartTimestamp: productUsageStartTimestamp
            });
        } catch (error) {
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404 || (0, $8KUFq.isClientFetchError)(error)) return;
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.roadmaps.introduction.spotlight.dismissed', `Failed to get user property with key: ${(0, $8lgoE.PRODUCT_START_TIMESTAMP)}`, error instanceof Error ? error : undefined);
        }
        return getState().productUsageStartTimestamp;
    };

});

parcelRegister("8iz9g", function(module, exports) {

$parcel$export(module.exports, "loadCustomDatesCustomizeSpotlightDismissed", () => $a57880881c55e1bd$export$4a8766eb957669c8);
$parcel$export(module.exports, "setCustomDatesCustomizeSpotlightDismissed", () => $a57880881c55e1bd$export$82bd3ea030c97bbd);

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $hThlN = parcelRequire("hThlN");

var $8lgoE = parcelRequire("8lgoE");

var $4y7gv = parcelRequire("4y7gv");
const $a57880881c55e1bd$export$4a8766eb957669c8 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (typeof getState().customDates.customizeSpotlightDismissed === 'boolean') return;
        try {
            const customizeSpotlightDismissed = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED));
            const state = getState();
            setState({
                ...state,
                customDates: {
                    ...state.customDates,
                    customizeSpotlightDismissed: customizeSpotlightDismissed
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    customDates: {
                        customizeSpotlightDismissed: false
                    }
                });
                return;
            }
            const errorMessage = `Failed to get user property with key: ${(0, $8lgoE.CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED)}`;
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.custom-dates.customize.spotlight', errorMessage, error instanceof Error ? error : new (0, $hThlN.UnknownError)(errorMessage, error));
        }
    };
const $a57880881c55e1bd$export$82bd3ea030c97bbd = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        setState({
            ...state,
            customDates: {
                customizeSpotlightDismissed: true
            }
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED), 'true');
        } catch (error) {
            const errorMessage = `Failed to set user property with key: ${(0, $8lgoE.CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED)}`;
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.custom-dates.customize.spotlight', errorMessage, error instanceof Error ? error : new (0, $hThlN.UnknownError)(errorMessage, error));
        }
    };

});
parcelRegister("hThlN", function(module, exports) {

$parcel$export(module.exports, "UnknownError", () => $df1b5008c9f3614d$export$ff4405149dbd0c5c);

var $fJuTR = parcelRequire("fJuTR");
class $df1b5008c9f3614d$export$ff4405149dbd0c5c extends (0, $fJuTR.default) {
    constructor(message, details){
        super(message), this.name = 'UnknownError';
        this.details = details;
    }
}

});


parcelRegister("2Ir1d", function(module, exports) {

$parcel$export(module.exports, "loadImportState", () => $2fae3ed0475f4cde$export$32a519c7542a933);
$parcel$export(module.exports, "setImportSpotlightDismissed", () => $2fae3ed0475f4cde$export$2e25f2bad16928e3);
$parcel$export(module.exports, "setSuccessNotificationViewed", () => $2fae3ed0475f4cde$export$c4970fff383b7bfb);

var $k4x9q = parcelRequire("k4x9q");

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $6Yd06 = parcelRequire("6Yd06");

var $gYnSx = parcelRequire("gYnSx");

var $7e8wG = parcelRequire("7e8wG");

var $4y7gv = parcelRequire("4y7gv");

var $8lgoE = parcelRequire("8lgoE");

var $keeNI = parcelRequire("keeNI");
const $2fae3ed0475f4cde$export$32a519c7542a933 = ()=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        await (0, $4y7gv.maybeWaitForPremiumModal)(getState);
        // User property is already loaded
        if (getState().import.spotlightDismissed !== undefined) return;
        try {
            const remoteState = await (0, $FppkK.getUserProperty)(accountId, (0, $8lgoE.IMPORT_BULK_CREATE_ONBOARDING));
            const state = getState();
            setState({
                ...state,
                import: {
                    ...state.import,
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($k4x9q)))(remoteState, {
                        spotlightDismissed: false,
                        successNotificationViewed: false
                    })
                }
            });
        } catch (error) {
            // Expected error, the property is not set yet
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) {
                const state = getState();
                setState({
                    ...state,
                    import: {
                        ...state.import,
                        spotlightDismissed: false,
                        successNotificationViewed: false
                    }
                });
                return;
            }
            (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)('polaris.onboarding.import-spotlight', `Failed to get user property with key: ${(0, $8lgoE.IMPORT_BULK_CREATE_ONBOARDING)}`, error instanceof Error ? error : new Error(String(error)));
        }
    };
const $2fae3ed0475f4cde$export$2e25f2bad16928e3 = (spotlightDismissed)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newImportState = {
            ...state.import,
            spotlightDismissed: spotlightDismissed
        };
        setState({
            ...state,
            import: newImportState
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.IMPORT_BULK_CREATE_ONBOARDING), JSON.stringify(newImportState));
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.onboarding.imports-spotlight', (0, $keeNI.normalizeError)(error)));
        }
    };
const $2fae3ed0475f4cde$export$c4970fff383b7bfb = (successNotificationViewed)=>async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (!accountId) return;
        const state = getState();
        const newImportState = {
            ...state.import,
            successNotificationViewed: successNotificationViewed
        };
        setState({
            ...state,
            import: newImportState
        });
        try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $8lgoE.IMPORT_BULK_CREATE_ONBOARDING), JSON.stringify(newImportState));
        } catch (error) {
            (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.onboarding.imports-notification', (0, $keeNI.normalizeError)(error)));
        }
    };

});



parcelRegister("4V76I", function(module, exports) {

$parcel$export(module.exports, "useCollectionsTourDismissed", () => $08618d4951c750a7$export$17de768881ff6446);
$parcel$export(module.exports, "useTourSpotlightStep", () => $08618d4951c750a7$export$152b14ddbe17966d);
$parcel$export(module.exports, "useCollectionsIntroductionDismissed", () => $08618d4951c750a7$export$2c88e8fbdc79e33c);
$parcel$export(module.exports, "useCollectionsIntroductionPrerequisiteDismissalsMet", () => $08618d4951c750a7$export$45df47b92137b673);

var $4l17z = parcelRequire("4l17z");

var $chGrv = parcelRequire("chGrv");
const $08618d4951c750a7$export$17de768881ff6446 = (0, $4l17z.createHook)((0, $chGrv.getCollectionsTourDismissed));
const $08618d4951c750a7$export$152b14ddbe17966d = (0, $4l17z.createHook)((0, $chGrv.getTourSpotlightStep));
const $08618d4951c750a7$export$2c88e8fbdc79e33c = (0, $4l17z.createHook)((0, $chGrv.getCollectionsIntroductionDismissed));
const $08618d4951c750a7$export$45df47b92137b673 = (0, $4l17z.createHook)((0, $chGrv.getCollectionsIntroductionPrerequisiteDismissalsMet));

});
parcelRegister("chGrv", function(module, exports) {

$parcel$export(module.exports, "getCollectionsTourDismissed", () => $8ff670eac2e8d400$export$2f4e8052c0c8cc36);
$parcel$export(module.exports, "getTourSpotlightStep", () => $8ff670eac2e8d400$export$c0777ba57d86bcd1);
$parcel$export(module.exports, "getCollectionsIntroductionDismissed", () => $8ff670eac2e8d400$export$df23a375f28a4c0f);
$parcel$export(module.exports, "getCollectionsIntroductionPrerequisiteDismissalsMet", () => $8ff670eac2e8d400$export$e6b937f1096fabf9);

var $ahm5r = parcelRequire("ahm5r");
const $8ff670eac2e8d400$export$9bc19dcd1978ec48 = (state)=>state.collections;
const $8ff670eac2e8d400$export$2f4e8052c0c8cc36 = (0, $ahm5r.createSelector)($8ff670eac2e8d400$export$9bc19dcd1978ec48, (collections)=>collections.tourDismissed);
const $8ff670eac2e8d400$export$c0777ba57d86bcd1 = (0, $ahm5r.createSelector)($8ff670eac2e8d400$export$9bc19dcd1978ec48, (collections)=>collections.tourSpotlightStep);
const $8ff670eac2e8d400$export$df23a375f28a4c0f = (0, $ahm5r.createSelector)($8ff670eac2e8d400$export$9bc19dcd1978ec48, (collections)=>collections.introductionDismissed);
const $8ff670eac2e8d400$export$e6b937f1096fabf9 = (0, $ahm5r.createSelector)($8ff670eac2e8d400$export$9bc19dcd1978ec48, (collections)=>collections.introductionPrerequisiteDismissalsMet);

});


parcelRegister("a6k1J", function(module, exports) {

$parcel$export(module.exports, "useProductUsageStartTimestamp", () => $b5a88aacba1d43e8$export$935abb673611c138);

var $4l17z = parcelRequire("4l17z");

var $5KTPX = parcelRequire("5KTPX");
const $b5a88aacba1d43e8$export$935abb673611c138 = (0, $4l17z.createHook)((0, $5KTPX.getProductUsageStartTimestamp));

});
parcelRegister("5KTPX", function(module, exports) {

$parcel$export(module.exports, "getProductUsageStartTimestamp", () => $7f2e26bc2498b485$export$e96fba6f475323c2);
const $7f2e26bc2498b485$export$e96fba6f475323c2 = (state)=>state.productUsageStartTimestamp;

});


parcelRegister("cLtfY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2cc9f4c86de84e90$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2cc9f4c86de84e90$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    dismiss: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.dismiss",
        "defaultMessage": "Dismiss"
    },
    giveItATry: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.give-it-a-try",
        "defaultMessage": "Give it a try!"
    },
    message: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.message",
        "defaultMessage": "Create a roadmap tailored to the information your stakeholders care about the most by selecting which projects and ideas to include."
    },
    messageGalaxia: {
        "id": "polaris-lib-onboarding-flows.collections.tour.introduction.message-galaxia",
        "defaultMessage": "Create a roadmap tailored to the information your stakeholders care about the most by selecting which spaces and ideas to include."
    }
});

});

parcelRegister("fU6b0", function(module, exports) {

$parcel$export(module.exports, "useIsLicensedUser", () => $0a15724f2ec22a78$export$8130629f6db139c2);
$parcel$export(module.exports, "checkIfOlderThanNDays", () => $0a15724f2ec22a78$export$cbcf9869d63af9cf);
$parcel$export(module.exports, "useShouldShowRoadmapsIntroductionSpotlight", () => $0a15724f2ec22a78$export$d3d8da452c4b6372);

var $iW0U8 = parcelRequire("iW0U8");

var $4V76I = parcelRequire("4V76I");

var $a6k1J = parcelRequire("a6k1J");
const $0a15724f2ec22a78$export$8130629f6db139c2 = ()=>{
    const { hasProductDiscoveryAccess: hasProductDiscoveryAccess } = (0, $iW0U8.useApplicationPermissions)() ?? {};
    return Boolean(hasProductDiscoveryAccess);
};
const $0a15724f2ec22a78$export$cbcf9869d63af9cf = (productStartTimestamp, days = 7)=>{
    if (!productStartTimestamp) return false;
    const daysInMs = days * 86400000;
    const currentDate = new Date();
    const productAge = currentDate.getTime() - new Date(productStartTimestamp).getTime();
    return productAge > daysInMs;
};
const $0a15724f2ec22a78$export$d3d8da452c4b6372 = ()=>{
    const isLicensedUser = $0a15724f2ec22a78$export$8130629f6db139c2();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const isAlreadyInRoadmaps = window?.location.href.includes('roadmap');
    const isIntroductionDismissed = (0, $4V76I.useCollectionsIntroductionDismissed)();
    const arePrerequisiteDismissalsMet = (0, $4V76I.useCollectionsIntroductionPrerequisiteDismissalsMet)();
    const productUsageStartTimestamp = (0, $a6k1J.useProductUsageStartTimestamp)();
    // Determine if should show the spotlight
    return !(isAlreadyInRoadmaps || !isLicensedUser || isIntroductionDismissed === undefined || isIntroductionDismissed || !arePrerequisiteDismissalsMet || !$0a15724f2ec22a78$export$cbcf9869d63af9cf(productUsageStartTimestamp));
};

});


parcelRegister("bQoR3", function(module, exports) {

$parcel$export(module.exports, "getCollectionDetailsPageUrl", () => $ffa01029ecad820d$export$6d4e7a90e74e9b12);
$parcel$export(module.exports, "getCollectionViewPageUrl", () => $ffa01029ecad820d$export$32ac8841347e1f79);
$parcel$export(module.exports, "getCollectionsPageUrl", () => $ffa01029ecad820d$export$d15219b9c6a3e2f7);
$parcel$export(module.exports, "useCollectionIdeasCount", () => $ffa01029ecad820d$export$28cc502c982e0868);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $dFdvS = parcelRequire("dFdvS");

var $gtzis = parcelRequire("gtzis");
const $ffa01029ecad820d$var$withQueryParams = (path, queryParams)=>{
    if (queryParams) {
        const searchParams = new URLSearchParams();
        Object.keys(queryParams).forEach((key)=>{
            if (queryParams[key]) searchParams.set(key, queryParams[key]);
        });
        if (searchParams.size > 0) return `${path}?${searchParams.toString()}`;
    }
    return path;
};
const $ffa01029ecad820d$export$6d4e7a90e74e9b12 = (collectionUUID)=>`/jira/polaris/roadmaps/${collectionUUID}/view`;
const $ffa01029ecad820d$export$32ac8841347e1f79 = (collectionUUID, viewUUID, queryParams)=>$ffa01029ecad820d$var$withQueryParams(`/jira/polaris/roadmaps/${collectionUUID}/view/${viewUUID}`, queryParams);
const $ffa01029ecad820d$export$d15219b9c6a3e2f7 = (queryParams)=>$ffa01029ecad820d$var$withQueryParams('/jira/polaris/roadmaps', queryParams);
const $ffa01029ecad820d$var$debouncedGetIdeasCountWithJQL = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((jql, setRequest, res, rej)=>{
    const request = (0, $dFdvS.getIdeasCountForCollection)(jql);
    setRequest(request);
    request.then(res, rej).finally(()=>setRequest(undefined));
}, 500);
const $ffa01029ecad820d$export$28cc502c982e0868 = (projectKeys, filtersJql)=>{
    const jql = (0, $gtzis.getJQLForCollection)(projectKeys, filtersJql);
    const [ideasCount, setIdeasCount] = (0, $eJOHy.useState)(undefined);
    const [isLoading, setLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [request, setRequest] = (0, $eJOHy.useState)(undefined);
    (0, $eJOHy.useEffect)(()=>{
        if (jql && projectKeys.length) {
            setLoading(true);
            $ffa01029ecad820d$var$debouncedGetIdeasCountWithJQL(jql, setRequest, (newCount)=>{
                setIdeasCount(newCount);
                setLoading(false);
                setError(null);
            }, (err)=>{
                setIdeasCount(undefined);
                setLoading(false);
                setError(err);
            });
        } else setIdeasCount(undefined);
    }, [
        jql,
        projectKeys.length
    ]);
    return [
        ideasCount,
        isLoading,
        error,
        request
    ];
};

});
parcelRegister("dFdvS", function(module, exports) {

$parcel$export(module.exports, "createCollection", () => $b3fa99eb812b8349$export$c74125a8e3af6bb2);
$parcel$export(module.exports, "fetchCollection", () => $b3fa99eb812b8349$export$efeb96fc7f2aeaf9);
$parcel$export(module.exports, "fetchAllCollections", () => $b3fa99eb812b8349$export$fb62ec897a9d1e05);
$parcel$export(module.exports, "deleteCollection", () => $b3fa99eb812b8349$export$3d16e031f6551662);
$parcel$export(module.exports, "updateCollection", () => $b3fa99eb812b8349$export$c0683150b517c317);
$parcel$export(module.exports, "fetchCollectionsViewsCounts", () => $b3fa99eb812b8349$export$4ead91e2f6058f41);
$parcel$export(module.exports, "fetchCollectionDescription", () => $b3fa99eb812b8349$export$8cd86b5346d1e786);
$parcel$export(module.exports, "cloneCollection", () => $b3fa99eb812b8349$export$d753eba18153f51e);
$parcel$export(module.exports, "getIdeasCountForCollection", () => $b3fa99eb812b8349$export$d355ccab36abee74);

var $1Ozm9 = parcelRequire("1Ozm9");

var $jGzN3 = parcelRequire("jGzN3");

var $jbIuO = parcelRequire("jbIuO");

var $gYnSx = parcelRequire("gYnSx");

var $7e8wG = parcelRequire("7e8wG");

var $gtzis = parcelRequire("gtzis");

var $5AElp = parcelRequire("5AElp");
const $b3fa99eb812b8349$var$generateProjectKeys = (jql)=>{
    return (0, $gtzis.extractProjectKeysFromJql)(jql);
};
const $b3fa99eb812b8349$export$c74125a8e3af6bb2 = (collectionToCreate)=>(0, $jGzN3.performPostRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections`, {
        body: JSON.stringify(collectionToCreate)
    }).then((response)=>({
            uuid: response.uuid,
            name: response.name,
            emoji: response.emoji,
            color: response.color,
            jql: response.jql,
            ownerId: response.owner,
            projectKeys: $b3fa99eb812b8349$var$generateProjectKeys(response.jql),
            filtersJql: (0, $gtzis.extractFiltersJqlFromJql)(response.jql)
        }));
const $b3fa99eb812b8349$export$efeb96fc7f2aeaf9 = (collectionUUID, shouldIncludeViews = false)=>(0, $1Ozm9.default)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}${shouldIncludeViews ? '?expand=views' : ''}`).then((response)=>({
            uuid: response.uuid,
            name: response.name,
            emoji: response.emoji,
            color: response.color,
            jql: response.jql,
            ownerId: response.owner,
            views: response.views?.map((0, $5AElp.transformView)),
            projectKeys: $b3fa99eb812b8349$var$generateProjectKeys(response.jql),
            filtersJql: (0, $gtzis.extractFiltersJqlFromJql)(response.jql)
        }));
const $b3fa99eb812b8349$export$fb62ec897a9d1e05 = ()=>(0, $1Ozm9.default)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections`).then(({ collections: collections })=>collections.map((collection)=>({
                uuid: collection.uuid,
                name: collection.name,
                emoji: collection.emoji,
                color: collection.color,
                jql: collection.jql,
                ownerId: collection.owner,
                projectKeys: $b3fa99eb812b8349$var$generateProjectKeys(collection.jql),
                filtersJql: (0, $gtzis.extractFiltersJqlFromJql)(collection.jql)
            })));
const $b3fa99eb812b8349$export$3d16e031f6551662 = async (collectionUUID)=>{
    await (0, $jGzN3.performDeleteRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}`);
};
const $b3fa99eb812b8349$export$c0683150b517c317 = async (collectionUUID, collectionToUpdate)=>{
    await (0, $jGzN3.performPutRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}`, {
        body: JSON.stringify(collectionToUpdate)
    });
};
const $b3fa99eb812b8349$export$4ead91e2f6058f41 = (collectionsUUIDs)=>(0, $jGzN3.performPostRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/views-count`, {
        body: JSON.stringify({
            uuids: collectionsUUIDs
        })
    });
const $b3fa99eb812b8349$export$8cd86b5346d1e786 = (collectionUUID)=>(0, $1Ozm9.default)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/description`);
const $b3fa99eb812b8349$export$d753eba18153f51e = (collectionUUID, newCollectionName)=>(0, $jGzN3.performPostRequest)(`${(0, $jbIuO.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/clone`, {
        body: JSON.stringify({
            name: newCollectionName
        })
    });
const $b3fa99eb812b8349$export$d355ccab36abee74 = (jql)=>(0, $jGzN3.performPostRequest)('/rest/polaris/issues/searchCountForJql', {
        body: JSON.stringify({
            jql: jql,
            archived: 'ACTIVE_ONLY'
        })
    }).then((response)=>response.count).catch((error)=>{
        (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.error.getIdeasCountForCollectionFailed', error));
        throw error;
    });

});
parcelRegister("jbIuO", function(module, exports) {

$parcel$export(module.exports, "getJpdViewsServicePathPrefix", () => $f413c7737786871c$export$1d2754f769c8a3c6);
const $f413c7737786871c$export$1d2754f769c8a3c6 = ()=>{
    return '/gateway/api/jpd';
};

});

parcelRegister("gtzis", function(module, exports) {

$parcel$export(module.exports, "getJQLForCollection", () => $818429028dabd958$export$8d4a8272ec8d3589);
$parcel$export(module.exports, "extractProjectKeysFromJql", () => $818429028dabd958$export$35840c54e03d7673);
$parcel$export(module.exports, "extractFiltersJqlFromJql", () => $818429028dabd958$export$bcd3615366d8d128);
$parcel$export(module.exports, "getFieldsFromJql", () => $818429028dabd958$export$54e99094db1a28af);

var $2poie = parcelRequire("2poie");
var $eM3Eu = parcelRequire("eM3Eu");
var $lNgEH = parcelRequire("lNgEH");
var $3c1PD = parcelRequire("3c1PD");
const $818429028dabd958$var$quoteProjectKey = (projectKey)=>`"${projectKey}"`;
const $818429028dabd958$var$PROJECT_FIELD_KEY = 'project';
const $818429028dabd958$export$8d4a8272ec8d3589 = (projectsKeys = [], filtersJql = '')=>{
    const jast = new (0, $eM3Eu.JastBuilder)().build(filtersJql);
    projectsKeys.length && jast.query?.appendClause((0, $2poie.default).terminalClause((0, $2poie.default).field($818429028dabd958$var$PROJECT_FIELD_KEY), (0, $2poie.default).operator((0, $lNgEH.OPERATOR_IN)), (0, $2poie.default).listOperand(projectsKeys.map($818429028dabd958$var$quoteProjectKey).map((0, $2poie.default).byText.valueOperand))), (0, $f6a7331f12a1b6ec$export$6d6d48d210d3ca97));
    if (jast.query?.orderBy) jast.query.removeOrderBy();
    return (0, $3c1PD.print)(jast);
};
const $818429028dabd958$var$projectInRegex = /project\s+in\s+\((.*?)\)/;
const $818429028dabd958$var$projectKeyRegex = /"(.*?)"/g;
const $818429028dabd958$export$35840c54e03d7673 = (jql)=>{
    // Extract the part of the JQL related to `project in (...)`
    const projectInMatch = $818429028dabd958$var$projectInRegex.exec(jql);
    const projectKeys = [];
    if (projectInMatch) {
        const projectInClause = projectInMatch[1];
        let match;
        // Extract all project keys inside the quotes within the `project in (...)` clause
        // eslint-disable-next-line no-cond-assign
        while((match = $818429028dabd958$var$projectKeyRegex.exec(projectInClause)) !== null)projectKeys.push(match[1]);
    }
    return projectKeys;
};
const $818429028dabd958$export$bcd3615366d8d128 = (jql)=>{
    const jast = new (0, $eM3Eu.JastBuilder)().build(jql);
    const { where: where } = jast.query ?? {};
    if (!where) return '';
    const clauses = where.clauseType === (0, $27a6760b07fae18c$export$7a58b23488ea076b) ? where.clauses : [
        where
    ];
    const projectKeysClause = clauses.find((c)=>c.clauseType === (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a) && c.field.value === $818429028dabd958$var$PROJECT_FIELD_KEY);
    if (projectKeysClause) projectKeysClause.remove();
    return (0, $3c1PD.print)(jast);
};
const $818429028dabd958$var$getFieldsFromClauses = ([clause, ...rest])=>{
    if (!clause) return [];
    if (clause.clauseType === (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a)) return [
        clause.field.value,
        ...$818429028dabd958$var$getFieldsFromClauses(rest)
    ];
    if (clause.clauseType === (0, $27a6760b07fae18c$export$e356b89f8c8d2fcb)) return $818429028dabd958$var$getFieldsFromClauses([
        clause.clause,
        ...rest
    ]);
    return $818429028dabd958$var$getFieldsFromClauses([
        ...clause.clauses,
        ...rest
    ]);
};
const $818429028dabd958$var$getFieldKeyFromFieldName = (fieldKeys)=>(fieldName)=>fieldKeys[fieldName.replace(/\[.+\]$/, '').toLowerCase()];
const $818429028dabd958$export$54e99094db1a28af = (jql, fieldKeys)=>{
    const jast = new (0, $eM3Eu.JastBuilder)().build(jql);
    const { where: where } = jast.query ?? {};
    if (!where) return [];
    const clauses = where.clauseType === (0, $27a6760b07fae18c$export$7a58b23488ea076b) ? where.clauses : [
        where
    ];
    return $818429028dabd958$var$getFieldsFromClauses(clauses).map($818429028dabd958$var$getFieldKeyFromFieldName(fieldKeys)).filter((field)=>!!field);
};

});
const $27a6760b07fae18c$export$7a58b23488ea076b = 'compound';
const $27a6760b07fae18c$export$ae56b4ef248a2b6a = 'terminal';
const $27a6760b07fae18c$export$e356b89f8c8d2fcb = 'not';

const $f6a7331f12a1b6ec$export$6d6d48d210d3ca97 = 'and';
const $f6a7331f12a1b6ec$export$7b8f0a728d79a753 = 'or';

parcelRegister("2poie", function(module, exports) {

$parcel$export(module.exports, "internalCreators", () => $ad713220215d6377$export$64d991963cfb5532);
$parcel$export(module.exports, "default", () => $ad713220215d6377$export$2e2bcd8739ae039);

var $jM7oP = parcelRequire("jM7oP");

var $5h022 = parcelRequire("5h022");

var $3V0FX = parcelRequire("3V0FX");

var $4Kn63 = parcelRequire("4Kn63");

var $g5ykS = parcelRequire("g5ykS");

var $g6LQT = parcelRequire("g6LQT");

var $7200d = parcelRequire("7200d");

var $dRMnf = parcelRequire("dRMnf");

var $gVR58 = parcelRequire("gVR58");

var $bEKhm = parcelRequire("bEKhm");

var $8aPyf = parcelRequire("8aPyf");

var $lHgaC = parcelRequire("lHgaC");

var $6eoxd = parcelRequire("6eoxd");

var $3yf4i = parcelRequire("3yf4i");

var $99bXG = parcelRequire("99bXG");

var $alArd = parcelRequire("alArd");

var $4L5nY = parcelRequire("4L5nY");

var $9wCiv = parcelRequire("9wCiv");

var $4gvny = parcelRequire("4gvny");

var $7cmts = parcelRequire("7cmts");

var $cVKku = parcelRequire("cVKku");

var $7tmhC = parcelRequire("7tmhC");
const $ad713220215d6377$export$64d991963cfb5532 = {
    query: (0, $7cmts.queryInternal),
    compoundClause: (0, $5h022.compoundClauseInternal),
    compoundOperator: (0, $3V0FX.compoundOperatorInternal),
    terminalClause: (0, $cVKku.terminalClauseInternal),
    notClause: (0, $bEKhm.notClauseInternal),
    notClauseOperator: (0, $8aPyf.notClauseOperatorInternal),
    predicate: (0, $4L5nY.predicateInternal),
    predicateOperator: (0, $9wCiv.predicateOperatorInternal),
    field: (0, $4Kn63.fieldInternal),
    property: (0, $4gvny.propertyInternal),
    operator: (0, $lHgaC.operatorInternal),
    valueOperand: (0, $7tmhC.valueOperandInternal),
    keywordOperand: (0, $dRMnf.keywordOperandInternal),
    functionOperand: (0, $g5ykS.functionOperandInternal),
    functionString: (0, $g6LQT.functionStringInternal),
    argument: (0, $jM7oP.argumentInternal),
    listOperand: (0, $gVR58.listOperandInternal),
    orderBy: (0, $6eoxd.orderByInternal),
    orderByOperator: (0, $alArd.orderByOperatorInternal),
    orderByField: (0, $99bXG.orderByFieldInternal),
    orderByDirection: (0, $3yf4i.orderByDirectionInternal)
};
var $ad713220215d6377$export$2e2bcd8739ae039 = {
    jast: $7200d.jast,
    query: $7cmts.query,
    compoundClause: $5h022.compoundClause,
    compoundOperator: $3V0FX.compoundOperator,
    terminalClause: $cVKku.terminalClause,
    notClause: $bEKhm.notClause,
    notClauseOperator: $8aPyf.notClauseOperator,
    predicate: $4L5nY.predicate,
    predicateOperator: $9wCiv.predicateOperator,
    field: $4Kn63.field,
    property: $4gvny.property,
    operator: $lHgaC.operator,
    valueOperand: $7tmhC.valueOperand,
    keywordOperand: $dRMnf.keywordOperand,
    functionOperand: $g5ykS.functionOperand,
    functionString: $g6LQT.functionString,
    argument: $jM7oP.argument,
    listOperand: $gVR58.listOperand,
    orderBy: $6eoxd.orderBy,
    orderByOperator: $alArd.orderByOperator,
    orderByField: $99bXG.orderByField,
    orderByDirection: $3yf4i.orderByDirection,
    byText: {
        argument: (0, $jM7oP.argumentByText),
        valueOperand: (0, $7tmhC.valueOperandByText)
    }
};

});
parcelRegister("jM7oP", function(module, exports) {

$parcel$export(module.exports, "argument", () => $ba5ec20b9b9d8663$export$6ea29ee575e3f5ff);
$parcel$export(module.exports, "argumentInternal", () => $ba5ec20b9b9d8663$export$5b341d50fa5bcdd5);
$parcel$export(module.exports, "argumentByText", () => $ba5ec20b9b9d8663$export$84c43d23f51170cb);

var $5ydaD = parcelRequire("5ydaD");
var $a2j0G = parcelRequire("a2j0G");

var $gKU15 = parcelRequire("gKU15");
function $ba5ec20b9b9d8663$var$acceptArgument(visitor) {
    return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
}
function $ba5ec20b9b9d8663$var$enterNode(listener) {
    listener.enterArgument && listener.enterArgument(this);
}
function $ba5ec20b9b9d8663$var$exitNode(listener) {
    listener.exitArgument && listener.exitArgument(this);
}
const $ba5ec20b9b9d8663$export$6ea29ee575e3f5ff = (value)=>$ba5ec20b9b9d8663$export$5b341d50fa5bcdd5(value, (0, $a2j0G.sanitiseJqlString)(value));
const $ba5ec20b9b9d8663$export$84c43d23f51170cb = (text)=>$ba5ec20b9b9d8663$export$5b341d50fa5bcdd5((0, $5ydaD.normaliseJqlString)(text), text);
const $ba5ec20b9b9d8663$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $ba5ec20b9b9d8663$var$acceptArgument,
        enterNode: $ba5ec20b9b9d8663$var$enterNode,
        exitNode: $ba5ec20b9b9d8663$var$exitNode,
        getChildren: (0, $gKU15.noChildren),
        parent: null
    });

});
parcelRegister("5ydaD", function(module, exports) {

$parcel$export(module.exports, "normaliseJqlString", () => $692c166240a6c517$export$cecf78a779acc0ff);
const $692c166240a6c517$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $692c166240a6c517$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $692c166240a6c517$export$b86601123607fee5 = (maybeQuotedString)=>$692c166240a6c517$export$7a0b99b892e0dda8(maybeQuotedString) || $692c166240a6c517$export$d5efd6512db694fd(maybeQuotedString);
const $692c166240a6c517$export$cecf78a779acc0ff = (maybeQuotedString)=>{
    if ($692c166240a6c517$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};

});

parcelRegister("a2j0G", function(module, exports) {

$parcel$export(module.exports, "sanitiseJqlString", () => $2ff5bce3dea96f24$export$3eb9033c48208278);

var $6PCNA = parcelRequire("6PCNA");
// Derived from JQLLexer#VALID_UNQUOTED_CHARS
const $2ff5bce3dea96f24$var$CHARS_TO_QUOTE = new RegExp(`[\\s${(0, (/*@__PURE__*/$parcel$interopDefault($6PCNA)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
const $2ff5bce3dea96f24$export$3eb9033c48208278 = (jqlString)=>{
    if ($2ff5bce3dea96f24$var$CHARS_TO_QUOTE.test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
    return jqlString;
};

});
parcelRegister("6PCNA", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $4f959a1cf3d02dc6$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $4f959a1cf3d02dc6$var$reHasRegExpChar = RegExp($4f959a1cf3d02dc6$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $4f959a1cf3d02dc6$var$escapeRegExp(string) {
    string = $cz1WF(string);
    return string && $4f959a1cf3d02dc6$var$reHasRegExpChar.test(string) ? string.replace($4f959a1cf3d02dc6$var$reRegExpChar, '\\$&') : string;
}
module.exports = $4f959a1cf3d02dc6$var$escapeRegExp;

});


parcelRegister("gKU15", function(module, exports) {

$parcel$export(module.exports, "noChildren", () => $c704c5aea1b974e6$export$470bef71e654b804);
$parcel$export(module.exports, "assignParent", () => $c704c5aea1b974e6$export$a4685923af2913a);
const $c704c5aea1b974e6$export$470bef71e654b804 = ()=>[];
const $c704c5aea1b974e6$export$a4685923af2913a = (node)=>{
    node.getChildren().forEach((child)=>{
        child.parent = node;
    });
};

});


parcelRegister("5h022", function(module, exports) {

$parcel$export(module.exports, "compoundClause", () => $c6f549ccf4e3460e$export$ab714e56a32c25f2);
$parcel$export(module.exports, "compoundClauseInternal", () => $c6f549ccf4e3460e$export$cd65eed8c10b0911);


var $6HSRB = parcelRequire("6HSRB");

var $gKU15 = parcelRequire("gKU15");
function $c6f549ccf4e3460e$var$acceptCompoundClause(visitor) {
    return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
}
function $c6f549ccf4e3460e$var$enterNode(listener) {
    listener.enterCompoundClause && listener.enterCompoundClause(this);
}
function $c6f549ccf4e3460e$var$exitNode(listener) {
    listener.exitCompoundClause && listener.exitCompoundClause(this);
}
function $c6f549ccf4e3460e$var$getChildren() {
    return [
        this.operator,
        ...this.clauses
    ];
}
const $c6f549ccf4e3460e$export$ab714e56a32c25f2 = (operator, clauses)=>{
    return $c6f549ccf4e3460e$export$cd65eed8c10b0911(operator, clauses);
};
const $c6f549ccf4e3460e$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
    const node = {
        type: (0, $66bb7f5e87fdacb6$export$2d205682cc545947),
        clauseType: (0, $27a6760b07fae18c$export$7a58b23488ea076b),
        operator: operator,
        clauses: clauses,
        position: position,
        accept: $c6f549ccf4e3460e$var$acceptCompoundClause,
        enterNode: $c6f549ccf4e3460e$var$enterNode,
        exitNode: $c6f549ccf4e3460e$var$exitNode,
        getChildren: $c6f549ccf4e3460e$var$getChildren,
        parent: null,
        appendClause: $6HSRB.appendClause,
        remove: $6HSRB.remove,
        removeClause: $6HSRB.removeClause,
        replace: $6HSRB.replace,
        replaceClause: $6HSRB.replaceClause
    };
    (0, $gKU15.assignParent)(node);
    return node;
};

});
const $66bb7f5e87fdacb6$export$98dda21ec825792 = 'query';
const $66bb7f5e87fdacb6$export$2d205682cc545947 = 'clause';
const $66bb7f5e87fdacb6$export$d2f212d8ddbc8d1d = 'operand';
const $66bb7f5e87fdacb6$export$da0f73edded4a63d = 'order_by';

parcelRegister("6HSRB", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);


var $gKU15 = parcelRequire("gKU15");
function appendClause(clause) {
    let clausesToAppend = [
        clause
    ];
    // If the clause to append is compound with a matching operator then we flatten it into the current clause
    if (clause.clauseType === (0, $27a6760b07fae18c$export$7a58b23488ea076b) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
    this.clauses.push(...clausesToAppend);
    (0, $gKU15.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    this.clauses = this.clauses.filter((val)=>val !== clause);
    if (this.clauses.length === 1) this.replace(this.clauses[0]);
    else if (this.clauses.length === 0) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    this.clauses = this.clauses.map((child)=>{
        return child === clause ? nextClause : child;
    });
    (0, $gKU15.assignParent)(this);
}

});


parcelRegister("3V0FX", function(module, exports) {

$parcel$export(module.exports, "compoundOperator", () => $23f1ffecbb76cbdb$export$84bb3ebbba491aee);
$parcel$export(module.exports, "compoundOperatorInternal", () => $23f1ffecbb76cbdb$export$63c33bc3fe74fee6);

var $gKU15 = parcelRequire("gKU15");
function $23f1ffecbb76cbdb$var$acceptCompoundOperator(visitor) {
    return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
}
function $23f1ffecbb76cbdb$var$enterNode(listener) {
    listener.enterCompoundOperator && listener.enterCompoundOperator(this);
}
function $23f1ffecbb76cbdb$var$exitNode(listener) {
    listener.exitCompoundOperator && listener.exitCompoundOperator(this);
}
const $23f1ffecbb76cbdb$export$84bb3ebbba491aee = (value)=>$23f1ffecbb76cbdb$export$63c33bc3fe74fee6(value, []);
const $23f1ffecbb76cbdb$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
        value: value,
        positions: operatorPositions,
        position: null,
        accept: $23f1ffecbb76cbdb$var$acceptCompoundOperator,
        enterNode: $23f1ffecbb76cbdb$var$enterNode,
        exitNode: $23f1ffecbb76cbdb$var$exitNode,
        getChildren: (0, $gKU15.noChildren),
        parent: null
    });

});

parcelRegister("4Kn63", function(module, exports) {

$parcel$export(module.exports, "field", () => $17d06e127fa28ff6$export$e0f35d825088c098);
$parcel$export(module.exports, "fieldInternal", () => $17d06e127fa28ff6$export$2193f8c541622b6);

var $a2j0G = parcelRequire("a2j0G");

var $gKU15 = parcelRequire("gKU15");
function $17d06e127fa28ff6$var$acceptField(visitor) {
    return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
}
function $17d06e127fa28ff6$var$enterNode(listener) {
    listener.enterField && listener.enterField(this);
}
function $17d06e127fa28ff6$var$exitNode(listener) {
    listener.exitField && listener.exitField(this);
}
function $17d06e127fa28ff6$var$getChildren() {
    return this.properties ? [
        ...this.properties
    ] : [];
}
const $17d06e127fa28ff6$export$e0f35d825088c098 = (value, properties)=>{
    return $17d06e127fa28ff6$export$2193f8c541622b6(value, (0, $a2j0G.sanitiseJqlString)(value), properties);
};
const $17d06e127fa28ff6$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
    const node = {
        text: text,
        value: value,
        properties: properties,
        position: position,
        accept: $17d06e127fa28ff6$var$acceptField,
        enterNode: $17d06e127fa28ff6$var$enterNode,
        exitNode: $17d06e127fa28ff6$var$exitNode,
        getChildren: $17d06e127fa28ff6$var$getChildren,
        parent: null
    };
    (0, $gKU15.assignParent)(node);
    return node;
};

});

parcelRegister("g5ykS", function(module, exports) {

$parcel$export(module.exports, "functionOperand", () => $df803c56cdfb962f$export$4f981b0e83488ce);
$parcel$export(module.exports, "functionOperandInternal", () => $df803c56cdfb962f$export$c1f2ce91dc05872a);


var $gKU15 = parcelRequire("gKU15");
function $df803c56cdfb962f$var$acceptFunctionOperand(visitor) {
    return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
}
function $df803c56cdfb962f$var$enterNode(listener) {
    listener.enterFunctionOperand && listener.enterFunctionOperand(this);
}
function $df803c56cdfb962f$var$exitNode(listener) {
    listener.exitFunctionOperand && listener.exitFunctionOperand(this);
}
function $df803c56cdfb962f$var$getChildren() {
    return [
        this.function,
        ...this.arguments
    ];
}
const $df803c56cdfb962f$export$4f981b0e83488ce = (functionString, args = [])=>$df803c56cdfb962f$export$c1f2ce91dc05872a(functionString, args);
const $df803c56cdfb962f$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
    const node = {
        type: (0, $66bb7f5e87fdacb6$export$d2f212d8ddbc8d1d),
        operandType: (0, $f38290926d0398e2$export$19c7c729db381f9d),
        function: functionString,
        arguments: args,
        position: position,
        accept: $df803c56cdfb962f$var$acceptFunctionOperand,
        enterNode: $df803c56cdfb962f$var$enterNode,
        exitNode: $df803c56cdfb962f$var$exitNode,
        getChildren: $df803c56cdfb962f$var$getChildren,
        parent: null
    };
    (0, $gKU15.assignParent)(node);
    return node;
};

});
const $f38290926d0398e2$export$38accfc5a5d1c113 = 'value';
const $f38290926d0398e2$export$f6049126fd97001f = 'keyword';
const $f38290926d0398e2$export$19c7c729db381f9d = 'function';
const $f38290926d0398e2$export$fabec4aebba3f4df = 'list';
const $f38290926d0398e2$export$1c46dca02aac24dd = 'empty';


parcelRegister("g6LQT", function(module, exports) {

$parcel$export(module.exports, "functionString", () => $b70005ec3b99c7f8$export$4e1bb9a7ff8d0ef9);
$parcel$export(module.exports, "functionStringInternal", () => $b70005ec3b99c7f8$export$7aa9944588b7a69f);

var $a2j0G = parcelRequire("a2j0G");

var $gKU15 = parcelRequire("gKU15");
function $b70005ec3b99c7f8$var$acceptFunctionString(visitor) {
    return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
}
function $b70005ec3b99c7f8$var$enterNode(listener) {
    listener.enterFunction && listener.enterFunction(this);
}
function $b70005ec3b99c7f8$var$exitNode(listener) {
    listener.exitFunction && listener.exitFunction(this);
}
const $b70005ec3b99c7f8$export$4e1bb9a7ff8d0ef9 = (value)=>$b70005ec3b99c7f8$export$7aa9944588b7a69f(value, (0, $a2j0G.sanitiseJqlString)(value));
const $b70005ec3b99c7f8$export$7aa9944588b7a69f = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $b70005ec3b99c7f8$var$acceptFunctionString,
        enterNode: $b70005ec3b99c7f8$var$enterNode,
        exitNode: $b70005ec3b99c7f8$var$exitNode,
        getChildren: (0, $gKU15.noChildren),
        parent: null
    });

});

parcelRegister("7200d", function(module, exports) {

$parcel$export(module.exports, "jast", () => $305a367432a8568f$export$b9e70a00f479ff43);
const $305a367432a8568f$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
        query: query,
        represents: represents,
        errors: errors
    });

});

parcelRegister("dRMnf", function(module, exports) {

$parcel$export(module.exports, "keywordOperand", () => $39515ec1642c0b57$export$2edd4971ed69f2ce);
$parcel$export(module.exports, "keywordOperandInternal", () => $39515ec1642c0b57$export$7cc55480b054047b);


var $gKU15 = parcelRequire("gKU15");
function $39515ec1642c0b57$var$acceptKeywordOperand(visitor) {
    return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
}
function $39515ec1642c0b57$var$enterNode(listener) {
    listener.enterKeywordOperand && listener.enterKeywordOperand(this);
}
function $39515ec1642c0b57$var$exitNode(listener) {
    listener.exitKeywordOperand && listener.exitKeywordOperand(this);
}
const $39515ec1642c0b57$export$2edd4971ed69f2ce = ()=>$39515ec1642c0b57$export$7cc55480b054047b((0, $f38290926d0398e2$export$1c46dca02aac24dd));
const $39515ec1642c0b57$export$7cc55480b054047b = (value, position = null)=>({
        type: (0, $66bb7f5e87fdacb6$export$d2f212d8ddbc8d1d),
        operandType: (0, $f38290926d0398e2$export$f6049126fd97001f),
        value: value,
        position: position,
        accept: $39515ec1642c0b57$var$acceptKeywordOperand,
        enterNode: $39515ec1642c0b57$var$enterNode,
        exitNode: $39515ec1642c0b57$var$exitNode,
        getChildren: (0, $gKU15.noChildren),
        parent: null
    });

});

parcelRegister("gVR58", function(module, exports) {

$parcel$export(module.exports, "listOperand", () => $78935370fa4e42db$export$769866c3e9d41d50);
$parcel$export(module.exports, "listOperandInternal", () => $78935370fa4e42db$export$663c7831528c984b);


var $4OAoG = parcelRequire("4OAoG");

var $gKU15 = parcelRequire("gKU15");
function $78935370fa4e42db$var$acceptListOperand(visitor) {
    return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
}
function $78935370fa4e42db$var$enterNode(listener) {
    listener.enterListOperand && listener.enterListOperand(this);
}
function $78935370fa4e42db$var$exitNode(listener) {
    listener.exitListOperand && listener.exitListOperand(this);
}
function $78935370fa4e42db$var$getChildren() {
    return [
        ...this.values
    ];
}
const $78935370fa4e42db$export$769866c3e9d41d50 = (values)=>$78935370fa4e42db$export$663c7831528c984b(values);
const $78935370fa4e42db$export$663c7831528c984b = (values, position = null)=>{
    const node = {
        type: (0, $66bb7f5e87fdacb6$export$d2f212d8ddbc8d1d),
        operandType: (0, $f38290926d0398e2$export$fabec4aebba3f4df),
        values: values,
        position: position,
        accept: $78935370fa4e42db$var$acceptListOperand,
        enterNode: $78935370fa4e42db$var$enterNode,
        exitNode: $78935370fa4e42db$var$exitNode,
        getChildren: $78935370fa4e42db$var$getChildren,
        parent: null,
        appendOperand: $4OAoG.appendOperand
    };
    (0, $gKU15.assignParent)(node);
    return node;
};

});
parcelRegister("4OAoG", function(module, exports) {

$parcel$export(module.exports, "appendOperand", () => $308acf2918115aae$export$d94c54f1aee177c4);


var $gKU15 = parcelRequire("gKU15");
function $308acf2918115aae$export$d94c54f1aee177c4(operand) {
    this.values.push(...operand.operandType === (0, $f38290926d0398e2$export$fabec4aebba3f4df) ? operand.values : [
        operand
    ]);
    (0, $gKU15.assignParent)(this);
}

});


parcelRegister("bEKhm", function(module, exports) {

$parcel$export(module.exports, "notClause", () => $93e11f6880a8aeb4$export$b4734a9fedb4d44e);
$parcel$export(module.exports, "notClauseInternal", () => $93e11f6880a8aeb4$export$b25621824fea4548);


var $44Ngl = parcelRequire("44Ngl");

var $gKU15 = parcelRequire("gKU15");

var $8aPyf = parcelRequire("8aPyf");
function $93e11f6880a8aeb4$var$acceptNotClause(visitor) {
    return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
}
function $93e11f6880a8aeb4$var$enterNode(listener) {
    listener.enterNotClause && listener.enterNotClause(this);
}
function $93e11f6880a8aeb4$var$exitNode(listener) {
    listener.exitNotClause && listener.exitNotClause(this);
}
function $93e11f6880a8aeb4$var$getChildren() {
    return [
        this.operator,
        this.clause
    ];
}
const $93e11f6880a8aeb4$export$b4734a9fedb4d44e = (clause)=>{
    return $93e11f6880a8aeb4$export$b25621824fea4548(clause, (0, $8aPyf.notClauseOperator)());
};
const $93e11f6880a8aeb4$export$b25621824fea4548 = (clause, operator, position = null)=>{
    const node = {
        type: (0, $66bb7f5e87fdacb6$export$2d205682cc545947),
        clauseType: (0, $27a6760b07fae18c$export$e356b89f8c8d2fcb),
        clause: clause,
        operator: operator,
        position: position,
        accept: $93e11f6880a8aeb4$var$acceptNotClause,
        enterNode: $93e11f6880a8aeb4$var$enterNode,
        exitNode: $93e11f6880a8aeb4$var$exitNode,
        getChildren: $93e11f6880a8aeb4$var$getChildren,
        parent: null,
        remove: $44Ngl.remove,
        removeClause: $44Ngl.removeClause,
        replace: $44Ngl.replace,
        replaceClause: $44Ngl.replaceClause
    };
    (0, $gKU15.assignParent)(node);
    return node;
};

});
parcelRegister("44Ngl", function(module, exports) {

$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);

var $gKU15 = parcelRequire("gKU15");
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    if (this.clause === clause) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    if (this.clause === clause) {
        this.clause = nextClause;
        (0, $gKU15.assignParent)(this);
    }
}

});

parcelRegister("8aPyf", function(module, exports) {

$parcel$export(module.exports, "notClauseOperator", () => $bd6bd728a50411eb$export$d2cd8239f99c13d3);
$parcel$export(module.exports, "notClauseOperatorInternal", () => $bd6bd728a50411eb$export$1b15a32bb57b9020);

var $lNgEH = parcelRequire("lNgEH");

var $gKU15 = parcelRequire("gKU15");
function $bd6bd728a50411eb$var$acceptNotClauseOperator(visitor) {
    return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
}
function $bd6bd728a50411eb$var$enterNode(listener) {
    listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
}
function $bd6bd728a50411eb$var$exitNode(listener) {
    listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
}
const $bd6bd728a50411eb$export$d2cd8239f99c13d3 = ()=>$bd6bd728a50411eb$export$1b15a32bb57b9020();
const $bd6bd728a50411eb$export$1b15a32bb57b9020 = (position = null)=>({
        value: (0, $lNgEH.CLAUSE_OPERATOR_NOT),
        position: position,
        accept: $bd6bd728a50411eb$var$acceptNotClauseOperator,
        enterNode: $bd6bd728a50411eb$var$enterNode,
        exitNode: $bd6bd728a50411eb$var$exitNode,
        getChildren: (0, $gKU15.noChildren),
        parent: null
    });

});
parcelRegister("lNgEH", function(module, exports) {

$parcel$export(module.exports, "CLAUSE_OPERATOR_NOT", () => $21e643d700b625c9$export$c6c71ceedb15cda9);
$parcel$export(module.exports, "OPERATOR_EQUALS", () => $21e643d700b625c9$export$466517a888d00195);
$parcel$export(module.exports, "OPERATOR_NOT_EQUALS", () => $21e643d700b625c9$export$6d0d8810623974a5);
$parcel$export(module.exports, "OPERATOR_GT", () => $21e643d700b625c9$export$bcbb090ab3c498b3);
$parcel$export(module.exports, "OPERATOR_LT", () => $21e643d700b625c9$export$4bf1a4aa659c6ea4);
$parcel$export(module.exports, "OPERATOR_GT_EQUALS", () => $21e643d700b625c9$export$83ce674214a54b2a);
$parcel$export(module.exports, "OPERATOR_LT_EQUALS", () => $21e643d700b625c9$export$9629fd1727ef62ee);
$parcel$export(module.exports, "OPERATOR_IN", () => $21e643d700b625c9$export$c4e3fb55e320e979);
$parcel$export(module.exports, "OPERATOR_NOT_IN", () => $21e643d700b625c9$export$f9857532eaa24ddc);
$parcel$export(module.exports, "OPERATOR_LIKE", () => $21e643d700b625c9$export$221595834b8766ab);
$parcel$export(module.exports, "OPERATOR_NOT_LIKE", () => $21e643d700b625c9$export$fcefabf94a9bffbf);
$parcel$export(module.exports, "OPERATOR_IS", () => $21e643d700b625c9$export$4feeb3f4ff56bcef);
$parcel$export(module.exports, "OPERATOR_IS_NOT", () => $21e643d700b625c9$export$d08d969a0da27188);
$parcel$export(module.exports, "OPERATOR_WAS", () => $21e643d700b625c9$export$8f907e179985256d);
$parcel$export(module.exports, "OPERATOR_WAS_IN", () => $21e643d700b625c9$export$cc7b9d0b3ee23193);
$parcel$export(module.exports, "OPERATOR_WAS_NOT_IN", () => $21e643d700b625c9$export$585d3c004af078bb);
$parcel$export(module.exports, "OPERATOR_WAS_NOT", () => $21e643d700b625c9$export$123eaa9ccc2d9445);
$parcel$export(module.exports, "OPERATOR_CHANGED", () => $21e643d700b625c9$export$15f5b446ba8c941e);
$parcel$export(module.exports, "EQUALS_OPERATORS", () => $21e643d700b625c9$export$643c6101f3fc8547);
$parcel$export(module.exports, "LIKE_OPERATORS", () => $21e643d700b625c9$export$329664c9cf18cca6);
$parcel$export(module.exports, "COMPARISON_OPERATORS", () => $21e643d700b625c9$export$1b167a3705885a8b);
$parcel$export(module.exports, "IN_OPERATORS", () => $21e643d700b625c9$export$f25cf16c2270312f);
$parcel$export(module.exports, "IS_OPERATORS", () => $21e643d700b625c9$export$eb58cfffe4a6b805);
$parcel$export(module.exports, "WAS_OPERATORS", () => $21e643d700b625c9$export$c22a981f581de218);
$parcel$export(module.exports, "WAS_IN_OPERATORS", () => $21e643d700b625c9$export$6d08c4699bb75284);
$parcel$export(module.exports, "CHANGED_OPERATORS", () => $21e643d700b625c9$export$b7dc214eef214c1c);
$parcel$export(module.exports, "OPERATORS", () => $21e643d700b625c9$export$184799fc79ccac89);
$parcel$export(module.exports, "LIST_OPERATORS", () => $21e643d700b625c9$export$77c793736847e030);
const $21e643d700b625c9$export$c6c71ceedb15cda9 = 'not';
const $21e643d700b625c9$export$466517a888d00195 = '=';
const $21e643d700b625c9$export$6d0d8810623974a5 = '!=';
const $21e643d700b625c9$export$bcbb090ab3c498b3 = '>';
const $21e643d700b625c9$export$4bf1a4aa659c6ea4 = '<';
const $21e643d700b625c9$export$83ce674214a54b2a = '>=';
const $21e643d700b625c9$export$9629fd1727ef62ee = '<=';
const $21e643d700b625c9$export$c4e3fb55e320e979 = 'in';
const $21e643d700b625c9$export$f9857532eaa24ddc = 'not in';
const $21e643d700b625c9$export$221595834b8766ab = '~';
const $21e643d700b625c9$export$fcefabf94a9bffbf = '!~';
const $21e643d700b625c9$export$4feeb3f4ff56bcef = 'is';
const $21e643d700b625c9$export$d08d969a0da27188 = 'is not';
const $21e643d700b625c9$export$8f907e179985256d = 'was';
const $21e643d700b625c9$export$cc7b9d0b3ee23193 = 'was in';
const $21e643d700b625c9$export$585d3c004af078bb = 'was not in';
const $21e643d700b625c9$export$123eaa9ccc2d9445 = 'was not';
const $21e643d700b625c9$export$15f5b446ba8c941e = 'changed';
const $21e643d700b625c9$export$643c6101f3fc8547 = [
    $21e643d700b625c9$export$466517a888d00195,
    $21e643d700b625c9$export$6d0d8810623974a5
];
const $21e643d700b625c9$export$329664c9cf18cca6 = [
    $21e643d700b625c9$export$221595834b8766ab,
    $21e643d700b625c9$export$fcefabf94a9bffbf
];
const $21e643d700b625c9$export$1b167a3705885a8b = [
    $21e643d700b625c9$export$4bf1a4aa659c6ea4,
    $21e643d700b625c9$export$bcbb090ab3c498b3,
    $21e643d700b625c9$export$9629fd1727ef62ee,
    $21e643d700b625c9$export$83ce674214a54b2a
];
const $21e643d700b625c9$export$f25cf16c2270312f = [
    $21e643d700b625c9$export$c4e3fb55e320e979,
    $21e643d700b625c9$export$f9857532eaa24ddc
];
const $21e643d700b625c9$export$eb58cfffe4a6b805 = [
    $21e643d700b625c9$export$4feeb3f4ff56bcef,
    $21e643d700b625c9$export$d08d969a0da27188
];
const $21e643d700b625c9$export$c22a981f581de218 = [
    $21e643d700b625c9$export$8f907e179985256d,
    $21e643d700b625c9$export$123eaa9ccc2d9445
];
const $21e643d700b625c9$export$6d08c4699bb75284 = [
    $21e643d700b625c9$export$cc7b9d0b3ee23193,
    $21e643d700b625c9$export$585d3c004af078bb
];
const $21e643d700b625c9$export$b7dc214eef214c1c = [
    $21e643d700b625c9$export$15f5b446ba8c941e
];
const $21e643d700b625c9$export$184799fc79ccac89 = [
    ...$21e643d700b625c9$export$643c6101f3fc8547,
    ...$21e643d700b625c9$export$329664c9cf18cca6,
    ...$21e643d700b625c9$export$1b167a3705885a8b,
    ...$21e643d700b625c9$export$f25cf16c2270312f,
    ...$21e643d700b625c9$export$eb58cfffe4a6b805,
    ...$21e643d700b625c9$export$c22a981f581de218,
    ...$21e643d700b625c9$export$6d08c4699bb75284,
    ...$21e643d700b625c9$export$b7dc214eef214c1c
];
const $21e643d700b625c9$export$77c793736847e030 = [
    $21e643d700b625c9$export$c4e3fb55e320e979,
    $21e643d700b625c9$export$f9857532eaa24ddc,
    $21e643d700b625c9$export$cc7b9d0b3ee23193,
    $21e643d700b625c9$export$585d3c004af078bb
];

});



parcelRegister("lHgaC", function(module, exports) {

$parcel$export(module.exports, "operator", () => $70c1133afc9f4066$export$dbd72860f701d4f3);
$parcel$export(module.exports, "operatorInternal", () => $70c1133afc9f4066$export$649025bc60ab9c3b);

var $gKU15 = parcelRequire("gKU15");
function $70c1133afc9f4066$var$acceptOperator(visitor) {
    return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
}
function $70c1133afc9f4066$var$enterNode(listener) {
    listener.enterOperator && listener.enterOperator(this);
}
function $70c1133afc9f4066$var$exitNode(listener) {
    listener.exitOperator && listener.exitOperator(this);
}
const $70c1133afc9f4066$export$dbd72860f701d4f3 = (value)=>$70c1133afc9f4066$export$649025bc60ab9c3b(value, value);
const $70c1133afc9f4066$export$649025bc60ab9c3b = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $70c1133afc9f4066$var$acceptOperator,
        enterNode: $70c1133afc9f4066$var$enterNode,
        exitNode: $70c1133afc9f4066$var$exitNode,
        getChildren: (0, $gKU15.noChildren),
        parent: null
    });

});

parcelRegister("6eoxd", function(module, exports) {

$parcel$export(module.exports, "orderBy", () => $3cbd4ff7217d92d1$export$f18af21d6f4dafd8);
$parcel$export(module.exports, "orderByInternal", () => $3cbd4ff7217d92d1$export$e4eb1fa6bc8465c1);


var $5fMBC = parcelRequire("5fMBC");

var $gKU15 = parcelRequire("gKU15");

var $alArd = parcelRequire("alArd");
function $3cbd4ff7217d92d1$var$acceptOrderBy(visitor) {
    return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
}
function $3cbd4ff7217d92d1$var$enterNode(listener) {
    listener.enterOrderBy && listener.enterOrderBy(this);
}
function $3cbd4ff7217d92d1$var$exitNode(listener) {
    listener.exitOrderBy && listener.exitOrderBy(this);
}
function $3cbd4ff7217d92d1$var$getChildren() {
    return [
        this.operator,
        ...this.fields
    ];
}
const $3cbd4ff7217d92d1$export$f18af21d6f4dafd8 = (fields)=>{
    return $3cbd4ff7217d92d1$export$e4eb1fa6bc8465c1(fields, (0, $alArd.orderByOperator)());
};
const $3cbd4ff7217d92d1$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
    const node = {
        type: (0, $66bb7f5e87fdacb6$export$da0f73edded4a63d),
        operator: operator,
        fields: fields,
        position: position,
        accept: $3cbd4ff7217d92d1$var$acceptOrderBy,
        enterNode: $3cbd4ff7217d92d1$var$enterNode,
        exitNode: $3cbd4ff7217d92d1$var$exitNode,
        getChildren: $3cbd4ff7217d92d1$var$getChildren,
        parent: null,
        prependOrderField: $5fMBC.prependOrderField,
        setOrderDirection: $5fMBC.setOrderDirection,
        replace: $5fMBC.replace,
        replaceOrderField: $5fMBC.replaceOrderField,
        remove: $5fMBC.remove,
        removeOrderField: $5fMBC.removeOrderField
    };
    (0, $gKU15.assignParent)(node);
    return node;
};

});
parcelRegister("5fMBC", function(module, exports) {

$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceOrderField", () => replaceOrderField);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeOrderField", () => removeOrderField);

var $gKU15 = parcelRequire("gKU15");
function prependOrderField(orderField) {
    this.fields.unshift(orderField);
    (0, $gKU15.assignParent)(this);
}
function setOrderDirection(orderDirection) {
    if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
}
function replace(nextOrderBy) {
    if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
}
function replaceOrderField(orderByField, nextOrderByField) {
    this.fields = this.fields.map((child)=>{
        return child === orderByField ? nextOrderByField : child;
    });
    (0, $gKU15.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeOrderBy();
}
function removeOrderField(orderByField) {
    this.fields = this.fields.filter((field)=>field !== orderByField);
    if (this.fields.length === 0) this.remove();
}

});

parcelRegister("alArd", function(module, exports) {

$parcel$export(module.exports, "orderByOperator", () => $599b999bec0347d3$export$c7307b67924c61ea);
$parcel$export(module.exports, "orderByOperatorInternal", () => $599b999bec0347d3$export$739e30af23a08da0);


var $gKU15 = parcelRequire("gKU15");
function $599b999bec0347d3$var$acceptOrderByOperator(visitor) {
    return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
}
function $599b999bec0347d3$var$enterNode(listener) {
    listener.enterOrderByOperator && listener.enterOrderByOperator(this);
}
function $599b999bec0347d3$var$exitNode(listener) {
    listener.exitOrderByOperator && listener.exitOrderByOperator(this);
}
const $599b999bec0347d3$export$c7307b67924c61ea = ()=>$599b999bec0347d3$export$739e30af23a08da0();
const $599b999bec0347d3$export$739e30af23a08da0 = (position = null)=>({
        value: (0, $8ff9fbbb483161a6$export$ca51f5fd60a74517),
        position: position,
        accept: $599b999bec0347d3$var$acceptOrderByOperator,
        enterNode: $599b999bec0347d3$var$enterNode,
        exitNode: $599b999bec0347d3$var$exitNode,
        getChildren: (0, $gKU15.noChildren),
        parent: null
    });

});
const $8ff9fbbb483161a6$export$ca51f5fd60a74517 = 'ORDER BY';
const $8ff9fbbb483161a6$export$6d60017b9e092e73 = 'ASC';
const $8ff9fbbb483161a6$export$2ea27ea5f2121899 = 'DESC';



parcelRegister("3yf4i", function(module, exports) {

$parcel$export(module.exports, "orderByDirection", () => $7488d2eb38fb8138$export$864d934efed3ccaa);
$parcel$export(module.exports, "orderByDirectionInternal", () => $7488d2eb38fb8138$export$8c65cac1a7852d1f);

var $gKU15 = parcelRequire("gKU15");
function $7488d2eb38fb8138$var$acceptOrderByDirection(visitor) {
    return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
}
function $7488d2eb38fb8138$var$enterNode(listener) {
    listener.enterOrderByDirection && listener.enterOrderByDirection(this);
}
function $7488d2eb38fb8138$var$exitNode(listener) {
    listener.exitOrderByDirection && listener.exitOrderByDirection(this);
}
const $7488d2eb38fb8138$export$864d934efed3ccaa = (value)=>$7488d2eb38fb8138$export$8c65cac1a7852d1f(value);
const $7488d2eb38fb8138$export$8c65cac1a7852d1f = (value, position = null)=>({
        value: value,
        position: position,
        accept: $7488d2eb38fb8138$var$acceptOrderByDirection,
        enterNode: $7488d2eb38fb8138$var$enterNode,
        exitNode: $7488d2eb38fb8138$var$exitNode,
        getChildren: (0, $gKU15.noChildren),
        parent: null
    });

});

parcelRegister("99bXG", function(module, exports) {

$parcel$export(module.exports, "orderByField", () => $409974c6c0b3ede1$export$942df63e5e3d3899);
$parcel$export(module.exports, "orderByFieldInternal", () => $409974c6c0b3ede1$export$661a7786e3d15926);

var $8o1t5 = parcelRequire("8o1t5");

var $gKU15 = parcelRequire("gKU15");
function $409974c6c0b3ede1$var$acceptOrderByField(visitor) {
    return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
}
function $409974c6c0b3ede1$var$enterNode(listener) {
    listener.enterOrderByField && listener.enterOrderByField(this);
}
function $409974c6c0b3ede1$var$exitNode(listener) {
    listener.exitOrderByField && listener.exitOrderByField(this);
}
function $409974c6c0b3ede1$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.direction) children.push(this.direction);
    return children;
}
const $409974c6c0b3ede1$export$942df63e5e3d3899 = (field, direction)=>$409974c6c0b3ede1$export$661a7786e3d15926(field, direction);
const $409974c6c0b3ede1$export$661a7786e3d15926 = (field, direction, position = null)=>{
    const node = {
        field: field,
        direction: direction,
        position: position,
        accept: $409974c6c0b3ede1$var$acceptOrderByField,
        enterNode: $409974c6c0b3ede1$var$enterNode,
        exitNode: $409974c6c0b3ede1$var$exitNode,
        getChildren: $409974c6c0b3ede1$var$getChildren,
        parent: null,
        setOrderDirection: $8o1t5.setOrderDirection,
        replace: $8o1t5.replace,
        remove: $8o1t5.remove
    };
    (0, $gKU15.assignParent)(node);
    return node;
};

});
parcelRegister("8o1t5", function(module, exports) {

$parcel$export(module.exports, "setOrderDirection", () => $0ce9b68ea05905ea$export$b596730931a09703);
$parcel$export(module.exports, "replace", () => $0ce9b68ea05905ea$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "remove", () => $0ce9b68ea05905ea$export$cd7f480d6b8286c3);

var $gKU15 = parcelRequire("gKU15");
function $0ce9b68ea05905ea$export$b596730931a09703(orderDirection) {
    this.direction = orderDirection;
    (0, $gKU15.assignParent)(this);
}
function $0ce9b68ea05905ea$export$77ad94ebf1c2b9ed(orderByField) {
    if (this.parent) this.parent.replaceOrderField(this, orderByField);
}
function $0ce9b68ea05905ea$export$cd7f480d6b8286c3() {
    if (this.parent) this.parent.removeOrderField(this);
}

});


parcelRegister("4L5nY", function(module, exports) {

$parcel$export(module.exports, "predicate", () => $25793786e976dd9b$export$5fc51e445ce24faf);
$parcel$export(module.exports, "predicateInternal", () => $25793786e976dd9b$export$a767a27ad05a38a2);

var $gKU15 = parcelRequire("gKU15");
function $25793786e976dd9b$var$acceptPredicate(visitor) {
    return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
}
function $25793786e976dd9b$var$enterNode(listener) {
    listener.enterPredicate && listener.enterPredicate(this);
}
function $25793786e976dd9b$var$exitNode(listener) {
    listener.exitPredicate && listener.exitPredicate(this);
}
function $25793786e976dd9b$var$getChildren() {
    const children = [
        this.operator
    ];
    if (this.operand) children.push(this.operand);
    return children;
}
const $25793786e976dd9b$export$5fc51e445ce24faf = (operator, operand)=>$25793786e976dd9b$export$a767a27ad05a38a2(operator, operand);
const $25793786e976dd9b$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
    const node = {
        operator: operator,
        operand: operand,
        position: position,
        accept: $25793786e976dd9b$var$acceptPredicate,
        enterNode: $25793786e976dd9b$var$enterNode,
        exitNode: $25793786e976dd9b$var$exitNode,
        getChildren: $25793786e976dd9b$var$getChildren,
        parent: null
    };
    (0, $gKU15.assignParent)(node);
    return node;
};

});

parcelRegister("9wCiv", function(module, exports) {

$parcel$export(module.exports, "predicateOperator", () => $b1619889d01edc54$export$5419b7f16910ea62);
$parcel$export(module.exports, "predicateOperatorInternal", () => $b1619889d01edc54$export$c69d893689716768);

var $gKU15 = parcelRequire("gKU15");
function $b1619889d01edc54$var$acceptPredicateOperator(visitor) {
    return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
}
function $b1619889d01edc54$var$enterNode(listener) {
    listener.enterPredicateOperator && listener.enterPredicateOperator(this);
}
function $b1619889d01edc54$var$exitNode(listener) {
    listener.exitPredicateOperator && listener.exitPredicateOperator(this);
}
const $b1619889d01edc54$export$5419b7f16910ea62 = (value)=>$b1619889d01edc54$export$c69d893689716768(value, value);
const $b1619889d01edc54$export$c69d893689716768 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $b1619889d01edc54$var$acceptPredicateOperator,
        enterNode: $b1619889d01edc54$var$enterNode,
        exitNode: $b1619889d01edc54$var$exitNode,
        getChildren: (0, $gKU15.noChildren),
        parent: null
    });

});

parcelRegister("4gvny", function(module, exports) {

$parcel$export(module.exports, "property", () => $f7f91dcb71e25012$export$d541bacb2bda4494);
$parcel$export(module.exports, "propertyInternal", () => $f7f91dcb71e25012$export$1cbd90994fef1fad);

var $gKU15 = parcelRequire("gKU15");
function $f7f91dcb71e25012$var$acceptProperty(visitor) {
    return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
}
function $f7f91dcb71e25012$var$enterNode(listener) {
    listener.enterProperty && listener.enterProperty(this);
}
function $f7f91dcb71e25012$var$exitNode(listener) {
    listener.exitProperty && listener.exitProperty(this);
}
function $f7f91dcb71e25012$var$getChildren() {
    const children = [];
    if (this.key) children.push(this.key);
    if (this.path) return children.concat(this.path);
    return children;
}
const $f7f91dcb71e25012$export$d541bacb2bda4494 = (key, path = [])=>$f7f91dcb71e25012$export$1cbd90994fef1fad(key, path);
const $f7f91dcb71e25012$export$1cbd90994fef1fad = (key, path, position = null)=>{
    const node = {
        key: key,
        path: path,
        position: position,
        accept: $f7f91dcb71e25012$var$acceptProperty,
        enterNode: $f7f91dcb71e25012$var$enterNode,
        exitNode: $f7f91dcb71e25012$var$exitNode,
        getChildren: $f7f91dcb71e25012$var$getChildren,
        parent: null
    };
    (0, $gKU15.assignParent)(node);
    return node;
};

});

parcelRegister("7cmts", function(module, exports) {

$parcel$export(module.exports, "query", () => $dc7f446bd3d44849$export$2fa187e846a241c4);
$parcel$export(module.exports, "queryInternal", () => $dc7f446bd3d44849$export$bc2d6e2e1fd9014);


var $eZIyT = parcelRequire("eZIyT");

var $gKU15 = parcelRequire("gKU15");
/**
 * AstNode accept functions. We define them outside of the creator function so the same function reference is returned
 * when a creator is invoked multiple times (which is helpful when testing for equality of AST objects).
 */ function $dc7f446bd3d44849$var$acceptQuery(visitor) {
    return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
}
function $dc7f446bd3d44849$var$enterNode(listener) {
    listener.enterQuery && listener.enterQuery(this);
}
function $dc7f446bd3d44849$var$exitNode(listener) {
    listener.exitQuery && listener.exitQuery(this);
}
function $dc7f446bd3d44849$var$getChildren() {
    const children = [];
    if (this.where) children.push(this.where);
    if (this.orderBy) children.push(this.orderBy);
    return children;
}
const $dc7f446bd3d44849$export$2fa187e846a241c4 = (where, orderBy)=>$dc7f446bd3d44849$export$bc2d6e2e1fd9014(where, orderBy);
const $dc7f446bd3d44849$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
    const node = {
        type: (0, $66bb7f5e87fdacb6$export$98dda21ec825792),
        where: where,
        orderBy: orderBy,
        position: position,
        accept: $dc7f446bd3d44849$var$acceptQuery,
        enterNode: $dc7f446bd3d44849$var$enterNode,
        exitNode: $dc7f446bd3d44849$var$exitNode,
        getChildren: $dc7f446bd3d44849$var$getChildren,
        parent: null,
        appendClause: $eZIyT.appendClause,
        prependOrderField: $eZIyT.prependOrderField,
        setOrderDirection: $eZIyT.setOrderDirection,
        removeClause: $eZIyT.removeClause,
        replaceClause: $eZIyT.replaceClause,
        replaceOrderBy: $eZIyT.replaceOrderBy,
        removeOrderBy: $eZIyT.removeOrderBy
    };
    (0, $gKU15.assignParent)(node);
    return node;
};

});
parcelRegister("eZIyT", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replaceOrderBy", () => replaceOrderBy);
$parcel$export(module.exports, "replaceClause", () => replaceClause);
$parcel$export(module.exports, "removeOrderBy", () => removeOrderBy);

var $2poie = parcelRequire("2poie");

var $gKU15 = parcelRequire("gKU15");
function appendClause(clause, compoundOperatorValue) {
    if (!this.where) this.where = clause;
    else {
        const nextCompoundOperator = (0, $2poie.default).compoundOperator(compoundOperatorValue);
        const nextClause = (0, $2poie.default).compoundClause(nextCompoundOperator, []);
        // Append previous and new clause which will flatten compound clauses with matching operators.
        nextClause.appendClause(this.where);
        nextClause.appendClause(clause);
        this.where = nextClause;
    }
    (0, $gKU15.assignParent)(this);
}
function prependOrderField(orderField) {
    if (!this.orderBy) {
        this.orderBy = (0, $2poie.default).orderBy([
            orderField
        ]);
        (0, $gKU15.assignParent)(this);
    } else this.orderBy.prependOrderField(orderField);
}
function setOrderDirection(orderDirection) {
    if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
}
function removeClause(clause) {
    if (this.where === clause) this.where = undefined;
}
function replaceOrderBy(orderBy) {
    if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
    else {
        this.orderBy = orderBy;
        (0, $gKU15.assignParent)(this);
    }
}
function replaceClause(clause, nextClause) {
    if (this.where === clause) {
        this.where = nextClause;
        (0, $gKU15.assignParent)(this);
    }
}
function removeOrderBy() {
    this.orderBy = undefined;
}

});


parcelRegister("cVKku", function(module, exports) {

$parcel$export(module.exports, "terminalClause", () => $a2811d092b773481$export$2627cbe08dd86b00);
$parcel$export(module.exports, "terminalClauseInternal", () => $a2811d092b773481$export$cc08e43598d091fc);


var $ayksV = parcelRequire("ayksV");

var $gKU15 = parcelRequire("gKU15");
function $a2811d092b773481$var$acceptTerminalClause(visitor) {
    return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
}
function $a2811d092b773481$var$enterNode(listener) {
    listener.enterTerminalClause && listener.enterTerminalClause(this);
}
function $a2811d092b773481$var$exitNode(listener) {
    listener.exitTerminalClause && listener.exitTerminalClause(this);
}
function $a2811d092b773481$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.operator) children.push(this.operator);
    if (this.operand) children.push(this.operand);
    return children.concat(this.predicates);
}
const $a2811d092b773481$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
    return $a2811d092b773481$export$cc08e43598d091fc(field, operator, operand, predicates);
};
const $a2811d092b773481$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
    const node = {
        type: (0, $66bb7f5e87fdacb6$export$2d205682cc545947),
        clauseType: (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a),
        field: field,
        operator: operator,
        operand: operand,
        predicates: predicates,
        position: position,
        accept: $a2811d092b773481$var$acceptTerminalClause,
        enterNode: $a2811d092b773481$var$enterNode,
        exitNode: $a2811d092b773481$var$exitNode,
        getChildren: $a2811d092b773481$var$getChildren,
        parent: null,
        setOperator: $ayksV.setOperator,
        setOperand: $ayksV.setOperand,
        appendOperand: $ayksV.appendOperand,
        remove: $ayksV.remove,
        replace: $ayksV.replace
    };
    (0, $gKU15.assignParent)(node);
    return node;
};

});
parcelRegister("ayksV", function(module, exports) {

$parcel$export(module.exports, "setOperator", () => setOperator);
$parcel$export(module.exports, "setOperand", () => setOperand);
$parcel$export(module.exports, "appendOperand", () => appendOperand);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replace", () => replace);


var $2poie = parcelRequire("2poie");

var $gKU15 = parcelRequire("gKU15");
function setOperator(operator) {
    this.operator = operator;
    (0, $gKU15.assignParent)(this);
}
function setOperand(operand) {
    this.operand = operand;
    (0, $gKU15.assignParent)(this);
}
function appendOperand(operand) {
    if (this.operand) {
        if (this.operand.operandType === (0, $f38290926d0398e2$export$fabec4aebba3f4df)) this.operand.appendOperand(operand);
        else this.setOperand((0, $2poie.default).listOperand([
            this.operand,
            ...operand.operandType === (0, $f38290926d0398e2$export$fabec4aebba3f4df) ? operand.values : [
                operand
            ]
        ]));
    } else this.setOperand(operand);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}

});


parcelRegister("7tmhC", function(module, exports) {

$parcel$export(module.exports, "valueOperand", () => $ea094a15c420fbf6$export$2b6e4d2ed8d53bf3);
$parcel$export(module.exports, "valueOperandInternal", () => $ea094a15c420fbf6$export$79c37d97caac8627);
$parcel$export(module.exports, "valueOperandByText", () => $ea094a15c420fbf6$export$3ac9155bde56a45f);


var $5ydaD = parcelRequire("5ydaD");
var $a2j0G = parcelRequire("a2j0G");

var $gKU15 = parcelRequire("gKU15");
function $ea094a15c420fbf6$var$acceptValueOperand(visitor) {
    return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
}
function $ea094a15c420fbf6$var$enterNode(listener) {
    listener.enterValueOperand && listener.enterValueOperand(this);
}
function $ea094a15c420fbf6$var$exitNode(listener) {
    listener.exitValueOperand && listener.exitValueOperand(this);
}
const $ea094a15c420fbf6$export$2b6e4d2ed8d53bf3 = (value)=>$ea094a15c420fbf6$export$79c37d97caac8627(value, (0, $a2j0G.sanitiseJqlString)(value));
const $ea094a15c420fbf6$export$3ac9155bde56a45f = (text)=>$ea094a15c420fbf6$export$79c37d97caac8627((0, $5ydaD.normaliseJqlString)(text), text);
const $ea094a15c420fbf6$export$79c37d97caac8627 = (value, text, position = null)=>({
        type: (0, $66bb7f5e87fdacb6$export$d2f212d8ddbc8d1d),
        operandType: (0, $f38290926d0398e2$export$38accfc5a5d1c113),
        text: text,
        value: value,
        position: position,
        accept: $ea094a15c420fbf6$var$acceptValueOperand,
        enterNode: $ea094a15c420fbf6$var$enterNode,
        exitNode: $ea094a15c420fbf6$var$exitNode,
        getChildren: (0, $gKU15.noChildren),
        parent: null
    });

});


parcelRegister("eM3Eu", function(module, exports) {

$parcel$export(module.exports, "JastBuilder", () => $6f448c98bba7dd3c$export$99cae18a5a6ba8cf);

var $jz1xX = parcelRequire("jz1xX");

var $LFmXM = parcelRequire("LFmXM");

var $lznor = parcelRequire("lznor");
var $7UI9e = parcelRequire("7UI9e");

var $2poie = parcelRequire("2poie");

var $j2mvV = parcelRequire("j2mvV");
var $aAJVH = parcelRequire("aAJVH");

var $fvDF4 = parcelRequire("fvDF4");
class $6f448c98bba7dd3c$export$99cae18a5a6ba8cf {
    setErrorHandler(errorHandler) {
        this.errorHandler = errorHandler;
        return this;
    }
    setErrorListeners(errorListeners) {
        this.errorListeners = this.errorListeners.concat(errorListeners);
        return this;
    }
    build(value) {
        const tokens = this.getTokens(value);
        const parser = this.getParser(tokens);
        const astErrorListener = new (0, $j2mvV.JastBuilderErrorListener)();
        parser.removeErrorListeners();
        parser.addErrorListener(astErrorListener);
        this.errorListeners.forEach((errorListener)=>parser.addErrorListener(errorListener));
        if (this.errorHandler) {
            parser.errorHandler = this.errorHandler;
            this.errorHandler.reset(parser);
        }
        const visitor = new (0, $fvDF4.QueryVisitor)(tokens);
        try {
            const parseTree = parser.jqlQuery();
            const query = parseTree.accept(visitor);
            return (0, $2poie.default).jast(query, value, astErrorListener.errors);
        } catch (error) {
            return (0, $2poie.default).jast(undefined, value, [
                new (0, $aAJVH.JQLParseError)(error.message, error)
            ]);
        }
    }
    constructor(){
        this.errorListeners = [];
        this.errorHandler = undefined;
        this.getTokens = (0, $LFmXM.default)((value)=>{
            const chars = (0, $jz1xX.CharStreams).fromString(value);
            const lexer = new (0, $lznor.JQLLexer)(chars);
            return new (0, $jz1xX.CommonTokenStream)(lexer);
        });
        this.getParser = (0, $LFmXM.default)((tokens)=>new (0, $7UI9e.JQLParser)(tokens));
    }
}

});
parcelRegister("jz1xX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e3e27c5f9836a7a6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e3e27c5f9836a7a6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e3e27c5f9836a7a6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("gZZg5")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("86N5m")), module.exports);

// export * from "./ANTLRFileStream";
$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("7ERej")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("jY97w")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("h5rBk")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("cBsOS")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("d0TlQ")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("3wxwf")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("lXg5i")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("8Mk1Z")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("arOt9")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("1y11S")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("b6VR9")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("cNbax")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("6gsRs")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("4Allj")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("d7mTm")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("6iuj6")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("2iaul")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("d4sFB")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("gTQRB")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("8I7Eq")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("6Npyx")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("8tp3s")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("4qcTm")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("dDGsq")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("bvca3")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("djIaX")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("5NlfZ")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("adfkv")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("ct3k0")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("lWPhg")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("24a4y")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("1uFvm")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("gBCh3")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("9moap")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("iB1aK")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("2G93d")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("5fKqt")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("dAoWy")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("kKHPj")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("3sjft")), module.exports);

// export * from "./UnbufferedCharStream";
// export * from "./UnbufferedTokenStream";
$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("7twhW")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("5t4I3")), module.exports);

$e3e27c5f9836a7a6$var$__exportStar((parcelRequire("7kyUa")), module.exports);

});
parcelRegister("gZZg5", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("86N5m", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7ERej", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ // ConvertTo-TS run at 2016-10-04T11:26:49.0828748-07:00
var $59358f274fb6c10c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ANTLRInputStream = void 0;

var $gwEr2 = parcelRequire("gwEr2");

var $esDFm = parcelRequire("esDFm");

var $d4sFB = parcelRequire("d4sFB");
const $59358f274fb6c10c$var$READ_BUFFER_SIZE = 1024;
const $59358f274fb6c10c$var$INITIAL_BUFFER_SIZE = 1024;
/**
 * Vacuum all input from a {@link Reader}/{@link InputStream} and then treat it
 * like a `char[]` buffer. Can also pass in a {@link String} or
 * `char[]` to use.
 *
 * If you need encoding, pass in stream/reader with correct encoding.
 *
 * @deprecated as of 4.7, please use `CharStreams` interface.
 */ class $59358f274fb6c10c$var$ANTLRInputStream {
    /** Copy data in string to a local char array */ constructor(input){
        /** 0..n-1 index into string of next char */ this.p = 0;
        this.data = input;
        this.n = input.length;
    }
    /** Reset the stream so that it's in the same state it was
     *  when the object was created *except* the data array is not
     *  touched.
     */ reset() {
        this.p = 0;
    }
    consume() {
        if (this.p >= this.n) {
            $gwEr2(this.LA(1) === $d4sFB.IntStream.EOF);
            throw new Error("cannot consume EOF");
        }
        //System.out.println("prev p="+p+", c="+(char)data[p]);
        if (this.p < this.n) this.p++;
    }
    LA(i) {
        if (i === 0) return 0; // undefined
        if (i < 0) {
            i++; // e.g., translate LA(-1) to use offset i=0; then data[p+0-1]
            if (this.p + i - 1 < 0) return $d4sFB.IntStream.EOF; // invalid; no char before first char
        }
        if (this.p + i - 1 >= this.n) //System.out.println("char LA("+i+")=EOF; p="+p);
        return $d4sFB.IntStream.EOF;
        //System.out.println("char LA("+i+")="+(char)data[p+i-1]+"; p="+p);
        //System.out.println("LA("+i+"); p="+p+" n="+n+" data.length="+data.length);
        return this.data.charCodeAt(this.p + i - 1);
    }
    LT(i) {
        return this.LA(i);
    }
    /** Return the current input symbol index 0..n where n indicates the
     *  last symbol has been read.  The index is the index of char to
     *  be returned from LA(1).
     */ get index() {
        return this.p;
    }
    get size() {
        return this.n;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    /** consume() ahead until p==index; can't just set p=index as we must
     *  update line and charPositionInLine. If we seek backwards, just set p
     */ seek(index) {
        if (index <= this.p) {
            this.p = index; // just jump; don't update stream state (line, ...)
            return;
        }
        // seek forward, consume until p hits index or n (whichever comes first)
        index = Math.min(index, this.n);
        while(this.p < index)this.consume();
    }
    getText(interval) {
        let start = interval.a;
        let stop = interval.b;
        if (stop >= this.n) stop = this.n - 1;
        let count = stop - start + 1;
        if (start >= this.n) return "";
        // System.err.println("data: "+Arrays.toString(data)+", n="+n+
        // 				   ", start="+start+
        // 				   ", stop="+stop);
        return this.data.substr(start, count);
    }
    get sourceName() {
        if (!this.name) return $d4sFB.IntStream.UNKNOWN_SOURCE_NAME;
        return this.name;
    }
    toString() {
        return this.data;
    }
}
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "consume", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "LA", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "index", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "size", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "mark", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "release", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "seek", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "getText", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "sourceName", null);
$59358f274fb6c10c$var$__decorate([
    $esDFm.Override
], $59358f274fb6c10c$var$ANTLRInputStream.prototype, "toString", null);
module.exports.ANTLRInputStream = $59358f274fb6c10c$var$ANTLRInputStream;

});
parcelRegister("gwEr2", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $igDjg = parcelRequire("igDjg");
'use strict';
function $c07f0014105f4d3c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c07f0014105f4d3c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c07f0014105f4d3c$var$_typeof(o);
}
function $c07f0014105f4d3c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c07f0014105f4d3c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c07f0014105f4d3c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c07f0014105f4d3c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c07f0014105f4d3c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c07f0014105f4d3c$var$_toPropertyKey(arg) {
    var key = $c07f0014105f4d3c$var$_toPrimitive(arg, "string");
    return $c07f0014105f4d3c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c07f0014105f4d3c$var$_toPrimitive(input, hint) {
    if ($c07f0014105f4d3c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c07f0014105f4d3c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c07f0014105f4d3c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $9Ej6r = parcelRequire("9Ej6r");
var $c07f0014105f4d3c$var$_require$codes = $9Ej6r.codes, $c07f0014105f4d3c$var$ERR_AMBIGUOUS_ARGUMENT = $c07f0014105f4d3c$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE = $c07f0014105f4d3c$var$_require$codes.ERR_INVALID_ARG_TYPE, $c07f0014105f4d3c$var$ERR_INVALID_ARG_VALUE = $c07f0014105f4d3c$var$_require$codes.ERR_INVALID_ARG_VALUE, $c07f0014105f4d3c$var$ERR_INVALID_RETURN_VALUE = $c07f0014105f4d3c$var$_require$codes.ERR_INVALID_RETURN_VALUE, $c07f0014105f4d3c$var$ERR_MISSING_ARGS = $c07f0014105f4d3c$var$_require$codes.ERR_MISSING_ARGS;

var $jc4ou = parcelRequire("jc4ou");

var $7WF8Y = parcelRequire("7WF8Y");
var $c07f0014105f4d3c$var$inspect = $7WF8Y.inspect;

var $7WF8Y = parcelRequire("7WF8Y");
var $c07f0014105f4d3c$require$_require$types = $7WF8Y.types;
var $c07f0014105f4d3c$var$isPromise = $c07f0014105f4d3c$require$_require$types.isPromise, $c07f0014105f4d3c$var$isRegExp = $c07f0014105f4d3c$require$_require$types.isRegExp;

var $c07f0014105f4d3c$var$objectAssign = (parcelRequire("10hUt"))();

var $c07f0014105f4d3c$var$objectIs = (parcelRequire("4LgTG"))();

var $c07f0014105f4d3c$var$RegExpPrototypeTest = (parcelRequire("2TUjA"))('RegExp.prototype.test');
var $c07f0014105f4d3c$var$errorCache = new Map();
var $c07f0014105f4d3c$var$isDeepEqual;
var $c07f0014105f4d3c$var$isDeepStrictEqual;
var $c07f0014105f4d3c$var$parseExpressionAt;
var $c07f0014105f4d3c$var$findNodeAround;
var $c07f0014105f4d3c$var$decoder;

function $c07f0014105f4d3c$var$lazyLoadComparison() {
    var comparison = (parcelRequire("lV95c"));
    $c07f0014105f4d3c$var$isDeepEqual = comparison.isDeepEqual;
    $c07f0014105f4d3c$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $c07f0014105f4d3c$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $c07f0014105f4d3c$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $c07f0014105f4d3c$var$escapeFn = function escapeFn(str) {
    return $c07f0014105f4d3c$var$meta[str.charCodeAt(0)];
};
var $c07f0014105f4d3c$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $c07f0014105f4d3c$var$assert = module.exports = $c07f0014105f4d3c$var$ok;
var $c07f0014105f4d3c$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $c07f0014105f4d3c$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $jc4ou(obj);
}
function $c07f0014105f4d3c$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($c07f0014105f4d3c$var$warned === false) {
            $c07f0014105f4d3c$var$warned = true;
            var warn = $igDjg.emitWarning ? $igDjg.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $c07f0014105f4d3c$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $jc4ou(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$c07f0014105f4d3c$var$assert.fail = $c07f0014105f4d3c$var$fail;
// The AssertionError is defined in internal/error.
$c07f0014105f4d3c$var$assert.AssertionError = $jc4ou;
function $c07f0014105f4d3c$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $jc4ou({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $c07f0014105f4d3c$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $c07f0014105f4d3c$var$innerOk.apply(void 0, [
        $c07f0014105f4d3c$var$ok,
        args.length
    ].concat(args));
}
$c07f0014105f4d3c$var$assert.ok = $c07f0014105f4d3c$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $c07f0014105f4d3c$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$c07f0014105f4d3c$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$c07f0014105f4d3c$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($c07f0014105f4d3c$var$isDeepEqual === undefined) $c07f0014105f4d3c$var$lazyLoadComparison();
    if (!$c07f0014105f4d3c$var$isDeepEqual(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$c07f0014105f4d3c$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($c07f0014105f4d3c$var$isDeepEqual === undefined) $c07f0014105f4d3c$var$lazyLoadComparison();
    if ($c07f0014105f4d3c$var$isDeepEqual(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $c07f0014105f4d3c$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($c07f0014105f4d3c$var$isDeepEqual === undefined) $c07f0014105f4d3c$var$lazyLoadComparison();
    if (!$c07f0014105f4d3c$var$isDeepStrictEqual(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$c07f0014105f4d3c$var$assert.notDeepStrictEqual = $c07f0014105f4d3c$var$notDeepStrictEqual;
function $c07f0014105f4d3c$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($c07f0014105f4d3c$var$isDeepEqual === undefined) $c07f0014105f4d3c$var$lazyLoadComparison();
    if ($c07f0014105f4d3c$var$isDeepStrictEqual(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $c07f0014105f4d3c$var$notDeepStrictEqual
    });
}
$c07f0014105f4d3c$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$c07f0014105f4d3c$var$objectIs(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$c07f0014105f4d3c$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c07f0014105f4d3c$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($c07f0014105f4d3c$var$objectIs(actual, expected)) $c07f0014105f4d3c$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $c07f0014105f4d3c$var$Comparison = /*#__PURE__*/ $c07f0014105f4d3c$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $c07f0014105f4d3c$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $c07f0014105f4d3c$var$isRegExp(obj[key]) && $c07f0014105f4d3c$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $c07f0014105f4d3c$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$c07f0014105f4d3c$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $c07f0014105f4d3c$var$Comparison(actual, keys);
            var b = new $c07f0014105f4d3c$var$Comparison(expected, keys, actual);
            var err = new $jc4ou({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $c07f0014105f4d3c$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $c07f0014105f4d3c$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($c07f0014105f4d3c$var$isRegExp(expected)) return $c07f0014105f4d3c$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($c07f0014105f4d3c$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $jc4ou({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($c07f0014105f4d3c$var$isDeepEqual === undefined) $c07f0014105f4d3c$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $c07f0014105f4d3c$var$isRegExp(expected[key]) && $c07f0014105f4d3c$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $c07f0014105f4d3c$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $c07f0014105f4d3c$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $c07f0014105f4d3c$var$NO_EXCEPTION_SENTINEL;
}
function $c07f0014105f4d3c$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $c07f0014105f4d3c$var$isPromise(obj) || obj !== null && $c07f0014105f4d3c$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $c07f0014105f4d3c$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$c07f0014105f4d3c$var$checkIsPromise(resultPromise)) throw new $c07f0014105f4d3c$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($c07f0014105f4d3c$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $c07f0014105f4d3c$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $c07f0014105f4d3c$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($c07f0014105f4d3c$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $c07f0014105f4d3c$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $c07f0014105f4d3c$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $c07f0014105f4d3c$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $c07f0014105f4d3c$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $c07f0014105f4d3c$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$c07f0014105f4d3c$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $c07f0014105f4d3c$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $c07f0014105f4d3c$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $c07f0014105f4d3c$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $c07f0014105f4d3c$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$c07f0014105f4d3c$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $c07f0014105f4d3c$var$expectsError.apply(void 0, [
        throws,
        $c07f0014105f4d3c$var$getActual(promiseFn)
    ].concat(args));
};
$c07f0014105f4d3c$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $c07f0014105f4d3c$var$waitForActual(promiseFn).then(function(result) {
        return $c07f0014105f4d3c$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$c07f0014105f4d3c$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $c07f0014105f4d3c$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $c07f0014105f4d3c$var$getActual(fn)
    ].concat(args));
};
$c07f0014105f4d3c$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $c07f0014105f4d3c$var$waitForActual(fn).then(function(result) {
        return $c07f0014105f4d3c$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$c07f0014105f4d3c$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($c07f0014105f4d3c$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $c07f0014105f4d3c$var$inspect(err);
        var newErr = new $jc4ou({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $c07f0014105f4d3c$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$c07f0014105f4d3c$var$isRegExp(regexp)) throw new $c07f0014105f4d3c$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $c07f0014105f4d3c$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($c07f0014105f4d3c$var$_typeof(string), " (").concat($c07f0014105f4d3c$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($c07f0014105f4d3c$var$inspect(regexp), ". Input:\n\n").concat($c07f0014105f4d3c$var$inspect(string), "\n"));
        var err = new $jc4ou({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$c07f0014105f4d3c$var$assert.match = function match(string, regexp, message) {
    $c07f0014105f4d3c$var$internalMatch(string, regexp, message, match, 'match');
};
$c07f0014105f4d3c$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $c07f0014105f4d3c$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $c07f0014105f4d3c$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $c07f0014105f4d3c$var$innerOk.apply(void 0, [
        $c07f0014105f4d3c$var$strict,
        args.length
    ].concat(args));
}
$c07f0014105f4d3c$var$assert.strict = $c07f0014105f4d3c$var$objectAssign($c07f0014105f4d3c$var$strict, $c07f0014105f4d3c$var$assert, {
    equal: $c07f0014105f4d3c$var$assert.strictEqual,
    deepEqual: $c07f0014105f4d3c$var$assert.deepStrictEqual,
    notEqual: $c07f0014105f4d3c$var$assert.notStrictEqual,
    notDeepEqual: $c07f0014105f4d3c$var$assert.notDeepStrictEqual
});
$c07f0014105f4d3c$var$assert.strict.strict = $c07f0014105f4d3c$var$assert.strict;

});
parcelRegister("9Ej6r", function(module, exports) {

$parcel$export(module.exports, "codes", () => $7066aaed797d201d$export$e45cb6485273080e, (v) => $7066aaed797d201d$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $7066aaed797d201d$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $7066aaed797d201d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7066aaed797d201d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7066aaed797d201d$var$_typeof(o);
}
function $7066aaed797d201d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7066aaed797d201d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7066aaed797d201d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7066aaed797d201d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7066aaed797d201d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7066aaed797d201d$var$_toPropertyKey(arg) {
    var key = $7066aaed797d201d$var$_toPrimitive(arg, "string");
    return $7066aaed797d201d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7066aaed797d201d$var$_toPrimitive(input, hint) {
    if ($7066aaed797d201d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7066aaed797d201d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7066aaed797d201d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7066aaed797d201d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7066aaed797d201d$var$_setPrototypeOf(subClass, superClass);
}
function $7066aaed797d201d$var$_setPrototypeOf(o, p) {
    $7066aaed797d201d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7066aaed797d201d$var$_setPrototypeOf(o, p);
}
function $7066aaed797d201d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7066aaed797d201d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7066aaed797d201d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7066aaed797d201d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7066aaed797d201d$var$_possibleConstructorReturn(this, result);
    };
}
function $7066aaed797d201d$var$_possibleConstructorReturn(self, call) {
    if (call && ($7066aaed797d201d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7066aaed797d201d$var$_assertThisInitialized(self);
}
function $7066aaed797d201d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7066aaed797d201d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7066aaed797d201d$var$_getPrototypeOf(o) {
    $7066aaed797d201d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7066aaed797d201d$var$_getPrototypeOf(o);
}
var $7066aaed797d201d$var$codes = {};
// Lazy loaded
var $7066aaed797d201d$var$assert;
var $7066aaed797d201d$var$util;
function $7066aaed797d201d$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $7066aaed797d201d$var$_inherits(NodeError, _Base);
        var _super = $7066aaed797d201d$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $7066aaed797d201d$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $7066aaed797d201d$var$_createClass(NodeError);
    }(Base);
    $7066aaed797d201d$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $7066aaed797d201d$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $7066aaed797d201d$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $7066aaed797d201d$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $7066aaed797d201d$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$7066aaed797d201d$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$7066aaed797d201d$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($7066aaed797d201d$var$assert === undefined) $7066aaed797d201d$var$assert = (parcelRequire("gwEr2"));
    $7066aaed797d201d$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $7066aaed797d201d$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($7066aaed797d201d$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($7066aaed797d201d$var$oneOf(expected, 'type'));
    else {
        var type = $7066aaed797d201d$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($7066aaed797d201d$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($7066aaed797d201d$var$_typeof(actual));
    return msg;
}, TypeError);

$7066aaed797d201d$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($7066aaed797d201d$var$util === undefined) $7066aaed797d201d$var$util = (parcelRequire("7WF8Y"));
    var inspected = $7066aaed797d201d$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$7066aaed797d201d$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($7066aaed797d201d$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$7066aaed797d201d$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($7066aaed797d201d$var$assert === undefined) $7066aaed797d201d$var$assert = (parcelRequire("gwEr2"));
    $7066aaed797d201d$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$7066aaed797d201d$export$e45cb6485273080e = $7066aaed797d201d$var$codes;

});
parcelRegister("7WF8Y", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $igDjg = parcelRequire("igDjg");
var $5c8ddd78d1eb5694$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $5c8ddd78d1eb5694$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$5c8ddd78d1eb5694$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($5c8ddd78d1eb5694$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($5c8ddd78d1eb5694$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($5c8ddd78d1eb5694$var$isNull(x) || !$5c8ddd78d1eb5694$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $5c8ddd78d1eb5694$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $igDjg !== 'undefined' && $igDjg.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $igDjg === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($igDjg.throwDeprecation) throw new Error(msg);
            else if ($igDjg.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $5c8ddd78d1eb5694$var$debugs = {};
var $5c8ddd78d1eb5694$var$debugEnvRegex = /^$/;
var $5c8ddd78d1eb5694$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$5c8ddd78d1eb5694$var$debugs[set]) {
        if ($5c8ddd78d1eb5694$var$debugEnvRegex.test(set)) {
            var pid = $igDjg.pid;
            $5c8ddd78d1eb5694$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $5c8ddd78d1eb5694$var$debugs[set] = function() {};
    }
    return $5c8ddd78d1eb5694$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $5c8ddd78d1eb5694$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $5c8ddd78d1eb5694$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($5c8ddd78d1eb5694$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($5c8ddd78d1eb5694$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($5c8ddd78d1eb5694$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($5c8ddd78d1eb5694$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($5c8ddd78d1eb5694$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $5c8ddd78d1eb5694$var$stylizeWithColor;
    return $5c8ddd78d1eb5694$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $5c8ddd78d1eb5694$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$5c8ddd78d1eb5694$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$5c8ddd78d1eb5694$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $5c8ddd78d1eb5694$var$stylizeWithColor(str, styleType) {
    var style = $5c8ddd78d1eb5694$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $5c8ddd78d1eb5694$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $5c8ddd78d1eb5694$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $5c8ddd78d1eb5694$var$stylizeNoColor(str, styleType) {
    return str;
}
function $5c8ddd78d1eb5694$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $5c8ddd78d1eb5694$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $5c8ddd78d1eb5694$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$5c8ddd78d1eb5694$var$isString(ret)) ret = $5c8ddd78d1eb5694$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $5c8ddd78d1eb5694$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $5c8ddd78d1eb5694$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($5c8ddd78d1eb5694$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $5c8ddd78d1eb5694$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($5c8ddd78d1eb5694$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($5c8ddd78d1eb5694$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($5c8ddd78d1eb5694$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($5c8ddd78d1eb5694$var$isError(value)) return $5c8ddd78d1eb5694$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($5c8ddd78d1eb5694$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($5c8ddd78d1eb5694$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($5c8ddd78d1eb5694$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($5c8ddd78d1eb5694$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($5c8ddd78d1eb5694$var$isError(value)) base = ' ' + $5c8ddd78d1eb5694$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($5c8ddd78d1eb5694$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $5c8ddd78d1eb5694$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $5c8ddd78d1eb5694$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $5c8ddd78d1eb5694$var$reduceToSingleString(output, base, braces);
}
function $5c8ddd78d1eb5694$var$formatPrimitive(ctx, value) {
    if ($5c8ddd78d1eb5694$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($5c8ddd78d1eb5694$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($5c8ddd78d1eb5694$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($5c8ddd78d1eb5694$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($5c8ddd78d1eb5694$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $5c8ddd78d1eb5694$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $5c8ddd78d1eb5694$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($5c8ddd78d1eb5694$var$hasOwnProperty(value, String(i))) output.push($5c8ddd78d1eb5694$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($5c8ddd78d1eb5694$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $5c8ddd78d1eb5694$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$5c8ddd78d1eb5694$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($5c8ddd78d1eb5694$var$isNull(recurseTimes)) str = $5c8ddd78d1eb5694$var$formatValue(ctx, desc.value, null);
            else str = $5c8ddd78d1eb5694$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($5c8ddd78d1eb5694$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $5c8ddd78d1eb5694$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("eQQyY"));
function $5c8ddd78d1eb5694$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $5c8ddd78d1eb5694$var$isArray;
function $5c8ddd78d1eb5694$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $5c8ddd78d1eb5694$var$isBoolean;
function $5c8ddd78d1eb5694$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $5c8ddd78d1eb5694$var$isNull;
function $5c8ddd78d1eb5694$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $5c8ddd78d1eb5694$var$isNullOrUndefined;
function $5c8ddd78d1eb5694$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $5c8ddd78d1eb5694$var$isNumber;
function $5c8ddd78d1eb5694$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $5c8ddd78d1eb5694$var$isString;
function $5c8ddd78d1eb5694$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $5c8ddd78d1eb5694$var$isSymbol;
function $5c8ddd78d1eb5694$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $5c8ddd78d1eb5694$var$isUndefined;
function $5c8ddd78d1eb5694$var$isRegExp(re) {
    return $5c8ddd78d1eb5694$var$isObject(re) && $5c8ddd78d1eb5694$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $5c8ddd78d1eb5694$var$isRegExp;
module.exports.types.isRegExp = $5c8ddd78d1eb5694$var$isRegExp;
function $5c8ddd78d1eb5694$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $5c8ddd78d1eb5694$var$isObject;
function $5c8ddd78d1eb5694$var$isDate(d) {
    return $5c8ddd78d1eb5694$var$isObject(d) && $5c8ddd78d1eb5694$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $5c8ddd78d1eb5694$var$isDate;
module.exports.types.isDate = $5c8ddd78d1eb5694$var$isDate;
function $5c8ddd78d1eb5694$var$isError(e) {
    return $5c8ddd78d1eb5694$var$isObject(e) && ($5c8ddd78d1eb5694$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $5c8ddd78d1eb5694$var$isError;
module.exports.types.isNativeError = $5c8ddd78d1eb5694$var$isError;
function $5c8ddd78d1eb5694$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $5c8ddd78d1eb5694$var$isFunction;
function $5c8ddd78d1eb5694$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $5c8ddd78d1eb5694$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("fMvDf"));
function $5c8ddd78d1eb5694$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $5c8ddd78d1eb5694$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $5c8ddd78d1eb5694$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $5c8ddd78d1eb5694$var$timestamp() {
    var d = new Date();
    var time = [
        $5c8ddd78d1eb5694$var$pad(d.getHours()),
        $5c8ddd78d1eb5694$var$pad(d.getMinutes()),
        $5c8ddd78d1eb5694$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $5c8ddd78d1eb5694$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $5c8ddd78d1eb5694$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("lpcNn"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$5c8ddd78d1eb5694$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $5c8ddd78d1eb5694$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol && original[$5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol]) {
        var fn = original[$5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $5c8ddd78d1eb5694$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $5c8ddd78d1eb5694$var$kCustomPromisifiedSymbol;
function $5c8ddd78d1eb5694$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $5c8ddd78d1eb5694$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $igDjg.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $igDjg.nextTick($5c8ddd78d1eb5694$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $5c8ddd78d1eb5694$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $5c8ddd78d1eb5694$var$callbackify;

});
parcelRegister("eQQyY", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $8NKMi = parcelRequire("8NKMi");

var $7qnIS = parcelRequire("7qnIS");

var $3eoyd = parcelRequire("3eoyd");

var $cC7Tq = parcelRequire("cC7Tq");
function $acfeb1ef2847c7f3$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $acfeb1ef2847c7f3$var$BigIntSupported = typeof BigInt !== 'undefined';
var $acfeb1ef2847c7f3$var$SymbolSupported = typeof Symbol !== 'undefined';
var $acfeb1ef2847c7f3$var$ObjectToString = $acfeb1ef2847c7f3$var$uncurryThis(Object.prototype.toString);
var $acfeb1ef2847c7f3$var$numberValue = $acfeb1ef2847c7f3$var$uncurryThis(Number.prototype.valueOf);
var $acfeb1ef2847c7f3$var$stringValue = $acfeb1ef2847c7f3$var$uncurryThis(String.prototype.valueOf);
var $acfeb1ef2847c7f3$var$booleanValue = $acfeb1ef2847c7f3$var$uncurryThis(Boolean.prototype.valueOf);
if ($acfeb1ef2847c7f3$var$BigIntSupported) var $acfeb1ef2847c7f3$var$bigIntValue = $acfeb1ef2847c7f3$var$uncurryThis(BigInt.prototype.valueOf);
if ($acfeb1ef2847c7f3$var$SymbolSupported) var $acfeb1ef2847c7f3$var$symbolValue = $acfeb1ef2847c7f3$var$uncurryThis(Symbol.prototype.valueOf);
function $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $8NKMi;
module.exports.isGeneratorFunction = $7qnIS;
module.exports.isTypedArray = $cC7Tq;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $acfeb1ef2847c7f3$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $acfeb1ef2847c7f3$var$isPromise;
function $acfeb1ef2847c7f3$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $cC7Tq(value) || $acfeb1ef2847c7f3$var$isDataView(value);
}
module.exports.isArrayBufferView = $acfeb1ef2847c7f3$var$isArrayBufferView;
function $acfeb1ef2847c7f3$var$isUint8Array(value) {
    return $3eoyd(value) === 'Uint8Array';
}
module.exports.isUint8Array = $acfeb1ef2847c7f3$var$isUint8Array;
function $acfeb1ef2847c7f3$var$isUint8ClampedArray(value) {
    return $3eoyd(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $acfeb1ef2847c7f3$var$isUint8ClampedArray;
function $acfeb1ef2847c7f3$var$isUint16Array(value) {
    return $3eoyd(value) === 'Uint16Array';
}
module.exports.isUint16Array = $acfeb1ef2847c7f3$var$isUint16Array;
function $acfeb1ef2847c7f3$var$isUint32Array(value) {
    return $3eoyd(value) === 'Uint32Array';
}
module.exports.isUint32Array = $acfeb1ef2847c7f3$var$isUint32Array;
function $acfeb1ef2847c7f3$var$isInt8Array(value) {
    return $3eoyd(value) === 'Int8Array';
}
module.exports.isInt8Array = $acfeb1ef2847c7f3$var$isInt8Array;
function $acfeb1ef2847c7f3$var$isInt16Array(value) {
    return $3eoyd(value) === 'Int16Array';
}
module.exports.isInt16Array = $acfeb1ef2847c7f3$var$isInt16Array;
function $acfeb1ef2847c7f3$var$isInt32Array(value) {
    return $3eoyd(value) === 'Int32Array';
}
module.exports.isInt32Array = $acfeb1ef2847c7f3$var$isInt32Array;
function $acfeb1ef2847c7f3$var$isFloat32Array(value) {
    return $3eoyd(value) === 'Float32Array';
}
module.exports.isFloat32Array = $acfeb1ef2847c7f3$var$isFloat32Array;
function $acfeb1ef2847c7f3$var$isFloat64Array(value) {
    return $3eoyd(value) === 'Float64Array';
}
module.exports.isFloat64Array = $acfeb1ef2847c7f3$var$isFloat64Array;
function $acfeb1ef2847c7f3$var$isBigInt64Array(value) {
    return $3eoyd(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $acfeb1ef2847c7f3$var$isBigInt64Array;
function $acfeb1ef2847c7f3$var$isBigUint64Array(value) {
    return $3eoyd(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $acfeb1ef2847c7f3$var$isBigUint64Array;
function $acfeb1ef2847c7f3$var$isMapToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object Map]';
}
$acfeb1ef2847c7f3$var$isMapToString.working = typeof Map !== 'undefined' && $acfeb1ef2847c7f3$var$isMapToString(new Map());
function $acfeb1ef2847c7f3$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $acfeb1ef2847c7f3$var$isMapToString.working ? $acfeb1ef2847c7f3$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $acfeb1ef2847c7f3$var$isMap;
function $acfeb1ef2847c7f3$var$isSetToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object Set]';
}
$acfeb1ef2847c7f3$var$isSetToString.working = typeof Set !== 'undefined' && $acfeb1ef2847c7f3$var$isSetToString(new Set());
function $acfeb1ef2847c7f3$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $acfeb1ef2847c7f3$var$isSetToString.working ? $acfeb1ef2847c7f3$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $acfeb1ef2847c7f3$var$isSet;
function $acfeb1ef2847c7f3$var$isWeakMapToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object WeakMap]';
}
$acfeb1ef2847c7f3$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $acfeb1ef2847c7f3$var$isWeakMapToString(new WeakMap());
function $acfeb1ef2847c7f3$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $acfeb1ef2847c7f3$var$isWeakMapToString.working ? $acfeb1ef2847c7f3$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $acfeb1ef2847c7f3$var$isWeakMap;
function $acfeb1ef2847c7f3$var$isWeakSetToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object WeakSet]';
}
$acfeb1ef2847c7f3$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $acfeb1ef2847c7f3$var$isWeakSetToString(new WeakSet());
function $acfeb1ef2847c7f3$var$isWeakSet(value) {
    return $acfeb1ef2847c7f3$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $acfeb1ef2847c7f3$var$isWeakSet;
function $acfeb1ef2847c7f3$var$isArrayBufferToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$acfeb1ef2847c7f3$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $acfeb1ef2847c7f3$var$isArrayBufferToString(new ArrayBuffer());
function $acfeb1ef2847c7f3$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $acfeb1ef2847c7f3$var$isArrayBufferToString.working ? $acfeb1ef2847c7f3$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $acfeb1ef2847c7f3$var$isArrayBuffer;
function $acfeb1ef2847c7f3$var$isDataViewToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object DataView]';
}
$acfeb1ef2847c7f3$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $acfeb1ef2847c7f3$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $acfeb1ef2847c7f3$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $acfeb1ef2847c7f3$var$isDataViewToString.working ? $acfeb1ef2847c7f3$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $acfeb1ef2847c7f3$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $acfeb1ef2847c7f3$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $acfeb1ef2847c7f3$var$isSharedArrayBufferToString(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $acfeb1ef2847c7f3$var$isSharedArrayBuffer(value) {
    if (typeof $acfeb1ef2847c7f3$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $acfeb1ef2847c7f3$var$isSharedArrayBufferToString.working === 'undefined') $acfeb1ef2847c7f3$var$isSharedArrayBufferToString.working = $acfeb1ef2847c7f3$var$isSharedArrayBufferToString(new $acfeb1ef2847c7f3$var$SharedArrayBufferCopy());
    return $acfeb1ef2847c7f3$var$isSharedArrayBufferToString.working ? $acfeb1ef2847c7f3$var$isSharedArrayBufferToString(value) : value instanceof $acfeb1ef2847c7f3$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $acfeb1ef2847c7f3$var$isSharedArrayBuffer;
function $acfeb1ef2847c7f3$var$isAsyncFunction(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $acfeb1ef2847c7f3$var$isAsyncFunction;
function $acfeb1ef2847c7f3$var$isMapIterator(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $acfeb1ef2847c7f3$var$isMapIterator;
function $acfeb1ef2847c7f3$var$isSetIterator(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $acfeb1ef2847c7f3$var$isSetIterator;
function $acfeb1ef2847c7f3$var$isGeneratorObject(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $acfeb1ef2847c7f3$var$isGeneratorObject;
function $acfeb1ef2847c7f3$var$isWebAssemblyCompiledModule(value) {
    return $acfeb1ef2847c7f3$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $acfeb1ef2847c7f3$var$isWebAssemblyCompiledModule;
function $acfeb1ef2847c7f3$var$isNumberObject(value) {
    return $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, $acfeb1ef2847c7f3$var$numberValue);
}
module.exports.isNumberObject = $acfeb1ef2847c7f3$var$isNumberObject;
function $acfeb1ef2847c7f3$var$isStringObject(value) {
    return $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, $acfeb1ef2847c7f3$var$stringValue);
}
module.exports.isStringObject = $acfeb1ef2847c7f3$var$isStringObject;
function $acfeb1ef2847c7f3$var$isBooleanObject(value) {
    return $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, $acfeb1ef2847c7f3$var$booleanValue);
}
module.exports.isBooleanObject = $acfeb1ef2847c7f3$var$isBooleanObject;
function $acfeb1ef2847c7f3$var$isBigIntObject(value) {
    return $acfeb1ef2847c7f3$var$BigIntSupported && $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, $acfeb1ef2847c7f3$var$bigIntValue);
}
module.exports.isBigIntObject = $acfeb1ef2847c7f3$var$isBigIntObject;
function $acfeb1ef2847c7f3$var$isSymbolObject(value) {
    return $acfeb1ef2847c7f3$var$SymbolSupported && $acfeb1ef2847c7f3$var$checkBoxedPrimitive(value, $acfeb1ef2847c7f3$var$symbolValue);
}
module.exports.isSymbolObject = $acfeb1ef2847c7f3$var$isSymbolObject;
function $acfeb1ef2847c7f3$var$isBoxedPrimitive(value) {
    return $acfeb1ef2847c7f3$var$isNumberObject(value) || $acfeb1ef2847c7f3$var$isStringObject(value) || $acfeb1ef2847c7f3$var$isBooleanObject(value) || $acfeb1ef2847c7f3$var$isBigIntObject(value) || $acfeb1ef2847c7f3$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $acfeb1ef2847c7f3$var$isBoxedPrimitive;
function $acfeb1ef2847c7f3$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($acfeb1ef2847c7f3$var$isArrayBuffer(value) || $acfeb1ef2847c7f3$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $acfeb1ef2847c7f3$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("8NKMi", function(module, exports) {
'use strict';

var $66872f7ca248cb6e$var$hasToStringTag = (parcelRequire("5nSZG"))();

var $2TUjA = parcelRequire("2TUjA");
var $66872f7ca248cb6e$var$$toString = $2TUjA('Object.prototype.toString');
var $66872f7ca248cb6e$var$isStandardArguments = function isArguments(value) {
    if ($66872f7ca248cb6e$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $66872f7ca248cb6e$var$$toString(value) === '[object Arguments]';
};
var $66872f7ca248cb6e$var$isLegacyArguments = function isArguments(value) {
    if ($66872f7ca248cb6e$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $66872f7ca248cb6e$var$$toString(value) !== '[object Array]' && $66872f7ca248cb6e$var$$toString(value.callee) === '[object Function]';
};
var $66872f7ca248cb6e$var$supportsStandardArguments = function() {
    return $66872f7ca248cb6e$var$isStandardArguments(arguments);
}();
$66872f7ca248cb6e$var$isStandardArguments.isLegacyArguments = $66872f7ca248cb6e$var$isLegacyArguments; // for tests
module.exports = $66872f7ca248cb6e$var$supportsStandardArguments ? $66872f7ca248cb6e$var$isStandardArguments : $66872f7ca248cb6e$var$isLegacyArguments;

});
parcelRegister("5nSZG", function(module, exports) {
'use strict';

var $cwWvF = parcelRequire("cwWvF");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $cwWvF() && !!Symbol.toStringTag;
};

});

parcelRegister("2TUjA", function(module, exports) {
'use strict';

var $1b3Ts = parcelRequire("1b3Ts");

var $6zl1T = parcelRequire("6zl1T");
var $21cc66c4c492aea4$var$$indexOf = $6zl1T($1b3Ts('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1b3Ts(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $21cc66c4c492aea4$var$$indexOf(name, '.prototype.') > -1) return $6zl1T(intrinsic);
    return intrinsic;
};

});
parcelRegister("6zl1T", function(module, exports) {
'use strict';

var $fSty5 = parcelRequire("fSty5");

var $1Yj66 = parcelRequire("1Yj66");

var $giui0 = parcelRequire("giui0");

var $1w5ZU = parcelRequire("1w5ZU");
module.exports = function callBind(originalFunction) {
    var func = $giui0(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $fSty5(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($1Yj66) $1Yj66(module.exports, 'apply', {
    value: $1w5ZU
});
else module.exports.apply = $1w5ZU;

});
parcelRegister("fSty5", function(module, exports) {
'use strict';

var $1b3Ts = parcelRequire("1b3Ts");

var $gAEXI = parcelRequire("gAEXI");

var $b8f2d1ef0d4df03e$var$hasDescriptors = (parcelRequire("9ndBI"))();

var $kwOoE = parcelRequire("kwOoE");

var $imbfI = parcelRequire("imbfI");
var $b8f2d1ef0d4df03e$var$$floor = $1b3Ts('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $imbfI('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $b8f2d1ef0d4df03e$var$$floor(length) !== length) throw new $imbfI('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $kwOoE) {
        var desc = $kwOoE(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($b8f2d1ef0d4df03e$var$hasDescriptors) $gAEXI(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $gAEXI(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("gAEXI", function(module, exports) {
'use strict';

var $1Yj66 = parcelRequire("1Yj66");

var $bqoCM = parcelRequire("bqoCM");

var $imbfI = parcelRequire("imbfI");

var $kwOoE = parcelRequire("kwOoE");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $imbfI('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $imbfI('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $imbfI('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $imbfI('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $imbfI('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $imbfI('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$kwOoE && $kwOoE(obj, property);
    if ($1Yj66) $1Yj66(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $bqoCM('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("9ndBI", function(module, exports) {
'use strict';

var $1Yj66 = parcelRequire("1Yj66");
var $6d30d12bc8205bd1$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$1Yj66;
};
$6d30d12bc8205bd1$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$1Yj66) return null;
    try {
        return $1Yj66([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $6d30d12bc8205bd1$var$hasPropertyDescriptors;

});


parcelRegister("1w5ZU", function(module, exports) {
'use strict';

var $inBv6 = parcelRequire("inBv6");

var $gJ8ML = parcelRequire("gJ8ML");

var $9xm9a = parcelRequire("9xm9a");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $9xm9a($inBv6, $gJ8ML, arguments);
};

});




parcelRegister("7qnIS", function(module, exports) {
'use strict';
var $567d5cfb22b1b184$var$toStr = Object.prototype.toString;
var $567d5cfb22b1b184$var$fnToStr = Function.prototype.toString;
var $567d5cfb22b1b184$var$isFnRegex = /^\s*(?:function)?\*/;

var $567d5cfb22b1b184$var$hasToStringTag = (parcelRequire("5nSZG"))();
var $567d5cfb22b1b184$var$getProto = Object.getPrototypeOf;
var $567d5cfb22b1b184$var$getGeneratorFunc = function() {
    if (!$567d5cfb22b1b184$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $567d5cfb22b1b184$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($567d5cfb22b1b184$var$isFnRegex.test($567d5cfb22b1b184$var$fnToStr.call(fn))) return true;
    if (!$567d5cfb22b1b184$var$hasToStringTag) {
        var str = $567d5cfb22b1b184$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$567d5cfb22b1b184$var$getProto) return false;
    if (typeof $567d5cfb22b1b184$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $567d5cfb22b1b184$var$getGeneratorFunc();
        $567d5cfb22b1b184$var$GeneratorFunction = generatorFunc ? $567d5cfb22b1b184$var$getProto(generatorFunc) : false;
    }
    return $567d5cfb22b1b184$var$getProto(fn) === $567d5cfb22b1b184$var$GeneratorFunction;
};

});

parcelRegister("3eoyd", function(module, exports) {
'use strict';

var $9xfpK = parcelRequire("9xfpK");

var $4DPeP = parcelRequire("4DPeP");

var $6zl1T = parcelRequire("6zl1T");

var $f8M6V = parcelRequire("f8M6V");

var $kwOoE = parcelRequire("kwOoE");

var $9SzeH = parcelRequire("9SzeH");
var $25a5b9308bd94906$var$$toString = $f8M6V('Object.prototype.toString');

var $25a5b9308bd94906$var$hasToStringTag = (parcelRequire("5nSZG"))();
var $25a5b9308bd94906$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $25a5b9308bd94906$var$typedArrays = $4DPeP();
var $25a5b9308bd94906$var$$slice = $f8M6V('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $25a5b9308bd94906$var$$indexOf = $f8M6V('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $25a5b9308bd94906$var$cache = {
    __proto__: null
};
if ($25a5b9308bd94906$var$hasToStringTag && $kwOoE && $9SzeH) $9xfpK($25a5b9308bd94906$var$typedArrays, function(typedArray) {
    var arr = new $25a5b9308bd94906$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $9SzeH) {
        var proto = $9SzeH(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $kwOoE(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $9SzeH(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $kwOoE(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $25a5b9308bd94906$var$cache['$' + typedArray] = $6zl1T(descriptor.get);
    }
});
else $9xfpK($25a5b9308bd94906$var$typedArrays, function(typedArray) {
    var arr = new $25a5b9308bd94906$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $25a5b9308bd94906$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $6zl1T(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $25a5b9308bd94906$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $9xfpK(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $25a5b9308bd94906$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $25a5b9308bd94906$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $25a5b9308bd94906$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $9xfpK(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $25a5b9308bd94906$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $25a5b9308bd94906$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$25a5b9308bd94906$var$hasToStringTag) {
        /** @type {string} */ var tag = $25a5b9308bd94906$var$$slice($25a5b9308bd94906$var$$toString(value), 8, -1);
        if ($25a5b9308bd94906$var$$indexOf($25a5b9308bd94906$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $25a5b9308bd94906$var$trySlices(value);
    }
    if (!$kwOoE) return null;
     // unknown engine
    return $25a5b9308bd94906$var$tryTypedArrays(value);
};

});
parcelRegister("9xfpK", function(module, exports) {
'use strict';

var $81Pfa = parcelRequire("81Pfa");
var $6f1327188da2d457$var$toStr = Object.prototype.toString;
var $6f1327188da2d457$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $6f1327188da2d457$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($6f1327188da2d457$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $6f1327188da2d457$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $6f1327188da2d457$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($6f1327188da2d457$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $6f1327188da2d457$var$isArray(x) {
    return $6f1327188da2d457$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$81Pfa(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($6f1327188da2d457$var$isArray(list)) $6f1327188da2d457$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $6f1327188da2d457$var$forEachString(list, iterator, receiver);
    else $6f1327188da2d457$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("81Pfa", function(module, exports) {
'use strict';
var $5d862aa4803ed1a0$var$fnToStr = Function.prototype.toString;
var $5d862aa4803ed1a0$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $5d862aa4803ed1a0$var$badArrayLike;
var $5d862aa4803ed1a0$var$isCallableMarker;
if (typeof $5d862aa4803ed1a0$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $5d862aa4803ed1a0$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $5d862aa4803ed1a0$var$isCallableMarker;
        }
    });
    $5d862aa4803ed1a0$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $5d862aa4803ed1a0$var$reflectApply(function() {
        throw 42;
    }, null, $5d862aa4803ed1a0$var$badArrayLike);
} catch (_) {
    if (_ !== $5d862aa4803ed1a0$var$isCallableMarker) $5d862aa4803ed1a0$var$reflectApply = null;
}
else $5d862aa4803ed1a0$var$reflectApply = null;
var $5d862aa4803ed1a0$var$constructorRegex = /^\s*class\b/;
var $5d862aa4803ed1a0$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $5d862aa4803ed1a0$var$fnToStr.call(value);
        return $5d862aa4803ed1a0$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $5d862aa4803ed1a0$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($5d862aa4803ed1a0$var$isES6ClassFn(value)) return false;
        $5d862aa4803ed1a0$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $5d862aa4803ed1a0$var$toStr = Object.prototype.toString;
var $5d862aa4803ed1a0$var$objectClass = '[object Object]';
var $5d862aa4803ed1a0$var$fnClass = '[object Function]';
var $5d862aa4803ed1a0$var$genClass = '[object GeneratorFunction]';
var $5d862aa4803ed1a0$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $5d862aa4803ed1a0$var$ddaClass2 = '[object HTML document.all class]';
var $5d862aa4803ed1a0$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $5d862aa4803ed1a0$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $5d862aa4803ed1a0$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $5d862aa4803ed1a0$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $5d862aa4803ed1a0$var$all = document.all;
    if ($5d862aa4803ed1a0$var$toStr.call($5d862aa4803ed1a0$var$all) === $5d862aa4803ed1a0$var$toStr.call(document.all)) $5d862aa4803ed1a0$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($5d862aa4803ed1a0$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $5d862aa4803ed1a0$var$toStr.call(value);
            return (str === $5d862aa4803ed1a0$var$ddaClass || str === $5d862aa4803ed1a0$var$ddaClass2 || str === $5d862aa4803ed1a0$var$ddaClass3 // opera 12.16
             || str === $5d862aa4803ed1a0$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $5d862aa4803ed1a0$var$reflectApply ? function isCallable(value) {
    if ($5d862aa4803ed1a0$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $5d862aa4803ed1a0$var$reflectApply(value, null, $5d862aa4803ed1a0$var$badArrayLike);
    } catch (e) {
        if (e !== $5d862aa4803ed1a0$var$isCallableMarker) return false;
    }
    return !$5d862aa4803ed1a0$var$isES6ClassFn(value) && $5d862aa4803ed1a0$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($5d862aa4803ed1a0$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($5d862aa4803ed1a0$var$hasToStringTag) return $5d862aa4803ed1a0$var$tryFunctionObject(value);
    if ($5d862aa4803ed1a0$var$isES6ClassFn(value)) return false;
    var strClass = $5d862aa4803ed1a0$var$toStr.call(value);
    if (strClass !== $5d862aa4803ed1a0$var$fnClass && strClass !== $5d862aa4803ed1a0$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $5d862aa4803ed1a0$var$tryFunctionObject(value);
};

});


parcelRegister("4DPeP", function(module, exports) {
'use strict';

var $fCSU3 = parcelRequire("fCSU3");
var $36128cca598aa228$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $fCSU3.length; i++)if (typeof $36128cca598aa228$var$g[$fCSU3[i]] === 'function') // @ts-expect-error
    out[out.length] = $fCSU3[i];
    return out;
};

});
parcelRegister("fCSU3", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});



parcelRegister("cC7Tq", function(module, exports) {
'use strict';

var $3eoyd = parcelRequire("3eoyd");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$3eoyd(value);
};

});


parcelRegister("fMvDf", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("lpcNn", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("jc4ou", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $igDjg = parcelRequire("igDjg");
'use strict';
function $df928be34e98853c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df928be34e98853c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df928be34e98853c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $df928be34e98853c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df928be34e98853c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $df928be34e98853c$var$_defineProperty(obj, key, value) {
    key = $df928be34e98853c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $df928be34e98853c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $df928be34e98853c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $df928be34e98853c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $df928be34e98853c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $df928be34e98853c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $df928be34e98853c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $df928be34e98853c$var$_toPropertyKey(arg) {
    var key = $df928be34e98853c$var$_toPrimitive(arg, "string");
    return $df928be34e98853c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $df928be34e98853c$var$_toPrimitive(input, hint) {
    if ($df928be34e98853c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($df928be34e98853c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $df928be34e98853c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $df928be34e98853c$var$_setPrototypeOf(subClass, superClass);
}
function $df928be34e98853c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $df928be34e98853c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $df928be34e98853c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $df928be34e98853c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $df928be34e98853c$var$_possibleConstructorReturn(this, result);
    };
}
function $df928be34e98853c$var$_possibleConstructorReturn(self, call) {
    if (call && ($df928be34e98853c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $df928be34e98853c$var$_assertThisInitialized(self);
}
function $df928be34e98853c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $df928be34e98853c$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $df928be34e98853c$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$df928be34e98853c$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $df928be34e98853c$var$_construct(Class, arguments, $df928be34e98853c$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $df928be34e98853c$var$_setPrototypeOf(Wrapper, Class);
    };
    return $df928be34e98853c$var$_wrapNativeSuper(Class);
}
function $df928be34e98853c$var$_construct(Parent, args, Class) {
    if ($df928be34e98853c$var$_isNativeReflectConstruct()) $df928be34e98853c$var$_construct = Reflect.construct.bind();
    else $df928be34e98853c$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $df928be34e98853c$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $df928be34e98853c$var$_construct.apply(null, arguments);
}
function $df928be34e98853c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $df928be34e98853c$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $df928be34e98853c$var$_setPrototypeOf(o, p) {
    $df928be34e98853c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $df928be34e98853c$var$_setPrototypeOf(o, p);
}
function $df928be34e98853c$var$_getPrototypeOf(o) {
    $df928be34e98853c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $df928be34e98853c$var$_getPrototypeOf(o);
}
function $df928be34e98853c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $df928be34e98853c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $df928be34e98853c$var$_typeof(o);
}

var $7WF8Y = parcelRequire("7WF8Y");
var $df928be34e98853c$var$inspect = $7WF8Y.inspect;

var $9Ej6r = parcelRequire("9Ej6r");
var $df928be34e98853c$var$ERR_INVALID_ARG_TYPE = $9Ej6r.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $df928be34e98853c$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $df928be34e98853c$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $df928be34e98853c$var$blue = '';
var $df928be34e98853c$var$green = '';
var $df928be34e98853c$var$red = '';
var $df928be34e98853c$var$white = '';
var $df928be34e98853c$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $df928be34e98853c$var$kMaxShortLength = 10;
function $df928be34e98853c$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $df928be34e98853c$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $df928be34e98853c$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $df928be34e98853c$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $df928be34e98853c$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $df928be34e98853c$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $df928be34e98853c$var$_typeof(actual) === 'object' && $df928be34e98853c$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $df928be34e98853c$var$kMaxShortLength) {
            if (($df928be34e98853c$var$_typeof(actual) !== 'object' || actual === null) && ($df928be34e98853c$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($df928be34e98853c$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $igDjg.stderr && $igDjg.stderr.isTTY ? $igDjg.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($df928be34e98853c$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($df928be34e98853c$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $df928be34e98853c$var$kReadableOperator[operator] + "\n".concat($df928be34e98853c$var$green, "+ actual").concat($df928be34e98853c$var$white, " ").concat($df928be34e98853c$var$red, "- expected").concat($df928be34e98853c$var$white);
    var skippedMsg = " ".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($df928be34e98853c$var$red, "-").concat($df928be34e98853c$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($df928be34e98853c$var$green, "+").concat($df928be34e98853c$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$df928be34e98853c$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $df928be34e98853c$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($df928be34e98853c$var$green, "+").concat($df928be34e98853c$var$white, " ").concat(actualLine);
                other += "\n".concat($df928be34e98853c$var$red, "-").concat($df928be34e98853c$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white).concat(other, "\n") + "".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $df928be34e98853c$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $df928be34e98853c$var$_inherits(AssertionError, _Error);
    var _super = $df928be34e98853c$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $df928be34e98853c$var$_classCallCheck(this, AssertionError);
        if ($df928be34e98853c$var$_typeof(options) !== 'object' || options === null) throw new $df928be34e98853c$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($igDjg.stderr && $igDjg.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($igDjg.stderr && $igDjg.stderr.getColorDepth && $igDjg.stderr.getColorDepth() !== 1) {
                    $df928be34e98853c$var$blue = "\x1B[34m";
                    $df928be34e98853c$var$green = "\x1B[32m";
                    $df928be34e98853c$var$white = "\x1B[39m";
                    $df928be34e98853c$var$red = "\x1B[31m";
                } else {
                    $df928be34e98853c$var$blue = '';
                    $df928be34e98853c$var$green = '';
                    $df928be34e98853c$var$white = '';
                    $df928be34e98853c$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($df928be34e98853c$var$_typeof(actual) === 'object' && actual !== null && $df928be34e98853c$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $df928be34e98853c$var$copyError(actual);
                expected = $df928be34e98853c$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $df928be34e98853c$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $df928be34e98853c$var$kReadableOperator[operator];
                var res = $df928be34e98853c$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $df928be34e98853c$var$_typeof(actual) === 'object' && actual !== null) base = $df928be34e98853c$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($df928be34e98853c$var$blue, "...").concat($df928be34e98853c$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $df928be34e98853c$var$inspectValue(actual);
                var other = '';
                var knownOperators = $df928be34e98853c$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($df928be34e98853c$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($df928be34e98853c$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($df928be34e98853c$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($df928be34e98853c$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $df928be34e98853c$var$_possibleConstructorReturn(_this);
    }
    $df928be34e98853c$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $df928be34e98853c$var$inspect(this, $df928be34e98853c$var$_objectSpread($df928be34e98853c$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $df928be34e98853c$var$_wrapNativeSuper(Error), $df928be34e98853c$var$inspect.custom);
module.exports = $df928be34e98853c$var$AssertionError;

});

parcelRegister("10hUt", function(module, exports) {
'use strict';

var $9CbYT = parcelRequire("9CbYT");
var $0bb3af0d2c3ea2e8$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $0bb3af0d2c3ea2e8$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $9CbYT;
    if ($0bb3af0d2c3ea2e8$var$lacksProperEnumerationOrder()) return $9CbYT;
    if ($0bb3af0d2c3ea2e8$var$assignHasPendingExceptions()) return $9CbYT;
    return Object.assign;
};

});
parcelRegister("9CbYT", function(module, exports) {
'use strict';

var $iJBzN = parcelRequire("iJBzN");

var $7000f4db814cc860$var$hasSymbols = (parcelRequire("cwWvF"))();

var $f8M6V = parcelRequire("f8M6V");

var $cAzwJ = parcelRequire("cAzwJ");
var $7000f4db814cc860$var$$push = $f8M6V('Array.prototype.push');
var $7000f4db814cc860$var$$propIsEnumerable = $f8M6V('Object.prototype.propertyIsEnumerable');
var $7000f4db814cc860$var$originalGetSymbols = $7000f4db814cc860$var$hasSymbols ? $cAzwJ.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $cAzwJ(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $cAzwJ(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $iJBzN(from);
        var getSymbols = $7000f4db814cc860$var$hasSymbols && ($cAzwJ.getOwnPropertySymbols || $7000f4db814cc860$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($7000f4db814cc860$var$$propIsEnumerable(from, key)) $7000f4db814cc860$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($7000f4db814cc860$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("iJBzN", function(module, exports) {
'use strict';
var $da3993d5c090e106$var$slice = Array.prototype.slice;

var $dwUql = parcelRequire("dwUql");
var $da3993d5c090e106$var$origKeys = Object.keys;

var $da3993d5c090e106$var$keysShim = $da3993d5c090e106$var$origKeys ? function keys(o) {
    return $da3993d5c090e106$var$origKeys(o);
} : (parcelRequire("2xgn7"));
var $da3993d5c090e106$var$originalKeys = Object.keys;
$da3993d5c090e106$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($dwUql(object)) return $da3993d5c090e106$var$originalKeys($da3993d5c090e106$var$slice.call(object));
            return $da3993d5c090e106$var$originalKeys(object);
        };
    } else Object.keys = $da3993d5c090e106$var$keysShim;
    return Object.keys || $da3993d5c090e106$var$keysShim;
};
module.exports = $da3993d5c090e106$var$keysShim;

});
parcelRegister("dwUql", function(module, exports) {
'use strict';
var $9d9a082105a3d623$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $9d9a082105a3d623$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $9d9a082105a3d623$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("2xgn7", function(module, exports) {
'use strict';
var $1d8b5cf8e4b6d4ac$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $1d8b5cf8e4b6d4ac$var$has = Object.prototype.hasOwnProperty;
    var $1d8b5cf8e4b6d4ac$var$toStr = Object.prototype.toString;
    var $1d8b5cf8e4b6d4ac$var$isArgs = (parcelRequire("dwUql")); // eslint-disable-line global-require
    var $1d8b5cf8e4b6d4ac$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $1d8b5cf8e4b6d4ac$var$hasDontEnumBug = !$1d8b5cf8e4b6d4ac$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $1d8b5cf8e4b6d4ac$var$hasProtoEnumBug = $1d8b5cf8e4b6d4ac$var$isEnumerable.call(function() {}, 'prototype');
    var $1d8b5cf8e4b6d4ac$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $1d8b5cf8e4b6d4ac$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $1d8b5cf8e4b6d4ac$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$1d8b5cf8e4b6d4ac$var$excludedKeys['$' + k] && $1d8b5cf8e4b6d4ac$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$1d8b5cf8e4b6d4ac$var$hasAutomationEqualityBug) return $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototype(o);
        try {
            return $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $1d8b5cf8e4b6d4ac$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $1d8b5cf8e4b6d4ac$var$toStr.call(object) === '[object Function]';
        var isArguments = $1d8b5cf8e4b6d4ac$var$isArgs(object);
        var isString = isObject && $1d8b5cf8e4b6d4ac$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $1d8b5cf8e4b6d4ac$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$1d8b5cf8e4b6d4ac$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $1d8b5cf8e4b6d4ac$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($1d8b5cf8e4b6d4ac$var$hasDontEnumBug) {
            var skipConstructor = $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $1d8b5cf8e4b6d4ac$var$dontEnums.length; ++k)if (!(skipConstructor && $1d8b5cf8e4b6d4ac$var$dontEnums[k] === 'constructor') && $1d8b5cf8e4b6d4ac$var$has.call(object, $1d8b5cf8e4b6d4ac$var$dontEnums[k])) theKeys.push($1d8b5cf8e4b6d4ac$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $1d8b5cf8e4b6d4ac$var$keysShim;

});




parcelRegister("4LgTG", function(module, exports) {
'use strict';

var $6Mteo = parcelRequire("6Mteo");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $6Mteo;
};

});
parcelRegister("6Mteo", function(module, exports) {
'use strict';
var $4efde67e20b2f54e$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($4efde67e20b2f54e$var$numberIsNaN(a) && $4efde67e20b2f54e$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("lV95c", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $ff55f7860a99da96$var$_slicedToArray(arr, i) {
    return $ff55f7860a99da96$var$_arrayWithHoles(arr) || $ff55f7860a99da96$var$_iterableToArrayLimit(arr, i) || $ff55f7860a99da96$var$_unsupportedIterableToArray(arr, i) || $ff55f7860a99da96$var$_nonIterableRest();
}
function $ff55f7860a99da96$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ff55f7860a99da96$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ff55f7860a99da96$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ff55f7860a99da96$var$_arrayLikeToArray(o, minLen);
}
function $ff55f7860a99da96$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ff55f7860a99da96$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ff55f7860a99da96$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ff55f7860a99da96$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ff55f7860a99da96$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ff55f7860a99da96$var$_typeof(o);
}
var $ff55f7860a99da96$var$regexFlagsSupported = /a/g.flags !== undefined;
var $ff55f7860a99da96$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $ff55f7860a99da96$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $ff55f7860a99da96$var$objectIs = Object.is ? Object.is : (parcelRequire("gh4Iw"));
var $ff55f7860a99da96$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $ff55f7860a99da96$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("fLjZy"));
function $ff55f7860a99da96$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $ff55f7860a99da96$var$hasOwnProperty = $ff55f7860a99da96$var$uncurryThis(Object.prototype.hasOwnProperty);
var $ff55f7860a99da96$var$propertyIsEnumerable = $ff55f7860a99da96$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $ff55f7860a99da96$var$objectToString = $ff55f7860a99da96$var$uncurryThis(Object.prototype.toString);

var $7WF8Y = parcelRequire("7WF8Y");
var $ff55f7860a99da96$require$_require$types = $7WF8Y.types;
var $ff55f7860a99da96$var$isAnyArrayBuffer = $ff55f7860a99da96$require$_require$types.isAnyArrayBuffer, $ff55f7860a99da96$var$isArrayBufferView = $ff55f7860a99da96$require$_require$types.isArrayBufferView, $ff55f7860a99da96$var$isDate = $ff55f7860a99da96$require$_require$types.isDate, $ff55f7860a99da96$var$isMap = $ff55f7860a99da96$require$_require$types.isMap, $ff55f7860a99da96$var$isRegExp = $ff55f7860a99da96$require$_require$types.isRegExp, $ff55f7860a99da96$var$isSet = $ff55f7860a99da96$require$_require$types.isSet, $ff55f7860a99da96$var$isNativeError = $ff55f7860a99da96$require$_require$types.isNativeError, $ff55f7860a99da96$var$isBoxedPrimitive = $ff55f7860a99da96$require$_require$types.isBoxedPrimitive, $ff55f7860a99da96$var$isNumberObject = $ff55f7860a99da96$require$_require$types.isNumberObject, $ff55f7860a99da96$var$isStringObject = $ff55f7860a99da96$require$_require$types.isStringObject, $ff55f7860a99da96$var$isBooleanObject = $ff55f7860a99da96$require$_require$types.isBooleanObject, $ff55f7860a99da96$var$isBigIntObject = $ff55f7860a99da96$require$_require$types.isBigIntObject, $ff55f7860a99da96$var$isSymbolObject = $ff55f7860a99da96$require$_require$types.isSymbolObject, $ff55f7860a99da96$var$isFloat32Array = $ff55f7860a99da96$require$_require$types.isFloat32Array, $ff55f7860a99da96$var$isFloat64Array = $ff55f7860a99da96$require$_require$types.isFloat64Array;
function $ff55f7860a99da96$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $ff55f7860a99da96$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($ff55f7860a99da96$var$isNonIndex).concat($ff55f7860a99da96$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $ff55f7860a99da96$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $ff55f7860a99da96$var$ONLY_ENUMERABLE = undefined;
var $ff55f7860a99da96$var$kStrict = true;
var $ff55f7860a99da96$var$kLoose = false;
var $ff55f7860a99da96$var$kNoIterator = 0;
var $ff55f7860a99da96$var$kIsArray = 1;
var $ff55f7860a99da96$var$kIsSet = 2;
var $ff55f7860a99da96$var$kIsMap = 3;
// Check if they have the same source and flags
function $ff55f7860a99da96$var$areSimilarRegExps(a, b) {
    return $ff55f7860a99da96$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $ff55f7860a99da96$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $ff55f7860a99da96$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $ff55f7860a99da96$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $ff55f7860a99da96$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $ff55f7860a99da96$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $ff55f7860a99da96$var$isEqualBoxedPrimitive(val1, val2) {
    if ($ff55f7860a99da96$var$isNumberObject(val1)) return $ff55f7860a99da96$var$isNumberObject(val2) && $ff55f7860a99da96$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($ff55f7860a99da96$var$isStringObject(val1)) return $ff55f7860a99da96$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($ff55f7860a99da96$var$isBooleanObject(val1)) return $ff55f7860a99da96$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($ff55f7860a99da96$var$isBigIntObject(val1)) return $ff55f7860a99da96$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $ff55f7860a99da96$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $ff55f7860a99da96$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $ff55f7860a99da96$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($ff55f7860a99da96$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $ff55f7860a99da96$var$numberIsNaN(val1) && $ff55f7860a99da96$var$numberIsNaN(val2);
        if ($ff55f7860a99da96$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $ff55f7860a99da96$var$_typeof(val1) !== 'object') {
            if (val2 === null || $ff55f7860a99da96$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $ff55f7860a99da96$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $ff55f7860a99da96$var$objectToString(val1);
    var val2Tag = $ff55f7860a99da96$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $ff55f7860a99da96$var$getOwnNonIndexProperties(val1, $ff55f7860a99da96$var$ONLY_ENUMERABLE);
        var keys2 = $ff55f7860a99da96$var$getOwnNonIndexProperties(val2, $ff55f7860a99da96$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, $ff55f7860a99da96$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$ff55f7860a99da96$var$isMap(val1) && $ff55f7860a99da96$var$isMap(val2) || !$ff55f7860a99da96$var$isSet(val1) && $ff55f7860a99da96$var$isSet(val2)) return false;
    }
    if ($ff55f7860a99da96$var$isDate(val1)) {
        if (!$ff55f7860a99da96$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($ff55f7860a99da96$var$isRegExp(val1)) {
        if (!$ff55f7860a99da96$var$isRegExp(val2) || !$ff55f7860a99da96$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($ff55f7860a99da96$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($ff55f7860a99da96$var$isArrayBufferView(val1)) {
        if (!strict && ($ff55f7860a99da96$var$isFloat32Array(val1) || $ff55f7860a99da96$var$isFloat64Array(val1))) {
            if (!$ff55f7860a99da96$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$ff55f7860a99da96$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $ff55f7860a99da96$var$getOwnNonIndexProperties(val1, $ff55f7860a99da96$var$ONLY_ENUMERABLE);
        var _keys2 = $ff55f7860a99da96$var$getOwnNonIndexProperties(val2, $ff55f7860a99da96$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, $ff55f7860a99da96$var$kNoIterator, _keys);
    } else if ($ff55f7860a99da96$var$isSet(val1)) {
        if (!$ff55f7860a99da96$var$isSet(val2) || val1.size !== val2.size) return false;
        return $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, $ff55f7860a99da96$var$kIsSet);
    } else if ($ff55f7860a99da96$var$isMap(val1)) {
        if (!$ff55f7860a99da96$var$isMap(val2) || val1.size !== val2.size) return false;
        return $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, $ff55f7860a99da96$var$kIsMap);
    } else if ($ff55f7860a99da96$var$isAnyArrayBuffer(val1)) {
        if (!$ff55f7860a99da96$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($ff55f7860a99da96$var$isBoxedPrimitive(val1) && !$ff55f7860a99da96$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, $ff55f7860a99da96$var$kNoIterator);
}
function $ff55f7860a99da96$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $ff55f7860a99da96$var$propertyIsEnumerable(val, k);
    });
}
function $ff55f7860a99da96$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$ff55f7860a99da96$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $ff55f7860a99da96$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($ff55f7860a99da96$var$propertyIsEnumerable(val1, key)) {
                    if (!$ff55f7860a99da96$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($ff55f7860a99da96$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $ff55f7860a99da96$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $ff55f7860a99da96$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $ff55f7860a99da96$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $ff55f7860a99da96$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $ff55f7860a99da96$var$kNoIterator || iterationType === $ff55f7860a99da96$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $ff55f7860a99da96$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $ff55f7860a99da96$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $ff55f7860a99da96$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($ff55f7860a99da96$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $ff55f7860a99da96$var$findLooseMatchingPrimitives(prim) {
    switch($ff55f7860a99da96$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($ff55f7860a99da96$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $ff55f7860a99da96$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $ff55f7860a99da96$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $ff55f7860a99da96$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $ff55f7860a99da96$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$ff55f7860a99da96$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $ff55f7860a99da96$var$innerDeepEqual(item, curB, false, memo);
}
function $ff55f7860a99da96$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $ff55f7860a99da96$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($ff55f7860a99da96$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$ff55f7860a99da96$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $ff55f7860a99da96$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($ff55f7860a99da96$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$ff55f7860a99da96$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$ff55f7860a99da96$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $ff55f7860a99da96$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $ff55f7860a99da96$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($ff55f7860a99da96$var$innerDeepEqual(key1, key2, strict, memo) && $ff55f7860a99da96$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $ff55f7860a99da96$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $ff55f7860a99da96$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $ff55f7860a99da96$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($ff55f7860a99da96$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$ff55f7860a99da96$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$ff55f7860a99da96$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $ff55f7860a99da96$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $ff55f7860a99da96$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($ff55f7860a99da96$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$ff55f7860a99da96$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$ff55f7860a99da96$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$ff55f7860a99da96$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $ff55f7860a99da96$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $ff55f7860a99da96$var$kIsSet) {
        if (!$ff55f7860a99da96$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $ff55f7860a99da96$var$kIsMap) {
        if (!$ff55f7860a99da96$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $ff55f7860a99da96$var$kIsArray) for(; i < a.length; i++){
        if ($ff55f7860a99da96$var$hasOwnProperty(a, i)) {
            if (!$ff55f7860a99da96$var$hasOwnProperty(b, i) || !$ff55f7860a99da96$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($ff55f7860a99da96$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$ff55f7860a99da96$var$hasOwnProperty(b, key) || !$ff55f7860a99da96$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$ff55f7860a99da96$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $ff55f7860a99da96$var$isDeepEqual(val1, val2) {
    return $ff55f7860a99da96$var$innerDeepEqual(val1, val2, $ff55f7860a99da96$var$kLoose);
}
function $ff55f7860a99da96$var$isDeepStrictEqual(val1, val2) {
    return $ff55f7860a99da96$var$innerDeepEqual(val1, val2, $ff55f7860a99da96$var$kStrict);
}
module.exports = {
    isDeepEqual: $ff55f7860a99da96$var$isDeepEqual,
    isDeepStrictEqual: $ff55f7860a99da96$var$isDeepStrictEqual
};

});
parcelRegister("gh4Iw", function(module, exports) {
'use strict';

var $hSIPK = parcelRequire("hSIPK");

var $6zl1T = parcelRequire("6zl1T");

var $6Mteo = parcelRequire("6Mteo");

var $4LgTG = parcelRequire("4LgTG");

var $2fKtp = parcelRequire("2fKtp");
var $bd91e494441fd9ab$var$polyfill = $6zl1T($4LgTG(), Object);
$hSIPK($bd91e494441fd9ab$var$polyfill, {
    getPolyfill: $4LgTG,
    implementation: $6Mteo,
    shim: $2fKtp
});
module.exports = $bd91e494441fd9ab$var$polyfill;

});
parcelRegister("hSIPK", function(module, exports) {
'use strict';

var $iJBzN = parcelRequire("iJBzN");
var $d04a41db78b5c12d$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $d04a41db78b5c12d$var$toStr = Object.prototype.toString;
var $d04a41db78b5c12d$var$concat = Array.prototype.concat;

var $gAEXI = parcelRequire("gAEXI");
var $d04a41db78b5c12d$var$isFunction = function(fn) {
    return typeof fn === 'function' && $d04a41db78b5c12d$var$toStr.call(fn) === '[object Function]';
};

var $d04a41db78b5c12d$var$supportsDescriptors = (parcelRequire("9ndBI"))();
var $d04a41db78b5c12d$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$d04a41db78b5c12d$var$isFunction(predicate) || !predicate()) return;
    }
    if ($d04a41db78b5c12d$var$supportsDescriptors) $gAEXI(object, name, value, true);
    else $gAEXI(object, name, value);
};
var $d04a41db78b5c12d$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $iJBzN(map);
    if ($d04a41db78b5c12d$var$hasSymbols) props = $d04a41db78b5c12d$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$d04a41db78b5c12d$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$d04a41db78b5c12d$var$defineProperties.supportsDescriptors = !!$d04a41db78b5c12d$var$supportsDescriptors;
module.exports = $d04a41db78b5c12d$var$defineProperties;

});

parcelRegister("2fKtp", function(module, exports) {
'use strict';

var $4LgTG = parcelRequire("4LgTG");

var $hSIPK = parcelRequire("hSIPK");
module.exports = function shimObjectIs() {
    var polyfill = $4LgTG();
    $hSIPK(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("fLjZy", function(module, exports) {
'use strict';

var $6zl1T = parcelRequire("6zl1T");

var $hSIPK = parcelRequire("hSIPK");

var $4ehKb = parcelRequire("4ehKb");

var $eh0Ub = parcelRequire("eh0Ub");

var $c4AUD = parcelRequire("c4AUD");
var $b79ac0c428ccfd21$var$polyfill = $6zl1T($eh0Ub(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $hSIPK($b79ac0c428ccfd21$var$polyfill, {
    getPolyfill: $eh0Ub,
    implementation: $4ehKb,
    shim: $c4AUD
});
module.exports = $b79ac0c428ccfd21$var$polyfill;

});
parcelRegister("4ehKb", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("eh0Ub", function(module, exports) {
'use strict';

var $4ehKb = parcelRequire("4ehKb");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $4ehKb;
};

});

parcelRegister("c4AUD", function(module, exports) {
'use strict';

var $hSIPK = parcelRequire("hSIPK");

var $eh0Ub = parcelRequire("eh0Ub");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $eh0Ub();
    $hSIPK(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("esDFm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SuppressWarnings = module.exports.Override = module.exports.Nullable = module.exports.NotNull = void 0;
function $a872730e1966eaf0$var$NotNull(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.NotNull = $a872730e1966eaf0$var$NotNull;
function $a872730e1966eaf0$var$Nullable(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.Nullable = $a872730e1966eaf0$var$Nullable;
function $a872730e1966eaf0$var$Override(target, propertyKey, propertyDescriptor) {
// do something with 'target' ...
}
module.exports.Override = $a872730e1966eaf0$var$Override;
function $a872730e1966eaf0$var$SuppressWarnings(options) {
    return (target, propertyKey, descriptor)=>{
    // intentionally empty
    };
}
module.exports.SuppressWarnings = $a872730e1966eaf0$var$SuppressWarnings;

});

parcelRegister("d4sFB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntStream = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.6934376-07:00
var $9841e360291f6c03$var$IntStream;
(function(IntStream) {
    /**
     * The value returned by {@link #LA LA()} when the end of the stream is
     * reached.
     */ IntStream.EOF = -1;
    /**
     * The value returned by {@link #getSourceName} when the actual name of the
     * underlying source is not known.
     */ IntStream.UNKNOWN_SOURCE_NAME = "<unknown>";
})($9841e360291f6c03$var$IntStream = module.exports.IntStream || (module.exports.IntStream = {}));

});


parcelRegister("jY97w", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e89ab20be58c2533$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BailErrorStrategy = void 0;

var $cNbax = parcelRequire("cNbax");

var $6iuj6 = parcelRequire("6iuj6");

var $esDFm = parcelRequire("esDFm");

var $5EAbA = parcelRequire("5EAbA");
/**
 * This implementation of {@link ANTLRErrorStrategy} responds to syntax errors
 * by immediately canceling the parse operation with a
 * {@link ParseCancellationException}. The implementation ensures that the
 * {@link ParserRuleContext#exception} field is set for all parse tree nodes
 * that were not completed prior to encountering the error.
 *
 * This error strategy is useful in the following scenarios.
 *
 * * **Two-stage parsing:** This error strategy allows the first
 *   stage of two-stage parsing to immediately terminate if an error is
 *   encountered, and immediately fall back to the second stage. In addition to
 *   avoiding wasted work by attempting to recover from errors here, the empty
 *   implementation of {@link BailErrorStrategy#sync} improves the performance of
 *   the first stage.
 * * **Silent validation:** When syntax errors are not being
 *   reported or logged, and the parse result is simply ignored if errors occur,
 *   the {@link BailErrorStrategy} avoids wasting work on recovering from errors
 *   when the result will be ignored either way.
 *
 * ```
 * myparser.errorHandler = new BailErrorStrategy();
 * ```
 *
 * @see Parser.errorHandler
 */ class $e89ab20be58c2533$var$BailErrorStrategy extends $cNbax.DefaultErrorStrategy {
    /** Instead of recovering from exception `e`, re-throw it wrapped
     *  in a {@link ParseCancellationException} so it is not caught by the
     *  rule function catches.  Use {@link Exception#getCause()} to get the
     *  original {@link RecognitionException}.
     */ recover(recognizer, e) {
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $5EAbA.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover inline; if the parser
     *  successfully recovers, it won't throw an exception.
     */ recoverInline(recognizer) {
        let e = new $6iuj6.InputMismatchException(recognizer);
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $5EAbA.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover from problems in subrules. */ sync(recognizer) {
    // intentionally empty
    }
}
$e89ab20be58c2533$var$__decorate([
    $esDFm.Override
], $e89ab20be58c2533$var$BailErrorStrategy.prototype, "recover", null);
$e89ab20be58c2533$var$__decorate([
    $esDFm.Override
], $e89ab20be58c2533$var$BailErrorStrategy.prototype, "recoverInline", null);
$e89ab20be58c2533$var$__decorate([
    $esDFm.Override
], $e89ab20be58c2533$var$BailErrorStrategy.prototype, "sync", null);
module.exports.BailErrorStrategy = $e89ab20be58c2533$var$BailErrorStrategy;

});
parcelRegister("cNbax", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9502b98abfaa9eda$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9502b98abfaa9eda$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultErrorStrategy = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $d7mTm = parcelRequire("d7mTm");

var $6iuj6 = parcelRequire("6iuj6");

var $6og9T = parcelRequire("6og9T");

var $4qcTm = parcelRequire("4qcTm");

var $haz8F = parcelRequire("haz8F");

var $2G93d = parcelRequire("2G93d");

var $esDFm = parcelRequire("esDFm");
/**
 * This is the default implementation of {@link ANTLRErrorStrategy} used for
 * error reporting and recovery in ANTLR parsers.
 */ class $9502b98abfaa9eda$var$DefaultErrorStrategy {
    constructor(){
        /**
         * Indicates whether the error strategy is currently "recovering from an
         * error". This is used to suppress reporting multiple error messages while
         * attempting to recover from a detected syntax error.
         *
         * @see #inErrorRecoveryMode
         */ this.errorRecoveryMode = false;
        /** The index into the input stream where the last error occurred.
         * 	This is used to prevent infinite loops where an error is found
         *  but no token is consumed during recovery...another error is found,
         *  ad nauseum.  This is a failsafe mechanism to guarantee that at least
         *  one token/tree node is consumed for two errors.
         */ this.lastErrorIndex = -1;
        /**
         * @see #nextTokensContext
         */ this.nextTokensState = $17Oz4.ATNState.INVALID_STATE_NUMBER;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition} to
     * ensure that the handler is not in error recovery mode.
     */ reset(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * This method is called to enter error recovery mode when a recognition
     * exception is reported.
     *
     * @param recognizer the parser instance
     */ beginErrorCondition(recognizer) {
        this.errorRecoveryMode = true;
    }
    /**
     * {@inheritDoc}
     */ inErrorRecoveryMode(recognizer) {
        return this.errorRecoveryMode;
    }
    /**
     * This method is called to leave error recovery mode after recovering from
     * a recognition exception.
     *
     * @param recognizer
     */ endErrorCondition(recognizer) {
        this.errorRecoveryMode = false;
        this.lastErrorStates = undefined;
        this.lastErrorIndex = -1;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition}.
     */ reportMatch(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation returns immediately if the handler is already
     * in error recovery mode. Otherwise, it calls {@link #beginErrorCondition}
     * and dispatches the reporting task based on the runtime type of `e`
     * according to the following table.
     *
     * * {@link NoViableAltException}: Dispatches the call to
     *   {@link #reportNoViableAlternative}
     * * {@link InputMismatchException}: Dispatches the call to
     *   {@link #reportInputMismatch}
     * * {@link FailedPredicateException}: Dispatches the call to
     *   {@link #reportFailedPredicate}
     * * All other types: calls {@link Parser#notifyErrorListeners} to report
     *   the exception
     */ reportError(recognizer, e) {
        // if we've already reported an error and have not matched a token
        // yet successfully, don't report any errors.
        if (this.inErrorRecoveryMode(recognizer)) //			System.err.print("[SPURIOUS] ");
        return; // don't report spurious errors
        this.beginErrorCondition(recognizer);
        if (e instanceof $4qcTm.NoViableAltException) this.reportNoViableAlternative(recognizer, e);
        else if (e instanceof $6iuj6.InputMismatchException) this.reportInputMismatch(recognizer, e);
        else if (e instanceof $d7mTm.FailedPredicateException) this.reportFailedPredicate(recognizer, e);
        else {
            console.error(`unknown recognition error type: ${e}`);
            this.notifyErrorListeners(recognizer, e.toString(), e);
        }
    }
    notifyErrorListeners(recognizer, message, e) {
        let offendingToken = e.getOffendingToken(recognizer);
        if (offendingToken === undefined) // Pass null to notifyErrorListeners so it in turn calls the error listeners with undefined as the offending
        // token. If we passed undefined, it would instead call the listeners with currentToken from the parser.
        offendingToken = null;
        recognizer.notifyErrorListeners(message, offendingToken, e);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation resynchronizes the parser by consuming tokens
     * until we find one in the resynchronization set--loosely the set of tokens
     * that can follow the current rule.
     */ recover(recognizer, e) {
        //		System.out.println("recover in "+recognizer.getRuleInvocationStack()+
        //						   " index="+recognizer.inputStream.index+
        //						   ", lastErrorIndex="+
        //						   lastErrorIndex+
        //						   ", states="+lastErrorStates);
        if (this.lastErrorIndex === recognizer.inputStream.index && this.lastErrorStates && this.lastErrorStates.contains(recognizer.state)) // uh oh, another error at same token index and previously-visited
        // state in ATN; must be a case where LT(1) is in the recovery
        // token set so nothing got consumed. Consume a single token
        // at least to prevent an infinite loop; this is a failsafe.
        //			System.err.println("seen error condition before index="+
        //							   lastErrorIndex+", states="+lastErrorStates);
        //			System.err.println("FAILSAFE consumes "+recognizer.getTokenNames()[recognizer.inputStream.LA(1)]);
        recognizer.consume();
        this.lastErrorIndex = recognizer.inputStream.index;
        if (!this.lastErrorStates) this.lastErrorStates = new $6og9T.IntervalSet();
        this.lastErrorStates.add(recognizer.state);
        let followSet = this.getErrorRecoverySet(recognizer);
        this.consumeUntil(recognizer, followSet);
    }
    /**
     * The default implementation of {@link ANTLRErrorStrategy#sync} makes sure
     * that the current lookahead symbol is consistent with what were expecting
     * at this point in the ATN. You can call this anytime but ANTLR only
     * generates code to check before subrules/loops and each iteration.
     *
     * Implements Jim Idle's magic sync mechanism in closures and optional
     * subrules. E.g.,
     *
     * ```antlr
     * a : sync ( stuff sync )* ;
     * sync : {consume to what can follow sync} ;
     * ```
     *
     * At the start of a sub rule upon error, {@link #sync} performs single
     * token deletion, if possible. If it can't do that, it bails on the current
     * rule and uses the default error recovery, which consumes until the
     * resynchronization set of the current rule.
     *
     * If the sub rule is optional (`(...)?`, `(...)*`, or block
     * with an empty alternative), then the expected set includes what follows
     * the subrule.
     *
     * During loop iteration, it consumes until it sees a token that can start a
     * sub rule or what follows loop. Yes, that is pretty aggressive. We opt to
     * stay in the loop as long as possible.
     *
     * **ORIGINS**
     *
     * Previous versions of ANTLR did a poor job of their recovery within loops.
     * A single mismatch token or missing token would force the parser to bail
     * out of the entire rules surrounding the loop. So, for rule
     *
     * ```antlr
     * classDef : 'class' ID '{' member* '}'
     * ```
     *
     * input with an extra token between members would force the parser to
     * consume until it found the next class definition rather than the next
     * member definition of the current class.
     *
     * This functionality cost a little bit of effort because the parser has to
     * compare token set at the start of the loop and at each iteration. If for
     * some reason speed is suffering for you, you can turn off this
     * functionality by simply overriding this method as a blank { }.
     */ sync(recognizer) {
        let s = recognizer.interpreter.atn.states[recognizer.state];
        //		System.err.println("sync @ "+s.stateNumber+"="+s.getClass().getSimpleName());
        // If already recovering, don't try to sync
        if (this.inErrorRecoveryMode(recognizer)) return;
        let tokens = recognizer.inputStream;
        let la = tokens.LA(1);
        // try cheaper subset first; might get lucky. seems to shave a wee bit off
        let nextTokens = recognizer.atn.nextTokens(s);
        if (nextTokens.contains(la)) {
            // We are sure the token matches
            this.nextTokensContext = undefined;
            this.nextTokensState = $17Oz4.ATNState.INVALID_STATE_NUMBER;
            return;
        }
        if (nextTokens.contains($2G93d.Token.EPSILON)) {
            if (this.nextTokensContext === undefined) {
                // It's possible the next token won't match; information tracked
                // by sync is restricted for performance.
                this.nextTokensContext = recognizer.context;
                this.nextTokensState = recognizer.state;
            }
            return;
        }
        switch(s.stateType){
            case $9TBHo.ATNStateType.BLOCK_START:
            case $9TBHo.ATNStateType.STAR_BLOCK_START:
            case $9TBHo.ATNStateType.PLUS_BLOCK_START:
            case $9TBHo.ATNStateType.STAR_LOOP_ENTRY:
                // report error and recover if possible
                if (this.singleTokenDeletion(recognizer)) return;
                throw new $6iuj6.InputMismatchException(recognizer);
            case $9TBHo.ATNStateType.PLUS_LOOP_BACK:
            case $9TBHo.ATNStateType.STAR_LOOP_BACK:
                //			System.err.println("at loop back: "+s.getClass().getSimpleName());
                this.reportUnwantedToken(recognizer);
                let expecting = recognizer.getExpectedTokens();
                let whatFollowsLoopIterationOrRule = expecting.or(this.getErrorRecoverySet(recognizer));
                this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
                break;
            default:
                break;
        }
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link NoViableAltException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportNoViableAlternative(recognizer, e) {
        let tokens = recognizer.inputStream;
        let input;
        if (tokens) {
            if (e.startToken.type === $2G93d.Token.EOF) input = "<EOF>";
            else input = tokens.getTextFromRange(e.startToken, e.getOffendingToken());
        } else input = "<unknown input>";
        let msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is an
     * {@link InputMismatchException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportInputMismatch(recognizer, e) {
        let expected = e.expectedTokens;
        let expectedString = expected ? expected.toStringVocabulary(recognizer.vocabulary) : "";
        let msg = "mismatched input " + this.getTokenErrorDisplay(e.getOffendingToken(recognizer)) + " expecting " + expectedString;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link FailedPredicateException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportFailedPredicate(recognizer, e) {
        let ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
        let msg = "rule " + ruleName + " " + e.message;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This method is called to report a syntax error which requires the removal
     * of a token from the input stream. At the time this method is called, the
     * erroneous symbol is current `LT(1)` symbol and has not yet been
     * removed from the input stream. When this method returns,
     * `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenDeletion} identifies
     * single-token deletion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportUnwantedToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let tokenName = this.getTokenErrorDisplay(t);
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "extraneous input " + tokenName + " expecting " + expecting.toStringVocabulary(recognizer.vocabulary);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * This method is called to report a syntax error which requires the
     * insertion of a missing token into the input stream. At the time this
     * method is called, the missing token has not yet been inserted. When this
     * method returns, `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenInsertion} identifies
     * single-token insertion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportMissingToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "missing " + expecting.toStringVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation attempts to recover from the mismatched input
     * by using single token insertion and deletion as described below. If the
     * recovery attempt fails, this method
     * {@link InputMismatchException}.
     *
     * **EXTRA TOKEN** (single token deletion)
     *
     * `LA(1)` is not what we are looking for. If `LA(2)` has the
     * right token, however, then assume `LA(1)` is some extra spurious
     * token and delete it. Then consume and return the next token (which was
     * the `LA(2)` token) as the successful result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenDeletion}.
     *
     * **MISSING TOKEN** (single token insertion)
     *
     * If current token (at `LA(1)`) is consistent with what could come
     * after the expected `LA(1)` token, then assume the token is missing
     * and use the parser's {@link TokenFactory} to create it on the fly. The
     * "insertion" is performed by returning the created token as the successful
     * result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenInsertion}.
     *
     * **EXAMPLE**
     *
     * For example, Input `i=(3;` is clearly missing the `')'`. When
     * the parser returns from the nested call to `expr`, it will have
     * call chain:
     *
     * ```
     * stat → expr → atom
     * ```
     *
     * and it will be trying to match the `')'` at this point in the
     * derivation:
     *
     * ```
     * => ID '=' '(' INT ')' ('+' atom)* ';'
     *                    ^
     * ```
     *
     * The attempt to match `')'` will fail when it sees `';'` and
     * call {@link #recoverInline}. To recover, it sees that `LA(1)==';'`
     * is in the set of tokens that can follow the `')'` token reference
     * in rule `atom`. It can assume that you forgot the `')'`.
     */ recoverInline(recognizer) {
        // SINGLE TOKEN DELETION
        let matchedSymbol = this.singleTokenDeletion(recognizer);
        if (matchedSymbol) {
            // we have deleted the extra token.
            // now, move past ttype token as if all were ok
            recognizer.consume();
            return matchedSymbol;
        }
        // SINGLE TOKEN INSERTION
        if (this.singleTokenInsertion(recognizer)) return this.getMissingSymbol(recognizer);
        // even that didn't work; must throw the exception
        if (this.nextTokensContext === undefined) throw new $6iuj6.InputMismatchException(recognizer);
        else throw new $6iuj6.InputMismatchException(recognizer, this.nextTokensState, this.nextTokensContext);
    }
    /**
     * This method implements the single-token insertion inline error recovery
     * strategy. It is called by {@link #recoverInline} if the single-token
     * deletion strategy fails to recover from the mismatched input. If this
     * method returns `true`, `recognizer` will be in error recovery
     * mode.
     *
     * This method determines whether or not single-token insertion is viable by
     * checking if the `LA(1)` input symbol could be successfully matched
     * if it were instead the `LA(2)` symbol. If this method returns
     * `true`, the caller is responsible for creating and inserting a
     * token with the correct type to produce this behavior.
     *
     * @param recognizer the parser instance
     * @returns `true` if single-token insertion is a viable recovery
     * strategy for the current mismatched input, otherwise `false`
     */ singleTokenInsertion(recognizer) {
        let currentSymbolType = recognizer.inputStream.LA(1);
        // if current token is consistent with what could come after current
        // ATN state, then we know we're missing a token; error recovery
        // is free to conjure up and insert the missing token
        let currentState = recognizer.interpreter.atn.states[recognizer.state];
        let next = currentState.transition(0).target;
        let atn = recognizer.interpreter.atn;
        let expectingAtLL2 = atn.nextTokens(next, $haz8F.PredictionContext.fromRuleContext(atn, recognizer.context));
        //		console.warn("LT(2) set="+expectingAtLL2.toString(recognizer.getTokenNames()));
        if (expectingAtLL2.contains(currentSymbolType)) {
            this.reportMissingToken(recognizer);
            return true;
        }
        return false;
    }
    /**
     * This method implements the single-token deletion inline error recovery
     * strategy. It is called by {@link #recoverInline} to attempt to recover
     * from mismatched input. If this method returns `undefined`, the parser and error
     * handler state will not have changed. If this method returns non-`undefined`,
     * `recognizer` will *not* be in error recovery mode since the
     * returned token was a successful match.
     *
     * If the single-token deletion is successful, this method calls
     * {@link #reportUnwantedToken} to report the error, followed by
     * {@link Parser#consume} to actually "delete" the extraneous token. Then,
     * before returning {@link #reportMatch} is called to signal a successful
     * match.
     *
     * @param recognizer the parser instance
     * @returns the successfully matched {@link Token} instance if single-token
     * deletion successfully recovers from the mismatched input, otherwise
     * `undefined`
     */ singleTokenDeletion(recognizer) {
        let nextTokenType = recognizer.inputStream.LA(2);
        let expecting = this.getExpectedTokens(recognizer);
        if (expecting.contains(nextTokenType)) {
            this.reportUnwantedToken(recognizer);
            /*
            System.err.println("recoverFromMismatchedToken deleting "+
                               ((TokenStream)recognizer.inputStream).LT(1)+
                               " since "+((TokenStream)recognizer.inputStream).LT(2)+
                               " is what we want");
            */ recognizer.consume(); // simply delete extra token
            // we want to return the token we're actually matching
            let matchedSymbol = recognizer.currentToken;
            this.reportMatch(recognizer); // we know current token is correct
            return matchedSymbol;
        }
        return undefined;
    }
    /** Conjure up a missing token during error recovery.
     *
     *  The recognizer attempts to recover from single missing
     *  symbols. But, actions might refer to that missing symbol.
     *  For example, x=ID {f($x);}. The action clearly assumes
     *  that there has been an identifier matched previously and that
     *  $x points at that token. If that token is missing, but
     *  the next token in the stream is what we want we assume that
     *  this token is missing and we keep going. Because we
     *  have to return some token to replace the missing token,
     *  we have to conjure one up. This method gives the user control
     *  over the tokens returned for missing tokens. Mostly,
     *  you will want to create something special for identifier
     *  tokens. For literals such as '{' and ',', the default
     *  action in the parser or tree parser works. It simply creates
     *  a CommonToken of the appropriate type. The text will be the token.
     *  If you change what tokens must be created by the lexer,
     *  override this method to create the appropriate tokens.
     */ getMissingSymbol(recognizer) {
        let currentSymbol = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let expectedTokenType = $2G93d.Token.INVALID_TYPE;
        if (!expecting.isNil) // get any element
        expectedTokenType = expecting.minElement;
        let tokenText;
        if (expectedTokenType === $2G93d.Token.EOF) tokenText = "<missing EOF>";
        else tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
        let current = currentSymbol;
        let lookback = recognizer.inputStream.tryLT(-1);
        if (current.type === $2G93d.Token.EOF && lookback != null) current = lookback;
        return this.constructToken(recognizer.inputStream.tokenSource, expectedTokenType, tokenText, current);
    }
    constructToken(tokenSource, expectedTokenType, tokenText, current) {
        let factory = tokenSource.tokenFactory;
        let x = current.tokenSource;
        let stream = x ? x.inputStream : undefined;
        return factory.create({
            source: tokenSource,
            stream: stream
        }, expectedTokenType, tokenText, $2G93d.Token.DEFAULT_CHANNEL, -1, -1, current.line, current.charPositionInLine);
    }
    getExpectedTokens(recognizer) {
        return recognizer.getExpectedTokens();
    }
    /** How should a token be displayed in an error message? The default
     *  is to display just the text, but during development you might
     *  want to have a lot of information spit out.  Override in that case
     *  to use t.toString() (which, for CommonToken, dumps everything about
     *  the token). This is better than forcing you to override a method in
     *  your token objects because you don't have to go modify your lexer
     *  so that it creates a new Java type.
     */ getTokenErrorDisplay(t) {
        if (!t) return "<no token>";
        let s = this.getSymbolText(t);
        if (!s) {
            if (this.getSymbolType(t) === $2G93d.Token.EOF) s = "<EOF>";
            else s = `<${this.getSymbolType(t)}>`;
        }
        return this.escapeWSAndQuote(s);
    }
    getSymbolText(symbol) {
        return symbol.text;
    }
    getSymbolType(symbol) {
        return symbol.type;
    }
    escapeWSAndQuote(s) {
        //		if ( s==null ) return s;
        s = s.replace("\n", "\\n");
        s = s.replace("\r", "\\r");
        s = s.replace("\t", "\\t");
        return "'" + s + "'";
    }
    /*  Compute the error recovery set for the current rule.  During
     *  rule invocation, the parser pushes the set of tokens that can
     *  follow that rule reference on the stack; this amounts to
     *  computing FIRST of what follows the rule reference in the
     *  enclosing rule. See LinearApproximator.FIRST().
     *  This local follow set only includes tokens
     *  from within the rule; i.e., the FIRST computation done by
     *  ANTLR stops at the end of a rule.
     *
     *  EXAMPLE
     *
     *  When you find a "no viable alt exception", the input is not
     *  consistent with any of the alternatives for rule r.  The best
     *  thing to do is to consume tokens until you see something that
     *  can legally follow a call to r *or* any rule that called r.
     *  You don't want the exact set of viable next tokens because the
     *  input might just be missing a token--you might consume the
     *  rest of the input looking for one of the missing tokens.
     *
     *  Consider grammar:
     *
     *  a : '[' b ']'
     *    | '(' b ')'
     *    ;
     *  b : c '^' INT ;
     *  c : ID
     *    | INT
     *    ;
     *
     *  At each rule invocation, the set of tokens that could follow
     *  that rule is pushed on a stack.  Here are the various
     *  context-sensitive follow sets:
     *
     *  FOLLOW(b1_in_a) = FIRST(']') = ']'
     *  FOLLOW(b2_in_a) = FIRST(')') = ')'
     *  FOLLOW(c_in_b) = FIRST('^') = '^'
     *
     *  Upon erroneous input "[]", the call chain is
     *
     *  a -> b -> c
     *
     *  and, hence, the follow context stack is:
     *
     *  depth     follow set       start of rule execution
     *    0         <EOF>                    a (from main())
     *    1          ']'                     b
     *    2          '^'                     c
     *
     *  Notice that ')' is not included, because b would have to have
     *  been called from a different context in rule a for ')' to be
     *  included.
     *
     *  For error recovery, we cannot consider FOLLOW(c)
     *  (context-sensitive or otherwise).  We need the combined set of
     *  all context-sensitive FOLLOW sets--the set of all tokens that
     *  could follow any reference in the call chain.  We need to
     *  resync to one of those tokens.  Note that FOLLOW(c)='^' and if
     *  we resync'd to that token, we'd consume until EOF.  We need to
     *  sync to context-sensitive FOLLOWs for a, b, and c: {']','^'}.
     *  In this case, for input "[]", LA(1) is ']' and in the set, so we would
     *  not consume anything. After printing an error, rule c would
     *  return normally.  Rule b would not find the required '^' though.
     *  At this point, it gets a mismatched token error and
     *  exception (since LA(1) is not in the viable following token
     *  set).  The rule exception handler tries to recover, but finds
     *  the same recovery set and doesn't consume anything.  Rule b
     *  exits normally returning to rule a.  Now it finds the ']' (and
     *  with the successful match exits errorRecovery mode).
     *
     *  So, you can see that the parser walks up the call chain looking
     *  for the token that was a member of the recovery set.
     *
     *  Errors are not generated in errorRecovery mode.
     *
     *  ANTLR's error recovery mechanism is based upon original ideas:
     *
     *  "Algorithms + Data Structures = Programs" by Niklaus Wirth
     *
     *  and
     *
     *  "A note on error recovery in recursive descent parsers":
     *  http://portal.acm.org/citation.cfm?id=947902.947905
     *
     *  Later, Josef Grosch had some good ideas:
     *
     *  "Efficient and Comfortable Error Recovery in Recursive Descent
     *  Parsers":
     *  ftp://www.cocolab.com/products/cocktail/doca4.ps/ell.ps.zip
     *
     *  Like Grosch I implement context-sensitive FOLLOW sets that are combined
     *  at run-time upon error to avoid overhead during parsing.
     */ getErrorRecoverySet(recognizer) {
        let atn = recognizer.interpreter.atn;
        let ctx = recognizer.context;
        let recoverSet = new $6og9T.IntervalSet();
        while(ctx && ctx.invokingState >= 0){
            // compute what follows who invoked us
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            let follow = atn.nextTokens(rt.followState);
            recoverSet.addAll(follow);
            ctx = ctx._parent;
        }
        recoverSet.remove($2G93d.Token.EPSILON);
        //		System.out.println("recover set "+recoverSet.toString(recognizer.getTokenNames()));
        return recoverSet;
    }
    /** Consume tokens until one matches the given token set. */ consumeUntil(recognizer, set) {
        //		System.err.println("consumeUntil("+set.toString(recognizer.getTokenNames())+")");
        let ttype = recognizer.inputStream.LA(1);
        while(ttype !== $2G93d.Token.EOF && !set.contains(ttype)){
            //System.out.println("consume during recover LA(1)="+getTokenNames()[input.LA(1)]);
            //			recognizer.inputStream.consume();
            recognizer.consume();
            ttype = recognizer.inputStream.LA(1);
        }
    }
}
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reset", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "beginErrorCondition", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "inErrorRecoveryMode", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "endErrorCondition", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportMatch", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportError", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "notifyErrorListeners", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "recover", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "sync", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull),
    $9502b98abfaa9eda$var$__param(1, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportNoViableAlternative", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull),
    $9502b98abfaa9eda$var$__param(1, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportInputMismatch", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull),
    $9502b98abfaa9eda$var$__param(1, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportFailedPredicate", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportUnwantedToken", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "reportMissingToken", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.Override
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "recoverInline", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "singleTokenInsertion", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "singleTokenDeletion", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.NotNull,
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "getMissingSymbol", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.NotNull,
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "getExpectedTokens", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "getSymbolText", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "getSymbolType", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.NotNull,
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "escapeWSAndQuote", null);
$9502b98abfaa9eda$var$__decorate([
    $esDFm.NotNull,
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "getErrorRecoverySet", null);
$9502b98abfaa9eda$var$__decorate([
    $9502b98abfaa9eda$var$__param(0, $esDFm.NotNull),
    $9502b98abfaa9eda$var$__param(1, $esDFm.NotNull)
], $9502b98abfaa9eda$var$DefaultErrorStrategy.prototype, "consumeUntil", null);
module.exports.DefaultErrorStrategy = $9502b98abfaa9eda$var$DefaultErrorStrategy;

});
parcelRegister("17Oz4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0d1dab0077cad626$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNState = void 0;

var $esDFm = parcelRequire("esDFm");
const $0d1dab0077cad626$var$INITIAL_NUM_TRANSITIONS = 4;
/**
 * The following images show the relation of states and
 * {@link ATNState#transitions} for various grammar constructs.
 *
 * * Solid edges marked with an &#0949; indicate a required
 *   {@link EpsilonTransition}.
 *
 * * Dashed edges indicate locations where any transition derived from
 *   {@link Transition} might appear.
 *
 * * Dashed nodes are place holders for either a sequence of linked
 *   {@link BasicState} states or the inclusion of a block representing a nested
 *   construct in one of the forms below.
 *
 * * Nodes showing multiple outgoing alternatives with a `...` support
 *   any number of alternatives (one or more). Nodes without the `...` only
 *   support the exact number of alternatives shown in the diagram.
 *
 * <h2>Basic Blocks</h2>
 *
 * <h3>Rule</h3>
 *
 * <embed src="images/Rule.svg" type="image/svg+xml"/>
 *
 * <h3>Block of 1 or more alternatives</h3>
 *
 * <embed src="images/Block.svg" type="image/svg+xml"/>
 *
 * <h2>Greedy Loops</h2>
 *
 * <h3>Greedy Closure: `(...)*`</h3>
 *
 * <embed src="images/ClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Positive Closure: `(...)+`</h3>
 *
 * <embed src="images/PositiveClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Optional: `(...)?`</h3>
 *
 * <embed src="images/OptionalGreedy.svg" type="image/svg+xml"/>
 *
 * <h2>Non-Greedy Loops</h2>
 *
 * <h3>Non-Greedy Closure: `(...)*?`</h3>
 *
 * <embed src="images/ClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Positive Closure: `(...)+?`</h3>
 *
 * <embed src="images/PositiveClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Optional: `(...)??`</h3>
 *
 * <embed src="images/OptionalNonGreedy.svg" type="image/svg+xml"/>
 */ class $0d1dab0077cad626$var$ATNState {
    constructor(){
        this.stateNumber = $0d1dab0077cad626$var$ATNState.INVALID_STATE_NUMBER;
        this.ruleIndex = 0; // at runtime, we don't have Rule objects
        this.epsilonOnlyTransitions = false;
        /** Track the transitions emanating from this ATN state. */ this.transitions = [];
        this.optimizedTransitions = this.transitions;
    }
    /**
     * Gets the state number.
     *
     * @returns the state number
     */ getStateNumber() {
        return this.stateNumber;
    }
    /**
     * For all states except {@link RuleStopState}, this returns the state
     * number. Returns -1 for stop states.
     *
     * @returns -1 for {@link RuleStopState}, otherwise the state number
     */ get nonStopStateNumber() {
        return this.getStateNumber();
    }
    hashCode() {
        return this.stateNumber;
    }
    equals(o) {
        // are these states same object?
        if (o instanceof $0d1dab0077cad626$var$ATNState) return this.stateNumber === o.stateNumber;
        return false;
    }
    get isNonGreedyExitState() {
        return false;
    }
    toString() {
        return String(this.stateNumber);
    }
    getTransitions() {
        return this.transitions.slice(0);
    }
    get numberOfTransitions() {
        return this.transitions.length;
    }
    addTransition(e, index) {
        if (this.transitions.length === 0) this.epsilonOnlyTransitions = e.isEpsilon;
        else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
            this.epsilonOnlyTransitions = false;
            throw new Error("ATN state " + this.stateNumber + " has both epsilon and non-epsilon transitions.");
        }
        this.transitions.splice(index !== undefined ? index : this.transitions.length, 0, e);
    }
    transition(i) {
        return this.transitions[i];
    }
    setTransition(i, e) {
        this.transitions[i] = e;
    }
    removeTransition(index) {
        return this.transitions.splice(index, 1)[0];
    }
    get onlyHasEpsilonTransitions() {
        return this.epsilonOnlyTransitions;
    }
    setRuleIndex(ruleIndex) {
        this.ruleIndex = ruleIndex;
    }
    get isOptimized() {
        return this.optimizedTransitions !== this.transitions;
    }
    get numberOfOptimizedTransitions() {
        return this.optimizedTransitions.length;
    }
    getOptimizedTransition(i) {
        return this.optimizedTransitions[i];
    }
    addOptimizedTransition(e) {
        if (!this.isOptimized) this.optimizedTransitions = new Array();
        this.optimizedTransitions.push(e);
    }
    setOptimizedTransition(i, e) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions[i] = e;
    }
    removeOptimizedTransition(i) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions.splice(i, 1);
    }
}
$0d1dab0077cad626$var$__decorate([
    $esDFm.Override
], $0d1dab0077cad626$var$ATNState.prototype, "hashCode", null);
$0d1dab0077cad626$var$__decorate([
    $esDFm.Override
], $0d1dab0077cad626$var$ATNState.prototype, "equals", null);
$0d1dab0077cad626$var$__decorate([
    $esDFm.Override
], $0d1dab0077cad626$var$ATNState.prototype, "toString", null);
module.exports.ATNState = $0d1dab0077cad626$var$ATNState;
(function(ATNState) {
    ATNState.INVALID_STATE_NUMBER = -1;
})($0d1dab0077cad626$var$ATNState = module.exports.ATNState || (module.exports.ATNState = {}));

});

parcelRegister("9TBHo", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNStateType = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:27.4734328-07:00
var $73467e5304f76889$var$ATNStateType;
(function(ATNStateType) {
    ATNStateType[ATNStateType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
    ATNStateType[ATNStateType["BASIC"] = 1] = "BASIC";
    ATNStateType[ATNStateType["RULE_START"] = 2] = "RULE_START";
    ATNStateType[ATNStateType["BLOCK_START"] = 3] = "BLOCK_START";
    ATNStateType[ATNStateType["PLUS_BLOCK_START"] = 4] = "PLUS_BLOCK_START";
    ATNStateType[ATNStateType["STAR_BLOCK_START"] = 5] = "STAR_BLOCK_START";
    ATNStateType[ATNStateType["TOKEN_START"] = 6] = "TOKEN_START";
    ATNStateType[ATNStateType["RULE_STOP"] = 7] = "RULE_STOP";
    ATNStateType[ATNStateType["BLOCK_END"] = 8] = "BLOCK_END";
    ATNStateType[ATNStateType["STAR_LOOP_BACK"] = 9] = "STAR_LOOP_BACK";
    ATNStateType[ATNStateType["STAR_LOOP_ENTRY"] = 10] = "STAR_LOOP_ENTRY";
    ATNStateType[ATNStateType["PLUS_LOOP_BACK"] = 11] = "PLUS_LOOP_BACK";
    ATNStateType[ATNStateType["LOOP_END"] = 12] = "LOOP_END";
})($73467e5304f76889$var$ATNStateType = module.exports.ATNStateType || (module.exports.ATNStateType = {}));

});

parcelRegister("d7mTm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $98cdafa8e98c4b36$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $98cdafa8e98c4b36$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FailedPredicateException = void 0;

var $lWPhg = parcelRequire("lWPhg");

var $esDFm = parcelRequire("esDFm");

var $dlxNc = parcelRequire("dlxNc");
/** A semantic predicate failed during validation.  Validation of predicates
 *  occurs when normally parsing the alternative just like matching a token.
 *  Disambiguating predicate evaluation occurs when we test a predicate during
 *  prediction.
 */ let $98cdafa8e98c4b36$var$FailedPredicateException = class FailedPredicateException extends $lWPhg.RecognitionException {
    constructor(recognizer, predicate, message){
        super(recognizer, recognizer.inputStream, recognizer.context, FailedPredicateException.formatMessage(predicate, message));
        let s = recognizer.interpreter.atn.states[recognizer.state];
        let trans = s.transition(0);
        if (trans instanceof $dlxNc.PredicateTransition) {
            this._ruleIndex = trans.ruleIndex;
            this._predicateIndex = trans.predIndex;
        } else {
            this._ruleIndex = 0;
            this._predicateIndex = 0;
        }
        this._predicate = predicate;
        super.setOffendingToken(recognizer, recognizer.currentToken);
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
    get predicateIndex() {
        return this._predicateIndex;
    }
    get predicate() {
        return this._predicate;
    }
    static formatMessage(predicate, message) {
        if (message) return message;
        return `failed predicate: {${predicate}}?`;
    }
};
$98cdafa8e98c4b36$var$__decorate([
    $esDFm.NotNull
], $98cdafa8e98c4b36$var$FailedPredicateException, "formatMessage", null);
$98cdafa8e98c4b36$var$FailedPredicateException = $98cdafa8e98c4b36$var$__decorate([
    $98cdafa8e98c4b36$var$__param(0, $esDFm.NotNull)
], $98cdafa8e98c4b36$var$FailedPredicateException);
module.exports.FailedPredicateException = $98cdafa8e98c4b36$var$FailedPredicateException;

});
parcelRegister("lWPhg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionException = void 0;
/** The root of the ANTLR exception hierarchy. In general, ANTLR tracks just
 *  3 kinds of errors: prediction errors, failed predicate errors, and
 *  mismatched input errors. In each case, the parser knows where it is
 *  in the input, where it is in the ATN, the rule invocation stack,
 *  and what kind of problem occurred.
 */ class $ffa6ca695057706e$var$RecognitionException extends Error {
    constructor(recognizer, input, ctx, message){
        super(message);
        this._offendingState = -1;
        this._recognizer = recognizer;
        this.input = input;
        this.ctx = ctx;
        if (recognizer) this._offendingState = recognizer.state;
    }
    /**
     * Get the ATN state number the parser was in at the time the error
     * occurred. For {@link NoViableAltException} and
     * {@link LexerNoViableAltException} exceptions, this is the
     * {@link DecisionState} number. For others, it is the state whose outgoing
     * edge we couldn't match.
     *
     * If the state number is not known, this method returns -1.
     */ get offendingState() {
        return this._offendingState;
    }
    setOffendingState(offendingState) {
        this._offendingState = offendingState;
    }
    /**
     * Gets the set of input symbols which could potentially follow the
     * previously matched symbol at the time this exception was thrown.
     *
     * If the set of expected tokens is not known and could not be computed,
     * this method returns `undefined`.
     *
     * @returns The set of token types that could potentially follow the current
     * state in the ATN, or `undefined` if the information is not available.
     */ get expectedTokens() {
        if (this._recognizer) return this._recognizer.atn.getExpectedTokens(this._offendingState, this.ctx);
        return undefined;
    }
    /**
     * Gets the {@link RuleContext} at the time this exception was thrown.
     *
     * If the context is not available, this method returns `undefined`.
     *
     * @returns The {@link RuleContext} at the time this exception was thrown.
     * If the context is not available, this method returns `undefined`.
     */ get context() {
        return this.ctx;
    }
    /**
     * Gets the input stream which is the symbol source for the recognizer where
     * this exception was thrown.
     *
     * If the input stream is not available, this method returns `undefined`.
     *
     * @returns The input stream which is the symbol source for the recognizer
     * where this exception was thrown, or `undefined` if the stream is not
     * available.
     */ get inputStream() {
        return this.input;
    }
    getOffendingToken(recognizer) {
        if (recognizer && recognizer !== this._recognizer) return undefined;
        return this.offendingToken;
    }
    setOffendingToken(recognizer, offendingToken) {
        if (recognizer === this._recognizer) this.offendingToken = offendingToken;
    }
    /**
     * Gets the {@link Recognizer} where this exception occurred.
     *
     * If the recognizer is not available, this method returns `undefined`.
     *
     * @returns The recognizer where this exception occurred, or `undefined` if
     * the recognizer is not available.
     */ get recognizer() {
        return this._recognizer;
    }
}
module.exports.RecognitionException = $ffa6ca695057706e$var$RecognitionException;

});

parcelRegister("dlxNc", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9b77730a2147488d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9b77730a2147488d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredicateTransition = void 0;

var $5sT1a = parcelRequire("5sT1a");

var $esDFm = parcelRequire("esDFm");

var $8DW9a = parcelRequire("8DW9a");
/** TODO: this is old comment:
 *  A tree of semantic predicates from the grammar AST if label==SEMPRED.
 *  In the ATN, labels will always be exactly one predicate, but the DFA
 *  may have to combine a bunch of them as it collects predicates from
 *  multiple ATN configurations into a single DFA state.
 */ let $9b77730a2147488d$var$PredicateTransition = class PredicateTransition extends $5sT1a.AbstractPredicateTransition {
    constructor(target, ruleIndex, predIndex, isCtxDependent){
        super(target);
        this.ruleIndex = ruleIndex;
        this.predIndex = predIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 4 /* PREDICATE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $8DW9a.SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
    }
    toString() {
        return "pred_" + this.ruleIndex + ":" + this.predIndex;
    }
};
$9b77730a2147488d$var$__decorate([
    $esDFm.Override
], $9b77730a2147488d$var$PredicateTransition.prototype, "serializationType", null);
$9b77730a2147488d$var$__decorate([
    $esDFm.Override
], $9b77730a2147488d$var$PredicateTransition.prototype, "isEpsilon", null);
$9b77730a2147488d$var$__decorate([
    $esDFm.Override
], $9b77730a2147488d$var$PredicateTransition.prototype, "matches", null);
$9b77730a2147488d$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $9b77730a2147488d$var$PredicateTransition.prototype, "toString", null);
$9b77730a2147488d$var$PredicateTransition = $9b77730a2147488d$var$__decorate([
    $9b77730a2147488d$var$__param(0, $esDFm.NotNull)
], $9b77730a2147488d$var$PredicateTransition);
module.exports.PredicateTransition = $9b77730a2147488d$var$PredicateTransition;

});
parcelRegister("5sT1a", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractPredicateTransition = void 0;

var $i2NOt = parcelRequire("i2NOt");
/**
 *
 * @author Sam Harwell
 */ class $3faa3ead218da507$var$AbstractPredicateTransition extends $i2NOt.Transition {
    constructor(target){
        super(target);
    }
}
module.exports.AbstractPredicateTransition = $3faa3ead218da507$var$AbstractPredicateTransition;

});
parcelRegister("i2NOt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d22f0dc3629a2b33$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d22f0dc3629a2b33$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transition = void 0;

var $esDFm = parcelRequire("esDFm");
/** An ATN transition between any two ATN states.  Subclasses define
 *  atom, set, epsilon, action, predicate, rule transitions.
 *
 *  This is a one way link.  It emanates from a state (usually via a list of
 *  transitions) and has a target state.
 *
 *  Since we never have to change the ATN transitions once we construct it,
 *  we can fix these transitions as specific classes. The DFA transitions
 *  on the other hand need to update the labels as it adds transitions to
 *  the states. We'll use the term Edge for the DFA to distinguish them from
 *  ATN transitions.
 */ let $d22f0dc3629a2b33$var$Transition = class Transition {
    constructor(target){
        if (target == null) throw new Error("target cannot be null.");
        this.target = target;
    }
    /**
     * Determines if the transition is an "epsilon" transition.
     *
     * The default implementation returns `false`.
     *
     * @returns `true` if traversing this transition in the ATN does not
     * consume an input symbol; otherwise, `false` if traversing this
     * transition consumes (matches) an input symbol.
     */ get isEpsilon() {
        return false;
    }
    get label() {
        return undefined;
    }
};
$d22f0dc3629a2b33$var$Transition.serializationNames = [
    "INVALID",
    "EPSILON",
    "RANGE",
    "RULE",
    "PREDICATE",
    "ATOM",
    "ACTION",
    "SET",
    "NOT_SET",
    "WILDCARD",
    "PRECEDENCE"
];
$d22f0dc3629a2b33$var$__decorate([
    $esDFm.NotNull
], $d22f0dc3629a2b33$var$Transition.prototype, "target", void 0);
$d22f0dc3629a2b33$var$Transition = $d22f0dc3629a2b33$var$__decorate([
    $d22f0dc3629a2b33$var$__param(0, $esDFm.NotNull)
], $d22f0dc3629a2b33$var$Transition);
module.exports.Transition = $d22f0dc3629a2b33$var$Transition;

});


parcelRegister("8DW9a", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $64af120133c02755$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $64af120133c02755$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SemanticContext = void 0;

var $fJumX = parcelRequire("fJumX");

var $crbOk = parcelRequire("crbOk");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $g4Hat = parcelRequire("g4Hat");
function $64af120133c02755$var$max(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison < 0) result = current;
    }
    return result;
}
function $64af120133c02755$var$min(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison > 0) result = current;
    }
    return result;
}
/** A tree structure used to record the semantic context in which
 *  an ATN configuration is valid.  It's either a single predicate,
 *  a conjunction `p1&&p2`, or a sum of products `p1||p2`.
 *
 *  I have scoped the {@link AND}, {@link OR}, and {@link Predicate} subclasses of
 *  {@link SemanticContext} within the scope of this outer class.
 */ class $64af120133c02755$var$SemanticContext {
    /**
     * The default {@link SemanticContext}, which is semantically equivalent to
     * a predicate of the form `{true}?`.
     */ static get NONE() {
        if ($64af120133c02755$var$SemanticContext._NONE === undefined) $64af120133c02755$var$SemanticContext._NONE = new $64af120133c02755$var$SemanticContext.Predicate();
        return $64af120133c02755$var$SemanticContext._NONE;
    }
    /**
     * Evaluate the precedence predicates for the context and reduce the result.
     *
     * @param parser The parser instance.
     * @param parserCallStack
     * @returns The simplified semantic context after precedence predicates are
     * evaluated, which will be one of the following values.
     *
     * * {@link #NONE}: if the predicate simplifies to `true` after
     *   precedence predicates are evaluated.
     * * `undefined`: if the predicate simplifies to `false` after
     *   precedence predicates are evaluated.
     * * `this`: if the semantic context is not changed as a result of
     *   precedence predicate evaluation.
     * * A non-`undefined` {@link SemanticContext}: the new simplified
     *   semantic context after precedence predicates are evaluated.
     */ evalPrecedence(parser, parserCallStack) {
        return this;
    }
    static and(a, b) {
        if (!a || a === $64af120133c02755$var$SemanticContext.NONE) return b;
        if (b === $64af120133c02755$var$SemanticContext.NONE) return a;
        let result = new $64af120133c02755$var$SemanticContext.AND(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
    /**
     *
     *  @see ParserATNSimulator#getPredsForAmbigAlts
     */ static or(a, b) {
        if (!a) return b;
        if (a === $64af120133c02755$var$SemanticContext.NONE || b === $64af120133c02755$var$SemanticContext.NONE) return $64af120133c02755$var$SemanticContext.NONE;
        let result = new $64af120133c02755$var$SemanticContext.OR(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
}
module.exports.SemanticContext = $64af120133c02755$var$SemanticContext;
(function(SemanticContext) {
    /**
     * This random 30-bit prime represents the value of `AND.class.hashCode()`.
     */ const AND_HASHCODE = 40363613;
    /**
     * This random 30-bit prime represents the value of `OR.class.hashCode()`.
     */ const OR_HASHCODE = 486279973;
    function filterPrecedencePredicates(collection) {
        let result = [];
        for(let i = 0; i < collection.length; i++){
            let context = collection[i];
            if (context instanceof SemanticContext.PrecedencePredicate) {
                result.push(context);
                // Remove the item from 'collection' and move i back so we look at the same index again
                collection.splice(i, 1);
                i--;
            }
        }
        return result;
    }
    class Predicate extends SemanticContext {
        constructor(ruleIndex = -1, predIndex = -1, isCtxDependent = false){
            super();
            this.ruleIndex = ruleIndex;
            this.predIndex = predIndex;
            this.isCtxDependent = isCtxDependent;
        }
        eval(parser, parserCallStack) {
            let localctx = this.isCtxDependent ? parserCallStack : undefined;
            return parser.sempred(localctx, this.ruleIndex, this.predIndex);
        }
        hashCode() {
            let hashCode = $i99P2.MurmurHash.initialize();
            hashCode = $i99P2.MurmurHash.update(hashCode, this.ruleIndex);
            hashCode = $i99P2.MurmurHash.update(hashCode, this.predIndex);
            hashCode = $i99P2.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
            hashCode = $i99P2.MurmurHash.finish(hashCode, 3);
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof Predicate)) return false;
            if (this === obj) return true;
            return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
        }
        toString() {
            return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
        }
    }
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], Predicate.prototype, "eval", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], Predicate.prototype, "hashCode", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], Predicate.prototype, "equals", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], Predicate.prototype, "toString", null);
    SemanticContext.Predicate = Predicate;
    class PrecedencePredicate extends SemanticContext {
        constructor(precedence){
            super();
            this.precedence = precedence;
        }
        eval(parser, parserCallStack) {
            return parser.precpred(parserCallStack, this.precedence);
        }
        evalPrecedence(parser, parserCallStack) {
            if (parser.precpred(parserCallStack, this.precedence)) return SemanticContext.NONE;
            else return undefined;
        }
        compareTo(o) {
            return this.precedence - o.precedence;
        }
        hashCode() {
            let hashCode = 1;
            hashCode = 31 * hashCode + this.precedence;
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof PrecedencePredicate)) return false;
            if (this === obj) return true;
            return this.precedence === obj.precedence;
        }
        toString() {
            return "{" + this.precedence + ">=prec}?";
        }
    }
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "eval", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "evalPrecedence", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "compareTo", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "hashCode", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "equals", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], PrecedencePredicate.prototype, "toString", null);
    SemanticContext.PrecedencePredicate = PrecedencePredicate;
    /**
     * This is the base class for semantic context "operators", which operate on
     * a collection of semantic context "operands".
     *
     * @since 4.3
     */ class Operator extends SemanticContext {
    }
    SemanticContext.Operator = Operator;
    /**
     * A semantic context which is true whenever none of the contained contexts
     * is false.
     */ let AND = class AND extends Operator {
        constructor(a, b){
            super();
            let operands = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
            if (a instanceof AND) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof AND) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the lowest precedence
            let reduced = $64af120133c02755$var$min(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof AND)) return false;
            return $crbOk.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $i99P2.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (!opnd.eval(parser, parserCallStack)) return false;
            }
            return true;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated == null) // The AND context is false if any element is false
                return undefined;
                else if (evaluated !== SemanticContext.NONE) // Reduce the result by skipping true elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were true, so the AND context is true
            return SemanticContext.NONE;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.and(result, operands[i]);
            return result;
        }
        toString() {
            return $g4Hat.join(this.opnds, "&&");
        }
    };
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "operands", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "equals", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "hashCode", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "eval", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "evalPrecedence", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], AND.prototype, "toString", null);
    AND = $64af120133c02755$var$__decorate([
        $64af120133c02755$var$__param(0, $esDFm.NotNull),
        $64af120133c02755$var$__param(1, $esDFm.NotNull)
    ], AND);
    SemanticContext.AND = AND;
    /**
     * A semantic context which is true whenever at least one of the contained
     * contexts is true.
     */ let OR = class OR extends Operator {
        constructor(a, b){
            super();
            let operands = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
            if (a instanceof OR) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof OR) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the highest precedence
            let reduced = $64af120133c02755$var$max(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof OR)) return false;
            return $crbOk.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $i99P2.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (opnd.eval(parser, parserCallStack)) return true;
            }
            return false;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated === SemanticContext.NONE) // The OR context is true if any element is true
                return SemanticContext.NONE;
                else if (evaluated) // Reduce the result by skipping false elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were false, so the OR context is false
            return undefined;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.or(result, operands[i]);
            return result;
        }
        toString() {
            return $g4Hat.join(this.opnds, "||");
        }
    };
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "operands", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "equals", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "hashCode", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "eval", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "evalPrecedence", null);
    $64af120133c02755$var$__decorate([
        $esDFm.Override
    ], OR.prototype, "toString", null);
    OR = $64af120133c02755$var$__decorate([
        $64af120133c02755$var$__param(0, $esDFm.NotNull),
        $64af120133c02755$var$__param(1, $esDFm.NotNull)
    ], OR);
    SemanticContext.OR = OR;
})($64af120133c02755$var$SemanticContext = module.exports.SemanticContext || (module.exports.SemanticContext = {}));

});
parcelRegister("fJumX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b7429dac6dd82255$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b7429dac6dd82255$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashSet = void 0;

var $gwEr2 = parcelRequire("gwEr2");

var $ikPYR = parcelRequire("ikPYR");

var $esDFm = parcelRequire("esDFm");

var $i99P2 = parcelRequire("i99P2");
/** {@link Set} implementation with closed hashing (open addressing). */ // NOTE:  JavaScript's Set interface has on significant different diffrence from Java's:
// 		  e.g. the return type of add() differs!
//        For this reason I've commented tweaked the implements clause
const $b7429dac6dd82255$var$INITAL_CAPACITY = 16; // must be power of 2
const $b7429dac6dd82255$var$LOAD_FACTOR = 0.75;
class $b7429dac6dd82255$var$Array2DHashSet {
    constructor(comparatorOrSet, initialCapacity = $b7429dac6dd82255$var$INITAL_CAPACITY){
        /** How many elements in set */ this.n = 0;
        this.threshold = Math.floor($b7429dac6dd82255$var$INITAL_CAPACITY * $b7429dac6dd82255$var$LOAD_FACTOR); // when to expand
        if (comparatorOrSet instanceof $b7429dac6dd82255$var$Array2DHashSet) {
            this.comparator = comparatorOrSet.comparator;
            this.buckets = comparatorOrSet.buckets.slice(0);
            for(let i = 0; i < this.buckets.length; i++){
                let bucket = this.buckets[i];
                if (bucket) this.buckets[i] = bucket.slice(0);
            }
            this.n = comparatorOrSet.n;
            this.threshold = comparatorOrSet.threshold;
        } else {
            this.comparator = comparatorOrSet || $ikPYR.DefaultEqualityComparator.INSTANCE;
            this.buckets = this.createBuckets(initialCapacity);
        }
    }
    /**
     * Add `o` to set if not there; return existing value if already
     * there. This method performs the same operation as {@link #add} aside from
     * the return value.
     */ getOrAdd(o) {
        if (this.n > this.threshold) this.expand();
        return this.getOrAddImpl(o);
    }
    getOrAddImpl(o) {
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        // NEW BUCKET
        if (!bucket) {
            bucket = [
                o
            ];
            this.buckets[b] = bucket;
            this.n++;
            return o;
        }
        // LOOK FOR IT IN BUCKET
        for (let existing of bucket){
            if (this.comparator.equals(existing, o)) return existing; // found existing, quit
        }
        // FULL BUCKET, expand and add to end
        bucket.push(o);
        this.n++;
        return o;
    }
    get(o) {
        if (o == null) return o;
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        if (!bucket) // no bucket
        return undefined;
        for (let e of bucket){
            if (this.comparator.equals(e, o)) return e;
        }
        return undefined;
    }
    getBucket(o) {
        let hash = this.comparator.hashCode(o);
        let b = hash & this.buckets.length - 1; // assumes len is power of 2
        return b;
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                hash = $i99P2.MurmurHash.update(hash, this.comparator.hashCode(o));
            }
        }
        hash = $i99P2.MurmurHash.finish(hash, this.size);
        return hash;
    }
    equals(o) {
        if (o === this) return true;
        if (!(o instanceof $b7429dac6dd82255$var$Array2DHashSet)) return false;
        if (o.size !== this.size) return false;
        let same = this.containsAll(o);
        return same;
    }
    expand() {
        let old = this.buckets;
        let newCapacity = this.buckets.length * 2;
        let newTable = this.createBuckets(newCapacity);
        this.buckets = newTable;
        this.threshold = Math.floor(newCapacity * $b7429dac6dd82255$var$LOAD_FACTOR);
        //		System.out.println("new size="+newCapacity+", thres="+threshold);
        // rehash all existing entries
        let oldSize = this.size;
        for (let bucket of old){
            if (!bucket) continue;
            for (let o of bucket){
                let b = this.getBucket(o);
                let newBucket = this.buckets[b];
                if (!newBucket) {
                    newBucket = [];
                    this.buckets[b] = newBucket;
                }
                newBucket.push(o);
            }
        }
        $gwEr2(this.n === oldSize);
    }
    add(t) {
        let existing = this.getOrAdd(t);
        return existing === t;
    }
    get size() {
        return this.n;
    }
    get isEmpty() {
        return this.n === 0;
    }
    contains(o) {
        return this.containsFast(this.asElementType(o));
    }
    containsFast(obj) {
        if (obj == null) return false;
        return this.get(obj) != null;
    }
    *[Symbol.iterator]() {
        yield* this.toArray();
    }
    toArray() {
        const a = new Array(this.size);
        // Copy elements from the nested arrays into the destination array
        let i = 0; // Position within destination array
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                a[i++] = o;
            }
        }
        return a;
    }
    containsAll(collection) {
        if (collection instanceof $b7429dac6dd82255$var$Array2DHashSet) {
            let s = collection;
            for (let bucket of s.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    if (!this.containsFast(this.asElementType(o))) return false;
                }
            }
        } else for (let o of collection){
            if (!this.containsFast(this.asElementType(o))) return false;
        }
        return true;
    }
    addAll(c) {
        let changed = false;
        for (let o of c){
            let existing = this.getOrAdd(o);
            if (existing !== o) changed = true;
        }
        return changed;
    }
    clear() {
        this.buckets = this.createBuckets($b7429dac6dd82255$var$INITAL_CAPACITY);
        this.n = 0;
        this.threshold = Math.floor($b7429dac6dd82255$var$INITAL_CAPACITY * $b7429dac6dd82255$var$LOAD_FACTOR);
    }
    toString() {
        if (this.size === 0) return "{}";
        let buf = "{";
        let first = true;
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                if (first) first = false;
                else buf += ", ";
                buf += o.toString();
            }
        }
        buf += "}";
        return buf;
    }
    toTableString() {
        let buf = "";
        for (let bucket of this.buckets){
            if (bucket == null) {
                buf += "null\n";
                continue;
            }
            buf += "[";
            let first = true;
            for (let o of bucket){
                if (first) first = false;
                else buf += " ";
                if (o == null) buf += "_";
                else buf += o.toString();
            }
            buf += "]\n";
        }
        return buf;
    }
    /**
     * Return `o` as an instance of the element type `T`. If
     * `o` is non-undefined but known to not be an instance of `T`, this
     * method returns `undefined`. The base implementation does not perform any
     * type checks; override this method to provide strong type checks for the
     * {@link #contains} and {@link #remove} methods to ensure the arguments to
     * the {@link EqualityComparator} for the set always have the expected
     * types.
     *
     * @param o the object to try and cast to the element type of the set
     * @returns `o` if it could be an instance of `T`, otherwise
     * `undefined`.
     */ asElementType(o) {
        return o;
    }
    /**
     * Return an array of `T[]` with length `capacity`.
     *
     * @param capacity the length of the array to return
     * @returns the newly constructed array
     */ createBuckets(capacity) {
        return new Array(capacity);
    }
}
$b7429dac6dd82255$var$__decorate([
    $esDFm.NotNull
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "comparator", void 0);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "hashCode", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "equals", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "add", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "size", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "isEmpty", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "contains", null);
$b7429dac6dd82255$var$__decorate([
    $b7429dac6dd82255$var$__param(0, $esDFm.Nullable)
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "containsFast", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, Symbol.iterator, null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "toArray", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "containsAll", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "addAll", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "clear", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.Override
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "toString", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.SuppressWarnings("unchecked")
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "asElementType", null);
$b7429dac6dd82255$var$__decorate([
    $esDFm.SuppressWarnings("unchecked")
], $b7429dac6dd82255$var$Array2DHashSet.prototype, "createBuckets", null);
module.exports.Array2DHashSet = $b7429dac6dd82255$var$Array2DHashSet;

});
parcelRegister("ikPYR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d5926a811e8c9536$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultEqualityComparator = void 0;

var $esDFm = parcelRequire("esDFm");

var $i99P2 = parcelRequire("i99P2");

var $73sQO = parcelRequire("73sQO");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $d5926a811e8c9536$var$DefaultEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        else if (typeof obj === "string" || typeof obj === "number") return $i99P2.MurmurHash.hashCode([
            obj
        ]);
        else return $73sQO.ObjectEqualityComparator.INSTANCE.hashCode(obj);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (typeof a === "string" || typeof a === "number") return a === b;
        else return $73sQO.ObjectEqualityComparator.INSTANCE.equals(a, b);
    }
}
$d5926a811e8c9536$var$DefaultEqualityComparator.INSTANCE = new $d5926a811e8c9536$var$DefaultEqualityComparator();
$d5926a811e8c9536$var$__decorate([
    $esDFm.Override
], $d5926a811e8c9536$var$DefaultEqualityComparator.prototype, "hashCode", null);
$d5926a811e8c9536$var$__decorate([
    $esDFm.Override
], $d5926a811e8c9536$var$DefaultEqualityComparator.prototype, "equals", null);
module.exports.DefaultEqualityComparator = $d5926a811e8c9536$var$DefaultEqualityComparator;

});
parcelRegister("i99P2", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MurmurHash = void 0;
/**
 *
 * @author Sam Harwell
 */ var $d360afbc1084b137$var$MurmurHash;
(function(MurmurHash) {
    const DEFAULT_SEED = 0;
    /**
     * Initialize the hash using the specified `seed`.
     *
     * @param seed the seed (optional)
     * @returns the intermediate hash value
     */ function initialize(seed = DEFAULT_SEED) {
        return seed;
    }
    MurmurHash.initialize = initialize;
    /**
     * Update the intermediate hash value for the next input `value`.
     *
     * @param hash the intermediate hash value
     * @param value the value to add to the current hash
     * @returns the updated intermediate hash value
     */ function update(hash, value) {
        const c1 = 0xCC9E2D51;
        const c2 = 0x1B873593;
        const r1 = 15;
        const r2 = 13;
        const m = 5;
        const n = 0xE6546B64;
        if (value == null) value = 0;
        else if (typeof value === "string") value = hashString(value);
        else if (typeof value === "object") value = value.hashCode();
        let k = value;
        k = Math.imul(k, c1);
        k = k << r1 | k >>> 32 - r1;
        k = Math.imul(k, c2);
        hash = hash ^ k;
        hash = hash << r2 | hash >>> 32 - r2;
        hash = Math.imul(hash, m) + n;
        return hash & 0xFFFFFFFF;
    }
    MurmurHash.update = update;
    /**
     * Apply the final computation steps to the intermediate value `hash`
     * to form the final result of the MurmurHash 3 hash function.
     *
     * @param hash the intermediate hash value
     * @param numberOfWords the number of integer values added to the hash
     * @returns the final hash result
     */ function finish(hash, numberOfWords) {
        hash = hash ^ numberOfWords * 4;
        hash = hash ^ hash >>> 16;
        hash = Math.imul(hash, 0x85EBCA6B);
        hash = hash ^ hash >>> 13;
        hash = Math.imul(hash, 0xC2B2AE35);
        hash = hash ^ hash >>> 16;
        return hash;
    }
    MurmurHash.finish = finish;
    /**
     * Utility function to compute the hash code of an array using the
     * MurmurHash algorithm.
     *
     * @param <T> the array element type
     * @param data the array data
     * @param seed the seed for the MurmurHash algorithm
     * @returns the hash code of the data
     */ function hashCode(data, seed = DEFAULT_SEED) {
        let hash = initialize(seed);
        let length = 0;
        for (let value of data){
            hash = update(hash, value);
            length++;
        }
        hash = finish(hash, length);
        return hash;
    }
    MurmurHash.hashCode = hashCode;
    /**
     * Function to hash a string. Based on the implementation found here:
     * http://stackoverflow.com/a/7616484
     */ function hashString(str) {
        let len = str.length;
        if (len === 0) return 0;
        let hash = 0;
        for(let i = 0; i < len; i++){
            let c = str.charCodeAt(i);
            hash = (hash << 5 >>> 0) - hash + c;
            hash |= 0;
        }
        return hash;
    }
})($d360afbc1084b137$var$MurmurHash = module.exports.MurmurHash || (module.exports.MurmurHash = {}));

});

parcelRegister("73sQO", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $522f31675a8ff093$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectEqualityComparator = void 0;

var $esDFm = parcelRequire("esDFm");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $522f31675a8ff093$var$ObjectEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return obj.hashCode();
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        return a.equals(b);
    }
}
$522f31675a8ff093$var$ObjectEqualityComparator.INSTANCE = new $522f31675a8ff093$var$ObjectEqualityComparator();
$522f31675a8ff093$var$__decorate([
    $esDFm.Override
], $522f31675a8ff093$var$ObjectEqualityComparator.prototype, "hashCode", null);
$522f31675a8ff093$var$__decorate([
    $esDFm.Override
], $522f31675a8ff093$var$ObjectEqualityComparator.prototype, "equals", null);
module.exports.ObjectEqualityComparator = $522f31675a8ff093$var$ObjectEqualityComparator;

});



parcelRegister("crbOk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $90e12b08060db581$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrayEqualityComparator = void 0;

var $esDFm = parcelRequire("esDFm");

var $i99P2 = parcelRequire("i99P2");

var $73sQO = parcelRequire("73sQO");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $90e12b08060db581$var$ArrayEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return $i99P2.MurmurHash.hashCode(obj, 0);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined`, this method returns `true`. Otherwise if only
     * `a` is `undefined`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (b == null) return false;
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$73sQO.ObjectEqualityComparator.INSTANCE.equals(a[i], b[i])) return false;
        }
        return true;
    }
}
$90e12b08060db581$var$ArrayEqualityComparator.INSTANCE = new $90e12b08060db581$var$ArrayEqualityComparator();
$90e12b08060db581$var$__decorate([
    $esDFm.Override
], $90e12b08060db581$var$ArrayEqualityComparator.prototype, "hashCode", null);
$90e12b08060db581$var$__decorate([
    $esDFm.Override
], $90e12b08060db581$var$ArrayEqualityComparator.prototype, "equals", null);
module.exports.ArrayEqualityComparator = $90e12b08060db581$var$ArrayEqualityComparator;

});

parcelRegister("g4Hat", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toCharArray = module.exports.toMap = module.exports.equals = module.exports.join = module.exports.escapeWhitespace = void 0;
function $bb3e8152647e0789$var$escapeWhitespace(s, escapeSpaces) {
    return escapeSpaces ? s.replace(/ /, "\u00B7") : s.replace(/\t/, "\\t").replace(/\n/, "\\n").replace(/\r/, "\\r");
}
module.exports.escapeWhitespace = $bb3e8152647e0789$var$escapeWhitespace;
// Seriously: why isn't this built in to java? ugh!
function $bb3e8152647e0789$var$join(collection, separator) {
    let buf = "";
    let first = true;
    for (let current of collection){
        if (first) first = false;
        else buf += separator;
        buf += current;
    }
    return buf;
}
module.exports.join = $bb3e8152647e0789$var$join;
function $bb3e8152647e0789$var$equals(x, y) {
    if (x === y) return true;
    if (x === undefined || y === undefined) return false;
    return x.equals(y);
}
module.exports.equals = $bb3e8152647e0789$var$equals;
// export function numNonnull(data: any[]): number {
// 	let n: number =  0;
// 	if ( data == null ) return n;
// 	for (let o of data) {
// 		if ( o!=null ) n++;
// 	}
// 	return n;
// }
// export function removeAllElements<T>(data: Collection<T>, value: T): void {
// 	if ( data==null ) return;
// 	while ( data.contains(value) ) data.remove(value);
// }
// export function writeFile(@NotNull file: File, @NotNull content: Uint8Array): void {
// 	let fos: FileOutputStream = new FileOutputStream(file);
// 	try {
// 		fos.write(content);
// 	} finally {
// 		fos.close();
// 	}
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string): void {
// 	writeFile(fileName, content, null);
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string, @Nullable encoding: string): void {
// 	let f: File =  new File(fileName);
// 	let fos: FileOutputStream =  new FileOutputStream(f);
// 	let osw: OutputStreamWriter;
// 	if (encoding != null) {
// 		osw = new OutputStreamWriter(fos, encoding);
// 	}
// 	else {
// 		osw = new OutputStreamWriter(fos);
// 	}
// 	try {
// 		osw.write(content);
// 	}
// 	finally {
// 		osw.close();
// 	}
// }
// @NotNull
// export function readFile(@NotNull fileName: string): char[] {
// 	return readFile(fileName, null);
// }
// @NotNull
// export function readFile(@NotNull fileName: string, @Nullable encoding: string): char[] {
// 	let f: File =  new File(fileName);
// 	let size: number =  (int)f.length();
// 	let isr: InputStreamReader;
// 	let fis: FileInputStream =  new FileInputStream(fileName);
// 	if ( encoding!=null ) {
// 		isr = new InputStreamReader(fis, encoding);
// 	}
// 	else {
// 		isr = new InputStreamReader(fis);
// 	}
// 	let data: char[] =  null;
// 	try {
// 		data = new char[size];
// 		let n: number =  isr.read(data);
// 		if (n < data.length) {
// 			data = Arrays.copyOf(data, n);
// 		}
// 	}
// 	finally {
// 		isr.close();
// 	}
// 	return data;
// }
// export function removeAll<T>(@NotNull predicate: List<T> list,@NotNull Predicate<? super T>): void {
// 	let j: number =  0;
// 	for (let i = 0; i < list.size; i++) {
// 		let item: T =  list.get(i);
// 		if (!predicate.eval(item)) {
// 			if (j != i) {
// 				list.set(j, item);
// 			}
// 			j++;
// 		}
// 	}
// 	if (j < list.size) {
// 		list.subList(j, list.size).clear();
// 	}
// }
// export function removeAll<T>(@NotNull predicate: Iterable<T> iterable,@NotNull Predicate<? super T>): void {
// 	if (iterable instanceof List<?>) {
// 		removeAll((List<T>)iterable, predicate);
// 		return;
// 	}
// 	for (Iterator<T> iterator = iterable.iterator(); iterator.hasNext(); ) {
// 		let item: T =  iterator.next();
// 		if (predicate.eval(item)) {
// 			iterator.remove();
// 		}
// 	}
// }
/** Convert array of strings to string&rarr;index map. Useful for
 *  converting rulenames to name&rarr;ruleindex map.
 */ function $bb3e8152647e0789$var$toMap(keys) {
    let m = new Map();
    for(let i = 0; i < keys.length; i++)m.set(keys[i], i);
    return m;
}
module.exports.toMap = $bb3e8152647e0789$var$toMap;
function $bb3e8152647e0789$var$toCharArray(str) {
    if (typeof str === "string") {
        let result = new Uint16Array(str.length);
        for(let i = 0; i < str.length; i++)result[i] = str.charCodeAt(i);
        return result;
    } else return str.toCharArray();
}
module.exports.toCharArray = $bb3e8152647e0789$var$toCharArray; // /**
 // 	* @since 4.5
 // 	*/
 // @NotNull
 // export function toSet(@NotNull bits: BitSet): IntervalSet {
 // 	let s: IntervalSet =  new IntervalSet();
 // 	let i: number =  bits.nextSetBit(0);
 // 	while ( i >= 0 ) {
 // 		s.add(i);
 // 		i = bits.nextSetBit(i+1);
 // 	}
 // 	return s;
 // }

});




parcelRegister("6iuj6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $495beedc9f8e5b02$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $495beedc9f8e5b02$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InputMismatchException = void 0;

var $lWPhg = parcelRequire("lWPhg");

var $esDFm = parcelRequire("esDFm");
/** This signifies any kind of mismatched input exceptions such as
 *  when the current input does not match the expected token.
 */ let $495beedc9f8e5b02$var$InputMismatchException = class InputMismatchException extends $lWPhg.RecognitionException {
    constructor(recognizer, state, context){
        if (context === undefined) context = recognizer.context;
        super(recognizer, recognizer.inputStream, context);
        if (state !== undefined) this.setOffendingState(state);
        this.setOffendingToken(recognizer, recognizer.currentToken);
    }
};
$495beedc9f8e5b02$var$InputMismatchException = $495beedc9f8e5b02$var$__decorate([
    $495beedc9f8e5b02$var$__param(0, $esDFm.NotNull)
], $495beedc9f8e5b02$var$InputMismatchException);
module.exports.InputMismatchException = $495beedc9f8e5b02$var$InputMismatchException;

});

parcelRegister("6og9T", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4a7184b7a0008122$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4a7184b7a0008122$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntervalSet = void 0;

var $crbOk = parcelRequire("crbOk");

var $eOyS9 = parcelRequire("eOyS9");

var $4Q2DM = parcelRequire("4Q2DM");

var $gTQRB = parcelRequire("gTQRB");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * This class implements the {@link IntSet} backed by a sorted array of
 * non-overlapping intervals. It is particularly efficient for representing
 * large collections of numbers, where the majority of elements appear as part
 * of a sequential range of numbers that are all part of the set. For example,
 * the set { 1, 2, 3, 4, 7, 8 } may be represented as { [1, 4], [7, 8] }.
 *
 * This class is able to represent sets containing any combination of values in
 * the range {@link Integer#MIN_VALUE} to {@link Integer#MAX_VALUE}
 * (inclusive).
 */ class $4a7184b7a0008122$var$IntervalSet {
    constructor(intervals){
        this.readonly = false;
        if (intervals != null) this._intervals = intervals.slice(0);
        else this._intervals = [];
    }
    static get COMPLETE_CHAR_SET() {
        if ($4a7184b7a0008122$var$IntervalSet._COMPLETE_CHAR_SET === undefined) {
            $4a7184b7a0008122$var$IntervalSet._COMPLETE_CHAR_SET = $4a7184b7a0008122$var$IntervalSet.of($gTQRB.Lexer.MIN_CHAR_VALUE, $gTQRB.Lexer.MAX_CHAR_VALUE);
            $4a7184b7a0008122$var$IntervalSet._COMPLETE_CHAR_SET.setReadonly(true);
        }
        return $4a7184b7a0008122$var$IntervalSet._COMPLETE_CHAR_SET;
    }
    static get EMPTY_SET() {
        if ($4a7184b7a0008122$var$IntervalSet._EMPTY_SET == null) {
            $4a7184b7a0008122$var$IntervalSet._EMPTY_SET = new $4a7184b7a0008122$var$IntervalSet();
            $4a7184b7a0008122$var$IntervalSet._EMPTY_SET.setReadonly(true);
        }
        return $4a7184b7a0008122$var$IntervalSet._EMPTY_SET;
    }
    /**
     * Create a set with all ints within range [a..b] (inclusive). If b is omitted, the set contains the single element
     * a.
     */ static of(a, b = a) {
        let s = new $4a7184b7a0008122$var$IntervalSet();
        s.add(a, b);
        return s;
    }
    clear() {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        this._intervals.length = 0;
    }
    /** Add interval; i.e., add all integers from a to b to set.
     *  If b&lt;a, do nothing.
     *  Keep list in sorted order (by left range value).
     *  If overlap, combine ranges.  For example,
     *  If this is {1..5, 10..20}, adding 6..7 yields
     *  {1..5, 6..7, 10..20}.  Adding 4..8 yields {1..8, 10..20}.
     */ add(a, b = a) {
        this.addRange($4Q2DM.Interval.of(a, b));
    }
    // copy on write so we can cache a..a intervals and sets of that
    addRange(addition) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        //System.out.println("add "+addition+" to "+intervals.toString());
        if (addition.b < addition.a) return;
        // find position in list
        // Use iterators as we modify list in place
        for(let i = 0; i < this._intervals.length; i++){
            let r = this._intervals[i];
            if (addition.equals(r)) return;
            if (addition.adjacent(r) || !addition.disjoint(r)) {
                // next to each other, make a single larger interval
                let bigger = addition.union(r);
                this._intervals[i] = bigger;
                // make sure we didn't just create an interval that
                // should be merged with next interval in list
                while(i < this._intervals.length - 1){
                    i++;
                    let next = this._intervals[i];
                    if (!bigger.adjacent(next) && bigger.disjoint(next)) break;
                    // if we bump up against or overlap next, merge
                    // remove this one
                    this._intervals.splice(i, 1);
                    i--;
                    // move backwards to what we just set
                    this._intervals[i] = bigger.union(next);
                // set to 3 merged ones
                }
                // first call to next after previous duplicates the result
                return;
            }
            if (addition.startsBeforeDisjoint(r)) {
                // insert before r
                this._intervals.splice(i, 0, addition);
                return;
            }
        // if disjoint and after r, a future iteration will handle it
        }
        // ok, must be after last interval (and disjoint from last interval)
        // just add it
        this._intervals.push(addition);
    }
    /** combine all sets in the array returned the or'd value */ static or(sets) {
        let r = new $4a7184b7a0008122$var$IntervalSet();
        for (let s of sets)r.addAll(s);
        return r;
    }
    addAll(set) {
        if (set == null) return this;
        if (set instanceof $4a7184b7a0008122$var$IntervalSet) {
            let other = set;
            // walk set and add each interval
            let n = other._intervals.length;
            for(let i = 0; i < n; i++){
                let I = other._intervals[i];
                this.add(I.a, I.b);
            }
        } else for (let value of set.toArray())this.add(value);
        return this;
    }
    complementRange(minElement, maxElement) {
        return this.complement($4a7184b7a0008122$var$IntervalSet.of(minElement, maxElement));
    }
    /** {@inheritDoc} */ complement(vocabulary) {
        if (vocabulary.isNil) // nothing in common with null set
        return $4a7184b7a0008122$var$IntervalSet.EMPTY_SET;
        let vocabularyIS;
        if (vocabulary instanceof $4a7184b7a0008122$var$IntervalSet) vocabularyIS = vocabulary;
        else {
            vocabularyIS = new $4a7184b7a0008122$var$IntervalSet();
            vocabularyIS.addAll(vocabulary);
        }
        return vocabularyIS.subtract(this);
    }
    subtract(a) {
        if (a == null || a.isNil) return new $4a7184b7a0008122$var$IntervalSet(this._intervals);
        if (a instanceof $4a7184b7a0008122$var$IntervalSet) return $4a7184b7a0008122$var$IntervalSet.subtract(this, a);
        let other = new $4a7184b7a0008122$var$IntervalSet();
        other.addAll(a);
        return $4a7184b7a0008122$var$IntervalSet.subtract(this, other);
    }
    /**
     * Compute the set difference between two interval sets. The specific
     * operation is `left - right`.
     */ static subtract(left, right) {
        if (left.isNil) return new $4a7184b7a0008122$var$IntervalSet();
        let result = new $4a7184b7a0008122$var$IntervalSet(left._intervals);
        if (right.isNil) // right set has no elements; just return the copy of the current set
        return result;
        let resultI = 0;
        let rightI = 0;
        while(resultI < result._intervals.length && rightI < right._intervals.length){
            let resultInterval = result._intervals[resultI];
            let rightInterval = right._intervals[rightI];
            // operation: (resultInterval - rightInterval) and update indexes
            if (rightInterval.b < resultInterval.a) {
                rightI++;
                continue;
            }
            if (rightInterval.a > resultInterval.b) {
                resultI++;
                continue;
            }
            let beforeCurrent;
            let afterCurrent;
            if (rightInterval.a > resultInterval.a) beforeCurrent = new $4Q2DM.Interval(resultInterval.a, rightInterval.a - 1);
            if (rightInterval.b < resultInterval.b) afterCurrent = new $4Q2DM.Interval(rightInterval.b + 1, resultInterval.b);
            if (beforeCurrent) {
                if (afterCurrent) {
                    // split the current interval into two
                    result._intervals[resultI] = beforeCurrent;
                    result._intervals.splice(resultI + 1, 0, afterCurrent);
                    resultI++;
                    rightI++;
                    continue;
                } else {
                    // replace the current interval
                    result._intervals[resultI] = beforeCurrent;
                    resultI++;
                    continue;
                }
            } else if (afterCurrent) {
                // replace the current interval
                result._intervals[resultI] = afterCurrent;
                rightI++;
                continue;
            } else {
                // remove the current interval (thus no need to increment resultI)
                result._intervals.splice(resultI, 1);
                continue;
            }
        }
        // If rightI reached right.intervals.size, no more intervals to subtract from result.
        // If resultI reached result.intervals.size, we would be subtracting from an empty set.
        // Either way, we are done.
        return result;
    }
    or(a) {
        let o = new $4a7184b7a0008122$var$IntervalSet();
        o.addAll(this);
        o.addAll(a);
        return o;
    }
    /** {@inheritDoc} */ and(other) {
        if (other.isNil) // nothing in common with null set
        return new $4a7184b7a0008122$var$IntervalSet();
        let myIntervals = this._intervals;
        let theirIntervals = other._intervals;
        let intersection;
        let mySize = myIntervals.length;
        let theirSize = theirIntervals.length;
        let i = 0;
        let j = 0;
        // iterate down both interval lists looking for nondisjoint intervals
        while(i < mySize && j < theirSize){
            let mine = myIntervals[i];
            let theirs = theirIntervals[j];
            //System.out.println("mine="+mine+" and theirs="+theirs);
            if (mine.startsBeforeDisjoint(theirs)) // move this iterator looking for interval that might overlap
            i++;
            else if (theirs.startsBeforeDisjoint(mine)) // move other iterator looking for interval that might overlap
            j++;
            else if (mine.properlyContains(theirs)) {
                // overlap, add intersection, get next theirs
                if (!intersection) intersection = new $4a7184b7a0008122$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                j++;
            } else if (theirs.properlyContains(mine)) {
                // overlap, add intersection, get next mine
                if (!intersection) intersection = new $4a7184b7a0008122$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                i++;
            } else if (!mine.disjoint(theirs)) {
                // overlap, add intersection
                if (!intersection) intersection = new $4a7184b7a0008122$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                // Move the iterator of lower range [a..b], but not
                // the upper range as it may contain elements that will collide
                // with the next iterator. So, if mine=[0..115] and
                // theirs=[115..200], then intersection is 115 and move mine
                // but not theirs as theirs may collide with the next range
                // in thisIter.
                // move both iterators to next ranges
                if (mine.startsAfterNonDisjoint(theirs)) j++;
                else if (theirs.startsAfterNonDisjoint(mine)) i++;
            }
        }
        if (!intersection) return new $4a7184b7a0008122$var$IntervalSet();
        return intersection;
    }
    /** {@inheritDoc} */ contains(el) {
        let n = this._intervals.length;
        let l = 0;
        let r = n - 1;
        // Binary search for the element in the (sorted, disjoint) array of intervals.
        while(l <= r){
            let m = l + r >> 1;
            let I = this._intervals[m];
            let a = I.a;
            let b = I.b;
            if (b < el) l = m + 1;
            else if (a > el) r = m - 1;
            else // el >= a && el <= b
            return true;
        }
        return false;
    }
    /** {@inheritDoc} */ get isNil() {
        return this._intervals == null || this._intervals.length === 0;
    }
    /**
     * Returns the maximum value contained in the set if not isNil.
     *
     * @return the maximum value contained in the set.
     * @throws RangeError if set is empty
     */ get maxElement() {
        if (this.isNil) throw new RangeError("set is empty");
        let last = this._intervals[this._intervals.length - 1];
        return last.b;
    }
    /**
     * Returns the minimum value contained in the set if not isNil.
     *
     * @return the minimum value contained in the set.
     * @throws RangeError if set is empty
     */ get minElement() {
        if (this.isNil) throw new RangeError("set is empty");
        return this._intervals[0].a;
    }
    /** Return a list of Interval objects. */ get intervals() {
        return this._intervals;
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        for (let I of this._intervals){
            hash = $i99P2.MurmurHash.update(hash, I.a);
            hash = $i99P2.MurmurHash.update(hash, I.b);
        }
        hash = $i99P2.MurmurHash.finish(hash, this._intervals.length * 2);
        return hash;
    }
    /** Are two IntervalSets equal?  Because all intervals are sorted
     *  and disjoint, equals is a simple linear walk over both lists
     *  to make sure they are the same.  Interval.equals() is used
     *  by the List.equals() method to check the ranges.
     */ equals(o) {
        if (o == null || !(o instanceof $4a7184b7a0008122$var$IntervalSet)) return false;
        return $crbOk.ArrayEqualityComparator.INSTANCE.equals(this._intervals, o._intervals);
    }
    toString(elemAreChar = false) {
        let buf = "";
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) {
                if (a === $2G93d.Token.EOF) buf += "<EOF>";
                else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'";
                else buf += a;
            } else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'..'" + String.fromCodePoint(b) + "'";
            else buf += a + ".." + b;
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    toStringVocabulary(vocabulary) {
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        let buf = "";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) buf += this.elementName(vocabulary, a);
            else for(let i = a; i <= b; i++){
                if (i > a) buf += ", ";
                buf += this.elementName(vocabulary, i);
            }
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    elementName(vocabulary, a) {
        if (a === $2G93d.Token.EOF) return "<EOF>";
        else if (a === $2G93d.Token.EPSILON) return "<EPSILON>";
        else return vocabulary.getDisplayName(a);
    }
    get size() {
        let n = 0;
        let numIntervals = this._intervals.length;
        if (numIntervals === 1) {
            let firstInterval = this._intervals[0];
            return firstInterval.b - firstInterval.a + 1;
        }
        for(let i = 0; i < numIntervals; i++){
            let I = this._intervals[i];
            n += I.b - I.a + 1;
        }
        return n;
    }
    toIntegerList() {
        let values = new $eOyS9.IntegerList(this.size);
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.add(v);
        }
        return values;
    }
    toSet() {
        let s = new Set();
        for (let I of this._intervals){
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)s.add(v);
        }
        return s;
    }
    toArray() {
        let values = new Array();
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.push(v);
        }
        return values;
    }
    remove(el) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            if (el < a) break; // list is sorted and el is before this interval; not here
            // if whole interval x..x, rm
            if (el === a && el === b) {
                this._intervals.splice(i, 1);
                break;
            }
            // if on left edge x..b, adjust left
            if (el === a) {
                this._intervals[i] = $4Q2DM.Interval.of(I.a + 1, I.b);
                break;
            }
            // if on right edge a..x, adjust right
            if (el === b) {
                this._intervals[i] = $4Q2DM.Interval.of(I.a, I.b - 1);
                break;
            }
            // if in middle a..x..b, split interval
            if (el > a && el < b) {
                let oldb = I.b;
                this._intervals[i] = $4Q2DM.Interval.of(I.a, el - 1); // [a..x-1]
                this.add(el + 1, oldb); // add [x+1..b]
            }
        }
    }
    get isReadonly() {
        return this.readonly;
    }
    setReadonly(readonly) {
        if (this.readonly && !readonly) throw new Error("can't alter readonly IntervalSet");
        this.readonly = readonly;
    }
}
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "addAll", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "complement", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "subtract", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "or", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "and", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "contains", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "isNil", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "hashCode", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "equals", null);
$4a7184b7a0008122$var$__decorate([
    $4a7184b7a0008122$var$__param(0, $esDFm.NotNull)
], $4a7184b7a0008122$var$IntervalSet.prototype, "toStringVocabulary", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.NotNull,
    $4a7184b7a0008122$var$__param(0, $esDFm.NotNull)
], $4a7184b7a0008122$var$IntervalSet.prototype, "elementName", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "size", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.Override
], $4a7184b7a0008122$var$IntervalSet.prototype, "remove", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.NotNull
], $4a7184b7a0008122$var$IntervalSet, "of", null);
$4a7184b7a0008122$var$__decorate([
    $esDFm.NotNull
], $4a7184b7a0008122$var$IntervalSet, "subtract", null);
module.exports.IntervalSet = $4a7184b7a0008122$var$IntervalSet;

});
parcelRegister("eOyS9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ac90c92821ee5cb0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerList = void 0;

var $yEtb9 = parcelRequire("yEtb9");

var $esDFm = parcelRequire("esDFm");
const $ac90c92821ee5cb0$var$EMPTY_DATA = new Int32Array(0);
const $ac90c92821ee5cb0$var$INITIAL_SIZE = 4;
const $ac90c92821ee5cb0$var$MAX_ARRAY_SIZE = 2147483639;
/**
 *
 * @author Sam Harwell
 */ class $ac90c92821ee5cb0$var$IntegerList {
    constructor(arg){
        if (!arg) {
            this._data = $ac90c92821ee5cb0$var$EMPTY_DATA;
            this._size = 0;
        } else if (arg instanceof $ac90c92821ee5cb0$var$IntegerList) {
            this._data = arg._data.slice(0);
            this._size = arg._size;
        } else if (typeof arg === "number") {
            if (arg === 0) {
                this._data = $ac90c92821ee5cb0$var$EMPTY_DATA;
                this._size = 0;
            } else {
                this._data = new Int32Array(arg);
                this._size = 0;
            }
        } else {
            // arg is Iterable<number>
            this._data = $ac90c92821ee5cb0$var$EMPTY_DATA;
            this._size = 0;
            for (let value of arg)this.add(value);
        }
    }
    add(value) {
        if (this._data.length === this._size) this.ensureCapacity(this._size + 1);
        this._data[this._size] = value;
        this._size++;
    }
    addAll(list) {
        if (Array.isArray(list)) {
            this.ensureCapacity(this._size + list.length);
            this._data.subarray(this._size, this._size + list.length).set(list);
            this._size += list.length;
        } else if (list instanceof $ac90c92821ee5cb0$var$IntegerList) {
            this.ensureCapacity(this._size + list._size);
            this._data.subarray(this._size, this._size + list.size).set(list._data);
            this._size += list._size;
        } else {
            // list is JavaCollection<number>
            this.ensureCapacity(this._size + list.size);
            let current = 0;
            for (let xi of list){
                this._data[this._size + current] = xi;
                current++;
            }
            this._size += list.size;
        }
    }
    get(index) {
        if (index < 0 || index >= this._size) throw RangeError();
        return this._data[index];
    }
    contains(value) {
        for(let i = 0; i < this._size; i++){
            if (this._data[i] === value) return true;
        }
        return false;
    }
    set(index, value) {
        if (index < 0 || index >= this._size) throw RangeError();
        let previous = this._data[index];
        this._data[index] = value;
        return previous;
    }
    removeAt(index) {
        let value = this.get(index);
        this._data.copyWithin(index, index + 1, this._size);
        this._data[this._size - 1] = 0;
        this._size--;
        return value;
    }
    removeRange(fromIndex, toIndex) {
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw RangeError();
        if (fromIndex > toIndex) throw RangeError();
        this._data.copyWithin(toIndex, fromIndex, this._size);
        this._data.fill(0, this._size - (toIndex - fromIndex), this._size);
        this._size -= toIndex - fromIndex;
    }
    get isEmpty() {
        return this._size === 0;
    }
    get size() {
        return this._size;
    }
    trimToSize() {
        if (this._data.length === this._size) return;
        this._data = this._data.slice(0, this._size);
    }
    clear() {
        this._data.fill(0, 0, this._size);
        this._size = 0;
    }
    toArray() {
        if (this._size === 0) return [];
        return Array.from(this._data.subarray(0, this._size));
    }
    sort() {
        this._data.subarray(0, this._size).sort();
    }
    /**
     * Compares the specified object with this list for equality.  Returns
     * `true` if and only if the specified object is also an {@link IntegerList},
     * both lists have the same size, and all corresponding pairs of elements in
     * the two lists are equal.  In other words, two lists are defined to be
     * equal if they contain the same elements in the same order.
     *
     * This implementation first checks if the specified object is this
     * list. If so, it returns `true`; if not, it checks if the
     * specified object is an {@link IntegerList}. If not, it returns `false`;
     * if so, it checks the size of both lists. If the lists are not the same size,
     * it returns `false`; otherwise it iterates over both lists, comparing
     * corresponding pairs of elements.  If any comparison returns `false`,
     * this method returns `false`.
     *
     * @param o the object to be compared for equality with this list
     * @returns `true` if the specified object is equal to this list
     */ equals(o) {
        if (o === this) return true;
        if (!(o instanceof $ac90c92821ee5cb0$var$IntegerList)) return false;
        if (this._size !== o._size) return false;
        for(let i = 0; i < this._size; i++){
            if (this._data[i] !== o._data[i]) return false;
        }
        return true;
    }
    /**
     * Returns the hash code value for this list.
     *
     * This implementation uses exactly the code that is used to define the
     * list hash function in the documentation for the {@link List#hashCode}
     * method.
     *
     * @returns the hash code value for this list
     */ hashCode() {
        let hashCode = 1;
        for(let i = 0; i < this._size; i++)hashCode = 31 * hashCode + this._data[i];
        return hashCode;
    }
    /**
     * Returns a string representation of this list.
     */ toString() {
        return this._data.toString();
    }
    binarySearch(key, fromIndex, toIndex) {
        if (fromIndex === undefined) fromIndex = 0;
        if (toIndex === undefined) toIndex = this._size;
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw new RangeError();
        if (fromIndex > toIndex) throw new RangeError();
        return $yEtb9.Arrays.binarySearch(this._data, key, fromIndex, toIndex);
    }
    ensureCapacity(capacity) {
        if (capacity < 0 || capacity > $ac90c92821ee5cb0$var$MAX_ARRAY_SIZE) throw new RangeError();
        let newLength;
        if (this._data.length === 0) newLength = $ac90c92821ee5cb0$var$INITIAL_SIZE;
        else newLength = this._data.length;
        while(newLength < capacity){
            newLength = newLength * 2;
            if (newLength < 0 || newLength > $ac90c92821ee5cb0$var$MAX_ARRAY_SIZE) newLength = $ac90c92821ee5cb0$var$MAX_ARRAY_SIZE;
        }
        let tmp = new Int32Array(newLength);
        tmp.set(this._data);
        this._data = tmp;
    }
    /** Convert the list to a UTF-16 encoded char array. If all values are less
     *  than the 0xFFFF 16-bit code point limit then this is just a char array
     *  of 16-bit char as usual. For values in the supplementary range, encode
     * them as two UTF-16 code units.
     */ toCharArray() {
        // Optimize for the common case (all data values are < 0xFFFF) to avoid an extra scan
        let resultArray = new Uint16Array(this._size);
        let resultIdx = 0;
        let calculatedPreciseResultSize = false;
        for(let i = 0; i < this._size; i++){
            let codePoint = this._data[i];
            if (codePoint >= 0 && codePoint < 0x10000) {
                resultArray[resultIdx] = codePoint;
                resultIdx++;
                continue;
            }
            // Calculate the precise result size if we encounter a code point > 0xFFFF
            if (!calculatedPreciseResultSize) {
                let newResultArray = new Uint16Array(this.charArraySize());
                newResultArray.set(resultArray, 0);
                resultArray = newResultArray;
                calculatedPreciseResultSize = true;
            }
            // This will throw RangeError if the code point is not a valid Unicode code point
            let pair = String.fromCodePoint(codePoint);
            resultArray[resultIdx] = pair.charCodeAt(0);
            resultArray[resultIdx + 1] = pair.charCodeAt(1);
            resultIdx += 2;
        }
        return resultArray;
    }
    charArraySize() {
        let result = 0;
        for(let i = 0; i < this._size; i++)result += this._data[i] >= 0x10000 ? 2 : 1;
        return result;
    }
}
$ac90c92821ee5cb0$var$__decorate([
    $esDFm.NotNull
], $ac90c92821ee5cb0$var$IntegerList.prototype, "_data", void 0);
$ac90c92821ee5cb0$var$__decorate([
    $esDFm.Override
], $ac90c92821ee5cb0$var$IntegerList.prototype, "equals", null);
$ac90c92821ee5cb0$var$__decorate([
    $esDFm.Override
], $ac90c92821ee5cb0$var$IntegerList.prototype, "hashCode", null);
$ac90c92821ee5cb0$var$__decorate([
    $esDFm.Override
], $ac90c92821ee5cb0$var$IntegerList.prototype, "toString", null);
module.exports.IntegerList = $ac90c92821ee5cb0$var$IntegerList;

});
parcelRegister("yEtb9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Arrays = void 0;
var $06829183f5129d07$var$Arrays;
(function(Arrays) {
    /**
     * Searches the specified array of numbers for the specified value using the binary search algorithm. The array must
     * be sorted prior to making this call. If it is not sorted, the results are unspecified. If the array contains
     * multiple elements with the specified value, there is no guarantee which one will be found.
     *
     * @returns index of the search key, if it is contained in the array; otherwise, (-(insertion point) - 1). The
     * insertion point is defined as the point at which the key would be inserted into the array: the index of the first
     * element greater than the key, or array.length if all elements in the array are less than the specified key. Note
     * that this guarantees that the return value will be >= 0 if and only if the key is found.
     */ function binarySearch(array, key, fromIndex, toIndex) {
        return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
    }
    Arrays.binarySearch = binarySearch;
    function binarySearch0(array, fromIndex, toIndex, key) {
        let low = fromIndex;
        let high = toIndex - 1;
        while(low <= high){
            let mid = low + high >>> 1;
            let midVal = array[mid];
            if (midVal < key) low = mid + 1;
            else if (midVal > key) high = mid - 1;
            else // key found
            return mid;
        }
        // key not found.
        return -(low + 1);
    }
    function toString(array) {
        let result = "[";
        let first = true;
        for (let element of array){
            if (first) first = false;
            else result += ", ";
            if (element === null) result += "null";
            else if (element === undefined) result += "undefined";
            else result += element;
        }
        result += "]";
        return result;
    }
    Arrays.toString = toString;
})($06829183f5129d07$var$Arrays = module.exports.Arrays || (module.exports.Arrays = {}));

});


parcelRegister("4Q2DM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $385e111c1c7cf931$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Interval = void 0;

var $esDFm = parcelRequire("esDFm");
const $385e111c1c7cf931$var$INTERVAL_POOL_MAX_VALUE = 1000;
/** An immutable inclusive interval a..b */ class $385e111c1c7cf931$var$Interval {
    /**
     * @param a The start of the interval
     * @param b The end of the interval (inclusive)
     */ constructor(a, b){
        this.a = a;
        this.b = b;
    }
    static get INVALID() {
        return $385e111c1c7cf931$var$Interval._INVALID;
    }
    /** Interval objects are used readonly so share all with the
     *  same single value a==b up to some max size.  Use an array as a perfect hash.
     *  Return shared object for 0..INTERVAL_POOL_MAX_VALUE or a new
     *  Interval object with a..a in it.  On Java.g4, 218623 IntervalSets
     *  have a..a (set with 1 element).
     */ static of(a, b) {
        // cache just a..a
        if (a !== b || a < 0 || a > $385e111c1c7cf931$var$INTERVAL_POOL_MAX_VALUE) return new $385e111c1c7cf931$var$Interval(a, b);
        if ($385e111c1c7cf931$var$Interval.cache[a] == null) $385e111c1c7cf931$var$Interval.cache[a] = new $385e111c1c7cf931$var$Interval(a, a);
        return $385e111c1c7cf931$var$Interval.cache[a];
    }
    /** return number of elements between a and b inclusively. x..x is length 1.
     *  if b &lt; a, then length is 0.  9..10 has length 2.
     */ get length() {
        if (this.b < this.a) return 0;
        return this.b - this.a + 1;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof $385e111c1c7cf931$var$Interval)) return false;
        return this.a === o.a && this.b === o.b;
    }
    hashCode() {
        let hash = 23;
        hash = hash * 31 + this.a;
        hash = hash * 31 + this.b;
        return hash;
    }
    /** Does this start completely before other? Disjoint */ startsBeforeDisjoint(other) {
        return this.a < other.a && this.b < other.a;
    }
    /** Does this start at or before other? Nondisjoint */ startsBeforeNonDisjoint(other) {
        return this.a <= other.a && this.b >= other.a;
    }
    /** Does this.a start after other.b? May or may not be disjoint */ startsAfter(other) {
        return this.a > other.a;
    }
    /** Does this start completely after other? Disjoint */ startsAfterDisjoint(other) {
        return this.a > other.b;
    }
    /** Does this start after other? NonDisjoint */ startsAfterNonDisjoint(other) {
        return this.a > other.a && this.a <= other.b; // this.b>=other.b implied
    }
    /** Are both ranges disjoint? I.e., no overlap? */ disjoint(other) {
        return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
    }
    /** Are two intervals adjacent such as 0..41 and 42..42? */ adjacent(other) {
        return this.a === other.b + 1 || this.b === other.a - 1;
    }
    properlyContains(other) {
        return other.a >= this.a && other.b <= this.b;
    }
    /** Return the interval computed from combining this and other */ union(other) {
        return $385e111c1c7cf931$var$Interval.of(Math.min(this.a, other.a), Math.max(this.b, other.b));
    }
    /** Return the interval in common between this and o */ intersection(other) {
        return $385e111c1c7cf931$var$Interval.of(Math.max(this.a, other.a), Math.min(this.b, other.b));
    }
    /** Return the interval with elements from `this` not in `other`;
     *  `other` must not be totally enclosed (properly contained)
     *  within `this`, which would result in two disjoint intervals
     *  instead of the single one returned by this method.
     */ differenceNotProperlyContained(other) {
        let diff;
        if (other.startsBeforeNonDisjoint(this)) // other.a to left of this.a (or same)
        diff = $385e111c1c7cf931$var$Interval.of(Math.max(this.a, other.b + 1), this.b);
        else if (other.startsAfterNonDisjoint(this)) // other.a to right of this.a
        diff = $385e111c1c7cf931$var$Interval.of(this.a, other.a - 1);
        return diff;
    }
    toString() {
        return this.a + ".." + this.b;
    }
}
$385e111c1c7cf931$var$Interval._INVALID = new $385e111c1c7cf931$var$Interval(-1, -2);
$385e111c1c7cf931$var$Interval.cache = new Array($385e111c1c7cf931$var$INTERVAL_POOL_MAX_VALUE + 1);
$385e111c1c7cf931$var$__decorate([
    $esDFm.Override
], $385e111c1c7cf931$var$Interval.prototype, "equals", null);
$385e111c1c7cf931$var$__decorate([
    $esDFm.Override
], $385e111c1c7cf931$var$Interval.prototype, "hashCode", null);
$385e111c1c7cf931$var$__decorate([
    $esDFm.Override
], $385e111c1c7cf931$var$Interval.prototype, "toString", null);
module.exports.Interval = $385e111c1c7cf931$var$Interval;

});

parcelRegister("gTQRB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c4daca03ecd98d11$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Lexer = void 0;

var $arOt9 = parcelRequire("arOt9");

var $9AKkH = parcelRequire("9AKkH");

var $4Q2DM = parcelRequire("4Q2DM");

var $d4sFB = parcelRequire("d4sFB");

var $kkkg9 = parcelRequire("kkkg9");

var $6Npyx = parcelRequire("6Npyx");

var $esDFm = parcelRequire("esDFm");

var $24a4y = parcelRequire("24a4y");

var $2G93d = parcelRequire("2G93d");
/** A lexer is recognizer that draws input symbols from a character stream.
 *  lexer grammars result in a subclass of this object. A Lexer object
 *  uses simplified match() and error recovery mechanisms in the interest
 *  of speed.
 */ class $c4daca03ecd98d11$var$Lexer extends $24a4y.Recognizer {
    constructor(input){
        super();
        /** How to create token objects */ this._factory = $arOt9.CommonTokenFactory.DEFAULT;
        /** What character index in the stream did the current token start at?
         *  Needed, for example, to get the text for current token.  Set at
         *  the start of nextToken.
         */ this._tokenStartCharIndex = -1;
        /** The line on which the first character of the token resides */ this._tokenStartLine = 0;
        /** The character position of first character within the line */ this._tokenStartCharPositionInLine = 0;
        /** Once we see EOF on char stream, next token will be EOF.
         *  If you have DONE : EOF ; then you see DONE EOF.
         */ this._hitEOF = false;
        /** The channel number for the current token */ this._channel = 0;
        /** The token type for the current token */ this._type = 0;
        this._modeStack = new $9AKkH.IntegerStack();
        this._mode = $c4daca03ecd98d11$var$Lexer.DEFAULT_MODE;
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: input
        };
    }
    static get DEFAULT_TOKEN_CHANNEL() {
        return $2G93d.Token.DEFAULT_CHANNEL;
    }
    static get HIDDEN() {
        return $2G93d.Token.HIDDEN_CHANNEL;
    }
    reset(resetInput) {
        // wack Lexer state variables
        if (resetInput === undefined || resetInput) this._input.seek(0); // rewind the input
        this._token = undefined;
        this._type = $2G93d.Token.INVALID_TYPE;
        this._channel = $2G93d.Token.DEFAULT_CHANNEL;
        this._tokenStartCharIndex = -1;
        this._tokenStartCharPositionInLine = -1;
        this._tokenStartLine = -1;
        this._text = undefined;
        this._hitEOF = false;
        this._mode = $c4daca03ecd98d11$var$Lexer.DEFAULT_MODE;
        this._modeStack.clear();
        this.interpreter.reset();
    }
    /** Return a token from this source; i.e., match a token on the char
     *  stream.
     */ nextToken() {
        if (this._input == null) throw new Error("nextToken requires a non-null input stream.");
        // Mark start location in char stream so unbuffered streams are
        // guaranteed at least have text of current token
        let tokenStartMarker = this._input.mark();
        try {
            outer: while(true){
                if (this._hitEOF) return this.emitEOF();
                this._token = undefined;
                this._channel = $2G93d.Token.DEFAULT_CHANNEL;
                this._tokenStartCharIndex = this._input.index;
                this._tokenStartCharPositionInLine = this.interpreter.charPositionInLine;
                this._tokenStartLine = this.interpreter.line;
                this._text = undefined;
                do {
                    this._type = $2G93d.Token.INVALID_TYPE;
                    //				System.out.println("nextToken line "+tokenStartLine+" at "+((char)input.LA(1))+
                    //								   " in mode "+mode+
                    //								   " at index "+input.index);
                    let ttype;
                    try {
                        ttype = this.interpreter.match(this._input, this._mode);
                    } catch (e) {
                        if (e instanceof $6Npyx.LexerNoViableAltException) {
                            this.notifyListeners(e); // report error
                            this.recover(e);
                            ttype = $c4daca03ecd98d11$var$Lexer.SKIP;
                        } else throw e;
                    }
                    if (this._input.LA(1) === $d4sFB.IntStream.EOF) this._hitEOF = true;
                    if (this._type === $2G93d.Token.INVALID_TYPE) this._type = ttype;
                    if (this._type === $c4daca03ecd98d11$var$Lexer.SKIP) continue outer;
                }while (this._type === $c4daca03ecd98d11$var$Lexer.MORE);
                if (this._token == null) return this.emit();
                return this._token;
            }
        } finally{
            // make sure we release marker after match or
            // unbuffered char stream will keep buffering
            this._input.release(tokenStartMarker);
        }
    }
    /** Instruct the lexer to skip creating a token for current lexer rule
     *  and look for another token.  nextToken() knows to keep looking when
     *  a lexer rule finishes with token set to SKIP_TOKEN.  Recall that
     *  if token==undefined at end of any token rule, it creates one for you
     *  and emits it.
     */ skip() {
        this._type = $c4daca03ecd98d11$var$Lexer.SKIP;
    }
    more() {
        this._type = $c4daca03ecd98d11$var$Lexer.MORE;
    }
    mode(m) {
        this._mode = m;
    }
    pushMode(m) {
        if ($kkkg9.LexerATNSimulator.debug) console.log("pushMode " + m);
        this._modeStack.push(this._mode);
        this.mode(m);
    }
    popMode() {
        if (this._modeStack.isEmpty) throw new Error("EmptyStackException");
        if ($kkkg9.LexerATNSimulator.debug) console.log("popMode back to " + this._modeStack.peek());
        this.mode(this._modeStack.pop());
        return this._mode;
    }
    get tokenFactory() {
        return this._factory;
    }
    // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the char stream and reset the lexer */ set inputStream(input) {
        this.reset(false);
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: this._input
        };
    }
    get sourceName() {
        return this._input.sourceName;
    }
    emit(token) {
        if (!token) token = this._factory.create(this._tokenFactorySourcePair, this._type, this._text, this._channel, this._tokenStartCharIndex, this.charIndex - 1, this._tokenStartLine, this._tokenStartCharPositionInLine);
        this._token = token;
        return token;
    }
    emitEOF() {
        let cpos = this.charPositionInLine;
        let line = this.line;
        let eof = this._factory.create(this._tokenFactorySourcePair, $2G93d.Token.EOF, undefined, $2G93d.Token.DEFAULT_CHANNEL, this._input.index, this._input.index - 1, line, cpos);
        this.emit(eof);
        return eof;
    }
    get line() {
        return this.interpreter.line;
    }
    set line(line) {
        this.interpreter.line = line;
    }
    get charPositionInLine() {
        return this.interpreter.charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this.interpreter.charPositionInLine = charPositionInLine;
    }
    /** What is the index of the current character of lookahead? */ get charIndex() {
        return this._input.index;
    }
    /** Return the text matched so far for the current token or any
     *  text override.
     */ get text() {
        if (this._text != null) return this._text;
        return this.interpreter.getText(this._input);
    }
    /** Set the complete text of this token; it wipes any previous
     *  changes to the text.
     */ set text(text) {
        this._text = text;
    }
    /** Override if emitting multiple tokens. */ get token() {
        return this._token;
    }
    set token(_token) {
        this._token = _token;
    }
    set type(ttype) {
        this._type = ttype;
    }
    get type() {
        return this._type;
    }
    set channel(channel) {
        this._channel = channel;
    }
    get channel() {
        return this._channel;
    }
    /** Return a list of all Token objects in input char stream.
     *  Forces load of all tokens. Does not include EOF token.
     */ getAllTokens() {
        let tokens = [];
        let t = this.nextToken();
        while(t.type !== $2G93d.Token.EOF){
            tokens.push(t);
            t = this.nextToken();
        }
        return tokens;
    }
    notifyListeners(e) {
        let text = this._input.getText($4Q2DM.Interval.of(this._tokenStartCharIndex, this._input.index));
        let msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, undefined, this._tokenStartLine, this._tokenStartCharPositionInLine, msg, e);
    }
    getErrorDisplay(s) {
        if (typeof s === "number") {
            switch(s){
                case $2G93d.Token.EOF:
                    return "<EOF>";
                case 0x0a:
                    return "\\n";
                case 0x09:
                    return "\\t";
                case 0x0d:
                    return "\\r";
            }
            return String.fromCharCode(s);
        }
        return s.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
    }
    getCharErrorDisplay(c) {
        let s = this.getErrorDisplay(c);
        return "'" + s + "'";
    }
    recover(re) {
        if (re instanceof $6Npyx.LexerNoViableAltException) {
            if (this._input.LA(1) !== $d4sFB.IntStream.EOF) // skip a char and try again
            this.interpreter.consume(this._input);
        } else //System.out.println("consuming char "+(char)input.LA(1)+" during recovery");
        //re.printStackTrace();
        // TODO: Do we lose character or line position information?
        this._input.consume();
    }
}
$c4daca03ecd98d11$var$Lexer.DEFAULT_MODE = 0;
$c4daca03ecd98d11$var$Lexer.MORE = -2;
$c4daca03ecd98d11$var$Lexer.SKIP = -3;
$c4daca03ecd98d11$var$Lexer.MIN_CHAR_VALUE = 0x0000;
$c4daca03ecd98d11$var$Lexer.MAX_CHAR_VALUE = 0x10FFFF;
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "nextToken", null);
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "tokenFactory", null);
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "inputStream", null);
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "sourceName", null);
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "line", null);
$c4daca03ecd98d11$var$__decorate([
    $esDFm.Override
], $c4daca03ecd98d11$var$Lexer.prototype, "charPositionInLine", null);
module.exports.Lexer = $c4daca03ecd98d11$var$Lexer;

});
parcelRegister("arOt9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $79b3931d4343143e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenFactory = void 0;

var $8Mk1Z = parcelRequire("8Mk1Z");

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");
/**
 * This default implementation of {@link TokenFactory} creates
 * {@link CommonToken} objects.
 */ class $79b3931d4343143e$var$CommonTokenFactory {
    /**
     * Constructs a {@link CommonTokenFactory} with the specified value for
     * {@link #copyText}.
     *
     * When `copyText` is `false`, the {@link #DEFAULT} instance
     * should be used instead of constructing a new instance.
     *
     * @param copyText The value for {@link #copyText}.
     */ constructor(copyText = false){
        this.copyText = copyText;
    }
    create(source, type, text, channel, start, stop, line, charPositionInLine) {
        let t = new $8Mk1Z.CommonToken(type, text, source, channel, start, stop);
        t.line = line;
        t.charPositionInLine = charPositionInLine;
        if (text == null && this.copyText && source.stream != null) t.text = source.stream.getText($4Q2DM.Interval.of(start, stop));
        return t;
    }
    createSimple(type, text) {
        return new $8Mk1Z.CommonToken(type, text);
    }
}
$79b3931d4343143e$var$__decorate([
    $esDFm.Override
], $79b3931d4343143e$var$CommonTokenFactory.prototype, "create", null);
$79b3931d4343143e$var$__decorate([
    $esDFm.Override
], $79b3931d4343143e$var$CommonTokenFactory.prototype, "createSimple", null);
module.exports.CommonTokenFactory = $79b3931d4343143e$var$CommonTokenFactory;
(function(CommonTokenFactory) {
    /**
     * The default {@link CommonTokenFactory} instance.
     *
     * This token factory does not explicitly copy token text when constructing
     * tokens.
     */ CommonTokenFactory.DEFAULT = new CommonTokenFactory();
})($79b3931d4343143e$var$CommonTokenFactory = module.exports.CommonTokenFactory || (module.exports.CommonTokenFactory = {}));

});
parcelRegister("8Mk1Z", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6642582fa895ffd2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6642582fa895ffd2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonToken = void 0;

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
let $6642582fa895ffd2$var$CommonToken = class CommonToken {
    constructor(type, text, source = CommonToken.EMPTY_SOURCE, channel = $2G93d.Token.DEFAULT_CHANNEL, start = 0, stop = 0){
        /**
         * This is the backing field for {@link #getLine} and {@link #setLine}.
         */ this._line = 0;
        /**
         * This is the backing field for {@link #getCharPositionInLine} and
         * {@link #setCharPositionInLine}.
         */ this._charPositionInLine = -1; // set to invalid position
        /**
         * This is the backing field for {@link #getChannel} and
         * {@link #setChannel}.
         */ this._channel = $2G93d.Token.DEFAULT_CHANNEL;
        /**
         * This is the backing field for `tokenIndex`.
         */ this.index = -1;
        this._text = text;
        this._type = type;
        this.source = source;
        this._channel = channel;
        this.start = start;
        this.stop = stop;
        if (source.source != null) {
            this._line = source.source.line;
            this._charPositionInLine = source.source.charPositionInLine;
        }
    }
    /**
     * Constructs a new {@link CommonToken} as a copy of another {@link Token}.
     *
     * If `oldToken` is also a {@link CommonToken} instance, the newly
     * constructed token will share a reference to the {@link #text} field and
     * the {@link Tuple2} stored in {@link #source}. Otherwise, {@link #text} will
     * be assigned the result of calling {@link #getText}, and {@link #source}
     * will be constructed from the result of {@link Token#getTokenSource} and
     * {@link Token#getInputStream}.
     *
     * @param oldToken The token to copy.
     */ static fromToken(oldToken) {
        let result = new CommonToken(oldToken.type, undefined, CommonToken.EMPTY_SOURCE, oldToken.channel, oldToken.startIndex, oldToken.stopIndex);
        result._line = oldToken.line;
        result.index = oldToken.tokenIndex;
        result._charPositionInLine = oldToken.charPositionInLine;
        if (oldToken instanceof CommonToken) {
            result._text = oldToken._text;
            result.source = oldToken.source;
        } else {
            result._text = oldToken.text;
            result.source = {
                source: oldToken.tokenSource,
                stream: oldToken.inputStream
            };
        }
        return result;
    }
    get type() {
        return this._type;
    }
    // @Override
    set type(type) {
        this._type = type;
    }
    get line() {
        return this._line;
    }
    // @Override
    set line(line) {
        this._line = line;
    }
    get text() {
        if (this._text != null) return this._text;
        let input = this.inputStream;
        if (input == null) return undefined;
        let n = input.size;
        if (this.start < n && this.stop < n) return input.getText($4Q2DM.Interval.of(this.start, this.stop));
        else return "<EOF>";
    }
    /**
     * Explicitly set the text for this token. If {code text} is not
     * `undefined`, then {@link #getText} will return this value rather than
     * extracting the text from the input.
     *
     * @param text The explicit text of the token, or `undefined` if the text
     * should be obtained from the input along with the start and stop indexes
     * of the token.
     */ // @Override
    set text(text) {
        this._text = text;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    // @Override
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    get channel() {
        return this._channel;
    }
    // @Override
    set channel(channel) {
        this._channel = channel;
    }
    get startIndex() {
        return this.start;
    }
    set startIndex(start) {
        this.start = start;
    }
    get stopIndex() {
        return this.stop;
    }
    set stopIndex(stop) {
        this.stop = stop;
    }
    get tokenIndex() {
        return this.index;
    }
    // @Override
    set tokenIndex(index) {
        this.index = index;
    }
    get tokenSource() {
        return this.source.source;
    }
    get inputStream() {
        return this.source.stream;
    }
    toString(recognizer) {
        let channelStr = "";
        if (this._channel > 0) channelStr = ",channel=" + this._channel;
        let txt = this.text;
        if (txt != null) {
            txt = txt.replace(/\n/g, "\\n");
            txt = txt.replace(/\r/g, "\\r");
            txt = txt.replace(/\t/g, "\\t");
        } else txt = "<no text>";
        let typeString = String(this._type);
        if (recognizer) typeString = recognizer.vocabulary.getDisplayName(this._type);
        return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + txt + "',<" + typeString + ">" + channelStr + "," + this._line + ":" + this.charPositionInLine + "]";
    }
};
/**
 * An empty {@link Tuple2} which is used as the default value of
 * {@link #source} for tokens that do not have a source.
 */ $6642582fa895ffd2$var$CommonToken.EMPTY_SOURCE = {
    source: undefined,
    stream: undefined
};
$6642582fa895ffd2$var$__decorate([
    $esDFm.NotNull
], $6642582fa895ffd2$var$CommonToken.prototype, "source", void 0);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "type", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "line", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "text", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "charPositionInLine", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "channel", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "startIndex", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "stopIndex", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "tokenIndex", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "tokenSource", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "inputStream", null);
$6642582fa895ffd2$var$__decorate([
    $esDFm.Override
], $6642582fa895ffd2$var$CommonToken.prototype, "toString", null);
$6642582fa895ffd2$var$__decorate([
    $6642582fa895ffd2$var$__param(0, $esDFm.NotNull)
], $6642582fa895ffd2$var$CommonToken, "fromToken", null);
$6642582fa895ffd2$var$CommonToken = $6642582fa895ffd2$var$__decorate([
    $6642582fa895ffd2$var$__param(2, $esDFm.NotNull)
], $6642582fa895ffd2$var$CommonToken);
module.exports.CommonToken = $6642582fa895ffd2$var$CommonToken;

});
parcelRegister("2G93d", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Token = void 0;

var $d4sFB = parcelRequire("d4sFB");
var $1f3686587010d661$var$Token;
(function(Token) {
    Token.INVALID_TYPE = 0;
    /** During lookahead operations, this "token" signifies we hit rule end ATN state
     *  and did not follow it despite needing to.
     */ Token.EPSILON = -2;
    Token.MIN_USER_TOKEN_TYPE = 1;
    Token.EOF = $d4sFB.IntStream.EOF;
    /** All tokens go to the parser (unless skip() is called in that rule)
     *  on a particular "channel".  The parser tunes to a particular channel
     *  so that whitespace etc... can go to the parser on a "hidden" channel.
     */ Token.DEFAULT_CHANNEL = 0;
    /** Anything on different channel than DEFAULT_CHANNEL is not parsed
     *  by parser.
     */ Token.HIDDEN_CHANNEL = 1;
    /**
     * This is the minimum constant value which can be assigned to a
     * user-defined token channel.
     *
     * The non-negative numbers less than {@link #MIN_USER_CHANNEL_VALUE} are
     * assigned to the predefined channels {@link #DEFAULT_CHANNEL} and
     * {@link #HIDDEN_CHANNEL}.
     *
     * @see `Token.channel`
     */ Token.MIN_USER_CHANNEL_VALUE = 2;
})($1f3686587010d661$var$Token = module.exports.Token || (module.exports.Token = {}));

});



parcelRegister("9AKkH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerStack = void 0;

var $eOyS9 = parcelRequire("eOyS9");
/**
 *
 * @author Sam Harwell
 */ class $6fbb6a9751bc0f5e$var$IntegerStack extends $eOyS9.IntegerList {
    constructor(arg){
        super(arg);
    }
    push(value) {
        this.add(value);
    }
    pop() {
        return this.removeAt(this.size - 1);
    }
    peek() {
        return this.get(this.size - 1);
    }
}
module.exports.IntegerStack = $6fbb6a9751bc0f5e$var$IntegerStack;

});

parcelRegister("kkkg9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ecc564042155c9fa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ecc564042155c9fa$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerATNSimulator = void 0;

var $dg39p = parcelRequire("dg39p");

var $lDQMG = parcelRequire("lDQMG");

var $9qlOq = parcelRequire("9qlOq");

var $6co2U = parcelRequire("6co2U");

var $lbAqv = parcelRequire("lbAqv");

var $5jw7S = parcelRequire("5jw7S");

var $4Q2DM = parcelRequire("4Q2DM");

var $d4sFB = parcelRequire("d4sFB");

var $gTQRB = parcelRequire("gTQRB");

var $khqMx = parcelRequire("khqMx");

var $6Npyx = parcelRequire("6Npyx");

var $esDFm = parcelRequire("esDFm");

var $jjTpW = parcelRequire("jjTpW");

var $haz8F = parcelRequire("haz8F");

var $U6v4o = parcelRequire("U6v4o");

var $2G93d = parcelRequire("2G93d");

var $gwEr2 = parcelRequire("gwEr2");
/** "dup" of ParserInterpreter */ let $ecc564042155c9fa$var$LexerATNSimulator = class LexerATNSimulator extends $lbAqv.ATNSimulator {
    constructor(atn, recog){
        super(atn);
        this.optimize_tail_calls = true;
        /** The current token's starting index into the character stream.
         *  Shared across DFA to ATN simulation in case the ATN fails and the
         *  DFA did not have a previous accept state. In this case, we use the
         *  ATN-generated exception object.
         */ this.startIndex = -1;
        /** line number 1..n within the input */ this._line = 1;
        /** The index of the character relative to the beginning of the line 0..n-1 */ this._charPositionInLine = 0;
        this.mode = $gTQRB.Lexer.DEFAULT_MODE;
        /** Used during DFA/ATN exec to record the most recent accept configuration info */ this.prevAccept = new LexerATNSimulator.SimState();
        this.recog = recog;
    }
    copyState(simulator) {
        this._charPositionInLine = simulator.charPositionInLine;
        this._line = simulator._line;
        this.mode = simulator.mode;
        this.startIndex = simulator.startIndex;
    }
    match(input, mode) {
        this.mode = mode;
        let mark = input.mark();
        try {
            this.startIndex = input.index;
            this.prevAccept.reset();
            let s0 = this.atn.modeToDFA[mode].s0;
            if (s0 == null) return this.matchATN(input);
            else return this.execATN(input, s0);
        } finally{
            input.release(mark);
        }
    }
    reset() {
        this.prevAccept.reset();
        this.startIndex = -1;
        this._line = 1;
        this._charPositionInLine = 0;
        this.mode = $gTQRB.Lexer.DEFAULT_MODE;
    }
    matchATN(input) {
        let startState = this.atn.modeToStartState[this.mode];
        if (LexerATNSimulator.debug) console.log(`matchATN mode ${this.mode} start: ${startState}`);
        let old_mode = this.mode;
        let s0_closure = this.computeStartState(input, startState);
        let suppressEdge = s0_closure.hasSemanticContext;
        if (suppressEdge) s0_closure.hasSemanticContext = false;
        let next = this.addDFAState(s0_closure);
        if (!suppressEdge) {
            let dfa = this.atn.modeToDFA[this.mode];
            if (!dfa.s0) dfa.s0 = next;
            else next = dfa.s0;
        }
        let predict = this.execATN(input, next);
        if (LexerATNSimulator.debug) console.log(`DFA after matchATN: ${this.atn.modeToDFA[old_mode].toLexerString()}`);
        return predict;
    }
    execATN(input, ds0) {
        // console.log("enter exec index "+input.index+" from "+ds0.configs);
        if (LexerATNSimulator.debug) console.log(`start state closure=${ds0.configs}`);
        if (ds0.isAcceptState) // allow zero-length tokens
        this.captureSimState(this.prevAccept, input, ds0);
        let t = input.LA(1);
        // @NotNull
        let s = ds0; // s is current/from DFA state
        while(true){
            if (LexerATNSimulator.debug) console.log(`execATN loop starting closure: ${s.configs}`);
            // As we move src->trg, src->trg, we keep track of the previous trg to
            // avoid looking up the DFA state again, which is expensive.
            // If the previous target was already part of the DFA, we might
            // be able to avoid doing a reach operation upon t. If s!=null,
            // it means that semantic predicates didn't prevent us from
            // creating a DFA state. Once we know s!=null, we check to see if
            // the DFA state has an edge already for t. If so, we can just reuse
            // it's configuration set; there's no point in re-computing it.
            // This is kind of like doing DFA simulation within the ATN
            // simulation because DFA simulation is really just a way to avoid
            // computing reach/closure sets. Technically, once we know that
            // we have a previously added DFA state, we could jump over to
            // the DFA simulator. But, that would mean popping back and forth
            // a lot and making things more complicated algorithmically.
            // This optimization makes a lot of sense for loops within DFA.
            // A character will take us back to an existing DFA state
            // that already has lots of edges out of it. e.g., .* in comments.
            let target = this.getExistingTargetState(s, t);
            if (target == null) target = this.computeTargetState(input, s, t);
            if (target === $lbAqv.ATNSimulator.ERROR) break;
            // If this is a consumable input element, make sure to consume before
            // capturing the accept state so the input index, line, and char
            // position accurately reflect the state of the interpreter at the
            // end of the token.
            if (t !== $d4sFB.IntStream.EOF) this.consume(input);
            if (target.isAcceptState) {
                this.captureSimState(this.prevAccept, input, target);
                if (t === $d4sFB.IntStream.EOF) break;
            }
            t = input.LA(1);
            s = target; // flip; current DFA target becomes new src/from state
        }
        return this.failOrAccept(this.prevAccept, input, s.configs, t);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        let target = s.getTarget(t);
        if (LexerATNSimulator.debug && target != null) console.log("reuse state " + s.stateNumber + " edge to " + target.stateNumber);
        return target;
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param input The input stream
     * @param s The current DFA state
     * @param t The next input symbol
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(input, s, t) {
        let reach = new $jjTpW.OrderedATNConfigSet();
        // if we don't find an existing DFA state
        // Fill reach starting from closure, following t transitions
        this.getReachableConfigSet(input, s.configs, reach, t);
        if (reach.isEmpty) {
            if (!reach.hasSemanticContext) // we got nowhere on t, don't throw out this knowledge; it'd
            // cause a failover from DFA later.
            this.addDFAEdge(s, t, $lbAqv.ATNSimulator.ERROR);
            // stop when we can't match any more char
            return $lbAqv.ATNSimulator.ERROR;
        }
        // Add an edge from s to target DFA found/created for reach
        return this.addDFAEdge(s, t, reach);
    }
    failOrAccept(prevAccept, input, reach, t) {
        if (prevAccept.dfaState != null) {
            let lexerActionExecutor = prevAccept.dfaState.lexerActionExecutor;
            this.accept(input, lexerActionExecutor, this.startIndex, prevAccept.index, prevAccept.line, prevAccept.charPos);
            return prevAccept.dfaState.prediction;
        } else {
            // if no accept and EOF is first char, return EOF
            if (t === $d4sFB.IntStream.EOF && input.index === this.startIndex) return $2G93d.Token.EOF;
            throw new $6Npyx.LexerNoViableAltException(this.recog, input, this.startIndex, reach);
        }
    }
    /** Given a starting configuration set, figure out all ATN configurations
     *  we can reach upon input `t`. Parameter `reach` is a return
     *  parameter.
     */ getReachableConfigSet(input, closure, reach, t) {
        // this is used to skip processing for configs which have a lower priority
        // than a config that already reached an accept state for the same rule
        let skipAlt = $lDQMG.ATN.INVALID_ALT_NUMBER;
        for (let c of closure){
            let currentAltReachedAcceptState = c.alt === skipAlt;
            if (currentAltReachedAcceptState && c.hasPassedThroughNonGreedyDecision) continue;
            if (LexerATNSimulator.debug) console.log(`testing ${this.getTokenName(t)} at ${c.toString(this.recog, true)}`);
            let n = c.state.numberOfOptimizedTransitions;
            for(let ti = 0; ti < n; ti++){
                let trans = c.state.getOptimizedTransition(ti);
                let target = this.getReachableTarget(trans, t);
                if (target != null) {
                    let lexerActionExecutor = c.lexerActionExecutor;
                    let config;
                    if (lexerActionExecutor != null) {
                        lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
                        config = c.transform(target, true, lexerActionExecutor);
                    } else {
                        $gwEr2(c.lexerActionExecutor == null);
                        config = c.transform(target, true);
                    }
                    let treatEofAsEpsilon = t === $d4sFB.IntStream.EOF;
                    if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
                        // any remaining configs for this alt have a lower priority than
                        // the one that just reached an accept state.
                        skipAlt = c.alt;
                        break;
                    }
                }
            }
        }
    }
    accept(input, lexerActionExecutor, startIndex, index, line, charPos) {
        if (LexerATNSimulator.debug) console.log(`ACTION ${lexerActionExecutor}`);
        // seek to after last char in token
        input.seek(index);
        this._line = line;
        this._charPositionInLine = charPos;
        if (lexerActionExecutor != null && this.recog != null) lexerActionExecutor.execute(this.recog, input, startIndex);
    }
    getReachableTarget(trans, t) {
        if (trans.matches(t, $gTQRB.Lexer.MIN_CHAR_VALUE, $gTQRB.Lexer.MAX_CHAR_VALUE)) return trans.target;
        return undefined;
    }
    computeStartState(input, p) {
        let initialContext = $haz8F.PredictionContext.EMPTY_FULL;
        let configs = new $jjTpW.OrderedATNConfigSet();
        for(let i = 0; i < p.numberOfTransitions; i++){
            let target = p.transition(i).target;
            let c = $9qlOq.ATNConfig.create(target, i + 1, initialContext);
            this.closure(input, c, configs, false, false, false);
        }
        return configs;
    }
    /**
     * Since the alternatives within any lexer decision are ordered by
     * preference, this method stops pursuing the closure as soon as an accept
     * state is reached. After the first accept state is reached by depth-first
     * search from `config`, all other (potentially reachable) states for
     * this rule would have a lower priority.
     *
     * @returns `true` if an accept state is reached, otherwise
     * `false`.
     */ closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
        if (LexerATNSimulator.debug) console.log("closure(" + config.toString(this.recog, true) + ")");
        if (config.state instanceof $U6v4o.RuleStopState) {
            if (LexerATNSimulator.debug) {
                if (this.recog != null) console.log(`closure at ${this.recog.ruleNames[config.state.ruleIndex]} rule stop ${config}`);
                else console.log(`closure at rule stop ${config}`);
            }
            let context = config.context;
            if (context.isEmpty) {
                configs.add(config);
                return true;
            } else if (context.hasEmpty) {
                configs.add(config.transform(config.state, true, $haz8F.PredictionContext.EMPTY_FULL));
                currentAltReachedAcceptState = true;
            }
            for(let i = 0; i < context.size; i++){
                let returnStateNumber = context.getReturnState(i);
                if (returnStateNumber === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                let newContext = context.getParent(i); // "pop" return state
                let returnState = this.atn.states[returnStateNumber];
                let c = config.transform(returnState, false, newContext);
                currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
            }
            return currentAltReachedAcceptState;
        }
        // optimization
        if (!config.state.onlyHasEpsilonTransitions) {
            if (!currentAltReachedAcceptState || !config.hasPassedThroughNonGreedyDecision) configs.add(config);
        }
        let p = config.state;
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            let t = p.getOptimizedTransition(i);
            let c = this.getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon);
            if (c != null) currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
        }
        return currentAltReachedAcceptState;
    }
    // side-effect: can alter configs.hasSemanticContext
    getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon) {
        let c;
        switch(t.serializationType){
            case 3 /* RULE */ :
                let ruleTransition = t;
                if (this.optimize_tail_calls && ruleTransition.optimizedTailCall && !config.context.hasEmpty) c = config.transform(t.target, true);
                else {
                    let newContext = config.context.getChild(ruleTransition.followState.stateNumber);
                    c = config.transform(t.target, true, newContext);
                }
                break;
            case 10 /* PRECEDENCE */ :
                throw new Error("Precedence predicates are not supported in lexers.");
            case 4 /* PREDICATE */ :
                /*  Track traversing semantic predicates. If we traverse,
                    we cannot add a DFA state for this "reach" computation
                    because the DFA would not test the predicate again in the
                    future. Rather than creating collections of semantic predicates
                    like v3 and testing them on prediction, v4 will test them on the
                    fly all the time using the ATN not the DFA. This is slower but
                    semantically it's not used that often. One of the key elements to
                    this predicate mechanism is not adding DFA states that see
                    predicates immediately afterwards in the ATN. For example,
    
                    a : ID {p1}? | ID {p2}? ;
    
                    should create the start state for rule 'a' (to save start state
                    competition), but should not create target of ID state. The
                    collection of ATN states the following ID references includes
                    states reached by traversing predicates. Since this is when we
                    test them, we cannot cash the DFA state target of ID.
                */ let pt = t;
                if (LexerATNSimulator.debug) console.log("EVAL rule " + pt.ruleIndex + ":" + pt.predIndex);
                configs.hasSemanticContext = true;
                if (this.evaluatePredicate(input, pt.ruleIndex, pt.predIndex, speculative)) c = config.transform(t.target, true);
                else c = undefined;
                break;
            case 6 /* ACTION */ :
                if (config.context.hasEmpty) {
                    // execute actions anywhere in the start rule for a token.
                    //
                    // TODO: if the entry rule is invoked recursively, some
                    // actions may be executed during the recursive call. The
                    // problem can appear when hasEmpty is true but
                    // isEmpty is false. In this case, the config needs to be
                    // split into two contexts - one with just the empty path
                    // and another with everything but the empty path.
                    // Unfortunately, the current algorithm does not allow
                    // getEpsilonTarget to return two configurations, so
                    // additional modifications are needed before we can support
                    // the split operation.
                    let lexerActionExecutor = $khqMx.LexerActionExecutor.append(config.lexerActionExecutor, this.atn.lexerActions[t.actionIndex]);
                    c = config.transform(t.target, true, lexerActionExecutor);
                    break;
                } else {
                    // ignore actions in referenced rules
                    c = config.transform(t.target, true);
                    break;
                }
            case 1 /* EPSILON */ :
                c = config.transform(t.target, true);
                break;
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                if (treatEofAsEpsilon) {
                    if (t.matches($d4sFB.IntStream.EOF, $gTQRB.Lexer.MIN_CHAR_VALUE, $gTQRB.Lexer.MAX_CHAR_VALUE)) {
                        c = config.transform(t.target, false);
                        break;
                    }
                }
                c = undefined;
                break;
            default:
                c = undefined;
                break;
        }
        return c;
    }
    /**
     * Evaluate a predicate specified in the lexer.
     *
     * If `speculative` is `true`, this method was called before
     * {@link #consume} for the matched character. This method should call
     * {@link #consume} before evaluating the predicate to ensure position
     * sensitive values, including {@link Lexer#getText}, {@link Lexer#getLine},
     * and {@link Lexer#getCharPositionInLine}, properly reflect the current
     * lexer state. This method should restore `input` and the simulator
     * to the original state before returning (i.e. undo the actions made by the
     * call to {@link #consume}.
     *
     * @param input The input stream.
     * @param ruleIndex The rule containing the predicate.
     * @param predIndex The index of the predicate within the rule.
     * @param speculative `true` if the current index in `input` is
     * one character before the predicate's location.
     *
     * @returns `true` if the specified predicate evaluates to
     * `true`.
     */ evaluatePredicate(input, ruleIndex, predIndex, speculative) {
        // assume true if no recognizer was provided
        if (this.recog == null) return true;
        if (!speculative) return this.recog.sempred(undefined, ruleIndex, predIndex);
        let savedCharPositionInLine = this._charPositionInLine;
        let savedLine = this._line;
        let index = input.index;
        let marker = input.mark();
        try {
            this.consume(input);
            return this.recog.sempred(undefined, ruleIndex, predIndex);
        } finally{
            this._charPositionInLine = savedCharPositionInLine;
            this._line = savedLine;
            input.seek(index);
            input.release(marker);
        }
    }
    captureSimState(settings, input, dfaState) {
        settings.index = input.index;
        settings.line = this._line;
        settings.charPos = this._charPositionInLine;
        settings.dfaState = dfaState;
    }
    addDFAEdge(p, t, q) {
        if (q instanceof $6co2U.ATNConfigSet) {
            /* leading to this call, ATNConfigSet.hasSemanticContext is used as a
            * marker indicating dynamic predicate evaluation makes this edge
            * dependent on the specific input sequence, so the static edge in the
            * DFA should be omitted. The target DFAState is still created since
            * execATN has the ability to resynchronize with the DFA state cache
            * following the predicate evaluation step.
            *
            * TJP notes: next time through the DFA, we see a pred again and eval.
            * If that gets us to a previously created (but dangling) DFA
            * state, we can continue in pure DFA mode from there.
            */ let suppressEdge = q.hasSemanticContext;
            if (suppressEdge) q.hasSemanticContext = false;
            // @NotNull
            let to = this.addDFAState(q);
            if (suppressEdge) return to;
            this.addDFAEdge(p, t, to);
            return to;
        } else {
            if (LexerATNSimulator.debug) console.log("EDGE " + p + " -> " + q + " upon " + String.fromCharCode(t));
            if (p != null) p.setTarget(t, q);
        }
    }
    /** Add a new DFA state if there isn't one with this set of
     * 	configurations already. This method also detects the first
     * 	configuration containing an ATN rule stop state. Later, when
     * 	traversing the DFA, we will know which rule to accept.
     */ addDFAState(configs) {
        /* the lexer evaluates predicates on-the-fly; by this point configs
         * should not contain any configurations with unevaluated predicates.
         */ $gwEr2(!configs.hasSemanticContext);
        let proposed = new $5jw7S.DFAState(configs);
        let existing = this.atn.modeToDFA[this.mode].states.get(proposed);
        if (existing != null) return existing;
        configs.optimizeConfigs(this);
        let newState = new $5jw7S.DFAState(configs.clone(true));
        let firstConfigWithRuleStopState;
        for (let c of configs)if (c.state instanceof $U6v4o.RuleStopState) {
            firstConfigWithRuleStopState = c;
            break;
        }
        if (firstConfigWithRuleStopState != null) {
            let prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
            let lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
            newState.acceptStateInfo = new $dg39p.AcceptStateInfo(prediction, lexerActionExecutor);
        }
        return this.atn.modeToDFA[this.mode].addState(newState);
    }
    getDFA(mode) {
        return this.atn.modeToDFA[mode];
    }
    /** Get the text matched so far for the current token.
     */ getText(input) {
        // index is first lookahead char, don't include.
        return input.getText($4Q2DM.Interval.of(this.startIndex, input.index - 1));
    }
    get line() {
        return this._line;
    }
    set line(line) {
        this._line = line;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    consume(input) {
        let curChar = input.LA(1);
        if (curChar === "\n".charCodeAt(0)) {
            this._line++;
            this._charPositionInLine = 0;
        } else this._charPositionInLine++;
        input.consume();
    }
    getTokenName(t) {
        if (t === -1) return "EOF";
        //if ( atn.g!=null ) return atn.g.getTokenDisplayName(t);
        return "'" + String.fromCharCode(t) + "'";
    }
};
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "prevAccept", void 0);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "copyState", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "match", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.Override
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "reset", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "matchATN", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "execATN", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getExistingTargetState", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull,
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "computeTargetState", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(2, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getReachableConfigSet", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "accept", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull,
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "computeStartState", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(2, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "closure", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(2, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(3, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getEpsilonTarget", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "evaluatePredicate", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(1, $esDFm.NotNull),
    $ecc564042155c9fa$var$__param(2, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "captureSimState", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull,
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "addDFAState", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getDFA", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull,
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getText", null);
$ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "consume", null);
$ecc564042155c9fa$var$__decorate([
    $esDFm.NotNull
], $ecc564042155c9fa$var$LexerATNSimulator.prototype, "getTokenName", null);
$ecc564042155c9fa$var$LexerATNSimulator = $ecc564042155c9fa$var$__decorate([
    $ecc564042155c9fa$var$__param(0, $esDFm.NotNull)
], $ecc564042155c9fa$var$LexerATNSimulator);
module.exports.LexerATNSimulator = $ecc564042155c9fa$var$LexerATNSimulator;
(function(LexerATNSimulator) {
    LexerATNSimulator.debug = false;
    LexerATNSimulator.dfa_debug = false;
    /** When we hit an accept state in either the DFA or the ATN, we
     *  have to notify the character stream to start buffering characters
     *  via {@link IntStream#mark} and record the current state. The current sim state
     *  includes the current index into the input, the current line,
     *  and current character position in that line. Note that the Lexer is
     *  tracking the starting line and characterization of the token. These
     *  variables track the "state" of the simulator when it hits an accept state.
     *
     *  We track these variables separately for the DFA and ATN simulation
     *  because the DFA simulation often has to fail over to the ATN
     *  simulation. If the ATN simulation fails, we need the DFA to fall
     *  back to its previously accepted state, if any. If the ATN succeeds,
     *  then the ATN does the accept and the DFA simulator that invoked it
     *  can simply return the predicted token type.
     */ class SimState {
        constructor(){
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
        }
        reset() {
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
            this.dfaState = undefined;
        }
    }
    LexerATNSimulator.SimState = SimState;
})($ecc564042155c9fa$var$LexerATNSimulator = module.exports.LexerATNSimulator || (module.exports.LexerATNSimulator = {}));
module.exports.LexerATNSimulator = $ecc564042155c9fa$var$LexerATNSimulator;

});
parcelRegister("dg39p", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AcceptStateInfo = void 0;
/**
 * Stores information about a {@link DFAState} which is an accept state under
 * some condition. Certain settings, such as
 * {@link ParserATNSimulator#getPredictionMode()}, may be used in addition to
 * this information to determine whether or not a particular state is an accept
 * state.
 *
 * @author Sam Harwell
 */ class $9a6f36ab46ef5323$var$AcceptStateInfo {
    constructor(prediction, lexerActionExecutor){
        this._prediction = prediction;
        this._lexerActionExecutor = lexerActionExecutor;
    }
    /**
     * Gets the prediction made by this accept state. Note that this value
     * assumes the predicates, if any, in the {@link DFAState} evaluate to
     * `true`. If predicate evaluation is enabled, the final prediction of
     * the accept state will be determined by the result of predicate
     * evaluation.
     */ get prediction() {
        return this._prediction;
    }
    /**
     * Gets the {@link LexerActionExecutor} which can be used to execute actions
     * and/or commands after the lexer matches a token.
     */ get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
}
module.exports.AcceptStateInfo = $9a6f36ab46ef5323$var$AcceptStateInfo;

});

parcelRegister("lDQMG", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fc162f50821f0f08$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fc162f50821f0f08$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATN = void 0;

var $dkveu = parcelRequire("dkveu");

var $dLpRd = parcelRequire("dLpRd");

var $6og9T = parcelRequire("6og9T");

var $2xNwj = parcelRequire("2xNwj");

var $en89P = parcelRequire("en89P");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $haz8F = parcelRequire("haz8F");

var $2G93d = parcelRequire("2G93d");

var $gwEr2 = parcelRequire("gwEr2");
/** */ let $fc162f50821f0f08$var$ATN = class ATN {
    /** Used for runtime deserialization of ATNs from strings */ constructor(grammarType, maxTokenType){
        this.states = [];
        /** Each subrule/rule is a decision point and we must track them so we
         *  can go back later and build DFA predictors for them.  This includes
         *  all the rules, subrules, optional blocks, ()+, ()* etc...
         */ this.decisionToState = [];
        this.modeNameToStartState = new Map();
        this.modeToStartState = [];
        this.contextCache = new $dkveu.Array2DHashMap($73sQO.ObjectEqualityComparator.INSTANCE);
        this.decisionToDFA = [];
        this.modeToDFA = [];
        this.LL1Table = new Map();
        this.grammarType = grammarType;
        this.maxTokenType = maxTokenType;
    }
    clearDFA() {
        this.decisionToDFA = new Array(this.decisionToState.length);
        for(let i = 0; i < this.decisionToDFA.length; i++)this.decisionToDFA[i] = new $dLpRd.DFA(this.decisionToState[i], i);
        this.modeToDFA = new Array(this.modeToStartState.length);
        for(let i = 0; i < this.modeToDFA.length; i++)this.modeToDFA[i] = new $dLpRd.DFA(this.modeToStartState[i]);
        this.contextCache.clear();
        this.LL1Table.clear();
    }
    get contextCacheSize() {
        return this.contextCache.size;
    }
    getCachedContext(context) {
        return $haz8F.PredictionContext.getCachedContext(context, this.contextCache, new $haz8F.PredictionContext.IdentityHashMap());
    }
    getDecisionToDFA() {
        $gwEr2(this.decisionToDFA != null && this.decisionToDFA.length === this.decisionToState.length);
        return this.decisionToDFA;
    }
    nextTokens(s, ctx) {
        if (ctx) {
            let anal = new $en89P.LL1Analyzer(this);
            let next = anal.LOOK(s, ctx);
            return next;
        } else {
            if (s.nextTokenWithinRule) return s.nextTokenWithinRule;
            s.nextTokenWithinRule = this.nextTokens(s, $haz8F.PredictionContext.EMPTY_LOCAL);
            s.nextTokenWithinRule.setReadonly(true);
            return s.nextTokenWithinRule;
        }
    }
    addState(state) {
        state.atn = this;
        state.stateNumber = this.states.length;
        this.states.push(state);
    }
    removeState(state) {
        // just replace the state, don't shift states in list
        let invalidState = new $2xNwj.InvalidState();
        invalidState.atn = this;
        invalidState.stateNumber = state.stateNumber;
        this.states[state.stateNumber] = invalidState;
    }
    defineMode(name, s) {
        this.modeNameToStartState.set(name, s);
        this.modeToStartState.push(s);
        this.modeToDFA.push(new $dLpRd.DFA(s));
        this.defineDecisionState(s);
    }
    defineDecisionState(s) {
        this.decisionToState.push(s);
        s.decision = this.decisionToState.length - 1;
        this.decisionToDFA.push(new $dLpRd.DFA(s, s.decision));
        return s.decision;
    }
    getDecisionState(decision) {
        if (this.decisionToState.length > 0) return this.decisionToState[decision];
        return undefined;
    }
    get numberOfDecisions() {
        return this.decisionToState.length;
    }
    /**
     * Computes the set of input symbols which could follow ATN state number
     * `stateNumber` in the specified full `context`. This method
     * considers the complete parser context, but does not evaluate semantic
     * predicates (i.e. all predicates encountered during the calculation are
     * assumed true). If a path in the ATN exists from the starting state to the
     * {@link RuleStopState} of the outermost context without matching any
     * symbols, {@link Token#EOF} is added to the returned set.
     *
     * If `context` is `undefined`, it is treated as
     * {@link ParserRuleContext#EMPTY}.
     *
     * Note that this does NOT give you the set of all tokens that could
     * appear at a given token position in the input phrase.  In other words, it
     * does not answer:
     *
     * > Given a specific partial input phrase, return the set of all
     * > tokens that can follow the last token in the input phrase.
     *
     * The big difference is that with just the input, the parser could land
     * right in the middle of a lookahead decision. Getting all
     * *possible* tokens given a partial input stream is a separate
     * computation. See https://github.com/antlr/antlr4/issues/1428
     *
     * For this function, we are specifying an ATN state and call stack to
     * compute what token(s) can come next and specifically: outside of a
     * lookahead decision. That is what you want for error reporting and
     * recovery upon parse error.
     *
     * @param stateNumber the ATN state number
     * @param context the full parse context
     * @returns The set of potentially valid input symbols which could follow the
     * specified state in the specified context.
     * @ if the ATN does not contain a state with
     * number `stateNumber`
     */ getExpectedTokens(stateNumber, context) {
        if (stateNumber < 0 || stateNumber >= this.states.length) throw new RangeError("Invalid state number.");
        let ctx = context;
        let s = this.states[stateNumber];
        let following = this.nextTokens(s);
        if (!following.contains($2G93d.Token.EPSILON)) return following;
        let expected = new $6og9T.IntervalSet();
        expected.addAll(following);
        expected.remove($2G93d.Token.EPSILON);
        while(ctx != null && ctx.invokingState >= 0 && following.contains($2G93d.Token.EPSILON)){
            let invokingState = this.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = this.nextTokens(rt.followState);
            expected.addAll(following);
            expected.remove($2G93d.Token.EPSILON);
            ctx = ctx._parent;
        }
        if (following.contains($2G93d.Token.EPSILON)) expected.add($2G93d.Token.EOF);
        return expected;
    }
};
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "states", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "decisionToState", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "modeNameToStartState", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "modeToStartState", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "decisionToDFA", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "modeToDFA", void 0);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "nextTokens", null);
$fc162f50821f0f08$var$__decorate([
    $fc162f50821f0f08$var$__param(0, $esDFm.NotNull)
], $fc162f50821f0f08$var$ATN.prototype, "removeState", null);
$fc162f50821f0f08$var$__decorate([
    $fc162f50821f0f08$var$__param(0, $esDFm.NotNull),
    $fc162f50821f0f08$var$__param(1, $esDFm.NotNull)
], $fc162f50821f0f08$var$ATN.prototype, "defineMode", null);
$fc162f50821f0f08$var$__decorate([
    $fc162f50821f0f08$var$__param(0, $esDFm.NotNull)
], $fc162f50821f0f08$var$ATN.prototype, "defineDecisionState", null);
$fc162f50821f0f08$var$__decorate([
    $esDFm.NotNull
], $fc162f50821f0f08$var$ATN.prototype, "getExpectedTokens", null);
$fc162f50821f0f08$var$ATN = $fc162f50821f0f08$var$__decorate([
    $fc162f50821f0f08$var$__param(0, $esDFm.NotNull)
], $fc162f50821f0f08$var$ATN);
module.exports.ATN = $fc162f50821f0f08$var$ATN;
(function(ATN) {
    ATN.INVALID_ALT_NUMBER = 0;
})($fc162f50821f0f08$var$ATN = module.exports.ATN || (module.exports.ATN = {}));
module.exports.ATN = $fc162f50821f0f08$var$ATN;

});
parcelRegister("dkveu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashMap = void 0;

var $fJumX = parcelRequire("fJumX");
class $9b455ecf1c961528$var$MapKeyEqualityComparator {
    constructor(keyComparator){
        this.keyComparator = keyComparator;
    }
    hashCode(obj) {
        return this.keyComparator.hashCode(obj.key);
    }
    equals(a, b) {
        return this.keyComparator.equals(a.key, b.key);
    }
}
class $9b455ecf1c961528$var$Array2DHashMap {
    constructor(keyComparer){
        if (keyComparer instanceof $9b455ecf1c961528$var$Array2DHashMap) this.backingStore = new $fJumX.Array2DHashSet(keyComparer.backingStore);
        else this.backingStore = new $fJumX.Array2DHashSet(new $9b455ecf1c961528$var$MapKeyEqualityComparator(keyComparer));
    }
    clear() {
        this.backingStore.clear();
    }
    containsKey(key) {
        return this.backingStore.contains({
            key: key
        });
    }
    get(key) {
        let bucket = this.backingStore.get({
            key: key
        });
        if (!bucket) return undefined;
        return bucket.value;
    }
    get isEmpty() {
        return this.backingStore.isEmpty;
    }
    put(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else {
            result = element.value;
            element.value = value;
        }
        return result;
    }
    putIfAbsent(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else result = element.value;
        return result;
    }
    get size() {
        return this.backingStore.size;
    }
    hashCode() {
        return this.backingStore.hashCode();
    }
    equals(o) {
        if (!(o instanceof $9b455ecf1c961528$var$Array2DHashMap)) return false;
        return this.backingStore.equals(o.backingStore);
    }
}
module.exports.Array2DHashMap = $9b455ecf1c961528$var$Array2DHashMap;

});

parcelRegister("dLpRd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a053b8dbd76d12f6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a053b8dbd76d12f6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFA = void 0;

var $fJumX = parcelRequire("fJumX");

var $6co2U = parcelRequire("6co2U");

var $cXSly = parcelRequire("cXSly");

var $5jw7S = parcelRequire("5jw7S");

var $hZ9cR = parcelRequire("hZ9cR");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $izkyd = parcelRequire("izkyd");

var $5t4I3 = parcelRequire("5t4I3");
let $a053b8dbd76d12f6$var$DFA = class DFA {
    constructor(atnStartState, decision = 0){
        /**
         * A set of all states in the `DFA`.
         *
         * Note that this collection of states holds the DFA states for both SLL and LL prediction. Only the start state
         * needs to be differentiated for these cases, which is tracked by the `s0` and `s0full` fields.
         */ this.states = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
        this.nextStateNumber = 0;
        if (!atnStartState.atn) throw new Error("The ATNState must be associated with an ATN");
        this.atnStartState = atnStartState;
        this.atn = atnStartState.atn;
        this.decision = decision;
        // Precedence DFAs are associated with the special precedence decision created for left-recursive rules which
        // evaluate their alternatives using a precedence hierarchy. When such a decision is encountered, we mark this
        // DFA instance as a precedence DFA and initialize the initial states s0 and s0full to special DFAState
        // instances which use outgoing edges to link to the actual start state used for each precedence level.
        let isPrecedenceDfa = false;
        if (atnStartState instanceof $izkyd.StarLoopEntryState) {
            if (atnStartState.precedenceRuleDecision) {
                isPrecedenceDfa = true;
                this.s0 = new $5jw7S.DFAState(new $6co2U.ATNConfigSet());
                this.s0full = new $5jw7S.DFAState(new $6co2U.ATNConfigSet());
            }
        }
        this.precedenceDfa = isPrecedenceDfa;
    }
    /**
     * Gets whether this DFA is a precedence DFA. Precedence DFAs use a special
     * start state {@link #s0} which is not stored in {@link #states}. The
     * {@link DFAState#edges} array for this start state contains outgoing edges
     * supplying individual start states corresponding to specific precedence
     * values.
     *
     * @returns `true` if this is a precedence DFA; otherwise,
     * `false`.
     * @see Parser.precedence
     */ get isPrecedenceDfa() {
        return this.precedenceDfa;
    }
    /**
     * Get the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @returns The start state corresponding to the specified precedence, or
     * `undefined` if no start state exists for the specified precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ getPrecedenceStartState(precedence, fullContext) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        // s0 and s0full are never null for a precedence DFA
        if (fullContext) return this.s0full.getTarget(precedence);
        else return this.s0.getTarget(precedence);
    }
    /**
     * Set the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @param startState The start state corresponding to the specified
     * precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ setPrecedenceStartState(precedence, fullContext, startState) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        if (precedence < 0) return;
        if (fullContext) // s0full is never null for a precedence DFA
        this.s0full.setTarget(precedence, startState);
        else // s0 is never null for a precedence DFA
        this.s0.setTarget(precedence, startState);
    }
    get isEmpty() {
        if (this.isPrecedenceDfa) // s0 and s0full are never null for a precedence DFA
        return this.s0.getEdgeMap().size === 0 && this.s0full.getEdgeMap().size === 0;
        return this.s0 == null && this.s0full == null;
    }
    get isContextSensitive() {
        if (this.isPrecedenceDfa) // s0full is never null for a precedence DFA
        return this.s0full.getEdgeMap().size > 0;
        return this.s0full != null;
    }
    addState(state) {
        state.stateNumber = this.nextStateNumber++;
        return this.states.getOrAdd(state);
    }
    toString(vocabulary, ruleNames) {
        if (!vocabulary) vocabulary = $5t4I3.VocabularyImpl.EMPTY_VOCABULARY;
        if (!this.s0) return "";
        let serializer;
        if (ruleNames) serializer = new $cXSly.DFASerializer(this, vocabulary, ruleNames, this.atnStartState.atn);
        else serializer = new $cXSly.DFASerializer(this, vocabulary);
        return serializer.toString();
    }
    toLexerString() {
        if (!this.s0) return "";
        let serializer = new $hZ9cR.LexerDFASerializer(this);
        return serializer.toString();
    }
};
$a053b8dbd76d12f6$var$__decorate([
    $esDFm.NotNull
], $a053b8dbd76d12f6$var$DFA.prototype, "states", void 0);
$a053b8dbd76d12f6$var$__decorate([
    $esDFm.NotNull
], $a053b8dbd76d12f6$var$DFA.prototype, "atnStartState", void 0);
$a053b8dbd76d12f6$var$__decorate([
    $esDFm.NotNull
], $a053b8dbd76d12f6$var$DFA.prototype, "atn", void 0);
$a053b8dbd76d12f6$var$DFA = $a053b8dbd76d12f6$var$__decorate([
    $a053b8dbd76d12f6$var$__param(0, $esDFm.NotNull)
], $a053b8dbd76d12f6$var$DFA);
module.exports.DFA = $a053b8dbd76d12f6$var$DFA;

});
parcelRegister("6co2U", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $48368415f2c032d4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfigSet = void 0;

var $dkveu = parcelRequire("dkveu");

var $fJumX = parcelRequire("fJumX");

var $crbOk = parcelRequire("crbOk");

var $lDQMG = parcelRequire("lDQMG");

var $9qlOq = parcelRequire("9qlOq");

var $lVdCV = parcelRequire("lVdCV");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $haz8F = parcelRequire("haz8F");

var $8Uwhy = parcelRequire("8Uwhy");

var $8DW9a = parcelRequire("8DW9a");

var $gwEr2 = parcelRequire("gwEr2");

var $g4Hat = parcelRequire("g4Hat");
class $48368415f2c032d4$var$KeyTypeEqualityComparer {
    hashCode(key) {
        return key.state ^ key.alt;
    }
    equals(a, b) {
        return a.state === b.state && a.alt === b.alt;
    }
}
$48368415f2c032d4$var$KeyTypeEqualityComparer.INSTANCE = new $48368415f2c032d4$var$KeyTypeEqualityComparer();
function $48368415f2c032d4$var$NewKeyedConfigMap(map) {
    if (map) return new $dkveu.Array2DHashMap(map);
    else return new $dkveu.Array2DHashMap($48368415f2c032d4$var$KeyTypeEqualityComparer.INSTANCE);
}
/**
 * Represents a set of ATN configurations (see `ATNConfig`). As configurations are added to the set, they are merged
 * with other `ATNConfig` instances already in the set when possible using the graph-structured stack.
 *
 * An instance of this class represents the complete set of positions (with context) in an ATN which would be associated
 * with a single DFA state. Its internal representation is more complex than traditional state used for NFA to DFA
 * conversion due to performance requirements (both improving speed and reducing memory overhead) as well as supporting
 * features such as semantic predicates and non-greedy operators in a form to support ANTLR's prediction algorithm.
 *
 * @author Sam Harwell
 */ class $48368415f2c032d4$var$ATNConfigSet {
    constructor(set, readonly){
        this._uniqueAlt = 0;
        // Used in parser and lexer. In lexer, it indicates we hit a pred
        // while computing a closure operation.  Don't make a DFA state from this.
        this._hasSemanticContext = false;
        this._dipsIntoOuterContext = false;
        /**
         * When `true`, this config set represents configurations where the entire
         * outer context has been consumed by the ATN interpreter. This prevents the
         * {@link ParserATNSimulator#closure} from pursuing the global FOLLOW when a
         * rule stop state is reached with an empty prediction context.
         *
         * Note: `outermostConfigSet` and {@link #dipsIntoOuterContext} should never
         * be true at the same time.
         */ this.outermostConfigSet = false;
        this.cachedHashCode = -1;
        if (!set) {
            this.mergedConfigs = $48368415f2c032d4$var$NewKeyedConfigMap();
            this.unmerged = [];
            this.configs = [];
            this._uniqueAlt = $lDQMG.ATN.INVALID_ALT_NUMBER;
        } else {
            if (readonly) {
                this.mergedConfigs = undefined;
                this.unmerged = undefined;
            } else if (!set.isReadOnly) {
                this.mergedConfigs = $48368415f2c032d4$var$NewKeyedConfigMap(set.mergedConfigs);
                this.unmerged = set.unmerged.slice(0);
            } else {
                this.mergedConfigs = $48368415f2c032d4$var$NewKeyedConfigMap();
                this.unmerged = [];
            }
            this.configs = set.configs.slice(0);
            this._dipsIntoOuterContext = set._dipsIntoOuterContext;
            this._hasSemanticContext = set._hasSemanticContext;
            this.outermostConfigSet = set.outermostConfigSet;
            if (readonly || !set.isReadOnly) {
                this._uniqueAlt = set._uniqueAlt;
                this._conflictInfo = set._conflictInfo;
            }
        // if (!readonly && set.isReadOnly) -> addAll is called from clone()
        }
    }
    /**
     * Get the set of all alternatives represented by configurations in this
     * set.
     */ getRepresentedAlternatives() {
        if (this._conflictInfo != null) return this._conflictInfo.conflictedAlts.clone();
        let alts = new $lVdCV.BitSet();
        for (let config of this)alts.set(config.alt);
        return alts;
    }
    get isReadOnly() {
        return this.mergedConfigs == null;
    }
    get isOutermostConfigSet() {
        return this.outermostConfigSet;
    }
    set isOutermostConfigSet(outermostConfigSet) {
        if (this.outermostConfigSet && !outermostConfigSet) throw new Error("IllegalStateException");
        $gwEr2(!outermostConfigSet || !this._dipsIntoOuterContext);
        this.outermostConfigSet = outermostConfigSet;
    }
    getStates() {
        let states = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
        for (let c of this.configs)states.add(c.state);
        return states;
    }
    optimizeConfigs(interpreter) {
        if (this.configs.length === 0) return;
        for (let config of this.configs)config.context = interpreter.atn.getCachedContext(config.context);
    }
    clone(readonly) {
        let copy = new $48368415f2c032d4$var$ATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this.configs);
        return copy;
    }
    get size() {
        return this.configs.length;
    }
    get isEmpty() {
        return this.configs.length === 0;
    }
    contains(o) {
        if (!(o instanceof $9qlOq.ATNConfig)) return false;
        if (this.mergedConfigs && this.unmerged) {
            let config = o;
            let configKey = this.getKey(config);
            let mergedConfig = this.mergedConfigs.get(configKey);
            if (mergedConfig != null && this.canMerge(config, configKey, mergedConfig)) return mergedConfig.contains(config);
            for (let c of this.unmerged){
                if (c.contains(o)) return true;
            }
        } else for (let c of this.configs){
            if (c.contains(o)) return true;
        }
        return false;
    }
    *[Symbol.iterator]() {
        yield* this.configs;
    }
    toArray() {
        return this.configs;
    }
    add(e, contextCache) {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        $gwEr2(!this.outermostConfigSet || !e.reachesIntoOuterContext);
        if (contextCache == null) contextCache = $8Uwhy.PredictionContextCache.UNCACHED;
        let addKey;
        let key = this.getKey(e);
        let mergedConfig = this.mergedConfigs.get(key);
        addKey = mergedConfig == null;
        if (mergedConfig != null && this.canMerge(e, key, mergedConfig)) {
            mergedConfig.outerContextDepth = Math.max(mergedConfig.outerContextDepth, e.outerContextDepth);
            if (e.isPrecedenceFilterSuppressed) mergedConfig.isPrecedenceFilterSuppressed = true;
            let joined = $haz8F.PredictionContext.join(mergedConfig.context, e.context, contextCache);
            this.updatePropertiesForMergedConfig(e);
            if (mergedConfig.context === joined) return false;
            mergedConfig.context = joined;
            return true;
        }
        for(let i = 0; i < this.unmerged.length; i++){
            let unmergedConfig = this.unmerged[i];
            if (this.canMerge(e, key, unmergedConfig)) {
                unmergedConfig.outerContextDepth = Math.max(unmergedConfig.outerContextDepth, e.outerContextDepth);
                if (e.isPrecedenceFilterSuppressed) unmergedConfig.isPrecedenceFilterSuppressed = true;
                let joined = $haz8F.PredictionContext.join(unmergedConfig.context, e.context, contextCache);
                this.updatePropertiesForMergedConfig(e);
                if (unmergedConfig.context === joined) return false;
                unmergedConfig.context = joined;
                if (addKey) {
                    this.mergedConfigs.put(key, unmergedConfig);
                    this.unmerged.splice(i, 1);
                }
                return true;
            }
        }
        this.configs.push(e);
        if (addKey) this.mergedConfigs.put(key, e);
        else this.unmerged.push(e);
        this.updatePropertiesForAddedConfig(e);
        return true;
    }
    updatePropertiesForMergedConfig(config) {
        // merged configs can't change the alt or semantic context
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $gwEr2(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    updatePropertiesForAddedConfig(config) {
        if (this.configs.length === 1) this._uniqueAlt = config.alt;
        else if (this._uniqueAlt !== config.alt) this._uniqueAlt = $lDQMG.ATN.INVALID_ALT_NUMBER;
        this._hasSemanticContext = this._hasSemanticContext || !$8DW9a.SemanticContext.NONE.equals(config.semanticContext);
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $gwEr2(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    canMerge(left, leftKey, right) {
        if (left.state.stateNumber !== right.state.stateNumber) return false;
        if (leftKey.alt !== right.alt) return false;
        return left.semanticContext.equals(right.semanticContext);
    }
    getKey(e) {
        return {
            state: e.state.stateNumber,
            alt: e.alt
        };
    }
    containsAll(c) {
        for (let o of c){
            if (!(o instanceof $9qlOq.ATNConfig)) return false;
            if (!this.contains(o)) return false;
        }
        return true;
    }
    addAll(c, contextCache) {
        this.ensureWritable();
        let changed = false;
        for (let group of c)if (this.add(group, contextCache)) changed = true;
        return changed;
    }
    clear() {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        this.mergedConfigs.clear();
        this.unmerged.length = 0;
        this.configs.length = 0;
        this._dipsIntoOuterContext = false;
        this._hasSemanticContext = false;
        this._uniqueAlt = $lDQMG.ATN.INVALID_ALT_NUMBER;
        this._conflictInfo = undefined;
    }
    equals(obj) {
        if (this === obj) return true;
        if (!(obj instanceof $48368415f2c032d4$var$ATNConfigSet)) return false;
        return this.outermostConfigSet === obj.outermostConfigSet && $g4Hat.equals(this._conflictInfo, obj._conflictInfo) && $crbOk.ArrayEqualityComparator.INSTANCE.equals(this.configs, obj.configs);
    }
    hashCode() {
        if (this.isReadOnly && this.cachedHashCode !== -1) return this.cachedHashCode;
        let hashCode = 1;
        hashCode = 5 * hashCode ^ (this.outermostConfigSet ? 1 : 0);
        hashCode = 5 * hashCode ^ $crbOk.ArrayEqualityComparator.INSTANCE.hashCode(this.configs);
        if (this.isReadOnly) this.cachedHashCode = hashCode;
        return hashCode;
    }
    toString(showContext) {
        if (showContext == null) showContext = false;
        let buf = "";
        let sortedConfigs = this.configs.slice(0);
        sortedConfigs.sort((o1, o2)=>{
            if (o1.alt !== o2.alt) return o1.alt - o2.alt;
            else if (o1.state.stateNumber !== o2.state.stateNumber) return o1.state.stateNumber - o2.state.stateNumber;
            else return o1.semanticContext.toString().localeCompare(o2.semanticContext.toString());
        });
        buf += "[";
        for(let i = 0; i < sortedConfigs.length; i++){
            if (i > 0) buf += ", ";
            buf += sortedConfigs[i].toString(undefined, true, showContext);
        }
        buf += "]";
        if (this._hasSemanticContext) buf += ",hasSemanticContext=" + this._hasSemanticContext;
        if (this._uniqueAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER) buf += ",uniqueAlt=" + this._uniqueAlt;
        if (this._conflictInfo != null) {
            buf += ",conflictingAlts=" + this._conflictInfo.conflictedAlts;
            if (!this._conflictInfo.isExact) buf += "*";
        }
        if (this._dipsIntoOuterContext) buf += ",dipsIntoOuterContext";
        return buf.toString();
    }
    get uniqueAlt() {
        return this._uniqueAlt;
    }
    get hasSemanticContext() {
        return this._hasSemanticContext;
    }
    set hasSemanticContext(value) {
        this.ensureWritable();
        this._hasSemanticContext = value;
    }
    get conflictInfo() {
        return this._conflictInfo;
    }
    set conflictInfo(conflictInfo) {
        this.ensureWritable();
        this._conflictInfo = conflictInfo;
    }
    get conflictingAlts() {
        if (this._conflictInfo == null) return undefined;
        return this._conflictInfo.conflictedAlts;
    }
    get isExactConflict() {
        if (this._conflictInfo == null) return false;
        return this._conflictInfo.isExact;
    }
    get dipsIntoOuterContext() {
        return this._dipsIntoOuterContext;
    }
    get(index) {
        return this.configs[index];
    }
    ensureWritable() {
        if (this.isReadOnly) throw new Error("This ATNConfigSet is read only.");
    }
}
$48368415f2c032d4$var$__decorate([
    $esDFm.NotNull
], $48368415f2c032d4$var$ATNConfigSet.prototype, "getRepresentedAlternatives", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "size", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "isEmpty", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "contains", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, Symbol.iterator, null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "toArray", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "containsAll", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "clear", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "equals", null);
$48368415f2c032d4$var$__decorate([
    $esDFm.Override
], $48368415f2c032d4$var$ATNConfigSet.prototype, "hashCode", null);
module.exports.ATNConfigSet = $48368415f2c032d4$var$ATNConfigSet;

});
parcelRegister("9qlOq", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6dc7763ca4711224$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6dc7763ca4711224$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfig = void 0;

var $dkveu = parcelRequire("dkveu");

var $axZym = parcelRequire("axZym");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $haz8F = parcelRequire("haz8F");

var $8DW9a = parcelRequire("8DW9a");

var $gwEr2 = parcelRequire("gwEr2");
/**
 * This field stores the bit mask for implementing the
 * {@link #isPrecedenceFilterSuppressed} property as a bit within the
 * existing {@link #altAndOuterContextDepth} field.
 */ const $6dc7763ca4711224$var$SUPPRESS_PRECEDENCE_FILTER = 0x80000000;
/**
 * Represents a location with context in an ATN. The location is identified by the following values:
 *
 * * The current ATN state
 * * The predicted alternative
 * * The semantic context which must be true for this configuration to be enabled
 * * The syntactic context, which is represented as a graph-structured stack whose path(s) lead to the root of the rule
 *   invocations leading to this state
 *
 * In addition to these values, `ATNConfig` stores several properties about paths taken to get to the location which
 * were added over time to help with performance, correctness, and/or debugging.
 *
 * * `reachesIntoOuterContext`:: Used to ensure semantic predicates are not evaluated in the wrong context.
 * * `hasPassedThroughNonGreedyDecision`: Used for enabling first-match-wins instead of longest-match-wins after
 *   crossing a non-greedy decision.
 * * `lexerActionExecutor`: Used for tracking the lexer action(s) to execute should this instance be selected during
 *   lexing.
 * * `isPrecedenceFilterSuppressed`: A state variable for one of the dynamic disambiguation strategies employed by
 *   `ParserATNSimulator.applyPrecedenceFilter`.
 *
 * Due to the use of a graph-structured stack, a single `ATNConfig` is capable of representing many individual ATN
 * configurations which reached the same location in an ATN by following different paths.
 *
 * PERF: To conserve memory, `ATNConfig` is split into several different concrete types. `ATNConfig` itself stores the
 * minimum amount of information typically used to define an `ATNConfig` instance. Various derived types provide
 * additional storage space for cases where a non-default value is used for some of the object properties. The
 * `ATNConfig.create` and `ATNConfig.transform` methods automatically select the smallest concrete type capable of
 * representing the unique information for any given `ATNConfig`.
 */ let $6dc7763ca4711224$var$ATNConfig = class ATNConfig {
    constructor(state, altOrConfig, context){
        if (typeof altOrConfig === "number") {
            $gwEr2((altOrConfig & 0xFFFFFF) === altOrConfig);
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig;
            this._context = context;
        } else {
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig.altAndOuterContextDepth;
            this._context = context;
        }
    }
    static create(state, alt, context, semanticContext = $8DW9a.SemanticContext.NONE, lexerActionExecutor) {
        if (semanticContext !== $8DW9a.SemanticContext.NONE) {
            if (lexerActionExecutor != null) return new $6dc7763ca4711224$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, alt, context, false);
            else return new $6dc7763ca4711224$var$SemanticContextATNConfig(semanticContext, state, alt, context);
        } else if (lexerActionExecutor != null) return new $6dc7763ca4711224$var$ActionATNConfig(lexerActionExecutor, state, alt, context, false);
        else return new ATNConfig(state, alt, context);
    }
    /** Gets the ATN state associated with this configuration */ get state() {
        return this._state;
    }
    /** What alt (or lexer rule) is predicted by this configuration */ get alt() {
        return this.altAndOuterContextDepth & 0x00FFFFFF;
    }
    get context() {
        return this._context;
    }
    set context(context) {
        this._context = context;
    }
    get reachesIntoOuterContext() {
        return this.outerContextDepth !== 0;
    }
    /**
     * We cannot execute predicates dependent upon local context unless
     * we know for sure we are in the correct context. Because there is
     * no way to do this efficiently, we simply cannot evaluate
     * dependent predicates unless we are in the rule that initially
     * invokes the ATN simulator.
     *
     * closure() tracks the depth of how far we dip into the outer context:
     * depth &gt; 0.  Note that it may not be totally accurate depth since I
     * don't ever decrement. TODO: make it a boolean then
     */ get outerContextDepth() {
        return this.altAndOuterContextDepth >>> 24 & 0x7F;
    }
    set outerContextDepth(outerContextDepth) {
        $gwEr2(outerContextDepth >= 0);
        // saturate at 0x7F - everything but zero/positive is only used for debug information anyway
        outerContextDepth = Math.min(outerContextDepth, 0x7F);
        this.altAndOuterContextDepth = outerContextDepth << 24 | (this.altAndOuterContextDepth & -2130706433) >>> 0;
    }
    get lexerActionExecutor() {
        return undefined;
    }
    get semanticContext() {
        return $8DW9a.SemanticContext.NONE;
    }
    get hasPassedThroughNonGreedyDecision() {
        return false;
    }
    clone() {
        return this.transform(this.state, false);
    }
    transform(/*@NotNull*/ state, checkNonGreedy, arg2) {
        if (arg2 == null) return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $haz8F.PredictionContext) return this.transformImpl(state, arg2, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $8DW9a.SemanticContext) return this.transformImpl(state, this._context, arg2, checkNonGreedy, this.lexerActionExecutor);
        else return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, arg2);
    }
    transformImpl(state, context, semanticContext, checkNonGreedy, lexerActionExecutor) {
        let passedThroughNonGreedy = checkNonGreedy && ATNConfig.checkNonGreedyDecision(this, state);
        if (semanticContext !== $8DW9a.SemanticContext.NONE) {
            if (lexerActionExecutor != null || passedThroughNonGreedy) return new $6dc7763ca4711224$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, this, context, passedThroughNonGreedy);
            else return new $6dc7763ca4711224$var$SemanticContextATNConfig(semanticContext, state, this, context);
        } else if (lexerActionExecutor != null || passedThroughNonGreedy) return new $6dc7763ca4711224$var$ActionATNConfig(lexerActionExecutor, state, this, context, passedThroughNonGreedy);
        else return new ATNConfig(state, this, context);
    }
    static checkNonGreedyDecision(source, target) {
        return source.hasPassedThroughNonGreedyDecision || target instanceof $axZym.DecisionState && target.nonGreedy;
    }
    appendContext(context, contextCache) {
        if (typeof context === "number") {
            let appendedContext = this.context.appendSingleContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        } else {
            let appendedContext = this.context.appendContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        }
    }
    /**
     * Determines if this `ATNConfig` fully contains another `ATNConfig`.
     *
     * An ATN configuration represents a position (including context) in an ATN during parsing. Since `ATNConfig` stores
     * the context as a graph, a single `ATNConfig` instance is capable of representing many ATN configurations which
     * are all in the same "location" but have different contexts. These `ATNConfig` instances are again merged when
     * they are added to an `ATNConfigSet`. This method supports `ATNConfigSet.contains` by evaluating whether a
     * particular `ATNConfig` contains all of the ATN configurations represented by another `ATNConfig`.
     *
     * An `ATNConfig` _a_ contains another `ATNConfig` _b_ if all of the following conditions are met:
     *
     * * The configurations are in the same state (`state`)
     * * The configurations predict the same alternative (`alt`)
     * * The semantic context of _a_ implies the semantic context of _b_ (this method performs a weaker equality check)
     * * Joining the prediction contexts of _a_ and _b_ results in the prediction context of _a_
     *
     * This method implements a conservative approximation of containment. As a result, when this method returns `true`
     * it is known that parsing from `subconfig` can only recognize a subset of the inputs which can be recognized
     * starting at the current `ATNConfig`. However, due to the imprecise evaluation of implication for the semantic
     * contexts, no assumptions can be made about the relationship between the configurations when this method returns
     * `false`.
     *
     * @param subconfig The sub configuration.
     * @returns `true` if this configuration contains `subconfig`; otherwise, `false`.
     */ contains(subconfig) {
        if (this.state.stateNumber !== subconfig.state.stateNumber || this.alt !== subconfig.alt || !this.semanticContext.equals(subconfig.semanticContext)) return false;
        let leftWorkList = [];
        let rightWorkList = [];
        leftWorkList.push(this.context);
        rightWorkList.push(subconfig.context);
        while(true){
            let left = leftWorkList.pop();
            let right = rightWorkList.pop();
            if (!left || !right) break;
            if (left === right) return true;
            if (left.size < right.size) return false;
            if (right.isEmpty) return left.hasEmpty;
            else for(let i = 0; i < right.size; i++){
                let index = left.findReturnState(right.getReturnState(i));
                if (index < 0) // assumes invokingStates has no duplicate entries
                return false;
                leftWorkList.push(left.getParent(index));
                rightWorkList.push(right.getParent(i));
            }
        }
        return false;
    }
    get isPrecedenceFilterSuppressed() {
        return (this.altAndOuterContextDepth & $6dc7763ca4711224$var$SUPPRESS_PRECEDENCE_FILTER) !== 0;
    }
    set isPrecedenceFilterSuppressed(value) {
        if (value) this.altAndOuterContextDepth |= $6dc7763ca4711224$var$SUPPRESS_PRECEDENCE_FILTER;
        else this.altAndOuterContextDepth &= ~$6dc7763ca4711224$var$SUPPRESS_PRECEDENCE_FILTER;
    }
    /** An ATN configuration is equal to another if both have
     *  the same state, they predict the same alternative, and
     *  syntactic/semantic contexts are the same.
     */ equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ATNConfig)) return false;
        return this.state.stateNumber === o.state.stateNumber && this.alt === o.alt && this.reachesIntoOuterContext === o.reachesIntoOuterContext && this.context.equals(o.context) && this.semanticContext.equals(o.semanticContext) && this.isPrecedenceFilterSuppressed === o.isPrecedenceFilterSuppressed && this.hasPassedThroughNonGreedyDecision === o.hasPassedThroughNonGreedyDecision && $73sQO.ObjectEqualityComparator.INSTANCE.equals(this.lexerActionExecutor, o.lexerActionExecutor);
    }
    hashCode() {
        let hashCode = $i99P2.MurmurHash.initialize(7);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.state.stateNumber);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.alt);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.reachesIntoOuterContext ? 1 : 0);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.context);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.semanticContext);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.hasPassedThroughNonGreedyDecision ? 1 : 0);
        hashCode = $i99P2.MurmurHash.update(hashCode, this.lexerActionExecutor);
        hashCode = $i99P2.MurmurHash.finish(hashCode, 7);
        return hashCode;
    }
    /**
     * Returns a graphical representation of the current `ATNConfig` in Graphviz format. The graph can be stored to a
     * **.dot** file and then rendered to an image using Graphviz.
     *
     * @returns A Graphviz graph representing the current `ATNConfig`.
     *
     * @see http://www.graphviz.org/
     */ toDotString() {
        let builder = "";
        builder += "digraph G {\n";
        builder += "rankdir=LR;\n";
        let visited = new $dkveu.Array2DHashMap($haz8F.PredictionContext.IdentityEqualityComparator.INSTANCE);
        let workList = [];
        function getOrAddContext(context) {
            let newNumber = visited.size;
            let result = visited.putIfAbsent(context, newNumber);
            if (result != null) // Already saw this context
            return result;
            workList.push(context);
            return newNumber;
        }
        workList.push(this.context);
        visited.put(this.context, 0);
        while(true){
            let current = workList.pop();
            if (!current) break;
            for(let i = 0; i < current.size; i++){
                builder += "  s" + getOrAddContext(current);
                builder += "->";
                builder += "s" + getOrAddContext(current.getParent(i));
                builder += "[label=\"" + current.getReturnState(i) + "\"];\n";
            }
        }
        builder += "}\n";
        return builder.toString();
    }
    toString(recog, showAlt, showContext) {
        // Must check showContext before showAlt to preserve original overload behavior
        if (showContext == null) showContext = showAlt != null;
        if (showAlt == null) showAlt = true;
        let buf = "";
        // if (this.state.ruleIndex >= 0) {
        // 	if (recog != null) {
        // 		buf += (recog.ruleNames[this.state.ruleIndex] + ":");
        // 	} else {
        // 		buf += (this.state.ruleIndex + ":");
        // 	}
        // }
        let contexts;
        if (showContext) contexts = this.context.toStrings(recog, this.state.stateNumber);
        else contexts = [
            "?"
        ];
        let first = true;
        for (let contextDesc of contexts){
            if (first) first = false;
            else buf += ", ";
            buf += "(";
            buf += this.state;
            if (showAlt) {
                buf += ",";
                buf += this.alt;
            }
            if (this.context) {
                buf += ",";
                buf += contextDesc;
            }
            if (this.semanticContext !== $8DW9a.SemanticContext.NONE) {
                buf += ",";
                buf += this.semanticContext;
            }
            if (this.reachesIntoOuterContext) buf += ",up=" + this.outerContextDepth;
            buf += ")";
        }
        return buf.toString();
    }
};
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull
], $6dc7763ca4711224$var$ATNConfig.prototype, "_state", void 0);
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull
], $6dc7763ca4711224$var$ATNConfig.prototype, "_context", void 0);
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull
], $6dc7763ca4711224$var$ATNConfig.prototype, "state", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull,
    $6dc7763ca4711224$var$__param(0, $esDFm.NotNull)
], $6dc7763ca4711224$var$ATNConfig.prototype, "context", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull
], $6dc7763ca4711224$var$ATNConfig.prototype, "semanticContext", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ATNConfig.prototype, "clone", null);
$6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(0, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(2, $esDFm.NotNull)
], $6dc7763ca4711224$var$ATNConfig.prototype, "transformImpl", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ATNConfig.prototype, "equals", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ATNConfig.prototype, "hashCode", null);
$6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(0, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(3, $esDFm.NotNull)
], $6dc7763ca4711224$var$ATNConfig, "create", null);
$6dc7763ca4711224$var$ATNConfig = $6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(0, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(2, $esDFm.NotNull)
], $6dc7763ca4711224$var$ATNConfig);
module.exports.ATNConfig = $6dc7763ca4711224$var$ATNConfig;
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $6dc7763ca4711224$var$SemanticContextATNConfig = class SemanticContextATNConfig extends $6dc7763ca4711224$var$ATNConfig {
    constructor(semanticContext, state, altOrConfig, context){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else super(state, altOrConfig, context);
        this._semanticContext = semanticContext;
    }
    get semanticContext() {
        return this._semanticContext;
    }
};
$6dc7763ca4711224$var$__decorate([
    $esDFm.NotNull
], $6dc7763ca4711224$var$SemanticContextATNConfig.prototype, "_semanticContext", void 0);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$SemanticContextATNConfig.prototype, "semanticContext", null);
$6dc7763ca4711224$var$SemanticContextATNConfig = $6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(1, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(2, $esDFm.NotNull)
], $6dc7763ca4711224$var$SemanticContextATNConfig);
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a lexer action.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $6dc7763ca4711224$var$ActionATNConfig = class ActionATNConfig extends $6dc7763ca4711224$var$ATNConfig {
    constructor(lexerActionExecutor, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else {
            super(state, altOrConfig, context);
            if (altOrConfig.semanticContext !== $8DW9a.SemanticContext.NONE) throw new Error("Not supported");
        }
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ActionATNConfig.prototype, "lexerActionExecutor", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ActionATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$6dc7763ca4711224$var$ActionATNConfig = $6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(1, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(2, $esDFm.NotNull)
], $6dc7763ca4711224$var$ActionATNConfig);
/**
 * This class was derived from `SemanticContextATNConfig` purely as a memory optimization. It allows for the creation of
 * an `ATNConfig` with both a lexer action and a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $6dc7763ca4711224$var$ActionSemanticContextATNConfig = class ActionSemanticContextATNConfig extends $6dc7763ca4711224$var$SemanticContextATNConfig {
    constructor(lexerActionExecutor, semanticContext, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(semanticContext, state, altOrConfig, context);
        else super(semanticContext, state, altOrConfig, context);
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ActionSemanticContextATNConfig.prototype, "lexerActionExecutor", null);
$6dc7763ca4711224$var$__decorate([
    $esDFm.Override
], $6dc7763ca4711224$var$ActionSemanticContextATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$6dc7763ca4711224$var$ActionSemanticContextATNConfig = $6dc7763ca4711224$var$__decorate([
    $6dc7763ca4711224$var$__param(1, $esDFm.NotNull),
    $6dc7763ca4711224$var$__param(2, $esDFm.NotNull)
], $6dc7763ca4711224$var$ActionSemanticContextATNConfig);

});
parcelRegister("axZym", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionState = void 0;

var $17Oz4 = parcelRequire("17Oz4");
class $7adcbba0a09e732a$var$DecisionState extends $17Oz4.ATNState {
    constructor(){
        super(...arguments);
        this.decision = -1;
        this.nonGreedy = false;
        this.sll = false;
    }
}
module.exports.DecisionState = $7adcbba0a09e732a$var$DecisionState;

});

parcelRegister("haz8F", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c7fea0a7ff7ccaf2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c7fea0a7ff7ccaf2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SingletonPredictionContext = module.exports.PredictionContext = void 0;

var $dkveu = parcelRequire("dkveu");

var $fJumX = parcelRequire("fJumX");

var $yEtb9 = parcelRequire("yEtb9");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $8Uwhy = parcelRequire("8Uwhy");

var $gwEr2 = parcelRequire("gwEr2");
const $c7fea0a7ff7ccaf2$var$INITIAL_HASH = 1;
class $c7fea0a7ff7ccaf2$var$PredictionContext {
    constructor(cachedHashCode){
        this.cachedHashCode = cachedHashCode;
    }
    static calculateEmptyHashCode() {
        let hash = $i99P2.MurmurHash.initialize($c7fea0a7ff7ccaf2$var$INITIAL_HASH);
        hash = $i99P2.MurmurHash.finish(hash, 0);
        return hash;
    }
    static calculateSingleHashCode(parent, returnState) {
        let hash = $i99P2.MurmurHash.initialize($c7fea0a7ff7ccaf2$var$INITIAL_HASH);
        hash = $i99P2.MurmurHash.update(hash, parent);
        hash = $i99P2.MurmurHash.update(hash, returnState);
        hash = $i99P2.MurmurHash.finish(hash, 2);
        return hash;
    }
    static calculateHashCode(parents, returnStates) {
        let hash = $i99P2.MurmurHash.initialize($c7fea0a7ff7ccaf2$var$INITIAL_HASH);
        for (let parent of parents)hash = $i99P2.MurmurHash.update(hash, parent);
        for (let returnState of returnStates)hash = $i99P2.MurmurHash.update(hash, returnState);
        hash = $i99P2.MurmurHash.finish(hash, 2 * parents.length);
        return hash;
    }
    static fromRuleContext(atn, outerContext, fullContext = true) {
        if (outerContext.isEmpty) return fullContext ? $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL : $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_LOCAL;
        let parent;
        if (outerContext._parent) parent = $c7fea0a7ff7ccaf2$var$PredictionContext.fromRuleContext(atn, outerContext._parent, fullContext);
        else parent = fullContext ? $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL : $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_LOCAL;
        let state = atn.states[outerContext.invokingState];
        let transition = state.transition(0);
        return parent.getChild(transition.followState.stateNumber);
    }
    static addEmptyContext(context) {
        return context.addEmptyContext();
    }
    static removeEmptyContext(context) {
        return context.removeEmptyContext();
    }
    static join(context0, context1, contextCache = $8Uwhy.PredictionContextCache.UNCACHED) {
        if (context0 === context1) return context0;
        if (context0.isEmpty) return $c7fea0a7ff7ccaf2$var$PredictionContext.isEmptyLocal(context0) ? context0 : $c7fea0a7ff7ccaf2$var$PredictionContext.addEmptyContext(context1);
        else if (context1.isEmpty) return $c7fea0a7ff7ccaf2$var$PredictionContext.isEmptyLocal(context1) ? context1 : $c7fea0a7ff7ccaf2$var$PredictionContext.addEmptyContext(context0);
        let context0size = context0.size;
        let context1size = context1.size;
        if (context0size === 1 && context1size === 1 && context0.getReturnState(0) === context1.getReturnState(0)) {
            let merged = contextCache.join(context0.getParent(0), context1.getParent(0));
            if (merged === context0.getParent(0)) return context0;
            else if (merged === context1.getParent(0)) return context1;
            else return merged.getChild(context0.getReturnState(0));
        }
        let count = 0;
        let parentsList = new Array(context0size + context1size);
        let returnStatesList = new Array(parentsList.length);
        let leftIndex = 0;
        let rightIndex = 0;
        let canReturnLeft = true;
        let canReturnRight = true;
        while(leftIndex < context0size && rightIndex < context1size){
            if (context0.getReturnState(leftIndex) === context1.getReturnState(rightIndex)) {
                parentsList[count] = contextCache.join(context0.getParent(leftIndex), context1.getParent(rightIndex));
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnLeft = canReturnLeft && parentsList[count] === context0.getParent(leftIndex);
                canReturnRight = canReturnRight && parentsList[count] === context1.getParent(rightIndex);
                leftIndex++;
                rightIndex++;
            } else if (context0.getReturnState(leftIndex) < context1.getReturnState(rightIndex)) {
                parentsList[count] = context0.getParent(leftIndex);
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnRight = false;
                leftIndex++;
            } else {
                $gwEr2(context1.getReturnState(rightIndex) < context0.getReturnState(leftIndex));
                parentsList[count] = context1.getParent(rightIndex);
                returnStatesList[count] = context1.getReturnState(rightIndex);
                canReturnLeft = false;
                rightIndex++;
            }
            count++;
        }
        while(leftIndex < context0size){
            parentsList[count] = context0.getParent(leftIndex);
            returnStatesList[count] = context0.getReturnState(leftIndex);
            leftIndex++;
            canReturnRight = false;
            count++;
        }
        while(rightIndex < context1size){
            parentsList[count] = context1.getParent(rightIndex);
            returnStatesList[count] = context1.getReturnState(rightIndex);
            rightIndex++;
            canReturnLeft = false;
            count++;
        }
        if (canReturnLeft) return context0;
        else if (canReturnRight) return context1;
        if (count < parentsList.length) {
            parentsList = parentsList.slice(0, count);
            returnStatesList = returnStatesList.slice(0, count);
        }
        if (parentsList.length === 0) // if one of them was EMPTY_LOCAL, it would be empty and handled at the beginning of the method
        return $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL;
        else if (parentsList.length === 1) return new $c7fea0a7ff7ccaf2$var$SingletonPredictionContext(parentsList[0], returnStatesList[0]);
        else return new $c7fea0a7ff7ccaf2$var$ArrayPredictionContext(parentsList, returnStatesList);
    }
    static isEmptyLocal(context) {
        return context === $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_LOCAL;
    }
    static getCachedContext(context, contextCache, visited) {
        if (context.isEmpty) return context;
        let existing = visited.get(context);
        if (existing) return existing;
        existing = contextCache.get(context);
        if (existing) {
            visited.put(context, existing);
            return existing;
        }
        let changed = false;
        let parents = new Array(context.size);
        for(let i = 0; i < parents.length; i++){
            let parent = $c7fea0a7ff7ccaf2$var$PredictionContext.getCachedContext(context.getParent(i), contextCache, visited);
            if (changed || parent !== context.getParent(i)) {
                if (!changed) {
                    parents = new Array(context.size);
                    for(let j = 0; j < context.size; j++)parents[j] = context.getParent(j);
                    changed = true;
                }
                parents[i] = parent;
            }
        }
        if (!changed) {
            existing = contextCache.putIfAbsent(context, context);
            visited.put(context, existing != null ? existing : context);
            return context;
        }
        // We know parents.length>0 because context.isEmpty is checked at the beginning of the method.
        let updated;
        if (parents.length === 1) updated = new $c7fea0a7ff7ccaf2$var$SingletonPredictionContext(parents[0], context.getReturnState(0));
        else {
            let returnStates = new Array(context.size);
            for(let i = 0; i < context.size; i++)returnStates[i] = context.getReturnState(i);
            updated = new $c7fea0a7ff7ccaf2$var$ArrayPredictionContext(parents, returnStates, context.hashCode());
        }
        existing = contextCache.putIfAbsent(updated, updated);
        visited.put(updated, existing || updated);
        visited.put(context, existing || updated);
        return updated;
    }
    appendSingleContext(returnContext, contextCache) {
        return this.appendContext($c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL.getChild(returnContext), contextCache);
    }
    getChild(returnState) {
        return new $c7fea0a7ff7ccaf2$var$SingletonPredictionContext(this, returnState);
    }
    hashCode() {
        return this.cachedHashCode;
    }
    toStrings(recognizer, currentState, stop = $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL) {
        let result = [];
        outer: for(let perm = 0;; perm++){
            let offset = 0;
            let last = true;
            let p = this;
            let stateNumber = currentState;
            let localBuffer = "";
            localBuffer += "[";
            while(!p.isEmpty && p !== stop){
                let index = 0;
                if (p.size > 0) {
                    let bits = 1;
                    while(1 << bits >>> 0 < p.size)bits++;
                    let mask = (1 << bits >>> 0) - 1;
                    index = perm >> offset & mask;
                    last = last && index >= p.size - 1;
                    if (index >= p.size) continue outer;
                    offset += bits;
                }
                if (recognizer) {
                    if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                    localBuffer += " ";
                    let atn = recognizer.atn;
                    let s = atn.states[stateNumber];
                    let ruleName = recognizer.ruleNames[s.ruleIndex];
                    localBuffer += ruleName;
                } else if (p.getReturnState(index) !== $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL_STATE_KEY) {
                    if (!p.isEmpty) {
                        if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                        localBuffer += " ";
                        localBuffer += p.getReturnState(index);
                    }
                }
                stateNumber = p.getReturnState(index);
                p = p.getParent(index);
            }
            localBuffer += "]";
            result.push(localBuffer);
            if (last) break;
        }
        return result;
    }
}
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$PredictionContext.prototype, "hashCode", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $c7fea0a7ff7ccaf2$var$__param(0, $esDFm.NotNull),
    $c7fea0a7ff7ccaf2$var$__param(1, $esDFm.NotNull),
    $c7fea0a7ff7ccaf2$var$__param(2, $esDFm.NotNull)
], $c7fea0a7ff7ccaf2$var$PredictionContext, "join", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $c7fea0a7ff7ccaf2$var$__param(0, $esDFm.NotNull),
    $c7fea0a7ff7ccaf2$var$__param(1, $esDFm.NotNull),
    $c7fea0a7ff7ccaf2$var$__param(2, $esDFm.NotNull)
], $c7fea0a7ff7ccaf2$var$PredictionContext, "getCachedContext", null);
module.exports.PredictionContext = $c7fea0a7ff7ccaf2$var$PredictionContext;
class $c7fea0a7ff7ccaf2$var$EmptyPredictionContext extends $c7fea0a7ff7ccaf2$var$PredictionContext {
    constructor(fullContext){
        super($c7fea0a7ff7ccaf2$var$PredictionContext.calculateEmptyHashCode());
        this.fullContext = fullContext;
    }
    get isFullContext() {
        return this.fullContext;
    }
    addEmptyContext() {
        return this;
    }
    removeEmptyContext() {
        throw new Error("Cannot remove the empty context from itself.");
    }
    getParent(index) {
        throw new Error("index out of bounds");
    }
    getReturnState(index) {
        throw new Error("index out of bounds");
    }
    findReturnState(returnState) {
        return -1;
    }
    get size() {
        return 0;
    }
    appendSingleContext(returnContext, contextCache) {
        return contextCache.getChild(this, returnContext);
    }
    appendContext(suffix, contextCache) {
        return suffix;
    }
    get isEmpty() {
        return true;
    }
    get hasEmpty() {
        return true;
    }
    equals(o) {
        return this === o;
    }
    toStrings(recognizer, currentState, stop) {
        return [
            "[]"
        ];
    }
}
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "addEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "removeEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "getParent", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "getReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "findReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "size", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "appendSingleContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "appendContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "isEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "hasEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "equals", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$EmptyPredictionContext.prototype, "toStrings", null);
let $c7fea0a7ff7ccaf2$var$ArrayPredictionContext = class ArrayPredictionContext extends $c7fea0a7ff7ccaf2$var$PredictionContext {
    constructor(parents, returnStates, hashCode){
        super(hashCode || $c7fea0a7ff7ccaf2$var$PredictionContext.calculateHashCode(parents, returnStates));
        $gwEr2(parents.length === returnStates.length);
        $gwEr2(returnStates.length > 1 || returnStates[0] !== $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL_STATE_KEY, "Should be using PredictionContext.EMPTY instead.");
        this.parents = parents;
        this.returnStates = returnStates;
    }
    getParent(index) {
        return this.parents[index];
    }
    getReturnState(index) {
        return this.returnStates[index];
    }
    findReturnState(returnState) {
        return $yEtb9.Arrays.binarySearch(this.returnStates, returnState);
    }
    get size() {
        return this.returnStates.length;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return this.returnStates[this.returnStates.length - 1] === $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL_STATE_KEY;
    }
    addEmptyContext() {
        if (this.hasEmpty) return this;
        let parents2 = this.parents.slice(0);
        let returnStates2 = this.returnStates.slice(0);
        parents2.push($c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL);
        returnStates2.push($c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL_STATE_KEY);
        return new ArrayPredictionContext(parents2, returnStates2);
    }
    removeEmptyContext() {
        if (!this.hasEmpty) return this;
        if (this.returnStates.length === 2) return new $c7fea0a7ff7ccaf2$var$SingletonPredictionContext(this.parents[0], this.returnStates[0]);
        else {
            let parents2 = this.parents.slice(0, this.parents.length - 1);
            let returnStates2 = this.returnStates.slice(0, this.returnStates.length - 1);
            return new ArrayPredictionContext(parents2, returnStates2);
        }
    }
    appendContext(suffix, contextCache) {
        return ArrayPredictionContext.appendContextImpl(this, suffix, new $c7fea0a7ff7ccaf2$var$PredictionContext.IdentityHashMap());
    }
    static appendContextImpl(context, suffix, visited) {
        if (suffix.isEmpty) {
            if ($c7fea0a7ff7ccaf2$var$PredictionContext.isEmptyLocal(suffix)) {
                if (context.hasEmpty) return $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_LOCAL;
                throw new Error("what to do here?");
            }
            return context;
        }
        if (suffix.size !== 1) throw new Error("Appending a tree suffix is not yet supported.");
        let result = visited.get(context);
        if (!result) {
            if (context.isEmpty) result = suffix;
            else {
                let parentCount = context.size;
                if (context.hasEmpty) parentCount--;
                let updatedParents = new Array(parentCount);
                let updatedReturnStates = new Array(parentCount);
                for(let i = 0; i < parentCount; i++)updatedReturnStates[i] = context.getReturnState(i);
                for(let i = 0; i < parentCount; i++)updatedParents[i] = ArrayPredictionContext.appendContextImpl(context.getParent(i), suffix, visited);
                if (updatedParents.length === 1) result = new $c7fea0a7ff7ccaf2$var$SingletonPredictionContext(updatedParents[0], updatedReturnStates[0]);
                else {
                    $gwEr2(updatedParents.length > 1);
                    result = new ArrayPredictionContext(updatedParents, updatedReturnStates);
                }
                if (context.hasEmpty) result = $c7fea0a7ff7ccaf2$var$PredictionContext.join(result, suffix);
            }
            visited.put(context, result);
        }
        return result;
    }
    equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ArrayPredictionContext)) return false;
        if (this.hashCode() !== o.hashCode()) // can't be same if hash is different
        return false;
        let other = o;
        return this.equalsImpl(other, new $fJumX.Array2DHashSet());
    }
    equalsImpl(other, visited) {
        let selfWorkList = [];
        let otherWorkList = [];
        selfWorkList.push(this);
        otherWorkList.push(other);
        while(true){
            let currentSelf = selfWorkList.pop();
            let currentOther = otherWorkList.pop();
            if (!currentSelf || !currentOther) break;
            let operands = new $8Uwhy.PredictionContextCache.IdentityCommutativePredictionContextOperands(currentSelf, currentOther);
            if (!visited.add(operands)) continue;
            let selfSize = operands.x.size;
            if (selfSize === 0) {
                if (!operands.x.equals(operands.y)) return false;
                continue;
            }
            let otherSize = operands.y.size;
            if (selfSize !== otherSize) return false;
            for(let i = 0; i < selfSize; i++){
                if (operands.x.getReturnState(i) !== operands.y.getReturnState(i)) return false;
                let selfParent = operands.x.getParent(i);
                let otherParent = operands.y.getParent(i);
                if (selfParent.hashCode() !== otherParent.hashCode()) return false;
                if (selfParent !== otherParent) {
                    selfWorkList.push(selfParent);
                    otherWorkList.push(otherParent);
                }
            }
        }
        return true;
    }
};
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.NotNull
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "parents", void 0);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.NotNull
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "returnStates", void 0);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "getParent", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "getReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "findReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "size", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "isEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "hasEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "addEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "removeEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "appendContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext.prototype, "equals", null);
$c7fea0a7ff7ccaf2$var$ArrayPredictionContext = $c7fea0a7ff7ccaf2$var$__decorate([
    $c7fea0a7ff7ccaf2$var$__param(0, $esDFm.NotNull)
], $c7fea0a7ff7ccaf2$var$ArrayPredictionContext);
let $c7fea0a7ff7ccaf2$var$SingletonPredictionContext = class SingletonPredictionContext extends $c7fea0a7ff7ccaf2$var$PredictionContext {
    constructor(parent, returnState){
        super($c7fea0a7ff7ccaf2$var$PredictionContext.calculateSingleHashCode(parent, returnState));
        // assert(returnState != PredictionContext.EMPTY_FULL_STATE_KEY && returnState != PredictionContext.EMPTY_LOCAL_STATE_KEY);
        this.parent = parent;
        this.returnState = returnState;
    }
    getParent(index) {
        // assert(index == 0);
        return this.parent;
    }
    getReturnState(index) {
        // assert(index == 0);
        return this.returnState;
    }
    findReturnState(returnState) {
        return this.returnState === returnState ? 0 : -1;
    }
    get size() {
        return 1;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return false;
    }
    appendContext(suffix, contextCache) {
        return contextCache.getChild(this.parent.appendContext(suffix, contextCache), this.returnState);
    }
    addEmptyContext() {
        let parents = [
            this.parent,
            $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL
        ];
        let returnStates = [
            this.returnState,
            $c7fea0a7ff7ccaf2$var$PredictionContext.EMPTY_FULL_STATE_KEY
        ];
        return new $c7fea0a7ff7ccaf2$var$ArrayPredictionContext(parents, returnStates);
    }
    removeEmptyContext() {
        return this;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof SingletonPredictionContext)) return false;
        let other = o;
        if (this.hashCode() !== other.hashCode()) return false;
        return this.returnState === other.returnState && this.parent.equals(other.parent);
    }
};
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.NotNull
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "parent", void 0);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "getParent", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "getReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "findReturnState", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "size", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "isEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "hasEmpty", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "appendContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "addEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "removeEmptyContext", null);
$c7fea0a7ff7ccaf2$var$__decorate([
    $esDFm.Override
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext.prototype, "equals", null);
$c7fea0a7ff7ccaf2$var$SingletonPredictionContext = $c7fea0a7ff7ccaf2$var$__decorate([
    $c7fea0a7ff7ccaf2$var$__param(0, $esDFm.NotNull)
], $c7fea0a7ff7ccaf2$var$SingletonPredictionContext);
module.exports.SingletonPredictionContext = $c7fea0a7ff7ccaf2$var$SingletonPredictionContext;
(function(PredictionContext) {
    PredictionContext.EMPTY_LOCAL = new $c7fea0a7ff7ccaf2$var$EmptyPredictionContext(false);
    PredictionContext.EMPTY_FULL = new $c7fea0a7ff7ccaf2$var$EmptyPredictionContext(true);
    PredictionContext.EMPTY_LOCAL_STATE_KEY = -2147483648;
    PredictionContext.EMPTY_FULL_STATE_KEY = 2147483647;
    class IdentityHashMap extends $dkveu.Array2DHashMap {
        constructor(){
            super(IdentityEqualityComparator.INSTANCE);
        }
    }
    PredictionContext.IdentityHashMap = IdentityHashMap;
    class IdentityEqualityComparator {
        IdentityEqualityComparator() {
        // intentionally empty
        }
        hashCode(obj) {
            return obj.hashCode();
        }
        equals(a, b) {
            return a === b;
        }
    }
    IdentityEqualityComparator.INSTANCE = new IdentityEqualityComparator();
    $c7fea0a7ff7ccaf2$var$__decorate([
        $esDFm.Override
    ], IdentityEqualityComparator.prototype, "hashCode", null);
    $c7fea0a7ff7ccaf2$var$__decorate([
        $esDFm.Override
    ], IdentityEqualityComparator.prototype, "equals", null);
    PredictionContext.IdentityEqualityComparator = IdentityEqualityComparator;
})($c7fea0a7ff7ccaf2$var$PredictionContext = module.exports.PredictionContext || (module.exports.PredictionContext = {}));

});
parcelRegister("8Uwhy", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $67cc983af147926c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionContextCache = void 0;

var $dkveu = parcelRequire("dkveu");

var $esDFm = parcelRequire("esDFm");

var $73sQO = parcelRequire("73sQO");

var $haz8F = parcelRequire("haz8F");

var $gwEr2 = parcelRequire("gwEr2");
/** Used to cache {@link PredictionContext} objects. Its used for the shared
 *  context cash associated with contexts in DFA states. This cache
 *  can be used for both lexers and parsers.
 *
 * @author Sam Harwell
 */ class $67cc983af147926c$var$PredictionContextCache {
    constructor(enableCache = true){
        this.contexts = new $dkveu.Array2DHashMap($73sQO.ObjectEqualityComparator.INSTANCE);
        this.childContexts = new $dkveu.Array2DHashMap($73sQO.ObjectEqualityComparator.INSTANCE);
        this.joinContexts = new $dkveu.Array2DHashMap($73sQO.ObjectEqualityComparator.INSTANCE);
        this.enableCache = enableCache;
    }
    getAsCached(context) {
        if (!this.enableCache) return context;
        let result = this.contexts.get(context);
        if (!result) {
            result = context;
            this.contexts.put(context, context);
        }
        return result;
    }
    getChild(context, invokingState) {
        if (!this.enableCache) return context.getChild(invokingState);
        let operands = new $67cc983af147926c$var$PredictionContextCache.PredictionContextAndInt(context, invokingState);
        let result = this.childContexts.get(operands);
        if (!result) {
            result = context.getChild(invokingState);
            result = this.getAsCached(result);
            this.childContexts.put(operands, result);
        }
        return result;
    }
    join(x, y) {
        if (!this.enableCache) return $haz8F.PredictionContext.join(x, y, this);
        let operands = new $67cc983af147926c$var$PredictionContextCache.IdentityCommutativePredictionContextOperands(x, y);
        let result = this.joinContexts.get(operands);
        if (result) return result;
        result = $haz8F.PredictionContext.join(x, y, this);
        result = this.getAsCached(result);
        this.joinContexts.put(operands, result);
        return result;
    }
}
module.exports.PredictionContextCache = $67cc983af147926c$var$PredictionContextCache;
$67cc983af147926c$var$PredictionContextCache.UNCACHED = new $67cc983af147926c$var$PredictionContextCache(false);
(function(PredictionContextCache) {
    class PredictionContextAndInt {
        constructor(obj, value){
            this.obj = obj;
            this.value = value;
        }
        equals(obj) {
            if (!(obj instanceof PredictionContextAndInt)) return false;
            else if (obj === this) return true;
            let other = obj;
            return this.value === other.value && (this.obj === other.obj || this.obj != null && this.obj.equals(other.obj));
        }
        hashCode() {
            let hashCode = 5;
            hashCode = 7 * hashCode + (this.obj != null ? this.obj.hashCode() : 0);
            hashCode = 7 * hashCode + this.value;
            return hashCode;
        }
    }
    $67cc983af147926c$var$__decorate([
        $esDFm.Override
    ], PredictionContextAndInt.prototype, "equals", null);
    $67cc983af147926c$var$__decorate([
        $esDFm.Override
    ], PredictionContextAndInt.prototype, "hashCode", null);
    PredictionContextCache.PredictionContextAndInt = PredictionContextAndInt;
    class IdentityCommutativePredictionContextOperands {
        constructor(x, y){
            $gwEr2(x != null);
            $gwEr2(y != null);
            this._x = x;
            this._y = y;
        }
        get x() {
            return this._x;
        }
        get y() {
            return this._y;
        }
        equals(o) {
            if (!(o instanceof IdentityCommutativePredictionContextOperands)) return false;
            else if (this === o) return true;
            let other = o;
            return this._x === other._x && this._y === other._y || this._x === other._y && this._y === other._x;
        }
        hashCode() {
            return this._x.hashCode() ^ this._y.hashCode();
        }
    }
    $67cc983af147926c$var$__decorate([
        $esDFm.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "equals", null);
    $67cc983af147926c$var$__decorate([
        $esDFm.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "hashCode", null);
    PredictionContextCache.IdentityCommutativePredictionContextOperands = IdentityCommutativePredictionContextOperands;
})($67cc983af147926c$var$PredictionContextCache = module.exports.PredictionContextCache || (module.exports.PredictionContextCache = {}));

});



parcelRegister("lVdCV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BitSet = void 0;

var $7WF8Y = parcelRequire("7WF8Y");

var $i99P2 = parcelRequire("i99P2");
/**
 * Private empty array used to construct empty BitSets
 */ const $ff597dd62e8c3e1d$var$EMPTY_DATA = new Uint16Array(0);
/**
 * Gets the word index of the `UInt16` element in `BitSet.data` containing the bit with the specified index.
 */ function $ff597dd62e8c3e1d$var$getIndex(bitNumber) {
    return bitNumber >>> 4;
}
/**
 * Convert a word index into the bit index of the LSB of that word
 */ function $ff597dd62e8c3e1d$var$unIndex(n) {
    return n * 16;
}
/**
 * Get's the bit number of the least signficant bit set LSB which is set in a word non-zero word;
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $ff597dd62e8c3e1d$var$findLSBSet(word) {
    let bit = 1;
    for(let i = 0; i < 16; i++){
        if ((word & bit) !== 0) return i;
        bit = bit << 1 >>> 0;
    }
    throw new RangeError("No specified bit found");
}
function $ff597dd62e8c3e1d$var$findMSBSet(word) {
    let bit = 32768;
    for(let i = 15; i >= 0; i--){
        if ((word & bit) !== 0) return i;
        bit = bit >>> 1;
    }
    throw new RangeError("No specified bit found");
}
/**
 * Gets a 16-bit mask with bit numbers fromBit to toBit (inclusive) set.
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $ff597dd62e8c3e1d$var$bitsFor(fromBit, toBit) {
    fromBit &= 0xF;
    toBit &= 0xF;
    if (fromBit === toBit) return 1 << fromBit >>> 0;
    return 0xFFFF >>> 15 - toBit ^ 0xFFFF >>> 16 - fromBit;
}
/**
 * A lookup table for number of set bits in a 16-bit integer.   This is used to quickly count the cardinality (number of unique elements) of a BitSet.
 */ const $ff597dd62e8c3e1d$var$POP_CNT = new Uint8Array(65536);
for(let i = 0; i < 16; i++){
    const stride = 1 << i >>> 0;
    let index = 0;
    while(index < $ff597dd62e8c3e1d$var$POP_CNT.length){
        // skip the numbers where the bit isn't set
        index += stride;
        // increment the ones where the bit is set
        for(let j = 0; j < stride; j++){
            $ff597dd62e8c3e1d$var$POP_CNT[index]++;
            index++;
        }
    }
}
class $ff597dd62e8c3e1d$var$BitSet {
    /*
    ** constructor implementation
    */ constructor(arg){
        if (!arg) // covering the case of unspecified and nbits===0
        this.data = $ff597dd62e8c3e1d$var$EMPTY_DATA;
        else if (typeof arg === "number") {
            if (arg < 0) throw new RangeError("nbits cannot be negative");
            else this.data = new Uint16Array($ff597dd62e8c3e1d$var$getIndex(arg - 1) + 1);
        } else if (arg instanceof $ff597dd62e8c3e1d$var$BitSet) this.data = arg.data.slice(0); // Clone the data
        else {
            let max = -1;
            for (let v of arg)if (max < v) max = v;
            this.data = new Uint16Array($ff597dd62e8c3e1d$var$getIndex(max - 1) + 1);
            for (let v of arg)this.set(v);
        }
    }
    /**
     * Performs a logical **AND** of this target bit set with the argument bit set. This bit set is modified so that
     * each bit in it has the value `true` if and only if it both initially had the value `true` and the corresponding
     * bit in the bit set argument also had the value `true`.
     */ and(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $ff597dd62e8c3e1d$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Clears all of the bits in this `BitSet` whose corresponding bit is set in the specified `BitSet`.
     */ andNot(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i] ^ 0xFFFF;
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $ff597dd62e8c3e1d$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Returns the number of bits set to `true` in this `BitSet`.
     */ cardinality() {
        if (this.isEmpty) return 0;
        const data = this.data;
        const length = data.length;
        let result = 0;
        for(let i = 0; i < length; i++)result += $ff597dd62e8c3e1d$var$POP_CNT[data[i]];
        return result;
    }
    clear(fromIndex, toIndex) {
        if (fromIndex == null) this.data.fill(0);
        else if (toIndex == null) this.set(fromIndex, false);
        else this.set(fromIndex, toIndex, false);
    }
    flip(fromIndex, toIndex) {
        if (toIndex == null) toIndex = fromIndex;
        if (fromIndex < 0 || toIndex < fromIndex) throw new RangeError();
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        const lastWord = $ff597dd62e8c3e1d$var$getIndex(toIndex);
        if (word === lastWord) this.data[word] ^= $ff597dd62e8c3e1d$var$bitsFor(fromIndex, toIndex);
        else {
            this.data[word++] ^= $ff597dd62e8c3e1d$var$bitsFor(fromIndex, 15);
            while(word < lastWord)this.data[word++] ^= 0xFFFF;
            this.data[word++] ^= $ff597dd62e8c3e1d$var$bitsFor(0, toIndex);
        }
    }
    get(fromIndex, toIndex) {
        if (toIndex === undefined) return !!(this.data[$ff597dd62e8c3e1d$var$getIndex(fromIndex)] & $ff597dd62e8c3e1d$var$bitsFor(fromIndex, fromIndex));
        else {
            // return a BitSet
            let result = new $ff597dd62e8c3e1d$var$BitSet(toIndex + 1);
            for(let i = fromIndex; i <= toIndex; i++)result.set(i, this.get(i));
            return result;
        }
    }
    /**
     * Returns true if the specified `BitSet` has any bits set to `true` that are also set to `true` in this `BitSet`.
     *
     * @param set `BitSet` to intersect with
     */ intersects(set) {
        let smallerLength = Math.min(this.length(), set.length());
        if (smallerLength === 0) return false;
        let bound = $ff597dd62e8c3e1d$var$getIndex(smallerLength - 1);
        for(let i = 0; i <= bound; i++){
            if ((this.data[i] & set.data[i]) !== 0) return true;
        }
        return false;
    }
    /**
     * Returns true if this `BitSet` contains no bits that are set to `true`.
     */ get isEmpty() {
        return this.length() === 0;
    }
    /**
     * Returns the "logical size" of this `BitSet`: the index of the highest set bit in the `BitSet` plus one. Returns
     * zero if the `BitSet` contains no set bits.
     */ length() {
        if (!this.data.length) return 0;
        return this.previousSetBit($ff597dd62e8c3e1d$var$unIndex(this.data.length) - 1) + 1;
    }
    /**
     * Returns the index of the first bit that is set to `false` that occurs on or after the specified starting index,
     * If no such bit exists then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        if (word > length) return -1;
        let ignore = 0xFFFF ^ $ff597dd62e8c3e1d$var$bitsFor(fromIndex, 15);
        if ((data[word] | ignore) === 0xFFFF) {
            word++;
            ignore = 0;
            for(; word < length; word++){
                if (data[word] !== 0xFFFF) break;
            }
            if (word === length) // Hit the end
            return -1;
        }
        return $ff597dd62e8c3e1d$var$unIndex(word) + $ff597dd62e8c3e1d$var$findLSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the first bit that is set to `true` that occurs on or after the specified starting index.
     * If no such bit exists then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.nextSetBit(0); i >= 0; i = bs.nextSetBit(i + 1)) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        if (word > length) return -1;
        let mask = $ff597dd62e8c3e1d$var$bitsFor(fromIndex, 15);
        if ((data[word] & mask) === 0) {
            word++;
            mask = 0xFFFF;
            for(; word < length; word++){
                if (data[word] !== 0) break;
            }
            if (word >= length) return -1;
        }
        return $ff597dd62e8c3e1d$var$unIndex(word) + $ff597dd62e8c3e1d$var$findLSBSet(data[word] & mask);
    }
    /**
     * Performs a logical **OR** of this bit set with the bit set argument. This bit set is modified so that a bit in it
     * has the value `true` if and only if it either already had the value `true` or the corresponding bit in the bit
     * set argument has the value `true`.
     */ or(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Or those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] | other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $ff597dd62e8c3e1d$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord);
    }
    /**
     * Returns the index of the nearest bit that is set to `false` that occurs on or before the specified starting
     * index. If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let ignore = 0xFFFF ^ $ff597dd62e8c3e1d$var$bitsFor(0, fromIndex);
        if ((data[word] | ignore) === 0xFFFF) {
            ignore = 0;
            word--;
            for(; word >= 0; word--){
                if (data[word] !== 0xFFFF) break;
            }
            if (word < 0) // Hit the end
            return -1;
        }
        return $ff597dd62e8c3e1d$var$unIndex(word) + $ff597dd62e8c3e1d$var$findMSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the nearest bit that is set to `true` that occurs on or before the specified starting index.
     * If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.length(); (i = bs.previousSetBit(i-1)) >= 0; ) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let mask = $ff597dd62e8c3e1d$var$bitsFor(0, fromIndex);
        if ((data[word] & mask) === 0) {
            word--;
            mask = 0xFFFF;
            for(; word >= 0; word--){
                if (data[word] !== 0) break;
            }
            if (word < 0) return -1;
        }
        return $ff597dd62e8c3e1d$var$unIndex(word) + $ff597dd62e8c3e1d$var$findMSBSet(data[word] & mask);
    }
    set(fromIndex, toIndex, value) {
        if (toIndex === undefined) {
            toIndex = fromIndex;
            value = true;
        } else if (typeof toIndex === "boolean") {
            value = toIndex;
            toIndex = fromIndex;
        }
        if (value === undefined) value = true;
        if (fromIndex < 0 || fromIndex > toIndex) throw new RangeError();
        let word = $ff597dd62e8c3e1d$var$getIndex(fromIndex);
        let lastWord = $ff597dd62e8c3e1d$var$getIndex(toIndex);
        if (value && lastWord >= this.data.length) {
            // Grow array "just enough" for bits we need to set
            let temp = new Uint16Array(lastWord + 1);
            this.data.forEach((value, index)=>temp[index] = value);
            this.data = temp;
        } else if (!value) {
            // But there is no need to grow array to clear bits.
            if (word >= this.data.length) // Early exit
            return;
            if (lastWord >= this.data.length) {
                // Adjust work to fit array
                lastWord = this.data.length - 1;
                toIndex = this.data.length * 16 - 1;
            }
        }
        if (word === lastWord) this._setBits(word, value, $ff597dd62e8c3e1d$var$bitsFor(fromIndex, toIndex));
        else {
            this._setBits(word++, value, $ff597dd62e8c3e1d$var$bitsFor(fromIndex, 15));
            while(word < lastWord)this.data[word++] = value ? 0xFFFF : 0;
            this._setBits(word, value, $ff597dd62e8c3e1d$var$bitsFor(0, toIndex));
        }
    }
    _setBits(word, value, mask) {
        if (value) this.data[word] |= mask;
        else this.data[word] &= 0xFFFF ^ mask;
    }
    /**
     * Returns the number of bits of space actually in use by this `BitSet` to represent bit values. The maximum element
     * in the set is the size - 1st element.
     */ get size() {
        return this.data.byteLength * 8;
    }
    /**
     * Returns a new byte array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let bytes = s.toByteArray();`
     * then `bytes.length === (s.length()+7)/8` and `s.get(n) === ((bytes[n/8] & (1<<(n%8))) != 0)` for all
     * `n < 8 * bytes.length`.
     */ // toByteArray(): Int8Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Returns a new integer array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let integers = s.toIntegerArray();`
     * then `integers.length === (s.length()+31)/32` and `s.get(n) === ((integers[n/32] & (1<<(n%32))) != 0)` for all
     * `n < 32 * integers.length`.
     */ // toIntegerArray(): Int32Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    hashCode() {
        return $i99P2.MurmurHash.hashCode(this.data, 22);
    }
    /**
     * Compares this object against the specified object. The result is `true` if and only if the argument is not
     * `undefined` and is a `Bitset` object that has exactly the same set of bits set to `true` as this bit set. That
     * is, for every nonnegative index `k`,
     *
     * ```
     * ((BitSet)obj).get(k) == this.get(k)
     * ```
     *
     * must be true. The current sizes of the two bit sets are not compared.
     */ equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $ff597dd62e8c3e1d$var$BitSet)) return false;
        const len = this.length();
        if (len !== obj.length()) return false;
        if (len === 0) return true;
        let bound = $ff597dd62e8c3e1d$var$getIndex(len - 1);
        for(let i = 0; i <= bound; i++){
            if (this.data[i] !== obj.data[i]) return false;
        }
        return true;
    }
    /**
     * Returns a string representation of this bit set. For every index for which this `BitSet` contains a bit in the
     * set state, the decimal representation of that index is included in the result. Such indices are listed in order
     * from lowest to highest, separated by ", " (a comma and a space) and surrounded by braces, resulting in the usual
     * mathematical notation for a set of integers.
     *
     * Example:
     *
     *     BitSet drPepper = new BitSet();
     *
     * Now `drPepper.toString()` returns `"{}"`.
     *
     *     drPepper.set(2);
     *
     * Now `drPepper.toString()` returns `"{2}"`.
     *
     *     drPepper.set(4);
     *     drPepper.set(10);
     *
     * Now `drPepper.toString()` returns `"{2, 4, 10}"`.
     */ toString() {
        let result = "{";
        let first = true;
        for(let i = this.nextSetBit(0); i >= 0; i = this.nextSetBit(i + 1)){
            if (first) first = false;
            else result += ", ";
            result += i;
        }
        result += "}";
        return result;
    }
    // static valueOf(bytes: Int8Array): BitSet;
    // static valueOf(buffer: ArrayBuffer): BitSet;
    // static valueOf(integers: Int32Array): BitSet;
    // static valueOf(data: Int8Array | Int32Array | ArrayBuffer): BitSet {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Performs a logical **XOR** of this bit set with the bit set argument. This bit set is modified so that a bit in
     * it has the value `true` if and only if one of the following statements holds:
     *
     * * The bit initially has the value `true`, and the corresponding bit in the argument has the value `false`.
     * * The bit initially has the value `false`, and the corresponding bit in the argument has the value `true`.
     */ xor(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Xor those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] ^ other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $ff597dd62e8c3e1d$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord + 1);
    }
    clone() {
        return new $ff597dd62e8c3e1d$var$BitSet(this);
    }
    [Symbol.iterator]() {
        return new $ff597dd62e8c3e1d$var$BitSetIterator(this.data);
    }
    // Overrides formatting for nodejs assert etc.
    [$7WF8Y.inspect.custom]() {
        return "BitSet " + this.toString();
    }
}
module.exports.BitSet = $ff597dd62e8c3e1d$var$BitSet;
class $ff597dd62e8c3e1d$var$BitSetIterator {
    constructor(data){
        this.data = data;
        this.index = 0;
        this.mask = 0xFFFF;
    }
    next() {
        while(this.index < this.data.length){
            const bits = this.data[this.index] & this.mask;
            if (bits !== 0) {
                const bitNumber = $ff597dd62e8c3e1d$var$unIndex(this.index) + $ff597dd62e8c3e1d$var$findLSBSet(bits);
                this.mask = $ff597dd62e8c3e1d$var$bitsFor(bitNumber + 1, 15);
                return {
                    done: false,
                    value: bitNumber
                };
            }
            this.index++;
            this.mask = 0xFFFF;
        }
        return {
            done: true,
            value: -1
        };
    }
    [Symbol.iterator]() {
        return this;
    }
}

});


parcelRegister("cXSly", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $970526d2c9830e83$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFASerializer = void 0;

var $lbAqv = parcelRequire("lbAqv");

var $esDFm = parcelRequire("esDFm");

var $haz8F = parcelRequire("haz8F");

var $24a4y = parcelRequire("24a4y");

var $5t4I3 = parcelRequire("5t4I3");
/** A DFA walker that knows how to dump them to serialized strings. */ class $970526d2c9830e83$var$DFASerializer {
    constructor(dfa, vocabulary, ruleNames, atn){
        if (vocabulary instanceof $24a4y.Recognizer) {
            ruleNames = vocabulary.ruleNames;
            atn = vocabulary.atn;
            vocabulary = vocabulary.vocabulary;
        } else if (!vocabulary) vocabulary = $5t4I3.VocabularyImpl.EMPTY_VOCABULARY;
        this.dfa = dfa;
        this.vocabulary = vocabulary;
        this.ruleNames = ruleNames;
        this.atn = atn;
    }
    toString() {
        if (!this.dfa.s0) return "";
        let buf = "";
        if (this.dfa.states) {
            let states = new Array(...this.dfa.states.toArray());
            states.sort((o1, o2)=>o1.stateNumber - o2.stateNumber);
            for (let s of states){
                let edges = s.getEdgeMap();
                let edgeKeys = [
                    ...edges.keys()
                ].sort((a, b)=>a - b);
                let contextEdges = s.getContextEdgeMap();
                let contextEdgeKeys = [
                    ...contextEdges.keys()
                ].sort((a, b)=>a - b);
                for (let entry of edgeKeys){
                    let value = edges.get(entry);
                    if ((value == null || value === $lbAqv.ATNSimulator.ERROR) && !s.isContextSymbol(entry)) continue;
                    let contextSymbol = false;
                    buf += this.getStateString(s) + "-" + this.getEdgeLabel(entry) + "->";
                    if (s.isContextSymbol(entry)) {
                        buf += "!";
                        contextSymbol = true;
                    }
                    let t = value;
                    if (t && t.stateNumber !== $lbAqv.ATNSimulator.ERROR.stateNumber) buf += this.getStateString(t) + "\n";
                    else if (contextSymbol) buf += "ctx\n";
                }
                if (s.isContextSensitive) for (let entry of contextEdgeKeys)buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
            }
        }
        let output = buf;
        if (output.length === 0) return "";
        //return Utils.sortLinesInString(output);
        return output;
    }
    getContextLabel(i) {
        if (i === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) return "ctx:EMPTY_FULL";
        else if (i === $haz8F.PredictionContext.EMPTY_LOCAL_STATE_KEY) return "ctx:EMPTY_LOCAL";
        if (this.atn && i > 0 && i <= this.atn.states.length) {
            let state = this.atn.states[i];
            let ruleIndex = state.ruleIndex;
            if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
        }
        return "ctx:" + String(i);
    }
    getEdgeLabel(i) {
        return this.vocabulary.getDisplayName(i);
    }
    getStateString(s) {
        if (s === $lbAqv.ATNSimulator.ERROR) return "ERROR";
        let n = s.stateNumber;
        let stateStr = "s" + n;
        if (s.isAcceptState) {
            if (s.predicates) stateStr = ":s" + n + "=>" + s.predicates;
            else stateStr = ":s" + n + "=>" + s.prediction;
        }
        if (s.isContextSensitive) {
            stateStr += "*";
            for (let config of s.configs)if (config.reachesIntoOuterContext) {
                stateStr += "*";
                break;
            }
        }
        return stateStr;
    }
}
$970526d2c9830e83$var$__decorate([
    $esDFm.NotNull
], $970526d2c9830e83$var$DFASerializer.prototype, "dfa", void 0);
$970526d2c9830e83$var$__decorate([
    $esDFm.NotNull
], $970526d2c9830e83$var$DFASerializer.prototype, "vocabulary", void 0);
$970526d2c9830e83$var$__decorate([
    $esDFm.Override
], $970526d2c9830e83$var$DFASerializer.prototype, "toString", null);
module.exports.DFASerializer = $970526d2c9830e83$var$DFASerializer;

});
parcelRegister("lbAqv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f6c6e19f6a67273a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f6c6e19f6a67273a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNSimulator = void 0;

var $6co2U = parcelRequire("6co2U");

var $5jw7S = parcelRequire("5jw7S");

var $esDFm = parcelRequire("esDFm");

var $haz8F = parcelRequire("haz8F");
let $f6c6e19f6a67273a$var$ATNSimulator = class ATNSimulator {
    constructor(atn){
        this.atn = atn;
    }
    static get ERROR() {
        if (!ATNSimulator._ERROR) {
            ATNSimulator._ERROR = new $5jw7S.DFAState(new $6co2U.ATNConfigSet());
            ATNSimulator._ERROR.stateNumber = $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY;
        }
        return ATNSimulator._ERROR;
    }
    /**
     * Clear the DFA cache used by the current instance. Since the DFA cache may
     * be shared by multiple ATN simulators, this method may affect the
     * performance (but not accuracy) of other parsers which are being used
     * concurrently.
     *
     * @ if the current instance does not
     * support clearing the DFA.
     *
     * @since 4.3
     */ clearDFA() {
        this.atn.clearDFA();
    }
};
$f6c6e19f6a67273a$var$__decorate([
    $esDFm.NotNull
], $f6c6e19f6a67273a$var$ATNSimulator.prototype, "atn", void 0);
$f6c6e19f6a67273a$var$__decorate([
    $esDFm.NotNull
], $f6c6e19f6a67273a$var$ATNSimulator, "ERROR", null);
$f6c6e19f6a67273a$var$ATNSimulator = $f6c6e19f6a67273a$var$__decorate([
    $f6c6e19f6a67273a$var$__param(0, $esDFm.NotNull)
], $f6c6e19f6a67273a$var$ATNSimulator);
module.exports.ATNSimulator = $f6c6e19f6a67273a$var$ATNSimulator;
(function(ATNSimulator) {
    const RULE_VARIANT_DELIMITER = "$";
    const RULE_LF_VARIANT_MARKER = "$lf$";
    const RULE_NOLF_VARIANT_MARKER = "$nolf$";
})($f6c6e19f6a67273a$var$ATNSimulator = module.exports.ATNSimulator || (module.exports.ATNSimulator = {}));
module.exports.ATNSimulator = $f6c6e19f6a67273a$var$ATNSimulator;

});
parcelRegister("5jw7S", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3de7a5a6cf99484b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3de7a5a6cf99484b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFAState = void 0;

var $lDQMG = parcelRequire("lDQMG");

var $lVdCV = parcelRequire("lVdCV");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $haz8F = parcelRequire("haz8F");

var $gwEr2 = parcelRequire("gwEr2");
/** A DFA state represents a set of possible ATN configurations.
 *  As Aho, Sethi, Ullman p. 117 says "The DFA uses its state
 *  to keep track of all possible states the ATN can be in after
 *  reading each input symbol.  That is to say, after reading
 *  input a1a2..an, the DFA is in a state that represents the
 *  subset T of the states of the ATN that are reachable from the
 *  ATN's start state along some path labeled a1a2..an."
 *  In conventional NFA&rarr;DFA conversion, therefore, the subset T
 *  would be a bitset representing the set of states the
 *  ATN could be in.  We need to track the alt predicted by each
 *  state as well, however.  More importantly, we need to maintain
 *  a stack of states, tracking the closure operations as they
 *  jump from rule to rule, emulating rule invocations (method calls).
 *  I have to add a stack to simulate the proper lookahead sequences for
 *  the underlying LL grammar from which the ATN was derived.
 *
 *  I use a set of ATNConfig objects not simple states.  An ATNConfig
 *  is both a state (ala normal conversion) and a RuleContext describing
 *  the chain of rules (if any) followed to arrive at that state.
 *
 *  A DFA state may have multiple references to a particular state,
 *  but with different ATN contexts (with same or different alts)
 *  meaning that state was reached via a different set of rule invocations.
 */ class $3de7a5a6cf99484b$var$DFAState {
    /**
     * Constructs a new `DFAState`.
     *
     * @param configs The set of ATN configurations defining this state.
     */ constructor(configs){
        this.stateNumber = -1;
        this.configs = configs;
        this.edges = new Map();
        this.contextEdges = new Map();
    }
    get isContextSensitive() {
        return !!this.contextSymbols;
    }
    isContextSymbol(symbol) {
        if (!this.isContextSensitive) return false;
        return this.contextSymbols.get(symbol);
    }
    setContextSymbol(symbol) {
        $gwEr2(this.isContextSensitive);
        this.contextSymbols.set(symbol);
    }
    setContextSensitive(atn) {
        $gwEr2(!this.configs.isOutermostConfigSet);
        if (this.isContextSensitive) return;
        if (!this.contextSymbols) this.contextSymbols = new $lVdCV.BitSet();
    }
    get acceptStateInfo() {
        return this._acceptStateInfo;
    }
    set acceptStateInfo(acceptStateInfo) {
        this._acceptStateInfo = acceptStateInfo;
    }
    get isAcceptState() {
        return !!this._acceptStateInfo;
    }
    get prediction() {
        if (!this._acceptStateInfo) return $lDQMG.ATN.INVALID_ALT_NUMBER;
        return this._acceptStateInfo.prediction;
    }
    get lexerActionExecutor() {
        if (!this._acceptStateInfo) return undefined;
        return this._acceptStateInfo.lexerActionExecutor;
    }
    getTarget(symbol) {
        return this.edges.get(symbol);
    }
    setTarget(symbol, target) {
        this.edges.set(symbol, target);
    }
    getEdgeMap() {
        return this.edges;
    }
    getContextTarget(invokingState) {
        if (invokingState === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        return this.contextEdges.get(invokingState);
    }
    setContextTarget(invokingState, target) {
        if (!this.isContextSensitive) throw new Error("The state is not context sensitive.");
        if (invokingState === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        this.contextEdges.set(invokingState, target);
    }
    getContextEdgeMap() {
        let map = new Map(this.contextEdges);
        let existing = map.get(-1);
        if (existing !== undefined) {
            if (map.size === 1) {
                let result = new Map();
                result.set($haz8F.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                return result;
            } else {
                map.delete(-1);
                map.set($haz8F.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
            }
        }
        return map;
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize(7);
        hash = $i99P2.MurmurHash.update(hash, this.configs.hashCode());
        hash = $i99P2.MurmurHash.finish(hash, 1);
        return hash;
    }
    /**
     * Two {@link DFAState} instances are equal if their ATN configuration sets
     * are the same. This method is used to see if a state already exists.
     *
     * Because the number of alternatives and number of ATN configurations are
     * finite, there is a finite number of DFA states that can be processed.
     * This is necessary to show that the algorithm terminates.
     *
     * Cannot test the DFA state numbers here because in
     * {@link ParserATNSimulator#addDFAState} we need to know if any other state
     * exists that has this exact set of ATN configurations. The
     * {@link #stateNumber} is irrelevant.
     */ equals(o) {
        // compare set of ATN configurations in this set with other
        if (this === o) return true;
        if (!(o instanceof $3de7a5a6cf99484b$var$DFAState)) return false;
        let other = o;
        let sameSet = this.configs.equals(other.configs);
        //		System.out.println("DFAState.equals: "+configs+(sameSet?"==":"!=")+other.configs);
        return sameSet;
    }
    toString() {
        let buf = "";
        buf += this.stateNumber + ":" + this.configs;
        if (this.isAcceptState) {
            buf += "=>";
            if (this.predicates) buf += this.predicates;
            else buf += this.prediction;
        }
        return buf.toString();
    }
}
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.NotNull
], $3de7a5a6cf99484b$var$DFAState.prototype, "configs", void 0);
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.NotNull
], $3de7a5a6cf99484b$var$DFAState.prototype, "edges", void 0);
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.NotNull
], $3de7a5a6cf99484b$var$DFAState.prototype, "contextEdges", void 0);
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.Override
], $3de7a5a6cf99484b$var$DFAState.prototype, "hashCode", null);
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.Override
], $3de7a5a6cf99484b$var$DFAState.prototype, "equals", null);
$3de7a5a6cf99484b$var$__decorate([
    $esDFm.Override
], $3de7a5a6cf99484b$var$DFAState.prototype, "toString", null);
module.exports.DFAState = $3de7a5a6cf99484b$var$DFAState;
(function(DFAState) {
    /** Map a predicate to a predicted alternative. */ let PredPrediction = class PredPrediction {
        constructor(pred, alt){
            this.alt = alt;
            this.pred = pred;
        }
        toString() {
            return "(" + this.pred + ", " + this.alt + ")";
        }
    };
    $3de7a5a6cf99484b$var$__decorate([
        $esDFm.NotNull
    ], PredPrediction.prototype, "pred", void 0);
    $3de7a5a6cf99484b$var$__decorate([
        $esDFm.Override
    ], PredPrediction.prototype, "toString", null);
    PredPrediction = $3de7a5a6cf99484b$var$__decorate([
        $3de7a5a6cf99484b$var$__param(0, $esDFm.NotNull)
    ], PredPrediction);
    DFAState.PredPrediction = PredPrediction;
})($3de7a5a6cf99484b$var$DFAState = module.exports.DFAState || (module.exports.DFAState = {}));

});


parcelRegister("24a4y", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1813c4a7a7427bce$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1813c4a7a7427bce$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $b6VR9 = parcelRequire("b6VR9");

var $adfkv = parcelRequire("adfkv");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");

var $g4Hat = parcelRequire("g4Hat");
class $1813c4a7a7427bce$var$Recognizer {
    constructor(){
        this._listeners = [
            $b6VR9.ConsoleErrorListener.INSTANCE
        ];
        this._stateNumber = -1;
    }
    /**
     * Get a map from token names to token types.
     *
     * Used for XPath and tree pattern compilation.
     */ getTokenTypeMap() {
        let vocabulary = this.vocabulary;
        let result = $1813c4a7a7427bce$var$Recognizer.tokenTypeMapCache.get(vocabulary);
        if (result == null) {
            let intermediateResult = new Map();
            for(let i = 0; i <= this.atn.maxTokenType; i++){
                let literalName = vocabulary.getLiteralName(i);
                if (literalName != null) intermediateResult.set(literalName, i);
                let symbolicName = vocabulary.getSymbolicName(i);
                if (symbolicName != null) intermediateResult.set(symbolicName, i);
            }
            intermediateResult.set("EOF", $2G93d.Token.EOF);
            result = intermediateResult;
            $1813c4a7a7427bce$var$Recognizer.tokenTypeMapCache.set(vocabulary, result);
        }
        return result;
    }
    /**
     * Get a map from rule names to rule indexes.
     *
     * Used for XPath and tree pattern compilation.
     */ getRuleIndexMap() {
        let ruleNames = this.ruleNames;
        if (ruleNames == null) throw new Error("The current recognizer does not provide a list of rule names.");
        let result = $1813c4a7a7427bce$var$Recognizer.ruleIndexMapCache.get(ruleNames);
        if (result == null) {
            result = $g4Hat.toMap(ruleNames);
            $1813c4a7a7427bce$var$Recognizer.ruleIndexMapCache.set(ruleNames, result);
        }
        return result;
    }
    getTokenType(tokenName) {
        let ttype = this.getTokenTypeMap().get(tokenName);
        if (ttype != null) return ttype;
        return $2G93d.Token.INVALID_TYPE;
    }
    /**
     * If this recognizer was generated, it will have a serialized ATN
     * representation of the grammar.
     *
     * For interpreters, we don't know their serialized ATN despite having
     * created the interpreter from it.
     */ get serializedATN() {
        throw new Error("there is no serialized ATN");
    }
    /**
     * Get the {@link ATN} used by the recognizer for prediction.
     *
     * @returns The {@link ATN} used by the recognizer for prediction.
     */ get atn() {
        return this._interp.atn;
    }
    /**
     * Get the ATN interpreter used by the recognizer for prediction.
     *
     * @returns The ATN interpreter used by the recognizer for prediction.
     */ get interpreter() {
        return this._interp;
    }
    /**
     * Set the ATN interpreter used by the recognizer for prediction.
     *
     * @param interpreter The ATN interpreter used by the recognizer for
     * prediction.
     */ set interpreter(interpreter) {
        this._interp = interpreter;
    }
    /** If profiling during the parse/lex, this will return DecisionInfo records
     *  for each decision in recognizer in a ParseInfo object.
     *
     * @since 4.3
     */ get parseInfo() {
        return Promise.resolve(undefined);
    }
    /** What is the error header, normally line/character position information? */ getErrorHeader(e) {
        let token = e.getOffendingToken();
        if (!token) return "";
        let line = token.line;
        let charPositionInLine = token.charPositionInLine;
        return "line " + line + ":" + charPositionInLine;
    }
    /**
     * @exception NullPointerException if `listener` is `undefined`.
     */ addErrorListener(listener) {
        if (!listener) throw new TypeError("listener must not be null");
        this._listeners.push(listener);
    }
    removeErrorListener(listener) {
        let position = this._listeners.indexOf(listener);
        if (position !== -1) this._listeners.splice(position, 1);
    }
    removeErrorListeners() {
        this._listeners.length = 0;
    }
    getErrorListeners() {
        return this._listeners.slice(0);
    }
    getErrorListenerDispatch() {
        return new $adfkv.ProxyErrorListener(this.getErrorListeners());
    }
    // subclass needs to override these if there are sempreds or actions
    // that the ATN interp needs to execute
    sempred(_localctx, ruleIndex, actionIndex) {
        return true;
    }
    precpred(localctx, precedence) {
        return true;
    }
    action(_localctx, ruleIndex, actionIndex) {
    // intentionally empty
    }
    get state() {
        return this._stateNumber;
    }
    /** Indicate that the recognizer has changed internal state that is
     *  consistent with the ATN state passed in.  This way we always know
     *  where we are in the ATN as the parser goes along. The rule
     *  context objects form a stack that lets us see the stack of
     *  invoking rules. Combine this and we have complete ATN
     *  configuration information.
     */ set state(atnState) {
        //		System.err.println("setState "+atnState);
        this._stateNumber = atnState;
    //		if ( traceATNStates ) _ctx.trace(atnState);
    }
}
$1813c4a7a7427bce$var$Recognizer.EOF = -1;
$1813c4a7a7427bce$var$Recognizer.tokenTypeMapCache = new WeakMap();
$1813c4a7a7427bce$var$Recognizer.ruleIndexMapCache = new WeakMap();
$1813c4a7a7427bce$var$__decorate([
    $esDFm.SuppressWarnings("serial"),
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "_listeners", void 0);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "getTokenTypeMap", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "getRuleIndexMap", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "serializedATN", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "atn", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull,
    $1813c4a7a7427bce$var$__param(0, $esDFm.NotNull)
], $1813c4a7a7427bce$var$Recognizer.prototype, "interpreter", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull,
    $1813c4a7a7427bce$var$__param(0, $esDFm.NotNull)
], $1813c4a7a7427bce$var$Recognizer.prototype, "getErrorHeader", null);
$1813c4a7a7427bce$var$__decorate([
    $1813c4a7a7427bce$var$__param(0, $esDFm.NotNull)
], $1813c4a7a7427bce$var$Recognizer.prototype, "addErrorListener", null);
$1813c4a7a7427bce$var$__decorate([
    $1813c4a7a7427bce$var$__param(0, $esDFm.NotNull)
], $1813c4a7a7427bce$var$Recognizer.prototype, "removeErrorListener", null);
$1813c4a7a7427bce$var$__decorate([
    $esDFm.NotNull
], $1813c4a7a7427bce$var$Recognizer.prototype, "getErrorListeners", null);
module.exports.Recognizer = $1813c4a7a7427bce$var$Recognizer;

});
parcelRegister("b6VR9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleErrorListener = void 0;
/**
 *
 * @author Sam Harwell
 */ class $816d225174e7b521$var$ConsoleErrorListener {
    /**
     * {@inheritDoc}
     *
     * This implementation prints messages to {@link System#err} containing the
     * values of `line`, `charPositionInLine`, and `msg` using
     * the following format.
     *
     * <pre>
     * line *line*:*charPositionInLine* *msg*
     * </pre>
     */ syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        console.error(`line ${line}:${charPositionInLine} ${msg}`);
    }
}
module.exports.ConsoleErrorListener = $816d225174e7b521$var$ConsoleErrorListener;
/**
 * Provides a default instance of {@link ConsoleErrorListener}.
 */ $816d225174e7b521$var$ConsoleErrorListener.INSTANCE = new $816d225174e7b521$var$ConsoleErrorListener();

});

parcelRegister("adfkv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $76f7027510cb365c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $76f7027510cb365c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyErrorListener = void 0;

var $esDFm = parcelRequire("esDFm");
/**
 * This implementation of {@link ANTLRErrorListener} dispatches all calls to a
 * collection of delegate listeners. This reduces the effort required to support multiple
 * listeners.
 *
 * @author Sam Harwell
 */ class $76f7027510cb365c$var$ProxyErrorListener {
    constructor(delegates){
        this.delegates = delegates;
        if (!delegates) throw new Error("Invalid delegates");
    }
    getDelegates() {
        return this.delegates;
    }
    syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        this.delegates.forEach((listener)=>{
            if (listener.syntaxError) listener.syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e);
        });
    }
}
$76f7027510cb365c$var$__decorate([
    $esDFm.Override,
    $76f7027510cb365c$var$__param(0, $esDFm.NotNull),
    $76f7027510cb365c$var$__param(4, $esDFm.NotNull)
], $76f7027510cb365c$var$ProxyErrorListener.prototype, "syntaxError", null);
module.exports.ProxyErrorListener = $76f7027510cb365c$var$ProxyErrorListener;

});


parcelRegister("5t4I3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3fb35060e4517eb3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VocabularyImpl = void 0;

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * This class provides a default implementation of the {@link Vocabulary}
 * interface.
 *
 * @author Sam Harwell
 */ class $3fb35060e4517eb3$var$VocabularyImpl {
    /**
     * Constructs a new instance of {@link VocabularyImpl} from the specified
     * literal, symbolic, and display token names.
     *
     * @param literalNames The literal names assigned to tokens, or an empty array
     * if no literal names are assigned.
     * @param symbolicNames The symbolic names assigned to tokens, or
     * an empty array if no symbolic names are assigned.
     * @param displayNames The display names assigned to tokens, or an empty array
     * to use the values in `literalNames` and `symbolicNames` as
     * the source of display names, as described in
     * {@link #getDisplayName(int)}.
     *
     * @see #getLiteralName(int)
     * @see #getSymbolicName(int)
     * @see #getDisplayName(int)
     */ constructor(literalNames, symbolicNames, displayNames){
        this.literalNames = literalNames;
        this.symbolicNames = symbolicNames;
        this.displayNames = displayNames;
        // See note here on -1 part: https://github.com/antlr/antlr4/pull/1146
        this._maxTokenType = Math.max(this.displayNames.length, Math.max(this.literalNames.length, this.symbolicNames.length)) - 1;
    }
    get maxTokenType() {
        return this._maxTokenType;
    }
    getLiteralName(tokenType) {
        if (tokenType >= 0 && tokenType < this.literalNames.length) return this.literalNames[tokenType];
        return undefined;
    }
    getSymbolicName(tokenType) {
        if (tokenType >= 0 && tokenType < this.symbolicNames.length) return this.symbolicNames[tokenType];
        if (tokenType === $2G93d.Token.EOF) return "EOF";
        return undefined;
    }
    getDisplayName(tokenType) {
        if (tokenType >= 0 && tokenType < this.displayNames.length) {
            let displayName = this.displayNames[tokenType];
            if (displayName) return displayName;
        }
        let literalName = this.getLiteralName(tokenType);
        if (literalName) return literalName;
        let symbolicName = this.getSymbolicName(tokenType);
        if (symbolicName) return symbolicName;
        return String(tokenType);
    }
}
/**
 * Gets an empty {@link Vocabulary} instance.
 *
 * No literal or symbol names are assigned to token types, so
 * {@link #getDisplayName(int)} returns the numeric value for all tokens
 * except {@link Token#EOF}.
 */ $3fb35060e4517eb3$var$VocabularyImpl.EMPTY_VOCABULARY = new $3fb35060e4517eb3$var$VocabularyImpl([], [], []);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.NotNull
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "literalNames", void 0);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.NotNull
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "symbolicNames", void 0);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.NotNull
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "displayNames", void 0);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.Override
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "maxTokenType", null);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.Override
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "getLiteralName", null);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.Override
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "getSymbolicName", null);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $3fb35060e4517eb3$var$VocabularyImpl.prototype, "getDisplayName", null);
$3fb35060e4517eb3$var$__decorate([
    $esDFm.NotNull
], $3fb35060e4517eb3$var$VocabularyImpl, "EMPTY_VOCABULARY", void 0);
module.exports.VocabularyImpl = $3fb35060e4517eb3$var$VocabularyImpl;

});


parcelRegister("hZ9cR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d17f465c3764290d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d17f465c3764290d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerDFASerializer = void 0;

var $cXSly = parcelRequire("cXSly");

var $esDFm = parcelRequire("esDFm");

var $5t4I3 = parcelRequire("5t4I3");
let $d17f465c3764290d$var$LexerDFASerializer = class LexerDFASerializer extends $cXSly.DFASerializer {
    constructor(dfa){
        super(dfa, $5t4I3.VocabularyImpl.EMPTY_VOCABULARY);
    }
    getEdgeLabel(i) {
        return "'" + String.fromCodePoint(i) + "'";
    }
};
$d17f465c3764290d$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $d17f465c3764290d$var$LexerDFASerializer.prototype, "getEdgeLabel", null);
$d17f465c3764290d$var$LexerDFASerializer = $d17f465c3764290d$var$__decorate([
    $d17f465c3764290d$var$__param(0, $esDFm.NotNull)
], $d17f465c3764290d$var$LexerDFASerializer);
module.exports.LexerDFASerializer = $d17f465c3764290d$var$LexerDFASerializer;

});

parcelRegister("izkyd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d84b6fdbd708b59b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopEntryState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $lVdCV = parcelRequire("lVdCV");

var $axZym = parcelRequire("axZym");

var $esDFm = parcelRequire("esDFm");
class $d84b6fdbd708b59b$var$StarLoopEntryState extends $axZym.DecisionState {
    constructor(){
        super(...arguments);
        /**
         * Indicates whether this state can benefit from a precedence DFA during SLL
         * decision making.
         *
         * This is a computed property that is calculated during ATN deserialization
         * and stored for use in {@link ParserATNSimulator} and
         * {@link ParserInterpreter}.
         *
         * @see `DFA.isPrecedenceDfa`
         */ this.precedenceRuleDecision = false;
        /**
         * For precedence decisions, this set marks states *S* which have all
         * of the following characteristics:
         *
         * * One or more invocation sites of the current rule returns to
         *   *S*.
         * * The closure from *S* includes the current decision without
         *   passing through any rule invocations or stepping out of the current
         *   rule.
         *
         * This field is not used when {@link #precedenceRuleDecision} is
         * `false`.
         */ this.precedenceLoopbackStates = new $lVdCV.BitSet();
    }
    get stateType() {
        return $9TBHo.ATNStateType.STAR_LOOP_ENTRY;
    }
}
$d84b6fdbd708b59b$var$__decorate([
    $esDFm.Override
], $d84b6fdbd708b59b$var$StarLoopEntryState.prototype, "stateType", null);
module.exports.StarLoopEntryState = $d84b6fdbd708b59b$var$StarLoopEntryState;

});


parcelRegister("2xNwj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1da51385954c77a9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $aTslC = parcelRequire("aTslC");

var $esDFm = parcelRequire("esDFm");
/**
 *
 * @author Sam Harwell
 */ class $1da51385954c77a9$var$InvalidState extends $aTslC.BasicState {
    get stateType() {
        return $9TBHo.ATNStateType.INVALID_TYPE;
    }
}
$1da51385954c77a9$var$__decorate([
    $esDFm.Override
], $1da51385954c77a9$var$InvalidState.prototype, "stateType", null);
module.exports.InvalidState = $1da51385954c77a9$var$InvalidState;

});
parcelRegister("aTslC", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7ee507addbdfb9ca$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
/**
 *
 * @author Sam Harwell
 */ class $7ee507addbdfb9ca$var$BasicState extends $17Oz4.ATNState {
    get stateType() {
        return $9TBHo.ATNStateType.BASIC;
    }
}
$7ee507addbdfb9ca$var$__decorate([
    $esDFm.Override
], $7ee507addbdfb9ca$var$BasicState.prototype, "stateType", null);
module.exports.BasicState = $7ee507addbdfb9ca$var$BasicState;

});


parcelRegister("en89P", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a7698a95bc07b861$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a7698a95bc07b861$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LL1Analyzer = void 0;

var $5sT1a = parcelRequire("5sT1a");

var $fJumX = parcelRequire("fJumX");

var $9qlOq = parcelRequire("9qlOq");

var $lVdCV = parcelRequire("lVdCV");

var $6og9T = parcelRequire("6og9T");

var $esDFm = parcelRequire("esDFm");

var $grncH = parcelRequire("grncH");

var $73sQO = parcelRequire("73sQO");

var $haz8F = parcelRequire("haz8F");

var $U6v4o = parcelRequire("U6v4o");

var $acKOx = parcelRequire("acKOx");

var $2G93d = parcelRequire("2G93d");

var $4EBHJ = parcelRequire("4EBHJ");
let $a7698a95bc07b861$var$LL1Analyzer = class LL1Analyzer {
    constructor(atn){
        this.atn = atn;
    }
    /**
     * Calculates the SLL(1) expected lookahead set for each outgoing transition
     * of an {@link ATNState}. The returned array has one element for each
     * outgoing transition in `s`. If the closure from transition
     * *i* leads to a semantic predicate before matching a symbol, the
     * element at index *i* of the result will be `undefined`.
     *
     * @param s the ATN state
     * @returns the expected symbols for each outgoing transition of `s`.
     */ getDecisionLookahead(s) {
        //		System.out.println("LOOK("+s.stateNumber+")");
        if (s == null) return undefined;
        let look = new Array(s.numberOfTransitions);
        for(let alt = 0; alt < s.numberOfTransitions; alt++){
            let current = new $6og9T.IntervalSet();
            look[alt] = current;
            let lookBusy = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
            let seeThruPreds = false; // fail to get lookahead upon pred
            this._LOOK(s.transition(alt).target, undefined, $haz8F.PredictionContext.EMPTY_LOCAL, current, lookBusy, new $lVdCV.BitSet(), seeThruPreds, false);
            // Wipe out lookahead for this alternative if we found nothing
            // or we had a predicate when we !seeThruPreds
            if (current.size === 0 || current.contains(LL1Analyzer.HIT_PRED)) {
                current = undefined;
                look[alt] = current;
            }
        }
        return look;
    }
    LOOK(s, ctx, stopState) {
        if (stopState === undefined) {
            if (s.atn == null) throw new Error("Illegal state");
            stopState = s.atn.ruleToStopState[s.ruleIndex];
        } else if (stopState === null) // This is an explicit request to pass undefined as the stopState to _LOOK. Used to distinguish an overload
        // from the method which simply omits the stopState parameter.
        stopState = undefined;
        let r = new $6og9T.IntervalSet();
        let seeThruPreds = true; // ignore preds; get all lookahead
        let addEOF = true;
        this._LOOK(s, stopState, ctx, r, new $fJumX.Array2DHashSet(), new $lVdCV.BitSet(), seeThruPreds, addEOF);
        return r;
    }
    /**
     * Compute set of tokens that can follow `s` in the ATN in the
     * specified `ctx`.
     * <p/>
     * If `ctx` is {@link PredictionContext#EMPTY_LOCAL} and
     * `stopState` or the end of the rule containing `s` is reached,
     * {@link Token#EPSILON} is added to the result set. If `ctx` is not
     * {@link PredictionContext#EMPTY_LOCAL} and `addEOF` is `true`
     * and `stopState` or the end of the outermost rule is reached,
     * {@link Token#EOF} is added to the result set.
     *
     * @param s the ATN state.
     * @param stopState the ATN state to stop at. This can be a
     * {@link BlockEndState} to detect epsilon paths through a closure.
     * @param ctx The outer context, or {@link PredictionContext#EMPTY_LOCAL} if
     * the outer context should not be used.
     * @param look The result lookahead set.
     * @param lookBusy A set used for preventing epsilon closures in the ATN
     * from causing a stack overflow. Outside code should pass
     * `new HashSet<ATNConfig>` for this argument.
     * @param calledRuleStack A set used for preventing left recursion in the
     * ATN from causing a stack overflow. Outside code should pass
     * `new BitSet()` for this argument.
     * @param seeThruPreds `true` to true semantic predicates as
     * implicitly `true` and "see through them", otherwise `false`
     * to treat semantic predicates as opaque and add {@link #HIT_PRED} to the
     * result if one is encountered.
     * @param addEOF Add {@link Token#EOF} to the result if the end of the
     * outermost context is reached. This parameter has no effect if `ctx`
     * is {@link PredictionContext#EMPTY_LOCAL}.
     */ _LOOK(s, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
        //		System.out.println("_LOOK("+s.stateNumber+", ctx="+ctx);
        let c = $9qlOq.ATNConfig.create(s, 0, ctx);
        if (!lookBusy.add(c)) return;
        if (s === stopState) {
            if ($haz8F.PredictionContext.isEmptyLocal(ctx)) {
                look.add($2G93d.Token.EPSILON);
                return;
            } else if (ctx.isEmpty) {
                if (addEOF) look.add($2G93d.Token.EOF);
                return;
            }
        }
        if (s instanceof $U6v4o.RuleStopState) {
            if (ctx.isEmpty && !$haz8F.PredictionContext.isEmptyLocal(ctx)) {
                if (addEOF) look.add($2G93d.Token.EOF);
                return;
            }
            let removed = calledRuleStack.get(s.ruleIndex);
            try {
                calledRuleStack.clear(s.ruleIndex);
                for(let i = 0; i < ctx.size; i++){
                    if (ctx.getReturnState(i) === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                    let returnState = this.atn.states[ctx.getReturnState(i)];
                    //					System.out.println("popping back to "+retState);
                    this._LOOK(returnState, stopState, ctx.getParent(i), look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                }
            } finally{
                if (removed) calledRuleStack.set(s.ruleIndex);
            }
        }
        let n = s.numberOfTransitions;
        for(let i = 0; i < n; i++){
            let t = s.transition(i);
            if (t instanceof $acKOx.RuleTransition) {
                if (calledRuleStack.get(t.ruleIndex)) continue;
                let newContext = ctx.getChild(t.followState.stateNumber);
                try {
                    calledRuleStack.set(t.ruleIndex);
                    this._LOOK(t.target, stopState, newContext, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                } finally{
                    calledRuleStack.clear(t.ruleIndex);
                }
            } else if (t instanceof $5sT1a.AbstractPredicateTransition) {
                if (seeThruPreds) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                else look.add(LL1Analyzer.HIT_PRED);
            } else if (t.isEpsilon) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
            else if (t instanceof $4EBHJ.WildcardTransition) look.addAll($6og9T.IntervalSet.of($2G93d.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
            else {
                //				System.out.println("adding "+ t);
                let set = t.label;
                if (set != null) {
                    if (t instanceof $grncH.NotSetTransition) set = set.complement($6og9T.IntervalSet.of($2G93d.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                    look.addAll(set);
                }
            }
        }
    }
};
/** Special value added to the lookahead sets to indicate that we hit
 *  a predicate during analysis if `seeThruPreds==false`.
 */ $a7698a95bc07b861$var$LL1Analyzer.HIT_PRED = $2G93d.Token.INVALID_TYPE;
$a7698a95bc07b861$var$__decorate([
    $esDFm.NotNull
], $a7698a95bc07b861$var$LL1Analyzer.prototype, "atn", void 0);
$a7698a95bc07b861$var$__decorate([
    $esDFm.NotNull,
    $a7698a95bc07b861$var$__param(0, $esDFm.NotNull),
    $a7698a95bc07b861$var$__param(1, $esDFm.NotNull)
], $a7698a95bc07b861$var$LL1Analyzer.prototype, "LOOK", null);
$a7698a95bc07b861$var$__decorate([
    $a7698a95bc07b861$var$__param(0, $esDFm.NotNull),
    $a7698a95bc07b861$var$__param(2, $esDFm.NotNull),
    $a7698a95bc07b861$var$__param(3, $esDFm.NotNull),
    $a7698a95bc07b861$var$__param(4, $esDFm.NotNull),
    $a7698a95bc07b861$var$__param(5, $esDFm.NotNull)
], $a7698a95bc07b861$var$LL1Analyzer.prototype, "_LOOK", null);
$a7698a95bc07b861$var$LL1Analyzer = $a7698a95bc07b861$var$__decorate([
    $a7698a95bc07b861$var$__param(0, $esDFm.NotNull)
], $a7698a95bc07b861$var$LL1Analyzer);
module.exports.LL1Analyzer = $a7698a95bc07b861$var$LL1Analyzer;

});
parcelRegister("grncH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bf812ac15f890a0f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $bf812ac15f890a0f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotSetTransition = void 0;

var $esDFm = parcelRequire("esDFm");

var $4mzjd = parcelRequire("4mzjd");
let $bf812ac15f890a0f$var$NotSetTransition = class NotSetTransition extends $4mzjd.SetTransition {
    constructor(target, set){
        super(target, set);
    }
    get serializationType() {
        return 8 /* NOT_SET */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
    }
    toString() {
        return "~" + super.toString();
    }
};
$bf812ac15f890a0f$var$__decorate([
    $esDFm.Override
], $bf812ac15f890a0f$var$NotSetTransition.prototype, "serializationType", null);
$bf812ac15f890a0f$var$__decorate([
    $esDFm.Override
], $bf812ac15f890a0f$var$NotSetTransition.prototype, "matches", null);
$bf812ac15f890a0f$var$__decorate([
    $esDFm.Override
], $bf812ac15f890a0f$var$NotSetTransition.prototype, "toString", null);
$bf812ac15f890a0f$var$NotSetTransition = $bf812ac15f890a0f$var$__decorate([
    $bf812ac15f890a0f$var$__param(0, $esDFm.NotNull),
    $bf812ac15f890a0f$var$__param(1, $esDFm.Nullable)
], $bf812ac15f890a0f$var$NotSetTransition);
module.exports.NotSetTransition = $bf812ac15f890a0f$var$NotSetTransition;

});
parcelRegister("4mzjd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $32d49b192b3581d1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $32d49b192b3581d1$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetTransition = void 0;

var $6og9T = parcelRequire("6og9T");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");

var $i2NOt = parcelRequire("i2NOt");
/** A transition containing a set of values. */ let $32d49b192b3581d1$var$SetTransition = class SetTransition extends $i2NOt.Transition {
    // TODO (sam): should we really allow undefined here?
    constructor(target, set){
        super(target);
        if (set == null) set = $6og9T.IntervalSet.of($2G93d.Token.INVALID_TYPE);
        this.set = set;
    }
    get serializationType() {
        return 7 /* SET */ ;
    }
    get label() {
        return this.set;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this.set.contains(symbol);
    }
    toString() {
        return this.set.toString();
    }
};
$32d49b192b3581d1$var$__decorate([
    $esDFm.NotNull
], $32d49b192b3581d1$var$SetTransition.prototype, "set", void 0);
$32d49b192b3581d1$var$__decorate([
    $esDFm.Override
], $32d49b192b3581d1$var$SetTransition.prototype, "serializationType", null);
$32d49b192b3581d1$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $32d49b192b3581d1$var$SetTransition.prototype, "label", null);
$32d49b192b3581d1$var$__decorate([
    $esDFm.Override
], $32d49b192b3581d1$var$SetTransition.prototype, "matches", null);
$32d49b192b3581d1$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $32d49b192b3581d1$var$SetTransition.prototype, "toString", null);
$32d49b192b3581d1$var$SetTransition = $32d49b192b3581d1$var$__decorate([
    $32d49b192b3581d1$var$__param(0, $esDFm.NotNull),
    $32d49b192b3581d1$var$__param(1, $esDFm.Nullable)
], $32d49b192b3581d1$var$SetTransition);
module.exports.SetTransition = $32d49b192b3581d1$var$SetTransition;

});


parcelRegister("U6v4o", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0a8a45ddfa7016cf$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStopState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
/** The last node in the ATN for a rule, unless that rule is the start symbol.
 *  In that case, there is one transition to EOF. Later, we might encode
 *  references to all calls to this rule to compute FOLLOW sets for
 *  error handling.
 */ class $0a8a45ddfa7016cf$var$RuleStopState extends $17Oz4.ATNState {
    get nonStopStateNumber() {
        return -1;
    }
    get stateType() {
        return $9TBHo.ATNStateType.RULE_STOP;
    }
}
$0a8a45ddfa7016cf$var$__decorate([
    $esDFm.Override
], $0a8a45ddfa7016cf$var$RuleStopState.prototype, "nonStopStateNumber", null);
$0a8a45ddfa7016cf$var$__decorate([
    $esDFm.Override
], $0a8a45ddfa7016cf$var$RuleStopState.prototype, "stateType", null);
module.exports.RuleStopState = $0a8a45ddfa7016cf$var$RuleStopState;

});

parcelRegister("acKOx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $76df56aac7091e8d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $76df56aac7091e8d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleTransition = void 0;

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
/** */ let $76df56aac7091e8d$var$RuleTransition = class RuleTransition extends $i2NOt.Transition {
    constructor(ruleStart, ruleIndex, precedence, followState){
        super(ruleStart);
        this.tailCall = false;
        this.optimizedTailCall = false;
        this.ruleIndex = ruleIndex;
        this.precedence = precedence;
        this.followState = followState;
    }
    get serializationType() {
        return 3 /* RULE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
};
$76df56aac7091e8d$var$__decorate([
    $esDFm.NotNull
], $76df56aac7091e8d$var$RuleTransition.prototype, "followState", void 0);
$76df56aac7091e8d$var$__decorate([
    $esDFm.Override
], $76df56aac7091e8d$var$RuleTransition.prototype, "serializationType", null);
$76df56aac7091e8d$var$__decorate([
    $esDFm.Override
], $76df56aac7091e8d$var$RuleTransition.prototype, "isEpsilon", null);
$76df56aac7091e8d$var$__decorate([
    $esDFm.Override
], $76df56aac7091e8d$var$RuleTransition.prototype, "matches", null);
$76df56aac7091e8d$var$RuleTransition = $76df56aac7091e8d$var$__decorate([
    $76df56aac7091e8d$var$__param(0, $esDFm.NotNull),
    $76df56aac7091e8d$var$__param(3, $esDFm.NotNull)
], $76df56aac7091e8d$var$RuleTransition);
module.exports.RuleTransition = $76df56aac7091e8d$var$RuleTransition;

});

parcelRegister("4EBHJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $36382520b7b8202f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $36382520b7b8202f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WildcardTransition = void 0;

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
let $36382520b7b8202f$var$WildcardTransition = class WildcardTransition extends $i2NOt.Transition {
    constructor(target){
        super(target);
    }
    get serializationType() {
        return 9 /* WILDCARD */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
    }
    toString() {
        return ".";
    }
};
$36382520b7b8202f$var$__decorate([
    $esDFm.Override
], $36382520b7b8202f$var$WildcardTransition.prototype, "serializationType", null);
$36382520b7b8202f$var$__decorate([
    $esDFm.Override
], $36382520b7b8202f$var$WildcardTransition.prototype, "matches", null);
$36382520b7b8202f$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $36382520b7b8202f$var$WildcardTransition.prototype, "toString", null);
$36382520b7b8202f$var$WildcardTransition = $36382520b7b8202f$var$__decorate([
    $36382520b7b8202f$var$__param(0, $esDFm.NotNull)
], $36382520b7b8202f$var$WildcardTransition);
module.exports.WildcardTransition = $36382520b7b8202f$var$WildcardTransition;

});



parcelRegister("khqMx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ec3a2b803d986844$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ec3a2b803d986844$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerActionExecutor = void 0;

var $crbOk = parcelRequire("crbOk");

var $hv3tp = parcelRequire("hv3tp");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Represents an executor for a sequence of lexer actions which traversed during
 * the matching operation of a lexer rule (token).
 *
 * The executor tracks position information for position-dependent lexer actions
 * efficiently, ensuring that actions appearing only at the end of the rule do
 * not cause bloating of the {@link DFA} created for the lexer.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $ec3a2b803d986844$var$LexerActionExecutor = class LexerActionExecutor {
    /**
     * Constructs an executor for a sequence of {@link LexerAction} actions.
     * @param lexerActions The lexer actions to execute.
     */ constructor(lexerActions){
        this._lexerActions = lexerActions;
        let hash = $i99P2.MurmurHash.initialize();
        for (let lexerAction of lexerActions)hash = $i99P2.MurmurHash.update(hash, lexerAction);
        this.cachedHashCode = $i99P2.MurmurHash.finish(hash, lexerActions.length);
    }
    /**
     * Creates a {@link LexerActionExecutor} which executes the actions for
     * the input `lexerActionExecutor` followed by a specified
     * `lexerAction`.
     *
     * @param lexerActionExecutor The executor for actions already traversed by
     * the lexer while matching a token within a particular
     * {@link ATNConfig}. If this is `undefined`, the method behaves as though
     * it were an empty executor.
     * @param lexerAction The lexer action to execute after the actions
     * specified in `lexerActionExecutor`.
     *
     * @returns A {@link LexerActionExecutor} for executing the combine actions
     * of `lexerActionExecutor` and `lexerAction`.
     */ static append(lexerActionExecutor, lexerAction) {
        if (!lexerActionExecutor) return new LexerActionExecutor([
            lexerAction
        ]);
        let lexerActions = lexerActionExecutor._lexerActions.slice(0);
        lexerActions.push(lexerAction);
        return new LexerActionExecutor(lexerActions);
    }
    /**
     * Creates a {@link LexerActionExecutor} which encodes the current offset
     * for position-dependent lexer actions.
     *
     * Normally, when the executor encounters lexer actions where
     * {@link LexerAction#isPositionDependent} returns `true`, it calls
     * {@link IntStream#seek} on the input {@link CharStream} to set the input
     * position to the *end* of the current token. This behavior provides
     * for efficient DFA representation of lexer actions which appear at the end
     * of a lexer rule, even when the lexer rule matches a variable number of
     * characters.
     *
     * Prior to traversing a match transition in the ATN, the current offset
     * from the token start index is assigned to all position-dependent lexer
     * actions which have not already been assigned a fixed offset. By storing
     * the offsets relative to the token start index, the DFA representation of
     * lexer actions which appear in the middle of tokens remains efficient due
     * to sharing among tokens of the same length, regardless of their absolute
     * position in the input stream.
     *
     * If the current executor already has offsets assigned to all
     * position-dependent lexer actions, the method returns `this`.
     *
     * @param offset The current offset to assign to all position-dependent
     * lexer actions which do not already have offsets assigned.
     *
     * @returns A {@link LexerActionExecutor} which stores input stream offsets
     * for all position-dependent lexer actions.
     */ fixOffsetBeforeMatch(offset) {
        let updatedLexerActions;
        for(let i = 0; i < this._lexerActions.length; i++)if (this._lexerActions[i].isPositionDependent && !(this._lexerActions[i] instanceof $hv3tp.LexerIndexedCustomAction)) {
            if (!updatedLexerActions) updatedLexerActions = this._lexerActions.slice(0);
            updatedLexerActions[i] = new $hv3tp.LexerIndexedCustomAction(offset, this._lexerActions[i]);
        }
        if (!updatedLexerActions) return this;
        return new LexerActionExecutor(updatedLexerActions);
    }
    /**
     * Gets the lexer actions to be executed by this executor.
     * @returns The lexer actions to be executed by this executor.
     */ get lexerActions() {
        return this._lexerActions;
    }
    /**
     * Execute the actions encapsulated by this executor within the context of a
     * particular {@link Lexer}.
     *
     * This method calls {@link IntStream#seek} to set the position of the
     * `input` {@link CharStream} prior to calling
     * {@link LexerAction#execute} on a position-dependent action. Before the
     * method returns, the input position will be restored to the same position
     * it was in when the method was invoked.
     *
     * @param lexer The lexer instance.
     * @param input The input stream which is the source for the current token.
     * When this method is called, the current {@link IntStream#index} for
     * `input` should be the start of the following token, i.e. 1
     * character past the end of the current token.
     * @param startIndex The token start index. This value may be passed to
     * {@link IntStream#seek} to set the `input` position to the beginning
     * of the token.
     */ execute(lexer, input, startIndex) {
        let requiresSeek = false;
        let stopIndex = input.index;
        try {
            for (let lexerAction of this._lexerActions){
                if (lexerAction instanceof $hv3tp.LexerIndexedCustomAction) {
                    let offset = lexerAction.offset;
                    input.seek(startIndex + offset);
                    lexerAction = lexerAction.action;
                    requiresSeek = startIndex + offset !== stopIndex;
                } else if (lexerAction.isPositionDependent) {
                    input.seek(stopIndex);
                    requiresSeek = false;
                }
                lexerAction.execute(lexer);
            }
        } finally{
            if (requiresSeek) input.seek(stopIndex);
        }
    }
    hashCode() {
        return this.cachedHashCode;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerActionExecutor)) return false;
        return this.cachedHashCode === obj.cachedHashCode && $crbOk.ArrayEqualityComparator.INSTANCE.equals(this._lexerActions, obj._lexerActions);
    }
};
$ec3a2b803d986844$var$__decorate([
    $esDFm.NotNull
], $ec3a2b803d986844$var$LexerActionExecutor.prototype, "_lexerActions", void 0);
$ec3a2b803d986844$var$__decorate([
    $esDFm.NotNull
], $ec3a2b803d986844$var$LexerActionExecutor.prototype, "lexerActions", null);
$ec3a2b803d986844$var$__decorate([
    $ec3a2b803d986844$var$__param(0, $esDFm.NotNull)
], $ec3a2b803d986844$var$LexerActionExecutor.prototype, "execute", null);
$ec3a2b803d986844$var$__decorate([
    $esDFm.Override
], $ec3a2b803d986844$var$LexerActionExecutor.prototype, "hashCode", null);
$ec3a2b803d986844$var$__decorate([
    $esDFm.Override
], $ec3a2b803d986844$var$LexerActionExecutor.prototype, "equals", null);
$ec3a2b803d986844$var$__decorate([
    $esDFm.NotNull,
    $ec3a2b803d986844$var$__param(1, $esDFm.NotNull)
], $ec3a2b803d986844$var$LexerActionExecutor, "append", null);
$ec3a2b803d986844$var$LexerActionExecutor = $ec3a2b803d986844$var$__decorate([
    $ec3a2b803d986844$var$__param(0, $esDFm.NotNull)
], $ec3a2b803d986844$var$LexerActionExecutor);
module.exports.LexerActionExecutor = $ec3a2b803d986844$var$LexerActionExecutor;

});
parcelRegister("hv3tp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cbd806a78853c705$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $cbd806a78853c705$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerIndexedCustomAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * This implementation of {@link LexerAction} is used for tracking input offsets
 * for position-dependent actions within a {@link LexerActionExecutor}.
 *
 * This action is not serialized as part of the ATN, and is only required for
 * position-dependent lexer actions which appear at a location other than the
 * end of a rule. For more information about DFA optimizations employed for
 * lexer actions, see {@link LexerActionExecutor#append} and
 * {@link LexerActionExecutor#fixOffsetBeforeMatch}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $cbd806a78853c705$var$LexerIndexedCustomAction = class LexerIndexedCustomAction {
    /**
     * Constructs a new indexed custom action by associating a character offset
     * with a {@link LexerAction}.
     *
     * Note: This class is only required for lexer actions for which
     * {@link LexerAction#isPositionDependent} returns `true`.
     *
     * @param offset The offset into the input {@link CharStream}, relative to
     * the token start index, at which the specified lexer action should be
     * executed.
     * @param action The lexer action to execute at a particular offset in the
     * input {@link CharStream}.
     */ constructor(offset, action){
        this._offset = offset;
        this._action = action;
    }
    /**
     * Gets the location in the input {@link CharStream} at which the lexer
     * action should be executed. The value is interpreted as an offset relative
     * to the token start index.
     *
     * @returns The location in the input {@link CharStream} at which the lexer
     * action should be executed.
     */ get offset() {
        return this._offset;
    }
    /**
     * Gets the lexer action to execute.
     *
     * @returns A {@link LexerAction} object which executes the lexer action.
     */ get action() {
        return this._action;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns the result of calling {@link #getActionType}
     * on the {@link LexerAction} returned by {@link #getAction}.
     */ get actionType() {
        return this._action.actionType;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * This method calls {@link #execute} on the result of {@link #getAction}
     * using the provided `lexer`.
     */ execute(lexer) {
        // assume the input stream position was properly set by the calling code
        this._action.execute(lexer);
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this._offset);
        hash = $i99P2.MurmurHash.update(hash, this._action);
        return $i99P2.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerIndexedCustomAction)) return false;
        return this._offset === obj._offset && this._action.equals(obj._action);
    }
};
$cbd806a78853c705$var$__decorate([
    $esDFm.NotNull
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "action", null);
$cbd806a78853c705$var$__decorate([
    $esDFm.Override
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "actionType", null);
$cbd806a78853c705$var$__decorate([
    $esDFm.Override
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "isPositionDependent", null);
$cbd806a78853c705$var$__decorate([
    $esDFm.Override
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "execute", null);
$cbd806a78853c705$var$__decorate([
    $esDFm.Override
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "hashCode", null);
$cbd806a78853c705$var$__decorate([
    $esDFm.Override
], $cbd806a78853c705$var$LexerIndexedCustomAction.prototype, "equals", null);
$cbd806a78853c705$var$LexerIndexedCustomAction = $cbd806a78853c705$var$__decorate([
    $cbd806a78853c705$var$__param(1, $esDFm.NotNull)
], $cbd806a78853c705$var$LexerIndexedCustomAction);
module.exports.LexerIndexedCustomAction = $cbd806a78853c705$var$LexerIndexedCustomAction;

});


parcelRegister("6Npyx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4f2b24917d98a0c1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4f2b24917d98a0c1$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerNoViableAltException = void 0;

var $lWPhg = parcelRequire("lWPhg");

var $esDFm = parcelRequire("esDFm");

var $4Q2DM = parcelRequire("4Q2DM");

var $g4Hat = parcelRequire("g4Hat");
let $4f2b24917d98a0c1$var$LexerNoViableAltException = class LexerNoViableAltException extends $lWPhg.RecognitionException {
    constructor(lexer, input, startIndex, deadEndConfigs){
        super(lexer, input);
        this._startIndex = startIndex;
        this._deadEndConfigs = deadEndConfigs;
    }
    get startIndex() {
        return this._startIndex;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
    get inputStream() {
        return super.inputStream;
    }
    toString() {
        let symbol = "";
        if (this._startIndex >= 0 && this._startIndex < this.inputStream.size) {
            symbol = this.inputStream.getText($4Q2DM.Interval.of(this._startIndex, this._startIndex));
            symbol = $g4Hat.escapeWhitespace(symbol, false);
        }
        // return String.format(Locale.getDefault(), "%s('%s')", LexerNoViableAltException.class.getSimpleName(), symbol);
        return `LexerNoViableAltException('${symbol}')`;
    }
};
$4f2b24917d98a0c1$var$__decorate([
    $esDFm.Override
], $4f2b24917d98a0c1$var$LexerNoViableAltException.prototype, "inputStream", null);
$4f2b24917d98a0c1$var$__decorate([
    $esDFm.Override
], $4f2b24917d98a0c1$var$LexerNoViableAltException.prototype, "toString", null);
$4f2b24917d98a0c1$var$LexerNoViableAltException = $4f2b24917d98a0c1$var$__decorate([
    $4f2b24917d98a0c1$var$__param(1, $esDFm.NotNull)
], $4f2b24917d98a0c1$var$LexerNoViableAltException);
module.exports.LexerNoViableAltException = $4f2b24917d98a0c1$var$LexerNoViableAltException;

});

parcelRegister("jjTpW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e10ac7679ae3108e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OrderedATNConfigSet = void 0;

var $6co2U = parcelRequire("6co2U");

var $esDFm = parcelRequire("esDFm");
/**
 *
 * @author Sam Harwell
 */ class $e10ac7679ae3108e$var$OrderedATNConfigSet extends $6co2U.ATNConfigSet {
    constructor(set, readonly){
        if (set != null && readonly != null) super(set, readonly);
        else super();
    }
    clone(readonly) {
        let copy = new $e10ac7679ae3108e$var$OrderedATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this);
        return copy;
    }
    getKey(e) {
        // This is a specially crafted key to ensure configurations are only merged if they are equal
        return {
            state: 0,
            alt: e.hashCode()
        };
    }
    canMerge(left, leftKey, right) {
        return left.equals(right);
    }
}
$e10ac7679ae3108e$var$__decorate([
    $esDFm.Override
], $e10ac7679ae3108e$var$OrderedATNConfigSet.prototype, "clone", null);
$e10ac7679ae3108e$var$__decorate([
    $esDFm.Override
], $e10ac7679ae3108e$var$OrderedATNConfigSet.prototype, "getKey", null);
$e10ac7679ae3108e$var$__decorate([
    $esDFm.Override
], $e10ac7679ae3108e$var$OrderedATNConfigSet.prototype, "canMerge", null);
module.exports.OrderedATNConfigSet = $e10ac7679ae3108e$var$OrderedATNConfigSet;

});




parcelRegister("4qcTm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3383972d3ce7c61d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoViableAltException = void 0;

var $dDGsq = parcelRequire("dDGsq");

var $lWPhg = parcelRequire("lWPhg");

var $esDFm = parcelRequire("esDFm");
/** Indicates that the parser could not decide which of two or more paths
 *  to take based upon the remaining input. It tracks the starting token
 *  of the offending input and also knows where the parser was
 *  in the various paths when the error. Reported by reportNoViableAlternative()
 */ class $3383972d3ce7c61d$var$NoViableAltException extends $lWPhg.RecognitionException {
    constructor(recognizer, input, startToken, offendingToken, deadEndConfigs, ctx){
        if (recognizer instanceof $dDGsq.Parser) {
            if (input === undefined) input = recognizer.inputStream;
            if (startToken === undefined) startToken = recognizer.currentToken;
            if (offendingToken === undefined) offendingToken = recognizer.currentToken;
            if (ctx === undefined) ctx = recognizer.context;
        }
        super(recognizer, input, ctx);
        this._deadEndConfigs = deadEndConfigs;
        this._startToken = startToken;
        this.setOffendingToken(recognizer, offendingToken);
    }
    get startToken() {
        return this._startToken;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
}
$3383972d3ce7c61d$var$__decorate([
    $esDFm.NotNull
], $3383972d3ce7c61d$var$NoViableAltException.prototype, "_startToken", void 0);
module.exports.NoViableAltException = $3383972d3ce7c61d$var$NoViableAltException;

});
parcelRegister("dDGsq", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9edfda115552908e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9edfda115552908e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var $9edfda115552908e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $g4Hat = parcelRequire("g4Hat");

var $cYBtK = parcelRequire("cYBtK");

var $es7AZ = parcelRequire("es7AZ");

var $cNbax = parcelRequire("cNbax");

var $5zuwY = parcelRequire("5zuwY");

var $9AKkH = parcelRequire("9AKkH");

var $gTQRB = parcelRequire("gTQRB");

var $esDFm = parcelRequire("esDFm");

var $bYNsJ = parcelRequire("bYNsJ");

var $l4uOS = parcelRequire("l4uOS");

var $ct3k0 = parcelRequire("ct3k0");

var $24a4y = parcelRequire("24a4y");

var $6JC52 = parcelRequire("6JC52");

var $2G93d = parcelRequire("2G93d");
class $9edfda115552908e$var$TraceListener {
    constructor(ruleNames, tokenStream){
        this.ruleNames = ruleNames;
        this.tokenStream = tokenStream;
    }
    enterEveryRule(ctx) {
        console.log("enter   " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    exitEveryRule(ctx) {
        console.log("exit    " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    visitErrorNode(node) {
    // intentionally empty
    }
    visitTerminal(node) {
        let parent = node.parent.ruleContext;
        let token = node.symbol;
        console.log("consume " + token + " rule " + this.ruleNames[parent.ruleIndex]);
    }
}
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$TraceListener.prototype, "enterEveryRule", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$TraceListener.prototype, "exitEveryRule", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$TraceListener.prototype, "visitErrorNode", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$TraceListener.prototype, "visitTerminal", null);



/** This is all the parsing support code essentially; most of it is error recovery stuff. */ class $9edfda115552908e$var$Parser extends $24a4y.Recognizer {
    constructor(input){
        super();
        /**
         * The error handling strategy for the parser. The default value is a new
         * instance of {@link DefaultErrorStrategy}.
         *
         * @see #getErrorHandler
         * @see #setErrorHandler
         */ this._errHandler = new $cNbax.DefaultErrorStrategy();
        this._precedenceStack = new $9AKkH.IntegerStack();
        /**
         * Specifies whether or not the parser should construct a parse tree during
         * the parsing process. The default value is `true`.
         *
         * @see `buildParseTree`
         */ this._buildParseTrees = true;
        /**
         * The list of {@link ParseTreeListener} listeners registered to receive
         * events during the parse.
         *
         * @see #addParseListener
         */ this._parseListeners = [];
        /**
         * The number of syntax errors reported during parsing. This value is
         * incremented each time {@link #notifyErrorListeners} is called.
         */ this._syntaxErrors = 0;
        /** Indicates parser has match()ed EOF token. See {@link #exitRule()}. */ this.matchedEOF = false;
        this._precedenceStack.push(0);
        this.inputStream = input;
    }
    reset(resetInput) {
        // Note: this method executes when not parsing, so _ctx can be undefined
        if (resetInput === undefined || resetInput) this.inputStream.seek(0);
        this._errHandler.reset(this);
        this._ctx = undefined;
        this._syntaxErrors = 0;
        this.matchedEOF = false;
        this.isTrace = false;
        this._precedenceStack.clear();
        this._precedenceStack.push(0);
        let interpreter = this.interpreter;
        if (interpreter != null) interpreter.reset();
    }
    /**
     * Match current input symbol against `ttype`. If the symbol type
     * matches, {@link ANTLRErrorStrategy#reportMatch} and {@link #consume} are
     * called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @param ttype the token type to match
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * `ttype` and the error strategy could not recover from the
     * mismatched symbol
     */ match(ttype) {
        let t = this.currentToken;
        if (t.type === ttype) {
            if (ttype === $2G93d.Token.EOF) this.matchedEOF = true;
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Match current input symbol as a wildcard. If the symbol type matches
     * (i.e. has a value greater than 0), {@link ANTLRErrorStrategy#reportMatch}
     * and {@link #consume} are called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link Parser#createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * a wildcard and the error strategy could not recover from the mismatched
     * symbol
     */ matchWildcard() {
        let t = this.currentToken;
        if (t.type > 0) {
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Track the {@link ParserRuleContext} objects during the parse and hook
     * them up using the {@link ParserRuleContext#children} list so that it
     * forms a parse tree. The {@link ParserRuleContext} returned from the start
     * rule represents the root of the parse tree.
     *
     * Note that if we are not building parse trees, rule contexts only point
     * upwards. When a rule exits, it returns the context but that gets garbage
     * collected if nobody holds a reference. It points upwards but nobody
     * points at it.
     *
     * When we build parse trees, we are adding all of these contexts to
     * {@link ParserRuleContext#children} list. Contexts are then not candidates
     * for garbage collection.
     */ set buildParseTree(buildParseTrees) {
        this._buildParseTrees = buildParseTrees;
    }
    /**
     * Gets whether or not a complete parse tree will be constructed while
     * parsing. This property is `true` for a newly constructed parser.
     *
     * @returns `true` if a complete parse tree will be constructed while
     * parsing, otherwise `false`
     */ get buildParseTree() {
        return this._buildParseTrees;
    }
    getParseListeners() {
        return this._parseListeners;
    }
    /**
     * Registers `listener` to receive events during the parsing process.
     *
     * To support output-preserving grammar transformations (including but not
     * limited to left-recursion removal, automated left-factoring, and
     * optimized code generation), calls to listener methods during the parse
     * may differ substantially from calls made by
     * {@link ParseTreeWalker#DEFAULT} used after the parse is complete. In
     * particular, rule entry and exit events may occur in a different order
     * during the parse than after the parser. In addition, calls to certain
     * rule entry methods may be omitted.
     *
     * With the following specific exceptions, calls to listener events are
     * *deterministic*, i.e. for identical input the calls to listener
     * methods will be the same.
     *
     * * Alterations to the grammar used to generate code may change the
     *   behavior of the listener calls.
     * * Alterations to the command line options passed to ANTLR 4 when
     *   generating the parser may change the behavior of the listener calls.
     * * Changing the version of the ANTLR Tool used to generate the parser
     *   may change the behavior of the listener calls.
     *
     * @param listener the listener to add
     *
     * @throws {@link TypeError} if `listener` is `undefined`
     */ addParseListener(listener) {
        if (listener == null) throw new TypeError("listener cannot be null");
        this._parseListeners.push(listener);
    }
    /**
     * Remove `listener` from the list of parse listeners.
     *
     * If `listener` is `undefined` or has not been added as a parse
     * listener, this method does nothing.
     *
     * @see #addParseListener
     *
     * @param listener the listener to remove
     */ removeParseListener(listener) {
        let index = this._parseListeners.findIndex((l)=>l === listener);
        if (index !== -1) this._parseListeners.splice(index, 1);
    }
    /**
     * Remove all parse listeners.
     *
     * @see #addParseListener
     */ removeParseListeners() {
        this._parseListeners.length = 0;
    }
    /**
     * Notify any parse listeners of an enter rule event.
     *
     * @see #addParseListener
     */ triggerEnterRuleEvent() {
        for (let listener of this._parseListeners){
            if (listener.enterEveryRule) listener.enterEveryRule(this._ctx);
            this._ctx.enterRule(listener);
        }
    }
    /**
     * Notify any parse listeners of an exit rule event.
     *
     * @see #addParseListener
     */ triggerExitRuleEvent() {
        // reverse order walk of listeners
        for(let i = this._parseListeners.length - 1; i >= 0; i--){
            let listener = this._parseListeners[i];
            this._ctx.exitRule(listener);
            if (listener.exitEveryRule) listener.exitEveryRule(this._ctx);
        }
    }
    /**
     * Gets the number of syntax errors reported during parsing. This value is
     * incremented each time {@link #notifyErrorListeners} is called.
     *
     * @see #notifyErrorListeners
     */ get numberOfSyntaxErrors() {
        return this._syntaxErrors;
    }
    get tokenFactory() {
        return this._input.tokenSource.tokenFactory;
    }
    /**
     * The ATN with bypass alternatives is expensive to create so we create it
     * lazily.
     *
     * @ if the current parser does not
     * implement the `serializedATN` property.
     */ getATNWithBypassAlts() {
        let serializedAtn = this.serializedATN;
        if (serializedAtn == null) throw new Error("The current parser does not support an ATN with bypass alternatives.");
        let result = $9edfda115552908e$var$Parser.bypassAltsAtnCache.get(serializedAtn);
        if (result == null) {
            let deserializationOptions = new $cYBtK.ATNDeserializationOptions();
            deserializationOptions.isGenerateRuleBypassTransitions = true;
            result = new $es7AZ.ATNDeserializer(deserializationOptions).deserialize($g4Hat.toCharArray(serializedAtn));
            $9edfda115552908e$var$Parser.bypassAltsAtnCache.set(serializedAtn, result);
        }
        return result;
    }
    compileParseTreePattern(pattern, patternRuleIndex, lexer) {
        return $9edfda115552908e$var$__awaiter(this, void 0, void 0, function*() {
            if (!lexer) {
                if (this.inputStream) {
                    let tokenSource = this.inputStream.tokenSource;
                    if (tokenSource instanceof $gTQRB.Lexer) lexer = tokenSource;
                }
                if (!lexer) throw new Error("Parser can't discover a lexer to use");
            }
            let currentLexer = lexer;
            let m = yield Promise.resolve().then(()=>(parcelRequire("gXy9C")));
            let matcher = new m.ParseTreePatternMatcher(currentLexer, this);
            return matcher.compile(pattern, patternRuleIndex);
        });
    }
    get errorHandler() {
        return this._errHandler;
    }
    set errorHandler(handler) {
        this._errHandler = handler;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the token stream and reset the parser. */ set inputStream(input) {
        this.reset(false);
        this._input = input;
    }
    /** Match needs to return the current input symbol, which gets put
     *  into the label for the associated token ref; e.g., x=ID.
     */ get currentToken() {
        return this._input.LT(1);
    }
    notifyErrorListeners(msg, offendingToken, e) {
        if (offendingToken === undefined) offendingToken = this.currentToken;
        else if (offendingToken === null) offendingToken = undefined;
        this._syntaxErrors++;
        let line = -1;
        let charPositionInLine = -1;
        if (offendingToken != null) {
            line = offendingToken.line;
            charPositionInLine = offendingToken.charPositionInLine;
        }
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, offendingToken, line, charPositionInLine, msg, e);
    }
    /**
     * Consume and return the [current symbol](`currentToken`).
     *
     * E.g., given the following input with `A` being the current
     * lookahead symbol, this function moves the cursor to `B` and returns
     * `A`.
     *
     * ```
     * A B
     * ^
     * ```
     *
     * If the parser is not in error recovery mode, the consumed symbol is added
     * to the parse tree using {@link ParserRuleContext#addChild(TerminalNode)}, and
     * {@link ParseTreeListener#visitTerminal} is called on any parse listeners.
     * If the parser *is* in error recovery mode, the consumed symbol is
     * added to the parse tree using {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)} and
     * {@link ParseTreeListener#visitErrorNode} is called on any parse
     * listeners.
     */ consume() {
        let o = this.currentToken;
        if (o.type !== $9edfda115552908e$var$Parser.EOF) this.inputStream.consume();
        let hasListener = this._parseListeners.length !== 0;
        if (this._buildParseTrees || hasListener) {
            if (this._errHandler.inErrorRecoveryMode(this)) {
                let node = this._ctx.addErrorNode(this.createErrorNode(this._ctx, o));
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitErrorNode) listener.visitErrorNode(node);
                }
            } else {
                let node = this.createTerminalNode(this._ctx, o);
                this._ctx.addChild(node);
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitTerminal) listener.visitTerminal(node);
                }
            }
        }
        return o;
    }
    /**
     * How to create a token leaf node associated with a parent.
     * Typically, the terminal node to create is not a function of the parent.
     *
     * @since 4.7
     */ createTerminalNode(parent, t) {
        return new $6JC52.TerminalNode(t);
    }
    /**
     * How to create an error node, given a token, associated with a parent.
     * Typically, the error node to create is not a function of the parent.
     *
     * @since 4.7
     */ createErrorNode(parent, t) {
        return new $5zuwY.ErrorNode(t);
    }
    addContextToParseTree() {
        let parent = this._ctx._parent;
        // add current context to parent if we have a parent
        if (parent != null) parent.addChild(this._ctx);
    }
    /**
     * Always called by generated parsers upon entry to a rule. Access field
     * {@link #_ctx} get the current context.
     */ enterRule(localctx, state, ruleIndex) {
        this.state = state;
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    enterLeftFactoredRule(localctx, state, ruleIndex) {
        this.state = state;
        if (this._buildParseTrees) {
            let factoredContext = this._ctx.getChild(this._ctx.childCount - 1);
            this._ctx.removeLastChild();
            factoredContext._parent = localctx;
            localctx.addChild(factoredContext);
        }
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    exitRule() {
        if (this.matchedEOF) // if we have matched EOF, it cannot consume past EOF so we use LT(1) here
        this._ctx._stop = this._input.LT(1); // LT(1) will be end of file
        else this._ctx._stop = this._input.tryLT(-1); // stop node is what we just matched
        // trigger event on _ctx, before it reverts to parent
        this.triggerExitRuleEvent();
        this.state = this._ctx.invokingState;
        this._ctx = this._ctx._parent;
    }
    enterOuterAlt(localctx, altNum) {
        localctx.altNumber = altNum;
        // if we have new localctx, make sure we replace existing ctx
        // that is previous child of parse tree
        if (this._buildParseTrees && this._ctx !== localctx) {
            let parent = this._ctx._parent;
            if (parent != null) {
                parent.removeLastChild();
                parent.addChild(localctx);
            }
        }
        this._ctx = localctx;
    }
    /**
     * Get the precedence level for the top-most precedence rule.
     *
     * @returns The precedence level for the top-most precedence rule, or -1 if
     * the parser context is not nested within a precedence rule.
     */ get precedence() {
        if (this._precedenceStack.isEmpty) return -1;
        return this._precedenceStack.peek();
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this.state = state;
        this._precedenceStack.push(precedence);
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    /** Like {@link #enterRule} but for recursive rules.
     *  Make the current context the child of the incoming localctx.
     */ pushNewRecursionContext(localctx, state, ruleIndex) {
        let previous = this._ctx;
        previous._parent = localctx;
        previous.invokingState = state;
        previous._stop = this._input.tryLT(-1);
        this._ctx = localctx;
        this._ctx._start = previous._start;
        if (this._buildParseTrees) this._ctx.addChild(previous);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    unrollRecursionContexts(_parentctx) {
        this._precedenceStack.pop();
        this._ctx._stop = this._input.tryLT(-1);
        let retctx = this._ctx; // save current ctx (return value)
        // unroll so _ctx is as it was before call to recursive method
        if (this._parseListeners.length > 0) while(this._ctx !== _parentctx){
            this.triggerExitRuleEvent();
            this._ctx = this._ctx._parent;
        }
        else this._ctx = _parentctx;
        // hook into tree
        retctx._parent = _parentctx;
        if (this._buildParseTrees && _parentctx != null) // add return ctx into invoking rule's tree
        _parentctx.addChild(retctx);
    }
    getInvokingContext(ruleIndex) {
        let p = this._ctx;
        while(p && p.ruleIndex !== ruleIndex)p = p._parent;
        return p;
    }
    get context() {
        return this._ctx;
    }
    set context(ctx) {
        this._ctx = ctx;
    }
    precpred(localctx, precedence) {
        return precedence >= this._precedenceStack.peek();
    }
    getErrorListenerDispatch() {
        return new $ct3k0.ProxyParserErrorListener(this.getErrorListeners());
    }
    inContext(context) {
        // TODO: useful in parser?
        return false;
    }
    /**
     * Checks whether or not `symbol` can follow the current state in the
     * ATN. The behavior of this method is equivalent to the following, but is
     * implemented such that the complete context-sensitive follow set does not
     * need to be explicitly constructed.
     *
     * ```
     * return getExpectedTokens().contains(symbol);
     * ```
     *
     * @param symbol the symbol type to check
     * @returns `true` if `symbol` can follow the current state in
     * the ATN, otherwise `false`.
     */ isExpectedToken(symbol) {
        //   		return interpreter.atn.nextTokens(_ctx);
        let atn = this.interpreter.atn;
        let ctx = this._ctx;
        let s = atn.states[this.state];
        let following = atn.nextTokens(s);
        if (following.contains(symbol)) return true;
        //        System.out.println("following "+s+"="+following);
        if (!following.contains($2G93d.Token.EPSILON)) return false;
        while(ctx != null && ctx.invokingState >= 0 && following.contains($2G93d.Token.EPSILON)){
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = atn.nextTokens(rt.followState);
            if (following.contains(symbol)) return true;
            ctx = ctx._parent;
        }
        if (following.contains($2G93d.Token.EPSILON) && symbol === $2G93d.Token.EOF) return true;
        return false;
    }
    get isMatchedEOF() {
        return this.matchedEOF;
    }
    /**
     * Computes the set of input symbols which could follow the current parser
     * state and context, as given by {@link #getState} and {@link #getContext},
     * respectively.
     *
     * @see ATN#getExpectedTokens(int, RuleContext)
     */ getExpectedTokens() {
        return this.atn.getExpectedTokens(this.state, this.context);
    }
    getExpectedTokensWithinCurrentRule() {
        let atn = this.interpreter.atn;
        let s = atn.states[this.state];
        return atn.nextTokens(s);
    }
    /** Get a rule's index (i.e., `RULE_ruleName` field) or -1 if not found. */ getRuleIndex(ruleName) {
        let ruleIndex = this.getRuleIndexMap().get(ruleName);
        if (ruleIndex != null) return ruleIndex;
        return -1;
    }
    get ruleContext() {
        return this._ctx;
    }
    /** Return List&lt;String&gt; of the rule names in your parser instance
     *  leading up to a call to the current rule.  You could override if
     *  you want more details such as the file/line info of where
     *  in the ATN a rule is invoked.
     *
     *  This is very useful for error messages.
     */ getRuleInvocationStack(ctx = this._ctx) {
        let p = ctx; // Workaround for Microsoft/TypeScript#14487
        let ruleNames = this.ruleNames;
        let stack = [];
        while(p != null){
            // compute what follows who invoked us
            let ruleIndex = p.ruleIndex;
            if (ruleIndex < 0) stack.push("n/a");
            else stack.push(ruleNames[ruleIndex]);
            p = p._parent;
        }
        return stack;
    }
    /** For debugging and other purposes. */ getDFAStrings() {
        let s = [];
        for (let dfa of this._interp.atn.decisionToDFA)s.push(dfa.toString(this.vocabulary, this.ruleNames));
        return s;
    }
    /** For debugging and other purposes. */ dumpDFA() {
        let seenOne = false;
        for (let dfa of this._interp.atn.decisionToDFA)if (!dfa.isEmpty) {
            if (seenOne) console.log();
            console.log("Decision " + dfa.decision + ":");
            $igDjg.stdout.write(dfa.toString(this.vocabulary, this.ruleNames));
            seenOne = true;
        }
    }
    get sourceName() {
        return this._input.sourceName;
    }
    get parseInfo() {
        return Promise.resolve().then(()=>(parcelRequire("dRoiU"))).then((m)=>{
            let interp = this.interpreter;
            if (interp instanceof m.ProfilingATNSimulator) return new $bYNsJ.ParseInfo(interp);
            return undefined;
        });
    }
    /**
     * @since 4.3
     */ setProfile(profile) {
        return $9edfda115552908e$var$__awaiter(this, void 0, void 0, function*() {
            let m = yield Promise.resolve().then(()=>(parcelRequire("dRoiU")));
            let interp = this.interpreter;
            if (profile) {
                if (!(interp instanceof m.ProfilingATNSimulator)) this.interpreter = new m.ProfilingATNSimulator(this);
            } else if (interp instanceof m.ProfilingATNSimulator) this.interpreter = new $l4uOS.ParserATNSimulator(this.atn, this);
            this.interpreter.setPredictionMode(interp.getPredictionMode());
        });
    }
    /** During a parse is sometimes useful to listen in on the rule entry and exit
     *  events as well as token matches. This is for quick and dirty debugging.
     */ set isTrace(trace) {
        if (!trace) {
            if (this._tracer) {
                this.removeParseListener(this._tracer);
                this._tracer = undefined;
            }
        } else {
            if (this._tracer) this.removeParseListener(this._tracer);
            else this._tracer = new $9edfda115552908e$var$TraceListener(this.ruleNames, this._input);
            this.addParseListener(this._tracer);
        }
    }
    /**
     * Gets whether a {@link TraceListener} is registered as a parse listener
     * for the parser.
     */ get isTrace() {
        return this._tracer != null;
    }
}
/**
 * This field maps from the serialized ATN string to the deserialized {@link ATN} with
 * bypass alternatives.
 *
 * @see ATNDeserializationOptions.isGenerateRuleBypassTransitions
 */ $9edfda115552908e$var$Parser.bypassAltsAtnCache = new Map();
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "_errHandler", void 0);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "match", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "matchWildcard", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "getParseListeners", null);
$9edfda115552908e$var$__decorate([
    $9edfda115552908e$var$__param(0, $esDFm.NotNull)
], $9edfda115552908e$var$Parser.prototype, "addParseListener", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "getATNWithBypassAlts", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull,
    $9edfda115552908e$var$__param(0, $esDFm.NotNull)
], $9edfda115552908e$var$Parser.prototype, "errorHandler", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$Parser.prototype, "inputStream", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "currentToken", null);
$9edfda115552908e$var$__decorate([
    $9edfda115552908e$var$__param(0, $esDFm.NotNull)
], $9edfda115552908e$var$Parser.prototype, "enterRule", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override,
    $9edfda115552908e$var$__param(0, $esDFm.Nullable)
], $9edfda115552908e$var$Parser.prototype, "precpred", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$Parser.prototype, "getErrorListenerDispatch", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "getExpectedTokens", null);
$9edfda115552908e$var$__decorate([
    $esDFm.NotNull
], $9edfda115552908e$var$Parser.prototype, "getExpectedTokensWithinCurrentRule", null);
$9edfda115552908e$var$__decorate([
    $esDFm.Override
], $9edfda115552908e$var$Parser.prototype, "parseInfo", null);
module.exports.Parser = $9edfda115552908e$var$Parser;

});
parcelRegister("cYBtK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9728292026f6087a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializationOptions = void 0;

var $esDFm = parcelRequire("esDFm");
/**
 *
 * @author Sam Harwell
 */ class $9728292026f6087a$var$ATNDeserializationOptions {
    constructor(options){
        this.readOnly = false;
        if (options) {
            this.verifyATN = options.verifyATN;
            this.generateRuleBypassTransitions = options.generateRuleBypassTransitions;
            this.optimize = options.optimize;
        } else {
            this.verifyATN = true;
            this.generateRuleBypassTransitions = false;
            this.optimize = true;
        }
    }
    static get defaultOptions() {
        if ($9728292026f6087a$var$ATNDeserializationOptions._defaultOptions == null) {
            $9728292026f6087a$var$ATNDeserializationOptions._defaultOptions = new $9728292026f6087a$var$ATNDeserializationOptions();
            $9728292026f6087a$var$ATNDeserializationOptions._defaultOptions.makeReadOnly();
        }
        return $9728292026f6087a$var$ATNDeserializationOptions._defaultOptions;
    }
    get isReadOnly() {
        return this.readOnly;
    }
    makeReadOnly() {
        this.readOnly = true;
    }
    get isVerifyATN() {
        return this.verifyATN;
    }
    set isVerifyATN(verifyATN) {
        this.throwIfReadOnly();
        this.verifyATN = verifyATN;
    }
    get isGenerateRuleBypassTransitions() {
        return this.generateRuleBypassTransitions;
    }
    set isGenerateRuleBypassTransitions(generateRuleBypassTransitions) {
        this.throwIfReadOnly();
        this.generateRuleBypassTransitions = generateRuleBypassTransitions;
    }
    get isOptimize() {
        return this.optimize;
    }
    set isOptimize(optimize) {
        this.throwIfReadOnly();
        this.optimize = optimize;
    }
    throwIfReadOnly() {
        if (this.isReadOnly) throw new Error("The object is read only.");
    }
}
$9728292026f6087a$var$__decorate([
    $esDFm.NotNull
], $9728292026f6087a$var$ATNDeserializationOptions, "defaultOptions", null);
module.exports.ATNDeserializationOptions = $9728292026f6087a$var$ATNDeserializationOptions;

});

parcelRegister("es7AZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a85992867d098ad4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a85992867d098ad4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializer = void 0;

var $9elhd = parcelRequire("9elhd");

var $fJumX = parcelRequire("fJumX");

var $lDQMG = parcelRequire("lDQMG");

var $cYBtK = parcelRequire("cYBtK");

var $9TBHo = parcelRequire("9TBHo");

var $elgsv = parcelRequire("elgsv");

var $6Wwgi = parcelRequire("6Wwgi");

var $aTslC = parcelRequire("aTslC");

var $lVdCV = parcelRequire("lVdCV");

var $h0Oxm = parcelRequire("h0Oxm");

var $fqwBK = parcelRequire("fqwBK");

var $axZym = parcelRequire("axZym");

var $dLpRd = parcelRequire("dLpRd");

var $4t2Am = parcelRequire("4t2Am");

var $6og9T = parcelRequire("6og9T");

var $2xNwj = parcelRequire("2xNwj");

var $lAw71 = parcelRequire("lAw71");

var $hinaj = parcelRequire("hinaj");

var $jWb5l = parcelRequire("jWb5l");

var $ermyP = parcelRequire("ermyP");

var $lPekc = parcelRequire("lPekc");

var $i50Cm = parcelRequire("i50Cm");

var $8OGST = parcelRequire("8OGST");

var $j6qbp = parcelRequire("j6qbp");

var $3fYXW = parcelRequire("3fYXW");

var $esDFm = parcelRequire("esDFm");

var $grncH = parcelRequire("grncH");

var $l4uOS = parcelRequire("l4uOS");

var $j2EBs = parcelRequire("j2EBs");

var $6U6Db = parcelRequire("6U6Db");

var $l5c3t = parcelRequire("l5c3t");

var $dlxNc = parcelRequire("dlxNc");

var $evTXr = parcelRequire("evTXr");

var $54SKF = parcelRequire("54SKF");

var $U6v4o = parcelRequire("U6v4o");

var $acKOx = parcelRequire("acKOx");

var $4mzjd = parcelRequire("4mzjd");

var $aj3zV = parcelRequire("aj3zV");

var $cLQen = parcelRequire("cLQen");

var $izkyd = parcelRequire("izkyd");

var $2G93d = parcelRequire("2G93d");

var $c0QqZ = parcelRequire("c0QqZ");

var $lkdkr = parcelRequire("lkdkr");

var $4EBHJ = parcelRequire("4EBHJ");
var $a85992867d098ad4$var$UnicodeDeserializingMode;
(function(UnicodeDeserializingMode) {
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_BMP"] = 0] = "UNICODE_BMP";
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_SMP"] = 1] = "UNICODE_SMP";
})($a85992867d098ad4$var$UnicodeDeserializingMode || ($a85992867d098ad4$var$UnicodeDeserializingMode = {}));
/**
 *
 * @author Sam Harwell
 */ class $a85992867d098ad4$var$ATNDeserializer {
    constructor(deserializationOptions){
        if (deserializationOptions === undefined) deserializationOptions = $cYBtK.ATNDeserializationOptions.defaultOptions;
        this.deserializationOptions = deserializationOptions;
    }
    static get SERIALIZED_VERSION() {
        /* This value should never change. Updates following this version are
         * reflected as change in the unique ID SERIALIZED_UUID.
         */ return 3;
    }
    /**
     * Determines if a particular serialized representation of an ATN supports
     * a particular feature, identified by the {@link UUID} used for serializing
     * the ATN at the time the feature was first introduced.
     *
     * @param feature The {@link UUID} marking the first time the feature was
     * supported in the serialized ATN.
     * @param actualUuid The {@link UUID} of the actual serialized ATN which is
     * currently being deserialized.
     * @returns `true` if the `actualUuid` value represents a
     * serialized ATN at or after the feature identified by `feature` was
     * introduced; otherwise, `false`.
     */ static isFeatureSupported(feature, actualUuid) {
        let featureIndex = $a85992867d098ad4$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(feature));
        if (featureIndex < 0) return false;
        return $a85992867d098ad4$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(actualUuid)) >= featureIndex;
    }
    static getUnicodeDeserializer(mode) {
        if (mode === 0 /* UNICODE_BMP */ ) return {
            readUnicode: (data, p)=>{
                return $a85992867d098ad4$var$ATNDeserializer.toInt(data[p]);
            },
            size: 1
        };
        else return {
            readUnicode: (data, p)=>{
                return $a85992867d098ad4$var$ATNDeserializer.toInt32(data, p);
            },
            size: 2
        };
    }
    deserialize(data) {
        data = data.slice(0);
        // Each Uint16 value in data is shifted by +2 at the entry to this method. This is an encoding optimization
        // targeting the serialized values 0 and -1 (serialized to 0xFFFF), each of which are very common in the
        // serialized form of the ATN. In the modified UTF-8 that Java uses for compiled string literals, these two
        // character values have multi-byte forms. By shifting each value by +2, they become characters 2 and 1 prior to
        // writing the string, each of which have single-byte representations. Since the shift occurs in the tool during
        // ATN serialization, each target is responsible for adjusting the values during deserialization.
        //
        // As a special case, note that the first element of data is not adjusted because it contains the major version
        // number of the serialized ATN, which was fixed at 3 at the time the value shifting was implemented.
        for(let i = 1; i < data.length; i++)data[i] = data[i] - 2 & 0xFFFF;
        let p = 0;
        let version = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        if (version !== $a85992867d098ad4$var$ATNDeserializer.SERIALIZED_VERSION) {
            let reason = `Could not deserialize ATN with version ${version} (expected ${$a85992867d098ad4$var$ATNDeserializer.SERIALIZED_VERSION}).`;
            throw new Error(reason);
        }
        let uuid = $a85992867d098ad4$var$ATNDeserializer.toUUID(data, p);
        p += 8;
        if ($a85992867d098ad4$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(uuid)) < 0) {
            let reason = `Could not deserialize ATN with UUID ${uuid} (expected ${$a85992867d098ad4$var$ATNDeserializer.SERIALIZED_UUID} or a legacy UUID).`;
            throw new Error(reason);
        }
        let supportsLexerActions = $a85992867d098ad4$var$ATNDeserializer.isFeatureSupported($a85992867d098ad4$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid);
        let grammarType = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        let maxTokenType = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        let atn = new $lDQMG.ATN(grammarType, maxTokenType);
        //
        // STATES
        //
        let loopBackStateNumbers = [];
        let endStateNumbers = [];
        let nstates = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nstates; i++){
            let stype = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            // ignore bad type of states
            if (stype === $9TBHo.ATNStateType.INVALID_TYPE) {
                atn.addState(new $2xNwj.InvalidState());
                continue;
            }
            let ruleIndex = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            if (ruleIndex === 0xFFFF) ruleIndex = -1;
            let s = this.stateFactory(stype, ruleIndex);
            if (stype === $9TBHo.ATNStateType.LOOP_END) {
                let loopBackStateNumber = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                loopBackStateNumbers.push([
                    s,
                    loopBackStateNumber
                ]);
            } else if (s instanceof $fqwBK.BlockStartState) {
                let endStateNumber = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                endStateNumbers.push([
                    s,
                    endStateNumber
                ]);
            }
            atn.addState(s);
        }
        // delay the assignment of loop back and end states until we know all the state instances have been initialized
        for (let pair of loopBackStateNumbers)pair[0].loopBackState = atn.states[pair[1]];
        for (let pair of endStateNumbers)pair[0].endState = atn.states[pair[1]];
        let numNonGreedyStates = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numNonGreedyStates; i++){
            let stateNumber = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].nonGreedy = true;
        }
        let numSllDecisions = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numSllDecisions; i++){
            let stateNumber = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].sll = true;
        }
        let numPrecedenceStates = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numPrecedenceStates; i++){
            let stateNumber = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].isPrecedenceRule = true;
        }
        //
        // RULES
        //
        let nrules = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        if (atn.grammarType === 0 /* LEXER */ ) atn.ruleToTokenType = new Int32Array(nrules);
        atn.ruleToStartState = new Array(nrules);
        for(let i = 0; i < nrules; i++){
            let s = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            let startState = atn.states[s];
            startState.leftFactored = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]) !== 0;
            atn.ruleToStartState[i] = startState;
            if (atn.grammarType === 0 /* LEXER */ ) {
                let tokenType = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                if (tokenType === 0xFFFF) tokenType = $2G93d.Token.EOF;
                atn.ruleToTokenType[i] = tokenType;
                if (!$a85992867d098ad4$var$ATNDeserializer.isFeatureSupported($a85992867d098ad4$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid)) {
                    // this piece of unused metadata was serialized prior to the
                    // addition of LexerAction
                    let actionIndexIgnored = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                    if (actionIndexIgnored === 0xFFFF) actionIndexIgnored = -1;
                }
            }
        }
        atn.ruleToStopState = new Array(nrules);
        for (let state of atn.states){
            if (!(state instanceof $U6v4o.RuleStopState)) continue;
            atn.ruleToStopState[state.ruleIndex] = state;
            atn.ruleToStartState[state.ruleIndex].stopState = state;
        }
        //
        // MODES
        //
        let nmodes = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nmodes; i++){
            let s = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            atn.modeToStartState.push(atn.states[s]);
        }
        atn.modeToDFA = new Array(nmodes);
        for(let i = 0; i < nmodes; i++)atn.modeToDFA[i] = new $dLpRd.DFA(atn.modeToStartState[i]);
        //
        // SETS
        //
        let sets = [];
        // First, read all sets with 16-bit Unicode code points <= U+FFFF.
        p = this.deserializeSets(data, p, sets, $a85992867d098ad4$var$ATNDeserializer.getUnicodeDeserializer(0 /* UNICODE_BMP */ ));
        // Next, if the ATN was serialized with the Unicode SMP feature,
        // deserialize sets with 32-bit arguments <= U+10FFFF.
        if ($a85992867d098ad4$var$ATNDeserializer.isFeatureSupported($a85992867d098ad4$var$ATNDeserializer.ADDED_UNICODE_SMP, uuid)) p = this.deserializeSets(data, p, sets, $a85992867d098ad4$var$ATNDeserializer.getUnicodeDeserializer(1 /* UNICODE_SMP */ ));
        //
        // EDGES
        //
        let nedges = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nedges; i++){
            let src = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p]);
            let trg = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p + 1]);
            let ttype = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p + 2]);
            let arg1 = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p + 3]);
            let arg2 = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p + 4]);
            let arg3 = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p + 5]);
            let trans = this.edgeFactory(atn, ttype, src, trg, arg1, arg2, arg3, sets);
            // console.log(`EDGE ${trans.constructor.name} ${src}->${trg} ${Transition.serializationNames[ttype]} ${arg1},${arg2},${arg3}`);
            let srcState = atn.states[src];
            srcState.addTransition(trans);
            p += 6;
        }
        let returnTransitionsSet = new $fJumX.Array2DHashSet({
            hashCode: (o)=>o.stopState ^ o.returnState ^ o.outermostPrecedenceReturn,
            equals: (a, b)=>{
                return a.stopState === b.stopState && a.returnState === b.returnState && a.outermostPrecedenceReturn === b.outermostPrecedenceReturn;
            }
        });
        let returnTransitions = [];
        for (let state of atn.states){
            let returningToLeftFactored = state.ruleIndex >= 0 && atn.ruleToStartState[state.ruleIndex].leftFactored;
            for(let i = 0; i < state.numberOfTransitions; i++){
                let t = state.transition(i);
                if (!(t instanceof $acKOx.RuleTransition)) continue;
                let ruleTransition = t;
                let returningFromLeftFactored = atn.ruleToStartState[ruleTransition.target.ruleIndex].leftFactored;
                if (!returningFromLeftFactored && returningToLeftFactored) continue;
                let outermostPrecedenceReturn = -1;
                if (atn.ruleToStartState[ruleTransition.target.ruleIndex].isPrecedenceRule) {
                    if (ruleTransition.precedence === 0) outermostPrecedenceReturn = ruleTransition.target.ruleIndex;
                }
                let current = {
                    stopState: ruleTransition.target.ruleIndex,
                    returnState: ruleTransition.followState.stateNumber,
                    outermostPrecedenceReturn: outermostPrecedenceReturn
                };
                if (returnTransitionsSet.add(current)) returnTransitions.push(current);
            }
        }
        // Add all elements from returnTransitions to the ATN
        for (let returnTransition of returnTransitions){
            let transition = new $4t2Am.EpsilonTransition(atn.states[returnTransition.returnState], returnTransition.outermostPrecedenceReturn);
            atn.ruleToStopState[returnTransition.stopState].addTransition(transition);
        }
        for (let state of atn.states){
            if (state instanceof $fqwBK.BlockStartState) {
                // we need to know the end state to set its start state
                if (state.endState === undefined) throw new Error("IllegalStateException");
                // block end states can only be associated to a single block start state
                if (state.endState.startState !== undefined) throw new Error("IllegalStateException");
                state.endState.startState = state;
            }
            if (state instanceof $6U6Db.PlusLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $j2EBs.PlusBlockStartState) target.loopBackState = loopbackState;
                }
            } else if (state instanceof $cLQen.StarLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $izkyd.StarLoopEntryState) target.loopBackState = loopbackState;
                }
            }
        }
        //
        // DECISIONS
        //
        let ndecisions = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 1; i <= ndecisions; i++){
            let s = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
            let decState = atn.states[s];
            atn.decisionToState.push(decState);
            decState.decision = i - 1;
        }
        //
        // LEXER ACTIONS
        //
        if (atn.grammarType === 0 /* LEXER */ ) {
            if (supportsLexerActions) {
                atn.lexerActions = new Array($a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]));
                for(let i = 0; i < atn.lexerActions.length; i++){
                    let actionType = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                    let data1 = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                    if (data1 === 0xFFFF) data1 = -1;
                    let data2 = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
                    if (data2 === 0xFFFF) data2 = -1;
                    let lexerAction = this.lexerActionFactory(actionType, data1, data2);
                    atn.lexerActions[i] = lexerAction;
                }
            } else {
                // for compatibility with older serialized ATNs, convert the old
                // serialized action index for action transitions to the new
                // form, which is the index of a LexerCustomAction
                let legacyLexerActions = [];
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (!(transition instanceof $9elhd.ActionTransition)) continue;
                    let ruleIndex = transition.ruleIndex;
                    let actionIndex = transition.actionIndex;
                    let lexerAction = new $hinaj.LexerCustomAction(ruleIndex, actionIndex);
                    state.setTransition(i, new $9elhd.ActionTransition(transition.target, ruleIndex, legacyLexerActions.length, false));
                    legacyLexerActions.push(lexerAction);
                }
                atn.lexerActions = legacyLexerActions;
            }
        }
        this.markPrecedenceDecisions(atn);
        atn.decisionToDFA = new Array(ndecisions);
        for(let i = 0; i < ndecisions; i++)atn.decisionToDFA[i] = new $dLpRd.DFA(atn.decisionToState[i], i);
        if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
        if (this.deserializationOptions.isGenerateRuleBypassTransitions && atn.grammarType === 1 /* PARSER */ ) {
            atn.ruleToTokenType = new Int32Array(atn.ruleToStartState.length);
            for(let i = 0; i < atn.ruleToStartState.length; i++)atn.ruleToTokenType[i] = atn.maxTokenType + i + 1;
            for(let i = 0; i < atn.ruleToStartState.length; i++){
                let bypassStart = new $6Wwgi.BasicBlockStartState();
                bypassStart.ruleIndex = i;
                atn.addState(bypassStart);
                let bypassStop = new $h0Oxm.BlockEndState();
                bypassStop.ruleIndex = i;
                atn.addState(bypassStop);
                bypassStart.endState = bypassStop;
                atn.defineDecisionState(bypassStart);
                bypassStop.startState = bypassStart;
                let endState;
                let excludeTransition;
                if (atn.ruleToStartState[i].isPrecedenceRule) {
                    // wrap from the beginning of the rule to the StarLoopEntryState
                    endState = undefined;
                    for (let state of atn.states){
                        if (state.ruleIndex !== i) continue;
                        if (!(state instanceof $izkyd.StarLoopEntryState)) continue;
                        let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                        if (!(maybeLoopEndState instanceof $3fYXW.LoopEndState)) continue;
                        if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $U6v4o.RuleStopState) {
                            endState = state;
                            break;
                        }
                    }
                    if (!endState) throw new Error("Couldn't identify final state of the precedence rule prefix section.");
                    excludeTransition = endState.loopBackState.transition(0);
                } else endState = atn.ruleToStopState[i];
                // all non-excluded transitions that currently target end state need to target blockEnd instead
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (transition === excludeTransition) continue;
                    if (transition.target === endState) transition.target = bypassStop;
                }
                // all transitions leaving the rule start state need to leave blockStart instead
                while(atn.ruleToStartState[i].numberOfTransitions > 0){
                    let transition = atn.ruleToStartState[i].removeTransition(atn.ruleToStartState[i].numberOfTransitions - 1);
                    bypassStart.addTransition(transition);
                }
                // link the new states
                atn.ruleToStartState[i].addTransition(new $4t2Am.EpsilonTransition(bypassStart));
                bypassStop.addTransition(new $4t2Am.EpsilonTransition(endState));
                let matchState = new $aTslC.BasicState();
                atn.addState(matchState);
                matchState.addTransition(new $elgsv.AtomTransition(bypassStop, atn.ruleToTokenType[i]));
                bypassStart.addTransition(new $4t2Am.EpsilonTransition(matchState));
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        if (this.deserializationOptions.isOptimize) {
            while(true){
                let optimizationCount = 0;
                optimizationCount += $a85992867d098ad4$var$ATNDeserializer.inlineSetRules(atn);
                optimizationCount += $a85992867d098ad4$var$ATNDeserializer.combineChainedEpsilons(atn);
                let preserveOrder = atn.grammarType === 0 /* LEXER */ ;
                optimizationCount += $a85992867d098ad4$var$ATNDeserializer.optimizeSets(atn, preserveOrder);
                if (optimizationCount === 0) break;
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        $a85992867d098ad4$var$ATNDeserializer.identifyTailCalls(atn);
        return atn;
    }
    deserializeSets(data, p, sets, unicodeDeserializer) {
        let nsets = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nsets; i++){
            let nintervals = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p]);
            p++;
            let set = new $6og9T.IntervalSet();
            sets.push(set);
            let containsEof = $a85992867d098ad4$var$ATNDeserializer.toInt(data[p++]) !== 0;
            if (containsEof) set.add(-1);
            for(let j = 0; j < nintervals; j++){
                let a = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                let b = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                set.add(a, b);
            }
        }
        return p;
    }
    /**
     * Analyze the {@link StarLoopEntryState} states in the specified ATN to set
     * the {@link StarLoopEntryState#precedenceRuleDecision} field to the
     * correct value.
     *
     * @param atn The ATN.
     */ markPrecedenceDecisions(atn) {
        // Map rule index -> precedence decision for that rule
        let rulePrecedenceDecisions = new Map();
        for (let state of atn.states){
            if (!(state instanceof $izkyd.StarLoopEntryState)) continue;
            /* We analyze the ATN to determine if this ATN decision state is the
             * decision for the closure block that determines whether a
             * precedence rule should continue or complete.
             */ if (atn.ruleToStartState[state.ruleIndex].isPrecedenceRule) {
                let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                if (maybeLoopEndState instanceof $3fYXW.LoopEndState) {
                    if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $U6v4o.RuleStopState) {
                        rulePrecedenceDecisions.set(state.ruleIndex, state);
                        state.precedenceRuleDecision = true;
                        state.precedenceLoopbackStates = new $lVdCV.BitSet(atn.states.length);
                    }
                }
            }
        }
        // After marking precedence decisions, we go back through and fill in
        // StarLoopEntryState.precedenceLoopbackStates.
        for (let precedenceDecision of rulePrecedenceDecisions)for (let transition of atn.ruleToStopState[precedenceDecision[0]].getTransitions()){
            if (transition.serializationType !== 1 /* EPSILON */ ) continue;
            let epsilonTransition = transition;
            if (epsilonTransition.outermostPrecedenceReturn !== -1) continue;
            precedenceDecision[1].precedenceLoopbackStates.set(transition.target.stateNumber);
        }
    }
    verifyATN(atn) {
        // verify assumptions
        for (let state of atn.states){
            this.checkCondition(state !== undefined, "ATN states should not be undefined.");
            if (state.stateType === $9TBHo.ATNStateType.INVALID_TYPE) continue;
            this.checkCondition(state.onlyHasEpsilonTransitions || state.numberOfTransitions <= 1);
            if (state instanceof $j2EBs.PlusBlockStartState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $izkyd.StarLoopEntryState) {
                let starLoopEntryState = state;
                this.checkCondition(starLoopEntryState.loopBackState !== undefined);
                this.checkCondition(starLoopEntryState.numberOfTransitions === 2);
                if (starLoopEntryState.transition(0).target instanceof $aj3zV.StarBlockStartState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $3fYXW.LoopEndState);
                    this.checkCondition(!starLoopEntryState.nonGreedy);
                } else if (starLoopEntryState.transition(0).target instanceof $3fYXW.LoopEndState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $aj3zV.StarBlockStartState);
                    this.checkCondition(starLoopEntryState.nonGreedy);
                } else throw new Error("IllegalStateException");
            }
            if (state instanceof $cLQen.StarLoopbackState) {
                this.checkCondition(state.numberOfTransitions === 1);
                this.checkCondition(state.transition(0).target instanceof $izkyd.StarLoopEntryState);
            }
            if (state instanceof $3fYXW.LoopEndState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $54SKF.RuleStartState) this.checkCondition(state.stopState !== undefined);
            if (state instanceof $fqwBK.BlockStartState) this.checkCondition(state.endState !== undefined);
            if (state instanceof $h0Oxm.BlockEndState) this.checkCondition(state.startState !== undefined);
            if (state instanceof $axZym.DecisionState) {
                let decisionState = state;
                this.checkCondition(decisionState.numberOfTransitions <= 1 || decisionState.decision >= 0);
            } else this.checkCondition(state.numberOfTransitions <= 1 || state instanceof $U6v4o.RuleStopState);
        }
    }
    checkCondition(condition, message) {
        if (!condition) throw new Error("IllegalStateException: " + message);
    }
    static inlineSetRules(atn) {
        let inlinedCalls = 0;
        let ruleToInlineTransition = new Array(atn.ruleToStartState.length);
        for(let i = 0; i < atn.ruleToStartState.length; i++){
            let startState = atn.ruleToStartState[i];
            let middleState = startState;
            while(middleState.onlyHasEpsilonTransitions && middleState.numberOfOptimizedTransitions === 1 && middleState.getOptimizedTransition(0).serializationType === 1 /* EPSILON */ )middleState = middleState.getOptimizedTransition(0).target;
            if (middleState.numberOfOptimizedTransitions !== 1) continue;
            let matchTransition = middleState.getOptimizedTransition(0);
            let matchTarget = matchTransition.target;
            if (matchTransition.isEpsilon || !matchTarget.onlyHasEpsilonTransitions || matchTarget.numberOfOptimizedTransitions !== 1 || !(matchTarget.getOptimizedTransition(0).target instanceof $U6v4o.RuleStopState)) continue;
            switch(matchTransition.serializationType){
                case 5 /* ATOM */ :
                case 2 /* RANGE */ :
                case 7 /* SET */ :
                    ruleToInlineTransition[i] = matchTransition;
                    break;
                case 8 /* NOT_SET */ :
                case 9 /* WILDCARD */ :
                    continue;
                default:
                    continue;
            }
        }
        for (let state of atn.states){
            if (state.ruleIndex < 0) continue;
            let optimizedTransitions;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $acKOx.RuleTransition)) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                let ruleTransition = transition;
                let effective = ruleToInlineTransition[ruleTransition.target.ruleIndex];
                if (effective === undefined) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(i));
                }
                inlinedCalls++;
                let target = ruleTransition.followState;
                let intermediateState = new $aTslC.BasicState();
                intermediateState.setRuleIndex(target.ruleIndex);
                atn.addState(intermediateState);
                optimizedTransitions.push(new $4t2Am.EpsilonTransition(intermediateState));
                switch(effective.serializationType){
                    case 5 /* ATOM */ :
                        intermediateState.addTransition(new $elgsv.AtomTransition(target, effective._label));
                        break;
                    case 2 /* RANGE */ :
                        intermediateState.addTransition(new $evTXr.RangeTransition(target, effective.from, effective.to));
                        break;
                    case 7 /* SET */ :
                        intermediateState.addTransition(new $4mzjd.SetTransition(target, effective.label));
                        break;
                    default:
                        throw new Error("UnsupportedOperationException");
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($l4uOS.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + inlinedCalls + " rule invocations by inlining sets.");
        return inlinedCalls;
    }
    static combineChainedEpsilons(atn) {
        let removedEdges = 0;
        for (let state of atn.states){
            if (!state.onlyHasEpsilonTransitions || state instanceof $U6v4o.RuleStopState) continue;
            let optimizedTransitions;
            nextTransition: for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                let intermediate = transition.target;
                if (transition.serializationType !== 1 /* EPSILON */  || transition.outermostPrecedenceReturn !== -1 || intermediate.stateType !== $9TBHo.ATNStateType.BASIC || !intermediate.onlyHasEpsilonTransitions) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++)if (intermediate.getOptimizedTransition(j).serializationType !== 1 /* EPSILON */  || intermediate.getOptimizedTransition(j).outermostPrecedenceReturn !== -1) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                removedEdges++;
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(j));
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++){
                    let target = intermediate.getOptimizedTransition(j).target;
                    optimizedTransitions.push(new $4t2Am.EpsilonTransition(target));
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($l4uOS.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedEdges + " transitions by combining chained epsilon transitions.");
        return removedEdges;
    }
    static optimizeSets(atn, preserveOrder) {
        if (preserveOrder) // this optimization currently doesn't preserve edge order.
        return 0;
        let removedPaths = 0;
        let decisions = atn.decisionToState;
        for (let decision of decisions){
            let setTransitions = new $6og9T.IntervalSet();
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++){
                let epsTransition = decision.getOptimizedTransition(i);
                if (!(epsTransition instanceof $4t2Am.EpsilonTransition)) continue;
                if (epsTransition.target.numberOfOptimizedTransitions !== 1) continue;
                let transition = epsTransition.target.getOptimizedTransition(0);
                if (!(transition.target instanceof $h0Oxm.BlockEndState)) continue;
                if (transition instanceof $grncH.NotSetTransition) continue;
                if (transition instanceof $elgsv.AtomTransition || transition instanceof $evTXr.RangeTransition || transition instanceof $4mzjd.SetTransition) setTransitions.add(i);
            }
            if (setTransitions.size <= 1) continue;
            let optimizedTransitions = [];
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++)if (!setTransitions.contains(i)) optimizedTransitions.push(decision.getOptimizedTransition(i));
            let blockEndState = decision.getOptimizedTransition(setTransitions.minElement).target.getOptimizedTransition(0).target;
            let matchSet = new $6og9T.IntervalSet();
            for (let interval of setTransitions.intervals)for(let j = interval.a; j <= interval.b; j++){
                let matchTransition = decision.getOptimizedTransition(j).target.getOptimizedTransition(0);
                if (matchTransition instanceof $grncH.NotSetTransition) throw new Error("Not yet implemented.");
                else matchSet.addAll(matchTransition.label);
            }
            let newTransition;
            if (matchSet.intervals.length === 1) {
                if (matchSet.size === 1) newTransition = new $elgsv.AtomTransition(blockEndState, matchSet.minElement);
                else {
                    let matchInterval = matchSet.intervals[0];
                    newTransition = new $evTXr.RangeTransition(blockEndState, matchInterval.a, matchInterval.b);
                }
            } else newTransition = new $4mzjd.SetTransition(blockEndState, matchSet);
            let setOptimizedState = new $aTslC.BasicState();
            setOptimizedState.setRuleIndex(decision.ruleIndex);
            atn.addState(setOptimizedState);
            setOptimizedState.addTransition(newTransition);
            optimizedTransitions.push(new $4t2Am.EpsilonTransition(setOptimizedState));
            removedPaths += decision.numberOfOptimizedTransitions - optimizedTransitions.length;
            if (decision.isOptimized) while(decision.numberOfOptimizedTransitions > 0)decision.removeOptimizedTransition(decision.numberOfOptimizedTransitions - 1);
            for (let transition of optimizedTransitions)decision.addOptimizedTransition(transition);
        }
        if ($l4uOS.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedPaths + " paths by collapsing sets.");
        return removedPaths;
    }
    static identifyTailCalls(atn) {
        for (let state of atn.states){
            for(let i = 0; i < state.numberOfTransitions; i++){
                let transition = state.transition(i);
                if (!(transition instanceof $acKOx.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
            if (!state.isOptimized) continue;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $acKOx.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
        }
    }
    static testTailCall(atn, transition, optimizedPath) {
        if (!optimizedPath && transition.tailCall) return true;
        if (optimizedPath && transition.optimizedTailCall) return true;
        let reachable = new $lVdCV.BitSet(atn.states.length);
        let worklist = [];
        worklist.push(transition.followState);
        while(true){
            let state = worklist.pop();
            if (!state) break;
            if (reachable.get(state.stateNumber)) continue;
            if (state instanceof $U6v4o.RuleStopState) continue;
            if (!state.onlyHasEpsilonTransitions) return false;
            let transitionCount = optimizedPath ? state.numberOfOptimizedTransitions : state.numberOfTransitions;
            for(let i = 0; i < transitionCount; i++){
                let t = optimizedPath ? state.getOptimizedTransition(i) : state.transition(i);
                if (t.serializationType !== 1 /* EPSILON */ ) return false;
                worklist.push(t.target);
            }
        }
        return true;
    }
    static toInt(c) {
        return c;
    }
    static toInt32(data, offset) {
        return (data[offset] | data[offset + 1] << 16) >>> 0;
    }
    static toUUID(data, offset) {
        let leastSigBits = $a85992867d098ad4$var$ATNDeserializer.toInt32(data, offset);
        let lessSigBits = $a85992867d098ad4$var$ATNDeserializer.toInt32(data, offset + 2);
        let moreSigBits = $a85992867d098ad4$var$ATNDeserializer.toInt32(data, offset + 4);
        let mostSigBits = $a85992867d098ad4$var$ATNDeserializer.toInt32(data, offset + 6);
        return new $lkdkr.UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    edgeFactory(atn, type, src, trg, arg1, arg2, arg3, sets) {
        let target = atn.states[trg];
        switch(type){
            case 1 /* EPSILON */ :
                return new $4t2Am.EpsilonTransition(target);
            case 2 /* RANGE */ :
                if (arg3 !== 0) return new $evTXr.RangeTransition(target, $2G93d.Token.EOF, arg2);
                else return new $evTXr.RangeTransition(target, arg1, arg2);
            case 3 /* RULE */ :
                let rt = new $acKOx.RuleTransition(atn.states[arg1], arg2, arg3, target);
                return rt;
            case 4 /* PREDICATE */ :
                let pt = new $dlxNc.PredicateTransition(target, arg1, arg2, arg3 !== 0);
                return pt;
            case 10 /* PRECEDENCE */ :
                return new $l5c3t.PrecedencePredicateTransition(target, arg1);
            case 5 /* ATOM */ :
                if (arg3 !== 0) return new $elgsv.AtomTransition(target, $2G93d.Token.EOF);
                else return new $elgsv.AtomTransition(target, arg1);
            case 6 /* ACTION */ :
                let a = new $9elhd.ActionTransition(target, arg1, arg2, arg3 !== 0);
                return a;
            case 7 /* SET */ :
                return new $4mzjd.SetTransition(target, sets[arg1]);
            case 8 /* NOT_SET */ :
                return new $grncH.NotSetTransition(target, sets[arg1]);
            case 9 /* WILDCARD */ :
                return new $4EBHJ.WildcardTransition(target);
        }
        throw new Error("The specified transition type is not valid.");
    }
    stateFactory(type, ruleIndex) {
        let s;
        switch(type){
            case $9TBHo.ATNStateType.INVALID_TYPE:
                return new $2xNwj.InvalidState();
            case $9TBHo.ATNStateType.BASIC:
                s = new $aTslC.BasicState();
                break;
            case $9TBHo.ATNStateType.RULE_START:
                s = new $54SKF.RuleStartState();
                break;
            case $9TBHo.ATNStateType.BLOCK_START:
                s = new $6Wwgi.BasicBlockStartState();
                break;
            case $9TBHo.ATNStateType.PLUS_BLOCK_START:
                s = new $j2EBs.PlusBlockStartState();
                break;
            case $9TBHo.ATNStateType.STAR_BLOCK_START:
                s = new $aj3zV.StarBlockStartState();
                break;
            case $9TBHo.ATNStateType.TOKEN_START:
                s = new $c0QqZ.TokensStartState();
                break;
            case $9TBHo.ATNStateType.RULE_STOP:
                s = new $U6v4o.RuleStopState();
                break;
            case $9TBHo.ATNStateType.BLOCK_END:
                s = new $h0Oxm.BlockEndState();
                break;
            case $9TBHo.ATNStateType.STAR_LOOP_BACK:
                s = new $cLQen.StarLoopbackState();
                break;
            case $9TBHo.ATNStateType.STAR_LOOP_ENTRY:
                s = new $izkyd.StarLoopEntryState();
                break;
            case $9TBHo.ATNStateType.PLUS_LOOP_BACK:
                s = new $6U6Db.PlusLoopbackState();
                break;
            case $9TBHo.ATNStateType.LOOP_END:
                s = new $3fYXW.LoopEndState();
                break;
            default:
                let message = `The specified state type ${type} is not valid.`;
                throw new Error(message);
        }
        s.ruleIndex = ruleIndex;
        return s;
    }
    lexerActionFactory(type, data1, data2) {
        switch(type){
            case 0 /* CHANNEL */ :
                return new $lAw71.LexerChannelAction(data1);
            case 1 /* CUSTOM */ :
                return new $hinaj.LexerCustomAction(data1, data2);
            case 2 /* MODE */ :
                return new $jWb5l.LexerModeAction(data1);
            case 3 /* MORE */ :
                return $ermyP.LexerMoreAction.INSTANCE;
            case 4 /* POP_MODE */ :
                return $lPekc.LexerPopModeAction.INSTANCE;
            case 5 /* PUSH_MODE */ :
                return new $i50Cm.LexerPushModeAction(data1);
            case 6 /* SKIP */ :
                return $8OGST.LexerSkipAction.INSTANCE;
            case 7 /* TYPE */ :
                return new $j6qbp.LexerTypeAction(data1);
            default:
                let message = `The specified lexer action type ${type} is not valid.`;
                throw new Error(message);
        }
    }
}
/* WARNING: DO NOT MERGE THESE LINES. If UUIDs differ during a merge,
 * resolve the conflict by generating a new ID!
 */ /**
 * This is the earliest supported serialized UUID.
 */ $a85992867d098ad4$var$ATNDeserializer.BASE_SERIALIZED_UUID = $lkdkr.UUID.fromString("E4178468-DF95-44D0-AD87-F22A5D5FB6D3");
/**
 * This UUID indicates an extension of {@link #ADDED_PRECEDENCE_TRANSITIONS}
 * for the addition of lexer actions encoded as a sequence of
 * {@link LexerAction} instances.
 */ $a85992867d098ad4$var$ATNDeserializer.ADDED_LEXER_ACTIONS = $lkdkr.UUID.fromString("AB35191A-1603-487E-B75A-479B831EAF6D");
/**
 * This UUID indicates the serialized ATN contains two sets of
 * IntervalSets, where the second set's values are encoded as
 * 32-bit integers to support the full Unicode SMP range up to U+10FFFF.
 */ $a85992867d098ad4$var$ATNDeserializer.ADDED_UNICODE_SMP = $lkdkr.UUID.fromString("C23FEA89-0605-4f51-AFB8-058BCAB8C91B");
/**
 * This list contains all of the currently supported UUIDs, ordered by when
 * the feature first appeared in this branch.
 */ $a85992867d098ad4$var$ATNDeserializer.SUPPORTED_UUIDS = [
    $a85992867d098ad4$var$ATNDeserializer.BASE_SERIALIZED_UUID,
    $a85992867d098ad4$var$ATNDeserializer.ADDED_LEXER_ACTIONS,
    $a85992867d098ad4$var$ATNDeserializer.ADDED_UNICODE_SMP
];
/**
 * This is the current serialized UUID.
 */ $a85992867d098ad4$var$ATNDeserializer.SERIALIZED_UUID = $a85992867d098ad4$var$ATNDeserializer.ADDED_UNICODE_SMP;
$a85992867d098ad4$var$__decorate([
    $esDFm.NotNull
], $a85992867d098ad4$var$ATNDeserializer.prototype, "deserializationOptions", void 0);
$a85992867d098ad4$var$__decorate([
    $a85992867d098ad4$var$__param(0, $esDFm.NotNull)
], $a85992867d098ad4$var$ATNDeserializer.prototype, "deserialize", null);
$a85992867d098ad4$var$__decorate([
    $a85992867d098ad4$var$__param(0, $esDFm.NotNull)
], $a85992867d098ad4$var$ATNDeserializer.prototype, "markPrecedenceDecisions", null);
$a85992867d098ad4$var$__decorate([
    $esDFm.NotNull,
    $a85992867d098ad4$var$__param(0, $esDFm.NotNull)
], $a85992867d098ad4$var$ATNDeserializer.prototype, "edgeFactory", null);
module.exports.ATNDeserializer = $a85992867d098ad4$var$ATNDeserializer;

});
parcelRegister("9elhd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6b85ecfc8f932b00$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6b85ecfc8f932b00$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionTransition = void 0;

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
let $6b85ecfc8f932b00$var$ActionTransition = class ActionTransition extends $i2NOt.Transition {
    constructor(target, ruleIndex, actionIndex = -1, isCtxDependent = false){
        super(target);
        this.ruleIndex = ruleIndex;
        this.actionIndex = actionIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 6 /* ACTION */ ;
    }
    get isEpsilon() {
        return true; // we are to be ignored by analysis 'cept for predicates
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "action_" + this.ruleIndex + ":" + this.actionIndex;
    }
};
$6b85ecfc8f932b00$var$__decorate([
    $esDFm.Override
], $6b85ecfc8f932b00$var$ActionTransition.prototype, "serializationType", null);
$6b85ecfc8f932b00$var$__decorate([
    $esDFm.Override
], $6b85ecfc8f932b00$var$ActionTransition.prototype, "isEpsilon", null);
$6b85ecfc8f932b00$var$__decorate([
    $esDFm.Override
], $6b85ecfc8f932b00$var$ActionTransition.prototype, "matches", null);
$6b85ecfc8f932b00$var$__decorate([
    $esDFm.Override
], $6b85ecfc8f932b00$var$ActionTransition.prototype, "toString", null);
$6b85ecfc8f932b00$var$ActionTransition = $6b85ecfc8f932b00$var$__decorate([
    $6b85ecfc8f932b00$var$__param(0, $esDFm.NotNull)
], $6b85ecfc8f932b00$var$ActionTransition);
module.exports.ActionTransition = $6b85ecfc8f932b00$var$ActionTransition;

});

parcelRegister("elgsv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a70fcb33cb62f153$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a70fcb33cb62f153$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtomTransition = void 0;

var $6og9T = parcelRequire("6og9T");

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
/** TODO: make all transitions sets? no, should remove set edges */ let $a70fcb33cb62f153$var$AtomTransition = class AtomTransition extends $i2NOt.Transition {
    constructor(target, label){
        super(target);
        this._label = label;
    }
    get serializationType() {
        return 5 /* ATOM */ ;
    }
    get label() {
        return $6og9T.IntervalSet.of(this._label);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this._label === symbol;
    }
    toString() {
        return String(this.label);
    }
};
$a70fcb33cb62f153$var$__decorate([
    $esDFm.Override
], $a70fcb33cb62f153$var$AtomTransition.prototype, "serializationType", null);
$a70fcb33cb62f153$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $a70fcb33cb62f153$var$AtomTransition.prototype, "label", null);
$a70fcb33cb62f153$var$__decorate([
    $esDFm.Override
], $a70fcb33cb62f153$var$AtomTransition.prototype, "matches", null);
$a70fcb33cb62f153$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $a70fcb33cb62f153$var$AtomTransition.prototype, "toString", null);
$a70fcb33cb62f153$var$AtomTransition = $a70fcb33cb62f153$var$__decorate([
    $a70fcb33cb62f153$var$__param(0, $esDFm.NotNull)
], $a70fcb33cb62f153$var$AtomTransition);
module.exports.AtomTransition = $a70fcb33cb62f153$var$AtomTransition;

});

parcelRegister("6Wwgi", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $50e12f5dabf960d1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicBlockStartState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $fqwBK = parcelRequire("fqwBK");

var $esDFm = parcelRequire("esDFm");
/**
 *
 * @author Sam Harwell
 */ class $50e12f5dabf960d1$var$BasicBlockStartState extends $fqwBK.BlockStartState {
    get stateType() {
        return $9TBHo.ATNStateType.BLOCK_START;
    }
}
$50e12f5dabf960d1$var$__decorate([
    $esDFm.Override
], $50e12f5dabf960d1$var$BasicBlockStartState.prototype, "stateType", null);
module.exports.BasicBlockStartState = $50e12f5dabf960d1$var$BasicBlockStartState;

});
parcelRegister("fqwBK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockStartState = void 0;

var $axZym = parcelRequire("axZym");
/**  The start of a regular `(...)` block. */ class $b3b293f71aea38f4$var$BlockStartState extends $axZym.DecisionState {
}
module.exports.BlockStartState = $b3b293f71aea38f4$var$BlockStartState;

});


parcelRegister("h0Oxm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c629a360f3a068ca$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockEndState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
/** Terminal node of a simple `(a|b|c)` block. */ class $c629a360f3a068ca$var$BlockEndState extends $17Oz4.ATNState {
    get stateType() {
        return $9TBHo.ATNStateType.BLOCK_END;
    }
}
$c629a360f3a068ca$var$__decorate([
    $esDFm.Override
], $c629a360f3a068ca$var$BlockEndState.prototype, "stateType", null);
module.exports.BlockEndState = $c629a360f3a068ca$var$BlockEndState;

});

parcelRegister("4t2Am", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $340be0435f71aac4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $340be0435f71aac4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EpsilonTransition = void 0;

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
let $340be0435f71aac4$var$EpsilonTransition = class EpsilonTransition extends $i2NOt.Transition {
    constructor(target, outermostPrecedenceReturn = -1){
        super(target);
        this._outermostPrecedenceReturn = outermostPrecedenceReturn;
    }
    /**
     * @returns the rule index of a precedence rule for which this transition is
     * returning from, where the precedence value is 0; otherwise, -1.
     *
     * @see ATNConfig.isPrecedenceFilterSuppressed
     * @see ParserATNSimulator#applyPrecedenceFilter(ATNConfigSet, ParserRuleContext, PredictionContextCache)
     * @since 4.4.1
     */ get outermostPrecedenceReturn() {
        return this._outermostPrecedenceReturn;
    }
    get serializationType() {
        return 1 /* EPSILON */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "epsilon";
    }
};
$340be0435f71aac4$var$__decorate([
    $esDFm.Override
], $340be0435f71aac4$var$EpsilonTransition.prototype, "serializationType", null);
$340be0435f71aac4$var$__decorate([
    $esDFm.Override
], $340be0435f71aac4$var$EpsilonTransition.prototype, "isEpsilon", null);
$340be0435f71aac4$var$__decorate([
    $esDFm.Override
], $340be0435f71aac4$var$EpsilonTransition.prototype, "matches", null);
$340be0435f71aac4$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $340be0435f71aac4$var$EpsilonTransition.prototype, "toString", null);
$340be0435f71aac4$var$EpsilonTransition = $340be0435f71aac4$var$__decorate([
    $340be0435f71aac4$var$__param(0, $esDFm.NotNull)
], $340be0435f71aac4$var$EpsilonTransition);
module.exports.EpsilonTransition = $340be0435f71aac4$var$EpsilonTransition;

});

parcelRegister("lAw71", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fb75de970db175c7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fb75de970db175c7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerChannelAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `channel` lexer action by calling
 * {@link Lexer#setChannel} with the assigned channel.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $fb75de970db175c7$var$LexerChannelAction {
    /**
     * Constructs a new `channel` action with the specified channel value.
     * @param channel The channel value to pass to {@link Lexer#setChannel}.
     */ constructor(channel){
        this._channel = channel;
    }
    /**
     * Gets the channel to use for the {@link Token} created by the lexer.
     *
     * @returns The channel to use for the {@link Token} created by the lexer.
     */ get channel() {
        return this._channel;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#CHANNEL}.
     */ get actionType() {
        return 0 /* CHANNEL */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#setChannel} with the
     * value provided by {@link #getChannel}.
     */ execute(lexer) {
        lexer.channel = this._channel;
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        hash = $i99P2.MurmurHash.update(hash, this._channel);
        return $i99P2.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $fb75de970db175c7$var$LexerChannelAction)) return false;
        return this._channel === obj._channel;
    }
    toString() {
        return `channel(${this._channel})`;
    }
}
$fb75de970db175c7$var$__decorate([
    $esDFm.Override
], $fb75de970db175c7$var$LexerChannelAction.prototype, "actionType", null);
$fb75de970db175c7$var$__decorate([
    $esDFm.Override
], $fb75de970db175c7$var$LexerChannelAction.prototype, "isPositionDependent", null);
$fb75de970db175c7$var$__decorate([
    $esDFm.Override,
    $fb75de970db175c7$var$__param(0, $esDFm.NotNull)
], $fb75de970db175c7$var$LexerChannelAction.prototype, "execute", null);
$fb75de970db175c7$var$__decorate([
    $esDFm.Override
], $fb75de970db175c7$var$LexerChannelAction.prototype, "hashCode", null);
$fb75de970db175c7$var$__decorate([
    $esDFm.Override
], $fb75de970db175c7$var$LexerChannelAction.prototype, "equals", null);
$fb75de970db175c7$var$__decorate([
    $esDFm.Override
], $fb75de970db175c7$var$LexerChannelAction.prototype, "toString", null);
module.exports.LexerChannelAction = $fb75de970db175c7$var$LexerChannelAction;

});

parcelRegister("hinaj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c976164228d63343$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c976164228d63343$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerCustomAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Executes a custom lexer action by calling {@link Recognizer#action} with the
 * rule and action indexes assigned to the custom action. The implementation of
 * a custom action is added to the generated code for the lexer in an override
 * of {@link Recognizer#action} when the grammar is compiled.
 *
 * This class may represent embedded actions created with the `{...}`
 * syntax in ANTLR 4, as well as actions created for lexer commands where the
 * command argument could not be evaluated when the grammar was compiled.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $c976164228d63343$var$LexerCustomAction {
    /**
     * Constructs a custom lexer action with the specified rule and action
     * indexes.
     *
     * @param ruleIndex The rule index to use for calls to
     * {@link Recognizer#action}.
     * @param actionIndex The action index to use for calls to
     * {@link Recognizer#action}.
     */ constructor(ruleIndex, actionIndex){
        this._ruleIndex = ruleIndex;
        this._actionIndex = actionIndex;
    }
    /**
     * Gets the rule index to use for calls to {@link Recognizer#action}.
     *
     * @returns The rule index for the custom action.
     */ get ruleIndex() {
        return this._ruleIndex;
    }
    /**
     * Gets the action index to use for calls to {@link Recognizer#action}.
     *
     * @returns The action index for the custom action.
     */ get actionIndex() {
        return this._actionIndex;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns {@link LexerActionType#CUSTOM}.
     */ get actionType() {
        return 1 /* CUSTOM */ ;
    }
    /**
     * Gets whether the lexer action is position-dependent. Position-dependent
     * actions may have different semantics depending on the {@link CharStream}
     * index at the time the action is executed.
     *
     * Custom actions are position-dependent since they may represent a
     * user-defined embedded action which makes calls to methods like
     * {@link Lexer#getText}.
     *
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * Custom actions are implemented by calling {@link Lexer#action} with the
     * appropriate rule and action indexes.
     */ execute(lexer) {
        lexer.action(undefined, this._ruleIndex, this._actionIndex);
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        hash = $i99P2.MurmurHash.update(hash, this._ruleIndex);
        hash = $i99P2.MurmurHash.update(hash, this._actionIndex);
        return $i99P2.MurmurHash.finish(hash, 3);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $c976164228d63343$var$LexerCustomAction)) return false;
        return this._ruleIndex === obj._ruleIndex && this._actionIndex === obj._actionIndex;
    }
}
$c976164228d63343$var$__decorate([
    $esDFm.Override
], $c976164228d63343$var$LexerCustomAction.prototype, "actionType", null);
$c976164228d63343$var$__decorate([
    $esDFm.Override
], $c976164228d63343$var$LexerCustomAction.prototype, "isPositionDependent", null);
$c976164228d63343$var$__decorate([
    $esDFm.Override,
    $c976164228d63343$var$__param(0, $esDFm.NotNull)
], $c976164228d63343$var$LexerCustomAction.prototype, "execute", null);
$c976164228d63343$var$__decorate([
    $esDFm.Override
], $c976164228d63343$var$LexerCustomAction.prototype, "hashCode", null);
$c976164228d63343$var$__decorate([
    $esDFm.Override
], $c976164228d63343$var$LexerCustomAction.prototype, "equals", null);
module.exports.LexerCustomAction = $c976164228d63343$var$LexerCustomAction;

});

parcelRegister("jWb5l", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e83c08696b675ccd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e83c08696b675ccd$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerModeAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `mode` lexer action by calling {@link Lexer#mode} with
 * the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $e83c08696b675ccd$var$LexerModeAction {
    /**
     * Constructs a new `mode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#mode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `mode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MODE}.
     */ get actionType() {
        return 2 /* MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#mode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.mode(this._mode);
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        hash = $i99P2.MurmurHash.update(hash, this._mode);
        return $i99P2.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $e83c08696b675ccd$var$LexerModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `mode(${this._mode})`;
    }
}
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override
], $e83c08696b675ccd$var$LexerModeAction.prototype, "actionType", null);
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override
], $e83c08696b675ccd$var$LexerModeAction.prototype, "isPositionDependent", null);
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override,
    $e83c08696b675ccd$var$__param(0, $esDFm.NotNull)
], $e83c08696b675ccd$var$LexerModeAction.prototype, "execute", null);
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override
], $e83c08696b675ccd$var$LexerModeAction.prototype, "hashCode", null);
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override
], $e83c08696b675ccd$var$LexerModeAction.prototype, "equals", null);
$e83c08696b675ccd$var$__decorate([
    $esDFm.Override
], $e83c08696b675ccd$var$LexerModeAction.prototype, "toString", null);
module.exports.LexerModeAction = $e83c08696b675ccd$var$LexerModeAction;

});

parcelRegister("ermyP", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a835166398566135$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a835166398566135$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerMoreAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `more` lexer action by calling {@link Lexer#more}.
 *
 * The `more` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $a835166398566135$var$LexerMoreAction {
    /**
     * Constructs the singleton instance of the lexer `more` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MORE}.
     */ get actionType() {
        return 3 /* MORE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#more}.
     */ execute(lexer) {
        lexer.more();
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        return $i99P2.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "more";
    }
}
$a835166398566135$var$__decorate([
    $esDFm.Override
], $a835166398566135$var$LexerMoreAction.prototype, "actionType", null);
$a835166398566135$var$__decorate([
    $esDFm.Override
], $a835166398566135$var$LexerMoreAction.prototype, "isPositionDependent", null);
$a835166398566135$var$__decorate([
    $esDFm.Override,
    $a835166398566135$var$__param(0, $esDFm.NotNull)
], $a835166398566135$var$LexerMoreAction.prototype, "execute", null);
$a835166398566135$var$__decorate([
    $esDFm.Override
], $a835166398566135$var$LexerMoreAction.prototype, "hashCode", null);
$a835166398566135$var$__decorate([
    $esDFm.Override
], $a835166398566135$var$LexerMoreAction.prototype, "equals", null);
$a835166398566135$var$__decorate([
    $esDFm.Override
], $a835166398566135$var$LexerMoreAction.prototype, "toString", null);
module.exports.LexerMoreAction = $a835166398566135$var$LexerMoreAction;
(function(LexerMoreAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerMoreAction.INSTANCE = new LexerMoreAction();
})($a835166398566135$var$LexerMoreAction = module.exports.LexerMoreAction || (module.exports.LexerMoreAction = {}));

});

parcelRegister("lPekc", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fe397901d0b681ed$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fe397901d0b681ed$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPopModeAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `popMode` lexer action by calling {@link Lexer#popMode}.
 *
 * The `popMode` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $fe397901d0b681ed$var$LexerPopModeAction {
    /**
     * Constructs the singleton instance of the lexer `popMode` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#POP_MODE}.
     */ get actionType() {
        return 4 /* POP_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#popMode}.
     */ execute(lexer) {
        lexer.popMode();
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        return $i99P2.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "popMode";
    }
}
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "actionType", null);
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "isPositionDependent", null);
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override,
    $fe397901d0b681ed$var$__param(0, $esDFm.NotNull)
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "execute", null);
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "hashCode", null);
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "equals", null);
$fe397901d0b681ed$var$__decorate([
    $esDFm.Override
], $fe397901d0b681ed$var$LexerPopModeAction.prototype, "toString", null);
module.exports.LexerPopModeAction = $fe397901d0b681ed$var$LexerPopModeAction;
(function(LexerPopModeAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerPopModeAction.INSTANCE = new LexerPopModeAction();
})($fe397901d0b681ed$var$LexerPopModeAction = module.exports.LexerPopModeAction || (module.exports.LexerPopModeAction = {}));

});

parcelRegister("i50Cm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d2992c51027ada37$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d2992c51027ada37$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPushModeAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `pushMode` lexer action by calling
 * {@link Lexer#pushMode} with the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $d2992c51027ada37$var$LexerPushModeAction {
    /**
     * Constructs a new `pushMode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#pushMode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `pushMode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#PUSH_MODE}.
     */ get actionType() {
        return 5 /* PUSH_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#pushMode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.pushMode(this._mode);
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        hash = $i99P2.MurmurHash.update(hash, this._mode);
        return $i99P2.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $d2992c51027ada37$var$LexerPushModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `pushMode(${this._mode})`;
    }
}
$d2992c51027ada37$var$__decorate([
    $esDFm.Override
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "actionType", null);
$d2992c51027ada37$var$__decorate([
    $esDFm.Override
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "isPositionDependent", null);
$d2992c51027ada37$var$__decorate([
    $esDFm.Override,
    $d2992c51027ada37$var$__param(0, $esDFm.NotNull)
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "execute", null);
$d2992c51027ada37$var$__decorate([
    $esDFm.Override
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "hashCode", null);
$d2992c51027ada37$var$__decorate([
    $esDFm.Override
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "equals", null);
$d2992c51027ada37$var$__decorate([
    $esDFm.Override
], $d2992c51027ada37$var$LexerPushModeAction.prototype, "toString", null);
module.exports.LexerPushModeAction = $d2992c51027ada37$var$LexerPushModeAction;

});

parcelRegister("8OGST", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $66b4422a2a20edad$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $66b4422a2a20edad$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerSkipAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `skip` lexer action by calling {@link Lexer#skip}.
 *
 * The `skip` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $66b4422a2a20edad$var$LexerSkipAction {
    /**
     * Constructs the singleton instance of the lexer `skip` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#SKIP}.
     */ get actionType() {
        return 6 /* SKIP */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#skip}.
     */ execute(lexer) {
        lexer.skip();
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        return $i99P2.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "skip";
    }
}
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "actionType", null);
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "isPositionDependent", null);
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override,
    $66b4422a2a20edad$var$__param(0, $esDFm.NotNull)
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "execute", null);
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "hashCode", null);
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "equals", null);
$66b4422a2a20edad$var$__decorate([
    $esDFm.Override
], $66b4422a2a20edad$var$LexerSkipAction.prototype, "toString", null);
module.exports.LexerSkipAction = $66b4422a2a20edad$var$LexerSkipAction;
(function(LexerSkipAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerSkipAction.INSTANCE = new LexerSkipAction();
})($66b4422a2a20edad$var$LexerSkipAction = module.exports.LexerSkipAction || (module.exports.LexerSkipAction = {}));

});

parcelRegister("j6qbp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $de82e34741a62417$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $de82e34741a62417$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerTypeAction = void 0;

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");
/**
 * Implements the `type` lexer action by setting `Lexer.type`
 * with the assigned type.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $de82e34741a62417$var$LexerTypeAction {
    /**
     * Constructs a new `type` action with the specified token type value.
     * @param type The type to assign to the token using `Lexer.type`.
     */ constructor(type){
        this._type = type;
    }
    /**
     * Gets the type to assign to a token created by the lexer.
     * @returns The type to assign to a token created by the lexer.
     */ get type() {
        return this._type;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#TYPE}.
     */ get actionType() {
        return 7 /* TYPE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by setting `Lexer.type` with the
     * value provided by `type`.
     */ execute(lexer) {
        lexer.type = this._type;
    }
    hashCode() {
        let hash = $i99P2.MurmurHash.initialize();
        hash = $i99P2.MurmurHash.update(hash, this.actionType);
        hash = $i99P2.MurmurHash.update(hash, this._type);
        return $i99P2.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $de82e34741a62417$var$LexerTypeAction)) return false;
        return this._type === obj._type;
    }
    toString() {
        return `type(${this._type})`;
    }
}
$de82e34741a62417$var$__decorate([
    $esDFm.Override
], $de82e34741a62417$var$LexerTypeAction.prototype, "actionType", null);
$de82e34741a62417$var$__decorate([
    $esDFm.Override
], $de82e34741a62417$var$LexerTypeAction.prototype, "isPositionDependent", null);
$de82e34741a62417$var$__decorate([
    $esDFm.Override,
    $de82e34741a62417$var$__param(0, $esDFm.NotNull)
], $de82e34741a62417$var$LexerTypeAction.prototype, "execute", null);
$de82e34741a62417$var$__decorate([
    $esDFm.Override
], $de82e34741a62417$var$LexerTypeAction.prototype, "hashCode", null);
$de82e34741a62417$var$__decorate([
    $esDFm.Override
], $de82e34741a62417$var$LexerTypeAction.prototype, "equals", null);
$de82e34741a62417$var$__decorate([
    $esDFm.Override
], $de82e34741a62417$var$LexerTypeAction.prototype, "toString", null);
module.exports.LexerTypeAction = $de82e34741a62417$var$LexerTypeAction;

});

parcelRegister("3fYXW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $25f2105603fe5855$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoopEndState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
/** Mark the end of a * or + loop. */ class $25f2105603fe5855$var$LoopEndState extends $17Oz4.ATNState {
    get stateType() {
        return $9TBHo.ATNStateType.LOOP_END;
    }
}
$25f2105603fe5855$var$__decorate([
    $esDFm.Override
], $25f2105603fe5855$var$LoopEndState.prototype, "stateType", null);
module.exports.LoopEndState = $25f2105603fe5855$var$LoopEndState;

});

parcelRegister("l4uOS", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f571e0d4afb01ff2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f571e0d4afb01ff2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserATNSimulator = void 0;

var $dg39p = parcelRequire("dg39p");

var $9elhd = parcelRequire("9elhd");

var $fJumX = parcelRequire("fJumX");

var $yEtb9 = parcelRequire("yEtb9");

var $lDQMG = parcelRequire("lDQMG");

var $9qlOq = parcelRequire("9qlOq");

var $6co2U = parcelRequire("6co2U");

var $lbAqv = parcelRequire("lbAqv");

var $9TBHo = parcelRequire("9TBHo");

var $elgsv = parcelRequire("elgsv");

var $lVdCV = parcelRequire("lVdCV");

var $3AFtK = parcelRequire("3AFtK");

var $axZym = parcelRequire("axZym");

var $5jw7S = parcelRequire("5jw7S");

var $eOyS9 = parcelRequire("eOyS9");

var $4Q2DM = parcelRequire("4Q2DM");

var $d4sFB = parcelRequire("d4sFB");

var $esDFm = parcelRequire("esDFm");

var $grncH = parcelRequire("grncH");

var $4qcTm = parcelRequire("4qcTm");

var $73sQO = parcelRequire("73sQO");

var $5NlfZ = parcelRequire("5NlfZ");

var $haz8F = parcelRequire("haz8F");

var $8Uwhy = parcelRequire("8Uwhy");

var $2cmeG = parcelRequire("2cmeG");

var $U6v4o = parcelRequire("U6v4o");

var $acKOx = parcelRequire("acKOx");

var $8DW9a = parcelRequire("8DW9a");

var $4mzjd = parcelRequire("4mzjd");

var $fO6gt = parcelRequire("fO6gt");

var $2G93d = parcelRequire("2G93d");

var $5t4I3 = parcelRequire("5t4I3");

var $gwEr2 = parcelRequire("gwEr2");
const $f571e0d4afb01ff2$var$MAX_SHORT_VALUE = 0xFFFF;
const $f571e0d4afb01ff2$var$MIN_INTEGER_VALUE = -2147483648;
/**
 * The embodiment of the adaptive LL(*), ALL(*), parsing strategy.
 *
 * The basic complexity of the adaptive strategy makes it harder to understand.
 * We begin with ATN simulation to build paths in a DFA. Subsequent prediction
 * requests go through the DFA first. If they reach a state without an edge for
 * the current symbol, the algorithm fails over to the ATN simulation to
 * complete the DFA path for the current input (until it finds a conflict state
 * or uniquely predicting state).
 *
 * All of that is done without using the outer context because we want to create
 * a DFA that is not dependent upon the rule invocation stack when we do a
 * prediction. One DFA works in all contexts. We avoid using context not
 * necessarily because it's slower, although it can be, but because of the DFA
 * caching problem. The closure routine only considers the rule invocation stack
 * created during prediction beginning in the decision rule. For example, if
 * prediction occurs without invoking another rule's ATN, there are no context
 * stacks in the configurations. When lack of context leads to a conflict, we
 * don't know if it's an ambiguity or a weakness in the strong LL(*) parsing
 * strategy (versus full LL(*)).
 *
 * When SLL yields a configuration set with conflict, we rewind the input and
 * retry the ATN simulation, this time using full outer context without adding
 * to the DFA. Configuration context stacks will be the full invocation stacks
 * from the start rule. If we get a conflict using full context, then we can
 * definitively say we have a true ambiguity for that input sequence. If we
 * don't get a conflict, it implies that the decision is sensitive to the outer
 * context. (It is not context-sensitive in the sense of context-sensitive
 * grammars.)
 *
 * The next time we reach this DFA state with an SLL conflict, through DFA
 * simulation, we will again retry the ATN simulation using full context mode.
 * This is slow because we can't save the results and have to "interpret" the
 * ATN each time we get that input.
 *
 * **CACHING FULL CONTEXT PREDICTIONS**
 *
 * We could cache results from full context to predicted alternative easily and
 * that saves a lot of time but doesn't work in presence of predicates. The set
 * of visible predicates from the ATN start state changes depending on the
 * context, because closure can fall off the end of a rule. I tried to cache
 * tuples (stack context, semantic context, predicted alt) but it was slower
 * than interpreting and much more complicated. Also required a huge amount of
 * memory. The goal is not to create the world's fastest parser anyway. I'd like
 * to keep this algorithm simple. By launching multiple threads, we can improve
 * the speed of parsing across a large number of files.
 *
 * There is no strict ordering between the amount of input used by SLL vs LL,
 * which makes it really hard to build a cache for full context. Let's say that
 * we have input A B C that leads to an SLL conflict with full context X. That
 * implies that using X we might only use A B but we could also use A B C D to
 * resolve conflict. Input A B C D could predict alternative 1 in one position
 * in the input and A B C E could predict alternative 2 in another position in
 * input. The conflicting SLL configurations could still be non-unique in the
 * full context prediction, which would lead us to requiring more input than the
 * original A B C.	To make a	prediction cache work, we have to track	the exact
 * input	used during the previous prediction. That amounts to a cache that maps
 * X to a specific DFA for that context.
 *
 * Something should be done for left-recursive expression predictions. They are
 * likely LL(1) + pred eval. Easier to do the whole SLL unless error and retry
 * with full LL thing Sam does.
 *
 * **AVOIDING FULL CONTEXT PREDICTION**
 *
 * We avoid doing full context retry when the outer context is empty, we did not
 * dip into the outer context by falling off the end of the decision state rule,
 * or when we force SLL mode.
 *
 * As an example of the not dip into outer context case, consider as super
 * constructor calls versus function calls. One grammar might look like
 * this:
 *
 * ```antlr
 * ctorBody
 *   : '{' superCall? stat* '}'
 *   ;
 * ```
 *
 * Or, you might see something like
 *
 * ```antlr
 * stat
 *   : superCall ';'
 *   | expression ';'
 *   | ...
 *   ;
 * ```
 *
 * In both cases I believe that no closure operations will dip into the outer
 * context. In the first case ctorBody in the worst case will stop at the '}'.
 * In the 2nd case it should stop at the ';'. Both cases should stay within the
 * entry rule and not dip into the outer context.
 *
 * **PREDICATES**
 *
 * Predicates are always evaluated if present in either SLL or LL both. SLL and
 * LL simulation deals with predicates differently. SLL collects predicates as
 * it performs closure operations like ANTLR v3 did. It delays predicate
 * evaluation until it reaches and accept state. This allows us to cache the SLL
 * ATN simulation whereas, if we had evaluated predicates on-the-fly during
 * closure, the DFA state configuration sets would be different and we couldn't
 * build up a suitable DFA.
 *
 * When building a DFA accept state during ATN simulation, we evaluate any
 * predicates and return the sole semantically valid alternative. If there is
 * more than 1 alternative, we report an ambiguity. If there are 0 alternatives,
 * we throw an exception. Alternatives without predicates act like they have
 * true predicates. The simple way to think about it is to strip away all
 * alternatives with false predicates and choose the minimum alternative that
 * remains.
 *
 * When we start in the DFA and reach an accept state that's predicated, we test
 * those and return the minimum semantically viable alternative. If no
 * alternatives are viable, we throw an exception.
 *
 * During full LL ATN simulation, closure always evaluates predicates and
 * on-the-fly. This is crucial to reducing the configuration set size during
 * closure. It hits a landmine when parsing with the Java grammar, for example,
 * without this on-the-fly evaluation.
 *
 * **SHARING DFA**
 *
 * All instances of the same parser share the same decision DFAs through a
 * static field. Each instance gets its own ATN simulator but they share the
 * same {@link ATN#decisionToDFA} field. They also share a
 * {@link PredictionContextCache} object that makes sure that all
 * {@link PredictionContext} objects are shared among the DFA states. This makes
 * a big size difference.
 *
 * **THREAD SAFETY**
 *
 * The {@link ParserATNSimulator} locks on the {@link ATN#decisionToDFA} field when
 * it adds a new DFA object to that array. {@link #addDFAEdge}
 * locks on the DFA for the current decision when setting the
 * {@link DFAState#edges} field. {@link #addDFAState} locks on
 * the DFA for the current decision when looking up a DFA state to see if it
 * already exists. We must make sure that all requests to add DFA states that
 * are equivalent result in the same shared DFA object. This is because lots of
 * threads will be trying to update the DFA at once. The
 * {@link #addDFAState} method also locks inside the DFA lock
 * but this time on the shared context cache when it rebuilds the
 * configurations' {@link PredictionContext} objects using cached
 * subgraphs/nodes. No other locking occurs, even during DFA simulation. This is
 * safe as long as we can guarantee that all threads referencing
 * `s.edge[t]` get the same physical target {@link DFAState}, or
 * `undefined`. Once into the DFA, the DFA simulation does not reference the
 * {@link DFA#states} map. It follows the {@link DFAState#edges} field to new
 * targets. The DFA simulator will either find {@link DFAState#edges} to be
 * `undefined`, to be non-`undefined` and `dfa.edges[t]` undefined, or
 * `dfa.edges[t]` to be non-undefined. The
 * {@link #addDFAEdge} method could be racing to set the field
 * but in either case the DFA simulator works; if `undefined`, and requests ATN
 * simulation. It could also race trying to get `dfa.edges[t]`, but either
 * way it will work because it's not doing a test and set operation.
 *
 * **Starting with SLL then failing to combined SLL/LL (Two-Stage
 * Parsing)**
 *
 * Sam pointed out that if SLL does not give a syntax error, then there is no
 * point in doing full LL, which is slower. We only have to try LL if we get a
 * syntax error. For maximum speed, Sam starts the parser set to pure SLL
 * mode with the {@link BailErrorStrategy}:
 *
 * ```
 * parser.interpreter.{@link #setPredictionMode setPredictionMode}`(`{@link PredictionMode#SLL}`)`;
 * parser.{@link Parser#setErrorHandler setErrorHandler}(new {@link BailErrorStrategy}());
 * ```
 *
 * If it does not get a syntax error, then we're done. If it does get a syntax
 * error, we need to retry with the combined SLL/LL strategy.
 *
 * The reason this works is as follows. If there are no SLL conflicts, then the
 * grammar is SLL (at least for that input set). If there is an SLL conflict,
 * the full LL analysis must yield a set of viable alternatives which is a
 * subset of the alternatives reported by SLL. If the LL set is a singleton,
 * then the grammar is LL but not SLL. If the LL set is the same size as the SLL
 * set, the decision is SLL. If the LL set has size &gt; 1, then that decision
 * is truly ambiguous on the current input. If the LL set is smaller, then the
 * SLL conflict resolution might choose an alternative that the full LL would
 * rule out as a possibility based upon better context information. If that's
 * the case, then the SLL parse will definitely get an error because the full LL
 * analysis says it's not viable. If SLL conflict resolution chooses an
 * alternative within the LL set, them both SLL and LL would choose the same
 * alternative because they both choose the minimum of multiple conflicting
 * alternatives.
 *
 * Let's say we have a set of SLL conflicting alternatives `{1, 2, 3}` and
 * a smaller LL set called *s*. If *s* is `{2, 3}`, then SLL
 * parsing will get an error because SLL will pursue alternative 1. If
 * *s* is `{1, 2}` or `{1, 3}` then both SLL and LL will
 * choose the same alternative because alternative one is the minimum of either
 * set. If *s* is `{2}` or `{3}` then SLL will get a syntax
 * error. If *s* is `{1}` then SLL will succeed.
 *
 * Of course, if the input is invalid, then we will get an error for sure in
 * both SLL and LL parsing. Erroneous input will therefore require 2 passes over
 * the input.
 */ let $f571e0d4afb01ff2$var$ParserATNSimulator = class ParserATNSimulator extends $lbAqv.ATNSimulator {
    constructor(atn, parser){
        super(atn);
        this.predictionMode = $2cmeG.PredictionMode.LL;
        this.force_global_context = false;
        this.always_try_local_context = true;
        /**
         * Determines whether the DFA is used for full-context predictions. When
         * `true`, the DFA stores transition information for both full-context
         * and SLL parsing; otherwise, the DFA only stores SLL transition
         * information.
         *
         * For some grammars, enabling the full-context DFA can result in a
         * substantial performance improvement. However, this improvement typically
         * comes at the expense of memory used for storing the cached DFA states,
         * configuration sets, and prediction contexts.
         *
         * The default value is `false`.
         */ this.enable_global_context_dfa = false;
        this.optimize_unique_closure = true;
        this.optimize_ll1 = true;
        this.optimize_tail_calls = true;
        this.tail_call_preserves_sll = true;
        this.treat_sllk1_conflict_as_ambiguity = false;
        /**
         * When `true`, ambiguous alternatives are reported when they are
         * encountered within {@link #execATN}. When `false`, these messages
         * are suppressed. The default is `false`.
         *
         * When messages about ambiguous alternatives are not required, setting this
         * to `false` enables additional internal optimizations which may lose
         * this information.
         */ this.reportAmbiguities = false;
        /** By default we do full context-sensitive LL(*) parsing not
         *  Strong LL(*) parsing. If we fail with Strong LL(*) we
         *  try full LL(*). That means we rewind and use context information
         *  when closure operations fall off the end of the rule that
         *  holds the decision were evaluating.
         */ this.userWantsCtxSensitive = true;
        this._parser = parser;
    }
    getPredictionMode() {
        return this.predictionMode;
    }
    setPredictionMode(predictionMode) {
        this.predictionMode = predictionMode;
    }
    reset() {
    // intentionally empty
    }
    adaptivePredict(input, decision, outerContext, useContext) {
        if (useContext === undefined) useContext = false;
        let dfa = this.atn.decisionToDFA[decision];
        $gwEr2(dfa != null);
        if (this.optimize_ll1 && !dfa.isPrecedenceDfa && !dfa.isEmpty) {
            let ll_1 = input.LA(1);
            if (ll_1 >= 0 && ll_1 <= 0xFFFF) {
                let key = (decision << 16 >>> 0) + ll_1;
                let alt = this.atn.LL1Table.get(key);
                if (alt != null) return alt;
            }
        }
        this.dfa = dfa;
        if (this.force_global_context) useContext = true;
        else if (!this.always_try_local_context) useContext = useContext || dfa.isContextSensitive;
        this.userWantsCtxSensitive = useContext || this.predictionMode !== $2cmeG.PredictionMode.SLL && outerContext != null && !this.atn.decisionToState[decision].sll;
        if (outerContext == null) outerContext = $5NlfZ.ParserRuleContext.emptyContext();
        let state;
        if (!dfa.isEmpty) state = this.getStartState(dfa, input, outerContext, useContext);
        if (state == null) {
            if (outerContext == null) outerContext = $5NlfZ.ParserRuleContext.emptyContext();
            if (ParserATNSimulator.debug) console.log("ATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
            state = this.computeStartState(dfa, outerContext, useContext);
        }
        let m = input.mark();
        let index = input.index;
        try {
            let alt = this.execDFA(dfa, input, index, state);
            if (ParserATNSimulator.debug) console.log("DFA after predictATN: " + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
            return alt;
        } finally{
            this.dfa = undefined;
            input.seek(index);
            input.release(m);
        }
    }
    getStartState(dfa, input, outerContext, useContext) {
        if (!useContext) {
            if (dfa.isPrecedenceDfa) {
                // the start state for a precedence DFA depends on the current
                // parser precedence, and is provided by a DFA method.
                let state = dfa.getPrecedenceStartState(this._parser.precedence, false);
                if (state == null) return undefined;
                return new $fO6gt.SimulatorState(outerContext, state, false, outerContext);
            } else {
                if (dfa.s0 == null) return undefined;
                return new $fO6gt.SimulatorState(outerContext, dfa.s0, false, outerContext);
            }
        }
        if (!this.enable_global_context_dfa) return undefined;
        let remainingContext = outerContext;
        $gwEr2(outerContext != null);
        let s0;
        if (dfa.isPrecedenceDfa) s0 = dfa.getPrecedenceStartState(this._parser.precedence, true);
        else s0 = dfa.s0full;
        while(remainingContext != null && s0 != null && s0.isContextSensitive){
            remainingContext = this.skipTailCalls(remainingContext);
            s0 = s0.getContextTarget(this.getReturnState(remainingContext));
            if (remainingContext.isEmpty) $gwEr2(s0 == null || !s0.isContextSensitive);
            else remainingContext = remainingContext.parent;
        }
        if (s0 == null) return undefined;
        return new $fO6gt.SimulatorState(outerContext, s0, useContext, remainingContext);
    }
    execDFA(dfa, input, startIndex, state) {
        let outerContext = state.outerContext;
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
        if (ParserATNSimulator.dfa_debug) console.log(dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
        let s = state.s0;
        let t = input.LA(1);
        let remainingOuterContext = state.remainingOuterContext;
        while(true){
            if (ParserATNSimulator.dfa_debug) console.log("DFA state " + s.stateNumber + " LA(1)==" + this.getLookaheadName(input));
            if (state.useContext) while(s.isContextSymbol(t)){
                let next;
                if (remainingOuterContext != null) {
                    remainingOuterContext = this.skipTailCalls(remainingOuterContext);
                    next = s.getContextTarget(this.getReturnState(remainingOuterContext));
                }
                if (next == null) {
                    // fail over to ATN
                    let initialState = new $fO6gt.SimulatorState(state.outerContext, s, state.useContext, remainingOuterContext);
                    return this.execATN(dfa, input, startIndex, initialState);
                }
                $gwEr2(remainingOuterContext != null);
                remainingOuterContext = remainingOuterContext.parent;
                s = next;
            }
            if (this.isAcceptState(s, state.useContext)) {
                if (s.predicates != null) {
                    if (ParserATNSimulator.dfa_debug) console.log("accept " + s);
                } else if (ParserATNSimulator.dfa_debug) console.log("accept; predict " + s.prediction + " in state " + s.stateNumber);
                break;
            }
            // t is not updated if one of these states is reached
            $gwEr2(!this.isAcceptState(s, state.useContext));
            // if no edge, pop over to ATN interpreter, update DFA and return
            let target = this.getExistingTargetState(s, t);
            if (target == null) {
                if (ParserATNSimulator.dfa_debug && t >= 0) console.log("no edge for " + this._parser.vocabulary.getDisplayName(t));
                let alt;
                if (ParserATNSimulator.dfa_debug) {
                    let interval = $4Q2DM.Interval.of(startIndex, this._parser.inputStream.index);
                    console.log("ATN exec upon " + this._parser.inputStream.getText(interval) + " at DFA state " + s.stateNumber);
                }
                let initialState = new $fO6gt.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                alt = this.execATN(dfa, input, startIndex, initialState);
                if (ParserATNSimulator.dfa_debug) console.log("back from DFA update, alt=" + alt + ", dfa=\n" + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                // action already executed
                if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + alt);
                return alt; // we've updated DFA, exec'd action, and have our deepest answer
            } else if (target === $lbAqv.ATNSimulator.ERROR) {
                let errorState = new $fO6gt.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                return this.handleNoViableAlt(input, startIndex, errorState);
            }
            s = target;
            if (!this.isAcceptState(s, state.useContext) && t !== $d4sFB.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
        //		if ( acceptState==null ) {
        //			if ( debug ) System.out.println("!!! no viable alt in dfa");
        //			return -1;
        //		}
        if (!state.useContext && s.configs.conflictInfo != null) {
            if (dfa.atnStartState instanceof $axZym.DecisionState) {
                if (!this.userWantsCtxSensitive || !s.configs.dipsIntoOuterContext && s.configs.isExactConflict || this.treat_sllk1_conflict_as_ambiguity && input.index === startIndex) ;
                else {
                    $gwEr2(!state.useContext);
                    // Before attempting full context prediction, check to see if there are
                    // disambiguating or validating predicates to evaluate which allow an
                    // immediate decision
                    let conflictingAlts;
                    let predicates = s.predicates;
                    if (predicates != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        conflictingAlts = this.evalSemanticContext(predicates, outerContext, true);
                        if (conflictingAlts.cardinality() === 1) return conflictingAlts.nextSetBit(0);
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                    if (this.reportAmbiguities) {
                        let conflictState = new $fO6gt.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                        this.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, input.index);
                    }
                    input.seek(startIndex);
                    return this.adaptivePredict(input, dfa.decision, outerContext, true);
                }
            }
        }
        // Before jumping to prediction, check to see if there are
        // disambiguating or validating predicates to evaluate
        let predicates = s.predicates;
        if (predicates != null) {
            let stopIndex = input.index;
            if (startIndex !== stopIndex) input.seek(startIndex);
            let alts = this.evalSemanticContext(predicates, outerContext, this.reportAmbiguities && this.predictionMode === $2cmeG.PredictionMode.LL_EXACT_AMBIG_DETECTION);
            switch(alts.cardinality()){
                case 0:
                    throw this.noViableAlt(input, outerContext, s.configs, startIndex);
                case 1:
                    return alts.nextSetBit(0);
                default:
                    // report ambiguity after predicate evaluation to make sure the correct
                    // set of ambig alts is reported.
                    if (startIndex !== stopIndex) input.seek(stopIndex);
                    this.reportAmbiguity(dfa, s, startIndex, stopIndex, s.configs.isExactConflict, alts, s.configs);
                    return alts.nextSetBit(0);
            }
        }
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + s.prediction);
        return s.prediction;
    }
    /**
     * Determines if a particular DFA state should be treated as an accept state
     * for the current prediction mode. In addition to the `useContext`
     * parameter, the {@link #getPredictionMode()} method provides the
     * prediction mode controlling the prediction algorithm as a whole.
     *
     * The default implementation simply returns the value of
     * `DFAState.isAcceptState` except for conflict states when
     * `useContext` is `true` and {@link #getPredictionMode()} is
     * {@link PredictionMode#LL_EXACT_AMBIG_DETECTION}. In that case, only
     * conflict states where {@link ATNConfigSet#isExactConflict} is
     * `true` are considered accept states.
     *
     * @param state The DFA state to check.
     * @param useContext `true` if the prediction algorithm is currently
     * considering the full parser context; otherwise, `false` if the
     * algorithm is currently performing a local context prediction.
     *
     * @returns `true` if the specified `state` is an accept state;
     * otherwise, `false`.
     */ isAcceptState(state, useContext) {
        if (!state.isAcceptState) return false;
        if (state.configs.conflictingAlts == null) // unambiguous
        return true;
        // More picky when we need exact conflicts
        if (useContext && this.predictionMode === $2cmeG.PredictionMode.LL_EXACT_AMBIG_DETECTION) return state.configs.isExactConflict;
        return true;
    }
    /** Performs ATN simulation to compute a predicted alternative based
     *  upon the remaining input, but also updates the DFA cache to avoid
     *  having to traverse the ATN again for the same input sequence.
     *
     * There are some key conditions we're looking for after computing a new
     * set of ATN configs (proposed DFA state):
     *
     * * if the set is empty, there is no viable alternative for current symbol
     * * does the state uniquely predict an alternative?
     * * does the state have a conflict that would prevent us from
     *   putting it on the work list?
     * * if in non-greedy decision is there a config at a rule stop state?
     *
     * We also have some key operations to do:
     *
     * * add an edge from previous DFA state to potentially new DFA state, D,
     *   upon current symbol but only if adding to work list, which means in all
     *   cases except no viable alternative (and possibly non-greedy decisions?)
     * * collecting predicates and adding semantic context to DFA accept states
     * * adding rule context to context-sensitive DFA accept states
     * * consuming an input symbol
     * * reporting a conflict
     * * reporting an ambiguity
     * * reporting a context sensitivity
     * * reporting insufficient predicates
     *
     * We should isolate those operations, which are side-effecting, to the
     * main work loop. We can isolate lots of code into other functions, but
     * they should be side effect free. They can return package that
     * indicates whether we should report something, whether we need to add a
     * DFA edge, whether we need to augment accept state with semantic
     * context or rule invocation context. Actually, it seems like we always
     * add predicates if they exist, so that can simply be done in the main
     * loop for any accept state creation or modification request.
     *
     * cover these cases:
     *   dead end
     *   single alt
     *   single alt + preds
     *   conflict
     *   conflict + preds
     *
     * TODO: greedy + those
     */ execATN(dfa, input, startIndex, initialState) {
        if (ParserATNSimulator.debug) console.log("execATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input));
        let outerContext = initialState.outerContext;
        let useContext = initialState.useContext;
        let t = input.LA(1);
        let previous = initialState;
        let contextCache = new $8Uwhy.PredictionContextCache();
        while(true){
            let nextState = this.computeReachSet(dfa, previous, t, contextCache);
            if (nextState == null) {
                this.setDFAEdge(previous.s0, input.LA(1), $lbAqv.ATNSimulator.ERROR);
                return this.handleNoViableAlt(input, startIndex, previous);
            }
            let D = nextState.s0;
            // predicted alt => accept state
            $gwEr2(D.isAcceptState || D.prediction === $lDQMG.ATN.INVALID_ALT_NUMBER);
            // conflicted => accept state
            $gwEr2(D.isAcceptState || D.configs.conflictInfo == null);
            if (this.isAcceptState(D, useContext)) {
                let conflictingAlts = D.configs.conflictingAlts;
                let predictedAlt = conflictingAlts == null ? D.prediction : $lDQMG.ATN.INVALID_ALT_NUMBER;
                if (predictedAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER) {
                    if (this.optimize_ll1 && input.index === startIndex && !dfa.isPrecedenceDfa && nextState.outerContext === nextState.remainingOuterContext && dfa.decision >= 0 && !D.configs.hasSemanticContext) {
                        if (t >= 0 && t <= $f571e0d4afb01ff2$var$MAX_SHORT_VALUE) {
                            let key = (dfa.decision << 16 >>> 0) + t;
                            this.atn.LL1Table.set(key, predictedAlt);
                        }
                    }
                    if (useContext && this.always_try_local_context) this.reportContextSensitivity(dfa, predictedAlt, nextState, startIndex, input.index);
                }
                predictedAlt = D.prediction;
                //				int k = input.index - startIndex + 1; // how much input we used
                //				System.out.println("used k="+k);
                let attemptFullContext = conflictingAlts != null && this.userWantsCtxSensitive;
                if (attemptFullContext) // Only exact conflicts are known to be ambiguous when local
                // prediction does not step out of the decision rule.
                attemptFullContext = !useContext && (D.configs.dipsIntoOuterContext || !D.configs.isExactConflict) && (!this.treat_sllk1_conflict_as_ambiguity || input.index !== startIndex);
                if (D.configs.hasSemanticContext) {
                    let predPredictions = D.predicates;
                    if (predPredictions != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        // use complete evaluation here if we'll want to retry with full context if still ambiguous
                        conflictingAlts = this.evalSemanticContext(predPredictions, outerContext, attemptFullContext || this.reportAmbiguities);
                        switch(conflictingAlts.cardinality()){
                            case 0:
                                throw this.noViableAlt(input, outerContext, D.configs, startIndex);
                            case 1:
                                return conflictingAlts.nextSetBit(0);
                            default:
                                break;
                        }
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                }
                if (!attemptFullContext) {
                    if (conflictingAlts != null) {
                        if (this.reportAmbiguities && conflictingAlts.cardinality() > 1) this.reportAmbiguity(dfa, D, startIndex, input.index, D.configs.isExactConflict, conflictingAlts, D.configs);
                        predictedAlt = conflictingAlts.nextSetBit(0);
                    }
                    return predictedAlt;
                } else {
                    $gwEr2(!useContext);
                    $gwEr2(this.isAcceptState(D, false));
                    if (ParserATNSimulator.debug) console.log("RETRY with outerContext=" + outerContext);
                    let fullContextState = this.computeStartState(dfa, outerContext, true);
                    if (this.reportAmbiguities) this.reportAttemptingFullContext(dfa, conflictingAlts, nextState, startIndex, input.index);
                    input.seek(startIndex);
                    return this.execATN(dfa, input, startIndex, fullContextState);
                }
            }
            previous = nextState;
            if (t !== $d4sFB.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
    }
    /**
     * This method is used to improve the localization of error messages by
     * choosing an alternative rather than throwing a
     * {@link NoViableAltException} in particular prediction scenarios where the
     * {@link #ERROR} state was reached during ATN simulation.
     *
     * The default implementation of this method uses the following
     * algorithm to identify an ATN configuration which successfully parsed the
     * decision entry rule. Choosing such an alternative ensures that the
     * {@link ParserRuleContext} returned by the calling rule will be complete
     * and valid, and the syntax error will be reported later at a more
     * localized location.
     *
     * * If no configuration in `configs` reached the end of the
     *   decision rule, return {@link ATN#INVALID_ALT_NUMBER}.
     * * If all configurations in `configs` which reached the end of the
     *   decision rule predict the same alternative, return that alternative.
     * * If the configurations in `configs` which reached the end of the
     *   decision rule predict multiple alternatives (call this *S*),
     *   choose an alternative in the following order.
     *
     *     1. Filter the configurations in `configs` to only those
     *        configurations which remain viable after evaluating semantic predicates.
     *        If the set of these filtered configurations which also reached the end of
     *        the decision rule is not empty, return the minimum alternative
     *        represented in this set.
     *     1. Otherwise, choose the minimum alternative in *S*.
     *
     * In some scenarios, the algorithm described above could predict an
     * alternative which will result in a {@link FailedPredicateException} in
     * parser. Specifically, this could occur if the *only* configuration
     * capable of successfully parsing to the end of the decision rule is
     * blocked by a semantic predicate. By choosing this alternative within
     * {@link #adaptivePredict} instead of throwing a
     * {@link NoViableAltException}, the resulting
     * {@link FailedPredicateException} in the parser will identify the specific
     * predicate which is preventing the parser from successfully parsing the
     * decision rule, which helps developers identify and correct logic errors
     * in semantic predicates.
     *
     * @param input The input {@link TokenStream}
     * @param startIndex The start index for the current prediction, which is
     * the input index where any semantic context in `configs` should be
     * evaluated
     * @param previous The ATN simulation state immediately before the
     * {@link #ERROR} state was reached
     *
     * @returns The value to return from {@link #adaptivePredict}, or
     * {@link ATN#INVALID_ALT_NUMBER} if a suitable alternative was not
     * identified and {@link #adaptivePredict} should report an error instead.
     */ handleNoViableAlt(input, startIndex, previous) {
        if (previous.s0 != null) {
            let alts = new $lVdCV.BitSet();
            let maxAlt = 0;
            for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $U6v4o.RuleStopState) {
                alts.set(config.alt);
                maxAlt = Math.max(maxAlt, config.alt);
            }
            switch(alts.cardinality()){
                case 0:
                    break;
                case 1:
                    return alts.nextSetBit(0);
                default:
                    if (!previous.s0.configs.hasSemanticContext) // configs doesn't contain any predicates, so the predicate
                    // filtering code below would be pointless
                    return alts.nextSetBit(0);
                    /*
                     * Try to find a configuration set that not only dipped into the outer
                     * context, but also isn't eliminated by a predicate.
                     */ let filteredConfigs = new $6co2U.ATNConfigSet();
                    for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $U6v4o.RuleStopState) filteredConfigs.add(config);
                    /* The following code blocks are adapted from predicateDFAState with
                     * the following key changes.
                     *
                     *  1. The code operates on an ATNConfigSet rather than a DFAState.
                     *  2. Predicates are collected for all alternatives represented in
                     *     filteredConfigs, rather than restricting the evaluation to
                     *     conflicting and/or unique configurations.
                     */ let altToPred = this.getPredsForAmbigAlts(alts, filteredConfigs, maxAlt);
                    if (altToPred != null) {
                        let predicates = this.getPredicatePredictions(alts, altToPred);
                        if (predicates != null) {
                            let stopIndex = input.index;
                            try {
                                input.seek(startIndex);
                                let filteredAlts = this.evalSemanticContext(predicates, previous.outerContext, false);
                                if (!filteredAlts.isEmpty) return filteredAlts.nextSetBit(0);
                            } finally{
                                input.seek(stopIndex);
                            }
                        }
                    }
                    return alts.nextSetBit(0);
            }
        }
        throw this.noViableAlt(input, previous.outerContext, previous.s0.configs, startIndex);
    }
    computeReachSet(dfa, previous, t, contextCache) {
        let useContext = previous.useContext;
        let remainingGlobalContext = previous.remainingOuterContext;
        let s = previous.s0;
        if (useContext) while(s.isContextSymbol(t)){
            let next;
            if (remainingGlobalContext != null) {
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                next = s.getContextTarget(this.getReturnState(remainingGlobalContext));
            }
            if (next == null) break;
            $gwEr2(remainingGlobalContext != null);
            remainingGlobalContext = remainingGlobalContext.parent;
            s = next;
        }
        $gwEr2(!this.isAcceptState(s, useContext));
        if (this.isAcceptState(s, useContext)) return new $fO6gt.SimulatorState(previous.outerContext, s, useContext, remainingGlobalContext);
        let s0 = s;
        let target = this.getExistingTargetState(s0, t);
        if (target == null) {
            let result = this.computeTargetState(dfa, s0, remainingGlobalContext, t, useContext, contextCache);
            target = result[0];
            remainingGlobalContext = result[1];
        }
        if (target === $lbAqv.ATNSimulator.ERROR) return undefined;
        $gwEr2(!useContext || !target.configs.dipsIntoOuterContext);
        return new $fO6gt.SimulatorState(previous.outerContext, target, useContext, remainingGlobalContext);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        return s.getTarget(t);
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param dfa
     * @param s The current DFA state
     * @param remainingGlobalContext
     * @param t The next input symbol
     * @param useContext
     * @param contextCache
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
        let closureConfigs = s.configs.toArray();
        let contextElements;
        let reach = new $6co2U.ATNConfigSet();
        let stepIntoGlobal;
        do {
            let hasMoreContext = !useContext || remainingGlobalContext != null;
            if (!hasMoreContext) reach.isOutermostConfigSet = true;
            let reachIntermediate = new $6co2U.ATNConfigSet();
            /* Configurations already in a rule stop state indicate reaching the end
             * of the decision rule (local context) or end of the start rule (full
             * context). Once reached, these configurations are never updated by a
             * closure operation, so they are handled separately for the performance
             * advantage of having a smaller intermediate set when calling closure.
             *
             * For full-context reach operations, separate handling is required to
             * ensure that the alternative matching the longest overall sequence is
             * chosen when multiple such configurations can match the input.
             */ let skippedStopStates;
            for (let c of closureConfigs){
                if (ParserATNSimulator.debug) console.log("testing " + this.getTokenName(t) + " at " + c.toString());
                if (c.state instanceof $U6v4o.RuleStopState) {
                    $gwEr2(c.context.isEmpty);
                    if (useContext && !c.reachesIntoOuterContext || t === $d4sFB.IntStream.EOF) {
                        if (skippedStopStates == null) skippedStopStates = [];
                        skippedStopStates.push(c);
                    }
                    continue;
                }
                let n = c.state.numberOfOptimizedTransitions;
                for(let ti = 0; ti < n; ti++){
                    let trans = c.state.getOptimizedTransition(ti);
                    let target = this.getReachableTarget(c, trans, t);
                    if (target != null) reachIntermediate.add(c.transform(target, false), contextCache);
                }
            }
            /* This block optimizes the reach operation for intermediate sets which
             * trivially indicate a termination state for the overall
             * adaptivePredict operation.
             *
             * The conditions assume that intermediate
             * contains all configurations relevant to the reach set, but this
             * condition is not true when one or more configurations have been
             * withheld in skippedStopStates, or when the current symbol is EOF.
             */ if (this.optimize_unique_closure && skippedStopStates == null && t !== $2G93d.Token.EOF && reachIntermediate.uniqueAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER) {
                reachIntermediate.isOutermostConfigSet = reach.isOutermostConfigSet;
                reach = reachIntermediate;
                break;
            }
            /* If the reach set could not be trivially determined, perform a closure
             * operation on the intermediate set to compute its initial value.
             */ let collectPredicates = false;
            let treatEofAsEpsilon = t === $2G93d.Token.EOF;
            this.closure(reachIntermediate, reach, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon);
            stepIntoGlobal = reach.dipsIntoOuterContext;
            if (t === $d4sFB.IntStream.EOF) /* After consuming EOF no additional input is possible, so we are
                 * only interested in configurations which reached the end of the
                 * decision rule (local context) or end of the start rule (full
                 * context). Update reach to contain only these configurations. This
                 * handles both explicit EOF transitions in the grammar and implicit
                 * EOF transitions following the end of the decision or start rule.
                 *
                 * This is handled before the configurations in skippedStopStates,
                 * because any configurations potentially added from that list are
                 * already guaranteed to meet this condition whether or not it's
                 * required.
                 */ reach = this.removeAllConfigsNotInRuleStopState(reach, contextCache);
            /* If skippedStopStates is not undefined, then it contains at least one
             * configuration. For full-context reach operations, these
             * configurations reached the end of the start rule, in which case we
             * only add them back to reach if no configuration during the current
             * closure operation reached such a state. This ensures adaptivePredict
             * chooses an alternative matching the longest overall sequence when
             * multiple alternatives are viable.
             */ if (skippedStopStates != null && (!useContext || !$2cmeG.PredictionMode.hasConfigInRuleStopState(reach))) {
                $gwEr2(skippedStopStates.length > 0);
                for (let c of skippedStopStates)reach.add(c, contextCache);
            }
            if (useContext && stepIntoGlobal) {
                reach.clear();
                // We know remainingGlobalContext is not undefined at this point (why?)
                remainingGlobalContext;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                let nextContextElement = this.getReturnState(remainingGlobalContext);
                if (contextElements == null) contextElements = new $eOyS9.IntegerList();
                if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                else remainingGlobalContext = remainingGlobalContext.parent;
                contextElements.add(nextContextElement);
                if (nextContextElement !== $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) for(let i = 0; i < closureConfigs.length; i++)closureConfigs[i] = closureConfigs[i].appendContext(nextContextElement, contextCache);
            }
        }while (useContext && stepIntoGlobal);
        if (reach.isEmpty) {
            this.setDFAEdge(s, t, $lbAqv.ATNSimulator.ERROR);
            return [
                $lbAqv.ATNSimulator.ERROR,
                remainingGlobalContext
            ];
        }
        let result = this.addDFAEdge(dfa, s, t, contextElements, reach, contextCache);
        return [
            result,
            remainingGlobalContext
        ];
    }
    /**
     * Return a configuration set containing only the configurations from
     * `configs` which are in a {@link RuleStopState}. If all
     * configurations in `configs` are already in a rule stop state, this
     * method simply returns `configs`.
     *
     * @param configs the configuration set to update
     * @param contextCache the {@link PredictionContext} cache
     *
     * @returns `configs` if all configurations in `configs` are in a
     * rule stop state, otherwise return a new configuration set containing only
     * the configurations from `configs` which are in a rule stop state
     */ removeAllConfigsNotInRuleStopState(configs, contextCache) {
        if ($2cmeG.PredictionMode.allConfigsInRuleStopStates(configs)) return configs;
        let result = new $6co2U.ATNConfigSet();
        for (let config of configs){
            if (!(config.state instanceof $U6v4o.RuleStopState)) continue;
            result.add(config, contextCache);
        }
        return result;
    }
    computeStartState(dfa, globalContext, useContext) {
        let s0 = dfa.isPrecedenceDfa ? dfa.getPrecedenceStartState(this._parser.precedence, useContext) : useContext ? dfa.s0full : dfa.s0;
        if (s0 != null) {
            if (!useContext) return new $fO6gt.SimulatorState(globalContext, s0, useContext, globalContext);
            s0.setContextSensitive(this.atn);
        }
        let decision = dfa.decision;
        // @NotNull
        let p = dfa.atnStartState;
        let previousContext = 0;
        let remainingGlobalContext = globalContext;
        let initialContext = useContext ? $haz8F.PredictionContext.EMPTY_FULL : $haz8F.PredictionContext.EMPTY_LOCAL; // always at least the implicit call to start rule
        let contextCache = new $8Uwhy.PredictionContextCache();
        if (useContext) {
            if (!this.enable_global_context_dfa) {
                while(remainingGlobalContext != null)if (remainingGlobalContext.isEmpty) {
                    previousContext = $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
            }
            while(s0 != null && s0.isContextSensitive && remainingGlobalContext != null){
                let next;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                if (remainingGlobalContext.isEmpty) {
                    next = s0.getContextTarget($haz8F.PredictionContext.EMPTY_FULL_STATE_KEY);
                    previousContext = $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    next = s0.getContextTarget(previousContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
                if (next == null) break;
                s0 = next;
            }
        }
        if (s0 != null && !s0.isContextSensitive) return new $fO6gt.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
        let configs = new $6co2U.ATNConfigSet();
        while(true){
            let reachIntermediate = new $6co2U.ATNConfigSet();
            let n = p.numberOfTransitions;
            for(let ti = 0; ti < n; ti++){
                // for each transition
                let target = p.transition(ti).target;
                reachIntermediate.add($9qlOq.ATNConfig.create(target, ti + 1, initialContext));
            }
            let hasMoreContext = remainingGlobalContext != null;
            if (!hasMoreContext) configs.isOutermostConfigSet = true;
            let collectPredicates = true;
            this.closure(reachIntermediate, configs, collectPredicates, hasMoreContext, contextCache, false);
            let stepIntoGlobal = configs.dipsIntoOuterContext;
            let next;
            if (useContext && !this.enable_global_context_dfa) {
                s0 = this.addDFAState(dfa, configs, contextCache);
                break;
            } else if (s0 == null) {
                if (!dfa.isPrecedenceDfa) {
                    next = this.addDFAState(dfa, configs, contextCache);
                    if (useContext) {
                        if (!dfa.s0full) dfa.s0full = next;
                        else next = dfa.s0full;
                    } else if (!dfa.s0) dfa.s0 = next;
                    else next = dfa.s0;
                } else {
                    /* If this is a precedence DFA, we use applyPrecedenceFilter
                     * to convert the computed start state to a precedence start
                     * state. We then use DFA.setPrecedenceStartState to set the
                     * appropriate start state for the precedence level rather
                     * than simply setting DFA.s0.
                     */ configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                    next = this.addDFAState(dfa, configs, contextCache);
                    dfa.setPrecedenceStartState(this._parser.precedence, useContext, next);
                }
            } else {
                if (dfa.isPrecedenceDfa) configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                next = this.addDFAState(dfa, configs, contextCache);
                s0.setContextTarget(previousContext, next);
            }
            s0 = next;
            if (!useContext || !stepIntoGlobal) break;
            // TODO: make sure it distinguishes empty stack states
            next.setContextSensitive(this.atn);
            // We know remainingGlobalContext is not undefined at this point (why?)
            remainingGlobalContext;
            configs.clear();
            remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
            let nextContextElement = this.getReturnState(remainingGlobalContext);
            if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
            else remainingGlobalContext = remainingGlobalContext.parent;
            if (nextContextElement !== $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) initialContext = initialContext.appendSingleContext(nextContextElement, contextCache);
            previousContext = nextContextElement;
        }
        return new $fO6gt.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
    }
    /**
     * This method transforms the start state computed by
     * {@link #computeStartState} to the special start state used by a
     * precedence DFA for a particular precedence value. The transformation
     * process applies the following changes to the start state's configuration
     * set.
     *
     * 1. Evaluate the precedence predicates for each configuration using
     *    {@link SemanticContext#evalPrecedence}.
     * 1. When {@link ATNConfig#isPrecedenceFilterSuppressed} is `false`,
     *    remove all configurations which predict an alternative greater than 1,
     *    for which another configuration that predicts alternative 1 is in the
     *    same ATN state with the same prediction context. This transformation is
     *    valid for the following reasons:
     *
     *     * The closure block cannot contain any epsilon transitions which bypass
     *       the body of the closure, so all states reachable via alternative 1 are
     *       part of the precedence alternatives of the transformed left-recursive
     *       rule.
     *     * The "primary" portion of a left recursive rule cannot contain an
     *       epsilon transition, so the only way an alternative other than 1 can exist
     *       in a state that is also reachable via alternative 1 is by nesting calls
     *       to the left-recursive rule, with the outer calls not being at the
     *       preferred precedence level. The
     *       {@link ATNConfig#isPrecedenceFilterSuppressed} property marks ATN
     *       configurations which do not meet this condition, and therefore are not
     *       eligible for elimination during the filtering process.
     *
     * The prediction context must be considered by this filter to address
     * situations like the following.
     *
     * ```antlr
     * grammar TA;
     * prog: statement* EOF;
     * statement: letterA | statement letterA 'b' ;
     * letterA: 'a';
     * ```
     *
     * If the above grammar, the ATN state immediately before the token
     * reference `'a'` in `letterA` is reachable from the left edge
     * of both the primary and closure blocks of the left-recursive rule
     * `statement`. The prediction context associated with each of these
     * configurations distinguishes between them, and prevents the alternative
     * which stepped out to `prog` (and then back in to `statement`
     * from being eliminated by the filter.
     *
     * @param configs The configuration set computed by
     * {@link #computeStartState} as the start state for the DFA.
     * @returns The transformed configuration set representing the start state
     * for a precedence DFA at a particular precedence level (determined by
     * calling {@link Parser#getPrecedence}).
     */ applyPrecedenceFilter(configs, globalContext, contextCache) {
        let statesFromAlt1 = new Map();
        let configSet = new $6co2U.ATNConfigSet();
        for (let config of configs){
            // handle alt 1 first
            if (config.alt !== 1) continue;
            let updatedContext = config.semanticContext.evalPrecedence(this._parser, globalContext);
            if (updatedContext == null) continue;
            statesFromAlt1.set(config.state.stateNumber, config.context);
            if (updatedContext !== config.semanticContext) configSet.add(config.transform(config.state, false, updatedContext), contextCache);
            else configSet.add(config, contextCache);
        }
        for (let config of configs){
            if (config.alt === 1) continue;
            if (!config.isPrecedenceFilterSuppressed) {
                /* In the future, this elimination step could be updated to also
                 * filter the prediction context for alternatives predicting alt>1
                 * (basically a graph subtraction algorithm).
                 */ let context = statesFromAlt1.get(config.state.stateNumber);
                if (context != null && context.equals(config.context)) continue;
            }
            configSet.add(config, contextCache);
        }
        return configSet;
    }
    getReachableTarget(source, trans, ttype) {
        if (trans.matches(ttype, 0, this.atn.maxTokenType)) return trans.target;
        return undefined;
    }
    /** collect and set D's semantic context */ predicateDFAState(D, configs, nalts) {
        let conflictingAlts = this.getConflictingAltsFromConfigSet(configs);
        if (!conflictingAlts) throw new Error("This unhandled scenario is intended to be unreachable, but I'm currently not sure of why we know that's the case.");
        if (ParserATNSimulator.debug) console.log("predicateDFAState " + D);
        let altToPred = this.getPredsForAmbigAlts(conflictingAlts, configs, nalts);
        // altToPred[uniqueAlt] is now our validating predicate (if any)
        let predPredictions;
        if (altToPred != null) {
            // we have a validating predicate; test it
            // Update DFA so reach becomes accept state with predicate
            predPredictions = this.getPredicatePredictions(conflictingAlts, altToPred);
            D.predicates = predPredictions;
        }
        return predPredictions;
    }
    getPredsForAmbigAlts(ambigAlts, configs, nalts) {
        // REACH=[1|1|[]|0:0, 1|2|[]|0:1]
        /* altToPred starts as an array of all undefined contexts. The entry at index i
         * corresponds to alternative i. altToPred[i] may have one of three values:
         *   1. undefined: no ATNConfig c is found such that c.alt===i
         *   2. SemanticContext.NONE: At least one ATNConfig c exists such that
         *      c.alt===i and c.semanticContext===SemanticContext.NONE. In other words,
         *      alt i has at least one unpredicated config.
         *   3. Non-NONE Semantic Context: There exists at least one, and for all
         *      ATNConfig c such that c.alt===i, c.semanticContext!==SemanticContext.NONE.
         *
         * From this, it is clear that NONE||anything==NONE.
         */ let altToPred = new Array(nalts + 1);
        let n = altToPred.length;
        for (let c of configs)if (ambigAlts.get(c.alt)) altToPred[c.alt] = $8DW9a.SemanticContext.or(altToPred[c.alt], c.semanticContext);
        let nPredAlts = 0;
        for(let i = 0; i < n; i++){
            if (altToPred[i] == null) altToPred[i] = $8DW9a.SemanticContext.NONE;
            else if (altToPred[i] !== $8DW9a.SemanticContext.NONE) nPredAlts++;
        }
        // At this point we know `altToPred` doesn't contain any undefined entries
        let result = altToPred;
        // nonambig alts are undefined in result
        if (nPredAlts === 0) result = undefined;
        if (ParserATNSimulator.debug) console.log("getPredsForAmbigAlts result " + (result ? $yEtb9.Arrays.toString(result) : "undefined"));
        return result;
    }
    getPredicatePredictions(ambigAlts, altToPred) {
        let pairs = [];
        let containsPredicate = false;
        for(let i = 1; i < altToPred.length; i++){
            let pred = altToPred[i];
            // unpredicated is indicated by SemanticContext.NONE
            $gwEr2(pred != null);
            // find first unpredicated but ambig alternative, if any.
            // Only ambiguous alternatives will have SemanticContext.NONE.
            // Any unambig alts or ambig naked alts after first ambig naked are ignored
            // (undefined, i) means alt i is the default prediction
            // if no (undefined, i), then no default prediction.
            if (ambigAlts != null && ambigAlts.get(i) && pred === $8DW9a.SemanticContext.NONE) pairs.push(new $5jw7S.DFAState.PredPrediction(pred, i));
            else if (pred !== $8DW9a.SemanticContext.NONE) {
                containsPredicate = true;
                pairs.push(new $5jw7S.DFAState.PredPrediction(pred, i));
            }
        }
        if (!containsPredicate) return undefined;
        //		System.out.println(Arrays.toString(altToPred)+"->"+pairs);
        return pairs;
    }
    /** Look through a list of predicate/alt pairs, returning alts for the
     *  pairs that win. An `undefined` predicate indicates an alt containing an
     *  unpredicated config which behaves as "always true."
     */ evalSemanticContext(predPredictions, outerContext, complete) {
        let predictions = new $lVdCV.BitSet();
        for (let pair of predPredictions){
            if (pair.pred === $8DW9a.SemanticContext.NONE) {
                predictions.set(pair.alt);
                if (!complete) break;
                continue;
            }
            let evaluatedResult = this.evalSemanticContextImpl(pair.pred, outerContext, pair.alt);
            if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("eval pred " + pair + "=" + evaluatedResult);
            if (evaluatedResult) {
                if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("PREDICT " + pair.alt);
                predictions.set(pair.alt);
                if (!complete) break;
            }
        }
        return predictions;
    }
    /**
     * Evaluate a semantic context within a specific parser context.
     *
     * This method might not be called for every semantic context evaluated
     * during the prediction process. In particular, we currently do not
     * evaluate the following but it may change in the future:
     *
     * * Precedence predicates (represented by
     *   {@link SemanticContext.PrecedencePredicate}) are not currently evaluated
     *   through this method.
     * * Operator predicates (represented by {@link SemanticContext.AND} and
     *   {@link SemanticContext.OR}) are evaluated as a single semantic
     *   context, rather than evaluating the operands individually.
     *   Implementations which require evaluation results from individual
     *   predicates should override this method to explicitly handle evaluation of
     *   the operands within operator predicates.
     *
     * @param pred The semantic context to evaluate
     * @param parserCallStack The parser context in which to evaluate the
     * semantic context
     * @param alt The alternative which is guarded by `pred`
     *
     * @since 4.3
     */ evalSemanticContextImpl(pred, parserCallStack, alt) {
        return pred.eval(this._parser, parserCallStack);
    }
    /* TODO: If we are doing predicates, there is no point in pursuing
         closure operations if we reach a DFA state that uniquely predicts
         alternative. We will not be caching that DFA state and it is a
         waste to pursue the closure. Might have to advance when we do
         ambig detection thought :(
          */ closure(sourceConfigs, configs, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon) {
        if (contextCache == null) contextCache = $8Uwhy.PredictionContextCache.UNCACHED;
        let currentConfigs = sourceConfigs;
        let closureBusy = new $fJumX.Array2DHashSet($73sQO.ObjectEqualityComparator.INSTANCE);
        while(currentConfigs.size > 0){
            let intermediate = new $6co2U.ATNConfigSet();
            for (let config of currentConfigs)this.closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContext, contextCache, 0, treatEofAsEpsilon);
            currentConfigs = intermediate;
        }
    }
    closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth, treatEofAsEpsilon) {
        if (ParserATNSimulator.debug) console.log("closure(" + config.toString(this._parser, true) + ")");
        if (config.state instanceof $U6v4o.RuleStopState) {
            // We hit rule end. If we have context info, use it
            if (!config.context.isEmpty) {
                let hasEmpty = config.context.hasEmpty;
                let nonEmptySize = config.context.size - (hasEmpty ? 1 : 0);
                for(let i = 0; i < nonEmptySize; i++){
                    let newContext = config.context.getParent(i); // "pop" return state
                    let returnState = this.atn.states[config.context.getReturnState(i)];
                    let c = $9qlOq.ATNConfig.create(returnState, config.alt, newContext, config.semanticContext);
                    // While we have context to pop back from, we may have
                    // gotten that context AFTER having fallen off a rule.
                    // Make sure we track that we are now out of context.
                    c.outerContextDepth = config.outerContextDepth;
                    c.isPrecedenceFilterSuppressed = config.isPrecedenceFilterSuppressed;
                    $gwEr2(depth > $f571e0d4afb01ff2$var$MIN_INTEGER_VALUE);
                    this.closureImpl(c, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth - 1, treatEofAsEpsilon);
                }
                if (!hasEmpty || !hasMoreContexts) return;
                config = config.transform(config.state, false, $haz8F.PredictionContext.EMPTY_LOCAL);
            } else if (!hasMoreContexts) {
                configs.add(config, contextCache);
                return;
            } else {
                // else if we have no context info, just chase follow links (if greedy)
                if (ParserATNSimulator.debug) console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
                if (config.context === $haz8F.PredictionContext.EMPTY_FULL) // no need to keep full context overhead when we step out
                config = config.transform(config.state, false, $haz8F.PredictionContext.EMPTY_LOCAL);
                else if (!config.reachesIntoOuterContext && $haz8F.PredictionContext.isEmptyLocal(config.context)) // add stop state when leaving decision rule for the first time
                configs.add(config, contextCache);
            }
        }
        let p = config.state;
        // optimization
        if (!p.onlyHasEpsilonTransitions) {
            configs.add(config, contextCache);
            // make sure to not return here, because EOF transitions can act as
            // both epsilon transitions and non-epsilon transitions.
            if (ParserATNSimulator.debug) console.log("added config " + configs);
        }
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            // This block implements first-edge elimination of ambiguous LR
            // alternatives as part of dynamic disambiguation during prediction.
            // See antlr/antlr4#1398.
            if (i === 0 && p.stateType === $9TBHo.ATNStateType.STAR_LOOP_ENTRY && p.precedenceRuleDecision && !config.context.hasEmpty) {
                let precedenceDecision = p;
                // When suppress is true, it means the outgoing edge i==0 is
                // ambiguous with the outgoing edge i==1, and thus the closure
                // operation can dynamically disambiguate by suppressing this
                // edge during the closure operation.
                let suppress = true;
                for(let j = 0; j < config.context.size; j++)if (!precedenceDecision.precedenceLoopbackStates.get(config.context.getReturnState(j))) {
                    suppress = false;
                    break;
                }
                if (suppress) continue;
            }
            let t = p.getOptimizedTransition(i);
            let continueCollecting = !(t instanceof $9elhd.ActionTransition) && collectPredicates;
            let c = this.getEpsilonTarget(config, t, continueCollecting, depth === 0, contextCache, treatEofAsEpsilon);
            if (c != null) {
                if (t instanceof $acKOx.RuleTransition) {
                    if (intermediate != null && !collectPredicates) {
                        intermediate.add(c, contextCache);
                        continue;
                    }
                }
                let newDepth = depth;
                if (config.state instanceof $U6v4o.RuleStopState) {
                    // target fell off end of rule; mark resulting c as having dipped into outer context
                    // We can't get here if incoming config was rule stop and we had context
                    // track how far we dip into outer context.  Might
                    // come in handy and we avoid evaluating context dependent
                    // preds if this is > 0.
                    if (this.dfa != null && this.dfa.isPrecedenceDfa) {
                        let outermostPrecedenceReturn = t.outermostPrecedenceReturn;
                        if (outermostPrecedenceReturn === this.dfa.atnStartState.ruleIndex) c.isPrecedenceFilterSuppressed = true;
                    }
                    c.outerContextDepth = c.outerContextDepth + 1;
                    if (!closureBusy.add(c)) continue;
                    $gwEr2(newDepth > $f571e0d4afb01ff2$var$MIN_INTEGER_VALUE);
                    newDepth--;
                    if (ParserATNSimulator.debug) console.log("dips into outer ctx: " + c);
                } else if (t instanceof $acKOx.RuleTransition) {
                    if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$haz8F.PredictionContext.isEmptyLocal(config.context))) {
                        $gwEr2(c.context === config.context);
                        if (newDepth === 0) {
                            // the pop/push of a tail call would keep the depth
                            // constant, except we latch if it goes negative
                            newDepth--;
                            if (!this.tail_call_preserves_sll && $haz8F.PredictionContext.isEmptyLocal(config.context)) // make sure the SLL config "dips into the outer context" or prediction may not fall back to LL on conflict
                            c.outerContextDepth = c.outerContextDepth + 1;
                        }
                    } else // latch when newDepth goes negative - once we step out of the entry context we can't return
                    if (newDepth >= 0) newDepth++;
                } else {
                    if (!t.isEpsilon && !closureBusy.add(c)) continue;
                }
                this.closureImpl(c, configs, intermediate, closureBusy, continueCollecting, hasMoreContexts, contextCache, newDepth, treatEofAsEpsilon);
            }
        }
    }
    getRuleName(index) {
        if (this._parser != null && index >= 0) return this._parser.ruleNames[index];
        return "<rule " + index + ">";
    }
    getEpsilonTarget(config, t, collectPredicates, inContext, contextCache, treatEofAsEpsilon) {
        switch(t.serializationType){
            case 3 /* RULE */ :
                return this.ruleTransition(config, t, contextCache);
            case 10 /* PRECEDENCE */ :
                return this.precedenceTransition(config, t, collectPredicates, inContext);
            case 4 /* PREDICATE */ :
                return this.predTransition(config, t, collectPredicates, inContext);
            case 6 /* ACTION */ :
                return this.actionTransition(config, t);
            case 1 /* EPSILON */ :
                return config.transform(t.target, false);
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                // EOF transitions act like epsilon transitions after the first EOF
                // transition is traversed
                if (treatEofAsEpsilon) {
                    if (t.matches($2G93d.Token.EOF, 0, 1)) return config.transform(t.target, false);
                }
                return undefined;
            default:
                return undefined;
        }
    }
    actionTransition(config, t) {
        if (ParserATNSimulator.debug) console.log("ACTION edge " + t.ruleIndex + ":" + t.actionIndex);
        return config.transform(t.target, false);
    }
    precedenceTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.precedence + ">=_p" + ", ctx dependent=true");
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && inContext) {
            let newSemCtx = $8DW9a.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    predTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.ruleIndex + ":" + pt.predIndex + ", ctx dependent=" + pt.isCtxDependent);
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && (!pt.isCtxDependent || pt.isCtxDependent && inContext)) {
            let newSemCtx = $8DW9a.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    ruleTransition(config, t, contextCache) {
        if (ParserATNSimulator.debug) console.log("CALL rule " + this.getRuleName(t.target.ruleIndex) + ", ctx=" + config.context);
        let returnState = t.followState;
        let newContext;
        if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$haz8F.PredictionContext.isEmptyLocal(config.context))) newContext = config.context;
        else if (contextCache != null) newContext = contextCache.getChild(config.context, returnState.stateNumber);
        else newContext = config.context.getChild(returnState.stateNumber);
        return config.transform(t.target, false, newContext);
    }
    isConflicted(configset, contextCache) {
        if (configset.uniqueAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER || configset.size <= 1) return undefined;
        let configs = configset.toArray();
        configs.sort(ParserATNSimulator.STATE_ALT_SORT_COMPARATOR);
        let exact = !configset.dipsIntoOuterContext;
        let alts = new $lVdCV.BitSet();
        let minAlt = configs[0].alt;
        alts.set(minAlt);
        /* Quick checks come first (single pass, no context joining):
         *  1. Make sure first config in the sorted list predicts the minimum
         *     represented alternative.
         *  2. Make sure every represented state has at least one configuration
         *     which predicts the minimum represented alternative.
         *  3. (exact only) make sure every represented state has at least one
         *     configuration which predicts each represented alternative.
         */ // quick check 1 & 2 => if we assume #1 holds and check #2 against the
        // minAlt from the first state, #2 will fail if the assumption was
        // incorrect
        let currentState = configs[0].state.nonStopStateNumber;
        for (let config of configs){
            let stateNumber = config.state.nonStopStateNumber;
            if (stateNumber !== currentState) {
                if (config.alt !== minAlt) return undefined;
                currentState = stateNumber;
            }
        }
        let representedAlts;
        if (exact) {
            currentState = configs[0].state.nonStopStateNumber;
            // get the represented alternatives of the first state
            representedAlts = new $lVdCV.BitSet();
            let maxAlt = minAlt;
            for (let config of configs){
                if (config.state.nonStopStateNumber !== currentState) break;
                let alt = config.alt;
                representedAlts.set(alt);
                maxAlt = alt;
            }
            // quick check #3:
            currentState = configs[0].state.nonStopStateNumber;
            let currentAlt = minAlt;
            for (let config of configs){
                let stateNumber = config.state.nonStopStateNumber;
                let alt = config.alt;
                if (stateNumber !== currentState) {
                    if (currentAlt !== maxAlt) {
                        exact = false;
                        break;
                    }
                    currentState = stateNumber;
                    currentAlt = minAlt;
                } else if (alt !== currentAlt) {
                    if (alt !== representedAlts.nextSetBit(currentAlt + 1)) {
                        exact = false;
                        break;
                    }
                    currentAlt = alt;
                }
            }
        }
        currentState = configs[0].state.nonStopStateNumber;
        let firstIndexCurrentState = 0;
        let lastIndexCurrentStateMinAlt = 0;
        let joinedCheckContext = configs[0].context;
        for(let i = 1; i < configs.length; i++){
            let config = configs[i];
            if (config.alt !== minAlt) break;
            if (config.state.nonStopStateNumber !== currentState) break;
            lastIndexCurrentStateMinAlt = i;
            joinedCheckContext = contextCache.join(joinedCheckContext, configs[i].context);
        }
        for(let i = lastIndexCurrentStateMinAlt + 1; i < configs.length; i++){
            let config = configs[i];
            let state = config.state;
            alts.set(config.alt);
            if (state.nonStopStateNumber !== currentState) {
                currentState = state.nonStopStateNumber;
                firstIndexCurrentState = i;
                lastIndexCurrentStateMinAlt = i;
                joinedCheckContext = config.context;
                for(let j = firstIndexCurrentState + 1; j < configs.length; j++){
                    let config2 = configs[j];
                    if (config2.alt !== minAlt) break;
                    if (config2.state.nonStopStateNumber !== currentState) break;
                    lastIndexCurrentStateMinAlt = j;
                    joinedCheckContext = contextCache.join(joinedCheckContext, config2.context);
                }
                i = lastIndexCurrentStateMinAlt;
                continue;
            }
            let joinedCheckContext2 = config.context;
            let currentAlt = config.alt;
            let lastIndexCurrentStateCurrentAlt = i;
            for(let j = lastIndexCurrentStateCurrentAlt + 1; j < configs.length; j++){
                let config2 = configs[j];
                if (config2.alt !== currentAlt) break;
                if (config2.state.nonStopStateNumber !== currentState) break;
                lastIndexCurrentStateCurrentAlt = j;
                joinedCheckContext2 = contextCache.join(joinedCheckContext2, config2.context);
            }
            i = lastIndexCurrentStateCurrentAlt;
            let check = contextCache.join(joinedCheckContext, joinedCheckContext2);
            if (!joinedCheckContext.equals(check)) return undefined;
            // update exact if necessary
            exact = exact && joinedCheckContext.equals(joinedCheckContext2);
        }
        return new $3AFtK.ConflictInfo(alts, exact);
    }
    getConflictingAltsFromConfigSet(configs) {
        let conflictingAlts = configs.conflictingAlts;
        if (conflictingAlts == null && configs.uniqueAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER) {
            conflictingAlts = new $lVdCV.BitSet();
            conflictingAlts.set(configs.uniqueAlt);
        }
        return conflictingAlts;
    }
    getTokenName(t) {
        if (t === $2G93d.Token.EOF) return "EOF";
        let vocabulary = this._parser != null ? this._parser.vocabulary : $5t4I3.VocabularyImpl.EMPTY_VOCABULARY;
        let displayName = vocabulary.getDisplayName(t);
        if (displayName === String(t)) return displayName;
        return displayName + "<" + t + ">";
    }
    getLookaheadName(input) {
        return this.getTokenName(input.LA(1));
    }
    dumpDeadEndConfigs(nvae) {
        console.log("dead end configs: ");
        let deadEndConfigs = nvae.deadEndConfigs;
        if (!deadEndConfigs) return;
        for (let c of deadEndConfigs){
            let trans = "no edges";
            if (c.state.numberOfOptimizedTransitions > 0) {
                let t = c.state.getOptimizedTransition(0);
                if (t instanceof $elgsv.AtomTransition) trans = "Atom " + this.getTokenName(t._label);
                else if (t instanceof $4mzjd.SetTransition) {
                    let not = t instanceof $grncH.NotSetTransition;
                    trans = (not ? "~" : "") + "Set " + t.set.toString();
                }
            }
            console.log(c.toString(this._parser, true) + ":" + trans);
        }
    }
    noViableAlt(input, outerContext, configs, startIndex) {
        return new $4qcTm.NoViableAltException(this._parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
    }
    getUniqueAlt(configs) {
        let alt = $lDQMG.ATN.INVALID_ALT_NUMBER;
        for (let c of configs){
            if (alt === $lDQMG.ATN.INVALID_ALT_NUMBER) alt = c.alt; // found first alt
            else if (c.alt !== alt) return $lDQMG.ATN.INVALID_ALT_NUMBER;
        }
        return alt;
    }
    configWithAltAtStopState(configs, alt) {
        for (let c of configs)if (c.alt === alt) {
            if (c.state instanceof $U6v4o.RuleStopState) return true;
        }
        return false;
    }
    addDFAEdge(dfa, fromState, t, contextTransitions, toConfigs, contextCache) {
        $gwEr2(contextTransitions == null || contextTransitions.isEmpty || dfa.isContextSensitive);
        let from = fromState;
        let to = this.addDFAState(dfa, toConfigs, contextCache);
        if (contextTransitions != null) for (let context of contextTransitions.toArray()){
            if (context === $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) {
                if (from.configs.isOutermostConfigSet) continue;
            }
            from.setContextSensitive(this.atn);
            from.setContextSymbol(t);
            let next = from.getContextTarget(context);
            if (next != null) {
                from = next;
                continue;
            }
            next = this.addDFAContextState(dfa, from.configs, context, contextCache);
            $gwEr2(context !== $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY || next.configs.isOutermostConfigSet);
            from.setContextTarget(context, next);
            from = next;
        }
        if (ParserATNSimulator.debug) console.log("EDGE " + from + " -> " + to + " upon " + this.getTokenName(t));
        this.setDFAEdge(from, t, to);
        if (ParserATNSimulator.debug) console.log("DFA=\n" + dfa.toString(this._parser != null ? this._parser.vocabulary : $5t4I3.VocabularyImpl.EMPTY_VOCABULARY, this._parser != null ? this._parser.ruleNames : undefined));
        return to;
    }
    setDFAEdge(p, t, q) {
        if (p != null) p.setTarget(t, q);
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAContextState(dfa, configs, returnContext, contextCache) {
        if (returnContext !== $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY) {
            let contextConfigs = new $6co2U.ATNConfigSet();
            for (let config of configs)contextConfigs.add(config.appendContext(returnContext, contextCache));
            return this.addDFAState(dfa, contextConfigs, contextCache);
        } else {
            $gwEr2(!configs.isOutermostConfigSet, "Shouldn't be adding a duplicate edge.");
            configs = configs.clone(true);
            configs.isOutermostConfigSet = true;
            return this.addDFAState(dfa, configs, contextCache);
        }
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAState(dfa, configs, contextCache) {
        let enableDfa = this.enable_global_context_dfa || !configs.isOutermostConfigSet;
        if (enableDfa) {
            if (!configs.isReadOnly) configs.optimizeConfigs(this);
            let proposed = this.createDFAState(dfa, configs);
            let existing = dfa.states.get(proposed);
            if (existing != null) return existing;
        }
        if (!configs.isReadOnly) {
            if (configs.conflictInfo == null) configs.conflictInfo = this.isConflicted(configs, contextCache);
        }
        let newState = this.createDFAState(dfa, configs.clone(true));
        // getDecisionState won't return undefined when we request a known valid decision
        let decisionState = this.atn.getDecisionState(dfa.decision);
        let predictedAlt = this.getUniqueAlt(configs);
        if (predictedAlt !== $lDQMG.ATN.INVALID_ALT_NUMBER) newState.acceptStateInfo = new $dg39p.AcceptStateInfo(predictedAlt);
        else if (configs.conflictingAlts != null) {
            let conflictingAlts = configs.conflictingAlts;
            if (conflictingAlts) newState.acceptStateInfo = new $dg39p.AcceptStateInfo(conflictingAlts.nextSetBit(0));
        }
        if (newState.isAcceptState && configs.hasSemanticContext) this.predicateDFAState(newState, configs, decisionState.numberOfTransitions);
        if (!enableDfa) return newState;
        let added = dfa.addState(newState);
        if (ParserATNSimulator.debug && added === newState) console.log("adding new DFA state: " + newState);
        return added;
    }
    createDFAState(dfa, configs) {
        return new $5jw7S.DFAState(configs);
    }
    reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $4Q2DM.Interval.of(startIndex, stopIndex);
            console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + conflictState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(this._parser, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        }
    }
    reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $4Q2DM.Interval.of(startIndex, stopIndex);
            console.log("reportContextSensitivity decision=" + dfa.decision + ":" + acceptState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(this._parser, dfa, startIndex, stopIndex, prediction, acceptState);
        }
    }
    /** If context sensitive parsing, we know it's ambiguity not conflict */ reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $4Q2DM.Interval.of(startIndex, stopIndex);
            console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAmbiguity) listener.reportAmbiguity(this._parser, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        }
    }
    getReturnState(context) {
        if (context.isEmpty) return $haz8F.PredictionContext.EMPTY_FULL_STATE_KEY;
        let state = this.atn.states[context.invokingState];
        let transition = state.transition(0);
        return transition.followState.stateNumber;
    }
    skipTailCalls(context) {
        if (!this.optimize_tail_calls) return context;
        while(!context.isEmpty){
            let state = this.atn.states[context.invokingState];
            $gwEr2(state.numberOfTransitions === 1 && state.transition(0).serializationType === 3 /* RULE */ );
            let transition = state.transition(0);
            if (!transition.tailCall) break;
            // This method requires that the root ancestor of the ParserRuleContext be empty. If we make it to this
            // line, we know the current node is not empty, which means it does have a parent.
            context = context.parent;
        }
        return context;
    }
    /**
     * @since 4.3
     */ get parser() {
        return this._parser;
    }
};
$f571e0d4afb01ff2$var$ParserATNSimulator.debug = false;
$f571e0d4afb01ff2$var$ParserATNSimulator.dfa_debug = false;
$f571e0d4afb01ff2$var$ParserATNSimulator.retry_debug = false;
$f571e0d4afb01ff2$var$ParserATNSimulator.STATE_ALT_SORT_COMPARATOR = (o1, o2)=>{
    let diff = o1.state.nonStopStateNumber - o2.state.nonStopStateNumber;
    if (diff !== 0) return diff;
    diff = o1.alt - o2.alt;
    if (diff !== 0) return diff;
    return 0;
};
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "predictionMode", void 0);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getPredictionMode", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "setPredictionMode", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.Override
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "reset", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "adaptivePredict", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getStartState", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(3, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "execDFA", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(3, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "execATN", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "handleNoViableAlt", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getExistingTargetState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "computeTargetState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "removeAllConfigsNotInRuleStopState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "computeStartState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "applyPrecedenceFilter", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getReachableTarget", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getPredsForAmbigAlts", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "evalSemanticContext", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "evalSemanticContextImpl", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(4, $esDFm.Nullable)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "closure", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.Nullable),
    $f571e0d4afb01ff2$var$__param(3, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(6, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "closureImpl", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getRuleName", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getEpsilonTarget", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "actionTransition", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.Nullable,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "precedenceTransition", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.Nullable,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "predTransition", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.Nullable)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "ruleTransition", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "isConflicted", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getTokenName", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "dumpDeadEndConfigs", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "noViableAlt", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "getUniqueAlt", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "configWithAltAtStopState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(4, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "addDFAEdge", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.Nullable),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.Nullable)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "setDFAEdge", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "addDFAContextState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "addDFAState", null);
$f571e0d4afb01ff2$var$__decorate([
    $esDFm.NotNull,
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(1, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "createDFAState", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "reportAttemptingFullContext", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(2, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "reportContextSensitivity", null);
$f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(5, $esDFm.NotNull),
    $f571e0d4afb01ff2$var$__param(6, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator.prototype, "reportAmbiguity", null);
$f571e0d4afb01ff2$var$ParserATNSimulator = $f571e0d4afb01ff2$var$__decorate([
    $f571e0d4afb01ff2$var$__param(0, $esDFm.NotNull)
], $f571e0d4afb01ff2$var$ParserATNSimulator);
module.exports.ParserATNSimulator = $f571e0d4afb01ff2$var$ParserATNSimulator;

});
parcelRegister("3AFtK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $29d4e8b3dd9d0c91$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConflictInfo = void 0;

var $esDFm = parcelRequire("esDFm");

var $g4Hat = parcelRequire("g4Hat");
/**
 * This class stores information about a configuration conflict.
 *
 * @author Sam Harwell
 */ class $29d4e8b3dd9d0c91$var$ConflictInfo {
    constructor(conflictedAlts, exact){
        this._conflictedAlts = conflictedAlts;
        this.exact = exact;
    }
    /**
     * Gets the set of conflicting alternatives for the configuration set.
     */ get conflictedAlts() {
        return this._conflictedAlts;
    }
    /**
     * Gets whether or not the configuration conflict is an exact conflict.
     * An exact conflict occurs when the prediction algorithm determines that
     * the represented alternatives for a particular configuration set cannot be
     * further reduced by consuming additional input. After reaching an exact
     * conflict during an SLL prediction, only switch to full-context prediction
     * could reduce the set of viable alternatives. In LL prediction, an exact
     * conflict indicates a true ambiguity in the input.
     *
     * For the {@link PredictionMode#LL_EXACT_AMBIG_DETECTION} prediction mode,
     * accept states are conflicting but not exact are treated as non-accept
     * states.
     */ get isExact() {
        return this.exact;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $29d4e8b3dd9d0c91$var$ConflictInfo)) return false;
        return this.isExact === obj.isExact && $g4Hat.equals(this.conflictedAlts, obj.conflictedAlts);
    }
    hashCode() {
        return this.conflictedAlts.hashCode();
    }
}
$29d4e8b3dd9d0c91$var$__decorate([
    $esDFm.Override
], $29d4e8b3dd9d0c91$var$ConflictInfo.prototype, "equals", null);
$29d4e8b3dd9d0c91$var$__decorate([
    $esDFm.Override
], $29d4e8b3dd9d0c91$var$ConflictInfo.prototype, "hashCode", null);
module.exports.ConflictInfo = $29d4e8b3dd9d0c91$var$ConflictInfo;

});

parcelRegister("5NlfZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $43820489bf2012b7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserRuleContext = void 0;

var $5zuwY = parcelRequire("5zuwY");

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");

var $1uFvm = parcelRequire("1uFvm");

var $6JC52 = parcelRequire("6JC52");
/** A rule invocation record for parsing.
 *
 *  Contains all of the information about the current rule not stored in the
 *  RuleContext. It handles parse tree children list, Any ATN state
 *  tracing, and the default values available for rule invocations:
 *  start, stop, rule index, current alt number.
 *
 *  Subclasses made for each rule and grammar track the parameters,
 *  return values, locals, and labels specific to that rule. These
 *  are the objects that are returned from rules.
 *
 *  Note text is not an actual field of a rule return value; it is computed
 *  from start and stop using the input stream's toString() method.  I
 *  could add a ctor to this so that we can pass in and store the input
 *  stream, but I'm not sure we want to do that.  It would seem to be undefined
 *  to get the .text property anyway if the rule matches tokens from multiple
 *  input streams.
 *
 *  I do not use getters for fields of objects that are used simply to
 *  group values such as this aggregate.  The getters/setters are there to
 *  satisfy the superclass interface.
 */ class $43820489bf2012b7$var$ParserRuleContext extends $1uFvm.RuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber == null) super();
        else super(parent, invokingStateNumber);
    }
    static emptyContext() {
        return $43820489bf2012b7$var$ParserRuleContext.EMPTY;
    }
    /**
     * COPY a ctx (I'm deliberately not using copy constructor) to avoid
     * confusion with creating node with parent. Does not copy children
     * (except error leaves).
     *
     * This is used in the generated parser code to flip a generic XContext
     * node for rule X to a YContext for alt label Y. In that sense, it is not
     * really a generic copy function.
     *
     * If we do an error sync() at start of a rule, we might add error nodes
     * to the generic XContext so this function must copy those nodes to the
     * YContext as well else they are lost!
     */ copyFrom(ctx) {
        this._parent = ctx._parent;
        this.invokingState = ctx.invokingState;
        this._start = ctx._start;
        this._stop = ctx._stop;
        // copy any error nodes to alt label node
        if (ctx.children) {
            this.children = [];
            // reset parent pointer for any error nodes
            for (let child of ctx.children)if (child instanceof $5zuwY.ErrorNode) this.addChild(child);
        }
    }
    // Double dispatch methods for listeners
    enterRule(listener) {
    // intentionally empty
    }
    exitRule(listener) {
    // intentionally empty
    }
    /** Add a parse tree node to this as a child.  Works for
     *  internal and leaf nodes. Does not set parent link;
     *  other add methods must do that. Other addChild methods
     *  call this.
     *
     *  We cannot set the parent pointer of the incoming node
     *  because the existing interfaces do not have a setParent()
     *  method and I don't want to break backward compatibility for this.
     *
     *  @since 4.7
     */ addAnyChild(t) {
        if (!this.children) this.children = [
            t
        ];
        else this.children.push(t);
        return t;
    }
    addChild(t) {
        let result;
        if (t instanceof $6JC52.TerminalNode) {
            t.setParent(this);
            this.addAnyChild(t);
            return;
        } else if (t instanceof $1uFvm.RuleContext) {
            // Does not set parent link
            this.addAnyChild(t);
            return;
        } else {
            // Deprecated code path
            t = new $6JC52.TerminalNode(t);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    addErrorNode(node) {
        if (node instanceof $5zuwY.ErrorNode) {
            const errorNode = node;
            errorNode.setParent(this);
            return this.addAnyChild(errorNode);
        } else {
            // deprecated path
            const badToken = node;
            let t = new $5zuwY.ErrorNode(badToken);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    //	public void trace(int s) {
    //		if ( states==null ) states = new ArrayList<Integer>();
    //		states.add(s);
    //	}
    /** Used by enterOuterAlt to toss out a RuleContext previously added as
     *  we entered a rule. If we have # label, we will need to remove
     *  generic ruleContext object.
     */ removeLastChild() {
        if (this.children) this.children.pop();
    }
    get parent() {
        let parent = super.parent;
        if (parent === undefined || parent instanceof $43820489bf2012b7$var$ParserRuleContext) return parent;
        throw new TypeError("Invalid parent type for ParserRuleContext");
    }
    // Note: in TypeScript, order or arguments reversed
    getChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) throw new RangeError("index parameter must be between >= 0 and <= number of children.");
        if (ctxType == null) return this.children[i];
        let result = this.tryGetChild(i, ctxType);
        if (result === undefined) throw new Error("The specified node does not exist");
        return result;
    }
    tryGetChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what node with ctxType have we found?
        for (let o of this.children)if (o instanceof ctxType) {
            j++;
            if (j === i) return o;
        }
        return undefined;
    }
    getToken(ttype, i) {
        let result = this.tryGetToken(ttype, i);
        if (result === undefined) throw new Error("The specified token does not exist");
        return result;
    }
    tryGetToken(ttype, i) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what token with ttype have we found?
        for (let o of this.children)if (o instanceof $6JC52.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) {
                j++;
                if (j === i) return o;
            }
        }
        return undefined;
    }
    getTokens(ttype) {
        let tokens = [];
        if (!this.children) return tokens;
        for (let o of this.children)if (o instanceof $6JC52.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) tokens.push(o);
        }
        return tokens;
    }
    get ruleContext() {
        return this;
    }
    // NOTE: argument order change from Java version
    getRuleContext(i, ctxType) {
        return this.getChild(i, ctxType);
    }
    tryGetRuleContext(i, ctxType) {
        return this.tryGetChild(i, ctxType);
    }
    getRuleContexts(ctxType) {
        let contexts = [];
        if (!this.children) return contexts;
        for (let o of this.children)if (o instanceof ctxType) contexts.push(o);
        return contexts;
    }
    get childCount() {
        return this.children ? this.children.length : 0;
    }
    get sourceInterval() {
        if (!this._start) return $4Q2DM.Interval.INVALID;
        if (!this._stop || this._stop.tokenIndex < this._start.tokenIndex) return $4Q2DM.Interval.of(this._start.tokenIndex, this._start.tokenIndex - 1); // empty
        return $4Q2DM.Interval.of(this._start.tokenIndex, this._stop.tokenIndex);
    }
    /**
     * Get the initial token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may exceed stop.
     */ get start() {
        return this._start;
    }
    /**
     * Get the final token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may precede start.
     */ get stop() {
        return this._stop;
    }
    /** Used for rule context info debugging during parse-time, not so much for ATN debugging */ toInfoString(recognizer) {
        let rules = recognizer.getRuleInvocationStack(this).reverse();
        return "ParserRuleContext" + rules + "{" + "start=" + this._start + ", stop=" + this._stop + "}";
    }
}
$43820489bf2012b7$var$ParserRuleContext.EMPTY = new $43820489bf2012b7$var$ParserRuleContext();
$43820489bf2012b7$var$__decorate([
    $esDFm.Override
], $43820489bf2012b7$var$ParserRuleContext.prototype, "parent", null);
$43820489bf2012b7$var$__decorate([
    $esDFm.Override
], $43820489bf2012b7$var$ParserRuleContext.prototype, "childCount", null);
$43820489bf2012b7$var$__decorate([
    $esDFm.Override
], $43820489bf2012b7$var$ParserRuleContext.prototype, "sourceInterval", null);
module.exports.ParserRuleContext = $43820489bf2012b7$var$ParserRuleContext;

});
parcelRegister("5zuwY", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $40e7e769cc652e20$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorNode = void 0;

var $esDFm = parcelRequire("esDFm");

var $6JC52 = parcelRequire("6JC52");
/** Represents a token that was consumed during resynchronization
 *  rather than during a valid match operation. For example,
 *  we will create this kind of a node during single token insertion
 *  and deletion as well as during "consume until error recovery set"
 *  upon no viable alternative exceptions.
 */ class $40e7e769cc652e20$var$ErrorNode extends $6JC52.TerminalNode {
    constructor(token){
        super(token);
    }
    accept(visitor) {
        return visitor.visitErrorNode(this);
    }
}
$40e7e769cc652e20$var$__decorate([
    $esDFm.Override
], $40e7e769cc652e20$var$ErrorNode.prototype, "accept", null);
module.exports.ErrorNode = $40e7e769cc652e20$var$ErrorNode;

});
parcelRegister("6JC52", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4e747c0024dd6c45$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TerminalNode = void 0;

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
class $4e747c0024dd6c45$var$TerminalNode {
    constructor(symbol){
        this._symbol = symbol;
    }
    getChild(i) {
        throw new RangeError("Terminal Node has no children.");
    }
    get symbol() {
        return this._symbol;
    }
    get parent() {
        return this._parent;
    }
    setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this._symbol;
    }
    get sourceInterval() {
        let tokenIndex = this._symbol.tokenIndex;
        return new $4Q2DM.Interval(tokenIndex, tokenIndex);
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitTerminal(this);
    }
    get text() {
        return this._symbol.text || "";
    }
    toStringTree(parser) {
        return this.toString();
    }
    toString() {
        if (this._symbol.type === $2G93d.Token.EOF) return "<EOF>";
        return this._symbol.text || "";
    }
}
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "getChild", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "parent", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "setParent", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "payload", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "sourceInterval", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "childCount", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "accept", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "text", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "toStringTree", null);
$4e747c0024dd6c45$var$__decorate([
    $esDFm.Override
], $4e747c0024dd6c45$var$TerminalNode.prototype, "toString", null);
module.exports.TerminalNode = $4e747c0024dd6c45$var$TerminalNode;

});


parcelRegister("1uFvm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1168c9c90534f342$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContext = void 0;

var $lDQMG = parcelRequire("lDQMG");

var $24a4y = parcelRequire("24a4y");

var $8FZwR = parcelRequire("8FZwR");

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");

var $hLP94 = parcelRequire("hLP94");

var $5NlfZ = parcelRequire("5NlfZ");
/** A rule context is a record of a single rule invocation.
 *
 *  We form a stack of these context objects using the parent
 *  pointer. A parent pointer of `undefined` indicates that the current
 *  context is the bottom of the stack. The ParserRuleContext subclass
 *  as a children list so that we can turn this data structure into a
 *  tree.
 *
 *  The root node always has a `undefined` pointer and invokingState of -1.
 *
 *  Upon entry to parsing, the first invoked rule function creates a
 *  context object (a subclass specialized for that rule such as
 *  SContext) and makes it the root of a parse tree, recorded by field
 *  Parser._ctx.
 *
 *  public final SContext s() throws RecognitionException {
 *      SContext _localctx = new SContext(_ctx, state); <-- create new node
 *      enterRule(_localctx, 0, RULE_s);                     <-- push it
 *      ...
 *      exitRule();                                          <-- pop back to _localctx
 *      return _localctx;
 *  }
 *
 *  A subsequent rule invocation of r from the start rule s pushes a
 *  new context object for r whose parent points at s and use invoking
 *  state is the state with r emanating as edge label.
 *
 *  The invokingState fields from a context object to the root
 *  together form a stack of rule indication states where the root
 *  (bottom of the stack) has a -1 sentinel value. If we invoke start
 *  symbol s then call r1, which calls r2, the  would look like
 *  this:
 *
 *     SContext[-1]   <- root node (bottom of the stack)
 *     R1Context[p]   <- p in rule s called r1
 *     R2Context[q]   <- q in rule r1 called r2
 *
 *  So the top of the stack, _ctx, represents a call to the current
 *  rule and it holds the return address from another rule that invoke
 *  to this rule. To invoke a rule, we must always have a current context.
 *
 *  The parent contexts are useful for computing lookahead sets and
 *  getting error information.
 *
 *  These objects are used during parsing and prediction.
 *  For the special case of parsers, we use the subclass
 *  ParserRuleContext.
 *
 *  @see ParserRuleContext
 */ class $1168c9c90534f342$var$RuleContext extends $8FZwR.RuleNode {
    constructor(parent, invokingState){
        super();
        this._parent = parent;
        this.invokingState = invokingState != null ? invokingState : -1;
    }
    static getChildContext(parent, invokingState) {
        return new $1168c9c90534f342$var$RuleContext(parent, invokingState);
    }
    depth() {
        let n = 0;
        let p = this;
        while(p){
            p = p._parent;
            n++;
        }
        return n;
    }
    /** A context is empty if there is no invoking state; meaning nobody called
     *  current context.
     */ get isEmpty() {
        return this.invokingState === -1;
    }
    // satisfy the ParseTree / SyntaxTree interface
    get sourceInterval() {
        return $4Q2DM.Interval.INVALID;
    }
    get ruleContext() {
        return this;
    }
    get parent() {
        return this._parent;
    }
    /** @since 4.7. {@see ParseTree#setParent} comment */ setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this;
    }
    /** Return the combined text of all child nodes. This method only considers
     *  tokens which have been added to the parse tree.
     *
     *  Since tokens on hidden channels (e.g. whitespace or comments) are not
     *  added to the parse trees, they will not appear in the output of this
     *  method.
     */ get text() {
        if (this.childCount === 0) return "";
        let builder = "";
        for(let i = 0; i < this.childCount; i++)builder += this.getChild(i).text;
        return builder.toString();
    }
    get ruleIndex() {
        return -1;
    }
    /** For rule associated with this parse tree internal node, return
     *  the outer alternative number used to match the input. Default
     *  implementation does not compute nor store this alt num. Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *  to set it.
     *
     *  @since 4.5.3
     */ get altNumber() {
        return $lDQMG.ATN.INVALID_ALT_NUMBER;
    }
    /** Set the outer alternative number for this context node. Default
     *  implementation does nothing to avoid backing field overhead for
     *  trees that don't need it.  Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *
     *  @since 4.5.3
     */ set altNumber(altNumber) {
    // intentionally ignored by the base implementation
    }
    getChild(i) {
        throw new RangeError("i must be greater than or equal to 0 and less than childCount");
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitChildren(this);
    }
    toStringTree(recog) {
        return $hLP94.Trees.toStringTree(this, recog);
    }
    toString(arg1, stop) {
        const ruleNames = arg1 instanceof $24a4y.Recognizer ? arg1.ruleNames : arg1;
        stop = stop || $5NlfZ.ParserRuleContext.emptyContext();
        let buf = "";
        let p = this;
        buf += "[";
        while(p && p !== stop){
            if (!ruleNames) {
                if (!p.isEmpty) buf += p.invokingState;
            } else {
                let ruleIndex = p.ruleIndex;
                let ruleName = ruleIndex >= 0 && ruleIndex < ruleNames.length ? ruleNames[ruleIndex] : ruleIndex.toString();
                buf += ruleName;
            }
            if (p._parent && (ruleNames || !p._parent.isEmpty)) buf += " ";
            p = p._parent;
        }
        buf += "]";
        return buf.toString();
    }
}
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "sourceInterval", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "ruleContext", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "parent", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "setParent", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "payload", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "text", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "getChild", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "childCount", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "accept", null);
$1168c9c90534f342$var$__decorate([
    $esDFm.Override
], $1168c9c90534f342$var$RuleContext.prototype, "toStringTree", null);
module.exports.RuleContext = $1168c9c90534f342$var$RuleContext;

});
parcelRegister("8FZwR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleNode = void 0;
class $6511e1766b7044d6$var$RuleNode {
}
module.exports.RuleNode = $6511e1766b7044d6$var$RuleNode;

});

parcelRegister("hLP94", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cefe7fdd17d6991a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $cefe7fdd17d6991a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Trees = void 0;

var $lDQMG = parcelRequire("lDQMG");

var $8Mk1Z = parcelRequire("8Mk1Z");

var $5zuwY = parcelRequire("5zuwY");

var $esDFm = parcelRequire("esDFm");

var $dDGsq = parcelRequire("dDGsq");

var $5NlfZ = parcelRequire("5NlfZ");

var $8FZwR = parcelRequire("8FZwR");

var $6JC52 = parcelRequire("6JC52");

var $2G93d = parcelRequire("2G93d");

var $g4Hat = parcelRequire("g4Hat");
/** A set of utility routines useful for all kinds of ANTLR trees. */ class $cefe7fdd17d6991a$var$Trees {
    static toStringTree(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $dDGsq.Parser) ruleNames = arg2.ruleNames;
        else ruleNames = arg2;
        let s = $g4Hat.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        if (t.childCount === 0) return s;
        let buf = "";
        buf += "(";
        s = $g4Hat.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        buf += s;
        buf += " ";
        for(let i = 0; i < t.childCount; i++){
            if (i > 0) buf += " ";
            buf += this.toStringTree(t.getChild(i), ruleNames);
        }
        buf += ")";
        return buf;
    }
    static getNodeText(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $dDGsq.Parser) ruleNames = arg2.ruleNames;
        else if (arg2) ruleNames = arg2;
        else {
            // no recog or rule names
            let payload = t.payload;
            if (typeof payload.text === "string") return payload.text;
            return t.payload.toString();
        }
        if (t instanceof $8FZwR.RuleNode) {
            let ruleContext = t.ruleContext;
            let ruleIndex = ruleContext.ruleIndex;
            let ruleName = ruleNames[ruleIndex];
            let altNumber = ruleContext.altNumber;
            if (altNumber !== $lDQMG.ATN.INVALID_ALT_NUMBER) return ruleName + ":" + altNumber;
            return ruleName;
        } else if (t instanceof $5zuwY.ErrorNode) return t.toString();
        else if (t instanceof $6JC52.TerminalNode) {
            let symbol = t.symbol;
            return symbol.text || "";
        }
        throw new TypeError("Unexpected node type");
    }
    static getChildren(t) {
        let kids = [];
        for(let i = 0; i < t.childCount; i++)kids.push(t.getChild(i));
        return kids;
    }
    static getAncestors(t) {
        let ancestors = [];
        let p = t.parent;
        while(p){
            ancestors.unshift(p); // insert at start
            p = p.parent;
        }
        return ancestors;
    }
    /** Return true if t is u's parent or a node on path to root from u.
     *  Use === not equals().
     *
     *  @since 4.5.1
     */ static isAncestorOf(t, u) {
        if (!t || !u || !t.parent) return false;
        let p = u.parent;
        while(p){
            if (t === p) return true;
            p = p.parent;
        }
        return false;
    }
    static findAllTokenNodes(t, ttype) {
        return $cefe7fdd17d6991a$var$Trees.findAllNodes(t, ttype, true);
    }
    static findAllRuleNodes(t, ruleIndex) {
        return $cefe7fdd17d6991a$var$Trees.findAllNodes(t, ruleIndex, false);
    }
    static findAllNodes(t, index, findTokens) {
        let nodes = [];
        $cefe7fdd17d6991a$var$Trees._findAllNodes(t, index, findTokens, nodes);
        return nodes;
    }
    static _findAllNodes(t, index, findTokens, nodes) {
        // check this node (the root) first
        if (findTokens && t instanceof $6JC52.TerminalNode) {
            if (t.symbol.type === index) nodes.push(t);
        } else if (!findTokens && t instanceof $5NlfZ.ParserRuleContext) {
            if (t.ruleIndex === index) nodes.push(t);
        }
        // check children
        for(let i = 0; i < t.childCount; i++)$cefe7fdd17d6991a$var$Trees._findAllNodes(t.getChild(i), index, findTokens, nodes);
    }
    /** Get all descendents; includes t itself.
     *
     * @since 4.5.1
     */ static getDescendants(t) {
        let nodes = [];
        function recurse(e) {
            nodes.push(e);
            const n = e.childCount;
            for(let i = 0; i < n; i++)recurse(e.getChild(i));
        }
        recurse(t);
        return nodes;
    }
    /** Find smallest subtree of t enclosing range startTokenIndex..stopTokenIndex
     *  inclusively using postorder traversal.  Recursive depth-first-search.
     *
     *  @since 4.5
     */ static getRootOfSubtreeEnclosingRegion(t, startTokenIndex, stopTokenIndex) {
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let child = t.getChild(i);
            let r = $cefe7fdd17d6991a$var$Trees.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
            if (r) return r;
        }
        if (t instanceof $5NlfZ.ParserRuleContext) {
            let stopToken = t.stop;
            if (startTokenIndex >= t.start.tokenIndex && // is range fully contained in t?
            (stopToken == null || stopTokenIndex <= stopToken.tokenIndex)) // note: r.stop==null likely implies that we bailed out of parser and there's nothing to the right
            return t;
        }
        return undefined;
    }
    /** Replace any subtree siblings of root that are completely to left
     *  or right of lookahead range with a CommonToken(Token.INVALID_TYPE,"...")
     *  node. The source interval for t is not altered to suit smaller range!
     *
     *  WARNING: destructive to t.
     *
     *  @since 4.5.1
     */ static stripChildrenOutOfRange(t, root, startIndex, stopIndex) {
        if (!t) return;
        let count = t.childCount;
        for(let i = 0; i < count; i++){
            let child = t.getChild(i);
            let range = child.sourceInterval;
            if (child instanceof $5NlfZ.ParserRuleContext && (range.b < startIndex || range.a > stopIndex)) {
                if ($cefe7fdd17d6991a$var$Trees.isAncestorOf(child, root)) {
                    let abbrev = new $8Mk1Z.CommonToken($2G93d.Token.INVALID_TYPE, "...");
                    t.children[i] = new $6JC52.TerminalNode(abbrev); // HACK access to private
                }
            }
        }
    }
    static findNodeSuchThat(t, pred) {
        // No type check needed as long as users only use one of the available overloads
        if (pred(t)) return t;
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let u = $cefe7fdd17d6991a$var$Trees.findNodeSuchThat(t.getChild(i), pred);
            if (u !== undefined) return u;
        }
        return undefined;
    }
}
$cefe7fdd17d6991a$var$__decorate([
    $cefe7fdd17d6991a$var$__param(0, $esDFm.NotNull)
], $cefe7fdd17d6991a$var$Trees, "toStringTree", null);
$cefe7fdd17d6991a$var$__decorate([
    $esDFm.NotNull,
    $cefe7fdd17d6991a$var$__param(0, $esDFm.NotNull)
], $cefe7fdd17d6991a$var$Trees, "getAncestors", null);
$cefe7fdd17d6991a$var$__decorate([
    $cefe7fdd17d6991a$var$__param(0, $esDFm.NotNull)
], $cefe7fdd17d6991a$var$Trees, "getRootOfSubtreeEnclosingRegion", null);
module.exports.Trees = $cefe7fdd17d6991a$var$Trees;

});



parcelRegister("2cmeG", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $199df35814bac0d8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionMode = void 0;

var $dkveu = parcelRequire("dkveu");

var $i99P2 = parcelRequire("i99P2");

var $esDFm = parcelRequire("esDFm");

var $U6v4o = parcelRequire("U6v4o");
/**
 * This enumeration defines the prediction modes available in ANTLR 4 along with
 * utility methods for analyzing configuration sets for conflicts and/or
 * ambiguities.
 */ var $199df35814bac0d8$var$PredictionMode;
(function(PredictionMode) {
    /**
     * The SLL(*) prediction mode. This prediction mode ignores the current
     * parser context when making predictions. This is the fastest prediction
     * mode, and provides correct results for many grammars. This prediction
     * mode is more powerful than the prediction mode provided by ANTLR 3, but
     * may result in syntax errors for grammar and input combinations which are
     * not SLL.
     *
     * When using this prediction mode, the parser will either return a correct
     * parse tree (i.e. the same parse tree that would be returned with the
     * {@link #LL} prediction mode), or it will report a syntax error. If a
     * syntax error is encountered when using the {@link #SLL} prediction mode,
     * it may be due to either an actual syntax error in the input or indicate
     * that the particular combination of grammar and input requires the more
     * powerful {@link #LL} prediction abilities to complete successfully.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["SLL"] = 0] = "SLL";
    /**
     * The LL(*) prediction mode. This prediction mode allows the current parser
     * context to be used for resolving SLL conflicts that occur during
     * prediction. This is the fastest prediction mode that guarantees correct
     * parse results for all combinations of grammars with syntactically correct
     * inputs.
     *
     * When using this prediction mode, the parser will make correct decisions
     * for all syntactically-correct grammar and input combinations. However, in
     * cases where the grammar is truly ambiguous this prediction mode might not
     * report a precise answer for *exactly which* alternatives are
     * ambiguous.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL"] = 1] = "LL";
    /**
     * The LL(*) prediction mode with exact ambiguity detection. In addition to
     * the correctness guarantees provided by the {@link #LL} prediction mode,
     * this prediction mode instructs the prediction algorithm to determine the
     * complete and exact set of ambiguous alternatives for every ambiguous
     * decision encountered while parsing.
     *
     * This prediction mode may be used for diagnosing ambiguities during
     * grammar development. Due to the performance overhead of calculating sets
     * of ambiguous alternatives, this prediction mode should be avoided when
     * the exact results are not necessary.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL_EXACT_AMBIG_DETECTION"] = 2] = "LL_EXACT_AMBIG_DETECTION";
})($199df35814bac0d8$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
(function(PredictionMode) {
    /** A Map that uses just the state and the stack context as the key. */ // NOTE: Base type used to be FlexibleHashMap<ATNConfig, BitSet>
    class AltAndContextMap extends $dkveu.Array2DHashMap {
        constructor(){
            super(AltAndContextConfigEqualityComparator.INSTANCE);
        }
    }
    class AltAndContextConfigEqualityComparator {
        AltAndContextConfigEqualityComparator() {
        // intentionally empty
        }
        /**
         * The hash code is only a function of the {@link ATNState#stateNumber}
         * and {@link ATNConfig#context}.
         */ hashCode(o) {
            let hashCode = $i99P2.MurmurHash.initialize(7);
            hashCode = $i99P2.MurmurHash.update(hashCode, o.state.stateNumber);
            hashCode = $i99P2.MurmurHash.update(hashCode, o.context);
            hashCode = $i99P2.MurmurHash.finish(hashCode, 2);
            return hashCode;
        }
        equals(a, b) {
            if (a === b) return true;
            if (a == null || b == null) return false;
            return a.state.stateNumber === b.state.stateNumber && a.context.equals(b.context);
        }
    }
    AltAndContextConfigEqualityComparator.INSTANCE = new AltAndContextConfigEqualityComparator();
    $199df35814bac0d8$var$__decorate([
        $esDFm.Override
    ], AltAndContextConfigEqualityComparator.prototype, "hashCode", null);
    $199df35814bac0d8$var$__decorate([
        $esDFm.Override
    ], AltAndContextConfigEqualityComparator.prototype, "equals", null);
    /**
     * Checks if any configuration in `configs` is in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if any configuration in `configs` is in a
     * {@link RuleStopState}, otherwise `false`
     */ function hasConfigInRuleStopState(configs) {
        for (let c of configs){
            if (c.state instanceof $U6v4o.RuleStopState) return true;
        }
        return false;
    }
    PredictionMode.hasConfigInRuleStopState = hasConfigInRuleStopState;
    /**
     * Checks if all configurations in `configs` are in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if all configurations in `configs` are in a
     * {@link RuleStopState}, otherwise `false`
     */ function allConfigsInRuleStopStates(/*@NotNull*/ configs) {
        for (let config of configs){
            if (!(config.state instanceof $U6v4o.RuleStopState)) return false;
        }
        return true;
    }
    PredictionMode.allConfigsInRuleStopStates = allConfigsInRuleStopStates;
})($199df35814bac0d8$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));

});

parcelRegister("fO6gt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b8206294aba6be67$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b8206294aba6be67$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimulatorState = void 0;

var $esDFm = parcelRequire("esDFm");

var $5NlfZ = parcelRequire("5NlfZ");
/**
 *
 * @author Sam Harwell
 */ let $b8206294aba6be67$var$SimulatorState = class SimulatorState {
    constructor(outerContext, s0, useContext, remainingOuterContext){
        this.outerContext = outerContext != null ? outerContext : $5NlfZ.ParserRuleContext.emptyContext();
        this.s0 = s0;
        this.useContext = useContext;
        this.remainingOuterContext = remainingOuterContext;
    }
};
$b8206294aba6be67$var$SimulatorState = $b8206294aba6be67$var$__decorate([
    $b8206294aba6be67$var$__param(1, $esDFm.NotNull)
], $b8206294aba6be67$var$SimulatorState);
module.exports.SimulatorState = $b8206294aba6be67$var$SimulatorState;

});


parcelRegister("j2EBs", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ddcdb33017a842a9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusBlockStartState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $fqwBK = parcelRequire("fqwBK");

var $esDFm = parcelRequire("esDFm");
/** Start of `(A|B|...)+` loop. Technically a decision state, but
 *  we don't use for code generation; somebody might need it, so I'm defining
 *  it for completeness. In reality, the {@link PlusLoopbackState} node is the
 *  real decision-making note for `A+`.
 */ class $ddcdb33017a842a9$var$PlusBlockStartState extends $fqwBK.BlockStartState {
    get stateType() {
        return $9TBHo.ATNStateType.PLUS_BLOCK_START;
    }
}
$ddcdb33017a842a9$var$__decorate([
    $esDFm.Override
], $ddcdb33017a842a9$var$PlusBlockStartState.prototype, "stateType", null);
module.exports.PlusBlockStartState = $ddcdb33017a842a9$var$PlusBlockStartState;

});

parcelRegister("6U6Db", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $506d1dd5405be440$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusLoopbackState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $axZym = parcelRequire("axZym");

var $esDFm = parcelRequire("esDFm");
/** Decision state for `A+` and `(A|B)+`.  It has two transitions:
 *  one to the loop back to start of the block and one to exit.
 */ class $506d1dd5405be440$var$PlusLoopbackState extends $axZym.DecisionState {
    get stateType() {
        return $9TBHo.ATNStateType.PLUS_LOOP_BACK;
    }
}
$506d1dd5405be440$var$__decorate([
    $esDFm.Override
], $506d1dd5405be440$var$PlusLoopbackState.prototype, "stateType", null);
module.exports.PlusLoopbackState = $506d1dd5405be440$var$PlusLoopbackState;

});

parcelRegister("l5c3t", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f5936a7914ccad6f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f5936a7914ccad6f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecedencePredicateTransition = void 0;

var $5sT1a = parcelRequire("5sT1a");

var $esDFm = parcelRequire("esDFm");

var $8DW9a = parcelRequire("8DW9a");
/**
 *
 * @author Sam Harwell
 */ let $f5936a7914ccad6f$var$PrecedencePredicateTransition = class PrecedencePredicateTransition extends $5sT1a.AbstractPredicateTransition {
    constructor(target, precedence){
        super(target);
        this.precedence = precedence;
    }
    get serializationType() {
        return 10 /* PRECEDENCE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $8DW9a.SemanticContext.PrecedencePredicate(this.precedence);
    }
    toString() {
        return this.precedence + " >= _p";
    }
};
$f5936a7914ccad6f$var$__decorate([
    $esDFm.Override
], $f5936a7914ccad6f$var$PrecedencePredicateTransition.prototype, "serializationType", null);
$f5936a7914ccad6f$var$__decorate([
    $esDFm.Override
], $f5936a7914ccad6f$var$PrecedencePredicateTransition.prototype, "isEpsilon", null);
$f5936a7914ccad6f$var$__decorate([
    $esDFm.Override
], $f5936a7914ccad6f$var$PrecedencePredicateTransition.prototype, "matches", null);
$f5936a7914ccad6f$var$__decorate([
    $esDFm.Override
], $f5936a7914ccad6f$var$PrecedencePredicateTransition.prototype, "toString", null);
$f5936a7914ccad6f$var$PrecedencePredicateTransition = $f5936a7914ccad6f$var$__decorate([
    $f5936a7914ccad6f$var$__param(0, $esDFm.NotNull)
], $f5936a7914ccad6f$var$PrecedencePredicateTransition);
module.exports.PrecedencePredicateTransition = $f5936a7914ccad6f$var$PrecedencePredicateTransition;

});

parcelRegister("evTXr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a90f5dfe3a55f17e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a90f5dfe3a55f17e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RangeTransition = void 0;

var $6og9T = parcelRequire("6og9T");

var $esDFm = parcelRequire("esDFm");

var $i2NOt = parcelRequire("i2NOt");
let $a90f5dfe3a55f17e$var$RangeTransition = class RangeTransition extends $i2NOt.Transition {
    constructor(target, from, to){
        super(target);
        this.from = from;
        this.to = to;
    }
    get serializationType() {
        return 2 /* RANGE */ ;
    }
    get label() {
        return $6og9T.IntervalSet.of(this.from, this.to);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= this.from && symbol <= this.to;
    }
    toString() {
        return "'" + String.fromCodePoint(this.from) + "'..'" + String.fromCodePoint(this.to) + "'";
    }
};
$a90f5dfe3a55f17e$var$__decorate([
    $esDFm.Override
], $a90f5dfe3a55f17e$var$RangeTransition.prototype, "serializationType", null);
$a90f5dfe3a55f17e$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $a90f5dfe3a55f17e$var$RangeTransition.prototype, "label", null);
$a90f5dfe3a55f17e$var$__decorate([
    $esDFm.Override
], $a90f5dfe3a55f17e$var$RangeTransition.prototype, "matches", null);
$a90f5dfe3a55f17e$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull
], $a90f5dfe3a55f17e$var$RangeTransition.prototype, "toString", null);
$a90f5dfe3a55f17e$var$RangeTransition = $a90f5dfe3a55f17e$var$__decorate([
    $a90f5dfe3a55f17e$var$__param(0, $esDFm.NotNull)
], $a90f5dfe3a55f17e$var$RangeTransition);
module.exports.RangeTransition = $a90f5dfe3a55f17e$var$RangeTransition;

});

parcelRegister("54SKF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3b27cc07a8f55191$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStartState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
class $3b27cc07a8f55191$var$RuleStartState extends $17Oz4.ATNState {
    constructor(){
        super(...arguments);
        this.isPrecedenceRule = false;
        this.leftFactored = false;
    }
    get stateType() {
        return $9TBHo.ATNStateType.RULE_START;
    }
}
$3b27cc07a8f55191$var$__decorate([
    $esDFm.Override
], $3b27cc07a8f55191$var$RuleStartState.prototype, "stateType", null);
module.exports.RuleStartState = $3b27cc07a8f55191$var$RuleStartState;

});

parcelRegister("aj3zV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $780e745635507ed4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarBlockStartState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $fqwBK = parcelRequire("fqwBK");

var $esDFm = parcelRequire("esDFm");
/** The block that begins a closure loop. */ class $780e745635507ed4$var$StarBlockStartState extends $fqwBK.BlockStartState {
    get stateType() {
        return $9TBHo.ATNStateType.STAR_BLOCK_START;
    }
}
$780e745635507ed4$var$__decorate([
    $esDFm.Override
], $780e745635507ed4$var$StarBlockStartState.prototype, "stateType", null);
module.exports.StarBlockStartState = $780e745635507ed4$var$StarBlockStartState;

});

parcelRegister("cLQen", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $94c263cb0220bf37$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopbackState = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $esDFm = parcelRequire("esDFm");
class $94c263cb0220bf37$var$StarLoopbackState extends $17Oz4.ATNState {
    get loopEntryState() {
        return this.transition(0).target;
    }
    get stateType() {
        return $9TBHo.ATNStateType.STAR_LOOP_BACK;
    }
}
$94c263cb0220bf37$var$__decorate([
    $esDFm.Override
], $94c263cb0220bf37$var$StarLoopbackState.prototype, "stateType", null);
module.exports.StarLoopbackState = $94c263cb0220bf37$var$StarLoopbackState;

});

parcelRegister("c0QqZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8bee2881bedcfb48$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokensStartState = void 0;

var $9TBHo = parcelRequire("9TBHo");

var $axZym = parcelRequire("axZym");

var $esDFm = parcelRequire("esDFm");
/** The Tokens rule start state linking to each lexer rule start state */ class $8bee2881bedcfb48$var$TokensStartState extends $axZym.DecisionState {
    get stateType() {
        return $9TBHo.ATNStateType.TOKEN_START;
    }
}
$8bee2881bedcfb48$var$__decorate([
    $esDFm.Override
], $8bee2881bedcfb48$var$TokensStartState.prototype, "stateType", null);
module.exports.TokensStartState = $8bee2881bedcfb48$var$TokensStartState;

});

parcelRegister("lkdkr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = void 0;

var $i99P2 = parcelRequire("i99P2");
class $f865ce06460c5d56$var$UUID {
    constructor(mostSigBits, moreSigBits, lessSigBits, leastSigBits){
        this.data = new Uint32Array(4);
        this.data[0] = mostSigBits;
        this.data[1] = moreSigBits;
        this.data[2] = lessSigBits;
        this.data[3] = leastSigBits;
    }
    static fromString(data) {
        if (!/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(data)) throw new Error("Incorrectly formatted UUID");
        let segments = data.split("-");
        let mostSigBits = parseInt(segments[0], 16);
        let moreSigBits = (parseInt(segments[1], 16) << 16 >>> 0) + parseInt(segments[2], 16);
        let lessSigBits = (parseInt(segments[3], 16) << 16 >>> 0) + parseInt(segments[4].substr(0, 4), 16);
        let leastSigBits = parseInt(segments[4].substr(-8), 16);
        return new $f865ce06460c5d56$var$UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    hashCode() {
        return $i99P2.MurmurHash.hashCode([
            this.data[0],
            this.data[1],
            this.data[2],
            this.data[3]
        ]);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $f865ce06460c5d56$var$UUID)) return false;
        return this.data[0] === obj.data[0] && this.data[1] === obj.data[1] && this.data[2] === obj.data[2] && this.data[3] === obj.data[3];
    }
    toString() {
        return ("00000000" + this.data[0].toString(16)).substr(-8) + "-" + ("0000" + (this.data[1] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[1].toString(16)).substr(-4) + "-" + ("0000" + (this.data[2] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[2].toString(16)).substr(-4) + ("00000000" + this.data[3].toString(16)).substr(-8);
    }
}
module.exports.UUID = $f865ce06460c5d56$var$UUID;

});


parcelRegister("bYNsJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8b8baa7f19328023$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8b8baa7f19328023$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseInfo = void 0;

var $esDFm = parcelRequire("esDFm");
/**
 * This class provides access to specific and aggregate statistics gathered
 * during profiling of a parser.
 *
 * @since 4.3
 */ let $8b8baa7f19328023$var$ParseInfo = class ParseInfo {
    constructor(atnSimulator){
        this.atnSimulator = atnSimulator;
    }
    /**
     * Gets an array of {@link DecisionInfo} instances containing the profiling
     * information gathered for each decision in the ATN.
     *
     * @returns An array of {@link DecisionInfo} instances, indexed by decision
     * number.
     */ getDecisionInfo() {
        return this.atnSimulator.getDecisionInfo();
    }
    /**
     * Gets the decision numbers for decisions that required one or more
     * full-context predictions during parsing. These are decisions for which
     * {@link DecisionInfo#LL_Fallback} is non-zero.
     *
     * @returns A list of decision numbers which required one or more
     * full-context predictions during parsing.
     */ getLLDecisions() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let LL = [];
        for(let i = 0; i < decisions.length; i++){
            let fallBack = decisions[i].LL_Fallback;
            if (fallBack > 0) LL.push(i);
        }
        return LL;
    }
    /**
     * Gets the total time spent during prediction across all decisions made
     * during parsing. This value is the sum of
     * {@link DecisionInfo#timeInPrediction} for all decisions.
     */ getTotalTimeInPrediction() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let t = 0;
        for (let decision of decisions)t += decision.timeInPrediction;
        return t;
    }
    /**
     * Gets the total number of SLL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#SLL_TotalLook} for all decisions.
     */ getTotalSLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of LL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#LL_TotalLook} for all decisions.
     */ getTotalLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL prediction
     * across all decisions made during parsing.
     */ getTotalSLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for LL prediction
     * across all decisions made during parsing.
     */ getTotalLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL and LL
     * prediction across all decisions made during parsing.
     *
     * This value is the sum of {@link #getTotalSLLATNLookaheadOps} and
     * {@link #getTotalLLATNLookaheadOps}.
     */ getTotalATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions){
            k += decision.SLL_ATNTransitions;
            k += decision.LL_ATNTransitions;
        }
        return k;
    }
    getDFASize(decision) {
        if (decision) {
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
            return decisionToDFA.states.size;
        } else {
            let n = 0;
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA;
            for(let i = 0; i < decisionToDFA.length; i++)n += this.getDFASize(i);
            return n;
        }
    }
};
$8b8baa7f19328023$var$__decorate([
    $esDFm.NotNull
], $8b8baa7f19328023$var$ParseInfo.prototype, "getDecisionInfo", null);
$8b8baa7f19328023$var$__decorate([
    $esDFm.NotNull
], $8b8baa7f19328023$var$ParseInfo.prototype, "getLLDecisions", null);
$8b8baa7f19328023$var$ParseInfo = $8b8baa7f19328023$var$__decorate([
    $8b8baa7f19328023$var$__param(0, $esDFm.NotNull)
], $8b8baa7f19328023$var$ParseInfo);
module.exports.ParseInfo = $8b8baa7f19328023$var$ParseInfo;

});

parcelRegister("ct3k0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $913ac514b76a37df$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyParserErrorListener = void 0;

var $adfkv = parcelRequire("adfkv");

var $esDFm = parcelRequire("esDFm");
/**
 * @author Sam Harwell
 */ class $913ac514b76a37df$var$ProxyParserErrorListener extends $adfkv.ProxyErrorListener {
    constructor(delegates){
        super(delegates);
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAmbiguity) listener.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        });
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        });
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState);
        });
    }
}
$913ac514b76a37df$var$__decorate([
    $esDFm.Override
], $913ac514b76a37df$var$ProxyParserErrorListener.prototype, "reportAmbiguity", null);
$913ac514b76a37df$var$__decorate([
    $esDFm.Override
], $913ac514b76a37df$var$ProxyParserErrorListener.prototype, "reportAttemptingFullContext", null);
$913ac514b76a37df$var$__decorate([
    $esDFm.Override
], $913ac514b76a37df$var$ProxyParserErrorListener.prototype, "reportContextSensitivity", null);
module.exports.ProxyParserErrorListener = $913ac514b76a37df$var$ProxyParserErrorListener;

});

parcelRegister("gXy9C", function(module, exports) {

let $c58ca6502429af48$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c58ca6502429af48$var$load("4zaLN").then(()=>parcelRequire('3i2SZ'));

});

parcelRegister("dRoiU", function(module, exports) {

let $a17313e371b31cbb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a17313e371b31cbb$var$load("erk9r").then(()=>parcelRequire('8rjeX'));

});




parcelRegister("5EAbA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseCancellationException = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:42.5447085-07:00
/**
 * This exception is thrown to cancel a parsing operation. This exception does
 * not extend {@link RecognitionException}, allowing it to bypass the standard
 * error recovery mechanisms. {@link BailErrorStrategy} throws this exception in
 * response to a parse error.
 *
 * @author Sam Harwell
 */ class $41dcc1f37efdf89f$var$ParseCancellationException extends Error {
    constructor(cause){
        super(cause.message);
        this.cause = cause;
        this.stack = cause.stack;
    }
    getCause() {
        return this.cause;
    }
}
module.exports.ParseCancellationException = $41dcc1f37efdf89f$var$ParseCancellationException;

});


parcelRegister("h5rBk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c708504646673e71$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c708504646673e71$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferedTokenStream = void 0;

var $gwEr2 = parcelRequire("gwEr2");

var $8Mk1Z = parcelRequire("8Mk1Z");

var $4Q2DM = parcelRequire("4Q2DM");

var $gTQRB = parcelRequire("gTQRB");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * This implementation of {@link TokenStream} loads tokens from a
 * {@link TokenSource} on-demand, and places the tokens in a buffer to provide
 * access to any previous token by index.
 *
 * This token stream ignores the value of {@link Token#getChannel}. If your
 * parser requires the token stream filter tokens to only those on a particular
 * channel, such as {@link Token#DEFAULT_CHANNEL} or
 * {@link Token#HIDDEN_CHANNEL}, use a filtering token stream such a
 * {@link CommonTokenStream}.
 */ let $c708504646673e71$var$BufferedTokenStream = class BufferedTokenStream {
    constructor(tokenSource){
        /**
         * A collection of all tokens fetched from the token source. The list is
         * considered a complete view of the input once {@link #fetchedEOF} is set
         * to `true`.
         */ this.tokens = [];
        /**
         * The index into {@link #tokens} of the current token (next token to
         * {@link #consume}). {@link #tokens}`[`{@link #p}`]` should be
         * {@link #LT LT(1)}.
         *
         * This field is set to -1 when the stream is first constructed or when
         * {@link #setTokenSource} is called, indicating that the first token has
         * not yet been fetched from the token source. For additional information,
         * see the documentation of {@link IntStream} for a description of
         * Initializing Methods.
         */ this.p = -1;
        /**
         * Indicates whether the {@link Token#EOF} token has been fetched from
         * {@link #tokenSource} and added to {@link #tokens}. This field improves
         * performance for the following cases:
         *
         * * {@link #consume}: The lookahead check in {@link #consume} to prevent
         *   consuming the EOF symbol is optimized by checking the values of
         *   {@link #fetchedEOF} and {@link #p} instead of calling {@link #LA}.
         * * {@link #fetch}: The check to prevent adding multiple EOF symbols into
         *   {@link #tokens} is trivial with this field.
         */ this.fetchedEOF = false;
        if (tokenSource == null) throw new Error("tokenSource cannot be null");
        this._tokenSource = tokenSource;
    }
    get tokenSource() {
        return this._tokenSource;
    }
    /** Reset this token stream by setting its token source. */ set tokenSource(tokenSource) {
        this._tokenSource = tokenSource;
        this.tokens.length = 0;
        this.p = -1;
        this.fetchedEOF = false;
    }
    get index() {
        return this.p;
    }
    mark() {
        return 0;
    }
    release(marker) {
    // no resources to release
    }
    seek(index) {
        this.lazyInit();
        this.p = this.adjustSeekIndex(index);
    }
    get size() {
        return this.tokens.length;
    }
    consume() {
        let skipEofCheck;
        if (this.p >= 0) {
            if (this.fetchedEOF) // the last token in tokens is EOF. skip check if p indexes any
            // fetched token except the last.
            skipEofCheck = this.p < this.tokens.length - 1;
            else // no EOF token in tokens. skip check if p indexes a fetched token.
            skipEofCheck = this.p < this.tokens.length;
        } else // not yet initialized
        skipEofCheck = false;
        if (!skipEofCheck && this.LA(1) === $2G93d.Token.EOF) throw new Error("cannot consume EOF");
        if (this.sync(this.p + 1)) this.p = this.adjustSeekIndex(this.p + 1);
    }
    /** Make sure index `i` in tokens has a token.
     *
     * @returns `true` if a token is located at index `i`, otherwise
     *    `false`.
     * @see #get(int i)
     */ sync(i) {
        $gwEr2(i >= 0);
        let n = i - this.tokens.length + 1; // how many more elements we need?
        //System.out.println("sync("+i+") needs "+n);
        if (n > 0) {
            let fetched = this.fetch(n);
            return fetched >= n;
        }
        return true;
    }
    /** Add `n` elements to buffer.
     *
     * @returns The actual number of elements added to the buffer.
     */ fetch(n) {
        if (this.fetchedEOF) return 0;
        for(let i = 0; i < n; i++){
            let t = this.tokenSource.nextToken();
            if (this.isWritableToken(t)) t.tokenIndex = this.tokens.length;
            this.tokens.push(t);
            if (t.type === $2G93d.Token.EOF) {
                this.fetchedEOF = true;
                return i + 1;
            }
        }
        return n;
    }
    get(i) {
        if (i < 0 || i >= this.tokens.length) throw new RangeError("token index " + i + " out of range 0.." + (this.tokens.length - 1));
        return this.tokens[i];
    }
    /** Get all tokens from start..stop inclusively. */ getRange(start, stop) {
        if (start < 0 || stop < 0) return [];
        this.lazyInit();
        let subset = new Array();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $2G93d.Token.EOF) break;
            subset.push(t);
        }
        return subset;
    }
    LA(i) {
        let token = this.LT(i);
        if (!token) return $2G93d.Token.INVALID_TYPE;
        return token.type;
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        return this.tokens[this.p - k];
    }
    LT(k) {
        let result = this.tryLT(k);
        if (result === undefined) throw new RangeError("requested lookback index out of range");
        return result;
    }
    tryLT(k) {
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p + k - 1;
        this.sync(i);
        if (i >= this.tokens.length) // return EOF token
        // EOF must be last token
        return this.tokens[this.tokens.length - 1];
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /**
     * Allowed derived classes to modify the behavior of operations which change
     * the current stream position by adjusting the target token index of a seek
     * operation. The default implementation simply returns `i`. If an
     * exception is thrown in this method, the current stream index should not be
     * changed.
     *
     * For example, {@link CommonTokenStream} overrides this method to ensure that
     * the seek target is always an on-channel token.
     *
     * @param i The target token index.
     * @returns The adjusted target token index.
     */ adjustSeekIndex(i) {
        return i;
    }
    lazyInit() {
        if (this.p === -1) this.setup();
    }
    setup() {
        this.sync(0);
        this.p = this.adjustSeekIndex(0);
    }
    /** Given a start and stop index, return a `List` of all tokens in
     *  the token type `BitSet`.  Return an empty array if no tokens were found.  This
     *  method looks at both on and off channel tokens.
     */ getTokens(start, stop, types) {
        this.lazyInit();
        if (start === undefined) {
            $gwEr2(stop === undefined && types === undefined);
            return this.tokens;
        } else if (stop === undefined) stop = this.tokens.length - 1;
        if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
        if (start > stop) return [];
        if (types === undefined) return this.tokens.slice(start, stop + 1);
        else if (typeof types === "number") types = new Set().add(types);
        let typesSet = types;
        // list = tokens[start:stop]:{T t, t.type in types}
        let filteredTokens = this.tokens.slice(start, stop + 1);
        filteredTokens = filteredTokens.filter((value)=>typesSet.has(value.type));
        return filteredTokens;
    }
    /**
     * Given a starting index, return the index of the next token on channel.
     * Return `i` if `tokens[i]` is on channel. Return the index of
     * the EOF token if there are no tokens on channel between `i` and
     * EOF.
     */ nextTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) return this.size - 1;
        let token = this.tokens[i];
        while(token.channel !== channel){
            if (token.type === $2G93d.Token.EOF) return i;
            i++;
            this.sync(i);
            token = this.tokens[i];
        }
        return i;
    }
    /**
     * Given a starting index, return the index of the previous token on
     * channel. Return `i` if `tokens[i]` is on channel. Return -1
     * if there are no tokens on channel between `i` and 0.
     *
     * If `i` specifies an index at or after the EOF token, the EOF token
     * index is returned. This is due to the fact that the EOF token is treated
     * as though it were on every channel.
     */ previousTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) // the EOF token is on every channel
        return this.size - 1;
        while(i >= 0){
            let token = this.tokens[i];
            if (token.type === $2G93d.Token.EOF || token.channel === channel) return i;
            i--;
        }
        return i;
    }
    /** Collect all tokens on specified channel to the right of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL} or
     *  EOF. If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToRight(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        let nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, $gTQRB.Lexer.DEFAULT_TOKEN_CHANNEL);
        let to;
        let from = tokenIndex + 1;
        // if none onchannel to right, nextOnChannel=-1 so set to = last token
        if (nextOnChannel === -1) to = this.size - 1;
        else to = nextOnChannel;
        return this.filterForChannel(from, to, channel);
    }
    /** Collect all tokens on specified channel to the left of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL}.
     *  If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToLeft(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        if (tokenIndex === 0) // obviously no tokens can appear before the first token
        return [];
        let prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, $gTQRB.Lexer.DEFAULT_TOKEN_CHANNEL);
        if (prevOnChannel === tokenIndex - 1) return [];
        // if none onchannel to left, prevOnChannel=-1 then from=0
        let from = prevOnChannel + 1;
        let to = tokenIndex - 1;
        return this.filterForChannel(from, to, channel);
    }
    filterForChannel(from, to, channel) {
        let hidden = new Array();
        for(let i = from; i <= to; i++){
            let t = this.tokens[i];
            if (channel === -1) {
                if (t.channel !== $gTQRB.Lexer.DEFAULT_TOKEN_CHANNEL) hidden.push(t);
            } else if (t.channel === channel) hidden.push(t);
        }
        return hidden;
    }
    get sourceName() {
        return this.tokenSource.sourceName;
    }
    getText(interval) {
        if (interval === undefined) interval = $4Q2DM.Interval.of(0, this.size - 1);
        else if (!(interval instanceof $4Q2DM.Interval)) // Note: the more obvious check for 'instanceof RuleContext' results in a circular dependency problem
        interval = interval.sourceInterval;
        let start = interval.a;
        let stop = interval.b;
        if (start < 0 || stop < 0) return "";
        this.fill();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        let buf = "";
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $2G93d.Token.EOF) break;
            buf += t.text;
        }
        return buf.toString();
    }
    getTextFromRange(start, stop) {
        if (this.isToken(start) && this.isToken(stop)) return this.getText($4Q2DM.Interval.of(start.tokenIndex, stop.tokenIndex));
        return "";
    }
    /** Get all tokens from lexer until EOF. */ fill() {
        this.lazyInit();
        const blockSize = 1000;
        while(true){
            let fetched = this.fetch(blockSize);
            if (fetched < blockSize) return;
        }
    }
    // TODO: Figure out a way to make this more flexible?
    isWritableToken(t) {
        return t instanceof $8Mk1Z.CommonToken;
    }
    // TODO: Figure out a way to make this more flexible?
    isToken(t) {
        return t instanceof $8Mk1Z.CommonToken;
    }
};
$c708504646673e71$var$__decorate([
    $esDFm.NotNull
], $c708504646673e71$var$BufferedTokenStream.prototype, "_tokenSource", void 0);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "tokenSource", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "index", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "mark", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "release", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "seek", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "size", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "consume", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "get", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "LA", null);
$c708504646673e71$var$__decorate([
    $esDFm.NotNull,
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "LT", null);
$c708504646673e71$var$__decorate([
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "sourceName", null);
$c708504646673e71$var$__decorate([
    $esDFm.NotNull,
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "getText", null);
$c708504646673e71$var$__decorate([
    $esDFm.NotNull,
    $esDFm.Override
], $c708504646673e71$var$BufferedTokenStream.prototype, "getTextFromRange", null);
$c708504646673e71$var$BufferedTokenStream = $c708504646673e71$var$__decorate([
    $c708504646673e71$var$__param(0, $esDFm.NotNull)
], $c708504646673e71$var$BufferedTokenStream);
module.exports.BufferedTokenStream = $c708504646673e71$var$BufferedTokenStream;

});

parcelRegister("cBsOS", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("d0TlQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CharStreams = void 0;

var $3wxwf = parcelRequire("3wxwf");

var $lXg5i = parcelRequire("lXg5i");

var $d4sFB = parcelRequire("d4sFB");
// const DEFAULT_BUFFER_SIZE: number = 4096;
/** This class represents the primary interface for creating {@link CharStream}s
 *  from a variety of sources as of 4.7.  The motivation was to support
 *  Unicode code points > U+FFFF.  {@link ANTLRInputStream} and
 *  {@link ANTLRFileStream} are now deprecated in favor of the streams created
 *  by this interface.
 *
 *  DEPRECATED: {@code new ANTLRFileStream("myinputfile")}
 *  NEW:        {@code CharStreams.fromFileName("myinputfile")}
 *
 *  WARNING: If you use both the deprecated and the new streams, you will see
 *  a nontrivial performance degradation. This speed hit is because the
 *  {@link Lexer}'s internal code goes from a monomorphic to megamorphic
 *  dynamic dispatch to get characters from the input stream. Java's
 *  on-the-fly compiler (JIT) is unable to perform the same optimizations
 *  so stick with either the old or the new streams, if performance is
 *  a primary concern. See the extreme debugging and spelunking
 *  needed to identify this issue in our timing rig:
 *
 *      https://github.com/antlr/antlr4/pull/1781
 *
 *  The ANTLR character streams still buffer all the input when you create
 *  the stream, as they have done for ~20 years. If you need unbuffered
 *  access, please note that it becomes challenging to create
 *  parse trees. The parse tree has to point to tokens which will either
 *  point into a stale location in an unbuffered stream or you have to copy
 *  the characters out of the buffer into the token. That defeats the purpose
 *  of unbuffered input. Per the ANTLR book, unbuffered streams are primarily
 *  useful for processing infinite streams *during the parse.*
 *
 *  The new streams also use 8-bit buffers when possible so this new
 *  interface supports character streams that use half as much memory
 *  as the old {@link ANTLRFileStream}, which assumed 16-bit characters.
 *
 *  A big shout out to Ben Hamilton (github bhamiltoncx) for his superhuman
 *  efforts across all targets to get true Unicode 3.1 support for U+10FFFF.
 *
 *  @since 4.7
 */ var $9796360e323bb25a$var$CharStreams;
(function(CharStreams) {
    // /**
    //  * Creates a {@link CharStream} given a path to a UTF-8
    //  * encoded file on disk.
    //  *
    //  * Reads the entire contents of the file into the result before returning.
    //  */
    // export function fromFile(file: File): CharStream;
    // export function fromFile(file: File, charset: Charset): CharStream;
    // export function fromFile(file: File, charset?: Charset): CharStream {
    // 	if (charset === undefined) {
    // 		charset = Charset.forName("UTF-8");
    // 	}
    function fromString(s, sourceName) {
        if (sourceName === undefined || sourceName.length === 0) sourceName = $d4sFB.IntStream.UNKNOWN_SOURCE_NAME;
        // Initial guess assumes no code points > U+FFFF: one code
        // point for each code unit in the string
        let codePointBufferBuilder = $3wxwf.CodePointBuffer.builder(s.length);
        // TODO: CharBuffer.wrap(String) rightfully returns a read-only buffer
        // which doesn't expose its array, so we make a copy.
        let cb = new Uint16Array(s.length);
        for(let i = 0; i < s.length; i++)cb[i] = s.charCodeAt(i);
        codePointBufferBuilder.append(cb);
        return $lXg5i.CodePointCharStream.fromBuffer(codePointBufferBuilder.build(), sourceName);
    }
    CharStreams.fromString = fromString;
// export function bufferFromChannel(
// 	channel: ReadableByteChannel,
// 	charset: Charset,
// 	bufferSize: number,
// 	decodingErrorAction: CodingErrorAction,
// 	inputSize: number): CodePointBuffer {
// 	try {
// 		let utf8BytesIn: Uint8Array = new Uint8Array(bufferSize);
// 		let utf16CodeUnitsOut: Uint16Array = new Uint16Array(bufferSize);
// 		if (inputSize === -1) {
// 			inputSize = bufferSize;
// 		} else if (inputSize > Integer.MAX_VALUE) {
// 			// ByteBuffer et al don't support long sizes
// 			throw new RangeError(`inputSize ${inputSize} larger than max ${Integer.MAX_VALUE}`);
// 		}
// 		let codePointBufferBuilder: CodePointBuffer.Builder = CodePointBuffer.builder(inputSize);
// 		let decoder: CharsetDecoder = charset
// 				.newDecoder()
// 				.onMalformedInput(decodingErrorAction)
// 				.onUnmappableCharacter(decodingErrorAction);
// 		let endOfInput: boolean = false;
// 		while (!endOfInput) {
// 			let bytesRead: number = channel.read(utf8BytesIn);
// 			endOfInput = (bytesRead === -1);
// 			utf8BytesIn.flip();
// 			let result: CoderResult = decoder.decode(
// 				utf8BytesIn,
// 				utf16CodeUnitsOut,
// 				endOfInput);
// 			if (result.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 				result.throwException();
// 			}
// 			utf16CodeUnitsOut.flip();
// 			codePointBufferBuilder.append(utf16CodeUnitsOut);
// 			utf8BytesIn.compact();
// 			utf16CodeUnitsOut.compact();
// 		}
// 		// Handle any bytes at the end of the file which need to
// 		// be represented as errors or substitution characters.
// 		let flushResult: CoderResult = decoder.flush(utf16CodeUnitsOut);
// 		if (flushResult.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 			flushResult.throwException();
// 		}
// 		utf16CodeUnitsOut.flip();
// 		codePointBufferBuilder.append(utf16CodeUnitsOut);
// 		return codePointBufferBuilder.build();
// 	}
// 	finally {
// 		channel.close();
// 	}
// }
})($9796360e323bb25a$var$CharStreams = module.exports.CharStreams || (module.exports.CharStreams = {}));

});
parcelRegister("3wxwf", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointBuffer = void 0;

var $gwEr2 = parcelRequire("gwEr2");

var $eIoqK = parcelRequire("eIoqK");
/**
 * Wrapper for `Uint8Array` / `Uint16Array` / `Int32Array`.
 */ class $290e5c7608340dee$var$CodePointBuffer {
    constructor(buffer, size){
        this.buffer = buffer;
        this._position = 0;
        this._size = size;
    }
    static withArray(buffer) {
        return new $290e5c7608340dee$var$CodePointBuffer(buffer, buffer.length);
    }
    get position() {
        return this._position;
    }
    set position(newPosition) {
        if (newPosition < 0 || newPosition > this._size) throw new RangeError();
        this._position = newPosition;
    }
    get remaining() {
        return this._size - this.position;
    }
    get(offset) {
        return this.buffer[offset];
    }
    array() {
        return this.buffer.slice(0, this._size);
    }
    static builder(initialBufferSize) {
        return new $290e5c7608340dee$var$CodePointBuffer.Builder(initialBufferSize);
    }
}
module.exports.CodePointBuffer = $290e5c7608340dee$var$CodePointBuffer;
(function(CodePointBuffer) {
    let Type;
    (function(Type) {
        Type[Type["BYTE"] = 0] = "BYTE";
        Type[Type["CHAR"] = 1] = "CHAR";
        Type[Type["INT"] = 2] = "INT";
    })(Type || (Type = {}));
    class Builder {
        constructor(initialBufferSize){
            this.type = 0 /* BYTE */ ;
            this.buffer = new Uint8Array(initialBufferSize);
            this.prevHighSurrogate = -1;
            this.position = 0;
        }
        build() {
            return new CodePointBuffer(this.buffer, this.position);
        }
        static roundUpToNextPowerOfTwo(i) {
            let nextPowerOfTwo = 32 - Math.clz32(i - 1);
            return Math.pow(2, nextPowerOfTwo);
        }
        ensureRemaining(remainingNeeded) {
            switch(this.type){
                case 0 /* BYTE */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint8Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 1 /* CHAR */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint16Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 2 /* INT */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Int32Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
            }
        }
        append(utf16In) {
            this.ensureRemaining(utf16In.length);
            this.appendArray(utf16In);
        }
        appendArray(utf16In) {
            switch(this.type){
                case 0 /* BYTE */ :
                    this.appendArrayByte(utf16In);
                    break;
                case 1 /* CHAR */ :
                    this.appendArrayChar(utf16In);
                    break;
                case 2 /* INT */ :
                    this.appendArrayInt(utf16In);
                    break;
            }
        }
        appendArrayByte(utf16In) {
            $gwEr2(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outByte = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (c <= 0xFF) outByte[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    if (!$eIoqK.isHighSurrogate(c)) {
                        this.byteToCharBuffer(utf16In.length);
                        this.appendArrayChar(utf16In);
                        return;
                    } else {
                        this.byteToIntBuffer(utf16In.length);
                        this.appendArrayInt(utf16In);
                        return;
                    }
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayChar(utf16In) {
            $gwEr2(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outChar = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (!$eIoqK.isHighSurrogate(c)) outChar[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    this.charToIntBuffer(utf16In.length);
                    this.appendArrayInt(utf16In);
                    return;
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayInt(utf16In) {
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outInt = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                inOffset++;
                if (this.prevHighSurrogate !== -1) {
                    if ($eIoqK.isLowSurrogate(c)) {
                        outInt[outOffset] = String.fromCharCode(this.prevHighSurrogate, c).codePointAt(0);
                        outOffset++;
                        this.prevHighSurrogate = -1;
                    } else {
                        // Dangling high surrogate
                        outInt[outOffset] = this.prevHighSurrogate;
                        outOffset++;
                        if ($eIoqK.isHighSurrogate(c)) this.prevHighSurrogate = c;
                        else {
                            outInt[outOffset] = c;
                            outOffset++;
                            this.prevHighSurrogate = -1;
                        }
                    }
                } else if ($eIoqK.isHighSurrogate(c)) this.prevHighSurrogate = c;
                else {
                    outInt[outOffset] = c;
                    outOffset++;
                }
            }
            if (this.prevHighSurrogate !== -1) {
                // Dangling high surrogate
                outInt[outOffset] = this.prevHighSurrogate;
                outOffset++;
            }
            this.position = outOffset;
        }
        byteToCharBuffer(toAppend) {
            // CharBuffers hold twice as much per unit as ByteBuffers, so start with half the capacity.
            let newBuffer = new Uint16Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 1 /* CHAR */ ;
            this.buffer = newBuffer;
        }
        byteToIntBuffer(toAppend) {
            // IntBuffers hold four times as much per unit as ByteBuffers, so start with one quarter the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 2));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
        charToIntBuffer(toAppend) {
            // IntBuffers hold two times as much per unit as ByteBuffers, so start with one half the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
    }
    CodePointBuffer.Builder = Builder;
})($290e5c7608340dee$var$CodePointBuffer = module.exports.CodePointBuffer || (module.exports.CodePointBuffer = {}));

});
parcelRegister("eIoqK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSupplementaryCodePoint = module.exports.isLowSurrogate = module.exports.isHighSurrogate = void 0;
function $ab682023343875fe$var$isHighSurrogate(ch) {
    return ch >= 0xD800 && ch <= 0xDBFF;
}
module.exports.isHighSurrogate = $ab682023343875fe$var$isHighSurrogate;
function $ab682023343875fe$var$isLowSurrogate(ch) {
    return ch >= 0xDC00 && ch <= 0xDFFF;
}
module.exports.isLowSurrogate = $ab682023343875fe$var$isLowSurrogate;
function $ab682023343875fe$var$isSupplementaryCodePoint(ch) {
    return ch >= 0x10000;
}
module.exports.isSupplementaryCodePoint = $ab682023343875fe$var$isSupplementaryCodePoint;

});


parcelRegister("lXg5i", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ffbb95ad08ca6a0e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointCharStream = void 0;

var $gwEr2 = parcelRequire("gwEr2");

var $d4sFB = parcelRequire("d4sFB");

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");
/**
 * Alternative to {@link ANTLRInputStream} which treats the input
 * as a series of Unicode code points, instead of a series of UTF-16
 * code units.
 *
 * Use this if you need to parse input which potentially contains
 * Unicode values > U+FFFF.
 */ class $ffbb95ad08ca6a0e$var$CodePointCharStream {
    // Use the factory method {@link #fromBuffer(CodePointBuffer)} to
    // construct instances of this type.
    constructor(array, position, remaining, name){
        // TODO
        $gwEr2(position === 0);
        this._array = array;
        this._size = remaining;
        this._name = name;
        this._position = 0;
    }
    get internalStorage() {
        return this._array;
    }
    static fromBuffer(codePointBuffer, name) {
        if (name === undefined || name.length === 0) name = $d4sFB.IntStream.UNKNOWN_SOURCE_NAME;
        // Java lacks generics on primitive types.
        //
        // To avoid lots of calls to virtual methods in the
        // very hot codepath of LA() below, we construct one
        // of three concrete subclasses.
        //
        // The concrete subclasses directly access the code
        // points stored in the underlying array (byte[],
        // char[], or int[]), so we can avoid lots of virtual
        // method calls to ByteBuffer.get(offset).
        return new $ffbb95ad08ca6a0e$var$CodePointCharStream(codePointBuffer.array(), codePointBuffer.position, codePointBuffer.remaining, name);
    }
    consume() {
        if (this._size - this._position === 0) {
            $gwEr2(this.LA(1) === $d4sFB.IntStream.EOF);
            throw new RangeError("cannot consume EOF");
        }
        this._position++;
    }
    get index() {
        return this._position;
    }
    get size() {
        return this._size;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    seek(index) {
        this._position = index;
    }
    get sourceName() {
        return this._name;
    }
    toString() {
        return this.getText($4Q2DM.Interval.of(0, this.size - 1));
    }
    LA(i) {
        let offset;
        switch(Math.sign(i)){
            case -1:
                offset = this.index + i;
                if (offset < 0) return $d4sFB.IntStream.EOF;
                return this._array[offset];
            case 0:
                // Undefined
                return 0;
            case 1:
                offset = this.index + i - 1;
                if (offset >= this.size) return $d4sFB.IntStream.EOF;
                return this._array[offset];
        }
        throw new RangeError("Not reached");
    }
    /** Return the UTF-16 encoded string for the given interval */ getText(interval) {
        const startIdx = Math.min(interval.a, this.size);
        const len = Math.min(interval.b - interval.a + 1, this.size - startIdx);
        if (this._array instanceof Int32Array) return String.fromCodePoint(...Array.from(this._array.subarray(startIdx, startIdx + len)));
        else return String.fromCharCode(...Array.from(this._array.subarray(startIdx, startIdx + len)));
    }
}
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "consume", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "index", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "size", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "mark", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "release", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "seek", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "sourceName", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "toString", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "LA", null);
$ffbb95ad08ca6a0e$var$__decorate([
    $esDFm.Override
], $ffbb95ad08ca6a0e$var$CodePointCharStream.prototype, "getText", null);
module.exports.CodePointCharStream = $ffbb95ad08ca6a0e$var$CodePointCharStream;

});


parcelRegister("1y11S", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1209c3d1bc2cac22$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1209c3d1bc2cac22$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenStream = void 0;

var $h5rBk = parcelRequire("h5rBk");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * This class extends {@link BufferedTokenStream} with functionality to filter
 * token streams to tokens on a particular channel (tokens where
 * {@link Token#getChannel} returns a particular value).
 *
 * This token stream provides access to all tokens by index or when calling
 * methods like {@link #getText}. The channel filtering is only used for code
 * accessing tokens via the lookahead methods {@link #LA}, {@link #LT}, and
 * {@link #LB}.
 *
 * By default, tokens are placed on the default channel
 * ({@link Token#DEFAULT_CHANNEL}), but may be reassigned by using the
 * `->channel(HIDDEN)` lexer command, or by using an embedded action to
 * call {@link Lexer#setChannel}.
 *
 * Note: lexer rules which use the `->skip` lexer command or call
 * {@link Lexer#skip} do not produce tokens at all, so input text matched by
 * such a rule will not be available as part of the token stream, regardless of
 * channel.
 */ let $1209c3d1bc2cac22$var$CommonTokenStream = class CommonTokenStream extends $h5rBk.BufferedTokenStream {
    /**
     * Constructs a new {@link CommonTokenStream} using the specified token
     * source and filtering tokens to the specified channel. Only tokens whose
     * {@link Token#getChannel} matches `channel` or have the
     * `Token.type` equal to {@link Token#EOF} will be returned by the
     * token stream lookahead methods.
     *
     * @param tokenSource The token source.
     * @param channel The channel to use for filtering tokens.
     */ constructor(tokenSource, channel = $2G93d.Token.DEFAULT_CHANNEL){
        super(tokenSource);
        this.channel = channel;
    }
    adjustSeekIndex(i) {
        return this.nextTokenOnChannel(i, this.channel);
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        let i = this.p;
        let n = 1;
        // find k good tokens looking backwards
        while(n <= k && i > 0){
            // skip off-channel tokens
            i = this.previousTokenOnChannel(i - 1, this.channel);
            n++;
        }
        if (i < 0) return undefined;
        return this.tokens[i];
    }
    tryLT(k) {
        //System.out.println("enter LT("+k+")");
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p;
        let n = 1; // we know tokens[p] is a good one
        // find k good tokens
        while(n < k){
            // skip off-channel tokens, but make sure to not look past EOF
            if (this.sync(i + 1)) i = this.nextTokenOnChannel(i + 1, this.channel);
            n++;
        }
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /** Count EOF just once. */ getNumberOfOnChannelTokens() {
        let n = 0;
        this.fill();
        for (let t of this.tokens){
            if (t.channel === this.channel) n++;
            if (t.type === $2G93d.Token.EOF) break;
        }
        return n;
    }
};
$1209c3d1bc2cac22$var$__decorate([
    $esDFm.Override
], $1209c3d1bc2cac22$var$CommonTokenStream.prototype, "adjustSeekIndex", null);
$1209c3d1bc2cac22$var$__decorate([
    $esDFm.Override
], $1209c3d1bc2cac22$var$CommonTokenStream.prototype, "tryLB", null);
$1209c3d1bc2cac22$var$__decorate([
    $esDFm.Override
], $1209c3d1bc2cac22$var$CommonTokenStream.prototype, "tryLT", null);
$1209c3d1bc2cac22$var$CommonTokenStream = $1209c3d1bc2cac22$var$__decorate([
    $1209c3d1bc2cac22$var$__param(0, $esDFm.NotNull)
], $1209c3d1bc2cac22$var$CommonTokenStream);
module.exports.CommonTokenStream = $1209c3d1bc2cac22$var$CommonTokenStream;

});

parcelRegister("6gsRs", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dependents = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.1349829-07:00
/**
 *
 * @author Sam Harwell
 */ var $48fa9fed976e4bf6$var$Dependents;
(function(Dependents) {
    /**
     * The element is dependent upon the specified rule.
     */ Dependents[Dependents["SELF"] = 0] = "SELF";
    /**
     * The element is dependent upon the set of the specified rule's parents
     * (rules which directly reference it).
     */ Dependents[Dependents["PARENTS"] = 1] = "PARENTS";
    /**
     * The element is dependent upon the set of the specified rule's children
     * (rules which it directly references).
     */ Dependents[Dependents["CHILDREN"] = 2] = "CHILDREN";
    /**
     * The element is dependent upon the set of the specified rule's ancestors
     * (the transitive closure of `PARENTS` rules).
     */ Dependents[Dependents["ANCESTORS"] = 3] = "ANCESTORS";
    /**
     * The element is dependent upon the set of the specified rule's descendants
     * (the transitive closure of `CHILDREN` rules).
     */ Dependents[Dependents["DESCENDANTS"] = 4] = "DESCENDANTS";
    /**
     * The element is dependent upon the set of the specified rule's siblings
     * (the union of `CHILDREN` of its `PARENTS`).
     */ Dependents[Dependents["SIBLINGS"] = 5] = "SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear before a reference to the rule).
     */ Dependents[Dependents["PRECEEDING_SIBLINGS"] = 6] = "PRECEEDING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's following
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear after a reference to the rule).
     */ Dependents[Dependents["FOLLOWING_SIBLINGS"] = 7] = "FOLLOWING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * elements (rules which might end before the start of the specified rule
     * while parsing). This is calculated by taking the
     * `PRECEEDING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["PRECEEDING"] = 8] = "PRECEEDING";
    /**
     * The element is dependent upon the set of the specified rule's following
     * elements (rules which might start after the end of the specified rule
     * while parsing). This is calculated by taking the
     * `FOLLOWING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["FOLLOWING"] = 9] = "FOLLOWING";
})($48fa9fed976e4bf6$var$Dependents = module.exports.Dependents || (module.exports.Dependents = {}));

});

parcelRegister("4Allj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $356b147161a3df5a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $356b147161a3df5a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiagnosticErrorListener = void 0;

var $lVdCV = parcelRequire("lVdCV");

var $esDFm = parcelRequire("esDFm");

var $4Q2DM = parcelRequire("4Q2DM");
/**
 * This implementation of {@link ANTLRErrorListener} can be used to identify
 * certain potential correctness and performance problems in grammars. "Reports"
 * are made by calling {@link Parser#notifyErrorListeners} with the appropriate
 * message.
 *
 * * **Ambiguities**: These are cases where more than one path through the
 *   grammar can match the input.
 * * **Weak context sensitivity**: These are cases where full-context
 *   prediction resolved an SLL conflict to a unique alternative which equaled the
 *   minimum alternative of the SLL conflict.
 * * **Strong (forced) context sensitivity**: These are cases where the
 *   full-context prediction resolved an SLL conflict to a unique alternative,
 *   *and* the minimum alternative of the SLL conflict was found to not be
 *   a truly viable alternative. Two-stage parsing cannot be used for inputs where
 *   this situation occurs.
 *
 * @author Sam Harwell
 */ class $356b147161a3df5a$var$DiagnosticErrorListener {
    /**
     * Initializes a new instance of {@link DiagnosticErrorListener}, specifying
     * whether all ambiguities or only exact ambiguities are reported.
     *
     * @param exactOnly `true` to report only exact ambiguities, otherwise
     * `false` to report all ambiguities.  Defaults to true.
     */ constructor(exactOnly = true){
        this.exactOnly = exactOnly;
        this.exactOnly = exactOnly;
    }
    syntaxError(/*@NotNull*/ recognizer, offendingSymbol, line, charPositionInLine, /*@NotNull*/ msg, e) {
    // intentionally empty
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (this.exactOnly && !exact) return;
        let decision = this.getDecisionDescription(recognizer, dfa);
        let conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
        let text = recognizer.inputStream.getText($4Q2DM.Interval.of(startIndex, stopIndex));
        let message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        let format = "reportAttemptingFullContext d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($4Q2DM.Interval.of(startIndex, stopIndex));
        let message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        let format = "reportContextSensitivity d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($4Q2DM.Interval.of(startIndex, stopIndex));
        let message = `reportContextSensitivity d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    getDecisionDescription(recognizer, dfa) {
        let decision = dfa.decision;
        let ruleIndex = dfa.atnStartState.ruleIndex;
        let ruleNames = recognizer.ruleNames;
        if (ruleIndex < 0 || ruleIndex >= ruleNames.length) return decision.toString();
        let ruleName = ruleNames[ruleIndex];
        if (!ruleName) return decision.toString();
        return `${decision} (${ruleName})`;
    }
    /**
     * Computes the set of conflicting or ambiguous alternatives from a
     * configuration set, if that information was not already provided by the
     * parser.
     *
     * @param reportedAlts The set of conflicting or ambiguous alternatives, as
     * reported by the parser.
     * @param configs The conflicting or ambiguous configuration set.
     * @returns Returns `reportedAlts` if it is not `undefined`, otherwise
     * returns the set of alternatives represented in `configs`.
     */ getConflictingAlts(reportedAlts, configs) {
        if (reportedAlts != null) return reportedAlts;
        let result = new $lVdCV.BitSet();
        for (let config of configs)result.set(config.alt);
        return result;
    }
}
$356b147161a3df5a$var$__decorate([
    $esDFm.Override
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "syntaxError", null);
$356b147161a3df5a$var$__decorate([
    $esDFm.Override,
    $356b147161a3df5a$var$__param(0, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(1, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(6, $esDFm.NotNull)
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "reportAmbiguity", null);
$356b147161a3df5a$var$__decorate([
    $esDFm.Override,
    $356b147161a3df5a$var$__param(0, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(1, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(5, $esDFm.NotNull)
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "reportAttemptingFullContext", null);
$356b147161a3df5a$var$__decorate([
    $esDFm.Override,
    $356b147161a3df5a$var$__param(0, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(1, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(5, $esDFm.NotNull)
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "reportContextSensitivity", null);
$356b147161a3df5a$var$__decorate([
    $356b147161a3df5a$var$__param(0, $esDFm.NotNull),
    $356b147161a3df5a$var$__param(1, $esDFm.NotNull)
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "getDecisionDescription", null);
$356b147161a3df5a$var$__decorate([
    $esDFm.NotNull,
    $356b147161a3df5a$var$__param(1, $esDFm.NotNull)
], $356b147161a3df5a$var$DiagnosticErrorListener.prototype, "getConflictingAlts", null);
module.exports.DiagnosticErrorListener = $356b147161a3df5a$var$DiagnosticErrorListener;

});

parcelRegister("2iaul", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1ab565ff78924252$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InterpreterRuleContext = void 0;

var $esDFm = parcelRequire("esDFm");

var $5NlfZ = parcelRequire("5NlfZ");
/**
 * This class extends {@link ParserRuleContext} by allowing the value of
 * {@link #getRuleIndex} to be explicitly set for the context.
 *
 * {@link ParserRuleContext} does not include field storage for the rule index
 * since the context classes created by the code generator override the
 * {@link #getRuleIndex} method to return the correct value for that context.
 * Since the parser interpreter does not use the context classes generated for a
 * parser, this class (with slightly more memory overhead per node) is used to
 * provide equivalent functionality.
 */ class $1ab565ff78924252$var$InterpreterRuleContext extends $5NlfZ.ParserRuleContext {
    constructor(ruleIndex, parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._ruleIndex = ruleIndex;
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
}
$1ab565ff78924252$var$__decorate([
    $esDFm.Override
], $1ab565ff78924252$var$InterpreterRuleContext.prototype, "ruleIndex", null);
module.exports.InterpreterRuleContext = $1ab565ff78924252$var$InterpreterRuleContext;

});

parcelRegister("8I7Eq", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $65785e22623bca95$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $65785e22623bca95$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerInterpreter = void 0;

var $gTQRB = parcelRequire("gTQRB");

var $kkkg9 = parcelRequire("kkkg9");

var $esDFm = parcelRequire("esDFm");

var $esDFm = parcelRequire("esDFm");
let $65785e22623bca95$var$LexerInterpreter = class LexerInterpreter extends $gTQRB.Lexer {
    constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input){
        super(input);
        if (atn.grammarType !== 0 /* LEXER */ ) throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
        this._grammarFileName = grammarFileName;
        this._atn = atn;
        this._ruleNames = ruleNames.slice(0);
        this._channelNames = channelNames.slice(0);
        this._modeNames = modeNames.slice(0);
        this._vocabulary = vocabulary;
        this._interp = new $kkkg9.LexerATNSimulator(atn, this);
    }
    get atn() {
        return this._atn;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get channelNames() {
        return this._channelNames;
    }
    get modeNames() {
        return this._modeNames;
    }
    get vocabulary() {
        return this._vocabulary;
    }
};
$65785e22623bca95$var$__decorate([
    $esDFm.NotNull
], $65785e22623bca95$var$LexerInterpreter.prototype, "_vocabulary", void 0);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "atn", null);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "grammarFileName", null);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "ruleNames", null);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "channelNames", null);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "modeNames", null);
$65785e22623bca95$var$__decorate([
    $esDFm.Override
], $65785e22623bca95$var$LexerInterpreter.prototype, "vocabulary", null);
$65785e22623bca95$var$LexerInterpreter = $65785e22623bca95$var$__decorate([
    $65785e22623bca95$var$__param(1, $esDFm.NotNull)
], $65785e22623bca95$var$LexerInterpreter);
module.exports.LexerInterpreter = $65785e22623bca95$var$LexerInterpreter;

});

parcelRegister("8tp3s", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $62b4778561d490bb$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $62b4778561d490bb$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ListTokenSource = void 0;

var $arOt9 = parcelRequire("arOt9");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * Provides an implementation of {@link TokenSource} as a wrapper around a list
 * of {@link Token} objects.
 *
 * If the final token in the list is an {@link Token#EOF} token, it will be used
 * as the EOF token for every call to {@link #nextToken} after the end of the
 * list is reached. Otherwise, an EOF token will be created.
 */ let $62b4778561d490bb$var$ListTokenSource = class ListTokenSource {
    /**
     * Constructs a new {@link ListTokenSource} instance from the specified
     * collection of {@link Token} objects and source name.
     *
     * @param tokens The collection of {@link Token} objects to provide as a
     * {@link TokenSource}.
     * @param sourceName The name of the {@link TokenSource}. If this value is
     * `undefined`, {@link #getSourceName} will attempt to infer the name from
     * the next {@link Token} (or the previous token if the end of the input has
     * been reached).
     *
     * @exception NullPointerException if `tokens` is `undefined`
     */ constructor(tokens, sourceName){
        /**
         * The index into {@link #tokens} of token to return by the next call to
         * {@link #nextToken}. The end of the input is indicated by this value
         * being greater than or equal to the number of items in {@link #tokens}.
         */ this.i = 0;
        /**
         * This is the backing field for {@link #getTokenFactory} and
         * {@link setTokenFactory}.
         */ this._factory = $arOt9.CommonTokenFactory.DEFAULT;
        if (tokens == null) throw new Error("tokens cannot be null");
        this.tokens = tokens;
        this._sourceName = sourceName;
    }
    /**
     * {@inheritDoc}
     */ get charPositionInLine() {
        if (this.i < this.tokens.length) return this.tokens[this.i].charPositionInLine;
        else if (this.eofToken != null) return this.eofToken.charPositionInLine;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let tokenText = lastToken.text;
            if (tokenText != null) {
                let lastNewLine = tokenText.lastIndexOf("\n");
                if (lastNewLine >= 0) return tokenText.length - lastNewLine - 1;
            }
            return lastToken.charPositionInLine + lastToken.stopIndex - lastToken.startIndex + 1;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 0;
    }
    /**
     * {@inheritDoc}
     */ nextToken() {
        if (this.i >= this.tokens.length) {
            if (this.eofToken == null) {
                let start = -1;
                if (this.tokens.length > 0) {
                    let previousStop = this.tokens[this.tokens.length - 1].stopIndex;
                    if (previousStop !== -1) start = previousStop + 1;
                }
                let stop = Math.max(-1, start - 1);
                this.eofToken = this._factory.create({
                    source: this,
                    stream: this.inputStream
                }, $2G93d.Token.EOF, "EOF", $2G93d.Token.DEFAULT_CHANNEL, start, stop, this.line, this.charPositionInLine);
            }
            return this.eofToken;
        }
        let t = this.tokens[this.i];
        if (this.i === this.tokens.length - 1 && t.type === $2G93d.Token.EOF) this.eofToken = t;
        this.i++;
        return t;
    }
    /**
     * {@inheritDoc}
     */ get line() {
        if (this.i < this.tokens.length) return this.tokens[this.i].line;
        else if (this.eofToken != null) return this.eofToken.line;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let line = lastToken.line;
            let tokenText = lastToken.text;
            if (tokenText != null) {
                for(let i = 0; i < tokenText.length; i++)if (tokenText.charAt(i) === "\n") line++;
            }
            // if no text is available, assume the token did not contain any newline characters.
            return line;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 1;
    }
    /**
     * {@inheritDoc}
     */ get inputStream() {
        if (this.i < this.tokens.length) return this.tokens[this.i].inputStream;
        else if (this.eofToken != null) return this.eofToken.inputStream;
        else if (this.tokens.length > 0) return this.tokens[this.tokens.length - 1].inputStream;
        // no input stream information is available
        return undefined;
    }
    /**
     * {@inheritDoc}
     */ get sourceName() {
        if (this._sourceName) return this._sourceName;
        let inputStream = this.inputStream;
        if (inputStream != null) return inputStream.sourceName;
        return "List";
    }
    /**
     * {@inheritDoc}
     */ // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    /**
     * {@inheritDoc}
     */ get tokenFactory() {
        return this._factory;
    }
};
$62b4778561d490bb$var$__decorate([
    $esDFm.Override
], $62b4778561d490bb$var$ListTokenSource.prototype, "charPositionInLine", null);
$62b4778561d490bb$var$__decorate([
    $esDFm.Override
], $62b4778561d490bb$var$ListTokenSource.prototype, "nextToken", null);
$62b4778561d490bb$var$__decorate([
    $esDFm.Override
], $62b4778561d490bb$var$ListTokenSource.prototype, "line", null);
$62b4778561d490bb$var$__decorate([
    $esDFm.Override
], $62b4778561d490bb$var$ListTokenSource.prototype, "inputStream", null);
$62b4778561d490bb$var$__decorate([
    $esDFm.Override
], $62b4778561d490bb$var$ListTokenSource.prototype, "sourceName", null);
$62b4778561d490bb$var$__decorate([
    $esDFm.Override,
    $esDFm.NotNull,
    $62b4778561d490bb$var$__param(0, $esDFm.NotNull)
], $62b4778561d490bb$var$ListTokenSource.prototype, "tokenFactory", null);
$62b4778561d490bb$var$ListTokenSource = $62b4778561d490bb$var$__decorate([
    $62b4778561d490bb$var$__param(0, $esDFm.NotNull)
], $62b4778561d490bb$var$ListTokenSource);
module.exports.ListTokenSource = $62b4778561d490bb$var$ListTokenSource;

});

parcelRegister("bvca3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("djIaX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9b1f511704f60b2d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9b1f511704f60b2d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserInterpreter = void 0;

var $17Oz4 = parcelRequire("17Oz4");

var $9TBHo = parcelRequire("9TBHo");

var $lVdCV = parcelRequire("lVdCV");

var $d7mTm = parcelRequire("d7mTm");

var $6iuj6 = parcelRequire("6iuj6");

var $2iaul = parcelRequire("2iaul");

var $3fYXW = parcelRequire("3fYXW");

var $esDFm = parcelRequire("esDFm");

var $esDFm = parcelRequire("esDFm");

var $dDGsq = parcelRequire("dDGsq");

var $l4uOS = parcelRequire("l4uOS");

var $lWPhg = parcelRequire("lWPhg");

var $izkyd = parcelRequire("izkyd");

var $2G93d = parcelRequire("2G93d");
/** A parser simulator that mimics what ANTLR's generated
 *  parser code does. A ParserATNSimulator is used to make
 *  predictions via adaptivePredict but this class moves a pointer through the
 *  ATN to simulate parsing. ParserATNSimulator just
 *  makes us efficient rather than having to backtrack, for example.
 *
 *  This properly creates parse trees even for left recursive rules.
 *
 *  We rely on the left recursive rule invocation and special predicate
 *  transitions to make left recursive rules work.
 *
 *  See TestParserInterpreter for examples.
 */ let $9b1f511704f60b2d$var$ParserInterpreter = class ParserInterpreter extends $dDGsq.Parser {
    constructor(grammarFileName, vocabulary, ruleNames, atn, input){
        super(grammarFileName instanceof ParserInterpreter ? grammarFileName.inputStream : input);
        /** This stack corresponds to the _parentctx, _parentState pair of locals
         *  that would exist on call stack frames with a recursive descent parser;
         *  in the generated function for a left-recursive rule you'd see:
         *
         *  private EContext e(int _p) {
         *      ParserRuleContext _parentctx = _ctx;    // Pair.a
         *      int _parentState = state;          // Pair.b
         *      ...
         *  }
         *
         *  Those values are used to create new recursive rule invocation contexts
         *  associated with left operand of an alt like "expr '*' expr".
         */ this._parentContextStack = [];
        /** We need a map from (decision,inputIndex)->forced alt for computing ambiguous
         *  parse trees. For now, we allow exactly one override.
         */ this.overrideDecision = -1;
        this.overrideDecisionInputIndex = -1;
        this.overrideDecisionAlt = -1;
        this.overrideDecisionReached = false; // latch and only override once; error might trigger infinite loop
        /** What is the current context when we override a decisions?  This tells
         *  us what the root of the parse tree is when using override
         *  for an ambiguity/lookahead check.
         */ this._overrideDecisionRoot = undefined;
        if (grammarFileName instanceof ParserInterpreter) {
            let old = grammarFileName;
            this._grammarFileName = old._grammarFileName;
            this._atn = old._atn;
            this.pushRecursionContextStates = old.pushRecursionContextStates;
            this._ruleNames = old._ruleNames;
            this._vocabulary = old._vocabulary;
            this.interpreter = new $l4uOS.ParserATNSimulator(this._atn, this);
        } else {
            // The second constructor requires non-null arguments
            vocabulary;
            ruleNames;
            atn;
            this._grammarFileName = grammarFileName;
            this._atn = atn;
            this._ruleNames = ruleNames.slice(0);
            this._vocabulary = vocabulary;
            // identify the ATN states where pushNewRecursionContext() must be called
            this.pushRecursionContextStates = new $lVdCV.BitSet(atn.states.length);
            for (let state of atn.states){
                if (!(state instanceof $izkyd.StarLoopEntryState)) continue;
                if (state.precedenceRuleDecision) this.pushRecursionContextStates.set(state.stateNumber);
            }
            // get atn simulator that knows how to do predictions
            this.interpreter = new $l4uOS.ParserATNSimulator(atn, this);
        }
    }
    reset(resetInput) {
        if (resetInput === undefined) super.reset();
        else super.reset(resetInput);
        this.overrideDecisionReached = false;
        this._overrideDecisionRoot = undefined;
    }
    get atn() {
        return this._atn;
    }
    get vocabulary() {
        return this._vocabulary;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    /** Begin parsing at startRuleIndex */ parse(startRuleIndex) {
        let startRuleStartState = this._atn.ruleToStartState[startRuleIndex];
        this._rootContext = this.createInterpreterRuleContext(undefined, $17Oz4.ATNState.INVALID_STATE_NUMBER, startRuleIndex);
        if (startRuleStartState.isPrecedenceRule) this.enterRecursionRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
        else this.enterRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex);
        while(true){
            let p = this.atnState;
            switch(p.stateType){
                case $9TBHo.ATNStateType.RULE_STOP:
                    // pop; return from rule
                    if (this._ctx.isEmpty) {
                        if (startRuleStartState.isPrecedenceRule) {
                            let result = this._ctx;
                            let parentContext = this._parentContextStack.pop();
                            this.unrollRecursionContexts(parentContext[0]);
                            return result;
                        } else {
                            this.exitRule();
                            return this._rootContext;
                        }
                    }
                    this.visitRuleStopState(p);
                    break;
                default:
                    try {
                        this.visitState(p);
                    } catch (e) {
                        if (e instanceof $lWPhg.RecognitionException) {
                            this.state = this._atn.ruleToStopState[p.ruleIndex].stateNumber;
                            this.context.exception = e;
                            this.errorHandler.reportError(this, e);
                            this.recover(e);
                        } else throw e;
                    }
                    break;
            }
        }
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this._parentContextStack.push([
            this._ctx,
            localctx.invokingState
        ]);
        super.enterRecursionRule(localctx, state, ruleIndex, precedence);
    }
    get atnState() {
        return this._atn.states[this.state];
    }
    visitState(p) {
        let predictedAlt = 1;
        if (p.numberOfTransitions > 1) predictedAlt = this.visitDecisionState(p);
        let transition = p.transition(predictedAlt - 1);
        switch(transition.serializationType){
            case 1 /* EPSILON */ :
                if (this.pushRecursionContextStates.get(p.stateNumber) && !(transition.target instanceof $3fYXW.LoopEndState)) {
                    // We are at the start of a left recursive rule's (...)* loop
                    // and we're not taking the exit branch of loop.
                    let parentContext = this._parentContextStack[this._parentContextStack.length - 1];
                    let localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this._ctx.ruleIndex);
                    this.pushNewRecursionContext(localctx, this._atn.ruleToStartState[p.ruleIndex].stateNumber, this._ctx.ruleIndex);
                }
                break;
            case 5 /* ATOM */ :
                this.match(transition._label);
                break;
            case 2 /* RANGE */ :
            case 7 /* SET */ :
            case 8 /* NOT_SET */ :
                if (!transition.matches(this._input.LA(1), $2G93d.Token.MIN_USER_TOKEN_TYPE, 65535)) this.recoverInline();
                this.matchWildcard();
                break;
            case 9 /* WILDCARD */ :
                this.matchWildcard();
                break;
            case 3 /* RULE */ :
                let ruleStartState = transition.target;
                let ruleIndex = ruleStartState.ruleIndex;
                let newctx = this.createInterpreterRuleContext(this._ctx, p.stateNumber, ruleIndex);
                if (ruleStartState.isPrecedenceRule) this.enterRecursionRule(newctx, ruleStartState.stateNumber, ruleIndex, transition.precedence);
                else this.enterRule(newctx, transition.target.stateNumber, ruleIndex);
                break;
            case 4 /* PREDICATE */ :
                let predicateTransition = transition;
                if (!this.sempred(this._ctx, predicateTransition.ruleIndex, predicateTransition.predIndex)) throw new $d7mTm.FailedPredicateException(this);
                break;
            case 6 /* ACTION */ :
                let actionTransition = transition;
                this.action(this._ctx, actionTransition.ruleIndex, actionTransition.actionIndex);
                break;
            case 10 /* PRECEDENCE */ :
                if (!this.precpred(this._ctx, transition.precedence)) {
                    let precedence = transition.precedence;
                    throw new $d7mTm.FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
                }
                break;
            default:
                throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
        }
        this.state = transition.target.stateNumber;
    }
    /** Method visitDecisionState() is called when the interpreter reaches
     *  a decision state (instance of DecisionState). It gives an opportunity
     *  for subclasses to track interesting things.
     */ visitDecisionState(p) {
        let predictedAlt;
        this.errorHandler.sync(this);
        let decision = p.decision;
        if (decision === this.overrideDecision && this._input.index === this.overrideDecisionInputIndex && !this.overrideDecisionReached) {
            predictedAlt = this.overrideDecisionAlt;
            this.overrideDecisionReached = true;
        } else predictedAlt = this.interpreter.adaptivePredict(this._input, decision, this._ctx);
        return predictedAlt;
    }
    /** Provide simple "factory" for InterpreterRuleContext's.
     *  @since 4.5.1
     */ createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
        return new $2iaul.InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
    }
    visitRuleStopState(p) {
        let ruleStartState = this._atn.ruleToStartState[p.ruleIndex];
        if (ruleStartState.isPrecedenceRule) {
            let parentContext = this._parentContextStack.pop();
            this.unrollRecursionContexts(parentContext[0]);
            this.state = parentContext[1];
        } else this.exitRule();
        let ruleTransition = this._atn.states[this.state].transition(0);
        this.state = ruleTransition.followState.stateNumber;
    }
    /** Override this parser interpreters normal decision-making process
     *  at a particular decision and input token index. Instead of
     *  allowing the adaptive prediction mechanism to choose the
     *  first alternative within a block that leads to a successful parse,
     *  force it to take the alternative, 1..n for n alternatives.
     *
     *  As an implementation limitation right now, you can only specify one
     *  override. This is sufficient to allow construction of different
     *  parse trees for ambiguous input. It means re-parsing the entire input
     *  in general because you're never sure where an ambiguous sequence would
     *  live in the various parse trees. For example, in one interpretation,
     *  an ambiguous input sequence would be matched completely in expression
     *  but in another it could match all the way back to the root.
     *
     *  s : e '!'? ;
     *  e : ID
     *    | ID '!'
     *    ;
     *
     *  Here, x! can be matched as (s (e ID) !) or (s (e ID !)). In the first
     *  case, the ambiguous sequence is fully contained only by the root.
     *  In the second case, the ambiguous sequences fully contained within just
     *  e, as in: (e ID !).
     *
     *  Rather than trying to optimize this and make
     *  some intelligent decisions for optimization purposes, I settled on
     *  just re-parsing the whole input and then using
     *  {link Trees#getRootOfSubtreeEnclosingRegion} to find the minimal
     *  subtree that contains the ambiguous sequence. I originally tried to
     *  record the call stack at the point the parser detected and ambiguity but
     *  left recursive rules create a parse tree stack that does not reflect
     *  the actual call stack. That impedance mismatch was enough to make
     *  it it challenging to restart the parser at a deeply nested rule
     *  invocation.
     *
     *  Only parser interpreters can override decisions so as to avoid inserting
     *  override checking code in the critical ALL(*) prediction execution path.
     *
     *  @since 4.5
     */ addDecisionOverride(decision, tokenIndex, forcedAlt) {
        this.overrideDecision = decision;
        this.overrideDecisionInputIndex = tokenIndex;
        this.overrideDecisionAlt = forcedAlt;
    }
    get overrideDecisionRoot() {
        return this._overrideDecisionRoot;
    }
    /** Rely on the error handler for this parser but, if no tokens are consumed
     *  to recover, add an error node. Otherwise, nothing is seen in the parse
     *  tree.
     */ recover(e) {
        let i = this._input.index;
        this.errorHandler.recover(this, e);
        if (this._input.index === i) {
            // no input consumed, better add an error node
            let tok = e.getOffendingToken();
            if (!tok) throw new Error("Expected exception to have an offending token");
            let source = tok.tokenSource;
            let stream = source !== undefined ? source.inputStream : undefined;
            let sourcePair = {
                source: source,
                stream: stream
            };
            if (e instanceof $6iuj6.InputMismatchException) {
                let expectedTokens = e.expectedTokens;
                if (expectedTokens === undefined) throw new Error("Expected the exception to provide expected tokens");
                let expectedTokenType = $2G93d.Token.INVALID_TYPE;
                if (!expectedTokens.isNil) // get any element
                expectedTokenType = expectedTokens.minElement;
                let errToken = this.tokenFactory.create(sourcePair, expectedTokenType, tok.text, $2G93d.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            } else {
                let source = tok.tokenSource;
                let errToken = this.tokenFactory.create(sourcePair, $2G93d.Token.INVALID_TYPE, tok.text, $2G93d.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            }
        }
    }
    recoverInline() {
        return this._errHandler.recoverInline(this);
    }
    /** Return the root of the parse, which can be useful if the parser
     *  bails out. You still can access the top node. Note that,
     *  because of the way left recursive rules add children, it's possible
     *  that the root will not have any children if the start rule immediately
     *  called and left recursive rule that fails.
     *
     * @since 4.5.1
     */ get rootContext() {
        return this._rootContext;
    }
};
$9b1f511704f60b2d$var$__decorate([
    $esDFm.NotNull
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "_vocabulary", void 0);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "reset", null);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "atn", null);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "vocabulary", null);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "ruleNames", null);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "grammarFileName", null);
$9b1f511704f60b2d$var$__decorate([
    $esDFm.Override
], $9b1f511704f60b2d$var$ParserInterpreter.prototype, "enterRecursionRule", null);
$9b1f511704f60b2d$var$ParserInterpreter = $9b1f511704f60b2d$var$__decorate([
    $9b1f511704f60b2d$var$__param(1, $esDFm.NotNull)
], $9b1f511704f60b2d$var$ParserInterpreter);
module.exports.ParserInterpreter = $9b1f511704f60b2d$var$ParserInterpreter;

});

parcelRegister("gBCh3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c16dca7b4f738f44$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContextWithAltNum = void 0;

var $lDQMG = parcelRequire("lDQMG");

var $esDFm = parcelRequire("esDFm");

var $5NlfZ = parcelRequire("5NlfZ");
/** A handy class for use with
 *
 *  options {contextSuperClass=org.antlr.v4.runtime.RuleContextWithAltNum;}
 *
 *  that provides a backing field / impl for the outer alternative number
 *  matched for an internal parse tree node.
 *
 *  I'm only putting into Java runtime as I'm certain I'm the only one that
 *  will really every use this.
 */ class $c16dca7b4f738f44$var$RuleContextWithAltNum extends $5NlfZ.ParserRuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._altNumber = $lDQMG.ATN.INVALID_ALT_NUMBER;
    }
    get altNumber() {
        return this._altNumber;
    }
    // @Override
    set altNumber(altNum) {
        this._altNumber = altNum;
    }
}
$c16dca7b4f738f44$var$__decorate([
    $esDFm.Override
], $c16dca7b4f738f44$var$RuleContextWithAltNum.prototype, "altNumber", null);
module.exports.RuleContextWithAltNum = $c16dca7b4f738f44$var$RuleContextWithAltNum;

});

parcelRegister("9moap", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleDependency = void 0;
/**
 * Declares a dependency upon a grammar rule, along with a set of zero or more dependent rules.
 *
 * Version numbers within a grammar should be assigned on a monotonically increasing basis to allow for accurate
 * tracking of dependent rules.
 *
 * @author Sam Harwell
 */ function $6d08ea266c6ae7f4$var$RuleDependency(dependency) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleDependency = $6d08ea266c6ae7f4$var$RuleDependency;

});

parcelRegister("iB1aK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleVersion = void 0;
/**
 *
 * @author Sam Harwell
 */ function $d89c977dc44fdf68$var$RuleVersion(version) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleVersion = $d89c977dc44fdf68$var$RuleVersion;

});

parcelRegister("5fKqt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dAoWy", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kKHPj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3sjft", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2842eafbba1c332c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RewriteOperation = module.exports.TokenStreamRewriter = void 0;

var $4Q2DM = parcelRequire("4Q2DM");

var $esDFm = parcelRequire("esDFm");

var $2G93d = parcelRequire("2G93d");
/**
 * Useful for rewriting out a buffered input token stream after doing some
 * augmentation or other manipulations on it.
 *
 * You can insert stuff, replace, and delete chunks. Note that the operations
 * are done lazily--only if you convert the buffer to a {@link String} with
 * {@link TokenStream#getText()}. This is very efficient because you are not
 * moving data around all the time. As the buffer of tokens is converted to
 * strings, the {@link #getText()} method(s) scan the input token stream and
 * check to see if there is an operation at the current index. If so, the
 * operation is done and then normal {@link String} rendering continues on the
 * buffer. This is like having multiple Turing machine instruction streams
 * (programs) operating on a single input tape. :)
 *
 * This rewriter makes no modifications to the token stream. It does not ask the
 * stream to fill itself up nor does it advance the input cursor. The token
 * stream `TokenStream.index` will return the same value before and
 * after any {@link #getText()} call.
 *
 * The rewriter only works on tokens that you have in the buffer and ignores the
 * current input cursor. If you are buffering tokens on-demand, calling
 * {@link #getText()} halfway through the input will only do rewrites for those
 * tokens in the first half of the file.
 *
 * Since the operations are done lazily at {@link #getText}-time, operations do
 * not screw up the token index values. That is, an insert operation at token
 * index `i` does not change the index values for tokens
 * `i`+1..n-1.
 *
 * Because operations never actually alter the buffer, you may always get the
 * original token stream back without undoing anything. Since the instructions
 * are queued up, you can easily simulate transactions and roll back any changes
 * if there is an error just by removing instructions. For example,
 *
 * ```
 * CharStream input = new ANTLRFileStream("input");
 * TLexer lex = new TLexer(input);
 * CommonTokenStream tokens = new CommonTokenStream(lex);
 * T parser = new T(tokens);
 * TokenStreamRewriter rewriter = new TokenStreamRewriter(tokens);
 * parser.startRule();
 * ```
 *
 * Then in the rules, you can execute (assuming rewriter is visible):
 *
 * ```
 * Token t,u;
 * ...
 * rewriter.insertAfter(t, "text to put after t");}
 * rewriter.insertAfter(u, "text after u");}
 * System.out.println(rewriter.getText());
 * ```
 *
 * You can also have multiple "instruction streams" and get multiple rewrites
 * from a single pass over the input. Just name the instruction streams and use
 * that name again when printing the buffer. This could be useful for generating
 * a C file and also its header file--all from the same buffer:
 *
 * ```
 * rewriter.insertAfter("pass1", t, "text to put after t");}
 * rewriter.insertAfter("pass2", u, "text after u");}
 * System.out.println(rewriter.getText("pass1"));
 * System.out.println(rewriter.getText("pass2"));
 * ```
 *
 * If you don't use named rewrite streams, a "default" stream is used as the
 * first example shows.
 */ class $2842eafbba1c332c$var$TokenStreamRewriter {
    constructor(tokens){
        this.tokens = tokens;
        this.programs = new Map();
        this.programs.set($2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME, []);
        this.lastRewriteTokenIndexes = new Map();
    }
    getTokenStream() {
        return this.tokens;
    }
    rollback(instructionIndex, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let is = this.programs.get(programName);
        if (is != null) this.programs.set(programName, is.slice($2842eafbba1c332c$var$TokenStreamRewriter.MIN_TOKEN_INDEX, instructionIndex));
    }
    deleteProgram(programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        this.rollback($2842eafbba1c332c$var$TokenStreamRewriter.MIN_TOKEN_INDEX, programName);
    }
    insertAfter(tokenOrIndex, text, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        // to insert after, just insert before next index (even if past end)
        let rewrites = this.getProgram(programName);
        let op = new $2842eafbba1c332c$var$InsertAfterOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    insertBefore(tokenOrIndex, text, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        let rewrites = this.getProgram(programName);
        let op = new $2842eafbba1c332c$var$InsertBeforeOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    replaceSingle(index, text) {
        if (typeof index === "number") this.replace(index, index, text);
        else this.replace(index, index, text);
    }
    replace(from, to, text, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (typeof from !== "number") from = from.tokenIndex;
        if (typeof to !== "number") to = to.tokenIndex;
        if (from > to || from < 0 || to < 0 || to >= this.tokens.size) throw new RangeError(`replace: range invalid: ${from}..${to}(size=${this.tokens.size})`);
        let rewrites = this.getProgram(programName);
        let op = new $2842eafbba1c332c$var$ReplaceOp(this.tokens, from, to, rewrites.length, text);
        rewrites.push(op);
    }
    delete(from, to, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (to === undefined) to = from;
        if (typeof from === "number") this.replace(from, to, "", programName);
        else this.replace(from, to, "", programName);
    }
    getLastRewriteTokenIndex(programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let I = this.lastRewriteTokenIndexes.get(programName);
        if (I == null) return -1;
        return I;
    }
    setLastRewriteTokenIndex(programName, i) {
        this.lastRewriteTokenIndexes.set(programName, i);
    }
    getProgram(name) {
        let is = this.programs.get(name);
        if (is == null) is = this.initializeProgram(name);
        return is;
    }
    initializeProgram(name) {
        let is = [];
        this.programs.set(name, is);
        return is;
    }
    getText(intervalOrProgram, programName = $2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let interval;
        if (intervalOrProgram instanceof $4Q2DM.Interval) interval = intervalOrProgram;
        else interval = $4Q2DM.Interval.of(0, this.tokens.size - 1);
        if (typeof intervalOrProgram === "string") programName = intervalOrProgram;
        let rewrites = this.programs.get(programName);
        let start = interval.a;
        let stop = interval.b;
        // ensure start/end are in range
        if (stop > this.tokens.size - 1) stop = this.tokens.size - 1;
        if (start < 0) start = 0;
        if (rewrites == null || rewrites.length === 0) return this.tokens.getText(interval); // no instructions to execute
        let buf = [];
        // First, optimize instruction stream
        let indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
        // Walk buffer, executing instructions and emitting tokens
        let i = start;
        while(i <= stop && i < this.tokens.size){
            let op = indexToOp.get(i);
            indexToOp.delete(i); // remove so any left have index size-1
            let t = this.tokens.get(i);
            if (op == null) {
                // no operation at that index, just dump token
                if (t.type !== $2G93d.Token.EOF) buf.push(String(t.text));
                i++; // move to next token
            } else i = op.execute(buf); // execute operation and skip
        }
        // include stuff after end if it's last index in buffer
        // So, if they did an insertAfter(lastValidIndex, "foo"), include
        // foo if end==lastValidIndex.
        if (stop === this.tokens.size - 1) {
            // Scan any remaining operations after last token
            // should be included (they will be inserts).
            for (let op of indexToOp.values())if (op.index >= this.tokens.size - 1) buf.push(op.text.toString());
        }
        return buf.join("");
    }
    /** We need to combine operations and report invalid operations (like
     *  overlapping replaces that are not completed nested). Inserts to
     *  same index need to be combined etc...  Here are the cases:
     *
     *  I.i.u I.j.v								leave alone, nonoverlapping
     *  I.i.u I.i.v								combine: Iivu
     *
     *  R.i-j.u R.x-y.v	| i-j in x-y			delete first R
     *  R.i-j.u R.i-j.v							delete first R
     *  R.i-j.u R.x-y.v	| x-y in i-j			ERROR
     *  R.i-j.u R.x-y.v	| boundaries overlap	ERROR
     *
     *  Delete special case of replace (text==undefined):
     *  D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
     *
     *  I.i.u R.x-y.v | i in (x+1)-y			delete I (since insert before
     * 											we're not deleting i)
     *  I.i.u R.x-y.v | i not in (x+1)-y		leave alone, nonoverlapping
     *  R.x-y.v I.i.u | i in x-y				ERROR
     *  R.x-y.v I.x.u 							R.x-y.uv (combine, delete I)
     *  R.x-y.v I.i.u | i not in x-y			leave alone, nonoverlapping
     *
     *  I.i.u = insert u before op @ index i
     *  R.x-y.u = replace x-y indexed tokens with u
     *
     *  First we need to examine replaces. For any replace op:
     *
     * 		1. wipe out any insertions before op within that range.
     * 		2. Drop any replace op before that is contained completely within
     * 	 that range.
     * 		3. Throw exception upon boundary overlap with any previous replace.
     *
     *  Then we can deal with inserts:
     *
     * 		1. for any inserts to same index, combine even if not adjacent.
     * 		2. for any prior replace with same left boundary, combine this
     * 	 insert with replace and delete this replace.
     * 		3. throw exception if index in same range as previous replace
     *
     *  Don't actually delete; make op undefined in list. Easier to walk list.
     *  Later we can throw as we add to index &rarr; op map.
     *
     *  Note that I.2 R.2-2 will wipe out I.2 even though, technically, the
     *  inserted stuff would be before the replace range. But, if you
     *  add tokens in front of a method body '{' and then delete the method
     *  body, I think the stuff before the '{' you added should disappear too.
     *
     *  Return a map from token index to operation.
     */ reduceToSingleOperationPerIndex(rewrites) {
        // console.log(`rewrites=[${Utils.join(rewrites, ", ")}]`);
        // WALK REPLACES
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $2842eafbba1c332c$var$ReplaceOp)) continue;
            let rop = op;
            // Wipe prior inserts within range
            let inserts = this.getKindOfOps(rewrites, $2842eafbba1c332c$var$InsertBeforeOp, i);
            for (let iop of inserts){
                if (iop.index === rop.index) {
                    // E.g., insert before 2, delete 2..2; update replace
                    // text to include insert before, kill insert
                    rewrites[iop.instructionIndex] = undefined;
                    rop.text = iop.text.toString() + (rop.text != null ? rop.text.toString() : "");
                } else if (iop.index > rop.index && iop.index <= rop.lastIndex) // delete insert as it's a no-op.
                rewrites[iop.instructionIndex] = undefined;
            }
            // Drop any prior replaces contained within
            let prevReplaces = this.getKindOfOps(rewrites, $2842eafbba1c332c$var$ReplaceOp, i);
            for (let prevRop of prevReplaces){
                if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
                    // delete replace as it's a no-op.
                    rewrites[prevRop.instructionIndex] = undefined;
                    continue;
                }
                // throw exception unless disjoint or identical
                let disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
                // Delete special case of replace (text==null):
                // D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
                if (prevRop.text == null && rop.text == null && !disjoint) {
                    // console.log(`overlapping deletes: ${prevRop}, ${rop}`);
                    rewrites[prevRop.instructionIndex] = undefined; // kill first delete
                    rop.index = Math.min(prevRop.index, rop.index);
                    rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
                // console.log(`new rop ${rop}`);
                } else if (!disjoint) throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
            }
        }
        // WALK INSERTS
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $2842eafbba1c332c$var$InsertBeforeOp)) continue;
            let iop = op;
            // combine current insert with prior if any at same index
            let prevInserts = this.getKindOfOps(rewrites, $2842eafbba1c332c$var$InsertBeforeOp, i);
            for (let prevIop of prevInserts)if (prevIop.index === iop.index) {
                if (prevIop instanceof $2842eafbba1c332c$var$InsertAfterOp) {
                    iop.text = this.catOpText(prevIop.text, iop.text);
                    rewrites[prevIop.instructionIndex] = undefined;
                } else if (prevIop instanceof $2842eafbba1c332c$var$InsertBeforeOp) {
                    // convert to strings...we're in process of toString'ing
                    // whole token buffer so no lazy eval issue with any templates
                    iop.text = this.catOpText(iop.text, prevIop.text);
                    // delete redundant prior insert
                    rewrites[prevIop.instructionIndex] = undefined;
                }
            }
            // look for replaces where iop.index is in range; error
            let prevReplaces = this.getKindOfOps(rewrites, $2842eafbba1c332c$var$ReplaceOp, i);
            for (let rop of prevReplaces){
                if (iop.index === rop.index) {
                    rop.text = this.catOpText(iop.text, rop.text);
                    rewrites[i] = undefined; // delete current insert
                    continue;
                }
                if (iop.index >= rop.index && iop.index <= rop.lastIndex) throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
            }
        }
        // console.log(`rewrites after=[${Utils.join(rewrites, ", ")}]`);
        let m = new Map();
        for (let op of rewrites){
            if (op == null) continue;
            if (m.get(op.index) != null) throw new Error("should only be one op per index");
            m.set(op.index, op);
        }
        // console.log(`index to op: ${m}`);
        return m;
    }
    catOpText(a, b) {
        let x = "";
        let y = "";
        if (a != null) x = a.toString();
        if (b != null) y = b.toString();
        return x + y;
    }
    /** Get all operations before an index of a particular kind */ getKindOfOps(rewrites, kind, before) {
        let ops = [];
        for(let i = 0; i < before && i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (op instanceof kind) ops.push(op);
        }
        return ops;
    }
}
module.exports.TokenStreamRewriter = $2842eafbba1c332c$var$TokenStreamRewriter;
$2842eafbba1c332c$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME = "default";
$2842eafbba1c332c$var$TokenStreamRewriter.PROGRAM_INIT_SIZE = 100;
$2842eafbba1c332c$var$TokenStreamRewriter.MIN_TOKEN_INDEX = 0;
// Define the rewrite operation hierarchy
class $2842eafbba1c332c$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        this.tokens = tokens;
        this.instructionIndex = instructionIndex;
        this.index = index;
        this.text = text === undefined ? "" : text;
    }
    /** Execute the rewrite operation by possibly adding to the buffer.
     *  Return the index of the next token to operate on.
     */ execute(buf) {
        return this.index;
    }
    toString() {
        let opName = this.constructor.name;
        let $index = opName.indexOf("$");
        opName = opName.substring($index + 1, opName.length);
        return "<" + opName + "@" + this.tokens.get(this.index) + ":\"" + this.text + "\">";
    }
}
$2842eafbba1c332c$var$__decorate([
    $esDFm.Override
], $2842eafbba1c332c$var$RewriteOperation.prototype, "toString", null);
module.exports.RewriteOperation = $2842eafbba1c332c$var$RewriteOperation;
class $2842eafbba1c332c$var$InsertBeforeOp extends $2842eafbba1c332c$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index, instructionIndex, text);
    }
    execute(buf) {
        buf.push(this.text.toString());
        if (this.tokens.get(this.index).type !== $2G93d.Token.EOF) buf.push(String(this.tokens.get(this.index).text));
        return this.index + 1;
    }
}
$2842eafbba1c332c$var$__decorate([
    $esDFm.Override
], $2842eafbba1c332c$var$InsertBeforeOp.prototype, "execute", null);
/** Distinguish between insert after/before to do the "insert afters"
 *  first and then the "insert befores" at same index. Implementation
 *  of "insert after" is "insert before index+1".
 */ class $2842eafbba1c332c$var$InsertAfterOp extends $2842eafbba1c332c$var$InsertBeforeOp {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index + 1, instructionIndex, text); // insert after is insert before index+1
    }
}
/** I'm going to try replacing range from x..y with (y-x)+1 ReplaceOp
 *  instructions.
 */ class $2842eafbba1c332c$var$ReplaceOp extends $2842eafbba1c332c$var$RewriteOperation {
    constructor(tokens, from, to, instructionIndex, text){
        super(tokens, from, instructionIndex, text);
        this.lastIndex = to;
    }
    execute(buf) {
        if (this.text != null) buf.push(this.text.toString());
        return this.lastIndex + 1;
    }
    toString() {
        if (this.text == null) return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
        return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ":\"" + this.text + "\">";
    }
}
$2842eafbba1c332c$var$__decorate([
    $esDFm.Override
], $2842eafbba1c332c$var$ReplaceOp.prototype, "execute", null);
$2842eafbba1c332c$var$__decorate([
    $esDFm.Override
], $2842eafbba1c332c$var$ReplaceOp.prototype, "toString", null);

});

parcelRegister("7twhW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7kyUa", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("lznor", function(module, exports) {

$parcel$export(module.exports, "JQLLexer", () => $8132725dc5c59eb0$export$375c79404cc64c7f);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLLexer.g4 by ANTLR 4.7.3-SNAPSHOT

var $es7AZ = parcelRequire("es7AZ");

var $gTQRB = parcelRequire("gTQRB");

var $kkkg9 = parcelRequire("kkkg9");

var $5t4I3 = parcelRequire("5t4I3");

var $g4Hat = parcelRequire("g4Hat");
class $8132725dc5c59eb0$export$375c79404cc64c7f extends (0, $gTQRB.Lexer) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.QUOTED_STR = 1;
    }
    static{
        this.SQUOTED_STR = 2;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.channelNames = [
            'DEFAULT_TOKEN_CHANNEL',
            'HIDDEN'
        ];
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.modeNames = [
            'DEFAULT_MODE',
            'QUOTED_STR',
            'SQUOTED_STR'
        ];
    }
    static{
        this.ruleNames = [
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'LQUOTE',
            'LSQUOTE',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'QUOTED_CONTENT',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'SQUOTED_CONTENT',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING',
            'VALID_UNQUOTED_CHARS',
            'VALID_QUOTED_CHARS',
            'VALID_SQUOTED_CHARS',
            'RESERVED_CHARS',
            'QUOTE',
            'SQUOTE',
            'BSLASH',
            'NL',
            'CR',
            'SPACE',
            'AMPER',
            'AMPER_AMPER',
            'PIPE',
            'PIPE_PIPE',
            'ESCAPE',
            'NEWLINE',
            'HEXDIGIT',
            'WS',
            'MINUS',
            'DIGIT',
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $5t4I3.VocabularyImpl)($8132725dc5c59eb0$export$375c79404cc64c7f._LITERAL_NAMES, $8132725dc5c59eb0$export$375c79404cc64c7f._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $8132725dc5c59eb0$export$375c79404cc64c7f.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    constructor(input){
        super(input);
        this._interp = new (0, $kkkg9.LexerATNSimulator)($8132725dc5c59eb0$export$375c79404cc64c7f._ATN, this);
    }
    // @Override
    get grammarFileName() {
        return 'JQLLexer.g4';
    }
    // @Override
    get ruleNames() {
        return $8132725dc5c59eb0$export$375c79404cc64c7f.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $8132725dc5c59eb0$export$375c79404cc64c7f._serializedATN;
    }
    // @Override
    get channelNames() {
        return $8132725dc5c59eb0$export$375c79404cc64c7f.channelNames;
    }
    // @Override
    get modeNames() {
        return $8132725dc5c59eb0$export$375c79404cc64c7f.modeNames;
    }
    static{
        this._serializedATNSegments = 3;
    }
    static{
        this._serializedATNSegment0 = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x020\u062E\b\x01\b\x01\b\x01\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04\"	\"\x04#	#\x04$	$\x04%	%\x04&	&\x04'	'\x04(	(\x04)	)\x04*	*\x04+	+\x04,	,\x04-	-\x04.	.\x04/	/\x040	0\x041	1\x042	2\x043	3\x044	4\x045	5\x046	6\x047	7\x048	8\x049	9\x04:	:\x04;	;\x04<	<\x04=	=\x04>	>\x04?	?\x04@	@\x04A	A\x04B	B\x04C	C\x04D	D\x04E	E\x04F	F\x04G	G\x04H	H\x04I	I\x04J	J\x04K	K\x04L	L\x04M	M\x04N	N\x04O	O\x04P	P\x04Q	Q\x04R	R\x04S	S\x04T	T\x04U	U\x04V	V\x04W	W\x04X	X\x04Y	Y\x04Z	Z\x04[	[\x04\\	\\\x04]	]\x04^	^\x04_	_\x04`	`\x04a	a\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03	\x03	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0e\x03\x0e\x03\x0f\x03\x0f\x03\x0f\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\xfc\n\x14\x03\x15\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u0103\n\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\u0114\n\x17\x03\x18\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03 \x03 \x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03$\x06$\u0154\n$\r$\x0e$\u0155\x03%\x03%\x06%\u015A\n%\r%\x0e%\u015B\x03&\x03&\x03&\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x05'\u0582\n'\x03(\x03(\x06(\u0586\n(\r(\x0e(\u0587\x03)\x06)\u058B\n)\r)\x0e)\u058C\x03)\x03)\x03*\x03*\x03+\x03+\x03,\x03,\x03,\x03,\x03-\x03-\x05-\u059B\n-\x03-\x03-\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x030\x030\x030\x030\x031\x031\x051\u05AD\n1\x031\x031\x032\x032\x032\x032\x033\x033\x033\x033\x034\x034\x035\x035\x036\x036\x037\x037\x038\x038\x039\x039\x03:\x03:\x03;\x03;\x03<\x03<\x03=\x03=\x03>\x03>\x03?\x03?\x03?\x03@\x03@\x03A\x03A\x03A\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x05B\u05E3\nB\x03C\x03C\x05C\u05E7\nC\x03D\x03D\x03D\x03D\x03D\x03D\x03D\x05D\u05F0\nD\x03E\x03E\x03E\x05E\u05F5\nE\x03F\x03F\x03G\x03G\x03H\x03H\x03I\x03I\x03J\x03J\x03K\x03K\x03L\x03L\x03M\x03M\x03N\x03N\x03O\x03O\x03P\x03P\x03Q\x03Q\x03R\x03R\x03S\x03S\x03T\x03T\x03U\x03U\x03V\x03V\x03W\x03W\x03X\x03X\x03Y\x03Y\x03Z\x03Z\x03[\x03[\x03\\\x03\\\x03]\x03]\x03^\x03^\x03_\x03_\x03`\x03`\x03a\x03a\x02\x02\x02b\x05\x02\x03\x07\x02\x04	\x02\x05\v\x02\x06\r\x02\x07\x0f\x02\x02\x11\x02\x02\x13\x02\b\x15\x02	\x17\x02\n\x19\x02\v\x1b\x02\f\x1d\x02\r\x1f\x02\x0e!\x02\x0f#\x02\x10%\x02\x11'\x02\x12)\x02\x13+\x02\x14-\x02\x15/\x02\x161\x02\x173\x02\x185\x02\x197\x02\x1a9\x02\x1b;\x02\x1c=\x02\x1d?\x02\x1eA\x02\x1fC\x02 E\x02!G\x02\"I\x02#K\x02$M\x02%O\x02&Q\x02'S\x02(U\x02)W\x02*Y\x02+[\x02\x02]\x02,_\x02-a\x02.c\x02\x02e\x02/g\x020i\x02\x02k\x02\x02m\x02\x02o\x02\x02q\x02\x02s\x02\x02u\x02\x02w\x02\x02y\x02\x02{\x02\x02}\x02\x02\x7f\x02\x02\x81\x02\x02\x83\x02\x02\x85\x02\x02\x87\x02\x02\x89\x02\x02\x8b\x02\x02\x8d\x02\x02\x8f\x02\x02\x91\x02\x02\x93\x02\x02\x95\x02\x02\x97\x02\x02\x99\x02\x02\x9b\x02\x02\x9d\x02\x02\x9f\x02\x02\xa1\x02\x02\xa3\x02\x02\xa5\x02\x02\xa7\x02\x02\xa9\x02\x02\xab\x02\x02\xad\x02\x02\xaf\x02\x02\xb1\x02\x02\xb3\x02\x02\xb5\x02\x02\xb7\x02\x02\xb9\x02\x02\xbb\x02\x02\xbd\x02\x02\xbf\x02\x02\xc1\x02\x02\xc3\x02\x02\x05\x02\x03\x04\"	\x02\x02.11=B]`}\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!$$^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!))^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02%',-11==AB``}}\x7f\x7f\x05\x02ppttvv\x03\x022;\x04\x02CCcc\x04\x02DDdd\x04\x02EEee\x04\x02FFff\x04\x02GGgg\x04\x02HHhh\x04\x02IIii\x04\x02JJjj\x04\x02KKkk\x04\x02LLll\x04\x02MMmm\x04\x02NNnn\x04\x02OOoo\x04\x02PPpp\x04\x02QQqq\x04\x02RRrr\x04\x02SSss\x04\x02TTtt\x04\x02UUuu\x04\x02VVvv\x04\x02WWww\x04\x02XXxx\x04\x02YYyy\x04\x02ZZzz\x04\x02[[{{\x04\x02\\\\||\x02\u06B5\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02	\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0f\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1b\x03\x02\x02\x02\x02\x1d\x03\x02\x02\x02\x02\x1f\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x03Y\x03\x02\x02\x02\x03[\x03\x02\x02\x02\x03]\x03\x02\x02\x02\x03_\x03\x02\x02\x02\x04a\x03\x02\x02\x02\x04c\x03\x02\x02\x02\x04e\x03\x02\x02\x02\x04g\x03\x02\x02\x02\x05\xc5\x03\x02\x02\x02\x07\xc7\x03\x02\x02\x02	\xc9\x03\x02\x02\x02\v\xcb\x03\x02\x02\x02\r\xcd\x03\x02\x02\x02\x0f\xcf\x03\x02\x02\x02\x11\xd4\x03\x02\x02\x02\x13\xd9\x03\x02\x02\x02\x15\xdb\x03\x02\x02\x02\x17\xdd\x03\x02\x02\x02\x19\xdf\x03\x02\x02\x02\x1b\xe2\x03\x02\x02\x02\x1d\xe5\x03\x02\x02\x02\x1f\xe7\x03\x02\x02\x02!\xea\x03\x02\x02\x02#\xec\x03\x02\x02\x02%\xef\x03\x02\x02\x02'\xf2\x03\x02\x02\x02)\xfb\x03\x02\x02\x02+\u0102\x03\x02\x02\x02-\u0104\x03\x02\x02\x02/\u0113\x03\x02\x02\x021\u0115\x03\x02\x02\x023\u0119\x03\x02\x02\x025\u0121\x03\x02\x02\x027\u0128\x03\x02\x02\x029\u012E\x03\x02\x02\x02;\u0133\x03\x02\x02\x02=\u0136\x03\x02\x02\x02?\u0139\x03\x02\x02\x02A\u0140\x03\x02\x02\x02C\u0146\x03\x02\x02\x02E\u0149\x03\x02\x02\x02G\u014D\x03\x02\x02\x02I\u0153\x03\x02\x02\x02K\u0157\x03\x02\x02\x02M\u015D\x03\x02\x02\x02O\u0581\x03\x02\x02\x02Q\u0585\x03\x02\x02\x02S\u058A\x03\x02\x02\x02U\u0590\x03\x02\x02\x02W\u0592\x03\x02\x02\x02Y\u0594\x03\x02\x02\x02[\u059A\x03\x02\x02\x02]\u059E\x03\x02\x02\x02_\u05A2\x03\x02\x02\x02a\u05A6\x03\x02\x02\x02c\u05AC\x03\x02\x02\x02e\u05B0\x03\x02\x02\x02g\u05B4\x03\x02\x02\x02i\u05B8\x03\x02\x02\x02k\u05BA\x03\x02\x02\x02m\u05BC\x03\x02\x02\x02o\u05BE\x03\x02\x02\x02q\u05C0\x03\x02\x02\x02s\u05C2\x03\x02\x02\x02u\u05C4\x03\x02\x02\x02w\u05C6\x03\x02\x02\x02y\u05C8\x03\x02\x02\x02{\u05CA\x03\x02\x02\x02}\u05CC\x03\x02\x02\x02\x7f\u05CE\x03\x02\x02\x02\x81\u05D1\x03\x02\x02\x02\x83\u05D3\x03\x02\x02\x02\x85\u05D6\x03\x02\x02\x02\x87\u05E6\x03\x02\x02\x02\x89\u05EF\x03\x02\x02\x02\x8b\u05F4\x03\x02\x02\x02\x8d\u05F6\x03\x02\x02\x02\x8f\u05F8\x03\x02\x02\x02\x91\u05FA\x03\x02\x02\x02\x93\u05FC\x03\x02\x02\x02\x95\u05FE\x03\x02\x02\x02\x97\u0600\x03\x02\x02\x02\x99\u0602\x03\x02\x02\x02\x9b\u0604\x03\x02\x02\x02\x9d\u0606\x03\x02\x02\x02\x9f\u0608\x03\x02\x02\x02\xa1\u060A\x03\x02\x02\x02\xa3\u060C\x03\x02\x02\x02\xa5\u060E\x03\x02\x02\x02\xa7\u0610\x03\x02\x02\x02\xa9\u0612\x03\x02\x02\x02\xab\u0614\x03\x02\x02\x02\xad\u0616\x03\x02\x02\x02\xaf\u0618\x03\x02\x02\x02\xb1\u061A\x03\x02\x02\x02\xb3\u061C\x03\x02\x02\x02\xb5\u061E\x03\x02\x02\x02\xb7\u0620\x03\x02\x02\x02\xb9\u0622\x03\x02\x02\x02\xbb\u0624\x03\x02\x02\x02\xbd\u0626\x03\x02\x02\x02\xbf\u0628\x03\x02\x02\x02\xc1\u062A\x03\x02\x02\x02\xc3\u062C\x03\x02\x02\x02\xc5\xc6\x07*\x02\x02\xc6\x06\x03\x02\x02\x02\xc7\xc8\x07+\x02\x02\xc8\b\x03\x02\x02\x02\xc9\xca\x07.\x02\x02\xca\n\x03\x02\x02\x02\xcb\xcc\x07]\x02\x02\xcc\f\x03\x02\x02\x02\xcd\xce\x07_\x02\x02\xce\x0e\x03\x02\x02\x02\xcf\xd0\x05q8\x02\xd0\xd1\x03\x02\x02\x02\xd1\xd2\b\x07\x02\x02\xd2\xd3\b\x07\x03\x02\xd3\x10\x03\x02\x02\x02\xd4\xd5\x05s9\x02\xd5\xd6\x03\x02\x02\x02\xd6\xd7\b\b\x02\x02\xd7\xd8\b\b\x04\x02\xd8\x12\x03\x02\x02\x02\xd9\xda\x07#\x02\x02\xda\x14\x03\x02\x02\x02\xdb\xdc\x07>\x02\x02\xdc\x16\x03\x02\x02\x02\xdd\xde\x07@\x02\x02\xde\x18\x03\x02\x02\x02\xdf\xe0\x07@\x02\x02\xe0\xe1\x07?\x02\x02\xe1\x1a\x03\x02\x02\x02\xe2\xe3\x07>\x02\x02\xe3\xe4\x07?\x02\x02\xe4\x1c\x03\x02\x02\x02\xe5\xe6\x07?\x02\x02\xe6\x1e\x03\x02\x02\x02\xe7\xe8\x07#\x02\x02\xe8\xe9\x07?\x02\x02\xe9 \x03\x02\x02\x02\xea\xeb\x07\x80\x02\x02\xeb\"\x03\x02\x02\x02\xec\xed\x07#\x02\x02\xed\xee\x07\x80\x02\x02\xee$\x03\x02\x02\x02\xef\xf0\x05\xa1P\x02\xf0\xf1\x05\xabU\x02\xf1&\x03\x02\x02\x02\xf2\xf3\x05\xa1P\x02\xf3\xf4\x05\xb5Z\x02\xf4(\x03\x02\x02\x02\xf5\xf6\x05\x91H\x02\xf6\xf7\x05\xabU\x02\xf7\xf8\x05\x97K\x02\xf8\xfc\x03\x02\x02\x02\xf9\xfc\x05}>\x02\xfa\xfc\x05\x7f?\x02\xfb\xf5\x03\x02\x02\x02\xfb\xf9\x03\x02\x02\x02\xfb\xfa\x03\x02\x02\x02\xfc*\x03\x02\x02\x02\xfd\xfe\x05\xadV\x02\xfe\xff\x05\xb3Y\x02\xff\u0103\x03\x02\x02\x02\u0100\u0103\x05\x81@\x02\u0101\u0103\x05\x83A\x02\u0102\xfd\x03\x02\x02\x02\u0102\u0100\x03\x02\x02\x02\u0102\u0101\x03\x02\x02\x02\u0103";
    }
    static{
        this._serializedATNSegment1 = ",\x03\x02\x02\x02\u0104\u0105\x05\xabU\x02\u0105\u0106\x05\xadV\x02\u0106\u0107\x05\xb7[\x02\u0107.\x03\x02\x02\x02\u0108\u0109\x05\x99L\x02\u0109\u010A\x05\xa9T\x02\u010A\u010B\x05\xafW\x02\u010B\u010C\x05\xb7[\x02\u010C\u010D\x05\xc1`\x02\u010D\u0114\x03\x02\x02\x02\u010E\u010F\x05\xabU\x02\u010F\u0110\x05\xb9\\\x02\u0110\u0111\x05\xa7S\x02\u0111\u0112\x05\xa7S\x02\u0112\u0114\x03\x02\x02\x02\u0113\u0108\x03\x02\x02\x02\u0113\u010E\x03\x02\x02\x02\u01140\x03\x02\x02\x02\u0115\u0116\x05\xbd^\x02\u0116\u0117\x05\x91H\x02\u0117\u0118\x05\xb5Z\x02\u01182\x03\x02\x02\x02\u0119\u011A\x05\x95J\x02\u011A\u011B\x05\x9fO\x02\u011B\u011C\x05\x91H\x02\u011C\u011D\x05\xabU\x02\u011D\u011E\x05\x9dN\x02\u011E\u011F\x05\x99L\x02\u011F\u0120\x05\x97K\x02\u01204\x03\x02\x02\x02\u0121\u0122\x05\x93I\x02\u0122\u0123\x05\x99L\x02\u0123\u0124\x05\x9bM\x02\u0124\u0125\x05\xadV\x02\u0125\u0126\x05\xb3Y\x02\u0126\u0127\x05\x99L\x02\u01276\x03\x02\x02\x02\u0128\u0129\x05\x91H\x02\u0129\u012A\x05\x9bM\x02\u012A\u012B\x05\xb7[\x02\u012B\u012C\x05\x99L\x02\u012C\u012D\x05\xb3Y\x02\u012D8\x03\x02\x02\x02\u012E\u012F\x05\x9bM\x02\u012F\u0130\x05\xb3Y\x02\u0130\u0131\x05\xadV\x02\u0131\u0132\x05\xa9T\x02\u0132:\x03\x02\x02\x02\u0133\u0134\x05\xb7[\x02\u0134\u0135\x05\xadV\x02\u0135<\x03\x02\x02\x02\u0136\u0137\x05\xadV\x02\u0137\u0138\x05\xabU\x02\u0138>\x03\x02\x02\x02\u0139\u013A\x05\x97K\x02\u013A\u013B\x05\xb9\\\x02\u013B\u013C\x05\xb3Y\x02\u013C\u013D\x05\xa1P\x02\u013D\u013E\x05\xabU\x02\u013E\u013F\x05\x9dN\x02\u013F@\x03\x02\x02\x02\u0140\u0141\x05\xadV\x02\u0141\u0142\x05\xb3Y\x02\u0142\u0143\x05\x97K\x02\u0143\u0144\x05\x99L\x02\u0144\u0145\x05\xb3Y\x02\u0145B\x03\x02\x02\x02\u0146\u0147\x05\x93I\x02\u0147\u0148\x05\xc1`\x02\u0148D\x03\x02\x02\x02\u0149\u014A\x05\x91H\x02\u014A\u014B\x05\xb5Z\x02\u014B\u014C\x05\x95J\x02\u014CF\x03\x02\x02\x02\u014D\u014E\x05\x97K\x02\u014E\u014F\x05\x99L\x02\u014F\u0150\x05\xb5Z\x02\u0150\u0151\x05\x95J\x02\u0151H\x03\x02\x02\x02\u0152\u0154\x05\x8fG\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02\u0156J\x03\x02\x02\x02\u0157\u0159\x05\x8dF\x02\u0158\u015A\x05\x8fG\x02\u0159\u0158\x03\x02\x02\x02\u015A\u015B\x03\x02\x02\x02\u015B\u0159\x03\x02\x02\x02\u015B\u015C\x03\x02\x02\x02\u015CL\x03\x02\x02\x02\u015D\u015E\x05\x95J\x02\u015E\u015F\x05\x9bM\x02\u015FN\x03\x02\x02\x02\u0160\u0161\x05\x91H\x02\u0161\u0162\x05\x93I\x02\u0162\u0163\x05\xadV\x02\u0163\u0164\x05\xb3Y\x02\u0164\u0165\x05\xb7[\x02\u0165\u0582\x03\x02\x02\x02\u0166\u0167\x05\x91H\x02\u0167\u0168\x05\x95J\x02\u0168\u0169\x05\x95J\x02\u0169\u016A\x05\x99L\x02\u016A\u016B\x05\xb5Z\x02\u016B\u016C\x05\xb5Z\x02\u016C\u0582\x03\x02\x02\x02\u016D\u016E\x05\x91H\x02\u016E\u016F\x05\x97K\x02\u016F\u0170\x05\x97K\x02\u0170\u0582\x03\x02\x02\x02\u0171\u0172\x05\x91H\x02\u0172\u0173\x05\xa7S\x02\u0173\u0174\x05\xa1P\x02\u0174\u0175\x05\x91H\x02\u0175\u0176\x05\xb5Z\x02\u0176\u0582\x03\x02\x02\x02\u0177\u0178\x05\x91H\x02\u0178\u0179\x05\xa7S\x02\u0179\u017A\x05\xb7[\x02\u017A\u017B\x05\x99L\x02\u017B\u017C\x05\xb3Y\x02\u017C\u0582\x03\x02\x02\x02\u017D\u017E\x05\x91H\x02\u017E\u017F\x05\xabU\x02\u017F\u0180\x05\xc1`\x02\u0180\u0582\x03\x02\x02\x02\u0181\u0182\x05\x91H\x02\u0182\u0183\x05\xb5Z\x02\u0183\u0582\x03\x02\x02\x02\u0184\u0185\x05\x91H\x02\u0185\u0186\x05\xb9\\\x02\u0186\u0187\x05\x97K\x02\u0187\u0188\x05\xa1P\x02\u0188\u0189\x05\xb7[\x02\u0189\u0582\x03\x02\x02\x02\u018A\u018B\x05\x91H\x02\u018B\u018C\x05\xbb]\x02\u018C\u018D\x05\x9dN\x02\u018D\u0582\x03\x02\x02\x02\u018E\u018F\x05\x93I\x02\u018F\u0190\x05\x99L\x02\u0190\u0191\x05\x9dN\x02\u0191\u0192\x05\xa1P\x02\u0192\u0193\x05\xabU\x02\u0193\u0582\x03\x02\x02\x02\u0194\u0195\x05\x93I\x02\u0195\u0196\x05\x99L\x02\u0196\u0197\x05\xb7[\x02\u0197\u0198\x05\xbd^\x02\u0198\u0199\x05\x99L\x02\u0199\u019A\x05\x99L\x02\u019A\u019B\x05\xabU\x02\u019B\u0582\x03\x02\x02\x02\u019C\u019D\x05\x93I\x02\u019D\u019E\x05\xadV\x02\u019E\u019F\x05\xadV\x02\u019F\u01A0\x05\xa7S\x02\u01A0\u01A1\x05\x99L\x02\u01A1\u01A2\x05\x91H\x02\u01A2\u01A3\x05\xabU\x02\u01A3\u0582\x03\x02\x02\x02\u01A4\u01A5\x05\x93I\x02\u01A5\u01A6\x05\xb3Y\x02\u01A6\u01A7\x05\x99L\x02\u01A7\u01A8\x05\x91H\x02\u01A8\u01A9\x05\xa5R\x02\u01A9\u0582\x03\x02\x02\x02\u01AA\u01AB\x05\x93I\x02\u01AB\u01AC\x05\xc1`\x02\u01AC\u01AD\x05\xb7[\x02\u01AD\u01AE\x05\x99L\x02\u01AE\u0582\x03\x02\x02\x02\u01AF\u01B0\x05\x95J\x02\u01B0\u01B1\x05\x91H\x02\u01B1\u01B2\x05\xb7[\x02\u01B2\u01B3\x05\x95J\x02\u01B3\u01B4\x05\x9fO\x02\u01B4\u0582\x03\x02\x02\x02\u01B5\u01B6\x05\x95J\x02\u01B6\u01B7\x05\x9fO\x02\u01B7\u01B8\x05\x91H\x02\u01B8\u01B9\x05\xb3Y\x02\u01B9\u0582\x03\x02\x02\x02\u01BA\u01BB\x05\x95J\x02\u01BB\u01BC\x05\x9fO\x02\u01BC\u01BD\x05\x91H\x02\u01BD\u01BE\x05\xb3Y\x02\u01BE\u01BF\x05\x91H\x02\u01BF\u01C0\x05\x95J\x02\u01C0\u01C1\x05\xb7[\x02\u01C1\u01C2\x05\x99L\x02\u01C2\u01C3\x05\xb3Y\x02\u01C3\u0582\x03\x02\x02\x02\u01C4\u01C5\x05\x95J\x02\u01C5\u01C6\x05\x9fO\x02\u01C6\u01C7\x05\x99L\x02\u01C7\u01C8\x05\x95J\x02\u01C8\u01C9\x05\xa5R\x02\u01C9\u0582\x03\x02\x02\x02\u01CA\u01CB\x05\x95J\x02\u01CB\u01CC\x05\x9fO\x02\u01CC\u01CD\x05\x99L\x02\u01CD\u01CE\x05\x95J\x02\u01CE\u01CF\x05\xa5R\x02\u01CF\u01D0\x05\xafW\x02\u01D0\u01D1\x05\xadV\x02\u01D1\u01D2\x05\xa1P\x02\u01D2\u01D3\x05\xabU\x02\u01D3\u01D4\x05\xb7[\x02\u01D4\u0582\x03\x02\x02\x02\u01D5\u01D6\x05\x95J\x02\u01D6\u01D7\x05\xadV\x02\u01D7\u01D8\x05\xa7S\x02\u01D8\u01D9\x05\xa7S\x02\u01D9\u01DA\x05\x91H\x02\u01DA\u01DB\x05\xb7[\x02\u01DB\u01DC\x05\x99L\x02\u01DC\u0582\x03\x02\x02\x02\u01DD\u01DE\x05\x95J\x02\u01DE\u01DF\x05\xadV\x02\u01DF\u01E0\x05\xa7S\x02\u01E0\u01E1\x05\xa7S\x02\u01E1\u01E2\x05\x91H\x02\u01E2\u01E3\x05\xb7[\x02\u01E3\u01E4\x05\xa1P\x02\u01E4\u01E5\x05\xadV\x02\u01E5\u01E6\x05\xabU\x02\u01E6\u0582\x03\x02\x02\x02\u01E7\u01E8\x05\x95J\x02\u01E8\u01E9\x05\xadV\x02\u01E9\u01EA\x05\xa7S\x02\u01EA\u01EB\x05\xb9\\\x02\u01EB\u01EC\x05\xa9T\x02\u01EC\u01ED\x05\xabU\x02\u01ED\u0582\x03\x02\x02\x02\u01EE\u01EF\x05\x95J\x02\u01EF\u01F0\x05\xadV\x02\u01F0\u01F1\x05\xa9T\x02\u01F1\u01F2\x05\xa9T\x02\u01F2\u01F3\x05\xa1P\x02\u01F3\u01F4\x05\xb7[\x02\u01F4\u0582\x03\x02\x02\x02\u01F5\u01F6\x05\x95J\x02\u01F6\u01F7\x05\xadV\x02\u01F7\u01F8\x05\xabU\x02\u01F8\u01F9\x05\xabU\x02\u01F9\u01FA\x05\x99L\x02\u01FA\u01FB\x05\x95J\x02\u01FB\u01FC\x05\xb7[\x02\u01FC\u0582\x03\x02\x02\x02\u01FD\u01FE\x05\x95J\x02\u01FE\u01FF\x05\xadV\x02\u01FF\u0200\x05\xabU\x02\u0200\u0201\x05\xb7[\x02\u0201\u0202\x05\xa1P\x02\u0202\u0203\x05\xabU\x02\u0203\u0204\x05\xb9\\\x02\u0204\u0205\x05\x99L\x02\u0205\u0582\x03\x02\x02\x02\u0206\u0207\x05\x95J\x02\u0207\u0208\x05\xadV\x02\u0208\u0209\x05\xb9\\\x02\u0209\u020A\x05\xabU\x02\u020A\u020B\x05\xb7[\x02\u020B\u0582\x03\x02\x02\x02\u020C\u020D\x05\x95J\x02\u020D\u020E\x05\xb3Y\x02\u020E\u020F\x05\x99L\x02\u020F\u0210\x05\x91H\x02\u0210\u0211\x05\xb7[\x02\u0211\u0212\x05\x99L\x02\u0212\u0582\x03\x02\x02\x02\u0213\u0214\x05\x95J\x02\u0214\u0215\x05\xb9\\\x02\u0215\u0216\x05\xb3Y\x02\u0216\u0217\x05\xb3Y\x02\u0217\u0218\x05\x99L\x02\u0218\u0219\x05\xabU\x02\u0219\u021A\x05\xb7[\x02\u021A\u0582\x03\x02\x02\x02\u021B\u021C\x05\x97K\x02\u021C\u021D\x05\x91H\x02\u021D\u021E\x05\xb7[\x02\u021E\u021F\x05\x99L\x02\u021F\u0582\x03\x02\x02\x02\u0220\u0221\x05\x97K\x02\u0221\u0222\x05\x99L\x02\u0222\u0223\x05\x95J\x02\u0223\u0224\x05\xa1P\x02\u0224\u0225\x05\xa9T\x02\u0225\u0226\x05\x91H\x02\u0226\u0227\x05\xa7S\x02\u0227\u0582\x03\x02\x02\x02\u0228\u0229\x05\x97K\x02\u0229\u022A\x05\x99L\x02\u022A\u022B\x05\x95J\x02\u022B\u022C\x05\xa7S\x02\u022C\u022D\x05\x91H\x02\u022D\u022E\x05\xb3Y\x02\u022E\u022F\x05\x99L\x02\u022F\u0582\x03\x02\x02\x02\u0230\u0231\x05\x97K\x02\u0231\u0232\x05\x99L\x02\u0232\u0233\x05\x95J\x02\u0233\u0234\x05\xb3Y\x02\u0234\u0235\x05\x99L\x02\u0235\u0236\x05\xa9T\x02\u0236\u0237\x05\x99L\x02\u0237\u0238\x05\xabU\x02\u0238\u0239\x05\xb7[\x02\u0239\u0582\x03\x02\x02\x02\u023A\u023B\x05\x97K\x02\u023B\u023C\x05\x99L\x02\u023C\u023D\x05\x9bM\x02\u023D\u023E\x05\x91H\x02\u023E\u023F\x05\xb9\\\x02\u023F\u0240\x05\xa7S\x02\u0240\u0241\x05\xb7[\x02\u0241\u0582\x03\x02\x02\x02\u0242\u0243\x05\x97K\x02\u0243\u0244\x05\x99L\x02\u0244\u0245\x05\x9bM\x02\u0245\u0246\x05\x91H\x02\u0246\u0247\x05\xb9\\\x02\u0247\u0248\x05\xa7S\x02\u0248\u0249\x05\xb7[\x02\u0249\u024A\x05\xb5Z\x02\u024A\u0582\x03\x02\x02\x02\u024B\u024C\x05\x97K\x02\u024C\u024D\x05\x99L\x02\u024D\u024E\x05\x9bM\x02\u024E\u024F\x05\xa1P\x02\u024F\u0250\x05\xabU\x02\u0250\u0251\x05\x99L\x02\u0251\u0582\x03\x02\x02\x02\u0252\u0253\x05\x97K\x02\u0253\u0254\x05\x99L\x02\u0254\u0255\x05\xa7S\x02\u0255\u0256\x05\x99L\x02\u0256\u0257\x05\xb7[\x02\u0257\u0258\x05\x99L\x02\u0258\u0582\x03\x02\x02\x02\u0259\u025A\x05\x97K\x02\u025A\u025B\x05\x99L\x02\u025B\u025C\x05\xa7S\x02\u025C\u025D\x05\xa1P\x02\u025D\u025E\x05\xa9T\x02\u025E\u025F\x05\xa1P\x02\u025F\u0260\x05\xb7[\x02\u0260\u0261\x05\x99L\x02\u0261\u0262\x05\xb3Y\x02\u0262\u0582\x03\x02\x02\x02\u0263\u0264\x05\x97K\x02\u0264\u0265\x05\xa1P\x02\u0265\u0266\x05\x9bM\x02\u0266\u0267\x05\x9bM\x02\u0267\u0268\x05\x99L\x02\u0268\u0269\x05\xb3Y\x02\u0269\u026A\x05\x99L\x02\u026A\u026B\x05\xabU\x02\u026B\u026C\x05\x95J\x02\u026C\u026D\x05\x99L\x02\u026D\u0582\x03\x02\x02\x02\u026E\u026F\x05\x97K\x02\u026F\u0270\x05\xa1P\x02\u0270\u0271\x05\xb5Z\x02\u0271\u0272\x05\xb7[\x02\u0272\u0273\x05\xa1P\x02\u0273\u0274\x05\xabU\x02\u0274\u0275\x05\x95J\x02\u0275\u0276\x05\xb7[\x02\u0276\u0582\x03\x02\x02\x02\u0277\u0278\x05\x97K\x02\u0278\u0279\x05\xa1P\x02\u0279\u027A\x05\xbb]\x02\u027A\u027B\x05\xa1P\x02\u027B\u027C\x05\x97K\x02\u027C\u027D\x05\x99L\x02\u027D\u0582\x03\x02\x02\x02\u027E\u027F\x05\x97K\x02\u027F\u0280\x05\xadV\x02\u0280\u0582\x03\x02\x02\x02\u0281\u0282\x05\x97K\x02\u0282\u0283\x05\xadV\x02\u0283\u0284\x05\xb9\\\x02\u0284\u0285\x05\x93I\x02\u0285\u0286\x05\xa7S\x02\u0286\u0287\x05\x99L\x02\u0287\u0582\x03\x02\x02\x02\u0288\u0289\x05\x97K\x02\u0289\u028A\x05\xb3Y\x02\u028A\u028B\x05\xadV\x02\u028B\u028C\x05\xafW\x02\u028C\u0582\x03\x02\x02\x02\u028D\u028E\x05\x99L\x02\u028E\u028F\x05\xa7S\x02\u028F\u0290\x05\xb5Z\x02\u0290\u0291\x05\x99L\x02\u0291\u0582\x03\x02\x02\x02\u0292\u0293\x05\x99L\x02\u0293\u0294\x05\xabU\x02\u0294\u0295\x05\x95J\x02\u0295\u0296\x05\xadV\x02\u0296\u0297\x05\x97K\x02\u0297\u0298\x05\xa1P\x02\u0298\u0299\x05\xabU\x02\u0299\u029A\x05\x9dN\x02\u029A\u0582\x03\x02\x02\x02\u029B\u029C\x05\x99L\x02\u029C\u029D\x05\xabU\x02\u029D\u029E\x05\x97K\x02\u029E\u0582\x03\x02\x02\x02\u029F\u02A0\x05\x99L\x02\u02A0\u02A1\x05\xb1X\x02\u02A1\u02A2\x05\xb9\\\x02\u02A2\u02A3\x05\x91H\x02\u02A3\u02A4\x05\xa7S\x02\u02A4\u02A5\x05\xb5Z\x02\u02A5\u0582\x03\x02\x02\x02\u02A6\u02A7\x05\x99L\x02\u02A7\u02A8\x05\xb5Z\x02\u02A8\u02A9\x05\x95J\x02\u02A9\u02AA\x05\x91H\x02\u02AA\u02AB\x05\xafW\x02\u02AB\u02AC\x05\x99L\x02\u02AC\u0582\x03\x02\x02\x02\u02AD\u02AE\x05\x99L\x02\u02AE\u02AF\x05\xbf_\x02\u02AF\u02B0\x05\x95J\x02\u02B0\u02B1\x05\xa7S\x02\u02B1\u02B2\x05\xb9\\\x02\u02B2\u02B3\x05\xb5Z\x02\u02B3\u02B4\x05\xa1P\x02\u02B4\u02B5\x05\xbb]\x02\u02B5\u02B6\x05\x99L\x02\u02B6\u0582\x03\x02\x02\x02\u02B7\u02B8\x05\x99L\x02\u02B8\u02B9\x05\xbf_\x02\u02B9\u02BA\x05\x99L\x02\u02BA\u02BB\x05\x95J\x02\u02BB\u0582\x03\x02\x02\x02\u02BC\u02BD\x05\x99L\x02\u02BD\u02BE\x05\xbf_\x02\u02BE\u02BF\x05\x99L\x02\u02BF\u02C0\x05\x95J\x02\u02C0\u02C1\x05\xb9\\\x02\u02C1\u02C2\x05\xb7[\x02\u02C2\u02C3\x05\x99L\x02\u02C3\u0582\x03\x02\x02\x02\u02C4\u02C5\x05\x99L\x02\u02C5\u02C6\x05\xbf_\x02\u02C6\u02C7\x05\xa1P\x02\u02C7\u02C8\x05\xb5Z\x02\u02C8\u02C9\x05\xb7[\x02\u02C9\u02CA\x05\xb5Z\x02\u02CA\u0582\x03\x02\x02\x02\u02CB\u02CC\x05\x99L\x02\u02CC\u02CD\x05\xbf_\x02\u02CD\u02CE\x05\xafW\x02\u02CE\u02CF\x05\xa7S\x02\u02CF\u02D0\x05\x91H\x02\u02D0\u02D1\x05\xa1P\x02\u02D1\u02D2\x05\xabU\x02\u02D2\u0582\x03\x02\x02\x02\u02D3\u02D4\x05\x9bM\x02\u02D4\u02D5\x05\x91H\x02\u02D5\u02D6\x05\xa7S\x02\u02D6\u02D7\x05\xb5Z\x02\u02D7\u02D8\x05\x99L\x02\u02D8\u0582\x03\x02\x02\x02\u02D9\u02DA\x05\x9bM\x02\u02DA\u02DB\x05\x99L\x02\u02DB\u02DC\x05\xb7[\x02\u02DC\u02DD\x05\x95J\x02\u02DD\u02DE\x05\x9fO\x02\u02DE\u0582\x03\x02\x02\x02\u02DF\u02E0\x05\x9bM\x02\u02E0\u02E1\x05\xa1P\x02\u02E1\u02E2\x05\xa7S\x02\u02E2\u02E3\x05\x99L\x02\u02E3\u0582\x03\x02\x02\x02\u02E4\u02E5\x05\x9bM\x02\u02E5\u02E6\x05\xa1P\x02\u02E6\u02E7\x05\x99L\x02\u02E7\u02E8\x05\xa7S\x02\u02E8\u02E9\x05\x97K\x02\u02E9\u0582\x03\x02\x02\x02\u02EA\u02EB\x05\x9bM\x02\u02EB\u02EC\x05\xa1P\x02\u02EC\u02ED\x05\xb3Y\x02\u02ED\u02EE\x05\xb5Z\x02\u02EE\u02EF\x05\xb7[\x02\u02EF\u0582\x03\x02\x02\x02\u02F0\u02F1\x05\x9bM\x02\u02F1\u02F2\x05\xa7S\x02\u02F2\u02F3\x05\xadV\x02\u02F3\u02F4\x05\x91H\x02\u02F4\u02F5\x05\xb7[\x02\u02F5\u0582\x03\x02\x02\x02\u02F6\u02F7\x05\x9bM\x02\u02F7\u02F8\x05\xadV\x02\u02F8\u02F9\x05\xb3Y\x02\u02F9\u0582\x03\x02\x02\x02\u02FA\u02FB\x05\x9bM\x02\u02FB\u02FC\x05\xb9\\\x02\u02FC\u02FD\x05\xabU\x02\u02FD\u02FE\x05\x95J\x02\u02FE\u02FF\x05\xb7[\x02\u02FF\u0300\x05\xa1P\x02\u0300\u0301\x05\xadV\x02\u0301\u0302\x05\xabU\x02\u0302\u0582\x03\x02\x02\x02\u0303\u0304\x05\x9dN\x02\u0304\u0305\x05\xadV\x02\u0305\u0582\x03\x02\x02\x02\u0306\u0307\x05\x9dN\x02\u0307\u0308\x05\xadV\x02\u0308\u0309\x05\xb7[\x02\u0309\u030A\x05\xadV\x02\u030A\u0582\x03\x02\x02\x02\u030B\u030C\x05\x9dN\x02\u030C\u030D\x05\xb3Y\x02\u030D\u030E\x05\x91H\x02\u030E\u030F\x05\xabU\x02\u030F\u0310\x05\xb7[\x02\u0310\u0582\x03\x02\x02\x02\u0311\u0312\x05\x9dN\x02\u0312\u0313\x05\xb3Y\x02\u0313\u0314\x05\x99L\x02\u0314\u0315\x05\x91H\x02\u0315\u0316\x05\xb7[\x02\u0316\u0317\x05\x99L\x02\u0317\u0318\x05\xb3Y\x02\u0318\u0582\x03\x02\x02\x02\u0319\u031A\x05\x9dN\x02\u031A\u031B\x05\xb3Y\x02\u031B\u031C\x05\xadV\x02\u031C\u031D\x05\xb9\\\x02\u031D\u031E\x05\xafW\x02\u031E\u0582\x03\x02\x02\x02\u031F\u0320\x05\x9fO\x02\u0320\u0321\x05\x91H\x02\u0321\u0322\x05\xbb]\x02\u0322\u0323\x05\xa1P\x02\u0323\u0324\x05\xabU\x02\u0324\u0325\x05\x9dN\x02\u0325\u0582\x03\x02\x02\x02\u0326\u0327\x05\xa1P\x02\u0327\u0328\x05\x97K\x02\u0328\u0329\x05\x99L\x02\u0329\u032A\x05\xabU\x02\u032A\u032B\x05\xb7[\x02\u032B\u032C\x05\xa1P\x02\u032C\u032D\x05\x9bM\x02\u032D\u032E\x05\xa1P\x02\u032E\u032F\x05\x99L\x02\u032F\u0330\x05\x97K\x02\u0330\u0582\x03\x02\x02\x02\u0331\u0332\x05\xa1P\x02\u0332\u0333\x05\x9bM\x02\u0333\u0582\x03\x02\x02\x02\u0334\u0335\x05\xa1P\x02\u0335\u0336\x05\xa9T\x02\u0336\u0337\x05\xa9T\x02\u0337\u0338\x05\x99L\x02\u0338\u0339\x05\x97K\x02\u0339\u033A\x05\xa1P\x02\u033A\u033B\x05\x91H\x02\u033B\u033C\x05\xb7[\x02\u033C\u033D\x05\x99L\x02\u033D\u0582\x03\x02\x02\x02\u033E\u033F\x05\xa1P\x02\u033F\u0340\x05\xabU\x02\u0340\u0341\x05\x95J\x02\u0341\u0342\x05\xb3Y\x02\u0342\u0343\x05\x99L\x02\u0343\u0344\x05\xa9T\x02\u0344\u0345\x05\x99L\x02\u0345\u0346\x05\xabU\x02\u0346\u0347\x05\xb7[\x02\u0347\u0582\x03\x02\x02\x02\u0348\u0349\x05\xa1P\x02\u0349\u034A\x05\xabU\x02\u034A\u034B\x05\x97K\x02\u034B\u034C\x05\x99L\x02\u034C\u034D\x05\xbf_\x02\u034D\u0582\x03\x02\x02\x02\u034E\u034F\x05\xa1P\x02\u034F\u0350\x05\xabU\x02\u0350\u0351\x05\xa1P\x02\u0351\u0352\x05\xb7[\x02\u0352\u0353\x05\xa1P\x02\u0353\u0354\x05\x91H\x02\u0354\u0355\x05\xa7S\x02\u0355\u0582\x03\x02\x02\x02\u0356\u0357\x05\xa1P\x02\u0357\u0358\x05\xabU\x02\u0358\u0359\x05\xabU\x02\u0359\u035A\x05\x99L\x02\u035A\u035B\x05\xb3Y\x02\u035B\u0582\x03\x02\x02\x02\u035C\u035D\x05\xa1P\x02\u035D\u035E\x05\xabU\x02\u035E\u035F\x05\xadV\x02\u035F\u0360\x05\xb9\\\x02\u0360\u0361\x05\xb7[\x02\u0361\u0582\x03\x02\x02\x02\u0362\u0363\x05\xa1P\x02\u0363\u0364\x05\xabU\x02\u0364\u0365\x05\xafW\x02\u0365\u0366\x05\xb9\\\x02\u0366\u0367\x05\xb7[\x02\u0367\u0582\x03\x02\x02\x02\u0368\u0369\x05\xa1P\x02\u0369\u036A\x05\xabU\x02\u036A\u036B\x05\xb5Z\x02\u036B\u036C\x05\x99L\x02\u036C\u036D\x05\xb3Y\x02\u036D\u036E\x05\xb7[\x02\u036E\u0582\x03\x02\x02\x02\u036F\u0370\x05\xa1P\x02\u0370\u0371\x05\xabU\x02\u0371\u0372\x05\xb7[\x02\u0372\u0582\x03\x02\x02\x02\u0373\u0374\x05\xa1P\x02\u0374\u0375\x05\xabU\x02\u0375\u0376\x05\xb7[\x02\u0376\u0377\x05\x99L\x02\u0377\u0378\x05\x9dN\x02\u0378\u0379\x05\x99L\x02\u0379\u037A\x05\xb3Y\x02\u037A\u0582\x03\x02\x02\x02\u037B\u037C\x05\xa1P\x02\u037C\u037D\x05\xabU\x02\u037D\u037E\x05\xb7[\x02\u037E\u037F\x05\x99L\x02\u037F\u0380\x05\xb3Y\x02\u0380\u0381\x05\xb5Z\x02\u0381\u0382\x05\x99L\x02\u0382\u0383\x05\x95J\x02\u0383\u0384\x05\xb7[\x02\u0384\u0582\x03\x02\x02\x02\u0385\u0386\x05\xa1P\x02\u0386\u0387\x05\xabU\x02\u0387\u0388\x05\xb7[\x02\u0388\u0389\x05\x99L\x02\u0389\u038A\x05\xb3Y\x02\u038A\u038B\x05\xb5Z\x02\u038B\u038C\x05\x99L\x02\u038C\u038D\x05\x95J\x02\u038D\u038E\x05\xb7[\x02\u038E\u038F\x05\xa1P\x02\u038F\u0390\x05\xadV\x02\u0390\u0391\x05\xabU\x02\u0391\u0582\x03\x02\x02\x02\u0392\u0393\x05\xa1P\x02\u0393\u0394\x05\xabU\x02\u0394\u0395\x05\xb7[\x02\u0395\u0396\x05\xadV\x02\u0396\u0582\x03\x02\x02\x02\u0397\u0398\x05\xa1P\x02\u0398\u0399\x05\xb5Z\x02\u0399\u039A\x05\x99L\x02\u039A\u039B\x05\xa9T\x02\u039B\u039C\x05\xafW\x02\u039C\u039D\x05\xb7[\x02\u039D\u039E\x05\xc1`\x02\u039E\u0582\x03\x02\x02\x02\u039F\u03A0\x05\xa1P\x02\u03A0\u03A1\x05\xb5Z\x02\u03A1\u03A2\x05\xabU\x02\u03A2\u03A3\x05\xb9\\\x02\u03A3\u03A4\x05\xa7S\x02\u03A4\u03A5\x05\xa7S\x02\u03A5\u0582\x03\x02\x02\x02\u03A6\u03A7\x05\xa3Q\x02\u03A7\u03A8\x05\xadV\x02\u03A8\u03A9\x05\xa1P\x02\u03A9\u03AA\x05\xabU\x02\u03AA\u0582\x03\x02\x02\x02\u03AB\u03AC\x05\xa7S\x02\u03AC\u03AD\x05\x91H\x02\u03AD\u03AE\x05\xb5Z\x02\u03AE\u03AF\x05\xb7[\x02\u03AF\u0582\x03\x02\x02\x02\u03B0\u03B1\x05\xa7S\x02\u03B1\u03B2\x05\x99L\x02\u03B2\u03B3\x05\x9bM\x02\u03B3\u03B4\x05\xb7[\x02\u03B4\u0582\x03\x02\x02\x02\u03B5\u03B6\x05\xa7S\x02\u03B6\u03B7\x05\x99L\x02\u03B7\u03B8\x05\xb5Z\x02\u03B8\u03B9\x05\xb5Z\x02\u03B9\u0582\x03\x02\x02\x02\u03BA\u03BB\x05\xa7S\x02\u03BB\u03BC\x05\xa1P\x02\u03BC\u03BD\x05\xa5R\x02\u03BD\u03BE\x05\x99L\x02\u03BE\u0582\x03\x02\x02\x02\u03BF\u03C0\x05\xa7S\x02\u03C0\u03C1\x05\xa1P\x02\u03C1\u03C2\x05\xa9T\x02\u03C2\u03C3\x05\xa1P\x02\u03C3\u03C4\x05\xb7[\x02\u03C4\u0582\x03\x02\x02\x02\u03C5\u03C6\x05\xa7S\x02\u03C6\u03C7\x05\xadV\x02\u03C7\u03C8\x05\x95J\x02\u03C8\u03C9\x05\xa5R\x02\u03C9\u0582\x03\x02\x02\x02\u03CA\u03CB\x05\xa7S\x02\u03CB\u03CC\x05\xadV\x02\u03CC\u03CD\x05\xabU\x02\u03CD\u03CE\x05\x9dN\x02\u03CE\u0582\x03\x02\x02\x02\u03CF\u03D0\x05\xa9T\x02\u03D0\u03D1\x05\x91H\x02\u03D1\u03D2\x05\xbf_\x02\u03D2\u0582\x03\x02\x02\x02\u03D3\u03D4\x05\xa9T\x02\u03D4\u03D5\x05\xa1P\x02\u03D5\u03D6\x05\xabU\x02\u03D6\u0582\x03\x02\x02\x02\u03D7\u03D8\x05\xa9T\x02\u03D8\u03D9\x05\xa1P\x02\u03D9\u03DA\x05\xabU\x02\u03DA\u03DB\x05\xb9\\\x02\u03DB\u03DC\x05\xb5Z\x02\u03DC\u0582\x03\x02\x02\x02\u03DD\u03DE\x05\xa9T\x02\u03DE\u03DF\x05\xadV\x02\u03DF\u03E0\x05\x97K\x02\u03E0\u03E1\x05\x99L\x02\u03E1\u0582\x03\x02\x02\x02\u03E2\u03E3\x05\xa9T\x02\u03E3\u03E4\x05\xadV\x02\u03E4\u03E5\x05\x97K\x02\u03E5\u03E6\x05\xa1P\x02\u03E6\u03E7\x05\x9bM\x02\u03E7\u03E8\x05\xc1`\x02\u03E8\u0582\x03\x02\x02\x02\u03E9\u03EA\x05\xa9T\x02\u03EA\u03EB\x05\xadV\x02\u03EB\u03EC\x05\x97K\x02\u03EC\u03ED\x05\xb9\\\x02\u03ED\u03EE\x05\xa7S\x02\u03EE\u03EF\x05\xadV\x02\u03EF\u0582\x03\x02\x02\x02\u03F0\u03F1\x05\xa9T\x02\u03F1\u03F2\x05\xadV\x02\u03F2\u03F3\x05\xb3Y\x02\u03F3\u03F4\x05\x99L\x02\u03F4\u0582\x03\x02\x02\x02\u03F5\u03F6\x05\xa9T\x02\u03F6\u03F7\x05\xb9\\\x02\u03F7\u03F8\x05\xa7S\x02\u03F8\u03F9\x05\xb7[\x02\u03F9\u03FA\x05\xa1P\x02\u03FA\u03FB\x05\xafW\x02\u03FB\u03FC\x05\xa7S\x02\u03FC\u03FD\x05\xc1`\x02\u03FD\u0582\x03\x02\x02\x02\u03FE\u03FF\x05\xabU\x02\u03FF\u0400\x05\x99L\x02\u0400\u0401\x05\xbf_\x02\u0401\u0402\x05\xb7[\x02\u0402\u0582\x03\x02\x02\x02\u0403\u0404\x05\xabU\x02\u0404\u0405\x05\xadV\x02\u0405\u0406\x05\x91H\x02\u0406\u0407\x05\xb9\\\x02\u0407\u0408\x05\x97K\x02\u0408\u0409\x05\xa1P\x02\u0409\u040A\x05\xb7[\x02\u040A\u0582\x03\x02\x02\x02\u040B\u040C\x05\xabU\x02\u040C\u040D\x05\xadV\x02\u040D\u040E\x05\xb7[\x02\u040E\u040F\x05\xa1P\x02\u040F\u0410\x05\xabU\x02\u0410\u0582\x03\x02\x02\x02\u0411\u0412\x05\xabU\x02\u0412\u0413\x05\xadV\x02\u0413\u0414\x05\xbd^\x02\u0414\u0415\x05\x91H\x02\u0415\u0416\x05\xa1P\x02\u0416\u0417\x05\xb7[\x02\u0417\u0582\x03\x02\x02\x02\u0418\u0419\x05\xabU\x02\u0419\u041A\x05\xb9\\\x02\u041A\u041B\x05\xa9T\x02\u041B\u041C\x05\x93I\x02\u041C\u041D\x05\x99L\x02\u041D\u041E\x05\xb3Y\x02\u041E\u0582\x03\x02\x02\x02\u041F\u0420\x05\xadV\x02\u0420\u0421\x05\x93I\x02\u0421\u0422\x05\xa3Q\x02\u0422\u0423\x05\x99L\x02\u0423\u0424\x05\x95J\x02\u0424\u0425\x05\xb7[\x02\u0425\u0582\x03\x02\x02\x02\u0426\u0427\x05\xadV\x02\u0427\u0428\x05\x9bM\x02\u0428\u0582\x03\x02\x02\x02\u0429\u042A\x05\xadV\x02\u042A\u042B\x05\xafW\x02\u042B\u042C\x05\xb7[\x02\u042C\u042D\x05\xa1P\x02\u042D\u042E\x05\xadV\x02\u042E\u042F\x05\xabU\x02\u042F\u0582\x03\x02\x02\x02\u0430\u0431\x05\xadV\x02\u0431\u0432\x05\xb9\\\x02\u0432\u0433\x05\xb7[\x02\u0433\u0434\x05\x99L\x02\u0434\u0435\x05\xb3Y\x02\u0435\u0582\x03\x02\x02\x02\u0436\u0437\x05\xadV\x02\u0437\u0438\x05\xb9\\\x02\u0438\u0439\x05\xb7[\x02\u0439\u043A\x05\xafW\x02\u043A\u043B\x05\xb9\\\x02\u043B\u043C\x05\xb7[\x02\u043C\u0582\x03\x02\x02\x02\u043D\u043E\x05\xafW\x02\u043E\u043F\x05\xadV\x02\u043F\u0440\x05\xbd^\x02\u0440\u0441\x05\x99L\x02\u0441\u0442\x05";
    }
    static{
        this._serializedATNSegment2 = '\xb3Y\x02\u0442\u0582\x03\x02\x02\x02\u0443\u0444\x05\xafW\x02\u0444\u0445\x05\xb3Y\x02\u0445\u0446\x05\x99L\x02\u0446\u0447\x05\xbb]\x02\u0447\u0448\x05\xa1P\x02\u0448\u0449\x05\xadV\x02\u0449\u044A\x05\xb9\\\x02\u044A\u044B\x05\xb5Z\x02\u044B\u0582\x03\x02\x02\x02\u044C\u044D\x05\xafW\x02\u044D\u044E\x05\xb3Y\x02\u044E\u044F\x05\xa1P\x02\u044F\u0450\x05\xadV\x02\u0450\u0451\x05\xb3Y\x02\u0451\u0582\x03\x02\x02\x02\u0452\u0453\x05\xafW\x02\u0453\u0454\x05\xb3Y\x02\u0454\u0455\x05\xa1P\x02\u0455\u0456\x05\xbb]\x02\u0456\u0457\x05\xa1P\x02\u0457\u0458\x05\xa7S\x02\u0458\u0459\x05\x99L\x02\u0459\u045A\x05\x9dN\x02\u045A\u045B\x05\x99L\x02\u045B\u045C\x05\xb5Z\x02\u045C\u0582\x03\x02\x02\x02\u045D\u045E\x05\xafW\x02\u045E\u045F\x05\xb9\\\x02\u045F\u0460\x05\x93I\x02\u0460\u0461\x05\xa7S\x02\u0461\u0462\x05\xa1P\x02\u0462\u0463\x05\x95J\x02\u0463\u0582\x03\x02\x02\x02\u0464\u0465\x05\xb3Y\x02\u0465\u0466\x05\x91H\x02\u0466\u0467\x05\xa1P\x02\u0467\u0468\x05\xb5Z\x02\u0468\u0469\x05\x99L\x02\u0469\u0582\x03\x02\x02\x02\u046A\u046B\x05\xb3Y\x02\u046B\u046C\x05\x91H\x02\u046C\u046D\x05\xbd^\x02\u046D\u0582\x03\x02\x02\x02\u046E\u046F\x05\xb3Y\x02\u046F\u0470\x05\x99L\x02\u0470\u0471\x05\xa9T\x02\u0471\u0472\x05\x91H\x02\u0472\u0473\x05\xa1P\x02\u0473\u0474\x05\xabU\x02\u0474\u0475\x05\x97K\x02\u0475\u0476\x05\x99L\x02\u0476\u0477\x05\xb3Y\x02\u0477\u0582\x03\x02\x02\x02\u0478\u0479\x05\xb3Y\x02\u0479\u047A\x05\x99L\x02\u047A\u047B\x05\xabU\x02\u047B\u047C\x05\x91H\x02\u047C\u047D\x05\xa9T\x02\u047D\u047E\x05\x99L\x02\u047E\u0582\x03\x02\x02\x02\u047F\u0480\x05\xb3Y\x02\u0480\u0481\x05\x99L\x02\u0481\u0482\x05\xb5Z\x02\u0482\u0483\x05\xadV\x02\u0483\u0484\x05\xb9\\\x02\u0484\u0485\x05\xb3Y\x02\u0485\u0486\x05\x95J\x02\u0486\u0487\x05\x99L\x02\u0487\u0582\x03\x02\x02\x02\u0488\u0489\x05\xb3Y\x02\u0489\u048A\x05\x99L\x02\u048A\u048B\x05\xb7[\x02\u048B\u048C\x05\xb9\\\x02\u048C\u048D\x05\xb3Y\x02\u048D\u048E\x05\xabU\x02\u048E\u0582\x03\x02\x02\x02\u048F\u0490\x05\xb3Y\x02\u0490\u0491\x05\x99L\x02\u0491\u0492\x05\xb7[\x02\u0492\u0493\x05\xb9\\\x02\u0493\u0494\x05\xb3Y\x02\u0494\u0495\x05\xabU\x02\u0495\u0496\x05\xb5Z\x02\u0496\u0582\x03\x02\x02\x02\u0497\u0498\x05\xb3Y\x02\u0498\u0499\x05\x99L\x02\u0499\u049A\x05\xbb]\x02\u049A\u049B\x05\xadV\x02\u049B\u049C\x05\xa5R\x02\u049C\u049D\x05\x99L\x02\u049D\u0582\x03\x02\x02\x02\u049E\u049F\x05\xb3Y\x02\u049F\u04A0\x05\xa1P\x02\u04A0\u04A1\x05\x9dN\x02\u04A1\u04A2\x05\x9fO\x02\u04A2\u04A3\x05\xb7[\x02\u04A3\u0582\x03\x02\x02\x02\u04A4\u04A5\x05\xb3Y\x02\u04A5\u04A6\x05\xadV\x02\u04A6\u04A7\x05\xbd^\x02\u04A7\u0582\x03\x02\x02\x02\u04A8\u04A9\x05\xb3Y\x02\u04A9\u04AA\x05\xadV\x02\u04AA\u04AB\x05\xbd^\x02\u04AB\u04AC\x05\xa1P\x02\u04AC\u04AD\x05\x97K\x02\u04AD\u0582\x03\x02\x02\x02\u04AE\u04AF\x05\xb3Y\x02\u04AF\u04B0\x05\xadV\x02\u04B0\u04B1\x05\xbd^\x02\u04B1\u04B2\x05\xabU\x02\u04B2\u04B3\x05\xb9\\\x02\u04B3\u04B4\x05\xa9T\x02\u04B4\u0582\x03\x02\x02\x02\u04B5\u04B6\x05\xb3Y\x02\u04B6\u04B7\x05\xadV\x02\u04B7\u04B8\x05\xbd^\x02\u04B8\u04B9\x05\xb5Z\x02\u04B9\u0582\x03\x02\x02\x02\u04BA\u04BB\x05\xb5Z\x02\u04BB\u04BC\x05\x99L\x02\u04BC\u04BD\x05\xa7S\x02\u04BD\u04BE\x05\x99L\x02\u04BE\u04BF\x05\x95J\x02\u04BF\u04C0\x05\xb7[\x02\u04C0\u0582\x03\x02\x02\x02\u04C1\u04C2\x05\xb5Z\x02\u04C2\u04C3\x05\x99L\x02\u04C3\u04C4\x05\xb5Z\x02\u04C4\u04C5\x05\xb5Z\x02\u04C5\u04C6\x05\xa1P\x02\u04C6\u04C7\x05\xadV\x02\u04C7\u04C8\x05\xabU\x02\u04C8\u0582\x03\x02\x02\x02\u04C9\u04CA\x05\xb5Z\x02\u04CA\u04CB\x05\x99L\x02\u04CB\u04CC\x05\xb7[\x02\u04CC\u0582\x03\x02\x02\x02\u04CD\u04CE\x05\xb5Z\x02\u04CE\u04CF\x05\x9fO\x02\u04CF\u04D0\x05\x91H\x02\u04D0\u04D1\x05\xb3Y\x02\u04D1\u04D2\x05\x99L\x02\u04D2\u0582\x03\x02\x02\x02\u04D3\u04D4\x05\xb5Z\x02\u04D4\u04D5\x05\xa1P\x02\u04D5\u04D6\x05\xc3a\x02\u04D6\u04D7\x05\x99L\x02\u04D7\u0582\x03\x02\x02\x02\u04D8\u04D9\x05\xb5Z\x02\u04D9\u04DA\x05\xb1X\x02\u04DA\u04DB\x05\xb3Y\x02\u04DB\u04DC\x05\xb7[\x02\u04DC\u0582\x03\x02\x02\x02\u04DD\u04DE\x05\xb5Z\x02\u04DE\u04DF\x05\xb7[\x02\u04DF\u04E0\x05\x91H\x02\u04E0\u04E1\x05\xb3Y\x02\u04E1\u04E2\x05\xb7[\x02\u04E2\u0582\x03\x02\x02\x02\u04E3\u04E4\x05\xb5Z\x02\u04E4\u04E5\x05\xb7[\x02\u04E5\u04E6\x05\xb3Y\x02\u04E6\u04E7\x05\xa1P\x02\u04E7\u04E8\x05\x95J\x02\u04E8\u04E9\x05\xb7[\x02\u04E9\u0582\x03\x02\x02\x02\u04EA\u04EB\x05\xb5Z\x02\u04EB\u04EC\x05\xb7[\x02\u04EC\u04ED\x05\xb3Y\x02\u04ED\u04EE\x05\xa1P\x02\u04EE\u04EF\x05\xabU\x02\u04EF\u04F0\x05\x9dN\x02\u04F0\u0582\x03\x02\x02\x02\u04F1\u04F2\x05\xb5Z\x02\u04F2\u04F3\x05\xb9\\\x02\u04F3\u04F4\x05\x93I\x02\u04F4\u04F5\x05\xb7[\x02\u04F5\u04F6\x05\xb3Y\x02\u04F6\u04F7\x05\x91H\x02\u04F7\u04F8\x05\x95J\x02\u04F8\u04F9\x05\xb7[\x02\u04F9\u0582\x03\x02\x02\x02\u04FA\u04FB\x05\xb5Z\x02\u04FB\u04FC\x05\xb9\\\x02\u04FC\u04FD\x05\xa9T\x02\u04FD\u0582\x03\x02\x02\x02\u04FE\u04FF\x05\xb5Z\x02\u04FF\u0500\x05\xc1`\x02\u0500\u0501\x05\xabU\x02\u0501\u0502\x05\xadV\x02\u0502\u0503\x05\xabU\x02\u0503\u0504\x05\xc1`\x02\u0504\u0505\x05\xa9T\x02\u0505\u0582\x03\x02\x02\x02\u0506\u0507\x05\xb7[\x02\u0507\u0508\x05\x91H\x02\u0508\u0509\x05\x93I\x02\u0509\u050A\x05\xa7S\x02\u050A\u050B\x05\x99L\x02\u050B\u0582\x03\x02\x02\x02\u050C\u050D\x05\xb7[\x02\u050D\u050E\x05\x9fO\x02\u050E\u050F\x05\x99L\x02\u050F\u0510\x05\xabU\x02\u0510\u0582\x03\x02\x02\x02\u0511\u0512\x05\xb7[\x02\u0512\u0513\x05\xb3Y\x02\u0513\u0514\x05\x91H\x02\u0514\u0515\x05\xabU\x02\u0515\u0516\x05\xb5Z\x02\u0516\u0582\x03\x02\x02\x02\u0517\u0518\x05\xb7[\x02\u0518\u0519\x05\xb3Y\x02\u0519\u051A\x05\x91H\x02\u051A\u051B\x05\xabU\x02\u051B\u051C\x05\xb5Z\x02\u051C\u051D\x05\x91H\x02\u051D\u051E\x05\x95J\x02\u051E\u051F\x05\xb7[\x02\u051F\u0520\x05\xa1P\x02\u0520\u0521\x05\xadV\x02\u0521\u0522\x05\xabU\x02\u0522\u0582\x03\x02\x02\x02\u0523\u0524\x05\xb7[\x02\u0524\u0525\x05\xb3Y\x02\u0525\u0526\x05\xa1P\x02\u0526\u0527\x05\x9dN\x02\u0527\u0528\x05\x9dN\x02\u0528\u0529\x05\x99L\x02\u0529\u052A\x05\xb3Y\x02\u052A\u0582\x03\x02\x02\x02\u052B\u052C\x05\xb7[\x02\u052C\u052D\x05\xb3Y\x02\u052D\u052E\x05\xb9\\\x02\u052E\u052F\x05\x99L\x02\u052F\u0582\x03\x02\x02\x02\u0530\u0531\x05\xb9\\\x02\u0531\u0532\x05\xa1P\x02\u0532\u0533\x05\x97K\x02\u0533\u0582\x03\x02\x02\x02\u0534\u0535\x05\xb9\\\x02\u0535\u0536\x05\xabU\x02\u0536\u0537\x05\xa1P\x02\u0537\u0538\x05\xadV\x02\u0538\u0539\x05\xabU\x02\u0539\u0582\x03\x02\x02\x02\u053A\u053B\x05\xb9\\\x02\u053B\u053C\x05\xabU\x02\u053C\u053D\x05\xa1P\x02\u053D\u053E\x05\xb1X\x02\u053E\u053F\x05\xb9\\\x02\u053F\u0540\x05\x99L\x02\u0540\u0582\x03\x02\x02\x02\u0541\u0542\x05\xb9\\\x02\u0542\u0543\x05\xafW\x02\u0543\u0544\x05\x97K\x02\u0544\u0545\x05\x91H\x02\u0545\u0546\x05\xb7[\x02\u0546\u0547\x05\x99L\x02\u0547\u0582\x03\x02\x02\x02\u0548\u0549\x05\xb9\\\x02\u0549\u054A\x05\xb5Z\x02\u054A\u054B\x05\x99L\x02\u054B\u054C\x05\xb3Y\x02\u054C\u0582\x03\x02\x02\x02\u054D\u054E\x05\xbb]\x02\u054E\u054F\x05\x91H\x02\u054F\u0550\x05\xa7S\x02\u0550\u0551\x05\xa1P\x02\u0551\u0552\x05\x97K\x02\u0552\u0553\x05\x91H\x02\u0553\u0554\x05\xb7[\x02\u0554\u0555\x05\x99L\x02\u0555\u0582\x03\x02\x02\x02\u0556\u0557\x05\xbb]\x02\u0557\u0558\x05\x91H\x02\u0558\u0559\x05\xa7S\x02\u0559\u055A\x05\xb9\\\x02\u055A\u055B\x05\x99L\x02\u055B\u055C\x05\xb5Z\x02\u055C\u0582\x03\x02\x02\x02\u055D\u055E\x05\xbb]\x02\u055E\u055F\x05\xa1P\x02\u055F\u0560\x05\x99L\x02\u0560\u0561\x05\xbd^\x02\u0561\u0582\x03\x02\x02\x02\u0562\u0563\x05\xbd^\x02\u0563\u0564\x05\x9fO\x02\u0564\u0565\x05\x99L\x02\u0565\u0566\x05\xabU\x02\u0566\u0582\x03\x02\x02\x02\u0567\u0568\x05\xbd^\x02\u0568\u0569\x05\x9fO\x02\u0569\u056A\x05\x99L\x02\u056A\u056B\x05\xabU\x02\u056B\u056C\x05\x99L\x02\u056C\u056D\x05\xbb]\x02\u056D\u056E\x05\x99L\x02\u056E\u056F\x05\xb3Y\x02\u056F\u0582\x03\x02\x02\x02\u0570\u0571\x05\xbd^\x02\u0571\u0572\x05\x9fO\x02\u0572\u0573\x05\x99L\x02\u0573\u0574\x05\xb3Y\x02\u0574\u0575\x05\x99L\x02\u0575\u0582\x03\x02\x02\x02\u0576\u0577\x05\xbd^\x02\u0577\u0578\x05\x9fO\x02\u0578\u0579\x05\xa1P\x02\u0579\u057A\x05\xa7S\x02\u057A\u057B\x05\x99L\x02\u057B\u0582\x03\x02\x02\x02\u057C\u057D\x05\xbd^\x02\u057D\u057E\x05\xa1P\x02\u057E\u057F\x05\xb7[\x02\u057F\u0580\x05\x9fO\x02\u0580\u0582\x03\x02\x02\x02\u0581\u0160\x03\x02\x02\x02\u0581\u0166\x03\x02\x02\x02\u0581\u016D\x03\x02\x02\x02\u0581\u0171\x03\x02\x02\x02\u0581\u0177\x03\x02\x02\x02\u0581\u017D\x03\x02\x02\x02\u0581\u0181\x03\x02\x02\x02\u0581\u0184\x03\x02\x02\x02\u0581\u018A\x03\x02\x02\x02\u0581\u018E\x03\x02\x02\x02\u0581\u0194\x03\x02\x02\x02\u0581\u019C\x03\x02\x02\x02\u0581\u01A4\x03\x02\x02\x02\u0581\u01AA\x03\x02\x02\x02\u0581\u01AF\x03\x02\x02\x02\u0581\u01B5\x03\x02\x02\x02\u0581\u01BA\x03\x02\x02\x02\u0581\u01C4\x03\x02\x02\x02\u0581\u01CA\x03\x02\x02\x02\u0581\u01D5\x03\x02\x02\x02\u0581\u01DD\x03\x02\x02\x02\u0581\u01E7\x03\x02\x02\x02\u0581\u01EE\x03\x02\x02\x02\u0581\u01F5\x03\x02\x02\x02\u0581\u01FD\x03\x02\x02\x02\u0581\u0206\x03\x02\x02\x02\u0581\u020C\x03\x02\x02\x02\u0581\u0213\x03\x02\x02\x02\u0581\u021B\x03\x02\x02\x02\u0581\u0220\x03\x02\x02\x02\u0581\u0228\x03\x02\x02\x02\u0581\u0230\x03\x02\x02\x02\u0581\u023A\x03\x02\x02\x02\u0581\u0242\x03\x02\x02\x02\u0581\u024B\x03\x02\x02\x02\u0581\u0252\x03\x02\x02\x02\u0581\u0259\x03\x02\x02\x02\u0581\u0263\x03\x02\x02\x02\u0581\u026E\x03\x02\x02\x02\u0581\u0277\x03\x02\x02\x02\u0581\u027E\x03\x02\x02\x02\u0581\u0281\x03\x02\x02\x02\u0581\u0288\x03\x02\x02\x02\u0581\u028D\x03\x02\x02\x02\u0581\u0292\x03\x02\x02\x02\u0581\u029B\x03\x02\x02\x02\u0581\u029F\x03\x02\x02\x02\u0581\u02A6\x03\x02\x02\x02\u0581\u02AD\x03\x02\x02\x02\u0581\u02B7\x03\x02\x02\x02\u0581\u02BC\x03\x02\x02\x02\u0581\u02C4\x03\x02\x02\x02\u0581\u02CB\x03\x02\x02\x02\u0581\u02D3\x03\x02\x02\x02\u0581\u02D9\x03\x02\x02\x02\u0581\u02DF\x03\x02\x02\x02\u0581\u02E4\x03\x02\x02\x02\u0581\u02EA\x03\x02\x02\x02\u0581\u02F0\x03\x02\x02\x02\u0581\u02F6\x03\x02\x02\x02\u0581\u02FA\x03\x02\x02\x02\u0581\u0303\x03\x02\x02\x02\u0581\u0306\x03\x02\x02\x02\u0581\u030B\x03\x02\x02\x02\u0581\u0311\x03\x02\x02\x02\u0581\u0319\x03\x02\x02\x02\u0581\u031F\x03\x02\x02\x02\u0581\u0326\x03\x02\x02\x02\u0581\u0331\x03\x02\x02\x02\u0581\u0334\x03\x02\x02\x02\u0581\u033E\x03\x02\x02\x02\u0581\u0348\x03\x02\x02\x02\u0581\u034E\x03\x02\x02\x02\u0581\u0356\x03\x02\x02\x02\u0581\u035C\x03\x02\x02\x02\u0581\u0362\x03\x02\x02\x02\u0581\u0368\x03\x02\x02\x02\u0581\u036F\x03\x02\x02\x02\u0581\u0373\x03\x02\x02\x02\u0581\u037B\x03\x02\x02\x02\u0581\u0385\x03\x02\x02\x02\u0581\u0392\x03\x02\x02\x02\u0581\u0397\x03\x02\x02\x02\u0581\u039F\x03\x02\x02\x02\u0581\u03A6\x03\x02\x02\x02\u0581\u03AB\x03\x02\x02\x02\u0581\u03B0\x03\x02\x02\x02\u0581\u03B5\x03\x02\x02\x02\u0581\u03BA\x03\x02\x02\x02\u0581\u03BF\x03\x02\x02\x02\u0581\u03C5\x03\x02\x02\x02\u0581\u03CA\x03\x02\x02\x02\u0581\u03CF\x03\x02\x02\x02\u0581\u03D3\x03\x02\x02\x02\u0581\u03D7\x03\x02\x02\x02\u0581\u03DD\x03\x02\x02\x02\u0581\u03E2\x03\x02\x02\x02\u0581\u03E9\x03\x02\x02\x02\u0581\u03F0\x03\x02\x02\x02\u0581\u03F5\x03\x02\x02\x02\u0581\u03FE\x03\x02\x02\x02\u0581\u0403\x03\x02\x02\x02\u0581\u040B\x03\x02\x02\x02\u0581\u0411\x03\x02\x02\x02\u0581\u0418\x03\x02\x02\x02\u0581\u041F\x03\x02\x02\x02\u0581\u0426\x03\x02\x02\x02\u0581\u0429\x03\x02\x02\x02\u0581\u0430\x03\x02\x02\x02\u0581\u0436\x03\x02\x02\x02\u0581\u043D\x03\x02\x02\x02\u0581\u0443\x03\x02\x02\x02\u0581\u044C\x03\x02\x02\x02\u0581\u0452\x03\x02\x02\x02\u0581\u045D\x03\x02\x02\x02\u0581\u0464\x03\x02\x02\x02\u0581\u046A\x03\x02\x02\x02\u0581\u046E\x03\x02\x02\x02\u0581\u0478\x03\x02\x02\x02\u0581\u047F\x03\x02\x02\x02\u0581\u0488\x03\x02\x02\x02\u0581\u048F\x03\x02\x02\x02\u0581\u0497\x03\x02\x02\x02\u0581\u049E\x03\x02\x02\x02\u0581\u04A4\x03\x02\x02\x02\u0581\u04A8\x03\x02\x02\x02\u0581\u04AE\x03\x02\x02\x02\u0581\u04B5\x03\x02\x02\x02\u0581\u04BA\x03\x02\x02\x02\u0581\u04C1\x03\x02\x02\x02\u0581\u04C9\x03\x02\x02\x02\u0581\u04CD\x03\x02\x02\x02\u0581\u04D3\x03\x02\x02\x02\u0581\u04D8\x03\x02\x02\x02\u0581\u04DD\x03\x02\x02\x02\u0581\u04E3\x03\x02\x02\x02\u0581\u04EA\x03\x02\x02\x02\u0581\u04F1\x03\x02\x02\x02\u0581\u04FA\x03\x02\x02\x02\u0581\u04FE\x03\x02\x02\x02\u0581\u0506\x03\x02\x02\x02\u0581\u050C\x03\x02\x02\x02\u0581\u0511\x03\x02\x02\x02\u0581\u0517\x03\x02\x02\x02\u0581\u0523\x03\x02\x02\x02\u0581\u052B\x03\x02\x02\x02\u0581\u0530\x03\x02\x02\x02\u0581\u0534\x03\x02\x02\x02\u0581\u053A\x03\x02\x02\x02\u0581\u0541\x03\x02\x02\x02\u0581\u0548\x03\x02\x02\x02\u0581\u054D\x03\x02\x02\x02\u0581\u0556\x03\x02\x02\x02\u0581\u055D\x03\x02\x02\x02\u0581\u0562\x03\x02\x02\x02\u0581\u0567\x03\x02\x02\x02\u0581\u0570\x03\x02\x02\x02\u0581\u0576\x03\x02\x02\x02\u0581\u057C\x03\x02\x02\x02\u0582P\x03\x02\x02\x02\u0583\u0586\x05\x85B\x02\u0584\u0586\x05i4\x02\u0585\u0583\x03\x02\x02\x02\u0585\u0584\x03\x02\x02\x02\u0586\u0587\x03\x02\x02\x02\u0587\u0585\x03\x02\x02\x02\u0587\u0588\x03\x02\x02\x02\u0588R\x03\x02\x02\x02\u0589\u058B\x05\x8bE\x02\u058A\u0589\x03\x02\x02\x02\u058B\u058C\x03\x02\x02\x02\u058C\u058A\x03\x02\x02\x02\u058C\u058D\x03\x02\x02\x02\u058D\u058E\x03\x02\x02\x02\u058E\u058F\b)\x05\x02\u058FT\x03\x02\x02\x02\u0590\u0591\x05o7\x02\u0591V\x03\x02\x02\x02\u0592\u0593\v\x02\x02\x02\u0593X\x03\x02\x02\x02\u0594\u0595\x05q8\x02\u0595\u0596\x03\x02\x02\x02\u0596\u0597\b,\x06\x02\u0597Z\x03\x02\x02\x02\u0598\u059B\x05\x85B\x02\u0599\u059B\x05k5\x02\u059A\u0598\x03\x02\x02\x02\u059A\u0599\x03\x02\x02\x02\u059B\u059C\x03\x02\x02\x02\u059C\u059D\b-\x02\x02\u059D\\\x03\x02\x02\x02\u059E\u059F\x07\x02\x02\x03\u059F\u05A0\x03\x02\x02\x02\u05A0\u05A1\b.\x06\x02\u05A1^\x03\x02\x02\x02\u05A2\u05A3\v\x02\x02\x02\u05A3\u05A4\x03\x02\x02\x02\u05A4\u05A5\b/\x06\x02\u05A5`\x03\x02\x02\x02\u05A6\u05A7\x05s9\x02\u05A7\u05A8\x03\x02\x02\x02\u05A8\u05A9\b0\x06\x02\u05A9b\x03\x02\x02\x02\u05AA\u05AD\x05\x85B\x02\u05AB\u05AD\x05m6\x02\u05AC\u05AA\x03\x02\x02\x02\u05AC\u05AB\x03\x02\x02\x02\u05AD\u05AE\x03\x02\x02\x02\u05AE\u05AF\b1\x02\x02\u05AFd\x03\x02\x02\x02\u05B0\u05B1\x07\x02\x02\x03\u05B1\u05B2\x03\x02\x02\x02\u05B2\u05B3\b2\x06\x02\u05B3f\x03\x02\x02\x02\u05B4\u05B5\v\x02\x02\x02\u05B5\u05B6\x03\x02\x02\x02\u05B6\u05B7\b3\x06\x02\u05B7h\x03\x02\x02\x02\u05B8\u05B9\n\x02\x02\x02\u05B9j\x03\x02\x02\x02\u05BA\u05BB\n\x03\x02\x02\u05BBl\x03\x02\x02\x02\u05BC\u05BD\n\x04\x02\x02\u05BDn\x03\x02\x02\x02\u05BE\u05BF	\x05\x02\x02\u05BFp\x03\x02\x02\x02\u05C0\u05C1\x07$\x02\x02\u05C1r\x03\x02\x02\x02\u05C2\u05C3\x07)\x02\x02\u05C3t\x03\x02\x02\x02\u05C4\u05C5\x07^\x02\x02\u05C5v\x03\x02\x02\x02\u05C6\u05C7\x07\x0f\x02\x02\u05C7x\x03\x02\x02\x02\u05C8\u05C9\x07\f\x02\x02\u05C9z\x03\x02\x02\x02\u05CA\u05CB\x07"\x02\x02\u05CB|\x03\x02\x02\x02\u05CC\u05CD\x07(\x02\x02\u05CD~\x03\x02\x02\x02\u05CE\u05CF\x07(\x02\x02\u05CF\u05D0\x07(\x02\x02\u05D0\x80\x03\x02\x02\x02\u05D1\u05D2\x07~\x02\x02\u05D2\x82\x03\x02\x02\x02\u05D3\u05D4\x07~\x02\x02\u05D4\u05D5\x07~\x02\x02\u05D5\x84\x03\x02\x02\x02\u05D6\u05E2\x05u:\x02\u05D7\u05E3	\x06\x02\x02\u05D8\u05E3\x05q8\x02\u05D9\u05E3\x05s9\x02\u05DA\u05E3\x05u:\x02\u05DB\u05E3\x05{=\x02\u05DC\u05DD\x07w\x02\x02\u05DD\u05DE\x05\x89D\x02\u05DE\u05DF\x05\x89D\x02\u05DF\u05E0\x05\x89D\x02\u05E0\u05E1\x05\x89D\x02\u05E1\u05E3\x03\x02\x02\x02\u05E2\u05D7\x03\x02\x02\x02\u05E2\u05D8\x03\x02\x02\x02\u05E2\u05D9\x03\x02\x02\x02\u05E2\u05DA\x03\x02\x02\x02\u05E2\u05DB\x03\x02\x02\x02\u05E2\u05DC\x03\x02\x02\x02\u05E3\x86\x03\x02\x02\x02\u05E4\u05E7\x05w;\x02\u05E5\u05E7\x05y<\x02\u05E6\u05E4\x03\x02\x02\x02\u05E6\u05E5\x03\x02\x02\x02\u05E7\x88\x03\x02\x02\x02\u05E8\u05F0\x05\x8fG\x02\u05E9\u05F0\x05\x91H\x02\u05EA\u05F0\x05\x93I\x02\u05EB\u05F0\x05\x95J\x02\u05EC\u05F0\x05\x97K\x02\u05ED\u05F0\x05\x99L\x02\u05EE\u05F0\x05\x9bM\x02\u05EF\u05E8\x03\x02\x02\x02\u05EF\u05E9\x03\x02\x02\x02\u05EF\u05EA\x03\x02\x02\x02\u05EF\u05EB\x03\x02\x02\x02\u05EF\u05EC\x03\x02\x02\x02\u05EF\u05ED\x03\x02\x02\x02\u05EF\u05EE\x03\x02\x02\x02\u05F0\x8a\x03\x02\x02\x02\u05F1\u05F5\x05{=\x02\u05F2\u05F5\x07\v\x02\x02\u05F3\u05F5\x05\x87C\x02\u05F4\u05F1\x03\x02\x02\x02\u05F4\u05F2\x03\x02\x02\x02\u05F4\u05F3\x03\x02\x02\x02\u05F5\x8c\x03\x02\x02\x02\u05F6\u05F7\x07/\x02\x02\u05F7\x8e\x03\x02\x02\x02\u05F8\u05F9	\x07\x02\x02\u05F9\x90\x03\x02\x02\x02\u05FA\u05FB	\b\x02\x02\u05FB\x92\x03\x02\x02\x02\u05FC\u05FD		\x02\x02\u05FD\x94\x03\x02\x02\x02\u05FE\u05FF	\n\x02\x02\u05FF\x96\x03\x02\x02\x02\u0600\u0601	\v\x02\x02\u0601\x98\x03\x02\x02\x02\u0602\u0603	\f\x02\x02\u0603\x9a\x03\x02\x02\x02\u0604\u0605	\r\x02\x02\u0605\x9c\x03\x02\x02\x02\u0606\u0607	\x0e\x02\x02\u0607\x9e\x03\x02\x02\x02\u0608\u0609	\x0f\x02\x02\u0609\xa0\x03\x02\x02\x02\u060A\u060B	\x10\x02\x02\u060B\xa2\x03\x02\x02\x02\u060C\u060D	\x11\x02\x02\u060D\xa4\x03\x02\x02\x02\u060E\u060F	\x12\x02\x02\u060F\xa6\x03\x02\x02\x02\u0610\u0611	\x13\x02\x02\u0611\xa8\x03\x02\x02\x02\u0612\u0613	\x14\x02\x02\u0613\xaa\x03\x02\x02\x02\u0614\u0615	\x15\x02\x02\u0615\xac\x03\x02\x02\x02\u0616\u0617	\x16\x02\x02\u0617\xae\x03\x02\x02\x02\u0618\u0619	\x17\x02\x02\u0619\xb0\x03\x02\x02\x02\u061A\u061B	\x18\x02\x02\u061B\xb2\x03\x02\x02\x02\u061C\u061D	\x19\x02\x02\u061D\xb4\x03\x02\x02\x02\u061E\u061F	\x1a\x02\x02\u061F\xb6\x03\x02\x02\x02\u0620\u0621	\x1b\x02\x02\u0621\xb8\x03\x02\x02\x02\u0622\u0623	\x1c\x02\x02\u0623\xba\x03\x02\x02\x02\u0624\u0625	\x1d\x02\x02\u0625\xbc\x03\x02\x02\x02\u0626\u0627	\x1e\x02\x02\u0627\xbe\x03\x02\x02\x02\u0628\u0629	\x1f\x02\x02\u0629\xc0\x03\x02\x02\x02\u062A\u062B	 \x02\x02\u062B\xc2\x03\x02\x02\x02\u062C\u062D	!\x02\x02\u062D\xc4\x03\x02\x02\x02\x14\x02\x03\x04\xfb\u0102\u0113\u0155\u015B\u0581\u0585\u0587\u058C\u059A\u05AC\u05E2\u05E6\u05EF\u05F4\x07\x05\x02\x02\x04\x03\x02\x04\x04\x02\x02\x03\x02\x04\x02\x02';
    }
    static{
        this._serializedATN = $g4Hat.join([
            $8132725dc5c59eb0$export$375c79404cc64c7f._serializedATNSegment0,
            $8132725dc5c59eb0$export$375c79404cc64c7f._serializedATNSegment1,
            $8132725dc5c59eb0$export$375c79404cc64c7f._serializedATNSegment2
        ], '');
    }
    static get _ATN() {
        if (!$8132725dc5c59eb0$export$375c79404cc64c7f.__ATN) $8132725dc5c59eb0$export$375c79404cc64c7f.__ATN = new (0, $es7AZ.ATNDeserializer)().deserialize($g4Hat.toCharArray($8132725dc5c59eb0$export$375c79404cc64c7f._serializedATN));
        return $8132725dc5c59eb0$export$375c79404cc64c7f.__ATN;
    }
}

});

parcelRegister("7UI9e", function(module, exports) {

$parcel$export(module.exports, "JQLParser", () => $fd149865cf75e9bf$export$9c4772e191bdb810);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLParser.g4 by ANTLR 4.7.3-SNAPSHOT

var $es7AZ = parcelRequire("es7AZ");

var $4qcTm = parcelRequire("4qcTm");

var $dDGsq = parcelRequire("dDGsq");

var $5NlfZ = parcelRequire("5NlfZ");

var $l4uOS = parcelRequire("l4uOS");

var $lWPhg = parcelRequire("lWPhg");

var $2G93d = parcelRequire("2G93d");

var $5t4I3 = parcelRequire("5t4I3");

var $g4Hat = parcelRequire("g4Hat");
class $fd149865cf75e9bf$export$9c4772e191bdb810 extends (0, $dDGsq.Parser) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.RULE_jqlQuery = 0;
    }
    static{
        this.RULE_jqlWhere = 1;
    }
    static{
        this.RULE_jqlOrClause = 2;
    }
    static{
        this.RULE_jqlAndClause = 3;
    }
    static{
        this.RULE_jqlNotClause = 4;
    }
    static{
        this.RULE_jqlSubClause = 5;
    }
    static{
        this.RULE_jqlTerminalClause = 6;
    }
    static{
        this.RULE_jqlTerminalClauseRhs = 7;
    }
    static{
        this.RULE_jqlEqualsOperator = 8;
    }
    static{
        this.RULE_jqlLikeOperator = 9;
    }
    static{
        this.RULE_jqlComparisonOperator = 10;
    }
    static{
        this.RULE_jqlInOperator = 11;
    }
    static{
        this.RULE_jqlIsOperator = 12;
    }
    static{
        this.RULE_jqlWasOperator = 13;
    }
    static{
        this.RULE_jqlWasInOperator = 14;
    }
    static{
        this.RULE_jqlChangedOperator = 15;
    }
    static{
        this.RULE_jqlField = 16;
    }
    static{
        this.RULE_jqlFieldProperty = 17;
    }
    static{
        this.RULE_jqlCustomField = 18;
    }
    static{
        this.RULE_jqlString = 19;
    }
    static{
        this.RULE_jqlNumber = 20;
    }
    static{
        this.RULE_jqlOperand = 21;
    }
    static{
        this.RULE_jqlEmpty = 22;
    }
    static{
        this.RULE_jqlValue = 23;
    }
    static{
        this.RULE_jqlFunction = 24;
    }
    static{
        this.RULE_jqlFunctionName = 25;
    }
    static{
        this.RULE_jqlArgumentList = 26;
    }
    static{
        this.RULE_jqlList = 27;
    }
    static{
        this.RULE_jqlListStart = 28;
    }
    static{
        this.RULE_jqlListEnd = 29;
    }
    static{
        this.RULE_jqlPropertyArgument = 30;
    }
    static{
        this.RULE_jqlArgument = 31;
    }
    static{
        this.RULE_jqlWasPredicate = 32;
    }
    static{
        this.RULE_jqlChangedPredicate = 33;
    }
    static{
        this.RULE_jqlDatePredicateOperator = 34;
    }
    static{
        this.RULE_jqlDateRangePredicateOperator = 35;
    }
    static{
        this.RULE_jqlUserPredicateOperator = 36;
    }
    static{
        this.RULE_jqlValuePredicateOperator = 37;
    }
    static{
        this.RULE_jqlPredicateOperand = 38;
    }
    static{
        this.RULE_jqlOrderBy = 39;
    }
    static{
        this.RULE_jqlSearchSort = 40;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.ruleNames = [
            'jqlQuery',
            'jqlWhere',
            'jqlOrClause',
            'jqlAndClause',
            'jqlNotClause',
            'jqlSubClause',
            'jqlTerminalClause',
            'jqlTerminalClauseRhs',
            'jqlEqualsOperator',
            'jqlLikeOperator',
            'jqlComparisonOperator',
            'jqlInOperator',
            'jqlIsOperator',
            'jqlWasOperator',
            'jqlWasInOperator',
            'jqlChangedOperator',
            'jqlField',
            'jqlFieldProperty',
            'jqlCustomField',
            'jqlString',
            'jqlNumber',
            'jqlOperand',
            'jqlEmpty',
            'jqlValue',
            'jqlFunction',
            'jqlFunctionName',
            'jqlArgumentList',
            'jqlList',
            'jqlListStart',
            'jqlListEnd',
            'jqlPropertyArgument',
            'jqlArgument',
            'jqlWasPredicate',
            'jqlChangedPredicate',
            'jqlDatePredicateOperator',
            'jqlDateRangePredicateOperator',
            'jqlUserPredicateOperator',
            'jqlValuePredicateOperator',
            'jqlPredicateOperand',
            'jqlOrderBy',
            'jqlSearchSort'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $5t4I3.VocabularyImpl)($fd149865cf75e9bf$export$9c4772e191bdb810._LITERAL_NAMES, $fd149865cf75e9bf$export$9c4772e191bdb810._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    // @Override
    get grammarFileName() {
        return 'JQLParser.g4';
    }
    // @Override
    get ruleNames() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810._serializedATN;
    }
    constructor(input){
        super(input);
        this._interp = new (0, $l4uOS.ParserATNSimulator)($fd149865cf75e9bf$export$9c4772e191bdb810._ATN, this);
    }
    // @RuleVersion(0)
    jqlQuery() {
        let _localctx = new $fd149865cf75e9bf$export$ff413535b9575c8(this._ctx, this.state);
        this.enterRule(_localctx, 0, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlQuery);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 83;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la & -32) === 0 && (1 << _la & (1 << $fd149865cf75e9bf$export$9c4772e191bdb810.LPAREN | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.BANG | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.NOT)) !== 0 || (_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $fd149865cf75e9bf$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.CUSTOMFIELD - 33 | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.STRING - 33 | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 82;
                this.jqlWhere();
            }
            this.state = 86;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $fd149865cf75e9bf$export$9c4772e191bdb810.ORDER) {
                this.state = 85;
                this.jqlOrderBy();
            }
            this.state = 88;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.EOF);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWhere() {
        let _localctx = new $fd149865cf75e9bf$export$4148a879cab28017(this._ctx, this.state);
        this.enterRule(_localctx, 2, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlWhere);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 90;
            this.jqlOrClause();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrClause() {
        let _localctx = new $fd149865cf75e9bf$export$d69831d387793480(this._ctx, this.state);
        this.enterRule(_localctx, 4, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlOrClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 92;
            this.jqlAndClause();
            this.state = 97;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $fd149865cf75e9bf$export$9c4772e191bdb810.OR){
                this.state = 93;
                this.match($fd149865cf75e9bf$export$9c4772e191bdb810.OR);
                this.state = 94;
                this.jqlAndClause();
                this.state = 99;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlAndClause() {
        let _localctx = new $fd149865cf75e9bf$export$f16819001158b9e(this._ctx, this.state);
        this.enterRule(_localctx, 6, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlAndClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 100;
            this.jqlNotClause();
            this.state = 105;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $fd149865cf75e9bf$export$9c4772e191bdb810.AND){
                this.state = 101;
                this.match($fd149865cf75e9bf$export$9c4772e191bdb810.AND);
                this.state = 102;
                this.jqlNotClause();
                this.state = 107;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNotClause() {
        let _localctx = new $fd149865cf75e9bf$export$5e9146f8d5cf1330(this._ctx, this.state);
        this.enterRule(_localctx, 8, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlNotClause);
        let _la;
        try {
            this.state = 112;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $fd149865cf75e9bf$export$9c4772e191bdb810.BANG:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 108;
                    _la = this._input.LA(1);
                    if (!(_la === $fd149865cf75e9bf$export$9c4772e191bdb810.BANG || _la === $fd149865cf75e9bf$export$9c4772e191bdb810.NOT)) this._errHandler.recoverInline(this);
                    else {
                        if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 109;
                    this.jqlNotClause();
                    break;
                case $fd149865cf75e9bf$export$9c4772e191bdb810.LPAREN:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 110;
                    this.jqlSubClause();
                    break;
                case $fd149865cf75e9bf$export$9c4772e191bdb810.POSNUMBER:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.NEGNUMBER:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.CUSTOMFIELD:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.STRING:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.QUOTE_STRING:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 111;
                    this.jqlTerminalClause();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSubClause() {
        let _localctx = new $fd149865cf75e9bf$export$a136a0e9655bfb04(this._ctx, this.state);
        this.enterRule(_localctx, 10, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlSubClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 114;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.LPAREN);
            this.state = 115;
            this.jqlOrClause();
            this.state = 116;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClause() {
        let _localctx = new $fd149865cf75e9bf$export$23486a2f2ddd5bcd(this._ctx, this.state);
        this.enterRule(_localctx, 12, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlTerminalClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 118;
            this.jqlField();
            this.state = 119;
            this.jqlTerminalClauseRhs();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClauseRhs() {
        let _localctx = new $fd149865cf75e9bf$export$93924a205c12d32c(this._ctx, this.state);
        this.enterRule(_localctx, 14, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs);
        let _la;
        try {
            this.state = 176;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 14, this._ctx)){
                case 1:
                    _localctx = new $fd149865cf75e9bf$export$c428f709a58396e5(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 121;
                    this.jqlEqualsOperator();
                    this.state = 125;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 5, this._ctx)){
                        case 1:
                            this.state = 122;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 123;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 124;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 2:
                    _localctx = new $fd149865cf75e9bf$export$1b131204ef9fa33d(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 127;
                    this.jqlLikeOperator();
                    this.state = 131;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 6, this._ctx)){
                        case 1:
                            this.state = 128;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 129;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 130;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 3:
                    _localctx = new $fd149865cf75e9bf$export$d83706ee80a9852a(_localctx);
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 133;
                    this.jqlComparisonOperator();
                    this.state = 136;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 7, this._ctx)){
                        case 1:
                            this.state = 134;
                            this.jqlValue();
                            break;
                        case 2:
                            this.state = 135;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 4:
                    _localctx = new $fd149865cf75e9bf$export$2934b8ff22fddd2d(_localctx);
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 138;
                    this.jqlInOperator();
                    this.state = 141;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.LPAREN:
                            this.state = 139;
                            this.jqlList();
                            break;
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.POSNUMBER:
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.NEGNUMBER:
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.STRING:
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.QUOTE_STRING:
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 140;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $4qcTm.NoViableAltException)(this);
                    }
                    break;
                case 5:
                    _localctx = new $fd149865cf75e9bf$export$8b84310182afcf93(_localctx);
                    this.enterOuterAlt(_localctx, 5);
                    this.state = 143;
                    this.jqlIsOperator();
                    this.state = 144;
                    this.jqlEmpty();
                    break;
                case 6:
                    _localctx = new $fd149865cf75e9bf$export$5df295dc7a2cac7c(_localctx);
                    this.enterOuterAlt(_localctx, 6);
                    this.state = 146;
                    this.jqlWasOperator();
                    this.state = 150;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 9, this._ctx)){
                        case 1:
                            this.state = 147;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 148;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 149;
                            this.jqlFunction();
                            break;
                    }
                    this.state = 155;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $fd149865cf75e9bf$export$9c4772e191bdb810.BEFORE | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.AFTER | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.ON | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.DURING | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 152;
                        this.jqlWasPredicate();
                        this.state = 157;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 7:
                    _localctx = new $fd149865cf75e9bf$export$9ac3367aee261b32(_localctx);
                    this.enterOuterAlt(_localctx, 7);
                    this.state = 158;
                    this.jqlWasInOperator();
                    this.state = 161;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.LPAREN:
                            this.state = 159;
                            this.jqlList();
                            break;
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.POSNUMBER:
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.NEGNUMBER:
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.STRING:
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.QUOTE_STRING:
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 160;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $4qcTm.NoViableAltException)(this);
                    }
                    this.state = 166;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $fd149865cf75e9bf$export$9c4772e191bdb810.BEFORE | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.AFTER | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.ON | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.DURING | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 163;
                        this.jqlWasPredicate();
                        this.state = 168;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 8:
                    _localctx = new $fd149865cf75e9bf$export$7a7defca8628a13c(_localctx);
                    this.enterOuterAlt(_localctx, 8);
                    this.state = 169;
                    this.jqlChangedOperator();
                    this.state = 173;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $fd149865cf75e9bf$export$9c4772e191bdb810.BEFORE | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.AFTER | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.FROM | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.TO | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.ON | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.DURING | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 170;
                        this.jqlChangedPredicate();
                        this.state = 175;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEqualsOperator() {
        let _localctx = new $fd149865cf75e9bf$export$41e475fc1988e413(this._ctx, this.state);
        this.enterRule(_localctx, 16, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlEqualsOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 178;
            _la = this._input.LA(1);
            if (!(_la === $fd149865cf75e9bf$export$9c4772e191bdb810.EQUALS || _la === $fd149865cf75e9bf$export$9c4772e191bdb810.NOT_EQUALS)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlLikeOperator() {
        let _localctx = new $fd149865cf75e9bf$export$b76fe5387fdd7efd(this._ctx, this.state);
        this.enterRule(_localctx, 18, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlLikeOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 180;
            _la = this._input.LA(1);
            if (!(_la === $fd149865cf75e9bf$export$9c4772e191bdb810.LIKE || _la === $fd149865cf75e9bf$export$9c4772e191bdb810.NOT_LIKE)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlComparisonOperator() {
        let _localctx = new $fd149865cf75e9bf$export$d821da0716b3ec95(this._ctx, this.state);
        this.enterRule(_localctx, 20, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlComparisonOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 182;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $fd149865cf75e9bf$export$9c4772e191bdb810.LT | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.GT | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.GTEQ | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.LTEQ)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlInOperator() {
        let _localctx = new $fd149865cf75e9bf$export$178478bfa8292f72(this._ctx, this.state);
        this.enterRule(_localctx, 22, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlInOperator);
        try {
            this.state = 187;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $fd149865cf75e9bf$export$9c4772e191bdb810.IN:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 184;
                    this.match($fd149865cf75e9bf$export$9c4772e191bdb810.IN);
                    break;
                case $fd149865cf75e9bf$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 185;
                    this.match($fd149865cf75e9bf$export$9c4772e191bdb810.NOT);
                    this.state = 186;
                    this.match($fd149865cf75e9bf$export$9c4772e191bdb810.IN);
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlIsOperator() {
        let _localctx = new $fd149865cf75e9bf$export$e64c31d2830b66e4(this._ctx, this.state);
        this.enterRule(_localctx, 24, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlIsOperator);
        try {
            this.state = 192;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 16, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 189;
                    this.match($fd149865cf75e9bf$export$9c4772e191bdb810.IS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 190;
                    this.match($fd149865cf75e9bf$export$9c4772e191bdb810.IS);
                    this.state = 191;
                    this.match($fd149865cf75e9bf$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasOperator() {
        let _localctx = new $fd149865cf75e9bf$export$7e283636700e4a6c(this._ctx, this.state);
        this.enterRule(_localctx, 26, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlWasOperator);
        try {
            this.state = 197;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 17, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 194;
                    this.match($fd149865cf75e9bf$export$9c4772e191bdb810.WAS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 195;
                    this.match($fd149865cf75e9bf$export$9c4772e191bdb810.WAS);
                    this.state = 196;
                    this.match($fd149865cf75e9bf$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasInOperator() {
        let _localctx = new $fd149865cf75e9bf$export$b9118b1ed9a78d66(this._ctx, this.state);
        this.enterRule(_localctx, 28, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlWasInOperator);
        try {
            this.state = 204;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 18, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 199;
                    this.match($fd149865cf75e9bf$export$9c4772e191bdb810.WAS);
                    this.state = 200;
                    this.match($fd149865cf75e9bf$export$9c4772e191bdb810.IN);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 201;
                    this.match($fd149865cf75e9bf$export$9c4772e191bdb810.WAS);
                    this.state = 202;
                    this.match($fd149865cf75e9bf$export$9c4772e191bdb810.NOT);
                    this.state = 203;
                    this.match($fd149865cf75e9bf$export$9c4772e191bdb810.IN);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedOperator() {
        let _localctx = new $fd149865cf75e9bf$export$493d626ed78ca66(this._ctx, this.state);
        this.enterRule(_localctx, 30, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlChangedOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 206;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.CHANGED);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlField() {
        let _localctx = new $fd149865cf75e9bf$export$b33300c3d916229a(this._ctx, this.state);
        this.enterRule(_localctx, 32, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlField);
        let _la;
        try {
            this.state = 219;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $fd149865cf75e9bf$export$9c4772e191bdb810.POSNUMBER:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.NEGNUMBER:
                    _localctx = new $fd149865cf75e9bf$export$11fec15307d2e17b(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 208;
                    this.jqlNumber();
                    break;
                case $fd149865cf75e9bf$export$9c4772e191bdb810.CUSTOMFIELD:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.STRING:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.QUOTE_STRING:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.SQUOTE_STRING:
                    _localctx = new $fd149865cf75e9bf$export$b8b24f99f985ebb3(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 211;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.STRING:
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.QUOTE_STRING:
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 209;
                            this.jqlString();
                            break;
                        case $fd149865cf75e9bf$export$9c4772e191bdb810.CUSTOMFIELD:
                            this.state = 210;
                            this.jqlCustomField();
                            break;
                        default:
                            throw new (0, $4qcTm.NoViableAltException)(this);
                    }
                    this.state = 216;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la === $fd149865cf75e9bf$export$9c4772e191bdb810.LBRACKET){
                        this.state = 213;
                        this.jqlFieldProperty();
                        this.state = 218;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFieldProperty() {
        let _localctx = new $fd149865cf75e9bf$export$b02d0b6637ce0593(this._ctx, this.state);
        this.enterRule(_localctx, 34, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlFieldProperty);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 221;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.LBRACKET);
            this.state = 222;
            this.jqlArgument();
            this.state = 223;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.RBRACKET);
            this.state = 228;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $fd149865cf75e9bf$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.STRING - 33 | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0){
                this.state = 225;
                this.jqlPropertyArgument();
                this.state = 230;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlCustomField() {
        let _localctx = new $fd149865cf75e9bf$export$401a038855cc5b15(this._ctx, this.state);
        this.enterRule(_localctx, 36, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlCustomField);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 231;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.CUSTOMFIELD);
            this.state = 232;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.LBRACKET);
            this.state = 233;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.POSNUMBER);
            this.state = 234;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.RBRACKET);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlString() {
        let _localctx = new $fd149865cf75e9bf$export$bde73d8ad7c8b71e(this._ctx, this.state);
        this.enterRule(_localctx, 38, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlString);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 236;
            _la = this._input.LA(1);
            if (!((_la - 37 & -32) === 0 && (1 << _la - 37 & (1 << $fd149865cf75e9bf$export$9c4772e191bdb810.STRING - 37 | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.QUOTE_STRING - 37 | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.SQUOTE_STRING - 37)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNumber() {
        let _localctx = new $fd149865cf75e9bf$export$8737d94a1880e8b3(this._ctx, this.state);
        this.enterRule(_localctx, 40, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlNumber);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 238;
            _localctx._jqlNum = this._input.LT(1);
            _la = this._input.LA(1);
            if (!(_la === $fd149865cf75e9bf$export$9c4772e191bdb810.POSNUMBER || _la === $fd149865cf75e9bf$export$9c4772e191bdb810.NEGNUMBER)) _localctx._jqlNum = this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOperand() {
        let _localctx = new $fd149865cf75e9bf$export$2eaac5a9828bf647(this._ctx, this.state);
        this.enterRule(_localctx, 42, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlOperand);
        try {
            this.state = 244;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 23, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 240;
                    this.jqlEmpty();
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 241;
                    this.jqlValue();
                    break;
                case 3:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 242;
                    this.jqlFunction();
                    break;
                case 4:
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 243;
                    this.jqlList();
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEmpty() {
        let _localctx = new $fd149865cf75e9bf$export$d85a062f90025e5c(this._ctx, this.state);
        this.enterRule(_localctx, 44, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlEmpty);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 246;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.EMPTY);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValue() {
        let _localctx = new $fd149865cf75e9bf$export$2e17d457b0933bec(this._ctx, this.state);
        this.enterRule(_localctx, 46, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlValue);
        try {
            this.state = 250;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $fd149865cf75e9bf$export$9c4772e191bdb810.STRING:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.QUOTE_STRING:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 248;
                    this.jqlString();
                    break;
                case $fd149865cf75e9bf$export$9c4772e191bdb810.POSNUMBER:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 249;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunction() {
        let _localctx = new $fd149865cf75e9bf$export$ebf0cc785e9ee41a(this._ctx, this.state);
        this.enterRule(_localctx, 48, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlFunction);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 252;
            this.jqlFunctionName();
            this.state = 253;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.LPAREN);
            this.state = 255;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $fd149865cf75e9bf$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.STRING - 33 | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 254;
                this.jqlArgumentList();
            }
            this.state = 257;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunctionName() {
        let _localctx = new $fd149865cf75e9bf$export$1f5f7ac816788f44(this._ctx, this.state);
        this.enterRule(_localctx, 50, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlFunctionName);
        try {
            this.state = 261;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $fd149865cf75e9bf$export$9c4772e191bdb810.STRING:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.QUOTE_STRING:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 259;
                    this.jqlString();
                    break;
                case $fd149865cf75e9bf$export$9c4772e191bdb810.POSNUMBER:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 260;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgumentList() {
        let _localctx = new $fd149865cf75e9bf$export$83d7c13849b931c3(this._ctx, this.state);
        this.enterRule(_localctx, 52, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlArgumentList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 263;
            this.jqlArgument();
            this.state = 268;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $fd149865cf75e9bf$export$9c4772e191bdb810.COMMA){
                this.state = 264;
                this.match($fd149865cf75e9bf$export$9c4772e191bdb810.COMMA);
                this.state = 265;
                this.jqlArgument();
                this.state = 270;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlList() {
        let _localctx = new $fd149865cf75e9bf$export$9cb97a63f2be4864(this._ctx, this.state);
        this.enterRule(_localctx, 54, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 271;
            this.jqlListStart();
            this.state = 272;
            this.jqlOperand();
            this.state = 277;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $fd149865cf75e9bf$export$9c4772e191bdb810.COMMA){
                this.state = 273;
                this.match($fd149865cf75e9bf$export$9c4772e191bdb810.COMMA);
                this.state = 274;
                this.jqlOperand();
                this.state = 279;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 280;
            this.jqlListEnd();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListStart() {
        let _localctx = new $fd149865cf75e9bf$export$c419f717bfc46a5d(this._ctx, this.state);
        this.enterRule(_localctx, 56, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlListStart);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 282;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.LPAREN);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListEnd() {
        let _localctx = new $fd149865cf75e9bf$export$f6cd3e372f5ab120(this._ctx, this.state);
        this.enterRule(_localctx, 58, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlListEnd);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 284;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPropertyArgument() {
        let _localctx = new $fd149865cf75e9bf$export$e20ce4a2ed16372c(this._ctx, this.state);
        this.enterRule(_localctx, 60, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlPropertyArgument);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 286;
            this.jqlArgument();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgument() {
        let _localctx = new $fd149865cf75e9bf$export$a95583953c237f88(this._ctx, this.state);
        this.enterRule(_localctx, 62, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlArgument);
        try {
            this.state = 290;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $fd149865cf75e9bf$export$9c4772e191bdb810.STRING:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.QUOTE_STRING:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 288;
                    this.jqlString();
                    break;
                case $fd149865cf75e9bf$export$9c4772e191bdb810.POSNUMBER:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 289;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasPredicate() {
        let _localctx = new $fd149865cf75e9bf$export$9fa1e4d63f31b911(this._ctx, this.state);
        this.enterRule(_localctx, 64, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlWasPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 295;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $fd149865cf75e9bf$export$9c4772e191bdb810.BEFORE:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.AFTER:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.ON:
                    this.state = 292;
                    this.jqlDatePredicateOperator();
                    break;
                case $fd149865cf75e9bf$export$9c4772e191bdb810.DURING:
                    this.state = 293;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $fd149865cf75e9bf$export$9c4772e191bdb810.BY:
                    this.state = 294;
                    this.jqlUserPredicateOperator();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
            this.state = 297;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedPredicate() {
        let _localctx = new $fd149865cf75e9bf$export$e77e479a48133015(this._ctx, this.state);
        this.enterRule(_localctx, 66, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlChangedPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 303;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $fd149865cf75e9bf$export$9c4772e191bdb810.BEFORE:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.AFTER:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.ON:
                    this.state = 299;
                    this.jqlDatePredicateOperator();
                    break;
                case $fd149865cf75e9bf$export$9c4772e191bdb810.DURING:
                    this.state = 300;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $fd149865cf75e9bf$export$9c4772e191bdb810.BY:
                    this.state = 301;
                    this.jqlUserPredicateOperator();
                    break;
                case $fd149865cf75e9bf$export$9c4772e191bdb810.FROM:
                case $fd149865cf75e9bf$export$9c4772e191bdb810.TO:
                    this.state = 302;
                    this.jqlValuePredicateOperator();
                    break;
                default:
                    throw new (0, $4qcTm.NoViableAltException)(this);
            }
            this.state = 305;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDatePredicateOperator() {
        let _localctx = new $fd149865cf75e9bf$export$dc01290aee731418(this._ctx, this.state);
        this.enterRule(_localctx, 68, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 307;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $fd149865cf75e9bf$export$9c4772e191bdb810.BEFORE | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.AFTER | 1 << $fd149865cf75e9bf$export$9c4772e191bdb810.ON)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDateRangePredicateOperator() {
        let _localctx = new $fd149865cf75e9bf$export$75412b8b6a6442e1(this._ctx, this.state);
        this.enterRule(_localctx, 70, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 309;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.DURING);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlUserPredicateOperator() {
        let _localctx = new $fd149865cf75e9bf$export$ad402332075c8656(this._ctx, this.state);
        this.enterRule(_localctx, 72, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 311;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.BY);
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValuePredicateOperator() {
        let _localctx = new $fd149865cf75e9bf$export$4239d7c0fbafd3f1(this._ctx, this.state);
        this.enterRule(_localctx, 74, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 313;
            _la = this._input.LA(1);
            if (!(_la === $fd149865cf75e9bf$export$9c4772e191bdb810.FROM || _la === $fd149865cf75e9bf$export$9c4772e191bdb810.TO)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPredicateOperand() {
        let _localctx = new $fd149865cf75e9bf$export$6b796c5a4b8c18e(this._ctx, this.state);
        this.enterRule(_localctx, 76, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlPredicateOperand);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 315;
            this.jqlOperand();
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrderBy() {
        let _localctx = new $fd149865cf75e9bf$export$534469b9c8f44139(this._ctx, this.state);
        this.enterRule(_localctx, 78, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlOrderBy);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 317;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.ORDER);
            this.state = 318;
            this.match($fd149865cf75e9bf$export$9c4772e191bdb810.BY);
            this.state = 319;
            this.jqlSearchSort();
            this.state = 324;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $fd149865cf75e9bf$export$9c4772e191bdb810.COMMA){
                this.state = 320;
                this.match($fd149865cf75e9bf$export$9c4772e191bdb810.COMMA);
                this.state = 321;
                this.jqlSearchSort();
                this.state = 326;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSearchSort() {
        let _localctx = new $fd149865cf75e9bf$export$c7d8f03f36952a46(this._ctx, this.state);
        this.enterRule(_localctx, 80, $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlSearchSort);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 327;
            this.jqlField();
            this.state = 329;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $fd149865cf75e9bf$export$9c4772e191bdb810.ASC || _la === $fd149865cf75e9bf$export$9c4772e191bdb810.DESC) {
                this.state = 328;
                _la = this._input.LA(1);
                if (!(_la === $fd149865cf75e9bf$export$9c4772e191bdb810.ASC || _la === $fd149865cf75e9bf$export$9c4772e191bdb810.DESC)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2G93d.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        } catch (re) {
            if (re instanceof (0, $lWPhg.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    static{
        this._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x030\u014E\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04"	"\x04#	#\x04$	$\x04%	%\x04&	&\x04\'	\'\x04(	(\x04)	)\x04*	*\x03\x02\x05\x02V\n\x02\x03\x02\x05\x02Y\n\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04b\n\x04\f\x04\x0e\x04e\v\x04\x03\x05\x03\x05\x03\x05\x07\x05j\n\x05\f\x05\x0e\x05m\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06s\n\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03	\x03	\x03	\x03	\x05	\x80\n	\x03	\x03	\x03	\x03	\x05	\x86\n	\x03	\x03	\x03	\x05	\x8b\n	\x03	\x03	\x03	\x05	\x90\n	\x03	\x03	\x03	\x03	\x03	\x03	\x03	\x05	\x99\n	\x03	\x07	\x9c\n	\f	\x0e	\x9f\v	\x03	\x03	\x03	\x05	\xa4\n	\x03	\x07	\xa7\n	\f	\x0e	\xaa\v	\x03	\x03	\x07	\xae\n	\f	\x0e	\xb1\v	\x05	\xb3\n	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x05\r\xbe\n\r\x03\x0e\x03\x0e\x03\x0e\x05\x0e\xc3\n\x0e\x03\x0f\x03\x0f\x03\x0f\x05\x0f\xc8\n\x0f\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x05\x10\xcf\n\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x05\x12\xd6\n\x12\x03\x12\x07\x12\xd9\n\x12\f\x12\x0e\x12\xdc\v\x12\x05\x12\xde\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x03\x13\x07\x13\xe5\n\x13\f\x13\x0e\x13\xe8\v\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\xf7\n\x17\x03\x18\x03\x18\x03\x19\x03\x19\x05\x19\xfd\n\x19\x03\x1a\x03\x1a\x03\x1a\x05\x1a\u0102\n\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x05\x1b\u0108\n\x1b\x03\x1c\x03\x1c\x03\x1c\x07\x1c\u010D\n\x1c\f\x1c\x0e\x1c\u0110\v\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1d\x07\x1d\u0116\n\x1d\f\x1d\x0e\x1d\u0119\v\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03 \x03 \x03!\x03!\x05!\u0125\n!\x03"\x03"\x03"\x05"\u012A\n"\x03"\x03"\x03#\x03#\x03#\x03#\x05#\u0132\n#\x03#\x03#\x03$\x03$\x03%\x03%\x03&\x03&\x03\'\x03\'\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x07)\u0145\n)\f)\x0e)\u0148\v)\x03*\x03*\x05*\u014C\n*\x03*\x02\x02\x02+\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0e\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1a\x02\x1c\x02\x1e\x02 \x02"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x028\x02:\x02<\x02>\x02@\x02B\x02D\x02F\x02H\x02J\x02L\x02N\x02P\x02R\x02\x02\v\x04\x02\b\b\x15\x15\x03\x02\r\x0e\x03\x02\x0f\x10\x03\x02	\f\x05\x02\'\'++..\x03\x02#$\x04\x02\x19\x1a\x1d\x1d\x03\x02\x1b\x1c\x03\x02!"\x02\u0155\x02U\x03\x02\x02\x02\x04\\\x03\x02\x02\x02\x06^\x03\x02\x02\x02\bf\x03\x02\x02\x02\nr\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0ex\x03\x02\x02\x02\x10\xb2\x03\x02\x02\x02\x12\xb4\x03\x02\x02\x02\x14\xb6\x03\x02\x02\x02\x16\xb8\x03\x02\x02\x02\x18\xbd\x03\x02\x02\x02\x1a\xc2\x03\x02\x02\x02\x1c\xc7\x03\x02\x02\x02\x1e\xce\x03\x02\x02\x02 \xd0\x03\x02\x02\x02"\xdd\x03\x02\x02\x02$\xdf\x03\x02\x02\x02&\xe9\x03\x02\x02\x02(\xee\x03\x02\x02\x02*\xf0\x03\x02\x02\x02,\xf6\x03\x02\x02\x02.\xf8\x03\x02\x02\x020\xfc\x03\x02\x02\x022\xfe\x03\x02\x02\x024\u0107\x03\x02\x02\x026\u0109\x03\x02\x02\x028\u0111\x03\x02\x02\x02:\u011C\x03\x02\x02\x02<\u011E\x03\x02\x02\x02>\u0120\x03\x02\x02\x02@\u0124\x03\x02\x02\x02B\u0129\x03\x02\x02\x02D\u0131\x03\x02\x02\x02F\u0135\x03\x02\x02\x02H\u0137\x03\x02\x02\x02J\u0139\x03\x02\x02\x02L\u013B\x03\x02\x02\x02N\u013D\x03\x02\x02\x02P\u013F\x03\x02\x02\x02R\u0149\x03\x02\x02\x02TV\x05\x04\x03\x02UT\x03\x02\x02\x02UV\x03\x02\x02\x02VX\x03\x02\x02\x02WY\x05P)\x02XW\x03\x02\x02\x02XY\x03\x02\x02\x02YZ\x03\x02\x02\x02Z[\x07\x02\x02\x03[\x03\x03\x02\x02\x02\\]\x05\x06\x04\x02]\x05\x03\x02\x02\x02^c\x05\b\x05\x02_`\x07\x14\x02\x02`b\x05\b\x05\x02a_\x03\x02\x02\x02be\x03\x02\x02\x02ca\x03\x02\x02\x02cd\x03\x02\x02\x02d\x07\x03\x02\x02\x02ec\x03\x02\x02\x02fk\x05\n\x06\x02gh\x07\x13\x02\x02hj\x05\n\x06\x02ig\x03\x02\x02\x02jm\x03\x02\x02\x02ki\x03\x02\x02\x02kl\x03\x02\x02\x02l	\x03\x02\x02\x02mk\x03\x02\x02\x02no	\x02\x02\x02os\x05\n\x06\x02ps\x05\f\x07\x02qs\x05\x0e\b\x02rn\x03\x02\x02\x02rp\x03\x02\x02\x02rq\x03\x02\x02\x02s\v\x03\x02\x02\x02tu\x07\x03\x02\x02uv\x05\x06\x04\x02vw\x07\x04\x02\x02w\r\x03\x02\x02\x02xy\x05"\x12\x02yz\x05\x10	\x02z\x0f\x03\x02\x02\x02{\x7f\x05\x12\n\x02|\x80\x05.\x18\x02}\x80\x050\x19\x02~\x80\x052\x1a\x02\x7f|\x03\x02\x02\x02\x7f}\x03\x02\x02\x02\x7f~\x03\x02\x02\x02\x80\xb3\x03\x02\x02\x02\x81\x85\x05\x14\v\x02\x82\x86\x05.\x18\x02\x83\x86\x050\x19\x02\x84\x86\x052\x1a\x02\x85\x82\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x84\x03\x02\x02\x02\x86\xb3\x03\x02\x02\x02\x87\x8a\x05\x16\f\x02\x88\x8b\x050\x19\x02\x89\x8b\x052\x1a\x02\x8a\x88\x03\x02\x02\x02\x8a\x89\x03\x02\x02\x02\x8b\xb3\x03\x02\x02\x02\x8c\x8f\x05\x18\r\x02\x8d\x90\x058\x1d\x02\x8e\x90\x052\x1a\x02\x8f\x8d\x03\x02\x02\x02\x8f\x8e\x03\x02\x02\x02\x90\xb3\x03\x02\x02\x02\x91\x92\x05\x1a\x0e\x02\x92\x93\x05.\x18\x02\x93\xb3\x03\x02\x02\x02\x94\x98\x05\x1c\x0f\x02\x95\x99\x05.\x18\x02\x96\x99\x050\x19\x02\x97\x99\x052\x1a\x02\x98\x95\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x97\x03\x02\x02\x02\x99\x9d\x03\x02\x02\x02\x9a\x9c\x05B"\x02\x9b\x9a\x03\x02\x02\x02\x9c\x9f\x03\x02\x02\x02\x9d\x9b\x03\x02\x02\x02\x9d\x9e\x03\x02\x02\x02\x9e\xb3\x03\x02\x02\x02\x9f\x9d\x03\x02\x02\x02\xa0\xa3\x05\x1e\x10\x02\xa1\xa4\x058\x1d\x02\xa2\xa4\x052\x1a\x02\xa3\xa1\x03\x02\x02\x02\xa3\xa2\x03\x02\x02\x02\xa4\xa8\x03\x02\x02\x02\xa5\xa7\x05B"\x02\xa6\xa5\x03\x02\x02\x02\xa7\xaa\x03\x02\x02\x02\xa8\xa6\x03\x02\x02\x02\xa8\xa9\x03\x02\x02\x02\xa9\xb3\x03\x02\x02\x02\xaa\xa8\x03\x02\x02\x02\xab\xaf\x05 \x11\x02\xac\xae\x05D#\x02\xad\xac\x03\x02\x02\x02\xae\xb1\x03\x02\x02\x02\xaf\xad\x03\x02\x02\x02\xaf\xb0\x03\x02\x02\x02\xb0\xb3\x03\x02\x02\x02\xb1\xaf\x03\x02\x02\x02\xb2{\x03\x02\x02\x02\xb2\x81\x03\x02\x02\x02\xb2\x87\x03\x02\x02\x02\xb2\x8c\x03\x02\x02\x02\xb2\x91\x03\x02\x02\x02\xb2\x94\x03\x02\x02\x02\xb2\xa0\x03\x02\x02\x02\xb2\xab\x03\x02\x02\x02\xb3\x11\x03\x02\x02\x02\xb4\xb5	\x03\x02\x02\xb5\x13\x03\x02\x02\x02\xb6\xb7	\x04\x02\x02\xb7\x15\x03\x02\x02\x02\xb8\xb9	\x05\x02\x02\xb9\x17\x03\x02\x02\x02\xba\xbe\x07\x11\x02\x02\xbb\xbc\x07\x15\x02\x02\xbc\xbe\x07\x11\x02\x02\xbd\xba\x03\x02\x02\x02\xbd\xbb\x03\x02\x02\x02\xbe\x19\x03\x02\x02\x02\xbf\xc3\x07\x12\x02\x02\xc0\xc1\x07\x12\x02\x02\xc1\xc3\x07\x15\x02\x02\xc2\xbf\x03\x02\x02\x02\xc2\xc0\x03\x02\x02\x02\xc3\x1b\x03\x02\x02\x02\xc4\xc8\x07\x17\x02\x02\xc5\xc6\x07\x17\x02\x02\xc6\xc8\x07\x15\x02\x02\xc7\xc4\x03\x02\x02\x02\xc7\xc5\x03\x02\x02\x02\xc8\x1d\x03\x02\x02\x02\xc9\xca\x07\x17\x02\x02\xca\xcf\x07\x11\x02\x02\xcb\xcc\x07\x17\x02\x02\xcc\xcd\x07\x15\x02\x02\xcd\xcf\x07\x11\x02\x02\xce\xc9\x03\x02\x02\x02\xce\xcb\x03\x02\x02\x02\xcf\x1f\x03\x02\x02\x02\xd0\xd1\x07\x18\x02\x02\xd1!\x03\x02\x02\x02\xd2\xde\x05*\x16\x02\xd3\xd6\x05(\x15\x02\xd4\xd6\x05&\x14\x02\xd5\xd3\x03\x02\x02\x02\xd5\xd4\x03\x02\x02\x02\xd6\xda\x03\x02\x02\x02\xd7\xd9\x05$\x13\x02\xd8\xd7\x03\x02\x02\x02\xd9\xdc\x03\x02\x02\x02\xda\xd8\x03\x02\x02\x02\xda\xdb\x03\x02\x02\x02\xdb\xde\x03\x02\x02\x02\xdc\xda\x03\x02\x02\x02\xdd\xd2\x03\x02\x02\x02\xdd\xd5\x03\x02\x02\x02\xde#\x03\x02\x02\x02\xdf\xe0\x07\x06\x02\x02\xe0\xe1\x05@!\x02\xe1\xe2\x07\x07\x02\x02\xe2\xe6\x03\x02\x02\x02\xe3\xe5\x05> \x02\xe4\xe3\x03\x02\x02\x02\xe5\xe8\x03\x02\x02\x02\xe6\xe4\x03\x02\x02\x02\xe6\xe7\x03\x02\x02\x02\xe7%\x03\x02\x02\x02\xe8\xe6\x03\x02\x02\x02\xe9\xea\x07%\x02\x02\xea\xeb\x07\x06\x02\x02\xeb\xec\x07#\x02\x02\xec\xed\x07\x07\x02\x02\xed\'\x03\x02\x02\x02\xee\xef	\x06\x02\x02\xef)\x03\x02\x02\x02\xf0\xf1	\x07\x02\x02\xf1+\x03\x02\x02\x02\xf2\xf7\x05.\x18\x02\xf3\xf7\x050\x19\x02\xf4\xf7\x052\x1a\x02\xf5\xf7\x058\x1d\x02\xf6\xf2\x03\x02\x02\x02\xf6\xf3\x03\x02\x02\x02\xf6\xf4\x03\x02\x02\x02\xf6\xf5\x03\x02\x02\x02\xf7-\x03\x02\x02\x02\xf8\xf9\x07\x16\x02\x02\xf9/\x03\x02\x02\x02\xfa\xfd\x05(\x15\x02\xfb\xfd\x05*\x16\x02\xfc\xfa\x03\x02\x02\x02\xfc\xfb\x03\x02\x02\x02\xfd1\x03\x02\x02\x02\xfe\xff\x054\x1b\x02\xff\u0101\x07\x03\x02\x02\u0100\u0102\x056\x1c\x02\u0101\u0100\x03\x02\x02\x02\u0101\u0102\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103\u0104\x07\x04\x02\x02\u01043\x03\x02\x02\x02\u0105\u0108\x05(\x15\x02\u0106\u0108\x05*\x16\x02\u0107\u0105\x03\x02\x02\x02\u0107\u0106\x03\x02\x02\x02\u01085\x03\x02\x02\x02\u0109\u010E\x05@!\x02\u010A\u010B\x07\x05\x02\x02\u010B\u010D\x05@!\x02\u010C\u010A\x03\x02\x02\x02\u010D\u0110\x03\x02\x02\x02\u010E\u010C\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F7\x03\x02\x02\x02\u0110\u010E\x03\x02\x02\x02\u0111\u0112\x05:\x1e\x02\u0112\u0117\x05,\x17\x02\u0113\u0114\x07\x05\x02\x02\u0114\u0116\x05,\x17\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0119\x03\x02\x02\x02\u0117\u0115\x03\x02\x02\x02\u0117\u0118\x03\x02\x02\x02\u0118\u011A\x03\x02\x02\x02\u0119\u0117\x03\x02\x02\x02\u011A\u011B\x05<\x1f\x02\u011B9\x03\x02\x02\x02\u011C\u011D\x07\x03\x02\x02\u011D;\x03\x02\x02\x02\u011E\u011F\x07\x04\x02\x02\u011F=\x03\x02\x02\x02\u0120\u0121\x05@!\x02\u0121?\x03\x02\x02\x02\u0122\u0125\x05(\x15\x02\u0123\u0125\x05*\x16\x02\u0124\u0122\x03\x02\x02\x02\u0124\u0123\x03\x02\x02\x02\u0125A\x03\x02\x02\x02\u0126\u012A\x05F$\x02\u0127\u012A\x05H%\x02\u0128\u012A\x05J&\x02\u0129\u0126\x03\x02\x02\x02\u0129\u0127\x03\x02\x02\x02\u0129\u0128\x03\x02\x02\x02\u012A\u012B\x03\x02\x02\x02\u012B\u012C\x05N(\x02\u012CC\x03\x02\x02\x02\u012D\u0132\x05F$\x02\u012E\u0132\x05H%\x02\u012F\u0132\x05J&\x02\u0130\u0132\x05L\'\x02\u0131\u012D\x03\x02\x02\x02\u0131\u012E\x03\x02\x02\x02\u0131\u012F\x03\x02\x02\x02\u0131\u0130\x03\x02\x02\x02\u0132\u0133\x03\x02\x02\x02\u0133\u0134\x05N(\x02\u0134E\x03\x02\x02\x02\u0135\u0136	\b\x02\x02\u0136G\x03\x02\x02\x02\u0137\u0138\x07\x1e\x02\x02\u0138I\x03\x02\x02\x02\u0139\u013A\x07 \x02\x02\u013AK\x03\x02\x02\x02\u013B\u013C		\x02\x02\u013CM\x03\x02\x02\x02\u013D\u013E\x05,\x17\x02\u013EO\x03\x02\x02\x02\u013F\u0140\x07\x1f\x02\x02\u0140\u0141\x07 \x02\x02\u0141\u0146\x05R*\x02\u0142\u0143\x07\x05\x02\x02\u0143\u0145\x05R*\x02\u0144\u0142\x03\x02\x02\x02\u0145\u0148\x03\x02\x02\x02\u0146\u0144\x03\x02\x02\x02\u0146\u0147\x03\x02\x02\x02\u0147Q\x03\x02\x02\x02\u0148\u0146\x03\x02\x02\x02\u0149\u014B\x05"\x12\x02\u014A\u014C	\n\x02\x02\u014B\u014A\x03\x02\x02\x02\u014B\u014C\x03\x02\x02\x02\u014CS\x03\x02\x02\x02$UXckr\x7f\x85\x8a\x8f\x98\x9d\xa3\xa8\xaf\xb2\xbd\xc2\xc7\xce\xd5\xda\xdd\xe6\xf6\xfc\u0101\u0107\u010E\u0117\u0124\u0129\u0131\u0146\u014B';
    }
    static get _ATN() {
        if (!$fd149865cf75e9bf$export$9c4772e191bdb810.__ATN) $fd149865cf75e9bf$export$9c4772e191bdb810.__ATN = new (0, $es7AZ.ATNDeserializer)().deserialize($g4Hat.toCharArray($fd149865cf75e9bf$export$9c4772e191bdb810._serializedATN));
        return $fd149865cf75e9bf$export$9c4772e191bdb810.__ATN;
    }
}
class $fd149865cf75e9bf$export$ff413535b9575c8 extends (0, $5NlfZ.ParserRuleContext) {
    EOF() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.EOF, 0);
    }
    jqlWhere() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$4148a879cab28017);
    }
    jqlOrderBy() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$534469b9c8f44139);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlQuery;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlQuery) listener.enterJqlQuery(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlQuery) listener.exitJqlQuery(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlQuery) return visitor.visitJqlQuery(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$4148a879cab28017 extends (0, $5NlfZ.ParserRuleContext) {
    jqlOrClause() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$d69831d387793480);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlWhere;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWhere) listener.enterJqlWhere(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWhere) listener.exitJqlWhere(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWhere) return visitor.visitJqlWhere(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$d69831d387793480 extends (0, $5NlfZ.ParserRuleContext) {
    jqlAndClause(i) {
        if (i === undefined) return this.getRuleContexts($fd149865cf75e9bf$export$f16819001158b9e);
        else return this.getRuleContext(i, $fd149865cf75e9bf$export$f16819001158b9e);
    }
    OR(i) {
        if (i === undefined) return this.getTokens($fd149865cf75e9bf$export$9c4772e191bdb810.OR);
        else return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.OR, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlOrClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrClause) listener.enterJqlOrClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrClause) listener.exitJqlOrClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrClause) return visitor.visitJqlOrClause(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$f16819001158b9e extends (0, $5NlfZ.ParserRuleContext) {
    jqlNotClause(i) {
        if (i === undefined) return this.getRuleContexts($fd149865cf75e9bf$export$5e9146f8d5cf1330);
        else return this.getRuleContext(i, $fd149865cf75e9bf$export$5e9146f8d5cf1330);
    }
    AND(i) {
        if (i === undefined) return this.getTokens($fd149865cf75e9bf$export$9c4772e191bdb810.AND);
        else return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.AND, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlAndClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlAndClause) listener.enterJqlAndClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlAndClause) listener.exitJqlAndClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlAndClause) return visitor.visitJqlAndClause(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$5e9146f8d5cf1330 extends (0, $5NlfZ.ParserRuleContext) {
    jqlNotClause() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$5e9146f8d5cf1330);
    }
    NOT() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.NOT, 0);
    }
    BANG() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.BANG, 0);
    }
    jqlSubClause() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$a136a0e9655bfb04);
    }
    jqlTerminalClause() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$23486a2f2ddd5bcd);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlNotClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNotClause) listener.enterJqlNotClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNotClause) listener.exitJqlNotClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNotClause) return visitor.visitJqlNotClause(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$a136a0e9655bfb04 extends (0, $5NlfZ.ParserRuleContext) {
    LPAREN() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.LPAREN, 0);
    }
    jqlOrClause() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$d69831d387793480);
    }
    RPAREN() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlSubClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSubClause) listener.enterJqlSubClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSubClause) listener.exitJqlSubClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSubClause) return visitor.visitJqlSubClause(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$23486a2f2ddd5bcd extends (0, $5NlfZ.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$b33300c3d916229a);
    }
    jqlTerminalClauseRhs() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$93924a205c12d32c);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlTerminalClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlTerminalClause) listener.enterJqlTerminalClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlTerminalClause) listener.exitJqlTerminalClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlTerminalClause) return visitor.visitJqlTerminalClause(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$93924a205c12d32c extends (0, $5NlfZ.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $fd149865cf75e9bf$export$c428f709a58396e5 extends $fd149865cf75e9bf$export$93924a205c12d32c {
    jqlEqualsOperator() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$41e475fc1988e413);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsClause) listener.enterJqlEqualsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsClause) listener.exitJqlEqualsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsClause) return visitor.visitJqlEqualsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$1b131204ef9fa33d extends $fd149865cf75e9bf$export$93924a205c12d32c {
    jqlLikeOperator() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$b76fe5387fdd7efd);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeClause) listener.enterJqlLikeClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeClause) listener.exitJqlLikeClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeClause) return visitor.visitJqlLikeClause(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$d83706ee80a9852a extends $fd149865cf75e9bf$export$93924a205c12d32c {
    jqlComparisonOperator() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$d821da0716b3ec95);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonClause) listener.enterJqlComparisonClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonClause) listener.exitJqlComparisonClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonClause) return visitor.visitJqlComparisonClause(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$2934b8ff22fddd2d extends $fd149865cf75e9bf$export$93924a205c12d32c {
    jqlInOperator() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$178478bfa8292f72);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInClause) listener.enterJqlInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInClause) listener.exitJqlInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInClause) return visitor.visitJqlInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$8b84310182afcf93 extends $fd149865cf75e9bf$export$93924a205c12d32c {
    jqlIsOperator() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$e64c31d2830b66e4);
    }
    jqlEmpty() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$d85a062f90025e5c);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsClause) listener.enterJqlIsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsClause) listener.exitJqlIsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsClause) return visitor.visitJqlIsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$5df295dc7a2cac7c extends $fd149865cf75e9bf$export$93924a205c12d32c {
    jqlWasOperator() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$7e283636700e4a6c);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($fd149865cf75e9bf$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $fd149865cf75e9bf$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasClause) listener.enterJqlWasClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasClause) listener.exitJqlWasClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasClause) return visitor.visitJqlWasClause(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$9ac3367aee261b32 extends $fd149865cf75e9bf$export$93924a205c12d32c {
    jqlWasInOperator() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$b9118b1ed9a78d66);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($fd149865cf75e9bf$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $fd149865cf75e9bf$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInClause) listener.enterJqlWasInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInClause) listener.exitJqlWasInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInClause) return visitor.visitJqlWasInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$7a7defca8628a13c extends $fd149865cf75e9bf$export$93924a205c12d32c {
    jqlChangedOperator() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$493d626ed78ca66);
    }
    jqlChangedPredicate(i) {
        if (i === undefined) return this.getRuleContexts($fd149865cf75e9bf$export$e77e479a48133015);
        else return this.getRuleContext(i, $fd149865cf75e9bf$export$e77e479a48133015);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedClause) listener.enterJqlChangedClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedClause) listener.exitJqlChangedClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedClause) return visitor.visitJqlChangedClause(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$41e475fc1988e413 extends (0, $5NlfZ.ParserRuleContext) {
    EQUALS() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.EQUALS, 0);
    }
    NOT_EQUALS() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.NOT_EQUALS, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlEqualsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsOperator) listener.enterJqlEqualsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsOperator) listener.exitJqlEqualsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsOperator) return visitor.visitJqlEqualsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$b76fe5387fdd7efd extends (0, $5NlfZ.ParserRuleContext) {
    LIKE() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.LIKE, 0);
    }
    NOT_LIKE() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.NOT_LIKE, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlLikeOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeOperator) listener.enterJqlLikeOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeOperator) listener.exitJqlLikeOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeOperator) return visitor.visitJqlLikeOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$d821da0716b3ec95 extends (0, $5NlfZ.ParserRuleContext) {
    LT() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.LT, 0);
    }
    GT() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.GT, 0);
    }
    LTEQ() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.LTEQ, 0);
    }
    GTEQ() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.GTEQ, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlComparisonOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonOperator) listener.enterJqlComparisonOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonOperator) listener.exitJqlComparisonOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonOperator) return visitor.visitJqlComparisonOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$178478bfa8292f72 extends (0, $5NlfZ.ParserRuleContext) {
    IN() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInOperator) listener.enterJqlInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInOperator) listener.exitJqlInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInOperator) return visitor.visitJqlInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$e64c31d2830b66e4 extends (0, $5NlfZ.ParserRuleContext) {
    IS() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.IS, 0);
    }
    NOT() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlIsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsOperator) listener.enterJqlIsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsOperator) listener.exitJqlIsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsOperator) return visitor.visitJqlIsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$7e283636700e4a6c extends (0, $5NlfZ.ParserRuleContext) {
    WAS() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.WAS, 0);
    }
    NOT() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlWasOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasOperator) listener.enterJqlWasOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasOperator) listener.exitJqlWasOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasOperator) return visitor.visitJqlWasOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$b9118b1ed9a78d66 extends (0, $5NlfZ.ParserRuleContext) {
    WAS() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.WAS, 0);
    }
    IN() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlWasInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInOperator) listener.enterJqlWasInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInOperator) listener.exitJqlWasInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInOperator) return visitor.visitJqlWasInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$493d626ed78ca66 extends (0, $5NlfZ.ParserRuleContext) {
    CHANGED() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.CHANGED, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlChangedOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedOperator) listener.enterJqlChangedOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedOperator) listener.exitJqlChangedOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedOperator) return visitor.visitJqlChangedOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$b33300c3d916229a extends (0, $5NlfZ.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlField;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $fd149865cf75e9bf$export$11fec15307d2e17b extends $fd149865cf75e9bf$export$b33300c3d916229a {
    jqlNumber() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$8737d94a1880e8b3);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumberField) listener.enterJqlNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumberField) listener.exitJqlNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumberField) return visitor.visitJqlNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$b8b24f99f985ebb3 extends $fd149865cf75e9bf$export$b33300c3d916229a {
    jqlString() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$bde73d8ad7c8b71e);
    }
    jqlCustomField() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$401a038855cc5b15);
    }
    jqlFieldProperty(i) {
        if (i === undefined) return this.getRuleContexts($fd149865cf75e9bf$export$b02d0b6637ce0593);
        else return this.getRuleContext(i, $fd149865cf75e9bf$export$b02d0b6637ce0593);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNonNumberField) listener.enterJqlNonNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNonNumberField) listener.exitJqlNonNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNonNumberField) return visitor.visitJqlNonNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$b02d0b6637ce0593 extends (0, $5NlfZ.ParserRuleContext) {
    LBRACKET() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.LBRACKET, 0);
    }
    RBRACKET() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.RBRACKET, 0);
    }
    jqlPropertyArgument(i) {
        if (i === undefined) return this.getRuleContexts($fd149865cf75e9bf$export$e20ce4a2ed16372c);
        else return this.getRuleContext(i, $fd149865cf75e9bf$export$e20ce4a2ed16372c);
    }
    jqlArgument() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlFieldProperty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFieldProperty) listener.enterJqlFieldProperty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFieldProperty) listener.exitJqlFieldProperty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFieldProperty) return visitor.visitJqlFieldProperty(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$401a038855cc5b15 extends (0, $5NlfZ.ParserRuleContext) {
    CUSTOMFIELD() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.CUSTOMFIELD, 0);
    }
    LBRACKET() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.LBRACKET, 0);
    }
    POSNUMBER() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    RBRACKET() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.RBRACKET, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlCustomField;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlCustomField) listener.enterJqlCustomField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlCustomField) listener.exitJqlCustomField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlCustomField) return visitor.visitJqlCustomField(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$bde73d8ad7c8b71e extends (0, $5NlfZ.ParserRuleContext) {
    STRING() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.STRING, 0);
    }
    QUOTE_STRING() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.QUOTE_STRING, 0);
    }
    SQUOTE_STRING() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.SQUOTE_STRING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlString;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlString) listener.enterJqlString(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlString) listener.exitJqlString(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlString) return visitor.visitJqlString(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$8737d94a1880e8b3 extends (0, $5NlfZ.ParserRuleContext) {
    POSNUMBER() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    NEGNUMBER() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.NEGNUMBER, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlNumber;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumber) listener.enterJqlNumber(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumber) listener.exitJqlNumber(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumber) return visitor.visitJqlNumber(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$2eaac5a9828bf647 extends (0, $5NlfZ.ParserRuleContext) {
    jqlEmpty() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$ebf0cc785e9ee41a);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$9cb97a63f2be4864);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOperand) listener.enterJqlOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOperand) listener.exitJqlOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOperand) return visitor.visitJqlOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$d85a062f90025e5c extends (0, $5NlfZ.ParserRuleContext) {
    EMPTY() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.EMPTY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlEmpty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEmpty) listener.enterJqlEmpty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEmpty) listener.exitJqlEmpty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEmpty) return visitor.visitJqlEmpty(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$2e17d457b0933bec extends (0, $5NlfZ.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlValue;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValue) listener.enterJqlValue(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValue) listener.exitJqlValue(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValue) return visitor.visitJqlValue(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$ebf0cc785e9ee41a extends (0, $5NlfZ.ParserRuleContext) {
    jqlFunctionName() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$1f5f7ac816788f44);
    }
    LPAREN() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.RPAREN, 0);
    }
    jqlArgumentList() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$83d7c13849b931c3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlFunction;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunction) listener.enterJqlFunction(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunction) listener.exitJqlFunction(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunction) return visitor.visitJqlFunction(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$1f5f7ac816788f44 extends (0, $5NlfZ.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlFunctionName;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunctionName) listener.enterJqlFunctionName(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunctionName) listener.exitJqlFunctionName(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunctionName) return visitor.visitJqlFunctionName(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$83d7c13849b931c3 extends (0, $5NlfZ.ParserRuleContext) {
    jqlArgument(i) {
        if (i === undefined) return this.getRuleContexts($fd149865cf75e9bf$export$a95583953c237f88);
        else return this.getRuleContext(i, $fd149865cf75e9bf$export$a95583953c237f88);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($fd149865cf75e9bf$export$9c4772e191bdb810.COMMA);
        else return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlArgumentList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgumentList) listener.enterJqlArgumentList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgumentList) listener.exitJqlArgumentList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgumentList) return visitor.visitJqlArgumentList(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$9cb97a63f2be4864 extends (0, $5NlfZ.ParserRuleContext) {
    jqlListStart() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$c419f717bfc46a5d);
    }
    jqlOperand(i) {
        if (i === undefined) return this.getRuleContexts($fd149865cf75e9bf$export$2eaac5a9828bf647);
        else return this.getRuleContext(i, $fd149865cf75e9bf$export$2eaac5a9828bf647);
    }
    jqlListEnd() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$f6cd3e372f5ab120);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($fd149865cf75e9bf$export$9c4772e191bdb810.COMMA);
        else return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlList) listener.enterJqlList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlList) listener.exitJqlList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlList) return visitor.visitJqlList(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$c419f717bfc46a5d extends (0, $5NlfZ.ParserRuleContext) {
    LPAREN() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.LPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlListStart;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListStart) listener.enterJqlListStart(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListStart) listener.exitJqlListStart(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListStart) return visitor.visitJqlListStart(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$f6cd3e372f5ab120 extends (0, $5NlfZ.ParserRuleContext) {
    RPAREN() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlListEnd;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListEnd) listener.enterJqlListEnd(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListEnd) listener.exitJqlListEnd(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListEnd) return visitor.visitJqlListEnd(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$e20ce4a2ed16372c extends (0, $5NlfZ.ParserRuleContext) {
    jqlArgument() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlPropertyArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPropertyArgument) listener.enterJqlPropertyArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPropertyArgument) listener.exitJqlPropertyArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPropertyArgument) return visitor.visitJqlPropertyArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$a95583953c237f88 extends (0, $5NlfZ.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgument) listener.enterJqlArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgument) listener.exitJqlArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgument) return visitor.visitJqlArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$9fa1e4d63f31b911 extends (0, $5NlfZ.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$ad402332075c8656);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlWasPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasPredicate) listener.enterJqlWasPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasPredicate) listener.exitJqlWasPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasPredicate) return visitor.visitJqlWasPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$e77e479a48133015 extends (0, $5NlfZ.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$ad402332075c8656);
    }
    jqlValuePredicateOperator() {
        return this.tryGetRuleContext(0, $fd149865cf75e9bf$export$4239d7c0fbafd3f1);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlChangedPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedPredicate) listener.enterJqlChangedPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedPredicate) listener.exitJqlChangedPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedPredicate) return visitor.visitJqlChangedPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$dc01290aee731418 extends (0, $5NlfZ.ParserRuleContext) {
    AFTER() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.AFTER, 0);
    }
    BEFORE() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.BEFORE, 0);
    }
    ON() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.ON, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDatePredicateOperator) listener.enterJqlDatePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDatePredicateOperator) listener.exitJqlDatePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDatePredicateOperator) return visitor.visitJqlDatePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$75412b8b6a6442e1 extends (0, $5NlfZ.ParserRuleContext) {
    DURING() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.DURING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDateRangePredicateOperator) listener.enterJqlDateRangePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDateRangePredicateOperator) listener.exitJqlDateRangePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDateRangePredicateOperator) return visitor.visitJqlDateRangePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$ad402332075c8656 extends (0, $5NlfZ.ParserRuleContext) {
    BY() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.BY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlUserPredicateOperator) listener.enterJqlUserPredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlUserPredicateOperator) listener.exitJqlUserPredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlUserPredicateOperator) return visitor.visitJqlUserPredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$4239d7c0fbafd3f1 extends (0, $5NlfZ.ParserRuleContext) {
    FROM() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.FROM, 0);
    }
    TO() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.TO, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValuePredicateOperator) listener.enterJqlValuePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValuePredicateOperator) listener.exitJqlValuePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValuePredicateOperator) return visitor.visitJqlValuePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$6b796c5a4b8c18e extends (0, $5NlfZ.ParserRuleContext) {
    jqlOperand() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$2eaac5a9828bf647);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlPredicateOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPredicateOperand) listener.enterJqlPredicateOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPredicateOperand) listener.exitJqlPredicateOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPredicateOperand) return visitor.visitJqlPredicateOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$534469b9c8f44139 extends (0, $5NlfZ.ParserRuleContext) {
    ORDER() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.ORDER, 0);
    }
    BY() {
        return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.BY, 0);
    }
    jqlSearchSort(i) {
        if (i === undefined) return this.getRuleContexts($fd149865cf75e9bf$export$c7d8f03f36952a46);
        else return this.getRuleContext(i, $fd149865cf75e9bf$export$c7d8f03f36952a46);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($fd149865cf75e9bf$export$9c4772e191bdb810.COMMA);
        else return this.getToken($fd149865cf75e9bf$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlOrderBy;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrderBy) listener.enterJqlOrderBy(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrderBy) listener.exitJqlOrderBy(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrderBy) return visitor.visitJqlOrderBy(this);
        else return visitor.visitChildren(this);
    }
}
class $fd149865cf75e9bf$export$c7d8f03f36952a46 extends (0, $5NlfZ.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $fd149865cf75e9bf$export$b33300c3d916229a);
    }
    DESC() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.DESC, 0);
    }
    ASC() {
        return this.tryGetToken($fd149865cf75e9bf$export$9c4772e191bdb810.ASC, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $fd149865cf75e9bf$export$9c4772e191bdb810.RULE_jqlSearchSort;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSearchSort) listener.enterJqlSearchSort(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSearchSort) listener.exitJqlSearchSort(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSearchSort) return visitor.visitJqlSearchSort(this);
        else return visitor.visitChildren(this);
    }
}

});

parcelRegister("j2mvV", function(module, exports) {

$parcel$export(module.exports, "JastBuilderErrorListener", () => $71c2dab91f1a459b$export$d0857f60ff1f385);

var $aAJVH = parcelRequire("aAJVH");

var $4OiCB = parcelRequire("4OiCB");
class $71c2dab91f1a459b$export$d0857f60ff1f385 {
    constructor(){
        this.errors = [];
        this.syntaxError = (recognizer, offendingSymbol, line, charPositionInLine, msg)=>{
            if (offendingSymbol === undefined) this.errors.push(new (0, $aAJVH.JQLParseError)(msg));
            else this.errors.push(new (0, $4OiCB.JQLSyntaxError)(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
        };
    }
}

});
parcelRegister("aAJVH", function(module, exports) {

$parcel$export(module.exports, "JQLParseError", () => $a40d66482458d4df$export$e8cfe2b2c93fbd4b);
/**
 * Represents a error occurring when trying to parse JQL into a Jast.
 */ class $a40d66482458d4df$export$e8cfe2b2c93fbd4b extends Error {
    constructor(message, cause){
        super(message);
        this.name = 'JQLParseError';
        this.cause = cause;
        this.description = message;
    }
}

});

parcelRegister("4OiCB", function(module, exports) {

$parcel$export(module.exports, "JQLSyntaxError", () => $ba4fc29bb2980648$export$3276184116160c41);

var $aAJVH = parcelRequire("aAJVH");
class $ba4fc29bb2980648$export$3276184116160c41 extends (0, $aAJVH.JQLParseError) {
    constructor(message, start, stop, line, charPositionInLine){
        super(message);
        this.name = 'JQLSyntaxError';
        this.start = start;
        this.stop = stop;
        this.line = line;
        this.charPositionInLine = charPositionInLine;
    }
}

});


parcelRegister("fvDF4", function(module, exports) {

$parcel$export(module.exports, "QueryVisitor", () => $506f9e10ca9ad63f$export$418003b930734805);

var $2poie = parcelRequire("2poie");

var $lXRbM = parcelRequire("lXRbM");

var $iJeK2 = parcelRequire("iJeK2");

var $iayUe = parcelRequire("iayUe");
class $506f9e10ca9ad63f$export$418003b930734805 extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.whereVisitor = new (0, $iayUe.WhereVisitor)(this.tokens), this.orderByVisitor = new (0, $iJeK2.OrderByVisitor)(this.tokens), this.visitJqlQuery = (ctx)=>{
            const whereContext = ctx.jqlWhere();
            const orderByContext = ctx.jqlOrderBy();
            return (0, $2poie.internalCreators).query(whereContext && whereContext.accept(this.whereVisitor), orderByContext && orderByContext.accept(this.orderByVisitor), (0, $lXRbM.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("lXRbM", function(module, exports) {

$parcel$export(module.exports, "JastBuildingVisitor", () => $f63fd88a0bea8433$export$d3c14d7188b09387);
$parcel$export(module.exports, "getPositionFromToken", () => $f63fd88a0bea8433$export$85a4e6d858dbc6fb);
$parcel$export(module.exports, "getPositionFromContext", () => $f63fd88a0bea8433$export$264629d4cd3cad3f);
$parcel$export(module.exports, "getPositionsFromTerminalNodes", () => $f63fd88a0bea8433$export$30d51184879cbaa8);
$parcel$export(module.exports, "normalizeText", () => $f63fd88a0bea8433$export$7c2714a5250b9239);
class $f63fd88a0bea8433$export$d3c14d7188b09387 {
    constructor(tokens){
        this.tokens = tokens;
    }
    visit(tree) {
        throw new Error('Unsupported operation visit(ParseTree)');
    }
    visitChildren(node) {
        throw new Error('Unsupported operation visitChildren(RuleNode)');
    }
    visitErrorNode(node) {
        throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
    }
    visitTerminal(node) {
        throw new Error('Unsupported operation visitTerminal(TerminalNode)');
    }
}
const $f63fd88a0bea8433$export$85a4e6d858dbc6fb = (startToken, stopToken)=>[
        startToken.startIndex,
        (stopToken || startToken).stopIndex + 1
    ];
const $f63fd88a0bea8433$export$264629d4cd3cad3f = (ctx)=>[
        ctx.start.startIndex,
        ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex
    ];
const $f63fd88a0bea8433$export$30d51184879cbaa8 = (terminalNodes)=>terminalNodes.map((node)=>$f63fd88a0bea8433$export$85a4e6d858dbc6fb(node.payload));
const $f63fd88a0bea8433$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ');

});

parcelRegister("iJeK2", function(module, exports) {

$parcel$export(module.exports, "OrderByVisitor", () => $cd8302d241f3a0a7$export$2774b71b99734811);


var $2poie = parcelRequire("2poie");

var $jr72q = parcelRequire("jr72q");

var $lXRbM = parcelRequire("lXRbM");

var $31nlx = parcelRequire("31nlx");
class $cd8302d241f3a0a7$export$2774b71b99734811 extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.searchSortVisitor = new $cd8302d241f3a0a7$var$SearchSortVisitor(this.tokens), this.visitJqlOrderBy = (ctx)=>{
            // If this rule returned due to an exception then the order by operator is incomplete so we should exit early,
            // e.g. 'order '.
            if (ctx.exception) return undefined;
            const operator = (0, $2poie.internalCreators).orderByOperator((0, $lXRbM.getPositionFromToken)(ctx.ORDER().payload, ctx.BY().payload));
            const fields = ctx.jqlSearchSort().map((searchSortCtx)=>searchSortCtx.accept(this.searchSortVisitor)).filter((0, $jr72q.notUndefined));
            return (0, $2poie.internalCreators).orderBy(fields, operator, (0, $lXRbM.getPositionFromContext)(ctx));
        };
    }
}
class $cd8302d241f3a0a7$var$SearchSortVisitor extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.fieldVisitor = new (0, $31nlx.FieldVisitor)(this.tokens), this.visitJqlSearchSort = (ctx)=>{
            const fieldCtx = ctx.jqlField();
            // If the field rule is returned due to an exception then we should ignore this search search rule. This happens
            // when there are no fields following and order by clause, e.g. 'order by '
            if (fieldCtx.exception) return undefined;
            let direction;
            const desc = ctx.DESC();
            const asc = ctx.ASC();
            if (desc !== undefined) direction = (0, $2poie.internalCreators).orderByDirection((0, $8ff9fbbb483161a6$export$2ea27ea5f2121899), (0, $lXRbM.getPositionFromToken)(desc.payload));
            else if (asc !== undefined) direction = (0, $2poie.internalCreators).orderByDirection((0, $8ff9fbbb483161a6$export$6d60017b9e092e73), (0, $lXRbM.getPositionFromToken)(asc.payload));
            return (0, $2poie.internalCreators).orderByField(ctx.jqlField().accept(this.fieldVisitor), direction, (0, $lXRbM.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("jr72q", function(module, exports) {

$parcel$export(module.exports, "notUndefined", () => $8089096b417a003c$export$9a1adf421b69c6a);
/**
 * Type predicate to assert an argument is not undefined.
 */ function $8089096b417a003c$export$9a1adf421b69c6a(x) {
    return x !== undefined;
}

});

parcelRegister("31nlx", function(module, exports) {

$parcel$export(module.exports, "FieldVisitor", () => $618c251c65335fa3$export$c6a85c4c3bf2317d);

var $2poie = parcelRequire("2poie");

var $4hqU1 = parcelRequire("4hqU1");

var $lXRbM = parcelRequire("lXRbM");

var $fRLVz = parcelRequire("fRLVz");
class $618c251c65335fa3$export$c6a85c4c3bf2317d extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $fRLVz.StringVisitor)(this.tokens), this.fieldPropertyVisitor = new $618c251c65335fa3$var$FieldPropertyVisitor(this.tokens), this.visitJqlNumberField = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $2poie.internalCreators).field(text, text, undefined, (0, $lXRbM.getPositionFromContext)(ctx));
        }, this.visitJqlNonNumberField = (ctx)=>{
            const stringContext = ctx.jqlString();
            const properties = ctx.jqlFieldProperty().map((context)=>context.accept(this.fieldPropertyVisitor));
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $2poie.internalCreators).field(stringValue.value, stringValue.text, properties, (0, $lXRbM.getPositionFromContext)(ctx));
            }
            const text = this.tokens.getText(ctx);
            return (0, $2poie.internalCreators).field(text, text, properties, (0, $lXRbM.getPositionFromContext)(ctx));
        };
    }
}
class $618c251c65335fa3$var$FieldPropertyVisitor extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $4hqU1.ArgumentVisitor)(this.tokens), this.propertyArgumentVisitor = new $618c251c65335fa3$var$PropertyArgumentVisitor(this.tokens), this.visitJqlFieldProperty = (ctx)=>{
            const argumentContext = ctx.jqlArgument();
            const propertyArgumentContext = ctx.jqlPropertyArgument();
            const path = propertyArgumentContext.map((context)=>context.accept(this.propertyArgumentVisitor));
            return (0, $2poie.internalCreators).property(argumentContext && argumentContext.accept(this.argumentVisitor), path, (0, $lXRbM.getPositionFromContext)(ctx));
        };
    }
}
class $618c251c65335fa3$var$PropertyArgumentVisitor extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $4hqU1.ArgumentVisitor)(this.tokens), this.visitJqlPropertyArgument = (ctx)=>{
            return ctx.jqlArgument().accept(this.argumentVisitor);
        };
    }
}

});
parcelRegister("4hqU1", function(module, exports) {

$parcel$export(module.exports, "ArgumentVisitor", () => $d24ff89c20865426$export$46b5a1f6d962d533);

var $2poie = parcelRequire("2poie");

var $lXRbM = parcelRequire("lXRbM");

var $fRLVz = parcelRequire("fRLVz");
class $d24ff89c20865426$export$46b5a1f6d962d533 extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $fRLVz.StringVisitor)(this.tokens), this.visitJqlArgument = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $2poie.internalCreators).argument(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $2poie.internalCreators).argument(text, text, (0, $lXRbM.getPositionFromContext)(ctx));
            }
        };
    }
}

});
parcelRegister("fRLVz", function(module, exports) {

$parcel$export(module.exports, "StringVisitor", () => $7eb0bebc6c7a2a69$export$617850cb96304515);

var $lXRbM = parcelRequire("lXRbM");
class $7eb0bebc6c7a2a69$export$617850cb96304515 extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlString = (ctx)=>{
            const text = this.tokens.getText(ctx);
            const position = (0, $lXRbM.getPositionFromContext)(ctx);
            let value;
            if (ctx.QUOTE_STRING()) value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
            else if (ctx.SQUOTE_STRING()) value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
            else // unquoted string
            value = text;
            return {
                text: text,
                value: value,
                position: position
            };
        };
    }
}

});




parcelRegister("iayUe", function(module, exports) {

$parcel$export(module.exports, "WhereVisitor", () => $de79a04d7265b79e$export$c573472f1d20e15d);


var $2poie = parcelRequire("2poie");

var $jr72q = parcelRequire("jr72q");

var $lXRbM = parcelRequire("lXRbM");

var $dY2gp = parcelRequire("dY2gp");
class $de79a04d7265b79e$export$c573472f1d20e15d extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.terminalClauseVisitor = new (0, $dY2gp.TerminalClauseVisitor)(this.tokens), this.visitJqlWhere = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        }, this.visitJqlOrClause = (ctx)=>{
            const clauses = ctx.jqlAndClause().map((andClauseContext)=>andClauseContext.accept(this)).filter((0, $jr72q.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $2poie.internalCreators).compoundOperator((0, $f6a7331f12a1b6ec$export$7b8f0a728d79a753), (0, $lXRbM.getPositionsFromTerminalNodes)(ctx.OR()));
                return (0, $2poie.internalCreators).compoundClause(operator, clauses, (0, $lXRbM.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        }, this.visitJqlAndClause = (ctx)=>{
            const clauses = ctx.jqlNotClause().map((notClauseContext)=>notClauseContext.accept(this)).filter((0, $jr72q.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $2poie.internalCreators).compoundOperator((0, $f6a7331f12a1b6ec$export$6d6d48d210d3ca97), (0, $lXRbM.getPositionsFromTerminalNodes)(ctx.AND()));
                return (0, $2poie.internalCreators).compoundClause(operator, clauses, (0, $lXRbM.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        }, this.visitJqlNotClause = (ctx)=>{
            const notClauseContext = ctx.jqlNotClause();
            const subClauseContext = ctx.jqlSubClause();
            const terminalClauseContext = ctx.jqlTerminalClause();
            let clause;
            if (notClauseContext !== undefined) clause = notClauseContext.accept(this) || undefined;
            else if (subClauseContext !== undefined) clause = subClauseContext.accept(this) || undefined;
            else if (terminalClauseContext !== undefined) clause = terminalClauseContext.accept(this.terminalClauseVisitor);
            // Our token can be either NOT or !
            let notToken = ctx.NOT();
            notToken = notToken === undefined ? ctx.BANG() : notToken;
            if (notToken && clause) return (0, $2poie.internalCreators).notClause(clause, (0, $2poie.internalCreators).notClauseOperator((0, $lXRbM.getPositionFromToken)(notToken.payload)), (0, $lXRbM.getPositionFromContext)(ctx));
            return clause;
        }, this.visitJqlSubClause = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
    }
}

});
parcelRegister("dY2gp", function(module, exports) {

$parcel$export(module.exports, "TerminalClauseVisitor", () => $0611804f21827b62$export$14576ae5bd1874a9);

var $2poie = parcelRequire("2poie");

var $jr72q = parcelRequire("jr72q");

var $lXRbM = parcelRequire("lXRbM");

var $31nlx = parcelRequire("31nlx");

var $93DOU = parcelRequire("93DOU");

var $kttgF = parcelRequire("kttgF");

var $6LCF3 = parcelRequire("6LCF3");
class $0611804f21827b62$export$14576ae5bd1874a9 extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.fieldVisitor = new (0, $31nlx.FieldVisitor)(this.tokens), this.terminalClauseRhsVisitor = new $0611804f21827b62$var$TerminalClauseRhsVisitor(this.tokens), this.visitJqlTerminalClause = (ctx)=>{
            const field = ctx.jqlField().accept(this.fieldVisitor);
            const { operator: operator, operand: operand, predicates: predicates } = ctx.jqlTerminalClauseRhs().accept(this.terminalClauseRhsVisitor);
            const position = (0, $lXRbM.getPositionFromContext)(ctx);
            return (0, $2poie.internalCreators).terminalClause(field, operator, operand, predicates, position);
        };
    }
}
class $0611804f21827b62$var$TerminalClauseRhsVisitor extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operatorVisitor = new (0, $kttgF.OperatorVisitor)(this.tokens), this.terminalClauseOperandVisitor = new $0611804f21827b62$var$TerminalClauseOperandVisitor(this.tokens), this.predicateVisitor = new (0, $6LCF3.PredicateVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
            const operator = ctx.jqlEqualsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlLikeClause = (ctx)=>{
            const operator = ctx.jqlLikeOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlComparisonClause = (ctx)=>{
            const operator = ctx.jqlComparisonOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlInClause = (ctx)=>{
            const operator = ctx.jqlInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlIsClause = (ctx)=>{
            const operator = ctx.jqlIsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlWasClause = (ctx)=>{
            const operator = ctx.jqlWasOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $jr72q.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        }, this.visitJqlWasInClause = (ctx)=>{
            const operator = ctx.jqlWasInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $jr72q.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        }, this.visitJqlChangedClause = (ctx)=>{
            const operator = ctx.jqlChangedOperator().accept(this.operatorVisitor);
            const predicates = ctx.jqlChangedPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $jr72q.notUndefined));
            return {
                operator: operator,
                operand: undefined,
                predicates: predicates
            };
        }, // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const operator = node.accept(this.operatorVisitor);
            return {
                operator: operator,
                operand: undefined,
                predicates: []
            };
        };
    }
}
class $0611804f21827b62$var$TerminalClauseOperandVisitor extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operandVisitor = new (0, $93DOU.OperandVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlLikeClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlComparisonClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlIsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty()
            ]);
        }, this.visitJqlWasClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlWasInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        }, this.getOperandForContexts = (contexts)=>{
            const operandContext = contexts.find((0, $jr72q.notUndefined));
            return operandContext?.accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("93DOU", function(module, exports) {

$parcel$export(module.exports, "OperandVisitor", () => $f26df4d2c2b4e7dc$export$ef8ae1aa15d9c9af);


var $2poie = parcelRequire("2poie");

var $jr72q = parcelRequire("jr72q");

var $4hqU1 = parcelRequire("4hqU1");

var $lXRbM = parcelRequire("lXRbM");

var $cy1T3 = parcelRequire("cy1T3");

var $fRLVz = parcelRequire("fRLVz");
class $f26df4d2c2b4e7dc$export$ef8ae1aa15d9c9af extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $fRLVz.StringVisitor)(this.tokens), this.numberVisitor = new (0, $cy1T3.NumberVisitor)(this.tokens), this.functionNameVisitor = new $f26df4d2c2b4e7dc$var$FunctionNameVisitor(this.tokens), this.argumentListVisitor = new $f26df4d2c2b4e7dc$var$ArgumentListVisitor(this.tokens), this.visitJqlOperand = (ctx)=>{
            const operandContext = [
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlList(),
                ctx.jqlFunction()
            ].find((0, $jr72q.notUndefined));
            return operandContext?.accept(this);
        }, this.visitJqlEmpty = (ctx)=>{
            // ANTLR will optimistically create a jqlEmpty node in some situations where user input doesn't match the EMPTY
            // token, e.g. when using value operands in IS clauses ("field is value"), where EMPTY is the only valid operand.
            if (ctx.exception) return undefined;
            return (0, $2poie.internalCreators).keywordOperand((0, $f38290926d0398e2$export$1c46dca02aac24dd), (0, $lXRbM.getPositionFromToken)(ctx.EMPTY().payload));
        }, this.visitJqlValue = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $2poie.internalCreators).valueOperand(stringValue.value, stringValue.text, stringValue.position);
            }
            const numberContext = ctx.jqlNumber();
            if (numberContext !== undefined) return numberContext.accept(this.numberVisitor);
        }, this.visitJqlList = (ctx)=>{
            const values = ctx.jqlOperand().map((operandCtx)=>operandCtx.accept(this)).filter((0, $jr72q.notUndefined));
            return (0, $2poie.internalCreators).listOperand(values, (0, $lXRbM.getPositionFromContext)(ctx));
        }, this.visitJqlFunction = (ctx)=>{
            const argumentListContext = ctx.jqlArgumentList();
            return (0, $2poie.internalCreators).functionOperand(ctx.jqlFunctionName().accept(this.functionNameVisitor), argumentListContext === undefined ? [] : argumentListContext.accept(this.argumentListVisitor), (0, $lXRbM.getPositionFromContext)(ctx));
        };
    }
}
class $f26df4d2c2b4e7dc$var$FunctionNameVisitor extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $fRLVz.StringVisitor)(this.tokens), this.visitJqlFunctionName = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $2poie.internalCreators).functionString(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $2poie.internalCreators).functionString(text, text, (0, $lXRbM.getPositionFromContext)(ctx));
            }
        };
    }
}
class $f26df4d2c2b4e7dc$var$ArgumentListVisitor extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $4hqU1.ArgumentVisitor)(this.tokens), this.visitJqlArgumentList = (ctx)=>{
            return ctx.jqlArgument().map((argumentCtx)=>argumentCtx.accept(this.argumentVisitor));
        };
    }
}

});
parcelRegister("cy1T3", function(module, exports) {

$parcel$export(module.exports, "NumberVisitor", () => $bf5d3c406d4497b4$export$a55432f0884633e4);

var $2poie = parcelRequire("2poie");

var $lXRbM = parcelRequire("lXRbM");
class $bf5d3c406d4497b4$export$a55432f0884633e4 extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlNumber = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $2poie.internalCreators).valueOperand(text, text, (0, $lXRbM.getPositionFromContext)(ctx));
        };
    }
}

});


parcelRegister("kttgF", function(module, exports) {

$parcel$export(module.exports, "OperatorVisitor", () => $4e29931e2692b08c$export$e56f89ba95b51d2a);

var $2poie = parcelRequire("2poie");

var $lpN3x = parcelRequire("lpN3x");

var $lXRbM = parcelRequire("lXRbM");
class $4e29931e2692b08c$export$e56f89ba95b51d2a extends (0, $lXRbM.JastBuildingVisitor) {
    visitJqlEqualsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $lpN3x.isEqualsOperator)(text)) throw new Error(`'${text}' does not match any of the recognised equals operators`);
        return (0, $2poie.internalCreators).operator(text, text, (0, $lXRbM.getPositionFromContext)(ctx));
    }
    visitJqlLikeOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $lpN3x.isLikeOperator)(text)) throw new Error(`'${text}' does not match any of the recognised like operators`);
        return (0, $2poie.internalCreators).operator(text, text, (0, $lXRbM.getPositionFromContext)(ctx));
    }
    visitJqlComparisonOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $lpN3x.isComparisonOperator)(text)) throw new Error(`'${text}' does not match any of the recognised comparison operators`);
        return (0, $2poie.internalCreators).operator(text, text, (0, $lXRbM.getPositionFromContext)(ctx));
    }
    visitJqlInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $lXRbM.normalizeText)(text);
        if (!(0, $lpN3x.isInOperator)(value)) // This can happen if an incomplete operator is used, e.g. `status not open`.
        return undefined;
        return (0, $2poie.internalCreators).operator(value, text, (0, $lXRbM.getPositionFromContext)(ctx));
    }
    visitJqlIsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $lXRbM.normalizeText)(text);
        if (!(0, $lpN3x.isIsOperator)(value)) throw new Error(`'${text}' does not match any of the recognised is operators`);
        return (0, $2poie.internalCreators).operator(value, text, (0, $lXRbM.getPositionFromContext)(ctx));
    }
    visitJqlWasOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $lXRbM.normalizeText)(text);
        if (!(0, $lpN3x.isWasOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was operators`);
        return (0, $2poie.internalCreators).operator(value, text, (0, $lXRbM.getPositionFromContext)(ctx));
    }
    visitJqlWasInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $lXRbM.normalizeText)(text);
        if (!(0, $lpN3x.isWasInOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was in operators`);
        return (0, $2poie.internalCreators).operator(value, text, (0, $lXRbM.getPositionFromContext)(ctx));
    }
    visitJqlChangedOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $lXRbM.normalizeText)(text);
        if (!(0, $lpN3x.isChangedOperator)(value)) throw new Error(`'${text}' does not match any of the recognised changed operators`);
        return (0, $2poie.internalCreators).operator(value, text, (0, $lXRbM.getPositionFromContext)(ctx));
    }
    constructor(...args){
        super(...args), // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const { sourceInterval: sourceInterval } = node;
            const text = this.tokens.getText(sourceInterval);
            if (text) {
                const value = (0, $lXRbM.normalizeText)(text);
                const { a: startIndex, b: stopIndex } = sourceInterval;
                const startToken = this.tokens.get(startIndex);
                const stopToken = this.tokens.get(stopIndex);
                const position = (0, $lXRbM.getPositionFromToken)(startToken, stopToken);
                if ((0, $lpN3x.isOperator)(value)) return (0, $2poie.internalCreators).operator(value, text, position);
            }
        };
    }
}

});
parcelRegister("lpN3x", function(module, exports) {

$parcel$export(module.exports, "isOperator", () => $fb1275cc67a193d7$export$4e40859592ee7ac2);
$parcel$export(module.exports, "isEqualsOperator", () => $fb1275cc67a193d7$export$6d0fc196fa8a1673);
$parcel$export(module.exports, "isLikeOperator", () => $fb1275cc67a193d7$export$ad91b6d6a89cb64e);
$parcel$export(module.exports, "isComparisonOperator", () => $fb1275cc67a193d7$export$4477c442bd5c2a6d);
$parcel$export(module.exports, "isInOperator", () => $fb1275cc67a193d7$export$c5e1cdef30e30bff);
$parcel$export(module.exports, "isIsOperator", () => $fb1275cc67a193d7$export$ccc3334744e395c7);
$parcel$export(module.exports, "isWasOperator", () => $fb1275cc67a193d7$export$2b1c5d7e7856f91d);
$parcel$export(module.exports, "isWasInOperator", () => $fb1275cc67a193d7$export$55d8c9b20d99509f);
$parcel$export(module.exports, "isChangedOperator", () => $fb1275cc67a193d7$export$b65d23d23ade534b);
$parcel$export(module.exports, "isListOperator", () => $fb1275cc67a193d7$export$b09522e4061bbdd6);

var $lNgEH = parcelRequire("lNgEH");
const $fb1275cc67a193d7$export$4e40859592ee7ac2 = (operator)=>(0, $lNgEH.OPERATORS).includes(operator);
const $fb1275cc67a193d7$export$6d0fc196fa8a1673 = (operator)=>(0, $lNgEH.EQUALS_OPERATORS).includes(operator);
const $fb1275cc67a193d7$export$ad91b6d6a89cb64e = (operator)=>(0, $lNgEH.LIKE_OPERATORS).includes(operator);
const $fb1275cc67a193d7$export$4477c442bd5c2a6d = (operator)=>(0, $lNgEH.COMPARISON_OPERATORS).includes(operator);
const $fb1275cc67a193d7$export$c5e1cdef30e30bff = (operator)=>(0, $lNgEH.IN_OPERATORS).includes(operator);
const $fb1275cc67a193d7$export$ccc3334744e395c7 = (operator)=>(0, $lNgEH.IS_OPERATORS).includes(operator);
const $fb1275cc67a193d7$export$2b1c5d7e7856f91d = (operator)=>(0, $lNgEH.WAS_OPERATORS).includes(operator);
const $fb1275cc67a193d7$export$55d8c9b20d99509f = (operator)=>(0, $lNgEH.WAS_IN_OPERATORS).includes(operator);
const $fb1275cc67a193d7$export$b65d23d23ade534b = (operator)=>(0, $lNgEH.CHANGED_OPERATORS).includes(operator);
const $fb1275cc67a193d7$export$b09522e4061bbdd6 = (operator)=>(0, $lNgEH.LIST_OPERATORS).includes(operator);

});


parcelRegister("6LCF3", function(module, exports) {

$parcel$export(module.exports, "PredicateVisitor", () => $94e80821e46e05d8$export$33bb52a35c693109);

var $2poie = parcelRequire("2poie");

var $ej9vP = parcelRequire("ej9vP");

var $jr72q = parcelRequire("jr72q");

var $lXRbM = parcelRequire("lXRbM");

var $93DOU = parcelRequire("93DOU");
class $94e80821e46e05d8$export$33bb52a35c693109 extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.predicateOperatorVisitor = new $94e80821e46e05d8$var$PredicateOperatorVisitor(this.tokens), this.predicateOperandVisitor = new $94e80821e46e05d8$var$PredicateOperandVisitor(this.tokens), this.visitJqlWasPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $lXRbM.getPositionFromContext)(ctx);
            return (0, $2poie.internalCreators).predicate(operator, operand, position);
        }, this.visitJqlChangedPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator(),
                ctx.jqlValuePredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $lXRbM.getPositionFromContext)(ctx);
            return (0, $2poie.internalCreators).predicate(operator, operand, position);
        }, this.getOperatorForContexts = (contexts)=>{
            const operatorContext = contexts.find((0, $jr72q.notUndefined));
            if (operatorContext !== undefined) return operatorContext.accept(this.predicateOperatorVisitor);
            else throw new Error('Undefined predicate operator context');
        };
    }
}
class $94e80821e46e05d8$var$PredicateOperatorVisitor extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlDatePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlDateRangePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlUserPredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlValuePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.getPredicateOperator = (ctx)=>{
            const text = this.tokens.getText(ctx);
            // Replace consecutive whitespace chars with single space
            const value = text.toLowerCase().replace(/\s+/g, ' ');
            if (!(0, $ej9vP.isPredicateOperator)(value)) throw new Error(`Found a history predicate operator which does not map to a changed time predicate operator in the ast: ${text}`);
            return (0, $2poie.internalCreators).predicateOperator(value, text, (0, $lXRbM.getPositionFromContext)(ctx));
        };
    }
}
class $94e80821e46e05d8$var$PredicateOperandVisitor extends (0, $lXRbM.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operandVisitor = new (0, $93DOU.OperandVisitor)(this.tokens), this.visitJqlPredicateOperand = (ctx)=>{
            return ctx.jqlOperand().accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("ej9vP", function(module, exports) {

$parcel$export(module.exports, "isPredicateOperator", () => $6cc095f63410fbaa$export$188978ad94919403);

var $gI5hf = parcelRequire("gI5hf");
const $6cc095f63410fbaa$export$188978ad94919403 = (operator)=>(0, $gI5hf.PREDICATE_OPERATORS).includes(operator);

});
parcelRegister("gI5hf", function(module, exports) {

$parcel$export(module.exports, "PREDICATE_OPERATORS", () => $fc46b2a16060812b$export$e200440af9f1d9f);
const $fc46b2a16060812b$export$3d56e2ae1b4bbbf9 = 'after';
const $fc46b2a16060812b$export$f0a816341603bb63 = 'before';
const $fc46b2a16060812b$export$cdc81c84f768d513 = 'by';
const $fc46b2a16060812b$export$8a5280c65e704c3d = 'during';
const $fc46b2a16060812b$export$71f882dcac65f97a = 'from';
const $fc46b2a16060812b$export$5685a35c6b0a7ee8 = 'on';
const $fc46b2a16060812b$export$5a83c4789e531a = 'to';
const $fc46b2a16060812b$export$e200440af9f1d9f = [
    $fc46b2a16060812b$export$3d56e2ae1b4bbbf9,
    $fc46b2a16060812b$export$f0a816341603bb63,
    $fc46b2a16060812b$export$cdc81c84f768d513,
    $fc46b2a16060812b$export$8a5280c65e704c3d,
    $fc46b2a16060812b$export$71f882dcac65f97a,
    $fc46b2a16060812b$export$5685a35c6b0a7ee8,
    $fc46b2a16060812b$export$5a83c4789e531a
];

});







parcelRegister("3c1PD", function(module, exports) {

$parcel$export(module.exports, "print", () => $7aed4a8a81e908e3$export$c2d084dc44961371);

var $8sbs2 = parcelRequire("8sbs2");

var $51oyv = parcelRequire("51oyv");

var $2iKv0 = parcelRequire("2iKv0");
const $7aed4a8a81e908e3$export$c2d084dc44961371 = (jast, options = {})=>{
    return (0, $2iKv0.printDocToString)((0, $51oyv.printAstToDoc)(jast, (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(options, [
        'operatorCase'
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(options, [
        'printWidth'
    ]));
};

});
parcelRegister("8sbs2", function(module, exports) {

var $d3Wo8 = parcelRequire("d3Wo8");

var $lgI96 = parcelRequire("lgI96");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $01969c2a577eb827$var$pick = $lgI96(function(object, paths) {
    return object == null ? {} : $d3Wo8(object, paths);
});
module.exports = $01969c2a577eb827$var$pick;

});
parcelRegister("d3Wo8", function(module, exports) {

var $8WT03 = parcelRequire("8WT03");

var $4tuSC = parcelRequire("4tuSC");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $9828d8da72c16145$var$basePick(object, paths) {
    return $8WT03(object, paths, function(value, path) {
        return $4tuSC(object, path);
    });
}
module.exports = $9828d8da72c16145$var$basePick;

});


parcelRegister("51oyv", function(module, exports) {

$parcel$export(module.exports, "printAstToDoc", () => $e81438da6f043f64$export$f0ef38932978952);


var $7ivol = parcelRequire("7ivol");

var $bWzGo = parcelRequire("bWzGo");
const $e81438da6f043f64$var$formatOperator = (operator, operatorCase)=>{
    switch(operatorCase){
        case 'lower':
            return operator.toLowerCase();
        case 'upper':
            return operator.toUpperCase();
        case 'preserve':
            return operator;
    }
};
class $e81438da6f043f64$export$27a275559a5c8102 extends (0, $7ivol.AbstractJastVisitor) {
    constructor({ operatorCase: operatorCase } = {}){
        super();
        this.operatorCase = operatorCase || 'preserve';
    }
    visitArgument(argument) {
        return argument.text;
    }
    /**
	 * Visit each of the provided nodes and form a new array with each `Doc` joined by the provided separator.
	 */ joinNodes(nodes, separator) {
        const docs = [];
        nodes.forEach((node)=>{
            if (separator !== undefined && docs.length > 0) docs.push(separator);
            docs.push(node.accept(this));
        });
        return docs;
    }
    visitCompoundClause(compoundClause) {
        const operatorDoc = compoundClause.operator.accept(this);
        const clauseDocs = [];
        compoundClause.clauses.forEach((clause)=>{
            if (clauseDocs.length > 0) clauseDocs.push((0, $bWzGo.ifBreak)((0, $bWzGo.newLine)(), ' '), operatorDoc, ' ');
            // Wrap nested compound clauses in parentheses
            if (clause.clauseType === (0, $27a6760b07fae18c$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
            else clauseDocs.push(clause.accept(this));
        });
        return (0, $bWzGo.group)(clauseDocs);
    }
    visitCompoundOperator(compoundOperator) {
        return $e81438da6f043f64$var$formatOperator(compoundOperator.value, this.operatorCase);
    }
    visitField(field) {
        const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
        return (0, $bWzGo.group)([
            field.text,
            ...propertyDocs
        ]);
    }
    visitFunction(functionString) {
        return functionString.text;
    }
    visitFunctionOperand(functionOperand) {
        const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
        return (0, $bWzGo.group)([
            functionOperand.function.accept(this),
            '(',
            ...argumentDocs,
            ')'
        ]);
    }
    visitKeywordOperand(keywordOperand) {
        return keywordOperand.value;
    }
    visitListOperand(listOperand) {
        const operandDocs = this.joinNodes(listOperand.values, ', ');
        return (0, $bWzGo.group)([
            '(',
            ...operandDocs,
            ')'
        ]);
    }
    visitOperator(operator) {
        return $e81438da6f043f64$var$formatOperator(operator.text, this.operatorCase);
    }
    visitOrderBy(orderBy) {
        const fieldDocs = this.joinNodes(orderBy.fields, ', ');
        return (0, $bWzGo.group)([
            orderBy.operator.accept(this),
            ' ',
            ...fieldDocs
        ]);
    }
    visitOrderByDirection(orderByDirection) {
        return orderByDirection.value;
    }
    visitOrderByField(orderByField) {
        const docs = [
            orderByField.field.accept(this)
        ];
        if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
        return (0, $bWzGo.group)(docs);
    }
    visitOrderByOperator(orderByOperator) {
        return $e81438da6f043f64$var$formatOperator(orderByOperator.value, this.operatorCase);
    }
    visitPredicate(predicate) {
        const docs = [
            predicate.operator.accept(this)
        ];
        if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
        return (0, $bWzGo.group)(docs);
    }
    visitPredicateOperator(predicateOperator) {
        return $e81438da6f043f64$var$formatOperator(predicateOperator.text, this.operatorCase);
    }
    visitProperty(property) {
        const docs = [];
        if (property.key) docs.push('[', property.key.accept(this), ']');
        if (property.path) {
            const pathDocs = this.joinNodes(property.path, ' ');
            docs.push(...pathDocs);
        }
        return (0, $bWzGo.group)(docs);
    }
    visitQuery(query) {
        if (query.where && query.orderBy) return (0, $bWzGo.group)([
            query.where.accept(this),
            (0, $bWzGo.ifBreak)((0, $bWzGo.newLine)(), ' '),
            query.orderBy.accept(this)
        ]);
        else if (query.where) return query.where.accept(this);
        else if (query.orderBy) return query.orderBy.accept(this);
        return '';
    }
    visitTerminalClause(terminalClause) {
        const docs = [
            terminalClause.field.accept(this)
        ];
        if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
        if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
        terminalClause.predicates.forEach((predicate)=>{
            docs.push(' ', predicate.accept(this));
        });
        return (0, $bWzGo.group)(docs);
    }
    visitValueOperand(valueOperand) {
        return valueOperand.text;
    }
    visitNotClause(notClause) {
        const clauseDocs = [];
        // Wrap nested compound clauses in parentheses
        if (notClause.clause.clauseType === (0, $27a6760b07fae18c$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
        else clauseDocs.push(notClause.clause.accept(this));
        return (0, $bWzGo.group)([
            notClause.operator.accept(this),
            ' ',
            ...clauseDocs
        ]);
    }
    visitNotClauseOperator(notClauseOperator) {
        return notClauseOperator.value;
    }
    visitChildren() {
        throw new Error('Required visit method not implemented for node');
    }
    defaultResult() {
        return '';
    }
}
const $e81438da6f043f64$export$f0ef38932978952 = (jast, options)=>{
    const astToDocVisitor = new $e81438da6f043f64$export$27a275559a5c8102(options);
    return jast.query ? jast.query.accept(astToDocVisitor) : '';
};

});
parcelRegister("7ivol", function(module, exports) {

$parcel$export(module.exports, "AbstractJastVisitor", () => $39677c0c19a65ed8$export$51be62b46ee668fd);
class $39677c0c19a65ed8$export$51be62b46ee668fd {
    /**
	 * The default implementation calls AstNode#accept on the specified node.
	 * @param node
	 */ visit(node) {
        return node.accept(this);
    }
    /**
	 * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
	 * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
	 * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
	 * aggregate result and the result of visiting the child.
	 */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
	 * Aggregates the results of visiting multiple children of a node.
	 *
	 * The default implementation returns `nextResult`, meaning
	 * {@link #visitChildren} will return the result of the last child visited
	 * (or return the initial value if the node has no children).
	 *
	 * @param aggregate The previous aggregate value. In the default
	 * implementation, the aggregate value is initialized to
	 * {@link #defaultResult}, which is passed as the `aggregate` argument
	 * to this method after the first child node is visited.
	 * @param nextResult The result of the immediately preceeding call to visit
	 * a child node.
	 *
	 * @returns The updated aggregate result.
	 */ aggregateResult(aggregate, nextResult) {
        return nextResult;
    }
    /**
	 * This method is called before visiting each child in
	 * {@link #visitChildren}. When the method is first called\ `currentResult`
	 * will be the initial value (in the default implementation, the initial value
	 * is returned by a call to {@link #defaultResult}).
	 *
	 * The default implementation always returns `true`, indicating that
	 * `visitChildren` should only return after all children are visited.
	 * One reason to override this method is to provide a "short circuit"
	 * evaluation option for situations where the result of visiting a single
	 * child has the potential to determine the result of the visit operation as
	 * a whole.
	 *
	 * @param node The {@link AstNode} whose children are currently being
	 * visited.
	 * @param currentResult The current aggregate result of the children visited
	 * to the current point.
	 *
	 * @returns `true` to continue visiting children. Otherwise return
	 * `false` to stop visiting children and immediately return the
	 * current aggregate result from {@link #visitChildren}.
	 */ shouldVisitNextChild(node, currentResult) {
        return true;
    }
}

});

parcelRegister("bWzGo", function(module, exports) {

$parcel$export(module.exports, "group", () => $6bf864b5d2788cc4$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "ifBreak", () => $6bf864b5d2788cc4$export$1db8e61901dcb0fa);
$parcel$export(module.exports, "newLine", () => $6bf864b5d2788cc4$export$dc84f6841f96b7da);
const $6bf864b5d2788cc4$export$e5e25fbcc1f7affe = (contents)=>{
    return {
        type: 'group',
        contents: contents
    };
};
const $6bf864b5d2788cc4$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
    return {
        type: 'if-break',
        breakContents: breakContents,
        flatContents: flatContents
    };
};
const $6bf864b5d2788cc4$export$dc84f6841f96b7da = ()=>{
    return {
        type: 'new-line'
    };
};

});


parcelRegister("2iKv0", function(module, exports) {

$parcel$export(module.exports, "printDocToString", () => $bdd38eefd0aea4dd$export$316fc7e94b95b118);
const $bdd38eefd0aea4dd$var$computeFlatWidth = (doc)=>{
    if (typeof doc === 'string') return doc.length;
    if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $bdd38eefd0aea4dd$var$computeFlatWidth(innerDoc), 0);
    switch(doc.type){
        case 'group':
            return $bdd38eefd0aea4dd$var$computeFlatWidth(doc.contents);
        case 'if-break':
            return $bdd38eefd0aea4dd$var$computeFlatWidth(doc.flatContents);
        case 'new-line':
            // TODO This probably represents a bug as we don't expect new lines in the flat path
            return 0;
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $bdd38eefd0aea4dd$var$printDoc = (doc, context)=>{
    if (typeof doc === 'string') return {
        result: doc,
        endIndex: context.startIndex + doc.length
    };
    switch(doc.type){
        case 'group':
            return $bdd38eefd0aea4dd$var$printGroup(doc, context);
        case 'if-break':
            return $bdd38eefd0aea4dd$var$printIfBreak(doc, context);
        case 'new-line':
            return $bdd38eefd0aea4dd$var$printNewLine();
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $bdd38eefd0aea4dd$var$printGroup = (doc, context)=>{
    const docWidth = context.startIndex + $bdd38eefd0aea4dd$var$computeFlatWidth(doc);
    const breakContents = context.printWidth !== null && docWidth > context.printWidth;
    return doc.contents.reduce((agg, innerDoc)=>{
        const innerContext = {
            ...context,
            startIndex: agg.endIndex,
            breakContents: breakContents
        };
        const output = $bdd38eefd0aea4dd$var$printDoc(innerDoc, innerContext);
        return {
            result: agg.result + output.result,
            endIndex: output.endIndex
        };
    }, {
        result: '',
        endIndex: context.startIndex
    });
};
const $bdd38eefd0aea4dd$var$printIfBreak = (doc, context)=>{
    if (context.breakContents) return $bdd38eefd0aea4dd$var$printDoc(doc.breakContents, context);
    return $bdd38eefd0aea4dd$var$printDoc(doc.flatContents, context);
};
const $bdd38eefd0aea4dd$var$printNewLine = ()=>{
    return {
        result: '\n',
        // Reset our end index as a new line is being output.
        endIndex: 0
    };
};
// TODO Tweak this number with design
const $bdd38eefd0aea4dd$var$defaultPrintWidth = 100;
const $bdd38eefd0aea4dd$export$316fc7e94b95b118 = (doc, options = {})=>{
    const { printWidth: printWidth = $bdd38eefd0aea4dd$var$defaultPrintWidth } = options;
    const output = $bdd38eefd0aea4dd$var$printDoc(doc, {
        printWidth: printWidth,
        startIndex: 0,
        breakContents: false
    });
    return output.result;
};

});



parcelRegister("5AElp", function(module, exports) {

$parcel$export(module.exports, "transformView", () => $8a756033577bb028$export$601ea8be46c5c28c);
const $8a756033577bb028$export$601ea8be46c5c28c = (view)=>({
        uuid: view.uuid,
        ownerId: view.owner,
        kind: view.visualizationType,
        title: view.name,
        emoji: view.emoji,
        description: view.description,
        apiResponse: view
    });

});



parcelRegister("9Ku9P", function(module, exports) {

$parcel$export(module.exports, "PremiumLozenge", () => $41cd091e8fa03364$export$b37ef9640eaa3746);

var $eJOHy = parcelRequire("eJOHy");

var $b1Zrw = parcelRequire("b1Zrw");

var $eKt3l = parcelRequire("eKt3l");
const $41cd091e8fa03364$export$b37ef9640eaa3746 = ({ children: children })=>{
    const isVisible = (0, $eKt3l.useIsPremiumLozengeVisible)();
    return isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b1Zrw.PaidFeatureAwarenessPremiumLozenge), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};

});
parcelRegister("eKt3l", function(module, exports) {

$parcel$export(module.exports, "useIsPremiumLozengeVisible", () => $12cb4a293a4e170d$export$894065ae16e309f2);

var $eJOHy = parcelRequire("eJOHy");

var $fRXNt = parcelRequire("fRXNt");

var $9HmCl = parcelRequire("9HmCl");

const $12cb4a293a4e170d$export$894065ae16e309f2 = ()=>{
    const isPremium = (0, $fRXNt.useIsPremiumEdition)();
    const productEntitlementDetails = (0, $9HmCl.useProductEntitlementDetails)();
    const trialEndDate = productEntitlementDetails?.[0, $c67afc22d109ff7f$export$9062e724eddb8377]?.trialEndTime;
    return (0, $eJOHy.useMemo)(()=>{
        return isPremium && trialEndDate && trialEndDate - Date.now() > 0;
    }, [
        trialEndDate,
        isPremium
    ]);
};

});
parcelRegister("fRXNt", function(module, exports) {

$parcel$export(module.exports, "useIsPremiumEdition", () => $b0ffb33e1d479a9f$export$8aa8a7878fd61770);
$parcel$export(module.exports, "useIsViewPermissionsEnabled", () => $b0ffb33e1d479a9f$export$a94405ffcb20c356);
$parcel$export(module.exports, "useIsCrossProjectViewsEnabled", () => $b0ffb33e1d479a9f$export$34d097b1cd6f89c1);
$parcel$export(module.exports, "useIsConnectionsEnabled", () => $b0ffb33e1d479a9f$export$304793dd2c5f4db0);

var $7jTnu = parcelRequire("7jTnu");

var $bRJAs = parcelRequire("bRJAs");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");
const $b0ffb33e1d479a9f$export$8aa8a7878fd61770 = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    if ((0, $7jTnu.fg)('polaris_force-premium')) return true;
    const jpdEdition = (0, $a9ldn.getEdition)((0, $bRJAs.JIRA_PRODUCT_DISCOVERY), appEditions);
    // TODO: POL-10089 use entitlements instead of the edition when it will be available
    return jpdEdition === (0, $a9ldn.toEdition)((0, $a9ldn.PREMIUM_EDITION));
};
const $b0ffb33e1d479a9f$export$642bac71144485ad = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    const jpdEdition = (0, $a9ldn.getEdition)((0, $bRJAs.JIRA_PRODUCT_DISCOVERY), appEditions);
    return jpdEdition === (0, $a9ldn.toEdition)((0, $a9ldn.STANDARD_EDITION));
};
const $b0ffb33e1d479a9f$export$a94405ffcb20c356 = ()=>{
    const isPremium = $b0ffb33e1d479a9f$export$8aa8a7878fd61770();
    return isPremium;
};
const $b0ffb33e1d479a9f$export$34d097b1cd6f89c1 = ()=>{
    const isPremium = $b0ffb33e1d479a9f$export$8aa8a7878fd61770();
    return isPremium;
};
const $b0ffb33e1d479a9f$export$304793dd2c5f4db0 = ()=>{
    const isPremium = $b0ffb33e1d479a9f$export$8aa8a7878fd61770();
    const isStandard = $b0ffb33e1d479a9f$export$642bac71144485ad();
    if (isStandard && (0, $7jTnu.fg)('jpd_issues_relationships_eap_lighthouse_customer')) return true;
    return isPremium;
};

});

const $c67afc22d109ff7f$export$9062e724eddb8377 = 'jira-product-discovery';



parcelRegister("fqYMs", function(module, exports) {

$parcel$export(module.exports, "useCollectionSelectedMatch", () => $4f734d559e0a282b$export$f8678ffe77a81702);
$parcel$export(module.exports, "useIsCollectionsSelected", () => $4f734d559e0a282b$export$bff956e91a23208e);
$parcel$export(module.exports, "useIsJpdProjectView", () => $4f734d559e0a282b$export$dbf8a4da34593bdd);
$parcel$export(module.exports, "useIsCollectionSelected", () => $4f734d559e0a282b$export$d1d2d8dc13ec1cf);
$parcel$export(module.exports, "getViewUrl", () => $4f734d559e0a282b$export$bdccd6a672e4a607);

var $kfvK2 = parcelRequire("kfvK2");

var $bQoR3 = parcelRequire("bQoR3");
const $4f734d559e0a282b$export$f8678ffe77a81702 = (0, $kfvK2.createRouterSelector)(({ route: route, match: match })=>{
    const viewUUID = match.params?.resource || undefined;
    const collectionUUID = match.params?.collectionUUID || undefined;
    const isCollectionSelected = route.name === 'polaris-collections' && collectionUUID !== undefined && viewUUID !== undefined;
    return isCollectionSelected ? {
        collectionUUID: collectionUUID,
        viewUUID: viewUUID
    } : undefined;
});
const $4f734d559e0a282b$export$bff956e91a23208e = (0, $kfvK2.createRouterSelector)(({ route: route, match: match })=>{
    const viewUUID = match.params?.resource || undefined;
    const collectionUUID = match.params?.collectionUUID || undefined;
    return route.name === 'polaris-collections' && viewUUID === undefined && collectionUUID === undefined;
});
const $4f734d559e0a282b$export$dbf8a4da34593bdd = (0, $kfvK2.createRouterSelector)(({ route: route, match: match })=>{
    const viewUUID = match.params?.resource || undefined;
    return route.name === 'polaris-ideas' && viewUUID !== undefined;
});
const $4f734d559e0a282b$export$d1d2d8dc13ec1cf = (options)=>{
    const collectionMatched = $4f734d559e0a282b$export$f8678ffe77a81702();
    if (options?.collectionUUID) return collectionMatched && collectionMatched.collectionUUID === options.collectionUUID;
    return Boolean(collectionMatched);
};
const $4f734d559e0a282b$export$bdccd6a672e4a607 = ({ container: container, view: view })=>{
    // In collections we don't use `view.polarisId` like we do in jpd-project-menu
    // but instead we use `view.id` that contains UUID
    return (0, $bQoR3.getCollectionViewPageUrl)(container.collectionUUID, view.id);
};

});

parcelRegister("jThqL", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $a3d4770c7341a93a$export$a06f1c675e846f6f);

var $eJOHy = parcelRequire("eJOHy");

var $2y3Ci = parcelRequire("2y3Ci");
var $ilbtc = parcelRequire("ilbtc");
var $1swHh = parcelRequire("1swHh");

var $lRq8t = parcelRequire("lRq8t");

var $h4Bzb = parcelRequire("h4Bzb");

var $1Ce3C = parcelRequire("1Ce3C");

var $bQoR3 = parcelRequire("bQoR3");

var $jQm53 = parcelRequire("jQm53");

var $92oWt = parcelRequire("92oWt");
const $a3d4770c7341a93a$export$a06f1c675e846f6f = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem } = (0, $eJOHy.useContext)((0, $jQm53.AnalyticContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ilbtc.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1swHh.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Ce3C.ViewAllEntityMenuItem), {
        href: (0, $bQoR3.getCollectionsPageUrl)(),
        menuId: (0, $h4Bzb.MENU_ID_ROADMAPS_VIEW_ALL),
        onClick: (e)=>{
            fireUIAnalyticForFixMenuItem();
            onClose?.(e);
        }
    }, formatMessage((0, $92oWt.default).viewAllRoadmaps)))));
};

});
parcelRegister("jQm53", function(module, exports) {

$parcel$export(module.exports, "AnalyticContext", () => $ec48c897812e3adc$export$da0556bf821b3494);
$parcel$export(module.exports, "AnalyticContextProvider", () => $ec48c897812e3adc$export$aea8e3edcdec81e3);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");




var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $7i4qI = parcelRequire("7i4qI");
const $ec48c897812e3adc$export$da0556bf821b3494 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    fireUIAnalyticForFixMenuItem: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    fireUIAnalyticForFixButton: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    fireUIAnalyticForFavouriteToggle: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    fireUIAnalyticForRoadmapsItems: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});
const $ec48c897812e3adc$export$aea8e3edcdec81e3 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const fireUIAnalyticForFixMenuItem = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
                itemId: (0, $7i4qI.VIEW_ALL_ROADMAPS)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFixButton = (0, $eJOHy.useCallback)(({ itemId: itemId })=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: itemId
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFavouriteToggle = (0, $eJOHy.useCallback)(({ starType: starType, parentItemId: parentItemId })=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$74712b62056d422e),
                parentItemId: parentItemId,
                parentItemType: 'roadmap',
                itemId: starType
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForRoadmapsItems = (0, $eJOHy.useCallback)(({ itemId: itemId, section: section })=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
                itemType: (0, $6bf6536f83c22cfe$export$bb8a37ab8d9ba82b).toLowerCase(),
                itemId: itemId,
                section: section
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const value = (0, $eJOHy.useMemo)(()=>({
            fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem,
            fireUIAnalyticForFixButton: fireUIAnalyticForFixButton,
            fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle,
            fireUIAnalyticForRoadmapsItems: fireUIAnalyticForRoadmapsItems
        }), [
        fireUIAnalyticForFavouriteToggle,
        fireUIAnalyticForFixButton,
        fireUIAnalyticForFixMenuItem,
        fireUIAnalyticForRoadmapsItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec48c897812e3adc$export$da0556bf821b3494.Provider, {
        value: value
    }, children);
};

});

parcelRegister("92oWt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f847c23bf792aa3c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f847c23bf792aa3c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewAllRoadmaps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.footer.view-all-roadmaps",
        "defaultMessage": "View all roadmaps"
    }
});

});



parcelRegister("3n4ak", function(module, exports) {

$parcel$export(module.exports, "ActionButtonsStatic", () => $e387fffe39d8e230$export$d29fef02bcf1ee7);

var $eJOHy = parcelRequire("eJOHy");

var $i140O = parcelRequire("i140O");

var $MlWTN = parcelRequire("MlWTN");

var $9JB3T = parcelRequire("9JB3T");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $8IuE5 = parcelRequire("8IuE5");

var $ajqBI = parcelRequire("ajqBI");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $jQm53 = parcelRequire("jQm53");

var $7i4qI = parcelRequire("7i4qI");

var $dfwn8 = parcelRequire("dfwn8");
const $e387fffe39d8e230$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $8IuE5.L1_MENU_ID).ROADMAPS,
        hasSeparator: false
    }));
const $e387fffe39d8e230$export$d29fef02bcf1ee7 = /*#__PURE__*/ (0, $eJOHy.memo)(({ isReadOnly: isReadOnly, isCreadRoadmapLoading: isCreadRoadmapLoading, isCreateRoadmapDisabled: isCreateRoadmapDisabled, createRoadmapTooltipContent: createRoadmapTooltipContent, onCreateRoadmapClick: onCreateRoadmapClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton } = (0, $eJOHy.useContext)((0, $jQm53.AnalyticContext));
    const handleNavMenuOpen = (0, $eJOHy.useCallback)(()=>{
        fireUIAnalyticForFixButton({
            itemId: (0, $7i4qI.MEATBALL_DROPDOWN)
        });
    }, [
        fireUIAnalyticForFixButton
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: createRoadmapTooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i140O))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $dfwn8.messages).createRoadmap),
        isLoading: isCreadRoadmapLoading,
        isDisabled: isCreateRoadmapDisabled,
        onClick: onCreateRoadmapClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: (0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton') ? handleNavMenuOpen : ()=>fireUIAnalyticForFixButton({
                itemId: (0, $7i4qI.MEATBALL_DROPDOWN)
            }),
        MenuItems: (0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton') ? $e387fffe39d8e230$var$MenuItems : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
                menuId: (0, $8IuE5.L1_MENU_ID).ROADMAPS,
                hasSeparator: false
            }))
    }));
});

});
parcelRegister("dfwn8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fbcd7e20c99885e9$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $fbcd7e20c99885e9$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    createRoadmap: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons-static.create-roadmap",
        "defaultMessage": "Create roadmap"
    }
});

});


parcelRegister("1Pdwr", function(module, exports) {

let $15450b19dd15fe54$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $15450b19dd15fe54$var$load("1VRB2"),
    $15450b19dd15fe54$var$load("bABhq"),
    $15450b19dd15fe54$var$load("cd2SA")
]).then(()=>parcelRequire('7h3zr'));

});


parcelRegister("g0Ue2", function(module, exports) {

$parcel$export(module.exports, "Starred", () => $9ed8831c729c8fd6$export$8cd2a0520fb55072);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $16sa1 = parcelRequire("16sa1");

var $fTYy4 = parcelRequire("fTYy4");

var $fllrh = parcelRequire("fllrh");
const $9ed8831c729c8fd6$export$8cd2a0520fb55072 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4-sidebar-starred"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "starred",
        packageName: (0, $fTYy4.PACKAGE_NAME),
        teamName: (0, $fTYy4.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fllrh.StarredFlyoutMenuItem), null)));

});
parcelRegister("fTYy4", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $992ebd70482a7abb$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $992ebd70482a7abb$export$d57b6b390e78d90f);
$parcel$export(module.exports, "FAVOURITE_QUERY_LIMIT", () => $992ebd70482a7abb$export$77881eca52f4f5a6);
$parcel$export(module.exports, "FAVORITE_TYPE_MAP", () => $992ebd70482a7abb$export$c2849e00cccc2078);
$parcel$export(module.exports, "FAVORITE_TYPE_FILTER_MAP", () => $992ebd70482a7abb$export$531e43cc63c1e036);
$parcel$export(module.exports, "VALID_FAVORITE_TYPES", () => $992ebd70482a7abb$export$336e25f77ad481a9);
$parcel$export(module.exports, "FAVORITE_TYPE_FILTER_MESSAGE_WITH_PROJECT_TERM", () => $992ebd70482a7abb$export$85266ed7d25f274d);
$parcel$export(module.exports, "FAVORITE_TYPE_FILTER_MESSAGE", () => $992ebd70482a7abb$export$de9a288dad6f35f1);
$parcel$export(module.exports, "SEARCH_STARRED_ITEMS", () => $992ebd70482a7abb$export$6b181848cd9c8308);
$parcel$export(module.exports, "FILTER", () => $992ebd70482a7abb$export$c1c49903035a02df);

var $liZWd = parcelRequire("liZWd");
const $992ebd70482a7abb$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Starred';
const $992ebd70482a7abb$export$d57b6b390e78d90f = 'jira-cosmos';
const $992ebd70482a7abb$export$77881eca52f4f5a6 = 15;
const $992ebd70482a7abb$export$c2849e00cccc2078 = {
    PROJECT: 'PROJECT',
    FILTER: 'FILTER',
    DASHBOARD: 'DASHBOARD',
    PLAN: 'PLAN',
    BOARD: 'BOARD',
    QUEUE: 'QUEUE'
};
const $992ebd70482a7abb$export$531e43cc63c1e036 = {
    ...$992ebd70482a7abb$export$c2849e00cccc2078,
    ALL: 'ALL'
};
const $992ebd70482a7abb$export$336e25f77ad481a9 = Object.values($992ebd70482a7abb$export$c2849e00cccc2078);
const $992ebd70482a7abb$export$85266ed7d25f274d = {
    [$992ebd70482a7abb$export$531e43cc63c1e036.PROJECT]: (0, $liZWd.messages).projects,
    [$992ebd70482a7abb$export$531e43cc63c1e036.FILTER]: (0, $liZWd.messages).filters,
    [$992ebd70482a7abb$export$531e43cc63c1e036.DASHBOARD]: (0, $liZWd.messages).dashboards,
    [$992ebd70482a7abb$export$531e43cc63c1e036.PLAN]: (0, $liZWd.messages).plans,
    [$992ebd70482a7abb$export$531e43cc63c1e036.BOARD]: (0, $liZWd.messages).boards,
    [$992ebd70482a7abb$export$531e43cc63c1e036.QUEUE]: (0, $liZWd.messages).queues,
    [$992ebd70482a7abb$export$531e43cc63c1e036.ALL]: (0, $liZWd.messages).all
};
const $992ebd70482a7abb$export$de9a288dad6f35f1 = {
    [$992ebd70482a7abb$export$531e43cc63c1e036.PROJECT]: (0, $liZWd.messages).projectsGalaxia,
    [$992ebd70482a7abb$export$531e43cc63c1e036.FILTER]: (0, $liZWd.messages).filters,
    [$992ebd70482a7abb$export$531e43cc63c1e036.DASHBOARD]: (0, $liZWd.messages).dashboards,
    [$992ebd70482a7abb$export$531e43cc63c1e036.PLAN]: (0, $liZWd.messages).plans,
    [$992ebd70482a7abb$export$531e43cc63c1e036.BOARD]: (0, $liZWd.messages).boards,
    [$992ebd70482a7abb$export$531e43cc63c1e036.QUEUE]: (0, $liZWd.messages).queues,
    [$992ebd70482a7abb$export$531e43cc63c1e036.ALL]: (0, $liZWd.messages).all
};
const $992ebd70482a7abb$export$6b181848cd9c8308 = 'searchStarredItems';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $992ebd70482a7abb$var$VIEW_ALL_STARRED_ITEMS = 'viewAllStarredItems';
const $992ebd70482a7abb$export$c1c49903035a02df = 'filter';

});
parcelRegister("liZWd", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6104af8dee8eec40$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $6104af8dee8eec40$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    projects: {
        "id": "navigation-apps-sidebar-nav4-starred.common.projects",
        "defaultMessage": "Projects"
    },
    filters: {
        "id": "navigation-apps-sidebar-nav4-starred.common.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "navigation-apps-sidebar-nav4-starred.common.dashboards",
        "defaultMessage": "Dashboards"
    },
    plans: {
        "id": "navigation-apps-sidebar-nav4-starred.common.plans",
        "defaultMessage": "Plans"
    },
    boards: {
        "id": "navigation-apps-sidebar-nav4-starred.common.boards",
        "defaultMessage": "Boards"
    },
    queues: {
        "id": "navigation-apps-sidebar-nav4-starred.common.queues",
        "defaultMessage": "Queues"
    },
    all: {
        "id": "navigation-apps-sidebar-nav4-starred.common.all",
        "defaultMessage": "All"
    },
    projectsGalaxia: {
        "id": "navigation-apps-sidebar-nav4-starred.common.projects-galaxia",
        "defaultMessage": "Spaces"
    }
});

});


parcelRegister("fllrh", function(module, exports) {

$parcel$export(module.exports, "StarredFlyoutMenuItem", () => $f51d7f6f962004e1$export$b5a36b539503145d);

var $eJOHy = parcelRequire("eJOHy");

var $1jsTl = parcelRequire("1jsTl");

var $d9oCz = parcelRequire("d9oCz");
var $5jwgZ = parcelRequire("5jwgZ");
var $63KSu = parcelRequire("63KSu");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");


var $a9aec = parcelRequire("a9aec");

var $80rA3 = parcelRequire("80rA3");

var $8IuE5 = parcelRequire("8IuE5");

var $if69u = parcelRequire("if69u");

var $2QH3X = parcelRequire("2QH3X");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");

var $fTYy4 = parcelRequire("fTYy4");

var $57LT2 = parcelRequire("57LT2");

var $hjIwz = parcelRequire("hjIwz");
const $f51d7f6f962004e1$var$EMPTY_OBJECT = {};
function $f51d7f6f962004e1$export$b5a36b539503145d() {
    const cloudId = (0, $kEUB1.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $hjIwz.sidebarStarredMenuEntryPoint), (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            filter: {
                types: (0, $fTYy4.VALID_FAVORITE_TYPES),
                sort: {
                    order: 'DESC'
                }
            },
            count: (0, $fTYy4.FAVOURITE_QUERY_LIMIT)
        }), [
        cloudId
    ]) : {
        cloudId: cloudId,
        filter: {
            types: (0, $fTYy4.VALID_FAVORITE_TYPES),
            sort: {
                order: 'DESC'
            }
        },
        count: (0, $fTYy4.FAVOURITE_QUERY_LIMIT)
    });
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $57LT2.default).starred, (0, (/*@__PURE__*/$parcel$interopDefault($1jsTl))));
    const onOpenChangeHandler = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)(async (isOpen)=>{
        if (isOpen) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $8IuE5.L1_MENU_ID).STARRED);
            (0, $gCeeo.fireUIAnalytics)(event, (0, $a9aec.SECTION_ITEM_STARRED), {
                isInMore: isInMore
            });
        }
    }, [
        createAnalyticsEvent,
        moreMenuIds
    ]) : async (isOpen)=>{
        if (isOpen) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $8IuE5.L1_MENU_ID).STARRED);
            (0, $gCeeo.fireUIAnalytics)(event, (0, $a9aec.SECTION_ITEM_STARRED), {
                isInMore: isInMore
            });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9oCz.FlyoutMenuItem), {
        onOpenChange: onOpenChangeHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $63KSu.FlyoutMenuItemTrigger), {
        interactionName: "nav4-sidebar-starred",
        ref: triggerRef,
        elemBefore: icon
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5jwgZ.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-starred-default",
        packageName: (0, $fTYy4.PACKAGE_NAME),
        teamName: (0, $fTYy4.TEAM_NAME),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
            isFlyout: true,
            withHeading: true,
            withSearch: true
        }),
        // Props for the root component.
        runtimeProps: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? $f51d7f6f962004e1$var$EMPTY_OBJECT : {}
    })));
}

});
parcelRegister("57LT2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c8e62a3a86ce682$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5c8e62a3a86ce682$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    starred: {
        "id": "navigation-apps-sidebar-nav4-starred.starred",
        "defaultMessage": "Starred"
    }
});

});

parcelRegister("hjIwz", function(module, exports) {

$parcel$export(module.exports, "sidebarStarredMenuEntryPoint", () => $afba6c50f7224e36$export$72aec40208131d);

var $2gCFS = parcelRequire("2gCFS");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $afba6c50f7224e36$export$72aec40208131d = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("ht54I")), {
        moduleId: "ab25fe7d",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, filter: filter, count: count })=>({
            queries: {
                starredMenuData: {
                    parameters: $2gCFS.default,
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        count: count,
                        filter: filter
                    }
                }
            }
        })
});

});
parcelRegister("2gCFS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd2eee301c188f14$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7bb03542a269252c90a2aa73c01c6062>>
 * @relayHash f34979afb8cd27df9f4da6c1a31a9ee6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 31e047825e1403b4e5982d0a07da0a9f90eee8f2086996cd6caf739c1a5196dd

var $37Ewn = parcelRequire("37Ewn");
const $fd2eee301c188f14$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v5 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v7 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v12 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isNode"
    }, v13 = [
        v9 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v10 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "filterUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterId"
                },
                v12 /*: any*/ 
            ],
            "type": "JiraFilter",
            "abstractKey": "__isJiraFilter"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "title"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "starredMenuQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "allFavourites",
                                "args": v5 /*: any*/ ,
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v6 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.allFavourites.pageInfo"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "starredMenu_navigationAppsSidebarNav4SidebarsContentStarred"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "starredMenuQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "allFavourites",
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "starredItems",
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v11 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "starredItems",
                            "args": v7 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "StarredMenuListContent_starredItems",
                            "kind": "LinkedHandle",
                            "name": "favourites"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "31e047825e1403b4e5982d0a07da0a9f90eee8f2086996cd6caf739c1a5196dd",
            "metadata": {},
            "name": "starredMenuQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fd2eee301c188f14$var$node.hash = "a986e516464a8c05df425dc6bf3d574d";
(0, $37Ewn.PreloadableQueryRegistry).set($fd2eee301c188f14$var$node.params.id, $fd2eee301c188f14$var$node);
var $fd2eee301c188f14$export$2e2bcd8739ae039 = $fd2eee301c188f14$var$node;

});

parcelRegister("ht54I", function(module, exports) {

let $cb7914e69daf4b33$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cb7914e69daf4b33$var$load("lp2Ob").then(()=>parcelRequire('1kHWg'));

});




parcelRegister("i8N06", function(module, exports) {

$parcel$export(module.exports, "Teams", () => $a66e8fcb2eff0bac$export$b3a34d915d8dd11e);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $16sa1 = parcelRequire("16sa1");


var $lCuJx = parcelRequire("lCuJx");

var $ccYyA = parcelRequire("ccYyA");
const $a66e8fcb2eff0bac$export$b3a34d915d8dd11e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4-sidebar-teams"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "teams",
        packageName: (0, $fc0de1b8d7119b0d$export$b8b9d90f9e5bd72b),
        teamName: (0, $fc0de1b8d7119b0d$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ccYyA.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lCuJx.TeamsMenu), null))));

});
const $fc0de1b8d7119b0d$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Teams';
const $fc0de1b8d7119b0d$export$d57b6b390e78d90f = 'People and Teams Collective';
const $fc0de1b8d7119b0d$export$f17fc93a893ec45c = 'add';
const $fc0de1b8d7119b0d$export$6ee8a54637c51e7d = 'createATeam';
const $fc0de1b8d7119b0d$export$b3dcfa0224e0289c = 'invitePeople';
const $fc0de1b8d7119b0d$export$f06dfcec5ff912e = 'meatballDropdown';
const $fc0de1b8d7119b0d$export$1245c8aac7dab260 = '/jira/people/search';

parcelRegister("lCuJx", function(module, exports) {

$parcel$export(module.exports, "TeamsMenu", () => $4ab3ba2b2051f6c9$export$deb84fb5c6bff4b0);

var $eJOHy = parcelRequire("eJOHy");

var $i0ZlX = parcelRequire("i0ZlX");

var $i140O = parcelRequire("i140O");

var $4BzUI = parcelRequire("4BzUI");

var $1AUsu = parcelRequire("1AUsu");
var $MlWTN = parcelRequire("MlWTN");

var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");

var $aasrU = parcelRequire("aasrU");

var $cNe2t = parcelRequire("cNe2t");

var $lRq8t = parcelRequire("lRq8t");




var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $jRu18 = parcelRequire("jRu18");


var $j6opr = parcelRequire("j6opr");

var $dIJOd = parcelRequire("dIJOd");

var $7jTnu = parcelRequire("7jTnu");

var $286cZ = parcelRequire("286cZ");


var $k8PfX = parcelRequire("k8PfX");

var $cFGzN = parcelRequire("cFGzN");

var $2VH7W = parcelRequire("2VH7W");
const $4ab3ba2b2051f6c9$var$PopupContent = ({ openTeamsPopup: openTeamsPopup, createTeamModalTrigger: createTeamModalTrigger })=>{
    const invitePeopleModalTrigger = (0, $2VH7W.useInvitePeopleModal)();
    const actionSubjectId = (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_TEAMS];
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const onButtonClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                parentItemId: (0, $a9aec.SECTION_ITEM_TEAMS),
                itemId: (0, $fc0de1b8d7119b0d$export$b3dcfa0224e0289c)
            }
        });
        invitePeopleModalTrigger();
        openTeamsPopup(false);
    }, [
        createAnalyticsEvent,
        actionSubjectId,
        invitePeopleModalTrigger,
        openTeamsPopup
    ]);
    const onCreateTeamClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                parentItemId: (0, $a9aec.SECTION_ITEM_TEAMS),
                itemId: (0, $fc0de1b8d7119b0d$export$6ee8a54637c51e7d)
            }
        });
        createTeamModalTrigger();
        openTeamsPopup(false);
    }, [
        createAnalyticsEvent,
        actionSubjectId,
        createTeamModalTrigger,
        openTeamsPopup
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        xcss: $4ab3ba2b2051f6c9$var$teamsMenuStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
        onClick: onButtonClick
    }, formatMessage((0, $k8PfX.default).invitePeople)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
        onClick: onCreateTeamClick
    }, formatMessage((0, $k8PfX.default).createTeam)));
};
const $4ab3ba2b2051f6c9$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $h4Bzb.MENU_ID_TEAMS),
        hasSeparator: false
    }));
const $4ab3ba2b2051f6c9$export$deb84fb5c6bff4b0 = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'), ()=>{
    const [isOpenTeamsPopup, openTeamsPopup] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).TEAMS);
    const location = (0, $jRu18.useLocation)();
    const path = location.pathname + location.search;
    const isSelected = path === (0, $fc0de1b8d7119b0d$export$1245c8aac7dab260);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const actionSubjectId = (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_TEAMS];
    const label = formatMessage((0, $k8PfX.default).addButton);
    const [createTeamModal, createTeamModalTrigger] = (0, $cFGzN.useCreateTeamModal)();
    const invitePeopleModalTrigger = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? undefined : (0, $2VH7W.useInvitePeopleModal)();
    const onLinkClick = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? (0, $eJOHy.useCallback)(()=>{
        sendSectionItemAnalyticsEvent({
            menuId: (0, $8IuE5.L1_MENU_ID).TEAMS,
            sectionItem: (0, $a9aec.SECTION_ITEM_TEAMS)
        });
    }, [
        sendSectionItemAnalyticsEvent
    ]) : ()=>{
        sendSectionItemAnalyticsEvent({
            menuId: (0, $8IuE5.L1_MENU_ID).TEAMS,
            sectionItem: (0, $a9aec.SECTION_ITEM_TEAMS)
        });
    };
    const onPlusButtonClick = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                parentItemId: (0, $a9aec.SECTION_ITEM_TEAMS),
                itemId: (0, $fc0de1b8d7119b0d$export$f17fc93a893ec45c)
            }
        });
        openTeamsPopup(true);
    }, [
        createAnalyticsEvent,
        actionSubjectId
    ]) : ()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                parentItemId: (0, $a9aec.SECTION_ITEM_TEAMS),
                itemId: (0, $fc0de1b8d7119b0d$export$f17fc93a893ec45c)
            }
        });
        openTeamsPopup(true);
    };
    const isTailoredOnboarding = (0, $j6opr.isTailoredOnboardingEnabled)();
    const peopleMenuWrapperRef = (0, $i0ZlX.useRegisterNudgeTarget)((0, $2b839a8453de5367$export$77bc79debbf5c069), isTailoredOnboarding || (0, $7jTnu.fg)('tailored_onboarding_m2p5_gate')).ref;
    const renderContent = (0, $eJOHy.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4ab3ba2b2051f6c9$var$PopupContent, {
            openTeamsPopup: openTeamsPopup,
            createTeamModalTrigger: createTeamModalTrigger
        });
    }, [
        createTeamModalTrigger,
        openTeamsPopup
    ]);
    const onMoreNavMenuButtonClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6),
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: (0, $fc0de1b8d7119b0d$export$f06dfcec5ff912e)
            }
        });
    }, [
        actionSubjectId,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, createTeamModal, (isTailoredOnboarding || (0, $7jTnu.fg)('tailored_onboarding_m2p5_gate')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dIJOd.InviteTeamNudgeAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aasrU.LinkMenuItem), {
        ref: isTailoredOnboarding || (0, $7jTnu.fg)('tailored_onboarding_m2p5_gate') ? peopleMenuWrapperRef : undefined,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-teams.ui.sidenav-teams",
        href: (0, $fc0de1b8d7119b0d$export$1245c8aac7dab260),
        isSelected: isSelected,
        elemBefore: icon,
        onClick: onLinkClick,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
            shouldRenderToParent: true,
            placement: "bottom-start",
            messageId: "navigation-apps-sidebar-nav4-sidebars-content-teams.ui.popup",
            messageType: "transactional",
            onClose: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? (0, $eJOHy.useCallback)(()=>openTeamsPopup(false), []) : ()=>openTeamsPopup(false),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BzUI.default), {
                    ...triggerProps,
                    icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i140O))), {
                            ...iconProps,
                            size: "small"
                        }),
                    appearance: "subtle",
                    spacing: "compact",
                    testId: "navigation-apps-sidebar-nav4-sidebars-content-teams.ui.sidenav-teams-popup-trigger",
                    isSelected: isOpenTeamsPopup,
                    label: label,
                    tooltip: {
                        content: label
                    },
                    isTooltipDisabled: false,
                    onClick: onPlusButtonClick
                }),
            isOpen: isOpenTeamsPopup,
            content: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? renderContent : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
                    xcss: $4ab3ba2b2051f6c9$var$teamsMenuStyle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
                    onClick: ()=>{
                        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: 'dropdownItem',
                            actionSubjectId: actionSubjectId,
                            attributes: {
                                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                                parentItemId: (0, $a9aec.SECTION_ITEM_TEAMS),
                                itemId: (0, $fc0de1b8d7119b0d$export$b3dcfa0224e0289c)
                            }
                        });
                        invitePeopleModalTrigger?.();
                        openTeamsPopup(false);
                    }
                }, formatMessage((0, $k8PfX.default).invitePeople)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
                    onClick: ()=>{
                        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: 'dropdownItem',
                            actionSubjectId: actionSubjectId,
                            attributes: {
                                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                                parentItemId: (0, $a9aec.SECTION_ITEM_TEAMS),
                                itemId: (0, $fc0de1b8d7119b0d$export$6ee8a54637c51e7d)
                            }
                        });
                        createTeamModalTrigger();
                        openTeamsPopup(false);
                    }
                }, formatMessage((0, $k8PfX.default).createTeam)))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
            onOpen: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? onMoreNavMenuButtonClick : ()=>{
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6),
                    actionSubjectId: actionSubjectId,
                    attributes: {
                        level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                        componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                        itemId: (0, $fc0de1b8d7119b0d$export$f06dfcec5ff912e)
                    }
                });
            },
            MenuItems: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? $4ab3ba2b2051f6c9$var$MenuItems : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
                    menuId: (0, $h4Bzb.MENU_ID_TEAMS),
                    hasSeparator: false
                }))
        }))
    }, formattedMessage));
});
const $4ab3ba2b2051f6c9$var$teamsMenuStyle = (0, $5Wv5g.xcss)({
    minWidth: '260px',
    paddingBlock: 'space.100'
});

});
parcelRegister("j6opr", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingScrumAndSoftwareKanbanEnabled", () => $65f12fd0230d3118$export$5dd90adc2e8ee137);
$parcel$export(module.exports, "isTailoredOnboardingEnabled", () => $65f12fd0230d3118$export$8eec918bc6d2ab67);
$parcel$export(module.exports, "isEligibleForTailoredOnboardingM3", () => $65f12fd0230d3118$export$54c132e77bb6d105);
$parcel$export(module.exports, "isEligibleForTailoredOnboardingScrumAndSoftwareKanban", () => $65f12fd0230d3118$export$713219ba4b63fe78);
$parcel$export(module.exports, "useIsTailoredOnboardingEnabledAndEligible", () => $65f12fd0230d3118$export$46047e5fecf4cae5);
$parcel$export(module.exports, "isTailoredOnboardingEnabledWithExposure", () => $65f12fd0230d3118$export$142e2425d224298f);
$parcel$export(module.exports, "useIsTailoredOnboardingM2p5EligibleWithExposure", () => $65f12fd0230d3118$export$fd0589feb622f26b);
$parcel$export(module.exports, "useIsScrumProject", () => $65f12fd0230d3118$export$f9373c9ef51fa1f4);

var $eJOHy = parcelRequire("eJOHy");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $iaU5H = parcelRequire("iaU5H");

var $lMSWJ = parcelRequire("lMSWJ");

var $2aY2d = parcelRequire("2aY2d");

var $dhdXs = parcelRequire("dhdXs");


var $lUto7 = parcelRequire("lUto7");

var $gCeeo = parcelRequire("gCeeo");

var $f1Zdy = parcelRequire("f1Zdy");

var $3wPiD = parcelRequire("3wPiD");
const $65f12fd0230d3118$export$7889b94f54c2d416 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $epTsa.UNSAFE_noExposureExp)('tailored_onboarding_m3');
    return (0, $7jTnu.fg)('tailored_onboarding_m3_gate') && expConfig.get('isEnabled', false);
};
const $65f12fd0230d3118$export$5dd90adc2e8ee137 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $epTsa.UNSAFE_noExposureExp)('tailored_onboarding_scrum_and_software_kanban');
    return expConfig.get('isEnabled', false);
};
const $65f12fd0230d3118$export$8eec918bc6d2ab67 = ()=>{
    return $65f12fd0230d3118$export$7889b94f54c2d416() || $65f12fd0230d3118$export$5dd90adc2e8ee137();
};
const $65f12fd0230d3118$export$54c132e77bb6d105 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin })=>{
    if (!isSiteAdmin) return false;
    const isSoftwareTeamType = teamType === (0, $2b839a8453de5367$export$b8b1ac856ba1434b);
    const isKanbanTemplate = templateKey?.startsWith((0, $dhdXs.KANBAN_TEAM_MANAGED_KEY));
    if (isKanbanTemplate && !isSoftwareTeamType && $65f12fd0230d3118$export$7889b94f54c2d416()) return true;
    return false;
};
const $65f12fd0230d3118$export$713219ba4b63fe78 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin, fireExposure: fireExposure = false, analyticEvent: analyticEvent })=>{
    if (!isSiteAdmin) return false;
    const isSoftwareTeamType = teamType === (0, $2b839a8453de5367$export$b8b1ac856ba1434b);
    const isScrumTemplate = templateKey?.startsWith((0, $dhdXs.SCRUM_TEAM_MANAGED_KEY));
    const isKanbanTemplate = templateKey?.startsWith((0, $dhdXs.KANBAN_TEAM_MANAGED_KEY));
    // Software Kanban or Scrum all Team Types
    if (isKanbanTemplate && isSoftwareTeamType || isScrumTemplate) {
        // User is eligible for experiment. Fires exposure for those in control too here
        if (fireExposure) {
            analyticEvent && (0, $gCeeo.fireTrackAnalytics)(analyticEvent, 'tailoredOnboardingWithScrumAndSoftwareKanban personalised', {
                teamType: teamType,
                templateKey: templateKey,
                isEnabled: (0, $epTsa.expVal)('tailored_onboarding_scrum_and_software_kanban', 'isEnabled', false)
            });
            return (0, $epTsa.expVal)('tailored_onboarding_scrum_and_software_kanban', 'isEnabled', false);
        }
        if ($65f12fd0230d3118$export$5dd90adc2e8ee137()) return true;
    }
    return false;
};
const $65f12fd0230d3118$export$5188e1ffa34f6a91 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin })=>{
    return $65f12fd0230d3118$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    }) || $65f12fd0230d3118$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
};
const $65f12fd0230d3118$export$46047e5fecf4cae5 = ()=>{
    const isEnabled = $65f12fd0230d3118$export$8eec918bc6d2ab67();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const { data: projectData } = (0, $2aY2d.useProjectContext)();
    const projectType = projectData?.projectType;
    const isSoftwareProject = projectType === 'software';
    const shouldFetch = isEnabled && isSiteAdmin && isSoftwareProject && !(0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name');
    const { isReady: teamTypeIsReady, teamType: teamType } = (0, $iaU5H.useTeamTypeShortHand)({
        shouldFetch: shouldFetch
    });
    const { loading: projectContextLoading, data: projectContext } = (0, $2aY2d.useProjectContext)();
    const { isReady: templateKeyIsReady, data: templateKey } = (0, $lMSWJ.useFetchInitialProjectTemplateName)({
        shouldFetch: shouldFetch,
        projectId: projectContext?.projectId
    });
    if ((0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) return {
        isReady: true,
        isTailoredOnboardingM3EnabledAndEligible: false,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: false
    };
    if (!isEnabled) return {
        isReady: true,
        isTailoredOnboardingM3EnabledAndEligible: false,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: false
    };
    const isTailoredOnboardingM3EnabledAndEligible = $65f12fd0230d3118$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
    const isTailoredOnboardingEnabledWithScrumAndSoftware = $65f12fd0230d3118$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
    return {
        isReady: teamTypeIsReady && templateKeyIsReady && !projectContextLoading,
        isTailoredOnboardingM3EnabledAndEligible: isEnabled && isTailoredOnboardingM3EnabledAndEligible,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: isEnabled && isTailoredOnboardingEnabledWithScrumAndSoftware,
        teamType: teamType
    };
};
const $65f12fd0230d3118$export$142e2425d224298f = ({ isSiteAdmin: isSiteAdmin, analyticEvent: analyticEvent, teamType: teamType, templateKey: templateKey })=>{
    if ($65f12fd0230d3118$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    })) {
        (0, $gCeeo.fireTrackAnalytics)(analyticEvent, 'tailoredM3Redirect personalised', {
            teamType: teamType,
            templateKey: templateKey,
            isEnabled: (0, $epTsa.expVal)('tailored_onboarding_m3', 'isEnabled', false)
        });
        return (0, $epTsa.expVal)('tailored_onboarding_m3', 'isEnabled', false);
    }
    return $65f12fd0230d3118$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin,
        fireExposure: true,
        analyticEvent: analyticEvent
    });
};
const $65f12fd0230d3118$export$fd0589feb622f26b = ({ isBusinessProject: isBusinessProject, isTrelloCrossflow: isTrelloCrossflow, isOnboarding: isOnboarding })=>{
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const isBasicEligible = isSiteAdmin && isBusinessProject && !isTrelloCrossflow;
    const { isReady: teamTypeIsReady, teamType: teamType } = (0, $iaU5H.useTeamTypeShortHand)({
        shouldFetch: isBasicEligible
    });
    const isTargettedTeamType = ![
        (0, $2b839a8453de5367$export$4f3cb0844009af52),
        (0, $2b839a8453de5367$export$e4824f74b9879164)
    ].includes(teamType ?? '');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const fireOnce = (0, $eJOHy.useRef)(false);
    if (!isBasicEligible) return {
        isEligible: false,
        isReady: true
    };
    if (!teamTypeIsReady) return {
        isEligible: undefined,
        isReady: false
    };
    if (isBusinessProject && isSiteAdmin && isTargettedTeamType) {
        if (!fireOnce.current) {
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'tailoredM2p5 exposed', {
                teamType: teamType,
                isOnboarding: isOnboarding,
                isEnabled: (0, $epTsa.expVal)('tailored_onboarding_m2p5', 'isEnabled', false)
            });
            fireOnce.current = true;
        }
        return {
            isEligible: (0, $epTsa.expVal)('tailored_onboarding_m2p5', 'isEnabled', false),
            isReady: true,
            teamType: teamType
        };
    }
    return {
        isEligible: false,
        isReady: true,
        teamType: teamType
    };
};
const $65f12fd0230d3118$export$f9373c9ef51fa1f4 = ()=>{
    if (!$65f12fd0230d3118$export$5dd90adc2e8ee137()) return false;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: data } = (0, $3wPiD.useFeatures)();
    return (data?.hasSprint && data?.hasBacklog) ?? false;
};

});
parcelRegister("iaU5H", function(module, exports) {

$parcel$export(module.exports, "useUserEmailDomain", () => $a6df81812f31a424$export$f95c1c6f997ec47f);
$parcel$export(module.exports, "useAtlassianAccount", () => $a6df81812f31a424$export$19d38f479bd18098);
$parcel$export(module.exports, "useTeamTypeShortHand", () => $a6df81812f31a424$export$1a086dfae472ccfe);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $bonXV = parcelRequire("bonXV");


var $afhdY = parcelRequire("afhdY");

var $LT9wJ = parcelRequire("LT9wJ");
const $a6df81812f31a424$export$d4c72bab9d6cc13a = {
    isFetching: false,
    wasFetchedOnce: false,
    fetchError: null
};
const $a6df81812f31a424$var$Store = (0, $GtRbT.createStore)({
    initialState: $a6df81812f31a424$export$d4c72bab9d6cc13a,
    actions: $LT9wJ.actions,
    name: 'atlassian-account'
});
const $a6df81812f31a424$var$loggedInEmailDomainSelector = (0, $4MchI.createSelector)((state)=>state.data, (accountInfo)=>{
    if (!accountInfo) return null;
    const [, loggedInEmailDomain] = accountInfo.email?.split('@') ?? [];
    return loggedInEmailDomain;
});
const $a6df81812f31a424$export$2a9b22328f7b68fa = (0, $iJq0l.createHook)($a6df81812f31a424$var$Store, {
    selector: $a6df81812f31a424$var$loggedInEmailDomainSelector
});
const $a6df81812f31a424$export$f95c1c6f997ec47f = (isEligibleToCall = true)=>{
    const [loggedInEmailDomain, { fetchAtlassianAccountData: fetchAtlassianAccountData }] = $a6df81812f31a424$export$2a9b22328f7b68fa();
    (0, $eJOHy.useEffect)(()=>{
        if (isEligibleToCall && !loggedInEmailDomain) fetchAtlassianAccountData();
    }, [
        fetchAtlassianAccountData,
        isEligibleToCall,
        loggedInEmailDomain
    ]);
    return {
        data: loggedInEmailDomain
    };
};
const $a6df81812f31a424$export$19d38f479bd18098 = (0, $iJq0l.createHook)($a6df81812f31a424$var$Store);
const $a6df81812f31a424$export$1a086dfae472ccfe = ({ shouldFetch: shouldFetch })=>{
    const [{ data: atlassianAccountData, isFetching: isFetching, wasFetchedOnce: wasFetchedOnce }, { fetchAtlassianAccountData: fetchAtlassianAccountData }] = $a6df81812f31a424$export$19d38f479bd18098();
    const localStorageTeamTypeShorthand = (0, $bonXV.localStorageProvider).get((0, $2b839a8453de5367$export$c06666264cd35603));
    (0, $eJOHy.useEffect)(()=>{
        if (shouldFetch && !localStorageTeamTypeShorthand && !isFetching && !wasFetchedOnce) fetchAtlassianAccountData({
            source: 'useTeamTypeShortHand'
        });
    }, [
        fetchAtlassianAccountData,
        isFetching,
        localStorageTeamTypeShorthand,
        shouldFetch,
        wasFetchedOnce
    ]);
    if (localStorageTeamTypeShorthand) return {
        isReady: true,
        teamType: localStorageTeamTypeShorthand
    };
    if (!shouldFetch) return {
        isReady: true,
        teamType: (0, $afhdY.mapUserSegmentationFullToShorthand)(atlassianAccountData?.extendedProfile.teamType)
    };
    if (atlassianAccountData?.extendedProfile.teamType && !localStorageTeamTypeShorthand) (0, $bonXV.localStorageProvider).set((0, $2b839a8453de5367$export$c06666264cd35603), (0, $afhdY.mapUserSegmentationFullToShorthand)(atlassianAccountData.extendedProfile.teamType));
    return {
        isReady: !isFetching && wasFetchedOnce,
        teamType: (0, $afhdY.mapUserSegmentationFullToShorthand)(atlassianAccountData?.extendedProfile.teamType)
    };
};

});
parcelRegister("bonXV", function(module, exports) {

$parcel$export(module.exports, "sessionStorageProvider", () => $d3902f951848120d$export$5a24cb3021127ff7);
$parcel$export(module.exports, "localStorageProvider", () => $d3902f951848120d$export$aa821bfb3308a1f5);

var $dnU6V = parcelRequire("dnU6V");

var $4elgJ = parcelRequire("4elgJ");




const $d3902f951848120d$export$5a24cb3021127ff7 = (0, $4elgJ.createSessionExpirableStorageProvider)('onboarding-core');
const $d3902f951848120d$export$aa821bfb3308a1f5 = (0, $dnU6V.createLocalExpirableStorageProvider)('onboarding-core');

});

parcelRegister("afhdY", function(module, exports) {

$parcel$export(module.exports, "mapUserSegmentationFullToShorthand", () => $42441bb11ea9f3be$export$8897f7082e20c8df);

const $42441bb11ea9f3be$export$8897f7082e20c8df = (teamTypeFromMe)=>{
    switch(teamTypeFromMe){
        case 0, $2b839a8453de5367$export$e07d1fa2da8ed874:
            return 0, $2b839a8453de5367$export$572242e58bd07594;
        case 0, $2b839a8453de5367$export$76dcec3f438d9e56:
            return 0, $2b839a8453de5367$export$d7de553940261eba;
        case 0, $2b839a8453de5367$export$9a574c301f67ba30:
            return 0, $2b839a8453de5367$export$4c29d0d04c15e55d;
        case 0, $2b839a8453de5367$export$363ec144a94029c8:
            return 0, $2b839a8453de5367$export$3950f7f841bf94b6;
        case 0, $2b839a8453de5367$export$df0fb32d68ae1e78:
            return 0, $2b839a8453de5367$export$881249b988b6030f;
        case 0, $2b839a8453de5367$export$d9c0e3e59442fb4:
            return 0, $2b839a8453de5367$export$e4824f74b9879164;
        case 0, $2b839a8453de5367$export$27dbc7d7ce66e6e3:
            return 0, $2b839a8453de5367$export$4f3cb0844009af52;
        case 0, $2b839a8453de5367$export$a5dce388adf922bd:
            return 0, $2b839a8453de5367$export$1a65d50c4a641bb4;
        case 0, $2b839a8453de5367$export$e1473b31a257caff:
            return 0, $2b839a8453de5367$export$9ee64e8fbd8b03a2;
        case 0, $2b839a8453de5367$export$699265ec8ad9a740:
            return 0, $2b839a8453de5367$export$b8b1ac856ba1434b;
        case 0, $2b839a8453de5367$export$85657457db93c2c2:
            return 0, $2b839a8453de5367$export$4f54a09a24fd1d74;
        case 0, $2b839a8453de5367$export$c0c2d1dfaeba89dd:
            return 0, $2b839a8453de5367$export$79685802e8ff1098;
        case 0, $2b839a8453de5367$export$2e6a7ad3ab9c82a3:
            return 0, $2b839a8453de5367$export$e5c438b7501b5a24;
        case 0, $2b839a8453de5367$export$7b60378c3b4372e9:
            return 0, $2b839a8453de5367$export$cbc0e551d91a692d;
        default:
            return teamTypeFromMe;
    }
};

});

parcelRegister("LT9wJ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $bbe4751bb62a1916$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $lbLuD = parcelRequire("lbLuD");
const $bbe4751bb62a1916$export$e324594224ef24da = {
    fetchAtlassianAccountData: ({ source: source } = {})=>async ({ setState: setState, getState: getState })=>{
            const { isFetching: isFetching, wasFetchedOnce: wasFetchedOnce } = getState();
            if (isFetching || wasFetchedOnce) return;
            setState({
                isFetching: true
            });
            try {
                const data = await (0, $lbLuD.getAtlassianAccountWithRethrow)({
                    source: source
                });
                if (data !== null) setState({
                    data: data
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    wasFetchedOnce: true
                });
            }
        }
};

});
parcelRegister("lbLuD", function(module, exports) {

$parcel$export(module.exports, "getAtlassianAccountWithRethrow", () => $6409e4d9657598fd$export$1f20b0741dc598bc);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

const $6409e4d9657598fd$export$1f20b0741dc598bc = async ({ source: source } = {})=>{
    try {
        const { extended_profile: { job_title: jobTitle, team_type: teamType }, email: email, account_id: accountId } = await (0, $jGzN3.performGetRequestWithRetry)((0, $c72c3757ca9ad677$export$80945eb3738bcee8));
        return {
            extendedProfile: {
                jobTitle: jobTitle,
                teamType: teamType
            },
            email: email,
            accountId: accountId
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'getAtlassianAccountWithRethrow',
                packageName: 'jiraAtlassianAccount',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                source: source
            },
            error: error
        });
        throw error;
    }
};

});
const $c72c3757ca9ad677$export$80945eb3738bcee8 = '/gateway/api/me';




parcelRegister("lMSWJ", function(module, exports) {

$parcel$export(module.exports, "useFetchInitialProjectTemplateName", () => $dea82e0ab71f0e3d$export$b11629f839f2f12a);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $2kg86 = parcelRequire("2kg86");
const $dea82e0ab71f0e3d$export$d4c72bab9d6cc13a = {};
const $dea82e0ab71f0e3d$var$store = (0, $GtRbT.createStore)({
    name: 'jira-initial-project-template-name',
    initialState: $dea82e0ab71f0e3d$export$d4c72bab9d6cc13a,
    actions: $2kg86.actions
});
const $dea82e0ab71f0e3d$export$ee6e247e51917971 = (0, $iJq0l.createHook)($dea82e0ab71f0e3d$var$store);
const $dea82e0ab71f0e3d$export$b11629f839f2f12a = ({ shouldFetch: shouldFetch, projectId: projectId })=>{
    const [state, { fetchInitialProjectTemplateName: fetchInitialProjectTemplateName }] = $dea82e0ab71f0e3d$export$ee6e247e51917971();
    (0, $eJOHy.useEffect)(()=>{
        if (shouldFetch && projectId) fetchInitialProjectTemplateName(`${projectId}`);
    }, [
        fetchInitialProjectTemplateName,
        projectId,
        shouldFetch
    ]);
    if (!projectId) return {
        data: undefined,
        isReady: true
    };
    if (!shouldFetch) return {
        // Still return the data if it's already fetched
        // leave it to consumer to decide what to do with it
        data: state[`${projectId}`]?.templateKey,
        isReady: true
    };
    return {
        data: state[`${projectId}`]?.templateKey,
        isReady: state[`${projectId}`]?.fetchStatus === 'fetched'
    };
};

});
parcelRegister("2kg86", function(module, exports) {

$parcel$export(module.exports, "actions", () => $7dff126411e88521$export$e324594224ef24da);

var $bE631 = parcelRequire("bE631");
const $7dff126411e88521$export$e324594224ef24da = {
    fetchInitialProjectTemplateName: (0, $bE631.fetchInitialProjectTemplateNameWithRethrow)
};

});
parcelRegister("bE631", function(module, exports) {

$parcel$export(module.exports, "fetchInitialProjectTemplateNameWithRethrow", () => $b22ec6ff9089c7a6$export$c837cab65def4654);

var $fnu0d = parcelRequire("fnu0d");

var $gYnSx = parcelRequire("gYnSx");

var $bPTb5 = parcelRequire("bPTb5");
const $b22ec6ff9089c7a6$export$c837cab65def4654 = (projectId)=>async ({ getState: getState, setState: setState })=>{
        try {
            const currentState = getState();
            const currentStateForProjectId = currentState[projectId];
            if (currentStateForProjectId?.fetchStatus === 'fetched' || currentStateForProjectId?.fetchStatus === 'fetching') return;
            const localStorageInitialProjectTemplateName = (0, $bPTb5.getLocalStorageInitialProjectTemplateName)({
                projectId: projectId
            });
            if (localStorageInitialProjectTemplateName) {
                setState({
                    [projectId]: {
                        fetchStatus: 'fetched',
                        templateKey: localStorageInitialProjectTemplateName
                    }
                });
                return;
            }
            setState({
                [projectId]: {
                    ...currentStateForProjectId,
                    fetchStatus: 'fetching'
                }
            });
            const response = await (0, $fnu0d.get)({
                consumerMeta: {
                    id: 'fetchInitialProjectTemplateNameWithRethrow',
                    packageName: '@atlassian/jira-onboarding-core',
                    teamName: 'Jlove-Makkuro'
                },
                projectId: projectId,
                projectProperties: [
                    'initial.project.template.name'
                ]
            });
            const templateKey = response?.project?.['initial.project.template.name'];
            if (templateKey) {
                (0, $bPTb5.setLocalStorageInitialProjectTemplateName)({
                    projectId: projectId,
                    templateKey: templateKey
                });
                setState({
                    [projectId]: {
                        fetchStatus: 'fetched',
                        templateKey: templateKey
                    }
                });
            } else setState({
                [projectId]: {
                    fetchStatus: 'fetched',
                    templateKey: ''
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'fetchInitialProjectTemplateNameWithRethrow',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                }
            });
            setState({
                [projectId]: {
                    fetchStatus: 'fetched',
                    templateKey: ''
                }
            });
        }
    };

});
parcelRegister("bPTb5", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageInitialProjectTemplateName", () => $7c91abb4b04bea95$export$82cce58d3eca5268);
$parcel$export(module.exports, "setLocalStorageInitialProjectTemplateName", () => $7c91abb4b04bea95$export$8767e71370b25cc2);

var $dnU6V = parcelRequire("dnU6V");

var $gYnSx = parcelRequire("gYnSx");
const $7c91abb4b04bea95$var$localStorageProvider = (0, $dnU6V.createLocalStorageProvider)('jira-initial-project-template-name');
const $7c91abb4b04bea95$export$82cce58d3eca5268 = ({ projectId: projectId })=>{
    try {
        return $7c91abb4b04bea95$var$localStorageProvider.get(projectId);
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('getLocalStorageInitialProjectTemplateName');
        (0, $gYnSx.default)({
            error: typeGuardedError,
            meta: {
                id: 'getLocalStorageInitialProjectTemplateName',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            }
        });
        return undefined;
    }
};
const $7c91abb4b04bea95$export$8767e71370b25cc2 = ({ projectId: projectId, templateKey: templateKey })=>{
    try {
        $7c91abb4b04bea95$var$localStorageProvider.set(projectId, templateKey);
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('localStorageSetOnboardingPersonalisationResponse');
        (0, $gYnSx.default)({
            error: typeGuardedError,
            meta: {
                id: 'localStorageSetOnboardingPersonalisationResponse',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            }
        });
    }
};

});




parcelRegister("3wPiD", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $429849cdadbc9a3e$export$4a39035bacc4ed76);

var $eJOHy = parcelRequire("eJOHy");

var $dSkLG = parcelRequire("dSkLG");

var $1WzGp = parcelRequire("1WzGp");

var $cZfeH = parcelRequire("cZfeH");

var $fsjYk = parcelRequire("fsjYk");

var $jphFu = parcelRequire("jphFu");
const $429849cdadbc9a3e$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $dSkLG.useJiraSoftwareProjectNavigation)();
    const isEligibleForFeatureToggle = (0, $fsjYk.useShouldApplyFeatureToggle)();
    const [sidebarFeatureToggled] = (0, $1WzGp.useSidebarFeatureToggled)();
    const extractedData = (0, $eJOHy.useMemo)(()=>data && (0, $jphFu.extractData)(data), [
        data
    ]);
    // merged feature status before navigation resource gets refreshed
    // if and only if there are features toggled and they are eligible for the feature
    const features = (0, $eJOHy.useMemo)(()=>{
        if (!extractedData || !isEligibleForFeatureToggle || !sidebarFeatureToggled) return extractedData;
        return {
            ...extractedData,
            ...sidebarFeatureToggled
        };
    }, [
        extractedData,
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    (0, $cZfeH.useClearSidebarToggled)();
    return {
        data: features,
        loading: loading,
        error: error
    };
};

});
parcelRegister("1WzGp", function(module, exports) {

$parcel$export(module.exports, "useFeature", () => $2c23860c2dfc0b9e$export$fc97652867e5867e);
$parcel$export(module.exports, "useEnablingFeature", () => $2c23860c2dfc0b9e$export$207b461610a7fca6);
$parcel$export(module.exports, "useSidebarFeatureToggled", () => $2c23860c2dfc0b9e$export$9eef668f94562feb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $gpE3r = parcelRequire("gpE3r");
const $2c23860c2dfc0b9e$var$initialState = {
    features: [],
    isLoading: false,
    enablingFeatures: [],
    isFetchError: false,
    sidebarFeatureToggled: null
};
const $2c23860c2dfc0b9e$var$store = (0, $GtRbT.createStore)({
    name: 'feature-toggle',
    initialState: $2c23860c2dfc0b9e$var$initialState,
    actions: $gpE3r.actions
});
const $2c23860c2dfc0b9e$export$fc97652867e5867e = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store);
const $2c23860c2dfc0b9e$export$207b461610a7fca6 = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store, {
    selector: (state, { feature: feature })=>state.enablingFeatures.some((f)=>f === feature)
});
const $2c23860c2dfc0b9e$export$e7699ed698eeb9ec = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store, {
    selector: (state, { feature: feature })=>state.features.find((f)=>f.feature === feature)?.state
});
const $2c23860c2dfc0b9e$export$9eef668f94562feb = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store, {
    selector: (state)=>state.sidebarFeatureToggled
});

});
parcelRegister("gpE3r", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e143742cb7786e84$export$e324594224ef24da);

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");

var $2DEdX = parcelRequire("2DEdX");

var $75UwL = parcelRequire("75UwL");

var $dFKLJ = parcelRequire("dFKLJ");

var $5ekEZ = parcelRequire("5ekEZ");
const $e143742cb7786e84$var$clearSiderbarFeatureToggled = ()=>({ setState: setState })=>{
        setState({
            sidebarFeatureToggled: null
        });
    };
const $e143742cb7786e84$var$fetchFeatures = (boardId)=>async ({ getState: getState, setState: setState })=>{
        const { features: features, isLoading: isLoading } = getState();
        if (isLoading) return;
        setState({
            isFetchError: false
        });
        try {
            if (features.length === 0) {
                setState({
                    isLoading: true
                });
                const data = await (0, $dFKLJ.getBoardFeatures)(boardId);
                const filteredFeatures = (0, $75UwL.filterAndSort)(data);
                (0, $75UwL.fireErrorAnalyticsOnUnmatchFeatureKey)(filteredFeatures);
                setState({
                    isLoading: false,
                    features: filteredFeatures
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetchError: true,
                isLoading: false
            });
            (0, $gYnSx.default)({
                meta: {
                    ...(0, $2DEdX.commonErrorAnalyticsMeta),
                    id: 'fetchFeatures'
                },
                error: error
            });
        }
    };
const $e143742cb7786e84$var$syncFeatures = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
        const { features: features } = getState();
        const featureMap = (0, $2DEdX.getFeatureMap)();
        const synced = features.map((f)=>{
            const id = f.feature;
            if (featureMap[id]) {
                const { statusKey: statusKey } = featureMap[id];
                return {
                    ...f,
                    state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                };
            }
            return f;
        });
        setState({
            features: synced
        });
    };
const $e143742cb7786e84$var$updateFeature = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
        const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
        const featureMap = (0, $2DEdX.getFeatureMap)();
        const currentStatus = features.find((f)=>f.feature === feature)?.state;
        const isEnabling = currentStatus === 'DISABLED';
        if (!boardId || feature.length === 0 || !currentStatus) return;
        try {
            // Optimistically update the toggle status before the API call finishes
            // and add feature to the enabling states
            setState({
                features: features.map((0, $75UwL.updateFeatureState)(feature, dependentFeature)),
                sidebarFeatureToggled: {
                    ...sidebarFeatureToggled ?? {},
                    [featureMap[feature].statusKey]: isEnabling,
                    ...dependentFeature && {
                        [featureMap[dependentFeature].statusKey]: isEnabling
                    }
                },
                ...isEnabling && {
                    enablingFeatures: [
                        ...enablingFeatures,
                        feature
                    ]
                }
            });
            await (0, $5ekEZ.updateBoardFeature)({
                boardId: boardId,
                feature: feature,
                enabling: isEnabling
            });
            (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                featureId: feature,
                newStatus: currentStatus
            });
            onAfterUpdate?.(feature, isEnabling);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onError?.();
            setState({
                features: features,
                sidebarFeatureToggled: sidebarFeatureToggled
            });
            (0, $gYnSx.default)({
                meta: {
                    ...(0, $2DEdX.commonErrorAnalyticsMeta),
                    id: 'updateFeature'
                },
                error: error
            });
        }
        if (isEnabling) setState({
            // feature has been enabled, remove from enabling state
            enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
        });
    };
const $e143742cb7786e84$export$e324594224ef24da = {
    fetchFeatures: $e143742cb7786e84$var$fetchFeatures,
    updateFeature: $e143742cb7786e84$var$updateFeature,
    syncFeatures: $e143742cb7786e84$var$syncFeatures,
    clearSiderbarFeatureToggled: $e143742cb7786e84$var$clearSiderbarFeatureToggled
};

});
parcelRegister("2DEdX", function(module, exports) {

$parcel$export(module.exports, "commonErrorAnalyticsMeta", () => $5997e650472e24c4$export$47825241dc3c472c);
$parcel$export(module.exports, "MANAGE_FEATURE_MENU_ITEM_TEST_ID", () => $5997e650472e24c4$export$143e1d685830adbe);
$parcel$export(module.exports, "getFeatureMap", () => $5997e650472e24c4$export$6ac50cf33852adb5);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $5997e650472e24c4$export$f5e4c120ac01b615);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $LFmXM = parcelRequire("LFmXM");

var $8oHgS = parcelRequire("8oHgS");

var $415Kd = parcelRequire("415Kd");

var $4prz0 = parcelRequire("4prz0");

var $efzee = parcelRequire("efzee");

var $mEt3r = parcelRequire("mEt3r");

var $dPFdN = parcelRequire("dPFdN");
const $5997e650472e24c4$export$47825241dc3c472c = {
    packageName: 'jiraTmpFeatureToggle',
    teamName: 'jlove-makkuro'
};
const $5997e650472e24c4$export$143e1d685830adbe = 'manage-feature-menu-item';
const $5997e650472e24c4$export$a712b1e96d47b856 = {
    'jsw.agility.simple-roadmap': {
        descriptionKey: 'timelineDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dPFdN))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasRoadmap',
        order: 10,
        redirectOn: [
            'software-timeline',
            'software-roadmap'
        ]
    },
    'jsw.agility.backlog': {
        descriptionKey: 'backlogDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8oHgS))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBacklog',
        order: 20,
        redirectOn: [
            'software-backlog'
        ]
    },
    'jsw.agility.board': {
        descriptionKey: 'boardDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($415Kd))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBoard',
        order: 30
    },
    'jsw.agility.issue_navigator': {
        descriptionKey: 'issueNavigatorDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($efzee))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasSIN',
        order: 40,
        redirectOn: [
            'software-issue-navigator',
            'issue'
        ]
    },
    'jsw.agility.sprints': {
        descriptionKey: 'releasesDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        statusKey: 'hasSprint',
        order: 50,
        isHidden: true
    }
}; // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>
const $5997e650472e24c4$export$6ac50cf33852adb5 = (0, $LFmXM.default)(({ isSimplifyNavExperimentEnabled: isSimplifyNavExperimentEnabled } = {})=>({
        'jsw.agility.simple-roadmap': {
            descriptionKey: 'timelineDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dPFdN))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasRoadmap',
            order: 10,
            redirectOn: [
                'software-timeline',
                'software-roadmap'
            ]
        },
        'jsw.agility.backlog': {
            descriptionKey: 'backlogDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8oHgS))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBacklog',
            order: 20,
            redirectOn: [
                'software-backlog'
            ]
        },
        'jsw.agility.board': {
            descriptionKey: 'boardDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($415Kd))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBoard',
            order: 30
        },
        ...!isSimplifyNavExperimentEnabled && {
            'jsw.agility.issue_navigator': {
                descriptionKey: 'issueNavigatorDescription',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($efzee))), {
                    spacing: "spacious",
                    label: ""
                }),
                statusKey: 'hasSIN',
                order: 40,
                redirectOn: [
                    'software-issue-navigator',
                    'issue'
                ]
            }
        },
        'jsw.agility.sprints': {
            descriptionKey: 'releasesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
            statusKey: 'hasSprint',
            order: 50,
            isHidden: true
        },
        'jsw.agility.pages': {
            descriptionKey: 'projectPagesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mEt3r))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasPages',
            order: 60,
            redirectOn: [
                'project-pages'
            ]
        },
        'jsw.agility.list_view': {
            descriptionKey: 'listDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4prz0))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasList',
            order: 35,
            redirectOn: [
                'software-list'
            ]
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))); // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>;
const $5997e650472e24c4$export$f5e4c120ac01b615 = 'feature-toggle-error-flag';

});
parcelRegister("8oHgS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8757186054f9d759a1f776986ffd32d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61d22163450f7d52$var$_react = $61d22163450f7d52$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $61d22163450f7d52$var$_backlog = $61d22163450f7d52$var$_interopRequireDefault((parcelRequire("87mBE")));

var $61d22163450f7d52$var$_backlog2 = $61d22163450f7d52$var$_interopRequireDefault((parcelRequire("56yoc")));
function $61d22163450f7d52$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BacklogIcon.
 * This component is BacklogIcon, with `UNSAFE_fallbackIcon` set to "BacklogIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61d22163450f7d52$var$BacklogIcon = (props)=>/*#__PURE__*/ $61d22163450f7d52$var$_react.default.createElement($61d22163450f7d52$var$_backlog.default, Object.assign({
        LEGACY_fallbackIcon: $61d22163450f7d52$var$_backlog2.default
    }, props));
$61d22163450f7d52$var$BacklogIcon.Name = 'BacklogIconMigration';
var $61d22163450f7d52$var$_default = module.exports.default = $61d22163450f7d52$var$BacklogIcon;

});
parcelRegister("87mBE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e90834c69f17e47$var$_react = $5e90834c69f17e47$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5e90834c69f17e47$var$_baseNew = $5e90834c69f17e47$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $5e90834c69f17e47$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e90834c69f17e47$var$BacklogIcon = (props)=>/*#__PURE__*/ $5e90834c69f17e47$var$_react.default.createElement($5e90834c69f17e47$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$5e90834c69f17e47$var$BacklogIcon.displayName = 'BacklogIcon';
var $5e90834c69f17e47$var$_default = module.exports.default = $5e90834c69f17e47$var$BacklogIcon;

});

parcelRegister("56yoc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b783045eed6d3aa$var$_react = $3b783045eed6d3aa$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $3b783045eed6d3aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3b783045eed6d3aa$var$BacklogIcon = (props)=>/*#__PURE__*/ $3b783045eed6d3aa$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.002C5 19 17 19 17 19v-2.002C17 17 5 17 5 17zm-2-2.004C3 15.894 3.895 15 4.994 15h12.012c1.101 0 1.994.898 1.994 1.998v2.004A1.997 1.997 0 0 1 17.006 21H4.994A2 2 0 0 1 3 19.002z"/><path d="M5 15h12v-2H5zm-2-4h16v6H3z"/><path d="M7 11.002C7 11 19 11 19 11V8.998C19 9 7 9 7 9zM5 8.998C5 7.894 5.895 7 6.994 7h12.012C20.107 7 21 7.898 21 8.998v2.004A1.997 1.997 0 0 1 19.006 13H6.994A2 2 0 0 1 5 11.002z"/><path d="M5 5v2h12V5zm-2-.002C3 3.894 3.895 3 4.994 3h12.012C18.107 3 19 3.898 19 4.998V9H3z"/></g></svg>`
    }, props));
$3b783045eed6d3aa$var$BacklogIcon.displayName = 'BacklogIcon';
var $3b783045eed6d3aa$var$_default = module.exports.default = $3b783045eed6d3aa$var$BacklogIcon;

});


parcelRegister("415Kd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d6de69f6e8d23d80c647d0a6d3ecd7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ecbb62206dc8482$var$_react = $2ecbb62206dc8482$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2ecbb62206dc8482$var$_board = $2ecbb62206dc8482$var$_interopRequireDefault((parcelRequire("kkAKd")));

var $2ecbb62206dc8482$var$_board2 = $2ecbb62206dc8482$var$_interopRequireDefault((parcelRequire("6rBC8")));
function $2ecbb62206dc8482$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BoardIcon.
 * This component is BoardIcon, with `UNSAFE_fallbackIcon` set to "BoardIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ecbb62206dc8482$var$BoardIcon = (props)=>/*#__PURE__*/ $2ecbb62206dc8482$var$_react.default.createElement($2ecbb62206dc8482$var$_board.default, Object.assign({
        LEGACY_fallbackIcon: $2ecbb62206dc8482$var$_board2.default
    }, props));
$2ecbb62206dc8482$var$BoardIcon.Name = 'BoardIconMigration';
var $2ecbb62206dc8482$var$_default = module.exports.default = $2ecbb62206dc8482$var$BoardIcon;

});
parcelRegister("6rBC8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b127112b72f87e0$var$_react = $4b127112b72f87e0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $4b127112b72f87e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4b127112b72f87e0$var$BoardIcon = (props)=>/*#__PURE__*/ $4b127112b72f87e0$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props));
$4b127112b72f87e0$var$BoardIcon.displayName = 'BoardIcon';
var $4b127112b72f87e0$var$_default = module.exports.default = $4b127112b72f87e0$var$BoardIcon;

});


parcelRegister("4prz0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e406a416cb0a4f8d2c2370983b384961>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $335ee0cb47ab678e$var$_react = $335ee0cb47ab678e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $335ee0cb47ab678e$var$_listBulleted = $335ee0cb47ab678e$var$_interopRequireDefault((parcelRequire("dbtUh")));

var $335ee0cb47ab678e$var$_bulletList = $335ee0cb47ab678e$var$_interopRequireDefault((parcelRequire("5oecI")));
function $335ee0cb47ab678e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ListBulletedIcon.
 * This component is ListBulletedIcon, with `UNSAFE_fallbackIcon` set to "BulletListIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $335ee0cb47ab678e$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $335ee0cb47ab678e$var$_react.default.createElement($335ee0cb47ab678e$var$_listBulleted.default, Object.assign({
        LEGACY_fallbackIcon: $335ee0cb47ab678e$var$_bulletList.default
    }, props));
$335ee0cb47ab678e$var$ListBulletedIcon.Name = 'ListBulletedIconMigration';
var $335ee0cb47ab678e$var$_default = module.exports.default = $335ee0cb47ab678e$var$ListBulletedIcon;

});
parcelRegister("5oecI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eca3648bae4d520$var$_react = $3eca3648bae4d520$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $3eca3648bae4d520$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3eca3648bae4d520$var$BulletListIcon = (props)=>/*#__PURE__*/ $3eca3648bae4d520$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="10" y="15" rx="1"/><rect width="2" height="2" x="6" y="15" rx="1"/><rect width="8" height="2" x="10" y="11" rx="1"/><rect width="2" height="2" x="6" y="11" rx="1"/><rect width="8" height="2" x="10" y="7" rx="1"/><rect width="2" height="2" x="6" y="7" rx="1"/></g></svg>`
    }, props));
$3eca3648bae4d520$var$BulletListIcon.displayName = 'BulletListIcon';
var $3eca3648bae4d520$var$_default = module.exports.default = $3eca3648bae4d520$var$BulletListIcon;

});


parcelRegister("mEt3r", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::182e7300aed0f8931ea6d6a6afcdcbad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04417237096a10c7$var$_react = $04417237096a10c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $04417237096a10c7$var$_page = $04417237096a10c7$var$_interopRequireDefault((parcelRequire("46Ypp")));

var $04417237096a10c7$var$_page2 = $04417237096a10c7$var$_interopRequireDefault((parcelRequire("kKwMm")));
function $04417237096a10c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PageIcon.
 * This component is PageIcon, with `UNSAFE_fallbackIcon` set to "PageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04417237096a10c7$var$PageIcon = (props)=>/*#__PURE__*/ $04417237096a10c7$var$_react.default.createElement($04417237096a10c7$var$_page.default, Object.assign({
        LEGACY_fallbackIcon: $04417237096a10c7$var$_page2.default
    }, props));
$04417237096a10c7$var$PageIcon.Name = 'PageIconMigration';
var $04417237096a10c7$var$_default = module.exports.default = $04417237096a10c7$var$PageIcon;

});
parcelRegister("46Ypp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fe694e83a2a95a6$var$_react = $2fe694e83a2a95a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2fe694e83a2a95a6$var$_baseNew = $2fe694e83a2a95a6$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $2fe694e83a2a95a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2fe694e83a2a95a6$var$PageIcon = (props)=>/*#__PURE__*/ $2fe694e83a2a95a6$var$_react.default.createElement($2fe694e83a2a95a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$2fe694e83a2a95a6$var$PageIcon.displayName = 'PageIcon';
var $2fe694e83a2a95a6$var$_default = module.exports.default = $2fe694e83a2a95a6$var$PageIcon;

});

parcelRegister("kKwMm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1b187c00a26846e$var$_react = $f1b187c00a26846e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $f1b187c00a26846e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f1b187c00a26846e$var$PageIcon = (props)=>/*#__PURE__*/ $f1b187c00a26846e$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props));
$f1b187c00a26846e$var$PageIcon.displayName = 'PageIcon';
var $f1b187c00a26846e$var$_default = module.exports.default = $f1b187c00a26846e$var$PageIcon;

});


parcelRegister("dPFdN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::478474977414af6f20354d0841ac3249>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a120038499c190fc$var$_react = $a120038499c190fc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a120038499c190fc$var$_roadmap = $a120038499c190fc$var$_interopRequireDefault((parcelRequire("980v4")));

var $a120038499c190fc$var$_roadmap2 = $a120038499c190fc$var$_interopRequireDefault((parcelRequire("3bdi5")));
function $a120038499c190fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RoadmapIcon.
 * This component is RoadmapIcon, with `UNSAFE_fallbackIcon` set to "RoadmapIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a120038499c190fc$var$RoadmapIcon = (props)=>/*#__PURE__*/ $a120038499c190fc$var$_react.default.createElement($a120038499c190fc$var$_roadmap.default, Object.assign({
        LEGACY_fallbackIcon: $a120038499c190fc$var$_roadmap2.default
    }, props));
$a120038499c190fc$var$RoadmapIcon.Name = 'RoadmapIconMigration';
var $a120038499c190fc$var$_default = module.exports.default = $a120038499c190fc$var$RoadmapIcon;

});
parcelRegister("3bdi5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $250cb56e81138b6a$var$_react = $250cb56e81138b6a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $250cb56e81138b6a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $250cb56e81138b6a$var$RoadmapIcon = (props)=>/*#__PURE__*/ $250cb56e81138b6a$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 2h10a3 3 0 0 1 0 6H6a3 3 0 1 1 0-6m0 2a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2zm4 5h8a3 3 0 0 1 0 6h-8a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-4 5h6a3 3 0 0 1 0 6H6a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"/></svg>`
    }, props));
$250cb56e81138b6a$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $250cb56e81138b6a$var$_default = module.exports.default = $250cb56e81138b6a$var$RoadmapIcon;

});



parcelRegister("75UwL", function(module, exports) {

$parcel$export(module.exports, "filterAndSort", () => $df1cc586f514efec$export$d0e0de50c701304c);
$parcel$export(module.exports, "findDependentFeature", () => $df1cc586f514efec$export$4c8205136225a4e2);
$parcel$export(module.exports, "updateFeatureState", () => $df1cc586f514efec$export$2bdeae30201d513c);
$parcel$export(module.exports, "fireErrorAnalyticsOnUnmatchFeatureKey", () => $df1cc586f514efec$export$5da1e8c5ba5c0dc2);

var $3l9kN = parcelRequire("3l9kN");

var $gYnSx = parcelRequire("gYnSx");

var $2DEdX = parcelRequire("2DEdX");
const $df1cc586f514efec$export$b70265791d2079d4 = (hasFeature)=>hasFeature ? 'ENABLED' : 'DISABLED';
const $df1cc586f514efec$export$d0e0de50c701304c = (features)=>{
    const featureMap = (0, $2DEdX.getFeatureMap)();
    return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
};
const $df1cc586f514efec$export$4c8205136225a4e2 = (features, featureId)=>{
    const featureToDisable = features.find((f)=>f.feature === featureId);
    // Will only show the modal when the current status is enabled for both the feature to disable and the dependent feature
    if (featureToDisable?.state !== 'ENABLED') return undefined;
    // For the scope of the feature toggle, we assume there is only one dependency for now
    return features.find((f)=>f.prerequisites.includes(featureId) && f.state === 'ENABLED');
};
const $df1cc586f514efec$export$2bdeae30201d513c = (featureId, dependentFeatureId)=>(feature)=>feature.feature === featureId || dependentFeatureId && feature.feature === dependentFeatureId ? {
            ...feature,
            state: feature.state === 'ENABLED' ? 'DISABLED' : 'ENABLED'
        } : feature;
const $df1cc586f514efec$export$5da1e8c5ba5c0dc2 = (filteredFeatures)=>{
    const featureMap = (0, $2DEdX.getFeatureMap)();
    if (filteredFeatures.length < Object.keys(featureMap).length) {
        const unmatchedFeatureKeys = (0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
        (0, $gYnSx.default)({
            error: new Error("Some feature keys don't match . Please check API response"),
            meta: {
                ...(0, $2DEdX.commonErrorAnalyticsMeta),
                id: 'unmatchFeatureKey'
            },
            attributes: {
                unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
            }
        });
    }
};

});
parcelRegister("3l9kN", function(module, exports) {

var $leN9Q = parcelRequire("leN9Q");

var $l76qh = parcelRequire("l76qh");

var $d1ShJ = parcelRequire("d1ShJ");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $26ea92e191963c80$var$without = $l76qh(function(array, values) {
    return $d1ShJ(array) ? $leN9Q(array, values) : [];
});
module.exports = $26ea92e191963c80$var$without;

});
parcelRegister("leN9Q", function(module, exports) {

var $4hmxn = parcelRequire("4hmxn");

var $40QQB = parcelRequire("40QQB");

var $e2REr = parcelRequire("e2REr");

var $lylkU = parcelRequire("lylkU");

var $cUaWv = parcelRequire("cUaWv");

var $fAWNe = parcelRequire("fAWNe");
/** Used as the size to enable large array optimizations. */ var $f761097be90b00fc$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $f761097be90b00fc$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $40QQB, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $lylkU(values, $cUaWv(iteratee));
    if (comparator) {
        includes = $e2REr;
        isCommon = false;
    } else if (values.length >= $f761097be90b00fc$var$LARGE_ARRAY_SIZE) {
        includes = $fAWNe;
        isCommon = false;
        values = new $4hmxn(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $f761097be90b00fc$var$baseDifference;

});



parcelRegister("dFKLJ", function(module, exports) {

$parcel$export(module.exports, "getBoardFeatures", () => $5482b7a0e862d1ce$export$c20100b185d41ab0);

var $jGzN3 = parcelRequire("jGzN3");

var $8ZH3C = parcelRequire("8ZH3C");
const $5482b7a0e862d1ce$export$c20100b185d41ab0 = async (boardId)=>{
    const data = await (0, $jGzN3.performGetRequest)((0, $8ZH3C.getBoardFeaturesUrl)(boardId));
    return data.features;
};

});
parcelRegister("8ZH3C", function(module, exports) {

$parcel$export(module.exports, "getBoardFeaturesUrl", () => $a432628e74c040a5$export$3f9939d302766b52);
const $a432628e74c040a5$export$3f9939d302766b52 = (boardId)=>`/rest/agile/latest/board/${boardId}/features`;

});


parcelRegister("5ekEZ", function(module, exports) {

$parcel$export(module.exports, "updateBoardFeature", () => $daf54280ff8482fb$export$61f6bbb745b3a3);

var $jGzN3 = parcelRequire("jGzN3");

var $8ZH3C = parcelRequire("8ZH3C");
const $daf54280ff8482fb$export$61f6bbb745b3a3 = async (request)=>{
    // it returns the board features array, but we don't use it for optimistic update
    // feature state is used instead to indicate if the updates successful or not
    const data = await (0, $jGzN3.performPutRequest)((0, $8ZH3C.getBoardFeaturesUrl)(request.boardId), {
        body: JSON.stringify(request)
    });
    const newState = data.features.find((f)=>f.feature === request.feature)?.state;
    return newState ?? (request.enabling ? 'ENABLED' : 'DISABLED');
};

});



parcelRegister("cZfeH", function(module, exports) {

$parcel$export(module.exports, "useClearSidebarToggled", () => $ab83a592c4668936$export$2946f555c6f48127);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $dSkLG = parcelRequire("dSkLG");

var $6d9QY = parcelRequire("6d9QY");

var $1WzGp = parcelRequire("1WzGp");

var $fsjYk = parcelRequire("fsjYk");
const $ab83a592c4668936$export$2946f555c6f48127 = ()=>{
    const { data: data, refresh: refresh } = (0, $dSkLG.useJiraSoftwareProjectNavigation)();
    const [sidebarFeatureToggled, { clearSiderbarFeatureToggled: clearSiderbarFeatureToggled }] = (0, $1WzGp.useSidebarFeatureToggled)();
    const isEligibleForFeatureToggle = (0, $fsjYk.useShouldApplyFeatureToggle)();
    const sidebarHasChanged = (0, $eJOHy.useRef)(false);
    const previousData = (0, $6d9QY.usePreviousWithInitial)(data);
    // if resource data has changed since the last refresh then remove the sidebar toggled data.
    // i.e. whatever that has been toggled is reflected on the latest resource
    const shouldClear = (0, $eJOHy.useMemo)(()=>isEligibleForFeatureToggle && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(previousData, data), [
        isEligibleForFeatureToggle,
        previousData,
        data
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (shouldClear) clearSiderbarFeatureToggled();
    }, [
        shouldClear,
        clearSiderbarFeatureToggled
    ]);
    (0, $eJOHy.useEffect)(()=>{
        sidebarHasChanged.current = isEligibleForFeatureToggle && !!sidebarFeatureToggled;
    }, [
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    // refresh the navigation resource if sidebar has changed
    (0, $eJOHy.useEffect)(()=>()=>{
            if (sidebarHasChanged.current) refresh();
        }, [
        refresh
    ]);
};

});
parcelRegister("6d9QY", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $6561b991da312eac$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousPersistent", () => $6561b991da312eac$export$9c42f2690cfe6963);
$parcel$export(module.exports, "usePreviousWithInitial", () => $6561b991da312eac$export$23fbbb2e62c4a911);

var $eJOHy = parcelRequire("eJOHy");
const $6561b991da312eac$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $6561b991da312eac$export$9c42f2690cfe6963 = (value)=>{
    // initialise the ref with previous and current values
    const ref = (0, $eJOHy.useRef)({
        value: value,
        prev: undefined
    });
    const current = ref.current.value;
    // if the value passed into hook doesn't match what we store as "current"
    // move the "current" to the "previous"
    // and store the passed value as "current"
    if (value !== current) ref.current = {
        value: value,
        prev: current
    };
    // return the previous value only
    return ref.current.prev;
};
const $6561b991da312eac$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $eJOHy.useRef)(value);
    (0, $eJOHy.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});

parcelRegister("fsjYk", function(module, exports) {

$parcel$export(module.exports, "useShouldApplyFeatureToggle", () => $fa56f9341174283f$export$7deca16ba2d9eb74);

var $ln6Iy = parcelRequire("ln6Iy");

var $2aY2d = parcelRequire("2aY2d");

var $01Isa = parcelRequire("01Isa");
const $fa56f9341174283f$export$7deca16ba2d9eb74 = ()=>{
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const firstActivationDateMs = (0, $01Isa.useFirstActivationDateMs)() || 0;
    const isJSW = project?.projectType === (0, $ln6Iy.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isProjectAdmin = !!project?.isProjectAdmin;
    const isNewInstance = new Date(firstActivationDateMs) >= new Date('2023-09-25T15:00:00');
    return isJSW && isTMP && isProjectAdmin && isNewInstance;
};

});
parcelRegister("01Isa", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $f3b05b48d8980ff5$export$9df3a539e50a284b);

var $lvKO5 = parcelRequire("lvKO5");
const $f3b05b48d8980ff5$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});



parcelRegister("jphFu", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $e9a39bce412d9671$export$9df5fa0a366163d2);

var $epTsa = parcelRequire("epTsa");
const $e9a39bce412d9671$export$9df5fa0a366163d2 = (navData)=>{
    const { permissionInfo: permissionInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCode: hasCode, hasGoals: hasGoals, hasGetStarted: hasGetStarted, hasSecurity: hasSecurity, hasDeployments: hasDeployments, hasDevelopment: hasDevelopment, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasRoadmap: hasRoadmap, hasReports: hasReports, hasRequests: hasRequests, hasIssues: hasIssues, hasSprint: hasSprint, hasIncidents: hasIncidents, hasCalendar: hasCalendar, hasForms: hasForms, hasSummaryPage: hasSummaryPage, aiInfo: aiInfo, hasArchivedIssues: hasArchivedIssues = false } = navData;
    const isProjectOrJiraAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasRoadmap: hasRoadmap,
        hasCode: hasCode,
        hasGoals: hasGoals,
        hasGetStarted: isProjectOrJiraAdmin && hasGetStarted,
        hasSecurity: hasSecurity,
        hasDeployments: hasDeployments,
        hasDevelopment: hasDevelopment,
        hasList: hasList,
        hasReleases: hasReleases,
        hasSIN: hasIssues,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasPages: hasPages,
        hasOpsgenie: hasOpsgenieSchedule,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        hasSprint: hasSprint,
        hasIncidents: hasIncidents,
        hasCalendar: hasCalendar,
        hasForms: (0, $epTsa.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasSummaryPage: hasSummaryPage,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true
    };
};

});





parcelRegister("753q2", function(module, exports) {

$parcel$export(module.exports, "Stub", () => $ed0f9f17541d7429$export$1ab0b9ce3cf276f8);

var $eJOHy = parcelRequire("eJOHy");

var $MlWTN = parcelRequire("MlWTN");

var $aasrU = parcelRequire("aasrU");




var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $8IuE5 = parcelRequire("8IuE5");

var $7jTnu = parcelRequire("7jTnu");

var $qEpp6 = parcelRequire("qEpp6");

var $eL2Ux = parcelRequire("eL2Ux");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");


var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $jRu18 = parcelRequire("jRu18");
const $ed0f9f17541d7429$export$1ab0b9ce3cf276f8 = ({ menuId: menuId, href: href })=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)(menuId);
    const location = (0, $jRu18.useLocation)();
    const path = location.pathname + location.search;
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aasrU.LinkMenuItem), {
        elemBefore: icon,
        href: href,
        isSelected: path === href,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed0f9f17541d7429$var$ActionButtons, {
            menuId: menuId
        }),
        onClick: ()=>{
            if (menuId === (0, $8IuE5.L1_MENU_ID).TEAMS) sendSectionItemAnalyticsEvent({
                menuId: (0, $8IuE5.L1_MENU_ID).TEAMS,
                sectionItem: (0, $a9aec.SECTION_ITEM_TEAMS)
            });
        }
    }, formattedMessage);
};
function $ed0f9f17541d7429$var$ActionButtons({ menuId: menuId }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const handleNavMenuOpen = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6),
            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[menuId],
            attributes: {
                level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                itemId: (0, $e6bca68b75395543$export$f06dfcec5ff912e)
            }
        });
    }, [
        createAnalyticsEvent,
        menuId
    ]);
    const MenuItems = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
            menuId: menuId,
            hasSeparator: false
        })), [
        menuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: (0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton') ? handleNavMenuOpen : ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6),
                actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[menuId],
                attributes: {
                    level: (0, $4fdd5d9c1b32dd60$export$265c523d1a8f25cf),
                    componentType: (0, $493796f3bdee881c$export$95b0c331af13d819),
                    itemId: (0, $e6bca68b75395543$export$f06dfcec5ff912e)
                }
            });
        },
        MenuItems: (0, $7jTnu.fg)('jfp-magma-perf-optimise-morenavmenubutton') ? MenuItems : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
                menuId: menuId,
                hasSeparator: false
            }))
    });
}

});


parcelRegister("99tvj", function(module, exports) {

$parcel$export(module.exports, "useFilterL1MenuItemsByEditionAndLicense", () => $d21ef2b7ff9a2f2a$export$bf04108d78a3abbe);

var $eJOHy = parcelRequire("eJOHy");

var $gDXSd = parcelRequire("gDXSd");

var $7jTnu = parcelRequire("7jTnu");

var $8IuE5 = parcelRequire("8IuE5");

var $lJ0uX = parcelRequire("lJ0uX");

var $eJYI8 = parcelRequire("eJYI8");

var $SPYRa = parcelRequire("SPYRa");

var $fRXNt = parcelRequire("fRXNt");

var $1JbRu = parcelRequire("1JbRu");

var $ht7jn = parcelRequire("ht7jn");

var $dx2Xz = parcelRequire("dx2Xz");

var $48zBc = parcelRequire("48zBc");

var $d9MBC = parcelRequire("d9MBC");
const $d21ef2b7ff9a2f2a$export$bf04108d78a3abbe = (navItems)=>{
    const showAssets = (0, $lJ0uX.useShowAssets)();
    const { shouldUseJSM: shouldUseJSM } = (0, $gDXSd.useOgTenantInfo)();
    const shouldShowRoadmaps = (0, $fRXNt.useIsCrossProjectViewsEnabled)();
    const shouldRenderOverviews = (0, $eJYI8.useShouldRenderOverviews)();
    const [shouldRenderPlans] = (0, $SPYRa.useNavigationPlansVisibility)();
    const showCustomerService = (0, $1JbRu.useShowCustomerService)();
    const showCustomerServiceAnalytics = (0, $ht7jn.useShowCustomerServiceAnalytics)();
    const { goals: goals, assets: assets, confluence: confluence, projects: projects, loom: loom, teams: teams, opsgenie: opsgenie } = (0, $dx2Xz.useGlobalApps)();
    const showCommunicationsMenu = (0, $48zBc.useShowCommunicationsMenu)();
    const shouldRenderApps = !((0, $7jTnu.fg)('jira-hide-apps-in-isolated-cloud') && (0, $d9MBC.isIsolatedCloud)());
    return (0, $eJOHy.useMemo)(()=>navItems.filter(({ menuId: menuId })=>{
            if (menuId === (0, $8IuE5.L1_MENU_ID).OPERATIONS) return shouldUseJSM;
            if (menuId === (0, $8IuE5.L1_MENU_ID).ASSETS) /* remove this on
					 * assets_as_an_app_v2 cleanup &&
					 *
					 * Should hide the L1 Assets menu item when the asset shortcut is present
					 */ return showAssets && !assets;
            if (menuId === (0, $8IuE5.L1_MENU_ID).ROADMAPS) return shouldShowRoadmaps;
            if (menuId === (0, $8IuE5.L1_MENU_ID).OVERVIEWS) return (0, $7jTnu.fg)('blu-2858-sidebar-menu-overviews') && shouldRenderOverviews;
            if (menuId === (0, $8IuE5.L1_MENU_ID).PLANS) return shouldRenderPlans;
            if (menuId === (0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS) return showCustomerServiceAnalytics;
            // See https://jplat.jira.atlassian.cloud/browse/BLU-3307
            // For the Dogfooding phase of Nav4 we are going to intentionally hide the Goals menu item.
            // This if block should be removed when we work on https://jplat.jira.atlassian.cloud/browse/BLU-3261
            // as we will know the correct URL for the Goals menu item at that point.
            if (menuId === (0, $8IuE5.L1_MENU_ID).GOALS) return false;
            if (menuId === (0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE) return showCustomerService;
            if (menuId === (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS) return assets;
            if (menuId === (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS) return goals;
            // App Shortcuts for Platform Component, feature gated in useGlobalApps
            if (menuId === (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE) return confluence;
            if (menuId === (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS) return projects;
            if (menuId === (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM) return loom;
            if (menuId === (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS) return teams;
            if (menuId === (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE) return opsgenie;
            if (menuId === (0, $8IuE5.L1_MENU_ID).COMMUNICATION) return showCommunicationsMenu;
            if (menuId === (0, $8IuE5.L1_MENU_ID).APPS) return shouldRenderApps;
            return true;
        }), [
        navItems,
        shouldUseJSM,
        showAssets,
        shouldShowRoadmaps,
        shouldRenderOverviews,
        shouldRenderPlans,
        showCustomerService,
        showCustomerServiceAnalytics,
        goals,
        assets,
        confluence,
        projects,
        loom,
        teams,
        opsgenie,
        showCommunicationsMenu,
        shouldRenderApps
    ]);
};

});
parcelRegister("lJ0uX", function(module, exports) {

$parcel$export(module.exports, "useShowAssets", () => $a4b173902015b922$export$6d1797fe1bb33b7a);

var $7cSYk = parcelRequire("7cSYk");

var $lvKO5 = parcelRequire("lvKO5");
function $a4b173902015b922$export$6d1797fe1bb33b7a() {
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    if ((0, $7cSYk.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP) && isJSMUser) return true;
    return false;
}

});

parcelRegister("1JbRu", function(module, exports) {

$parcel$export(module.exports, "useShowCustomerService", () => $01ba127d60db9986$export$e760a809f2958bc7);

var $7jTnu = parcelRequire("7jTnu");

var $hbF3h = parcelRequire("hbF3h");

var $gZTP9 = parcelRequire("gZTP9");

var $iW0U8 = parcelRequire("iW0U8");
const $01ba127d60db9986$export$c4885f1dde7a76dc = ()=>{
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $iW0U8.useApplicationPermissions)();
    return (0, $7jTnu.fg)('jcs_master_flag') && (isAdmin || hasServiceDeskAccess);
};
const $01ba127d60db9986$export$888d99f9044122c4 = ()=>{
    const { hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $iW0U8.useApplicationPermissions)();
    return (0, $7jTnu.fg)('jcs_master_flag') && hasCustomerServiceAccess;
};
const $01ba127d60db9986$export$e760a809f2958bc7 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('jcs_project_type_m3'), $01ba127d60db9986$export$888d99f9044122c4, $01ba127d60db9986$export$c4885f1dde7a76dc);

});

parcelRegister("ht7jn", function(module, exports) {

$parcel$export(module.exports, "useShowCustomerServiceAnalytics", () => $594909db36a8e283$export$4aaa66e80d627346);

var $7jTnu = parcelRequire("7jTnu");

var $gZTP9 = parcelRequire("gZTP9");

var $iW0U8 = parcelRequire("iW0U8");
const $594909db36a8e283$export$4aaa66e80d627346 = ()=>{
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $iW0U8.useApplicationPermissions)();
    return (0, $7jTnu.fg)('jcs-analytics-page') && (isAdmin || hasServiceDeskAccess);
};

});

parcelRegister("48zBc", function(module, exports) {

$parcel$export(module.exports, "useShowCommunicationsMenu", () => $47b0386e1215dcbb$export$b98d497f7858571b);

var $a9ldn = parcelRequire("a9ldn");

var $7jTnu = parcelRequire("7jTnu");

var $8vyDv = parcelRequire("8vyDv");

var $gZTP9 = parcelRequire("gZTP9");

var $lUto7 = parcelRequire("lUto7");

var $bEiQD = parcelRequire("bEiQD");

var $lvKO5 = parcelRequire("lvKO5");
const $47b0386e1215dcbb$export$b98d497f7858571b = ()=>{
    const { isOrgAdmin: isOrgAdmin } = (0, $bEiQD.useIsOrgAdmin)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const appEditions = (0, $8vyDv.useAppEditions)();
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    // Check if user has premium edition
    const isPremium = appEditions?.software === (0, $a9ldn.PREMIUM_EDITION);
    // Check if user has specific product license
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    const isAdminUser = isOrgAdmin || isSiteAdmin || isAdmin;
    const showCommunicationsMenu = isAdminUser && isPremium && isJSMUser && (0, $7jTnu.fg)('communications_stakeholder_management_platform');
    return showCommunicationsMenu;
};

});
parcelRegister("bEiQD", function(module, exports) {

$parcel$export(module.exports, "useIsOrgAdmin", () => $0e2a7c03acc2874b$export$8ed42372757d8b2a);

var $eJOHy = parcelRequire("eJOHy");

var $hPZg4 = parcelRequire("hPZg4");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $g9Vr6 = parcelRequire("g9Vr6");

var $8q7lT = parcelRequire("8q7lT");
const $0e2a7c03acc2874b$var$getUserOrgPermissions = async ({ orgId: orgId, userId: userId })=>(0, $jGzN3.performPostRequest)('/gateway/api/permissions/permitted', {
        body: JSON.stringify({
            resourceId: `ari:cloud:platform::org/${orgId}`,
            principalId: `ari:cloud:identity::user/${userId}`,
            permissionId: 'manage-users'
        })
    }).then((resp)=>!!resp?.permitted);
const $0e2a7c03acc2874b$export$8ed42372757d8b2a = ()=>{
    const userId = (0, $8q7lT.useAccountId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const checkUserIsOrgAdmin = (0, $eJOHy.useCallback)(async ()=>{
        if (!userId || !orgId) return false;
        return $0e2a7c03acc2874b$var$getUserOrgPermissions({
            orgId: orgId,
            userId: userId
        });
    }, [
        orgId,
        userId
    ]);
    const { loading: loading, error: error, data: data, fetch: fetchIsOrgAdmin } = (0, $hPZg4.useService)(checkUserIsOrgAdmin, {
        data: false
    });
    (0, $eJOHy.useEffect)(()=>{
        fetchIsOrgAdmin();
    }, [
        fetchIsOrgAdmin
    ]);
    (0, $eJOHy.useEffect)(()=>{
        (0, $gYnSx.default)({
            meta: {
                id: 'checkUserIsOrgAdmin',
                packageName: 'jiraBusinessGoalPicker',
                teamName: 'jira-yurree'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: error
        });
    }, [
        error
    ]);
    return {
        isOrgAdmin: !!data,
        loading: loading,
        hasErrorOccurred: !!error,
        retry: fetchIsOrgAdmin
    };
};

});



parcelRegister("efIGC", function(module, exports) {

$parcel$export(module.exports, "useRefreshL1MenuItems", () => $11175ae5b197dd63$export$6f30ce19c2e3e4c0);

var $eJOHy = parcelRequire("eJOHy");

var $2zs80 = parcelRequire("2zs80");

var $24QYf = parcelRequire("24QYf");
const $11175ae5b197dd63$export$6f30ce19c2e3e4c0 = (navItems = [])=>(0, $eJOHy.useMemo)(()=>{
        const missingMenuIds = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))((0, $24QYf.USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS), navItems.map(({ menuId: menuId })=>menuId));
        return [
            ...navItems,
            ...missingMenuIds.map((menuId)=>({
                    menuId: menuId,
                    isVisible: true
                }))
        ];
    }, [
        navItems
    ]);

});
parcelRegister("2zs80", function(module, exports) {

var $leN9Q = parcelRequire("leN9Q");

var $72Qfa = parcelRequire("72Qfa");

var $l76qh = parcelRequire("l76qh");

var $d1ShJ = parcelRequire("d1ShJ");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $1df4ab4b3ebd7a42$var$difference = $l76qh(function(array, values) {
    return $d1ShJ(array) ? $leN9Q(array, $72Qfa(values, 1, $d1ShJ, true)) : [];
});
module.exports = $1df4ab4b3ebd7a42$var$difference;

});


parcelRegister("kRqOw", function(module, exports) {

$parcel$export(module.exports, "MoreMenuIsOpenContextProvider", () => $346ab3a8e11009e0$export$d11e004ed91611ce);

var $eJOHy = parcelRequire("eJOHy");

var $eO1d3 = parcelRequire("eO1d3");
const $346ab3a8e11009e0$export$d11e004ed91611ce = ({ children: children })=>{
    const [moreMenuIsOpen, setMoreMenuIsOpen] = (0, $eJOHy.useState)(false);
    const moreMenuIsOpenContext = (0, $eJOHy.useMemo)(()=>({
            moreMenuIsOpen: moreMenuIsOpen,
            setMoreMenuIsOpen: setMoreMenuIsOpen
        }), [
        moreMenuIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eO1d3.MoreMenuIsOpenContext).Provider, {
        value: moreMenuIsOpenContext
    }, children);
};

});
parcelRegister("eO1d3", function(module, exports) {

$parcel$export(module.exports, "MoreMenuIsOpenContext", () => $f9cd06b886a023d5$export$8888ac4b19e27f70);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $f9cd06b886a023d5$export$8888ac4b19e27f70 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    moreMenuIsOpen: false,
    setMoreMenuIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});

});


parcelRegister("g5qtb", function(module, exports) {

$parcel$export(module.exports, "SidebarCustomization", () => $49cac2c6568bcfd7$export$64f537f23c5bcad6);

var $eJOHy = parcelRequire("eJOHy");

var $lbvZy = parcelRequire("lbvZy");

var $a9aec = parcelRequire("a9aec");

var $80rA3 = parcelRequire("80rA3");

var $qEpp6 = parcelRequire("qEpp6");

var $18SQd = parcelRequire("18SQd");

var $lRq8t = parcelRequire("lRq8t");

var $9WyX8 = parcelRequire("9WyX8");

var $4exVH = parcelRequire("4exVH");

var $aKwXy = parcelRequire("aKwXy");

var $2ng07 = parcelRequire("2ng07");
function $49cac2c6568bcfd7$export$64f537f23c5bcad6({ menuData: menuData, productItemsData: productItemsData, appItemsData: appItemsData, getAppShortcutURL: getAppShortcutURL }) {
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const { peekMenuId: peekMenuId } = (0, $eJOHy.useContext)((0, $80rA3.PeekMenuIdContext));
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const pressTracing = (0, $lbvZy.default)('nav4-sidebar-more');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClickMoreMenuTrigger = (0, $eJOHy.useCallback)(()=>{
        sendSectionItemAnalyticsEvent({
            sectionItem: (0, $a9aec.SECTION_ITEM_MORE)
        });
        pressTracing();
    }, [
        pressTracing,
        sendSectionItemAnalyticsEvent
    ]);
    return moreMenuIds.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ng07.CustomizeSidebar), {
        productItemsData: productItemsData,
        appItemsData: appItemsData
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4exVH.PeekMenuItem), {
        menuData: menuData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $18SQd.GlobalMoreMenu), {
        productItemsData: productItemsData,
        appItemsData: appItemsData,
        menuItemComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9WyX8.MoreMenuItem), {
                ...props,
                getAppShortcutURL: getAppShortcutURL
            }),
        customizeSidebarMenuItem: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ng07.CustomizeSidebar), {
            productItemsData: productItemsData,
            appItemsData: appItemsData
        }),
        moreMenuItemLabel: formatMessage((0, $aKwXy.default).more),
        peekingMenuIds: peekMenuId ? [
            peekMenuId
        ] : undefined,
        onClickMoreMenuTrigger: onClickMoreMenuTrigger
    }));
}

});
parcelRegister("18SQd", function(module, exports) {

$parcel$export(module.exports, "GlobalMoreMenu", () => $9ec69c092a093d27$export$6741e824c68e9927);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1hJxR = parcelRequire("1hJxR");

var $iUdBG = parcelRequire("iUdBG");
var $9ec69c092a093d27$export$2e2bcd8739ae039 // This is only needed to support the Atlaskit docs. See https://hello.atlassian.net/wiki/spaces/navx/pages/5305993008/Platform+Guide#Atlaskit-%3CProps%3E-component-not-rendering
 = $9ec69c092a093d27$export$6741e824c68e9927;
function $9ec69c092a093d27$export$6741e824c68e9927({ productItemsData: productItemsData, appItemsData: appItemsData = [], menuItemComponent: menuItemComponent, customizeSidebarMenuItem: customizeSidebarMenuItem, moreMenuItemLabel: moreMenuItemLabel, peekingMenuIds: peekingMenuIds = [], onClickMoreMenuTrigger: onClickMoreMenuTrigger, testId: testId, triggerRef: triggerRef, triggerVisualContentRef: triggerVisualContentRef, dropIndicator: dropIndicator }) {
    const { hiddenProductItemsData: hiddenProductItemsData, hiddenAppItemsData: hiddenAppItemsData, shouldShowMoreMenu: shouldShowMoreMenu } = (0, $iUdBG.getHiddenItems)(productItemsData, appItemsData, peekingMenuIds);
    if (!shouldShowMoreMenu) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: customizeSidebarMenuItem
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1hJxR.MoreMenuPopup), {
        productItemsData: hiddenProductItemsData,
        appItemsData: hiddenAppItemsData,
        moreMenuItemComponent: menuItemComponent,
        customizeSidebarMenuItem: customizeSidebarMenuItem,
        moreMenuItemLabel: moreMenuItemLabel,
        onClickMoreMenuTrigger: onClickMoreMenuTrigger,
        testId: testId,
        triggerRef: triggerRef,
        triggerVisualContentRef: triggerVisualContentRef,
        dropIndicator: dropIndicator
    });
}

});
parcelRegister("1hJxR", function(module, exports) {

$parcel$export(module.exports, "MoreMenuPopup", () => $9ac0b2b613e77045$export$b426d2e536b00785);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4poV0 = parcelRequire("4poV0");

var $2y3Ci = parcelRequire("2y3Ci");

var $kRcOu = parcelRequire("kRcOu");

var $42Y7K = parcelRequire("42Y7K");

var $dhRXV = parcelRequire("dhRXV");

var $7X1V1 = parcelRequire("7X1V1");
const $9ac0b2b613e77045$var$styles = {
    popupContentContainerStyles: "_195gr5cr _kqswh2mm",
    popupContentStyles: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
function $9ac0b2b613e77045$export$b426d2e536b00785({ productItemsData: productItemsData, appItemsData: appItemsData, moreMenuItemComponent: moreMenuItemComponent, customizeSidebarMenuItem: customizeSidebarMenuItem, moreMenuItemLabel: moreMenuItemLabel, onClickMoreMenuTrigger: onClickMoreMenuTrigger, testId: testId, triggerRef: triggerRef, triggerVisualContentRef: triggerVisualContentRef, dropIndicator: dropIndicator }) {
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const closeMenu = ()=>setIsOpen(false);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(!isOpen), onClickMoreMenuTrigger && onClickMoreMenuTrigger();
    }, [
        onClickMoreMenuTrigger,
        isOpen
    ]);
    const mergeTriggerRef = (0, $eJOHy.useCallback)((popupRef)=>(element)=>{
            if (triggerRef && typeof triggerRef === 'function') triggerRef(element);
            else if (triggerRef) triggerRef.current = element;
            if (popupRef && typeof popupRef === 'function') popupRef(element);
            else if (popupRef) popupRef.current = element;
        }, [
        triggerRef
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $42Y7K.Popup), {
        isOpen: isOpen,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $42Y7K.PopupTrigger), {
                children: (triggerProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kRcOu.ButtonMenuItem), {
                        ...triggerProps,
                        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4poV0))), {
                            label: "",
                            color: "currentColor",
                            spacing: "spacious"
                        }),
                        onClick: onClick,
                        testId: testId,
                        ref: mergeTriggerRef(triggerProps.ref),
                        visualContentRef: triggerVisualContentRef,
                        dropIndicator: dropIndicator,
                        children: moreMenuItemLabel
                    })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
                xcss: $9ac0b2b613e77045$var$styles.popupContentContainerStyles,
                role: "listitem",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $42Y7K.PopupContent), {
                    testId: `${testId}-content`,
                    shouldFitContainer: true,
                    placement: "bottom-start",
                    // Offset the top margin of the menu section.
                    // This will keep an even spacing of menu items between those inside the dropdown and those above,
                    // and keep the icons aligned
                    offset: [
                        -4,
                        4
                    ],
                    onClose: ()=>setIsOpen(false),
                    shouldRenderToParent: true,
                    strategy: "absolute",
                    children: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
                            xcss: $9ac0b2b613e77045$var$styles.popupContentStyles,
                            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2y3Ci.MenuList), {
                                children: [
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7X1V1.MoreMenuSection), {
                                        itemsData: productItemsData,
                                        moreMenuItemComponent: moreMenuItemComponent,
                                        closeMenu: closeMenu
                                    }),
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7X1V1.MoreMenuSection), {
                                        itemsData: appItemsData,
                                        moreMenuItemComponent: moreMenuItemComponent,
                                        closeMenu: closeMenu
                                    }),
                                    customizeSidebarMenuItem
                                ]
                            })
                        })
                })
            })
        ]
    });
}

});
parcelRegister("7X1V1", function(module, exports) {

$parcel$export(module.exports, "MoreMenuSection", () => $a4056fa223bbda5f$export$e69b6dd1756fb519);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2y3Ci = parcelRequire("2y3Ci");

var $feav5 = parcelRequire("feav5");
var $1swHh = parcelRequire("1swHh");
function $a4056fa223bbda5f$export$e69b6dd1756fb519({ itemsData: itemsData, moreMenuItemComponent: moreMenuItemComponent, closeMenu: closeMenu }) {
    if (itemsData.length === 0) return null;
    const MenuItemComponent = moreMenuItemComponent;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1swHh.MenuSection), {
        isMenuListItem: true,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2y3Ci.MenuList), {
                children: itemsData.map(({ menuId: menuId })=>/*#__PURE__*/ (0, $gt9Am.jsx)(MenuItemComponent, {
                        menuId: menuId,
                        closeMenu: closeMenu
                    }, menuId))
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $feav5.Divider), {})
        ]
    });
}

});


parcelRegister("iUdBG", function(module, exports) {

$parcel$export(module.exports, "getHiddenItems", () => $20c9ed22d4681012$export$89456cd3628213b2);
function $20c9ed22d4681012$export$89456cd3628213b2(productItemsData, appItemsData, peekingMenuIds) {
    const checkIsHiddenMenuItem = ({ menuId: menuId, visible: visible })=>!visible && !peekingMenuIds.includes(menuId);
    const hiddenProductItemsData = productItemsData.filter(checkIsHiddenMenuItem);
    const hiddenAppItemsData = appItemsData.filter(checkIsHiddenMenuItem);
    return {
        hiddenProductItemsData: hiddenProductItemsData,
        hiddenAppItemsData: hiddenAppItemsData,
        shouldShowMoreMenu: hiddenProductItemsData.length !== 0 || hiddenAppItemsData.length !== 0
    };
}

});


parcelRegister("9WyX8", function(module, exports) {

$parcel$export(module.exports, "MoreMenuItem", () => $2b90a1c096c82754$export$e967513bbeba0537);

var $eJOHy = parcelRequire("eJOHy");

var $aasrU = parcelRequire("aasrU");

var $kRcOu = parcelRequire("kRcOu");

var $eL2Ux = parcelRequire("eL2Ux");

var $80rA3 = parcelRequire("80rA3");

var $ig45T = parcelRequire("ig45T");

var $qEpp6 = parcelRequire("qEpp6");

var $a9aec = parcelRequire("a9aec");

var $dx2Xz = parcelRequire("dx2Xz");

var $h4Bzb = parcelRequire("h4Bzb");

var $7jTnu = parcelRequire("7jTnu");

var $41vqi = parcelRequire("41vqi");
function $2b90a1c096c82754$export$e967513bbeba0537({ menuId: menuId, closeMenu: closeMenu, key: key, getAppShortcutURL: getAppShortcutURL }) {
    const { setPeekMenuId: setPeekMenuId } = (0, $eJOHy.useContext)((0, $80rA3.PeekMenuIdContext));
    const configurableId = (0, $ig45T.convertToConfigurableMenuId)(menuId);
    const isGlobalApp = (0, $dx2Xz.isGlobalAppMenuId)(menuId);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)(configurableId);
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const getProductUrl = (0, $eJOHy.useCallback)(()=>{
        if (!isGlobalApp || !getAppShortcutURL) return;
        if ((0, $h4Bzb.GLOBAL_APP_MENU_ID_TO_APS_KEY)[menuId]) {
            const apsKey = (0, $h4Bzb.GLOBAL_APP_MENU_ID_TO_APS_KEY)[menuId];
            return getAppShortcutURL(apsKey);
        }
    }, [
        isGlobalApp,
        getAppShortcutURL,
        menuId
    ]);
    // This is part of an intermediate state workaround where links are accounted for;
    // we don't expect links to be in the More menu at the end state,
    // at which point this and the MenuLinkItem below can be removed.
    const USER_NAVIGATION_ITEM_LINKS = (0, $41vqi.getUserNavigationItemLinks)();
    const url = (0, $7jTnu.fg)('nav4_global_links_jira') ? getProductUrl() || USER_NAVIGATION_ITEM_LINKS[menuId] : USER_NAVIGATION_ITEM_LINKS[menuId];
    const onClick = (0, $eJOHy.useCallback)(()=>{
        closeMenu();
        if (!isGlobalApp) // Global apps open in a new tab onClick so they don't need to be a peek-item
        setPeekMenuId(configurableId);
        sendSectionItemAnalyticsEvent({
            menuId: configurableId,
            sectionItem: (0, $a9aec.SECTION_ITEM_MAP)[configurableId]
        });
    }, [
        closeMenu,
        configurableId,
        isGlobalApp,
        sendSectionItemAnalyticsEvent,
        setPeekMenuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aasrU.LinkMenuItem), {
        elemBefore: icon,
        href: url,
        onClick: onClick,
        key: key,
        target: isGlobalApp ? '_blank' : undefined
    }, formattedMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kRcOu.ButtonMenuItem), {
        elemBefore: icon,
        onClick: onClick,
        key: key
    }, formattedMessage));
}

});
parcelRegister("ig45T", function(module, exports) {

$parcel$export(module.exports, "convertToConfigurableMenuId", () => $7b296a666ec05c45$export$c54090f9034b2d83);

var $h4Bzb = parcelRequire("h4Bzb");
const $7b296a666ec05c45$export$c54090f9034b2d83 = (menuId)=>{
    switch(menuId){
        case 'jira.sidebar.apps':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).APPS;
        case 'jira.sidebar.assets':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).ASSETS;
        case 'jira.sidebar.dashboards':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).DASHBOARDS;
        case 'jira.sidebar.filters':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).FILTERS;
        case 'jira.sidebar.goals':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GOALS;
        case 'jira.sidebar.operations':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).OPERATIONS;
        case 'jira.sidebar.communication':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).COMMUNICATION;
        case 'jira.sidebar.overviews':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).OVERVIEWS;
        case 'jira.sidebar.plans':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).PLANS;
        case 'jira.sidebar.projects':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).PROJECTS;
        case 'jira.sidebar.recent':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).RECENT;
        case 'jira.sidebar.starred':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).STARRED;
        case 'jira.sidebar.teams':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).TEAMS;
        case 'jira.sidebar.roadmaps':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).ROADMAPS;
        case 'jira.sidebar.customerService':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE;
        case 'jira.sidebar.customerHubs':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).CUSTOMER_HUBS;
        case 'jira.sidebar.customerServiceAnalytics':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE_ANALYTICS;
        case 'jira.sidebar.globalApp.assets':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_ASSETS;
        case 'jira.sidebar.globalApp.goals':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_GOALS;
        case 'jira.sidebar.globalApp.confluence':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_CONFLUENCE;
        case 'jira.sidebar.globalApp.teams':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_TEAMS;
        case 'jira.sidebar.globalApp.projects':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_PROJECTS;
        case 'jira.sidebar.globalApp.loom':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_LOOM;
        case 'jira.sidebar.globalApp.opsgenie':
            return (0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_OPSGENIE;
        default:
            throw new Error(`Invalid menuId: ${menuId}`);
    }
};

});


parcelRegister("4exVH", function(module, exports) {

$parcel$export(module.exports, "PeekMenuItem", () => $e747ac1126b30647$export$4287f527b7969caa);

var $eJOHy = parcelRequire("eJOHy");

var $80rA3 = parcelRequire("80rA3");

var $mIeXW = parcelRequire("mIeXW");
const $e747ac1126b30647$export$4287f527b7969caa = ({ menuData: menuData })=>{
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const { peekMenuId: peekMenuId } = (0, $eJOHy.useContext)((0, $80rA3.PeekMenuIdContext));
    return !!peekMenuId && moreMenuIds.includes(peekMenuId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $mIeXW.ConfigurableMenuItem), {
        isDefaultOpen: true,
        menuData: menuData,
        menuId: peekMenuId
    });
};

});

parcelRegister("aKwXy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a39c89199cef8dab$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a39c89199cef8dab$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    more: {
        "id": "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu-items.sidebar-customization.more",
        "defaultMessage": "More"
    }
});

});

parcelRegister("2ng07", function(module, exports) {

$parcel$export(module.exports, "CustomizeSidebar", () => $3f83028505e53196$export$bfa967364825ce72);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $f7Yza = parcelRequire("f7Yza");

var $hOTKA = parcelRequire("hOTKA");

var $haSyH = parcelRequire("haSyH");

var $d6Pnu = parcelRequire("d6Pnu");
function $3f83028505e53196$export$bfa967364825ce72({ productItemsData: productItemsData, appItemsData: appItemsData }) {
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            productItemsData: productItemsData,
            appItemsData: appItemsData
        }), [
        productItemsData,
        appItemsData
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $hOTKA.CustomisableSidebarModalEntrypoint),
        entryPointProps: entryPointParams,
        title: formatMessage((0, $d6Pnu.default).customizeSidebar),
        useInternalModal: false
    }, ({ ref: ref })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $haSyH.CustomizeSidebarMenuItem), {
            ref: ref
        }));
}

});
parcelRegister("hOTKA", function(module, exports) {

$parcel$export(module.exports, "CustomisableSidebarModalEntrypoint", () => $6a1af2b46614ca1c$export$420f0b14c9bb574e);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $6a1af2b46614ca1c$export$420f0b14c9bb574e = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("jV9rR")).then(({ JiraCustomizationModal: JiraCustomizationModal })=>JiraCustomizationModal), {
        moduleId: "fd0bd96d",
        priority: "interaction"
    }),
    getPreloadProps: (props)=>({
            queries: {},
            props: props
        })
});

});
parcelRegister("jV9rR", function(module, exports) {

let $e80aab6b67f4fff6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e80aab6b67f4fff6$var$load("2vGol").then(()=>parcelRequire('79bi2'));

});


parcelRegister("haSyH", function(module, exports) {

$parcel$export(module.exports, "CustomizeSidebarMenuItem", () => $d410af64a035c01d$export$b7fa0daee00ba08b);

var $eJOHy = parcelRequire("eJOHy");

var $clUC1 = parcelRequire("clUC1");

var $kRcOu = parcelRequire("kRcOu");

var $2QH3X = parcelRequire("2QH3X");

var $qEpp6 = parcelRequire("qEpp6");

var $a9aec = parcelRequire("a9aec");

var $d6Pnu = parcelRequire("d6Pnu");
const $d410af64a035c01d$export$b7fa0daee00ba08b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick }, ref)=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $d6Pnu.default).customizeSidebar, (0, (/*@__PURE__*/$parcel$interopDefault($clUC1))));
    const sendSectionItemAnalyticsEvent = (0, $qEpp6.useSectionItemAnalytics)();
    const onClickHandler = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        sendSectionItemAnalyticsEvent({
            sectionItem: (0, $a9aec.SECTION_ITEM_CUSTOMIZE_SIDEBAR)
        });
        onClick?.(event, analyticsEvent);
    }, [
        onClick,
        sendSectionItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kRcOu.ButtonMenuItem), {
        interactionName: "nav4-sidebar-customise-modal",
        elemBefore: icon,
        onClick: onClickHandler,
        ref: ref
    }, formattedMessage);
});

});
parcelRegister("clUC1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8bb9804f9ea7eaa10f227008c94bcff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fe35c34c1011242$var$_react = $8fe35c34c1011242$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8fe35c34c1011242$var$_baseNew = $8fe35c34c1011242$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $8fe35c34c1011242$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8fe35c34c1011242$var$CustomizeIcon = (props)=>/*#__PURE__*/ $8fe35c34c1011242$var$_react.default.createElement($8fe35c34c1011242$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.375C3 1.615 3.616 1 4.375 1h1.75c.76 0 1.375.616 1.375 1.375v4.25C7.5 7.385 6.884 8 6.125 8h-1.75C3.615 8 3 7.384 3 6.625V5.25H0v-1.5h3zm1.5.125v4H6v-4zM16 5.25H8.5v-1.5H16zM8.5 9.375C8.5 8.615 9.116 8 9.875 8h1.75C12.385 8 13 8.616 13 9.375v1.375h3v1.5h-3v1.375c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zM10 9.5v4h1.5v-4zM0 12.25v-1.5h7.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$8fe35c34c1011242$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $8fe35c34c1011242$var$_default = module.exports.default = $8fe35c34c1011242$var$CustomizeIcon;

});

parcelRegister("d6Pnu", function(module, exports) {

$parcel$export(module.exports, "default", () => $772c2deb33dad986$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $772c2deb33dad986$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    customizeSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu-items.sidebar-customization.customize-sidebar-menu-item.customize-sidebar",
        "defaultMessage": "Customize sidebar"
    }
});

});




parcelRegister("5kDxs", function(module, exports) {

$parcel$export(module.exports, "PeekMenuIdContextProvider", () => $0be1425064f115cc$export$b7d1a20f5a877f18);

var $eJOHy = parcelRequire("eJOHy");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $cbCSE = parcelRequire("cbCSE");

var $80rA3 = parcelRequire("80rA3");
// Eventually this will be all configurable menu ids and can be removed at that point.
// TODO: Adam, I think we've reached that point.
const $0be1425064f115cc$var$CONFIGURABLE_MENU_IDS_USING_SIDEBAR_CONTEXT = [
    (0, $h4Bzb.CONFIGURABLE_MENU_ID).ASSETS,
    (0, $h4Bzb.CONFIGURABLE_MENU_ID).APPS,
    (0, $h4Bzb.CONFIGURABLE_MENU_ID).DASHBOARDS,
    (0, $h4Bzb.CONFIGURABLE_MENU_ID).FILTERS,
    (0, $h4Bzb.CONFIGURABLE_MENU_ID).OPERATIONS,
    (0, $h4Bzb.CONFIGURABLE_MENU_ID).PLANS,
    (0, $h4Bzb.CONFIGURABLE_MENU_ID).PROJECTS
];
const $0be1425064f115cc$export$b7d1a20f5a877f18 = ({ children: children })=>{
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const { isControlledNav: isControlledNav, isControlledPath: isControlledPath } = (0, $cbCSE.useSidebarNav4Controller)();
    const { moreMenuIds: moreMenuIds } = (0, $eJOHy.useContext)((0, $80rA3.NavItemsContext));
    const [peekMenuId, setPeekMenuId] = (0, $eJOHy.useState)(()=>$0be1425064f115cc$var$getAutoPeekMenuId(isSelectedPath, isControlledNav, isControlledPath, moreMenuIds));
    // This effect automatically overrides the manual value of peek menu id (set when clicking in the more menu item).
    // This effect is only triggered when controlled, selected, or more menu ids change.
    // Use layout effect so peek menu id is set before render.
    // An alternative to any effect would be to set peek menu id when setting selected path.
    // However, that may require elevating this context.
    (0, $eJOHy.useLayoutEffect)(()=>setPeekMenuId((currentPeekMenuId)=>$0be1425064f115cc$var$getAutoPeekMenuId(isSelectedPath, isControlledNav, isControlledPath, moreMenuIds, currentPeekMenuId)), [
        isControlledNav,
        isControlledPath,
        isSelectedPath,
        moreMenuIds
    ]);
    const peekMenuIdContext = (0, $eJOHy.useMemo)(()=>({
            peekMenuId: peekMenuId,
            setPeekMenuId: setPeekMenuId
        }), [
        peekMenuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $80rA3.PeekMenuIdContext).Provider, {
        value: peekMenuIdContext
    }, children);
};
const $0be1425064f115cc$var$getAutoPeekMenuId = (isSelectedPath, isControlledNav, isControlledPath, moreMenuIds, peekMenuId)=>{
    // When controlled...
    if (isControlledNav) return moreMenuIds.find(isControlledPath);
    // Otherwise selected...
    const autoPeekMenuId = moreMenuIds.find(isSelectedPath);
    // Once all configurable menu ids are using sidebar context we can just return `autoPeekMenuId`.
    if (autoPeekMenuId) return autoPeekMenuId;
    // Unpeek if peek menu id is no longer selected.
    // Only do this for menu ids using the sidebar context for now.
    // Legacy menu ids set peek menu id manually.
    if (peekMenuId && $0be1425064f115cc$var$CONFIGURABLE_MENU_IDS_USING_SIDEBAR_CONTEXT.includes(peekMenuId)) return undefined;
    // Otherwise unchanged.
    return peekMenuId;
};

});

parcelRegister("6CQFr", function(module, exports) {

$parcel$export(module.exports, "GlobalShortcutsWithInvitePeopleProvider", () => $0cc1fe580ce46bdc$export$19459237290a4ec4);
$parcel$export(module.exports, "GlobalShortcuts", () => $0cc1fe580ce46bdc$export$bae2da217bf9db6);

var $eJOHy = parcelRequire("eJOHy");

var $kEUB1 = parcelRequire("kEUB1");

var $iIz45 = parcelRequire("iIz45");
var $aQp9j = parcelRequire("aQp9j");

var $g9Vr6 = parcelRequire("g9Vr6");

var $ccYyA = parcelRequire("ccYyA");

var $8q7lT = parcelRequire("8q7lT");

var $7jTnu = parcelRequire("7jTnu");

var $286cZ = parcelRequire("286cZ");

var $9qvK9 = parcelRequire("9qvK9");

var $huZVT = parcelRequire("huZVT");

var $g7Dyb = parcelRequire("g7Dyb");
const $0cc1fe580ce46bdc$var$GlobalShortcutsComponent = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-3'), ({ appItemsData: appItemsData, teamsAppConfig: teamsAppConfig, handleUpdateGetFilteredProductLinks: handleUpdateGetFilteredProductLinks })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const userId = (0, $8q7lT.useAccountId)();
    const licenceFilterMap = (0, $g7Dyb.useLicenseFilterMap)(teamsAppConfig);
    // sort filtered products based on order of appItemsData
    const orderedShortcuts = (0, $9qvK9.useOrderedAppShortcuts)(licenceFilterMap, appItemsData);
    // sync updated shortcut items across the other atomic components
    const onUpdateGetFilteredProductLinks = (getFilteredProductLinks)=>{
        if (onUpdateGetFilteredProductLinks && handleUpdateGetFilteredProductLinks) handleUpdateGetFilteredProductLinks(getFilteredProductLinks);
    };
    const userIdOrUndefined = (0, $7jTnu.fg)('platform_navigation_data_provider_caching_support') ? userId || undefined : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iIz45.default), {
        cloudId: cloudId,
        orgId: orgId,
        userId: userIdOrUndefined,
        promoteSite: true,
        shortcutItems: orderedShortcuts,
        product: "jira",
        productLinksFilter: cloudId ? (0, $aQp9j.productLinksWorkspaceCloudIdFilter)(cloudId) : undefined,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
    });
});
// Wrapper required to use teams app shortcut hook
const $0cc1fe580ce46bdc$var$GlobalShortcutsInvitePeopleWrapper = (props)=>{
    const { component: teamsAppComponent, config: teamsAppConfig } = (0, $huZVT.useTeamsAppShortcut)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, teamsAppComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cc1fe580ce46bdc$var$GlobalShortcutsComponent, {
        ...props,
        teamsAppConfig: teamsAppConfig
    }));
};
const $0cc1fe580ce46bdc$export$19459237290a4ec4 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ccYyA.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cc1fe580ce46bdc$var$GlobalShortcutsInvitePeopleWrapper, props));
};
const $0cc1fe580ce46bdc$export$bae2da217bf9db6 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cc1fe580ce46bdc$var$GlobalShortcutsComponent, props);
};

});
parcelRegister("iIz45", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9b5afe163229497$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");


var $kxsjC = parcelRequire("kxsjC");

var $f1Zdy = parcelRequire("f1Zdy");

var $2y3Ci = parcelRequire("2y3Ci");

var $aRh7I = parcelRequire("aRh7I");

var $h1VbR = parcelRequire("h1VbR");

var $gaiLP = parcelRequire("gaiLP");

var $7SKIr = parcelRequire("7SKIr");
var $4PPPq = parcelRequire("4PPPq");
var $9nsoK = parcelRequire("9nsoK");

var $2SW0B = parcelRequire("2SW0B");

var $8l3lF = parcelRequire("8l3lF");

var $kLFT4 = parcelRequire("kLFT4");


var $8otNG = parcelRequire("8otNG");

var $4nKjo = parcelRequire("4nKjo");

var $xdvfj = parcelRequire("xdvfj");
var $d9b5afe163229497$export$2e2bcd8739ae039 // This is only needed to support the Atlaskit docs. See https://hello.atlassian.net/wiki/spaces/navx/pages/5305993008/Platform+Guide#Atlaskit-%3CProps%3E-component-not-rendering
 = $d9b5afe163229497$export$bae2da217bf9db6;
function $d9b5afe163229497$export$bae2da217bf9db6(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gaiLP.default), {
        name: (0, $edd8da6dce7988b2$export$fe240e33002221f),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4PPPq.BFFProvider), {
            consumer: (0, $7SKIr.BFFConsumerEnum).GLOBAL_SHORTCUTS,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kLFT4.GlobalShortcutsWithIntlProvider), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxsjC.NavigationAnalyticsContext), {
                    data: {
                        product: props?.product
                    },
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($d9b5afe163229497$var$Menu, {
                        ...props
                    })
                })
            })
        })
    });
}
function $d9b5afe163229497$var$Menu({ testId: testId, shortcutItems: shortcutItems = [], forceStatic: forceStatic, cloudId: cloudId, orgId: orgId, userId: userId, useSkeleton: useSkeleton, promoteSite: promoteSite, productLinksFilter: productLinksFilter, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks }) {
    // Update Ref
    const onUpdateGetFilteredProductLinksRef = (0, $eJOHy.useRef)(onUpdateGetFilteredProductLinks);
    onUpdateGetFilteredProductLinksRef.current = onUpdateGetFilteredProductLinks;
    // Filter Ref
    const productLinksFilterRef = (0, $eJOHy.useRef)(productLinksFilter);
    productLinksFilterRef.current = productLinksFilter;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { buildURLAndFetchData: buildURLAndFetchData, status: status, productLinks: productLinks } = (0, $9nsoK.useBFFDataProvider)({
        request: {},
        cloudId: cloudId,
        orgId: orgId,
        userId: userId,
        forceStatic: forceStatic
    });
    const getFilteredProductLinks = (0, $eJOHy.useCallback)((apsKey)=>{
        let filteredProductLinks = productLinks[apsKey] ?? [];
        if (productLinksFilterRef.current) filteredProductLinks = filteredProductLinks.filter(productLinksFilterRef.current);
        return {
            promotedLink: filteredProductLinks.find((item, _i, arr)=>arr.length === 1 || promoteSite && item.isCurrentSite),
            links: filteredProductLinks.filter((item, _i, arr)=>arr.length === 1 || !(promoteSite && item.isCurrentSite)),
            status: status
        };
    }, [
        productLinks,
        promoteSite,
        status
    ]);
    const mappedShortcutItems = (0, $eJOHy.useMemo)(()=>{
        return shortcutItems.map((item, index)=>{
            const key = item.apsKey || `shortcut-${index}`;
            // Render nested items if the dynamic data is available and we are not forcing static rendering
            if (!forceStatic && status?.toLowerCase() === (0, $7SKIr.RequestStatus).COMPLETE && item?.apsKey && productLinks?.[item.apsKey]) {
                const { links: filteredProductLinks, promotedLink: promotedLink } = getFilteredProductLinks(item.apsKey);
                const siteName = filteredProductLinks?.[0]?.displayName;
                // Determine whether shortcut is a single site and is current site and return link instead of flyout
                if (filteredProductLinks.length === 1 && !item.url) item.url = filteredProductLinks[0].url;
                return {
                    ...item,
                    siteName: siteName,
                    key: key,
                    promoted: promotedLink ? {
                        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8otNG.ImageFromUrl), {
                            src: promotedLink.avatar,
                            alt: "",
                            fallback: item.icon
                        }),
                        label: promotedLink.displayName,
                        url: promotedLink.url
                    } : undefined,
                    items: filteredProductLinks.map((link)=>({
                            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8otNG.ImageFromUrl), {
                                src: link.avatar,
                                alt: "",
                                fallback: item.icon
                            }),
                            label: link.displayName,
                            displayName: link.displayName,
                            url: link.url
                        }))
                };
            }
            return {
                ...item,
                key: key
            };
        });
    }, [
        shortcutItems,
        productLinks,
        forceStatic,
        status,
        getFilteredProductLinks
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (onUpdateGetFilteredProductLinksRef.current) onUpdateGetFilteredProductLinksRef.current(getFilteredProductLinks);
    }, [
        getFilteredProductLinks
    ]);
    const apsKeys = (0, $eJOHy.useMemo)(()=>{
        return shortcutItems.map((item)=>item.apsKey || '').filter((item)=>!!item);
    }, [
        shortcutItems
    ]);
    const mountedRef = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (forceStatic || status?.toLowerCase() !== (0, $7SKIr.RequestStatus).COMPLETE || productLinks && !Object.keys(productLinks).length || mountedRef.current === true) return;
        mountedRef.current = true;
        const missingShortcuts = shortcutItems.filter((item)=>{
            // todo: Should we include items with missing APS keys?
            return !(0, $8l3lF.getUrlMaybe)(item) && item.apsKey && !productLinks?.[item.apsKey];
        });
        const intended = shortcutItems.length;
        const rendered = intended - missingShortcuts.length;
        createAnalyticsEvent({
            eventType: (0, $27c7fc6638bd7614$export$a1562d08625f5d7e),
            action: 'cls',
            actionSubject: 'menu',
            actionSubjectId: 'globalNavigation',
            attributes: {
                name: product,
                intended: intended,
                rendered: rendered,
                missingAPSKeys: missingShortcuts.map((item)=>item.apsKey).filter(Boolean)
            }
        }).fire((0, $2SW0B.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        shortcutItems,
        productLinks,
        product,
        forceStatic,
        status
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!forceStatic) buildURLAndFetchData();
    }, [
        apsKeys,
        buildURLAndFetchData,
        forceStatic
    ]);
    const createLinkItem = (0, $eJOHy.useCallback)((shortcut)=>{
        if (status?.toLowerCase() === (0, $7SKIr.RequestStatus).COMPLETE) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $xdvfj.ShortcutMenuItem), {
            shortcut: shortcut,
            status: status,
            expandItems: shortcut.items && shortcut.items.length > 1 ? shortcut.items : undefined,
            promotedItem: shortcut.promoted,
            siteName: shortcut.siteName
        }, shortcut.key);
        // Show skeleton while BFF is loading
        if (useSkeleton && (status === (0, $7SKIr.RequestStatus).LOADING || status === (0, $7SKIr.RequestStatus).INIT)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nKjo.MenuSkeletonItem), {}, shortcut.key);
        // We only want to allow static menu expand item if we are forcing static,
        // otherwise it should be showing the singular item as a disabled link until the
        // data is loaded.
        if (forceStatic && shortcut.items) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $xdvfj.ShortcutMenuItem), {
            shortcut: shortcut,
            expandItems: shortcut.items,
            forceStatic: forceStatic
        }, shortcut.key);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $xdvfj.ShortcutMenuItem), {
            shortcut: shortcut,
            status: status,
            forceStatic: forceStatic
        }, shortcut.key);
    }, [
        forceStatic,
        status,
        useSkeleton
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $aRh7I.default), {
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2y3Ci.MenuList), {
                children: mappedShortcutItems?.map(createLinkItem)
            }),
            !forceStatic && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h1VbR.default), {
                name: (0, $edd8da6dce7988b2$export$2158b6d23c9689f5),
                hold: status === (0, $7SKIr.RequestStatus).INIT || status === (0, $7SKIr.RequestStatus).LOADING
            })
        ]
    });
}

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $27c7fc6638bd7614$export$a1562d08625f5d7e = 'ui';
const $27c7fc6638bd7614$export$947dac6c72b26f81 = 'track';
const $27c7fc6638bd7614$export$f1d537d508d2945a = 'screen';
const $27c7fc6638bd7614$export$12346a674644c156 = 'operational';
const $27c7fc6638bd7614$export$b055de0e665cb20c = 'unknown';

parcelRegister("7SKIr", function(module, exports) {

$parcel$export(module.exports, "BFFConsumerEnum", () => $e35928f7445fc89a$export$9a146e025690327e);
$parcel$export(module.exports, "ASSETS_APP_KEY", () => $e35928f7445fc89a$export$45e63649edff1e2a);
$parcel$export(module.exports, "MAX_ATTEMPTS_DEFAULT", () => $e35928f7445fc89a$export$45c80c6b98d65f36);
$parcel$export(module.exports, "RETRY_INTERVAL_DEFAULT", () => $e35928f7445fc89a$export$7b4183e5f0de390a);
$parcel$export(module.exports, "DAYS_AUTO_PROVISIONED_ITEM_CONSIDERED_NEW", () => $e35928f7445fc89a$export$891dc7068a3d5e65);
$parcel$export(module.exports, "DAYS_END_USER_ACTIVE_PRODUCT_CONSIDERED_NEW", () => $e35928f7445fc89a$export$6e594fe130dbe3b);
$parcel$export(module.exports, "RequestStatus", () => $e35928f7445fc89a$export$600e7c1f9e0414e1);
$parcel$export(module.exports, "BFF_REQUEST_STATUS_KEY", () => $e35928f7445fc89a$export$c889532d47d74e9c);
$parcel$export(module.exports, "FLIGHTDECK_REQUEST_STATUS_KEY", () => $e35928f7445fc89a$export$123b1b8742c0ac6a);
var $e35928f7445fc89a$export$9a146e025690327e = /*#__PURE__*/ function(BFFConsumerEnum) {
    BFFConsumerEnum["ATLASSIAN_SWITCHER"] = "ATLASSIAN_SWITCHER";
    BFFConsumerEnum["GLOBAL_SHORTCUTS"] = "GLOBAL_SHORTCUTS";
    BFFConsumerEnum["GLOBAL_SIDE_NAVIGATION"] = "GLOBAL_SIDE_NAVIGATION";
    BFFConsumerEnum["UNIVERSAL_CREATE"] = "UNIVERSAL_CREATE";
    return BFFConsumerEnum;
}({});
const $e35928f7445fc89a$export$45e63649edff1e2a = 'ASSETS';
const $e35928f7445fc89a$export$45c80c6b98d65f36 = 3;
const $e35928f7445fc89a$export$7b4183e5f0de390a = 1000;
const $e35928f7445fc89a$export$891dc7068a3d5e65 = 14;
const $e35928f7445fc89a$export$6e594fe130dbe3b = 14;
var $e35928f7445fc89a$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["INIT"] = "initializing";
    RequestStatus["LOADING"] = "loading";
    RequestStatus["COMPLETE"] = "complete";
    RequestStatus["ERROR"] = "error";
    return RequestStatus;
}({});
const $e35928f7445fc89a$export$c889532d47d74e9c = 'bff';
const $e35928f7445fc89a$export$123b1b8742c0ac6a = 'flightdeck';
const $e35928f7445fc89a$export$95d80cce92acae9 = 'uc-suggestions';

});

parcelRegister("4PPPq", function(module, exports) {

$parcel$export(module.exports, "BFFContext", () => $5685b2321db2c67e$export$873dcaf380a86d6b);
$parcel$export(module.exports, "useBFFContext", () => $5685b2321db2c67e$export$63342c357ecccda2);
$parcel$export(module.exports, "BFFProvider", () => $5685b2321db2c67e$export$71a938590b6955cc);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7SKIr = parcelRequire("7SKIr");
const $5685b2321db2c67e$export$b2445cd6f2d7fd5 = {
    cache: {},
    cacheKey: '',
    status: null,
    consumer: null
};
const $5685b2321db2c67e$export$873dcaf380a86d6b = /*#__PURE__*/ (0, $eJOHy.createContext)({
    value: $5685b2321db2c67e$export$b2445cd6f2d7fd5,
    currentLoadingRequests: [],
    setValue: ()=>{},
    updateCurrentLoadingRequests: (name, status)=>{}
});
function $5685b2321db2c67e$export$63342c357ecccda2() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($5685b2321db2c67e$export$873dcaf380a86d6b);
}
function $5685b2321db2c67e$export$71a938590b6955cc({ consumer: consumer, children: children }) {
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState({
        cache: {},
        cacheKey: consumer,
        consumer: consumer,
        status: (0, $7SKIr.RequestStatus).INIT
    });
    const [currentLoadingRequests, setCurrentLoadingRequests] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState([]);
    const updateCurrentLoadingRequests = (0, $eJOHy.useCallback)((name, status)=>{
        switch(status){
            case (0, $7SKIr.RequestStatus).LOADING:
                setCurrentLoadingRequests((prev)=>[
                        ...prev,
                        name
                    ]);
                break;
            case (0, $7SKIr.RequestStatus).COMPLETE:
                setCurrentLoadingRequests((prev)=>prev.filter((request)=>request !== name));
                break;
            case (0, $7SKIr.RequestStatus).ERROR:
                setCurrentLoadingRequests([]);
                break;
        }
    }, [
        setCurrentLoadingRequests
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($5685b2321db2c67e$export$873dcaf380a86d6b.Provider, {
        value: {
            value: value,
            setValue: setValue,
            currentLoadingRequests: currentLoadingRequests,
            updateCurrentLoadingRequests: updateCurrentLoadingRequests
        },
        children: children
    });
}

});

parcelRegister("9nsoK", function(module, exports) {

$parcel$export(module.exports, "useBFFDataProvider", () => $3ace0365b6e46310$export$a00b492c9c3c66db);

var $eJOHy = parcelRequire("eJOHy");

var $7SKIr = parcelRequire("7SKIr");

var $9aKrw = parcelRequire("9aKrw");

var $gapI3 = parcelRequire("gapI3");

var $gePDH = parcelRequire("gePDH");

var $8x21a = parcelRequire("8x21a");

var $c26Nd = parcelRequire("c26Nd");
async function $3ace0365b6e46310$var$wait(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $3ace0365b6e46310$export$a00b492c9c3c66db({ request: request, cloudId: cloudId, orgId: orgId, userId: userId, forceStatic: forceStatic }) {
    const { items: cachedItems, addItemsToCache: addItemsToCache, clearCache: clearCache, cacheKey: cacheKey, updateCacheKey: updateCacheKey } = (0, $gapI3.useCache)();
    const { setStatus: setStatus, status: status } = (0, $8x21a.useStatus)();
    const { productLinks: productLinks } = (0, $gePDH.useProductLinks)({
        cloudId: cloudId,
        orgId: orgId,
        forceStatic: forceStatic
    });
    const { buildURL: buildURL } = (0, $c26Nd.useURLBuilder)({
        cloudId: cloudId,
        userId: userId
    });
    const currentRequest = (0, $eJOHy.useRef)(null);
    const fetchData = (0, $eJOHy.useCallback)(async (url, data, attemptCount = 1, successCheck)=>{
        if (url === '') throw new Error('URL is empty');
        setStatus((0, $7SKIr.RequestStatus).LOADING, (0, $7SKIr.BFF_REQUEST_STATUS_KEY));
        try {
            const response = await (0, $9aKrw.fetchJSON)(url, {});
            switch(response.status){
                case (0, $7SKIr.RequestStatus).ERROR:
                    throw response.error;
                case (0, $7SKIr.RequestStatus).COMPLETE:
                    if (!successCheck || successCheck(response.data)) {
                        setStatus((0, $7SKIr.RequestStatus).COMPLETE, (0, $7SKIr.BFF_REQUEST_STATUS_KEY));
                        currentRequest.current = null;
                        return response.data;
                    } else throw new Error('BFF success check failed');
            }
        } catch (e) {
            const maxAttempts = request?.maxAttempts ?? (0, $7SKIr.MAX_ATTEMPTS_DEFAULT);
            if (request?.shouldRetryOnException && attemptCount < maxAttempts) {
                // Introduce longer wait times for each retry attempt
                await $3ace0365b6e46310$var$wait((request?.attemptInterval ?? (0, $7SKIr.RETRY_INTERVAL_DEFAULT)) * attemptCount);
                return await fetchData(url, data, attemptCount + 1, successCheck);
            } else {
                currentRequest.current = null;
                setStatus((0, $7SKIr.RequestStatus).ERROR);
                throw new Error('Max attempts reached');
            }
        }
    }, [
        request?.attemptInterval,
        request?.maxAttempts,
        request?.shouldRetryOnException,
        setStatus
    ]);
    /**
	 * Helper function to build a URL and fetch data.
	 */ const buildURLAndFetchData = (0, $eJOHy.useCallback)(async ()=>{
        // Wait for the current request to end before firing another
        if (currentRequest.current) return currentRequest.current;
        const builtUrl = buildURL({});
        if (builtUrl !== '') {
            currentRequest.current = fetchData(builtUrl, undefined, undefined, (result)=>{
                return result.sites && result.sites.length > 0;
            });
            const fetchedData = await currentRequest.current;
            if (fetchedData.sites && fetchedData.sites.length) addItemsToCache(fetchedData.sites);
        }
    }, [
        addItemsToCache,
        buildURL,
        fetchData
    ]);
    return {
        status: status,
        cachedItems: cachedItems,
        cacheKey: cacheKey,
        updateCacheKey: updateCacheKey,
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        buildURL: buildURL,
        fetchData: fetchData,
        buildURLAndFetchData: buildURLAndFetchData,
        productLinks: productLinks
    };
}

});
parcelRegister("9aKrw", function(module, exports) {

$parcel$export(module.exports, "isLocalHost", () => $bbfce01df95851ef$export$f931afb2c5ecf7c7);
$parcel$export(module.exports, "fetchJSON", () => $bbfce01df95851ef$export$81bec6e38e8b706b);

var $7SKIr = parcelRequire("7SKIr");

var $HHWoi = parcelRequire("HHWoi");
function $bbfce01df95851ef$export$23da1d24a38b0bde() {
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('jira-dev.com');
}
function $bbfce01df95851ef$export$f931afb2c5ecf7c7() {
    const host = window.location.host;
    return host.includes('localhost') && host.includes(':');
}
async function $bbfce01df95851ef$export$81bec6e38e8b706b(url, init) {
    try {
        const response = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: {
                'Atl-BFF-Payload-Version': (0, $HHWoi.default).packageVersion,
                ...init?.headers
            }
        });
        const jsonResponse = await response.json();
        return {
            status: (0, $7SKIr.RequestStatus).COMPLETE,
            data: jsonResponse
        };
    } catch (e) {
        return {
            status: (0, $7SKIr.RequestStatus).ERROR,
            error: e,
            data: null
        };
    }
}

});
parcelRegister("HHWoi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7245a824995d65b9$export$2e2bcd8739ae039);
const $7245a824995d65b9$var$packageName = "platform-pkg";
const $7245a824995d65b9$var$packageVersion = "0.0.0-use.local";
var $7245a824995d65b9$export$2e2bcd8739ae039 = {
    packageName: $7245a824995d65b9$var$packageName,
    packageVersion: $7245a824995d65b9$var$packageVersion
};

});


parcelRegister("gapI3", function(module, exports) {

$parcel$export(module.exports, "useCache", () => $41f2e2852deb0e1f$export$c6e89b6bb9436bc0);

var $eJOHy = parcelRequire("eJOHy");

var $4PPPq = parcelRequire("4PPPq");
function $41f2e2852deb0e1f$export$c6e89b6bb9436bc0() {
    const { value: { consumer: consumer, cache: cache, cacheKey: cacheKey }, setValue: setValue } = (0, $eJOHy.useContext)((0, $4PPPq.BFFContext));
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    const items = (0, $eJOHy.useMemo)(()=>{
        return cache[cacheKey] ?? [];
    }, [
        cache,
        cacheKey
    ]);
    const updateCacheKey = (0, $eJOHy.useCallback)((updatedCacheKey)=>{
        setValue((prev)=>({
                ...prev,
                cacheKey: `${consumer}-${updatedCacheKey}`
            }));
    }, [
        setValue,
        consumer
    ]);
    const addItemsToCache = (0, $eJOHy.useCallback)((items, compareKey = 'cloudId')=>{
        setValue((prev)=>{
            const itemData = prev.cache[cacheKey] ?? [];
            // Overwrite values with matched key if a new value is present
            // This shouldn't be necessary, but it helps act as a safeguard
            // for duplication.
            for (let item of items){
                const replacedItemIndex = itemData.findIndex((i)=>i[compareKey] === item[compareKey]);
                if (replacedItemIndex !== -1) itemData[replacedItemIndex] = item;
                else itemData.push(item);
            }
            return {
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: itemData
                }
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const clearCache = (0, $eJOHy.useCallback)(()=>{
        setValue((prev)=>({
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: []
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    return {
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        updateCacheKey: updateCacheKey,
        cacheKey: cacheKey,
        items: items
    };
}

});

parcelRegister("gePDH", function(module, exports) {

$parcel$export(module.exports, "useProductLinks", () => $fefdb0185d9b7fe6$export$79322ba781a26ce1);

var $eJOHy = parcelRequire("eJOHy");

var $9nfpX = parcelRequire("9nfpX");

var $igNUx = parcelRequire("igNUx");

var $7SKIr = parcelRequire("7SKIr");

var $iCgTy = parcelRequire("iCgTy");

var $6EA4X = parcelRequire("6EA4X");

var $jA7zj = parcelRequire("jA7zj");

var $gapI3 = parcelRequire("gapI3");

var $8x21a = parcelRequire("8x21a");
function $fefdb0185d9b7fe6$var$checkIsRecentEndUserActivatedProduct(productType, endUserActivationDate) {
    const parsedEndUserActivationDate = Date.parse(endUserActivationDate || '');
    if (!endUserActivationDate || isNaN(parsedEndUserActivationDate) || ![
        'CONFLUENCE',
        'JIRA_SERVICE_DESK',
        'JIRA_PRODUCT_DISCOVERY'
    ].includes(productType)) return false;
    const days = (0, $iCgTy.daysBetween)(new Date(parsedEndUserActivationDate), new Date());
    return days >= 0 && days <= (0, $7SKIr.DAYS_END_USER_ACTIVE_PRODUCT_CONSIDERED_NEW);
}
function $fefdb0185d9b7fe6$var$checkIsNewlyAutoProvisioned(autoProvisionDate) {
    let isConsideredNew = false;
    if (autoProvisionDate) {
        const days = (0, $iCgTy.daysBetween)(new Date(autoProvisionDate), new Date());
        isConsideredNew = days >= 0 && days <= (0, $7SKIr.DAYS_AUTO_PROVISIONED_ITEM_CONSIDERED_NEW);
    }
    return isConsideredNew;
}
function $fefdb0185d9b7fe6$var$checkShouldRemoveJWM(productType) {
    return [
        'JIRA_SOFTWARE',
        'JIRA_PRODUCT_DISCOVERY',
        'JIRA_SERVICE_DESK'
    ].includes(productType);
}
const $fefdb0185d9b7fe6$var$flightdeckClient = new (0, $9nfpX.default)('atlassian-navigagtion-bff-data-provider');
function $fefdb0185d9b7fe6$export$79322ba781a26ce1({ cloudId: cloudId, orgId: orgId, forceStatic: forceStatic }) {
    const { items: items } = (0, $gapI3.useCache)();
    const { setStatus: setStatus } = (0, $8x21a.useStatus)();
    const [fdResponse, setFdResponse] = (0, $eJOHy.useState)(null);
    const [productConfig, setProductConfig] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        const getFlightdeckData = async ()=>{
            try {
                setStatus((0, $7SKIr.RequestStatus).LOADING, (0, $7SKIr.FLIGHTDECK_REQUEST_STATUS_KEY));
                const fdResponse = await $fefdb0185d9b7fe6$var$flightdeckClient.fetchConfigFromFlightDeck({
                    // app-switcher-fe is currently the only valid name that is configured
                    // in Flightdeck
                    name: 'app-switcher-fe',
                    // This should get updated to be based on the supplied consumer
                    // name: `app-global-shortcuts-${consumer}-fe`,
                    dimensions: {
                        environmentType: 'prod',
                        perimeter: (0, $igNUx.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
                    }
                });
                setFdResponse(fdResponse);
                setStatus((0, $7SKIr.RequestStatus).COMPLETE, (0, $7SKIr.FLIGHTDECK_REQUEST_STATUS_KEY));
            } catch (e) {
                setStatus((0, $7SKIr.RequestStatus).ERROR, (0, $7SKIr.FLIGHTDECK_REQUEST_STATUS_KEY));
            }
        };
        if (!fdResponse && !forceStatic) getFlightdeckData();
    }, [
        fdResponse,
        setStatus,
        forceStatic
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!fdResponse) return;
        const config = {};
        for (const product of fdResponse.products){
            const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, rebrandedDisplayName: rebrandedDisplayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey, rebrandedIconKey: rebrandedIconKey } = product;
            config[apsKey] = {
                key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
                siteUrlSuffix: siteUrlSuffix,
                ordinal: ordinal,
                label: (0, $jA7zj.formatText)(displayName),
                rebrandedLabel: rebrandedDisplayName && (0, $jA7zj.formatText)(rebrandedDisplayName),
                description: (0, $jA7zj.formatText)(subtitle),
                iconKey: iconKey,
                rebrandedIconKey: rebrandedIconKey
            };
            // TODO: remove this once Asset app becomes standalone app
            if (apsKey === 'JIRA_SERVICE_DESK' && !config[0, $7SKIr.ASSETS_APP_KEY]) config[0, $7SKIr.ASSETS_APP_KEY] = {
                key: (0, $7SKIr.ASSETS_APP_KEY),
                siteUrlSuffix: '/jira/assets',
                ordinal: ordinal + 0.1,
                label: (0, $jA7zj.formatText)('Assets'),
                iconKey: 'assets'
            };
        }
        setProductConfig(config);
    }, [
        fdResponse
    ]);
    const getProductLinkForItem = (0, $eJOHy.useCallback)((productType, siteUrl, productUrl)=>{
        if (productUrl) return productUrl;
        const siteSuffix = productConfig?.[productType]?.siteUrlSuffix;
        return `${siteUrl}${siteSuffix}`;
    }, [
        productConfig
    ]);
    const productLinks = (0, $eJOHy.useMemo)(()=>{
        const products = {};
        const shouldRemoveJWM = items.some((item)=>{
            return (item.availableProducts || []).some(({ productType: productType })=>$fefdb0185d9b7fe6$var$checkShouldRemoveJWM(productType));
        });
        items.forEach((item)=>{
            const { availableProducts: availableProducts = [], cloudId: cachedItemCloudId, avatar: avatar, url: siteUrl, displayName: displayName, org: org } = item;
            // only apply org level filtering if org data is available
            if (org && orgId && org.id !== orgId) return;
            availableProducts.forEach((product)=>{
                const { autoProvisionDate: autoProvisionDate, companyHubName: companyHubName, isCompanyHubPublishedAndPremium: isCompanyHubPublishedAndPremium, endUserActivationDate: endUserActivationDate, url: productUrl } = product;
                let { productType: productType } = product;
                const isExcludeJiraBusiness = productType === 'JIRA_BUSINESS' && !shouldRemoveJWM;
                // if a site has JWM only and no other Jiras, JWM needs to appear under "Jira"
                // to ensure that this happens, we set JSM's productType to 'JIRA_SOFTWARE'
                // this will ensure that JWM is not removed, even if another site has JSW/JPD/JSM
                if (isExcludeJiraBusiness) productType = 'JIRA_SOFTWARE';
                if (!products[productType]) products[productType] = [];
                if (!isExcludeJiraBusiness) products[productType].push({
                    product: product,
                    isCurrentSite: Boolean(cachedItemCloudId) && cloudId?.toLowerCase() === cachedItemCloudId?.toLowerCase(),
                    isCompanyHubPublishedAndPremium: isCompanyHubPublishedAndPremium,
                    companyHubName: companyHubName,
                    shouldShowNewLozenge: $fefdb0185d9b7fe6$var$checkIsRecentEndUserActivatedProduct(productType, endUserActivationDate) || productType !== 'CONFLUENCE' && $fefdb0185d9b7fe6$var$checkIsNewlyAutoProvisioned(autoProvisionDate),
                    shouldShowTryLozenge: productType === 'CONFLUENCE' && $fefdb0185d9b7fe6$var$checkIsNewlyAutoProvisioned(autoProvisionDate),
                    autoProvisionDate: autoProvisionDate,
                    displayName: displayName,
                    url: getProductLinkForItem(productType, siteUrl, productUrl),
                    avatar: avatar,
                    cloudId: cachedItemCloudId
                });
            });
        });
        return (0, $6EA4X.sortArraysInObject)(products, (a, b)=>{
            return (0, $jA7zj.sortAlphabetically)('asc')(a.displayName, b.displayName);
        });
    }, [
        items,
        orgId,
        cloudId,
        getProductLinkForItem
    ]);
    return {
        productLinks: productLinks
    };
}

});
parcelRegister("iCgTy", function(module, exports) {

$parcel$export(module.exports, "daysBetween", () => $96b173aff64d93d9$export$416492d1a5f46c79);
const $96b173aff64d93d9$var$MILLISECONDS_IN_A_DAY = 86400000;
function $96b173aff64d93d9$export$416492d1a5f46c79(firstDate, secondDate) {
    if (!$96b173aff64d93d9$var$isValidDate(firstDate) || !$96b173aff64d93d9$var$isValidDate(secondDate)) return -1;
    const first = firstDate.getTime();
    const second = secondDate.getTime();
    const millisecondsBetween = Math.abs(second - first);
    return Math.round(millisecondsBetween / $96b173aff64d93d9$var$MILLISECONDS_IN_A_DAY);
}
// https://stackoverflow.com/questions/643782/how-to-check-whether-an-object-is-a-date/44198641#44198641
function $96b173aff64d93d9$var$isValidDate(date) {
    return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
}

});

parcelRegister("6EA4X", function(module, exports) {

$parcel$export(module.exports, "sortArraysInObject", () => $a74f83e8743f7000$export$3e8bbf689f8e6cad);
function $a74f83e8743f7000$export$3e8bbf689f8e6cad(record, sortFunction) {
    for(const key in record)if (Array.isArray(record[key])) record[key].sort(sortFunction); // Sorts alphabetically or numerically by default
    return record;
}

});

parcelRegister("jA7zj", function(module, exports) {

$parcel$export(module.exports, "formatText", () => $c9d4799d2a99632c$export$905fe28a7c283e1d);
$parcel$export(module.exports, "sortAlphabetically", () => $c9d4799d2a99632c$export$60f5d4abb43a14b3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
const $c9d4799d2a99632c$export$905fe28a7c283e1d = (text)=>{
    return typeof text === 'string' ? text : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...text
    });
};
const $c9d4799d2a99632c$export$60f5d4abb43a14b3 = (direction)=>(a, b)=>{
        const aLower = a.toLowerCase();
        const bLower = b.toLowerCase();
        if (direction === 'asc') return aLower.localeCompare(bLower);
        return bLower.localeCompare(aLower);
    };

});

parcelRegister("8x21a", function(module, exports) {

$parcel$export(module.exports, "useStatus", () => $2940c760e9de857a$export$53cc6abb6942ce72);

var $eJOHy = parcelRequire("eJOHy");

var $7SKIr = parcelRequire("7SKIr");

var $4PPPq = parcelRequire("4PPPq");
function $2940c760e9de857a$export$53cc6abb6942ce72() {
    const { setValue: setValue, value: { status: status }, currentLoadingRequests: currentLoadingRequests, updateCurrentLoadingRequests: updateCurrentLoadingRequests } = (0, $4PPPq.useBFFContext)();
    const isInitializing = (0, $eJOHy.useMemo)(()=>status === (0, $7SKIr.RequestStatus).INIT, [
        status
    ]);
    const isComplete = (0, $eJOHy.useMemo)(()=>status === (0, $7SKIr.RequestStatus).COMPLETE, [
        status
    ]);
    const isError = (0, $eJOHy.useMemo)(()=>status === (0, $7SKIr.RequestStatus).ERROR, [
        status
    ]);
    const isLoading = (0, $eJOHy.useMemo)(()=>status === (0, $7SKIr.RequestStatus).LOADING, [
        status
    ]);
    const isLoaded = (0, $eJOHy.useMemo)(()=>status !== (0, $7SKIr.RequestStatus).LOADING, [
        status
    ]);
    // Globally update the status based on the request queue for the BFF
    (0, $eJOHy.useEffect)(()=>{
        if (!currentLoadingRequests.length && status === (0, $7SKIr.RequestStatus).LOADING) // Ensure that the error state remains if it was previously set
        setValue((prev)=>{
            if (prev.status === (0, $7SKIr.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: (0, $7SKIr.RequestStatus).COMPLETE
            };
        });
    }, [
        currentLoadingRequests,
        setValue,
        status
    ]);
    // Globally manage the request queue of any calls to the BFF
    const setStatus = (0, $eJOHy.useCallback)((newStatus, integratingComponent)=>{
        if (newStatus === (0, $7SKIr.RequestStatus).LOADING && integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $7SKIr.RequestStatus).LOADING);
        if (newStatus === (0, $7SKIr.RequestStatus).COMPLETE) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $7SKIr.RequestStatus).COMPLETE);
        }
        if (newStatus === (0, $7SKIr.RequestStatus).ERROR) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $7SKIr.RequestStatus).ERROR);
        }
        // Don't allow the status to be marked as anything other than ERROR
        // if an error is pre-existing
        setValue((prev)=>{
            if (prev.status === (0, $7SKIr.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: newStatus === (0, $7SKIr.RequestStatus).ERROR ? (0, $7SKIr.RequestStatus).ERROR : (0, $7SKIr.RequestStatus).LOADING
            };
        });
    }, [
        updateCurrentLoadingRequests,
        setValue
    ]);
    return {
        status: status,
        isInitializing: isInitializing,
        isComplete: isComplete,
        isError: isError,
        isLoading: isLoading,
        isLoaded: isLoaded,
        setStatus: setStatus
    };
}

});


parcelRegister("c26Nd", function(module, exports) {

$parcel$export(module.exports, "useURLBuilder", () => $0e921126ff93b729$export$3748aab334e7d372);

var $eJOHy = parcelRequire("eJOHy");

var $7SKIr = parcelRequire("7SKIr");

var $9aKrw = parcelRequire("9aKrw");

var $gapI3 = parcelRequire("gapI3");

var $6O7WJ = parcelRequire("6O7WJ");
var $0e921126ff93b729$export$92af951f33a9009c = /*#__PURE__*/ function(BFFEndpointsEnum) {
    BFFEndpointsEnum["AVAILABLE_PRODUCTS"] = "/gateway/api/app-switcher/api/available-products";
    BFFEndpointsEnum["SUGGESTIONS"] = "/gateway/api/app-switcher/api/universal-create/v1/suggestions";
    return BFFEndpointsEnum;
}({});
function $0e921126ff93b729$export$3748aab334e7d372({ cloudId: cloudId, userId: userId }) {
    const { consumer: consumer } = (0, $6O7WJ.useConsumer)();
    const { items: cachedItems } = (0, $gapI3.useCache)();
    const buildUCRecommendationURL = (0, $eJOHy.useCallback)(({ product: product, orgId: orgId, userId: userId, locale: locale, subProduct: subProduct })=>{
        const baseUrl = "/gateway/api/app-switcher/api/universal-create/v1/suggestions";
        const url = new URL(`${getHomeUrl()}${baseUrl}`);
        const searchParams = new URLSearchParams();
        const queryParams = {
            tenantid: cloudId,
            product: product,
            orgid: orgId,
            userid: userId,
            source: consumer,
            locale: locale,
            subproduct: subProduct
        };
        Object.entries(queryParams).forEach(([key, value])=>{
            if (value) searchParams.append(key, value);
        });
        // Append search params to URL
        url.search = searchParams.toString();
        return url.toString();
    }, [
        consumer,
        cloudId
    ]);
    const buildProductShortcutURL = (0, $eJOHy.useCallback)(({ baseUrl: baseUrl })=>{
        baseUrl = baseUrl ?? "/gateway/api/app-switcher/api/available-products";
        // No point in building a URL if there are no items to fetch and the cache is already populated
        if (cachedItems.length > 0) return '';
        const queryValues = '';
        return `${getHomeUrl()}${baseUrl}?${queryValues}`;
    }, [
        cachedItems
    ]);
    const buildURL = (0, $eJOHy.useCallback)(({ baseUrl: baseUrl })=>{
        let url = '';
        if (baseUrl) url = `${getHomeUrl()}${baseUrl}`;
        // Consumer specific URL building implementations happen here
        switch(consumer){
            case (0, $7SKIr.BFFConsumerEnum).GLOBAL_SHORTCUTS:
                url = buildProductShortcutURL({});
                break;
            case (0, $7SKIr.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION:
                url = buildProductShortcutURL({});
                break;
        }
        if (!url) return url;
        // Append the consumer to the URL
        const formattedUrl = new URL(url);
        const updatedParams = new URLSearchParams(formattedUrl.search);
        if (consumer) updatedParams.append('source', consumer);
        if (cloudId) updatedParams.append('tenantid', cloudId);
        if (userId) updatedParams.append('userid', userId);
        return `${formattedUrl.origin}${formattedUrl.pathname}?${updatedParams}`;
    }, [
        buildProductShortcutURL,
        consumer,
        cloudId,
        userId
    ]);
    const getHomeUrl = ()=>{
        if ((0, $9aKrw.isLocalHost)()) return 'https://home.stg.atlassian.com';
        return new URL(window.location.href).origin;
    };
    return {
        buildURL: buildURL,
        buildProductShortcutURL: buildProductShortcutURL,
        buildUCRecommendationURL: buildUCRecommendationURL
    };
}

});
parcelRegister("6O7WJ", function(module, exports) {

$parcel$export(module.exports, "useConsumer", () => $eb33c3a459f3c6d7$export$33062d550933de6f);

var $eJOHy = parcelRequire("eJOHy");

var $4PPPq = parcelRequire("4PPPq");
function $eb33c3a459f3c6d7$export$33062d550933de6f() {
    const { value: { consumer: consumer } } = (0, $eJOHy.useContext)((0, $4PPPq.BFFContext));
    return {
        consumer: consumer
    };
}

});



parcelRegister("2SW0B", function(module, exports) {

$parcel$export(module.exports, "Products", () => $aba7864200117029$export$92e44ea1079b9ec6);
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $aba7864200117029$export$85183a312807388d);
/**
 * Product keys as defined in flight-deck.
 * https://bitbucket.org/atlassian/flight-deck/src/master/packages/integrations/twp-switch-to-products/contrib/
 */ var $aba7864200117029$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    // ATLAS_* - Need to be standalone apps to sit in this space
    Products["ATLAS_HOME"] = "ATLAS_HOME";
    Products["ATLAS_GOALS"] = "GOALS";
    Products["ATLAS_TEAMS"] = "TEAMS";
    Products["ATLAS_HUB"] = "ATLAS_HUB";
    Products["ANALYTICS"] = "ANALYTICS";
    Products["ASSETS"] = "ASSETS";
    Products["BITBUCKET"] = "BITBUCKET";
    Products["COMPASS"] = "COMPASS";
    Products["FOCUS"] = "mercury";
    Products["STUDIO"] = "STUDIO";
    Products["OPSGENIE"] = "OPSGENIE";
    Products["JIRA_SERVICE_MANAGEMENT"] = "JIRA_SERVICE_DESK";
    Products["JIRA_PRODUCT_DISCOVERY"] = "JIRA_PRODUCT_DISCOVERY";
    Products["JIRA_SOFTWARE"] = "JIRA_SOFTWARE";
    Products["CONFLUENCE"] = "CONFLUENCE";
    Products["LOOM"] = "LOOM";
    Products["PROJECTS"] = "PROJECTS";
    Products["TALENT"] = "TALENT";
    Products["TRELLO"] = "TRELLO";
    return Products;
}({});
const $aba7864200117029$export$85183a312807388d = 'navigation';

});

parcelRegister("8l3lF", function(module, exports) {

$parcel$export(module.exports, "getUrlMaybe", () => $c291ee5140ff18f9$export$ac51fdc0c7ed862d);

var $ffOne = parcelRequire("ffOne");
const $c291ee5140ff18f9$export$ac51fdc0c7ed862d = (options)=>options.url || (0, $ffOne.getFallbackUrlMaybe)(options.fallbackUrl);

});
parcelRegister("ffOne", function(module, exports) {

$parcel$export(module.exports, "getFallbackUrlMaybe", () => $6e798091f6bc86a0$export$1f32ba41e2b31f39);

var $an2Q7 = parcelRequire("an2Q7");
const $6e798091f6bc86a0$export$1f32ba41e2b31f39 = (fallbackUrl)=>{
    if (fallbackUrl === undefined) return undefined;
    return (0, $an2Q7.getFallbackUrl)(fallbackUrl);
};

});
parcelRegister("an2Q7", function(module, exports) {

$parcel$export(module.exports, "getFallbackUrl", () => $1c374d645f531b64$export$739b3f561aa47bc9);
const $1c374d645f531b64$export$739b3f561aa47bc9 = (fallbackUrl)=>{
    if (typeof fallbackUrl === 'function') return fallbackUrl();
    // `fallbackUrl` is a string, return it directly
    return fallbackUrl;
};

});



parcelRegister("kLFT4", function(module, exports) {

$parcel$export(module.exports, "GlobalShortcutsWithIntlProvider", () => $603450738dda4a01$export$6b89dea1a4334953);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NGNw = parcelRequire("5NGNw");

var $9OXN3 = parcelRequire("9OXN3");

var $319et = parcelRequire("319et");
const $603450738dda4a01$var$fetchMessagesForLocale = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $319et.asyncLanguages) ? locale : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $319et.asyncLanguages)[languageLocale]?.();
        return localeMessages?.default ?? (0, $9OXN3.default);
    } catch (e) {
    // ignore
    }
    return 0, $9OXN3.default;
};
const $603450738dda4a01$export$6b89dea1a4334953 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5NGNw.default), {
        defaultMessages: (0, $9OXN3.default),
        loaderFn: $603450738dda4a01$var$fetchMessagesForLocale,
        children: children
    });
};

});
parcelRegister("9OXN3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c5d0f840e4715c13$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $lbyQ5 = parcelRequire("lbyQ5");
var $c5d0f840e4715c13$export$2e2bcd8739ae039 = (0, $lbyQ5.default);

});
parcelRegister("lbyQ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f945bb9a6162f02$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $2f945bb9a6162f02$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'All sites',
    'navigation.global-shortcuts.apps.align': 'Align',
    'navigation.global-shortcuts.apps.analytics': 'Analytics',
    'navigation.global-shortcuts.apps.assets': 'Assets',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': 'Company Hub',
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': 'Goals',
    'navigation.global-shortcuts.apps.home': 'Home',
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Projects',
    'navigation.global-shortcuts.apps.projects-galaxia': 'Spaces',
    'navigation.global-shortcuts.apps.studio': 'Studio',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': 'Teams',
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Close',
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': '{name} site',
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(currently unavailable)',
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Open external link icon',
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(loading)',
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(loading)',
    'navigation.global-shortcuts.shortcut-action.open-menu-label': 'open menu',
    'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
    'navigation.global-shortcuts.sites': '{productName} sites'
};

});


parcelRegister("319et", function(module, exports) {

$parcel$export(module.exports, "asyncLanguages", () => $49d3755071dbb655$export$3770c7a7737d463c);

























const $49d3755071dbb655$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("icv0w")),
    da: ()=>(parcelRequire("gB0JE")),
    de: ()=>(parcelRequire("31hJU")),
    'en-GB': ()=>(parcelRequire("d4BrN")),
    'en-ZZ': ()=>(parcelRequire("MEpPG")),
    en: ()=>Promise.resolve((parcelRequire("9OXN3"))),
    es: ()=>(parcelRequire("lvHo7")),
    fi: ()=>(parcelRequire("5le3f")),
    fr: ()=>(parcelRequire("lhB0M")),
    hu: ()=>(parcelRequire("k46yU")),
    it: ()=>(parcelRequire("gPFWs")),
    ja: ()=>(parcelRequire("9AZiV")),
    ko: ()=>(parcelRequire("1Hhhy")),
    nb: ()=>(parcelRequire("2W6E7")),
    nl: ()=>(parcelRequire("gl8g3")),
    pl: ()=>(parcelRequire("gg0Wy")),
    'pt-BR': ()=>(parcelRequire("ggyfb")),
    ru: ()=>(parcelRequire("d9MaD")),
    sv: ()=>(parcelRequire("huUCZ")),
    th: ()=>(parcelRequire("lQz1f")),
    tr: ()=>(parcelRequire("jhMGC")),
    uk: ()=>(parcelRequire("jthAd")),
    vi: ()=>(parcelRequire("8vE34")),
    zh_TW: ()=>(parcelRequire("3jlmE")),
    zh: ()=>(parcelRequire("aVrFh"))
};

});
parcelRegister("icv0w", function(module, exports) {

let $d401666bd91fff15$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d401666bd91fff15$var$load("boAPw").then(()=>parcelRequire('eIqAP'));

});

parcelRegister("gB0JE", function(module, exports) {

let $c150ac0a0a5346b2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c150ac0a0a5346b2$var$load("1FJ1y").then(()=>parcelRequire('jaFSy'));

});

parcelRegister("31hJU", function(module, exports) {

let $232f39c4760e508c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $232f39c4760e508c$var$load("187KK").then(()=>parcelRequire('1Zsiz'));

});

parcelRegister("d4BrN", function(module, exports) {

let $9848b257692b579e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9848b257692b579e$var$load("0LSEj").then(()=>parcelRequire('ePABH'));

});

parcelRegister("MEpPG", function(module, exports) {

let $0923d5842fe09024$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0923d5842fe09024$var$load("9rqtC").then(()=>parcelRequire('9cyR7'));

});

parcelRegister("lvHo7", function(module, exports) {

let $fa8e2632424372e0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fa8e2632424372e0$var$load("avxoU").then(()=>parcelRequire('6NrGo'));

});

parcelRegister("5le3f", function(module, exports) {

let $3e39d03d604c0d25$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3e39d03d604c0d25$var$load("77o4F").then(()=>parcelRequire('bOmUn'));

});

parcelRegister("lhB0M", function(module, exports) {

let $f7e7e536223b77ac$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f7e7e536223b77ac$var$load("3YPxJ").then(()=>parcelRequire('aaIGO'));

});

parcelRegister("k46yU", function(module, exports) {

let $e9b9456f49338235$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e9b9456f49338235$var$load("5Ox6M").then(()=>parcelRequire('34ETP'));

});

parcelRegister("gPFWs", function(module, exports) {

let $c411f18c50a72050$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c411f18c50a72050$var$load("e8xaD").then(()=>parcelRequire('dwIVs'));

});

parcelRegister("9AZiV", function(module, exports) {

let $6fc7079547f5bbae$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6fc7079547f5bbae$var$load("iD3H9").then(()=>parcelRequire('lr0DP'));

});

parcelRegister("1Hhhy", function(module, exports) {

let $13c7367dd1289dc8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $13c7367dd1289dc8$var$load("jggVm").then(()=>parcelRequire('46cqQ'));

});

parcelRegister("2W6E7", function(module, exports) {

let $22362750a9b152d7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $22362750a9b152d7$var$load("6OScC").then(()=>parcelRequire('9S6ri'));

});

parcelRegister("gl8g3", function(module, exports) {

let $be55035b15731981$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $be55035b15731981$var$load("ldqqd").then(()=>parcelRequire('6iCFQ'));

});

parcelRegister("gg0Wy", function(module, exports) {

let $bd5edf499fc8a5d2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bd5edf499fc8a5d2$var$load("buB9d").then(()=>parcelRequire('ln4di'));

});

parcelRegister("ggyfb", function(module, exports) {

let $bd78b4149a941535$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bd78b4149a941535$var$load("4GNuR").then(()=>parcelRequire('42tJp'));

});

parcelRegister("d9MaD", function(module, exports) {

let $99417b439eb9224c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $99417b439eb9224c$var$load("cY1NF").then(()=>parcelRequire('kHxkT'));

});

parcelRegister("huUCZ", function(module, exports) {

let $cbd12a19ada78150$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cbd12a19ada78150$var$load("aQhFR").then(()=>parcelRequire('faXz1'));

});

parcelRegister("lQz1f", function(module, exports) {

let $fe799e59057d6233$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fe799e59057d6233$var$load("f7iL6").then(()=>parcelRequire('1pQhM'));

});

parcelRegister("jhMGC", function(module, exports) {

let $e0a55efa2fe31619$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e0a55efa2fe31619$var$load("5hzvd").then(()=>parcelRequire('35gvJ'));

});

parcelRegister("jthAd", function(module, exports) {

let $e2ce5d6521813f9a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e2ce5d6521813f9a$var$load("bNu5Q").then(()=>parcelRequire('2dccb'));

});

parcelRegister("8vE34", function(module, exports) {

let $632048c78b2569b5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $632048c78b2569b5$var$load("ixLaM").then(()=>parcelRequire('aoItg'));

});

parcelRegister("3jlmE", function(module, exports) {

let $2693b7f6e84678ce$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2693b7f6e84678ce$var$load("3aYM5").then(()=>parcelRequire('4aVHf'));

});

parcelRegister("aVrFh", function(module, exports) {

let $7f44afeec6028154$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7f44afeec6028154$var$load("2Vis0").then(()=>parcelRequire('8PGka'));

});



const $edd8da6dce7988b2$export$fe240e33002221f = 'global-shortcuts-platform-component';
const $edd8da6dce7988b2$export$2158b6d23c9689f5 = 'global-shortcuts-data-loading';

parcelRegister("8otNG", function(module, exports) {

$parcel$export(module.exports, "ImageFromUrl", () => $9811144480ae75c9$export$8ce0ddc4c9a614d4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eFc5v = parcelRequire("eFc5v");
const $9811144480ae75c9$export$8ce0ddc4c9a614d4 = ({ src: src, alt: alt, fallback: fallback, testId: testId })=>{
    const [hasError, setHasError] = (0, $eJOHy.useState)(false);
    if (!src || hasError) return fallback;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eFc5v.default), {
        src: src,
        alt: alt,
        onError: ()=>{
            setHasError(true);
        },
        testId: testId
    });
};

});

parcelRegister("4nKjo", function(module, exports) {

$parcel$export(module.exports, "MenuSkeletonItem", () => $4980f1f115531387$export$cde35cc9e1359709);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i7XOj = parcelRequire("i7XOj");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $9LyfF = parcelRequire("9LyfF");

var $aVwGC = parcelRequire("aVwGC");
const $4980f1f115531387$var$DEFAULT_MENU_SKELETON_HEIGHT = 32;
const $4980f1f115531387$var$DEFAULT_AVATAR_HEIGHT = 20;
const $4980f1f115531387$var$DEFAULT_CONTENT_HEIGHT = 12;
const $4980f1f115531387$var$DEFAULT_BORDER_RADIUS = 4;
const $4980f1f115531387$var$styles = {
    root: "_4t3izwfg _1bsb1osq _ca0qze3t _n3tdze3t _19bv1b66 _u5f31b66",
    avatar: "_19bvv77o"
};
const $4980f1f115531387$export$cde35cc9e1359709 = ({ avatarHeight: avatarHeight = $4980f1f115531387$var$DEFAULT_AVATAR_HEIGHT, contentHeight: contentHeight = $4980f1f115531387$var$DEFAULT_CONTENT_HEIGHT })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9LyfF.default), {
        xcss: (0, $i7XOj.cx)($4980f1f115531387$var$styles.root),
        alignBlock: "center",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $i8x5n.default), {
            alignItems: "center",
            gap: "space.050",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.default), {
                    xcss: (0, $i7XOj.cx)($4980f1f115531387$var$styles.avatar),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aVwGC.default), {
                        width: avatarHeight,
                        height: avatarHeight,
                        borderRadius: $4980f1f115531387$var$DEFAULT_BORDER_RADIUS
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aVwGC.default), {
                    width: "100%",
                    height: contentHeight,
                    borderRadius: "0"
                })
            ]
        })
    });
};

});

parcelRegister("xdvfj", function(module, exports) {

$parcel$export(module.exports, "ShortcutMenuItem", () => $82588a6647681fb4$export$af94fce1535255cc);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");


var $f1Zdy = parcelRequire("f1Zdy");

var $7SKIr = parcelRequire("7SKIr");

var $2SW0B = parcelRequire("2SW0B");

var $ffOne = parcelRequire("ffOne");

var $8l3lF = parcelRequire("8l3lF");

var $ejacE = parcelRequire("ejacE");

var $9187f = parcelRequire("9187f");

var $fvugt = parcelRequire("fvugt");
function $82588a6647681fb4$export$af94fce1535255cc({ shortcut: shortcut, status: status, expandItems: expandItems, forceStatic: forceStatic, promotedItem: promotedItem, siteName: siteName }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const analyticsName = shortcut.label;
    const siteNameAriaLabel = siteName ? ` (${siteName})` : '';
    /**
	 * If the data provider is being initialised or loading, we want to display a placeholder item with a spinner.
	 */ const loading = (0, $eJOHy.useMemo)(()=>!!(!forceStatic && status && (status === (0, $7SKIr.RequestStatus).INIT || status === (0, $7SKIr.RequestStatus).LOADING)), [
        status,
        forceStatic
    ]);
    /**
	 * Set disabled state based on what we know at this point
	 * from whether we are forcing static rendering and the status of the BFF request.
	 * If we have more conditions received from the BFF in the future (such as permissions), we can account for those here too.
	 */ const disabled = (0, $eJOHy.useMemo)(()=>{
        // If forceStatic is explicitly set to true, do not disable the item
        if (forceStatic) return false;
        // Do not explicitly disable links that have empty URLs, because we don't want to display them at all
        // todo: Should we include undefined URLs and fallback URLs?
        if ((0, $ffOne.getFallbackUrlMaybe)(shortcut.fallbackUrl) === '') return false;
        // Only show disabled state when the BFF request is complete and fails
        if (status === (0, $7SKIr.RequestStatus).ERROR) return true;
        if (forceStatic === undefined) return false;
        return !forceStatic;
    }, [
        forceStatic,
        shortcut,
        status
    ]);
    /**
	 * An event to pass down to the inner menu item component (MenuLinkItem or MenuExpandItem) to be called when the item is disabled.
	 * This allows the inner components to handle further disabling conditions within themselves if applicable,
	 * and optionally pass up a reason for the disabled state determined within itself.
	 * If no reason is passed, we check against what we know here from the data received from the BFF.
	 */ const onDisable = (0, $eJOHy.useCallback)((reason)=>{
        // Do not fire analytics event until loading is complete
        if (!status || status === (0, $7SKIr.RequestStatus).INIT || status === (0, $7SKIr.RequestStatus).LOADING) return;
        // This currently covers reasons like request errors.
        // If the BFF gives us more information in the future (such as permissions), that should be accounted for here too.
        const bffReason = status !== (0, $7SKIr.RequestStatus).COMPLETE ? status : undefined;
        createAnalyticsEvent({
            eventType: (0, $27c7fc6638bd7614$export$a1562d08625f5d7e),
            action: 'disabled',
            actionSubject: 'button',
            actionSubjectId: 'globalNavigation',
            attributes: {
                name: analyticsName,
                reason: reason ?? bffReason
            }
        }).fire((0, $2SW0B.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        analyticsName,
        status
    ]);
    const Component = shortcut?.component;
    if (Component) return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        onClick: ()=>{
            (0, $9187f.fireMenuLinkItemClickAnalyticsEvent)(createAnalyticsEvent, analyticsName);
            shortcut.onClick?.();
        }
    });
    if (expandItems && expandItems?.length > 0) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ejacE.MenuExpandItem), {
        analyticsName: analyticsName,
        icon: shortcut.icon,
        label: shortcut.label,
        labelElem: shortcut.labelElem,
        items: expandItems,
        disabled: disabled,
        onDisable: onDisable,
        promotedItem: promotedItem,
        loading: loading,
        onClick: shortcut.onClick
    }, shortcut.key);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9187f.MenuLinkItem), {
        analyticsName: analyticsName,
        disabled: disabled,
        apsKey: shortcut.apsKey,
        icon: shortcut.icon,
        url: (0, $8l3lF.getUrlMaybe)(shortcut),
        label: shortcut.label,
        labelElem: shortcut.labelElem,
        onDisable: onDisable,
        loading: loading,
        actions: shortcut.actions,
        ariaLabel: formatMessage((0, $fvugt.messages).menuLinkItemAriaLabel, {
            appName: analyticsName,
            siteName: siteNameAriaLabel
        }),
        onClick: shortcut.onClick
    }, shortcut.key);
}

});
parcelRegister("ejacE", function(module, exports) {

$parcel$export(module.exports, "MenuExpandItem", () => $9fab6fa1be59c645$export$3b6395e687b929ba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");


var $f1Zdy = parcelRequire("f1Zdy");

var $alkjW = parcelRequire("alkjW");

var $i7XOj = parcelRequire("i7XOj");

var $kRcOu = parcelRequire("kRcOu");

var $d9oCz = parcelRequire("d9oCz");
var $5jwgZ = parcelRequire("5jwgZ");
var $63KSu = parcelRequire("63KSu");

var $2y3Ci = parcelRequire("2y3Ci");

var $dhRXV = parcelRequire("dhRXV");

var $2SW0B = parcelRequire("2SW0B");

var $8l3lF = parcelRequire("8l3lF");

var $8LjUW = parcelRequire("8LjUW");

var $9187f = parcelRequire("9187f");

var $bvqrD = parcelRequire("bvqrD");

var $6z9z4 = parcelRequire("6z9z4");

var $4gZ0j = parcelRequire("4gZ0j");
const $9fab6fa1be59c645$var$styles = {
    root: "_otyr1b66"
};
const $9fab6fa1be59c645$export$3b6395e687b929ba = ({ icon: icon, label: label, labelElem: labelElem, analyticsName: analyticsName, items: items, disabled: disabled, onDisable: onDisable, promotedItem: promotedItem, loading: loading, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const closeFlyout = (0, $eJOHy.useCallback)(()=>setIsOpen(false), []);
    const toggleFlyout = (0, $eJOHy.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: (0, $27c7fc6638bd7614$export$a1562d08625f5d7e),
            action: 'clicked',
            actionSubject: 'globalNavigation',
            actionSubjectId: 'navigationItem',
            attributes: {
                name: analyticsName,
                isExpanding: !isOpen
            }
        }).fire((0, $2SW0B.ANALYTICS_CHANNEL));
        setIsOpen((prev)=>!prev);
        onClick?.();
    }, [
        createAnalyticsEvent,
        analyticsName,
        isOpen,
        onClick
    ]);
    const createLinkItem = (0, $eJOHy.useCallback)((shortcut, index)=>{
        return shortcut.items ? /*#__PURE__*/ (0, $gt9Am.jsx)($9fab6fa1be59c645$export$3b6395e687b929ba, {
            icon: shortcut.icon,
            label: shortcut.label,
            labelElem: shortcut.labelElem,
            items: shortcut.items,
            disabled: disabled,
            actions: shortcut.actions,
            analyticsName: analyticsName,
            onClick: shortcut.onClick
        }, shortcut?.apsKey ?? `shortcut-${index}`) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9187f.MenuLinkItem), {
            apsKey: shortcut.apsKey,
            icon: shortcut.icon,
            url: (0, $8l3lF.getUrlMaybe)(shortcut),
            label: shortcut.label,
            labelElem: shortcut.labelElem,
            disabled: disabled,
            ariaLabel: formatMessage((0, $4gZ0j.messages).siteAriaLabel, {
                name: shortcut.label
            }),
            analyticsName: analyticsName,
            onClick: shortcut.onClick
        }, shortcut?.apsKey ?? `shortcut-${index}`);
    }, [
        analyticsName,
        disabled,
        formatMessage
    ]);
    // If loading state then show loading placeholder
    if (loading === true) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvqrD.MenuLoadingItem), {
        icon: icon,
        label: labelElem ?? label
    });
    if (disabled) {
        onDisable?.();
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kRcOu.ButtonMenuItem), {
            elemBefore: icon,
            isDisabled: true,
            children: labelElem ?? label
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $d9oCz.FlyoutMenuItem), {
        isOpen: isOpen,
        onOpenChange: setIsOpen,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $63KSu.FlyoutMenuItemTrigger), {
                elemBefore: icon,
                onClick: toggleFlyout,
                children: labelElem ?? label
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5jwgZ.FlyoutMenuItemContent), {
                onClose: closeFlyout,
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8LjUW.MenuContent), {
                    heading: labelElem ?? label,
                    children: [
                        promotedItem && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6z9z4.MenuSection), {
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2y3Ci.MenuList), {
                                children: createLinkItem(promotedItem, 1)
                            }, "gas-promoted-sites")
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6z9z4.MenuSection), {
                            label: formatMessage((0, $4gZ0j.messages).allSites),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2y3Ci.MenuList), {
                                children: items?.map(createLinkItem)
                            }, "gas-all-sites")
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
                            xcss: (0, $i7XOj.cx)($9fab6fa1be59c645$var$styles.root),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $alkjW.default), {
                                shouldFitContainer: true,
                                appearance: "default",
                                onClick: closeFlyout,
                                children: formatMessage((0, $4gZ0j.messages).closeButtonAriaLabel)
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("8LjUW", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $cac4c615f4ae94b1$export$479f0f2f71193efe);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $i7XOj = parcelRequire("i7XOj");

var $bvFRW = parcelRequire("bvFRW");

var $jkibc = parcelRequire("jkibc");
var $bxHeV = parcelRequire("bxHeV");

var $axfZ6 = parcelRequire("axfZ6");
const $cac4c615f4ae94b1$var$styles = {
    root: "_1e0c1txw _2lx21bp4 _c71l1x4w _18m91wug _19bvu2gc _u5f3u2gc",
    heading: "_1rjc12x7 _19bv12x7 _1e0c1txw _4cvr1h6o"
};
const $cac4c615f4ae94b1$export$479f0f2f71193efe = ({ children: children, heading: heading })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $jkibc.default), {
        xcss: (0, $i7XOj.cx)($cac4c615f4ae94b1$var$styles.root),
        inline: "space.100",
        children: [
            heading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.default), {
                xcss: (0, $i7XOj.cx)($cac4c615f4ae94b1$var$styles.heading),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvFRW.default), {
                    size: "xsmall",
                    as: "h2",
                    children: formatMessage((0, $axfZ6.messages).sites, {
                        productName: heading
                    })
                })
            }),
            children
        ]
    });
};

});
parcelRegister("axfZ6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $549f5c10877e451e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $549f5c10877e451e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    sites: {
        id: 'navigation.global-shortcuts.sites',
        defaultMessage: '{productName} sites',
        description: 'The label that appends the product name in the expand menu'
    }
});

});


parcelRegister("9187f", function(module, exports) {

$parcel$export(module.exports, "fireMenuLinkItemClickAnalyticsEvent", () => $bd07a226a4037955$export$18a13ecc162cd5c2);
$parcel$export(module.exports, "MenuLinkItem", () => $bd07a226a4037955$export$68ef190193a37bc2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");


var $f1Zdy = parcelRequire("f1Zdy");

var $i7XOj = parcelRequire("i7XOj");

var $6L9RF = parcelRequire("6L9RF");

var $kRcOu = parcelRequire("kRcOu");

var $aasrU = parcelRequire("aasrU");

var $dhRXV = parcelRequire("dhRXV");

var $2SW0B = parcelRequire("2SW0B");

var $bvqrD = parcelRequire("bvqrD");

var $1VIfR = parcelRequire("1VIfR");

var $4OZiC = parcelRequire("4OZiC");
const $bd07a226a4037955$export$18a13ecc162cd5c2 = (createAnalyticsEvent, analyticsName)=>{
    createAnalyticsEvent({
        eventType: (0, $27c7fc6638bd7614$export$a1562d08625f5d7e),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'globalNavigation',
        attributes: {
            name: analyticsName
        }
    }).fire((0, $2SW0B.ANALYTICS_CHANNEL));
};
const $bd07a226a4037955$var$styles = {
    iconsBlock: "_18zr12x7"
};
const $bd07a226a4037955$export$68ef190193a37bc2 = ({ analyticsName: analyticsName, url: url, label: label, labelElem: labelElem, icon: icon, disabled: disabled, onDisable: onDisable, ariaLabel: ariaLabel, loading: loading, actions: actions, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const onClickMenuLinkItem = (0, $eJOHy.useCallback)(()=>{
        $bd07a226a4037955$export$18a13ecc162cd5c2(createAnalyticsEvent, analyticsName);
        onClick?.();
    }, [
        createAnalyticsEvent,
        analyticsName,
        onClick
    ]);
    // If loading is true, we want to render a representation of the button
    if (loading === true) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvqrD.MenuLoadingItem), {
        icon: icon,
        label: labelElem ?? label,
        showLinkIcon: true
    });
    // Don't render anything if url is undefined or empty, and disabled is not explicitly set to true
    if ((!url || url === '') && !disabled) return null;
    // Render disabled items if no url and/or disabled is true
    if (!url || disabled) {
        if (!url || url === '') onDisable?.('Invalid URL');
        else onDisable?.();
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $kRcOu.ButtonMenuItem), {
            elemBefore: icon,
            isDisabled: true,
            children: [
                labelElem ?? label,
                /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    "aria-label": formatMessage((0, $4OZiC.messages).disabledItemAriaLabel)
                })
            ]
        });
    }
    // Only render link item if url is defined
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aasrU.LinkMenuItem), {
        actionsOnHover: actions && actions.length && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1VIfR.ShortcutActionMenu), {
            actions: actions
        }),
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
            xcss: (0, $i7XOj.cx)($bd07a226a4037955$var$styles.iconsBlock),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6L9RF))), {
                label: formatMessage((0, $4OZiC.messages).linkExternalIconLabel),
                size: "small"
            })
        }),
        href: url,
        target: "_blank",
        onClick: onClickMenuLinkItem,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            "aria-label": ariaLabel,
            children: labelElem ?? label
        })
    });
};

});
parcelRegister("bvqrD", function(module, exports) {

$parcel$export(module.exports, "MenuLoadingItem", () => $5e67ef89872cef43$export$6c62e509491f8f00);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $i7XOj = parcelRequire("i7XOj");

var $6L9RF = parcelRequire("6L9RF");

var $kRcOu = parcelRequire("kRcOu");

var $dhRXV = parcelRequire("dhRXV");

var $dPlS8 = parcelRequire("dPlS8");

var $27u3y = parcelRequire("27u3y");
const $5e67ef89872cef43$var$styles = {
    iconsBlock: "_18zr12x7"
};
const $5e67ef89872cef43$export$6c62e509491f8f00 = ({ icon: icon, label: label, showLinkIcon: showLinkIcon })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $kRcOu.ButtonMenuItem), {
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
            xcss: (0, $i7XOj.cx)($5e67ef89872cef43$var$styles.iconsBlock),
            children: showLinkIcon ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6L9RF))), {
                label: formatMessage((0, $27u3y.messages).loadingItemAriaLabel),
                size: "small"
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dPlS8.default), {
                size: "small"
            })
        }),
        testId: "menu-button-loading",
        children: [
            label,
            /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                "aria-label": formatMessage((0, $27u3y.messages).loadingItemAriaLabel)
            })
        ]
    });
};

});
parcelRegister("27u3y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b7f22b0f7bf44908$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b7f22b0f7bf44908$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    loadingItemAriaLabel: {
        id: 'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label',
        description: 'Additional context after the label text for screen reader users when an item is loading',
        defaultMessage: '(loading)'
    }
});

});


parcelRegister("1VIfR", function(module, exports) {

$parcel$export(module.exports, "ShortcutActionMenu", () => $79656cea8fd8aea7$export$7e648395389e18b0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $4BzUI = parcelRequire("4BzUI");

var $i140O = parcelRequire("i140O");

var $1AUsu = parcelRequire("1AUsu");
var $MlWTN = parcelRequire("MlWTN");

var $5UxOh = parcelRequire("5UxOh");

var $hdza0 = parcelRequire("hdza0");
const $79656cea8fd8aea7$export$7e648395389e18b0 = ({ actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5UxOh.Popup), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $MlWTN.default), {
                children: actions.map((action, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $1AUsu.default), {
                        onClick: (e)=>{
                            e.preventDefault();
                            action.onClick?.();
                            setIsOpen(false);
                        },
                        children: action.component
                    }, index))
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                icon: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i140O))), {
                        ...props,
                        size: "small"
                    }),
                label: formatMessage((0, $hdza0.messages).shortcutActionOpenMenuLabel),
                onClick: ()=>setIsOpen(true)
            })
    });
};

});
parcelRegister("hdza0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $15d849e1b84331b3$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $15d849e1b84331b3$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    shortcutActionOpenMenuLabel: {
        id: 'navigation.global-shortcuts.shortcut-action.open-menu-label',
        description: 'Label for shortcut action items button',
        defaultMessage: 'open menu'
    }
});

});


parcelRegister("4OZiC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $448f10b5f378948f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $448f10b5f378948f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    disabledItemAriaLabel: {
        id: 'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label',
        description: 'Additional context after the label text for screen reader users when an item is disabled',
        defaultMessage: '(currently unavailable)'
    },
    loadingItemAriaLabel: {
        id: 'navigation.global-shortcuts.menu-link-item.loading-item-aria-label',
        description: 'Additional context after the label text for screen reader users when an item is loading',
        defaultMessage: '(loading)'
    },
    linkExternalIconLabel: {
        id: 'navigation.global-shortcuts.menu-link-item.link-external-item-label',
        description: 'Label for the link external icon',
        defaultMessage: 'Open external link icon'
    }
});

});


parcelRegister("6z9z4", function(module, exports) {

$parcel$export(module.exports, "MenuSection", () => $c650c5fa65d4c16b$export$4b1545b4f2016d26);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i7XOj = parcelRequire("i7XOj");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
const $c650c5fa65d4c16b$var$styles = {
    heading: "_11c82smr _1rjcu2gc _19bv12x7 _ca0qu2gc _n3tdu2gc _syaz1gjq _k48p1pd9 _1e0c1txw _4cvr1h6o"
};
const $c650c5fa65d4c16b$export$4b1545b4f2016d26 = ({ children: children, label: label })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $i8x5n.default), {
        direction: "column",
        children: [
            label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.default), {
                xcss: (0, $i7XOj.cx)($c650c5fa65d4c16b$var$styles.heading),
                children: label
            }),
            children
        ]
    });
};

});

parcelRegister("4gZ0j", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ec3104b6523d7360$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $ec3104b6523d7360$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    allSites: {
        id: 'navigation.global-shortcuts.all-sites',
        defaultMessage: 'All sites',
        description: 'The "all sites" menu label in expand menu'
    },
    closeButtonAriaLabel: {
        id: 'navigation.global-shortcuts.menu-expand-item.close-button-aria-label',
        description: 'Close button for menu expand item content',
        defaultMessage: 'Close'
    },
    siteAriaLabel: {
        id: 'navigation.global-shortcuts.menu-expand-item.site-aria-label',
        description: 'Aria label for sites',
        defaultMessage: '{name} site'
    }
});

});


parcelRegister("fvugt", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d71e617a5759dd1e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d71e617a5759dd1e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    menuLinkItemAriaLabel: {
        id: 'navigation.global-shortcuts.shortcut-link-item.aria-label',
        description: 'Aria label for menu link item',
        defaultMessage: '{appName}{siteName}'
    }
});

});



parcelRegister("aQp9j", function(module, exports) {

$parcel$export(module.exports, "productLinksWorkspaceCloudIdFilter", () => $d618eafe5a9945ae$export$54a1da5292674ec8);
const $d618eafe5a9945ae$export$54a1da5292674ec8 = (workspaceCloudId)=>(item, index, arr)=>{
        const matchedItem = arr.find((productLink)=>{
            return productLink.cloudId === workspaceCloudId;
        });
        // If an item exists in the parent array with the same cloudId,
        // we don't want to show a flyout and instead only want the list
        // of available product links to include the matching cloudId.
        if (matchedItem) return workspaceCloudId === item.cloudId;
        // If the filter gets here we want to only pass the first item
        return index === 0;
    };

});

parcelRegister("9qvK9", function(module, exports) {

$parcel$export(module.exports, "useOrderedAppShortcuts", () => $5045ab6151543f3b$export$4bb4a114d280c175);

var $eJOHy = parcelRequire("eJOHy");
const $5045ab6151543f3b$export$4bb4a114d280c175 = (shortcuts, appItemsData)=>{
    const orderedShortcuts = (0, $eJOHy.useMemo)(()=>{
        if (!appItemsData || appItemsData.length === 0) return Object.values(shortcuts);
        return appItemsData.reduce((acc, value)=>{
            const config = shortcuts[value.menuId];
            if (config && value.visible) acc.push(config);
            return acc;
        }, []);
    }, [
        appItemsData,
        shortcuts
    ]);
    return orderedShortcuts;
};

});

parcelRegister("huZVT", function(module, exports) {

$parcel$export(module.exports, "useTeamsAppShortcut", () => $f3c7d9176e76ca2a$export$68b2e4594fafcb97);

var $eJOHy = parcelRequire("eJOHy");

var $h8epd = parcelRequire("h8epd");

var $lRq8t = parcelRequire("lRq8t");

var $dZ5xe = parcelRequire("dZ5xe");

var $cFGzN = parcelRequire("cFGzN");

var $2VH7W = parcelRequire("2VH7W");

var $k8PfX = parcelRequire("k8PfX");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");



var $a9aec = parcelRequire("a9aec");

var $2LcvY = parcelRequire("2LcvY");

var $h4Bzb = parcelRequire("h4Bzb");

var $41vqi = parcelRequire("41vqi");
const $f3c7d9176e76ca2a$var$CREATE_A_TEAM = 'createATeam';
const $f3c7d9176e76ca2a$var$INVITE_PEOPLE = 'invitePeople';
const $f3c7d9176e76ca2a$export$68b2e4594fafcb97 = ()=>{
    const USER_NAVIGATION_ITEM_LINKS = (0, $41vqi.getUserNavigationItemLinks)();
    const teamsConfig = (0, $dZ5xe.useTeams)(USER_NAVIGATION_ITEM_LINKS[0, $h4Bzb.MENU_ID_TEAMS]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const invitePeopleModalTrigger = (0, $2VH7W.useInvitePeopleModal)();
    const [createTeamModal, createTeamModalTrigger] = (0, $cFGzN.useCreateTeamModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const component = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, createTeamModal);
    }, [
        createTeamModal
    ]);
    const config = (0, $eJOHy.useMemo)(()=>{
        return {
            ...teamsConfig,
            actions: [
                {
                    onClick: ()=>{
                        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: 'dropdownItem',
                            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_TEAMS],
                            attributes: {
                                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                                parentItemId: (0, $a9aec.GLOBAL_APP_SHORTCUT_TEAMS),
                                itemId: $f3c7d9176e76ca2a$var$INVITE_PEOPLE
                            }
                        });
                        invitePeopleModalTrigger();
                    },
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, formatMessage((0, $k8PfX.default).invitePeople))
                },
                {
                    onClick: ()=>{
                        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: 'dropdownItem',
                            actionSubjectId: (0, $2LcvY.MENU_ID_ANALYTIC_EVENT_IDS)[0, $h4Bzb.MENU_ID_TEAMS],
                            attributes: {
                                level: (0, $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1),
                                componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
                                parentItemId: (0, $a9aec.GLOBAL_APP_SHORTCUT_TEAMS),
                                itemId: $f3c7d9176e76ca2a$var$CREATE_A_TEAM
                            }
                        });
                        createTeamModalTrigger();
                    },
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), null, formatMessage((0, $k8PfX.default).createTeam))
                }
            ]
        };
    }, [
        teamsConfig,
        createTeamModalTrigger,
        invitePeopleModalTrigger,
        formatMessage,
        createAnalyticsEvent
    ]);
    return {
        config: config,
        component: component
    };
};

});
parcelRegister("dZ5xe", function(module, exports) {

$parcel$export(module.exports, "useTeams", () => $b70d56f680f035e4$export$6fe02dcc2001dcb0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8uw8h = parcelRequire("8uw8h");

var $2SW0B = parcelRequire("2SW0B");

var $14lOq = parcelRequire("14lOq");

var $9gHVU = parcelRequire("9gHVU");
const $b70d56f680f035e4$var$icon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.TeamsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true
});
const $b70d56f680f035e4$export$6fe02dcc2001dcb0 = (fallbackUrl)=>(0, $14lOq.useAppGlobalShortcutLinkItem)($b70d56f680f035e4$var$icon, (0, $9gHVU.messages).label, fallbackUrl, {
        apsKey: (0, $2SW0B.Products).ATLAS_TEAMS
    });

});
parcelRegister("14lOq", function(module, exports) {

$parcel$export(module.exports, "useAppGlobalShortcutLinkItem", () => $2972160b3f7defc2$export$7613f0bd7ffe380c);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");
const $2972160b3f7defc2$export$7613f0bd7ffe380c = (icon, label, fallbackUrl, options)=>{
    const { labelElem: labelElem, apsKey: apsKey } = options ?? {};
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $eJOHy.useMemo)(()=>({
            icon: icon,
            label: formatMessage(label),
            labelElem: labelElem,
            apsKey: apsKey,
            fallbackUrl: fallbackUrl
        }), [
        apsKey,
        fallbackUrl,
        formatMessage,
        icon,
        label,
        labelElem
    ]);
};

});

parcelRegister("9gHVU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $94fda84e39f7c873$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $94fda84e39f7c873$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.teams',
        defaultMessage: 'Teams',
        description: 'The link label for Teams'
    }
});

});



parcelRegister("g7Dyb", function(module, exports) {

$parcel$export(module.exports, "useLicenseFilterMap", () => $641cf0eae92bc890$export$bb19044ea3485639);

var $eJOHy = parcelRequire("eJOHy");

var $gu8vI = parcelRequire("gu8vI");

var $kgWR4 = parcelRequire("kgWR4");

var $jycaj = parcelRequire("jycaj");

var $49RNM = parcelRequire("49RNM");

var $edNrL = parcelRequire("edNrL");

var $eIH5E = parcelRequire("eIH5E");

var $8IuE5 = parcelRequire("8IuE5");

var $epTsa = parcelRequire("epTsa");

var $41vqi = parcelRequire("41vqi");

var $9Byj7 = parcelRequire("9Byj7");

var $aYncF = parcelRequire("aYncF");

var $8wUZn = parcelRequire("8wUZn");
const $641cf0eae92bc890$export$bb19044ea3485639 = (teamsAppConfig)=>{
    const licenceStates = (0, $8wUZn.useLicenseStates)();
    const products = (0, $aYncF.getLicensedProducts)();
    const hasConfluence = products[(0, $aYncF.LICENSED_PRODUCTS).CONFLUENCE];
    const hasLoom = products[(0, $aYncF.LICENSED_PRODUCTS).LOOM];
    let hasTownsquare = true;
    if ((0, $epTsa.expVal)('navx-1075-remove-goals-and-projects-fallback-urls', 'isEnabled', false)) // Force `false` if value is not defined
    hasTownsquare = !!products[(0, $aYncF.LICENSED_PRODUCTS).TOWNSQUARE];
    const USER_NAVIGATION_ITEM_LINKS = (0, $41vqi.getUserNavigationItemLinks)();
    const confluenceItem = (0, $kgWR4.useConfluence)(USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]);
    const loomItem = (0, $jycaj.useLoom)(USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]);
    const assetsItem = (0, $gu8vI.useAssets)(USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]);
    const opsgenieItem = (0, $edNrL.useOpsgenie)(USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]);
    const goalsItem = (0, $49RNM.useGoals)(USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]);
    const projectsItem = (0, $eIH5E.useProjects)(USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]);
    return (0, $eJOHy.useMemo)(()=>{
        const assetsItemWithComponent = {
            ...assetsItem,
            component: $641cf0eae92bc890$var$AssetsComponent
        };
        if (licenceStates.core === 'ACTIVE') {
            if (licenceStates.serviceDesk === 'ACTIVE') return {
                ...hasConfluence ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: confluenceItem
                } : {},
                ...hasLoom ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: loomItem
                } : {},
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: assetsItemWithComponent,
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: opsgenieItem,
                ...teamsAppConfig ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
                } : {},
                ...hasTownsquare ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: goalsItem
                } : {}
            };
            if (licenceStates.productDiscovery === 'ACTIVE') return {
                ...hasConfluence ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: confluenceItem
                } : {},
                ...hasLoom ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: loomItem
                } : {},
                ...teamsAppConfig ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
                } : {},
                ...hasTownsquare ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: goalsItem
                } : {}
            };
        } else {
            if (licenceStates.serviceDesk === 'ACTIVE') return {
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: assetsItemWithComponent,
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: opsgenieItem,
                ...teamsAppConfig ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
                } : {},
                ...hasTownsquare ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: goalsItem
                } : {}
            };
            if (licenceStates.productDiscovery === 'ACTIVE') return {
                ...teamsAppConfig ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
                } : {},
                ...hasTownsquare ? {
                    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: goalsItem
                } : {}
            };
        }
        return {
            ...hasConfluence ? {
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: confluenceItem
            } : {},
            ...hasLoom ? {
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: loomItem
            } : {},
            ...teamsAppConfig ? {
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: teamsAppConfig
            } : {},
            ...hasTownsquare ? {
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: goalsItem
            } : {},
            ...hasTownsquare ? {
                [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: projectsItem
            } : {}
        };
    }, [
        assetsItem,
        confluenceItem,
        goalsItem,
        hasConfluence,
        hasLoom,
        hasTownsquare,
        licenceStates.core,
        licenceStates.productDiscovery,
        licenceStates.serviceDesk,
        loomItem,
        opsgenieItem,
        projectsItem,
        teamsAppConfig
    ]);
};
const $641cf0eae92bc890$var$AssetsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Byj7.GlobalAppShortcuts), {
        menuId: (0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS
    });

});
parcelRegister("gu8vI", function(module, exports) {

$parcel$export(module.exports, "useAssets", () => $b9181047624f0c5c$export$bd973f06e9aaec8c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $8uw8h = parcelRequire("8uw8h");

var $2SW0B = parcelRequire("2SW0B");

var $14lOq = parcelRequire("14lOq");

var $6Mg1Q = parcelRequire("6Mg1Q");
const $b9181047624f0c5c$var$icon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.AssetsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true
});
function $b9181047624f0c5c$export$2e2bcd8739ae039(fallbackUrl) {
    return {
        icon: $b9181047624f0c5c$var$icon,
        // The i18n unfriendly default value of `label` is why this function is deprecated.
        // `labelElem` will be used instead of `label` in most places, but `label` will still be used in some places like customization modal.
        // For an i18n friendly default value of `label`, please use `useAssets` instead.
        label: 'Assets',
        labelElem: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $6Mg1Q.messages).label
        }),
        fallbackUrl: fallbackUrl,
        apsKey: (0, $2SW0B.Products).ASSETS
    };
}
const $b9181047624f0c5c$export$bd973f06e9aaec8c = (fallbackUrl)=>(0, $14lOq.useAppGlobalShortcutLinkItem)($b9181047624f0c5c$var$icon, (0, $6Mg1Q.messages).label, fallbackUrl, {
        apsKey: (0, $2SW0B.Products).ASSETS
    });

});
parcelRegister("6Mg1Q", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c68002185c3c9e00$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $c68002185c3c9e00$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.assets',
        defaultMessage: 'Assets',
        description: 'The link label for Assets'
    }
});

});


parcelRegister("kgWR4", function(module, exports) {

$parcel$export(module.exports, "useConfluence", () => $58a41848b83c79eb$export$4f925a926283ab5);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8uw8h = parcelRequire("8uw8h");

var $2SW0B = parcelRequire("2SW0B");

var $14lOq = parcelRequire("14lOq");

var $2WZRW = parcelRequire("2WZRW");
const $58a41848b83c79eb$var$icon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.ConfluenceIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true
});
const $58a41848b83c79eb$export$4f925a926283ab5 = (fallbackUrl)=>(0, $14lOq.useAppGlobalShortcutLinkItem)($58a41848b83c79eb$var$icon, (0, $2WZRW.messages).label, fallbackUrl, {
        apsKey: (0, $2SW0B.Products).CONFLUENCE
    });

});
parcelRegister("2WZRW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7028cfb96fdd1ea7$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $7028cfb96fdd1ea7$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.confluence',
        defaultMessage: 'Confluence',
        description: 'The link label for Confluence'
    }
});

});


parcelRegister("jycaj", function(module, exports) {

$parcel$export(module.exports, "useLoom", () => $231f6090687776b6$export$ef6b4021b8157342);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8uw8h = parcelRequire("8uw8h");

var $2SW0B = parcelRequire("2SW0B");

var $14lOq = parcelRequire("14lOq");

var $4yKce = parcelRequire("4yKce");
const $231f6090687776b6$var$icon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.LoomIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true
});
const $231f6090687776b6$export$ef6b4021b8157342 = (fallbackUrl)=>(0, $14lOq.useAppGlobalShortcutLinkItem)($231f6090687776b6$var$icon, (0, $4yKce.messages).label, fallbackUrl, {
        apsKey: (0, $2SW0B.Products).LOOM
    });

});
parcelRegister("4yKce", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b1695df98ffb4cb2$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b1695df98ffb4cb2$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.loom',
        defaultMessage: 'Loom',
        description: 'The link label for Loom'
    }
});

});


parcelRegister("49RNM", function(module, exports) {

$parcel$export(module.exports, "useGoals", () => $706f12e493a33df5$export$1b288bd6ab893e8f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8uw8h = parcelRequire("8uw8h");

var $2SW0B = parcelRequire("2SW0B");

var $14lOq = parcelRequire("14lOq");

var $iuxhi = parcelRequire("iuxhi");
const $706f12e493a33df5$var$icon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.GoalsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true
});
const $706f12e493a33df5$export$1b288bd6ab893e8f = (fallbackUrl)=>(0, $14lOq.useAppGlobalShortcutLinkItem)($706f12e493a33df5$var$icon, (0, $iuxhi.messages).label, fallbackUrl, {
        apsKey: (0, $2SW0B.Products).ATLAS_GOALS
    });

});
parcelRegister("iuxhi", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dd1c4da6beb030e4$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $dd1c4da6beb030e4$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.goals',
        defaultMessage: 'Goals',
        description: 'The link label for Goals'
    }
});

});


parcelRegister("edNrL", function(module, exports) {

$parcel$export(module.exports, "useOpsgenie", () => $faa1aa29476fa3ad$export$1a89b17f91671267);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8uw8h = parcelRequire("8uw8h");

var $2SW0B = parcelRequire("2SW0B");

var $14lOq = parcelRequire("14lOq");

var $aM2F8 = parcelRequire("aM2F8");
const $faa1aa29476fa3ad$var$icon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.OpsgenieIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true
});
const $faa1aa29476fa3ad$export$1a89b17f91671267 = (fallbackUrl)=>(0, $14lOq.useAppGlobalShortcutLinkItem)($faa1aa29476fa3ad$var$icon, (0, $aM2F8.messages).label, fallbackUrl, {
        apsKey: (0, $2SW0B.Products).OPSGENIE
    });

});
parcelRegister("aM2F8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $eab697a5e83cf0e9$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $eab697a5e83cf0e9$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.opsgenie',
        defaultMessage: 'Opsgenie',
        description: 'The link label for Opsgenie'
    }
});

});


parcelRegister("eIH5E", function(module, exports) {

$parcel$export(module.exports, "useProjects", () => $36289de2a9f80ff4$export$39d4f31fc4866d70);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $21HMC = parcelRequire("21HMC");

var $8uw8h = parcelRequire("8uw8h");

var $2SW0B = parcelRequire("2SW0B");

var $14lOq = parcelRequire("14lOq");

var $fUTID = parcelRequire("fUTID");
const $36289de2a9f80ff4$var$icon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.ProjectsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true
});
function $36289de2a9f80ff4$export$2e2bcd8739ae039(fallbackUrl) {
    const label = (0, $21HMC.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $fUTID.messages).labelGalaxia : (0, $fUTID.messages).label;
    return {
        icon: $36289de2a9f80ff4$var$icon,
        // The i18n unfriendly default value of `label` is why this function is deprecated.
        // `labelElem` will be used instead of `label` in most places, but `label` will still be used in some places like customization modal.
        // For an i18n friendly default value of `label`, please use `useProjects` instead.
        label: 'Projects',
        labelElem: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...label
        }),
        fallbackUrl: fallbackUrl,
        apsKey: (0, $2SW0B.Products).PROJECTS
    };
}
const $36289de2a9f80ff4$export$39d4f31fc4866d70 = (fallbackUrl)=>{
    const label = (0, $21HMC.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $fUTID.messages).labelGalaxia : (0, $fUTID.messages).label;
    return (0, $14lOq.useAppGlobalShortcutLinkItem)($36289de2a9f80ff4$var$icon, label, fallbackUrl, {
        apsKey: (0, $2SW0B.Products).PROJECTS
    });
};

});
parcelRegister("fUTID", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b9762b597ffad0d4$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b9762b597ffad0d4$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-shortcuts.apps.projects',
        defaultMessage: 'Projects',
        description: 'The link label for Projects'
    },
    labelGalaxia: {
        id: 'navigation.global-shortcuts.apps.projects-galaxia',
        defaultMessage: 'Spaces',
        description: 'The link label for Projects'
    }
});

});










parcelRegister("2r2Qz", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardEmbedRouteEntry", () => $29322ff28d980cef$export$b5558b683e9c45a4);

var $igNUx = parcelRequire("igNUx");

var $eJe5A = parcelRequire("eJe5A");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $27Owl = parcelRequire("27Owl");

var $fbgOh = parcelRequire("fbgOh");

var $alzbz = parcelRequire("alzbz");

var $9NmsS = parcelRequire("9NmsS");

var $b8mPY = parcelRequire("b8mPY");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $cxQGT = parcelRequire("cxQGT");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $fzFPm = parcelRequire("fzFPm");

var $kbZYB = parcelRequire("kbZYB");

var $6dwgv = parcelRequire("6dwgv");

var $hkqTc = parcelRequire("hkqTc");
const $29322ff28d980cef$export$b5558b683e9c45a4 = (0, $6xToB.createEntry)((0, $fzFPm.classicSoftwareBoardEmbedRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board-embed',
        component: (0, $kbZYB.RapidBoardSpaPage),
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $5L7qx.resourceWithCondition2)((0, $alzbz.shouldLoadUIFBoardResources), (0, $c0h8V.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $alzbz.shouldLoadUIFBoardResources)() && !(0, $igNUx.isFedRamp)(), (0, $b8mPY.nextBestTaskFeatureResource)),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)(),
            (0, $cxQGT.themePreferenceResource),
            (0, $hHbzj.forgeBoardModuleResource)
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kbZYB.UIFBoardSpa)
        ],
        meta: {
            capability: (0, $hkqTc.classicBoardCapability)
        }
    }));

});
parcelRegister("b8mPY", function(module, exports) {

$parcel$export(module.exports, "nextBestTaskFeatureResource", () => $c69fbe24c063fd77$export$5d472f7d515300ca);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");

const $c69fbe24c063fd77$export$5d472f7d515300ca = (0, $l1VxS.createResource)({
    type: (0, $040daa3db0be3503$export$6f0555de4f60e84e),
    getKey: ()=>(0, $040daa3db0be3503$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            return await (0, $jGzN3.performGetRequest)(`/rest/api/3/mypreferences?key=${(0, $040daa3db0be3503$export$b94951a11282ae6a)}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
				 * If the user has never set the preference, we auto enroll them and set the initial value to true.
				 */ return {
                hasUserOptedIn: true
            };
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: (0, $040daa3db0be3503$export$7f111648ca05f056),
                    packageName: (0, $040daa3db0be3503$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return false,
		 * this ensures if user is in the experiment cohort but later opted out, they don't revert to having the feature enabled */ return {
            hasUserOptedIn: false
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $040daa3db0be3503$export$6f0555de4f60e84e = 'RESOURCE_TYPE_NEXT_BEST_TASK_FEATURE';
const $040daa3db0be3503$export$7e7d7930e22ba39f = 'nbt-opt-in-resource-key'; // value is global for user
const $040daa3db0be3503$export$b94951a11282ae6a = 'next-best-task-feature';
const $040daa3db0be3503$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesNextBestTask';
const $040daa3db0be3503$export$7f111648ca05f056 = 'useResource.fetchNextBestTaskOptInPreference';


parcelRegister("fzFPm", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardEmbedRoute", () => $134627f3bb568c9c$export$122afcef7dfd252);
const $134627f3bb568c9c$export$122afcef7dfd252 = {
    name: 'rapidboard-board-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed'
};

});

parcelRegister("hkqTc", function(module, exports) {

$parcel$export(module.exports, "classicBoardCapability", () => $7376c20eb73bee8d$export$a6d9a03b76d2193b);

const $7376c20eb73bee8d$export$a6d9a03b76d2193b = !false ? (0, $652f5f63189f3e2a$export$664edf77d4c76110) : (0, $652f5f63189f3e2a$export$fc5f182fc9019b1c);

});


parcelRegister("cyLCh", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardRouteEntry", () => $56e241b7ecaa2cf7$export$f2cd114cf8ab53aa);

var $igNUx = parcelRequire("igNUx");

var $kHlOR = parcelRequire("kHlOR");

var $1wb5r = parcelRequire("1wb5r");

var $7jTnu = parcelRequire("7jTnu");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $27Owl = parcelRequire("27Owl");

var $fbgOh = parcelRequire("fbgOh");

var $alzbz = parcelRequire("alzbz");

var $9NmsS = parcelRequire("9NmsS");

var $b8mPY = parcelRequire("b8mPY");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $k7VE6 = parcelRequire("k7VE6");

var $kbZYB = parcelRequire("kbZYB");

var $c5gcy = parcelRequire("c5gcy");

var $itkIt = parcelRequire("itkIt");

var $zNGiI = parcelRequire("zNGiI");

var $hS1gr = parcelRequire("hS1gr");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $8vmEP = parcelRequire("8vmEP");

var $epTsa = parcelRequire("epTsa");

var $hkqTc = parcelRequire("hkqTc");

var $fBkBS = parcelRequire("fBkBS");
/**
 * Ordinarily it would be inadvisable to evaluate something like this in
 * a static route, as this could lead to inconsistent behaviour between
 * the server and the browser.
 *
 * In this case it is necessary and safe because:
 * 1) There are two versions of the board that share the same route
 *    and we can only tell them apart at runtime. When the old version
 *    is eventually removed, this should be cleaned up.
 * 2) No requests for board data are made on the server, so even
 *    if the value is incorrect on the server it won't be utilised
 * */ const $56e241b7ecaa2cf7$var$getLayout = ()=>{
    let viewMode = 'DEFAULT';
    if ((0, $itkIt.isLocalStorageAvailable)()) viewMode = (0, $c5gcy.getViewModeFromLocalStorage)();
    return (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.pageLoadIssuePreloadLayoutBuilder)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ], viewMode));
};
const $56e241b7ecaa2cf7$var$isColoredLabelsMilestone2ExperimentEnabled = ()=>{
    return (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) !== false;
};
const $56e241b7ecaa2cf7$export$f2cd114cf8ab53aa = (0, $6xToB.createEntry)((0, $k7VE6.classicSoftwareBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        component: (0, $kbZYB.RapidBoardSpaPage),
        skeleton: (0, $zNGiI.ClassicBoardSkeleton),
        layout: $56e241b7ecaa2cf7$var$getLayout(),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.ForPaintClassicSoftwareProjectSidebar),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-fix-nav4-sidebar-client-api-call')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $5L7qx.resourceWithCondition2)((0, $alzbz.shouldLoadUIFBoardResources), (0, $c0h8V.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $alzbz.shouldLoadUIFBoardResources)() && !(0, $igNUx.isFedRamp)(), (0, $b8mPY.nextBestTaskFeatureResource)),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)(),
            (0, $hHbzj.forgeBoardModuleResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource)),
            (0, $5L7qx.resourceWithCondition2)($56e241b7ecaa2cf7$var$isColoredLabelsMilestone2ExperimentEnabled, (0, $8vmEP.coloredLabelsResource))
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kbZYB.UIFBoardSpa)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-board-early-entry'
            ]
        },
        meta: {
            capability: (0, $hkqTc.classicBoardCapability)
        },
        earlyAssets: (0, $1wb5r.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-classic-board-entries/src/classicSoftwareBoardRouteEntry.tsx',
                whichExportToUse: 'classicSoftwareBoardRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-software-board.json'
        },
        entryPoint: ()=>(0, $fBkBS.classicBoardPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("k7VE6", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardRoute", () => $a86c112e63e1973c$export$131d51ca54849e97);
const $a86c112e63e1973c$export$131d51ca54849e97 = {
    name: 'rapidboard-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("zNGiI", function(module, exports) {

$parcel$export(module.exports, "ClassicBoardSkeleton", () => $1dcd14fbb9b67592$export$631611c5fdf027d5);
/* ClassicBoardSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $4mqUi = parcelRequire("4mqUi");
const $1dcd14fbb9b67592$var$customCssStyles = null;
const $1dcd14fbb9b67592$export$631611c5fdf027d5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4mqUi))),
        className: (0, $hcewu.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("4mqUi", function(module, exports) {
module.exports = new URL("classic-board-app-skeleton.tpl.bf1c26f5.svg", import.meta.url).toString();

});


parcelRegister("8vmEP", function(module, exports) {

$parcel$export(module.exports, "coloredLabelsResource", () => $67b5fd6cf53e55fe$export$f0ad3e030e2810cd);

var $9FYIg = parcelRequire("9FYIg");

var $gYnSx = parcelRequire("gYnSx");

var $gfurL = parcelRequire("gfurL");

const $67b5fd6cf53e55fe$export$f0ad3e030e2810cd = (0, $9FYIg.createRelayResource)({
    type: (0, $c4cbf185d67d5f99$export$23ce323aea9a6251),
    getQuery: ({ query: query, match: match }, { tenantContext: tenantContext })=>{
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        let boardAriId = null;
        try {
            boardAriId = boardId ? `ari:cloud:jira-software:${tenantContext.cloudId}:board/${boardId}` : '';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'getBoardAriId',
                    packageName: 'jiraSoftwareBoard',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            parameters: (0, $gfurL.default),
            variables: {
                boardId: boardAriId || ''
            },
            options: {
                fetchPolicy: 'network-only'
            }
        };
    },
    isBrowserOnly: true
});

});
parcelRegister("gfurL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8636672e9306f825$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9fd26d8ea440c3315d30fdcc98a3091>>
 * @relayHash f1a1e7f4f3391d9025cda1e1a967eac2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6cc55bf7b732ac37d40318c8c8e923f5e4fb306144d2d271a0d55c3f0909b71
const $8636672e9306f825$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "colorKey"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "coloredLabelsUpdater_getLabelsInBoardQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelConnection",
                            "kind": "LinkedField",
                            "name": "labelsInBoard",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraLabelEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraLabel",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraColor",
                                                    "kind": "LinkedField",
                                                    "name": "color",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "coloredLabelsUpdater_getLabelsInBoardQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelConnection",
                            "kind": "LinkedField",
                            "name": "labelsInBoard",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraLabelEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraLabel",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraColor",
                                                    "kind": "LinkedField",
                                                    "name": "color",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a6cc55bf7b732ac37d40318c8c8e923f5e4fb306144d2d271a0d55c3f0909b71",
            "metadata": {},
            "name": "coloredLabelsUpdater_getLabelsInBoardQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8636672e9306f825$var$node.hash = "ae1319e8a8b2f29c250f16107724930b";
var $8636672e9306f825$export$2e2bcd8739ae039 = $8636672e9306f825$var$node;

});

const $c4cbf185d67d5f99$export$23ce323aea9a6251 = 'COLORED_LABELS_RELAY';


parcelRegister("fBkBS", function(module, exports) {

$parcel$export(module.exports, "classicBoardPageEntryPoint", () => $ecc79b0d6607dd5f$export$b7ca8af848cd7993);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $iJnZt = parcelRequire("iJnZt");

var $5DQfo = parcelRequire("5DQfo");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $9n5I0 = parcelRequire("9n5I0");
const $ecc79b0d6607dd5f$export$b7ca8af848cd7993 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iJnZt.nextGenBoardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("iJnZt", function(module, exports) {

$parcel$export(module.exports, "nextGenBoardEntryPoint", () => $644517290b990a06$export$bb3c6f02a735f848);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $644517290b990a06$export$bb3c6f02a735f848 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("4kmpi")), {
        moduleId: "5be6be56",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});



parcelRegister("gUidc", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBacklogRouteEntry", () => $caeffc5f86b73edb$export$9bcdab5e8a786007);

var $h8pnX = parcelRequire("h8pnX");

var $kHlOR = parcelRequire("kHlOR");


var $1wb5r = parcelRequire("1wb5r");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $27Owl = parcelRequire("27Owl");

var $alzbz = parcelRequire("alzbz");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $abOZT = parcelRequire("abOZT");

var $kbZYB = parcelRequire("kbZYB");

var $9ZjGp = parcelRequire("9ZjGp");

var $hS1gr = parcelRequire("hS1gr");

var $8BTxL = parcelRequire("8BTxL");
const $caeffc5f86b73edb$export$9bcdab5e8a786007 = (0, $6xToB.createEntry)((0, $abOZT.classicSoftwareBoardSettingsInsightsRapidboardBacklogRoute), ()=>({
        group: 'classic-software',
        ufoName: 'rapidboard-backlog-insights',
        component: (0, $8BTxL.InsightsSettingsRedirect),
        skeleton: (0, $9ZjGp.NextGenBacklogSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $h8pnX.issueHierarchyPageResource),
            (0, $27Owl.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kbZYB.LazyRapidBoard),
            (0, $kbZYB.LazyRapidBoardApps),
            (0, $kbZYB.LazyRapidBoardDataApiResource),
            (0, $kbZYB.LazyRapidBoardConfigApiResource),
            (0, $kbZYB.LazyRapidBoardWrmBundleResource),
            (0, $kbZYB.LazyRapidBoardResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $652f5f63189f3e2a$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $1wb5r.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("h8pnX", function(module, exports) {

$parcel$export(module.exports, "issueHierarchyPageResource", () => $dce7ef1b233e0f6f$export$98d50a2e19509817);

var $9FYIg = parcelRequire("9FYIg");

var $1BmVN = parcelRequire("1BmVN");
const $dce7ef1b233e0f6f$export$98d50a2e19509817 = (0, $9FYIg.createRelayResource)({
    type: 'RESOURCE1',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $1BmVN.default),
            variables: {
                cloudId: tenantContext.cloudId
            }
        })
});

});
parcelRegister("1BmVN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1259760b38732005$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b65744edce0440b8e642853273ae8687>>
 * @relayHash 294a4ab1c7b53980fe6b85dec03375af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fd7778c6c621e8e81603008d8868eba33cdeb7957066255208f8e57178401dec
const $1259760b38732005$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "level"
    }, v4 = [
        {
            "concreteType": "JiraIssueTypeHierarchyLevel",
            "kind": "LinkedField",
            "name": "hierarchyLevel",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ]
        },
        {
            "concreteType": "JiraIssueTypeConnection",
            "kind": "LinkedField",
            "name": "cmpIssueTypes",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                    "kind": "LinkedField",
                                    "name": "hierarchy",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "small"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v5 = {
        "concreteType": "JiraHierarchyConfigError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "code"
            },
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v6 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyConfigurationQuery",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueHierarchyConfigData",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": v4 /*: any*/ 
            },
            {
                "kind": "ScalarField",
                "name": "success"
            },
            v5 /*: any*/ 
        ]
    }, v7 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyLimits",
        "kind": "LinkedField",
        "name": "issueHierarchyLimits",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "maxLevels"
            },
            {
                "kind": "ScalarField",
                "name": "nameLength"
            }
        ]
    }, v8 = {
        "args": v1 /*: any*/ ,
        "kind": "ScalarField",
        "name": "lockedIssueTypeIds"
    }, v9 = {
        "concreteType": "JiraIssueHierarchyConfigData",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": true,
        "selections": v4 /*: any*/ 
    }, v10 = {
        "concreteType": "JiraLongRunningTaskProgress",
        "kind": "LinkedField",
        "name": "taskProgress",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "kind": "ScalarField",
                "name": "progress"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainIssueHierarchyQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "saveButton_AdminPagesIssueTypesIssueHierarchyDirectory"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "saveDialog_AdminPagesIssueTypesIssueHierarchyDirectory"
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainIssueHierarchyQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fd7778c6c621e8e81603008d8868eba33cdeb7957066255208f8e57178401dec",
            "metadata": {},
            "name": "mainIssueHierarchyQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1259760b38732005$var$node.hash = "b729898c1b9905024698f9734f816a8e";
var $1259760b38732005$export$2e2bcd8739ae039 = $1259760b38732005$var$node;

});


parcelRegister("b4jBr", function(module, exports) {

$parcel$export(module.exports, "horizontalNavJiraResource", () => $0bd7097ca3e78874$export$faeb8c89315e20da);

var $9FYIg = parcelRequire("9FYIg");

var $byeh6 = parcelRequire("byeh6");

var $3osLr = parcelRequire("3osLr");

var $bBtQo = parcelRequire("bBtQo");

var $6zXPf = parcelRequire("6zXPf");

var $7Bvm5 = parcelRequire("7Bvm5");

var $5L7qx = parcelRequire("5L7qx");

var $hBje1 = parcelRequire("hBje1");
const $0bd7097ca3e78874$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
    const boardId = match.params.boardId;
    let { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    projectId = projectId ?? '';
    const projectIdOrKey = projectId || projectKey;
    const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
    const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
    const projectAri = projectId ? (0, $3osLr.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    }).toString() : '';
    let containerNavigationInput;
    if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
        scopeId: boardAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    else containerNavigationInput = boardAri || projectAri ? {
        scopeId: boardAri || projectAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: (0, $byeh6.default),
        variables: {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey,
            withProject: Boolean(projectIdOrKey),
            boardId: boardAri,
            withBoard: Boolean(boardAri),
            containerNavigationInput: containerNavigationInput,
            isTMPBoardRoute: isTMPBoardRoute,
            first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE)
        }
    };
};
const $0bd7097ca3e78874$var$horizontalNavJiraResourceActual = (0, $hBje1.withGiraAggAnonSsrFix)((0, $9FYIg.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_JIRA_QUERY',
    getQuery: $0bd7097ca3e78874$export$71eec30d9db46a56
}));
const $0bd7097ca3e78874$export$faeb8c89315e20da = (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)(), $0bd7097ca3e78874$var$horizontalNavJiraResourceActual);

});
parcelRegister("byeh6", function(module, exports) {

$parcel$export(module.exports, "default", () => $82bde2de23c60ccc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<99e99bfa51bc1cdc4829ab1d6d27a5f1>>
 * @relayHash cba6ce20d219b60b230ae7abbc8dfbfd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 67688bd785c6b8a973ee02d9f893c0f256281de1c688dcdfbe72361625e99501

var $7KZsS = parcelRequire("7KZsS");

var $7ze1k = parcelRequire("7ze1k");

var $5OxM8 = parcelRequire("5OxM8");

var $gpGBt = parcelRequire("gpGBt");

var $811y8 = parcelRequire("811y8");

var $37Ewn = parcelRequire("37Ewn");
const $82bde2de23c60ccc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTMPBoardRoute"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withBoard"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withProject"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "boardType"
    }, v22 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JiraHorizontalNavigationContent"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "JiraHorizontalNavigationContentOld"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraisfetchaccesslevelforsplitsharebuttonenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "containerNavigationInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraContainerNavigationResult"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "first",
                                                    "variableName": "first"
                                                }
                                            ],
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDefault"
                                                                },
                                                                v10 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                },
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRemove"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canSetAsDefault"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v12 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraNavigationItem",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v15 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeUrl"
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v15 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v18 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "withBoard",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "withProject",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "idOrKey",
                                    "variableName": "projectIdOrKey"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canEditProjectConfig",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                },
                                v9 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                                                    "kind": "LinkedField",
                                                    "name": "teamsConnected",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "created"
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraisfetchaccesslevelforsplitsharebuttonenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "accessLevel"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isTMPBoardRoute",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "mostRecentlyViewedBoard",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLiveTemplate"
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "67688bd785c6b8a973ee02d9f893c0f256281de1c688dcdfbe72361625e99501",
            "metadata": {},
            "name": "HorizontalNavJiraInnerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $7KZsS.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": (0, $811y8.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider": (0, $7ze1k.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": (0, $gpGBt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraisfetchaccesslevelforsplitsharebuttonenabledrelayprovider": (0, $5OxM8.default)
            }
        }
    };
}();
$82bde2de23c60ccc$var$node.hash = "1202c52be78d2663e71063591f5f6fb5";
(0, $37Ewn.PreloadableQueryRegistry).set($82bde2de23c60ccc$var$node.params.id, $82bde2de23c60ccc$var$node);
var $82bde2de23c60ccc$export$2e2bcd8739ae039 = $82bde2de23c60ccc$var$node;

});


parcelRegister("abOZT", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBacklogRoute", () => $16779a343a56a3a6$export$e43f33a0c1ae830c);
const $16779a343a56a3a6$export$e43f33a0c1ae830c = {
    name: 'rapidboard-backlog',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog',
    query: [
        'config=insightsConfig'
    ]
};

});

parcelRegister("8BTxL", function(module, exports) {

$parcel$export(module.exports, "InsightsSettingsRedirect", () => $b26a9d577c1c9bb4$export$f7bc2c5799e41684);

var $70SHW = parcelRequire("70SHW");

var $95O7y = parcelRequire("95O7y");
const $b26a9d577c1c9bb4$export$f7bc2c5799e41684 = ()=>{
    const { setSelectedConfigTab: setSelectedConfigTab } = (0, $70SHW.useSelectedConfigTab)();
    const [, setConfigParam] = (0, $95O7y.useQueryParam)('config');
    setSelectedConfigTab('filter');
    setConfigParam('filter');
    return null;
};

});
parcelRegister("70SHW", function(module, exports) {

$parcel$export(module.exports, "useSelectedConfigTab", () => $490a4f1d12f4798a$export$9b386f1a3e61b385);

var $dnU6V = parcelRequire("dnU6V");

var $7jTnu = parcelRequire("7jTnu");
const $490a4f1d12f4798a$export$9b386f1a3e61b385 = ()=>{
    const storageProvider = (0, $dnU6V.createLocalStorageProvider)('', false);
    const SELECTED_CONFIG_TAB_KEY = 'selectedConfigTab';
    const getSelectedConfigTab = ()=>{
        if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) return storageProvider.get(SELECTED_CONFIG_TAB_KEY) || '';
        return localStorage.getItem(SELECTED_CONFIG_TAB_KEY) || '';
    };
    const setSelectedConfigTab = (newConfigTab)=>{
        if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) storageProvider.set(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
        else localStorage.setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
    };
    return {
        getSelectedConfigTab: getSelectedConfigTab,
        setSelectedConfigTab: setSelectedConfigTab
    };
};

});



parcelRegister("6p8i9", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBoardRouteEntry", () => $262090c926929379$export$d4cb7b5fe9faae5e);

var $h8pnX = parcelRequire("h8pnX");

var $kHlOR = parcelRequire("kHlOR");


var $1wb5r = parcelRequire("1wb5r");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $27Owl = parcelRequire("27Owl");

var $alzbz = parcelRequire("alzbz");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $cfP4L = parcelRequire("cfP4L");

var $kbZYB = parcelRequire("kbZYB");

var $zNGiI = parcelRequire("zNGiI");

var $hS1gr = parcelRequire("hS1gr");

var $8BTxL = parcelRequire("8BTxL");
const $262090c926929379$export$d4cb7b5fe9faae5e = (0, $6xToB.createEntry)((0, $cfP4L.classicSoftwareBoardSettingsInsightsRapidboardBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'rapidboard-board-insights',
        component: (0, $8BTxL.InsightsSettingsRedirect),
        skeleton: (0, $zNGiI.ClassicBoardSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $h8pnX.issueHierarchyPageResource),
            (0, $27Owl.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kbZYB.LazyRapidBoard),
            (0, $kbZYB.LazyRapidBoardApps),
            (0, $kbZYB.LazyRapidBoardDataApiResource),
            (0, $kbZYB.LazyRapidBoardConfigApiResource),
            (0, $kbZYB.LazyRapidBoardWrmBundleResource),
            (0, $kbZYB.LazyRapidBoardResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $652f5f63189f3e2a$export$fc5f182fc9019b1c)
        },
        earlyAssets: (0, $1wb5r.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("cfP4L", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBoardRoute", () => $9044012524759fbc$export$8c2f936709b987ac);
const $9044012524759fbc$export$8c2f936709b987ac = {
    name: 'rapidboard-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId',
    query: [
        'config=insightsConfig'
    ]
};

});


parcelRegister("4RXNm", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsRouteEntry", () => $166a16e46d70e618$export$4e7891e9bba3f679);

var $igNUx = parcelRequire("igNUx");

var $6xToB = parcelRequire("6xToB");

var $zNGiI = parcelRequire("zNGiI");

var $7Oedg = parcelRequire("7Oedg");

var $ioHIu = parcelRequire("ioHIu");

var $dZRaT = parcelRequire("dZRaT");

var $9NmsS = parcelRequire("9NmsS");

var $alzbz = parcelRequire("alzbz");

var $27Owl = parcelRequire("27Owl");

var $bTfc4 = parcelRequire("bTfc4");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $fbgOh = parcelRequire("fbgOh");

var $5L7qx = parcelRequire("5L7qx");

var $c0h8V = parcelRequire("c0h8V");

var $b8mPY = parcelRequire("b8mPY");


var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $a4jDB = parcelRequire("a4jDB");
const $166a16e46d70e618$export$4e7891e9bba3f679 = (0, $6xToB.createEntry)((0, $7Oedg.classicSoftwareBoardSettingsRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        skeleton: (0, $zNGiI.ClassicBoardSkeleton),
        entryPoint: ()=>(0, $a4jDB.boardSettingsPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.ForPaintClassicSoftwareProjectSidebar),
            sidebarId: (0, $5RW99.SIDEBAR_ID).BOARD_SETTINGS
        },
        layout: (0, $ioHIu.genericProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $5L7qx.resourceWithCondition2)((0, $alzbz.shouldLoadUIFBoardResources), (0, $c0h8V.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $alzbz.shouldLoadUIFBoardResources)() && !(0, $igNUx.isFedRamp)(), (0, $b8mPY.nextBestTaskFeatureResource)),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)(),
            (0, $hHbzj.forgeBoardModuleResource)
        ],
        meta: {
            // Inline this statement instead of creating a (circular) dependency by importing
            // { classicBoardCapability } from '@atlassian/jira-router-routes-software-classic-board-entries/src/common/constants.tsx';
            capability: !false ? (0, $652f5f63189f3e2a$export$664edf77d4c76110) : (0, $652f5f63189f3e2a$export$fc5f182fc9019b1c)
        }
    }));

});
parcelRegister("7Oedg", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsRoute", () => $7a77c8b2ca1d391d$export$c055a8844d0d2f5e);
const $7a77c8b2ca1d391d$export$c055a8844d0d2f5e = {
    name: 'rapidboard-board-settings',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/settings/:config',
    query: [
        'from-backlog?'
    ]
};

});

parcelRegister("a4jDB", function(module, exports) {

$parcel$export(module.exports, "boardSettingsPageEntryPoint", () => $3c13d43de97673c8$export$e92abb48a4e0c94d);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $3kyC0 = parcelRequire("3kyC0");

var $5n4TZ = parcelRequire("5n4TZ");
const $3c13d43de97673c8$export$e92abb48a4e0c94d = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $5n4TZ.classicBoardSettingsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $3kyC0.nav4SidebarSettingsBoardEntryPoint)
    }
});

});
parcelRegister("3kyC0", function(module, exports) {

$parcel$export(module.exports, "nav4SidebarSettingsBoardEntryPoint", () => $5566f1bf3e63509d$export$f4cb88eb97cbdc30);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $5566f1bf3e63509d$export$f4cb88eb97cbdc30 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("1Ds5S")), {
        moduleId: "98fd14bc",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps () {
        return {};
    }
});

});
parcelRegister("1Ds5S", function(module, exports) {

let $130f39ccf533c743$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $130f39ccf533c743$var$load("7B9oS").then(()=>parcelRequire('7TH4E'));

});


parcelRegister("5n4TZ", function(module, exports) {

$parcel$export(module.exports, "classicBoardSettingsEntryPoint", () => $f00ba1a8670b9f3b$export$fd11e3f2f113ef67);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $f00ba1a8670b9f3b$export$fd11e3f2f113ef67 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("2xkNk")).then(({ BoardSettingsSwitcher: BoardSettingsSwitcher })=>BoardSettingsSwitcher), {
        moduleId: "59af2752",
        moduleName: "BoardSettingsSwitcher",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("2xkNk", function(module, exports) {

let $1d8ecb3546afe84e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1d8ecb3546afe84e$var$load("1VRB2"),
    $1d8ecb3546afe84e$var$load("bABhq"),
    $1d8ecb3546afe84e$var$load("gSE8Y")
]).then(()=>parcelRequire('cO2Fz'));

});




parcelRegister("94WeZ", function(module, exports) {

$parcel$export(module.exports, "cmpVelocityRouteEntry", () => $27f17dfe76c3b690$export$93315233fc25c1b4);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8FCAy = parcelRequire("8FCAy");

var $8JxCQ = parcelRequire("8JxCQ");

var $8iZ3C = parcelRequire("8iZ3C");

var $awzH2 = parcelRequire("awzH2");
const $27f17dfe76c3b690$export$93315233fc25c1b4 = (0, $6xToB.createEntry)((0, $8JxCQ.cmpVelocityRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.velocity-report-cmp',
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $awzH2.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>(0, $8iZ3C.velocityReportPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("8JxCQ", function(module, exports) {

$parcel$export(module.exports, "cmpVelocityRoute", () => $79d60745a93d6fbc$export$1dfb0bd517ec7a8b);
const $79d60745a93d6fbc$export$1dfb0bd517ec7a8b = {
    name: 'software-reports-velocity-cmp',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/velocity'
};

});

parcelRegister("8iZ3C", function(module, exports) {

$parcel$export(module.exports, "velocityReportPageEntrypoint", () => $bc6ce3c629e61c0b$export$571ee01f62e186c8);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $5C8tx = parcelRequire("5C8tx");
const $bc6ce3c629e61c0b$export$571ee01f62e186c8 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $5C8tx.velocityReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("5C8tx", function(module, exports) {

$parcel$export(module.exports, "velocityReportEntrypoint", () => $258417ee791ad89b$export$6f6bc731b8a9d27);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $258417ee791ad89b$export$6f6bc731b8a9d27 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("iFidf")), {
        moduleId: "3ce1c0b2",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iFidf", function(module, exports) {

let $d96a2effdfa814c3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $d96a2effdfa814c3$var$load("1VRB2"),
    $d96a2effdfa814c3$var$load("bABhq"),
    $d96a2effdfa814c3$var$load("94EhQ")
]).then(()=>parcelRequire('b1t6C'));

});



parcelRegister("awzH2", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $bfe7e156cd647afe$export$8cb713295e6b7204);
$parcel$export(module.exports, "getTMPReportsCommonResource", () => $bfe7e156cd647afe$export$f234446c23dc22a);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $bfe7e156cd647afe$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $bfe7e156cd647afe$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});
parcelRegister("ho3Tv", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJSWReportsResource", () => $cc95b3bd57d16e20$export$5910307042ab3f6f);

var $2at4v = parcelRequire("2at4v");

var $l1VxS = parcelRequire("l1VxS");

var $9kIEH = parcelRequire("9kIEH");
const $cc95b3bd57d16e20$export$5910307042ab3f6f = (0, $l1VxS.createResource)({
    type: 'JIRA_SOFTWARE_REPORTS',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $2at4v.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $2at4v.getBoardId)(match, query);
        if (boardId == null) return null;
        const response = await (0, $9kIEH.fetchJSWReports)(boardId);
        return response?.reports;
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("9kIEH", function(module, exports) {

$parcel$export(module.exports, "fetchJSWReports", () => $0b71b3b31d605b16$export$a93a577d6971da2c);

var $jGzN3 = parcelRequire("jGzN3");
const $0b71b3b31d605b16$export$a93a577d6971da2c = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $jGzN3.performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
};

});


parcelRegister("hlh4g", function(module, exports) {

$parcel$export(module.exports, "devOpsReportPreconditionResource", () => $a69e62c33f4a6228$export$96cb0eae1b3413f4);
$parcel$export(module.exports, "useDevOpsReportPreconditionResource", () => $a69e62c33f4a6228$export$e9adc6103e9ed514);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $a69e62c33f4a6228$export$96cb0eae1b3413f4 = (0, $l1VxS.createResource)({
    type: (0, $271f8eaa42077abf$export$14c5ce449424c281),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("dkmKW")),
    maxAge: 60000
});
const $a69e62c33f4a6228$export$e9adc6103e9ed514 = ()=>(0, $eJrcF.useResource)($a69e62c33f4a6228$export$96cb0eae1b3413f4);

});
const $271f8eaa42077abf$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $271f8eaa42077abf$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $271f8eaa42077abf$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';

parcelRegister("dkmKW", function(module, exports) {

let $9b3ecb874f4d89a4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9b3ecb874f4d89a4$var$load("5tE5x").then(()=>parcelRequire('19vLN'));

});




parcelRegister("lO0b1", function(module, exports) {

$parcel$export(module.exports, "commsStatusPageManageRouteEntry", () => $907edeedf4d0c302$export$910fe84bbbdaf423);

var $83Rpv = parcelRequire("83Rpv");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $cCZMV = parcelRequire("cCZMV");
const $907edeedf4d0c302$export$910fe84bbbdaf423 = (0, $6xToB.createEntry)((0, $83Rpv.commsStatusPageManageRoute), ()=>({
        group: 'eoc',
        component: (0, $cCZMV.StatusPageManage),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).STATUS_PAGE_MANAGE,
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cCZMV.LazyStatusPageManage)
        ]
    }));

});
parcelRegister("83Rpv", function(module, exports) {

$parcel$export(module.exports, "commsStatusPageManageRoute", () => $f4b5df1b0435aec3$export$af3a71b2eac6f6ca);
const $f4b5df1b0435aec3$export$af3a71b2eac6f6ca = {
    name: 'communications-status-page-manage',
    path: '/jira/ops/status-page-manage',
    exact: true
};

});

parcelRegister("cCZMV", function(module, exports) {

$parcel$export(module.exports, "LazyStatusPageManage", () => $6df73ad680d64b08$export$f75ff9ec214ffed8);
$parcel$export(module.exports, "StatusPageManage", () => $6df73ad680d64b08$export$86c4ec7d84a207b7);
// eslint-disable-next-line jira/filename-case

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $6df73ad680d64b08$export$f75ff9ec214ffed8 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("cLLD4")).then((exportedMembers)=>exportedMembers.StatusPageManage), {
    moduleId: "./src/packages/eoc/status-page-manage/src/index.tsx"
});
const $6df73ad680d64b08$export$86c4ec7d84a207b7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6df73ad680d64b08$export$f75ff9ec214ffed8,
        pageId: "async-jira-eoc-status-page-manage",
        shouldShowSpinner: false
    });

});
parcelRegister("cLLD4", function(module, exports) {

let $94bed1fd8d014db0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $94bed1fd8d014db0$var$load("3uzNf").then(()=>parcelRequire('gMPAS'));

});



parcelRegister("81S4s", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholderGroupsRouteEntry", () => $f85b738690fadb0a$export$f0dd910016653be3);

var $6xToB = parcelRequire("6xToB");

var $lrHlh = parcelRequire("lrHlh");

var $7jTnu = parcelRequire("7jTnu");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $9NmsS = parcelRequire("9NmsS");

var $hLwPy = parcelRequire("hLwPy");
const $f85b738690fadb0a$export$f0dd910016653be3 = (0, $6xToB.createEntry)((0, $lrHlh.communicationsStakeholderGroupsRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).COMMUNICATIONS,
            sidebar: (0, $1f2LE.default)
        },
        entryPoint: ()=>{
            return (0, $7jTnu.fg)('communications_stakeholder_management_platform') ? (0, $hLwPy.stakeholderGroupsPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ]
    }));

});
parcelRegister("lrHlh", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholderGroupsRoute", () => $63809c299c37f3a3$export$87043fcbf23f0119);
const $63809c299c37f3a3$export$87043fcbf23f0119 = {
    name: 'communications-stakeholder-groups',
    path: '/jira/communications/stakeholder-groups'
};

});

parcelRegister("hLwPy", function(module, exports) {

$parcel$export(module.exports, "stakeholderGroupsPageEntryPoint", () => $4d63f3b57632a9ba$export$838bd3c623ceac0);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $4RIkD = parcelRequire("4RIkD");

var $bZXJd = parcelRequire("bZXJd");
const $4d63f3b57632a9ba$export$838bd3c623ceac0 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $bZXJd.communicationsStakeholderGroupsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).COMMUNICATIONS,
    horizontalNavigation: (0, $4RIkD.communicationsHorizontalNavEntrypoint)
});

});
parcelRegister("4RIkD", function(module, exports) {

$parcel$export(module.exports, "communicationsHorizontalNavEntrypoint", () => $3aacff5720a5fdfd$export$6862ea61ceda83f3);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $3aacff5720a5fdfd$export$6862ea61ceda83f3 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("kXS2x")).then((module)=>module.HorizontalCommunicationsNav), {
        moduleId: "a456392a",
        moduleName: "HorizontalCommunicationsNav",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kXS2x", function(module, exports) {

let $f4333c8ebcbdf14e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f4333c8ebcbdf14e$var$load("8CDnp").then(()=>parcelRequire('iofEW'));

});


parcelRegister("bZXJd", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholderGroupsEntrypoint", () => $2fb7d9e63b82e621$export$df18143715531ee1);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $2fb7d9e63b82e621$export$df18143715531ee1 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("cYVae")).then((module)=>module.StakeholderGroupsPage), {
        moduleId: "90ba51b1",
        moduleName: "StakeholderGroupsPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cYVae", function(module, exports) {

let $97376e36b69a9e41$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $97376e36b69a9e41$var$load("5Qcdl").then(()=>parcelRequire('fxoyS'));

});




parcelRegister("cGZ5m", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholdersRouteEntry", () => $beb1dd341221ad4f$export$c12bfa7616ac8400);

var $6xToB = parcelRequire("6xToB");

var $kizvV = parcelRequire("kizvV");

var $7jTnu = parcelRequire("7jTnu");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $9NmsS = parcelRequire("9NmsS");

var $ecyHK = parcelRequire("ecyHK");
const $beb1dd341221ad4f$export$c12bfa7616ac8400 = (0, $6xToB.createEntry)((0, $kizvV.communicationsStakeholdersRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).COMMUNICATIONS,
            sidebar: (0, $1f2LE.default)
        },
        entryPoint: ()=>{
            return (0, $7jTnu.fg)('communications_stakeholder_management_platform') ? (0, $ecyHK.stakeholdersPageEntrypoint) : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ]
    }));

});
parcelRegister("kizvV", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholdersRoute", () => $ef1758a83ffe54af$export$9933513623f14d7f);
const $ef1758a83ffe54af$export$9933513623f14d7f = {
    name: 'communications-stakeholders',
    path: '/jira/communications/stakeholders'
};

});

parcelRegister("ecyHK", function(module, exports) {

$parcel$export(module.exports, "stakeholdersPageEntrypoint", () => $0cd85c16b7b4715f$export$24a5b3c3e5dd381e);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $4RIkD = parcelRequire("4RIkD");

var $iZq2f = parcelRequire("iZq2f");
const $0cd85c16b7b4715f$export$24a5b3c3e5dd381e = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iZq2f.communicationsStakeholdersEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).COMMUNICATIONS,
    horizontalNavigation: (0, $4RIkD.communicationsHorizontalNavEntrypoint)
});

});
parcelRegister("iZq2f", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholdersEntrypoint", () => $24e9dba2481b9faf$export$2be0008a269b55af);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $inQqC = parcelRequire("inQqC");

const $24e9dba2481b9faf$export$2be0008a269b55af = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(0, $inQqC.clientSideOnly)((parcelRequire("cetxZ")).then((module)=>module.StakeholdersPage)), {
        moduleId: "52ac92a7",
        moduleName: "StakeholdersPage",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        // const filter = (() => {
        // 	try {
        // 		return context.query.filter ? JSON.parse(context.query.filter) : {};
        // 	} catch {
        // 		return {};
        // 	}
        // })();
        return {
            queries: {
            }
        };
    }
});

});
parcelRegister("inQqC", function(module, exports) {

$parcel$export(module.exports, "clientSideOnly", () => $82b73592f648e5cd$export$7fda87e5e6d5a8d1);
const $82b73592f648e5cd$export$7fda87e5e6d5a8d1 = (x)=>x;

});

parcelRegister("cetxZ", function(module, exports) {

let $8e7db64b1f568ba4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8e7db64b1f568ba4$var$load("k2IQ4").then(()=>parcelRequire('krf2j'));

});




parcelRegister("2BDh0", function(module, exports) {

$parcel$export(module.exports, "compassProductSettingsRouteEntry", () => $8ed7619b22cea546$export$703b5090da478c9c);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $k5Vpa = parcelRequire("k5Vpa");

var $9NmsS = parcelRequire("9NmsS");

var $6iLpr = parcelRequire("6iLpr");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $8ed7619b22cea546$var$LazyCompassProductSettingsPage = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fpfkx"))), {
    moduleId: "./src/packages/spa-apps/compass-product-settings/src/index.tsx"
});
const $8ed7619b22cea546$var$CompassProductSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8ed7619b22cea546$var$LazyCompassProductSettingsPage,
        pageId: "async-compass-product-settings",
        shouldShowSpinner: true
    });
const $8ed7619b22cea546$export$703b5090da478c9c = (0, $6xToB.createEntry)((0, $6iLpr.compassProductSettingsRoute), ()=>({
        group: 'global-settings',
        component: $8ed7619b22cea546$var$CompassProductSettingsComponent,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $k5Vpa.compassProductSettingsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $8ed7619b22cea546$var$LazyCompassProductSettingsPage
        ]
    }));

});
parcelRegister("k5Vpa", function(module, exports) {

$parcel$export(module.exports, "compassProductSettingsResource", () => $1b5e4a9067cd1ba4$export$d18ff068d6c25455);
$parcel$export(module.exports, "useCompassProductSettingsResource", () => $1b5e4a9067cd1ba4$export$6cbcbd11d26ae36f);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $1b5e4a9067cd1ba4$export$d18ff068d6c25455 = (0, $l1VxS.createResource)({
    type: (0, $1eb4dd82f40cf71c$export$6f0555de4f60e84e),
    getKey: ()=>'state',
    getData: async ()=>{
        try {
            const isCompassEnabledForNewProjects = await (0, $jGzN3.performGetRequest)(`/rest/api/3/application-properties?key=${(0, $1eb4dd82f40cf71c$export$5685d70c20140008)}`).then(({ value: value })=>value.toLowerCase().trim() === 'true');
            return {
                isCompassEnabledForNewProjects: isCompassEnabledForNewProjects
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error?.statusCode === 404) return {
                isCompassEnabledForNewProjects: true
            };
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'compassProductSettingsResource',
                    packageName: 'jiraRouterResourcesCompassProductSettings',
                    teamName: 'compass-lodestone'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
});
const $1b5e4a9067cd1ba4$export$6cbcbd11d26ae36f = ()=>(0, $eJrcF.useResource)($1b5e4a9067cd1ba4$export$d18ff068d6c25455);

});
const $1eb4dd82f40cf71c$export$6f0555de4f60e84e = 'RESOURCE_TYPE_COMPASS_PRODUCT_SETTINGS';
const $1eb4dd82f40cf71c$export$5685d70c20140008 = 'jira.admin.compass.is-enabled-for-new-project';


parcelRegister("6iLpr", function(module, exports) {

$parcel$export(module.exports, "compassProductSettingsRoute", () => $ab7fd4c32714bac4$export$48d633ce1d0d2a0e);
const $ab7fd4c32714bac4$export$48d633ce1d0d2a0e = {
    name: 'compass-product-settings',
    path: '/jira/settings/products/compass',
    exact: true
};

});

parcelRegister("fpfkx", function(module, exports) {

let $b37515114588882c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b37515114588882c$var$load("5sK8Z").then(()=>parcelRequire('4x7m1'));

});


parcelRegister("c7HRO", function(module, exports) {

$parcel$export(module.exports, "connectGeneralInvalidRouteEntry", () => $cd4f636d38699abe$export$d8088cb4e7cc7efd);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $5OsiD = parcelRequire("5OsiD");

var $d8BiX = parcelRequire("d8BiX");

var $36JSs = parcelRequire("36JSs");
const $cd4f636d38699abe$export$d8088cb4e7cc7efd = (0, $6xToB.createEntry)((0, $5OsiD.connectGeneralInvalidRoute), ()=>({
        group: 'connect',
        layout: (0, $6dwgv.createLayout)(),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $aDtWM.genericConnectSidebars)
        },
        component: (0, $36JSs.default),
        resources: (0, $d8BiX.getGeneralConnectRouteResources)(),
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $36JSs.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect'
    }));

});
parcelRegister("5OsiD", function(module, exports) {

$parcel$export(module.exports, "connectGeneralInvalidRoute", () => $5b26b56fa24b53a8$export$486ffffd0a2797a5);

var $loXHl = parcelRequire("loXHl");
const $5b26b56fa24b53a8$export$486ffffd0a2797a5 = {
    name: 'connect-general-invalid',
    path: '/plugins/servlet/ac/:addonKey//:moduleKey',
    query: (0, $loXHl.CONNECT_GENERAL_QUERY_PARAMS)
};

});
parcelRegister("loXHl", function(module, exports) {

$parcel$export(module.exports, "CONNECT_GENERAL_QUERY_PARAMS", () => $d36006477dc3f049$export$2fdb05fdbf78d595);
// must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
const $d36006477dc3f049$export$2fdb05fdbf78d595 = [
    'mobile?!=true',
    'includeWebResources?!=true',
    'classifier?!=json',
    'project.key?',
    'project.id?'
];

});


parcelRegister("d8BiX", function(module, exports) {

$parcel$export(module.exports, "getGeneralConnectRouteResources", () => $1175208f01dda0de$export$2c86c2f79b80cf77);
$parcel$export(module.exports, "getProjectConnectRouteDefaultResources", () => $1175208f01dda0de$export$4c06110e7d14ab3c);

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $kRv8K = parcelRequire("kRv8K");

var $7FIkD = parcelRequire("7FIkD");

var $b41XS = parcelRequire("b41XS");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");
const $1175208f01dda0de$export$2c86c2f79b80cf77 = ()=>[
        ...(0, $kRv8K.getBusinessProjectResources)(),
        ...(0, $9NmsS.getNavigationResources)(),
        (0, $enHI7.navigationSidebarGlobalResource),
        ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $bTfc4.incidentExperimentTraitResource),
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
        (0, $7FIkD.connectGeneralResources),
        (0, $4VIcO.getConsolidationStateResource)()
    ];
const $1175208f01dda0de$export$4c06110e7d14ab3c = ()=>[
        ...(0, $kRv8K.getBusinessProjectResources)(),
        ...(0, $9NmsS.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $bTfc4.incidentExperimentTraitResource),
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
        (0, $b41XS.connectProjectResources)
    ];

});
parcelRegister("7FIkD", function(module, exports) {

$parcel$export(module.exports, "connectGeneralResources", () => $ac1e673dd620ded4$export$f34ab0d904621847);
$parcel$export(module.exports, "useConnectGeneralResource", () => $ac1e673dd620ded4$export$53479840ec6d4024);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $ac1e673dd620ded4$export$f34ab0d904621847 = (0, $l1VxS.createResource)({
    type: (0, $ac8db659dabbf119$export$d5eed449bb62d4c1),
    getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
        // spa-router/src/common/types.js:
        /** TODO we are supporting `undefined` here because we are currently using both
		 * this version of the `Match` type, and react-routers version (which allows for `undefined`)
		 * To fix this we should move `matchPath` to our own util so we can apply our own types, then
		 * decide if we want to support undefined types.
		 */ if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("135qK"))
});
const $ac1e673dd620ded4$export$53479840ec6d4024 = ()=>(0, $eJrcF.useResource)($ac1e673dd620ded4$export$f34ab0d904621847);

});
const $ac8db659dabbf119$export$d5eed449bb62d4c1 = 'CONNECT_GENERAL';

parcelRegister("135qK", function(module, exports) {

let $0c3a48a1956a0080$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0c3a48a1956a0080$var$load("hV7z2").then(()=>parcelRequire('cu1Rj'));

});


parcelRegister("b41XS", function(module, exports) {

$parcel$export(module.exports, "connectProjectResources", () => $bbf230b3d3c324b1$export$7d2d082a4b91a6c7);
// eslint-disable-next-line jira/import-whitelist

var $fnx9L = parcelRequire("fnx9L");

var $9pJMP = parcelRequire("9pJMP");

var $l1VxS = parcelRequire("l1VxS");


const $bbf230b3d3c324b1$export$7d2d082a4b91a6c7 = (0, $l1VxS.createResource)({
    type: (0, $f71270049d49ef4d$export$da32d27651782c3),
    getKey: ({ query: query })=>{
        const { addonKey: addonKey, moduleKey: moduleKey } = (0, $fnx9L.transformUrlToAddonAndModuleKeys)(query);
        if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    depends: [
        (0, $9pJMP.staticProjectSidebarNavigationResource).type
    ],
    getDataLoader: ()=>(parcelRequire("4sd5b"))
});

});
parcelRegister("fnx9L", function(module, exports) {

$parcel$export(module.exports, "transformResponse", () => $c9fc058b98a5f055$export$3361e9be8093ddcc);
$parcel$export(module.exports, "extractContext", () => $c9fc058b98a5f055$export$efdbd45f3e77a161);
$parcel$export(module.exports, "transformQueryParams", () => $c9fc058b98a5f055$export$9e3c3f47fc3ab3d0);
$parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", () => $c9fc058b98a5f055$export$752ef5ab3d7ab15f);

var $eSnSE = parcelRequire("eSnSE");

var $aEyM4 = parcelRequire("aEyM4");

var $6zXPf = parcelRequire("6zXPf");

var $imXGf = parcelRequire("imXGf");
const $c9fc058b98a5f055$export$3361e9be8093ddcc = (response)=>{
    try {
        const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
        let structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
        structuredContext = {
            ...structuredContext,
            jira: {
                ...structuredContext.jira,
                horizontalNavigation: (0, $6zXPf.getWillShowNav4)()
            }
        };
        const context = {
            productContext: productContext,
            structuredContext: structuredContext,
            productCtx: productContext
        };
        return {
            ...response,
            ...context,
            isFullPage: response.general === '1',
            user: {
                timeZone: response.timeZone,
                uid: response.uid || undefined,
                ukey: response.ukey || undefined,
                fullName: response.fullName || undefined
            },
            targets: {
                env: {
                    resize: 'both'
                }
            },
            history: {
                state: ''
            },
            autoresize: true,
            ns: response.uniqueKey,
            containerId: `embedded-${response.uniqueKey}`,
            contextPath: response.cp,
            width: response.w || response.width,
            height: response.h || response.height
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const location = 'connect-iframe.transformer';
        (0, $eSnSE.default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
        return {
            autoresize: true,
            productCtx: undefined,
            structuredContext: undefined,
            isFullPage: true,
            history: {
                state: ''
            },
            targets: {
                env: {
                    resize: 'both'
                }
            }
        };
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c9fc058b98a5f055$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
    const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
    return newValue !== null ? {
        [newName]: newValue
    } : null;
};
const $c9fc058b98a5f055$export$1f8eea5a5a32169f = (contextData)=>{
    const scope = contextData && contextData.scope || null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const project = contextData && contextData.project || null;
    const projectId = $c9fc058b98a5f055$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $c9fc058b98a5f055$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $c9fc058b98a5f055$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
    const boardId = $c9fc058b98a5f055$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $c9fc058b98a5f055$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
    const project = projectSidebarNavInfo && (0, $imXGf.extractData)(projectSidebarNavInfo) || null;
    const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, $aEyM4.extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
    const projectId = $c9fc058b98a5f055$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $c9fc058b98a5f055$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $c9fc058b98a5f055$var$checkValueAndMapToNewName(board, 'type', 'board.type');
    const boardId = $c9fc058b98a5f055$var$checkValueAndMapToNewName(board, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $c9fc058b98a5f055$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
    const context = $c9fc058b98a5f055$export$1f8eea5a5a32169f(contextData);
    return {
        ...query,
        ...context
    };
};
const $c9fc058b98a5f055$export$752ef5ab3d7ab15f = (query)=>{
    const { selectedItem: selectedItem } = query;
    let addonKey = '';
    let moduleKey = '';
    if (selectedItem) {
        const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
        [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
    }
    return {
        addonKey: addonKey,
        moduleKey: moduleKey
    };
};

});
parcelRegister("aEyM4", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $f0de9883562e19b9$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractUserBoard", () => $f0de9883562e19b9$export$67db9e2d1b6ed865);
const $f0de9883562e19b9$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
    if (jiraSoftwareNavData.boardInfo == null) return null;
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: true
    };
};
const $f0de9883562e19b9$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: false
    };
};

});


const $f71270049d49ef4d$export$da32d27651782c3 = 'CONNECT_PROJECT';

parcelRegister("4sd5b", function(module, exports) {

let $33e3ece3e5a5a211$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $33e3ece3e5a5a211$var$load("7bJSr").then(()=>parcelRequire('e68Yk'));

});



parcelRegister("36JSs", function(module, exports) {

$parcel$export(module.exports, "LazyGeneralConnect", () => $d6d3c040ac0d88f6$export$c33275abe6c1e577);
$parcel$export(module.exports, "default", () => $d6d3c040ac0d88f6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $d6d3c040ac0d88f6$export$c33275abe6c1e577 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("b87VE"))), {
    moduleId: "./src/packages/spa-apps/jira-connect/general-pages/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d6d3c040ac0d88f6$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d6d3c040ac0d88f6$export$c33275abe6c1e577,
        pageId: "connect",
        shouldShowSpinner: true
    });

});
parcelRegister("b87VE", function(module, exports) {

let $81a6978f53c1f4ca$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $81a6978f53c1f4ca$var$load("15Er6").then(()=>parcelRequire('dx7Jv'));

});



parcelRegister("2wLap", function(module, exports) {

$parcel$export(module.exports, "connectGeneralRouteEntry", () => $646d2275bae5d744$export$46273ee39bcd958b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $dO60j = parcelRequire("dO60j");

var $d8BiX = parcelRequire("d8BiX");

var $36JSs = parcelRequire("36JSs");
const $646d2275bae5d744$export$46273ee39bcd958b = (0, $6xToB.createEntry)((0, $dO60j.connectGeneralRoute), ()=>({
        group: 'connect',
        layout: (0, $6dwgv.createLayout)(),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $aDtWM.genericConnectSidebars)
        },
        component: (0, $36JSs.default),
        resources: (0, $d8BiX.getGeneralConnectRouteResources)(),
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $36JSs.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect'
    }));

});
parcelRegister("dO60j", function(module, exports) {

$parcel$export(module.exports, "connectGeneralRoute", () => $78c09d42272238f6$export$1fda4850b6314ff0);

var $loXHl = parcelRequire("loXHl");
const $78c09d42272238f6$export$1fda4850b6314ff0 = {
    name: 'connect-general',
    path: '/plugins/servlet/ac/:addonKey/:moduleKey',
    query: (0, $loXHl.CONNECT_GENERAL_QUERY_PARAMS)
};

});


parcelRegister("3arhy", function(module, exports) {

$parcel$export(module.exports, "connectGeneralServiceDeskProjectRouteEntry", () => $503cb0345c3432e1$export$487a360459ad1bea);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $1PvPk = parcelRequire("1PvPk");

var $6Jf2i = parcelRequire("6Jf2i");

var $d8BiX = parcelRequire("d8BiX");

var $36JSs = parcelRequire("36JSs");
const $503cb0345c3432e1$export$487a360459ad1bea = (0, $6xToB.createEntry)((0, $6Jf2i.connectGeneralServiceDeskProjectRoute), ()=>({
        group: 'connect',
        layout: (0, $6dwgv.createLayout)(),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $aDtWM.genericConnectSidebars)
        },
        component: (0, $36JSs.default),
        resources: [
            ...(0, $d8BiX.getGeneralConnectRouteResources)(),
            ...(0, $1PvPk.getServiceDeskNavigationSingleResources)()
        ],
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $36JSs.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect'
    }));

});
parcelRegister("6Jf2i", function(module, exports) {

$parcel$export(module.exports, "connectGeneralServiceDeskProjectRoute", () => $e6b03c0e2f966895$export$e8a58aee75961b55);
const $e6b03c0e2f966895$export$e8a58aee75961b55 = {
    name: 'connect-general-service-desk-project',
    path: '/plugins/servlet/ac/:addonKey/:moduleKey',
    query: [
        'mobile?!=true',
        'includeWebResources?!=true',
        'classifier?!=json',
        'project.key?',
        'project.id?',
        'project.key',
        'servicedesk.serviceDeskId'
    ]
};

});


parcelRegister("9IZNs", function(module, exports) {

$parcel$export(module.exports, "connectProjectRouteEntry", () => $26e8e25e2b17ced9$export$96bdc57a01f2ee48);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $fbmQ3 = parcelRequire("fbmQ3");

var $d8BiX = parcelRequire("d8BiX");

var $dzuEl = parcelRequire("dzuEl");
const $26e8e25e2b17ced9$export$96bdc57a01f2ee48 = (0, $6xToB.createEntry)((0, $fbmQ3.connectProjectRoute), ()=>({
        group: 'connect',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        layout: (0, $ioHIu.genericProjectLayout),
        ufoName: 'jira-connect',
        // Match resources that are fetched for legacyConnectProjectRouteEntry
        // See src/packages/router-routes/legacy/connect-project/entries/src/index.tsx
        resources: [
            ...(0, $d8BiX.getProjectConnectRouteDefaultResources)(),
            ...(0, $1PvPk.getServiceDeskSharedNavigationSingleResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $dzuEl.connectProjectsPageEntrypoint)
    }));

});
parcelRegister("fbmQ3", function(module, exports) {

$parcel$export(module.exports, "connectProjectRoute", () => $f44764dedad36013$export$27e7531864dfb704);

var $3BMxd = parcelRequire("3BMxd");
const $f44764dedad36013$export$27e7531864dfb704 = {
    name: 'connect-project',
    path: '/projects/:projectKey',
    query: (0, $3BMxd.CONNECT_PROJECT_QUERY_PARAMS)
};

});
parcelRegister("3BMxd", function(module, exports) {

$parcel$export(module.exports, "CONNECT_PROJECT_QUERY_PARAMS", () => $42010840a4b13bde$export$9bb839aee83bf4d8);
const $42010840a4b13bde$export$9bb839aee83bf4d8 = [
    'selectedItem=(^com.atlassian.plugins.atlassian-connect-plugin.*)'
];

});


parcelRegister("dzuEl", function(module, exports) {

$parcel$export(module.exports, "connectProjectsPageEntrypoint", () => $d72dd44cf681dc01$export$d7105af2aa9527d0);
$parcel$export(module.exports, "connectProjectsWithoutHorizontalNavPageEntrypoint", () => $d72dd44cf681dc01$export$8df81c5e9c00a7b4);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $fBNI3 = parcelRequire("fBNI3");

var $9n5I0 = parcelRequire("9n5I0");
const $d72dd44cf681dc01$export$d7105af2aa9527d0 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $fBNI3.connectProjectsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $d72dd44cf681dc01$export$8df81c5e9c00a7b4 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $fBNI3.connectProjectsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("fBNI3", function(module, exports) {

$parcel$export(module.exports, "connectProjectsEntrypoint", () => $66846dd8f8b71f04$export$4ff832a017f5175c);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $66846dd8f8b71f04$export$4ff832a017f5175c = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("apxVX")), {
        moduleId: "2203c501",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                query: context.query
            }
        })
});

});
parcelRegister("apxVX", function(module, exports) {

let $79468fbecbf2f57a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $79468fbecbf2f57a$var$load("7tiYW").then(()=>parcelRequire('aqLmU'));

});




parcelRegister("1YKQh", function(module, exports) {

$parcel$export(module.exports, "createProjectRouteEntry", () => $7843f5d9f7ac1782$export$28887e2da22c839a);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $UpqWg = parcelRequire("UpqWg");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $7843f5d9f7ac1782$var$LazyCreateProject = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("fU3B9")), {
    moduleId: "./src/packages/spa-apps/create-project/src/index.tsx"
});
const $7843f5d9f7ac1782$var$CreateProject = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $7843f5d9f7ac1782$var$LazyCreateProject,
        pageId: "spa-apps/create-project",
        shouldShowSpinner: true
    });
const $7843f5d9f7ac1782$export$28887e2da22c839a = (0, $6xToB.createEntry)((0, $UpqWg.createProjectRoute), ()=>({
        group: 'components',
        component: $7843f5d9f7ac1782$var$CreateProject,
        layout: (0, $ioHIu.genericProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $7843f5d9f7ac1782$var$LazyCreateProject
        ]
    }));

});
parcelRegister("UpqWg", function(module, exports) {

$parcel$export(module.exports, "createProjectRoute", () => $7eb1157664ce6def$export$5ce9108542315ac8);
const $7eb1157664ce6def$export$5ce9108542315ac8 = {
    name: 'create-project',
    path: '/jira/create-project',
    exact: true
};

});

parcelRegister("fU3B9", function(module, exports) {

let $b93ee07d94261b62$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b93ee07d94261b62$var$load("k1DyH").then(()=>parcelRequire('7v6Xe'));

});


parcelRegister("5vEtc", function(module, exports) {

$parcel$export(module.exports, "customerServiceEscalationsRouteEntry", () => $215db75612ea2329$export$36a7c374f4474cc1);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lLLpQ = parcelRequire("lLLpQ");

var $hc29r = parcelRequire("hc29r");

var $lgUu3 = parcelRequire("lgUu3");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $215db75612ea2329$var$LazyServicedeskCustomerServiceEscalations = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bzp3t"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-service-escalations/src/index.tsx"
});
const $215db75612ea2329$var$ServicedeskCustomerServiceEscalations = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $215db75612ea2329$var$LazyServicedeskCustomerServiceEscalations,
        pageId: "spa-apps/servicedesk/customer-service-escalations",
        shouldShowSpinner: true
    });
const $215db75612ea2329$export$36a7c374f4474cc1 = (0, $6xToB.createEntry)((0, $lgUu3.customerServiceEscalationsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $lLLpQ.componentFilterResource),
            (0, $hc29r.priorityFilterResource)
        ],
        component: $215db75612ea2329$var$ServicedeskCustomerServiceEscalations,
        perfMetricKey: 'jsm-customer-service-escalations-component-load',
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $215db75612ea2329$var$LazyServicedeskCustomerServiceEscalations
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS),
                teamName: 'boysenberry'
            }
        }
    }));

});
parcelRegister("lLLpQ", function(module, exports) {

$parcel$export(module.exports, "componentFilterResource", () => $2c16adcd153f09f9$export$306e389909032632);
$parcel$export(module.exports, "useComponentFilterResource", () => $2c16adcd153f09f9$export$e13868d6ab2288af);

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $2c16adcd153f09f9$var$getDataLoader = ()=>(parcelRequire("5bBES"));
const $2c16adcd153f09f9$export$306e389909032632 = (0, $l1VxS.createResource)({
    type: 'ESCALATIONS_COMPONENT_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
    getDataLoader: $2c16adcd153f09f9$var$getDataLoader
});
const $2c16adcd153f09f9$export$e13868d6ab2288af = ()=>(0, $eJrcF.useResource)($2c16adcd153f09f9$export$306e389909032632);

});
parcelRegister("5bBES", function(module, exports) {

let $3c6b30fdffe8a618$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3c6b30fdffe8a618$var$load("byTA4").then(()=>parcelRequire('xl1rO'));

});


parcelRegister("hc29r", function(module, exports) {

$parcel$export(module.exports, "priorityFilterResource", () => $32c1ef26ebfd7598$export$ca03c5f9fc44703e);
$parcel$export(module.exports, "usePriorityFilterResource", () => $32c1ef26ebfd7598$export$3654f46b6bb12558);

var $7jTnu = parcelRequire("7jTnu");

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $32c1ef26ebfd7598$var$getDataLoader = ()=>(parcelRequire("g3cmx"));
const $32c1ef26ebfd7598$export$ca03c5f9fc44703e = (0, $l1VxS.createResource)({
    type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
    getDataLoader: $32c1ef26ebfd7598$var$getDataLoader
});
const $32c1ef26ebfd7598$export$3654f46b6bb12558 = ()=>(0, $eJrcF.useResource)((0, $7jTnu.fg)('jcs_master_flag') ? $32c1ef26ebfd7598$export$ca03c5f9fc44703e : (0, $l1VxS.createResource)({
        type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
        getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
        getDataLoader: $32c1ef26ebfd7598$var$getDataLoader
    }));

});
parcelRegister("g3cmx", function(module, exports) {

let $baf6841d444d7f3d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $baf6841d444d7f3d$var$load("dokrm").then(()=>parcelRequire('3WEzz'));

});


parcelRegister("lgUu3", function(module, exports) {

$parcel$export(module.exports, "customerServiceEscalationsRoute", () => $35e9854d0e3aa940$export$51e84b36f828d9ff);
const $35e9854d0e3aa940$export$51e84b36f828d9ff = {
    name: 'servicedesk-customer-service-escalations',
    path: '/jira/servicedesk/projects/:projectKey/escalations',
    exact: true
};

});

parcelRegister("bzp3t", function(module, exports) {

let $86c665fb3867a8cd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $86c665fb3867a8cd$var$load("1VRB2"),
    $86c665fb3867a8cd$var$load("bABhq"),
    $86c665fb3867a8cd$var$load("7vqGd"),
    $86c665fb3867a8cd$var$load("1Y4bq"),
    $86c665fb3867a8cd$var$load("ebsji")
]).then(()=>parcelRequire('fnE71'));

});


parcelRegister("l1629", function(module, exports) {

$parcel$export(module.exports, "customerServiceProductsRouteEntry", () => $0617445854def8ae$export$8e015e39dbc90d0b);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $s2Zja = parcelRequire("s2Zja");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $ig3cl = parcelRequire("ig3cl");

var $fIWRC = parcelRequire("fIWRC");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $0617445854def8ae$var$LazyServicedeskCustomerServiceProducts = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2vE8l"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-service-products/src/index.tsx"
});
const $0617445854def8ae$var$ServicedeskCustomerServiceProducts = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $0617445854def8ae$var$LazyServicedeskCustomerServiceProducts,
        pageId: "spa-apps/servicedesk/customer-service-products",
        shouldShowSpinner: true
    });
const $0617445854def8ae$export$8e015e39dbc90d0b = (0, $6xToB.createEntry)((0, $fIWRC.customerServiceProductsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $s2Zja.AsyncDirectoryNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ig3cl.customerServiceProductsQueryResource)
        ],
        component: $0617445854def8ae$var$ServicedeskCustomerServiceProducts,
        perfMetricKey: 'jsm-customer-service-products-component-load',
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $0617445854def8ae$var$LazyServicedeskCustomerServiceProducts
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS),
                teamName: 'boysenberry'
            }
        }
    }));

});
parcelRegister("s2Zja", function(module, exports) {

$parcel$export(module.exports, "AsyncDirectoryNav", () => $a5663a17c7d615f7$export$a237f415539577a5);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");


const $a5663a17c7d615f7$var$LazyDirectoryNav = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("9w5Fp")).then(({ DirectoryHorizontalNav: DirectoryHorizontalNav })=>DirectoryHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/directory/src/ui/index.tsx"
});
const $a5663a17c7d615f7$export$a237f415539577a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "horizontal-jsm-directory-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a5663a17c7d615f7$var$LazyDirectoryNav, null));

});
parcelRegister("9w5Fp", function(module, exports) {

let $6edb7f8d27dda693$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6edb7f8d27dda693$var$load("3XmQO").then(()=>parcelRequire('aoP5b'));

});


parcelRegister("ig3cl", function(module, exports) {

$parcel$export(module.exports, "PRODUCTS_PAGE_SIZE", () => $017f65ea37d42132$export$9e59a0b3e9d74a99);
$parcel$export(module.exports, "customerServiceProductsQueryResource", () => $017f65ea37d42132$export$f9257217f5333b1a);

var $9FYIg = parcelRequire("9FYIg");

var $b7uxO = parcelRequire("b7uxO");
const $017f65ea37d42132$export$9e59a0b3e9d74a99 = 50;
const $017f65ea37d42132$export$f9257217f5333b1a = (0, $9FYIg.createRelayResource)({
    type: 'CUSTOMER_SERVICE_PRODUCTS_QUERY',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $b7uxO.default),
            variables: {
                cloudId: tenantContext.cloudId,
                first: $017f65ea37d42132$export$9e59a0b3e9d74a99
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("b7uxO", function(module, exports) {

$parcel$export(module.exports, "default", () => $599381046c28d29c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4df781c51f5dfbc32b76735c59bb33af>>
 * @relayHash 081a2dfa9c4407c84bf8d024899e92b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bb8d4ae9602322e43ac61cf45c886f9ecad88afb1aaa237fd8615ea59abb7c16
const $599381046c28d29c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = [
        v2 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcCustomerServiceProductsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "productsPage_servicedeskCustomerServiceProducts"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcCustomerServiceProductsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "entitlementsCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "handle": "connection",
                            "key": "customerServiceProducts_productConnections",
                            "kind": "LinkedHandle",
                            "name": "productConnections"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bb8d4ae9602322e43ac61cf45c886f9ecad88afb1aaa237fd8615ea59abb7c16",
            "metadata": {},
            "name": "srcCustomerServiceProductsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$599381046c28d29c$var$node.hash = "3c49696a6cdc337af280ec80f957ea89";
var $599381046c28d29c$export$2e2bcd8739ae039 = $599381046c28d29c$var$node;

});


parcelRegister("fIWRC", function(module, exports) {

$parcel$export(module.exports, "customerServiceProductsRoute", () => $9927dc66533760f6$export$73e241aabf4c9c58);
const $9927dc66533760f6$export$73e241aabf4c9c58 = {
    name: 'servicedesk-customer-service-products',
    path: '/jira/servicedesk/projects/:projectKey/products',
    exact: true
};

});

parcelRegister("2vE8l", function(module, exports) {

let $1d3d9bbaa0df7d08$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1d3d9bbaa0df7d08$var$load("1VRB2"),
    $1d3d9bbaa0df7d08$var$load("bABhq"),
    $1d3d9bbaa0df7d08$var$load("7vqGd"),
    $1d3d9bbaa0df7d08$var$load("1Y4bq"),
    $1d3d9bbaa0df7d08$var$load("ibLow")
]).then(()=>parcelRequire('3oVAl'));

});


parcelRegister("e54wO", function(module, exports) {

$parcel$export(module.exports, "customIssueRouteEntry", () => $d90cf6b802c1c59b$export$3813414450b75758);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $2Qpxd = parcelRequire("2Qpxd");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $2ZjY0 = parcelRequire("2ZjY0");

var $7jTnu = parcelRequire("7jTnu");

var $1PvPk = parcelRequire("1PvPk");

var $iWhpv = parcelRequire("iWhpv");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $bwzwd = parcelRequire("bwzwd");

var $9U6YG = parcelRequire("9U6YG");
const $d90cf6b802c1c59b$export$3813414450b75758 = (0, $6xToB.createEntry)((0, $2Qpxd.customIssueRoute), ()=>({
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            // Keep this consistent with the one in customQueueRouteEntry.tsx, so it won't rerender the queue agent view component
            // when navigating between queues and issues.
            // Rereder could cause problem:
            // 1. Issue view will lose issue navigator component
            // 2. When navigating back to queue, the queue will lose the scroll position.
            horizontal: (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $2ZjY0.AsyncHorizontalNavQueue) : undefined
        },
        skeleton: (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $9U6YG.QueueLoadingSkeleton) : undefined,
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            ...(0, $1PvPk.getInsightResources)(),
            ...(0, $1PvPk.getIssueListSsrResource)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $iWhpv.servicedeskIsItsmProjectResource),
            ...(0, $5nfTh.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        group: 'servicedesk',
        // It is important to keep this component consistent across the two routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        component: (0, $bwzwd.CustomQueueRouteComponent),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bwzwd.LazyServicedeskQueuesAgentAndIssueView)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("2Qpxd", function(module, exports) {

$parcel$export(module.exports, "customIssueRoute", () => $7ca5d0c219b8e601$export$2c4bc3091ab58cd0);
const $7ca5d0c219b8e601$export$2c4bc3091ab58cd0 = {
    name: 'servicedesk-queues-custom-issue-detail',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("ieQb1", function(module, exports) {

$parcel$export(module.exports, "newIssueViewLockInStatusResource", () => $f809acc9341aa882$export$647de7516d081bd8);
$parcel$export(module.exports, "useNewIssueViewLockInStatus", () => $f809acc9341aa882$export$d8ba398930f2f5f);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $6XhAO = parcelRequire("6XhAO");

const $f809acc9341aa882$export$647de7516d081bd8 = (0, $l1VxS.createResource)({
    type: (0, $6XhAO.RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("8vvRf")),
    maxAge: Number.MAX_VALUE
});
const $f809acc9341aa882$export$d8ba398930f2f5f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($f809acc9341aa882$export$647de7516d081bd8);
    return {
        loading: loading,
        error: error,
        newIssueViewLockedIn: data && data.newIssueViewLockedIn
    };
};

});
parcelRegister("8vvRf", function(module, exports) {

let $6319ee4ddc3309e3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6319ee4ddc3309e3$var$load("cucJh").then(()=>parcelRequire('ieUfL'));

});


parcelRegister("2ZjY0", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalNavQueue", () => $3d69ac55b6dae45f$export$5f20c7610c638983);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $ch9En = parcelRequire("ch9En");

var $6zXPf = parcelRequire("6zXPf");

var $iX5t3 = parcelRequire("iX5t3");

var $8LnTF = parcelRequire("8LnTF");

var $2Qpxd = parcelRequire("2Qpxd");

var $hih5V = parcelRequire("hih5V");

var $2FqDG = parcelRequire("2FqDG");

var $26mRz = parcelRequire("26mRz");
const $3d69ac55b6dae45f$export$5f20c7610c638983 = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const [issueKey] = (0, $2FqDG.usePathParam)('issueKey');
    const isIssueView = route.name === (0, $2Qpxd.customIssueRoute).name || route.name === (0, $8LnTF.customPracticeQueueRoute).name && issueKey;
    const content = !isIssueView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "horizontal-nav-queue",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iX5t3.HorizontalNavSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $26mRz.LazyHorizontalNavQueue), null));
    return (0, $6zXPf.getWillShowNav4)() ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $3d69ac55b6dae45f$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $3d69ac55b6dae45f$var$styles
    }, content));
};
const $3d69ac55b6dae45f$var$containerStyles = (0, $5Wv5g.xcss)({
    position: 'relative'
});
const $3d69ac55b6dae45f$var$styles = (0, $5Wv5g.xcss)({
    position: 'absolute',
    width: '100%'
});

});
parcelRegister("8LnTF", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueRoute", () => $de61ecd99379c904$export$59d0bd42aa07faad);
const $de61ecd99379c904$export$59d0bd42aa07faad = {
    name: 'servicedesk-practice-custom-and-issue',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("26mRz", function(module, exports) {

$parcel$export(module.exports, "LazyHorizontalNavQueue", () => $672fa091873772f6$export$d5abd8e11ee6080b);

var $gzcjr = parcelRequire("gzcjr");

const $672fa091873772f6$export$d5abd8e11ee6080b = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("k46Tg")).then((HorizontalNavQueue)=>HorizontalNavQueue), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/queue/src/ui/HorizontalNavQueue.tsx"
});

});
parcelRegister("k46Tg", function(module, exports) {

let $e9b986a95c47b855$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $e9b986a95c47b855$var$load("1VRB2"),
    $e9b986a95c47b855$var$load("bABhq"),
    $e9b986a95c47b855$var$load("6mImz")
]).then(()=>parcelRequire('8VQU1'));

});



parcelRegister("bwzwd", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesAgentAndIssueView", () => $3fd45bf9eaf5b481$export$6f01bfb6fc18a06e);
$parcel$export(module.exports, "CustomQueueRouteComponent", () => $3fd45bf9eaf5b481$export$59d555419fbaa611);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $7jTnu = parcelRequire("7jTnu");

var $2dJFW = parcelRequire("2dJFW");

const $3fd45bf9eaf5b481$export$6f01bfb6fc18a06e = (0, $gzcjr.lazyForPaint)(()=>{
    return (0, $2dJFW.markAsProductBundleReady)((parcelRequire("5LZk9")));
}, {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-agent-and-issue-view/src/index.tsx"
});
const $3fd45bf9eaf5b481$export$59d555419fbaa611 = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    const issueKey = match.params && match.params.issueKey || '';
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3fd45bf9eaf5b481$export$6f01bfb6fc18a06e,
        pageId: `spa-apps/servicedesk/queues/${queueId}/${issueKey}/${oldIssueView}`,
        shouldShowSpinner: !(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag')
    });
};

});
parcelRegister("5LZk9", function(module, exports) {

let $4340e93278968b68$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $4340e93278968b68$var$load("7vqGd"),
    $4340e93278968b68$var$load("1Y4bq"),
    $4340e93278968b68$var$load("1VRB2"),
    $4340e93278968b68$var$load("bABhq"),
    $4340e93278968b68$var$load("cPwGX")
]).then(()=>parcelRequire('86K1L'));

});


parcelRegister("9U6YG", function(module, exports) {

$parcel$export(module.exports, "QueueLoadingSkeleton", () => $e75f46c99d6bd30b$export$d20068523efc567f);

var $eJOHy = parcelRequire("eJOHy");

var $lRxpy = parcelRequire("lRxpy");

var $6OSA0 = parcelRequire("6OSA0");

var $7jTnu = parcelRequire("7jTnu");

var $6zXPf = parcelRequire("6zXPf");
const $e75f46c99d6bd30b$export$d20068523efc567f = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && !(0, $7jTnu.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRxpy.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null));
};

});
parcelRegister("lRxpy", function(module, exports) {

$parcel$export(module.exports, "useStylingPatch", () => $b29a0528b0d1edc9$export$ed35078f707ec860);
$parcel$export(module.exports, "QueueNav3StylingPatchContainer", () => $b29a0528b0d1edc9$export$9cbbe53228ab978f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6zXPf = parcelRequire("6zXPf");

var $7jTnu = parcelRequire("7jTnu");

var $hih5V = parcelRequire("hih5V");

var $2FqDG = parcelRequire("2FqDG");

var $7MMy7 = parcelRequire("7MMy7");

var $8LnTF = parcelRequire("8LnTF");

var $ezY2M = parcelRequire("ezY2M");

var $iuwL5 = parcelRequire("iuwL5");

var $3z9R8 = parcelRequire("3z9R8");

var $aoMKL = parcelRequire("aoMKL");

var $2Qpxd = parcelRequire("2Qpxd");
const $b29a0528b0d1edc9$var$SEGMENT_KEY = 'queues-agent-view-top-layout-nav3';
const $b29a0528b0d1edc9$export$ed35078f707ec860 = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const [issueKey] = (0, $2FqDG.usePathParam)('issueKey');
    if (!(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag')) return {
        shouldUseStylingPatch: false,
        isNav3QueueIssueViewRoute: false
    };
    const isNav3QueueRouteOld = !(0, $6zXPf.getWillShowNav4)() && (route.name === (0, $7MMy7.customQueueRoute).name || route.name === (0, $8LnTF.customPracticeQueueRoute).name && !issueKey);
    const isNav3QueueRouteNew = !(0, $6zXPf.getWillShowNav4)() && (route.name === (0, $7MMy7.customQueueRoute).name || route.name === (0, $8LnTF.customPracticeQueueRoute).name || // Only the Nav3 Queue content and Nav3 Category Queue content are wrapped with QueueNav3StylingPatchContainer.
    // The routes where we should doing this wrapping are queue route, category queue route and issue view route
    // The reason why we are also need to wrap the Queue content on issue view route is because we want to avoid re-rendering.
    // ----------------------------------------------------------------------------------------------------------
    // Inside the QueueNav3StylingPatchContainer (below), we will avoid putting the height on issue view route (because of this scroll problem).
    // This will not trigger the re-rendering because the DOM structure isn’t changed.
    route.name === (0, $2Qpxd.customIssueRoute).name);
    // customIssueRoute is issue view route for custom queue
    // while customPracticeQueueRoute contains route for both practice queue agent view and practice queue issue view, we need to check issueKey to determine if it's issue view route
    const isNav3QueueIssueViewRoute = !(0, $6zXPf.getWillShowNav4)() && (route.name === (0, $2Qpxd.customIssueRoute).name || route.name === (0, $8LnTF.customPracticeQueueRoute).name && !!issueKey);
    const isNav3QueueRoute = (0, $7jTnu.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? isNav3QueueRouteNew : isNav3QueueRouteOld;
    const isNav3BoardRoute = !(0, $6zXPf.getWillShowNav4)() && (route.name === (0, $iuwL5.customQueueBoardRoute).name || route.name === (0, $ezY2M.customPracticeQueueBoardRoute).name);
    const isNav3CalendarRoute = !(0, $6zXPf.getWillShowNav4)() && (route.name === (0, $3z9R8.customQueueCalendarRoute).name || route.name === (0, $aoMKL.customPracticeQueueCalendarRoute).name);
    return {
        shouldUseStylingPatch: isNav3QueueRoute || isNav3BoardRoute || isNav3CalendarRoute,
        isNav3QueueIssueViewRoute: isNav3QueueIssueViewRoute
    };
};
const $b29a0528b0d1edc9$export$9cbbe53228ab978f = ({ children: children })=>{
    const { shouldUseStylingPatch: shouldUseStylingPatch, isNav3QueueIssueViewRoute: isNav3QueueIssueViewRoute } = $b29a0528b0d1edc9$export$ed35078f707ec860();
    if (shouldUseStylingPatch || !(0, $7jTnu.fg)('jsm_fix_queue_issue_view_navigate_back_state')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-vc": (0, $7jTnu.fg)('jsm_view_inside_queue_ssr_metric') ? `${$b29a0528b0d1edc9$var$SEGMENT_KEY}${false ? '-ssr' : ''}` : undefined,
        "data-ssr-placeholder": false && (0, $7jTnu.fg)('jsm_view_inside_queue_ssr_metric') ? $b29a0528b0d1edc9$var$SEGMENT_KEY : undefined,
        "data-ssr-placeholder-replace": false || !(0, $7jTnu.fg)('jsm_view_inside_queue_ssr_metric') ? undefined : $b29a0528b0d1edc9$var$SEGMENT_KEY,
        "data-testid": "horizontal-nav-queue.controllers.styling-patch.queue-nav-3-styling-patch-container",
        className: (0, $hcewu.default)([
            !isNav3QueueIssueViewRoute && "_ca0q1h05 _vchhusvi _1e0c1txw _2lx21bp4 _4t3i1osq"
        ])
    }, children);
    return children;
};
const $b29a0528b0d1edc9$var$nav3PaddingStyles = null;

});
parcelRegister("7MMy7", function(module, exports) {

$parcel$export(module.exports, "customQueueRoute", () => $8b42a61db1b1071b$export$e1fac82ca0b0d637);
const $8b42a61db1b1071b$export$e1fac82ca0b0d637 = {
    name: 'servicedesk-queues-custom-view',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("ezY2M", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueBoardRoute", () => $b21aec2e594727c2$export$47ae519519dbd803);
const $b21aec2e594727c2$export$47ae519519dbd803 = {
    name: 'servicedesk-queues-practice-custom-board',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/board/:boardId',
    exact: true
};

});

parcelRegister("iuwL5", function(module, exports) {

$parcel$export(module.exports, "customQueueBoardRoute", () => $60482c0d1d8abd43$export$5407961894c40126);
const $60482c0d1d8abd43$export$5407961894c40126 = {
    name: 'servicedesk-queues-custom-board',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/board/:boardId',
    exact: true
};

});

parcelRegister("3z9R8", function(module, exports) {

$parcel$export(module.exports, "customQueueCalendarRoute", () => $947a5826d96b9330$export$82a97d9fba2cfa9a);
const $947a5826d96b9330$export$82a97d9fba2cfa9a = {
    name: 'servicedesk-queues-custom-calendar',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/calendar/:boardId',
    exact: true
};

});

parcelRegister("aoMKL", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueCalendarRoute", () => $a639ed70e298b726$export$5a0e47b0abcf7c2f);
const $a639ed70e298b726$export$5a0e47b0abcf7c2f = {
    name: 'servicedesk-queues-practice-custom-calendar',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/calendar/:boardId',
    exact: true
};

});




parcelRegister("ft8RF", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueBoardRouteEntry", () => $1546556f2a4387de$export$7b0b0691f8b766cf);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $ezY2M = parcelRequire("ezY2M");

var $1PvPk = parcelRequire("1PvPk");

var $aQoXd = parcelRequire("aQoXd");

var $7jTnu = parcelRequire("7jTnu");

var $4VIcO = parcelRequire("4VIcO");

var $alzbz = parcelRequire("alzbz");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $hZn8E = parcelRequire("hZn8E");

var $6zXPf = parcelRequire("6zXPf");

var $2ZjY0 = parcelRequire("2ZjY0");

var $26mRz = parcelRequire("26mRz");

var $kD31z = parcelRequire("kD31z");
const $1546556f2a4387de$export$7b0b0691f8b766cf = (0, $6xToB.createEntry)((0, $ezY2M.customPracticeQueueBoardRoute), ()=>({
        group: 'servicedesk',
        component: (0, $9BJU1.default),
        entryPoint: ()=>{
            if ((0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $6zXPf.getWillShowNav4)() ? (0, $kD31z.boardPageEntryPoint) : (0, $kD31z.boardPageNav3EntryPoint);
            return undefined;
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        skeleton: (0, $kD31z.BoardSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $6zXPf.getWillShowNav4)() ? (0, $2ZjY0.AsyncHorizontalNavQueue) : undefined
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!false, (0, $c0h8V.uifBoardResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $6zXPf.getWillShowNav4)(), (0, $hZn8E.horizontalNavQueueResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $26mRz.LazyHorizontalNavQueue)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("hZn8E", function(module, exports) {

$parcel$export(module.exports, "horizontalNavQueueResource", () => $1ea991232f726ef5$export$896712202052ca56);

var $9FYIg = parcelRequire("9FYIg");

var $2KVNq = parcelRequire("2KVNq");

var $2BUDW = parcelRequire("2BUDW");

var $bBtQo = parcelRequire("bBtQo");

var $7Bvm5 = parcelRequire("7Bvm5");

var $hBje1 = parcelRequire("hBje1");
const $1ea991232f726ef5$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
    const queueId = match.params.queueId;
    let { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    projectId = projectId ?? '';
    const projectIdOrKey = projectId || projectKey;
    const queueAri = queueId ? (0, $2BUDW.JiraServicedeskQueueAri).create({
        siteId: cloudId,
        queueId: queueId || '',
        activationId: activationId
    }).toString() : '';
    const containerNavigationInput = queueAri ? {
        scopeId: queueAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: $2KVNq.default,
        variables: {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey,
            containerNavigationInput: containerNavigationInput,
            first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE)
        }
    };
};
const $1ea991232f726ef5$export$896712202052ca56 = (0, $hBje1.withGiraAggAnonSsrFix)((0, $9FYIg.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_QUEUE_QUERY',
    getQuery: $1ea991232f726ef5$export$71eec30d9db46a56
}));

});
parcelRegister("2KVNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $006e919579626eae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c8059f14a3201b31e0652bd91e511bc>>
 * @relayHash ad9b22c18ca56c0cec6bb77e087f1a60
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5a6395a2023b01b4b8728b98901f39635c74a467c84cd540ba5af518baccad2
const $006e919579626eae$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b5a6395a2023b01b4b8728b98901f39635c74a467c84cd540ba5af518baccad2",
        "metadata": {},
        "name": "HorizontalNavQueueInnerQuery",
        "operationKind": "query",
        "text": null
    }
};
var $006e919579626eae$export$2e2bcd8739ae039 = $006e919579626eae$var$node;

});


parcelRegister("kD31z", function(module, exports) {

$parcel$export(module.exports, "boardPageNav3EntryPoint", () => $c83d93be51937897$export$ae25ae5278cbd6a1);
$parcel$export(module.exports, "boardPageEntryPoint", () => $c83d93be51937897$export$552f44bed039f041);
$parcel$export(module.exports, "BoardSkeleton", () => $c83d93be51937897$export$325f821722dfa572);

var $eJOHy = parcelRequire("eJOHy");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $7jTnu = parcelRequire("7jTnu");

var $3PvPr = parcelRequire("3PvPr");

var $eIyjT = parcelRequire("eIyjT");

var $zNGiI = parcelRequire("zNGiI");

var $lRxpy = parcelRequire("lRxpy");

var $6zXPf = parcelRequire("6zXPf");
const $c83d93be51937897$export$ae25ae5278cbd6a1 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $eIyjT.boardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $c83d93be51937897$export$552f44bed039f041 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $eIyjT.boardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $3PvPr.horizontalNavQueueEntrypoint)
});
const $c83d93be51937897$export$325f821722dfa572 = ()=>(0, $6zXPf.getWillShowNav4)() && !(0, $7jTnu.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $zNGiI.ClassicBoardSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRxpy.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $zNGiI.ClassicBoardSkeleton), null));

});
parcelRegister("3PvPr", function(module, exports) {

$parcel$export(module.exports, "horizontalNavQueueEntrypoint", () => $add8ea01289a3169$export$df9ea493099a3cc4);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $2KVNq = parcelRequire("2KVNq");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $2BUDW = parcelRequire("2BUDW");

var $bBtQo = parcelRequire("bBtQo");

var $7Bvm5 = parcelRequire("7Bvm5");

const $add8ea01289a3169$export$df9ea493099a3cc4 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("aKGHg")), {
        moduleId: "664171c5",
        moduleName: "HorizontalNavQueueInner",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: ({ context: { match: match, query: query }, tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        const queueId = match.params.queueId;
        let { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        projectKey = projectKey ?? '';
        projectId = projectId ?? '';
        const projectIdOrKey = projectId || projectKey;
        const queueAri = queueId ? (0, $2BUDW.JiraServicedeskQueueAri).create({
            siteId: cloudId,
            queueId: queueId || '',
            activationId: activationId
        }).toString() : '';
        const containerNavigationInput = queueAri ? {
            scopeId: queueAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                horizontalNavQueueQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $2KVNq.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        containerNavigationInput: containerNavigationInput,
                        first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            }
        };
    }
});

});
parcelRegister("aKGHg", function(module, exports) {

let $7d3f51f51966726c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7d3f51f51966726c$var$load("1VRB2"),
    $7d3f51f51966726c$var$load("bABhq"),
    $7d3f51f51966726c$var$load("2aUwz")
]).then(()=>parcelRequire('25hyE'));

});


parcelRegister("eIyjT", function(module, exports) {

$parcel$export(module.exports, "boardEntryPoint", () => $f7d7b76d75ec55cb$export$937ca5a4cdc1a12e);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $f7d7b76d75ec55cb$export$937ca5a4cdc1a12e = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("f4P7j")), {
        moduleId: "286ebff8",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("f4P7j", function(module, exports) {

let $af9ee184b75cf8a1$var$load = (parcelRequire("gLHA4"))(4);




module.exports = Promise.all([
    (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $af9ee184b75cf8a1$var$load("esKGV")
        ]);
    }, function() {
        return Promise.all([
            $af9ee184b75cf8a1$var$load("7uqQP")
        ]);
    }),
    $af9ee184b75cf8a1$var$load("k4gbU"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("eDlXl"), 4)),
    $af9ee184b75cf8a1$var$load("1VRB2"),
    $af9ee184b75cf8a1$var$load("bABhq"),
    $af9ee184b75cf8a1$var$load("2qG46")
]).then(()=>parcelRequire('aMLZ1'));

});




parcelRegister("bwD6U", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueCalendarRouteEntry", () => $77aa9aca48804f59$export$8e8d88d3af02e6f7);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $aoMKL = parcelRequire("aoMKL");

var $1PvPk = parcelRequire("1PvPk");

var $aQoXd = parcelRequire("aQoXd");

var $4VIcO = parcelRequire("4VIcO");

var $c0h8V = parcelRequire("c0h8V");

var $5FSZM = parcelRequire("5FSZM");

var $hZn8E = parcelRequire("hZn8E");

var $7jTnu = parcelRequire("7jTnu");

var $5L7qx = parcelRequire("5L7qx");

var $6zXPf = parcelRequire("6zXPf");

var $2ZjY0 = parcelRequire("2ZjY0");

var $26mRz = parcelRequire("26mRz");

var $lgaNk = parcelRequire("lgaNk");
const $77aa9aca48804f59$export$8e8d88d3af02e6f7 = (0, $6xToB.createEntry)((0, $aoMKL.customPracticeQueueCalendarRoute), ()=>({
        group: 'servicedesk',
        component: (0, $9BJU1.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $6zXPf.getWillShowNav4)() ? (0, $2ZjY0.AsyncHorizontalNavQueue) : undefined
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $26mRz.LazyHorizontalNavQueue)
        ],
        entryPoint: ()=>{
            if ((0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $6zXPf.getWillShowNav4)() ? (0, $lgaNk.calendarPageEntryPoint) : (0, $lgaNk.calendarPageNav3EntryPoint);
            return undefined;
        },
        skeleton: (0, $lgaNk.CalendarSkeleton),
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5FSZM.getCalendarFilterFieldsResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $6zXPf.getWillShowNav4)(), (0, $hZn8E.horizontalNavQueueResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>!false, (0, $c0h8V.uifBoardResource))
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("lgaNk", function(module, exports) {

$parcel$export(module.exports, "calendarPageNav3EntryPoint", () => $659b52ad76340769$export$4dc8c8e2c977ed01);
$parcel$export(module.exports, "calendarPageEntryPoint", () => $659b52ad76340769$export$eda0c2fb67f7d7e7);
$parcel$export(module.exports, "CalendarSkeleton", () => $659b52ad76340769$export$ebc7c47cc535837e);

var $eJOHy = parcelRequire("eJOHy");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $7jTnu = parcelRequire("7jTnu");

var $4mfV8 = parcelRequire("4mfV8");

var $3PvPr = parcelRequire("3PvPr");

var $lRxpy = parcelRequire("lRxpy");

var $F9BvL = parcelRequire("F9BvL");

var $6zXPf = parcelRequire("6zXPf");
const $659b52ad76340769$export$4dc8c8e2c977ed01 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $4mfV8.calendarEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $659b52ad76340769$export$eda0c2fb67f7d7e7 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $4mfV8.calendarEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $3PvPr.horizontalNavQueueEntrypoint)
});
const $659b52ad76340769$export$ebc7c47cc535837e = ()=>(0, $6zXPf.getWillShowNav4)() && !(0, $7jTnu.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $F9BvL.ClassicCalendarSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRxpy.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $F9BvL.ClassicCalendarSkeleton), null));

});
parcelRegister("4mfV8", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $392a2ed62bbe99be$export$19cf4b398f638dc6);

var $7jTnu = parcelRequire("7jTnu");

var $dW8bA = parcelRequire("dW8bA");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");
// This is the key used to store the calendar filters in the local storage
const $392a2ed62bbe99be$var$ISSUE_SEARCH_INPUT_STORAGE_KEY = 'calendar-issue-search-input';
// This is the key used to store the calendar view settings in the local storage
const $392a2ed62bbe99be$var$VIEW_SETTINGS_STORAGE_KEY = 'calendar-view-settings';
/**
 * Default Day Starts At Time in Calendar View Settings
 */ const $392a2ed62bbe99be$var$DEFAULT_DAY_STARTS_AT = '09:00 AM';
function $392a2ed62bbe99be$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $392a2ed62bbe99be$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $392a2ed62bbe99be$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $392a2ed62bbe99be$var$createScope({ context: context, tenantContext: tenantContext }, viewId) {
    const { cloudId: cloudId } = tenantContext;
    return {
        type: 'board',
        boardId: $392a2ed62bbe99be$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: (0, $7jTnu.fg)('fix_jsm_calendar_scope_issue') ? [] : [
            String(context.match.params.projectKey)
        ],
        viewId: viewId
    };
}
function $392a2ed62bbe99be$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        ids: [
            scope.boardId
        ],
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $392a2ed62bbe99be$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $392a2ed62bbe99be$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $392a2ed62bbe99be$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField, viewId: viewId }) {
    return {
        date: $392a2ed62bbe99be$var$toMidnightUTCString(selectedDate),
        mode: $392a2ed62bbe99be$var$toViewMode(viewRange),
        weekStart: $392a2ed62bbe99be$var$toWeekStart(weekStartsOn),
        ...(0, $7jTnu.fg)('jira_calendar_load_more_pagination') ? {
            startDateField: startDateField,
            endDateField: endDateField
        } : {},
        viewId: viewId
    };
}
function $392a2ed62bbe99be$var$buildStorageKey({ cloudId: cloudId, activationId: activationId, boardId: boardId, featureKey: featureKey }) {
    const viewId = $392a2ed62bbe99be$var$buildViewId({
        cloudId: cloudId,
        activationId: activationId,
        boardId: boardId
    });
    const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
    return `${LOCALSTORAGE_KEY_PREFIX}/view/${viewId}/${featureKey}`;
}
function $392a2ed62bbe99be$var$getStorageValue(storageKey) {
    // window check is needed because this code is also executed on the SSR
    if (typeof window !== 'undefined') return localStorage?.getItem(storageKey) || '';
    return '';
}
function $392a2ed62bbe99be$var$buildIssuesSearchInput(storageKey) {
    return {
        additionalFilterQuery: $392a2ed62bbe99be$var$getStorageValue(storageKey) || ''
    };
}
function $392a2ed62bbe99be$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $392a2ed62bbe99be$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $392a2ed62bbe99be$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}
function $392a2ed62bbe99be$var$buildViewId({ cloudId: cloudId, activationId: activationId, boardId: boardId }) {
    // https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Ajira%3Aview
    return `ari:cloud:jira:${cloudId}:view/activation/${activationId}/board/${boardId}`;
}

const $392a2ed62bbe99be$export$19cf4b398f638dc6 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("fxTye")), {
        moduleId: "7a55ad65",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const { date: date } = context.query;
        const selectedDate = $392a2ed62bbe99be$var$toDate(date);
        const { boardId: boardId, projectKey: projectKey } = context.match.params;
        if (!boardId || !projectKey) throw new Error('boardId and projectKey must be provided.');
        const viewId = $392a2ed62bbe99be$var$buildViewId({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId
        });
        const scope = $392a2ed62bbe99be$var$createScope(entryPointRouteParams, viewId || '');
        const storageKeyForIssueSearchInput = $392a2ed62bbe99be$var$buildStorageKey({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId,
            featureKey: $392a2ed62bbe99be$var$ISSUE_SEARCH_INPUT_STORAGE_KEY
        });
        const storageKeyForViewSettings = $392a2ed62bbe99be$var$buildStorageKey({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId,
            featureKey: $392a2ed62bbe99be$var$VIEW_SETTINGS_STORAGE_KEY
        });
        const defaultViewRange = 'month';
        const storedConfig = $392a2ed62bbe99be$var$getStorageValue(storageKeyForViewSettings);
        const viewSettingsConfig = storedConfig ? JSON.parse(storedConfig) : {
            viewRange: defaultViewRange,
            weekStartsOn: null,
            dayStartsAt: $392a2ed62bbe99be$var$DEFAULT_DAY_STARTS_AT,
            showWeekends: false,
            showIssueKey: true,
            showIn24HourClock: false,
            colorBy: 'status'
        };
        const viewRange = viewSettingsConfig.viewRange ?? 'month';
        const weekStartsOn = viewSettingsConfig.weekStartsOn ?? 'sunday';
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const colorBy = viewSettingsConfig.colorBy ?? 'status';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const issuesSearchInput = $392a2ed62bbe99be$var$buildIssuesSearchInput(storageKeyForIssueSearchInput);
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $dW8bA.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $392a2ed62bbe99be$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $392a2ed62bbe99be$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField,
                            viewId: viewId
                        }),
                        issuesPageSize: 200,
                        issuesSearchInput: issuesSearchInput,
                        unscheduledIssuesSearchInput: $392a2ed62bbe99be$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $392a2ed62bbe99be$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $392a2ed62bbe99be$var$buildSprintsSearchInput(),
                        skipSprintSearch: false,
                        viewId: viewId,
                        skipFieldConfig: false,
                        schedulePermissionsEnabled: (0, $7jTnu.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $7jTnu.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV2Search: false,
                        includeRecurrenceIndicator: false,
                        pageLoadMoreEnabledViewSettings: (0, $7jTnu.fg)('jira_calendar_load_more_pagination_view_settings'),
                        skipUserPreferences: false
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                dayStartsAt: viewSettingsConfig.dayStartsAt,
                issueEventFields: issueEventFields,
                projectKey: projectKey,
                storageKeyForViewSettings: storageKeyForViewSettings,
                storageKeyForIssueSearchInput: storageKeyForIssueSearchInput,
                showWeekends: viewSettingsConfig.showWeekends,
                showIssueKey: viewSettingsConfig.showIssueKey,
                showIn24HourClock: viewSettingsConfig.showIn24HourClock,
                colorBy: colorBy
            }
        };
    }
});

});
parcelRegister("fxTye", function(module, exports) {

let $b515075ce1fa3b1e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $b515075ce1fa3b1e$var$load("1VRB2"),
    $b515075ce1fa3b1e$var$load("bABhq"),
    $b515075ce1fa3b1e$var$load("7vqGd"),
    $b515075ce1fa3b1e$var$load("1Y4bq"),
    $b515075ce1fa3b1e$var$load("ki6Rr")
]).then(()=>parcelRequire('ly6Vc'));

});


parcelRegister("F9BvL", function(module, exports) {

$parcel$export(module.exports, "ClassicCalendarSkeleton", () => $76106232d0ffc3fb$export$49d3670908a8d8fe);

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $95UR5 = parcelRequire("95UR5");
const $76106232d0ffc3fb$export$49d3670908a8d8fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($95UR5)))
    });

});
parcelRegister("95UR5", function(module, exports) {
module.exports = new URL("classic-calendar-skeleton.tpl.3dcfde16.svg", import.meta.url).toString();

});




parcelRegister("frNhT", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueRouteEntry", () => $49f9483b7c8aab0e$export$b43128c9b5db2a5e);

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $i67QL = parcelRequire("i67QL");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $ksbf6 = parcelRequire("ksbf6");

var $1PvPk = parcelRequire("1PvPk");

var $8LnTF = parcelRequire("8LnTF");

var $aQoXd = parcelRequire("aQoXd");

var $hZn8E = parcelRequire("hZn8E");

var $2ZjY0 = parcelRequire("2ZjY0");

var $26mRz = parcelRequire("26mRz");

var $7jTnu = parcelRequire("7jTnu");

var $5L7qx = parcelRequire("5L7qx");

var $5nfTh = parcelRequire("5nfTh");

var $6I8xu = parcelRequire("6I8xu");

var $bwzwd = parcelRequire("bwzwd");

var $9U6YG = parcelRequire("9U6YG");
const $49f9483b7c8aab0e$export$b43128c9b5db2a5e = (0, $6xToB.createEntry)((0, $8LnTF.customPracticeQueueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $bwzwd.CustomQueueRouteComponent),
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        skeleton: (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $9U6YG.QueueLoadingSkeleton) : undefined,
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $2ZjY0.AsyncHorizontalNavQueue) : undefined
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            ...(0, $1PvPk.getKnowledgeBaseResources)(),
            ...(0, $1PvPk.getInsightResources)(),
            ...(0, $1PvPk.getIssueListSsrResource)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('remove_repackaging_banner_for_change'), (0, $ksbf6.jsmRepackagingBannerResource)),
            ...(0, $5nfTh.getAIContextPanelResources)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $hZn8E.horizontalNavQueueResource))
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp),
            (0, $6I8xu.AsyncBulkActionToolbarLazy)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bwzwd.LazyServicedeskQueuesAgentAndIssueView),
            (0, $i67QL.LazyForPaintServicedeskSidebar),
            (0, $26mRz.LazyHorizontalNavQueue)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("ksbf6", function(module, exports) {

$parcel$export(module.exports, "jsmRepackagingBannerResource", () => $a8973f3524fa8ac9$export$760ca885f96dacb6);
$parcel$export(module.exports, "useJsmRepackagingBannerResource", () => $a8973f3524fa8ac9$export$f1444ccc5653a5cb);

var $eJOHy = parcelRequire("eJOHy");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $k50RE = parcelRequire("k50RE");

const $a8973f3524fa8ac9$var$getDataLoader = ()=>(parcelRequire("loood"));
const $a8973f3524fa8ac9$export$760ca885f96dacb6 = (0, $l1VxS.createResource)({
    type: 'JSM_REPACKAGING_BANNER',
    getKey: ()=>'JSM_REPACKAGING_BANNER',
    getDataLoader: $a8973f3524fa8ac9$var$getDataLoader,
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});
const $a8973f3524fa8ac9$export$f1444ccc5653a5cb = (workCategory, accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)($a8973f3524fa8ac9$export$760ca885f96dacb6);
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (error || loading || !data || !accountId) return {
            show: false
        };
        const { bannerMeta: bannerMeta, bannerDismissState: bannerDismissState } = data;
        const workCategoryDismissState = bannerDismissState?.[workCategory];
        if (!bannerMeta.show || !(bannerMeta.type === 'info' || bannerMeta.type === 'warning')) return {
            show: false
        };
        if (!workCategoryDismissState) return {
            ...bannerDismissState,
            ...bannerMeta,
            refresh: refresh
        };
        if (workCategoryDismissState.packagingChangeDate !== bannerMeta.data.packagingChangeDate) {
            (0, $k50RE.deleteBannerDismissState)({
                accountId: accountId
            });
            return {
                ...bannerMeta,
                refresh: refresh
            };
        }
        if (workCategoryDismissState.bannerHiddenUntil > Date.now()) return {
            show: false
        };
        return {
            ...bannerMeta,
            ...bannerDismissState,
            refresh: refresh
        };
    }, [
        data,
        loading,
        error,
        workCategory,
        accountId,
        refresh
    ]);
};

});
parcelRegister("k50RE", function(module, exports) {

$parcel$export(module.exports, "deleteBannerDismissState", () => $754788cf22fa61a7$export$e21bb99d98e8c8b4);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
async function $754788cf22fa61a7$export$e21bb99d98e8c8b4({ accountId: accountId }) {
    try {
        await (0, $jGzN3.performDeleteRequest)(`/rest/api/3/user/properties/jsm-repackaging-banners-dismiss-state?accountId=${accountId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // https://data-portal.internal.atlassian.com/analytics/registry/71209
        (0, $gYnSx.default)({
            meta: {
                id: 'deleteBannerDismissState',
                packageName: 'jiraRouterResourcesJsmRepackagingBanner',
                teamName: 'jenga'
            },
            error: error
        });
    }
}

});

parcelRegister("loood", function(module, exports) {

let $f92ec223d6267ea7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f92ec223d6267ea7$var$load("6lsWg").then(()=>parcelRequire('gIUn6'));

});


parcelRegister("6I8xu", function(module, exports) {

$parcel$export(module.exports, "AsyncBulkActionToolbarLazy", () => $7f54d336d3737fd1$export$f0945fba2003d80a);
$parcel$export(module.exports, "AsyncBulkActionToolbar", () => $7f54d336d3737fd1$export$d53c287f3c6193b2);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $7f54d336d3737fd1$export$f0945fba2003d80a = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("9mqSx")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/bulk-actions-toolbar/src/index.tsx"
});
const $7f54d336d3737fd1$export$d53c287f3c6193b2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "async.jira-servicedesk.bulk-actions.toolbar",
        packageName: "atlassian/jira-servicedesk-bulk-actions-toolbar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "servicedesk-bulk-actions-toolbar",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f54d336d3737fd1$export$f0945fba2003d80a, props)));

});
parcelRegister("9mqSx", function(module, exports) {

let $6d0b04af0055e4d6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6d0b04af0055e4d6$var$load("1VRB2"),
    $6d0b04af0055e4d6$var$load("bABhq"),
    $6d0b04af0055e4d6$var$load("7vqGd"),
    $6d0b04af0055e4d6$var$load("1Y4bq"),
    $6d0b04af0055e4d6$var$load("h71yO")
]).then(()=>parcelRequire('8cYfx'));

});



parcelRegister("iZ2AQ", function(module, exports) {

$parcel$export(module.exports, "customQueueBoardRouteEntry", () => $3b1fd5b4a83cdc1a$export$f94102e9d0a3b113);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $1PvPk = parcelRequire("1PvPk");

var $iuwL5 = parcelRequire("iuwL5");

var $aQoXd = parcelRequire("aQoXd");

var $7jTnu = parcelRequire("7jTnu");

var $4VIcO = parcelRequire("4VIcO");

var $alzbz = parcelRequire("alzbz");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $hZn8E = parcelRequire("hZn8E");

var $6zXPf = parcelRequire("6zXPf");

var $2ZjY0 = parcelRequire("2ZjY0");

var $26mRz = parcelRequire("26mRz");

var $kD31z = parcelRequire("kD31z");
const $3b1fd5b4a83cdc1a$export$f94102e9d0a3b113 = (0, $6xToB.createEntry)((0, $iuwL5.customQueueBoardRoute), ()=>({
        group: 'servicedesk',
        component: (0, $9BJU1.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        entryPoint: ()=>{
            if ((0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $6zXPf.getWillShowNav4)() ? (0, $kD31z.boardPageEntryPoint) : (0, $kD31z.boardPageNav3EntryPoint);
            return undefined;
        },
        skeleton: (0, $kD31z.BoardSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $6zXPf.getWillShowNav4)() ? (0, $2ZjY0.AsyncHorizontalNavQueue) : undefined
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $26mRz.LazyHorizontalNavQueue)
        ],
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!false, (0, $c0h8V.uifBoardResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $6zXPf.getWillShowNav4)(), (0, $hZn8E.horizontalNavQueueResource))
        ],
        supportsPreviewPanel: true
    }));

});

parcelRegister("2d55w", function(module, exports) {

$parcel$export(module.exports, "customQueueCalendarRouteEntry", () => $ab22129773969ec2$export$a6aaa9129c24f852);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $1PvPk = parcelRequire("1PvPk");

var $3z9R8 = parcelRequire("3z9R8");

var $aQoXd = parcelRequire("aQoXd");

var $4VIcO = parcelRequire("4VIcO");

var $c0h8V = parcelRequire("c0h8V");

var $5FSZM = parcelRequire("5FSZM");

var $7jTnu = parcelRequire("7jTnu");

var $5L7qx = parcelRequire("5L7qx");

var $hZn8E = parcelRequire("hZn8E");

var $6zXPf = parcelRequire("6zXPf");

var $2ZjY0 = parcelRequire("2ZjY0");

var $26mRz = parcelRequire("26mRz");

var $lgaNk = parcelRequire("lgaNk");
const $ab22129773969ec2$export$a6aaa9129c24f852 = (0, $6xToB.createEntry)((0, $3z9R8.customQueueCalendarRoute), ()=>({
        group: 'servicedesk',
        component: (0, $9BJU1.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $6zXPf.getWillShowNav4)() ? (0, $2ZjY0.AsyncHorizontalNavQueue) : undefined
        },
        entryPoint: ()=>{
            if ((0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $6zXPf.getWillShowNav4)() ? (0, $lgaNk.calendarPageEntryPoint) : (0, $lgaNk.calendarPageNav3EntryPoint);
            return undefined;
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $26mRz.LazyHorizontalNavQueue)
        ],
        skeleton: (0, $lgaNk.CalendarSkeleton),
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5FSZM.getCalendarFilterFieldsResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $6zXPf.getWillShowNav4)(), (0, $hZn8E.horizontalNavQueueResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>!false, (0, $c0h8V.uifBoardResource))
        ],
        supportsPreviewPanel: true
    }));

});

parcelRegister("3bo4c", function(module, exports) {

$parcel$export(module.exports, "customQueueRouteEntry", () => $35090fd6a231bcdf$export$54a295e04e6cea33);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $7MMy7 = parcelRequire("7MMy7");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $hZn8E = parcelRequire("hZn8E");

var $2ZjY0 = parcelRequire("2ZjY0");

var $26mRz = parcelRequire("26mRz");

var $7jTnu = parcelRequire("7jTnu");

var $5L7qx = parcelRequire("5L7qx");

var $iWhpv = parcelRequire("iWhpv");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $i67QL = parcelRequire("i67QL");

var $6I8xu = parcelRequire("6I8xu");

var $bwzwd = parcelRequire("bwzwd");

var $9U6YG = parcelRequire("9U6YG");
const $35090fd6a231bcdf$export$54a295e04e6cea33 = (0, $6xToB.createEntry)((0, $7MMy7.customQueueRoute), ()=>({
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $2ZjY0.AsyncHorizontalNavQueue) : undefined
        },
        skeleton: (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $9U6YG.QueueLoadingSkeleton) : undefined,
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            ...(0, $1PvPk.getInsightResources)(),
            ...(0, $1PvPk.getIssueListSsrResource)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $iWhpv.servicedeskIsItsmProjectResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $hZn8E.horizontalNavQueueResource))
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp),
            (0, $6I8xu.AsyncBulkActionToolbarLazy)
        ],
        group: 'servicedesk',
        // It is important to keep this component consistent across the two routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        component: (0, $bwzwd.CustomQueueRouteComponent),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bwzwd.LazyServicedeskQueuesAgentAndIssueView),
            (0, $i67QL.LazyForPaintServicedeskSidebar),
            (0, $26mRz.LazyHorizontalNavQueue)
        ],
        supportsPreviewPanel: true
    }));

});

parcelRegister("kINnF", function(module, exports) {

$parcel$export(module.exports, "dashboardEditRouteEntry", () => $ff2b2f103cf40f8e$export$9b0fdfd6a51a17de);

var $7IYIF = parcelRequire("7IYIF");


var $1wb5r = parcelRequire("1wb5r");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $jlaZM = parcelRequire("jlaZM");

var $9NmsS = parcelRequire("9NmsS");

var $2Ga0d = parcelRequire("2Ga0d");

var $hUpHQ = parcelRequire("hUpHQ");

var $8vUDE = parcelRequire("8vUDE");

var $g8uYY = parcelRequire("g8uYY");

var $lixcc = parcelRequire("lixcc");

var $en43l = parcelRequire("en43l");
const $ff2b2f103cf40f8e$export$9b0fdfd6a51a17de = (0, $6xToB.createEntry)((0, $2Ga0d.dashboardEditRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$ff2b2f103cf40f8e$var$pageEntryPoint,
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $7IYIF.dashboardBackgroundScriptsLayout)),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $en43l.dashboardResources)(),
            (0, $jlaZM.gadgetDirectoryResource)
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $1wb5r.NORMAL_EARLY_ASSET_STRATEGY)
    }));
// Page entrypoint, referred to above...
const $ff2b2f103cf40f8e$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8vUDE.dashboardEditEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).DASHBOARDS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $hUpHQ.nav4DashboardsContentEntryPoint)
            }
        }
    }
});

});
parcelRegister("7IYIF", function(module, exports) {

$parcel$export(module.exports, "dashboardBackgroundScriptsLayout", () => $15dcb686237ae24b$export$f0a12e66953aa38a);

var $6dwgv = parcelRequire("6dwgv");

var $3O07j = parcelRequire("3O07j");
const $15dcb686237ae24b$export$f0a12e66953aa38a = (0, $6dwgv.createLayout)({
    globalComponents: [
        (0, $3O07j.DashboardBackgroundScripts)
    ]
});

});
parcelRegister("3O07j", function(module, exports) {

$parcel$export(module.exports, "DashboardBackgroundScripts", () => $caf28a7036a34af8$export$4095842bb2e8d712);

var $gMQDC = parcelRequire("gMQDC");
const $caf28a7036a34af8$export$4095842bb2e8d712 = (0, $gMQDC.LazyAfterPaintBackgroundScripts);
$caf28a7036a34af8$export$4095842bb2e8d712.displayName = 'ConditionalDashboardBackgroundScripts';

});
parcelRegister("gMQDC", function(module, exports) {

$parcel$export(module.exports, "LazyAfterPaintBackgroundScripts", () => $aac4aec64484ba5b$export$d4768112536c9dc9);

var $gzcjr = parcelRequire("gzcjr");

const $aac4aec64484ba5b$export$d4768112536c9dc9 = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("ghZRF")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/dashboard/background-scripts/src/ui/index.tsx"
});

});
parcelRegister("ghZRF", function(module, exports) {

let $bdbe38e8df5eec00$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bdbe38e8df5eec00$var$load("6C0hQ").then(()=>parcelRequire('1NtAt'));

});




parcelRegister("jlaZM", function(module, exports) {

$parcel$export(module.exports, "dashboardConfigAndWRMResource", () => $eddd06b4219d924c$export$2853c0e656e89346);
$parcel$export(module.exports, "useDashboardResource", () => $eddd06b4219d924c$export$e5e5b3f462d6a4cb);
$parcel$export(module.exports, "useMultiDashboardsResource", () => $eddd06b4219d924c$export$6a46406b05d8d13c);
$parcel$export(module.exports, "dashboardAMDModulesResource", () => $eddd06b4219d924c$export$ef3fa55626812fa4);
$parcel$export(module.exports, "useDashboardAMDModulesResource", () => $eddd06b4219d924c$export$efe0eb9a44e08d38);
$parcel$export(module.exports, "dashboardReactGadgetsResource", () => $eddd06b4219d924c$export$39804ce8cc42cd04);
$parcel$export(module.exports, "useDashboardReactGadgetsResource", () => $eddd06b4219d924c$export$31b430e01a1caab5);
$parcel$export(module.exports, "dashboardForgeResource", () => $eddd06b4219d924c$export$4e0719e53da01e93);
$parcel$export(module.exports, "gadgetDirectoryResource", () => $eddd06b4219d924c$export$36c9632be21fbb06);
$parcel$export(module.exports, "useGadgetDirectoryResource", () => $eddd06b4219d924c$export$27f4c12e781b4572);
$parcel$export(module.exports, "useDashboardForgeResource", () => $eddd06b4219d924c$export$75ca1b431898fd09);

var $fohjD = parcelRequire("fohjD");

var $dhAnj = parcelRequire("dhAnj");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");

var $E0qsj = parcelRequire("E0qsj");

var $hElUD = parcelRequire("hElUD");


var $3qYSS = parcelRequire("3qYSS");

var $lQtHx = parcelRequire("lQtHx");

var $8Fsa4 = parcelRequire("8Fsa4");

var $rbj9K = parcelRequire("rbj9K");

var $fxH8d = parcelRequire("fxH8d");
const $eddd06b4219d924c$export$2853c0e656e89346 = (0, $l1VxS.createResource)({
    type: (0, $fd22ea3140eeb833$export$ca03ff6cc792cc16),
    getKey: $hElUD.getKey,
    getData: (0, $lQtHx.default),
    maxAge: Infinity
});
// the type signature of promise and update is different on the useDashboardResource and useMultiDashboardsResource hook
const $eddd06b4219d924c$var$extractFirstPromise = (promise)=>promise ? promise.then((configs)=>configs && configs[0]) : null;
const $eddd06b4219d924c$export$e5e5b3f462d6a4cb = ()=>{
    // the response will have different signature on update, promise and clear etc
    const resourceResponse = $eddd06b4219d924c$export$6a46406b05d8d13c();
    const { loading: loading, error: error, data: data, promise: promiseOfMultiConfigs, ...rest } = resourceResponse;
    const extractFirstUpdate = (0, $fAZgY.useCallbackWithCondition)((getNewData)=>resourceResponse.update(([a])=>[
                getNewData(a)
            ]), [
        resourceResponse
    ], ()=>(0, $7jTnu.fg)('jfp-magma-concurrent-dashboard'));
    // RouteResourceResponseLoading type
    if (loading) return {
        ...rest,
        error: null,
        data: null,
        promise: $eddd06b4219d924c$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: true,
        update: extractFirstUpdate
    };
    // RouteResourceResponseError type
    if (error) return {
        ...rest,
        error: error,
        data: null,
        promise: $eddd06b4219d924c$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: false,
        update: extractFirstUpdate
    };
    // RouteResourceResponseLoaded type
    if (data && !error) return {
        ...rest,
        loading: false,
        update: extractFirstUpdate,
        data: data[0],
        error: null,
        promise: $eddd06b4219d924c$var$extractFirstPromise(promiseOfMultiConfigs)
    };
    // RouteResourceResponseInitial type
    return {
        ...rest,
        loading: false,
        error: error,
        data: null,
        promise: null,
        update: extractFirstUpdate
    };
};
const $eddd06b4219d924c$export$6a46406b05d8d13c = ()=>(0, $eJrcF.useResource)($eddd06b4219d924c$export$2853c0e656e89346);
const $eddd06b4219d924c$export$ef3fa55626812fa4 = (0, $E0qsj.createDependentResource)({
    type: (0, $fd22ea3140eeb833$export$e239393fd4e2bc85),
    getKey: $hElUD.getKey,
    depends: [
        (0, $fd22ea3140eeb833$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $E0qsj.withEitherDataOrError)((data)=>{
        const { gadgets: gadgets, preloadedModuleNames: preloadedModuleNames } = data.reduce((prev, curr)=>({
                gadgets: prev.gadgets.concat(curr.gadgets),
                preloadedModuleNames: prev.preloadedModuleNames.concat(curr.preloadedModuleNames)
            }), {
            gadgets: [],
            preloadedModuleNames: []
        });
        const moduleNames = (0, $fxH8d.gadgetsToUniqueSortedAmdModules)(gadgets);
        const isPreloaded = moduleNames.every((name)=>preloadedModuleNames.includes(name));
        return {
            moduleNames: moduleNames,
            isPreloaded: isPreloaded
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, amdModules: amdModules }, b)=>(0, $E0qsj.withEitherDataOrError)((prev, next)=>next.moduleNames.length > prev.moduleNames.length || next.moduleNames.some((name)=>amdModules?.[name] == null), ()=>true)(a, b),
    getData: (0, $3qYSS.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $eddd06b4219d924c$export$efe0eb9a44e08d38 = ()=>(0, $eJrcF.useResource)($eddd06b4219d924c$export$ef3fa55626812fa4);
const $eddd06b4219d924c$export$39804ce8cc42cd04 = (0, $E0qsj.createDependentResource)({
    type: (0, $fd22ea3140eeb833$export$9e5db01432b13b67),
    getKey: $hElUD.getKey,
    depends: [
        (0, $fd22ea3140eeb833$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $E0qsj.withEitherDataOrError)((data)=>{
        const gadgets = data.flatMap((dashboard)=>dashboard.gadgets);
        return {
            reactGadgets: (0, $fxH8d.gadgetsToSortedReactGadgets)(gadgets)
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, reactGadgetsState: reactGadgetsState }, b)=>(0, $E0qsj.withEitherDataOrError)((prev, next)=>JSON.stringify(next.reactGadgets) !== JSON.stringify(prev.reactGadgets) || reactGadgetsState != null && Object.values(reactGadgetsState).some((v)=>!v), ()=>true)(a, b),
    getData: (0, $rbj9K.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $eddd06b4219d924c$export$31b430e01a1caab5 = ()=>(0, $eJrcF.useResource)($eddd06b4219d924c$export$39804ce8cc42cd04);
const $eddd06b4219d924c$export$4e0719e53da01e93 = (0, $l1VxS.createResource)({
    type: (0, $fd22ea3140eeb833$export$bce41807cc929d0f),
    getKey: $hElUD.getKey,
    getData: async (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        const modules = await (0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.DASHBOARD_GADGET_MODULE),
                (0, $fohjD.DASHBOARD_BACKGROUND_SCRIPT_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $fohjD.SOURCE_ROUTER)
        });
        return {
            gadgets: modules[0, $fohjD.DASHBOARD_GADGET_MODULE],
            backgroundScripts: modules[0, $fohjD.DASHBOARD_BACKGROUND_SCRIPT_MODULE]
        };
    },
    maxAge: Infinity
});
const $eddd06b4219d924c$export$36c9632be21fbb06 = (0, $l1VxS.createResource)({
    type: (0, $fd22ea3140eeb833$export$c07a25ebb6af1e84),
    getKey: ()=>'gadgetDirectoryItems',
    getData: (0, $8Fsa4.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $eddd06b4219d924c$export$27f4c12e781b4572 = ()=>(0, $eJrcF.useResource)($eddd06b4219d924c$export$36c9632be21fbb06);
const $eddd06b4219d924c$export$75ca1b431898fd09 = ()=>(0, $eJrcF.useResource)($eddd06b4219d924c$export$4e0719e53da01e93);

});
parcelRegister("E0qsj", function(module, exports) {

$parcel$export(module.exports, "withEitherDataOrError", () => $4baea0a192bade5c$export$54e973088fdd59a1);
$parcel$export(module.exports, "createDependentResource", () => $4baea0a192bade5c$export$7f8dd41bdfd85a47);
$parcel$export(module.exports, "SharedValueAggregateError", () => $4baea0a192bade5c$export$36d5102d613df7c6);

var $l1VxS = parcelRequire("l1VxS");
var $dSu1v = parcelRequire("dSu1v");
const $4baea0a192bade5c$export$54e973088fdd59a1 = (dataFn, errorFn)=>(...args)=>{
        const invalidArgs = args.filter((v)=>v == null || v instanceof Error);
        return invalidArgs.length ? errorFn(invalidArgs[0]) : dataFn(...args);
    };
const $4baea0a192bade5c$export$fcdc85dfc621ec7a = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new (0, $dSu1v.ResourceDependencyError)(`Cannot decode dependency "${type}", it may be missing from resource depends field`);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return resourceSlice.data;
};
const $4baea0a192bade5c$export$bee6a631bfb54474 = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new Error(`Cannot decode dependency: "${type}" must be included in the resource depends field`);
    // prefer previous value rather than error
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { loading: loading, data: data, promise: promise, error: error } = resourceSlice;
    return loading && promise ? promise.then((v)=>v, (e)=>data ?? e) : data ?? error;
};
const $4baea0a192bade5c$export$7f8dd41bdfd85a47 = ({ type: type, depends: depends, mapToSharedValue: mapToSharedValue, shouldUpdate: shouldUpdate, getData: getData, ...rest })=>(0, $l1VxS.createResource)({
        ...rest,
        type: type,
        depends: [
            ...depends,
            type
        ],
        getData: (dataContext, storeContext)=>{
            const { dependencies: dependencies } = dataContext;
            const prevValue = $4baea0a192bade5c$export$fcdc85dfc621ec7a(dependencies, type);
            const valuesOrPromises = depends.map((d)=>$4baea0a192bade5c$export$bee6a631bfb54474(dependencies, d));
            const implementation = (depDataOrErrorOrNull)=>{
                const newShared = mapToSharedValue(...depDataOrErrorOrNull);
                return prevValue == null || prevValue instanceof Error || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                shouldUpdate(prevValue, newShared) ? getData(prevValue, newShared)(dataContext, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                storeContext) : prevValue;
            };
            return valuesOrPromises.some((v)=>v instanceof Promise) ? Promise.allSettled(valuesOrPromises).then((arr)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                arr.map((v)=>v.status === 'fulfilled' ? v.value : v.reason)).then(implementation) : implementation(valuesOrPromises);
        }
    });
class $4baea0a192bade5c$export$36d5102d613df7c6 extends Error {
    constructor({ name: name, isPrefetch: isPrefetch, sharedValue: sharedValue }){
        super(`${name} is missing dependency, prefetch [${isPrefetch}] sharedValue [${sharedValue}]`);
        this.skipSentry = true;
    }
}

});

parcelRegister("hElUD", function(module, exports) {

$parcel$export(module.exports, "getKey", () => $13f3de97d34e3670$export$a47fb462a08de82f);
// eslint-disable-next-line jira/import-whitelist

var $iluXv = parcelRequire("iluXv");
const $13f3de97d34e3670$export$a47fb462a08de82f = ({ route: route, query: query, match: { params: params } })=>{
    if (route.name === 'system-dashboard-edit') return 0, $iluXv.SYSTEM_DASHBOARD_ID;
    if (route.name === 'dashboard-wallboard') // NOTE - Currently we will only load the first dashboard in the list
    return query.dashboardId?.split(',')[0];
    return params.dashboardId?.replace('last-visited', 'lastVisited') ?? query.selectPageId ?? 'lastVisited';
};

});
parcelRegister("iluXv", function(module, exports) {

$parcel$export(module.exports, "GADGET_DISPLAY", () => $0a37d7d1a1d083ba$export$d7e1dfcefcde2410);
$parcel$export(module.exports, "MAXIMIZED_PARAM", () => $0a37d7d1a1d083ba$export$86eaa19ea940a4f5);
$parcel$export(module.exports, "CONNECT_ITEM_AMD_MODULE", () => $0a37d7d1a1d083ba$export$a1baea8b97610fd);
$parcel$export(module.exports, "WEB_RESOURCE_MAP", () => $0a37d7d1a1d083ba$export$c6d360a8456d120a);
$parcel$export(module.exports, "PRELOADED_GADGET_DATA_KEY", () => $0a37d7d1a1d083ba$export$30b970d16c2f5e0a);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_ID", () => $0a37d7d1a1d083ba$export$50eac80bcbebc737);
$parcel$export(module.exports, "DASHBOARD_HEADER_HEIGHT", () => $0a37d7d1a1d083ba$export$e11ffd0409aa6522);
$parcel$export(module.exports, "FOOTER_MARGIN", () => $0a37d7d1a1d083ba$export$4d708f4c16ae3a73);
$parcel$export(module.exports, "STORAGE_PREFIX", () => $0a37d7d1a1d083ba$export$7cc65d02ca2e18ec);
$parcel$export(module.exports, "GADGET_LOCAL_STORAGE_NAME", () => $0a37d7d1a1d083ba$export$255117c9adec50a5);
$parcel$export(module.exports, "DASHBOARD_LOCAL_STORAGE_KEY_NAME", () => $0a37d7d1a1d083ba$export$e281465c09f561d4);
$parcel$export(module.exports, "GADGET_DEFAULT_HEIGHT", () => $0a37d7d1a1d083ba$export$46dd0168a7875b47);
$parcel$export(module.exports, "COLOR_MAP", () => $0a37d7d1a1d083ba$export$1468aefba37090f9);
$parcel$export(module.exports, "COLOR_NAME_MAP", () => $0a37d7d1a1d083ba$export$5d9e688e192a63ae);
$parcel$export(module.exports, "COLOR_CHECKMARK_MAP", () => $0a37d7d1a1d083ba$export$6906a4beef307ac4);
$parcel$export(module.exports, "MODAL_ID", () => $0a37d7d1a1d083ba$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "LAYOUTS", () => $0a37d7d1a1d083ba$export$87e50aced9c52ebb);
$parcel$export(module.exports, "GADGET_HEIGHT_UPDATE_WAIT_TIME", () => $0a37d7d1a1d083ba$export$b0234a47b1a4a515);
$parcel$export(module.exports, "GADGET_DRAG_CONTAINER_HEIGHT", () => $0a37d7d1a1d083ba$export$9674cd14c20d1c89);
$parcel$export(module.exports, "GADGET_METRICS_TYPE", () => $0a37d7d1a1d083ba$export$46b6c8eb53069613);
$parcel$export(module.exports, "PAGE_READY_METRIC_KEY", () => $0a37d7d1a1d083ba$export$464d2a6bcb398791);
$parcel$export(module.exports, "DELETE_DASHBOARD_EXPERIENCE", () => $0a37d7d1a1d083ba$export$4f74f1f13671c49d);
$parcel$export(module.exports, "COPY_DASHBOARD_EXPERIENCE", () => $0a37d7d1a1d083ba$export$3853fce65645c557);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE", () => $0a37d7d1a1d083ba$export$c8c77659771c38b9);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD_EXPERIENCE", () => $0a37d7d1a1d083ba$export$707702c47e5b9648);
$parcel$export(module.exports, "CREATE_DASHBOARD_EXPERIENCE", () => $0a37d7d1a1d083ba$export$efbab4efa7252143);
$parcel$export(module.exports, "VIEW_DASHBOARD_EDITABLE_EXPERIENCE", () => $0a37d7d1a1d083ba$export$7b6f3ec1189de156);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EXPERIENCE", () => $0a37d7d1a1d083ba$export$f0e105144716a420);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EMBED_EXPERIENCE", () => $0a37d7d1a1d083ba$export$5ba84cd082269cd5);
$parcel$export(module.exports, "VIEW_DASHBOARD_WALLBOARD_READONLY_EXPERIENCE", () => $0a37d7d1a1d083ba$export$6c84c6099fed3c23);
$parcel$export(module.exports, "ADD_GADGET_EXPERIENCE", () => $0a37d7d1a1d083ba$export$3b17b4f7f722b1ae);
$parcel$export(module.exports, "SAVE_AMD_GADGET_CONFIG_PREFERENCES", () => $0a37d7d1a1d083ba$export$c8900d7e874d42ca);
$parcel$export(module.exports, "SAVE_FORGE_GADGET_CONFIG_PREFERENCES", () => $0a37d7d1a1d083ba$export$bac5a3e9d008da59);
$parcel$export(module.exports, "SAVE_CUSTOM_GADGET_TITLE_PREFERENCES", () => $0a37d7d1a1d083ba$export$18b54b2c53cf6acd);
$parcel$export(module.exports, "VIEW_WRM_GADGET_EXPERIENCE", () => $0a37d7d1a1d083ba$export$a3d5b76ea0c8f4ca);
$parcel$export(module.exports, "CHANGE_LAYOUT_EXPERIENCE", () => $0a37d7d1a1d083ba$export$7254246f25b4cbc8);
$parcel$export(module.exports, "DELETE_GADGET_EXPERIENCE", () => $0a37d7d1a1d083ba$export$40c4d345e57fce2d);
$parcel$export(module.exports, "VIEW_REACT_GADGET_EXPERIENCE", () => $0a37d7d1a1d083ba$export$43fb10a4d8374f1a);
$parcel$export(module.exports, "DASHBOARD_VIEW_SOURCENAME", () => $0a37d7d1a1d083ba$export$2f961c74af6d8735);
$parcel$export(module.exports, "DASHBOARD_VIEW_EMBED_SOURCENAME", () => $0a37d7d1a1d083ba$export$dab1096b356df1cc);
$parcel$export(module.exports, "DASHBOARD_EDIT_SOURCENAME", () => $0a37d7d1a1d083ba$export$32f0edca4eebb9c7);
$parcel$export(module.exports, "DASHBOARD_WALLBOARD_VIEW_SOURCENAME", () => $0a37d7d1a1d083ba$export$791f7067c41dc5b1);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_EDIT_SOURCENAME", () => $0a37d7d1a1d083ba$export$eba1a497984af3ae);
$parcel$export(module.exports, "COPY_DASHBOARD", () => $0a37d7d1a1d083ba$export$3578044b625436f9);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH", () => $0a37d7d1a1d083ba$export$48bb59a846d62ea0);
$parcel$export(module.exports, "DELETE_DASHBOARD", () => $0a37d7d1a1d083ba$export$e7dfbcf33cf2b19a);
$parcel$export(module.exports, "DUPLICATE_GADGET_EXPERIENCE", () => $0a37d7d1a1d083ba$export$fabf79b25b44377f);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD", () => $0a37d7d1a1d083ba$export$abba919f32a1a776);
$parcel$export(module.exports, "GADGET_ERROR_TYPE", () => $0a37d7d1a1d083ba$export$768dad6811159849);
$parcel$export(module.exports, "DASHBOARD_REFRESH_LOAD_BUFFER_MS", () => $0a37d7d1a1d083ba$export$ada294d471e7dfc3);
$parcel$export(module.exports, "REFRESH_LABEL_UPDATE_INTERVAL", () => $0a37d7d1a1d083ba$export$f4280aaeba4d1d08);
$parcel$export(module.exports, "CONNECT_GADGET_REFRESH_REQUEST_EVENT", () => $0a37d7d1a1d083ba$export$685171fdf5112bc4);
$parcel$export(module.exports, "FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT", () => $0a37d7d1a1d083ba$export$4d8c12b9aaeac619);
$parcel$export(module.exports, "ISSUE_SEARCH_DEFAULT_COLUMNS", () => $0a37d7d1a1d083ba$export$f07dac7b8de3bda);


var $dPMMf = parcelRequire("dPMMf");

var $agYa8 = parcelRequire("agYa8");
const $0a37d7d1a1d083ba$export$d7e1dfcefcde2410 = {
    MAXIMIZED: 'maximized',
    NORMAL: 'normal',
    HIDDEN: 'hidden'
};
const $0a37d7d1a1d083ba$export$86eaa19ea940a4f5 = 'maximized';
const $0a37d7d1a1d083ba$export$a1baea8b97610fd = 'atlassian-connect/connect-dashboard-item';
const $0a37d7d1a1d083ba$export$c6d360a8456d120a = {
    'jira-dashboard-items/assigned-to-me': 'com.atlassian.jira.gadgets:assigned-to-me-dashboard-item-resources',
    'jira-dashboard-items/filter-results': 'com.atlassian.jira.gadgets:filter-results-dashboard-item-resources',
    'jira-dashboard-items/createdvsresolved': 'com.atlassian.jira.gadgets:createdvsresolved-dashboard-item-resources',
    'jira-dashboard-items/favourite-filters': 'com.atlassian.jira.gadgets:favourite-filters-dashboard-item-resources',
    'jira-dashboard-items/in-progress': 'com.atlassian.jira.gadgets:in-progress-dashboard-item-resources',
    'jira-dashboard-items/stats': 'com.atlassian.jira.gadgets:stats-dashboard-item-resources',
    'jira-dashboard-items/watched': 'com.atlassian.jira.gadgets:watched-dashboard-item-resources',
    'jira-dashboard-items/labels': 'com.atlassian.jira.gadgets:labels-dashboard-item-resources',
    'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item-resources',
    'jira-dashboard-items/piechart': 'com.atlassian.jira.gadgets:piechart-dashboard-item-resources',
    'jira-dashboard-items/voted': 'com.atlassian.jira.gadgets:voted-dashboard-item-resources',
    'jira-dashboard-items/two-dimensional-stats': 'com.atlassian.jira.gadgets:two-dimensional-stats-dashboard-item-resources',
    'jira-dashboard-items/sprint-health': 'com.pyxis.greenhopper.jira:greenhopper-sprint-health-dashboard-item-resources',
    'jira-dashboard-items/sprint-days-remaining': 'com.pyxis.greenhopper.jira:greenhopper-days-remaining-dashboard-item-resources',
    'servicedesk/internal/dashboard-items/filter/filter-dashboard-item': 'com.atlassian.servicedesk.dashboard-items-plugin:spa-filter-dashboard-item-resources',
    'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'com.atlassian.servicedesk.servicedesk-reports-plugin:custom-report-dashboard-item-resources-spa',
    'jira-dashboard-items/projects': 'com.atlassian.jira.gadgets:projects-dashboard-item-resources',
    'jira-dashboard-items/issuescalendar': 'com.atlassian.jira.ext.calendar:issues-calendar-dashboard-item-resources',
    'jira-dashboard-items/activitystream': 'com.atlassian.streams.streams-jira-plugin:activitystream-dashboard-item-resources',
    'jira-dashboard-items/recently-created': 'com.atlassian.jira.gadgets:recently-created-chart-dashboard-item-resources',
    'jira-dashboard-items/resolution-time': 'com.atlassian.jira.gadgets:resolution-time-dashboard-item-resources',
    'jira-dashboard-items/timesince': 'com.atlassian.jira.gadgets:timesince-dashboard-item-resources',
    'jira-dashboard-items/spacer': 'com.atlassian.jira.gadgets:spacer-dashboard-item-resources',
    'jira-dashboard-items/sprint-burndown': 'com.pyxis.greenhopper.jira:greenhopper-sprint-burndown-dashboard-item-resources',
    'jira-dashboard-items/workload-pie-chart': 'com.atlassian.jira.gadgets:workload-pie-chart-dashboard-item-resources',
    'jira-dashboard-items/roadmap': 'com.atlassian.jira.gadgets:roadmap-dashboard-item-resources',
    'jira-dashboard-items/average-age-chart': 'com.atlassian.jira.gadgets:average-age-chart-dashboard-item-resources',
    'jira-dashboard-items/average-time-in-status-chart': 'com.atlassian.jira.gadgets:average-time-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/average-number-of-times-in-status-chart': 'com.atlassian.jira.gadgets:average-number-of-times-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/heat-map': 'com.atlassian.jira.gadgets:heat-map-dashboard-item-resources',
    'jira-dashboard-items/time-to-first-response': 'com.atlassian.jira.gadgets:time-to-first-response-dashboard-item-resources',
    'jira-dashboard-items/rapid-view': 'com.pyxis.greenhopper.jira:greenhopper-rapid-view-dashboard-item-resources',
    'jira-dashboard-items/version-report': 'com.pyxis.greenhopper.jira:greenhopper-version-report-dashboard-item-resources'
};
const $0a37d7d1a1d083ba$export$30b970d16c2f5e0a = 'DASHBOARD_GADGET_PRELOADED_DATA';
const $0a37d7d1a1d083ba$export$50eac80bcbebc737 = '10000';
const $0a37d7d1a1d083ba$export$e11ffd0409aa6522 = (0, $dPMMf.gridSize) * 10;
const $0a37d7d1a1d083ba$export$4d708f4c16ae3a73 = (0, $dPMMf.gridSize) * 2;
const $0a37d7d1a1d083ba$export$7cc65d02ca2e18ec = 'dashboard';
const $0a37d7d1a1d083ba$export$255117c9adec50a5 = 'AG.congolmerate.cookie';
const $0a37d7d1a1d083ba$export$e281465c09f561d4 = 'dashboard-data';
const $0a37d7d1a1d083ba$export$46dd0168a7875b47 = 160;
const $0a37d7d1a1d083ba$var$COLOR_BLUE = '#2684ff';
const $0a37d7d1a1d083ba$var$COLOR_RED = '#ff5630';
const $0a37d7d1a1d083ba$var$COLOR_YELLOW = '#ffab00';
const $0a37d7d1a1d083ba$var$COLOR_GREEN = '#36b37e';
const $0a37d7d1a1d083ba$var$COLOR_TEAL = '#00b8d9';
const $0a37d7d1a1d083ba$var$COLOR_PURPLE = '#6554c0';
const $0a37d7d1a1d083ba$var$COLOR_GRAY = '#97a0af';
const $0a37d7d1a1d083ba$var$COLOR_WHITE = '#ffffff';
const $0a37d7d1a1d083ba$export$1468aefba37090f9 = {
    color1: $0a37d7d1a1d083ba$var$COLOR_BLUE,
    color2: $0a37d7d1a1d083ba$var$COLOR_RED,
    color3: $0a37d7d1a1d083ba$var$COLOR_YELLOW,
    color4: $0a37d7d1a1d083ba$var$COLOR_GREEN,
    color5: $0a37d7d1a1d083ba$var$COLOR_TEAL,
    color6: $0a37d7d1a1d083ba$var$COLOR_PURPLE,
    color7: $0a37d7d1a1d083ba$var$COLOR_GRAY,
    color8: $0a37d7d1a1d083ba$var$COLOR_WHITE
};
const $0a37d7d1a1d083ba$export$5d9e688e192a63ae = {
    [$0a37d7d1a1d083ba$var$COLOR_BLUE]: (0, $agYa8.default).blue,
    [$0a37d7d1a1d083ba$var$COLOR_RED]: (0, $agYa8.default).red,
    [$0a37d7d1a1d083ba$var$COLOR_YELLOW]: (0, $agYa8.default).yellow,
    [$0a37d7d1a1d083ba$var$COLOR_GREEN]: (0, $agYa8.default).green,
    [$0a37d7d1a1d083ba$var$COLOR_TEAL]: (0, $agYa8.default).teal,
    [$0a37d7d1a1d083ba$var$COLOR_PURPLE]: (0, $agYa8.default).purple,
    [$0a37d7d1a1d083ba$var$COLOR_GRAY]: (0, $agYa8.default).gray,
    [$0a37d7d1a1d083ba$var$COLOR_WHITE]: (0, $agYa8.default).white
};
const $0a37d7d1a1d083ba$export$6906a4beef307ac4 = {
    color1: (0, $135dba7912433cc2$exports).N10,
    color2: (0, $135dba7912433cc2$exports).N10,
    color3: (0, $135dba7912433cc2$exports).N500,
    color4: (0, $135dba7912433cc2$exports).N10,
    color5: (0, $135dba7912433cc2$exports).N500,
    color6: (0, $135dba7912433cc2$exports).N10,
    color7: (0, $135dba7912433cc2$exports).N10,
    color8: (0, $135dba7912433cc2$exports).N500
};
const $0a37d7d1a1d083ba$export$ebdd5a8e5b1c2de5 = {
    EDIT_LAYOUT: 'edit-layout',
    DASHBOARD_COPY: 'dashboard-copy',
    AUTOMATIC_REFRESH: 'dashboard-automatic-refresh',
    DASHBOARD_RENAME_OR_SHARE: 'dashboard-rename-or-share',
    DASHBOARD_DELETE: 'dashboard-delete',
    CONFIGURE_WALLBOARD: 'configure-wallboard',
    DASHBOARD_CREATE: 'dashboard-create-on-dashboard-page'
};
const $0a37d7d1a1d083ba$export$87e50aced9c52ebb = [
    'A',
    'AA',
    'AAA',
    'BA',
    'AB'
];
const $0a37d7d1a1d083ba$export$b0234a47b1a4a515 = 350;
const $0a37d7d1a1d083ba$export$9674cd14c20d1c89 = 250;
const $0a37d7d1a1d083ba$export$46b6c8eb53069613 = {
    REPORT: 'REPORT_GADGET_METRICS',
    TIMEOUT: 'TIMEOUT_GADGET_METRICS'
};
const $0a37d7d1a1d083ba$export$464d2a6bcb398791 = 'JIRA_SPA_PAGE_READY';
const $0a37d7d1a1d083ba$export$4f74f1f13671c49d = 'delete-dashboard';
const $0a37d7d1a1d083ba$export$3853fce65645c557 = 'copy-dashboard';
const $0a37d7d1a1d083ba$export$c8c77659771c38b9 = 'dashboard-automatic-refresh';
const $0a37d7d1a1d083ba$export$707702c47e5b9648 = 'rename-or-share-dashboard';
const $0a37d7d1a1d083ba$export$efbab4efa7252143 = 'create-dashboard';
const $0a37d7d1a1d083ba$export$7b6f3ec1189de156 = 'view-dashboard-editable';
const $0a37d7d1a1d083ba$export$f0e105144716a420 = 'view-dashboard-readonly';
const $0a37d7d1a1d083ba$export$5ba84cd082269cd5 = 'view-dashboard-readonly-embed';
const $0a37d7d1a1d083ba$export$6c84c6099fed3c23 = 'view-dashboard-wallboard-readonly';
const $0a37d7d1a1d083ba$export$3b17b4f7f722b1ae = 'add-gadget';
const $0a37d7d1a1d083ba$export$c8900d7e874d42ca = 'save-amd-gadget-config';
const $0a37d7d1a1d083ba$export$bac5a3e9d008da59 = 'save-forge-gadget-config';
const $0a37d7d1a1d083ba$export$18b54b2c53cf6acd = 'save-custom-gadget-title-config';
const $0a37d7d1a1d083ba$export$a3d5b76ea0c8f4ca = 'view-wrm-gadget';
const $0a37d7d1a1d083ba$export$7254246f25b4cbc8 = 'change-layout';
const $0a37d7d1a1d083ba$export$40c4d345e57fce2d = 'delete-gadget';
const $0a37d7d1a1d083ba$export$43fb10a4d8374f1a = 'view-react-gadget';
const $0a37d7d1a1d083ba$export$2f961c74af6d8735 = 'dashboardView';
const $0a37d7d1a1d083ba$export$dab1096b356df1cc = 'dashboardViewEmbed';
const $0a37d7d1a1d083ba$export$32f0edca4eebb9c7 = 'dashboardEdit';
const $0a37d7d1a1d083ba$export$791f7067c41dc5b1 = 'dashboardWallboardView';
const $0a37d7d1a1d083ba$export$eba1a497984af3ae = 'systemDashboardEdit';
const $0a37d7d1a1d083ba$export$3578044b625436f9 = 'copyDashboard';
const $0a37d7d1a1d083ba$export$48bb59a846d62ea0 = 'automaticRefresh';
const $0a37d7d1a1d083ba$export$e7dfbcf33cf2b19a = 'deleteDashboard';
const $0a37d7d1a1d083ba$export$fabf79b25b44377f = 'duplicateGadget';
const $0a37d7d1a1d083ba$export$abba919f32a1a776 = 'renameOrShareDashboard';
const $0a37d7d1a1d083ba$export$768dad6811159849 = {
    VIEW_ERROR: 'viewError',
    EDIT_ERROR: 'editError',
    CONFIG_ERROR: 'configError',
    NOT_SUPPORTED_ERROR: 'notSupportedError'
};
const $0a37d7d1a1d083ba$export$ada294d471e7dfc3 = 1000;
const $0a37d7d1a1d083ba$export$f4280aaeba4d1d08 = 30000;
const $0a37d7d1a1d083ba$export$685171fdf5112bc4 = 'jira_dashboard_item_refresh';
const $0a37d7d1a1d083ba$export$4d8c12b9aaeac619 = 'JIRA_DASHBOARD_GADGET_REFRESH';
const $0a37d7d1a1d083ba$export$f07dac7b8de3bda = [
    'issuetype',
    'issuekey',
    'summary',
    'priority'
];

});
parcelRegister("agYa8", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eb3035b95f7a2b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $70eb3035b95f7a2b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    blue: {
        "id": "dashboard-common.blue",
        "defaultMessage": "Blue"
    },
    red: {
        "id": "dashboard-common.red",
        "defaultMessage": "Red"
    },
    yellow: {
        "id": "dashboard-common.yellow",
        "defaultMessage": "Yellow"
    },
    green: {
        "id": "dashboard-common.green",
        "defaultMessage": "Green"
    },
    teal: {
        "id": "dashboard-common.teal",
        "defaultMessage": "Teal"
    },
    purple: {
        "id": "dashboard-common.purple",
        "defaultMessage": "Purple"
    },
    gray: {
        "id": "dashboard-common.gray",
        "defaultMessage": "Gray"
    },
    white: {
        "id": "dashboard-common.white",
        "defaultMessage": "White"
    }
});

});



const $fd22ea3140eeb833$export$ca03ff6cc792cc16 = 'DASHBOARD_CONFIG_AND_WRM';
const $fd22ea3140eeb833$export$e239393fd4e2bc85 = 'DASHBOARD_AMD_MODULES';
const $fd22ea3140eeb833$export$9e5db01432b13b67 = 'DASHBOARD_REACT_GADGETS';
const $fd22ea3140eeb833$export$bce41807cc929d0f = 'DASHBOARD_FORGE';
const $fd22ea3140eeb833$export$c07a25ebb6af1e84 = 'DASHBOARD_GADGET_DIRECTORY';

parcelRegister("3qYSS", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dacccd1f2016ac0$export$2e2bcd8739ae039);

var $a8PVz = parcelRequire("a8PVz");

var $E0qsj = parcelRequire("E0qsj");

var $ljFr2 = parcelRequire("ljFr2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2dacccd1f2016ac0$export$2e2bcd8739ae039 = (_maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch })=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $E0qsj.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { moduleNames: moduleNames, isPreloaded: isPreloaded } = sharedValue;
            const maybePromiseAmdModules = isPreloaded || await (0, $ljFr2.loadAmdModules)((0, $a8PVz.asyncWrmRequire), moduleNames) ? (0, $ljFr2.evalAmdModules)(moduleNames) : null;
            const amdModules = maybePromiseAmdModules instanceof Promise ? await maybePromiseAmdModules : maybePromiseAmdModules;
            return {
                sharedValue: sharedValue,
                amdModules: amdModules
            };
        })();
    };

});
parcelRegister("a8PVz", function(module, exports) {

$parcel$export(module.exports, "asyncWrmRequire", () => $9aefac71b25b50c0$export$1024fe099ca05f05);
$parcel$export(module.exports, "asyncWrmRequireWithPrefetch", () => $9aefac71b25b50c0$export$3ca0de203efa570e);
/* eslint-disable jira/wrm/no-load-bridge */ 
var $ligZL = parcelRequire("ligZL");
var $jb3ni = parcelRequire("jb3ni");
const $9aefac71b25b50c0$export$1024fe099ca05f05 = (resourcesToRequire)=>(0, $ligZL.wrmRequire)(resourcesToRequire);
const $9aefac71b25b50c0$export$3ca0de203efa570e = (resourcesToRequire, batchUrl)=>(0, $jb3ni.wrmRequireWithPrefetch)(resourcesToRequire, batchUrl);

});

parcelRegister("ljFr2", function(module, exports) {

$parcel$export(module.exports, "loadAmdModules", () => $0ebb29f40170e1c7$export$2c79895bd69a8d54);
$parcel$export(module.exports, "evalAmdModules", () => $0ebb29f40170e1c7$export$d74eab33af9baaea);

var $eSnSE = parcelRequire("eSnSE");

var $iluXv = parcelRequire("iluXv");
/**
 * Dummy implementation for a Connect gadget, as rendering and editing are
 * managed externally.
 */ class $0ebb29f40170e1c7$var$ConnectDashboardItem {
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    render() {}
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    renderEdit() {}
}
const $0ebb29f40170e1c7$export$3bf37adbbdcafcc8 = (moduleName, retries = 5)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (typeof window.require !== 'function') throw new TypeError('window.require is not a function');
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.require(moduleName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // amd module could throw a non-Error
        if (error instanceof Error && /^No \S+$|^\S+ missing \S+$/.test(error.message)) {
            // some AMD modules have define() inside a require() block in which case the module is not immediately ready to be window.require()'d
            // this is due to the 4ms timeout in requirejs' require(), we need a retry logic here to make sure the module is loaded.
            // see the comment section for https://jdog.jira-dev.com/browse/WRM-71
            if (retries > 0) return new Promise((r)=>setTimeout(r, 100)).then(()=>$0ebb29f40170e1c7$export$3bf37adbbdcafcc8(moduleName, retries - 1));
        }
        throw error;
    }
};
const $0ebb29f40170e1c7$export$2c79895bd69a8d54 = async (wrmRequire, moduleNames)=>{
    if (moduleNames.length === 0) return false;
    const prefixedAmdResources = moduleNames.map((amdModule)=>(0, $iluXv.WEB_RESOURCE_MAP)[amdModule]).map((resourceName)=>`wrc!${resourceName}`);
    try {
        // no result from the promise only the side effect of having loaded the AMD module via WRM
        await wrmRequire(prefixedAmdResources);
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.resource', `Failed to load web resources [${prefixedAmdResources.join(',')}]`, error);
        return false;
    }
};
const $0ebb29f40170e1c7$var$getSortedModuleNamesFromTuples = (tuples)=>tuples.map(([moduleName])=>moduleName).sort((a, b)=>a.localeCompare(b)).join(',');
const $0ebb29f40170e1c7$export$d74eab33af9baaea = (amdModuleNames)=>{
    const tuplesOrPromises = amdModuleNames.map((amdModuleName)=>{
        try {
            const module = amdModuleName === (0, $iluXv.CONNECT_ITEM_AMD_MODULE) ? $0ebb29f40170e1c7$var$ConnectDashboardItem : $0ebb29f40170e1c7$export$3bf37adbbdcafcc8(amdModuleName);
            return module instanceof Promise ? module.then((v)=>[
                    amdModuleName,
                    v
                ]) : [
                amdModuleName,
                module
            ];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return Promise.reject(error);
        }
    });
    const hasPromise = tuplesOrPromises.some((entry)=>entry instanceof Promise);
    if (!hasPromise) {
        (0, $eSnSE.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful synchronous bulk eval AMD modules');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Object.fromEntries(tuplesOrPromises);
    }
    return Promise.allSettled(tuplesOrPromises).then((results)=>{
        const tuples = results.map((result, i)=>{
            if (result.status === 'fulfilled') return result.value;
            const { reason: error } = result;
            const amdModuleName = amdModuleNames[i];
            const message = error instanceof Error ? error.message : String(error);
            (0, $eSnSE.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD module [${amdModuleName}] with error [${message}]`, error);
            return [
                amdModuleName,
                null
            ];
        });
        const failedTuples = tuples.filter((module)=>module[1] === null);
        failedTuples.length > 0 ? (0, $eSnSE.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD modules [${$0ebb29f40170e1c7$var$getSortedModuleNamesFromTuples(failedTuples)}]`) : (0, $eSnSE.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful asynchronous bulk eval AMD modules');
        return Object.fromEntries(tuples);
    });
};

});


parcelRegister("lQtHx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe7193624272bdef$export$2e2bcd8739ae039);

var $7DwRl = parcelRequire("7DwRl");

var $eSnSE = parcelRequire("eSnSE");

var $7rykd = parcelRequire("7rykd");

var $l1whs = parcelRequire("l1whs");

var $dnNPa = parcelRequire("dnNPa");

var $i6ThV = parcelRequire("i6ThV");

var $hElUD = parcelRequire("hElUD");

var $fxH8d = parcelRequire("fxH8d");
const $fe7193624272bdef$var$generateScriptTagAndPreloadedModuleNames = async (configs)=>{
    const gadgets = configs.flatMap((config)=>config.gadgets);
    const preloadedModuleNames = (0, $fxH8d.gadgetsToUniqueSortedAmdModules)(gadgets);
    const wrmBundleDescriptor = await (0, $l1whs.default)(preloadedModuleNames);
    return configs.map((config)=>{
        const scriptTags = [
            wrmBundleDescriptor ? (0, $i6ThV.default)(wrmBundleDescriptor) : null,
            (0, $dnNPa.default)(config)
        ].filter(Boolean).join('\n') || null;
        return {
            ...config,
            scriptTags: scriptTags,
            preloadedModuleNames: preloadedModuleNames
        };
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe7193624272bdef$export$2e2bcd8739ae039 = async (context)=>{
    // this is either for single dashboard/wallboard or wallboard slide show with multiple dashboards
    try {
        const { route: route, query: query } = context;
        const originalConfigs = route.name === 'dashboard-wallboard' ? await (0, $7rykd.getDashboardsConfig)(query.dashboardId) : [
            await (0, $7rykd.default)((0, $hElUD.getKey)(context))
        ];
        const configs = originalConfigs.map((config)=>({
                ...config,
                gadgets: (0, $7DwRl.mapToReactGadgets)(config.gadgets)
            }));
        if (!false) return configs.map((config)=>({
                ...config,
                preloadedModuleNames: []
            }));
        return $fe7193624272bdef$var$generateScriptTagAndPreloadedModuleNames(configs);
    } catch (error) {
        (0, $eSnSE.default).unsafeErrorWithCustomerData('spa-apps.dashboard.get-config-and-wrm-data', `Failed to get dashboard configuration and wrm data: route=[${context.route.name}], query=[${JSON.stringify(context.query)}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};

});
parcelRegister("7DwRl", function(module, exports) {

$parcel$export(module.exports, "mapToReactGadgets", () => $70e6ea57c1c19022$export$c90615c5eb218d50);

var $7jTnu = parcelRequire("7jTnu");
const $70e6ea57c1c19022$export$c90615c5eb218d50 = (gadgets)=>{
    const gadgetMapping = {
        ...(0, $7jTnu.fg)('endeavour_nin_filter_results_gadget') ? {
            'jira-dashboard-items/filter-results': 'react/filter-results'
        } : {},
        'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'react/custom-report',
        ...(0, $7jTnu.fg)('endeavour_nin_assigned_to_me_gadget') ? {
            'jira-dashboard-items/assigned-to-me': 'react/assigned-to-me'
        } : {},
        ...(0, $7jTnu.fg)('endeavour_nin_issues_in_progress_gadget') ? {
            'jira-dashboard-items/in-progress': 'react/issues-in-progress'
        } : {},
        ...(0, $7jTnu.fg)('endeavour_nin_voted_issues_gadget') ? {
            'jira-dashboard-items/voted': 'react/voted-issues'
        } : {},
        ...(0, $7jTnu.fg)('endeavour_nin_watched_issues_gadget') ? {
            'jira-dashboard-items/watched': 'react/watched-issues'
        } : {}
    }; // satisfies Record<string, ReactKey>; SSR image build Thread Loader doesn't understand 'satisfies'
    const isMapped = (module)=>module !== undefined && module in gadgetMapping;
    return gadgets.map((gadget)=>{
        if (isMapped(gadget.amdModule)) return {
            ...gadget,
            reactKey: gadgetMapping[gadget.amdModule],
            amdModule: undefined,
            configurable: false,
            inlineHtml: undefined
        };
        return gadget;
    });
};

});

parcelRegister("7rykd", function(module, exports) {

$parcel$export(module.exports, "default", () => $db5ea9750860430f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getDashboardsConfig", () => $db5ea9750860430f$export$1264b6af3adf5084);

var $1Ozm9 = parcelRequire("1Ozm9");

var $eSnSE = parcelRequire("eSnSE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$db5ea9750860430f$export$2e2bcd8739ae039 = async (id)=>{
    try {
        return (0, $1Ozm9.default)(`/rest/dashboards/1.0/${id}.json`);
    } catch (error) {
        (0, $eSnSE.default).unsafeErrorWithCustomerData('spa-apps.dashboard.fetch-dashboard-config', `Failed to get dashboard config json with id=[${id}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};
const $db5ea9750860430f$export$1264b6af3adf5084 = async (idsCsv)=>{
    try {
        return (0, $1Ozm9.default)(`/rest/dashboards/1.0?dashboardId=${idsCsv}`);
    } catch (error) {
        (0, $eSnSE.default).unsafeErrorWithCustomerData('spa-apps.dashboard.fetch-dashboard-config', `Failed to get dashboard config with ids=[${idsCsv}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};

});

parcelRegister("l1whs", function(module, exports) {

$parcel$export(module.exports, "default", () => $28a7b496d07a93d7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $iluXv = parcelRequire("iluXv");

var $1Ozm9 = parcelRequire("1Ozm9");

var $eSnSE = parcelRequire("eSnSE");
const $28a7b496d07a93d7$var$CRITICAL_DEPENDENCIES = [
    'jira.webresources:util',
    'jira.webresources:feature-flags',
    'com.atlassian.jira.jira-atlaskit-plugin:overrides-general'
];
const $28a7b496d07a93d7$var$JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$28a7b496d07a93d7$export$2e2bcd8739ae039 = async (moduleNames)=>{
    if (moduleNames.length === 0) return Promise.resolve(null);
    const contextsToRequire = moduleNames.map((amdModule)=>(0, $iluXv.WEB_RESOURCE_MAP)[amdModule]);
    const payload = {
        r: [],
        c: [
            ...$28a7b496d07a93d7$var$CRITICAL_DEPENDENCIES,
            ...contextsToRequire
        ],
        xc: [
            $28a7b496d07a93d7$var$JIRA_HERITAGE_CRITICAL_BATCH
        ],
        xr: []
    };
    try {
        return (0, $1Ozm9.default)('/rest/webResources/1.0/resources?operation=FetchWRMData', {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    } catch (error) {
        (0, $eSnSE.default).unsafeErrorWithCustomerData('spa-apps.dashboard.wrm-bundle-descriptor', `Failed to fetch wrm bundle with contexts [${contextsToRequire.join(',')}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};

});

parcelRegister("dnNPa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a5f13865e07cedd$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $iluXv = parcelRequire("iluXv");

var $dI81q = parcelRequire("dI81q");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3a5f13865e07cedd$export$2e2bcd8739ae039 = (dashboardConfig)=>{
    if (dashboardConfig.gadgets.length === 0) return null;
    const prefetches = (0, $dI81q.getPrefetches)(dashboardConfig);
    const preloadLinks = prefetches.map((prefetch)=>`<link rel="preload" as="fetch" href="${prefetch.url}" crossorigin="anonymous" />`).join('\n') || null;
    const syncPrefetchUrls = prefetches.filter((prefetch)=>prefetch.isSyncLoadingSupported()).map((prefetch)=>prefetch.url);
    if (preloadLinks != null && syncPrefetchUrls.length > 0) {
        const fetchScript = `
            <script type="text/javascript" data-defer-skip>
                const preloadUrls = ${JSON.stringify(syncPrefetchUrls)};
                window['${(0, $iluXv.PRELOADED_GADGET_DATA_KEY)}'] = {};

                preloadUrls.forEach((preloadUrl) => {
                    fetch(preloadUrl)
                        .then(res => res.json())
                        .then(data => {
                            window['${(0, $iluXv.PRELOADED_GADGET_DATA_KEY)}'][preloadUrl] = data;
                        });
                });
            </script>
        `;
        return preloadLinks + fetchScript;
    }
    return preloadLinks;
};

});
parcelRegister("dI81q", function(module, exports) {

$parcel$export(module.exports, "getPrefetches", () => $3131787f134a9e3e$export$3144db3718ad5e57);

var $cA5jK = parcelRequire("cA5jK");
const $3131787f134a9e3e$export$3144db3718ad5e57 = ({ gadgets: gadgets })=>{
    const lookup = (0, $cA5jK.getPrefetchDict)();
    return gadgets.flatMap((gadget)=>{
        const identifier = gadget.amdModule;
        const prefechProp = identifier != null ? lookup[identifier] : undefined;
        if (!prefechProp || !prefechProp.enabled) return [];
        const { func: func, priority: priority, isSyncLoadingSupported: isSyncLoadingSupported } = prefechProp;
        return func(gadget).map((url)=>({
                url: url,
                priority: priority,
                isSyncLoadingSupported: isSyncLoadingSupported
            }));
    });
};

});
parcelRegister("cA5jK", function(module, exports) {

$parcel$export(module.exports, "getPrefetchDict", () => $249224b7a18d3fb6$export$244cea94cab19e07);

var $7jTnu = parcelRequire("7jTnu");

var $dJT4y = parcelRequire("dJT4y");

var $ehfMg = parcelRequire("ehfMg");

var $9bbm9 = parcelRequire("9bbm9");
const $249224b7a18d3fb6$export$244cea94cab19e07 = ()=>({
        'jira-dashboard-items/activitystream': {
            func: (0, $ehfMg.getActivityStreamPrefetchLink),
            priority: (0, $dJT4y.LOADING_PRIORITY).HIGH,
            enabled: true,
            isSyncLoadingSupported: ()=>false
        },
        'jira-dashboard-items/filter-results': {
            func: (0, $9bbm9.getFilterResultsPrefetchLink),
            priority: (0, $dJT4y.LOADING_PRIORITY).LOW,
            enabled: !(0, $7jTnu.fg)('endeavour_nin_filter_results_gadget'),
            isSyncLoadingSupported: ()=>true
        }
    });

});
parcelRegister("dJT4y", function(module, exports) {

$parcel$export(module.exports, "LOADING_PRIORITY", () => $23c62257b27bbbf0$export$cb9b1f2232733c1b);
const $23c62257b27bbbf0$export$cb9b1f2232733c1b = {
    HIGH: 'preload',
    LOW: 'prefetch'
};

});

parcelRegister("ehfMg", function(module, exports) {

$parcel$export(module.exports, "getActivityStreamPrefetchLink", () => $76ab8a67f710df71$export$360928f5bf059a9e);

var $b5RwB = parcelRequire("b5RwB");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $76ab8a67f710df71$var$replacer = (match, part1)=>String.fromCharCode(part1);
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#63-81
// @ts-expect-error - TS7006 - Parameter 'operatorLower' implicitly has an 'any' type.
const $76ab8a67f710df71$var$getDateValue = (dateValue, operatorLower)=>{
    // make sure we're dealing with a string so we can use indexOf and split without errors
    const dateStr = `${dateValue}`;
    const operator = operatorLower.toUpperCase();
    let dateArr;
    if (dateStr.indexOf(' ') !== -1) dateArr = dateStr.split(' ');
    else if (operator === 'BETWEEN') dateArr = [
        dateValue,
        dateValue
    ];
    else dateArr = [
        dateValue
    ];
    return dateArr.map((date, index)=>{
        // make sure we're adding numbers and not concatenating strings
        const dateInt = parseInt(date, 10);
        if (operator === 'AFTER' || operator === 'BETWEEN' && index === 1) return dateInt + 86400000 - 1; // Add 23 hours, 59 minutes, 59 seconds to get to end of day
        return dateInt;
    }).join(' ');
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#20
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $76ab8a67f710df71$var$handleSpecialCases = (rule)=>{
    let { value: value, operator: operator } = rule;
    const { type: type } = rule;
    if (Array.isArray(value)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const encodedValues = [];
        value.forEach((val)=>{
            // additional level of encoding for spaces because otherwise the spaces
            // will be mistaken for value delimiters (STRM-1857); escape space as "_"
            // and escape any existing "_" as "\_"
            encodedValues.push(val.replace(/_/g, '\\_').replace(/ /g, '_'));
        });
        value = encodedValues.join(' ');
    }
    if (type === 'date') {
        if (operator === 'is') // back end doesn't support "IS", we have to turn it into a between
        operator = 'between';
        value = $76ab8a67f710df71$var$getDateValue(value, operator);
        // We had some problems getting the date values
        // Return empty rule so it won't be included
        if (value.indexOf('NaN') !== -1) return {};
    } else if (type === 'list' || type === 'user') {
        // allow comma-separated values (in addition to space separated) for issue keys and usernames
        value = value.replace(/,/g, ' ');
        // escape underscores as "\_" (because "_" is used to escape spaces in lists)
        value = value.replace(/_/g, '\\_');
    }
    return {
        value: value,
        operator: operator
    };
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#651-683
const $76ab8a67f710df71$var$getParamsFromRules = (rules)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const params = {};
    const providers = JSON.parse(decodeURIComponent(rules.replace(/&#([0-9]+);/g, $76ab8a67f710df71$var$replacer)))?.providers || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const enabledProviders = [];
    // @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    providers.forEach((provider)=>{
        const providerKey = provider.provider;
        const { rules: providerRules } = provider;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stringifiedRules = [];
        if (!provider.disabled) {
            if (providerKey !== 'streams') enabledProviders.push(providerKey);
            // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
            providerRules.forEach((rule)=>{
                const modifiedRuleObj = $76ab8a67f710df71$var$handleSpecialCases(rule);
                const { operator: operator, value: value } = modifiedRuleObj;
                if (operator && value) stringifiedRules.push([
                    rule.rule,
                    operator.toUpperCase(),
                    value
                ].join(' '));
            });
            params[providerKey] = stringifiedRules;
        }
    });
    if (enabledProviders.length < providers.length - 1) params.providers = enabledProviders.join(' ');
    return params;
};
const $76ab8a67f710df71$export$3d7deb7cf8a9de04 = (gadget)=>{
    const prefs = Object.fromEntries(gadget.userPrefs?.fields.map((field)=>[
            field.name,
            field.value
        ]) ?? []);
    const params = {
        maxResults: prefs.numofentries ?? 25,
        relativeLinks: true,
        ...prefs.rules ? $76ab8a67f710df71$var$getParamsFromRules(prefs.rules) : {}
    };
    // Gadget encodes spaces as '+', rather than '%20'.  Need to replace here to match URL exactly.
    return (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(params).replace(/%20/g, '+');
};
const $76ab8a67f710df71$var$ACTIVITY_STREAM_REST_URL = 'plugins/servlet/streams';
const $76ab8a67f710df71$export$360928f5bf059a9e = (gadgetData)=>{
    const paramStr = $76ab8a67f710df71$export$3d7deb7cf8a9de04(gadgetData);
    return [
        `/${$76ab8a67f710df71$var$ACTIVITY_STREAM_REST_URL}?${paramStr}`
    ];
};

});

parcelRegister("9bbm9", function(module, exports) {

$parcel$export(module.exports, "getFilterResultsPrefetchLink", () => $f18556a61bfce23a$export$947cd90004054337);

var $b5RwB = parcelRequire("b5RwB");
const $f18556a61bfce23a$var$FILTER_RESULTS_REST_URL = 'rest/gadget/1.0/issueTable';
const $f18556a61bfce23a$export$947cd90004054337 = (gadgetData)=>{
    const { properties: properties } = gadgetData.context.dashboardItem;
    const data = {
        num: properties.num,
        tableContext: 'jira.table.cols.dashboard',
        addDefault: false,
        columnNames: typeof properties.columnNames === 'string' ? properties.columnNames.split('|') : undefined,
        enableSorting: true,
        paging: true,
        showActions: true,
        filterId: undefined,
        jql: undefined,
        sortBy: String(properties.sortBy && properties.sortBy !== '' ? properties.sortBy : null),
        startIndex: properties.startIndex ? properties.startIndex : 0
    };
    let queryType = '';
    if (properties.filterId) {
        queryType = 'filter';
        Object.assign(data, {
            filterId: properties.filterId
        });
    } else if (properties.jql) {
        queryType = 'jql';
        Object.assign(data, {
            jql: properties.jql
        });
    }
    // IMPORTANT - type definitions are incorrect, sort is definitely an option
    // @see https://www.npmjs.com/package/query-string/v/5.1.0
    // @ts-expect-error - TS2345 - Argument of type '{ sort: boolean; }' is not assignable to parameter of type 'StringifyOptions'.
    const paramStr = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(data, {
        sort: false
    }).replace(/%20/g, '+');
    const preloadUrl = `/${$f18556a61bfce23a$var$FILTER_RESULTS_REST_URL}/${queryType}?${paramStr}`;
    return [
        preloadUrl
    ];
};

});




parcelRegister("i6ThV", function(module, exports) {

$parcel$export(module.exports, "default", () => $53883be98866e9a2$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$53883be98866e9a2$export$2e2bcd8739ae039 = (response)=>{
    let resourceHtml = `
        <script type="text/javascript" data-defer-skip>
            window.WRM=window.WRM||{};window.WRM._unparsedData=window.WRM._unparsedData||{};window.WRM._unparsedErrors=window.WRM._unparsedErrors||{};
            WRM._unparsedData = Object.assign({}, WRM._unparsedData, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedData))}));
            WRM._unparsedErrors = Object.assign({}, WRM._unparsedErrors, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedErrors))}));
            if(window.WRM._dataArrived)window.WRM._dataArrived();
        </script>
    `;
    response.resources.forEach((resource)=>{
        const { url: url, resourceType: resourceType, key: key } = resource;
        if (resourceType === 'CSS') {
            const cssResource = `<link
                href=${url}
                type="text/css"
                rel="stylesheet"
                media="all"
                data-wrm-key=${key}
                data-wrm-batch-type="context"
            />`;
            resourceHtml += cssResource;
        } else {
            const jsResource = `<div>
                <script
                    type="text/javascript"
                    data-initially-rendered
                    data-defer-skip
                    src=${url}
                    data-wrm-key=${key}
                    data-wrm-batch-type="context"
                ></script>
            </div>`;
            resourceHtml += jsResource;
        }
    });
    return resourceHtml;
};

});

parcelRegister("fxH8d", function(module, exports) {

$parcel$export(module.exports, "gadgetsToUniqueSortedAmdModules", () => $327bd7a3fadeaf27$export$598e0ea2a7525181);
$parcel$export(module.exports, "gadgetsToSortedReactGadgets", () => $327bd7a3fadeaf27$export$f98787198c197952);
// eslint-disable-next-line jira/import-whitelist

var $iluXv = parcelRequire("iluXv");

var $8MjsA = parcelRequire("8MjsA");
const $327bd7a3fadeaf27$export$598e0ea2a7525181 = (gadgets)=>gadgets // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .map(({ amdModule: amdModule })=>amdModule) // validated below
    .filter(Boolean).filter((amdModule)=>amdModule in (0, $iluXv.WEB_RESOURCE_MAP)).filter((v, i, a)=>a.indexOf(v) === i).sort() ?? [];
const $327bd7a3fadeaf27$export$f98787198c197952 = (gadgets)=>gadgets.reduce((gadgetsAccumulator, gadget)=>{
        if (!(0, $8MjsA.isReactKey)(gadget.reactKey)) return gadgetsAccumulator;
        gadgetsAccumulator.push({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            reactKey: gadget.reactKey,
            id: gadget.id,
            userPrefs: gadget.userPrefs
        });
        return gadgetsAccumulator;
    }, []).sort((a, b)=>a.id.localeCompare(b.id));

});
parcelRegister("8MjsA", function(module, exports) {

$parcel$export(module.exports, "isReactKey", () => $52b83e6aaadc4f03$export$6acd06c99f745b49);
$parcel$export(module.exports, "default", () => $52b83e6aaadc4f03$export$2e2bcd8739ae039);

var $17XsP = parcelRequire("17XsP");

var $4A8Tm = parcelRequire("4A8Tm");

var $8ospY = parcelRequire("8ospY");
/** This is a gadgets definition file.  */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $52b83e6aaadc4f03$var$GADGETS_DEFINITION = {
    [(0, $8ospY.REACT_KEY).FILTER_RESULTS]: (0, $4A8Tm.FILTER_RESULTS_DEFINITION),
    [(0, $8ospY.REACT_KEY).ASSIGNED_TO_ME]: (0, $4A8Tm.ASSIGNED_TO_ME_DEFINITION),
    [(0, $8ospY.REACT_KEY).ISSUES_IN_PROGRESS]: (0, $4A8Tm.ISSUES_IN_PROGRESS_DEFINITION),
    [(0, $8ospY.REACT_KEY).VOTED_ISSUES]: (0, $4A8Tm.VOTED_ISSUES_DEFINITION),
    [(0, $8ospY.REACT_KEY).WATCHED_ISSUES]: (0, $4A8Tm.WATCHED_ISSUES_DEFINITION),
    [(0, $8ospY.REACT_KEY).CUSTOM_REPORT]: (0, $17XsP.default)
};
function $52b83e6aaadc4f03$export$6acd06c99f745b49(key) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return !!(key && Object.values((0, $8ospY.REACT_KEY)).includes(key));
}
var $52b83e6aaadc4f03$export$2e2bcd8739ae039 = $52b83e6aaadc4f03$var$GADGETS_DEFINITION;

});
parcelRegister("17XsP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ba03e9ae9cfb516$export$2e2bcd8739ae039);

var $lwRcY = parcelRequire("lwRcY");

var $2qfPu = parcelRequire("2qfPu");

var $hLUwd = parcelRequire("hLUwd");
const $5ba03e9ae9cfb516$var$CUSTOM_REPORT_DEFINITION = {
    componentView: (0, $2qfPu.LazyCustomReportGadgetView),
    componentEdit: (0, $lwRcY.LazyCustomReportGadgetEdit),
    getInitialState: $hLUwd.default,
    preload: $2qfPu.preload
};
var $5ba03e9ae9cfb516$export$2e2bcd8739ae039 = $5ba03e9ae9cfb516$var$CUSTOM_REPORT_DEFINITION;

});
parcelRegister("lwRcY", function(module, exports) {

$parcel$export(module.exports, "LazyCustomReportGadgetEdit", () => $9c98ae885e285cdb$export$475e4a6fb8f40116);

var $gzcjr = parcelRequire("gzcjr");

const $9c98ae885e285cdb$export$475e4a6fb8f40116 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("3Dv56")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/edit/main.tsx"
});

});
parcelRegister("3Dv56", function(module, exports) {

let $2a5d1fb8ee78f7d7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2a5d1fb8ee78f7d7$var$load("4Rs7R").then(()=>parcelRequire('1lUBb'));

});


parcelRegister("2qfPu", function(module, exports) {

$parcel$export(module.exports, "LazyCustomReportGadgetView", () => $9dbbbd3c17549925$export$27df795d4f3ff173);
$parcel$export(module.exports, "preload", () => $9dbbbd3c17549925$export$513ccb98c53b8039);

var $gzcjr = parcelRequire("gzcjr");

const $9dbbbd3c17549925$export$27df795d4f3ff173 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("kD6KV")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/view/main.tsx"
});
const { preload: $9dbbbd3c17549925$export$513ccb98c53b8039 } = $9dbbbd3c17549925$export$27df795d4f3ff173;

});
parcelRegister("kD6KV", function(module, exports) {

let $f04cb0b8f920fd70$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f04cb0b8f920fd70$var$load("bBz9L").then(()=>parcelRequire('TOAHd'));

});


parcelRegister("hLUwd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6705b5a7e1c76b7$export$2e2bcd8739ae039);
const $f6705b5a7e1c76b7$var$getInitialState = ()=>Promise.resolve({
        intervalValue: '1',
        isCustom: 'false',
        projectValue: '0',
        refresh: 'false',
        reportValue: '0',
        gadgetContentTitle: ''
    });
var $f6705b5a7e1c76b7$export$2e2bcd8739ae039 = $f6705b5a7e1c76b7$var$getInitialState;

});


parcelRegister("4A8Tm", function(module, exports) {

$parcel$export(module.exports, "FILTER_RESULTS_DEFINITION", () => $6dcd4e956050d432$export$3581891d04da6bb8);
$parcel$export(module.exports, "ASSIGNED_TO_ME_DEFINITION", () => $6dcd4e956050d432$export$652d5a9cc2c18d2e);
$parcel$export(module.exports, "ISSUES_IN_PROGRESS_DEFINITION", () => $6dcd4e956050d432$export$54b46348d1ed5d22);
$parcel$export(module.exports, "VOTED_ISSUES_DEFINITION", () => $6dcd4e956050d432$export$ea96ce30d34ce354);
$parcel$export(module.exports, "WATCHED_ISSUES_DEFINITION", () => $6dcd4e956050d432$export$5109728db227eae);

var $eJOHy = parcelRequire("eJOHy");

var $3MbRU = parcelRequire("3MbRU");

var $8G0iN = parcelRequire("8G0iN");

var $ixr5d = parcelRequire("ixr5d");

var $92GBg = parcelRequire("92GBg");

var $bz1Gz = parcelRequire("bz1Gz");

var $gVMtN = parcelRequire("gVMtN");

var $i222u = parcelRequire("i222u");
const $6dcd4e956050d432$var$componentViewWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $6dcd4e956050d432$var$componentEditWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $6dcd4e956050d432$var$FILTER_RESULTS_CONFIG = {
    testId: 'react-issue-table-gadgets.filter-results.view'
};
const $6dcd4e956050d432$export$3581891d04da6bb8 = {
    componentView: $6dcd4e956050d432$var$componentViewWithAdditionalState((0, $92GBg.IssueTableGadgetView), $6dcd4e956050d432$var$FILTER_RESULTS_CONFIG),
    componentEdit: (0, $8G0iN.FilterResultsGadgetEdit),
    getInitialState: (0, $i222u.default)($6dcd4e956050d432$var$FILTER_RESULTS_CONFIG),
    preload: (0, $92GBg.preload)
};
const $6dcd4e956050d432$var$ASSIGNED_TO_ME_CONFIG = {
    predeterminedJql: 'assignee = currentUser() AND statusCategory != 3 ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.assigned-to-me.view'
};
const $6dcd4e956050d432$export$652d5a9cc2c18d2e = {
    componentView: $6dcd4e956050d432$var$componentViewWithAdditionalState((0, $92GBg.IssueTableGadgetView), $6dcd4e956050d432$var$ASSIGNED_TO_ME_CONFIG),
    componentEdit: $6dcd4e956050d432$var$componentEditWithAdditionalState((0, $3MbRU.AssignedToMeGadgetEdit), $6dcd4e956050d432$var$ASSIGNED_TO_ME_CONFIG),
    getInitialState: (0, $i222u.default)($6dcd4e956050d432$var$ASSIGNED_TO_ME_CONFIG),
    preload: (0, $92GBg.preload)
};
const $6dcd4e956050d432$var$ISSUES_IN_PROGRESS_CONFIG = {
    predeterminedJql: 'status = "In Progress" AND statusCategory != Done AND assignee = currentUser() ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.issues-in-progress.view'
};
const $6dcd4e956050d432$export$54b46348d1ed5d22 = {
    componentView: $6dcd4e956050d432$var$componentViewWithAdditionalState((0, $92GBg.IssueTableGadgetView), $6dcd4e956050d432$var$ISSUES_IN_PROGRESS_CONFIG),
    componentEdit: $6dcd4e956050d432$var$componentEditWithAdditionalState((0, $ixr5d.IssuesInProgressGadgetEdit), $6dcd4e956050d432$var$ISSUES_IN_PROGRESS_CONFIG),
    getInitialState: (0, $i222u.default)($6dcd4e956050d432$var$ISSUES_IN_PROGRESS_CONFIG),
    preload: (0, $92GBg.preload)
};
const $6dcd4e956050d432$var$VOTED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in votedIssues() AND statusCategory != Done ORDER BY votes DESC',
    predeterminedJqlIncludeResolved: 'issue in votedIssues() ORDER BY votes DESC',
    defaultSortPrefs: {
        field: 'votes',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.voted-issues.view'
};
const $6dcd4e956050d432$export$ea96ce30d34ce354 = {
    componentView: $6dcd4e956050d432$var$componentViewWithAdditionalState((0, $92GBg.IssueTableGadgetView), $6dcd4e956050d432$var$VOTED_ISSUES_CONFIG),
    componentEdit: $6dcd4e956050d432$var$componentEditWithAdditionalState((0, $bz1Gz.VotedIssuesGadgetEdit), $6dcd4e956050d432$var$VOTED_ISSUES_CONFIG),
    getInitialState: (0, $i222u.default)($6dcd4e956050d432$var$VOTED_ISSUES_CONFIG),
    preload: (0, $92GBg.preload)
};
const $6dcd4e956050d432$var$WATCHED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in watchedIssues() AND statusCategory != Done ORDER BY watchers DESC',
    predeterminedJqlIncludeResolved: 'issue in watchedIssues() ORDER BY watchers DESC',
    defaultSortPrefs: {
        field: 'watchers',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.watched-issues.view'
};
const $6dcd4e956050d432$export$5109728db227eae = {
    componentView: $6dcd4e956050d432$var$componentViewWithAdditionalState((0, $92GBg.IssueTableGadgetView), $6dcd4e956050d432$var$WATCHED_ISSUES_CONFIG),
    componentEdit: $6dcd4e956050d432$var$componentEditWithAdditionalState((0, $gVMtN.WatchedIssuesGadgetEdit), $6dcd4e956050d432$var$WATCHED_ISSUES_CONFIG),
    getInitialState: (0, $i222u.default)($6dcd4e956050d432$var$WATCHED_ISSUES_CONFIG),
    preload: (0, $92GBg.preload)
};

});
parcelRegister("3MbRU", function(module, exports) {

$parcel$export(module.exports, "AssignedToMeGadgetEdit", () => $0df2d23261b9fc3e$export$3ae3568d16dc8f35);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $kSxjd = parcelRequire("kSxjd");

var $gzcjr = parcelRequire("gzcjr");

const $0df2d23261b9fc3e$var$LazyAssignedToMeGadgetEdit = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("2l4Fk")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/assigned-to-me/edit/main.tsx"
});
const $0df2d23261b9fc3e$export$3ae3568d16dc8f35 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "assigned-to-me-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kSxjd.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0df2d23261b9fc3e$var$LazyAssignedToMeGadgetEdit, props));
const { preload: $0df2d23261b9fc3e$export$513ccb98c53b8039 } = $0df2d23261b9fc3e$var$LazyAssignedToMeGadgetEdit;

});
parcelRegister("kSxjd", function(module, exports) {

$parcel$export(module.exports, "FilterResultsEditSkeleton", () => $9975e76ceee590cb$export$e10d91ce257e7374);
/* filter-results-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $gImlD = parcelRequire("gImlD");
const $9975e76ceee590cb$var$customCssStyles = null;
const $9975e76ceee590cb$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT = '698px';
const $9975e76ceee590cb$export$e10d91ce257e7374 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gImlD))),
        containerStyles: {
            height: $9975e76ceee590cb$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT
        },
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("gImlD", function(module, exports) {
module.exports = new URL("filter-results-edit-skeleton.tpl.783fb7b7.svg", import.meta.url).toString();

});


parcelRegister("2l4Fk", function(module, exports) {

let $1b412969c467315d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1b412969c467315d$var$load("1VRB2"),
    $1b412969c467315d$var$load("bABhq"),
    $1b412969c467315d$var$load("eDzss"),
    $1b412969c467315d$var$load("poELQ")
]).then(()=>parcelRequire('hizmQ'));

});


parcelRegister("8G0iN", function(module, exports) {

$parcel$export(module.exports, "FilterResultsGadgetEdit", () => $58603643e09663c6$export$6dfceca003c43832);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $kSxjd = parcelRequire("kSxjd");

var $gzcjr = parcelRequire("gzcjr");

const $58603643e09663c6$var$LazyFilterResultsGadgetEdit = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("hpUrQ")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/filter-results/edit/main.tsx"
});
const $58603643e09663c6$export$6dfceca003c43832 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "filter-results-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kSxjd.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58603643e09663c6$var$LazyFilterResultsGadgetEdit, props));
const { preload: $58603643e09663c6$export$513ccb98c53b8039 } = $58603643e09663c6$var$LazyFilterResultsGadgetEdit;

});
parcelRegister("hpUrQ", function(module, exports) {

let $cae08edda56c8391$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $cae08edda56c8391$var$load("1VRB2"),
    $cae08edda56c8391$var$load("bABhq"),
    $cae08edda56c8391$var$load("eDzss"),
    $cae08edda56c8391$var$load("395pz")
]).then(()=>parcelRequire('390xr'));

});


parcelRegister("ixr5d", function(module, exports) {

$parcel$export(module.exports, "IssuesInProgressGadgetEdit", () => $8a793479fb83e9e0$export$199fec410a0f70a2);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $kSxjd = parcelRequire("kSxjd");

var $gzcjr = parcelRequire("gzcjr");

const $8a793479fb83e9e0$var$LazyIssuesInProgressGadgetEdit = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("csmkB")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/issues-in-progress/edit/main.tsx"
});
const $8a793479fb83e9e0$export$199fec410a0f70a2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issues-in-progress-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kSxjd.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8a793479fb83e9e0$var$LazyIssuesInProgressGadgetEdit, props));
const { preload: $8a793479fb83e9e0$export$513ccb98c53b8039 } = $8a793479fb83e9e0$var$LazyIssuesInProgressGadgetEdit;

});
parcelRegister("csmkB", function(module, exports) {

let $91196c12a11dd927$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $91196c12a11dd927$var$load("1VRB2"),
    $91196c12a11dd927$var$load("bABhq"),
    $91196c12a11dd927$var$load("eDzss"),
    $91196c12a11dd927$var$load("eQ6sK")
]).then(()=>parcelRequire('5tlcN'));

});


parcelRegister("92GBg", function(module, exports) {

$parcel$export(module.exports, "IssueTableGadgetView", () => $2546d43c174a6acb$export$da0765a3c10e16a3);
$parcel$export(module.exports, "preload", () => $2546d43c174a6acb$export$513ccb98c53b8039);

var $eJOHy = parcelRequire("eJOHy");

var $iluXv = parcelRequire("iluXv");

var $ch9En = parcelRequire("ch9En");

var $KWlg0 = parcelRequire("KWlg0");

var $gzcjr = parcelRequire("gzcjr");

const $2546d43c174a6acb$var$LazyIssueTableGadgetView = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("klsKq")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/view/main.tsx"
});
const $2546d43c174a6acb$export$da0765a3c10e16a3 = ({ customSkeletonHeightInPx: customSkeletonHeightInPx, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "filter-results-gadget-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $KWlg0.FilterResultsIssueTableSkeleton), {
            height: `${customSkeletonHeightInPx ?? (0, $iluXv.GADGET_DEFAULT_HEIGHT)}px`
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2546d43c174a6acb$var$LazyIssueTableGadgetView, {
        customSkeletonHeightInPx: customSkeletonHeightInPx,
        ...props
    }));
const { preload: $2546d43c174a6acb$export$513ccb98c53b8039 } = $2546d43c174a6acb$var$LazyIssueTableGadgetView;

});
parcelRegister("KWlg0", function(module, exports) {

$parcel$export(module.exports, "FilterResultsIssueTableSkeleton", () => $20813c86b16240ff$export$35d754053deeac73);
/* filter-results-issue-table.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $17fUS = parcelRequire("17fUS");
const $20813c86b16240ff$var$customCssStyles = null;
const $20813c86b16240ff$export$35d754053deeac73 = ({ height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($17fUS))),
        containerStyles: {
            height: height
        },
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("17fUS", function(module, exports) {
module.exports = new URL("filter-results-issue-table-skeleton.tpl.a502204a.svg", import.meta.url).toString();

});


parcelRegister("klsKq", function(module, exports) {

let $ecfc1181ec25e73a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ecfc1181ec25e73a$var$load("1VRB2"),
    $ecfc1181ec25e73a$var$load("bABhq"),
    $ecfc1181ec25e73a$var$load("eDzss"),
    $ecfc1181ec25e73a$var$load("k73Vu")
]).then(()=>parcelRequire('d3SdG'));

});


parcelRegister("bz1Gz", function(module, exports) {

$parcel$export(module.exports, "VotedIssuesGadgetEdit", () => $3d37a81833c717c2$export$7650b85a7a54914);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $kSxjd = parcelRequire("kSxjd");

var $gzcjr = parcelRequire("gzcjr");

const $3d37a81833c717c2$var$LazyVotedIssuesGadgetEdit = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("3BY78")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/voted-issues/edit/main.tsx"
});
const $3d37a81833c717c2$export$7650b85a7a54914 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "voted-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kSxjd.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3d37a81833c717c2$var$LazyVotedIssuesGadgetEdit, props));
const { preload: $3d37a81833c717c2$export$513ccb98c53b8039 } = $3d37a81833c717c2$var$LazyVotedIssuesGadgetEdit;

});
parcelRegister("3BY78", function(module, exports) {

let $2a13752f465ea0ce$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $2a13752f465ea0ce$var$load("1VRB2"),
    $2a13752f465ea0ce$var$load("bABhq"),
    $2a13752f465ea0ce$var$load("eDzss"),
    $2a13752f465ea0ce$var$load("ajoMW")
]).then(()=>parcelRequire('ln0ip'));

});


parcelRegister("gVMtN", function(module, exports) {

$parcel$export(module.exports, "WatchedIssuesGadgetEdit", () => $db913fcb8ad1a43f$export$a53864bd0bf8a85f);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $kSxjd = parcelRequire("kSxjd");

var $gzcjr = parcelRequire("gzcjr");

const $db913fcb8ad1a43f$var$LazyWatchedIssuesGadgetEdit = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("gnydH")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/watched-issues/edit/main.tsx"
});
const $db913fcb8ad1a43f$export$a53864bd0bf8a85f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "watched-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kSxjd.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($db913fcb8ad1a43f$var$LazyWatchedIssuesGadgetEdit, props));
const { preload: $db913fcb8ad1a43f$export$513ccb98c53b8039 } = $db913fcb8ad1a43f$var$LazyWatchedIssuesGadgetEdit;

});
parcelRegister("gnydH", function(module, exports) {

let $bec956b2e4fee8c2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $bec956b2e4fee8c2$var$load("1VRB2"),
    $bec956b2e4fee8c2$var$load("bABhq"),
    $bec956b2e4fee8c2$var$load("eDzss"),
    $bec956b2e4fee8c2$var$load("3MtSP")
]).then(()=>parcelRequire('9y8Vg'));

});


parcelRegister("i222u", function(module, exports) {

$parcel$export(module.exports, "default", () => $cab080f0d58cec23$export$2e2bcd8739ae039);

var $27LST = parcelRequire("27LST");

var $jBRHo = parcelRequire("jBRHo");

var $3UXIi = parcelRequire("3UXIi");

var $gKL7K = parcelRequire("gKL7K");
const $cab080f0d58cec23$var$createGetInitialState = ({ predeterminedJql: predeterminedJql, predeterminedJqlIncludeResolved: predeterminedJqlIncludeResolved, defaultSortPrefs: defaultSortPrefs, testId: testId })=>async (resourceContext, userPrefs)=>{
        if (resourceContext?.tenantContext == null) throw new Error('Tenant context is not available');
        const { cloudId: cloudId, activationId: activationId } = resourceContext.tenantContext;
        const validUserPrefs = (0, $gKL7K.transformToValidUserPrefs)((0, $27LST.decodeUserPreferences)(userPrefs));
        if (validUserPrefs.filterId === undefined && predeterminedJql === undefined && predeterminedJqlIncludeResolved === undefined) throw new Error('FilterId or JQL has to be available to be able to load the gadget initial state');
        const sortPrefs = (()=>{
            if (validUserPrefs.sortField) return {
                sortField: validUserPrefs.sortField,
                sortDirection: validUserPrefs.sortDirection
            };
            if (defaultSortPrefs) return {
                sortField: defaultSortPrefs.field,
                sortDirection: defaultSortPrefs.direction
            };
        })();
        const includeResolved = validUserPrefs.showResolved;
        const jql = includeResolved ? predeterminedJqlIncludeResolved : predeterminedJql;
        const queryReference = await (0, $3UXIi.loadQueryWithUserPrefs)({
            ...validUserPrefs,
            ...sortPrefs
        }, (0, $jBRHo.default), cloudId, activationId, 'store-and-network', jql);
        return {
            queryReference: queryReference,
            predeterminedJql: predeterminedJql,
            defaultSortPrefs: defaultSortPrefs,
            testId: testId
        };
    };
var $cab080f0d58cec23$export$2e2bcd8739ae039 = $cab080f0d58cec23$var$createGetInitialState;

});
parcelRegister("27LST", function(module, exports) {

$parcel$export(module.exports, "getUserPreferences", () => $04f8c794fd7da3f4$export$ae3f5fa351e2f57a);
$parcel$export(module.exports, "decodeUserPreferences", () => $04f8c794fd7da3f4$export$ebdfc6c2778ef8e2);

var $1Ozm9 = parcelRequire("1Ozm9");
const $04f8c794fd7da3f4$var$isBooleanString = (str)=>[
        'true',
        'false'
    ].includes(str.toLowerCase().trim());
const $04f8c794fd7da3f4$var$stringToBoolean = (str)=>str.toLowerCase().trim() === 'true';
const $04f8c794fd7da3f4$export$ae3f5fa351e2f57a = (action)=>(0, $1Ozm9.default)(action);
const $04f8c794fd7da3f4$export$ebdfc6c2778ef8e2 = (userPreferences = [])=>userPreferences.reduce((output, { value: value, name: name })=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...output,
            [name]: $04f8c794fd7da3f4$var$isBooleanString(value) ? $04f8c794fd7da3f4$var$stringToBoolean(value) : value
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});

});

parcelRegister("jBRHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dbde769b55aacf7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0738389a7ca4b750c97cac0dacf31209>>
 * @relayHash 29bc89fac3c12e57422e9e3421607dae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 87ececc9179099e35dff52e84a7485ecd281aafcbc9b2b8a0076024e48f3b7b5

var $kZq2R = parcelRequire("kZq2R");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $hRj2m = parcelRequire("hRj2m");

var $2HLoK = parcelRequire("2HLoK");

var $bU8Sj = parcelRequire("bU8Sj");

var $clCUA = parcelRequire("clCUA");

var $8Qoc7 = parcelRequire("8Qoc7");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");

var $7lcgt = parcelRequire("7lcgt");

var $iOvkB = parcelRequire("iOvkB");
const $7dbde769b55aacf7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterAri"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNotFilterFetch"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v15 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v16 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v17 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v18 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "kind": "ScalarField",
        "name": "type"
    }, v21 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "value"
    }, v23 = [
        v22 /*: any*/ ,
        v11 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v24 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v25 = {
        "kind": "ClientExtension",
        "selections": [
            v24 /*: any*/ 
        ]
    }, v26 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v27 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v28 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v29 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v30 = {
        "kind": "ScalarField",
        "name": "text"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": [
            v30 /*: any*/ ,
            v13 /*: any*/ ,
            v25 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v32 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v33 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v11 /*: any*/ 
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v35 = [
        v32 /*: any*/ 
    ], v36 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v22 /*: any*/ 
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v38 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v39 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v40 = {
        "kind": "ClientExtension",
        "selections": [
            v14 /*: any*/ 
        ]
    }, v41 = [
        v13 /*: any*/ ,
        v11 /*: any*/ 
    ], v42 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v43 = [
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "small"
                        }
                    ]
                },
                v13 /*: any*/ ,
                v11 /*: any*/ 
            ]
        }
    ], v44 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v45 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v46 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v47 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v46 /*: any*/ ,
                    v13 /*: any*/ ,
                    v11 /*: any*/ 
                ]
            },
            v11 /*: any*/ 
        ]
    }, v48 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v49 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v50 = {
        "kind": "ScalarField",
        "name": "number"
    }, v51 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v53 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ], v54 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueTableViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "issueTableView_reactIssueTableGadgets"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueTableViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetsInput",
                                    "variableName": "fieldSetsInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isResolved"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canBeExported"
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                v11 /*: any*/ 
                                                            ]
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v13 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                v18 /*: any*/ ,
                                                                v11 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v15 /*: any*/ ,
                                                                                        v18 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"status\"])"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v19 /*: any*/ ,
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 500
                                                }
                                            ],
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v19 /*: any*/ ,
                                                                                        v15 /*: any*/ ,
                                                                                        v20 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        v11 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v13 /*: any*/ ,
                                                                                                                        v11 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraCascadingOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "cascadingOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v23 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "childOptionValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v23 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCascadingSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v26 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v11 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v29 /*: any*/ ,
                                                                                                        v13 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                v31 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCommentSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "commentSummary",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "canAddComment"
                                                                                                                },
                                                                                                                v32 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCommentSummaryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "uri"
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraUrlField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v33 /*: any*/ ,
                                                                                                                v11 /*: any*/ ,
                                                                                                                v34 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v35 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                v34 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v36 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedUsersConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v37 /*: any*/ ,
                                                                                                                                v13 /*: any*/ ,
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v39 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "email"
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraTeamView",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedTeam",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "jiraSuppliedName"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTeamViewField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v11 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraEstimate",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "originalEstimate",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "timeInSeconds"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingSettings",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingSettings",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "workingHoursPerDay"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "workingDaysPerWeek"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "defaultFormat"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "defaultUnit"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v15 /*: any*/ ,
                                                                                                                        v13 /*: any*/ ,
                                                                                                                        v20 /*: any*/ ,
                                                                                                                        v25 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": "label",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "value"
                                                                                                                },
                                                                                                                v11 /*: any*/ ,
                                                                                                                v27 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraRadioSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v26 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v13 /*: any*/ ,
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "versionId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "args": v26 /*: any*/ ,
                                                                                                            "concreteType": "JiraGoalConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGoals",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoal",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v9 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v40 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                v14 /*: any*/ ,
                                                                                                                v24 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraGoalsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v26 /*: any*/ ,
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "href"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v32 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "message"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "componentsOld",
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v41 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "date"
                                                                                                },
                                                                                                v13 /*: any*/ ,
                                                                                                v42 /*: any*/ ,
                                                                                                v25 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v29 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "summary"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        v16 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v17 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v26 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v13 /*: any*/ ,
                                                                                                                        v33 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v32 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v13 /*: any*/ ,
                                                                                                v25 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": v43 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": v43 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ ,
                                                                                                        v44 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v9 /*: any*/ ,
                                                                                                                v45 /*: any*/ ,
                                                                                                                v47 /*: any*/ ,
                                                                                                                v44 /*: any*/ ,
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v9 /*: any*/ ,
                                                                                                                v45 /*: any*/ ,
                                                                                                                v47 /*: any*/ ,
                                                                                                                v44 /*: any*/ ,
                                                                                                                v11 /*: any*/ ,
                                                                                                                v10 /*: any*/ ,
                                                                                                                v48 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "args": [
                                                                                                                                {
                                                                                                                                    "kind": "Literal",
                                                                                                                                    "name": "ids",
                                                                                                                                    "value": [
                                                                                                                                        "issuetype",
                                                                                                                                        "project",
                                                                                                                                        "summary",
                                                                                                                                        "status"
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldsById",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                v11 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v15 /*: any*/ ,
                                                                                                                                                        v30 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v15 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issueType",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v11 /*: any*/ ,
                                                                                                                                                                v49 /*: any*/ ,
                                                                                                                                                                v13 /*: any*/ ,
                                                                                                                                                                v46 /*: any*/ ,
                                                                                                                                                                v12 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v15 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "status",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v11 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "statusCategory",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v11 /*: any*/ ,
                                                                                                                                                                        v16 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraStatusField"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueTypeField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v15 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v49 /*: any*/ ,
                                                                                                                                        v12 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "summaryField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v15 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatusField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "statusField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v15 /*: any*/ ,
                                                                                                                                v18 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v13 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v13 /*: any*/ ,
                                                                                                v25 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        v9 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": v41 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v11 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "sprintId"
                                                                                                                        },
                                                                                                                        v13 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v13 /*: any*/ ,
                                                                                                v25 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v19 /*: any*/ ,
                                                                                                        v37 /*: any*/ ,
                                                                                                        v38 /*: any*/ ,
                                                                                                        v13 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        v39 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v13 /*: any*/ ,
                                                                                                v42 /*: any*/ ,
                                                                                                v25 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v26 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v41 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "json"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        v46 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "first",
                                                                                                            "value": 1
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v32 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v48 /*: any*/ ,
                                                                                                                                v9 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v17 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v11 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                v11 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "relationName"
                                                                                                                        },
                                                                                                                        v11 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                v50 /*: any*/ ,
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        v50 /*: any*/ ,
                                                                                                        v51 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        v50 /*: any*/ ,
                                                                                                        v13 /*: any*/ ,
                                                                                                        v51 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v25 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v11 /*: any*/ ,
                                                                                                                        v13 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v25 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraFlag",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "flag",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isFlagged"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFlagField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraWatch",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "watch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "count"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWatching"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraWatchesField"
                                                                                        },
                                                                                        v40 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v36 /*: any*/ ,
                                                                                                                v40 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v34 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v35 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v40 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                        },
                                        v40 /*: any*/ 
                                    ]
                                },
                                v52 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "pageSize",
                                            "variableName": "first"
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": v53 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": v53 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": v53 /*: any*/ 
                                        }
                                    ]
                                },
                                v40 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetIds",
                                    "variableName": "fieldSetIds"
                                }
                            ],
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v54 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jqlTerm"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "aliases"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isSortable"
                                                },
                                                {
                                                    "concreteType": "JiraFieldSetPreferences",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetPreferences",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "width"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsMetadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueSearchMetadataField",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "canBeConfigured"
                                                                                },
                                                                                v15 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isPlaceHolderField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraFieldType",
                                                    "kind": "LinkedField",
                                                    "name": "fieldType",
                                                    "plural": false,
                                                    "selections": [
                                                        v54 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v32 /*: any*/ ,
                                v40 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "isNotFilterFetch",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v52 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "87ececc9179099e35dff52e84a7485ecd281aafcbc9b2b8a0076024e48f3b7b5",
            "metadata": {},
            "name": "issueTableViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $7lcgt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": (0, $clCUA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default)
            }
        }
    };
}();
$7dbde769b55aacf7$var$node.hash = "1f70c31f4e1c3b7345f8eebe7535773a";
var $7dbde769b55aacf7$export$2e2bcd8739ae039 = $7dbde769b55aacf7$var$node;

});

parcelRegister("3UXIi", function(module, exports) {

$parcel$export(module.exports, "loadQueryWithUserPrefs", () => $3a2f2bb16b1da3c2$export$700e212b8b5c678f);

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $7797X = parcelRequire("7797X");

var $26oP8 = parcelRequire("26oP8");
async function $3a2f2bb16b1da3c2$export$700e212b8b5c678f({ filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection }, query, cloudId, activationId, fetchPolicy = 'store-or-network', jql) {
    const { variables: variables } = await (0, $26oP8.transformToVariables)({
        userPrefs: {
            filterId: filterId,
            columnNames: columnNames,
            num: num,
            sortField: sortField,
            sortDirection: sortDirection
        },
        cloudId: cloudId,
        activationId: activationId,
        jql: jql
    });
    const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), query, variables, {
        fetchPolicy: fetchPolicy
    });
    if (false && queryReference.id != null) await (0, $7797X.QueryPromisesMap).get(queryReference.id);
    return queryReference;
}

});
parcelRegister("26oP8", function(module, exports) {

$parcel$export(module.exports, "transformToVariables", () => $89cb822fe50e27eb$export$a5cefa50115212b3);

var $4NoAT = parcelRequire("4NoAT");

var $8jOO7 = parcelRequire("8jOO7");

var $aPVW5 = parcelRequire("aPVW5");

var $4uCZb = parcelRequire("4uCZb");



const $89cb822fe50e27eb$export$a5cefa50115212b3 = async ({ userPrefs: userPrefs, cloudId: cloudId, activationId: activationId, jql: jql, fetchIssueTableJqlFields: fetchIssueTableJqlFields })=>{
    const { filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection, showResolved: showResolved } = userPrefs;
    const filterAri = !jql && filterId ? (0, $4NoAT.JiraFilterAri).create({
        filterId: filterId,
        siteId: cloudId,
        activationId: activationId
    }).toString() : '';
    const variables = {
        cloudId: cloudId,
        issueSearchInput: {
            ...jql ? {
                jql: jql
            } : {
                filterId: filterId
            }
        },
        after: null,
        first: num,
        fieldSetIds: columnNames,
        amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
        shouldQueryFieldSetsById: true,
        fieldSetsInput: {
            fieldSetIds: columnNames
        },
        isNotFilterFetch: !filterAri,
        filterAri: filterAri
    };
    let fieldToJqlTermMap = new Map();
    if (!sortField || !sortDirection || ![
        'ASC',
        'DESC'
    ].includes(sortDirection)) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    let jqlToModify = jql;
    if (fetchIssueTableJqlFields && !jqlToModify && filterAri) {
        const result = await fetchIssueTableJqlFields(filterAri, variables.fieldSetIds, cloudId);
        fieldToJqlTermMap = result.fieldToJqlTermMap;
        jqlToModify = result.searchJql;
    }
    if (!jqlToModify) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    // This pulls in over 600KB of code, and if it's not deferred it's eagerly loaded as
    // part of the main jira-spa route map
    const [{ JqlUtils: JqlUtils }, { default: removeFieldClauseFromJql }, { default: findClauseInAst }] = await Promise.all([
        (parcelRequire("9TYvT")),
        (parcelRequire("638V4")),
        (parcelRequire("dI4um"))
    ]);
    const jqlUtils = new JqlUtils();
    const jqlTermForSortField = (0, $4uCZb.getJqlTermForField)(sortField, fieldToJqlTermMap);
    const modifiedJql = jqlUtils.jql(jqlToModify);
    const oldPrimarySortField = modifiedJql.getPrimarySortField();
    if (oldPrimarySortField) {
        // if the sort field in original filter jql is using alias, we need to pass all possible aliases in
        // so that jqlUtils knows to replace it instead of append it as a new field
        const aliases = (0, $aPVW5.getAliasesForField)(jqlTermForSortField, fieldToJqlTermMap);
        // Sometimes, oldPrimarySortField from the JQL has
        // quotations around it which we should include
        const inclusiveAliases = Array.from(new Set([
            ...aliases,
            oldPrimarySortField
        ]));
        modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, inclusiveAliases);
    } else modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, []);
    let finalJql = modifiedJql.jqlString;
    if (showResolved) {
        const jast = modifiedJql.jast;
        if (jast) {
            const statusClause = findClauseInAst(jast, 'statusCategory');
            if (statusClause) finalJql = removeFieldClauseFromJql(jast, statusClause);
        }
    }
    return {
        variables: {
            ...variables,
            issueSearchInput: {
                jql: finalJql
            }
        },
        fieldToJqlTermMap: fieldToJqlTermMap
    };
};

});
parcelRegister("8jOO7", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $235707a6a613803b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $235707a6a613803b$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SORT_ASC", () => $235707a6a613803b$export$88956207daf9a17e);
$parcel$export(module.exports, "SORT_DESC", () => $235707a6a613803b$export$bc14f97913aaf2a);
$parcel$export(module.exports, "SORT_NONE", () => $235707a6a613803b$export$9c424bf3e8ffe64e);
$parcel$export(module.exports, "MODIFY_COLUMNS", () => $235707a6a613803b$export$1f921c78ce6d243c);
$parcel$export(module.exports, "REORDER_COLUMNS", () => $235707a6a613803b$export$83371d6c41a974aa);
$parcel$export(module.exports, "RESTORE_COLUMNS", () => $235707a6a613803b$export$3bfe53b79fc4f6ed);
$parcel$export(module.exports, "MOVE_COLUMN_FIRST", () => $235707a6a613803b$export$957d455bb65919d8);
$parcel$export(module.exports, "MOVE_COLUMN_LEFT", () => $235707a6a613803b$export$2082861c970802b0);
$parcel$export(module.exports, "MOVE_COLUMN_RIGHT", () => $235707a6a613803b$export$21847d308b0769ad);
$parcel$export(module.exports, "MOVE_COLUMN_LAST", () => $235707a6a613803b$export$c32913bc261af82d);
$parcel$export(module.exports, "BORDER_WIDTH", () => $235707a6a613803b$export$e2bd4c1faded7921);
$parcel$export(module.exports, "HEADER_HEIGHT", () => $235707a6a613803b$export$cdb7fd9d999c7168);
$parcel$export(module.exports, "ROW_HEIGHT", () => $235707a6a613803b$export$88e6c5bab2ff80e8);
$parcel$export(module.exports, "COLUMN_ID_MEATBALL_MENU", () => $235707a6a613803b$export$de4c02b525d877fa);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $235707a6a613803b$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $235707a6a613803b$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_INTERNAL_COLUMN", () => $235707a6a613803b$export$b4e9105b7f5f1b0f);
$parcel$export(module.exports, "ACTION_COLUMNS", () => $235707a6a613803b$export$3dbdc5c16825be4d);
$parcel$export(module.exports, "EXPAND_BUTTON_WIDTH", () => $235707a6a613803b$export$a1c171a82c45d53f);
$parcel$export(module.exports, "CREATE_CHILD_BUTTON_WIDTH", () => $235707a6a613803b$export$43ff8c492b8a2e1b);
$parcel$export(module.exports, "EXPAND_CELL_PADDING", () => $235707a6a613803b$export$9c5dd6078b37aac2);
$parcel$export(module.exports, "DEPTH_WIDTH", () => $235707a6a613803b$export$a8273d7d48e89fce);
$parcel$export(module.exports, "MAX_COLUMNS", () => $235707a6a613803b$export$7ec4af037f372df4);
$parcel$export(module.exports, "CHILD_QUERY_PAGE_SIZE", () => $235707a6a613803b$export$d2372dfbd4e91a11);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $235707a6a613803b$export$1adf7afff96bbf16);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH_COMPACT", () => $235707a6a613803b$export$10016003aa27fa67);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH", () => $235707a6a613803b$export$5575b9e0ed3ff59f);
$parcel$export(module.exports, "DEFAULT_COLUMN_WIDTH", () => $235707a6a613803b$export$7c3f559e2ca95fa);
$parcel$export(module.exports, "MAXIMUM_COLUMN_WIDTH", () => $235707a6a613803b$export$e1a42c2fefb5af25);
$parcel$export(module.exports, "SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH", () => $235707a6a613803b$export$54fb99171fb48426);
$parcel$export(module.exports, "MINIMUM_MERGED_CELL_COLUMN_WIDTH", () => $235707a6a613803b$export$787e40d1c5baf821);
$parcel$export(module.exports, "COLUMN_WIDTH_ASSIGNEE", () => $235707a6a613803b$export$49f5d64369d40b04);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_LONG", () => $235707a6a613803b$export$bfe09a9186b98f8f);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SHORT", () => $235707a6a613803b$export$f2540f34b796306d);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SUMMARY", () => $235707a6a613803b$export$954afb0fcf5a326);
$parcel$export(module.exports, "COLUMN_OPERATION_REORDER", () => $235707a6a613803b$export$93758649595b2d58);
$parcel$export(module.exports, "COLUMN_OPERATION_RESIZE", () => $235707a6a613803b$export$cad8c6a0b6e78898);
$parcel$export(module.exports, "INSERT_COLUMN_BUTTON_Y_OFFSET", () => $235707a6a613803b$export$5252387dc65db584);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_FULL_HEIGHT", () => $235707a6a613803b$export$754b76ac8fa63350);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_HEADER_ONLY", () => $235707a6a613803b$export$fa5c7dad7ee16383);
$parcel$export(module.exports, "ROW_OPERATION_REORDER", () => $235707a6a613803b$export$4e8abe16cd1126dd);
$parcel$export(module.exports, "DENSITY_COMPACT", () => $235707a6a613803b$export$6c0a5a77457ca62);
$parcel$export(module.exports, "DENSITY_FULL", () => $235707a6a613803b$export$119d8ab9a5bc4b2);
$parcel$export(module.exports, "LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE", () => $235707a6a613803b$export$9ef77944c441ad07);
$parcel$export(module.exports, "LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE", () => $235707a6a613803b$export$c1f680390b97c9e1);
$parcel$export(module.exports, "CHILD_ITEMS_EXPERIENCE", () => $235707a6a613803b$export$e03155205bf92428);
$parcel$export(module.exports, "CHILD_ITEMS_LOAD_MORE_EXPERIENCE", () => $235707a6a613803b$export$311c64c0d94dcdf3);
$parcel$export(module.exports, "GROUPED_ITEMS_EXPERIENCE", () => $235707a6a613803b$export$f5d215df3c6473e9);
$parcel$export(module.exports, "GROUPED_LOAD_MORE_EXPERIENCE", () => $235707a6a613803b$export$b4fd503bf7cccacd);
$parcel$export(module.exports, "INLINE_ISSUE_CREATE_EXPERIENCE", () => $235707a6a613803b$export$70f80a241e016093);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $235707a6a613803b$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "MAKE_CHILD", () => $235707a6a613803b$export$5eb61e3ff74a4f58);
$parcel$export(module.exports, "REORDER_ABOVE", () => $235707a6a613803b$export$9213b5774112217f);
$parcel$export(module.exports, "REORDER_BELOW", () => $235707a6a613803b$export$118b06a03e2c672f);
$parcel$export(module.exports, "INSTRUCTION_BLOCKED", () => $235707a6a613803b$export$71b8539e20744dab);
$parcel$export(module.exports, "COMBINE", () => $235707a6a613803b$export$a259161040977848);
$parcel$export(module.exports, "REORDER_BEFORE", () => $235707a6a613803b$export$15f7f11d631a78c1);
$parcel$export(module.exports, "REORDER_AFTER", () => $235707a6a613803b$export$3a8d6fe24ed2320f);
$parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", () => $235707a6a613803b$export$5b388ccfa29be01);
$parcel$export(module.exports, "COLUMN_PICKER_CONFIGURATION_CONTAINER", () => $235707a6a613803b$export$f6d7582f33b86010);
$parcel$export(module.exports, "COLUMN_PICKER_ADD_COLUMN_CONTAINER", () => $235707a6a613803b$export$f92486d03c064eac);
$parcel$export(module.exports, "MAX_LINE_WRAP_OLD", () => $235707a6a613803b$export$139bffb2a576e8c0);
$parcel$export(module.exports, "MAX_LINE_WRAP_NEW", () => $235707a6a613803b$export$3b696b0ac06c2cc4);
$parcel$export(module.exports, "HIGHLIGHT_LINGER_DURATION_MS", () => $235707a6a613803b$export$6ba5aaedfd1b5319);
$parcel$export(module.exports, "SORT_A_TO_Z", () => $235707a6a613803b$export$1bc2edb2aa5e8282);
$parcel$export(module.exports, "SORT_Z_TO_A", () => $235707a6a613803b$export$c7b524b6c48f8273);
$parcel$export(module.exports, "SORT_LOWEST_TO_HIGHEST", () => $235707a6a613803b$export$9c60c93d5e95e80f);
$parcel$export(module.exports, "SORT_HIGHEST_TO_LOWEST", () => $235707a6a613803b$export$476f4bdd6eba4fb2);
$parcel$export(module.exports, "SORT_OLDEST_TO_NEWEST", () => $235707a6a613803b$export$fbcac9f513cf13f4);
$parcel$export(module.exports, "SORT_NEWEST_TO_OLDEST", () => $235707a6a613803b$export$d3c0241ce8ae9a73);
$parcel$export(module.exports, "DUPLICATE_FIELD_EDIT_WIDTH", () => $235707a6a613803b$export$de4b89eec2f02226);
$parcel$export(module.exports, "GRID_NAVIGATION_ONBOARDING_TRIGGERS", () => $235707a6a613803b$export$61885878ee8ed2ff);
$parcel$export(module.exports, "KEYBOARD_SHORTCUTS_HELP_ARTICLE_ID", () => $235707a6a613803b$export$6fb1d4dbf61e0523);

var $j8Km1 = parcelRequire("j8Km1");
const $235707a6a613803b$export$b8b9d90f9e5bd72b = 'jiraNativeIssueTable';
const $235707a6a613803b$export$d57b6b390e78d90f = 'empanada';
const $235707a6a613803b$export$88956207daf9a17e = 'ASC';
const $235707a6a613803b$export$bc14f97913aaf2a = 'DESC';
const $235707a6a613803b$export$9c424bf3e8ffe64e = 'NONE';
const $235707a6a613803b$export$1f921c78ce6d243c = 'MODIFY_COLUMNS';
const $235707a6a613803b$export$83371d6c41a974aa = 'REORDER_COLUMNS';
const $235707a6a613803b$export$3bfe53b79fc4f6ed = 'RESTORE_COLUMNS';
const $235707a6a613803b$export$957d455bb65919d8 = 'MOVE_COLUMN_FIRST';
const $235707a6a613803b$export$2082861c970802b0 = 'MOVE_COLUMN_LEFT';
const $235707a6a613803b$export$21847d308b0769ad = 'MOVE_COLUMN_RIGHT';
const $235707a6a613803b$export$c32913bc261af82d = 'MOVE_COLUMN_LAST';
const $235707a6a613803b$export$e2bd4c1faded7921 = '1px';
const $235707a6a613803b$export$cdb7fd9d999c7168 = 40;
const $235707a6a613803b$export$88e6c5bab2ff80e8 = 40;
const $235707a6a613803b$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $235707a6a613803b$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $235707a6a613803b$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $235707a6a613803b$export$b4e9105b7f5f1b0f = '__issuetable_internal';
const $235707a6a613803b$export$3dbdc5c16825be4d = [
    $235707a6a613803b$export$c3266da279aa6b84,
    $235707a6a613803b$export$de4c02b525d877fa,
    $235707a6a613803b$export$66b2a4a5f67468ac,
    (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)
];
const $235707a6a613803b$export$a1c171a82c45d53f = 24;
const $235707a6a613803b$export$43ff8c492b8a2e1b = 24;
const $235707a6a613803b$export$9c5dd6078b37aac2 = 16;
const $235707a6a613803b$export$a8273d7d48e89fce = 24;
const $235707a6a613803b$export$7ec4af037f372df4 = 500;
const $235707a6a613803b$export$d2372dfbd4e91a11 = 50;
const $235707a6a613803b$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $235707a6a613803b$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $235707a6a613803b$export$c1d348661674e922 = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $235707a6a613803b$export$67082d449d5ec91 = 'com.atlassian.servicedesk:sd-request-feedback';
const $235707a6a613803b$export$145a4a20f394acf9 = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $235707a6a613803b$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $235707a6a613803b$export$10016003aa27fa67 = 40; // 2 x 8px cell padding + 24px icon size
const $235707a6a613803b$export$5575b9e0ed3ff59f = 69; // 2 x 8px cell padding + 2 x 24px icon size + 4px gap + 1px border
const $235707a6a613803b$export$7c3f559e2ca95fa = 170;
const $235707a6a613803b$export$e1a42c2fefb5af25 = 999;
const $235707a6a613803b$export$54fb99171fb48426 = 80;
const $235707a6a613803b$export$a194aa0e243a27f9 = 156;
const $235707a6a613803b$export$87a3548b97ce2540 = 136;
const $235707a6a613803b$export$d182a35496b19fb4 = 112;
const $235707a6a613803b$export$4fd6711c21931f5b = 116;
const $235707a6a613803b$export$9b72110b9a7c0a39 = 102;
const $235707a6a613803b$export$54c15048528650a8 = 84;
const $235707a6a613803b$export$7ed05c26fe24a805 = 200;
const $235707a6a613803b$export$787e40d1c5baf821 = 180;
const $235707a6a613803b$export$49f5d64369d40b04 = 204;
const $235707a6a613803b$export$bfe09a9186b98f8f = 400;
const $235707a6a613803b$export$f2540f34b796306d = 300;
const $235707a6a613803b$export$954afb0fcf5a326 = 450;
const $235707a6a613803b$export$93758649595b2d58 = 'reorder';
const $235707a6a613803b$export$cad8c6a0b6e78898 = 'resize';
const $235707a6a613803b$export$5252387dc65db584 = -16;
const $235707a6a613803b$export$754b76ac8fa63350 = 'FULL_HEIGHT';
const $235707a6a613803b$export$fa5c7dad7ee16383 = 'HEADER_ONLY';
const $235707a6a613803b$export$4e8abe16cd1126dd = 'rowReorder';
const $235707a6a613803b$export$6c0a5a77457ca62 = 'COMPACT';
const $235707a6a613803b$export$119d8ab9a5bc4b2 = 'FULL';
const $235707a6a613803b$export$9ef77944c441ad07 = 'LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE';
const $235707a6a613803b$export$c1f680390b97c9e1 = 'LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE';
const $235707a6a613803b$export$e03155205bf92428 = 'loadChildItems';
const $235707a6a613803b$export$311c64c0d94dcdf3 = 'loadMoreChildItems';
const $235707a6a613803b$export$f5d215df3c6473e9 = 'loadGroupChildren';
const $235707a6a613803b$export$b4fd503bf7cccacd = 'loadMoreGroupedItems';
const $235707a6a613803b$export$70f80a241e016093 = 'createIssue';
const $235707a6a613803b$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
const $235707a6a613803b$export$5eb61e3ff74a4f58 = 'make-child';
const $235707a6a613803b$export$9213b5774112217f = 'reorder-above';
const $235707a6a613803b$export$118b06a03e2c672f = 'reorder-below';
const $235707a6a613803b$export$71b8539e20744dab = 'instruction-blocked';
const $235707a6a613803b$export$a259161040977848 = 'combine';
const $235707a6a613803b$export$15f7f11d631a78c1 = 'reorder-before';
const $235707a6a613803b$export$3a8d6fe24ed2320f = 'reorder-after';
const $235707a6a613803b$export$5b388ccfa29be01 = -1;
const $235707a6a613803b$export$f6d7582f33b86010 = 'COLUMN_PICKER_CONFIGURATION_CONTAINER';
const $235707a6a613803b$export$f92486d03c064eac = 'COLUMN_PICKER_ADD_COLUMN_CONTAINER';
const $235707a6a613803b$export$139bffb2a576e8c0 = 2;
const $235707a6a613803b$export$3b696b0ac06c2cc4 = 1;
const $235707a6a613803b$export$6ba5aaedfd1b5319 = 2000;
const $235707a6a613803b$export$1bc2edb2aa5e8282 = 'a_to_z';
const $235707a6a613803b$export$c7b524b6c48f8273 = 'z_to_a';
const $235707a6a613803b$export$9c60c93d5e95e80f = 'lowest_to_highest';
const $235707a6a613803b$export$476f4bdd6eba4fb2 = 'highest_to_lowest';
const $235707a6a613803b$export$fbcac9f513cf13f4 = 'oldest_to_newest';
const $235707a6a613803b$export$d3c0241ce8ae9a73 = 'newest_to_oldest';
const $235707a6a613803b$export$de4b89eec2f02226 = 270;
const $235707a6a613803b$export$61885878ee8ed2ff = {
    MORE_SHORTCUTS_CLICKED: 'jira-grid-navigation-onboarding-more-shortcuts-clicked',
    OK_CLICKED: 'jira-grid-navigation-onboarding-ok-clicked'
};
const $235707a6a613803b$export$6fb1d4dbf61e0523 = '6yfW2wFuTcluCiX8ghrxWj';

});
parcelRegister("j8Km1", function(module, exports) {

$parcel$export(module.exports, "KNOWN_COLUMN_TYPES", () => $e5b9ff271db028f7$export$bbc2e8c301f97f97);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $e5b9ff271db028f7$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $e5b9ff271db028f7$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_MERGED_COLUMN", () => $e5b9ff271db028f7$export$3237751348c4f1b);
$parcel$export(module.exports, "MERGED_COLUMN_TYPES", () => $e5b9ff271db028f7$export$72f66561203b705c);
$parcel$export(module.exports, "MERGED_COLUMN_IDS", () => $e5b9ff271db028f7$export$70f30e260ec270f2);
$parcel$export(module.exports, "MERGED_COLUMN_DEFAULT_WIDTH", () => $e5b9ff271db028f7$export$6aa1d347deb86ef3);
$parcel$export(module.exports, "NIN_PROJECT_OPERATION_SCOPE", () => $e5b9ff271db028f7$export$fae6afe554014a45);
$parcel$export(module.exports, "NIN_GLOBAL_OPERATION_SCOPE", () => $e5b9ff271db028f7$export$39ec48f092f3ea90);
const $e5b9ff271db028f7$export$bbc2e8c301f97f97 = {
    ASSIGNEE: 'assignee',
    CHECKBOX: '__issuetable_internal_checkbox',
    CHECKBOX_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
    DESCRIPTION: 'description',
    ENVIRONMENT: 'environment',
    EXPAND_BUTTON: '__issuetable_internal_expand_button',
    ISSUE_KEY: 'issuekey',
    ISSUE_OPERATIONS: '__issuetable_internal_meatball',
    STATUS: 'status',
    SUMMARY: 'summary',
    ISSUE_TYPE: 'issuetype',
    RESOLUTION: 'resolution',
    PARENT: 'parent',
    LABELS: 'labels',
    COMPONENTS: 'components',
    FIX_VERSIONS: 'fixVersions',
    STATUS_CATEGORY: 'statusCategory',
    PROJECT: 'project',
    READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
    SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
    TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
    EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
    CREATED: 'created',
    RESOLUTION_DATE: 'resolutiondate',
    TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
    UPDATED: 'updated',
    DUE_DATE: 'duedate',
    REPORTER: 'reporter',
    CREATOR: 'creator',
    PRIORITY: 'priority',
    AFFECTS_VERSIONS: 'versions',
    REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin',
    NUMBER: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
    STORY_POINT_ESTIMATE: 'com.pyxis.greenhopper.jira:jsw-story-points',
    USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
    CUSTOM_LABELS: 'com.atlassian.jira.plugin.system.customfieldtypes:labels',
    TIMELINE: 'timeline',
    DATE_TIME: 'com.atlassian.jira.plugin.system.customfieldtypes:datetime',
    URL: 'com.atlassian.jira.plugin.system.customfieldtypes:url',
    SINGLE_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
    MULTI_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
    MULTI_USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker',
    MERGED_COLUMN: '__issuetable_internal_merged_column',
    TEAM: 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team',
    ORIGINAL_ESTIMATE: 'timeoriginalestimate',
    GOALS: 'com.atlassian.jira.plugin.system.customfieldtypes:goals',
    CASCADING_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
    CONFLUENCE_PAGES: 'confluenceRemoteIssueLinks',
    PEOPLE: 'com.atlassian.jira.plugin.system.customfieldtypes:people',
    DATE_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker'
};
const $e5b9ff271db028f7$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $e5b9ff271db028f7$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $e5b9ff271db028f7$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $e5b9ff271db028f7$export$3237751348c4f1b = '__issuetable_internal_merged_column';
const $e5b9ff271db028f7$export$72f66561203b705c = [
    $e5b9ff271db028f7$export$bbc2e8c301f97f97.ISSUE_TYPE,
    $e5b9ff271db028f7$export$bbc2e8c301f97f97.ISSUE_KEY,
    $e5b9ff271db028f7$export$bbc2e8c301f97f97.SUMMARY
];
const $e5b9ff271db028f7$export$70f30e260ec270f2 = [
    'issuetype',
    'issuekey',
    'summary'
];
const $e5b9ff271db028f7$export$6aa1d347deb86ef3 = 64; // 24 * 2 (two icons) + 8*2 (horizontal padding)
const $e5b9ff271db028f7$export$fae6afe554014a45 = 'NIN_PROJECT';
const $e5b9ff271db028f7$export$39ec48f092f3ea90 = 'NIN_GLOBAL';

});


parcelRegister("aPVW5", function(module, exports) {

$parcel$export(module.exports, "getAliasesForField", () => $41cc5c59baaab770$export$94d69942fbe58a01);
const $41cc5c59baaab770$export$94d69942fbe58a01 = (field, fieldToJqlTermMap)=>{
    // provided field could be a field id, name, an alias, or a jql term
    let term = fieldToJqlTermMap.get(field);
    if (term === undefined) {
        // it may be a jql term itself
        // filter is still an experiment feature in Iterator so we do old school looping
        for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === field) {
            term = keyValuePair[1];
            break;
        }
    }
    if (term === undefined) return [];
    // we do a reverse look-up to find any other keys of this jql term, they can all be used in a jql
    const set = new Set();
    set.add(term);
    for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === term) set.add(keyValuePair[0]);
    return Array.from(set);
};

});

parcelRegister("4uCZb", function(module, exports) {

$parcel$export(module.exports, "getJqlTermForField", () => $b8f199beaa022d8a$export$ef4e8b2c9bc7bd4d);

var $1S1Tf = parcelRequire("1S1Tf");
const $b8f199beaa022d8a$export$ef4e8b2c9bc7bd4d = (field, fieldToJqlTermMap)=>{
    const convertedField = (0, $1S1Tf.convertFieldToJqlTerm)(field);
    const jqlTermForField = fieldToJqlTermMap.get(convertedField) ?? convertedField;
    return jqlTermForField;
};

});
parcelRegister("1S1Tf", function(module, exports) {

$parcel$export(module.exports, "convertFieldToJqlTerm", () => $deb668ce7f0a6895$export$29f734dc2c61ea9d);
const $deb668ce7f0a6895$export$29f734dc2c61ea9d = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    // fieldName match regex for customfield_<number> exactly
    // legacy gadget may have it stored as customfield_<number> in user prefs
    if (/^customfield_\d+$/.test(fieldName)) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    return fieldName;
};

});


parcelRegister("9TYvT", function(module, exports) {

let $735830d3b4edcaf3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $735830d3b4edcaf3$var$load("kox0i").then(()=>parcelRequire('imx7a'));

});

parcelRegister("638V4", function(module, exports) {

let $4679f11840e88f62$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4679f11840e88f62$var$load("25RDT").then(()=>parcelRequire('boEdP'));

});

parcelRegister("dI4um", function(module, exports) {

let $9fb2ddca39e7c465$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9fb2ddca39e7c465$var$load("9pJ9N").then(()=>parcelRequire('3qoCN'));

});



parcelRegister("gKL7K", function(module, exports) {

$parcel$export(module.exports, "transformToValidUserPrefs", () => $de3749d4733e362d$export$e9345b021afd3cc3);

var $db9hy = parcelRequire("db9hy");

var $8knHl = parcelRequire("8knHl");

var $f1gVB = parcelRequire("f1gVB");
const $de3749d4733e362d$export$e9345b021afd3cc3 = (rawUserPrefs)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const pageSize = parseInt(rawUserPrefs.num, 10);
    const fieldSetIds = (0, $db9hy.convertUserPrefsToColumnNames)(rawUserPrefs.columnNames);
    const stringifiedFilterId = `${rawUserPrefs.filterId}`;
    const { sortDirection: sortDirection, sortField: sortField } = (0, $8knHl.getSortFieldAndDirection)(rawUserPrefs.sortBy);
    const showResolved = !!rawUserPrefs.showResolved;
    return {
        filterId: (0, $f1gVB.isFilterId)(stringifiedFilterId) ? stringifiedFilterId : undefined,
        columnNames: fieldSetIds,
        num: !Number.isNaN(pageSize) ? pageSize : 10,
        sortDirection: sortDirection,
        sortField: sortField,
        showResolved: showResolved
    };
};

});
parcelRegister("db9hy", function(module, exports) {

$parcel$export(module.exports, "convertUserPrefsToColumnNames", () => $c43676d5930696ed$export$6e5cdc232ebb20cf);

var $iluXv = parcelRequire("iluXv");

const $c43676d5930696ed$export$6e5cdc232ebb20cf = (columns)=>typeof columns === 'string' && columns !== '' && columns !== '--Default--' ? columns.split((0, $aa603a4a6cc3d43b$export$a3d4af30107c4f4d)).map((col)=>col.replaceAll((0, $aa603a4a6cc3d43b$export$952287cc7aef3a4c), (0, $aa603a4a6cc3d43b$export$a3d4af30107c4f4d))) : (0, $iluXv.ISSUE_SEARCH_DEFAULT_COLUMNS);

});
const $aa603a4a6cc3d43b$export$dd03181e30c7d559 = 5;
const $aa603a4a6cc3d43b$export$a3d4af30107c4f4d = '|';
const $aa603a4a6cc3d43b$export$952287cc7aef3a4c = '%7C';


parcelRegister("8knHl", function(module, exports) {

$parcel$export(module.exports, "getSortFieldAndDirection", () => $1d645544a8ea064c$export$e535bb2dfaa4d10b);
const $1d645544a8ea064c$export$e535bb2dfaa4d10b = (sortByFromUserPrefs)=>{
    const [sortField, sortDirection] = typeof sortByFromUserPrefs === 'string' ? sortByFromUserPrefs.split(':') : [];
    if (!sortField || sortDirection !== 'ASC' && sortDirection !== 'DESC') return {};
    return {
        sortField: sortField,
        sortDirection: sortDirection
    };
};

});

parcelRegister("f1gVB", function(module, exports) {

$parcel$export(module.exports, "isFilterId", () => $e93567f8e731246c$export$23be85030bd58047);
// this is copied from NIN https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/issue-navigator/actions/common/src/utils/filters/index.tsx?at=abdc1df97c8cee2475285ab25c47a938ce99d65a
const $e93567f8e731246c$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});




parcelRegister("8ospY", function(module, exports) {

$parcel$export(module.exports, "REACT_KEY", () => $c0263edac7754048$export$e0e89108956f58f6);
// React gadget keys
const $c0263edac7754048$export$c8ae0b83405368ed = 'react/filter-results';
const $c0263edac7754048$var$REACT_KEY_ASSIGNED_TO_ME = 'react/assigned-to-me';
const $c0263edac7754048$var$REACT_KEY_ISSUES_IN_PROGRESS = 'react/issues-in-progress';
const $c0263edac7754048$var$REACT_KEY_VOTED_ISSUES = 'react/voted-issues';
const $c0263edac7754048$var$REACT_KEY_WATCHED_ISSUES = 'react/watched-issues';
const $c0263edac7754048$var$REACT_KEY_CUSTOM_REPORT = 'react/custom-report';
const $c0263edac7754048$export$e0e89108956f58f6 = {
    FILTER_RESULTS: $c0263edac7754048$export$c8ae0b83405368ed,
    ASSIGNED_TO_ME: $c0263edac7754048$var$REACT_KEY_ASSIGNED_TO_ME,
    ISSUES_IN_PROGRESS: $c0263edac7754048$var$REACT_KEY_ISSUES_IN_PROGRESS,
    VOTED_ISSUES: $c0263edac7754048$var$REACT_KEY_VOTED_ISSUES,
    WATCHED_ISSUES: $c0263edac7754048$var$REACT_KEY_WATCHED_ISSUES,
    CUSTOM_REPORT: $c0263edac7754048$var$REACT_KEY_CUSTOM_REPORT
};

});




parcelRegister("8Fsa4", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ca618da80c61e6e$export$2e2bcd8739ae039);

var $jGzN3 = parcelRequire("jGzN3");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4ca618da80c61e6e$export$2e2bcd8739ae039 = async ()=>(0, $jGzN3.performGetRequest)('/rest/config/1.0/directoryitems.json');

});

parcelRegister("rbj9K", function(module, exports) {

$parcel$export(module.exports, "default", () => $21b334fde51b6ff0$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $j5TCC = parcelRequire("j5TCC");

var $8MjsA = parcelRequire("8MjsA");

var $E0qsj = parcelRequire("E0qsj");

var $4lxlN = parcelRequire("4lxlN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$21b334fde51b6ff0$export$2e2bcd8739ae039 = (maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch }, storeContext)=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $E0qsj.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { reactGadgets: nextGadgets } = sharedValue;
            const prev = maybePrevData != null && !(maybePrevData instanceof Error) && maybePrevData.reactGadgetsState || {};
            const persistedGadgets = nextGadgets.filter(({ id: id })=>!!prev[id]);
            const gadgetsToLoad = nextGadgets.filter((gadget)=>{
                // componentEdit will be optional in the future, although currently types say that it's required
                const isConfigurable = !!(0, $8MjsA.default)[gadget.reactKey].componentEdit;
                const isUnconfigured = isConfigurable && !(0, $j5TCC.isGadgetConfigured)(gadget.userPrefs);
                return !prev[gadget.id] && !isUnconfigured;
            });
            const skippedGadgets = nextGadgets.filter((gadget)=>!prev[gadget.id] && !gadgetsToLoad.some(({ id: id })=>id === gadget.id));
            const reactGadgetsState = {
                ...Object.fromEntries(persistedGadgets.map(({ id: id })=>[
                        id,
                        prev[id]
                    ])),
                ...Object.fromEntries(skippedGadgets.map(({ id: id })=>[
                        id,
                        {}
                    ])),
                ...await (0, $4lxlN.loadReactGadgets)(gadgetsToLoad, storeContext)
            };
            return {
                sharedValue: sharedValue,
                reactGadgetsState: reactGadgetsState
            };
        })();
    };

});
parcelRegister("j5TCC", function(module, exports) {

$parcel$export(module.exports, "isGadgetConfigured", () => $651ae8a0bb1abfd0$export$b625fae487818738);
const $651ae8a0bb1abfd0$export$b625fae487818738 = (userPrefs)=>userPrefs?.fields.some(({ name: name, value: value })=>name === 'isConfigured' && value === 'true') ?? false;

});

parcelRegister("4lxlN", function(module, exports) {

$parcel$export(module.exports, "loadReactGadgets", () => $1fcf9ef6c7245c9e$export$7e1a3455761184a2);
// eslint-disable-next-line jira/import-whitelist

var $8MjsA = parcelRequire("8MjsA");
const $1fcf9ef6c7245c9e$var$preloadGadgetBundles = (reactKeys)=>reactKeys.forEach((reactKey)=>{
        (0, $8MjsA.default)[reactKey].preload();
    });
const $1fcf9ef6c7245c9e$export$7e1a3455761184a2 = async (gadgets, storeContext)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const distinctReactKeys = [
        ...new Set(gadgets.map((gadget)=>gadget.reactKey))
    ];
    $1fcf9ef6c7245c9e$var$preloadGadgetBundles(distinctReactKeys);
    return Object.fromEntries(await Promise.all(gadgets.map(({ id: id, reactKey: reactKey, userPrefs: userPrefs })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $8MjsA.default)[reactKey]?.getInitialState(storeContext, userPrefs?.fields || []).then((state)=>[
                id,
                state
            ], (error)=>[
                id,
                error
            ]))));
};

});



parcelRegister("2Ga0d", function(module, exports) {

$parcel$export(module.exports, "dashboardEditRoute", () => $b352cea7b082c6d1$export$b6e00d2cd7369fbd);
const $b352cea7b082c6d1$export$b6e00d2cd7369fbd = {
    name: 'dashboard-edit',
    path: '/jira/dashboards/:dashboardId(\\d+)/edit',
    query: [
        'maximized?'
    ],
    exact: true
};

});

parcelRegister("8vUDE", function(module, exports) {

$parcel$export(module.exports, "dashboardEditEntryPoint", () => $a622e7f542388744$export$eb39305ec6fcebf1);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $a622e7f542388744$export$eb39305ec6fcebf1 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("ht0hi")), {
        moduleId: "4d5a5b34",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("ht0hi", function(module, exports) {

let $cb755c47ca650477$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $cb755c47ca650477$var$load("1VRB2"),
    $cb755c47ca650477$var$load("bABhq"),
    $cb755c47ca650477$var$load("bJtlf")
]).then(()=>parcelRequire('jmgZu'));

});


parcelRegister("en43l", function(module, exports) {

$parcel$export(module.exports, "dashboardResources", () => $04dfe95f5bd72bdf$export$50d95db618f58349);
$parcel$export(module.exports, "LazyDashboardView", () => $04dfe95f5bd72bdf$export$c3bf98706b62de2b);
$parcel$export(module.exports, "LazyDashboardViewEmbed", () => $04dfe95f5bd72bdf$export$94d85118d282a15);
$parcel$export(module.exports, "LazySystemDashboardEdit", () => $04dfe95f5bd72bdf$export$c8d59d34c3e8f345);
$parcel$export(module.exports, "DashboardViewEmbedPage", () => $04dfe95f5bd72bdf$export$86d9f777f9d4e312);
$parcel$export(module.exports, "SystemDashboardEditPage", () => $04dfe95f5bd72bdf$export$dcd19a888f8c85c);

var $eJOHy = parcelRequire("eJOHy");

var $jlaZM = parcelRequire("jlaZM");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");
const $04dfe95f5bd72bdf$export$50d95db618f58349 = ()=>[
        (0, $jlaZM.dashboardConfigAndWRMResource),
        (0, $jlaZM.dashboardAMDModulesResource),
        (0, $jlaZM.dashboardReactGadgetsResource),
        (0, $jlaZM.dashboardForgeResource)
    ];

const $04dfe95f5bd72bdf$export$c3bf98706b62de2b = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5tSbt"))), {
    moduleId: "./src/packages/global-pages/dashboard/view/src/index.tsx"
});

const $04dfe95f5bd72bdf$export$94d85118d282a15 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7tRRt"))), {
    moduleId: "./src/packages/global-pages/dashboard/view-embed/src/index.tsx"
});

const $04dfe95f5bd72bdf$export$c8d59d34c3e8f345 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("74JsQ"))), {
    moduleId: "./src/packages/spa-apps/dashboard/system-dashboard-edit/src/index.tsx"
});
const $04dfe95f5bd72bdf$export$86d9f777f9d4e312 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $04dfe95f5bd72bdf$export$94d85118d282a15,
        pageId: "dashboard",
        shouldShowSpinner: true
    });
const $04dfe95f5bd72bdf$export$dcd19a888f8c85c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $04dfe95f5bd72bdf$export$c8d59d34c3e8f345,
        pageId: "system-dashboard-edit",
        shouldShowSpinner: false
    });

});
parcelRegister("5tSbt", function(module, exports) {

let $3fd9b108f52cabdb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $3fd9b108f52cabdb$var$load("1VRB2"),
    $3fd9b108f52cabdb$var$load("bABhq"),
    $3fd9b108f52cabdb$var$load("cI3U2")
]).then(()=>parcelRequire('8Xpvo'));

});

parcelRegister("7tRRt", function(module, exports) {

let $5725059d67fd59b9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5725059d67fd59b9$var$load("7X84x").then(()=>parcelRequire('4NPdN'));

});

parcelRegister("74JsQ", function(module, exports) {

let $526c2c5efb6c6233$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $526c2c5efb6c6233$var$load("1VRB2"),
    $526c2c5efb6c6233$var$load("bABhq"),
    $526c2c5efb6c6233$var$load("bgTfJ")
]).then(()=>parcelRequire('eM952'));

});



parcelRegister("fkKo1", function(module, exports) {

$parcel$export(module.exports, "dashboardRouteEntry", () => $3859dd2e475cb8d5$export$9fbbaafb58999ac3);

var $kHlOR = parcelRequire("kHlOR");


var $1wb5r = parcelRequire("1wb5r");

var $1RKJf = parcelRequire("1RKJf");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9aj7y = parcelRequire("9aj7y");

var $doZ3p = parcelRequire("doZ3p");

var $en43l = parcelRequire("en43l");
const $3859dd2e475cb8d5$export$9fbbaafb58999ac3 = (0, $6xToB.createEntry)((0, $9aj7y.dashboardRoute), ()=>({
        group: 'dashboard',
        component: (0, $doZ3p.DashboardRedirect),
        layout: (0, $1RKJf.homepageLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $en43l.dashboardResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $en43l.LazyDashboardView)
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$4695c1a423ffe431)
        },
        isRedirect: true,
        earlyAssets: (0, $1wb5r.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("1RKJf", function(module, exports) {

$parcel$export(module.exports, "homepageLayout", () => $e8887a1c3d0e1d20$export$5b7fb151d60504c);

var $fz8gQ = parcelRequire("fz8gQ");

var $7h3uc = parcelRequire("7h3uc");

var $6dwgv = parcelRequire("6dwgv");
const $e8887a1c3d0e1d20$export$5b7fb151d60504c = (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), {
    // both of the components are wrapped with componentWithCondition
    globalComponents: [
        (0, $fz8gQ.AsyncTransitionHomeRenderer),
        (0, $fz8gQ.AsyncWelcomeModalRenderer)
    ]
});

});
parcelRegister("fz8gQ", function(module, exports) {

$parcel$export(module.exports, "AsyncTransitionHomeRenderer", () => $7101fec8869f42fd$export$cb38f5a820347580);
$parcel$export(module.exports, "AsyncWelcomeModalRenderer", () => $7101fec8869f42fd$export$9cda67d6c86d7b98);
$parcel$export(module.exports, "eocChangeboardingLayout", () => $7101fec8869f42fd$export$b8fa7ac7019001bb);

var $6dwgv = parcelRequire("6dwgv");

var $gzcjr = parcelRequire("gzcjr");

var $bJscI = parcelRequire("bJscI");

const $7101fec8869f42fd$export$cb38f5a820347580 = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("arhTh")).then((module)=>module.TransitionHomeRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/ui/transition-home/main.tsx"
});
$7101fec8869f42fd$export$cb38f5a820347580.displayName = 'AsyncTransitionHomeRenderer';

const $7101fec8869f42fd$export$9cda67d6c86d7b98 = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("axR23")).then((module)=>module.WelcomeModalRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/ui/wizard/main.tsx"
});
$7101fec8869f42fd$export$9cda67d6c86d7b98.displayName = 'AsyncWelcomeModalRenderer';

const $7101fec8869f42fd$export$913f5a2340406083 = (0, $bJscI.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("6HtmX")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/right-sidebars/index.tsx"
}), ()=>null);
$7101fec8869f42fd$export$913f5a2340406083.displayName = 'MigrationHubRightSidebar';

const $7101fec8869f42fd$export$6d7715b12d3ad17b = (0, $bJscI.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("3XBWb")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/onboarding/index.tsx"
}), ()=>null);
$7101fec8869f42fd$export$6d7715b12d3ad17b.displayName = 'MigrationHubOnboarding';
const $7101fec8869f42fd$export$b8fa7ac7019001bb = (0, $6dwgv.createLayout)({
    get globalComponents () {
        return [
            $7101fec8869f42fd$export$cb38f5a820347580,
            $7101fec8869f42fd$export$9cda67d6c86d7b98,
            $7101fec8869f42fd$export$6d7715b12d3ad17b
        ];
    },
    rightSidebars: [
        $7101fec8869f42fd$export$913f5a2340406083
    ]
});

});
parcelRegister("arhTh", function(module, exports) {

let $799a4dad73eb55d5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $799a4dad73eb55d5$var$load("j23wJ").then(()=>parcelRequire('N7rTt'));

});

parcelRegister("axR23", function(module, exports) {

let $7ad61f83c7e636ca$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7ad61f83c7e636ca$var$load("iPQqv").then(()=>parcelRequire('6y9Ty'));

});

parcelRegister("6HtmX", function(module, exports) {

let $4e0d8a5b5997acd5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4e0d8a5b5997acd5$var$load("a2Uvg").then(()=>parcelRequire('9HF0e'));

});

parcelRegister("3XBWb", function(module, exports) {

let $2e244f597d9816b6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2e244f597d9816b6$var$load("iD0hI").then(()=>parcelRequire('9XKDI'));

});



parcelRegister("9aj7y", function(module, exports) {

$parcel$export(module.exports, "dashboardRoute", () => $27e86cdbb90113ab$export$3bf0ecb39349b6ef);
const $27e86cdbb90113ab$export$3bf0ecb39349b6ef = {
    name: 'dashboard',
    path: '/secure/Dashboard.jspa'
};

});

parcelRegister("doZ3p", function(module, exports) {

$parcel$export(module.exports, "DashboardRedirect", () => $03c8cbf0c62ac2eb$export$da833ddcffcc38ba);

var $eJOHy = parcelRequire("eJOHy");

var $hih5V = parcelRequire("hih5V");

var $7fTjp = parcelRequire("7fTjp");

var $02kpm = parcelRequire("02kpm");
var $gCY1z = parcelRequire("gCY1z");
const $03c8cbf0c62ac2eb$export$da833ddcffcc38ba = ()=>{
    const [{ query: query, location: { hash: hash } }] = (0, $gCY1z.useRouter)();
    const { path: path } = (0, $hih5V.useRouteByName)('dashboard-view') ?? {};
    if (path == null) throw new Error('Dashboard view route not found');
    const { selectPageId: id } = query;
    const idParam = /^\d+$/.test(id) ? id : 'last-visited';
    const generatedPath = (0, $02kpm.generatePath)(path, {
        dashboardId: idParam
    });
    const maximizedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
    const pathWithQuery = maximizedId !== null ? `${generatedPath}?maximized=${maximizedId}` : generatedPath;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: pathWithQuery,
        persistSearchParams: false
    });
};

});


parcelRegister("4BD3h", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRedirectRouteEntry", () => $15a393c2e4817283$export$8dae8091f8e43b97);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9l1y1 = parcelRequire("9l1y1");

var $9NmsS = parcelRequire("9NmsS");

var $41bNV = parcelRequire("41bNV");

var $7fTjp = parcelRequire("7fTjp");

var $iMFdk = parcelRequire("iMFdk");

var $fRaUi = parcelRequire("fRaUi");
const $15a393c2e4817283$var$DashboardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/dashboards"
    });
const $15a393c2e4817283$export$8dae8091f8e43b97 = (0, $6xToB.createEntry)((0, $41bNV.dashboardsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $9l1y1.dashboardsDirectoryResource)
        ],
        component: !false ? $15a393c2e4817283$var$DashboardsDirectoryRedirect : (0, $fRaUi.DashboardsDirectoryComponent),
        skeleton: (0, $iMFdk.DashboardsDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fRaUi.LazyDashboardsDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("9l1y1", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryResource", () => $20253ccc3882e5b9$export$1cf6c7815471c2a2);

var $cJYBV = parcelRequire("cJYBV");

var $l1VxS = parcelRequire("l1VxS");
const $20253ccc3882e5b9$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY = 'DASHBOARDS_DIRECTORY';

const $20253ccc3882e5b9$export$1cf6c7815471c2a2 = (0, $l1VxS.createResource)({
    type: $20253ccc3882e5b9$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("8udHD")),
    maxAge: (0, $cJYBV.MIN_MAX_AGE)
});

});
parcelRegister("8udHD", function(module, exports) {

let $62dbc1261be6dfdd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $62dbc1261be6dfdd$var$load("74vMZ").then(()=>parcelRequire('6qyMq'));

});


parcelRegister("41bNV", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRedirectRoute", () => $f4dfd28f92ee4173$export$b96f6fb3c35a6fe5);
const $f4dfd28f92ee4173$export$b96f6fb3c35a6fe5 = {
    name: 'dashboards-directory-secure',
    path: '/secure/ConfigurePortalPages(!default.jspa|.jspa)'
};

});

parcelRegister("fRaUi", function(module, exports) {

$parcel$export(module.exports, "LazyDashboardsDirectory", () => $da5c1fc915e72d55$export$f2f3fd22cd37e121);
$parcel$export(module.exports, "DashboardsDirectoryComponent", () => $da5c1fc915e72d55$export$1cc6cc01050e1215);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $da5c1fc915e72d55$export$f2f3fd22cd37e121 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("a9ES3"))), {
    moduleId: "./src/packages/spa-apps/directories/dashboards/src/index.tsx"
});
const $da5c1fc915e72d55$export$1cc6cc01050e1215 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $da5c1fc915e72d55$export$f2f3fd22cd37e121,
        pageId: "dashboards-directory",
        shouldShowSpinner: false
    });

});
parcelRegister("a9ES3", function(module, exports) {

let $764a72bbb11fdeef$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $764a72bbb11fdeef$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $764a72bbb11fdeef$var$load("deNlq")
        ]);
    }),
    $764a72bbb11fdeef$var$load("1VRB2"),
    $764a72bbb11fdeef$var$load("bABhq"),
    $764a72bbb11fdeef$var$load("1fn1t")
]).then(()=>parcelRequire('8iNv0'));

});



parcelRegister("czPgr", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRouteEntry", () => $3569b78ccc33f692$export$748e329bd0c282a);

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9l1y1 = parcelRequire("9l1y1");

var $9NmsS = parcelRequire("9NmsS");

var $fuV6j = parcelRequire("fuV6j");

var $iMFdk = parcelRequire("iMFdk");

var $g8uYY = parcelRequire("g8uYY");

var $lixcc = parcelRequire("lixcc");

var $hUpHQ = parcelRequire("hUpHQ");

var $lqtcb = parcelRequire("lqtcb");
const $3569b78ccc33f692$export$748e329bd0c282a = (0, $6xToB.createEntry)((0, $fuV6j.dashboardsDirectoryRoute), ()=>({
        group: 'directories',
        entryPoint: ()=>$3569b78ccc33f692$var$pageEntryPoint,
        skeleton: (0, $iMFdk.DashboardsDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $9l1y1.dashboardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        supportsPreviewPanel: true
    }));
// Page entrypoint, referred to above...
const $3569b78ccc33f692$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $lqtcb.dashboardDirectoryEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).DASHBOARDS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $hUpHQ.nav4DashboardsContentEntryPoint)
            }
        }
    }
});

});
parcelRegister("lqtcb", function(module, exports) {

$parcel$export(module.exports, "dashboardDirectoryEntryPoint", () => $7d994a9615f2c1db$export$3325d832741ebeb3);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $7d994a9615f2c1db$export$3325d832741ebeb3 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("a9ES3")), {
        moduleId: "933882c8",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});


parcelRegister("7Zjtg", function(module, exports) {

$parcel$export(module.exports, "dashboardViewEmbedRouteEntry", () => $3bc9683c1ed0874b$export$73a377380ff671af);

var $3O07j = parcelRequire("3O07j");


var $1wb5r = parcelRequire("1wb5r");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $cxQGT = parcelRequire("cxQGT");

var $1LonB = parcelRequire("1LonB");

var $en43l = parcelRequire("en43l");
const $3bc9683c1ed0874b$export$73a377380ff671af = (0, $6xToB.createEntry)((0, $1LonB.dashboardViewEmbedRoute), ()=>({
        group: 'dashboard',
        component: (0, $en43l.DashboardViewEmbedPage),
        layout: (0, $6dwgv.createLayout)({
            globalComponents: [
                (0, $3O07j.DashboardBackgroundScripts)
            ],
            isChromeless: true
        }),
        resources: [
            (0, $cxQGT.themePreferenceResource),
            ...(0, $en43l.dashboardResources)()
        ],
        forPaint: [
            (0, $en43l.LazyDashboardViewEmbed)
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $1wb5r.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("1LonB", function(module, exports) {

$parcel$export(module.exports, "dashboardViewEmbedRoute", () => $9eb7d3f85958508e$export$258b5e3f294617d2);
const $9eb7d3f85958508e$export$258b5e3f294617d2 = {
    name: 'dashboard-view-embed',
    path: '/jira/dashboards/:dashboardId(\\d+)/embed',
    query: [],
    exact: true
};

});


parcelRegister("1Jz0d", function(module, exports) {

$parcel$export(module.exports, "dashboardViewRouteEntry", () => $4f211a4e781d6bbf$export$18226b6422149926);

var $7IYIF = parcelRequire("7IYIF");


var $1wb5r = parcelRequire("1wb5r");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $kmQWD = parcelRequire("kmQWD");

var $7EJL7 = parcelRequire("7EJL7");

var $g8uYY = parcelRequire("g8uYY");

var $lixcc = parcelRequire("lixcc");

var $hUpHQ = parcelRequire("hUpHQ");

var $en43l = parcelRequire("en43l");
const $4f211a4e781d6bbf$export$18226b6422149926 = (0, $6xToB.createEntry)((0, $kmQWD.dashboardViewRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$4f211a4e781d6bbf$var$pageEntryPoint,
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $7IYIF.dashboardBackgroundScriptsLayout)),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $en43l.dashboardResources)()
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $1wb5r.NORMAL_EARLY_ASSET_STRATEGY),
        ufoName: 'dashboard',
        supportsPreviewPanel: true
    }));
const $4f211a4e781d6bbf$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $7EJL7.dashboardViewEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).DASHBOARDS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $hUpHQ.nav4DashboardsContentEntryPoint)
            }
        }
    }
});

});
parcelRegister("kmQWD", function(module, exports) {

$parcel$export(module.exports, "dashboardViewRoute", () => $d44c47ccc7ce6a45$export$24f1b2ff97b9d3e6);
const $d44c47ccc7ce6a45$export$24f1b2ff97b9d3e6 = {
    name: 'dashboard-view',
    path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
    query: [
        'maximized?'
    ],
    exact: true
};

});

parcelRegister("7EJL7", function(module, exports) {

$parcel$export(module.exports, "dashboardViewEntryPoint", () => $21c1d7e9bf95e874$export$acd33fbfe610d0e6);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $21c1d7e9bf95e874$export$acd33fbfe610d0e6 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("5tSbt")), {
        moduleId: "2821e152",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});


parcelRegister("kJhhx", function(module, exports) {

$parcel$export(module.exports, "dashboardWallboardRouteEntry", () => $b76beb67f2413d0e$export$6009dd8e88f1a7de);

var $3O07j = parcelRequire("3O07j");


var $1wb5r = parcelRequire("1wb5r");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $cxQGT = parcelRequire("cxQGT");

var $7L9Wn = parcelRequire("7L9Wn");

var $g8uYY = parcelRequire("g8uYY");

var $8giOv = parcelRequire("8giOv");

var $en43l = parcelRequire("en43l");
const $b76beb67f2413d0e$export$6009dd8e88f1a7de = (0, $6xToB.createEntry)((0, $7L9Wn.dashboardWallboardRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$b76beb67f2413d0e$var$dashboardWallboardPageEntryPoint,
        layout: (0, $6dwgv.createLayout)({
            globalComponents: [
                (0, $3O07j.DashboardBackgroundScripts)
            ],
            // we don't want nav bar and right panel etc to appear in wallboard, so we use chromeless mode
            isChromeless: true
        }),
        resources: [
            (0, $cxQGT.themePreferenceResource),
            ...(0, $en43l.dashboardResources)()
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $1wb5r.NORMAL_EARLY_ASSET_STRATEGY)
    }));
const $b76beb67f2413d0e$var$dashboardWallboardPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $8giOv.dashboardWallboardEntryPoint)
});

});
parcelRegister("7L9Wn", function(module, exports) {

$parcel$export(module.exports, "dashboardWallboardRoute", () => $fdfaa2dfb7f3b9a4$export$eaa33c953ab9ca63);
const $fdfaa2dfb7f3b9a4$export$eaa33c953ab9ca63 = {
    name: 'dashboard-wallboard',
    path: '/jira/dashboards/wallboard',
    query: [
        'dashboardId',
        'cyclePeriod?',
        'transitionFx?',
        'random?'
    ],
    exact: true
};

});

parcelRegister("8giOv", function(module, exports) {

$parcel$export(module.exports, "dashboardWallboardEntryPoint", () => $88c6d758580a5f43$export$99f21964c00b61ef);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $88c6d758580a5f43$export$99f21964c00b61ef = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("kQZvV")), {
        moduleId: "b10917db",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("kQZvV", function(module, exports) {

let $f2e8615af1e7a94e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f2e8615af1e7a94e$var$load("bZkqQ").then(()=>parcelRequire('i04af'));

});



parcelRegister("5Ufi9", function(module, exports) {

$parcel$export(module.exports, "devopsConnectedProjectRouteEntry", () => $ef2048fddb43ff08$export$ae258fb8ec2c1f86);

var $kHlOR = parcelRequire("kHlOR");

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $agnyK = parcelRequire("agnyK");

var $6ZXtj = parcelRequire("6ZXtj");
const $ef2048fddb43ff08$export$ae258fb8ec2c1f86 = (0, $6xToB.createEntry)((0, $agnyK.devopsConnectedProjectRoute), ()=>({
        group: 'devops',
        ufoName: 'devops.connected-project',
        component: (0, $6ZXtj.default),
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6ZXtj.LazyDevopsConnectedProject)
        ]
    }));

});
parcelRegister("agnyK", function(module, exports) {

$parcel$export(module.exports, "devopsConnectedProjectRoute", () => $4dcba4b6da22a793$export$91257312631802bc);
const $4dcba4b6da22a793$export$91257312631802bc = {
    name: 'devops-connected-project',
    path: '/jira/devops/connected-project'
};

});

parcelRegister("6ZXtj", function(module, exports) {

$parcel$export(module.exports, "LazyDevopsConnectedProject", () => $fa420428cf303180$export$dcd3d20b0038b35c);
$parcel$export(module.exports, "default", () => $fa420428cf303180$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $fa420428cf303180$export$dcd3d20b0038b35c = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4bZvY"))), {
    moduleId: "./src/packages/spa-apps/devops-connected-project/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fa420428cf303180$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fa420428cf303180$export$dcd3d20b0038b35c,
        pageId: "devops-connected-project",
        shouldShowSpinner: true
    });

});
parcelRegister("4bZvY", function(module, exports) {

let $30d7e80e7eba3a8a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $30d7e80e7eba3a8a$var$load("jMhNI").then(()=>parcelRequire('WpfYQ'));

});



parcelRegister("l8WGY", function(module, exports) {

$parcel$export(module.exports, "digestsNotificationsPersonalSettingsRouteEntry", () => $188a9bf64694b85c$export$6ff00ce079beb0ed);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $eaZMD = parcelRequire("eaZMD");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $kdVPH = parcelRequire("kdVPH");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $188a9bf64694b85c$var$LazyDigestsNotificationsPersonalSettings = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("jTMsj"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings/digests-notifications/src/index.tsx"
});
const $188a9bf64694b85c$var$DigestsNotificationsPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $188a9bf64694b85c$var$LazyDigestsNotificationsPersonalSettings,
        pageId: "personal-settings-notifications",
        shouldShowSpinner: true
    });
const $188a9bf64694b85c$export$6ff00ce079beb0ed = (0, $6xToB.createEntry)((0, $kdVPH.digestsNotificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: $188a9bf64694b85c$var$DigestsNotificationsPersonalSettingsComponent,
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PROFILE,
            sidebar: (0, $eaZMD.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $188a9bf64694b85c$var$LazyDigestsNotificationsPersonalSettings
        ]
    }));

});
parcelRegister("eaZMD", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa192dcf2dceb161$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $aa192dcf2dceb161$var$LazyPersonalSettingsSidebar = (0, $gzcjr.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("7KTxJ")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/personal-settings/src/index.tsx"
});
const $aa192dcf2dceb161$var$PersonalSettingsSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "personalSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa192dcf2dceb161$var$LazyPersonalSettingsSidebar, null));
var $aa192dcf2dceb161$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($aa192dcf2dceb161$var$PersonalSettingsSidebar);

});
parcelRegister("7KTxJ", function(module, exports) {

let $5a57e9fe7900d801$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5a57e9fe7900d801$var$load("i6yLp").then(()=>parcelRequire('7MdHb'));

});


parcelRegister("kdVPH", function(module, exports) {

$parcel$export(module.exports, "digestsNotificationsPersonalSettingsRoute", () => $1833a171e9ff0806$export$36b31d006b9456a1);
const $1833a171e9ff0806$export$36b31d006b9456a1 = {
    name: 'personal-settings-digests',
    path: '/jira/settings/personal/digests'
};

});

parcelRegister("jTMsj", function(module, exports) {

let $e7c8bda607b5b5a9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e7c8bda607b5b5a9$var$load("a84Ct").then(()=>parcelRequire('4948p'));

});


parcelRegister("d29rL", function(module, exports) {

$parcel$export(module.exports, "emailNotificationsLogAccessRouteEntry", () => $2521abd1a1635c49$export$4d57b993ce36e7b2);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $aNm4v = parcelRequire("aNm4v");

var $6WhGP = parcelRequire("6WhGP");

var $7A34I = parcelRequire("7A34I");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $5fjzQ = parcelRequire("5fjzQ");
const $2521abd1a1635c49$var$emailNotificationsLogEntryPointPage = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $7A34I.notificationLogsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

const $2521abd1a1635c49$var$LazyNotificationLogsType = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("jZecm"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/notification-logs/src/index.tsx"
});
const $2521abd1a1635c49$var$NotificationLogs = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $2521abd1a1635c49$var$LazyNotificationLogsType,
        pageId: "Notification Logs",
        shouldShowSpinner: false
    });
const $2521abd1a1635c49$export$4d57b993ce36e7b2 = (0, $6xToB.createEntry)((0, $6WhGP.emailNotificationsLogAccessRoute), ()=>({
        group: 'global-settings',
        component: $2521abd1a1635c49$var$NotificationLogs,
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $aNm4v.systemConfigurationGeneralResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $2521abd1a1635c49$var$LazyNotificationLogsType
        ],
        pageId: 'admin-settings-email-notifications-log',
        entryPoint () {
            return $2521abd1a1635c49$var$emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("aNm4v", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationGeneralResource", () => $f0148833c09ef3ca$export$b622f7400bfafd0d);

var $l1VxS = parcelRequire("l1VxS");


const $f0148833c09ef3ca$export$b622f7400bfafd0d = (0, $l1VxS.createResource)({
    type: (0, $839d13d40d1761ff$export$e780b172f774b673),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("1TyXe"))
});

});
const $839d13d40d1761ff$export$e780b172f774b673 = 'RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL';

parcelRegister("1TyXe", function(module, exports) {

let $16160ab512239a0c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $16160ab512239a0c$var$load("j9BRY").then(()=>parcelRequire('aQoI6'));

});


parcelRegister("6WhGP", function(module, exports) {

$parcel$export(module.exports, "emailNotificationsLogAccessRoute", () => $2e31e685eac5cd0f$export$aed294a4a292b909);
const $2e31e685eac5cd0f$export$aed294a4a292b909 = {
    name: 'global-admin-helper-email-notifications-log',
    path: '/jira/settings/system/notification-logs',
    exact: true
};

});

parcelRegister("7A34I", function(module, exports) {

$parcel$export(module.exports, "notificationLogsEntryPoint", () => $9928e86358963954$export$818d841e00bb3749);

var $9yZIb = parcelRequire("9yZIb");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $9928e86358963954$export$818d841e00bb3749 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("jZecm")), {
        moduleId: "d533cc53",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $9yZIb.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context?.query?.projectId,
                        notificationType: 'INTERNAL_NOTIFICATION',
                        notificationActionType: 'USER_INVITE',
                        recipientId: ''
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});

});
parcelRegister("9yZIb", function(module, exports) {

$parcel$export(module.exports, "default", () => $118789b04b22ff28$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6106f34f1da05e19191cff41bffd4296>>
 * @relayHash 1d90cf309bc3da9c32297c3b1e952819
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71e1f26fd67e2af410f2d8354171d8867b0efd6546709fc85bec1419f20e5b6d
const $118789b04b22ff28$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "71e1f26fd67e2af410f2d8354171d8867b0efd6546709fc85bec1419f20e5b6d",
        "metadata": {},
        "name": "uiNotificationLogsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $118789b04b22ff28$export$2e2bcd8739ae039 = $118789b04b22ff28$var$node;

});

parcelRegister("jZecm", function(module, exports) {

let $e8ceba4d4eab632c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e8ceba4d4eab632c$var$load("6iwWU").then(()=>parcelRequire('cppNo'));

});



parcelRegister("47SW5", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingCreateRouteEntry", () => $0a350a8f2e007f4e$export$92f4b6644eb6cb88);

var $1r6q8 = parcelRequire("1r6q8");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $f5GYg = parcelRequire("f5GYg");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $jXwOY = parcelRequire("jXwOY");

var $4dPst = parcelRequire("4dPst");

var $91lt4 = parcelRequire("91lt4");
const $0a350a8f2e007f4e$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $0a350a8f2e007f4e$export$92f4b6644eb6cb88 = (0, $6xToB.createEntry)((0, $f5GYg.eocAlertIssueSyncingCreateRoute), ()=>({
        group: 'eoc',
        component: (0, $jXwOY.AlertIssueSync),
        slot: (0, $4dPst.AlertIssueSyncCreate),
        basePath: '/jira/settings/products/ops',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $1r6q8.resources).configuredSyncsResource,
            (0, $1r6q8.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$0a350a8f2e007f4e$var$getNavigationSpecifications()
        },
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync)
        ]
    }));

});
parcelRegister("1r6q8", function(module, exports) {

$parcel$export(module.exports, "resources", () => $278b7dd8e6a23b3c$export$bc99aaabaf7b70a7);

var $9yLd1 = parcelRequire("9yLd1");

var $7sva8 = parcelRequire("7sva8");

var $at7cW = parcelRequire("at7cW");

var $53BQM = parcelRequire("53BQM");
const $278b7dd8e6a23b3c$export$bc99aaabaf7b70a7 = {
    configuredSyncsResource: $9yLd1.configuredSyncsResource,
    userAccessRightsResource: $53BQM.userAccessRightsResource,
    getTeamResource: $at7cW.getTeamResource,
    isCurrentSiteSyncEnabledResource: $7sva8.isCurrentSiteSyncEnabledResource
};

});
parcelRegister("9yLd1", function(module, exports) {

$parcel$export(module.exports, "configuredSyncsResource", () => $881739331e05dc17$export$333c290f4a1ec41c);

var $l1VxS = parcelRequire("l1VxS");

var $cSq56 = parcelRequire("cSq56");

var $gHFxe = parcelRequire("gHFxe");
const $881739331e05dc17$export$333c290f4a1ec41c = (0, $l1VxS.createResource)({
    type: 'configuredSyncsResource',
    getKey: ({ query: query, match: match })=>{
        const teamId = match.params.teamId ?? query['teamId'];
        const keyword = query['keyword'];
        const type = query['type'];
        const page = query['page'] || '1';
        const status = query['status'];
        return (0, $cSq56.UrlHelper)('configuredSyncsResource', {
            page: page,
            keyword: keyword,
            type: type,
            status: status,
            teamId: teamId
        });
    },
    getData: (routerContext)=>(0, $gHFxe.default).getSyncs(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("cSq56", function(module, exports) {

$parcel$export(module.exports, "UrlHelper", () => $31f71a27b9ff1aff$export$bacbc496e850c0a4);
const $31f71a27b9ff1aff$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    const qs = new URLSearchParams(q).toString();
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("gHFxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $974204b58ddf07b2$export$2e2bcd8739ae039);

var $br21R = parcelRequire("br21R");

var $cSq56 = parcelRequire("cSq56");

const $974204b58ddf07b2$var$getSyncs = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $0cef7da4dbc097ac$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId ?? query.teamId,
        type: query.type,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $br21R.eocFetch)((0, $cSq56.UrlHelper)('/v1/entity-sync/unified', {
        ...queryParams,
        offset: offset.toString(),
        limit: (0, $0cef7da4dbc097ac$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $0cef7da4dbc097ac$export$31ecae7225aecec6)),
            itemCount: response.data.count
        }));
};
const $974204b58ddf07b2$var$patchSync = async (syncId, syncType, body, teamId)=>(0, $br21R.eocFetch)((0, $cSq56.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $974204b58ddf07b2$var$deleteSync = async (syncId, syncType, teamId)=>(0, $br21R.eocFetch)((0, $cSq56.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
var $974204b58ddf07b2$export$2e2bcd8739ae039 = {
    getSyncs: $974204b58ddf07b2$var$getSyncs,
    patchSync: $974204b58ddf07b2$var$patchSync,
    deleteSync: $974204b58ddf07b2$var$deleteSync
};

});
const $0cef7da4dbc097ac$export$31ecae7225aecec6 = 20;



parcelRegister("7sva8", function(module, exports) {

$parcel$export(module.exports, "isCurrentSiteSyncEnabledResource", () => $cbbeb8ec08a5f85b$export$94465df791bf80);

var $l1VxS = parcelRequire("l1VxS");

var $85EPc = parcelRequire("85EPc");
const $cbbeb8ec08a5f85b$export$94465df791bf80 = (0, $l1VxS.createResource)({
    type: 'isCurrentSiteSyncEnabledResource',
    getKey: ()=>`isCurrentSiteSyncEnabledResource`,
    getData: (0, $85EPc.getIsCurrentSiteSyncEnabled),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("85EPc", function(module, exports) {

$parcel$export(module.exports, "getIsCurrentSiteSyncEnabled", () => $f36bb7cd7e321873$export$93fc09e39edf63d0);

var $br21R = parcelRequire("br21R");
const $f36bb7cd7e321873$export$93fc09e39edf63d0 = ()=>(0, $br21R.eocFetch)(`/v1/entity-sync/is-current-site-enabled`).then((response)=>response.data.enabled);

});


parcelRegister("at7cW", function(module, exports) {

$parcel$export(module.exports, "getTeamResource", () => $c3b0ceb3753dcac1$export$50271c9e7f21f10e);

var $l1VxS = parcelRequire("l1VxS");

var $feIEW = parcelRequire("feIEW");
var $jXKdt = parcelRequire("jXKdt");

var $3u3ag = parcelRequire("3u3ag");
const $c3b0ceb3753dcac1$export$50271c9e7f21f10e = (0, $l1VxS.createResource)({
    type: 'getSyncTeamResource',
    getKey: (routerContext)=>`getSyncTeamResource#${routerContext.match.params?.teamId}`,
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $feIEW.assert)(!!teamId, new (0, $jXKdt.AssertionError)('getTeamResource', 'teamId should be set to fetch the team'));
        const result = await (0, $3u3ag.getTeam)(teamId);
        return result ?? null;
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("3u3ag", function(module, exports) {

$parcel$export(module.exports, "getTeam", () => $a02484fe3822f6ed$export$491fe77f22ab2b51);

var $br21R = parcelRequire("br21R");
const $a02484fe3822f6ed$export$491fe77f22ab2b51 = (teamId)=>(0, $br21R.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    }).then((response)=>response.values.filter((responder)=>!responder.deleted).at(0));

});


parcelRegister("53BQM", function(module, exports) {

$parcel$export(module.exports, "userAccessRightsResource", () => $8348e9173940c1e4$export$69ddc7cc64ae9a02);

var $l1VxS = parcelRequire("l1VxS");

var $jYOws = parcelRequire("jYOws");
const $8348e9173940c1e4$export$69ddc7cc64ae9a02 = (0, $l1VxS.createResource)({
    type: 'userAccessRightsResource',
    getKey: ()=>'userAccessRightsResource',
    getData: (routerContext)=>(0, $jYOws.getUserRights)(routerContext.match.params.teamId),
    maxAge: 600000,
    isBrowserOnly: true
});

});
parcelRegister("jYOws", function(module, exports) {

$parcel$export(module.exports, "getUserRights", () => $fc6a3c25f8b5c200$export$84e2ed279bc4e64e);

var $br21R = parcelRequire("br21R");

var $cSq56 = parcelRequire("cSq56");
const $fc6a3c25f8b5c200$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $br21R.eocFetch)((0, $cSq56.UrlHelper)(`/v1/entity-sync/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data.userAccessRights);
};

});



parcelRegister("f5GYg", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingCreateRoute", () => $fd5513f4a6b1d432$export$f271eef5f9ec6602);
const $fd5513f4a6b1d432$export$f271eef5f9ec6602 = {
    name: 'eoc-alert-issue-syncing-create',
    path: '/jira/settings/products/ops/syncs/create',
    exact: true
};

});

parcelRegister("17wyZ", function(module, exports) {

$parcel$export(module.exports, "LazyHorizontalOperationsConfigurationNav", () => $9602bbd162c7b35f$export$aea682543f08e131);
$parcel$export(module.exports, "AsyncHorizontalOperationsConfigurationNav", () => $9602bbd162c7b35f$export$1f7a0efe3746ea0d);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $9602bbd162c7b35f$export$aea682543f08e131 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("74gzk")).then(({ HorizontalOperationsConfiguration: HorizontalOperationsConfiguration })=>HorizontalOperationsConfiguration), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/horizontal-nav-operations-configuration/src/ui/index.tsx"
});
const $9602bbd162c7b35f$export$1f7a0efe3746ea0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jira-operations-configurations-horizontal-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "asyncHorizontalOperationsConfigurationNav",
        packageName: "jiraOperationsConfigurationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9602bbd162c7b35f$export$aea682543f08e131, null)));

});
parcelRegister("74gzk", function(module, exports) {

let $5255c25802f118f9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5255c25802f118f9$var$load("kt4AE").then(()=>parcelRequire('d9nVP'));

});


parcelRegister("fXF6E", function(module, exports) {

$parcel$export(module.exports, "LazySidebarContent", () => $72f17456b4756ef4$export$5cb783b45e692ee9);
$parcel$export(module.exports, "default", () => $72f17456b4756ef4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $bYKAe = parcelRequire("bYKAe");

var $er9fy = parcelRequire("er9fy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $gZTP9 = parcelRequire("gZTP9");

var $gDXSd = parcelRequire("gDXSd");

var $7jTnu = parcelRequire("7jTnu");

var $2mHfh = parcelRequire("2mHfh");

const $72f17456b4756ef4$export$5cb783b45e692ee9 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("1i1cu")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/operations/src/ui/main.tsx"
});
const $72f17456b4756ef4$var$AsyncSidebar = ()=>{
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const { isOpsAdmin: isOpsAdmin } = (0, $gDXSd.useOgTenantInfo)();
    const hasOperationsGeneralConfiguration = (0, $7jTnu.fg)('operations-tenant-info-endpoint-update') ? isAdmin || isOpsAdmin : isAdmin;
    if (!hasOperationsGeneralConfiguration && (0, $7jTnu.fg)('redirect_user_to_ops_page_from_global_settings')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.operations-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsOperationsSettings",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: "/jira/ops/overview"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.operations-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsOperationsSettings",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYKAe.SidebarContent), {
        currentPageName: "operations",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-operations.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.global-settings.operations-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $er9fy.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($72f17456b4756ef4$export$5cb783b45e692ee9, null))));
};
var $72f17456b4756ef4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($72f17456b4756ef4$var$AsyncSidebar);

});
parcelRegister("bYKAe", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $77dbf0d832306973$export$49e8f7b58a4df4ea);

var $eJOHy = parcelRequire("eJOHy");

var $bvFRW = parcelRequire("bvFRW");

var $bL3dk = parcelRequire("bL3dk");
var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");

var $2y3Ci = parcelRequire("2y3Ci");
var $1Can4 = parcelRequire("1Can4");
var $2klPI = parcelRequire("2klPI");

var $lRq8t = parcelRequire("lRq8t");

var $dmCMv = parcelRequire("dmCMv");

var $6mubb = parcelRequire("6mubb");

var $8Ik7k = parcelRequire("8Ik7k");
const $77dbf0d832306973$export$49e8f7b58a4df4ea = ({ children: children, currentPageName: currentPageName, testId: testId = 'navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content' })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2klPI.SideNavHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.200",
        xcss: $77dbf0d832306973$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        alignBlock: "center",
        grow: "hug",
        space: "space.100",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content.header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dmCMv.BackButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $8Ik7k.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6mubb.AsyncPageSwitcher), {
        currentPageName: currentPageName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Can4.SideNavContent), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y3Ci.MenuList), null, children)));
};
const $77dbf0d832306973$var$headingStyles = (0, $5Wv5g.xcss)({
    // 4px of left padding is added to align the back icon with the side nav toggle button
    paddingInlineStart: 'space.050'
});

});
parcelRegister("2klPI", function(module, exports) {

$parcel$export(module.exports, "SideNavHeader", () => $1863702d8c02a3c5$export$9d28ff3a0d89869c);
/* side-nav-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $1863702d8c02a3c5$var$styles = {
    root: "_18zrutpp _1q51utpp _85i51b66"
};
const $1863702d8c02a3c5$export$9d28ff3a0d89869c = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $1863702d8c02a3c5$var$styles.root
        ]),
        children: children
    });
};

});

parcelRegister("dmCMv", function(module, exports) {

$parcel$export(module.exports, "BackButton", () => $03ccf5889850875c$export$e0d897ee21382f67);

var $eJOHy = parcelRequire("eJOHy");

var $i0PfN = parcelRequire("i0PfN");

var $3d7x1 = parcelRequire("3d7x1");

var $9JB3T = parcelRequire("9JB3T");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $iMOVa = parcelRequire("iMOVa");

var $hJP5z = parcelRequire("hJP5z");
function $03ccf5889850875c$export$e0d897ee21382f67() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { previousUrl: previousUrl } = (0, $iMOVa.useNavigateBack)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: formatMessage((0, $hJP5z.default).tooltip),
        hideTooltipOnMouseDown: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0PfN.default), {
        href: previousUrl || '',
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3d7x1))),
        label: formatMessage((0, $hJP5z.default).label),
        onClick: ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
        }
    }));
}

});
parcelRegister("iMOVa", function(module, exports) {

$parcel$export(module.exports, "useNavigateBack", () => $c7e8cc63d19de1c5$export$7ce1f551d78f9130);
$parcel$export(module.exports, "NavigateBackProvider", () => $c7e8cc63d19de1c5$export$e1e76f4ee7f8174d);

var $eJOHy = parcelRequire("eJOHy");

var $iIQmy = parcelRequire("iIQmy");

var $fs2Be = parcelRequire("fs2Be");

var $7jTnu = parcelRequire("7jTnu");

var $2FqDG = parcelRequire("2FqDG");

var $gtV1h = parcelRequire("gtV1h");
const $c7e8cc63d19de1c5$var$STORAGE_KEY = 'back-button-url';
const $c7e8cc63d19de1c5$var$NavigateBackContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $c7e8cc63d19de1c5$export$7ce1f551d78f9130 = ()=>{
    const context = (0, $eJOHy.useContext)($c7e8cc63d19de1c5$var$NavigateBackContext);
    if (!context) throw new Error('useNavigateBack must be used within a NavigateBackProvider');
    return context;
};
function $c7e8cc63d19de1c5$export$e1e76f4ee7f8174d({ children: children }) {
    const [projectKey] = (0, $2FqDG.usePathParam)('projectKey');
    const homeRouteToUse = (0, $7jTnu.fg)('blu-7514_update_jira_home_your_work_to_for_you') ? (0, $iIQmy.jiraHomeRoute) : (0, $fs2Be.oldJiraHomeRoute);
    const defaultInitialUrl = projectKey ? `/projects/${projectKey}` : homeRouteToUse.path;
    const [previousUrl, setPreviousUrl] = (0, $eJOHy.useState)(()=>(0, $gtV1h.storageProvider).get($c7e8cc63d19de1c5$var$STORAGE_KEY) ?? defaultInitialUrl);
    const saveCurrentRoute = (0, $eJOHy.useCallback)((currentUrl)=>{
        setPreviousUrl(currentUrl);
        (0, $gtV1h.storageProvider).set($c7e8cc63d19de1c5$var$STORAGE_KEY, currentUrl);
    }, []);
    const value = (0, $eJOHy.useMemo)(()=>({
            saveCurrentRoute: saveCurrentRoute,
            previousUrl: previousUrl
        }), [
        saveCurrentRoute,
        previousUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7e8cc63d19de1c5$var$NavigateBackContext.Provider, {
        value: value
    }, children);
}

});
parcelRegister("gtV1h", function(module, exports) {

$parcel$export(module.exports, "storageProvider", () => $4106a8f58da85e5f$export$ce7751641b93537d);

var $4elgJ = parcelRequire("4elgJ");
const $4106a8f58da85e5f$export$ce7751641b93537d = (0, $4elgJ.createSessionStorageProvider)('sidebar-navigation');

});


parcelRegister("hJP5z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a9705df1d6b4200$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4a9705df1d6b4200$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltip: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.tooltip",
        "defaultMessage": "Go back"
    },
    label: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.label",
        "defaultMessage": "Navigate back to the previous page"
    }
});

});


parcelRegister("6mubb", function(module, exports) {

$parcel$export(module.exports, "AsyncPageSwitcher", () => $268b1c2797b82553$export$3130bd98029942c);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");
const $268b1c2797b82553$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $268b1c2797b82553$var$headingSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $268b1c2797b82553$var$dropdownSkeleton
    }));

const $268b1c2797b82553$var$LazyPageSwitcher = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("ema4L")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/common/src/common/ui/page-switcher/main.tsx"
});
const $268b1c2797b82553$export$3130bd98029942c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.global-settings.page-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($268b1c2797b82553$export$8f31e4c4a37b8e9c, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($268b1c2797b82553$var$LazyPageSwitcher, props));
const $268b1c2797b82553$var$headingSkeleton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100'
});
const $268b1c2797b82553$var$dropdownSkeleton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});
parcelRegister("ema4L", function(module, exports) {

let $a73aefa21c5bf682$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a73aefa21c5bf682$var$load("cuBkC").then(()=>parcelRequire('iBhA4'));

});


parcelRegister("8Ik7k", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c3432e4bbefd7de$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6c3432e4bbefd7de$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.heading",
        "defaultMessage": "Jira admin settings"
    }
});

});


parcelRegister("er9fy", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $61ade8359bd67b6e$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");
const $61ade8359bd67b6e$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $61ade8359bd67b6e$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $61ade8359bd67b6e$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $61ade8359bd67b6e$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $61ade8359bd67b6e$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $61ade8359bd67b6e$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $61ade8359bd67b6e$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $61ade8359bd67b6e$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $61ade8359bd67b6e$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $61ade8359bd67b6e$var$menuItem
    }));
const $61ade8359bd67b6e$var$sectionHeading = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100',
    marginTop: 'space.100'
});
const $61ade8359bd67b6e$var$menuItem = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("1i1cu", function(module, exports) {

let $0f086741eaefa5b9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0f086741eaefa5b9$var$load("a9SYQ").then(()=>parcelRequire('5HAMb'));

});


parcelRegister("jXwOY", function(module, exports) {

$parcel$export(module.exports, "AlertIssueSync", () => $171cde3cecf9f5e8$export$5a4922ba79d730f4);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $91lt4 = parcelRequire("91lt4");
const $171cde3cecf9f5e8$export$5a4922ba79d730f4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $91lt4.LazyAlertIssueSync),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });

});
parcelRegister("91lt4", function(module, exports) {

$parcel$export(module.exports, "LazyAlertIssueSync", () => $fbbc03211b5cc15e$export$dbbcce89c7be1e71);
$parcel$export(module.exports, "LazyAlertIssueSyncCreate", () => $fbbc03211b5cc15e$export$ff3e9ed7471eebce);
$parcel$export(module.exports, "LazyAlertIssueSyncDetail", () => $fbbc03211b5cc15e$export$75137a2a583918e2);

var $gzcjr = parcelRequire("gzcjr");

const $fbbc03211b5cc15e$export$dbbcce89c7be1e71 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("6dHyz")).then((module)=>module.AlertIssueSync), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $fbbc03211b5cc15e$export$ff3e9ed7471eebce = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("6dHyz")).then((module)=>module.AlertIssueSyncCreate), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $fbbc03211b5cc15e$export$75137a2a583918e2 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("6dHyz")).then((module)=>module.AlertIssueSyncDetail), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

});
parcelRegister("6dHyz", function(module, exports) {

let $4875be6e5a794fb5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $4875be6e5a794fb5$var$load("1VRB2"),
    $4875be6e5a794fb5$var$load("bABhq"),
    $4875be6e5a794fb5$var$load("bXV1Q")
]).then(()=>parcelRequire('6dsY7'));

});



parcelRegister("4dPst", function(module, exports) {

$parcel$export(module.exports, "AlertIssueSyncCreate", () => $0359aa9666dfd98a$export$a26f24c49385cf3a);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $91lt4 = parcelRequire("91lt4");
const $0359aa9666dfd98a$export$a26f24c49385cf3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $91lt4.LazyAlertIssueSyncCreate),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });

});


parcelRegister("jP5bP", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingDetailRouteEntry", () => $340f4a7b0a748fb9$export$7e604b22ae6e7c1e);

var $1r6q8 = parcelRequire("1r6q8");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $78a75 = parcelRequire("78a75");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $jXwOY = parcelRequire("jXwOY");

var $gne1j = parcelRequire("gne1j");

var $91lt4 = parcelRequire("91lt4");
const $340f4a7b0a748fb9$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $340f4a7b0a748fb9$export$7e604b22ae6e7c1e = (0, $6xToB.createEntry)((0, $78a75.eocAlertIssueSyncingDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $jXwOY.AlertIssueSync),
        slot: (0, $gne1j.AlertIssueSyncDetail),
        basePath: '/jira/settings/products/ops',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $1r6q8.resources).configuredSyncsResource,
            (0, $1r6q8.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$340f4a7b0a748fb9$var$getNavigationSpecifications()
        },
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync)
        ]
    }));

});
parcelRegister("78a75", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingDetailRoute", () => $e453ebe087689708$export$f1b4093ef603b98d);
const $e453ebe087689708$export$f1b4093ef603b98d = {
    name: 'eoc-alert-issue-syncing-detail',
    path: '/jira/settings/products/ops/syncs/:syncId',
    exact: true
};

});

parcelRegister("gne1j", function(module, exports) {

$parcel$export(module.exports, "AlertIssueSyncDetail", () => $8ddb0455f3defe71$export$c21f2a7e1aa801a7);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $91lt4 = parcelRequire("91lt4");
const $8ddb0455f3defe71$export$c21f2a7e1aa801a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $91lt4.LazyAlertIssueSyncDetail),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });

});


parcelRegister("lmaBn", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingRouteEntry", () => $e7669f2f70889228$export$c63d0942ec0f93c);

var $1r6q8 = parcelRequire("1r6q8");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $iRfwO = parcelRequire("iRfwO");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $83tUc = parcelRequire("83tUc");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $91lt4 = parcelRequire("91lt4");

var $jXwOY = parcelRequire("jXwOY");
const $e7669f2f70889228$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $e7669f2f70889228$export$c63d0942ec0f93c = (0, $6xToB.createEntry)((0, $83tUc.eocAlertIssueSyncingRoute), ()=>({
        group: 'eoc',
        component: (0, $jXwOY.AlertIssueSync),
        slot: null,
        basePath: '/jira/settings/products/ops',
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $1r6q8.resources).configuredSyncsResource,
            (0, $1r6q8.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$e7669f2f70889228$var$getNavigationSpecifications()
        },
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync)
        ]
    }));

});
parcelRegister("iRfwO", function(module, exports) {

$parcel$export(module.exports, "opsSettingsLayout", () => $89e42e11d77f40df$export$96d5e7da242cacf9);
$parcel$export(module.exports, "opsMigrationHubLayout", () => $89e42e11d77f40df$export$d4e92309ebd00b0f);
$parcel$export(module.exports, "opsNotificationsLayout", () => $89e42e11d77f40df$export$5714bc9520dbc6cf);

var $6dwgv = parcelRequire("6dwgv");

var $gzcjr = parcelRequire("gzcjr");

var $bJscI = parcelRequire("bJscI");

var $yRJUA = parcelRequire("yRJUA");

var $7h3uc = parcelRequire("7h3uc");

const $89e42e11d77f40df$export$f61c80ac3b95bc7d = (0, $bJscI.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("6HtmX")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/right-sidebars/index.tsx"
}), ()=>null);
$89e42e11d77f40df$export$f61c80ac3b95bc7d.displayName = 'RightSidebars';

const $89e42e11d77f40df$export$70238cd3868b67c9 = (0, $bJscI.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("3XBWb")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/onboarding/index.tsx"
}), ()=>null);
$89e42e11d77f40df$export$70238cd3868b67c9.displayName = 'Onboarding';
const $89e42e11d77f40df$export$96d5e7da242cacf9 = (0, $6dwgv.composeLayouts)((0, $yRJUA.globalSettingsLayout), {
    get globalComponents () {
        return [
            $89e42e11d77f40df$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $89e42e11d77f40df$export$f61c80ac3b95bc7d
    ]
});
const $89e42e11d77f40df$export$d4e92309ebd00b0f = (0, $6dwgv.createLayout)({
    get globalComponents () {
        return [
            $89e42e11d77f40df$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $89e42e11d77f40df$export$f61c80ac3b95bc7d
    ]
});
const $89e42e11d77f40df$export$5714bc9520dbc6cf = (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), {
    get globalComponents () {
        return [
            $89e42e11d77f40df$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $89e42e11d77f40df$export$f61c80ac3b95bc7d
    ]
});

});

parcelRegister("83tUc", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingRoute", () => $a0ff879417ff8c9b$export$73d6a0dc298aae15);
const $a0ff879417ff8c9b$export$73d6a0dc298aae15 = {
    name: 'eoc-alert-issue-syncing',
    path: '/jira/settings/products/ops/syncs',
    exact: true
};

});


parcelRegister("6egyA", function(module, exports) {

$parcel$export(module.exports, "eocApiKeyManagementRouteEntry", () => $0807834eb69697da$export$e18a6be3d2ffad71);

var $dM6RG = parcelRequire("dM6RG");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $j7rf7 = parcelRequire("j7rf7");

var $7jTnu = parcelRequire("7jTnu");

var $6zXPf = parcelRequire("6zXPf");

var $fXF6E = parcelRequire("fXF6E");

var $vd3SG = parcelRequire("vd3SG");
const $0807834eb69697da$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $0807834eb69697da$export$e18a6be3d2ffad71 = (0, $6xToB.createEntry)((0, $j7rf7.eocApiKeyManagementRoute), ()=>({
        group: 'eoc',
        component: (0, $vd3SG.default),
        layout: (0, $iRfwO.opsSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$0807834eb69697da$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $dM6RG.resources)()
        ],
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $vd3SG.LazyApiKeyManagement)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $vd3SG.LazyApiKeyManagement)
        ]
    }));

});
parcelRegister("dM6RG", function(module, exports) {

$parcel$export(module.exports, "apiKeysResource", () => $ad2e65c0d97f78c8$export$a98d5421eda11f29);
$parcel$export(module.exports, "resources", () => $ad2e65c0d97f78c8$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");
parcelRequire("dwoHY");
var $fbCoq = parcelRequire("fbCoq");

var $l3faq = parcelRequire("l3faq");
const $ad2e65c0d97f78c8$export$a98d5421eda11f29 = (0, $l1VxS.createResource)({
    type: 'api-key-management',
    getKey: ()=>'api-key-management',
    getData: async ({ dependencies: dependencies })=>{
        const data = await dependencies[(0, $fbCoq.eocUserResource).type]?.promise;
        return (0, $l3faq.fetchKeys)(data.accountId);
    },
    isBrowserOnly: true,
    maxCache: 0,
    maxAge: 0,
    depends: [
        (0, $fbCoq.eocUserResource).type
    ]
});
const $ad2e65c0d97f78c8$export$bc99aaabaf7b70a7 = ()=>[
        (0, $fbCoq.eocUserResource),
        $ad2e65c0d97f78c8$export$a98d5421eda11f29
    ];

});
parcelRegister("dwoHY", function(module, exports) {

$parcel$export(module.exports, "eocCommonResources", () => $8a2d1972e58d206d$export$8977bbbf2f7167d2);
$parcel$export(module.exports, "eocUserResource", () => (parcelRequire("fbCoq")).eocUserResource);

var $fbCoq = parcelRequire("fbCoq");
const $8a2d1972e58d206d$export$8977bbbf2f7167d2 = ()=>[
        (0, $fbCoq.eocUserResource)
    ];

});
parcelRegister("fbCoq", function(module, exports) {

$parcel$export(module.exports, "eocUserResource", () => $fe7eb9f80a9cc7e7$export$3a08a0bdeef86956);

var $l1VxS = parcelRequire("l1VxS");

var $6bB7s = parcelRequire("6bB7s");
const $fe7eb9f80a9cc7e7$export$3a08a0bdeef86956 = (0, $l1VxS.createResource)({
    type: 'create-user-resource',
    getKey: ()=>'create-user-resource',
    getData: async ()=>(0, $6bB7s.fetchJsmUserInfo)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("6bB7s", function(module, exports) {

$parcel$export(module.exports, "fetchJsmUserInfo", () => $a3e950cbaddaa300$export$7d750310098b5a7);

var $br21R = parcelRequire("br21R");
var $b388R = parcelRequire("b388R");
const $a3e950cbaddaa300$var$JSM_BASE_URL = '/rest/api/3/myself';
const $a3e950cbaddaa300$export$7d750310098b5a7 = ()=>{
    return (0, $br21R.eocFetch)($a3e950cbaddaa300$var$JSM_BASE_URL, {
        exactUrl: true,
        errorTransformer: (0, $b388R.jsmErrorTransformer)
    });
};

});



parcelRegister("l3faq", function(module, exports) {

$parcel$export(module.exports, "fetchKeys", () => $c79937d265462ce2$export$a0d93e1b78b8e70b);
$parcel$export(module.exports, "deleteApiKey", () => $c79937d265462ce2$export$d2f8649a375a4113);

var $br21R = parcelRequire("br21R");
const $c79937d265462ce2$export$a0d93e1b78b8e70b = async (accountId)=>{
    return (0, $br21R.eocFetch)('/api-keys/web?accountId=' + accountId);
};
const $c79937d265462ce2$export$d2f8649a375a4113 = async (key, accountId)=>{
    return (0, $br21R.eocFetch)(`/api-keys/web?apiKey=${key}&accountId=${accountId}`, {
        method: 'DELETE'
    });
};

});


parcelRegister("j7rf7", function(module, exports) {

$parcel$export(module.exports, "eocApiKeyManagementRoute", () => $37320d71e199c893$export$84985159d5695f4d);
const $37320d71e199c893$export$84985159d5695f4d = {
    name: 'eoc-api-key-management',
    path: '/jira/settings/products/ops/api-key-management',
    exact: true
};

});

parcelRegister("vd3SG", function(module, exports) {

$parcel$export(module.exports, "LazyApiKeyManagement", () => $591f70ea6542176a$export$6ae4b26c31b1b0d2);
$parcel$export(module.exports, "default", () => $591f70ea6542176a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $591f70ea6542176a$export$6ae4b26c31b1b0d2 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("lK1Xm")), {
    moduleId: "./src/packages/eoc/api-key-management/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$591f70ea6542176a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $591f70ea6542176a$export$6ae4b26c31b1b0d2,
        pageId: "async-jira-eoc-api-key-management",
        shouldShowSpinner: false
    });

});
parcelRegister("lK1Xm", function(module, exports) {

let $fd3f6960d3e4e33d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fd3f6960d3e4e33d$var$load("jo01H").then(()=>parcelRequire('fP0nh'));

});



parcelRegister("5JjgV", function(module, exports) {

$parcel$export(module.exports, "eocAssignCustomRolesRouteEntry", () => $80b7eb9e24c3f73b$export$c51a4ee3e3f1b270);

var $FPBNK = parcelRequire("FPBNK");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $hCdSq = parcelRequire("hCdSq");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $9fAJx = parcelRequire("9fAJx");
const $80b7eb9e24c3f73b$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $80b7eb9e24c3f73b$export$c51a4ee3e3f1b270 = (0, $6xToB.createEntry)((0, $hCdSq.eocAssignCustomRolesRoute), ()=>({
        group: 'eoc',
        component: (0, $9fAJx.default),
        layout: (0, $iRfwO.opsSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$80b7eb9e24c3f73b$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $FPBNK.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9fAJx.LazyAssignCustomRoles)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9fAJx.LazyAssignCustomRoles)
        ]
    }));

});
parcelRegister("FPBNK", function(module, exports) {

$parcel$export(module.exports, "rolesResource", () => $5b005bcea7cbfa3d$export$52e29d5915d5f674);
$parcel$export(module.exports, "resources", () => $5b005bcea7cbfa3d$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $e2Pej = parcelRequire("e2Pej");
const $5b005bcea7cbfa3d$export$52e29d5915d5f674 = (0, $l1VxS.createResource)({
    type: 'rolesResource',
    getKey: ()=>'rolesResource',
    getData: (0, $e2Pej.getRolesEndpoint),
    isBrowserOnly: true
});
const $5b005bcea7cbfa3d$export$bc99aaabaf7b70a7 = ()=>[
        $5b005bcea7cbfa3d$export$52e29d5915d5f674
    ];

});
parcelRegister("e2Pej", function(module, exports) {

$parcel$export(module.exports, "getUsersEndpoint", () => $a198752462e64a27$export$d372f7d69e481dba);
$parcel$export(module.exports, "getFilteredUsersEndpoint", () => $a198752462e64a27$export$d8f86d9603f031c0);
$parcel$export(module.exports, "getRolesEndpoint", () => $a198752462e64a27$export$7d0bc1a3c689fc74);
$parcel$export(module.exports, "updateRoleOfUserEndpoint", () => $a198752462e64a27$export$a0b296dc0259976f);

var $br21R = parcelRequire("br21R");

var $h4DEr = parcelRequire("h4DEr");
const $a198752462e64a27$export$d372f7d69e481dba = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, query] = queryKey;
    let url = new (0, $h4DEr.URLBuilder)(`/v1/users/search`).withQueryParam('limit', limit).withQueryParam('query', query).withQueryParam('cursor', lastEvaluatedToken).build();
    return (0, $br21R.eocFetch)(url);
};
const $a198752462e64a27$export$d8f86d9603f031c0 = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, ...filters] = queryKey;
    if (filters.length === 0) return Promise.resolve({
        lastEvaluatedToken: '',
        values: []
    });
    return (0, $br21R.eocFetch)('/v1/users/roles/filter', {
        method: 'POST',
        body: {
            limit: limit,
            roles: filters,
            offset: lastEvaluatedToken || 0
        }
    });
};
const $a198752462e64a27$export$7d0bc1a3c689fc74 = ()=>{
    return (0, $br21R.eocFetch)('/v1/users/roles');
};
const $a198752462e64a27$export$a0b296dc0259976f = ({ roleId: roleId, accountId: accountId })=>{
    return (0, $br21R.eocFetch)(`/v1/users/roles/assign`, {
        method: 'PATCH',
        body: {
            accountId: accountId,
            roleId: roleId
        }
    });
};

});
parcelRegister("h4DEr", function(module, exports) {

$parcel$export(module.exports, "URLBuilder", () => $915a9531a85d168a$export$61d2e8db329a11f8);
class $915a9531a85d168a$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '').map(([key, value])=>[
                key,
                value && value.toString()
            ]);
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams === '') return `${this.url}`;
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});



parcelRegister("hCdSq", function(module, exports) {

$parcel$export(module.exports, "eocAssignCustomRolesRoute", () => $b8461b7b2865c5e2$export$79c37191a61ac94b);
const $b8461b7b2865c5e2$export$79c37191a61ac94b = {
    name: 'eoc-assign-custom-roles',
    path: '/jira/settings/products/ops/role-assignment',
    exact: true
};

});

parcelRegister("9fAJx", function(module, exports) {

$parcel$export(module.exports, "LazyAssignCustomRoles", () => $5bfcff16018399de$export$fb6bafef9453a357);
$parcel$export(module.exports, "default", () => $5bfcff16018399de$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $5bfcff16018399de$export$fb6bafef9453a357 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("gwdei")), {
    moduleId: "./src/packages/eoc/assign-custom-roles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5bfcff16018399de$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $5bfcff16018399de$export$fb6bafef9453a357,
        pageId: "async-eoc-assign-custom-roles",
        shouldShowSpinner: false
    });

});
parcelRegister("gwdei", function(module, exports) {

let $c069e59bcda4ebc3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c069e59bcda4ebc3$var$load("1FVS7").then(()=>parcelRequire('2y4Ff'));

});



parcelRegister("gTM9q", function(module, exports) {

$parcel$export(module.exports, "eocAutomationsRouteEntry", () => $7b4c9d28536c2bf9$export$6ff606556e19e12);

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $bWlm7 = parcelRequire("bWlm7");

var $3RwpL = parcelRequire("3RwpL");
const $7b4c9d28536c2bf9$export$6ff606556e19e12 = (0, $6xToB.createEntry)((0, $bWlm7.eocAutomationsRoute), ()=>({
        group: 'eoc',
        component: (0, $3RwpL.default),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3RwpL.LazyOpsTeamAutomation),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("bWlm7", function(module, exports) {

$parcel$export(module.exports, "eocAutomationsRoute", () => $559682becc30910d$export$4a84eb4d8d37c9d4);
const $559682becc30910d$export$4a84eb4d8d37c9d4 = {
    name: 'eoc-automations',
    path: '/jira/ops/teams/:teamId/automations',
    exact: true
};

});

parcelRegister("3RwpL", function(module, exports) {

$parcel$export(module.exports, "LazyOpsTeamAutomation", () => $0c73ca548832a597$export$903a0a44cc0933c5);
$parcel$export(module.exports, "default", () => $0c73ca548832a597$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $0c73ca548832a597$export$903a0a44cc0933c5 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("4p06L")), {
    moduleId: "./src/packages/spa-apps/ops-team-scope-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0c73ca548832a597$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $0c73ca548832a597$export$903a0a44cc0933c5,
        pageId: "ops-team-automation",
        shouldShowSpinner: true
    });

});
parcelRegister("4p06L", function(module, exports) {

let $334994b57dfeb6bf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $334994b57dfeb6bf$var$load("924gv").then(()=>parcelRequire('3EYJt'));

});



parcelRegister("bJd2N", function(module, exports) {

$parcel$export(module.exports, "eocCustomRolesRouteEntry", () => $27f8adf98042f45f$export$9c9bab95d425eb6f);

var $lRwSr = parcelRequire("lRwSr");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $hObAB = parcelRequire("hObAB");

var $7jTnu = parcelRequire("7jTnu");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $doKHc = parcelRequire("doKHc");
const $27f8adf98042f45f$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $27f8adf98042f45f$export$9c9bab95d425eb6f = (0, $6xToB.createEntry)((0, $hObAB.eocCustomRolesRoute), ()=>({
        group: 'eoc',
        component: (0, $doKHc.default),
        layout: (0, $iRfwO.opsSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$27f8adf98042f45f$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $lRwSr.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $doKHc.LazyCustomRoles)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $doKHc.LazyCustomRoles)
        ]
    }));

});
parcelRegister("lRwSr", function(module, exports) {

$parcel$export(module.exports, "customRolesResource", () => $2accb1f2244a32cf$export$7140716a1b1b8e7a);
$parcel$export(module.exports, "resources", () => $2accb1f2244a32cf$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $3WRcE = parcelRequire("3WRcE");
const $2accb1f2244a32cf$export$7140716a1b1b8e7a = (0, $l1VxS.createResource)({
    type: 'rolesResource',
    getKey: ()=>'rolesResource',
    getData: (0, $3WRcE.getCustomRolesListEndpoint),
    isBrowserOnly: true
});
const $2accb1f2244a32cf$export$bc99aaabaf7b70a7 = ()=>[
        $2accb1f2244a32cf$export$7140716a1b1b8e7a
    ];

});
parcelRegister("3WRcE", function(module, exports) {

$parcel$export(module.exports, "getPermissionsEndpoint", () => $84b6a2443ff46c01$export$f97b589720c51ce1);
$parcel$export(module.exports, "createCustomRoleEndpoint", () => $84b6a2443ff46c01$export$5a7187e04c844900);
$parcel$export(module.exports, "editCustomRoleEndpoint", () => $84b6a2443ff46c01$export$304735a80b86192e);
$parcel$export(module.exports, "deleteCustomRoleEndpoint", () => $84b6a2443ff46c01$export$e12995ccad013f65);
$parcel$export(module.exports, "getCustomRolesListEndpoint", () => $84b6a2443ff46c01$export$3619edac53aa59fd);

var $br21R = parcelRequire("br21R");
const $84b6a2443ff46c01$export$f97b589720c51ce1 = ()=>(0, $br21R.eocFetch)(`/v1/users/permissions`);
const $84b6a2443ff46c01$export$5a7187e04c844900 = (newCustomRole)=>(0, $br21R.eocFetch)(`/v1/users/roles`, {
        method: 'POST',
        body: newCustomRole
    });
const $84b6a2443ff46c01$export$304735a80b86192e = (updatedCustomRole)=>{
    const { id: id } = updatedCustomRole;
    return (0, $br21R.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'PATCH',
        body: updatedCustomRole
    });
};
const $84b6a2443ff46c01$export$e12995ccad013f65 = (id)=>{
    return (0, $br21R.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'DELETE'
    });
};
const $84b6a2443ff46c01$export$3619edac53aa59fd = ()=>(0, $br21R.eocFetch)(`/v1/users/roles`);

});


parcelRegister("hObAB", function(module, exports) {

$parcel$export(module.exports, "eocCustomRolesRoute", () => $9fd95fd7b4578d26$export$3213a7325ca9911);
const $9fd95fd7b4578d26$export$3213a7325ca9911 = {
    name: 'eoc-custom-roles',
    path: '/jira/settings/products/ops/roles',
    exact: true
};

});

parcelRegister("doKHc", function(module, exports) {

$parcel$export(module.exports, "LazyCustomRoles", () => $dd207319cda3505c$export$78ed54710f55f948);
$parcel$export(module.exports, "default", () => $dd207319cda3505c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $dd207319cda3505c$export$78ed54710f55f948 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("6ec9t")), {
    moduleId: "./src/packages/eoc/custom-roles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dd207319cda3505c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $dd207319cda3505c$export$78ed54710f55f948,
        pageId: "async-eoc-custom-roles",
        shouldShowSpinner: false
    });

});
parcelRegister("6ec9t", function(module, exports) {

let $488d79f702defdf4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $488d79f702defdf4$var$load("bpsdx").then(()=>parcelRequire('9Qguw'));

});



parcelRegister("2Q9dT", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertListRedirectRouteEntry", () => $c7e7856940511d22$export$4fc438c20edc8a6f);

var $17OMI = parcelRequire("17OMI");

var $kHlOR = parcelRequire("kHlOR");

var $fz8gQ = parcelRequire("fz8gQ");

var $5RW99 = parcelRequire("5RW99");

var $7TRTJ = parcelRequire("7TRTJ");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $2p5Lf = parcelRequire("2p5Lf");

var $jhbvD = parcelRequire("jhbvD");
const $c7e7856940511d22$export$4fc438c20edc8a6f = (0, $6xToB.createEntry)((0, $2p5Lf.eocGlobalAlertListRedirectRoute), ()=>({
        group: 'eoc',
        component: (0, $jhbvD.AlertListComponent),
        layout: (0, $fz8gQ.eocChangeboardingLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $17OMI.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME,
            sidebar: (0, $7TRTJ.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jhbvD.LazyAlertList),
            (0, $7TRTJ.LazyGlobalAlertsSidebar)
        ]
    }));

});
parcelRegister("17OMI", function(module, exports) {

$parcel$export(module.exports, "resources", () => $dc44749445123c7e$export$bc99aaabaf7b70a7);

var $9o2rQ = parcelRequire("9o2rQ");

var $dwoHY = parcelRequire("dwoHY");

var $iH6rR = parcelRequire("iH6rR");

var $3fBIk = parcelRequire("3fBIk");

var $3SYsB = parcelRequire("3SYsB");
const $dc44749445123c7e$export$bc99aaabaf7b70a7 = ()=>[
        (0, $3SYsB.uiPreferencesResource),
        (0, $3fBIk.savedSearchesResource),
        (0, $iH6rR.compressionRatioResource),
        (0, $9o2rQ.alertGroupingStateResource),
        ...(0, $dwoHY.eocCommonResources)()
    ];

});
parcelRegister("9o2rQ", function(module, exports) {

$parcel$export(module.exports, "alertGroupingStateResource", () => $e9fc788ec95fdee7$export$722cc8285202ce44);

var $l1VxS = parcelRequire("l1VxS");

var $kTW2a = parcelRequire("kTW2a");
const $e9fc788ec95fdee7$var$emptyAlertGroupingState = {
    isEnabled: false,
    reason: null
};
const $e9fc788ec95fdee7$export$722cc8285202ce44 = (0, $l1VxS.createResource)({
    type: 'alertGroupingStateResource',
    getKey: ()=>'alertGroupingStateResource',
    getData: async ()=>{
        try {
            const response = await (0, $kTW2a.getGroupFeatureStatus)();
            return response;
        } catch (e) {
            // Exception handling and to return emptyState
            return $e9fc788ec95fdee7$var$emptyAlertGroupingState;
        }
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("kTW2a", function(module, exports) {

$parcel$export(module.exports, "getGroupFeatureStatus", () => $983d4f88f49a16c8$export$48deee62d9dfb365);

var $j0Ns8 = parcelRequire("j0Ns8");

var $2QonX = parcelRequire("2QonX");

var $br21R = parcelRequire("br21R");
const $983d4f88f49a16c8$export$48deee62d9dfb365 = ()=>{
    const url = new (0, $2QonX.URLBuilder)((0, $j0Ns8.withAIOpsDomainPrefix)('/v1/aiops/feature-state')).withQueryParam('featureName', 'alert-grouping').build();
    return (0, $br21R.eocFetch)(url, {
        exactUrl: true
    });
};

});
parcelRegister("j0Ns8", function(module, exports) {

$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $ff445aaefcd6bbb6$export$81c70e0016508593);

var $b388R = parcelRequire("b388R");
const $ff445aaefcd6bbb6$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $b388R.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});

parcelRegister("2QonX", function(module, exports) {

$parcel$export(module.exports, "URLBuilder", () => $56a693a5b5df509b$export$61d2e8db329a11f8);
class $56a693a5b5df509b$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '');
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});



parcelRegister("iH6rR", function(module, exports) {

$parcel$export(module.exports, "compressionRatioResource", () => $85f5cc82c356aad3$export$8c912e73f758af2);

var $l1VxS = parcelRequire("l1VxS");

var $euwB2 = parcelRequire("euwB2");
const $85f5cc82c356aad3$var$emptyCompressionBanner = {
    compressionRatio: 0,
    uniqueGroupCount: 0,
    rollingWindow: 0
};
const $85f5cc82c356aad3$export$8c912e73f758af2 = (0, $l1VxS.createResource)({
    type: 'compressionRatioResource',
    getKey: ()=>'compressionRatioResource',
    getData: async ()=>{
        try {
            const response = await (0, $euwB2.getCompressionRatio)();
            return response;
        } catch (e) {
            return $85f5cc82c356aad3$var$emptyCompressionBanner;
        }
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("euwB2", function(module, exports) {

$parcel$export(module.exports, "getCompressionRatio", () => $347df48281f7438b$export$4991457f359db4f7);

var $br21R = parcelRequire("br21R");

var $jhAUc = parcelRequire("jhAUc");
const $347df48281f7438b$export$4991457f359db4f7 = ()=>{
    return (0, $br21R.eocFetch)((0, $jhAUc.withAIOpsDomainPrefix)('/v1/alert-insights/compression-ratio'), {
        exactUrl: true
    });
};

});


parcelRegister("3fBIk", function(module, exports) {

$parcel$export(module.exports, "savedSearchesResource", () => $699120e2cdc6e34c$export$d915b849e6dd786b);

var $l1VxS = parcelRequire("l1VxS");

var $duG08 = parcelRequire("duG08");
const $699120e2cdc6e34c$export$d915b849e6dd786b = (0, $l1VxS.createResource)({
    type: 'savedSearchesResource',
    getKey: ()=>'savedSearchesResource',
    getData: ()=>(0, $duG08.getSavedSearchesEndpoint)(),
    maxAge: 300000,
    isBrowserOnly: true
});

});

parcelRegister("3SYsB", function(module, exports) {

$parcel$export(module.exports, "uiPreferencesResource", () => $9400f6c9662ebaec$export$4e143f0fe4b2e025);

var $l1VxS = parcelRequire("l1VxS");

var $7NadH = parcelRequire("7NadH");
const $9400f6c9662ebaec$export$4e143f0fe4b2e025 = (0, $l1VxS.createResource)({
    type: 'uiPreferencesResource',
    getKey: ()=>'uiPreferencesResource',
    getData: ()=>(0, $7NadH.getUiPreferencesEndpoint)(),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("7NadH", function(module, exports) {

$parcel$export(module.exports, "getUiPreferencesEndpoint", () => $289aaaf51e6eba9f$export$afa4854419ed2fc8);
$parcel$export(module.exports, "updateUiPreferencesEndpoint", () => $289aaaf51e6eba9f$export$4990793476d8f783);

var $br21R = parcelRequire("br21R");
const $289aaaf51e6eba9f$export$afa4854419ed2fc8 = ()=>{
    return (0, $br21R.eocFetch)('/v1/alerts/ui-preferences');
};
const $289aaaf51e6eba9f$export$4990793476d8f783 = (data)=>{
    return (0, $br21R.eocFetch)('/v1/alerts/ui-preferences', {
        method: 'PATCH',
        body: data
    });
};

});



parcelRegister("7TRTJ", function(module, exports) {

$parcel$export(module.exports, "LazyGlobalAlertsSidebar", () => $caf22840305bd6a5$export$674fd99c08c90491);
$parcel$export(module.exports, "AsyncSidebarEocGlobalAlerts", () => $caf22840305bd6a5$export$a1c034c1031e8711);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $gzcjr = parcelRequire("gzcjr");

const $caf22840305bd6a5$export$674fd99c08c90491 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("1Lv8Z")).then((bundle)=>bundle), {
    moduleId: "./src/packages/navigation-apps/sidebar/eoc-global-alerts/src/index.tsx"
});
const $caf22840305bd6a5$export$a1c034c1031e8711 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "eocGlobalAlerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($caf22840305bd6a5$export$674fd99c08c90491, null));

});
parcelRegister("1Lv8Z", function(module, exports) {

let $149256c178cf12ba$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $149256c178cf12ba$var$load("1VRB2"),
    $149256c178cf12ba$var$load("bABhq"),
    $149256c178cf12ba$var$load("10IqO")
]).then(()=>parcelRequire('6Ya0u'));

});


parcelRegister("2p5Lf", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertListRedirectRoute", () => $ff44028307d04ba8$export$491d479dc37383e9);
const $ff44028307d04ba8$export$491d479dc37383e9 = {
    name: 'eoc-global-alerts-redirect',
    path: '/jira/ops',
    exact: true
};

});

parcelRegister("jhbvD", function(module, exports) {

$parcel$export(module.exports, "LazyAlertList", () => $7290c43ada9de388$export$f4aafff31d950b6c);
$parcel$export(module.exports, "AlertListComponent", () => $7290c43ada9de388$export$9333bfa567c9c31);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $7290c43ada9de388$export$f4aafff31d950b6c = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("fYnBy")), {
    moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
});
const $7290c43ada9de388$export$9333bfa567c9c31 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $7290c43ada9de388$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });

});
parcelRegister("fYnBy", function(module, exports) {

let $ba0ec5089a66e716$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ba0ec5089a66e716$var$load("1VRB2"),
    $ba0ec5089a66e716$var$load("bABhq"),
    $ba0ec5089a66e716$var$load("7vqGd"),
    $ba0ec5089a66e716$var$load("1Y4bq"),
    $ba0ec5089a66e716$var$load("eDzss"),
    $ba0ec5089a66e716$var$load("jfBlU")
]).then(()=>parcelRequire('nPAxe'));

});



parcelRegister("hr8RB", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertListRouteEntry", () => $3a3e13783354d482$export$851a659e50436cff);

var $17OMI = parcelRequire("17OMI");

var $kHlOR = parcelRequire("kHlOR");

var $fz8gQ = parcelRequire("fz8gQ");

var $5RW99 = parcelRequire("5RW99");

var $7TRTJ = parcelRequire("7TRTJ");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $jn07M = parcelRequire("jn07M");

var $jhbvD = parcelRequire("jhbvD");
const $3a3e13783354d482$export$851a659e50436cff = (0, $6xToB.createEntry)((0, $jn07M.eocGlobalAlertListRoute), ()=>({
        group: 'eoc',
        component: (0, $jhbvD.AlertListComponent),
        layout: (0, $fz8gQ.eocChangeboardingLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $17OMI.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME,
            sidebar: (0, $7TRTJ.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jhbvD.LazyAlertList),
            (0, $7TRTJ.LazyGlobalAlertsSidebar)
        ]
    }));

});

parcelRegister("haVHi", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertsDetailRouteEntry", () => $446e77773c8ea48d$export$bcb93d8198d511b9);

var $5bTUU = parcelRequire("5bTUU");

var $17OMI = parcelRequire("17OMI");

var $i1cBv = parcelRequire("i1cBv");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $7TRTJ = parcelRequire("7TRTJ");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $jibdU = parcelRequire("jibdU");

var $7jTnu = parcelRequire("7jTnu");

var $5L7qx = parcelRequire("5L7qx");

var $jhbvD = parcelRequire("jhbvD");
const $446e77773c8ea48d$export$bcb93d8198d511b9 = (0, $6xToB.createEntry)((0, $jibdU.eocGlobalAlertsDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $jhbvD.AlertListComponent),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $17OMI.resources)(),
            ...(0, $5bTUU.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('automation_discoverability_in_jsm'), (0, $i1cBv.getAutomationDiscoveryDismissResource))
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME,
            sidebar: (0, $7TRTJ.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jhbvD.LazyAlertList),
            (0, $7TRTJ.LazyGlobalAlertsSidebar)
        ]
    }));

});
parcelRegister("5bTUU", function(module, exports) {

$parcel$export(module.exports, "alertDetailResource", () => $2585825273f5698a$export$f918335771807ac4);
$parcel$export(module.exports, "logTypesResource", () => $2585825273f5698a$export$f9c57ab4d5f63686);
$parcel$export(module.exports, "entityRelationTypesResource", () => $2585825273f5698a$export$a5515392cb45b9f8);
$parcel$export(module.exports, "responderStatesResource", () => $2585825273f5698a$export$c3b70747662e5932);
$parcel$export(module.exports, "resources", () => $2585825273f5698a$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $eaj78 = parcelRequire("eaj78");

var $8XtVW = parcelRequire("8XtVW");

var $kCzgP = parcelRequire("kCzgP");

var $feIEW = parcelRequire("feIEW");
var $jXKdt = parcelRequire("jXKdt");

var $dwoHY = parcelRequire("dwoHY");

var $cQfTR = parcelRequire("cQfTR");

var $8jPLI = parcelRequire("8jPLI");
const $2585825273f5698a$var$ALERT_DETAIL_RESOURCE_TYPE = 'alertDetailResource';
const $2585825273f5698a$export$f918335771807ac4 = (0, $l1VxS.createResource)({
    type: $2585825273f5698a$var$ALERT_DETAIL_RESOURCE_TYPE,
    getKey: (routerContext)=>`alertDetailResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        (0, $feIEW.assert)(!!alertId, new (0, $jXKdt.AssertionError)('alertDetailResource', 'alertId should be set to fetch alert-detail'));
        return (0, $8jPLI.getAlertDetail)(alertId);
    },
    isBrowserOnly: true
});
const $2585825273f5698a$export$f9c57ab4d5f63686 = (0, $l1VxS.createResource)({
    type: 'logTypesResource',
    getKey: (routerContext)=>`logTypesResource#${routerContext.match.params.id}`,
    getData: async ()=>{
        return (0, $8jPLI.getAlertLogTypesEndpoint)();
    },
    isBrowserOnly: true
});
const $2585825273f5698a$export$a5515392cb45b9f8 = (0, $l1VxS.createResource)({
    type: 'entityRelationTypesResource',
    getKey: (routerContext)=>`entityRelationTypesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        const dependencies = routerContext.dependencies;
        (0, $feIEW.assert)(!!alertId, new (0, $jXKdt.AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
        // if id on the url is not a valid uuid and flag is on then wait for alertDetailResource to resolve for getting id of the alert instead of tinyId
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eaj78)))(alertId) && (0, $8XtVW.fg)('alert_detail_convert_tiny_id_to_alert_id')) {
            const { id: id } = await (0, $cQfTR.consumeDependency)(dependencies, $2585825273f5698a$var$ALERT_DETAIL_RESOURCE_TYPE);
            return (0, $8jPLI.getEntityRelationTypesEndpoint)(id);
        }
        return (0, $8jPLI.getEntityRelationTypesEndpoint)(alertId);
    },
    depends: [
        $2585825273f5698a$var$ALERT_DETAIL_RESOURCE_TYPE
    ],
    isBrowserOnly: true
});
const $2585825273f5698a$export$c3b70747662e5932 = (0, $l1VxS.createResource)({
    type: 'responderStatesResource',
    getKey: (routerContext)=>`responderStatesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        const dependencies = routerContext.dependencies;
        (0, $feIEW.assert)(!!alertId, new (0, $jXKdt.AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
        // if id on the url is not a valid uuid and flag is on then wait for alertDetailResource to resolve for getting id of the alert instead of tinyId
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eaj78)))(alertId) && (0, $8XtVW.fg)('alert_detail_convert_tiny_id_to_alert_id')) {
            const { id: id } = await (0, $cQfTR.consumeDependency)(dependencies, $2585825273f5698a$var$ALERT_DETAIL_RESOURCE_TYPE);
            return (0, $8jPLI.getResponderStatesEndpoint)(id);
        }
        return (0, $8jPLI.getResponderStatesEndpoint)(alertId);
    },
    depends: [
        $2585825273f5698a$var$ALERT_DETAIL_RESOURCE_TYPE
    ],
    isBrowserOnly: true
});
const $2585825273f5698a$export$bc99aaabaf7b70a7 = ()=>[
        $2585825273f5698a$export$f918335771807ac4,
        $2585825273f5698a$export$f9c57ab4d5f63686,
        $2585825273f5698a$export$c3b70747662e5932,
        $2585825273f5698a$export$a5515392cb45b9f8,
        (0, $kCzgP.relatedAlertGroupResource),
        ...(0, $dwoHY.eocCommonResources)()
    ];

});
parcelRegister("eaj78", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $5Ovjr = parcelRequire("5Ovjr");
var $a500d3812b6eabd3$require$Buffer = $5Ovjr.Buffer;
var $a500d3812b6eabd3$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $a500d3812b6eabd3$var$_byteToHex = [];
for(var $a500d3812b6eabd3$var$i = 0; $a500d3812b6eabd3$var$i < 256; $a500d3812b6eabd3$var$i++)$a500d3812b6eabd3$var$_byteToHex[$a500d3812b6eabd3$var$i] = ($a500d3812b6eabd3$var$i + 0x100).toString(16).substr(1);
function $a500d3812b6eabd3$var$unparse(buf, offset) {
    var i = offset || 0, bth = $a500d3812b6eabd3$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($a500d3812b6eabd3$require$Buffer.isBuffer(uuid)) parsedUuid = $a500d3812b6eabd3$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$a500d3812b6eabd3$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $a500d3812b6eabd3$var$extractVersion(parsedUuid);
    else if ($a500d3812b6eabd3$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $a500d3812b6eabd3$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("kCzgP", function(module, exports) {

$parcel$export(module.exports, "relatedAlertGroupResource", () => $8aecc56750829d0d$export$35df14c9f0cfb113);

var $l1VxS = parcelRequire("l1VxS");

var $feIEW = parcelRequire("feIEW");
var $jXKdt = parcelRequire("jXKdt");

var $bJyzr = parcelRequire("bJyzr");
const $8aecc56750829d0d$export$35df14c9f0cfb113 = (0, $l1VxS.createResource)({
    type: 'relatedAlertGroupResource',
    getKey: (routerContext)=>`relatedAlertGroupResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        (0, $feIEW.assert)(!!alertId, new (0, $jXKdt.AssertionError)('relatedAlertGroupResource', 'alertId should be set to fetch related alert-groups'));
        return (0, $bJyzr.getRelatedAlertGroup)(alertId);
    },
    isBrowserOnly: true
});

});
parcelRegister("bJyzr", function(module, exports) {

$parcel$export(module.exports, "getRelatedAlertGroup", () => $6cae0e8a80417289$export$665e34f20aad273a);

var $br21R = parcelRequire("br21R");

var $jIDCB = parcelRequire("jIDCB");
const $6cae0e8a80417289$export$665e34f20aad273a = (alertId)=>(0, $br21R.eocFetch)((0, $jIDCB.withAIOpsDomainPrefix)(`/v1/group-insights/get-group-of-alert?alertId=${alertId}`), {
        exactUrl: true
    });

});
parcelRegister("jIDCB", function(module, exports) {

$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $947d300d0d55a8a7$export$81c70e0016508593);

var $b388R = parcelRequire("b388R");
const $947d300d0d55a8a7$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $b388R.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});



parcelRegister("cQfTR", function(module, exports) {

$parcel$export(module.exports, "consumeDependency", () => $01ddbb261c6e161f$export$a973ef9e17a326f);
async function $01ddbb261c6e161f$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    return dependencies[key]?.data;
}

});

parcelRegister("8jPLI", function(module, exports) {

$parcel$export(module.exports, "getAlertDetail", () => $16436b778d313669$export$436b6d88c1865c54);
$parcel$export(module.exports, "getAlertLogTypesEndpoint", () => $16436b778d313669$export$97200f7e7a7d1479);
$parcel$export(module.exports, "getResponderStatesEndpoint", () => $16436b778d313669$export$498d1a9ea659d430);
$parcel$export(module.exports, "getEntityRelationTypesEndpoint", () => $16436b778d313669$export$8f96130abdd7549d);

var $br21R = parcelRequire("br21R");
const $16436b778d313669$export$436b6d88c1865c54 = (alertId)=>(0, $br21R.eocFetch)(`/v1/alerts/${alertId}`);
const $16436b778d313669$export$97200f7e7a7d1479 = ()=>(0, $br21R.eocFetch)(`/v1/alerts/logs/types`);
const $16436b778d313669$export$498d1a9ea659d430 = (alertId)=>(0, $br21R.eocFetch)(`/v1/alerts/${alertId}/responder-states`);
const $16436b778d313669$export$8f96130abdd7549d = (alertId)=>(0, $br21R.eocFetch)(`/v1/alerts/${alertId}/entity-relations/relation-types`).then((res)=>({
            relationTypes: res.relationTypes.sort((a, b)=>a.label.localeCompare(b.label))
        }));

});


parcelRegister("i1cBv", function(module, exports) {

$parcel$export(module.exports, "getAutomationDiscoveryDismissResource", () => $78a06afdcb26f495$export$3e9b930ef3c80543);

var $l1VxS = parcelRequire("l1VxS");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

const $78a06afdcb26f495$var$PROPERTY_KEY = 'jira.user.issue.automation-discoverability.panel.state';
const $78a06afdcb26f495$export$3e9b930ef3c80543 = (0, $l1VxS.createResource)({
    type: 'getAutomationDiscoveryDismiss',
    getKey: ()=>'getAutomationDiscoveryDismiss',
    getData: async ()=>{
        try {
            const res = await (0, $jGzN3.performGetRequest)(`/rest/api/3/mypreferences?key=${$78a06afdcb26f495$var$PROPERTY_KEY}`);
            return res;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === (0, $44ccf6b895337c89$export$8bca792d963eb0ef)) return null;
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'getDismissData',
                    teamName: 'ITOps Phantom',
                    packageName: 'jiraEocAutomationDiscovery'
                }
            });
            throw error;
        }
    },
    maxAge: 300000
});

});

parcelRegister("jibdU", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertsDetailRoute", () => $a56b027b36a6ba01$export$d87948ea641004e2);
const $a56b027b36a6ba01$export$d87948ea641004e2 = {
    name: 'eoc-global-alert-detail',
    path: '/jira/ops/alerts/:id',
    exact: true
};

});


parcelRegister("gCQuB", function(module, exports) {

$parcel$export(module.exports, "eocGlobalGroupDetailRouteEntry", () => $aa5067eb6d4b9bab$export$66928ab349190059);

var $17OMI = parcelRequire("17OMI");

var $d8PBA = parcelRequire("d8PBA");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $7TRTJ = parcelRequire("7TRTJ");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $kPioY = parcelRequire("kPioY");

var $9HKZp = parcelRequire("9HKZp");
const $aa5067eb6d4b9bab$export$66928ab349190059 = (0, $6xToB.createEntry)((0, $kPioY.eocGlobalGroupDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $9HKZp.default),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $d8PBA.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $17OMI.resources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME,
            sidebar: (0, $7TRTJ.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9HKZp.LazyGroupDetail),
            (0, $7TRTJ.LazyGlobalAlertsSidebar)
        ]
    }));

});
parcelRegister("d8PBA", function(module, exports) {

$parcel$export(module.exports, "groupHeaderResource", () => $b9e676ae5391b110$export$e6ba56f6b67069c8);
$parcel$export(module.exports, "aiSuggestionsResource", () => $b9e676ae5391b110$export$94675faef1d4568b);
$parcel$export(module.exports, "resources", () => $b9e676ae5391b110$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $feIEW = parcelRequire("feIEW");
var $jXKdt = parcelRequire("jXKdt");

var $kNHXY = parcelRequire("kNHXY");
const $b9e676ae5391b110$export$e6ba56f6b67069c8 = (0, $l1VxS.createResource)({
    type: 'groupHeaderResource',
    getKey: (routerContext)=>`groupHeaderResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const groupId = routerContext.match.params?.id;
        (0, $feIEW.assert)(!!groupId, new (0, $jXKdt.AssertionError)('groupHeaderResource', 'groupId should be set to fetch group-detail-header'));
        return (0, $kNHXY.getHeaderDetails)(groupId);
    },
    isBrowserOnly: true
});
const $b9e676ae5391b110$export$94675faef1d4568b = (0, $l1VxS.createResource)({
    type: 'aiSuggestionsResource',
    getKey: (routerContext)=>`aiSuggestionsResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const groupId = routerContext.match.params?.id;
        (0, $feIEW.assert)(!!groupId, new (0, $jXKdt.AssertionError)('aiSuggestionsResource', 'groupId should be set to fetch ai-suggestions for any group'));
        return (0, $kNHXY.getAISuggestions)(groupId);
    },
    isBrowserOnly: true
});
const $b9e676ae5391b110$export$bc99aaabaf7b70a7 = ()=>[
        $b9e676ae5391b110$export$e6ba56f6b67069c8,
        $b9e676ae5391b110$export$94675faef1d4568b
    ];

});
parcelRegister("kNHXY", function(module, exports) {

$parcel$export(module.exports, "getHeaderDetails", () => $56a066a9a4d393d2$export$c0f2e4bfcbff05d1);
$parcel$export(module.exports, "getAISuggestions", () => $56a066a9a4d393d2$export$34bb7a15a54039a5);
$parcel$export(module.exports, "addGroupAssignee", () => $56a066a9a4d393d2$export$bd5bdebdb6d9abb);

var $br21R = parcelRequire("br21R");

var $dQyYZ = parcelRequire("dQyYZ");
const $56a066a9a4d393d2$export$c0f2e4bfcbff05d1 = (groupId)=>(0, $br21R.eocFetch)((0, $dQyYZ.withAIOpsPrefix)(`/v1/group-insights/${groupId}`), {
        exactUrl: true
    });
const $56a066a9a4d393d2$export$34bb7a15a54039a5 = (groupId)=>(0, $br21R.eocFetch)((0, $dQyYZ.withAIOpsPrefix)(`/v1/group-insights/getSimilar/${groupId}`), {
        exactUrl: true
    });
const $56a066a9a4d393d2$export$bd5bdebdb6d9abb = (groupId, assigneeId)=>(0, $br21R.eocFetch)((0, $dQyYZ.withAIOpsPrefix)(`/v1/group-insights/${groupId}/add-assignee/${assigneeId}`), {
        method: 'PUT',
        exactUrl: true
    });

});
parcelRegister("dQyYZ", function(module, exports) {

$parcel$export(module.exports, "withAIOpsPrefix", () => $21d885e52e13d71f$export$5ad74397753c99a2);
$parcel$export(module.exports, "formatTimezone", () => $21d885e52e13d71f$export$26da7aa151b6684c);

var $fdKLI = parcelRequire("fdKLI");

var $eZ54B = parcelRequire("eZ54B");

var $b388R = parcelRequire("b388R");
const $21d885e52e13d71f$export$5ad74397753c99a2 = (input)=>{
    const cloudId = (0, $b388R.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};
function $21d885e52e13d71f$export$9e555a50010549c1(timezone) {
    const splittedTz = timezone.split('/');
    // EST || EST5EDT
    if (splittedTz.length === 0) return splittedTz;
    // Europe/Amsterdam || Europe/Isle_of_Man || America/North_Dakota/New_Salem
    if (splittedTz.length > 0) {
        const areaName = splittedTz[splittedTz.length - 1];
        return areaName.replace(/_/g, ' ');
    }
    return timezone;
}
function $21d885e52e13d71f$export$26da7aa151b6684c(timezone) {
    const timeZone = timezone ?? (0, $eZ54B.guessUserTimeZone)();
    return (0, $fdKLI.default)(new Date(), timeZone, `z '${$21d885e52e13d71f$export$9e555a50010549c1(timeZone)}'`);
}

});
parcelRegister("fdKLI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b14c593580abaf28$export$2e2bcd8739ae039);

var $7noXc = parcelRequire("7noXc");

var $9WggP = parcelRequire("9WggP");

var $6fNYs = parcelRequire("6fNYs");
function $b14c593580abaf28$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($7noXc)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $9WggP.default)((0, $6fNYs.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("9WggP", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c626cc9bdc49ae$export$2e2bcd8739ae039);

var $47etr = parcelRequire("47etr");

var $hEaw7 = parcelRequire("hEaw7");

var $6JKBS = parcelRequire("6JKBS");
var $73c626cc9bdc49ae$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $73c626cc9bdc49ae$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($73c626cc9bdc49ae$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $6JKBS.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $hEaw7.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($47etr)))(dirtyDate, formatStr, options);
}

});
parcelRegister("hEaw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd8e548b5b83f185$export$2e2bcd8739ae039);

var $5ZZZV = parcelRequire("5ZZZV");

var $gL6Wk = parcelRequire("gL6Wk");
var $cd8e548b5b83f185$var$MILLISECONDS_IN_MINUTE = 60000;
var $cd8e548b5b83f185$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $cd8e548b5b83f185$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $cd8e548b5b83f185$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $cd8e548b5b83f185$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $cd8e548b5b83f185$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $cd8e548b5b83f185$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $cd8e548b5b83f185$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $cd8e548b5b83f185$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $cd8e548b5b83f185$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $cd8e548b5b83f185$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $cd8e548b5b83f185$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $cd8e548b5b83f185$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $5ZZZV.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $5ZZZV.default)('long', date, options);
        }
    }
};
function $cd8e548b5b83f185$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $gL6Wk.default)(timeZone, originalDate, true) / $cd8e548b5b83f185$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $cd8e548b5b83f185$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $cd8e548b5b83f185$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $cd8e548b5b83f185$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $cd8e548b5b83f185$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $cd8e548b5b83f185$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $cd8e548b5b83f185$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $cd8e548b5b83f185$var$formatTimezone(offset, dirtyDelimeter);
}
function $cd8e548b5b83f185$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $cd8e548b5b83f185$var$addLeadingZeros(minutes, 2);
}
var $cd8e548b5b83f185$export$2e2bcd8739ae039 = $cd8e548b5b83f185$var$formatters;

});
parcelRegister("5ZZZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $45e2bdb4bbc10725$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $45e2bdb4bbc10725$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $45e2bdb4bbc10725$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $45e2bdb4bbc10725$var$partsTimeZone(dtf, date) : $45e2bdb4bbc10725$var$hackyTimeZone(dtf, date);
}
function $45e2bdb4bbc10725$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $45e2bdb4bbc10725$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $45e2bdb4bbc10725$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("gL6Wk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3366b33ba470723$export$2e2bcd8739ae039);

var $hAKwN = parcelRequire("hAKwN");

var $lI3Nh = parcelRequire("lI3Nh");
var $c3366b33ba470723$var$MILLISECONDS_IN_HOUR = 3600000;
var $c3366b33ba470723$var$MILLISECONDS_IN_MINUTE = 60000;
var $c3366b33ba470723$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $c3366b33ba470723$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $c3366b33ba470723$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $c3366b33ba470723$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$c3366b33ba470723$var$validateTimezone(hours)) return NaN;
        return -(hours * $c3366b33ba470723$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $c3366b33ba470723$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$c3366b33ba470723$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $c3366b33ba470723$var$MILLISECONDS_IN_HOUR + minutes * $c3366b33ba470723$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($c3366b33ba470723$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $c3366b33ba470723$var$toUtcDate(date);
        var offset = $c3366b33ba470723$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $c3366b33ba470723$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $c3366b33ba470723$var$toUtcDate(date) {
    return (0, $lI3Nh.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $c3366b33ba470723$var$calcOffset(date, timezoneString) {
    var tokens = (0, $hAKwN.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $lI3Nh.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $c3366b33ba470723$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $c3366b33ba470723$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $c3366b33ba470723$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $c3366b33ba470723$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $c3366b33ba470723$var$validIANATimezoneCache = {};
function $c3366b33ba470723$var$isValidTimezoneIANAString(timeZoneString) {
    if ($c3366b33ba470723$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $c3366b33ba470723$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("hAKwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cce9e3ec8a142526$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $cce9e3ec8a142526$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $cce9e3ec8a142526$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $cce9e3ec8a142526$var$partsOffset(dtf, date) : $cce9e3ec8a142526$var$hackyOffset(dtf, date);
}
var $cce9e3ec8a142526$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $cce9e3ec8a142526$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $cce9e3ec8a142526$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $cce9e3ec8a142526$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $cce9e3ec8a142526$var$dtfCache = {};
function $cce9e3ec8a142526$var$getDateTimeFormat(timeZone) {
    if (!$cce9e3ec8a142526$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $cce9e3ec8a142526$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $cce9e3ec8a142526$var$dtfCache[timeZone];
}

});

parcelRegister("lI3Nh", function(module, exports) {

$parcel$export(module.exports, "default", () => $fce0a668a8c08cdd$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $fce0a668a8c08cdd$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("6JKBS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e7b19cb15854820$export$2e2bcd8739ae039);

var $a04h3 = parcelRequire("a04h3");

var $ejJXr = parcelRequire("ejJXr");

var $gL6Wk = parcelRequire("gL6Wk");

var $f0FRt = parcelRequire("f0FRt");
var $4e7b19cb15854820$var$MILLISECONDS_IN_HOUR = 3600000;
var $4e7b19cb15854820$var$MILLISECONDS_IN_MINUTE = 60000;
var $4e7b19cb15854820$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $4e7b19cb15854820$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $f0FRt.default)
};
function $4e7b19cb15854820$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $4e7b19cb15854820$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($a04h3)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $4e7b19cb15854820$var$splitDateString(argument);
    var parseYearResult = $4e7b19cb15854820$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $4e7b19cb15854820$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $4e7b19cb15854820$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $gL6Wk.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $4e7b19cb15854820$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $4e7b19cb15854820$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $4e7b19cb15854820$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $4e7b19cb15854820$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $4e7b19cb15854820$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $4e7b19cb15854820$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $4e7b19cb15854820$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $4e7b19cb15854820$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $4e7b19cb15854820$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $4e7b19cb15854820$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $4e7b19cb15854820$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$4e7b19cb15854820$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $4e7b19cb15854820$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$4e7b19cb15854820$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $4e7b19cb15854820$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$4e7b19cb15854820$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $4e7b19cb15854820$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$4e7b19cb15854820$var$validateWeekDate(year, week)) return new Date(NaN);
        return $4e7b19cb15854820$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $4e7b19cb15854820$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$4e7b19cb15854820$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $4e7b19cb15854820$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $4e7b19cb15854820$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $4e7b19cb15854820$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$4e7b19cb15854820$var$validateTime(hours)) return NaN;
        return hours % 24 * $4e7b19cb15854820$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $4e7b19cb15854820$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$4e7b19cb15854820$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $4e7b19cb15854820$var$MILLISECONDS_IN_HOUR + minutes * $4e7b19cb15854820$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $4e7b19cb15854820$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$4e7b19cb15854820$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $4e7b19cb15854820$var$MILLISECONDS_IN_HOUR + minutes * $4e7b19cb15854820$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $4e7b19cb15854820$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $4e7b19cb15854820$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $4e7b19cb15854820$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $4e7b19cb15854820$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $4e7b19cb15854820$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $4e7b19cb15854820$var$isLeapYearIndex(year);
        if (isLeapYear && date > $4e7b19cb15854820$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $4e7b19cb15854820$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $4e7b19cb15854820$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $4e7b19cb15854820$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $4e7b19cb15854820$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $4e7b19cb15854820$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("f0FRt", function(module, exports) {

$parcel$export(module.exports, "default", () => $aed753ea0833b511$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $aed753ea0833b511$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $aed753ea0833b511$export$2e2bcd8739ae039 = $aed753ea0833b511$var$tzPattern;

});



parcelRegister("6fNYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $48dae89af9c32012$export$2e2bcd8739ae039);

var $gL6Wk = parcelRequire("gL6Wk");

var $6JKBS = parcelRequire("6JKBS");
function $48dae89af9c32012$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $6JKBS.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $gL6Wk.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("eZ54B", function(module, exports) {

$parcel$export(module.exports, "guessUserTimeZone", () => $30e71647798961e4$export$6fd096fe0456f5b);
$parcel$export(module.exports, "formatDate", () => $30e71647798961e4$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getDefaultTimes", () => $30e71647798961e4$export$951e947e785c998d);

var $ebRJx = parcelRequire("ebRJx");
function $30e71647798961e4$export$6fd096fe0456f5b() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function $30e71647798961e4$export$3ae94a2503e890a1(date, timezone = $30e71647798961e4$export$6fd096fe0456f5b(), format = 'PP p') {
    return (0, $ebRJx.default)(new Date(date), timezone, format);
}
const $30e71647798961e4$export$951e947e785c998d = ()=>{
    return [
        ...Array(24).keys()
    ].map((time)=>{
        let newTime = time.toString();
        if (newTime.length === 1) newTime = `0${time}`;
        return [
            `${newTime}:00`,
            `${newTime}:30`
        ];
    }).flatMap((time)=>time);
};

});
parcelRegister("ebRJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a54bc62153bb576a$export$2e2bcd8739ae039);

var $7noXc = parcelRequire("7noXc");

var $aRlfW = parcelRequire("aRlfW");

var $kXsmt = parcelRequire("kXsmt");
function $a54bc62153bb576a$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($7noXc)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $aRlfW.default)((0, $kXsmt.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("aRlfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e7f57a570f95d98$export$2e2bcd8739ae039);

var $47etr = parcelRequire("47etr");

var $5PhxM = parcelRequire("5PhxM");

var $dMPhC = parcelRequire("dMPhC");
var $7e7f57a570f95d98$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $7e7f57a570f95d98$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($7e7f57a570f95d98$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $dMPhC.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $5PhxM.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($47etr)))(dirtyDate, formatStr, options);
}

});
parcelRegister("5PhxM", function(module, exports) {

$parcel$export(module.exports, "default", () => $43df530270ea2746$export$2e2bcd8739ae039);

var $fgSdU = parcelRequire("fgSdU");

var $k8MHY = parcelRequire("k8MHY");
var $43df530270ea2746$var$MILLISECONDS_IN_MINUTE = 60000;
var $43df530270ea2746$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $43df530270ea2746$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $43df530270ea2746$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $43df530270ea2746$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $43df530270ea2746$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $43df530270ea2746$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $43df530270ea2746$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $43df530270ea2746$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $43df530270ea2746$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $43df530270ea2746$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $43df530270ea2746$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $43df530270ea2746$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $fgSdU.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $fgSdU.default)('long', date, options);
        }
    }
};
function $43df530270ea2746$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $k8MHY.default)(timeZone, originalDate, true) / $43df530270ea2746$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $43df530270ea2746$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $43df530270ea2746$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $43df530270ea2746$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $43df530270ea2746$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $43df530270ea2746$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $43df530270ea2746$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $43df530270ea2746$var$formatTimezone(offset, dirtyDelimeter);
}
function $43df530270ea2746$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $43df530270ea2746$var$addLeadingZeros(minutes, 2);
}
var $43df530270ea2746$export$2e2bcd8739ae039 = $43df530270ea2746$var$formatters;

});
parcelRegister("fgSdU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1e26940c384b261$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $b1e26940c384b261$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $b1e26940c384b261$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $b1e26940c384b261$var$partsTimeZone(dtf, date) : $b1e26940c384b261$var$hackyTimeZone(dtf, date);
}
function $b1e26940c384b261$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $b1e26940c384b261$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $b1e26940c384b261$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("k8MHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea9a566c132d41ee$export$2e2bcd8739ae039);

var $a15lU = parcelRequire("a15lU");

var $6jw1Q = parcelRequire("6jw1Q");
var $ea9a566c132d41ee$var$MILLISECONDS_IN_HOUR = 3600000;
var $ea9a566c132d41ee$var$MILLISECONDS_IN_MINUTE = 60000;
var $ea9a566c132d41ee$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $ea9a566c132d41ee$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $ea9a566c132d41ee$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $ea9a566c132d41ee$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$ea9a566c132d41ee$var$validateTimezone(hours)) return NaN;
        return -(hours * $ea9a566c132d41ee$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $ea9a566c132d41ee$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$ea9a566c132d41ee$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $ea9a566c132d41ee$var$MILLISECONDS_IN_HOUR + minutes * $ea9a566c132d41ee$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($ea9a566c132d41ee$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $ea9a566c132d41ee$var$toUtcDate(date);
        var offset = $ea9a566c132d41ee$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $ea9a566c132d41ee$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $ea9a566c132d41ee$var$toUtcDate(date) {
    return (0, $6jw1Q.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $ea9a566c132d41ee$var$calcOffset(date, timezoneString) {
    var tokens = (0, $a15lU.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $6jw1Q.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $ea9a566c132d41ee$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $ea9a566c132d41ee$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $ea9a566c132d41ee$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $ea9a566c132d41ee$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $ea9a566c132d41ee$var$validIANATimezoneCache = {};
function $ea9a566c132d41ee$var$isValidTimezoneIANAString(timeZoneString) {
    if ($ea9a566c132d41ee$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $ea9a566c132d41ee$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("a15lU", function(module, exports) {

$parcel$export(module.exports, "default", () => $74ae264438c87198$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $74ae264438c87198$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $74ae264438c87198$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $74ae264438c87198$var$partsOffset(dtf, date) : $74ae264438c87198$var$hackyOffset(dtf, date);
}
var $74ae264438c87198$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $74ae264438c87198$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $74ae264438c87198$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $74ae264438c87198$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $74ae264438c87198$var$dtfCache = {};
function $74ae264438c87198$var$getDateTimeFormat(timeZone) {
    if (!$74ae264438c87198$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $74ae264438c87198$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $74ae264438c87198$var$dtfCache[timeZone];
}

});

parcelRegister("6jw1Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $498d5cb093137c3d$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $498d5cb093137c3d$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("dMPhC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a09789d8f85d8ea2$export$2e2bcd8739ae039);

var $a04h3 = parcelRequire("a04h3");

var $ejJXr = parcelRequire("ejJXr");

var $k8MHY = parcelRequire("k8MHY");

var $3m5hh = parcelRequire("3m5hh");
var $a09789d8f85d8ea2$var$MILLISECONDS_IN_HOUR = 3600000;
var $a09789d8f85d8ea2$var$MILLISECONDS_IN_MINUTE = 60000;
var $a09789d8f85d8ea2$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $a09789d8f85d8ea2$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $3m5hh.default)
};
function $a09789d8f85d8ea2$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $a09789d8f85d8ea2$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($a04h3)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $a09789d8f85d8ea2$var$splitDateString(argument);
    var parseYearResult = $a09789d8f85d8ea2$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $a09789d8f85d8ea2$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $a09789d8f85d8ea2$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $k8MHY.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $a09789d8f85d8ea2$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $a09789d8f85d8ea2$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $a09789d8f85d8ea2$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $a09789d8f85d8ea2$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $a09789d8f85d8ea2$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $a09789d8f85d8ea2$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $a09789d8f85d8ea2$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $a09789d8f85d8ea2$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $a09789d8f85d8ea2$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $a09789d8f85d8ea2$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $a09789d8f85d8ea2$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$a09789d8f85d8ea2$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $a09789d8f85d8ea2$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$a09789d8f85d8ea2$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $a09789d8f85d8ea2$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$a09789d8f85d8ea2$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $a09789d8f85d8ea2$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$a09789d8f85d8ea2$var$validateWeekDate(year, week)) return new Date(NaN);
        return $a09789d8f85d8ea2$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $a09789d8f85d8ea2$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$a09789d8f85d8ea2$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $a09789d8f85d8ea2$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $a09789d8f85d8ea2$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $a09789d8f85d8ea2$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$a09789d8f85d8ea2$var$validateTime(hours)) return NaN;
        return hours % 24 * $a09789d8f85d8ea2$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $a09789d8f85d8ea2$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$a09789d8f85d8ea2$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $a09789d8f85d8ea2$var$MILLISECONDS_IN_HOUR + minutes * $a09789d8f85d8ea2$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $a09789d8f85d8ea2$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$a09789d8f85d8ea2$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $a09789d8f85d8ea2$var$MILLISECONDS_IN_HOUR + minutes * $a09789d8f85d8ea2$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $a09789d8f85d8ea2$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $a09789d8f85d8ea2$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $a09789d8f85d8ea2$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $a09789d8f85d8ea2$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $a09789d8f85d8ea2$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $a09789d8f85d8ea2$var$isLeapYearIndex(year);
        if (isLeapYear && date > $a09789d8f85d8ea2$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $a09789d8f85d8ea2$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $a09789d8f85d8ea2$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $a09789d8f85d8ea2$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $a09789d8f85d8ea2$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $a09789d8f85d8ea2$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("3m5hh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2717853bccc19429$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $2717853bccc19429$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $2717853bccc19429$export$2e2bcd8739ae039 = $2717853bccc19429$var$tzPattern;

});



parcelRegister("kXsmt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f41f5155270168bb$export$2e2bcd8739ae039);

var $k8MHY = parcelRequire("k8MHY");

var $dMPhC = parcelRequire("dMPhC");
function $f41f5155270168bb$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $dMPhC.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $k8MHY.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});






parcelRegister("kPioY", function(module, exports) {

$parcel$export(module.exports, "eocGlobalGroupDetailRoute", () => $04b87b53684bbda2$export$e6569aff8dfd4c1d);
const $04b87b53684bbda2$export$e6569aff8dfd4c1d = {
    name: 'eoc-global-group-detail',
    path: '/jira/ops/group-detail/:id',
    exact: true
};

});

parcelRegister("9HKZp", function(module, exports) {

$parcel$export(module.exports, "LazyGroupDetail", () => $121ff44230386a5e$export$8d4b3992eb19d436);
$parcel$export(module.exports, "default", () => $121ff44230386a5e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $121ff44230386a5e$export$8d4b3992eb19d436 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("iefqH")), {
    moduleId: "./src/packages/eoc/group-detail/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$121ff44230386a5e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $121ff44230386a5e$export$8d4b3992eb19d436,
        pageId: "async-jira-eoc-group-detail",
        shouldShowSpinner: false
    });

});
parcelRegister("iefqH", function(module, exports) {

let $d45580ca18343938$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $d45580ca18343938$var$load("1VRB2"),
    $d45580ca18343938$var$load("bABhq"),
    $d45580ca18343938$var$load("7vqGd"),
    $d45580ca18343938$var$load("1Y4bq"),
    $d45580ca18343938$var$load("eDzss"),
    $d45580ca18343938$var$load("ed9C0")
]).then(()=>parcelRequire('gZ67m'));

});



parcelRegister("4gFBe", function(module, exports) {

$parcel$export(module.exports, "eocGlobalHeartbeatsRouteEntry", () => $ac43bac0557723f4$export$2d7875aa465a7757);

var $jpZip = parcelRequire("jpZip");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $31fc3 = parcelRequire("31fc3");

var $iRfwO = parcelRequire("iRfwO");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $igs1s = parcelRequire("igs1s");
const $ac43bac0557723f4$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $ac43bac0557723f4$export$2d7875aa465a7757 = (0, $6xToB.createEntry)((0, $31fc3.eocGlobalHeartbeatsRoute), ()=>({
        group: 'eoc',
        component: (0, $igs1s.HeartbeatsComponent),
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $jpZip.resources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$ac43bac0557723f4$var$getNavigationSpecifications()
        },
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $igs1s.LazyHeartbeats)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $igs1s.LazyHeartbeats)
        ]
    }));

});
parcelRegister("jpZip", function(module, exports) {

$parcel$export(module.exports, "heartbeatsResource", () => $2cfdcef274ab866f$export$dd38e2aa5cfda9c9);
$parcel$export(module.exports, "heartbeatsUserRightsResource", () => $2cfdcef274ab866f$export$b5d9a0bcdfa848ce);
$parcel$export(module.exports, "resources", () => $2cfdcef274ab866f$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $g2FCS = parcelRequire("g2FCS");
const $2cfdcef274ab866f$export$dd38e2aa5cfda9c9 = (0, $l1VxS.createResource)({
    type: 'heartbeatsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `heartbeats/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $g2FCS.getHeartbeatsEndpoint)(teamId);
    },
    isBrowserOnly: true
});
const $2cfdcef274ab866f$export$b5d9a0bcdfa848ce = (0, $l1VxS.createResource)({
    type: 'heartbeatsUserRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `heartbeats-user-rights/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $g2FCS.getHeartbeatsUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $2cfdcef274ab866f$export$bc99aaabaf7b70a7 = ()=>[
        $2cfdcef274ab866f$export$dd38e2aa5cfda9c9,
        $2cfdcef274ab866f$export$b5d9a0bcdfa848ce
    ];

});
parcelRegister("g2FCS", function(module, exports) {

$parcel$export(module.exports, "getHeartbeatsEndpoint", () => $39732b0d9a509697$export$c322dad372dcb08b);
$parcel$export(module.exports, "validateHeartbeatNameEndpoint", () => $39732b0d9a509697$export$676f6aee59f124b0);
$parcel$export(module.exports, "createHeartbeatEndpoint", () => $39732b0d9a509697$export$891ea85cc6973b32);
$parcel$export(module.exports, "updateHeartbeatEndpoint", () => $39732b0d9a509697$export$7311481b59e02e06);
$parcel$export(module.exports, "switchHeartbeatEndpoint", () => $39732b0d9a509697$export$5df993f1c74d7e8e);
$parcel$export(module.exports, "deleteHeartbeatEndpoint", () => $39732b0d9a509697$export$716e365975fc2cd1);
$parcel$export(module.exports, "getHeartbeatsUserRights", () => $39732b0d9a509697$export$26eaca11f3b4e506);
$parcel$export(module.exports, "updateAutoCreationEndpoint", () => $39732b0d9a509697$export$38097aade6a3b234);

var $br21R = parcelRequire("br21R");

var $b4qtw = parcelRequire("b4qtw");
const $39732b0d9a509697$export$c322dad372dcb08b = (teamId)=>(0, $br21R.eocFetch)((0, $b4qtw.generateBaseUrl)(teamId), {
        method: 'GET'
    });
const $39732b0d9a509697$export$676f6aee59f124b0 = (heartbeatName, teamId)=>(0, $br21R.eocFetch)(`${(0, $b4qtw.generateBaseUrl)(teamId)}/validateEmail?heartbeatName=${encodeURIComponent(heartbeatName)}`, {
        method: 'GET',
        responseType: 'headers'
    });
const $39732b0d9a509697$export$891ea85cc6973b32 = (heartbeat, teamId)=>(0, $br21R.eocFetch)((0, $b4qtw.generateBaseUrl)(teamId), {
        method: 'POST',
        body: heartbeat
    });
const $39732b0d9a509697$export$7311481b59e02e06 = (heartbeat, teamId)=>(0, $br21R.eocFetch)((0, $b4qtw.generateBaseUrl)(teamId), {
        method: 'PUT',
        body: heartbeat
    });
const $39732b0d9a509697$export$5df993f1c74d7e8e = (enable, name, teamId)=>(0, $br21R.eocFetch)(`${(0, $b4qtw.generateBaseUrl)(teamId)}/enable?enabled=${enable}&name=${encodeURIComponent(name)}`, {
        method: 'PATCH'
    });
const $39732b0d9a509697$export$716e365975fc2cd1 = (name, teamId)=>(0, $br21R.eocFetch)(`${(0, $b4qtw.generateBaseUrl)(teamId)}?name=${encodeURIComponent(name)}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
const $39732b0d9a509697$export$26eaca11f3b4e506 = (teamId)=>{
    return (0, $br21R.eocFetch)(`${(0, $b4qtw.generateBaseUrl)(teamId)}/rights`);
};
const $39732b0d9a509697$export$38097aade6a3b234 = (teamId, autoCreateEnabled)=>(0, $br21R.eocFetch)(`${(0, $b4qtw.generateBaseUrl)(teamId)}/updateHeartbeatAutoCreation?autoCreateEnabled=${autoCreateEnabled}`, {
        method: 'POST',
        responseType: 'headers'
    });

});
parcelRegister("b4qtw", function(module, exports) {

$parcel$export(module.exports, "getMaxAvailableEpoch", () => $83fb296ea67babd6$export$1eaa8fc6df8a5dac);
$parcel$export(module.exports, "generateBaseUrl", () => $83fb296ea67babd6$export$25e86c63685d7e40);

var $j0PM9 = parcelRequire("j0PM9");
const $83fb296ea67babd6$export$1eaa8fc6df8a5dac = ()=>{
    const today = new Date();
    const futureDate = new Date();
    futureDate.setFullYear(today.getFullYear() * (0, $j0PM9.MAX_INTERVAL_TIME_YEARS));
    const epochTime = futureDate.getTime();
    return epochTime;
};
const $83fb296ea67babd6$export$25e86c63685d7e40 = (teamId)=>{
    return teamId ? `/v1/teams/${teamId}/heartbeats` : '/v1/heartbeats';
};

});
parcelRegister("j0PM9", function(module, exports) {

$parcel$export(module.exports, "MAX_INTERVAL_TIME_YEARS", () => $1e411a89448bf60b$export$c3f9ae43b3ab397c);
$parcel$export(module.exports, "MIN_DATE_SHOWN_EPOCH", () => $1e411a89448bf60b$export$f081f690fcb957ce);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $1e411a89448bf60b$export$a7c923252528b255);
const $1e411a89448bf60b$export$c3f9ae43b3ab397c = 5;
const $1e411a89448bf60b$export$f081f690fcb957ce = 946677600;
const $1e411a89448bf60b$export$a7c923252528b255 = {
    actions: 'eoc-heartbeats_actions'
};

});




parcelRegister("31fc3", function(module, exports) {

$parcel$export(module.exports, "eocGlobalHeartbeatsRoute", () => $73a1034ba3855894$export$48568054c59facbb);
const $73a1034ba3855894$export$48568054c59facbb = {
    name: 'eoc-global-heartbeats',
    path: '/jira/settings/products/ops/heartbeats',
    exact: true
};

});

parcelRegister("igs1s", function(module, exports) {

$parcel$export(module.exports, "LazyHeartbeats", () => $10bfd1aa77151542$export$93c9586b023b5aa3);
$parcel$export(module.exports, "HeartbeatsComponent", () => $10bfd1aa77151542$export$43c2d87bd51ba6ac);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $10bfd1aa77151542$export$93c9586b023b5aa3 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("fNGLR")), {
    moduleId: "./src/packages/eoc/heartbeats/src/index.tsx"
});
const $10bfd1aa77151542$export$43c2d87bd51ba6ac = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $10bfd1aa77151542$export$93c9586b023b5aa3,
        pageId: "async-jira-eoc-heartbeats",
        shouldShowSpinner: false
    });

});
parcelRegister("fNGLR", function(module, exports) {

let $b80c9c09be3ea265$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b80c9c09be3ea265$var$load("kb4SH").then(()=>parcelRequire('ee1yi'));

});



parcelRegister("dCYpv", function(module, exports) {

$parcel$export(module.exports, "eocGlobalMaintenanceRouteEntry", () => $89b01b8fb5fbf786$export$ce2a5648c28a5b48);

var $iVKB5 = parcelRequire("iVKB5");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $iRfwO = parcelRequire("iRfwO");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $6PfIm = parcelRequire("6PfIm");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $kMVdl = parcelRequire("kMVdl");
const $89b01b8fb5fbf786$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $89b01b8fb5fbf786$export$ce2a5648c28a5b48 = (0, $6xToB.createEntry)((0, $6PfIm.eocGlobalMaintenanceRoute), ()=>({
        group: 'eoc',
        component: (0, $kMVdl.MaintenanceComponent),
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $iVKB5.resources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$89b01b8fb5fbf786$var$getNavigationSpecifications()
        },
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kMVdl.LazyMaintenance)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kMVdl.LazyMaintenance)
        ]
    }));

});
parcelRegister("iVKB5", function(module, exports) {

$parcel$export(module.exports, "maintenanceResource", () => $730c351002ab3c15$export$5486c78261efb2c3);
$parcel$export(module.exports, "maintenanceUserRightsResource", () => $730c351002ab3c15$export$e4c92d8948e3625);
$parcel$export(module.exports, "resources", () => $730c351002ab3c15$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $dwoHY = parcelRequire("dwoHY");

var $jkNeG = parcelRequire("jkNeG");
const $730c351002ab3c15$export$5486c78261efb2c3 = (0, $l1VxS.createResource)({
    type: 'maintenanceResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `maintenance/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $jkNeG.getMaintenance)(teamId);
    },
    isBrowserOnly: true
});
const $730c351002ab3c15$export$e4c92d8948e3625 = (0, $l1VxS.createResource)({
    type: 'maintenanceUserRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `maintenance-user-rights/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $jkNeG.getMaintenanceUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $730c351002ab3c15$export$bc99aaabaf7b70a7 = ()=>[
        ...(0, $dwoHY.eocCommonResources)(),
        $730c351002ab3c15$export$5486c78261efb2c3,
        $730c351002ab3c15$export$e4c92d8948e3625
    ];

});
parcelRegister("jkNeG", function(module, exports) {

$parcel$export(module.exports, "getMaintenance", () => $637df9ee0c9ad9e8$export$9cc878e1852c5ee1);
$parcel$export(module.exports, "deleteMaintenance", () => $637df9ee0c9ad9e8$export$f64242288df38e86);
$parcel$export(module.exports, "cancelMaintenance", () => $637df9ee0c9ad9e8$export$2d4a5362bda1b3c1);
$parcel$export(module.exports, "changeDateAndTime", () => $637df9ee0c9ad9e8$export$2162fcbd04e23a3d);
$parcel$export(module.exports, "getMaintenanceUserRights", () => $637df9ee0c9ad9e8$export$60048f3b7e7bf9b9);
$parcel$export(module.exports, "createMaintenance", () => $637df9ee0c9ad9e8$export$602dd976bd963418);
$parcel$export(module.exports, "updateMaintenance", () => $637df9ee0c9ad9e8$export$fa55cd063e1b15c2);

var $br21R = parcelRequire("br21R");
const $637df9ee0c9ad9e8$export$9cc878e1852c5ee1 = (teamId)=>{
    return (0, $br21R.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances`);
};
const $637df9ee0c9ad9e8$export$f64242288df38e86 = (teamId, id)=>{
    return (0, $br21R.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $637df9ee0c9ad9e8$export$2d4a5362bda1b3c1 = (teamId, id)=>{
    return (0, $br21R.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/cancel`, {
        method: 'PATCH'
    });
};
const $637df9ee0c9ad9e8$export$2162fcbd04e23a3d = (teamId, id, endDate)=>{
    return (0, $br21R.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/updateEndDate`, {
        method: 'PATCH',
        body: {
            endDate: endDate
        }
    });
};
const $637df9ee0c9ad9e8$export$60048f3b7e7bf9b9 = (teamId)=>{
    return (0, $br21R.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/rights`);
};
const $637df9ee0c9ad9e8$export$602dd976bd963418 = (payload, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances` : '/v1/maintenances';
    return (0, $br21R.eocFetch)(url, {
        method: 'POST',
        body: payload
    });
};
const $637df9ee0c9ad9e8$export$fa55cd063e1b15c2 = (payload, id, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances/${id}` : `/v1/maintenances/${id}`;
    return (0, $br21R.eocFetch)(url, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("6PfIm", function(module, exports) {

$parcel$export(module.exports, "eocGlobalMaintenanceRoute", () => $f8bec2b534fc57c5$export$e0665f23a759e78f);
const $f8bec2b534fc57c5$export$e0665f23a759e78f = {
    name: 'eoc-global-maintenance',
    path: '/jira/settings/products/ops/maintenance',
    exact: true
};

});

parcelRegister("kMVdl", function(module, exports) {

$parcel$export(module.exports, "LazyMaintenance", () => $71650970c1af5b00$export$c5c7dc53d976edee);
$parcel$export(module.exports, "MaintenanceComponent", () => $71650970c1af5b00$export$76d7c25f72022339);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $71650970c1af5b00$export$c5c7dc53d976edee = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("dLh4V")), {
    moduleId: "./src/packages/eoc/maintenance/src/index.tsx"
});
const $71650970c1af5b00$export$76d7c25f72022339 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $71650970c1af5b00$export$c5c7dc53d976edee,
        pageId: "async-jira-eoc-maintenance",
        shouldShowSpinner: false
    });

});
parcelRegister("dLh4V", function(module, exports) {

let $a04ce994308c0b0f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $a04ce994308c0b0f$var$load("1VRB2"),
    $a04ce994308c0b0f$var$load("bABhq"),
    $a04ce994308c0b0f$var$load("kK5U3")
]).then(()=>parcelRequire('8L6ZW'));

});



parcelRegister("ezywV", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsHomePageNav4RouteEntry", () => $f2c1ac7f91e1614d$export$193586b163d4afae);

var $1vFVi = parcelRequire("1vFVi");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $63eGz = parcelRequire("63eGz");

var $iRfwO = parcelRequire("iRfwO");

var $98AOo = parcelRequire("98AOo");
const $f2c1ac7f91e1614d$export$193586b163d4afae = (0, $6xToB.createEntry)((0, $63eGz.eocGlobalReportsHomePageNav4Route), ()=>({
        group: 'eoc',
        component: (0, $98AOo.OpsReportsRedirect),
        layout: (0, $iRfwO.opsMigrationHubLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1vFVi.resources)(),
            (0, $1vFVi.opsReportsPermissionResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default)
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $98AOo.LazyOpsReportsRedirect),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("1vFVi", function(module, exports) {

$parcel$export(module.exports, "opsReportsResource", () => $f4d383d3bbe555bd$export$8498311fc7a4ab48);
$parcel$export(module.exports, "opsReportsPermissionResource", () => $f4d383d3bbe555bd$export$c432f280d76e2acf);
$parcel$export(module.exports, "resources", () => $f4d383d3bbe555bd$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $feIEW = parcelRequire("feIEW");
var $jXKdt = parcelRequire("jXKdt");

var $7wS89 = parcelRequire("7wS89");

var $fzWLN = parcelRequire("fzWLN");
const $f4d383d3bbe555bd$export$8498311fc7a4ab48 = (0, $l1VxS.createResource)({
    type: 'opsReportsResource',
    getKey: ()=>'opsReportsResource',
    getData: async ()=>{
        const settings = await (0, $fzWLN.getReportSettings)();
        const api = (0, $fzWLN.getDashboards);
        return {
            settings: settings,
            dashboards: settings.showReportingMaintenance ? null : await api()
        };
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $f4d383d3bbe555bd$export$c432f280d76e2acf = (0, $l1VxS.createResource)({
    type: 'opsReportsPermissionResource',
    getKey: ({ match: match })=>{
        return `opsReportsPermissionResource-${match.params?.teamId}`;
    },
    getData: async (routerContext)=>{
        const isTeamDashboard = (0, $7wS89.isTeamReportsUrl)(routerContext.match.url);
        const teamId = routerContext.match.params?.teamId;
        (0, $feIEW.assert)(!isTeamDashboard || !!teamId, new (0, $jXKdt.AssertionError)('opsReportsPermissionResource', 'teamId should be set to fetch reports permissions on TeamDashboard page'));
        return (0, $fzWLN.getReportRights)(teamId);
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $f4d383d3bbe555bd$export$bc99aaabaf7b70a7 = ()=>[
        $f4d383d3bbe555bd$export$8498311fc7a4ab48,
        $f4d383d3bbe555bd$export$c432f280d76e2acf
    ];

});
parcelRegister("7wS89", function(module, exports) {

$parcel$export(module.exports, "withReportingPrefix", () => $4b962c2d25230541$export$c0f073d636267c44);
$parcel$export(module.exports, "isTeamReportsUrl", () => $4b962c2d25230541$export$f923ac475871fcad);

var $b388R = parcelRequire("b388R");
function $4b962c2d25230541$export$c0f073d636267c44(input) {
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = (0, $b388R.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jsm/ops/reporting/cloudId/${cloudId}/api` + input;
    return input;
}
const $4b962c2d25230541$export$f923ac475871fcad = (pathName)=>pathName.startsWith('/jira/ops/teams/');

});

parcelRegister("fzWLN", function(module, exports) {

$parcel$export(module.exports, "getDashboards", () => $74d737658b0742b1$export$8e4b6d6c4fec08f3);
$parcel$export(module.exports, "getReportSettings", () => $74d737658b0742b1$export$9114b8a872caf5d8);
$parcel$export(module.exports, "getSsoEmbedUrlEndpoint", () => $74d737658b0742b1$export$8384a95746267bd8);
$parcel$export(module.exports, "getReportRights", () => $74d737658b0742b1$export$f4a61c3c8c619f12);
$parcel$export(module.exports, "getAVPEmbedTokens", () => $74d737658b0742b1$export$fb46892f83504a42);

var $br21R = parcelRequire("br21R");

var $7wS89 = parcelRequire("7wS89");

var $b1gJQ = parcelRequire("b1gJQ");
const $74d737658b0742b1$export$8e4b6d6c4fec08f3 = ()=>(0, $br21R.eocFetch)((0, $7wS89.withReportingPrefix)('/v5/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $b1gJQ.opsReportsErrorTransformer
    });
const $74d737658b0742b1$export$e69121e90ce0231b = ()=>(0, $br21R.eocFetch)((0, $7wS89.withReportingPrefix)('/v3/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $b1gJQ.opsReportsErrorTransformer
    });
const $74d737658b0742b1$export$9114b8a872caf5d8 = ()=>(0, $br21R.eocFetch)((0, $7wS89.withReportingPrefix)('/v3/reports/index'), {
        exactUrl: true,
        errorTransformer: $b1gJQ.opsReportsErrorTransformer
    });
const $74d737658b0742b1$export$8384a95746267bd8 = (isDarkMode, dashboardId, teamId)=>{
    const queryParam = teamId ? {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        teamId: teamId,
        // Adding time as queryParam to avoid browser caching
        // Should ideally be handled by "Cache-Control" header from server
        _: Date.now().toString()
    } : {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        _: Date.now().toString()
    };
    const url = `/v3/reports/dashboard?${new URLSearchParams(queryParam).toString()}`;
    return (0, $br21R.eocFetch)((0, $7wS89.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $b1gJQ.opsReportsErrorTransformer
    });
};
const $74d737658b0742b1$export$f4a61c3c8c619f12 = (teamId)=>{
    let url = '/v3/reports/rights';
    if (teamId) url += `?teamId=${teamId}`;
    return (0, $br21R.eocFetch)((0, $7wS89.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $b1gJQ.opsReportsErrorTransformer
    });
};
const $74d737658b0742b1$export$fb46892f83504a42 = (dashboardId, teamId)=>{
    let url = '/v3/reports/embed-token';
    return (0, $br21R.eocFetch)((0, $7wS89.withReportingPrefix)(url), {
        exactUrl: true,
        method: 'POST',
        body: {
            dashboardId: dashboardId,
            teamId: teamId
        },
        errorTransformer: $b1gJQ.opsReportsErrorTransformer
    });
};

});
parcelRegister("b1gJQ", function(module, exports) {

$parcel$export(module.exports, "opsReportsErrorTransformer", () => $39b39260ef433879$export$b170750bd4489531);

var $b8wNz = parcelRequire("b8wNz");
const $39b39260ef433879$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8)|("ISO-8859-1")|(ISO-8859-1))))/i;
const $39b39260ef433879$export$b170750bd4489531 = (e)=>{
    if ((0, $b8wNz.isHTTPError)(e)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $39b39260ef433879$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $b8wNz.StreamedHTTPError)(e, data, data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $b8wNz.StreamedHTTPError)(e, message, message));
    }
    return e;
};

});



parcelRegister("63eGz", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsHomePageNav4Route", () => $7d3c0d02265ceb21$export$e7c62a288f7d3a11);
const $7d3c0d02265ceb21$export$e7c62a288f7d3a11 = {
    name: 'eoc-global-reports',
    path: '/jira/ops/reports',
    exact: true
};

});

parcelRegister("98AOo", function(module, exports) {

$parcel$export(module.exports, "LazyOpsReports", () => $869a8a1e2d67bce3$export$2404f0e35deca592);
$parcel$export(module.exports, "LazyOpsReportsRedirect", () => $869a8a1e2d67bce3$export$d33ea1a773b744e);
$parcel$export(module.exports, "LazyGlobalOpsReports", () => $869a8a1e2d67bce3$export$66850ec5549adba6);
$parcel$export(module.exports, "LazyOpsReportsUnsubscribe", () => $869a8a1e2d67bce3$export$5fd77c3bbfb22cbd);
$parcel$export(module.exports, "OpsReportsRedirect", () => $869a8a1e2d67bce3$export$22253dbadb46d0cf);
$parcel$export(module.exports, "GlobalOpsReports", () => $869a8a1e2d67bce3$export$648ddf2d1f8b1c3f);
$parcel$export(module.exports, "OpsReports", () => $869a8a1e2d67bce3$export$87e6a54b4f5dc91e);
$parcel$export(module.exports, "OpsReportsUnsubscribe", () => $869a8a1e2d67bce3$export$7f366d77015c286f);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $869a8a1e2d67bce3$export$2404f0e35deca592 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("5RGml")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $869a8a1e2d67bce3$export$d33ea1a773b744e = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("5RGml")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $869a8a1e2d67bce3$export$66850ec5549adba6 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("5RGml")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $869a8a1e2d67bce3$export$5fd77c3bbfb22cbd = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("5RGml")).then((exportedMembers)=>exportedMembers.OpsReportsUnsubscribe), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $869a8a1e2d67bce3$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $869a8a1e2d67bce3$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
const $869a8a1e2d67bce3$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $869a8a1e2d67bce3$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
const $869a8a1e2d67bce3$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $869a8a1e2d67bce3$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });
const $869a8a1e2d67bce3$export$7f366d77015c286f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $869a8a1e2d67bce3$export$5fd77c3bbfb22cbd,
        pageId: "async-jira-eoc-ops-reports-unsubscribe",
        shouldShowSpinner: false
    });

});
parcelRegister("5RGml", function(module, exports) {

let $4452c2ad8864e18c$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    $4452c2ad8864e18c$var$load("1VRB2"),
    $4452c2ad8864e18c$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("fuvSE"), 4)),
    $4452c2ad8864e18c$var$load("7vqGd"),
    $4452c2ad8864e18c$var$load("1Y4bq"),
    $4452c2ad8864e18c$var$load("aa63A")
]).then(()=>parcelRequire('cImxM'));

});



parcelRegister("iXFOs", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsNav4RouteEntry", () => $9c0ed43579def0b8$export$90a73fe101848dd);

var $1vFVi = parcelRequire("1vFVi");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $72EwM = parcelRequire("72EwM");

var $98AOo = parcelRequire("98AOo");
const $9c0ed43579def0b8$export$90a73fe101848dd = (0, $6xToB.createEntry)((0, $72EwM.eocGlobalReportsNav4Route), ()=>({
        group: 'eoc',
        component: (0, $98AOo.GlobalOpsReports),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1vFVi.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $98AOo.LazyGlobalOpsReports)
        ]
    }));

});
parcelRegister("72EwM", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsNav4Route", () => $9c498525c08cccd4$export$2344cc35fd2eff4e);
const $9c498525c08cccd4$export$2344cc35fd2eff4e = {
    name: 'eoc-global-report-dashboard',
    path: '/jira/ops/reports/:dashboardId',
    exact: true
};

});


parcelRegister("dqsu7", function(module, exports) {

$parcel$export(module.exports, "eocHeartbeatsRouteEntry", () => $496d13b3d3b8550b$export$2c2d6115c4280a08);

var $jpZip = parcelRequire("jpZip");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $3oIRx = parcelRequire("3oIRx");

var $igs1s = parcelRequire("igs1s");
const $496d13b3d3b8550b$export$2c2d6115c4280a08 = (0, $6xToB.createEntry)((0, $3oIRx.eocHeartbeatsRoute), ()=>({
        group: 'eoc',
        component: (0, $igs1s.HeartbeatsComponent),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $jpZip.resources)(),
            ...(0, $io7oY.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $igs1s.LazyHeartbeats),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("3oIRx", function(module, exports) {

$parcel$export(module.exports, "eocHeartbeatsRoute", () => $d17cfa5e832430e2$export$71bd833dcb7bd1e9);
const $d17cfa5e832430e2$export$71bd833dcb7bd1e9 = {
    name: 'eoc-heartbeats',
    path: '/jira/ops/teams/:teamId/heartbeats',
    exact: true
};

});


parcelRegister("j3oaw", function(module, exports) {

$parcel$export(module.exports, "eocMaintenanceRouteEntry", () => $a17211bb7828b802$export$e9c59d0d6bfec8a3);

var $iVKB5 = parcelRequire("iVKB5");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $3qe4A = parcelRequire("3qe4A");

var $kMVdl = parcelRequire("kMVdl");
const $a17211bb7828b802$export$e9c59d0d6bfec8a3 = (0, $6xToB.createEntry)((0, $3qe4A.eocMaintenanceRoute), ()=>({
        group: 'eoc',
        component: (0, $kMVdl.MaintenanceComponent),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $iVKB5.resources)(),
            ...(0, $io7oY.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kMVdl.LazyMaintenance),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("3qe4A", function(module, exports) {

$parcel$export(module.exports, "eocMaintenanceRoute", () => $3579c3313c5d4bfc$export$7523f600b27b1b54);
const $3579c3313c5d4bfc$export$7523f600b27b1b54 = {
    name: 'eoc-maintenance',
    path: '/jira/ops/teams/:teamId/maintenance',
    exact: true
};

});


parcelRegister("atZb5", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRedirectRouteEntry", () => $8757cbc08785af76$export$c5c49f69c4fe1ea6);

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $5AUdw = parcelRequire("5AUdw");

var $7rCqf = parcelRequire("7rCqf");
const $8757cbc08785af76$export$c5c49f69c4fe1ea6 = (0, $6xToB.createEntry)((0, $5AUdw.eocOnCallRedirectRoute), ()=>({
        group: 'eoc',
        component: (0, $7rCqf.OnCallRedirect),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        isRedirect: true
    }));

});
parcelRegister("5AUdw", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRedirectRoute", () => $706d9c14d0500529$export$d725ece0e087d522);
const $706d9c14d0500529$export$d725ece0e087d522 = {
    name: 'eoc-on-call-redirect',
    path: '/jira/ops/teams/:teamId',
    exact: true
};

});

parcelRegister("7rCqf", function(module, exports) {

$parcel$export(module.exports, "OnCallRedirect", () => $74dda56f1dc0d5b5$export$659b7ce11c160b32);
$parcel$export(module.exports, "LazyOnCall", () => $74dda56f1dc0d5b5$export$772095aa22362f73);
$parcel$export(module.exports, "default", () => $74dda56f1dc0d5b5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $2mHfh = parcelRequire("2mHfh");
var $gCY1z = parcelRequire("gCY1z");
const $74dda56f1dc0d5b5$export$659b7ce11c160b32 = ()=>{
    const [routeContext] = (0, $gCY1z.useRouter)();
    const redirectionUrl = `${routeContext.location.pathname}/on-call`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: redirectionUrl
    });
};

const $74dda56f1dc0d5b5$export$772095aa22362f73 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("4apdC")), {
    moduleId: "./src/packages/eoc/on-call/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$74dda56f1dc0d5b5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $74dda56f1dc0d5b5$export$772095aa22362f73,
        pageId: "async-jira-eoc-on-call",
        shouldShowSpinner: false
    });

});
parcelRegister("4apdC", function(module, exports) {

let $308ba87bace83891$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $308ba87bace83891$var$load("1VRB2"),
    $308ba87bace83891$var$load("bABhq"),
    $308ba87bace83891$var$load("7vqGd"),
    $308ba87bace83891$var$load("1Y4bq"),
    $308ba87bace83891$var$load("3GDGI")
]).then(()=>parcelRequire('1cQxv'));

});



parcelRegister("bcSH6", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRouteEntry", () => $a5f720dfbef0d05b$export$ac245212b12db871);

var $h7gCU = parcelRequire("h7gCU");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $k6osT = parcelRequire("k6osT");

var $7rCqf = parcelRequire("7rCqf");
const $a5f720dfbef0d05b$export$ac245212b12db871 = (0, $6xToB.createEntry)((0, $k6osT.eocOnCallRoute), ()=>({
        group: 'eoc',
        component: (0, $7rCqf.default),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)(),
            ...(0, $h7gCU.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7rCqf.LazyOnCall),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("h7gCU", function(module, exports) {

$parcel$export(module.exports, "getTeamResource", () => $d44c494ee6cd8b46$export$50271c9e7f21f10e);
$parcel$export(module.exports, "resources", () => $d44c494ee6cd8b46$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $feIEW = parcelRequire("feIEW");
var $jXKdt = parcelRequire("jXKdt");

var $2HJaS = parcelRequire("2HJaS");

var $11KMI = parcelRequire("11KMI");

var $6p3HM = parcelRequire("6p3HM");
const $d44c494ee6cd8b46$export$50271c9e7f21f10e = (0, $l1VxS.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $feIEW.assert)(!!teamId, new (0, $jXKdt.AssertionError)('getTeamResource', 'teamId should be set to fetch on-call'));
        return (0, $6p3HM.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $d44c494ee6cd8b46$export$bc99aaabaf7b70a7 = ()=>[
        ...(0, $11KMI.resources),
        (0, $2HJaS.routingRulesResource),
        $d44c494ee6cd8b46$export$50271c9e7f21f10e
    ];

});
parcelRegister("2HJaS", function(module, exports) {

$parcel$export(module.exports, "routingRulesResource", () => $eaabb489ebf4de22$export$7f38c73dca88500e);

var $l1VxS = parcelRequire("l1VxS");

var $feIEW = parcelRequire("feIEW");
var $jXKdt = parcelRequire("jXKdt");

var $iQDXY = parcelRequire("iQDXY");
const $eaabb489ebf4de22$export$7f38c73dca88500e = (0, $l1VxS.createResource)({
    type: 'routingRulesResource',
    getKey: ()=>'routingRulesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $feIEW.assert)(!!teamId, new (0, $jXKdt.AssertionError)('routingRulesResource', 'teamId should be set to fetch routing-rules'));
        return (0, $iQDXY.getRoutingRules)(teamId);
    },
    isBrowserOnly: true
});

});
parcelRegister("iQDXY", function(module, exports) {

$parcel$export(module.exports, "getRoutingRules", () => $3b069483dfa5a144$export$425c24c86196521);

var $br21R = parcelRequire("br21R");
const $3b069483dfa5a144$export$425c24c86196521 = (teamId)=>(0, $br21R.eocFetch)(`/v1/teams/${teamId}/routing-rules`);

});


parcelRegister("11KMI", function(module, exports) {

$parcel$export(module.exports, "getSchedulesResource", () => $14e13a3c05c97e5b$export$6b2b3e2a53cc13e2);
$parcel$export(module.exports, "getUiPreferencesResource", () => $14e13a3c05c97e5b$export$5c6454d866055bdd);
$parcel$export(module.exports, "getScheduleRightsResource", () => $14e13a3c05c97e5b$export$9d9ecb8586783931);
$parcel$export(module.exports, "getScheduleTimeTemplatesResource", () => $14e13a3c05c97e5b$export$90251855f07c54b4);
$parcel$export(module.exports, "resources", () => $14e13a3c05c97e5b$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $dwoHY = parcelRequire("dwoHY");

var $jDL6C = parcelRequire("jDL6C");

var $eknvn = parcelRequire("eknvn");

var $koDki = parcelRequire("koDki");

var $1c1NE = parcelRequire("1c1NE");

var $RwOoQ = parcelRequire("RwOoQ");

var $ftu4y = parcelRequire("ftu4y");
const $14e13a3c05c97e5b$export$6b2b3e2a53cc13e2 = (0, $l1VxS.createResource)({
    type: 'getSchedulesResource',
    getKey: ()=>'getSchedulesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $1c1NE.endpoints).getScheduleList((0, $eknvn.getTeamIdFromContext)(routerExtendedContext))
});
const $14e13a3c05c97e5b$export$5c6454d866055bdd = (0, $l1VxS.createResource)({
    type: 'getSchedulePreferencesResource',
    getKey: ()=>'getSchedulePreferencesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $RwOoQ.endpoints).getUiPreferences((0, $eknvn.getTeamIdFromContext)(routerExtendedContext))
});
const $14e13a3c05c97e5b$export$9d9ecb8586783931 = (0, $l1VxS.createResource)({
    type: 'getScheduleRightsResource',
    getKey: ()=>'getScheduleRightsResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $ftu4y.endpoints).getScheduleRights((0, $eknvn.getTeamIdFromContext)(routerExtendedContext))
});
const $14e13a3c05c97e5b$export$90251855f07c54b4 = (0, $l1VxS.createResource)({
    type: 'getScheduleTimeTemplatesResource',
    getKey: ()=>'getScheduleTimeTemplatesResourceurce',
    isBrowserOnly: true,
    getData: async ()=>(0, $koDki.endpoints).getScheduleTimeTemplates()
});
const $14e13a3c05c97e5b$export$bc99aaabaf7b70a7 = [
    $14e13a3c05c97e5b$export$6b2b3e2a53cc13e2,
    $14e13a3c05c97e5b$export$5c6454d866055bdd,
    $14e13a3c05c97e5b$export$9d9ecb8586783931,
    $14e13a3c05c97e5b$export$90251855f07c54b4,
    ...(0, $jDL6C.resources),
    ...(0, $dwoHY.eocCommonResources)()
];

});
parcelRegister("jDL6C", function(module, exports) {

$parcel$export(module.exports, "getTimezonesResource", () => $a9f7c6cb75cc8c98$export$7524ea9fda8149c6);
$parcel$export(module.exports, "getTimeTemplatesResource", () => $a9f7c6cb75cc8c98$export$f045bbf39b81240d);
$parcel$export(module.exports, "resources", () => $a9f7c6cb75cc8c98$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $8AWjG = parcelRequire("8AWjG");
const $a9f7c6cb75cc8c98$export$7524ea9fda8149c6 = (0, $l1VxS.createResource)({
    type: 'getEocTimezonesResource',
    getKey: ()=>'getEocTimezonesResource',
    isBrowserOnly: true,
    getData: async ()=>(0, $8AWjG.endpoints).getTimezones()
});
const $a9f7c6cb75cc8c98$export$f045bbf39b81240d = (0, $l1VxS.createResource)({
    type: 'getEocTimeTemplatesResource',
    getKey: ()=>'getEocTimeTemplatesResource',
    isBrowserOnly: true,
    getData: async ()=>(0, $8AWjG.endpoints).getTimeTemplates()
});
const $a9f7c6cb75cc8c98$export$bc99aaabaf7b70a7 = [
    $a9f7c6cb75cc8c98$export$7524ea9fda8149c6
];

});
parcelRegister("8AWjG", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $bebf2fbf8244ff9a$export$3a2536d80ecc00e7);

var $br21R = parcelRequire("br21R");

var $eqrfq = parcelRequire("eqrfq");
const $bebf2fbf8244ff9a$var$getTimezones = async ()=>{
    const response = await (0, $br21R.eocFetch)((0, $eqrfq.urls).customers.timezones.url(), {
        method: 'GET'
    });
    const adjusted = response.timezones.map((timezone)=>({
            ...timezone,
            offset: timezone.offset * 60000,
            currentOffset: timezone.currentOffset * 60000
        }));
    return {
        ...response,
        timezones: adjusted
    };
};
const $bebf2fbf8244ff9a$var$getTimeTemplates = ()=>{
    return (0, $br21R.eocFetch)((0, $eqrfq.urls).schedules.timeTemplates.rotation.url(), {
        method: 'GET'
    });
};
const $bebf2fbf8244ff9a$export$3a2536d80ecc00e7 = {
    getTimezones: $bebf2fbf8244ff9a$var$getTimezones,
    getTimeTemplates: $bebf2fbf8244ff9a$var$getTimeTemplates
};

});
parcelRegister("eqrfq", function(module, exports) {

$parcel$export(module.exports, "urls", () => $a32777300943e890$export$bcae9ba627f604b6);
const $a32777300943e890$export$bcae9ba627f604b6 = Object.freeze({
    alerts: {
        responders: {
            names: {
                url: ()=>'/v1/alerts/responders/names'
            },
            autoComplete: {
                url: ()=>'/v1/alerts/responders/auto-complete'
            },
            suggested: {
                url: ()=>'/v1/alerts/responders/suggested'
            }
        }
    },
    schedules: {
        url: ()=>`/v1/schedules`,
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`/v1/schedules/${scheduleId}`,
            clone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/clone`
            },
            name: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/name`
            },
            timezone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timezone`
            },
            enable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/enable`
            },
            disable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/disable`
            },
            webCalendarUrl: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/web-calendar-url`
            },
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timeline`
            },
            overrides: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/overrides`,
                alias: {
                    url: ({ scheduleId: scheduleId, alias: alias } = {
                        scheduleId: ':scheduleId',
                        alias: ':alias'
                    })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                },
                bulk: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                }
            },
            rotations: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/rotations`,
                rotationId: {
                    url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                        scheduleId: ':scheduleId',
                        rotationId: ':rotationId'
                    })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                    order: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                    },
                    name: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                    }
                }
            }
        },
        user: {
            webCalendarUrl: {
                url: ()=>`/v1/schedules/user/web-calendar-url`
            }
        },
        timeTemplates: {
            rotation: {
                url: ()=>'/v1/schedules/time-templates/rotation'
            }
        }
    },
    customers: {
        timezones: {
            url: ()=>'/v1/customers/timezones'
        }
    }
});

});



parcelRegister("eknvn", function(module, exports) {

$parcel$export(module.exports, "getTeamIdFromContext", () => $e930d4881f66b37a$export$3ea727bebc3792bb);

var $feIEW = parcelRequire("feIEW");
var $jXKdt = parcelRequire("jXKdt");

var $h0qRP = parcelRequire("h0qRP");
const $e930d4881f66b37a$export$3ea727bebc3792bb = (routerContext)=>{
    const teamId = (0, $h0qRP.getSafe)(()=>routerContext.match.params.teamId, null);
    (0, $feIEW.assert)(!(0, $h0qRP.isEmpty)(teamId), new (0, $jXKdt.AssertionError)('eoc-schedule', 'teamId in routerContext is not defined'));
    return teamId;
};

});
parcelRegister("h0qRP", function(module, exports) {

$parcel$export(module.exports, "getSafe", () => $e343bcff9386349d$export$fedb900c0ea4e699);
$parcel$export(module.exports, "isEmpty", () => $e343bcff9386349d$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isNullOrUndefined", () => $e343bcff9386349d$export$bedb7023a7733221);
$parcel$export(module.exports, "noLeadingOrTrailingSpaces", () => $e343bcff9386349d$export$5fc068d42db64a99);

var $gh6ER = parcelRequire("gh6ER");
const $e343bcff9386349d$export$fedb900c0ea4e699 = (fn, defaultValue)=>{
    try {
        return fn();
    } catch  {
        return defaultValue;
    }
};
const $e343bcff9386349d$export$dd1bc94b04021eeb = (input)=>{
    if (input !== 0 && input !== false && !input) return true;
    if (!(input instanceof Date) && typeof input === 'object' && Object.keys(input).length === 0) return true;
    return false;
};
const $e343bcff9386349d$export$bedb7023a7733221 = (input)=>{
    return input === null || input === undefined;
};
const $e343bcff9386349d$export$5fc068d42db64a99 = (message)=>({ formatMessage: formatMessage })=>(value)=>{
            if (typeof value === 'string' && (value.startsWith(' ') || value.endsWith(' '))) return message ?? formatMessage((0, $gh6ER.messages).nameSpaceValidationError);
        };

});
parcelRegister("gh6ER", function(module, exports) {

$parcel$export(module.exports, "messages", () => $983ada29437085f7$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $983ada29437085f7$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    /*
   Misc common messages
  */ noOne: {
        id: 'eoc-schedule.common.no-one',
        defaultMessage: 'No one',
        description: 'Name of the user whose type is no-one.'
    },
    error: {
        id: 'eoc-schedule.common.error',
        defaultMessage: 'Error',
        description: 'Just simple error message.'
    },
    tryAgain: {
        id: 'eoc-schedule.common.try-again',
        defaultMessage: 'Try again',
        description: 'Try again message when an error occurs.'
    },
    cancel: {
        id: 'eoc-schedule.common.cancel',
        defaultMessage: 'Cancel',
        description: 'A cancel button.'
    },
    confirm: {
        id: 'eoc-schedule.common.confirm',
        defaultMessage: 'Confirm',
        description: 'A confirm button.'
    },
    addOverride: {
        id: 'eoc-schedule.common.add-override',
        defaultMessage: 'Add override',
        description: 'Adding override for a period item.'
    },
    overrideButton: {
        id: 'eoc-schedule.common.override',
        defaultMessage: 'Override',
        description: 'A override button.'
    },
    saveButton: {
        id: 'eoc-schedule.common.save',
        defaultMessage: 'Save',
        description: 'A save button.'
    },
    edit: {
        id: 'eoc-schedule.common.edit',
        defaultMessage: 'Edit',
        description: 'Button for editing schedule.'
    },
    turnOff: {
        id: 'eoc-schedule.common.turn-off',
        defaultMessage: 'Turn off',
        description: 'Button for turn-offing schedule.'
    },
    turnOn: {
        id: 'eoc-schedule.common.turn-on',
        defaultMessage: 'Turn on',
        description: 'Button for turn-on schedule.'
    },
    delete: {
        id: 'eoc-schedule.common.delete',
        defaultMessage: 'Delete',
        description: 'Button for deleting schedule or rotation.'
    },
    duplicate: {
        id: 'eoc-schedule.common.duplicate',
        defaultMessage: 'Duplicate',
        description: 'Button for duplicating schedule or rotation.'
    },
    remove: {
        id: 'eoc-schedule.common.remove',
        defaultMessage: 'Remove',
        description: 'Button for removing participant.'
    },
    start: {
        id: 'eoc-schedule.common.start',
        defaultMessage: 'Start',
        description: 'Label for start time and date.'
    },
    end: {
        id: 'eoc-schedule.common.end',
        defaultMessage: 'End',
        description: 'Label for end time and date.'
    },
    startTime: {
        id: 'eoc-schedule.common.start-time',
        defaultMessage: 'Start time',
        description: 'Label for start time and date.'
    },
    endTime: {
        id: 'eoc-schedule.common.end-time',
        defaultMessage: 'End time',
        description: 'Label for end time and date.'
    },
    startDate: {
        id: 'eoc-schedule.common.start-date',
        defaultMessage: 'Start date',
        description: 'Label for start time and date.'
    },
    endDate: {
        id: 'eoc-schedule.common.end-date',
        defaultMessage: 'End date',
        description: 'Label for end time and date.'
    },
    team: {
        id: 'eoc-schedule.common.team',
        defaultMessage: 'Team',
        description: 'Label that indicates responder is of type: Team'
    },
    escalation: {
        id: 'eoc-schedule.common.escalation',
        defaultMessage: 'Escalation',
        description: 'Label that indicates responder is of type: Escalation'
    },
    schedule: {
        id: 'eoc-schedule.common.schedule',
        defaultMessage: 'Schedule',
        description: 'Label that indicates responder is of type: Schedule'
    },
    selectionCount: {
        id: 'eoc-schedule.common.selection-count',
        defaultMessage: '{count} shifts selected',
        description: 'Indicates how many shifts are selected for override.'
    },
    quickOverrideTitle: {
        id: 'eoc-schedule.common.quick-override-title',
        defaultMessage: 'Override',
        description: 'Title for quick override card.'
    },
    search: {
        id: 'eoc-schedule.common.search',
        defaultMessage: 'Search',
        description: 'Label of search icon that shown inside search participant field'
    },
    replaceWith: {
        id: 'eoc-schedule.common.replace-with',
        defaultMessage: 'Replace with',
        description: 'A button for opening popup for replacing a participant.'
    },
    participants: {
        id: 'eoc-schedule.common.participants',
        defaultMessage: 'Participants',
        description: 'Label for participants.'
    },
    addParticipants: {
        id: 'eoc-schedule.common.add-participants',
        defaultMessage: 'Add people, teams, and escalation policies',
        description: 'Placeholder text for auto complete field for participants (responders).'
    },
    select: {
        id: 'eoc-schedule.common.select',
        defaultMessage: 'Select',
        description: 'Label that indicates selecting.'
    },
    teamDeleted: {
        id: 'eoc-schedule.common.team-deleted',
        defaultMessage: 'Team deleted',
        description: 'Fallback responder name that suggest team is deleted.'
    },
    deletedSchedule: {
        id: 'eoc-schedule.common.deleted-schedule',
        defaultMessage: 'Deleted schedule',
        description: 'Fallback responder name that suggest schedule is deleted.'
    },
    deletedEscalation: {
        id: 'eoc-schedule.common.deleted-escalation',
        defaultMessage: 'Deleted escalation',
        description: 'Fallback responder name that suggest escalation is deleted.'
    },
    formerUser: {
        id: 'eoc-schedule.common.former-user',
        defaultMessage: 'Former user',
        description: 'Fallback responder name that suggest user is deactivated or deleted.'
    },
    discard: {
        id: 'eoc-schedule.common.discard',
        defaultMessage: 'Discard',
        description: 'Button for discarding.'
    },
    confirmProceed: {
        id: 'eoc-schedule.common.confirm-proceed',
        defaultMessage: 'Are you sure to proceed?',
        description: 'A confirmation for proceeding.'
    },
    /*
   Common validation related messages
  */ required: {
        id: 'eoc-schedule.common.required',
        defaultMessage: 'This field is required.',
        description: 'A text that informs users that field should be filled.'
    },
    noSpaceAtEndOrStart: {
        id: 'eoc-schedule.common.no-space-at-end-or-start',
        defaultMessage: 'Field cannot contain spaces at start or end.',
        description: 'A text that informs users that field cannot start or end with spaces.'
    },
    maxLength: {
        id: 'eoc-schedule.common.max-length',
        defaultMessage: 'Field cannot be longer than {max} characters.',
        description: 'A text that informs users that field should be shorter than certain length.'
    },
    maxValue: {
        id: 'eoc-schedule.common.max-value',
        defaultMessage: 'Field should be less than {max}.',
        description: 'A text that informs users that field should be less than certain value.'
    },
    minValue: {
        id: 'eoc-schedule.common.min-value',
        defaultMessage: 'Enter digit 1 or more.',
        description: 'This sentence instructs the user to input a numeric value of at least 1 digit or greater.'
    },
    timePast: {
        id: 'eoc-schedule.common.time-past',
        defaultMessage: 'Time should be later than current time.',
        description: 'Validation error that indicates time values is in past.'
    },
    startLaterEnd: {
        id: 'eoc-schedule.common.start-later-end',
        defaultMessage: 'Start time should be before the end time.',
        description: 'Validation error that indicates start time is later than the end time.'
    },
    endEarlierStart: {
        id: 'eoc-schedule.common.end-earlier-start',
        defaultMessage: 'End time should be after the start time.',
        description: 'Validation error that indicates end time is earlier than the start time.'
    },
    startEndSame: {
        id: 'eoc-schedule.common.start-end-same',
        defaultMessage: 'Start and end time cannot be same.',
        description: 'Validation error that indicates start and end time should be different.'
    },
    thirtyMinuteInterval: {
        id: 'eoc-schedule.common.thirty-minute-intervals',
        defaultMessage: 'Time should be defined as 30 minute intervals.',
        description: 'Validation error that indicates time can be in 30 minutes intervals.'
    },
    nameSpaceValidationError: {
        id: 'eoc-schedule.common.name-space-validation-error',
        defaultMessage: 'The name cannot start or end with a space.',
        description: 'Error message for name validation when it starts or ends with a space'
    }
});

});



parcelRegister("koDki", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $3d17243be6dd6e43$export$3a2536d80ecc00e7);

var $br21R = parcelRequire("br21R");

var $7Ck3E = parcelRequire("7Ck3E");
const $3d17243be6dd6e43$var$orderRotation = ({ scheduleId: scheduleId, after: after, rotationId: rotationId })=>{
    return (0, $br21R.eocFetch)((0, $7Ck3E.urls).schedules.scheduleId.rotations.rotationId.order.url({
        rotationId: rotationId,
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            after: after
        }
    });
};
const $3d17243be6dd6e43$var$getRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $br21R.eocFetch)((0, $7Ck3E.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'GET'
    });
};
const $3d17243be6dd6e43$var$deleteRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $br21R.eocFetch)((0, $7Ck3E.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'DELETE'
    });
};
const $3d17243be6dd6e43$var$addRotation = ({ name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, hasEndTime: hasEndTime, rotationPeriod: rotationPeriod, scheduleId: scheduleId, timeTemplateId: timeTemplateId, timingType: timingType, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
    return (0, $br21R.eocFetch)((0, $7Ck3E.urls).schedules.scheduleId.rotations.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            rotationPeriod: rotationPeriod,
            startTimeRaw: startTimeRaw,
            endTimeRaw: endTimeRaw,
            hasEndTime: hasEndTime
        }
    });
};
const $3d17243be6dd6e43$var$editRotation = ({ id: id, name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, rotationPeriod: rotationPeriod, hasEndTime: hasEndTime, timingType: timingType, scheduleId: scheduleId, timeTemplateId: timeTemplateId, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
    return (0, $br21R.eocFetch)((0, $7Ck3E.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: id
    }), {
        method: 'PUT',
        body: {
            id: id,
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            rotationPeriod: rotationPeriod,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            startTimeRaw: startTimeRaw,
            endTimeRaw: endTimeRaw,
            hasEndTime: hasEndTime
        }
    });
};
const $3d17243be6dd6e43$var$getScheduleTimeTemplates = ()=>{
    return (0, $br21R.eocFetch)((0, $7Ck3E.urls).schedules.timeTemplates.rotation.url(), {
        method: 'GET'
    });
};
const $3d17243be6dd6e43$export$3a2536d80ecc00e7 = {
    deleteRotation: $3d17243be6dd6e43$var$deleteRotation,
    getRotation: $3d17243be6dd6e43$var$getRotation,
    orderRotation: $3d17243be6dd6e43$var$orderRotation,
    addRotation: $3d17243be6dd6e43$var$addRotation,
    editRotation: $3d17243be6dd6e43$var$editRotation,
    getScheduleTimeTemplates: $3d17243be6dd6e43$var$getScheduleTimeTemplates
};

});
parcelRegister("7Ck3E", function(module, exports) {

$parcel$export(module.exports, "urls", () => $5106be16a04eb209$export$bcae9ba627f604b6);
const $5106be16a04eb209$export$bcae9ba627f604b6 = Object.freeze({
    alerts: {
        responders: {
            names: {
                url: ()=>'/v1/alerts/responders/names'
            },
            autoComplete: {
                url: ()=>'/v1/alerts/responders/auto-complete'
            }
        }
    },
    schedules: {
        url: ()=>`/v1/schedules`,
        teams: {
            teamId: {
                url: ({ teamId: teamId } = {
                    teamId: ':teamId'
                })=>`/v1/schedules/teams/${teamId}`,
                rights: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/schedules/teams/${teamId}/rights`
                }
            }
        },
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`/v1/schedules/${scheduleId}`,
            clone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/clone`
            },
            name: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/name`
            },
            timezone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timezone`
            },
            enable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/enable`
            },
            disable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/disable`
            },
            webCalendarUrl: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/web-calendar-url`
            },
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timeline`
            },
            overrides: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/overrides`,
                alias: {
                    url: ({ scheduleId: scheduleId, alias: alias } = {
                        scheduleId: ':scheduleId',
                        alias: ':alias'
                    })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                },
                bulk: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                }
            },
            rotations: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/rotations`,
                rotationId: {
                    url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                        scheduleId: ':scheduleId',
                        rotationId: ':rotationId'
                    })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                    order: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                    },
                    name: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                    }
                }
            }
        },
        timeTemplates: {
            rotation: {
                url: ()=>'/v1/schedules/time-templates/rotation'
            }
        }
    },
    customers: {
        timezones: {
            url: ()=>'/v1/customers/timezones'
        }
    },
    uiPreference: {
        schedule: {
            team: {
                teamId: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/users/ui-preference/schedule/team/${teamId}`
                }
            }
        }
    },
    onboarding: {
        completeTask: {
            url: ()=>'/v1/onboarding/complete-task'
        }
    }
});

});


parcelRegister("1c1NE", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $97873a304f60b927$export$3a2536d80ecc00e7);

var $br21R = parcelRequire("br21R");

var $7Ck3E = parcelRequire("7Ck3E");
const $97873a304f60b927$var$getScheduleList = (teamId)=>{
    return (0, $br21R.eocFetch)((0, $7Ck3E.urls).schedules.teams.teamId.url({
        teamId: teamId
    }));
};
const $97873a304f60b927$var$updateSchedule = ({ scheduleId: scheduleId, description: description, name: name, enabled: enabled, timezone: timezone })=>{
    return (0, $br21R.eocFetch)((0, $7Ck3E.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone
        }
    });
};
const $97873a304f60b927$var$deleteSchedule = ({ scheduleId: scheduleId })=>{
    return (0, $br21R.eocFetch)((0, $7Ck3E.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'DELETE'
    });
};
const $97873a304f60b927$export$3a2536d80ecc00e7 = {
    deleteSchedule: $97873a304f60b927$var$deleteSchedule,
    getScheduleList: $97873a304f60b927$var$getScheduleList,
    updateSchedule: $97873a304f60b927$var$updateSchedule
};

});

parcelRegister("RwOoQ", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $b0396551f563d91f$export$3a2536d80ecc00e7);

var $br21R = parcelRequire("br21R");

var $7Ck3E = parcelRequire("7Ck3E");
const $b0396551f563d91f$var$getUiPreferences = (teamId)=>{
    return (0, $br21R.eocFetch)((0, $7Ck3E.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }));
};
const $b0396551f563d91f$var$updateUiPreferences = ({ teamId: teamId, key: key, value: value })=>{
    return (0, $br21R.eocFetch)((0, $7Ck3E.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }), {
        method: 'PATCH',
        body: {
            [key]: value
        }
    });
};
const $b0396551f563d91f$export$3a2536d80ecc00e7 = {
    getUiPreferences: $b0396551f563d91f$var$getUiPreferences,
    updateUiPreferences: $b0396551f563d91f$var$updateUiPreferences
};

});

parcelRegister("ftu4y", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $73236c423dba0951$export$3a2536d80ecc00e7);

var $br21R = parcelRequire("br21R");

var $7Ck3E = parcelRequire("7Ck3E");
const $73236c423dba0951$var$getScheduleRights = (teamId)=>{
    return (0, $br21R.eocFetch)((0, $7Ck3E.urls).schedules.teams.teamId.rights.url({
        teamId: teamId
    }));
};
const $73236c423dba0951$var$createSchedule = ({ description: description, name: name, teamId: teamId, timezone: timezone })=>{
    return (0, $br21R.eocFetch)((0, $7Ck3E.urls).schedules.url(), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            teamId: teamId,
            timezone: timezone,
            // Created schedules are enabled by default
            enabled: true
        }
    });
};
const $73236c423dba0951$var$cloneSchedule = ({ description: description, name: name, enabled: enabled, timezone: timezone, teamId: teamId, scheduleId: scheduleId })=>{
    return (0, $br21R.eocFetch)((0, $7Ck3E.urls).schedules.scheduleId.clone.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone,
            teamId: teamId
        }
    });
};
const $73236c423dba0951$export$3a2536d80ecc00e7 = {
    createSchedule: $73236c423dba0951$var$createSchedule,
    getScheduleRights: $73236c423dba0951$var$getScheduleRights,
    cloneSchedule: $73236c423dba0951$var$cloneSchedule
};

});


parcelRegister("6p3HM", function(module, exports) {

$parcel$export(module.exports, "getTeam", () => $26b82329c016fb0c$export$491fe77f22ab2b51);

var $br21R = parcelRequire("br21R");
const $26b82329c016fb0c$export$491fe77f22ab2b51 = (teamId)=>(0, $br21R.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });

});


parcelRegister("k6osT", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRoute", () => $744fb1975a9af96a$export$5eaa466ae8a4d7d3);
const $744fb1975a9af96a$export$5eaa466ae8a4d7d3 = {
    name: 'eoc-on-call',
    path: '/jira/ops/teams/:teamId/on-call',
    exact: true
};

});


parcelRegister("L6NLT", function(module, exports) {

$parcel$export(module.exports, "eocOverviewAllTeamsRouteEntry", () => $f412e52bc0639fdf$export$842d7c81068bb64e);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $GnSwp = parcelRequire("GnSwp");

var $6xToB = parcelRequire("6xToB");

var $70evk = parcelRequire("70evk");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $fKceA = parcelRequire("fKceA");

var $dwoHY = parcelRequire("dwoHY");

var $5L7qx = parcelRequire("5L7qx");

var $7jTnu = parcelRequire("7jTnu");

var $9i0Bn = parcelRequire("9i0Bn");
const $f412e52bc0639fdf$export$842d7c81068bb64e = (0, $6xToB.createEntry)((0, $fKceA.eocOverviewAllTeamsRoute), ()=>({
        group: 'eoc',
        component: (0, $9i0Bn.EocOverviewAllTeamsComponent),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $70evk.getTeamsResource),
            ...(0, $dwoHY.eocCommonResources)().map((resource)=>(0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('your_work_page_operation_widgets_changes'), resource))
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME,
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsOverviewNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $GnSwp.LazyHorizontalOperationsOverviewNav),
            (0, $9i0Bn.LazyOverviewAllTeamsPage)
        ]
    }));

});
parcelRegister("70evk", function(module, exports) {

$parcel$export(module.exports, "getTeamsResource", () => $36ea1c80197b97be$export$27d854bd39923fc7);
// eslint-disable-next-line jira/import-whitelist

var $35tzL = parcelRequire("35tzL");
var $aYkbw = parcelRequire("aYkbw");

var $7jTnu = parcelRequire("7jTnu");

var $l1VxS = parcelRequire("l1VxS");

var $dI30d = parcelRequire("dI30d");

const $36ea1c80197b97be$export$27d854bd39923fc7 = (0, $l1VxS.createResource)({
    type: (0, $aYkbw.getTeamsResource).type,
    getKey: (0, $aYkbw.getTeamsResource).getKey,
    getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, isSiteAdmin: isSiteAdmin, isAdmin: isAdmin } })=>{
        if (!atlassianAccountId) return null;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const tenantInfo = await dependencies[0, $f8747ec2695de8a7$export$25ee35b01de9d734]?.promise;
        const isOpsAdmin = (0, $dI30d.checkIsOpsAdmin)(tenantInfo);
        const shouldSeeAllTeams = (0, $7jTnu.fg)('operations-tenant-info-endpoint-update') ? isSiteAdmin || isAdmin || isOpsAdmin : isSiteAdmin || isAdmin;
        return (0, $35tzL.getTeams)({
            queryParams: {
                accountId: !shouldSeeAllTeams ? atlassianAccountId : undefined,
                showAvatar: true,
                ...(0, $7jTnu.fg)('display_eoc_managed_teams_with_verified_marks') && {
                    includeTeamExternalDetails: true
                }
            }
        });
    },
    isBrowserOnly: true,
    maxAge: 0,
    depends: [
        (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
    ]
});

});
parcelRegister("35tzL", function(module, exports) {

$parcel$export(module.exports, "getTeams", () => $a0122ab843d0cf49$export$5a622455e94bac3);

var $br21R = parcelRequire("br21R");
const $a0122ab843d0cf49$export$5a622455e94bac3 = ({ url: url, queryParams: queryParams })=>{
    const params = new URLSearchParams();
    if (queryParams.keyword) params.append('keyword', queryParams.keyword);
    if (queryParams.size) params.append('size', queryParams.size.toString());
    if (queryParams.offset) params.append('offset', queryParams.offset.toString());
    if (queryParams.accountId) params.append('memberId', queryParams.accountId);
    if (queryParams.showAvatar) params.append('showAvatar', String(queryParams.showAvatar));
    if (queryParams.includeTeamExternalDetails) params.append('includeTeamExternalDetails', String(queryParams.includeTeamExternalDetails));
    if (url) return (0, $br21R.eocFetch)(`${url}${params.toString() ? `?${params.toString()}` : ''}`, {
        exactUrl: true
    });
    return (0, $br21R.eocFetch)(`/v1/teams${params.toString() ? `?${params.toString()}` : ''}`);
};

});

parcelRegister("aYkbw", function(module, exports) {

$parcel$export(module.exports, "getTeamsResource", () => $74f7f314f3311108$export$27d854bd39923fc7);

var $l1VxS = parcelRequire("l1VxS");

var $35tzL = parcelRequire("35tzL");
const $74f7f314f3311108$export$27d854bd39923fc7 = (0, $l1VxS.createResource)({
    type: 'getTeamsResource',
    getKey: ()=>'overview',
    getData: async ()=>{
        throw new Error('getData of getTeamsResource is not implemented in platform package, you should do it in your product');
    },
    isBrowserOnly: true
});

});


parcelRegister("fKceA", function(module, exports) {

$parcel$export(module.exports, "eocOverviewAllTeamsRoute", () => $5d5a2485f47a86ad$export$dbe53627482b9f0f);
const $5d5a2485f47a86ad$export$dbe53627482b9f0f = {
    name: 'eoc-overview-all-teams',
    path: '/jira/ops/overview/teams',
    exact: true
};

});

parcelRegister("9i0Bn", function(module, exports) {

$parcel$export(module.exports, "LazyOverviewPage", () => $80a5b5dee0a7d5b5$export$c7c96cc8d6e9a8f1);
$parcel$export(module.exports, "LazyOverviewAllTeamsPage", () => $80a5b5dee0a7d5b5$export$9a22ecad8322834e);
$parcel$export(module.exports, "EocOverviewComponent", () => $80a5b5dee0a7d5b5$export$b22309f0ee469d5c);
$parcel$export(module.exports, "EocOverviewAllTeamsComponent", () => $80a5b5dee0a7d5b5$export$2713003ebbdbb975);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $80a5b5dee0a7d5b5$export$c7c96cc8d6e9a8f1 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("hLFEe")).then((m)=>m.OverviewPage), {
    moduleId: "./src/packages/eoc/overview/src/ui/overview-page/index.tsx"
});

const $80a5b5dee0a7d5b5$export$9a22ecad8322834e = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("3QvKY")).then((m)=>m.AllTeamsPage), {
    moduleId: "./src/packages/eoc/overview/src/ui/all-teams-page/index.tsx"
});
const $80a5b5dee0a7d5b5$export$b22309f0ee469d5c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $80a5b5dee0a7d5b5$export$c7c96cc8d6e9a8f1,
        pageId: "async-jira-eoc-overview",
        shouldShowSpinner: false
    });
const $80a5b5dee0a7d5b5$export$2713003ebbdbb975 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $80a5b5dee0a7d5b5$export$9a22ecad8322834e,
        pageId: "async-jira-eoc-overview-all-teams",
        shouldShowSpinner: false
    });

});
parcelRegister("hLFEe", function(module, exports) {

let $cef721dfada8f904$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cef721dfada8f904$var$load("3d5pd").then(()=>parcelRequire('AkBvw'));

});

parcelRegister("3QvKY", function(module, exports) {

let $2ccedc9f86e3c373$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2ccedc9f86e3c373$var$load("196ai").then(()=>parcelRequire('d8lGf'));

});



parcelRegister("d1pTa", function(module, exports) {

$parcel$export(module.exports, "eocOverviewRouteEntry", () => $a903633f689b80a7$export$f1a859c727c30be4);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $GnSwp = parcelRequire("GnSwp");

var $6xToB = parcelRequire("6xToB");

var $70evk = parcelRequire("70evk");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $88DS7 = parcelRequire("88DS7");

var $iRfwO = parcelRequire("iRfwO");

var $dwoHY = parcelRequire("dwoHY");

var $5L7qx = parcelRequire("5L7qx");

var $7jTnu = parcelRequire("7jTnu");

var $9i0Bn = parcelRequire("9i0Bn");
const $a903633f689b80a7$export$f1a859c727c30be4 = (0, $6xToB.createEntry)((0, $88DS7.eocOverviewRoute), ()=>({
        group: 'eoc',
        component: (0, $9i0Bn.EocOverviewComponent),
        layout: (0, $iRfwO.opsMigrationHubLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $70evk.getTeamsResource),
            ...(0, $dwoHY.eocCommonResources)().map((resource)=>(0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('your_work_page_operation_widgets_changes'), resource))
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME,
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsOverviewNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $GnSwp.LazyHorizontalOperationsOverviewNav),
            (0, $9i0Bn.LazyOverviewPage)
        ]
    }));

});
parcelRegister("88DS7", function(module, exports) {

$parcel$export(module.exports, "eocOverviewRoute", () => $7d3f8efb155cd058$export$cb929d46451a5c12);
const $7d3f8efb155cd058$export$cb929d46451a5c12 = {
    name: 'eoc-overview',
    path: '/jira/ops/overview',
    exact: true
};

});


parcelRegister("42xEn", function(module, exports) {

$parcel$export(module.exports, "eocPermissionsRouteEntry", () => $dce501faa7419f5e$export$c2ced436a30c60dc);

var $lnvG6 = parcelRequire("lnvG6");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $5Wzun = parcelRequire("5Wzun");

var $a6Kdh = parcelRequire("a6Kdh");
const $dce501faa7419f5e$export$c2ced436a30c60dc = (0, $6xToB.createEntry)((0, $5Wzun.eocPermissionsRoute), ()=>({
        group: 'eoc',
        component: (0, $a6Kdh.default),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // pageAccessResource should be defined before memberRolesResources since they depend on it
            (0, $lnvG6.pageAccessResource),
            ...(0, $lnvG6.resources)(),
            ...(0, $io7oY.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $a6Kdh.LazyMemberRoles),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("lnvG6", function(module, exports) {

$parcel$export(module.exports, "pageAccessResource", () => $f1a9e6e63746e683$export$b0d36f8262140e35);
$parcel$export(module.exports, "memberRolesResource", () => $f1a9e6e63746e683$export$5c4885c1f1a535b);
$parcel$export(module.exports, "getTeamResource", () => $f1a9e6e63746e683$export$50271c9e7f21f10e);
$parcel$export(module.exports, "customTeamRolesResource", () => $f1a9e6e63746e683$export$ed1eb48699cf7893);
$parcel$export(module.exports, "resources", () => $f1a9e6e63746e683$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $8XtVW = parcelRequire("8XtVW");

var $feIEW = parcelRequire("feIEW");
var $jXKdt = parcelRequire("jXKdt");

var $43cld = parcelRequire("43cld");
const $f1a9e6e63746e683$var$mapStatus = (status, userAccessLevel)=>{
    if (userAccessLevel === 'INTERNAL_INACTIVE') return 'suspended';
    if (status === 'REQUEST_ACCESS' || status === 'DENIED_REQUEST_EXISTS' || status === 'FORBIDDEN' || status === 'DIRECT_ACCESS') return 'invite';
    if (status === 'ACCESS_EXISTS') return 'member';
    if (status === 'PENDING_REQUEST_EXISTS') return 'pending';
    if (status === '' || status === undefined) return 'member';
    return 'invite';
};
const $f1a9e6e63746e683$var$checkPageAccessRightsOnRouteDependency = async (dependencies)=>{
    let isAuthorizedToSeeMemberRolesPage = false;
    if (dependencies[$f1a9e6e63746e683$var$PAGE_ACCESS_RESOURCE_TYPE]) {
        const data = await dependencies[$f1a9e6e63746e683$var$PAGE_ACCESS_RESOURCE_TYPE].promise;
        isAuthorizedToSeeMemberRolesPage = data?.productOrTeamAdmin;
    }
    return isAuthorizedToSeeMemberRolesPage;
};
const $f1a9e6e63746e683$var$getMembersPaginated = async (teamId)=>{
    let hasNextPage = true;
    let endCursor = '';
    let members = [];
    while(hasNextPage && endCursor !== null){
        const gqlResponse = await (0, $43cld.getMembers)(teamId, endCursor);
        endCursor = gqlResponse.data.team?.teamV2?.members.pageInfo.endCursor ?? '';
        hasNextPage = gqlResponse.data.team?.teamV2?.members.pageInfo.hasNextPage ?? false;
        const newMembers = gqlResponse.data.team?.teamV2?.members.edges.map((edge)=>edge.node.member);
        if (newMembers) members = [
            ...members,
            ...newMembers
        ];
    }
    return members;
};
const $f1a9e6e63746e683$var$PAGE_ACCESS_RESOURCE_TYPE = 'pageAccessResource';
const $f1a9e6e63746e683$export$b0d36f8262140e35 = (0, $l1VxS.createResource)({
    type: $f1a9e6e63746e683$var$PAGE_ACCESS_RESOURCE_TYPE,
    getKey: ()=>'pageAccessResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $feIEW.assert)(!!teamId, new (0, $jXKdt.AssertionError)('pageAccessResource', 'teamId should be set to fetch page access'));
        return (0, $43cld.getMemberRolesPageAccess)(teamId);
    },
    isBrowserOnly: true
});
const $f1a9e6e63746e683$export$5c4885c1f1a535b = (0, $l1VxS.createResource)({
    type: 'memberRolesResource',
    getKey: ()=>'memberRolesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        const dependencies = routerContext.dependencies;
        (0, $feIEW.assert)(!!teamId, new (0, $jXKdt.AssertionError)('memberRolesResource', 'teamId should be set to fetch member-roles'));
        const isAuthorizedToSeeMemberRolesPage = await $f1a9e6e63746e683$var$checkPageAccessRightsOnRouteDependency(dependencies);
        if (!isAuthorizedToSeeMemberRolesPage) return null;
        let members;
        if ((0, $8XtVW.fg)('member-roles-graphql-paginaton')) members = await $f1a9e6e63746e683$var$getMembersPaginated(teamId);
        else {
            const gqlResponse = await (0, $43cld.getMembersOld)(teamId);
            members = gqlResponse?.data.team?.teamV2?.members.edges.map((edge)=>edge.node.member) || [];
        }
        const memberRoleResponse = await (0, $43cld.getRoleAndJSMLicenseInfoEndpoint)({
            platformTeamId: teamId,
            accountIds: members.map((member)=>member.accountId)
        });
        const teamMembers = members.map((user)=>{
            const userWithRole = memberRoleResponse.teamMembers.find((userWithRole)=>userWithRole.accountId === user.accountId);
            return {
                ...user,
                role: userWithRole?.roleId || 'user',
                jsmLicense: userWithRole?.jsmLicense || false,
                jiraAdmin: userWithRole?.jiraAdmin || false,
                invitationStatus: 'member'
            };
        });
        const membersWithoutJSMLicense = teamMembers.filter((teamMembers)=>!teamMembers.jsmLicense);
        if (!membersWithoutJSMLicense.length) return teamMembers;
        const accountIds = membersWithoutJSMLicense.map((member)=>member.accountId).join(',');
        try {
            const { embeddedValue: embeddedValue } = await (0, $43cld.getJSMInvitationStatusInfoEndpoint)({
                accountIds: accountIds
            });
            return teamMembers.map((user)=>{
                const userWithInvitationStatus = embeddedValue.find((userWithInvitationStatus)=>userWithInvitationStatus.accountId === user.accountId);
                return {
                    ...user,
                    invitationStatus: $f1a9e6e63746e683$var$mapStatus(userWithInvitationStatus?.accessMode, userWithInvitationStatus?.userAccessLevel)
                };
            });
        } catch  {
            return teamMembers;
        }
    },
    isBrowserOnly: true,
    depends: [
        $f1a9e6e63746e683$var$PAGE_ACCESS_RESOURCE_TYPE
    ]
});
const $f1a9e6e63746e683$export$50271c9e7f21f10e = (0, $l1VxS.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $feIEW.assert)(!!teamId, new (0, $jXKdt.AssertionError)('getTeamResource', 'teamId should be set to fetch team info on member roles'));
        return (0, $43cld.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $f1a9e6e63746e683$export$ed1eb48699cf7893 = (0, $l1VxS.createResource)({
    type: 'customTeamRolesResource',
    getKey: ()=>'customRolesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        const dependencies = routerContext.dependencies;
        (0, $feIEW.assert)(!!teamId, new (0, $jXKdt.AssertionError)('customTeamRolesResource', 'teamId should be set to fetch custom-team-roles'));
        const isAuthorizedToSeeMemberRolesPage = await $f1a9e6e63746e683$var$checkPageAccessRightsOnRouteDependency(dependencies);
        if (!isAuthorizedToSeeMemberRolesPage) return null;
        return (0, $43cld.getCustomTeamRolesEndpoint)(teamId);
    },
    isBrowserOnly: true,
    depends: [
        $f1a9e6e63746e683$var$PAGE_ACCESS_RESOURCE_TYPE
    ]
});
const $f1a9e6e63746e683$export$bc99aaabaf7b70a7 = ()=>[
        $f1a9e6e63746e683$export$5c4885c1f1a535b,
        $f1a9e6e63746e683$export$50271c9e7f21f10e,
        $f1a9e6e63746e683$export$ed1eb48699cf7893
    ];

});
parcelRegister("43cld", function(module, exports) {

$parcel$export(module.exports, "getMembersOld", () => $c18cc1c88e88e32b$export$dc7a9fe3089fc26e);
$parcel$export(module.exports, "getMembers", () => $c18cc1c88e88e32b$export$f4931e6f9feb30c5);
$parcel$export(module.exports, "getMemberRolesPageAccess", () => $c18cc1c88e88e32b$export$95d4c4e762437fdd);
$parcel$export(module.exports, "getRoleAndJSMLicenseInfoEndpoint", () => $c18cc1c88e88e32b$export$38ab389cb64a5000);
$parcel$export(module.exports, "getJSMInvitationStatusInfoEndpoint", () => $c18cc1c88e88e32b$export$fd43007da8683026);
$parcel$export(module.exports, "getTeam", () => $c18cc1c88e88e32b$export$491fe77f22ab2b51);
$parcel$export(module.exports, "getCustomTeamRolesEndpoint", () => $c18cc1c88e88e32b$export$ebfa293eb1ef42f5);

var $8XtVW = parcelRequire("8XtVW");

var $br21R = parcelRequire("br21R");
var $b388R = parcelRequire("b388R");
const $c18cc1c88e88e32b$var$operationName = 'memberRolesTeamMembersQuery';
const $c18cc1c88e88e32b$var$getMembersParams = (after)=>{
    const firstParam = (0, $8XtVW.fg)('platform_increase_limit_of_members_query') ? 'first: 300' : 'first: 100';
    const afterParam = after ? `, after: "${after}"` : '';
    return `(${firstParam}${afterParam})`;
};
const $c18cc1c88e88e32b$export$dc7a9fe3089fc26e = (teamId)=>{
    const queryUrl = '/gateway/api/graphql';
    const teamAri = `ari:cloud:identity::team/${teamId}`;
    const siteId = (0, $b388R.getMeta)('ajs-cloud-id');
    const membersQueryV2 = `query memberRolesTeamMembersQuery($teamId: ID!, $siteId: String!) {
		team {
			teamV2 (id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
				id
				members ${(0, $8XtVW.fg)('platform_increase_limit_of_members_query') ? '(first: 300)' : ''}{
					edges {
						cursor
						node {
							member  {
								... on AtlassianAccountUser {
									email
								}
								name
								picture
								accountId
								accountStatus
							}
							state
							role
						}
					}
				}
			}
		}
	}
	`;
    return (0, $br21R.eocFetch)(queryUrl, {
        method: 'POST',
        body: JSON.stringify({
            operationName: $c18cc1c88e88e32b$var$operationName,
            query: membersQueryV2,
            variables: {
                teamId: teamAri,
                siteId: siteId
            }
        }),
        headers: {
            'Content-Type': 'application/json',
            'X-ExperimentalApi': 'teams-beta, team-members-beta'
        },
        exactUrl: true
    });
};
const $c18cc1c88e88e32b$export$f4931e6f9feb30c5 = (teamId, after)=>{
    const queryUrl = '/gateway/api/graphql';
    const teamAri = `ari:cloud:identity::team/${teamId}`;
    const siteId = (0, $b388R.getMeta)('ajs-cloud-id');
    const membersQueryV2 = `query memberRolesTeamMembersQuery($teamId: ID!, $siteId: String!) {
		team {
			teamV2 (id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
				id
				members ${$c18cc1c88e88e32b$var$getMembersParams(after)}{
					edges {
						cursor
						node {
							member  {
								... on AtlassianAccountUser {
									email
								}
								name
								picture
								accountId
								accountStatus
							}
							state
							role
						}
					}
					pageInfo {
						endCursor
						hasNextPage
					}
				}
			}
		}
	}
	`;
    return (0, $br21R.eocFetch)(queryUrl, {
        method: 'POST',
        body: JSON.stringify({
            operationName: $c18cc1c88e88e32b$var$operationName,
            query: membersQueryV2,
            variables: {
                teamId: teamAri,
                siteId: siteId
            }
        }),
        headers: {
            'Content-Type': 'application/json',
            'X-ExperimentalApi': 'teams-beta, team-members-beta'
        },
        exactUrl: true
    });
};
const $c18cc1c88e88e32b$export$95d4c4e762437fdd = (teamId)=>(0, $br21R.eocFetch)(`/v1/teams/members/member-roles-page-access?platformTeamId=${teamId}`);
const $c18cc1c88e88e32b$export$38ab389cb64a5000 = ({ platformTeamId: platformTeamId, accountIds: accountIds })=>(0, $br21R.eocFetch)(`/v1/teams/members`, {
        method: 'POST',
        body: {
            platformTeamId: platformTeamId,
            accountIds: accountIds
        }
    });
const $c18cc1c88e88e32b$export$fd43007da8683026 = ({ accountIds: accountIds })=>(0, $br21R.eocFetch)(`/v1/users/access-request-capabilities?accountIds=${accountIds}`, {
        method: 'GET'
    });
const $c18cc1c88e88e32b$export$491fe77f22ab2b51 = (teamId)=>(0, $br21R.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });
const $c18cc1c88e88e32b$export$ebfa293eb1ef42f5 = (platformTeamId)=>(0, $br21R.eocFetch)(`/v1/teams/${platformTeamId}/roles`);

});


parcelRegister("5Wzun", function(module, exports) {

$parcel$export(module.exports, "eocPermissionsRoute", () => $f55ad163e13bf5d3$export$8e6afd724de3be6e);
const $f55ad163e13bf5d3$export$8e6afd724de3be6e = {
    name: 'eoc-permissions',
    path: '/jira/ops/teams/:teamId/settings',
    exact: true
};

});

parcelRegister("a6Kdh", function(module, exports) {

$parcel$export(module.exports, "LazyMemberRoles", () => $04e7a8ade7ba428a$export$27b4fb95241ab47);
$parcel$export(module.exports, "default", () => $04e7a8ade7ba428a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $04e7a8ade7ba428a$export$27b4fb95241ab47 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("1SYsN")), {
    moduleId: "./src/packages/eoc/member-roles/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$04e7a8ade7ba428a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $04e7a8ade7ba428a$export$27b4fb95241ab47,
        pageId: "async-jira-eoc-member-roles",
        shouldShowSpinner: false
    });

});
parcelRegister("1SYsN", function(module, exports) {

let $15f9bc5d4a0a987d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $15f9bc5d4a0a987d$var$load("bnc6a").then(()=>parcelRequire('3EgOL'));

});



parcelRegister("6y1qE", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRedirectRouteEntry", () => $38270fe969ef3f07$export$c5606e8eeca32c0f);

var $1vFVi = parcelRequire("1vFVi");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $fP5hi = parcelRequire("fP5hi");

var $98AOo = parcelRequire("98AOo");
const $38270fe969ef3f07$export$c5606e8eeca32c0f = (0, $6xToB.createEntry)((0, $fP5hi.eocReportsTeamRedirectRoute), ()=>({
        group: 'eoc',
        component: (0, $98AOo.OpsReportsRedirect),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)(),
            ...(0, $1vFVi.resources)(),
            (0, $1vFVi.opsReportsPermissionResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $98AOo.LazyOpsReportsRedirect),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("fP5hi", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRedirectRoute", () => $d768d698dfe73ff3$export$26b0a544e6502d55);
const $d768d698dfe73ff3$export$26b0a544e6502d55 = {
    name: 'eoc-reports',
    path: '/jira/ops/teams/:teamId/reports',
    exact: true
};

});


parcelRegister("5UUbR", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRouteEntry", () => $d31e1f1a1195128c$export$cd1c1a81e516fec5);

var $1vFVi = parcelRequire("1vFVi");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $hhkDv = parcelRequire("hhkDv");

var $98AOo = parcelRequire("98AOo");
const $d31e1f1a1195128c$export$cd1c1a81e516fec5 = (0, $6xToB.createEntry)((0, $hhkDv.eocReportsTeamRoute), ()=>({
        group: 'eoc',
        component: (0, $98AOo.OpsReports),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)(),
            ...(0, $1vFVi.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $98AOo.LazyOpsReports),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("hhkDv", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRoute", () => $18d6d825e2e93cf9$export$c9e0796615c034f3);
const $18d6d825e2e93cf9$export$c9e0796615c034f3 = {
    name: 'eoc-reports-team',
    path: '/jira/ops/teams/:teamId/reports/:dashboardId',
    exact: true
};

});


parcelRegister("djdJN", function(module, exports) {

$parcel$export(module.exports, "eocReportsUnsubscribeRouteEntry", () => $66afa995de4f4abf$export$6e8d112a548528b5);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $46YLy = parcelRequire("46YLy");

var $98AOo = parcelRequire("98AOo");
const $66afa995de4f4abf$export$6e8d112a548528b5 = (0, $6xToB.createEntry)((0, $46YLy.eocReportsUnsubscribeRoute), ()=>({
        group: 'eoc',
        component: (0, $98AOo.OpsReportsUnsubscribe),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $98AOo.LazyOpsReportsUnsubscribe)
        ]
    }));

});
parcelRegister("46YLy", function(module, exports) {

$parcel$export(module.exports, "eocReportsUnsubscribeRoute", () => $5285f5ca5480918e$export$72cde899ee974e6e);
const $5285f5ca5480918e$export$72cde899ee974e6e = {
    name: 'eoc-reports-unsubscribe',
    path: '/jira/ops/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});


parcelRegister("5ylat", function(module, exports) {

$parcel$export(module.exports, "eocScheduleGlobalRouteEntry", () => $5ab3dfa90913e3a9$export$831e8756cdaae4ba);

var $eJOHy = parcelRequire("eJOHy");

var $4vA2m = parcelRequire("4vA2m");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $753hq = parcelRequire("753hq");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5ab3dfa90913e3a9$var$LazyScheduleGlobalPage = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("1y5Yf")).then((m)=>m.ScheduleGlobalPage), {
    moduleId: "./src/packages/eoc/schedule-global/src/ui/index.tsx"
});
const $5ab3dfa90913e3a9$var$EocScheduleGlobalComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $5ab3dfa90913e3a9$var$LazyScheduleGlobalPage,
        pageId: "async-jira-eoc-schedule-global",
        shouldShowSpinner: false
    });
const $5ab3dfa90913e3a9$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $5ab3dfa90913e3a9$export$831e8756cdaae4ba = (0, $6xToB.createEntry)((0, $753hq.eocScheduleGlobalRoute), ()=>({
        group: 'eoc',
        component: $5ab3dfa90913e3a9$var$EocScheduleGlobalComponent,
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $4vA2m.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$5ab3dfa90913e3a9$var$getNavigationSpecifications()
        },
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            $5ab3dfa90913e3a9$var$LazyScheduleGlobalPage
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            $5ab3dfa90913e3a9$var$LazyScheduleGlobalPage
        ]
    }));

});
parcelRegister("4vA2m", function(module, exports) {

$parcel$export(module.exports, "resources", () => $e6587213489c9a7f$export$bc99aaabaf7b70a7);

var $dwoHY = parcelRequire("dwoHY");

var $jDL6C = parcelRequire("jDL6C");
const $e6587213489c9a7f$export$bc99aaabaf7b70a7 = ()=>[
        (0, $jDL6C.getTimezonesResource),
        (0, $jDL6C.getTimeTemplatesResource),
        ...(0, $dwoHY.eocCommonResources)()
    ];

});

parcelRegister("753hq", function(module, exports) {

$parcel$export(module.exports, "eocScheduleGlobalRoute", () => $c461ff52ffca1a86$export$10454dc485142eb6);
const $c461ff52ffca1a86$export$10454dc485142eb6 = {
    name: 'eoc-schedules',
    path: '/jira/settings/products/ops/schedules',
    exact: true
};

});

parcelRegister("1y5Yf", function(module, exports) {

let $120d99121a6cbad3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $120d99121a6cbad3$var$load("22Bzk").then(()=>parcelRequire('hYna3'));

});


parcelRegister("dEChv", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertDetailRouteEntry", () => $b793d39d728adba9$export$94aaa7006da9d63a);

var $5bTUU = parcelRequire("5bTUU");

var $17OMI = parcelRequire("17OMI");

var $io7oY = parcelRequire("io7oY");

var $i1cBv = parcelRequire("i1cBv");

var $7jTnu = parcelRequire("7jTnu");

var $5L7qx = parcelRequire("5L7qx");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $igYXn = parcelRequire("igYXn");

var $fy9vy = parcelRequire("fy9vy");
const $b793d39d728adba9$export$94aaa7006da9d63a = (0, $6xToB.createEntry)((0, $igYXn.eocTeamAlertDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $fy9vy.default),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)(),
            ...(0, $17OMI.resources)(),
            ...(0, $5bTUU.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('automation_discoverability_in_jsm'), (0, $i1cBv.getAutomationDiscoveryDismissResource))
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fy9vy.LazyAlertList),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("fy9vy", function(module, exports) {

$parcel$export(module.exports, "LazyAlertList", () => $bdc84cdc67c7a25d$export$f4aafff31d950b6c);
$parcel$export(module.exports, "default", () => $bdc84cdc67c7a25d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $bdc84cdc67c7a25d$export$f4aafff31d950b6c = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("fYnBy")), {
    moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bdc84cdc67c7a25d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $bdc84cdc67c7a25d$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });

});


parcelRegister("7YInD", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingCreateRouteEntry", () => $c4f6beb549f8d6f1$export$8c07dc381591dc69);

var $1r6q8 = parcelRequire("1r6q8");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $4Mrbh = parcelRequire("4Mrbh");

var $jXwOY = parcelRequire("jXwOY");

var $4dPst = parcelRequire("4dPst");

var $91lt4 = parcelRequire("91lt4");
const $c4f6beb549f8d6f1$export$8c07dc381591dc69 = (0, $6xToB.createEntry)((0, $4Mrbh.eocTeamAlertIssueSyncingCreateRoute), ()=>({
        group: 'eoc',
        component: (0, $jXwOY.AlertIssueSync),
        layout: (0, $igwPu.opsTeamLayout),
        slot: (0, $4dPst.AlertIssueSyncCreate),
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $1r6q8.resources).configuredSyncsResource,
            (0, $1r6q8.resources).userAccessRightsResource,
            (0, $1r6q8.resources).getTeamResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("4Mrbh", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingCreateRoute", () => $a39de729ea392ca3$export$915ef1948fe4650a);
const $a39de729ea392ca3$export$915ef1948fe4650a = {
    name: 'eoc-team-alert-issue-syncing-create',
    path: '/jira/ops/teams/:teamId/syncs/create',
    exact: true
};

});


parcelRegister("kXXTW", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingDetailRouteEntry", () => $2210068f8b76d0d7$export$6298ff494c460e75);

var $1r6q8 = parcelRequire("1r6q8");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $jhI29 = parcelRequire("jhI29");

var $gne1j = parcelRequire("gne1j");

var $jXwOY = parcelRequire("jXwOY");

var $91lt4 = parcelRequire("91lt4");
const $2210068f8b76d0d7$export$6298ff494c460e75 = (0, $6xToB.createEntry)((0, $jhI29.eocTeamAlertIssueSyncingDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $jXwOY.AlertIssueSync),
        layout: (0, $igwPu.opsTeamLayout),
        slot: (0, $gne1j.AlertIssueSyncDetail),
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $1r6q8.resources).configuredSyncsResource,
            (0, $1r6q8.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("jhI29", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingDetailRoute", () => $6698d14394398285$export$e91535fc2137c3b);
const $6698d14394398285$export$e91535fc2137c3b = {
    name: 'eoc-team-alert-issue-syncing-detail',
    path: '/jira/ops/teams/:teamId/syncs/:syncId',
    exact: true
};

});


parcelRegister("6aBHI", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingRouteEntry", () => $23265ba2582c9139$export$be342a3401146aae);

var $1r6q8 = parcelRequire("1r6q8");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $flCKw = parcelRequire("flCKw");

var $jXwOY = parcelRequire("jXwOY");

var $91lt4 = parcelRequire("91lt4");
const $23265ba2582c9139$export$be342a3401146aae = (0, $6xToB.createEntry)((0, $flCKw.eocTeamAlertIssueSyncingRoute), ()=>({
        group: 'eoc',
        component: (0, $jXwOY.AlertIssueSync),
        layout: (0, $igwPu.opsTeamLayout),
        slot: null,
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $1r6q8.resources).configuredSyncsResource,
            (0, $1r6q8.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("flCKw", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingRoute", () => $7345549d10c755cc$export$37ea7624561cbb89);
const $7345549d10c755cc$export$37ea7624561cbb89 = {
    name: 'eoc-team-alert-issue-syncing',
    path: '/jira/ops/teams/:teamId/syncs',
    exact: true
};

});


parcelRegister("85n74", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertListRouteEntry", () => $6796c399b3b3aaae$export$de37dab3b3ed8e5c);

var $17OMI = parcelRequire("17OMI");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $ghsHL = parcelRequire("ghsHL");

var $fy9vy = parcelRequire("fy9vy");
const $6796c399b3b3aaae$export$de37dab3b3ed8e5c = (0, $6xToB.createEntry)((0, $ghsHL.eocTeamAlertListRoute), ()=>({
        group: 'eoc',
        component: (0, $fy9vy.default),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)(),
            ...(0, $17OMI.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fy9vy.LazyAlertList),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("ghsHL", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertListRoute", () => $edadd18ba8feba76$export$94efd60f23d97aa5);
const $edadd18ba8feba76$export$94efd60f23d97aa5 = {
    name: 'eoc-team-alerts',
    path: '/jira/ops/teams/:teamId/alerts',
    exact: true
};

});


parcelRegister("ekFnU", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsDownloadRouteEntry", () => $a004d162c1e0c610$export$d2ce6f09ef8aa840);

var $72NQI = parcelRequire("72NQI");

var $yRJUA = parcelRequire("yRJUA");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $7RTxG = parcelRequire("7RTxG");

var $9lzBd = parcelRequire("9lzBd");
const $a004d162c1e0c610$export$d2ce6f09ef8aa840 = (0, $6xToB.createEntry)((0, $7RTxG.eocTeamCustomerLogsDownloadRoute), ()=>({
        group: 'eoc',
        component: (0, $9lzBd.CustomerLogsDownloadPage),
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $72NQI.downloadResources)()
        ],
        forPaint: [
            (0, $9lzBd.LazyCustomerLogsDownLoad)
        ]
    }));

});
parcelRegister("72NQI", function(module, exports) {

$parcel$export(module.exports, "resources", () => $0c9382ad53a29892$export$bc99aaabaf7b70a7);
$parcel$export(module.exports, "downloadResources", () => $0c9382ad53a29892$export$8571305c82629fe4);

var $dwoHY = parcelRequire("dwoHY");

var $8kQh4 = parcelRequire("8kQh4");

var $kvchH = parcelRequire("kvchH");

var $01waL = parcelRequire("01waL");
const $0c9382ad53a29892$export$bc99aaabaf7b70a7 = ()=>[
        (0, $01waL.uiSettingsResource),
        (0, $kvchH.logsResource),
        ...(0, $dwoHY.eocCommonResources)()
    ];
const $0c9382ad53a29892$export$8571305c82629fe4 = ()=>[
        (0, $8kQh4.downloadAuditLogsResource),
        ...(0, $dwoHY.eocCommonResources)()
    ];

});
parcelRegister("8kQh4", function(module, exports) {

$parcel$export(module.exports, "downloadAuditLogsResource", () => $e471185304cff85e$export$304da75014b88b78);

var $l1VxS = parcelRequire("l1VxS");

var $feIEW = parcelRequire("feIEW");
var $jXKdt = parcelRequire("jXKdt");

var $2Ohdw = parcelRequire("2Ohdw");
const $e471185304cff85e$export$304da75014b88b78 = (0, $l1VxS.createResource)({
    type: 'download-audit-logs-resource',
    getKey: ()=>'download-audit-logs-resource',
    getData: async (routerContext)=>{
        const uniqueKey = routerContext.match.params.exportUniqueKey;
        (0, $feIEW.assert)(!!uniqueKey, new (0, $jXKdt.AssertionError)('downloadAuditLogs resource', 'uniqueKey must be defined'));
        return (0, $2Ohdw.fetchDownloadLinkEndpoint)(uniqueKey);
    },
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("2Ohdw", function(module, exports) {

$parcel$export(module.exports, "fetchDownloadLinkEndpoint", () => $79ef6be84f060ae0$export$c8df7e5942ba1d96);

var $br21R = parcelRequire("br21R");
const $79ef6be84f060ae0$export$c8df7e5942ba1d96 = async (exportUniqueKey)=>{
    return (0, $br21R.eocFetch)(`/v1/logs/export/${exportUniqueKey}/download`, {
        responseType: 'text'
    });
};

});


parcelRegister("kvchH", function(module, exports) {

$parcel$export(module.exports, "logsResource", () => $60db6cf667e7c56d$export$fd88b4310d3f52ff);

var $l1VxS = parcelRequire("l1VxS");

var $4MZh2 = parcelRequire("4MZh2");
const $60db6cf667e7c56d$export$fd88b4310d3f52ff = (0, $l1VxS.createResource)({
    type: 'ui-get-logs',
    getKey: (routerContext)=>{
        const integrationId = routerContext.match.params.integrationId;
        const urlParam = new URLSearchParams();
        Object.entries(routerContext.query).forEach(([key, value])=>{
            if (value) urlParam.set(key, value);
        });
        return !!integrationId ? `integration-${integrationId}-logs#${urlParam.toString()}` : `ui-get-logs#${urlParam.toString()}`;
    },
    getData: async (routerContext)=>{
        return (0, $4MZh2.fetchLogs)({
            fromUnit: routerContext.query?.fromUnit,
            fromValue: routerContext.query?.fromValue,
            startTimestamp: routerContext.query?.startTimestamp,
            endTimestamp: routerContext.query?.endTimestamp,
            eventCategories: routerContext.query?.eventCategories,
            levels: routerContext.query?.levels,
            size: routerContext.query?.size ?? 30,
            insertedAt: routerContext.query?.insertedAt,
            searchString: routerContext.query?.searchString,
            pageDirection: routerContext.query?.pageDirection ?? 'NEXT',
            integrationId: routerContext.match.params.integrationId
        });
    },
    maxAge: 60000,
    isBrowserOnly: true
});

});
parcelRegister("4MZh2", function(module, exports) {

$parcel$export(module.exports, "fetchLogs", () => $0c62296d33d922a5$export$b9fcc8145a518db4);

var $br21R = parcelRequire("br21R");

var $jbFLx = parcelRequire("jbFLx");
const $0c62296d33d922a5$export$b9fcc8145a518db4 = async (params)=>{
    const urlParams = (0, $jbFLx.generateLogParams)(params);
    return (0, $br21R.eocFetch)('/v1/logs/search?' + urlParams.toString()).then((response)=>(0, $jbFLx.postProcessLogsSearch)(urlParams, response));
};

});
parcelRegister("jbFLx", function(module, exports) {

$parcel$export(module.exports, "isValidTimePeriodFormat", () => $8543a033b4da6116$export$2214112898027187);
$parcel$export(module.exports, "getBetweenErrorMessage", () => $8543a033b4da6116$export$b29a6f1d6d345720);
$parcel$export(module.exports, "isValidBetweenInput", () => $8543a033b4da6116$export$7b619dd534dac336);
$parcel$export(module.exports, "isInvalidDateValue", () => $8543a033b4da6116$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "checkQueryIncludesValue", () => $8543a033b4da6116$export$792d5c0a6d15a15e);
$parcel$export(module.exports, "parseGroupOptionQuery", () => $8543a033b4da6116$export$f344cca10df5ca13);
$parcel$export(module.exports, "parseOptionQuery", () => $8543a033b4da6116$export$100c2d7fc380fbfa);
$parcel$export(module.exports, "collectQueryParamsFromOptions", () => $8543a033b4da6116$export$4db9080fab1bce85);
$parcel$export(module.exports, "calculateTimeBetween", () => $8543a033b4da6116$export$42dac873831f0e2);
$parcel$export(module.exports, "generateLogParams", () => $8543a033b4da6116$export$85293a2f3995ddcc);
$parcel$export(module.exports, "fromUnitConverter", () => $8543a033b4da6116$export$ae02811946c03a4b);
$parcel$export(module.exports, "createBaseQuery", () => $8543a033b4da6116$export$9a8301702bf003c4);
$parcel$export(module.exports, "calculateNewStartAndEndTimestamp", () => $8543a033b4da6116$export$b06db0f8b326b929);
$parcel$export(module.exports, "isDetailsSectionEmpty", () => $8543a033b4da6116$export$74cb10c4b9924e49);
$parcel$export(module.exports, "generateParamsForOneMonthInterval", () => $8543a033b4da6116$export$130612b33e678a37);
$parcel$export(module.exports, "calculateWidthAccordingToLevel", () => $8543a033b4da6116$export$e083dc64e00e053b);
$parcel$export(module.exports, "getSourceStringFromUrl", () => $8543a033b4da6116$export$c6631e198cf7c0f4);
$parcel$export(module.exports, "makeMarkup", () => $8543a033b4da6116$export$59302306c6f78677);
$parcel$export(module.exports, "postProcessLogsSearch", () => $8543a033b4da6116$export$9a858fe3837c0be0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1dGnw = parcelRequire("1dGnw");

var $fTjQo = parcelRequire("fTjQo");

var $dBLX0 = parcelRequire("dBLX0");

var $kQ82p = parcelRequire("kQ82p");

var $8XZn3 = parcelRequire("8XZn3");

var $8dH3d = parcelRequire("8dH3d");

var $jPROM = parcelRequire("jPROM");

var $h8epd = parcelRequire("h8epd");

var $feIEW = parcelRequire("feIEW");
var $jXKdt = parcelRequire("jXKdt");

var $hFkGd = parcelRequire("hFkGd");

var $6kFyi = parcelRequire("6kFyi");

var $51o5v = parcelRequire("51o5v");

var $5l37J = parcelRequire("5l37J");
// jira-frontend/src/packages/jql-builder-basic-datetime/src/ui/utils/time-functions.tsx
const $8543a033b4da6116$var$isNumeric = (value)=>/^\d+$/.test(value);
const $8543a033b4da6116$export$2214112898027187 = (timeDigits, timeUnit)=>{
    return timeDigits === '' || timeDigits !== undefined && $8543a033b4da6116$var$isNumeric(timeDigits) && parseInt(timeDigits, 10) > -1 && (0, $6kFyi.RANGE_OPTIONS).includes(timeUnit);
};
const $8543a033b4da6116$export$b29a6f1d6d345720 = (intl, value)=>{
    if (!value?.startDate && !value?.endDate) return intl.formatMessage((0, $5l37J.default).validationMessageAtLeastOneValue);
    if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return intl.formatMessage((0, $5l37J.default).validationMessageBeforeGreaterThanAfter);
    if (value && (value?.startDate !== '' && !(0, $dBLX0.default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, $dBLX0.default)(new Date(value?.endDate)))) return intl.formatMessage((0, $5l37J.default).validationMessageInvalidDateFormat);
    return undefined;
};
const $8543a033b4da6116$export$7b619dd534dac336 = (value)=>{
    if (!value?.startDate && !value?.endDate) return false;
    if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return false;
    if (value && (value?.startDate !== '' && !(0, $dBLX0.default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, $dBLX0.default)(new Date(value?.endDate)))) return false;
    return true;
};
const $8543a033b4da6116$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $dBLX0.default)((0, $kQ82p.default)(value)) && value !== '';
};
const $8543a033b4da6116$export$760bb1b75585fb94 = (value)=>{
    return value.map((event)=>event.value).join(',');
};
const $8543a033b4da6116$export$792d5c0a6d15a15e = (query, value)=>{
    return query?.includes(value.toString()) ?? false;
};
const $8543a033b4da6116$export$f344cca10df5ca13 = (query, options)=>{
    if (!query) return [];
    const labels = [];
    options.map((option)=>{
        option.options.map((item)=>labels.push(item));
    });
    return labels.filter(({ value: value })=>$8543a033b4da6116$export$792d5c0a6d15a15e(query, value));
};
const $8543a033b4da6116$export$100c2d7fc380fbfa = (query, options)=>{
    if (!query) return [];
    return options.filter((label)=>query.includes(label.value.toString()));
};
const $8543a033b4da6116$export$422789958d8174dd = (unit)=>(0, $6kFyi.RANGE_OPTIONS).includes(unit);
const $8543a033b4da6116$export$4db9080fab1bce85 = (options)=>{
    return options.map((option)=>option.value).join(',');
};
const $8543a033b4da6116$var$isTimeQueryParamsValid = (params)=>{
    if (params.has('startTimestamp') && params.has('endTimestamp')) return true;
    else if (params.has('fromUnit') && params.has('fromValue')) return true;
    return false;
};
const $8543a033b4da6116$export$42dac873831f0e2 = (params)=>{
    const now = new Date();
    if (!params.get('startTimestamp') && !params.get('endTimestamp') && params.get('fromUnit') && params.get('fromValue')) {
        const parsedFromValue = parseInt(params.get('fromValue') ?? '1');
        switch(params.get('fromUnit')){
            case 'HOUR':
                params.set('endTimestamp', (now.getTime() * (0, $51o5v.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $8XZn3.default)(now, {
                    hours: parsedFromValue
                }).getTime() * (0, $51o5v.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'DAY':
                params.set('endTimestamp', (now.getTime() * (0, $51o5v.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $8XZn3.default)(now, {
                    days: parsedFromValue
                }).getTime() * (0, $51o5v.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'WEEK':
                params.set('endTimestamp', (now.getTime() * (0, $51o5v.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $8XZn3.default)(now, {
                    weeks: parsedFromValue
                }).getTime() * (0, $51o5v.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'MONTH':
                params.set('endTimestamp', (now.getTime() * (0, $51o5v.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $8XZn3.default)(now, {
                    months: parsedFromValue
                }).getTime() * (0, $51o5v.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
        }
        params.delete('fromUnit');
        params.delete('fromValue');
    }
    return params;
};
const $8543a033b4da6116$export$85293a2f3995ddcc = (params)=>{
    const urlParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value])=>{
        if (value) urlParams.append(key, decodeURI(value));
    });
    if (!$8543a033b4da6116$var$isTimeQueryParamsValid(urlParams)) {
        // Remove time parameters if exists since they were not matched.
        urlParams.delete('fromUnit');
        urlParams.delete('fromValue');
        urlParams.delete('startTimestamp');
        urlParams.delete('endTimestamp');
        urlParams.append('fromUnit', 'DAY');
        urlParams.append('fromValue', '1');
    }
    return $8543a033b4da6116$export$42dac873831f0e2(urlParams);
};
const $8543a033b4da6116$var$calculateTimeDifference = (startDate, endDate)=>{
    const minutesDiff = (0, $1dGnw.default)(endDate, startDate);
    if (minutesDiff < 60) return {
        hours: 1,
        days: 0,
        weeks: 0,
        months: 0,
        years: 0
    };
    const hoursDiff = minutesDiff / 60;
    const daysDiff = minutesDiff / 60 / 24;
    const weeksDiff = minutesDiff / 60 / 24 / 7;
    const monthsDiff = minutesDiff / 60 / 24 / 7 / 4;
    return {
        hours: hoursDiff > 0 ? Math.floor(hoursDiff) : 0,
        days: daysDiff > 0 ? Math.floor(daysDiff) : 0,
        weeks: weeksDiff > 0 ? Math.floor(weeksDiff) : 0,
        months: monthsDiff > 0 ? Math.floor(monthsDiff) : 0
    };
};
const $8543a033b4da6116$export$ae02811946c03a4b = (startDate, endDate)=>{
    const parsedStartDate = (0, $kQ82p.default)(startDate);
    const parsedEndDate = (0, $kQ82p.default)(endDate);
    const timeDifference = $8543a033b4da6116$var$calculateTimeDifference(parsedStartDate, parsedEndDate);
    if (timeDifference.months > 0) return {
        timeUnit: 'MONTH',
        timeDigits: timeDifference.months.toString()
    };
    else if (timeDifference.weeks > 0) return {
        timeUnit: 'WEEK',
        timeDigits: timeDifference.weeks.toString()
    };
    else if (timeDifference.days > 0) return {
        timeUnit: 'DAY',
        timeDigits: timeDifference.days.toString()
    };
    else return {
        timeUnit: 'HOUR',
        timeDigits: timeDifference.hours.toString()
    };
};
const $8543a033b4da6116$export$9a8301702bf003c4 = (query)=>{
    let searchQuery = {};
    if (query.searchString) searchQuery = {
        ...searchQuery,
        searchString: query.searchString
    };
    if (query.startTimestamp && query.endTimestamp) searchQuery = {
        ...searchQuery,
        startTimestamp: query.startTimestamp,
        endTimestamp: query.endTimestamp
    };
    if (query.timeType) searchQuery = {
        ...searchQuery,
        timeType: query.timeType
    };
    if (query.eventCategories) searchQuery = {
        ...searchQuery,
        eventCategories: query.eventCategories
    };
    if (query.levels) searchQuery = {
        ...searchQuery,
        levels: query.levels
    };
    if (query.size) searchQuery = {
        ...searchQuery,
        size: query.size
    };
    return searchQuery;
};
function $8543a033b4da6116$export$b06db0f8b326b929(startTimestamp, endTimestamp) {
    const startDateIntValue = parseInt(startTimestamp) / (0, $51o5v.NANOSECONDS_IN_MILLISECOND);
    const endDateIntValue = parseInt(endTimestamp) / (0, $51o5v.NANOSECONDS_IN_MILLISECOND);
    const { timeDigits: fromValue, timeUnit: fromUnit } = $8543a033b4da6116$export$ae02811946c03a4b((0, $fTjQo.default)(startDateIntValue), (0, $fTjQo.default)(endDateIntValue));
    const params = $8543a033b4da6116$export$42dac873831f0e2(new URLSearchParams({
        fromValue: fromValue,
        fromUnit: fromUnit
    }));
    const startTimestampParams = params.get('startTimestamp');
    const endTimestampParams = params.get('endTimestamp');
    (0, $feIEW.assert)(!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(startTimestampParams) && !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(endTimestampParams), new (0, $jXKdt.AssertionError)('calculateNewStartAndEndTimestamp', 'startTimestamp and endTimestamp should not be null'));
    return {
        startTimestamp: startTimestampParams,
        endTimestamp: endTimestampParams
    };
}
const $8543a033b4da6116$export$74cb10c4b9924e49 = (importantField, raw, isImportantFieldEmpty)=>{
    if (!importantField || !raw) return true;
    const parsedImportantField = JSON.parse(importantField);
    const parsedRaw = JSON.parse(raw);
    return ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(parsedImportantField) || isImportantFieldEmpty === true) && (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(parsedRaw);
};
const $8543a033b4da6116$export$130612b33e678a37 = ()=>{
    const params = $8543a033b4da6116$export$42dac873831f0e2(new URLSearchParams({
        fromUnit: 'MONTH',
        fromValue: '1'
    }));
    const startDate = params.get('startTimestamp');
    const endDate = params.get('endTimestamp');
    (0, $feIEW.assert)(!!startDate && !!endDate, new (0, $jXKdt.AssertionError)('generateParamsForOneMonthInterval', 'startTimestamp and endDate should not be null'));
    return {
        dateTimeValue: {
            startDate: startDate,
            endDate: endDate
        },
        timeType: (0, $hFkGd.TimeRadioOptions).WITHIN_THE_LAST
    };
};
const $8543a033b4da6116$export$e083dc64e00e053b = (level)=>{
    const BASE_OFFSET = 18;
    return `${(0, $51o5v.DETAIL_ITEM_BASE_WIDTH) - level * BASE_OFFSET}px`;
};
const $8543a033b4da6116$export$c6631e198cf7c0f4 = (search)=>{
    const splittedSearch = search.split(/source=/i);
    if (splittedSearch.length > 1) return decodeURIComponent(splittedSearch[1]);
    return '';
};
function $8543a033b4da6116$export$59302306c6f78677(fragment, key) {
    const { nodeName: nodeName, nodeType: nodeType, childNodes: childNodes, textContent: textContent } = fragment;
    if (nodeType === Node.TEXT_NODE) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: textContent
    }, key);
    const children = [];
    childNodes.forEach((childNode, i)=>{
        const markup = $8543a033b4da6116$export$59302306c6f78677(childNode, String(i));
        if (markup) children.push(markup);
    });
    switch(nodeName){
        case 'B':
            return /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                children: children
            }, key);
        case 'I':
            return /*#__PURE__*/ (0, $gt9Am.jsx)("i", {
                children: children
            }, key);
        case 'STRONG':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8epd.default), {
                weight: "bold",
                children: children
            }, key);
        case 'EM':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8epd.default), {
                as: "em",
                children: children
            }, key);
        case 'CODE':
            // eslint-disable-next-line @atlaskit/design-system/no-html-code
            return /*#__PURE__*/ (0, $gt9Am.jsx)("code", {
                children: children
            }, key);
    }
    if (children.length === 1) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: children[0]
    }, key);
    if (children.length) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        children: children
    }, key);
    return null;
}
const $8543a033b4da6116$export$9a858fe3837c0be0 = (urlParams, response)=>{
    if (urlParams.get('startTimestamp') && urlParams.get('endTimestamp')) return {
        ...response,
        data: {
            ...response.data,
            pagination: {
                ...response.data.pagination,
                calcStartDate: urlParams.get('startTimestamp'),
                calcEndDate: urlParams.get('endTimestamp')
            }
        }
    };
    return response;
};

});
parcelRegister("hFkGd", function(module, exports) {

$parcel$export(module.exports, "TimeRadioOptions", () => $99c6de1cfb4015be$export$ff1338756af30600);
var $99c6de1cfb4015be$export$ff1338756af30600 = /*#__PURE__*/ function(TimeRadioOptions) {
    TimeRadioOptions["WITHIN_THE_LAST"] = "withinTheLast";
    TimeRadioOptions["BETWEEN"] = "between";
    return TimeRadioOptions;
}({});

});

parcelRegister("6kFyi", function(module, exports) {

$parcel$export(module.exports, "RANGE_OPTIONS", () => $e217c02462c75ca4$export$a0f3448347834e6b);
const $e217c02462c75ca4$export$a0f3448347834e6b = [
    'HOUR',
    'DAY',
    'WEEK',
    'MONTH'
];

});

parcelRegister("51o5v", function(module, exports) {

$parcel$export(module.exports, "PAGE_SIZE_QUERY_PARAM", () => $d079e193a128fa39$export$4b254bc84a71033a);
$parcel$export(module.exports, "NANOSECONDS_IN_MILLISECOND", () => $d079e193a128fa39$export$753f41e31eccb6d7);
$parcel$export(module.exports, "getHeaderWidths", () => $d079e193a128fa39$export$8aa6dbdb947f7df1);
$parcel$export(module.exports, "DETAIL_ITEM_BASE_WIDTH", () => $d079e193a128fa39$export$1220f90483bde21);
const $d079e193a128fa39$export$4b254bc84a71033a = 'size';
const $d079e193a128fa39$export$753f41e31eccb6d7 = 1000000;
const $d079e193a128fa39$export$8aa6dbdb947f7df1 = (params)=>{
    const { DATE_HEADER_WIDTH: DATE_HEADER_WIDTH, CATEGORY_HEADER_WIDTH: CATEGORY_HEADER_WIDTH, TYPE_HEADER_WIDTH: TYPE_HEADER_WIDTH } = params.showEventCategoryField ? {
        // Widths for audit logs page
        DATE_HEADER_WIDTH: 16,
        CATEGORY_HEADER_WIDTH: 16,
        TYPE_HEADER_WIDTH: 10
    } : {
        // Widths for integration-specific log page
        DATE_HEADER_WIDTH: 14,
        CATEGORY_HEADER_WIDTH: 0,
        TYPE_HEADER_WIDTH: 12
    };
    const columnsToShow = [
        DATE_HEADER_WIDTH,
        CATEGORY_HEADER_WIDTH,
        TYPE_HEADER_WIDTH
    ];
    let sum = 0;
    columnsToShow.forEach((width)=>{
        sum += width;
    });
    return {
        DATE_HEADER_WIDTH: `${DATE_HEADER_WIDTH}%`,
        CATEGORY_HEADER_WIDTH: `${CATEGORY_HEADER_WIDTH}%`,
        TYPE_HEADER_WIDTH: `${TYPE_HEADER_WIDTH}%`,
        CHANGE_SUMMARY_HEADER_WIDTH: `${100 - sum}%`
    };
};
const $d079e193a128fa39$export$1220f90483bde21 = 250;

});

parcelRegister("5l37J", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d5ec83db57ac976$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6d5ec83db57ac976$var$messages = (0, $7qGN1.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.customer-logs.common.utils.validation-message-before-greater-than-after.no-translate`,
        defaultMessage: 'Specify a valid time range.',
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.customer-logs.common.utils.validation-message-invalid-date-format.no-translate`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validationMessageAtLeastOneValue: {
        id: `eoc.customer-logs.common.utils.validation-message-at-least-one-value.no-translate`,
        defaultMessage: 'Select at least one value.',
        description: 'Message displayed to the user when there is no selected before and end date together'
    }
});
var $6d5ec83db57ac976$export$2e2bcd8739ae039 = $6d5ec83db57ac976$var$messages;

});




parcelRegister("01waL", function(module, exports) {

$parcel$export(module.exports, "uiSettingsResource", () => $838f662c3fa096c0$export$f2b33518cf31cd40);

var $l1VxS = parcelRequire("l1VxS");

var $3G67h = parcelRequire("3G67h");
const $838f662c3fa096c0$export$f2b33518cf31cd40 = (0, $l1VxS.createResource)({
    type: 'ui-settings-resource',
    getKey: ()=>'ui-settings-resource',
    getData: async ()=>(0, $3G67h.fetchUiSettingsEndpoint)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("3G67h", function(module, exports) {

$parcel$export(module.exports, "fetchUiSettingsEndpoint", () => $034a3abb72451d67$export$ea2f12bcbdce2020);

var $br21R = parcelRequire("br21R");
const $034a3abb72451d67$export$ea2f12bcbdce2020 = async ()=>{
    return (0, $br21R.eocFetch)('/v1/logs');
};

});



parcelRegister("7RTxG", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsDownloadRoute", () => $9cb3689751fd3d67$export$678856ccddc0bc05);
const $9cb3689751fd3d67$export$678856ccddc0bc05 = {
    name: 'eoc-team-customer-logs-download',
    path: '/jira/settings/products/ops/jira-service-management-audit-logs/download/:exportUniqueKey',
    exact: true
};

});

parcelRegister("9lzBd", function(module, exports) {

$parcel$export(module.exports, "LazyCustomerLogs", () => $74267c97f7a69873$export$6e30e25faf4f6dce);
$parcel$export(module.exports, "LazyCustomerLogsDownLoad", () => $74267c97f7a69873$export$898c7cb3b28a6104);
$parcel$export(module.exports, "default", () => $74267c97f7a69873$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CustomerLogsDownloadPage", () => $74267c97f7a69873$export$a5786cf859b7b457);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $74267c97f7a69873$export$6e30e25faf4f6dce = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("30UqJ")), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});

const $74267c97f7a69873$export$898c7cb3b28a6104 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("30UqJ")).then(({ CustomerLogsDownloadPage: CustomerLogsDownloadPage })=>CustomerLogsDownloadPage), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$74267c97f7a69873$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $74267c97f7a69873$export$6e30e25faf4f6dce,
        pageId: "async-jira-eoc-customer-logs",
        shouldShowSpinner: false
    });
const $74267c97f7a69873$export$a5786cf859b7b457 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $74267c97f7a69873$export$898c7cb3b28a6104,
        pageId: "async-jira-eoc-customer-logs-download",
        shouldShowSpinner: false
    });

});
parcelRegister("30UqJ", function(module, exports) {

let $231d250f3a2ed9eb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $231d250f3a2ed9eb$var$load("1xD21").then(()=>parcelRequire('57oKS'));

});



parcelRegister("3s5Pk", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsRouteEntry", () => $30927a52d25dd1e8$export$42ca979ec2919b23);

var $72NQI = parcelRequire("72NQI");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $6zXPf = parcelRequire("6zXPf");

var $iTOe5 = parcelRequire("iTOe5");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $9lzBd = parcelRequire("9lzBd");
const $30927a52d25dd1e8$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $30927a52d25dd1e8$export$42ca979ec2919b23 = (0, $6xToB.createEntry)((0, $iTOe5.eocTeamCustomerLogsRoute), ()=>({
        group: 'eoc',
        component: (0, $9lzBd.default),
        layout: (0, $iRfwO.opsSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$30927a52d25dd1e8$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $72NQI.resources)()
        ],
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9lzBd.LazyCustomerLogs)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9lzBd.LazyCustomerLogs)
        ]
    }));

});
parcelRegister("iTOe5", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsRoute", () => $b8938549b62bad8e$export$4b517044f5f7830d);
const $b8938549b62bad8e$export$4b517044f5f7830d = {
    name: 'eoc-team-customer-logs',
    path: '/jira/settings/products/ops/jira-service-management-audit-logs',
    exact: true
};

});


parcelRegister("Vlf4X", function(module, exports) {

$parcel$export(module.exports, "eocTeamGroupDetailRouteEntry", () => $3d2511d7ed26a782$export$2b25520e20820251);

var $17OMI = parcelRequire("17OMI");

var $d8PBA = parcelRequire("d8PBA");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $bQuVG = parcelRequire("bQuVG");

var $9HKZp = parcelRequire("9HKZp");
const $3d2511d7ed26a782$export$2b25520e20820251 = (0, $6xToB.createEntry)((0, $bQuVG.eocTeamGroupDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $9HKZp.default),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)(),
            ...(0, $d8PBA.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $17OMI.resources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9HKZp.LazyGroupDetail),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("bQuVG", function(module, exports) {

$parcel$export(module.exports, "eocTeamGroupDetailRoute", () => $1e8ac7f8b70f6a94$export$aa8cf61e94739f21);
const $1e8ac7f8b70f6a94$export$aa8cf61e94739f21 = {
    name: 'eoc-team-group-detail',
    path: '/jira/ops/teams/:teamId/group-detail/:id',
    exact: true
};

});


parcelRegister("7JuWl", function(module, exports) {

$parcel$export(module.exports, "eocUserNotificationsRouteEntry", () => $030ef2384ba5b682$export$15b42089d01e5917);

var $j7fEk = parcelRequire("j7fEk");

var $efbEC = parcelRequire("efbEC");

var $4VmHN = parcelRequire("4VmHN");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $gPROq = parcelRequire("gPROq");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $8fcHh = parcelRequire("8fcHh");
const $030ef2384ba5b682$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $030ef2384ba5b682$export$15b42089d01e5917 = (0, $6xToB.createEntry)((0, $gPROq.eocUserNotificationsRoute), ()=>({
        group: 'eoc',
        component: (0, $8fcHh.default),
        layout: (0, $iRfwO.opsSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$030ef2384ba5b682$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $j7fEk.createContactsResource)(),
            (0, $4VmHN.createNotificationPreferencesResource)(),
            (0, $efbEC.createMuteResource)(),
            (0, $efbEC.createQuietHoursResource)(),
            (0, $4VmHN.createForwardingRulesResource)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8fcHh.LazyUserNotifications)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8fcHh.LazyUserNotifications)
        ]
    }));

});
parcelRegister("j7fEk", function(module, exports) {

$parcel$export(module.exports, "createContactsResource", () => $e7583704ad3e00bd$export$b9ca444b0be3df97);
$parcel$export(module.exports, "contactsResource", () => $e7583704ad3e00bd$export$54a06d876c95357d);

var $l1VxS = parcelRequire("l1VxS");

var $8XtVW = parcelRequire("8XtVW");

var $aWgVv = parcelRequire("aWgVv");
const $e7583704ad3e00bd$export$b9ca444b0be3df97 = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'contactsResource',
        getKey: ()=>'contactsResource',
        getData: async ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = (0, $8XtVW.fg)('jsm_admin_access_user_notification_settings') ? match.params?.targetAccountId : undefined;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await (0, $aWgVv.getContacts)(targetAccountId);
            return data.contacts;
        },
        isBrowserOnly: true,
        depends: depends
    });
const $e7583704ad3e00bd$export$54a06d876c95357d = $e7583704ad3e00bd$export$b9ca444b0be3df97();

});
parcelRegister("aWgVv", function(module, exports) {

$parcel$export(module.exports, "getContacts", () => $bf13302a5b8b267c$export$70ff9d70e43e8f10);
$parcel$export(module.exports, "addContactEndpoint", () => $bf13302a5b8b267c$export$bd596455bda1cd66);
$parcel$export(module.exports, "orderContactEndpoint", () => $bf13302a5b8b267c$export$77f16e7683ad08d6);
$parcel$export(module.exports, "updateContactStatusEndpoint", () => $bf13302a5b8b267c$export$d50cab05338f8080);
$parcel$export(module.exports, "deleteContactEndpoint", () => $bf13302a5b8b267c$export$59eb3ff38e4cd944);
$parcel$export(module.exports, "editContactEndpoint", () => $bf13302a5b8b267c$export$3f8035f77e3aeb9d);
$parcel$export(module.exports, "sendVerificationCodeEndpoint", () => $bf13302a5b8b267c$export$74e1bdc56dc32826);
$parcel$export(module.exports, "checkVerificationCodeEndpoint", () => $bf13302a5b8b267c$export$fbe80b8d857094de);

var $br21R = parcelRequire("br21R");

var $7dndE = parcelRequire("7dndE");
const $bf13302a5b8b267c$export$70ff9d70e43e8f10 = (targetAccountId)=>(0, $br21R.eocFetch)(`/v1/users/contact${(0, $7dndE.getTargetAccountIdSuffix)(targetAccountId)}`);
const $bf13302a5b8b267c$export$bd596455bda1cd66 = (newAddress, method, targetAccountId)=>{
    return (0, $br21R.eocFetch)(`/v1/users/contact${(0, $7dndE.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'POST',
        body: {
            address: newAddress,
            method: method.toLowerCase()
        }
    });
};
const $bf13302a5b8b267c$export$77f16e7683ad08d6 = (contactId, after, targetAccountId)=>{
    return (0, $br21R.eocFetch)(`/v1/users/contact/order${(0, $7dndE.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId,
            after: after
        }
    });
};
const $bf13302a5b8b267c$export$d50cab05338f8080 = (status)=>{
    return status ? $bf13302a5b8b267c$var$enableContactEndpoint : $bf13302a5b8b267c$var$disableContactEndpoint;
};
const $bf13302a5b8b267c$var$enableContactEndpoint = (contactId, targetAccountId)=>{
    return (0, $br21R.eocFetch)(`/v1/users/contact/state/enabled${(0, $7dndE.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $bf13302a5b8b267c$var$disableContactEndpoint = (contactId, targetAccountId)=>{
    return (0, $br21R.eocFetch)(`/v1/users/contact/state/disabled${(0, $7dndE.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $bf13302a5b8b267c$export$59eb3ff38e4cd944 = (contactId, targetAccountId)=>{
    return (0, $br21R.eocFetch)(`/v1/users/contact${(0, $7dndE.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'DELETE',
        body: {
            contactId: contactId
        },
        responseType: 'headers'
    });
};
const $bf13302a5b8b267c$export$3f8035f77e3aeb9d = (contactId, newAddress, targetAccountId)=>{
    return (0, $br21R.eocFetch)(`/v1/users/contact${(0, $7dndE.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId,
            address: newAddress
        }
    });
};
const $bf13302a5b8b267c$export$74e1bdc56dc32826 = (phoneNumber, method, targetAccountId)=>{
    return (0, $br21R.eocFetch)(`/v1/users/contact/verification${(0, $7dndE.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'POST',
        body: {
            phoneNumber: phoneNumber,
            method: method.toLowerCase()
        }
    });
};
const $bf13302a5b8b267c$export$fbe80b8d857094de = (phoneNumber, code, targetAccountId)=>{
    return (0, $br21R.eocFetch)(`/v1/users/contact/verification/check${(0, $7dndE.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'POST',
        body: {
            phoneNumber: phoneNumber,
            code: code
        },
        responseType: 'headers'
    });
};

});
parcelRegister("7dndE", function(module, exports) {

$parcel$export(module.exports, "calculateRemainingMinutesAndSeconds", () => $a815639370bcd23b$export$d3f650aeadf07bf8);
$parcel$export(module.exports, "getTargetAccountIdSuffix", () => $a815639370bcd23b$export$f538d5c43127966b);

var $8XtVW = parcelRequire("8XtVW");
const $a815639370bcd23b$export$d3f650aeadf07bf8 = (countDown)=>{
    const minutes = Math.floor(countDown % 3600000 / 60000);
    const seconds = Math.floor(countDown % 60000 / 1000);
    return [
        minutes < 0 ? 0 : minutes,
        seconds < 0 ? 0 : seconds
    ];
};
const $a815639370bcd23b$export$f538d5c43127966b = (targetAccountId)=>{
    if ((0, $8XtVW.fg)('jsm_admin_access_user_notification_settings')) return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
    return '';
};

});



parcelRegister("efbEC", function(module, exports) {

$parcel$export(module.exports, "createMuteResource", () => $429eb5b493906e82$export$c849cfac68bc6e80);
$parcel$export(module.exports, "createQuietHoursResource", () => $429eb5b493906e82$export$efc5e8690061f9cc);
$parcel$export(module.exports, "muteResource", () => $429eb5b493906e82$export$3c4c16a7c2620c29);
$parcel$export(module.exports, "quietHoursResource", () => $429eb5b493906e82$export$9b33012bd34cc225);

var $l1VxS = parcelRequire("l1VxS");

var $7rdZX = parcelRequire("7rdZX");
const $429eb5b493906e82$export$c849cfac68bc6e80 = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'muteResource',
        getKey: ()=>'muteResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $7rdZX.getMuteDetail)(targetAccountId);
        },
        isBrowserOnly: true,
        depends: depends
    });
const $429eb5b493906e82$export$efc5e8690061f9cc = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'quietHoursResource',
        getKey: ()=>'quietHoursResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $7rdZX.getQuietHoursDetail)(targetAccountId);
        },
        isBrowserOnly: true,
        depends: depends
    });
const $429eb5b493906e82$export$3c4c16a7c2620c29 = $429eb5b493906e82$export$c849cfac68bc6e80();
const $429eb5b493906e82$export$9b33012bd34cc225 = $429eb5b493906e82$export$efc5e8690061f9cc();

});
parcelRegister("7rdZX", function(module, exports) {

$parcel$export(module.exports, "getMuteDetail", () => $0d7dabe6c338d62d$export$80a4e62998a806a6);
$parcel$export(module.exports, "getQuietHoursDetail", () => $0d7dabe6c338d62d$export$44a94c74f358d02f);

var $br21R = parcelRequire("br21R");

var $3Tpz7 = parcelRequire("3Tpz7");
const $0d7dabe6c338d62d$export$80a4e62998a806a6 = (targetAccountId)=>(0, $br21R.eocFetch)(`/v1/users/notifications/mute${(0, $3Tpz7.getTargetAccountIdSuffix)(targetAccountId)}`);
const $0d7dabe6c338d62d$export$44a94c74f358d02f = (targetAccountId)=>(0, $br21R.eocFetch)(`/v1/users/quiet-hours/details${(0, $3Tpz7.getTargetAccountIdSuffix)(targetAccountId)}`);

});
parcelRegister("3Tpz7", function(module, exports) {

$parcel$export(module.exports, "getTargetAccountIdSuffix", () => $04e83d1535f6af98$export$f538d5c43127966b);

var $8XtVW = parcelRequire("8XtVW");
const $04e83d1535f6af98$export$f538d5c43127966b = (targetAccountId)=>{
    if ((0, $8XtVW.fg)('jsm_admin_access_user_notification_settings')) return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
    return '';
};

});



parcelRegister("4VmHN", function(module, exports) {

$parcel$export(module.exports, "createNotificationPreferencesResource", () => $50a839cdf1c0def0$export$731980bd233a4797);
$parcel$export(module.exports, "createForwardingRulesResource", () => $50a839cdf1c0def0$export$5314dca65b4e5888);

var $l1VxS = parcelRequire("l1VxS");
parcelRequire("dwoHY");
var $fbCoq = parcelRequire("fbCoq");

var $jQ7W1 = parcelRequire("jQ7W1");
const $50a839cdf1c0def0$export$731980bd233a4797 = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'notificationPreferencesResource',
        getKey: ()=>'notificationPreferencesResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $jQ7W1.getNotificationPreferences)(targetAccountId);
        },
        isBrowserOnly: true,
        depends: depends
    });
const $50a839cdf1c0def0$export$5314dca65b4e5888 = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'forwardingRulesResource',
        getKey: ()=>'forwardingRulesResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $jQ7W1.getForwardingRules)(targetAccountId).then(({ values: values })=>values);
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("jQ7W1", function(module, exports) {

$parcel$export(module.exports, "getNotificationPreferences", () => $5f31db73a3b3f692$export$60e139c3026f21bc);
$parcel$export(module.exports, "getForwardingRules", () => $5f31db73a3b3f692$export$2161af98e3d645a5);

var $br21R = parcelRequire("br21R");

var $f8mND = parcelRequire("f8mND");
const $5f31db73a3b3f692$export$60e139c3026f21bc = (targetAccountId)=>(0, $br21R.eocFetch)(`/v1/users/notification-preferences${(0, $f8mND.getTargetAccountIdSuffix)(targetAccountId)}`);
const $5f31db73a3b3f692$export$2161af98e3d645a5 = (targetAccountId)=>(0, $br21R.eocFetch)(`/v1/alerts/notifications/forwarding-rules${(0, $f8mND.getTargetAccountIdSuffix)(targetAccountId)}`);

});
parcelRegister("f8mND", function(module, exports) {

$parcel$export(module.exports, "getOperationName", () => $10e42bb94a9c3367$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getMatchType", () => $10e42bb94a9c3367$export$a8ea0fb63186ef7e);
$parcel$export(module.exports, "formatRestriction", () => $10e42bb94a9c3367$export$99bcc87a197977ea);
$parcel$export(module.exports, "getAvailableRuleTypeOptions", () => $10e42bb94a9c3367$export$c5259662f509f23f);
$parcel$export(module.exports, "getDefaultTimeOptions", () => $10e42bb94a9c3367$export$318d0e67e244d7ff);
$parcel$export(module.exports, "getTargetAccountIdSuffix", () => $10e42bb94a9c3367$export$f538d5c43127966b);

var $8RQlO = parcelRequire("8RQlO");

var $57raR = parcelRequire("57raR");

var $jD788 = parcelRequire("jD788");

var $5IPrF = parcelRequire("5IPrF");

var $8XtVW = parcelRequire("8XtVW");

var $6flYd = parcelRequire("6flYd");

var $ezktX = parcelRequire("ezktX");

var $9nvYO = parcelRequire("9nvYO");
const $10e42bb94a9c3367$export$41bca9dc6871dd4e = (id)=>{
    const operation = (0, $6flYd.OPERATIONS).find((operation)=>operation.id === id);
    return operation?.name;
};
const $10e42bb94a9c3367$export$a8ea0fb63186ef7e = (conditionMatchType)=>{
    switch(conditionMatchType){
        case 1:
            return 'match-any-condition';
        case 2:
            return 'match-all-conditions';
        default:
            return 'match-all';
    }
};
const $10e42bb94a9c3367$export$5f84d4e06c0693c4 = ()=>{
    const firstDOW = (0, $5IPrF.default)(new Date(), {
        weekStartsOn: 0
    });
    const weekDays = Array.from(Array(7)).map((e, i)=>({
            label: (0, $57raR.default)((0, $8RQlO.default)(firstDOW, i), 'EEEE'),
            value: i % 7 + 1
        }));
    return weekDays;
};
const $10e42bb94a9c3367$export$99bcc87a197977ea = (timeInterval)=>{
    const days = $10e42bb94a9c3367$export$5f84d4e06c0693c4();
    const startDay = days.find((day)=>day.value === timeInterval.startDay);
    const endDay = days.find((day)=>day.value === timeInterval.endDay);
    const startTime = (0, $57raR.default)((0, $jD788.default)(new Date(), {
        hours: timeInterval.startHour,
        minutes: timeInterval.startMinute
    }), 'p');
    const endTime = (0, $57raR.default)((0, $jD788.default)(new Date(), {
        hours: timeInterval.endHour,
        minutes: timeInterval.endMinute
    }), 'p');
    if (startDay && endDay) {
        const formattedTime = `${startDay.label} ${startTime} - ${endDay.label} ${endTime}`;
        return formattedTime;
    }
    const formattedTime = `${startTime} - ${endTime}`;
    return formattedTime;
};
const $10e42bb94a9c3367$export$c5259662f509f23f = (formatMessage)=>{
    return Object.keys((0, $ezktX.AVAILABLE_RULE_TYPES)).filter((v)=>isNaN(Number(v))).map((key)=>({
            label: formatMessage((0, $9nvYO.default)[key]),
            value: key
        }));
};
const $10e42bb94a9c3367$export$318d0e67e244d7ff = ()=>{
    return [
        ...Array(24).keys()
    ].map((time)=>{
        let newTime = time.toString();
        if (newTime.length === 1) newTime = `0${time}`;
        return [
            `${newTime}:00`,
            `${newTime}:30`
        ];
    }).flatMap((time)=>time);
};
const $10e42bb94a9c3367$export$f538d5c43127966b = (targetAccountId)=>{
    if ((0, $8XtVW.fg)('jsm_admin_access_user_notification_settings')) return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
    return '';
};

});
parcelRegister("6flYd", function(module, exports) {

$parcel$export(module.exports, "DATE_FORMAT", () => $7edd958fb9ffaab4$export$45c85543ba71221d);
$parcel$export(module.exports, "TIME_FORMAT", () => $7edd958fb9ffaab4$export$c4e1e4e065ff5bd8);
$parcel$export(module.exports, "DATETIME_FORMAT", () => $7edd958fb9ffaab4$export$ae1dc8cbcf481d8e);
$parcel$export(module.exports, "OPERATIONS", () => $7edd958fb9ffaab4$export$98ff4de2f070152d);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $7edd958fb9ffaab4$export$a7c923252528b255);
$parcel$export(module.exports, "defaultTimes", () => $7edd958fb9ffaab4$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "supportArticles", () => $7edd958fb9ffaab4$export$f4b848c2437238f9);

var $ezktX = parcelRequire("ezktX");
const $7edd958fb9ffaab4$export$45c85543ba71221d = 'dd/MM/yyyy';
const $7edd958fb9ffaab4$export$c4e1e4e065ff5bd8 = 'h:mm aaa';
const $7edd958fb9ffaab4$export$ae1dc8cbcf481d8e = `${$7edd958fb9ffaab4$export$45c85543ba71221d}; ${$7edd958fb9ffaab4$export$c4e1e4e065ff5bd8}`;
const $7edd958fb9ffaab4$export$98ff4de2f070152d = [
    {
        order: 0,
        id: (0, $ezktX.OperationIds).Matches,
        name: (0, $ezktX.Operation).Matches
    },
    {
        order: 1,
        id: (0, $ezktX.OperationIds).Equals,
        name: (0, $ezktX.Operation).Equals
    },
    {
        order: 2,
        id: (0, $ezktX.OperationIds).Contains,
        name: (0, $ezktX.Operation).Contains
    },
    {
        order: 3,
        id: (0, $ezktX.OperationIds).StartsWith,
        name: (0, $ezktX.Operation).StartsWith
    },
    {
        order: 4,
        id: (0, $ezktX.OperationIds).EndsWith,
        name: (0, $ezktX.Operation).EndsWith
    },
    {
        order: 5,
        id: (0, $ezktX.OperationIds).ContainsKey,
        name: (0, $ezktX.Operation).ContainsKey
    },
    {
        order: 6,
        id: (0, $ezktX.OperationIds).ContainsValue,
        name: (0, $ezktX.Operation).ContainsValue
    },
    {
        order: 7,
        id: (0, $ezktX.OperationIds).GreaterThan,
        name: (0, $ezktX.Operation).GreaterThan
    },
    {
        order: 8,
        id: (0, $ezktX.OperationIds).LessThan,
        name: (0, $ezktX.Operation).LessThan
    },
    {
        order: 9,
        id: (0, $ezktX.OperationIds).IsEmpty,
        name: (0, $ezktX.Operation).IsEmpty
    },
    {
        order: 10,
        id: (0, $ezktX.OperationIds).EqualsIgnoreWhitespace,
        name: (0, $ezktX.Operation).EqualsIgnoreWhitespace
    }
];
const $7edd958fb9ffaab4$export$a7c923252528b255 = {
    dndTitle: 'eoc-notifications_dnd_title',
    rulesTitle: 'eoc-notifications_rules_title',
    forwardingRulesTitle: 'eoc-notifications_forwarding_rules_title'
};
const $7edd958fb9ffaab4$export$b42ffb9f09b1861b = [
    ...Array(24).keys()
].map((time)=>{
    let newTime = time.toString();
    if (newTime.length === 1) newTime = `0${time}`;
    return [
        `${newTime}:00`,
        `${newTime}:30`
    ];
}).flatMap((time)=>time);
const $7edd958fb9ffaab4$export$f4b848c2437238f9 = {
    setUpRoleBasedNotifications: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-role-based-notifications/',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/112066569/Set+up+role-based+notifications/'
    },
    setUpSmsAndVoice: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-sms-and-voice-notifications/#Contact-information',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11404235/Set+up+SMS+and+voice+notifications#Contact-information'
    },
    setUpNotificationPreferences: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-notification-preferences',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11469955/Set+up+notification+preferences'
    },
    notificationForwardingRules: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/add-notification-forwarding-rules',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11404196/Add+notification+forwarding+rules'
    }
};

});
parcelRegister("ezktX", function(module, exports) {

$parcel$export(module.exports, "AVAILABLE_RULE_TYPES", () => $026db53a7432c3c7$export$a4958d8d5a6aee21);
$parcel$export(module.exports, "OperationIds", () => $026db53a7432c3c7$export$9e369e35ea3634d7);
$parcel$export(module.exports, "ReverseOperations", () => $026db53a7432c3c7$export$e722854e5571abe4);
$parcel$export(module.exports, "MatchConditionType", () => $026db53a7432c3c7$export$dab128282aa7aeee);
$parcel$export(module.exports, "Operation", () => $026db53a7432c3c7$export$ab5aad00225c5662);
var $026db53a7432c3c7$export$a4958d8d5a6aee21 = /*#__PURE__*/ function(AVAILABLE_RULE_TYPES) {
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["New Alert"] = 0] = "New Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Schedule Start"] = 3] = "Schedule Start";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Schedule End"] = 7] = "Schedule End";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Incoming Call Routing"] = 8] = "Incoming Call Routing";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Acknowledged Alert"] = 1] = "Acknowledged Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Closed Alert"] = 2] = "Closed Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Assigned Alert"] = 5] = "Assigned Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Add Note"] = 6] = "Add Note";
    return AVAILABLE_RULE_TYPES;
}({});
var $026db53a7432c3c7$export$9e369e35ea3634d7 = /*#__PURE__*/ function(OperationIds) {
    OperationIds[OperationIds["Matches"] = 0] = "Matches";
    OperationIds[OperationIds["Contains"] = 1] = "Contains";
    OperationIds[OperationIds["StartsWith"] = 3] = "StartsWith";
    OperationIds[OperationIds["EndsWith"] = 4] = "EndsWith";
    OperationIds[OperationIds["Equals"] = 5] = "Equals";
    OperationIds[OperationIds["ContainsKey"] = 6] = "ContainsKey";
    OperationIds[OperationIds["ContainsValue"] = 7] = "ContainsValue";
    OperationIds[OperationIds["GreaterThan"] = 8] = "GreaterThan";
    OperationIds[OperationIds["LessThan"] = 9] = "LessThan";
    OperationIds[OperationIds["IsEmpty"] = 10] = "IsEmpty";
    OperationIds[OperationIds["EqualsIgnoreWhitespace"] = 11] = "EqualsIgnoreWhitespace";
    return OperationIds;
}({});
var $026db53a7432c3c7$export$e722854e5571abe4 = /*#__PURE__*/ function(ReverseOperations) {
    ReverseOperations[ReverseOperations["matches"] = 0] = "matches";
    ReverseOperations[ReverseOperations["contains"] = 1] = "contains";
    ReverseOperations[ReverseOperations["starts-with"] = 3] = "starts-with";
    ReverseOperations[ReverseOperations["ends-with"] = 4] = "ends-with";
    ReverseOperations[ReverseOperations["equals"] = 5] = "equals";
    ReverseOperations[ReverseOperations["contains-key"] = 6] = "contains-key";
    ReverseOperations[ReverseOperations["contains-value"] = 7] = "contains-value";
    ReverseOperations[ReverseOperations["greater-than"] = 8] = "greater-than";
    ReverseOperations[ReverseOperations["less-than"] = 9] = "less-than";
    ReverseOperations[ReverseOperations["is-empty"] = 10] = "is-empty";
    ReverseOperations[ReverseOperations["equals-ignore-whitespace"] = 11] = "equals-ignore-whitespace";
    return ReverseOperations;
}({});
var $026db53a7432c3c7$export$dab128282aa7aeee = /*#__PURE__*/ function(MatchConditionType) {
    MatchConditionType[MatchConditionType["match-all"] = 0] = "match-all";
    MatchConditionType[MatchConditionType["match-any-condition"] = 1] = "match-any-condition";
    MatchConditionType[MatchConditionType["match-all-conditions"] = 2] = "match-all-conditions";
    return MatchConditionType;
}({});
var $026db53a7432c3c7$export$ab5aad00225c5662 = /*#__PURE__*/ function(Operation) {
    Operation["Matches"] = "matches";
    Operation["Contains"] = "contains";
    Operation["StartsWith"] = "starts-with";
    Operation["EndsWith"] = "ends-with";
    Operation["Equals"] = "equals";
    Operation["ContainsKey"] = "contains-key";
    Operation["ContainsValue"] = "contains-value";
    Operation["GreaterThan"] = "greater-than";
    Operation["LessThan"] = "less-than";
    Operation["IsEmpty"] = "is-empty";
    Operation["EqualsIgnoreWhitespace"] = "equals-ignore-whitespace";
    return Operation;
}({});

});


parcelRegister("9nvYO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fc361bcbd7af3e9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $2fc361bcbd7af3e9$var$messages = (0, $7qGN1.defineMessages)({
    addIcon: {
        id: 'eoc.notifications.rules.add-icon.no-translate',
        defaultMessage: 'Add rule',
        description: 'Button label to indicate it is used for adding a new notification rule.'
    },
    'New Alert': {
        id: 'eoc.notifications.ui.notifications.new-alert.no-translate',
        defaultMessage: 'New alert',
        description: 'The title of new alert notifications'
    },
    'Schedule Start': {
        id: 'eoc.notifications.ui.notifications.schedule-start.no-translate',
        defaultMessage: 'Schedule start',
        description: 'The title of schedule start notifications'
    },
    'Schedule End': {
        id: 'eoc.notifications.ui.notifications.schedule-end.no-translate',
        defaultMessage: 'Schedule end',
        description: 'The title of schedule end notifications'
    },
    'Acknowledged Alert': {
        id: 'eoc.notifications.ui.notifications.acknowledged-alert.no-translate',
        defaultMessage: 'Acknowledged alert',
        description: 'The title of acknowledged alert notifications'
    },
    'Closed Alert': {
        id: 'eoc.notifications.ui.notifications.closed-alert.no-translate',
        defaultMessage: 'Closed alert',
        description: 'The title of closed alert notifications'
    },
    'Assigned Alert': {
        id: 'eoc.notifications.ui.notifications.assigned-alert.no-translate',
        defaultMessage: 'Assigned alert',
        description: 'The title of assigned alert notifications'
    },
    'Add Note': {
        id: 'eoc.notifications.ui.notifications.add-note.no-translate',
        defaultMessage: 'Add note',
        description: 'The title of add note notifications'
    },
    'Incoming Call Routing': {
        id: 'eoc.notifications.ui.notifications.incoming-call-routing.no-translate',
        defaultMessage: 'Incoming Call Routing',
        description: 'The title of incoming call rounting notifications'
    },
    addButtonTooltip: {
        id: 'eoc.notifications.common.ui.notification-section.add-button-tooltip.non-final',
        defaultMessage: "A role-based notification is in effect, so adding more rules isn\u2019t possible.",
        description: 'The message to be shown when user tries to add a rule but there is a role-based notification'
    }
});
var $2fc361bcbd7af3e9$export$2e2bcd8739ae039 = $2fc361bcbd7af3e9$var$messages;

});




parcelRegister("gPROq", function(module, exports) {

$parcel$export(module.exports, "eocUserNotificationsRoute", () => $64a2dff356011922$export$f7a15352c90f8063);
const $64a2dff356011922$export$f7a15352c90f8063 = {
    name: 'eoc-user-notifications',
    path: '/jira/settings/products/ops/role-assignment/notifications/:targetAccountId',
    exact: true
};

});

parcelRegister("8fcHh", function(module, exports) {

$parcel$export(module.exports, "LazyUserNotifications", () => $cdd80e4e0e1de913$export$a510b3cfe09fad0d);
$parcel$export(module.exports, "default", () => $cdd80e4e0e1de913$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $cdd80e4e0e1de913$export$a510b3cfe09fad0d = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("eNzLY")), {
    ssr: false,
    moduleId: "./src/packages/eoc/user-notifications/src/index.tsx"
});
const $cdd80e4e0e1de913$var$LazyUserNotificationsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cdd80e4e0e1de913$export$a510b3cfe09fad0d,
        pageId: "async-eoc-user-notifications",
        shouldShowSpinner: false
    });
var $cdd80e4e0e1de913$export$2e2bcd8739ae039 = $cdd80e4e0e1de913$var$LazyUserNotificationsPage;

});
parcelRegister("eNzLY", function(module, exports) {

let $ac6163fe3502d76c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ac6163fe3502d76c$var$load("1VRB2"),
    $ac6163fe3502d76c$var$load("bABhq"),
    $ac6163fe3502d76c$var$load("7vqGd"),
    $ac6163fe3502d76c$var$load("1Y4bq"),
    $ac6163fe3502d76c$var$load("fBlPf")
]).then(()=>parcelRequire('jE64o'));

});



parcelRegister("4kc5Q", function(module, exports) {

$parcel$export(module.exports, "errorsNotFoundRouteEntry", () => $88e7ccc882e07762$export$c4c012a49b465e94);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $hTP13 = parcelRequire("hTP13");
const $88e7ccc882e07762$export$c4c012a49b465e94 = (0, $6xToB.createEntry)((0, $hTP13.errorsNotFoundRoute), ()=>({
        group: 'errors',
        component: (0, $9BJU1.default),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9BJU1.LazyNotFoundErrorPage)
        ]
    }));

});
parcelRegister("hTP13", function(module, exports) {

$parcel$export(module.exports, "errorsNotFoundRoute", () => $11ca6d2fc3955dd4$export$465fa01c0f3a0551);
const $11ca6d2fc3955dd4$export$465fa01c0f3a0551 = {
    name: 'errors-not-found',
    path: '/jira/:projectType(software|servicedesk|core)'
};

});


parcelRegister("ksM4d", function(module, exports) {

$parcel$export(module.exports, "externalImportRouteEntry", () => $405b65f4bf032022$export$d55ce647d8216437);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $dB6ZO = parcelRequire("dB6ZO");

var $5fjzQ = parcelRequire("5fjzQ");

var $fSjll = parcelRequire("fSjll");
const $405b65f4bf032022$export$d55ce647d8216437 = (0, $6xToB.createEntry)((0, $dB6ZO.externalImportRoute), ()=>({
        group: 'global-settings',
        component: (0, $fSjll.default),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("dB6ZO", function(module, exports) {

$parcel$export(module.exports, "externalImportRoute", () => $235145e3e8943ed5$export$17c79100fc4c65a1);
const $235145e3e8943ed5$export$17c79100fc4c65a1 = {
    name: 'external-import',
    path: '/jira/settings/system/external-import'
};

});

parcelRegister("fSjll", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3d2125bcfbad4a4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d3d2125bcfbad4a4$var$LazyExternalImport = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("2MV25")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/admin-pages/external-import/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d3d2125bcfbad4a4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d3d2125bcfbad4a4$var$LazyExternalImport,
        pageId: "external-import-general",
        shouldShowSpinner: false
    });

});
parcelRegister("2MV25", function(module, exports) {

let $207c4df21acf34d2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $207c4df21acf34d2$var$load("7vqGd"),
    $207c4df21acf34d2$var$load("1Y4bq"),
    $207c4df21acf34d2$var$load("fAbxa"),
    $207c4df21acf34d2$var$load("1VRB2"),
    $207c4df21acf34d2$var$load("bABhq"),
    $207c4df21acf34d2$var$load("goEM7")
]).then(()=>parcelRequire('daUrk'));

});



parcelRegister("czFX6", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRedirectRouteEntry", () => $f769615681996eec$export$41fb3f2a3e68c7c3);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $jBMV2 = parcelRequire("jBMV2");

var $9NmsS = parcelRequire("9NmsS");

var $2mMik = parcelRequire("2mMik");

var $iMFdk = parcelRequire("iMFdk");

var $alJZi = parcelRequire("alJZi");
const $f769615681996eec$export$41fb3f2a3e68c7c3 = (0, $6xToB.createEntry)((0, $2mMik.filtersDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $jBMV2.filtersDirectoryResource)
        ],
        component: !false ? (0, $alJZi.FiltersDirectoryRedirect) : (0, $alJZi.FiltersDirectoryComponent),
        skeleton: (0, $iMFdk.FiltersDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).FILTERS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $alJZi.LazyFiltersDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("jBMV2", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryResource", () => $f1677d54c5a99941$export$53f99086c62225b6);

var $cJYBV = parcelRequire("cJYBV");

var $l1VxS = parcelRequire("l1VxS");


const $f1677d54c5a99941$export$53f99086c62225b6 = (0, $l1VxS.createResource)({
    type: (0, $7a54c23c1a218244$export$79e191bf6cb15284),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("aDeHu")),
    maxAge: (0, $cJYBV.MIN_MAX_AGE)
});

});
const $7a54c23c1a218244$export$79e191bf6cb15284 = 'FILTERS_DIRECTORY';

parcelRegister("aDeHu", function(module, exports) {

let $7bd8f31f75f02df4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7bd8f31f75f02df4$var$load("8Quk8").then(()=>parcelRequire('1hTxv'));

});


parcelRegister("2mMik", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRedirectRoute", () => $b7c4dec64890edd4$export$f4f86e1ddc30a625);
const $b7c4dec64890edd4$export$f4f86e1ddc30a625 = {
    name: 'filters-directory-redirect',
    path: '/ManageFilters.jspa'
};

});

parcelRegister("alJZi", function(module, exports) {

$parcel$export(module.exports, "FiltersDirectoryRedirect", () => $d2566f6145a43912$export$c56e739d3bb1fe19);
$parcel$export(module.exports, "LazyFiltersDirectory", () => $d2566f6145a43912$export$cc133cd5c6f1b69d);
$parcel$export(module.exports, "FiltersDirectoryComponent", () => $d2566f6145a43912$export$e5d735e83dacb7c7);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");
const $d2566f6145a43912$export$c56e739d3bb1fe19 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/filters"
    });

const $d2566f6145a43912$export$cc133cd5c6f1b69d = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("e70zF"))), {
    moduleId: "./src/packages/spa-apps/directories/filters/src/index.tsx"
});
const $d2566f6145a43912$export$e5d735e83dacb7c7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d2566f6145a43912$export$cc133cd5c6f1b69d,
        pageId: "filters-directory",
        shouldShowSpinner: false
    });

});
parcelRegister("e70zF", function(module, exports) {

let $a4622a2731044554$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $a4622a2731044554$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $a4622a2731044554$var$load("deNlq")
        ]);
    }),
    $a4622a2731044554$var$load("7vqGd"),
    $a4622a2731044554$var$load("1Y4bq"),
    $a4622a2731044554$var$load("1VRB2"),
    $a4622a2731044554$var$load("bABhq"),
    $a4622a2731044554$var$load("l12iP")
]).then(()=>parcelRequire('8vvws'));

});



parcelRegister("keKPA", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRouteEntry", () => $5b102addf0af494c$export$ca77bc660994f51f);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $jBMV2 = parcelRequire("jBMV2");

var $9NmsS = parcelRequire("9NmsS");

var $bxSuo = parcelRequire("bxSuo");

var $iMFdk = parcelRequire("iMFdk");

var $alJZi = parcelRequire("alJZi");
const $5b102addf0af494c$export$ca77bc660994f51f = (0, $6xToB.createEntry)((0, $bxSuo.filtersDirectoryRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $jBMV2.filtersDirectoryResource)
        ],
        component: (0, $alJZi.FiltersDirectoryComponent),
        skeleton: (0, $iMFdk.FiltersDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).FILTERS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $alJZi.LazyFiltersDirectory)
        ],
        supportsPreviewPanel: true
    }));

});

parcelRegister("437TO", function(module, exports) {

$parcel$export(module.exports, "findAppsRouteEntry", () => $5c14761a914993f2$export$422f564c9c56a4f8);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $63mGD = parcelRequire("63mGD");

var $ixFkc = parcelRequire("ixFkc");
const $5c14761a914993f2$export$422f564c9c56a4f8 = (0, $6xToB.createEntry)((0, $63mGD.findAppsRoute), ()=>({
        group: 'marketplace',
        component: (0, $ixFkc.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $gKFn0.default)
        },
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ixFkc.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace'
    }));

});
parcelRegister("63mGD", function(module, exports) {

$parcel$export(module.exports, "findAppsRoute", () => $6ffd6d796f0895d5$export$e264ef643451c60a);
const $6ffd6d796f0895d5$export$e264ef643451c60a = {
    name: 'marketplace-index',
    path: '/jira/marketplace'
};

});


parcelRegister("6HVt9", function(module, exports) {

$parcel$export(module.exports, "forgeAdminRouteEntry", () => $c768b8f60c08a6f3$export$9e57f00c65d37e11);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $dJrIK = parcelRequire("dJrIK");

var $bwe90 = parcelRequire("bwe90");
const $c768b8f60c08a6f3$export$9e57f00c65d37e11 = (0, $6xToB.createEntry)((0, $dJrIK.forgeAdminRoute), ()=>({
        component: (0, $bwe90.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $gKFn0.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bwe90.LazyForgeAdminPage)
        ]
    }));

});
parcelRegister("dJrIK", function(module, exports) {

$parcel$export(module.exports, "forgeAdminRoute", () => $86cbf649ecb40238$export$157f97e6454c2a9f);
const $86cbf649ecb40238$export$157f97e6454c2a9f = {
    name: 'forge-spa-admin',
    path: '/jira/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("bwe90", function(module, exports) {

$parcel$export(module.exports, "LazyForgeAdminPage", () => $fdaa0f262cc8cd3b$export$66ee65dcd4a6458d);
$parcel$export(module.exports, "default", () => $fdaa0f262cc8cd3b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $fdaa0f262cc8cd3b$export$66ee65dcd4a6458d = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("Rxr2l")), {
    moduleId: "./src/packages/spa-apps/forge/admin/src/index.tsx"
});
const $fdaa0f262cc8cd3b$export$c9e5f500ef472147 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fdaa0f262cc8cd3b$export$66ee65dcd4a6458d,
        pageId: "forge-spa-admin",
        shouldShowSpinner: true
    });
var $fdaa0f262cc8cd3b$export$2e2bcd8739ae039 = $fdaa0f262cc8cd3b$export$c9e5f500ef472147;

});
parcelRegister("Rxr2l", function(module, exports) {

let $0a0ee2dc8fa81b0c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0a0ee2dc8fa81b0c$var$load("6M4lq").then(()=>parcelRequire('fKvyc'));

});



parcelRegister("7RQxY", function(module, exports) {

$parcel$export(module.exports, "forgeAdminSettingsRouteEntry", () => $18283900414ceb01$export$ea8439aa1b4afbb2);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $jWLr7 = parcelRequire("jWLr7");

var $bwe90 = parcelRequire("bwe90");
const $18283900414ceb01$export$ea8439aa1b4afbb2 = (0, $6xToB.createEntry)((0, $jWLr7.forgeAdminSettingsRoute), ()=>({
        component: (0, $bwe90.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $gKFn0.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bwe90.LazyForgeAdminPage)
        ]
    }));

});
parcelRegister("jWLr7", function(module, exports) {

$parcel$export(module.exports, "forgeAdminSettingsRoute", () => $fbbfaf5995f770ab$export$392534a80a0b9b11);
const $fbbfaf5995f770ab$export$392534a80a0b9b11 = {
    name: 'forge-spa-admin-settings',
    path: '/jira/settings/apps/:settingsType(configure|get-started)/:appId/:envId/:route?'
};

});


parcelRegister("5ZQVr", function(module, exports) {

$parcel$export(module.exports, "forgeFieldContextualConfigurationRouteEntry", () => $28fbac4ae560480e$export$425186ecf36e93c);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $gZbmE = parcelRequire("gZbmE");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $6aUfx = parcelRequire("6aUfx");

var $kf1MW = parcelRequire("kf1MW");
const $28fbac4ae560480e$export$425186ecf36e93c = (0, $6xToB.createEntry)((0, $6aUfx.forgeFieldContextualConfigurationRoute), ()=>({
        component: (0, $kf1MW.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $hHbzj.forgeCustomFieldTypeResource),
            (0, $gZbmE.fieldContextConfigPageResource),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kf1MW.LazyForgeFieldContextConfigPage)
        ]
    }));

});
parcelRegister("8XpuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $69f3a4d32478eb00$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $69f3a4d32478eb00$var$LazyGlobalIssuesSettingsSidebar = (0, $gzcjr.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("cXq1j")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-issues/src/index.tsx"
});
const $69f3a4d32478eb00$var$GlobalIssuesSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalIssuesSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69f3a4d32478eb00$var$LazyGlobalIssuesSettingsSidebar, null)));
var $69f3a4d32478eb00$export$2e2bcd8739ae039 = $69f3a4d32478eb00$var$GlobalIssuesSettingsSidebar;

});
parcelRegister("cXq1j", function(module, exports) {

let $96ef2dc7989bee74$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $96ef2dc7989bee74$var$load("1VRB2"),
    $96ef2dc7989bee74$var$load("bABhq"),
    $96ef2dc7989bee74$var$load("7ejIY")
]).then(()=>parcelRequire('jlQix'));

});


parcelRegister("gZbmE", function(module, exports) {

$parcel$export(module.exports, "fieldContextConfigPageResource", () => $daea4e0f7e27674b$export$686a607053a18611);

var $l1VxS = parcelRequire("l1VxS");


const $daea4e0f7e27674b$export$686a607053a18611 = (0, $l1VxS.createResource)({
    type: (0, $cf50a866b7d0e879$export$4b80522d38222ad),
    getKey: ()=>'data',
    getDataLoader: ()=>(parcelRequire("aYm1R")),
    maxAge: 5000
});

});
const $cf50a866b7d0e879$export$4b80522d38222ad = 'FORGE_FIELD_CONTEXTUAL_CONFIG';

parcelRegister("aYm1R", function(module, exports) {

let $7fd0987ea45dcf59$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7fd0987ea45dcf59$var$load("8MJ9L").then(()=>parcelRequire('khZod'));

});


parcelRegister("6aUfx", function(module, exports) {

$parcel$export(module.exports, "forgeFieldContextualConfigurationRoute", () => $a35ead35515b7f91$export$2ee4468dd8e9636f);
const $a35ead35515b7f91$export$2ee4468dd8e9636f = {
    name: 'forge-spa-field-context-config',
    path: '/jira/settings/issues/field/:fieldId/context/:contextId/configure/app'
};

});

parcelRegister("kf1MW", function(module, exports) {

$parcel$export(module.exports, "LazyForgeFieldContextConfigPage", () => $8e1e953397428d8f$export$c53e206c7fd6fb76);
$parcel$export(module.exports, "default", () => $8e1e953397428d8f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $8e1e953397428d8f$export$c53e206c7fd6fb76 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("ckjiH")), {
    moduleId: "./src/packages/spa-apps/forge/field-contextual-config/src/index.tsx"
});
const $8e1e953397428d8f$export$50bd0baee0b2f946 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8e1e953397428d8f$export$c53e206c7fd6fb76,
        pageId: "forge-spa-field-context-config",
        shouldShowSpinner: true
    });
var $8e1e953397428d8f$export$2e2bcd8739ae039 = $8e1e953397428d8f$export$50bd0baee0b2f946;

});
parcelRegister("ckjiH", function(module, exports) {

let $8f9652fe7cd6ed05$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8f9652fe7cd6ed05$var$load("8CT5U").then(()=>parcelRequire('6Tbkh'));

});



parcelRegister("1PFei", function(module, exports) {

$parcel$export(module.exports, "forgeGlobalRouteEntry", () => $0b2b5957b5ab469d$export$68b00eede5bc25e6);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $fzU9D = parcelRequire("fzU9D");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $fXVLW = parcelRequire("fXVLW");

var $fkt3o = parcelRequire("fkt3o");
const $0b2b5957b5ab469d$export$68b00eede5bc25e6 = (0, $6xToB.createEntry)((0, $fXVLW.forgeGlobalRoute), ()=>({
        component: (0, $fkt3o.default),
        layout: (0, $6dwgv.createLayout)(),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $fzU9D.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationForgeGlobalPageResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fkt3o.LazyForgeGlobalPage)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("fzU9D", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf0326ad75688b34$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $bf0326ad75688b34$var$LazyForPaintForgeGlobalPageSidebar = (0, $gzcjr.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("drpSO")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/forge-global-page/src/index.tsx"
});
const $bf0326ad75688b34$var$ForgeGlobalPageSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "forgeGlobalPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf0326ad75688b34$var$LazyForPaintForgeGlobalPageSidebar, null)));
$bf0326ad75688b34$var$ForgeGlobalPageSidebar.displayName = 'ForgeGlobalPageSidebar';
var $bf0326ad75688b34$export$2e2bcd8739ae039 = $bf0326ad75688b34$var$ForgeGlobalPageSidebar;

});
parcelRegister("drpSO", function(module, exports) {

let $9c91dfcaaae317f3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $9c91dfcaaae317f3$var$load("1VRB2"),
    $9c91dfcaaae317f3$var$load("bABhq"),
    $9c91dfcaaae317f3$var$load("6g5Jr")
]).then(()=>parcelRequire('46KFl'));

});


parcelRegister("fXVLW", function(module, exports) {

$parcel$export(module.exports, "forgeGlobalRoute", () => $d37f9dc9fdd24009$export$4146dba061d1c72d);
const $d37f9dc9fdd24009$export$4146dba061d1c72d = {
    name: 'forge-spa-global',
    path: '/jira/apps/:appId/:envId/:route?'
};

});

parcelRegister("fkt3o", function(module, exports) {

$parcel$export(module.exports, "LazyForgeGlobalPage", () => $42640cb09091dc2b$export$332293feb5cffd72);
$parcel$export(module.exports, "default", () => $42640cb09091dc2b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $42640cb09091dc2b$export$332293feb5cffd72 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("eWeSI")), {
    moduleId: "./src/packages/spa-apps/forge/global/src/index.tsx"
});
const $42640cb09091dc2b$export$4c36a7b018e5e5cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $42640cb09091dc2b$export$332293feb5cffd72,
        pageId: "forge-spa-global",
        shouldShowSpinner: true
    });
var $42640cb09091dc2b$export$2e2bcd8739ae039 = $42640cb09091dc2b$export$4c36a7b018e5e5cc;

});
parcelRegister("eWeSI", function(module, exports) {

let $ae02069d1e194704$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ae02069d1e194704$var$load("fCATF").then(()=>parcelRequire('1J3S4'));

});



parcelRegister("11NnB", function(module, exports) {

$parcel$export(module.exports, "forgePersonalSettingsRouteEntry", () => $644ab9063c66de4e$export$bcf4a0e471a2493d);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $eaZMD = parcelRequire("eaZMD");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $2e4qA = parcelRequire("2e4qA");

var $azbTY = parcelRequire("azbTY");
const $644ab9063c66de4e$export$bcf4a0e471a2493d = (0, $6xToB.createEntry)((0, $2e4qA.forgePersonalSettingsRoute), ()=>({
        component: (0, $azbTY.default),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PROFILE,
            sidebar: (0, $eaZMD.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $azbTY.LazyForgePersonalSettingsPage)
        ]
    }));

});
parcelRegister("2e4qA", function(module, exports) {

$parcel$export(module.exports, "forgePersonalSettingsRoute", () => $9d2b8bb79f84d5f0$export$8cf022892f01dc88);
const $9d2b8bb79f84d5f0$export$8cf022892f01dc88 = {
    name: 'forge-spa-personal-settings',
    path: '/jira/settings/personal/apps/:appId/:envId/:route?'
};

});

parcelRegister("azbTY", function(module, exports) {

$parcel$export(module.exports, "LazyForgePersonalSettingsPage", () => $3a0226e7a1a791e6$export$984c6340ff981792);
$parcel$export(module.exports, "default", () => $3a0226e7a1a791e6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $3a0226e7a1a791e6$export$984c6340ff981792 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("j4Vc0")), {
    moduleId: "./src/packages/spa-apps/forge/personal-settings/src/index.tsx"
});
const $3a0226e7a1a791e6$export$fb659fde7fa91075 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3a0226e7a1a791e6$export$984c6340ff981792,
        pageId: "forge-spa-personal-settings",
        shouldShowSpinner: true
    });
var $3a0226e7a1a791e6$export$2e2bcd8739ae039 = $3a0226e7a1a791e6$export$fb659fde7fa91075;

});
parcelRegister("j4Vc0", function(module, exports) {

let $de3ac15274203bce$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $de3ac15274203bce$var$load("jYV9F").then(()=>parcelRequire('cJxZP'));

});



parcelRegister("gRPtE", function(module, exports) {

$parcel$export(module.exports, "forgeProjectRouteEntry", () => $390fd685a1011595$export$1ed77617605af86d);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $bTfc4 = parcelRequire("bTfc4");

var $1tU1R = parcelRequire("1tU1R");

var $jDBnR = parcelRequire("jDBnR");
const $390fd685a1011595$export$1ed77617605af86d = (0, $6xToB.createEntry)((0, $1tU1R.forgeProjectRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            ...(0, $1PvPk.getServiceDeskSharedNavigationSingleResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $dZRaT.projectContextResourceWithCache),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $jDBnR.forgeProjectPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("1tU1R", function(module, exports) {

$parcel$export(module.exports, "forgeProjectRoute", () => $a297ebf60add814e$export$998d01fc8f4c3224);
const $a297ebf60add814e$export$998d01fc8f4c3224 = {
    name: 'forge-spa-project',
    path: '/jira/:projectType(software|software/c|core)/projects/:projectKey/apps/:appId/:envId/:route?'
};

});

parcelRegister("jDBnR", function(module, exports) {

$parcel$export(module.exports, "forgeProjectPageEntrypoint", () => $59eba036dbc12336$export$74e6ff15060a7efe);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9OhlI = parcelRequire("9OhlI");

var $9n5I0 = parcelRequire("9n5I0");
const $59eba036dbc12336$export$74e6ff15060a7efe = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9OhlI.forgeProjectEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("9OhlI", function(module, exports) {

$parcel$export(module.exports, "forgeProjectEntrypoint", () => $eccabc7b5ea24861$export$109bb60f5ed960e9);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $eccabc7b5ea24861$export$109bb60f5ed960e9 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("28ikr")), {
        moduleId: "a42399f5",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                match: context.match
            }
        })
});

});
parcelRegister("28ikr", function(module, exports) {

let $18da8bcde79ac43f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $18da8bcde79ac43f$var$load("bEZ3C").then(()=>parcelRequire('eDZUG'));

});




parcelRegister("4xmZV", function(module, exports) {

$parcel$export(module.exports, "forgeProjectServicedeskRouteEntry", () => $a4349ddee4ad74de$export$6732bea56e68d0b4);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $bTfc4 = parcelRequire("bTfc4");

var $34SPF = parcelRequire("34SPF");

var $89EYK = parcelRequire("89EYK");
const $a4349ddee4ad74de$export$6732bea56e68d0b4 = (0, $6xToB.createEntry)((0, $34SPF.forgeProjectServicedeskRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSharedNavigationSingleResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $dZRaT.projectContextResourceWithCache),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $89EYK.forgeProjectServicedeskPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("34SPF", function(module, exports) {

$parcel$export(module.exports, "forgeProjectServicedeskRoute", () => $fcae3112c20bfc77$export$8b83928f9f21e11);
const $fcae3112c20bfc77$export$8b83928f9f21e11 = {
    name: 'forge-spa-project-servicedesk',
    path: '/jira/:projectType(servicedesk)/projects/:projectKey/apps/:appId/:envId/:route?'
};

});

parcelRegister("89EYK", function(module, exports) {

$parcel$export(module.exports, "forgeProjectServicedeskPageEntrypoint", () => $f2f8c0e8c5c9b8ab$export$eae71fd9c3e0166a);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9OhlI = parcelRequire("9OhlI");
const $f2f8c0e8c5c9b8ab$export$eae71fd9c3e0166a = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9OhlI.forgeProjectEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});


parcelRegister("bv6P6", function(module, exports) {

$parcel$export(module.exports, "forgeServicedeskQueueRouteEntry", () => $17a924e571fb638f$export$1486fc4f85c1237);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $dpkla = parcelRequire("dpkla");

var $aQoXd = parcelRequire("aQoXd");

var $034mL = parcelRequire("034mL");
const $17a924e571fb638f$export$1486fc4f85c1237 = (0, $6xToB.createEntry)((0, $dpkla.forgeServicedeskQueueRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $034mL.forgeServiceDeskQueuePageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("dpkla", function(module, exports) {

$parcel$export(module.exports, "forgeServicedeskQueueRoute", () => $6fe3936aea0f5c85$export$b77275b989ab42a6);
const $6fe3936aea0f5c85$export$b77275b989ab42a6 = {
    name: 'forge-spa-servicedesk-queue',
    path: '/jira/servicedesk/projects/:projectKey/queues/apps/:appId/:envId/:route?'
};

});

parcelRegister("034mL", function(module, exports) {

$parcel$export(module.exports, "forgeServiceDeskQueuePageEntrypoint", () => $2985510ba8e89b49$export$e50db2ee9d53508e);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $bkUuj = parcelRequire("bkUuj");
const $2985510ba8e89b49$export$e50db2ee9d53508e = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $bkUuj.forgeServiceDeskEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("bkUuj", function(module, exports) {

$parcel$export(module.exports, "forgeServiceDeskEntrypoint", () => $54fbdd32032aa554$export$5f56161124a4cb21);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $54fbdd32032aa554$export$5f56161124a4cb21 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("3knq0")), {
        moduleId: "70dc4c33",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3knq0", function(module, exports) {

let $26c567c5c05998df$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $26c567c5c05998df$var$load("jvkIi").then(()=>parcelRequire('f9hBa'));

});




parcelRegister("lGtFG", function(module, exports) {

$parcel$export(module.exports, "generalPersonalSettingsRouteEntry", () => $87150ee752e36ecd$export$e8b7e9281fc3db35);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $eaZMD = parcelRequire("eaZMD");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $4wyu4 = parcelRequire("4wyu4");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $2hhQE = parcelRequire("2hhQE");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $87150ee752e36ecd$var$LazyGeneralPersonalSettings = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("dYY8Q"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings/general/src/index.tsx"
});
const $87150ee752e36ecd$var$GeneralPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $87150ee752e36ecd$var$LazyGeneralPersonalSettings,
        pageId: "personal-settings-general",
        shouldShowSpinner: true
    });
const $87150ee752e36ecd$export$e8b7e9281fc3db35 = (0, $6xToB.createEntry)((0, $4wyu4.generalPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: $87150ee752e36ecd$var$GeneralPersonalSettingsComponent,
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PROFILE,
            sidebar: (0, $eaZMD.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $2hhQE.getLabsResources)(),
            ...(0, $hHbzj.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $87150ee752e36ecd$var$LazyGeneralPersonalSettings
        ]
    }));

});
parcelRegister("4wyu4", function(module, exports) {

$parcel$export(module.exports, "generalPersonalSettingsRoute", () => $15328041019aaf7d$export$7a6c9715a86f906b);
const $15328041019aaf7d$export$7a6c9715a86f906b = {
    name: 'personal-settings-general',
    path: '/jira/settings/personal/general'
};

});

parcelRegister("2hhQE", function(module, exports) {

$parcel$export(module.exports, "getLabsResources", () => $cf2fc41aa5d1a754$export$18345571aa12a367);

var $igNUx = parcelRequire("igNUx");

var $5zQIb = parcelRequire("5zQIb");

var $b8mPY = parcelRequire("b8mPY");

var $5L7qx = parcelRequire("5L7qx");
const $cf2fc41aa5d1a754$export$18345571aa12a367 = ()=>[
        (0, $5zQIb.newIssueViewTransitionLockInStatusResource),
        (0, $5L7qx.resourceWithCondition2)(()=>!(0, $igNUx.isFedRamp)(), (0, $b8mPY.nextBestTaskFeatureResource))
    ];

});

parcelRegister("dYY8Q", function(module, exports) {

let $a2df87d188570b84$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a2df87d188570b84$var$load("lQIOU").then(()=>parcelRequire('1QmuW'));

});


parcelRegister("ilnMG", function(module, exports) {

$parcel$export(module.exports, "globalEscalationsRouteEntry", () => $62f604aabcc4e3aa$export$adde4536d8e5f94c);

var $eJOHy = parcelRequire("eJOHy");

var $4VYk1 = parcelRequire("4VYk1");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $9m8pQ = parcelRequire("9m8pQ");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $62f604aabcc4e3aa$var$LazyGlobalEscalations = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("kh4gE")).then((module)=>module.GlobalEscalationsPage), {
    moduleId: "./src/packages/eoc/global-escalations/src/index.tsx"
});
const $62f604aabcc4e3aa$var$GlobalEscalationsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $62f604aabcc4e3aa$var$LazyGlobalEscalations,
        pageId: "async-jira-eoc-global-escalations",
        shouldShowSpinner: false
    });
const $62f604aabcc4e3aa$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $62f604aabcc4e3aa$export$adde4536d8e5f94c = (0, $6xToB.createEntry)((0, $9m8pQ.globalEscalationsRoute), ()=>({
        group: 'eoc',
        component: $62f604aabcc4e3aa$var$GlobalEscalationsComponent,
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VYk1.globalEscalationsListInfoResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$62f604aabcc4e3aa$var$getNavigationSpecifications()
        },
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            $62f604aabcc4e3aa$var$LazyGlobalEscalations
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            $62f604aabcc4e3aa$var$LazyGlobalEscalations
        ]
    }));

});
parcelRegister("4VYk1", function(module, exports) {

$parcel$export(module.exports, "globalEscalationsListInfoResource", () => $d94227b091e4538c$export$bffddc002dadaf3a);

var $l1VxS = parcelRequire("l1VxS");

var $irNBW = parcelRequire("irNBW");
const $d94227b091e4538c$export$bffddc002dadaf3a = (0, $l1VxS.createResource)({
    type: 'globalEscalationsListInfoResource',
    getKey: ()=>'globalEscalationsListInfoResource',
    getData: (0, $irNBW.getListInfo),
    isBrowserOnly: true
});

});
parcelRegister("irNBW", function(module, exports) {

$parcel$export(module.exports, "getEscalations", () => $980ce136312c36fd$export$300727380b60aeb4);
$parcel$export(module.exports, "getListInfo", () => $980ce136312c36fd$export$bdc8fe7d9cd263b);

var $br21R = parcelRequire("br21R");
const $980ce136312c36fd$export$300727380b60aeb4 = ({ lastEvaluatedToken: lastEvaluatedToken, queryKey: queryKey })=>{
    const [, filtersString] = queryKey;
    const filters = JSON.parse(filtersString);
    const params = new URLSearchParams({
        ...filters,
        lastEvaluatedToken: lastEvaluatedToken
    });
    return (0, $br21R.eocFetch)(`/v1/escalations/search?${params.toString()}`);
};
const $980ce136312c36fd$export$bdc8fe7d9cd263b = ()=>{
    return (0, $br21R.eocFetch)('/v1/escalations/list-info');
};

});


parcelRegister("9m8pQ", function(module, exports) {

$parcel$export(module.exports, "globalEscalationsRoute", () => $1d1c75ae70e67e71$export$9ed12f6fa845edfb);
const $1d1c75ae70e67e71$export$9ed12f6fa845edfb = {
    name: 'eoc-global-escalations',
    path: '/jira/settings/products/ops/escalation-policies',
    exact: true
};

});

parcelRegister("kh4gE", function(module, exports) {

let $ec28b4a68c8450d3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ec28b4a68c8450d3$var$load("1VRB2"),
    $ec28b4a68c8450d3$var$load("bABhq"),
    $ec28b4a68c8450d3$var$load("jHURK")
]).then(()=>parcelRequire('8KP6j'));

});


parcelRegister("3baNr", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallDetailRouteEntry", () => $f08f7ccd78bddc66$export$39f40714591c98c0);

var $eJOHy = parcelRequire("eJOHy");

var $7tCYE = parcelRequire("7tCYE");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $7ZvEb = parcelRequire("7ZvEb");

var $1F9cm = parcelRequire("1F9cm");

var $3BFKs = parcelRequire("3BFKs");
const $f08f7ccd78bddc66$var$IncomingCallDetail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $3BFKs.LazyIncomingCallDetail),
        pageId: "async-jira-eoc-incoming-call-detail",
        shouldShowSpinner: false
    });
const $f08f7ccd78bddc66$export$39f40714591c98c0 = (0, $6xToB.createEntry)((0, $7ZvEb.globalIncomingCallDetailRoute), ()=>({
        group: 'eoc',
        component: $f08f7ccd78bddc66$var$IncomingCallDetail,
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $7tCYE.detailResources)()
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3BFKs.LazyIncomingCall)
        ]
    }));

});
parcelRegister("7tCYE", function(module, exports) {

$parcel$export(module.exports, "listResources", () => $8c7ce4e58155aa4c$export$c83d9fd41123ab31);
$parcel$export(module.exports, "detailResources", () => $8c7ce4e58155aa4c$export$63630293105c0f4e);

var $fm4we = parcelRequire("fm4we");

var $1HXBr = parcelRequire("1HXBr");
const $8c7ce4e58155aa4c$export$c83d9fd41123ab31 = ()=>[
        (0, $1HXBr.listResource)
    ];
const $8c7ce4e58155aa4c$export$63630293105c0f4e = ()=>[
        (0, $fm4we.detailResource)
    ];

});
parcelRegister("fm4we", function(module, exports) {

$parcel$export(module.exports, "detailResource", () => $bfc9777f9fac1573$export$13d78d45f8054f1e);

var $l1VxS = parcelRequire("l1VxS");

var $feIEW = parcelRequire("feIEW");
var $jXKdt = parcelRequire("jXKdt");

var $j1cDm = parcelRequire("j1cDm");
const $bfc9777f9fac1573$export$13d78d45f8054f1e = (0, $l1VxS.createResource)({
    type: 'getDetailResource',
    getKey: ()=>'getDetailResource',
    getData: async (routerContext)=>{
        const id = routerContext.match.params?.id;
        (0, $feIEW.assert)(!!id, new (0, $jXKdt.AssertionError)('detailResource', 'id should be set to fetch incoming call detail'));
        return (0, $j1cDm.getDetail)(id);
    },
    isBrowserOnly: true
});

});
parcelRegister("j1cDm", function(module, exports) {

$parcel$export(module.exports, "getDetail", () => $bf09d6b643276824$export$d6c3faeb2ce9d297);

var $br21R = parcelRequire("br21R");

var $2CsZ9 = parcelRequire("2CsZ9");
const $bf09d6b643276824$export$d6c3faeb2ce9d297 = (id)=>{
    const endpoint = `${(0, $2CsZ9.urls).incomingCall.detail.url(id)}`;
    return (0, $br21R.eocFetch)(endpoint);
};

});
parcelRegister("2CsZ9", function(module, exports) {

$parcel$export(module.exports, "urls", () => $40f9bb366151d97b$export$bcae9ba627f604b6);
const $40f9bb366151d97b$export$bcae9ba627f604b6 = Object.freeze({
    incomingCall: {
        url: ()=>`/v1/incoming-call`,
        detail: {
            url: (incomingCallId = ':incomingCallId')=>`${$40f9bb366151d97b$export$bcae9ba627f604b6.incomingCall.url()}/${incomingCallId}`
        }
    }
});

});



parcelRegister("1HXBr", function(module, exports) {

$parcel$export(module.exports, "listResource", () => $832d0e8664fe972d$export$5ee018e9baf9d633);

var $bWxTm = parcelRequire("bWxTm");

var $fmCm9 = parcelRequire("fmCm9");
const $832d0e8664fe972d$export$5ee018e9baf9d633 = (0, $bWxTm.createPaginatedResource)({
    type: 'getListResource',
    getKey: ()=>'getListResource',
    getData: ()=>(0, $fmCm9.getList),
    isBrowserOnly: true
});

});
parcelRegister("bWxTm", function(module, exports) {

$parcel$export(module.exports, "createPaginatedResource", () => $7a08ec2747e36723$export$561b032e4d26d1e8);

var $l1VxS = parcelRequire("l1VxS");
const $7a08ec2747e36723$export$561b032e4d26d1e8 = ({ getData: getData, getKey: getKey, ...arg })=>{
    return (0, $l1VxS.createResource)({
        ...arg,
        getKey: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = query['page'] || '1';
            const key = `${getKey(routerContext, customContext)}#${page}`;
            return key;
        },
        getData: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = parseInt(query['page']) || 1;
            return getData(routerContext, customContext)({
                page: page
            });
        }
    });
};

});

parcelRegister("fmCm9", function(module, exports) {

$parcel$export(module.exports, "getList", () => $6779bbb116c13d6e$export$73fffd6dda5144e);
$parcel$export(module.exports, "addIncomingCall", () => $6779bbb116c13d6e$export$cdae09ff00c893b2);

var $br21R = parcelRequire("br21R");

var $2CsZ9 = parcelRequire("2CsZ9");
const $6779bbb116c13d6e$export$73fffd6dda5144e = ({ page: page })=>{
    const limit = 20;
    const offset = (page - 1) * limit;
    const params = new URLSearchParams({
        offset: `${offset}`,
        limit: `${limit}`,
        sortBy: 'name',
        sort: 'asc'
    });
    const endpoint = `${(0, $2CsZ9.urls).incomingCall.url()}?${params.toString()}`;
    return (0, $br21R.eocFetch)(endpoint).then(({ data: data, count: count })=>{
        return {
            data: data,
            count: Math.ceil(count / limit)
        };
    });
};
const $6779bbb116c13d6e$export$cdae09ff00c893b2 = (params)=>{
    return (0, $br21R.eocFetch)((0, $2CsZ9.urls).incomingCall.url(), {
        method: 'POST',
        body: params
    });
};

});



parcelRegister("7ZvEb", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallDetailRoute", () => $54aa78d434702576$export$10f19333da6ac52c);
const $54aa78d434702576$export$10f19333da6ac52c = {
    name: 'eoc-incoming-call-detail',
    path: '/jira/settings/products/ops/incoming-call/:id',
    exact: true
};

});

parcelRegister("3BFKs", function(module, exports) {

$parcel$export(module.exports, "LazyIncomingCall", () => $e5362cebd43bef8f$export$d76e6607b7e88a7b);
$parcel$export(module.exports, "LazyIncomingCallDetail", () => $e5362cebd43bef8f$export$1c56f2b1fdd5d724);

var $gzcjr = parcelRequire("gzcjr");

const $e5362cebd43bef8f$export$d76e6607b7e88a7b = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("e5H3y")).then((module)=>module.IncomingCallPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});

const $e5362cebd43bef8f$export$1c56f2b1fdd5d724 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("e5H3y")).then((module)=>module.IncomingCallDetailPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});

});
parcelRegister("e5H3y", function(module, exports) {

let $a422ee62499cead8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $a422ee62499cead8$var$load("1VRB2"),
    $a422ee62499cead8$var$load("bABhq"),
    $a422ee62499cead8$var$load("5ralW")
]).then(()=>parcelRequire('d2zX5'));

});



parcelRegister("fuBQx", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallRouteEntry", () => $f970485e84ffcf64$export$bf8ccc758901febd);

var $eJOHy = parcelRequire("eJOHy");

var $7tCYE = parcelRequire("7tCYE");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $iRfwO = parcelRequire("iRfwO");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $95K6m = parcelRequire("95K6m");

var $1F9cm = parcelRequire("1F9cm");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $3BFKs = parcelRequire("3BFKs");
const $f970485e84ffcf64$var$IncomingCall = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $3BFKs.LazyIncomingCall),
        pageId: "async-jira-eoc-incoming-call",
        shouldShowSpinner: false
    });
const $f970485e84ffcf64$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $f970485e84ffcf64$export$bf8ccc758901febd = (0, $6xToB.createEntry)((0, $95K6m.globalIncomingCallRoute), ()=>({
        group: 'eoc',
        component: $f970485e84ffcf64$var$IncomingCall,
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $7tCYE.listResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$f970485e84ffcf64$var$getNavigationSpecifications()
        },
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3BFKs.LazyIncomingCall)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3BFKs.LazyIncomingCall)
        ]
    }));

});
parcelRegister("95K6m", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallRoute", () => $b6754300df67400a$export$8dd2e8adca05d8a3);
const $b6754300df67400a$export$8dd2e8adca05d8a3 = {
    name: 'eoc-incoming-call',
    path: '/jira/settings/products/ops/incoming-call',
    exact: true
};

});


parcelRegister("4Bcd1", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationCreateRouteEntry", () => $4da23ddd245f4fa9$export$62eef9a2917f041f);

var $lTVHD = parcelRequire("lTVHD");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $8ivmo = parcelRequire("8ivmo");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $9bIMK = parcelRequire("9bIMK");

var $cbgXG = parcelRequire("cbgXG");

var $h5q0o = parcelRequire("h5q0o");
const $4da23ddd245f4fa9$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $4da23ddd245f4fa9$export$62eef9a2917f041f = (0, $6xToB.createEntry)((0, $8ivmo.globalIntegrationCreateRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $9bIMK.IntegrationAutomation),
        slot: (0, $cbgXG.IntegrationCreate),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $lTVHD.resources).configuredIntegrationsResource,
            (0, $lTVHD.resources).integrationListResource,
            (0, $lTVHD.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$4da23ddd245f4fa9$var$getNavigationSpecifications()
        },
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("lTVHD", function(module, exports) {

$parcel$export(module.exports, "resources", () => $9944f34cb79d3a2f$export$bc99aaabaf7b70a7);

var $lS8rY = parcelRequire("lS8rY");

var $2TDCv = parcelRequire("2TDCv");

var $3ZcWr = parcelRequire("3ZcWr");
const $9944f34cb79d3a2f$export$bc99aaabaf7b70a7 = {
    configuredIntegrationsResource: $lS8rY.configuredIntegrationsResource,
    integrationListResource: $2TDCv.integrationListResource,
    userAccessRightsResource: $3ZcWr.userAccessRightsResource
};

});
parcelRegister("lS8rY", function(module, exports) {

$parcel$export(module.exports, "configuredIntegrationsResource", () => $3e3ea67a32d3bc44$export$4136019b80be5917);

var $l1VxS = parcelRequire("l1VxS");

var $7M2yQ = parcelRequire("7M2yQ");

var $cF4Qy = parcelRequire("cF4Qy");

const $3e3ea67a32d3bc44$export$4136019b80be5917 = (0, $l1VxS.createResource)({
    type: 'configuredIntegrationsResource',
    getKey: ({ query: query, match: match })=>{
        const teamId = match.params.teamId ?? query['teamId'];
        const group = query['group'];
        const keyword = query['keyword'];
        const status = query['status'];
        const page = query['page'] || '1';
        return (0, $7M2yQ.UrlHelper)((0, $b1945f0eddcc66ba$export$bc7daa294a7c75e4), {
            [(0, $b1945f0eddcc66ba$export$d26137cf824a9e53)]: page,
            [(0, $b1945f0eddcc66ba$export$299579ccbdd63cbc)]: keyword,
            [(0, $b1945f0eddcc66ba$export$d7415cfdee4bffc8)]: group,
            [(0, $b1945f0eddcc66ba$export$ce2c93e90dda8613)]: status,
            [(0, $b1945f0eddcc66ba$export$4e0ddb4dc97eb573)]: teamId
        });
    },
    getData: (routerContext)=>(0, $cF4Qy.default).getIntegrations(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("7M2yQ", function(module, exports) {

$parcel$export(module.exports, "UrlHelper", () => $27b5866f9b42e635$export$bacbc496e850c0a4);
const $27b5866f9b42e635$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    // Using %2C in URLs causes bugs in AngularJS, so we need to replace it with comma
    const qs = new URLSearchParams(q).toString().replace(/%2C/g, ',');
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("cF4Qy", function(module, exports) {

$parcel$export(module.exports, "default", () => $296cb7a56f9f15ab$export$2e2bcd8739ae039);

var $br21R = parcelRequire("br21R");

var $7M2yQ = parcelRequire("7M2yQ");

const $296cb7a56f9f15ab$var$getIntegrations = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $915281a41556fba5$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId ?? query.teamId,
        group: query.group,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $br21R.eocFetch)((0, $7M2yQ.UrlHelper)('/v3/integrations/unified', {
        ...queryParams,
        offset: offset.toString(),
        limit: (0, $915281a41556fba5$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $915281a41556fba5$export$31ecae7225aecec6)),
            itemCount: response.data.count,
            platformTeamId: response.data.platformTeamId
        }));
};
const $296cb7a56f9f15ab$var$patchIntegration = async (integrationId, integrationType, body, teamId)=>(0, $br21R.eocFetch)((0, $7M2yQ.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $296cb7a56f9f15ab$var$deleteIntegration = async (integrationId, integrationType, teamId)=>(0, $br21R.eocFetch)((0, $7M2yQ.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
var $296cb7a56f9f15ab$export$2e2bcd8739ae039 = {
    getIntegrations: $296cb7a56f9f15ab$var$getIntegrations,
    patchIntegration: $296cb7a56f9f15ab$var$patchIntegration,
    deleteIntegration: $296cb7a56f9f15ab$var$deleteIntegration
};

});
const $915281a41556fba5$export$31ecae7225aecec6 = 20;


const $b1945f0eddcc66ba$export$bc7daa294a7c75e4 = 'configuredIntegrationsResource';
const $b1945f0eddcc66ba$export$d26137cf824a9e53 = 'page';
const $b1945f0eddcc66ba$export$299579ccbdd63cbc = 'keyword';
const $b1945f0eddcc66ba$export$d7415cfdee4bffc8 = 'group';
const $b1945f0eddcc66ba$export$ce2c93e90dda8613 = 'status';
const $b1945f0eddcc66ba$export$4e0ddb4dc97eb573 = 'teamId';


parcelRegister("2TDCv", function(module, exports) {

$parcel$export(module.exports, "integrationListResource", () => $a21046e58b1fd552$export$f60a40a11a6e0ee4);

var $l1VxS = parcelRequire("l1VxS");

var $kVOkl = parcelRequire("kVOkl");
const $a21046e58b1fd552$export$f60a40a11a6e0ee4 = (0, $l1VxS.createResource)({
    type: 'integrationListResource',
    getKey: ({ query: query })=>{
        const group = query['group'];
        const keyword = query['keyword'];
        return `integrationListResource?group=${group}&keyword=${keyword}`;
    },
    getData: async (routerContext)=>await (0, $kVOkl.default).getIntegrationList(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("kVOkl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9f9a13bd724c91b$export$2e2bcd8739ae039);

var $br21R = parcelRequire("br21R");

var $7M2yQ = parcelRequire("7M2yQ");
const $a9f9a13bd724c91b$var$getIntegrationList = (query, teamId)=>{
    const { keyword: keyword, group: group } = query ?? {};
    return (0, $br21R.eocFetch)((0, $7M2yQ.UrlHelper)(`/v3/integrations/unified/supported-integrations`, {
        keyword: keyword,
        group: group,
        teamId: teamId
    })).then((response)=>{
        const { labels: labels, availableGroups: availableGroups, allTypes: allTypes, platformTeamId: platformTeamId } = response.data;
        return {
            labels: labels,
            availableGroups: availableGroups,
            allTypes: allTypes,
            platformTeamId: platformTeamId
        };
    });
};
const $a9f9a13bd724c91b$var$getIntegrationTypes = (integrationType, teamId)=>(0, $br21R.eocFetch)((0, $7M2yQ.UrlHelper)(`/v3/integrations/unified/${integrationType}/types`, {
        teamId: teamId
    })).then((response)=>response.data.map((integrationType)=>({
                ...integrationType,
                value: integrationType.type,
                label: integrationType.displayName
            })));
var $a9f9a13bd724c91b$export$2e2bcd8739ae039 = {
    getIntegrationList: $a9f9a13bd724c91b$var$getIntegrationList,
    getIntegrationTypes: $a9f9a13bd724c91b$var$getIntegrationTypes
};

});


parcelRegister("3ZcWr", function(module, exports) {

$parcel$export(module.exports, "userAccessRightsResource", () => $5ca81c81cdeb2c5b$export$69ddc7cc64ae9a02);

var $l1VxS = parcelRequire("l1VxS");

var $9lveI = parcelRequire("9lveI");
const $5ca81c81cdeb2c5b$export$69ddc7cc64ae9a02 = (0, $l1VxS.createResource)({
    type: 'userAccessRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params.teamId;
        return `userAccessRightsResource#${!!teamId ? teamId : ''}`;
    },
    getData: (routerContext)=>(0, $9lveI.getUserRights)(routerContext.match.params.teamId),
    maxAge: 3600000,
    isBrowserOnly: true
});

});
parcelRegister("9lveI", function(module, exports) {

$parcel$export(module.exports, "getUserRights", () => $c52b8b5b72d70b58$export$84e2ed279bc4e64e);

var $br21R = parcelRequire("br21R");

var $7M2yQ = parcelRequire("7M2yQ");
const $c52b8b5b72d70b58$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $br21R.eocFetch)((0, $7M2yQ.UrlHelper)(`/v3/integrations/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data);
};

});



parcelRegister("8ivmo", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationCreateRoute", () => $36d368c7f57a8f21$export$bb272d36e3c3b7c1);
const $36d368c7f57a8f21$export$bb272d36e3c3b7c1 = {
    name: 'eoc-integration-create',
    path: '/jira/settings/products/ops/integrations/create/:type',
    exact: true
};

});

parcelRegister("9bIMK", function(module, exports) {

$parcel$export(module.exports, "IntegrationAutomation", () => $a6465774f50a1840$export$434c3e2269913ac0);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $h5q0o = parcelRequire("h5q0o");
const $a6465774f50a1840$export$434c3e2269913ac0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $h5q0o.LazyIntegrationAutomation),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});
parcelRegister("h5q0o", function(module, exports) {

$parcel$export(module.exports, "LazyIntegrationAutomation", () => $4f1e56f6e7b802ad$export$68c40afda0287b61);
$parcel$export(module.exports, "LazyIntegrationDetail", () => $4f1e56f6e7b802ad$export$fd7f60e3df94c902);
$parcel$export(module.exports, "LazyIntegrationCreate", () => $4f1e56f6e7b802ad$export$aa9358ade7cb53ee);
$parcel$export(module.exports, "LazyIntegrationList", () => $4f1e56f6e7b802ad$export$993132b847f26efa);
$parcel$export(module.exports, "LazyIntegrationLog", () => $4f1e56f6e7b802ad$export$b02ef932401d95fc);

var $gzcjr = parcelRequire("gzcjr");

const $4f1e56f6e7b802ad$export$68c40afda0287b61 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("jin4A")).then((module)=>module.IntegrationAutomation), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $4f1e56f6e7b802ad$export$fd7f60e3df94c902 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("jin4A")).then((module)=>module.IntegrationDetail), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $4f1e56f6e7b802ad$export$aa9358ade7cb53ee = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("jin4A")).then((module)=>module.IntegrationCreate), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $4f1e56f6e7b802ad$export$993132b847f26efa = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("jin4A")).then((module)=>module.IntegrationList), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $4f1e56f6e7b802ad$export$b02ef932401d95fc = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("jin4A")).then((module)=>module.IntegrationLog), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

});
parcelRegister("jin4A", function(module, exports) {

let $e0c19893a737ebcb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $e0c19893a737ebcb$var$load("1VRB2"),
    $e0c19893a737ebcb$var$load("bABhq"),
    $e0c19893a737ebcb$var$load("7vqGd"),
    $e0c19893a737ebcb$var$load("1Y4bq"),
    $e0c19893a737ebcb$var$load("g1iTo")
]).then(()=>parcelRequire('9rMVR'));

});



parcelRegister("cbgXG", function(module, exports) {

$parcel$export(module.exports, "IntegrationCreate", () => $e010794379d58299$export$5cb14595364f02c);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $h5q0o = parcelRequire("h5q0o");
const $e010794379d58299$export$5cb14595364f02c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $h5q0o.LazyIntegrationCreate),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("flxCZ", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationDetailRouteEntry", () => $cfffd9007dcf9897$export$b66abbccbf93e9ad);

var $lTVHD = parcelRequire("lTVHD");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $8KL6m = parcelRequire("8KL6m");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $9bIMK = parcelRequire("9bIMK");

var $6M51H = parcelRequire("6M51H");

var $h5q0o = parcelRequire("h5q0o");
const $cfffd9007dcf9897$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $cfffd9007dcf9897$export$b66abbccbf93e9ad = (0, $6xToB.createEntry)((0, $8KL6m.globalIntegrationDetailRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $9bIMK.IntegrationAutomation),
        slot: (0, $6M51H.IntegrationDetail),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $lTVHD.resources).configuredIntegrationsResource,
            (0, $lTVHD.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$cfffd9007dcf9897$var$getNavigationSpecifications()
        },
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("8KL6m", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationDetailRoute", () => $0687adc34b378b13$export$f826f15073eda98);
const $0687adc34b378b13$export$f826f15073eda98 = {
    name: 'eoc-integration-detail',
    path: '/jira/settings/products/ops/integrations/:type/:integrationId',
    exact: true
};

});

parcelRegister("6M51H", function(module, exports) {

$parcel$export(module.exports, "IntegrationDetail", () => $98be509013c42a08$export$8bb99f196e0be5b6);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $h5q0o = parcelRequire("h5q0o");
const $98be509013c42a08$export$8bb99f196e0be5b6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $h5q0o.LazyIntegrationDetail),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("k85NS", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationListRouteEntry", () => $abda72d2df4cfe5b$export$790602da39f8af00);

var $lTVHD = parcelRequire("lTVHD");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $idgsu = parcelRequire("idgsu");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $9bIMK = parcelRequire("9bIMK");

var $juImm = parcelRequire("juImm");

var $h5q0o = parcelRequire("h5q0o");
const $abda72d2df4cfe5b$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $abda72d2df4cfe5b$export$790602da39f8af00 = (0, $6xToB.createEntry)((0, $idgsu.globalIntegrationListRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $9bIMK.IntegrationAutomation),
        slot: (0, $juImm.IntegrationList),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $lTVHD.resources).integrationListResource,
            (0, $lTVHD.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$abda72d2df4cfe5b$var$getNavigationSpecifications()
        },
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("idgsu", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationListRoute", () => $6aa01fe5cb8c3f87$export$270e16f240db883b);
const $6aa01fe5cb8c3f87$export$270e16f240db883b = {
    name: 'eoc-integration-list',
    path: '/jira/settings/products/ops/integrations/list',
    exact: true
};

});

parcelRegister("juImm", function(module, exports) {

$parcel$export(module.exports, "IntegrationList", () => $b07b6a309061e362$export$955768269b79c203);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $h5q0o = parcelRequire("h5q0o");
const $b07b6a309061e362$export$955768269b79c203 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $h5q0o.LazyIntegrationList),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("dyOQA", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationLogRouteEntry", () => $4cc5676159504c32$export$d30f51d0f351bd8a);

var $72NQI = parcelRequire("72NQI");

var $lTVHD = parcelRequire("lTVHD");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $lRIbV = parcelRequire("lRIbV");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $9bIMK = parcelRequire("9bIMK");

var $1MNgS = parcelRequire("1MNgS");

var $h5q0o = parcelRequire("h5q0o");
const $4cc5676159504c32$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $4cc5676159504c32$export$d30f51d0f351bd8a = (0, $6xToB.createEntry)((0, $lRIbV.globalIntegrationLogRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $9bIMK.IntegrationAutomation),
        slot: (0, $1MNgS.IntegrationLog),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $72NQI.resources)(),
            (0, $lTVHD.resources).configuredIntegrationsResource,
            (0, $lTVHD.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$4cc5676159504c32$var$getNavigationSpecifications()
        },
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("lRIbV", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationLogRoute", () => $9c657a70c1412117$export$71884dc820e415fc);
const $9c657a70c1412117$export$71884dc820e415fc = {
    name: 'eoc-integration-log',
    path: '/jira/settings/products/ops/integrations/:type/:integrationId/logs',
    exact: true
};

});

parcelRegister("1MNgS", function(module, exports) {

$parcel$export(module.exports, "IntegrationLog", () => $afbe360ff0e1c88d$export$b545b4a4c4cee016);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $h5q0o = parcelRequire("h5q0o");
const $afbe360ff0e1c88d$export$b545b4a4c4cee016 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $h5q0o.LazyIntegrationLog),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("898Bv", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationsRouteEntry", () => $65d7c81351596706$export$6e5cd6656076550f);

var $lTVHD = parcelRequire("lTVHD");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $iRfwO = parcelRequire("iRfwO");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $3xUgf = parcelRequire("3xUgf");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $h5q0o = parcelRequire("h5q0o");

var $9bIMK = parcelRequire("9bIMK");
const $65d7c81351596706$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $65d7c81351596706$export$6e5cd6656076550f = (0, $6xToB.createEntry)((0, $3xUgf.globalIntegrationsRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $9bIMK.IntegrationAutomation),
        slot: null,
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $lTVHD.resources).configuredIntegrationsResource,
            (0, $lTVHD.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$65d7c81351596706$var$getNavigationSpecifications()
        },
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("3xUgf", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationsRoute", () => $09d9f5f57c193d36$export$e196ff2390a1ec56);
const $09d9f5f57c193d36$export$e196ff2390a1ec56 = {
    name: 'eoc-integrations',
    path: '/jira/settings/products/ops/integrations',
    exact: true
};

});


parcelRegister("2Z13m", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRouteEntry", () => $b78af05281889852$export$30f8c1a53605b10b);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $hbb1g = parcelRequire("hbb1g");

var $eznTg = parcelRequire("eznTg");


var $klAnQ = parcelRequire("klAnQ");

var $gAL0c = parcelRequire("gAL0c");

var $d4NVH = parcelRequire("d4NVH");

var $dq5jm = parcelRequire("dq5jm");

var $fYGKn = parcelRequire("fYGKn");
const $b78af05281889852$export$30f8c1a53605b10b = (0, $6xToB.createEntry)((0, $hbb1g.globalIssueNavigatorBrowseIssueRedirectRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        component: (0, $dq5jm.default),
        skeleton: (0, $eznTg.GlobalIssueNavigatorSkeleton),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fYGKn.LazyGlobalIssueNavigator)
        ],
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $klAnQ.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $gAL0c.getCommonGlobalResources)()
        ],
        layout: (0, $7h3uc.globalLayout)
    }));

});
parcelRegister("hbb1g", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRoute", () => $a85677dacaa6e27c$export$34695dccebecc6bc);
const $a85677dacaa6e27c$export$34695dccebecc6bc = {
    name: 'global-issue-navigator-browse-issue-redirect',
    path: '/browse/:issueKey?',
    query: [
        'jql|filter'
    ]
};

});

parcelRegister("eznTg", function(module, exports) {

$parcel$export(module.exports, "GlobalIssueNavigatorSkeleton", () => $9e9b8f436d40863b$export$51681996374b2585);
/* global-app.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $b7j7G = parcelRequire("b7j7G");
const $9e9b8f436d40863b$var$customCssStyles = null;
const $9e9b8f436d40863b$export$51681996374b2585 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b7j7G))),
        className: (0, $hcewu.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("b7j7G", function(module, exports) {
module.exports = new URL("global-issue-navigator-skeleton.tpl.b1bf4b99.svg", import.meta.url).toString();

});


parcelRegister("klAnQ", function(module, exports) {

$parcel$export(module.exports, "getCommonGlobalNavigation", () => $2aaf8d60fbd6872f$export$2f31f4f387017d83);

var $5RW99 = parcelRequire("5RW99");

var $ftFEp = parcelRequire("ftFEp");
const $2aaf8d60fbd6872f$export$2f31f4f387017d83 = ()=>({
        menuId: (0, $5RW99.MENU_ID).FILTERS,
        sidebar: (0, $ftFEp.AsyncForPaintSidebarFiltersGlobal)
    });

});
parcelRegister("ftFEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $159719ac782bc91d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AsyncForPaintSidebarFiltersGlobal", () => $159719ac782bc91d$export$7655c90db6341aa6);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

// Legacy GIN Sidebar
const $159719ac782bc91d$var$LazySidebarFiltersLegacy = (0, $gzcjr.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("bGGKi")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/index.tsx"
});
const $159719ac782bc91d$var$AsyncSidebarFiltersLegacy = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($159719ac782bc91d$var$LazySidebarFiltersLegacy, null)));
var $159719ac782bc91d$export$2e2bcd8739ae039 = $159719ac782bc91d$var$AsyncSidebarFiltersLegacy;

// Global-scope NIN sidebar
const $159719ac782bc91d$var$LazyAfterPaintSidebarFiltersGlobal = (0, $gzcjr.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    return (parcelRequire("3SNdY")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});

const $159719ac782bc91d$var$LazyForPaintSidebarFiltersGlobal = (0, $gzcjr.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("3SNdY")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});
const $159719ac782bc91d$export$1af88ebe65f50e73 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($159719ac782bc91d$var$LazyAfterPaintSidebarFiltersGlobal, null)));
const $159719ac782bc91d$export$7655c90db6341aa6 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($159719ac782bc91d$var$LazyForPaintSidebarFiltersGlobal, null)));

});
parcelRegister("bGGKi", function(module, exports) {

let $8824c66179583bb2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8824c66179583bb2$var$load("1VRB2"),
    $8824c66179583bb2$var$load("bABhq"),
    $8824c66179583bb2$var$load("fBaMK")
]).then(()=>parcelRequire('6C8aj'));

});

parcelRegister("3SNdY", function(module, exports) {

let $2d3c992d358c02ce$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $2d3c992d358c02ce$var$load("1VRB2"),
    $2d3c992d358c02ce$var$load("bABhq"),
    $2d3c992d358c02ce$var$load("kHsiQ")
]).then(()=>parcelRequire('6ItgB'));

});



parcelRegister("gAL0c", function(module, exports) {

$parcel$export(module.exports, "getCommonGlobalResources", () => $588d871c56f845a6$export$343e92405307cf8d);

var $7jTnu = parcelRequire("7jTnu");

var $2LBez = parcelRequire("2LBez");

var $dpFVo = parcelRequire("dpFVo");

var $dSkEC = parcelRequire("dSkEC");

var $8k1uC = parcelRequire("8k1uC");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $5L7qx = parcelRequire("5L7qx");

var $5nfTh = parcelRequire("5nfTh");

const $588d871c56f845a6$export$343e92405307cf8d = ()=>[
        (0, $5L7qx.browserOnlyResourceWithCondition)(// HOT-120098 - Mark resource as "browser only" in Legacy SSR to reduce the cost of
        // double-SSR when Modern SSR static fallbacks are not available.
        ()=>false && !(0, $9790b8dfe6f31c81$export$19d68f5aa485d903) && (0, $7jTnu.fg)('empanada_nin_disable_legacy_ssr'), (0, $8k1uC.issueNavigatorRelayResource)),
        (0, $5L7qx.browserOnlyResourceWithCondition)(// HOT-120098 - Mark resource as "browser only" in Legacy SSR to reduce the cost of
        // double-SSR when Modern SSR static fallbacks are not available.
        ()=>false && !(0, $9790b8dfe6f31c81$export$19d68f5aa485d903) && (0, $7jTnu.fg)('empanada_nin_disable_legacy_ssr'), (0, $8k1uC.issueNavigatorFilterRelayResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('nin_request_hydrate_query_earlier') && !(0, $7jTnu.fg)('render_jql_builder_in_ssr'), (0, $8k1uC.issueNavigatorHydrationRelayResourceBrowserOnly)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('render_jql_builder_in_ssr'), (0, $5L7qx.browserOnlyResourceWithCondition)(// HOT-120098 - Mark resource as "browser only" in Legacy SSR to reduce the cost of
        // double-SSR when Modern SSR static fallbacks are not available.
        ()=>false && !(0, $9790b8dfe6f31c81$export$19d68f5aa485d903) && (0, $7jTnu.fg)('empanada_nin_disable_legacy_ssr'), (0, $8k1uC.issueNavigatorHydrationRelayResource))),
        ...(0, $9NmsS.getNavigationResources)(),
        (0, $enHI7.navigationSidebarGlobalResource),
        (0, $dSkEC.isNinGlobalScopeEnrolmentEnabledResource),
        (0, $5L7qx.resourceWithCondition2)((0, $dpFVo.getWillShowNav3), (0, $2LBez.sidebarFiltersGlobalResource)),
        ...(0, $5nfTh.getAIContextPanelResources)()
    ];

});
parcelRegister("2LBez", function(module, exports) {

$parcel$export(module.exports, "sidebarFiltersGlobalResource", () => $bbc6337e25a04802$export$7e0b804085f0470d);

var $9FYIg = parcelRequire("9FYIg");

var $2CIHr = parcelRequire("2CIHr");

var $hBje1 = parcelRequire("hBje1");
const $bbc6337e25a04802$export$7e0b804085f0470d = (0, $hBje1.withGiraAggAnonSsrFix)((0, $9FYIg.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_FILTERS_GLOBAL',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $2CIHr.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("2CIHr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7e5cd1c06d82638$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4654bfdfd3e20081cf96674156c0485e>>
 * @relayHash b167c3924c240111eb2c04f5138be112
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 488e4e7ceb05d5d63726635de6bb578e2d4b52a4643ab9ca4393d1579b8d07f0

var $5Jxq3 = parcelRequire("5Jxq3");
const $e7e5cd1c06d82638$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ],
        "type": "JiraCustomFilter"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            },
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "isFavourite",
                                    "value": false
                                }
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "FILTER"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteFiltersOld",
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "favouriteFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "488e4e7ceb05d5d63726635de6bb578e2d4b52a4643ab9ca4393d1579b8d07f0",
            "metadata": {},
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider": (0, $5Jxq3.default)
            }
        }
    };
}();
$e7e5cd1c06d82638$var$node.hash = "b5467e25277d67ce676aa25dd3a16377";
var $e7e5cd1c06d82638$export$2e2bcd8739ae039 = $e7e5cd1c06d82638$var$node;

});
parcelRegister("5Jxq3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a554ab6a3a2d497f$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $a554ab6a3a2d497f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('add_limit_to_nav3_starred_filter_sidebar');
    }
};

});



parcelRegister("dSkEC", function(module, exports) {

$parcel$export(module.exports, "isNinGlobalScopeEnrolmentEnabledResource", () => $d4b13795e146c70f$export$3f6390b4131d761b);

var $l1VxS = parcelRequire("l1VxS");

const $d4b13795e146c70f$var$getDataLoader = ()=>(parcelRequire("139XQ"));
const $d4b13795e146c70f$export$3f6390b4131d761b = (0, $l1VxS.createResource)({
    type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
    getKey: ()=>'ninGlobalScopeEnrolment',
    getDataLoader: $d4b13795e146c70f$var$getDataLoader
});

});
parcelRegister("139XQ", function(module, exports) {

let $0c3dccf7ef509bee$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0c3dccf7ef509bee$var$load("dsgSt").then(()=>parcelRequire('2Dq8O'));

});


parcelRegister("8k1uC", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorRelayResource", () => $ed0a4483fb669c9c$export$b4096f516fb93159);
$parcel$export(module.exports, "issueNavigatorFilterRelayResource", () => $ed0a4483fb669c9c$export$44ca3a0b25f38d83);
$parcel$export(module.exports, "issueNavigatorHydrationRelayResource", () => $ed0a4483fb669c9c$export$967ef0cfbd1cc946);
$parcel$export(module.exports, "issueNavigatorHydrationRelayResourceBrowserOnly", () => $ed0a4483fb669c9c$export$2c98f9cf5d4c493e);
/* eslint-disable jira/import-whitelist */ 
var $j4oe4 = parcelRequire("j4oe4");

var $4NoAT = parcelRequire("4NoAT");

var $epTsa = parcelRequire("epTsa");

var $82cqT = parcelRequire("82cqT");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $awWeA = parcelRequire("awWeA");

var $8oKDI = parcelRequire("8oKDI");

var $7zZ4w = parcelRequire("7zZ4w");

var $7797X = parcelRequire("7797X");

var $9FYIg = parcelRequire("9FYIg");

var $8jMVZ = parcelRequire("8jMVZ");

var $4mFQO = parcelRequire("4mFQO");

var $93W2w = parcelRequire("93W2w");

var $l1VxS = parcelRequire("l1VxS");

var $7jTnu = parcelRequire("7jTnu");

var $9S9Cb = parcelRequire("9S9Cb");

var $2HIMw = parcelRequire("2HIMw");

var $lzktc = parcelRequire("lzktc");
const $ed0a4483fb669c9c$export$b4096f516fb93159 = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $2HIMw.RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY)}`,
    getKey: ()=>'issue-navigator-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter, groupBy: groupBy, hideDone: hideDone } = (0, $lzktc.getParams)(routerContext);
        const jqlOrFilterId = (0, $lzktc.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
        const maxIssuesPerPage = (0, $iRahl.getMaxIssuesPerPage)();
        const chromelessRoute = (0, $lzktc.isChromelessRoute)(routerContext) && (0, $7jTnu.fg)('jira_nin_smart_link');
        let viewId;
        let shouldQueryConditionalFormatting = Boolean(projectKey);
        let isIFCEnabled = Boolean(projectKey);
        const filterId = Boolean(filter) && (0, $82cqT.isCustomFilter)(filter) ? filter : null;
        if (chromelessRoute && (0, $7jTnu.fg)('jira_nin_smart_link')) {
            // Disable conditional formatting for chromeless (i.e. embed) routes
            shouldQueryConditionalFormatting = false;
            // Disable IFC for chromeless (i.e. embed) routes
            isIFCEnabled = false;
            // Explicitly load list view for chromeless (i.e. embed) routes
            viewId = filterId ? (0, $eibCx.convertFilterIdToIssueNavigatorId)(filterId) : 'list_default';
        }
        let staticViewInput;
        if (projectKey === undefined || projectKey === null) staticViewInput = {
            isHierarchyEnabled: false,
            isGroupingEnabled: false,
            isHideDoneEnabled: false
        };
        else if (hideDone != null) staticViewInput = {
            isHideDoneEnabled: hideDone
        };
        const viewConfigInput = staticViewInput ? {
            staticViewInput: staticViewInput
        } : {
            viewInput: {
                namespace: (0, $iRahl.ISSUE_SEARCH_NAMESPACE)
            }
        };
        const viewConfigInputOld = projectKey !== undefined && projectKey !== null ? {
            viewInput: {
                namespace: (0, $iRahl.ISSUE_SEARCH_NAMESPACE)
            }
        } : {
            staticViewInput: {
                isHierarchyEnabled: false,
                isGroupingEnabled: false,
                isHideDoneEnabled: false
            }
        };
        const staticViewInputOld = projectKey === undefined || projectKey === null ? {
            isHierarchyEnabled: false,
            isGroupingEnabled: false,
            isHideDoneEnabled: false
        } : undefined;
        let viewQueryInput;
        if ((0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding')) viewQueryInput = projectKey == null ? {
            viewAri: (0, $9S9Cb.createViewAri)({
                activationId: tenantContext.activationId,
                cloudId: tenantContext.cloudId
            })
        } : {
            projectKeyAndItemIdQuery: {
                cloudId: tenantContext.cloudId,
                projectKey: projectKey,
                itemId: routerContext.match.params.itemId ?? ''
            }
        };
        let operationScope;
        if (isIFCEnabled && (0, $epTsa.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false)) operationScope = (0, $awWeA.getOperationScope)(projectKey);
        else if (projectKey) operationScope = (0, $iRahl.NIN_PROJECT_OPERATION_SCOPE);
        else operationScope = (0, $iRahl.NIN_GLOBAL_OPERATION_SCOPE);
        const variables = {
            cloudId: tenantContext.cloudId,
            first: issueKey == null ? maxIssuesPerPage : null,
            issueSearchInput: jqlOrFilterId,
            namespace: (0, $iRahl.ISSUE_SEARCH_NAMESPACE),
            fieldSetsInput: {
                viewInput: {
                    namespace: (0, $iRahl.ISSUE_SEARCH_NAMESPACE),
                    filterId: filterId,
                    viewId: viewId
                }
            },
            after: null,
            options: {
                issueKey: issueKey
            },
            filterId: filterId,
            amountOfColumns: (0, $iRahl.MAX_AMOUNT_OF_COLUMNS),
            shouldQueryHasChildren: projectKey !== null && projectKey !== undefined && (0, $epTsa.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false),
            ...(0, $7jTnu.fg)('jsc_nin_operation_scope_fe') && {
                scope: {
                    operationScope: operationScope,
                    ...isIFCEnabled && (0, $epTsa.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false) ? {
                        projectKey: projectKey
                    } : {}
                }
            },
            ...(0, $epTsa.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false) && {
                viewConfigInput: (0, $7jTnu.fg)('jsc_list_query_param_merge') ? viewConfigInput : viewConfigInputOld
            },
            staticViewInput: (0, $7jTnu.fg)('jsc_list_query_param_merge') ? staticViewInput : staticViewInputOld,
            ...(0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding') && {
                viewQueryInput: viewQueryInput,
                settings: {
                    groupBy: groupBy,
                    hideDone: hideDone,
                    jql: 'jql' in jqlOrFilterId ? jqlOrFilterId.jql : undefined
                }
            },
            atlassianIntelligenceProductFeature: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $iRahl.NATURAL_LANGUAGE_TO_JQL),
            projectKey: projectKey ?? '',
            shouldQueryProject: Boolean(projectKey) && ((0, $epTsa.expVal)('jira_list_realtime_updates_with_queue', 'isEnabled', false) || (0, $epTsa.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false) || (0, $epTsa.expVal)('jira-issue-navigator-saved-filters-menu', 'isEnabled', false) || (0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding')),
            shouldQueryConditionalFormatting: shouldQueryConditionalFormatting && (0, $7jTnu.fg)('jira_list_conditional_formatting'),
            groupBy: (0, $7jTnu.fg)('jsc_list_query_param_merge') ? groupBy ?? null : null,
            ...isIFCEnabled && (0, $epTsa.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false) && {
                fieldSetsScope: {
                    operationScope: operationScope,
                    projectKey: projectKey
                }
            },
            viewId: viewId
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $93W2w.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $7797X.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $ed0a4483fb669c9c$export$44ca3a0b25f38d83 = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $2HIMw.RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY)}`,
    getKey: ()=>'issue-navigator-filter-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { filter: filter } = (0, $lzktc.getParams)(routerContext);
        const includeFilter = Boolean(filter) && (0, $82cqT.isFilterId)(filter);
        const variables = {
            includeFilter: includeFilter,
            filterAri: includeFilter ? (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'filter',
                resourceId: filter,
                activationId: tenantContext.activationId
            }) : ''
        };
        const options = {
            fetchPolicy: includeFilter ? 'network-only' : 'store-only'
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $4mFQO.default), variables, options);
        if (false && queryReference.id != null) await (0, $7797X.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $ed0a4483fb669c9c$export$967ef0cfbd1cc946 = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $2HIMw.RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY)}`,
    getKey: ()=>'issue-navigator-hydration-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $lzktc.getParams)(routerContext);
        const jqlOrFilterId = (0, $lzktc.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
        // eslint-disable-next-line jira/ff/inline-usage
        const variables = {
            accountId: tenantContext.atlassianAccountId ?? '',
            cloudId: tenantContext.cloudId,
            includeUser: true,
            includeJira: true,
            isFilter: 'filterId' in jqlOrFilterId,
            jql: 'jql' in jqlOrFilterId && jqlOrFilterId.jql || '',
            filterAri: 'filterId' in jqlOrFilterId && (0, $4NoAT.JiraFilterAri).create({
                siteId: tenantContext.cloudId,
                filterId: filter,
                activationId: tenantContext.activationId
            }).toString() || '',
            viewContext: null,
            isPlanReleaseFeatureToggleEnabled: (0, $7jTnu.fg)('simple-plans-m2-release-feature-toggle')
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $8jMVZ.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $7797X.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $ed0a4483fb669c9c$export$2c98f9cf5d4c493e = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $2HIMw.RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY)}_BROWSER_ONLY`,
    getKey: ()=>'issue-navigator-hydration-relay-browser-only',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $lzktc.getParams)(routerContext);
        const jqlOrFilterId = (0, $lzktc.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
        // eslint-disable-next-line jira/ff/inline-usage
        const variables = {
            accountId: tenantContext.atlassianAccountId ?? '',
            cloudId: tenantContext.cloudId,
            includeUser: true,
            includeJira: true,
            isFilter: 'filterId' in jqlOrFilterId,
            jql: 'jql' in jqlOrFilterId && jqlOrFilterId.jql || '',
            filterAri: 'filterId' in jqlOrFilterId && (0, $4NoAT.JiraFilterAri).create({
                siteId: tenantContext.cloudId,
                filterId: filter,
                activationId: tenantContext.activationId
            }).toString() || '',
            viewContext: null,
            isPlanReleaseFeatureToggleEnabled: (0, $7jTnu.fg)('simple-plans-m2-release-feature-toggle')
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $8jMVZ.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $7797X.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("82cqT", function(module, exports) {

$parcel$export(module.exports, "isCustomFilter", () => $210cb11189693860$export$31180e7f1db565e5);
$parcel$export(module.exports, "isFilterId", () => $210cb11189693860$export$23be85030bd58047);
const $210cb11189693860$export$31180e7f1db565e5 = (filterId)=>/^\d+$/.test(filterId);
const $210cb11189693860$export$887fa95a5a5cf197 = (filterId)=>/^-\d+$/.test(filterId);
const $210cb11189693860$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});

parcelRegister("iRahl", function(module, exports) {

$parcel$export(module.exports, "sortDirections", () => $44bd204fdd3c598a$export$73034536b9adc928);
$parcel$export(module.exports, "FilterTypes", () => $44bd204fdd3c598a$export$ad2e3f13451a5d44);
$parcel$export(module.exports, "SearchInputTypes", () => $44bd204fdd3c598a$export$75a31bc7c097ba4b);
$parcel$export(module.exports, "views", () => $44bd204fdd3c598a$export$d0079916fe6800ac);
$parcel$export(module.exports, "defaultOrderFields", () => $44bd204fdd3c598a$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", () => $44bd204fdd3c598a$export$de2495608df10495);
$parcel$export(module.exports, "DEFAULT_ORDER_FIELD", () => $44bd204fdd3c598a$export$393cb330f31d305c);
$parcel$export(module.exports, "DEFAULT_SORT_DIRECTION", () => $44bd204fdd3c598a$export$8ea18fa9e35fdf25);
$parcel$export(module.exports, "DEFAULT_VIEW_ID", () => $44bd204fdd3c598a$export$500b5c379b5c7f2e);
$parcel$export(module.exports, "MAX_ISSUES_PER_PAGE", () => $44bd204fdd3c598a$export$f88f58d1a4b2078b);
$parcel$export(module.exports, "getMaxIssuesPerPage", () => $44bd204fdd3c598a$export$8c67ad1f64ab5a9c);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $44bd204fdd3c598a$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "PACKAGE_NAME", () => $44bd204fdd3c598a$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $44bd204fdd3c598a$export$d57b6b390e78d90f);
$parcel$export(module.exports, "EXPERIENCE_NAME", () => $44bd204fdd3c598a$export$52919046b94109dc);
$parcel$export(module.exports, "GROUPED_LIST_EXPERIENCE_ID", () => $44bd204fdd3c598a$export$88890124f795113d);
$parcel$export(module.exports, "ANALYTICS_LIST_VIEW_SOURCE_NAME", () => $44bd204fdd3c598a$export$81d9767bc5c1549e);
$parcel$export(module.exports, "ANALYTICS_DETAIL_VIEW_SOURCE_NAME", () => $44bd204fdd3c598a$export$524ae4278a57eea2);
$parcel$export(module.exports, "MAX_AMOUNT_OF_COLUMNS", () => $44bd204fdd3c598a$export$608eeb3a32afef02);
$parcel$export(module.exports, "COLUMN_TYPE_EPIC_LINK", () => $44bd204fdd3c598a$export$ce9e2d7c178a9557);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $44bd204fdd3c598a$export$1adf7afff96bbf16);
$parcel$export(module.exports, "NATURAL_LANGUAGE_TO_JQL", () => $44bd204fdd3c598a$export$55628b4c44d1522a);
$parcel$export(module.exports, "NIN_PROJECT_OPERATION_SCOPE", () => $44bd204fdd3c598a$export$fae6afe554014a45);
$parcel$export(module.exports, "NIN_GLOBAL_OPERATION_SCOPE", () => $44bd204fdd3c598a$export$39ec48f092f3ea90);
$parcel$export(module.exports, "NIN_PROJECT_SHADOW_REQUEST_OPERATION_SCOPE", () => $44bd204fdd3c598a$export$2c213b805a8379cf);
$parcel$export(module.exports, "NIN_SIDEBAR_SCOPE", () => $44bd204fdd3c598a$export$adc96a79a4445d56);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_SIDEBAR_ID", () => $44bd204fdd3c598a$export$6c35abbca3056365);
$parcel$export(module.exports, "ALL_COLUMNS_ID", () => $44bd204fdd3c598a$export$eb85a4c9b5d9ce7b);
$parcel$export(module.exports, "supportedOrderFields", () => $44bd204fdd3c598a$export$3630aa1c4c69277f);
$parcel$export(module.exports, "getSupportedFieldForAlias", () => $44bd204fdd3c598a$export$eaadab3243bf458);
$parcel$export(module.exports, "isJiraIssueSearchViewMetadata", () => $44bd204fdd3c598a$export$f40fffea1f8469ac);
$parcel$export(module.exports, "isJiraSpreadsheetView", () => $44bd204fdd3c598a$export$2627fa464eafde69);

var $8jOO7 = parcelRequire("8jOO7");
const $44bd204fdd3c598a$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};
const $44bd204fdd3c598a$export$ad2e3f13451a5d44 = {
    ID: 'filterId',
    JQL: 'filterJql'
};
const $44bd204fdd3c598a$export$75a31bc7c097ba4b = {
    JQL: 'jql',
    FILTER: 'filter',
    FILTER_AND_JQL: 'filterAndJql'
};
const $44bd204fdd3c598a$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};
const $44bd204fdd3c598a$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $44bd204fdd3c598a$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
const $44bd204fdd3c598a$export$393cb330f31d305c = $44bd204fdd3c598a$export$2bd49f8f262d7cbb.created;
const $44bd204fdd3c598a$export$8ea18fa9e35fdf25 = $44bd204fdd3c598a$export$73034536b9adc928.DESC;
const $44bd204fdd3c598a$export$500b5c379b5c7f2e = 'list_default';
const $44bd204fdd3c598a$export$f88f58d1a4b2078b = 50;
const $44bd204fdd3c598a$export$8c67ad1f64ab5a9c = ()=>$44bd204fdd3c598a$export$f88f58d1a4b2078b;
const $44bd204fdd3c598a$export$f7109619a5e9e0d6 = 'issue-navigator-next';
const $44bd204fdd3c598a$export$b8b9d90f9e5bd72b = 'jiraIssueNavigator';
const $44bd204fdd3c598a$export$d57b6b390e78d90f = 'empanada';
const $44bd204fdd3c598a$export$52919046b94109dc = 'showPinIssueList';
const $44bd204fdd3c598a$export$88890124f795113d = 'groupedList';
const $44bd204fdd3c598a$export$81d9767bc5c1549e = 'issueNavigatorListView';
const $44bd204fdd3c598a$export$524ae4278a57eea2 = 'issueNavigatorDetailView';
const $44bd204fdd3c598a$export$af225181779390f4 = 'list_default';
const $44bd204fdd3c598a$export$608eeb3a32afef02 = (0, $8jOO7.MAX_COLUMNS);
const $44bd204fdd3c598a$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $44bd204fdd3c598a$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $44bd204fdd3c598a$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $44bd204fdd3c598a$export$fae6afe554014a45 = 'NIN_PROJECT';
const $44bd204fdd3c598a$export$39ec48f092f3ea90 = 'NIN_GLOBAL';
const $44bd204fdd3c598a$export$2c213b805a8379cf = 'NIN_PROJECT_SHADOW_REQUEST';
const $44bd204fdd3c598a$export$adc96a79a4445d56 = 'NIN_SIDEBAR';
const $44bd204fdd3c598a$export$6c35abbca3056365 = 'IssueNavigator';
const $44bd204fdd3c598a$export$eb85a4c9b5d9ce7b = 'all-columns';
const $44bd204fdd3c598a$export$3630aa1c4c69277f = {
    created: {
        jqlTerm: 'created',
        fieldType: 'created',
        aliases: []
    },
    key: {
        jqlTerm: 'key',
        fieldType: 'issuekey',
        aliases: [
            'issuekey'
        ]
    },
    lastviewed: {
        jqlTerm: 'lastviewed',
        fieldType: 'lastviewed',
        aliases: []
    },
    priority: {
        jqlTerm: 'priority',
        fieldType: 'priority',
        aliases: []
    },
    resolved: {
        jqlTerm: 'resolved',
        fieldType: 'resolutiondate',
        aliases: []
    },
    status: {
        jqlTerm: 'status',
        fieldType: 'status',
        aliases: []
    },
    updated: {
        jqlTerm: 'updated',
        fieldType: 'updated',
        aliases: []
    },
    issuetype: {
        jqlTerm: 'issuetype',
        fieldType: 'issuetype',
        aliases: [
            'type'
        ]
    },
    assignee: {
        jqlTerm: 'assignee',
        fieldType: 'assignee',
        aliases: []
    },
    duedate: {
        jqlTerm: 'duedate',
        fieldType: 'duedate',
        aliases: []
    },
    reporter: {
        jqlTerm: 'reporter',
        fieldType: 'reporter',
        aliases: []
    },
    summary: {
        jqlTerm: 'summary',
        fieldType: 'summary',
        aliases: []
    }
};
const $44bd204fdd3c598a$export$eaadab3243bf458 = (alias)=>Object.keys($44bd204fdd3c598a$export$3630aa1c4c69277f).find((key)=>$44bd204fdd3c598a$export$3630aa1c4c69277f[key]?.aliases.includes(alias));
const $44bd204fdd3c598a$export$f40fffea1f8469ac = (data)=>[
        'JiraIssueSearchView',
        'JiraDetailedView',
        'JiraListView',
        'JiraGroupedListView'
    ].includes(data.__typename);
const $44bd204fdd3c598a$export$2627fa464eafde69 = (data)=>[
        'JiraListView',
        'JiraGroupedListView'
    ].includes(data.__typename);

});

parcelRegister("eibCx", function(module, exports) {

$parcel$export(module.exports, "createRememoizeSelector", () => $0e7c4003c6219e66$export$982d75deeca693ef);
$parcel$export(module.exports, "isNormalClick", () => $0e7c4003c6219e66$export$729f3684d5c2b9b9);
$parcel$export(module.exports, "isNonNullish", () => $0e7c4003c6219e66$export$70573498ee17fe1d);
$parcel$export(module.exports, "parseIssueNavigatorViewIdOrDefault", () => $0e7c4003c6219e66$export$ad0c80ba9128e83a);
$parcel$export(module.exports, "isFilterViewId", () => $0e7c4003c6219e66$export$194f1a1e890054c9);
$parcel$export(module.exports, "convertToIssueNavigatorId", () => $0e7c4003c6219e66$export$6ce707b3eccb341d);
$parcel$export(module.exports, "convertToView", () => $0e7c4003c6219e66$export$95ef66082092aa68);
$parcel$export(module.exports, "convertFilterIdToIssueNavigatorId", () => $0e7c4003c6219e66$export$ec4f6e9ea23bb55d);
$parcel$export(module.exports, "exclusiveGroupResultsOrIssueResultsFragment", () => $0e7c4003c6219e66$export$1dde85fc919cd8db);

var $ahm5r = parcelRequire("ahm5r");

var $iRahl = parcelRequire("iRahl");
const $0e7c4003c6219e66$export$982d75deeca693ef = (0, $ahm5r.createSelectorCreator)((0, $ahm5r.defaultMemoize), // @ts-expect-error - TS2339 - Property '_rememoize' does not exist on type 'T'. | TS2339 - Property '_rememoize' does not exist on type 'T'.
(a, b)=>a._rememoize === b._rememoize);
const $0e7c4003c6219e66$export$729f3684d5c2b9b9 = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
function $0e7c4003c6219e66$var$isPossibleValueEntry(entry) {
    return typeof entry[1] === 'string' || typeof entry[1] === 'number' || Array.isArray(entry[1]) && entry[1].length > 0;
}
const $0e7c4003c6219e66$export$20fba0bc14771b28 = (state)=>{
    const definedEntries = Object.entries(state).filter($0e7c4003c6219e66$var$isPossibleValueEntry);
    return definedEntries.map((entry)=>({
            key: entry[0],
            value: Array.isArray(entry[1]) ? entry[1].map((values)=>values.value) : entry[1]
        }));
};
const $0e7c4003c6219e66$export$6256478a5735e738 = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(state).reduce((acc, key)=>{
        const value = state[key];
        if (key === 'search') {
            if (typeof value !== 'string') throw new Error('Unexpected non-string literal for search.');
            acc[key] = value;
        } else if (Array.isArray(value)) acc[key] = value.map((values)=>values.value);
        else if (typeof value === 'string' || typeof value === 'undefined') acc[key] = value || [];
        else acc[key] = value;
        return acc;
    }, {});
const $0e7c4003c6219e66$export$28dade55d1b3964b = (viewId)=>viewId === 'detail' ? (0, $iRahl.views).detail : (0, $iRahl.views).list;
const $0e7c4003c6219e66$export$587f73d78d2a7579 = (viewMode)=>viewMode === (0, $iRahl.views).detail ? 'detail' : 'list_default';
const $0e7c4003c6219e66$export$5786a571e562003d = (viewMode)=>viewMode === (0, $iRahl.views).detail ? 'DETAIL' : 'LIST';
function $0e7c4003c6219e66$export$70573498ee17fe1d(value) {
    return value != null;
}
const $0e7c4003c6219e66$export$ad0c80ba9128e83a = (viewId, defaultValue = 'list_default')=>{
    if (!viewId) return defaultValue;
    switch(viewId){
        case 'list_default':
            return 'list_default';
        case 'list_system':
            return 'list_system';
        case 'detail':
            return 'detail';
        default:
            if ($0e7c4003c6219e66$export$194f1a1e890054c9(viewId)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return viewId;
            return defaultValue;
    }
};
const $0e7c4003c6219e66$export$194f1a1e890054c9 = (viewId)=>/^list_filter_\d+$/.test(viewId);
const $0e7c4003c6219e66$export$6ce707b3eccb341d = (view)=>view === (0, $iRahl.views).detail ? 'detail' : 'list_default';
const $0e7c4003c6219e66$export$95ef66082092aa68 = (issueNavigatorViewId)=>issueNavigatorViewId === 'detail' ? (0, $iRahl.views).detail : (0, $iRahl.views).list;
const $0e7c4003c6219e66$export$ec4f6e9ea23bb55d = (filterId)=>{
    if (typeof filterId === 'number') return `list_filter_${filterId}`;
    const filterIdInt = Number(filterId);
    if (Number.isNaN(filterIdInt)) throw new Error('filterId is invalid');
    return `list_filter_${filterIdInt}`;
};
function $0e7c4003c6219e66$export$1dde85fc919cd8db({ groupResults: groupResults, issueResults: issueResults }) {
    if (issueResults) return {
        groupResults: null,
        issueResults: issueResults
    };
    if (groupResults) return {
        groupResults: groupResults,
        issueResults: null
    };
    return null;
}

});

parcelRegister("awWeA", function(module, exports) {

$parcel$export(module.exports, "getOperationScope", () => $5af88e3fbe2eb6ab$export$93ef6e0525bce59d);

var $j8Km1 = parcelRequire("j8Km1");
const $5af88e3fbe2eb6ab$export$93ef6e0525bce59d = (projectKey)=>{
    let operationScope;
    if (projectKey != null) operationScope = (0, $j8Km1.NIN_PROJECT_OPERATION_SCOPE);
    else operationScope = (0, $j8Km1.NIN_GLOBAL_OPERATION_SCOPE);
    return operationScope;
};

});

parcelRegister("8jMVZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $093b8d5743dd0b76$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<296de75e35cb07fe080e23ace858a78e>>
 * @relayHash e8f98055e5741882d770ae3f9d601043
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6ce9d09660428bd26bc6bab008de01d9b128040aa45b6652f1bca1729f0d9064
const $093b8d5743dd0b76$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeJira"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeUser"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isFilter"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPlanReleaseFeatureToggleEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v11 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v12 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v13 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        },
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v15 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v16 = [
        v14 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v15 /*: any*/ 
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ], v17 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        },
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = [
        v14 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v18 /*: any*/ 
    ], v20 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v21 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v22 = {
        "kind": "ScalarField",
        "name": "key"
    }, v23 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorName"
                },
                v18 /*: any*/ 
            ]
        }
    ], v24 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v25 = [
        v14 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v15 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        v14 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v20 /*: any*/ ,
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldShowInContext"
                                        },
                                        {
                                            "condition": "isPlanReleaseFeatureToggleEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        v11 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "shouldExcludeInScope"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "operators"
                                        },
                                        {
                                            "concreteType": "JiraFieldType",
                                            "kind": "LinkedField",
                                            "name": "fieldType",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v20 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlProjectFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v23 /*: any*/ ,
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v23 /*: any*/ ,
                                                            "type": "JiraJqlStatusCategoryFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "xsmall"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": v19 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v14 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "text"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "state"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "boardName"
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v24 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        v24 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlCascadingOptionFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v20 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "error",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ],
            "type": "QueryError"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hydrateJqlBuilderQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValues"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useQuery"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValues_cascadeSelectPicker"
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": v13 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQuery",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v17 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQueryForFilter",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v8 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hydrateJqlBuilderQuery",
            "selections": [
                {
                    "condition": "includeUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "accountId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v19 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": v13 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQuery",
                                                    "plural": false,
                                                    "selections": v25 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v17 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQueryForFilter",
                                                    "plural": false,
                                                    "selections": v25 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6ce9d09660428bd26bc6bab008de01d9b128040aa45b6652f1bca1729f0d9064",
            "metadata": {},
            "name": "hydrateJqlBuilderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$093b8d5743dd0b76$var$node.hash = "30fd8badf71c8e43e13c94db5bb98b42";
var $093b8d5743dd0b76$export$2e2bcd8739ae039 = $093b8d5743dd0b76$var$node;

});

parcelRegister("4mFQO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad68114cb1dd8f51$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c0dc4a342f4ce5786fbe069292419e8>>
 * @relayHash 4722fbdc72716192181bb0830d738d17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9373e4d70177ba3d0d672c65e67a2165b4a0d774802f56dbef66239dd52c8e5
const $ad68114cb1dd8f51$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_filterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b9373e4d70177ba3d0d672c65e67a2165b4a0d774802f56dbef66239dd52c8e5",
            "metadata": {},
            "name": "main_FilterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ad68114cb1dd8f51$var$node.hash = "181bb07a6bafd05a2033750384a06766";
var $ad68114cb1dd8f51$export$2e2bcd8739ae039 = $ad68114cb1dd8f51$var$node;

});

parcelRegister("93W2w", function(module, exports) {

$parcel$export(module.exports, "default", () => $04e26ee18435d3dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d6329ebc5bc2fe7e67fe6585fd273716>>
 * @relayHash 41fd0671da22eb1b5f9ce993fb1cd169
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f34a9b4af83a44f1b25def3f0ab41fa0b9576c9096360a6c789aae8396e6171

var $kZq2R = parcelRequire("kZq2R");

var $bFEtW = parcelRequire("bFEtW");

var $lcRgI = parcelRequire("lcRgI");

var $1vgnN = parcelRequire("1vgnN");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $eylLg = parcelRequire("eylLg");

var $4MVMw = parcelRequire("4MVMw");

var $iiQfx = parcelRequire("iiQfx");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $hRj2m = parcelRequire("hRj2m");

var $2HLoK = parcelRequire("2HLoK");

var $kmr3r = parcelRequire("kmr3r");

var $bU8Sj = parcelRequire("bU8Sj");

var $clCUA = parcelRequire("clCUA");

var $8Qoc7 = parcelRequire("8Qoc7");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");

var $cqnj8 = parcelRequire("cqnj8");

var $7lcgt = parcelRequire("7lcgt");

var $iOvkB = parcelRequire("iOvkB");
const $04e26ee18435d3dd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianIntelligenceProductFeature"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryConditionalFormatting"
    }, v19 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryProject"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v24 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewQueryInput"
    }, v25 = {
        "kind": "Variable",
        "name": "isConditionalFormattingEnabled",
        "variableName": "shouldQueryConditionalFormatting"
    }, v26 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v27 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v28 = [
        v27 /*: any*/ 
    ], v29 = [
        v27 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v30 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v31 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v32 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v33 = {
        "kind": "ScalarField",
        "name": "message"
    }, v34 = [
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v32 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        },
        v33 /*: any*/ 
    ], v35 = {
        "kind": "ScalarField",
        "name": "id"
    }, v36 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "fieldSetsScope"
    }, v37 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        },
        v36 /*: any*/ 
    ], v38 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v39 = {
        "kind": "ScalarField",
        "name": "savedViewId"
    }, v40 = {
        "kind": "Variable",
        "name": "settings",
        "variableName": "settings"
    }, v41 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v42 = {
        "kind": "Variable",
        "name": "groupBy",
        "variableName": "groupBy"
    }, v43 = [
        v42 /*: any*/ ,
        v31 /*: any*/ ,
        v40 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v44 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v45 = {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraField",
                "kind": "LinkedField",
                "name": "groupByField",
                "plural": false,
                "selections": [
                    v44 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            }
        ]
    }, v46 = {
        "kind": "ScalarField",
        "name": "hideDone"
    }, v47 = {
        "kind": "ScalarField",
        "name": "isHierarchyEnabled"
    }, v48 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v49 = {
        "kind": "Variable",
        "name": "before",
        "variableName": "before"
    }, v50 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v51 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v52 = {
        "kind": "Variable",
        "name": "last",
        "variableName": "last"
    }, v53 = {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
    }, v54 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v55 = [
        v48 /*: any*/ ,
        v49 /*: any*/ ,
        v50 /*: any*/ ,
        v51 /*: any*/ ,
        v31 /*: any*/ ,
        v52 /*: any*/ ,
        v53 /*: any*/ ,
        v54 /*: any*/ ,
        v40 /*: any*/ 
    ], v56 = [
        v39 /*: any*/ 
    ], v57 = {
        "kind": "ScalarField",
        "name": "isGroupingEnabled"
    }, v58 = {
        "kind": "ScalarField",
        "name": "canEnableGrouping"
    }, v59 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v60 = {
        "kind": "ScalarField",
        "name": "type"
    }, v61 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v62 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v63 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "aliases"
            }
        ]
    }, v64 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v65 = {
        "kind": "ClientExtension",
        "selections": [
            v64 /*: any*/ 
        ]
    }, v66 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v56 /*: any*/ 
    }, v67 = {
        "kind": "ScalarField",
        "name": "canEnableHierarchy"
    }, v68 = {
        "kind": "ScalarField",
        "name": "name"
    }, v69 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v70 = {
        "kind": "ScalarField",
        "name": "key"
    }, v71 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v72 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v73 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v74 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v73 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            },
            v35 /*: any*/ 
        ]
    }, v75 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueType",
                        "plural": false,
                        "selections": [
                            v68 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v76 = {
        "kind": "ClientExtension",
        "selections": [
            v64 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isHighlightedIssueRow"
            }
        ]
    }, v77 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v78 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v77 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v79 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v78 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v80 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraStatusField",
                "kind": "LinkedField",
                "name": "statusField",
                "plural": false,
                "selections": [
                    v44 /*: any*/ ,
                    v79 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            }
        ]
    }, v81 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "status"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v32 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v44 /*: any*/ ,
                                            v79 /*: any*/ 
                                        ],
                                        "type": "JiraStatusField"
                                    },
                                    v35 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "fieldsById(ids:[\"status\"])"
            }
        ]
    }, v82 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v83 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v84 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v32 /*: any*/ ,
            v35 /*: any*/ ,
            v70 /*: any*/ ,
            v71 /*: any*/ ,
            v72 /*: any*/ ,
            v74 /*: any*/ ,
            v75 /*: any*/ ,
            v76 /*: any*/ ,
            v80 /*: any*/ ,
            v81 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v82 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v83 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v85 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v86 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v87 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v68 /*: any*/ ,
                                    v35 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v88 = {
        "kind": "ScalarField",
        "name": "value"
    }, v89 = [
        v88 /*: any*/ ,
        v35 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v90 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v91 = {
        "kind": "ClientExtension",
        "selections": [
            v90 /*: any*/ 
        ]
    }, v92 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v93 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v94 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v95 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v96 = {
        "kind": "ScalarField",
        "name": "text"
    }, v97 = {
        "kind": "InlineFragment",
        "selections": [
            v96 /*: any*/ ,
            v68 /*: any*/ ,
            v91 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v98 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v99 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            v98 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v100 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v101 = [
        v59 /*: any*/ 
    ], v102 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v88 /*: any*/ 
        ]
    }, v103 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v104 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v105 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v106 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    }, v107 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v108 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v68 /*: any*/ ,
                    {
                        "concreteType": "JiraCascadingOption",
                        "kind": "LinkedField",
                        "name": "cascadingOption",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "parentOptionValue",
                                "plural": false,
                                "selections": v89 /*: any*/ 
                            },
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "childOptionValue",
                                "plural": false,
                                "selections": v89 /*: any*/ 
                            }
                        ]
                    },
                    v91 /*: any*/ 
                ],
                "type": "JiraCascadingSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v68 /*: any*/ ,
                    {
                        "args": v92 /*: any*/ ,
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v93 /*: any*/ ,
                                            v94 /*: any*/ ,
                                            v35 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedComponentsConnection(first:1000)"
                    },
                    v91 /*: any*/ 
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v95 /*: any*/ ,
                    v68 /*: any*/ ,
                    v91 /*: any*/ 
                ],
                "type": "JiraDateTimePickerField"
            },
            v97 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraCommentSummary",
                        "kind": "LinkedField",
                        "name": "commentSummary",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "canAddComment"
                            },
                            v59 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraCommentSummaryField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v68 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "uri"
                    },
                    v91 /*: any*/ 
                ],
                "type": "JiraUrlField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v68 /*: any*/ ,
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "fieldOption",
                        "plural": false,
                        "selections": [
                            v88 /*: any*/ ,
                            v99 /*: any*/ ,
                            v35 /*: any*/ ,
                            v100 /*: any*/ 
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionConnection",
                                "kind": "LinkedField",
                                "name": "fieldOptions",
                                "plural": false,
                                "selections": v101 /*: any*/ 
                            }
                        ]
                    },
                    v91 /*: any*/ 
                ],
                "type": "JiraSingleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v68 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v35 /*: any*/ ,
                                            v88 /*: any*/ ,
                                            v100 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v91 /*: any*/ 
                ],
                "type": "JiraMultipleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v68 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    v102 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v91 /*: any*/ 
                ],
                "type": "JiraCheckboxesField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v68 /*: any*/ ,
                    {
                        "concreteType": "JiraUserConnection",
                        "kind": "LinkedField",
                        "name": "selectedUsersConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v32 /*: any*/ ,
                                            v103 /*: any*/ ,
                                            v68 /*: any*/ ,
                                            v104 /*: any*/ ,
                                            v35 /*: any*/ ,
                                            v105 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "email"
                                                    }
                                                ],
                                                "type": "AtlassianAccountUser"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v91 /*: any*/ 
                ],
                "type": "JiraMultipleSelectUserPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v68 /*: any*/ ,
                    {
                        "concreteType": "JiraTeamView",
                        "kind": "LinkedField",
                        "name": "selectedTeam",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedName"
                            }
                        ]
                    },
                    v91 /*: any*/ 
                ],
                "type": "JiraTeamViewField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    {
                                        "concreteType": "JiraEstimate",
                                        "kind": "LinkedField",
                                        "name": "originalEstimate",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "timeInSeconds"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraTimeTrackingSettings",
                                        "kind": "LinkedField",
                                        "name": "timeTrackingSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingHoursPerDay"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingDaysPerWeek"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultFormat"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultUnit"
                                            }
                                        ]
                                    },
                                    v44 /*: any*/ ,
                                    v68 /*: any*/ ,
                                    v60 /*: any*/ ,
                                    v91 /*: any*/ 
                                ]
                            },
                            v35 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraOriginalTimeEstimateField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v68 /*: any*/ ,
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "selectedOption",
                        "plural": false,
                        "selections": [
                            v106 /*: any*/ ,
                            v35 /*: any*/ ,
                            v93 /*: any*/ 
                        ]
                    },
                    v91 /*: any*/ 
                ],
                "type": "JiraRadioSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v68 /*: any*/ ,
                    {
                        "args": v92 /*: any*/ ,
                        "concreteType": "JiraVersionConnection",
                        "kind": "LinkedField",
                        "name": "selectedVersionsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraVersionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v35 /*: any*/ ,
                                            v68 /*: any*/ ,
                                            v93 /*: any*/ ,
                                            v94 /*: any*/ ,
                                            v107 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedVersionsConnection(first:1000)"
                    },
                    v91 /*: any*/ 
                ],
                "type": "JiraMultipleVersionPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v68 /*: any*/ ,
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ 
                        ]
                    },
                    {
                        "args": v92 /*: any*/ ,
                        "concreteType": "JiraGoalConnection",
                        "kind": "LinkedField",
                        "name": "selectedGoals",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v35 /*: any*/ ,
                                            v70 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            v65 /*: any*/ 
                        ],
                        "storageKey": "selectedGoals(first:1000)"
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            v64 /*: any*/ ,
                            v90 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraGoalsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v68 /*: any*/ ,
                    {
                        "args": v92 /*: any*/ ,
                        "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                        "kind": "LinkedField",
                        "name": "confluenceRemoteIssueLinks",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v35 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "href"
                                            }
                                        ]
                                    }
                                ]
                            },
                            v59 /*: any*/ 
                        ],
                        "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                    },
                    v91 /*: any*/ 
                ],
                "type": "JiraConfluenceRemoteIssueLinksField"
            }
        ]
    }, v109 = [
        v33 /*: any*/ 
    ], v110 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": v109 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v111 = [
        v68 /*: any*/ ,
        v35 /*: any*/ 
    ], v112 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "componentsOld",
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": v111 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v96 /*: any*/ 
                ],
                "type": "JiraSingleLineTextField"
            }
        ]
    }, v113 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v114 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v68 /*: any*/ ,
            v113 /*: any*/ ,
            v91 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v115 = {
        "kind": "InlineFragment",
        "selections": [
            v95 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v116 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v70 /*: any*/ ,
                    v82 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v35 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v117 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v118 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v68 /*: any*/ ,
                    v77 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v119 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v68 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v78 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v120 = [
        v68 /*: any*/ ,
        v99 /*: any*/ 
    ], v121 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v92 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v120 /*: any*/ 
                            }
                        ]
                    },
                    v59 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v68 /*: any*/ ,
            v91 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v122 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v96 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v123 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v99 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v124 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v125 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v124 /*: any*/ ,
                    v68 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            },
            v35 /*: any*/ 
        ]
    }, v126 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v127 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v128 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v77 /*: any*/ 
        ]
    }, v129 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v70 /*: any*/ ,
                    v122 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v70 /*: any*/ ,
                            v123 /*: any*/ ,
                            v125 /*: any*/ ,
                            v122 /*: any*/ ,
                            v35 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v70 /*: any*/ ,
                            v123 /*: any*/ ,
                            v125 /*: any*/ ,
                            v122 /*: any*/ ,
                            v35 /*: any*/ ,
                            v71 /*: any*/ ,
                            v126 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "ids",
                                                "value": [
                                                    "issuetype",
                                                    "project",
                                                    "summary",
                                                    "status"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldsById",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v32 /*: any*/ ,
                                                            v35 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v44 /*: any*/ ,
                                                                    v96 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v44 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v35 /*: any*/ ,
                                                                            v127 /*: any*/ ,
                                                                            v68 /*: any*/ ,
                                                                            v124 /*: any*/ ,
                                                                            v73 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraIssueTypeField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v44 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "status",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v35 /*: any*/ ,
                                                                            v128 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraStatusField"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                    }
                                ]
                            },
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueTypeField",
                                        "kind": "LinkedField",
                                        "name": "issueTypeField",
                                        "plural": false,
                                        "selections": [
                                            v44 /*: any*/ ,
                                            {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "issueType",
                                                "plural": false,
                                                "selections": [
                                                    v127 /*: any*/ ,
                                                    v73 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraSingleLineTextField",
                                        "kind": "LinkedField",
                                        "name": "summaryField",
                                        "plural": false,
                                        "selections": [
                                            v44 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraStatusField",
                                        "kind": "LinkedField",
                                        "name": "statusField",
                                        "plural": false,
                                        "selections": [
                                            v35 /*: any*/ ,
                                            v44 /*: any*/ ,
                                            v79 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v68 /*: any*/ ,
                    v91 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v130 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v131 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v68 /*: any*/ ,
                    v130 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            },
            v68 /*: any*/ ,
            v91 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v132 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v68 /*: any*/ ,
                    v70 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v35 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v133 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v111 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v134 = [
        v35 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "sprintId"
        },
        v68 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "state"
        },
        {
            "kind": "ScalarField",
            "name": "endDate"
        }
    ], v135 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v134 /*: any*/ 
                            }
                        ]
                    }
                ]
            },
            v68 /*: any*/ ,
            v91 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v136 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v32 /*: any*/ ,
                    v103 /*: any*/ ,
                    v104 /*: any*/ ,
                    v68 /*: any*/ ,
                    v35 /*: any*/ ,
                    v105 /*: any*/ 
                ]
            },
            v68 /*: any*/ ,
            v113 /*: any*/ ,
            v91 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v137 = {
        "kind": "InlineFragment",
        "selections": [
            v68 /*: any*/ ,
            {
                "args": v92 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v111 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v138 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v139 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v68 /*: any*/ ,
                    v124 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v140 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v59 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v126 /*: any*/ ,
                                            v70 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v32 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v78 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v35 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v35 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v35 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v141 = {
        "kind": "ScalarField",
        "name": "number"
    }, v142 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v143 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v141 /*: any*/ ,
            v68 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    v141 /*: any*/ ,
                    v142 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v141 /*: any*/ ,
                    v68 /*: any*/ ,
                    v142 /*: any*/ ,
                    v91 /*: any*/ 
                ]
            },
            v91 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v144 = {
        "kind": "ScalarField",
        "name": "groupId"
    }, v145 = {
        "kind": "InlineFragment",
        "selections": [
            v68 /*: any*/ ,
            {
                "concreteType": "JiraGroupConnection",
                "kind": "LinkedField",
                "name": "selectedGroupsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    v68 /*: any*/ ,
                                    v144 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v91 /*: any*/ 
        ],
        "type": "JiraMultipleGroupPickerField"
    }, v146 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraFlag",
                        "kind": "LinkedField",
                        "name": "flag",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFlagged"
                            }
                        ]
                    }
                ],
                "type": "JiraFlagField"
            }
        ]
    }, v147 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraWatch",
                "kind": "LinkedField",
                "name": "watch",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isWatching"
                    }
                ]
            }
        ],
        "type": "JiraWatchesField"
    }, v148 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v101 /*: any*/ 
    }, v149 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v150 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v151 = [
        v32 /*: any*/ ,
        v35 /*: any*/ 
    ], v152 = {
        "args": v85 /*: any*/ ,
        "concreteType": "JiraIssueFieldSetConnection",
        "kind": "LinkedField",
        "name": "fieldSets",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v60 /*: any*/ ,
                            v38 /*: any*/ ,
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v32 /*: any*/ ,
                                                    v44 /*: any*/ ,
                                                    v60 /*: any*/ ,
                                                    v86 /*: any*/ ,
                                                    v35 /*: any*/ ,
                                                    v87 /*: any*/ ,
                                                    v108 /*: any*/ ,
                                                    v110 /*: any*/ ,
                                                    v112 /*: any*/ ,
                                                    v114 /*: any*/ ,
                                                    v115 /*: any*/ ,
                                                    v116 /*: any*/ ,
                                                    v117 /*: any*/ ,
                                                    v97 /*: any*/ ,
                                                    v118 /*: any*/ ,
                                                    v119 /*: any*/ ,
                                                    v121 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v68 /*: any*/ ,
                                                                    v83 /*: any*/ ,
                                                                    v35 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v129 /*: any*/ ,
                                                    v131 /*: any*/ ,
                                                    v132 /*: any*/ ,
                                                    v133 /*: any*/ ,
                                                    v135 /*: any*/ ,
                                                    v136 /*: any*/ ,
                                                    v137 /*: any*/ ,
                                                    v138 /*: any*/ ,
                                                    v139 /*: any*/ ,
                                                    v140 /*: any*/ ,
                                                    v143 /*: any*/ ,
                                                    v145 /*: any*/ ,
                                                    v146 /*: any*/ ,
                                                    v147 /*: any*/ ,
                                                    v65 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOptionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOptions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraOptionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v102 /*: any*/ ,
                                                                            v65 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraCheckboxesField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOption",
                                                                "kind": "LinkedField",
                                                                "name": "fieldOption",
                                                                "plural": false,
                                                                "selections": [
                                                                    v100 /*: any*/ ,
                                                                    v35 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectField"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v148 /*: any*/ 
                                ]
                            },
                            v65 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "shouldQueryConditionalFormatting",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "args": v92 /*: any*/ ,
                                                                        "concreteType": "JiraComponentConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedComponentsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponentEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraComponent",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "componentId"
                                                                                            },
                                                                                            v35 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "storageKey": "selectedComponentsConnection(first:1000)"
                                                                    }
                                                                ],
                                                                "type": "JiraComponentsField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraUserConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedUsersConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraUserEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v32 /*: any*/ ,
                                                                                            v103 /*: any*/ ,
                                                                                            v35 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraMultipleSelectUserPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraPriority",
                                                                        "kind": "LinkedField",
                                                                        "name": "priority",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v149 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraPriorityField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraProject",
                                                                        "kind": "LinkedField",
                                                                        "name": "project",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v150 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraProjectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersion",
                                                                        "kind": "LinkedField",
                                                                        "name": "version",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v107 /*: any*/ ,
                                                                            v35 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraSingleVersionPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v127 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraIssueTypeField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "args": v92 /*: any*/ ,
                                                                        "concreteType": "JiraVersionConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedVersionsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraVersionEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraVersion",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v107 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "storageKey": "selectedVersionsConnection(first:1000)"
                                                                    }
                                                                ],
                                                                "type": "JiraMultipleVersionPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedValue",
                                                                        "plural": false,
                                                                        "selections": v151 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "JiraSingleSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSelectableValueConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedValues",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSelectableValueEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": v151 /*: any*/ 
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraMultipleSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraOption",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedOption",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v106 /*: any*/ ,
                                                                            v35 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraRadioSelectField"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldSets(first:500)"
    }, v153 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v154 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v155 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v153 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            v154 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            }
        ]
    }, v156 = {
        "concreteType": "JiraIssueNavigatorPageInfo",
        "kind": "LinkedField",
        "name": "issueNavigatorPageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "firstIssuePosition"
            },
            {
                "kind": "ScalarField",
                "name": "lastIssuePosition"
            }
        ]
    }, v157 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v158 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v159 = [
        v157 /*: any*/ ,
        v69 /*: any*/ ,
        v158 /*: any*/ 
    ], v160 = {
        "args": [
            {
                "kind": "Literal",
                "name": "maxCursors",
                "value": 7
            }
        ],
        "concreteType": "JiraPageCursors",
        "kind": "LinkedField",
        "name": "pageCursors",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": v159 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "last",
                "plural": false,
                "selections": v159 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "first",
                "plural": false,
                "selections": [
                    v69 /*: any*/ ,
                    v157 /*: any*/ ,
                    v158 /*: any*/ 
                ]
            }
        ],
        "storageKey": "pageCursors(maxCursors:7)"
    }, v161 = {
        "kind": "ScalarField",
        "name": "totalIssueSearchResultCount"
    }, v162 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v32 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ],
                "type": "JiraInvalidSyntaxError"
            },
            {
                "kind": "InlineFragment",
                "selections": v109 /*: any*/ ,
                "type": "JiraServerError"
            }
        ]
    }, v163 = {
        "kind": "ScalarField",
        "name": "isCappingIssueSearchResult"
    }, v164 = [
        "issueSearchInput"
    ], v165 = [
        v48 /*: any*/ ,
        v49 /*: any*/ ,
        v51 /*: any*/ ,
        v42 /*: any*/ ,
        v31 /*: any*/ ,
        v52 /*: any*/ ,
        v54 /*: any*/ ,
        v40 /*: any*/ 
    ], v166 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v167 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v38 /*: any*/ 
        ]
    }, v168 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v32 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v62 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "label",
                                "plural": false,
                                "selections": v120 /*: any*/ 
                            }
                        ],
                        "type": "JiraJqlLabelFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "group",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    v144 /*: any*/ ,
                                    v68 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlGroupFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    v107 /*: any*/ ,
                                    v68 /*: any*/ 
                                ]
                            },
                            v61 /*: any*/ 
                        ],
                        "type": "JiraJqlVersionFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v61 /*: any*/ ,
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "option",
                                "plural": false,
                                "selections": [
                                    v88 /*: any*/ ,
                                    v35 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlOptionFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueTypes",
                                "plural": true,
                                "selections": [
                                    v68 /*: any*/ ,
                                    v83 /*: any*/ ,
                                    v35 /*: any*/ ,
                                    v127 /*: any*/ ,
                                    v73 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlIssueTypeFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v61 /*: any*/ ,
                            {
                                "concreteType": "JiraResolution",
                                "kind": "LinkedField",
                                "name": "resolution",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    v68 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlResolutionFieldValue"
                    }
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ ,
                            v149 /*: any*/ ,
                            v68 /*: any*/ ,
                            v130 /*: any*/ 
                        ]
                    },
                    v61 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v32 /*: any*/ ,
                            v35 /*: any*/ ,
                            v103 /*: any*/ ,
                            v68 /*: any*/ ,
                            v104 /*: any*/ 
                        ]
                    },
                    v61 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ ,
                            v68 /*: any*/ ,
                            v128 /*: any*/ 
                        ]
                    },
                    v61 /*: any*/ ,
                    v78 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v141 /*: any*/ 
                ],
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ ,
                            v100 /*: any*/ ,
                            v88 /*: any*/ ,
                            v99 /*: any*/ 
                        ]
                    },
                    v61 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": v134 /*: any*/ 
                    },
                    v61 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            }
                        ]
                    },
                    v61 /*: any*/ 
                ],
                "type": "JiraJqlGoalsFieldValue"
            }
        ]
    }, v169 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v170 = [
        v50 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        v36 /*: any*/ ,
        v40 /*: any*/ 
    ], v171 = [
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                v83 /*: any*/ ,
                v68 /*: any*/ ,
                v35 /*: any*/ 
            ]
        }
    ], v172 = [
        v48 /*: any*/ ,
        v49 /*: any*/ ,
        v50 /*: any*/ ,
        v51 /*: any*/ ,
        v31 /*: any*/ ,
        v52 /*: any*/ ,
        v53 /*: any*/ ,
        v54 /*: any*/ ,
        v40 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v173 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "feature",
                    "variableName": "atlassianIntelligenceProductFeature"
                }
            ],
            "kind": "ObjectValue",
            "name": "atlassianIntelligenceProductFeatureInput"
        },
        v27 /*: any*/ 
    ], v174 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "args": [
                        v25 /*: any*/ ,
                        v26 /*: any*/ ,
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys.0",
                                    "variableName": "projectKey"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "projectKeys"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_issueQuery"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v28 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_IssueNavigator_userPreferences"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_jira"
                        },
                        {
                            "condition": "shouldQueryProject",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v29 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                v25 /*: any*/ 
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "main_issueNavigator_IssueNavigatorUI_project"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "issueSearch_issueNavigatorProject"
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormatting",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v30 /*: any*/ ,
                                                    "kind": "FragmentSpread",
                                                    "name": "container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v11 /*: any*/ ,
                v8 /*: any*/ ,
                v12 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v13 /*: any*/ ,
                v23 /*: any*/ ,
                v14 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v15 /*: any*/ ,
                v20 /*: any*/ ,
                v18 /*: any*/ ,
                v10 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v16 /*: any*/ ,
                v9 /*: any*/ ,
                v19 /*: any*/ ,
                v6 /*: any*/ ,
                v24 /*: any*/ ,
                v17 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraissuenavigatorsavedfiltersmenuenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v27 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "filterId",
                                    "variableName": "filterId"
                                },
                                v31 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "namespace",
                                    "variableName": "namespace"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewConfigInput",
                                    "variableName": "staticViewInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewId",
                                    "variableName": "viewId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewQueryInput",
                                    "variableName": "viewQueryInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "jiraIssueSearchView",
                            "plural": false,
                            "selections": [
                                v32 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraView"
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "error",
                                    "plural": false,
                                    "selections": v34 /*: any*/ 
                                },
                                v35 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "viewId"
                                        },
                                        {
                                            "args": v37 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraFieldSetPreferences",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetPreferences",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isFrozen"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canPublishViewConfig"
                                                },
                                                v39 /*: any*/ ,
                                                {
                                                    "args": [
                                                        v40 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "isViewConfigModified"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v41 /*: any*/ ,
                                                        {
                                                            "args": v43 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v45 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v47 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v55 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": [
                                                                v41 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraDetailedView"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": v56 /*: any*/ 
                                        }
                                    ],
                                    "type": "JiraIssueSearchViewMetadata",
                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v43 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                            "kind": "LinkedField",
                                            "name": "viewSettings",
                                            "plural": false,
                                            "selections": [
                                                v57 /*: any*/ ,
                                                v58 /*: any*/ ,
                                                v45 /*: any*/ ,
                                                v47 /*: any*/ ,
                                                v46 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": [
                                                        v36 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "hasDefaultFieldSets"
                                                },
                                                {
                                                    "args": v37 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v59 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v60 /*: any*/ ,
                                                                        v61 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v61 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v63 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldsMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueSearchMetadataField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canBeConfigured"
                                                                                                        },
                                                                                                        v44 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isPlaceHolderField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v65 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v66 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v43 /*: any*/ ,
                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "viewSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v47 /*: any*/ ,
                                                                        v67 /*: any*/ ,
                                                                        v57 /*: any*/ ,
                                                                        v58 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSpreadsheetView",
                                                            "abstractKey": "__isJiraSpreadsheetView"
                                                        }
                                                    ]
                                                },
                                                v66 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v43 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v46 /*: any*/ ,
                                                                v67 /*: any*/ ,
                                                                v45 /*: any*/ ,
                                                                v47 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canEnableReranking"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                },
                                                v65 /*: any*/ 
                                            ],
                                            "type": "JiraIssueSearchViewMetadata",
                                            "abstractKey": "__isJiraIssueSearchViewMetadata"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v41 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "filterId"
                                                        },
                                                        {
                                                            "args": v43 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroupByConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "groupByConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraField",
                                                                            "kind": "LinkedField",
                                                                            "name": "groupByField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v68 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "typeKey"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                }
                                            ],
                                            "type": "JiraView",
                                            "abstractKey": "__isJiraView"
                                        }
                                    ],
                                    "type": "JiraSpreadsheetView",
                                    "abstractKey": "__isJiraSpreadsheetView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v55 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v69 /*: any*/ ,
                                                        v84 /*: any*/ ,
                                                        v32 /*: any*/ ,
                                                        v152 /*: any*/ ,
                                                        v65 /*: any*/ 
                                                    ]
                                                },
                                                v155 /*: any*/ ,
                                                v156 /*: any*/ ,
                                                v160 /*: any*/ ,
                                                v161 /*: any*/ ,
                                                v162 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                v163 /*: any*/ ,
                                                v65 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v55 /*: any*/ ,
                                            "filters": v164 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorDetailedViewPagination__issues",
                                            "kind": "LinkedHandle",
                                            "name": "issues"
                                        }
                                    ],
                                    "type": "JiraDetailedView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v165 /*: any*/ ,
                                            "concreteType": "JiraSpreadsheetGroupConnection",
                                            "kind": "LinkedField",
                                            "name": "groups",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSpreadsheetGroupEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v69 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroup",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v32 /*: any*/ ,
                                                                v35 /*: any*/ ,
                                                                v41 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v166 /*: any*/ ,
                                                                v167 /*: any*/ ,
                                                                v168 /*: any*/ ,
                                                                v169 /*: any*/ 
                                                            ]
                                                        },
                                                        v32 /*: any*/ 
                                                    ]
                                                },
                                                v155 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "groupByField"
                                                },
                                                v41 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v34 /*: any*/ 
                                                },
                                                {
                                                    "condition": "isPaginating",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroup",
                                                            "kind": "LinkedField",
                                                            "name": "firstGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                {
                                                                    "args": v170 /*: any*/ ,
                                                                    "concreteType": "JiraIssueConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "issues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v32 /*: any*/ ,
                                                                                v69 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v32 /*: any*/ ,
                                                                                        v35 /*: any*/ ,
                                                                                        v70 /*: any*/ ,
                                                                                        v71 /*: any*/ ,
                                                                                        v72 /*: any*/ ,
                                                                                        v74 /*: any*/ ,
                                                                                        v75 /*: any*/ ,
                                                                                        v76 /*: any*/ ,
                                                                                        v80 /*: any*/ ,
                                                                                        v81 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "args": v85 /*: any*/ ,
                                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldSets",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v60 /*: any*/ ,
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fields",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v32 /*: any*/ ,
                                                                                                                                v44 /*: any*/ ,
                                                                                                                                v60 /*: any*/ ,
                                                                                                                                v86 /*: any*/ ,
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                v87 /*: any*/ ,
                                                                                                                                v108 /*: any*/ ,
                                                                                                                                v110 /*: any*/ ,
                                                                                                                                v112 /*: any*/ ,
                                                                                                                                v114 /*: any*/ ,
                                                                                                                                v115 /*: any*/ ,
                                                                                                                                v116 /*: any*/ ,
                                                                                                                                v117 /*: any*/ ,
                                                                                                                                v97 /*: any*/ ,
                                                                                                                                v118 /*: any*/ ,
                                                                                                                                v119 /*: any*/ ,
                                                                                                                                v121 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                                                                    "kind": "Condition",
                                                                                                                                                    "passingValue": true,
                                                                                                                                                    "selections": v171 /*: any*/ 
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": false,
                                                                                                                                            "selections": v171 /*: any*/ 
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                                },
                                                                                                                                v129 /*: any*/ ,
                                                                                                                                v131 /*: any*/ ,
                                                                                                                                v132 /*: any*/ ,
                                                                                                                                v133 /*: any*/ ,
                                                                                                                                v135 /*: any*/ ,
                                                                                                                                v136 /*: any*/ ,
                                                                                                                                v137 /*: any*/ ,
                                                                                                                                v138 /*: any*/ ,
                                                                                                                                v139 /*: any*/ ,
                                                                                                                                v140 /*: any*/ ,
                                                                                                                                v143 /*: any*/ ,
                                                                                                                                v145 /*: any*/ ,
                                                                                                                                v146 /*: any*/ ,
                                                                                                                                v147 /*: any*/ ,
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v148 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "fieldSets(first:500)"
                                                                                },
                                                                                v65 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "PageInfo",
                                                                            "kind": "LinkedField",
                                                                            "name": "pageInfo",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v153 /*: any*/ ,
                                                                                v154 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v161 /*: any*/ ,
                                                                        v163 /*: any*/ ,
                                                                        v65 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": v170 /*: any*/ ,
                                                                    "filters": [
                                                                        "fieldSetsInput",
                                                                        "scope",
                                                                        "settings"
                                                                    ],
                                                                    "handle": "connection",
                                                                    "key": "firstGroupSection_nativeIssueTable__issues",
                                                                    "kind": "LinkedHandle",
                                                                    "name": "issues"
                                                                },
                                                                v41 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v166 /*: any*/ ,
                                                                v168 /*: any*/ ,
                                                                v169 /*: any*/ ,
                                                                v167 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v65 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v165 /*: any*/ ,
                                            "filters": v164 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorGroupedListViewPagination__groups",
                                            "kind": "LinkedHandle",
                                            "name": "groups"
                                        }
                                    ],
                                    "type": "JiraGroupedListView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v172 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v69 /*: any*/ ,
                                                        v84 /*: any*/ ,
                                                        v32 /*: any*/ ,
                                                        v152 /*: any*/ ,
                                                        {
                                                            "condition": "shouldQueryHasChildren",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "items": [
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "filterByProjectKeys.0",
                                                                                    "variableName": "projectKey"
                                                                                }
                                                                            ],
                                                                            "kind": "ListValue",
                                                                            "name": "filterByProjectKeys"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "hasChildren"
                                                                },
                                                                {
                                                                    "args": [
                                                                        v26 /*: any*/ 
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "canHaveChildIssues"
                                                                }
                                                            ]
                                                        },
                                                        v65 /*: any*/ 
                                                    ]
                                                },
                                                v155 /*: any*/ ,
                                                v156 /*: any*/ ,
                                                v160 /*: any*/ ,
                                                v161 /*: any*/ ,
                                                v162 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                v163 /*: any*/ ,
                                                v65 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v172 /*: any*/ ,
                                            "filters": v164 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorListViewPagination__issues",
                                            "kind": "LinkedHandle",
                                            "name": "issues"
                                        }
                                    ],
                                    "type": "JiraListView"
                                }
                            ]
                        },
                        {
                            "args": v28 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jqlBuilderSearchMode"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isNaturalLanguageSpotlightTourEnabled"
                                },
                                v65 /*: any*/ 
                            ]
                        },
                        {
                            "args": v173 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "shouldShowAtlassianIntelligence"
                        },
                        {
                            "args": v173 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "atlassianIntelligenceAction",
                            "plural": false,
                            "selections": [
                                v32 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isAccessible"
                                        }
                                    ],
                                    "type": "JiraAccessAtlassianIntelligenceFeature"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "link"
                                        }
                                    ],
                                    "type": "JiraEnableAtlassianIntelligenceDeepLink"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v28 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldWithAliases",
                                    "kind": "LinkedField",
                                    "name": "rankField",
                                    "plural": false,
                                    "selections": [
                                        v44 /*: any*/ ,
                                        v62 /*: any*/ ,
                                        v63 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "shouldQueryProject",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v29 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        v70 /*: any*/ ,
                                        v150 /*: any*/ ,
                                        {
                                            "alias": "createIssues",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "CREATE_ISSUES"
                                                }
                                            ],
                                            "concreteType": "JiraProjectAction",
                                            "kind": "LinkedField",
                                            "name": "action",
                                            "plural": false,
                                            "selections": v174 /*: any*/ ,
                                            "storageKey": "action(type:\"CREATE_ISSUES\")"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectType"
                                        },
                                        v35 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "editIssues",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v174 /*: any*/ ,
                                                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormatting",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v30 /*: any*/ ,
                                                    "concreteType": "JiraFormattingRuleConnection",
                                                    "kind": "LinkedField",
                                                    "name": "conditionalFormattingRules",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFormattingRuleEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFormattingRule",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "expression",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v32 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v44 /*: any*/ ,
                                                                                        {
                                                                                            "alias": "singleValueOperator",
                                                                                            "kind": "ScalarField",
                                                                                            "name": "operator"
                                                                                        },
                                                                                        v88 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraFormattingSingleValueOperand"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v44 /*: any*/ ,
                                                                                        {
                                                                                            "alias": "multipleValueOperator",
                                                                                            "kind": "ScalarField",
                                                                                            "name": "operator"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "values"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraFormattingMultipleValueOperand"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v44 /*: any*/ ,
                                                                                        {
                                                                                            "alias": "noValueOperator",
                                                                                            "kind": "ScalarField",
                                                                                            "name": "operator"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraFormattingNoValueOperand"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "formattingArea"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraColor",
                                                                            "kind": "LinkedField",
                                                                            "name": "formattingColor",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v35 /*: any*/ ,
                                                                                v98 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v35 /*: any*/ 
                                                                    ]
                                                                },
                                                                v32 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "conditionalFormattingRules(first:20)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5f34a9b4af83a44f1b25def3f0ab41fa0b9576c9096360a6c789aae8396e6171",
            "metadata": {},
            "name": "main_IssueNavigatorQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": (0, $iiQfx.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx": (0, $lcRgI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider": (0, $eylLg.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $7lcgt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider": (0, $4MVMw.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider": (0, $cqnj8.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $kmr3r.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": (0, $clCUA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider": (0, $bFEtW.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraissuenavigatorsavedfiltersmenuenabledrelayprovider": (0, $1vgnN.default)
            }
        }
    };
}();
$04e26ee18435d3dd$var$node.hash = "f3aa42dddc117ba37540772297f61801";
var $04e26ee18435d3dd$export$2e2bcd8739ae039 = $04e26ee18435d3dd$var$node;

});
parcelRegister("bFEtW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d13fab2ad1861152$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $d13fab2ad1861152$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('group_by_any_fields_technical');
    }
};

});

parcelRegister("lcRgI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5044a43d32ddc421$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $5044a43d32ddc421$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('issue_table_frozen_columns');
    }
};

});

parcelRegister("1vgnN", function(module, exports) {

$parcel$export(module.exports, "default", () => $39ab5c277de2fbb0$export$2e2bcd8739ae039);

var $epTsa = parcelRequire("epTsa");
var $39ab5c277de2fbb0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $epTsa.expVal)('jira-issue-navigator-saved-filters-menu', 'isEnabled', false);
    }
};

});

parcelRegister("eylLg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5026bc93a9dbae2$export$2e2bcd8739ae039);

var $epTsa = parcelRequire("epTsa");
var $f5026bc93a9dbae2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $epTsa.expVal)('saved_list_view', 'isEnabled', false);
    }
};

});

parcelRegister("4MVMw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1d5368f37f136cb$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $f1d5368f37f136cb$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding');
    }
};

});

parcelRegister("iiQfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2f41d418b65dd3d$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $f2f41d418b65dd3d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('saved_list_view_technical_changes');
    }
};

});

parcelRegister("kmr3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $828374d45db0f539$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $828374d45db0f539$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jsc_list_reparenting');
    }
};

});

parcelRegister("cqnj8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dc2689c4189780e$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $0dc2689c4189780e$var$JscIssueRankingRelayProvider = {
    get () {
        return (0, $7jTnu.fg)('jsc_list_reranking_gate');
    }
};
var $0dc2689c4189780e$export$2e2bcd8739ae039 = $0dc2689c4189780e$var$JscIssueRankingRelayProvider;

});


parcelRegister("9S9Cb", function(module, exports) {

$parcel$export(module.exports, "createViewAri", () => $6c29cdb9d8abd803$export$8e9e81ca81fb9409);

var $496yH = parcelRequire("496yH");

var $7jTnu = parcelRequire("7jTnu");

var $4ihOZ = parcelRequire("4ihOZ");

var $kEUB1 = parcelRequire("kEUB1");

var $kfvK2 = parcelRequire("kfvK2");
const $6c29cdb9d8abd803$var$useViewItemId = (0, $kfvK2.createRouterSelector)((state)=>state.match?.params?.itemId);
const $6c29cdb9d8abd803$export$8e9e81ca81fb9409 = ({ activationId: activationId, cloudId: cloudId, layout: layout, projectId: projectId, viewItemId: viewItemId })=>{
    const layoutPart = layout ? `/layout/${layout}` : '';
    if (projectId) {
        const viewItemIdPart = viewItemId ? `/${viewItemId}` : '';
        return (0, $496yH.JiraViewAri).create({
            activationId: activationId,
            scopeId: `${projectId}/${(0, $7jTnu.fg)('jira_list_nin_merge') ? 'list' : 'issues'}${viewItemIdPart}${layoutPart}`,
            scopeType: 'project',
            siteId: cloudId
        }).toString();
    }
    return (0, $496yH.JiraViewAri).create({
        activationId: activationId,
        scopeId: `issue-navigator${layoutPart}`,
        scopeType: 'global',
        siteId: cloudId
    }).toString();
};
const $6c29cdb9d8abd803$export$b6b78fb187396ce9 = ({ layout: layout, projectId: projectId })=>{
    const activationId = (0, $4ihOZ.useActivationId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const viewItemId = $6c29cdb9d8abd803$var$useViewItemId();
    return $6c29cdb9d8abd803$export$8e9e81ca81fb9409({
        activationId: activationId,
        cloudId: cloudId,
        layout: layout,
        projectId: projectId,
        viewItemId: viewItemId
    });
};

});
parcelRegister("496yH", function(module, exports) {

$parcel$export(module.exports, "JiraViewAri", () => $304d171cb4c80fb0$export$259cce321cdbcc);

var $l6thc = parcelRequire("l6thc");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/view/manifest.ts
var $304d171cb4c80fb0$var$jiraViewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $l6thc.JiraViewAriResourceOwner),
    resourceType: (0, $l6thc.JiraViewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{scopeType}/{scopeId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        scopeType: /(global|project|board)/,
        // eslint-disable-line no-useless-escape
        scopeId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/view/index.ts
var $304d171cb4c80fb0$export$259cce321cdbcc = class _JiraViewAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._scopeType = opts.resourceIdSegmentValues.scopeType, this._scopeId = opts.resourceIdSegmentValues.scopeId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get scopeType() {
        return this._scopeType;
    }
    get scopeId() {
        return this._scopeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $304d171cb4c80fb0$var$jiraViewAriStaticOpts.qualifier,
            platformQualifier: $304d171cb4c80fb0$var$jiraViewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $304d171cb4c80fb0$var$jiraViewAriStaticOpts.resourceOwner,
            resourceType: $304d171cb4c80fb0$var$jiraViewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.scopeType}/${opts.scopeId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                scopeType: opts.scopeType,
                scopeId: opts.scopeId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $304d171cb4c80fb0$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $304d171cb4c80fb0$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            scopeType: this.scopeType,
            scopeId: this.scopeId
        };
    }
};

});
parcelRegister("l6thc", function(module, exports) {

$parcel$export(module.exports, "JiraViewAriResourceOwner", () => $f5d0de35c3dbae2a$export$c63cbf12e88f62b6);
$parcel$export(module.exports, "JiraViewAriResourceType", () => $f5d0de35c3dbae2a$export$4b456bf9436bd47e);
// src/jira/view/types.ts
var $f5d0de35c3dbae2a$export$c63cbf12e88f62b6 = "jira", $f5d0de35c3dbae2a$export$4b456bf9436bd47e = "view";

});



parcelRegister("2HIMw", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY", () => $bdc751863d77333a$export$c300d3b7f3dc697d);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY", () => $bdc751863d77333a$export$b99d8b4e19091835);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY", () => $bdc751863d77333a$export$1b65799bbeba8a33);
$parcel$export(module.exports, "defaultOrderFields", () => $bdc751863d77333a$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "sortDirections", () => $bdc751863d77333a$export$73034536b9adc928);
const $bdc751863d77333a$export$c300d3b7f3dc697d = 'ISSUE_NAVIGATOR_RELAY';
const $bdc751863d77333a$export$b99d8b4e19091835 = 'ISSUE_NAVIGATOR_FILTER_RELAY';
const $bdc751863d77333a$export$1b65799bbeba8a33 = 'ISSUE_NAVIGATOR_HYDRATION_RELAY';
const $bdc751863d77333a$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $bdc751863d77333a$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};

});

parcelRegister("lzktc", function(module, exports) {

$parcel$export(module.exports, "getDefaultJqlGin", () => $cc65a5b5e9f5208f$export$8780b1523384f42d);
$parcel$export(module.exports, "getParams", () => $cc65a5b5e9f5208f$export$ec161d740909e39d);
$parcel$export(module.exports, "getJqlOrFilterId", () => $cc65a5b5e9f5208f$export$b968a035fc2aa57b);
$parcel$export(module.exports, "isChromelessRoute", () => $cc65a5b5e9f5208f$export$cc6019019381b4fd);
/* eslint-disable jira/import-whitelist */ 
var $82cqT = parcelRequire("82cqT");

var $ljej9 = parcelRequire("ljej9");

var $hLPih = parcelRequire("hLPih");

var $7jTnu = parcelRequire("7jTnu");

var $2HIMw = parcelRequire("2HIMw");
const $cc65a5b5e9f5208f$export$8780b1523384f42d = ()=>`ORDER BY ${(0, $2HIMw.defaultOrderFields).created} ${(0, $2HIMw.sortDirections).DESC}`;
const $cc65a5b5e9f5208f$export$ec161d740909e39d = ({ match: { params: params }, query: query })=>{
    const { projectKey: projectKey } = params;
    const { filter: filter, jql: jql, selectedIssue: selectedIssue, groupBy: groupBy, hideDone: hideDone } = query;
    // Default JQL when no relevant query parameter is set
    const defaultJql = projectKey !== null && projectKey !== undefined ? (0, $hLPih.getDefaultJql)((0, $ljej9.toProjectKey)(projectKey)) : $cc65a5b5e9f5208f$export$8780b1523384f42d();
    return {
        page: 1,
        jql: jql,
        issueKey: selectedIssue,
        projectKey: projectKey,
        filter: filter,
        defaultJql: defaultJql,
        ...(0, $7jTnu.fg)('jsc_list_query_param_merge') && {
            groupBy: groupBy,
            hideDone: hideDone === 'true' || hideDone === 'false' ? hideDone === 'true' : undefined
        }
    };
};
const $cc65a5b5e9f5208f$export$b968a035fc2aa57b = (defaultJql, jqlParam, filter, projectKey)=>{
    // If JQL param has been defined (even if it's empty) we should use it
    if (typeof jqlParam === 'string') return {
        jql: jqlParam
    };
    // If filter is non-empty then use the filter parameter
    if (typeof filter === 'string' && filter !== '') {
        if ((0, $82cqT.isFilterId)(filter)) return {
            filterId: filter
        };
        const filterJql = projectKey !== null && projectKey !== undefined ? (0, $hLPih.mapFilterToJql)(projectKey, filter) : undefined;
        if (filterJql !== undefined) return {
            jql: filterJql
        };
    }
    // Fallback to the default JQL if neither JQL or valid filter parameters have been provided.
    return {
        jql: defaultJql
    };
};
const $cc65a5b5e9f5208f$export$cc6019019381b4fd = ({ route: route })=>{
    return route.layout?.isChromeless ?? false;
};

});
parcelRegister("hLPih", function(module, exports) {

$parcel$export(module.exports, "isFilterKey", () => $c803067837d15823$export$2cad587bb603edda);
$parcel$export(module.exports, "mapFilterToJql", () => $c803067837d15823$export$1d71dda738f608f);
$parcel$export(module.exports, "getDefaultJql", () => $c803067837d15823$export$346d50fe8350b1d0);
$parcel$export(module.exports, "getUrlPrefix", () => $c803067837d15823$export$821d4141d135e0d0);

var $b5RwB = parcelRequire("b5RwB");

var $iRahl = parcelRequire("iRahl");

var $64ivx = parcelRequire("64ivx");
const $c803067837d15823$export$2cad587bb603edda = (filter)=>typeof filter === 'string' && filter in (0, $64ivx.Filters);
const $c803067837d15823$export$1d71dda738f608f = (projectKey, filter)=>{
    if (!$c803067837d15823$export$2cad587bb603edda(filter)) return undefined;
    const clauses = [
        `project = "${projectKey}"`
    ];
    let order = (0, $iRahl.DEFAULT_ORDER_FIELD);
    const direction = (0, $iRahl.DEFAULT_SORT_DIRECTION);
    switch((0, $64ivx.Filters)[filter]){
        case (0, $64ivx.Filters).myopenissues:
            clauses.push('assignee IN (currentUser())');
            clauses.push(`statusCategory IN (${(0, $64ivx.StatusCategoryValues).TO_DO}, ${(0, $64ivx.StatusCategoryValues).IN_PROGRESS})`);
            break;
        case (0, $64ivx.Filters).reportedbyme:
            clauses.push('reporter IN (currentUser())');
            break;
        case (0, $64ivx.Filters).allopenissues:
            clauses.push(`statusCategory IN (${(0, $64ivx.StatusCategoryValues).TO_DO}, ${(0, $64ivx.StatusCategoryValues).IN_PROGRESS})`);
            order = (0, $iRahl.defaultOrderFields).updated;
            break;
        case (0, $64ivx.Filters).doneissues:
            clauses.push(`statusCategory = ${(0, $64ivx.StatusCategoryValues).DONE}`);
            break;
        case (0, $64ivx.Filters).recentlyviewed:
            order = (0, $iRahl.defaultOrderFields).lastviewed;
            break;
        case (0, $64ivx.Filters).resolvedrecently:
            clauses.push('resolved >= -1w');
            order = (0, $iRahl.defaultOrderFields).updated;
            break;
        case (0, $64ivx.Filters).updatedrecently:
            order = (0, $iRahl.defaultOrderFields).updated;
            break;
        case (0, $64ivx.Filters).allissues:
            order = (0, $iRahl.defaultOrderFields).created;
            break;
        default:
    }
    return `${clauses.join(' AND ')} ORDER BY ${order} ${direction}`.trim();
};
const $c803067837d15823$export$346d50fe8350b1d0 = (projectKey)=>`project = "${projectKey}" ORDER BY ${0, $iRahl.DEFAULT_ORDER_FIELD} ${0, $iRahl.DEFAULT_SORT_DIRECTION}`;
const $c803067837d15823$export$e5b4f9d05e643346 = (search, match)=>({
        ...(0, $b5RwB.parse)(search),
        ...match && match.params
    });
const $c803067837d15823$export$821d4141d135e0d0 = (url)=>{
    const match = url.match(/^(.*)\/projects.*$/);
    return (match && match[1]) ?? '';
};

});
parcelRegister("64ivx", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $c7fcd0af44be8211$export$92a576f896a9bf72);
$parcel$export(module.exports, "StatusCategoryValues", () => $c7fcd0af44be8211$export$72d6e2acce8f36fd);
const $c7fcd0af44be8211$export$92a576f896a9bf72 = {
    myopenissues: Symbol('myopenissues'),
    reportedbyme: Symbol('reportedbyme'),
    allopenissues: Symbol('allopenissues'),
    doneissues: Symbol('doneissues'),
    recentlyviewed: Symbol('recentlyviewed'),
    resolvedrecently: Symbol('resolvedrecently'),
    updatedrecently: Symbol('updatedrecently'),
    allissues: Symbol('allissues')
};
const $c7fcd0af44be8211$export$72d6e2acce8f36fd = {
    TO_DO: '"To Do"',
    DONE: '"Done"',
    IN_PROGRESS: '"In Progress"'
};

});





parcelRegister("d4NVH", function(module, exports) {

$parcel$export(module.exports, "getRouteReporting", () => $3aaa8bb9c2bc5949$export$1300cb25a03c28fe);
const $3aaa8bb9c2bc5949$export$1300cb25a03c28fe = ()=>({
        id: 'issue-navigator',
        packageName: 'issueNavigator',
        teamName: 'empanada'
    });

});

parcelRegister("dq5jm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9029fb076dae25f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");

var $gCY1z = parcelRequire("gCY1z");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e9029fb076dae25f$export$2e2bcd8739ae039 = ()=>{
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    const issueKey = match.params.issueKey ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/issues/${issueKey}`
    });
};

});

parcelRegister("fYGKn", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorGinRedirectPageEntryPoint", () => $f8b6617ed5804749$export$f0e4197c4e8c99ac);
$parcel$export(module.exports, "issueNavigatorPageEntryPoint", () => $f8b6617ed5804749$export$b75ca1c5551bc52f);
$parcel$export(module.exports, "issueNavigatorPageEntryPointWithNested", () => $f8b6617ed5804749$export$6f6d14ffd6415d3f);
$parcel$export(module.exports, "issueNavigatorWithoutHorizontalNavPageEntryPoint", () => $f8b6617ed5804749$export$ebe022658b1c5d7a);
$parcel$export(module.exports, "issueNavigatorPinRedirectPageEntryPoint", () => $f8b6617ed5804749$export$a90e8f2ed95763c3);
$parcel$export(module.exports, "issueNavigatorEmbedPageEntryPoint", () => $f8b6617ed5804749$export$650aa18210eea5a8);
$parcel$export(module.exports, "LazyGlobalIssueNavigator", () => $f8b6617ed5804749$export$8ff267588532c2ce);

var $gzcjr = parcelRequire("gzcjr");

var $j3LTu = parcelRequire("j3LTu");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");

var $4ZT9l = parcelRequire("4ZT9l");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");

var $aDQ9G = parcelRequire("aDQ9G");

var $efo1i = parcelRequire("efo1i");
const $f8b6617ed5804749$export$f0e4197c4e8c99ac = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $aDQ9G.globalIssueNavigatorGinRedirectEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).FILTERS
});
const $f8b6617ed5804749$export$b75ca1c5551bc52f = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $j3LTu.issueNavigatorEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $f8b6617ed5804749$export$6f6d14ffd6415d3f = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $j3LTu.issueNavigatorEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $f8b6617ed5804749$export$ebe022658b1c5d7a = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $j3LTu.issueNavigatorEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $f8b6617ed5804749$export$a90e8f2ed95763c3 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $efo1i.issueNavigatorPinRedirectEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $f8b6617ed5804749$export$650aa18210eea5a8 = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $4ZT9l.issueNavigatorEmbedEntrypoint)
});

const $f8b6617ed5804749$export$8ff267588532c2ce = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8hhLE")), {
    moduleId: "./src/packages/spa-apps/issue-navigator/global-issue-navigator/src/index.tsx"
});

});
parcelRegister("j3LTu", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorEntrypoint", () => $4cef8257e9e53d42$export$4ec136b0c737540b);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $gvzJT = parcelRequire("gvzJT");

var $7jTnu = parcelRequire("7jTnu");

var $4G2FD = parcelRequire("4G2FD");

const $4cef8257e9e53d42$export$4ec136b0c737540b = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("9PnMh")), {
        moduleId: "7afd1266",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        const issueKey = entryPointParams?.context?.query?.selectedIssue;
        let preloadProps = {};
        // exclude nativeIssueTableEntryPoint and jqlBuilderWithAiEntryPoint from preloading on the issue route
        if (!issueKey) preloadProps = {
            entryPoints: {
                nativeIssueTableEntryPoint: {
                    entryPoint: (0, $gvzJT.nativeIssueTableEntryPoint),
                    entryPointParams: entryPointParams
                },
                ...(0, $7jTnu.fg)('jql_builder_basic_ssr_stability_fixes') ? {
                    jqlBuilderWithAiEntryPoint: {
                        entryPoint: (0, $4G2FD.jqlBuilderWithAiEntryPoint),
                        entryPointParams: entryPointParams
                    }
                } : {}
            }
        };
        return preloadProps;
    }
});

});
parcelRegister("gvzJT", function(module, exports) {

$parcel$export(module.exports, "nativeIssueTableEntryPoint", () => $80cad17c8d3185b4$export$df35b18d762f614);

var $4BK1O = parcelRequire("4BK1O");

var $j3Ybe = parcelRequire("j3Ybe");

const $80cad17c8d3185b4$export$df35b18d762f614 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("exlCl")).then((module)=>module.NativeIssueTableEntryPoint), {
        moduleId: "b6718107",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("exlCl", function(module, exports) {

let $a954ea8b35f70fcf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $a954ea8b35f70fcf$var$load("1VRB2"),
    $a954ea8b35f70fcf$var$load("bABhq"),
    $a954ea8b35f70fcf$var$load("eDzss"),
    $a954ea8b35f70fcf$var$load("9yzwZ")
]).then(()=>parcelRequire('go5Mj'));

});


parcelRegister("4G2FD", function(module, exports) {

$parcel$export(module.exports, "jqlBuilderWithAiEntryPoint", () => $fd934fe77cb1c7d8$export$43f8e092231523ab);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $fd934fe77cb1c7d8$export$43f8e092231523ab = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("leU9u")).then((module)=>module.JQLBuilderWithAIEntryPoint), {
        moduleId: "e6ce66ee",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("leU9u", function(module, exports) {

let $f766766dc17670c8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $f766766dc17670c8$var$load("1VRB2"),
    $f766766dc17670c8$var$load("bABhq"),
    $f766766dc17670c8$var$load("5OeFx")
]).then(()=>parcelRequire('8ntLI'));

});


parcelRegister("9PnMh", function(module, exports) {

let $727b523ebb65ff3a$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_nin_covnert_share_to_entrypoint', function() {
        return Promise.all([
            $727b523ebb65ff3a$var$load("jcgjD")
        ]);
    }, function() {
        return Promise.all([
            $727b523ebb65ff3a$var$load("eEfn1"),
            $727b523ebb65ff3a$var$load("bABhq"),
            $727b523ebb65ff3a$var$load("1VRB2")
        ]);
    }),
    $727b523ebb65ff3a$var$load("kvJgD")
]).then(()=>parcelRequire('irimY'));

});


parcelRegister("4ZT9l", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorEmbedEntrypoint", () => $8f24b95b321d46e3$export$407d940f927eac56);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $gvzJT = parcelRequire("gvzJT");

const $8f24b95b321d46e3$export$407d940f927eac56 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("deYHH")), {
        moduleId: "9aa91f84",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        return {
            entryPoints: {
                nativeIssueTableEntryPoint: {
                    entryPoint: (0, $gvzJT.nativeIssueTableEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
    }
});

});
parcelRegister("deYHH", function(module, exports) {

let $9a3babafaa1aec54$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_nin_covnert_share_to_entrypoint', function() {
        return Promise.all([
            $9a3babafaa1aec54$var$load("jcgjD")
        ]);
    }, function() {
        return Promise.all([
            $9a3babafaa1aec54$var$load("eEfn1"),
            $9a3babafaa1aec54$var$load("bABhq"),
            $9a3babafaa1aec54$var$load("1VRB2")
        ]);
    }),
    $9a3babafaa1aec54$var$load("4Jogm")
]).then(()=>parcelRequire('78wo9'));

});


parcelRegister("aDQ9G", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorGinRedirectEntrypoint", () => $64b31bdc90c786b5$export$3185a5139b079ec0);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $eaAW8 = parcelRequire("eaAW8");

var $gvzJT = parcelRequire("gvzJT");

var $7jTnu = parcelRequire("7jTnu");

var $4G2FD = parcelRequire("4G2FD");

const $64b31bdc90c786b5$export$3185a5139b079ec0 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("kPcQw")), {
        moduleId: "e648b5f0",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        const issueKey = entryPointParams?.context?.match?.params?.issueKey;
        return {
            entryPoints: {
                globalIssueNavigatorEntryPoint: {
                    entryPoint: (0, $eaAW8.globalIssueNavigatorEntryPoint),
                    entryPointParams: entryPointParams
                },
                ...!issueKey ? {
                    nativeIssueTableEntryPoint: {
                        entryPoint: (0, $gvzJT.nativeIssueTableEntryPoint),
                        entryPointParams: entryPointParams
                    },
                    ...(0, $7jTnu.fg)('jql_builder_basic_ssr_stability_fixes') ? {
                        jqlBuilderWithAiEntryPoint: {
                            entryPoint: (0, $4G2FD.jqlBuilderWithAiEntryPoint),
                            entryPointParams: entryPointParams
                        }
                    } : {}
                } : {}
            }
        };
    }
});

});
parcelRegister("eaAW8", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorEntryPoint", () => $ce5c836c382687ef$export$79ac0647e40ae809);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $ce5c836c382687ef$export$79ac0647e40ae809 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("8hhLE")).then((module)=>module.GlobalIssueNavigatorSPAEntryPoint), {
        moduleId: "c478d9ce",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8hhLE", function(module, exports) {

let $606db18b90479bf6$var$load = (parcelRequire("gLHA4"))(4);


module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_nin_covnert_share_to_entrypoint', function() {
        return Promise.all([
            $606db18b90479bf6$var$load("jcgjD")
        ]);
    }, function() {
        return Promise.all([
            $606db18b90479bf6$var$load("eEfn1"),
            $606db18b90479bf6$var$load("bABhq"),
            $606db18b90479bf6$var$load("1VRB2")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_nin_convert_apps_to_entrypoint', function() {
        return Promise.all([
            $606db18b90479bf6$var$load("kmCVr")
        ]);
    }, function() {
        return Promise.all([
            $606db18b90479bf6$var$load("k5rsf")
        ]);
    }),
    $606db18b90479bf6$var$load("kMydy")
]).then(()=>parcelRequire('2vRh2'));

});


parcelRegister("kPcQw", function(module, exports) {

let $f292890bb224969e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f292890bb224969e$var$load("fckZn").then(()=>parcelRequire('3xzAj'));

});


parcelRegister("efo1i", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorPinRedirectEntrypoint", () => $ed4ca92ea727ad31$export$cc17cd3f65b3828f);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $ed4ca92ea727ad31$export$cc17cd3f65b3828f = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("bZkns")), {
        moduleId: "8d4a4d33",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bZkns", function(module, exports) {

let $8ba532bd62f2968b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8ba532bd62f2968b$var$load("bArN0").then(()=>parcelRequire('jLUA6'));

});




parcelRegister("cZnHb", function(module, exports) {

$parcel$export(module.exports, "globalMailSettingsRouteEntry", () => $2142508b82594168$export$5e1236665a530df4);

var $kHlOR = parcelRequire("kHlOR");

var $6qDrV = parcelRequire("6qDrV");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $75uKm = parcelRequire("75uKm");

var $ZL6Qq = parcelRequire("ZL6Qq");

var $eGZWT = parcelRequire("eGZWT");
const $2142508b82594168$export$5e1236665a530df4 = (0, $6xToB.createEntry)((0, $75uKm.globalMailSettingsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.global-mail-settings',
        component: (0, $6qDrV.default)(()=>true, (0, $eGZWT.default), (0, $ZL6Qq.default)),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $eGZWT.LazyGlobalMailSettings)
        ]
    }));

});
parcelRegister("75uKm", function(module, exports) {

$parcel$export(module.exports, "globalMailSettingsRoute", () => $48a2ae2426d7fdf5$export$e69b84daf70501b3);
const $48a2ae2426d7fdf5$export$e69b84daf70501b3 = {
    name: 'global-mail-settings',
    path: '/secure/admin/global-mail-settings',
    exact: true
};

});

parcelRegister("ZL6Qq", function(module, exports) {

$parcel$export(module.exports, "default", () => $18c7af094da371c2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7Z2hn = parcelRequire("7Z2hn");
var /** This exists to be used as a route since the redirect as a route and redirect as a component
 * have different props, and flow complains. */ // @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': location, query, route, match, action
// eslint-disable-next-line jira/import/no-anonymous-default-export
$18c7af094da371c2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z2hn.default), null);

});
parcelRegister("7Z2hn", function(module, exports) {

$parcel$export(module.exports, "default", () => $058bd651131efa09$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $aN4Pk = parcelRequire("aN4Pk");

var $2fNLP = parcelRequire("2fNLP");

var $eSnSE = parcelRequire("eSnSE");

var $bdG9p = parcelRequire("bdG9p");

var $hWeHP = parcelRequire("hWeHP");

var $gCeeo = parcelRequire("gCeeo");

var $jJaSe = parcelRequire("jJaSe");

var $4elgJ = parcelRequire("4elgJ");

var $7jTnu = parcelRequire("7jTnu");

var $6JCFc = parcelRequire("6JCFc");
const $058bd651131efa09$var$THRESHOLD = 30000;
const $058bd651131efa09$var$getScopeType = (scope)=>{
    switch(scope.identifierType){
        case 'boardId':
            return 'board';
        case 'projectId':
        case 'projectKey':
            return scope.pageType === 'settings' ? 'projectSettings' : 'project';
        default:
            return '';
    }
};
const $058bd651131efa09$var$sessionStorageProvider = (0, $4elgJ.createSessionStorageProvider)('', false);
class $058bd651131efa09$export$836fe1ef2cfde075 extends (0, $eJOHy.Component) {
    componentDidMount() {
        // eslint-disable-next-line jira/react-magnetic-di/no-unneeded
        (0, $gRw8I.di)(sessionStorage, $058bd651131efa09$var$sessionStorageProvider, window);
        const { location: { pathname: pathname, search: search }, flagService: flagService, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const redirectPathname = pathname.startsWith('//') ? pathname.substr(1) : pathname;
        const lastRedirectTime = (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? Number($058bd651131efa09$var$sessionStorageProvider.get(redirectPathname)) : Number(sessionStorage.getItem(redirectPathname));
        if (!lastRedirectTime) (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $058bd651131efa09$var$sessionStorageProvider.set(redirectPathname, Date.now().toString()) : sessionStorage.setItem(redirectPathname, Date.now().toString());
        else if (Date.now() - lastRedirectTime < $058bd651131efa09$var$THRESHOLD) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const scopeData = (0, $2fNLP.default)(window.location.href, (0, $hWeHP.default));
            const scope = $058bd651131efa09$var$getScopeType(scopeData);
            (0, $eSnSE.default).safeErrorWithoutCustomerData('redirect-loop.error', 'Redirect error caused by invalid url', {
                scope: scope
            });
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({
                action: 'entered'
            }), 'redirect-loop entered', 'endeavour.spa.redirect-loop', {
                scope: scope
            });
            flagService.showFlag((0, $6JCFc.errorFlag)());
            (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $058bd651131efa09$var$sessionStorageProvider.remove(redirectPathname) : sessionStorage.removeItem(redirectPathname);
            return;
        } else (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $058bd651131efa09$var$sessionStorageProvider.remove(redirectPathname) : sessionStorage.removeItem(redirectPathname);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(redirectPathname + search);
    }
    render() {
        return null;
    }
}
var // @ts-expect-error - TS2345 - Argument of type 'ForwardRefExoticComponent<Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>>' is not assignable to parameter of type 'ComponentType<{ flagService: FlagService; }>'. | TS2345 - Argument of type 'typeof RedirectToLegacyRouting' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & typeof RedirectToLegacyRouting) | ((new (props: WithAnalyticsEventsProps) => Component<...>) & typeof RedirectToLegacyRouting)'.
$058bd651131efa09$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)((0, $bdG9p.default)((0, $aN4Pk.default)()($058bd651131efa09$export$836fe1ef2cfde075)));

});
parcelRegister("2fNLP", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $87bb57fd652d51da$export$557c2f222778cea6);
$parcel$export(module.exports, "default", () => $87bb57fd652d51da$export$2e2bcd8739ae039);

var $3Q6BV = parcelRequire("3Q6BV");

var $jkKE1 = parcelRequire("jkKE1");

var $8L5FN = parcelRequire("8L5FN");

var $6zxj7 = parcelRequire("6zxj7");

var $kgGWj = parcelRequire("kgGWj");
const $87bb57fd652d51da$var$projectScopeDataMap = {
    routes: [
        // Query string
        /[&?]projectKey=(\w+)/i,
        // Service desk, business and some software
        /\/projects\/(\w+)/i,
        // Issue page (not root)
        /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
        // Project settings
        /\/plugins\/servlet\/project-config\/(\w+)/i,
        // Service Desk project settings
        /\/servicedesk\/admin\/(\w+)/i,
        // Browse project
        /\/browse\/(\w+)\/?(\?.*)?$/i
    ],
    meta: [
        // Software
        'ghx-project-key',
        // Settings
        'projectKey',
        // Reports
        'ajs-project-key'
    ]
};
const $87bb57fd652d51da$var$getProjectId = (url)=>{
    const projectIdRoutes = [
        // Query string - reports
        /[&?]selectedProjectId=(\w+)/i,
        // Query string - edit project, delete project
        /[&?]pid=(\w+)/i,
        // Query string - release notes
        /[&?]projectId=(\w+)/i,
        // Query string - connect items
        /[&?]project\.id=(\w+)/i
    ];
    return projectIdRoutes.reduce((foundId, route)=>{
        if (foundId) return foundId;
        const match = url.match(route);
        if (match != null) {
            const [, projectId] = match;
            if (projectId) return projectId;
        }
        return null;
    }, null);
};
/**
 * Extracts certain data out of the URL that is required by other data providers.
 */ const $87bb57fd652d51da$var$getProjectKey = (url, getMeta)=>{
    let projectKey = null;
    $87bb57fd652d51da$var$projectScopeDataMap.meta.forEach((tagName)=>{
        const value = getMeta(tagName);
        if (value && projectKey == null) projectKey = value;
    });
    $87bb57fd652d51da$var$projectScopeDataMap.routes.forEach((route)=>{
        const match = url.match(route);
        if (match != null && projectKey == null) [, projectKey] = match;
    });
    return projectKey || undefined;
};
const $87bb57fd652d51da$export$557c2f222778cea6 = (url)=>{
    try {
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(url, true);
        let boardId = parsed.query ? parsed.query.rapidView : null;
        if (boardId == null) {
            const match = url.match(/\/boards\/(\d+)/i);
            boardId = match ? match[1] : null;
        }
        return boardId;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return null;
    }
};
const $87bb57fd652d51da$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, $8L5FN.default).some((regex)=>regex.test(url)) || (0, $6zxj7.default).some((regex)=>regex.test(url));
const $87bb57fd652d51da$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
    // Project routes that have a project id in the URL
    const isProject = ()=>{
        const routes = [
            /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
            /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
            /\/secure\/ReleaseNote.jspa.+projectId/i,
            /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
        ];
        return $87bb57fd652d51da$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        }) || routes.some((regex)=>regex.test(url));
    };
    return projectKey || projectId && isProject();
};
const $87bb57fd652d51da$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, $kgGWj.default).some((route)=>url.match(route)) || $87bb57fd652d51da$var$isProjectSettingsConnectRoute({
        getMeta: getMeta,
        url: url
    });
const $87bb57fd652d51da$var$getProjectPageType = (getMeta, url)=>{
    if ($87bb57fd652d51da$var$isProjectSettingsPage({
        getMeta: getMeta,
        url: url
    })) return 'settings';
    const decorator = getMeta('decorator');
    const isSettings = getMeta('is-settings-page') === 'true';
    return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$87bb57fd652d51da$export$2e2bcd8739ae039 = (url, getMeta)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const extractedData = {};
    const boardId = $87bb57fd652d51da$export$557c2f222778cea6(url);
    if (boardId) extractedData.boardId = boardId;
    const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $87bb57fd652d51da$var$getProjectKey(url, getMeta);
    if (projectKey) extractedData.projectKey = projectKey;
    const projectId = $87bb57fd652d51da$var$getProjectId(url);
    if (projectId) extractedData.projectId = projectId;
    const isProject = $87bb57fd652d51da$var$isProjectPage({
        getMeta: getMeta,
        projectId: projectId,
        projectKey: projectKey,
        url: url
    });
    extractedData.pageType = isProject ? $87bb57fd652d51da$var$getProjectPageType(getMeta, url) : undefined;
    const identifier = (0, $jkKE1.getScopeIdentifier)({
        boardId: boardId,
        projectKey: projectKey,
        projectId: isProject ? projectId : null
    });
    // This gets around a flow inexact type error
    return {
        ...extractedData,
        ...identifier
    };
};

});
parcelRegister("8L5FN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9991dc7a3b0c4326$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $9991dc7a3b0c4326$export$2e2bcd8739ae039 = [
    // Regex groups: addonKey, pageKey
    /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
];

});

parcelRegister("6zxj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $85420e92e692d947$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $85420e92e692d947$export$2e2bcd8739ae039 = [
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
];

});

parcelRegister("kgGWj", function(module, exports) {

$parcel$export(module.exports, "default", () => $270dbf4ef727859d$export$2e2bcd8739ae039);

var $6zxj7 = parcelRequire("6zxj7");
const $270dbf4ef727859d$var$commonClassicProjectSettingsRoutes = [
    /\/plugins\/servlet\/project-config/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
    /\/plugins\/servlet\/project-config\/.+\/fields/i,
    /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
    /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
    /\/plugins\/servlet\/project-config\/.+\/notifications/i,
    /\/plugins\/servlet\/project-config\/.+\/permissions/i,
    /\/plugins\/servlet\/project-config\/.+\/screens/i,
    /\/plugins\/servlet\/project-config\/.+\/workflows/i,
    /\/project\/DeleteProject!default\.jspa/i,
    /\/secure\/project\/EditProject!default\.jspa/i,
    // Collectors
    /\/secure\/AddCollector/i,
    /\/secure\/InsertCollectorHelp/i,
    /\/ViewCollector!default\.jspa\?projectKey=/i,
    /\/ViewCollectors!default\.jspa\?projectKey=/i,
    // Development tools
    /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
    // Hipchat
    /\/InstallHipChat\.jspa\?projectKey=/i,
    /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
    // Forge
    /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$270dbf4ef727859d$export$2e2bcd8739ae039 = [
    ...$270dbf4ef727859d$var$commonClassicProjectSettingsRoutes,
    /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
    ...(0, $6zxj7.default),
    // Service Desk project settings
    /\/servicedesk\/admin\/(\w+)/i,
    // SPA settings
    /\/projects\/\w+\/settings(\/\w+)*/i
];

});


parcelRegister("6JCFc", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $c0c08f8506304cea$export$b9a7f1ebeaa76953);

var $7uOn8 = parcelRequire("7uOn8");
const $c0c08f8506304cea$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        title: (0, $7uOn8.messages).title,
        description: (0, $7uOn8.messages).description,
        messageId: 'spa-apps-common.redirect.legacy-routing.flags.flag.error.error-flag',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $7uOn8.messages).goHome,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.assign('/')
            }
        ]
    });

});
parcelRegister("7uOn8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4dbc780177456e55$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $4dbc780177456e55$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "redirect.legacy-routing.flags.error.title",
        "defaultMessage": "We can't find the page you're looking for"
    },
    description: {
        "id": "redirect.legacy-routing.flags.error.description",
        "defaultMessage": "Check your spelling in the address bar. Or, try opening this site's home page to search or browse for the content."
    },
    goHome: {
        "id": "redirect.legacy-routing.flags.error.go-home",
        "defaultMessage": "Go to the homepage"
    }
});

});




parcelRegister("eGZWT", function(module, exports) {

$parcel$export(module.exports, "LazyGlobalMailSettings", () => $045882abf78a8f88$export$a133d90b2004a90e);
$parcel$export(module.exports, "default", () => $045882abf78a8f88$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $045882abf78a8f88$export$a133d90b2004a90e = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("6toGL"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/global-mail-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$045882abf78a8f88$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $045882abf78a8f88$export$a133d90b2004a90e,
        pageId: "global-mail-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("6toGL", function(module, exports) {

let $4b689a2e5fe2493a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4b689a2e5fe2493a$var$load("iB8WA").then(()=>parcelRequire('79ZX9'));

});



parcelRegister("ExJeP", function(module, exports) {

$parcel$export(module.exports, "globalPoliciesRouteEntry", () => $ae77252a608218ce$export$2ee2f43d380cc210);

var $klg4M = parcelRequire("klg4M");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $iRfwO = parcelRequire("iRfwO");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1LKbD = parcelRequire("1LKbD");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $fIZNm = parcelRequire("fIZNm");
const $ae77252a608218ce$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $ae77252a608218ce$export$2ee2f43d380cc210 = (0, $6xToB.createEntry)((0, $1LKbD.globalPoliciesRoute), ()=>({
        group: 'eoc',
        component: (0, $fIZNm.AlertPoliciesComponent),
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $klg4M.resources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$ae77252a608218ce$var$getNavigationSpecifications()
        },
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fIZNm.LazyAlertPolicies)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fIZNm.LazyAlertPolicies)
        ]
    }));

});
parcelRegister("1LKbD", function(module, exports) {

$parcel$export(module.exports, "globalPoliciesRoute", () => $b6a7ef9496c2a629$export$4eb24a8e860a3df7);
const $b6a7ef9496c2a629$export$4eb24a8e860a3df7 = {
    name: 'eoc-policies',
    path: '/jira/settings/products/ops/policies',
    exact: true
};

});


parcelRegister("5CWoo", function(module, exports) {

$parcel$export(module.exports, "globalSettingsContactAdministratorRouteEntry", () => $c47af52924d3b837$export$d213125be8246eea);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $c7iMO = parcelRequire("c7iMO");

var $j37Rv = parcelRequire("j37Rv");
const $c47af52924d3b837$export$d213125be8246eea = (0, $6xToB.createEntry)((0, $c7iMO.globalSettingsContactAdministratorRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.contact-administrator',
        component: (0, $j37Rv.default),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $j37Rv.LazyContactAdministratorPage)
        ]
    }));

});
parcelRegister("c7iMO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsContactAdministratorRoute", () => $c6110c9eb362d553$export$146910ddc36bf151);
const $c6110c9eb362d553$export$146910ddc36bf151 = {
    name: 'global-settings-contact-administrator',
    path: '/jira/contact-administrator'
};

});

parcelRegister("j37Rv", function(module, exports) {

$parcel$export(module.exports, "LazyContactAdministratorPage", () => $1c7e31900a7f65b9$export$bf75747a931b9a2b);
$parcel$export(module.exports, "default", () => $1c7e31900a7f65b9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $1c7e31900a7f65b9$export$bf75747a931b9a2b = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("64M1D"))), {
    moduleId: "./src/packages/admin-pages/contact-administrator/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1c7e31900a7f65b9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1c7e31900a7f65b9$export$bf75747a931b9a2b,
        pageId: "jira-admin-pages-contact-administrator",
        shouldShowSpinner: true
    });

});
parcelRegister("64M1D", function(module, exports) {

let $46c85ea5b97cd99d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $46c85ea5b97cd99d$var$load("cE10f").then(()=>parcelRequire('aXZhn'));

});



parcelRegister("fBUuA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsCustomFieldsRouteEntry", () => $ec60de6547af3189$export$d83c2e469d070766);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $2dhyd = parcelRequire("2dhyd");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $6ez9p = parcelRequire("6ez9p");

var $5fjzQ = parcelRequire("5fjzQ");

var $bCdza = parcelRequire("bCdza");
const $ec60de6547af3189$export$d83c2e469d070766 = (0, $6xToB.createEntry)((0, $6ez9p.globalSettingsCustomFieldsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.custom-fields-directory',
        component: (0, $bCdza.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $2dhyd.customFieldsDirectoryResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bCdza.LazyCustomFieldsDirectoryAdmin)
        ]
    }));

});
parcelRegister("2dhyd", function(module, exports) {

$parcel$export(module.exports, "customFieldsDirectoryResource", () => $513a9bcccb9aa19f$export$3d783f106e15b01a);

var $l1VxS = parcelRequire("l1VxS");


const $513a9bcccb9aa19f$export$3d783f106e15b01a = (0, $l1VxS.createResource)({
    type: (0, $32ac74db0fe7b93d$export$f237bae095c310e7),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("6tLtY"))
});

});
const $32ac74db0fe7b93d$export$f237bae095c310e7 = 'CUSTOM_FIELDS_DIRECTORY';

parcelRegister("6tLtY", function(module, exports) {

let $4b7a48882c5daf73$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4b7a48882c5daf73$var$load("58E13").then(()=>parcelRequire('8gyyU'));

});


parcelRegister("6ez9p", function(module, exports) {

$parcel$export(module.exports, "globalSettingsCustomFieldsRoute", () => $31dc00f4aa9ce38a$export$45e7d93edcc9507f);
const $31dc00f4aa9ce38a$export$45e7d93edcc9507f = {
    name: 'global-settings-issues-custom-fields-view',
    path: '/secure/admin/ViewCustomFields(!default)?.jspa'
};

});

parcelRegister("bCdza", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldsDirectoryAdmin", () => $6150103a26efb44c$export$55a5c16f39a046af);
$parcel$export(module.exports, "default", () => $6150103a26efb44c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $6150103a26efb44c$export$55a5c16f39a046af = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7iCVa"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/custom-fields-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6150103a26efb44c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6150103a26efb44c$export$55a5c16f39a046af,
        pageId: "admin-pages-custom-fields-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("7iCVa", function(module, exports) {

let $550867c1a60f9019$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $550867c1a60f9019$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $550867c1a60f9019$var$load("deNlq")
        ]);
    }),
    $550867c1a60f9019$var$load("1VRB2"),
    $550867c1a60f9019$var$load("bABhq"),
    $550867c1a60f9019$var$load("eDzss"),
    $550867c1a60f9019$var$load("ehxnE")
]).then(()=>parcelRequire('10sHA'));

});



parcelRegister("3WFhy", function(module, exports) {

$parcel$export(module.exports, "globalSettingsEditPermissionSchemesRouteEntry", () => $67ed067875824d69$export$25dca167915e813c);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $1RvYH = parcelRequire("1RvYH");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $b2icQ = parcelRequire("b2icQ");

var $3Kw2I = parcelRequire("3Kw2I");
const $67ed067875824d69$export$25dca167915e813c = (0, $6xToB.createEntry)((0, $b2icQ.globalSettingsEditPermissionSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.configure-permission-scheme',
        component: (0, $3Kw2I.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $1RvYH.editPermissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3Kw2I.LazyEditPermissionSchemePage)
        ],
        meta: {
            reporting: {
                id: 'EditPermissionScheme',
                packageName: 'jiraAdminPagesEditPermissionScheme',
                teamName: 'gordian'
            }
        }
    }));

});
parcelRegister("1RvYH", function(module, exports) {

$parcel$export(module.exports, "editPermissionSchemePageResource", () => $0d614a165a29d166$export$2b6bb2f543863b53);

var $9FYIg = parcelRequire("9FYIg");

var $8njch = parcelRequire("8njch");
const $0d614a165a29d166$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE = 'EDIT_PERMISSION_SCHEME_PAGE';
const $0d614a165a29d166$export$2b6bb2f543863b53 = (0, $9FYIg.createRelayResource)({
    type: $0d614a165a29d166$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $8njch.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`,
                first: 50
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("8njch", function(module, exports) {

$parcel$export(module.exports, "default", () => $a055bae4b70a9780$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cf9dd52bff7eb700bc199213f93ee422>>
 * @relayHash 68742a61b838212a798006d6e9c7143f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9dd26f13d3fb1b9e1841f3a7c158f1280d92df4a0e3f0e04a02484bf36dbae88

var $i6iR0 = parcelRequire("i6iR0");
const $a055bae4b70a9780$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "schemeId"
    }, v2 = {
        "kind": "Variable",
        "name": "schemeId",
        "variableName": "schemeId"
    }, v3 = [
        v2 /*: any*/ 
    ], v4 = {
        "kind": "ScalarField",
        "name": "isEditable"
    }, v5 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            v4 /*: any*/ 
        ]
    }, v6 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v2 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "kind": "ScalarField",
        "name": "description"
    }, v12 = {
        "kind": "ScalarField",
        "name": "text"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = [
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v13 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v3 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PermissionCategories"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "header_editPermissionScheme"
                                            },
                                            v5 /*: any*/ 
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.viewPermissionScheme"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v6 /*: any*/ ,
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "getProjectsByPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.getProjectsByPermissionScheme.edges.node.projectId"
                                                            }
                                                        ]
                                                    },
                                                    "action": "LOG",
                                                    "path": "jira.getProjectsByPermissionScheme.edges.node"
                                                }
                                            ]
                                        },
                                        "action": "LOG",
                                        "path": "jira.getProjectsByPermissionScheme.edges"
                                    }
                                ]
                            },
                            "action": "LOG",
                            "path": "jira.getProjectsByPermissionScheme"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraprojectpermissionsupportteamsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "configuration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "tag"
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionMessageExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "message",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionDocumentationExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "documentation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v14 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v9 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraprojectpermissionsupportteamsrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "usageType"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "avatarUrl"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v13 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v9 /*: any*/ ,
                                                                                                v13 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v14 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v13 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "totalCount"
                                                                },
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "getProjectsByPermissionScheme",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9dd26f13d3fb1b9e1841f3a7c158f1280d92df4a0e3f0e04a02484bf36dbae88",
            "metadata": {},
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraprojectpermissionsupportteamsrelayprovider": (0, $i6iR0.default)
            }
        }
    };
}();
$a055bae4b70a9780$var$node.hash = "9e1e7326d79aae057f4943753d3cd309";
var $a055bae4b70a9780$export$2e2bcd8739ae039 = $a055bae4b70a9780$var$node;

});
parcelRegister("i6iR0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d84dfe0856968003$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $d84dfe0856968003$var$JiraProjectPermissionSupportTeamsRelayProvider = {
    get () {
        return (0, $7jTnu.fg)('support_teams_in_jira_project_permission');
    }
};
var $d84dfe0856968003$export$2e2bcd8739ae039 = $d84dfe0856968003$var$JiraProjectPermissionSupportTeamsRelayProvider;

});



parcelRegister("b2icQ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsEditPermissionSchemesRoute", () => $a857ecd9bcf82c5b$export$d57f448badd0561f);
const $a857ecd9bcf82c5b$export$d57f448badd0561f = {
    name: 'global-settings-issues-edit-permissions-schemes',
    path: '/jira/settings/issues/permission-schemes/:schemeId'
};

});

parcelRegister("3Kw2I", function(module, exports) {

$parcel$export(module.exports, "LazyEditPermissionSchemePage", () => $92a617ea3198921b$export$4549705b02900c32);
$parcel$export(module.exports, "default", () => $92a617ea3198921b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $92a617ea3198921b$export$4549705b02900c32 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("hHsOr"))), {
    moduleId: "./src/packages/permissions-administration/pages/edit-permission-scheme/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$92a617ea3198921b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $92a617ea3198921b$export$4549705b02900c32,
        pageId: "jira-edit-permission-scheme",
        shouldShowSpinner: true
    });

});
parcelRegister("hHsOr", function(module, exports) {

let $ce2ccd657d130735$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ce2ccd657d130735$var$load("gYrLb").then(()=>parcelRequire('iYTly'));

});



parcelRegister("7T8Ox", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFormDataConnectionsRouteEntry", () => $d873a89f38ef5899$export$d975ee3e4df0b4d2);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $8x7Ns = parcelRequire("8x7Ns");

var $7zSPZ = parcelRequire("7zSPZ");

var $g8uYY = parcelRequire("g8uYY");

var $3dKrj = parcelRequire("3dKrj");
const $d873a89f38ef5899$var$jiraAdminProformaDataConnectionsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $7zSPZ.default),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $d873a89f38ef5899$export$d975ee3e4df0b4d2 = (0, $6xToB.createEntry)((0, $8x7Ns.globalSettingsFormDataConnectionsRoute), ()=>({
        group: 'global-settings',
        component: (0, $3dKrj.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3dKrj.LazyProformaJiraDataConnectionsPage)
        ],
        entryPoint () {
            return $d873a89f38ef5899$var$jiraAdminProformaDataConnectionsPageEntryPoint;
        }
    }));

});
parcelRegister("8x7Ns", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFormDataConnectionsRoute", () => $5e42bfd1789c4d6a$export$6633247975d81f28);
const $5e42bfd1789c4d6a$export$6633247975d81f28 = {
    name: 'global-settings-issues-form-data-connections',
    path: '/jira/settings/forms/data-connections'
};

});

parcelRegister("7zSPZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bc6056a355a5f25$export$2e2bcd8739ae039);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $2bc6056a355a5f25$var$JiraAdminProformaDataConnectionsEntryPoint = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("9GTBi")), {
        moduleId: "606040fa",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});
var $2bc6056a355a5f25$export$2e2bcd8739ae039 = $2bc6056a355a5f25$var$JiraAdminProformaDataConnectionsEntryPoint;

});
parcelRegister("9GTBi", function(module, exports) {

let $70e32a6ac9305c5d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $70e32a6ac9305c5d$var$load("2E9FP").then(()=>parcelRequire('8gBj2'));

});


parcelRegister("3dKrj", function(module, exports) {

$parcel$export(module.exports, "LazyProformaJiraDataConnectionsPage", () => $0b2318210149c244$export$a81885366284dc75);
$parcel$export(module.exports, "default", () => $0b2318210149c244$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $0b2318210149c244$export$a81885366284dc75 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("eEDDB"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/proforma/data-connections/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0b2318210149c244$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $0b2318210149c244$export$a81885366284dc75,
        pageId: "jira-admin-pages-forms-data-connections",
        shouldShowSpinner: true
    });

});
parcelRegister("eEDDB", function(module, exports) {

let $aab38c52cc17c8de$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $aab38c52cc17c8de$var$load("cqpew").then(()=>parcelRequire('1NXaV'));

});



parcelRegister("8H8bx", function(module, exports) {

$parcel$export(module.exports, "globalSettingsGlobalPermissionsRouteEntry", () => $e2bffd4a31205864$export$34203273711b537f);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $7jTnu = parcelRequire("7jTnu");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $4BZBc = parcelRequire("4BZBc");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $iwxpQ = parcelRequire("iwxpQ");

var $9BJU1 = parcelRequire("9BJU1");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $5fjzQ = parcelRequire("5fjzQ");

const $e2bffd4a31205864$var$LazyGlobalPermissions = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("YW0dp"))), {
    moduleId: "./src/packages/permissions-administration/pages/global-permissions/src/index.tsx"
});
const $e2bffd4a31205864$var$LazyGlobalPermissionsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e2bffd4a31205864$var$LazyGlobalPermissions,
        pageId: "jira-global-permissions",
        shouldShowSpinner: true
    });
const $e2bffd4a31205864$export$34203273711b537f = (0, $6xToB.createEntry)((0, $iwxpQ.globalSettingsGlobalPermissionsRoute), ()=>({
        group: 'global-settings',
        component: (0, $bJscI.componentWithFG)('olympus-global-permissions-fe-modernisation', $e2bffd4a31205864$var$LazyGlobalPermissionsPage, (0, $9BJU1.default)),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $4BZBc.globalPermissionsResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>(0, $7jTnu.fg)('olympus-global-permissions-fe-modernisation'),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $e2bffd4a31205864$var$LazyGlobalPermissions
        ],
        meta: {
            reporting: {
                id: 'GlobalPermissions',
                packageName: 'jiraAdminPagesGlobalPermissions',
                teamName: 'gordian'
            }
        }
    }));

});
parcelRegister("4BZBc", function(module, exports) {

$parcel$export(module.exports, "globalPermissionsResource", () => $51a95a8a00d37fea$export$9a5d1bc1ff678482);

var $9FYIg = parcelRequire("9FYIg");

var $1HQsX = parcelRequire("1HQsX");
const $51a95a8a00d37fea$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS = 'GLOBAL_PERMISSIONS';
const $51a95a8a00d37fea$export$9a5d1bc1ff678482 = (0, $9FYIg.createRelayResource)({
    type: $51a95a8a00d37fea$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS,
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $1HQsX.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("1HQsX", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b4393eacfca3c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f014b4044459efb94c4edb99f926dd1>>
 * @relayHash 402a674bdd82767605c36953e2732f07
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6
const $93b4393eacfca3c3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_globalPermissionsAndGrantsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "globalPermissionsAndGrants",
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "getGlobalPermissionsAndGrants",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalPermissionsTable_globalPermissions"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "grantPermissionDialog_globalPermissions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.globalPermissionsAndGrants"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_globalPermissionsAndGrantsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "globalPermissionsAndGrants",
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "getGlobalPermissionsAndGrants",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraGlobalPermissionGrants",
                                            "kind": "LinkedField",
                                            "name": "globalPermissionGrants",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraGlobalPermission",
                                                    "kind": "LinkedField",
                                                    "name": "permission",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isManagedByJira"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraGroup",
                                                    "kind": "LinkedField",
                                                    "name": "groups",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "groupId"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraGlobalPermissionGrantsList"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6",
            "metadata": {},
            "name": "main_globalPermissionsAndGrantsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$93b4393eacfca3c3$var$node.hash = "9f1b7eb98b606c41655e4fa1f200a351";
var $93b4393eacfca3c3$export$2e2bcd8739ae039 = $93b4393eacfca3c3$var$node;

});


parcelRegister("iwxpQ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsGlobalPermissionsRoute", () => $b4c73b5e103a0249$export$236ce89eb737f752);
const $b4c73b5e103a0249$export$236ce89eb737f752 = {
    name: 'global-settings-global-permissions',
    path: '/secure/admin/global-permissions'
};

});

parcelRegister("YW0dp", function(module, exports) {

let $0b7298cb48314170$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0b7298cb48314170$var$load("7RLfy").then(()=>parcelRequire('fUtcU'));

});


parcelRegister("bI8Dj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldSchemeRouteEntry", () => $6bbc1555fcf02ec3$export$7d7f30b10ed32027);

var $4kXTh = parcelRequire("4kXTh");

var $6xToB = parcelRequire("6xToB");

var $5Hv7B = parcelRequire("5Hv7B");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $epTsa = parcelRequire("epTsa");

var $8XpuN = parcelRequire("8XpuN");

var $9NmsS = parcelRequire("9NmsS");

var $enHI7 = parcelRequire("enHI7");

var $5fjzQ = parcelRequire("5fjzQ");

var $g8uYY = parcelRequire("g8uYY");
const $6bbc1555fcf02ec3$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $4kXTh.globalAdminFieldSchemeEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $6bbc1555fcf02ec3$export$7d7f30b10ed32027 = (0, $6xToB.createEntry)((0, $5Hv7B.globalSettingsIssueFieldSchemeRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.field-scheme',
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        canTransitionIn: ()=>(0, $epTsa.expValEquals)('jira_efa_for_cmp_m2_experiment', 'isEnabled', true, false),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>{
            if (!(0, $epTsa.expValEquals)('jira_efa_for_cmp_m2_experiment', 'isEnabled', true, false)) return undefined;
            return $6bbc1555fcf02ec3$var$pageEntryPoint;
        },
        meta: {
            reporting: {
                packageName: 'jiraAdminPagesFieldScheme',
                id: 'globalSettingsIssueFieldScheme',
                teamName: 'Yamato'
            }
        }
    }));

});
parcelRegister("4kXTh", function(module, exports) {

$parcel$export(module.exports, "globalAdminFieldSchemeEntryPoint", () => $29fbe3de237d3c9e$export$db849352675d81cc);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

var $8j1z7 = parcelRequire("8j1z7");

var $jvFHA = parcelRequire("jvFHA");

const $29fbe3de237d3c9e$export$db849352675d81cc = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("64q9h")), {
        moduleId: "d7333f59",
        moduleName: "FieldSchemeApp",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: tenantContext })=>({
            queries: {
                fieldSchemePageQuery: {
                    parameters: (0, $8j1z7.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        input: {
                            schemeId: match.params?.schemeId || ''
                        },
                        fieldSchemeAri: match.params?.schemeId ? (0, $jvFHA.JiraFieldSchemeAri).create({
                            siteId: tenantContext.cloudId,
                            activationId: tenantContext.activationId,
                            fieldSchemeId: match.params.schemeId
                        }).toString() : ''
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            },
            extraProps: {
                schemeId: match.params?.schemeId || ''
            }
        })
});

});
parcelRegister("8j1z7", function(module, exports) {

$parcel$export(module.exports, "default", () => $09a2a20c194e1ee4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<71e7ecddaee5fad4440071e1fce70fa3>>
 * @relayHash 4a17c19c720fd94173e2f91c7958bc25
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f3eaee73ef6030b6f709a50cd08ffdc9022c6c06aa798679748120dbd6bdeea0

var $37Ewn = parcelRequire("37Ewn");
const $09a2a20c194e1ee4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSchemeAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v3 = {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 40
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FieldSchemePageQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "AssociatedFieldsTable"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "fieldSchemeAri",
                            "variableName": "fieldSchemeAri"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "PageHeader"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "FieldSchemePageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraFieldSchemeAssociatedFieldsConnection",
                    "kind": "LinkedField",
                    "name": "jira_fieldSchemeAssociatedFields",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraFieldSchemeAssociatedFieldsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraFieldSchemeAssociatedField",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraField",
                                            "kind": "LinkedField",
                                            "name": "field",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeName"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFieldLocked"
                                        },
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "associatedFieldsTable_adminPagesFieldScheme_jira_fieldSchemeAssociatedFields",
                    "kind": "LinkedHandle",
                    "name": "jira_fieldSchemeAssociatedFields"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "fieldSchemeAri"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "projectsCount"
                                }
                            ],
                            "type": "JiraFieldScheme"
                        },
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "f3eaee73ef6030b6f709a50cd08ffdc9022c6c06aa798679748120dbd6bdeea0",
            "metadata": {},
            "name": "FieldSchemePageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$09a2a20c194e1ee4$var$node.hash = "135c3fa6cf49b6287a65de35ab3be2d5";
(0, $37Ewn.PreloadableQueryRegistry).set($09a2a20c194e1ee4$var$node.params.id, $09a2a20c194e1ee4$var$node);
var $09a2a20c194e1ee4$export$2e2bcd8739ae039 = $09a2a20c194e1ee4$var$node;

});

parcelRegister("jvFHA", function(module, exports) {

$parcel$export(module.exports, "JiraFieldSchemeAri", () => $e34142bbe390fbd4$export$5e44b06409c4e697);

var $k0RMs = parcelRequire("k0RMs");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/field-scheme/manifest.ts
var $e34142bbe390fbd4$var$jiraFieldSchemeAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $k0RMs.JiraFieldSchemeAriResourceOwner),
    resourceType: (0, $k0RMs.JiraFieldSchemeAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldSchemeId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldSchemeId: /[0-9]+/
    }
};
// src/jira/field-scheme/index.ts
var $e34142bbe390fbd4$export$5e44b06409c4e697 = class _JiraFieldSchemeAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldSchemeId = opts.resourceIdSegmentValues.fieldSchemeId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldSchemeId() {
        return this._fieldSchemeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e34142bbe390fbd4$var$jiraFieldSchemeAriStaticOpts.qualifier,
            platformQualifier: $e34142bbe390fbd4$var$jiraFieldSchemeAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e34142bbe390fbd4$var$jiraFieldSchemeAriStaticOpts.resourceOwner,
            resourceType: $e34142bbe390fbd4$var$jiraFieldSchemeAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldSchemeId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldSchemeId: opts.fieldSchemeId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $e34142bbe390fbd4$var$jiraFieldSchemeAriStaticOpts);
        return new _JiraFieldSchemeAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $e34142bbe390fbd4$var$jiraFieldSchemeAriStaticOpts);
        return new _JiraFieldSchemeAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldSchemeId: this.fieldSchemeId
        };
    }
};

});
parcelRegister("k0RMs", function(module, exports) {

$parcel$export(module.exports, "JiraFieldSchemeAriResourceOwner", () => $e91d866f96fb107a$export$8f6ad5e411df9d8);
$parcel$export(module.exports, "JiraFieldSchemeAriResourceType", () => $e91d866f96fb107a$export$6d39bf538961beb4);
// src/jira/field-scheme/types.ts
var $e91d866f96fb107a$export$8f6ad5e411df9d8 = "jira", $e91d866f96fb107a$export$6d39bf538961beb4 = "field-scheme";

});


parcelRegister("64q9h", function(module, exports) {

let $46b76661c89f4a5b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $46b76661c89f4a5b$var$load("771vl").then(()=>parcelRequire('2EEnO'));

});


parcelRegister("5Hv7B", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldSchemeRoute", () => $2f2f824f35a1894a$export$4fa4d1ddd1b89f8e);
const $2f2f824f35a1894a$export$4fa4d1ddd1b89f8e = {
    name: 'global-settings-issues-field-scheme',
    path: '/jira/settings/issues/field-schemes/:schemeId',
    exact: true
};

});


parcelRegister("4cnHJ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldSchemesConfigRouteEntry", () => $f3ec35f184053727$export$dc59f583c700b3f9);

var $eJOHy = parcelRequire("eJOHy");

var $c7HAt = parcelRequire("c7HAt");

var $6xToB = parcelRequire("6xToB");

var $eKVJl = parcelRequire("eKVJl");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $epTsa = parcelRequire("epTsa");

var $9NmsS = parcelRequire("9NmsS");

var $enHI7 = parcelRequire("enHI7");

var $5fjzQ = parcelRequire("5fjzQ");

var $g8uYY = parcelRequire("g8uYY");

var $7Gdao = parcelRequire("7Gdao");
const $f3ec35f184053727$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $c7HAt.globalAdminFieldSchemesEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $f3ec35f184053727$export$dc59f583c700b3f9 = (0, $6xToB.createEntry)((0, $eKVJl.globalSettingsIssueFieldSchemesConfigRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.field-schemes',
        layout: (0, $yRJUA.globalSettingsLayout),
        skeleton: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Gdao.FieldSchemesSkeleton), null);
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        canTransitionIn: ()=>(0, $epTsa.expValEquals)('jira_efa_for_cmp_m2_experiment', 'isEnabled', true, false),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>{
            if (!(0, $epTsa.expValEquals)('jira_efa_for_cmp_m2_experiment', 'isEnabled', true, false)) return undefined;
            return $f3ec35f184053727$var$pageEntryPoint;
        },
        meta: {
            reporting: {
                packageName: 'jiraAdminPagesFieldSchemes',
                id: 'globalSettingsIssueFieldSchemes',
                teamName: 'Yamato'
            }
        }
    }));

});
parcelRegister("c7HAt", function(module, exports) {

$parcel$export(module.exports, "globalAdminFieldSchemesEntryPoint", () => $df6afde3b0a0efd2$export$7f6007a9ef27a05a);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

var $5JRqS = parcelRequire("5JRqS");

const $df6afde3b0a0efd2$export$7f6007a9ef27a05a = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("bXjRp")), {
        moduleId: "b162d4e3",
        moduleName: "FieldSchemesApp",
        priority: "interaction"
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>({
            queries: {
                pageQueryRef: {
                    parameters: (0, $5JRqS.default),
                    variables: {
                        cloudId: tenantContext.cloudId
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        })
});

});
parcelRegister("5JRqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $916c668e5260dccf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a638cf21c54f165b2f76d510b552c338>>
 * @relayHash 8a97c73fffa93e17305f1f7dcc59eeff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d6bd95860c4a74776e61a4667e9f4adbd03a35f0fcb6c2c93eb7046279087a56

var $37Ewn = parcelRequire("37Ewn");
const $916c668e5260dccf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 40
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FieldSchemesAppQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "FieldSchemesPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FieldSchemesAppQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraFieldSchemesConnection",
                    "kind": "LinkedField",
                    "name": "jira_fieldSchemes",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraFieldSchemesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraFieldScheme",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "schemeId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldsCount"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectsCount"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "fieldSchemesTable_adminPagesFieldSchemes_jira_fieldSchemes",
                    "kind": "LinkedHandle",
                    "name": "jira_fieldSchemes"
                }
            ]
        },
        "params": {
            "id": "d6bd95860c4a74776e61a4667e9f4adbd03a35f0fcb6c2c93eb7046279087a56",
            "metadata": {},
            "name": "FieldSchemesAppQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$916c668e5260dccf$var$node.hash = "5d849fa3dc746f78acf5e0a8b2791820";
(0, $37Ewn.PreloadableQueryRegistry).set($916c668e5260dccf$var$node.params.id, $916c668e5260dccf$var$node);
var $916c668e5260dccf$export$2e2bcd8739ae039 = $916c668e5260dccf$var$node;

});

parcelRegister("bXjRp", function(module, exports) {

let $8b449c41225a6a88$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8b449c41225a6a88$var$load("dbeP3").then(()=>parcelRequire('flVrS'));

});


parcelRegister("eKVJl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldSchemesConfigRoute", () => $02c18caf632c9e77$export$9c41d0c6d3034d6a);
const $02c18caf632c9e77$export$9c41d0c6d3034d6a = {
    name: 'global-settings-issues-field-schemes',
    path: '/jira/settings/issues/field-schemes',
    exact: true
};

});

parcelRegister("7Gdao", function(module, exports) {

$parcel$export(module.exports, "FieldSchemesSkeleton", () => $3a9cdb21f2ed4208$export$7e38a517468c73e2);
/* FieldSchemesSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $e7AnQ = parcelRequire("e7AnQ");
const $3a9cdb21f2ed4208$export$7e38a517468c73e2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e7AnQ)))
    });

});
parcelRegister("e7AnQ", function(module, exports) {
module.exports = new URL("field-schemes-app-skeleton.tpl.0f9ec3c8.svg", import.meta.url).toString();

});



parcelRegister("g6DXA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldSchemesRouteEntry", () => $6fe289a5c8346640$export$d76b41f577aeeba5);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $gNr7h = parcelRequire("gNr7h");

var $5fjzQ = parcelRequire("5fjzQ");

var $dakbt = parcelRequire("dakbt");
const $6fe289a5c8346640$export$d76b41f577aeeba5 = (0, $6xToB.createEntry)((0, $gNr7h.globalSettingsIssueFieldSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.screen-schemes',
        component: (0, $dakbt.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dakbt.LazyScreenSchemesPage)
        ]
    }));

});
parcelRegister("gNr7h", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldSchemesRoute", () => $67e9e57c0011a18b$export$3c5a0cf6ecc1bdf1);
const $67e9e57c0011a18b$export$3c5a0cf6ecc1bdf1 = {
    name: 'global-settings-issues-field-schemes-view',
    path: '/jira/settings/issues/screen-schemes'
};

});

parcelRegister("dakbt", function(module, exports) {

$parcel$export(module.exports, "LazyScreenSchemesPage", () => $fde5fd2e5864e1ea$export$342ae41503f611f1);
$parcel$export(module.exports, "default", () => $fde5fd2e5864e1ea$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $fde5fd2e5864e1ea$export$342ae41503f611f1 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("6Xoul"))), {
    moduleId: "./src/packages/admin-pages/screen-schemes-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fde5fd2e5864e1ea$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fde5fd2e5864e1ea$export$342ae41503f611f1,
        pageId: "jira-admin-pages-screen-schemes-page",
        shouldShowSpinner: true
    });

});
parcelRegister("6Xoul", function(module, exports) {

let $510b3fa822392240$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $510b3fa822392240$var$load("1VRB2"),
    $510b3fa822392240$var$load("bABhq"),
    $510b3fa822392240$var$load("j3Tvz")
]).then(()=>parcelRequire('dFn0c'));

});



parcelRegister("tNfGA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldScreensRouteEntry", () => $8b6063e622d9269c$export$ea08b1064c32ddb2);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $jtpSO = parcelRequire("jtpSO");

var $5fjzQ = parcelRequire("5fjzQ");

var $iSul8 = parcelRequire("iSul8");
const $8b6063e622d9269c$export$ea08b1064c32ddb2 = (0, $6xToB.createEntry)((0, $jtpSO.globalSettingsIssueFieldScreensRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.screens',
        component: (0, $iSul8.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iSul8.LazyScreensPage)
        ]
    }));

});
parcelRegister("jtpSO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldScreensRoute", () => $8315e11698b1e326$export$197fd5d0ee709ca4);
const $8315e11698b1e326$export$197fd5d0ee709ca4 = {
    name: 'global-settings-issues-field-screens',
    path: '/jira/settings/issues/screens'
};

});

parcelRegister("iSul8", function(module, exports) {

$parcel$export(module.exports, "LazyScreensPage", () => $4697a3feba66eb2e$export$f4e6d546d7f2894c);
$parcel$export(module.exports, "default", () => $4697a3feba66eb2e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $4697a3feba66eb2e$export$f4e6d546d7f2894c = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ifteN"))), {
    moduleId: "./src/packages/admin-pages/screens/screens-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4697a3feba66eb2e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4697a3feba66eb2e$export$f4e6d546d7f2894c,
        pageId: "jira-admin-pages-screens-page",
        shouldShowSpinner: true
    });

});
parcelRegister("ifteN", function(module, exports) {

let $d4904eb657b5d9d8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $d4904eb657b5d9d8$var$load("1VRB2"),
    $d4904eb657b5d9d8$var$load("bABhq"),
    $d4904eb657b5d9d8$var$load("jwK1R")
]).then(()=>parcelRequire('3Cjvi'));

});



parcelRegister("4szwi", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRouteEntry", () => $5996c7f300dc44ce$export$b0811d27c1832ea1);

var $f9Fhp = parcelRequire("f9Fhp");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $dwx3R = parcelRequire("dwx3R");

var $9BJU1 = parcelRequire("9BJU1");

var $5fjzQ = parcelRequire("5fjzQ");

var $epTsa = parcelRequire("epTsa");
const $5996c7f300dc44ce$var$globalSettingsIssueFieldsManagementEntryPointPage = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $f9Fhp.globalSettingsIssueFieldsManagementRouteEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $5996c7f300dc44ce$export$b0811d27c1832ea1 = (0, $6xToB.createEntry)((0, $dwx3R.globalSettingsIssueFieldsManagementRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.fields',
        component: (0, $9BJU1.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        canTransitionIn: ()=>(0, $epTsa.expValEquals)('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', true, false),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint () {
            if ((0, $epTsa.expValEquals)('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', true, false)) return $5996c7f300dc44ce$var$globalSettingsIssueFieldsManagementEntryPointPage;
        }
    }));

});
parcelRegister("f9Fhp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRouteEntryPoint", () => $34694f5f23b618d0$export$b2a8ea978923a786);
// entrypoint.tsx

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $9zApf = parcelRequire("9zApf");

var $7jTnu = parcelRequire("7jTnu");
// Backwards compatibility with old URL params
const $34694f5f23b618d0$var$CustomFieldStatus = {
    TRASHED: 'trashed',
    ACTIVE: 'active'
};

const $34694f5f23b618d0$export$b2a8ea978923a786 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("bTHoI")), {
        moduleId: "8d9bdaab",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: { query: query } })=>{
        const initialTab = query.customFieldStatus?.toLowerCase() === $34694f5f23b618d0$var$CustomFieldStatus.TRASHED ? 'deleted' : 'active';
        return {
            queries: {
                globalFields: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $9zApf.default,
                    variables: {
                        cloudId: cloudId,
                        includeTypeDisplayName: (0, $7jTnu.fg)('add_sort_by_field_type_display_name') || false
                    }
                }
            },
            extraProps: {
                initialTab: initialTab
            }
        };
    }
});

});
parcelRegister("9zApf", function(module, exports) {

$parcel$export(module.exports, "default", () => $60efe253fb564be7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3baffbd65b7946f42c363c4c4c064c9d>>
 * @relayHash 2ee61623ca50c42eaefaf8b4a4b50bfd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a4032c3b535f4bb4c9e0f712d6c0e16c6dd229341561a835fc849d8e6bb8c287
const $60efe253fb564be7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a4032c3b535f4bb4c9e0f712d6c0e16c6dd229341561a835fc849d8e6bb8c287",
        "metadata": {},
        "name": "uiAdminPagesFieldsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $60efe253fb564be7$export$2e2bcd8739ae039 = $60efe253fb564be7$var$node;

});

parcelRegister("bTHoI", function(module, exports) {

let $8a967ea61e03317b$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $8a967ea61e03317b$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $8a967ea61e03317b$var$load("deNlq")
        ]);
    }),
    $8a967ea61e03317b$var$load("b9ASZ")
]).then(()=>parcelRequire('18U6A'));

});


parcelRegister("dwx3R", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRoute", () => $bb3d1e7348ae7593$export$6e571c84819449f5);
const $bb3d1e7348ae7593$export$6e571c84819449f5 = {
    name: 'global-settings-issues-fields-management-view',
    path: '/jira/settings/issues/fields'
};

});


parcelRegister("f7XdL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRouteEntry", () => $c891a70b2c398d64$export$ce3302d254f9c0b4);

var $eJOHy = parcelRequire("eJOHy");

var $h8pnX = parcelRequire("h8pnX");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $gL0pr = parcelRequire("gL0pr");

var $7fTjp = parcelRequire("7fTjp");

var $iOCyz = parcelRequire("iOCyz");
const $c891a70b2c398d64$export$ce3302d254f9c0b4 = (0, $6xToB.createEntry)((0, $gL0pr.globalSettingsIssueHierarchyRedirectRoute), ()=>({
        group: 'global-settings',
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
                to: "/jira/settings/issues/issue-hierarchy"
            }),
        isRedirect: true,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $h8pnX.issueHierarchyPageResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iOCyz.LazyIssueHierarchyDirectory)
        ]
    }));

});
parcelRegister("gL0pr", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRoute", () => $845130a82495e6e3$export$6236a41e09bb858a);
const $845130a82495e6e3$export$6236a41e09bb858a = {
    name: 'global-settings-issues-hierarchy-redirect',
    path: '/secure/PortfolioHierarchy.jspa'
};

});

parcelRegister("iOCyz", function(module, exports) {

$parcel$export(module.exports, "LazyIssueHierarchyDirectory", () => $817cd99bb93ca89e$export$1ff7255ab4f7a2dd);
$parcel$export(module.exports, "default", () => $817cd99bb93ca89e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $817cd99bb93ca89e$export$1ff7255ab4f7a2dd = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("a4ggs"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-hierarchy-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$817cd99bb93ca89e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $817cd99bb93ca89e$export$1ff7255ab4f7a2dd,
        pageId: "jira-admin-pages-issue-hierarchy-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("a4ggs", function(module, exports) {

let $7546e4dd27b24ee0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7546e4dd27b24ee0$var$load("1VRB2"),
    $7546e4dd27b24ee0$var$load("bABhq"),
    $7546e4dd27b24ee0$var$load("3Mvbx")
]).then(()=>parcelRequire('7BQsk'));

});



parcelRegister("goUY1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRouteEntry", () => $e8f24026c3471cba$export$119e5b48edcee4ff);

var $h8pnX = parcelRequire("h8pnX");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $kFp0r = parcelRequire("kFp0r");

var $5fjzQ = parcelRequire("5fjzQ");

var $iOCyz = parcelRequire("iOCyz");
const $e8f24026c3471cba$export$119e5b48edcee4ff = (0, $6xToB.createEntry)((0, $kFp0r.globalSettingsIssueHierarchyRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-hierarchy-config',
        component: (0, $iOCyz.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $h8pnX.issueHierarchyPageResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iOCyz.LazyIssueHierarchyDirectory)
        ]
    }));

});
parcelRegister("kFp0r", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRoute", () => $e6c6cf3d092abfdf$export$2c220ed11ae62e14);
const $e6c6cf3d092abfdf$export$2c220ed11ae62e14 = {
    name: 'global-settings-issues-hierarchy-view',
    path: '/jira/settings/issues/issue-hierarchy'
};

});


parcelRegister("cpLuR", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRouteEntry", () => $254ce9d765bbe306$export$5519b86c9ea602e1);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $jbTNU = parcelRequire("jbTNU");

var $8zfV8 = parcelRequire("8zfV8");
const $254ce9d765bbe306$export$5519b86c9ea602e1 = (0, $6xToB.createEntry)((0, $jbTNU.globalSettingsIssuesExplicitFieldAssociationRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        component: (0, $8zfV8.LazyExplicitFieldsProjectListPage),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8zfV8.LazyExplicitFieldsProjectListPromise)
        ]
    }));

});
parcelRegister("jbTNU", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRoute", () => $1855163d6f79197b$export$4f2c2d125c2b811a);
const $1855163d6f79197b$export$4f2c2d125c2b811a = {
    name: 'global-settings-issues-explicit-field-association-project-list',
    path: '/jira/settings/issues/explicit-field-association'
};

});

parcelRegister("8zfV8", function(module, exports) {

$parcel$export(module.exports, "LazyExplicitFieldsProjectListPromise", () => $fb333efc50c60ea2$export$7b11685155ada84d);
$parcel$export(module.exports, "LazyExplicitFieldsProjectListPage", () => $fb333efc50c60ea2$export$e81c180c4f4833e);

var $eJOHy = parcelRequire("eJOHy");

var $gzcjr = parcelRequire("gzcjr");

var $1F9cm = parcelRequire("1F9cm");

const $fb333efc50c60ea2$export$7b11685155ada84d = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8LrCn")), {
    moduleId: "./src/packages/spa-apps/error-pages/not-found/src/index.tsx"
});
const $fb333efc50c60ea2$export$e81c180c4f4833e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fb333efc50c60ea2$export$7b11685155ada84d,
        pageId: "errors-404",
        shouldShowSpinner: false
    });

});


parcelRegister("5KbgO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNewIssueSearchRouteEntry", () => $d84cdb0f414aa0e8$export$ecfeb067cb61f7f7);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $9bTfr = parcelRequire("9bTfr");

var $5fjzQ = parcelRequire("5fjzQ");

var $4b89B = parcelRequire("4b89B");
const $d84cdb0f414aa0e8$export$ecfeb067cb61f7f7 = (0, $6xToB.createEntry)((0, $9bTfr.globalSettingsIssuesNewIssueSearchRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.new-issue-search-transition',
        component: (0, $4b89B.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4b89B.LazyNewIssueSearchTransition)
        ],
        canTransitionIn: ()=>true
    }));

});
parcelRegister("9bTfr", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNewIssueSearchRoute", () => $10a8d73ad8a06398$export$774dc60e785b8ae8);
const $10a8d73ad8a06398$export$774dc60e785b8ae8 = {
    name: 'global-settings-issues-new-issue-search',
    path: '/jira/settings/issues/new-issue-search-transition'
};

});

parcelRegister("4b89B", function(module, exports) {

$parcel$export(module.exports, "LazyNewIssueSearchTransition", () => $41cdd0dc39a15f49$export$aa5e318abd957ad);
$parcel$export(module.exports, "default", () => $41cdd0dc39a15f49$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $41cdd0dc39a15f49$export$aa5e318abd957ad = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("heBib"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/new-issue-search-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$41cdd0dc39a15f49$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $41cdd0dc39a15f49$export$aa5e318abd957ad,
        pageId: "jira-admin-pages-new-issue-search-transition",
        shouldShowSpinner: true
    });

});
parcelRegister("heBib", function(module, exports) {

let $c8c0abefd6e0ca2f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c8c0abefd6e0ca2f$var$load("fYRcA").then(()=>parcelRequire('iB9F0'));

});



parcelRegister("d3qbB", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRouteEntry", () => $690814e47b18fedb$export$63a56a096ab0d260);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $kHlOR = parcelRequire("kHlOR");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $dhkml = parcelRequire("dhkml");

var $5fjzQ = parcelRequire("5fjzQ");

var $1DhCr = parcelRequire("1DhCr");
const $690814e47b18fedb$export$63a56a096ab0d260 = (0, $6xToB.createEntry)((0, $dhkml.globalSettingsIssuesPrioritiesRoute), ()=>({
        group: 'global-settings',
        component: (0, $1DhCr.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1DhCr.LazyPrioritiesPage)
        ]
    }));

});
parcelRegister("dhkml", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRoute", () => $bca045faab5c8bda$export$518516cdf6b7cd83);
const $bca045faab5c8bda$export$518516cdf6b7cd83 = {
    name: 'global-settings-issues-priorities',
    path: '/jira/settings/issues/priorities'
};

});

parcelRegister("1DhCr", function(module, exports) {

$parcel$export(module.exports, "LazyPrioritiesPage", () => $2d85bab79423bf6e$export$2b5843205130631c);
$parcel$export(module.exports, "default", () => $2d85bab79423bf6e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $2d85bab79423bf6e$export$2b5843205130631c = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7g3YK"))), {
    moduleId: "./src/packages/admin-pages/priorities/src/index.tsx"
});
const $2d85bab79423bf6e$var$PrioritiesPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $2d85bab79423bf6e$export$2b5843205130631c,
        pageId: "jira-admin-pages-priorities",
        shouldShowSpinner: true
    });
var $2d85bab79423bf6e$export$2e2bcd8739ae039 = $2d85bab79423bf6e$var$PrioritiesPage;

});
parcelRegister("7g3YK", function(module, exports) {

let $548d1d1ce5741f9e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $548d1d1ce5741f9e$var$load("R0Z7Y").then(()=>parcelRequire('ho0V4'));

});



parcelRegister("kLk7C", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRouteEntry", () => $75a2806a58bbbdbf$export$a5ac2a64ed09e754);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $fKd3N = parcelRequire("fKd3N");

var $5fjzQ = parcelRequire("5fjzQ");

var $9Bh0G = parcelRequire("9Bh0G");
const $75a2806a58bbbdbf$export$a5ac2a64ed09e754 = (0, $6xToB.createEntry)((0, $fKd3N.globalSettingsIssuesPrioritySchemesRoute), ()=>({
        group: 'global-settings',
        component: (0, $9Bh0G.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $9Bh0G.LazyPrioritySchemes)
        ]
    }));

});
parcelRegister("fKd3N", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRoute", () => $406083e41b689f52$export$185af30f53271c10);
const $406083e41b689f52$export$185af30f53271c10 = {
    name: 'global-settings-issues-priority-schemes',
    path: '/jira/settings/issues/priority-schemes'
};

});

parcelRegister("9Bh0G", function(module, exports) {

$parcel$export(module.exports, "LazyPrioritySchemes", () => $023d8f15f5c6ff64$export$20bb8a3b40a3add4);
$parcel$export(module.exports, "default", () => $023d8f15f5c6ff64$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $023d8f15f5c6ff64$export$20bb8a3b40a3add4 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("55VZd"))), {
    moduleId: "./src/packages/admin-pages/priority-schemes/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$023d8f15f5c6ff64$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $023d8f15f5c6ff64$export$20bb8a3b40a3add4,
        pageId: "jira-admin-pages-priority-schemes",
        shouldShowSpinner: true
    });

});
parcelRegister("55VZd", function(module, exports) {

let $3b5a6640ccf6d585$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $3b5a6640ccf6d585$var$load("1VRB2"),
    $3b5a6640ccf6d585$var$load("bABhq"),
    $3b5a6640ccf6d585$var$load("rvOvs")
]).then(()=>parcelRequire('klWjk'));

});



parcelRegister("fcC3H", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesRouteEntry", () => $7a35b209d240cbf4$export$680243b058188dc0);

var $24q98 = parcelRequire("24q98");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $EEl9K = parcelRequire("EEl9K");

var $5fjzQ = parcelRequire("5fjzQ");

var $2Gm1W = parcelRequire("2Gm1W");
const $7a35b209d240cbf4$export$680243b058188dc0 = (0, $6xToB.createEntry)((0, $EEl9K.globalSettingsIssueTypesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-types',
        component: (0, $2Gm1W.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $24q98.issueTypesResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $2Gm1W.LazyIssueTypesDirectory)
        ]
    }));

});
parcelRegister("24q98", function(module, exports) {

$parcel$export(module.exports, "issueTypesResource", () => $9908f68875501254$export$614e9d897c1ef917);

var $b5RwB = parcelRequire("b5RwB");

var $l1VxS = parcelRequire("l1VxS");

var $dHr8U = parcelRequire("dHr8U");
const $9908f68875501254$export$614e9d897c1ef917 = (0, $l1VxS.createResource)({
    type: 'GLOBAL_ADMIN_ISSUE_TYPES_DIRECTORY',
    getKey: ()=>'issue types',
    getData: async ({ query: query })=>(0, $dHr8U.getIssueTypes)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(query))
});

});
parcelRegister("dHr8U", function(module, exports) {

$parcel$export(module.exports, "getIssueTypes", () => $22bb0c24e30189e8$export$4cf4b24b88599615);

var $b5RwB = parcelRequire("b5RwB");

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");


var $d64X1 = parcelRequire("d64X1");
const $22bb0c24e30189e8$export$4cf4b24b88599615 = async (qs)=>{
    const filter = (0, $d64X1.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify((0, $d64X1.toApiUrlTransformer)(filter));
    try {
        return await (0, $1Ozm9.default)(`/rest/internal/3/issuetype/search?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: (0, $1ba65dc7195bd459$export$4adfbb237b083187),
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $1ba65dc7195bd459$export$4adfbb237b083187 = 'jiraAdminPagesIssueTypesResources';

parcelRegister("d64X1", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $ee9effee47fd8c84$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $ee9effee47fd8c84$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toSearchFilterQsTransformer", () => $ee9effee47fd8c84$export$bcd1ab210547e2f5);
$parcel$export(module.exports, "toSortFieldFilterQsTransformer", () => $ee9effee47fd8c84$export$c114848fa733e5c4);
$parcel$export(module.exports, "toSortDirectionFilterQsTransformer", () => $ee9effee47fd8c84$export$c5d2609f8b4048d3);
$parcel$export(module.exports, "toApiUrlTransformer", () => $ee9effee47fd8c84$export$fb15afa686993f11);

var $6GoxC = parcelRequire("6GoxC");

var $b5RwB = parcelRequire("b5RwB");



var $bOEO3 = parcelRequire("bOEO3");

var $8k9Gj = parcelRequire("8k9Gj");

var $3EoCO = parcelRequire("3EoCO");
const $ee9effee47fd8c84$var$sortDirectionMap = {
    [(0, $a535a1c1a5d4d33f$export$1dee026a19752d6b).toLowerCase()]: (0, $a535a1c1a5d4d33f$export$1dee026a19752d6b),
    [(0, $a535a1c1a5d4d33f$export$b6abcf7fa1d94f65).toLowerCase()]: (0, $a535a1c1a5d4d33f$export$b6abcf7fa1d94f65)
};
const $ee9effee47fd8c84$var$sortFieldMap = {
    [(0, $bbf630b4e2114055$export$3c5e605ca7ade9f2).toLowerCase()]: (0, $bbf630b4e2114055$export$3c5e605ca7ade9f2),
    [(0, $bbf630b4e2114055$export$7673664bdc3ae979).toLowerCase()]: (0, $bbf630b4e2114055$export$7673664bdc3ae979)
};
const $ee9effee47fd8c84$export$5b9f8ed2c34be88a = (filter)=>filter ? {
        page: filter.page !== undefined && filter.page >= 1 ? String(filter.page) : undefined,
        sortDirection: (0, $8k9Gj.fieldToParam)(filter.sortDirection),
        sortField: (0, $8k9Gj.fieldToParam)(filter.sortField),
        searchFilter: (0, $8k9Gj.trimSearchFilter)(filter.searchFilter)
    } : {};
const $ee9effee47fd8c84$export$bec67ef860c0d0e1 = (params)=>({
        page: Math.floor(Number((0, $bOEO3.number).parse(params.page))) || undefined,
        searchFilter: (0, $8k9Gj.trimSearchFilter)(params.searchFilter),
        sortDirection: (0, $8k9Gj.fieldFromParam)($ee9effee47fd8c84$var$sortDirectionMap, params.sortDirection),
        sortField: (0, $8k9Gj.fieldFromParam)($ee9effee47fd8c84$var$sortFieldMap, params.sortField)
    });
const $ee9effee47fd8c84$export$bcd1ab210547e2f5 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(qs);
    return parsed.searchFilter ? parsed.searchFilter : '';
};
const $ee9effee47fd8c84$export$c114848fa733e5c4 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(qs);
    return parsed.sortField && parsed.sortField === 'name' ? (0, $bbf630b4e2114055$export$3c5e605ca7ade9f2) : (0, $bbf630b4e2114055$export$7673664bdc3ae979);
};
const $ee9effee47fd8c84$export$c5d2609f8b4048d3 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(qs);
    return parsed.sortDirection && parsed.sortDirection === 'asc' ? (0, $a535a1c1a5d4d33f$export$1dee026a19752d6b) : (0, $a535a1c1a5d4d33f$export$b6abcf7fa1d94f65);
};
const $ee9effee47fd8c84$var$apiSortByMap = {
    [(0, $a535a1c1a5d4d33f$export$1dee026a19752d6b)]: '',
    [(0, $a535a1c1a5d4d33f$export$b6abcf7fa1d94f65)]: '-'
};
const $ee9effee47fd8c84$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($6GoxC)))({}, filter, (0, $3EoCO.DEFAULT_FILTER));
    // this additional mapping here is needed because the BE issue type search API already supports sorting by hierarchy level using the "type" parameter. It was decided to add mapping on frontend. More details here https://atlassian.slack.com/archives/C02HN05MC8K/p1680683395059279
    const sortFieldMapping = fullFilter.sortField === 'hierarchy-level' ? 'type' : fullFilter.sortField;
    return {
        maxResults: (0, $3EoCO.MAX_RESULTS),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.page - 1) * (0, $3EoCO.MAX_RESULTS),
        query: (0, $8k9Gj.trimSearchFilter)(fullFilter.searchFilter),
        // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
        orderBy: `${$ee9effee47fd8c84$var$apiSortByMap[fullFilter.sortDirection]}${sortFieldMapping}`
    };
};

});
parcelRegister("6GoxC", function(module, exports) {

var $l76qh = parcelRequire("l76qh");

var $2wri1 = parcelRequire("2wri1");

var $eA1it = parcelRequire("eA1it");

var $bIi70 = parcelRequire("bIi70");
/** Used for built-in method references. */ var $4dd9b3b5c88f0b8c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4dd9b3b5c88f0b8c$var$hasOwnProperty = $4dd9b3b5c88f0b8c$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $4dd9b3b5c88f0b8c$var$defaults = $l76qh(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $eA1it(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $bIi70(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $2wri1(value, $4dd9b3b5c88f0b8c$var$objectProto[key]) && !$4dd9b3b5c88f0b8c$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = $4dd9b3b5c88f0b8c$var$defaults;

});

// data field names
const $bbf630b4e2114055$export$3c5e605ca7ade9f2 = 'name';
const $bbf630b4e2114055$export$d44826c816b5619b = 'description';
const $bbf630b4e2114055$export$b87f371cbc396fcf = 'type';
const $bbf630b4e2114055$export$7673664bdc3ae979 = 'hierarchy-level';
const $bbf630b4e2114055$export$68e97ee499f7c743 = 'related-schemes';
const $bbf630b4e2114055$export$92a1a3b7554e9387 = 'actions';
const $bbf630b4e2114055$export$23ba45d5f8d54fed = 'level-number';
const $bbf630b4e2114055$export$1dc71bc9f1a3749a = 'arrow';
const $bbf630b4e2114055$export$8be5a31a21d0c723 = 'level-name';
const $bbf630b4e2114055$export$6ad51af4785d6548 = 'jira-issue-types';
const $bbf630b4e2114055$export$20068afc6f8c1737 = 'label-space';

const $a535a1c1a5d4d33f$export$1dee026a19752d6b = 'ASC';
const $a535a1c1a5d4d33f$export$b6abcf7fa1d94f65 = 'DESC';

parcelRegister("bOEO3", function(module, exports) {

$parcel$export(module.exports, "string", () => $9cbdb5c296f305a5$export$22b082955e083ec3);
$parcel$export(module.exports, "bool", () => $9cbdb5c296f305a5$export$87b259aa03e3d267);
$parcel$export(module.exports, "array", () => $9cbdb5c296f305a5$export$2f23118c22fb2630);
$parcel$export(module.exports, "multiple", () => $9cbdb5c296f305a5$export$939ddaa3205df08e);
$parcel$export(module.exports, "number", () => $9cbdb5c296f305a5$export$98e628dec113755e);

var $d7YnM = parcelRequire("d7YnM");
const $9cbdb5c296f305a5$export$22b082955e083ec3 = {
    stringify: (0, (/*@__PURE__*/$parcel$interopDefault($d7YnM))),
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($d7YnM)))
};
const $9cbdb5c296f305a5$export$87b259aa03e3d267 = {
    stringify: (value)=>String(value),
    parse: (value)=>{
        if (value === 'true') return true;
        if (value === 'false') return false;
        return undefined;
    }
};
const $9cbdb5c296f305a5$export$2f23118c22fb2630 = {
    stringify: (value)=>value && Array.isArray(value) ? value.join(',') : undefined,
    parse: (value)=>typeof value === 'string' ? value?.split(',') : undefined
};
const $9cbdb5c296f305a5$export$939ddaa3205df08e = {
    stringify: (value)=>{
        if (!value || !Array.isArray(value)) return undefined;
        return value.length === 1 ? value[0] : value;
    },
    parse: (value)=>value && Array.isArray(value) ? value : [
            String(value)
        ]
};
const $9cbdb5c296f305a5$export$98e628dec113755e = {
    stringify: (value)=>`${value}`,
    parse: (value)=>Number(value)
};

});

parcelRegister("8k9Gj", function(module, exports) {

$parcel$export(module.exports, "fieldToParam", () => $e204fe5cc0b7416d$export$7341f299e7b93e87);
$parcel$export(module.exports, "fieldFromParam", () => $e204fe5cc0b7416d$export$c876451e094c0060);
$parcel$export(module.exports, "trimSearchFilter", () => $e204fe5cc0b7416d$export$ed1722f41c23aaaf);
const $e204fe5cc0b7416d$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $e204fe5cc0b7416d$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $e204fe5cc0b7416d$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});

parcelRegister("3EoCO", function(module, exports) {

$parcel$export(module.exports, "MAX_RESULTS", () => $112d0ba2477c64e1$export$f6b2881bc1090cea);
$parcel$export(module.exports, "DEFAULT_FILTER", () => $112d0ba2477c64e1$export$6deee0e4f2fb784e);


const $112d0ba2477c64e1$export$f6b2881bc1090cea = 15;
const $112d0ba2477c64e1$export$6deee0e4f2fb784e = {
    page: 1,
    sortDirection: (0, $a535a1c1a5d4d33f$export$b6abcf7fa1d94f65),
    sortField: (0, $bbf630b4e2114055$export$7673664bdc3ae979)
};

});




parcelRegister("EEl9K", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesRoute", () => $a015bf0c6e96bc46$export$7358263a3bbb38b1);
const $a015bf0c6e96bc46$export$7358263a3bbb38b1 = {
    name: 'global-settings-issues-types-view',
    path: '/jira/settings/issues/issue-types'
};

});

parcelRegister("2Gm1W", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypesDirectory", () => $13a10676821889fb$export$661e1bf38bb82270);
$parcel$export(module.exports, "default", () => $13a10676821889fb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $13a10676821889fb$export$661e1bf38bb82270 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("eO4I9"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-types-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$13a10676821889fb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $13a10676821889fb$export$661e1bf38bb82270,
        pageId: "jira-admin-pages-issue-types-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("eO4I9", function(module, exports) {

let $ac7963c0a9f1bd25$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ac7963c0a9f1bd25$var$load("1VRB2"),
    $ac7963c0a9f1bd25$var$load("bABhq"),
    $ac7963c0a9f1bd25$var$load("foFfY")
]).then(()=>parcelRequire('drGkM'));

});



parcelRegister("4CAXG", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesSchemesRouteEntry", () => $ef13d4b0e87cf5f0$export$8f940be66a7e7324);

var $1GrIr = parcelRequire("1GrIr");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $gMZln = parcelRequire("gMZln");

var $5fjzQ = parcelRequire("5fjzQ");

var $31U0M = parcelRequire("31U0M");
const $ef13d4b0e87cf5f0$export$8f940be66a7e7324 = (0, $6xToB.createEntry)((0, $gMZln.globalSettingsIssueTypesSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.view-issue-type-schemes',
        component: (0, $31U0M.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $1GrIr.default),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $31U0M.LazyIssueTypeSchemesDirectory)
        ]
    }));

});
parcelRegister("1GrIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6139d1d60d40c03$export$2e2bcd8739ae039);

var $b5RwB = parcelRequire("b5RwB");

var $l1VxS = parcelRequire("l1VxS");

var $hT35T = parcelRequire("hT35T");
const $a6139d1d60d40c03$var$ISSUE_TYPE_SCHEME_TABLE_TYPE = 'ISSUE_TYPE_SCHEME_TABLE';
const $a6139d1d60d40c03$var$ISSUE_TYPE_SCHEME_TABLE_KEY = 'ISSUE_TYPE_SCHEME_TABLE_KEY';
const $a6139d1d60d40c03$var$issueTypeSchemeResource = (0, $l1VxS.createResource)({
    type: $a6139d1d60d40c03$var$ISSUE_TYPE_SCHEME_TABLE_TYPE,
    getKey: ({ query: query })=>`${$a6139d1d60d40c03$var$ISSUE_TYPE_SCHEME_TABLE_KEY}-${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $hT35T.getIssueTypeSchemes)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(query))
});
var $a6139d1d60d40c03$export$2e2bcd8739ae039 = $a6139d1d60d40c03$var$issueTypeSchemeResource;

});
parcelRegister("hT35T", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeSchemes", () => $6954b4cb1a443fca$export$2844cac611eecaa7);

var $b5RwB = parcelRequire("b5RwB");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $69kFd = parcelRequire("69kFd");

var $3rHvS = parcelRequire("3rHvS");
const $6954b4cb1a443fca$export$2844cac611eecaa7 = async (qs)=>{
    const filter = (0, $3rHvS.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify((0, $3rHvS.toApiUrlTransformer)(filter));
    try {
        return await (0, $jGzN3.performGetRequest)(`/rest/api/3/issuetypescheme?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: (0, $69kFd.PACKAGE_NAME),
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("69kFd", function(module, exports) {

$parcel$export(module.exports, "SOURCE_NAME", () => $eb5d4116722ef537$export$a3821bc63538b210);
$parcel$export(module.exports, "ISSUE_TYPE_SCHEMES_TABLE", () => $eb5d4116722ef537$export$91570d508c93485d);
$parcel$export(module.exports, "ORDER", () => $eb5d4116722ef537$export$11e75bce9f7ea886);
$parcel$export(module.exports, "MAX_RESULTS", () => $eb5d4116722ef537$export$f6b2881bc1090cea);
$parcel$export(module.exports, "defaultIssueTypeSchemesFilter", () => $eb5d4116722ef537$export$625de46796f967ae);
$parcel$export(module.exports, "EMPTY_PROJECTS_PAGE", () => $eb5d4116722ef537$export$81a0343467d0e9a9);
$parcel$export(module.exports, "PACKAGE_NAME", () => $eb5d4116722ef537$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $eb5d4116722ef537$export$9ac56b2484c2d4e9);
// analytics constants

const $eb5d4116722ef537$export$a3821bc63538b210 = 'issueTypeSchemeDirectory';
const $eb5d4116722ef537$export$91570d508c93485d = 'issueTypeSchemesTable';
const $eb5d4116722ef537$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $eb5d4116722ef537$export$f6b2881bc1090cea = 10;
const $eb5d4116722ef537$export$625de46796f967ae = {
    pageNumber: 1,
    pageSize: $eb5d4116722ef537$export$f6b2881bc1090cea,
    expand: [
        'projects',
        'issueTypes'
    ],
    orderBy: 'name',
    sortDirection: (0, $a535a1c1a5d4d33f$export$b6abcf7fa1d94f65)
};
const $eb5d4116722ef537$export$81a0343467d0e9a9 = {
    startAt: 0,
    maxResults: 10,
    values: [],
    total: 0,
    isLast: true
};
const $eb5d4116722ef537$export$b8b9d90f9e5bd72b = 'jiraAdminPagesIssueTypeSchemesDirectory';
const $eb5d4116722ef537$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});

});

parcelRegister("3rHvS", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $98a6aa2868ec8307$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $98a6aa2868ec8307$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $98a6aa2868ec8307$export$fb15afa686993f11);

var $6GoxC = parcelRequire("6GoxC");

var $bOEO3 = parcelRequire("bOEO3");

var $69kFd = parcelRequire("69kFd");

var $11Qsp = parcelRequire("11Qsp");
const $98a6aa2868ec8307$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy
    };
};
const $98a6aa2868ec8307$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = params;
    const parsedNumber = Number.isNaN((0, $bOEO3.number).parse(pageNumber)) ? (0, $69kFd.defaultIssueTypeSchemesFilter).pageNumber : (0, $bOEO3.number).parse(pageNumber);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' ? orderBy : undefined;
    return {
        ...(0, $69kFd.defaultIssueTypeSchemesFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy
    };
};
const $98a6aa2868ec8307$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($6GoxC)))({}, filter, (0, $69kFd.defaultIssueTypeSchemesFilter));
    let requestParams = {
        maxResults: (0, $69kFd.MAX_RESULTS),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.pageNumber - 1) * (0, $69kFd.MAX_RESULTS),
        orderBy: fullFilter.orderBy,
        queryString: (0, $11Qsp.trimSearchFilter)(fullFilter.searchFilter)
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("11Qsp", function(module, exports) {

$parcel$export(module.exports, "trimSearchFilter", () => $f878d4cd778e2617$export$ed1722f41c23aaaf);
const $f878d4cd778e2617$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});




parcelRegister("gMZln", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesSchemesRoute", () => $a2980d6044f25ee6$export$2aba97aa663f43b3);
const $a2980d6044f25ee6$export$2aba97aa663f43b3 = {
    name: 'global-settings-issues-types-schemes-manage',
    path: '/jira/settings/issues/issue-type-schemes'
};

});

parcelRegister("31U0M", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSchemesDirectory", () => $c8bade2c565be10b$export$611728a54ba37830);
$parcel$export(module.exports, "default", () => $c8bade2c565be10b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $c8bade2c565be10b$export$611728a54ba37830 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("SpQzH"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-type-schemes-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c8bade2c565be10b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c8bade2c565be10b$export$611728a54ba37830,
        pageId: "jira-admin-pages-issue-type-schemes-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("SpQzH", function(module, exports) {

let $0a3917eec06a24d1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0a3917eec06a24d1$var$load("20NAG").then(()=>parcelRequire('2yAmG'));

});



parcelRegister("kZ7rD", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesScreenSchemesRouteEntry", () => $519cb5832694145f$export$e2c2c1569887e684);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $cnps2 = parcelRequire("cnps2");

var $5fjzQ = parcelRequire("5fjzQ");

var $35xnd = parcelRequire("35xnd");
const $519cb5832694145f$export$e2c2c1569887e684 = (0, $6xToB.createEntry)((0, $cnps2.globalSettingsIssueTypesScreenSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-type-screen-schemes',
        component: (0, $35xnd.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $35xnd.LazyIssueTypeScreenSchemesPage)
        ]
    }));

});
parcelRegister("cnps2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesScreenSchemesRoute", () => $59a0d82495c94fa6$export$df93a4addc359237);
const $59a0d82495c94fa6$export$df93a4addc359237 = {
    name: 'global-settings-issues-types-screen-schemes-view',
    path: '/jira/settings/issues/issue-type-screen-schemes'
};

});

parcelRegister("35xnd", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeScreenSchemesPage", () => $1b60da8c0eeefdc3$export$350edfb57b335a57);
$parcel$export(module.exports, "default", () => $1b60da8c0eeefdc3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $1b60da8c0eeefdc3$export$350edfb57b335a57 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("1iFvS"))), {
    moduleId: "./src/packages/admin-pages/issue-type-screen-schemes-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1b60da8c0eeefdc3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1b60da8c0eeefdc3$export$350edfb57b335a57,
        pageId: "jira-admin-pages-issue-type-screen-schemes-page",
        shouldShowSpinner: true
    });

});
parcelRegister("1iFvS", function(module, exports) {

let $0f27ac8d5e114a45$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $0f27ac8d5e114a45$var$load("1VRB2"),
    $0f27ac8d5e114a45$var$load("bABhq"),
    $0f27ac8d5e114a45$var$load("5QUmQ")
]).then(()=>parcelRequire('hrRYp'));

});



parcelRegister("dChQF", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflow1RouteEntry", () => $ac67cbf255a22335$export$55e4c1d21a9b75e6);

var $1nJtC = parcelRequire("1nJtC");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $fQQ9b = parcelRequire("fQQ9b");

var $5fjzQ = parcelRequire("5fjzQ");

var $du7XD = parcelRequire("du7XD");
const $ac67cbf255a22335$export$55e4c1d21a9b75e6 = (0, $6xToB.createEntry)((0, $fQQ9b.globalSettingsIssueWorkflow1Route), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.view-workflows',
        component: (0, $du7XD.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $1nJtC.default),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $du7XD.LazyListWorkflows)
        ]
    }));

});
parcelRegister("1nJtC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff43200fb00a118b$export$2e2bcd8739ae039);

var $b5RwB = parcelRequire("b5RwB");

var $l1VxS = parcelRequire("l1VxS");

var $fAANq = parcelRequire("fAANq");
const $ff43200fb00a118b$var$WORKFLOWS_TABLE_TYPE = 'WORKFLOWS_TABLE';
const $ff43200fb00a118b$var$WORKFLOWS_TABLE_KEY = 'WORKFLOWS_TABLE_KEY';
const $ff43200fb00a118b$var$workFlowsResource = (0, $l1VxS.createResource)({
    type: $ff43200fb00a118b$var$WORKFLOWS_TABLE_TYPE,
    getKey: ({ query: query })=>`${$ff43200fb00a118b$var$WORKFLOWS_TABLE_KEY}-${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $fAANq.getListWorkFlows)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(query))
});
var $ff43200fb00a118b$export$2e2bcd8739ae039 = $ff43200fb00a118b$var$workFlowsResource;

});
parcelRegister("fAANq", function(module, exports) {

$parcel$export(module.exports, "getListWorkFlows", () => $ae5d1859679b7755$export$952f5d693c3c0d4e);

var $b5RwB = parcelRequire("b5RwB");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $fySav = parcelRequire("fySav");

var $3VsdN = parcelRequire("3VsdN");
const $ae5d1859679b7755$export$952f5d693c3c0d4e = async (qs)=>{
    const filter = (0, $3VsdN.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify((0, $3VsdN.toApiUrlTransformer)(filter));
    try {
        return await (0, $jGzN3.performGetRequest)(`/rest/api/3/workflow/search?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'getWorkflowsSearchAPI',
                packageName: (0, $fySav.PACKAGE_NAME),
                teamName: 'helix'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("fySav", function(module, exports) {

$parcel$export(module.exports, "SOURCE_NAME", () => $7f38a672b36663ef$export$a3821bc63538b210);
$parcel$export(module.exports, "WORKFLOW_NAME", () => $7f38a672b36663ef$export$a69699c3acbd94ca);
$parcel$export(module.exports, "PACKAGE_NAME", () => $7f38a672b36663ef$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "WORKFLOWS_ACTIONS", () => $7f38a672b36663ef$export$f3ab46ae5f3c01ad);
$parcel$export(module.exports, "WORKFLOWS_SCHEME", () => $7f38a672b36663ef$export$81c9aaf617cb2f01);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_JIRA_NAME", () => $7f38a672b36663ef$export$615f1d8b29794ae);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_BUILDS_WORKFLOWS_NAME", () => $7f38a672b36663ef$export$fccd4c1ce5f0896f);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $7f38a672b36663ef$export$5716e8bcb003888d);
$parcel$export(module.exports, "defaultListWorkFlowsFilter", () => $7f38a672b36663ef$export$dc5aae53031515c);
$parcel$export(module.exports, "ORDER", () => $7f38a672b36663ef$export$11e75bce9f7ea886);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $7f38a672b36663ef$export$9ac56b2484c2d4e9);
$parcel$export(module.exports, "PAGE_SIZE_CHANGE_ANALYTICS", () => $7f38a672b36663ef$export$e6613a3c77896936);
$parcel$export(module.exports, "API_PREFIX", () => $7f38a672b36663ef$export$a3f6840410eb0571);

const $7f38a672b36663ef$export$a3821bc63538b210 = 'listWorkflows';
const $7f38a672b36663ef$export$a69699c3acbd94ca = 'workflowName';
const $7f38a672b36663ef$export$b8b9d90f9e5bd72b = 'jira-admin-pages-list-workflows';
const $7f38a672b36663ef$export$f3ab46ae5f3c01ad = 'workflowsActions';
const $7f38a672b36663ef$export$81c9aaf617cb2f01 = 'workflowScheme';
const $7f38a672b36663ef$export$615f1d8b29794ae = 'jira';
const $7f38a672b36663ef$export$fccd4c1ce5f0896f = 'Builds Workflow';
const $7f38a672b36663ef$export$5716e8bcb003888d = 10;
const $7f38a672b36663ef$export$dc5aae53031515c = {
    pageNumber: 1,
    pageSize: $7f38a672b36663ef$export$5716e8bcb003888d,
    expand: [
        'default',
        'hasDraftWorkflow',
        'schemes',
        'operations',
        'projects'
    ],
    orderBy: 'name',
    sortDirection: (0, $a535a1c1a5d4d33f$export$1dee026a19752d6b),
    isActive: true
};
const $7f38a672b36663ef$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $7f38a672b36663ef$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});
const $7f38a672b36663ef$export$e6613a3c77896936 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'pageSize'
});
const $7f38a672b36663ef$export$a3f6840410eb0571 = 'gateway/api/jira/project-configuration';

});

parcelRegister("3VsdN", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $405d56adac524b4f$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $405d56adac524b4f$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $405d56adac524b4f$export$fb15afa686993f11);

var $bOEO3 = parcelRequire("bOEO3");

var $fySav = parcelRequire("fySav");

var $01GPE = parcelRequire("01GPE");
const $405d56adac524b4f$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy,
        isActive: isActive,
        pageSize: pageSize
    };
};
const $405d56adac524b4f$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = params;
    const parsedNumber = Number.isNaN((0, $bOEO3.number).parse(pageNumber)) ? (0, $fySav.defaultListWorkFlowsFilter).pageNumber : (0, $bOEO3.number).parse(pageNumber);
    const parsedSize = Number.isNaN((0, $bOEO3.number).parse(pageSize)) ? (0, $fySav.defaultListWorkFlowsFilter).pageSize : (0, $bOEO3.number).parse(pageSize);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' || orderBy === 'updated' || orderBy === '-updated' ? orderBy : undefined;
    const isActiveFinal = isActive != null ? isActive === 'true' : (0, $fySav.defaultListWorkFlowsFilter).isActive;
    return {
        ...(0, $fySav.defaultListWorkFlowsFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        pageSize: parsedSize != null ? Number(parsedSize) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy,
        isActive: isActiveFinal
    };
};
const $405d56adac524b4f$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = {
        ...(0, $fySav.defaultListWorkFlowsFilter),
        ...filter
    };
    const { pageNumber: pageNumber = 1, pageSize: pageSize = (0, $fySav.DEFAULT_PAGE_SIZE) } = fullFilter;
    let requestParams = {
        maxResults: pageSize,
        startAt: (pageNumber - 1) * pageSize,
        orderBy: fullFilter.orderBy,
        queryString: (0, $01GPE.trimSearchFilter)(fullFilter.searchFilter),
        isActive: fullFilter.isActive
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("01GPE", function(module, exports) {

$parcel$export(module.exports, "trimSearchFilter", () => $884bae35693b6bf0$export$ed1722f41c23aaaf);
const $884bae35693b6bf0$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $884bae35693b6bf0$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $884bae35693b6bf0$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});




parcelRegister("fQQ9b", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflow1Route", () => $b90ccaaf01661e08$export$f8f2a617a2f4d53);
const $b90ccaaf01661e08$export$f8f2a617a2f4d53 = {
    name: 'global-settings-issues-workflows-pages',
    path: '/jira/settings/issues/workflows'
};

});

parcelRegister("du7XD", function(module, exports) {

$parcel$export(module.exports, "LazyListWorkflows", () => $8182e561fb9b3513$export$4c64b4f1ecf22fc8);
$parcel$export(module.exports, "default", () => $8182e561fb9b3513$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $8182e561fb9b3513$export$4c64b4f1ecf22fc8 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("kxrV1"))), {
    moduleId: "./src/packages/admin-pages/list-workflows/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8182e561fb9b3513$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8182e561fb9b3513$export$4c64b4f1ecf22fc8,
        pageId: "jira-admin-pages-list-workflows",
        shouldShowSpinner: true
    });

});
parcelRegister("kxrV1", function(module, exports) {

let $03dbd0b4e133daed$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $03dbd0b4e133daed$var$load("25LrV").then(()=>parcelRequire('28Ibt'));

});



parcelRegister("67YRM", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowEditRouteEntry", () => $aa12078081d7bc2e$export$d2b3121978e344e);

var $k4cev = parcelRequire("k4cev");

var $kHlOR = parcelRequire("kHlOR");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $7K5Ea = parcelRequire("7K5Ea");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $h6n7A = parcelRequire("h6n7A");

var $5fjzQ = parcelRequire("5fjzQ");

var $6OSA0 = parcelRequire("6OSA0");

var $epTsa = parcelRequire("epTsa");

var $kL8k5 = parcelRequire("kL8k5");

var $jS1hO = parcelRequire("jS1hO");

var $cxQGT = parcelRequire("cxQGT");

var $lb6FK = parcelRequire("lb6FK");

var $iRrJM = parcelRequire("iRrJM");
const $aa12078081d7bc2e$var$globalSettingsIssueWorkflowEditEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $k4cev.editWorkflowEntryPoint)
});
const $aa12078081d7bc2e$export$d2b3121978e344e = (0, $6xToB.createEntry)((0, $h6n7A.globalSettingsIssueWorkflowEditRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.edit-workflow',
        entryPoint: ()=>(0, $epTsa.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? $aa12078081d7bc2e$var$globalSettingsIssueWorkflowEditEntryPoint : undefined,
        skeleton: (0, $epTsa.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? (0, $6OSA0.default) : undefined,
        component: (0, $epTsa.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? undefined : (0, $iRrJM.default),
        layout: (0, $epTsa.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? (0, $7K5Ea.chromelessLayout) : (0, $yRJUA.globalSettingsLayout),
        navigation: (0, $epTsa.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? undefined : {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: (0, $epTsa.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? [
            (0, $kL8k5.workflowCapabilitiesResource),
            (0, $jS1hO.workflowDocumentResource),
            (0, $cxQGT.themePreferenceResource),
            (0, $lb6FK.rovoEntitlementResource)
        ] : [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: (0, $epTsa.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? undefined : [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iRrJM.LazyEditWorkflow)
        ]
    }));

});
parcelRegister("k4cev", function(module, exports) {

$parcel$export(module.exports, "editWorkflowEntryPoint", () => $001dea09ccd398b6$export$8173c14a99f6a4bb);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $001dea09ccd398b6$export$8173c14a99f6a4bb = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("fD2Jm")).then((module)=>module.EditWorkflow), {
        moduleId: "9f739006",
        moduleName: "EditWorkflow",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fD2Jm", function(module, exports) {

let $b60c9dc64417d2d7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $b60c9dc64417d2d7$var$load("7vqGd"),
    $b60c9dc64417d2d7$var$load("1Y4bq"),
    $b60c9dc64417d2d7$var$load("1VRB2"),
    $b60c9dc64417d2d7$var$load("bABhq"),
    $b60c9dc64417d2d7$var$load("4xDS7")
]).then(()=>parcelRequire('k9sQt'));

});


parcelRegister("h6n7A", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowEditRoute", () => $f345e45d74df8c40$export$9d533f08a4447cc);
const $f345e45d74df8c40$export$9d533f08a4447cc = {
    name: 'global-settings-issues-workflow-edit',
    path: '/jira/settings/issues/workflows/:workflowId'
};

});

parcelRegister("kL8k5", function(module, exports) {

$parcel$export(module.exports, "workflowCapabilitiesResource", () => $03a4d75ef373c866$export$752f9619231646c7);
$parcel$export(module.exports, "useWorkflowCapabilities", () => $03a4d75ef373c866$export$861a32391dc35e21);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $j5idT = parcelRequire("j5idT");
const $03a4d75ef373c866$export$e683a752d2185432 = 'ADMIN_WORKFLOW_CAPABILITIES';
const $03a4d75ef373c866$export$752f9619231646c7 = (0, $l1VxS.createResource)({
    type: $03a4d75ef373c866$export$e683a752d2185432,
    getKey: (matchedRoute)=>{
        const { workflowId: workflowId } = matchedRoute.match.params;
        return `${$03a4d75ef373c866$export$e683a752d2185432}_${workflowId}`;
    },
    getData: (0, $j5idT.fetchWorkflowCapabilities),
    maxAge: 1000,
    isBrowserOnly: true
});
const $03a4d75ef373c866$export$861a32391dc35e21 = ()=>(0, $eJrcF.useResource)($03a4d75ef373c866$export$752f9619231646c7);

});
parcelRegister("j5idT", function(module, exports) {

$parcel$export(module.exports, "fetchWorkflowCapabilities", () => $330d675fff983670$export$51e1638cbea98309);

var $ewTX1 = parcelRequire("ewTX1");

var $6uWhG = parcelRequire("6uWhG");

var $4kMB4 = parcelRequire("4kMB4");

var $7hVvO = parcelRequire("7hVvO");
const $330d675fff983670$export$51e1638cbea98309 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const { isAnonymous: isAnonymous, cloudId: cloudId } = tenantContext;
    if (isAnonymous || !match.params.workflowId) {
        const message = !match.params.workflowId ? 'Workflow ID is not defined.' : "Workflows can't be edited in anonymous mode.";
        throw new Error(message);
    }
    try {
        // better way to monitor perf?
        (0, $6uWhG.setMark)((0, $4kMB4.prefetchApiStartMark));
        const workflowCapabilities = await (0, $ewTX1.getWorkflowCapabilities)(cloudId, {
            workflowId: match.params.workflowId
        });
        (0, $6uWhG.setMark)((0, $4kMB4.prefetchApiReadyMark));
        return workflowCapabilities;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $7hVvO.createResourceError)({
            component: 'spa.view.routes.admin-pages.workflows.workflow-capabilities.getData',
            message: 'An error was thrown while prefetching workflow capabilities data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("ewTX1", function(module, exports) {

$parcel$export(module.exports, "getWorkflowCapabilities", () => $6353da2b1399f54a$export$334f82027882d665);

var $e0I8k = parcelRequire("e0I8k");

var $1Ozm9 = parcelRequire("1Ozm9");

var $eSnSE = parcelRequire("eSnSE");
const $6353da2b1399f54a$export$c1b7f62a96ae605b = ()=>'gateway/api/jira/project-configuration';
const $6353da2b1399f54a$export$a5b7a8c3b1c6e775 = (cloudId, params)=>`/${$6353da2b1399f54a$export$c1b7f62a96ae605b()}/query/${cloudId}/workflow/capabilities?${(0, $e0I8k.stringify)(params)}`;
const $6353da2b1399f54a$export$334f82027882d665 = (cloudId, options)=>(0, $1Ozm9.default)($6353da2b1399f54a$export$a5b7a8c3b1c6e775(cloudId, options), {
        method: 'GET'
    }).catch((e)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('getWorkflowAvailableCapabilities', e);
        throw e;
    });

});
parcelRegister("e0I8k", function(module, exports) {

$parcel$export(module.exports, "decode", () => $a3334cc298c2f94d$export$2f872c0f2117be69, (v) => $a3334cc298c2f94d$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "parse", () => $a3334cc298c2f94d$export$98e6a39c04603d36, (v) => $a3334cc298c2f94d$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "encode", () => $a3334cc298c2f94d$export$c564cdbbe6da493, (v) => $a3334cc298c2f94d$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "stringify", () => $a3334cc298c2f94d$export$fac44ee5b035f737, (v) => $a3334cc298c2f94d$export$fac44ee5b035f737 = v);
var $a3334cc298c2f94d$export$2f872c0f2117be69;
var $a3334cc298c2f94d$export$98e6a39c04603d36;
var $a3334cc298c2f94d$export$c564cdbbe6da493;
var $a3334cc298c2f94d$export$fac44ee5b035f737;
'use strict';

$a3334cc298c2f94d$export$2f872c0f2117be69 = $a3334cc298c2f94d$export$98e6a39c04603d36 = (parcelRequire("dsfwg"));

$a3334cc298c2f94d$export$c564cdbbe6da493 = $a3334cc298c2f94d$export$fac44ee5b035f737 = (parcelRequire("6vVY0"));

});
parcelRegister("dsfwg", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $9cb9edb7aa9a3001$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$9cb9edb7aa9a3001$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($9cb9edb7aa9a3001$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $9cb9edb7aa9a3001$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("6vVY0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $4be29a4f00cc422b$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $4be29a4f00cc422b$var$map($4be29a4f00cc422b$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(k)) + eq;
        if ($4be29a4f00cc422b$var$isArray(obj[k])) return $4be29a4f00cc422b$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(name)) + eq + encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(obj));
};
var $4be29a4f00cc422b$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $4be29a4f00cc422b$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $4be29a4f00cc422b$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});





parcelRegister("jS1hO", function(module, exports) {

$parcel$export(module.exports, "workflowDocumentResource", () => $aaa717bc04429990$export$b63b10ddc49fa54f);
$parcel$export(module.exports, "useWorkflowDocument", () => $aaa717bc04429990$export$1ed79b881a7cb8b1);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $6y5nr = parcelRequire("6y5nr");
const $aaa717bc04429990$export$e683a752d2185432 = 'ADMIN_WORKFLOW_DOCUMENT';
const $aaa717bc04429990$export$b63b10ddc49fa54f = (0, $l1VxS.createResource)({
    type: $aaa717bc04429990$export$e683a752d2185432,
    getKey: (matchedRoute)=>{
        const { workflowId: workflowId } = matchedRoute.match.params;
        return `${$aaa717bc04429990$export$e683a752d2185432}_${workflowId}`;
    },
    getData: async (routerContext, customContext)=>(0, $6y5nr.fetchWorkflowDocument)(routerContext, customContext, false),
    maxAge: 1000,
    isBrowserOnly: true
});
const $aaa717bc04429990$export$1ed79b881a7cb8b1 = ()=>(0, $eJrcF.useResource)($aaa717bc04429990$export$b63b10ddc49fa54f);

});
parcelRegister("6y5nr", function(module, exports) {

$parcel$export(module.exports, "fetchWorkflowDocument", () => $d9338ef756608254$export$f9f333ad2a8d394b);

var $26HpW = parcelRequire("26HpW");

var $6uWhG = parcelRequire("6uWhG");

var $4kMB4 = parcelRequire("4kMB4");

var $7hVvO = parcelRequire("7hVvO");

var $7jTnu = parcelRequire("7jTnu");
const $d9338ef756608254$export$f9f333ad2a8d394b = async ({ match: match }, { tenantContext: tenantContext }, isProjectScoped)=>{
    const { isAnonymous: isAnonymous, cloudId: cloudId } = tenantContext;
    if (isAnonymous || !match.params.workflowId) {
        const message = !match.params.workflowId ? 'Workflow ID is not defined.' : "Workflows can't be edited in anonymous mode.";
        throw new Error(message);
    }
    try {
        (0, $6uWhG.setMark)((0, $4kMB4.prefetchApiStartMark));
        const workflowDocument = await (0, $26HpW.getWorkflow)(cloudId, {
            workflowId: match.params.workflowId
        }, (0, $7jTnu.fg)('hix-6846-discard-wfl-drafts-on-update') ? {
            checkForDrafts: !isProjectScoped
        } : undefined);
        (0, $6uWhG.setMark)((0, $4kMB4.prefetchApiReadyMark));
        return workflowDocument;
    } catch (error) {
        throw (0, $7hVvO.createResourceError)({
            component: 'spa.view.routes.admin-pages.workflows.workflow-document.getData',
            message: 'An error was thrown while prefetching workflow document data',
            name: 'ResourceError'
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
        error);
    }
};

});
parcelRegister("26HpW", function(module, exports) {

$parcel$export(module.exports, "getWorkflow", () => $6c1bc65b288131c9$export$f927248b35ee72a7);

var $jPROM = parcelRequire("jPROM");

var $jGzN3 = parcelRequire("jGzN3");

var $7jTnu = parcelRequire("7jTnu");
const $6c1bc65b288131c9$export$c1b7f62a96ae605b = ()=>'gateway/api/jira/project-configuration';
const $6c1bc65b288131c9$export$a5b7a8c3b1c6e775 = (cloudId)=>`/${$6c1bc65b288131c9$export$c1b7f62a96ae605b()}/query/${cloudId}/3/workflow`;
const $6c1bc65b288131c9$export$f927248b35ee72a7 = (cloudId, workflowIdentifier, config)=>{
    const url = $6c1bc65b288131c9$export$a5b7a8c3b1c6e775(cloudId);
    const { workflowId: workflowId, workflowName: workflowName, projectAndIssueType: projectAndIssueType } = workflowIdentifier;
    const payload = {
        skipUsageLookup: false
    };
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(workflowId)) payload.workflowIds = [
        workflowId
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(workflowName)) payload.workflowNames = [
        workflowName
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(projectAndIssueType)) payload.projectAndIssueTypes = [
        projectAndIssueType
    ];
    if (config?.checkForDrafts && (0, $7jTnu.fg)('hix-6846-discard-wfl-drafts-on-update')) payload.checkForDrafts = true;
    return (0, $jGzN3.performPostRequest)(url, {
        body: JSON.stringify(payload)
    });
};

});



parcelRegister("iRrJM", function(module, exports) {

$parcel$export(module.exports, "LazyEditWorkflow", () => $c5567d5a04080bc2$export$cb79ebb337a95317);
$parcel$export(module.exports, "default", () => $c5567d5a04080bc2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $c5567d5a04080bc2$export$cb79ebb337a95317 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fD2Jm"))), {
    moduleId: "./src/packages/admin-pages/edit-workflow/src/EditWorkflow.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c5567d5a04080bc2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c5567d5a04080bc2$export$cb79ebb337a95317,
        pageId: "jira-admin-pages-edit-workflow",
        shouldShowSpinner: true
    });

});


parcelRegister("bWzV9", function(module, exports) {

$parcel$export(module.exports, "globalSettingsLegacyFieldLayoutRouteEntry", () => $fdb3f390a6a0e4ed$export$49998c6229ab8099);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $bisZi = parcelRequire("bisZi");

var $ludcG = parcelRequire("ludcG");
const $fdb3f390a6a0e4ed$export$49998c6229ab8099 = (0, $6xToB.createEntry)((0, $bisZi.globalSettingsLegacyFieldLayoutRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        component: (0, $ludcG.LazyLegacyFieldLayoutPage),
        forPaint: [
            (0, $ludcG.LazyLegacyFieldLayoutPromise)
        ]
    }));

});
parcelRegister("bisZi", function(module, exports) {

$parcel$export(module.exports, "globalSettingsLegacyFieldLayoutRoute", () => $8faa06314f4ceadf$export$82fa992cdfa20fb5);
const $8faa06314f4ceadf$export$82fa992cdfa20fb5 = {
    name: 'global-settings-issues-legacy-field-layout',
    path: '/jira/settings/issues/field-configuration/:fieldLayoutId'
};

});

parcelRegister("ludcG", function(module, exports) {

$parcel$export(module.exports, "LazyLegacyFieldLayoutPromise", () => $086204577f90cc0d$export$8b5ab888f8df499);
$parcel$export(module.exports, "LazyLegacyFieldLayoutPage", () => $086204577f90cc0d$export$676ecf497a280cfa);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $086204577f90cc0d$export$8b5ab888f8df499 = (0, $gzcjr.lazyForPaint)(()=>{
    return (0, $2dJFW.markAsProductBundleReady)((parcelRequire("fvXDP")).then((bundle)=>bundle.LegacyFieldLayoutApp));
}, {
    moduleId: "./src/packages/admin-pages/legacy-field-layout/src/index.tsx"
});
const $086204577f90cc0d$export$676ecf497a280cfa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $086204577f90cc0d$export$8b5ab888f8df499,
        pageId: "jira-admin-pages-legacy-field-layout",
        shouldShowSpinner: true
    });

});
parcelRegister("fvXDP", function(module, exports) {

let $b4b803ce55e942f7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b4b803ce55e942f7$var$load("1BsIT").then(()=>parcelRequire('dwFRQ'));

});



parcelRegister("aieAu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsOptimizeFieldConfigurationSchemeRouteEntry", () => $29e6ae5f90f5f894$export$b98ced4649f55b1c);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $d0oBd = parcelRequire("d0oBd");

var $bJscI = parcelRequire("bJscI");

var $7jTnu = parcelRequire("7jTnu");

var $9BJU1 = parcelRequire("9BJU1");

var $5fjzQ = parcelRequire("5fjzQ");

var $lXTH9 = parcelRequire("lXTH9");
const $29e6ae5f90f5f894$export$b98ced4649f55b1c = (0, $6xToB.createEntry)((0, $d0oBd.globalSettingsOptimizeFieldConfigurationSchemeRoute), ()=>({
        group: 'global-settings',
        component: (0, $bJscI.componentWithFG)('field_streamlining_ui', (0, $lXTH9.OptimizeFieldConfigurationSchemePage), (0, $9BJU1.default)),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        canTransitionIn: ()=>(0, $7jTnu.fg)('field_streamlining_ui'),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $lXTH9.LazyOptimizeFieldConfigurationSchemePagePage)
        ]
    }));

});
parcelRegister("d0oBd", function(module, exports) {

$parcel$export(module.exports, "globalSettingsOptimizeFieldConfigurationSchemeRoute", () => $814cf952bcc75cda$export$3da73e59758744eb);
const $814cf952bcc75cda$export$3da73e59758744eb = {
    name: 'global-settings-optimize-field-configuration-scheme-view',
    path: '/jira/settings/issues/field-configuration-schemes/:fieldConfigurationSchemeId/optimize'
};

});

parcelRegister("lXTH9", function(module, exports) {

$parcel$export(module.exports, "LazyOptimizeFieldConfigurationSchemePagePage", () => $06f25e3f3eca09e7$export$bd8509501da10c3);
$parcel$export(module.exports, "OptimizeFieldConfigurationSchemePage", () => $06f25e3f3eca09e7$export$7cd55863572c1f3a);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $06f25e3f3eca09e7$export$bd8509501da10c3 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("8BIoJ"))), {
    ssr: false,
    moduleId: "./src/packages/site-optimizer/optimize-field-configuration-scheme-page/src/index.tsx"
});
const $06f25e3f3eca09e7$export$7cd55863572c1f3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $06f25e3f3eca09e7$export$bd8509501da10c3,
        pageId: "jira-admin-pages-optimize-field-configuration-scheme-page",
        shouldShowSpinner: true
    });

});
parcelRegister("8BIoJ", function(module, exports) {

let $644437e9e36ebb0b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $644437e9e36ebb0b$var$load("4VcUB").then(()=>parcelRequire('cEOMi'));

});



parcelRegister("hEWb7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsOptimizeWorkTypeSchemeRouteEntry", () => $d8a4f7bf8e198653$export$bae97ca0b9dd2ea2);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $fekcl = parcelRequire("fekcl");

var $bJscI = parcelRequire("bJscI");

var $7jTnu = parcelRequire("7jTnu");

var $9BJU1 = parcelRequire("9BJU1");

var $5fjzQ = parcelRequire("5fjzQ");

var $iDRnR = parcelRequire("iDRnR");
const $d8a4f7bf8e198653$export$bae97ca0b9dd2ea2 = (0, $6xToB.createEntry)((0, $fekcl.globalSettingsOptimizeWorkTypeSchemeRoute), ()=>({
        group: 'global-settings',
        component: (0, $bJscI.componentWithFG)('optimize_issue_type_scheme_page', (0, $iDRnR.OptimizeWorkTypeSchemePage), (0, $9BJU1.default)),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        canTransitionIn: ()=>(0, $7jTnu.fg)('optimize_issue_type_scheme_page'),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iDRnR.LazyOptimizeWorkTypeSchemePagePage)
        ]
    }));

});
parcelRegister("fekcl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsOptimizeWorkTypeSchemeRoute", () => $efcb9b38d5c14047$export$c0e227e20c671f81);
const $efcb9b38d5c14047$export$c0e227e20c671f81 = {
    name: 'global-settings-optimize-work-type-scheme-view',
    path: '/jira/settings/issues/issue-type-schemes/:workTypeSchemeId/optimize'
};

});

parcelRegister("iDRnR", function(module, exports) {

$parcel$export(module.exports, "LazyOptimizeWorkTypeSchemePagePage", () => $03d92ca6caf8d71b$export$267fd3967a05d273);
$parcel$export(module.exports, "OptimizeWorkTypeSchemePage", () => $03d92ca6caf8d71b$export$ba894e00aa169b3b);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $03d92ca6caf8d71b$export$267fd3967a05d273 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("9v6OK"))), {
    ssr: false,
    moduleId: "./src/packages/site-optimizer/optimize-work-type-scheme-page/src/index.tsx"
});
const $03d92ca6caf8d71b$export$ba894e00aa169b3b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $03d92ca6caf8d71b$export$267fd3967a05d273,
        pageId: "jira-admin-pages-optimize-work-type-scheme-page",
        shouldShowSpinner: true
    });

});
parcelRegister("9v6OK", function(module, exports) {

let $6eac4c24b4b8a1b4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6eac4c24b4b8a1b4$var$load("8nBPP").then(()=>parcelRequire('in4So'));

});



parcelRegister("dVpvh", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldCleanupRouteEntry", () => $6b5162eeb56a9068$export$2861e75e48fa039f);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $cOL7T = parcelRequire("cOL7T");

var $leTLb = parcelRequire("leTLb");
const $6b5162eeb56a9068$export$2861e75e48fa039f = (0, $6xToB.createEntry)((0, $cOL7T.globalSettingsPerformanceCustomFieldCleanupRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return 0, $leTLb.customFieldCleanupMetricDetailEntryPoint;
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("cOL7T", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldCleanupRoute", () => $943e20c180cc897c$export$cb147997a6f0639a);
const $943e20c180cc897c$export$cb147997a6f0639a = {
    name: 'global-settings-performance-custom-field-cleanup',
    path: '/jira/settings/system/performance/metrics/customfield/cleanup'
};

});

parcelRegister("leTLb", function(module, exports) {

$parcel$export(module.exports, "customFieldCleanupMetricDetailEntryPoint", () => $5e58eff6c33d0db6$export$47780c76bc3a7e1e);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $2aGAf = parcelRequire("2aGAf");

const $5e58eff6c33d0db6$export$47780c76bc3a7e1e = (0, $g8uYY.createPageEntryPoint)({
    main: {
        root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("cna7P")), {
            moduleId: "e0a8c357",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    },
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("cna7P", function(module, exports) {

let $901f7ca94412b2b1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $901f7ca94412b2b1$var$load("1VRB2"),
    $901f7ca94412b2b1$var$load("bABhq"),
    $901f7ca94412b2b1$var$load("f9s8j")
]).then(()=>parcelRequire('9H0ZF'));

});



parcelRegister("iLf1F", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldProjectLimitRouteEntry", () => $b7656d74ec0e9808$export$e86e8247db1f29bb);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $gqJO6 = parcelRequire("gqJO6");

var $9NmsS = parcelRequire("9NmsS");

var $hxJkg = parcelRequire("hxJkg");

var $3AyZ6 = parcelRequire("3AyZ6");
const $b7656d74ec0e9808$export$e86e8247db1f29bb = (0, $6xToB.createEntry)((0, $hxJkg.globalSettingsPerformanceCustomFieldProjectLimitRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return 0, $3AyZ6.customFieldProjectLimitMetricDetailEntryPoint;
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $gqJO6.fieldsProjectsLimitsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("gqJO6", function(module, exports) {

$parcel$export(module.exports, "fieldsProjectsLimitsResource", () => $82ad06ef690a2967$export$c3fe56fd6a83a952);

var $l1VxS = parcelRequire("l1VxS");
const $82ad06ef690a2967$var$RESOURCE_TYPE_FIELDS_PROJECTS_LIMITS = 'FIELDS_PROJECTS_LIMITS';

const $82ad06ef690a2967$export$c3fe56fd6a83a952 = (0, $l1VxS.createResource)({
    type: $82ad06ef690a2967$var$RESOURCE_TYPE_FIELDS_PROJECTS_LIMITS,
    getKey: ()=>'fieldsProjectsLimits',
    getDataLoader: ()=>(parcelRequire("l1t6N"))
});

});
parcelRegister("l1t6N", function(module, exports) {

let $f4e0455187522085$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f4e0455187522085$var$load("aVenw").then(()=>parcelRequire('2vAnn'));

});


parcelRegister("hxJkg", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldProjectLimitRoute", () => $f21837c6155b33f4$export$9449246286770320);
const $f21837c6155b33f4$export$9449246286770320 = {
    name: 'global-settings-performance-custom-field-project-limit',
    path: '/jira/settings/system/performance/metrics/customfield/projectlimit'
};

});

parcelRegister("3AyZ6", function(module, exports) {

$parcel$export(module.exports, "customFieldProjectLimitMetricDetailEntryPoint", () => $766ea365c40ef396$export$a2234cc105eb9aa9);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $2aGAf = parcelRequire("2aGAf");

const $766ea365c40ef396$export$a2234cc105eb9aa9 = (0, $g8uYY.createPageEntryPoint)({
    main: {
        root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("ahY4m")), {
            moduleId: "43601b8e",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    },
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("ahY4m", function(module, exports) {

let $77da166a8603b076$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $77da166a8603b076$var$load("oB8Qf").then(()=>parcelRequire('bTqVl'));

});



parcelRegister("2zDjc", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldRouteEntry", () => $726ab017cdee397f$export$8cc68908e4ed5a16);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $ec3NN = parcelRequire("ec3NN");

var $96vQW = parcelRequire("96vQW");
const $726ab017cdee397f$export$8cc68908e4ed5a16 = (0, $6xToB.createEntry)((0, $ec3NN.globalSettingsPerformanceCustomFieldRoute), ()=>({
        group: 'global-settings',
        component: (0, $96vQW.CustomFieldMetricDetail),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $96vQW.LazyCustomFieldDetail)
        ]
    }));

});
parcelRegister("ec3NN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldRoute", () => $5379f2145d09883a$export$198b0dea5bcb104d);
const $5379f2145d09883a$export$198b0dea5bcb104d = {
    name: 'global-settings-performance-custom-field',
    path: '/jira/settings/system/performance/metrics/customfield'
};

});

parcelRegister("96vQW", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldDetail", () => $33c7f88cb2f8be50$export$d323aa888b5be0c2);
$parcel$export(module.exports, "CustomFieldMetricDetail", () => $33c7f88cb2f8be50$export$446bf9be075b3cb);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $33c7f88cb2f8be50$export$d323aa888b5be0c2 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4lBom"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-custom-field/src/index.tsx"
});
const $33c7f88cb2f8be50$export$446bf9be075b3cb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $33c7f88cb2f8be50$export$d323aa888b5be0c2,
        pageId: "system-performance-metric-detail-custom-field",
        shouldShowSpinner: true
    });

});
parcelRegister("4lBom", function(module, exports) {

let $32a620d9dcc48bbe$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $32a620d9dcc48bbe$var$load("1VRB2"),
    $32a620d9dcc48bbe$var$load("bABhq"),
    $32a620d9dcc48bbe$var$load("eDzss"),
    $32a620d9dcc48bbe$var$load("d6HSZ")
]).then(()=>parcelRequire('8nmH7'));

});



parcelRegister("9Isj0", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceIssueArchivalRouteEntry", () => $5cbcd9a80ebdf6e8$export$6f8a930d1f2f4103);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $hIpQN = parcelRequire("hIpQN");

var $Uskeg = parcelRequire("Uskeg");
const $5cbcd9a80ebdf6e8$export$6f8a930d1f2f4103 = (0, $6xToB.createEntry)((0, $hIpQN.globalSettingsPerformanceIssueArchivalRoute), ()=>({
        group: 'global-settings',
        component: (0, $Uskeg.IssueMetricDetail),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $Uskeg.LazyIssueDetail)
        ]
    }));

});
parcelRegister("hIpQN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceIssueArchivalRoute", () => $f293e219049e69c5$export$a615b79ae9fb06e5);
const $f293e219049e69c5$export$a615b79ae9fb06e5 = {
    name: 'global-settings-performance-issue',
    path: '/jira/settings/system/performance/metrics/issue'
};

});

parcelRegister("Uskeg", function(module, exports) {

$parcel$export(module.exports, "LazyIssueDetail", () => $fdf43b91f1ac3288$export$e44cbefb7c57e031);
$parcel$export(module.exports, "IssueMetricDetail", () => $fdf43b91f1ac3288$export$30b22d5292fcd86f);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $fdf43b91f1ac3288$export$e44cbefb7c57e031 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("gWJWC"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-issue/src/index.tsx"
});
const $fdf43b91f1ac3288$export$30b22d5292fcd86f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fdf43b91f1ac3288$export$e44cbefb7c57e031,
        pageId: "system-performance-metric-detail-issue",
        shouldShowSpinner: true
    });

});
parcelRegister("gWJWC", function(module, exports) {

let $c565b3c21055654e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $c565b3c21055654e$var$load("1VRB2"),
    $c565b3c21055654e$var$load("bABhq"),
    $c565b3c21055654e$var$load("eDzss"),
    $c565b3c21055654e$var$load("3bWyU")
]).then(()=>parcelRequire('4CgFO'));

});



parcelRegister("bs2w3", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceMetricDetailRouteEntry", () => $0767927744640a15$export$4b547a5bd165bd83);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $jnVux = parcelRequire("jnVux");

var $8WrNo = parcelRequire("8WrNo");
const $0767927744640a15$export$4b547a5bd165bd83 = (0, $6xToB.createEntry)((0, $jnVux.globalSettingsPerformanceMetricDetailRoute), ()=>({
        group: 'global-settings',
        component: (0, $8WrNo.RedirectToExactMetricRoutes),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("jnVux", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceMetricDetailRoute", () => $620a245b2f6d3335$export$d4f7a24791f8b506);
const $620a245b2f6d3335$export$d4f7a24791f8b506 = {
    name: 'global-settings-performance-metric-detail',
    path: '/jira/settings/system/performance/metric/:metricKey'
};

});

parcelRegister("8WrNo", function(module, exports) {

$parcel$export(module.exports, "RedirectToExactMetricRoutes", () => $6e9f017b39f8449a$export$dda90f06f8afe9ec);

var $eJOHy = parcelRequire("eJOHy");

var $f1Zdy = parcelRequire("f1Zdy");

var $gCeeo = parcelRequire("gCeeo");

var $7fTjp = parcelRequire("7fTjp");

var $gCY1z = parcelRequire("gCY1z");
const $6e9f017b39f8449a$export$dda90f06f8afe9ec = ()=>{
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // If we have a metric key in the URL, we know the user has accessed the old route
        // and we should fire an operational analytics event.
        // Once the frequency of this event is 0, we can consider removing the redirect.
        if (match?.params?.metricKey) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'old-metric-detail-route visited', {
            metricKey: match.params.metricKey
        });
    }, [
        match?.params?.metricKey,
        createAnalyticsEvent
    ]);
    if (match == null || match.params == null || match.params.metricKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/settings/system/performance/overview"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/jira/settings/system/performance/metrics/${match.params.metricKey}`
    });
};

});


parcelRegister("jlE2b", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceOverviewRouteEntry", () => $b8b84d76ead7eb10$export$6f957aade53e2c17);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $bcaR6 = parcelRequire("bcaR6");

var $5NKAA = parcelRequire("5NKAA");

var $bCewD = parcelRequire("bCewD");
const $b8b84d76ead7eb10$export$6f957aade53e2c17 = (0, $6xToB.createEntry)((0, $5NKAA.globalSettingsPerformanceOverviewRoute), ()=>({
        group: 'global-settings',
        component: (0, $bCewD.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $bcaR6.metricsOverviewPageResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bCewD.LazyOverview)
        ]
    }));

});
parcelRegister("bcaR6", function(module, exports) {

$parcel$export(module.exports, "metricsOverviewPageResource", () => $3d664a9d2cc556cb$export$ac0b4ef4ec4987ae);

var $7jTnu = parcelRequire("7jTnu");

var $9FYIg = parcelRequire("9FYIg");

var $ja6hU = parcelRequire("ja6hU");
const $3d664a9d2cc556cb$export$ac0b4ef4ec4987ae = (0, $9FYIg.createRelayResource)({
    type: 'ADMIN_PAGES_PERFORMANCE_OVERVIEW',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $ja6hU.default),
            variables: {
                cloudId: tenantContext.cloudId,
                schemaMigrationEnabled: (0, $7jTnu.fg)('site_optimiser_schema_migration')
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("ja6hU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bd2d44323d86584$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<669304670c931d09af8646f09ee71460>>
 * @relayHash 3b0412c013eb910bffa938b54599e765
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 589c5cc207a17b7fcd72acde1a46f074a3ac0a2e82da10793f61efb4fb0a786e
const $2bd2d44323d86584$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "schemaMigrationEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "currentValue"
    }, v4 = {
        "kind": "ScalarField",
        "name": "warningValue"
    }, v5 = {
        "kind": "ScalarField",
        "name": "thresholdValue"
    }, v6 = {
        "kind": "ScalarField",
        "name": "cleanupValue"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_adminPagesPerformance_Overview_Query",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "schemaMigrationEnabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v1 /*: any*/ ,
                                            "concreteType": "JiraResourceUsageMetricConnection",
                                            "kind": "LinkedField",
                                            "name": "resourceUsageMetrics",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "main_adminPagesPerformance_OverviewPage"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.resourceUsageMetrics"
                                    }
                                ]
                            },
                            {
                                "condition": "schemaMigrationEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v1 /*: any*/ ,
                                            "concreteType": "JiraResourceUsageMetricConnectionV2",
                                            "kind": "LinkedField",
                                            "name": "resourceUsageMetricsV2",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "main_adminPagesPerformance_OverviewPageV2"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.resourceUsageMetricsV2"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_adminPagesPerformance_Overview_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "schemaMigrationEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraResourceUsageMetricConnection",
                                    "kind": "LinkedField",
                                    "name": "resourceUsageMetrics",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraResourceUsageMetric",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "schemaMigrationEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraResourceUsageMetricConnectionV2",
                                    "kind": "LinkedField",
                                    "name": "resourceUsageMetricsV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "589c5cc207a17b7fcd72acde1a46f074a3ac0a2e82da10793f61efb4fb0a786e",
            "metadata": {},
            "name": "main_adminPagesPerformance_Overview_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2bd2d44323d86584$var$node.hash = "f41d000bf8612aeb0ad7a3bfa4b9b2cb";
var $2bd2d44323d86584$export$2e2bcd8739ae039 = $2bd2d44323d86584$var$node;

});


parcelRegister("5NKAA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceOverviewRoute", () => $dbfadb11fc0e9b18$export$677fc3a2086479d2);
const $dbfadb11fc0e9b18$export$677fc3a2086479d2 = {
    name: 'global-settings-performance-overview',
    path: '/jira/settings/system/performance/overview'
};

});

parcelRegister("bCewD", function(module, exports) {

$parcel$export(module.exports, "LazyOverview", () => $21f93b1c5953002f$export$17b4d4eaede5f445);
$parcel$export(module.exports, "default", () => $21f93b1c5953002f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $21f93b1c5953002f$export$17b4d4eaede5f445 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("88rCP"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/overview/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$21f93b1c5953002f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $21f93b1c5953002f$export$17b4d4eaede5f445,
        pageId: "system-performance-overview",
        shouldShowSpinner: true
    });

});
parcelRegister("88rCP", function(module, exports) {

let $5ec47fe893d590b8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5ec47fe893d590b8$var$load("1VRB2"),
    $5ec47fe893d590b8$var$load("bABhq"),
    $5ec47fe893d590b8$var$load("dLWHe")
]).then(()=>parcelRequire('5ExgM'));

});



parcelRegister("kDttK", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectCleanupRouteEntry", () => $6da04e599b811bf3$export$7048705fd224d040);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $lirjv = parcelRequire("lirjv");

var $3fsKo = parcelRequire("3fsKo");
const $6da04e599b811bf3$export$7048705fd224d040 = (0, $6xToB.createEntry)((0, $lirjv.globalSettingsPerformanceProjectCleanupRoute), ()=>({
        group: 'global-settings',
        component: (0, $3fsKo.ProjectCleanupMetricDetail),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3fsKo.LazyProjectCleanupDetail)
        ]
    }));

});
parcelRegister("lirjv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectCleanupRoute", () => $d316f80a5a0f24b2$export$c0d3487a9dc79ff3);
const $d316f80a5a0f24b2$export$c0d3487a9dc79ff3 = {
    name: 'global-settings-performance-project-cleanup',
    path: '/jira/settings/system/performance/metrics/projectCleanup'
};

});

parcelRegister("3fsKo", function(module, exports) {

$parcel$export(module.exports, "LazyProjectCleanupDetail", () => $cd9ca891c314ff85$export$a02cb3bfa11d0dc0);
$parcel$export(module.exports, "ProjectCleanupMetricDetail", () => $cd9ca891c314ff85$export$2adb5abd6651c182);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $cd9ca891c314ff85$export$a02cb3bfa11d0dc0 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2uahh"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-cleanup/src/index.tsx"
});
const $cd9ca891c314ff85$export$2adb5abd6651c182 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cd9ca891c314ff85$export$a02cb3bfa11d0dc0,
        pageId: "system-performance-metric-detail-project-cleanup",
        shouldShowSpinner: true
    });

});
parcelRegister("2uahh", function(module, exports) {

let $1cf65b0a56fb7d22$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1cf65b0a56fb7d22$var$load("1VRB2"),
    $1cf65b0a56fb7d22$var$load("bABhq"),
    $1cf65b0a56fb7d22$var$load("eDzss"),
    $1cf65b0a56fb7d22$var$load("5xt01")
]).then(()=>parcelRequire('fGjAz'));

});



parcelRegister("20DnI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectRoleActorRouteEntry", () => $99e48c57c4fb50f0$export$a37cab737d8b474a);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $dQs2a = parcelRequire("dQs2a");

var $fa9c1 = parcelRequire("fa9c1");
const $99e48c57c4fb50f0$export$a37cab737d8b474a = (0, $6xToB.createEntry)((0, $dQs2a.globalSettingsPerformanceProjectRoleActorRoute), ()=>({
        group: 'global-settings',
        component: (0, $fa9c1.ProjectRoleActorMetricDetail),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fa9c1.LazyProjectRoleActorDetail)
        ]
    }));

});
parcelRegister("dQs2a", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectRoleActorRoute", () => $dee84a18d9ab2ffa$export$c81695f590e65a42);
const $dee84a18d9ab2ffa$export$c81695f590e65a42 = {
    name: 'global-settings-performance-project-role-actor',
    path: '/jira/settings/system/performance/metrics/projectroleactor'
};

});

parcelRegister("fa9c1", function(module, exports) {

$parcel$export(module.exports, "LazyProjectRoleActorDetail", () => $809fa5df770221f0$export$41ecfa31d3d81e1c);
$parcel$export(module.exports, "ProjectRoleActorMetricDetail", () => $809fa5df770221f0$export$3c58376b89706313);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $809fa5df770221f0$export$41ecfa31d3d81e1c = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5Or9L"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-role-actor/src/index.tsx"
});
const $809fa5df770221f0$export$3c58376b89706313 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $809fa5df770221f0$export$41ecfa31d3d81e1c,
        pageId: "system-performance-metric-detail-project-role-actor",
        shouldShowSpinner: true
    });

});
parcelRegister("5Or9L", function(module, exports) {

let $43b6aff66735b7da$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $43b6aff66735b7da$var$load("1VRB2"),
    $43b6aff66735b7da$var$load("bABhq"),
    $43b6aff66735b7da$var$load("eDzss"),
    $43b6aff66735b7da$var$load("5ycRF")
]).then(()=>parcelRequire('9zKIx'));

});



parcelRegister("81vTA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceWorkTypeProjectLimitRouteEntry", () => $698075abb119f507$export$965a17cb3e65a2e5);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $bkhk6 = parcelRequire("bkhk6");

var $icUQP = parcelRequire("icUQP");

var $gH15Q = parcelRequire("gH15Q");
const $698075abb119f507$export$965a17cb3e65a2e5 = (0, $6xToB.createEntry)((0, $bkhk6.globalSettingsPerformanceWorkTypeProjectLimitRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return 0, $gH15Q.workTypeProjectLimitMetricDetailEntryPoint;
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $icUQP.workTypeProjectsLimitsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("bkhk6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceWorkTypeProjectLimitRoute", () => $d0b82d9272a49d17$export$1931d6cf70f5bde7);
const $d0b82d9272a49d17$export$1931d6cf70f5bde7 = {
    name: 'global-settings-performance-work-type-project-limit',
    path: '/jira/settings/system/performance/metrics/worktype/projectlimit'
};

});

parcelRegister("icUQP", function(module, exports) {

$parcel$export(module.exports, "workTypeProjectsLimitsResource", () => $402413fb3711d27c$export$2ec7f3178377ec2c);

var $l1VxS = parcelRequire("l1VxS");
const $402413fb3711d27c$var$RESOURCE_TYPE_WORK_TYPE_PROJECTS_LIMITS = 'WORK_TYPE_PROJECTS_LIMITS';

const $402413fb3711d27c$export$2ec7f3178377ec2c = (0, $l1VxS.createResource)({
    type: $402413fb3711d27c$var$RESOURCE_TYPE_WORK_TYPE_PROJECTS_LIMITS,
    getKey: ()=>'workTypeProjectsLimits',
    getDataLoader: ()=>(parcelRequire("cSzJD"))
});

});
parcelRegister("cSzJD", function(module, exports) {

let $96063f6fcacc3f82$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $96063f6fcacc3f82$var$load("cs6xx").then(()=>parcelRequire('aoDXB'));

});


parcelRegister("gH15Q", function(module, exports) {

$parcel$export(module.exports, "workTypeProjectLimitMetricDetailEntryPoint", () => $b5a5ae6ea29de9bc$export$f497120022a11a8d);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $2aGAf = parcelRequire("2aGAf");

const $b5a5ae6ea29de9bc$export$f497120022a11a8d = (0, $g8uYY.createPageEntryPoint)({
    main: {
        root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("1Z4TX")), {
            moduleId: "478492f0",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    },
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("1Z4TX", function(module, exports) {

let $171f4a4aade3b24b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $171f4a4aade3b24b$var$load("4MKnm").then(()=>parcelRequire('2ws0G'));

});



parcelRegister("f0p1P", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceWorkTypeRouteEntry", () => $b2f47f947ec65a73$export$92421240ff4c94e5);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $1kjON = parcelRequire("1kjON");

var $1wNA2 = parcelRequire("1wNA2");
const $b2f47f947ec65a73$export$92421240ff4c94e5 = (0, $6xToB.createEntry)((0, $1kjON.globalSettingsPerformanceWorkTypeRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return 0, $1wNA2.workTypeMetricDetailEntryPoint;
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("1kjON", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceWorkTypeRoute", () => $af42797de3d7f2e9$export$6e2ae2fc0cb46e28);
const $af42797de3d7f2e9$export$6e2ae2fc0cb46e28 = {
    name: 'global-settings-performance-work-type',
    path: '/jira/settings/system/performance/metrics/worktype'
};

});

parcelRegister("1wNA2", function(module, exports) {

$parcel$export(module.exports, "workTypeMetricDetailEntryPoint", () => $d12b05cdcf22bda6$export$a9f578d6187315f8);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $2aGAf = parcelRequire("2aGAf");

const $d12b05cdcf22bda6$export$a9f578d6187315f8 = (0, $g8uYY.createPageEntryPoint)({
    main: {
        root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("jH3D7")), {
            moduleId: "0d2267fc",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    },
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("jH3D7", function(module, exports) {

let $e564d94a07a5abbd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e564d94a07a5abbd$var$load("6SQX3").then(()=>parcelRequire('j3YP6'));

});



parcelRegister("1yaIP", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPermissionSchemesRouteEntry", () => $4845417ac4f7292e$export$85d07cd59d004b5b);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $4PYLV = parcelRequire("4PYLV");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $jEcOI = parcelRequire("jEcOI");

var $bVzQe = parcelRequire("bVzQe");
const $4845417ac4f7292e$export$85d07cd59d004b5b = (0, $6xToB.createEntry)((0, $jEcOI.globalSettingsPermissionSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.configure-permission-scheme',
        component: (0, $bVzQe.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $4PYLV.permissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bVzQe.LazyPermissionSchemePage)
        ],
        meta: {
            reporting: {
                id: 'PermissionScheme',
                packageName: 'jiraAdminPagesPermissionScheme',
                teamName: 'gordian'
            }
        }
    }));

});
parcelRegister("4PYLV", function(module, exports) {

$parcel$export(module.exports, "permissionSchemePageResource", () => $c3bdd4d86bf4a1d4$export$58d9013f694fc9d0);

var $9FYIg = parcelRequire("9FYIg");

var $15MPj = parcelRequire("15MPj");
const $c3bdd4d86bf4a1d4$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE = 'PERMISSION_SCHEME_PAGE';
const $c3bdd4d86bf4a1d4$export$58d9013f694fc9d0 = (0, $9FYIg.createRelayResource)({
    type: $c3bdd4d86bf4a1d4$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $15MPj.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("15MPj", function(module, exports) {

$parcel$export(module.exports, "default", () => $aad813eafe39647c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf59478679f84bf44b49fd41a2544ee4>>
 * @relayHash 0250f6408e8d8064d7cc97a77e2f5386
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb
const $aad813eafe39647c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "schemeId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "schemeId",
            "variableName": "schemeId"
        }
    ], v2 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "description"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ], v9 = [
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v1 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "header_permissionScheme"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PermissionsTable"
                                            },
                                            v2 /*: any*/ 
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.viewPermissionScheme"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v4 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb",
            "metadata": {},
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$aad813eafe39647c$var$node.hash = "41dd09a71a35c8ed416631b02fa73316";
var $aad813eafe39647c$export$2e2bcd8739ae039 = $aad813eafe39647c$var$node;

});


parcelRegister("jEcOI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPermissionSchemesRoute", () => $2d85bd50d3c083df$export$ceade8e040291782);
const $2d85bd50d3c083df$export$ceade8e040291782 = {
    name: 'global-settings-permissions-schemes',
    path: '/jira/settings/issues/permission-schemes-new/:schemeId'
};

});

parcelRegister("bVzQe", function(module, exports) {

$parcel$export(module.exports, "LazyPermissionSchemePage", () => $149f3a31b76919ac$export$f7fcf8304eb17dda);
$parcel$export(module.exports, "default", () => $149f3a31b76919ac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $149f3a31b76919ac$export$f7fcf8304eb17dda = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("68y6P"))), {
    moduleId: "./src/packages/permissions-administration/pages/permission-scheme/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$149f3a31b76919ac$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $149f3a31b76919ac$export$f7fcf8304eb17dda,
        pageId: "jira-permission-scheme",
        shouldShowSpinner: true
    });

});
parcelRegister("68y6P", function(module, exports) {

let $477df2c548a9f3d0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $477df2c548a9f3d0$var$load("1VRB2"),
    $477df2c548a9f3d0$var$load("bABhq"),
    $477df2c548a9f3d0$var$load("ka9Kz")
]).then(()=>parcelRequire('44Ret'));

});



parcelRegister("bksGt", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemBulkMailRouteEntry", () => $358c5488ab53b7fe$export$f1e14d1857713e35);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $6K4yM = parcelRequire("6K4yM");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $9gC8Q = parcelRequire("9gC8Q");

var $2lbA8 = parcelRequire("2lbA8");
const $358c5488ab53b7fe$export$f1e14d1857713e35 = (0, $6xToB.createEntry)((0, $9gC8Q.globalSettingsSystemBulkMailRoute), ()=>({
        group: 'global-settings',
        component: (0, $2lbA8.default),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $6K4yM.SidebarGlobalSettingsSystem)
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $2lbA8.LazyBulkEmail)
        ]
    }));

});
parcelRegister("6K4yM", function(module, exports) {

$parcel$export(module.exports, "SidebarGlobalSettingsSystem", () => $3f83fc002f25ad5f$export$52af3150b9f64726);

var $eJOHy = parcelRequire("eJOHy");

var $1IRel = parcelRequire("1IRel");

var $8Q9Ns = parcelRequire("8Q9Ns");

var $lwUCf = parcelRequire("lwUCf");
const $3f83fc002f25ad5f$export$52af3150b9f64726 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Q9Ns.SidebarRenderStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lwUCf.Menu), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Q9Ns.SidebarReady), {
        id: (0, $1IRel.SIDEBAR_ID).GLOBAL_SETTINGS_SYSTEM
    }));

});
parcelRegister("1IRel", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_ID", () => $65c620124257314a$export$adf978edbdfaf080);
const $65c620124257314a$export$adf978edbdfaf080 = {
    CONNECT: 'CONNECT',
    CORE: 'CORE',
    FILTERS: 'FILTERS',
    FILTERS_GLOBAL: 'FILTERS_GLOBAL',
    FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
    GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
    GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
    GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
    GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
    GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
    JSM: 'JSM',
    JSW_CLASSIC: 'JSW_CLASSIC',
    JSW_NEXT_GEN: 'JSW_NEXT_GEN',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    EOC_OPERATIONS: 'EOC_OPERATIONS',
    POLARIS: 'POLARIS',
    USER: 'USER',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};

});

parcelRegister("lwUCf", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $515a7afc1067af50$export$d9b273488cd8ce6f);

var $eJOHy = parcelRequire("eJOHy");

var $bvCsK = parcelRequire("bvCsK");
var $3IxgF = parcelRequire("3IxgF");
var $irvT9 = parcelRequire("irvT9");
var $5RrpQ = parcelRequire("5RrpQ");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $8kc2T = parcelRequire("8kc2T");

var $jsesb = parcelRequire("jsesb");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $dPngI = parcelRequire("dPngI");

var $hih5V = parcelRequire("hih5V");

var $12LC2 = parcelRequire("12LC2");

var $4nlI9 = parcelRequire("4nlI9");

var $jNN5t = parcelRequire("jNN5t");

var $984NX = parcelRequire("984NX");

var $biIRA = parcelRequire("biIRA");

var $cQl3U = parcelRequire("cQl3U");

var $013X4 = parcelRequire("013X4");

var $kgYBH = parcelRequire("kgYBH");

var $km8c0 = parcelRequire("km8c0");

var $gg4FC = parcelRequire("gg4FC");

var $8mGF5 = parcelRequire("8mGF5");

var $e54td = parcelRequire("e54td");

var $1hRnr = parcelRequire("1hRnr");
const $515a7afc1067af50$var$calculateStack = (route)=>{
    const routeName = route && route.name;
    if ([
        'global-settings-performance-metric-detail',
        'global-settings-performance-overview',
        'global-settings-performance-project-cleanup',
        'global-settings-performance-project-role-actor',
        'global-settings-performance-custom-field',
        'global-settings-performance-work-type',
        'global-settings-performance-issue'
    ].includes(routeName)) return [
        (0, $12LC2.SECTION_ID).PERFORMANCE_AND_SCALE
    ];
    return [];
};
const $515a7afc1067af50$export$d9b273488cd8ce6f = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const route = (0, $hih5V.useCurrentRoute)();
    const { data: connectItems } = (0, $4nlI9.useGlobalSettingsSystemConnectItems)();
    const [stack, setStack] = (0, $eJOHy.useState)($515a7afc1067af50$var$calculateStack(route));
    (0, $eJOHy.useEffect)(()=>{
        setStack($515a7afc1067af50$var$calculateStack(route));
    }, [
        route
    ]);
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    const generalConfigurationPath = navigationPath.generalConfiguration;
    if (features == null || connectItems == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5RrpQ.default), null);
    const navigationContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, features.hasGeneralConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'general-configuration'
        },
        href: generalConfigurationPath,
        selectedOn: (0, $1hRnr.isGeneralConfigurationSelected)
    }, formatMessage((0, $kgYBH.default).generalConfiguration)), features.hasDarkFeatures && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'dark-features'
        },
        href: navigationPath.darkFeatures,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $kgYBH.default).darkFeatures)), features.hasTroubleshootingAndSupportSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8mGF5.TroubleshootingAndSupportSection), null), features.hasSecuritySection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $km8c0.SecuritySection), null), features.hasCollectors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'collectors'
        },
        href: navigationPath.issueCollectors,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $kgYBH.default).issueCollectorsIssueTermRefresh : (0, $kgYBH.default).issueCollectors)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $biIRA.AutomationSection), null), features.hasUserInterfaceSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e54td.UserInterfaceSection), null), features.hasImportExportSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cQl3U.ImportExportSection), null), features.hasMailSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $013X4.MailSection), null), features.hasAdminHelperSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jNN5t.AdminHelperSection), null), features.hasSharedSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gg4FC.SharedSection), null), features.hasAdvancedSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $984NX.AdvancedSection), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPngI.ConnectMenu), {
        items: connectItems,
        overrides: {
            BackMenuItem: {
                href: '/jira/settings/system/general-configuration',
                title: formatMessage((0, $kgYBH.default).systemGroup)
            }
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jsesb.ContextualAnalyticsData), {
        menuId: "global-settings/system",
        stack: stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $irvT9.default), {
        label: formatMessage((0, $kgYBH.default).globalSettingsSystemSidebarLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvCsK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8kc2T.TitleHeader), null, formatMessage((0, $kgYBH.default).systemGroup))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3IxgF.default), {
        stack: stack,
        onChange: setStack
    }, navigationContent)));
};

});
parcelRegister("bvCsK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0371fd6f28536372$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $dhRXV = parcelRequire("dhRXV");
const $0371fd6f28536372$var$styles = {
    navigationFooter: "_1e0c1ule _85i5u2gc _1q511ejb _y4tiu2gc _bozgu2gc"
};
/**
 * __Navigation header__
 *
 * Allows for customisation of the header.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $0371fd6f28536372$var$NavigationHeader = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
        xcss: $0371fd6f28536372$var$styles.navigationFooter,
        "data-navheader": true,
        children: children
    });
};
var $0371fd6f28536372$export$2e2bcd8739ae039 = $0371fd6f28536372$var$NavigationHeader;

});

parcelRegister("3IxgF", function(module, exports) {

$parcel$export(module.exports, "ROOT_ID", () => $17e7e2559d31ad92$export$ec71a3379b43ae5c);
$parcel$export(module.exports, "default", () => $17e7e2559d31ad92$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eLMgP = parcelRequire("eLMgP");

var $8XtVW = parcelRequire("8XtVW");

var $7Jx8v = parcelRequire("7Jx8v");

var $7yWpW = parcelRequire("7yWpW");

var $6AUjy = parcelRequire("6AUjy");

var $eGPDm = parcelRequire("eGPDm");

var $dIh93 = parcelRequire("dIh93");
const $17e7e2559d31ad92$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
const $17e7e2559d31ad92$var$nestableNavigationContentStyles = null;
const $17e7e2559d31ad92$var$nestingRootStyles = null;
/**
 * __Nestable navigation content__
 *
 * The container for navigation items with nested views
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#nested-navigation)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $17e7e2559d31ad92$var$NestableNavigationContent = (props)=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator, isDefaultFocusControl: isDefaultFocusControl = true } = props;
    const goBackButtonRef = (0, $eJOHy.useRef)(null);
    const [committedStack, setCommittedStack] = (0, $eJOHy.useState)(stack || initialStack || []);
    const controlledStack = stack || undefined;
    const currentStackId = committedStack[committedStack.length - 1] || $17e7e2559d31ad92$export$ec71a3379b43ae5c;
    const [transition, setTransition] = (0, $eJOHy.useState)('nesting');
    const backTestId = testId && `${testId}--go-back-item`;
    const [activeParentId, setActiveParentId] = (0, $eJOHy.useState)('');
    const [focusGoBackButton, setFocusGoBackButton] = (0, $eJOHy.useState)(false);
    const shouldFocus = isDefaultFocusControl && (0, $8XtVW.fg)('platform-side-navigation-keyboard-focus');
    const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Jx8v.default), {
            ...props,
            children: "Go back"
        });
    const { childIdsRef: childIdsRef } = (0, $6AUjy.useChildIds)(currentStackId, committedStack, onUnknownNest);
    const onNestHandler = (0, $eJOHy.useCallback)((layerId)=>{
        onChange && onChange(committedStack.concat(layerId));
        setFocusGoBackButton(true);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.concat(layerId);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    const onUnNestHandler = (0, $eJOHy.useCallback)(()=>{
        onChange && onChange(committedStack.slice(0, committedStack.length - 1));
        setActiveParentId(currentStackId);
        setFocusGoBackButton(false);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('unnesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.slice(0, prev.length - 1);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack,
        setActiveParentId,
        currentStackId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!controlledStack) // We aren't in controlled mode - bail out.
        return;
        if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) // stacks are equal - do nothing!
        return;
        // Controlled prop updated, let's figure out if we're nesting or unnesting.
        if (controlledStack.length < committedStack.length) // We are unnesting (removing from the stack)
        setTransition('unnesting');
        else // We are nesting (adding to the stack)
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack(controlledStack);
        });
    }, [
        committedStack,
        controlledStack
    ]);
    const backButton = renderGoBackItem({
        onClick: onUnNestHandler,
        testId: backTestId,
        ref: shouldFocus ? goBackButtonRef : null
    });
    const context = (0, $eJOHy.useMemo)(()=>({
            currentStackId: currentStackId,
            backButton: backButton,
            stack: committedStack,
            onNest: onNestHandler,
            onUnNest: onUnNestHandler,
            parentId: $17e7e2559d31ad92$export$ec71a3379b43ae5c,
            childIds: childIdsRef,
            forceShowTopScrollIndicator: showTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        currentStackId,
        backButton,
        committedStack,
        onNestHandler,
        onUnNestHandler,
        childIdsRef,
        showTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    const manageFocus = (event)=>{
        const triggeredByKeyboard = event.nativeEvent.detail === 0;
        if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": testId,
            ref: containerRef,
            tabIndex: -1,
            onClick: manageFocus,
            className: (0, $hcewu.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4t3i1osq _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eLMgP.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dIh93.NestingMotion), {
                    enterFrom: transition === 'nesting' ? 'right' : 'left',
                    exitTo: transition === 'nesting' ? 'left' : 'right',
                    testId: testId && `${testId}-anim`,
                    children: (motion)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ...motion,
                            className: (0, $hcewu.default)([
                                "_1e0c1txw _1bsb1osq _4t3i1osq _kqswstnw _2lx21bp4",
                                motion.className
                            ]),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eGPDm.NestedContext).Provider, {
                                // This provider is inside the NestingMotion to ensure it keeps a stale
                                // reference to the previous value.
                                value: context,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7yWpW.default), {
                                    title: "",
                                    id: $17e7e2559d31ad92$export$ec71a3379b43ae5c,
                                    children: children
                                })
                            })
                        })
                }, currentStackId)
            })
        })
    });
};
var $17e7e2559d31ad92$export$2e2bcd8739ae039 = $17e7e2559d31ad92$var$NestableNavigationContent;

});
parcelRegister("7Jx8v", function(module, exports) {

$parcel$export(module.exports, "default", () => $65b0c391fbfd21bf$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $DW5A3 = parcelRequire("DW5A3");


var $1ZvJ4 = parcelRequire("1ZvJ4");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $65b0c391fbfd21bf$var$GoBackItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ className: className, iconBefore: iconBefore = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($DW5A3))), {
    color: "currentColor",
    LEGACY_secondaryColor: `var(--ds-surface, ${(0, $135dba7912433cc2$export$e655ef011c4aa1a2)})`,
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $eJOHy.useState)(false);
    const onClickHandler = (0, $eJOHy.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ZvJ4.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $65b0c391fbfd21bf$export$2e2bcd8739ae039 = $65b0c391fbfd21bf$var$GoBackItem;

});
parcelRegister("DW5A3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19a10e1149a5b84d93e6a05c6f1be0d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0780b3e673316f49$var$_react = $0780b3e673316f49$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0780b3e673316f49$var$_arrowLeft = $0780b3e673316f49$var$_interopRequireDefault((parcelRequire("3d7x1")));

var $0780b3e673316f49$var$_arrowLeftCircle = $0780b3e673316f49$var$_interopRequireDefault((parcelRequire("jmq6n")));
function $0780b3e673316f49$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0780b3e673316f49$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $0780b3e673316f49$var$_react.default.createElement($0780b3e673316f49$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $0780b3e673316f49$var$_arrowLeftCircle.default
    }, props));
$0780b3e673316f49$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $0780b3e673316f49$var$_default = module.exports.default = $0780b3e673316f49$var$ArrowLeftIcon;

});
parcelRegister("jmq6n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e18451ae5555cf51$var$_react = $e18451ae5555cf51$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $e18451ae5555cf51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e18451ae5555cf51$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $e18451ae5555cf51$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props));
$e18451ae5555cf51$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $e18451ae5555cf51$var$_default = module.exports.default = $e18451ae5555cf51$var$ArrowLeftCircleIcon;

});


parcelRegister("1ZvJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0a5d0260f69f7e7$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1AUsu = parcelRequire("1AUsu");

var $eGPDm = parcelRequire("eGPDm");
const $e0a5d0260f69f7e7$var$styles = {
    root: "_2rko1sit _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
    selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $e0a5d0260f69f7e7$var$ButtonItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $eGPDm.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1AUsu.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $e0a5d0260f69f7e7$var$styles.root,
            props.isSelected && $e0a5d0260f69f7e7$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $e0a5d0260f69f7e7$export$2e2bcd8739ae039 = $e0a5d0260f69f7e7$var$ButtonItem;

});


parcelRegister("7yWpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e86f66c6e554cdd6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $LH7Sv = parcelRequire("LH7Sv");

var $8XtVW = parcelRequire("8XtVW");

var $dhRXV = parcelRequire("dhRXV");


var $1ZvJ4 = parcelRequire("1ZvJ4");
var $6V48L = parcelRequire("6V48L");
var $fEeX1 = parcelRequire("fEeX1");

var $3IxgF = parcelRequire("3IxgF");

var $eGPDm = parcelRequire("eGPDm");

var $6AUjy = parcelRequire("6AUjy");
const $e86f66c6e554cdd6$var$styles = {
    iconContainer: "_1e0c1nu9",
    nestingItem: "_udl3glyw _kqsfglyw _udrwglyw _13qvglyw _9mqr1kw7 _povs1kw7 _uv2d1kw7 _atks1kw7",
    nestingItemDisabled: "_1c06idpf _udl3glyw"
};
/**
 * NestingItem will render itself differently depending in what context it is rendered in.
 * When not open - it will render itself as an item.
 * When open - it will render its children.
 */ const $e86f66c6e554cdd6$var$NestingItem = (props)=>{
    const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, className: className, isDisabled: isDisabled, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
    const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator, activeParentId: activeParentId, goBackButtonRef: goBackButtonRef, isDefaultFocusControl: isDefaultFocusControl, focusGoBackButton: focusGoBackButton } = (0, $eGPDm.useNestedContext)();
    const [isInteracted, setIsInteracted] = (0, $eJOHy.useState)(false);
    const parentItemRef = (0, $eJOHy.useRef)(null);
    // To avoid error we need to make sure that the component is wrapped in ForwardRef
    const isForwardRefCheck = (component)=>{
        if (component?.prototype?.isReactComponent) return false;
        return component?.$$typeof === Symbol.for('react.forward_ref');
    };
    const shouldFocus = isDefaultFocusControl && (0, $8XtVW.fg)('platform-side-navigation-keyboard-focus');
    const backButtonRef = shouldFocus ? goBackButtonRef : null;
    const activeParentRef = shouldFocus ? parentItemRef : null;
    (0, $eJOHy.useEffect)(()=>{
        if (shouldFocus) {
            if (activeParentId === id) parentItemRef?.current?.focus();
            if (focusGoBackButton) goBackButtonRef?.current?.focus();
        }
    }, [
        activeParentId,
        id,
        goBackButtonRef,
        focusGoBackButton,
        isDefaultFocusControl,
        shouldFocus
    ]);
    const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
        onClick: onUnNest,
        testId: testId && `${testId}--go-back-item`,
        ref: backButtonRef
    }) || contextualBackButton;
    const context = (0, $eJOHy.useMemo)(()=>({
            stack: stack,
            currentStackId: currentStackId,
            onNest: onNest,
            onUnNest: onUnNest,
            backButton: backButton,
            parentId: id,
            childIds: childIds,
            forceShowTopScrollIndicator: forceShowTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        stack,
        currentStackId,
        onNest,
        onUnNest,
        backButton,
        id,
        childIds,
        forceShowTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    (0, $6AUjy.useChildIdsEffect)(childIds, id);
    const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    /**
   * We want both the on nest handler and the onclick handler to be called.
   * We create a wrapper function to call both.
   */ const onClickHandler = (0, $eJOHy.useCallback)((e)=>{
        if (isInteracted) // We return early if this has been interacted with because its assumed
        // this will be already exiting - so we don't want to double up the click.
        return;
        // Avoid a nesting transition if a modifier key is detected during click.
        // @ts-expect-error - Argument of type 'MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>' is not assignable to parameter of type 'MouseEvent'
        if (isNormalClick(e)) {
            setIsInteracted(true);
            onNest(id);
        }
        onClick && onClick(e);
    }, [
        isInteracted,
        onClick,
        onNest,
        id
    ]);
    if (currentStackId === id) return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eGPDm.NestedContext).Provider, {
        value: context,
        children: [
            stack.length >= 1 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
                paddingBlock: "space.075",
                paddingInline: "space.100",
                children: backButton
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fEeX1.default), {
                testId: testId,
                showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1,
                children: children
            })
        ]
    });
    if ([
        (0, $3IxgF.ROOT_ID),
        ...stack
    ].includes(id)) return children;
    const componentProps = {
        iconAfter: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
            children: [
                iconAfter ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
                    xcss: $e86f66c6e554cdd6$var$styles.iconContainer,
                    "data-custom-icon": true,
                    as: "span",
                    children: iconAfter
                }) : null,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
                    "data-right-arrow": true,
                    xcss: $e86f66c6e554cdd6$var$styles.iconContainer,
                    as: "span",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($LH7Sv))), {
                        testId: testId && `${testId}--item--right-arrow`,
                        color: "currentColor",
                        LEGACY_secondaryColor: `var(--ds-surface, ${(0, $135dba7912433cc2$export$e655ef011c4aa1a2)})`,
                        label: ""
                    })
                })
            ]
        }),
        onClick: onClickHandler,
        isSelected: isSelected,
        isDisabled: isDisabled,
        testId: testId && `${testId}--item`,
        ...rest,
        children: title
    };
    if (component) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6V48L.default), {
        ref: isForwardRefCheck(component) ? parentItemRef : null,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $e86f66c6e554cdd6$var$styles.nestingItem,
            isDisabled && $e86f66c6e554cdd6$var$styles.nestingItemDisabled,
            className
        ]),
        //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        component: component
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ZvJ4.default), {
        ref: activeParentRef,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $e86f66c6e554cdd6$var$styles.nestingItem,
            isDisabled && $e86f66c6e554cdd6$var$styles.nestingItemDisabled,
            className
        ])
    });
};
var $e86f66c6e554cdd6$export$2e2bcd8739ae039 = $e86f66c6e554cdd6$var$NestingItem;

});
parcelRegister("LH7Sv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dbc8100b1314a43ce0868b8331a89007>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08f5d7d6db8e772b$var$_react = $08f5d7d6db8e772b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $08f5d7d6db8e772b$var$_arrowRight = $08f5d7d6db8e772b$var$_interopRequireDefault((parcelRequire("6jxv4")));

var $08f5d7d6db8e772b$var$_arrowRightCircle = $08f5d7d6db8e772b$var$_interopRequireDefault((parcelRequire("g448W")));
function $08f5d7d6db8e772b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08f5d7d6db8e772b$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $08f5d7d6db8e772b$var$_react.default.createElement($08f5d7d6db8e772b$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $08f5d7d6db8e772b$var$_arrowRightCircle.default
    }, props));
$08f5d7d6db8e772b$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $08f5d7d6db8e772b$var$_default = module.exports.default = $08f5d7d6db8e772b$var$ArrowRightIcon;

});
parcelRegister("6jxv4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $498e80d5ba9313ca$var$_react = $498e80d5ba9313ca$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $498e80d5ba9313ca$var$_baseNew = $498e80d5ba9313ca$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $498e80d5ba9313ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $498e80d5ba9313ca$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $498e80d5ba9313ca$var$_react.default.createElement($498e80d5ba9313ca$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$498e80d5ba9313ca$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $498e80d5ba9313ca$var$_default = module.exports.default = $498e80d5ba9313ca$var$ArrowRightIcon;

});

parcelRegister("g448W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb203bce7d901517$var$_react = $bb203bce7d901517$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $bb203bce7d901517$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bb203bce7d901517$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $bb203bce7d901517$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props));
$bb203bce7d901517$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $bb203bce7d901517$var$_default = module.exports.default = $bb203bce7d901517$var$ArrowRightCircleIcon;

});


parcelRegister("6V48L", function(module, exports) {

$parcel$export(module.exports, "default", () => $712021b2f4153847$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8DtAB = parcelRequire("8DtAB");

var $eGPDm = parcelRequire("eGPDm");
const $712021b2f4153847$var$styles = {
    root: "_2rko1sit _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
    selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $712021b2f4153847$var$CustomItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $eGPDm.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8DtAB.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $712021b2f4153847$var$styles.root,
            props.isSelected && $712021b2f4153847$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $712021b2f4153847$export$2e2bcd8739ae039 = $712021b2f4153847$var$CustomItem;

});

parcelRegister("fEeX1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6e0743101489bf5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eKgsm = parcelRequire("eKgsm");

var $eGPDm = parcelRequire("eGPDm");
const $c6e0743101489bf5$var$outerContainerCSS = null;
const $c6e0743101489bf5$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjgqwt _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $c6e0743101489bf5$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $c6e0743101489bf5$var$NavigationContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $eGPDm.useShouldNestedElementRender)();
    const scrollbar = (0, $eKgsm.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rus1p09 _1kt9b3bt _1enwftgi _z5wtu2gc _14mjgqwt _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfk1p09 _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $hcewu.default)([
                $c6e0743101489bf5$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $c6e0743101489bf5$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $c6e0743101489bf5$var$containerCSS.basic,
                    showTopScrollIndicator && $c6e0743101489bf5$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});
var $c6e0743101489bf5$export$2e2bcd8739ae039 = $c6e0743101489bf5$var$NavigationContent;

});
parcelRegister("eKgsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cd555ef63896a86$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $4cd555ef63896a86$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $eJOHy.useState)(0);
    const elementRef = (0, $eJOHy.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("6AUjy", function(module, exports) {

$parcel$export(module.exports, "useChildIds", () => $7ad5699854346edb$export$61b3ef4f009a9474);
$parcel$export(module.exports, "useChildIdsEffect", () => $7ad5699854346edb$export$ea18c2b5f0e24612);

var $eJOHy = parcelRequire("eJOHy");

var $3IxgF = parcelRequire("3IxgF");
const $7ad5699854346edb$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
    const childIdsRef = (0, $eJOHy.useRef)(new Set());
    (0, $eJOHy.useEffect)(()=>{
        // we are holding navigation item IDs in childIdsRef
        // check if the current displayed nav item (currentStackId) is in childIdsRef. if it's not, this means it's undefined
        if (currentStackId === (0, $3IxgF.ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
        onUnknownNest(committedStack || [
            currentStackId
        ]);
    }, [
        currentStackId,
        committedStack,
        onUnknownNest
    ]);
    return {
        childIdsRef: childIdsRef
    };
};
const $7ad5699854346edb$export$ea18c2b5f0e24612 = (childIds, id)=>{
    (0, $eJOHy.useEffect)(()=>{
        if (!childIds || !childIds.current) return;
        if (!childIds.current.has(id)) childIds.current.add(id);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            childIds.current.delete(id);
        };
    // childIds shouldn't change as it's a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
};

});


parcelRegister("dIh93", function(module, exports) {

$parcel$export(module.exports, "NestingMotion", () => $71bc513731eb389f$export$9e743a8c2a6b450e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $am1Db = parcelRequire("am1Db");
const $71bc513731eb389f$export$9e743a8c2a6b450e = (props)=>{
    const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $am1Db.default), {
        exitTo: exitTo,
        enterFrom: enterFrom,
        animationTimingFunction: "ease-out",
        children: (innerProps, direction)=>children({
                'data-enter-from': enterFrom,
                'data-exit-to': exitTo,
                'data-testid': testId && `${testId}-${direction}`,
                ...innerProps
            })
    });
};

});


parcelRegister("irvT9", function(module, exports) {

$parcel$export(module.exports, "default", () => $06eca97ed81a67f3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fEAVV = parcelRequire("fEAVV");
const $06eca97ed81a67f3$var$sidebarMinWidth = '240px';
const $06eca97ed81a67f3$var$sideNavStyles = null;
/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 */ const $06eca97ed81a67f3$var$SideNavigation = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, label: label, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        "data-vc": `side-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'side-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'side-navigation-placeholder'
        },
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _1ul9p3fh _4t3i1osq _kqswh2mm _2lx21bp4 _bfhkw70a _syazjjyb"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fEAVV.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch",
            children: children
        })
    });
});
var $06eca97ed81a67f3$export$2e2bcd8739ae039 = $06eca97ed81a67f3$var$SideNavigation;

});

parcelRegister("dysoB", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $af143be694f933c4$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3Q6BV = parcelRequire("3Q6BV");

var $6V48L = parcelRequire("6V48L");

var $c9uTK = parcelRequire("c9uTK");
var $gCY1z = parcelRequire("gCY1z");

var $8KWr1 = parcelRequire("8KWr1");

var $fZmSO = parcelRequire("fZmSO");
const $af143be694f933c4$var$cssVarPrefix = '--sidebar-menu-item';
const $af143be694f933c4$var$bgColorCssVar = `${$af143be694f933c4$var$cssVarPrefix}-bg-color`;
const $af143be694f933c4$var$bgColorHoverCssVar = `${$af143be694f933c4$var$cssVarPrefix}-bg-color-hover`;
const $af143be694f933c4$var$bgColorActiveCssVar = `${$af143be694f933c4$var$cssVarPrefix}-bg-color-active`;
const $af143be694f933c4$var$colorCssVar = `${$af143be694f933c4$var$cssVarPrefix}-color`;
const $af143be694f933c4$var$colorHoverCssVar = `${$af143be694f933c4$var$cssVarPrefix}-color-hover`;
const $af143be694f933c4$var$colorActiveCssVar = `${$af143be694f933c4$var$cssVarPrefix}-color-active`;
const $af143be694f933c4$var$boxShadowCssVar = `${$af143be694f933c4$var$cssVarPrefix}-box-shadow`;
const $af143be694f933c4$var$iconSecondaryColorHoverCssVar = `${$af143be694f933c4$var$cssVarPrefix}-icon-secondary-color-hover`;
const $af143be694f933c4$var$styles = {
    root: "_ow0718uv _vwjz18uv _el8t18uv _17rj1kw7 _1f981kw7 _12pi1kw7 _1iqunqa1 _6xf7nqa1 _1lwpnqa1 _144v1r31 _3m4d1r31 _epv21r31 _chl4glyw _1bblglyw _1xhsglyw _1txwidpf _fg45idpf _gmaiidpf _10fu1oxo _iozn1cd0 _1vzi1w2z _davf29yu _1lfucjiy _s3s5tlke _12pzh2mm",
    selected: "_1cmdaqb7",
    themeColorDefault: "_1w905hvc _zelm5hvc _1f1j5hvc _1cmd5hvc",
    themeColorHover: "_1fh1smn3",
    themeColorActive: "_1l5a14t4 _1gdc14t4 _g8mu14t4 _434t14t4",
    themeBgColorDefault: "_16hgrn9c",
    themeBgColorHover: "_u1mb58tq",
    themeBgColorActive: "_1lg618j6",
    themeIconSecondaryColorHover: "_1k5811db"
};
const $af143be694f933c4$var$WrapperComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ $eJOHy.createElement((0, $c9uTK.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ $eJOHy.createElement($af143be694f933c4$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $af143be694f933c4$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, className: className, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $fZmSO.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $gCY1z.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $8KWr1.useSidebarTheme)();
    const itemTheme = theme?.navigation?.item;
    const iconTheme = theme?.navigation?.icon;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $af143be694f933c4$var$WrapperComponent,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined,
        style: {
            [$af143be694f933c4$var$bgColorCssVar]: itemTheme?.background?.default ?? undefined,
            [$af143be694f933c4$var$bgColorHoverCssVar]: itemTheme?.background?.hover ?? undefined,
            [$af143be694f933c4$var$bgColorActiveCssVar]: itemTheme?.background?.active ?? undefined,
            [$af143be694f933c4$var$colorCssVar]: itemTheme?.color?.default ?? undefined,
            [$af143be694f933c4$var$colorHoverCssVar]: itemTheme?.color?.hover ?? undefined,
            [$af143be694f933c4$var$colorActiveCssVar]: itemTheme?.color?.active ?? undefined,
            [$af143be694f933c4$var$boxShadowCssVar]: itemTheme?.color?.active != null ? `${itemTheme?.color?.active} 0 0 0 2px inset` : `${"var(--ds-border-focused, #388BFF)"} 0 0 0 2px inset`,
            [$af143be694f933c4$var$iconSecondaryColorHoverCssVar]: iconTheme?.secondary?.color?.hover ?? undefined
        }
    };
    if (overrides?.CustomItem?.render) return overrides?.CustomItem?.render({
        ...customProps,
        className: (0, $hcewu.default)([
            (0, $hcewu.default)([
                $af143be694f933c4$var$styles.root
            ]),
            isSelected && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.selected
            ]),
            itemTheme?.color?.default && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeColorDefault
            ]),
            itemTheme?.background?.default && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeBgColorDefault
            ]),
            itemTheme?.background?.hover && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeBgColorHover
            ]),
            itemTheme?.background?.active && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeBgColorActive
            ]),
            itemTheme?.color?.hover && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeColorHover
            ]),
            itemTheme?.color?.active && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeColorActive
            ]),
            iconTheme?.secondary?.color?.hover && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeIconSecondaryColorHover
            ]),
            className
        ])
    });
    return /*#__PURE__*/ $eJOHy.createElement((0, $6V48L.default), {
        ...customProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hcewu.default)([
            $af143be694f933c4$var$styles.root,
            isSelected && $af143be694f933c4$var$styles.selected,
            itemTheme?.color?.default && $af143be694f933c4$var$styles.themeColorDefault,
            itemTheme?.background?.default && $af143be694f933c4$var$styles.themeBgColorDefault,
            itemTheme?.background?.hover && $af143be694f933c4$var$styles.themeBgColorHover,
            itemTheme?.background?.active && $af143be694f933c4$var$styles.themeBgColorActive,
            itemTheme?.color?.hover && $af143be694f933c4$var$styles.themeColorHover,
            itemTheme?.color?.active && $af143be694f933c4$var$styles.themeColorActive,
            iconTheme?.secondary?.color?.hover && $af143be694f933c4$var$styles.themeIconSecondaryColorHover,
            className
        ])
    });
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af143be694f933c4$var$ButtonItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8KWr1", function(module, exports) {

$parcel$export(module.exports, "SidebarThemeProvider", () => $76cb412fcc597faf$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $76cb412fcc597faf$export$b1a81b4626bc52c3);

var $eJOHy = parcelRequire("eJOHy");
const $76cb412fcc597faf$var$ThemeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $76cb412fcc597faf$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($76cb412fcc597faf$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $76cb412fcc597faf$export$b1a81b4626bc52c3 = ()=>(0, $eJOHy.useContext)($76cb412fcc597faf$var$ThemeContext);

});

parcelRegister("fZmSO", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $95214767aefcba5f$export$a81c45382e7253ac);

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");
const $95214767aefcba5f$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("8kc2T", function(module, exports) {

$parcel$export(module.exports, "TitleHeader", () => $5d3eb52abe585b54$export$de3705f3d2162955);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $1H6cR = parcelRequire("1H6cR");
const $5d3eb52abe585b54$var$overrideStyles = null;
const $5d3eb52abe585b54$export$de3705f3d2162955 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1H6cR.CustomHeader), {
        testId: "navigation-apps-sidebar-common.common.ui.title-header",
        className: (0, $hcewu.default)([
            "_dqi54jg8 _1lfu4jg8"
        ])
    }, children);
};

});
parcelRegister("1H6cR", function(module, exports) {

$parcel$export(module.exports, "CustomHeader", () => $c6612ad9800f1aa6$export$a231a61d189ef09a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6V48L = parcelRequire("6V48L");

var $8KWr1 = parcelRequire("8KWr1");
const $c6612ad9800f1aa6$var$bgColorCssVar = '--header-bg-color';
const $c6612ad9800f1aa6$var$textColorCssVar = '--header-text-color';
const $c6612ad9800f1aa6$var$containerStyles = null;
const $c6612ad9800f1aa6$var$bgColorThemeStyles = null;
const $c6612ad9800f1aa6$var$colorThemeStyles = null;
const $c6612ad9800f1aa6$export$1e86fd0e1db89578 = ({ className: className, ...props })=>{
    const theme = (0, $8KWr1.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_syaz1jnk _kqswh2mm _uizt1wug _vrjt140y _1cmdleuv _jl2n73ad _1v6j1fxt",
            item?.background?.default && "_bfhk1im0",
            item?.color?.default && "_syaz1jnk _i9a11jnk",
            className
        ]),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$c6612ad9800f1aa6$var$bgColorCssVar]: item?.background?.default,
            [$c6612ad9800f1aa6$var$textColorCssVar]: item?.color?.default
        },
        ...props
    });
};
const $c6612ad9800f1aa6$export$a231a61d189ef09a = ({ iconBefore: iconBefore, iconAfter: iconAfter, children: children, ...rest })=>{
    return /*#__PURE__*/ $eJOHy.createElement((0, $6V48L.default), {
        ...rest,
        component: $c6612ad9800f1aa6$export$1e86fd0e1db89578,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isTitleHeading: true
    }, children);
};

});


parcelRegister("jsesb", function(module, exports) {

$parcel$export(module.exports, "ContextualAnalyticsData", () => $69dd343014a7c35f$export$198470770171c65);
$parcel$export(module.exports, "IssuesContextualAnalyticsData", () => $69dd343014a7c35f$export$bc7f6eebc16e6127);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $4xbv3 = parcelRequire("4xbv3");

var $eWzpp = parcelRequire("eWzpp");

var $8ZNPQ = parcelRequire("8ZNPQ");
const $69dd343014a7c35f$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
            navVersion: '3',
            viewId: (0, $8ZNPQ.generateViewId)(menuId, ...stack),
            navigationLayer: 'container',
            ...attributes
        }
    });
const $69dd343014a7c35f$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: // eslint-disable-next-line react-hooks/react-compiler
useProject = (0, $eWzpp.useProject), ...rest })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: project } = useProject();
    const projectConfig = (project?.isSimplified ? (0, $ln6Iy.ProjectStyle).NEXT_GEN : (0, $ln6Iy.ProjectStyle).CLASSIC) || undefined;
    const projectType = project?.type || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            projectConfig: projectConfig,
            projectType: projectType,
            navigatorScope: navigatorScope
        }
    });
};

});
parcelRegister("8ZNPQ", function(module, exports) {

$parcel$export(module.exports, "generateViewId", () => $d7357fd7d80444c9$export$5b5545ed894dc47a);
const $d7357fd7d80444c9$export$5b5545ed894dc47a = (...ids)=>ids.join('/');

});


parcelRegister("gp9Js", function(module, exports) {

$parcel$export(module.exports, "getSystemNavigationPaths", () => $95f097573d74b3f1$export$76c5f80c8d9bdb0e);
$parcel$export(module.exports, "isSystemNavPath", () => $95f097573d74b3f1$export$3e53a29d6e499ec4);

var $7jTnu = parcelRequire("7jTnu");
const $95f097573d74b3f1$export$76c5f80c8d9bdb0e = ()=>({
        generalConfiguration: '/jira/settings/system/general-configuration',
        darkFeatures: '/secure/admin/SiteDarkFeatures!default.jspa',
        issueCollectors: '/secure/admin/ViewGlobalCollectors!default.jspa',
        globalAutomation: '/jira/settings/automation',
        // troubleshooting
        troubleshootingAuditLog: '/auditing/view',
        troubleshootingPluginViewer: '/plugins/servlet/depview/plugins',
        troubleshootingModulesViewer: '/plugins/servlet/depview/modules',
        troubleshootingSystemInfo: '/secure/admin/ViewSystemInfo.jspa',
        troubleshootingIntegrityChecker: '/secure/admin/IntegrityChecker!default.jspa',
        troubleshootingLoggingProfiling: '/secure/admin/ViewLogging.jspa',
        troubleshootingSchedulerDetails: '/secure/admin/SchedulerAdmin.jspa',
        troubleshootingPerformanceAndScale: '/jira/settings/system/performance/overview',
        // security
        securityProjectRoles: '/secure/project/ViewProjectRoles.jspa',
        securityGlobalPermissions: (0, $7jTnu.fg)('olympus-global-permissions-fe-modernisation') ? '/secure/admin/global-permissions' : '/secure/admin/GlobalPermissions!default.jspa',
        // user interface
        userInterfacesUserDefaults: '/secure/admin/ViewUserDefaultSettings.jspa',
        userInterfacesEditDefaultDashboard: '/secure/admin/EditDefaultDashboard!default.jspa',
        userInterfacesLookAndFeel: '/secure/admin/LookAndFeel!default.jspa',
        userInterfacesPasAdmin: '/plugins/servlet/pas/admin',
        userInterfacesSiteAdmin: '/jira/settings/system/ui/announcement-banner',
        // import and export
        importSectionBackupManager: '/secure/admin/CloudExport.jspa',
        importSectionExternalImport: '/secure/admin/ExternalImport1.jspa',
        importSectionExternalImportNew: '/jira/settings/system/external-import',
        importSectionCloudImport: '/secure/admin/CloudImport!start.jspa?source=import_cloud',
        importSectionServerImport: '/secure/admin/CloudImport!start.jspa?source=import_server',
        // mail
        mailSectionGlobalMailSettings: '/secure/admin/GlobalMailSettings.jspa',
        mailSectionOutgoingMail: '/secure/admin/OutgoingMailServers.jspa',
        mailSectionIncomingMail: '/secure/admin/IncomingMailServers.jspa',
        mailSectionSendMail: '/secure/admin/SendBulkMail!default.jspa',
        // admin
        adminHelperPermissionHelper: '/secure/admin/PermissionHelperAdmin.jspa',
        adminHelperEmailNotificationsLogHelper: '/jira/settings/system/notification-logs',
        // shared
        sharedSectionManageFilters: '/secure/admin/filters/ViewSharedFilters.jspa',
        sharedManageDashboards: '/secure/admin/dashboards/ViewSharedDashboards.jspa',
        // advanced
        advancedSectionAttachments: '/secure/admin/ViewAttachmentSettings.jspa',
        advancedSectionEvents: '/secure/admin/ListEventTypes.jspa',
        advancedSectionWebHooks: '/plugins/servlet/webhooks',
        advancedSectionServices: '/secure/admin/ViewServices!default.jspa',
        advancedLexoRankManagement: '/secure/GHLexoRankManage.jspa?decorator=admin'
    });
const $95f097573d74b3f1$var$getSystemNavPaths = ()=>{
    return [
        '/jira/settings/system/general-configuration',
        '/secure/admin/SiteDarkFeatures',
        '/secure/admin/ViewGlobalCollectors',
        '/jira/settings/automation',
        '/auditing/view',
        '/secure/project/ViewProjectRoles',
        '/secure/admin/global-permissions',
        '/secure/admin/GlobalPermissions',
        '/secure/admin/ViewUserDefaultSettings',
        '/secure/admin/EditDefaultDashboard',
        '/secure/admin/LookAndFeel',
        '/jira/settings/system/ui/announcement-banner',
        '/secure/admin/CloudExport',
        '/jira/settings/system/external-import',
        '/secure/admin/CloudImport',
        '/secure/admin/GlobalMailSettings',
        '/secure/admin/global-mail-settings',
        '/secure/admin/OutgoingMailServers',
        '/secure/admin/IncomingMailServers',
        '/secure/admin/SendBulkMail',
        '/secure/admin/PermissionHelperAdmin',
        '/jira/settings/system/notification-logs',
        '/secure/admin/filters/ViewSharedFilters',
        '/secure/admin/dashboards/ViewSharedDashboards',
        '/secure/admin/ViewAttachmentSettings',
        '/secure/admin/ListEventTypes',
        '/plugins/servlet/webhooks',
        '/secure/GHLexoRankManage'
    ];
};
const $95f097573d74b3f1$export$3e53a29d6e499ec4 = (path)=>{
    const paths = $95f097573d74b3f1$var$getSystemNavPaths();
    return path && paths.some((p)=>path.includes(p));
};

});

parcelRegister("dPngI", function(module, exports) {

$parcel$export(module.exports, "ConnectMenu", () => $f2c616a9ef8ca18f$export$19d0925d424b864a);

var $eJOHy = parcelRequire("eJOHy");

var $2FyzM = parcelRequire("2FyzM");

var $2L5WL = parcelRequire("2L5WL");
const $f2c616a9ef8ca18f$export$19d0925d424b864a = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '' })=>{
    const filteredItems = (0, $2FyzM.useFilteredItems)(items || null, shouldFilter);
    if (filteredItems == null || !filteredItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, filteredItems.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2L5WL.ConnectItem), {
            item: item,
            key: item.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        })));
};

});
parcelRegister("2FyzM", function(module, exports) {

$parcel$export(module.exports, "useFilteredItems", () => $834772dde15fdd1a$export$79762159776e61da);

var $eJOHy = parcelRequire("eJOHy");

var $eES78 = parcelRequire("eES78");
const $834772dde15fdd1a$export$79762159776e61da = (items, shouldFilter = true)=>(0, $eJOHy.useMemo)(()=>{
        if (!shouldFilter) return items || [];
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"services" | "collectors" | "attachments" | "eventtypes" | "webhooks-admin" | "greenhopper-lexorank-manage" | "admin-helper-admin-section" | "advanced_section" | "dark_features" | ... 74 more ... | "com.codebarrel.addons.automation__cb-automation" | "com.codebarrel.addons.automation.moderate__cb-automation"'.
        return items?.filter((item)=>!(0, $eES78.staticLegacyIds).includes(item.id)) || [];
    }, [
        items,
        shouldFilter
    ]);

});

parcelRegister("2L5WL", function(module, exports) {

$parcel$export(module.exports, "ConnectItem", () => $02c32db1d359d9d3$export$8bb4bcea44a3c9ea);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jSYec = parcelRequire("jSYec");

var $7Tz5f = parcelRequire("7Tz5f");

var $9YRcI = parcelRequire("9YRcI");

var $eAeIg = parcelRequire("eAeIg");

var $jUPZ1 = parcelRequire("jUPZ1");

var $cGvTS = parcelRequire("cGvTS");

var $dysoB = parcelRequire("dysoB");

var $7wb6T = parcelRequire("7wb6T");

var $8kc2T = parcelRequire("8kc2T");

var $gkhxF = parcelRequire("gkhxF");

var $8xDPn = parcelRequire("8xDPn");
const $02c32db1d359d9d3$export$8bb4bcea44a3c9ea = ({ index: index, item: item, overrides: overrides, showIcons: showIcons, submenuId: submenuId = '', isNested: isNested = false })=>{
    const { addNew: addNew } = (0, $jUPZ1.useConnectItemClickHistory)();
    const isDialog = item.styleClass && (0, $cGvTS.isConnectDialogWebItem)(item.styleClass);
    const webItemRef = (0, $eJOHy.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const BackMenuItem = {
        ...overrides.BackMenuItem,
        onClick: (ev)=>{
            // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
            // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
            // This is to satisfy a requirement for open expandable menus to remain open
            // when users return to the project settings menu
            if (submenuId != null) {
                const cookieData = (0, $9YRcI.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                let parsedCookieData = null;
                try {
                    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                    parsedCookieData = JSON.parse(cookieData);
                } catch  {
                    // Rather than throw an error - just set the default state
                    parsedCookieData = {
                        submenuActive: false,
                        expanded: false
                    };
                }
                const newCookieData = {
                    ...parsedCookieData,
                    submenuActive: false
                };
                (0, $eAeIg.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newCookieData));
            }
            // Setting navigateOnBackMenuItemClick to true will allow backToProject link to take user to the default project page
            if (overrides?.navigateOnBackMenuItemClick !== true) ev.preventDefault();
            overrides.BackMenuItem?.onClick?.(ev);
        }
    };
    const icon = (0, $eJOHy.useMemo)(()=>{
        if (showIcons !== true) return null;
        return item.iconUrl != null && item.iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02c32db1d359d9d3$var$ConnectIcon, {
            src: item.iconUrl,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jSYec))), {
            spacing: "spacious",
            label: ""
        });
    }, [
        showIcons,
        item.iconUrl
    ]);
    const onItemClick = (0, $eJOHy.useCallback)((event)=>{
        // We need to check we're clicking an item inside a nested menu for a connect item.
        // if we are deep linking to a nested connect item -> we need to maintain the hiding of nav-modules
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick && isNested) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        if (isDialog) (0, $cGvTS.withConnectHost)((connectHost)=>{
            if (webItemRef.current && item.styleClass && item.url) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
        });
        else item.url != null && addNew(item.url);
    }, [
        addNew,
        isDialog,
        isNested,
        item.styleClass,
        item.url,
        overrides
    ]);
    const onNestedMenuItemClick = (0, $eJOHy.useCallback)((event)=>{
        // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
        // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
        // This is to satisfy a requirement for open expandable menus to remain open
        // when users return to the project settings menu
        if (submenuId != null) {
            const cookieData = (0, $9YRcI.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
            if (cookieData != null) (0, $eAeIg.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify({
                ...JSON.parse(cookieData),
                submenuActive: true
            }));
        }
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        return ()=>null;
    }, [
        overrides,
        submenuId
    ]);
    if (item.section === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tz5f.default), {
        title: item.name,
        hasSeparator: Boolean(index)
    }, (item.items || []).map((si, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02c32db1d359d9d3$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            overrides: {
                ...overrides,
                BackMenuItem: BackMenuItem
            },
            index: idx,
            isNested: isNested
        })));
    if (item.items) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gkhxF.NestingMenuItem), {
        id: item.id,
        analytics: {
            itemId: item.id
        },
        iconBefore: icon,
        overrides: {
            ...overrides,
            BackMenuItem: BackMenuItem
        },
        title: item.name,
        onClick: onNestedMenuItemClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wb6T.NavigationContentWrapper), {
        submenuActive: true,
        nestedMenuOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tz5f.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8kc2T.TitleHeader), null, item.name), (item.items || []).map((si, nestIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02c32db1d359d9d3$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            index: nestIndex,
            overrides: {
                ...overrides,
                BackMenuItem: {
                    href: item.url,
                    title: si.name,
                    onClick: (ev)=>ev.preventDefault()
                }
            },
            isNested: true
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: item.id
        },
        selectedOn: (0, $8xDPn.matchUrlExact)(),
        iconBefore: icon,
        href: isDialog ? undefined : item.url,
        onClick: onItemClick,
        ref: webItemRef
    }, item.name);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02c32db1d359d9d3$var$ConnectIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eAeIg", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $35882f1170e3dcfb$export$93509ff9a62ee022);

var $9mpW3 = parcelRequire("9mpW3");
const $35882f1170e3dcfb$export$93509ff9a62ee022 = (key, value, attributes)=>{
    (0, $9mpW3.setStrictlyNecessaryCookie)(key, value, attributes);
};

});

parcelRegister("7wb6T", function(module, exports) {

$parcel$export(module.exports, "NavigationHeaderWrapper", () => $6bae686b85f6a717$export$bae9b35e967353d5);
$parcel$export(module.exports, "NavigationExpandableContentWrapper", () => $6bae686b85f6a717$export$4e88508e6904469e);
$parcel$export(module.exports, "NavigationContentWrapper", () => $6bae686b85f6a717$export$e7d691a5a9258e1b);
$parcel$export(module.exports, "NextGenIssueTypesWrapper", () => $6bae686b85f6a717$export$f094f7aad76e4268);
$parcel$export(module.exports, "ExpandableProjectSettingsWrapper", () => $6bae686b85f6a717$export$e38bb288d890ec2f);
$parcel$export(module.exports, "ShortCutsAndAppsWrapper", () => $6bae686b85f6a717$export$337add4342ee7986);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $dPMMf = parcelRequire("dPMMf");
const $6bae686b85f6a717$export$bae9b35e967353d5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bae686b85f6a717$var$NavigationHeaderWrapperContainer, null, props.children);
const $6bae686b85f6a717$export$4e88508e6904469e = (props)=>{
    const { nestedAppOpen: nestedAppOpen, submenuActive: submenuActive, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bae686b85f6a717$var$NavigationExpandableContentWrapperContainer, {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, children);
};
const $6bae686b85f6a717$export$e7d691a5a9258e1b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bae686b85f6a717$var$NavigationContentWrapperContainer, {
        submenuActive: props.submenuActive,
        nestedMenuOpen: props.nestedMenuOpen,
        "data-component-selector": "NavigationContentWrapperContainer"
    }, props.children);
const $6bae686b85f6a717$export$f094f7aad76e4268 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bae686b85f6a717$var$NextGenIssueTypesWrapperContainer, null, props.children);
const $6bae686b85f6a717$export$e38bb288d890ec2f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bae686b85f6a717$var$ExpandableProjectContainer, null, props.children);
const $6bae686b85f6a717$export$337add4342ee7986 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bae686b85f6a717$var$ShortCutsAndAppsContainer, null, props.children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6bae686b85f6a717$var$NavigationHeaderWrapperContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0u2gc _1s541012 _1lfu1012",
            __cmplp.className
        ])
    });
});
const $6bae686b85f6a717$var$NavigationExpandableContentWrapperContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedAppOpen: nestedAppOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ykp9lh": (0, $awdRS.default)(__cmplp.nestedAppOpen ? 'auto' : '100%'),
            "--_1qrlsbv": (0, $awdRS.default)(Math.round((0, $dPMMf.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0u2gc _1q1o54a6 _1dul54a6 _ofxb54a6 _179m54a6 _vnu9l52n _19iyl52n _t6kll52n _shi3l52n _15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive && "_4t3i1qw7",
            __cmplp.submenuActive ? "_bq2uyjp0 _1n80yjp0 _di7gyjp0 _1lozyjp0" : "_bq2u1d7o _1n801d7o _di7g1d7o _1loz1d7o",
            __cmplp.className
        ])
    });
});
const $6bae686b85f6a717$var$NavigationContentWrapperContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedMenuOpen: nestedMenuOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6w8gix": (0, $awdRS.default)(__cmplp.nestedMenuOpen ? 0 : 7.5 * (0, $dPMMf.gridSize), "px"),
            "--_1qrlsbv": (0, $awdRS.default)(Math.round((0, $dPMMf.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive ? "_4t3iu4z3" : "_4t3i1wug",
            __cmplp.submenuActive ? "_vnu91tcg _19iy1tcg _t6kl1tcg _shi31tcg" : "_vnu9l52n _19iyl52n _t6kll52n _shi3l52n",
            __cmplp.nestedMenuOpen && "_1reo1wug _18m91wug _14tk183y",
            __cmplp.className
        ])
    });
});
const $6bae686b85f6a717$var$NextGenIssueTypesWrapperContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _vpnr1ejb _14tk72c6 _cb62utpp _1wtp1txs _l9o61txs _f6zi1txs",
            __cmplp.className
        ])
    });
});
const $6bae686b85f6a717$var$ExpandableProjectContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1osq _1wtppxbi _df5vpxbi",
            __cmplp.className
        ])
    });
});
const $6bae686b85f6a717$var$ShortCutsAndAppsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _14tk72c6 _t3zc183y _1so41gjq _1thc1skh _a6avqslr _dnyv1skh",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gkhxF", function(module, exports) {

$parcel$export(module.exports, "NestingMenuItem", () => $fac5addee1b29ecd$export$4c594f24f8e4128a);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $DW5A3 = parcelRequire("DW5A3");

var $7yWpW = parcelRequire("7yWpW");

var $dysGT = parcelRequire("dysGT");

var $dysoB = parcelRequire("dysoB");

var $8KWr1 = parcelRequire("8KWr1");

var $762yz = parcelRequire("762yz");
const $fac5addee1b29ecd$var$iconSecondaryColorCssVar = '--nesting-menu-item-icon-secondary-color';
const $fac5addee1b29ecd$var$styles = {
    backButtonThemeOverrides: "_18ljulk5 _ksbyulk5",
    customItem: "_4t3i1ady _vl7qglyw _slhpglyw _7upw1txw _1nrm18uv _1a3b18uv _1ydc18uv _c2wa1kw7 _4fpr1kw7 _1x281kw7 _1iohnqa1 _5goinqa1 _1726nqa1 _1q5t1r31 _nt751r31 _9nxe1r31 _1ohyglyw _49pcglyw _tpgfglyw _1r9xidpf _1hvwidpf _12gridpf"
};
const $fac5addee1b29ecd$var$WrappingLinkComponent = (props)=>/*#__PURE__*/ $eJOHy.createElement("a", props, props.children);
const $fac5addee1b29ecd$export$4c594f24f8e4128a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
    const theme = (0, $8KWr1.useSidebarTheme)();
    const iconSecondaryColor = theme?.navigation?.icon?.secondary?.color?.default;
    const { BackMenuItem: BackMenuItem = {} } = overrides;
    const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $eJOHy.Fragment), ...backItemProps } = BackMenuItem; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const renderBackItem = (0, $eJOHy.useCallback)(({ onClick: onClick })=>/*#__PURE__*/ $eJOHy.createElement(WrapperComponent, null, /*#__PURE__*/ $eJOHy.createElement((0, $dysoB.MenuItem), {
            ...backItemProps,
            analytics: {
                itemId: 'back'
            },
            iconBefore: /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($DW5A3))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: (ev)=>{
                if ((0, $762yz.isNormalClick)(ev)) {
                    onClick();
                    backItemProps.onClick?.(ev);
                }
            },
            // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
            style: {
                [$fac5addee1b29ecd$var$iconSecondaryColorCssVar]: iconSecondaryColor ?? undefined
            },
            className: (0, $hcewu.default)([
                iconSecondaryColor && $fac5addee1b29ecd$var$styles.backButtonThemeOverrides
            ])
        }, backTitle)), [
        WrapperComponent,
        backItemProps,
        backTitle,
        iconSecondaryColor
    ]);
    const renderCustomItem = (0, $eJOHy.useCallback)(({ children: itemTitle, onClick: onClick, className: className, ...props })=>/*#__PURE__*/ $eJOHy.createElement((0, $7yWpW.default), {
            ...props,
            id: id,
            component: reloadOnNavigationToNesting ? $fac5addee1b29ecd$var$WrappingLinkComponent : props.component,
            onClick: (ev)=>{
                // if nesting item already selected do not trigger route change
                if (props.isSelected === true) ev.preventDefault();
                onClick && onClick(ev);
            },
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            overrides: {
                GoBackItem: {
                    render: renderBackItem
                }
            },
            title: itemTitle,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
            className: (0, $hcewu.default)([
                $fac5addee1b29ecd$var$styles.customItem,
                className
            ])
        }, /*#__PURE__*/ $eJOHy.createElement((0, $dysGT.SidebarErrorBoundary), {
            id: `${id}Nesting`,
            packageName: "jiraSpaAppsSidebarCommon"
        }, children)), [
        children,
        id,
        reloadOnNavigationToNesting,
        renderBackItem
    ]);
    return /*#__PURE__*/ $eJOHy.createElement((0, $dysoB.MenuItem), {
        ...rest,
        ref: ref,
        overrides: {
            CustomItem: {
                render: renderCustomItem
            }
        }
    }, title);
});

});



parcelRegister("12LC2", function(module, exports) {

$parcel$export(module.exports, "SECTION_ID", () => $edeae68033ab1128$export$501955bd67991a25);
const $edeae68033ab1128$export$501955bd67991a25 = {
    MIGRATE_TO_CLOUD_SITE: 'migrate-to-cloud-site',
    PERFORMANCE_AND_SCALE: 'performance-and-scale'
};

});

parcelRegister("4nlI9", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $f7718e8cb9fac139$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", () => $f7718e8cb9fac139$export$f601efaceb0636f4);

var $eJOHy = parcelRequire("eJOHy");

var $dGS6y = parcelRequire("dGS6y");

var $jkijI = parcelRequire("jkijI");

var $8mNJo = parcelRequire("8mNJo");

var $lvKO5 = parcelRequire("lvKO5");

var $35kfd = parcelRequire("35kfd");
const $f7718e8cb9fac139$export$4a39035bacc4ed76 = (0, $jkijI.withThrowOnError)(()=>{
    const { data: data, loading: loading, error: error } = (0, $dGS6y.useNavigationGlobalResource)();
    const { isDevMode: isDevMode, isAdmin: isAdmin } = (0, $lvKO5.useTenantContext)();
    const extractedData = (0, $eJOHy.useMemo)(()=>data && (0, $35kfd.extractData)(data, isDevMode, isAdmin), [
        data,
        isDevMode,
        isAdmin
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
});
const $f7718e8cb9fac139$export$f601efaceb0636f4 = (0, $jkijI.withThrowOnError)((0, $8mNJo.useGlobalSettingsSystemConnectItems));

});
parcelRegister("dGS6y", function(module, exports) {

$parcel$export(module.exports, "useNavigationGlobalResource", () => $5ff6e79cef908460$export$1e1c317ed5b99faa);

var $eJOHy = parcelRequire("eJOHy");

var $enHI7 = parcelRequire("enHI7");

var $eJrcF = parcelRequire("eJrcF");
const $5ff6e79cef908460$export$1e1c317ed5b99faa = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)((0, $enHI7.navigationSidebarGlobalResource));
    const response = (0, $eJOHy.useMemo)(()=>data && data.response, [
        data
    ]);
    return {
        data: response,
        loading: loading,
        error: error
    };
};

});

parcelRegister("jkijI", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $8b058de70bdadedd$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $gRw8I = parcelRequire("gRw8I");
const $8b058de70bdadedd$var$isDataEmpty = (data)=>data == null;
function $8b058de70bdadedd$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $gRw8I.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $8b058de70bdadedd$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});

parcelRegister("8mNJo", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", () => $786134a7d6f046e9$export$f601efaceb0636f4);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $dGS6y = parcelRequire("dGS6y");

var $gCY1z = parcelRequire("gCY1z");

var $3uU3k = parcelRequire("3uU3k");

var $e4GDd = parcelRequire("e4GDd");

var $7Q6ai = parcelRequire("7Q6ai");
// use memoised functions per hook to avoid re-computation between same hooks
const $786134a7d6f046e9$var$getItemsMemo = (0, $LFmXM.default)((d)=>(0, $e4GDd.getLinks)(d, [
        'admin_system_menu'
    ], {
        skipFilter: true
    }).map((0, $7Q6ai.transformLink)).filter(Boolean));
const $786134a7d6f046e9$var$findItemAndStackMemo = (0, $LFmXM.default)((0, $3uU3k.findItemAndStack));
const $786134a7d6f046e9$export$f601efaceb0636f4 = ()=>{
    const [{ route: route, location: location }] = (0, $gCY1z.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $dGS6y.useNavigationGlobalResource)();
    const items = (0, $eJOHy.useMemo)(()=>data && $786134a7d6f046e9$var$getItemsMemo(data), [
        data
    ]);
    const found = (0, $eJOHy.useMemo)(()=>route && items && $786134a7d6f046e9$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});
parcelRegister("3uU3k", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $0c85a801882a0f1a$export$751e2e6237002565);

var $cSmYj = parcelRequire("cSmYj");

var $7ZUpE = parcelRequire("7ZUpE");
// JSPA-1062 remove qs items that might not always be there
const $0c85a801882a0f1a$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $0c85a801882a0f1a$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $0c85a801882a0f1a$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $7ZUpE.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $0c85a801882a0f1a$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $0c85a801882a0f1a$var$splitRelevantQs(itemQs);
        const sameQuery = $0c85a801882a0f1a$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $0c85a801882a0f1a$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});
parcelRegister("7ZUpE", function(module, exports) {

$parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", () => $fcdc4828e19c6025$export$a8aac2ba4dc1f57);
$parcel$export(module.exports, "CONNECT_ROUTES_SET", () => $fcdc4828e19c6025$export$c47bf667d3008c53);
$parcel$export(module.exports, "JSM_BOARD_ROUTES_SET", () => $fcdc4828e19c6025$export$50c2d6bcb0b94b74);
const $fcdc4828e19c6025$export$a8aac2ba4dc1f57 = new Set([
    'classic-business-overview-summary',
    'classic-business-overview-calendar',
    'classic-business-overview-timeline',
    'classic-business-overview-redirect'
]);
const $fcdc4828e19c6025$export$c47bf667d3008c53 = new Set([
    'connect-project',
    'connect-general',
    'connect-general-service-desk-project',
    'legacy-connect-project',
    'legacy-connect-general'
]);
const $fcdc4828e19c6025$export$50c2d6bcb0b94b74 = new Set([
    'servicedesk-boards',
    'servicedesk-queues-views-config',
    'servicedesk-practice-views-config'
]);

});


parcelRegister("e4GDd", function(module, exports) {

$parcel$export(module.exports, "getLinks", () => $f7606ddd2919ecd5$export$8054dcb2b42da45c);

var $5MqBz = parcelRequire("5MqBz");

var $9BLJ5 = parcelRequire("9BLJ5");
const $f7606ddd2919ecd5$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
    const acc = [];
    locations.forEach((location)=>{
        const links = (0, $5MqBz.getLinksFromSidebar)(sidebarConfig, location);
        if (omitSections === true) {
            // merge 2 arrays in good performance way
            Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
            return;
        }
        // merge 2 arrays in good performance way
        Array.prototype.push.apply(acc, links);
    });
    return acc.filter((item)=>{
        if (!item) return false;
        if (skipFilter === true) return true;
        const hasConnectPrefix = item.id && item.id.includes((0, $9BLJ5.connectPrefix));
        if (hasConnectPrefix) return true;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"sd-reports-addons" | "sd-queues-addons" | "com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent"'.
        const isConnectSection = (0, $9BLJ5.connectSections).includes(item.id);
        if (isConnectSection) return true;
        const isJsdConnectSection = item.id && item.id.includes((0, $9BLJ5.jsdConnectPrefix));
        if (isJsdConnectSection) return true;
        return false;
    });
};

});
parcelRegister("5MqBz", function(module, exports) {

$parcel$export(module.exports, "hasItemInSidebar", () => $6acdf3cbbe313a21$export$57dd40eec4c64521);
$parcel$export(module.exports, "getLinksFromSidebar", () => $6acdf3cbbe313a21$export$9b7e0e4dd8bfade8);
const $6acdf3cbbe313a21$var$findLink = (arrayOfLinks, legacyId, partialMatch = false)=>{
    if (!Array.isArray(arrayOfLinks)) return undefined;
    for(let i = 0; i < arrayOfLinks.length; i += 1){
        const link = arrayOfLinks[i];
        if (partialMatch && link.id.indexOf(legacyId) === 0) return link;
        if (link.id === legacyId) return link;
        if (link.links) {
            const linkFound = $6acdf3cbbe313a21$var$findLink(link.links, legacyId, partialMatch);
            if (linkFound) return linkFound;
        }
    }
    return undefined;
};
const $6acdf3cbbe313a21$export$f62346e9b1894488 = (sidebarConfig, legacyId, partialMatch = false)=>sidebarConfig && sidebarConfig.product && $6acdf3cbbe313a21$var$findLink(sidebarConfig.product.links, legacyId, partialMatch) || undefined;
const $6acdf3cbbe313a21$export$57dd40eec4c64521 = (sidebarConfig, legacyId, partialMatch)=>Boolean($6acdf3cbbe313a21$export$f62346e9b1894488(sidebarConfig, legacyId, partialMatch));
const $6acdf3cbbe313a21$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
        if (item.id === legacyId) return item.links;
        return item.links && $6acdf3cbbe313a21$var$findChildLinks(item.links, legacyId);
    }).find(Boolean);
const $6acdf3cbbe313a21$export$9b7e0e4dd8bfade8 = (sidebarConfig, legacyId)=>{
    const links = legacyId != null ? $6acdf3cbbe313a21$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
    return links || [];
};

});

parcelRegister("9BLJ5", function(module, exports) {

$parcel$export(module.exports, "connectPrefix", () => $37513bb0a469b460$export$196d83ebd873fb40);
$parcel$export(module.exports, "jsdConnectPrefix", () => $37513bb0a469b460$export$7fac8f726f52d70);
$parcel$export(module.exports, "connectSections", () => $37513bb0a469b460$export$b1c2c1fc5d10280);

var $eES78 = parcelRequire("eES78");
const $37513bb0a469b460$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
const $37513bb0a469b460$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
const $37513bb0a469b460$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const $37513bb0a469b460$var$jsdQueuesConnectSection = 'sd-queues-addons';
const $37513bb0a469b460$export$b1c2c1fc5d10280 = [
    $37513bb0a469b460$var$legacyAddonPanelLinkId,
    (0, $eES78.REPORTS_IDS).REPORTS_ADDONS,
    $37513bb0a469b460$var$jsdQueuesConnectSection
];

});


parcelRegister("7Q6ai", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $70bed4bda6f79222$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $70bed4bda6f79222$export$27267b6b6650eaa5);
const $70bed4bda6f79222$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($70bed4bda6f79222$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $70bed4bda6f79222$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($70bed4bda6f79222$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});


parcelRegister("35kfd", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $986afa50afdb72df$export$9df5fa0a366163d2);

var $5MqBz = parcelRequire("5MqBz");
const $986afa50afdb72df$export$9df5fa0a366163d2 = (data, isDevMode, isAdmin)=>({
        hasGeneralConfiguration: isAdmin,
        hasDarkFeatures: (0, $5MqBz.hasItemInSidebar)(data, 'dark_features'),
        hasTroubleshootingAndSupportSection: isAdmin,
        hasViewAuditing: isAdmin,
        hasPluginViewer: isDevMode && isAdmin,
        hasModulesViewer: isDevMode && isAdmin,
        hasSystemInfo: (0, $5MqBz.hasItemInSidebar)(data, 'system_info'),
        hasIntegrityChecker: (0, $5MqBz.hasItemInSidebar)(data, 'integrity_checker'),
        hasLoggingProfiling: (0, $5MqBz.hasItemInSidebar)(data, 'logging_profiling'),
        hasSchedulerDetails: (0, $5MqBz.hasItemInSidebar)(data, 'scheduler_details'),
        hasSecuritySection: isAdmin,
        hasProjectRoles: isAdmin,
        hasGlobalPermissions: isAdmin,
        hasCollectors: isAdmin,
        hasUserInterfaceSection: isAdmin,
        hasUserDefaults: isAdmin,
        hasEditDefaultDashboard: isAdmin,
        hasLookAndFeel: isAdmin,
        hasPasAdmin: (0, $5MqBz.hasItemInSidebar)(data, 'com.atlassian.pas:pas-admin-link-jira'),
        hasImportExportSection: isAdmin,
        hasBackupManager: isAdmin,
        hasExternalImport: isAdmin,
        hasRestoreSystem: (0, $5MqBz.hasItemInSidebar)(data, 'vertigo_import'),
        hasCloudImport: (0, $5MqBz.hasItemInSidebar)(data, 'vertigo_import_jira_cloud'),
        hasServerImport: (0, $5MqBz.hasItemInSidebar)(data, 'vertigo_import_jira_server'),
        hasMailSection: isAdmin,
        hasGlobalMailSettings: isAdmin,
        hasOutgoingMail: isAdmin,
        hasIncomingMail: isAdmin,
        hasSendMail: isAdmin,
        hasAdminHelperSection: isAdmin,
        hasPermissionHelper: isAdmin,
        hasSharedSection: isAdmin,
        hasManageDashboards: isAdmin,
        hasManageFilters: isAdmin,
        // advanced
        hasAdvancedSection: isAdmin,
        hasAttachments: isAdmin,
        hasEvents: isAdmin,
        hasWebHooks: isAdmin,
        hasServices: isAdmin,
        hasLexoRankManagement: (0, $5MqBz.hasItemInSidebar)(data, 'greenhopper-lexorank-manage')
    });

});


parcelRegister("jNN5t", function(module, exports) {

$parcel$export(module.exports, "AdminHelperSection", () => $284ed6edcc1285b8$export$4855b2d78f0d666a);

var $eJOHy = parcelRequire("eJOHy");

var $8wfPR = parcelRequire("8wfPR");

var $gbiVe = parcelRequire("gbiVe");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $7Tz5f = parcelRequire("7Tz5f");
var $5RrpQ = parcelRequire("5RrpQ");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $4nlI9 = parcelRequire("4nlI9");

var $jDVls = parcelRequire("jDVls");
const $284ed6edcc1285b8$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY = 'blocking-invitations-log-spotlight';
const $284ed6edcc1285b8$export$4855b2d78f0d666a = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5RrpQ.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tz5f.default), {
        title: formatMessage((0, $jDVls.default).adminHelper)
    }, features.hasPermissionHelper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'permission-helper'
        },
        href: navigationPath.adminHelperPermissionHelper,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $jDVls.default).permissionHelper)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), {
        name: $284ed6edcc1285b8$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'email-notifications-log'
        },
        href: navigationPath.adminHelperEmailNotificationsLogHelper,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $284ed6edcc1285b8$var$emailNotificationsLogContainerStyles
    }, formatMessage((0, $jDVls.default).adminEmailAuditNotificationsLog))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wfPR.EngagementSpotlight), {
        engagementId: $284ed6edcc1285b8$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
    })));
};
const $284ed6edcc1285b8$var$emailNotificationsLogContainerStyles = (0, $5Wv5g.xcss)({
    display: 'flex',
    justifyContent: 'space-between'
});

});
parcelRegister("jDVls", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca6b4330674f0b26$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ca6b4330674f0b26$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    adminHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-helper",
        "defaultMessage": "Admin helper"
    },
    permissionHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.permission-helper",
        "defaultMessage": "Permission helper"
    },
    adminEmailAuditNotificationsLog: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-email-audit-notifications-log",
        "defaultMessage": "Admin email audit"
    }
});

});


parcelRegister("984NX", function(module, exports) {

$parcel$export(module.exports, "AdvancedSection", () => $31c218580cdf3392$export$32bea920eaad7efb);

var $eJOHy = parcelRequire("eJOHy");

var $7Tz5f = parcelRequire("7Tz5f");
var $5RrpQ = parcelRequire("5RrpQ");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $4nlI9 = parcelRequire("4nlI9");

var $53NWI = parcelRequire("53NWI");
const $31c218580cdf3392$export$32bea920eaad7efb = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5RrpQ.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tz5f.default), {
        title: formatMessage((0, $53NWI.default).advanced)
    }, features.hasAttachments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'attachments'
        },
        href: navigationPath.advancedSectionAttachments,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $53NWI.default).attachments)), features.hasEvents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'events'
        },
        href: navigationPath.advancedSectionEvents,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $53NWI.default).events)), features.hasWebHooks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'webhooks'
        },
        href: navigationPath.advancedSectionWebHooks,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $53NWI.default).webhooks)), features.hasLexoRankManagement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'lexorank-management'
        },
        href: navigationPath.advancedLexoRankManagement,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $53NWI.default).lexorankManagement)));
};

});
parcelRegister("53NWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $09c752d73d743455$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $09c752d73d743455$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    advanced: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.advanced",
        "defaultMessage": "Advanced"
    },
    attachments: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.attachments",
        "defaultMessage": "Attachments"
    },
    events: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.events",
        "defaultMessage": "Events"
    },
    webhooks: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.webhooks",
        "defaultMessage": "WebHooks"
    },
    lexorankManagement: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.lexorank-management",
        "defaultMessage": "LexoRank management"
    }
});

});


parcelRegister("biIRA", function(module, exports) {

$parcel$export(module.exports, "AutomationSection", () => $25640454f6bfc0ee$export$5fa01e4d25d8e6ec);

var $eJOHy = parcelRequire("eJOHy");

var $7Tz5f = parcelRequire("7Tz5f");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $5GHeW = parcelRequire("5GHeW");
const $25640454f6bfc0ee$export$5fa01e4d25d8e6ec = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tz5f.default), {
        title: formatMessage((0, $5GHeW.default).automationGroup)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        href: navigationPath.globalAutomation,
        selectedOn: [
            'global-automation'
        ]
    }, formatMessage((0, $5GHeW.default).globalAutomation)));
};

});
parcelRegister("5GHeW", function(module, exports) {

$parcel$export(module.exports, "default", () => $acf7c280d3e158e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $acf7c280d3e158e4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    automationGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.automation.automation-group",
        "defaultMessage": "Automation"
    },
    globalAutomation: {
        "id": "spa-apps-sidebar-global-settings-system.menu.automation.global-automation",
        "defaultMessage": "Global automation"
    }
});

});


parcelRegister("cQl3U", function(module, exports) {

$parcel$export(module.exports, "ImportExportSection", () => $b91ddb39621dbc16$export$2e4cb1dc5b398447);

var $eJOHy = parcelRequire("eJOHy");

var $7Tz5f = parcelRequire("7Tz5f");
var $5RrpQ = parcelRequire("5RrpQ");

var $ln6Iy = parcelRequire("ln6Iy");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $lvKO5 = parcelRequire("lvKO5");

var $4nlI9 = parcelRequire("4nlI9");

var $jmET1 = parcelRequire("jmET1");
const $b91ddb39621dbc16$export$2e4cb1dc5b398447 = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { licensedProducts: licensedProducts } = (0, $lvKO5.useTenantContext)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5RrpQ.default), null);
    const hasSupportedLicense = licensedProducts[(0, $ln6Iy.projectTypeToCanonicalId)((0, $ln6Iy.SOFTWARE_PROJECT))] || licensedProducts[(0, $ln6Iy.projectTypeToCanonicalId)((0, $ln6Iy.CORE_PROJECT))];
    const showNewExternalImport = hasSupportedLicense;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tz5f.default), {
        title: formatMessage((0, $jmET1.default).importExportGroup)
    }, features.hasBackupManager && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'cloud-export'
        },
        href: navigationPath.importSectionBackupManager,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $jmET1.default).backupManager)), features.hasExternalImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'external-import'
        },
        href: showNewExternalImport ? navigationPath.importSectionExternalImportNew : navigationPath.importSectionExternalImport,
        selectedOn: (currentLocation, itemLocation)=>(0, $8xDPn.matchUrlExact)()(currentLocation, itemLocation) || showNewExternalImport && currentLocation.pathname.includes(navigationPath.importSectionExternalImport)
    }, formatMessage((0, $jmET1.default).externalImport)), features.hasCloudImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'cloud-import'
        },
        href: navigationPath.importSectionCloudImport,
        selectedOn: (0, $8xDPn.matchUrlExact)()
    }, formatMessage((0, $jmET1.default).importJiraCloud)), features.hasServerImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'server-import'
        },
        href: navigationPath.importSectionServerImport,
        selectedOn: (0, $8xDPn.matchUrlExact)()
    }, formatMessage((0, $jmET1.default).importJiraServer)));
};

});
parcelRegister("jmET1", function(module, exports) {

$parcel$export(module.exports, "default", () => $80a0b82ad0592101$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $80a0b82ad0592101$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    importExportGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-export-group",
        "defaultMessage": "Import and export"
    },
    backupManager: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.backup-manager",
        "defaultMessage": "Backup manager"
    },
    externalImport: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.external-import",
        "defaultMessage": "External System Import"
    },
    restoreSystem: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.restore-system",
        "defaultMessage": "Restore system"
    },
    importJiraCloud: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-cloud",
        "defaultMessage": "Import Jira Cloud"
    },
    importJiraServer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-server",
        "defaultMessage": "Import Jira Server"
    }
});

});


parcelRegister("013X4", function(module, exports) {

$parcel$export(module.exports, "MailSection", () => $6d5aa7476d5021b7$export$6e0cda39522c0aa7);

var $eJOHy = parcelRequire("eJOHy");

var $7Tz5f = parcelRequire("7Tz5f");
var $5RrpQ = parcelRequire("5RrpQ");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $4nlI9 = parcelRequire("4nlI9");

var $dtZZt = parcelRequire("dtZZt");

var $5v2Rk = parcelRequire("5v2Rk");
const $6d5aa7476d5021b7$export$6e0cda39522c0aa7 = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5RrpQ.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tz5f.default), {
        title: formatMessage((0, $dtZZt.default).mailGroup)
    }, features.hasGlobalMailSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'global-mail-settings'
        },
        href: navigationPath.mailSectionGlobalMailSettings,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $dtZZt.default).globalMailSettings)), features.hasOutgoingMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'outgoing-mail'
        },
        href: navigationPath.mailSectionOutgoingMail,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $dtZZt.default).outgoingMail)), features.hasIncomingMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'incoming-mail'
        },
        href: navigationPath.mailSectionIncomingMail,
        selectedOn: (0, $5v2Rk.isIncomingMailSelected)
    }, formatMessage((0, $dtZZt.default).incomingMail)), features.hasSendMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'send-email'
        },
        href: navigationPath.mailSectionSendMail,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $dtZZt.default).sendEmail)));
};

});
parcelRegister("dtZZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed6dc523930ca679$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ed6dc523930ca679$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    mailGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.mail-group",
        "defaultMessage": "Mail"
    },
    globalMailSettings: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.global-mail-settings",
        "defaultMessage": "Global Mail Settings"
    },
    outgoingMail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.outgoing-mail",
        "defaultMessage": "Outgoing Mail"
    },
    incomingMail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.incoming-mail",
        "defaultMessage": "Incoming Mail"
    },
    sendEmail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.send-email",
        "defaultMessage": "Send email"
    }
});

});

parcelRegister("5v2Rk", function(module, exports) {

$parcel$export(module.exports, "isIncomingMailSelected", () => $8a4849689084cd66$export$3f53f72603975cb0);

var $8xDPn = parcelRequire("8xDPn");
const $8a4849689084cd66$var$INCOMING_MAIL_PATH_REGEXP = /\/admin\/(\w+)Pop(Mail)?Server/i;
const $8a4849689084cd66$export$3f53f72603975cb0 = (currentLocation, itemLocation)=>(0, $8xDPn.matchUrlExact)()(currentLocation, itemLocation) || $8a4849689084cd66$var$INCOMING_MAIL_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("kgYBH", function(module, exports) {

$parcel$export(module.exports, "default", () => $fab742a91d22043b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fab742a91d22043b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    systemGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.system-group",
        "defaultMessage": "System settings"
    },
    generalConfiguration: {
        "id": "spa-apps-sidebar-global-settings-system.menu.general-configuration",
        "defaultMessage": "General configuration"
    },
    darkFeatures: {
        "id": "spa-apps-sidebar-global-settings-system.menu.dark-features",
        "defaultMessage": "Dark features"
    },
    issueCollectors: {
        "id": "spa-apps-sidebar-global-settings-system.menu.issue-collectors",
        "defaultMessage": "Issue collectors"
    },
    globalSettingsSystemSidebarLabel: {
        "id": "spa-apps-sidebar-global-settings-system.menu.global-settings-system-sidebar-label",
        "defaultMessage": "Sidebar"
    },
    issueCollectorsIssueTermRefresh: {
        "id": "spa-apps-sidebar-global-settings-system.menu.issue-collectors-issue-term-refresh",
        "defaultMessage": "Work item collectors"
    }
});

});

parcelRegister("km8c0", function(module, exports) {

$parcel$export(module.exports, "SecuritySection", () => $2de52b30b3079886$export$4f16aec1633bed7d);

var $eJOHy = parcelRequire("eJOHy");

var $7Tz5f = parcelRequire("7Tz5f");
var $5RrpQ = parcelRequire("5RrpQ");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $4nlI9 = parcelRequire("4nlI9");

var $7EtzP = parcelRequire("7EtzP");

var $8EV7W = parcelRequire("8EV7W");
const $2de52b30b3079886$export$4f16aec1633bed7d = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5RrpQ.default), null);
    const globalPermissionsPath = navigationPath.securityGlobalPermissions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tz5f.default), {
        title: formatMessage((0, $7EtzP.default).securityGroup)
    }, features.hasProjectRoles && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'project-roles'
        },
        href: navigationPath.securityProjectRoles,
        selectedOn: (0, $8EV7W.isProjectRolesSelected)
    }, formatMessage((0, $7EtzP.default).projectRoles)), features.hasGlobalPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'global-permissions'
        },
        href: globalPermissionsPath,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $7EtzP.default).globalPermissions)));
};

});
parcelRegister("7EtzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdb8303b45d710f6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fdb8303b45d710f6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    securityGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.security-group",
        "defaultMessage": "Security"
    },
    projectRoles: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.project-roles",
        "defaultMessage": "Project roles"
    },
    globalPermissions: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.global-permissions",
        "defaultMessage": "Global permissions"
    }
});

});

parcelRegister("8EV7W", function(module, exports) {

$parcel$export(module.exports, "isProjectRolesSelected", () => $ff731d2affade8a4$export$ca9501e7fedfce90);

var $8xDPn = parcelRequire("8xDPn");
const $ff731d2affade8a4$var$PROJECT_ROLES_PATH_REGEXP = /\/project\/(\w+)ProjectRole/i;
const $ff731d2affade8a4$export$ca9501e7fedfce90 = (currentLocation, itemLocation)=>(0, $8xDPn.matchUrlExact)()(currentLocation, itemLocation) || $ff731d2affade8a4$var$PROJECT_ROLES_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("gg4FC", function(module, exports) {

$parcel$export(module.exports, "SharedSection", () => $05fba404380a8e8d$export$230e518497f06fdc);

var $eJOHy = parcelRequire("eJOHy");

var $7Tz5f = parcelRequire("7Tz5f");
var $5RrpQ = parcelRequire("5RrpQ");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $4nlI9 = parcelRequire("4nlI9");

var $8c9sn = parcelRequire("8c9sn");
const $05fba404380a8e8d$export$230e518497f06fdc = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5RrpQ.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tz5f.default), {
        title: formatMessage((0, $8c9sn.default).sharedItems)
    }, features.hasManageFilters && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'manage-filters'
        },
        href: navigationPath.sharedSectionManageFilters,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $8c9sn.default).filters)), features.hasManageDashboards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'manage-dashboards'
        },
        href: navigationPath.sharedManageDashboards,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $8c9sn.default).dashboards)));
};

});
parcelRegister("8c9sn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0f4d97db1c45217$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a0f4d97db1c45217$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    sharedItems: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-items",
        "defaultMessage": "Shared Items"
    },
    sharedFilters: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-filters",
        "defaultMessage": "Shared filters"
    },
    sharedDashboards: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-dashboards",
        "defaultMessage": "Shared dashboards"
    },
    filters: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.dashboards",
        "defaultMessage": "Dashboards"
    }
});

});


parcelRegister("8mGF5", function(module, exports) {

$parcel$export(module.exports, "TroubleshootingAndSupportSection", () => $cf60a611cf5d4781$export$dad01649916e6a2d);

var $eJOHy = parcelRequire("eJOHy");

var $7Tz5f = parcelRequire("7Tz5f");
var $5RrpQ = parcelRequire("5RrpQ");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $bxtyM = parcelRequire("bxtyM");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $4nlI9 = parcelRequire("4nlI9");

var $3jVDS = parcelRequire("3jVDS");

var $3NDiG = parcelRequire("3NDiG");

var $4cBUk = parcelRequire("4cBUk");
const $cf60a611cf5d4781$export$dad01649916e6a2d = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { hasSiteOptimizerEntitlement: hasSiteOptimizerEntitlement } = (0, $bxtyM.useSiteOptimizerCheck)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5RrpQ.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tz5f.default), {
        title: formatMessage((0, $3jVDS.default).troubleshootingGroup)
    }, features.hasViewAuditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'view-auditing'
        },
        href: navigationPath.troubleshootingAuditLog,
        selectedOn: (0, $4cBUk.isViewAuditingSelected)
    }, formatMessage((0, $3jVDS.default).auditLog)), features.hasPluginViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'plugin-viewer'
        },
        href: navigationPath.troubleshootingPluginViewer,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $3jVDS.default).pluginViewer)), features.hasModulesViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'modules-viewer'
        },
        href: navigationPath.troubleshootingModulesViewer,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $3jVDS.default).modulesViewer)), features.hasSystemInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'system-info'
        },
        href: navigationPath.troubleshootingSystemInfo,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $3jVDS.default).systemInfo)), features.hasIntegrityChecker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'integrity-checker'
        },
        href: navigationPath.troubleshootingIntegrityChecker,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $3jVDS.default).integrityChecker)), features.hasLoggingProfiling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'logging-profiling'
        },
        href: navigationPath.troubleshootingLoggingProfiling,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $3jVDS.default).loggingProfiling)), features.hasSchedulerDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'scheduler-details'
        },
        href: navigationPath.troubleshootingSchedulerDetails,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $3jVDS.default).schedulerDetails)), hasSiteOptimizerEntitlement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3NDiG.PerformanceMenuItem), null));
};

});
parcelRegister("bxtyM", function(module, exports) {

$parcel$export(module.exports, "useSiteOptimizerCheck", () => $8a287a8fe16adf8c$export$7df80afc329cd61);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $jGzN3 = parcelRequire("jGzN3");
const $8a287a8fe16adf8c$export$e9921a980669184 = ()=>(0, $jGzN3.performGetRequest)('/rest/internal/psi/latest/licence/check');
const $8a287a8fe16adf8c$export$7df80afc329cd61 = ()=>{
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const [hasEntitlement, setHasEntitlement] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)();
    const fetch = async ()=>{
        try {
            setLoading(true);
            setError(undefined);
            if ((0, $7jTnu.fg)('override-enable-performance-and-scale-admin-menu')) setHasEntitlement(true);
            else {
                const data = await $8a287a8fe16adf8c$export$e9921a980669184();
                setHasEntitlement(data?.isVisible ?? false);
            }
            setLoading(false);
        } catch (apiError) {
            setLoading(false);
            setError(apiError);
        }
    };
    (0, $eJOHy.useEffect)(()=>{
        fetch();
    }, []);
    return {
        loading: loading,
        hasSiteOptimizerEntitlement: hasEntitlement,
        error: error
    };
};

});

parcelRegister("3jVDS", function(module, exports) {

$parcel$export(module.exports, "default", () => $52beb7cb400b52c2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $52beb7cb400b52c2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    troubleshootingGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.troubleshooting-group",
        "defaultMessage": "Troubleshooting and Support"
    },
    auditLog: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.audit-log",
        "defaultMessage": "Audit Log"
    },
    pluginViewer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.plugin-viewer",
        "defaultMessage": "Plugin Viewer"
    },
    modulesViewer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.modules-viewer",
        "defaultMessage": "Modules Viewer"
    },
    systemInfo: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.system-info",
        "defaultMessage": "System info"
    },
    integrityChecker: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.integrity-checker",
        "defaultMessage": "Integrity checker"
    },
    loggingProfiling: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.logging-profiling",
        "defaultMessage": "Logging profiling"
    },
    schedulerDetails: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.scheduler-details",
        "defaultMessage": "Scheduler details"
    }
});

});

parcelRegister("3NDiG", function(module, exports) {

$parcel$export(module.exports, "PerformanceMenuItem", () => $6fc2f116c407bd92$export$b4e98631ff0b3fb5);

var $eJOHy = parcelRequire("eJOHy");

var $6alcT = parcelRequire("6alcT");

var $hZUwi = parcelRequire("hZUwi");
var $gbiVe = parcelRequire("gbiVe");
var $REcGP = parcelRequire("REcGP");

var $dhRXV = parcelRequire("dhRXV");
var $gPqEA = parcelRequire("gPqEA");

var $lRq8t = parcelRequire("lRq8t");

var $gkhxF = parcelRequire("gkhxF");

var $gp9Js = parcelRequire("gp9Js");

var $gCeeo = parcelRequire("gCeeo");

var $9HHOs = parcelRequire("9HHOs");

var $8q7lT = parcelRequire("8q7lT");

var $12LC2 = parcelRequire("12LC2");

var $fuICN = parcelRequire("fuICN");

var $fKDY2 = parcelRequire("fKDY2");

var $3nYWL = parcelRequire("3nYWL");
const $6fc2f116c407bd92$export$b4e98631ff0b3fb5 = ()=>{
    const accountId = (0, $8q7lT.useAccountId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOptimiserSpotlightActive, setIsOptimiserSpotlightActive] = (0, $eJOHy.useState)(false);
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    const BackMenuItem = {
        href: '/jira/settings/system/general-configuration',
        title: formatMessage((0, $fuICN.default).itemBack)
    };
    const fetchSpotlightState = (0, $eJOHy.useCallback)(async ()=>{
        if (accountId != null) {
            const response = await (0, $3nYWL.hasSeenSiteOptimiserSpotlight)(accountId);
            setIsOptimiserSpotlightActive(!response);
        }
    }, [
        accountId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchSpotlightState();
    }, [
        fetchSpotlightState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hZUwi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), {
        name: "site-optimiser-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gkhxF.NestingMenuItem), {
        analytics: {
            itemId: 'performance-and-scale'
        },
        href: navigationPath.troubleshootingPerformanceAndScale,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPqEA.default), {
            gap: "space.050",
            justifyContent: "start",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), null, formatMessage((0, $fuICN.default).performanceAndScale)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
            appearance: "new"
        }, formatMessage((0, $fuICN.default).beta))),
        overrides: {
            BackMenuItem: BackMenuItem
        },
        id: (0, $12LC2.SECTION_ID).PERFORMANCE_AND_SCALE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKDY2.PerformanceAndScaleMenu), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $REcGP.default), null, isOptimiserSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), {
        actions: [
            {
                onClick: (_, analyticsEvent)=>{
                    setIsOptimiserSpotlightActive(false);
                    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'performanceMenuItemSpotlightComplete');
                },
                text: formatMessage((0, $fuICN.default).spotlightAction)
            }
        ],
        heading: formatMessage((0, $fuICN.default).spotlightHeading),
        target: "site-optimiser-spotlight",
        key: "site-optimiser-spotlight",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "right top",
        messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.jira-spotlight.site-optimiser-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $fuICN.default).spotlightBody))));
};

});
parcelRegister("fuICN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1499884aa597ea7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d1499884aa597ea7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    performanceAndScale: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale",
        "defaultMessage": "Site optimizer"
    },
    itemBack: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.item-back",
        "defaultMessage": "Back to system"
    },
    spotlightHeading: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-heading",
        "defaultMessage": "Clean up your site"
    },
    spotlightBody: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-body",
        "defaultMessage": "Remove old data that might be slowing down your site in a few clicks."
    },
    spotlightAction: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-action",
        "defaultMessage": "Ok"
    },
    beta: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.beta",
        "defaultMessage": "Beta"
    }
});

});

parcelRegister("fKDY2", function(module, exports) {

$parcel$export(module.exports, "PerformanceAndScaleMenu", () => $ba767faeb08b2c25$export$442d4ccb0d25fc50);

var $eJOHy = parcelRequire("eJOHy");

var $5gcb9 = parcelRequire("5gcb9");

var $6PSjY = parcelRequire("6PSjY");

var $7Tz5f = parcelRequire("7Tz5f");

var $gbiVe = parcelRequire("gbiVe");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $8kc2T = parcelRequire("8kc2T");

var $8xDPn = parcelRequire("8xDPn");

var $dGzlS = parcelRequire("dGzlS");

var $967Ue = parcelRequire("967Ue");
const $ba767faeb08b2c25$export$442d4ccb0d25fc50 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const basePerformanceUrl = '/jira/settings/system/performance';
    const allVisibleMetrics = (0, $6PSjY.getAllVisibleMetrics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8kc2T.TitleHeader), null, formatMessage((0, $dGzlS.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tz5f.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'performance-overview'
        },
        selectedOn: (0, $8xDPn.matchUrlPathname)(),
        href: `${basePerformanceUrl}/overview`
    }, formatMessage((0, $dGzlS.default).overview))), allVisibleMetrics.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tz5f.default), {
        title: formatMessage((0, $dGzlS.default).allReports)
    }, allVisibleMetrics.map((metric)=>{
        if (metric.key === (0, $5gcb9.PROJECT_CLEANUP_KEY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
            key: "project-cleanup-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), {
            name: (0, $967Ue.PROJECT_CLEANUP_SPOTLIGHT_NAME)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
            analytics: {
                itemId: `performance-metric-${metric.key}`
            },
            href: `${basePerformanceUrl}/metrics/${metric.key}`,
            selectedOn: (0, $8xDPn.matchUrlPathname)(),
            key: metric.key
        }, formatMessage(metric.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $967Ue.ProjectCleanupSpotlight), null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
            analytics: {
                itemId: `performance-metric-${metric.key}`
            },
            href: `${basePerformanceUrl}/metrics/${metric.key}`,
            selectedOn: (0, $8xDPn.matchUrlPathname)(),
            key: metric.key
        }, formatMessage(metric.name));
    })));
};

});
parcelRegister("5gcb9", function(module, exports) {

$parcel$export(module.exports, "PROJECT_CLEANUP_KEY", () => $74e8a104d2c69b31$export$4e9bf1d386c2f0c);
$parcel$export(module.exports, "PROJECT_CLEANUP", () => $74e8a104d2c69b31$export$761acf34bef3a717);

var $7qGN1 = parcelRequire("7qGN1");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $74e8a104d2c69b31$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $74e8a104d2c69b31$var$DESCRIPTION_DESC = 'Description of the site optimizer metric.';
const $74e8a104d2c69b31$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $74e8a104d2c69b31$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $74e8a104d2c69b31$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $74e8a104d2c69b31$var$CLEANUP_VALUE_LABEL_DESC = 'Label to be shown next to the cleanup value of the metric.';
const $74e8a104d2c69b31$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $74e8a104d2c69b31$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
const $74e8a104d2c69b31$var$messages = (0, $7qGN1.defineMessages)({
    nameNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.name-non-final",
        "defaultMessage": "Projects"
    },
    descriptionNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.description-non-final",
        "defaultMessage": "Below, we\u2019ve identified company-managed and team-managed projects in your site that can be archived or trashed because they contain no issues. Removing these projects can improve site performance and stability."
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.project-cleanup.recommendation-url-text",
        "defaultMessage": "See how we identify these projects."
    },
    analysisNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.analysis-non-final",
        "defaultMessage": "Analysis"
    },
    activityLogNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.activity-log-non-final",
        "defaultMessage": "Activity log"
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
        "defaultMessage": "Projects over time"
    },
    warningNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.warning-non-final",
        "defaultMessage": "The number of projects is nearing our recommended threshold."
    },
    exceededNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.exceeded-non-final",
        "defaultMessage": "There are some project..."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.project-cleanup.current-value-label",
        "defaultMessage": "Projects in your site"
    },
    cleanupValueLabel: {
        "id": "admin-pages-performance.common.assets.project-cleanup.cleanup-value-label",
        "defaultMessage": "Recommended for cleanup"
    }
});
const $74e8a104d2c69b31$export$4e9bf1d386c2f0c = 'projectcleanup';
const $74e8a104d2c69b31$export$761acf34bef3a717 = {
    key: $74e8a104d2c69b31$export$4e9bf1d386c2f0c,
    visible: true,
    name: $74e8a104d2c69b31$var$messages.nameNonFinal,
    description: $74e8a104d2c69b31$var$messages.descriptionNonFinal,
    tabLabels: [
        $74e8a104d2c69b31$var$messages.analysisNonFinal,
        $74e8a104d2c69b31$var$messages.activityLogNonFinal
    ],
    warningMessage: $74e8a104d2c69b31$var$messages.warningNonFinal,
    exceededMessage: $74e8a104d2c69b31$var$messages.exceededNonFinal,
    risks: [],
    mitigations: [],
    currentValueLabel: $74e8a104d2c69b31$var$messages.currentValueLabel,
    cleanupValueLabel: $74e8a104d2c69b31$var$messages.cleanupValueLabel,
    graphHeader: $74e8a104d2c69b31$var$messages.graphHeader,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-the-number-of-projects-in-your-site/',
    recommendationUrlText: $74e8a104d2c69b31$var$messages.recommendationUrlText
};

});

parcelRegister("6PSjY", function(module, exports) {

$parcel$export(module.exports, "getAllVisibleMetrics", () => $09c96fe29690b84b$export$e6140fda06493d18);
$parcel$export(module.exports, "getMetric", () => $09c96fe29690b84b$export$ed0dc1178a679c67);
$parcel$export(module.exports, "getAllVisibleMetricKeys", () => $09c96fe29690b84b$export$1f2abf3e170d35d2);
$parcel$export(module.exports, "assertNever", () => $09c96fe29690b84b$export$cbadc5a7223772a8);
$parcel$export(module.exports, "TooltipMap", () => $09c96fe29690b84b$export$9bd9f2d76c500145);
$parcel$export(module.exports, "getUrl", () => $09c96fe29690b84b$export$94df0e59ebebf4a7);

var $i1RZI = parcelRequire("i1RZI");

var $dXGYg = parcelRequire("dXGYg");

var $jNYkJ = parcelRequire("jNYkJ");

var $5gcb9 = parcelRequire("5gcb9");

var $kbtrL = parcelRequire("kbtrL");

var $j1zBH = parcelRequire("j1zBH");
class $09c96fe29690b84b$export$9419457073a1750 {
    constructor(metrics){
        this.metrics = metrics;
    }
    getMetric(key) {
        return this.metrics.find((m)=>m.key === key);
    }
    getAllVisibleMetrics() {
        return this.metrics.filter((metric)=>metric.visible && $09c96fe29690b84b$var$mitigationEnabled(metric.key));
    }
    getAllVisibleMetricsKeys() {
        return $09c96fe29690b84b$export$e6140fda06493d18().map((m)=>m.key);
    }
}
/**
 * Metric registry singleton. We should not be creating another registry.
 */ const $09c96fe29690b84b$var$REGISTRY = new $09c96fe29690b84b$export$9419457073a1750((0, $j1zBH.METRICS));
const $09c96fe29690b84b$export$ed0dc1178a679c67 = $09c96fe29690b84b$var$REGISTRY.getMetric.bind($09c96fe29690b84b$var$REGISTRY);
const $09c96fe29690b84b$export$e6140fda06493d18 = $09c96fe29690b84b$var$REGISTRY.getAllVisibleMetrics.bind($09c96fe29690b84b$var$REGISTRY);
const $09c96fe29690b84b$export$1f2abf3e170d35d2 = $09c96fe29690b84b$var$REGISTRY.getAllVisibleMetricsKeys.bind($09c96fe29690b84b$var$REGISTRY);
const $09c96fe29690b84b$var$mitigationEnabled = (metricKey)=>{
    switch(metricKey){
        case 0, $5gcb9.PROJECT_CLEANUP_KEY:
        case 0, $kbtrL.PROJECT_ROLE_ACTOR_KEY:
        case 0, $dXGYg.CUSTOM_FIELDS_KEY:
        case 0, $jNYkJ.ISSUE_KEY:
            return true;
        default:
            return false;
    }
};
const $09c96fe29690b84b$export$cbadc5a7223772a8 = (_, message)=>{
    throw new Error(message);
};
const $09c96fe29690b84b$export$9bd9f2d76c500145 = {
    [(0, $dXGYg.CUSTOM_FIELDS_KEY)]: (0, $i1RZI.CustomFieldsTooltip)
};
const $09c96fe29690b84b$export$94df0e59ebebf4a7 = (metric)=>`metrics/${metric.key}`;

});
parcelRegister("i1RZI", function(module, exports) {

$parcel$export(module.exports, "CustomFieldsTooltip", () => $380062244592d177$export$9a2f1f96cf156e26);

var $jRWWM = parcelRequire("jRWWM");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $i7XOj = parcelRequire("i7XOj");

var $dhRXV = parcelRequire("dhRXV");

var $9JB3T = parcelRequire("9JB3T");
var $4ZSsl = parcelRequire("4ZSsl");

var $lRq8t = parcelRequire("lRq8t");

var $kjMQ3 = parcelRequire("kjMQ3");
const $380062244592d177$var$CustomTooltip = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, ...rest }, ref)=>{
    return /*#__PURE__*/ $eJOHy.createElement((0, $4ZSsl.default), {
        ...rest,
        ref: ref,
        className: (0, $hcewu.default)([
            $380062244592d177$var$styles.tooltipStyles
        ])
    }, children);
});
const $380062244592d177$export$9a2f1f96cf156e26 = ({ children: children, dataRef: dataRef, metricState: metricState })=>{
    const { resourceUsageMetricV2: metricUsageData } = (0, $j4oe4.useFragment)((0, $jRWWM.default), dataRef);
    if (metricUsageData === null || metricUsageData === undefined) return null;
    const customFieldsCount = {
        globalScopedCustomFieldsCount: metricUsageData.globalScopedCustomFieldsCount,
        projectScopedCustomFieldsCount: metricUsageData.projectScopedCustomFieldsCount
    };
    const customFieldsCountLabels = {
        globalScopedCustomFieldsCountLabel: (0, $kjMQ3.default).globalScopedCustomFieldsCountLabel,
        projectScopedCustomFieldsCountLabel: (0, $kjMQ3.default).projectScopedCustomFieldsCountLabel,
        globalScopedCustomFieldsCountAriaLabel: (0, $kjMQ3.default).globalScopedCustomFieldsCountAriaLabel,
        projectScopedCustomFieldsCountArialLabel: (0, $kjMQ3.default).projectScopedCustomFieldsCountAriaLabel
    };
    return /*#__PURE__*/ $eJOHy.createElement((0, $9JB3T.default), {
        content: /*#__PURE__*/ $eJOHy.createElement($380062244592d177$var$CustomFieldsTooltipContent, {
            customFieldsCount: customFieldsCount,
            customFieldsCountLabels: customFieldsCountLabels,
            metricState: metricState
        }),
        component: $380062244592d177$var$CustomTooltip
    }, children);
};
const $380062244592d177$var$CustomFieldsTooltipContent = ({ customFieldsCount: customFieldsCount, customFieldsCountLabels: customFieldsCountLabels, metricState: metricState })=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $lRq8t.default)();
    const { globalScopedCustomFieldsCount: globalScopedCustomFieldsCount, projectScopedCustomFieldsCount: projectScopedCustomFieldsCount } = customFieldsCount;
    const { globalScopedCustomFieldsCountLabel: globalScopedCustomFieldsCountLabel, projectScopedCustomFieldsCountLabel: projectScopedCustomFieldsCountLabel, globalScopedCustomFieldsCountAriaLabel: globalScopedCustomFieldsCountAriaLabel, projectScopedCustomFieldsCountArialLabel: projectScopedCustomFieldsCountArialLabel } = customFieldsCountLabels;
    return /*#__PURE__*/ $eJOHy.createElement((0, $dhRXV.default), {
        xcss: $380062244592d177$var$styles.numbersContainer
    }, globalScopedCustomFieldsCount != null && globalScopedCustomFieldsCountLabel && /*#__PURE__*/ $eJOHy.createElement((0, $dhRXV.default), {
        xcss: $380062244592d177$var$styles.numberContainer,
        tabIndex: 0,
        "aria-label": globalScopedCustomFieldsCountAriaLabel ? formatMessage(globalScopedCustomFieldsCountAriaLabel, {
            number: formatNumber(globalScopedCustomFieldsCount)
        }) : undefined
    }, /*#__PURE__*/ $eJOHy.createElement((0, $dhRXV.default), {
        xcss: (0, $i7XOj.cx)(metricState === 'none' && $380062244592d177$var$styles.successNumber, metricState === 'warning' && $380062244592d177$var$styles.warningNumber, metricState === 'exceeded' && $380062244592d177$var$styles.errorNumber, $380062244592d177$var$styles.fontWeightStyles),
        "aria-describedby": "global-scoped-custom-fields-count-desc"
    }, formatNumber(globalScopedCustomFieldsCount)), /*#__PURE__*/ $eJOHy.createElement((0, $dhRXV.default), {
        xcss: $380062244592d177$var$styles.textContainer
    }, /*#__PURE__*/ $eJOHy.createElement("small", {
        id: "global-scoped-custom-fields-count-desc"
    }, formatMessage(globalScopedCustomFieldsCountLabel)))), projectScopedCustomFieldsCount != null && projectScopedCustomFieldsCountLabel && /*#__PURE__*/ $eJOHy.createElement((0, $dhRXV.default), {
        xcss: $380062244592d177$var$styles.numberContainer,
        tabIndex: 0,
        "aria-label": projectScopedCustomFieldsCountArialLabel ? formatMessage(projectScopedCustomFieldsCountArialLabel, {
            number: formatNumber(projectScopedCustomFieldsCount)
        }) : undefined
    }, /*#__PURE__*/ $eJOHy.createElement((0, $dhRXV.default), {
        xcss: (0, $i7XOj.cx)(metricState === 'none' && $380062244592d177$var$styles.successNumber, metricState === 'warning' && $380062244592d177$var$styles.warningNumber, metricState === 'exceeded' && $380062244592d177$var$styles.errorNumber, $380062244592d177$var$styles.fontWeightStyles),
        "aria-describedby": "project-scoped-custom-fields-count-desc"
    }, formatNumber(projectScopedCustomFieldsCount)), /*#__PURE__*/ $eJOHy.createElement((0, $dhRXV.default), {
        xcss: $380062244592d177$var$styles.textContainer
    }, /*#__PURE__*/ $eJOHy.createElement("small", {
        id: "project-scoped-custom-fields-count-desc"
    }, formatMessage(projectScopedCustomFieldsCountLabel)))));
};
const $380062244592d177$var$styles = {
    numbersContainer: "_1e0c1txw _y3gn1h6o _1bsb1mjv _1bah1yb4 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
    numberContainer: "_16jlidpf _1o9zidpf _i0dl1wug",
    successNumber: "_11c8nf1z _syazaqb7",
    warningNumber: "_11c8nf1z _syaz1q28",
    errorNumber: "_11c8nf1z _syaz9lu1",
    fontWeightStyles: "_k48p1pd9",
    textContainer: "_p12f1lit",
    tooltipStyles: "_2rkoiti9 _bfhk1j9a _syaz15cr _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _16qszucj"
};

});
parcelRegister("jRWWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b91b70647a9e509b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<feb6f7edc1df5e3d4101e36703e049f6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b91b70647a9e509b$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "metricKey"
        }
    ],
    "kind": "Fragment",
    "name": "tooltip_AdminPagesPerformance_CustomFieldsTooltip",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "metricKey",
                    "variableName": "metricKey"
                }
            ],
            "kind": "LinkedField",
            "name": "resourceUsageMetricV2",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "globalScopedCustomFieldsCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectScopedCustomFieldsCount"
                        }
                    ],
                    "type": "JiraCustomFieldUsageMetric"
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$b91b70647a9e509b$var$node.hash = "b444713d2e6355b2eb2e6faa4401998f";
var $b91b70647a9e509b$export$2e2bcd8739ae039 = $b91b70647a9e509b$var$node;

});

parcelRegister("kjMQ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a0161ec30b74006$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8a0161ec30b74006$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.custom-fields.name",
        "defaultMessage": "Custom fields"
    },
    description: {
        "id": "admin-pages-performance.common.assets.custom-fields.description",
        "defaultMessage": "Here are the custom fields in your site, including ones we think can be removed because they\u2019re not used. Removing unused fields could improve site performance and stability."
    },
    chart: {
        "id": "admin-pages-performance.common.assets.custom-fields.chart",
        "defaultMessage": "Overview"
    },
    reviewAndAnalyze: {
        "id": "admin-pages-performance.common.assets.custom-fields.review-and-analyze",
        "defaultMessage": "Analysis"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.custom-fields.warning",
        "defaultMessage": "The number of custom fields is nearing our recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.custom-fields.exceeded",
        "defaultMessage": "There are more custom fields than our recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.custom-fields.risk-1",
        "defaultMessage": "Custom fields can make searching for issues (JQL and boards) and creating issues slow."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.custom-fields.mitigation-1",
        "defaultMessage": "Edit the context for the custom field to make it visible only for specific projects."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.custom-fields.mitigation-2",
        "defaultMessage": "Limit the number of custom fields across all projects and use the same custom field in multiple projects."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.current-value-label",
        "defaultMessage": "Custom fields in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-label",
        "defaultMessage": "Recommended maximum number of custom fields"
    },
    globalScopedCustomFieldsCountLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.global-scoped-custom-fields-count-label",
        "defaultMessage": "CMP custom fields count"
    },
    projectScopedCustomFieldsCountLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.project-scoped-custom-fields-count-label",
        "defaultMessage": "TMP custom fields count"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.current-value-aria-label",
        "defaultMessage": "{number} custom fields in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of custom fields"
    },
    globalScopedCustomFieldsCountAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.global-scoped-custom-fields-count-aria-label",
        "defaultMessage": "{number} {number, plural, one {global scoped custom field} other {global scoped custom fields}}"
    },
    projectScopedCustomFieldsCountAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.project-scoped-custom-fields-count-aria-label",
        "defaultMessage": "{number} {number, plural, one {project scoped custom field} other {global scoped custom fields}}"
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.custom-fields.recommendation-url-text",
        "defaultMessage": "See how we identify these fields."
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.custom-fields.graph-header",
        "defaultMessage": "Custom fields over time"
    },
    risk1IssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.custom-fields.risk-1-issue-term-refresh",
        "defaultMessage": "Custom fields can make searching (JQL and boards) and creating work items slow."
    }
});

});


parcelRegister("dXGYg", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_FIELDS_KEY", () => $a0ceec3559180829$export$d214286a7039b004);
$parcel$export(module.exports, "CUSTOM_FIELDS", () => $a0ceec3559180829$export$459112111ad5b136);

var $kjMQ3 = parcelRequire("kjMQ3");
const $a0ceec3559180829$export$d214286a7039b004 = 'customField';
const $a0ceec3559180829$export$459112111ad5b136 = {
    key: $a0ceec3559180829$export$d214286a7039b004,
    visible: true,
    name: (0, $kjMQ3.default).name,
    description: (0, $kjMQ3.default).description,
    tabLabels: [
        (0, $kjMQ3.default).chart,
        (0, $kjMQ3.default).reviewAndAnalyze
    ],
    warningMessage: (0, $kjMQ3.default).warning,
    exceededMessage: (0, $kjMQ3.default).exceeded,
    risks: [
        (0, $kjMQ3.default).risk1
    ],
    mitigations: [],
    currentValueLabel: (0, $kjMQ3.default).currentValueLabel,
    currentValueAriaLabel: (0, $kjMQ3.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $kjMQ3.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $kjMQ3.default).thresholdValueAriaLabel,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-custom-fields/',
    recommendationUrlText: (0, $kjMQ3.default).recommendationUrlText,
    graphHeader: (0, $kjMQ3.default).graphHeader,
    showTooltip: true
};

});

parcelRegister("jNYkJ", function(module, exports) {

$parcel$export(module.exports, "ISSUE_KEY", () => $b071ab859fd3c21c$export$5daa28d10e23592);
$parcel$export(module.exports, "ISSUE", () => $b071ab859fd3c21c$export$76a449e52fa0e1e8);

var $7qGN1 = parcelRequire("7qGN1");
const $b071ab859fd3c21c$var$messages = (0, $7qGN1.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.issue.name",
        "defaultMessage": "Issues"
    },
    description: {
        "id": "admin-pages-performance.common.assets.issue.description",
        "defaultMessage": "Here\u2019s a quick snapshot of the total number of issues in your site, including some that we think can be archived. Archiving unused issues can improve performance and stability of your site."
    },
    reviewAndAnalyze: {
        "id": "admin-pages-performance.common.assets.issue.review-and-analyze",
        "defaultMessage": "Analysis"
    },
    activityLog: {
        "id": "admin-pages-performance.common.assets.issue.activity-log",
        "defaultMessage": "Activity log"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.issue.warning",
        "defaultMessage": "The number of issues in the system is nearing our recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.issue.exceeded",
        "defaultMessage": "There are more issues in the system than our recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.issue.risk-1",
        "defaultMessage": "If you have too many issues you may find searches, automations, and workflow rules are slower than usual."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-1",
        "defaultMessage": "Delete any projects that are no longer required."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-2",
        "defaultMessage": "Disable Jira integrations that create issues you don't need."
    },
    mitigation3: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-3",
        "defaultMessage": "Delete old issues that are no longer required. Use a JQL query to find issues older than a year (\u201Ccreated < -365d order by created DESC\u201C)."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.issue.current-value-label",
        "defaultMessage": "Total current issues in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-label",
        "defaultMessage": "Recommended maximum number of issues"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.issue.current-value-aria-label",
        "defaultMessage": "{number} total current issues in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of issues"
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.issue.graph-header",
        "defaultMessage": "Issues over time"
    }
});
const $b071ab859fd3c21c$export$5daa28d10e23592 = 'issue';
const $b071ab859fd3c21c$export$76a449e52fa0e1e8 = {
    key: $b071ab859fd3c21c$export$5daa28d10e23592,
    visible: true,
    name: $b071ab859fd3c21c$var$messages.name,
    description: $b071ab859fd3c21c$var$messages.description,
    tabLabels: [
        $b071ab859fd3c21c$var$messages.reviewAndAnalyze,
        $b071ab859fd3c21c$var$messages.activityLog
    ],
    warningMessage: $b071ab859fd3c21c$var$messages.warning,
    exceededMessage: $b071ab859fd3c21c$var$messages.exceeded,
    risks: [
        $b071ab859fd3c21c$var$messages.risk1
    ],
    mitigations: [
        $b071ab859fd3c21c$var$messages.mitigation1,
        $b071ab859fd3c21c$var$messages.mitigation2,
        $b071ab859fd3c21c$var$messages.mitigation3
    ],
    currentValueLabel: $b071ab859fd3c21c$var$messages.currentValueLabel,
    currentValueAriaLabel: $b071ab859fd3c21c$var$messages.currentValueAriaLabel,
    thresholdValueLabel: $b071ab859fd3c21c$var$messages.thresholdValueLabel,
    thresholdValueAriaLabel: $b071ab859fd3c21c$var$messages.thresholdValueAriaLabel,
    graphHeader: $b071ab859fd3c21c$var$messages.graphHeader
};

});

parcelRegister("kbtrL", function(module, exports) {

$parcel$export(module.exports, "PROJECT_ROLE_ACTOR_KEY", () => $eb63b920a4a7146f$export$a570ca3f6cc5e280);
$parcel$export(module.exports, "PROJECT_ROLE_ACTOR", () => $eb63b920a4a7146f$export$fc3d2ee6c3fb3908);

var $7qGN1 = parcelRequire("7qGN1");
const $eb63b920a4a7146f$var$messages = (0, $7qGN1.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.project-role-actor.name",
        "defaultMessage": "Project role permissions"
    },
    description: {
        "id": "admin-pages-performance.common.assets.project-role-actor.description",
        "defaultMessage": "Here's a quick snapshot of the total number of project role permissions across your site."
    },
    analysis: {
        "id": "admin-pages-performance.common.assets.project-role-actor.analysis",
        "defaultMessage": "Analysis"
    },
    activityLog: {
        "id": "admin-pages-performance.common.assets.project-role-actor.activity-log",
        "defaultMessage": "Activity log"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.project-role-actor.warning",
        "defaultMessage": "Your number of project role memberships is nearing the recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.project-role-actor.exceeded",
        "defaultMessage": "Your number of project role memberships is over the recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.project-role-actor.risk-1",
        "defaultMessage": "When the number of project role memberships (users or groups) increases, viewing, searching, and creating issues becomes slower."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-1",
        "defaultMessage": "Remove users who no longer need access to your site rather than only suspending them. Suspending users removes their permission but not their project role membership."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-2",
        "defaultMessage": "Give memberships to groups of users instead of individual users. Granting membership to a group of 50 users count as 1 membership whereas granting memberships to 50 single users counts as 50 memberships."
    },
    mitigation3: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-3",
        "defaultMessage": "Use the default project role members in your permission scheme."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.current-value-label",
        "defaultMessage": "Current project role permissions in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-label",
        "defaultMessage": "Recommended maximum number of permissions"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.current-value-aria-label",
        "defaultMessage": "{number} current project role permissions in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of permissions"
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.project-role-actor.recommendation-url-text",
        "defaultMessage": "Learn more about optimizing your project role memberships."
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
        "defaultMessage": "Project role permissions over time"
    }
});
const $eb63b920a4a7146f$export$a570ca3f6cc5e280 = 'projectroleactor';
const $eb63b920a4a7146f$export$fc3d2ee6c3fb3908 = {
    key: $eb63b920a4a7146f$export$a570ca3f6cc5e280,
    visible: true,
    name: $eb63b920a4a7146f$var$messages.name,
    description: $eb63b920a4a7146f$var$messages.description,
    tabLabels: [
        $eb63b920a4a7146f$var$messages.analysis,
        $eb63b920a4a7146f$var$messages.activityLog
    ],
    warningMessage: $eb63b920a4a7146f$var$messages.warning,
    exceededMessage: $eb63b920a4a7146f$var$messages.exceeded,
    risks: [
        $eb63b920a4a7146f$var$messages.risk1
    ],
    mitigations: [
        $eb63b920a4a7146f$var$messages.mitigation1,
        $eb63b920a4a7146f$var$messages.mitigation2,
        $eb63b920a4a7146f$var$messages.mitigation3
    ],
    currentValueLabel: $eb63b920a4a7146f$var$messages.currentValueLabel,
    currentValueAriaLabel: $eb63b920a4a7146f$var$messages.currentValueAriaLabel,
    thresholdValueLabel: $eb63b920a4a7146f$var$messages.thresholdValueLabel,
    thresholdValueAriaLabel: $eb63b920a4a7146f$var$messages.thresholdValueAriaLabel,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-number-of-project-role-memberships/',
    recommendationUrlText: $eb63b920a4a7146f$var$messages.recommendationUrlText,
    graphHeader: $eb63b920a4a7146f$var$messages.graphHeader
};

});

parcelRegister("j1zBH", function(module, exports) {

$parcel$export(module.exports, "METRICS", () => $41065b7fb6092ace$export$3f0e99ae6e0ec541);
$parcel$export(module.exports, "RUN_ANALYSIS", () => $41065b7fb6092ace$export$769b1a9477352cf9);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS", () => $41065b7fb6092ace$export$e7e31b14c32e055a);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_DROPDOWN", () => $41065b7fb6092ace$export$d96fe00ff2b38bae);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CONFIRM", () => $41065b7fb6092ace$export$3d4bb5f187c6844e);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CANCEL", () => $41065b7fb6092ace$export$5c1079e323f5d5bd);
$parcel$export(module.exports, "TAB_CLICKED", () => $41065b7fb6092ace$export$d358fc12daa9f606);
$parcel$export(module.exports, "RECOMMENDATIONS_LOADED", () => $41065b7fb6092ace$export$60cc0c61c99a5b81);
$parcel$export(module.exports, "METRIC_CARD_CLICKED", () => $41065b7fb6092ace$export$71794f4d197278dc);
$parcel$export(module.exports, "PROJECT_ROLE_ACTOR_FILTER_BY_PROJECT", () => $41065b7fb6092ace$export$9e34afbf86922b4a);
$parcel$export(module.exports, "projectRoleActorAttributes", () => $41065b7fb6092ace$export$d6761557c91eea50);
$parcel$export(module.exports, "ARCHIVE_ISSUES_CONFIRM", () => $41065b7fb6092ace$export$4e4b9391f7936ba2);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES", () => $41065b7fb6092ace$export$70525d18051240f4);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_CANCEL", () => $41065b7fb6092ace$export$4951e0e034b50b9c);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_TRY_AGAIN", () => $41065b7fb6092ace$export$108288df7758f60c);
$parcel$export(module.exports, "VIEW_ISSUES", () => $41065b7fb6092ace$export$972d5a8da0d9f4c3);
$parcel$export(module.exports, "STOP_ISSUE_ARCHIVAL", () => $41065b7fb6092ace$export$b920363d50bcf753);
$parcel$export(module.exports, "ISSUE_UNARCHIVAL_COMPLETED", () => $41065b7fb6092ace$export$a84a5210fbad774);
$parcel$export(module.exports, "JQL_SEARCH", () => $41065b7fb6092ace$export$5c2df36fdd8476f7);
$parcel$export(module.exports, "DEFAULT_QUERY_SELECTED", () => $41065b7fb6092ace$export$77f23f1b921d5321);
$parcel$export(module.exports, "issueAnalyticsAttributes", () => $41065b7fb6092ace$export$c62a52f3f7d80ec3);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH", () => $41065b7fb6092ace$export$8daffc99348bf555);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CONFIRM", () => $41065b7fb6092ace$export$20f13a04bc3e5d74);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CANCEL", () => $41065b7fb6092ace$export$ed285e0e924b673c);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_SUCCEEDED", () => $41065b7fb6092ace$export$26f5d7eae10db511);
$parcel$export(module.exports, "customFieldAttributes", () => $41065b7fb6092ace$export$33989f74b6ba0674);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_STARTED", () => $41065b7fb6092ace$export$d39b24a650c6c79d);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_DISMISSED", () => $41065b7fb6092ace$export$eca4028936acf763);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_COMPLETED", () => $41065b7fb6092ace$export$9ba0a5caedb0ff37);
$parcel$export(module.exports, "RESTORE_ACTIVITY_LOG", () => $41065b7fb6092ace$export$7b6bf63452d40db8);
$parcel$export(module.exports, "DOWNLOAD_CSV", () => $41065b7fb6092ace$export$efdb93c7210090d1);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTERS_CLEARED", () => $41065b7fb6092ace$export$6c650be5c2b4774f);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_PROJECT", () => $41065b7fb6092ace$export$6493dd0e190d3f58);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_STALE", () => $41065b7fb6092ace$export$422673ba1cec4aed);
$parcel$export(module.exports, "PROJECT_CLEAN_UP", () => $41065b7fb6092ace$export$3a7186fc63c9e188);
$parcel$export(module.exports, "PROJECT_CLEANUP_COMPLETED", () => $41065b7fb6092ace$export$8e0b8859a3cbd9e6);
$parcel$export(module.exports, "ACTION_TRASH", () => $41065b7fb6092ace$export$342d8b9804e407c7);
$parcel$export(module.exports, "ACTION_ARCHIVE", () => $41065b7fb6092ace$export$b685f2109baf2b4f);
$parcel$export(module.exports, "ACTION_UNARCHIVE", () => $41065b7fb6092ace$export$3ac60b381ed426ca);

var $dXGYg = parcelRequire("dXGYg");

var $jNYkJ = parcelRequire("jNYkJ");

var $5gcb9 = parcelRequire("5gcb9");

var $kbtrL = parcelRequire("kbtrL");

var $kJOYm = parcelRequire("kJOYm");
const $41065b7fb6092ace$export$3f0e99ae6e0ec541 = [
    // Inclusion of issues in metrics is dependent on improving mitigation strategies for issues.
    // Inclusion of issue links in metrics is dependent on improving mitigation strategies for issue links.
    // ISSUE_LINKS,
    // CUSTOM_FIELD_OPTIONS,
    (0, $dXGYg.CUSTOM_FIELDS),
    (0, $kJOYm.WORK_TYPES),
    (0, $jNYkJ.ISSUE),
    (0, $kbtrL.PROJECT_ROLE_ACTOR),
    // Inclusion of file attachments in metrics is dependent on improving mitigation strategies for file attachments.
    // FILE_ATTACHMENTS,
    (0, $5gcb9.PROJECT_CLEANUP)
];
const $41065b7fb6092ace$export$769b1a9477352cf9 = 'runAnalysis';
const $41065b7fb6092ace$export$e7e31b14c32e055a = 'deleteRecommendations';
const $41065b7fb6092ace$export$d96fe00ff2b38bae = 'deleteRecommendationsDropdown';
const $41065b7fb6092ace$export$3d4bb5f187c6844e = 'deleteRecommendationsConfirm';
const $41065b7fb6092ace$export$5c1079e323f5d5bd = 'deleteRecommendationsCancel';
const $41065b7fb6092ace$export$d358fc12daa9f606 = 'psiTab';
const $41065b7fb6092ace$export$60cc0c61c99a5b81 = 'recommendations loaded';
const $41065b7fb6092ace$export$71794f4d197278dc = 'mitigationMetricCard';
const $41065b7fb6092ace$export$9e34afbf86922b4a = 'projectRoleActorFilterByProject';
const $41065b7fb6092ace$export$d6761557c91eea50 = {
    metric: (0, $kbtrL.PROJECT_ROLE_ACTOR_KEY)
};
const $41065b7fb6092ace$export$4e4b9391f7936ba2 = 'archiveIssuesConfirm';
const $41065b7fb6092ace$export$70525d18051240f4 = 'restoreIssueArchival';
const $41065b7fb6092ace$export$4951e0e034b50b9c = 'restoreIssueCancel';
const $41065b7fb6092ace$export$108288df7758f60c = 'restoreIssueTryAgain';
const $41065b7fb6092ace$export$972d5a8da0d9f4c3 = 'viewIssues';
const $41065b7fb6092ace$export$b920363d50bcf753 = 'stopIssueArchival';
const $41065b7fb6092ace$export$a84a5210fbad774 = 'restoreIssueArchival completed';
const $41065b7fb6092ace$export$5c2df36fdd8476f7 = 'jqlSearch';
const $41065b7fb6092ace$export$77f23f1b921d5321 = 'defaultQuerySelected';
const $41065b7fb6092ace$export$c62a52f3f7d80ec3 = {
    metric: (0, $jNYkJ.ISSUE_KEY)
};
const $41065b7fb6092ace$export$8daffc99348bf555 = 'customFieldMoveToTrash';
const $41065b7fb6092ace$export$20f13a04bc3e5d74 = 'customFieldMoveToTrashConfirm';
const $41065b7fb6092ace$export$ed285e0e924b673c = 'customFieldMoveToTrashCancel';
const $41065b7fb6092ace$export$26f5d7eae10db511 = 'customFieldMoveToTrash succeeded';
const $41065b7fb6092ace$export$33989f74b6ba0674 = {
    metric: (0, $dXGYg.CUSTOM_FIELDS).key
};
const $41065b7fb6092ace$export$d39b24a650c6c79d = 'metricPerformanceSpotlight started';
const $41065b7fb6092ace$export$eca4028936acf763 = 'metricPerformanceSpotlightDismissed';
const $41065b7fb6092ace$export$9ba0a5caedb0ff37 = 'metricPerformanceSpotlight completed';
const $41065b7fb6092ace$export$7b6bf63452d40db8 = 'restoreActivityLog';
const $41065b7fb6092ace$export$efdb93c7210090d1 = 'downloadActivityLogCsv';
const $41065b7fb6092ace$export$6c650be5c2b4774f = 'projectCleanupFiltersCleared';
const $41065b7fb6092ace$export$6493dd0e190d3f58 = 'projectCleanupFilterByProjectState';
const $41065b7fb6092ace$export$422673ba1cec4aed = 'projectCleanupFilterByStale';
const $41065b7fb6092ace$export$3a7186fc63c9e188 = 'projectCleanUp';
const $41065b7fb6092ace$export$8e0b8859a3cbd9e6 = 'projectCleanup completed';
const $41065b7fb6092ace$export$342d8b9804e407c7 = 'TRASH';
const $41065b7fb6092ace$export$b685f2109baf2b4f = 'ARCHIVE';
const $41065b7fb6092ace$export$3ac60b381ed426ca = 'UNARCHIVE';
const $41065b7fb6092ace$export$638cc6e36b2a737a = 'SUCCESS';
const $41065b7fb6092ace$export$d71930f7f5807a72 = 'FAILED';
const $41065b7fb6092ace$export$5a9ac66c2785cc13 = 'IN_PROGRESS';

});
parcelRegister("kJOYm", function(module, exports) {

$parcel$export(module.exports, "WORK_TYPES_KEY", () => $f67fae3f5eb82d3e$export$c171a00037afe9fe);
$parcel$export(module.exports, "WORK_TYPES", () => $f67fae3f5eb82d3e$export$cca1526cdd4d7d3f);

var $1UA8V = parcelRequire("1UA8V");
const $f67fae3f5eb82d3e$export$c171a00037afe9fe = 'worktype';
const $f67fae3f5eb82d3e$export$cca1526cdd4d7d3f = {
    key: $f67fae3f5eb82d3e$export$c171a00037afe9fe,
    visible: true,
    name: (0, $1UA8V.default).nameNonFinal,
    description: (0, $1UA8V.default).descriptionNonFinal,
    tabLabels: [
        (0, $1UA8V.default).chartNonFinal,
        (0, $1UA8V.default).reviewAndAnalyzeNonFinal
    ],
    warningMessage: (0, $1UA8V.default).warningNonFinal,
    exceededMessage: (0, $1UA8V.default).exceededNonFinal,
    risks: [
        (0, $1UA8V.default).risk1NonFinal
    ],
    mitigations: [],
    currentValueLabel: (0, $1UA8V.default).currentValueLabelNonFinal,
    currentValueAriaLabel: (0, $1UA8V.default).currentValueAriaLabelNonFinal,
    thresholdValueLabel: (0, $1UA8V.default).thresholdValueLabelNonFinal,
    thresholdValueAriaLabel: (0, $1UA8V.default).thresholdValueAriaLabelNonFinal,
    recommendationUrl: '',
    recommendationUrlText: (0, $1UA8V.default).recommendationUrlTextNonFinal,
    graphHeader: (0, $1UA8V.default).graphHeaderNonFinal
};

});
parcelRegister("1UA8V", function(module, exports) {

$parcel$export(module.exports, "default", () => $468dad380b80a053$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $468dad380b80a053$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    nameNonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.name-non-final",
        "defaultMessage": "Work types"
    },
    descriptionNonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.description-non-final",
        "defaultMessage": "Here are the work types in your site, including ones we think can be removed because they\u2019re not used. Removing work types could improve site performance and stability."
    },
    chartNonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.chart-non-final",
        "defaultMessage": "Overview"
    },
    reviewAndAnalyzeNonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.review-and-analyze-non-final",
        "defaultMessage": "Analysis"
    },
    warningNonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.warning-non-final",
        "defaultMessage": "The number of work types is nearing our recommended threshold."
    },
    exceededNonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.exceeded-non-final",
        "defaultMessage": "There are more work types than our recommended threshold."
    },
    risk1NonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.risk-1-non-final",
        "defaultMessage": "Work types can make searching for issues (JQL and boards) and creating issues slow."
    },
    mitigation1NonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.mitigation-1-non-final",
        "defaultMessage": "Edit the context for the work type to make it visible only for specific projects."
    },
    mitigation2NonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.mitigation-2-non-final",
        "defaultMessage": "Limit the number of work types across all projects and use the same work type in multiple projects."
    },
    currentValueLabelNonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.current-value-label-non-final",
        "defaultMessage": "Work types in your site"
    },
    thresholdValueLabelNonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.threshold-value-label-non-final",
        "defaultMessage": "Recommended maximum number of work types"
    },
    currentValueAriaLabelNonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.current-value-aria-label-non-final",
        "defaultMessage": "{number} work types in your site"
    },
    thresholdValueAriaLabelNonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.threshold-value-aria-label-non-final",
        "defaultMessage": "{number} recommended maximum number of work types"
    },
    recommendationUrlTextNonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.recommendation-url-text-non-final",
        "defaultMessage": "See how we identify these work types."
    },
    graphHeaderNonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.graph-header-non-final",
        "defaultMessage": "Work types over time"
    },
    risk1IssueTermRefreshNonFinal: {
        "id": "admin-pages-performance.common.assets.work-types.risk-1-issue-term-refresh-non-final",
        "defaultMessage": "Work types can make searching (JQL and boards) and creating work items slow."
    }
});

});




parcelRegister("dGzlS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bde9993f72fbcea$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6bde9993f72fbcea$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.title",
        "defaultMessage": "Site optimizer"
    },
    overview: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.overview",
        "defaultMessage": "Overview"
    },
    allReports: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.all-reports",
        "defaultMessage": "All reports"
    }
});

});

parcelRegister("967Ue", function(module, exports) {

$parcel$export(module.exports, "PROJECT_CLEANUP_SPOTLIGHT_NAME", () => $504137348dac6364$export$4150c6a7c9be0102);
$parcel$export(module.exports, "ProjectCleanupSpotlight", () => $504137348dac6364$export$6dc8afd0c00f9525);

var $eJOHy = parcelRequire("eJOHy");

var $REcGP = parcelRequire("REcGP");

var $lRq8t = parcelRequire("lRq8t");

var $9HHOs = parcelRequire("9HHOs");

var $drA6C = parcelRequire("drA6C");

var $5x1EH = parcelRequire("5x1EH");
const $504137348dac6364$export$4150c6a7c9be0102 = 'site-optimiser-project-cleanup-spotlight-nav';
const $504137348dac6364$export$6dc8afd0c00f9525 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, $drA6C.useProjectCleanupSpotlight)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $REcGP.default), null, isProjectCleanupSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), {
        actions: [
            {
                onClick: ()=>setIsProjectCleanupSpotlightActive(false),
                text: formatMessage((0, $5x1EH.default).spotlightAction)
            }
        ],
        heading: formatMessage((0, $5x1EH.default).spotlightHeading),
        target: $504137348dac6364$export$4150c6a7c9be0102,
        key: $504137348dac6364$export$4150c6a7c9be0102,
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "right top",
        messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $5x1EH.default).spotlightDescription)));
});

});
parcelRegister("drA6C", function(module, exports) {

$parcel$export(module.exports, "useProjectCleanupSpotlight", () => $37bbb63fa043a950$export$780bcf6e3ebf2d12);

var $eJOHy = parcelRequire("eJOHy");

var $2naeK = parcelRequire("2naeK");

var $8q7lT = parcelRequire("8q7lT");
// Ensure this key matches the key in the old nav in navigation-apps/sidebar package
const $37bbb63fa043a950$var$PROPERTY_KEY = 'jira.user.settings.system.project-cleanup-onboarding-spotlight';
const $37bbb63fa043a950$export$780bcf6e3ebf2d12 = ()=>{
    const accountId = (0, $8q7lT.useAccountId)();
    const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, $eJOHy.useState)(false);
    const getHasSeenProjectCleanupSpotlight = async (id)=>{
        const response = await (0, $2naeK.getUserProperty)({
            accountId: id,
            propertyKey: $37bbb63fa043a950$var$PROPERTY_KEY,
            defaultValue: false
        });
        // If they have not seen the spotlight, return true and mark as shown
        if (!response.value) {
            await (0, $2naeK.setUserProperty)({
                accountId: id,
                propertyKey: $37bbb63fa043a950$var$PROPERTY_KEY,
                propertyValue: true
            });
            return false;
        }
        return true;
    };
    const fetchSpotlightState = (0, $eJOHy.useCallback)(async ()=>{
        if (accountId !== null) {
            const response = await getHasSeenProjectCleanupSpotlight(accountId);
            setIsProjectCleanupSpotlightActive(!response);
        }
    }, [
        accountId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchSpotlightState();
    }, [
        fetchSpotlightState
    ]);
    return [
        isProjectCleanupSpotlightActive,
        setIsProjectCleanupSpotlightActive
    ];
};

});
parcelRegister("2naeK", function(module, exports) {

$parcel$export(module.exports, "getUserProperty", () => $e363c04c9af85b10$export$b3126db2ef6e34ed);
$parcel$export(module.exports, "setUserProperty", () => $e363c04c9af85b10$export$ba821ce5e177c7ef);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $e363c04c9af85b10$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $e363c04c9af85b10$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $e363c04c9af85b10$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // The API deliberately returns 404 if user property is not found - we will return default value
        if (response.status === 404) return {
            key: propertyKey,
            value: defaultValue
        };
        if (response.ok) return await response.json();
        throw new Error(`Fetching ${propertyKey} user property failed.`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'getUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};
const $e363c04c9af85b10$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $e363c04c9af85b10$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $jGzN3.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'setUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("5x1EH", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf24a9d402c283f0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cf24a9d402c283f0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    spotlightHeading: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-heading",
        "defaultMessage": "Clean out unused projects"
    },
    spotlightDescription: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-description",
        "defaultMessage": "Quickly remove inactive or empty projects to improve your site\u2019s performance. "
    },
    spotlightAction: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-action",
        "defaultMessage": "Ok"
    }
});

});



parcelRegister("3nYWL", function(module, exports) {

$parcel$export(module.exports, "hasSeenSiteOptimiserSpotlight", () => $90d873808e331528$export$3ed4e8541d8ba40);

var $2naeK = parcelRequire("2naeK");
const $90d873808e331528$var$PROPERTY_KEY = 'jira.user.settings.system.site-optimizer-spotlight';
const $90d873808e331528$export$3ed4e8541d8ba40 = async (accountId)=>{
    const response = await (0, $2naeK.getUserProperty)({
        accountId: accountId,
        propertyKey: $90d873808e331528$var$PROPERTY_KEY,
        defaultValue: false
    });
    // If they have not seen the spotlight, return true and mark as shown
    if (!response.value) {
        await (0, $2naeK.setUserProperty)({
            accountId: accountId,
            propertyKey: $90d873808e331528$var$PROPERTY_KEY,
            propertyValue: true
        });
        return false;
    }
    return true;
};

});


parcelRegister("4cBUk", function(module, exports) {

$parcel$export(module.exports, "isViewAuditingSelected", () => $0ec5eaa9039b7bc4$export$6da8ca04904513f9);

var $8xDPn = parcelRequire("8xDPn");
const $0ec5eaa9039b7bc4$var$VIEW_AUDITING_PATH_REGEXP = /\/auditing\/(\w+)/i;
const $0ec5eaa9039b7bc4$export$6da8ca04904513f9 = (currentLocation, itemLocation)=>(0, $8xDPn.matchUrlExact)()(currentLocation, itemLocation) || $0ec5eaa9039b7bc4$var$VIEW_AUDITING_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("e54td", function(module, exports) {

$parcel$export(module.exports, "UserInterfaceSection", () => $f1c13eb897db8fdd$export$c4128359313d3f58);

var $eJOHy = parcelRequire("eJOHy");

var $7Tz5f = parcelRequire("7Tz5f");
var $5RrpQ = parcelRequire("5RrpQ");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $gZTP9 = parcelRequire("gZTP9");

var $4nlI9 = parcelRequire("4nlI9");

var $bp1wP = parcelRequire("bp1wP");
const $f1c13eb897db8fdd$export$c4128359313d3f58 = ()=>{
    const isJiraAdmin = (0, $gZTP9.useIsAdmin)();
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5RrpQ.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tz5f.default), {
        title: formatMessage((0, $bp1wP.default).userInterface)
    }, features.hasUserDefaults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'user-defaults'
        },
        href: navigationPath.userInterfacesUserDefaults,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $bp1wP.default).userDefaults)), features.hasEditDefaultDashboard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'edit-default-dashboard'
        },
        href: navigationPath.userInterfacesEditDefaultDashboard,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $bp1wP.default).systemDashboard)), features.hasLookAndFeel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'look-and-feel'
        },
        href: navigationPath.userInterfacesLookAndFeel,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $bp1wP.default).lookAndFeel)), features.hasPasAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'pas-admin-link-jira'
        },
        href: navigationPath.userInterfacesPasAdmin,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $bp1wP.default).pasAdmin)), isJiraAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'announcement-banner'
        },
        href: navigationPath.userInterfacesSiteAdmin,
        selectedOn: [
            'global-settings-system-ui-announcement-banner'
        ]
    }, formatMessage((0, $bp1wP.default).announcementBanner)));
};

});
parcelRegister("bp1wP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a2698a46d5bfed1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4a2698a46d5bfed1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    userInterface: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-interface",
        "defaultMessage": "User Interface"
    },
    userDefaults: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-defaults",
        "defaultMessage": "Default user preferences"
    },
    systemDashboard: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.system-dashboard",
        "defaultMessage": "Default dashboard"
    },
    lookAndFeel: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.look-and-feel",
        "defaultMessage": "Look and feel"
    },
    pasAdmin: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.pas-admin",
        "defaultMessage": "Public Announcement Service"
    },
    announcementBanner: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.announcement-banner",
        "defaultMessage": "Announcement banner"
    }
});

});


parcelRegister("1hRnr", function(module, exports) {

$parcel$export(module.exports, "isGeneralConfigurationSelected", () => $3b9adf410e2cf34e$export$ba31cfa97c56eefd);

var $8xDPn = parcelRequire("8xDPn");
const $3b9adf410e2cf34e$var$APPLICATION_PROPERTIES_PATH_REGEXP = /\/admin\/(\w+)ApplicationProperties/i;
const $3b9adf410e2cf34e$export$ba31cfa97c56eefd = (currentLocation, itemLocation)=>(0, $8xDPn.matchUrlExact)()(currentLocation, itemLocation) || $3b9adf410e2cf34e$var$APPLICATION_PROPERTIES_PATH_REGEXP.test(currentLocation.pathname);

});



parcelRegister("9gC8Q", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemBulkMailRoute", () => $35065d871a511d9b$export$2b269dcf51f5a4d3);
const $35065d871a511d9b$export$2b269dcf51f5a4d3 = {
    name: 'global-settings-system-bulk-mail',
    path: '/jira/settings/system/send-email'
};

});

parcelRegister("2lbA8", function(module, exports) {

$parcel$export(module.exports, "LazyBulkEmail", () => $0897ce069002a905$export$416f8039fbf50bea);
$parcel$export(module.exports, "default", () => $0897ce069002a905$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $0897ce069002a905$export$416f8039fbf50bea = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("40TGP"))), {
    moduleId: "./src/packages/admin-pages/bulk-email-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0897ce069002a905$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $0897ce069002a905$export$416f8039fbf50bea,
        pageId: "jira-admin-pages-bulk-email",
        shouldShowSpinner: true
    });

});
parcelRegister("40TGP", function(module, exports) {

let $2ec25c573d7869d2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2ec25c573d7869d2$var$load("2DJfg").then(()=>parcelRequire('32GL6'));

});



parcelRegister("WOvcu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUiAnnouncementBannerRouteEntry", () => $2e98342e95de1283$export$416d225883781012);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $7lDtC = parcelRequire("7lDtC");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $5fjzQ = parcelRequire("5fjzQ");

const $2e98342e95de1283$var$LazyAnnouncementBanner = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("027p6"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/system/ui/announcement-banner/src/index.tsx"
});
const $2e98342e95de1283$var$AnnouncementBanner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $2e98342e95de1283$var$LazyAnnouncementBanner,
        pageId: "admin-pages-system-ui-announcement-banner",
        shouldShowSpinner: true
    });
const $2e98342e95de1283$export$416d225883781012 = (0, $6xToB.createEntry)((0, $7lDtC.globalSettingsSystemUiAnnouncementBannerRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.system.ui.announcement-banner',
        component: $2e98342e95de1283$var$AnnouncementBanner,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $2e98342e95de1283$var$LazyAnnouncementBanner
        ]
    }));

});
parcelRegister("7lDtC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUiAnnouncementBannerRoute", () => $b10d9c8d87ba9100$export$20631ff3b13dafc0);
const $b10d9c8d87ba9100$export$20631ff3b13dafc0 = {
    name: 'global-settings-system-ui-announcement-banner',
    path: '/jira/settings/system/ui/announcement-banner'
};

});

parcelRegister("027p6", function(module, exports) {

let $0065ee462bd5e3bc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $0065ee462bd5e3bc$var$load("1VRB2"),
    $0065ee462bd5e3bc$var$load("bABhq"),
    $0065ee462bd5e3bc$var$load("eDzss"),
    $0065ee462bd5e3bc$var$load("cS3Lt")
]).then(()=>parcelRequire('eNQ0k'));

});


parcelRegister("kaoIS", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioActionsRouteEntry", () => $437928c715502ace$export$47cbfd555c8570c0);

var $kHlOR = parcelRequire("kHlOR");

var $1wb5r = parcelRequire("1wb5r");

var $9BJU1 = parcelRequire("9BJU1");

var $1PvPk = parcelRequire("1PvPk");

var $6xToB = parcelRequire("6xToB");

var $aQoXd = parcelRequire("aQoXd");

var $hmxvq = parcelRequire("hmxvq");

var $bJscI = parcelRequire("bJscI");

var $ioWDK = parcelRequire("ioWDK");

var $jmvbS = parcelRequire("jmvbS");
const $437928c715502ace$export$47cbfd555c8570c0 = (0, $6xToB.createEntry)((0, $hmxvq.helpCenterSettingsAgentStudioActionsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio-actions',
        component: (0, $bJscI.componentWithFG)('csm-actions-framework-visibility', (0, $jmvbS.AgentStudioActionsComponent), (0, $9BJU1.default)),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: (0, $ioWDK.agentStudioNavigation),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jmvbS.LazyAgentStudioActionsPage)
        ],
        earlyAssets: (0, $1wb5r.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("hmxvq", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioActionsRoute", () => $a90dd7388fe2339c$export$5cfc987a071755e7);
const $a90dd7388fe2339c$export$5cfc987a071755e7 = {
    name: 'helpcenter-settings-agent-studio-actions',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/actions',
    exact: true
};

});

parcelRegister("ioWDK", function(module, exports) {

$parcel$export(module.exports, "navigation", () => $6332fb700a1a107a$export$428e7c787d57587d);
$parcel$export(module.exports, "agentStudioNavigation", () => $6332fb700a1a107a$export$c198b13d4a0b8cea);

var $5RW99 = parcelRequire("5RW99");

var $6LKuI = parcelRequire("6LKuI");

var $dUMft = parcelRequire("dUMft");

var $bJscI = parcelRequire("bJscI");
const $6332fb700a1a107a$export$428e7c787d57587d = {
    sidebarId: (0, $5RW99.SIDEBAR_ID).HELP_CENTER_SETTINGS,
    menuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
    sidebar: (0, $dUMft.default)
};
const $6332fb700a1a107a$export$c198b13d4a0b8cea = {
    sidebarId: (0, $5RW99.SIDEBAR_ID).HELP_CENTER_SETTINGS,
    menuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
    sidebar: (0, $dUMft.default),
    horizontal: (0, $bJscI.componentWithFG)('enable_support_center_agent_studio_page', (0, $6LKuI.AsyncSupportCenterHorizontalNav), ()=>null)
};

});
parcelRegister("6LKuI", function(module, exports) {

$parcel$export(module.exports, "AsyncSupportCenterHorizontalNav", () => $cc0d90ecf988f50b$export$123fcd6868b7ea3f);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $cc0d90ecf988f50b$var$LazyHorizontalSupportCenterNav = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("gp1qU")).then(({ HorizontalNav: HorizontalNav })=>HorizontalNav), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/horizontal-nav/main.tsx"
});
const $cc0d90ecf988f50b$export$123fcd6868b7ea3f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderUFOMigration), {
        name: "help-center-settings-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cc0d90ecf988f50b$var$LazyHorizontalSupportCenterNav, null));
};

});
parcelRegister("gp1qU", function(module, exports) {

let $bf1017b13b49353f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bf1017b13b49353f$var$load("a4BZC").then(()=>parcelRequire('d02Yx'));

});


parcelRegister("dUMft", function(module, exports) {

$parcel$export(module.exports, "default", () => $56210a9ed64c7b2d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $56210a9ed64c7b2d$export$ea77f88c1b841127 = (0, $gzcjr.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("9vZFV")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/help-center-settings/src/index.tsx"
});
const $56210a9ed64c7b2d$var$HelpCenterSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($56210a9ed64c7b2d$export$ea77f88c1b841127, null)));
$56210a9ed64c7b2d$var$HelpCenterSettingsSidebar.displayName = 'HelpCenterSettingsSidebar';
var $56210a9ed64c7b2d$export$2e2bcd8739ae039 = $56210a9ed64c7b2d$var$HelpCenterSettingsSidebar;

});
parcelRegister("9vZFV", function(module, exports) {

let $6ed6d9bb1d035262$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6ed6d9bb1d035262$var$load("kZ4Lc").then(()=>parcelRequire('kNZGg'));

});



parcelRegister("jmvbS", function(module, exports) {

$parcel$export(module.exports, "LazyAgentStudioOverviewPage", () => $cd99f40b75230879$export$5fa375047554c75c);
$parcel$export(module.exports, "AgentStudioOverviewPage", () => $cd99f40b75230879$export$3c32337b9e9c89e5);
$parcel$export(module.exports, "LazyAgentStudioConversationReviewPage", () => $cd99f40b75230879$export$e5bd431cce56c023);
$parcel$export(module.exports, "AgentStudioConversationReview", () => $cd99f40b75230879$export$ba343ba7cdb4cca4);
$parcel$export(module.exports, "LazyAgentStudioSimulatorPage", () => $cd99f40b75230879$export$89ec1205a5fbfa5a);
$parcel$export(module.exports, "AgentStudioSimulatorComponent", () => $cd99f40b75230879$export$974fe2862709837d);
$parcel$export(module.exports, "LazyAgentStudioActionsPage", () => $cd99f40b75230879$export$f1d6621241cd5379);
$parcel$export(module.exports, "AgentStudioActionsComponent", () => $cd99f40b75230879$export$27f9057c3758bdae);
$parcel$export(module.exports, "csmAgentOverviewPageEntryPoint", () => $cd99f40b75230879$export$64672a53ea64d95b);
$parcel$export(module.exports, "agentStudioKnowledgePageEntryPoint", () => $cd99f40b75230879$export$a9cf3691889e3b8);
$parcel$export(module.exports, "csmAgentHandoffPageEntryPoint", () => $cd99f40b75230879$export$822a9de2df799668);
$parcel$export(module.exports, "csmAgentConversationReviewPageEntryPoint", () => $cd99f40b75230879$export$14c5ab081cdbeb0d);
$parcel$export(module.exports, "csmAgentChatSimulatorPageEntryPoint", () => $cd99f40b75230879$export$dc40d5702a9b03f3);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $1DMsj = parcelRequire("1DMsj");

var $f1kLD = parcelRequire("f1kLD");

var $6aFRk = parcelRequire("6aFRk");

var $bIg7E = parcelRequire("bIg7E");

var $coKPK = parcelRequire("coKPK");

const $cd99f40b75230879$export$5fa375047554c75c = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("hwZtj")).then((module)=>module.AgentOverview)), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/overview/index.tsx"
});
const $cd99f40b75230879$export$3c32337b9e9c89e5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cd99f40b75230879$export$5fa375047554c75c,
        pageId: "help-center-settings-agent-studio-overview",
        shouldShowSpinner: true
    });

const $cd99f40b75230879$export$e5bd431cce56c023 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("aLZPk"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/conversation-review/index.tsx"
});
const $cd99f40b75230879$export$ba343ba7cdb4cca4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cd99f40b75230879$export$e5bd431cce56c023,
        pageId: "help-center-settings-agent-studio-conversation-review",
        shouldShowSpinner: true
    });

const $cd99f40b75230879$export$89ec1205a5fbfa5a = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("68MQj"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/chat-simulator/index.tsx"
});
const $cd99f40b75230879$export$974fe2862709837d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cd99f40b75230879$export$89ec1205a5fbfa5a,
        pageId: "help-center-settings-agent-studio-chat-simulator",
        shouldShowSpinner: false
    });

const $cd99f40b75230879$export$f1d6621241cd5379 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("daeLG"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/actions/index.tsx"
});
const $cd99f40b75230879$export$27f9057c3758bdae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cd99f40b75230879$export$f1d6621241cd5379,
        pageId: "help-center-settings-agent-studio-chat-actions",
        shouldShowSpinner: false
    });
const $cd99f40b75230879$export$64672a53ea64d95b = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $f1kLD.csmAgentOverviewEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});
const $cd99f40b75230879$export$a9cf3691889e3b8 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1DMsj.helpCenterSettingsAgentStudioKnowledgeAppEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});
const $cd99f40b75230879$export$822a9de2df799668 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $bIg7E.helpCenterSettingsAgentStudioHandoffEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});
const $cd99f40b75230879$export$14c5ab081cdbeb0d = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $coKPK.csmAgentConversationReviewEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});
const $cd99f40b75230879$export$dc40d5702a9b03f3 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $6aFRk.csmAgentChatSimulatorEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("1DMsj", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioKnowledgeAppEntryPoint", () => $89dd4f8fdb2fa606$export$9436eec1eefc1701);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $jjrJE = parcelRequire("jjrJE");

const $89dd4f8fdb2fa606$export$9436eec1eefc1701 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("gYUEW")), {
        moduleId: "4b9cc39b",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $jjrJE.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`
                    }
                }
            }
        })
});

});
parcelRegister("jjrJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0716589c2ae5440$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7975a004da92a606996f012c39a7bd74>>
 * @relayHash 7517a65583faed70dbfad33ebebfb7fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7062c3ecfa368283782ea4badae1efec4d13b76b7bd2fb2d781f242160bd2237
const $e0716589c2ae5440$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            v2 /*: any*/ 
        ],
        "type": "CsmAiAgent"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "knowledgeConfig_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "knowledgeConfig_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ]
                                },
                                v2 /*: any*/ 
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7062c3ecfa368283782ea4badae1efec4d13b76b7bd2fb2d781f242160bd2237",
            "metadata": {},
            "name": "knowledgeConfig_agentIdentityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e0716589c2ae5440$var$node.hash = "0b997c6ab7fcf5ad5b42793b2c9d9bc6";
var $e0716589c2ae5440$export$2e2bcd8739ae039 = $e0716589c2ae5440$var$node;

});

parcelRegister("gYUEW", function(module, exports) {

let $c5ce334b4aa0fb47$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c5ce334b4aa0fb47$var$load("dnCQN").then(()=>parcelRequire('kVw6A'));

});


parcelRegister("f1kLD", function(module, exports) {

$parcel$export(module.exports, "csmAgentOverviewEntryPoint", () => $58a98793ef05d0d8$export$50a5fd926c9d7bb4);

var $aeOg3 = parcelRequire("aeOg3");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $58a98793ef05d0d8$export$50a5fd926c9d7bb4 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("hwZtj")).then((module)=>module.AgentOverview), {
        moduleId: "a5f961b3",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $aeOg3.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`
                    }
                }
            }
        })
});

});
parcelRegister("aeOg3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cb95829d75dd101$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7cf2646009b5cbeacadbd2981ae4c724>>
 * @relayHash de1a3ad7103e5f1f34b2ddcb6cce2420
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee1fad18784cb4de28a044ddec3469e8c5d86a523313ff94fb6acae9de9554ed
const $3cb95829d75dd101$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "overview_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "agentCard_AtlassianCsmAgentOverview"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "agentIdentity_AtlassianCsmAgentIdentity_agentRef"
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "overview_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "companyName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "companyDescription"
                                                },
                                                {
                                                    "concreteType": "CsmAiAgentTone",
                                                    "kind": "LinkedField",
                                                    "name": "tone",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "greetingMessage"
                                                },
                                                {
                                                    "concreteType": "CsmAiAgentConversationStarter",
                                                    "kind": "LinkedField",
                                                    "name": "conversationStarters",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "message"
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "CsmAiAgent"
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ee1fad18784cb4de28a044ddec3469e8c5d86a523313ff94fb6acae9de9554ed",
            "metadata": {},
            "name": "overview_agentIdentityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3cb95829d75dd101$var$node.hash = "afa6c6513ac79e69b5a4254589193e25";
var $3cb95829d75dd101$export$2e2bcd8739ae039 = $3cb95829d75dd101$var$node;

});

parcelRegister("hwZtj", function(module, exports) {

let $cc351bd7084c3dac$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cc351bd7084c3dac$var$load("hYoXO").then(()=>parcelRequire('3bNcX'));

});


parcelRegister("6aFRk", function(module, exports) {

$parcel$export(module.exports, "csmAgentChatSimulatorEntryPoint", () => $8d162f0d675f53d7$export$e3fcb8d4e80081b0);

var $5qSqb = parcelRequire("5qSqb");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $8d162f0d675f53d7$export$e3fcb8d4e80081b0 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("68MQj")), {
        moduleId: "e930d9dc",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $5qSqb.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`
                    }
                }
            }
        })
});

});
parcelRegister("5qSqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa1e999f852e7e59$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fe98323d8ba25bee0cdc2d21b347b37c>>
 * @relayHash 6ec40e2940a58d5987f8d0d2565b653b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b009d3de84f25c5f42694160edf048b5c7d1d61a085303179c1eec4658087cc
const $fa1e999f852e7e59$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "greetingMessage"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "chatSimulator_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "CsmAiAgentConversationStarter",
                                                    "kind": "LinkedField",
                                                    "name": "conversationStarters",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "CsmAiAgent"
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "chatSimulator_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "CsmAiAgentConversationStarter",
                                                    "kind": "LinkedField",
                                                    "name": "conversationStarters",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "CsmAiAgent"
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b009d3de84f25c5f42694160edf048b5c7d1d61a085303179c1eec4658087cc",
            "metadata": {},
            "name": "chatSimulator_agentIdentityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fa1e999f852e7e59$var$node.hash = "db75ee797c497b47b6a05c1132ca4fc4";
var $fa1e999f852e7e59$export$2e2bcd8739ae039 = $fa1e999f852e7e59$var$node;

});

parcelRegister("68MQj", function(module, exports) {

let $47896097a94bbc9e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $47896097a94bbc9e$var$load("1VRB2"),
    $47896097a94bbc9e$var$load("bABhq"),
    $47896097a94bbc9e$var$load("k4gbU"),
    $47896097a94bbc9e$var$load("eDzss"),
    $47896097a94bbc9e$var$load("lOtjo")
]).then(()=>parcelRequire('fNyDF'));

});


parcelRegister("bIg7E", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioHandoffEntryPoint", () => $1a6a6a0154dd0793$export$443ff355bdadb1d7);

var $d4Dzq = parcelRequire("d4Dzq");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $1a6a6a0154dd0793$export$443ff355bdadb1d7 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("f0WDw")), {
        moduleId: "7048febb",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $d4Dzq.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`
                    }
                }
            }
        })
});

});
parcelRegister("d4Dzq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b808e1f9b93adde$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e861d8f16bffbbd90aacdc48a82287e>>
 * @relayHash 3e33e72b6548910557838772437690a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bff615b7752f36899326f0bc3c951340ca1b8d705f2b44bb34372d6dcd9acb69
const $5b808e1f9b93adde$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "handoffConfig_csmAiHubQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "kind": "LinkedField",
                        "name": "csmAi_getAiHubByHelpCenterAri",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "configuration_AtlassianCsmHandoffConfig_queryReference"
                                    }
                                ],
                                "type": "CsmAiHub"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "csmAi_getAiHubByHelpCenterAri"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "handoffConfig_csmAiHubQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "handoffConfigs",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "enabled"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "connectorConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "message"
                                                                }
                                                            ],
                                                            "type": "CsmAiMessageHandoff"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "formId"
                                                                }
                                                            ],
                                                            "type": "CsmAiTicketingHandoff"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CsmAiHandoffConfig"
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bff615b7752f36899326f0bc3c951340ca1b8d705f2b44bb34372d6dcd9acb69",
            "metadata": {},
            "name": "handoffConfig_csmAiHubQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5b808e1f9b93adde$var$node.hash = "b48226f0209d788d92ecab37f14e92ea";
var $5b808e1f9b93adde$export$2e2bcd8739ae039 = $5b808e1f9b93adde$var$node;

});

parcelRegister("f0WDw", function(module, exports) {

let $aee4571a2d586c46$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $aee4571a2d586c46$var$load("bIHVf").then(()=>parcelRequire('7ek15'));

});


parcelRegister("coKPK", function(module, exports) {

$parcel$export(module.exports, "csmAgentConversationReviewEntryPoint", () => $0dc8e352bc5ef3ea$export$d1ea95606ab7ac2e);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $kAriv = parcelRequire("kAriv");

const $0dc8e352bc5ef3ea$export$d1ea95606ab7ac2e = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("aLZPk")), {
        moduleId: "b29d9436",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $kAriv.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`
                    }
                }
            }
        })
});

});
parcelRegister("kAriv", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa0c98e1cd7d8cd3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d293c5fa575e282b09e51ccabc0fea4>>
 * @relayHash 5d73a886053db0c3167810d478cac2ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 95c94140fecba78cb87b8cfc0cf42eaf05d1a58960bd94f0b354baf1030acfc9
const $aa0c98e1cd7d8cd3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "CsmAiHub"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "conversationReview_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "conversationReview_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "95c94140fecba78cb87b8cfc0cf42eaf05d1a58960bd94f0b354baf1030acfc9",
            "metadata": {},
            "name": "conversationReview_agentIdentityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$aa0c98e1cd7d8cd3$var$node.hash = "340a20f2d50cc5f77582b00676ed5abb";
var $aa0c98e1cd7d8cd3$export$2e2bcd8739ae039 = $aa0c98e1cd7d8cd3$var$node;

});

parcelRegister("aLZPk", function(module, exports) {

let $7d7e40b3b6c6cc5a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7d7e40b3b6c6cc5a$var$load("eDzss"),
    $7d7e40b3b6c6cc5a$var$load("4lJpw")
]).then(()=>parcelRequire('emiB3'));

});


parcelRegister("daeLG", function(module, exports) {

let $9957aa2f484cdafa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9957aa2f484cdafa$var$load("7EUxS").then(()=>parcelRequire('a6zpZ'));

});



parcelRegister("1B1tE", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioChatSimulatorRouteEntry", () => $b0cace4ebf9f1985$export$c4240053c0a5eb9c);

var $kHlOR = parcelRequire("kHlOR");

var $1wb5r = parcelRequire("1wb5r");

var $9BJU1 = parcelRequire("9BJU1");

var $1PvPk = parcelRequire("1PvPk");

var $6xToB = parcelRequire("6xToB");

var $aQoXd = parcelRequire("aQoXd");

var $c7K9Q = parcelRequire("c7K9Q");

var $bJscI = parcelRequire("bJscI");

var $7VVbK = parcelRequire("7VVbK");

var $7jTnu = parcelRequire("7jTnu");

var $ioWDK = parcelRequire("ioWDK");

var $jmvbS = parcelRequire("jmvbS");
const $b0cace4ebf9f1985$export$c4240053c0a5eb9c = (0, $6xToB.createEntry)((0, $c7K9Q.helpCenterSettingsAgentStudioChatSimulatorRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio-chat-simulator',
        entryPoint () {
            if (!(0, $7jTnu.fg)('enable_support_center_agent_studio_page')) return undefined;
            return 0, $jmvbS.csmAgentChatSimulatorPageEntryPoint;
        },
        component: (0, $bJscI.componentWithFG)('enable_support_center_agent_studio_page', (0, $jmvbS.AgentStudioSimulatorComponent), (0, $9BJU1.default)),
        skeleton: (0, $7VVbK.ChatSimulatorLoadingState),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: (0, $ioWDK.agentStudioNavigation),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jmvbS.LazyAgentStudioSimulatorPage)
        ],
        earlyAssets: (0, $1wb5r.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("c7K9Q", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioChatSimulatorRoute", () => $a5e81e63205bb2cd$export$426c3d828fdab50e);
const $a5e81e63205bb2cd$export$426c3d828fdab50e = {
    name: 'helpcenter-settings-agent-studio-chat-simulator',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/simulator',
    exact: true
};

});

parcelRegister("7VVbK", function(module, exports) {

$parcel$export(module.exports, "ChatSimulatorLoadingState", () => $afd77ffccacd4be4$export$3966fd37f06836dd);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $dtyGQ = parcelRequire("dtyGQ");
var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");

var $aVwGC = parcelRequire("aVwGC");
const $afd77ffccacd4be4$var$gridStyles = (0, $5Wv5g.xcss)({
    height: '920px'
});
const $afd77ffccacd4be4$var$leftSidebarStyles = (0, $5Wv5g.xcss)({
    height: '100%',
    paddingBottom: 'space.0'
});
const $afd77ffccacd4be4$var$mainContentStyles = (0, $5Wv5g.xcss)({
    height: '100%'
});
const $afd77ffccacd4be4$var$chatSectionStyles = (0, $5Wv5g.xcss)({
    height: '100%',
    width: '100%',
    paddingTop: 'space.100',
    paddingBottom: 'space.0',
    paddingInline: 'space.200',
    overflow: 'auto',
    maxWidth: 'min(800px, 50vw)',
    marginInline: 'auto'
});
const $afd77ffccacd4be4$var$conversationListStyle = (0, $5Wv5g.xcss)({
    padding: 'space.300'
});
const $afd77ffccacd4be4$export$3966fd37f06836dd = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dtyGQ.default), {
        xcss: $afd77ffccacd4be4$var$gridStyles,
        rowGap: "space.200",
        columnGap: "space.0",
        templateColumns: "360px 1fr",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9LyfF.default), {
                alignBlock: "start",
                xcss: $afd77ffccacd4be4$var$leftSidebarStyles,
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.default), {
                        padding: "space.300",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aVwGC.default), {
                            isShimmering: true,
                            width: "100%",
                            height: "32px",
                            borderRadius: 3
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9LyfF.default), {
                        space: "space.100",
                        xcss: $afd77ffccacd4be4$var$conversationListStyle,
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aVwGC.default), {
                                isShimmering: true,
                                width: "100%",
                                height: "36px",
                                borderRadius: 3
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aVwGC.default), {
                                isShimmering: true,
                                width: "100%",
                                height: "36px",
                                borderRadius: 3
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aVwGC.default), {
                                isShimmering: true,
                                width: "100%",
                                height: "36px",
                                borderRadius: 3
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aVwGC.default), {
                                isShimmering: true,
                                width: "100%",
                                height: "36px",
                                borderRadius: 3
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9LyfF.default), {
                xcss: $afd77ffccacd4be4$var$mainContentStyles,
                spread: "space-between",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.default), {
                        padding: "space.300",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aVwGC.default), {
                            isShimmering: true,
                            width: "50%",
                            height: "32px",
                            borderRadius: 0
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9LyfF.default), {
                        xcss: $afd77ffccacd4be4$var$chatSectionStyles,
                        alignBlock: "end",
                        space: "space.200",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aVwGC.default), {
                                isShimmering: true,
                                width: "440px",
                                height: "120px",
                                borderRadius: 2
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9LyfF.default), {
                                space: "space.050",
                                alignInline: "end",
                                children: [
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aVwGC.default), {
                                        isShimmering: true,
                                        width: "240px",
                                        height: "32px",
                                        borderRadius: 8
                                    }),
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aVwGC.default), {
                                        isShimmering: true,
                                        width: "320px",
                                        height: "32px",
                                        borderRadius: 8
                                    }),
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aVwGC.default), {
                                        isShimmering: true,
                                        width: "180px",
                                        height: "32px",
                                        borderRadius: 8
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9LyfF.default), {
                                space: "space.100",
                                children: [
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aVwGC.default), {
                                        isShimmering: true,
                                        width: "100%",
                                        height: "84px",
                                        borderRadius: 8
                                    }),
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aVwGC.default), {
                                        isShimmering: true,
                                        width: "100%",
                                        height: "40px",
                                        borderRadius: 0
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });

});


parcelRegister("a155r", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioConversationReviewRouteEntry", () => $3272e411d1941a11$export$8fa9ba2d9a9de6f8);

var $kHlOR = parcelRequire("kHlOR");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $1wb5r = parcelRequire("1wb5r");

var $6xToB = parcelRequire("6xToB");

var $aQoXd = parcelRequire("aQoXd");

var $jO8A4 = parcelRequire("jO8A4");

var $cZZ6H = parcelRequire("cZZ6H");

var $bJscI = parcelRequire("bJscI");

var $7jTnu = parcelRequire("7jTnu");

var $jmvbS = parcelRequire("jmvbS");

var $ioWDK = parcelRequire("ioWDK");
const $3272e411d1941a11$var$getConversationReviewResources = ()=>(0, $cZZ6H.resources).conversationReview;
const $3272e411d1941a11$export$8fa9ba2d9a9de6f8 = (0, $6xToB.createEntry)((0, $jO8A4.helpCenterSettingsAgentStudioConversationReviewRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio.conversation-review',
        entryPoint () {
            if (!(0, $7jTnu.fg)('enable_support_center_agent_studio_page')) return undefined;
            return 0, $jmvbS.csmAgentConversationReviewPageEntryPoint;
        },
        component: (0, $bJscI.componentWithFG)('enable_support_center_agent_studio_page', (0, $jmvbS.AgentStudioConversationReview), (0, $9BJU1.default)),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: (0, $ioWDK.agentStudioNavigation),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            ...$3272e411d1941a11$var$getConversationReviewResources()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jmvbS.LazyAgentStudioConversationReviewPage)
        ],
        earlyAssets: (0, $1wb5r.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("jO8A4", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioConversationReviewRoute", () => $6f4742ebd51ba056$export$6d3fd8c6a2cde9ea);
const $6f4742ebd51ba056$export$6d3fd8c6a2cde9ea = {
    name: 'helpcenter-settings-agent-studio-conversation-review',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/review/:conversationId?',
    exact: true
};

});

parcelRegister("cZZ6H", function(module, exports) {

$parcel$export(module.exports, "resources", () => $976a951d7d1f1498$export$bc99aaabaf7b70a7);

var $l4zDK = parcelRequire("l4zDK");
// packages/ai-mate/csm-conversation-review/src/ui/index.tsx
const $976a951d7d1f1498$var$conversationRouteNameAndPathFields = {
    name: 'conversationReview',
    path: '/:conversationId?'
};
const $976a951d7d1f1498$export$bc99aaabaf7b70a7 = {
    conversationReview: [
        (0, $l4zDK.conversationsResource),
        (0, $l4zDK.messagesResource)
    ]
};

});
parcelRegister("l4zDK", function(module, exports) {

$parcel$export(module.exports, "conversationsResource", () => $f5759e13b66327b0$export$666da16fe604f76a);
$parcel$export(module.exports, "messagesResource", () => $f5759e13b66327b0$export$e5eacbe7ea3678fe);

var $l1VxS = parcelRequire("l1VxS");

var $4QsHs = parcelRequire("4QsHs");

var $67QpS = parcelRequire("67QpS");

var $1KArU = parcelRequire("1KArU");

var $6tcei = parcelRequire("6tcei");
const $f5759e13b66327b0$export$666da16fe604f76a = (0, $l1VxS.createResource)({
    type: 'CONVERSATIONS',
    getKey: (ctx)=>`conversations-${(0, $67QpS.serialiseFiltersQueryToSearchParams)((0, $67QpS.getFiltersQuery)(ctx.query)).toString()}-${ctx.query.csmAiHubId}`,
    getData: async (ctx)=>{
        return (0, $6tcei.fetchConversations)({
            csmHubId: ctx.query.csmAiHubId,
            cursor: ctx.query.cursor,
            filters: ctx.query
        });
    },
    isBrowserOnly: true
});
const $f5759e13b66327b0$export$e5eacbe7ea3678fe = (0, $l1VxS.createResource)({
    type: 'CONVERSATION_MESSAGES',
    getKey: ({ match: match })=>`conversation-messages-${match.params.conversationId}`,
    getData: async ({ match: match })=>{
        const conversationId = match.params.conversationId;
        if (!conversationId) return {
            messages: [],
            error: {
                errorMessage: 'No conversationId provided',
                errors: [
                    'Missing conversationId'
                ],
                statusCode: 400
            }
        };
        const headers = (0, $4QsHs.createHeaders)();
        return fetch(`${(0, $1KArU.API_GATEWAY_BASE_URL)}/assist/csm/v2/reporting/conversations/${match.params.conversationId}/messages`, {
            method: 'GET',
            headers: headers
        }).then((response)=>response.json()).then((data)=>{
            const conversation = data.conversation;
            const messages = data.messages;
            const error = 'errorMessage' in data ? data : undefined;
            return {
                conversation: conversation,
                messages: messages,
                error: error
            };
        });
    },
    isBrowserOnly: true
});

});
parcelRegister("4QsHs", function(module, exports) {

$parcel$export(module.exports, "CLOUD_ID_HEADER", () => $3e045bcd3f060b3f$export$220635283667d336);
$parcel$export(module.exports, "createHeaders", () => $3e045bcd3f060b3f$export$197579c449ddabf4);
$parcel$export(module.exports, "getRequestHeadersForAnnotation", () => $3e045bcd3f060b3f$export$61dc7354b71f29a6);
const $3e045bcd3f060b3f$var$PRODUCT_HEADER = 'x-product';
const $3e045bcd3f060b3f$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
const $3e045bcd3f060b3f$export$220635283667d336 = 'x-cloudid';
const $3e045bcd3f060b3f$var$JIRA_PRODUCT = 'jira';
const $3e045bcd3f060b3f$var$CSM_AI_EXPERIENCE_ID = 'csm-ai';
function $3e045bcd3f060b3f$export$197579c449ddabf4(init) {
    return new Headers({
        [$3e045bcd3f060b3f$var$PRODUCT_HEADER]: $3e045bcd3f060b3f$var$JIRA_PRODUCT,
        [$3e045bcd3f060b3f$var$EXPERIENCE_ID_HEADER]: $3e045bcd3f060b3f$var$CSM_AI_EXPERIENCE_ID,
        ...init || {}
    });
}
function $3e045bcd3f060b3f$export$61dc7354b71f29a6(cloudId) {
    const headers = $3e045bcd3f060b3f$export$197579c449ddabf4({
        ...cloudId ? {
            [$3e045bcd3f060b3f$export$220635283667d336]: cloudId
        } : {},
        'Content-Type': 'application/json'
    });
    return headers;
}

});

parcelRegister("67QpS", function(module, exports) {

$parcel$export(module.exports, "BUILT_IN_FILTERS_BY_PARAM", () => $475c0e507cf1b0fa$export$f0b7684dd99bf7f2);
$parcel$export(module.exports, "isValidDateQueryValue", () => $475c0e507cf1b0fa$export$5e471de6d5eefc41);
$parcel$export(module.exports, "isFilterField", () => $475c0e507cf1b0fa$export$d8a98f7533d78e24);
$parcel$export(module.exports, "serialiseFiltersQueryToSearchParams", () => $475c0e507cf1b0fa$export$4966dc62d022f1b7);
$parcel$export(module.exports, "getFiltersQuery", () => $475c0e507cf1b0fa$export$ada173b2ef64ad5d);

var $LFmXM = parcelRequire("LFmXM");

var $g3m9J = parcelRequire("g3m9J");
const $475c0e507cf1b0fa$var$SUPPORTED_FILTER_TYPES = [
    'string',
    'enum',
    'number',
    'boolean',
    'date'
];
const $475c0e507cf1b0fa$export$f0b7684dd99bf7f2 = {
    type: {
        label: 'Conversation type',
        param: 'type',
        type: 'enum',
        options: [
            {
                label: 'Test',
                value: 'test'
            },
            {
                label: 'Real',
                value: 'real'
            },
            {
                label: 'Imported',
                value: 'imported'
            }
        ]
    },
    reviewStatus: {
        label: 'Conversation',
        param: 'reviewStatus',
        type: 'enum',
        options: [
            {
                label: 'Good conversation',
                value: 'good'
            },
            {
                label: 'Bad conversation',
                value: 'bad'
            },
            {
                label: 'Not review',
                value: 'not-reviewed'
            }
        ]
    },
    messageReviewStatus: {
        label: 'Response',
        param: 'messageReviewStatus',
        type: 'enum',
        options: [
            {
                label: 'Reviewed',
                value: 'reviewed'
            },
            {
                label: 'Not reviewed',
                value: 'not-reviewed'
            }
        ]
    },
    lastUpdated: {
        label: 'Last updated',
        param: 'lastUpdated',
        type: 'date'
    },
    feedback: {
        label: 'Customer feedback',
        param: 'feedback',
        type: 'enum',
        options: [
            {
                label: 'Good response',
                value: 'good'
            },
            {
                label: 'Bad response',
                value: 'bad'
            }
        ]
    },
    tags: {
        label: 'Review tags',
        param: 'tags',
        type: 'enum',
        options: [
            (0, $g3m9J.accuracyTagsGroup),
            (0, $g3m9J.languageTagsGroup),
            (0, $g3m9J.problemTagsGroup)
        ]
    }
};
const $475c0e507cf1b0fa$export$3060295572f39fc0 = Object.values($475c0e507cf1b0fa$export$f0b7684dd99bf7f2);
const $475c0e507cf1b0fa$export$7be404e211e7c3aa = new Map($475c0e507cf1b0fa$export$3060295572f39fc0.map((filter)=>[
        filter.param,
        filter
    ]));
const $475c0e507cf1b0fa$export$5e471de6d5eefc41 = (value)=>{
    if (typeof value === 'string') return [
        'today',
        'yesterday',
        'past7Days',
        'past30Days'
    ].includes(value);
    if (typeof value === 'object' && value) {
        if ('to' in value && 'from' in value) return [
            'string',
            'undefined'
        ].includes(typeof value.to) && [
            'string',
            'undefined'
        ].includes(typeof value.from);
        if ('to' in value) return [
            'string',
            'undefined'
        ].includes(typeof value.to);
        if ('from' in value) return [
            'string',
            'undefined'
        ].includes(typeof value.from);
    }
    return false;
};
const $475c0e507cf1b0fa$var$BUILT_IN_FILTER_QUERY_PARAMS = $475c0e507cf1b0fa$export$3060295572f39fc0.map(({ param: param })=>param);
const $475c0e507cf1b0fa$export$53c0ae385683a670 = (param)=>{
    return $475c0e507cf1b0fa$var$BUILT_IN_FILTER_QUERY_PARAMS.some((x)=>x === param);
};
const $475c0e507cf1b0fa$export$d8a98f7533d78e24 = (param)=>{
    return $475c0e507cf1b0fa$export$53c0ae385683a670(param);
};
const $475c0e507cf1b0fa$var$QUERY_STRING_PARSERS = {
    string: (value)=>value,
    number: (value)=>isNaN(Number(value)) ? undefined : Number(value),
    boolean: (value)=>[
            'true',
            'false'
        ].some((v)=>v === value) ? value : undefined,
    enum: (value)=>value.split(','),
    date: (value)=>{
        const betweenMatch = value.match(/^between\.(\d{4}-\d{2}-\d{2}(?:T.*Z)?)?\.(\d{4}-\d{2}-\d{2}(?:T.*Z)?)?$/);
        if (betweenMatch) {
            const [, a, b] = betweenMatch !== null && betweenMatch !== void 0 ? betweenMatch : [];
            const from = Boolean(a) ? a : undefined;
            const to = Boolean(b) ? b : undefined;
            return {
                from: from,
                to: to
            };
        }
        const fromToMatch = value.match(/^(from|to)\.(\d{4}-\d{2}-\d{2}(?:T.*Z)?)$/);
        if (fromToMatch) {
            const [, operation, date] = fromToMatch !== null && fromToMatch !== void 0 ? fromToMatch : [];
            return operation === 'from' ? {
                from: date
            } : {
                to: date
            };
        }
        if ($475c0e507cf1b0fa$export$5e471de6d5eefc41(value)) return value;
    }
};
const $475c0e507cf1b0fa$var$startOfDate = (date)=>{
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
};
const $475c0e507cf1b0fa$var$normaliseDateString = (date, endOfDate)=>{
    const isDateOnlyString = /^\d{4}-\d{2}-\d{2}$/.test(date);
    if (!isDateOnlyString) return new Date(date);
    const d = new Date(date);
    if (!endOfDate) d.setHours(0, 0, 0, 0);
    else d.setHours(23, 59, 59, 999);
    return d;
};
const $475c0e507cf1b0fa$export$2ca7fe1ffae7d4ec = {
    type: (value)=>[
            [
                'conversationType',
                String(value)
            ]
        ],
    lastUpdated: (value)=>{
        if (typeof value === 'string') switch(value){
            case 'today':
                return [
                    [
                        'updatedAfter',
                        $475c0e507cf1b0fa$var$startOfDate(new Date()).toISOString()
                    ]
                ];
            case 'yesterday':
                return [
                    [
                        'updatedAfter',
                        $475c0e507cf1b0fa$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 1))).toISOString()
                    ],
                    [
                        'updatedBefore',
                        $475c0e507cf1b0fa$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 0))).toISOString()
                    ]
                ];
            case 'past7Days':
                return [
                    [
                        'updatedAfter',
                        $475c0e507cf1b0fa$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 7))).toISOString()
                    ]
                ];
            case 'past30Days':
                return [
                    [
                        'updatedAfter',
                        $475c0e507cf1b0fa$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 30))).toISOString()
                    ]
                ];
        }
        if (typeof value === 'object') {
            if ('from' in value && 'to' in value && value.from && value.to) return [
                [
                    'updatedAfter',
                    $475c0e507cf1b0fa$var$normaliseDateString(value.from).toISOString()
                ],
                [
                    'updatedBefore',
                    $475c0e507cf1b0fa$var$normaliseDateString(value.to, true).toISOString()
                ]
            ];
            if ('from' in value && value.from) return [
                [
                    'updatedAfter',
                    $475c0e507cf1b0fa$var$normaliseDateString(value.from).toISOString()
                ]
            ];
            if ('to' in value && value.to) return [
                [
                    'updatedBefore',
                    $475c0e507cf1b0fa$var$normaliseDateString(value.to).toISOString()
                ]
            ];
        }
        return [];
    },
    feedback: (value)=>[
            [
                'customerFeedback',
                String(value)
            ]
        ],
    reviewStatus: (value)=>[
            [
                'conversationReviewStatus',
                String(value)
            ]
        ],
    messageReviewStatus: (value)=>[
            [
                'messageReviewStatus',
                String(value)
            ]
        ],
    tags: (value)=>[
            [
                'annotatedLabels',
                String(value)
            ]
        ]
};
const $475c0e507cf1b0fa$export$49da2961ae0c0fca = {
    ...$475c0e507cf1b0fa$export$2ca7fe1ffae7d4ec,
    lastUpdated: (value)=>{
        if (typeof value === 'string') switch(value){
            case 'today':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $475c0e507cf1b0fa$var$startOfDate(new Date()).toISOString()
                    ]
                ];
            case 'yesterday':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $475c0e507cf1b0fa$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 1))).toISOString()
                    ],
                    [
                        'lastMessageTimestampBefore',
                        $475c0e507cf1b0fa$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 0))).toISOString()
                    ]
                ];
            case 'past7Days':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $475c0e507cf1b0fa$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 7))).toISOString()
                    ]
                ];
            case 'past30Days':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $475c0e507cf1b0fa$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 30))).toISOString()
                    ]
                ];
        }
        if (typeof value === 'object') {
            if ('from' in value && 'to' in value && value.from && value.to) return [
                [
                    'lastMessageTimestampAfter',
                    $475c0e507cf1b0fa$var$normaliseDateString(value.from).toISOString()
                ],
                [
                    'lastMessageTimestampBefore',
                    $475c0e507cf1b0fa$var$normaliseDateString(value.to, true).toISOString()
                ]
            ];
            if ('from' in value && value.from) return [
                [
                    'lastMessageTimestampAfter',
                    $475c0e507cf1b0fa$var$normaliseDateString(value.from).toISOString()
                ]
            ];
            if ('to' in value && value.to) return [
                [
                    'lastMessageTimestampBefore',
                    $475c0e507cf1b0fa$var$normaliseDateString(value.to).toISOString()
                ]
            ];
        }
        return [];
    }
};
const $475c0e507cf1b0fa$export$4966dc62d022f1b7 = (0, $LFmXM.default)((query)=>{
    return Object.entries(query).reduce((searchParams, [param, value])=>{
        const filters = $475c0e507cf1b0fa$export$7be404e211e7c3aa;
        const filter = filters.get(param);
        if (!filter || typeof value === 'undefined') return searchParams;
        const serialisers = $475c0e507cf1b0fa$export$49da2961ae0c0fca;
        const serialiser = serialisers[filter.param];
        if (filter.param in serialisers) {
            const params = serialiser(value);
            params.forEach(([key, value])=>{
                searchParams.append(key, value);
            });
            return searchParams;
        }
        return searchParams;
    }, new URLSearchParams());
});
const $475c0e507cf1b0fa$export$ada173b2ef64ad5d = (0, $LFmXM.default)((query)=>{
    const filters = $475c0e507cf1b0fa$export$7be404e211e7c3aa;
    return Object.entries(query).reduce((acc, [param, value])=>{
        if (!$475c0e507cf1b0fa$export$d8a98f7533d78e24(param)) return acc;
        const filter = filters.get(param);
        if (!filter) return acc;
        try {
            const parsedValue = $475c0e507cf1b0fa$var$QUERY_STRING_PARSERS[filter.type](value);
            return {
                ...acc,
                [param]: parsedValue
            };
        } catch (err) {
            return acc;
        }
    }, {});
});

});
parcelRegister("g3m9J", function(module, exports) {

$parcel$export(module.exports, "accuracyTagsGroup", () => $bafe1cdc6351df2f$export$f592d323cd45fe0b);
$parcel$export(module.exports, "languageTagsGroup", () => $bafe1cdc6351df2f$export$bd57e646b9ca4d6);
$parcel$export(module.exports, "problemTagsGroup", () => $bafe1cdc6351df2f$export$f12ac532d5145c52);
const $bafe1cdc6351df2f$export$40b86a6296d7a6cc = [
    {
        label: 'Accurate',
        value: 'accurate'
    },
    {
        label: 'Not accurate',
        value: 'not-accurate'
    }
];
const $bafe1cdc6351df2f$export$f592d323cd45fe0b = {
    label: 'Accuracy',
    options: $bafe1cdc6351df2f$export$40b86a6296d7a6cc
};
const $bafe1cdc6351df2f$export$f1009b3c58b25589 = [
    {
        label: 'Easy to understand',
        value: 'easy-to-understand'
    },
    {
        label: 'Hard to understand',
        value: 'hard-to-understand'
    },
    {
        label: 'Concise',
        value: 'concise'
    },
    {
        label: 'Verbose',
        value: 'verbose'
    },
    {
        label: 'Grammatical errors',
        value: 'grammatical-errors'
    },
    {
        label: 'Formatting errors',
        value: 'formatting-errors'
    },
    {
        label: 'Incorrect tone',
        value: 'incorrect-tone'
    }
];
const $bafe1cdc6351df2f$export$bd57e646b9ca4d6 = {
    label: 'Language',
    options: $bafe1cdc6351df2f$export$f1009b3c58b25589
};
const $bafe1cdc6351df2f$export$ea5f6f7f4df4b955 = [
    {
        label: 'Vague question',
        value: 'vaque-question'
    },
    {
        label: 'Irrelevant answer',
        value: 'irrelevant-answer'
    },
    {
        label: 'Human required',
        value: 'human-required'
    },
    {
        label: 'Content not retrieved',
        value: 'content-not-retrieved'
    },
    {
        label: 'Missing links',
        value: 'missing-links'
    },
    {
        label: 'Incorrect source',
        value: 'incorrect-source'
    }
];
const $bafe1cdc6351df2f$export$f12ac532d5145c52 = {
    label: 'Problems',
    options: $bafe1cdc6351df2f$export$ea5f6f7f4df4b955
};

});


parcelRegister("1KArU", function(module, exports) {

$parcel$export(module.exports, "API_GATEWAY_BASE_URL", () => $14665c60bf22b0f9$export$d9629d145ee9933b);
const $14665c60bf22b0f9$export$d9629d145ee9933b = '/gateway/api';
function $14665c60bf22b0f9$export$23da1d24a38b0bde() {
    const hostname = window.location.hostname;
    return hostname.includes('localhost') || hostname.includes('.stg.internal.atlassian') || hostname.includes('.stg.atlassian');
}

});

parcelRegister("6tcei", function(module, exports) {

$parcel$export(module.exports, "fetchConversations", () => $4b5ef007e02f62f8$export$b4d0565c06de18cb);

var $4QsHs = parcelRequire("4QsHs");

var $67QpS = parcelRequire("67QpS");

var $1KArU = parcelRequire("1KArU");

var $4Yyos = parcelRequire("4Yyos");
const $4b5ef007e02f62f8$export$b4d0565c06de18cb = async ({ csmHubId: csmHubId, cursor: cursor, filters: filters })=>{
    const headers = (0, $4QsHs.createHeaders)();
    const queryString = (0, $67QpS.serialiseFiltersQueryToSearchParams)((0, $67QpS.getFiltersQuery)(filters));
    if (cursor) queryString.set('cursor', cursor);
    const baseUrl = `${(0, $1KArU.API_GATEWAY_BASE_URL)}/assist/csm/v2/reporting/${csmHubId}/conversations`;
    return fetch(`${baseUrl}?${queryString}`, {
        method: 'GET',
        headers: headers
    }).then((response)=>response.json()).then((data)=>{
        const conversations = data.items.filter((0, $4Yyos.isNotExcludedOwner));
        const error = 'errorMessage' in data ? data : undefined;
        return {
            conversations: conversations,
            hasNext: data.hasNext || false,
            cursor: data.cursor,
            error: error
        };
    });
};

});
parcelRegister("4Yyos", function(module, exports) {

$parcel$export(module.exports, "isNotExcludedOwner", () => $39f771dfbc0f57b7$export$f4707ebc2561f73d);
// Users who's conversations should be excluded from the list
const $39f771dfbc0f57b7$export$9112ec7e6c72159b = [
    // Staging test bot
    'ari:cloud:identity::user/61c2c7a390cfd2007154ede7',
    // Prod test bot - 'cst-e2e-test-bot
    'ari:cloud:identity::user/61bc6c272f24e70068bf462a'
];
const $39f771dfbc0f57b7$export$f4707ebc2561f73d = (c)=>{
    return !$39f771dfbc0f57b7$export$9112ec7e6c72159b.includes(c.owner);
};

});





parcelRegister("brOp7", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioHandoffRouteEntry", () => $4a632b5165f09623$export$df69744b9adaa993);

var $7jTnu = parcelRequire("7jTnu");

var $1wb5r = parcelRequire("1wb5r");

var $9BJU1 = parcelRequire("9BJU1");

var $1PvPk = parcelRequire("1PvPk");

var $6xToB = parcelRequire("6xToB");

var $aQoXd = parcelRequire("aQoXd");

var $8hrqj = parcelRequire("8hrqj");

var $ioWDK = parcelRequire("ioWDK");

var $jmvbS = parcelRequire("jmvbS");
const $4a632b5165f09623$export$df69744b9adaa993 = (0, $6xToB.createEntry)((0, $8hrqj.helpCenterSettingsAgentStudioHandoffRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio-handoff',
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $7jTnu.fg)('csm_ai_agent_builder_handoff') ? (0, $jmvbS.csmAgentHandoffPageEntryPoint) : undefined;
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: (0, $ioWDK.agentStudioNavigation),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        earlyAssets: (0, $1wb5r.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("8hrqj", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioHandoffRoute", () => $3d38fd10ace00879$export$d23d0e34831b4de5);
const $3d38fd10ace00879$export$d23d0e34831b4de5 = {
    name: 'helpcenter-settings-agent-studio-handoff',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/handoff',
    exact: true
};

});


parcelRegister("7JuPt", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioKnowledgeRouteEntry", () => $78a6dd8384e84619$export$6d22d206a282d6a9);

var $7jTnu = parcelRequire("7jTnu");

var $1wb5r = parcelRequire("1wb5r");

var $9BJU1 = parcelRequire("9BJU1");

var $1PvPk = parcelRequire("1PvPk");

var $6xToB = parcelRequire("6xToB");

var $aQoXd = parcelRequire("aQoXd");

var $fs6rV = parcelRequire("fs6rV");

var $lS82J = parcelRequire("lS82J");

var $ioWDK = parcelRequire("ioWDK");

var $jmvbS = parcelRequire("jmvbS");
const $78a6dd8384e84619$export$6d22d206a282d6a9 = (0, $6xToB.createEntry)((0, $lS82J.helpCenterSettingsAgentStudioKnowledgeRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio-knowledge',
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $7jTnu.fg)('enable_support_center_agent_studio_page') ? (0, $jmvbS.agentStudioKnowledgePageEntryPoint) : undefined;
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: (0, $ioWDK.agentStudioNavigation),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $fs6rV.knowledgeSourcesResource)
        ],
        earlyAssets: (0, $1wb5r.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("fs6rV", function(module, exports) {

$parcel$export(module.exports, "knowledgeSourcesResource", () => $b3fe793bbed331ca$export$98ae61e83ea268b1);

var $l1VxS = parcelRequire("l1VxS");
const $b3fe793bbed331ca$var$TWENTY_FOUR_HOURS_IN_MS = 86400000;

const $b3fe793bbed331ca$export$98ae61e83ea268b1 = (0, $l1VxS.createResource)({
    type: 'CSM_AGENT_CONFIGURATION_KNOWLEDGE_SOURCES',
    getKey: (routerContext)=>`knowledge-sources-${routerContext.query.agentId}`,
    getData: (routerContext)=>(parcelRequire("7riWt")).then((module)=>module.default(routerContext.query.agentId)),
    maxAge: $b3fe793bbed331ca$var$TWENTY_FOUR_HOURS_IN_MS,
    isBrowserOnly: true
});

});
parcelRegister("7riWt", function(module, exports) {

let $56a9bf861321c88b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $56a9bf861321c88b$var$load("14uDU").then(()=>parcelRequire('6SR8O'));

});


parcelRegister("lS82J", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioKnowledgeRoute", () => $477aa41954592fee$export$f1df26b41169b43);
const $477aa41954592fee$export$f1df26b41169b43 = {
    name: 'helpcenter-settings-agent-studio-knowledge',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/knowledge',
    exact: true
};

});


parcelRegister("kTUT3", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioRouteEntry", () => $d2c2d3de713052bf$export$5328c10e46075e4d);

var $7jTnu = parcelRequire("7jTnu");

var $kHlOR = parcelRequire("kHlOR");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $aQoXd = parcelRequire("aQoXd");

var $1wb5r = parcelRequire("1wb5r");

var $6xToB = parcelRequire("6xToB");

var $CsWXk = parcelRequire("CsWXk");

var $bJscI = parcelRequire("bJscI");

var $jmvbS = parcelRequire("jmvbS");

var $ioWDK = parcelRequire("ioWDK");
const $d2c2d3de713052bf$export$5328c10e46075e4d = (0, $6xToB.createEntry)((0, $CsWXk.helpCenterSettingsAgentStudioRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio',
        // For either return undefined scenario, it will fallback to the component config below
        entryPoint () {
            if (!(0, $7jTnu.fg)('enable_support_center_agent_studio_page')) return undefined;
            return 0, $jmvbS.csmAgentOverviewPageEntryPoint;
        },
        component: (0, $bJscI.componentWithFG)('enable_support_center_agent_studio_page', (0, $jmvbS.AgentStudioOverviewPage), (0, $9BJU1.default)),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: (0, $ioWDK.agentStudioNavigation),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jmvbS.LazyAgentStudioOverviewPage)
        ],
        earlyAssets: (0, $1wb5r.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("CsWXk", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioRoute", () => $5328927e5e2ee980$export$b8b0efb16984db50);
const $5328927e5e2ee980$export$b8b0efb16984db50 = {
    name: 'helpcenter-settings-agent-studio',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent',
    exact: true
};

});


parcelRegister("cHL3P", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsRouteEntry", () => $6c409a0ed730b565$export$13d5cfdc3231d970);

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $9WgdA = parcelRequire("9WgdA");

var $7tVpB = parcelRequire("7tVpB");
const $6c409a0ed730b565$export$13d5cfdc3231d970 = (0, $6xToB.createEntry)((0, $9WgdA.helpCenterSettingsAnalyticsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.analytics',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
        },
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $7jTnu.fg)('jcs-analytics-page') ? (0, $7tVpB.helpCenterSettingsAnalyticsRoutePageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ]
    }));

});
parcelRegister("9WgdA", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsRoute", () => $8a2496471cbe6288$export$1487d4661960397f);
const $8a2496471cbe6288$export$1487d4661960397f = {
    exact: true,
    name: 'customer-service-helpcenter-analytics',
    path: '/jira/helpcenter/analytics'
};

});

parcelRegister("7tVpB", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsRoutePageEntryPoint", () => $0282c14db2b50045$export$cb0b3a882806ef6e);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $176gs = parcelRequire("176gs");
const $0282c14db2b50045$export$cb0b3a882806ef6e = (0, $g8uYY.createPageEntryPoint)({
    main: $176gs.helpCenterSettingsAnalyticsAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("176gs", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsAppEntryPoint", () => $a93f80fd61957fa1$export$fa405dadb950b4a6);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $a93f80fd61957fa1$export$fa405dadb950b4a6 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("kl1Z9")), {
        moduleId: "19032ae8",
        priority: "interaction"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("kl1Z9", function(module, exports) {

let $ece74f0ac2b673ab$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    $ece74f0ac2b673ab$var$load("1VRB2"),
    $ece74f0ac2b673ab$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("5RPny"), 4)),
    $ece74f0ac2b673ab$var$load("7vqGd"),
    $ece74f0ac2b673ab$var$load("1Y4bq"),
    $ece74f0ac2b673ab$var$load("eDzss"),
    $ece74f0ac2b673ab$var$load("7PLvu")
]).then(()=>parcelRequire('f4Ym1'));

});




parcelRegister("fSwF2", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesRouteEntry", () => $557a37e34b1dceed$export$dcf98310ab461eb0);

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $5df3d = parcelRequire("5df3d");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $jbd9a = parcelRequire("jbd9a");
const $557a37e34b1dceed$export$dcf98310ab461eb0 = (0, $6xToB.createEntry)((0, $5df3d.helpCenterSettingsArticlesRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.articles',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $7jTnu.fg)('jcs_master_flag') ? (0, $jbd9a.helpCenterSettingArticlesAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("5df3d", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesRoute", () => $b6c69d3e551bf1b0$export$6445613754b0db30);
const $b6c69d3e551bf1b0$export$6445613754b0db30 = {
    name: 'helpcenter-settings-articles',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles',
    exact: true
};

});

parcelRegister("jbd9a", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingArticlesAppPageEntryPoint", () => $859703d541edd309$export$5f683051fd990adb);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $5Tx3j = parcelRequire("5Tx3j");
const $859703d541edd309$export$5f683051fd990adb = (0, $g8uYY.createPageEntryPoint)({
    main: $5Tx3j.HelpCenterSettingsArticlesAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("5Tx3j", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsArticlesAppEntryPoint", () => $ab13940cb2c3ceca$export$ba888b162abf6368);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $ab13940cb2c3ceca$export$ba888b162abf6368 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("9zToG")), {
        moduleId: "8c0e0839",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("9zToG", function(module, exports) {

let $6f925aa3c889cceb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6f925aa3c889cceb$var$load("1VRB2"),
    $6f925aa3c889cceb$var$load("bABhq"),
    $6f925aa3c889cceb$var$load("7sgjQ")
]).then(()=>parcelRequire('aOmEt'));

});




parcelRegister("4VbNK", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesViewArticleRouteEntry", () => $50eb33ded365fa9b$export$d14f4c2b666bbb54);

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $4oz3c = parcelRequire("4oz3c");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $3Npex = parcelRequire("3Npex");
const $50eb33ded365fa9b$export$d14f4c2b666bbb54 = (0, $6xToB.createEntry)((0, $4oz3c.helpCenterSettingsArticlesViewArticleRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.articles-view-article',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $7jTnu.fg)('jcs_master_flag') ? (0, $3Npex.helpCenterSettingViewArticleAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("4oz3c", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesViewArticleRoute", () => $57f64524b25ffba6$export$c5c6fbcb1f26b87b);
const $57f64524b25ffba6$export$c5c6fbcb1f26b87b = {
    name: 'helpcenter-settings-articles-view-article',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId',
    exact: true
};

});

parcelRegister("3Npex", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingViewArticleAppPageEntryPoint", () => $94dcbb3f1f3e9d5d$export$7f08ea9d5c2912ad);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $bIezk = parcelRequire("bIezk");
const $94dcbb3f1f3e9d5d$export$7f08ea9d5c2912ad = (0, $g8uYY.createPageEntryPoint)({
    main: $bIezk.HelpCenterSettingsArticlesViewArticleAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("bIezk", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsArticlesViewArticleAppEntryPoint", () => $02c8add95f28b39d$export$31df33b35c5b2ee);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $02c8add95f28b39d$export$31df33b35c5b2ee = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("cr7yM")), {
        moduleId: "6cb514e3",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("cr7yM", function(module, exports) {

let $90dddeea5a610163$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $90dddeea5a610163$var$load("lnf4N").then(()=>parcelRequire('840FM'));

});




parcelRegister("25Xvp", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsBrandingRouteEntry", () => $cc12446ed59acf26$export$5ee7fbd23c469c7);

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $hk17k = parcelRequire("hk17k");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $gwjJa = parcelRequire("gwjJa");
const $cc12446ed59acf26$export$5ee7fbd23c469c7 = (0, $6xToB.createEntry)((0, $hk17k.helpCenterSettingsBrandingRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.branding',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint () {
            if ((0, $7jTnu.fg)('jcs-global-branding')) return 0, $gwjJa.helpCenterSettingBrandingAppPageEntryPoint;
            return undefined;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("hk17k", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsBrandingRoute", () => $e97eefade00572d4$export$f70734f5d2d3d52b);
const $e97eefade00572d4$export$f70734f5d2d3d52b = {
    exact: true,
    name: 'helpcenter-settings-branding',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/branding'
};

});

parcelRegister("gwjJa", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingBrandingAppPageEntryPoint", () => $114b94b4bc86d507$export$bb128cb1d0aaba4d);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $3OGRB = parcelRequire("3OGRB");
const $114b94b4bc86d507$export$bb128cb1d0aaba4d = (0, $g8uYY.createPageEntryPoint)({
    main: $3OGRB.helpCenterSettingBrandingAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("3OGRB", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingBrandingAppEntryPoint", () => $44063b95641e944b$export$f1525531cb4c9a9c);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

var $cNzOo = parcelRequire("cNzOo");

const $44063b95641e944b$export$f1525531cb4c9a9c = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("anuLN")), {
        moduleId: "b3034233",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                uiBrandingQuery: {
                    parameters: $cNzOo.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterId: helpCenterId || '',
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("cNzOo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60c40206430996f6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74b907751b14d3428974c967b06e46e1>>
 * @relayHash c579d7d60c1c98be9b1e70d9c09624bf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c4b72f0c6488e1e579480e28250d5f23967bfee0292f482de71fa508c34f20a
const $60c40206430996f6$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4c4b72f0c6488e1e579480e28250d5f23967bfee0292f482de71fa508c34f20a",
        "metadata": {},
        "name": "uiBrandingQuery",
        "operationKind": "query",
        "text": null
    }
};
var $60c40206430996f6$export$2e2bcd8739ae039 = $60c40206430996f6$var$node;

});

parcelRegister("anuLN", function(module, exports) {

let $78e3eb9c1d353f45$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $78e3eb9c1d353f45$var$load("dTUsO").then(()=>parcelRequire('dILzZ'));

});




parcelRegister("5uVut", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCreateArticleRouteEntry", () => $9e10006556bee2fa$export$882f07b6a7d364c7);

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $gJf7C = parcelRequire("gJf7C");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $cbGjT = parcelRequire("cbGjT");
const $9e10006556bee2fa$export$882f07b6a7d364c7 = (0, $6xToB.createEntry)((0, $gJf7C.helpCenterSettingsCreateArticleRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.create-article',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $7jTnu.fg)('jcs_master_flag') ? (0, $cbGjT.helpCenterSettingCreateArticleAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("gJf7C", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCreateArticleRoute", () => $4f742c01382a8940$export$6f4350070b3391d2);
const $4f742c01382a8940$export$6f4350070b3391d2 = {
    name: 'helpcenter-settings-create-article',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId/space/:spaceKey/edit',
    query: [
        'draftShareId?',
        'topicId?'
    ]
};

});

parcelRegister("cbGjT", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingCreateArticleAppPageEntryPoint", () => $a09176e2db3393ef$export$2dedebb94d500afa);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $jgINI = parcelRequire("jgINI");
const $a09176e2db3393ef$export$2dedebb94d500afa = (0, $g8uYY.createPageEntryPoint)({
    main: $jgINI.HelpCenterSettingsCreateArticleAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("jgINI", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsCreateArticleAppEntryPoint", () => $eaa75240b4e3aff6$export$dd82613d258b9120);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $eaa75240b4e3aff6$export$dd82613d258b9120 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("3kyic")), {
        moduleId: "d6a89104",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("3kyic", function(module, exports) {

let $26cdd72826f7af07$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $26cdd72826f7af07$var$load("g6Mh8").then(()=>parcelRequire('kXVNP'));

});




parcelRegister("qU7hK", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerAccessRouteEntry", () => $9a54a2dc61f74cd4$export$5cfeb28cf3c43d24);

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $28JNJ = parcelRequire("28JNJ");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $74TzF = parcelRequire("74TzF");
const $9a54a2dc61f74cd4$export$5cfeb28cf3c43d24 = (0, $6xToB.createEntry)((0, $28JNJ.helpCenterSettingsCustomerAccessRoute), ()=>({
        perfMetricKey: 'help-center-settings.customer-access',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $bJscI.componentWithFG)('jcs_master_flag', (0, $74TzF.HelpCenterSettingsCustomerAccess), (0, $9BJU1.default)),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $74TzF.LazyHelpCenterSettingsCustomerAccess)
        ],
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("28JNJ", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerAccessRoute", () => $242a38aec89abe47$export$5adf9b8f07e4dd7b);
const $242a38aec89abe47$export$5adf9b8f07e4dd7b = {
    name: 'helpcenter-settings-customer-access',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-access'
};

});

parcelRegister("74TzF", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsCustomerAccess", () => $d81328931cc8aa2e$export$2c331ddbdb6fb4ef);
$parcel$export(module.exports, "HelpCenterSettingsCustomerAccess", () => $d81328931cc8aa2e$export$ab643bb246877df);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $d81328931cc8aa2e$export$2c331ddbdb6fb4ef = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("73rBW"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/customer-access/src/index.tsx"
});
const $d81328931cc8aa2e$export$ab643bb246877df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d81328931cc8aa2e$export$2c331ddbdb6fb4ef,
        pageId: "help-center-settings-customer-access",
        shouldShowSpinner: true
    });

});
parcelRegister("73rBW", function(module, exports) {

let $522e3b279df5dae3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $522e3b279df5dae3$var$load("7vqGd"),
    $522e3b279df5dae3$var$load("1Y4bq"),
    $522e3b279df5dae3$var$load("crVZc")
]).then(()=>parcelRequire('dSNBY'));

});



parcelRegister("9cLPB", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsRouteEntry", () => $897f6369f1c33670$export$4e4f38417d267cf6);

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $gqslx = parcelRequire("gqslx");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $4V1Wf = parcelRequire("4V1Wf");
const $897f6369f1c33670$export$4e4f38417d267cf6 = (0, $6xToB.createEntry)((0, $gqslx.helpCenterSettingsCustomerNotificationsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.customer-notifications',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $bJscI.componentWithFG)('jcs_master_flag', (0, $4V1Wf.HelpCenterSettingsCustomerNotifications), (0, $9BJU1.default)),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4V1Wf.LazyHelpCenterSettingsCustomerNotifications)
        ],
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("gqslx", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsRoute", () => $019b89d0278cff0b$export$88fcb9acf40a0827);
const $019b89d0278cff0b$export$88fcb9acf40a0827 = {
    name: 'helpcenter-settings-customer-notifications',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-notifications'
};

});

parcelRegister("4V1Wf", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsCustomerNotifications", () => $8f1848ef04965ad8$export$b2b6550dec008a98);
$parcel$export(module.exports, "HelpCenterSettingsCustomerNotifications", () => $8f1848ef04965ad8$export$2f2f18f57014444a);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $8f1848ef04965ad8$export$b2b6550dec008a98 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("cRJKG"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/customer-notifications/src/index.tsx"
});
const $8f1848ef04965ad8$export$2f2f18f57014444a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8f1848ef04965ad8$export$b2b6550dec008a98,
        pageId: "help-center-settings-customer-notifications",
        shouldShowSpinner: true
    });

});
parcelRegister("cRJKG", function(module, exports) {

let $95ddeca76e7aca37$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $95ddeca76e7aca37$var$load("2z6Ys").then(()=>parcelRequire('cYXPO'));

});



parcelRegister("cVu4s", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsDetailsRouteEntry", () => $8c22f9998b0d4d13$export$a9c03c3c37251dd3);

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $5oeMa = parcelRequire("5oeMa");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $dCgv3 = parcelRequire("dCgv3");
const $8c22f9998b0d4d13$export$a9c03c3c37251dd3 = (0, $6xToB.createEntry)((0, $5oeMa.helpCenterSettingsDetailsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.details',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $7jTnu.fg)('jcs_master_flag') ? (0, $dCgv3.helpCenterSettingDetailsAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("5oeMa", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsDetailsRoute", () => $9a5a76848176565b$export$f54c1546ddea019b);
const $9a5a76848176565b$export$f54c1546ddea019b = {
    name: 'helpcenter-settings-details',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/details',
    exact: true
};

});

parcelRegister("dCgv3", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingDetailsAppPageEntryPoint", () => $0acfa6394b0a8124$export$c52cb026d0dc8ed7);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $jsgdZ = parcelRequire("jsgdZ");
const $0acfa6394b0a8124$export$c52cb026d0dc8ed7 = (0, $g8uYY.createPageEntryPoint)({
    main: $jsgdZ.helpCenterSettingDetailsAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("jsgdZ", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingDetailsAppEntryPoint", () => $f9ee001ee56e248f$export$519ec4ef3722cb47);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $lFyR7 = parcelRequire("lFyR7");

const $f9ee001ee56e248f$export$519ec4ef3722cb47 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("6HRRQ")), {
        moduleId: "e9a696a2",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                serviceHubDetailsQuery: {
                    parameters: $lFyR7.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("lFyR7", function(module, exports) {

$parcel$export(module.exports, "default", () => $164b09074b25c540$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<345cdcc4a5f30bb844cb8f9e476b52b7>>
 * @relayHash 296f5d76497003b9efc4db58170d3c04
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 310bfbced7ee7a0f7321719746db0b9812584400fb073bf58476709972041428
const $164b09074b25c540$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "310bfbced7ee7a0f7321719746db0b9812584400fb073bf58476709972041428",
        "metadata": {},
        "name": "uiServiceHubDetailsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $164b09074b25c540$export$2e2bcd8739ae039 = $164b09074b25c540$var$node;

});

parcelRegister("6HRRQ", function(module, exports) {

let $4e208b2b259d4ef5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $4e208b2b259d4ef5$var$load("7vqGd"),
    $4e208b2b259d4ef5$var$load("1Y4bq"),
    $4e208b2b259d4ef5$var$load("1W8Jg")
]).then(()=>parcelRequire('1QTjA'));

});




parcelRegister("dceq5", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsEmailRouteEntry", () => $affc413bf6d59e8f$export$f95717dac47e4db3);

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $dN1NV = parcelRequire("dN1NV");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $4R3qR = parcelRequire("4R3qR");
const $affc413bf6d59e8f$export$f95717dac47e4db3 = (0, $6xToB.createEntry)((0, $dN1NV.helpCenterSettingsEmailRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.email',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $bJscI.componentWithFG)('jcs_master_flag', (0, $4R3qR.HelpCenterSettingsEmail), (0, $9BJU1.default)),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4R3qR.LazyHelpCenterSettingsEmail)
        ],
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("dN1NV", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsEmailRoute", () => $3389fac66e445ee2$export$4515288a48c62087);
const $3389fac66e445ee2$export$4515288a48c62087 = {
    name: 'helpcenter-settings-email',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/email',
    exact: true
};

});

parcelRegister("4R3qR", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsEmail", () => $766a31f54d9e1d55$export$e090cd3a62343249);
$parcel$export(module.exports, "HelpCenterSettingsEmail", () => $766a31f54d9e1d55$export$962f20e752738967);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $766a31f54d9e1d55$export$e090cd3a62343249 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8xeo5")), {
    moduleId: "./src/packages/spa-apps/help-center-settings/email/src/index.tsx"
});
const $766a31f54d9e1d55$export$962f20e752738967 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $766a31f54d9e1d55$export$e090cd3a62343249,
        pageId: "help-center-settings-email",
        shouldShowSpinner: true
    });

});
parcelRegister("8xeo5", function(module, exports) {

let $636c90e0a47a214f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $636c90e0a47a214f$var$load("1VRB2"),
    $636c90e0a47a214f$var$load("bABhq"),
    $636c90e0a47a214f$var$load("dWJ4p")
]).then(()=>parcelRequire('dBf4A'));

});



parcelRegister("i1SxF", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormEditRouteEntry", () => $05db6725367511ce$export$1750cfcab794a07d);

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $7c7ou = parcelRequire("7c7ou");

var $9BJU1 = parcelRequire("9BJU1");

var $iQx3C = parcelRequire("iQx3C");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $4XDZT = parcelRequire("4XDZT");
const $05db6725367511ce$export$1750cfcab794a07d = (0, $6xToB.createEntry)((0, $iQx3C.helpCenterSettingsFormEditRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.form-edit',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $7jTnu.fg)('jcs_master_flag') ? (0, $4XDZT.helpCenterSettingFormEditAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $7c7ou.formEditJirafieldsResource)
        ]
    }));

});
parcelRegister("7c7ou", function(module, exports) {

$parcel$export(module.exports, "formEditJirafieldsResource", () => $eba93f6a60ca6f09$export$ca58e1498fd1ff3e);
$parcel$export(module.exports, "useFormEditJirafields", () => $eba93f6a60ca6f09$export$8a76fadb956ce203);

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $eba93f6a60ca6f09$var$getDataLoader = ()=>(parcelRequire("dFHsW"));
const $eba93f6a60ca6f09$export$ca58e1498fd1ff3e = (0, $l1VxS.createResource)({
    type: 'HELP_CENTER_FORM_EDIT_JIRAFIELDS_RESOURCE',
    getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
    getDataLoader: $eba93f6a60ca6f09$var$getDataLoader,
    isBrowserOnly: true
});
const $eba93f6a60ca6f09$export$8a76fadb956ce203 = ()=>(0, $eJrcF.useResource)($eba93f6a60ca6f09$export$ca58e1498fd1ff3e);

});
parcelRegister("dFHsW", function(module, exports) {

let $9f40d21ec69976d0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9f40d21ec69976d0$var$load("fUwKh").then(()=>parcelRequire('lCM2t'));

});


parcelRegister("iQx3C", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormEditRoute", () => $a9812b10d82d7ebc$export$31bd3e10c42460dc);
const $a9812b10d82d7ebc$export$31bd3e10c42460dc = {
    exact: true,
    name: 'helpcenter-settings-form-edit',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/forms/:formId'
};

});

parcelRegister("4XDZT", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormEditAppPageEntryPoint", () => $8b232d5f3c0f4591$export$2792cba2387cbc5c);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $cDcwY = parcelRequire("cDcwY");
const $8b232d5f3c0f4591$export$2792cba2387cbc5c = (0, $g8uYY.createPageEntryPoint)({
    main: $cDcwY.helpCenterSettingFormEditAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("cDcwY", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormEditAppEntryPoint", () => $c91eceae72db5a99$export$262512d610e494f8);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $9m1cC = parcelRequire("9m1cC");

const $c91eceae72db5a99$export$262512d610e494f8 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("1LuP5")), {
        moduleId: "d82eb4d8",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId, formId: formId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                uiFormEditRoutingQuery: {
                    parameters: $9m1cC.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        templateFormAri: `ari:cloud:jira-customer-service::template-form/activation/${activationId}/${formId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("9m1cC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8afb1d03c0ac5113$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e08557ab552bf44df293cd7626377d57>>
 * @relayHash 25cf59f5b03aae972cf632dae9685f3c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7dd46115cf70ad94d508dc1c7421a44d4cff3f62c44724b51e2c900cb6cfe9d3
const $8afb1d03c0ac5113$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7dd46115cf70ad94d508dc1c7421a44d4cff3f62c44724b51e2c900cb6cfe9d3",
        "metadata": {},
        "name": "uiFormEditRoutingQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8afb1d03c0ac5113$export$2e2bcd8739ae039 = $8afb1d03c0ac5113$var$node;

});

parcelRegister("1LuP5", function(module, exports) {

let $1492170b336af2b9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1492170b336af2b9$var$load("d7d9L").then(()=>parcelRequire('dZrxI'));

});




parcelRegister("64vgo", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormsRouteEntry", () => $ed2e4fada4dfb854$export$9a67aaae787c9f40);

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $fDEjZ = parcelRequire("fDEjZ");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $3wgAy = parcelRequire("3wgAy");
const $ed2e4fada4dfb854$export$9a67aaae787c9f40 = (0, $6xToB.createEntry)((0, $fDEjZ.helpCenterSettingsFormsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.forms',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $7jTnu.fg)('jcs_master_flag') ? (0, $3wgAy.helpCenterSettingFormsAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("fDEjZ", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormsRoute", () => $283bcbedda55f023$export$45b14c3ed47b2b3a);
const $283bcbedda55f023$export$45b14c3ed47b2b3a = {
    exact: true,
    name: 'helpcenter-settings-forms',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/forms'
};

});

parcelRegister("3wgAy", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormsAppPageEntryPoint", () => $91ee78b052c924d7$export$b50d944f3be2457f);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $bBJjz = parcelRequire("bBJjz");
const $91ee78b052c924d7$export$b50d944f3be2457f = (0, $g8uYY.createPageEntryPoint)({
    main: $bBJjz.helpCenterSettingFormsAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("bBJjz", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormsAppEntryPoint", () => $492dafc7f32d9aee$export$ce8253ab16579f12);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $5rUe3 = parcelRequire("5rUe3");

const $492dafc7f32d9aee$export$ce8253ab16579f12 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("aynnY")), {
        moduleId: "c7a4dbb9",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                uiFormsQuery: {
                    parameters: $5rUe3.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("5rUe3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4eb44f03c6bb515$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<84b049be8f3a777ce173b3c8cca04631>>
 * @relayHash 0a68a91abafc7c22614c8b72a0a3f13b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ae63b4dd317fe8ffc05de4c48bb50926299366f1b898d6a5e04aae8b233cac4
const $b4eb44f03c6bb515$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0ae63b4dd317fe8ffc05de4c48bb50926299366f1b898d6a5e04aae8b233cac4",
        "metadata": {},
        "name": "uiFormsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b4eb44f03c6bb515$export$2e2bcd8739ae039 = $b4eb44f03c6bb515$var$node;

});

parcelRegister("aynnY", function(module, exports) {

let $7aef3845125608a6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7aef3845125608a6$var$load("84un0").then(()=>parcelRequire('29qD5'));

});




parcelRegister("9hXyI", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsKbRouteEntry", () => $7dcf48ed5e4a68ed$export$caf568619a621961);

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $by3fT = parcelRequire("by3fT");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $3JHTH = parcelRequire("3JHTH");
const $7dcf48ed5e4a68ed$export$caf568619a621961 = (0, $6xToB.createEntry)((0, $by3fT.helpCenterSettingsKbRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.kb',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $bJscI.componentWithFG)('jcs_master_flag', (0, $3JHTH.HelpCenterSettingsKnowledgeBase), (0, $9BJU1.default)),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3JHTH.LazyHelpCenterSettingsKnowledgeBase)
        ],
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            // TODO: https://jplat.jira.atlassian.cloud/browse/BERRY-2884
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("by3fT", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsKbRoute", () => $e03ffc91b212b4d9$export$8a784299dc7faaff);
const $e03ffc91b212b4d9$export$8a784299dc7faaff = {
    name: 'helpcenter-settings-kb',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/kb',
    exact: true
};

});

parcelRegister("3JHTH", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsKnowledgeBase", () => $e9cce4da843200c7$export$92983043c677b1b1);
$parcel$export(module.exports, "HelpCenterSettingsKnowledgeBase", () => $e9cce4da843200c7$export$c1d58cf9dc0a2ed3);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $e9cce4da843200c7$export$92983043c677b1b1 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lxCKa"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/knowledge-settings/src/index.tsx"
});
const $e9cce4da843200c7$export$c1d58cf9dc0a2ed3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e9cce4da843200c7$export$92983043c677b1b1,
        pageId: "help-center-settings-knowledge-base",
        shouldShowSpinner: true
    });

});
parcelRegister("lxCKa", function(module, exports) {

let $faeabbb9e8cae0f7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $faeabbb9e8cae0f7$var$load("1VRB2"),
    $faeabbb9e8cae0f7$var$load("bABhq"),
    $faeabbb9e8cae0f7$var$load("jFxSY")
]).then(()=>parcelRequire('kQUup'));

});



parcelRegister("1PXic", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsNotFoundRouteEntry", () => $a753187a83d5ad3a$export$2dced3f6d0a4894);

var $6xToB = parcelRequire("6xToB");

var $l0KDT = parcelRequire("l0KDT");

var $jJNU7 = parcelRequire("jJNU7");
const $a753187a83d5ad3a$export$2dced3f6d0a4894 = (0, $6xToB.createEntry)((0, $l0KDT.helpCenterSettingsNotFoundRoute), ()=>({
        group: 'customer-service',
        component: (0, $jJNU7.NotFound)
    }));

});
parcelRegister("l0KDT", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsNotFoundRoute", () => $23763a2d6fc2020c$export$b6bc9dd96e9608e7);
const $23763a2d6fc2020c$export$b6bc9dd96e9608e7 = {
    exact: false,
    name: 'customer-service-not-found',
    path: '/jira/helpcenter/:any'
};

});

parcelRegister("jJNU7", function(module, exports) {

$parcel$export(module.exports, "NotFound", () => $a847820c6bf7f1cc$export$271f9f08425019c7);

var $eJOHy = parcelRequire("eJOHy");

var $cOy0I = parcelRequire("cOy0I");

var $kfvK2 = parcelRequire("kfvK2");

var $gYnSx = parcelRequire("gYnSx");
const $a847820c6bf7f1cc$var$useLocation = (0, $kfvK2.createRouterSelector)(({ location: location })=>location.pathname);
const $a847820c6bf7f1cc$export$271f9f08425019c7 = ()=>{
    const pathname = $a847820c6bf7f1cc$var$useLocation();
    (0, $eJOHy.useEffect)(()=>{
        (0, $gYnSx.default)({
            meta: {
                id: 'serviceHubPageNotFound',
                packageName: 'jiraServicedeskCustomerServiceServiceHubs',
                teamName: 'boysenberry'
            },
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                pathname: pathname
            }
        });
    }, [
        pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cOy0I.NotFoundErrorPageAsync), null);
};

});


parcelRegister("pX4Kl", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsRouteEntry", () => $9d65972d70e54b01$export$4afd756ea4d2cf7e);

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $7SF7y = parcelRequire("7SF7y");

var $gPOXv = parcelRequire("gPOXv");
const $9d65972d70e54b01$export$4afd756ea4d2cf7e = (0, $6xToB.createEntry)((0, $7SF7y.helpCenterSettingsServiceHubsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.service-hubs',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
        },
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $7jTnu.fg)('jcs_master_flag') ? (0, $gPOXv.helpCenterSettingsServiceHubsRoutePageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ]
    }));

});
parcelRegister("7SF7y", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsRoute", () => $5b040b4d0e410c37$export$16970f28ba5bfb66);
const $5b040b4d0e410c37$export$16970f28ba5bfb66 = {
    exact: true,
    name: 'customer-service-helpcenter',
    path: '/jira/helpcenter'
};

});

parcelRegister("gPOXv", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsRoutePageEntryPoint", () => $1e4457e3235fe1d5$export$3c1cef4845013f95);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $fUQgH = parcelRequire("fUQgH");
const $1e4457e3235fe1d5$export$3c1cef4845013f95 = (0, $g8uYY.createPageEntryPoint)({
    main: $fUQgH.helpCenterSettingsServiceHubsAppEntryPoint,
    // TODO update to right menu id
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("fUQgH", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsAppEntryPoint", () => $4245f6963e24ff54$export$68ab0caf884fe346);

var $aAYhl = parcelRequire("aAYhl");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");
const $4245f6963e24ff54$var$NUMBER_OF_HELP_CENTERS_INITIAL_FETCH = 20;
const $4245f6963e24ff54$var$SORT_ORDER = 'CREATED_DATE_DESCENDING';

const $4245f6963e24ff54$export$68ab0caf884fe346 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("hpxIv")).then((module)=>module.HelpCenterSettingServiceHubsAppWithJCSLicenseCheck), {
        moduleId: "c447b568",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                serviceHubsQuery: {
                    parameters: $aAYhl.default,
                    variables: {
                        cloudId: cloudId,
                        workspaceAri: `ari:cloud:jira:${cloudId}:workspace/${activationId}`,
                        SORT_ORDER: $4245f6963e24ff54$var$SORT_ORDER,
                        NUMBER_OF_HELP_CENTERS_INITIAL_FETCH: $4245f6963e24ff54$var$NUMBER_OF_HELP_CENTERS_INITIAL_FETCH
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("aAYhl", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd6f0211d3ab01ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a26780337adfcc15ec26908f79550ee6>>
 * @relayHash bcef1344cba25537e7a53d600a9db480
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 88265765b0265d05b90e13c21862d0aa44f2965a1a92f528efc0bc2ff1c0744d
const $fd6f0211d3ab01ab$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "88265765b0265d05b90e13c21862d0aa44f2965a1a92f528efc0bc2ff1c0744d",
        "metadata": {},
        "name": "srcCustomerServiceServiceHubsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $fd6f0211d3ab01ab$export$2e2bcd8739ae039 = $fd6f0211d3ab01ab$var$node;

});

parcelRegister("hpxIv", function(module, exports) {

let $caceecf42f2a07a8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $caceecf42f2a07a8$var$load("7vqGd"),
    $caceecf42f2a07a8$var$load("1Y4bq"),
    $caceecf42f2a07a8$var$load("hiZQv")
]).then(()=>parcelRequire('bgS4M'));

});




parcelRegister("7lW5H", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteOverviewRouteEntry", () => $669a0e265b7bff0e$export$eb728930eecb0b42);

var $7jTnu = parcelRequire("7jTnu");

var $aQoXd = parcelRequire("aQoXd");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $be9GB = parcelRequire("be9GB");

var $dUMft = parcelRequire("dUMft");

var $5RW99 = parcelRequire("5RW99");

var $b9dJE = parcelRequire("b9dJE");

var $a8qDQ = parcelRequire("a8qDQ");
const $669a0e265b7bff0e$export$eb728930eecb0b42 = (0, $6xToB.createEntry)((0, $be9GB.helpCenterSettingsSupportWebsiteOverviewRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website.overview',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).HELP_CENTER_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
            sidebar: (0, $dUMft.default),
            horizontal: (0, $7jTnu.fg)('csm_contact_us_rte') ? undefined : (0, $b9dJE.AsyncSupportWebsiteNav)
        },
        component: (0, $9BJU1.default),
        entryPoint: ()=>{
            if (!(0, $7jTnu.fg)('jcs_master_flag')) return undefined;
            return (0, $7jTnu.fg)('csm_contact_us_rte') ? (0, $a8qDQ.HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation) : (0, $a8qDQ.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint);
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)()
        ]
    }));

});
parcelRegister("be9GB", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteOverviewRoute", () => $6103956352967918$export$64e95782b19caeac);
const $6103956352967918$export$64e95782b19caeac = {
    name: 'helpcenter-settings-support-website-details-overview',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/overview',
    exact: true
};

});

parcelRegister("b9dJE", function(module, exports) {

$parcel$export(module.exports, "AsyncSupportWebsiteNav", () => $ee27107460aa32df$export$8887f9c4b5829b78);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $ee27107460aa32df$var$LazySupportWebsiteNav = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("3IBdU")).then(({ SupportWebsiteNavOld: SupportWebsiteNavOld })=>SupportWebsiteNavOld), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-csm/support-website/src/ui/index.tsx"
});
const $ee27107460aa32df$export$8887f9c4b5829b78 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "horizontal-csm-support-site-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ee27107460aa32df$var$LazySupportWebsiteNav, null));

});
parcelRegister("3IBdU", function(module, exports) {

let $2b525af20c6475e9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2b525af20c6475e9$var$load("7SReG").then(()=>parcelRequire('7Hi0z'));

});


parcelRegister("a8qDQ", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint", () => $b1808f85d92b32ca$export$780fd78388c1f1d1);
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation", () => $b1808f85d92b32ca$export$23f7867fc61415d6);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $lXSXs = parcelRequire("lXSXs");

var $469qC = parcelRequire("469qC");
const $b1808f85d92b32ca$export$780fd78388c1f1d1 = (0, $g8uYY.createPageEntryPoint)({
    main: $lXSXs.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});
const $b1808f85d92b32ca$export$23f7867fc61415d6 = (0, $g8uYY.createPageEntryPoint)({
    main: $lXSXs.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
    horizontalNavigation: (0, $469qC.horizontalNavigationCsmSupportWebsiteEntryPoint)
});

});
parcelRegister("lXSXs", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint", () => $d9ead258d20a7a85$export$780fd78388c1f1d1);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $tUyQM = parcelRequire("tUyQM");

const $d9ead258d20a7a85$export$780fd78388c1f1d1 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("1f2pk")), {
        moduleId: "d27a8c99",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                serviceHubDetailsQuery: {
                    parameters: $tUyQM.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("tUyQM", function(module, exports) {

$parcel$export(module.exports, "default", () => $948ab87f71f95c4c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<56704f869dd3bf26b9493dcc9318675d>>
 * @relayHash 47a9d4ba3c89adc65459e3e00e470969
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a276a4c71e6f6b8cd865f9fdff52d9b21ef5c500d0d49ccfd5a505cbe7b9c3dd
const $948ab87f71f95c4c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a276a4c71e6f6b8cd865f9fdff52d9b21ef5c500d0d49ccfd5a505cbe7b9c3dd",
        "metadata": {},
        "name": "uiSupportWebsiteOverviewServiceHubPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $948ab87f71f95c4c$export$2e2bcd8739ae039 = $948ab87f71f95c4c$var$node;

});

parcelRegister("1f2pk", function(module, exports) {

let $0e790f41c80db3c7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $0e790f41c80db3c7$var$load("7vqGd"),
    $0e790f41c80db3c7$var$load("1Y4bq"),
    $0e790f41c80db3c7$var$load("1EFZ9")
]).then(()=>parcelRequire('7XuGk'));

});


parcelRegister("469qC", function(module, exports) {

$parcel$export(module.exports, "horizontalNavigationCsmSupportWebsiteEntryPoint", () => $6d564a6bea220942$export$2ba426f18e0d22f5);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $fFsPv = parcelRequire("fFsPv");

const $6d564a6bea220942$export$2ba426f18e0d22f5 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("gKv7P")), {
        moduleId: "b4f1b5e4",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                mainHorizontalNavCsmSupportWebsiteQuery: {
                    parameters: $fFsPv.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("fFsPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e25928fc8eb1a415$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<254d867d38ac2047e1b355de64e44419>>
 * @relayHash 74a6ed725a3c21301a8a9e20260043d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e56b17fc47959b40a696bb4d93e1ad9907e79c351376c9594868dd91b2bd2a9d
const $e25928fc8eb1a415$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e56b17fc47959b40a696bb4d93e1ad9907e79c351376c9594868dd91b2bd2a9d",
        "metadata": {},
        "name": "mainHorizontalNavCsmSupportWebsiteQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e25928fc8eb1a415$export$2e2bcd8739ae039 = $e25928fc8eb1a415$var$node;

});

parcelRegister("gKv7P", function(module, exports) {

let $c3191612c1abcd94$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c3191612c1abcd94$var$load("csiBl").then(()=>parcelRequire('a0LuS'));

});




parcelRegister("7RzXN", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsitePagesRouteEntry", () => $15b18cf58fe79f1d$export$5077ff1d96b93d83);

var $aQoXd = parcelRequire("aQoXd");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $fhK2S = parcelRequire("fhK2S");

var $dUMft = parcelRequire("dUMft");

var $5RW99 = parcelRequire("5RW99");

var $b9dJE = parcelRequire("b9dJE");

var $7jTnu = parcelRequire("7jTnu");

var $4uXiB = parcelRequire("4uXiB");
const $15b18cf58fe79f1d$export$5077ff1d96b93d83 = (0, $6xToB.createEntry)((0, $fhK2S.helpCenterSettingsSupportWebsitePagesRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website.pages',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).HELP_CENTER_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
            sidebar: (0, $dUMft.default),
            horizontal: (0, $7jTnu.fg)('csm_contact_us_rte') ? undefined : (0, $b9dJE.AsyncSupportWebsiteNav)
        },
        component: (0, $9BJU1.default),
        entryPoint: ()=>{
            if (!(0, $7jTnu.fg)('jcs_master_flag')) return undefined;
            return (0, $7jTnu.fg)('csm_contact_us_rte') ? (0, $4uXiB.HelpCenterSettingsSupportWebsitePagesAppEntryPointWithHorizontalNavigation) : (0, $4uXiB.HelpCenterSettingsSupportWebsitePagesAppEntryPoint);
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)()
        ]
    }));

});
parcelRegister("fhK2S", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsitePagesRoute", () => $cf061a366125027d$export$a6eefe359f3d3ade);
const $cf061a366125027d$export$a6eefe359f3d3ade = {
    name: 'helpcenter-settings-support-website-details-pages',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/pages',
    exact: true
};

});

parcelRegister("4uXiB", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPoint", () => $df1b05e0083ad85c$export$7d51b2b14ae8000f);
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPointWithHorizontalNavigation", () => $df1b05e0083ad85c$export$e27663b14f44038e);

var $g8uYY = parcelRequire("g8uYY");

var $469qC = parcelRequire("469qC");

var $5RW99 = parcelRequire("5RW99");

var $ISPIA = parcelRequire("ISPIA");
const $df1b05e0083ad85c$export$7d51b2b14ae8000f = (0, $g8uYY.createPageEntryPoint)({
    main: $ISPIA.HelpCenterSettingsSupportWebsitePagesAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});
const $df1b05e0083ad85c$export$e27663b14f44038e = (0, $g8uYY.createPageEntryPoint)({
    main: $ISPIA.HelpCenterSettingsSupportWebsitePagesAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
    horizontalNavigation: (0, $469qC.horizontalNavigationCsmSupportWebsiteEntryPoint)
});

});
parcelRegister("ISPIA", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPoint", () => $a4abb3745ae9a7f4$export$7d51b2b14ae8000f);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $ebP6O = parcelRequire("ebP6O");

const $a4abb3745ae9a7f4$export$7d51b2b14ae8000f = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("hVfA8")), {
        moduleId: "c9581695",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                customPagesQuery: {
                    parameters: $ebP6O.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterARI: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        NUMBER_OF_PAGES_INITIAL_FETCH: 300
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("ebP6O", function(module, exports) {

$parcel$export(module.exports, "default", () => $58e6b63d51da3f2c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<255b47cc0babd2dc6c2822562386643c>>
 * @relayHash 4cef641aeddb35300aa8d4846416dd5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15c35c8f3c86832753921d0da0dad55d8b9e763158ce0f0a3976cf1897ea1a8b
const $58e6b63d51da3f2c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "15c35c8f3c86832753921d0da0dad55d8b9e763158ce0f0a3976cf1897ea1a8b",
        "metadata": {
            "connection": [
                {
                    "count": "NUMBER_OF_PAGES_INITIAL_FETCH",
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "helpCenter",
                        "helpCenterPages"
                    ]
                }
            ]
        },
        "name": "uiSupportWebsiteCustomPagesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $58e6b63d51da3f2c$export$2e2bcd8739ae039 = $58e6b63d51da3f2c$var$node;

});

parcelRegister("hVfA8", function(module, exports) {

let $d0c3d8c3862ddc8d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d0c3d8c3862ddc8d$var$load("8lWAZ").then(()=>parcelRequire('3HAKZ'));

});




parcelRegister("8M7gQ", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteRouteEntry", () => $5d298e21be96f4b1$export$59cfd0dfcd1b4311);

var $aQoXd = parcelRequire("aQoXd");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $8BXqW = parcelRequire("8BXqW");

var $5RW99 = parcelRequire("5RW99");

var $dUMft = parcelRequire("dUMft");

var $b9dJE = parcelRequire("b9dJE");

var $7jTnu = parcelRequire("7jTnu");

var $3cDvy = parcelRequire("3cDvy");
const $5d298e21be96f4b1$export$59cfd0dfcd1b4311 = (0, $6xToB.createEntry)((0, $8BXqW.helpCenterSettingsSupportWebsiteRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).HELP_CENTER_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
            sidebar: (0, $dUMft.default),
            horizontal: (0, $7jTnu.fg)('csm_contact_us_rte') ? undefined : (0, $b9dJE.AsyncSupportWebsiteNav)
        },
        component: (0, $9BJU1.default),
        entryPoint: ()=>{
            if (!(0, $7jTnu.fg)('jcs_master_flag')) return undefined;
            return (0, $7jTnu.fg)('csm_contact_us_rte') ? (0, $3cDvy.HelpCenterSettingsSupportWebsiteEntryPointWithHorizontalNavigation) : (0, $3cDvy.HelpCenterSettingsSupportWebsiteEntryPoint);
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)()
        ]
    }));

});
parcelRegister("8BXqW", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteRoute", () => $b72b0aa9579f37a6$export$c59ea9b870a0e809);
const $b72b0aa9579f37a6$export$c59ea9b870a0e809 = {
    name: 'helpcenter-settings-support-website-details',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website',
    exact: true
};

});

parcelRegister("3cDvy", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteEntryPoint", () => $37e8019dbe2c1863$export$91f75c485220b109);
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteEntryPointWithHorizontalNavigation", () => $37e8019dbe2c1863$export$4811316770750d89);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $5iiP9 = parcelRequire("5iiP9");

var $469qC = parcelRequire("469qC");
const $37e8019dbe2c1863$export$91f75c485220b109 = (0, $g8uYY.createPageEntryPoint)({
    main: $5iiP9.HelpCenterSettingsSupportWebsiteAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});
const $37e8019dbe2c1863$export$4811316770750d89 = (0, $g8uYY.createPageEntryPoint)({
    main: $5iiP9.HelpCenterSettingsSupportWebsiteAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
    horizontalNavigation: (0, $469qC.horizontalNavigationCsmSupportWebsiteEntryPoint)
});

});
parcelRegister("5iiP9", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteAppEntryPoint", () => $580dca05e836ac74$export$43c72a7c514122ed);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $580dca05e836ac74$export$43c72a7c514122ed = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("9O1SK")), {
        moduleId: "6e5d67aa",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("9O1SK", function(module, exports) {

let $723a3e4dabd954d1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $723a3e4dabd954d1$var$load("30v5T").then(()=>parcelRequire('k5jfD'));

});




parcelRegister("4AyGF", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsWidgetConfigurationRouteEntry", () => $858d2da35e031de3$export$c31c9a710ba499e8);

var $aQoXd = parcelRequire("aQoXd");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $dHjtl = parcelRequire("dHjtl");

var $7jTnu = parcelRequire("7jTnu");

var $b5xUw = parcelRequire("b5xUw");

var $ioWDK = parcelRequire("ioWDK");
const $858d2da35e031de3$export$c31c9a710ba499e8 = (0, $6xToB.createEntry)((0, $dHjtl.helpCenterSettingsWidgetConfigurationRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.widget-configuration',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint: ()=>{
            if (!(0, $7jTnu.fg)('csm_agent_config_widget_configuration_embed_page')) return undefined;
            return 0, $b5xUw.HelpCenterSettingsWidgetConfigurationEntryPoint;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)()
        ]
    }));

});
parcelRegister("dHjtl", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsWidgetConfigurationRoute", () => $25574dce869a712f$export$5383ecd0996d74ed);
const $25574dce869a712f$export$5383ecd0996d74ed = {
    name: 'helpcenter-settings-widget-configuration',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/widget-configuration',
    exact: true
};

});

parcelRegister("b5xUw", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsWidgetConfigurationEntryPoint", () => $fdbb2bb303d289a0$export$8b1b69a280b85325);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $iEk8Z = parcelRequire("iEk8Z");
const $fdbb2bb303d289a0$export$8b1b69a280b85325 = (0, $g8uYY.createPageEntryPoint)({
    main: $iEk8Z.HelpCenterSettingsWidgetConfigurationAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("iEk8Z", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsWidgetConfigurationAppEntryPoint", () => $db3f43a887661996$export$5b62ed117b99ac21);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $f68DD = parcelRequire("f68DD");

const $db3f43a887661996$export$5b62ed117b99ac21 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("3jeZQ")), {
        moduleId: "3b1d944d",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                page: {
                    parameters: (0, $f68DD.default),
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("f68DD", function(module, exports) {

$parcel$export(module.exports, "default", () => $eea9c42bdf5eb7d4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<230d2e61bc7701d4fc87ed7aaeef6712>>
 * @relayHash 5092ed6e33bf3757d7e045f4ded60cf6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 90f597a013f86e5d9b1e6b04fcbac995002116aaec78aa0e5de42e74d0478e97

var $37Ewn = parcelRequire("37Ewn");
const $eea9c42bdf5eb7d4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EMBED"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiCsmWidgetConfigurationQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "widgets",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference"
                                                }
                                            ],
                                            "type": "CsmAiWidgetConfig"
                                        }
                                    ],
                                    "storageKey": "widgets(type:\"EMBED\")"
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiCsmWidgetConfigurationQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "widgets",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "allowedDomains"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isAnonymousAccessEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "position"
                                                },
                                                {
                                                    "concreteType": "CsmAiWidgetBrandingTheme",
                                                    "kind": "LinkedField",
                                                    "name": "theme",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "colorVibeVariant"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "radius"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "space"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "chatColor"
                                                        },
                                                        {
                                                            "concreteType": "CsmAiWidgetBrandingAttribution",
                                                            "kind": "LinkedField",
                                                            "name": "attribution",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CsmAiWidgetConfig"
                                        }
                                    ],
                                    "storageKey": "widgets(type:\"EMBED\")"
                                },
                                v5 /*: any*/ 
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                        },
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "90f597a013f86e5d9b1e6b04fcbac995002116aaec78aa0e5de42e74d0478e97",
            "metadata": {},
            "name": "uiCsmWidgetConfigurationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$eea9c42bdf5eb7d4$var$node.hash = "6b620091915d7e69227f87a1a80ef7ac";
(0, $37Ewn.PreloadableQueryRegistry).set($eea9c42bdf5eb7d4$var$node.params.id, $eea9c42bdf5eb7d4$var$node);
var $eea9c42bdf5eb7d4$export$2e2bcd8739ae039 = $eea9c42bdf5eb7d4$var$node;

});

parcelRegister("3jeZQ", function(module, exports) {

let $268ec7724ac1448b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $268ec7724ac1448b$var$load("kahlF").then(()=>parcelRequire('kljxZ'));

});




parcelRegister("MBVfl", function(module, exports) {

$parcel$export(module.exports, "homeOnboardingRedirectRouteEntry", () => $7b89ea521d9a7722$export$2740cfaa979353b9);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $h7Tbo = parcelRequire("h7Tbo");

var $8ULju = parcelRequire("8ULju");
const $7b89ea521d9a7722$export$2740cfaa979353b9 = (0, $6xToB.createEntry)((0, $h7Tbo.homeOnboardingRedirectRoute), ()=>({
        group: 'home',
        component: (0, $8ULju.default),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        isRedirect: true,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("h7Tbo", function(module, exports) {

$parcel$export(module.exports, "homeOnboardingRedirectRoute", () => $69b4b747cd814a8d$export$2eaffde3ad991b33);
const $69b4b747cd814a8d$export$2eaffde3ad991b33 = {
    name: 'home-onboarding-redirect',
    path: '/jira/your-work-onboarding',
    exact: true
};

});

parcelRegister("8ULju", function(module, exports) {

$parcel$export(module.exports, "default", () => $e94200604f01264f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $iqtgH = parcelRequire("iqtgH");

var $83DiZ = parcelRequire("83DiZ");
/**
 * This component will cause an SPA transition (and overwrite of current history) to Your work or the Projects directory
 * depending on whether nav-v3, Your work's deep dive cards, and the JSW onboarding flows in Your work are enabled.
 */ const $e94200604f01264f$var$JiraHomeOnboardingRedirect = ()=>{
    const { replace: replace } = (0, $83DiZ.useRouterActions)();
    replace('/jira/your-work');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireOperationalAnalytics), {
        eventName: "JiraHomeOnboardingRedirect loaded",
        componentName: "JiraHomeOnboardingRedirect",
        attributes: {
            isRedirectionEnabled: true
        }
    });
};
var $e94200604f01264f$export$2e2bcd8739ae039 = $e94200604f01264f$var$JiraHomeOnboardingRedirect;

});


parcelRegister("4w8EY", function(module, exports) {

$parcel$export(module.exports, "homeRedirectRouteEntry", () => $09b5e322c4bfffbf$export$5379c026da4201e6);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $6r5jO = parcelRequire("6r5jO");

var $3LdAk = parcelRequire("3LdAk");
const $09b5e322c4bfffbf$export$5379c026da4201e6 = (0, $6xToB.createEntry)((0, $6r5jO.homeRedirectRoute), ()=>({
        group: 'home',
        component: (0, $3LdAk.default),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        isRedirect: true,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("6r5jO", function(module, exports) {

$parcel$export(module.exports, "homeRedirectRoute", () => $af81b3277e6bf3b6$export$f7a252c9d61f8f94);
const $af81b3277e6bf3b6$export$f7a252c9d61f8f94 = {
    name: 'home-redirect',
    path: '/jira',
    exact: true
};

});

parcelRegister("3LdAk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eaf4ee054cb26e2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lGrwR = parcelRequire("lGrwR");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4eaf4ee054cb26e2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGrwR.default), null);

});
parcelRegister("lGrwR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4da6a8cf5da911a7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $eSnSE = parcelRequire("eSnSE");

var $aUy7d = parcelRequire("aUy7d");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");

const $4da6a8cf5da911a7$var$JiraBaseRedirectWrapper = ()=>{
    (0, $gRw8I.di)(window);
    const { data: data, loading: loading } = (0, $eJrcF.useResource)((0, $aUy7d.userHomepageResource));
    (0, $eJOHy.useEffect)(()=>{
        if (!loading && data == null) (0, $eSnSE.default).safeInfoWithoutCustomerData((0, $1c4d6835d61579b2$export$25a759e49d5049db), 'userHomepage data is null');
    }, [
        loading,
        data
    ]);
    if (loading) return null;
    // redirect to monolith to handle "/jira" route if homepageData is null (should not happen)
    if (data == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.replace('/jira');
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: data.homepagePreference
    });
};
var $4da6a8cf5da911a7$export$2e2bcd8739ae039 = $4da6a8cf5da911a7$var$JiraBaseRedirectWrapper;

});
const $1c4d6835d61579b2$export$25a759e49d5049db = 'spa-apps.common.redirect.jira-base-routing';




parcelRegister("eYdQw", function(module, exports) {

$parcel$export(module.exports, "issueCreateEmbedRouteEntry", () => $52f852bd8c3d84bd$export$abd0bbe95839baf7);

var $eJOHy = parcelRequire("eJOHy");

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $cxQGT = parcelRequire("cxQGT");

var $aiWTC = parcelRequire("aiWTC");

var $aV23b = parcelRequire("aV23b");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");
const $52f852bd8c3d84bd$var$handleEmbedLinkClick = (e)=>{
    const eventTarget = e.target;
    // this is used for handling all the button clicks inside the iframe to open the new link in a new tab
    // as this view is mainly used an embed view inside an iframe.
    if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
    eventTarget.target = '_blank';
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $52f852bd8c3d84bd$var$LazyIssueCreateEmbed = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("878Qs")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/issue-create-embed/src/index.tsx"
});
const $52f852bd8c3d84bd$var$IssueCreateEmbedLazy = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('click', $52f852bd8c3d84bd$var$handleEmbedLinkClick, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('click', $52f852bd8c3d84bd$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $52f852bd8c3d84bd$var$LazyIssueCreateEmbed,
        pageId: "spa-apps/issue-create-embed",
        shouldShowSpinner: true
    }));
};
const $52f852bd8c3d84bd$export$abd0bbe95839baf7 = (0, $6xToB.createEntry)((0, $aiWTC.issueCreateEmbedRoute), ()=>({
        group: 'issue',
        component: $52f852bd8c3d84bd$var$IssueCreateEmbedLazy,
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        forPaint: [
            $52f852bd8c3d84bd$var$LazyIssueCreateEmbed
        ]
    }));

});
parcelRegister("aiWTC", function(module, exports) {

$parcel$export(module.exports, "issueCreateEmbedRoute", () => $7edf4a90e0aef5e3$export$c155f4de16b62110);
const $7edf4a90e0aef5e3$export$c155f4de16b62110 = {
    name: 'issue-create-embed',
    path: '/jira/issues/create/embed'
};

});

parcelRegister("878Qs", function(module, exports) {

let $5e85d6a6e2178d18$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5e85d6a6e2178d18$var$load("fAbxa"),
    $5e85d6a6e2178d18$var$load("k4gbU"),
    $5e85d6a6e2178d18$var$load("1VRB2"),
    $5e85d6a6e2178d18$var$load("bABhq"),
    $5e85d6a6e2178d18$var$load("7vqGd"),
    $5e85d6a6e2178d18$var$load("1Y4bq"),
    $5e85d6a6e2178d18$var$load("eDzss"),
    $5e85d6a6e2178d18$var$load("8ZPnD")
]).then(()=>parcelRequire('fTNst'));

});


parcelRegister("lOn6l", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalJiraRouteEntry", () => $533b9b9374a389f0$export$8925c79a030fdfe8);

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $j26UA = parcelRequire("j26UA");

var $eznTg = parcelRequire("eznTg");


var $klAnQ = parcelRequire("klAnQ");

var $gAL0c = parcelRequire("gAL0c");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");
const $533b9b9374a389f0$export$8925c79a030fdfe8 = (0, $6xToB.createEntry)((0, $j26UA.issueNavigatorGlobalJiraRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $eznTg.GlobalIssueNavigatorSkeleton),
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $klAnQ.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $gAL0c.getCommonGlobalResources)()
        ],
        layout: (0, $7h3uc.globalLayout),
        entryPoint: ()=>(0, $fYGKn.globalIssueNavigatorGinRedirectPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("j26UA", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalJiraRoute", () => $07713bbd3066130c$export$286b1d26dcbbce9e);
const $07713bbd3066130c$export$286b1d26dcbbce9e = {
    name: 'global-issue-navigator',
    path: '/jira/issues/:issueKey?'
};

});


parcelRegister("37pqk", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalRouteEntry", () => $be43171d4eefaba4$export$3e58fe44312b4093);

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $47bQc = parcelRequire("47bQc");

var $eznTg = parcelRequire("eznTg");


var $klAnQ = parcelRequire("klAnQ");

var $gAL0c = parcelRequire("gAL0c");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");
const $be43171d4eefaba4$export$3e58fe44312b4093 = (0, $6xToB.createEntry)((0, $47bQc.issueNavigatorGlobalRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $eznTg.GlobalIssueNavigatorSkeleton),
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $klAnQ.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $gAL0c.getCommonGlobalResources)()
        ],
        layout: (0, $7h3uc.globalLayout),
        isHydrateRootEnabled: (0, $7jTnu.fg)('nin-full-page-hydrate-root'),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorGlobalRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorGlobalRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-navigator.json',
            // An increase from 1.2s default to 1.5s will comfortably cater for P95 of issue search requests
            // For more insights into this decision, see https://jplat.atlassian.net/browse/EM-9249
            fetchTimeout: (0, $7jTnu.fg)('increase_server_fetch_timeouts_for_nin_bifrost') ? 1500 : undefined
        },
        entryPoint: ()=>(0, $fYGKn.globalIssueNavigatorGinRedirectPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("47bQc", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalRoute", () => $c1bfc0f1ce07a50f$export$928d3577bbe9e124);
const $c1bfc0f1ce07a50f$export$928d3577bbe9e124 = {
    name: 'global-issue-navigator',
    path: '/issues'
};

});


parcelRegister("gymKR", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessCustomEmbedRouteEntry", () => $6462e9329c8c7527$export$ca299eb1d1e6d3a9);

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $bZGp2 = parcelRequire("bZGp2");


var $hFWLB = parcelRequire("hFWLB");

var $7K5Ea = parcelRequire("7K5Ea");

var $kSeQy = parcelRequire("kSeQy");

var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");
const $6462e9329c8c7527$export$ca299eb1d1e6d3a9 = (0, $6xToB.createEntry)((0, $bZGp2.issueNavigatorProjectBusinessCustomEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $hFWLB.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        entryPoint: ()=>(0, $7jTnu.fg)('jira_nin_smart_link') ? (0, $fYGKn.issueNavigatorEmbedPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint)
    }));

});
parcelRegister("bZGp2", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessCustomEmbedRoute", () => $67ae605c2a0d7d1e$export$7c9a6e2f3d99aa24);
const $67ae605c2a0d7d1e$export$7c9a6e2f3d99aa24 = {
    name: 'issue-navigator-core-custom-embed',
    path: '/jira/core/projects/:projectKey/issues/:itemId/embed'
};

});

parcelRegister("hFWLB", function(module, exports) {

$parcel$export(module.exports, "EmbedIssueNavigatorSkeleton", () => $fd170ea0a62770da$export$1b1eaa2e48fda507);
/* embed-app.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $3FfuU = parcelRequire("3FfuU");
const $fd170ea0a62770da$var$customCssStyles = null;
const $fd170ea0a62770da$export$1b1eaa2e48fda507 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3FfuU))),
        className: (0, $hcewu.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("3FfuU", function(module, exports) {
module.exports = new URL("embed-issue-navigator-skeleton.tpl.616c25ab.svg", import.meta.url).toString();

});


parcelRegister("bQFhw", function(module, exports) {

$parcel$export(module.exports, "getCommonProjectResources", () => $e4f9b2fa1dd4e1a6$export$6236a7417086ea8d);

var $7jTnu = parcelRequire("7jTnu");

var $hHbzj = parcelRequire("hHbzj");

var $3IBHH = parcelRequire("3IBHH");

var $70taY = parcelRequire("70taY");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $kRv8K = parcelRequire("kRv8K");

var $dSkEC = parcelRequire("dSkEC");

var $8k1uC = parcelRequire("8k1uC");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $5L7qx = parcelRequire("5L7qx");

var $5nfTh = parcelRequire("5nfTh");

const $e4f9b2fa1dd4e1a6$export$6236a7417086ea8d = ({ isUsingSidebarEntrypoint: isUsingSidebarEntrypoint } = {})=>[
        (0, $5L7qx.browserOnlyResourceWithCondition)(// HOT-120098 - Mark resource as "browser only" in Legacy SSR to reduce the cost of
        // double-SSR when Modern SSR static fallbacks are not available.
        ()=>false && !(0, $9790b8dfe6f31c81$export$19d68f5aa485d903) && (0, $7jTnu.fg)('empanada_nin_disable_legacy_ssr'), (0, $8k1uC.issueNavigatorRelayResource)),
        (0, $5L7qx.browserOnlyResourceWithCondition)(// HOT-120098 - Mark resource as "browser only" in Legacy SSR to reduce the cost of
        // double-SSR when Modern SSR static fallbacks are not available.
        ()=>false && !(0, $9790b8dfe6f31c81$export$19d68f5aa485d903) && (0, $7jTnu.fg)('empanada_nin_disable_legacy_ssr'), (0, $8k1uC.issueNavigatorFilterRelayResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('nin_request_hydrate_query_earlier') && !(0, $7jTnu.fg)('render_jql_builder_in_ssr'), (0, $8k1uC.issueNavigatorHydrationRelayResourceBrowserOnly)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('render_jql_builder_in_ssr'), (0, $5L7qx.browserOnlyResourceWithCondition)(// HOT-120098 - Mark resource as "browser only" in Legacy SSR to reduce the cost of
        // double-SSR when Modern SSR static fallbacks are not available.
        ()=>false && !(0, $9790b8dfe6f31c81$export$19d68f5aa485d903) && (0, $7jTnu.fg)('empanada_nin_disable_legacy_ssr'), (0, $8k1uC.issueNavigatorHydrationRelayResource))),
        ...(0, $9NmsS.getNavigationResources)({
            isUsingSidebarEntrypoint: isUsingSidebarEntrypoint
        }),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $bTfc4.incidentExperimentTraitResource),
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $kRv8K.getBusinessProjectResources)(),
        (0, $70taY.sidebarProjectIssuesResource),
        (0, $dSkEC.isNinGlobalScopeEnrolmentEnabledResource),
        // this resource is also used by the nav4 sidebar for JSM project's 'issues and filters'
        // src/packages/navigation-apps/sidebar-nav4/jsm-project-menu/src/ui/project-menu/issues-and-filters/default-filters/index.tsx
        (0, $3IBHH.staticSidebarDefaultPINFiltersResource),
        ...(0, $5nfTh.getAIContextPanelResources)()
    ];

});
parcelRegister("3IBHH", function(module, exports) {

$parcel$export(module.exports, "staticSidebarDefaultPINFiltersResource", () => $af6bf790275ff943$export$d3efe54a881807bf);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $an7p8 = parcelRequire("an7p8");
const $af6bf790275ff943$export$d3efe54a881807bf = (0, $l1VxS.createResource)({
    type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
    getKey: ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
        return projectKey || 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
        if (projectKey == null) return null;
        return (0, $an7p8.fetchDefaultPINFiltersNavData)(projectKey);
    },
    maxAge: 300000
});

});
parcelRegister("an7p8", function(module, exports) {

$parcel$export(module.exports, "fetchDefaultPINFiltersNavData", () => $9e0f6cb12be550b3$export$268c1bcb44a0ddd3);

var $jGzN3 = parcelRequire("jGzN3");
const $9e0f6cb12be550b3$var$extractNavIds = (result)=>new Set((result['com.atlassian.jira.jira-projects-issue-navigator:generic-filters'] || []).map((filterNavItem)=>filterNavItem.id));
const $9e0f6cb12be550b3$export$268c1bcb44a0ddd3 = async (projectKey)=>{
    if (projectKey == null) throw new Error('invalid project id or key');
    const result = await (0, $jGzN3.performGetRequest)(`/rest/filters/1.0/filters?projectKey=${projectKey}`);
    const filterNavIds = $9e0f6cb12be550b3$var$extractNavIds(result);
    return {
        hasMyOpenIssues: filterNavIds.has('myopenissues'),
        hasReportedByMe: filterNavIds.has('reportedbyme'),
        hasAllIssues: filterNavIds.has('allissues'),
        hasAllOpenIssues: filterNavIds.has('allopenissues'),
        hasDoneIssues: filterNavIds.has('doneissues'),
        hasViewedRecently: filterNavIds.has('recentlyviewed'),
        hasCreatedRecently: filterNavIds.has('addedrecently'),
        hasResolvedRecently: filterNavIds.has('resolvedrecently'),
        hasUpdatedRecently: filterNavIds.has('updatedrecently')
    };
};

});


parcelRegister("70taY", function(module, exports) {

$parcel$export(module.exports, "sidebarProjectIssuesResource", () => $415ca39887aadfd5$export$be31dd7adcfd2297);

var $9FYIg = parcelRequire("9FYIg");

var $3wMj6 = parcelRequire("3wMj6");

var $hBje1 = parcelRequire("hBje1");
const $415ca39887aadfd5$export$be31dd7adcfd2297 = (0, $hBje1.withGiraAggAnonSsrFix)((0, $9FYIg.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $3wMj6.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("3wMj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $da2f00f6c73f2d52$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<02638f2e8727b45498d5facc19a78e14>>
 * @relayHash 976837d13abb9b9131601925549fb05e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f420a549079d5a65e8a18d3584aa82b524d2287758061372f8331701919dd3f9

var $5Jxq3 = parcelRequire("5Jxq3");
const $da2f00f6c73f2d52$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ],
        "type": "JiraCustomFilter"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "FILTER"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteFiltersOld",
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "favouriteFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f420a549079d5a65e8a18d3584aa82b524d2287758061372f8331701919dd3f9",
            "metadata": {},
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider": (0, $5Jxq3.default)
            }
        }
    };
}();
$da2f00f6c73f2d52$var$node.hash = "86a313b9769c9a6a731e02bed044f4d2";
var $da2f00f6c73f2d52$export$2e2bcd8739ae039 = $da2f00f6c73f2d52$var$node;

});




parcelRegister("dJkii", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessEmbedRouteEntry", () => $a8f2e4ff4bb50b03$export$2b29f9b6033583e1);

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $950ia = parcelRequire("950ia");


var $hFWLB = parcelRequire("hFWLB");

var $7K5Ea = parcelRequire("7K5Ea");

var $kSeQy = parcelRequire("kSeQy");

var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");
const $a8f2e4ff4bb50b03$export$2b29f9b6033583e1 = (0, $6xToB.createEntry)((0, $950ia.issueNavigatorProjectBusinessEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $hFWLB.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        entryPoint: ()=>(0, $7jTnu.fg)('jira_nin_smart_link') ? (0, $fYGKn.issueNavigatorEmbedPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint)
    }));

});
parcelRegister("950ia", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessEmbedRoute", () => $072d8c6f0ad6b8ae$export$a59f4bdf8be89f93);
const $072d8c6f0ad6b8ae$export$a59f4bdf8be89f93 = {
    name: 'issue-navigator-core-embed',
    path: '/jira/core/projects/:projectKey/issues/embed'
};

});


parcelRegister("7M3Qw", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessRouteEntry", () => $de31742aff49379c$export$ce258b07e4b7eb8c);

var $hS1gr = parcelRequire("hS1gr");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $2CudY = parcelRequire("2CudY");

var $gwH93 = parcelRequire("gwH93");


var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");
const $de31742aff49379c$export$ce258b07e4b7eb8c = (0, $6xToB.createEntry)((0, $2CudY.issueNavigatorProjectBusinessRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $gwH93.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $6dwgv.createLayout)((0, $ioHIu.genericProjectLayout)),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectBusinessRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectBusinessRouteEntry'
            },
            manifestName: 'jira-spa-issue-navigator.json',
            enabled: true
        },
        entryPoint: ()=>(0, $fYGKn.issueNavigatorPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("2CudY", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessRoute", () => $45f2e5a21d68291e$export$3219766aa1a42d18);
const $45f2e5a21d68291e$export$3219766aa1a42d18 = {
    name: 'issue-navigator-core',
    path: '/jira/core/projects/:projectKey/issues/:itemId?'
};

});

parcelRegister("gwH93", function(module, exports) {

$parcel$export(module.exports, "ProjectIssueNavigatorSkeleton", () => $6692fc7a1d956e32$export$112138f5f732a994);
/* project-app.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6zXPf = parcelRequire("6zXPf");

var $hwuZ0 = parcelRequire("hwuZ0");

var $3jjcl = parcelRequire("3jjcl");

var $lux9S = parcelRequire("lux9S");
const $6692fc7a1d956e32$var$customCssStyles = null;
const $6692fc7a1d956e32$export$112138f5f732a994 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, $6zXPf.getWillShowNav4)() ? (0, (/*@__PURE__*/$parcel$interopDefault($3jjcl))) : (0, (/*@__PURE__*/$parcel$interopDefault($lux9S))),
        className: (0, $hcewu.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("3jjcl", function(module, exports) {
module.exports = new URL("project-issue-navigator-nav4-skeleton.tpl.0c4c4250.svg", import.meta.url).toString();

});

parcelRegister("lux9S", function(module, exports) {
module.exports = new URL("project-issue-navigator-skeleton.tpl.2a1718d8.svg", import.meta.url).toString();

});



parcelRegister("kSzi3", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicCustomEmbedRouteEntry", () => $20ece720ea215a17$export$26b088a9b796b7a4);

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $5ClYN = parcelRequire("5ClYN");

var $hFWLB = parcelRequire("hFWLB");

var $7K5Ea = parcelRequire("7K5Ea");


var $kSeQy = parcelRequire("kSeQy");

var $bQFhw = parcelRequire("bQFhw");

var $fYGKn = parcelRequire("fYGKn");

var $d4NVH = parcelRequire("d4NVH");
const $20ece720ea215a17$export$26b088a9b796b7a4 = (0, $6xToB.createEntry)((0, $5ClYN.issueNavigatorProjectClassicCustomEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $hFWLB.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        isHydrateRootEnabled: (0, $7jTnu.fg)('nin-full-page-hydrate-root'),
        entryPoint: ()=>(0, $7jTnu.fg)('jira_nin_smart_link') ? (0, $fYGKn.issueNavigatorEmbedPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint)
    }));

});
parcelRegister("5ClYN", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicCustomEmbedRoute", () => $a4758a21ea467aab$export$67a527991a5dd89b);
const $a4758a21ea467aab$export$67a527991a5dd89b = {
    name: 'issue-navigator-classic-custom-embed',
    path: '/jira/software/c/projects/:projectKey/issues/:itemId/embed'
};

});


parcelRegister("eIWvD", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicEmbedRouteEntry", () => $0134eb36ace1ef06$export$e77148aa19091842);

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $83CdI = parcelRequire("83CdI");

var $hFWLB = parcelRequire("hFWLB");

var $7K5Ea = parcelRequire("7K5Ea");


var $kSeQy = parcelRequire("kSeQy");

var $bQFhw = parcelRequire("bQFhw");

var $fYGKn = parcelRequire("fYGKn");

var $d4NVH = parcelRequire("d4NVH");
const $0134eb36ace1ef06$export$e77148aa19091842 = (0, $6xToB.createEntry)((0, $83CdI.issueNavigatorProjectClassicEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $hFWLB.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        isHydrateRootEnabled: (0, $7jTnu.fg)('nin-full-page-hydrate-root'),
        entryPoint: ()=>(0, $7jTnu.fg)('jira_nin_smart_link') ? (0, $fYGKn.issueNavigatorEmbedPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint)
    }));

});
parcelRegister("83CdI", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicEmbedRoute", () => $5ed3aaf68de71c16$export$1062bd8aa98d7bd1);
const $5ed3aaf68de71c16$export$1062bd8aa98d7bd1 = {
    name: 'issue-navigator-classic-embed',
    path: '/jira/software/c/projects/:projectKey/issues/embed'
};

});


parcelRegister("5HdwO", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicRouteEntry", () => $1c4accc0e340e2b1$export$88d5f4117ce3d0fb);

var $7jTnu = parcelRequire("7jTnu");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $fswMK = parcelRequire("fswMK");

var $gwH93 = parcelRequire("gwH93");

var $hS1gr = parcelRequire("hS1gr");


var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");
const $1c4accc0e340e2b1$export$88d5f4117ce3d0fb = (0, $6xToB.createEntry)((0, $fswMK.issueNavigatorProjectClassicRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $gwH93.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.ForPaintClassicSoftwareProjectSidebar),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            })
        ],
        layout: (0, $6dwgv.createLayout)((0, $ioHIu.genericProjectLayout)),
        isHydrateRootEnabled: (0, $7jTnu.fg)('nin-full-page-hydrate-root'),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectClassicRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectClassicRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-navigator.json',
            // An increase from 1.2s default to 1.5s will comfortably cater for P95 of issue search requests
            // For more insights into this decision, see https://jplat.atlassian.net/browse/EM-9249
            fetchTimeout: (0, $7jTnu.fg)('increase_server_fetch_timeouts_for_nin_bifrost') ? 1500 : undefined
        },
        entryPoint: ()=>(0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $fYGKn.issueNavigatorPageEntryPointWithNested) : (0, $fYGKn.issueNavigatorPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("fswMK", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicRoute", () => $02e6762aec3aaac6$export$8e7b74b6169d59ca);
const $02e6762aec3aaac6$export$8e7b74b6169d59ca = {
    name: 'issue-navigator-classic',
    path: '/jira/software/c/projects/:projectKey/issues/:itemId?'
};

});


parcelRegister("9kaa4", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectListServicedeskRouteEntry", () => $c25cb749c6b5e510$export$1e29ccb817b061b2);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $aGQ56 = parcelRequire("aGQ56");

var $gr3Ie = parcelRequire("gr3Ie");

var $aQoXd = parcelRequire("aQoXd");

var $gwH93 = parcelRequire("gwH93");


var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");
const $c25cb749c6b5e510$export$1e29ccb817b061b2 = (0, $6xToB.createEntry)((0, $gr3Ie.issueNavigatorProjectListServicedeskRoute), ()=>({
        ufoName: 'jsm-list-nin',
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $gwH93.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.ForPaintServicedeskSidebar)
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)(),
            (0, $aGQ56.queuesNavigationItems),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        layout: (0, $aQoXd.serviceProjectLayout),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectListServicedeskRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectListServicedeskRouteEntry'
            },
            manifestName: 'jira-spa-issue-navigator.json',
            enabled: true
        },
        entryPoint: ()=>(0, $fYGKn.issueNavigatorWithoutHorizontalNavPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("gr3Ie", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectListServicedeskRoute", () => $1c67afca82f07a57$export$ae79eb2d016347ad);
const $1c67afca82f07a57$export$ae79eb2d016347ad = {
    name: 'servicedesk-list',
    path: '/jira/servicedesk/projects/:projectKey/list/:itemId?'
};

});


parcelRegister("7lqd9", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectServicedeskRouteEntry", () => $eaeddc79e63a2b6a$export$b779296ccb8ca1a8);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $aGQ56 = parcelRequire("aGQ56");

var $byfv5 = parcelRequire("byfv5");

var $aQoXd = parcelRequire("aQoXd");

var $gwH93 = parcelRequire("gwH93");


var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");
const $eaeddc79e63a2b6a$export$b779296ccb8ca1a8 = (0, $6xToB.createEntry)((0, $byfv5.issueNavigatorProjectServicedeskRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $gwH93.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.ForPaintServicedeskSidebar)
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)(),
            (0, $aGQ56.queuesNavigationItems),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        layout: (0, $aQoXd.serviceProjectLayout),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectServicedeskRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectServicedeskRouteEntry'
            },
            manifestName: 'jira-spa-issue-navigator.json',
            enabled: true
        },
        entryPoint: ()=>(0, $fYGKn.issueNavigatorWithoutHorizontalNavPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("byfv5", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectServicedeskRoute", () => $b2697b842d9d2a49$export$e3495d64f36ba27c);
const $b2697b842d9d2a49$export$e3495d64f36ba27c = {
    name: 'servicedesk-issues',
    path: '/jira/servicedesk/projects/:projectKey/issues/:itemId?'
};

});


parcelRegister("bxEah", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareCustomEmbedRouteEntry", () => $d017c9a55a396236$export$128e557bdc64663e);

var $6xToB = parcelRequire("6xToB");

var $5pk1v = parcelRequire("5pk1v");

var $7K5Ea = parcelRequire("7K5Ea");

var $4VIcO = parcelRequire("4VIcO");

var $hFWLB = parcelRequire("hFWLB");


var $7jTnu = parcelRequire("7jTnu");

var $kSeQy = parcelRequire("kSeQy");

var $bQFhw = parcelRequire("bQFhw");

var $fYGKn = parcelRequire("fYGKn");

var $d4NVH = parcelRequire("d4NVH");
const $d017c9a55a396236$export$128e557bdc64663e = (0, $6xToB.createEntry)((0, $5pk1v.issueNavigatorProjectSoftwareCustomEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $hFWLB.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        entryPoint: ()=>(0, $7jTnu.fg)('jira_nin_smart_link') ? (0, $fYGKn.issueNavigatorEmbedPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint)
    }));

});
parcelRegister("5pk1v", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareCustomEmbedRoute", () => $41e03a10d9a3d551$export$efddc86081bba5fc);
const $41e03a10d9a3d551$export$efddc86081bba5fc = {
    name: 'software-issue-navigator-custom-embed',
    path: '/jira/software/projects/:projectKey/issues/:itemId/embed'
};

});


parcelRegister("ytX2z", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareEmbedRouteEntry", () => $badedcd1e5c2c1b7$export$e87ead168f851b66);

var $6xToB = parcelRequire("6xToB");

var $4eenS = parcelRequire("4eenS");

var $7K5Ea = parcelRequire("7K5Ea");

var $4VIcO = parcelRequire("4VIcO");

var $hFWLB = parcelRequire("hFWLB");


var $7jTnu = parcelRequire("7jTnu");

var $kSeQy = parcelRequire("kSeQy");

var $bQFhw = parcelRequire("bQFhw");

var $fYGKn = parcelRequire("fYGKn");

var $d4NVH = parcelRequire("d4NVH");
const $badedcd1e5c2c1b7$export$e87ead168f851b66 = (0, $6xToB.createEntry)((0, $4eenS.issueNavigatorProjectSoftwareEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $hFWLB.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        entryPoint: ()=>(0, $7jTnu.fg)('jira_nin_smart_link') ? (0, $fYGKn.issueNavigatorEmbedPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint)
    }));

});
parcelRegister("4eenS", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareEmbedRoute", () => $d598abe98648a3a5$export$ab4385f7ae539901);
const $d598abe98648a3a5$export$ab4385f7ae539901 = {
    name: 'software-issue-navigator-embed',
    path: '/jira/software/projects/:projectKey/issues/embed'
};

});


parcelRegister("5rr5U", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareRouteEntry", () => $2626c3312716833c$export$2a50f64378877c9d);

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $enVQb = parcelRequire("enVQb");

var $gwH93 = parcelRequire("gwH93");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");


var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");
const $2626c3312716833c$export$2a50f64378877c9d = (0, $6xToB.createEntry)((0, $enVQb.issueNavigatorProjectSoftwareRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $gwH93.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.ForPaintSoftwareProjectSidebar),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $6dwgv.createLayout)((0, $8FCAy.softwareProjectLayoutNoOnboarding)),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectSoftwareRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectSoftwareRouteEntry'
            },
            manifestName: 'jira-spa-issue-navigator.json',
            enabled: true
        },
        entryPoint: ()=>(0, $fYGKn.issueNavigatorPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("enVQb", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareRoute", () => $d376270ff6ff844f$export$b8bd410115307d80);
const $d376270ff6ff844f$export$b8bd410115307d80 = {
    name: 'software-issue-navigator',
    path: '/jira/software/projects/:projectKey/issues/:itemId?'
};

});


parcelRegister("fFeTt", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessAttachmentsRouteEntry", () => $05292bd8a56c1695$export$62c45d8ff658b6c2);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $jpDOj = parcelRequire("jpDOj");

var $jkM5n = parcelRequire("jkM5n");

var $g8uYY = parcelRequire("g8uYY");

var $9n5I0 = parcelRequire("9n5I0");
const $05292bd8a56c1695$var$attachmentsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jkM5n.attachmentsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $05292bd8a56c1695$export$62c45d8ff658b6c2 = (0, $6xToB.createEntry)((0, $jpDOj.jiraBusinessAttachmentsRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.attachments-view',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        entryPoint: ()=>$05292bd8a56c1695$var$attachmentsPageEntryPoint,
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        supportsPreviewPanel: true
    }));

});
parcelRegister("jpDOj", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessAttachmentsRoute", () => $de1305201950e721$export$81237c0b791e592e);
const $de1305201950e721$export$81237c0b791e592e = {
    name: 'classic-business-attachments',
    path: '/jira/core/projects/:projectKey/attachments'
};

});

parcelRegister("jkM5n", function(module, exports) {

$parcel$export(module.exports, "attachmentsEntryPoint", () => $c2b712895055eec8$export$d94bafd9d893ec98);

var $4b7aq = parcelRequire("4b7aq");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $c2b712895055eec8$export$d94bafd9d893ec98 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("5DPbG")), {
        moduleId: "26a1d436",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        // This entry point should only load in this route
        // once overview is supported by backend, we should have a different entry point for it
        const { projectKey: projectKey } = context.match.params;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                jwmAttachmentsQuery: {
                    parameters: $4b7aq.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: projectKey,
                        projectKeys: [
                            projectKey
                        ],
                        filters: {
                            fileName: '',
                            authorIds: [],
                            mimeTypes: [],
                            dateRange: {
                                before: undefined,
                                after: undefined
                            }
                        },
                        durationInSeconds: 900,
                        maxTokenLength: 65534,
                        attachmentCount: 100
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'network-only'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});

});
parcelRegister("4b7aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c848784960304ed5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<27cf8d4c8476b55ad0214615c4321597>>
 * @relayHash c6e9983b2d202d37d436585f73068bb1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c2e6d7f1e46fae7f20940e5f2d25270db884f9c4ffb727bc5ca1be7cef02546
const $c848784960304ed5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9c2e6d7f1e46fae7f20940e5f2d25270db884f9c4ffb727bc5ca1be7cef02546",
        "metadata": {},
        "name": "src_jiraBusinessAttachmentsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c848784960304ed5$export$2e2bcd8739ae039 = $c848784960304ed5$var$node;

});

parcelRegister("5DPbG", function(module, exports) {

let $41b84d057a5df057$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $41b84d057a5df057$var$load("1VRB2"),
    $41b84d057a5df057$var$load("bABhq"),
    $41b84d057a5df057$var$load("9qESC")
]).then(()=>parcelRequire('eZOQw'));

});



parcelRegister("9onbT", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardCustomEmbedRouteEntry", () => $6a30df79afe8bf4d$export$4622ad4c7294f3a7);

var $7K5Ea = parcelRequire("7K5Ea");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $9Jo4w = parcelRequire("9Jo4w");

var $kRv8K = parcelRequire("kRv8K");

var $kmsn1 = parcelRequire("kmsn1");

var $bAZBO = parcelRequire("bAZBO");
const $6a30df79afe8bf4d$export$4622ad4c7294f3a7 = (0, $6xToB.createEntry)((0, $kmsn1.jiraBusinessBoardCustomEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board-embed',
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        resources: [
            ...(0, $kRv8K.getProjectViewResources)(),
            (0, $9Jo4w.workflowIssuesResource)
        ],
        entryPoint: ()=>(0, $bAZBO.boardEmbedPageEntryPoint)
    }));

});
parcelRegister("9Jo4w", function(module, exports) {

$parcel$export(module.exports, "workflowIssuesResource", () => $4f8c50521aed954a$export$49027035af709702);
$parcel$export(module.exports, "useWorkflowIssues", () => $4f8c50521aed954a$export$86b7de71bf71360d);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $9MB0h = parcelRequire("9MB0h");
const $4f8c50521aed954a$var$RESOURCE_TYPE_KEY = 'BUSINESS_WORKFLOW_ISSUES';

const $4f8c50521aed954a$export$49027035af709702 = (0, $l1VxS.createResource)({
    type: $4f8c50521aed954a$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$4f8c50521aed954a$var$RESOURCE_TYPE_KEY}_${projectKey}_${matchedRoute.match?.params?.itemId ?? 'default'}`;
    },
    getDataLoader: ()=>Promise.resolve((parcelRequire("9MB0h"))),
    getData: (0, $9MB0h.default),
    maxAge: 1000,
    isBrowserOnly: true
});
const $4f8c50521aed954a$export$86b7de71bf71360d = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $eJrcF.useResource)($4f8c50521aed954a$export$49027035af709702);

});
parcelRegister("9MB0h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fcafc61247208ca2$export$2e2bcd8739ae039);

var $d04mc = parcelRequire("d04mc");

var $6uWhG = parcelRequire("6uWhG");

var $1uIew = parcelRequire("1uIew");

var $4kMB4 = parcelRequire("4kMB4");

var $7hVvO = parcelRequire("7hVvO");
const $fcafc61247208ca2$var$EMPTY_DATA = {
    workflows: [],
    lastChangedTime: null
};
function $fcafc61247208ca2$var$getEarlyPreload() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const earlyPreloadPromise = window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__ = null;
        return earlyPreloadPromise.then((response)=>{
            if (!response.success) {
                if (response.error.status === 304) throw new (0, $d04mc.Unchanged)('Workflow issues have not changed since the last request');
                throw new (0, $1uIew.default)(response.error.status);
            }
            return {
                workflows: response.workflows,
                lastChangedTime: null
            };
        });
    }
    return null;
}
function $fcafc61247208ca2$var$fetchData({ projectKey: projectKey, itemId: itemId }) {
    const earlyPreload = $fcafc61247208ca2$var$getEarlyPreload();
    if (earlyPreload !== null) return earlyPreload;
    return (0, $d04mc.fetchWorkflowIssues)({
        projectKey: projectKey,
        itemId: itemId
    });
}
async function $fcafc61247208ca2$export$2e2bcd8739ae039({ match: match }, { tenantContext: tenantContext }) {
    const { isAnonymous: isAnonymous } = tenantContext;
    if (isAnonymous) return $fcafc61247208ca2$var$EMPTY_DATA;
    try {
        (0, $6uWhG.setMark)((0, $4kMB4.prefetchApiStartMark));
        const workflows = await $fcafc61247208ca2$var$fetchData({
            projectKey: match.params.projectKey ?? '',
            itemId: match.params.itemId ?? undefined
        });
        (0, $6uWhG.setMark)((0, $4kMB4.prefetchApiReadyMark));
        return workflows;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $7hVvO.createResourceError)({
            component: 'spa.view.routes.business.board-workflows.getData',
            message: 'An error was thrown while prefetching board data',
            name: 'ResourceError'
        }, error);
    }
}

});
parcelRegister("d04mc", function(module, exports) {

$parcel$export(module.exports, "Unchanged", () => $a872adfb90aa89a1$export$eccd6db33b8f6a89);
$parcel$export(module.exports, "fetchWorkflowIssues", () => $a872adfb90aa89a1$export$17e2e8212d93f58d);

var $gRw8I = parcelRequire("gRw8I");


var $kDz4Q = parcelRequire("kDz4Q");

var $1uIew = parcelRequire("1uIew");

var $1oMOM = parcelRequire("1oMOM");
class $a872adfb90aa89a1$export$eccd6db33b8f6a89 extends Error {
}
const $a872adfb90aa89a1$export$17e2e8212d93f58d = async ({ projectKey: projectKey, itemId: itemId, ifChangedSince: ifChangedSince })=>{
    (0, $gRw8I.di)(fetch);
    try {
        (0, $kDz4Q.markViewMetric)('jwm-board', (0, $7ae6358d133c6fe3$export$23e322eb7c526958));
        let url = `/rest/board-api/1/board/${projectKey}/workflows?excludeLabels=true`;
        if (itemId) url += `&viewItemId=${itemId}`;
        const defaultOptions = (0, $1oMOM.getDefaultOptions)(url);
        const response = await fetch(url, {
            ...defaultOptions,
            headers: {
                ...defaultOptions.headers,
                ...ifChangedSince ? {
                    'x-aif-changed-since': ifChangedSince
                } : undefined
            }
        });
        if (!response.ok) {
            if (response.status === 304) throw new $a872adfb90aa89a1$export$eccd6db33b8f6a89('Workflow issues have not changed since the last request');
            throw new (0, $1uIew.default)(response.status);
        }
        const lastChangedTime = response.headers.get('x-alast-changed-time');
        const workflows = await response.json();
        return {
            workflows: workflows.data,
            lastChangedTime: lastChangedTime
        };
    } finally{
        (0, $kDz4Q.markViewMetric)('jwm-board', (0, $7ae6358d133c6fe3$export$83ca21a50372ea3b));
    }
};

});
const $7ae6358d133c6fe3$export$747aad128920134d = 3000;
const $7ae6358d133c6fe3$export$e4f8d353742c04ac = 4000;
const $7ae6358d133c6fe3$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $7ae6358d133c6fe3$export$23e322eb7c526958 = 'REQUEST_START';
const $7ae6358d133c6fe3$export$83ca21a50372ea3b = 'REQUEST_END';
const $7ae6358d133c6fe3$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $7ae6358d133c6fe3$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $7ae6358d133c6fe3$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $7ae6358d133c6fe3$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $7ae6358d133c6fe3$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $7ae6358d133c6fe3$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("kDz4Q", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", () => $14d6e286f06274f1$export$2878bf482e539059);
$parcel$export(module.exports, "markViewMetric", () => $14d6e286f06274f1$export$8d15b4fb25f90514);

var $4WXKS = parcelRequire("4WXKS");

const $14d6e286f06274f1$var$slo = {
    fmp: {
        initial: {
            threshold: (0, $7ae6358d133c6fe3$export$747aad128920134d)
        },
        transition: {
            threshold: (0, $7ae6358d133c6fe3$export$747aad128920134d)
        }
    },
    tti: {
        initial: {
            threshold: (0, $7ae6358d133c6fe3$export$e4f8d353742c04ac)
        },
        transition: {
            threshold: (0, $7ae6358d133c6fe3$export$e4f8d353742c04ac)
        }
    }
};
const $14d6e286f06274f1$var$timings = [
    {
        key: (0, $7ae6358d133c6fe3$export$540ffd289e5e0562),
        startMark: (0, $7ae6358d133c6fe3$export$23e322eb7c526958),
        endMark: (0, $7ae6358d133c6fe3$export$83ca21a50372ea3b)
    },
    {
        key: (0, $7ae6358d133c6fe3$export$821ca6ff41f300ec),
        startMark: (0, $7ae6358d133c6fe3$export$7b887ee35f2b465e),
        endMark: (0, $7ae6358d133c6fe3$export$ac953882305d6102)
    },
    {
        key: (0, $7ae6358d133c6fe3$export$7f7f60b5526c5ee3),
        startMark: (0, $7ae6358d133c6fe3$export$b78f0bbf209e5f4),
        endMark: (0, $7ae6358d133c6fe3$export$88ea1e280513690f)
    }
];
const $14d6e286f06274f1$export$2878bf482e539059 = {
    'approvals-view': (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.approvals-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    summary: (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.summary-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'summary-embed': (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.summary-view-embed',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    list: (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.list-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'list-embed': (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.list-embed-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'software-form-submit-embed': (0, $4WXKS.metrics).pageLoad({
        key: 'jsw.form-submit-embed',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'software-list': (0, $4WXKS.metrics).pageLoad({
        key: 'jsw.list-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'software-list-embed': (0, $4WXKS.metrics).pageLoad({
        key: 'jsw.list-view-embed',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    timeline: (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.timeline-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'timeline-embed': (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.timeline-embed-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    calendar: (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.calendar-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'calendar-embed': (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.calendar-embed-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    form: (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.form-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'form-submit': (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.form-submit-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'form-submit-embed': (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.form-submit-embed-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'form-submit-public': (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.form-submit-public-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'form-directory': (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.form-directory-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    board: (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.board-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'jwm-board': (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.jwm-board',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'jwm-board-embed': (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.jwm-board-embed',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'jwm-pages': (0, $4WXKS.metrics).pageLoad({
        key: 'jwm.jwm-pages',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    // TODO: will be removed with sploverview-decouple-calendar-perf-metrics
    'software-plan-calendar': (0, $4WXKS.metrics).pageLoad({
        key: 'jsw.plan-calendar-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    })
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $14d6e286f06274f1$var$startedMarks = {};
const $14d6e286f06274f1$export$8d15b4fb25f90514 = (view, mark)=>{
    const markKey = `${view}-${mark}`;
    // prevent overriding marks when markViewMetric() is called many times with the same param
    if ($14d6e286f06274f1$var$startedMarks[markKey]) return;
    $14d6e286f06274f1$var$startedMarks[markKey] = true;
    const metric = $14d6e286f06274f1$export$2878bf482e539059[view];
    metric?.mark(mark);
};

});




parcelRegister("kmsn1", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardCustomEmbedRoute", () => $1cdf4356b463bbfc$export$7d977a74e9d9d32b);
const $1cdf4356b463bbfc$export$7d977a74e9d9d32b = {
    name: 'classic-business-board-custom-embed',
    path: '/jira/core/projects/:projectKey/board/:itemId/embed',
    exact: true
};

});

parcelRegister("bAZBO", function(module, exports) {

$parcel$export(module.exports, "boardEmbedPageEntryPoint", () => $92c5de105924e1af$export$5046daadb8899791);

var $g8uYY = parcelRequire("g8uYY");

var $1U42Z = parcelRequire("1U42Z");
const $92c5de105924e1af$export$5046daadb8899791 = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $1U42Z.boardEmbedEntryPoint)
});

});
parcelRegister("1U42Z", function(module, exports) {

$parcel$export(module.exports, "boardEmbedEntryPoint", () => $497ac14d88f3339b$export$416ba69e2e054935);

var $1iGaq = parcelRequire("1iGaq");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $497ac14d88f3339b$export$416ba69e2e054935 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("9xQ2O")), {
        moduleId: "c853cc44",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        const itemId = context.match.params.itemId ?? '';
        let filterJql = context.query?.filter;
        let groupBy = context.query?.groupBy;
        // if in a client environment, check whether the router url matches the current window pathname
        // if it does, use the filter and groupBy from the current window location instead of the router query
        // this avoids reloading the query without the overrides when a user hovers over prefetching links that don't include them
        if (typeof window !== 'undefined' && window.location.pathname === context.match.url) {
            const searchParams = new URLSearchParams(window.location.search);
            filterJql = searchParams.get('filter') ?? undefined;
            groupBy = searchParams.get('groupBy') ?? undefined;
        }
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                boardEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $1iGaq.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        viewInput: {
                            jiraBoardViewQueryInput: {
                                projectKeyAndItemIdQuery: {
                                    cloudId: cloudId,
                                    projectKey: projectKey,
                                    itemId: itemId
                                }
                            },
                            settings: {
                                filterJql: filterJql,
                                groupBy: groupBy
                            }
                        }
                    }
                }
            }
        };
    }
});

});
parcelRegister("1iGaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a466da213b440cfc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa5e2bc153f727a227765414f771440a>>
 * @relayHash 94346eb5747de472f4f68297ebfcf2c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 96dc8b27b8785eeba39db966850e114ceecb3e312d08f02ea4da2d15c8ff2e18

var $9nr4d = parcelRequire("9nr4d");

var $bZXny = parcelRequire("bZXny");

var $f1blX = parcelRequire("f1blX");
const $a466da213b440cfc$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "96dc8b27b8785eeba39db966850e114ceecb3e312d08f02ea4da2d15c8ff2e18",
        "metadata": {},
        "name": "src_jiraBusinessBoardEmbedQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcibs44boardinlinecreatemigrationrelayprovider": (0, $9nr4d.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": (0, $f1blX.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcmbw191displayflagsincaseofnocolumnsrelayprovider": (0, $bZXny.default)
        }
    }
};
var $a466da213b440cfc$export$2e2bcd8739ae039 = $a466da213b440cfc$var$node;

});
parcelRegister("9nr4d", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0ea698b0d1f6b7f$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $c0ea698b0d1f6b7f$var$Ibs44BoardInlineCreateMigrationRelayProvider = {
    get () {
        return (0, $7jTnu.fg)('ibs-44_create_issue_in_board_using_relay');
    }
};
var $c0ea698b0d1f6b7f$export$2e2bcd8739ae039 = $c0ea698b0d1f6b7f$var$Ibs44BoardInlineCreateMigrationRelayProvider;

});

parcelRegister("bZXny", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1b000a78d1b6df0$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $a1b000a78d1b6df0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('mbw-191_display_flags_in_case_of_no_columns');
    }
};

});

parcelRegister("f1blX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4868550c9dfba19$export$2e2bcd8739ae039);

var $epTsa = parcelRequire("epTsa");
const $a4868550c9dfba19$var$MergeBoardWorkflowsRelayProvider = {
    get () {
        return (0, $epTsa.expVal)('merge_board_workflows', 'enabled', false);
    }
};
var $a4868550c9dfba19$export$2e2bcd8739ae039 = $a4868550c9dfba19$var$MergeBoardWorkflowsRelayProvider;

});


parcelRegister("9xQ2O", function(module, exports) {

let $6f2f910f201886ae$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6f2f910f201886ae$var$load("1VRB2"),
    $6f2f910f201886ae$var$load("bABhq"),
    $6f2f910f201886ae$var$load("eDzss"),
    $6f2f910f201886ae$var$load("fSoqu")
]).then(()=>parcelRequire('e9FEZ'));

});




parcelRegister("i6owk", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardEmbedRouteEntry", () => $d1a30f2f12e306b4$export$7a97e5e258f37b2a);

var $7K5Ea = parcelRequire("7K5Ea");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $9Jo4w = parcelRequire("9Jo4w");

var $kRv8K = parcelRequire("kRv8K");

var $jOTca = parcelRequire("jOTca");

var $bAZBO = parcelRequire("bAZBO");
const $d1a30f2f12e306b4$export$7a97e5e258f37b2a = (0, $6xToB.createEntry)((0, $jOTca.jiraBusinessBoardEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board-embed',
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        resources: [
            ...(0, $kRv8K.getProjectViewResources)(),
            (0, $9Jo4w.workflowIssuesResource)
        ],
        entryPoint: ()=>(0, $bAZBO.boardEmbedPageEntryPoint)
    }));

});
parcelRegister("jOTca", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardEmbedRoute", () => $ee31414ab6a65efa$export$bd75a810572fe27d);
const $ee31414ab6a65efa$export$bd75a810572fe27d = {
    name: 'classic-business-board-embed',
    path: '/jira/core/projects/:projectKey/board/embed',
    exact: true
};

});


parcelRegister("6tmSj", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardRouteEntry", () => $f032cb8874fad627$export$c7fe0dd4417407a0);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9Jo4w = parcelRequire("9Jo4w");

var $kRv8K = parcelRequire("kRv8K");

var $kkG73 = parcelRequire("kkG73");

var $8QUNR = parcelRequire("8QUNR");
const $f032cb8874fad627$export$c7fe0dd4417407a0 = (0, $6xToB.createEntry)((0, $kkG73.jiraBusinessBoardRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board',
        layout: (0, $6dwgv.composeLayouts)((0, $9eXLI.businessProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $kRv8K.getProjectViewResources)(),
            (0, $9Jo4w.workflowIssuesResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'business-board-early-entry'
            ]
        },
        entryPoint: ()=>(0, $8QUNR.boardPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("kkG73", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardRoute", () => $10e4ad517f14f730$export$14a5cbbd7e1e2dc2);
const $10e4ad517f14f730$export$14a5cbbd7e1e2dc2 = {
    name: 'classic-business-board',
    exact: true,
    path: '/jira/core/projects/:projectKey/board/:itemId?'
};

});

parcelRegister("8QUNR", function(module, exports) {

$parcel$export(module.exports, "boardPageEntryPoint", () => $6fdbf2ac74ec6e3b$export$552f44bed039f041);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $cbl4g = parcelRequire("cbl4g");

var $9n5I0 = parcelRequire("9n5I0");
const $6fdbf2ac74ec6e3b$export$552f44bed039f041 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cbl4g.boardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("cbl4g", function(module, exports) {

$parcel$export(module.exports, "boardEntryPoint", () => $59cd06a0e4aee0da$export$937ca5a4cdc1a12e);

var $inMIk = parcelRequire("inMIk");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $59cd06a0e4aee0da$export$937ca5a4cdc1a12e = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("cgBwq")), {
        moduleId: "8dcbcc62",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        const itemId = context.match.params.itemId ?? '';
        let filterJql = context.query?.filter;
        let groupBy = context.query?.groupBy;
        // if in a client environment, check whether the router url matches the current window pathname
        // if it does, use the filter and groupBy from the current window location instead of the router query
        // this avoids reloading the query without the overrides when a user hovers over prefetching links that don't include them
        if (typeof window !== 'undefined' && window.location.pathname === context.match.url) {
            const searchParams = new URLSearchParams(window.location.search);
            filterJql = searchParams.get('filter') ?? undefined;
            groupBy = searchParams.get('groupBy') ?? undefined;
        }
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                boardQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $inMIk.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        viewInput: {
                            jiraBoardViewQueryInput: {
                                projectKeyAndItemIdQuery: {
                                    cloudId: cloudId,
                                    projectKey: projectKey,
                                    itemId: itemId
                                }
                            },
                            settings: {
                                filterJql: filterJql,
                                groupBy: groupBy
                            }
                        }
                    }
                }
            }
        };
    }
});

});
parcelRegister("inMIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $add593b4d7bfa958$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5fecb5ba21bd1f94d60d327ae071debb>>
 * @relayHash e919d0c81cab203402cb537c261edaad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4533656cb932b72d000c31c3e7648b38de1be1e6992c42abee2cba248aca545a

var $9nr4d = parcelRequire("9nr4d");

var $bZXny = parcelRequire("bZXny");

var $f1blX = parcelRequire("f1blX");
const $add593b4d7bfa958$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4533656cb932b72d000c31c3e7648b38de1be1e6992c42abee2cba248aca545a",
        "metadata": {},
        "name": "src_jiraBusinessBoardQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcibs44boardinlinecreatemigrationrelayprovider": (0, $9nr4d.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": (0, $f1blX.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcmbw191displayflagsincaseofnocolumnsrelayprovider": (0, $bZXny.default)
        }
    }
};
var $add593b4d7bfa958$export$2e2bcd8739ae039 = $add593b4d7bfa958$var$node;

});

parcelRegister("cgBwq", function(module, exports) {

let $8ee415bdc412baa8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8ee415bdc412baa8$var$load("1VRB2"),
    $8ee415bdc412baa8$var$load("bABhq"),
    $8ee415bdc412baa8$var$load("eDzss"),
    $8ee415bdc412baa8$var$load("hCwjE")
]).then(()=>parcelRequire('9toZG'));

});




parcelRegister("2KqMs", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarCustomEmbedRouteEntry", () => $abb092c651899b6f$export$2971062de35b0b9e);

var $7K5Ea = parcelRequire("7K5Ea");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $dKroe = parcelRequire("dKroe");

var $g8uYY = parcelRequire("g8uYY");

var $cxQGT = parcelRequire("cxQGT");

var $aJSoj = parcelRequire("aJSoj");
const $abb092c651899b6f$var$calendarEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $aJSoj.calendarEntryPoint)
});
const $abb092c651899b6f$export$2971062de35b0b9e = (0, $6xToB.createEntry)((0, $dKroe.jiraBusinessCalendarCustomEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.calendar-embed-view',
        entryPoint () {
            return $abb092c651899b6f$var$calendarEmbedPageEntrypoint;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ]
    }));

});
parcelRegister("dKroe", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarCustomEmbedRoute", () => $f23b84d56ba648dd$export$9cee00d5c4aee198);
const $f23b84d56ba648dd$export$9cee00d5c4aee198 = {
    name: 'classic-business-calendar-custom-embed',
    path: '/jira/core/projects/:projectKey/calendar/:itemId/embed',
    exact: true
};

});

parcelRegister("aJSoj", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $752335b943997526$export$19cf4b398f638dc6);

var $7jTnu = parcelRequire("7jTnu");

var $grGtq = parcelRequire("grGtq");

var $dW8bA = parcelRequire("dW8bA");

var $epTsa = parcelRequire("epTsa");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");
const $752335b943997526$var$SETTINGS_STORAGE_KEY = 'calendar:settings:business';
function $752335b943997526$var$getViewSettings(key) {
    try {
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
const $752335b943997526$var$and = (clauses)=>{
    return clauses.map((clause)=>clause.trim()).filter((clause)=>clause.length > 0).join(' AND ');
};
function $752335b943997526$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $752335b943997526$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $752335b943997526$var$createScope({ context: context }) {
    return {
        type: 'project',
        projectKeys: [
            String(context.match.params.projectKey)
        ]
    };
}
function $752335b943997526$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $752335b943997526$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $752335b943997526$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $752335b943997526$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $752335b943997526$var$toMidnightUTCString(selectedDate),
        mode: $752335b943997526$var$toViewMode(viewRange),
        weekStart: $752335b943997526$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField,
        viewId: null
    };
}
/** Extracted from business/shared/simpleSearch */ function $752335b943997526$var$jqlSearchText(text) {
    if (text === undefined || text.trim() === '') return '';
    const sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const ISSUEKEY_REGEX = '([A-Z][A-Z0-9_]+-\\d+)';
    const issueKeyRegex = new RegExp(`^${ISSUEKEY_REGEX}$`);
    const japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    let search = sanitize(text);
    if (issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
}
function $752335b943997526$var$buildIssuesSearchInput(filter = '', text = '', hideDoneItems) {
    if (!(0, $7jTnu.fg)('jira_calendar_load_more_pagination')) return {
        additionalFilterQuery: ''
    };
    const hideDoneItemsQuery = "StatusCategory != 'Complete'";
    const search = $752335b943997526$var$jqlSearchText(text);
    return {
        additionalFilterQuery: $752335b943997526$var$and([
            search,
            filter,
            ...hideDoneItems ? [
                hideDoneItemsQuery
            ] : []
        ])
    };
}
function $752335b943997526$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}

const $752335b943997526$export$19cf4b398f638dc6 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("6yeFJ")), {
        moduleId: "70b39bf1",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        const scope = $752335b943997526$var$createScope(entryPointRouteParams);
        const { date: date, filter: filter, hideDone: hideDone, text: text } = context.query;
        const selectedDate = $752335b943997526$var$toDate(date);
        const settings = (0, $7jTnu.fg)('jira_calendar_load_more_pagination') ? $752335b943997526$var$getViewSettings($752335b943997526$var$SETTINGS_STORAGE_KEY) : undefined;
        const viewRange = 'month';
        const hideDoneItems = hideDone && (0, $7jTnu.fg)('calendar-hide-done-query-param') ? true : settings?.hideDoneItems ?? false;
        const weekStartsOn = (0, $7jTnu.fg)('jira_calendar_load_more_pagination') ? settings?.weekStartsOn ?? 'sunday' : 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $grGtq.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $dW8bA.default),
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $752335b943997526$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $752335b943997526$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesPageSize: 200,
                        issuesSearchInput: $752335b943997526$var$buildIssuesSearchInput(filter, text, hideDoneItems),
                        unscheduledIssuesSearchInput: $752335b943997526$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: {
                            versionStatuses: [
                                'RELEASED',
                                'UNRELEASED'
                            ],
                            includeSharedReleases: true
                        },
                        sprintsSearchInput: null,
                        skipSprintSearch: true,
                        viewId: null,
                        schedulePermissionsEnabled: (0, $7jTnu.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $7jTnu.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV2Search: false,
                        includeRecurrenceIndicator: (0, $epTsa.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true),
                        pageLoadMoreEnabledViewSettings: (0, $7jTnu.fg)('jira_calendar_load_more_pagination_view_settings'),
                        skipUserPreferences: false,
                        hasSavedViewCapability: (0, $epTsa.expValEquals)('atlas-96240_saved_views_calendar', 'enabled', true, false)
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                hasRecurrenceItemIndicator: (0, $epTsa.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true)
            }
        };
    }
});

});
parcelRegister("grGtq", function(module, exports) {

$parcel$export(module.exports, "default", () => $081cd5aafd2f772f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<620394e61554de6b4de7fc13153ce658>>
 * @relayHash e7f526a757abd5ec137c62e6d5d37fb3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 23ff8ebcf7d113448b039ee2b0b9d7d1d70d6a6af70115838ee65796d163a423
const $081cd5aafd2f772f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "23ff8ebcf7d113448b039ee2b0b9d7d1d70d6a6af70115838ee65796d163a423",
        "metadata": {},
        "name": "src_jiraBusinessSharedCalendarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $081cd5aafd2f772f$export$2e2bcd8739ae039 = $081cd5aafd2f772f$var$node;

});

parcelRegister("6yeFJ", function(module, exports) {

let $4c514c9b1a7a882a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $4c514c9b1a7a882a$var$load("1VRB2"),
    $4c514c9b1a7a882a$var$load("bABhq"),
    $4c514c9b1a7a882a$var$load("7vqGd"),
    $4c514c9b1a7a882a$var$load("1Y4bq"),
    $4c514c9b1a7a882a$var$load("9Hsre")
]).then(()=>parcelRequire('c7lS4'));

});



parcelRegister("5ZNYc", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarEmbedRouteEntry", () => $ea2e7d70e18d88e4$export$d75a7b48d8838f92);

var $7K5Ea = parcelRequire("7K5Ea");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $hRRyN = parcelRequire("hRRyN");

var $g8uYY = parcelRequire("g8uYY");

var $aJSoj = parcelRequire("aJSoj");
const $ea2e7d70e18d88e4$var$calendarEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $aJSoj.calendarEntryPoint)
});
const $ea2e7d70e18d88e4$export$d75a7b48d8838f92 = (0, $6xToB.createEntry)((0, $hRRyN.jiraBusinessCalendarEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.calendar-embed-view',
        entryPoint () {
            return $ea2e7d70e18d88e4$var$calendarEmbedPageEntrypoint;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        resources: (0, $kRv8K.getProjectViewResources)()
    }));

});
parcelRegister("hRRyN", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarEmbedRoute", () => $fdebf02151d3a6e5$export$71a801c267234959);
const $fdebf02151d3a6e5$export$71a801c267234959 = {
    name: 'classic-business-calendar-embed',
    path: '/jira/core/projects/:projectKey/calendar/embed',
    exact: true
};

});


parcelRegister("hPiSX", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarRouteEntry", () => $9cffa112dd43b0a5$export$b8f4785659c5349e);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $lxEqj = parcelRequire("lxEqj");

var $g8uYY = parcelRequire("g8uYY");

var $aJSoj = parcelRequire("aJSoj");

var $9n5I0 = parcelRequire("9n5I0");
const $9cffa112dd43b0a5$var$calendarPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $aJSoj.calendarEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $9cffa112dd43b0a5$export$b8f4785659c5349e = (0, $6xToB.createEntry)((0, $lxEqj.jiraBusinessCalendarRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.calendar-view',
        entryPoint () {
            return $9cffa112dd43b0a5$var$calendarPageEntrypoint;
        },
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        supportsPreviewPanel: true
    }));

});
parcelRegister("lxEqj", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarRoute", () => $f6caa0a33eb55e2b$export$3f1924073260dde6);
const $f6caa0a33eb55e2b$export$3f1924073260dde6 = {
    name: 'classic-business-calendar',
    path: '/jira/core/projects/:projectKey/calendar/:itemId?',
    exact: true
};

});


parcelRegister("5JYqa", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListCustomEmbedRouteEntry", () => $e0655816f8b3f8da$export$e48bc622b980eb9a);

var $7K5Ea = parcelRequire("7K5Ea");

var $g8uYY = parcelRequire("g8uYY");

var $7jTnu = parcelRequire("7jTnu");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $d5Xmj = parcelRequire("d5Xmj");

var $6NcRg = parcelRequire("6NcRg");


var $d4NVH = parcelRequire("d4NVH");

var $hFWLB = parcelRequire("hFWLB");

var $fYGKn = parcelRequire("fYGKn");

var $kSeQy = parcelRequire("kSeQy");

var $bQFhw = parcelRequire("bQFhw");
const $e0655816f8b3f8da$var$listEmbedPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $6NcRg.listEmbedEntryPoint)
});
const $e0655816f8b3f8da$export$e48bc622b980eb9a = (0, $6xToB.createEntry)((0, $d5Xmj.jiraBusinessListCustomEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: (0, $7jTnu.fg)('jira_list_nin_merge') ? 'jwm-list-custom-nin-embed' : 'jwm.list-embed-view',
        meta: (0, $7jTnu.fg)('jira_list_nin_merge') ? {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        } : undefined,
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $hFWLB.EmbedIssueNavigatorSkeleton) : (0, $kNM5Y.ThemedLazySkeleton),
        entryPoint: ()=>{
            if ((0, $7jTnu.fg)('jira_list_nin_merge')) return (0, $7jTnu.fg)('jira_nin_smart_link') ? (0, $fYGKn.issueNavigatorEmbedPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint);
            return $e0655816f8b3f8da$var$listEmbedPageEntryPoint;
        },
        resources: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $bQFhw.getCommonProjectResources)() : (0, $kRv8K.getProjectViewResources)()
    }));

});
parcelRegister("d5Xmj", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListCustomEmbedRoute", () => $6d5399012f5ad5e4$export$3bcc972f482cc0bd);
const $6d5399012f5ad5e4$export$3bcc972f482cc0bd = {
    name: 'classic-business-list-custom-embed',
    path: '/jira/core/projects/:projectKey/list/:itemId/embed',
    exact: true
};

});

parcelRegister("6NcRg", function(module, exports) {

$parcel$export(module.exports, "listEmbedEntryPoint", () => $e6c67193850e83b5$export$519bb55e1612f243);

var $KREkC = parcelRequire("KREkC");

var $6ZqQe = parcelRequire("6ZqQe");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");
const $e6c67193850e83b5$var$FORMAT_RULES_FIRST = 20;

const $e6c67193850e83b5$export$519bb55e1612f243 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("1vnZD")), {
        moduleId: "543152bd",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6ZqQe.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $KREkC.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $e6c67193850e83b5$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("KREkC", function(module, exports) {

$parcel$export(module.exports, "default", () => $af8d10af7c45935c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b813023754a9b145ce165f16a407c601>>
 * @relayHash 59527960279493483dc426741a94e942
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 27842af21d3c4a1c89e9cf81f5d797dbb89b3da4ac6cc54f90271e8a38b37e39
const $af8d10af7c45935c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "27842af21d3c4a1c89e9cf81f5d797dbb89b3da4ac6cc54f90271e8a38b37e39",
        "metadata": {},
        "name": "formatRulesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $af8d10af7c45935c$export$2e2bcd8739ae039 = $af8d10af7c45935c$var$node;

});

parcelRegister("6ZqQe", function(module, exports) {

$parcel$export(module.exports, "default", () => $75ebf32dbf9eaa2c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3fbad09b7a5f56fa90258f09408fcab9>>
 * @relayHash 09e2853d076a3827094f0b2a31a60cad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e0425937923f1cfadd146be550944e5e36b0ec94fb0732af23a465a8c1c70cf5
const $75ebf32dbf9eaa2c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e0425937923f1cfadd146be550944e5e36b0ec94fb0732af23a465a8c1c70cf5",
        "metadata": {},
        "name": "src_jiraBusinessListEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $75ebf32dbf9eaa2c$export$2e2bcd8739ae039 = $75ebf32dbf9eaa2c$var$node;

});

parcelRegister("1vnZD", function(module, exports) {

let $118b4c3871b5b981$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $118b4c3871b5b981$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $118b4c3871b5b981$var$load("e7BS9")
        ]);
    }),
    $118b4c3871b5b981$var$load("1VRB2"),
    $118b4c3871b5b981$var$load("bABhq"),
    $118b4c3871b5b981$var$load("2uXoB")
]).then(()=>parcelRequire('h0NOf'));

});



parcelRegister("ljCsD", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListEmbedRouteEntry", () => $6a1767c82c2ebe4f$export$a6737d9a8c0f9d4f);

var $7K5Ea = parcelRequire("7K5Ea");

var $g8uYY = parcelRequire("g8uYY");

var $7jTnu = parcelRequire("7jTnu");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $jkZuG = parcelRequire("jkZuG");

var $6NcRg = parcelRequire("6NcRg");


var $d4NVH = parcelRequire("d4NVH");

var $hFWLB = parcelRequire("hFWLB");

var $fYGKn = parcelRequire("fYGKn");

var $kSeQy = parcelRequire("kSeQy");

var $bQFhw = parcelRequire("bQFhw");
const $6a1767c82c2ebe4f$var$listEmbedPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $6NcRg.listEmbedEntryPoint)
});
const $6a1767c82c2ebe4f$export$a6737d9a8c0f9d4f = (0, $6xToB.createEntry)((0, $jkZuG.jiraBusinessListEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: (0, $7jTnu.fg)('jira_list_nin_merge') ? 'jwm-list-nin-embed' : 'jwm.list-embed-view',
        meta: (0, $7jTnu.fg)('jira_list_nin_merge') ? {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        } : undefined,
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $hFWLB.EmbedIssueNavigatorSkeleton) : (0, $kNM5Y.ThemedLazySkeleton),
        entryPoint: ()=>{
            if ((0, $7jTnu.fg)('jira_list_nin_merge')) return (0, $7jTnu.fg)('jira_nin_smart_link') ? (0, $fYGKn.issueNavigatorEmbedPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint);
            return $6a1767c82c2ebe4f$var$listEmbedPageEntryPoint;
        },
        resources: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $bQFhw.getCommonProjectResources)() : (0, $kRv8K.getProjectViewResources)()
    }));

});
parcelRegister("jkZuG", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListEmbedRoute", () => $9878e458870df13b$export$40306068630dfc2);
const $9878e458870df13b$export$40306068630dfc2 = {
    name: 'classic-business-list-embed',
    path: '/jira/core/projects/:projectKey/list/embed',
    exact: true
};

});


parcelRegister("lIqxK", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListRouteEntry", () => $47af72d9ac0051e7$export$9ef24aa950399eaf);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $maEn8 = parcelRequire("maEn8");

var $iUCDP = parcelRequire("iUCDP");

var $9n5I0 = parcelRequire("9n5I0");

var $7jTnu = parcelRequire("7jTnu");


var $gwH93 = parcelRequire("gwH93");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");

var $bQFhw = parcelRequire("bQFhw");
const $47af72d9ac0051e7$var$listPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iUCDP.listEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $47af72d9ac0051e7$export$9ef24aa950399eaf = (0, $6xToB.createEntry)((0, $maEn8.jiraBusinessListRoute), ()=>({
        group: 'classic-business',
        ufoName: (0, $7jTnu.fg)('jira_list_nin_merge') ? 'jwm-list-nin' : 'jwm.list-view',
        meta: (0, $7jTnu.fg)('jira_list_nin_merge') ? {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        } : undefined,
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $gwH93.ProjectIssueNavigatorSkeleton) : (0, $kNM5Y.ThemedLazySkeleton),
        entryPoint: ()=>(0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $fYGKn.issueNavigatorPageEntryPoint) : $47af72d9ac0051e7$var$listPageEntryPoint,
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $bQFhw.getCommonProjectResources)() : (0, $kRv8K.getProjectViewResources)(),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-list-entries/src/jiraBusinessListRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessListRouteEntry'
            },
            manifestName: 'jira-spa-issue-navigator.json',
            enabled: true
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("maEn8", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListRoute", () => $ccb2ae16fec1261e$export$ea171f7670960cff);
const $ccb2ae16fec1261e$export$ea171f7670960cff = {
    name: 'classic-business-list',
    path: '/jira/core/projects/:projectKey/list/:itemId?',
    exact: true
};

});

parcelRegister("iUCDP", function(module, exports) {

$parcel$export(module.exports, "listEntryPoint", () => $565b926a73689f90$export$6be4f10150ff6073);

var $KREkC = parcelRequire("KREkC");

var $eoxCK = parcelRequire("eoxCK");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");
const $565b926a73689f90$var$FORMAT_RULES_FIRST = 20;

const $565b926a73689f90$export$6be4f10150ff6073 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("a7cq8")), {
        moduleId: "b03343a1",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $eoxCK.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $KREkC.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $565b926a73689f90$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("eoxCK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f328ced9a59f1af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9516f6b957580a1dd0913ff88ae3e10d>>
 * @relayHash 8ab96395b697c5b81fab0afb4eebcfef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e0cc007557fb53672f36f25ae9fd169cd95e4b69654d21b1f471f604abc11db8
const $1f328ced9a59f1af$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e0cc007557fb53672f36f25ae9fd169cd95e4b69654d21b1f471f604abc11db8",
        "metadata": {},
        "name": "src_jiraBusinessListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1f328ced9a59f1af$export$2e2bcd8739ae039 = $1f328ced9a59f1af$var$node;

});

parcelRegister("a7cq8", function(module, exports) {

let $75d4314826c8d52b$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $75d4314826c8d52b$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $75d4314826c8d52b$var$load("e7BS9")
        ]);
    }),
    $75d4314826c8d52b$var$load("1VRB2"),
    $75d4314826c8d52b$var$load("bABhq"),
    $75d4314826c8d52b$var$load("i3RRy")
]).then(()=>parcelRequire('i30hB'));

});



parcelRegister("2Q6z2", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessOverviewRedirectRouteEntry", () => $2b4aa3d4305a47d5$export$3aa9116f715693e1);

var $kHlOR = parcelRequire("kHlOR");

var $gYW18 = parcelRequire("gYW18");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $27BUY = parcelRequire("27BUY");

var $kpZMy = parcelRequire("kpZMy");
const $2b4aa3d4305a47d5$export$3aa9116f715693e1 = (0, $6xToB.createEntry)((0, $27BUY.jiraBusinessOverviewRedirectRoute), ()=>({
        group: 'classic-business',
        isRedirect: true,
        component: (0, $kpZMy.default),
        layout: (0, $9eXLI.businessProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $gYW18.AsyncHorizontalOverviewNav)
        },
        resources: (0, $kRv8K.getOverviewViewResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("27BUY", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessOverviewRedirectRoute", () => $f757b15bc23ad42c$export$5ab0e07528c31349);
const $f757b15bc23ad42c$export$5ab0e07528c31349 = {
    name: 'classic-business-overview-redirect',
    path: '/jira/core/overviews/:overviewId',
    exact: true
};

});

parcelRegister("kpZMy", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ab828ee58da7410$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");

var $2FqDG = parcelRequire("2FqDG");
const $0ab828ee58da7410$var$OverviewRedirect = ()=>{
    const [overviewId] = (0, $2FqDG.usePathParam)('overviewId');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/jira/core/overviews/${overviewId}/summary`
    });
};
var $0ab828ee58da7410$export$2e2bcd8739ae039 = $0ab828ee58da7410$var$OverviewRedirect;

});


parcelRegister("c0nCS", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessProjectRedirectRouteEntry", () => $184f703c83207ef4$export$766e305da4c78de5);

var $kHlOR = parcelRequire("kHlOR");

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $1xlYL = parcelRequire("1xlYL");

var $hoV2u = parcelRequire("hoV2u");
const $184f703c83207ef4$export$766e305da4c78de5 = (0, $6xToB.createEntry)((0, $1xlYL.jiraBusinessProjectRedirectRoute), ()=>({
        group: 'classic-business',
        isRedirect: true,
        component: (0, $hoV2u.RedirectToLastVisitedProjectPage),
        layout: (0, $9eXLI.businessProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("1xlYL", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", () => $b8accc242737a0ed$export$73b60789ceb8e1eb);
const $b8accc242737a0ed$export$73b60789ceb8e1eb = {
    name: 'classic-business-redirect',
    path: '/jira/core/projects/:projectKey',
    exact: true
};

});


parcelRegister("1U37F", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessReportsOverviewRouteEntry", () => $2dbc28f707f1b70a$export$2cde310731fa9055);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $2T0cn = parcelRequire("2T0cn");

var $g8uYY = parcelRequire("g8uYY");

var $9n5I0 = parcelRequire("9n5I0");

var $lvjEc = parcelRequire("lvjEc");
const $2dbc28f707f1b70a$var$reportsOverviewPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $lvjEc.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $2dbc28f707f1b70a$export$2cde310731fa9055 = (0, $6xToB.createEntry)((0, $2T0cn.jiraBusinessReportsOverviewRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.reports-overview',
        entryPoint () {
            return $2dbc28f707f1b70a$var$reportsOverviewPageEntryPoint;
        },
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)()
    }));

});
parcelRegister("2T0cn", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessReportsOverviewRoute", () => $d42d8f4ced936b9c$export$5881ca008f82b9d8);
const $d42d8f4ced936b9c$export$5881ca008f82b9d8 = {
    name: 'classic-business-reports-overview',
    path: '/jira/core/projects/:projectKey/reports',
    exact: true
};

});

parcelRegister("lvjEc", function(module, exports) {

$parcel$export(module.exports, "reportsOverviewPageEntryPoint", () => $6dda353dfc5c9434$export$9dfa968d9e20b359);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $7LwBf = parcelRequire("7LwBf");

var $7jTnu = parcelRequire("7jTnu");

const $6dda353dfc5c9434$export$9dfa968d9e20b359 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("jYaqC")).then((mod)=>mod.ReportsOverviewPage), {
        moduleId: "b8514977",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const boardId = context.match.params.boardId ? String(context.match.params.boardId) : null;
        const projectKey = context.match.params.projectKey ? String(context.match.params.projectKey) : null;
        const isBoardContext = !!boardId;
        const isProjectContext = !!projectKey;
        const cloudId = tenantContext.cloudId;
        return {
            queries: {
                reportsOverviewPage: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $7LwBf.default,
                    variables: {
                        boardId: isBoardContext ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '',
                        projectKey: !isBoardContext && isProjectContext ? projectKey : '',
                        cloudId: cloudId,
                        isBoardContext: isBoardContext,
                        isMigrateTMPReportsOverviewEnabled: (0, $7jTnu.fg)('uxissue_545_migrate_tmp_reports_overview_page')
                    }
                }
            }
        };
    }
});

});
parcelRegister("7LwBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $236fe7b79542d01c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c0f3e2f8236d66f250ed199907375700>>
 * @relayHash 05ffd34fa5bbab01e2f30c02aed2c65a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 86fbcc3761e023c866715a47f9a81034800b47ed6e13666cad9721d0582b801d
const $236fe7b79542d01c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isBoardContext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isMigrateTMPReportsOverviewEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "concreteType": "JiraReportCategoryEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraReportCategoryNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "concreteType": "JiraReportConnection",
                        "kind": "LinkedField",
                        "name": "reports",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraReportConnectionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraReport",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v7 /*: any*/ ,
                                            v8 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "key"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "imageUrl"
                                            },
                                            {
                                                "condition": "isMigrateTMPReportsOverviewEnabled",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isNotApplicableReason"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isNotApplicableDesc"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "description"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url"
                                            },
                                            v9 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v9 /*: any*/ 
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "srcReportsOverviewPageQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "reportCategories_reportsOverviewPage"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "reportCategoriesOld_reportsOverviewPage"
                },
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v5 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jira_projectByIdOrKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v6 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira_projectByIdOrKey.projectType"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira_projectByIdOrKey"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "srcReportsOverviewPageQuery",
            "selections": [
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraReportCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "reportCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "statusCode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v10 /*: any*/ 
                                    ]
                                },
                                v9 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraReportCategoryConnection",
                                                    "kind": "LinkedField",
                                                    "name": "reportCategories",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v9 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "86fbcc3761e023c866715a47f9a81034800b47ed6e13666cad9721d0582b801d",
            "metadata": {},
            "name": "srcReportsOverviewPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$236fe7b79542d01c$var$node.hash = "a328c09129eaecdb359972f8c5e6f8cd";
var $236fe7b79542d01c$export$2e2bcd8739ae039 = $236fe7b79542d01c$var$node;

});

parcelRegister("jYaqC", function(module, exports) {

let $e89bb5c05369dc80$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e89bb5c05369dc80$var$load("kdIiC").then(()=>parcelRequire('b5voN'));

});



parcelRegister("3ZA2n", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryEmbedRouteEntry", () => $fb888a6e77e9fdf9$export$2c37f93832ff9919);

var $7K5Ea = parcelRequire("7K5Ea");

var $g8uYY = parcelRequire("g8uYY");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $jDHf0 = parcelRequire("jDHf0");

var $aGXnR = parcelRequire("aGXnR");

var $7lao1 = parcelRequire("7lao1");

var $7jTnu = parcelRequire("7jTnu");
const $fb888a6e77e9fdf9$var$summaryEmbedBusimessPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $7lao1.summaryBusinessEmbedEntrypoint)
});
const $fb888a6e77e9fdf9$var$getSummaryPageResource = ()=>{
    return [
        ...(0, $7jTnu.fg)('helios_biz_project_fast_activity_feed') ? [] : [
            (0, $jDHf0.activityFeedResource)
        ]
    ];
};
const $fb888a6e77e9fdf9$export$2c37f93832ff9919 = (0, $6xToB.createEntry)((0, $aGXnR.jiraBusinessSummaryEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.summary-view-embed',
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        resources: [
            ...(0, $kRv8K.getProjectViewResources)(),
            ...$fb888a6e77e9fdf9$var$getSummaryPageResource()
        ],
        entryPoint: ()=>{
            return $fb888a6e77e9fdf9$var$summaryEmbedBusimessPageEntrypoint;
        }
    }));

});
parcelRegister("jDHf0", function(module, exports) {

$parcel$export(module.exports, "activityFeedResource", () => $e8f412e2783ab0c0$export$928ea152e5c5de54);

var $eOsKQ = parcelRequire("eOsKQ");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");
const $e8f412e2783ab0c0$var$RESOURCE_TYPE_KEY = 'BUSINESS_ACTIVITY_FEED';
const $e8f412e2783ab0c0$var$EMPTY_DATA = {
    data: [],
    pageInfo: {
        hasNextPage: false,
        endCursor: ''
    }
};
const $e8f412e2783ab0c0$export$928ea152e5c5de54 = (0, $l1VxS.createResource)({
    type: $e8f412e2783ab0c0$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$e8f412e2783ab0c0$var$RESOURCE_TYPE_KEY}_${projectKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return $e8f412e2783ab0c0$var$EMPTY_DATA;
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
        return (0, $eOsKQ.fetchActivityFeed)(null, projectKey);
    },
    maxAge: 5000,
    isBrowserOnly: true
});
const $e8f412e2783ab0c0$export$ee1fe267047f502f = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $eJrcF.useResource)($e8f412e2783ab0c0$export$928ea152e5c5de54);

});
parcelRegister("eOsKQ", function(module, exports) {

$parcel$export(module.exports, "fetchActivityFeed", () => $e8e2785d375e41cc$export$967c92ed76f908b6);

var $gRw8I = parcelRequire("gRw8I");

var $1uIew = parcelRequire("1uIew");

var $jrKJw = parcelRequire("jrKJw");
const $e8e2785d375e41cc$var$PAGE_SIZE = 10;
const $e8e2785d375e41cc$var$CONTENT_TYPE = 'application/atom+xml; charset=UTF-8';
const $e8e2785d375e41cc$var$STREAM_PROVIDERS = 'thirdparty issues';
const $e8e2785d375e41cc$export$967c92ed76f908b6 = (after, projectKey)=>{
    (0, $gRw8I.di)(fetch);
    const firstIndex = after != null ? Number(after) : 0;
    const maxResults = firstIndex + $e8e2785d375e41cc$var$PAGE_SIZE;
    return fetch(// @ts-expect-error - TS2345: Types of property 'maxResults' are incompatible. Type 'number' is not assignable to type 'string'.
    `/plugins/servlet/streams?${new URLSearchParams({
        maxResults: maxResults,
        relativeLinks: true,
        streams: `key IS ${projectKey}`,
        providers: $e8e2785d375e41cc$var$STREAM_PROVIDERS
    }).toString()}`, {
        headers: {
            'content-type': $e8e2785d375e41cc$var$CONTENT_TYPE
        }
    }).then((response)=>{
        if (!response.ok) throw new (0, $1uIew.default)(response.status, `Error server response: ${response.status}`);
        return response.text();
    }).then((rawResponse)=>{
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(rawResponse, 'application/xml');
        const entries = (0, $jrKJw.transformData)(xmlDoc);
        return {
            data: entries,
            pageInfo: {
                hasNextPage: entries.length >= maxResults,
                endCursor: String(entries.length)
            }
        };
    });
};

});
parcelRegister("jrKJw", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $2673472aead14945$export$3ceb62baab058c6b);
const $2673472aead14945$export$3ceb62baab058c6b = (xmlDoc)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'ActivityFeedItem'.
    const result = [];
    // Typecheck with project references identifies this as error but existing typecheck is not so doesnt allow ts-expect-error, so used ts-ignore
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - Type 'NodeListOf<Element>' must have a '[Symbol.iterator]()' method that returns an iterator.
    for (const entry of xmlDoc.querySelectorAll('entry')){
        const id = entry.querySelector('id')?.textContent ?? '';
        const published = entry.querySelector('published')?.textContent ?? '';
        const name = entry.querySelector('author > name')?.textContent ?? '';
        const title = entry.querySelector('title')?.textContent ?? '';
        const iconUrl = entry.querySelector('[rel="http://streams.atlassian.com/syndication/icon"]')?.getAttribute('href') ?? '';
        const content = entry.querySelector('content')?.textContent;
        const feedItem = {
            id: id,
            author: {
                name: name,
                avatarUrl: ''
            },
            published: published,
            title: title,
            iconUrl: iconUrl,
            content: content
        };
        entry.querySelectorAll('author > link[rel=photo]').forEach((link)=>{
            if (link.getAttribute('media:height') === '48') feedItem.author.avatarUrl = link.getAttribute('href') ?? '';
        });
        result.push(feedItem);
    }
    return result;
};

});



parcelRegister("aGXnR", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryEmbedRoute", () => $d71cd7db20d0c836$export$d4aa7e677d381961);
const $d71cd7db20d0c836$export$d4aa7e677d381961 = {
    name: 'classic-business-summary-embed',
    path: '/jira/core/projects/:projectKey/summary/embed',
    exact: true
};

});

parcelRegister("7lao1", function(module, exports) {

$parcel$export(module.exports, "summaryBusinessEmbedEntrypoint", () => $5ece2cbaafb216d6$export$a027511631595373);

var $dSEJJ = parcelRequire("dSEJJ");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $5ece2cbaafb216d6$export$a027511631595373 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("aZfac")), {
        moduleId: "bfeee3c2",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $dSEJJ.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("dSEJJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5c9f1f77e701cc7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2161716a6a9ddd596df65d397a277cb5>>
 * @relayHash 4f557a85d513d521d9088e7217fed3ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15dd5fffb84db9cd2e32bf1439d87098cf295ac5f7e1bcaae80f031fdad2d763
const $f5c9f1f77e701cc7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "15dd5fffb84db9cd2e32bf1439d87098cf295ac5f7e1bcaae80f031fdad2d763",
        "metadata": {},
        "name": "src_jiraSummaryBusinessEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $f5c9f1f77e701cc7$export$2e2bcd8739ae039 = $f5c9f1f77e701cc7$var$node;

});

parcelRegister("aZfac", function(module, exports) {

let $7ffb5d06e39229d7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7ffb5d06e39229d7$var$load("1VRB2"),
    $7ffb5d06e39229d7$var$load("bABhq"),
    $7ffb5d06e39229d7$var$load("eDzss"),
    $7ffb5d06e39229d7$var$load("fbpD8")
]).then(()=>parcelRequire('ib7sZ'));

});



parcelRegister("ghxYA", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryRouteEntry", () => $d82905b20b85bd68$export$66365c0c5e8430d2);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $jDHf0 = parcelRequire("jDHf0");

var $xoHZX = parcelRequire("xoHZX");

var $5fwSH = parcelRequire("5fwSH");

var $9n5I0 = parcelRequire("9n5I0");

var $7jTnu = parcelRequire("7jTnu");
const $d82905b20b85bd68$var$summaryBusinessPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $5fwSH.summaryBusinessEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $d82905b20b85bd68$var$getSummaryPageResource = ()=>{
    return [
        ...(0, $7jTnu.fg)('helios_biz_project_fast_activity_feed') ? [] : [
            (0, $jDHf0.activityFeedResource)
        ]
    ];
};
const $d82905b20b85bd68$export$66365c0c5e8430d2 = (0, $6xToB.createEntry)((0, $xoHZX.jiraBusinessSummaryRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.summary-view',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $kRv8K.getProjectViewResources)(),
            ...$d82905b20b85bd68$var$getSummaryPageResource()
        ],
        entryPoint: ()=>{
            return $d82905b20b85bd68$var$summaryBusinessPageEntrypoint;
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("xoHZX", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryRoute", () => $f98c60dd3a974656$export$ad0ce411d14c71d7);
const $f98c60dd3a974656$export$ad0ce411d14c71d7 = {
    name: 'classic-business-summary',
    path: '/jira/core/projects/:projectKey/summary',
    exact: true
};

});

parcelRegister("5fwSH", function(module, exports) {

$parcel$export(module.exports, "summaryBusinessEntrypoint", () => $ea4dc8c9f01f8047$export$1655de4ea7d4bb73);

var $fN78K = parcelRequire("fN78K");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $ea4dc8c9f01f8047$export$1655de4ea7d4bb73 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("aVJaB")), {
        moduleId: "e788cf2e",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $fN78K.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("fN78K", function(module, exports) {

$parcel$export(module.exports, "default", () => $17b42e5297ed2898$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e999f38de92db02cb900ff3e39b1c9b5>>
 * @relayHash e1db5ab6de3c01b21716a8934a36cc9b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b047866626fc08071e5717fa8caf4a6c7867aefae410e0168cbc01019589055
const $17b42e5297ed2898$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0b047866626fc08071e5717fa8caf4a6c7867aefae410e0168cbc01019589055",
        "metadata": {},
        "name": "src_jiraSummaryBusinessQuery",
        "operationKind": "query",
        "text": null
    }
};
var $17b42e5297ed2898$export$2e2bcd8739ae039 = $17b42e5297ed2898$var$node;

});

parcelRegister("aVJaB", function(module, exports) {

let $7f52441962c0a688$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7f52441962c0a688$var$load("1VRB2"),
    $7f52441962c0a688$var$load("bABhq"),
    $7f52441962c0a688$var$load("eDzss"),
    $7f52441962c0a688$var$load("4y6oV")
]).then(()=>parcelRequire('j9j0S'));

});



parcelRegister("bMvJs", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineEmbedRouteEntry", () => $0294bda49e4b203b$export$ef65a62ced1a9df1);

var $7K5Ea = parcelRequire("7K5Ea");

var $g8uYY = parcelRequire("g8uYY");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $3f2WR = parcelRequire("3f2WR");

var $egdw2 = parcelRequire("egdw2");

var $6mHOv = parcelRequire("6mHOv");
const $0294bda49e4b203b$var$timelineEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $6mHOv.timelineEntrypoint)
});
const $0294bda49e4b203b$var$legacyimelineEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $egdw2.timelineEmbedEntrypoint)
});
const $0294bda49e4b203b$export$ef65a62ced1a9df1 = (0, $6xToB.createEntry)((0, $3f2WR.jiraBusinessTimelineEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.timeline-embed-view',
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $7jTnu.fg)('enable_field_namespace_filtering') && (0, $7jTnu.fg)('issue_table_frozen_columns') && (0, $7jTnu.fg)('jira_list_extended_scroll_container_props') && (0, $7jTnu.fg)('jira_list_merged_column_gate') && (0, $7jTnu.fg)('jira_native_issue_table_extra_custom_components') && (0, $epTsa.expValEquals)('jira_timeline_harmonisation_m1', 'isEnabled', true) ? $0294bda49e4b203b$var$timelineEmbedPageEntrypoint : $0294bda49e4b203b$var$legacyimelineEmbedPageEntrypoint
    }));

});
parcelRegister("3f2WR", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineEmbedRoute", () => $03a3fd655997b506$export$d85fbccfa0ba559a);
const $03a3fd655997b506$export$d85fbccfa0ba559a = {
    name: 'classic-business-timeline-embed',
    path: '/jira/core/projects/:projectKey/timeline/embed',
    exact: true
};

});

parcelRegister("egdw2", function(module, exports) {

$parcel$export(module.exports, "timelineEmbedEntrypoint", () => $d861558f24426713$export$12a9d017aa53985f);

var $bpttI = parcelRequire("bpttI");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $d861558f24426713$export$12a9d017aa53985f = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("7qjw1")), {
        moduleId: "88bc99ab",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                timelineEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $bpttI.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("bpttI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1628df2ccefacae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c25e21ec05fd2b676e0b39f50f317308>>
 * @relayHash aaa779177ef49e606102f9e257279c2f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52e90730f9edc63b8e9c272f467903f50d287b068a5e9571a6fd34719bb2539c
const $f1628df2ccefacae$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "52e90730f9edc63b8e9c272f467903f50d287b068a5e9571a6fd34719bb2539c",
        "metadata": {},
        "name": "src_jiraBusinessTimelineEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $f1628df2ccefacae$export$2e2bcd8739ae039 = $f1628df2ccefacae$var$node;

});

parcelRegister("7qjw1", function(module, exports) {

let $567a19801b6ab554$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $567a19801b6ab554$var$load("1VRB2"),
    $567a19801b6ab554$var$load("bABhq"),
    $567a19801b6ab554$var$load("davsI")
]).then(()=>parcelRequire('fDHwb'));

});


parcelRegister("6mHOv", function(module, exports) {

$parcel$export(module.exports, "timelineEntrypoint", () => $f5be1f5b0393c2c3$export$7586afa83216512a);

var $7jTnu = parcelRequire("7jTnu");

var $P5lF7 = parcelRequire("P5lF7");

var $fCagM = parcelRequire("fCagM");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");
const $f5be1f5b0393c2c3$var$and = (clauses)=>{
    return clauses.map((clause)=>clause.trim()).filter((clause)=>clause.length > 0).join(' AND ');
};
const $f5be1f5b0393c2c3$var$getProjectJql = (projectKey)=>projectKey.length > 0 ? `project = '${projectKey}'` : '';
const $f5be1f5b0393c2c3$var$getSearchTextJql = (text)=>{
    if (text === undefined || text.trim() === '') return '';
    const sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const issueKeyRegex = new RegExp('^([A-Z][A-Z0-9_]+-\\d+)$');
    const japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    let search = sanitize(text);
    if (issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
};
const $f5be1f5b0393c2c3$var$buildIssuesSearchInput = (filter = '', text = '', projectKey = '')=>{
    const search = $f5be1f5b0393c2c3$var$getSearchTextJql(text);
    const project = $f5be1f5b0393c2c3$var$getProjectJql(projectKey);
    return {
        jql: `${$f5be1f5b0393c2c3$var$and([
            search,
            filter,
            project
        ])} ORDER BY rank ASC`
    };
};
// should be equivalent to the getToday function in jira/src/packages/software/roadmap/utils/src/utils/dates.tsx
const $f5be1f5b0393c2c3$var$getToday = ()=>{
    const now = new Date();
    const date = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
    return date.valueOf();
};

const $f5be1f5b0393c2c3$export$7586afa83216512a = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("8i5hY")), {
        moduleId: "ea9f2eb3",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const namespace = (0, $7jTnu.fg)('enable_field_namespace_filtering') ? 'TIMELINE' : 'ISSUE_NAVIGATOR';
        const projectKey = context.match.params.projectKey;
        const { filter: filter, text: text } = context.query;
        if (projectKey == null) throw new Error('Project key missing');
        const fieldSetIds = [
            'issuetype',
            'issuekey',
            'summary',
            'timeline'
        ];
        const staticViewInput = {
            isGroupingEnabled: false,
            isHierarchyEnabled: true
        };
        return {
            extraProps: {
                today: $f5be1f5b0393c2c3$var$getToday()
            },
            queries: {
                businessTimelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $P5lF7.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                timelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $fCagM.default),
                    variables: {
                        amountOfColumns: 500,
                        cloudId: cloudId,
                        fieldSetIds: fieldSetIds,
                        fieldSetsInput: {
                            fieldSetIds: fieldSetIds
                        },
                        filterId: null,
                        first: 50,
                        issueSearchInput: $f5be1f5b0393c2c3$var$buildIssuesSearchInput(filter, text, projectKey),
                        namespace: namespace,
                        projectKey: projectKey,
                        shouldQueryFieldSetsById: false,
                        shouldQueryHasChildren: true,
                        staticViewInput: staticViewInput,
                        viewConfigInput: {
                            staticViewInput: staticViewInput
                        },
                        viewId: 'list_default'
                    }
                }
            }
        };
    }
});

});
parcelRegister("P5lF7", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bbd0ac55c726fa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<951467f217b7b80c29447f75caa0a085>>
 * @relayHash abf98366ae34ffd1f8b11a9f6e296e42
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe89a0048379d250f0d0d63fea37ec5e51eabf66a8cd926fb797e653f452a422
const $80bbd0ac55c726fa$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fe89a0048379d250f0d0d63fea37ec5e51eabf66a8cd926fb797e653f452a422",
        "metadata": {},
        "name": "src_jiraHarmonisedBusinessTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $80bbd0ac55c726fa$export$2e2bcd8739ae039 = $80bbd0ac55c726fa$var$node;

});

parcelRegister("fCagM", function(module, exports) {

$parcel$export(module.exports, "default", () => $223f6fc754a85a37$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<35588b02cc21a3b18228280a5a8d05de>>
 * @relayHash 8f92b2b794a58ab706ee9a0fb9f74f1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a97c50980e598914f8237cff2ccad6c06e91f48ba80f19340231dccbe6be6fd5

var $kZq2R = parcelRequire("kZq2R");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $4MVMw = parcelRequire("4MVMw");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $hRj2m = parcelRequire("hRj2m");

var $2HLoK = parcelRequire("2HLoK");

var $kmr3r = parcelRequire("kmr3r");

var $bU8Sj = parcelRequire("bU8Sj");

var $clCUA = parcelRequire("clCUA");

var $8Qoc7 = parcelRequire("8Qoc7");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");

var $7lcgt = parcelRequire("7lcgt");

var $iOvkB = parcelRequire("iOvkB");
const $223f6fc754a85a37$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a97c50980e598914f8237cff2ccad6c06e91f48ba80f19340231dccbe6be6fd5",
        "metadata": {},
        "name": "src_timelineQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $kmr3r.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $7lcgt.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": (0, $clCUA.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider": (0, $4MVMw.default)
        }
    }
};
var $223f6fc754a85a37$export$2e2bcd8739ae039 = $223f6fc754a85a37$var$node;

});

parcelRegister("8i5hY", function(module, exports) {

let $60941b71eab74246$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $60941b71eab74246$var$load("7vqGd"),
    $60941b71eab74246$var$load("1Y4bq"),
    $60941b71eab74246$var$load("1VRB2"),
    $60941b71eab74246$var$load("bABhq"),
    $60941b71eab74246$var$load("eDzss"),
    $60941b71eab74246$var$load("ftDEC")
]).then(()=>parcelRequire('6Lijq'));

});



parcelRegister("ffcU3", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineRouteEntry", () => $03a43808b6d91c8a$export$5725375da49b5772);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $g8uYY = parcelRequire("g8uYY");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9jvLx = parcelRequire("9jvLx");

var $1J9Ft = parcelRequire("1J9Ft");

var $6mHOv = parcelRequire("6mHOv");

var $9n5I0 = parcelRequire("9n5I0");
const $03a43808b6d91c8a$var$timelinePageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $6mHOv.timelineEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $03a43808b6d91c8a$var$legacyTimelinePageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1J9Ft.timelineEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $03a43808b6d91c8a$export$5725375da49b5772 = (0, $6xToB.createEntry)((0, $9jvLx.jiraBusinessTimelineRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.timeline-view',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $7jTnu.fg)('enable_field_namespace_filtering') && (0, $7jTnu.fg)('issue_table_frozen_columns') && (0, $7jTnu.fg)('jira_list_extended_scroll_container_props') && (0, $7jTnu.fg)('jira_list_merged_column_gate') && (0, $7jTnu.fg)('jira_native_issue_table_extra_custom_components') && (0, $epTsa.expValEquals)('jira_timeline_harmonisation_m1', 'isEnabled', true) ? $03a43808b6d91c8a$var$timelinePageEntrypoint : $03a43808b6d91c8a$var$legacyTimelinePageEntrypoint,
        supportsPreviewPanel: true
    }));

});
parcelRegister("9jvLx", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineRoute", () => $22d0d54ffe950fa8$export$4c71cfbf61bf0bf3);
const $22d0d54ffe950fa8$export$4c71cfbf61bf0bf3 = {
    name: 'classic-business-timeline',
    path: '/jira/core/projects/:projectKey/timeline',
    exact: true
};

});

parcelRegister("1J9Ft", function(module, exports) {

$parcel$export(module.exports, "timelineEntrypoint", () => $bdeab538ab55ab83$export$7586afa83216512a);

var $f5Ive = parcelRequire("f5Ive");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $bdeab538ab55ab83$export$7586afa83216512a = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("6aNh5")), {
        moduleId: "cac371d1",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                timelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $f5Ive.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("f5Ive", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5bec15de29074ce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec0d5db49437667573ca835bd84e9756>>
 * @relayHash 841436c7487840af84c959f83e5a4493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4443dbc3773e515f952da0ae8f171c483657c4548c4768b6b9c144da0822a4f1
const $d5bec15de29074ce$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4443dbc3773e515f952da0ae8f171c483657c4548c4768b6b9c144da0822a4f1",
        "metadata": {},
        "name": "src_jiraBusinessTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d5bec15de29074ce$export$2e2bcd8739ae039 = $d5bec15de29074ce$var$node;

});

parcelRegister("6aNh5", function(module, exports) {

let $47e9e62dd178bd47$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $47e9e62dd178bd47$var$load("1VRB2"),
    $47e9e62dd178bd47$var$load("bABhq"),
    $47e9e62dd178bd47$var$load("b0vgf")
]).then(()=>parcelRequire('bsJdy'));

});



parcelRegister("eWBMh", function(module, exports) {

$parcel$export(module.exports, "jiraHomeRouteEntry", () => $1c1cfc9939ff8808$export$578dcb61ac3cb57a);

var $eJOHy = parcelRequire("eJOHy");

var $dwa8t = parcelRequire("dwa8t");

var $1kys8 = parcelRequire("1kys8");

var $kHlOR = parcelRequire("kHlOR");

var $dI30d = parcelRequire("dI30d");

var $7jTnu = parcelRequire("7jTnu");

var $4ZkZK = parcelRequire("4ZkZK");

var $1RKJf = parcelRequire("1RKJf");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");


var $4VIcO = parcelRequire("4VIcO");

var $iDAU4 = parcelRequire("iDAU4");

var $80Ye8 = parcelRequire("80Ye8");

var $9NmsS = parcelRequire("9NmsS");

var $iIQmy = parcelRequire("iIQmy");

var $5fjzQ = parcelRequire("5fjzQ");

var $5L7qx = parcelRequire("5L7qx");

var $5gjY4 = parcelRequire("5gjY4");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $epTsa = parcelRequire("epTsa");

var $2emAF = parcelRequire("2emAF");

var $bvwBX = parcelRequire("bvwBX");

var $jnds2 = parcelRequire("jnds2");
const $1c1cfc9939ff8808$var$conditionalPostOfficeJiraYourWorkResource = (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('post_office_ssr_jira_your_work_enabled'), (0, $5fjzQ.postOfficeJiraYourWorkResource));
const $1c1cfc9939ff8808$var$conditionalJiraHomeWorkSuggestionsIsDeveloperResource = (0, $5L7qx.resourceWithCondition2)(()=>(0, $epTsa.expVal)('jira-your-work-work-suggestions-tab-experiment', 'isEnabled', false), (0, $80Ye8.jiraHomeWorkSuggestionsIsDeveloperResource));

const $1c1cfc9939ff8808$var$LazyJiraHomePage = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("9WbN4"))), {
    moduleId: "./src/packages/spa-apps/jira-home/src/index.tsx"
});
const $1c1cfc9939ff8808$var$checkConsolidationOnRouteDependency = async (dependencies)=>{
    const data = await dependencies[0, $f8747ec2695de8a7$export$25ee35b01de9d734].promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $dI30d.checkShouldUseJSM)(data);
};
const $1c1cfc9939ff8808$var$JiraHomeComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1c1cfc9939ff8808$var$LazyJiraHomePage,
        pageId: "jira-home",
        shouldShowSpinner: false
    });
const $1c1cfc9939ff8808$export$578dcb61ac3cb57a = (0, $6xToB.createEntry)((0, $iIQmy.jiraHomeRoute), ()=>({
        group: 'home',
        ufoName: 'jira-home',
        component: $1c1cfc9939ff8808$var$JiraHomeComponent,
        skeleton: (0, $5gjY4.YourWorkSkeleton),
        layout: (0, $1RKJf.homepageLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $iDAU4.jiraHomeResourceWithCache),
            (0, $4ZkZK.jiraHomePageRightSidePanelResource),
            $1c1cfc9939ff8808$var$conditionalPostOfficeJiraYourWorkResource,
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $dwa8t.widgetResources).map((resourceCreator)=>resourceCreator($1c1cfc9939ff8808$var$checkConsolidationOnRouteDependency, [
                    (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
                ])),
            ...(0, $1kys8.widgetResources).map((resourceCreator)=>(0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('your_work_page_operation_widgets_changes'), resourceCreator($1c1cfc9939ff8808$var$checkConsolidationOnRouteDependency, [
                    (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
                ]))),
            $1c1cfc9939ff8808$var$conditionalJiraHomeWorkSuggestionsIsDeveloperResource,
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_portal_widget'), (0, $bvwBX.fetchUserTraitsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_portal_widget'), (0, $2emAF.fetchSiteTraitsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_portal_widget'), (0, $jnds2.widgetDismissedStateResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $1c1cfc9939ff8808$var$LazyJiraHomePage
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("dwa8t", function(module, exports) {

$parcel$export(module.exports, "myTeamsResource", () => $fe4e3b82d8179668$export$602f373f7fdaccc1);
$parcel$export(module.exports, "statusResource", () => $fe4e3b82d8179668$export$8f57164cc67fb360);
$parcel$export(module.exports, "userTimelineResource", () => $fe4e3b82d8179668$export$35b906dc2329cdc6);
$parcel$export(module.exports, "schedulesResource", () => $fe4e3b82d8179668$export$f9574b51fbc36dc3);
$parcel$export(module.exports, "resources", () => $fe4e3b82d8179668$export$bc99aaabaf7b70a7);
$parcel$export(module.exports, "widgetResources", () => $fe4e3b82d8179668$export$bce3244764eac6e6);
$parcel$export(module.exports, "createMyTeamsResource", () => (parcelRequire("eZYPy")).createMyTeamsResource);
$parcel$export(module.exports, "createStatusResource", () => (parcelRequire("4YvI3")).createStatusResource);
$parcel$export(module.exports, "createUserTimelineResource", () => (parcelRequire("dk0oI")).createUserTimelineResource);
$parcel$export(module.exports, "createSchedulesResource", () => (parcelRequire("4BCtJ")).createSchedulesResource);
parcelRequire("dwoHY");
var $fbCoq = parcelRequire("fbCoq");

var $eZYPy = parcelRequire("eZYPy");

var $eeMQE = parcelRequire("eeMQE");

var $4BCtJ = parcelRequire("4BCtJ");

var $4YvI3 = parcelRequire("4YvI3");

var $dk0oI = parcelRequire("dk0oI");
const $fe4e3b82d8179668$export$602f373f7fdaccc1 = (0, $eZYPy.createMyTeamsResource)();
const $fe4e3b82d8179668$export$f363fac02afee7a4 = (0, $eeMQE.createOpsTeamsResource)();
const $fe4e3b82d8179668$export$8f57164cc67fb360 = (0, $4YvI3.createStatusResource)();
const $fe4e3b82d8179668$export$35b906dc2329cdc6 = (0, $dk0oI.createUserTimelineResource)();
const $fe4e3b82d8179668$export$f9574b51fbc36dc3 = (0, $4BCtJ.createSchedulesResource)();
const $fe4e3b82d8179668$export$bc99aaabaf7b70a7 = [
    (0, $fbCoq.eocUserResource),
    (0, $eZYPy.createMyTeamsResource)(),
    (0, $4YvI3.createStatusResource)(),
    (0, $eeMQE.createOpsTeamsResource)()
];
const $fe4e3b82d8179668$export$bce3244764eac6e6 = [
    ()=>(0, $fbCoq.eocUserResource),
    (callback, depends)=>(0, $eZYPy.createMyTeamsResource)(callback, depends),
    (callback, depends)=>(0, $4YvI3.createStatusResource)(callback, depends),
    (callback, depends)=>(0, $dk0oI.createUserTimelineResource)(callback, depends),
    (callback, depends)=>(0, $4BCtJ.createSchedulesResource)(callback, depends)
];

});
parcelRegister("eZYPy", function(module, exports) {

$parcel$export(module.exports, "createMyTeamsResource", () => $f4123a7965bc460e$export$bf86fb90d0661bcb);

var $l1VxS = parcelRequire("l1VxS");

var $dHXnk = parcelRequire("dHXnk");
const $f4123a7965bc460e$export$bf86fb90d0661bcb = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'myTeamsResource',
        getKey: ()=>'myTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $dHXnk.getMyTeamsEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("dHXnk", function(module, exports) {

$parcel$export(module.exports, "getMyTeamsEndpoint", () => $82d13ebf432ef424$export$abe46da7d1f191a7);

var $br21R = parcelRequire("br21R");
const $82d13ebf432ef424$export$abe46da7d1f191a7 = ()=>{
    return (0, $br21R.eocFetch)(`/v1/alerts/responders/suggested`);
};

});


parcelRegister("eeMQE", function(module, exports) {

$parcel$export(module.exports, "createOpsTeamsResource", () => $61a58d614e5028a0$export$99505a9d792f516c);

var $l1VxS = parcelRequire("l1VxS");

var $gKzAF = parcelRequire("gKzAF");
const $61a58d614e5028a0$export$99505a9d792f516c = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'opsTeamsResource',
        getKey: ()=>'opsTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $gKzAF.getOpsTeamsEndpoint)().then((response)=>{
                return response.values;
            });
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("gKzAF", function(module, exports) {

$parcel$export(module.exports, "getOpsTeamsEndpoint", () => $9ecd19a43bcd0049$export$7498ba30158c16cd);

var $br21R = parcelRequire("br21R");

var $aTag9 = parcelRequire("aTag9");
const $9ecd19a43bcd0049$export$7498ba30158c16cd = ()=>{
    return (0, $br21R.eocFetch)((0, $aTag9.urls).teams.url());
};

});
parcelRegister("aTag9", function(module, exports) {

$parcel$export(module.exports, "urls", () => $808160d1a61df676$export$bcae9ba627f604b6);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $808160d1a61df676$export$a7c923252528b255);
$parcel$export(module.exports, "SPOTLIGHT_TOURS", () => $808160d1a61df676$export$38c46ed7a5bc80a0);
$parcel$export(module.exports, "WhoIsOnCallHandler", () => $808160d1a61df676$export$1e7191618d5d4548);
$parcel$export(module.exports, "WhoIsOnCallWidgetHandler", () => $808160d1a61df676$export$d05bbb1ada0e07c4);
const $808160d1a61df676$export$bcae9ba627f604b6 = Object.freeze({
    schedules: {
        url: ()=>`/v1/schedules`,
        user: {
            url: ()=>`${$808160d1a61df676$export$bcae9ba627f604b6.schedules.url()}/user`,
            timeline: {
                url: ()=>`${$808160d1a61df676$export$bcae9ba627f604b6.schedules.user.url()}/timeline`,
                export: {
                    url: ()=>`${$808160d1a61df676$export$bcae9ba627f604b6.schedules.user.timeline.url()}/export`
                }
            },
            userId: {
                url: ({ userId: userId } = {
                    userId: ':userId'
                })=>`${$808160d1a61df676$export$bcae9ba627f604b6.schedules.user.url()}/${userId}`
            }
        },
        onCalls: {
            url: ()=>`${$808160d1a61df676$export$bcae9ba627f604b6.schedules.url()}/on-calls`
        },
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`${$808160d1a61df676$export$bcae9ba627f604b6.schedules.url()}/${scheduleId}`,
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`${$808160d1a61df676$export$bcae9ba627f604b6.schedules.scheduleId.url({
                        scheduleId: scheduleId
                    })}/timeline`
            }
        }
    },
    wioc: {
        status: {
            url: ()=>`${$808160d1a61df676$export$bcae9ba627f604b6.schedules.url()}/user/on-calls`
        }
    },
    teams: {
        url: ()=>`/v1/teams`
    }
});
const $808160d1a61df676$export$a7c923252528b255 = {
    firstOverlappingPeriod: 'eoc-who-is-on-call_first_overlapping_period'
};
const $808160d1a61df676$export$38c46ed7a5bc80a0 = {
    overlappingPeriod: 'eoc-who-is-on-call-overlapping-period'
};
class $808160d1a61df676$export$1e7191618d5d4548 {
    handler(message, context) {
        throw new Error('Not implemented');
    }
}
class $808160d1a61df676$export$d05bbb1ada0e07c4 {
    handler(message, context) {
        throw new Error('Not implemented');
    }
}

});



parcelRegister("4BCtJ", function(module, exports) {

$parcel$export(module.exports, "createSchedulesResource", () => $cc54cc782d3b480c$export$b5e65ca3f82b01c5);

var $l1VxS = parcelRequire("l1VxS");

var $eI5y2 = parcelRequire("eI5y2");
const $cc54cc782d3b480c$export$b5e65ca3f82b01c5 = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'schedulesResource',
        getKey: ()=>'schedulesResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $eI5y2.getSchedulesEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("eI5y2", function(module, exports) {

$parcel$export(module.exports, "getSchedulesEndpoint", () => $5961fbd359f59919$export$e8e940098db1b988);

var $br21R = parcelRequire("br21R");

var $aTag9 = parcelRequire("aTag9");
const $5961fbd359f59919$export$e8e940098db1b988 = ()=>{
    return (0, $br21R.eocFetch)(`${(0, $aTag9.urls).schedules.onCalls.url()}`);
};

});


parcelRegister("4YvI3", function(module, exports) {

$parcel$export(module.exports, "createStatusResource", () => $3d9b9fbba0e83123$export$3d1c353e2693418c);

var $l1VxS = parcelRequire("l1VxS");

var $aDXZr = parcelRequire("aDXZr");

var $h7c7n = parcelRequire("h7c7n");
const $3d9b9fbba0e83123$export$3d1c353e2693418c = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'statusResource',
        getKey: ()=>'statusResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $aDXZr.getStatus)().then((0, $h7c7n.transformStatusResponse));
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("aDXZr", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $40c370bb2e12cb51$export$b70265791d2079d4);

var $br21R = parcelRequire("br21R");

var $aTag9 = parcelRequire("aTag9");
const $40c370bb2e12cb51$export$b70265791d2079d4 = ()=>{
    return (0, $br21R.eocFetch)((0, $aTag9.urls).wioc.status.url(), {
        method: 'GET'
    });
};

});

parcelRegister("h7c7n", function(module, exports) {

$parcel$export(module.exports, "transformStatusResponse", () => $6d574918fb9b89f0$export$44a749c89534e42c);
const $6d574918fb9b89f0$export$44a749c89534e42c = ({ currentTimeUtcMillis: currentTimeUtcMillis, onCallUntilUtcMillis: onCallUntilUtcMillis, onCallUntilOffsetMillis: onCallUntilOffsetMillis, isCurrentOnCall: isCurrentOnCall, isParticipantOfAnyRotation: isParticipantOfAnyRotation, nextOnCallEndUtcMillis: nextOnCallEndUtcMillis, nextOnCallEndOffsetMillis: nextOnCallEndOffsetMillis, nextOnCallStartUtcMillis: nextOnCallStartUtcMillis, nextOnCallStartOffsetMillis: nextOnCallStartOffsetMillis })=>{
    return {
        currentDate: currentTimeUtcMillis,
        currentShiftEnd: onCallUntilUtcMillis,
        currentShiftEndOffset: onCallUntilOffsetMillis,
        isOnCall: isCurrentOnCall,
        isParticipantOfAnyRotation: isParticipantOfAnyRotation,
        nextEndDate: nextOnCallEndUtcMillis,
        nextEndOffset: nextOnCallEndOffsetMillis,
        nextStartDate: nextOnCallStartUtcMillis,
        nextStartOffset: nextOnCallStartOffsetMillis
    };
};

});


parcelRegister("dk0oI", function(module, exports) {

$parcel$export(module.exports, "createUserTimelineResource", () => $120f0e326cd167e5$export$a479dcc35c33def1);

var $l1VxS = parcelRequire("l1VxS");
parcelRequire("dwoHY");
var $fbCoq = parcelRequire("fbCoq");

var $c8kNX = parcelRequire("c8kNX");
const $120f0e326cd167e5$export$a479dcc35c33def1 = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'userTimelineResource',
        getKey: ()=>'userTimelineResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await dependencies[(0, $fbCoq.eocUserResource).type]?.promise;
            // Since depends API types are not exported it's impossible to infer types,
            // thus we have to use casting
            const accountId = data?.accountId;
            const timezone = data?.timeZone;
            if (!accountId || !timezone) return null;
            return (0, $c8kNX.getWidgetTimeline)(accountId);
        },
        isBrowserOnly: true,
        depends: [
            ...depends ? depends : [],
            (0, $fbCoq.eocUserResource).type
        ]
    });

});
parcelRegister("c8kNX", function(module, exports) {

$parcel$export(module.exports, "getWidgetTimeline", () => $2bfa5d415029cadf$export$bd80cae08a85b1f0);

var $4JAGm = parcelRequire("4JAGm");

var $br21R = parcelRequire("br21R");

var $aTag9 = parcelRequire("aTag9");

var $3eJrM = parcelRequire("3eJrM");
const $2bfa5d415029cadf$export$bd80cae08a85b1f0 = (accountId)=>{
    const formattedCurrent = (0, $4JAGm.default)(new Date(), 'UTC', "yyyy-MM-dd'T'HH:mm:ss.SSSXX");
    const urlParams = new URLSearchParams({
        currentDate: formattedCurrent,
        accountId: accountId,
        mode: 'timeline',
        timelineType: '6'
    });
    return (0, $br21R.eocFetch)(`${(0, $aTag9.urls).schedules.user.timeline.url()}?${urlParams.toString()}`, {
        method: 'GET'
    }).then((0, $3eJrM.transformUserTimelineResponse));
};

});
parcelRegister("4JAGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727d1bf57947685$export$2e2bcd8739ae039);

var $7noXc = parcelRequire("7noXc");

var $48y6J = parcelRequire("48y6J");

var $lRINO = parcelRequire("lRINO");
function $3727d1bf57947685$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($7noXc)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $48y6J.default)((0, $lRINO.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("48y6J", function(module, exports) {

$parcel$export(module.exports, "default", () => $30325dcf14f98bf7$export$2e2bcd8739ae039);

var $47etr = parcelRequire("47etr");

var $lfGJJ = parcelRequire("lfGJJ");

var $8B3Ft = parcelRequire("8B3Ft");
var $30325dcf14f98bf7$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $30325dcf14f98bf7$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($30325dcf14f98bf7$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $8B3Ft.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $lfGJJ.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($47etr)))(dirtyDate, formatStr, options);
}

});
parcelRegister("lfGJJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f78c264f63c6df99$export$2e2bcd8739ae039);

var $6Rtb9 = parcelRequire("6Rtb9");

var $kjB3C = parcelRequire("kjB3C");
var $f78c264f63c6df99$var$MILLISECONDS_IN_MINUTE = 60000;
var $f78c264f63c6df99$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $f78c264f63c6df99$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $f78c264f63c6df99$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $f78c264f63c6df99$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $f78c264f63c6df99$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $f78c264f63c6df99$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $f78c264f63c6df99$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $f78c264f63c6df99$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $f78c264f63c6df99$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $f78c264f63c6df99$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $f78c264f63c6df99$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $f78c264f63c6df99$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $6Rtb9.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $6Rtb9.default)('long', date, options);
        }
    }
};
function $f78c264f63c6df99$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $kjB3C.default)(timeZone, originalDate, true) / $f78c264f63c6df99$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $f78c264f63c6df99$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $f78c264f63c6df99$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $f78c264f63c6df99$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $f78c264f63c6df99$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $f78c264f63c6df99$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $f78c264f63c6df99$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $f78c264f63c6df99$var$formatTimezone(offset, dirtyDelimeter);
}
function $f78c264f63c6df99$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $f78c264f63c6df99$var$addLeadingZeros(minutes, 2);
}
var $f78c264f63c6df99$export$2e2bcd8739ae039 = $f78c264f63c6df99$var$formatters;

});
parcelRegister("6Rtb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fee53a0ebe64d9e$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $4fee53a0ebe64d9e$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $4fee53a0ebe64d9e$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $4fee53a0ebe64d9e$var$partsTimeZone(dtf, date) : $4fee53a0ebe64d9e$var$hackyTimeZone(dtf, date);
}
function $4fee53a0ebe64d9e$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $4fee53a0ebe64d9e$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $4fee53a0ebe64d9e$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("kjB3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $eca253d6c920a971$export$2e2bcd8739ae039);

var $6dL3i = parcelRequire("6dL3i");

var $4KOZr = parcelRequire("4KOZr");
var $eca253d6c920a971$var$MILLISECONDS_IN_HOUR = 3600000;
var $eca253d6c920a971$var$MILLISECONDS_IN_MINUTE = 60000;
var $eca253d6c920a971$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $eca253d6c920a971$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $eca253d6c920a971$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $eca253d6c920a971$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$eca253d6c920a971$var$validateTimezone(hours)) return NaN;
        return -(hours * $eca253d6c920a971$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $eca253d6c920a971$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$eca253d6c920a971$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $eca253d6c920a971$var$MILLISECONDS_IN_HOUR + minutes * $eca253d6c920a971$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($eca253d6c920a971$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $eca253d6c920a971$var$toUtcDate(date);
        var offset = $eca253d6c920a971$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $eca253d6c920a971$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $eca253d6c920a971$var$toUtcDate(date) {
    return (0, $4KOZr.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $eca253d6c920a971$var$calcOffset(date, timezoneString) {
    var tokens = (0, $6dL3i.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $4KOZr.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $eca253d6c920a971$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $eca253d6c920a971$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $eca253d6c920a971$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $eca253d6c920a971$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $eca253d6c920a971$var$validIANATimezoneCache = {};
function $eca253d6c920a971$var$isValidTimezoneIANAString(timeZoneString) {
    if ($eca253d6c920a971$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $eca253d6c920a971$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("6dL3i", function(module, exports) {

$parcel$export(module.exports, "default", () => $4878748d43bc58b6$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $4878748d43bc58b6$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $4878748d43bc58b6$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $4878748d43bc58b6$var$partsOffset(dtf, date) : $4878748d43bc58b6$var$hackyOffset(dtf, date);
}
var $4878748d43bc58b6$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $4878748d43bc58b6$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $4878748d43bc58b6$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $4878748d43bc58b6$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $4878748d43bc58b6$var$dtfCache = {};
function $4878748d43bc58b6$var$getDateTimeFormat(timeZone) {
    if (!$4878748d43bc58b6$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $4878748d43bc58b6$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $4878748d43bc58b6$var$dtfCache[timeZone];
}

});

parcelRegister("4KOZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $376302d8ec2bc99e$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $376302d8ec2bc99e$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("8B3Ft", function(module, exports) {

$parcel$export(module.exports, "default", () => $64249fcb742377fa$export$2e2bcd8739ae039);

var $a04h3 = parcelRequire("a04h3");

var $ejJXr = parcelRequire("ejJXr");

var $kjB3C = parcelRequire("kjB3C");

var $dNCVi = parcelRequire("dNCVi");
var $64249fcb742377fa$var$MILLISECONDS_IN_HOUR = 3600000;
var $64249fcb742377fa$var$MILLISECONDS_IN_MINUTE = 60000;
var $64249fcb742377fa$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $64249fcb742377fa$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $dNCVi.default)
};
function $64249fcb742377fa$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $64249fcb742377fa$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($a04h3)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $64249fcb742377fa$var$splitDateString(argument);
    var parseYearResult = $64249fcb742377fa$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $64249fcb742377fa$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $64249fcb742377fa$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $kjB3C.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $64249fcb742377fa$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $64249fcb742377fa$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $64249fcb742377fa$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $64249fcb742377fa$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $64249fcb742377fa$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $64249fcb742377fa$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $64249fcb742377fa$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $64249fcb742377fa$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $64249fcb742377fa$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $64249fcb742377fa$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $64249fcb742377fa$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$64249fcb742377fa$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $64249fcb742377fa$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$64249fcb742377fa$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $64249fcb742377fa$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$64249fcb742377fa$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $64249fcb742377fa$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$64249fcb742377fa$var$validateWeekDate(year, week)) return new Date(NaN);
        return $64249fcb742377fa$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $64249fcb742377fa$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$64249fcb742377fa$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $64249fcb742377fa$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $64249fcb742377fa$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $64249fcb742377fa$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$64249fcb742377fa$var$validateTime(hours)) return NaN;
        return hours % 24 * $64249fcb742377fa$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $64249fcb742377fa$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$64249fcb742377fa$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $64249fcb742377fa$var$MILLISECONDS_IN_HOUR + minutes * $64249fcb742377fa$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $64249fcb742377fa$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$64249fcb742377fa$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $64249fcb742377fa$var$MILLISECONDS_IN_HOUR + minutes * $64249fcb742377fa$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $64249fcb742377fa$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $64249fcb742377fa$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $64249fcb742377fa$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $64249fcb742377fa$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $64249fcb742377fa$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $64249fcb742377fa$var$isLeapYearIndex(year);
        if (isLeapYear && date > $64249fcb742377fa$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $64249fcb742377fa$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $64249fcb742377fa$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $64249fcb742377fa$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $64249fcb742377fa$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $64249fcb742377fa$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("dNCVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0be0b505de9d117$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $a0be0b505de9d117$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $a0be0b505de9d117$export$2e2bcd8739ae039 = $a0be0b505de9d117$var$tzPattern;

});



parcelRegister("lRINO", function(module, exports) {

$parcel$export(module.exports, "default", () => $feb14d0c35fb9c57$export$2e2bcd8739ae039);

var $kjB3C = parcelRequire("kjB3C");

var $8B3Ft = parcelRequire("8B3Ft");
function $feb14d0c35fb9c57$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $8B3Ft.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $kjB3C.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("3eJrM", function(module, exports) {

$parcel$export(module.exports, "transformUserTimelineResponse", () => $dc4cdc2f9f1aeccb$export$78049913b79774a2);

var $aQ0k3 = parcelRequire("aQ0k3");
const $dc4cdc2f9f1aeccb$export$78049913b79774a2 = ({ startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, startOffsetMillis: startOffsetMillis, endOffsetMillis: endOffsetMillis, utcTimeOffsetMillis: utcTimeOffsetMillis, currentTime: currentTime, periods: periods, ...data })=>{
    return {
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        nowEpoch: currentTime,
        startOffset: startOffsetMillis,
        endOffset: endOffsetMillis,
        nowOffset: utcTimeOffsetMillis,
        data: {
            ...data,
            periods: periods.map((0, $aQ0k3.fromMergedPeriodResponseToClusterPeriod))
        }
    };
};

});
parcelRegister("aQ0k3", function(module, exports) {

$parcel$export(module.exports, "fromMergedPeriodResponseToClusterPeriod", () => $5086fc51119cc638$export$9b0bac75f135bd57);
const $5086fc51119cc638$export$9b0bac75f135bd57 = (mergedPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingPeriods: overlappingPeriods } = mergedPeriodResponse;
    const clusterPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingPeriods.map($5086fc51119cc638$var$fromOverlappingPeriodResponseToOverlappingPeriod)
    };
    return clusterPeriod;
};
const $5086fc51119cc638$var$fromOverlappingPeriodResponseToOverlappingPeriod = (overlappingPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingRotations: overlappingRotations, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime } = overlappingPeriodResponse;
    const overlappingPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingRotations,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime
    };
    return overlappingPeriod;
};

});





parcelRegister("1kys8", function(module, exports) {

$parcel$export(module.exports, "openAlertsResource", () => $fb5a11990deed33f$export$fb6d91a24bfaa074);
$parcel$export(module.exports, "ackedAlertsResource", () => $fb5a11990deed33f$export$3917a9639b1be557);
$parcel$export(module.exports, "snoozedAlertsResource", () => $fb5a11990deed33f$export$f62d237df457042d);
$parcel$export(module.exports, "widgetResources", () => $fb5a11990deed33f$export$bce3244764eac6e6);

var $l1VxS = parcelRequire("l1VxS");

var $9FAlv = parcelRequire("9FAlv");

var $fxAON = parcelRequire("fxAON");
const $fb5a11990deed33f$export$e5eb8aade1d4272a = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'openAlertsResource',
        getKey: ()=>'openAlertsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $fxAON.fetchAlerts)({
                searchParams: {
                    query: (0, $9FAlv.PredefinedQueries).MY_OPEN_ALERTS,
                    limit: 3
                }
            });
        },
        isBrowserOnly: true,
        depends: depends
    });
const $fb5a11990deed33f$export$66760ff81022525f = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'ackedAlertsResource',
        getKey: ()=>'ackedAlertsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $fxAON.fetchAlerts)({
                searchParams: {
                    query: (0, $9FAlv.PredefinedQueries).MY_ACKED_ALERTS,
                    limit: 3
                }
            });
        },
        isBrowserOnly: true,
        depends: depends
    });
const $fb5a11990deed33f$export$73c7fe1d8124595f = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'snoozedAlertsResource',
        getKey: ()=>'snoozedAlertsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $fxAON.fetchAlerts)({
                searchParams: {
                    query: (0, $9FAlv.PredefinedQueries).MY_SNOOZED_ALERTS,
                    limit: 3
                }
            });
        },
        isBrowserOnly: true,
        depends: depends
    });
const $fb5a11990deed33f$export$fb6d91a24bfaa074 = $fb5a11990deed33f$export$e5eb8aade1d4272a();
const $fb5a11990deed33f$export$3917a9639b1be557 = $fb5a11990deed33f$export$66760ff81022525f();
const $fb5a11990deed33f$export$f62d237df457042d = $fb5a11990deed33f$export$73c7fe1d8124595f();
const $fb5a11990deed33f$export$bce3244764eac6e6 = [
    (callback, depends)=>$fb5a11990deed33f$export$e5eb8aade1d4272a(callback, depends),
    (callback, depends)=>$fb5a11990deed33f$export$66760ff81022525f(callback, depends),
    (callback, depends)=>$fb5a11990deed33f$export$73c7fe1d8124595f(callback, depends)
];

});
parcelRegister("9FAlv", function(module, exports) {

$parcel$export(module.exports, "ALERTS_STORE_NAME", () => $011562fa95eb9932$export$6793992c0b67d9c9);
$parcel$export(module.exports, "PredefinedQueries", () => $011562fa95eb9932$export$ed6721f2880ce367);
$parcel$export(module.exports, "initialState", () => $011562fa95eb9932$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "baseState", () => $011562fa95eb9932$export$a2290b0841306a43);
$parcel$export(module.exports, "GLOBAL_ALERTS_ROUTE_NAME", () => $011562fa95eb9932$export$ba93b3de87c980dc);
$parcel$export(module.exports, "GLOBAL_ALERT_DETAIL_ROUTE_NAME", () => $011562fa95eb9932$export$1881423041ad1b5c);
const $011562fa95eb9932$export$6793992c0b67d9c9 = 'navigation-alerts-store';
const $011562fa95eb9932$var$ONLY_MY_SELECTOR_QUERY = '(acknowledgedBy: me OR owner: me OR responders: me)';
const $011562fa95eb9932$export$ed6721f2880ce367 = {
    MY_OPEN_ALERTS: `status: open AND acknowledged: false AND snoozed: false AND ${$011562fa95eb9932$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_ACKED_ALERTS: `status: open AND acknowledged: true AND ${$011562fa95eb9932$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_SNOOZED_ALERTS: `status: open AND acknowledged: false AND snoozed: true AND ${$011562fa95eb9932$var$ONLY_MY_SELECTOR_QUERY}`
};
const $011562fa95eb9932$export$d4c72bab9d6cc13a = {};
const $011562fa95eb9932$export$a2290b0841306a43 = {
    items: null,
    isFetching: false,
    fetchError: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false,
    totalCount: 0
};
const $011562fa95eb9932$export$ba93b3de87c980dc = 'eoc-global-alerts';
const $011562fa95eb9932$export$1881423041ad1b5c = 'eoc-global-alert-detail';

});

parcelRegister("fxAON", function(module, exports) {

$parcel$export(module.exports, "fetchAlerts", () => $05e70f5c470e26f0$export$f7b1e2075b3da718);

var $br21R = parcelRequire("br21R");
const $05e70f5c470e26f0$export$f7b1e2075b3da718 = async ({ searchParams: searchParams })=>{
    const params = new URLSearchParams(searchParams ?? {});
    return (0, $br21R.eocFetch)(`/v1/alerts/?${params.toString()}`);
};

});


parcelRegister("4ZkZK", function(module, exports) {

$parcel$export(module.exports, "jiraHomePageRightSidePanelResource", () => $30acd9ad5acbc104$export$9cba342d9ec5384d);

var $9FYIg = parcelRequire("9FYIg");

var $gpj3Y = parcelRequire("gpj3Y");

var $48BUe = parcelRequire("48BUe");
const $30acd9ad5acbc104$var$isBroadcastWidgetEnabled = ()=>false;
const $30acd9ad5acbc104$export$9cba342d9ec5384d = (0, $9FYIg.createRelayResource)({
    type: (0, $48BUe.JIRA_HOME_PAGE_RIGHT_SIDE_PANEL),
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $gpj3Y.default),
            variables: {
                cloudId: tenantContext.cloudId,
                broadcastWidgetEnabled: $30acd9ad5acbc104$var$isBroadcastWidgetEnabled()
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("gpj3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $f731a952a6e56719$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d73a7099a9295c02951eb57579b7d93>>
 * @relayHash a7e48eaea1f1087c0622f1648327271d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1
const $f731a952a6e56719$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "broadcastWidgetEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_rightSidePanel_RootQuery",
            "selections": [
                {
                    "condition": "broadcastWidgetEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "main_homeBroadcastWidget_Widget"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_rightSidePanel_RootQuery",
            "selections": [
                {
                    "condition": "broadcastWidgetEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "JiraUserBroadcastMessageConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraUserBroadcastMessages",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraUserBroadcastMessageEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraUserBroadcastMessage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "shouldDisplay"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1",
            "metadata": {},
            "name": "main_rightSidePanel_RootQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f731a952a6e56719$var$node.hash = "174d1e9e3edb60b5684e0806b3d7342e";
var $f731a952a6e56719$export$2e2bcd8739ae039 = $f731a952a6e56719$var$node;

});

parcelRegister("48BUe", function(module, exports) {

$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $fc975c81b3f341b9$export$750459958906793);
$parcel$export(module.exports, "RIGHT_SIDE_PANEL_EXPERIENCE", () => $fc975c81b3f341b9$export$2eb41e47cfa429b7);
$parcel$export(module.exports, "JIRA_HOME_PAGE_RIGHT_SIDE_PANEL", () => $fc975c81b3f341b9$export$6c783d91630ece21);

var $dPMMf = parcelRequire("dPMMf");
const $fc975c81b3f341b9$export$750459958906793 = (0, $dPMMf.gridSize) * 49;
const $fc975c81b3f341b9$export$2eb41e47cfa429b7 = {
    experience: 'jiraHomeRightSidePanel',
    experienceId: undefined,
    analyticsSource: 'jira-home'
};
const $fc975c81b3f341b9$export$6c783d91630ece21 = 'JIRA_HOME_PAGE_RIGHT_SIDE_PANEL';

});


parcelRegister("iDAU4", function(module, exports) {

$parcel$export(module.exports, "jiraHomeResourceWithCache", () => $4e5b6a1d41336340$export$1da15dc2d924240c);

var $l1VxS = parcelRequire("l1VxS");


const $4e5b6a1d41336340$export$1da15dc2d924240c = (0, $l1VxS.createResource)({
    type: (0, $ee6e0cf9d15433cc$export$e79da7e0d9d1c1f2),
    getKey: ()=>'jira-home',
    getDataLoader: ()=>(parcelRequire("jxgBH")),
    maxAge: Infinity
});

});
const $ee6e0cf9d15433cc$export$e79da7e0d9d1c1f2 = 'JIRA_HOME';

parcelRegister("jxgBH", function(module, exports) {

let $e38dfb30b94fe4a0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e38dfb30b94fe4a0$var$load("4LLed").then(()=>parcelRequire('gu7eh'));

});


parcelRegister("80Ye8", function(module, exports) {

$parcel$export(module.exports, "jiraHomeWorkSuggestionsIsDeveloperResource", () => $8684b2f33815fbda$export$420b5969a526b86f);

var $9FYIg = parcelRequire("9FYIg");

var $clsnW = parcelRequire("clsnW");

var $hmtVp = parcelRequire("hmtVp");

var $aYncF = parcelRequire("aYncF");
const $8684b2f33815fbda$export$420b5969a526b86f = (0, $9FYIg.createRelayResource)({
    type: 'JIRA_HOME_WORK_SUGGESTIONS_IS_DEVELOPER',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $clsnW.default),
            variables: {
                cloudId: tenantContext.cloudId,
                isSoftwareLicensed: tenantContext.licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).JIRA_SOFTWARE] && tenantContext.licenseStates?.software === (0, $hmtVp.LICENSE_STATE_ACTIVE)
            }
        })
});

});
parcelRegister("clsnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $24b25cf36aed9e27$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9af3482c29caafe3c266b9a94e6bf614>>
 * @relayHash 33a398085fffc1c8c240023b01b17ecb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6531092ed29d33046fe36572f33533c333d5d1c7642ce67bd8f17687b4e69ba1
const $24b25cf36aed9e27$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSoftwareLicensed"
        }
    ], v1 = [
        {
            "condition": "isSoftwareLicensed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "WorkSuggestions",
                    "kind": "LinkedField",
                    "name": "workSuggestions",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "WorkSuggestionsUserProfile",
                            "kind": "LinkedField",
                            "name": "userProfileByCloudId",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "persona"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "JiraHomeWithWorkSuggestionsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "JiraHomeWithWorkSuggestionsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "6531092ed29d33046fe36572f33533c333d5d1c7642ce67bd8f17687b4e69ba1",
            "metadata": {},
            "name": "JiraHomeWithWorkSuggestionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$24b25cf36aed9e27$var$node.hash = "2ffc84c440c4cba253c916b64a96af89";
var $24b25cf36aed9e27$export$2e2bcd8739ae039 = $24b25cf36aed9e27$var$node;

});


parcelRegister("5gjY4", function(module, exports) {

$parcel$export(module.exports, "YourWorkSkeleton", () => $61046b34651c6bad$export$62cf62fa23284b71);
$parcel$export(module.exports, "YourWorkItemListSkeleton", () => $61046b34651c6bad$export$31cebe1052db844);

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $1uyFW = parcelRequire("1uyFW");

var $iLaLl = parcelRequire("iLaLl");
const $61046b34651c6bad$export$62cf62fa23284b71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1uyFW)))
    });
const $61046b34651c6bad$export$31cebe1052db844 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iLaLl))),
        containerStyles: {
            maxHeight: '30em'
        }
    });

});
parcelRegister("1uyFW", function(module, exports) {
module.exports = new URL("your-work-app-skeleton.tpl.14d150b5.svg", import.meta.url).toString();

});

parcelRegister("iLaLl", function(module, exports) {
module.exports = new URL("your-work-itemlist-skeleton.tpl.e9027f83.svg", import.meta.url).toString();

});


parcelRegister("jnds2", function(module, exports) {

$parcel$export(module.exports, "widgetDismissedStateResource", () => $57ae939029132df2$export$451c4a4a781aa514);
$parcel$export(module.exports, "useServiceDeskPortalWidgetResource", () => $57ae939029132df2$export$d3aa387095a4c8ad);

var $eJOHy = parcelRequire("eJOHy");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $gYnSx = parcelRequire("gYnSx");

var $FppkK = parcelRequire("FppkK");


const $57ae939029132df2$var$getDataLoader = ()=>(parcelRequire("ko6Hl"));
const $57ae939029132df2$export$451c4a4a781aa514 = (0, $l1VxS.createResource)({
    type: (0, $3f53320209c907af$export$5a807784695ecdeb),
    getKey: ()=>(0, $3f53320209c907af$export$5a807784695ecdeb),
    getDataLoader: $57ae939029132df2$var$getDataLoader,
    maxAge: Infinity
});
const $57ae939029132df2$export$d3aa387095a4c8ad = (accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, $eJrcF.useResource)($57ae939029132df2$export$451c4a4a781aa514);
    const loadingRef = (0, $eJOHy.useRef)(false);
    const errorRef = (0, $eJOHy.useRef)();
    const [userPropertiesError, setUserPropertiesError] = (0, $eJOHy.useState)();
    errorRef.current = userPropertiesError || error;
    const dismissAnnouncement = (0, $eJOHy.useCallback)(()=>{
        update(()=>({
                widgetIsDismissed: true
            }));
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $gYnSx.default)({
                    meta: {
                        id: 'useServiceDeskPortalWidgetResource',
                        packageName: 'jiraRouterResourcesServicedeskPortalWidgetResources',
                        teamName: 'Seqouia'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $FppkK.setUserProperties)(accountId, (0, $3f53320209c907af$export$f9c8733e3a81c54c), 'true').catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                (0, $gYnSx.default)({
                    meta: {
                        id: 'useServiceDeskPortalWidgetResource',
                        packageName: 'jiraRouterResourcesServicedeskPortalWidgetResources',
                        teamName: 'Sequoia'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                loadingRef.current = false;
            });
        }
    }, [
        update,
        accountId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (errorRef.current || loading || !data || !accountId) return {
            loading: loading,
            widgetIsDismissed: true,
            dismissAnnouncement: dismissAnnouncement
        };
        return {
            widgetIsDismissed: data.widgetIsDismissed,
            loading: loading,
            dismissAnnouncement: dismissAnnouncement
        };
    }, [
        loading,
        data,
        accountId,
        dismissAnnouncement
    ]);
};

});
const $3f53320209c907af$export$5a807784695ecdeb = 'SERVICEDESK_PORTAL_WIDGET_DISMISSED';
const $3f53320209c907af$export$f9c8733e3a81c54c = 'eoc-jsm-servicedesk-portal-widget';

parcelRegister("ko6Hl", function(module, exports) {

let $ed7b3ea31ccd1411$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ed7b3ea31ccd1411$var$load("84AXK").then(()=>parcelRequire('4CdMl'));

});


parcelRegister("9WbN4", function(module, exports) {

let $73c2ad2b67176225$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $73c2ad2b67176225$var$load("1VRB2"),
    $73c2ad2b67176225$var$load("bABhq"),
    $73c2ad2b67176225$var$load("3IbAg")
]).then(()=>parcelRequire('4Ov3V'));

});


parcelRegister("7lsw4", function(module, exports) {

$parcel$export(module.exports, "jiraSearchRouteEntry", () => $5bebce03f6f0e3a4$export$76b74d5744e69817);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $gpMOv = parcelRequire("gpMOv");

var $8VHZr = parcelRequire("8VHZr");

var $4c8NG = parcelRequire("4c8NG");
const $5bebce03f6f0e3a4$export$76b74d5744e69817 = (0, $6xToB.createEntry)((0, $gpMOv.jiraSearchRoute), ()=>({
        group: 'redirects',
        component: (0, $8VHZr.JiraSearchRedirect),
        isRedirect: true,
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4c8NG.jiraSearchResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("gpMOv", function(module, exports) {

$parcel$export(module.exports, "jiraSearchRoute", () => $6d1ee70e507e9079$export$a3a93dcf611b611a);
const $6d1ee70e507e9079$export$a3a93dcf611b611a = {
    name: 'jira-search',
    path: '/jira/search',
    exact: true
};

});

parcelRegister("8VHZr", function(module, exports) {

$parcel$export(module.exports, "JiraSearchRedirect", () => $1bb7117a1a55913a$export$ee180957879b33ac);

var $eJOHy = parcelRequire("eJOHy");

var $4FfIq = parcelRequire("4FfIq");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");

var $gjgo6 = parcelRequire("gjgo6");

var $4c8NG = parcelRequire("4c8NG");
const $1bb7117a1a55913a$export$ee180957879b33ac = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)((0, $4c8NG.jiraSearchResource));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4FfIq.IssueViewSkeleton), null);
    if (error || !data?.url) // handle api error state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gjgo6.QuickSearchToGlobalIssueNavigatorRedirect), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: data.url,
        push: false
    });
};

});
parcelRegister("gjgo6", function(module, exports) {

$parcel$export(module.exports, "QuickSearchToGlobalIssueNavigatorRedirect", () => $6420f1489837c0e8$export$968c2900ae111000);

var $eJOHy = parcelRequire("eJOHy");

var $hih5V = parcelRequire("hih5V");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $dSkEC = parcelRequire("dSkEC");

var $2mHfh = parcelRequire("2mHfh");
var $95O7y = parcelRequire("95O7y");
var $eJrcF = parcelRequire("eJrcF");
const $6420f1489837c0e8$export$968c2900ae111000 = ({ Redirect: Redirect = (0, $2mHfh.Redirect), fireScreenAnalytics: fireScreenAnalytics = (0, $gCeeo.fireScreenAnalytics), useAnalyticsEvents: // eslint-disable-next-line react-hooks/react-compiler
useAnalyticsEvents = (0, $f1Zdy.useAnalyticsEvents), useCurrentRoute: // eslint-disable-next-line react-hooks/react-compiler
useCurrentRoute = (0, $hih5V.useCurrentRoute), useQueryParam: // eslint-disable-next-line react-hooks/react-compiler
useQueryParam = (0, $95O7y.useQueryParam) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const route = useCurrentRoute();
    // eslint-disable-next-line react-hooks/react-compiler
    const [searchString] = useQueryParam('searchString');
    // eslint-disable-next-line react-hooks/react-compiler
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const { data: isNinEnabled } = (0, $eJrcF.useResource)((0, $dSkEC.isNinGlobalScopeEnrolmentEnabledResource));
    (0, $eJOHy.useEffect)(()=>{
        if (!route) return;
        const screenEvent = createAnalyticsEvent({
            screenName: 'quickSearchRedirect',
            attributes: {
                type: route.name
            }
        });
        fireScreenAnalytics(screenEvent);
    }, [
        createAnalyticsEvent,
        fireScreenAnalytics,
        route
    ]);
    let jql;
    if (isNinEnabled) jql = searchString != null ? `textfields ~ "${searchString}"` : 'ORDER BY created DESC';
    else jql = searchString != null ? `text ~ "${searchString}"` : 'order by created DESC';
    const redirectUrl = `/issues/?jql=${encodeURIComponent(jql)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Redirect, {
        to: redirectUrl
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6420f1489837c0e8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6420f1489837c0e8$export$968c2900ae111000, null);

});

parcelRegister("4c8NG", function(module, exports) {

$parcel$export(module.exports, "jiraSearchResource", () => $959381ff378a0f18$export$d23832be0ebf8a93);

var $b5RwB = parcelRequire("b5RwB");

var $1Ozm9 = parcelRequire("1Ozm9");

var $l1VxS = parcelRequire("l1VxS");
const $959381ff378a0f18$export$486bd66a4d919be7 = 'RESOURCE_TYPE_JIRA_SEARCH';
const $959381ff378a0f18$export$d23832be0ebf8a93 = (0, $l1VxS.createResource)({
    type: $959381ff378a0f18$export$486bd66a4d919be7,
    getKey: ()=>'search',
    getData: ({ query: query }, { tenantContext: tenantContext })=>{
        const { atlassianAccountId: atlassianAccountId } = tenantContext;
        if (!atlassianAccountId || !query?.searchString) return null;
        const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
            searchString: query.searchString
        });
        return (0, $1Ozm9.default)(`/rest/navigation/4/quicksearch?${queryStr}`);
    },
    isBrowserOnly: true
});

});



parcelRegister("bMj4d", function(module, exports) {

$parcel$export(module.exports, "jsmBoardRouteEntry", () => $c964b22851bcfd9e$export$44cb11fe4ca053f8);

var $kHlOR = parcelRequire("kHlOR");

var $iWUAX = parcelRequire("iWUAX");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $alzbz = parcelRequire("alzbz");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $eWDmv = parcelRequire("eWDmv");

var $aQoXd = parcelRequire("aQoXd");

var $zNGiI = parcelRequire("zNGiI");

var $27Owl = parcelRequire("27Owl");

var $fbgOh = parcelRequire("fbgOh");

var $cTGji = parcelRequire("cTGji");
const $c964b22851bcfd9e$export$44cb11fe4ca053f8 = (0, $6xToB.createEntry)((0, $eWDmv.jsmBoardRoute), ()=>({
        group: 'servicedesk',
        component: (0, $cTGji.ServicedeskBoard),
        layout: (0, $aQoXd.serviceProjectLayout),
        skeleton: (0, $zNGiI.ClassicBoardSkeleton),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cTGji.LazyServicedeskBoard),
            (0, $cTGji.LazyBoardSettings)
        ],
        perfMetricKey: 'servicedesk-boards-load',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $iWUAX.AsyncViewsNav)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!false, (0, $c0h8V.uifBoardResource)),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)(),
            (0, $dZRaT.projectContextResource)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("iWUAX", function(module, exports) {

$parcel$export(module.exports, "AsyncViewsNav", () => $4f80d54e53f9117f$export$b43adc74b6a33bde);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $4f80d54e53f9117f$var$LazyViewsNav = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("04Ncj")).then(({ ViewsBaseNav: ViewsBaseNav })=>ViewsBaseNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/views/src/ui/index.tsx"
});
const $4f80d54e53f9117f$export$b43adc74b6a33bde = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "horizontal-jsm-views-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4f80d54e53f9117f$var$LazyViewsNav, null));

});
parcelRegister("04Ncj", function(module, exports) {

let $00e6897843e6f289$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $00e6897843e6f289$var$load("1VRB2"),
    $00e6897843e6f289$var$load("bABhq"),
    $00e6897843e6f289$var$load("d12Ah")
]).then(()=>parcelRequire('3mJDw'));

});


parcelRegister("eWDmv", function(module, exports) {

$parcel$export(module.exports, "jsmBoardRoute", () => $ef24c8f577828357$export$a192088aab559fa1);
const $ef24c8f577828357$export$a192088aab559fa1 = {
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
    name: 'servicedesk-boards',
    exact: true
};

});

parcelRegister("cTGji", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskBoard", () => $76da0f6e46c42f64$export$bb5ed4e7838cf30c);
$parcel$export(module.exports, "LazyBoardSettings", () => $76da0f6e46c42f64$export$45bb2963a11a5163);
$parcel$export(module.exports, "ServicedeskBoard", () => $76da0f6e46c42f64$export$f058c0d1561d67f3);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $76da0f6e46c42f64$export$bb5ed4e7838cf30c = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("f4P7j"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/board/src/index.tsx"
});

const $76da0f6e46c42f64$export$45bb2963a11a5163 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("24HAQ")).then((module)=>module.ServicedeskBoardSettingsAppLayout)), {
    moduleId: "./src/packages/spa-apps/servicedesk/board-settings/src/ui/index.tsx"
});
const $76da0f6e46c42f64$export$f058c0d1561d67f3 = (props)=>{
    const { route: route, query: query } = props;
    if (route.name !== 'servicedesk-boards') return null;
    return query.config ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $76da0f6e46c42f64$export$45bb2963a11a5163,
        pageId: "spa-apps/servicedesk/boards/board-settings",
        shouldShowSpinner: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $76da0f6e46c42f64$export$bb5ed4e7838cf30c,
        pageId: "spa-apps/servicedesk/boards/board",
        shouldShowSpinner: true
    });
};

});
parcelRegister("24HAQ", function(module, exports) {

let $182dc52eea8dd799$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $182dc52eea8dd799$var$load("1VRB2"),
    $182dc52eea8dd799$var$load("bABhq"),
    $182dc52eea8dd799$var$load("jMA0O")
]).then(()=>parcelRequire('hm3w3'));

});



parcelRegister("6XPJ5", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubAllArticlesRouteEntry", () => $3c9d062c74dc59e1$export$5b55251966102ec);

var $kHlOR = parcelRequire("kHlOR");

var $5qNZF = parcelRequire("5qNZF");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $05dAZ = parcelRequire("05dAZ");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $37mqV = parcelRequire("37mqV");

var $bUl48 = parcelRequire("bUl48");
const $3c9d062c74dc59e1$export$5b55251966102ec = (0, $6xToB.createEntry)((0, $05dAZ.knowledgeHubAllArticlesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $bUl48.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $5qNZF.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bUl48.LazyServicedeskKnowledgeHubBrowseAllArticles)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("5qNZF", function(module, exports) {

$parcel$export(module.exports, "AsyncKbNav", () => $0f2e13b1c45ccae3$export$223f755b7799fe02);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $h47gY = parcelRequire("h47gY");

var $gzcjr = parcelRequire("gzcjr");

const $0f2e13b1c45ccae3$var$LazyKbNav = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("b0XyD")).then(({ KnowledgeBaseNav: KnowledgeBaseNav })=>KnowledgeBaseNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/knowledge-base/src/ui/index.tsx"
});
const $0f2e13b1c45ccae3$export$223f755b7799fe02 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "horizontal-jsm-kb-nav",
        packageName: "jira-horizontal-nav-jsm-knowledge-base"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderUFOMigration), {
        name: "horizontal-jsm-kb-nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0f2e13b1c45ccae3$var$LazyKbNav, null)));
};

});
parcelRegister("b0XyD", function(module, exports) {

let $804de4b8851c19db$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $804de4b8851c19db$var$load("7ZmJO").then(()=>parcelRequire('194dz'));

});


parcelRegister("05dAZ", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubAllArticlesRoute", () => $408453b4b18d1ed3$export$20e57a83f181da7b);
const $408453b4b18d1ed3$export$20e57a83f181da7b = {
    name: 'knowledge-hub-all-articles',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/browse/page/:pageId'
};

});

parcelRegister("37mqV", function(module, exports) {

$parcel$export(module.exports, "getKnowledgeHubResources", () => $b3d665e906aaec17$export$5421e48e728c449f);

var $85Ze9 = parcelRequire("85Ze9");

var $1PvPk = parcelRequire("1PvPk");
const $b3d665e906aaec17$export$5421e48e728c449f = ()=>[
        ...(0, $1PvPk.getServicedeskPageContextResources)(),
        (0, $85Ze9.kbConfluenceContextResource)
    ];

});

parcelRegister("bUl48", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubBrowseAllArticles", () => $96082a4fa3505fd8$export$c73ba7e80a805fb2);
$parcel$export(module.exports, "default", () => $96082a4fa3505fd8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $96082a4fa3505fd8$export$c73ba7e80a805fb2 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("8TR9J"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-articles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$96082a4fa3505fd8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $96082a4fa3505fd8$export$c73ba7e80a805fb2,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-articles",
        shouldShowSpinner: true
    });

});
parcelRegister("8TR9J", function(module, exports) {

let $67acb170bf7eaef5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $67acb170bf7eaef5$var$load("eDzss"),
    $67acb170bf7eaef5$var$load("l44D6")
]).then(()=>parcelRequire('1Tm7l'));

});



parcelRegister("1fi5O", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRouteEntry", () => $2fa427d97734a071$export$513e093ef937dc06);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $4SJN8 = parcelRequire("4SJN8");

var $aQoXd = parcelRequire("aQoXd");

var $37mqV = parcelRequire("37mqV");

var $4LjGe = parcelRequire("4LjGe");
const $2fa427d97734a071$export$513e093ef937dc06 = (0, $6xToB.createEntry)((0, $4SJN8.knowledgeHubArticleEmbedEditorRoute), ()=>({
        group: 'servicedesk',
        component: (0, $4LjGe.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4LjGe.LazyServiceDeskKnowledgeArticleEmbedEditor)
        ],
        perfMetricKey: 'service-management.knowledge.ep-editor'
    }));

});
parcelRegister("4SJN8", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRoute", () => $638ec66a6480ede7$export$bd512c426b095693);
const $638ec66a6480ede7$export$bd512c426b095693 = {
    name: 'kb-article-embed-editor',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/space/:spaceKey/articles/:articleId/edit',
    query: [
        'draftShareId?',
        'topicId?'
    ]
};

});

parcelRegister("4LjGe", function(module, exports) {

$parcel$export(module.exports, "LazyServiceDeskKnowledgeArticleEmbedEditor", () => $f8957981e861612d$export$35c6d2a033ef4c42);
$parcel$export(module.exports, "default", () => $f8957981e861612d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $f8957981e861612d$export$35c6d2a033ef4c42 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fak9F"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-article-embed-editor/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f8957981e861612d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f8957981e861612d$export$35c6d2a033ef4c42,
        pageId: "knowledge-article-embed-editor",
        shouldShowSpinner: true
    });

});
parcelRegister("fak9F", function(module, exports) {

let $b0a76c8cd1e99991$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b0a76c8cd1e99991$var$load("cqIsW").then(()=>parcelRequire('fbaeV'));

});



parcelRegister("3DoQq", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleInCategoryRouteEntry", () => $d986e9ce17378918$export$a67199ebb12b0f7f);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $cR5N0 = parcelRequire("cR5N0");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $37mqV = parcelRequire("37mqV");

var $1m9Vx = parcelRequire("1m9Vx");
const $d986e9ce17378918$export$a67199ebb12b0f7f = (0, $6xToB.createEntry)((0, $cR5N0.knowledgeHubArticleInCategoryRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.knowledge.article',
        component: (0, $1m9Vx.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1m9Vx.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("cR5N0", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleInCategoryRoute", () => $415cc4cad3a2ca3c$export$3afe8482ce820835);
const $415cc4cad3a2ca3c$export$3afe8482ce820835 = {
    name: 'knowledge-hub-article-in-category',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/articles/:articleId'
};

});

parcelRegister("1m9Vx", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubViewArticle", () => $18518def2687a56c$export$efd0ec49853aa81);
$parcel$export(module.exports, "default", () => $18518def2687a56c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $18518def2687a56c$export$efd0ec49853aa81 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("hmbMj"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-view-article/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$18518def2687a56c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $18518def2687a56c$export$efd0ec49853aa81,
        pageId: "spa-apps/servicedesk/knowledge-hub/view-article",
        shouldShowSpinner: true
    });

});
parcelRegister("hmbMj", function(module, exports) {

let $ca2da0a17b98c166$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ca2da0a17b98c166$var$load("crLMo").then(()=>parcelRequire('i2c2s'));

});



parcelRegister("dpAnL", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRouteEntry", () => $3af272ff53192dcc$export$de40c949b963d9e);

var $kHlOR = parcelRequire("kHlOR");

var $5qNZF = parcelRequire("5qNZF");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $bxbQK = parcelRequire("bxbQK");

var $5L7qx = parcelRequire("5L7qx");

var $2Y5nj = parcelRequire("2Y5nj");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $igNUx = parcelRequire("igNUx");

var $37mqV = parcelRequire("37mqV");

var $bUl48 = parcelRequire("bUl48");
const $3af272ff53192dcc$export$de40c949b963d9e = (0, $6xToB.createEntry)((0, $2Y5nj.knowledgeHubBrowseAllArticlesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $bUl48.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $5qNZF.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $igNUx.isFedRamp)(), (0, $bxbQK.virtualAgentKnowledgebaseTouchpointResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bUl48.LazyServicedeskKnowledgeHubBrowseAllArticles)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("bxbQK", function(module, exports) {

$parcel$export(module.exports, "virtualAgentKnowledgebaseTouchpointResource", () => $3afa3392dccb83a7$export$1b798e6122168cca);

var $7jTnu = parcelRequire("7jTnu");

var $9FYIg = parcelRequire("9FYIg");

var $4MEAW = parcelRequire("4MEAW");
const $3afa3392dccb83a7$export$1b798e6122168cca = (0, $9FYIg.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_KNOWLEDGE_BASE_TOUCHPOINT',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $4MEAW.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $7jTnu.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});
parcelRegister("4MEAW", function(module, exports) {

$parcel$export(module.exports, "default", () => $23885a01ddd4fc7b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d286ede3f2edeee466a0bd65055c253b>>
 * @relayHash 7555a82a51148c607a64f1ab7402dfed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a066b2d28ec980806bb63d852e0abfc11a1a1a5c90904f798db2d9030dc7252b
const $23885a01ddd4fc7b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a066b2d28ec980806bb63d852e0abfc11a1a1a5c90904f798db2d9030dc7252b",
        "metadata": {},
        "name": "mainVirtualServiceAgentCtaCardQuery",
        "operationKind": "query",
        "text": null
    }
};
var $23885a01ddd4fc7b$export$2e2bcd8739ae039 = $23885a01ddd4fc7b$var$node;

});


parcelRegister("2Y5nj", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRoute", () => $6f80f34f95941411$export$c8e99e3434791c0e);
const $6f80f34f95941411$export$c8e99e3434791c0e = {
    name: 'knowledge-hub-browse-all-articles',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles',
    exact: true
};

});


parcelRegister("20wcj", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRouteEntry", () => $823f90a908b238fe$export$dd6c99863524ee59);

var $kHlOR = parcelRequire("kHlOR");

var $5qNZF = parcelRequire("5qNZF");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $1nDFe = parcelRequire("1nDFe");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $37mqV = parcelRequire("37mqV");

var $7P9Bo = parcelRequire("7P9Bo");
const $823f90a908b238fe$export$dd6c99863524ee59 = (0, $6xToB.createEntry)((0, $1nDFe.knowledgeHubBrowseAllCategoriesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $7P9Bo.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $5qNZF.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7P9Bo.LazyServicedeskKnowledgeHubBrowseAllCategories)
        ],
        perfMetricKey: 'service-management.kb-categories',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_BROWSE_CATEGORIES,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_BROWSE_CATEGORIES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("1nDFe", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRoute", () => $58bbd9d370d8b140$export$256f841794b3f077);
const $58bbd9d370d8b140$export$256f841794b3f077 = {
    name: 'knowledge-hub-browse-all-categories',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories',
    exact: true
};

});

parcelRegister("7P9Bo", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubBrowseAllCategories", () => $984449bb49cd7f6f$export$a488cba75f18ade8);
$parcel$export(module.exports, "default", () => $984449bb49cd7f6f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $984449bb49cd7f6f$export$a488cba75f18ade8 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4bTh8"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-categories/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$984449bb49cd7f6f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $984449bb49cd7f6f$export$a488cba75f18ade8,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-categories",
        shouldShowSpinner: true
    });

});
parcelRegister("4bTh8", function(module, exports) {

let $30d311096e17c4f3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $30d311096e17c4f3$var$load("QMDGS").then(()=>parcelRequire('6MBBj'));

});



parcelRegister("1lGts", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseViewArticleRouteEntry", () => $f8027d8fdd2a398c$export$abb9cdffbf5c943b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $2mUb7 = parcelRequire("2mUb7");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $37mqV = parcelRequire("37mqV");

var $1m9Vx = parcelRequire("1m9Vx");
const $f8027d8fdd2a398c$export$abb9cdffbf5c943b = (0, $6xToB.createEntry)((0, $2mUb7.knowledgeHubBrowseViewArticleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.knowledge.article',
        component: (0, $1m9Vx.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1m9Vx.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("2mUb7", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseViewArticleRoute", () => $cd209d2926c2a236$export$ef8a9ec2979d1b10);
const $cd209d2926c2a236$export$ef8a9ec2979d1b10 = {
    name: 'knowledge-hub-browse-view-article',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles/:articleId'
};

});


parcelRegister("j3R4j", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryPageRouteEntry", () => $3ae5894492816ecf$export$464b24032c2aeb02);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $j3xLT = parcelRequire("j3xLT");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $37mqV = parcelRequire("37mqV");

var $el48G = parcelRequire("el48G");
const $3ae5894492816ecf$export$464b24032c2aeb02 = (0, $6xToB.createEntry)((0, $j3xLT.knowledgeHubCategoryPageRoute), ()=>({
        group: 'servicedesk',
        component: (0, $el48G.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $el48G.LazyServicedeskKnowledgeHubCategory)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_CATEGORY,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("j3xLT", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryPageRoute", () => $80f8d129ae4f90b7$export$79fb48a07e43639a);
const $80f8d129ae4f90b7$export$79fb48a07e43639a = {
    name: 'knowledge-hub-category-page',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/browse/page/:pageId'
};

});

parcelRegister("el48G", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubCategory", () => $fd62694248c955e3$export$c01a896b8d33aa9c);
$parcel$export(module.exports, "default", () => $fd62694248c955e3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $fd62694248c955e3$export$c01a896b8d33aa9c = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("j5BIz"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-category/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fd62694248c955e3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fd62694248c955e3$export$c01a896b8d33aa9c,
        pageId: "spa-apps/servicedesk/knowledge-hub/category",
        shouldShowSpinner: true
    });

});
parcelRegister("j5BIz", function(module, exports) {

let $de5bbdf11649cae7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $de5bbdf11649cae7$var$load("5Z2gS").then(()=>parcelRequire('ifsVi'));

});



parcelRegister("gG5r4", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryRouteEntry", () => $3785c68628c9a716$export$416d7b87b4f3205e);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $5kJg8 = parcelRequire("5kJg8");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $37mqV = parcelRequire("37mqV");

var $el48G = parcelRequire("el48G");
const $3785c68628c9a716$export$416d7b87b4f3205e = (0, $6xToB.createEntry)((0, $5kJg8.knowledgeHubCategoryRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.knowledge.category',
        component: (0, $el48G.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $el48G.LazyServicedeskKnowledgeHubCategory)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_CATEGORY,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("5kJg8", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryRoute", () => $513d9221090385c4$export$69ed5b0214ea6ee5);
const $513d9221090385c4$export$69ed5b0214ea6ee5 = {
    name: 'knowledge-hub-category',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId'
};

});


parcelRegister("jYWZX", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubDraftsRouteEntry", () => $3de8811eda552379$export$4da743c0d13c2cfc);

var $kHlOR = parcelRequire("kHlOR");

var $5qNZF = parcelRequire("5qNZF");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $ibB6D = parcelRequire("ibB6D");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $37mqV = parcelRequire("37mqV");

var $lGEBz = parcelRequire("lGEBz");
const $3de8811eda552379$export$4da743c0d13c2cfc = (0, $6xToB.createEntry)((0, $ibB6D.knowledgeHubDraftsRoute), ()=>({
        group: 'servicedesk',
        component: (0, $lGEBz.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $5qNZF.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $lGEBz.LazyServicedeskKnowledgeHubDrafts)
        ],
        perfMetricKey: 'service-management.kb-drafts',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_DRAFTS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_DRAFTS),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("ibB6D", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubDraftsRoute", () => $20dedff9bf24275c$export$670f3b59aa55b7ae);
const $20dedff9bf24275c$export$670f3b59aa55b7ae = {
    name: 'knowledge-hub-drafts',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/drafts',
    exact: true
};

});

parcelRegister("lGEBz", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubDrafts", () => $9dd32b6f3082a02e$export$53decb9d1eb60aed);
$parcel$export(module.exports, "default", () => $9dd32b6f3082a02e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $9dd32b6f3082a02e$export$53decb9d1eb60aed = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("1hiDF"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-drafts/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9dd32b6f3082a02e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $9dd32b6f3082a02e$export$53decb9d1eb60aed,
        pageId: "spa-apps/servicedesk/knowledge-hub/drafts",
        shouldShowSpinner: true
    });

});
parcelRegister("1hiDF", function(module, exports) {

let $0ee5d64676a0573e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $0ee5d64676a0573e$var$load("eDzss"),
    $0ee5d64676a0573e$var$load("1r8Y6")
]).then(()=>parcelRequire('by822'));

});



parcelRegister("21gXe", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubLandingRouteEntry", () => $af48c865d50803a3$export$671687d85e096e5b);

var $kHlOR = parcelRequire("kHlOR");

var $5qNZF = parcelRequire("5qNZF");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $1cRFu = parcelRequire("1cRFu");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $37mqV = parcelRequire("37mqV");

var $7KQFQ = parcelRequire("7KQFQ");
const $af48c865d50803a3$export$671687d85e096e5b = (0, $6xToB.createEntry)((0, $1cRFu.knowledgeHubLandingRoute), ()=>({
        group: 'servicedesk',
        component: (0, $7KQFQ.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $5qNZF.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7KQFQ.LazyServicedeskKnowledgeHubLanding)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_LANDING,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_LANDING),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("1cRFu", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubLandingRoute", () => $852afc9ee2401a27$export$239eaf6a202e0f54);
const $852afc9ee2401a27$export$239eaf6a202e0f54 = {
    name: 'knowledge-hub-landing',
    path: '/jira/servicedesk/projects/:projectKey/knowledge',
    exact: true
};

});

parcelRegister("7KQFQ", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubLanding", () => $60cb10bb5d52f412$export$f1266a588cfc310b);
$parcel$export(module.exports, "default", () => $60cb10bb5d52f412$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $60cb10bb5d52f412$export$f1266a588cfc310b = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("4XyPo")), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-landing/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$60cb10bb5d52f412$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $60cb10bb5d52f412$export$f1266a588cfc310b,
        pageId: "spa-apps/servicedesk/knowledge-hub/landing-page",
        shouldShowSpinner: true
    });

});
parcelRegister("4XyPo", function(module, exports) {

let $39c7b03162ca647a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $39c7b03162ca647a$var$load("bLENQ").then(()=>parcelRequire('96cJs'));

});



parcelRegister("5jjQ1", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSearchRouteEntry", () => $9b7f4a9d389ea822$export$49337a3cc2431ae5);

var $kHlOR = parcelRequire("kHlOR");

var $5qNZF = parcelRequire("5qNZF");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $bvETR = parcelRequire("bvETR");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $37mqV = parcelRequire("37mqV");

var $1m9Vx = parcelRequire("1m9Vx");
const $9b7f4a9d389ea822$export$49337a3cc2431ae5 = (0, $6xToB.createEntry)((0, $bvETR.knowledgeHubSearchRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1m9Vx.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $5qNZF.AsyncKbNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1m9Vx.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("bvETR", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSearchRoute", () => $e3ab93bfd33327ab$export$a47c36fb081b544d);
const $e3ab93bfd33327ab$export$a47c36fb081b544d = {
    name: 'knowledge-hub-search',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/search/articles/:articleId'
};

});


parcelRegister("1MGof", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSetupRouteEntry", () => $c084a6049e6be4fd$export$b220f8194ee7c231);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $jexDQ = parcelRequire("jexDQ");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $37mqV = parcelRequire("37mqV");

var $8Yxet = parcelRequire("8Yxet");
const $c084a6049e6be4fd$export$b220f8194ee7c231 = (0, $6xToB.createEntry)((0, $jexDQ.knowledgeHubSetupRoute), ()=>({
        group: 'servicedesk',
        component: (0, $8Yxet.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8Yxet.LazyServicedeskKnowledgeHubSetup)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_SETUP,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_SETUP),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("jexDQ", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSetupRoute", () => $7a69d7ec5c386457$export$f20770545704547d);
const $7a69d7ec5c386457$export$f20770545704547d = {
    name: 'knowledge-hub-setup',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/setup'
};

});

parcelRegister("8Yxet", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubSetup", () => $19aed36a1390b002$export$6c08040d2dc71e43);
$parcel$export(module.exports, "default", () => $19aed36a1390b002$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $19aed36a1390b002$export$6c08040d2dc71e43 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8KC36")), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-setup/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$19aed36a1390b002$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $19aed36a1390b002$export$6c08040d2dc71e43,
        pageId: "spa-apps/servicedesk/knowledge-hub/setup",
        shouldShowSpinner: true
    });

});
parcelRegister("8KC36", function(module, exports) {

let $65f02256aa1c9bf4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $65f02256aa1c9bf4$var$load("1Ak64").then(()=>parcelRequire('c5DUK'));

});



parcelRegister("i5Fsz", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSuggestedArticlesRouteEntry", () => $1c4b63b80aea78f0$export$6a7974939bde7d37);

var $kHlOR = parcelRequire("kHlOR");

var $5qNZF = parcelRequire("5qNZF");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $23Ngf = parcelRequire("23Ngf");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $37mqV = parcelRequire("37mqV");

var $0WCVc = parcelRequire("0WCVc");
const $1c4b63b80aea78f0$export$6a7974939bde7d37 = (0, $6xToB.createEntry)((0, $23Ngf.knowledgeHubSuggestedArticlesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $0WCVc.ServiceDeskKnowledgeHubSuggestedArticles),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $5qNZF.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $0WCVc.LazyServicedeskKnowledgeHubSuggestedArticles)
        ],
        perfMetricKey: 'service-management.kb-suggested-articles',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_SUGGESTED_ARTICLES,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_SUGGESTED_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("23Ngf", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSuggestedArticlesRoute", () => $8622f25f0723b25a$export$54edf5cef1c6b21b);
const $8622f25f0723b25a$export$54edf5cef1c6b21b = {
    name: 'knowledge-hub-suggested-topics',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/suggested-topics',
    exact: true
};

});

parcelRegister("0WCVc", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubSuggestedArticles", () => $f74daa10b19a4a9a$export$aee7d96c2ee4c388);
$parcel$export(module.exports, "ServiceDeskKnowledgeHubSuggestedArticles", () => $f74daa10b19a4a9a$export$ee4623542ebd573e);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $3XuP5 = parcelRequire("3XuP5");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $8vyDv = parcelRequire("8vyDv");

var $gzcjr = parcelRequire("gzcjr");

const $f74daa10b19a4a9a$export$aee7d96c2ee4c388 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ehUA0"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-suggested-articles/src/index.tsx"
});
const $f74daa10b19a4a9a$export$ee4623542ebd573e = ()=>{
    const { data: isAdminHubAIEnabled, loading: loading, error: error, fetchAIEnablement: fetchAIEnablement } = (0, $3XuP5.default)('jira-servicedesk');
    const appEditions = (0, $8vyDv.useAppEditions)();
    const isTopicSuggestionAllowed = (0, $eJOHy.useCallback)(()=>{
        if (!(0, $7jTnu.fg)('restrict-suggested-topics-to-jsm-premium')) return true;
        return appEditions.serviceDesk === 'PREMIUM_EDITION';
    }, [
        appEditions.serviceDesk
    ]);
    const showSuggestedTopics = isTopicSuggestionAllowed() && !loading && !error && isAdminHubAIEnabled && (0, $7jTnu.fg)('jsm-suggested-articles-in-kb');
    (0, $eJOHy.useEffect)(()=>{
        isTopicSuggestionAllowed() && (0, $7jTnu.fg)('jsm-suggested-articles-in-kb') && fetchAIEnablement();
    }, [
        fetchAIEnablement,
        isTopicSuggestionAllowed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showSuggestedTopics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f74daa10b19a4a9a$export$aee7d96c2ee4c388,
        pageId: "spa-apps/servicedesk/knowledge-hub/suggested-articles",
        shouldShowSpinner: true
    }));
};

});
parcelRegister("3XuP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f11b08ae1f3711e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $lsOEE = parcelRequire("lsOEE");
const $8f11b08ae1f3711e$var$useIsAdminHubAIEnabled = (jiraProduct, version)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [isAdminHubAiToggleEnabled, setIsAdminHubAiToggleEnabled] = (0, $eJOHy.useState)(null);
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const fetchData = (0, $eJOHy.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $lsOEE.fetchAiEnablement)(jiraProduct, version);
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchAiEnablementStatus succeeded');
            setIsAdminHubAiToggleEnabled(response.isEnabled);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError(err);
            (0, $gYnSx.default)({
                error: err,
                meta: {
                    id: 'fetchAiEnablementStatus failed'
                }
            });
        } finally{
            setLoading(false);
        }
    }, [
        createAnalyticsEvent,
        jiraProduct,
        version
    ]);
    return {
        data: isAdminHubAiToggleEnabled,
        loading: loading,
        error: error,
        fetchAIEnablement: fetchData
    };
};
var $8f11b08ae1f3711e$export$2e2bcd8739ae039 = $8f11b08ae1f3711e$var$useIsAdminHubAIEnabled;

});
parcelRegister("lsOEE", function(module, exports) {

$parcel$export(module.exports, "fetchAiEnablement", () => $dc8dcfb6f4d0d2bd$export$ad4105850d0ce824);

var $1Ozm9 = parcelRequire("1Ozm9");
const $dc8dcfb6f4d0d2bd$export$2171a423b572256a = (jiraProduct, version = '1')=>`/rest/api/${version}/aiconfig/ai-enabled/${jiraProduct}`;
const $dc8dcfb6f4d0d2bd$export$ad4105850d0ce824 = (jiraProduct, version = '1')=>{
    const url = $dc8dcfb6f4d0d2bd$export$2171a423b572256a(jiraProduct, version);
    return (0, $1Ozm9.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("ehUA0", function(module, exports) {

let $a66e8ac2daa3c885$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a66e8ac2daa3c885$var$load("4TnVI").then(()=>parcelRequire('7CCUS'));

});



parcelRegister("3mrXC", function(module, exports) {

$parcel$export(module.exports, "landingPageRouteEntry", () => $1a2af95fa31b4152$export$8ccc5b384e778bac);

var $igNUx = parcelRequire("igNUx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $loMl1 = parcelRequire("loMl1");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $5u2wi = parcelRequire("5u2wi");

var $g8uYY = parcelRequire("g8uYY");

var $dbEUp = parcelRequire("dbEUp");

var $cAYFR = parcelRequire("cAYFR");
const $1a2af95fa31b4152$var$landingPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $dbEUp.landingEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $1a2af95fa31b4152$export$8ccc5b384e778bac = (0, $6xToB.createEntry)((0, $loMl1.landingPageRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $igNUx.isFedRamp)()) return undefined;
            return $1a2af95fa31b4152$var$landingPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $5u2wi.VirtualAgentLandingSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("5u2wi", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentLandingSkeleton", () => $0e929a439af87fe6$export$f4b71d7b732df8a7);
/* VirtualAgentLandingSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $crQOK = parcelRequire("crQOK");
const $0e929a439af87fe6$var$customStyles = null;
const $0e929a439af87fe6$export$f4b71d7b732df8a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($crQOK))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("crQOK", function(module, exports) {
module.exports = new URL("virtual-agent-landing-app-skeleton.tpl.e8a7897b.svg", import.meta.url).toString();

});


parcelRegister("dbEUp", function(module, exports) {

$parcel$export(module.exports, "landingEntryPoint", () => $f1bb2f35aa113c41$export$ad927ca7512a3a01);

var $iHznS = parcelRequire("iHznS");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");
const $f1bb2f35aa113c41$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $f1bb2f35aa113c41$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10); // has to be truncated for proper caching in SSR

const $f1bb2f35aa113c41$export$ad927ca7512a3a01 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("4gcyE")), {
        moduleId: "06d84010",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $iHznS.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        startDate: $f1bb2f35aa113c41$var$formatFetchDate(new Date(Date.now() - $f1bb2f35aa113c41$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $f1bb2f35aa113c41$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("iHznS", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb561b2adfb36bc8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<926559935d96714cdc2f3908057aabd7>>
 * @relayHash 04a2990e8f89356b716b4fa0b8c7b93b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 730beb4039e9e81173ca804b12c625befbc6b5e4b36082ce298c6893a1fff65d

var $5rtNk = parcelRequire("5rtNk");

var $bXR9c = parcelRequire("bXR9c");

var $fUVPs = parcelRequire("fUVPs");

var $Ic6R7 = parcelRequire("Ic6R7");
const $eb561b2adfb36bc8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "730beb4039e9e81173ca804b12c625befbc6b5e4b36082ce298c6893a1fff65d",
        "metadata": {},
        "name": "srcVirtualAgentLandingQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": (0, $Ic6R7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvanextstepsrelayprovider": (0, $fUVPs.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmreplacevsawithrovoagentsrelayprovider": (0, $5rtNk.default)
        }
    }
};
var $eb561b2adfb36bc8$export$2e2bcd8739ae039 = $eb561b2adfb36bc8$var$node;

});
parcelRegister("5rtNk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2aff2c5d2b0241c$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $b2aff2c5d2b0241c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jsm-replace-vsa-with-rovo-agents');
    }
};

});

parcelRegister("fUVPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $582c441c33965029$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $582c441c33965029$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('show-next-steps-on-vsa-performance-page');
    }
};

});

parcelRegister("Ic6R7", function(module, exports) {

$parcel$export(module.exports, "default", () => $06934404485a86b2$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $06934404485a86b2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jsm_va_status_header');
    }
};

});


parcelRegister("4gcyE", function(module, exports) {

let $31a265ca3adf8158$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $31a265ca3adf8158$var$load("gXTXj").then(()=>parcelRequire('8kD52'));

});



parcelRegister("4SqLF", function(module, exports) {

$parcel$export(module.exports, "legacyPlanPageRedirectRouteEntry", () => $187cf9cb456facdd$export$e9cfdb950d40e917);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $lnaMp = parcelRequire("lnaMp");

var $eyNFj = parcelRequire("eyNFj");

var $iIcBn = parcelRequire("iIcBn");
const $187cf9cb456facdd$export$e9cfdb950d40e917 = (0, $6xToB.createEntry)((0, $lnaMp.legacyPlanPageRedirectRoute), ()=>({
        group: 'software',
        component: (0, $eyNFj.RedirectLegacyPlanPage),
        isRedirect: true,
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4KrIc.advancedRoadmapsScenarioIdResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iIcBn.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("lnaMp", function(module, exports) {

$parcel$export(module.exports, "legacyPlanPageRedirectRoute", () => $6d8f475adb205152$export$1e324bd9675918a8);
const $6d8f475adb205152$export$1e324bd9675918a8 = {
    name: 'software-advanced-roadmaps-redirect',
    path: '/secure/PortfolioPlanView.jspa'
};

});

parcelRegister("eyNFj", function(module, exports) {

$parcel$export(module.exports, "RedirectLegacyPlanPage", () => $0629fc505d245fd6$export$c3e4fda2290a52bf);
$parcel$export(module.exports, "RedirectPlanPageWithoutScenarioId", () => $0629fc505d245fd6$export$ff420400c9900835);
$parcel$export(module.exports, "RedirectPlanPageWithoutScenarioIdLoadQuery", () => $0629fc505d245fd6$export$e57364775e9e9634);

var $49XDD = parcelRequire("49XDD");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6OSA0 = parcelRequire("6OSA0");

var $4KrIc = parcelRequire("4KrIc");

var $7fTjp = parcelRequire("7fTjp");

var $1K1Ep = parcelRequire("1K1Ep");

var $eJrcF = parcelRequire("eJrcF");
var $gCY1z = parcelRequire("gCY1z");

var $49XDD = parcelRequire("49XDD");

var $lvKO5 = parcelRequire("lvKO5");
const $0629fc505d245fd6$var$PERSIST_SEARCH_PARAMS = [
    'search'
];
const $0629fc505d245fd6$var$RedirectLegacyPlanPageWithoutScenarioId = ()=>{
    const [{ query: query }] = (0, $gCY1z.useRouter)();
    const { data: data, loading: loading } = (0, $eJrcF.useResource)((0, $4KrIc.advancedRoadmapsScenarioIdResource));
    if (loading || data === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/jira/plans/${query.id}/scenarios/${data.scenarioId}`,
        persistSearchParams: $0629fc505d245fd6$var$PERSIST_SEARCH_PARAMS
    });
};
const $0629fc505d245fd6$export$c3e4fda2290a52bf = ()=>{
    const [{ query: query }] = (0, $gCY1z.useRouter)();
    const { id: id, sid: sid } = query;
    if (Number.isNaN(Number.parseFloat(sid))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0629fc505d245fd6$var$RedirectLegacyPlanPageWithoutScenarioId, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/jira/plans/${id}/scenarios/${sid}`,
        persistSearchParams: $0629fc505d245fd6$var$PERSIST_SEARCH_PARAMS
    });
};
const $0629fc505d245fd6$export$ff420400c9900835 = ()=>{
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    const { planId: planId } = match.params;
    if (planId === null || planId === undefined || Number.isNaN(Number.parseFloat(planId))) throw new Error('Plan cannot be loaded without planId');
    const { data: data, loading: loading } = (0, $eJrcF.useResource)((0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource));
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1K1Ep.ErrorScreen), {
        errorMessage: data.errorMessage
    });
    if (data.scenarioId === null || data.scenarioId === undefined || typeof data.scenarioId === 'string' && Number.isNaN(Number.parseFloat(data.scenarioId))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/jira/plans/${planId}/scenarios/${data.scenarioId}`,
        persistSearchParams: $0629fc505d245fd6$var$PERSIST_SEARCH_PARAMS
    });
};
const $0629fc505d245fd6$export$b2194d886d9f3b64 = ({ queryRef: queryRef, planId: planId })=>{
    const gqlData = (0, $j4oe4.usePreloadedQuery)((0, $49XDD.default), queryRef);
    const { data: data, loading: loading } = (0, $eJrcF.useResource)((0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource));
    const defaultTabUrl = gqlData?.jira?.planById?.defaultNavigationItem?.url;
    if (defaultTabUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: defaultTabUrl,
        persistSearchParams: $0629fc505d245fd6$var$PERSIST_SEARCH_PARAMS
    });
    // Fallback if can not get defaultTabUrl
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1K1Ep.ErrorScreen), {
        errorMessage: data.errorMessage
    });
    if (data.scenarioId === null || data.scenarioId === undefined || typeof data.scenarioId === 'string' && Number.isNaN(Number.parseFloat(data.scenarioId))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/jira/plans/${planId}/scenarios/${data.scenarioId}`,
        persistSearchParams: $0629fc505d245fd6$var$PERSIST_SEARCH_PARAMS
    });
};
const $0629fc505d245fd6$export$e57364775e9e9634 = ()=>{
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    const { planId: planId } = match.params;
    if (planId === null || planId === undefined || Number.isNaN(Number.parseFloat(planId))) throw new Error('Plan cannot be loaded without planId');
    const { cloudId: cloudId, activationId: activationId } = (0, $lvKO5.useTenantContext)();
    const [queryRef, loadQuery, disposeQuery] = (0, $j4oe4.useQueryLoader)((0, $49XDD.default));
    (0, $eJOHy.useEffect)(()=>{
        loadQuery({
            planId: `ari:cloud:jira:${cloudId}:plan/activation/${activationId}/${planId}`
        }, {
            fetchPolicy: 'store-or-network'
        });
        return disposeQuery;
    }, [
        loadQuery,
        disposeQuery,
        cloudId,
        activationId,
        planId
    ]);
    return queryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0629fc505d245fd6$export$b2194d886d9f3b64, {
        queryRef: queryRef,
        planId: planId
    }) : null;
};

});
parcelRegister("49XDD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2445e06a4117db1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<513d91abcf431d67cd831934eb3cdd81>>
 * @relayHash c7ba33b8e7695997c7bbf9e29b42c7ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b22213e57ba6874b345876f3c35d0dda118f459e6007f6c559d80ba94b6d1fe
const $e2445e06a4117db1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "planId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "planId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "JiraNavigationItem",
        "abstractKey": "__isJiraNavigationItem"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "planNoScenarioQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPlan",
                            "kind": "LinkedField",
                            "name": "planById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "LinkedField",
                                        "name": "defaultNavigationItem",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.planById.defaultNavigationItem"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "planNoScenarioQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPlan",
                            "kind": "LinkedField",
                            "name": "planById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "defaultNavigationItem",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7b22213e57ba6874b345876f3c35d0dda118f459e6007f6c559d80ba94b6d1fe",
            "metadata": {},
            "name": "planNoScenarioQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e2445e06a4117db1$var$node.hash = "7791279196ac8025a83cda3fc2b29b08";
var $e2445e06a4117db1$export$2e2bcd8739ae039 = $e2445e06a4117db1$var$node;

});

parcelRegister("1K1Ep", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $2e8e9348b642d506$export$42f84e610f279c31);

var $eJOHy = parcelRequire("eJOHy");

var $5ya7R = parcelRequire("5ya7R");


var $lHJi1 = parcelRequire("lHJi1");

var $ghcyi = parcelRequire("ghcyi");

var $khPJj = parcelRequire("khPJj");

var $2rgTV = parcelRequire("2rgTV");
const $2e8e9348b642d506$export$42f84e610f279c31 = ({ errorMessage: errorMessage, isEmbedded: isEmbedded = false, planId: planId })=>{
    /**
	 * Clearing the early-preload promises here otherwise they get carried on to the following plan loads.
	 *
	 * The SPA app renders the ErrorScreen instead of the PlanApp when the validation fails,
	 * hence the early-preload promises did not get cleaned up.
	 */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, react-hooks/react-compiler
    delete window.__ARJ_BACKLOG_PROMISE__;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.__ARJ_INFO_METADATA_PROMISE__;
    switch(errorMessage){
        case 0, $9bc9fcc35360d1f1$export$aa64437890e7b596:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5ya7R.RedirectToLoginPage), null);
        case 0, $9bc9fcc35360d1f1$export$3fe2400c9d24940d:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHJi1.AsyncLicenseViolationErrorPage), {
                isEmbedded: isEmbedded
            });
        case 0, $9bc9fcc35360d1f1$export$4589763db20bfd7f:
        case 0, $9bc9fcc35360d1f1$export$7e6358a0c21dff8c:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $khPJj.AsyncNotFoundErrorPage), {
                entity: (0, $9bc9fcc35360d1f1$export$c303e491e026ebc6),
                isEmbedded: isEmbedded
            });
        case 0, $9bc9fcc35360d1f1$export$6519152a5f0e081:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $khPJj.AsyncNotFoundErrorPage), {
                entity: (0, $9bc9fcc35360d1f1$export$9b928fc5e710e864),
                isEmbedded: isEmbedded,
                planId: planId
            });
        case 0, $9bc9fcc35360d1f1$export$6128dc888243fa0a:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ghcyi.AsyncNoPlanPermissionErrorPage), {
                isEmbedded: isEmbedded
            });
        case 0, $9bc9fcc35360d1f1$export$1f988ace3cbe8975:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2rgTV.AsyncLazyGenericErrorPage), null);
        default:
            return null;
    }
};

});
const $9bc9fcc35360d1f1$export$aa64437890e7b596 = 'permission-violation';
const $9bc9fcc35360d1f1$export$3fe2400c9d24940d = 'license-violation';
const $9bc9fcc35360d1f1$export$4589763db20bfd7f = 'plan-not-found';
const $9bc9fcc35360d1f1$export$6519152a5f0e081 = 'scenario-not-found';
const $9bc9fcc35360d1f1$export$7e6358a0c21dff8c = 'report-not-found';
const $9bc9fcc35360d1f1$export$6128dc888243fa0a = 'no-plan-permission';
const $9bc9fcc35360d1f1$export$1f988ace3cbe8975 = 'GENERIC';
const $9bc9fcc35360d1f1$export$c303e491e026ebc6 = 'PLAN';
const $9bc9fcc35360d1f1$export$9b928fc5e710e864 = 'SCENARIO';
const $9bc9fcc35360d1f1$export$b8b9d90f9e5bd72b = 'jiraSpaAppsAdvancedRoadmaps';
const $9bc9fcc35360d1f1$export$d57b6b390e78d90f = 'advanced-roadmaps';

parcelRegister("lHJi1", function(module, exports) {

$parcel$export(module.exports, "AsyncLicenseViolationErrorPage", () => $6e303ef7d2bed99c$export$f5d9764f07badc4d);

var $eJOHy = parcelRequire("eJOHy");

var $6OSA0 = parcelRequire("6OSA0");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $6e303ef7d2bed99c$var$LazyLicenseViolationErrorPage = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("eS2QS")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/license-violation/index.tsx"
});
const $6e303ef7d2bed99c$export$f5d9764f07badc4d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "arj-license-violation-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6e303ef7d2bed99c$var$LazyLicenseViolationErrorPage, props));

});
parcelRegister("eS2QS", function(module, exports) {

let $ad385226a4a765b5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ad385226a4a765b5$var$load("bXoyE").then(()=>parcelRequire('9GdMy'));

});


parcelRegister("ghcyi", function(module, exports) {

$parcel$export(module.exports, "AsyncNoPlanPermissionErrorPage", () => $87ae74d289795cd2$export$e595d2c5dfcb1d5a);

var $eJOHy = parcelRequire("eJOHy");

var $6OSA0 = parcelRequire("6OSA0");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $87ae74d289795cd2$var$LazyNoPlanPermissionErrorPage = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("2p0kS")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/no-plan-permission/index.tsx"
});
const $87ae74d289795cd2$export$e595d2c5dfcb1d5a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "arj-no-plan-permission",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($87ae74d289795cd2$var$LazyNoPlanPermissionErrorPage, props));

});
parcelRegister("2p0kS", function(module, exports) {

let $1bfe2d4136e90c3b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1bfe2d4136e90c3b$var$load("kmew9").then(()=>parcelRequire('hPioD'));

});


parcelRegister("khPJj", function(module, exports) {

$parcel$export(module.exports, "AsyncNotFoundErrorPage", () => $79f9e794c70fc463$export$8f6c907860218fdc);

var $eJOHy = parcelRequire("eJOHy");

var $6OSA0 = parcelRequire("6OSA0");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $79f9e794c70fc463$var$LazyNotFoundErrorPage = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("1lvBU")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/not-found/index.tsx"
});
const $79f9e794c70fc463$export$8f6c907860218fdc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "arj-not-found-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($79f9e794c70fc463$var$LazyNotFoundErrorPage, props));

});
parcelRegister("1lvBU", function(module, exports) {

let $0fb045cb6eddc6ae$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0fb045cb6eddc6ae$var$load("k98HO").then(()=>parcelRequire('5y4bu'));

});


parcelRegister("2rgTV", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyGenericErrorPage", () => $dbfe5cf5b0eacf76$export$8e4963c137216f8f);

var $eJOHy = parcelRequire("eJOHy");

var $6OSA0 = parcelRequire("6OSA0");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $dbfe5cf5b0eacf76$var$LazyGenericErrorPage = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("iIJGL")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/generic/index.tsx"
});
const $dbfe5cf5b0eacf76$export$8e4963c137216f8f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-arj-generic-error-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dbfe5cf5b0eacf76$var$LazyGenericErrorPage, null));

});
parcelRegister("iIJGL", function(module, exports) {

let $da0fc6e6d332f24a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $da0fc6e6d332f24a$var$load("4Hckg").then(()=>parcelRequire('g7lF5'));

});




parcelRegister("iIcBn", function(module, exports) {

$parcel$export(module.exports, "LazyPlanTimeline", () => $ea65241c1b4edd2f$export$bf48e5f1529ddaeb);
$parcel$export(module.exports, "default", () => $ea65241c1b4edd2f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ea65241c1b4edd2f$export$bf48e5f1529ddaeb = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5rLHw"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ea65241c1b4edd2f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ea65241c1b4edd2f$export$bf48e5f1529ddaeb,
        pageId: "plan-timeline",
        shouldShowSpinner: true
    });

});


parcelRegister("bRYwY", function(module, exports) {

$parcel$export(module.exports, "legacyPlanReportPageRedirectRouteEntry", () => $4d144feb6a840f18$export$c2a4c5c6576a704c);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $4vL7T = parcelRequire("4vL7T");

var $cWxb0 = parcelRequire("cWxb0");

var $iIcBn = parcelRequire("iIcBn");
const $4d144feb6a840f18$export$c2a4c5c6576a704c = (0, $6xToB.createEntry)((0, $4vL7T.legacyPlanReportPageRedirectRoute), ()=>({
        group: 'software',
        component: (0, $cWxb0.default),
        isRedirect: true,
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iIcBn.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("4vL7T", function(module, exports) {

$parcel$export(module.exports, "legacyPlanReportPageRedirectRoute", () => $1d4e7026354226c0$export$7747547e845a016c);
const $1d4e7026354226c0$export$7747547e845a016c = {
    name: 'software-advanced-roadmaps-redirect',
    path: '/secure/PortfolioReportView.jspa'
};

});

parcelRegister("cWxb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $464f19e6e477337c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");

var $gCY1z = parcelRequire("gCY1z");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$464f19e6e477337c$export$2e2bcd8739ae039 = ()=>{
    const [{ query: query }] = (0, $gCY1z.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/jira/plans/reports/${query.r}`,
        persistSearchParams: false
    });
};

});


parcelRegister("C784O", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRouteEntry", () => $ab28d2b73a7a7822$export$836428e7b33b6c6c);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $98adr = parcelRequire("98adr");

var $8FCAy = parcelRequire("8FCAy");

var $bMm2d = parcelRequire("bMm2d");
const $ab28d2b73a7a7822$export$836428e7b33b6c6c = (0, $6xToB.createEntry)((0, $98adr.legacyProjectReleasesNoteConfigRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        component: (0, $bMm2d.LegacyFrontendReleaseNoteRedirect),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("98adr", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRoute", () => $0c04158b743c13bc$export$a9509017cabb1e30);
const $0c04158b743c13bc$export$a9509017cabb1e30 = {
    name: 'legacy-project-releases-note-config',
    path: '/secure/ConfigureReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});

parcelRegister("bMm2d", function(module, exports) {

$parcel$export(module.exports, "BoardSettingsRedirectToCSM", () => $c91395048a6a2e4b$export$ccce5315da25c53e);
$parcel$export(module.exports, "RoadmapSettingsRedirectToTimelineSettings", () => $c91395048a6a2e4b$export$eaa324972a212c18);
$parcel$export(module.exports, "SpaReleaseNoteRedirectToVersionDetails", () => $c91395048a6a2e4b$export$52fa4fd8ca9baab5);
$parcel$export(module.exports, "LegacyFrontendReleaseNoteRedirect", () => $c91395048a6a2e4b$export$dee47264404d89a0);
$parcel$export(module.exports, "getUFOName", () => $c91395048a6a2e4b$export$759ec9adbd19c936);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $7UxjA = parcelRequire("7UxjA");

var $2mHfh = parcelRequire("2mHfh");
const $c91395048a6a2e4b$export$ccce5315da25c53e = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/columns`,
        push: false
    });
const $c91395048a6a2e4b$export$eaa324972a212c18 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/timeline`,
        push: false
    });
const $c91395048a6a2e4b$export$52fa4fd8ca9baab5 = ({ query: query })=>{
    const { version: versionId } = query;
    const { loading: loading, error: error, projectKey: projectKey } = (0, $7UxjA.useProjectKeyByProjectResource)();
    if (loading === false && error) return null;
    if (loading) return null;
    if (!versionId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: {
            pathname: `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin%3Arelease-page`,
            hash: '',
            search: ''
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: {
            pathname: `/projects/${projectKey}/versions/${versionId}/tab/release-report-all-issues`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
                isReleaseNoteModalOpen: true
            })
        }
    });
};
const $c91395048a6a2e4b$export$dee47264404d89a0 = ({ query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: {
            pathname: '/secure/ReleaseNote.jspa',
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
                ...query,
                isRedirectedFromLegacy: true
            })
        }
    });
const $c91395048a6a2e4b$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $c91395048a6a2e4b$export$759ec9adbd19c936 = (name)=>$c91395048a6a2e4b$var$ufoNamesMap[name] || name;

});
parcelRegister("7UxjA", function(module, exports) {

$parcel$export(module.exports, "useProjectKeyByProjectResource", () => $e8cc67911de41710$export$899fd1c46031ece8);

var $gYnSx = parcelRequire("gYnSx");

var $eJrcF = parcelRequire("eJrcF");

var $dZRaT = parcelRequire("dZRaT");
const $e8cc67911de41710$export$899fd1c46031ece8 = (teamName)=>{
    const { data: data, error: resourceError, loading: loading } = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    if (resourceError && data == null) {
        const isErrorErrorType = resourceError instanceof Error;
        const error = isErrorErrorType ? resourceError : new Error(`projectContextResource returned error resourceError: ${JSON.stringify(resourceError)}, loading: ${loading}, data: null`);
        (0, $gYnSx.default)({
            meta: {
                id: 'useResourceProjectContext',
                packageName: 'jiraRouterResourcesProjectContext',
                teamName: teamName ?? 'magma'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            loading: false,
            error: error,
            projectKey: null
        };
    }
    if (loading) return {
        loading: true,
        error: null,
        projectKey: null
    };
    // This case never happens by type definition, which you can't even mock test data for this case due to type definition. But if you don't check this, TS is not happy
    if (data == null) return {
        loading: false,
        error: new Error('projectContextResource returned data=null when loading false'),
        projectKey: null
    };
    return {
        loading: false,
        projectKey: data.projectKey,
        error: null
    };
};

});



parcelRegister("6hSMD", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteRouteEntry", () => $d3f4428503596633$export$781dd53d465d270d);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $7YSdU = parcelRequire("7YSdU");

var $8FCAy = parcelRequire("8FCAy");

var $bMm2d = parcelRequire("bMm2d");
const $d3f4428503596633$export$781dd53d465d270d = (0, $6xToB.createEntry)((0, $7YSdU.legacyProjectReleasesNoteRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        component: (0, $bMm2d.LegacyFrontendReleaseNoteRedirect),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("7YSdU", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteRoute", () => $99e8f8dd4db60f2d$export$6ef734887b6da0c8);
const $99e8f8dd4db60f2d$export$6ef734887b6da0c8 = {
    name: 'legacy-project-releases-note',
    path: '/jira/secure/ReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});


parcelRegister("bWZUz", function(module, exports) {

$parcel$export(module.exports, "legacyRapidBoardRouteEntry", () => $78370a65b7fbd64d$export$4a5b9e48e40676ad);

var $kHlOR = parcelRequire("kHlOR");


var $1wb5r = parcelRequire("1wb5r");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $alzbz = parcelRequire("alzbz");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $f7JE2 = parcelRequire("f7JE2");

var $kbZYB = parcelRequire("kbZYB");

var $zNGiI = parcelRequire("zNGiI");

var $hS1gr = parcelRequire("hS1gr");
const $78370a65b7fbd64d$export$4a5b9e48e40676ad = (0, $6xToB.createEntry)((0, $f7JE2.legacyRapidBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        component: (0, $kbZYB.RapidBoardSpaPage),
        skeleton: (0, $zNGiI.ClassicBoardSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kbZYB.LazyRapidBoard),
            (0, $kbZYB.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $652f5f63189f3e2a$export$fc5f182fc9019b1c)
        },
        earlyAssets: (0, $1wb5r.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true
    }));

});
parcelRegister("f7JE2", function(module, exports) {

$parcel$export(module.exports, "legacyRapidBoardRoute", () => $dea8f890c4b8c242$export$2bc0c59cefa2bd5e);
const $dea8f890c4b8c242$export$2bc0c59cefa2bd5e = {
    name: 'rapidboard-board',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView'
    ],
    __unsafeOrder: -1
};

});


parcelRegister("ihfrS", function(module, exports) {

$parcel$export(module.exports, "legacyRedirectRouteEntry", () => $e033d289cffb5bf4$export$27f123cb9320355);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $bSgdP = parcelRequire("bSgdP");

var $7Z2hn = parcelRequire("7Z2hn");
// @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': query, location, route, match, action
const $e033d289cffb5bf4$var$RedirectComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z2hn.default), null);
const $e033d289cffb5bf4$export$27f123cb9320355 = (0, $6xToB.createEntry)((0, $bSgdP.legacyRedirectRoute), ()=>({
        component: $e033d289cffb5bf4$var$RedirectComponent,
        layout: (0, $7h3uc.globalLayout),
        resources: [],
        isRedirect: true,
        canTransitionIn: ()=>false,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("bSgdP", function(module, exports) {

$parcel$export(module.exports, "legacyRedirectRoute", () => $7bcdedfe9f3abeaa$export$176ff76c3ba7c4ce);
const $7bcdedfe9f3abeaa$export$176ff76c3ba7c4ce = {
    path: '',
    name: 'legacy-redirect',
    exact: false
};

});


parcelRegister("kMe3w", function(module, exports) {

$parcel$export(module.exports, "listRouteEntry", () => $a937d5a79902b10c$export$4425668b2cd90292);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $gwH93 = parcelRequire("gwH93");

var $94VAY = parcelRequire("94VAY");

var $aQoXd = parcelRequire("aQoXd");

var $7jTnu = parcelRequire("7jTnu");

var $g8uYY = parcelRequire("g8uYY");

var $c5Vjm = parcelRequire("c5Vjm");

var $5FSZM = parcelRequire("5FSZM");

var $1PvPk = parcelRequire("1PvPk");

var $dZRaT = parcelRequire("dZRaT");

var $4VIcO = parcelRequire("4VIcO");

var $qJGcC = parcelRequire("qJGcC");

var $c0h8V = parcelRequire("c0h8V");
const $a937d5a79902b10c$var$entryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $c5Vjm.listEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $qJGcC.horizontalNavViewEntrypoint)
});
const $a937d5a79902b10c$export$4425668b2cd90292 = (0, $6xToB.createEntry)((0, $94VAY.listRoute), ()=>({
        group: 'servicedesk',
        component: (0, $9BJU1.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        entryPoint: ()=>{
            if (!(0, $7jTnu.fg)('jsm_list_view_milestone_1')) return undefined;
            return $a937d5a79902b10c$var$entryPoint;
        },
        skeleton: (0, $gwH93.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $5FSZM.getCalendarFilterFieldsResource)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $dZRaT.projectContextResource),
            (0, $c0h8V.uifBoardResource)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("94VAY", function(module, exports) {

$parcel$export(module.exports, "listRoute", () => $b1e843f6fd0b635c$export$5cf62dc131f4fd3d);
const $b1e843f6fd0b635c$export$5cf62dc131f4fd3d = {
    name: 'servicedesk-list',
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/list',
    exact: true
};

});

parcelRegister("c5Vjm", function(module, exports) {

$parcel$export(module.exports, "listEntryPoint", () => $dc5aa59c51159067$export$6be4f10150ff6073);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

var $7RF8n = parcelRequire("7RF8n");

const $dc5aa59c51159067$export$6be4f10150ff6073 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("fJIw8")), {
        moduleId: "17fdc298",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId } })=>{
        const boardId = match.params.boardId;
        const boardAri = `ari:cloud:jira-software:${cloudId}:board/${boardId}`;
        const projectKey = match.params.projectKey ?? '';
        const issueSearchInput = {
            customInput: {
                jiraSoftwareInput: {
                    jiraEntityId: boardAri,
                    additionalJql: ''
                }
            }
        };
        const defaultProps = {
            first: 50,
            last: null,
            before: null,
            after: null,
            options: {
                issueKey: null
            },
            viewConfigInput: {
                staticViewInput: {
                    isHierarchyEnabled: false,
                    isGroupingEnabled: false,
                    isHideDoneEnabled: false
                }
            },
            filterId: null,
            // namespace: 'JSM_ISSUE_NAVIGATOR',
            namespace: 'ISSUE_NAVIGATOR',
            amountOfColumns: 500,
            groupBy: null,
            viewQueryInput: null,
            shouldQueryHasChildren: false,
            fieldSetsInput: {
                viewInput: {
                    // TODO: Update once JSM is supported
                    // namespace: 'JSM_ISSUE_NAVIGATOR',
                    namespace: 'ISSUE_NAVIGATOR',
                    filterId: null
                }
            },
            scope: {
                // TODO: Update once JSM is supported
                operationScope: 'NIN_PROJECT',
                projectKey: projectKey
            }
        };
        return {
            queries: {
                jsmListDataQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $7RF8n.default,
                    variables: {
                        cloudId: cloudId,
                        issueSearchInput: issueSearchInput,
                        projectKey: projectKey,
                        ...defaultProps
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                projectKey: projectKey,
                issueSearchInput: issueSearchInput,
                defaultProps: defaultProps
            }
        };
    }
});

});
parcelRegister("7RF8n", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f93f0525f67d2cb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d641bfb0823a1fc3f5c78dea20b6d44>>
 * @relayHash a5d55f28e716fbd53b44fe182a41e576
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7726639e5c94c51412e3a36f2446c58750d377382ee8fe9c8d207fa6cd5f61f6

var $kZq2R = parcelRequire("kZq2R");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $hRj2m = parcelRequire("hRj2m");

var $2HLoK = parcelRequire("2HLoK");

var $bU8Sj = parcelRequire("bU8Sj");

var $clCUA = parcelRequire("clCUA");

var $8Qoc7 = parcelRequire("8Qoc7");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");

var $7lcgt = parcelRequire("7lcgt");

var $iOvkB = parcelRequire("iOvkB");
const $3f93f0525f67d2cb$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7726639e5c94c51412e3a36f2446c58750d377382ee8fe9c8d207fa6cd5f61f6",
        "metadata": {},
        "name": "uiJsmListQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $7lcgt.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": (0, $clCUA.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default)
        }
    }
};
var $3f93f0525f67d2cb$export$2e2bcd8739ae039 = $3f93f0525f67d2cb$var$node;

});

parcelRegister("fJIw8", function(module, exports) {

let $b74d9736f51c8ad6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $b74d9736f51c8ad6$var$load("1VRB2"),
    $b74d9736f51c8ad6$var$load("bABhq"),
    $b74d9736f51c8ad6$var$load("eDzss"),
    $b74d9736f51c8ad6$var$load("jCitY")
]).then(()=>parcelRequire('aBVDs'));

});


parcelRegister("qJGcC", function(module, exports) {

$parcel$export(module.exports, "horizontalNavViewEntrypoint", () => $1d234487fc217b81$export$47416ecfbb1a428a);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $1d234487fc217b81$export$47416ecfbb1a428a = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("04Ncj")), {
        moduleId: "73476d22",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("id9nd", function(module, exports) {

$parcel$export(module.exports, "loginEmbedRouteEntry", () => $e2bffff88fa509ad$export$faa46f8c5e1f06d3);

var $eJOHy = parcelRequire("eJOHy");

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $dJ4f6 = parcelRequire("dJ4f6");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $e2bffff88fa509ad$var$LazyLoginEmbed = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("hqiuH")), {
    moduleId: "./src/packages/spa-apps/login-embed/src/index.tsx"
});
const $e2bffff88fa509ad$var$LoginEmbed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e2bffff88fa509ad$var$LazyLoginEmbed,
        pageId: "spa-apps/login-embed",
        shouldShowSpinner: true
    });
const $e2bffff88fa509ad$export$faa46f8c5e1f06d3 = (0, $6xToB.createEntry)((0, $dJ4f6.loginEmbedRoute), ()=>({
        group: 'errors',
        component: $e2bffff88fa509ad$var$LoginEmbed,
        layout: (0, $7K5Ea.chromelessLayout)
    }));

});
parcelRegister("dJ4f6", function(module, exports) {

$parcel$export(module.exports, "loginEmbedRoute", () => $77eb0ed0591acbf9$export$9efae7a8e8e69866);
const $77eb0ed0591acbf9$export$9efae7a8e8e69866 = {
    name: 'login-embed',
    path: '/jira-login/embed'
};

});

parcelRegister("hqiuH", function(module, exports) {

let $caf335f038f53ca0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $caf335f038f53ca0$var$load("d7SF2").then(()=>parcelRequire('3ANMU'));

});


parcelRegister("7K8ER", function(module, exports) {

$parcel$export(module.exports, "manageProjectsDirectoryRouteEntry", () => $f8f2552c542728ef$export$d5b1a46987369ee4);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $vJYlr = parcelRequire("vJYlr");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1Gd8G = parcelRequire("1Gd8G");

var $iMFdk = parcelRequire("iMFdk");

var $1F9cm = parcelRequire("1F9cm");

var $9MwFx = parcelRequire("9MwFx");

var $4qnr5 = parcelRequire("4qnr5");

var $5TrFe = parcelRequire("5TrFe");
const $f8f2552c542728ef$var$LazyAdminProjectsDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4qnr5.LazyProjectsDirectory), {
        isAdminProjectDirectoryRoute: true
    });
const $f8f2552c542728ef$var$ProjectsDirectoryManageComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f8f2552c542728ef$var$LazyAdminProjectsDirectory,
        pageId: "projects-directory-manage-v3",
        shouldShowSpinner: false
    });
const $f8f2552c542728ef$export$d5b1a46987369ee4 = (0, $6xToB.createEntry)((0, $1Gd8G.manageProjectsDirectoryRoute), ()=>({
        group: 'directories',
        component: $f8f2552c542728ef$var$ProjectsDirectoryManageComponent,
        skeleton: (0, $iMFdk.ProjectsDirectorySkeleton),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            sidebar: (0, $vJYlr.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9MwFx.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4qnr5.LazyProjectsDirectory)
        ],
        ufoName: 'projects-directory-v3-manage',
        entryPoint () {
            return 0, $5TrFe.ProjectsDirectoryPageEntryPoint;
        }
    }));

});
parcelRegister("1Gd8G", function(module, exports) {

$parcel$export(module.exports, "manageProjectsDirectoryRoute", () => $22077b66f868a2f0$export$281a4490a0f8fb4c);
const $22077b66f868a2f0$export$281a4490a0f8fb4c = {
    name: 'projects-directory-manage',
    path: '/jira/settings/projects/manage'
};

});

parcelRegister("9MwFx", function(module, exports) {

$parcel$export(module.exports, "adminProjectDirectoryResources", () => $6d80d73586b75892$export$1b29db6307155621);

var $enHI7 = parcelRequire("enHI7");

var $i9ujx = parcelRequire("i9ujx");
const $6d80d73586b75892$export$1b29db6307155621 = ()=>[
        (0, $enHI7.navigationSidebarGlobalResource),
        (0, $i9ujx.projectsDirectoryPageResource)
    ];

});
parcelRegister("i9ujx", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryPageResource", () => $f8e474e7e2c6d5a7$export$aabb201a7f7100c5);
/* eslint-disable jira/import-whitelist */ 
var $j4oe4 = parcelRequire("j4oe4");

var $2YWby = parcelRequire("2YWby");

var $g1iDH = parcelRequire("g1iDH");

var $7zZ4w = parcelRequire("7zZ4w");

var $7797X = parcelRequire("7797X");

var $9FYIg = parcelRequire("9FYIg");

var $3vXGP = parcelRequire("3vXGP");

var $l1VxS = parcelRequire("l1VxS");

const $f8e474e7e2c6d5a7$export$aabb201a7f7100c5 = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $9392429483f8560c$export$2150caade62dc875)}`,
    getKey: ()=>'projects-directory-relay',
    // @ts-expect-error - might return null
    getData: async ({ query: query, route: route }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should temporally disable anonymous SSR until
        // the underlying auth issues have been fixed. Duplo team will push the real fix later.
        if (false && isAnonymous) return null;
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $3vXGP.default), {
            cloudId: tenantContext.cloudId,
            filter: (0, $g1iDH.mapQueryToFilter)((0, $2YWby.filterInitialState), {
                cloudId: cloudId,
                query: (0, $g1iDH.sanitizeLegacyQuery)(query),
                aliases: (0, $2YWby.filterAliasMap)
            }),
            first: query?.page ? (0, $2YWby.DEFAULT_LIMIT) * (parseInt(query.page, 10) || 1) : (0, $2YWby.DEFAULT_LIMIT),
            last: (0, $2YWby.DEFAULT_LIMIT),
            isAdminSettingsContext: route.name === 'projects-directory-manage',
            isAnonymous: isAnonymous
        }, {
            fetchPolicy: 'network-only'
        });
        if (false && queryReference.id != null) await (0, $7797X.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    }
});

});
parcelRegister("2YWby", function(module, exports) {

$parcel$export(module.exports, "TableColumns", () => $53c967357c262cd2$export$b0e68791ad9c52df);
$parcel$export(module.exports, "SortableColumns", () => $53c967357c262cd2$export$f9e740ef44a4c43a);
$parcel$export(module.exports, "FilterFields", () => $53c967357c262cd2$export$e38c2fbdcbc20613);
$parcel$export(module.exports, "filterAliasMap", () => $53c967357c262cd2$export$5bc0ad9873e5cd89);
$parcel$export(module.exports, "filterInitialState", () => $53c967357c262cd2$export$fcb7b3e474e67781);
$parcel$export(module.exports, "DEFAULT_LIMIT", () => $53c967357c262cd2$export$ebc5ec3267fbcf57);
$parcel$export(module.exports, "PROJECTS_DIRECTORY_EXPERIENCE", () => $53c967357c262cd2$export$7c1bd7128901e2c4);
$parcel$export(module.exports, "MANAGE_PROJECTS_DIRECTORY_EXPERIENCE", () => $53c967357c262cd2$export$72fb94bf1b8ec849);
// eslint-disable-next-line jira/import-whitelist

var $5W62K = parcelRequire("5W62K");
const $53c967357c262cd2$export$b0e68791ad9c52df = {
    Favourites: 'favourite',
    Key: 'key',
    Name: 'name',
    Type: 'type',
    Lead: 'lead',
    Category: 'category',
    LastIssueUpdate: 'last_issue_updated_time',
    Url: 'url',
    Action: 'actions'
};
const $53c967357c262cd2$export$f9e740ef44a4c43a = [
    $53c967357c262cd2$export$b0e68791ad9c52df.Favourites,
    $53c967357c262cd2$export$b0e68791ad9c52df.Key,
    $53c967357c262cd2$export$b0e68791ad9c52df.Name,
    $53c967357c262cd2$export$b0e68791ad9c52df.Lead,
    $53c967357c262cd2$export$b0e68791ad9c52df.Category,
    $53c967357c262cd2$export$b0e68791ad9c52df.LastIssueUpdate
];
const $53c967357c262cd2$export$e38c2fbdcbc20613 = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectTypeLabel: 'ProjectTypeLabel',
    ProjectCategoryId: 'projectCategoryId',
    ProjectCategoryLabel: 'projectCategoryLabel',
    ...(0, $5W62K.DefaultFilterFields)
};
const $53c967357c262cd2$export$5bc0ad9873e5cd89 = {
    contains: $53c967357c262cd2$export$e38c2fbdcbc20613.Keyword,
    selectedProjectType: $53c967357c262cd2$export$e38c2fbdcbc20613.ProjectType,
    selectedCategory: $53c967357c262cd2$export$e38c2fbdcbc20613.ProjectCategoryId
};
const $53c967357c262cd2$export$fcb7b3e474e67781 = {
    [$53c967357c262cd2$export$e38c2fbdcbc20613.Keyword]: '',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.ProjectType]: '',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.ProjectTypeLabel]: '',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.ProjectCategoryId]: '',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.ProjectCategoryLabel]: '',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.SortOrder]: 'ASC',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.SortKey]: $53c967357c262cd2$export$b0e68791ad9c52df.Name,
    [$53c967357c262cd2$export$e38c2fbdcbc20613.Page]: '1'
};
const $53c967357c262cd2$export$ebc5ec3267fbcf57 = 25;
const $53c967357c262cd2$export$7c1bd7128901e2c4 = 'viewProjectsDirectoryV3';
const $53c967357c262cd2$export$72fb94bf1b8ec849 = 'viewManageProjectsDirectoryV3';

});
parcelRegister("5W62K", function(module, exports) {

$parcel$export(module.exports, "DefaultFilterFields", () => $197bcec067979fbc$export$7ecdd4b6ae40e139);
$parcel$export(module.exports, "createUseFilter", () => $197bcec067979fbc$export$ef79d9c1dcb09f8f);

var $b5RwB = parcelRequire("b5RwB");

var $gYnSx = parcelRequire("gYnSx");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $197bcec067979fbc$export$7ecdd4b6ae40e139 = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
const $197bcec067979fbc$export$ef79d9c1dcb09f8f = (storeName, { getInitialState: getInitialState })=>{
    const actions = {
        updateFilter: (nameOrFilter, value)=>({ setState: setState, getState: getState }, { onUpdate: onUpdate })=>{
                const newFilter = typeof nameOrFilter === 'object' ? nameOrFilter : {
                    [nameOrFilter]: value
                };
                setState({
                    ...getState(),
                    [$197bcec067979fbc$export$7ecdd4b6ae40e139.Page]: 1,
                    ...newFilter
                });
                onUpdate(getState());
            },
        forceUpdate: ()=>({ getState: getState }, { onUpdate: onUpdate })=>onUpdate(getState())
    };
    const Store = (0, $GtRbT.createStore)({
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        initialState: {},
        actions: actions,
        name: storeName
    });
    const useFilter = (0, $iJq0l.createHook)(Store);
    const useScopedFilter = (0, $iJq0l.createHook)(Store, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        selector: (state, name)=>state[name]
    });
    const FilterContainer = (0, $6E16M.createContainer)(Store, {
        onInit: ()=>({ setState: setState })=>{
                try {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    const routeQuery = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(window.location.search);
                    setState(getInitialState({
                        routeQuery: routeQuery
                    }));
                } catch (error) {
                    (0, $gYnSx.default)({
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        error: error,
                        meta: {
                            id: 'createUseFilter',
                            packageName: 'jiraDirectoryBaseV3',
                            teamName: 'jira-cosmos'
                        }
                    });
                }
            },
        // reset initial state on unmount
        onCleanup: ()=>({ setState: setState })=>setState(getInitialState({
                    routeQuery: {}
                }))
    });
    return {
        useFilter: useFilter,
        useScopedFilter: useScopedFilter,
        FilterContainer: FilterContainer
    };
};

});


parcelRegister("g1iDH", function(module, exports) {

$parcel$export(module.exports, "sanitizeLegacyQuery", () => $2e20bdcb5aff1187$export$b6d5141c3209bd35);
$parcel$export(module.exports, "mapQueryToFilter", () => $2e20bdcb5aff1187$export$2274cd5f35844a96);

var $7jTnu = parcelRequire("7jTnu");

var $gtr2v = parcelRequire("gtr2v");

var $cLuhM = parcelRequire("cLuhM");

var $ln6Iy = parcelRequire("ln6Iy");

var $j8Fdp = parcelRequire("j8Fdp");

var $8oKDI = parcelRequire("8oKDI");

var $2YWby = parcelRequire("2YWby");
const $2e20bdcb5aff1187$var$LEGACY_ALL_VALUE = 'all';
const $2e20bdcb5aff1187$export$b6d5141c3209bd35 = (query)=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $2e20bdcb5aff1187$var$LEGACY_ALL_VALUE ? (0, $2YWby.filterInitialState)[(0, $2YWby.FilterFields).ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $2e20bdcb5aff1187$var$LEGACY_ALL_VALUE ? (0, $2YWby.filterInitialState)[(0, $2YWby.FilterFields).ProjectCategoryId] : query.selectedCategory
    });
const $2e20bdcb5aff1187$export$2274cd5f35844a96 = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [(0, $2YWby.FilterFields).Keyword]: keyword, [(0, $2YWby.FilterFields).ProjectCategoryId]: projectCategoryId, [(0, $2YWby.FilterFields).ProjectType]: types, [(0, $2YWby.FilterFields).SortOrder]: sortOrder, [(0, $2YWby.FilterFields).SortKey]: sortKey } = aliases && query ? (0, $j8Fdp.matchAliases)(filter, query, aliases) : filter; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) {
        const isAlreadyAri = (0, $7jTnu.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $gtr2v.AnyAri).check(projectCategoryId) : (0, $8oKDI.isAri)(projectCategoryId);
        if (isAlreadyAri) variables.projectCategoryId = projectCategoryId;
        else variables.projectCategoryId = (0, $7jTnu.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $cLuhM.JiraProjectCategoryAri).create({
            projectCategoryId: projectCategoryId,
            siteId: cloudId
        }).toString() : (0, $8oKDI.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
    }
    if (sortKey || sortOrder) {
        const sortByValue = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sortKey && (0, $2YWby.SortableColumns).includes(sortKey) ? sortKey : (0, $2YWby.filterInitialState)[(0, $2YWby.FilterFields).SortKey];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : (0, $2YWby.filterInitialState)[(0, $2YWby.FilterFields).SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    variables.types = types.split(',') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((type)=>(0, $ln6Iy.PROJECT_TYPES).includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

});
parcelRegister("cLuhM", function(module, exports) {

$parcel$export(module.exports, "JiraProjectCategoryAri", () => $94b15df57c4ec450$export$da484aad24207e3d);

var $2Q5Wf = parcelRequire("2Q5Wf");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/project-category/manifest.ts
var $94b15df57c4ec450$var$jiraProjectCategoryAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $2Q5Wf.JiraProjectCategoryAriResourceOwner),
    resourceType: (0, $2Q5Wf.JiraProjectCategoryAriResourceType),
    resourceIdSlug: "{projectCategoryId}",
    resourceIdSegmentFormats: {
        projectCategoryId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/project-category/index.ts
var $94b15df57c4ec450$export$da484aad24207e3d = class _JiraProjectCategoryAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectCategoryId = opts.resourceIdSegmentValues.projectCategoryId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectCategoryId() {
        return this._projectCategoryId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $94b15df57c4ec450$var$jiraProjectCategoryAriStaticOpts.qualifier,
            platformQualifier: $94b15df57c4ec450$var$jiraProjectCategoryAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $94b15df57c4ec450$var$jiraProjectCategoryAriStaticOpts.resourceOwner,
            resourceType: $94b15df57c4ec450$var$jiraProjectCategoryAriStaticOpts.resourceType,
            resourceId: `${opts.projectCategoryId}`,
            resourceIdSegmentValues: {
                projectCategoryId: opts.projectCategoryId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $94b15df57c4ec450$var$jiraProjectCategoryAriStaticOpts);
        return new _JiraProjectCategoryAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $94b15df57c4ec450$var$jiraProjectCategoryAriStaticOpts);
        return new _JiraProjectCategoryAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectCategoryId: this.projectCategoryId
        };
    }
};

});
parcelRegister("2Q5Wf", function(module, exports) {

$parcel$export(module.exports, "JiraProjectCategoryAriResourceOwner", () => $21150b6225c297d5$export$b4df372413a623f1);
$parcel$export(module.exports, "JiraProjectCategoryAriResourceType", () => $21150b6225c297d5$export$51b6f2a645c9e23a);
// src/jira/project-category/types.ts
var $21150b6225c297d5$export$b4df372413a623f1 = "jira", $21150b6225c297d5$export$51b6f2a645c9e23a = "project-category";

});


parcelRegister("j8Fdp", function(module, exports) {

$parcel$export(module.exports, "matchAliases", () => $660773f2835b6ff4$export$55f686d7a3507dbe);
$parcel$export(module.exports, "serializeSelectOptions", () => $660773f2835b6ff4$export$74a705e0bee1565b);
$parcel$export(module.exports, "serializeSelectOptionsLabel", () => $660773f2835b6ff4$export$eed751fcc55ddadd);
$parcel$export(module.exports, "matchValueToSelectOptions", () => $660773f2835b6ff4$export$17e142fa55464467);

var $2IQEX = parcelRequire("2IQEX");

var $8V8so = parcelRequire("8V8so");
const $660773f2835b6ff4$export$55f686d7a3507dbe = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $660773f2835b6ff4$export$40bf1812f0f07002 = (data, aliases)=>{
    const invertedAliases = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))(aliases);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8V8so)))(data, (_, key)=>invertedAliases[key] || key);
};
const $660773f2835b6ff4$export$74a705e0bee1565b = (options)=>options.map((v)=>v.value).join(',');
const $660773f2835b6ff4$export$eed751fcc55ddadd = (options)=>options.map((v)=>v.label).join(',');
const $660773f2835b6ff4$export$17e142fa55464467 = (value, options)=>value ? value.split(',').map((val)=>options.find((option)=>option.value === val)).filter(Boolean) : [];

});
parcelRegister("2IQEX", function(module, exports) {

var $9hKkF = parcelRequire("9hKkF");

var $h3TKx = parcelRequire("h3TKx");

var $d7YnM = parcelRequire("d7YnM");
/** Used for built-in method references. */ var $1fb889f558f23ac4$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1fb889f558f23ac4$var$nativeObjectToString = $1fb889f558f23ac4$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $1fb889f558f23ac4$var$invert = $h3TKx(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $1fb889f558f23ac4$var$nativeObjectToString.call(value);
    result[value] = key;
}, $9hKkF($d7YnM));
module.exports = $1fb889f558f23ac4$var$invert;

});
parcelRegister("h3TKx", function(module, exports) {

var $8uipj = parcelRequire("8uipj");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $c6bdf63192b21f8e$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $8uipj(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $c6bdf63192b21f8e$var$createInverter;

});
parcelRegister("8uipj", function(module, exports) {

var $75Jcs = parcelRequire("75Jcs");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $62df67589f85c449$var$baseInverter(object, setter, iteratee, accumulator) {
    $75Jcs(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $62df67589f85c449$var$baseInverter;

});



parcelRegister("8V8so", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $67ea34f606cb6857$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $67ea34f606cb6857$var$mapKeys;

});



parcelRegister("3vXGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $669d1847076c173f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1560f9790f71d21c908961f144df0b6a>>
 * @relayHash aac7213d2b277a963b74ea3348e418cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f11ab13ef9b27d64ab8116ae5ee95523773b35e7857255faa8484bbc509d8863

var $jhhgp = parcelRequire("jhhgp");

var $37Ewn = parcelRequire("37Ewn");
const $669d1847076c173f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAdminSettingsContext"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "isAnonymous",
            "variableName": "isAnonymous"
        }
    ], v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = {
        "alias": "canBrowseProjects",
        "args": [
            v7 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "type",
                "value": "BROWSE_PROJECTS"
            }
        ],
        "concreteType": "JiraPermission",
        "kind": "LinkedField",
        "name": "permission",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasPermission"
            }
        ]
    }, v9 = [
        v7 /*: any*/ 
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v17 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "header_projectsDirectoryV3"
                },
                {
                    "args": v6 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "refinementBar_projectsDirectoryV3_Filters"
                },
                {
                    "args": v6 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "projectsList_projectsDirectoryV3_rootQueryRef"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isAdminSettingsContext",
                            "variableName": "isAdminSettingsContext"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "pageLayout_projectsDirectoryV3_ProjectDirectoryLayout"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "emptyView_projectsDirectoryV3"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "noPermissionViews_projectsDirectoryV3"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "filter",
                                    "variableName": "filter"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "last",
                                    "variableName": "last"
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "canViewIssue",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                                                },
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteValue",
                                                    "kind": "LinkedField",
                                                    "name": "favouriteValue",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                v15 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "medium"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "navigationMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardId"
                                                                },
                                                                v11 /*: any*/ 
                                                            ],
                                                            "type": "JiraSoftwareProjectNavigationMetadata"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lead",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isUser"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectUrl"
                                                },
                                                {
                                                    "alias": "canViewProjectConfig",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "alias": "jiraProjectType",
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "alias": "jiraProjectName",
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "condition": "isAdminSettingsContext",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "lastUpdatedToolTipDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "COMPLETE_DATETIME_FORMAT"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                                                        },
                                                        {
                                                            "alias": "lastUpdatedDisplayDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "RELATIVE"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHasTotal"
                                }
                            ]
                        },
                        {
                            "alias": "canContactAdmin",
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": "jira.show.contact.administrators.form"
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        v8 /*: any*/ ,
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "shouldDisplay",
                                    "args": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "VIEW_PROJECT_CREATION_ENTRY"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        },
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectListRightPanelState"
                                        },
                                        v14 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "sidebarExperimentTemplates",
                                    "args": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "experimentKey",
                                            "value": "sidebarExperiment"
                                        }
                                    ],
                                    "concreteType": "JiraProjectListViewTemplateConnection",
                                    "kind": "LinkedField",
                                    "name": "projectListViewTemplates",
                                    "plural": false,
                                    "selections": [
                                        v17 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v16 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraProjectTypeDetailsConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjectTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectTypeDetailsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectTypeDetails",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f11ab13ef9b27d64ab8116ae5ee95523773b35e7857255faa8484bbc509d8863",
            "metadata": {},
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $jhhgp.default)
            }
        }
    };
}();
$669d1847076c173f$var$node.hash = "0383d6b00b0ae0222d704297e4fe4e64";
(0, $37Ewn.PreloadableQueryRegistry).set($669d1847076c173f$var$node.params.id, $669d1847076c173f$var$node);
var $669d1847076c173f$export$2e2bcd8739ae039 = $669d1847076c173f$var$node;

});

const $9392429483f8560c$export$2150caade62dc875 = 'PROJECTS_DIRECTORY_RELAY';



parcelRegister("4qnr5", function(module, exports) {

$parcel$export(module.exports, "LazyProjectsDirectory", () => $b25739e0d466197b$export$f9ee24127b8e4a7f);

var $2dJFW = parcelRequire("2dJFW");

var $gzcjr = parcelRequire("gzcjr");

const $b25739e0d466197b$export$f9ee24127b8e4a7f = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fKB3J"))), {
    moduleId: "./src/packages/spa-apps/directories/projects-v3/src/index.tsx"
});

});
parcelRegister("fKB3J", function(module, exports) {

let $b777e60df9b06bd3$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $b777e60df9b06bd3$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $b777e60df9b06bd3$var$load("deNlq")
        ]);
    }),
    $b777e60df9b06bd3$var$load("94FEM")
]).then(()=>parcelRequire('afSyV'));

});


parcelRegister("5TrFe", function(module, exports) {

$parcel$export(module.exports, "ProjectsDirectoryPageEntryPoint", () => $c4ec07c725b3a5c2$export$f4985310f86f98fc);

var $g8uYY = parcelRequire("g8uYY");

var $2Gh1T = parcelRequire("2Gh1T");

var $5RW99 = parcelRequire("5RW99");

var $4EA1U = parcelRequire("4EA1U");

var $9waEc = parcelRequire("9waEc");
const $c4ec07c725b3a5c2$export$f4985310f86f98fc = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $4EA1U.projectsDirectoryEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    rightSidebar: (0, $2Gh1T.RecommendationsInProjectListEntryPoint),
    rightSidebarFallback: (0, $9waEc.ProjectListSidebarSkeleton)
});

});
parcelRegister("2Gh1T", function(module, exports) {

$parcel$export(module.exports, "RecommendationsInProjectListEntryPoint", () => $264c69dab599d479$export$8baad7954c0e6b8c);

var $1GcZ0 = parcelRequire("1GcZ0");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $7jTnu = parcelRequire("7jTnu");

const $264c69dab599d479$export$8baad7954c0e6b8c = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("ckW4g")), {
        moduleId: "3a12ca77",
        priority: "userVisible"
    }),
    getPreloadProps: (extraProps)=>({
            extraProps: extraProps,
            queries: {
                templatesQueryRef: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $1GcZ0.default,
                    variables: {
                        cloudId: extraProps.tenantContext.cloudId,
                        isAnonymous: extraProps.tenantContext.isAnonymous,
                        isAllowingEndUsersToAccessCustomTemplates: (0, $7jTnu.fg)('allow_end_users_to_access_custom_templates')
                    }
                }
            }
        })
});

});
parcelRegister("1GcZ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6882e399275810aa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e5a932507584148c7318fad8cc2050fb>>
 * @relayHash dbb4fc405135e8a7a440f4a278aa8a4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ecb9c81810aa1fdab2dc5cd2d7a7132b51641fefbf041b495af8e5a823b8d51
const $6882e399275810aa$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5ecb9c81810aa1fdab2dc5cd2d7a7132b51641fefbf041b495af8e5a823b8d51",
        "metadata": {},
        "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6882e399275810aa$export$2e2bcd8739ae039 = $6882e399275810aa$var$node;

});

parcelRegister("ckW4g", function(module, exports) {

let $8fb4655952ecedbd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8fb4655952ecedbd$var$load("el4YK").then(()=>parcelRequire('i5FAK'));

});


parcelRegister("4EA1U", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryEntryPoint", () => $65dfc8578404e2bf$export$80225215a10b2688);

var $7jTnu = parcelRequire("7jTnu");

var $gtr2v = parcelRequire("gtr2v");

var $cLuhM = parcelRequire("cLuhM");

var $8oKDI = parcelRequire("8oKDI");

var $lt3IR = parcelRequire("lt3IR");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");
const $65dfc8578404e2bf$var$DEFAULT_LIMIT = 25;
const $65dfc8578404e2bf$var$PROJECTS_DIRECTORY_MANAGE = 'projects-directory-manage';
const $65dfc8578404e2bf$var$DefaultFilterFields = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $65dfc8578404e2bf$var$TableColumns = /*#__PURE__*/ function(TableColumns) {
    TableColumns["Favourites"] = "favourites";
    TableColumns["Key"] = "key";
    TableColumns["Name"] = "name";
    TableColumns["Type"] = "type";
    TableColumns["Lead"] = "lead";
    TableColumns["Category"] = "category";
    TableColumns["LastIssueUpdate"] = "last_issue_updated_time";
    TableColumns["Url"] = "url";
    TableColumns["Action"] = "actions";
    return TableColumns;
}($65dfc8578404e2bf$var$TableColumns || {});
const $65dfc8578404e2bf$var$SortableColumns = [
    "key",
    "name",
    "lead",
    "category",
    "last_issue_updated_time"
];
const $65dfc8578404e2bf$var$FilterFields = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectCategoryId: 'projectCategoryId',
    ...$65dfc8578404e2bf$var$DefaultFilterFields
};
const $65dfc8578404e2bf$var$filterAliasMap = {
    contains: $65dfc8578404e2bf$var$FilterFields.Keyword,
    selectedProjectType: $65dfc8578404e2bf$var$FilterFields.ProjectType,
    selectedCategory: $65dfc8578404e2bf$var$FilterFields.ProjectCategoryId
};
const $65dfc8578404e2bf$var$filterInitialState = {
    [$65dfc8578404e2bf$var$FilterFields.Keyword]: '',
    [$65dfc8578404e2bf$var$FilterFields.ProjectType]: '',
    [$65dfc8578404e2bf$var$FilterFields.ProjectCategoryId]: '',
    [$65dfc8578404e2bf$var$FilterFields.SortOrder]: 'ASC',
    [$65dfc8578404e2bf$var$FilterFields.SortKey]: "name",
    [$65dfc8578404e2bf$var$FilterFields.Page]: '1'
};
const $65dfc8578404e2bf$var$LEGACY_ALL_VALUE = 'all';
const $65dfc8578404e2bf$var$sanitizeLegacyQuery = (query = {})=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $65dfc8578404e2bf$var$LEGACY_ALL_VALUE ? $65dfc8578404e2bf$var$filterInitialState[$65dfc8578404e2bf$var$FilterFields.ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $65dfc8578404e2bf$var$LEGACY_ALL_VALUE ? $65dfc8578404e2bf$var$filterInitialState[$65dfc8578404e2bf$var$FilterFields.ProjectCategoryId] : query.selectedCategory
    });
const $65dfc8578404e2bf$var$matchAliases = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $65dfc8578404e2bf$var$CORE_PROJECT = 'business';
const $65dfc8578404e2bf$var$SOFTWARE_PROJECT = 'software';
const $65dfc8578404e2bf$var$SERVICE_DESK_PROJECT = 'service_desk';
const $65dfc8578404e2bf$var$PRODUCT_DISCOVERY_PROJECT = 'product_discovery';
const $65dfc8578404e2bf$var$PROJECT_TYPES = [
    $65dfc8578404e2bf$var$CORE_PROJECT,
    $65dfc8578404e2bf$var$SOFTWARE_PROJECT,
    $65dfc8578404e2bf$var$SERVICE_DESK_PROJECT,
    $65dfc8578404e2bf$var$PRODUCT_DISCOVERY_PROJECT
];
const $65dfc8578404e2bf$var$mapQueryToFilter = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [$65dfc8578404e2bf$var$FilterFields.Keyword]: keyword, [$65dfc8578404e2bf$var$FilterFields.ProjectCategoryId]: projectCategoryId, [$65dfc8578404e2bf$var$FilterFields.ProjectType]: types, [$65dfc8578404e2bf$var$FilterFields.SortOrder]: sortOrder, [$65dfc8578404e2bf$var$FilterFields.SortKey]: sortKey } = aliases && query ? $65dfc8578404e2bf$var$matchAliases(filter, query, aliases) : filter;
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) {
        const isAlreadyAri = (0, $7jTnu.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $gtr2v.AnyAri).check(projectCategoryId) : (0, $8oKDI.isAri)(projectCategoryId);
        if (isAlreadyAri) variables.projectCategoryId = projectCategoryId;
        else variables.projectCategoryId = (0, $7jTnu.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $cLuhM.JiraProjectCategoryAri).create({
            projectCategoryId: projectCategoryId,
            siteId: cloudId
        }).toString() : (0, $8oKDI.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
    }
    if (sortKey || sortOrder) {
        const sortByValue = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sortKey && $65dfc8578404e2bf$var$SortableColumns.includes(sortKey) ? sortKey : $65dfc8578404e2bf$var$filterInitialState[$65dfc8578404e2bf$var$FilterFields.SortKey];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : $65dfc8578404e2bf$var$filterInitialState[$65dfc8578404e2bf$var$FilterFields.SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    variables.types = types.split(',') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((type)=>$65dfc8578404e2bf$var$PROJECT_TYPES.includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

const $65dfc8578404e2bf$export$80225215a10b2688 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("kt3de")), {
        moduleId: "b77224b3",
        priority: "userVisible"
    }),
    getPreloadProps ({ context: { query: query, route: route }, tenantContext: tenantContext }) {
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        const extraProps = {
            isAdminProjectDirectoryRoute: route.name === $65dfc8578404e2bf$var$PROJECTS_DIRECTORY_MANAGE
        };
        if (false && isAnonymous) return {
            extraProps: extraProps
        };
        return {
            queries: {
                projectsDirectoryPage: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: (0, $lt3IR.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        filter: $65dfc8578404e2bf$var$mapQueryToFilter($65dfc8578404e2bf$var$filterInitialState, {
                            cloudId: cloudId,
                            query: $65dfc8578404e2bf$var$sanitizeLegacyQuery(query),
                            aliases: $65dfc8578404e2bf$var$filterAliasMap
                        }),
                        first: query?.page ? $65dfc8578404e2bf$var$DEFAULT_LIMIT * (parseInt(query.page, 10) || 1) : $65dfc8578404e2bf$var$DEFAULT_LIMIT,
                        last: $65dfc8578404e2bf$var$DEFAULT_LIMIT,
                        isAdminSettingsContext: route.name === $65dfc8578404e2bf$var$PROJECTS_DIRECTORY_MANAGE,
                        isAnonymous: isAnonymous
                    }
                }
            },
            extraProps: extraProps
        };
    }
});

});
parcelRegister("lt3IR", function(module, exports) {

$parcel$export(module.exports, "default", () => $73cc8d2737601446$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b746e9fdd3fabe08f142a7ce288063a9>>
 * @relayHash aac7213d2b277a963b74ea3348e418cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f11ab13ef9b27d64ab8116ae5ee95523773b35e7857255faa8484bbc509d8863

var $jhhgp = parcelRequire("jhhgp");
const $73cc8d2737601446$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f11ab13ef9b27d64ab8116ae5ee95523773b35e7857255faa8484bbc509d8863",
        "metadata": {},
        "name": "pageLayout_projectsDirectoryLayout_RootQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $jhhgp.default)
        }
    }
};
var $73cc8d2737601446$export$2e2bcd8739ae039 = $73cc8d2737601446$var$node;

});

parcelRegister("kt3de", function(module, exports) {

let $ee6901fcf77fc5b9$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ee6901fcf77fc5b9$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $ee6901fcf77fc5b9$var$load("deNlq")
        ]);
    }),
    $ee6901fcf77fc5b9$var$load("54KmP")
]).then(()=>parcelRequire('1bh7m'));

});


parcelRegister("9waEc", function(module, exports) {

$parcel$export(module.exports, "ProjectListSidebarSkeleton", () => $84327a5516097b11$export$808c25bcc6102427);
/* ProjectListSidebarSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $9e86l = parcelRequire("9e86l");
const $84327a5516097b11$var$customCssStyles = null;
const $84327a5516097b11$var$sidebarCssStyles = null;
const $84327a5516097b11$export$808c25bcc6102427 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_4t3i1osq _1bsb1gwv _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _t6vdt94y _1p3lnqa1 _5wramuej _bfhkvuon _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9e86l))),
        className: (0, $hcewu.default)([
            "_t6vdidpf _hr4jidpf"
        ])
    }));

});
parcelRegister("9e86l", function(module, exports) {
module.exports = new URL("project-list-sidebar-app-skeleton.tpl.35da4e26.svg", import.meta.url).toString();

});




parcelRegister("bIDIn", function(module, exports) {

$parcel$export(module.exports, "newRovoSearchRouteEntry", () => $316a3a3609d5a1b2$export$33531d48a743e2a6);

var $eJOHy = parcelRequire("eJOHy");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $6nUEc = parcelRequire("6nUEc");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $316a3a3609d5a1b2$var$LazyRovoSearchPage = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7z6UH"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/rovo-search/src/index.tsx"
});
const $316a3a3609d5a1b2$var$RovoSearchPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $316a3a3609d5a1b2$var$LazyRovoSearchPage,
        pageId: "rovo-search",
        shouldShowSpinner: false
    });
const $316a3a3609d5a1b2$export$33531d48a743e2a6 = (0, $6xToB.createEntry)((0, $6nUEc.newRovoSearchRoute), ()=>({
        group: 'search',
        component: $316a3a3609d5a1b2$var$RovoSearchPage,
        isRedirect: false,
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            $316a3a3609d5a1b2$var$LazyRovoSearchPage
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("6nUEc", function(module, exports) {

$parcel$export(module.exports, "newRovoSearchRoute", () => $4ec5a31945e81951$export$595a3e6b7223948e);
const $4ec5a31945e81951$export$595a3e6b7223948e = {
    name: 'jira-rovo-search-new',
    path: '/jira/rovo-search',
    exact: true
};

});

parcelRegister("7z6UH", function(module, exports) {

let $58212a2e594ce5f3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $58212a2e594ce5f3$var$load("1VRB2"),
    $58212a2e594ce5f3$var$load("bABhq"),
    $58212a2e594ce5f3$var$load("hwlgY"),
    $58212a2e594ce5f3$var$load("1G8UW"),
    $58212a2e594ce5f3$var$load("iSk93"),
    $58212a2e594ce5f3$var$load("eDzss"),
    $58212a2e594ce5f3$var$load("b21f6")
]).then(()=>parcelRequire('eG7sb'));

});


parcelRegister("iaJjO", function(module, exports) {

$parcel$export(module.exports, "notificationLogsRouteEntry", () => $aacecaf172ec0466$export$20ab3a955246df95);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $jodhV = parcelRequire("jodhV");

var $aQoXd = parcelRequire("aQoXd");

var $j74Q1 = parcelRequire("j74Q1");
const $aacecaf172ec0466$export$20ab3a955246df95 = (0, $6xToB.createEntry)((0, $jodhV.notificationLogsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        component: (0, $j74Q1.NotificationLogs),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $j74Q1.LazyNotificationLogs)
        ],
        perfMetricKey: 'jsm-notification-logs-component-load'
    }));

});
parcelRegister("jodhV", function(module, exports) {

$parcel$export(module.exports, "notificationLogsRoute", () => $f77455bc7881df50$export$c947c80f138bc137);
const $f77455bc7881df50$export$c947c80f138bc137 = {
    name: 'notification-logs',
    path: '/jira/servicedesk/projects/:projectKey/notification-logs',
    exact: true
};

});

parcelRegister("j74Q1", function(module, exports) {

$parcel$export(module.exports, "LazyNotificationLogs", () => $7f59ff5068e2430a$export$69cba5247233f8bc);
$parcel$export(module.exports, "NotificationLogs", () => $7f59ff5068e2430a$export$1139895a5af7252e);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $7f59ff5068e2430a$export$69cba5247233f8bc = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3T6cO"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/notification-logs/src/index.tsx"
});
const $7f59ff5068e2430a$export$1139895a5af7252e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $7f59ff5068e2430a$export$69cba5247233f8bc,
        pageId: "spa-apps/servicedesk/notification-logs",
        shouldShowSpinner: true
    });

});
parcelRegister("3T6cO", function(module, exports) {

let $2d4b527c0abb9fc3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2d4b527c0abb9fc3$var$load("1E0aZ").then(()=>parcelRequire('dAq4f'));

});



parcelRegister("flrMb", function(module, exports) {

$parcel$export(module.exports, "notificationsPersonalSettingsRouteEntry", () => $eb4c0f4709229790$export$640c1b3b96c9032e);

var $eJOHy = parcelRequire("eJOHy");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $eaZMD = parcelRequire("eaZMD");

var $bxWdr = parcelRequire("bxWdr");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $53QWl = parcelRequire("53QWl");

var $7fTjp = parcelRequire("7fTjp");

var $eb6BR = parcelRequire("eb6BR");

var $72GuB = parcelRequire("72GuB");
const $eb4c0f4709229790$var$personalSettingsNotificationsEntryPointPage = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $72GuB.personalSettingsNotificationsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).NOTIFICATIONS
});
const $eb4c0f4709229790$export$640c1b3b96c9032e = (0, $6xToB.createEntry)((0, $53QWl.notificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        skeleton: (0, $eb6BR.PersonalSettingsNotificationsAppSkeleton),
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
                to: (0, $bxWdr.getNotificationsPersonalSettingsPath)()
            }),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PROFILE,
            sidebar: (0, $eaZMD.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $hHbzj.getNavigationForgePersonalSettingsPageResources)()
        ],
        pageId: 'personal-settings-notifications',
        entryPoint () {
            return $eb4c0f4709229790$var$personalSettingsNotificationsEntryPointPage;
        }
    }));

});
parcelRegister("bxWdr", function(module, exports) {

$parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", () => $07c184ad65442c98$export$693b70d1bcef8627);
$parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $07c184ad65442c98$export$21946ea4c58fd4c9);
$parcel$export(module.exports, "DIGEST_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $07c184ad65442c98$export$cff16c3a6aa7a3a9);
$parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $07c184ad65442c98$export$2321c59d517801c8);
$parcel$export(module.exports, "getGeneralPersonalSettingsPath", () => $07c184ad65442c98$export$db9e3ccc1e5e3317);
$parcel$export(module.exports, "getNotificationsPersonalSettingsPath", () => $07c184ad65442c98$export$64a672523a583594);
$parcel$export(module.exports, "getAppsPersonalSettingsPath", () => $07c184ad65442c98$export$1a7321c4210a3049);
const $07c184ad65442c98$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
const $07c184ad65442c98$export$a974f4af282a75ba = '/jira/settings/personal';
const $07c184ad65442c98$export$693b70d1bcef8627 = `${$07c184ad65442c98$export$a974f4af282a75ba}/general`;
const $07c184ad65442c98$export$21946ea4c58fd4c9 = `${$07c184ad65442c98$export$a974f4af282a75ba}/notifications`;
const $07c184ad65442c98$export$cff16c3a6aa7a3a9 = `${$07c184ad65442c98$export$a974f4af282a75ba}/digests`;
const $07c184ad65442c98$export$1fffbb6055aa320a = `${$07c184ad65442c98$export$a974f4af282a75ba}/apps`;
const $07c184ad65442c98$export$2321c59d517801c8 = `${$07c184ad65442c98$export$a974f4af282a75ba}/alert-notifications`;
function $07c184ad65442c98$export$db9e3ccc1e5e3317() {
    return $07c184ad65442c98$export$693b70d1bcef8627;
}
function $07c184ad65442c98$export$88a45ae8c4b1c664() {
    return $07c184ad65442c98$export$2321c59d517801c8;
}
function $07c184ad65442c98$export$64a672523a583594() {
    return $07c184ad65442c98$export$21946ea4c58fd4c9;
}
function $07c184ad65442c98$export$1a7321c4210a3049() {
    return $07c184ad65442c98$export$1fffbb6055aa320a;
}

});

parcelRegister("53QWl", function(module, exports) {

$parcel$export(module.exports, "notificationsPersonalSettingsRoute", () => $0c0a4761dab0c29b$export$55ab09b9d6beb8be);
const $0c0a4761dab0c29b$export$55ab09b9d6beb8be = {
    name: 'personal-settings-notifications',
    path: '/jira/settings/personal/notifications'
};

});

parcelRegister("eb6BR", function(module, exports) {

$parcel$export(module.exports, "PersonalSettingsNotificationsAppSkeleton", () => $131ead9e22be457b$export$b542eb2d3193b983);
$parcel$export(module.exports, "PersonalSettingsNotificationsGlobalTableSkeleton", () => $131ead9e22be457b$export$d58f6bbbc1838cb2);
$parcel$export(module.exports, "ProjectNotificationAccordionSkeleton", () => $131ead9e22be457b$export$8cb773cb6fc17338);
/* PersonalSettingsNotificationsAppSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $hwuZ0 = parcelRequire("hwuZ0");

var $5U4IG = parcelRequire("5U4IG");

var $bFDfI = parcelRequire("bFDfI");

var $lODeX = parcelRequire("lODeX");

var $gQL7m = parcelRequire("gQL7m");
const $131ead9e22be457b$var$maxWidthCssStyles = null;
const $131ead9e22be457b$var$customCssStyles = null;
const $131ead9e22be457b$export$b542eb2d3193b983 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lODeX))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f8stt"
        ])
    });
const $131ead9e22be457b$export$d58f6bbbc1838cb2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($131ead9e22be457b$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5U4IG))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    }));
const $131ead9e22be457b$export$46fc11a564484c9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($131ead9e22be457b$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bFDfI))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    }));
const $131ead9e22be457b$export$8cb773cb6fc17338 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($131ead9e22be457b$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gQL7m))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $131ead9e22be457b$var$SkeletonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_c71ldgin _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5U4IG", function(module, exports) {
module.exports = new URL("global-table-skeleton-with-projects.tpl.5a5d24b9.svg", import.meta.url).toString();

});

parcelRegister("bFDfI", function(module, exports) {
module.exports = new URL("mimetype-skeleton.tpl.8b750352.svg", import.meta.url).toString();

});

parcelRegister("lODeX", function(module, exports) {
module.exports = new URL("personal-settings-notifications-app-skeleton-with-projects.tpl.d18b3c58.svg", import.meta.url).toString();

});

parcelRegister("gQL7m", function(module, exports) {
module.exports = new URL("project-accordion-skeleton.tpl.cee2df62.svg", import.meta.url).toString();

});


parcelRegister("72GuB", function(module, exports) {

$parcel$export(module.exports, "personalSettingsNotificationsEntryPoint", () => $611e3debee5346a6$export$44d710abd316d1f1);

var $cluCZ = parcelRequire("cluCZ");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $611e3debee5346a6$export$44d710abd316d1f1 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("7nIUq")), {
        moduleId: "fe0c927e",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            // Queries your async component uses
            queries: {
                pageAndProject: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $cluCZ.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context.query?.projectIds ? context.query.projectIds.split(',') : []
                    }
                }
            },
            // Optional - Anything extra you wish to pass to your component
            // Something from `EntryPointParams` for example
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});

});
parcelRegister("cluCZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b45afeef9d23fd2b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d90926d53427ea9177e55cce84d06f94>>
 * @relayHash 8df6ed3ca3de7f1679849a93c0559b51
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID de2ef332b28ff532d0a9a01b358aa15741c014c8b93ee581d3f727e11c8cab94

var $f3FK6 = parcelRequire("f3FK6");
const $b45afeef9d23fd2b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v7 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "emailChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "inProductChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "kind": "ScalarField",
            "name": "category"
        }
    ], v8 = {
        "concreteType": "JiraNotificationPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueAssigned",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueUpdated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentEdited",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueMoved",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "mentionsCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "worklogCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "miscellaneousIssueEventCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            }
        ]
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_NotificationsPageAndProjectQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraNotificationGlobalPreference",
                                    "kind": "LinkedField",
                                    "name": "notificationGlobalPreference",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTableNew"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraNotificationOptions",
                                                "kind": "LinkedField",
                                                "name": "options",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.notificationGlobalPreference.options"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.notificationGlobalPreference"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ui_NotificationsPageAndProjectQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraNotificationProjectPreferenceConnection",
                            "kind": "LinkedField",
                            "name": "allNotificationProjectPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectNotificationPreferenceEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationProjectPreferences",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "filters": [
                                "cloudId"
                            ],
                            "handle": "connection",
                            "key": "projects_allNotificationProjectPreferences",
                            "kind": "LinkedHandle",
                            "name": "allNotificationProjectPreferences"
                        },
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraNotificationGlobalPreference",
                            "kind": "LinkedField",
                            "name": "notificationGlobalPreference",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailNotificationEnabled"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleAssigneeEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleReporterEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyOwnChangesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "batchWindow"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "dailyBatchLocalTime"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "emailMimeType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailMimeTypeEditable"
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "allJiraProjectsForModal",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "notificationConfigurationState": "DEFAULT",
                                        "sortBy": {
                                            "sortBy": "NAME"
                                        }
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 5
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "de2ef332b28ff532d0a9a01b358aa15741c014c8b93ee581d3f727e11c8cab94",
            "metadata": {},
            "name": "ui_NotificationsPageAndProjectQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": (0, $f3FK6.default)
            }
        }
    };
}();
$b45afeef9d23fd2b$var$node.hash = "b001322577b49b90b0c0e44082f4b2b8";
var $b45afeef9d23fd2b$export$2e2bcd8739ae039 = $b45afeef9d23fd2b$var$node;

});
parcelRegister("f3FK6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a267137a7d680f8d$export$2e2bcd8739ae039);
var $a267137a7d680f8d$export$2e2bcd8739ae039 = {
    get () {
        return true;
    }
};

});


parcelRegister("7nIUq", function(module, exports) {

let $55fd8469ad2a28c9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $55fd8469ad2a28c9$var$load("izBQN").then(()=>parcelRequire('3f2BD'));

});



parcelRegister("10xT1", function(module, exports) {

$parcel$export(module.exports, "oldJiraHomeRouteEntry", () => $d8ae084afb2a1124$export$a9f6f4dd735b1a50);

var $dwa8t = parcelRequire("dwa8t");

var $1kys8 = parcelRequire("1kys8");

var $kHlOR = parcelRequire("kHlOR");

var $dI30d = parcelRequire("dI30d");

var $7jTnu = parcelRequire("7jTnu");

var $4ZkZK = parcelRequire("4ZkZK");

var $1RKJf = parcelRequire("1RKJf");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");


var $4VIcO = parcelRequire("4VIcO");

var $iDAU4 = parcelRequire("iDAU4");

var $80Ye8 = parcelRequire("80Ye8");

var $9NmsS = parcelRequire("9NmsS");

var $fs2Be = parcelRequire("fs2Be");

var $5fjzQ = parcelRequire("5fjzQ");

var $5L7qx = parcelRequire("5L7qx");

var $5gjY4 = parcelRequire("5gjY4");

var $epTsa = parcelRequire("epTsa");

var $2emAF = parcelRequire("2emAF");

var $bvwBX = parcelRequire("bvwBX");

var $jnds2 = parcelRequire("jnds2");

var $bzIap = parcelRequire("bzIap");
const $d8ae084afb2a1124$var$conditionalPostOfficeJiraYourWorkResource = (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('post_office_ssr_jira_your_work_enabled'), (0, $5fjzQ.postOfficeJiraYourWorkResource));
const $d8ae084afb2a1124$var$conditionalJiraHomeWorkSuggestionsIsDeveloperResource = (0, $5L7qx.resourceWithCondition2)(()=>(0, $epTsa.expVal)('jira-your-work-work-suggestions-tab-experiment', 'isEnabled', false), (0, $80Ye8.jiraHomeWorkSuggestionsIsDeveloperResource));
const $d8ae084afb2a1124$var$checkConsolidationOnRouteDependency = async (dependencies)=>{
    const data = await dependencies[0, $f8747ec2695de8a7$export$25ee35b01de9d734].promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $dI30d.checkShouldUseJSM)(data);
};
const $d8ae084afb2a1124$export$a9f6f4dd735b1a50 = (0, $6xToB.createEntry)((0, $fs2Be.oldJiraHomeRoute), ()=>({
        group: 'home',
        ufoName: 'jira-home',
        component: (0, $bzIap.ConditionalJiraHome),
        skeleton: (0, $5gjY4.YourWorkSkeleton),
        layout: (0, $1RKJf.homepageLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $iDAU4.jiraHomeResourceWithCache),
            (0, $4ZkZK.jiraHomePageRightSidePanelResource),
            $d8ae084afb2a1124$var$conditionalPostOfficeJiraYourWorkResource,
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $dwa8t.widgetResources).map((resourceCreator)=>resourceCreator($d8ae084afb2a1124$var$checkConsolidationOnRouteDependency, [
                    (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
                ])),
            ...(0, $1kys8.widgetResources).map((resourceCreator)=>(0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('your_work_page_operation_widgets_changes'), resourceCreator($d8ae084afb2a1124$var$checkConsolidationOnRouteDependency, [
                    (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
                ]))),
            $d8ae084afb2a1124$var$conditionalJiraHomeWorkSuggestionsIsDeveloperResource,
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_portal_widget'), (0, $bvwBX.fetchUserTraitsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_portal_widget'), (0, $2emAF.fetchSiteTraitsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_portal_widget'), (0, $jnds2.widgetDismissedStateResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bzIap.LazyJiraHomePage)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("bzIap", function(module, exports) {

$parcel$export(module.exports, "LazyJiraHomePage", () => $a07f43cc0d67a23c$export$72fc07b51a2e705d);
$parcel$export(module.exports, "ConditionalJiraHome", () => $a07f43cc0d67a23c$export$27e85db2fde321c7);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $1F9cm = parcelRequire("1F9cm");

var $2dJFW = parcelRequire("2dJFW");

var $gzcjr = parcelRequire("gzcjr");

var $7fTjp = parcelRequire("7fTjp");

const $a07f43cc0d67a23c$export$72fc07b51a2e705d = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("9WbN4"))), {
    moduleId: "./src/packages/spa-apps/jira-home/src/index.tsx"
});
// This component will redirect users from /jira/your-work to /jira/for-you.
// ScreenRedirect triggers a redirect ui event so we don't need to fire a manual operational event.
// We can remove this component once the frequency of the operational event is 0.
const $a07f43cc0d67a23c$var$YourWorkRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/for-you"
    });
const $a07f43cc0d67a23c$export$27e85db2fde321c7 = ()=>{
    return (0, $7jTnu.fg)('blu-7514_update_jira_home_your_work_to_for_you') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a07f43cc0d67a23c$var$YourWorkRedirect, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a07f43cc0d67a23c$export$72fc07b51a2e705d,
        pageId: "jira-home",
        shouldShowSpinner: false
    });
};

});


parcelRegister("5oAgu", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRedirectRouteEntry", () => $9aab4de5c0b54ba6$export$75f0bcae97d54ba0);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $kPEES = parcelRequire("kPEES");

var $c6XPK = parcelRequire("c6XPK");
const $9aab4de5c0b54ba6$export$75f0bcae97d54ba0 = (0, $6xToB.createEntry)((0, $kPEES.opsgenieScheduleRedirectRoute), ()=>({
        group: 'components',
        component: !false ? (0, $c6XPK.OpsgenieScheduleRedirect) : (0, $c6XPK.default),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c6XPK.LazyOpsGenieSchedule)
        ],
        isRedirect: true
    }));

});
parcelRegister("kPEES", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRedirectRoute", () => $9a227644729c3a18$export$5d29dbb36868dff4);
const $9a227644729c3a18$export$5d29dbb36868dff4 = {
    name: 'opsgenie-schedule-redirect',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:opsgenie-schedule-page'
    ]
};

});

parcelRegister("c6XPK", function(module, exports) {

$parcel$export(module.exports, "LazyOpsGenieSchedule", () => $5f4a9676e544329c$export$3a9c3ff70731bdd6);
$parcel$export(module.exports, "OpsgenieScheduleRedirect", () => $5f4a9676e544329c$export$6ffd640c3062d976);
$parcel$export(module.exports, "default", () => $5f4a9676e544329c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $hOUP7 = parcelRequire("hOUP7");

const $5f4a9676e544329c$export$3a9c3ff70731bdd6 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("1ZcOp"))), {
    moduleId: "./src/packages/spa-apps/project/opsgenie-schedule/src/index.tsx"
});
const $5f4a9676e544329c$export$6ffd640c3062d976 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hOUP7.RedirectToProjectType), {
        page: "/on-call-schedule"
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5f4a9676e544329c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $5f4a9676e544329c$export$3a9c3ff70731bdd6,
        pageId: "opsgenie-schedule",
        shouldShowSpinner: true
    });

});
parcelRegister("hOUP7", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $b00624fae0377dae$export$8a3df560509448b8);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $dZRaT = parcelRequire("dZRaT");

var $iIqWW = parcelRequire("iIqWW");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");
var $gCY1z = parcelRequire("gCY1z");
const $b00624fae0377dae$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $2mHfh.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $gCeeo.fireUIAnalytics), page: page, useAnalyticsEvents: // eslint-disable-next-line react-hooks/react-compiler
useAnalyticsEvents = (0, $f1Zdy.useAnalyticsEvents), useResource: // eslint-disable-next-line react-hooks/react-compiler
useResource = (0, $eJrcF.useResource), useRouter: // eslint-disable-next-line react-hooks/react-compiler
useRouter = (0, $gCY1z.useRouter), useSpaStateTransition: // eslint-disable-next-line react-hooks/react-compiler
useSpaStateTransition = (0, $iIqWW.useSpaStateTransition) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ match: match, query: query, route: route }] = useRouter();
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: data } = useResource((0, $dZRaT.projectContextResource));
    // eslint-disable-next-line react-hooks/react-compiler
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eJOHy.useRef)(createAnalyticsEvent({}));
    (0, $eJOHy.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $ln6Iy.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $ln6Iy.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});

parcelRegister("1ZcOp", function(module, exports) {

let $17256d255737c386$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $17256d255737c386$var$load("5RbmF").then(()=>parcelRequire('7DSXR'));

});



parcelRegister("k5e75", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRouteEntry", () => $07eff9f31f86dece$export$f128c1c4a1f0d631);

var $7mF43 = parcelRequire("7mF43");

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $9BJU1 = parcelRequire("9BJU1");

var $6lnLI = parcelRequire("6lnLI");

var $jom8W = parcelRequire("jom8W");

var $hS1gr = parcelRequire("hS1gr");

var $c6XPK = parcelRequire("c6XPK");
const $07eff9f31f86dece$export$f128c1c4a1f0d631 = (0, $6xToB.createEntry)((0, $6lnLI.opsgenieScheduleRoute), ()=>({
        group: 'components',
        ufoName: 'project-opsgenie-schedule',
        component: (0, $f2JN3.componentWithCondition)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $c6XPK.default)),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: [
                (0, $gHEJe.default),
                (0, $k6duF.default)
            ],
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c6XPK.LazyOpsGenieSchedule)
        ],
        meta: {
            reporting: {
                id: 'opsgenie-schedule',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('opsgenie-schedule'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("6lnLI", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRoute", () => $e3f20b049973159c$export$534a7ac096cb1da2);
const $e3f20b049973159c$export$534a7ac096cb1da2 = {
    name: 'opsgenie-schedule',
    path: '/jira/:projectType(software|software/c)/projects/:projectKey/on-call-schedule'
};

});


parcelRegister("leBbj", function(module, exports) {

$parcel$export(module.exports, "opsNotificationsPersonalSettingsRouteEntry", () => $1f71e65410b21a76$export$407513e3bdb49efe);

var $eJOHy = parcelRequire("eJOHy");

var $j7fEk = parcelRequire("j7fEk");

var $efbEC = parcelRequire("efbEC");

var $4VmHN = parcelRequire("4VmHN");parcelRequire("dwoHY");
var $fbCoq = parcelRequire("fbCoq");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $eaZMD = parcelRequire("eaZMD");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $cTPJz = parcelRequire("cTPJz");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $iRfwO = parcelRequire("iRfwO");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1f71e65410b21a76$var$LazyOpsNotificationsPersonalSettings = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3j4ya"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings/ops-notifications/src/index.tsx"
});
const $1f71e65410b21a76$var$OpsNotificationsPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1f71e65410b21a76$var$LazyOpsNotificationsPersonalSettings,
        pageId: "personal-settings-notifications",
        shouldShowSpinner: true
    });
const $1f71e65410b21a76$export$407513e3bdb49efe = (0, $6xToB.createEntry)((0, $cTPJz.opsNotificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: $1f71e65410b21a76$var$OpsNotificationsPersonalSettingsComponent,
        layout: (0, $iRfwO.opsNotificationsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PROFILE,
            sidebar: (0, $eaZMD.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $j7fEk.createContactsResource)(),
            (0, $4VmHN.createNotificationPreferencesResource)(),
            (0, $fbCoq.eocUserResource),
            (0, $efbEC.createMuteResource)(),
            (0, $efbEC.createQuietHoursResource)(),
            (0, $4VmHN.createForwardingRulesResource)(),
            ...(0, $hHbzj.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $1f71e65410b21a76$var$LazyOpsNotificationsPersonalSettings
        ]
    }));

});
parcelRegister("cTPJz", function(module, exports) {

$parcel$export(module.exports, "opsNotificationsPersonalSettingsRoute", () => $518284761c100d08$export$68ebdd4eccb7b383);
const $518284761c100d08$export$68ebdd4eccb7b383 = {
    name: 'personal-settings-ops-notifications',
    path: '/jira/settings/personal/alert-notifications'
};

});

parcelRegister("3j4ya", function(module, exports) {

let $2686acf99f04cc47$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $2686acf99f04cc47$var$load("1VRB2"),
    $2686acf99f04cc47$var$load("bABhq"),
    $2686acf99f04cc47$var$load("7vqGd"),
    $2686acf99f04cc47$var$load("1Y4bq"),
    $2686acf99f04cc47$var$load("2CWdf")
]).then(()=>parcelRequire('goaXA'));

});


parcelRegister("jlwtU", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesRouteEntry", () => $c87b6188b9371f43$export$219b6cc00b2f91a0);

var $epTsa = parcelRequire("epTsa");

var $7h3uc = parcelRequire("7h3uc");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $eYvz3 = parcelRequire("eYvz3");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $eR19P = parcelRequire("eR19P");

var $aQoXd = parcelRequire("aQoXd");

var $7c6fJ = parcelRequire("7c6fJ");
const $c87b6188b9371f43$var$peopleProfilesPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $7c6fJ.peopleProfilesEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PEOPLE
});
const $c87b6188b9371f43$export$219b6cc00b2f91a0 = (0, $6xToB.createEntry)((0, $eR19P.peopleProfilesRoute), ()=>({
        group: 'people-profiles',
        layout: (0, $eYvz3.layoutWithCondition)(()=>(0, $epTsa.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation'), (0, $aQoXd.rightSidebarsLayout), (0, $7h3uc.globalLayout)),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        ufoName: 'people-profiles',
        entryPoint: ()=>$c87b6188b9371f43$var$peopleProfilesPageEntrypoint,
        supportsPreviewPanel: true
    }));

});
parcelRegister("eYvz3", function(module, exports) {

$parcel$export(module.exports, "layoutWithCondition", () => $169a9523cff11418$export$c5db53e93ba35c0f);
const $169a9523cff11418$export$c5db53e93ba35c0f = (conditionGetter, itemTrue, itemFalse)=>({
        get isChromeless () {
            return conditionGetter() ? itemTrue.isChromeless : itemFalse.isChromeless;
        },
        get globalComponents () {
            return conditionGetter() ? itemTrue.globalComponents : itemFalse.globalComponents;
        },
        get rightSidebars () {
            return conditionGetter() ? itemTrue.rightSidebars : itemFalse.rightSidebars;
        }
    });

});

parcelRegister("eR19P", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesRoute", () => $48616684057e2867$export$1338132568be849);
const $48616684057e2867$export$1338132568be849 = {
    name: 'people-index',
    path: '/jira/people/:subPath?'
};

});

parcelRegister("7c6fJ", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesEntrypoint", () => $f72e7f8385be0ad5$export$26daeb77c71acf79);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $f72e7f8385be0ad5$export$26daeb77c71acf79 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("hD7EE")), {
        moduleId: "871dfc54",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hD7EE", function(module, exports) {

let $cd5c043e142ac4df$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $cd5c043e142ac4df$var$load("1VRB2"),
    $cd5c043e142ac4df$var$load("bABhq"),
    $cd5c043e142ac4df$var$load("hwlgY"),
    $cd5c043e142ac4df$var$load("1G8UW"),
    $cd5c043e142ac4df$var$load("iSk93"),
    $cd5c043e142ac4df$var$load("eDzss"),
    $cd5c043e142ac4df$var$load("jKIW4")
]).then(()=>parcelRequire('4I8rL'));

});



parcelRegister("3yeCC", function(module, exports) {

$parcel$export(module.exports, "performanceRouteEntry", () => $8bb4e40fdd7ce358$export$3f75a1735cbe5a04);

var $igNUx = parcelRequire("igNUx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $gjR2w = parcelRequire("gjR2w");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $g8uYY = parcelRequire("g8uYY");

var $9ycIa = parcelRequire("9ycIa");

var $cAYFR = parcelRequire("cAYFR");
const $8bb4e40fdd7ce358$var$performancePageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9ycIa.performanceEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $8bb4e40fdd7ce358$export$3f75a1735cbe5a04 = (0, $6xToB.createEntry)((0, $gjR2w.performanceRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $igNUx.isFedRamp)()) return undefined;
            return $8bb4e40fdd7ce358$var$performancePageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_PERFORMANCE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_PERFORMANCE),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("gjR2w", function(module, exports) {

$parcel$export(module.exports, "performanceRoute", () => $5ba6af24b39eb448$export$d867623f05adedb3);
const $5ba6af24b39eb448$export$d867623f05adedb3 = {
    name: 'project-settings-servicedesk-virtualagent-performance',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/performance'
};

});

parcelRegister("9ycIa", function(module, exports) {

$parcel$export(module.exports, "performanceEntryPoint", () => $3d4f3159d5c93a35$export$52b48527e9315b46);

var $12Xvg = parcelRequire("12Xvg");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");
const $3d4f3159d5c93a35$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $3d4f3159d5c93a35$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10); // has to be truncated for proper caching in SSR

const $3d4f3159d5c93a35$export$52b48527e9315b46 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("jIfli")), {
        moduleId: "25efd1aa",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $12Xvg.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
                        startDate: $3d4f3159d5c93a35$var$formatFetchDate(new Date(Date.now() - $3d4f3159d5c93a35$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $3d4f3159d5c93a35$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("12Xvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6db5c61764f52486$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<861165471f6f0a3ccb4f0e5d452abe29>>
 * @relayHash 21e9d7bc6c1d6159d3cb21287ece8c13
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cf0299fe94a9a8a861ab1195460e48c47ec0b6bbbeb73751ebaf9968c7a8b54d

var $bXR9c = parcelRequire("bXR9c");

var $fUVPs = parcelRequire("fUVPs");

var $Ic6R7 = parcelRequire("Ic6R7");
const $6db5c61764f52486$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "cf0299fe94a9a8a861ab1195460e48c47ec0b6bbbeb73751ebaf9968c7a8b54d",
        "metadata": {},
        "name": "srcVirtualAgentPerformanceQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": (0, $Ic6R7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvanextstepsrelayprovider": (0, $fUVPs.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $6db5c61764f52486$export$2e2bcd8739ae039 = $6db5c61764f52486$var$node;

});

parcelRegister("jIfli", function(module, exports) {

let $e59e0710d0fc7cc4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e59e0710d0fc7cc4$var$load("1dyIj").then(()=>parcelRequire('kUooe'));

});



parcelRegister("4FBBR", function(module, exports) {

$parcel$export(module.exports, "personalSettingsRouteEntry", () => $6cc27bb4c73249de$export$89646e32fa7698db);

var $eJOHy = parcelRequire("eJOHy");

var $j7fEk = parcelRequire("j7fEk");

var $efbEC = parcelRequire("efbEC");

var $4VmHN = parcelRequire("4VmHN");parcelRequire("dwoHY");
var $fbCoq = parcelRequire("fbCoq");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $bxWdr = parcelRequire("bxWdr");

var $6xToB = parcelRequire("6xToB");


var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $9Ocri = parcelRequire("9Ocri");

var $7fTjp = parcelRequire("7fTjp");

var $2dJFW = parcelRequire("2dJFW");

var $gzcjr = parcelRequire("gzcjr");

var $5HRxi = parcelRequire("5HRxi");

var $2hhQE = parcelRequire("2hhQE");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6cc27bb4c73249de$var$LazyLegacyPersonalSettings = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("99Mn7"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings-legacy/src/index.tsx"
});
const $6cc27bb4c73249de$export$89646e32fa7698db = (0, $6xToB.createEntry)((0, $9Ocri.personalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
                to: (0, $bxWdr.GENERAL_PERSONAL_SETTINGS_PATH)
            }),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PROFILE
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $j7fEk.createContactsResource)((0, $5HRxi.checkConsolidationOnRouteDependency), [
                (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
            ]),
            (0, $4VmHN.createNotificationPreferencesResource)((0, $5HRxi.checkConsolidationOnRouteDependency), [
                (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
            ]),
            (0, $fbCoq.eocUserResource),
            (0, $efbEC.createMuteResource)((0, $5HRxi.checkConsolidationOnRouteDependency), [
                (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
            ]),
            (0, $efbEC.createQuietHoursResource)((0, $5HRxi.checkConsolidationOnRouteDependency), [
                (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
            ]),
            (0, $4VmHN.createForwardingRulesResource)((0, $5HRxi.checkConsolidationOnRouteDependency), [
                (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
            ]),
            ...(0, $hHbzj.getNavigationForgePersonalSettingsPageResources)(),
            ...(0, $2hhQE.getLabsResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $6cc27bb4c73249de$var$LazyLegacyPersonalSettings
        ]
    }));

});
parcelRegister("9Ocri", function(module, exports) {

$parcel$export(module.exports, "personalSettingsRoute", () => $14fda5cb5a1c3334$export$176d0935b95c75e8);
const $14fda5cb5a1c3334$export$176d0935b95c75e8 = {
    name: 'personal-settings',
    path: '/secure/ViewPersonalSettings.jspa'
};

});

parcelRegister("5HRxi", function(module, exports) {

$parcel$export(module.exports, "checkConsolidationOnRouteDependency", () => $95d678804dd4af9e$export$ac86a769188afd33);

var $dI30d = parcelRequire("dI30d");

const $95d678804dd4af9e$export$ac86a769188afd33 = (dependencies)=>{
    const { data: data } = dependencies[0, $f8747ec2695de8a7$export$25ee35b01de9d734];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $dI30d.checkShouldUseJSM)(data);
};

});

parcelRegister("99Mn7", function(module, exports) {

let $6aaa79f50888bc18$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6aaa79f50888bc18$var$load("hwlgY"),
    $6aaa79f50888bc18$var$load("kjqPn")
]).then(()=>parcelRequire('7xDLz'));

});


parcelRegister("d5Bb9", function(module, exports) {

$parcel$export(module.exports, "piCreateIssueEmbedRouteEntry", () => $b0dd566c4fdad3c0$export$7f9ffa2e2d102ba);

var $eJOHy = parcelRequire("eJOHy");

var $6xToB = parcelRequire("6xToB");

var $aV23b = parcelRequire("aV23b");

var $1F9cm = parcelRequire("1F9cm");

var $7K5Ea = parcelRequire("7K5Ea");

var $cxQGT = parcelRequire("cxQGT");

var $fJ3AM = parcelRequire("fJ3AM");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b0dd566c4fdad3c0$var$LazyPICreateIssueEmbed = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("hQjgu")).then((module)=>module.CreateIssueEmbed), {
    ssr: false,
    moduleId: "./src/packages/growth/gmail-embed/src/ui/create-issue/index.tsx"
});
const $b0dd566c4fdad3c0$var$PIIssueCreateEmbedLazy = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $b0dd566c4fdad3c0$var$LazyPICreateIssueEmbed,
        pageId: "spa-apps/pi-issue-create-embed",
        shouldShowSpinner: true
    }));
};
const $b0dd566c4fdad3c0$export$7f9ffa2e2d102ba = (0, $6xToB.createEntry)((0, $fJ3AM.piCreateIssueEmbedRoute), ()=>({
        group: 'issue',
        component: $b0dd566c4fdad3c0$var$PIIssueCreateEmbedLazy,
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        forPaint: [
            $b0dd566c4fdad3c0$var$LazyPICreateIssueEmbed
        ]
    }));

});
parcelRegister("fJ3AM", function(module, exports) {

$parcel$export(module.exports, "piCreateIssueEmbedRoute", () => $ff79665c583f0923$export$e38c7e6f5c65691b);
const $ff79665c583f0923$export$e38c7e6f5c65691b = {
    name: 'pi-issue-create-embed',
    path: '/jira/issues/create/pi/embed'
};

});

parcelRegister("hQjgu", function(module, exports) {

let $cfd63c9cec393084$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cfd63c9cec393084$var$load("fhid1").then(()=>parcelRequire('8sEmV'));

});


parcelRegister("jSGUL", function(module, exports) {

$parcel$export(module.exports, "piEditIssueEmbedRouteEntry", () => $fb4ddde01355fb1f$export$54fd859765926fb);

var $eJOHy = parcelRequire("eJOHy");

var $6xToB = parcelRequire("6xToB");

var $gDv39 = parcelRequire("gDv39");

var $aV23b = parcelRequire("aV23b");

var $1F9cm = parcelRequire("1F9cm");

var $7K5Ea = parcelRequire("7K5Ea");

var $cxQGT = parcelRequire("cxQGT");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fb4ddde01355fb1f$var$LazyPIEditIssueEmbed = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("7ANlj")).then((module)=>module.EditIssueEmbed), {
    ssr: false,
    moduleId: "./src/packages/growth/gmail-embed/src/ui/edit-issue/index.tsx"
});
const $fb4ddde01355fb1f$var$PIIssueEditEmbedLazy = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fb4ddde01355fb1f$var$LazyPIEditIssueEmbed,
        pageId: "spa-apps/pi-issue-edit-embed",
        shouldShowSpinner: true
    }));
};
const $fb4ddde01355fb1f$export$54fd859765926fb = (0, $6xToB.createEntry)((0, $gDv39.piEditIssueEmbedRoute), ()=>({
        group: 'issue',
        component: $fb4ddde01355fb1f$var$PIIssueEditEmbedLazy,
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        forPaint: [
            $fb4ddde01355fb1f$var$LazyPIEditIssueEmbed
        ]
    }));

});
parcelRegister("gDv39", function(module, exports) {

$parcel$export(module.exports, "piEditIssueEmbedRoute", () => $fedc5372da6a666b$export$963ebe9ee36e7e80);
const $fedc5372da6a666b$export$963ebe9ee36e7e80 = {
    name: 'pi-issue-edit-embed',
    path: '/jira/issues/edit/pi/embed'
};

});

parcelRegister("7ANlj", function(module, exports) {

let $58722ba61179d896$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $58722ba61179d896$var$load("kuqxr").then(()=>parcelRequire('hfWkk'));

});


parcelRegister("bJXfU", function(module, exports) {

$parcel$export(module.exports, "planExportPageRouteEntry", () => $f4c659427106761d$export$d751e3552b21c604);

var $eJOHy = parcelRequire("eJOHy");

var $6xToB = parcelRequire("6xToB");

var $4KrIc = parcelRequire("4KrIc");

var $gmdNY = parcelRequire("gmdNY");

var $1F9cm = parcelRequire("1F9cm");

var $dIOB1 = parcelRequire("dIOB1");

var $iIcBn = parcelRequire("iIcBn");
/**
 * Export Page
 */ const $f4c659427106761d$var$ExportPageComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dIOB1.LazyAdvancedRoadmapsPlanExport), null);
const $f4c659427106761d$var$ExportPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f4c659427106761d$var$ExportPageComponent,
        pageId: "advanced-roadmap",
        shouldShowSpinner: true
    });
const $f4c659427106761d$export$d751e3552b21c604 = (0, $6xToB.createEntry)((0, $gmdNY.planExportPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-scenario-export',
        component: $f4c659427106761d$var$ExportPage,
        layout: {
            isChromeless: true,
            globalComponents: [],
            rightSidebars: []
        },
        resources: [
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        forPaint: [
            (0, $iIcBn.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("gmdNY", function(module, exports) {

$parcel$export(module.exports, "planExportPageRoute", () => $cc26ecc755c8471e$export$2ca5fe6f9ab466c1);
const $cc26ecc755c8471e$export$2ca5fe6f9ab466c1 = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId/scenarios/:scenarioId/export'
};

});

parcelRegister("dIOB1", function(module, exports) {

$parcel$export(module.exports, "LazyAdvancedRoadmapsPlanExport", () => $3e87659d9da32d1a$export$890fb5003e472449);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $3e87659d9da32d1a$export$890fb5003e472449 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("cxFx1"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3e87659d9da32d1a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3e87659d9da32d1a$export$890fb5003e472449,
        pageId: "advanced-roadmaps-plan",
        shouldShowSpinner: true
    });

});
parcelRegister("cxFx1", function(module, exports) {

let $9218c86dd489095b$var$load = (parcelRequire("gLHA4"))(4);





module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $9218c86dd489095b$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $9218c86dd489095b$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $9218c86dd489095b$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $9218c86dd489095b$var$load("kZxiU")
        ]);
    }),
    $9218c86dd489095b$var$load("7vqGd"),
    $9218c86dd489095b$var$load("1Y4bq"),
    $9218c86dd489095b$var$load("1VRB2"),
    $9218c86dd489095b$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("lzsqb"), 4)),
    $9218c86dd489095b$var$load("eDzss"),
    $9218c86dd489095b$var$load("1cdny")
]).then(()=>parcelRequire('5cOsz'));

});



parcelRegister("k3Rn6", function(module, exports) {

$parcel$export(module.exports, "planIncrementRouteEntry", () => $fea70cfa465a677a$export$a26fa5cabff8bc7c);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $eK8LX = parcelRequire("eK8LX");

var $7jTnu = parcelRequire("7jTnu");

var $13KtK = parcelRequire("13KtK");

var $ezGKx = parcelRequire("ezGKx");
const $fea70cfa465a677a$export$a26fa5cabff8bc7c = (0, $6xToB.createEntry)((0, $eK8LX.planIncrementRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $7jTnu.fg)('migrate_plans_to_entrypoints') ? (0, $13KtK.planIncrementPageEntryPoint) : undefined,
        component: (0, $ezGKx.PlanIncrement),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ezGKx.LazyPlanIncrement)
        ]
    }));

});
parcelRegister("it9UZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d272233cb03b552$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $6d272233cb03b552$var$LazyPlanSidebar = (0, $gzcjr.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("cT9AC")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/plan/src/index.tsx"
});
const $6d272233cb03b552$var$PlanSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "Plan"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6d272233cb03b552$var$LazyPlanSidebar, null)));
$6d272233cb03b552$var$PlanSidebar.displayName = 'PlanSidebar';
var $6d272233cb03b552$export$2e2bcd8739ae039 = $6d272233cb03b552$var$PlanSidebar;

});
parcelRegister("cT9AC", function(module, exports) {

let $96220f67c7bf9bdb$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    $96220f67c7bf9bdb$var$load("1VRB2"),
    $96220f67c7bf9bdb$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("ci5de"), 4)),
    $96220f67c7bf9bdb$var$load("3lFi7")
]).then(()=>parcelRequire('gjEnH'));

});


parcelRegister("8vSr3", function(module, exports) {

$parcel$export(module.exports, "planLayout", () => $e59450c8fb0bbe82$export$94e1d79bf65579e2);

var $6dwgv = parcelRequire("6dwgv");

var $gzcjr = parcelRequire("gzcjr");

const $e59450c8fb0bbe82$export$b6292b5f7e5b5fad = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("2O7Dk")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx"
});
const $e59450c8fb0bbe82$export$94e1d79bf65579e2 = (0, $6dwgv.createLayout)({
    globalComponents: [
        $e59450c8fb0bbe82$export$b6292b5f7e5b5fad
    ]
});

});
parcelRegister("2O7Dk", function(module, exports) {

let $20b62c1590a60a9d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $20b62c1590a60a9d$var$load("k56i8").then(()=>parcelRequire('dNajn'));

});


parcelRegister("eK8LX", function(module, exports) {

$parcel$export(module.exports, "planIncrementRoute", () => $f9f8e3fb39feca43$export$ef33a75556fde209);
const $f9f8e3fb39feca43$export$ef33a75556fde209 = {
    name: 'software-plan-increment',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId',
    exact: true
};

});

parcelRegister("13KtK", function(module, exports) {

$parcel$export(module.exports, "planIncrementPageEntryPoint", () => $ed1c3f79a0bb918d$export$a87dd3f7b0d2f7c2);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $eDyDZ = parcelRequire("eDyDZ");

var $dGTIT = parcelRequire("dGTIT");
const $ed1c3f79a0bb918d$export$a87dd3f7b0d2f7c2 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $eDyDZ.planIncrementEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint)
});

});
parcelRegister("dGTIT", function(module, exports) {

$parcel$export(module.exports, "plansHorizontalNavigationEntryPoint", () => $5fd8f9b4e9b35d81$export$172a11f0d118de01);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $4BK1O = parcelRequire("4BK1O");

var $j3Ybe = parcelRequire("j3Ybe");

var $3lQXJ = parcelRequire("3lQXJ");

var $7Bvm5 = parcelRequire("7Bvm5");
function $5fd8f9b4e9b35d81$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
    return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
}

const $5fd8f9b4e9b35d81$export$172a11f0d118de01 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("6Dbco")), {
        moduleId: "8c821489",
        moduleName: "HorizontalNavPlans",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        const planId = match.params.planId;
        const scenarioId = match.params.scenarioId;
        if (!planId) throw new Error('Plan Id is missing');
        if (!scenarioId) throw new Error('Scenario Id is missing');
        const planScenarioAri = $5fd8f9b4e9b35d81$var$toPlanScenarioAri({
            siteId: cloudId,
            activationId: activationId,
            planId: planId,
            scenarioId: scenarioId
        });
        return {
            queries: {
                horizontalNavPlansQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $3lQXJ.default,
                    variables: {
                        first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE),
                        cloudId: cloudId,
                        containerNavigationInput: {
                            scopeId: planScenarioAri
                        }
                    }
                }
            }
        };
    }
});

});
parcelRegister("3lQXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $44201a212c2f52b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<579d50b31430815e25d91a9a65380319>>
 * @relayHash 164c48c3824ef2f0755f6d70fb373e5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ae63d79ee56070a78fcd0f81b3991516463430dbed3ae6bcd427e7e0f13d71c
const $44201a212c2f52b2$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5ae63d79ee56070a78fcd0f81b3991516463430dbed3ae6bcd427e7e0f13d71c",
        "metadata": {},
        "name": "HorizontalNavPlansQuery",
        "operationKind": "query",
        "text": null
    }
};
var $44201a212c2f52b2$export$2e2bcd8739ae039 = $44201a212c2f52b2$var$node;

});

parcelRegister("6Dbco", function(module, exports) {

let $4d3f1279ab19eb3d$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    $4d3f1279ab19eb3d$var$load("1VRB2"),
    $4d3f1279ab19eb3d$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("5YzZK"), 4)),
    $4d3f1279ab19eb3d$var$load("eDzss"),
    $4d3f1279ab19eb3d$var$load("5CLUt")
]).then(()=>parcelRequire('4pkYY'));

});



parcelRegister("ezGKx", function(module, exports) {

$parcel$export(module.exports, "LazyPlanIncrement", () => $d4ad8d5b1c19c768$export$e7b9f83d442bac51);
$parcel$export(module.exports, "PlanIncrement", () => $d4ad8d5b1c19c768$export$5e1035d0876d64db);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $d4ad8d5b1c19c768$export$e7b9f83d442bac51 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("k6MXE"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index-old.tsx"
});
const $d4ad8d5b1c19c768$export$5e1035d0876d64db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d4ad8d5b1c19c768$export$e7b9f83d442bac51,
        pageId: "plan-increment",
        shouldShowSpinner: true
    });

});


parcelRegister("5DVEh", function(module, exports) {

$parcel$export(module.exports, "planIncrementsRouteEntry", () => $c0946d9248e930b4$export$f7abc47036ff7dd9);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $8Jq3e = parcelRequire("8Jq3e");

var $7jTnu = parcelRequire("7jTnu");

var $fQZh1 = parcelRequire("fQZh1");

var $h6iiZ = parcelRequire("h6iiZ");
const $c0946d9248e930b4$export$f7abc47036ff7dd9 = (0, $6xToB.createEntry)((0, $8Jq3e.planIncrementsRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $7jTnu.fg)('migrate_plans_to_entrypoints') ? (0, $h6iiZ.planProgramPageEntryPoint) : undefined,
        component: (0, $fQZh1.PlanProgram),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fQZh1.LazyPlanProgram)
        ]
    }));

});
parcelRegister("8Jq3e", function(module, exports) {

$parcel$export(module.exports, "planIncrementsRoute", () => $4e0258a5d99799dd$export$d0986e4bd9568b30);
const $4e0258a5d99799dd$export$d0986e4bd9568b30 = {
    name: 'software-plan-increments',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program',
    exact: true
};

});

parcelRegister("fQZh1", function(module, exports) {

$parcel$export(module.exports, "LazyPlanProgram", () => $44d65e02d863e8a0$export$9da4d4d5c4d7f749);
$parcel$export(module.exports, "PlanProgram", () => $44d65e02d863e8a0$export$fb30c2b19a4f5d59);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $44d65e02d863e8a0$export$9da4d4d5c4d7f749 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("hv0P5"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-program/index-old.tsx"
});
const $44d65e02d863e8a0$export$fb30c2b19a4f5d59 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $44d65e02d863e8a0$export$9da4d4d5c4d7f749,
        pageId: "plan-program",
        shouldShowSpinner: true
    });

});
parcelRegister("hv0P5", function(module, exports) {

let $cbd5f855969dac7e$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("aeOaG"), 4)),
    $cbd5f855969dac7e$var$load("0BRjH")
]).then(()=>parcelRequire('lRkR4'));

});


parcelRegister("h6iiZ", function(module, exports) {

$parcel$export(module.exports, "planProgramPageEntryPoint", () => $d72f9c83b02c2f38$export$cb6ac90e8faddaeb);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $jz9v9 = parcelRequire("jz9v9");

var $dGTIT = parcelRequire("dGTIT");
const $d72f9c83b02c2f38$export$cb6ac90e8faddaeb = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jz9v9.planProgramEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint)
});

});
parcelRegister("jz9v9", function(module, exports) {

$parcel$export(module.exports, "planProgramEntryPoint", () => $d047f107752f73d5$export$da91c765d9841bae);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $d047f107752f73d5$export$da91c765d9841bae = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("5sjRX")), {
        moduleId: "1b761aac",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5sjRX", function(module, exports) {

let $3f8efae6e37ffd91$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("1kUIs"), 4)),
    $3f8efae6e37ffd91$var$load("c4Emg")
]).then(()=>parcelRequire('kRz17'));

});




parcelRegister("jJEm7", function(module, exports) {

$parcel$export(module.exports, "planPageRouteEntry", () => $f568909fbeb06b81$export$f85a75f1604118ff);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $dCQ31 = parcelRequire("dCQ31");

var $6dwgv = parcelRequire("6dwgv");

var $8vSr3 = parcelRequire("8vSr3");

var $iIcBn = parcelRequire("iIcBn");

var $6xcVp = parcelRequire("6xcVp");
// This redirect is required to support legacy routes, it should never be deleted
const $f568909fbeb06b81$var$planPageRedirect = (0, $6xcVp.withRedirection)((0, $iIcBn.default), {
    to: '/timeline',
    redirectCondition: ()=>true
});
const $f568909fbeb06b81$export$f85a75f1604118ff = (0, $6xToB.createEntry)((0, $dCQ31.planPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-scenario',
        component: $f568909fbeb06b81$var$planPageRedirect,
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iIcBn.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("dCQ31", function(module, exports) {

$parcel$export(module.exports, "planPageRoute", () => $5b9547f9e6814bdd$export$26495e043d80cccc);
const $5b9547f9e6814bdd$export$26495e043d80cccc = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId/scenarios/:scenarioId'
};

});

parcelRegister("6xcVp", function(module, exports) {

$parcel$export(module.exports, "withRedirection", () => $0f261707661f001f$export$2c9e4550ef8bdea9);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");

var $gCY1z = parcelRequire("gCY1z");
function $0f261707661f001f$export$2c9e4550ef8bdea9(Component, { to: to, redirectCondition: redirectCondition }) {
    return ()=>{
        const [{ match: match }] = (0, $gCY1z.useRouter)();
        if (match == null || match.params == null || match.params.planId == null || match.params.scenarioId == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
            to: "/jira/plans"
        });
        if (!redirectCondition()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
            to: `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${to}`
        });
    };
}

});


parcelRegister("flxMn", function(module, exports) {

$parcel$export(module.exports, "planPageWithoutScenarioIdRouteEntry", () => $6be661039b495821$export$9cbef73b51558ef);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $6rAsd = parcelRequire("6rAsd");

var $6zXPf = parcelRequire("6zXPf");

var $eyNFj = parcelRequire("eyNFj");

var $iIcBn = parcelRequire("iIcBn");
const $6be661039b495821$export$9cbef73b51558ef = (0, $6xToB.createEntry)((0, $6rAsd.planPageWithoutScenarioIdRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-plan',
        component: (0, $6zXPf.getWillShowNav4)() ? (0, $eyNFj.RedirectPlanPageWithoutScenarioIdLoadQuery) : (0, $eyNFj.RedirectPlanPageWithoutScenarioId),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iIcBn.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("6rAsd", function(module, exports) {

$parcel$export(module.exports, "planPageWithoutScenarioIdRoute", () => $1b095408f7c3d976$export$610e14c9c89d0afb);
const $1b095408f7c3d976$export$610e14c9c89d0afb = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId(\\d+)'
};

});


parcelRegister("iJbtQ", function(module, exports) {

$parcel$export(module.exports, "planReportPageRouteEntry", () => $0197c538340d0c1c$export$e71031acce6d7e47);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $2zLut = parcelRequire("2zLut");

var $dts4B = parcelRequire("dts4B");
const $0197c538340d0c1c$export$e71031acce6d7e47 = (0, $6xToB.createEntry)((0, $2zLut.planReportPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-report',
        component: (0, $dts4B.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4KrIc.advancedRoadmapsPlanReportPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dts4B.LazyPlanReport)
        ]
    }));

});
parcelRegister("2zLut", function(module, exports) {

$parcel$export(module.exports, "planReportPageRoute", () => $fe6c4dfc2c704cf6$export$7c8c0761b1ba57bb);
const $fe6c4dfc2c704cf6$export$7c8c0761b1ba57bb = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/reports/:reportId'
};

});

parcelRegister("dts4B", function(module, exports) {

$parcel$export(module.exports, "LazyPlanReport", () => $9f6ef3646c3dba25$export$fe1fc08f511671db);
$parcel$export(module.exports, "default", () => $9f6ef3646c3dba25$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $9f6ef3646c3dba25$export$fe1fc08f511671db = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7ucEC"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-report/index.tsx"
});
const $9f6ef3646c3dba25$var$PlanReport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $9f6ef3646c3dba25$export$fe1fc08f511671db,
        pageId: "plan-report",
        shouldShowSpinner: true
    });
var $9f6ef3646c3dba25$export$2e2bcd8739ae039 = $9f6ef3646c3dba25$var$PlanReport;

});
parcelRegister("7ucEC", function(module, exports) {

let $573526981633141c$var$load = (parcelRequire("gLHA4"))(4);





module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $573526981633141c$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $573526981633141c$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $573526981633141c$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $573526981633141c$var$load("kZxiU")
        ]);
    }),
    $573526981633141c$var$load("7vqGd"),
    $573526981633141c$var$load("1Y4bq"),
    $573526981633141c$var$load("1VRB2"),
    $573526981633141c$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("cZyms"), 4)),
    $573526981633141c$var$load("eDzss"),
    $573526981633141c$var$load("gDxK0")
]).then(()=>parcelRequire('kwkQ2'));

});



parcelRegister("98Umx", function(module, exports) {

$parcel$export(module.exports, "plansDirectoryRouteEntry", () => $81b57271b28d1b61$export$4f9df77811fbdc1f);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $fZoD8 = parcelRequire("fZoD8");

var $iMFdk = parcelRequire("iMFdk");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $81b57271b28d1b61$var$LazyPlansDirectory = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5UKt0"))), {
    moduleId: "./src/packages/spa-apps/directories/plans/src/index.tsx"
});
const $81b57271b28d1b61$var$PlansDirectoryComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $81b57271b28d1b61$var$LazyPlansDirectory,
        pageId: "plans-directory",
        shouldShowSpinner: false
    });
const $81b57271b28d1b61$export$4f9df77811fbdc1f = (0, $6xToB.createEntry)((0, $fZoD8.plansDirectoryRoute), ()=>({
        group: 'directories',
        component: $81b57271b28d1b61$var$PlansDirectoryComponent,
        skeleton: (0, $iMFdk.PlansDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $81b57271b28d1b61$var$LazyPlansDirectory
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("5UKt0", function(module, exports) {

let $44e63a0e3b9f824d$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $44e63a0e3b9f824d$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $44e63a0e3b9f824d$var$load("deNlq")
        ]);
    }),
    $44e63a0e3b9f824d$var$load("2JPYb")
]).then(()=>parcelRequire('4TzQ2'));

});


parcelRegister("33RDm", function(module, exports) {

$parcel$export(module.exports, "planSetupPageRouteEntry", () => $621f3a350ed066c3$export$2a24acea4e628148);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $gqQqR = parcelRequire("gqQqR");

var $6M5Br = parcelRequire("6M5Br");
const $621f3a350ed066c3$export$2a24acea4e628148 = (0, $6xToB.createEntry)((0, $gqQqR.planSetupPageRoute), ()=>({
        group: 'software',
        component: (0, $6M5Br.default),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6M5Br.LazyAdvancedRoadmapsSetup)
        ]
    }));

});
parcelRegister("gqQqR", function(module, exports) {

$parcel$export(module.exports, "planSetupPageRoute", () => $ae880a552586841f$export$4815756bb523904e);
const $ae880a552586841f$export$4815756bb523904e = {
    name: 'software-advanced-roadmaps-setup',
    path: '/jira/plans/:planId/setup'
};

});

parcelRegister("6M5Br", function(module, exports) {

$parcel$export(module.exports, "LazyAdvancedRoadmapsSetup", () => $cbee4b463574734d$export$46bb3a1779d7815b);
$parcel$export(module.exports, "default", () => $cbee4b463574734d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $cbee4b463574734d$export$46bb3a1779d7815b = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("eclvt"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/setup/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cbee4b463574734d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cbee4b463574734d$export$46bb3a1779d7815b,
        pageId: "advanced-roadmaps-setup",
        shouldShowSpinner: true
    });

});
parcelRegister("eclvt", function(module, exports) {

let $a562de6f6883e339$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $a562de6f6883e339$var$load("1VRB2"),
    $a562de6f6883e339$var$load("bABhq"),
    $a562de6f6883e339$var$load("c1Bmr")
]).then(()=>parcelRequire('agOcn'));

});



parcelRegister("9a7o3", function(module, exports) {

$parcel$export(module.exports, "planUpsellRouteEntry", () => $e6d7a1d218fbbe94$export$363894d991872cbf);

var $6xToB = parcelRequire("6xToB");

var $8ETQ8 = parcelRequire("8ETQ8");

var $5RW99 = parcelRequire("5RW99");

var $7h3uc = parcelRequire("7h3uc");

var $9NmsS = parcelRequire("9NmsS");

var $43NYh = parcelRequire("43NYh");
const $e6d7a1d218fbbe94$export$363894d991872cbf = (0, $6xToB.createEntry)((0, $8ETQ8.planUpsellRoute), ()=>({
        group: 'software',
        entryPoint () {
            return 0, $43NYh.planUpsellPageEntryPoint;
        },
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        }
    }));

});
parcelRegister("43NYh", function(module, exports) {

$parcel$export(module.exports, "planUpsellPageEntryPoint", () => $d66a4a9fe9121626$export$7551fe27e3c0a4bf);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $8QNrG = parcelRequire("8QNrG");
const $d66a4a9fe9121626$export$7551fe27e3c0a4bf = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8QNrG.planUpsellEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS
});

});


parcelRegister("7Al9R", function(module, exports) {

$parcel$export(module.exports, "planViewNotFoundRouteEntry", () => $a64b24249c951d85$export$19c7bb0eeda48c06);

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $7UTBK = parcelRequire("7UTBK");

var $6dwgv = parcelRequire("6dwgv");

var $7h3uc = parcelRequire("7h3uc");

var $8vSr3 = parcelRequire("8vSr3");

var $it9UZ = parcelRequire("it9UZ");

var $aIYFK = parcelRequire("aIYFK");
const $a64b24249c951d85$export$19c7bb0eeda48c06 = (0, $6xToB.createEntry)((0, $7UTBK.planViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)()
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        entryPoint: ()=>(0, $aIYFK.planViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("7UTBK", function(module, exports) {

$parcel$export(module.exports, "planViewNotFoundRoute", () => $fac6abfa4bf0a428$export$f2531e319f8b4274);
const $fac6abfa4bf0a428$export$f2531e319f8b4274 = {
    name: 'plan-view-not-found',
    path: '/jira/plans/:planId/scenarios/:scenarioId/not-found'
};

});

parcelRegister("aIYFK", function(module, exports) {

$parcel$export(module.exports, "planViewNotFoundPageEntrypoint", () => $996718f76a69fe38$export$18e8a0d930f394a2);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $nTAA5 = parcelRequire("nTAA5");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $dGTIT = parcelRequire("dGTIT");

const $996718f76a69fe38$var$main = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("4ua6i")), {
        moduleId: "f2ea0209",
        moduleName: "PlanViewNotFound",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        const planId = match.params.planId;
        if (!planId) throw new Error('Plan Id is missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $nTAA5.default,
                    variables: {
                        planId: `ari:cloud:jira:${cloudId}:plan/activation/${activationId}/${planId}`
                    }
                }
            }
        };
    }
});
const $996718f76a69fe38$export$18e8a0d930f394a2 = (0, $g8uYY.createPageEntryPoint)({
    main: $996718f76a69fe38$var$main,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS
});

});
parcelRegister("nTAA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0d7b2719ea0082b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f97e78ab59091e8012bd8a05696ce789>>
 * @relayHash c51281360f2d7bd5387e9bb058f11f6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29dd5915a4af58bbd22d79842971790506a1f3ab87507ab96eca150acfd91229
const $a0d7b2719ea0082b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "29dd5915a4af58bbd22d79842971790506a1f3ab87507ab96eca150acfd91229",
        "metadata": {},
        "name": "PlanViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a0d7b2719ea0082b$export$2e2bcd8739ae039 = $a0d7b2719ea0082b$var$node;

});

parcelRegister("4ua6i", function(module, exports) {

let $3441cc80a1e215b2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3441cc80a1e215b2$var$load("28YWj").then(()=>parcelRequire('5nmGk'));

});



parcelRegister("4p5og", function(module, exports) {

$parcel$export(module.exports, "polarisCollectionsRouteEntry", () => $a14b7285543f033b$export$a034dc25c21d1029);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $aQxDr = parcelRequire("aQxDr");

var $aK1hS = parcelRequire("aK1hS");
const $a14b7285543f033b$export$a034dc25c21d1029 = (0, $6xToB.createEntry)((0, $aQxDr.polarisCollectionsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        ufoName: 'jpd.collections',
        component: (0, $aK1hS.default),
        layout: (0, $7h3uc.globalLayout),
        canTransitionIn: ()=>{
            // default is no-refresh
            return true;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $aK1hS.LazyCollectionsPage)
        ]
    }));

});
parcelRegister("aQxDr", function(module, exports) {

$parcel$export(module.exports, "polarisCollectionsRoute", () => $0750218039883055$export$d415b74f78a5f159);
const $0750218039883055$export$d415b74f78a5f159 = {
    name: 'polaris-collections',
    path: '/jira/polaris/roadmaps/:collectionUUID?/:section?/:resource?',
    query: [
        'projects?',
        'owners?'
    ],
    exact: true
};

});

parcelRegister("aK1hS", function(module, exports) {

$parcel$export(module.exports, "LazyCollectionsPage", () => $6444e855eac9b9ce$export$f7960e7dbd7e5265);
$parcel$export(module.exports, "default", () => $6444e855eac9b9ce$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fRXNt = parcelRequire("fRXNt");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $lvKO5 = parcelRequire("lvKO5");

var $gzcjr = parcelRequire("gzcjr");

var $2mHfh = parcelRequire("2mHfh");

const $6444e855eac9b9ce$export$f7960e7dbd7e5265 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ggY0b"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/collections/src/index.tsx"
});
const $6444e855eac9b9ce$var$useJpdLicensed = ()=>{
    const context = (0, $lvKO5.useTenantContext)();
    return context.licensedProducts['jira-product-discovery'];
};
const $6444e855eac9b9ce$export$3bba33442c4150b1 = ()=>{
    const jpdLicensed = $6444e855eac9b9ce$var$useJpdLicensed();
    const crossProjectViewsEnabled = (0, $fRXNt.useIsCrossProjectViewsEnabled)();
    if (!jpdLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: "/jira/polaris/unlicensed"
    });
    if (!crossProjectViewsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: "/jira"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6444e855eac9b9ce$export$f7960e7dbd7e5265,
        pageId: "async-polaris-collections",
        shouldShowSpinner: false
    });
};
var $6444e855eac9b9ce$export$2e2bcd8739ae039 = $6444e855eac9b9ce$export$3bba33442c4150b1;

});
parcelRegister("ggY0b", function(module, exports) {

let $bd8caf19664522b3$var$load = (parcelRequire("gLHA4"))(4);


module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $bd8caf19664522b3$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $bd8caf19664522b3$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $bd8caf19664522b3$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $bd8caf19664522b3$var$load("kZxiU")
        ]);
    }),
    $bd8caf19664522b3$var$load("hwlgY"),
    $bd8caf19664522b3$var$load("7vqGd"),
    $bd8caf19664522b3$var$load("1Y4bq"),
    $bd8caf19664522b3$var$load("1VRB2"),
    $bd8caf19664522b3$var$load("bABhq"),
    $bd8caf19664522b3$var$load("eDzss"),
    $bd8caf19664522b3$var$load("65Lvo")
]).then(()=>parcelRequire('LFaVG'));

});



parcelRegister("01dV2", function(module, exports) {

$parcel$export(module.exports, "polarisIdeasRouteEntry", () => $4d574276bc93dcbc$export$26631f98f007b2d2);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $jXAU3 = parcelRequire("jXAU3");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $f58ZR = parcelRequire("f58ZR");

var $6Kw7r = parcelRequire("6Kw7r");
const $4d574276bc93dcbc$export$26631f98f007b2d2 = (0, $6xToB.createEntry)((0, $f58ZR.polarisIdeasRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        ufoName: 'jpd.project',
        layout: (0, $jXAU3.polarisProjectLayout),
        canTransitionIn: ()=>true,
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint () {
            return 0, $6Kw7r.ideasPageEntryPoint;
        },
        preloadOptions: {
            earlyChunks: [
                'jpd-ideas-early-entry'
            ]
        }
    }));

});
parcelRegister("jXAU3", function(module, exports) {

$parcel$export(module.exports, "polarisProjectLayout", () => $9c466b8fcdf0c3fc$export$d5273c1a2e2fe212);

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");
const $9c466b8fcdf0c3fc$export$d5273c1a2e2fe212 = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout));

});

parcelRegister("f58ZR", function(module, exports) {

$parcel$export(module.exports, "polarisIdeasRoute", () => $0a2b0b5b270c777f$export$54c333cd4ed2d70e);
const $0a2b0b5b270c777f$export$54c333cd4ed2d70e = {
    name: 'polaris-ideas',
    path: '/jira/polaris/projects/:projectKey/ideas/:section?/:resource?',
    query: [
        'selectedIssue?',
        'issueViewLayout?'
    ],
    exact: true
};

});

parcelRegister("6Kw7r", function(module, exports) {

$parcel$export(module.exports, "ideasPageEntryPoint", () => $5aee234730b3e880$export$aa9a00411f9c3e39);

var $5RW99 = parcelRequire("5RW99");

var $g8uYY = parcelRequire("g8uYY");

var $cfmHv = parcelRequire("cfmHv");
const $5aee234730b3e880$export$aa9a00411f9c3e39 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cfmHv.ideasEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("cfmHv", function(module, exports) {

$parcel$export(module.exports, "ideasEntryPoint", () => $38687e9e7d1e4cfd$export$ffc470fa0659ba16);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $38687e9e7d1e4cfd$export$ffc470fa0659ba16 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("awFHU")), {
        moduleId: "3b89e133",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("awFHU", function(module, exports) {

let $7a9d3eb80c55d045$var$load = (parcelRequire("gLHA4"))(4);


module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $7a9d3eb80c55d045$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $7a9d3eb80c55d045$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $7a9d3eb80c55d045$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $7a9d3eb80c55d045$var$load("kZxiU")
        ]);
    }),
    $7a9d3eb80c55d045$var$load("hwlgY"),
    $7a9d3eb80c55d045$var$load("7vqGd"),
    $7a9d3eb80c55d045$var$load("1Y4bq"),
    $7a9d3eb80c55d045$var$load("1VRB2"),
    $7a9d3eb80c55d045$var$load("bABhq"),
    $7a9d3eb80c55d045$var$load("eDzss"),
    $7a9d3eb80c55d045$var$load("bfwU0")
]).then(()=>parcelRequire('fZeB7'));

});




parcelRegister("eDNar", function(module, exports) {

$parcel$export(module.exports, "polarisOnboardingRouteEntry", () => $102706bdacd1f2f0$export$a297a71cb150e2af);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $ho9E1 = parcelRequire("ho9E1");

var $loxDw = parcelRequire("loxDw");

var $flZs0 = parcelRequire("flZs0");
const $102706bdacd1f2f0$export$a297a71cb150e2af = (0, $6xToB.createEntry)((0, $loxDw.polarisOnboardingRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        component: (0, $flZs0.default),
        layout: (0, $7h3uc.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $ho9E1.projectCreatePermissionsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $flZs0.LazyOnboardingPage)
        ]
    }));

});
parcelRegister("loxDw", function(module, exports) {

$parcel$export(module.exports, "polarisOnboardingRoute", () => $69cf92a3b53325d9$export$6696e9deb45fe980);
const $69cf92a3b53325d9$export$6696e9deb45fe980 = {
    name: 'polaris-onboarding',
    path: '/welcome/discovery',
    exact: true
};

});

parcelRegister("flZs0", function(module, exports) {

$parcel$export(module.exports, "LazyOnboardingPage", () => $ee1b86146c0a5089$export$13889cc3ce0d5a93);
$parcel$export(module.exports, "default", () => $ee1b86146c0a5089$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ee1b86146c0a5089$export$13889cc3ce0d5a93 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7ys6U"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/onboarding/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ee1b86146c0a5089$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ee1b86146c0a5089$export$13889cc3ce0d5a93,
        pageId: "async-polaris-onboarding",
        shouldShowSpinner: false
    });

});
parcelRegister("7ys6U", function(module, exports) {

let $580183825ee4ca08$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $580183825ee4ca08$var$load("8peqP").then(()=>parcelRequire('ehwUR'));

});



parcelRegister("cWeYh", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsAccessRouteEntry", () => $9d756e76cba4e28a$export$9c0f51630c25c3d);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $gxPYM = parcelRequire("gxPYM");

var $5nhXC = parcelRequire("5nhXC");
const $9d756e76cba4e28a$export$9c0f51630c25c3d = (0, $6xToB.createEntry)((0, $gxPYM.polarisSettingsAccessRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        component: (0, $5nhXC.AccessSettingsPage),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $5nhXC.LazyAccessSettingsPage)
        ]
    }));

});
parcelRegister("gxPYM", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsAccessRoute", () => $fb96dc846965fa87$export$bfdcdf76e802d67d);
const $fb96dc846965fa87$export$bfdcdf76e802d67d = {
    name: 'polaris-settings-access',
    path: '/jira/settings/products/jira-product-discovery/access',
    exact: true
};

});

parcelRegister("5nhXC", function(module, exports) {

$parcel$export(module.exports, "LazyAccessSettingsPage", () => $ee37dbdedb1d9a72$export$b66ea0dcd38af7f0);
$parcel$export(module.exports, "AccessSettingsPage", () => $ee37dbdedb1d9a72$export$d46497fe68b0853c);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ee37dbdedb1d9a72$export$b66ea0dcd38af7f0 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("69Cxd"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/settings-access/src/index.tsx"
});
const $ee37dbdedb1d9a72$export$d46497fe68b0853c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ee37dbdedb1d9a72$export$b66ea0dcd38af7f0,
        pageId: "async-polaris-settings-access",
        shouldShowSpinner: false
    });

});
parcelRegister("69Cxd", function(module, exports) {

let $47b17989a30987c0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $47b17989a30987c0$var$load("6HMZj").then(()=>parcelRequire('ctW5D'));

});



parcelRegister("0eLvf", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsDatesRouteEntry", () => $8851d351a21b736a$export$df39bbcec5c3d8fb);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $2NgER = parcelRequire("2NgER");

var $b6rXY = parcelRequire("b6rXY");
const $8851d351a21b736a$export$df39bbcec5c3d8fb = (0, $6xToB.createEntry)((0, $2NgER.polarisSettingsDatesRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $b6rXY.polarisProductFinancialYearSettingsPageEntryPoint;
        }
    }));

});
parcelRegister("2NgER", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsDatesRoute", () => $6c040c4f7cf09229$export$41bd51b740ebfe25);
const $6c040c4f7cf09229$export$41bd51b740ebfe25 = {
    name: 'polaris-settings-financial-year',
    path: '/jira/settings/products/jira-product-discovery/dates',
    exact: true
};

});

parcelRegister("b6rXY", function(module, exports) {

$parcel$export(module.exports, "polarisProductFinancialYearSettingsPageEntryPoint", () => $3c67c836ee1ac3f9$export$b1c132cd756e9b86);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $02vUi = parcelRequire("02vUi");
const $3c67c836ee1ac3f9$export$b1c132cd756e9b86 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $02vUi.polarisProductFinancialYearSettingsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("02vUi", function(module, exports) {

$parcel$export(module.exports, "polarisProductFinancialYearSettingsEntryPoint", () => $5012b89db90f0de9$export$2e0ef763d6b208ea);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $5012b89db90f0de9$export$2e0ef763d6b208ea = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("1zUba")), {
        moduleId: "47bc544f",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1zUba", function(module, exports) {

let $1264a35576822491$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1264a35576822491$var$load("env0V").then(()=>parcelRequire('36V1P'));

});




parcelRegister("avhOT", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsEarlyAccessFeaturesRouteEntry", () => $66b928790495b2c4$export$986710683a071056);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $jMVo4 = parcelRequire("jMVo4");

var $40Wrm = parcelRequire("40Wrm");
const $66b928790495b2c4$export$986710683a071056 = (0, $6xToB.createEntry)((0, $jMVo4.polarisSettingsEarlyAccessFeaturesRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $40Wrm.polarisProductEAPSettingsPageEntryPoint;
        }
    }));

});
parcelRegister("jMVo4", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsEarlyAccessFeaturesRoute", () => $f8b20274dbc348ac$export$19bd38107b2ac64b);
const $f8b20274dbc348ac$export$19bd38107b2ac64b = {
    name: 'polaris-settings-early-access-features',
    path: '/jira/settings/products/jira-product-discovery/early-access-features',
    exact: true
};

});

parcelRegister("40Wrm", function(module, exports) {

$parcel$export(module.exports, "polarisProductEAPSettingsPageEntryPoint", () => $296b6ddc14f74157$export$1bd9d2b1f32dc9ee);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $f994p = parcelRequire("f994p");
const $296b6ddc14f74157$export$1bd9d2b1f32dc9ee = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $f994p.polarisProductEAPSettingsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("f994p", function(module, exports) {

$parcel$export(module.exports, "polarisProductEAPSettingsEntryPoint", () => $45e557a009fe89ce$export$92df711874ab564a);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $45e557a009fe89ce$export$92df711874ab564a = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("eJi2T")), {
        moduleId: "e4e16138",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eJi2T", function(module, exports) {

let $ab934420c334527f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ab934420c334527f$var$load("lgbIp").then(()=>parcelRequire('9mEOd'));

});




parcelRegister("jXIBH", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsGlobalFieldsRouteEntry", () => $22db189ea3edd0f3$export$e29465c661741392);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $2MVvM = parcelRequire("2MVvM");

var $8kB6m = parcelRequire("8kB6m");
const $22db189ea3edd0f3$export$e29465c661741392 = (0, $6xToB.createEntry)((0, $2MVvM.polarisSettingsGlobalFieldsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $8kB6m.polarisProductGlobalFieldsSettingsPageEntryPoint;
        }
    }));

});
parcelRegister("2MVvM", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsGlobalFieldsRoute", () => $84f1e8dd3752fa62$export$d1d77b6a84982ab8);
const $84f1e8dd3752fa62$export$d1d77b6a84982ab8 = {
    name: 'polaris-settings-global-fields',
    path: '/jira/settings/products/jira-product-discovery/global-fields',
    exact: true
};

});

parcelRegister("8kB6m", function(module, exports) {

$parcel$export(module.exports, "polarisProductGlobalFieldsSettingsPageEntryPoint", () => $ab23368ee389dfed$export$c682ebcd2290352f);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $l8hS0 = parcelRequire("l8hS0");
const $ab23368ee389dfed$export$c682ebcd2290352f = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $l8hS0.polarisProductGlobalFieldsSettingsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("l8hS0", function(module, exports) {

$parcel$export(module.exports, "polarisProductGlobalFieldsSettingsEntryPoint", () => $03ad3703d58cfb6d$export$f2f24531058bc251);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $03ad3703d58cfb6d$export$f2f24531058bc251 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("gdJTc")), {
        moduleId: "fead11bc",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gdJTc", function(module, exports) {

let $bcf174e720fee885$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $bcf174e720fee885$var$load("1VRB2"),
    $bcf174e720fee885$var$load("bABhq"),
    $bcf174e720fee885$var$load("leTHM")
]).then(()=>parcelRequire('49xmL'));

});




parcelRegister("f0kp3", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsViewBlueprintsRouteEntry", () => $88bc143b1e8c96d7$export$3a434d3b47ab1779);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $7jTnu = parcelRequire("7jTnu");

var $9BJU1 = parcelRequire("9BJU1");

var $9NmsS = parcelRequire("9NmsS");

var $cVkb1 = parcelRequire("cVkb1");

var $8Cky9 = parcelRequire("8Cky9");
const $88bc143b1e8c96d7$export$3a434d3b47ab1779 = (0, $6xToB.createEntry)((0, $cVkb1.polarisSettingsViewBlueprintsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        component: (0, $9BJU1.default),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return (0, $7jTnu.fg)('jpd-view-templates-sample-project') ? (0, $8Cky9.polarisProductViewBlueprintsSettingsPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("cVkb1", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsViewBlueprintsRoute", () => $d752382140b053dc$export$8a86f742c99c33c);
const $d752382140b053dc$export$8a86f742c99c33c = {
    name: 'polaris-settings-view-blueprints',
    path: '/jira/settings/products/jira-product-discovery/view-blueprints',
    exact: true
};

});

parcelRegister("8Cky9", function(module, exports) {

$parcel$export(module.exports, "polarisProductViewBlueprintsSettingsPageEntryPoint", () => $bd6a3e5257fb6968$export$b38d612b8eddc59a);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $3pvil = parcelRequire("3pvil");
const $bd6a3e5257fb6968$export$b38d612b8eddc59a = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $3pvil.polarisProductViewBlueprintsSettingsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("3pvil", function(module, exports) {

$parcel$export(module.exports, "polarisProductViewBlueprintsSettingsEntryPoint", () => $16c0d464d48543a1$export$39c56d81a6a3e673);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $16c0d464d48543a1$export$39c56d81a6a3e673 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("3rn0l")), {
        moduleId: "a9a1a8f1",
        moduleName: "PolarisViewBlueprintsSettingsPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3rn0l", function(module, exports) {

let $2815bcea26231b13$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2815bcea26231b13$var$load("8662U").then(()=>parcelRequire('cmt3m'));

});




parcelRegister("1zTPx", function(module, exports) {

$parcel$export(module.exports, "polarisUnlicensedRouteEntry", () => $5f6321715f461ebe$export$f975154b9b0ce777);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $ho9E1 = parcelRequire("ho9E1");

var $eOU53 = parcelRequire("eOU53");

var $Iw9hP = parcelRequire("Iw9hP");
const $5f6321715f461ebe$export$f975154b9b0ce777 = (0, $6xToB.createEntry)((0, $eOU53.polarisUnlicensedRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        component: (0, $Iw9hP.default),
        layout: (0, $7h3uc.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $ho9E1.projectCreatePermissionsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $Iw9hP.LazyUnlicensedPage)
        ]
    }));

});
parcelRegister("eOU53", function(module, exports) {

$parcel$export(module.exports, "polarisUnlicensedRoute", () => $e487e09687394076$export$32b1bc71501d2751);
const $e487e09687394076$export$32b1bc71501d2751 = {
    name: 'polaris-unlicensed',
    path: '/jira/polaris/unlicensed',
    exact: true
};

});

parcelRegister("Iw9hP", function(module, exports) {

$parcel$export(module.exports, "LazyUnlicensedPage", () => $d8e94c1162596627$export$394984ca86b38b8f);
$parcel$export(module.exports, "default", () => $d8e94c1162596627$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $d8e94c1162596627$export$394984ca86b38b8f = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2qjoS"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/unlicensed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d8e94c1162596627$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d8e94c1162596627$export$394984ca86b38b8f,
        pageId: "async-polaris-unlicensed",
        shouldShowSpinner: false
    });

});
parcelRegister("2qjoS", function(module, exports) {

let $1c3d0ef6ec7751eb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1c3d0ef6ec7751eb$var$load("9XQ7l").then(()=>parcelRequire('4eAP9'));

});



parcelRegister("hpFrr", function(module, exports) {

$parcel$export(module.exports, "productsJcsCustomerAccessRouteEntry", () => $5a003be32277141a$export$487fd1bbb9f3684e);

var $7jTnu = parcelRequire("7jTnu");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $hSYtN = parcelRequire("hSYtN");

var $1lFEV = parcelRequire("1lFEV");

var $9BJU1 = parcelRequire("9BJU1");

var $ahfWb = parcelRequire("ahfWb");

var $aIVyX = parcelRequire("aIVyX");
const $5a003be32277141a$var$productsJcsCustomerAccessEntryPointPage = (0, $g8uYY.createPageEntryPoint)({
    main: $1lFEV.productsJcsCustomerAccessEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $5a003be32277141a$export$487fd1bbb9f3684e = (0, $6xToB.createEntry)((0, $hSYtN.productsJcsCustomerAccessRoute), ()=>({
        group: 'global-settings',
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $7jTnu.fg)('jcs_master_flag') ? $5a003be32277141a$var$productsJcsCustomerAccessEntryPointPage : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $aIVyX.jsmGlobalCustomerAccessSettingsResource),
            (0, $ahfWb.jsmGlobalCustomerAccessAffectedProjectsResource)
        ]
    }));

});
parcelRegister("hSYtN", function(module, exports) {

$parcel$export(module.exports, "productsJcsCustomerAccessRoute", () => $babde1fb28d35ab4$export$db5278559525ffee);
const $babde1fb28d35ab4$export$db5278559525ffee = {
    name: 'products-jcs-customer-access',
    path: '/jira/settings/products/customerservice/customer-access',
    exact: true
};

});

parcelRegister("1lFEV", function(module, exports) {

$parcel$export(module.exports, "productsJcsCustomerAccessEntryPoint", () => $44672c42270cfc54$export$a10305920ea7bd7);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $44672c42270cfc54$export$a10305920ea7bd7 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("bKtF9")), {
        moduleId: "d1f6773e",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bKtF9", function(module, exports) {

let $88db000002601bb9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $88db000002601bb9$var$load("k98lY").then(()=>parcelRequire('gHrFG'));

});


parcelRegister("ahfWb", function(module, exports) {

$parcel$export(module.exports, "jsmGlobalCustomerAccessAffectedProjectsResource", () => $9619dcb374b8b212$export$f27acbd4701f5dfe);

var $l1VxS = parcelRequire("l1VxS");

const $9619dcb374b8b212$var$ONE_DAY_IN_MILLIS = 86400000;

const $9619dcb374b8b212$export$f27acbd4701f5dfe = (0, $l1VxS.createResource)({
    type: (0, $3df83461405be280$export$341f26dde034af5b),
    getKey: ()=>'affected-projects',
    getDataLoader: ()=>(parcelRequire("6E9y5")),
    maxAge: $9619dcb374b8b212$var$ONE_DAY_IN_MILLIS
});

});
const $3df83461405be280$export$341f26dde034af5b = 'JSM_CUSTOMER_ACCESS_AFFECTED_PROJECTS';
const $3df83461405be280$export$eb7818fb178a80b4 = 'JSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS';

parcelRegister("6E9y5", function(module, exports) {

let $4d6de2ae3d18fa6d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4d6de2ae3d18fa6d$var$load("gAtOL").then(()=>parcelRequire('60RsL'));

});


parcelRegister("aIVyX", function(module, exports) {

$parcel$export(module.exports, "jsmGlobalCustomerAccessSettingsResource", () => $d0ecaad6def73d7e$export$b1a50ad717b4ca61);

var $l1VxS = parcelRequire("l1VxS");

const $d0ecaad6def73d7e$var$ONE_DAY_IN_MILLIS = 86400000;

const $d0ecaad6def73d7e$export$b1a50ad717b4ca61 = (0, $l1VxS.createResource)({
    type: (0, $3df83461405be280$export$eb7818fb178a80b4),
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("7WGgP")),
    maxAge: $d0ecaad6def73d7e$var$ONE_DAY_IN_MILLIS
});

});
parcelRegister("7WGgP", function(module, exports) {

let $5c8ebd365593178b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5c8ebd365593178b$var$load("aXz7T").then(()=>parcelRequire('9Muer'));

});



parcelRegister("deNkw", function(module, exports) {

$parcel$export(module.exports, "productsJcsFormFieldsRouteEntry", () => $726ffe8edb0b2559$export$ce43ae01ccf4d9b6);

var $7jTnu = parcelRequire("7jTnu");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $etpAj = parcelRequire("etpAj");

var $91EJO = parcelRequire("91EJO");

var $9BJU1 = parcelRequire("9BJU1");

var $94sCg = parcelRequire("94sCg");
const $726ffe8edb0b2559$var$productsJcsFormFieldsEntryPointPage = (0, $g8uYY.createPageEntryPoint)({
    main: $91EJO.productsJcsFormFieldsEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $726ffe8edb0b2559$export$ce43ae01ccf4d9b6 = (0, $6xToB.createEntry)((0, $etpAj.productsJcsFormFieldsRoute), ()=>({
        group: 'global-settings',
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $7jTnu.fg)('jcs_forms_resiliency_fast_follows') ? $726ffe8edb0b2559$var$productsJcsFormFieldsEntryPointPage : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $94sCg.formFieldsResource)
        ]
    }));

});
parcelRegister("etpAj", function(module, exports) {

$parcel$export(module.exports, "productsJcsFormFieldsRoute", () => $bccff6db6e0640a2$export$ace810399baa80ca);
const $bccff6db6e0640a2$export$ace810399baa80ca = {
    name: 'products-jcs-form-fields',
    path: '/jira/settings/products/customerservice/form-fields',
    exact: true
};

});

parcelRegister("91EJO", function(module, exports) {

$parcel$export(module.exports, "productsJcsFormFieldsEntryPoint", () => $4d8c7fe486443d5d$export$4afec7b2100b3396);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $4d8c7fe486443d5d$export$4afec7b2100b3396 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("i5XOH")), {
        moduleId: "b263f162",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("i5XOH", function(module, exports) {

let $d2c717f8655681d6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d2c717f8655681d6$var$load("2R1Do").then(()=>parcelRequire('ku91u'));

});


parcelRegister("94sCg", function(module, exports) {

$parcel$export(module.exports, "setSearchFieldsFormQuery", () => $6d924f0867c57d4a$export$52917d9e09f11230);
$parcel$export(module.exports, "formFieldsResource", () => $6d924f0867c57d4a$export$cf387af041de8a73);

var $l1VxS = parcelRequire("l1VxS");

var $1Ozm9 = parcelRequire("1Ozm9");

var $erGGa = parcelRequire("erGGa");
const $6d924f0867c57d4a$export$2345ec6675b232f1 = {};
const $6d924f0867c57d4a$export$52917d9e09f11230 = (query)=>{
    $6d924f0867c57d4a$export$2345ec6675b232f1.query = query;
};
const $6d924f0867c57d4a$export$cf387af041de8a73 = (0, $l1VxS.createResource)({
    type: 'FORM_FIELDS_RESOURCE',
    // The query.page in getData() is cached, and only changes if getKey() returns a new value
    getKey: ({ query: query })=>`form-fields${query?.page || 1}`,
    getData: async ({ query: query })=>(0, $1Ozm9.default)((0, $erGGa.getUrl)(query?.page, $6d924f0867c57d4a$export$2345ec6675b232f1.query)),
    maxAge: 0
});

});
parcelRegister("erGGa", function(module, exports) {

$parcel$export(module.exports, "PAGE_SIZE", () => $9ecf94d73a482182$export$8ec3d08588d2eeda);
$parcel$export(module.exports, "getUrl", () => $9ecf94d73a482182$export$94df0e59ebebf4a7);
const $9ecf94d73a482182$export$8ec3d08588d2eeda = 50;
const $9ecf94d73a482182$var$getStartAt = (page)=>{
    const pageNum = Number(page);
    if (!page || Number.isNaN(pageNum)) return 0;
    return (pageNum - 1) * $9ecf94d73a482182$export$8ec3d08588d2eeda;
};
const $9ecf94d73a482182$export$94df0e59ebebf4a7 = (page, query)=>`/rest/jcs/admin/v1/request-intake/global-fields?startAt=${$9ecf94d73a482182$var$getStartAt(page)}${query ? `&query=${query}` : ''}`;

});



parcelRegister("b89Z5", function(module, exports) {

$parcel$export(module.exports, "productsJsmAuthenticationSettingsRouteEntry", () => $bec2eb907dbda6a2$export$de5cc5a334946074);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $8zxNY = parcelRequire("8zxNY");

var $9NmsS = parcelRequire("9NmsS");

var $7nP1r = parcelRequire("7nP1r");

var $9LwVv = parcelRequire("9LwVv");
const $bec2eb907dbda6a2$export$de5cc5a334946074 = (0, $6xToB.createEntry)((0, $7nP1r.productsJsmAuthenticationSettingsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-authentication-settings',
        component: (0, $9LwVv.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $8zxNY.jsmCustomerAuthenticationSettingsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9LwVv.LazyAuthenticationSettings)
        ]
    }));

});
parcelRegister("8zxNY", function(module, exports) {

$parcel$export(module.exports, "jsmCustomerAuthenticationSettingsResource", () => $dba45a17633e4999$export$73134c05a3c27bd);

var $l1VxS = parcelRequire("l1VxS");

var $aXJWD = parcelRequire("aXJWD");

const $dba45a17633e4999$export$73134c05a3c27bd = (0, $l1VxS.createResource)({
    type: (0, $aXJWD.RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS),
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("epoxK")),
    maxAge: (0, $aXJWD.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("aXJWD", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS", () => $5bd3ad00ba14ad29$export$6a2799d78d98b915);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $5bd3ad00ba14ad29$export$5a00268156ea5027);
const $5bd3ad00ba14ad29$export$6a2799d78d98b915 = 'JSM_CUSTOMER_AUTHENTICATION_SETTINGS';
const $5bd3ad00ba14ad29$export$5a00268156ea5027 = 86400000;

});

parcelRegister("epoxK", function(module, exports) {

let $a7d67044f2fc4e71$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a7d67044f2fc4e71$var$load("389p2").then(()=>parcelRequire('31JhY'));

});


parcelRegister("7nP1r", function(module, exports) {

$parcel$export(module.exports, "productsJsmAuthenticationSettingsRoute", () => $ab26972f5d90ccba$export$6395086ce7e72e37);
const $ab26972f5d90ccba$export$6395086ce7e72e37 = {
    name: 'products-jsm-authentication-settings',
    path: '/jira/settings/products/servicedesk/authentication',
    exact: true
};

});

parcelRegister("9LwVv", function(module, exports) {

$parcel$export(module.exports, "LazyAuthenticationSettings", () => $154d14dfb9d3f072$export$6cd59b0135f3fe86);
$parcel$export(module.exports, "default", () => $154d14dfb9d3f072$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $154d14dfb9d3f072$export$6cd59b0135f3fe86 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("9oIrA"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-authentication-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$154d14dfb9d3f072$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $154d14dfb9d3f072$export$6cd59b0135f3fe86,
        pageId: "spa-apps/admin-pages/jsm-authentication-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("9oIrA", function(module, exports) {

let $6d78d4912f30e083$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6d78d4912f30e083$var$load("8Tnpa").then(()=>parcelRequire('az2Jc'));

});



parcelRegister("i7x71", function(module, exports) {

$parcel$export(module.exports, "productsJsmChatopsAndVideosToolsRouteEntry", () => $10e8e9e9f5c20c58$export$8b55e723205ec5f3);

var $igNUx = parcelRequire("igNUx");

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $kaTH9 = parcelRequire("kaTH9");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $4Bp9F = parcelRequire("4Bp9F");
const $10e8e9e9f5c20c58$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $10e8e9e9f5c20c58$export$8b55e723205ec5f3 = (0, $6xToB.createEntry)((0, $kaTH9.productsJsmChatopsAndVideosToolsRoute), ()=>({
        group: 'global-settings',
        component: (0, $f2JN3.componentWithCondition)((0, $igNUx.isFedRamp), (0, $9BJU1.default), (0, $4Bp9F.default)),
        layout: (0, $iRfwO.opsSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$10e8e9e9f5c20c58$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4Bp9F.LazyProductsJsmChatopsAndVideoTools)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4Bp9F.LazyProductsJsmChatopsAndVideoTools)
        ]
    }));

});
parcelRegister("kaTH9", function(module, exports) {

$parcel$export(module.exports, "productsJsmChatopsAndVideosToolsRoute", () => $e00d1fa7828f8587$export$7c663ddc097df1e8);
const $e00d1fa7828f8587$export$7c663ddc097df1e8 = {
    name: 'products-jsm-chatops-and-videos-tools',
    path: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
    exact: true
};

});

parcelRegister("4Bp9F", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmChatopsAndVideoTools", () => $f74523e588532407$export$1b7f55251df02fe9);
$parcel$export(module.exports, "default", () => $f74523e588532407$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $f74523e588532407$export$1b7f55251df02fe9 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7oZ7F"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-chatops-and-video-tools/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f74523e588532407$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f74523e588532407$export$1b7f55251df02fe9,
        pageId: "products-jsm-chatops-and-video-tools",
        shouldShowSpinner: false
    });

});
parcelRegister("7oZ7F", function(module, exports) {

let $563a2ff80a830c19$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $563a2ff80a830c19$var$load("1VRB2"),
    $563a2ff80a830c19$var$load("bABhq"),
    $563a2ff80a830c19$var$load("gjgTL")
]).then(()=>parcelRequire('a7dE6'));

});



parcelRegister("iifeU", function(module, exports) {

$parcel$export(module.exports, "productsJsmComplianceRouteEntry", () => $6cacc33288024805$export$9cc9423a3967333b);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $i6IhW = parcelRequire("i6IhW");

var $jibk1 = parcelRequire("jibk1");
const $6cacc33288024805$export$9cc9423a3967333b = (0, $6xToB.createEntry)((0, $i6IhW.productsJsmComplianceRoute), ()=>({
        group: 'global-settings',
        component: (0, $jibk1.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jibk1.LazyProductsJsmCompliance)
        ],
        ufoName: 'admin.jsm-compliance'
    }));

});
parcelRegister("i6IhW", function(module, exports) {

$parcel$export(module.exports, "productsJsmComplianceRoute", () => $7472dad0721ea8a7$export$6196bf08f64419da);
const $7472dad0721ea8a7$export$6196bf08f64419da = {
    name: 'products-jsm-compliance',
    path: '/jira/settings/products/jira-service-management-compliance',
    exact: true
};

});

parcelRegister("jibk1", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmCompliance", () => $f88b58239d879054$export$159d8c0e1862cd2b);
$parcel$export(module.exports, "default", () => $f88b58239d879054$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $f88b58239d879054$export$159d8c0e1862cd2b = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("aVbuo"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-compliance/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f88b58239d879054$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f88b58239d879054$export$159d8c0e1862cd2b,
        pageId: "products-jsm-compliance",
        shouldShowSpinner: false
    });

});
parcelRegister("aVbuo", function(module, exports) {

let $7f3823c6835bd4da$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7f3823c6835bd4da$var$load("890eO").then(()=>parcelRequire('lWLYN'));

});



parcelRegister("6szZq", function(module, exports) {

$parcel$export(module.exports, "productsJsmConfigurationRouteEntry", () => $e26b049835a3ea5e$export$461f2b06a7a914db);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9SDiu = parcelRequire("9SDiu");

var $dHxg4 = parcelRequire("dHxg4");
const $e26b049835a3ea5e$export$461f2b06a7a914db = (0, $6xToB.createEntry)((0, $9SDiu.productsJsmConfigurationRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-configuration',
        component: (0, $dHxg4.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dHxg4.LazyProductsJsmConfiguration)
        ]
    }));

});
parcelRegister("9SDiu", function(module, exports) {

$parcel$export(module.exports, "productsJsmConfigurationRoute", () => $ced3bdc4503d5ae7$export$2ad48fbde4743a97);
const $ced3bdc4503d5ae7$export$2ad48fbde4743a97 = {
    name: 'products-jsm-configuration',
    path: '/jira/settings/products/jira-service-management-configuration',
    exact: true
};

});

parcelRegister("dHxg4", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmConfiguration", () => $212a160e375066dc$export$aa3f3d5ca376f305);
$parcel$export(module.exports, "default", () => $212a160e375066dc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $212a160e375066dc$export$aa3f3d5ca376f305 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("aGGmi"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-configuration/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$212a160e375066dc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $212a160e375066dc$export$aa3f3d5ca376f305,
        pageId: "products-jsm-configuration",
        shouldShowSpinner: false
    });

});
parcelRegister("aGGmi", function(module, exports) {

let $7c7eaf275d38574e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7c7eaf275d38574e$var$load("kzWa3").then(()=>parcelRequire('6EsK2'));

});



parcelRegister("bWhAh", function(module, exports) {

$parcel$export(module.exports, "productsJsmCustomerAccessRouteEntry", () => $f81d4ec847013e7d$export$d014f5ba2dec6c16);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $ahfWb = parcelRequire("ahfWb");

var $aIVyX = parcelRequire("aIVyX");

var $9NmsS = parcelRequire("9NmsS");

var $kgwNf = parcelRequire("kgwNf");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $f81d4ec847013e7d$var$LazyCustomerAccess = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("jOWFO"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/customer-access/src/index.tsx"
});
const $f81d4ec847013e7d$var$ServiceDeskCustomerAccess = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f81d4ec847013e7d$var$LazyCustomerAccess,
        pageId: "spa-apps/admin-pages/customer-access",
        shouldShowSpinner: false
    });
const $f81d4ec847013e7d$export$d014f5ba2dec6c16 = (0, $6xToB.createEntry)((0, $kgwNf.productsJsmCustomerAccessRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-customer-access',
        component: $f81d4ec847013e7d$var$ServiceDeskCustomerAccess,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $aIVyX.jsmGlobalCustomerAccessSettingsResource),
            (0, $ahfWb.jsmGlobalCustomerAccessAffectedProjectsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $f81d4ec847013e7d$var$LazyCustomerAccess
        ]
    }));

});
parcelRegister("kgwNf", function(module, exports) {

$parcel$export(module.exports, "productsJsmCustomerAccessRoute", () => $fa2fb26e28bbc0c4$export$b97e3b6231be8149);
const $fa2fb26e28bbc0c4$export$b97e3b6231be8149 = {
    name: 'products-jsm-customer-access',
    path: '/jira/settings/products/servicedesk/customer-access',
    exact: true
};

});

parcelRegister("jOWFO", function(module, exports) {

let $e6e03321b541bd38$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e6e03321b541bd38$var$load("anKqS").then(()=>parcelRequire('6faJr'));

});


parcelRegister("e8aTE", function(module, exports) {

$parcel$export(module.exports, "productsJsmEmailRequestsRouteEntry", () => $2bdefbfd0f952728$export$3f8d7424a47f4dd);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $3Lc9W = parcelRequire("3Lc9W");

var $10mYx = parcelRequire("10mYx");
const $2bdefbfd0f952728$export$3f8d7424a47f4dd = (0, $6xToB.createEntry)((0, $3Lc9W.productsJsmEmailRequestsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-email-requests',
        component: (0, $10mYx.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $10mYx.LazyProductsJsmEmailRequests)
        ]
    }));

});
parcelRegister("3Lc9W", function(module, exports) {

$parcel$export(module.exports, "productsJsmEmailRequestsRoute", () => $413e7c9d83f89f77$export$6288bb6ea42acf0c);
const $413e7c9d83f89f77$export$6288bb6ea42acf0c = {
    name: 'products-jsm-email-requests',
    path: '/jira/settings/products/jira-service-management-email-requests',
    exact: true
};

});

parcelRegister("10mYx", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmEmailRequests", () => $897f8688e3c4c26f$export$4c9d90d0caf04d67);
$parcel$export(module.exports, "default", () => $897f8688e3c4c26f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $897f8688e3c4c26f$export$4c9d90d0caf04d67 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("aMRNy"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-email-requests/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$897f8688e3c4c26f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $897f8688e3c4c26f$export$4c9d90d0caf04d67,
        pageId: "products-jsm-email-requests",
        shouldShowSpinner: false
    });

});
parcelRegister("aMRNy", function(module, exports) {

let $7da81e46b50bf3cc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7da81e46b50bf3cc$var$load("1VRB2"),
    $7da81e46b50bf3cc$var$load("bABhq"),
    $7da81e46b50bf3cc$var$load("g9SxB")
]).then(()=>parcelRequire('aWUbc'));

});



parcelRegister("iIHov", function(module, exports) {

$parcel$export(module.exports, "productsJsmFeatureUsageRouteEntry", () => $04835712f82e9b4c$export$80a3e4dda2dcd1a4);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $kY2I8 = parcelRequire("kY2I8");

var $ePaI2 = parcelRequire("ePaI2");

var $bb6oX = parcelRequire("bb6oX");
const $04835712f82e9b4c$export$80a3e4dda2dcd1a4 = (0, $6xToB.createEntry)((0, $kY2I8.productsJsmFeatureUsageRoute), ()=>({
        group: 'global-settings',
        component: (0, $bb6oX.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bb6oX.LazyProductsJsmFeatureUsage)
        ]
    }));

});
parcelRegister("kY2I8", function(module, exports) {

$parcel$export(module.exports, "productsJsmFeatureUsageRoute", () => $917783885bc19032$export$f98dec539fffaa15);
const $917783885bc19032$export$f98dec539fffaa15 = {
    name: 'products-jsm-feature-usage',
    path: '/jira/settings/products/servicedesk/feature-usage',
    exact: true
};

});

parcelRegister("bb6oX", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmFeatureUsage", () => $eaf6457f4f0134b4$export$5ad1c1e822bd5d34);
$parcel$export(module.exports, "default", () => $eaf6457f4f0134b4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $eaf6457f4f0134b4$export$5ad1c1e822bd5d34 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("cgroZ"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-feature-usage/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eaf6457f4f0134b4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $eaf6457f4f0134b4$export$5ad1c1e822bd5d34,
        pageId: "products-jsm-feature-usage",
        shouldShowSpinner: false
    });

});
parcelRegister("cgroZ", function(module, exports) {

let $8edc3c23e1d05378$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $8edc3c23e1d05378$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $8edc3c23e1d05378$var$load("deNlq")
        ]);
    }),
    $8edc3c23e1d05378$var$load("dEJaw")
]).then(()=>parcelRequire('gFzIn'));

});



parcelRegister("iuWdX", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRedirectRouteEntry", () => $831a426e56f151f9$export$289cc03f2eacd57a);

var $1vFVi = parcelRequire("1vFVi");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $feceW = parcelRequire("feceW");

var $dj700 = parcelRequire("dj700");
const $831a426e56f151f9$export$289cc03f2eacd57a = (0, $6xToB.createEntry)((0, $feceW.productsJsmGlobalOpsReportsRedirectRoute), ()=>({
        group: 'global-settings',
        component: (0, $dj700.OpsReportsRedirect),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $1vFVi.resources)(),
            (0, $1vFVi.opsReportsPermissionResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dj700.LazyGlobalOpsReports)
        ]
    }));

});
parcelRegister("feceW", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRedirectRoute", () => $7fe9eb30ea5dc240$export$c6d42e4b4a63248d);
const $7fe9eb30ea5dc240$export$c6d42e4b4a63248d = {
    name: 'products-jsm-global-ops-reports',
    path: '/jira/settings/products/ops/reports',
    exact: true
};

});

parcelRegister("dj700", function(module, exports) {

$parcel$export(module.exports, "LazyOpsReportsRedirect", () => $1f2606b570edae39$export$d33ea1a773b744e);
$parcel$export(module.exports, "LazyGlobalOpsReports", () => $1f2606b570edae39$export$66850ec5549adba6);
$parcel$export(module.exports, "OpsReportsRedirect", () => $1f2606b570edae39$export$22253dbadb46d0cf);
$parcel$export(module.exports, "GlobalOpsReports", () => $1f2606b570edae39$export$648ddf2d1f8b1c3f);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $1f2606b570edae39$export$2404f0e35deca592 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("5RGml")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $1f2606b570edae39$export$d33ea1a773b744e = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("5RGml")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $1f2606b570edae39$export$66850ec5549adba6 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("5RGml")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $1f2606b570edae39$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1f2606b570edae39$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
const $1f2606b570edae39$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1f2606b570edae39$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
const $1f2606b570edae39$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1f2606b570edae39$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });

});


parcelRegister("1hrj9", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRouteEntry", () => $8250c680c9a9f5f3$export$6a7fc41fb2523290);

var $1vFVi = parcelRequire("1vFVi");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $esB62 = parcelRequire("esB62");

var $dj700 = parcelRequire("dj700");
const $8250c680c9a9f5f3$export$6a7fc41fb2523290 = (0, $6xToB.createEntry)((0, $esB62.productsJsmGlobalOpsReportsRoute), ()=>({
        group: 'global-settings',
        component: (0, $dj700.GlobalOpsReports),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $1vFVi.resources)(),
            (0, $1vFVi.opsReportsPermissionResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dj700.LazyOpsReportsRedirect)
        ]
    }));

});
parcelRegister("esB62", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRoute", () => $0e7185d3fc20969c$export$d92d66762943b115);
const $0e7185d3fc20969c$export$d92d66762943b115 = {
    name: 'products-jsm-global-ops-reports',
    path: '/jira/settings/products/ops/reports/:dashboardId',
    exact: true
};

});


parcelRegister("aanGM", function(module, exports) {

$parcel$export(module.exports, "productsJsmIncidentManagementToolsRouteEntry", () => $d8b9c9cbdf53af8a$export$773f8e3318be1dd5);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $ixJHn = parcelRequire("ixJHn");

var $hAARs = parcelRequire("hAARs");
const $d8b9c9cbdf53af8a$export$773f8e3318be1dd5 = (0, $6xToB.createEntry)((0, $ixJHn.productsJsmIncidentManagementToolsRoute), ()=>({
        group: 'global-settings',
        component: (0, $hAARs.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $hAARs.LazyProductsJsmIncidentManagementTools)
        ]
    }));

});
parcelRegister("ixJHn", function(module, exports) {

$parcel$export(module.exports, "productsJsmIncidentManagementToolsRoute", () => $b65f029ad5edf478$export$da6d538ddabade32);
const $b65f029ad5edf478$export$da6d538ddabade32 = {
    name: 'products-jsm-incident-management-tools',
    path: '/jira/settings/products/jira-service-management-incident-management-tools',
    exact: true
};

});

parcelRegister("hAARs", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmIncidentManagementTools", () => $d6693f589420e9c1$export$f541eb9b8f00bfaf);
$parcel$export(module.exports, "default", () => $d6693f589420e9c1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $d6693f589420e9c1$export$f541eb9b8f00bfaf = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("cAgB1"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-incident-management-tools/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d6693f589420e9c1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d6693f589420e9c1$export$f541eb9b8f00bfaf,
        pageId: "products-jsm-incident-management-tools",
        shouldShowSpinner: false
    });

});
parcelRegister("cAgB1", function(module, exports) {

let $9295b87d3275f995$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $9295b87d3275f995$var$load("1VRB2"),
    $9295b87d3275f995$var$load("bABhq"),
    $9295b87d3275f995$var$load("3H0kp")
]).then(()=>parcelRequire('6Xyby'));

});



parcelRegister("35zIt", function(module, exports) {

$parcel$export(module.exports, "productsJsmKbPermissionsRouteEntry", () => $471fd988ccae382f$export$717e134eb971b450);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $lS0Ni = parcelRequire("lS0Ni");

var $8vM62 = parcelRequire("8vM62");
const $471fd988ccae382f$export$717e134eb971b450 = (0, $6xToB.createEntry)((0, $lS0Ni.productsJsmKbPermissionsRoute), ()=>({
        group: 'global-settings',
        component: (0, $8vM62.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8vM62.LazyProductsJsmKbPermissions)
        ]
    }));

});
parcelRegister("lS0Ni", function(module, exports) {

$parcel$export(module.exports, "productsJsmKbPermissionsRoute", () => $ba25a073d185b219$export$339486410c7a783f);
const $ba25a073d185b219$export$339486410c7a783f = {
    name: 'products-jsm-kb-permissions',
    path: '/jira/settings/products/jira-service-management-knowledge-base-permissions',
    exact: true
};

});

parcelRegister("8vM62", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmKbPermissions", () => $1e0ed0555920a229$export$a3e7bdc5dbf2d47e);
$parcel$export(module.exports, "default", () => $1e0ed0555920a229$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $1e0ed0555920a229$export$a3e7bdc5dbf2d47e = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ghg0k"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-kb-permissions/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1e0ed0555920a229$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1e0ed0555920a229$export$a3e7bdc5dbf2d47e,
        pageId: "products-jsm-kb-permissions",
        shouldShowSpinner: false
    });

});
parcelRegister("ghg0k", function(module, exports) {

let $bd9aa5feb8a6b509$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bd9aa5feb8a6b509$var$load("eNxJy").then(()=>parcelRequire('chRFA'));

});



parcelRegister("7V5F5", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsDetailsRouteEntry", () => $399a4bc41718c68e$export$f7b6cda88404733e);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $czabB = parcelRequire("czabB");

var $3OsCM = parcelRequire("3OsCM");

var $eAm8a = parcelRequire("eAm8a");

var $1JTub = parcelRequire("1JTub");

var $9NmsS = parcelRequire("9NmsS");

var $2RCde = parcelRequire("2RCde");

var $5qjxt = parcelRequire("5qjxt");
const $399a4bc41718c68e$export$f7b6cda88404733e = (0, $6xToB.createEntry)((0, $2RCde.productsJsmOrganizationsDetailsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-organization-page-list',
        isRedirect: false,
        component: (0, $5qjxt.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $3OsCM.productsJsmOrganizationDetailsResource),
            (0, $eAm8a.productsJsmOrganizationMembersResource),
            (0, $1JTub.productsJsmOrganizationListResource),
            (0, $czabB.jsmEmailDomainsListResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $5qjxt.LazyProductsJsmOrganizationDetails)
        ]
    }));

});
parcelRegister("czabB", function(module, exports) {

$parcel$export(module.exports, "jsmEmailDomainsListResource", () => $f31fe5e5165a82b6$export$8e956348e5d47a3c);

var $l1VxS = parcelRequire("l1VxS");


const $f31fe5e5165a82b6$export$8e956348e5d47a3c = (0, $l1VxS.createResource)({
    type: (0, $e0c2d30570ac08fb$export$2bde433b962efbdd),
    getKey: ()=>'email-domains-list',
    isBrowserOnly: true,
    getDataLoader: ()=>(parcelRequire("3jAmy"))
});

});
const $e0c2d30570ac08fb$export$2bde433b962efbdd = 'JSM_EMAIL_DOMAINS_LIST';

parcelRegister("3jAmy", function(module, exports) {

let $269f5a593c6fbab3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $269f5a593c6fbab3$var$load("6dx7e").then(()=>parcelRequire('1hCRG'));

});


parcelRegister("3OsCM", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationDetailsResource", () => $3653d199bce0332c$export$ccda79811a15bf5);

var $l1VxS = parcelRequire("l1VxS");


const $3653d199bce0332c$export$ccda79811a15bf5 = (0, $l1VxS.createResource)({
    type: (0, $db3054255b7b598f$export$52408f1a0f23569a),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("aMCO5"))
});

});
const $db3054255b7b598f$export$52408f1a0f23569a = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS';

parcelRegister("aMCO5", function(module, exports) {

let $7d9c7d4dcfdc085a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7d9c7d4dcfdc085a$var$load("jDnc6").then(()=>parcelRequire('28dfS'));

});


parcelRegister("eAm8a", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationMembersResource", () => $aab4d5617df7716d$export$65c7941bd3e14d00);

var $l1VxS = parcelRequire("l1VxS");

const $aab4d5617df7716d$var$TEN_SECONDS_IN_MILLIS = 10000;

const $aab4d5617df7716d$export$65c7941bd3e14d00 = (0, $l1VxS.createResource)({
    type: (0, $17b6b4e6f34ab8b9$export$d3eec3e4b4eac6ac),
    getKey: (routerContext)=>`OrganizationMembers-${routerContext.match.params.organizationId}-${routerContext.query.page}-${routerContext.query.query}`,
    getDataLoader: ()=>(parcelRequire("7NCiH")),
    maxAge: $aab4d5617df7716d$var$TEN_SECONDS_IN_MILLIS
});

});
const $17b6b4e6f34ab8b9$export$d3eec3e4b4eac6ac = 'PRODUCT_JSM_ORGANIZATION_MEMBERS';

parcelRegister("7NCiH", function(module, exports) {

let $5adad1b9f632068e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5adad1b9f632068e$var$load("5tHr4").then(()=>parcelRequire('7YOHo'));

});


parcelRegister("1JTub", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationListResource", () => $ed81d61ea3d2ffc7$export$3e38a27ad406d7f7);

var $l1VxS = parcelRequire("l1VxS");

const $ed81d61ea3d2ffc7$var$TEN_SECONDS_IN_MILLIS = 10000;

const $ed81d61ea3d2ffc7$export$3e38a27ad406d7f7 = (0, $l1VxS.createResource)({
    type: (0, $6308f871c220737d$export$50de2841b08b875f),
    getKey: (routerContext)=>routerContext.query.page,
    getDataLoader: ()=>(parcelRequire("591NH")),
    maxAge: $ed81d61ea3d2ffc7$var$TEN_SECONDS_IN_MILLIS
});

});
const $6308f871c220737d$export$50de2841b08b875f = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST';

parcelRegister("591NH", function(module, exports) {

let $3bef309446c50978$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3bef309446c50978$var$load("aNl50").then(()=>parcelRequire('1pQ0C'));

});


parcelRegister("2RCde", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsDetailsRoute", () => $78b9b6cf901ae9e2$export$bc61991d01535831);
const $78b9b6cf901ae9e2$export$bc61991d01535831 = {
    name: 'products-jsm-organizations',
    path: '/jira/settings/products/servicedesk/organizations/:organizationId',
    exact: true
};

});

parcelRegister("5qjxt", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmOrganizationDetails", () => $de8c3e3ab2353fd7$export$ff149ceefa65ab70);
$parcel$export(module.exports, "default", () => $de8c3e3ab2353fd7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $de8c3e3ab2353fd7$export$ff149ceefa65ab70 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fU29r"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organization-details/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$de8c3e3ab2353fd7$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $de8c3e3ab2353fd7$export$ff149ceefa65ab70,
        pageId: "products-jsm-organization-details",
        shouldShowSpinner: true
    });

});
parcelRegister("fU29r", function(module, exports) {

let $b93dc12992f85f72$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b93dc12992f85f72$var$load("KfV30").then(()=>parcelRequire('cYer5'));

});



parcelRegister("lAyQF", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsRouteEntry", () => $71c6011a22782edf$export$34d843946d3894aa);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $1JTub = parcelRequire("1JTub");

var $9NmsS = parcelRequire("9NmsS");

var $dpZfP = parcelRequire("dpZfP");

var $KQkQM = parcelRequire("KQkQM");
const $71c6011a22782edf$export$34d843946d3894aa = (0, $6xToB.createEntry)((0, $dpZfP.productsJsmOrganizationsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-organization-page-list',
        isRedirect: false,
        component: (0, $KQkQM.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $1JTub.productsJsmOrganizationListResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $KQkQM.LazyProductsJsmOrganizations)
        ]
    }));

});
parcelRegister("dpZfP", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsRoute", () => $6cf31810d295ba86$export$512fa30726e0049d);
const $6cf31810d295ba86$export$512fa30726e0049d = {
    name: 'products-jsm-organizations',
    path: '/jira/settings/products/servicedesk/organizations',
    exact: true
};

});

parcelRegister("KQkQM", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmOrganizations", () => $0263ee56cbcce9bc$export$410bec6e06fd4723);
$parcel$export(module.exports, "default", () => $0263ee56cbcce9bc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $0263ee56cbcce9bc$export$410bec6e06fd4723 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("k06oS"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organizations-list/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0263ee56cbcce9bc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $0263ee56cbcce9bc$export$410bec6e06fd4723,
        pageId: "products-jsm-organizations-list",
        shouldShowSpinner: true
    });

});
parcelRegister("k06oS", function(module, exports) {

let $e8f8c5b41244091e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e8f8c5b41244091e$var$load("bumIi").then(()=>parcelRequire('4Fdty'));

});



parcelRegister("9Gw9x", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationRouteEntry", () => $c921c85d99eb870a$export$2f65b1ec4ed05f91);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $vEsck = parcelRequire("vEsck");

var $gKS1S = parcelRequire("gKS1S");

var $330qz = parcelRequire("330qz");
const $c921c85d99eb870a$export$2f65b1ec4ed05f91 = (0, $6xToB.createEntry)((0, $gKS1S.productsJswConfigurationRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsw-configuration',
        component: (0, $330qz.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $vEsck.productsJswConfigurationResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $330qz.LazyProductsJswConfiguration)
        ]
    }));

});
parcelRegister("vEsck", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationResource", () => $67ddd663c88f9bfa$export$b6a5741c2b47fb17);

var $l1VxS = parcelRequire("l1VxS");


const $67ddd663c88f9bfa$export$b6a5741c2b47fb17 = (0, $l1VxS.createResource)({
    type: (0, $80696a591dc12263$export$73be8e1edd21e2d),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("d0ClA"))
});

});
const $80696a591dc12263$export$73be8e1edd21e2d = 'RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION';

parcelRegister("d0ClA", function(module, exports) {

let $9789055faf8f80b9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9789055faf8f80b9$var$load("3qJBf").then(()=>parcelRequire('e0i7w'));

});


parcelRegister("gKS1S", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationRoute", () => $06ca798eb9d59f47$export$decdad53ba9b97af);
const $06ca798eb9d59f47$export$decdad53ba9b97af = {
    name: 'products-jsw-configuration',
    path: '/jira/settings/products/jira-software-configuration',
    exact: true
};

});

parcelRegister("330qz", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJswConfiguration", () => $1760e0706c541113$export$f9a32397033f9ced);
$parcel$export(module.exports, "default", () => $1760e0706c541113$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $1760e0706c541113$export$f9a32397033f9ced = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bNgJA"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-configuration/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1760e0706c541113$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1760e0706c541113$export$f9a32397033f9ced,
        pageId: "products-jsw-configuration",
        shouldShowSpinner: false
    });

});
parcelRegister("bNgJA", function(module, exports) {

let $89614063c4312c85$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $89614063c4312c85$var$load("jZVVE").then(()=>parcelRequire('c3Oit'));

});



parcelRegister("uS0Wn", function(module, exports) {

$parcel$export(module.exports, "productsJswStorageManagementRouteEntry", () => $4eb5364b56c64c9e$export$c62ca2d3fcc552a5);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $8lvaF = parcelRequire("8lvaF");

var $jDfS8 = parcelRequire("jDfS8");

var $b0iFV = parcelRequire("b0iFV");
const $4eb5364b56c64c9e$export$c62ca2d3fcc552a5 = (0, $6xToB.createEntry)((0, $jDfS8.productsJswStorageManagementRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsw-configuration.storage-management',
        component: (0, $b0iFV.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $8lvaF.productsJswStorageManagementResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b0iFV.LazyProductsJswStorageManagement)
        ]
    }));

});
parcelRegister("8lvaF", function(module, exports) {

$parcel$export(module.exports, "productsJswStorageManagementResource", () => $dfa0c0214398d952$export$2cd668845b3478bd);

var $l1VxS = parcelRequire("l1VxS");


const $dfa0c0214398d952$export$2cd668845b3478bd = (0, $l1VxS.createResource)({
    type: (0, $0b5197d9433321af$export$1ac222647be3baf8),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("8ceI7"))
});

});
const $0b5197d9433321af$export$1ac222647be3baf8 = 'RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT';

parcelRegister("8ceI7", function(module, exports) {

let $5f7adaef557a0f72$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5f7adaef557a0f72$var$load("csG29").then(()=>parcelRequire('dK43S'));

});


parcelRegister("jDfS8", function(module, exports) {

$parcel$export(module.exports, "productsJswStorageManagementRoute", () => $d2475c32f47452c4$export$18f0044f00cc3996);
const $d2475c32f47452c4$export$18f0044f00cc3996 = {
    name: 'products-jsw-storage-management',
    path: '/jira/settings/products/jira-software-configuration/storage-management',
    exact: true
};

});

parcelRegister("b0iFV", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJswStorageManagement", () => $ac20c7f9847e6399$export$a4f5e12ce817cbb8);
$parcel$export(module.exports, "default", () => $ac20c7f9847e6399$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ac20c7f9847e6399$export$a4f5e12ce817cbb8 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("9SUgj"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-storage-management/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ac20c7f9847e6399$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ac20c7f9847e6399$export$a4f5e12ce817cbb8,
        pageId: "products-jsw-storage-management",
        shouldShowSpinner: true
    });

});
parcelRegister("9SUgj", function(module, exports) {

let $7324ccb1c398cfab$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7324ccb1c398cfab$var$load("eDzss"),
    $7324ccb1c398cfab$var$load("jMwfF")
]).then(()=>parcelRequire('8su69'));

});



parcelRegister("3CKd6", function(module, exports) {

$parcel$export(module.exports, "productsOnboardingHubCreateRouteEntry", () => $b2c19490c573bc5d$export$666a5dacd00ae9cf);

var $iRwEk = parcelRequire("iRwEk");

var $6xToB = parcelRequire("6xToB");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $yRJUA = parcelRequire("yRJUA");

var $7jTnu = parcelRequire("7jTnu");

var $7jwLG = parcelRequire("7jwLG");

var $9NmsS = parcelRequire("9NmsS");
const $b2c19490c573bc5d$var$productsOnboardingHubCreateEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iRwEk.onboardingHubWizardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $b2c19490c573bc5d$export$666a5dacd00ae9cf = (0, $6xToB.createEntry)((0, $7jwLG.productsOnboardingHubCreateRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return (0, $7jTnu.fg)('jira-onboarding-hub-gate') ? $b2c19490c573bc5d$var$productsOnboardingHubCreateEntryPoint : undefined;
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ]
    }));

});
parcelRegister("iRwEk", function(module, exports) {

$parcel$export(module.exports, "onboardingHubWizardEntryPoint", () => $8aa17551c94a1e06$export$fd5b175ebf56469c);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $8aa17551c94a1e06$export$fd5b175ebf56469c = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("dt5n9")).then((module)=>module.OnboardingWizard), {
        moduleId: "98def470",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                id: context.match.params?.id || ''
            }
        })
});

});
parcelRegister("dt5n9", function(module, exports) {

let $9ce226a3871c4c5e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $9ce226a3871c4c5e$var$load("1VRB2"),
    $9ce226a3871c4c5e$var$load("bABhq"),
    $9ce226a3871c4c5e$var$load("eDzss"),
    $9ce226a3871c4c5e$var$load("gsAEw")
]).then(()=>parcelRequire('23Di4'));

});


parcelRegister("7jwLG", function(module, exports) {

$parcel$export(module.exports, "productsOnboardingHubCreateRoute", () => $6a00e541f7f05ad2$export$a27be1bacf345707);
const $6a00e541f7f05ad2$export$a27be1bacf345707 = {
    name: 'products-onboarding-hub-create',
    path: '/jira/settings/products/onboarding/new'
};

});


parcelRegister("emNcb", function(module, exports) {

$parcel$export(module.exports, "productsOnboardingHubEditRouteEntry", () => $90cf2cfa6a2b0a53$export$a51e527aeaa5756f);

var $iRwEk = parcelRequire("iRwEk");

var $6xToB = parcelRequire("6xToB");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $yRJUA = parcelRequire("yRJUA");

var $7jTnu = parcelRequire("7jTnu");

var $i0ttp = parcelRequire("i0ttp");

var $9NmsS = parcelRequire("9NmsS");
const $90cf2cfa6a2b0a53$var$productsOnboardingHubEditEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iRwEk.onboardingHubWizardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $90cf2cfa6a2b0a53$export$a51e527aeaa5756f = (0, $6xToB.createEntry)((0, $i0ttp.productsOnboardingHubEditRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return (0, $7jTnu.fg)('jira-onboarding-hub-gate') ? $90cf2cfa6a2b0a53$var$productsOnboardingHubEditEntryPoint : undefined;
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ]
    }));

});
parcelRegister("i0ttp", function(module, exports) {

$parcel$export(module.exports, "productsOnboardingHubEditRoute", () => $cb9c40e06f6c2ef7$export$28172feeb183ba94);
const $cb9c40e06f6c2ef7$export$28172feeb183ba94 = {
    name: 'products-onboarding-hub-edit',
    path: '/jira/settings/products/onboarding/:id/edit'
};

});


parcelRegister("bb3Kz", function(module, exports) {

$parcel$export(module.exports, "productsOnboardingHubRouteEntry", () => $bd240a87609a2624$export$114fd427e3931043);

var $6xToB = parcelRequire("6xToB");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $yRJUA = parcelRequire("yRJUA");

var $8cK5I = parcelRequire("8cK5I");

var $7jTnu = parcelRequire("7jTnu");

var $2Kod9 = parcelRequire("2Kod9");

var $9NmsS = parcelRequire("9NmsS");
const $bd240a87609a2624$var$productsOnboardingHubEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8cK5I.onboardingHubEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $bd240a87609a2624$export$114fd427e3931043 = (0, $6xToB.createEntry)((0, $2Kod9.productsOnboardingHubRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return (0, $7jTnu.fg)('jira-onboarding-hub-gate') ? $bd240a87609a2624$var$productsOnboardingHubEntryPoint : undefined;
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ]
    }));

});
parcelRegister("8cK5I", function(module, exports) {

$parcel$export(module.exports, "onboardingHubEntryPoint", () => $702f7878806bd5f8$export$fbab93125af0feae);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $7jTnu = parcelRequire("7jTnu");

var $yTbrW = parcelRequire("yTbrW");

const $702f7878806bd5f8$export$fbab93125af0feae = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("9fTBY")), {
        moduleId: "1b14a2c7",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>{
        const { cloudId: cloudId } = tenantContext;
        const queries = {
            onboardingHubQuery: {
                options: {
                    fetchPolicy: 'store-and-network'
                },
                parameters: (0, $yTbrW.default),
                variables: {
                    cloudId: cloudId,
                    insightsEnabled: (0, $7jTnu.fg)('jira-onboarding-hub-insights-gate'),
                    rollingIntervals: (0, $7jTnu.fg)('jira-onboarding-hub-insights-gate') ? [
                        'DAYS_1',
                        'DAYS_7',
                        'DAYS_30',
                        'DAYS_90',
                        'DAYS_180'
                    ] : []
                }
            }
        };
        return {
            queries: queries
        };
    }
});

});
parcelRegister("yTbrW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e822689dfb6d26a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a2bf2de2893e4d49089494741b3b2f4d>>
 * @relayHash 07fb26a10e34a070f5b454b69a1e7216
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828049468dcafc82cadbb574b006a25cc3bbedcea5511dc9f049bf9748d1daca

var $37Ewn = parcelRequire("37Ewn");
const $6e822689dfb6d26a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "insightsEnabled"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rollingIntervals"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_onboardingHubQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "table_onboardingHub_OnboardingListTable"
                },
                {
                    "condition": "insightsEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "insightsPanel_onboardingHub"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ui_onboardingHubQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraOnboardingConfigConnection",
                    "kind": "LinkedField",
                    "name": "jira_onboardingConfigs",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraOnboardingConfigEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraOnboardingConfig",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "onboardingConfigAri"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "targetValues"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "updatedAt"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "insightsEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "tenantId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "GrowthUnifiedProfileSiteProfileResult",
                            "kind": "LinkedField",
                            "name": "growthUnifiedProfile_siteProfile",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "rollingIntervals",
                                            "variableName": "rollingIntervals"
                                        }
                                    ],
                                    "concreteType": "GrowthUnifiedProfileSiteOnboardingInsightsResult",
                                    "kind": "LinkedField",
                                    "name": "onboardingHubInsightsOverAll",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalViews"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "avgResourceEngagement"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "rollingInterval"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "completionRate"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "828049468dcafc82cadbb574b006a25cc3bbedcea5511dc9f049bf9748d1daca",
            "metadata": {},
            "name": "ui_onboardingHubQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6e822689dfb6d26a$var$node.hash = "bb997c0e92b39cddab2e3b38359728d0";
(0, $37Ewn.PreloadableQueryRegistry).set($6e822689dfb6d26a$var$node.params.id, $6e822689dfb6d26a$var$node);
var $6e822689dfb6d26a$export$2e2bcd8739ae039 = $6e822689dfb6d26a$var$node;

});

parcelRegister("9fTBY", function(module, exports) {

let $6bd0a70e605f1ada$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6bd0a70e605f1ada$var$load("eDzss"),
    $6bd0a70e605f1ada$var$load("1UgXw")
]).then(()=>parcelRequire('gELPT'));

});


parcelRegister("2Kod9", function(module, exports) {

$parcel$export(module.exports, "productsOnboardingHubRoute", () => $a626a147af55c538$export$6a9e8ece249577cc);
const $a626a147af55c538$export$6a9e8ece249577cc = {
    name: 'products-onboarding-hub',
    path: '/jira/settings/products/onboarding'
};

});


parcelRegister("fAxRm", function(module, exports) {

$parcel$export(module.exports, "proformaExportRouteEntry", () => $d1ffca1fc741593c$export$27be010fc1b30f6c);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $iyCyU = parcelRequire("iyCyU");

var $UzU1b = parcelRequire("UzU1b");
const $d1ffca1fc741593c$export$27be010fc1b30f6c = (0, $6xToB.createEntry)((0, $iyCyU.proformaExportRoute), ()=>({
        group: 'proforma',
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        component: (0, $UzU1b.default),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $UzU1b.LazyProformaExport)
        ]
    }));

});
parcelRegister("iyCyU", function(module, exports) {

$parcel$export(module.exports, "proformaExportRoute", () => $0e19409ed3fd7e40$export$5130d152b1cda229);
const $0e19409ed3fd7e40$export$5130d152b1cda229 = {
    name: 'proforma-export',
    path: '/jira/forms/export',
    exact: true
};

});

parcelRegister("UzU1b", function(module, exports) {

$parcel$export(module.exports, "LazyProformaExport", () => $668b9d64fc26885c$export$5e0d802a5d865352);
$parcel$export(module.exports, "default", () => $668b9d64fc26885c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $668b9d64fc26885c$export$5e0d802a5d865352 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("2HgMX")), {
    moduleId: "./src/packages/spa-apps/proforma-export/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$668b9d64fc26885c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $668b9d64fc26885c$export$5e0d802a5d865352,
        pageId: "proforma-export",
        shouldShowSpinner: true
    });

});
parcelRegister("2HgMX", function(module, exports) {

let $1f6c9ed0ace46d15$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1f6c9ed0ace46d15$var$load("a59yR").then(()=>parcelRequire('Li5l0'));

});



parcelRegister("gLtBa", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsGeneralRouteEntry", () => $96cc83be2d5613e1$export$90d7a2fe9ba3bc11);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $krfFu = parcelRequire("krfFu");

var $gcV4I = parcelRequire("gcV4I");
const $96cc83be2d5613e1$export$90d7a2fe9ba3bc11 = (0, $6xToB.createEntry)((0, $krfFu.proformaIssueFormsGeneralRoute), ()=>({
        group: 'proforma',
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        component: (0, $gcV4I.default),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $gcV4I.LazyProformaIssueFormsGeneral)
        ],
        perfMetricKey: 'issue-forms-general'
    }));

});
parcelRegister("krfFu", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsGeneralRoute", () => $c0c7ff427ec69461$export$5e0c19066a4c3806);
const $c0c7ff427ec69461$export$5e0c19066a4c3806 = {
    name: 'proforma-issue-forms-general',
    path: '/jira/forms/create',
    exact: true
};

});

parcelRegister("gcV4I", function(module, exports) {

$parcel$export(module.exports, "LazyProformaIssueFormsGeneral", () => $c63c887e9367d456$export$7c16b09eb95f1c5d);
$parcel$export(module.exports, "default", () => $c63c887e9367d456$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $c63c887e9367d456$export$7c16b09eb95f1c5d = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("2cWX9")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-general/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c63c887e9367d456$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c63c887e9367d456$export$7c16b09eb95f1c5d,
        pageId: "proforma-issue-forms-general",
        shouldShowSpinner: true
    });

});
parcelRegister("2cWX9", function(module, exports) {

let $19ba6ea0a193af42$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $19ba6ea0a193af42$var$load("7vqGd"),
    $19ba6ea0a193af42$var$load("1Y4bq"),
    $19ba6ea0a193af42$var$load("iC6BA")
]).then(()=>parcelRequire('2wveb'));

});



parcelRegister("3d0g1", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRedirectRouteEntry", () => $9738cb89159d4099$export$b498607b4440c4ef);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $aZ5HL = parcelRequire("aZ5HL");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $bL8CC = parcelRequire("bL8CC");

var $eRnC9 = parcelRequire("eRnC9");
const $9738cb89159d4099$export$b498607b4440c4ef = (0, $6xToB.createEntry)((0, $bL8CC.projectComponentsRedirectRoute), ()=>({
        group: 'components',
        component: !false ? (0, $eRnC9.ComponentsRedirect) : undefined,
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $aZ5HL.projectsComponentsResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        isRedirect: true
    }));

});
parcelRegister("aZ5HL", function(module, exports) {

$parcel$export(module.exports, "projectsComponentsResource", () => $ae3accc88e2541d8$export$557cc3eff8939b3);

var $cJYBV = parcelRequire("cJYBV");

var $l1VxS = parcelRequire("l1VxS");


const $ae3accc88e2541d8$export$557cc3eff8939b3 = (0, $l1VxS.createResource)({
    type: (0, $42742cb606e40290$export$ae1b86a8daeb387d),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("4L9Dz")),
    maxAge: (0, $cJYBV.MIN_MAX_AGE)
});

});
const $42742cb606e40290$export$ae1b86a8daeb387d = 'PROJECTS_COMPONENTS';

parcelRegister("4L9Dz", function(module, exports) {

let $377306f4f4272ebb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $377306f4f4272ebb$var$load("d8mMH").then(()=>parcelRequire('9fdve'));

});


parcelRegister("bL8CC", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRedirectRoute", () => $39e5f6263f4ac6d6$export$d370abe25253fa1b);

var $2b9AL = parcelRequire("2b9AL");
const $39e5f6263f4ac6d6$export$d370abe25253fa1b = {
    name: 'project-components-redirect',
    path: '/projects/:projectKey',
    query: (0, $2b9AL.PROJECTS_COMPONENTS_QUERY_PARAMS)
};

});
parcelRegister("2b9AL", function(module, exports) {

$parcel$export(module.exports, "PROJECTS_COMPONENTS_QUERY_PARAMS", () => $585d976fd2e1d0f3$export$1d7a0c194c3e83f2);
const $585d976fd2e1d0f3$export$1d7a0c194c3e83f2 = [
    'selectedItem=com.atlassian.jira.jira-projects-plugin:components-page'
];

});


parcelRegister("eRnC9", function(module, exports) {

$parcel$export(module.exports, "ComponentsRedirect", () => $dda166f65f6bcbc3$export$9cf9ae84482ff18e);

var $eJOHy = parcelRequire("eJOHy");

var $3Q6BV = parcelRequire("3Q6BV");

var $akJ5X = parcelRequire("akJ5X");
const $dda166f65f6bcbc3$export$9cf9ae84482ff18e = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $3Q6BV.qs).stringify(rest, true);
        return `/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akJ5X.RedirectToProjectType), {
        page: page
    });
};

});
parcelRegister("akJ5X", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $8b78b9af8d494d73$export$8a3df560509448b8);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $dZRaT = parcelRequire("dZRaT");

var $iIqWW = parcelRequire("iIqWW");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");
var $gCY1z = parcelRequire("gCY1z");
const $8b78b9af8d494d73$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $2mHfh.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $gCeeo.fireUIAnalytics), page: page, useAnalyticsEvents: // eslint-disable-next-line react-hooks/react-compiler
useAnalyticsEvents = (0, $f1Zdy.useAnalyticsEvents), useResource: // eslint-disable-next-line react-hooks/react-compiler
useResource = (0, $eJrcF.useResource), useRouter: // eslint-disable-next-line react-hooks/react-compiler
useRouter = (0, $gCY1z.useRouter), useSpaStateTransition: // eslint-disable-next-line react-hooks/react-compiler
useSpaStateTransition = (0, $iIqWW.useSpaStateTransition) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ match: match, query: query, route: route }] = useRouter();
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: data } = useResource((0, $dZRaT.projectContextResource));
    // eslint-disable-next-line react-hooks/react-compiler
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eJOHy.useRef)(createAnalyticsEvent({}));
    (0, $eJOHy.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $ln6Iy.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $ln6Iy.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});



parcelRegister("7mEsO", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRouteEntry", () => $9d1fbb9e0fa9d201$export$e60f53ff5ae626cd);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $aZ5HL = parcelRequire("aZ5HL");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $bwFUS = parcelRequire("bwFUS");

var $g8uYY = parcelRequire("g8uYY");

var $9n5I0 = parcelRequire("9n5I0");

var $6l2Aw = parcelRequire("6l2Aw");

var $7jTnu = parcelRequire("7jTnu");

var $5L7qx = parcelRequire("5L7qx");

var $6zEUu = parcelRequire("6zEUu");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $9d1fbb9e0fa9d201$var$projectComponentsPageEntryPointOld = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $6l2Aw.projectComponentsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $9d1fbb9e0fa9d201$var$projectComponentsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $6l2Aw.projectComponentsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $9d1fbb9e0fa9d201$export$e60f53ff5ae626cd = (0, $6xToB.createEntry)((0, $bwFUS.projectComponentsRoute), ()=>({
        group: 'components',
        ufoName: 'project-components-view',
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $aZ5HL.projectsComponentsResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jira-project-isglobalcomponent-route-resource'), (0, $6zEUu.projectGlobalComponentsResource))
        ],
        entryPoint: ()=>(0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? $9d1fbb9e0fa9d201$var$projectComponentsPageEntryPoint : $9d1fbb9e0fa9d201$var$projectComponentsPageEntryPointOld,
        supportsPreviewPanel: true
    }));

});
parcelRegister("bwFUS", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRoute", () => $4f4abd4e8b3df111$export$f76189bea494b0b8);
const $4f4abd4e8b3df111$export$f76189bea494b0b8 = {
    name: 'project-components',
    path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/components'
};

});

parcelRegister("6l2Aw", function(module, exports) {

$parcel$export(module.exports, "projectComponentsEntrypoint", () => $20c948855b9573f6$export$d90db228c6acd520);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $20c948855b9573f6$export$d90db228c6acd520 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("feMT2")), {
        moduleId: "f6db472c",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("feMT2", function(module, exports) {

let $b17e15b777d73e8b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $b17e15b777d73e8b$var$load("eDzss"),
    $b17e15b777d73e8b$var$load("gRbd0")
]).then(()=>parcelRequire('kMIvJ'));

});



parcelRegister("j2UMI", function(module, exports) {

$parcel$export(module.exports, "projectDirectoryRedirectRouteEntry", () => $9402b743579a1fe5$export$f1f04e35fd5f4283);

var $eJOHy = parcelRequire("eJOHy");

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $kHlOR = parcelRequire("kHlOR");

var $3phEv = parcelRequire("3phEv");

var $7fTjp = parcelRequire("7fTjp");

var $7h3uc = parcelRequire("7h3uc");
const $9402b743579a1fe5$var$ProjectsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/projects"
    });
const $9402b743579a1fe5$export$f1f04e35fd5f4283 = (0, $6xToB.createEntry)((0, $3phEv.projectDirectoryRedirectRoute), ()=>({
        group: 'classic-software',
        component: $9402b743579a1fe5$var$ProjectsDirectoryRedirect,
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        isRedirect: true,
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("3phEv", function(module, exports) {

$parcel$export(module.exports, "projectDirectoryRedirectRoute", () => $326a362e17ae685c$export$3913c8bee519225c);
const $326a362e17ae685c$export$3913c8bee519225c = {
    name: 'project-directory-redirect',
    path: '/secure/RapidBoard.jspa'
};

});


parcelRegister("l29cD", function(module, exports) {

$parcel$export(module.exports, "projectIssueNavigatorRouteEntry", () => $487eb24527a3e26f$export$d6b778af15db7d3);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4VIcO = parcelRequire("4VIcO");

var $71FJh = parcelRequire("71FJh");

var $gwH93 = parcelRequire("gwH93");


var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");
const $487eb24527a3e26f$export$d6b778af15db7d3 = (0, $6xToB.createEntry)((0, $71FJh.projectIssueNavigatorRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $gwH93.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        layout: (0, $6dwgv.createLayout)((0, $ioHIu.genericProjectLayout)),
        entryPoint: ()=>(0, $fYGKn.issueNavigatorPinRedirectPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("71FJh", function(module, exports) {

$parcel$export(module.exports, "projectIssueNavigatorRoute", () => $cbed4a6b99e05501$export$126b16ec65343bf);
const $cbed4a6b99e05501$export$126b16ec65343bf = {
    name: 'issue-navigator',
    path: '/projects/:projectKey/issues/:issueKey?'
};

});


parcelRegister("eze04", function(module, exports) {

$parcel$export(module.exports, "projectNotFoundRouteEntry", () => $87ab8a7cd3b94462$export$beae48175e3016b8);

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $eQwye = parcelRequire("eQwye");

var $hceXq = parcelRequire("hceXq");
const $87ab8a7cd3b94462$var$projectNotFoundPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $hceXq.projectNotFoundEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $87ab8a7cd3b94462$export$beae48175e3016b8 = (0, $6xToB.createEntry)((0, $eQwye.projectNotFoundRoute), ()=>({
        group: 'errors',
        entryPoint () {
            return $87ab8a7cd3b94462$var$projectNotFoundPageEntryPoint;
        },
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        pageId: 'project-not-found-page-id'
    }));

});
parcelRegister("eQwye", function(module, exports) {

$parcel$export(module.exports, "projectNotFoundRoute", () => $ad61ff49eaca5222$export$ad23ddca45852d02);
const $ad61ff49eaca5222$export$ad23ddca45852d02 = {
    name: 'project-not-found',
    path: '/jira/:projectType(software|servicedesk|core|polaris)/projects/not-found',
    exact: true
};

});

parcelRegister("hceXq", function(module, exports) {

$parcel$export(module.exports, "projectNotFoundEntryPoint", () => $ba3b5b2d880d29ad$export$6ffa2f426ba3b25a);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $ba3b5b2d880d29ad$export$6ffa2f426ba3b25a = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("9sHJ6")), {
        moduleId: "51ed29c5",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9sHJ6", function(module, exports) {

let $6e38a5c5317f7929$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6e38a5c5317f7929$var$load("gihAJ").then(()=>parcelRequire('jg2EL'));

});



parcelRegister("9B4ho", function(module, exports) {

$parcel$export(module.exports, "projectPagesLegacyRouteEntry", () => $d25b8db25da4495b$export$5788c5f8c4e440b1);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $jWQE3 = parcelRequire("jWQE3");

var $7CcYG = parcelRequire("7CcYG");
const $d25b8db25da4495b$export$5788c5f8c4e440b1 = (0, $6xToB.createEntry)((0, $jWQE3.projectPagesLegacyRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        component: !false ? (0, $7CcYG.PagesRedirect) : (0, $7CcYG.default),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7CcYG.LazyProjectPages)
        ],
        isRedirect: true
    }));

});
parcelRegister("jWQE3", function(module, exports) {

$parcel$export(module.exports, "projectPagesLegacyRoute", () => $846d63863db70a86$export$a82cbb9b9c689c40);
const $846d63863db70a86$export$a82cbb9b9c689c40 = {
    name: 'project-pages-legacy',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:project-pages-page'
    ]
};

});

parcelRegister("7CcYG", function(module, exports) {

$parcel$export(module.exports, "LazyProjectPages", () => $c8554474f623042e$export$c2115a649411f570);
$parcel$export(module.exports, "PagesRedirect", () => $c8554474f623042e$export$7c3b1828ada63555);
$parcel$export(module.exports, "default", () => $c8554474f623042e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $dGi3M = parcelRequire("dGi3M");

const $c8554474f623042e$export$c2115a649411f570 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("k3vXL"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/project/pages/src/index.tsx"
});
const $c8554474f623042e$export$7c3b1828ada63555 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dGi3M.RedirectToProjectType), {
        page: "/pages"
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c8554474f623042e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c8554474f623042e$export$c2115a649411f570,
        pageId: "project-pages",
        shouldShowSpinner: false
    });

});
parcelRegister("dGi3M", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $ebac16b69edfbbe3$export$8a3df560509448b8);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $dZRaT = parcelRequire("dZRaT");

var $iIqWW = parcelRequire("iIqWW");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");
var $gCY1z = parcelRequire("gCY1z");
const $ebac16b69edfbbe3$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $2mHfh.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $gCeeo.fireUIAnalytics), page: page, useAnalyticsEvents: // eslint-disable-next-line react-hooks/react-compiler
useAnalyticsEvents = (0, $f1Zdy.useAnalyticsEvents), useResource: // eslint-disable-next-line react-hooks/react-compiler
useResource = (0, $eJrcF.useResource), useRouter: // eslint-disable-next-line react-hooks/react-compiler
useRouter = (0, $gCY1z.useRouter), useSpaStateTransition: // eslint-disable-next-line react-hooks/react-compiler
useSpaStateTransition = (0, $iIqWW.useSpaStateTransition) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ match: match, query: query, route: route }] = useRouter();
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: data } = useResource((0, $dZRaT.projectContextResource));
    // eslint-disable-next-line react-hooks/react-compiler
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eJOHy.useRef)(createAnalyticsEvent({}));
    (0, $eJOHy.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $ln6Iy.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $ln6Iy.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});

parcelRegister("k3vXL", function(module, exports) {

let $e99ce1a83e066965$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $e99ce1a83e066965$var$load("7vqGd"),
    $e99ce1a83e066965$var$load("1Y4bq"),
    $e99ce1a83e066965$var$load("3xM69")
]).then(()=>parcelRequire('9A00a'));

});



parcelRegister("dMtOC", function(module, exports) {

$parcel$export(module.exports, "projectPagesRouteEntry", () => $e6bbf17f835c69ac$export$babf32528ef518e9);

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $9BJU1 = parcelRequire("9BJU1");

var $lzYaa = parcelRequire("lzYaa");

var $jom8W = parcelRequire("jom8W");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $epTsa = parcelRequire("epTsa");

var $7CcYG = parcelRequire("7CcYG");
const $e6bbf17f835c69ac$export$babf32528ef518e9 = (0, $6xToB.createEntry)((0, $lzYaa.projectPagesRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)() && (0, $epTsa.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false) || (0, $1302Y.getIsSoftwareThemingM2Enabled)(), (0, $1G20J.projectThemeResource))
        ],
        component: (0, $f2JN3.componentWithCondition)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $7CcYG.default)),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7CcYG.LazyProjectPages)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("lzYaa", function(module, exports) {

$parcel$export(module.exports, "projectPagesRoute", () => $24f94fca506bee70$export$54a218ca6d1c056a);
const $24f94fca506bee70$export$54a218ca6d1c056a = {
    name: 'project-pages',
    path: '/jira/:projectType(software|software/c|servicedesk)/projects/:projectKey/pages'
};

});


parcelRegister("2cgig", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRouteEntry", () => $bf61e2687b10809e$export$78ff5b5f42b9de4);

var $kHlOR = parcelRequire("kHlOR");

var $1RKJf = parcelRequire("1RKJf");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $i9ujx = parcelRequire("i9ujx");

var $h9tDf = parcelRequire("h9tDf");

var $iMFdk = parcelRequire("iMFdk");

var $7PT7e = parcelRequire("7PT7e");

var $4qnr5 = parcelRequire("4qnr5");
const $bf61e2687b10809e$export$78ff5b5f42b9de4 = (0, $6xToB.createEntry)((0, $h9tDf.projectsDirectoryLegacyPathRedirectRoute), ()=>({
        group: 'directories',
        component: (0, $7PT7e.ProjectsDirectoryRedirect),
        skeleton: (0, $iMFdk.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $1RKJf.homepageLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $i9ujx.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4qnr5.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("h9tDf", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRoute", () => $d97f830e3798d52f$export$c713f57300a82898);
const $d97f830e3798d52f$export$c713f57300a82898 = {
    name: 'projects-directory-legacy-path-spa-redirect',
    path: '/secure/BrowseProjects.jspa'
};

});

parcelRegister("7PT7e", function(module, exports) {

$parcel$export(module.exports, "ProjectsDirectoryRedirect", () => $130cbc93d99de54c$export$b68dd6112a931c10);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");
const $130cbc93d99de54c$export$b68dd6112a931c10 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/projects"
    });

});


parcelRegister("9GvQT", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRedirectRouteEntry", () => $b9b55a61cd5407c7$export$c3c347e60b82f074);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $vJYlr = parcelRequire("vJYlr");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9l6lo = parcelRequire("9l6lo");

var $iMFdk = parcelRequire("iMFdk");

var $lMQkR = parcelRequire("lMQkR");

var $9MwFx = parcelRequire("9MwFx");

var $4qnr5 = parcelRequire("4qnr5");
const $b9b55a61cd5407c7$export$c3c347e60b82f074 = (0, $6xToB.createEntry)((0, $9l6lo.projectsDirectoryManageRedirectRoute), ()=>({
        component: (0, $lMQkR.ProjectsDirectoryManageRedirect),
        skeleton: (0, $iMFdk.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebar: (0, $vJYlr.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9MwFx.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4qnr5.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("9l6lo", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRedirectRoute", () => $6a42ac46fc6348ec$export$dbd3b6c012e8b6dc);
const $6a42ac46fc6348ec$export$dbd3b6c012e8b6dc = {
    name: 'projects-directory-manage-redirect',
    path: '/secure/project/ViewProjects.jspa'
};

});

parcelRegister("lMQkR", function(module, exports) {

$parcel$export(module.exports, "ProjectsDirectoryManageRedirect", () => $9b4f68af14c60f5d$export$74316a0a4963952b);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");
const $9b4f68af14c60f5d$export$74316a0a4963952b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/settings/projects/manage"
    });

});


parcelRegister("65d18", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRouteEntry", () => $42b104f4bc1b1927$export$3f6ec3224d4c9da);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $vJYlr = parcelRequire("vJYlr");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $3ACK3 = parcelRequire("3ACK3");

var $iMFdk = parcelRequire("iMFdk");

var $lMQkR = parcelRequire("lMQkR");

var $9MwFx = parcelRequire("9MwFx");

var $4qnr5 = parcelRequire("4qnr5");
const $42b104f4bc1b1927$export$3f6ec3224d4c9da = (0, $6xToB.createEntry)((0, $3ACK3.projectsDirectoryManageRootRedirectRoute), ()=>({
        component: (0, $lMQkR.ProjectsDirectoryManageRedirect),
        skeleton: (0, $iMFdk.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebar: (0, $vJYlr.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9MwFx.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4qnr5.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("3ACK3", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRoute", () => $58de1c471b2134e5$export$4531e3b2e25fad23);
const $58de1c471b2134e5$export$4531e3b2e25fad23 = {
    name: 'projects-directory-manage-root-redirect',
    path: '/jira/settings/projects',
    exact: true
};

});


parcelRegister("7ucgW", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRedirectRouteEntry", () => $3444112c75a66fa5$export$8d9d65bb59f2354e);

var $kHlOR = parcelRequire("kHlOR");

var $1RKJf = parcelRequire("1RKJf");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $i9ujx = parcelRequire("i9ujx");

var $eLgCf = parcelRequire("eLgCf");

var $iMFdk = parcelRequire("iMFdk");

var $7PT7e = parcelRequire("7PT7e");

var $4qnr5 = parcelRequire("4qnr5");
const $3444112c75a66fa5$export$8d9d65bb59f2354e = (0, $6xToB.createEntry)((0, $eLgCf.projectsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        component: (0, $7PT7e.ProjectsDirectoryRedirect),
        skeleton: (0, $iMFdk.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $1RKJf.homepageLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $i9ujx.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4qnr5.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("eLgCf", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRedirectRoute", () => $d0a6e40b83c0e40c$export$d44f1be3782f0fde);
const $d0a6e40b83c0e40c$export$d44f1be3782f0fde = {
    name: 'projects-directory-redirect',
    path: '/projects',
    exact: true
};

});


parcelRegister("dVWks", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRouteEntry", () => $37b0dee9630da026$export$79292a834772288c);

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $lWdYg = parcelRequire("lWdYg");

var $iMFdk = parcelRequire("iMFdk");

var $5TrFe = parcelRequire("5TrFe");
const $37b0dee9630da026$export$79292a834772288c = (0, $6xToB.createEntry)((0, $lWdYg.projectsDirectoryRoute), ()=>({
        group: 'directories',
        entryPoint () {
            return 0, $5TrFe.ProjectsDirectoryPageEntryPoint;
        },
        skeleton: (0, $iMFdk.ProjectsDirectorySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        ufoName: 'projects-directory-v3',
        supportsPreviewPanel: true
    }));

});

parcelRegister("0MUFU", function(module, exports) {

$parcel$export(module.exports, "projectServiceDeskRouteEntry", () => $546ed11cb9687fd6$export$8810bfd4f6a0eb22);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $hoV2u = parcelRequire("hoV2u");

var $lzHTu = parcelRequire("lzHTu");

var $aQoXd = parcelRequire("aQoXd");
const $546ed11cb9687fd6$export$8810bfd4f6a0eb22 = (0, $6xToB.createEntry)((0, $lzHTu.projectServiceDeskRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: (0, $hoV2u.RedirectToLastVisitedProjectPage),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("lzHTu", function(module, exports) {

$parcel$export(module.exports, "projectServiceDeskRoute", () => $f2ad8a3da9671eff$export$1cfc858068dd8718);
const $f2ad8a3da9671eff$export$1cfc858068dd8718 = {
    name: 'servicedesk-redirect',
    path: '/jira/servicedesk/projects/:projectKey',
    exact: true
};

});


parcelRegister("1yqW3", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationCRouteEntry", () => $7f0e71e2d2ce1f95$export$8a6c5a399335fa16);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $HfFpQ = parcelRequire("HfFpQ");

var $8FCAy = parcelRequire("8FCAy");

var $ciVnR = parcelRequire("ciVnR");
const $7f0e71e2d2ce1f95$export$8a6c5a399335fa16 = (0, $6xToB.createEntry)((0, $HfFpQ.projectSettingsAutomationCRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings-automation-c',
        component: (0, $ciVnR.default),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ciVnR.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("HfFpQ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationCRoute", () => $7fb662775c603c76$export$5337cc16f271a9cf);
const $7fb662775c603c76$export$5337cc16f271a9cf = {
    name: 'project-settings-automation',
    path: '/jira/software/c/projects/:projectKey/settings/automate'
};

});

parcelRegister("ciVnR", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $c1355228edbf920b$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "default", () => $c1355228edbf920b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $c1355228edbf920b$export$dea5ad7e8eac12ae = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8Cajp")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c1355228edbf920b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c1355228edbf920b$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });

});
parcelRegister("8Cajp", function(module, exports) {

let $6459df13821241ab$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6459df13821241ab$var$load("b3zY4").then(()=>parcelRequire('jsBpx'));

});



parcelRegister("9rb1x", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationRouteEntry", () => $1e42863e0b2b2bc6$export$a34f85c5b69f2c2f);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $dcMoL = parcelRequire("dcMoL");

var $8FCAy = parcelRequire("8FCAy");

var $ciVnR = parcelRequire("ciVnR");

var $5JAAk = parcelRequire("5JAAk");
const $1e42863e0b2b2bc6$export$a34f85c5b69f2c2f = (0, $6xToB.createEntry)((0, $dcMoL.projectSettingsAutomationRoute), ()=>({
        group: 'project-settings-software',
        ufoName: `project-settings-automation-${0, $5JAAk.SOFTWARE_PRODUCT}`,
        component: (0, $ciVnR.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ciVnR.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("dcMoL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationRoute", () => $9fcd294085d4933a$export$7809aa084868deea);
const $9fcd294085d4933a$export$7809aa084868deea = {
    name: 'project-settings-automation',
    path: '/jira/software/projects/:projectKey/settings/automate'
};

});


parcelRegister("af0ih", function(module, exports) {

$parcel$export(module.exports, "projectSettingsComponentsRouteEntry", () => $65fba3aa952511d5$export$72497f4e39dd0df4);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $aZ5HL = parcelRequire("aZ5HL");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $oZbM4 = parcelRequire("oZbM4");

var $8tbnc = parcelRequire("8tbnc");

var $7jTnu = parcelRequire("7jTnu");

var $5L7qx = parcelRequire("5L7qx");

var $6zEUu = parcelRequire("6zEUu");

var $5Fd8r = parcelRequire("5Fd8r");
const $65fba3aa952511d5$export$72497f4e39dd0df4 = (0, $6xToB.createEntry)((0, $oZbM4.projectSettingsComponentsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource),
            (0, $aZ5HL.projectsComponentsResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jira-project-isglobalcomponent-route-resource'), (0, $6zEUu.projectGlobalComponentsResource))
        ],
        component: (0, $5Fd8r.default),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $5Fd8r.LazyProjectComponentsSettings)
        ]
    }));

});
parcelRegister("oZbM4", function(module, exports) {

$parcel$export(module.exports, "projectSettingsComponentsRoute", () => $92c696193aff339d$export$79cbce13eeecd53);
const $92c696193aff339d$export$79cbce13eeecd53 = {
    name: 'project-settings-components',
    path: '/plugins/servlet/project-config/:projectKey/administer-components'
};

});

parcelRegister("5Fd8r", function(module, exports) {

$parcel$export(module.exports, "LazyProjectComponentsSettings", () => $c5460e096c4a9cb1$export$bb69d8c36391123);
$parcel$export(module.exports, "default", () => $c5460e096c4a9cb1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3Q6BV = parcelRequire("3Q6BV");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $4GPxY = parcelRequire("4GPxY");

const $c5460e096c4a9cb1$export$bb69d8c36391123 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("feMT2"))), {
    moduleId: "./src/packages/spa-apps/project/components/src/index.tsx"
});
const $c5460e096c4a9cb1$export$60cfbcd781a48d01 = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $3Q6BV.qs).stringify(rest, true);
        return `/settings/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4GPxY.RedirectToProjectType), {
        page: page
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c5460e096c4a9cb1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c5460e096c4a9cb1$export$bb69d8c36391123,
        pageId: "project-settings-components",
        shouldShowSpinner: true
    });

});
parcelRegister("4GPxY", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $8a76893e6d91688d$export$8a3df560509448b8);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $dZRaT = parcelRequire("dZRaT");

var $iIqWW = parcelRequire("iIqWW");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");
var $gCY1z = parcelRequire("gCY1z");
const $8a76893e6d91688d$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $2mHfh.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $gCeeo.fireUIAnalytics), page: page, useAnalyticsEvents: // eslint-disable-next-line react-hooks/react-compiler
useAnalyticsEvents = (0, $f1Zdy.useAnalyticsEvents), useResource: // eslint-disable-next-line react-hooks/react-compiler
useResource = (0, $eJrcF.useResource), useRouter: // eslint-disable-next-line react-hooks/react-compiler
useRouter = (0, $gCY1z.useRouter), useSpaStateTransition: // eslint-disable-next-line react-hooks/react-compiler
useSpaStateTransition = (0, $iIqWW.useSpaStateTransition) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ match: match, query: query, route: route }] = useRouter();
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: data } = useResource((0, $dZRaT.projectContextResource));
    // eslint-disable-next-line react-hooks/react-compiler
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eJOHy.useRef)(createAnalyticsEvent({}));
    (0, $eJOHy.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $ln6Iy.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $ln6Iy.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});



parcelRegister("8Qqsd", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRedirectRouteEntry", () => $1197956214252f9a$export$36e1851c22975fc0);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $6dcZw = parcelRequire("6dcZw");

var $2mHfh = parcelRequire("2mHfh");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

var $chHKe = parcelRequire("chHKe");
const $1197956214252f9a$export$36e1851c22975fc0 = (0, $6xToB.createEntry)((0, $6dcZw.projectSettingsCoreAccessRedirectRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
                to: `/jira/core/projects/${String(match.params.projectKey)}/settings/access`,
                push: false
            }),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $chHKe.LazyPeopleSettings)
        ]
    }));

});
parcelRegister("6dcZw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRedirectRoute", () => $f6ee19dcce80b27f$export$59e3323ba0cc224a);
const $f6ee19dcce80b27f$export$59e3323ba0cc224a = {
    name: 'project-settings-core-access-redirect',
    path: '/jira/core/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("5bzOU", function(module, exports) {

$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $49c2cb555626b18a$export$808691f5a412afa3);

var $hHbzj = parcelRequire("hHbzj");

var $cY5nO = parcelRequire("cY5nO");

var $1gbqq = parcelRequire("1gbqq");

var $5zQIb = parcelRequire("5zQIb");

var $dZRaT = parcelRequire("dZRaT");
const $49c2cb555626b18a$export$808691f5a412afa3 = ()=>[
        (0, $5zQIb.newIssueViewTransitionLockInStatusResource),
        (0, $1gbqq.navigationSidebarAutomationLegacyEnabledResource),
        (0, $dZRaT.projectContextResourceWithCache),
        (0, $hHbzj.forgeProjectSettingsModuleResource),
        (0, $cY5nO.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

});

parcelRegister("chHKe", function(module, exports) {

$parcel$export(module.exports, "LazyPeopleSettings", () => $b5057500dcb8d4e3$export$7eee4f97b7a1273);

var $2dJFW = parcelRequire("2dJFW");

var $gzcjr = parcelRequire("gzcjr");

const $b5057500dcb8d4e3$export$7eee4f97b7a1273 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3EK91"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});

});
parcelRegister("3EK91", function(module, exports) {

let $2a98e6dac47c14d3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2a98e6dac47c14d3$var$load("kFAZf").then(()=>parcelRequire('aJyzh'));

});



parcelRegister("d1As4", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRouteEntry", () => $4d3b88c54f79a5f2$export$8188648c76953df0);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $3VgOR = parcelRequire("3VgOR");

var $bmwpE = parcelRequire("bmwpE");

var $1F9cm = parcelRequire("1F9cm");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

var $chHKe = parcelRequire("chHKe");
const $4d3b88c54f79a5f2$var$Access = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $chHKe.LazyPeopleSettings),
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });
const $4d3b88c54f79a5f2$export$8188648c76953df0 = (0, $6xToB.createEntry)((0, $3VgOR.projectSettingsCoreAccessRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $4d3b88c54f79a5f2$var$Access,
        skeleton: (0, $bmwpE.ProjectSettingsAccessSkeleton),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $chHKe.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access'
    }));

});
parcelRegister("3VgOR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRoute", () => $8a1da25dea9aa581$export$fe93051d5b7385a1);
const $8a1da25dea9aa581$export$fe93051d5b7385a1 = {
    name: 'project-settings-core-access',
    path: '/jira/core/projects/:projectKey/settings/access',
    exact: true
};

});


parcelRegister("9tjWC", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreApprovalsRouteEntry", () => $3ea5dad70b7fed83$export$728033a86ab68014);

var $cEBDW = parcelRequire("cEBDW");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $3iQHO = parcelRequire("3iQHO");

var $kq7bW = parcelRequire("kq7bW");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");
const $3ea5dad70b7fed83$var$approvalsProjectSettingsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $kq7bW.approvalsProjectSettingsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $3ea5dad70b7fed83$export$728033a86ab68014 = (0, $6xToB.createEntry)((0, $3iQHO.projectSettingsCoreApprovalsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        entryPoint () {
            return $3ea5dad70b7fed83$var$approvalsProjectSettingsPageEntryPoint;
        },
        ufoName: 'project-settings-approvals-core'
    }));

});
parcelRegister("3iQHO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreApprovalsRoute", () => $570c758affb99c6d$export$ba11c8f378a2c121);
const $570c758affb99c6d$export$ba11c8f378a2c121 = {
    name: 'project-settings-core-approvals',
    path: '/jira/core/projects/:projectKey/settings/approvals',
    exact: true
};

});

parcelRegister("kq7bW", function(module, exports) {

$parcel$export(module.exports, "approvalsProjectSettingsEntryPoint", () => $32be2780ad78a91d$export$1389a6ddf34f642e);

var $j7VfD = parcelRequire("j7VfD");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $32be2780ad78a91d$export$1389a6ddf34f642e = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("i7mBO")), {
        moduleId: "83e2f2c2",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                approvalsSettingsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $j7VfD.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("j7VfD", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fd2455a8cb64ed8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d871f3ede49d545d142f76fc4cdb7b72>>
 * @relayHash c1a8c3336b76570b82a8688f17264c3b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 270763b3ff0773a74aedea0d0dc622ebea8eee56eab0c89b0657cf49632cc53f
const $1fd2455a8cb64ed8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "270763b3ff0773a74aedea0d0dc622ebea8eee56eab0c89b0657cf49632cc53f",
        "metadata": {},
        "name": "src_jiraBusinessApprovalsSettingsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1fd2455a8cb64ed8$export$2e2bcd8739ae039 = $1fd2455a8cb64ed8$var$node;

});

parcelRegister("i7mBO", function(module, exports) {

let $d30a6b1d5ff856fe$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d30a6b1d5ff856fe$var$load("6wePH").then(()=>parcelRequire('55Rtn'));

});



parcelRegister("kwERN", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsFieldsRouteEntry", () => $e4251cc71e392b1f$export$7870a0b1630a504e);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $6ZxXy = parcelRequire("6ZxXy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $e4251cc71e392b1f$var$LazyConnectAppControlsSettings = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("d6Phh"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $e4251cc71e392b1f$var$ConnectAppControlsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e4251cc71e392b1f$var$LazyConnectAppControlsSettings,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });
const $e4251cc71e392b1f$export$7870a0b1630a504e = (0, $6xToB.createEntry)((0, $6ZxXy.projectSettingsCoreAppsFieldsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $e4251cc71e392b1f$var$ConnectAppControlsPage,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $e4251cc71e392b1f$var$LazyConnectAppControlsSettings
        ]
    }));

});
parcelRegister("6ZxXy", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsFieldsRoute", () => $080dc427416057ad$export$1c7e75ffaa491922);
const $080dc427416057ad$export$1c7e75ffaa491922 = {
    name: 'project-settings-core-apps-fields',
    path: '/jira/core/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("d6Phh", function(module, exports) {

let $98b39c9ae1b141d9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $98b39c9ae1b141d9$var$load("arE9i").then(()=>parcelRequire('cyXr6'));

});


parcelRegister("773VE", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsRouteEntry", () => $e6120f533ef1b107$export$c038a2892f34f1a9);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $8IBsx = parcelRequire("8IBsx");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $e6120f533ef1b107$var$LazyConnectAppsSettings = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ik609"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
const $e6120f533ef1b107$var$ConnectAppsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e6120f533ef1b107$var$LazyConnectAppsSettings,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });
const $e6120f533ef1b107$export$c038a2892f34f1a9 = (0, $6xToB.createEntry)((0, $8IBsx.projectSettingsCoreAppsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $e6120f533ef1b107$var$ConnectAppsPage,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $e6120f533ef1b107$var$LazyConnectAppsSettings
        ]
    }));

});
parcelRegister("8IBsx", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsRoute", () => $cf077f098f8ddb1b$export$c7ac65fb0bbe767f);
const $cf077f098f8ddb1b$export$c7ac65fb0bbe767f = {
    name: 'project-settings-core-apps',
    path: '/jira/core/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("ik609", function(module, exports) {

let $d56ec001e10a6bd7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d56ec001e10a6bd7$var$load("4S9RE").then(()=>parcelRequire('esCFD'));

});


parcelRegister("jiUh1", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationRouteEntry", () => $b1ff9d60d978fc78$export$a244870e56f5c9a3);

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $8zN8Z = parcelRequire("8zN8Z");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

var $6rTIE = parcelRequire("6rTIE");
const $b1ff9d60d978fc78$export$a244870e56f5c9a3 = (0, $6xToB.createEntry)((0, $8zN8Z.projectSettingsCoreAutomationRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: (0, $6rTIE.AutomationLazyPage),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6rTIE.LazyProjectSettingsJiraAutomation)
        ],
        ufoName: 'project-settings-automation-core'
    }));

});
parcelRegister("8zN8Z", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationRoute", () => $02f56a97b5d9c31c$export$65a4d727336c49f4);
const $02f56a97b5d9c31c$export$65a4d727336c49f4 = {
    name: 'project-settings-core-automation',
    path: '/jira/core/projects/:projectKey/settings/automation'
};

});

parcelRegister("6rTIE", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $be9afed948b0d963$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "AutomationLazyPage", () => $be9afed948b0d963$export$88eebe21cecb82db);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $be9afed948b0d963$export$dea5ad7e8eac12ae = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8Cajp")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
const $be9afed948b0d963$export$88eebe21cecb82db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $be9afed948b0d963$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("8Iv3H", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationV2RouteEntry", () => $20b78d4ec4d465f1$export$a2c8a6767edeeaed);

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $au58C = parcelRequire("au58C");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

var $6rTIE = parcelRequire("6rTIE");
const $20b78d4ec4d465f1$export$a2c8a6767edeeaed = (0, $6xToB.createEntry)((0, $au58C.projectSettingsCoreAutomationV2Route), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: (0, $6rTIE.AutomationLazyPage),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6rTIE.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("au58C", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationV2Route", () => $29de6e53cc1523c7$export$5437af2650f645e0);
const $29de6e53cc1523c7$export$5437af2650f645e0 = {
    name: 'project-settings-core-automation',
    path: '/jira/core/projects/:projectKey/settings/automate'
};

});


parcelRegister("f83an", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDataClassificationsRouteEntry", () => $896c6ec82d349197$export$cf5194c476e8bcdb);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $eAb6T = parcelRequire("eAb6T");

var $bmwpE = parcelRequire("bmwpE");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $896c6ec82d349197$var$LazyDataClassificationsSettings = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bzxaI"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
const $896c6ec82d349197$var$DataClassifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $896c6ec82d349197$var$LazyDataClassificationsSettings,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });
const $896c6ec82d349197$export$cf5194c476e8bcdb = (0, $6xToB.createEntry)((0, $eAb6T.projectSettingsCoreDataClassificationsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $896c6ec82d349197$var$DataClassifications,
        skeleton: (0, $bmwpE.ProjectSettingsDetailsSkeleton),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("eAb6T", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDataClassificationsRoute", () => $91083ef075cfb4b6$export$7aae1006c82a79c0);
const $91083ef075cfb4b6$export$7aae1006c82a79c0 = {
    name: 'project-settings-core-data-classifications',
    path: '/jira/core/projects/:projectKey/settings/data-classifications',
    exact: true
};

});


parcelRegister("cWPJr", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDefaultRedirectRouteEntry", () => $4e292bcc9172851a$export$df1c02c3f28b7a95);

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $enZCh = parcelRequire("enZCh");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

var $iOK3U = parcelRequire("iOK3U");
const $4e292bcc9172851a$export$df1c02c3f28b7a95 = (0, $6xToB.createEntry)((0, $enZCh.projectSettingsCoreDefaultRedirectRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: (0, $iOK3U.ProjectSettingsRedirect),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("enZCh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDefaultRedirectRoute", () => $01ed0bbfcd7d913f$export$322fe16ec991f12);
const $01ed0bbfcd7d913f$export$322fe16ec991f12 = {
    name: 'project-settings-core-redirect',
    path: '/jira/core/projects/:projectKey/settings'
};

});

parcelRegister("iOK3U", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsRedirect", () => $ff898726ca520125$export$72130cf40a3c3778);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $dSkLG = parcelRequire("dSkLG");

var $2mHfh = parcelRequire("2mHfh");
const $ff898726ca520125$export$72130cf40a3c3778 = ({ match: match })=>{
    const { data: data } = (0, $dSkLG.useJiraWorkmanagementProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/core/projects/${String(projectKey)}/settings/details`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    if ((0, $7jTnu.fg)('vmc-11-manage-versions-permission')) {
        if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/administer-versions`
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/core/projects/${String(match.params.projectKey)}/settings/details`
    });
};

});


parcelRegister("4BOoE", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDetailsRouteEntry", () => $68317367b53508d0$export$438a330ccc1e7a91);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $9GhPZ = parcelRequire("9GhPZ");

var $bmwpE = parcelRequire("bmwpE");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $68317367b53508d0$var$LazyDetailsSettings = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("9Vy7l"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
const $68317367b53508d0$var$Details = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $68317367b53508d0$var$LazyDetailsSettings,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });
const $68317367b53508d0$export$438a330ccc1e7a91 = (0, $6xToB.createEntry)((0, $9GhPZ.projectSettingsCoreDetailsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $68317367b53508d0$var$Details,
        skeleton: (0, $bmwpE.ProjectSettingsDetailsSkeleton),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $68317367b53508d0$var$LazyDetailsSettings
        ]
    }));

});
parcelRegister("9GhPZ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDetailsRoute", () => $ac2160042ab41ffe$export$14535b40530c8690);
const $ac2160042ab41ffe$export$14535b40530c8690 = {
    name: 'project-settings-core-details',
    path: '/jira/core/projects/:projectKey/settings/details',
    exact: true
};

});


parcelRegister("h7Red", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreFieldsRouteEntry", () => $c607ef6e47cdb175$export$8d8dff75124dcebc);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $uKS5x = parcelRequire("uKS5x");

var $5kWLm = parcelRequire("5kWLm");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $c607ef6e47cdb175$var$LazyFieldsSettings = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5j1d4"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
const $c607ef6e47cdb175$var$FieldsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c607ef6e47cdb175$var$LazyFieldsSettings,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });
const $c607ef6e47cdb175$export$8d8dff75124dcebc = (0, $6xToB.createEntry)((0, $5kWLm.projectSettingsCoreFieldsRoute), ()=>({
        group: 'project-settings-core',
        ufoName: 'project-settings.fields.jwm-tmp',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            (0, $uKS5x.fieldSettingsRelayResource)
        ],
        component: $c607ef6e47cdb175$var$FieldsPage,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $c607ef6e47cdb175$var$LazyFieldsSettings
        ]
    }));

});
parcelRegister("uKS5x", function(module, exports) {

$parcel$export(module.exports, "fieldSettingsRelayResource", () => $f44edc9542947688$export$68b4e700e00bad7a);

var $9FYIg = parcelRequire("9FYIg");

var $kMQL1 = parcelRequire("kMQL1");

var $bBtQo = parcelRequire("bBtQo");
const $f44edc9542947688$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS = 'PROJECT_SETTINGS_FIELDS';
const $f44edc9542947688$export$68b4e700e00bad7a = (0, $9FYIg.createRelayResource)({
    type: $f44edc9542947688$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
        return {
            parameters: (0, $kMQL1.default),
            variables: {
                projectKey: projectKey ?? '',
                cloudId: tenantContext.cloudId ?? ''
            },
            options: {
                fetchPolicy: 'network-only'
            }
        };
    }
});

});
parcelRegister("kMQL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7303c820db4fe2f0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b920556abf037fb372c1be7148d855bd>>
 * @relayHash ffbf0393f91ce8c25afb2ef8f3a54d70
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a4d63c3a3a85b921c92d520934c1c5bae222ae53c92ce896b94c1bcc2b952e73

var $8uhLQ = parcelRequire("8uhLQ");

var $bud2F = parcelRequire("bud2F");

var $37Ewn = parcelRequire("37Ewn");
const $7303c820db4fe2f0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        v2 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "isExplicitFieldAssociationsEnabled"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "key"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 30
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiFieldsPageQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "fieldsTable_projectFields"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "pageHeader_projectFields_Header"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "uiFieldsPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "xsmall"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "optionsPerFieldLimit"
                                },
                                {
                                    "concreteType": "JiraFieldTypeGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "projectFieldTypeGroups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFieldTypeGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldTypeGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "displayName"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectScopedFieldsPerProjectLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectScopedFieldsCount"
                                },
                                v7 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectWithIssueTypeIds",
                                    "kind": "LinkedField",
                                    "name": "projectWithVisibleIssueTypeIds",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldAssociationWithIssueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFieldAssociationWithIssueTypes",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldId"
                                                                        },
                                                                        v7 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "scope"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "typeName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "description"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "typeKey"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "hasMissingConfiguration"
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldOperation",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOperation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canRemove"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canDelete"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canEdit"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canModifyOptions"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraFieldOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraFieldOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "parentOptionId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "value"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraColor",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "color",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "colorKey"
                                                                                                        },
                                                                                                        v7 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldFormatConfig",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "formatStyle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "formatUnit"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "formatDecimals"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraNumberFieldFormatConfig"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isFieldLocked"
                                                                },
                                                                v9 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                                        },
                                        {
                                            "args": v8 /*: any*/ ,
                                            "filters": [
                                                "input"
                                            ],
                                            "handle": "connection",
                                            "key": "fieldsTable_fieldAssociationWithIssueTypes",
                                            "kind": "LinkedHandle",
                                            "name": "fieldAssociationWithIssueTypes"
                                        }
                                    ]
                                },
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a4d63c3a3a85b921c92d520934c1c5bae222ae53c92ce896b94c1bcc2b952e73",
            "metadata": {},
            "name": "uiFieldsPageQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider": (0, $8uhLQ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider": (0, $bud2F.default)
            }
        }
    };
}();
$7303c820db4fe2f0$var$node.hash = "b0872e3059548632993c06522c7f5584";
(0, $37Ewn.PreloadableQueryRegistry).set($7303c820db4fe2f0$var$node.params.id, $7303c820db4fe2f0$var$node);
var $7303c820db4fe2f0$export$2e2bcd8739ae039 = $7303c820db4fe2f0$var$node;

});
parcelRegister("8uhLQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9eeae788af0ce2a$export$2e2bcd8739ae039);

var $g5wv4 = parcelRequire("g5wv4");
var $d9eeae788af0ce2a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $g5wv4.isSidebarFormatConfigEnabled)();
    }
};

});
parcelRegister("g5wv4", function(module, exports) {

$parcel$export(module.exports, "formatDecimal", () => $9f3ef12a68cb7fc4$export$845857f28dc08744);
$parcel$export(module.exports, "formatNumberField", () => $9f3ef12a68cb7fc4$export$d390e3b8d1c21e01);
$parcel$export(module.exports, "transformToUI", () => $9f3ef12a68cb7fc4$export$ecbf259380af1f03);
$parcel$export(module.exports, "transformToServer", () => $9f3ef12a68cb7fc4$export$e7caeabf4d12f5b4);
$parcel$export(module.exports, "isSidebarFormatConfigEnabled", () => $9f3ef12a68cb7fc4$export$3c854a930069a447);
$parcel$export(module.exports, "formatConfigFromAggJiraNumberFieldFormatConfig", () => $9f3ef12a68cb7fc4$export$29f524126725ba4b);

var $7jTnu = parcelRequire("7jTnu");

/**
 * This is due to Jira commonly using the POSIX format (using '_' for defining locales),
 * such as in jira/src/packages/platform/utils/constants/src/supported-locales.tsx,
 * whereas the Intl Javascript API requires locales to be in the IETF BCP 47 format.
 */ const $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat = (locale)=>{
    return locale.replace('_', '-');
};
// Converts strings to lower case while also preventing string literal types from being converted
// into the more general `string` type as the String.prototype.toLowerCase() method always returns
// a `string` type, even if the string is a string literal. For example:
// const string = 'CONSTANT'; // type is `'CONSTANT'`;
// string.toLowerCase() // returned type is `string`;
// toLowerCase(string) // returned type is `'constant'`;
const $9f3ef12a68cb7fc4$var$toLowerCase = (inputString)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return inputString.toLocaleLowerCase();
};
const $9f3ef12a68cb7fc4$var$isSupportedCurrencyCode = (currencyCode)=>{
    // Check if the currency code is supported
    return Intl.supportedValuesOf($9f3ef12a68cb7fc4$var$toLowerCase((0, $7b3dcdbff4fbb09a$export$a82896da99871ba4))).includes(currencyCode);
};
const $9f3ef12a68cb7fc4$var$isSupportedUnit = (unit)=>{
    // Check if the unit is supported
    return Intl.supportedValuesOf($9f3ef12a68cb7fc4$var$toLowerCase((0, $7b3dcdbff4fbb09a$export$83551de9ca24925e))).includes(unit);
};
const $9f3ef12a68cb7fc4$export$3dc27271f5d5c629 = (amount, config = {})=>{
    const { currencyCode: currencyCode = (0, $7b3dcdbff4fbb09a$export$c852e1f5bb177898), locale: locale, currencyDisplay: currencyDisplay = (0, $7b3dcdbff4fbb09a$export$b9e50a64e0ca3437), ...rest } = config;
    // Check if the currency code is supported. fall back to decimal format if not.
    // @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
    const formatOptions = $9f3ef12a68cb7fc4$var$isSupportedCurrencyCode(currencyCode) ? {
        style: (0, $7b3dcdbff4fbb09a$export$a82896da99871ba4).toLocaleLowerCase(),
        currency: currencyCode,
        currencyDisplay: currencyDisplay,
        maximumFractionDigits: Number.isInteger(amount) ? 0 : undefined,
        ...rest
    } : {
        style: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...rest
    };
    const formatter = new Intl.NumberFormat(locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(locale), formatOptions);
    return formatter.format(amount ?? 0);
};
const $9f3ef12a68cb7fc4$export$32e6b1ae352e94d6 = (amount, config = {})=>{
    const { locale: locale, ...rest } = config;
    return new Intl.NumberFormat(locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(locale), {
        ...rest,
        // @ts-expect-error - TS2769 Typescript 5.9.2 upgrade
        style: (0, $7b3dcdbff4fbb09a$export$83551de9ca24925e).toLocaleLowerCase(),
        unit: (0, $7b3dcdbff4fbb09a$export$97f1ae291e87b4b2)
    }).format(amount ?? 0);
};
const $9f3ef12a68cb7fc4$export$bd39b96f71da1885 = (number, config = {})=>{
    const { unit: unit, locale: locale, ...rest } = config;
    // Check if the unit code is supported. fall back to decimal format if not.
    // @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
    const formatOptions = unit && $9f3ef12a68cb7fc4$var$isSupportedUnit(unit) ? {
        style: (0, $7b3dcdbff4fbb09a$export$83551de9ca24925e).toLocaleLowerCase(),
        unit: unit,
        ...rest
    } : {
        style: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...rest
    };
    const formatter = new Intl.NumberFormat(locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(locale), formatOptions);
    return formatter.format(number ?? 0);
};
const $9f3ef12a68cb7fc4$export$845857f28dc08744 = (number, config = {})=>{
    const formatter = new Intl.NumberFormat(config.locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(config.locale), {
        // @ts-expect-error - TS2769 Typescript 5.9.2 upgrade
        style: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...config
    });
    return formatter.format(number ?? 0);
};
const $9f3ef12a68cb7fc4$export$d390e3b8d1c21e01 = (number, config = {
    formatStyle: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea)
})=>{
    const { formatStyle: formatStyle, formatUnit: formatUnit, locale: locale } = config;
    switch(formatStyle){
        case 0, $7b3dcdbff4fbb09a$export$a82896da99871ba4:
            return formatUnit ? $9f3ef12a68cb7fc4$export$3dc27271f5d5c629(number, {
                locale: locale,
                currencyCode: formatUnit
            }) : $9f3ef12a68cb7fc4$export$845857f28dc08744(number, {
                locale: locale
            });
        case 0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9:
            return $9f3ef12a68cb7fc4$export$32e6b1ae352e94d6(number, {
                locale: locale
            });
        case 0, $7b3dcdbff4fbb09a$export$83551de9ca24925e:
            return formatUnit ? $9f3ef12a68cb7fc4$export$bd39b96f71da1885(number, {
                locale: locale,
                unit: formatUnit
            }) : $9f3ef12a68cb7fc4$export$845857f28dc08744(number, {
                locale: locale
            });
        default:
            return $9f3ef12a68cb7fc4$export$845857f28dc08744(number);
    }
};
const $9f3ef12a68cb7fc4$export$ecbf259380af1f03 = (number, formatStyle = (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea))=>number && formatStyle === (0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9) && (0, $7jTnu.fg)('frontier-currency-field-fix-percentage-storage') ? number * 100 : number;
const $9f3ef12a68cb7fc4$export$e7caeabf4d12f5b4 = (number, formatStyle = (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea))=>{
    if (!number || formatStyle !== (0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9) || !(0, $7jTnu.fg)('frontier-currency-field-fix-percentage-storage')) return number;
    // Use Number.EPSILON to avoid floating-point precision issues
    const result = number / 100;
    const factor = Math.pow(10, 8); // 8 decimal places should be sufficient for percentage precision
    return Math.round((result + Number.EPSILON) * factor) / factor;
};
const $9f3ef12a68cb7fc4$export$3c854a930069a447 = ()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $7jTnu.fg)('frontier-currency-field-d1') && (0, $7jTnu.fg)('fields-settings-currency-field-display');
const $9f3ef12a68cb7fc4$var$formatStyleMapper = (jiraFormatStyle)=>{
    switch(jiraFormatStyle){
        case 'CURRENCY':
            return 0, $7b3dcdbff4fbb09a$export$a82896da99871ba4;
        case 'PERCENT':
            return 0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9;
        case 'UNIT':
            return 0, $7b3dcdbff4fbb09a$export$83551de9ca24925e;
        default:
            return 0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea;
    }
};
const $9f3ef12a68cb7fc4$export$29f524126725ba4b = (gqlFormatConfig)=>{
    const { formatDecimals: formatDecimals, formatStyle: formatStyle, formatUnit: formatUnit } = gqlFormatConfig || {};
    return {
        formatStyle: $9f3ef12a68cb7fc4$var$formatStyleMapper(formatStyle),
        formatUnit: formatUnit || null,
        formatDecimals: formatDecimals ?? null
    };
};

});
const $7b3dcdbff4fbb09a$export$c852e1f5bb177898 = 'USD';
const $7b3dcdbff4fbb09a$export$b9e50a64e0ca3437 = 'narrowSymbol';
const $7b3dcdbff4fbb09a$export$768e3e8e60d01cea = 'DECIMAL';
const $7b3dcdbff4fbb09a$export$a82896da99871ba4 = 'CURRENCY';
const $7b3dcdbff4fbb09a$export$e50c15d5408652a9 = 'PERCENT';
const $7b3dcdbff4fbb09a$export$83551de9ca24925e = 'UNIT';
const $7b3dcdbff4fbb09a$export$e0f41b79f8d902b5 = 'liter';
const $7b3dcdbff4fbb09a$export$83a33c313ebf2c4a = 'meter';
const $7b3dcdbff4fbb09a$export$32fca264df3a7957 = 'kilogram';
const $7b3dcdbff4fbb09a$export$97f1ae291e87b4b2 = 'percent';



parcelRegister("bud2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $589ac61571781861$export$2e2bcd8739ae039);

var $epTsa = parcelRequire("epTsa");
var $589ac61571781861$export$2e2bcd8739ae039 = {
    get () {
        return (0, $epTsa.expVal)('thor_colourful_single_select_milestone2_experiment', 'isColorfulSingleSelectEnabled', false) && (0, $epTsa.expVal)('thor_colourful_single_select_fields_experiment', 'isColorfulSingleSelectEnabled', false);
    }
};

});



parcelRegister("5kWLm", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreFieldsRoute", () => $4257bf508e06a94e$export$7c4ee74641923239);
const $4257bf508e06a94e$export$7c4ee74641923239 = {
    name: 'project-settings-core-fields',
    path: '/jira/core/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("5j1d4", function(module, exports) {

let $3dcfaa59944aeab6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3dcfaa59944aeab6$var$load("dVR0c").then(()=>parcelRequire('kbmIh'));

});


parcelRegister("7Pdre", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreForgeAppsRouteEntry", () => $b44745a6260a38ee$export$1006fd9f5f02b1c2);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $kWuKC = parcelRequire("kWuKC");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $b44745a6260a38ee$var$LazyForgeProjectSettingsPage = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("c8agu")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $b44745a6260a38ee$var$ForgeProjectSettingsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $b44745a6260a38ee$var$LazyForgeProjectSettingsPage,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
const $b44745a6260a38ee$export$1006fd9f5f02b1c2 = (0, $6xToB.createEntry)((0, $kWuKC.projectSettingsCoreForgeAppsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $b44745a6260a38ee$var$ForgeProjectSettingsPage,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $b44745a6260a38ee$var$LazyForgeProjectSettingsPage
        ]
    }));

});
parcelRegister("kWuKC", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreForgeAppsRoute", () => $b8e85e53e98fa473$export$b34160f55b6104e9);
const $b8e85e53e98fa473$export$b34160f55b6104e9 = {
    name: 'project-settings-core-forge-apps',
    path: '/jira/core/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("c8agu", function(module, exports) {

let $8d4e31cc04c724a9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8d4e31cc04c724a9$var$load("2QXi8").then(()=>parcelRequire('1rEKn'));

});


parcelRegister("20zzw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesRouteEntry", () => $810b238042a3d46b$export$95ecbacf0120fcfd);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $4Briw = parcelRequire("4Briw");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $810b238042a3d46b$var$LazyIssueTypeSettings = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2Qznj"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
const $810b238042a3d46b$var$IssueTypePage = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $810b238042a3d46b$var$LazyIssueTypeSettings,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
const $810b238042a3d46b$export$95ecbacf0120fcfd = (0, $6xToB.createEntry)((0, $4Briw.projectSettingsCoreIssueTypesRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $810b238042a3d46b$var$IssueTypePage,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $810b238042a3d46b$var$LazyIssueTypeSettings
        ]
    }));

});
parcelRegister("4Briw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesRoute", () => $b52961adde1b4dc4$export$c3a32433c580b9ff);
const $b52961adde1b4dc4$export$c3a32433c580b9ff = {
    name: 'project-settings-core-issuetypes',
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});


parcelRegister("h4zAy", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesWorkflowRouteEntry", () => $bf2af5f0accc24f0$export$1dfd4811b9065dd6);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $4366C = parcelRequire("4366C");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $8tbnc = parcelRequire("8tbnc");

var $7K5Ea = parcelRequire("7K5Ea");

var $epTsa = parcelRequire("epTsa");

var $5bzOU = parcelRequire("5bzOU");

const $bf2af5f0accc24f0$var$LazyWorkflowNavigationSettings = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("gr4id"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
const $bf2af5f0accc24f0$var$WorkflowNavigationPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $bf2af5f0accc24f0$var$LazyWorkflowNavigationSettings,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });
const $bf2af5f0accc24f0$export$1dfd4811b9065dd6 = (0, $6xToB.createEntry)((0, $4366C.projectSettingsCoreIssueTypesWorkflowRoute), ()=>({
        group: 'project-settings-core',
        navigation: (0, $epTsa.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_business', 'isEnabled', true, false) ? undefined : {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $epTsa.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_business', 'isEnabled', true, false) ? (0, $7K5Ea.chromelessLayout) : (0, $cEBDW.coreProjectLayout),
        resources: (0, $epTsa.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_business', 'isEnabled', true, false) ? undefined : [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $bf2af5f0accc24f0$var$WorkflowNavigationPage,
        forPaint: (0, $epTsa.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_business', 'isEnabled', true, false) ? [
            $bf2af5f0accc24f0$var$LazyWorkflowNavigationSettings
        ] : [
            (0, $kHlOR.LazyAtlassianNavigation),
            $bf2af5f0accc24f0$var$LazyWorkflowNavigationSettings
        ]
    }));

});
parcelRegister("4366C", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesWorkflowRoute", () => $1b7c0478f6f55054$export$9e79ee307216071b);
const $1b7c0478f6f55054$export$9e79ee307216071b = {
    name: 'project-settings-core-issuetypes-workflow',
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("gr4id", function(module, exports) {

let $bf727f70e1ab1715$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $bf727f70e1ab1715$var$load("7vqGd"),
    $bf727f70e1ab1715$var$load("1Y4bq"),
    $bf727f70e1ab1715$var$load("1VRB2"),
    $bf727f70e1ab1715$var$load("bABhq"),
    $bf727f70e1ab1715$var$load("f1nZR")
]).then(()=>parcelRequire('79XtQ'));

});


parcelRegister("4WoRT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsEmailRouteEntry", () => $131266e2842e625f$export$da36a1671d868927);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $iieLc = parcelRequire("iieLc");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $131266e2842e625f$var$LazyProjectSettingsNotificationEmail = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fmrQC"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
const $131266e2842e625f$var$EmailNotifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $131266e2842e625f$var$LazyProjectSettingsNotificationEmail,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });
const $131266e2842e625f$export$da36a1671d868927 = (0, $6xToB.createEntry)((0, $iieLc.projectSettingsCoreNotificationsEmailRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $131266e2842e625f$var$EmailNotifications,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $131266e2842e625f$var$LazyProjectSettingsNotificationEmail
        ]
    }));

});
parcelRegister("iieLc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsEmailRoute", () => $e802fd4cece3fd28$export$b546589f1b048dc);
const $e802fd4cece3fd28$export$b546589f1b048dc = {
    name: 'project-settings-core-notifications-notification-email',
    path: '/jira/core/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("fmrQC", function(module, exports) {

let $b2ee831299296b07$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b2ee831299296b07$var$load("dOF8U").then(()=>parcelRequire('coZXG'));

});


parcelRegister("im6xk", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsIssueLogsRouteEntry", () => $a93d00cc87045434$export$e562140c482cb0c);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $jsl6f = parcelRequire("jsl6f");

var $9BdgC = parcelRequire("9BdgC");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");
const $a93d00cc87045434$var$emailNotificationsLogEntryPointPage = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9BdgC.notificationsIssueLogsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

const $a93d00cc87045434$var$LazyNotificationsIssueLogs = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("eE4gG"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
});
const $a93d00cc87045434$var$NotificationsIssueLogs = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a93d00cc87045434$var$LazyNotificationsIssueLogs,
        pageId: "project-settings-software-notifications-issue-logs",
        shouldShowSpinner: false
    });
const $a93d00cc87045434$export$e562140c482cb0c = (0, $6xToB.createEntry)((0, $jsl6f.projectSettingsCoreNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $a93d00cc87045434$var$NotificationsIssueLogs,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $a93d00cc87045434$var$LazyNotificationsIssueLogs
        ],
        entryPoint () {
            return $a93d00cc87045434$var$emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("jsl6f", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsIssueLogsRoute", () => $4ead34731e522065$export$56a8a0b88329b044);
const $4ead34731e522065$export$56a8a0b88329b044 = {
    name: 'project-settings-core-notifications-issue-logs',
    path: '/jira/core/projects/:projectKey/settings/notifications/issue-logs',
    exact: true
};

});


parcelRegister("6P2Hr", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsRouteEntry", () => $ecceeabad646c15f$export$ed481b03aa858542);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $heO95 = parcelRequire("heO95");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $ecceeabad646c15f$var$LazyNotificationsSettings = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bSbty"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
});
const $ecceeabad646c15f$var$Notifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ecceeabad646c15f$var$LazyNotificationsSettings,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });
const $ecceeabad646c15f$export$ed481b03aa858542 = (0, $6xToB.createEntry)((0, $heO95.projectSettingsCoreNotificationsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $ecceeabad646c15f$var$Notifications,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $ecceeabad646c15f$var$LazyNotificationsSettings
        ]
    }));

});
parcelRegister("heO95", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsRoute", () => $e152b432fb8df62a$export$a1ee80066685b98d);
const $e152b432fb8df62a$export$a1ee80066685b98d = {
    name: 'project-settings-core-notifications',
    path: '/jira/core/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("bSbty", function(module, exports) {

let $8a4da3b0361f4dd8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8a4da3b0361f4dd8$var$load("hl4Cv").then(()=>parcelRequire('6HtX7'));

});


parcelRegister("lJuD5", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaJiraFormBuilderRouteEntry", () => $c245f3f88d60b7f9$export$46d6b55ebf21ccc);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $dINx0 = parcelRequire("dINx0");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $c245f3f88d60b7f9$var$LazyProjectSettingsProformaJiraFormBuilder = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("h6wO6")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
const $c245f3f88d60b7f9$var$ProformaJiraFormBuilder = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c245f3f88d60b7f9$var$LazyProjectSettingsProformaJiraFormBuilder,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });
const $c245f3f88d60b7f9$export$46d6b55ebf21ccc = (0, $6xToB.createEntry)((0, $dINx0.projectSettingsCoreProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $c245f3f88d60b7f9$var$ProformaJiraFormBuilder,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $c245f3f88d60b7f9$var$LazyProjectSettingsProformaJiraFormBuilder
        ],
        perfMetricKey: 'form-builder'
    }));

});
parcelRegister("dINx0", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaJiraFormBuilderRoute", () => $e1e3eeeaacb0fb7d$export$4e7ce7e6ced0f291);
const $e1e3eeeaacb0fb7d$export$4e7ce7e6ced0f291 = {
    name: 'project-settings-core-proforma-jira-form-builder',
    path: '/jira/core/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});


parcelRegister("kjUZx", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaProjectFormsRouteEntry", () => $35d3e30ea0ace1d6$export$5e9e27f116094fdf);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $arxGf = parcelRequire("arxGf");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $35d3e30ea0ace1d6$var$LazyProjectSettingsProformaProjectForms = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("lW6IV")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
const $35d3e30ea0ace1d6$var$ProformaProjectForms = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $35d3e30ea0ace1d6$var$LazyProjectSettingsProformaProjectForms,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });
const $35d3e30ea0ace1d6$export$5e9e27f116094fdf = (0, $6xToB.createEntry)((0, $arxGf.projectSettingsCoreProformaProjectFormsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $35d3e30ea0ace1d6$var$ProformaProjectForms,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $35d3e30ea0ace1d6$var$LazyProjectSettingsProformaProjectForms
        ],
        perfMetricKey: 'forms-settings'
    }));

});
parcelRegister("arxGf", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaProjectFormsRoute", () => $50305d44c5434a67$export$57fe8c5107a9c0de);
const $50305d44c5434a67$export$57fe8c5107a9c0de = {
    name: 'project-settings-core-proforma-project-forms',
    path: '/jira/core/projects/:projectKey/settings/forms',
    exact: true
};

});


parcelRegister("4yidD", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCustomerServiceFeaturesRouteEntry", () => $b474ea2d12e536db$export$e17f02db5d9c0485);

var $TgOcC = parcelRequire("TgOcC");

var $7jTnu = parcelRequire("7jTnu");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $g9kBK = parcelRequire("g9kBK");

var $9BJU1 = parcelRequire("9BJU1");

var $aQoXd = parcelRequire("aQoXd");

var $5nMhu = parcelRequire("5nMhu");
const $b474ea2d12e536db$export$e17f02db5d9c0485 = (0, $6xToB.createEntry)((0, $TgOcC.projectSettingsCustomerServiceFeaturesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jcs-project-settings.features',
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $7jTnu.fg)('berry-5039-jcs-features-page') ? (0, $5nMhu.projectSettingFeaturesAppPageEntryPoint) : undefined;
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $g9kBK.featuresResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        perfMetricKey: 'jcs-project-settings.features'
    }));

});
parcelRegister("TgOcC", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCustomerServiceFeaturesRoute", () => $350a52cebf8a6f8e$export$5498201d2eacd40d);
const $350a52cebf8a6f8e$export$5498201d2eacd40d = {
    name: 'project-settings-customer-service-features',
    path: '/jira/servicedesk/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("5nMhu", function(module, exports) {

$parcel$export(module.exports, "projectSettingFeaturesAppPageEntryPoint", () => $60c5517c00398ff5$export$f5b640657f5a50a3);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9jhUW = parcelRequire("9jhUW");
const $60c5517c00398ff5$export$f5b640657f5a50a3 = (0, $g8uYY.createPageEntryPoint)({
    main: $9jhUW.projectSettingFeaturesAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("9jhUW", function(module, exports) {

$parcel$export(module.exports, "projectSettingFeaturesAppEntryPoint", () => $5964a44b58d9149c$export$83a2217e7eee641e);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $5964a44b58d9149c$export$83a2217e7eee641e = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("dHqtS")), {
        moduleId: "92e8308d",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dHqtS", function(module, exports) {

let $9f93d50dc88fc673$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9f93d50dc88fc673$var$load("5JVNx").then(()=>parcelRequire('7dsYV'));

});




parcelRegister("ikmMT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsNextgenRouteEntry", () => $bc8577501ac8c70a$export$872a0285d27dfa47);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $bCenk = parcelRequire("bCenk");

var $8FCAy = parcelRequire("8FCAy");

var $15K4j = parcelRequire("15K4j");

var $5JAAk = parcelRequire("5JAAk");
const $bc8577501ac8c70a$export$872a0285d27dfa47 = (0, $6xToB.createEntry)((0, $bCenk.projectSettingsForgeAppsNextgenRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $15K4j.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            ...(0, $15K4j.forgeProjectSettingsPageResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $15K4j.LazyForgeProjectSettingsPage)
        ]
    }));

});
parcelRegister("bCenk", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsNextgenRoute", () => $8e8aff77a4966b35$export$8559c4a0b692890e);
const $8e8aff77a4966b35$export$8559c4a0b692890e = {
    name: 'project-settings-software-apps-forge',
    path: '/jira/software/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("15K4j", function(module, exports) {

$parcel$export(module.exports, "LazyForgeProjectSettingsPage", () => $d48a6a4b849ef481$export$ef66d3f49a9953d8);
$parcel$export(module.exports, "forgeProjectSettingsPageResources", () => $d48a6a4b849ef481$export$33d85a1b2211b38);
$parcel$export(module.exports, "default", () => $d48a6a4b849ef481$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hHbzj = parcelRequire("hHbzj");

var $dZRaT = parcelRequire("dZRaT");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $d48a6a4b849ef481$export$ef66d3f49a9953d8 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("c8agu")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $d48a6a4b849ef481$export$33d85a1b2211b38 = ()=>[
        (0, $dZRaT.projectContextResourceWithCache),
        (0, $hHbzj.forgeProjectSettingsModuleResource)
    ];
const $d48a6a4b849ef481$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d48a6a4b849ef481$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
var $d48a6a4b849ef481$export$2e2bcd8739ae039 = $d48a6a4b849ef481$export$b943f48844c671a5;

});


parcelRegister("cw1uU", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsRouteEntry", () => $ff4e1798a1d685a7$export$54d0d8466c8b40dc);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $fefiR = parcelRequire("fefiR");

var $8FCAy = parcelRequire("8FCAy");

var $15K4j = parcelRequire("15K4j");
const $ff4e1798a1d685a7$export$54d0d8466c8b40dc = (0, $6xToB.createEntry)((0, $fefiR.projectSettingsForgeAppsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $15K4j.default),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $15K4j.forgeProjectSettingsPageResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $15K4j.LazyForgeProjectSettingsPage)
        ]
    }));

});
parcelRegister("fefiR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsRoute", () => $9468da00db699228$export$f74a0b1be9d5b9f6);
const $9468da00db699228$export$f74a0b1be9d5b9f6 = {
    name: 'project-settings-software-forge-apps',
    path: '/jira/software/c/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});


parcelRegister("3wFf4", function(module, exports) {

$parcel$export(module.exports, "projectSettingsOpsgenieRouteEntry", () => $5017ba35f8e063f9$export$4b4bfb4318f5a98e);

var $kHlOR = parcelRequire("kHlOR");

var $6qDrV = parcelRequire("6qDrV");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $5ZDgv = parcelRequire("5ZDgv");

var $jom8W = parcelRequire("jom8W");

var $8FCAy = parcelRequire("8FCAy");

var $jLc1n = parcelRequire("jLc1n");

var $5JAAk = parcelRequire("5JAAk");
const $5017ba35f8e063f9$export$4b4bfb4318f5a98e = (0, $6xToB.createEntry)((0, $5ZDgv.projectSettingsOpsgenieRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $6qDrV.default)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $jLc1n.default)),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jLc1n.LazyLinkOpsgeniePage)
        ],
        ufoName: 'project-settings.link-opsgenie'
    }));

});
parcelRegister("5ZDgv", function(module, exports) {

$parcel$export(module.exports, "projectSettingsOpsgenieRoute", () => $88f4bb44415aa69f$export$c7039de5a4b78802);
const $88f4bb44415aa69f$export$c7039de5a4b78802 = {
    name: 'project-settings-software-link-opsgenie',
    path: '/jira/software/projects/:projectKey/settings/opsgenie',
    exact: true
};

});


parcelRegister("85Rgm", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRedirectRouteEntry", () => $6893ced1fdd631e0$export$7a0e75d9ac8038aa);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $gVukG = parcelRequire("gVukG");

var $aQoXd = parcelRequire("aQoXd");

var $7gEmY = parcelRequire("7gEmY");

var $gwoLH = parcelRequire("gwoLH");
const $6893ced1fdd631e0$export$7a0e75d9ac8038aa = (0, $6xToB.createEntry)((0, $gVukG.projectSettingsServicedeskAccessRedirectRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $7gEmY.peopleAccessRedirect)(`/jira/${(0, $gwoLH.SERVICE_DESK_PRODUCT)}`),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7gEmY.LazyPeopleSettings)
        ]
    }));

});
parcelRegister("gVukG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRedirectRoute", () => $03a6b692b59c57cf$export$115667ee60b1ec74);
const $03a6b692b59c57cf$export$115667ee60b1ec74 = {
    name: 'project-settings-servicedesk-access-redirect',
    path: '/jira/servicedesk/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("7gEmY", function(module, exports) {

$parcel$export(module.exports, "LazyPeopleSettings", () => $f8bfa63a1f44827c$export$7eee4f97b7a1273);
$parcel$export(module.exports, "peopleAccessRedirect", () => $f8bfa63a1f44827c$export$45346ed2aa24e3f3);
$parcel$export(module.exports, "default", () => $f8bfa63a1f44827c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $2mHfh = parcelRequire("2mHfh");

const $f8bfa63a1f44827c$export$7eee4f97b7a1273 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3EK91"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $f8bfa63a1f44827c$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
const $f8bfa63a1f44827c$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f8bfa63a1f44827c$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f8bfa63a1f44827c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f8bfa63a1f44827c$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });

});

parcelRegister("gwoLH", function(module, exports) {

$parcel$export(module.exports, "SERVICE_DESK_PRODUCT", () => $e0380d4ed2642b4f$export$5575497f0592ee94);
$parcel$export(module.exports, "defaultRedirectForSettings", () => $e0380d4ed2642b4f$export$c9b0516439c55d7a);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");

var $7jTnu = parcelRequire("7jTnu");

var $dSkLG = parcelRequire("dSkLG");
const $e0380d4ed2642b4f$export$5575497f0592ee94 = 'servicedesk';
const $e0380d4ed2642b4f$export$c9b0516439c55d7a = (product)=>({ match: match })=>{
        const { data: data } = (0, $dSkLG.useJiraServiceManagementProjectNavigation)();
        if (!(0, $7jTnu.fg)('vmc-11-manage-versions-permission')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });
        if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });
        if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/plugins/servlet/project-config/${String(match.params.projectKey)}/administer-versions`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });
    };

});


parcelRegister("2Uft0", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRouteEntry", () => $525f705f51b6b77c$export$f7b56f6d0437146d);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9CHTy = parcelRequire("9CHTy");

var $aQoXd = parcelRequire("aQoXd");

var $bmwpE = parcelRequire("bmwpE");

var $7gEmY = parcelRequire("7gEmY");
const $525f705f51b6b77c$export$f7b56f6d0437146d = (0, $6xToB.createEntry)((0, $9CHTy.projectSettingsServicedeskAccessRoute), ()=>({
        group: 'project-settings-servicedesk',
        skeleton: (0, $bmwpE.ProjectSettingsAccessSkeleton),
        component: (0, $7gEmY.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7gEmY.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access'
    }));

});

parcelRegister("jCXKu", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsFieldsRouteEntry", () => $429da193784bf774$export$12f064da36fbd279);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9zBC5 = parcelRequire("9zBC5");

var $aQoXd = parcelRequire("aQoXd");

var $bfOBR = parcelRequire("bfOBR");
const $429da193784bf774$export$12f064da36fbd279 = (0, $6xToB.createEntry)((0, $9zBC5.projectSettingsServicedeskAppsFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bfOBR.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bfOBR.LazyConnectAppControlsSettings)
        ]
    }));

});
parcelRegister("bfOBR", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppControlsSettings", () => $08e4143173993014$export$246ec9cdadd2a163);
$parcel$export(module.exports, "ConnectAppsRedirect", () => $08e4143173993014$export$cc3414a2d9daf70d);
$parcel$export(module.exports, "default", () => $08e4143173993014$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $2aY2d = parcelRequire("2aY2d");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $2mHfh = parcelRequire("2mHfh");

var $02Yn6 = parcelRequire("02Yn6");

const $08e4143173993014$export$246ec9cdadd2a163 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("d6Phh"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $08e4143173993014$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT);
    return shouldRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
        push: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $02Yn6.default), null);
};
const $08e4143173993014$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08e4143173993014$var$ConnectAppsRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$08e4143173993014$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $08e4143173993014$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });

});
parcelRegister("02Yn6", function(module, exports) {

$parcel$export(module.exports, "LazyAppDiscoverySettings", () => $dba3d5bd8ba089d9$export$fa3bc297af95f169);
$parcel$export(module.exports, "default", () => $dba3d5bd8ba089d9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $dba3d5bd8ba089d9$export$fa3bc297af95f169 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ii4yz"))), {
    moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dba3d5bd8ba089d9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $dba3d5bd8ba089d9$export$fa3bc297af95f169,
        pageId: "project-settings-app-discovery-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("ii4yz", function(module, exports) {

let $d50d714c7a8d1f2d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d50d714c7a8d1f2d$var$load("eOgvs").then(()=>parcelRequire('ceVmw'));

});




parcelRegister("k25kz", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsRouteEntry", () => $1f88f7ee16a6ec1f$export$d637c59982b0d896);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $ihiVw = parcelRequire("ihiVw");

var $aQoXd = parcelRequire("aQoXd");

var $fnaXD = parcelRequire("fnaXD");
const $1f88f7ee16a6ec1f$export$d637c59982b0d896 = (0, $6xToB.createEntry)((0, $ihiVw.projectSettingsServicedeskAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $fnaXD.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fnaXD.LazyConnectAppsSettings)
        ]
    }));

});
parcelRegister("ihiVw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsRoute", () => $2ae3cd8e363a0b78$export$ccc91c475c403d1a);
const $2ae3cd8e363a0b78$export$ccc91c475c403d1a = {
    name: 'project-settings-servicedesk-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("fnaXD", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppsSettings", () => $fd2dde59f6c54c3a$export$3633e017e520a1c2);
$parcel$export(module.exports, "default", () => $fd2dde59f6c54c3a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $fd2dde59f6c54c3a$export$3633e017e520a1c2 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ik609"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fd2dde59f6c54c3a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fd2dde59f6c54c3a$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });

});


parcelRegister("ebqmN", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCopyRuleRouteEntry", () => $c4a82b72c69cbc80$export$1cfe280529d4ebf8);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $5JCiM = parcelRequire("5JCiM");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $dbpJT = parcelRequire("dbpJT");
const $c4a82b72c69cbc80$export$1cfe280529d4ebf8 = (0, $6xToB.createEntry)((0, $5JCiM.projectSettingsServicedeskAutomationCopyRuleRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.copy-rule',
        component: (0, $dbpJT.default),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dbpJT.LazyProjectSettingsServiceDeskAutomationCopyRule)
        ]
    }));

});
parcelRegister("5JCiM", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCopyRuleRoute", () => $dd3c3fb8e7544234$export$9aa8ef0c982cee2f);
const $dd3c3fb8e7544234$export$9aa8ef0c982cee2f = {
    name: 'project-settings-servicedesk-automation-copy-rule',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/copy/:ruleId'
};

});

parcelRegister("dbpJT", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationCopyRule", () => $ad45305132184954$export$4a3b5f6370555dbc);
$parcel$export(module.exports, "default", () => $ad45305132184954$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ad45305132184954$export$4a3b5f6370555dbc = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("jbR1X")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-copy-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad45305132184954$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ad45305132184954$export$4a3b5f6370555dbc,
        pageId: "project-settings-automation-copy-rule",
        shouldShowSpinner: true
    });

});
parcelRegister("jbR1X", function(module, exports) {

let $df882e25df5cb773$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $df882e25df5cb773$var$load("35epf").then(()=>parcelRequire('iOY2m'));

});



parcelRegister("43NlL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCreateRouteEntry", () => $59b039746438f768$export$f1e32463088d9246);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $6zM03 = parcelRequire("6zM03");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $j1lyW = parcelRequire("j1lyW");
const $59b039746438f768$export$f1e32463088d9246 = (0, $6xToB.createEntry)((0, $6zM03.projectSettingsServicedeskAutomationCreateRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.create-rule',
        component: (0, $j1lyW.default),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $j1lyW.LazyProjectSettingsServiceDeskAutomationCreateRule)
        ]
    }));

});
parcelRegister("6zM03", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCreateRoute", () => $d8bb8f7591b1fd9d$export$6f20ce2991881c20);
const $d8bb8f7591b1fd9d$export$6f20ce2991881c20 = {
    name: 'project-settings-servicedesk-automation-create',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/blueprint/:blueprintKey'
};

});

parcelRegister("j1lyW", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationCreateRule", () => $813af77cadfe206d$export$5b197b51eb5ad982);
$parcel$export(module.exports, "default", () => $813af77cadfe206d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $813af77cadfe206d$export$5b197b51eb5ad982 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("1xCK0")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-create-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$813af77cadfe206d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $813af77cadfe206d$export$5b197b51eb5ad982,
        pageId: "project-settings-automation-create-rule",
        shouldShowSpinner: true
    });

});
parcelRegister("1xCK0", function(module, exports) {

let $11f6eca7c11d2cb9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $11f6eca7c11d2cb9$var$load("3OsBh").then(()=>parcelRequire('b8Vr3'));

});



parcelRegister("2LDVV", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationEditRuleRouteEntry", () => $6061b8febeecda20$export$568d8653c06c756e);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $ck6WR = parcelRequire("ck6WR");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $4cIMR = parcelRequire("4cIMR");
const $6061b8febeecda20$export$568d8653c06c756e = (0, $6xToB.createEntry)((0, $ck6WR.projectSettingsServicedeskAutomationEditRuleRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.edit-rule',
        component: (0, $4cIMR.default),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4cIMR.LazyProjectSettingsServiceDeskAutomationEditRule)
        ]
    }));

});
parcelRegister("ck6WR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationEditRuleRoute", () => $99bda15133495d58$export$9f1e5391e2d6f95);
const $99bda15133495d58$export$9f1e5391e2d6f95 = {
    name: 'project-settings-servicedesk-automation-edit-rule',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/ruleset/:ruleId'
};

});

parcelRegister("4cIMR", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationEditRule", () => $8c64f30a5435a9db$export$c1c9a68738a9ab36);
$parcel$export(module.exports, "default", () => $8c64f30a5435a9db$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $8c64f30a5435a9db$export$c1c9a68738a9ab36 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("eQ264")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-edit-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c64f30a5435a9db$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8c64f30a5435a9db$export$c1c9a68738a9ab36,
        pageId: "project-settings-automation-edit-rule",
        shouldShowSpinner: true
    });

});
parcelRegister("eQ264", function(module, exports) {

let $acd78c6c5e1f781b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $acd78c6c5e1f781b$var$load("9fLAc").then(()=>parcelRequire('fYqHn'));

});



parcelRegister("9RMhv", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationRouteEntry", () => $1e3ee2b56177675c$export$7a0b8ca27efc7201);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $7xaze = parcelRequire("7xaze");

var $aQoXd = parcelRequire("aQoXd");

var $6eahc = parcelRequire("6eahc");

var $gwoLH = parcelRequire("gwoLH");
const $1e3ee2b56177675c$export$7a0b8ca27efc7201 = (0, $6xToB.createEntry)((0, $7xaze.projectSettingsServicedeskAutomationRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: `project-settings-automation-${0, $gwoLH.SERVICE_DESK_PRODUCT}`,
        component: (0, $6eahc.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6eahc.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("6eahc", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $3c1cceef4ab884be$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "default", () => $3c1cceef4ab884be$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $3c1cceef4ab884be$export$dea5ad7e8eac12ae = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8Cajp")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3c1cceef4ab884be$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3c1cceef4ab884be$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("h3kpF", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationSummaryRouteEntry", () => $7885896878c7a4da$export$4d6e0242b09fef3b);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $flolB = parcelRequire("flolB");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $71ddd = parcelRequire("71ddd");
const $7885896878c7a4da$export$4d6e0242b09fef3b = (0, $6xToB.createEntry)((0, $flolB.projectSettingsServicedeskAutomationSummaryRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.summary',
        component: (0, $71ddd.default),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $71ddd.LazyProjectSettingsServiceDeskAutomationSummary)
        ]
    }));

});
parcelRegister("71ddd", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationSummary", () => $047ecae84b6547da$export$2fc8c3fcbb365b89);
$parcel$export(module.exports, "default", () => $047ecae84b6547da$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $047ecae84b6547da$export$2fc8c3fcbb365b89 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("9GpfO")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-summary/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$047ecae84b6547da$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $047ecae84b6547da$export$2fc8c3fcbb365b89,
        pageId: "project-settings-automation-summary",
        shouldShowSpinner: true
    });

});
parcelRegister("9GpfO", function(module, exports) {

let $70cba03754bc6c20$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $70cba03754bc6c20$var$load("kvLiy").then(()=>parcelRequire('hfe3g'));

});



parcelRegister("23ehb", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationViewLogRouteEntry", () => $1b19201554765275$export$ddc45b708634b66);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $69J1v = parcelRequire("69J1v");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9Pq3q = parcelRequire("9Pq3q");
const $1b19201554765275$export$ddc45b708634b66 = (0, $6xToB.createEntry)((0, $69J1v.projectSettingsServicedeskAutomationViewLogRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.log',
        component: (0, $9Pq3q.default),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9Pq3q.LazyProjectSettingsServiceDeskAutomationViewLog)
        ]
    }));

});
parcelRegister("69J1v", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationViewLogRoute", () => $d3f08cfd387049df$export$ea3acd3ad4eb7d38);
const $d3f08cfd387049df$export$ea3acd3ad4eb7d38 = {
    name: 'project-settings-servicedesk-automation-view-log',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/log/:ruleId'
};

});

parcelRegister("9Pq3q", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationViewLog", () => $a240126197371616$export$db6c5cdbc65b2b4a);
$parcel$export(module.exports, "default", () => $a240126197371616$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $a240126197371616$export$db6c5cdbc65b2b4a = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("49DOo")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-view-log/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a240126197371616$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a240126197371616$export$db6c5cdbc65b2b4a,
        pageId: "project-settings-automation-view-log",
        shouldShowSpinner: true
    });

});
parcelRegister("49DOo", function(module, exports) {

let $3066e275074037c2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3066e275074037c2$var$load("fA2nj").then(()=>parcelRequire('9Kb0h'));

});



parcelRegister("70AS8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChangeManagementRouteEntry", () => $2713d8dd5a98d787$export$a8eaf3cca1d5d936);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1ePRx = parcelRequire("1ePRx");

var $ksbf6 = parcelRequire("ksbf6");

var $1PvPk = parcelRequire("1PvPk");

var $kgDPH = parcelRequire("kgDPH");

var $g9kBK = parcelRequire("g9kBK");

var $7g1XK = parcelRequire("7g1XK");

var $aQoXd = parcelRequire("aQoXd");

var $dEfqd = parcelRequire("dEfqd");

var $5L7qx = parcelRequire("5L7qx");

var $7jTnu = parcelRequire("7jTnu");

var $cg6Vz = parcelRequire("cg6Vz");
const $2713d8dd5a98d787$export$a8eaf3cca1d5d936 = (0, $6xToB.createEntry)((0, $7g1XK.projectSettingsServicedeskChangeManagementRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.change-management-settings',
        component: (0, $cg6Vz.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $kgDPH.serviceDeskContextResource),
            (0, $dEfqd.changeManagementSettingsProjectConfigurationResource),
            (0, $1ePRx.jsmChangeManagementSettingsGitLabGatingResource),
            (0, $g9kBK.featuresResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('remove_repackaging_banner_for_change'), (0, $ksbf6.jsmRepackagingBannerResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cg6Vz.LazyProjectSettingsServiceDeskChangeManagement)
        ]
    }));

});
parcelRegister("1ePRx", function(module, exports) {

$parcel$export(module.exports, "jsmChangeManagementSettingsGitLabGatingResource", () => $b66a14e650dc966f$export$315b6278d34861b4);
$parcel$export(module.exports, "useGitLabGatingResource", () => $b66a14e650dc966f$export$dd3715dce02ee460);

var $eJOHy = parcelRequire("eJOHy");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $b66a14e650dc966f$var$getDataLoader = ()=>(parcelRequire("4DMWb"));
const $b66a14e650dc966f$export$315b6278d34861b4 = (0, $l1VxS.createResource)({
    type: 'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
    getKey: ()=>'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
    getDataLoader: $b66a14e650dc966f$var$getDataLoader,
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});
const $b66a14e650dc966f$export$dd3715dce02ee460 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)($b66a14e650dc966f$export$315b6278d34861b4);
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            data: data?.data,
            pending: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: data?.error || error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("4DMWb", function(module, exports) {

let $3610c3ec1296630d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3610c3ec1296630d$var$load("9UsGX").then(()=>parcelRequire('c4uEB'));

});


parcelRegister("dEfqd", function(module, exports) {

$parcel$export(module.exports, "changeManagementSettingsProjectConfigurationResource", () => $fcb869bbdbbb9da4$export$2413ba18ec38282d);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $l1VxS = parcelRequire("l1VxS");
const $fcb869bbdbbb9da4$export$c0636b6062501e0b = 'CHANGE_MANAGEMENT_SETTINGS_PROJECT_CONFIG';

const $fcb869bbdbbb9da4$var$getDataLoader = ()=>(parcelRequire("9B244"));
const $fcb869bbdbbb9da4$var$getKey = ({ match: match })=>typeof match.params.projectKey === 'string' ? match.params.projectKey : '';
const $fcb869bbdbbb9da4$export$2413ba18ec38282d = (0, $l1VxS.createResource)({
    type: $fcb869bbdbbb9da4$export$c0636b6062501e0b,
    getKey: $fcb869bbdbbb9da4$var$getKey,
    getDataLoader: $fcb869bbdbbb9da4$var$getDataLoader,
    maxAge: Infinity
});

});
parcelRegister("9B244", function(module, exports) {

let $6fc92bbf4c7b2998$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6fc92bbf4c7b2998$var$load("cLS26").then(()=>parcelRequire('3T5bx'));

});


parcelRegister("cg6Vz", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskChangeManagement", () => $d32605cb6bbc6b58$export$e674d93688e620b3);
$parcel$export(module.exports, "default", () => $d32605cb6bbc6b58$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $d32605cb6bbc6b58$export$e674d93688e620b3 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("cfZbA"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-change-management-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d32605cb6bbc6b58$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d32605cb6bbc6b58$export$e674d93688e620b3,
        pageId: "project-settings-change-management",
        shouldShowSpinner: true
    });

});
parcelRegister("cfZbA", function(module, exports) {

let $8ec65903b748c645$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8ec65903b748c645$var$load("60Pw0").then(()=>parcelRequire('3UqVx'));

});



parcelRegister("ceWLf", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsChatRouteEntry", () => $0d19bbf5f4163584$export$aa27d235fc2eedf6);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $hCTNK = parcelRequire("hCTNK");

var $aQoXd = parcelRequire("aQoXd");

var $h3GVs = parcelRequire("h3GVs");

var $4kspE = parcelRequire("4kspE");
const $0d19bbf5f4163584$export$aa27d235fc2eedf6 = (0, $6xToB.createEntry)((0, $hCTNK.projectSettingsServicedeskChannelsChatRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $h3GVs.serviceDeskChatNextGenRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4kspE.LazyProjectSettingsServiceDeskChatSettings)
        ]
    }));

});
parcelRegister("h3GVs", function(module, exports) {

$parcel$export(module.exports, "serviceDeskChatNextGenRedirect", () => $f4f9420006bc3495$export$22c86ddb04b1359a);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $f4f9420006bc3495$export$22c86ddb04b1359a = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/chat`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: url
    });
};

});

parcelRegister("4kspE", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskChatSettings", () => $4129669277c2532f$export$971347f9ac02f862);
$parcel$export(module.exports, "default", () => $4129669277c2532f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $4129669277c2532f$export$971347f9ac02f862 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("2iuVL")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-chat-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4129669277c2532f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4129669277c2532f$export$971347f9ac02f862,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("2iuVL", function(module, exports) {

let $1ac5416c71adef97$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1ac5416c71adef97$var$load("c7Cjc").then(()=>parcelRequire('ev8xC'));

});



parcelRegister("fKViZ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsEmailNextGenRouteEntry", () => $98e20b568b44e473$export$b4590bec09451e4c);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $krn2b = parcelRequire("krn2b");

var $aQoXd = parcelRequire("aQoXd");

var $bGv2Y = parcelRequire("bGv2Y");

var $itJJd = parcelRequire("itJJd");
const $98e20b568b44e473$export$b4590bec09451e4c = (0, $6xToB.createEntry)((0, $krn2b.projectSettingsServicedeskChannelsEmailNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bGv2Y.serviceDeskEmailNextGenRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $itJJd.LazyProjectSettingsServiceDeskEmail)
        ]
    }));

});
parcelRegister("krn2b", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsEmailNextGenRoute", () => $7cb4164b89e9ea35$export$89c7bf2bac1464c2);
const $7cb4164b89e9ea35$export$89c7bf2bac1464c2 = {
    name: 'project-settings-servicedesk-channels-email-next-gen',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/email',
    exact: true
};

});

parcelRegister("bGv2Y", function(module, exports) {

$parcel$export(module.exports, "serviceDeskEmailNextGenRedirect", () => $0ef36f3d1b9f1f7d$export$86c8da903fb97c4f);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $0ef36f3d1b9f1f7d$export$86c8da903fb97c4f = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/email`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: url
    });
};

});

parcelRegister("itJJd", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskEmail", () => $a614736546f927dd$export$66d0c668045080de);
$parcel$export(module.exports, "default", () => $a614736546f927dd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4APnu = parcelRequire("4APnu");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $a614736546f927dd$export$66d0c668045080de = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("aTOp6")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a614736546f927dd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4APnu.HelpCenterSettingsRedirect), {
        page: "email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a614736546f927dd$export$66d0c668045080de,
        pageId: "project-settings-email",
        shouldShowSpinner: true
    }));

});
parcelRegister("4APnu", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsRedirect", () => $7f2cf35a1bd61fba$export$a24ec33acfeae48d);

var $edbJS = parcelRequire("edbJS");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $7fTjp = parcelRequire("7fTjp");

var $kfvK2 = parcelRequire("kfvK2");

var $2aY2d = parcelRequire("2aY2d");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $4ihOZ = parcelRequire("4ihOZ");

var $kEUB1 = parcelRequire("kEUB1");

var $f2JN3 = parcelRequire("f2JN3");

var $5HWRC = parcelRequire("5HWRC");

var $7jTnu = parcelRequire("7jTnu");

var $ln6Iy = parcelRequire("ln6Iy");

var $15sI9 = parcelRequire("15sI9");

var $4zOR8 = parcelRequire("4zOR8");

var $kbAMe = parcelRequire("kbAMe");

var $eHGsn = parcelRequire("eHGsn");
const $7f2cf35a1bd61fba$export$c224e724e933fbea = (page, pathname)=>{
    if (page === 'customer-notifications') {
        const customerNotificationsPage = pathname.split('/settings/customer-notifications')[1];
        if (customerNotificationsPage === '/template') return 'customer-notifications-template';
        if (customerNotificationsPage === '/account-notification/invite-customer') return 'customer-notifications-invite-customer';
        if (/rule\/\d+/.test(customerNotificationsPage)) return 'customer-notifications-rule';
    }
    return page;
};
const $7f2cf35a1bd61fba$export$2d1034e371a567c6 = (page, pathname, helpCenterId)=>{
    switch(page){
        case 'kb':
            return (0, $kbAMe.getSettingsPath)(pathname.replace('/confluence-kb', '/kb'), true, helpCenterId);
        default:
            return (0, $kbAMe.getSettingsPath)(pathname, true, helpCenterId);
    }
};
const $7f2cf35a1bd61fba$var$useLocation = (0, $kfvK2.createRouterSelector)((state)=>state.location);
const $7f2cf35a1bd61fba$export$b90b599f4b180ba = ({ page: page, children: children })=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const useLocationOld = (0, $kfvK2.createRouterSelector)((state)=>state.location);
    // eslint-disable-next-line react-hooks/react-compiler
    const location = useLocationOld();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const isJCS = (0, $4zOR8.useIsJCSProjectType)(projectContext?.projectType);
    (0, $eJOHy.useEffect)(()=>{
        if (isJCS && !(0, $15sI9.isHelpCenterSettingsPath)()) {
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectSettingsToHelpCenterSettings redirected', {
                page: $7f2cf35a1bd61fba$export$c224e724e933fbea(page, location.pathname)
            });
            showFlag({
                messageId: 'servicedesk-customer-service-common.ui.help-center-settings-redirect.show-flag.error',
                messageType: 'transactional',
                type: 'error',
                title: formatMessage((0, $eHGsn.default).errorTitle),
                description: formatMessage((0, $7jTnu.fg)('jcs_project_type_m3') ? (0, $eHGsn.default).description : (0, $eHGsn.default).errorDescription),
                isAutoDismiss: true
            });
        }
    }, [
        createAnalyticsEvent,
        formatMessage,
        isJCS,
        location.pathname,
        page,
        showFlag
    ]);
    if (isJCS && !(0, $15sI9.isHelpCenterSettingsPath)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/helpcenter"
    });
    return children;
};
const $7f2cf35a1bd61fba$export$4e0587d8c8738b4d = ({ page: page, children: children })=>{
    const location = $7f2cf35a1bd61fba$var$useLocation();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const isJCS = projectContext?.projectType === (0, $ln6Iy.CUSTOMER_SERVICE_PROJECT);
    (0, $eJOHy.useEffect)(()=>{
        if (isJCS && !(0, $15sI9.isHelpCenterSettingsPath)()) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectSettingsToHelpCenterSettings redirected', {
            page: $7f2cf35a1bd61fba$export$c224e724e933fbea(page, location.pathname)
        });
    }, [
        createAnalyticsEvent,
        isJCS,
        location.pathname,
        page
    ]);
    if (isJCS && !(0, $15sI9.isHelpCenterSettingsPath)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f2cf35a1bd61fba$export$b65700afa6ae3ae9, {
        page: page,
        pathname: location.pathname,
        projectId: projectContext.projectId
    });
    return children;
};
const $7f2cf35a1bd61fba$export$b65700afa6ae3ae9 = ({ page: page, pathname: pathname, projectId: projectId })=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const activationId = (0, $4ihOZ.useActivationId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const jiraProjectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    const jiraWorkspaceAri = `ari:cloud:jira:${cloudId}:workspace/${activationId}`;
    const { helpCenter: { helpCenterByHoistedProjectIdRouted: helpCenter } } = (0, $j4oe4.useLazyLoadQuery)((0, $edbJS.default), {
        cloudId: cloudId,
        jiraProjectAri: jiraProjectAri,
        jiraWorkspaceAri: jiraWorkspaceAri
    });
    if (helpCenter.__typename !== 'HelpCenter') {
        showFlag({
            messageId: 'servicedesk-customer-service-common.ui.help-center-settings-redirect.show-flag.error.1',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $eHGsn.default).errorTitle),
            description: formatMessage((0, $eHGsn.default).errorDescription),
            isAutoDismiss: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
            to: "/jira/helpcenter"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: $7f2cf35a1bd61fba$export$2d1034e371a567c6(page, pathname, (0, $5HWRC.HelpHelpCenterAri).parse(helpCenter.id).helpCenterId),
        persistSearchParams: true
    });
};
const $7f2cf35a1bd61fba$export$a24ec33acfeae48d = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jcs_project_type_m3'), $7f2cf35a1bd61fba$export$4e0587d8c8738b4d, $7f2cf35a1bd61fba$export$b90b599f4b180ba);

});
parcelRegister("edbJS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e147bc177b0a9f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a71e1d1b1dbf7cb82e4e714dfd62b93>>
 * @relayHash e13196a4072c1e05f1d5cb92fe604cee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d94a9943ce2554eb8cf7db62a3d014b0ef4ffb159df3aec135c71cb712c22610
const $7e147bc177b0a9f8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraProjectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraWorkspaceAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "projectAri",
            "variableName": "jiraProjectAri"
        },
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "jiraWorkspaceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": v4 /*: any*/ ,
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "helpCenterSettingsRedirectQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "HelpCenterQueryApi",
                        "kind": "LinkedField",
                        "name": "helpCenter",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterByHoistedProjectIdRouted",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "helpCenter.helpCenterByHoistedProjectIdRouted"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "helpCenter"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "helpCenterSettingsRedirectQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterByHoistedProjectIdRouted",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v4 /*: any*/ ,
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d94a9943ce2554eb8cf7db62a3d014b0ef4ffb159df3aec135c71cb712c22610",
            "metadata": {},
            "name": "helpCenterSettingsRedirectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7e147bc177b0a9f8$var$node.hash = "87969f8d9448b730bb329d59f60087f6";
var $7e147bc177b0a9f8$export$2e2bcd8739ae039 = $7e147bc177b0a9f8$var$node;

});

parcelRegister("5HWRC", function(module, exports) {

$parcel$export(module.exports, "HelpHelpCenterAri", () => $427ea1049004db28$export$a75f3c98d930b258);

var $1gIyy = parcelRequire("1gIyy");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/help/help-center/manifest.ts
var $427ea1049004db28$var$helpHelpCenterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $1gIyy.HelpHelpCenterAriResourceOwner),
    resourceType: (0, $1gIyy.HelpHelpCenterAriResourceType),
    resourceIdSlug: "{activationId}/{helpCenterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        helpCenterId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/help/help-center/index.ts
var $427ea1049004db28$export$a75f3c98d930b258 = class _HelpHelpCenterAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._activationId = opts.resourceIdSegmentValues.activationId, this._helpCenterId = opts.resourceIdSegmentValues.helpCenterId;
    }
    get activationId() {
        return this._activationId;
    }
    get helpCenterId() {
        return this._helpCenterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $427ea1049004db28$var$helpHelpCenterAriStaticOpts.qualifier,
            platformQualifier: $427ea1049004db28$var$helpHelpCenterAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $427ea1049004db28$var$helpHelpCenterAriStaticOpts.resourceOwner,
            resourceType: $427ea1049004db28$var$helpHelpCenterAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.helpCenterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                helpCenterId: opts.helpCenterId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $427ea1049004db28$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $427ea1049004db28$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            helpCenterId: this.helpCenterId
        };
    }
};

});
parcelRegister("1gIyy", function(module, exports) {

$parcel$export(module.exports, "HelpHelpCenterAriResourceOwner", () => $0ec9d9033d8aaf25$export$a4af98a27b4568ee);
$parcel$export(module.exports, "HelpHelpCenterAriResourceType", () => $0ec9d9033d8aaf25$export$f6271ed6947e9084);
// src/help/help-center/types.ts
var $0ec9d9033d8aaf25$export$a4af98a27b4568ee = "help", $0ec9d9033d8aaf25$export$f6271ed6947e9084 = "help-center";

});


parcelRegister("15sI9", function(module, exports) {

$parcel$export(module.exports, "isHelpCenterSettingsPath", () => $8aef23fd68bfd597$export$bf8b98b87d485657);
$parcel$export(module.exports, "getHelpCenterUUIDFromPath", () => $8aef23fd68bfd597$export$73a9fbfd9155f593);

var $gRw8I = parcelRequire("gRw8I");

var $7jTnu = parcelRequire("7jTnu");
const $8aef23fd68bfd597$export$bf8b98b87d485657 = ()=>{
    (0, $gRw8I.di)(window);
    if (!(0, $7jTnu.fg)('jcs_master_flag')) return false;
    if (!false) return window.location.pathname.includes('jira/helpcenter/');
    return false;
};
const $8aef23fd68bfd597$export$73a9fbfd9155f593 = ()=>{
    (0, $gRw8I.di)(window);
    if (!$8aef23fd68bfd597$export$bf8b98b87d485657()) return '';
    if (!false) return window.location.pathname.match(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/)?.[0];
    return '';
};

});

parcelRegister("4zOR8", function(module, exports) {

$parcel$export(module.exports, "useAsyncIsJCS", () => $03a8239df13c06d0$export$3894a8f24b665478);
$parcel$export(module.exports, "isJCSProjectType", () => $03a8239df13c06d0$export$25e1541dd4631818);
$parcel$export(module.exports, "useIsJCSProjectType", () => $03a8239df13c06d0$export$b78b0f34fdacd97a);
$parcel$export(module.exports, "isJCSTemplate", () => $03a8239df13c06d0$export$afee907b7a66ef2b);

var $hbF3h = parcelRequire("hbF3h");

var $7jTnu = parcelRequire("7jTnu");

var $jHFs0 = parcelRequire("jHFs0");

var $ln6Iy = parcelRequire("ln6Iy");
const $03a8239df13c06d0$var$useIsJCSProjectTypeFallback = (projectType, isAsync)=>{
    const isJCS = $03a8239df13c06d0$export$3894a8f24b665478();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return isAsync ? isJCS : Boolean(isJCS);
};
const $03a8239df13c06d0$export$25e1541dd4631818 = (projectType)=>projectType === (0, $ln6Iy.CUSTOMER_SERVICE_PROJECT) && (0, $7jTnu.fg)('jcs_project_type_m3');
const $03a8239df13c06d0$export$4b74a6f22da4a0d2 = (projectType)=>projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT) || $03a8239df13c06d0$export$25e1541dd4631818(projectType);
const $03a8239df13c06d0$export$b78b0f34fdacd97a = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('jcs_project_type_m3'), $03a8239df13c06d0$export$25e1541dd4631818, $03a8239df13c06d0$var$useIsJCSProjectTypeFallback);
//
//  M2 helpers, deprecated
// ---------------------
const $03a8239df13c06d0$var$useIsJCSUnderFF = ()=>{
    const { 'initial.project.template.name': initialProjectTemplate } = (0, $jHFs0.useProjectProperties)([
        'initial.project.template.name'
    ]);
    return initialProjectTemplate === 'com.atlassian.jcs:customer-service-management';
};
const $03a8239df13c06d0$export$927b5354181b3adf = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('jcs_master_flag'), $03a8239df13c06d0$var$useIsJCSUnderFF, ()=>false);
// Undefined can be used to check if project properties has been resolved or not
const $03a8239df13c06d0$var$useAsyncIsJCSUnderFF = ()=>{
    const { 'initial.project.template.name': initialProjectTemplate } = (0, $jHFs0.useProjectProperties)([
        'initial.project.template.name'
    ]);
    return initialProjectTemplate ? initialProjectTemplate === 'com.atlassian.jcs:customer-service-management' : undefined;
};
const $03a8239df13c06d0$export$3894a8f24b665478 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('jcs_master_flag'), $03a8239df13c06d0$var$useAsyncIsJCSUnderFF, ()=>false);
const $03a8239df13c06d0$var$isJCSTemplateUnderFF = (template)=>template === 'com.atlassian.jcs:customer-service-management';
const $03a8239df13c06d0$var$isJCSTemplateFallback = (template)=>false;
const $03a8239df13c06d0$export$afee907b7a66ef2b = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('jcs_master_flag'), $03a8239df13c06d0$var$isJCSTemplateUnderFF, $03a8239df13c06d0$var$isJCSTemplateFallback);

});
parcelRegister("jHFs0", function(module, exports) {

$parcel$export(module.exports, "useProjectProperties", () => $8737631b384de95a$export$58be98885c2d686a);

var $eJOHy = parcelRequire("eJOHy");

var $bPWfC = parcelRequire("bPWfC");

var $cSmYj = parcelRequire("cSmYj");

var $9pL9Y = parcelRequire("9pL9Y");

var $eWzpp = parcelRequire("eWzpp");

var $6d9QY = parcelRequire("6d9QY");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $89kvn = parcelRequire("89kvn");
const $8737631b384de95a$export$d4c72bab9d6cc13a = {};
const $8737631b384de95a$var$Store = (0, $GtRbT.createStore)({
    name: 'project-properties',
    initialState: $8737631b384de95a$export$d4c72bab9d6cc13a,
    actions: $89kvn.actions
});
const $8737631b384de95a$export$eebf791068e870dd = (0, $iJq0l.createHook)($8737631b384de95a$var$Store);
const $8737631b384de95a$export$58be98885c2d686a = (propertyKeys, projectIdOverride)=>{
    const { data: data } = (0, $eWzpp.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const projectId = projectIdOverride !== undefined ? projectIdOverride : data?.id && `${data.id}`;
    const [state, { get: get }] = $8737631b384de95a$export$eebf791068e870dd();
    const prevPropertyKeys = (0, $6d9QY.usePrevious)(propertyKeys);
    (0, $eJOHy.useEffect)(()=>{
        if (projectId === undefined) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraProjectPropertiesServices undefinedProjectId');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(propertyKeys, prevPropertyKeys) && !projectIdOverride) return;
        if (projectId) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        get(projectId, propertyKeys);
    }, [
        projectId,
        propertyKeys,
        prevPropertyKeys,
        get,
        createAnalyticsEvent,
        projectIdOverride
    ]);
    return projectId !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(state[projectId], (_, key)=>(0, (/*@__PURE__*/$parcel$interopDefault($bPWfC)))(propertyKeys, key)) : {};
};

});
parcelRegister("bPWfC", function(module, exports) {

var $kEE3x = parcelRequire("kEE3x");

var $7H30b = parcelRequire("7H30b");

var $l5Z0K = parcelRequire("l5Z0K");

var $c9FP3 = parcelRequire("c9FP3");

var $40zJW = parcelRequire("40zJW");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $89e1a48dc6c79c2b$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $89e1a48dc6c79c2b$var$includes(collection, value, fromIndex, guard) {
    collection = $7H30b(collection) ? collection : $40zJW(collection);
    fromIndex = fromIndex && !guard ? $c9FP3(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $89e1a48dc6c79c2b$var$nativeMax(length + fromIndex, 0);
    return $l5Z0K(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $kEE3x(collection, value, fromIndex) > -1;
}
module.exports = $89e1a48dc6c79c2b$var$includes;

});
parcelRegister("l5Z0K", function(module, exports) {

var $1O9y6 = parcelRequire("1O9y6");

var $4sprp = parcelRequire("4sprp");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $f5b964216372e7cd$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $f5b964216372e7cd$var$isString(value) {
    return typeof value == 'string' || !$4sprp(value) && $7gKgM(value) && $1O9y6(value) == $f5b964216372e7cd$var$stringTag;
}
module.exports = $f5b964216372e7cd$var$isString;

});


parcelRegister("89kvn", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4e23de55f0dc6aa6$export$e324594224ef24da);

var $lah0B = parcelRequire("lah0B");
const $4e23de55f0dc6aa6$export$e324594224ef24da = {
    get: $lah0B.get
};

});
parcelRegister("lah0B", function(module, exports) {

$parcel$export(module.exports, "get", () => $fe45d3e1a1e07c68$export$3988ae62b71be9a3);

var $2zs80 = parcelRequire("2zs80");

var $6dPbw = parcelRequire("6dPbw");

var $4c94y = parcelRequire("4c94y");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $8wOps = parcelRequire("8wOps");
const $fe45d3e1a1e07c68$export$3988ae62b71be9a3 = (projectId, properties)=>({ getState: getState, setState: setState })=>{
        const currentProperties = getState()[projectId] || {};
        const missingProperties = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(properties, (0, (/*@__PURE__*/$parcel$interopDefault($4c94y)))(currentProperties));
        missingProperties.length && ((0, $7jTnu.fg)('fix_for_sentry_alert_13071_on_project_properties') ? (0, $8wOps.default)({
            projectId: projectId,
            properties: missingProperties
        }).then((fetchedProperties)=>{
            const latestProperties = getState()[projectId] || {};
            setState({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [projectId]: {
                    ...latestProperties,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ...missingProperties.reduce((result, name)=>{
                        const reducedResult = result;
                        const fetchedProperty = fetchedProperties?.[name];
                        // `undefined` inside state means that property was never requested.
                        // If value returned for the property is `undefined`, we will set it to `null`,
                        // to differentiate it from the unrequested state. Otherwise, returned value will be set.
                        reducedResult[name] = (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw)))(fetchedProperty) ? null : fetchedProperty;
                        return reducedResult;
                    }, {})
                }
            });
        }).catch((error)=>{
            // Even on error, we should mark the properties as requested but failed
            // to differentiate from unrequested state
            const latestProperties = getState()[projectId] || {};
            setState({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [projectId]: {
                    ...latestProperties,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ...missingProperties.reduce((result, name)=>{
                        const reducedResult = result;
                        // Mark as null to indicate "requested but failed to load"
                        reducedResult[name] = null;
                        return reducedResult;
                    }, {})
                }
            });
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'getProjectProperties',
                    packageName: 'jiraProjectPropertiesServices',
                    teamName: 'Sequoia'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }) : (0, $8wOps.default)({
            projectId: projectId,
            properties: missingProperties
        }).then((fetchedProperties)=>{
            const latestProperties = getState()[projectId] || {};
            setState({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [projectId]: {
                    ...latestProperties,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ...missingProperties.reduce((result, name)=>{
                        const reducedResult = result;
                        const fetchedProperty = fetchedProperties?.[name];
                        // `undefined` inside state means that property was never requested.
                        // If value returned for the property is `undefined`, we will set it to `null`,
                        // to differentiate it from the unrequested state. Otherwise, returned value will be set.
                        reducedResult[name] = (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw)))(fetchedProperty) ? null : fetchedProperty;
                        return reducedResult;
                    }, {})
                }
            });
        }));
    };

});
parcelRegister("8wOps", function(module, exports) {

$parcel$export(module.exports, "default", () => $39c6eaa9a82a8c67$export$2e2bcd8739ae039);

var $fnu0d = parcelRequire("fnu0d");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$39c6eaa9a82a8c67$export$2e2bcd8739ae039 = async ({ projectId: projectId, properties: properties })=>{
    const { project: project } = await (0, $fnu0d.get)({
        projectId: projectId,
        projectProperties: properties,
        consumerMeta: {
            id: 'remoteGet',
            packageName: 'jiraProjectPropertiesServices',
            teamName: 'jsd-shield'
        }
    });
    return project;
};

});





parcelRegister("kbAMe", function(module, exports) {

$parcel$export(module.exports, "getSettingsPath", () => $4de62efb8d65a30f$export$67417cd3aaee582d);
const $4de62efb8d65a30f$export$67417cd3aaee582d = (path, isJCS, helpCenterId)=>{
    if (!helpCenterId) return isJCS ? path.replace('/jira/servicedesk/', '/jira/helpcenter/') : path;
    return path.replace('/jira/servicedesk/', '/jira/helpcenter/').replace('/settings', `/settings/${helpCenterId}`);
};

});

parcelRegister("eHGsn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4058617b77d67d0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e4058617b77d67d0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "servicedesk-customer-service-common.help-center-settings-redirect.error-title",
        "defaultMessage": "This page has been moved"
    },
    errorDescription: {
        "id": "servicedesk-customer-service-common.help-center-settings-redirect.error-description",
        "defaultMessage": "You can find the page you\u2019re looking for in a service hub."
    },
    description: {
        "id": "servicedesk-customer-service-common.help-center-settings-redirect.description",
        "defaultMessage": "You can find the page you\u2019re looking for in a customer hub."
    }
});

});


parcelRegister("aTOp6", function(module, exports) {

let $7ef62394b5390451$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7ef62394b5390451$var$load("1VRB2"),
    $7ef62394b5390451$var$load("bABhq"),
    $7ef62394b5390451$var$load("et8TY")
]).then(()=>parcelRequire('bz3yf'));

});



parcelRegister("5k4zE", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPermissionsNextGenRouteEntry", () => $e38a37dea8be38c8$export$65a2b00cdeff4516);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $393uA = parcelRequire("393uA");

var $kTJYz = parcelRequire("kTJYz");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $k4Fbw = parcelRequire("k4Fbw");

var $lHKQ7 = parcelRequire("lHKQ7");
const $e38a37dea8be38c8$export$65a2b00cdeff4516 = (0, $6xToB.createEntry)((0, $kTJYz.projectSettingsServicedeskChannelsPermissionsNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $k4Fbw.customerPermissionsRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $393uA.customerPermissionsPageDataResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $lHKQ7.LazyProjectSettingsServiceDeskCustomerPermissions)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions'
    }));

});
parcelRegister("393uA", function(module, exports) {

$parcel$export(module.exports, "customerPermissionsPageDataResource", () => $77ff35771c349120$export$ae3446385906310c);

var $l1VxS = parcelRequire("l1VxS");


const $77ff35771c349120$export$ae3446385906310c = (0, $l1VxS.createResource)({
    type: (0, $aeecb035e15f59c4$export$34a89f9aaa677bb5),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("bGBK1")),
    maxAge: Infinity
});

});
const $aeecb035e15f59c4$export$34a89f9aaa677bb5 = 'CUSTOMER_PERMISSIONS';

parcelRegister("bGBK1", function(module, exports) {

let $8820e4968427c6ce$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8820e4968427c6ce$var$load("1Bdan").then(()=>parcelRequire('eipTf'));

});


parcelRegister("k4Fbw", function(module, exports) {

$parcel$export(module.exports, "customerPermissionsRedirect", () => $559fc0f9b687d27f$export$59eedcca37dbbafd);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $559fc0f9b687d27f$export$59eedcca37dbbafd = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-permissions`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: url
    });
};

});

parcelRegister("lHKQ7", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskCustomerPermissions", () => $a85ba1ba70aa3e84$export$5367e40a24f0bd54);
$parcel$export(module.exports, "default", () => $a85ba1ba70aa3e84$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $a85ba1ba70aa3e84$export$5367e40a24f0bd54 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fEPfv"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-permissions/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a85ba1ba70aa3e84$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a85ba1ba70aa3e84$export$5367e40a24f0bd54,
        pageId: "project-settings-customer-permissions",
        shouldShowSpinner: true
    });

});
parcelRegister("fEPfv", function(module, exports) {

let $b6625875ce22c4d7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b6625875ce22c4d7$var$load("5Ad4z").then(()=>parcelRequire('ghfmm'));

});



parcelRegister("5w2Cj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPortalRouteEntry", () => $c7fd134a5a9d82ca$export$7b7294b50c70e50c);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $3pUIh = parcelRequire("3pUIh");

var $azYhY = parcelRequire("azYhY");

var $aQoXd = parcelRequire("aQoXd");

var $l1xjV = parcelRequire("l1xjV");

var $9KQ6p = parcelRequire("9KQ6p");
const $c7fd134a5a9d82ca$export$7b7294b50c70e50c = (0, $6xToB.createEntry)((0, $azYhY.projectSettingsServicedeskChannelsPortalRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $9KQ6p.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $3pUIh.portalSettingsContextResource),
            (0, $l1xjV.serviceDeskPortalSettingsResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9KQ6p.LazyProjectSettingsServiceDeskPortalSettings)
        ]
    }));

});
parcelRegister("3pUIh", function(module, exports) {

$parcel$export(module.exports, "portalSettingsContextResource", () => $cf274a567804ac90$export$4a3e29f235f3320c);

var $l1VxS = parcelRequire("l1VxS");
const $cf274a567804ac90$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT = 'PORTAL_SETTINGS_CONTEXT';

const $cf274a567804ac90$export$4a3e29f235f3320c = (0, $l1VxS.createResource)({
    type: $cf274a567804ac90$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("isONg"))
});

});
parcelRegister("isONg", function(module, exports) {

let $d7123e0d195a1299$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d7123e0d195a1299$var$load("hYuJl").then(()=>parcelRequire('cVpTe'));

});


parcelRegister("l1xjV", function(module, exports) {

$parcel$export(module.exports, "serviceDeskPortalSettingsResource", () => $f1b4420f26050bc4$export$ed977e313d34da4b);

var $9FYIg = parcelRequire("9FYIg");

var $6GtY0 = parcelRequire("6GtY0");
const $f1b4420f26050bc4$export$ed977e313d34da4b = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_SERVICE_DESK_PORTAL_SETTINGS`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $6GtY0.default),
            variables: {
                cloudId: cloudId,
                input: {
                    onlyMyAgents: true,
                    onlyFavouriteAgents: false
                }
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true
});

});
parcelRegister("6GtY0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c8831fb02e68698$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<33b1044dd8492d1e2afd261ac1aab28a>>
 * @relayHash e5e2b1d58847a6a52773ca8f7c14041a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f71b7c187d998485036be8a9e0091d6bd6b2a348424c82c0c1545d35921111e

var $kEBh8 = parcelRequire("kEBh8");
const $2c8831fb02e68698$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 30
        },
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyFavouriteAgents": false,
                "onlyMyAgents": true
            }
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewServiceDeskPortalSettingsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "ui_servicedeskSettingsCustomerPortalV2_CustomerPortalSettingsPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "viewServiceDeskPortalSettingsQuery",
            "selections": [
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "AgentStudioAgentsConnection",
                            "kind": "LinkedField",
                            "name": "agentStudio_getAgents",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "AgentStudioAgentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "AgentStudioAssistant",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "externalConfigReference"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "identityAccountId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "creatorType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v2 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "input"
                            ],
                            "handle": "connection",
                            "key": "RovoAgent_agentStudio_getAgents",
                            "kind": "LinkedHandle",
                            "name": "agentStudio_getAgents"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2f71b7c187d998485036be8a9e0091d6bd6b2a348424c82c0c1545d35921111e",
            "metadata": {},
            "name": "viewServiceDeskPortalSettingsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider": (0, $kEBh8.default)
            }
        }
    };
}();
$2c8831fb02e68698$var$node.hash = "a0cb09ba40a74d85ec08c13dadefd197";
var $2c8831fb02e68698$export$2e2bcd8739ae039 = $2c8831fb02e68698$var$node;

});
parcelRegister("kEBh8", function(module, exports) {

$parcel$export(module.exports, "default", () => $423071dd88fb4e5e$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $423071dd88fb4e5e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jsm_portal_rovo_agent_config_experience');
    }
};

});



parcelRegister("9KQ6p", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskPortalSettings", () => $194d1ca1f686a549$export$fdbd4b1e5ae0e422);
$parcel$export(module.exports, "default", () => $194d1ca1f686a549$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $194d1ca1f686a549$export$fdbd4b1e5ae0e422 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("4VXXh")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-portal-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$194d1ca1f686a549$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $194d1ca1f686a549$export$fdbd4b1e5ae0e422,
        pageId: "project-settings-portal-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("4VXXh", function(module, exports) {

let $397afe218b40e3ff$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $397afe218b40e3ff$var$load("27tR8").then(()=>parcelRequire('e4Icc'));

});



parcelRegister("cq7wq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsRouteEntry", () => $71dfe6b50d35f92b$export$2d20001d3350adbc);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $2fr4w = parcelRequire("2fr4w");

var $aQoXd = parcelRequire("aQoXd");

var $14hVA = parcelRequire("14hVA");
const $71dfe6b50d35f92b$export$2d20001d3350adbc = (0, $6xToB.createEntry)((0, $2fr4w.projectSettingsServicedeskChannelsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $14hVA.channelsRedirect)('customer-permissions'),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("2fr4w", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsRoute", () => $7f065328fdde9dbd$export$36e4210554830c2f);
const $7f065328fdde9dbd$export$36e4210554830c2f = {
    name: 'project-settings-servicedesk-channels',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels',
    exact: true
};

});

parcelRegister("14hVA", function(module, exports) {

$parcel$export(module.exports, "channelsRedirect", () => $cdecb553aa88fe31$export$c7e6c0ac0abe2336);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $47Jx0 = parcelRequire("47Jx0");

var $2mHfh = parcelRequire("2mHfh");
const $cdecb553aa88fe31$export$c7e6c0ac0abe2336 = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `${(0, $47Jx0.getNextgenSettingsUrl)((0, $ln6Iy.SERVICE_DESK_PROJECT), String(projectKey))}/channels/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: url,
            push: false
        });
    };

});
parcelRegister("47Jx0", function(module, exports) {

$parcel$export(module.exports, "getNextgenSettingsUrl", () => $ca6ed08f86da0440$export$26432406821aa7bf);
$parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", () => $ca6ed08f86da0440$export$defee92e506aa306);
$parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", () => $ca6ed08f86da0440$export$9133e09a98a043dc);
$parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", () => $ca6ed08f86da0440$export$b0d20d18e0230e83);
$parcel$export(module.exports, "getClassicJSWSettingsUrl", () => $ca6ed08f86da0440$export$ff0a17aa36a000df);
$parcel$export(module.exports, "getProjectSettingsDetailsUrl", () => $ca6ed08f86da0440$export$16d52b9357bb73ab);
$parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", () => $ca6ed08f86da0440$export$d531a9788343348f);
$parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", () => $ca6ed08f86da0440$export$dad567762dae162e);

var $ln6Iy = parcelRequire("ln6Iy");

var $7jTnu = parcelRequire("7jTnu");

var $eWLuJ = parcelRequire("eWLuJ");

var $h7qTf = parcelRequire("h7qTf");

var $fYGRD = parcelRequire("fYGRD");

var $5CoMi = parcelRequire("5CoMi");
const $ca6ed08f86da0440$export$26432406821aa7bf = (projectType, projectKey)=>{
    const products = {
        [(0, $ln6Iy.CORE_PROJECT)]: 'core',
        [(0, $ln6Iy.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $ln6Iy.CUSTOMER_SERVICE_PROJECT)]: (0, $7jTnu.fg)('jcs_project_type_m3') ? 'servicedesk' : 'customerservice',
        [(0, $ln6Iy.SOFTWARE_PROJECT)]: 'software',
        [(0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
    };
    const product = products[projectType];
    if (!product) {
        (0, $5CoMi.logError)((0, $h7qTf.PACKAGE_NAME), (0, $fYGRD.toErrorId)('urls'), (0, $fYGRD.toErrorMessage)(`Can't build default project settings url for project type: ${projectType}`), new Error(`Unexpected project type: ${projectType}`));
        // let's return classic url in that case
        return `/projects/${projectKey}/settings`;
    }
    if (projectType === (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
    return `/jira/${product}/projects/${projectKey}/settings`;
};
const $ca6ed08f86da0440$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
    if (projectType === (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT)) return `${$ca6ed08f86da0440$export$26432406821aa7bf(projectType, projectKey)}`;
    return `${$ca6ed08f86da0440$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${(0, $eWLuJ.serializeBackLink)(backLink)}`;
};
const $ca6ed08f86da0440$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
    if (projectType === (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT)) return `${$ca6ed08f86da0440$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
    return `${$ca6ed08f86da0440$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
};
const $ca6ed08f86da0440$export$b0d20d18e0230e83 = (projectKey)=>`${$ca6ed08f86da0440$export$26432406821aa7bf((0, $ln6Iy.SERVICE_DESK_PROJECT), projectKey)}/automation`;
const $ca6ed08f86da0440$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
const $ca6ed08f86da0440$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
    const urlBase = projectType === (0, $ln6Iy.SOFTWARE_PROJECT) && !isSimplified ? $ca6ed08f86da0440$export$ff0a17aa36a000df(projectKey) : $ca6ed08f86da0440$export$26432406821aa7bf(projectType, projectKey);
    return `${urlBase}/details`;
};
const $ca6ed08f86da0440$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${(0, $eWLuJ.serializeBackLink)(backLink)}`;
const $ca6ed08f86da0440$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${(0, $eWLuJ.serializeBackLink)(backLink)}`;

});
parcelRegister("eWLuJ", function(module, exports) {

$parcel$export(module.exports, "serializeBackLink", () => $f823ea5af97fa5f4$export$abebef1e474c32c5);
$parcel$export(module.exports, "getHrefWithBackLink", () => $f823ea5af97fa5f4$export$6d7b0d2d046b7fdd);
/**
 * When users complete task in SWIFT settings page, a UI flag shows and says "Go back to X"
 * This object configures the URL and _translated_ link text of the UI flag.
 *
 * If this backlink is not configured then SWIFT uses some default text ("Go to project") or similar.
 * Each project type has its own defaults: configured in Product features
 *
 * See https://hello.atlassian.net/wiki/spaces/JPCE/pages/700125807/SWIFT+backlinks
 */ const $f823ea5af97fa5f4$export$abebef1e474c32c5 = (backLink)=>{
    if (backLink == null) return '';
    const { url: url, title: title } = backLink;
    return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
};
const $f823ea5af97fa5f4$export$6d7b0d2d046b7fdd = (href, title)=>{
    if (!href || !href.length) return null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname, search: search } = window.location;
    const backlinkData = {
        // url and title are not using encodeURIComponent here because it will be serialized later.
        url: `${pathname}${search}`,
        title: title
    };
    const backlink = $f823ea5af97fa5f4$export$abebef1e474c32c5(backlinkData);
    return `${href}${backlink}`;
};

});

parcelRegister("h7qTf", function(module, exports) {

$parcel$export(module.exports, "TASK", () => $14c263c1c2dccee0$export$9355e489ad16f98e);
$parcel$export(module.exports, "BUG", () => $14c263c1c2dccee0$export$bcf558c186108044);
$parcel$export(module.exports, "STORY", () => $14c263c1c2dccee0$export$1ea39a3ae330045);
$parcel$export(module.exports, "EPIC", () => $14c263c1c2dccee0$export$3cb4a99a332e4186);
$parcel$export(module.exports, "SUB_TASK", () => $14c263c1c2dccee0$export$a06f889861f6537d);
$parcel$export(module.exports, "CUSTOM", () => $14c263c1c2dccee0$export$952581bc40160893);
$parcel$export(module.exports, "TEMPLATES_WHITELIST", () => $14c263c1c2dccee0$export$dff1da4a9bab6d3e);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $14c263c1c2dccee0$export$39cd48613b53ce2f);
$parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", () => $14c263c1c2dccee0$export$56eae1056efd4899);
$parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", () => $14c263c1c2dccee0$export$ca61f05d869b2ea3);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", () => $14c263c1c2dccee0$export$2ec42920a0df6b9a);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", () => $14c263c1c2dccee0$export$40c10ba35ceb5c6b);
$parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", () => $14c263c1c2dccee0$export$a11dccbf88784c62);
$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_APP_NAME", () => $14c263c1c2dccee0$export$f35dc2e6deb1692e);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_APP_NAME", () => $14c263c1c2dccee0$export$b36025abb367eace);
$parcel$export(module.exports, "JIRA_APP_NAME", () => $14c263c1c2dccee0$export$ec5d0e43836cb3c7);
$parcel$export(module.exports, "toPackageName", () => $14c263c1c2dccee0$export$f31a652635bd75fe);
$parcel$export(module.exports, "PACKAGE_NAME", () => $14c263c1c2dccee0$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", () => $14c263c1c2dccee0$export$a2231d79966e0ccc);
$parcel$export(module.exports, "RADIO_FIELD_TYPE", () => $14c263c1c2dccee0$export$28a4bdf7d9b6f9);
$parcel$export(module.exports, "USERPICKER_FIELD_TYPE", () => $14c263c1c2dccee0$export$9d758b3e8c6e0ed1);
$parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", () => $14c263c1c2dccee0$export$b0e37d421e006913);
$parcel$export(module.exports, "SELECT_FIELD_TYPE", () => $14c263c1c2dccee0$export$d77765147749db6b);
$parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", () => $14c263c1c2dccee0$export$42ef68d6bd555a8d);
$parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", () => $14c263c1c2dccee0$export$4db6eb15b3c529cf);
$parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", () => $14c263c1c2dccee0$export$ee975373b7797e8a);
$parcel$export(module.exports, "TEXT_FIELD_TYPE", () => $14c263c1c2dccee0$export$aa99342cc6a8ced5);
$parcel$export(module.exports, "NUMBER_FIELD_TYPE", () => $14c263c1c2dccee0$export$6f327bf99e20320);
$parcel$export(module.exports, "DATETIME_FIELD_TYPE", () => $14c263c1c2dccee0$export$dc64bdfdf9660a05);
$parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", () => $14c263c1c2dccee0$export$e6d73ed745b9a04);
$parcel$export(module.exports, "DATE_FIELD_TYPE", () => $14c263c1c2dccee0$export$d8b50f59220c7580);
$parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", () => $14c263c1c2dccee0$export$3a6f0a44478f1d2);
$parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", () => $14c263c1c2dccee0$export$68b76ef93df5a880);
$parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", () => $14c263c1c2dccee0$export$e7773fccbeec45e6);
$parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", () => $14c263c1c2dccee0$export$b45487b145c52a37);
$parcel$export(module.exports, "VERSION_FIELD_TYPE", () => $14c263c1c2dccee0$export$48548129a6d117f5);
$parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", () => $14c263c1c2dccee0$export$722c271a9e11cb94);
$parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", () => $14c263c1c2dccee0$export$33dbe2a903610aa1);
$parcel$export(module.exports, "emptyTenantContext", () => $14c263c1c2dccee0$export$ac655f5b3ff7b929);
// Issue Type Templates

var $4qiFT = parcelRequire("4qiFT");

var $814y1 = parcelRequire("814y1");

var $a9ldn = parcelRequire("a9ldn");

var $ljej9 = parcelRequire("ljej9");

var $hmtVp = parcelRequire("hmtVp");

var $c9z5K = parcelRequire("c9z5K");
const $14c263c1c2dccee0$export$9355e489ad16f98e = 'task';
const $14c263c1c2dccee0$export$bcf558c186108044 = 'bug';
const $14c263c1c2dccee0$export$1ea39a3ae330045 = 'story';
const $14c263c1c2dccee0$export$3cb4a99a332e4186 = 'epic';
const $14c263c1c2dccee0$export$a06f889861f6537d = 'subtask';
const $14c263c1c2dccee0$export$952581bc40160893 = 'custom';
const $14c263c1c2dccee0$export$dff1da4a9bab6d3e = [
    $14c263c1c2dccee0$export$9355e489ad16f98e,
    $14c263c1c2dccee0$export$bcf558c186108044,
    $14c263c1c2dccee0$export$1ea39a3ae330045,
    $14c263c1c2dccee0$export$3cb4a99a332e4186
];
const $14c263c1c2dccee0$export$39cd48613b53ce2f = (0, $814y1.TEXT_AREA_CF_TYPE);
const $14c263c1c2dccee0$export$56eae1056efd4899 = (0, $814y1.DESCRIPTION_TYPE);
const $14c263c1c2dccee0$export$ca61f05d869b2ea3 = (0, $814y1.ENVIRONMENT_TYPE);
const $14c263c1c2dccee0$export$2ec42920a0df6b9a = 'Story point estimate';
const $14c263c1c2dccee0$export$40c10ba35ceb5c6b = 'storyPointEstimate';
const $14c263c1c2dccee0$export$a4d3702d4c7481d6 = 44;
const $14c263c1c2dccee0$export$8a6a961f6caf7a8b = [
    $14c263c1c2dccee0$export$56eae1056efd4899,
    $14c263c1c2dccee0$export$39cd48613b53ce2f,
    $14c263c1c2dccee0$export$ca61f05d869b2ea3
];
const $14c263c1c2dccee0$export$e27914436cc13e3c = 'Jira Software';
const $14c263c1c2dccee0$export$a11dccbf88784c62 = 'Jira Service Management';
const $14c263c1c2dccee0$export$9f4aa232cbb6be46 = 'Jira Work Management';
const $14c263c1c2dccee0$export$b3c4739240716eb6 = 'Jira Ops';
const $14c263c1c2dccee0$export$f35dc2e6deb1692e = 'Jira Product Discovery';
const $14c263c1c2dccee0$export$b36025abb367eace = 'Jira Customer Service';
const $14c263c1c2dccee0$export$ec5d0e43836cb3c7 = 'Jira';
const $14c263c1c2dccee0$export$f31a652635bd75fe = (packageName)=>packageName;
const $14c263c1c2dccee0$export$b8b9d90f9e5bd72b = $14c263c1c2dccee0$export$f31a652635bd75fe('jiraProjectSettingsAppsCommon');
const $14c263c1c2dccee0$export$a2231d79966e0ccc = 'NEW_';
const $14c263c1c2dccee0$export$13dc44d2a9a248a4 = 'swift_openAddIssueTypeModal';
const $14c263c1c2dccee0$export$28a4bdf7d9b6f9 = 'radio';
const $14c263c1c2dccee0$export$9d758b3e8c6e0ed1 = 'userpicker';
const $14c263c1c2dccee0$export$b0e37d421e006913 = 'multiuserpicker';
const $14c263c1c2dccee0$export$d77765147749db6b = 'select';
const $14c263c1c2dccee0$export$42ef68d6bd555a8d = 'cascadingselect';
const $14c263c1c2dccee0$export$4db6eb15b3c529cf = 'multiselect';
const $14c263c1c2dccee0$export$ee975373b7797e8a = 'checkbox';
const $14c263c1c2dccee0$export$aa99342cc6a8ced5 = 'text';
const $14c263c1c2dccee0$export$6f327bf99e20320 = 'number';
const $14c263c1c2dccee0$export$dc64bdfdf9660a05 = 'datetime';
const $14c263c1c2dccee0$export$e6d73ed745b9a04 = 'projectpicker';
const $14c263c1c2dccee0$export$d8b50f59220c7580 = 'date';
const $14c263c1c2dccee0$export$3a6f0a44478f1d2 = 'assetspicker';
const $14c263c1c2dccee0$export$68b76ef93df5a880 = 'labelpicker';
const $14c263c1c2dccee0$export$e7773fccbeec45e6 = 'grouppicker';
const $14c263c1c2dccee0$export$b45487b145c52a37 = 'multigrouppicker';
const $14c263c1c2dccee0$export$48548129a6d117f5 = 'version';
const $14c263c1c2dccee0$export$722c271a9e11cb94 = 'multiversion';
const $14c263c1c2dccee0$export$33dbe2a903610aa1 = 'textarea';
const $14c263c1c2dccee0$export$ac655f5b3ff7b929 = ()=>({
        appEditions: (0, $a9ldn.populateApplicationEditions)(),
        appPermissions: (0, $c9z5K.populateApplicationPermissions)(),
        applicationKey: null,
        areProductSuggestionsEnabled: false,
        appUpdatesAvailable: null,
        atlassianAccountId: null,
        cloudId: (0, $ljej9.toCloudId)(''),
        activationId: (0, $ljej9.toActivationId)(''),
        cloudName: (0, $ljej9.toCloudName)(''),
        devopsProjectSignupSource: (0, $ljej9.toDevopsProjectSignupSource)(''),
        environment: null,
        fabricActivityUrl: null,
        fabricNotificationLogUrl: null,
        fabricPfDirUrl: null,
        firstActivationDateMs: null,
        isAdmin: false,
        isAnonymous: false,
        isDevMode: false,
        isDevopsProjectCreationScenario: false,
        isMarketingOptOut: false,
        isSiteAdmin: false,
        languageTag: null,
        licenseStates: (0, $hmtVp.populateApplicationLicenseStates)(),
        licensedProducts: {},
        locale: (0, $4qiFT.defaultLocale),
        loggedInUser: null,
        productCrossSellConfig: 'unknown',
        productEntitlementDetails: null,
        productPermissionGated: {
            core: false,
            software: false,
            serviceDesk: false,
            productDiscovery: false,
            customerService: false
        },
        siteAdminStatus: 'unknown',
        userFullname: null,
        xsrfToken: null,
        hasDlpEnabled: false,
        avpWorkspaceId: null,
        cmdbDisabledInFedRAMP: null
    });

});
parcelRegister("814y1", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $1e0b34ed3288576a$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $1e0b34ed3288576a$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $1e0b34ed3288576a$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $1e0b34ed3288576a$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $1e0b34ed3288576a$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $1e0b34ed3288576a$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $1e0b34ed3288576a$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $1e0b34ed3288576a$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $1e0b34ed3288576a$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $1e0b34ed3288576a$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $1e0b34ed3288576a$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $1e0b34ed3288576a$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $1e0b34ed3288576a$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $1e0b34ed3288576a$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $1e0b34ed3288576a$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $1e0b34ed3288576a$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $1e0b34ed3288576a$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $1e0b34ed3288576a$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $1e0b34ed3288576a$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $1e0b34ed3288576a$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $1e0b34ed3288576a$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $1e0b34ed3288576a$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $1e0b34ed3288576a$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $1e0b34ed3288576a$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $1e0b34ed3288576a$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $1e0b34ed3288576a$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $1e0b34ed3288576a$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $1e0b34ed3288576a$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $1e0b34ed3288576a$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $1e0b34ed3288576a$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $1e0b34ed3288576a$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $1e0b34ed3288576a$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $1e0b34ed3288576a$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $1e0b34ed3288576a$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $1e0b34ed3288576a$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $1e0b34ed3288576a$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $1e0b34ed3288576a$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $1e0b34ed3288576a$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $1e0b34ed3288576a$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $1e0b34ed3288576a$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $1e0b34ed3288576a$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $1e0b34ed3288576a$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $1e0b34ed3288576a$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $1e0b34ed3288576a$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $1e0b34ed3288576a$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $1e0b34ed3288576a$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $1e0b34ed3288576a$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $1e0b34ed3288576a$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $1e0b34ed3288576a$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $1e0b34ed3288576a$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $1e0b34ed3288576a$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $1e0b34ed3288576a$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $1e0b34ed3288576a$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $1e0b34ed3288576a$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $1e0b34ed3288576a$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $1e0b34ed3288576a$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $1e0b34ed3288576a$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $1e0b34ed3288576a$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $1e0b34ed3288576a$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $1e0b34ed3288576a$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $1e0b34ed3288576a$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $1e0b34ed3288576a$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $1e0b34ed3288576a$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $1e0b34ed3288576a$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $1e0b34ed3288576a$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $1e0b34ed3288576a$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $1e0b34ed3288576a$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $1e0b34ed3288576a$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $1e0b34ed3288576a$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $1e0b34ed3288576a$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $1e0b34ed3288576a$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $1e0b34ed3288576a$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $1e0b34ed3288576a$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $1e0b34ed3288576a$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $1e0b34ed3288576a$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $1e0b34ed3288576a$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $1e0b34ed3288576a$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $1e0b34ed3288576a$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $1e0b34ed3288576a$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $1e0b34ed3288576a$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $1e0b34ed3288576a$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $1e0b34ed3288576a$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $1e0b34ed3288576a$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $1e0b34ed3288576a$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $1e0b34ed3288576a$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $1e0b34ed3288576a$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $1e0b34ed3288576a$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $1e0b34ed3288576a$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $1e0b34ed3288576a$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $1e0b34ed3288576a$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $1e0b34ed3288576a$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $1e0b34ed3288576a$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $1e0b34ed3288576a$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $1e0b34ed3288576a$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $1e0b34ed3288576a$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $1e0b34ed3288576a$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $1e0b34ed3288576a$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "JCS_ORGANIZATION_GQL_FIELD", () => $1e0b34ed3288576a$export$7fe9e7bac5a59952);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $1e0b34ed3288576a$export$798d2f5814884447);
$parcel$export(module.exports, "FORGE_STRING_TYPE", () => $1e0b34ed3288576a$export$1e188101081be3f8);
$parcel$export(module.exports, "FORGE_STRING_LIST_TYPE", () => $1e0b34ed3288576a$export$caf3b3f20c0589b9);
$parcel$export(module.exports, "FORGE_NUMBER_TYPE", () => $1e0b34ed3288576a$export$9bdf08a1276e866c);
$parcel$export(module.exports, "FORGE_DATE_TYPE", () => $1e0b34ed3288576a$export$996c3d3eb2880229);
$parcel$export(module.exports, "FORGE_DATETIME_TYPE", () => $1e0b34ed3288576a$export$578c5856bf684e2a);
$parcel$export(module.exports, "FORGE_USER_TYPE", () => $1e0b34ed3288576a$export$38791c0fdd0bcce);
$parcel$export(module.exports, "FORGE_USER_LIST_TYPE", () => $1e0b34ed3288576a$export$5c209e1debd6c274);
$parcel$export(module.exports, "FORGE_GROUP_TYPE", () => $1e0b34ed3288576a$export$8646fecba9a8be61);
$parcel$export(module.exports, "FORGE_GROUP_LIST_TYPE", () => $1e0b34ed3288576a$export$68b91cd2f2e6b810);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $1e0b34ed3288576a$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $1e0b34ed3288576a$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $1e0b34ed3288576a$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $1e0b34ed3288576a$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $1e0b34ed3288576a$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $1e0b34ed3288576a$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $1e0b34ed3288576a$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $1e0b34ed3288576a$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $1e0b34ed3288576a$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $1e0b34ed3288576a$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $1e0b34ed3288576a$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $1e0b34ed3288576a$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $1e0b34ed3288576a$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $1e0b34ed3288576a$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $1e0b34ed3288576a$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $1e0b34ed3288576a$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $1e0b34ed3288576a$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $1e0b34ed3288576a$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $1e0b34ed3288576a$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $1e0b34ed3288576a$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $1e0b34ed3288576a$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $1e0b34ed3288576a$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $1e0b34ed3288576a$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $1e0b34ed3288576a$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $1e0b34ed3288576a$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $1e0b34ed3288576a$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $1e0b34ed3288576a$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $1e0b34ed3288576a$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $1e0b34ed3288576a$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $1e0b34ed3288576a$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $1e0b34ed3288576a$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $1e0b34ed3288576a$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $1e0b34ed3288576a$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $1e0b34ed3288576a$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $1e0b34ed3288576a$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $1e0b34ed3288576a$export$34317c2d84a93553);
$parcel$export(module.exports, "ORGANIZATION_CF_TYPE", () => $1e0b34ed3288576a$export$c1e26582406f77ec);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $1e0b34ed3288576a$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $1e0b34ed3288576a$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $1e0b34ed3288576a$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $1e0b34ed3288576a$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $1e0b34ed3288576a$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $1e0b34ed3288576a$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $1e0b34ed3288576a$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $1e0b34ed3288576a$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $1e0b34ed3288576a$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $1e0b34ed3288576a$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $1e0b34ed3288576a$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $1e0b34ed3288576a$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "JIM_PLUGIN_IMPORT_ID_LINK_CF_TYPE", () => $1e0b34ed3288576a$export$f94696506ee781f9);
$parcel$export(module.exports, "SYSTEM_IMPORT_ID_LINK_CF_TYPE", () => $1e0b34ed3288576a$export$8ba6ed64df1ce64a);
$parcel$export(module.exports, "UUID_CF_TYPE", () => $1e0b34ed3288576a$export$e90ce947f06b085d);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $1e0b34ed3288576a$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $1e0b34ed3288576a$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $1e0b34ed3288576a$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $1e0b34ed3288576a$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $1e0b34ed3288576a$export$2d75b47d12efc812);
$parcel$export(module.exports, "ATTACHMENTS_NUMBER_CF_TYPE", () => $1e0b34ed3288576a$export$36500b2821f7114f);
$parcel$export(module.exports, "LAST_COMMENT_DATE_CF_TYPE", () => $1e0b34ed3288576a$export$37dc91333ba7a96);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $1e0b34ed3288576a$export$7b79405842547ccb);
$parcel$export(module.exports, "ASSIGNEE_DOMAIN_CF_TYPE", () => $1e0b34ed3288576a$export$ac9f7d2dfc7c6826);
$parcel$export(module.exports, "REPORTER_DOMAIN_CF_TYPE", () => $1e0b34ed3288576a$export$a3d9c149d737aa78);
$parcel$export(module.exports, "COMMENTS_NUMBER_CF_TYPE", () => $1e0b34ed3288576a$export$4745e551386233a5);
$parcel$export(module.exports, "DAYS_LAST_COMMENTED_CF_TYPE", () => $1e0b34ed3288576a$export$5ee213d6fd4c9b2b);
$parcel$export(module.exports, "LAST_USER_COMMENTED_CF_TYPE", () => $1e0b34ed3288576a$export$fb0b6a2e098e1fe2);
$parcel$export(module.exports, "SLA_CF_TYPE", () => $1e0b34ed3288576a$export$fe1291c40f590f35);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $1e0b34ed3288576a$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $1e0b34ed3288576a$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $1e0b34ed3288576a$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $1e0b34ed3288576a$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $1e0b34ed3288576a$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ANY_CF_TYPE", () => $1e0b34ed3288576a$export$8c0f7dd088e5671d);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $1e0b34ed3288576a$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $1e0b34ed3288576a$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $1e0b34ed3288576a$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $1e0b34ed3288576a$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $1e0b34ed3288576a$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $1e0b34ed3288576a$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $1e0b34ed3288576a$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $1e0b34ed3288576a$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $1e0b34ed3288576a$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $1e0b34ed3288576a$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $1e0b34ed3288576a$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $1e0b34ed3288576a$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $1e0b34ed3288576a$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $1e0b34ed3288576a$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $1e0b34ed3288576a$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $1e0b34ed3288576a$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $1e0b34ed3288576a$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $1e0b34ed3288576a$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $1e0b34ed3288576a$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $1e0b34ed3288576a$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $1e0b34ed3288576a$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $1e0b34ed3288576a$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $1e0b34ed3288576a$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $1e0b34ed3288576a$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $1e0b34ed3288576a$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $1e0b34ed3288576a$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $1e0b34ed3288576a$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $1e0b34ed3288576a$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $1e0b34ed3288576a$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $1e0b34ed3288576a$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $1e0b34ed3288576a$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $1e0b34ed3288576a$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $1e0b34ed3288576a$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $1e0b34ed3288576a$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $1e0b34ed3288576a$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $1e0b34ed3288576a$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $1e0b34ed3288576a$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $1e0b34ed3288576a$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $1e0b34ed3288576a$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $1e0b34ed3288576a$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $1e0b34ed3288576a$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $1e0b34ed3288576a$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $1e0b34ed3288576a$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $1e0b34ed3288576a$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $1e0b34ed3288576a$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $1e0b34ed3288576a$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $1e0b34ed3288576a$export$b5358afda8ff335e);
$parcel$export(module.exports, "JOURNEY_PANEL_TYPE", () => $1e0b34ed3288576a$export$d2a475ff30e5bf97);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $1e0b34ed3288576a$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $1e0b34ed3288576a$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $1e0b34ed3288576a$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $1e0b34ed3288576a$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $1e0b34ed3288576a$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $1e0b34ed3288576a$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "WORKLOG", () => $1e0b34ed3288576a$export$df36fc05622c402);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $1e0b34ed3288576a$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $1e0b34ed3288576a$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $1e0b34ed3288576a$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "ARE_FIELDS_REORDERED", () => $1e0b34ed3288576a$export$6159d4eb69c78696);
$parcel$export(module.exports, "HIDE_EMPTY_FIELDS", () => $1e0b34ed3288576a$export$962c5b8782b7a233);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $1e0b34ed3288576a$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $1e0b34ed3288576a$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $1e0b34ed3288576a$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $1e0b34ed3288576a$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $1e0b34ed3288576a$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $1e0b34ed3288576a$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $1e0b34ed3288576a$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $1e0b34ed3288576a$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $1e0b34ed3288576a$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $1e0b34ed3288576a$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $1e0b34ed3288576a$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $1e0b34ed3288576a$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $1e0b34ed3288576a$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $1e0b34ed3288576a$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $1e0b34ed3288576a$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $1e0b34ed3288576a$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $1e0b34ed3288576a$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $1e0b34ed3288576a$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $1e0b34ed3288576a$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "AGGREGATE_TIME_ORIGINAL_ESTIMATE", () => $1e0b34ed3288576a$export$871661506c0a91ea);
$parcel$export(module.exports, "AGGREGATE_TIME_ESTIMATE", () => $1e0b34ed3288576a$export$4a7ecfe931ab6c07);
$parcel$export(module.exports, "PROGRESS", () => $1e0b34ed3288576a$export$fbc5ebe2e580bf8b);
$parcel$export(module.exports, "AGGREGATE_PROGRESS", () => $1e0b34ed3288576a$export$aa3b37e271efd578);
$parcel$export(module.exports, "WORKRATIO", () => $1e0b34ed3288576a$export$444bffe6526fb5f2);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $1e0b34ed3288576a$export$3c3e26aadbfa2c32);

var $LFmXM = parcelRequire("LFmXM");

var $7jTnu = parcelRequire("7jTnu");
const $1e0b34ed3288576a$export$b144116dae474c88 = 'issue-link-search';
const $1e0b34ed3288576a$export$bc917bc699b25f75 = 'number';
const $1e0b34ed3288576a$export$5f26ca419fdffbe7 = 'string';
const $1e0b34ed3288576a$export$ce9bfd823c7e1a6d = 'datetime';
const $1e0b34ed3288576a$export$346b72b1f7cd6d5a = 'date';
const $1e0b34ed3288576a$export$b20fbcacd7942c2a = 'option2';
const $1e0b34ed3288576a$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $1e0b34ed3288576a$export$a2e8554bffc61ece = 'any';
const $1e0b34ed3288576a$export$f25cd4907cbb25b9 = 'array';
const $1e0b34ed3288576a$export$5600354b43577e17 = 'user';
const $1e0b34ed3288576a$export$5dbc9917f72d0d2a = 'group';
const $1e0b34ed3288576a$export$253649f07fb55948 = 'object';
const $1e0b34ed3288576a$export$eb39592ba5247ee7 = 'group-list';
const $1e0b34ed3288576a$export$f48a9be226105736 = 'array-string';
const $1e0b34ed3288576a$export$42e2e93fc721df5d = 'version';
const $1e0b34ed3288576a$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $1e0b34ed3288576a$export$7773375e72c953ed = 'approval-panel';
const $1e0b34ed3288576a$export$80ad0037098f3919 = 'project';
const $1e0b34ed3288576a$export$82db8a26de491dd2 = 'array';
const $1e0b34ed3288576a$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $1e0b34ed3288576a$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $1e0b34ed3288576a$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $1e0b34ed3288576a$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $1e0b34ed3288576a$export$c979d9c548c05133 = 'JiraBooleanField';
const $1e0b34ed3288576a$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $1e0b34ed3288576a$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $1e0b34ed3288576a$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $1e0b34ed3288576a$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $1e0b34ed3288576a$export$b0deb225eed90fbd = 'JiraCMDBField';
const $1e0b34ed3288576a$export$add3775cfea8fde3 = 'JiraColorField';
const $1e0b34ed3288576a$export$9631d4098abab3eb = 'JiraComponentsField';
const $1e0b34ed3288576a$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $1e0b34ed3288576a$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $1e0b34ed3288576a$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $1e0b34ed3288576a$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $1e0b34ed3288576a$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $1e0b34ed3288576a$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $1e0b34ed3288576a$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $1e0b34ed3288576a$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $1e0b34ed3288576a$export$6d8da4497234455 = 'JiraEpicLinkField';
const $1e0b34ed3288576a$export$9bcfac568e4fa59c = 'JiraFlagField';
const $1e0b34ed3288576a$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $1e0b34ed3288576a$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $1e0b34ed3288576a$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $1e0b34ed3288576a$export$810709f0c5c2e9db = 'JiraLabelsField';
const $1e0b34ed3288576a$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $1e0b34ed3288576a$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $1e0b34ed3288576a$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $1e0b34ed3288576a$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $1e0b34ed3288576a$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $1e0b34ed3288576a$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $1e0b34ed3288576a$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $1e0b34ed3288576a$export$31aea7548807c6b5 = 'JiraPeopleField';
const $1e0b34ed3288576a$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $1e0b34ed3288576a$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $1e0b34ed3288576a$export$12f54499c6252188 = 'JiraProjectField';
const $1e0b34ed3288576a$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $1e0b34ed3288576a$export$c69486dd643dfb69 = 'JiraReporterField';
const $1e0b34ed3288576a$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $1e0b34ed3288576a$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $1e0b34ed3288576a$export$37f4daaa7b409554 = 'JiraRichTextField';
const $1e0b34ed3288576a$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $1e0b34ed3288576a$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $1e0b34ed3288576a$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $1e0b34ed3288576a$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $1e0b34ed3288576a$export$e40f819979b3881d = 'JiraStatusField';
const $1e0b34ed3288576a$export$6c243704a22baffe = 'JiraTeamField';
const $1e0b34ed3288576a$export$6c32429bac235203 = 'JiraTeamViewField';
const $1e0b34ed3288576a$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $1e0b34ed3288576a$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $1e0b34ed3288576a$export$37ccd11f08a93ccb = 'JiraUrlField';
const $1e0b34ed3288576a$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $1e0b34ed3288576a$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $1e0b34ed3288576a$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $1e0b34ed3288576a$export$aa815aaa741ae18 = 'JiraWatchesField';
const $1e0b34ed3288576a$export$e805f89b15d2abf4 = 'JiraAssetField';
const $1e0b34ed3288576a$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $1e0b34ed3288576a$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $1e0b34ed3288576a$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $1e0b34ed3288576a$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $1e0b34ed3288576a$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $1e0b34ed3288576a$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $1e0b34ed3288576a$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $1e0b34ed3288576a$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $1e0b34ed3288576a$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $1e0b34ed3288576a$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $1e0b34ed3288576a$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $1e0b34ed3288576a$export$c48132adab502d6b = 'JiraForgeUsersField';
const $1e0b34ed3288576a$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $1e0b34ed3288576a$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $1e0b34ed3288576a$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $1e0b34ed3288576a$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $1e0b34ed3288576a$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $1e0b34ed3288576a$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $1e0b34ed3288576a$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $1e0b34ed3288576a$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $1e0b34ed3288576a$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $1e0b34ed3288576a$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $1e0b34ed3288576a$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $1e0b34ed3288576a$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $1e0b34ed3288576a$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $1e0b34ed3288576a$export$bfcb1a91094f113a = 'JiraGoalsField';
const $1e0b34ed3288576a$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $1e0b34ed3288576a$export$7fe9e7bac5a59952 = 'JiraCustomerServiceOrganizationField';
const $1e0b34ed3288576a$export$798d2f5814884447 = 'forgeCustomField';
const $1e0b34ed3288576a$export$1e188101081be3f8 = 'forge/string';
const $1e0b34ed3288576a$export$caf3b3f20c0589b9 = 'forge/string-list';
const $1e0b34ed3288576a$export$9bdf08a1276e866c = 'forge/number';
const $1e0b34ed3288576a$export$996c3d3eb2880229 = 'forge/date';
const $1e0b34ed3288576a$export$578c5856bf684e2a = 'forge/datetime';
const $1e0b34ed3288576a$export$38791c0fdd0bcce = 'forge/user';
const $1e0b34ed3288576a$export$5c209e1debd6c274 = 'forge/user-list';
const $1e0b34ed3288576a$export$8646fecba9a8be61 = 'forge/group';
const $1e0b34ed3288576a$export$68b91cd2f2e6b810 = 'forge/group-list';
const $1e0b34ed3288576a$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $1e0b34ed3288576a$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $1e0b34ed3288576a$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $1e0b34ed3288576a$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $1e0b34ed3288576a$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $1e0b34ed3288576a$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $1e0b34ed3288576a$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $1e0b34ed3288576a$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $1e0b34ed3288576a$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $1e0b34ed3288576a$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $1e0b34ed3288576a$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $1e0b34ed3288576a$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $1e0b34ed3288576a$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $1e0b34ed3288576a$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $1e0b34ed3288576a$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $1e0b34ed3288576a$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $1e0b34ed3288576a$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $1e0b34ed3288576a$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $1e0b34ed3288576a$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $1e0b34ed3288576a$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $1e0b34ed3288576a$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $1e0b34ed3288576a$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $1e0b34ed3288576a$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $1e0b34ed3288576a$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $1e0b34ed3288576a$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $1e0b34ed3288576a$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $1e0b34ed3288576a$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $1e0b34ed3288576a$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $1e0b34ed3288576a$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $1e0b34ed3288576a$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $1e0b34ed3288576a$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $1e0b34ed3288576a$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $1e0b34ed3288576a$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $1e0b34ed3288576a$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $1e0b34ed3288576a$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $1e0b34ed3288576a$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $1e0b34ed3288576a$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $1e0b34ed3288576a$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
const $1e0b34ed3288576a$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $1e0b34ed3288576a$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $1e0b34ed3288576a$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $1e0b34ed3288576a$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $1e0b34ed3288576a$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $1e0b34ed3288576a$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $1e0b34ed3288576a$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $1e0b34ed3288576a$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $1e0b34ed3288576a$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $1e0b34ed3288576a$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $1e0b34ed3288576a$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $1e0b34ed3288576a$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $1e0b34ed3288576a$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $1e0b34ed3288576a$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $1e0b34ed3288576a$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $1e0b34ed3288576a$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $1e0b34ed3288576a$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $1e0b34ed3288576a$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $1e0b34ed3288576a$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $1e0b34ed3288576a$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $1e0b34ed3288576a$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $1e0b34ed3288576a$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $1e0b34ed3288576a$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $1e0b34ed3288576a$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $1e0b34ed3288576a$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $1e0b34ed3288576a$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $1e0b34ed3288576a$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $1e0b34ed3288576a$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $1e0b34ed3288576a$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $1e0b34ed3288576a$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $1e0b34ed3288576a$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $1e0b34ed3288576a$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $1e0b34ed3288576a$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $1e0b34ed3288576a$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $1e0b34ed3288576a$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $1e0b34ed3288576a$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $1e0b34ed3288576a$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $1e0b34ed3288576a$export$8c0f7dd088e5671d = 'any.custom.field.type';
const $1e0b34ed3288576a$export$fba8634fd401ba8b = 'assignee';
const $1e0b34ed3288576a$export$a91aea2438afcce8 = 'reporter';
const $1e0b34ed3288576a$export$b159f8b8f27aae4c = 'duedate';
const $1e0b34ed3288576a$export$34740f8d07d23ac0 = 'priority';
const $1e0b34ed3288576a$export$43b6e33ec70f2272 = 'labels';
const $1e0b34ed3288576a$export$ff39ebd4bb12b718 = 'created';
const $1e0b34ed3288576a$export$cd8e68094cb5c3cb = 'updated';
const $1e0b34ed3288576a$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $1e0b34ed3288576a$export$37abf56f13f61ec5 = 'components';
const $1e0b34ed3288576a$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $1e0b34ed3288576a$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $1e0b34ed3288576a$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $1e0b34ed3288576a$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $1e0b34ed3288576a$export$791007408faf42f4 = 'servicedesk-incident-management';
const $1e0b34ed3288576a$export$827a1c600bac12a3 = 'devSummary';
const $1e0b34ed3288576a$export$e9ba671d077969f8 = 'releases';
const $1e0b34ed3288576a$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $1e0b34ed3288576a$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $1e0b34ed3288576a$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $1e0b34ed3288576a$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $1e0b34ed3288576a$export$a5c9f63aadcb220 = 'fixVersions';
const $1e0b34ed3288576a$export$94009605902e4fe5 = 'versions';
const $1e0b34ed3288576a$export$5e7324042f1d6b31 = 'description';
const $1e0b34ed3288576a$export$113281d03e6830ef = 'environment';
const $1e0b34ed3288576a$export$5ff798870a3dffbf = 'watches';
const $1e0b34ed3288576a$export$907219511d14ba3d = 'summary';
const $1e0b34ed3288576a$export$d09aa6a4f3538063 = 'proforma-forms';
const $1e0b34ed3288576a$export$3aca8c91b58a42e2 = 'resolution';
const $1e0b34ed3288576a$export$ccb5ffefbf8b987c = 'timetracking';
const $1e0b34ed3288576a$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $1e0b34ed3288576a$export$358267065be1e = 'status';
const $1e0b34ed3288576a$export$dcaa788c7ada56de = 'statusCategory';
const $1e0b34ed3288576a$export$ebb48b08205007c5 = 'issuetype';
const $1e0b34ed3288576a$export$5e91047fe9955d0e = 'issuekey';
const $1e0b34ed3288576a$export$3b3d0889022c85b3 = 'children-issues';
const $1e0b34ed3288576a$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $1e0b34ed3288576a$export$8fe3d5be8cb17459 = 'epic-issues';
const $1e0b34ed3288576a$export$335851d83a79891 = 'hierarchy-level-below';
const $1e0b34ed3288576a$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $1e0b34ed3288576a$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $1e0b34ed3288576a$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $1e0b34ed3288576a$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $1e0b34ed3288576a$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $1e0b34ed3288576a$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $1e0b34ed3288576a$export$7b3d247435a784fa = 'SLA_PANEL';
const $1e0b34ed3288576a$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $1e0b34ed3288576a$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $1e0b34ed3288576a$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $1e0b34ed3288576a$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $1e0b34ed3288576a$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $1e0b34ed3288576a$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $1e0b34ed3288576a$export$d2a475ff30e5bf97 = 'JOURNEY_PANEL';
const $1e0b34ed3288576a$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $1e0b34ed3288576a$export$22f61ccc2730431f = 'similar-issues';
const $1e0b34ed3288576a$export$8bbb446f57294715 = 'subtasks';
const $1e0b34ed3288576a$export$34fcd7cb291a1e4d = 'votes';
const $1e0b34ed3288576a$export$5e93f2a57cc4ca3a = 'parent';
const $1e0b34ed3288576a$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $1e0b34ed3288576a$export$91a9dba2d38d9a6f = 'project';
const $1e0b34ed3288576a$export$df36fc05622c402 = 'worklog';
const $1e0b34ed3288576a$export$ede0a4c20124ec85 = 'timespent';
const $1e0b34ed3288576a$export$3eeb79d48fb5f667 = 'dataclassification';
const $1e0b34ed3288576a$export$45e72c9a63ab61ab = 'SENTIMENT';
const $1e0b34ed3288576a$export$6159d4eb69c78696 = 'ARE_FIELDS_REORDERED';
const $1e0b34ed3288576a$export$962c5b8782b7a233 = 'HIDE_EMPTY_FIELDS';
const $1e0b34ed3288576a$export$99ad62164189f781 = 'ecosystemGlance';
const $1e0b34ed3288576a$export$7719ef6e9283671 = 'forgeGlance';
const $1e0b34ed3288576a$export$bfebea5ce2e1887a = 'ecosystemContext';
const $1e0b34ed3288576a$export$be8e68fb1aed253e = 'forgeContext';
const $1e0b34ed3288576a$export$84e5674890d55030 = 'issuerestriction';
const $1e0b34ed3288576a$export$326a5522a485e43d = 'security';
const $1e0b34ed3288576a$export$c9f3f01e2c535302 = 'securitylevel';
const $1e0b34ed3288576a$export$35e5652f764785bd = 'creator';
const $1e0b34ed3288576a$export$66519f3bbff1796a = 'team';
const $1e0b34ed3288576a$export$a4ee0bca77cc8463 = 'estimate';
const $1e0b34ed3288576a$export$fed53408e89e0497 = 'dueDate';
const $1e0b34ed3288576a$export$d53c26f9ce31f56b = 'targetStart';
const $1e0b34ed3288576a$export$48f82d653f85e459 = 'targetEnd';
const $1e0b34ed3288576a$export$ea5a888f39f722c7 = 'startDate';
const $1e0b34ed3288576a$export$f245bbec12cc0e40 = 'color';
const $1e0b34ed3288576a$export$aed630b4b7114a59 = 'attachment';
const $1e0b34ed3288576a$export$b50c1a8fef07104 = 'issuelinks';
const $1e0b34ed3288576a$export$ea3d72f4bb7738ba = 'timeestimate';
const $1e0b34ed3288576a$export$a4cab0124760d860 = 'comment';
const $1e0b34ed3288576a$export$734929aef118d7e2 = 'worklog';
const $1e0b34ed3288576a$export$ffbacacb07c1d46d = 'parent';
const $1e0b34ed3288576a$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $1e0b34ed3288576a$export$278c072e2f9176ab = 'aggregatetimespent';
const $1e0b34ed3288576a$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $1e0b34ed3288576a$export$fbc5ebe2e580bf8b = 'progress';
const $1e0b34ed3288576a$export$aa3b37e271efd578 = 'aggregateprogress';
const $1e0b34ed3288576a$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $1e0b34ed3288576a$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $1e0b34ed3288576a$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $1e0b34ed3288576a$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $1e0b34ed3288576a$export$34740f8d07d23ac0,
        REPORTER_TYPE: $1e0b34ed3288576a$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $1e0b34ed3288576a$export$5e7324042f1d6b31,
        LABELS_TYPE: $1e0b34ed3288576a$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $1e0b34ed3288576a$export$37abf56f13f61ec5,
        SPRINT_TYPE: $1e0b34ed3288576a$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $1e0b34ed3288576a$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $1e0b34ed3288576a$export$269d70c1b1c9fb80,
        FIX_VERSIONS_TYPE: $1e0b34ed3288576a$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $1e0b34ed3288576a$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $1e0b34ed3288576a$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $1e0b34ed3288576a$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $1e0b34ed3288576a$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $1e0b34ed3288576a$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $1e0b34ed3288576a$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $1e0b34ed3288576a$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $1e0b34ed3288576a$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $1e0b34ed3288576a$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $1e0b34ed3288576a$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $1e0b34ed3288576a$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $1e0b34ed3288576a$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $1e0b34ed3288576a$export$c7ae0622b0bd5d56,
        ASSETS_CF_TYPE: $1e0b34ed3288576a$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $1e0b34ed3288576a$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $1e0b34ed3288576a$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $1e0b34ed3288576a$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $1e0b34ed3288576a$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $1e0b34ed3288576a$export$e9ba671d077969f8,
        BASELINE_START_CF_TYPE: $1e0b34ed3288576a$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $1e0b34ed3288576a$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $1e0b34ed3288576a$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $1e0b34ed3288576a$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $1e0b34ed3288576a$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $1e0b34ed3288576a$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $1e0b34ed3288576a$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $1e0b34ed3288576a$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $1e0b34ed3288576a$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $1e0b34ed3288576a$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $1e0b34ed3288576a$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $1e0b34ed3288576a$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $1e0b34ed3288576a$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $1e0b34ed3288576a$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $1e0b34ed3288576a$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $1e0b34ed3288576a$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $1e0b34ed3288576a$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $1e0b34ed3288576a$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $1e0b34ed3288576a$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $1e0b34ed3288576a$export$39866626496bbfc8,
        VERSION_CF_TYPE: $1e0b34ed3288576a$export$24382b4e8c58336b,
        DATE_CF_TYPE: $1e0b34ed3288576a$export$ff745f432984005d,
        GROUP_CF_TYPE: $1e0b34ed3288576a$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $1e0b34ed3288576a$export$b600addfa3355c57,
        USER_CF_TYPE: $1e0b34ed3288576a$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $1e0b34ed3288576a$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $1e0b34ed3288576a$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $1e0b34ed3288576a$export$65524be5675e57e6,
        TEAM_CF_TYPE: $1e0b34ed3288576a$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $1e0b34ed3288576a$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $1e0b34ed3288576a$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $1e0b34ed3288576a$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $1e0b34ed3288576a$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $1e0b34ed3288576a$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $1e0b34ed3288576a$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $1e0b34ed3288576a$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $1e0b34ed3288576a$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $1e0b34ed3288576a$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $1e0b34ed3288576a$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $1e0b34ed3288576a$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $1e0b34ed3288576a$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $1e0b34ed3288576a$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $1e0b34ed3288576a$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $1e0b34ed3288576a$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $1e0b34ed3288576a$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $1e0b34ed3288576a$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $1e0b34ed3288576a$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $1e0b34ed3288576a$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $1e0b34ed3288576a$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $1e0b34ed3288576a$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $1e0b34ed3288576a$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $1e0b34ed3288576a$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $1e0b34ed3288576a$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $1e0b34ed3288576a$export$2bbb7f69c97ea279,
        PARENT_TYPE: $1e0b34ed3288576a$export$5e93f2a57cc4ca3a,
        FORGE_CONTEXT_TYPE: $1e0b34ed3288576a$export$be8e68fb1aed253e,
        SENTIMENT_CF_TYPE: $1e0b34ed3288576a$export$c23cfbdf83daa90d
    };
    Object.assign(types, {
        SENTIMENT_TYPE: $1e0b34ed3288576a$export$45e72c9a63ab61ab
    });
    if ((0, $7jTnu.fg)('jsm-journey-builder-in-issue-view')) Object.assign(types, {
        JOURNEY_PANEL_TYPE: $1e0b34ed3288576a$export$d2a475ff30e5bf97
    });
    return types;
};
const $1e0b34ed3288576a$export$3c3e26aadbfa2c32 = (0, $LFmXM.default)($1e0b34ed3288576a$var$getLayoutFieldTypesNonMemoized);

});


parcelRegister("fYGRD", function(module, exports) {

$parcel$export(module.exports, "toErrorId", () => $79b7280a6d9df340$export$706bbe4209d93dfe);
$parcel$export(module.exports, "toErrorMessage", () => $79b7280a6d9df340$export$95506c204c060a3);
// Package name to be used in famaCatchAndLogFetchError and logError utils
const $79b7280a6d9df340$export$706bbe4209d93dfe = (id)=>id;
const $79b7280a6d9df340$export$95506c204c060a3 = (message)=>message;

});

parcelRegister("5CoMi", function(module, exports) {

$parcel$export(module.exports, "logError", () => $3cd7816bdb83a33f$export$58da9968c3170cb1);

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");
const $3cd7816bdb83a33f$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
    // Send error log to analytics pipeline (i.e. SFX) and Sentry
    (0, $gYnSx.default)({
        meta: {
            packageName: packageName,
            id: errorId,
            teamName: 'morphinecake'
        },
        attributes: {
            ...attributes,
            message: message
        },
        error: error
    });
    // Send error log to Splunk
    // We use this instead of `sendToPrivacyUnsafeSplunk` to preserve error message and custom properties
    const location = `${packageName}.${errorId}`;
    (0, $eSnSE.default).unsafeErrorWithCustomerData(location, message, error);
};

});




parcelRegister("bBqyO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsWidgetRouteEntry", () => $3eace7fe0145db1f$export$dcfc82c90a86b038);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $cX4Fw = parcelRequire("cX4Fw");

var $aQoXd = parcelRequire("aQoXd");

var $ezDsV = parcelRequire("ezDsV");

var $9btIX = parcelRequire("9btIX");
const $3eace7fe0145db1f$export$dcfc82c90a86b038 = (0, $6xToB.createEntry)((0, $cX4Fw.projectSettingsServicedeskChannelsWidgetRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $ezDsV.widgetsNextGenRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9btIX.LazyProjectSettingsServiceDeskWidgetSettings)
        ]
    }));

});
parcelRegister("ezDsV", function(module, exports) {

$parcel$export(module.exports, "widgetsNextGenRedirect", () => $9c8e55a52c3fbbf2$export$8ba256148f9b998f);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $9c8e55a52c3fbbf2$export$8ba256148f9b998f = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/widget`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: url
    });
};

});

parcelRegister("9btIX", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskWidgetSettings", () => $7c30dfa00c9a467f$export$216a049c4d917b0);
$parcel$export(module.exports, "default", () => $7c30dfa00c9a467f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $7c30dfa00c9a467f$export$216a049c4d917b0 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("eNGzt")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-widget-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7c30dfa00c9a467f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $7c30dfa00c9a467f$export$216a049c4d917b0,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("eNGzt", function(module, exports) {

let $ac66aa0f4073c3be$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ac66aa0f4073c3be$var$load("jgkn3").then(()=>parcelRequire('lqPYT'));

});



parcelRegister("cM5pJ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChatRouteEntry", () => $6bebb81557578ed6$export$f030ac1baa84c682);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $eaMHj = parcelRequire("eaMHj");

var $aQoXd = parcelRequire("aQoXd");

var $4kspE = parcelRequire("4kspE");
const $6bebb81557578ed6$export$f030ac1baa84c682 = (0, $6xToB.createEntry)((0, $eaMHj.projectSettingsServicedeskChatRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4kspE.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4kspE.LazyProjectSettingsServiceDeskChatSettings)
        ]
    }));

});

parcelRegister("95uMc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskClassicAppsRouteEntry", () => $9cd2edfb3fb74d72$export$aba71c4218b643ad);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $huYm9 = parcelRequire("huYm9");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $02Yn6 = parcelRequire("02Yn6");

var $bfOBR = parcelRequire("bfOBR");

var $gwoLH = parcelRequire("gwoLH");
const $9cd2edfb3fb74d72$export$aba71c4218b643ad = (0, $6xToB.createEntry)((0, $huYm9.projectSettingsServicedeskClassicAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.app-discovery',
        component: (0, $bfOBR.ConnectAppsRedirect)(`/jira/${(0, $gwoLH.SERVICE_DESK_PRODUCT)}`),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        isRedirect: true,
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $02Yn6.LazyAppDiscoverySettings)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).APP_DISCOVERY,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).APP_DISCOVERY),
                teamName: 'it-solutions-hermes'
            }
        }
    }));

});

parcelRegister("61kne", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerNotificationsRouteEntry", () => $d686ea5611775b5b$export$5a4abc64d2a82698);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $cdHCV = parcelRequire("cdHCV");

var $aQoXd = parcelRequire("aQoXd");

var $1VT2J = parcelRequire("1VT2J");
const $d686ea5611775b5b$export$5a4abc64d2a82698 = (0, $6xToB.createEntry)((0, $cdHCV.projectSettingsServicedeskCustomerNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $1VT2J.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1VT2J.LazyProjectSettingsServiceDeskCustomerNotifications)
        ]
    }));

});
parcelRegister("1VT2J", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskCustomerNotifications", () => $9a41abf4bbe3c762$export$c763ea321ade5f68);
$parcel$export(module.exports, "default", () => $9a41abf4bbe3c762$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4APnu = parcelRequire("4APnu");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $9a41abf4bbe3c762$export$c763ea321ade5f68 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("iVYUO")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9a41abf4bbe3c762$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4APnu.HelpCenterSettingsRedirect), {
        page: "customer-notifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $9a41abf4bbe3c762$export$c763ea321ade5f68,
        pageId: "project-settings-customer-notifications",
        shouldShowSpinner: true
    }));

});
parcelRegister("iVYUO", function(module, exports) {

let $dc8ccd62d129c41e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dc8ccd62d129c41e$var$load("3Ee1f").then(()=>parcelRequire('icLxk'));

});



parcelRegister("85bCZ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerPermissionsRouteEntry", () => $9a78ac60977c017a$export$ed034e5245184767);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $393uA = parcelRequire("393uA");

var $kDkUg = parcelRequire("kDkUg");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $lHKQ7 = parcelRequire("lHKQ7");
const $9a78ac60977c017a$export$ed034e5245184767 = (0, $6xToB.createEntry)((0, $kDkUg.projectSettingsServicedeskCustomerPermissionsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $lHKQ7.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $393uA.customerPermissionsPageDataResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $lHKQ7.LazyProjectSettingsServiceDeskCustomerPermissions)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions'
    }));

});

parcelRegister("ihexr", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDataClassificationsRouteEntry", () => $48e299761b3b2824$export$5cea2172fd288382);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $759RV = parcelRequire("759RV");

var $aQoXd = parcelRequire("aQoXd");

var $bmwpE = parcelRequire("bmwpE");

var $aGIH8 = parcelRequire("aGIH8");
const $48e299761b3b2824$export$5cea2172fd288382 = (0, $6xToB.createEntry)((0, $759RV.projectSettingsServicedeskDataClassificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $aGIH8.default),
        skeleton: (0, $bmwpE.ProjectSettingsDetailsSkeleton),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $aGIH8.LazyDataClassificationsSettings)
        ]
    }));

});
parcelRegister("759RV", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDataClassificationsRoute", () => $ca3a953b1f6e506d$export$ec4d4f6583272cd);
const $ca3a953b1f6e506d$export$ec4d4f6583272cd = {
    name: 'project-settings-servicedesk-data-classifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/data-classifications',
    exact: true
};

});

parcelRegister("aGIH8", function(module, exports) {

$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $1cda1e259567f6de$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $1cda1e259567f6de$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $1cda1e259567f6de$export$b8abcf8aa8f4df56 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bzxaI"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1cda1e259567f6de$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1cda1e259567f6de$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });

});


parcelRegister("3jDGC", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDetailsRouteEntry", () => $b4cda2e55e868793$export$6b37ff6fd616f383);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $95JeU = parcelRequire("95JeU");

var $aQoXd = parcelRequire("aQoXd");

var $bmwpE = parcelRequire("bmwpE");

var $8YBTO = parcelRequire("8YBTO");
const $b4cda2e55e868793$export$6b37ff6fd616f383 = (0, $6xToB.createEntry)((0, $95JeU.projectSettingsServicedeskDetailsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $8YBTO.default),
        skeleton: (0, $bmwpE.ProjectSettingsDetailsSkeleton),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8YBTO.LazyDetailsSettings)
        ]
    }));

});
parcelRegister("95JeU", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDetailsRoute", () => $db1040706d45857c$export$23583c23687c31c7);
const $db1040706d45857c$export$23583c23687c31c7 = {
    name: 'project-settings-servicedesk-details',
    // /settings/details
    path: '/jira/servicedesk/projects/:projectKey/settings/details',
    exact: true
};

});

parcelRegister("8YBTO", function(module, exports) {

$parcel$export(module.exports, "LazyDetailsSettings", () => $51dbb5946e9cd5f0$export$6f16b5efddd5c646);
$parcel$export(module.exports, "default", () => $51dbb5946e9cd5f0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $51dbb5946e9cd5f0$export$6f16b5efddd5c646 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("9Vy7l"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$51dbb5946e9cd5f0$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $51dbb5946e9cd5f0$export$6f16b5efddd5c646,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });

});


parcelRegister("kmfhe", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskEmailRouteEntry", () => $c9d53c7c163b6e62$export$676e8af036d3e9c1);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9Box0 = parcelRequire("9Box0");

var $aQoXd = parcelRequire("aQoXd");

var $itJJd = parcelRequire("itJJd");
const $c9d53c7c163b6e62$export$676e8af036d3e9c1 = (0, $6xToB.createEntry)((0, $9Box0.projectSettingsServicedeskEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.settings.email-channels',
        component: (0, $itJJd.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $itJJd.LazyProjectSettingsServiceDeskEmail)
        ]
    }));

});

parcelRegister("3VkWO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskExternalLinksRouteEntry", () => $1025c39b61c7e9a8$export$ca80e1d474f774d4);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $g9kBK = parcelRequire("g9kBK");

var $306id = parcelRequire("306id");

var $aQoXd = parcelRequire("aQoXd");

var $jjsMG = parcelRequire("jjsMG");
const $1025c39b61c7e9a8$export$ca80e1d474f774d4 = (0, $6xToB.createEntry)((0, $306id.projectSettingsServicedeskExternalLinksRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $jjsMG.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $g9kBK.featuresResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jjsMG.LazyProjectSettingsServiceDeskExternalLinks)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskExternalLinksRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskExternalLinksRouteEntry'
            },
            enabled: true
        },
        perfMetricKey: 'jsm-external-resources'
    }));

});
parcelRegister("jjsMG", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskExternalLinks", () => $6b6994fd623f14b2$export$28482a53859ec466);
$parcel$export(module.exports, "default", () => $6b6994fd623f14b2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $6b6994fd623f14b2$export$28482a53859ec466 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("cHCpq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-external-links/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6b6994fd623f14b2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6b6994fd623f14b2$export$28482a53859ec466,
        pageId: "project-settings-external-links",
        shouldShowSpinner: true
    });

});
parcelRegister("cHCpq", function(module, exports) {

let $93f74b6fcb2bfa69$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $93f74b6fcb2bfa69$var$load("4c1yj").then(()=>parcelRequire('4HuAu'));

});



parcelRegister("grzdo", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFeedbackRouteEntry", () => $6ddff2e6e1266340$export$5c0731470c0dc065);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $2TwJc = parcelRequire("2TwJc");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $78HKm = parcelRequire("78HKm");

var $eqrGz = parcelRequire("eqrGz");
const $6ddff2e6e1266340$export$5c0731470c0dc065 = (0, $6xToB.createEntry)((0, $2TwJc.projectSettingsServicedeskFeedbackRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $eqrGz.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $eqrGz.LazyProjectSettingsServiceDeskFeedbackSettings),
            (0, $78HKm.LazyCsatSettingsPage)
        ],
        perfMetricKey: 'jsm-feedback-settings',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).CSAT_CONFIG,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CSAT_CONFIG),
                teamName: 'jsm-request-intake'
            }
        }
    }));

});
parcelRegister("78HKm", function(module, exports) {

$parcel$export(module.exports, "LoadingComponent", () => $d408c10ee369f732$export$7db30d367db7d20a);
$parcel$export(module.exports, "LazyCsatSettingsPage", () => $d408c10ee369f732$export$32eb62914bae0e84);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dPlS8 = parcelRequire("dPlS8");

var $gzcjr = parcelRequire("gzcjr");
const $d408c10ee369f732$export$7db30d367db7d20a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d408c10ee369f732$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPlS8.default), {
        size: "large"
    }));

const $d408c10ee369f732$export$32eb62914bae0e84 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("bhvcN")), {
    moduleId: "./src/packages/servicedesk/csat/src/index.tsx"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $d408c10ee369f732$var$SpinnerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i68cl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bhvcN", function(module, exports) {

let $83697cfc5042bb95$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $83697cfc5042bb95$var$load("bySj4").then(()=>parcelRequire('2Zp7K'));

});


parcelRegister("eqrGz", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskFeedbackSettings", () => $5ff09dae1d5965ed$export$ff54bec6c7cb7d47);
$parcel$export(module.exports, "default", () => $5ff09dae1d5965ed$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");
const $5ff09dae1d5965ed$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $5ff09dae1d5965ed$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $5ff09dae1d5965ed$export$ff54bec6c7cb7d47 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("dqv61")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-feedback-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5ff09dae1d5965ed$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $5ff09dae1d5965ed$export$ff54bec6c7cb7d47,
        pageId: "project-settings-feedback-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("dqv61", function(module, exports) {

let $9c65d31baea39010$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9c65d31baea39010$var$load("cp1kB").then(()=>parcelRequire('ikxk8'));

});



parcelRegister("b29TL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFieldsRouteEntry", () => $9d8b23ec9e2dc585$export$8a5eabbb292c5b39);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $uKS5x = parcelRequire("uKS5x");

var $1PvPk = parcelRequire("1PvPk");

var $84Gb2 = parcelRequire("84Gb2");

var $aQoXd = parcelRequire("aQoXd");

var $961JK = parcelRequire("961JK");
const $9d8b23ec9e2dc585$export$8a5eabbb292c5b39 = (0, $6xToB.createEntry)((0, $84Gb2.projectSettingsServicedeskFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'project-settings.fields.jsm-tmp',
        component: (0, $961JK.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $uKS5x.fieldSettingsRelayResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $961JK.LazyFieldsSettings)
        ]
    }));

});
parcelRegister("961JK", function(module, exports) {

$parcel$export(module.exports, "LazyFieldsSettings", () => $29ec6aca051a27f4$export$e309780f520d125a);
$parcel$export(module.exports, "default", () => $29ec6aca051a27f4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $29ec6aca051a27f4$export$e309780f520d125a = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5j1d4"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$29ec6aca051a27f4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $29ec6aca051a27f4$export$e309780f520d125a,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });

});


parcelRegister("csLF9", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRouteEntry", () => $ad7c13eb7d123bba$export$58e3b68d22b7a42b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $iJSzu = parcelRequire("iJSzu");

var $aQoXd = parcelRequire("aQoXd");

var $hHbzj = parcelRequire("hHbzj");

var $dZRaT = parcelRequire("dZRaT");

var $7j7sP = parcelRequire("7j7sP");
const $ad7c13eb7d123bba$export$58e3b68d22b7a42b = (0, $6xToB.createEntry)((0, $iJSzu.projectSettingsServicedeskForgeAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $7j7sP.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResourceWithCache),
            (0, $hHbzj.forgeProjectSettingsModuleResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7j7sP.LazyForgeProjectSettingsPage)
        ]
    }));

});
parcelRegister("iJSzu", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRoute", () => $3c10eacac47d1aff$export$10bafd1256118bb8);
const $3c10eacac47d1aff$export$10bafd1256118bb8 = {
    name: 'project-settings-servicedesk-forge-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("7j7sP", function(module, exports) {

$parcel$export(module.exports, "LazyForgeProjectSettingsPage", () => $63360e0ca663daa2$export$ef66d3f49a9953d8);
$parcel$export(module.exports, "default", () => $63360e0ca663daa2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $63360e0ca663daa2$export$ef66d3f49a9953d8 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("c8agu")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $63360e0ca663daa2$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $63360e0ca663daa2$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
var $63360e0ca663daa2$export$2e2bcd8739ae039 = $63360e0ca663daa2$export$b943f48844c671a5;

});


parcelRegister("dTlAf", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIncidentManagementRouteEntry", () => $a960f273ccd8312c$export$95a73b5db67dd70a);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $kgDPH = parcelRequire("kgDPH");

var $499r8 = parcelRequire("499r8");

var $aQoXd = parcelRequire("aQoXd");

var $c8VU3 = parcelRequire("c8VU3");
const $a960f273ccd8312c$export$95a73b5db67dd70a = (0, $6xToB.createEntry)((0, $499r8.projectSettingsServicedeskIncidentManagementRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $c8VU3.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $kgDPH.serviceDeskContextResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c8VU3.LazyProjectSettingsServiceDeskIncidentManagement)
        ]
    }));

});
parcelRegister("c8VU3", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskIncidentManagement", () => $7113731f71e939b5$export$7796b6d080b8c187);
$parcel$export(module.exports, "default", () => $7113731f71e939b5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $7113731f71e939b5$export$7796b6d080b8c187 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("wNt9w"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-incident-management-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7113731f71e939b5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $7113731f71e939b5$export$7796b6d080b8c187,
        pageId: "project-settings-incident-management",
        shouldShowSpinner: true
    });

});
parcelRegister("wNt9w", function(module, exports) {

let $06295cd3a818e14a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $06295cd3a818e14a$var$load("1VRB2"),
    $06295cd3a818e14a$var$load("bABhq"),
    $06295cd3a818e14a$var$load("eDzss"),
    $06295cd3a818e14a$var$load("lVDo8")
]).then(()=>parcelRequire('aVMo3'));

});



parcelRegister("dKx89", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskInternalNotificationsNextGenRouteEntry", () => $a193934e2ac58a22$export$dfcd097af0ecd961);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $ie5KY = parcelRequire("ie5KY");

var $aQoXd = parcelRequire("aQoXd");

var $ejTKN = parcelRequire("ejTKN");

var $21Rpn = parcelRequire("21Rpn");
const $a193934e2ac58a22$export$dfcd097af0ecd961 = (0, $6xToB.createEntry)((0, $ie5KY.projectSettingsServicedeskInternalNotificationsNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.internal-notifications',
        component: (0, $21Rpn.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $21Rpn.LazyProjectSettingsServiceDeskInternalNotifications),
            (0, $ejTKN.LazyInternalNotificationSettingsPage)
        ]
    }));

});
parcelRegister("ejTKN", function(module, exports) {

$parcel$export(module.exports, "LazyInternalNotificationSettingsPage", () => $c9e05b3be0968278$export$501979bd6d492c43);

var $gzcjr = parcelRequire("gzcjr");

const $c9e05b3be0968278$export$501979bd6d492c43 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("f0k41")), {
    moduleId: "./src/packages/servicedesk/notification-internal/src/ui/index.tsx"
});

});
parcelRegister("f0k41", function(module, exports) {

let $aec66b62638810e9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $aec66b62638810e9$var$load("fjung").then(()=>parcelRequire('1ElO6'));

});


parcelRegister("21Rpn", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskInternalNotifications", () => $3ec1e94b1d511880$export$9c9d293dc6de29d0);
$parcel$export(module.exports, "default", () => $3ec1e94b1d511880$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $3ec1e94b1d511880$export$9c9d293dc6de29d0 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("hIhRB"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-internal-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3ec1e94b1d511880$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3ec1e94b1d511880$export$9c9d293dc6de29d0,
        pageId: "project-settings-internal-notifications",
        shouldShowSpinner: true
    });

});
parcelRegister("hIhRB", function(module, exports) {

let $ce546714120075c8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ce546714120075c8$var$load("haBNG").then(()=>parcelRequire('8XEjR'));

});



parcelRegister("bWmUQ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesRouteEntry", () => $3982899b389cbd5e$export$cf4a5eaa3cb7522f);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $jUN5r = parcelRequire("jUN5r");

var $aQoXd = parcelRequire("aQoXd");

var $jiE34 = parcelRequire("jiE34");

var $cJ4L7 = parcelRequire("cJ4L7");
const $3982899b389cbd5e$export$cf4a5eaa3cb7522f = (0, $6xToB.createEntry)((0, $jUN5r.projectSettingsServicedeskIssuetypesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: (0, $cJ4L7.getUFOName)('project-settings-servicedesk-issuetypes'),
        component: (0, $jiE34.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jiE34.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("jiE34", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSettings", () => $a09543c4156b447e$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $a09543c4156b447e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $a09543c4156b447e$export$36dcfb52d47cb93a = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2Qznj"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a09543c4156b447e$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a09543c4156b447e$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

});

parcelRegister("cJ4L7", function(module, exports) {

$parcel$export(module.exports, "getUFOName", () => $08fa2836826db87f$export$759ec9adbd19c936);
const $08fa2836826db87f$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $08fa2836826db87f$export$759ec9adbd19c936 = (name)=>$08fa2836826db87f$var$ufoNamesMap[name] || name;

});


parcelRegister("hT9aM", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesWorkflowRouteEntry", () => $f13b731f46475de6$export$a6c573e3904e9dbd);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $4YHpZ = parcelRequire("4YHpZ");

var $aQoXd = parcelRequire("aQoXd");

var $7K5Ea = parcelRequire("7K5Ea");

var $epTsa = parcelRequire("epTsa");

var $jiE34 = parcelRequire("jiE34");

var $i2X0L = parcelRequire("i2X0L");
const $f13b731f46475de6$export$a6c573e3904e9dbd = (0, $6xToB.createEntry)((0, $4YHpZ.projectSettingsServicedeskIssuetypesWorkflowRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $i2X0L.default),
        layout: (0, $epTsa.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_service', 'isEnabled', true, false) ? (0, $7K5Ea.chromelessLayout) : (0, $aQoXd.serviceProjectLayout),
        navigation: (0, $epTsa.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_service', 'isEnabled', true, false) ? undefined : {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: (0, $epTsa.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_service', 'isEnabled', true, false) ? undefined : [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: (0, $epTsa.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_service', 'isEnabled', true, false) ? [
            (0, $i2X0L.LazyWorkflowNavigationSettings)
        ] : [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jiE34.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("4YHpZ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesWorkflowRoute", () => $71fcdf9d5291b697$export$959cd36cc49d3b76);
const $71fcdf9d5291b697$export$959cd36cc49d3b76 = {
    name: 'project-settings-servicedesk-issuetypes-workflow',
    path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("i2X0L", function(module, exports) {

$parcel$export(module.exports, "LazyWorkflowNavigationSettings", () => $a1d3154877c5e5ef$export$cb608e3696682e76);
$parcel$export(module.exports, "default", () => $a1d3154877c5e5ef$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $a1d3154877c5e5ef$export$cb608e3696682e76 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("gr4id"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a1d3154877c5e5ef$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a1d3154877c5e5ef$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });

});


parcelRegister("dpK5U", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmFeaturesRouteEntry", () => $ca8160bc73736266$export$40ca23d1e05da300);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $g9kBK = parcelRequire("g9kBK");

var $5vwG0 = parcelRequire("5vwG0");

var $aQoXd = parcelRequire("aQoXd");

var $batW3 = parcelRequire("batW3");
const $ca8160bc73736266$export$40ca23d1e05da300 = (0, $6xToB.createEntry)((0, $5vwG0.projectSettingsServicedeskItsmFeaturesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jsm-features-settings',
        component: (0, $batW3.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $g9kBK.featuresResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $batW3.LazyProjectSettingsServiceDeskItsmFeatures)
        ],
        perfMetricKey: 'jsm-features-settings'
    }));

});
parcelRegister("5vwG0", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmFeaturesRoute", () => $98c64db85c471351$export$e60ffa2990540464);
const $98c64db85c471351$export$e60ffa2990540464 = {
    name: 'project-settings-servicedesk-itsm-features',
    path: '/jira/servicedesk/projects/:projectKey/settings/itsm-features',
    exact: true
};

});

parcelRegister("batW3", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskItsmFeatures", () => $4db313fe520648ff$export$562be1021beb9882);
$parcel$export(module.exports, "default", () => $4db313fe520648ff$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $4db313fe520648ff$export$562be1021beb9882 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("32c9K"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-itsm-features/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4db313fe520648ff$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4db313fe520648ff$export$562be1021beb9882,
        pageId: "project-settings-itsm-features",
        shouldShowSpinner: true
    });

});
parcelRegister("32c9K", function(module, exports) {

let $235afcf8e1e5a378$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $235afcf8e1e5a378$var$load("ayvPU").then(()=>parcelRequire('dAPjL'));

});



parcelRegister("f60wn", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry", () => $c56af183e57f7925$export$49692fb0973d60ca);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $JHxCO = parcelRequire("JHxCO");

var $1mIde = parcelRequire("1mIde");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $jGlrf = parcelRequire("jGlrf");
const $c56af183e57f7925$export$49692fb0973d60ca = (0, $6xToB.createEntry)((0, $1mIde.projectSettingsServicedeskItsmTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $jGlrf.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $JHxCO.servicedeskPracticesResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jGlrf.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields'
    }));

});
parcelRegister("1mIde", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypeFieldsRoute", () => $2977d780ce1dd0ae$export$1af0541fcb95547b);
const $2977d780ce1dd0ae$export$1af0541fcb95547b = {
    exact: true,
    name: 'project-settings-servicedesk-itsm-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice/request-type/:requestTypeId/:tabKey?'
};

});

parcelRegister("jGlrf", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskTicketTypeFields", () => $62d67bc476e72bc7$export$471040ce01e559fc);
$parcel$export(module.exports, "default", () => $62d67bc476e72bc7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4APnu = parcelRequire("4APnu");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $62d67bc476e72bc7$export$471040ce01e559fc = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("cjPsw")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-type-fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$62d67bc476e72bc7$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4APnu.HelpCenterSettingsRedirect), {
        page: "ticket-type-fields"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $62d67bc476e72bc7$export$471040ce01e559fc,
        pageId: "project-settings-ticket-type-fields",
        shouldShowSpinner: true
    }));

});
parcelRegister("cjPsw", function(module, exports) {

let $8f7f2d15ee97da39$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8f7f2d15ee97da39$var$load("1VRB2"),
    $8f7f2d15ee97da39$var$load("bABhq"),
    $8f7f2d15ee97da39$var$load("aWirD")
]).then(()=>parcelRequire('b2cpi'));

});



parcelRegister("18Mhr", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypesConfigRouteEntry", () => $f44ec38807b3d67e$export$9f40815b933b51ba);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $ksbf6 = parcelRequire("ksbf6");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $kEdwd = parcelRequire("kEdwd");

var $2Armd = parcelRequire("2Armd");

var $JHxCO = parcelRequire("JHxCO");

var $g9kBK = parcelRequire("g9kBK");

var $9pooG = parcelRequire("9pooG");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $23er7 = parcelRequire("23er7");

var $g8uYY = parcelRequire("g8uYY");

var $5L7qx = parcelRequire("5L7qx");

var $7jTnu = parcelRequire("7jTnu");

var $4sBtm = parcelRequire("4sBtm");
const $f44ec38807b3d67e$var$projectSettingsServicedeskItsmTicketTypesConfigPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $23er7.TicketTypesConfigEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $f44ec38807b3d67e$export$9f40815b933b51ba = (0, $6xToB.createEntry)((0, $9pooG.projectSettingsServicedeskItsmTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4sBtm.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            return $f44ec38807b3d67e$var$projectSettingsServicedeskItsmTicketTypesConfigPageEntrypoint;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $JHxCO.servicedeskPracticesResource),
            (0, $kEdwd.servicedeskIssueTypesResource),
            (0, $2Armd.servicedeskPortalGroupsResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('remove_repackaging_banner_for_change'), (0, $ksbf6.jsmRepackagingBannerResource)),
            (0, $g9kBK.featuresResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4sBtm.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration'
    }));

});
parcelRegister("kEdwd", function(module, exports) {

$parcel$export(module.exports, "servicedeskIssueTypesResource", () => $4c371e8026b56fdb$export$191ce50629f40dbe);

var $l1VxS = parcelRequire("l1VxS");


const $4c371e8026b56fdb$var$getDataLoader = ()=>(parcelRequire("17bdl"));
const $4c371e8026b56fdb$export$191ce50629f40dbe = (0, $l1VxS.createResource)({
    type: (0, $67a24649971d090c$export$1ed713fe52212251),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $4c371e8026b56fdb$var$getDataLoader
});

});
const $67a24649971d090c$export$1ed713fe52212251 = 'SERVICEDESK_ISSUE_TYPES';

parcelRegister("17bdl", function(module, exports) {

let $0cff24cb0d00da0a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $0cff24cb0d00da0a$var$load("hwlgY"),
    $0cff24cb0d00da0a$var$load("fpeYV")
]).then(()=>parcelRequire('5KjQk'));

});


parcelRegister("2Armd", function(module, exports) {

$parcel$export(module.exports, "servicedeskPortalGroupsResource", () => $2ac7c9d08da185de$export$c7fb28234b909b2f);

var $l1VxS = parcelRequire("l1VxS");


const $2ac7c9d08da185de$var$getDataLoader = ()=>(parcelRequire("dviMf"));
const $2ac7c9d08da185de$var$ONE_DAY_IN_MILLIS = 86400000;
const $2ac7c9d08da185de$export$c7fb28234b909b2f = (0, $l1VxS.createResource)({
    type: (0, $ffbd6364c6cc38ce$export$4160f2c498fcd32e),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $2ac7c9d08da185de$var$getDataLoader,
    maxAge: $2ac7c9d08da185de$var$ONE_DAY_IN_MILLIS
});

});
const $ffbd6364c6cc38ce$export$4160f2c498fcd32e = 'SERVICEDESK_PORTAL_GROUPS';

parcelRegister("dviMf", function(module, exports) {

let $9d4cbc5ce2f3ee92$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $9d4cbc5ce2f3ee92$var$load("hwlgY"),
    $9d4cbc5ce2f3ee92$var$load("iZxxe")
]).then(()=>parcelRequire('lwnQ4'));

});


parcelRegister("23er7", function(module, exports) {

$parcel$export(module.exports, "TicketTypesConfigEntrypoint", () => $da99b6cac6465d23$export$85bc484c6bab022d);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $1Bir5 = parcelRequire("1Bir5");

const $da99b6cac6465d23$export$85bc484c6bab022d = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("VEaO9")), {
        moduleId: "d08c0344",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const cloudId = tenantContext.cloudId;
        const projectKey = context.match.params.projectKey;
        if (!projectKey) throw new Error('Project key is required');
        return {
            entryPoints: {
                requestTypeTableEntrypoint: {
                    entryPoint: (0, $1Bir5.requestTypeTableEntrypoint),
                    entryPointParams: {
                        projectKey: projectKey,
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("1Bir5", function(module, exports) {

$parcel$export(module.exports, "requestTypeTableEntrypoint", () => $dc64eb020400b9a9$export$ecbf0c880decd2ac);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $e5VwX = parcelRequire("e5VwX");

const $dc64eb020400b9a9$export$ecbf0c880decd2ac = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("e1h4g")).then((module)=>module.RequestTypesTable), {
        moduleId: "44a9b8a6",
        priority: "userVisible"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId })=>{
        return {
            queries: {
                tableSettings: {
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    },
                    parameters: $e5VwX.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("e5VwX", function(module, exports) {

$parcel$export(module.exports, "default", () => $95b6d869f04d3470$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ce045fc0dd46722872f41c70f570f768>>
 * @relayHash 989e1263c7e39eb54ef3504b593961dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bc2fb1d6504af1e571c063410348f23ce17651af7eb3f1921b9b1483b8d48cc8
const $95b6d869f04d3470$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "bc2fb1d6504af1e571c063410348f23ce17651af7eb3f1921b9b1483b8d48cc8",
        "metadata": {},
        "name": "table_RequestTypesTableQuery",
        "operationKind": "query",
        "text": null
    }
};
var $95b6d869f04d3470$export$2e2bcd8739ae039 = $95b6d869f04d3470$var$node;

});

parcelRegister("e1h4g", function(module, exports) {

let $a34e65fbbfeb3232$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a34e65fbbfeb3232$var$load("aXdmq").then(()=>parcelRequire('fLuCd'));

});


parcelRegister("VEaO9", function(module, exports) {

let $0ad47c9217eba6fc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $0ad47c9217eba6fc$var$load("1VRB2"),
    $0ad47c9217eba6fc$var$load("bABhq"),
    $0ad47c9217eba6fc$var$load("hHCUm")
]).then(()=>parcelRequire('cURTI'));

});


parcelRegister("4sBtm", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskTicketTypesConfig", () => $e31003dd2f5c840b$export$c26e63f8b7d3b52c);
$parcel$export(module.exports, "default", () => $e31003dd2f5c840b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4APnu = parcelRequire("4APnu");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $e31003dd2f5c840b$export$c26e63f8b7d3b52c = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("3CEXo")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-types-config/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e31003dd2f5c840b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4APnu.HelpCenterSettingsRedirect), {
        page: "ticket-types-config"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e31003dd2f5c840b$export$c26e63f8b7d3b52c,
        pageId: "project-settings-ticket-types-config",
        shouldShowSpinner: true
    }));

});
parcelRegister("3CEXo", function(module, exports) {

let $2a34b0e68aa4b0cb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $2a34b0e68aa4b0cb$var$load("1VRB2"),
    $2a34b0e68aa4b0cb$var$load("bABhq"),
    $2a34b0e68aa4b0cb$var$load("lrGQo")
]).then(()=>parcelRequire('6JNBC'));

});



parcelRegister("iCcmc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationEditRouteEntry", () => $733e81f66b242acb$export$5cbb0a0098e65c64);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $aURSi = parcelRequire("aURSi");

var $aQoXd = parcelRequire("aQoXd");

var $3JiWp = parcelRequire("3JiWp");
const $733e81f66b242acb$export$5cbb0a0098e65c64 = (0, $6xToB.createEntry)((0, $aURSi.projectSettingsServicedeskJourneyConfigurationEditRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journey-config',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('journey-config'),
                teamName: 'JSM Getting Started'
            }
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        perfMetricKey: 'jsm-journey-configuration-edit',
        entryPoint: ()=>(0, $3JiWp.journeyConfigEditPageEntryPoint)
    }));

});
parcelRegister("aURSi", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationEditRoute", () => $1602c17bde8ba847$export$f80f582ef54900c6);
const $1602c17bde8ba847$export$f80f582ef54900c6 = {
    name: 'project-settings-servicedesk-journey-configuration-edit',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId/edit',
    exact: true
};

});

parcelRegister("3JiWp", function(module, exports) {

$parcel$export(module.exports, "journeyConfigEditPageEntryPoint", () => $7cedf9bb5f9ce252$export$7388ef888b9170a7);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $PC8KQ = parcelRequire("PC8KQ");
const $7cedf9bb5f9ce252$export$7388ef888b9170a7 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $PC8KQ.journeyConfigEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("PC8KQ", function(module, exports) {

$parcel$export(module.exports, "journeyConfigEntryPoint", () => $67104edf5aa204f7$export$26f82de7820f0c3);

var $g2u6t = parcelRequire("g2u6t");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $67104edf5aa204f7$export$26f82de7820f0c3 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("lGAy1")), {
        moduleId: "6bffb775",
        moduleName: "JourneyConfigurationPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        return {
            queries: {
                jiraJourneyConfiguration: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $g2u6t.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey || '',
                        journeyId: context.match.params.journeyId ?? '',
                        isEditing: context.match.path?.includes('journeys/:journeyId/edit')
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});

});
parcelRegister("g2u6t", function(module, exports) {

$parcel$export(module.exports, "default", () => $be417e0989f393e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e06cf0de02a02f5f42e77c496980e6a1>>
 * @relayHash 7d2c1f8e5b9684731e5713e07f73fc9f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d37362be06a6b3aae26e24a239f603fc7b91f3abcd57752080589e5fb224d266

var $JTvaD = parcelRequire("JTvaD");

var $cBqC9 = parcelRequire("cBqC9");
const $be417e0989f393e7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d37362be06a6b3aae26e24a239f603fc7b91f3abcd57752080589e5fb224d266",
        "metadata": {},
        "name": "JourneyConfigurationPageQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirajourneybuilderimprovevalidationrelayprovider": (0, $JTvaD.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmjourneybuilderconditionsmartvaluerelayprovider": (0, $cBqC9.default)
        }
    }
};
var $be417e0989f393e7$export$2e2bcd8739ae039 = $be417e0989f393e7$var$node;

});
parcelRegister("JTvaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $35484e35227f9e6a$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $35484e35227f9e6a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('journey_builder_validation_errors');
    }
};

});

parcelRegister("cBqC9", function(module, exports) {

$parcel$export(module.exports, "default", () => $29b0a83e7a75361c$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $29b0a83e7a75361c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jsm-journey-builder--condition-smart-value');
    }
};

});


parcelRegister("lGAy1", function(module, exports) {

let $fc99ded9ac4f3979$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $fc99ded9ac4f3979$var$load("1VRB2"),
    $fc99ded9ac4f3979$var$load("bABhq"),
    $fc99ded9ac4f3979$var$load("hKKwF")
]).then(()=>parcelRequire('g5gkO'));

});




parcelRegister("f0hVi", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationRouteEntry", () => $80846fcba3949f85$export$7475316a4561dd76);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $ao76L = parcelRequire("ao76L");

var $aQoXd = parcelRequire("aQoXd");

var $7jTnu = parcelRequire("7jTnu");

var $aU6Ad = parcelRequire("aU6Ad");
const $80846fcba3949f85$export$7475316a4561dd76 = (0, $6xToB.createEntry)((0, $ao76L.projectSettingsServicedeskJourneyConfigurationRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journey-config',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('journey-config'),
                teamName: 'JSM Getting Started'
            }
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        perfMetricKey: 'jsm-journey-configuration',
        entryPoint: ()=>(0, $7jTnu.fg)('jsm-journey-builder') ? (0, $aU6Ad.journeyConfigPageEntryPoint) : undefined
    }));

});
parcelRegister("ao76L", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationRoute", () => $08cc01901e712a96$export$9013e78604bfadb0);
const $08cc01901e712a96$export$9013e78604bfadb0 = {
    name: 'project-settings-servicedesk-journey-configuration',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId',
    exact: true
};

});

parcelRegister("aU6Ad", function(module, exports) {

$parcel$export(module.exports, "journeyConfigPageEntryPoint", () => $1e4d95712143af28$export$35537410b0bf07ea);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $PC8KQ = parcelRequire("PC8KQ");
const $1e4d95712143af28$export$35537410b0bf07ea = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $PC8KQ.journeyConfigEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});


parcelRegister("j9UDw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneysRouteEntry", () => $c1cbda040f9975dd$export$6c014a8c741bf222);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $frar7 = parcelRequire("frar7");

var $aQoXd = parcelRequire("aQoXd");

var $7jTnu = parcelRequire("7jTnu");

var $8DVKx = parcelRequire("8DVKx");
const $c1cbda040f9975dd$export$6c014a8c741bf222 = (0, $6xToB.createEntry)((0, $frar7.projectSettingsServicedeskJourneysRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journeys-list',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('journeys-list'),
                teamName: 'JSM Getting Started'
            }
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        perfMetricKey: 'jsm-journeys',
        entryPoint: ()=>(0, $7jTnu.fg)('jsm-journey-builder') ? (0, $8DVKx.journeysPageEntryPoint) : undefined
    }));

});
parcelRegister("frar7", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneysRoute", () => $d351fab09a3db8fb$export$627d71a1dd7a9593);
const $d351fab09a3db8fb$export$627d71a1dd7a9593 = {
    name: 'project-settings-servicedesk-journeys',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys',
    exact: true
};

});

parcelRegister("8DVKx", function(module, exports) {

$parcel$export(module.exports, "journeysPageEntryPoint", () => $16a00dc6910336cf$export$3b90f0eb27bdd52f);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $62QKB = parcelRequire("62QKB");
const $16a00dc6910336cf$export$3b90f0eb27bdd52f = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $62QKB.journeysEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("62QKB", function(module, exports) {

$parcel$export(module.exports, "journeysEntryPoint", () => $07bd4ccae6b495a7$export$4ded7f93dbe6eb63);

var $6OVqu = parcelRequire("6OVqu");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $07bd4ccae6b495a7$export$4ded7f93dbe6eb63 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("3Uxuc")), {
        moduleId: "ab11e2ef",
        moduleName: "JourneysPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                journeysPageQueryRef: {
                    parameters: $6OVqu.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey || ''
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("6OVqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae595d5f231617c6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc980efc5ff5e635370f791663aa19ff>>
 * @relayHash 7a91c4e9dc9c3329f704e5dcb8466252
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b55f90f67c621690126b363fafb511f6570df98f56e57cf7dcc787d6df9e513
const $ae595d5f231617c6$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8b55f90f67c621690126b363fafb511f6570df98f56e57cf7dcc787d6df9e513",
        "metadata": {},
        "name": "JourneysPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ae595d5f231617c6$export$2e2bcd8739ae039 = $ae595d5f231617c6$var$node;

});

parcelRegister("3Uxuc", function(module, exports) {

let $2d9093b2a8b240dd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2d9093b2a8b240dd$var$load("89Txo").then(()=>parcelRequire('jN0Pk'));

});




parcelRegister("fmhFi", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskKbRouteEntry", () => $f71de991dce104c4$export$d43e914d37d059b8);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $idiiX = parcelRequire("idiiX");

var $aQoXd = parcelRequire("aQoXd");

var $cfhyn = parcelRequire("cfhyn");
const $f71de991dce104c4$export$d43e914d37d059b8 = (0, $6xToB.createEntry)((0, $idiiX.projectSettingsServicedeskKbRoute), ()=>({
        group: 'project-settings-servicedesk',
        perfMetricKey: 'service-management.kb-settings',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        component: (0, $cfhyn.ServiceDeskKnowledgeBaseV2),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cfhyn.LazyProjectSettingsServiceDeskKnowledgeBaseV2)
        ],
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("cfhyn", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskKnowledgeBaseV2", () => $50a04f829d91e94a$export$7c7186fdd8c56428);
$parcel$export(module.exports, "ServiceDeskKnowledgeBaseV2", () => $50a04f829d91e94a$export$6d92735e249274bb);

var $eJOHy = parcelRequire("eJOHy");

var $4APnu = parcelRequire("4APnu");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");
const $50a04f829d91e94a$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $50a04f829d91e94a$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $50a04f829d91e94a$export$583a442626bd3345 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("4ZUSz")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-knowledge-base/src/index.tsx"
});

const $50a04f829d91e94a$export$7c7186fdd8c56428 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3myi9"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-settings/src/index.tsx"
});
const $50a04f829d91e94a$export$6d92735e249274bb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4APnu.HelpCenterSettingsRedirect), {
        page: "kb"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $50a04f829d91e94a$export$7c7186fdd8c56428,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$50a04f829d91e94a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $50a04f829d91e94a$export$583a442626bd3345,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    });

});
parcelRegister("4ZUSz", function(module, exports) {

let $3a38faebe4c2c934$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3a38faebe4c2c934$var$load("5YvCP").then(()=>parcelRequire('lxnHp'));

});

parcelRegister("3myi9", function(module, exports) {

let $272e06c751de0399$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $272e06c751de0399$var$load("1VRB2"),
    $272e06c751de0399$var$load("bABhq"),
    $272e06c751de0399$var$load("8N5WB")
]).then(()=>parcelRequire('3R5ta'));

});



parcelRegister("1Zxl4", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageKeyRouteEntry", () => $bdde8c2052f059a4$export$db3a99044f906462);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $aHHHc = parcelRequire("aHHHc");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $6VIPQ = parcelRequire("6VIPQ");

var $bwRpv = parcelRequire("bwRpv");
const $bdde8c2052f059a4$export$db3a99044f906462 = (0, $6xToB.createEntry)((0, $aHHHc.projectSettingsServicedeskLanguageKeyRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.translations',
        component: (0, $bwRpv.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $6VIPQ.languageTranslationsResource),
            (0, $6VIPQ.outgoingEmailStateModelResource)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).LANGUAGE_SETTINGS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).LANGUAGE_SETTINGS),
                teamName: 'jsm-banana'
            }
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bwRpv.LazyProjectSettingsServiceDeskLanguageTranslations)
        ],
        perfMetricKey: 'jsm-language-translations'
    }));

});
parcelRegister("aHHHc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageKeyRoute", () => $ff2a7730ea3efa27$export$194a3f27b07aafec);
const $ff2a7730ea3efa27$export$194a3f27b07aafec = {
    name: 'project-settings-servicedesk-language-key',
    path: '/jira/servicedesk/projects/:projectKey/settings/language/:languageKey/:sidebarItemKey?'
};

});

parcelRegister("6VIPQ", function(module, exports) {

$parcel$export(module.exports, "languageTranslationsResource", () => $d72c5d70b0ef9c22$export$f51887e33895eab9);
$parcel$export(module.exports, "outgoingEmailStateModelResource", () => $d72c5d70b0ef9c22$export$c460156a7e6b85b2);

var $l1VxS = parcelRequire("l1VxS");
const $d72c5d70b0ef9c22$export$9f529be3aeae01ea = 'JSM Language Translations';
const $d72c5d70b0ef9c22$export$ecd381e388e8c56f = "Language Support Customer Notification's Outgoing Email State";

const $d72c5d70b0ef9c22$export$f51887e33895eab9 = (0, $l1VxS.createResource)({
    type: 'Language Translations',
    getKey: ({ match: { params: { projectKey: projectKey, languageKey: languageKey } } })=>`${$d72c5d70b0ef9c22$export$9f529be3aeae01ea}-${projectKey}-${languageKey}`,
    getDataLoader: ()=>(parcelRequire("bFB7I")),
    maxAge: Infinity
});

const $d72c5d70b0ef9c22$export$c460156a7e6b85b2 = (0, $l1VxS.createResource)({
    type: 'Outgoing Email State Model',
    getKey: ()=>`${$d72c5d70b0ef9c22$export$ecd381e388e8c56f}`,
    getDataLoader: ()=>(parcelRequire("4BIz3")),
    maxAge: Infinity
});

});
parcelRegister("bFB7I", function(module, exports) {

let $87f051fc5156fb0a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $87f051fc5156fb0a$var$load("5R59Y").then(()=>parcelRequire('l5F6h'));

});

parcelRegister("4BIz3", function(module, exports) {

let $35ad2fad39e91737$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $35ad2fad39e91737$var$load("elZfE").then(()=>parcelRequire('fsKGx'));

});


parcelRegister("bwRpv", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskLanguageTranslations", () => $f80c5817021de235$export$c029d3f514c7b3e0);
$parcel$export(module.exports, "default", () => $f80c5817021de235$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $f80c5817021de235$export$c029d3f514c7b3e0 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("1E9A8")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-translations/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f80c5817021de235$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f80c5817021de235$export$c029d3f514c7b3e0,
        pageId: "project-settings-language-translations",
        shouldShowSpinner: true
    });

});
parcelRegister("1E9A8", function(module, exports) {

let $1330f5a2007ac7b1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1330f5a2007ac7b1$var$load("1VRB2"),
    $1330f5a2007ac7b1$var$load("bABhq"),
    $1330f5a2007ac7b1$var$load("eDzss"),
    $1330f5a2007ac7b1$var$load("2nL3y")
]).then(()=>parcelRequire('krw7z'));

});



parcelRegister("2rBHC", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageRouteEntry", () => $ea38399893f32964$export$576b048795cbefad);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $h0nMy = parcelRequire("h0nMy");

var $aQoXd = parcelRequire("aQoXd");

var $61hqg = parcelRequire("61hqg");

var $bwRpv = parcelRequire("bwRpv");
const $ea38399893f32964$export$576b048795cbefad = (0, $6xToB.createEntry)((0, $h0nMy.projectSettingsServicedeskLanguageRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.languages',
        component: (0, $61hqg.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bwRpv.LazyProjectSettingsServiceDeskLanguageTranslations)
        ]
    }));

});
parcelRegister("h0nMy", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageRoute", () => $01ab2f4fbae10b74$export$99b0bbae92462ac2);
const $01ab2f4fbae10b74$export$99b0bbae92462ac2 = {
    name: 'project-settings-servicedesk-language',
    path: '/jira/servicedesk/projects/:projectKey/settings/language',
    exact: true
};

});

parcelRegister("61hqg", function(module, exports) {

$parcel$export(module.exports, "default", () => $759d708f8a2f847e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $759d708f8a2f847e$export$213b8279037c9d98 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fZaXw"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-support/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$759d708f8a2f847e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $759d708f8a2f847e$export$213b8279037c9d98,
        pageId: "project-settings-language-support",
        shouldShowSpinner: true
    });

});
parcelRegister("fZaXw", function(module, exports) {

let $ba350dbfdb864888$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ba350dbfdb864888$var$load("621mn").then(()=>parcelRequire('ksMlh'));

});



parcelRegister("lxP9C", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCopyRouteEntry", () => $284d310929ea3792$export$dd52be928c274980);

var $6xToB = parcelRequire("6xToB");

var $7iMQu = parcelRequire("7iMQu");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lKSeb = parcelRequire("lKSeb");
const $284d310929ea3792$export$dd52be928c274980 = (0, $6xToB.createEntry)((0, $7iMQu.projectSettingsServicedeskLegacyAutomationRedirectCopyRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $lKSeb.automationRedirect)('copy')
    }));

});
parcelRegister("7iMQu", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCopyRoute", () => $f89447819405c1b0$export$869afe63d0e077be);
const $f89447819405c1b0$export$869afe63d0e077be = {
    name: 'project-settings-servicedesk-automation-redirect-copy',
    path: '/projects/:projectKey/settings/automation/copy/:ruleId'
};

});

parcelRegister("lKSeb", function(module, exports) {

$parcel$export(module.exports, "automationRedirect", () => $3afc8dba29b6c62d$export$d6674bfa636b8090);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $47Jx0 = parcelRequire("47Jx0");

var $2mHfh = parcelRequire("2mHfh");
// uses empty string instead of actual baseUrl as router redirect handles it internally
const $3afc8dba29b6c62d$var$newAutomationUrl = ({ match: match }, pageType)=>{
    const { projectKey: projectKey } = match.params;
    if (pageType === 'edit') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $47Jx0.getNextgenSettingsUrl)((0, $ln6Iy.SERVICE_DESK_PROJECT), String(projectKey))}/automation/ruleset/${ruleId || ''}`;
    }
    if (pageType === 'copy') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $47Jx0.getNextgenSettingsUrl)((0, $ln6Iy.SERVICE_DESK_PROJECT), String(projectKey))}/automation/copy/${ruleId || ''}`;
    }
    if (pageType === 'viewlog') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $47Jx0.getNextgenSettingsUrl)((0, $ln6Iy.SERVICE_DESK_PROJECT), String(projectKey))}/automation/log/${ruleId || ''}`;
    }
    if (pageType === 'create') {
        const { blueprintKey: blueprintKey } = match.params;
        return `${(0, $47Jx0.getNextgenSettingsUrl)((0, $ln6Iy.SERVICE_DESK_PROJECT), String(projectKey))}/automation/blueprint/${blueprintKey || ''}`;
    }
    return `${(0, $47Jx0.getNextgenSettingsUrl)((0, $ln6Iy.SERVICE_DESK_PROJECT), String(projectKey))}/automation`;
};
const $3afc8dba29b6c62d$export$d6674bfa636b8090 = (pageType)=>(routeContext)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: $3afc8dba29b6c62d$var$newAutomationUrl(routeContext, pageType),
            push: false
        });
    };

});


parcelRegister("etWAS", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCreateRouteEntry", () => $b638b0b7c05060c3$export$fc7d1f3302418153);

var $6xToB = parcelRequire("6xToB");

var $gWImf = parcelRequire("gWImf");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lKSeb = parcelRequire("lKSeb");
const $b638b0b7c05060c3$export$fc7d1f3302418153 = (0, $6xToB.createEntry)((0, $gWImf.projectSettingsServicedeskLegacyAutomationRedirectCreateRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $lKSeb.automationRedirect)('create')
    }));

});
parcelRegister("gWImf", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCreateRoute", () => $295c7318f3662b0a$export$c2a59dbe6d23efd4);
const $295c7318f3662b0a$export$c2a59dbe6d23efd4 = {
    name: 'project-settings-servicedesk-automation-redirect-create',
    path: '/projects/:projectKey/settings/automation/blueprint/:blueprintKey'
};

});


parcelRegister("lMs1U", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectEditRouteEntry", () => $41045a8199c69378$export$cf95450a3eafe8ff);

var $6xToB = parcelRequire("6xToB");

var $jFbOX = parcelRequire("jFbOX");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lKSeb = parcelRequire("lKSeb");
const $41045a8199c69378$export$cf95450a3eafe8ff = (0, $6xToB.createEntry)((0, $jFbOX.projectSettingsServicedeskLegacyAutomationRedirectEditRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $lKSeb.automationRedirect)('edit')
    }));

});
parcelRegister("jFbOX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectEditRoute", () => $75603592285f10d6$export$f61e79c14e9bc0a1);
const $75603592285f10d6$export$f61e79c14e9bc0a1 = {
    name: 'project-settings-servicedesk-automation-redirect-edit',
    path: '/projects/:projectKey/settings/automation/ruleset/:ruleId'
};

});


parcelRegister("apRSQ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectSummaryRouteEntry", () => $81b6ba8507e3173d$export$d6873ef17e5a0ea5);

var $6xToB = parcelRequire("6xToB");

var $1fVC8 = parcelRequire("1fVC8");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lKSeb = parcelRequire("lKSeb");
const $81b6ba8507e3173d$export$d6873ef17e5a0ea5 = (0, $6xToB.createEntry)((0, $1fVC8.projectSettingsServicedeskLegacyAutomationRedirectSummaryRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $lKSeb.automationRedirect)('summary')
    }));

});
parcelRegister("1fVC8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectSummaryRoute", () => $d541891b8c3672dd$export$fdd432d4e600f9);
const $d541891b8c3672dd$export$fdd432d4e600f9 = {
    name: 'project-settings-servicedesk-automation-redirect-summary',
    path: '/projects/:projectKey/settings/automation/'
};

});


parcelRegister("evzjc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry", () => $3036458d0faa0f7a$export$f0eaafcdee9dfa31);

var $6xToB = parcelRequire("6xToB");

var $eYgxG = parcelRequire("eYgxG");

var $5RW99 = parcelRequire("5RW99");

var $aQoXd = parcelRequire("aQoXd");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lKSeb = parcelRequire("lKSeb");
const $3036458d0faa0f7a$export$f0eaafcdee9dfa31 = (0, $6xToB.createEntry)((0, $eYgxG.projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $lKSeb.automationRedirect)('viewlog')
    }));

});
parcelRegister("eYgxG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute", () => $3edc675b300a297c$export$e6e772830a33ba0b);
const $3edc675b300a297c$export$e6e772830a33ba0b = {
    name: 'project-settings-servicedesk-automation-redirect-viewlog',
    path: '/projects/:projectKey/settings/automation/log/:ruleId'
};

});


parcelRegister("dG9Ao", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry", () => $02a782d67138c58b$export$b4d122e49516c10d);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $csrcH = parcelRequire("csrcH");

var $aQoXd = parcelRequire("aQoXd");

var $49ofR = parcelRequire("49ofR");

var $1VT2J = parcelRequire("1VT2J");
const $02a782d67138c58b$export$b4d122e49516c10d = (0, $6xToB.createEntry)((0, $csrcH.projectSettingsServicedeskNotificationsCustomerNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $49ofR.ServiceDeskCustomerNotificationsNextGenRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1VT2J.LazyProjectSettingsServiceDeskCustomerNotifications)
        ]
    }));

});
parcelRegister("49ofR", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskCustomerNotificationsNextGenRedirect", () => $7e0ece118f90f104$export$8249a46a710af6da);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $7e0ece118f90f104$export$8249a46a710af6da = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-notifications`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: url
    });
};

});


parcelRegister("eksQM", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRouteEntry", () => $f19ec1337dff05c0$export$ec0ead95e321b800);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $6WtFe = parcelRequire("6WtFe");

var $aQoXd = parcelRequire("aQoXd");

var $89DK8 = parcelRequire("89DK8");
const $f19ec1337dff05c0$export$ec0ead95e321b800 = (0, $6xToB.createEntry)((0, $6WtFe.projectSettingsServicedeskNotificationsEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $89DK8.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $89DK8.LazyProjectSettingsNotificationEmail)
        ]
    }));

});
parcelRegister("89DK8", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsNotificationEmail", () => $ab186adeaea4324b$export$ea7d73c94d9369f4);
$parcel$export(module.exports, "default", () => $ab186adeaea4324b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ab186adeaea4324b$export$ea7d73c94d9369f4 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fmrQC"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ab186adeaea4324b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ab186adeaea4324b$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });

});


parcelRegister("a0D4V", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry", () => $ec6dc7a41a147a38$export$4a15f2c244cd196c);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $buW1x = parcelRequire("buW1x");

var $aQoXd = parcelRequire("aQoXd");

var $ejTKN = parcelRequire("ejTKN");

var $aGYZJ = parcelRequire("aGYZJ");

var $21Rpn = parcelRequire("21Rpn");
const $ec6dc7a41a147a38$export$4a15f2c244cd196c = (0, $6xToB.createEntry)((0, $buW1x.projectSettingsServicedeskNotificationsInternalNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.internal-notifications',
        component: (0, $aGYZJ.serviceDeskInternalNotificationsNextGenRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $21Rpn.LazyProjectSettingsServiceDeskInternalNotifications),
            (0, $ejTKN.LazyInternalNotificationSettingsPage)
        ]
    }));

});
parcelRegister("aGYZJ", function(module, exports) {

$parcel$export(module.exports, "serviceDeskInternalNotificationsNextGenRedirect", () => $d0a2a76c15b5581c$export$49625f83fe7ecc69);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $d0a2a76c15b5581c$export$49625f83fe7ecc69 = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/internal-notifications`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: url
    });
};

});


parcelRegister("7mKmY", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRouteEntry", () => $3c3e9e2d2db5e2be$export$cc1164e0e5db595);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $iPhgi = parcelRequire("iPhgi");

var $aQoXd = parcelRequire("aQoXd");

var $89DK8 = parcelRequire("89DK8");

var $zt2zq = parcelRequire("zt2zq");
const $3c3e9e2d2db5e2be$export$cc1164e0e5db595 = (0, $6xToB.createEntry)((0, $iPhgi.projectSettingsServicedeskNotificationsNotificationEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $zt2zq.ServiceDeskNotificationEmailNextGenRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $89DK8.LazyProjectSettingsNotificationEmail)
        ]
    }));

});
parcelRegister("zt2zq", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskNotificationEmailNextGenRedirect", () => $bc23de3cd1331e8c$export$735e58642f560ddc);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $bc23de3cd1331e8c$export$735e58642f560ddc = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/notification-email`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: url
    });
};

});


parcelRegister("5UnPY", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsRouteEntry", () => $175512a96a8bbead$export$20923f853e06d781);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $cK42t = parcelRequire("cK42t");

var $aQoXd = parcelRequire("aQoXd");

var $ipaDV = parcelRequire("ipaDV");
const $175512a96a8bbead$export$20923f853e06d781 = (0, $6xToB.createEntry)((0, $cK42t.projectSettingsServicedeskNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $ipaDV.notificationsRedirect)('customer-notifications'),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("cK42t", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsRoute", () => $f9ccd1e5cc46db9e$export$dbc53740e1d7ff79);
const $f9ccd1e5cc46db9e$export$dbc53740e1d7ff79 = {
    name: 'project-settings-servicedesk-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("ipaDV", function(module, exports) {

$parcel$export(module.exports, "notificationsRedirect", () => $657d57b36eca46ef$export$59144dd4441639fa);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $47Jx0 = parcelRequire("47Jx0");

var $2mHfh = parcelRequire("2mHfh");
const $657d57b36eca46ef$export$59144dd4441639fa = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = projectKey !== null && projectKey !== undefined ? `${(0, $47Jx0.getNextgenSettingsUrl)((0, $ln6Iy.SERVICE_DESK_PROJECT), projectKey)}/notifications/${pageUrlFragment}` : `/projects/${String(projectKey)}/settings/notifications/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: url,
            push: false
        });
    };

});


parcelRegister("fQdWc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskOverviewRouteEntry", () => $f50820fe0a7da850$export$1f0cb137e600941a);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $jOHCX = parcelRequire("jOHCX");

var $aQoXd = parcelRequire("aQoXd");

var $cJRRo = parcelRequire("cJRRo");
const $f50820fe0a7da850$export$1f0cb137e600941a = (0, $6xToB.createEntry)((0, $jOHCX.projectSettingsServicedeskOverviewRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $cJRRo.AsyncOverviewSetting),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cJRRo.LazyOverviewSettings)
        ]
    }));

});
parcelRegister("jOHCX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskOverviewRoute", () => $9fe2cd3d22978790$export$b4043f1a1b914130);
const $9fe2cd3d22978790$export$b4043f1a1b914130 = {
    name: 'project-settings-servicedesk-overview',
    // /settings/overview
    path: '/jira/servicedesk/projects/:projectKey/settings/overview',
    exact: true
};

});

parcelRegister("cJRRo", function(module, exports) {

$parcel$export(module.exports, "LazyOverviewSettings", () => $5d004ea08ed7c696$export$ce469ceb4c68a932);
$parcel$export(module.exports, "AsyncOverviewSetting", () => $5d004ea08ed7c696$export$92888ae2bbb25072);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $5d004ea08ed7c696$export$ce469ceb4c68a932 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("j7aJO"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-overview/src/ui/index.tsx"
});
const $5d004ea08ed7c696$export$92888ae2bbb25072 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $5d004ea08ed7c696$export$ce469ceb4c68a932,
        pageId: "project-settings-overview",
        shouldShowSpinner: false
    });

});
parcelRegister("j7aJO", function(module, exports) {

let $dea70017bab49d65$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dea70017bab49d65$var$load("loHV0").then(()=>parcelRequire('48O0r'));

});



parcelRegister("dOUgk", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskPortalSettingsRouteEntry", () => $b71ef8069204d6e4$export$2f07a0943f4553c4);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $dOEVM = parcelRequire("dOEVM");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $kEhEs = parcelRequire("kEhEs");

var $cxsKb = parcelRequire("cxsKb");
const $b71ef8069204d6e4$export$2f07a0943f4553c4 = (0, $6xToB.createEntry)((0, $dOEVM.projectSettingsServicedeskPortalSettingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $cxsKb.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $kEhEs.serviceDeskPortalClassicSettingsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cxsKb.LazyProjectSettingsServiceDeskClassicPortalSettings)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).PORTAL_SETTINGS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).PORTAL_SETTINGS),
                teamName: 'jsd-shield'
            }
        }
    }));

});
parcelRegister("kEhEs", function(module, exports) {

$parcel$export(module.exports, "serviceDeskPortalClassicSettingsResource", () => $3141dc52973d1c7d$export$2c58fa923657baed);

var $9FYIg = parcelRequire("9FYIg");

var $jEZmP = parcelRequire("jEZmP");
const $3141dc52973d1c7d$export$2c58fa923657baed = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_SERVICE_DESK_PORTAL_CLASSIC_SETTINGS`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $jEZmP.default),
            variables: {
                cloudId: cloudId,
                input: {
                    onlyMyAgents: true,
                    onlyFavouriteAgents: false
                }
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true
});

});
parcelRegister("jEZmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e8ec5a96a71e26b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d81b9f2e8127e7de158924e859dc6889>>
 * @relayHash 92f21b5f327ad7c67e76499662c7635b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eb9d10cb83ae1be8bad1465b2a6f5a5a6ac0a887619a698d8852446035a37605

var $kEBh8 = parcelRequire("kEBh8");
const $2e8ec5a96a71e26b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 30
        },
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyFavouriteAgents": false,
                "onlyMyAgents": true
            }
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "srcviewServiceDeskClassicPortalSettingsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "ui_servicedeskPortalSettings_PortalSettings"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "srcviewServiceDeskClassicPortalSettingsQuery",
            "selections": [
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "AgentStudioAgentsConnection",
                            "kind": "LinkedField",
                            "name": "agentStudio_getAgents",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "AgentStudioAgentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "AgentStudioAssistant",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "externalConfigReference"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "identityAccountId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "creatorType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v2 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "input"
                            ],
                            "handle": "connection",
                            "key": "RovoAgent_agentStudio_getAgents",
                            "kind": "LinkedHandle",
                            "name": "agentStudio_getAgents"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "eb9d10cb83ae1be8bad1465b2a6f5a5a6ac0a887619a698d8852446035a37605",
            "metadata": {},
            "name": "srcviewServiceDeskClassicPortalSettingsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider": (0, $kEBh8.default)
            }
        }
    };
}();
$2e8ec5a96a71e26b$var$node.hash = "c49ff357fe9f88e7327c6730f209ebe7";
var $2e8ec5a96a71e26b$export$2e2bcd8739ae039 = $2e8ec5a96a71e26b$var$node;

});


parcelRegister("cxsKb", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskClassicPortalSettings", () => $ec991522ca4e9b2a$export$eb662b618d6247be);
$parcel$export(module.exports, "default", () => $ec991522ca4e9b2a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ec991522ca4e9b2a$export$eb662b618d6247be = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7FUXg"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-classic-portal-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ec991522ca4e9b2a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ec991522ca4e9b2a$export$eb662b618d6247be,
        pageId: "project-settings-classic-portal-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("7FUXg", function(module, exports) {

let $59688ac3962b0109$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $59688ac3962b0109$var$load("8BgmV").then(()=>parcelRequire('95W9l'));

});



parcelRegister("kxzOk", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaJiraFormBuilderRouteEntry", () => $c1f5291e9c274e3f$export$f7bbe7fb3eeb9258);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $dWzDb = parcelRequire("dWzDb");

var $aQoXd = parcelRequire("aQoXd");

var $ff6mX = parcelRequire("ff6mX");
const $c1f5291e9c274e3f$export$f7bbe7fb3eeb9258 = (0, $6xToB.createEntry)((0, $dWzDb.projectSettingsServicedeskProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $ff6mX.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ff6mX.LazyProjectSettingsProformaJiraFormBuilder)
        ],
        perfMetricKey: 'form-builder'
    }));

});
parcelRegister("dWzDb", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaJiraFormBuilderRoute", () => $476746b8998f854f$export$f2a7862c8cde472d);
const $476746b8998f854f$export$f2a7862c8cde472d = {
    name: 'project-settings-servicedesk-proforma-jira-form-builder',
    path: '/jira/servicedesk/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});

parcelRegister("ff6mX", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaJiraFormBuilder", () => $eb7b62859f8417fa$export$a7d63246a10aedd);
$parcel$export(module.exports, "default", () => $eb7b62859f8417fa$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $eb7b62859f8417fa$export$a7d63246a10aedd = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("h6wO6")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb7b62859f8417fa$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $eb7b62859f8417fa$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });

});


parcelRegister("3uU32", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaProjectFormsRouteEntry", () => $70e17818bf649559$export$f0d9fbaec8a9f2a);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $7B6GN = parcelRequire("7B6GN");

var $aQoXd = parcelRequire("aQoXd");

var $cOFxR = parcelRequire("cOFxR");
const $70e17818bf649559$export$f0d9fbaec8a9f2a = (0, $6xToB.createEntry)((0, $7B6GN.projectSettingsServicedeskProformaProjectFormsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $cOFxR.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cOFxR.LazyProjectSettingsProformaProjectForms)
        ],
        perfMetricKey: 'forms-settings'
    }));

});
parcelRegister("cOFxR", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaProjectForms", () => $ac6c25bcfe8ebf52$export$38414b624a749cec);
$parcel$export(module.exports, "default", () => $ac6c25bcfe8ebf52$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ac6c25bcfe8ebf52$export$38414b624a749cec = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("lW6IV")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ac6c25bcfe8ebf52$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ac6c25bcfe8ebf52$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });

});


parcelRegister("bpzvw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskRedirectRouteEntry", () => $efced346f7bd31d3$export$a0279fafdeb78607);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $efnXG = parcelRequire("efnXG");

var $aQoXd = parcelRequire("aQoXd");

var $gwoLH = parcelRequire("gwoLH");
const $efced346f7bd31d3$export$a0279fafdeb78607 = (0, $6xToB.createEntry)((0, $efnXG.projectSettingsServicedeskRedirectRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $gwoLH.defaultRedirectForSettings)((0, $gwoLH.SERVICE_DESK_PRODUCT)),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("efnXG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskRedirectRoute", () => $bfc01b189be62c12$export$3fbe0a89e4d1e816);
const $bfc01b189be62c12$export$3fbe0a89e4d1e816 = {
    name: 'project-settings-servicedesk-redirect',
    path: '/jira/servicedesk/projects/:projectKey/settings'
};

});


parcelRegister("5Ojcr", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypeFieldsRouteEntry", () => $d05ee6481ca3495f$export$30951c6038a30ec4);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $JHxCO = parcelRequire("JHxCO");

var $73X9K = parcelRequire("73X9K");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $jGlrf = parcelRequire("jGlrf");
const $d05ee6481ca3495f$export$30951c6038a30ec4 = (0, $6xToB.createEntry)((0, $73X9K.projectSettingsServicedeskTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $jGlrf.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $JHxCO.servicedeskPracticesResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jGlrf.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields'
    }));

});
parcelRegister("73X9K", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypeFieldsRoute", () => $dd2f232fea3fd1cb$export$6c99c477ef7583ba);
const $dd2f232fea3fd1cb$export$6c99c477ef7583ba = {
    exact: true,
    name: 'project-settings-servicedesk-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/request-type/:requestTypeId/:tabKey?'
};

});


parcelRegister("3Yt6X", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypesConfigRouteEntry", () => $3b9cbba88532f3e8$export$bcc0bb7cf7f75a0f);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $ksbf6 = parcelRequire("ksbf6");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $kEdwd = parcelRequire("kEdwd");

var $2Armd = parcelRequire("2Armd");

var $JHxCO = parcelRequire("JHxCO");

var $g9kBK = parcelRequire("g9kBK");

var $jmJlK = parcelRequire("jmJlK");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $23er7 = parcelRequire("23er7");

var $g8uYY = parcelRequire("g8uYY");

var $5L7qx = parcelRequire("5L7qx");

var $7jTnu = parcelRequire("7jTnu");

var $4sBtm = parcelRequire("4sBtm");
const $3b9cbba88532f3e8$var$projectSettingsServicedeskTicketTypesConfigPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $23er7.TicketTypesConfigEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $3b9cbba88532f3e8$export$bcc0bb7cf7f75a0f = (0, $6xToB.createEntry)((0, $jmJlK.projectSettingsServicedeskTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4sBtm.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $JHxCO.servicedeskPracticesResource),
            (0, $kEdwd.servicedeskIssueTypesResource),
            (0, $2Armd.servicedeskPortalGroupsResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('remove_repackaging_banner_for_change'), (0, $ksbf6.jsmRepackagingBannerResource)),
            (0, $g9kBK.featuresResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4sBtm.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        entryPoint () {
            return $3b9cbba88532f3e8$var$projectSettingsServicedeskTicketTypesConfigPageEntrypoint;
        },
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration'
    }));

});

parcelRegister("hAJ7N", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypeFieldsRouteEntry", () => $db1e39ec6021d647$export$515ee5ae44539ca4);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $JHxCO = parcelRequire("JHxCO");

var $boNcA = parcelRequire("boNcA");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $jGlrf = parcelRequire("jGlrf");
const $db1e39ec6021d647$export$515ee5ae44539ca4 = (0, $6xToB.createEntry)((0, $boNcA.projectSettingsServicedeskUnassignedTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $jGlrf.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $JHxCO.servicedeskPracticesResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jGlrf.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields'
    }));

});
parcelRegister("boNcA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypeFieldsRoute", () => $e89de84d8f540f5f$export$f7a986e844a111a6);
const $e89de84d8f540f5f$export$f7a986e844a111a6 = {
    exact: true,
    name: 'project-settings-servicedesk-unassigned-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned/request-type/:requestTypeId/:tabKey?'
};

});


parcelRegister("e9fEq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypesConfigRouteEntry", () => $5eea8950f1d4bbd6$export$6ba31a548ab77c4);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $ksbf6 = parcelRequire("ksbf6");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $kEdwd = parcelRequire("kEdwd");

var $2Armd = parcelRequire("2Armd");

var $JHxCO = parcelRequire("JHxCO");

var $g9kBK = parcelRequire("g9kBK");

var $88a5z = parcelRequire("88a5z");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $23er7 = parcelRequire("23er7");

var $g8uYY = parcelRequire("g8uYY");

var $5L7qx = parcelRequire("5L7qx");

var $7jTnu = parcelRequire("7jTnu");

var $4sBtm = parcelRequire("4sBtm");
const $5eea8950f1d4bbd6$var$projectSettingsServicedeskUnassignedTicketTypesConfigPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $23er7.TicketTypesConfigEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $5eea8950f1d4bbd6$export$6ba31a548ab77c4 = (0, $6xToB.createEntry)((0, $88a5z.projectSettingsServicedeskUnassignedTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4sBtm.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $JHxCO.servicedeskPracticesResource),
            (0, $kEdwd.servicedeskIssueTypesResource),
            (0, $2Armd.servicedeskPortalGroupsResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('remove_repackaging_banner_for_change'), (0, $ksbf6.jsmRepackagingBannerResource)),
            (0, $g9kBK.featuresResource)
        ],
        entryPoint () {
            return $5eea8950f1d4bbd6$var$projectSettingsServicedeskUnassignedTicketTypesConfigPageEntrypoint;
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4sBtm.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration'
    }));

});

parcelRegister("jxIae", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskWidgetRouteEntry", () => $9a9ed069fc4c7c1a$export$d86db47c21552ca);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $ihecD = parcelRequire("ihecD");

var $aQoXd = parcelRequire("aQoXd");

var $9btIX = parcelRequire("9btIX");
const $9a9ed069fc4c7c1a$export$d86db47c21552ca = (0, $6xToB.createEntry)((0, $ihecD.projectSettingsServicedeskWidgetRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $9btIX.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9btIX.LazyProjectSettingsServiceDeskWidgetSettings)
        ]
    }));

});

parcelRegister("19r4K", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRedirectRouteEntry", () => $eca8b990e5d6e664$export$99415df4033272f);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $AmstK = parcelRequire("AmstK");

var $8FCAy = parcelRequire("8FCAy");

var $a0ftS = parcelRequire("a0ftS");

var $5JAAk = parcelRequire("5JAAk");
const $eca8b990e5d6e664$export$99415df4033272f = (0, $6xToB.createEntry)((0, $AmstK.projectSettingsSoftwareAccessRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $a0ftS.peopleAccessRedirect)(`/jira/${(0, $5JAAk.SOFTWARE_PRODUCT)}`),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $a0ftS.LazyPeopleSettings)
        ]
    }));

});
parcelRegister("AmstK", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRedirectRoute", () => $a21d00e6cb269a17$export$55335c81a2be4654);
const $a21d00e6cb269a17$export$55335c81a2be4654 = {
    name: 'project-settings-software-access-redirect',
    path: '/jira/software/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("a0ftS", function(module, exports) {

$parcel$export(module.exports, "LazyPeopleSettings", () => $0e1df35189c810eb$export$7eee4f97b7a1273);
$parcel$export(module.exports, "peopleAccessRedirect", () => $0e1df35189c810eb$export$45346ed2aa24e3f3);
$parcel$export(module.exports, "default", () => $0e1df35189c810eb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $2mHfh = parcelRequire("2mHfh");

const $0e1df35189c810eb$export$7eee4f97b7a1273 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3EK91"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $0e1df35189c810eb$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
const $0e1df35189c810eb$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0e1df35189c810eb$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e1df35189c810eb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $0e1df35189c810eb$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });

});


parcelRegister("1Dztl", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRouteEntry", () => $add8e9c5eb5c357d$export$a5ead9d0de14b14b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $itaVS = parcelRequire("itaVS");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $a0ftS = parcelRequire("a0ftS");

var $5JAAk = parcelRequire("5JAAk");
const $add8e9c5eb5c357d$export$a5ead9d0de14b14b = (0, $6xToB.createEntry)((0, $itaVS.projectSettingsSoftwareAccessRoute), ()=>({
        group: 'project-settings-software',
        skeleton: (0, $bmwpE.ProjectSettingsAccessSkeleton),
        component: (0, $a0ftS.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $a0ftS.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access'
    }));

});
parcelRegister("itaVS", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRoute", () => $e7e217966d5db1d1$export$db689602f90567d8);
const $e7e217966d5db1d1$export$db689602f90567d8 = {
    name: 'project-settings-software-access',
    path: '/jira/software/projects/:projectKey/settings/access',
    exact: true
};

});


parcelRegister("1O3Ea", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsFieldsRouteEntry", () => $1effd20da3507d2b$export$78d9c4be1503dd23);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $j9joM = parcelRequire("j9joM");

var $8FCAy = parcelRequire("8FCAy");

var $44K8H = parcelRequire("44K8H");

var $5JAAk = parcelRequire("5JAAk");
const $1effd20da3507d2b$export$78d9c4be1503dd23 = (0, $6xToB.createEntry)((0, $j9joM.projectSettingsSoftwareAppsFieldsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $44K8H.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $44K8H.LazyConnectAppControlsSettings)
        ]
    }));

});
parcelRegister("j9joM", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsFieldsRoute", () => $e7281b621552f46e$export$333c94a9ec1a1535);
const $e7281b621552f46e$export$333c94a9ec1a1535 = {
    name: 'project-settings-software-apps-fields',
    path: '/jira/software/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("44K8H", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppControlsSettings", () => $56bfed5227fc70c1$export$246ec9cdadd2a163);
$parcel$export(module.exports, "default", () => $56bfed5227fc70c1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $2aY2d = parcelRequire("2aY2d");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $2mHfh = parcelRequire("2mHfh");

var $khcdw = parcelRequire("khcdw");

const $56bfed5227fc70c1$export$246ec9cdadd2a163 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("d6Phh"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $56bfed5227fc70c1$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT);
    return shouldRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
        push: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $khcdw.default), null);
};
const $56bfed5227fc70c1$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($56bfed5227fc70c1$var$ConnectAppsRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$56bfed5227fc70c1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $56bfed5227fc70c1$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });

});
parcelRegister("khcdw", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef50f029507b500$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $fef50f029507b500$export$fa3bc297af95f169 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ii4yz"))), {
    moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fef50f029507b500$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fef50f029507b500$export$fa3bc297af95f169,
        pageId: "project-settings-app-discovery-settings",
        shouldShowSpinner: false
    });

});



parcelRegister("e9Gfy", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsRouteEntry", () => $a5684f9b54699d69$export$290fcdffa80c48ce);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9sw1i = parcelRequire("9sw1i");

var $8FCAy = parcelRequire("8FCAy");

var $aoTfc = parcelRequire("aoTfc");

var $5JAAk = parcelRequire("5JAAk");
const $a5684f9b54699d69$export$290fcdffa80c48ce = (0, $6xToB.createEntry)((0, $9sw1i.projectSettingsSoftwareAppsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $aoTfc.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $aoTfc.LazyConnectAppsSettings)
        ]
    }));

});
parcelRegister("9sw1i", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsRoute", () => $9d5f34930bd0eff8$export$aece357f5f434121);
const $9d5f34930bd0eff8$export$aece357f5f434121 = {
    name: 'project-settings-software-apps',
    path: '/jira/software/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("aoTfc", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppsSettings", () => $52a3e6213c7bbeb6$export$3633e017e520a1c2);
$parcel$export(module.exports, "default", () => $52a3e6213c7bbeb6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $52a3e6213c7bbeb6$export$3633e017e520a1c2 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ik609"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$52a3e6213c7bbeb6$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $52a3e6213c7bbeb6$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });

});


parcelRegister("7RDKl", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAutomationRouteEntry", () => $1ce021a445899fcc$export$fb1f0477184046c5);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $drvCc = parcelRequire("drvCc");

var $8FCAy = parcelRequire("8FCAy");

var $ciVnR = parcelRequire("ciVnR");

var $5JAAk = parcelRequire("5JAAk");
const $1ce021a445899fcc$export$fb1f0477184046c5 = (0, $6xToB.createEntry)((0, $drvCc.projectSettingsSoftwareAutomationRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $ciVnR.default),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ciVnR.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("drvCc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAutomationRoute", () => $bdbd1f967e44e700$export$4d430aeb28b702f8);
const $bdbd1f967e44e700$export$4d430aeb28b702f8 = {
    name: 'project-settings-software-automation',
    path: '/jira/software/projects/:projectKey/settings/automation',
    exact: true
};

});


parcelRegister("b2ykh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCardRouteEntry", () => $666732fd1f3bb024$export$ca616a5516b2e16d);

var $bJys3 = parcelRequire("bJys3");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $2OwuX = parcelRequire("2OwuX");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $9100b = parcelRequire("9100b");
const $666732fd1f3bb024$export$ca616a5516b2e16d = (0, $6xToB.createEntry)((0, $2OwuX.projectSettingsSoftwareBoardsCardRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'board-settings-apps.card-cover-settings-page.page.load',
        component: (0, $9100b.default),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            (0, $bJys3.cardCoverImageResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9100b.LazyCard)
        ]
    }));

});
parcelRegister("bJys3", function(module, exports) {

$parcel$export(module.exports, "cardCoverImageResource", () => $301eb09024ad04bd$export$f37f52e28126ce75);

var $8oKDI = parcelRequire("8oKDI");

var $9FYIg = parcelRequire("9FYIg");

var $6VFcr = parcelRequire("6VFcr");
const $301eb09024ad04bd$var$RESOURCE_TYPE_BOARD_CONTEXT_CARD_COVER_SETTINGS = 'BOARD_CONTEXT_CARD_COVER_SETTINGS';
const $301eb09024ad04bd$export$f37f52e28126ce75 = (0, $9FYIg.createRelayResource)({
    type: $301eb09024ad04bd$var$RESOURCE_TYPE_BOARD_CONTEXT_CARD_COVER_SETTINGS,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $6VFcr.default),
            variables: {
                boardId: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("6VFcr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a982ebc202c5c83f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<969e874277a66b3f3af366fa762020d3>>
 * @relayHash 08ce84df83c28ee942e51d34169f573a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2d04f5e5da3c02e9a79c38c18f4b771230dd112adb2c02e86bb4923ba883d7c7
const $a982ebc202c5c83f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cardCoverSettingsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "toggle_ProjectSettingsBoardSettingsCard_CardCoverToggle"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "cardPreview_ProjectSettingsBoardSettingsCard"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cardCoverSettingsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CardMediaConfig",
                                    "kind": "LinkedField",
                                    "name": "cardMedia",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "2d04f5e5da3c02e9a79c38c18f4b771230dd112adb2c02e86bb4923ba883d7c7",
            "metadata": {},
            "name": "cardCoverSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a982ebc202c5c83f$var$node.hash = "0a38c0557dcf4e2928b9bc164b447b32";
var $a982ebc202c5c83f$export$2e2bcd8739ae039 = $a982ebc202c5c83f$var$node;

});


parcelRegister("2OwuX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCardRoute", () => $06c755143651aab7$export$d3f185a361401db7);
const $06c755143651aab7$export$d3f185a361401db7 = {
    name: 'project-settings-software-boards-card',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/card',
    exact: true
};

});

parcelRegister("9100b", function(module, exports) {

$parcel$export(module.exports, "LazyCard", () => $611ba7f62ba67427$export$40ff283c032abbc4);
$parcel$export(module.exports, "default", () => $611ba7f62ba67427$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $611ba7f62ba67427$export$40ff283c032abbc4 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("9gt2o")), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/card/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$611ba7f62ba67427$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $611ba7f62ba67427$export$40ff283c032abbc4,
        pageId: "board-settings-card",
        shouldShowSpinner: false
    });

});
parcelRegister("9gt2o", function(module, exports) {

let $6bec21f7894395c0$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("aji5X"), 4)),
    $6bec21f7894395c0$var$load("48QW0")
]).then(()=>parcelRequire('hCcnT'));

});



parcelRegister("g8YQf", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCsmRouteEntry", () => $f3a6a68938c61a15$export$7a31e42733ba05a0);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $eSDVj = parcelRequire("eSDVj");

var $8FCAy = parcelRequire("8FCAy");

var $bKZ40 = parcelRequire("bKZ40");

var $5JAAk = parcelRequire("5JAAk");
const $f3a6a68938c61a15$export$7a31e42733ba05a0 = (0, $6xToB.createEntry)((0, $eSDVj.projectSettingsSoftwareBoardsCsmRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'software.next-gen.boards.column-status-mapping.page.load',
        component: (0, $bKZ40.default),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bKZ40.LazyCsmSettings)
        ]
    }));

});
parcelRegister("eSDVj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCsmRoute", () => $7fec64f300556675$export$88e68eb447e3db49);
const $7fec64f300556675$export$88e68eb447e3db49 = {
    name: 'project-settings-software-boards-csm',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/columns',
    exact: true
};

});

parcelRegister("bKZ40", function(module, exports) {

$parcel$export(module.exports, "LazyCsmSettings", () => $8bd9f312c30150fe$export$de293ea44d0410ca);
$parcel$export(module.exports, "default", () => $8bd9f312c30150fe$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $8bd9f312c30150fe$export$de293ea44d0410ca = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("aCeiq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/csm/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8bd9f312c30150fe$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8bd9f312c30150fe$export$de293ea44d0410ca,
        pageId: "project-settings-csm",
        shouldShowSpinner: false
    });

});
parcelRegister("aCeiq", function(module, exports) {

let $7ba88ae757c47df6$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("59MG8"), 4)),
    $7ba88ae757c47df6$var$load("4hsIv")
]).then(()=>parcelRequire('gCEEF'));

});



parcelRegister("4OHhm", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCustomFiltersRouteEntry", () => $a3b688a9312ca1b4$export$6332ad3e1d8d721);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $loMw1 = parcelRequire("loMw1");

var $6xToB = parcelRequire("6xToB");

var $d257s = parcelRequire("d257s");

var $8FCAy = parcelRequire("8FCAy");

var $9bYiw = parcelRequire("9bYiw");

var $5JAAk = parcelRequire("5JAAk");
const $a3b688a9312ca1b4$export$6332ad3e1d8d721 = (0, $6xToB.createEntry)((0, $d257s.projectSettingsSoftwareBoardsCustomFiltersRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.custom-filters',
        component: (0, $9bYiw.default),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            (0, $loMw1.customFiltersResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9bYiw.LazyCustomFiltersSettings)
        ]
    }));

});
parcelRegister("loMw1", function(module, exports) {

$parcel$export(module.exports, "customFiltersResource", () => $2d786cc182460e02$export$3e390340716755de);

var $8oKDI = parcelRequire("8oKDI");

var $9FYIg = parcelRequire("9FYIg");

var $bLayR = parcelRequire("bLayR");
const $2d786cc182460e02$var$RESOURCE_TYPE_NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS = 'NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS';
const $2d786cc182460e02$export$3e390340716755de = (0, $9FYIg.createRelayResource)({
    type: $2d786cc182460e02$var$RESOURCE_TYPE_NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $bLayR.default),
            variables: {
                boardId: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("bLayR", function(module, exports) {

$parcel$export(module.exports, "default", () => $201761e473d963c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c655bf5d42bc04990088e48dc6b757f>>
 * @relayHash 82ae1b9c2b4e7b31e211094a4e3f4f3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686
const $201761e473d963c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "customFiltersQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CustomFilter",
                                    "kind": "LinkedField",
                                    "name": "customFilters",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "card_projectSettingsCustomFilters_customFilterFragmentRef"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.customFilters"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "card_projectSettingsCustomFilters_boardScopeFragmentRef"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "expandedCard_projectSettingsCustomFilters_boardScopeFragmentRef"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "customFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "FilterQuery",
                                    "kind": "LinkedField",
                                    "name": "filterQuery",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "sanitisedJql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errors"
                                        }
                                    ]
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686",
            "metadata": {},
            "name": "customFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$201761e473d963c4$var$node.hash = "2c5c0d030a87f3820766a2a896d71275";
var $201761e473d963c4$export$2e2bcd8739ae039 = $201761e473d963c4$var$node;

});


parcelRegister("d257s", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCustomFiltersRoute", () => $d41829c4c2ebff91$export$9bc9b345958a301c);
const $d41829c4c2ebff91$export$9bc9b345958a301c = {
    name: 'project-settings-software-boards-custom-filters',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/custom-filters',
    exact: true
};

});

parcelRegister("9bYiw", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFiltersSettings", () => $9912f484a3377ff4$export$7e21d36a9d4548e6);
$parcel$export(module.exports, "default", () => $9912f484a3377ff4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $9912f484a3377ff4$export$7e21d36a9d4548e6 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("izMDC")), {
    moduleId: "./src/packages/spa-apps/project-settings/custom-filters/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9912f484a3377ff4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $9912f484a3377ff4$export$7e21d36a9d4548e6,
        pageId: "project-settings-custom-filters",
        shouldShowSpinner: true
    });

});
parcelRegister("izMDC", function(module, exports) {

let $d8613965037091bd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d8613965037091bd$var$load("fjuzk").then(()=>parcelRequire('fx0K9'));

});



parcelRegister("3qny0", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRedirectRouteEntry", () => $eda55a7d7f657a4e$export$cb6169207ddfd1b2);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $7uOHY = parcelRequire("7uOHY");

var $8FCAy = parcelRequire("8FCAy");

var $bMm2d = parcelRequire("bMm2d");

var $5JAAk = parcelRequire("5JAAk");
const $eda55a7d7f657a4e$export$cb6169207ddfd1b2 = (0, $6xToB.createEntry)((0, $7uOHY.projectSettingsSoftwareBoardsRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bMm2d.BoardSettingsRedirectToCSM),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        isRedirect: true,
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("7uOHY", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRedirectRoute", () => $12f7b3f7e0482667$export$989ca67485551616);
const $12f7b3f7e0482667$export$989ca67485551616 = {
    name: 'project-settings-software-boards-redirect',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId',
    exact: true
};

});


parcelRegister("yk8YA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRoadmapRouteEntry", () => $3a766fb49c8d76d3$export$6d5eadd440c430f5);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6ZOOP = parcelRequire("6ZOOP");

var $aQRnD = parcelRequire("aQRnD");

var $8FCAy = parcelRequire("8FCAy");

var $bMm2d = parcelRequire("bMm2d");

var $5JAAk = parcelRequire("5JAAk");

var $eawym = parcelRequire("eawym");
const $3a766fb49c8d76d3$export$6d5eadd440c430f5 = (0, $6xToB.createEntry)((0, $aQRnD.projectSettingsSoftwareBoardsRoadmapRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bMm2d.RoadmapSettingsRedirectToTimelineSettings),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            (0, $6ZOOP.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $eawym.LazyRoadmap)
        ]
    }));

});
parcelRegister("6ZOOP", function(module, exports) {

$parcel$export(module.exports, "roadmapSettingsResource", () => $1e1651d8dbf744cf$export$7901a008bd73bf46);

var $8oKDI = parcelRequire("8oKDI");

var $9FYIg = parcelRequire("9FYIg");

var $k4wWt = parcelRequire("k4wWt");

const $1e1651d8dbf744cf$export$7901a008bd73bf46 = (0, $9FYIg.createRelayResource)({
    type: (0, $0a39a0a4006d2a49$export$e905b9170ecbb599),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $k4wWt.default),
            variables: {
                sourceAri: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                locationAri: undefined
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});

});
parcelRegister("k4wWt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f06e34294c6cea81$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<91c3fe6da3422150de0aefeb3da83b59>>
 * @relayHash cc70f886f5a48b398b5cdf75569624df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aae74ae245fd023e08e32b9c46ad237f06b6fe19c628a5c9b488472e2beb3cf2
const $f06e34294c6cea81$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locationAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "locationARI",
            "variableName": "locationAri"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isSprintsFeatureEnabled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "roadmapSettingsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "RoadmapConfiguration",
                                        "kind": "LinkedField",
                                        "name": "roadmapConfiguration",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "RoadmapBoardConfiguration",
                                                    "kind": "LinkedField",
                                                    "name": "boardConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "childIssuesSchedulingToggle_ProjectSettingsBoardSettingsRoadmap"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "childIssuesSchedulingPreview_ProjectSettingsBoardSettingsRoadmap"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapForSource.roadmapConfiguration.boardConfiguration"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapForSource.roadmapConfiguration"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "roadmapSettingsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "RoadmapConfiguration",
                                    "kind": "LinkedField",
                                    "name": "roadmapConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "RoadmapBoardConfiguration",
                                            "kind": "LinkedField",
                                            "name": "boardConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isChildIssuePlanningEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "childIssuePlanningMode"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "aae74ae245fd023e08e32b9c46ad237f06b6fe19c628a5c9b488472e2beb3cf2",
            "metadata": {},
            "name": "roadmapSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f06e34294c6cea81$var$node.hash = "9114fac2c709c65b2d6e748af5f3fc01";
var $f06e34294c6cea81$export$2e2bcd8739ae039 = $f06e34294c6cea81$var$node;

});

const $0a39a0a4006d2a49$export$75dfa03544a19422 = 'ROADMAP';
const $0a39a0a4006d2a49$export$e3b1cd17bd82de3d = 'CLASSIC_ROADMAP';
const $0a39a0a4006d2a49$export$e905b9170ecbb599 = 'BOARD_CONTEXT_ROADMAP_SETTINGS';


parcelRegister("aQRnD", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRoadmapRoute", () => $0bdf58350e54cd01$export$17ccdaa366ec26b8);
const $0bdf58350e54cd01$export$17ccdaa366ec26b8 = {
    name: 'project-settings-software-boards-roadmap',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/roadmap',
    exact: true
};

});

parcelRegister("eawym", function(module, exports) {

$parcel$export(module.exports, "LazyRoadmap", () => $90a67a71c73c441d$export$8eca5454e72ee961);
$parcel$export(module.exports, "default", () => $90a67a71c73c441d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $7jTnu = parcelRequire("7jTnu");

var $hWeHP = parcelRequire("hWeHP");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $90a67a71c73c441d$export$8eca5454e72ee961 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("7xvjV")), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/roadmap/src/index.tsx"
});
const $90a67a71c73c441d$var$AsyncProjectSettingsRoadmap = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "project-settings.roadmap",
        teamName: "chronos",
        attributes: {
            isSynthetic: (0, $7jTnu.fg)('is_synthetic_tenant') || (0, $hWeHP.default)('ajs-is-synthetic') === 'true'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $90a67a71c73c441d$export$8eca5454e72ee961,
        pageId: "board-settings-roadmap",
        shouldShowSpinner: false
    }));
var $90a67a71c73c441d$export$2e2bcd8739ae039 = $90a67a71c73c441d$var$AsyncProjectSettingsRoadmap;

});
parcelRegister("7xvjV", function(module, exports) {

let $57d3e90d21d4fc8f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $57d3e90d21d4fc8f$var$load("319lD").then(()=>parcelRequire('lGnF5'));

});



parcelRegister("kt0QB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsTimelineRouteEntry", () => $785be944363ad166$export$cc224b8b7595975b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6ZOOP = parcelRequire("6ZOOP");

var $fsWIZ = parcelRequire("fsWIZ");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $eawym = parcelRequire("eawym");
const $785be944363ad166$export$cc224b8b7595975b = (0, $6xToB.createEntry)((0, $fsWIZ.projectSettingsSoftwareBoardsTimelineRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'board-settings-apps.roadmap-settings-page.page.load',
        component: (0, $eawym.default),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            (0, $6ZOOP.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $eawym.LazyRoadmap)
        ]
    }));

});
parcelRegister("fsWIZ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsTimelineRoute", () => $e470e87a8e8934bd$export$e116d6b2a5f71426);
const $e470e87a8e8934bd$export$e116d6b2a5f71426 = {
    name: 'project-settings-software-boards-timeline',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/timeline',
    exact: true
};

});


parcelRegister("9oXBQ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDataClassificationsRouteEntry", () => $d02aad3df65bde67$export$cc932462de184b27);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $7HkyI = parcelRequire("7HkyI");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $8sWTO = parcelRequire("8sWTO");

var $5JAAk = parcelRequire("5JAAk");
const $d02aad3df65bde67$export$cc932462de184b27 = (0, $6xToB.createEntry)((0, $7HkyI.projectSettingsSoftwareDataClassificationsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $8sWTO.default),
        skeleton: (0, $bmwpE.ProjectSettingsDetailsSkeleton),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8sWTO.LazyDataClassificationsSettings)
        ]
    })); /**
 * Contains all software settings routes using the new url format `jira/:product/projects/:projectKey/settings`.
 */ 

});
parcelRegister("7HkyI", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDataClassificationsRoute", () => $ddb54c51bf5075f2$export$af525a8f93b72cc7);
const $ddb54c51bf5075f2$export$af525a8f93b72cc7 = {
    name: 'project-settings-software-data-classifications',
    path: '/jira/software/projects/:projectKey/settings/data-classifications',
    exact: true
};

});

parcelRegister("8sWTO", function(module, exports) {

$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $4cb7d7173ce2f963$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $4cb7d7173ce2f963$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $4cb7d7173ce2f963$export$b8abcf8aa8f4df56 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bzxaI"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4cb7d7173ce2f963$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4cb7d7173ce2f963$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });

});


parcelRegister("iBuWD", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDetailsRouteEntry", () => $b8ef082464936346$export$8440d3384846d9b8);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $bKD4m = parcelRequire("bKD4m");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $fLSSb = parcelRequire("fLSSb");

var $5JAAk = parcelRequire("5JAAk");
const $b8ef082464936346$export$8440d3384846d9b8 = (0, $6xToB.createEntry)((0, $bKD4m.projectSettingsSoftwareDetailsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $fLSSb.default),
        skeleton: (0, $bmwpE.ProjectSettingsDetailsSkeleton),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fLSSb.LazyDetailsSettings)
        ]
    }));

});
parcelRegister("bKD4m", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDetailsRoute", () => $490c2fcd02ca458b$export$8760347e2b0955eb);
const $490c2fcd02ca458b$export$8760347e2b0955eb = {
    name: 'project-settings-software-details',
    path: '/jira/software/projects/:projectKey/settings/details',
    exact: true
};

});


parcelRegister("jLhoT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareFieldsRouteEntry", () => $a203c8909d07104c$export$e6b200b5a1ce3063);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $uKS5x = parcelRequire("uKS5x");

var $8lV5C = parcelRequire("8lV5C");

var $8FCAy = parcelRequire("8FCAy");

var $3uXSV = parcelRequire("3uXSV");

var $5JAAk = parcelRequire("5JAAk");
const $a203c8909d07104c$export$e6b200b5a1ce3063 = (0, $6xToB.createEntry)((0, $8lV5C.projectSettingsSoftwareFieldsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.fields.jsw-tmp',
        component: (0, $3uXSV.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            (0, $uKS5x.fieldSettingsRelayResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3uXSV.LazyFieldsSettings)
        ]
    }));

});
parcelRegister("8lV5C", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareFieldsRoute", () => $810a57ebc01fe683$export$1ab9d3299fbc789b);
const $810a57ebc01fe683$export$1ab9d3299fbc789b = {
    name: 'project-settings-software-fields',
    path: '/jira/software/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("3uXSV", function(module, exports) {

$parcel$export(module.exports, "LazyFieldsSettings", () => $785e1d3d8e053734$export$e309780f520d125a);
$parcel$export(module.exports, "default", () => $785e1d3d8e053734$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $785e1d3d8e053734$export$e309780f520d125a = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5j1d4"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$785e1d3d8e053734$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $785e1d3d8e053734$export$e309780f520d125a,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });

});


parcelRegister("6Lgr4", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesRouteEntry", () => $1ad80e164a5cc198$export$84a9a2dce32d93aa);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $jnN0b = parcelRequire("jnN0b");

var $8FCAy = parcelRequire("8FCAy");

var $bMm2d = parcelRequire("bMm2d");

var $jCMY4 = parcelRequire("jCMY4");

var $5JAAk = parcelRequire("5JAAk");
const $1ad80e164a5cc198$export$84a9a2dce32d93aa = (0, $6xToB.createEntry)((0, $jnN0b.projectSettingsSoftwareIssuetypesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: (0, $bMm2d.getUFOName)('project-settings-software-issuetypes'),
        component: (0, $jCMY4.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jCMY4.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("jnN0b", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesRoute", () => $e7dc23b1c11a2277$export$7f26edefe51efc38);
const $e7dc23b1c11a2277$export$7f26edefe51efc38 = {
    name: 'project-settings-software-issuetypes',
    path: '/jira/software/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});

parcelRegister("jCMY4", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSettings", () => $916c97ed5e1b51e8$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $916c97ed5e1b51e8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $916c97ed5e1b51e8$export$36dcfb52d47cb93a = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2Qznj"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$916c97ed5e1b51e8$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $916c97ed5e1b51e8$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

});


parcelRegister("4KZfr", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesWorkflowRouteEntry", () => $a6f8dfb78aaaa30a$export$58ca33ed538911cb);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $8QFYS = parcelRequire("8QFYS");

var $8FCAy = parcelRequire("8FCAy");

var $7K5Ea = parcelRequire("7K5Ea");

var $epTsa = parcelRequire("epTsa");

var $jCMY4 = parcelRequire("jCMY4");

var $5JAAk = parcelRequire("5JAAk");

var $7vZpL = parcelRequire("7vZpL");
const $a6f8dfb78aaaa30a$export$58ca33ed538911cb = (0, $6xToB.createEntry)((0, $8QFYS.projectSettingsSoftwareIssuetypesWorkflowRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $7vZpL.default),
        layout: (0, $epTsa.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_software', 'isEnabled', true, false) ? (0, $7K5Ea.chromelessLayout) : (0, $8FCAy.softwareProjectLayout),
        navigation: (0, $epTsa.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_software', 'isEnabled', true, false) ? undefined : {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: (0, $epTsa.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_software', 'isEnabled', true, false) ? undefined : [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: (0, $epTsa.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_software', 'isEnabled', true, false) ? [
            (0, $7vZpL.LazyWorkflowNavigationSettings)
        ] : [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jCMY4.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("8QFYS", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesWorkflowRoute", () => $34f017735b7c24ba$export$de010d824a551ec);
const $34f017735b7c24ba$export$de010d824a551ec = {
    name: 'project-settings-software-issuetypes-workflow',
    path: '/jira/software/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("7vZpL", function(module, exports) {

$parcel$export(module.exports, "LazyWorkflowNavigationSettings", () => $d3ed430bfe6130b8$export$cb608e3696682e76);
$parcel$export(module.exports, "default", () => $d3ed430bfe6130b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $d3ed430bfe6130b8$export$cb608e3696682e76 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("gr4id"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d3ed430bfe6130b8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d3ed430bfe6130b8$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });

});


parcelRegister("b7rZt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNextGenFeaturesRouteEntry", () => $00b85432d35f8347$export$81067f5196099c81);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $jQLrI = parcelRequire("jQLrI");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $13jD0 = parcelRequire("13jD0");

var $5JAAk = parcelRequire("5JAAk");
const $00b85432d35f8347$export$81067f5196099c81 = (0, $6xToB.createEntry)((0, $jQLrI.projectSettingsSoftwareNextGenFeaturesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.next-gen-features',
        component: (0, $13jD0.default),
        skeleton: (0, $bmwpE.ProjectSettingsFeaturesSkeleton),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $13jD0.LazyFeaturesSettings)
        ]
    }));

});
parcelRegister("jQLrI", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNextGenFeaturesRoute", () => $ec992699611d5646$export$12c7a1737b594a28);
const $ec992699611d5646$export$12c7a1737b594a28 = {
    name: 'project-settings-software-next-gen-features',
    path: '/jira/software/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("13jD0", function(module, exports) {

$parcel$export(module.exports, "LazyFeaturesSettings", () => $69ea107c6d51ec4d$export$da4d608b99858bfc);
$parcel$export(module.exports, "default", () => $69ea107c6d51ec4d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $69ea107c6d51ec4d$export$da4d608b99858bfc = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fKK5h"))), {
    moduleId: "./src/packages/spa-apps/project-settings/next-gen-features/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$69ea107c6d51ec4d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $69ea107c6d51ec4d$export$da4d608b99858bfc,
        pageId: "project-settings-next-gen-features",
        shouldShowSpinner: false
    });

});
parcelRegister("fKK5h", function(module, exports) {

let $b77ee63ab0248750$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b77ee63ab0248750$var$load("afCvp").then(()=>parcelRequire('1BNgi'));

});



parcelRegister("5QSRE", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailCRouteEntry", () => $0617eba4efbb02c5$export$9bb08b8e1b39d15f);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $1ra19 = parcelRequire("1ra19");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $gJ40u = parcelRequire("gJ40u");

var $jjUOC = parcelRequire("jjUOC");
const $0617eba4efbb02c5$export$9bb08b8e1b39d15f = (0, $6xToB.createEntry)((0, $1ra19.projectSettingsSoftwareNotificationEmailCRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $gJ40u.default),
        skeleton: (0, $bmwpE.ProjectSettingsFeaturesSkeleton),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jjUOC.LazySoftwareClassicFeatures),
            (0, $gJ40u.LazyProjectSettingsNotificationEmail)
        ]
    }));

});
parcelRegister("1ra19", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailCRoute", () => $fb17ec44a0198b81$export$dda91725b6c4a039);
const $fb17ec44a0198b81$export$dda91725b6c4a039 = {
    name: 'project-settings-software-notifications-notification-email',
    path: '/jira/software/c/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("gJ40u", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsNotificationEmail", () => $1f720ecbed768347$export$ea7d73c94d9369f4);
$parcel$export(module.exports, "default", () => $1f720ecbed768347$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $1f720ecbed768347$export$ea7d73c94d9369f4 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fmrQC"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f720ecbed768347$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1f720ecbed768347$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });

});


parcelRegister("02HAY", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailRouteEntry", () => $b87adc14f724cc9c$export$8a17783c300fca11);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $i15aR = parcelRequire("i15aR");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");
const $b87adc14f724cc9c$export$8a17783c300fca11 = (0, $6xToB.createEntry)((0, $i15aR.projectSettingsSoftwareNotificationEmailRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $5JAAk.RedirectForSettings),
        skeleton: (0, $bmwpE.ProjectSettingsFeaturesSkeleton),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("i15aR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailRoute", () => $7c32d89ec3bc10b2$export$d4ed083331cb6e00);
const $7c32d89ec3bc10b2$export$d4ed083331cb6e00 = {
    name: 'project-settings-software-notifications-notification-email',
    path: '/jira/software/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});


parcelRegister("9QPcQ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsIssueLogsRouteEntry", () => $639b4a3511d27c69$export$9c37d834dfe46ebf);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $7bWyj = parcelRequire("7bWyj");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $6qzZB = parcelRequire("6qzZB");
const $639b4a3511d27c69$export$9c37d834dfe46ebf = (0, $6xToB.createEntry)((0, $7bWyj.projectSettingsSoftwareNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.software.notifications.issue-logs',
        component: (0, $6qzZB.SoftwareNotificationsIssueLogs),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6qzZB.LazySoftwareNotificationsIssueLogs)
        ],
        entryPoint () {
            return 0, $6qzZB.emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("7bWyj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsIssueLogsRoute", () => $e867f382a48cf966$export$ff4977f79c273b29);
const $e867f382a48cf966$export$ff4977f79c273b29 = {
    name: 'project-settings-software-notifications-issue-logs',
    path: '/jira/software/projects/:projectKey/settings/notifications/issue-logs',
    exact: true
};

});


parcelRegister("aZHdl", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsRouteEntry", () => $96cd91e79e45713e$export$1c340fa0c9022252);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $aftFt = parcelRequire("aftFt");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $1eXWM = parcelRequire("1eXWM");
const $96cd91e79e45713e$export$1c340fa0c9022252 = (0, $6xToB.createEntry)((0, $aftFt.projectSettingsSoftwareNotificationsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.software.notifications',
        component: (0, $1eXWM.default),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1eXWM.LazySoftwareNotificationsSettings)
        ]
    }));

});
parcelRegister("aftFt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsRoute", () => $c245d986ac8e7a90$export$c1d1892d6c07135a);
const $c245d986ac8e7a90$export$c1d1892d6c07135a = {
    name: 'project-settings-software-notifications',
    path: '/jira/software/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("1eXWM", function(module, exports) {

$parcel$export(module.exports, "LazySoftwareNotificationsSettings", () => $b2e1837ea41236f8$export$69a64a29d67ca160);
$parcel$export(module.exports, "default", () => $b2e1837ea41236f8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $b2e1837ea41236f8$export$69a64a29d67ca160 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bSbty"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b2e1837ea41236f8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $b2e1837ea41236f8$export$69a64a29d67ca160,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });

});


parcelRegister("307rd", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaJiraFormBuilderRouteEntry", () => $5f27c05213b316f7$export$5606059eca31e30);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4tyo9 = parcelRequire("4tyo9");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $flSSv = parcelRequire("flSSv");
const $5f27c05213b316f7$export$5606059eca31e30 = (0, $6xToB.createEntry)((0, $4tyo9.projectSettingsSoftwareProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $flSSv.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $flSSv.LazyProjectSettingsProformaJiraFormBuilder)
        ],
        perfMetricKey: 'form-builder'
    }));

});
parcelRegister("4tyo9", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaJiraFormBuilderRoute", () => $dfd34dc3ad1ed90f$export$cf33294d9d90a855);
const $dfd34dc3ad1ed90f$export$cf33294d9d90a855 = {
    name: 'project-settings-software-proforma-jira-form-builder',
    path: '/jira/software/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});


parcelRegister("cLEqv", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaProjectFormsRouteEntry", () => $25fd5a8e3e282347$export$ea77a3e974b26072);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $f4LUQ = parcelRequire("f4LUQ");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $7BRGK = parcelRequire("7BRGK");
const $25fd5a8e3e282347$export$ea77a3e974b26072 = (0, $6xToB.createEntry)((0, $f4LUQ.projectSettingsSoftwareProformaProjectFormsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $7BRGK.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7BRGK.LazyProjectSettingsProformaProjectForms)
        ],
        perfMetricKey: 'forms-settings'
    }));

});
parcelRegister("f4LUQ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaProjectFormsRoute", () => $088fd1a233d3dadb$export$750dec948cc98062);
const $088fd1a233d3dadb$export$750dec948cc98062 = {
    name: 'project-settings-software-proforma-project-forms',
    path: '/jira/software/projects/:projectKey/settings/forms',
    exact: true
};

});


parcelRegister("i0o2E", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareRedirectRouteEntry", () => $c18db11c05ae7c88$export$e5caf0892d6025c9);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $4HwCR = parcelRequire("4HwCR");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");
const $c18db11c05ae7c88$export$e5caf0892d6025c9 = (0, $6xToB.createEntry)((0, $4HwCR.projectSettingsSoftwareRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $5JAAk.RedirectForSettings),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("4HwCR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareRedirectRoute", () => $c0df11c9b0223c6f$export$168cc8ed4398c230);
const $c0df11c9b0223c6f$export$168cc8ed4398c230 = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    name: 'project-settings-software-redirect',
    path: '/jira/software/projects/:projectKey/settings'
};

});


parcelRegister("fQjCK", function(module, exports) {

$parcel$export(module.exports, "projectSettingsToolchainRouteEntry", () => $051f64e1870b7ff1$export$dd97d29f96b25d09);

var $kHlOR = parcelRequire("kHlOR");

var $6qDrV = parcelRequire("6qDrV");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $aaqFB = parcelRequire("aaqFB");

var $9BJU1 = parcelRequire("9BJU1");

var $bDouB = parcelRequire("bDouB");

var $jom8W = parcelRequire("jom8W");

var $8FCAy = parcelRequire("8FCAy");

var $1a7Aj = parcelRequire("1a7Aj");

var $5JAAk = parcelRequire("5JAAk");
const $051f64e1870b7ff1$export$dd97d29f96b25d09 = (0, $6xToB.createEntry)((0, $bDouB.projectSettingsToolchainRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $6qDrV.default)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $1a7Aj.default)),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            (0, $aaqFB.projectSettingsToolchainResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1a7Aj.LazyDevOpsConnectionsSettings)
        ],
        ufoName: 'project-settings.devops-connections'
    }));

});
parcelRegister("bDouB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsToolchainRoute", () => $15e2ebd41f5ef8dc$export$e3e3877ec9c5e840);
const $15e2ebd41f5ef8dc$export$e3e3877ec9c5e840 = {
    name: 'project-settings-software-toolchain-team-managed',
    path: '/jira/software/projects/:projectKey/settings/toolchain',
    exact: true
};

});


parcelRegister("kDBV4", function(module, exports) {

$parcel$export(module.exports, "projectSettingsVersionsRouteEntry", () => $f20ad773ddf4aa1a$export$4791201b4877aa5d);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $PZ4Ji = parcelRequire("PZ4Ji");

var $bTfc4 = parcelRequire("bTfc4");

var $7Rvy6 = parcelRequire("7Rvy6");

var $8tbnc = parcelRequire("8tbnc");

var $8ziHo = parcelRequire("8ziHo");
const $f20ad773ddf4aa1a$export$4791201b4877aa5d = (0, $6xToB.createEntry)((0, $7Rvy6.projectSettingsVersionsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource),
            (0, $PZ4Ji.projectVersionsRelayResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        component: (0, $8ziHo.RelayVersions),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8ziHo.LazyRelayProjectVersions)
        ]
    }));

});
parcelRegister("PZ4Ji", function(module, exports) {

$parcel$export(module.exports, "projectVersionsRelayResource", () => $cac17e3ec9a369b4$export$7e8aa1360f86345c);
/* eslint-disable jira/import-whitelist */ 
var $j4oe4 = parcelRequire("j4oe4");


var $cYcBU = parcelRequire("cYcBU");

var $7zZ4w = parcelRequire("7zZ4w");

var $7797X = parcelRequire("7797X");

var $9FYIg = parcelRequire("9FYIg");

var $kzPuE = parcelRequire("kzPuE");

var $l1VxS = parcelRequire("l1VxS");

var $7jTnu = parcelRequire("7jTnu");

const $cac17e3ec9a369b4$export$7e8aa1360f86345c = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $de70b073378ece45$export$59aa73792ad9507a)}`,
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `project-version-query-relay-${projectKey}`;
    },
    // @ts-expect-error - might return null
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $kzPuE.default), {
            initialLoadCount: 20,
            cloudId: tenantContext.cloudId,
            projectKey: match.params.projectKey,
            filter: (0, $cYcBU.transformStatusFromParam)(query[0, $5e130dc454373f11$export$3e8168848b996f7]),
            searchString: query[0, $5e130dc454373f11$export$a181206198b7f50c] || '',
            sortBy: {
                sortByField: (0, $cYcBU.transformSortFieldFromParam)(query[0, $5e130dc454373f11$export$a3482d3a8df0e725]),
                order: (0, $cYcBU.transformSortOrderFromParam)(query[0, $5e130dc454373f11$export$71089821f361e881])
            },
            isManageVersionsPermissionEnabled: (0, $7jTnu.fg)('vmc-11-manage-versions-permission')
        }, {
            fetchPolicy: 'store-or-network'
        });
        if (false && queryReference.id != null) await (0, $7797X.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
const $5e130dc454373f11$export$a181206198b7f50c = 'contains';
const $5e130dc454373f11$export$3e8168848b996f7 = 'status';
const $5e130dc454373f11$export$71089821f361e881 = 'orderDirection';
const $5e130dc454373f11$export$a3482d3a8df0e725 = 'orderField';
const $5e130dc454373f11$export$3c5e605ca7ade9f2 = 'NAME';
const $5e130dc454373f11$export$50241fe906e4f94e = 'RELEASE_DATE';
const $5e130dc454373f11$export$99a467bcc22b8df9 = 'START_DATE';
const $5e130dc454373f11$export$d44826c816b5619b = 'DESCRIPTION';
const $5e130dc454373f11$export$34694f8d8b23ee2a = 'SEQUENCE';
const $5e130dc454373f11$export$cb638d1fae624fbf = 20;
const $5e130dc454373f11$export$bbcbc202f2dfa28c = 3;
const $5e130dc454373f11$export$b983f2cb1f658a55 = 'RELEASED';
const $5e130dc454373f11$export$cb459d726a8530a5 = 'UNRELEASED';
const $5e130dc454373f11$export$c936349447a77fe0 = 'ARCHIVED';
const $5e130dc454373f11$export$c5ed97509d0e2aaf = 'projectVersions';

parcelRegister("cYcBU", function(module, exports) {

$parcel$export(module.exports, "transformStatusFromParam", () => $f25f67743d1604be$export$5760f9690301cdb);
$parcel$export(module.exports, "transformStatusToParam", () => $f25f67743d1604be$export$46595832dd863016);
$parcel$export(module.exports, "transformSortOrderFromParam", () => $f25f67743d1604be$export$1945e6d2f31e09e6);
$parcel$export(module.exports, "transformSortFieldFromParam", () => $f25f67743d1604be$export$f842a0d1846d319d);
$parcel$export(module.exports, "transformStatusToDropdownSelection", () => $f25f67743d1604be$export$7dad705635760cfe);
$parcel$export(module.exports, "getUpdatedDisplayedStatuses", () => $f25f67743d1604be$export$ce4c948ba1d53df4);
$parcel$export(module.exports, "getFormattedVersionDate", () => $f25f67743d1604be$export$5a6eeb16be7dd21d);


var $e4t5W = parcelRequire("e4t5W");

var $frPES = parcelRequire("frPES");

const $f25f67743d1604be$export$5760f9690301cdb = (input)=>{
    switch(input){
        case 'no-filter':
            return [
                (0, $frPES.RELEASED),
                (0, $frPES.UNRELEASED),
                (0, $frPES.ARCHIVED)
            ];
        case 'all':
            return [
                (0, $frPES.RELEASED),
                (0, $frPES.UNRELEASED),
                (0, $frPES.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $frPES.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $frPES.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $frPES.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $frPES.UNRELEASED)
                ];
            }
    }
};
const $f25f67743d1604be$export$46595832dd863016 = (input)=>{
    if (input) {
        if (input.length === 0) return 'no-filter';
        if (input.length > 2) return 'all';
        return [
            input.includes((0, $frPES.RELEASED)) && [
                'released'
            ],
            input.includes((0, $frPES.UNRELEASED)) && [
                'unreleased'
            ],
            input.includes((0, $frPES.ARCHIVED)) && [
                'archived'
            ]
        ].filter(Boolean).join('-');
    }
    return undefined;
};
const $f25f67743d1604be$export$1945e6d2f31e09e6 = (input)=>{
    switch(input){
        case 'ASC':
            return 0, $a535a1c1a5d4d33f$export$1dee026a19752d6b;
        case 'DESC':
            return 0, $a535a1c1a5d4d33f$export$b6abcf7fa1d94f65;
        default:
            return 0, $a535a1c1a5d4d33f$export$b6abcf7fa1d94f65;
    }
};
const $f25f67743d1604be$export$f842a0d1846d319d = (input)=>{
    switch(input){
        case 'NAME':
            return 0, $5e130dc454373f11$export$3c5e605ca7ade9f2;
        case 'RELEASEDATE':
            return 0, $5e130dc454373f11$export$50241fe906e4f94e;
        case 'STARTDATE':
            return 0, $5e130dc454373f11$export$99a467bcc22b8df9;
        case 'DESCRIPTION':
            return 0, $5e130dc454373f11$export$d44826c816b5619b;
        case 'SEQUENCE':
            return 0, $5e130dc454373f11$export$34694f8d8b23ee2a;
        default:
            return 0, $5e130dc454373f11$export$34694f8d8b23ee2a;
    }
};
const $f25f67743d1604be$export$7dad705635760cfe = (input)=>{
    switch(input){
        case 'no-filter':
            return [];
        case 'all':
            return [
                (0, $frPES.RELEASED),
                (0, $frPES.UNRELEASED),
                (0, $frPES.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $frPES.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $frPES.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $frPES.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $frPES.UNRELEASED)
                ];
            }
    }
};
const $f25f67743d1604be$export$ce4c948ba1d53df4 = (displayedStatuses, selectedStatuses, newStatus)=>{
    // Handle the case when a status is selected after deselection of all in dropdown where versions in all statuses are displayed despite empty selection & deselecting a status from a full selection.
    if (displayedStatuses.length === (0, $5e130dc454373f11$export$bbcbc202f2dfa28c)) {
        if (!selectedStatuses.length) return [
            newStatus
        ];
        return displayedStatuses.filter((status)=>status !== newStatus);
    }
    return displayedStatuses.includes(newStatus) ? displayedStatuses.filter((item)=>item !== newStatus) : [
        ...displayedStatuses,
        newStatus
    ];
};
const $f25f67743d1604be$export$5a6eeb16be7dd21d = (versionDate, formatDate)=>versionDate != null ? formatDate(new Date(versionDate), {
        timeZone: (0, $e4t5W.VERSION_DATE_FORMAT_OPTION).timeZone,
        dateStyle: 'long'
    }) : '';

});
parcelRegister("e4t5W", function(module, exports) {

$parcel$export(module.exports, "VERSION_DATE_FORMAT_OPTION", () => $bf615e51c363d101$export$d54c0d576c2caef5);
// Used to format date string from the server to display version start date and release date
// Server only stores date without any time information such as 2023-12-31
// Use this WHENEVER displaying version start date and release date.
// If you respect local timezone without this constant, there will be a bug that will display one day early date in negative timezones.
// https://jira.atlassian.com/browse/JSWCLOUD-22316
const $bf615e51c363d101$export$d54c0d576c2caef5 = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};

});

parcelRegister("frPES", function(module, exports) {

$parcel$export(module.exports, "RELEASED", () => $8aa2131c0941c313$export$b983f2cb1f658a55);
$parcel$export(module.exports, "UNRELEASED", () => $8aa2131c0941c313$export$cb459d726a8530a5);
$parcel$export(module.exports, "ARCHIVED", () => $8aa2131c0941c313$export$c936349447a77fe0);
const $8aa2131c0941c313$export$b983f2cb1f658a55 = 'RELEASED';
const $8aa2131c0941c313$export$cb459d726a8530a5 = 'UNRELEASED';
const $8aa2131c0941c313$export$c936349447a77fe0 = 'ARCHIVED';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8aa2131c0941c313$export$2e2bcd8739ae039 = [
    $8aa2131c0941c313$export$b983f2cb1f658a55,
    $8aa2131c0941c313$export$cb459d726a8530a5,
    $8aa2131c0941c313$export$c936349447a77fe0
];

});


parcelRegister("kzPuE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c03de956579829ee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<be6ae44fd11772903154fa2ff10aa6ce>>
 * @relayHash f6deebf30059f6281cb9bf02e6322b7d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a175b6c61bf13924cb07158ed38861f8913923419e12aad6abdd2052a17b0395
const $c03de956579829ee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "initialLoadCount"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isManageVersionsPermissionEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "alias": "jiraProjectType",
        "kind": "ScalarField",
        "name": "projectType"
    }, v12 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "MANAGE_VERSIONS"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "canPerform"
    }, v14 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v15 = {
        "kind": "Variable",
        "name": "searchString",
        "variableName": "searchString"
    }, v16 = {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
    }, v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v19 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v20 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v22 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "initialLoadCount"
    }, v23 = [
        v14 /*: any*/ ,
        v22 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v24 = {
        "kind": "ScalarField",
        "name": "id"
    }, v25 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v26 = [
        v25 /*: any*/ 
    ], v27 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": "DONE"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiProjectVersionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.projectId"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v10 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.key"
                                        },
                                        v11 /*: any*/ ,
                                        {
                                            "condition": "isManageVersionsPermissionEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "canEditVersions",
                                                    "args": v12 /*: any*/ ,
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v13 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "jira.jiraProjectByKey.canEditVersions.canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "versions",
                                                "args": [
                                                    v14 /*: any*/ ,
                                                    v15 /*: any*/ ,
                                                    v16 /*: any*/ 
                                                ],
                                                "concreteType": "JiraVersionConnection",
                                                "kind": "LinkedField",
                                                "name": "__uiProject__versions_connection",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraVersionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            v17 /*: any*/ ,
                                                            v18 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraVersion",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v17 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "errors",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "extensions",
                                                                "plural": true,
                                                                "selections": [
                                                                    v19 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v20 /*: any*/ ,
                                                    v21 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.versions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": [
                        v14 /*: any*/ ,
                        v22 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "isManageVersionsPermissionEnabled",
                            "variableName": "isManageVersionsPermissionEnabled"
                        },
                        v15 /*: any*/ ,
                        v16 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "table_projectVersions"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiProjectVersionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "condition": "isManageVersionsPermissionEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "canEditVersions",
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraProjectAction",
                                            "kind": "LinkedField",
                                            "name": "action",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ 
                                            ],
                                            "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                                        }
                                    ]
                                },
                                {
                                    "args": v23 /*: any*/ ,
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "versions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraVersion",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "status"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "releaseDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "overdue"
                                                        },
                                                        {
                                                            "alias": "allIssues",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "ALL"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"ALL\")"
                                                        },
                                                        {
                                                            "alias": "doneIssues",
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "done",
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "inProgress",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "IN_PROGRESS"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                                        },
                                                        {
                                                            "alias": "toDo",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "TODO"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"TODO\")"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "versionId"
                                                        },
                                                        v9 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v25 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v23 /*: any*/ ,
                                    "filters": [
                                        "filter",
                                        "searchString",
                                        "sortBy"
                                    ],
                                    "handle": "connection",
                                    "key": "uiProject__versions",
                                    "kind": "LinkedHandle",
                                    "name": "versions"
                                },
                                v24 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a175b6c61bf13924cb07158ed38861f8913923419e12aad6abdd2052a17b0395",
            "metadata": {
                "connection": [
                    {
                        "count": "initialLoadCount",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "jiraProjectByKey",
                            "versions"
                        ]
                    }
                ]
            },
            "name": "uiProjectVersionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c03de956579829ee$var$node.hash = "d200347d20dfa0c568d719d21b96cc62";
var $c03de956579829ee$export$2e2bcd8739ae039 = $c03de956579829ee$var$node;

});

const $de70b073378ece45$export$59aa73792ad9507a = 'PROJECT_VERSIONS';


parcelRegister("7Rvy6", function(module, exports) {

$parcel$export(module.exports, "projectSettingsVersionsRoute", () => $28b9577f82c55763$export$cc9450e5d7579b99);
const $28b9577f82c55763$export$cc9450e5d7579b99 = {
    name: 'project-settings-versions',
    path: '/plugins/servlet/project-config/:projectKey/administer-versions'
};

});

parcelRegister("8ziHo", function(module, exports) {

$parcel$export(module.exports, "LazyRelayProjectVersions", () => $ab0d1ae18bcd281e$export$9036da4fa9f7a66f);
$parcel$export(module.exports, "RelayVersions", () => $ab0d1ae18bcd281e$export$9aff7dab80671d9);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ab0d1ae18bcd281e$export$9036da4fa9f7a66f = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("KrseX"))), {
    moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
});
const $ab0d1ae18bcd281e$export$9aff7dab80671d9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ab0d1ae18bcd281e$export$9036da4fa9f7a66f,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });

});
parcelRegister("KrseX", function(module, exports) {

let $08b997e1daaf74ff$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $08b997e1daaf74ff$var$load("1VRB2"),
    $08b997e1daaf74ff$var$load("bABhq"),
    $08b997e1daaf74ff$var$load("4FI7E")
]).then(()=>parcelRequire('kLWhg'));

});



parcelRegister("3gALM", function(module, exports) {

$parcel$export(module.exports, "projectsRedirectRouteEntry", () => $93520232aa18f88b$export$56f9921db324f30);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $hoV2u = parcelRequire("hoV2u");

var $gwhEz = parcelRequire("gwhEz");
const $93520232aa18f88b$export$56f9921db324f30 = (0, $6xToB.createEntry)((0, $gwhEz.projectsRedirectRoute), ()=>({
        group: 'redirects',
        isRedirect: true,
        component: (0, $hoV2u.RedirectToLastVisitedProjectPage),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("gwhEz", function(module, exports) {

$parcel$export(module.exports, "projectsRedirectRoute", () => $210d4f34607aed1b$export$e6bc3ea427ddafb8);
const $210d4f34607aed1b$export$e6bc3ea427ddafb8 = {
    name: 'projects-redirect',
    path: '/projects/:projectKey',
    query: [
        'selectedItem!=(.+)'
    ],
    exact: true
};

});


parcelRegister("6l8wI", function(module, exports) {

$parcel$export(module.exports, "projectVersionsRouteEntry", () => $0a1e862d0941e89e$export$982bc443ef89cc3f);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $PZ4Ji = parcelRequire("PZ4Ji");

var $bTfc4 = parcelRequire("bTfc4");

var $ijegf = parcelRequire("ijegf");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $0a1e862d0941e89e$var$LazyRelayProjectVersions = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("KrseX"))), {
    moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
});
const $0a1e862d0941e89e$var$RelayVersions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $0a1e862d0941e89e$var$LazyRelayProjectVersions,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });
const $0a1e862d0941e89e$export$982bc443ef89cc3f = (0, $6xToB.createEntry)((0, $ijegf.projectVersionsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $PZ4Ji.projectVersionsRelayResource)
        ],
        component: $0a1e862d0941e89e$var$RelayVersions,
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $0a1e862d0941e89e$var$LazyRelayProjectVersions
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("ijegf", function(module, exports) {

$parcel$export(module.exports, "projectVersionsRoute", () => $1f4dd792c454a9fd$export$fb5516756c3eba40);

var $cehbk = parcelRequire("cehbk");
const $1f4dd792c454a9fd$export$fb5516756c3eba40 = {
    name: 'project-versions',
    path: '/projects/:projectKey',
    query: (0, $cehbk.PROJECTS_VERSIONS_QUERY_PARAMS)
};

});
parcelRegister("cehbk", function(module, exports) {

$parcel$export(module.exports, "PROJECTS_VERSIONS_QUERY_PARAMS", () => $a5ed9748ac327a73$export$ad46185437bb571a);
const $a5ed9748ac327a73$export$ad46185437bb571a = [
    'selectedItem=com.atlassian.jira.jira-projects-plugin:release-page'
];

});



parcelRegister("kzJod", function(module, exports) {

$parcel$export(module.exports, "promotionsRouteEntry", () => $b49e27e077669a06$export$875d88a44b1ff74c);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $d2yKs = parcelRequire("d2yKs");

var $ixFkc = parcelRequire("ixFkc");
const $b49e27e077669a06$export$875d88a44b1ff74c = (0, $6xToB.createEntry)((0, $d2yKs.promotionsRoute), ()=>({
        group: 'marketplace',
        component: (0, $ixFkc.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $gKFn0.default)
        },
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ixFkc.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace'
    }));

});
parcelRegister("d2yKs", function(module, exports) {

$parcel$export(module.exports, "promotionsRoute", () => $e6593ea95980eb90$export$45df65bfacbf9a2a);
const $e6593ea95980eb90$export$45df65bfacbf9a2a = {
    name: 'marketplace-promotions',
    path: '/jira/marketplace/manage/promotions'
};

});


parcelRegister("2jzeY", function(module, exports) {

$parcel$export(module.exports, "rapidboardBacklog1RouteEntry", () => $0d645fa50bc99e20$export$ee2385c1acba53f2);

var $6xToB = parcelRequire("6xToB");

var $kbZYB = parcelRequire("kbZYB");

var $alzbz = parcelRequire("alzbz");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $eJe5A = parcelRequire("eJe5A");

var $1wb5r = parcelRequire("1wb5r");

var $9ZjGp = parcelRequire("9ZjGp");

var $6dwgv = parcelRequire("6dwgv");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $b4jBr = parcelRequire("b4jBr");

var $kHlOR = parcelRequire("kHlOR");

var $4sNzw = parcelRequire("4sNzw");

const $0d645fa50bc99e20$export$ee2385c1acba53f2 = (0, $6xToB.createEntry)((0, $4sNzw.rapidboardBacklog1Route), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog',
        component: (0, $kbZYB.RapidBoardSpaPage),
        skeleton: (0, $9ZjGp.NextGenBacklogSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kbZYB.LazyRapidBoard),
            (0, $kbZYB.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $652f5f63189f3e2a$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $1wb5r.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true
    }));

});
parcelRegister("4sNzw", function(module, exports) {

$parcel$export(module.exports, "rapidboardBacklog1Route", () => $9ee3d028f8529fbc$export$ff874528b0b33a61);
const $9ee3d028f8529fbc$export$ff874528b0b33a61 = {
    name: 'rapidboard-backlog',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=(planning|planning.nodetail)'
    ]
};

});


parcelRegister("80YBd", function(module, exports) {

$parcel$export(module.exports, "rapidboardLastVisitedProjectRedirectRouteEntry", () => $7f229794e42917d4$export$420f86cfd239da4d);

var $6xToB = parcelRequire("6xToB");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $kHlOR = parcelRequire("kHlOR");

var $cYzeN = parcelRequire("cYzeN");

var $hoV2u = parcelRequire("hoV2u");
const $7f229794e42917d4$export$420f86cfd239da4d = (0, $6xToB.createEntry)((0, $cYzeN.rapidboardLastVisitedProjectRedirectRoute), ()=>({
        group: 'classic-software',
        component: (0, $hoV2u.RedirectToLastVisitedProjectPage),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        isRedirect: true,
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("cYzeN", function(module, exports) {

$parcel$export(module.exports, "rapidboardLastVisitedProjectRedirectRoute", () => $2c088233e87c120f$export$991b1be164057e91);
const $2c088233e87c120f$export$991b1be164057e91 = {
    name: 'rapidboard-last-visited-project-redirect',
    path: '/secure/RapidBoard.jspa',
    query: [
        'projectKey'
    ],
    __unsafeOrder: 1
};

});


parcelRegister("lfdJB", function(module, exports) {

$parcel$export(module.exports, "rapidboardReport1RouteEntry", () => $2cea65dfe88bd06a$export$7e8c0a9f6d68837);

var $6xToB = parcelRequire("6xToB");

var $kbZYB = parcelRequire("kbZYB");

var $alzbz = parcelRequire("alzbz");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $eJe5A = parcelRequire("eJe5A");

var $1wb5r = parcelRequire("1wb5r");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $9NmsS = parcelRequire("9NmsS");

var $b4jBr = parcelRequire("b4jBr");

var $kHlOR = parcelRequire("kHlOR");

var $eb6le = parcelRequire("eb6le");

var $c3Di2 = parcelRequire("c3Di2");

var $awzH2 = parcelRequire("awzH2");
const $2cea65dfe88bd06a$export$7e8c0a9f6d68837 = (0, $6xToB.createEntry)((0, $eb6le.rapidboardReport1Route), ()=>({
        group: 'classic-software',
        component: (0, $kbZYB.RapidBoardSpaPage),
        skeleton: (0, $c3Di2.ClassicReportSkeleton),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            ...(0, $awzH2.getReportsCommonResource)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kbZYB.LazyRapidBoard),
            (0, $kbZYB.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $1wb5r.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report',
        supportsPreviewPanel: true
    }));

});
parcelRegister("eb6le", function(module, exports) {

$parcel$export(module.exports, "rapidboardReport1Route", () => $8249f1ffba1a21f4$export$d27f9ad2fc277ff9);
const $8249f1ffba1a21f4$export$d27f9ad2fc277ff9 = {
    name: 'rapidboard-report',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=reporting',
        'chart'
    ]
};

});

parcelRegister("c3Di2", function(module, exports) {

$parcel$export(module.exports, "ClassicReportSkeleton", () => $4bc382652cc5ad21$export$d7667341f4db3b8d);

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $39aPx = parcelRequire("39aPx");
const $4bc382652cc5ad21$export$d7667341f4db3b8d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($39aPx)))
    });

});
parcelRegister("39aPx", function(module, exports) {
module.exports = new URL("classic-report-app-skeleton.tpl.1daae66d.svg", import.meta.url).toString();

});



parcelRegister("d8BX1", function(module, exports) {

$parcel$export(module.exports, "rapidboardReportRouteEntry", () => $a48346ca5684aaf7$export$745f1d5a2458a2d9);

var $6xToB = parcelRequire("6xToB");

var $b7HVj = parcelRequire("b7HVj");

var $kbZYB = parcelRequire("kbZYB");

var $c3Di2 = parcelRequire("c3Di2");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $alzbz = parcelRequire("alzbz");

var $eJe5A = parcelRequire("eJe5A");

var $kHlOR = parcelRequire("kHlOR");

var $1wb5r = parcelRequire("1wb5r");

var $7jTnu = parcelRequire("7jTnu");

var $awzH2 = parcelRequire("awzH2");

var $e0Ji4 = parcelRequire("e0Ji4");
const $a48346ca5684aaf7$export$745f1d5a2458a2d9 = (0, $6xToB.createEntry)((0, $b7HVj.rapidboardReportRoute), ()=>({
        group: 'classic-software',
        component: (0, $kbZYB.RapidBoardSpaPage),
        skeleton: (0, $c3Di2.ClassicReportSkeleton),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            ...(0, $awzH2.getReportsCommonResource)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kbZYB.LazyRapidBoard),
            (0, $kbZYB.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $1wb5r.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report',
        entryPoint: ()=>(0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $e0Ji4.reportPageProjectEntrypoint) : (0, $e0Ji4.reportPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("b7HVj", function(module, exports) {

$parcel$export(module.exports, "rapidboardReportRoute", () => $1f38f67ed088a445$export$d37f637b09fb9fda);
const $1f38f67ed088a445$export$d37f637b09fb9fda = {
    name: 'rapidboard-report',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/:chartView'
};

});

parcelRegister("e0Ji4", function(module, exports) {

$parcel$export(module.exports, "reportPageEntrypoint", () => $030bf664c930e9c5$export$73cecf7395943edd);
$parcel$export(module.exports, "reportPageProjectEntrypoint", () => $030bf664c930e9c5$export$bf3e4f038f61a19c);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $c4lqF = parcelRequire("c4lqF");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $030bf664c930e9c5$export$73cecf7395943edd = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $c4lqF.rapidBoardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $030bf664c930e9c5$export$bf3e4f038f61a19c = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $c4lqF.rapidBoardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    }
});

});
parcelRegister("c4lqF", function(module, exports) {

$parcel$export(module.exports, "rapidBoardEntryPoint", () => $946dcba1f75fba3a$export$15991360ec37fcaf);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $946dcba1f75fba3a$export$15991360ec37fcaf = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("gwtJl")), {
        moduleId: "4d7ce9a3",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("gwtJl", function(module, exports) {

let $c076b25751175680$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c076b25751175680$var$load("bxFPn").then(()=>parcelRequire('gEw1T'));

});




parcelRegister("hDTQX", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserBacklogRouteEntry", () => $51da1fe8702ba6ff$export$ccde3c1d7a857b27);

var $6xToB = parcelRequire("6xToB");

var $alzbz = parcelRequire("alzbz");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $fbgOh = parcelRequire("fbgOh");

var $27Owl = parcelRequire("27Owl");

var $eJe5A = parcelRequire("eJe5A");

var $1wb5r = parcelRequire("1wb5r");

var $3956v = parcelRequire("3956v");

var $9ZjGp = parcelRequire("9ZjGp");

var $6dwgv = parcelRequire("6dwgv");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $kMi77 = parcelRequire("kMi77");

var $ag8Tg = parcelRequire("ag8Tg");
const $51da1fe8702ba6ff$export$ccde3c1d7a857b27 = (0, $6xToB.createEntry)((0, $3956v.rapidboardUserBacklogRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $9ZjGp.NextGenBacklogSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getUIFBacklogDataResource)(),
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)(),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $ag8Tg.backlogPageEntrypoint),
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $kMi77.classicBacklogCapability)
        },
        earlyAssets: (0, $1wb5r.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true
    }));

});
parcelRegister("3956v", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserBacklogRoute", () => $a097d7ac6b9cdf6d$export$79c2d9718e914f91);
const $a097d7ac6b9cdf6d$export$79c2d9718e914f91 = {
    name: 'rapidboard-user-backlog',
    path: '/jira/people/:accountId/boards/:boardId/backlog'
};

});

parcelRegister("kMi77", function(module, exports) {

$parcel$export(module.exports, "classicBacklogCapability", () => $f2f0681e90285d31$export$10a7bb102137d92b);

const $f2f0681e90285d31$export$10a7bb102137d92b = !false ? (0, $652f5f63189f3e2a$export$571692eec8a399e1) : (0, $652f5f63189f3e2a$export$93104dc4eba58ba4);

});

parcelRegister("ag8Tg", function(module, exports) {

$parcel$export(module.exports, "backlogPageEntrypoint", () => $b112677a0f4958a4$export$1ccf08591607897d);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $cw1BI = parcelRequire("cw1BI");
const $b112677a0f4958a4$export$1ccf08591607897d = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cw1BI.nextGenBacklogEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("3NN4E", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportRouteEntry", () => $e5dcc50abdecc89d$export$374d78dc1cde7b56);

var $6xToB = parcelRequire("6xToB");

var $alzbz = parcelRequire("alzbz");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $eJe5A = parcelRequire("eJe5A");

var $1wb5r = parcelRequire("1wb5r");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $9NmsS = parcelRequire("9NmsS");

var $6fTv5 = parcelRequire("6fTv5");

var $c3Di2 = parcelRequire("c3Di2");

var $awzH2 = parcelRequire("awzH2");

var $e0Ji4 = parcelRequire("e0Ji4");
const $e5dcc50abdecc89d$export$374d78dc1cde7b56 = (0, $6xToB.createEntry)((0, $6fTv5.rapidboardUserReportRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $c3Di2.ClassicReportSkeleton),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            ...(0, $awzH2.getReportsCommonResource)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $e0Ji4.reportPageEntrypoint),
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $1wb5r.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true
    }));

});
parcelRegister("6fTv5", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportRoute", () => $b412fbcec0c262f7$export$7b85bca17717def6);
const $b412fbcec0c262f7$export$7b85bca17717def6 = {
    name: 'rapidboard-user-report',
    path: '/jira/people/:accountId/boards/:boardId/reports/:chartView'
};

});


parcelRegister("6034y", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportsOverviewRouteEntry", () => $2efbaf5219925a24$export$721c38d3152f9625);

var $6xToB = parcelRequire("6xToB");

var $7jTnu = parcelRequire("7jTnu");

var $5RW99 = parcelRequire("5RW99");

var $aTYS8 = parcelRequire("aTYS8");

var $ioHIu = parcelRequire("ioHIu");

var $hS1gr = parcelRequire("hS1gr");

var $g8uYY = parcelRequire("g8uYY");

var $aDtWM = parcelRequire("aDtWM");

var $alzbz = parcelRequire("alzbz");

var $9n5I0 = parcelRequire("9n5I0");

var $bTfc4 = parcelRequire("bTfc4");

var $9NmsS = parcelRequire("9NmsS");

var $lvjEc = parcelRequire("lvjEc");
const $2efbaf5219925a24$var$reportsOverviewPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $lvjEc.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $2efbaf5219925a24$export$721c38d3152f9625 = (0, $6xToB.createEntry)((0, $aTYS8.rapidboardUserReportsOverviewRoute), ()=>({
        group: 'classic-software',
        entryPoint () {
            return (0, $7jTnu.fg)('reports-overview-page-migration') ? $2efbaf5219925a24$var$reportsOverviewPageEntryPoint : undefined;
        },
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            ...(0, $9NmsS.getUserBoardNavigationResources)(),
            ...(0, $alzbz.getRapidboardResources)()
        ],
        ufoName: 'reports-overview',
        supportsPreviewPanel: true
    }));

});
parcelRegister("aTYS8", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportsOverviewRoute", () => $d69dfc0bbc23df77$export$6101ec4dca41c740);
const $d69dfc0bbc23df77$export$6101ec4dca41c740 = {
    name: 'rapidboard-user-reports-overview',
    path: '/jira/people/:accountId/boards/:boardId/reports'
};

});


parcelRegister("lCqer", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationDetailRouteEntry", () => $91fc81d2e805a87b$export$565325825b04cec6);

var $e4Bg5 = parcelRequire("e4Bg5");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $fSq6c = parcelRequire("fSq6c");

var $94jGb = parcelRequire("94jGb");

var $cjTtV = parcelRequire("cjTtV");
const $91fc81d2e805a87b$export$565325825b04cec6 = (0, $6xToB.createEntry)((0, $fSq6c.roleBasedNotificationDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $94jGb.RoleBasedNotificationsComponent),
        layout: (0, $yRJUA.globalSettingsLayout),
        slot: (0, $cjTtV.RoleBasedNotificationDetail),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $e4Bg5.resources)[0],
            (0, $e4Bg5.resources)[1],
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        forPaint: [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $94jGb.LazyRoleBasedNotifications)
        ]
    }));

});
parcelRegister("e4Bg5", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationsResource", () => $cc67806cdc6c1273$export$9a716bf20d804ec3);
$parcel$export(module.exports, "notificationDetailResource", () => $cc67806cdc6c1273$export$8ad8a0a20fd0ed5a);
$parcel$export(module.exports, "resources", () => $cc67806cdc6c1273$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $feIEW = parcelRequire("feIEW");
var $jXKdt = parcelRequire("jXKdt");

var $khI8Y = parcelRequire("khI8Y");
const $cc67806cdc6c1273$export$9a716bf20d804ec3 = (0, $l1VxS.createResource)({
    type: 'roleBasedNotificationsResource',
    getKey: ()=>'roleBasedNotificationsResource',
    getData: (0, $khI8Y.getRoleBasedNotificationsEndpoint),
    isBrowserOnly: true,
    maxAge: 300000
});
const $cc67806cdc6c1273$export$8ad8a0a20fd0ed5a = (0, $l1VxS.createResource)({
    type: 'notificationDetailResource',
    getKey: ({ match: match })=>{
        const settingId = match.params['id'];
        return `notificationDetailResource-id=${settingId}`;
    },
    getData: ({ match: match })=>{
        const settingId = match.params['id'];
        (0, $feIEW.assert)(!!settingId, new (0, $jXKdt.AssertionError)('notificationDetailResource', 'settingId is required'));
        return (0, $khI8Y.getRoleBasedNotificationDetailEndpoint)(settingId);
    },
    isBrowserOnly: true
});
const $cc67806cdc6c1273$export$bc99aaabaf7b70a7 = [
    $cc67806cdc6c1273$export$9a716bf20d804ec3,
    $cc67806cdc6c1273$export$8ad8a0a20fd0ed5a
];

});
parcelRegister("khI8Y", function(module, exports) {

$parcel$export(module.exports, "getRoleBasedNotificationsEndpoint", () => $05fd7033cee4e53b$export$db67dfe9fe98cd49);
$parcel$export(module.exports, "getRoleBasedNotificationDetailEndpoint", () => $05fd7033cee4e53b$export$5522446e6d3ee73);

var $br21R = parcelRequire("br21R");
const $05fd7033cee4e53b$export$db67dfe9fe98cd49 = ()=>(0, $br21R.eocFetch)(`/v1/role-based-notifications`);
const $05fd7033cee4e53b$export$5522446e6d3ee73 = (settingId)=>(0, $br21R.eocFetch)(`/v1/role-based-notifications/${settingId}`);

});


parcelRegister("fSq6c", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationDetailRoute", () => $1cb6004d03e4407c$export$10ec812f053317c9);
const $1cb6004d03e4407c$export$10ec812f053317c9 = {
    name: 'eoc-role-based-notifications-detail',
    path: '/jira/settings/products/ops/role-based-notifications/:id',
    exact: true
};

});

parcelRegister("94jGb", function(module, exports) {

$parcel$export(module.exports, "LazyRoleBasedNotifications", () => $1bb1c5fe35d368eb$export$15a244aba8f3b406);
$parcel$export(module.exports, "RoleBasedNotificationsComponent", () => $1bb1c5fe35d368eb$export$8994be6f8ad6a04a);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $1bb1c5fe35d368eb$export$15a244aba8f3b406 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("9otTz")).then((module)=>module.RoleBasedNotificationsPage), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});
const $1bb1c5fe35d368eb$export$8994be6f8ad6a04a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1bb1c5fe35d368eb$export$15a244aba8f3b406,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });

});
parcelRegister("9otTz", function(module, exports) {

let $6d6d8b846841e2f3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6d6d8b846841e2f3$var$load("1VRB2"),
    $6d6d8b846841e2f3$var$load("bABhq"),
    $6d6d8b846841e2f3$var$load("k4gbU"),
    $6d6d8b846841e2f3$var$load("9A3kn")
]).then(()=>parcelRequire('5lvpt'));

});


parcelRegister("cjTtV", function(module, exports) {

$parcel$export(module.exports, "RoleBasedNotificationDetail", () => $c9419f7e9b73b669$export$445112c3a1089cc5);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $c9419f7e9b73b669$export$5211e5a7ed694f98 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("9otTz")).then((module)=>module.RoleBasedNotificationDetail), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});
const $c9419f7e9b73b669$export$445112c3a1089cc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c9419f7e9b73b669$export$5211e5a7ed694f98,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });

});


parcelRegister("4YOsq", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationsRouteEntry", () => $d0e3c65e0fdd34ae$export$60de9875bb8ef1d6);

var $e4Bg5 = parcelRequire("e4Bg5");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $cAdCW = parcelRequire("cAdCW");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $7jTnu = parcelRequire("7jTnu");

var $fXF6E = parcelRequire("fXF6E");

var $6zXPf = parcelRequire("6zXPf");

var $94jGb = parcelRequire("94jGb");
const $d0e3c65e0fdd34ae$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $d0e3c65e0fdd34ae$export$60de9875bb8ef1d6 = (0, $6xToB.createEntry)((0, $cAdCW.roleBasedNotificationsRoute), ()=>({
        group: 'eoc',
        component: (0, $94jGb.RoleBasedNotificationsComponent),
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $e4Bg5.resources)[0],
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$d0e3c65e0fdd34ae$var$getNavigationSpecifications()
        },
        forPaint: (0, $7jTnu.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $94jGb.LazyRoleBasedNotifications)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $94jGb.LazyRoleBasedNotifications)
        ]
    }));

});
parcelRegister("cAdCW", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationsRoute", () => $496f8b17fab16e7c$export$5a10092825ee32e4);
const $496f8b17fab16e7c$export$5a10092825ee32e4 = {
    name: 'eoc-role-based-notifications',
    path: '/jira/settings/products/ops/role-based-notifications',
    exact: true
};

});


parcelRegister("3Rt1x", function(module, exports) {

$parcel$export(module.exports, "rovoSearchRouteEntry", () => $c11a58d690f29b8d$export$64c44018a429a3ed);

var $eJOHy = parcelRequire("eJOHy");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $7Bu6h = parcelRequire("7Bu6h");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c11a58d690f29b8d$var$LazyRovoSearchPage = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7z6UH"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/rovo-search/src/index.tsx"
});
const $c11a58d690f29b8d$var$RovoSearchPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c11a58d690f29b8d$var$LazyRovoSearchPage,
        pageId: "rovo-search",
        shouldShowSpinner: false
    });
const $c11a58d690f29b8d$export$64c44018a429a3ed = (0, $6xToB.createEntry)((0, $7Bu6h.rovoSearchRoute), ()=>({
        group: 'search',
        component: $c11a58d690f29b8d$var$RovoSearchPage,
        isRedirect: false,
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            $c11a58d690f29b8d$var$LazyRovoSearchPage
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("7Bu6h", function(module, exports) {

$parcel$export(module.exports, "rovoSearchRoute", () => $fbbd18239f0fbf85$export$c45b7c601eb1ba93);
const $fbbd18239f0fbf85$export$c45b7c601eb1ba93 = {
    name: 'jira-rovo-search',
    path: '/jira/cross-product-search',
    exact: true
};

});


parcelRegister("6cbbu", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostEntrypointsRouteEntry", () => $61ebdb34a3132775$export$95bd68c4f26980ed);

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $g8uYY = parcelRequire("g8uYY");

var $9NmsS = parcelRequire("9NmsS");

var $7jTnu = parcelRequire("7jTnu");

var $kSeQy = parcelRequire("kSeQy");

var $a9kHc = parcelRequire("a9kHc");

var $5RW99 = parcelRequire("5RW99");

var $cEyqp = parcelRequire("cEyqp");
const $61ebdb34a3132775$var$sandboxBundlerBifrostPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cEyqp.sandboxBundlerBifrostEntryPoint),
    // using PROJECTS as a placeholder
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $61ebdb34a3132775$export$95bd68c4f26980ed = (0, $6xToB.createEntry)((0, $a9kHc.sandboxBundlerBifrostEntrypointsRoute), ()=>({
        group: 'sandbox',
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        ufoName: 'sandbox-bundler',
        entryPoint: ()=>(0, $7jTnu.fg)('conditional_import_sandbox_bifrost') ? $61ebdb34a3132775$var$sandboxBundlerBifrostPageEntryPoint : (0, $kSeQy.notFoundPageEntrypoint),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxBundlerBifrostEntrypointsRouteEntry.tsx',
                whichExportToUse: 'sandboxBundlerBifrostEntrypointsRouteEntry'
            },
            enabled: false
        }
    }));

});
parcelRegister("a9kHc", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostEntrypointsRoute", () => $8bd0e2b2bcfc0245$export$1e4fe7eb44ddb2fd);
const $8bd0e2b2bcfc0245$export$1e4fe7eb44ddb2fd = {
    name: 'sandbox-bundler-bifrost-entrypoints',
    path: '/jira/software/sandbox/bundler-bifrost/entrypoints',
    exact: true
};

});

parcelRegister("cEyqp", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostEntryPoint", () => $0791eb6c2467b2f0$export$e6bb5cf1b802d157);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $0791eb6c2467b2f0$export$e6bb5cf1b802d157 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("ahGvP")), {
        moduleId: "ce1b1bd6",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("ahGvP", function(module, exports) {

let $77cc77f6956b872d$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("g81qY"))('test_conditional_imports', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('some_feature_gate_that_doesnt_exist', function() {
                return Promise.all([
                    $77cc77f6956b872d$var$load("iWk7w")
                ]);
            }, function() {
                return Promise.all([
                    $77cc77f6956b872d$var$load("jtfsh")
                ]);
            }),
            $77cc77f6956b872d$var$load("2uSuT")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('some_feature_gate_that_doesnt_exist', function() {
                return Promise.all([
                    $77cc77f6956b872d$var$load("iWk7w")
                ]);
            }, function() {
                return Promise.all([
                    $77cc77f6956b872d$var$load("jtfsh")
                ]);
            }),
            $77cc77f6956b872d$var$load("hwqQa")
        ]);
    }),
    $77cc77f6956b872d$var$load("8uz5k")
]).then(()=>parcelRequire('6JhVg'));

});



parcelRegister("bSbiO", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostRLLRouteEntry", () => $93c84e7192b9b61c$export$e0dd38ef6ff677e7);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $jVgoQ = parcelRequire("jVgoQ");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $93c84e7192b9b61c$var$LazySandboxBundlerPage = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ahGvP"))), {
    moduleId: "./src/packages/spa-apps/sandbox/bundler/src/index.tsx"
});
const $93c84e7192b9b61c$var$SandboxBundler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $93c84e7192b9b61c$var$LazySandboxBundlerPage,
        pageId: "sandbox-bundler-bifrost",
        shouldShowSpinner: true
    });
const $93c84e7192b9b61c$export$e0dd38ef6ff677e7 = (0, $6xToB.createEntry)((0, $jVgoQ.sandboxBundlerBifrostRLLRoute), ()=>({
        group: 'sandbox',
        component: (0, $bJscI.componentWithFG)('conditional_import_sandbox_bifrost', $93c84e7192b9b61c$var$SandboxBundler, (0, $9BJU1.default)),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $93c84e7192b9b61c$var$LazySandboxBundlerPage
        ],
        ufoName: 'sandbox-bundler',
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxBundlerBifrostRLLRouteEntry.tsx',
                whichExportToUse: 'sandboxBundlerBifrostRLLRouteEntry'
            },
            enabled: false
        }
    }));

});
parcelRegister("jVgoQ", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostRLLRoute", () => $eff0ee4362f7531d$export$c21fd836e6493cee);
const $eff0ee4362f7531d$export$c21fd836e6493cee = {
    name: 'sandbox-bundler-bifrost-rll',
    path: '/jira/software/sandbox/bundler-bifrost/rll',
    exact: true
};

});


parcelRegister("2M4fN", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerRouteEntry", () => $7f28bc2a325d0899$export$71497b88db8291d0);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $9laIn = parcelRequire("9laIn");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $7f28bc2a325d0899$var$LazySandboxBundlerPage = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ahGvP"))), {
    moduleId: "./src/packages/spa-apps/sandbox/bundler/src/index.tsx"
});
const $7f28bc2a325d0899$var$SandboxBundler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $7f28bc2a325d0899$var$LazySandboxBundlerPage,
        pageId: "sandbox-bundler",
        shouldShowSpinner: true
    });
const $7f28bc2a325d0899$export$71497b88db8291d0 = (0, $6xToB.createEntry)((0, $9laIn.sandboxBundlerRoute), ()=>({
        group: 'sandbox',
        component: (0, $bJscI.componentWithFG)('conditional_import_sandbox', $7f28bc2a325d0899$var$SandboxBundler, (0, $9BJU1.default)),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $7f28bc2a325d0899$var$LazySandboxBundlerPage
        ],
        ufoName: 'sandbox-bundler'
    }));

});
parcelRegister("9laIn", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerRoute", () => $e9053c64bfe9f59c$export$3891624aac454ec2);
const $e9053c64bfe9f59c$export$3891624aac454ec2 = {
    name: 'sandbox-bundler',
    path: '/jira/software/sandbox/bundler',
    exact: true
};

});


parcelRegister("kqm46", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayEchoPageUsingEntryPointRouteEntry", () => $adbabcc5a5197adb$export$38fc3637f21e26b2);

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $l556O = parcelRequire("l556O");

var $48g3M = parcelRequire("48g3M");

var $kSeQy = parcelRequire("kSeQy");

var $7jTnu = parcelRequire("7jTnu");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");
const $adbabcc5a5197adb$var$sandboxRelayEchoPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $48g3M.sandboxEchoPageEntryPoint),
    // using PROJECTS as a placeholder
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $adbabcc5a5197adb$export$38fc3637f21e26b2 = (0, $6xToB.createEntry)((0, $l556O.sandboxRelayEchoPageUsingEntryPointRoute), ()=>({
        group: 'sandbox',
        entryPoint: ()=>(0, $7jTnu.fg)('jfp-magma-support-defer') ? $adbabcc5a5197adb$var$sandboxRelayEchoPageEntryPoint : (0, $kSeQy.notFoundPageEntrypoint),
        layout: (0, $7h3uc.globalLayout),
        resources: [],
        ufoName: 'sandbox-relay-echo',
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxRelayEchoPageUsingEntryPointRouteEntry.tsx',
                whichExportToUse: 'sandboxRelayEchoPageUsingEntryPointRouteEntry'
            },
            // WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
            // enabled: true,
            manifestName: 'jira-spa-sandboxdemo.json'
        }
    }));

});
parcelRegister("l556O", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayEchoPageUsingEntryPointRoute", () => $6a45f6f09ed3e758$export$eaecd670f9df9fd6);
const $6a45f6f09ed3e758$export$eaecd670f9df9fd6 = {
    name: 'sandbox-relay-defer-echo',
    path: '/jira/software/sandbox/relay/echo',
    exact: true
};

});

parcelRegister("48g3M", function(module, exports) {

$parcel$export(module.exports, "sandboxEchoPageEntryPoint", () => $0c21780928bef493$export$d3ff1e280a8985f3);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $d2CP0 = parcelRequire("d2CP0");

const $0c21780928bef493$export$d3ff1e280a8985f3 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("1yxyx")), {
        moduleId: "73542e71",
        moduleName: "SandboxEchoPage",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: tenantContext, context: routerContext })=>{
        return {
            queries: {
                pageQueryRef: {
                    parameters: (0, $d2CP0.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        enableDefer: Boolean('defer' in routerContext.query ? routerContext.query.defer === 'true' : true),
                        skipLongQuery: Boolean('skipLong' in routerContext.query ? routerContext.query.skipLong === 'true' : true)
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("d2CP0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ceefef7557d9945$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f43786c95d21554e6525e62ba3fbbd95>>
 * @relayHash 34217eab0f370d5568f7c0ae333e556f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b22a744e4afb7fe2f6980e1e86b1c0648005cad43d16555b8e2f7003e74dec9
const $9ceefef7557d9945$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "enableDefer"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipLongQuery"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "alias": "criticalMessage",
        "args": v2 /*: any*/ ,
        "kind": "ScalarField",
        "name": "echo"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SandboxEchoPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxEchoDefer1"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxEchoDefer2"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "enableDefer",
                                                "variableName": "enableDefer"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "SandboxEchoDefer3"
                                    }
                                ]
                            },
                            {
                                "condition": "skipLongQuery",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "Defer",
                                        "selections": [
                                            {
                                                "args": v2 /*: any*/ ,
                                                "kind": "FragmentSpread",
                                                "name": "SandboxEchoVeryLongQuery"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SandboxEchoPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer1_PVNZy",
                            "selections": [
                                {
                                    "alias": "defer1",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "delayMs": 500
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "echo"
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer2_PVNZy",
                            "selections": [
                                {
                                    "alias": "defer2",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "delayMs": 700
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "echo"
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer3_1jcU60",
                            "selections": [
                                {
                                    "alias": "defer3",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "delayMs": 900
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "echo"
                                },
                                {
                                    "if": "enableDefer",
                                    "kind": "Defer",
                                    "label": "SandboxEchoDefer3$defer$SandboxEchoNestedDefer_PVNZy",
                                    "selections": [
                                        {
                                            "alias": "nestedImmediate",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 1
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        },
                                        {
                                            "alias": "nestedDefer1",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 600
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        },
                                        {
                                            "alias": "nestedDefer2",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 1600
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "skipLongQuery",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "if": "enableDefer",
                                    "kind": "Defer",
                                    "label": "SandboxEchoPageQuery$defer$SandboxEchoVeryLongQuery_PVNZy",
                                    "selections": [
                                        {
                                            "alias": "wasItWorthTheWait",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 5000
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1b22a744e4afb7fe2f6980e1e86b1c0648005cad43d16555b8e2f7003e74dec9",
            "metadata": {},
            "name": "SandboxEchoPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9ceefef7557d9945$var$node.hash = "6c4aa6e81890a1b652ce97e525a243a3";
var $9ceefef7557d9945$export$2e2bcd8739ae039 = $9ceefef7557d9945$var$node;

});

parcelRegister("1yxyx", function(module, exports) {

let $1222fef3b13a48eb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1222fef3b13a48eb$var$load("lJ2yn").then(()=>parcelRequire('6Yq66'));

});



parcelRegister("8LN4T", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayEchoPageUsingRLLRouteEntry", () => $b3a5afa822cb0045$export$3981404cc747e85);

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $iJZf8 = parcelRequire("iJZf8");

var $aBKJ5 = parcelRequire("aBKJ5");

var $5RW99 = parcelRequire("5RW99");

var $hS1gr = parcelRequire("hS1gr");

var $i9aex = parcelRequire("i9aex");

var $huHh8 = parcelRequire("huHh8");
const $b3a5afa822cb0045$export$3981404cc747e85 = (0, $6xToB.createEntry)((0, $iJZf8.sandboxRelayEchoPageUsingRLLRoute), ()=>({
        group: 'sandbox',
        layout: (0, $7h3uc.globalLayout),
        skeleton: (0, $huHh8.Skeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        component: (0, $aBKJ5.AsyncSandboxEchoPage),
        lazyForPaint: [
            (0, $aBKJ5.AsyncSandboxEchoPage)
        ],
        resources: [
            (0, $i9aex.sandboxEchoPageRelayResource)
        ],
        ufoName: 'sandbox-relay-echo',
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxRelayEchoPageUsingRLLRouteEntry.tsx',
                whichExportToUse: 'sandboxRelayEchoPageUsingRLLRouteEntry'
            },
            // WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
            // enabled: true,
            manifestName: 'jira-spa-sandboxdemo.json'
        }
    }));

});
parcelRegister("iJZf8", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayEchoPageUsingRLLRoute", () => $fee3df7c662b432a$export$382892be07e8f9fc);
const $fee3df7c662b432a$export$382892be07e8f9fc = {
    name: 'sandbox-relay-defer-echo',
    path: '/jira/software/sandbox/relay/echo',
    exact: true
};

});

parcelRegister("aBKJ5", function(module, exports) {

$parcel$export(module.exports, "AsyncSandboxEchoPage", () => $4ae2d78610286e52$export$3e76bcb04553d279);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gzcjr = parcelRequire("gzcjr");

var $9FYIg = parcelRequire("9FYIg");

var $2dJFW = parcelRequire("2dJFW");

var $d2CP0 = parcelRequire("d2CP0");

var $ch9En = parcelRequire("ch9En");

var $i9aex = parcelRequire("i9aex");

const $4ae2d78610286e52$export$cc4c54c1ebe3736c = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("1yxyx"))), {
    moduleId: "./src/packages/spa-apps/sandbox/relay/src/ui/SandboxEchoPage.tsx"
});
const $4ae2d78610286e52$export$131119b9314343c7 = ()=>{
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $d2CP0.default));
    if (queryReference == null) {
        loadQuery({
            cloudId: '7088b486-bbf4-4e1f-9195-412bfac4be28',
            enableDefer: true,
            skipLongQuery: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("small", null, "Triggering query...");
    }
    const props = {
        queries: {
            pageQueryRef: queryReference
        },
        props: {},
        extraProps: {},
        entryPoints: {}
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("small", null, "Self-starting sandbox echo page"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "self-starting-sandbox-echo-page",
        fallback: "Loading echo page..."
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4ae2d78610286e52$export$cc4c54c1ebe3736c, props)));
};
const $4ae2d78610286e52$export$3e76bcb04553d279 = ()=>{
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $i9aex.sandboxEchoPageRelayResource));
    const props = queryReference ? {
        queries: {
            pageQueryRef: queryReference
        },
        props: {},
        extraProps: {},
        entryPoints: {}
    } : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("small", null, "Async sandbox echo page"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-sandbox-echo-page",
        fallback: "Loading echo page..."
    }, props && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4ae2d78610286e52$export$cc4c54c1ebe3736c, props)));
};

});
parcelRegister("i9aex", function(module, exports) {

$parcel$export(module.exports, "sandboxEchoPageRelayResource", () => $f42ea47258f0a957$export$1d94b7b81d2cfb0c);
/* eslint-disable jira/import-whitelist */ 
var $j4oe4 = parcelRequire("j4oe4");

var $l1VxS = parcelRequire("l1VxS");

var $d2CP0 = parcelRequire("d2CP0");

var $7zZ4w = parcelRequire("7zZ4w");

var $7797X = parcelRequire("7797X");

var $9FYIg = parcelRequire("9FYIg");
const $f42ea47258f0a957$export$1d94b7b81d2cfb0c = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_SANDBOX_RELAY_DEFER_ECHO`,
    getKey: ()=>'sandbox-relay-defer-echo',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        // Bail if the request opted out of SSR rendering
        if (false && 'ssr' in routerContext.query && routerContext.query.ssr === 'false') return null;
        const variables = {
            cloudId: tenantContext.cloudId,
            enableDefer: Boolean('defer' in routerContext.query ? routerContext.query.defer === 'true' : true),
            skipLongQuery: Boolean('skipLong' in routerContext.query ? routerContext.query.skipLong === 'true' : true)
        };
        const options = {
            fetchPolicy: 'store-and-network'
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $d2CP0.default), variables, options);
        if (false && queryReference.id != null) await (0, $7797X.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});


parcelRegister("huHh8", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $48632f96d614d640$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");
const $48632f96d614d640$export$8f31e4c4a37b8e9c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, "Loading the sandbox page...");
};

});


parcelRegister("27YPb", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayJiraPageRouteEntry", () => $a7922aefb0f5eb52$export$c19004b7e7b87ab0);

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $j0eFT = parcelRequire("j0eFT");

var $3MJtg = parcelRequire("3MJtg");

var $kSeQy = parcelRequire("kSeQy");

var $7jTnu = parcelRequire("7jTnu");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");
const $a7922aefb0f5eb52$var$sandboxRelayJiraPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $3MJtg.sandboxJiraPageEntryPoint),
    // using PROJECTS as a placeholder
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $a7922aefb0f5eb52$export$c19004b7e7b87ab0 = (0, $6xToB.createEntry)((0, $j0eFT.sandboxRelayJiraPageRoute), ()=>({
        group: 'sandbox',
        entryPoint: ()=>(0, $7jTnu.fg)('jfp-magma-support-defer') ? $a7922aefb0f5eb52$var$sandboxRelayJiraPageEntryPoint : (0, $kSeQy.notFoundPageEntrypoint),
        layout: (0, $7h3uc.globalLayout),
        resources: [],
        ufoName: 'sandbox-relay-jirasearch',
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxRelayJiraPageRouteEntry.tsx',
                whichExportToUse: 'sandboxRelayJiraPageRouteEntry'
            },
            // WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
            // enabled: true,
            manifestName: 'jira-spa-sandboxdemo.json'
        }
    }));

});
parcelRegister("j0eFT", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayJiraPageRoute", () => $3f0eb6e010329da2$export$71a894fccabfdcfa);
const $3f0eb6e010329da2$export$71a894fccabfdcfa = {
    name: 'sandbox-relay-defer-jira',
    path: '/jira/software/sandbox/relay/jirasearch',
    exact: true
};

});

parcelRegister("3MJtg", function(module, exports) {

$parcel$export(module.exports, "sandboxJiraPageEntryPoint", () => $0e440ef96c50961e$export$d56ccd62431eaba5);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $9hrB6 = parcelRequire("9hrB6");

const $0e440ef96c50961e$export$d56ccd62431eaba5 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("gXCv4")), {
        moduleId: "ea0eea54",
        moduleName: "SandboxJiraPage",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: tenantContext, context: context })=>{
        return {
            queries: {
                pageQueryRef: {
                    parameters: (0, $9hrB6.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        enableDefer: Boolean('defer' in context.query ? context.query.defer === 'true' : true)
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("9hrB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e77b7f52d9094b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<79cda9a8a207ac397a141bd7897c3537>>
 * @relayHash 3037c8cb08fdd5bd0f2bb8885e4a147b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0191f3cabe6c9edb534f4c87d64645dbe943dea580fe1d42d0e0f5e9710d4ff4
const $8e77b7f52d9094b2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "enableDefer"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SandboxJiraPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "SandboxJiraCriticalData"
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxJiraUserPreferences"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxJiraAiStuff"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "enableDefer",
                                                "variableName": "enableDefer"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "SandboxJiraIssueSearch"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SandboxJiraPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "childIssuesLimit"
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxJiraPageQuery$defer$SandboxJiraUserPreferences_PVNZy",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isIssueViewCrossFlowBannerDismissed"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCustomNavBarThemeFlagDismissed"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxJiraPageQuery$defer$SandboxJiraAiStuff_PVNZy",
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "atlassianIntelligenceProductFeatureInput",
                                            "value": {
                                                "product": "JIRA_SOFTWARE"
                                            }
                                        },
                                        v1 /*: any*/ 
                                    ],
                                    "kind": "ScalarField",
                                    "name": "shouldShowAtlassianIntelligence"
                                },
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "isRovoEnabled"
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxJiraPageQuery$defer$SandboxJiraIssueSearch_1jcU60",
                            "selections": [
                                {
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 10
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "issueSearchInput",
                                            "value": {
                                                "jql": "ORDER BY created DESC"
                                            }
                                        }
                                    ],
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearch",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "idsOrAliases",
                                                                    "value": [
                                                                        "assignee",
                                                                        "reporter",
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "kind": "LinkedField",
                                                            "name": "fieldsByIdOrAlias",
                                                            "plural": true,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "if": "enableDefer",
                                                                    "kind": "Defer",
                                                                    "label": "SandboxJiraIssueWithDeferCard$defer$SandboxJiraIssueFieldEditability",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraIssueField"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isEditableInIssueView"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v3 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraStatus",
                                                                            "kind": "LinkedField",
                                                                            "name": "status",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraStatusField"
                                                                }
                                                            ],
                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"assignee\",\"reporter\",\"status\"])"
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0191f3cabe6c9edb534f4c87d64645dbe943dea580fe1d42d0e0f5e9710d4ff4",
            "metadata": {},
            "name": "SandboxJiraPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8e77b7f52d9094b2$var$node.hash = "1a8ba1e200e80a9f80ac57367382ae4b";
var $8e77b7f52d9094b2$export$2e2bcd8739ae039 = $8e77b7f52d9094b2$var$node;

});

parcelRegister("gXCv4", function(module, exports) {

let $c5900557d5fc5d09$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c5900557d5fc5d09$var$load("gyykG").then(()=>parcelRequire('b0htF'));

});



parcelRegister("5tYtA", function(module, exports) {

$parcel$export(module.exports, "secureFiltersDirectoryRedirectRouteEntry", () => $fb2741403521e011$export$c2ec350ee9e78717);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $jBMV2 = parcelRequire("jBMV2");

var $9NmsS = parcelRequire("9NmsS");

var $hiLFH = parcelRequire("hiLFH");

var $iMFdk = parcelRequire("iMFdk");

var $alJZi = parcelRequire("alJZi");
const $fb2741403521e011$export$c2ec350ee9e78717 = (0, $6xToB.createEntry)((0, $hiLFH.secureFiltersDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $jBMV2.filtersDirectoryResource)
        ],
        component: !false ? (0, $alJZi.FiltersDirectoryRedirect) : (0, $alJZi.FiltersDirectoryComponent),
        skeleton: (0, $iMFdk.FiltersDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).FILTERS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $alJZi.LazyFiltersDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("hiLFH", function(module, exports) {

$parcel$export(module.exports, "secureFiltersDirectoryRedirectRoute", () => $47c22521a29ff53a$export$50796f2aecd63181);
const $47c22521a29ff53a$export$50796f2aecd63181 = {
    name: 'filters-directory-secure-redirect',
    path: '/secure/ManageFilters.jspa'
};

});


parcelRegister("BcNEN", function(module, exports) {

$parcel$export(module.exports, "selectedDashboardRouteEntry", () => $e0db47cbd2b285a3$export$ac09a8d3ecbafc5);

var $kHlOR = parcelRequire("kHlOR");


var $1wb5r = parcelRequire("1wb5r");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $aDdiI = parcelRequire("aDdiI");

var $doZ3p = parcelRequire("doZ3p");

var $en43l = parcelRequire("en43l");
const $e0db47cbd2b285a3$export$ac09a8d3ecbafc5 = (0, $6xToB.createEntry)((0, $aDdiI.selectedDashboardRoute), ()=>({
        group: 'dashboard',
        component: (0, $doZ3p.DashboardRedirect),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $en43l.dashboardResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $en43l.LazyDashboardView)
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$4695c1a423ffe431)
        },
        isRedirect: true,
        earlyAssets: (0, $1wb5r.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("aDdiI", function(module, exports) {

$parcel$export(module.exports, "selectedDashboardRoute", () => $a7a3525a27418403$export$b32070ee9554c3fb);
const $a7a3525a27418403$export$b32070ee9554c3fb = {
    name: 'dashboard-selected',
    path: '/secure/Dashboard.jspa',
    query: [
        'selectPageId'
    ]
};

});


parcelRegister("2uDzR", function(module, exports) {

$parcel$export(module.exports, "servicedeskAtlassianAnalyticsRouteEntry", () => $2d3698a226f9318f$export$94d6674b63b9d647);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $4dwN1 = parcelRequire("4dwN1");

var $1PvPk = parcelRequire("1PvPk");

var $685d7 = parcelRequire("685d7");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $cH29p = parcelRequire("cH29p");
const $2d3698a226f9318f$export$94d6674b63b9d647 = (0, $6xToB.createEntry)((0, $685d7.servicedeskAtlassianAnalyticsRoute), ()=>({
        group: 'servicedesk',
        component: (0, $cH29p.AtlassianAnalytics),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4dwN1.servicedeskAtlassianAnalyticsResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cH29p.LazyAtlassianAnalytics)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ATLASSIAN_ANALYTICS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ATLASSIAN_ANALYTICS),
                teamName: 'ITSM Saga'
            }
        }
    }));

});
parcelRegister("4dwN1", function(module, exports) {

$parcel$export(module.exports, "servicedeskAtlassianAnalyticsResource", () => $be90a76c40395ac5$export$eb2deca89cf3fb61);

var $l1VxS = parcelRequire("l1VxS");


const $be90a76c40395ac5$var$getDataLoader = ()=>(parcelRequire("8jFWp"));
const $be90a76c40395ac5$export$eb2deca89cf3fb61 = (0, $l1VxS.createResource)({
    type: (0, $69de02b4dca0179d$export$73cf43fb073ce577),
    getKey: ()=>'atlassian analytics',
    getDataLoader: $be90a76c40395ac5$var$getDataLoader,
    isBrowserOnly: true
});

});
const $69de02b4dca0179d$export$73cf43fb073ce577 = 'SERVICEDESK_ATLASSIAN_ANALYTICS';

parcelRegister("8jFWp", function(module, exports) {

let $60e0a1b2a6c5501e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $60e0a1b2a6c5501e$var$load("fDKIw").then(()=>parcelRequire('1bupc'));

});


parcelRegister("685d7", function(module, exports) {

$parcel$export(module.exports, "servicedeskAtlassianAnalyticsRoute", () => $0ea22067db16111a$export$399ef3a2d4288bba);
const $0ea22067db16111a$export$399ef3a2d4288bba = {
    name: 'servicedesk-atlassian-analytics',
    path: '/jira/servicedesk/projects/:projectKey/reports/atlassian-analytics',
    exact: true
};

});

parcelRegister("cH29p", function(module, exports) {

$parcel$export(module.exports, "LazyAtlassianAnalytics", () => $a0b47ff3992b08c5$export$78ffe2f6530d45d1);
$parcel$export(module.exports, "AtlassianAnalytics", () => $a0b47ff3992b08c5$export$6d23a188bb96b7ab);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $a0b47ff3992b08c5$export$78ffe2f6530d45d1 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("65hDd"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/atlassian-analytics/src/index.tsx"
});
const $a0b47ff3992b08c5$export$6d23a188bb96b7ab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a0b47ff3992b08c5$export$78ffe2f6530d45d1,
        pageId: "spa-apps/servicedesk/atlassian-analytics",
        shouldShowSpinner: true
    });

});
parcelRegister("65hDd", function(module, exports) {

let $46e0e2fb059c4231$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $46e0e2fb059c4231$var$load("1VRB2"),
    $46e0e2fb059c4231$var$load("bABhq"),
    $46e0e2fb059c4231$var$load("ja9RY")
]).then(()=>parcelRequire('efGEo'));

});



parcelRegister("8hfgf", function(module, exports) {

$parcel$export(module.exports, "servicedeskCalendarRouteEntry", () => $1c40f7abe281227e$export$301bfcedbd0983b7);

var $7jTnu = parcelRequire("7jTnu");

var $iWUAX = parcelRequire("iWUAX");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $5FSZM = parcelRequire("5FSZM");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $cW37W = parcelRequire("cW37W");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $F9BvL = parcelRequire("F9BvL");

var $3NCrh = parcelRequire("3NCrh");
const $1c40f7abe281227e$export$301bfcedbd0983b7 = (0, $6xToB.createEntry)((0, $cW37W.servicedeskCalendarRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm-calendar',
        component: ()=>null,
        skeleton: (0, $F9BvL.ClassicCalendarSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $iWUAX.AsyncViewsNav)
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5FSZM.getCalendarFilterFieldsResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsd_shield_weekly_view_fast_follow') && !false, (0, $c0h8V.uifBoardResource))
        ],
        entryPoint: ()=>(0, $3NCrh.calendarPageEntryPoint),
        meta: {
            reporting: {
                id: 'calendar',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CALENDAR),
                teamName: 'jsd-shield'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("cW37W", function(module, exports) {

$parcel$export(module.exports, "servicedeskCalendarRoute", () => $6a52e1413cb61025$export$28a386a00670c893);
const $6a52e1413cb61025$export$28a386a00670c893 = {
    name: 'servicedesk-calendar',
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/calendar',
    exact: true
};

});

parcelRegister("3NCrh", function(module, exports) {

$parcel$export(module.exports, "calendarPageEntryPoint", () => $eb7b4ca967c641ff$export$eda0c2fb67f7d7e7);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $4mfV8 = parcelRequire("4mfV8");
const $eb7b4ca967c641ff$export$eda0c2fb67f7d7e7 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $4mfV8.calendarEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});


parcelRegister("57C4N", function(module, exports) {

$parcel$export(module.exports, "servicedeskChangeCalendarRouteEntry", () => $a58eb1942729acea$export$de5b915e23c7ce7d);

var $kHlOR = parcelRequire("kHlOR");

var $8rDuZ = parcelRequire("8rDuZ");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $ksbf6 = parcelRequire("ksbf6");

var $1PvPk = parcelRequire("1PvPk");

var $3tvzo = parcelRequire("3tvzo");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $2GFiz = parcelRequire("2GFiz");

var $hQazK = parcelRequire("hQazK");

var $5L7qx = parcelRequire("5L7qx");

var $7jTnu = parcelRequire("7jTnu");

var $b3PSq = parcelRequire("b3PSq");
const $a58eb1942729acea$export$de5b915e23c7ce7d = (0, $6xToB.createEntry)((0, $3tvzo.servicedeskChangeCalendarRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.change-calendar',
        component: (0, $b3PSq.default),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $8rDuZ.AsyncJSMOperationsHorizontalNav),
            onlyShowHorizontalOnNav4: true
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('remove_repackaging_banner_for_change'), (0, $ksbf6.jsmRepackagingBannerResource)),
            (0, $2GFiz.changeCalendarViewSettingsResource),
            (0, $hQazK.changeCalendarFilterSettingsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b3PSq.LazyChangeCalendar),
            (0, $8rDuZ.LazyJSMOperationsHorizontalNav)
        ],
        meta: {
            reporting: {
                id: 'changeCalendar',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CHANGE_CALENDAR),
                teamName: 'jenga'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("8rDuZ", function(module, exports) {

$parcel$export(module.exports, "LazyJSMOperationsHorizontalNav", () => $5f371d9b400d2df5$export$d9802671a2b1aa20);
$parcel$export(module.exports, "AsyncJSMOperationsHorizontalNav", () => $5f371d9b400d2df5$export$d4493569f106c71);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $5f371d9b400d2df5$export$d9802671a2b1aa20 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("bKwX0")).then(({ JSMOperationsHorizontalNav: JSMOperationsHorizontalNav })=>JSMOperationsHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/operations/src/ui/index.tsx"
});
const $5f371d9b400d2df5$export$d4493569f106c71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "horizontal-operations-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "asyncHorizontalOperationsNav",
        packageName: "jiraHorizontalNavJsmOperations",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f371d9b400d2df5$export$d9802671a2b1aa20, null)));

});
parcelRegister("bKwX0", function(module, exports) {

let $88dd8cec297963a2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $88dd8cec297963a2$var$load("1NGHb").then(()=>parcelRequire('8mRWC'));

});


parcelRegister("3tvzo", function(module, exports) {

$parcel$export(module.exports, "servicedeskChangeCalendarRoute", () => $fdafd4bc56333276$export$3dbc16ae422c469);
const $fdafd4bc56333276$export$3dbc16ae422c469 = {
    name: 'servicedesk-change-calendar',
    path: '/jira/servicedesk/projects/:projectKey/change-calendar',
    exact: true
};

});

parcelRegister("2GFiz", function(module, exports) {

$parcel$export(module.exports, "changeCalendarViewSettingsResource", () => $ffd75187e7726871$export$30950a4228efde07);

var $l1VxS = parcelRequire("l1VxS");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $ffd75187e7726871$var$getData = async (routerContext, { tenantContext: tenantContext })=>{
    if (!routerContext.match.params.projectKey) return;
    const { cloudId: cloudId } = tenantContext;
    const { projectKey: projectKey } = routerContext.match.params;
    try {
        const response = await (0, $jGzN3.performGetRequest)(`/gateway/api/jsm/change-management/view/api/v1/cloudId/${cloudId}/settings/project/${projectKey}`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'getChangeCalendarViewSettings',
                packageName: 'jiraRouterResourcesJsmChangeCalendar',
                teamName: 'jenga'
            },
            error: error
        });
        throw error;
    }
};
const $ffd75187e7726871$export$30950a4228efde07 = (0, $l1VxS.createResource)({
    getData: $ffd75187e7726871$var$getData,
    isBrowserOnly: true,
    type: 'CHANGE_CALENDAR_VIEW_SETTINGS_RESOURCE',
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    getKey: ()=>'CHANGE_CALENDAR_VIEW_SETTINGS_RESOURCE'
});

});

parcelRegister("hQazK", function(module, exports) {

$parcel$export(module.exports, "changeCalendarFilterSettingsResource", () => $e6a97725cc84fd93$export$2ec0cc3aa9fdf030);

var $l1VxS = parcelRequire("l1VxS");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $e6a97725cc84fd93$var$getData = async (routerContext, { tenantContext: tenantContext })=>{
    if (!routerContext.match.params.projectKey) return;
    const { cloudId: cloudId } = tenantContext;
    if (!routerContext.query.filterId) return;
    const { filterId: filterId } = routerContext.query;
    try {
        const response = await (0, $jGzN3.performGetRequest)(`/gateway/api/jsm/calendar/cloudid/${cloudId}/v1/change-calendar/filters/${filterId}`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'getChangeCalendarFilterSettings',
                packageName: 'jiraRouterResourcesJsmChangeCalendar',
                teamName: 'jenga'
            },
            error: error
        });
        throw error;
    }
};
const $e6a97725cc84fd93$export$2ec0cc3aa9fdf030 = (0, $l1VxS.createResource)({
    getData: $e6a97725cc84fd93$var$getData,
    isBrowserOnly: true,
    type: 'CHANGE_CALENDAR_FILTER_SETTINGS_RESOURCE',
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    getKey: ({ query: query })=>`CHANGE_CALENDAR_FILTER_SETTINGS_RESOURCE-${query.filterId}`
});

});

parcelRegister("b3PSq", function(module, exports) {

$parcel$export(module.exports, "LazyChangeCalendar", () => $05524ec0ecd6d6f3$export$a6cec2d1c2e631eb);
$parcel$export(module.exports, "default", () => $05524ec0ecd6d6f3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $05524ec0ecd6d6f3$export$a6cec2d1c2e631eb = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("baVE7"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/change-calendar/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$05524ec0ecd6d6f3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $05524ec0ecd6d6f3$export$a6cec2d1c2e631eb,
        pageId: "spa-apps/servicedesk/change-calendar",
        shouldShowSpinner: true
    });

});
parcelRegister("baVE7", function(module, exports) {

let $822d582f2f7267ce$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $822d582f2f7267ce$var$load("1VRB2"),
    $822d582f2f7267ce$var$load("bABhq"),
    $822d582f2f7267ce$var$load("9b6Yk")
]).then(()=>parcelRequire('dY9zr'));

});



parcelRegister("9vC5r", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewCreateRouteEntry", () => $b402e719dae1bbc4$export$b0a16a66af58eb25);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1PvPk = parcelRequire("1PvPk");

var $jW57K = parcelRequire("jW57K");

var $ePaI2 = parcelRequire("ePaI2");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $gy2Qg = parcelRequire("gy2Qg");

var $HGK5Q = parcelRequire("HGK5Q");

var $c72E0 = parcelRequire("c72E0");
const $b402e719dae1bbc4$export$b0a16a66af58eb25 = (0, $6xToB.createEntry)((0, $jW57K.servicedeskCmdbAssetsAnalyticsDataViewCreateRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $HGK5Q.AssetsAnalyticsDataViewCreate),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $HGK5Q.LazyServicedeskCmdbAssetsAnalyticsDataViewCreate)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-create',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_CREATE_PAGE),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("jW57K", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewCreateRoute", () => $49e1e26bc6018617$export$ab4f147f1c700ecd);
const $49e1e26bc6018617$export$ab4f147f1c700ecd = {
    name: 'servicedesk-cmdb-assets-analytics-data-view-create',
    path: '/jira/servicedesk/assets/analytics/data-view/create',
    exact: true
};

});

parcelRegister("HGK5Q", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbAssetsAnalyticsDataViewList", () => $6861df218fcd0df3$export$1a5a30b71ec01594);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsAnalyticsDataViewCreate", () => $6861df218fcd0df3$export$dd5cf457fb6402f7);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsAnalyticsDataViewDetails", () => $6861df218fcd0df3$export$df3c79bc4a19edf1);
$parcel$export(module.exports, "AssetsAnalyticsDataViewList", () => $6861df218fcd0df3$export$a7db3f7bf80b4eb7);
$parcel$export(module.exports, "AssetsAnalyticsDataViewCreate", () => $6861df218fcd0df3$export$fa1e0b9fb89de9d0);
$parcel$export(module.exports, "AssetsAnalyticsDataViewDetails", () => $6861df218fcd0df3$export$3de2c3601c3c1cca);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $6861df218fcd0df3$export$1a5a30b71ec01594 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("lONkQ")).then((exportedMembers)=>exportedMembers.CmdbAssetsAnalyticsDataViewList), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-custom-metrics/src/index.tsx"
});

const $6861df218fcd0df3$export$dd5cf457fb6402f7 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("lONkQ")).then((exportedMembers)=>exportedMembers.CmdbAssetsAnalyticsDataViewCreate), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-custom-metrics/src/index.tsx"
});

const $6861df218fcd0df3$export$df3c79bc4a19edf1 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("lONkQ")).then((exportedMembers)=>exportedMembers.CmdbAssetsAnalyticsDataViewDetails), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-custom-metrics/src/index.tsx"
});
const $6861df218fcd0df3$export$a7db3f7bf80b4eb7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6861df218fcd0df3$export$1a5a30b71ec01594,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-list",
        shouldShowSpinner: true
    });
const $6861df218fcd0df3$export$fa1e0b9fb89de9d0 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6861df218fcd0df3$export$dd5cf457fb6402f7,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-create",
        shouldShowSpinner: true
    });
};
const $6861df218fcd0df3$export$3de2c3601c3c1cca = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6861df218fcd0df3$export$df3c79bc4a19edf1,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-details",
        shouldShowSpinner: true
    });

});
parcelRegister("lONkQ", function(module, exports) {

let $fe24896d50e4bb43$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fe24896d50e4bb43$var$load("fz4eh").then(()=>parcelRequire('2s0Tm'));

});


parcelRegister("c72E0", function(module, exports) {

$parcel$export(module.exports, "AssetsAppRedirect", () => $0a528a52baf56a38$export$5d5d166a9477289f);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $2mHfh = parcelRequire("2mHfh");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");

var $bYOuG = parcelRequire("bYOuG");
const $0a528a52baf56a38$export$5d5d166a9477289f = ({ match: match, query: query })=>{
    const pattern = /\/jira\/servicedesk\/(assets|insight)/;
    let redirectionUrl = match.url.replace(pattern, (0, $bYOuG.ASSETS_APP_ROUTE_PREFIX));
    if (Object.keys(query).length > 0) redirectionUrl += `?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(query)}`;
    const analyticsAttributes = {
        matchedRoute: match.path
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: "assetsAppRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: redirectionUrl,
        push: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
        attributes: analyticsAttributes
    }));
};

});


parcelRegister("4XaE0", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewDetailsRouteEntry", () => $51bec44cb3cf7f69$export$cb82af0ec920487e);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1PvPk = parcelRequire("1PvPk");

var $lCkAD = parcelRequire("lCkAD");

var $ePaI2 = parcelRequire("ePaI2");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $gy2Qg = parcelRequire("gy2Qg");

var $HGK5Q = parcelRequire("HGK5Q");

var $c72E0 = parcelRequire("c72E0");
const $51bec44cb3cf7f69$export$cb82af0ec920487e = (0, $6xToB.createEntry)((0, $lCkAD.servicedeskCmdbAssetsAnalyticsDataViewDetailsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $HGK5Q.AssetsAnalyticsDataViewDetails),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $HGK5Q.LazyServicedeskCmdbAssetsAnalyticsDataViewDetails)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-details',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_DETAILS_PAGE),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("lCkAD", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewDetailsRoute", () => $9c8a514cc3f2866f$export$b024a0a636d7f43e);
const $9c8a514cc3f2866f$export$b024a0a636d7f43e = {
    name: 'servicedesk-cmdb-assets-analytics-data-view-details',
    path: '/jira/servicedesk/assets/analytics/data-view/:dataViewId',
    exact: true
};

});


parcelRegister("3OnXm", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewListRouteEntry", () => $701754a710e60c11$export$79ee0c9fe260269a);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1PvPk = parcelRequire("1PvPk");

var $dzfT8 = parcelRequire("dzfT8");

var $ePaI2 = parcelRequire("ePaI2");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $gy2Qg = parcelRequire("gy2Qg");

var $HGK5Q = parcelRequire("HGK5Q");

var $c72E0 = parcelRequire("c72E0");
const $701754a710e60c11$export$79ee0c9fe260269a = (0, $6xToB.createEntry)((0, $dzfT8.servicedeskCmdbAssetsAnalyticsDataViewListRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $HGK5Q.AssetsAnalyticsDataViewList),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $HGK5Q.LazyServicedeskCmdbAssetsAnalyticsDataViewList)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-list',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_LIST_PAGE),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("dzfT8", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewListRoute", () => $a99e99e3d00ab016$export$9134bfe87d382f51);
const $a99e99e3d00ab016$export$9134bfe87d382f51 = {
    name: 'servicedesk-cmdb-assets-analytics-data-view-list',
    path: '/jira/servicedesk/assets/analytics/data-view',
    exact: true
};

});


parcelRegister("bGvUH", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsGlobalConfigurationRouteEntry", () => $fbe506eaa77b0566$export$6755c90e62150ca0);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $c9q3g = parcelRequire("c9q3g");

var $gy2Qg = parcelRequire("gy2Qg");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $9PWlz = parcelRequire("9PWlz");

var $c72E0 = parcelRequire("c72E0");
const $fbe506eaa77b0566$export$6755c90e62150ca0 = (0, $6xToB.createEntry)((0, $c9q3g.servicedeskCmdbAssetsGlobalConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        ufoName: 'servicedesk-cmdb-assets-configure',
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $9PWlz.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9PWlz.LazyServicedeskCmdbGlobalConfigure)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'aurum'
            }
        }
    }));

});
parcelRegister("c9q3g", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsGlobalConfigurationRoute", () => $5ac6a1d23dbbe619$export$b28679181cd68abd);
const $5ac6a1d23dbbe619$export$b28679181cd68abd = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/assets/configure/global'
};

});

parcelRegister("9PWlz", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbGlobalConfigure", () => $26df75383e148d5d$export$b80bd807bad3fd0a);
$parcel$export(module.exports, "default", () => $26df75383e148d5d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $26df75383e148d5d$export$b80bd807bad3fd0a = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("kzJFr")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-v2/src/index.tsx"
});
const $26df75383e148d5d$var$GlobalConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $26df75383e148d5d$export$b80bd807bad3fd0a,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
var $26df75383e148d5d$export$2e2bcd8739ae039 = $26df75383e148d5d$var$GlobalConfigure;

});


parcelRegister("aWhYZ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectRouteEntry", () => $6ad6dc5569918d4d$export$ed571153b6c25586);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $7PjwP = parcelRequire("7PjwP");

var $6AQho = parcelRequire("6AQho");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $615A2 = parcelRequire("615A2");

var $c72E0 = parcelRequire("c72E0");
const $6ad6dc5569918d4d$export$ed571153b6c25586 = (0, $6xToB.createEntry)((0, $6AQho.servicedeskCmdbAssetsObjectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $615A2.InsightCmdbObjectViewV2),
        resources: [
            ...(0, $f1zun.getCmdbResources)(),
            (0, $7PjwP.insightObjectResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $615A2.LazyServicedeskCmdbObjectV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    }));

});
parcelRegister("6AQho", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectRoute", () => $4a363485ef74a60c$export$bf02944216c526ff);
const $4a363485ef74a60c$export$bf02944216c526ff = {
    name: 'servicedesk-cmdb-object',
    path: '/jira/servicedesk/assets/object/:objectId'
};

});

parcelRegister("615A2", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbObjectV2", () => $ac66cb2ec20f00a5$export$411c1981ced22249);
$parcel$export(module.exports, "InsightCmdbObjectViewV2", () => $ac66cb2ec20f00a5$export$3c208f927c6178ee);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ac66cb2ec20f00a5$export$411c1981ced22249 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("amEmz")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-v2/src/index.tsx"
});
const $ac66cb2ec20f00a5$export$3c208f927c6178ee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ac66cb2ec20f00a5$export$411c1981ced22249,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-v2",
        shouldShowSpinner: true
    });
var $ac66cb2ec20f00a5$export$2e2bcd8739ae039 = $ac66cb2ec20f00a5$export$3c208f927c6178ee;

});


parcelRegister("6S0Dc", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry", () => $02ca52f465a03c42$export$ce7f2af5016c6aa9);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $gBOsl = parcelRequire("gBOsl");

var $fTaqz = parcelRequire("fTaqz");

var $gy2Qg = parcelRequire("gy2Qg");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $drF7O = parcelRequire("drF7O");

var $c72E0 = parcelRequire("c72E0");
const $02ca52f465a03c42$export$ce7f2af5016c6aa9 = (0, $6xToB.createEntry)((0, $fTaqz.servicedeskCmdbAssetsObjectSchemaConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $drF7O.default),
        resources: [
            ...(0, $f1zun.getCmdbResources)(),
            (0, $gBOsl.serviceDeskAssetsImportTypeForgeDataResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $drF7O.LazyServicedeskCmdbObjectSchemaConfiguration)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }));

});
parcelRegister("fTaqz", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaConfigurationRoute", () => $328acf7f8457dbbe$export$b4a150d67181752);
const $328acf7f8457dbbe$export$b4a150d67181752 = {
    name: 'servicedesk-cmdb-object-schema-configuration',
    path: '/jira/servicedesk/assets/configure/object-schema/:objectSchemaId'
};

});

parcelRegister("drF7O", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbObjectSchemaConfiguration", () => $c29065276e0fd4ea$export$8305a1bc1c5bee45);
$parcel$export(module.exports, "default", () => $c29065276e0fd4ea$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $c29065276e0fd4ea$export$8305a1bc1c5bee45 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("iG7lW")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-configuration/src/index.tsx"
});
const $c29065276e0fd4ea$var$ObjectSchemaConfiguration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c29065276e0fd4ea$export$8305a1bc1c5bee45,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema-configuration",
        shouldShowSpinner: true
    });
var $c29065276e0fd4ea$export$2e2bcd8739ae039 = $c29065276e0fd4ea$var$ObjectSchemaConfiguration;

});


parcelRegister("hGerI", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaRouteEntry", () => $5a5c2569a2c40a1f$export$d9dc7083d0a34d11);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $f2URm = parcelRequire("f2URm");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $ofVNb = parcelRequire("ofVNb");

var $c72E0 = parcelRequire("c72E0");
const $5a5c2569a2c40a1f$export$d9dc7083d0a34d11 = (0, $6xToB.createEntry)((0, $f2URm.servicedeskCmdbAssetsObjectSchemaRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $ofVNb.ObjectSchemaV2),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ofVNb.LazyServicedeskCmdbObjectSchemaV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }));

});
parcelRegister("f2URm", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaRoute", () => $55573dbd66668d92$export$6f86804eb594cd29);
const $55573dbd66668d92$export$6f86804eb594cd29 = {
    name: 'servicedesk-cmdb-object-schema',
    path: '/jira/servicedesk/assets/object-schema/:objectSchemaId'
};

});


parcelRegister("6mL7K", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry", () => $57ba5ce0bc54933f$export$d45b927987c92c0e);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $knzIT = parcelRequire("knzIT");

var $gy2Qg = parcelRequire("gy2Qg");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $9e1BD = parcelRequire("9e1BD");

var $c72E0 = parcelRequire("c72E0");
const $57ba5ce0bc54933f$export$d45b927987c92c0e = (0, $6xToB.createEntry)((0, $knzIT.servicedeskCmdbAssetsObjectTypeConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $9e1BD.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9e1BD.LazyServicedeskCmdbConfigureObjectType)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'aurum'
            }
        },
        ufoName: 'service-management.insight-cmdb-object-type-configuration'
    }));

});
parcelRegister("knzIT", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectTypeConfigurationRoute", () => $2d8fc2c68284b2fa$export$73b901e16d5e5a02);
const $2d8fc2c68284b2fa$export$73b901e16d5e5a02 = {
    name: 'servicedesk-cmdb-object-type-configuration',
    path: '/jira/servicedesk/assets/configure/object-type/:objectTypeId'
};

});

parcelRegister("9e1BD", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbConfigureObjectType", () => $21c33c356c37a482$export$926956539e1f72ba);
$parcel$export(module.exports, "default", () => $21c33c356c37a482$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $21c33c356c37a482$export$926956539e1f72ba = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("gYoIL")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-object-type/src/index.tsx"
});
const $21c33c356c37a482$var$InsightConfigureObjectType = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $21c33c356c37a482$export$926956539e1f72ba,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure-object-type",
        shouldShowSpinner: true
    });
var $21c33c356c37a482$export$2e2bcd8739ae039 = $21c33c356c37a482$var$InsightConfigureObjectType;

});


parcelRegister("5S3BI", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsRouteEntry", () => $8feeee187aa08a00$export$2621677b40f03d6c);

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $6zXPf = parcelRequire("6zXPf");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1PvPk = parcelRequire("1PvPk");

var $lnqtD = parcelRequire("lnqtD");

var $gy2Qg = parcelRequire("gy2Qg");

var $ePaI2 = parcelRequire("ePaI2");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $c1dkq = parcelRequire("c1dkq");

var $c72E0 = parcelRequire("c72E0");
const $8feeee187aa08a00$export$2621677b40f03d6c = (0, $6xToB.createEntry)((0, $lnqtD.servicedeskCmdbAssetsReportsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), (0, $c1dkq.AssetsReportsNav4HomePage), (0, $c1dkq.AssetsReportingDefaultRedirect)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c1dkq.LazyServicedeskCmdbDefaultReportsRedirect),
            (0, $c1dkq.LazyServicedeskCmdbAssetsReportsNav4HomePage)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("lnqtD", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsRoute", () => $f9fa15d83ba0dce8$export$a075d8b7c4c55c41);
const $f9fa15d83ba0dce8$export$a075d8b7c4c55c41 = {
    name: 'servicedesk-cmdb-assets-reports-default-redirect',
    path: '/jira/servicedesk/assets/reports',
    exact: true
};

});


parcelRegister("6gpWo", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsTemplateRouteEntry", () => $65e2dc2fec3b80f9$export$51d27be4bd1db6ce);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $5gQb9 = parcelRequire("5gQb9");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1PvPk = parcelRequire("1PvPk");

var $dqVqR = parcelRequire("dqVqR");

var $gy2Qg = parcelRequire("gy2Qg");

var $ePaI2 = parcelRequire("ePaI2");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $c1dkq = parcelRequire("c1dkq");

var $c72E0 = parcelRequire("c72E0");
const $65e2dc2fec3b80f9$export$51d27be4bd1db6ce = (0, $6xToB.createEntry)((0, $dqVqR.servicedeskCmdbAssetsReportsTemplateRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $c1dkq.AssetsReports),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c1dkq.LazyServicedeskCmdbAssetsReports)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $5gQb9.default)
        },
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS),
                teamName: 'ITSM SAGA'
            }
        },
        perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template'
    }));

});
parcelRegister("dqVqR", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsTemplateRoute", () => $b2ca85993999d53a$export$9482cb7f11a7730);
const $b2ca85993999d53a$export$9482cb7f11a7730 = {
    name: 'servicedesk-cmdb-assets-reports',
    path: '/jira/servicedesk/assets/reports/:templateId',
    exact: true
};

});


parcelRegister("iUcGR", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsUnsubscribeRouteEntry", () => $418b5ece5bfd6164$export$5842852f274cd739);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1PvPk = parcelRequire("1PvPk");

var $8PssM = parcelRequire("8PssM");

var $gy2Qg = parcelRequire("gy2Qg");

var $ePaI2 = parcelRequire("ePaI2");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $c1dkq = parcelRequire("c1dkq");

var $c72E0 = parcelRequire("c72E0");
const $418b5ece5bfd6164$export$5842852f274cd739 = (0, $6xToB.createEntry)((0, $8PssM.servicedeskCmdbAssetsReportsUnsubscribeRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $c1dkq.AssetsReportsUnsubscribe),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c1dkq.LazyServicedeskCmdbAssetsReportsUnsubscribe)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("8PssM", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsUnsubscribeRoute", () => $cc84e72415fde3d6$export$66ab60d374e8e458);
const $cc84e72415fde3d6$export$66ab60d374e8e458 = {
    name: 'servicedesk-cmdb-assets-reports-unsubscribe',
    path: '/jira/servicedesk/assets/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});


parcelRegister("2n5BQ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsSchemasRouteEntry", () => $4682ddaa8d2f142d$export$70a75f8d403c935a);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $eqqzA = parcelRequire("eqqzA");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $ipGD4 = parcelRequire("ipGD4");

var $c72E0 = parcelRequire("c72E0");
const $4682ddaa8d2f142d$export$70a75f8d403c935a = (0, $6xToB.createEntry)((0, $eqqzA.servicedeskCmdbAssetsSchemasRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $ipGD4.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ipGD4.LazyServicedeskCmdbLandingPage)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
    }));

});
parcelRegister("eqqzA", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsSchemasRoute", () => $2d7056b98269bd98$export$118f7c2ddb756e80);
const $2d7056b98269bd98$export$118f7c2ddb756e80 = {
    name: 'servicedesk-cmdb-assets',
    path: '/jira/servicedesk/assets',
    exact: true
};

});

parcelRegister("ipGD4", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbLandingPage", () => $9991e7ecbfe44830$export$f6c79e6ff37913ee);
$parcel$export(module.exports, "default", () => $9991e7ecbfe44830$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $9991e7ecbfe44830$export$f6c79e6ff37913ee = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("1kNjT")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-landing-page/src/index.tsx"
});
const $9991e7ecbfe44830$var$LandingPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $9991e7ecbfe44830$export$f6c79e6ff37913ee,
        pageId: "spa-apps/servicedesk/insight/cmdb-landing-page",
        shouldShowSpinner: true
    });
var $9991e7ecbfe44830$export$2e2bcd8739ae039 = $9991e7ecbfe44830$var$LandingPage;

});


parcelRegister("fToBW", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureGlobalRouteEntry", () => $cb8e43e290123184$export$69b479583cd0d13f);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $aXZNL = parcelRequire("aXZNL");

var $gy2Qg = parcelRequire("gy2Qg");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $9PWlz = parcelRequire("9PWlz");

var $c72E0 = parcelRequire("c72E0");
const $cb8e43e290123184$export$69b479583cd0d13f = (0, $6xToB.createEntry)((0, $aXZNL.servicedeskCmdbInsightConfigureGlobalRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        ufoName: 'servicedesk-cmdb-insight-configure-global',
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $9PWlz.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9PWlz.LazyServicedeskCmdbGlobalConfigure)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'aurum'
            }
        }
    }));

});
parcelRegister("aXZNL", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureGlobalRoute", () => $cf33a2baf362ebf9$export$96e5da52356f214c);
const $cf33a2baf362ebf9$export$96e5da52356f214c = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/insight/configure/global'
};

});


parcelRegister("jcgn0", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureRouteEntry", () => $2f48f6ced1838a60$export$277a55a31c82cf0e);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $bVcMD = parcelRequire("bVcMD");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $giUPy = parcelRequire("giUPy");

var $c72E0 = parcelRequire("c72E0");
const $2f48f6ced1838a60$export$277a55a31c82cf0e = (0, $6xToB.createEntry)((0, $bVcMD.servicedeskCmdbInsightConfigureRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        ufoName: 'servicedesk-cmdb-insight-configure',
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $giUPy.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $giUPy.LazyServicedeskCmdbConfigure)
        ]
    }));

});
parcelRegister("bVcMD", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureRoute", () => $b762b8e73d6734e0$export$e960ab4fcd3e80b6);
const $b762b8e73d6734e0$export$e960ab4fcd3e80b6 = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/insight/configure'
};

});

parcelRegister("giUPy", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbConfigure", () => $551d5d4ddc929d78$export$8075d4042713bf6d);
$parcel$export(module.exports, "default", () => $551d5d4ddc929d78$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $551d5d4ddc929d78$export$8075d4042713bf6d = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("1UWtW")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure/src/index.tsx"
});
const $551d5d4ddc929d78$var$InsightConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $551d5d4ddc929d78$export$8075d4042713bf6d,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
var $551d5d4ddc929d78$export$2e2bcd8739ae039 = $551d5d4ddc929d78$var$InsightConfigure;

});
parcelRegister("1UWtW", function(module, exports) {

let $165862b922d97c09$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $165862b922d97c09$var$load("6v8Ia").then(()=>parcelRequire('ax5Nk'));

});



parcelRegister("apCqz", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObject4RouteEntry", () => $0e44f0616802f4ba$export$95574c3333e559d3);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $7PjwP = parcelRequire("7PjwP");

var $e9wXL = parcelRequire("e9wXL");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $615A2 = parcelRequire("615A2");

var $c72E0 = parcelRequire("c72E0");
const $0e44f0616802f4ba$export$95574c3333e559d3 = (0, $6xToB.createEntry)((0, $e9wXL.servicedeskCmdbInsightObject4Route), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $615A2.InsightCmdbObjectViewV2),
        resources: [
            ...(0, $f1zun.getCmdbResources)(),
            (0, $7PjwP.insightObjectResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $615A2.LazyServicedeskCmdbObjectV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    }));

});
parcelRegister("e9wXL", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObject4Route", () => $a2c99b6006f7ed34$export$223f5bacfd3d39fd);
const $a2c99b6006f7ed34$export$223f5bacfd3d39fd = {
    name: 'servicedesk-cmdb-object',
    path: '/jira/servicedesk/insight/assets/:objectId'
};

});


parcelRegister("lkzh1", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaConfigurationRouteEntry", () => $93af2de688a1eeb7$export$261e9b5115dfbb0a);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $hhBy7 = parcelRequire("hhBy7");

var $gy2Qg = parcelRequire("gy2Qg");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $drF7O = parcelRequire("drF7O");

var $c72E0 = parcelRequire("c72E0");
const $93af2de688a1eeb7$export$261e9b5115dfbb0a = (0, $6xToB.createEntry)((0, $hhBy7.servicedeskCmdbInsightObjectSchemaConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $drF7O.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $drF7O.LazyServicedeskCmdbObjectSchemaConfiguration)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }));

});
parcelRegister("hhBy7", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaConfigurationRoute", () => $8833a27b3c426f28$export$f6b688a8729943b3);
const $8833a27b3c426f28$export$f6b688a8729943b3 = {
    name: 'servicedesk-cmdb-object-schema-configuration',
    path: '/jira/servicedesk/insight/configure/object-schema/:objectSchemaId'
};

});


parcelRegister("1tJbT", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaRouteEntry", () => $e6d6211e734953b5$export$192b200c13b0b76a);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $5VsX3 = parcelRequire("5VsX3");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $ofVNb = parcelRequire("ofVNb");

var $c72E0 = parcelRequire("c72E0");
const $e6d6211e734953b5$export$192b200c13b0b76a = (0, $6xToB.createEntry)((0, $5VsX3.servicedeskCmdbInsightObjectSchemaRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $ofVNb.ObjectSchemaV2),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ofVNb.LazyServicedeskCmdbObjectSchemaV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }));

});
parcelRegister("5VsX3", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaRoute", () => $f6b100f9a383d9eb$export$fcde60ded71d4ae6);
const $f6b100f9a383d9eb$export$fcde60ded71d4ae6 = {
    name: 'servicedesk-cmdb-object-schema',
    path: '/jira/servicedesk/insight/object-schemas/:objectSchemaId'
};

});


parcelRegister("1p45F", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectTypeConfigurationRouteEntry", () => $ff2c06999c8b7fe6$export$de4ab140a5dbd984);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $iKdZi = parcelRequire("iKdZi");

var $gy2Qg = parcelRequire("gy2Qg");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $9e1BD = parcelRequire("9e1BD");

var $c72E0 = parcelRequire("c72E0");
const $ff2c06999c8b7fe6$export$de4ab140a5dbd984 = (0, $6xToB.createEntry)((0, $iKdZi.servicedeskCmdbInsightObjectTypeConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $9e1BD.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9e1BD.LazyServicedeskCmdbConfigureObjectType)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'aurum'
            }
        }
    }));

});
parcelRegister("iKdZi", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectTypeConfigurationRoute", () => $06c8b24580c74bd8$export$12e89d5d79d59785);
const $06c8b24580c74bd8$export$12e89d5d79d59785 = {
    name: 'servicedesk-cmdb-object-type-configuration',
    path: '/jira/servicedesk/insight/configure/object-type/:objectTypeId'
};

});


parcelRegister("1IT3x", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightRouteEntry", () => $62b3791ddc46d810$export$3befca4eb012b818);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $5Oo9O = parcelRequire("5Oo9O");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $ipGD4 = parcelRequire("ipGD4");

var $c72E0 = parcelRequire("c72E0");
const $62b3791ddc46d810$export$3befca4eb012b818 = (0, $6xToB.createEntry)((0, $5Oo9O.servicedeskCmdbInsightRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $7jTnu.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $ipGD4.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ipGD4.LazyServicedeskCmdbLandingPage)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
    }));

});
parcelRegister("5Oo9O", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightRoute", () => $566f9346b91d2df6$export$1efada07b7203f2d);
const $566f9346b91d2df6$export$1efada07b7203f2d = {
    name: 'servicedesk-cmdb-insight',
    path: '/jira/servicedesk/insight',
    exact: true
};

});


parcelRegister("eXAfa", function(module, exports) {

$parcel$export(module.exports, "servicedeskConnectProjectRouteEntry", () => $11b88f4bf539bb4e$export$72138a83eeba68eb);

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $7uDgr = parcelRequire("7uDgr");

var $aQoXd = parcelRequire("aQoXd");

var $d8BiX = parcelRequire("d8BiX");

var $dzuEl = parcelRequire("dzuEl");
const $11b88f4bf539bb4e$export$72138a83eeba68eb = (0, $6xToB.createEntry)((0, $7uDgr.servicedeskConnectProjectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $d8BiX.getProjectConnectRouteDefaultResources)(),
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        ufoName: 'jira-connect',
        entryPoint: ()=>(0, $dzuEl.connectProjectsWithoutHorizontalNavPageEntrypoint)
    }));

});
parcelRegister("7uDgr", function(module, exports) {

$parcel$export(module.exports, "servicedeskConnectProjectRoute", () => $0cc01ac14d8708f5$export$148fcbe26061b2c9);

var $3BMxd = parcelRequire("3BMxd");
const $0cc01ac14d8708f5$export$148fcbe26061b2c9 = {
    name: 'servicedesk-connect-project',
    path: '/jira/servicedesk/projects/:projectKey',
    query: (0, $3BMxd.CONNECT_PROJECT_QUERY_PARAMS),
    exact: true
};

});


parcelRegister("WBDy8", function(module, exports) {

$parcel$export(module.exports, "servicedeskCreateProjectRouteEntry", () => $48e0ea5eddeb89c0$export$ac25abe07ac3f570);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $ekxFp = parcelRequire("ekxFp");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $48e0ea5eddeb89c0$var$LazyServiceDeskCreateProject = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("euw0a")), {
    moduleId: "./src/packages/spa-apps/servicedesk/create-project/src/index.tsx"
});
const $48e0ea5eddeb89c0$var$ServiceDeskCreateProject = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $48e0ea5eddeb89c0$var$LazyServiceDeskCreateProject,
        pageId: "spa-apps/servicedesk/create-project",
        shouldShowSpinner: true
    });
const $48e0ea5eddeb89c0$export$ac25abe07ac3f570 = (0, $6xToB.createEntry)((0, $ekxFp.servicedeskCreateProjectRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: $48e0ea5eddeb89c0$var$ServiceDeskCreateProject,
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $48e0ea5eddeb89c0$var$LazyServiceDeskCreateProject
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).CREATE_PROJECT,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CREATE_PROJECT),
                teamName: 'Sequoia'
            }
        }
    }));

});
parcelRegister("ekxFp", function(module, exports) {

$parcel$export(module.exports, "servicedeskCreateProjectRoute", () => $850004015d5f6476$export$1f409a894343952a);
const $850004015d5f6476$export$1f409a894343952a = {
    name: 'servicedesk-create-project',
    path: '/jira/servicedesk/create-project',
    exact: true
};

});

parcelRegister("euw0a", function(module, exports) {

let $a8ccb0e9b51e8a49$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a8ccb0e9b51e8a49$var$load("cq04a").then(()=>parcelRequire('50IoF'));

});


parcelRegister("d0HTh", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomerDetailsRouteEntry", () => $7a254a84f15ea428$export$97ee6e9bb7f7bd31);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $izOHw = parcelRequire("izOHw");

var $3UyX6 = parcelRequire("3UyX6");

var $j5ihh = parcelRequire("j5ihh");

var $gy2Qg = parcelRequire("gy2Qg");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $aQoXd = parcelRequire("aQoXd");

var $dTgRN = parcelRequire("dTgRN");
const $7a254a84f15ea428$export$97ee6e9bb7f7bd31 = (0, $6xToB.createEntry)((0, $j5ihh.servicedeskCustomerDetailsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        component: (0, $dTgRN.ServicedeskCustomerDetails),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dTgRN.LazyServicedeskCustomerDetails)
        ],
        perfMetricKey: 'jsm-customer-details-component-load',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).CUSTOMER_DETAILS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CUSTOMER_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $izOHw.entitlementsCustomerQueryResource),
            (0, $3UyX6.uiCustomerDetailsPageQueryResource)
        ]
    }));

});
parcelRegister("izOHw", function(module, exports) {

$parcel$export(module.exports, "entitlementsCustomerQueryResource", () => $ddae7ed79786dcfb$export$78737979422d6907);

var $9FYIg = parcelRequire("9FYIg");

var $c63re = parcelRequire("c63re");
const $ddae7ed79786dcfb$export$78737979422d6907 = (0, $9FYIg.createRelayResource)({
    type: 'ENTITLEMENTS_CUSTOMER_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $c63re.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("c63re", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d01fc21e0adb92a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d711ace41d650be975013cf5a90d182>>
 * @relayHash 2d56ae07e9224712e6cbeb1d40c0d517
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b6e68492e4403956991e93b2bec1552e11424884520f6d91d362bfb3f950af38
const $6d01fc21e0adb92a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v9 = [
        v7 /*: any*/ ,
        v6 /*: any*/ 
    ], v10 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "entitlementsCustomerQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v2 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v4 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "customerService.productConnections.edges"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW",
                                "path": "customerService.productConnections"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "individualByAccountId",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v7 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "customerService.individualByAccountId.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v7 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": true
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "customerService.individualByAccountId.entitlementList"
                                                },
                                                v8 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceIndividual"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.individualByAccountId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "entitlementsCustomerQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": v9 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "entity",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v9 /*: any*/ ,
                                                            "type": "CustomerServiceOrganization"
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b6e68492e4403956991e93b2bec1552e11424884520f6d91d362bfb3f950af38",
            "metadata": {},
            "name": "entitlementsCustomerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6d01fc21e0adb92a$var$node.hash = "52b18fa6e520ef1142f20ddded30f5ba";
var $6d01fc21e0adb92a$export$2e2bcd8739ae039 = $6d01fc21e0adb92a$var$node;

});


parcelRegister("3UyX6", function(module, exports) {

$parcel$export(module.exports, "uiCustomerDetailsPageQueryResource", () => $e999423d71180dc7$export$d766b4bd7ad23814);

var $9FYIg = parcelRequire("9FYIg");

var $6bDem = parcelRequire("6bDem");
const $e999423d71180dc7$export$d766b4bd7ad23814 = (0, $9FYIg.createRelayResource)({
    type: 'UI_CUSTOMER_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $6bDem.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("6bDem", function(module, exports) {

$parcel$export(module.exports, "default", () => $88f442ce4c7d6ebe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<feb4ddb92be08c0d717024aa5a8194a8>>
 * @relayHash 368df621eebbab5cb9e1cf9ceded10d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c922c068178abaa255d12a88a8254e5b236724d396e47df3f3461e152127536
const $88f442ce4c7d6ebe$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4c922c068178abaa255d12a88a8254e5b236724d396e47df3f3461e152127536",
        "metadata": {},
        "name": "uiCustomerDetailsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $88f442ce4c7d6ebe$export$2e2bcd8739ae039 = $88f442ce4c7d6ebe$var$node;

});


parcelRegister("j5ihh", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomerDetailsRoute", () => $ea312d5b7212e930$export$42c0f04d04ecd1f8);
const $ea312d5b7212e930$export$42c0f04d04ecd1f8 = {
    name: 'servicedesk-customer-details',
    path: '/jira/servicedesk/projects/:projectKey/customers/:customerId',
    exact: true
};

});

parcelRegister("dTgRN", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCustomerDetails", () => $e525c2e3d295a5a4$export$6c5749ec31de847d);
$parcel$export(module.exports, "ServicedeskCustomerDetails", () => $e525c2e3d295a5a4$export$2412523c0e3657cc);
$parcel$export(module.exports, "ServiceDeskContacts", () => $e525c2e3d295a5a4$export$db9de32a8b149a29);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $e525c2e3d295a5a4$export$55118fe902ecc07a = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("clo7A")), {
    moduleId: "./src/packages/spa-apps/servicedesk/contacts/src/index.tsx"
});

const $e525c2e3d295a5a4$export$6c5749ec31de847d = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ekORM"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-details/src/index.tsx"
});
const $e525c2e3d295a5a4$export$2412523c0e3657cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e525c2e3d295a5a4$export$6c5749ec31de847d,
        pageId: "spa-apps/servicedesk/customer-details",
        shouldShowSpinner: true
    });
const $e525c2e3d295a5a4$export$db9de32a8b149a29 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e525c2e3d295a5a4$export$55118fe902ecc07a,
        pageId: "spa-apps/servicedesk/contacts",
        shouldShowSpinner: true
    });

});
parcelRegister("clo7A", function(module, exports) {

let $8fca2833c2ae9def$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $8fca2833c2ae9def$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $8fca2833c2ae9def$var$load("deNlq")
        ]);
    }),
    $8fca2833c2ae9def$var$load("1VRB2"),
    $8fca2833c2ae9def$var$load("bABhq"),
    $8fca2833c2ae9def$var$load("7vqGd"),
    $8fca2833c2ae9def$var$load("1Y4bq"),
    $8fca2833c2ae9def$var$load("87oY9")
]).then(()=>parcelRequire('64wtY'));

});

parcelRegister("ekORM", function(module, exports) {

let $a6fa63f08e6a3a0d$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $a6fa63f08e6a3a0d$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $a6fa63f08e6a3a0d$var$load("deNlq")
        ]);
    }),
    $a6fa63f08e6a3a0d$var$load("1VRB2"),
    $a6fa63f08e6a3a0d$var$load("bABhq"),
    $a6fa63f08e6a3a0d$var$load("7vqGd"),
    $a6fa63f08e6a3a0d$var$load("1Y4bq"),
    $a6fa63f08e6a3a0d$var$load("e10sU")
]).then(()=>parcelRequire('fpjBU'));

});



parcelRegister("43iIQ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomersV2RouteEntry", () => $29da80ea3498e911$export$e1fa279356610d18);

var $kHlOR = parcelRequire("kHlOR");

var $s2Zja = parcelRequire("s2Zja");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $do8sA = parcelRequire("do8sA");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $aQoXd = parcelRequire("aQoXd");

var $dTgRN = parcelRequire("dTgRN");
const $29da80ea3498e911$export$e1fa279356610d18 = (0, $6xToB.createEntry)((0, $do8sA.servicedeskCustomersV2Route), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        component: (0, $dTgRN.ServiceDeskContacts),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        perfMetricKey: 'jsm-customers-component-load',
        ufoName: 'jsm-customers-component-load',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $s2Zja.AsyncDirectoryNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        }
    }));

});
parcelRegister("do8sA", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomersV2Route", () => $88e458035e58b62a$export$89e9e350610ee31e);
const $88e458035e58b62a$export$89e9e350610ee31e = {
    name: 'servicedesk-customers-v2',
    path: '/jira/servicedesk/projects/:projectKey/customers',
    exact: true
};

});


parcelRegister("70DsH", function(module, exports) {

$parcel$export(module.exports, "servicedeskGettingStartedRouteEntry", () => $dcab3c0d94f4f97d$export$e4e0491275df7c2d);

var $g8uYY = parcelRequire("g8uYY");

var $7jTnu = parcelRequire("7jTnu");

var $5RW99 = parcelRequire("5RW99");

var $9pJMP = parcelRequire("9pJMP");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $kEdwd = parcelRequire("kEdwd");

var $9BJU1 = parcelRequire("9BJU1");

var $cZGEd = parcelRequire("cZGEd");

var $aQoXd = parcelRequire("aQoXd");

var $6kIK7 = parcelRequire("6kIK7");

var $bY77X = parcelRequire("bY77X");
const $dcab3c0d94f4f97d$var$gettingStartedPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $bY77X.gettingStartedEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $dcab3c0d94f4f97d$export$e4e0491275df7c2d = (0, $6xToB.createEntry)((0, $cZGEd.servicedeskGettingStartedRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-page-load',
        skeleton: (0, $6kIK7.GettingStartedPageSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $kEdwd.servicedeskIssueTypesResource)
        ],
        entryPoint () {
            return (0, $7jTnu.fg)('gsp_production_rollout') ? $dcab3c0d94f4f97d$var$gettingStartedPageEntryPoint : undefined;
        },
        component: (0, $9BJU1.default)
    }));

});
parcelRegister("cZGEd", function(module, exports) {

$parcel$export(module.exports, "servicedeskGettingStartedRoute", () => $07e0505073aabd09$export$165249c1c8f2e713);
const $07e0505073aabd09$export$165249c1c8f2e713 = {
    name: 'servicedesk-getting-started-page',
    path: '/jira/servicedesk/projects/:projectKey/getting-started',
    exact: true
};

});

parcelRegister("6kIK7", function(module, exports) {

$parcel$export(module.exports, "GettingStartedPageSkeleton", () => $5ae52f2a4a0f090c$export$525669daa9599ec);
/* GettingStartedPageSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $1ZhyK = parcelRequire("1ZhyK");
const $5ae52f2a4a0f090c$var$customCssStyles = null;
const $5ae52f2a4a0f090c$export$525669daa9599ec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1ZhyK))),
        className: (0, $hcewu.default)([
            "_rcuj1wug _o81c1wug _1l6u1wug _149m1wug _701wukw8 _9qarbrur"
        ])
    });

});
parcelRegister("1ZhyK", function(module, exports) {
module.exports = new URL("getting-started-page-app-skeleton.tpl.b9c0d034.svg", import.meta.url).toString();

});


parcelRegister("bY77X", function(module, exports) {

$parcel$export(module.exports, "gettingStartedEntryPoint", () => $c7866e05e3966a7e$export$a91a58d8bb93ad8e);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $c7866e05e3966a7e$export$a91a58d8bb93ad8e = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("ljxnk")), {
        moduleId: "99c912b0",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("ljxnk", function(module, exports) {

let $f84542f85059b4d3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $f84542f85059b4d3$var$load("eDzss"),
    $f84542f85059b4d3$var$load("3PidX")
]).then(()=>parcelRequire('9fBrm'));

});



parcelRegister("4ZKoO", function(module, exports) {

$parcel$export(module.exports, "servicedeskIssueRouteEntry", () => $2b335429284ca985$export$a4bd7206a6659ad3);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $g3m5X = parcelRequire("g3m5X");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $BkBVx = parcelRequire("BkBVx");
const $2b335429284ca985$export$a4bd7206a6659ad3 = (0, $6xToB.createEntry)((0, $g3m5X.servicedeskIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $BkBVx.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            ...(0, $1PvPk.getKnowledgeBaseResources)(),
            ...(0, $1PvPk.getInsightResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $5nfTh.getAIContextPanelResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $BkBVx.LazyServicedeskQueuesIssueViewRedirect)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("g3m5X", function(module, exports) {

$parcel$export(module.exports, "servicedeskIssueRoute", () => $72d1de5122ecf119$export$e146d4ae5415aa9);
const $72d1de5122ecf119$export$e146d4ae5415aa9 = {
    name: 'servicedesk-issue',
    path: '/jira/servicedesk/projects/:projectKey/issue/:issueKey',
    exact: true
};

});

parcelRegister("BkBVx", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesIssueViewRedirect", () => $9848d7602f788974$export$52593b5917c5e179);
$parcel$export(module.exports, "default", () => $9848d7602f788974$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $9848d7602f788974$export$52593b5917c5e179 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("hp0Nq")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view-redirect/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9848d7602f788974$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $9848d7602f788974$export$52593b5917c5e179,
        pageId: "spa-apps/servicedesk/queues/issue-view-redirect",
        shouldShowSpinner: true
    });

});
parcelRegister("hp0Nq", function(module, exports) {

let $cab5639118926d1d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cab5639118926d1d$var$load("cpers").then(()=>parcelRequire('aARrG'));

});



parcelRegister("ebcb6", function(module, exports) {

$parcel$export(module.exports, "servicedeskItsmSampleSpaceRouteEntry", () => $a0a6bcb029e5061c$export$61ad481262acd4e6);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $bMuMb = parcelRequire("bMuMb");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $a0a6bcb029e5061c$var$LazyItsmSampleSpace = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("6HT9J")), {
    moduleId: "./src/packages/spa-apps/servicedesk/itsm-sample-space/src/index.tsx"
});
const $a0a6bcb029e5061c$var$ItsmSampleSpace = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a0a6bcb029e5061c$var$LazyItsmSampleSpace,
        pageId: "spa-apps/servicedesk/itsm-sample-space",
        shouldShowSpinner: true
    });
const $a0a6bcb029e5061c$export$61ad481262acd4e6 = (0, $6xToB.createEntry)((0, $bMuMb.servicedeskItsmSampleSpaceRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: $a0a6bcb029e5061c$var$ItsmSampleSpace,
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $a0a6bcb029e5061c$var$LazyItsmSampleSpace
        ],
        perfMetricKey: 'jsm-sample-space-landing-page',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ITSM_SAMPLE_SPACE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ITSM_SAMPLE_SPACE),
                teamName: 'Sequoia'
            }
        }
    }));

});
parcelRegister("bMuMb", function(module, exports) {

$parcel$export(module.exports, "servicedeskItsmSampleSpaceRoute", () => $86b90d7f0d324d35$export$5bc288fedb880892);
const $86b90d7f0d324d35$export$5bc288fedb880892 = {
    name: 'servicedesk-itsm-sample-space',
    path: '/jira/servicedesk/itsm-sample-space',
    exact: true
};

});

parcelRegister("6HT9J", function(module, exports) {

let $4e218b0d9b521acc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4e218b0d9b521acc$var$load("HNl2p").then(()=>parcelRequire('bpPEC'));

});


parcelRegister("7HZi8", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReports2RouteEntry", () => $2df397c096f6d062$export$c4c0806ea684088);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $c2Apz = parcelRequire("c2Apz");

var $aQoXd = parcelRequire("aQoXd");

var $fAgY2 = parcelRequire("fAgY2");
const $2df397c096f6d062$export$c4c0806ea684088 = (0, $6xToB.createEntry)((0, $c2Apz.servicedeskKbRequestsReports2Route), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.kb-requests',
        component: (0, $fAgY2.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fAgY2.LazyServicedeskKbRequestsReports)
        ]
    }));

});
parcelRegister("c2Apz", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReports2Route", () => $9ec97f82d08b7a6d$export$276e2ed89304d21c);
const $9ec97f82d08b7a6d$export$276e2ed89304d21c = {
    name: 'servicedesk-kb-requests-reports',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)'
};

});

parcelRegister("fAgY2", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKbRequestsReports", () => $333192f636e993ee$export$f86e12b111395ad);
$parcel$export(module.exports, "default", () => $333192f636e993ee$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $333192f636e993ee$export$f86e12b111395ad = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("eo7Ql"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/kb-requests-reports/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$333192f636e993ee$export$2e2bcd8739ae039 = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $333192f636e993ee$export$f86e12b111395ad,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("eo7Ql", function(module, exports) {

let $a799641b92fe82f4$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $a799641b92fe82f4$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $a799641b92fe82f4$var$load("deNlq")
        ]);
    }),
    $a799641b92fe82f4$var$load("1VRB2"),
    $a799641b92fe82f4$var$load("bABhq"),
    $a799641b92fe82f4$var$load("kTkWw")
]).then(()=>parcelRequire('7WEsL'));

});



parcelRegister("lw128", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRouteEntry", () => $7902c6bcfd4f4b56$export$280a79a8f002dd58);

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $gSBJH = parcelRequire("gSBJH");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $dsXZq = parcelRequire("dsXZq");
const $7902c6bcfd4f4b56$export$280a79a8f002dd58 = (0, $6xToB.createEntry)((0, $gSBJH.servicedeskKbRequestsReportsIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $dsXZq.default),
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $5nfTh.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dsXZq.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue'
    }));

});
parcelRegister("gSBJH", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRoute", () => $69ac7bff90e8d811$export$296aa46068d40f43);
const $69ac7bff90e8d811$export$296aa46068d40f43 = {
    name: 'servicedesk-kb-requests-reports-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)/timescale/:timescaleId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("dsXZq", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsIssueView", () => $3da8fb6fdee0e38c$export$c2f0d3c59c9d3bf3);
$parcel$export(module.exports, "default", () => $3da8fb6fdee0e38c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $3da8fb6fdee0e38c$export$c2f0d3c59c9d3bf3 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("acY3R")), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-issue-view/src/index.tsx"
});
var /**
 * Dynamically constructs and renders a lazy-loaded page tailored to specific Servicedesk report views. By leveraging URL parameters such as issue key and timescale ID, it enhances user navigation within the Servicedesk environment by directly accommodating varied user inquiries and historical data perspectives.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$3da8fb6fdee0e38c$export$2e2bcd8739ae039 = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const timescaleId = `/${match.params && match.params.timescaleId || ''}`;
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3da8fb6fdee0e38c$export$c2f0d3c59c9d3bf3,
        pageId: `spa-apps/servicedesk/reports/issue${issueKey}${timescaleId}${oldIssueView}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("acY3R", function(module, exports) {

let $76e99d4abde87c0a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $76e99d4abde87c0a$var$load("7vqGd"),
    $76e99d4abde87c0a$var$load("1Y4bq"),
    $76e99d4abde87c0a$var$load("3vcFV")
]).then(()=>parcelRequire('3nhuO'));

});



parcelRegister("hAgX3", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRouteEntry", () => $85ebf8f8bc712cde$export$1c6b1e308d58ca8b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $fOFx7 = parcelRequire("fOFx7");

var $aQoXd = parcelRequire("aQoXd");

var $fAgY2 = parcelRequire("fAgY2");
const $85ebf8f8bc712cde$export$1c6b1e308d58ca8b = (0, $6xToB.createEntry)((0, $fOFx7.servicedeskKbRequestsReportsTimeScaleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.kb-requests',
        component: (0, $fAgY2.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fAgY2.LazyServicedeskKbRequestsReports)
        ]
    }));

});
parcelRegister("fOFx7", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRoute", () => $03dcde3e23deddd8$export$1585b6f8f1838e19);
const $03dcde3e23deddd8$export$1585b6f8f1838e19 = {
    name: 'servicedesk-kb-requests-reports-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)/timescale/:timescaleId'
};

});


parcelRegister("5xDmP", function(module, exports) {

$parcel$export(module.exports, "servicedeskOncallScheduleRouteEntry", () => $eb6dae7facdd0579$export$36994f6fd22da90e);

var $kHlOR = parcelRequire("kHlOR");

var $8rDuZ = parcelRequire("8rDuZ");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $29Aa1 = parcelRequire("29Aa1");

var $aQoXd = parcelRequire("aQoXd");

var $1Sdgw = parcelRequire("1Sdgw");
const $eb6dae7facdd0579$export$36994f6fd22da90e = (0, $6xToB.createEntry)((0, $29Aa1.servicedeskOncallScheduleRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.on-call-schedule',
        component: (0, $1Sdgw.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $8rDuZ.AsyncJSMOperationsHorizontalNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1Sdgw.LazyServicedeskOpsgenieSchedule),
            (0, $8rDuZ.LazyJSMOperationsHorizontalNav)
        ]
    }));

});
parcelRegister("29Aa1", function(module, exports) {

$parcel$export(module.exports, "servicedeskOncallScheduleRoute", () => $bfc7e65a2db60a5c$export$740e6e5e982b48a9);
const $bfc7e65a2db60a5c$export$740e6e5e982b48a9 = {
    name: 'servicedesk-oncall-schedule',
    path: '/jira/servicedesk/projects/:projectKey/on-call-schedule',
    exact: true
};

});

parcelRegister("1Sdgw", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskOpsgenieSchedule", () => $52a7395995ee09ea$export$e8392650fdcd92d5);
$parcel$export(module.exports, "default", () => $52a7395995ee09ea$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $52a7395995ee09ea$export$e8392650fdcd92d5 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("arZyG")), {
    moduleId: "./src/packages/spa-apps/servicedesk/opsgenie-schedule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$52a7395995ee09ea$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $52a7395995ee09ea$export$e8392650fdcd92d5,
        pageId: "spa-apps/servicedesk/opsgenie-schedule",
        shouldShowSpinner: true
    });

});
parcelRegister("arZyG", function(module, exports) {

let $79bc2d38d3f5fe75$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $79bc2d38d3f5fe75$var$load("gavSJ").then(()=>parcelRequire('bPPZx'));

});



parcelRegister("fKnCL", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationDetailsRouteEntry", () => $8d9bc2bab1187e70$export$a9452a74fdc4d74f);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $czabB = parcelRequire("czabB");

var $3OsCM = parcelRequire("3OsCM");

var $2rGHH = parcelRequire("2rGHH");

var $2rHmc = parcelRequire("2rHmc");

var $4bbnu = parcelRequire("4bbnu");

var $gy2Qg = parcelRequire("gy2Qg");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $aQoXd = parcelRequire("aQoXd");

var $c9Ddi = parcelRequire("c9Ddi");
const $8d9bc2bab1187e70$export$a9452a74fdc4d74f = (0, $6xToB.createEntry)((0, $4bbnu.servicedeskOrganizationDetailsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        component: (0, $c9Ddi.ServicedeskOrganizationDetails),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c9Ddi.LazyServicedeskOrganizationDetails)
        ],
        perfMetricKey: 'jsm-organization-details-component-load',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ORGANIZATION_DETAILS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ORGANIZATION_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $2rGHH.entitlementsOrganizationQueryResource),
            (0, $2rHmc.uiOrganizationDetailsPageQueryResource),
            (0, $3OsCM.productsJsmOrganizationDetailsResource),
            (0, $czabB.jsmEmailDomainsListResource)
        ]
    }));

});
parcelRegister("2rGHH", function(module, exports) {

$parcel$export(module.exports, "entitlementsOrganizationQueryResource", () => $ae75c6ccde1e8f8c$export$fead08d66d56688e);

var $9FYIg = parcelRequire("9FYIg");

var $64ohD = parcelRequire("64ohD");
const $ae75c6ccde1e8f8c$var$getCustomerServiceOrganizationAri = (organizationId, activationId)=>{
    return `ari:cloud:jira-servicedesk::organization/activation/${activationId}/${organizationId}`;
};
const $ae75c6ccde1e8f8c$export$fead08d66d56688e = (0, $9FYIg.createRelayResource)({
    type: 'ENTITLEMENTS_ORGANIZATION_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $64ohD.default),
            variables: {
                organizationId: $ae75c6ccde1e8f8c$var$getCustomerServiceOrganizationAri(String(match.params.organizationId), tenantContext.activationId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("64ohD", function(module, exports) {

$parcel$export(module.exports, "default", () => $000ceb03e98ca137$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5505d7bd1e485943d52683e3e287125b>>
 * @relayHash 4fd7c02cf85ce43ff1f3b2c2885428f1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 01a04225033d1c240e60c2831c34cc958b17cd0c6be52ce6b65c5484adb41a6f
const $000ceb03e98ca137$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizationId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entitlementsOrganizationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "customerService.productConnections.edges"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW",
                                "path": "customerService.productConnections"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v6 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "customerService.organizationByOrganizationId.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v6 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": false
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "customerService.organizationByOrganizationId.entitlementList"
                                                },
                                                v7 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.organizationByOrganizationId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entitlementsOrganizationQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "01a04225033d1c240e60c2831c34cc958b17cd0c6be52ce6b65c5484adb41a6f",
            "metadata": {},
            "name": "entitlementsOrganizationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$000ceb03e98ca137$var$node.hash = "c2dbf2a99cb38657b66de75f23707712";
var $000ceb03e98ca137$export$2e2bcd8739ae039 = $000ceb03e98ca137$var$node;

});


parcelRegister("2rHmc", function(module, exports) {

$parcel$export(module.exports, "uiOrganizationDetailsPageQueryResource", () => $152b3c5382e2edd1$export$ab65064827d1831d);

var $9FYIg = parcelRequire("9FYIg");

var $lNb90 = parcelRequire("lNb90");
const $152b3c5382e2edd1$var$getCustomerServiceOrganizationAri = (organizationId, activationId)=>{
    return `ari:cloud:jira-servicedesk::organization/activation/${activationId}/${organizationId}`;
};
const $152b3c5382e2edd1$export$ab65064827d1831d = (0, $9FYIg.createRelayResource)({
    type: 'UI_ORGANIZATION_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $lNb90.default),
            variables: {
                organizationId: $152b3c5382e2edd1$var$getCustomerServiceOrganizationAri(String(match.params.organizationId), tenantContext.activationId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("lNb90", function(module, exports) {

$parcel$export(module.exports, "default", () => $ead6b1d794658c44$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<08164275d7c73aca9297baa3da2d3967>>
 * @relayHash 572d7a60b6cd2c2d7190bee47f74e0e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8425025856dcdb524ab8c9068e976910d1b94e9aab4d880ce4e0939990c08edf
const $ead6b1d794658c44$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizationId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v8 = {
        "kind": "ScalarField",
        "name": "message"
    }, v9 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "errorType"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiOrganizationDetailsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "details",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "customDetailsSidebar_servicedeskCustomerServiceCustomDetailsSidebar_Inner"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.organizationByOrganizationId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiOrganizationDetailsPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "details",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceCustomDetailValue",
                                                            "kind": "LinkedField",
                                                            "name": "results",
                                                            "plural": true,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canEdit"
                                                                },
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "values"
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailType",
                                                                    "kind": "LinkedField",
                                                                    "name": "type",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "options"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "config",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                                                            "kind": "LinkedField",
                                                                            "name": "styleConfiguration",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionValue"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "style",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "backgroundColour"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "CustomerServiceCustomDetailValues"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "QueryError"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8425025856dcdb524ab8c9068e976910d1b94e9aab4d880ce4e0939990c08edf",
            "metadata": {},
            "name": "uiOrganizationDetailsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ead6b1d794658c44$var$node.hash = "8781f4b4eca174196d95ee737ccdc3aa";
var $ead6b1d794658c44$export$2e2bcd8739ae039 = $ead6b1d794658c44$var$node;

});


parcelRegister("4bbnu", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationDetailsRoute", () => $d82b0e98245fb755$export$eacc4723293cbc36);
const $d82b0e98245fb755$export$eacc4723293cbc36 = {
    name: 'servicedesk-organization-details',
    path: '/jira/servicedesk/projects/:projectKey/organizations/:organizationId',
    exact: true
};

});

parcelRegister("c9Ddi", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskOrganizations", () => $921e1612af0b1641$export$b40b4bfa472057b9);
$parcel$export(module.exports, "ServiceDeskOrganizations", () => $921e1612af0b1641$export$4abec67d7b34dda2);
$parcel$export(module.exports, "LazyServicedeskOrganizationDetails", () => $921e1612af0b1641$export$4a01866152e4a375);
$parcel$export(module.exports, "ServicedeskOrganizationDetails", () => $921e1612af0b1641$export$709be875ca0a7ead);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $921e1612af0b1641$export$b40b4bfa472057b9 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ipKIL"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organizations/src/index.tsx"
});
const $921e1612af0b1641$export$4abec67d7b34dda2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $921e1612af0b1641$export$b40b4bfa472057b9,
        pageId: "spa-apps/servicedesk/organizations",
        shouldShowSpinner: true
    });

const $921e1612af0b1641$export$4a01866152e4a375 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("1nHnb"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organization-details/src/index.tsx"
});
const $921e1612af0b1641$export$709be875ca0a7ead = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $921e1612af0b1641$export$4a01866152e4a375,
        pageId: "spa-apps/servicedesk/organization-details",
        shouldShowSpinner: true
    });

});
parcelRegister("ipKIL", function(module, exports) {

let $d67ecda1ef87e811$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $d67ecda1ef87e811$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $d67ecda1ef87e811$var$load("deNlq")
        ]);
    }),
    $d67ecda1ef87e811$var$load("1VRB2"),
    $d67ecda1ef87e811$var$load("bABhq"),
    $d67ecda1ef87e811$var$load("7vqGd"),
    $d67ecda1ef87e811$var$load("1Y4bq"),
    $d67ecda1ef87e811$var$load("kFOOI")
]).then(()=>parcelRequire('i6O3K'));

});

parcelRegister("1nHnb", function(module, exports) {

let $101995691d873a77$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $101995691d873a77$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $101995691d873a77$var$load("deNlq")
        ]);
    }),
    $101995691d873a77$var$load("1VRB2"),
    $101995691d873a77$var$load("bABhq"),
    $101995691d873a77$var$load("7vqGd"),
    $101995691d873a77$var$load("1Y4bq"),
    $101995691d873a77$var$load("d1R66")
]).then(()=>parcelRequire('aEKbH'));

});



parcelRegister("39J1B", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationsRouteEntry", () => $9cade4b21667ac39$export$cf20fe731144ca3b);

var $kHlOR = parcelRequire("kHlOR");

var $s2Zja = parcelRequire("s2Zja");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6pHN3 = parcelRequire("6pHN3");

var $gy2Qg = parcelRequire("gy2Qg");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $aQoXd = parcelRequire("aQoXd");

var $c9Ddi = parcelRequire("c9Ddi");
const $9cade4b21667ac39$export$cf20fe731144ca3b = (0, $6xToB.createEntry)((0, $6pHN3.servicedeskOrganizationsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        component: (0, $c9Ddi.ServiceDeskOrganizations),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c9Ddi.LazyServicedeskOrganizations)
        ],
        perfMetricKey: 'jsm-organizations-component-load',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $s2Zja.AsyncDirectoryNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ORGANIZATIONS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ORGANIZATIONS),
                teamName: 'boysenberry'
            }
        }
    }));

});
parcelRegister("6pHN3", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationsRoute", () => $f51d0f804cc19e99$export$d4a712c5bc3c3434);
const $f51d0f804cc19e99$export$d4a712c5bc3c3434 = {
    name: 'servicedesk-organizations',
    path: '/jira/servicedesk/projects/:projectKey/organizations',
    exact: true
};

});


parcelRegister("7Toln", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationV2RouteEntry", () => $6d7eb1b58c0db1e7$export$1b6ea96c35c2472c);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $czabB = parcelRequire("czabB");

var $3OsCM = parcelRequire("3OsCM");

var $1PvPk = parcelRequire("1PvPk");

var $at4wb = parcelRequire("at4wb");

var $lEhpY = parcelRequire("lEhpY");

var $aQoXd = parcelRequire("aQoXd");

var $bZvzu = parcelRequire("bZvzu");
const $6d7eb1b58c0db1e7$export$1b6ea96c35c2472c = (0, $6xToB.createEntry)((0, $lEhpY.servicedeskOrganizationV2Route), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $at4wb.serviceDeskOrganizationPanelForgeDataResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $3OsCM.productsJsmOrganizationDetailsResource),
            (0, $czabB.jsmEmailDomainsListResource)
        ],
        component: (0, $bZvzu.ServiceDeskOrganizationV2),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bZvzu.LazyServicedeskOrganizationV2)
        ],
        perfMetricKey: 'jsm-organizations-component-load'
    }));

});
parcelRegister("at4wb", function(module, exports) {

$parcel$export(module.exports, "serviceDeskOrganizationPanelForgeDataResource", () => $e01ad29c35e7b58c$export$f3c46a19f3594363);

var $l1VxS = parcelRequire("l1VxS");


const $e01ad29c35e7b58c$var$getDataLoader = ()=>(parcelRequire("igedT"));
const $e01ad29c35e7b58c$export$f3c46a19f3594363 = (0, $l1VxS.createResource)({
    type: (0, $73af164514e152ad$export$66d6e1e05866ee2f),
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `extension-${projectKey}`;
    },
    getDataLoader: $e01ad29c35e7b58c$var$getDataLoader,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
const $73af164514e152ad$export$66d6e1e05866ee2f = 'ORGANIZATION_PANEL_FORGE_DATA';

parcelRegister("igedT", function(module, exports) {

let $d4b4c106c9e0b669$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d4b4c106c9e0b669$var$load("eZHA9").then(()=>parcelRequire('8pPPY'));

});


parcelRegister("lEhpY", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationV2Route", () => $153c62dfd8829b5d$export$7f878f9aeac61f1e);
const $153c62dfd8829b5d$export$7f878f9aeac61f1e = {
    name: 'servicedesk-organization_v2',
    path: '/jira/servicedesk/projects/:projectKey/organization/:organizationId',
    exact: true
};

});

parcelRegister("bZvzu", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskOrganizationV2", () => $ebf7c027900b582d$export$1c7fcdb58f42db03);
$parcel$export(module.exports, "ServiceDeskOrganizationV2", () => $ebf7c027900b582d$export$5f69663d85db303d);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ebf7c027900b582d$export$1c7fcdb58f42db03 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4gvDq"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organization-v2/src/index.tsx"
});
const $ebf7c027900b582d$export$5f69663d85db303d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ebf7c027900b582d$export$1c7fcdb58f42db03,
        pageId: "spa-apps/servicedesk/organization-v2",
        shouldShowSpinner: true
    });

});
parcelRegister("4gvDq", function(module, exports) {

let $31b1321538d2a43e$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $31b1321538d2a43e$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $31b1321538d2a43e$var$load("deNlq")
        ]);
    }),
    $31b1321538d2a43e$var$load("1VRB2"),
    $31b1321538d2a43e$var$load("bABhq"),
    $31b1321538d2a43e$var$load("7hOia")
]).then(()=>parcelRequire('8Ib5W'));

});



parcelRegister("cTtTO", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksEditRouteEntry", () => $d87196730a6a7af9$export$abfa8cd64fabd80e);

var $7mF43 = parcelRequire("7mF43");

var $igNUx = parcelRequire("igNUx");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $k97SW = parcelRequire("k97SW");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $92nFX = parcelRequire("92nFX");

var $g8uYY = parcelRequire("g8uYY");

var $5HjWp = parcelRequire("5HjWp");

var $kSeQy = parcelRequire("kSeQy");
const $d87196730a6a7af9$var$editEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $92nFX.default),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $d87196730a6a7af9$export$abfa8cd64fabd80e = (0, $6xToB.createEntry)((0, $k97SW.servicedeskPlaybooksEditRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $igNUx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return $d87196730a6a7af9$var$editEntryPoint;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-edit-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('project-settings-playbooks-edit'),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $9BJU1.default),
        ufoName: 'playbook-edit',
        skeleton: (0, $5HjWp.PlaybookEditSkeleton)
    }));

});
parcelRegister("k97SW", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksEditRoute", () => $1f795a91a29828c8$export$5920ce3a2ccf6e2b);
const $1f795a91a29828c8$export$5920ce3a2ccf6e2b = {
    name: 'project-settings-playbooks-edit',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/:playbookId',
    exact: true
};

});

parcelRegister("92nFX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae50ecd7c33eb0e5$export$2e2bcd8739ae039);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

var $LN12I = parcelRequire("LN12I");

var $7jTnu = parcelRequire("7jTnu");

/**
 * NOTE - Please update src/packages/playbooks/edit-screen/src/entrypoint.tsx
 * as that is used in integration test and ideally both should be same except queries
 */ const $ae50ecd7c33eb0e5$var$playbookEditViewEntryPoint = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("8Zomu")), {
        moduleId: "15e5be42",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey, playbookId: playbookId = '' } = context.match.params;
        const { fromPlaybookId: fromPlaybookId = '' } = context.query;
        if (!projectKey) throw new Error('projectKey is required');
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const isNewPlaybook = !!playbookId?.includes($ae50ecd7c33eb0e5$var$NEW_PLAYBOOK_IDENTIFIER);
        const callablePlaybookId = $ae50ecd7c33eb0e5$var$getPlaybookId(playbookId, fromPlaybookId);
        const playbookAri = $ae50ecd7c33eb0e5$var$toPlaybookAri({
            siteId: cloudId,
            activationId: activationId,
            playbookId: callablePlaybookId
        });
        const isNewPlaybookCheck = isNewPlaybook && !fromPlaybookId;
        if (isNewPlaybookCheck) // This is complete new playbook creation
        return {
            extraProps: {
                playbookAri: playbookAri,
                isNew: true,
                variant: 'new'
            }
        };
        return {
            queries: {
                PlaybookDetailQuery: {
                    parameters: (0, $LN12I.default),
                    variables: {
                        playbookAri: playbookAri,
                        jqlFilterSupportEnabled: (0, $7jTnu.fg)('bif-2073-jql-filter-support-playbook')
                    }
                }
            },
            extraProps: {
                playbookAri: playbookAri,
                isNew: false,
                variant: isNewPlaybook && !!fromPlaybookId ? 'copy' : 'edit'
            }
        };
    }
});
var $ae50ecd7c33eb0e5$export$2e2bcd8739ae039 = $ae50ecd7c33eb0e5$var$playbookEditViewEntryPoint;
function $ae50ecd7c33eb0e5$var$toPlaybookAri({ siteId: siteId, activationId: activationId, playbookId: playbookId }) {
    return `ari:cloud:jira:${siteId}:playbook/activation/${activationId}/${playbookId}`;
}
const $ae50ecd7c33eb0e5$var$getPlaybookId = (playbookId, fromPlaybookId)=>{
    if (fromPlaybookId) return fromPlaybookId;
    return playbookId || '';
};
const $ae50ecd7c33eb0e5$var$NEW_PLAYBOOK_IDENTIFIER = '_new_';

});
parcelRegister("LN12I", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c986001d4f10581$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<62fd2d24521bf1b720b287d66f16c390>>
 * @relayHash e9c7e6b4898ee3fc37292a281d66d56b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e46b239ecba29033c61fed267ed511d448fb890bb4309170ec2b9627fe77264f
const $7c986001d4f10581$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e46b239ecba29033c61fed267ed511d448fb890bb4309170ec2b9627fe77264f",
        "metadata": {},
        "name": "PlaybookDetailQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7c986001d4f10581$export$2e2bcd8739ae039 = $7c986001d4f10581$var$node;

});

parcelRegister("8Zomu", function(module, exports) {

let $68b6eafdaedf0ad1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $68b6eafdaedf0ad1$var$load("1VRB2"),
    $68b6eafdaedf0ad1$var$load("bABhq"),
    $68b6eafdaedf0ad1$var$load("eDzss"),
    $68b6eafdaedf0ad1$var$load("7H2va")
]).then(()=>parcelRequire('hcWmc'));

});


parcelRegister("5HjWp", function(module, exports) {

$parcel$export(module.exports, "PlaybookEditSkeleton", () => $f02ebd704904094e$export$8e181e27312cd7a4);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $bL3dk = parcelRequire("bL3dk");
var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");

var $kQDPJ = parcelRequire("kQDPJ");

var $aVwGC = parcelRequire("aVwGC");

var $gfcvC = parcelRequire("gfcvC");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $dQvP5 = parcelRequire("dQvP5");
const $f02ebd704904094e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    returnToList: {
        "id": "playbooks-edit-screen.playbook-item.skeleton.return-to-list",
        "defaultMessage": "Return to list"
    }
});
const $f02ebd704904094e$export$8e181e27312cd7a4 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [playbookListLink] = (0, $dQvP5.useReturnToListUrl)();
    const actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.100",
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kQDPJ.default), {
        appearance: "subtle",
        href: playbookListLink
    }, formatMessage($f02ebd704904094e$export$defe85febe8b728c.returnToList)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        xcss: $f02ebd704904094e$var$containerStyle,
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gfcvC.default), {
        actions: actions,
        disableTitleStyles: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.300",
        direction: "row",
        justifyContent: "space-between",
        xcss: $f02ebd704904094e$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        xcss: $f02ebd704904094e$var$stepCards,
        alignBlock: "start",
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
        height: "52px",
        width: "100%",
        isShimmering: true,
        borderRadius: "8px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
        height: "52px",
        width: "100%",
        isShimmering: true,
        borderRadius: "8px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        xcss: $f02ebd704904094e$var$addButton,
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
        height: "40px",
        width: "40px",
        isShimmering: true,
        borderRadius: "40px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $f02ebd704904094e$var$detailStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
        height: "520px",
        width: "100%",
        isShimmering: true,
        borderRadius: "8px"
    }))));
};
const $f02ebd704904094e$var$containerStyle = (0, $5Wv5g.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    paddingLeft: 'space.300',
    paddingRight: 'space.500',
    height: '100vh'
});
const $f02ebd704904094e$var$detailStyle = (0, $5Wv5g.xcss)({
    maxWidth: '800px',
    minWidth: '440px',
    width: '45%'
});
const $f02ebd704904094e$var$contentStyles = (0, $5Wv5g.xcss)({
    width: '100%',
    paddingTop: 'space.400'
});
const $f02ebd704904094e$var$stepCards = (0, $5Wv5g.xcss)({
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: '30%',
    maxWidth: '600px'
});
const $f02ebd704904094e$var$addButton = (0, $5Wv5g.xcss)({
    height: '52px'
});

});
parcelRegister("dQvP5", function(module, exports) {

$parcel$export(module.exports, "getStepData", () => $90c00a6d3602dc90$export$f1427121561aecf8);
$parcel$export(module.exports, "isStep", () => $90c00a6d3602dc90$export$21684750287da054);
$parcel$export(module.exports, "getJiraPlaybookIdFromARI", () => $90c00a6d3602dc90$export$191a8b6475837449);
$parcel$export(module.exports, "useReturnToListUrl", () => $90c00a6d3602dc90$export$565f39f00aacdb73);
$parcel$export(module.exports, "getIsDescriptionEmpty", () => $90c00a6d3602dc90$export$f11d072d2cef989a);
$parcel$export(module.exports, "getStepsOrder", () => $90c00a6d3602dc90$export$812421dcb7983dd1);
$parcel$export(module.exports, "getStepsDetail", () => $90c00a6d3602dc90$export$aa46de8dc426f402);

var $bSr60 = parcelRequire("bSr60");

var $a8h6X = parcelRequire("a8h6X");

var $2FqDG = parcelRequire("2FqDG");

var $gSuah = parcelRequire("gSuah");
const $90c00a6d3602dc90$export$f1427121561aecf8 = (id, name, type, index)=>{
    return {
        stepId: id,
        name: name,
        index: index,
        type: type
    };
};
const $90c00a6d3602dc90$export$21684750287da054 = (data)=>{
    if (data) {
        const { type: type } = data;
        return type === 'INSTRUCTIONAL_RULE' || type === 'AUTOMATION_RULE';
    }
    return false;
};
const $90c00a6d3602dc90$export$cf6e5a5e05d437ad = (cloudId, activationId, playbookId)=>{
    return (0, $a8h6X.JiraPlaybookAri).create({
        siteId: cloudId,
        activationId: activationId,
        playbookId: playbookId
    }).toString();
};
const $90c00a6d3602dc90$export$191a8b6475837449 = (playbookAri)=>{
    return (0, $a8h6X.JiraPlaybookAri).parse(playbookAri).playbookId;
};
const $90c00a6d3602dc90$export$565f39f00aacdb73 = ()=>{
    const [projectKey = ''] = (0, $2FqDG.usePathParam)('projectKey');
    const playbookListLink = (0, $gSuah.getProjectSettingsPageUrl)(projectKey, 'playbooks');
    return [
        playbookListLink
    ];
};
const $90c00a6d3602dc90$export$f11d072d2cef989a = (description)=>{
    if (description && Object.keys(description).length > 0) return JSON.stringify(description) === JSON.stringify((0, $bSr60.getEmptyADF)());
    return true;
};
const $90c00a6d3602dc90$export$812421dcb7983dd1 = (data)=>{
    return data.map((step)=>step.stepId);
};
const $90c00a6d3602dc90$export$aa46de8dc426f402 = (data)=>{
    const acc = {};
    data.forEach((step)=>{
        acc[step.stepId] = step;
    });
    return acc;
};

});
parcelRegister("bSr60", function(module, exports) {

$parcel$export(module.exports, "getEmptyADF", () => $8800e3af8abb485d$export$d109ab46c9575565);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kEEgd = parcelRequire("kEEgd");
const $8800e3af8abb485d$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("kEEgd", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $aa8118386265920d$export$dd1bc94b04021eeb);
const $aa8118386265920d$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("a8h6X", function(module, exports) {

$parcel$export(module.exports, "JiraPlaybookAri", () => $7607ecaf31f00add$export$2b27259a6ef92c74);

var $3o7lc = parcelRequire("3o7lc");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/playbook/manifest.ts
var $7607ecaf31f00add$var$jiraPlaybookAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $3o7lc.JiraPlaybookAriResourceOwner),
    resourceType: (0, $3o7lc.JiraPlaybookAriResourceType),
    resourceIdSlug: "activation/{activationId}/{playbookId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        playbookId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira/playbook/index.ts
var $7607ecaf31f00add$export$2b27259a6ef92c74 = class _JiraPlaybookAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._playbookId = opts.resourceIdSegmentValues.playbookId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get playbookId() {
        return this._playbookId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7607ecaf31f00add$var$jiraPlaybookAriStaticOpts.qualifier,
            platformQualifier: $7607ecaf31f00add$var$jiraPlaybookAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7607ecaf31f00add$var$jiraPlaybookAriStaticOpts.resourceOwner,
            resourceType: $7607ecaf31f00add$var$jiraPlaybookAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.playbookId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                playbookId: opts.playbookId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $7607ecaf31f00add$var$jiraPlaybookAriStaticOpts);
        return new _JiraPlaybookAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $7607ecaf31f00add$var$jiraPlaybookAriStaticOpts);
        return new _JiraPlaybookAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            playbookId: this.playbookId
        };
    }
};

});
parcelRegister("3o7lc", function(module, exports) {

$parcel$export(module.exports, "JiraPlaybookAriResourceOwner", () => $27794eba312f7687$export$91235105b4a9ebd9);
$parcel$export(module.exports, "JiraPlaybookAriResourceType", () => $27794eba312f7687$export$5af5bf4e6f11326f);
// src/jira/playbook/types.ts
var $27794eba312f7687$export$91235105b4a9ebd9 = "jira", $27794eba312f7687$export$5af5bf4e6f11326f = "playbook";

});


parcelRegister("gSuah", function(module, exports) {

$parcel$export(module.exports, "getProjectUrl", () => $617ab16f323338b8$export$951b86b8e730b952);
$parcel$export(module.exports, "getRequestTypesUrl", () => $617ab16f323338b8$export$9d7c743b509e267);
$parcel$export(module.exports, "getChangeRequestTypesUrl", () => $617ab16f323338b8$export$6096ac65eb900914);
$parcel$export(module.exports, "getProjectSettingsPageUrl", () => $617ab16f323338b8$export$75ee62cffcd82d96);
$parcel$export(module.exports, "getProjectSettingsUrl", () => $617ab16f323338b8$export$a497c8f8c3782075);
$parcel$export(module.exports, "getWorkflowSettingsUrl", () => $617ab16f323338b8$export$c2a8139910ee6c);
$parcel$export(module.exports, "getJsmChangeEditionUrl", () => $617ab16f323338b8$export$b87292f363462760);
$parcel$export(module.exports, "getUserManagementUrl", () => $617ab16f323338b8$export$13f39b40814e5f3e);

var $ln6Iy = parcelRequire("ln6Iy");

var $47Jx0 = parcelRequire("47Jx0");

var $dFfRj = parcelRequire("dFfRj");

var $jmJlK = parcelRequire("jmJlK");

var $gwhEz = parcelRequire("gwhEz");

var $02kpm = parcelRequire("02kpm");
const $617ab16f323338b8$export$951b86b8e730b952 = (projectKey)=>(0, $02kpm.generatePath)((0, $gwhEz.projectsRedirectRoute).path, {
        projectKey: projectKey
    });
const $617ab16f323338b8$var$getNextgenIssueTypesUrl = (projectKey, issueTypeId)=>(0, $47Jx0.getNextgenSettingsIssueTypesUrl)((0, $ln6Iy.SERVICE_DESK_PROJECT), projectKey, issueTypeId);
const $617ab16f323338b8$export$9d7c743b509e267 = (projectKey, isSimplified = false)=>isSimplified ? $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey) : (0, $02kpm.generatePath)((0, $jmJlK.projectSettingsServicedeskTicketTypesConfigRoute).path, {
        projectKey: projectKey
    });
const $617ab16f323338b8$export$6096ac65eb900914 = (projectKey, isSimplified = false)=>isSimplified ? $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey) : `${$617ab16f323338b8$export$9d7c743b509e267(projectKey, isSimplified)}/category/changes`;
const $617ab16f323338b8$export$75ee62cffcd82d96 = (projectKey, relativeUrl)=>`/jira/servicedesk/projects/${projectKey}/settings/${relativeUrl}`;
const $617ab16f323338b8$export$a497c8f8c3782075 = (projectKey, isSimplified = false)=>{
    const classicSettingsUrl = `/plugins/servlet/project-config/${projectKey}`;
    return isSimplified ? $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey) : classicSettingsUrl;
};
const $617ab16f323338b8$export$c2a8139910ee6c = (projectKey, issueTypeId, isSimplified = false)=>{
    if (!issueTypeId) return isSimplified ? $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey) : (0, $02kpm.generatePath)((0, $dFfRj.legacyProjectSettingsWorkflowsRoute).path, {
        projectKey: projectKey
    });
    return isSimplified ? $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey, issueTypeId) : `/plugins/servlet/project-config/${projectKey}/issuetypes/${issueTypeId}/workflow`;
};
const $617ab16f323338b8$export$b87292f363462760 = ()=>'/admin/billing/applications/change-edition/jira-servicedesk.ondemand';
const $617ab16f323338b8$export$13f39b40814e5f3e = ()=>'/admin/users?referrerName=JIRA';

});
parcelRegister("dFfRj", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRoute", () => $d6f76bba36af0fd3$export$b03606cedffdadf6);
const $d6f76bba36af0fd3$export$b03606cedffdadf6 = {
    name: 'legacy-project-settings-workflows',
    path: '/plugins/servlet/project-config/:projectKey/workflows'
};

});





parcelRegister("dP6oq", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksListRouteEntry", () => $b6854d45556a380c$export$19177b8fa44e5e4d);

var $7mF43 = parcelRequire("7mF43");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $9AagY = parcelRequire("9AagY");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1TMtj = parcelRequire("1TMtj");

var $g8uYY = parcelRequire("g8uYY");

var $heGmm = parcelRequire("heGmm");

var $kSeQy = parcelRequire("kSeQy");

var $igNUx = parcelRequire("igNUx");
const $b6854d45556a380c$var$listEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1TMtj.default),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $b6854d45556a380c$export$19177b8fa44e5e4d = (0, $6xToB.createEntry)((0, $9AagY.servicedeskPlaybooksListRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $igNUx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return $b6854d45556a380c$var$listEntryPoint;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $heGmm.playbooksListRequestTypesResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-list-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('project-settings-playbooks-list'),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $9BJU1.default),
        ufoName: 'playbook-list'
    }));

});
parcelRegister("9AagY", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksListRoute", () => $e1335324213a53e9$export$cbed08b5b0671f5f);
const $e1335324213a53e9$export$cbed08b5b0671f5f = {
    name: 'project-settings-playbooks-list',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks',
    exact: true
};

});

parcelRegister("1TMtj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3ce5834aa35721d$export$2e2bcd8739ae039);

var $3onAA = parcelRequire("3onAA");

var $k36i1 = parcelRequire("k36i1");

var $dix9C = parcelRequire("dix9C");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

var $7jTnu = parcelRequire("7jTnu");
// This is for filters on type JiraPlaybookListFilter
const $a3ce5834aa35721d$var$getListFilters = (name, label)=>{
    const filters = {};
    if (name) filters.name = name;
    if (label) filters.labels = [
        label
    ];
    return Object.keys(filters).length > 0 ? filters : null;
};
function $a3ce5834aa35721d$var$getUsageFilter({ name: name, status: status }) {
    const filter = {
        endTime: null,
        name: null,
        startTime: null,
        state: null,
        stepStatus: null,
        stepType: null
    };
    if (name) filter.name = name;
    if (status === 'ENABLED' || status === 'DISABLED') filter.state = status;
    const cleanedFilter = Object.fromEntries(Object.entries(filter).filter(([_, v])=>v !== null));
    return Object.values(cleanedFilter).some(Boolean) ? cleanedFilter : null;
}
function $a3ce5834aa35721d$var$getListPageEntrypoint(tab, cloudId, projectKey, name, label, usageFilter, getFilter) {
    switch(tab){
        case 'logs':
            return {
                preloadedPlaybookLogsEntryPoint: {
                    entryPoint: (0, $k36i1.playbookLogsEntryPoint),
                    entryPointParams: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        first: 20,
                        filter: name ? {
                            name: name
                        } : null
                    }
                }
            };
        case 'usage':
            return {
                preloadedPlaybookUsageEntryPoint: {
                    entryPoint: (0, $dix9C.playbookUsageEntryPoint),
                    entryPointParams: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        first: 20,
                        usageFilter: usageFilter
                    }
                }
            };
        default:
            return {
                preloadedPlaybookListEntryPoint: {
                    entryPoint: (0, $3onAA.playbookListEntryPoint),
                    entryPointParams: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        first: 20,
                        ...(0, $7jTnu.fg)('phantom-3292-playbook-labels') ? {
                            filters: $a3ce5834aa35721d$var$getListFilters(name, label)
                        } : {
                            filter: getFilter()
                        },
                        isFetchingLabels: (0, $7jTnu.fg)('phantom-3292-playbook-labels')
                    }
                }
            };
    }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore Argument of type '{ root: ...; getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => any; }' is not assignable to parameter of type 'never'
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $a3ce5834aa35721d$var$playbookListViewEntryPoint = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("1dmOF")), {
        moduleId: "a498670b",
        priority: "interaction"
    }),
    // This has been causing build errors in unrelated code. Broadening type to fix build.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        const { tab: tab = 'list', name: name = '', status: status, label: label = '' } = context.query;
        if (!projectKey) throw new Error('projectKey is required');
        const getFilter = ()=>{
            if ((0, $7jTnu.fg)('phantom-playbook-save-as-draft')) {
                const filter = {};
                const state = $a3ce5834aa35721d$var$getStateFromStatus(status);
                if (name) filter.name = name;
                if (state) filter.state = state;
                return Object.values(filter).some(Boolean) ? filter : null;
            }
            return name ? {
                name: name
            } : null;
        };
        const usageFilter = (0, $7jTnu.fg)('enable_usage_tab') ? $a3ce5834aa35721d$var$getUsageFilter({
            name: name,
            status: status
        }) : null;
        let entryPoints;
        if ((0, $7jTnu.fg)('enable_usage_tab')) entryPoints = $a3ce5834aa35721d$var$getListPageEntrypoint(tab, tenantContext.cloudId, projectKey, name, label, usageFilter, getFilter);
        else // In case where tab is logs, we need to load the logs entry point
        // For other cases, fallback to the list entry point. This matches the current logic in the UI component.
        entryPoints = tab === 'logs' ? {
            preloadedPlaybookLogsEntryPoint: {
                entryPoint: (0, $k36i1.playbookLogsEntryPoint),
                entryPointParams: {
                    cloudId: tenantContext.cloudId,
                    projectKey: projectKey,
                    first: 20,
                    filter: name ? {
                        name: name
                    } : null
                }
            }
        } : {
            preloadedPlaybookListEntryPoint: {
                entryPoint: (0, $3onAA.playbookListEntryPoint),
                entryPointParams: {
                    cloudId: tenantContext.cloudId,
                    projectKey: projectKey,
                    first: 20,
                    ...(0, $7jTnu.fg)('phantom-3292-playbook-labels') ? {
                        filters: $a3ce5834aa35721d$var$getListFilters(name, label)
                    } : {
                        filter: getFilter()
                    },
                    isFetchingLabels: (0, $7jTnu.fg)('phantom-3292-playbook-labels')
                }
            }
        };
        return {
            extraProps: {
                accountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                projectId: context.query.projectId,
                projectKey: context.match.params.projectKey
            },
            entryPoints: entryPoints
        };
    }
});
var $a3ce5834aa35721d$export$2e2bcd8739ae039 = $a3ce5834aa35721d$var$playbookListViewEntryPoint;
const $a3ce5834aa35721d$var$getStateFromStatus = (status)=>{
    switch(status){
        case 'on':
            return 'ENABLED';
        case 'off':
            return 'DISABLED';
        case 'draft':
            return 'DRAFT';
        default:
            return undefined;
    }
};

});
parcelRegister("3onAA", function(module, exports) {

$parcel$export(module.exports, "playbookListEntryPoint", () => $03d10095880dc7de$export$d7be5d3b24f1d526);

var $hYpFY = parcelRequire("hYpFY");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $03d10095880dc7de$export$d7be5d3b24f1d526 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("czofG")).then((module)=>module.PlaybookList), {
        moduleId: "3f3b7cb0",
        moduleName: "PlaybookList",
        priority: "userVisible"
    }),
    getPreloadProps: (variables)=>{
        return {
            queries: {
                PlaybookListQuery: {
                    parameters: (0, $hYpFY.default),
                    variables: variables
                }
            }
        };
    }
});

});
parcelRegister("hYpFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b61c51f4dac2b90$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6d39a0c2462d19df68c0191f4833efd7>>
 * @relayHash d788a2aeb0fae4e4d80ce25d45d7e74f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdf7c38cb5d05b42232405fd538e660889cd2b346e28cb4ec030b80fd1714083
const $7b61c51f4dac2b90$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fdf7c38cb5d05b42232405fd538e660889cd2b346e28cb4ec030b80fd1714083",
        "metadata": {},
        "name": "PlaybookListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7b61c51f4dac2b90$export$2e2bcd8739ae039 = $7b61c51f4dac2b90$var$node;

});

parcelRegister("czofG", function(module, exports) {

let $926b90d9dce579c9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $926b90d9dce579c9$var$load("fnZ5f").then(()=>parcelRequire('eJKC4'));

});


parcelRegister("k36i1", function(module, exports) {

$parcel$export(module.exports, "playbookLogsEntryPoint", () => $c74f3dd1ab1fa184$export$7ebe0f850472ea07);

var $j3Ybe = parcelRequire("j3Ybe");

var $cNVVt = parcelRequire("cNVVt");

var $4BK1O = parcelRequire("4BK1O");

const $c74f3dd1ab1fa184$export$7ebe0f850472ea07 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("8EiBB")), {
        moduleId: "c3ca80f1",
        moduleName: "PlaybookLogs",
        priority: "userVisible"
    }),
    getPreloadProps: (variables)=>({
            queries: {
                PlaybookLogsQuery: {
                    parameters: (0, $cNVVt.default),
                    variables: variables
                }
            }
        })
});

});
parcelRegister("cNVVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $abfd91f921f593b8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<15280667f706316750b55d64796fb790>>
 * @relayHash c197bbece789e4cb329e128453687570
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 565606802eb0a72ceab02256a296b8539bab587a529cc4b38118031f77bf14d2
const $abfd91f921f593b8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "565606802eb0a72ceab02256a296b8539bab587a529cc4b38118031f77bf14d2",
        "metadata": {},
        "name": "PlaybookLogsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $abfd91f921f593b8$export$2e2bcd8739ae039 = $abfd91f921f593b8$var$node;

});

parcelRegister("8EiBB", function(module, exports) {

let $64c07dd3ee5f55f5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $64c07dd3ee5f55f5$var$load("bQpWe").then(()=>parcelRequire('9rDEK'));

});


parcelRegister("dix9C", function(module, exports) {

$parcel$export(module.exports, "playbookUsageEntryPoint", () => $2eb01bbc5748d004$export$acf5774377e79928);

var $5eTWL = parcelRequire("5eTWL");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $2eb01bbc5748d004$export$acf5774377e79928 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("9W7rJ")).then((module)=>module.PlaybookUsage), {
        moduleId: "f44e79ab",
        moduleName: "PlaybookUsage",
        priority: "userVisible"
    }),
    getPreloadProps: (variables)=>{
        return {
            queries: {
                PlaybookUsageQuery: {
                    parameters: (0, $5eTWL.default),
                    variables: variables
                }
            }
        };
    }
});

});
parcelRegister("5eTWL", function(module, exports) {

$parcel$export(module.exports, "default", () => $32a6a38dfdb1d392$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f7ba598fab94e932f31527824e7866a2>>
 * @relayHash c76a0108f60c565783452e6658a3cf18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ec0a456168b3b9b4a9c87ab77c8fe13240bb085fd5d2df1530d3abc4c6d359f
const $32a6a38dfdb1d392$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1ec0a456168b3b9b4a9c87ab77c8fe13240bb085fd5d2df1530d3abc4c6d359f",
        "metadata": {},
        "name": "PlaybookUsageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32a6a38dfdb1d392$export$2e2bcd8739ae039 = $32a6a38dfdb1d392$var$node;

});

parcelRegister("9W7rJ", function(module, exports) {

let $73bf4e88c1a63698$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $73bf4e88c1a63698$var$load("lNbRy").then(()=>parcelRequire('kn9Jn'));

});


parcelRegister("1dmOF", function(module, exports) {

let $0e28b42f3c53dc9c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0e28b42f3c53dc9c$var$load("3xaEF").then(()=>parcelRequire('dEERs'));

});


parcelRegister("heGmm", function(module, exports) {

$parcel$export(module.exports, "playbooksListRequestTypesResource", () => $fdcc282ddf971443$export$43f774aa05fabd18);

var $l1VxS = parcelRequire("l1VxS");


var $5j85B = parcelRequire("5j85B");

var $jGzN3 = parcelRequire("jGzN3");
const $fdcc282ddf971443$export$43f774aa05fabd18 = (0, $l1VxS.createResource)({
    type: 'PLAYBOOKS-LIST-REQUEST-TYPES-RESOURCE-TYPE',
    getKey: ({ match: match })=>{
        const projectKey = match.params.projectKey;
        return `playbooksListRequestTypesResource-${projectKey}`;
    },
    getData: async ({ dependencies: dependencies })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { projectId: projectId } = await (0, $5j85B.consumeDependency)(dependencies, (0, $c8eeacd6960f72dc$export$80a60a092d9ab81));
        return (0, $jGzN3.performGetRequest)($fdcc282ddf971443$var$getRequestTypesUrl(projectId)).then((response)=>response.ticketTypes);
    },
    maxAge: 300000,
    depends: [
        (0, $c8eeacd6960f72dc$export$80a60a092d9ab81)
    ]
});
const $fdcc282ddf971443$var$getRequestTypesUrl = (projectId)=>`/rest/servicedesk/1/servicedesk/${projectId}/request-types`;

});


parcelRegister("1cWr6", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeEditRouteEntry", () => $5e57647a9d2d6ff1$export$5d9efd0f838d30a1);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $kUiQk = parcelRequire("kUiQk");

var $aQoXd = parcelRequire("aQoXd");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $6sU1E = parcelRequire("6sU1E");

var $5NcGG = parcelRequire("5NcGG");

var $eOSoz = parcelRequire("eOSoz");
const $5e57647a9d2d6ff1$export$5d9efd0f838d30a1 = (0, $6xToB.createEntry)((0, $kUiQk.servicedeskPracticeEditRoute), ()=>({
        group: 'servicedesk',
        component: (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $5NcGG.ServicedeskQueuesConfig), (0, $6sU1E.default)),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            ...(0, $1PvPk.getIssueListSsrResource)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $1PvPk.getQueueConfigResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $5NcGG.LazyServicedeskQueuesConfig) : (0, $6sU1E.LazyServicedeskQueuesEditView)
        ],
        pageId: ({ query: query, match: match })=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $eOSoz.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("kUiQk", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeEditRoute", () => $68064f83de6ba407$export$dfaa99f66db1aa2);
const $68064f83de6ba407$export$dfaa99f66db1aa2 = {
    name: 'servicedesk-practice-edit',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit',
    exact: true,
    query: [
        'config?'
    ]
};

});

parcelRegister("6sU1E", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesEditView", () => $cfee4b7b9daa6dd6$export$5bb02347e0261e6a);
$parcel$export(module.exports, "default", () => $cfee4b7b9daa6dd6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $cfee4b7b9daa6dd6$export$5bb02347e0261e6a = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("d839T"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-edit-view/src/index.tsx"
});
var /**
 * @deprecated Remove this when fsm_views_inside_queues_-_main_flag is cleaned up
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$cfee4b7b9daa6dd6$export$2e2bcd8739ae039 = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cfee4b7b9daa6dd6$export$5bb02347e0261e6a,
        pageId: `spa-apps/servicedesk/queues/edit/${queueId}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("d839T", function(module, exports) {

let $98ee78f77539b701$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $98ee78f77539b701$var$load("1VRB2"),
    $98ee78f77539b701$var$load("bABhq"),
    $98ee78f77539b701$var$load("dliHm")
]).then(()=>parcelRequire('3mMPp'));

});


parcelRegister("5NcGG", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesConfig", () => $6c90f90f2236a9c9$export$8bc01f18d5db1178);
$parcel$export(module.exports, "ServicedeskQueuesConfig", () => $6c90f90f2236a9c9$export$ac10b7696844d33);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $2mHfh = parcelRequire("2mHfh");

const $6c90f90f2236a9c9$export$8bc01f18d5db1178 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8CFLn")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-config/src/index.tsx"
});
const $6c90f90f2236a9c9$export$ac10b7696844d33 = (props)=>{
    const { query: query } = props;
    // If URL is from edit queue, then redirect to the new URL with config query param
    if (!query.config) {
        const { config: config, ...restQuery } = query;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: {
                pathname: `${props.location.pathname}`,
                hash: '',
                search: (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
                    ...restQuery,
                    config: 'queueConfig'
                })
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6c90f90f2236a9c9$export$8bc01f18d5db1178,
        pageId: `spa-apps/servicedesk/queues/config/${query.config}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("8CFLn", function(module, exports) {

let $6472449e344c0f2d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6472449e344c0f2d$var$load("1VRB2"),
    $6472449e344c0f2d$var$load("bABhq"),
    $6472449e344c0f2d$var$load("cM1Uy")
]).then(()=>parcelRequire('8zm0a'));

});


parcelRegister("eOSoz", function(module, exports) {

$parcel$export(module.exports, "serviceDeskQueuesConfigPageEntryPoint", () => $d5f3ccd5f8ac5b8e$export$2a7296eb9b68414);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $8WAqO = parcelRequire("8WAqO");
const $d5f3ccd5f8ac5b8e$export$2a7296eb9b68414 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8WAqO.queuesConfigEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("8WAqO", function(module, exports) {

$parcel$export(module.exports, "queuesConfigEntrypoint", () => $e6a30f8a0d69b8d6$export$bc016338e2032123);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $2BUDW = parcelRequire("2BUDW");

var $bBtQo = parcelRequire("bBtQo");

var $7Bvm5 = parcelRequire("7Bvm5");

var $kRskq = parcelRequire("kRskq");

const $e6a30f8a0d69b8d6$export$bc016338e2032123 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>{
        return (parcelRequire("8CFLn"));
    }, {
        moduleId: "2bb3c6f1",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: match, query: query, route: route }, tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        const queueId = match.params.queueId;
        let { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
        projectKey = projectKey ?? '';
        const queueAri = queueId ? (0, $2BUDW.JiraServicedeskQueueAri).create({
            siteId: cloudId,
            queueId: queueId || '',
            activationId: activationId
        }).toString() : '';
        const input = queueAri ? {
            scopeId: queueAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                mainSettingsNavigationQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $kRskq.default),
                    variables: {
                        input: input,
                        first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            },
            extraProps: {
                query: query,
                match: match,
                route: route
            }
        };
    }
});

});
parcelRegister("kRskq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf0f49f93759bda$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<520492a88531f13890827de041b3c928>>
 * @relayHash dfd06866fddd95df7034205febe8eb4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9b239a41299b531cf29a09d8abbeb2cf530d1715b2ea22ad115bc7f31e5f68f9
const $ccf0f49f93759bda$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v7 /*: any*/ 
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = [
        v6 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                v7 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainSettingsNavigationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "concreteType": "JiraNavigationItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "navigationItems",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraNavigationItemEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "jira.containerNavigation.navigationItems.edges.node"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "jira.containerNavigation.navigationItems.edges"
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "errors",
                                                            "plural": true,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.containerNavigation"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainSettingsNavigationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v10 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9b239a41299b531cf29a09d8abbeb2cf530d1715b2ea22ad115bc7f31e5f68f9",
            "metadata": {},
            "name": "mainSettingsNavigationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ccf0f49f93759bda$var$node.hash = "a86c2910ccbf2af4328e8f1d666e319c";
var $ccf0f49f93759bda$export$2e2bcd8739ae039 = $ccf0f49f93759bda$var$node;

});




parcelRegister("e2eAj", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeIssueRouteEntry", () => $9e4b655f1cc669e8$export$ff51f5ad948cb987);

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lBzUC = parcelRequire("lBzUC");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $agdZX = parcelRequire("agdZX");
const $9e4b655f1cc669e8$export$ff51f5ad948cb987 = (0, $6xToB.createEntry)((0, $lBzUC.servicedeskPracticeIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $agdZX.default),
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            ...(0, $1PvPk.getKnowledgeBaseResources)(),
            ...(0, $1PvPk.getInsightResources)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $5nfTh.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $agdZX.LazyServicedeskQueuesIssueView)
        ]
    }));

});
parcelRegister("lBzUC", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeIssueRoute", () => $281b9b0e67e830ce$export$38a6ee0f22e74bf3);
const $281b9b0e67e830ce$export$38a6ee0f22e74bf3 = {
    name: 'servicedesk-practice-issue',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/issue/:issueKey',
    exact: true
};

});

parcelRegister("agdZX", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesIssueView", () => $836d24b8148d73e9$export$164f2dfdd8dc056b);
$parcel$export(module.exports, "default", () => $836d24b8148d73e9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $836d24b8148d73e9$export$164f2dfdd8dc056b = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("gZEzv")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view/src/index.tsx"
});
var /**
 * Constructs a URL path for navigating to a specific issue view within a service desk queue, incorporating optional parameters for issue identification and view customization.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$836d24b8148d73e9$export$2e2bcd8739ae039 = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const queueId = `/${match.params && match.params.queueId || ''}`;
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $836d24b8148d73e9$export$164f2dfdd8dc056b,
        pageId: `spa-apps/servicedesk/queues/issue${queueId}${issueKey}${oldIssueView}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("gZEzv", function(module, exports) {

let $c5f1d084ffa697a3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $c5f1d084ffa697a3$var$load("7vqGd"),
    $c5f1d084ffa697a3$var$load("1Y4bq"),
    $c5f1d084ffa697a3$var$load("64Mob")
]).then(()=>parcelRequire('cR5Ec'));

});



parcelRegister("hhVkJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeLandingRouteEntry", () => $fcc0b74cb2aae620$export$881d545af6c177f1);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $04ZHJ = parcelRequire("04ZHJ");

var $aQoXd = parcelRequire("aQoXd");

var $iY8Cx = parcelRequire("iY8Cx");
const $fcc0b74cb2aae620$export$881d545af6c177f1 = (0, $6xToB.createEntry)((0, $04ZHJ.servicedeskPracticeLandingRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: (0, $iY8Cx.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iY8Cx.LazyServicedeskQueuesLanding)
        ]
    }));

});
parcelRegister("04ZHJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeLandingRoute", () => $1e58439fa4c850cc$export$3c859c71be33b36c);
const $1e58439fa4c850cc$export$3c859c71be33b36c = {
    name: 'servicedesk-practice-landing',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/(custom)?',
    exact: true
};

});

parcelRegister("iY8Cx", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesLanding", () => $4fe67311b7d50fbd$export$bdf522692228bb6f);
$parcel$export(module.exports, "default", () => $4fe67311b7d50fbd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $4fe67311b7d50fbd$export$bdf522692228bb6f = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("biGky")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-landing/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4fe67311b7d50fbd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4fe67311b7d50fbd$export$bdf522692228bb6f,
        pageId: "spa-apps/servicedesk/queues/landing",
        shouldShowSpinner: true
    });

});
parcelRegister("biGky", function(module, exports) {

let $83a23620ebbd1000$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $83a23620ebbd1000$var$load("1VRB2"),
    $83a23620ebbd1000$var$load("bABhq"),
    $83a23620ebbd1000$var$load("7US36")
]).then(()=>parcelRequire('9SG4h'));

});



parcelRegister("kD0Ge", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeManageViewRouteEntry", () => $5f03f95b3578a6f9$export$4e1b0df2a8fcae78);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $eZFVv = parcelRequire("eZFVv");

var $aQoXd = parcelRequire("aQoXd");

var $9btrJ = parcelRequire("9btrJ");
const $5f03f95b3578a6f9$export$4e1b0df2a8fcae78 = (0, $6xToB.createEntry)((0, $eZFVv.servicedeskPracticeManageViewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $9btrJ.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: (0, $1PvPk.getQueuesResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9btrJ.LazyServicedeskQueuesManageView)
        ]
    }));

});
parcelRegister("eZFVv", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeManageViewRoute", () => $d84c7900692414fc$export$125e0ab662806584);
const $d84c7900692414fc$export$125e0ab662806584 = {
    name: 'servicedesk-practice-manage-view',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/queue-settings',
    exact: true
};

});

parcelRegister("9btrJ", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesManageView", () => $e7e908cf8bd7d464$export$9f1e189198f08c4a);
$parcel$export(module.exports, "default", () => $e7e908cf8bd7d464$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $e7e908cf8bd7d464$export$9f1e189198f08c4a = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("cq3aD"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-manage-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e7e908cf8bd7d464$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e7e908cf8bd7d464$export$9f1e189198f08c4a,
        pageId: "spa-apps/servicedesk/queues/manage",
        shouldShowSpinner: true
    });

});
parcelRegister("cq3aD", function(module, exports) {

let $90aa5f5330886110$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $90aa5f5330886110$var$load("dGy2L").then(()=>parcelRequire('eONcC'));

});



parcelRegister("gEBbt", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeNewRouteEntry", () => $32d4fbcd3f9e60a7$export$50a04ec00cb8039);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $5SFrC = parcelRequire("5SFrC");

var $aQoXd = parcelRequire("aQoXd");

var $96Gso = parcelRequire("96Gso");
const $32d4fbcd3f9e60a7$export$50a04ec00cb8039 = (0, $6xToB.createEntry)((0, $5SFrC.servicedeskPracticeNewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $96Gso.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $96Gso.LazyServicedeskQueuesCreateView)
        ]
    }));

});
parcelRegister("5SFrC", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeNewRoute", () => $995883df4293705a$export$8595a5452f93a1fd);
const $995883df4293705a$export$8595a5452f93a1fd = {
    name: 'servicedesk-practice-new',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};

});

parcelRegister("96Gso", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesCreateView", () => $79eb422bb41dddf8$export$c050b699bf9e3e40);
$parcel$export(module.exports, "default", () => $79eb422bb41dddf8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $79eb422bb41dddf8$export$c050b699bf9e3e40 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ftFY7"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-create-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$79eb422bb41dddf8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $79eb422bb41dddf8$export$c050b699bf9e3e40,
        pageId: "spa-apps/servicedesk/queues/create",
        shouldShowSpinner: true
    });

});
parcelRegister("ftFY7", function(module, exports) {

let $b44a1e9133497727$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $b44a1e9133497727$var$load("1VRB2"),
    $b44a1e9133497727$var$load("bABhq"),
    $b44a1e9133497727$var$load("3GBE1")
]).then(()=>parcelRequire('9bkHc'));

});



parcelRegister("2PL7S", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeViewsConfigRouteEntry", () => $96e25e34844225aa$export$101c882abd4d051);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $gmklX = parcelRequire("gmklX");

var $aQoXd = parcelRequire("aQoXd");

var $dZRaT = parcelRequire("dZRaT");

var $7jTnu = parcelRequire("7jTnu");

var $9BJU1 = parcelRequire("9BJU1");

var $f2JN3 = parcelRequire("f2JN3");

var $eOSoz = parcelRequire("eOSoz");

var $igFet = parcelRequire("igFet");
const $96e25e34844225aa$export$101c882abd4d051 = (0, $6xToB.createEntry)((0, $gmklX.servicedeskPracticeViewsConfigRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            ...(0, $1PvPk.getQueueViewConfigResource)(),
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $igFet.LazyServicedeskQueuesViewsConfig)
        ],
        ufoName: 'service-management.views.config',
        component: (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $igFet.ServicedeskQueuesViewsConfig), (0, $9BJU1.default)),
        pageId: ({ query: query, match: match })=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $eOSoz.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("gmklX", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeViewsConfigRoute", () => $f8c82471fd191327$export$e8e807e90d20fe7b);
const $f8c82471fd191327$export$e8e807e90d20fe7b = {
    name: 'servicedesk-practice-views-config',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit/:boardId',
    query: [
        'config'
    ],
    exact: true
};

});

parcelRegister("igFet", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesViewsConfig", () => $56fc48d919941e1c$export$12b9e920fc614605);
$parcel$export(module.exports, "ServicedeskQueuesViewsConfig", () => $56fc48d919941e1c$export$666845896df029ad);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $56fc48d919941e1c$export$12b9e920fc614605 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8CFLn")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-config/src/index.tsx"
});
const $56fc48d919941e1c$export$666845896df029ad = (props)=>{
    const { query: query } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $56fc48d919941e1c$export$12b9e920fc614605,
        pageId: `spa-apps/servicedesk/queues/views-config/${query.config}`,
        shouldShowSpinner: true
    });
};

});


parcelRegister("agCim", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectEmbedRouteEntry", () => $b1364b18da2faed3$export$2792607788ca81db);

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $d2EHA = parcelRequire("d2EHA");

var $kWsG7 = parcelRequire("kWsG7");
const $b1364b18da2faed3$export$2792607788ca81db = (0, $6xToB.createEntry)((0, $d2EHA.servicedeskProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        component: (0, $kWsG7.default),
        forPaint: [
            (0, $kWsG7.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("d2EHA", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectEmbedRoute", () => $75653deedab7964d$export$bf24763c9fc04bde);
const $75653deedab7964d$export$bf24763c9fc04bde = {
    name: 'servicedesk-proforma-issue-forms-direct-embed',
    path: '/jira/servicedesk/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});


parcelRegister("cnG0j", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectRouteEntry", () => $f135212708c3e5aa$export$f249c6e19ad4181e);

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $gqzIM = parcelRequire("gqzIM");

var $aQoXd = parcelRequire("aQoXd");

var $d017r = parcelRequire("d017r");
const $f135212708c3e5aa$export$f249c6e19ad4181e = (0, $6xToB.createEntry)((0, $gqzIM.servicedeskProformaIssueFormsDirectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        entryPoint: ()=>(0, $d017r.proformaIssueFormsDirectPageEntryPoint),
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("gqzIM", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectRoute", () => $b0562226df2b8eaf$export$9b51b0994bb4b8f0);
const $b0562226df2b8eaf$export$9b51b0994bb4b8f0 = {
    name: 'servicedesk-proforma-issue-forms-direct',
    path: '/jira/servicedesk/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});


parcelRegister("ghBxE", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectDashboardsEditableRouteEntry", () => $04aa311eec8115f1$export$a74c7ae68710fdc7);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $eyUVe = parcelRequire("eyUVe");

var $aQoXd = parcelRequire("aQoXd");

var $8IGm4 = parcelRequire("8IGm4");
const $04aa311eec8115f1$export$a74c7ae68710fdc7 = (0, $6xToB.createEntry)((0, $eyUVe.servicedeskProjectDashboardsEditableRoute), ()=>({
        group: 'servicedesk',
        component: (0, $8IGm4.ProjectDashboardsEditable),
        perfMetricKey: 'service-management.project-dashboards.dashboard-list',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8IGm4.LazyServicedeskProjectDashboardsEditable)
        ]
    }));

});
parcelRegister("eyUVe", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectDashboardsEditableRoute", () => $26359e305ab21ef4$export$e1b9572169ced05e);
const $26359e305ab21ef4$export$e1b9572169ced05e = {
    name: 'servicedesk-avp-project-dashboards-editable',
    path: '/jira/servicedesk/projects/:projectKey/dashboards/:dashboardId'
};

});

parcelRegister("8IGm4", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskProjectDashboardsEditable", () => $dc37e61d2f4c410e$export$cab0bd21e2c67be7);
$parcel$export(module.exports, "ProjectDashboardsEditable", () => $dc37e61d2f4c410e$export$65f0b3d2f1a55263);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $dc37e61d2f4c410e$export$cab0bd21e2c67be7 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("XJozT")).then((module)=>module.DashboardEditableSpaWrapper)), {
    moduleId: "./src/packages/spa-apps/servicedesk/project-dashboards/src/index.tsx"
});
const $dc37e61d2f4c410e$export$65f0b3d2f1a55263 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $dc37e61d2f4c410e$export$cab0bd21e2c67be7,
        pageId: "spa-apps/servicedesk-project-dashboards-editable",
        shouldShowSpinner: true
    });

});
parcelRegister("XJozT", function(module, exports) {

let $0b38b96332a3ae40$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    $0b38b96332a3ae40$var$load("1VRB2"),
    $0b38b96332a3ae40$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("30JZF"), 4)),
    $0b38b96332a3ae40$var$load("7vqGd"),
    $0b38b96332a3ae40$var$load("1Y4bq"),
    $0b38b96332a3ae40$var$load("eDzss"),
    $0b38b96332a3ae40$var$load("f1M57")
]).then(()=>parcelRequire('cK7eh'));

});



parcelRegister("lMO7Z", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectDashboardsListRouteEntry", () => $d739c4dbd17e2e0f$export$eaf3433859cfed23);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $8Q5ov = parcelRequire("8Q5ov");

var $aQoXd = parcelRequire("aQoXd");

var $6ahCL = parcelRequire("6ahCL");
const $d739c4dbd17e2e0f$export$eaf3433859cfed23 = (0, $6xToB.createEntry)((0, $8Q5ov.servicedeskProjectDashboardsListRoute), ()=>({
        group: 'servicedesk',
        component: (0, $6ahCL.ProjectDashboardsList),
        perfMetricKey: 'service-management.project-dashboards.dashboard-list',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6ahCL.LazyServicedeskProjectDashboardsList)
        ]
    }));

});
parcelRegister("8Q5ov", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectDashboardsListRoute", () => $974951619e1c7f4b$export$ff671f43f5c6b309);
const $974951619e1c7f4b$export$ff671f43f5c6b309 = {
    name: 'servicedesk-avp-project-dashboards-list',
    path: '/jira/servicedesk/projects/:projectKey/dashboards'
};

});

parcelRegister("6ahCL", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskProjectDashboardsList", () => $8ade08da966f3277$export$fea8ad531d3abdc3);
$parcel$export(module.exports, "ProjectDashboardsList", () => $8ade08da966f3277$export$86ab4708fa0d87fa);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $8ade08da966f3277$export$fea8ad531d3abdc3 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("XJozT")).then((module)=>module.DashboardList)), {
    moduleId: "./src/packages/spa-apps/servicedesk/project-dashboards/src/index.tsx"
});
const $8ade08da966f3277$export$86ab4708fa0d87fa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8ade08da966f3277$export$fea8ad531d3abdc3,
        pageId: "spa-apps/servicedesk-project-dashboards-list",
        shouldShowSpinner: true
    });

});


parcelRegister("fvFxE", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectSummaryRouteEntry", () => $87b5fdcb96a6d790$export$a24d68fcf82b16bb);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $2fpoV = parcelRequire("2fpoV");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $lx2dR = parcelRequire("lx2dR");

var $eMyNf = parcelRequire("eMyNf");

var $fJ5dc = parcelRequire("fJ5dc");
const $87b5fdcb96a6d790$export$a24d68fcf82b16bb = (0, $6xToB.createEntry)((0, $2fpoV.servicedeskProjectSummaryRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm.project-summary',
        component: ()=>null,
        skeleton: (0, $lx2dR.ProjectSummarySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $eMyNf.getProjectSummaryFilterFieldsResource)()
        ],
        entryPoint: ()=>(0, $fJ5dc.projectSummaryPageEntryPoint),
        meta: {
            reporting: {
                id: 'project-summary',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).PROJECT_SUMMARY),
                teamName: 'jsd-shield'
            }
        }
    }));

});
parcelRegister("2fpoV", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectSummaryRoute", () => $ce3486d6069a4f97$export$a23b752ff24027ae);
const $ce3486d6069a4f97$export$a23b752ff24027ae = {
    path: '/jira/servicedesk/projects/:projectKey/summary',
    name: 'servicedesk-project-summary'
};

});

parcelRegister("lx2dR", function(module, exports) {

$parcel$export(module.exports, "ProjectSummarySkeleton", () => $3b30c9ad0a7ce8c7$export$93a223cf4712c63d);

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $hY9ih = parcelRequire("hY9ih");
const $3b30c9ad0a7ce8c7$export$93a223cf4712c63d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hY9ih)))
    });

});
parcelRegister("hY9ih", function(module, exports) {
module.exports = new URL("project-summary-skeleton.tpl.f2232e71.svg", import.meta.url).toString();

});


parcelRegister("eMyNf", function(module, exports) {

$parcel$export(module.exports, "getProjectSummaryFilterFieldsResource", () => $28929482cb0982b0$export$efafab65f8d3c3b6);
$parcel$export(module.exports, "useGetProjectSummaryFilterFields", () => $28929482cb0982b0$export$e6baafb2e3d74187);
$parcel$export(module.exports, "useRequestTypeJqlTerm", () => $28929482cb0982b0$export$1bb1552d41afd41f);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $8KUFq = parcelRequire("8KUFq");

var $jGzN3 = parcelRequire("jGzN3");

var $7jTnu = parcelRequire("7jTnu");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $28929482cb0982b0$var$RESOURCE_NAME = 'projectSummaryFilterFieldResource';
const $28929482cb0982b0$export$6f0555de4f60e84e = 'RESOURCE_TYPE_JSM_PROJECT_SUMMARY_FILTERS';
const $28929482cb0982b0$var$REQUEST_TYPE_FILTER_TYPE = 'com.atlassian.servicedesk:vp-origin';
const $28929482cb0982b0$var$REQUEST_TYPE_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $28929482cb0982b0$var$createdField = {
    displayName: 'Created',
    fieldType: 'created',
    jqlTerm: 'created',
    operators: [
        'LESS_THAN_OR_EQUAL',
        'GREATER_THAN_OR_EQUAL',
        'NOT_IN',
        'IS_NOT',
        'LESS_THAN',
        'GREATER_THAN',
        'EQUALS',
        'IS',
        'IN',
        'NOT_EQUALS'
    ],
    searchTemplate: 'created',
    type: 'created'
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $28929482cb0982b0$var$priorityField = {
    displayName: 'Priority',
    fieldType: 'priority',
    jqlTerm: 'priority',
    operators: [
        'GREATER_THAN_OR_EQUAL',
        'LESS_THAN',
        'GREATER_THAN',
        'WAS_NOT',
        'IS',
        'IN',
        'CHANGED',
        'LESS_THAN_OR_EQUAL',
        'NOT_IN',
        'IS_NOT',
        'WAS_NOT_IN',
        'EQUALS',
        'WAS_IN',
        'WAS',
        'NOT_EQUALS'
    ],
    searchTemplate: 'priority',
    type: 'priority'
};
const $28929482cb0982b0$var$reportError = ({ error: error, id: id })=>(0, $gYnSx.default)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: id ? `${$28929482cb0982b0$var$RESOURCE_NAME}.${id}` : $28929482cb0982b0$var$RESOURCE_NAME,
            packageName: (0, $0bd75f18b7489379$export$b8b9d90f9e5bd72b),
            teamName: (0, $0bd75f18b7489379$export$d57b6b390e78d90f)
        }
    });
const $28929482cb0982b0$var$fetchFilterFieldsOld = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $42f9b927391b9e5b$export$546e90157aa718d4),
                variables: {
                    cloudId: cloudId,
                    contextFieldsFilter: (0, $7jTnu.fg)('corecap_3780_fix_rt_fetching_issue') ? {
                        jqlTerms: [
                            (0, $0bd75f18b7489379$export$2c388650eabddf5e),
                            (0, $0bd75f18b7489379$export$2fcf90614ee15858),
                            (0, $0bd75f18b7489379$export$43482ff574598f59)
                        ]
                    } : {
                        searchString: 'request type'
                    },
                    jqlContext: jqlContext
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        const tryGetField = ({ data: data, type: type, searchTemplate: searchTemplate, displayName: displayName })=>{
            const edges = data?.jira?.jqlBuilder?.fields?.edges;
            const field = edges?.find((edge)=>edge?.node?.type === type && edge?.node?.searchTemplate?.key === searchTemplate)?.node;
            return field ? {
                ...field,
                searchTemplate: field.searchTemplate.key,
                fieldType: field.type,
                displayName: displayName ?? field.displayName
            } : undefined;
        };
        return {
            requestTypeField: tryGetField({
                data: response.data,
                type: $28929482cb0982b0$var$REQUEST_TYPE_FILTER_TYPE,
                searchTemplate: $28929482cb0982b0$var$REQUEST_TYPE_FILTER_SEARCH_TEMPLATE
            })
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $8KUFq.isHttpClientErrorResponse)(error)) $28929482cb0982b0$var$reportError({
            error: error,
            id: 'fetchFields'
        });
        return {
            requestTypeField: undefined
        };
    }
};
const $28929482cb0982b0$var$fetchFilterFields = async (cloudId)=>{
    try {
        const requestTypeFieldResponse = await (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $42f9b927391b9e5b$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        const requestTypeField = requestTypeFieldResponse.data?.jira?.requestTypeField;
        if (!requestTypeField) return {
            requestTypeField: undefined
        };
        return {
            requestTypeField: {
                ...requestTypeField,
                searchTemplate: requestTypeField.searchTemplate?.key,
                fieldType: requestTypeField.type,
                displayName: requestTypeField.displayName
            }
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $8KUFq.isHttpClientErrorResponse)(error)) $28929482cb0982b0$var$reportError({
            error: error,
            id: 'fetchFields'
        });
        return {
            requestTypeField: undefined
        };
    }
};
const $28929482cb0982b0$var$getProjectKeyOrId = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $28929482cb0982b0$var$filterFieldsResource = (0, $l1VxS.createResource)({
    type: $28929482cb0982b0$export$6f0555de4f60e84e,
    getKey: ({ match: match, query: query })=>$28929482cb0982b0$export$6f0555de4f60e84e + $28929482cb0982b0$var$getProjectKeyOrId(match, query),
    getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const jqlContext = `project = '${$28929482cb0982b0$var$getProjectKeyOrId(match, query)}'`;
        return (0, $7jTnu.fg)('move_jsm_views_rt_filter_to_new_query') ? $28929482cb0982b0$var$fetchFilterFields(cloudId) : $28929482cb0982b0$var$fetchFilterFieldsOld(cloudId, jqlContext);
    },
    maxAge: Infinity
});
const $28929482cb0982b0$export$efafab65f8d3c3b6 = ()=>$28929482cb0982b0$var$filterFieldsResource;
const $28929482cb0982b0$export$e6baafb2e3d74187 = ()=>{
    const { data: filterResource } = (0, $eJrcF.useResource)($28929482cb0982b0$var$filterFieldsResource);
    const useFilterFields = (0, $eJOHy.useMemo)(()=>({ requestTypeField: requestTypeField = filterResource?.requestTypeField, requestTypeDisplayName: requestTypeDisplayName, priorityDisplayName: priorityDisplayName, createdDisplayName: createdDisplayName })=>{
            return [
                ...requestTypeField ? [
                    {
                        ...requestTypeField,
                        ...requestTypeDisplayName && {
                            displayName: requestTypeDisplayName
                        }
                    }
                ] : [],
                'status',
                'assignee',
                {
                    ...$28929482cb0982b0$var$priorityField,
                    ...priorityDisplayName && {
                        displayName: priorityDisplayName
                    }
                },
                {
                    ...$28929482cb0982b0$var$createdField,
                    ...createdDisplayName && {
                        displayName: createdDisplayName
                    }
                }
            ];
        }, [
        filterResource
    ]);
    return useFilterFields;
};
const $28929482cb0982b0$export$1bb1552d41afd41f = ({ jqlTerm: jqlTerm })=>{
    const { data: filterResource, loading: loading } = (0, $eJrcF.useResource)($28929482cb0982b0$var$filterFieldsResource);
    const term = jqlTerm ?? filterResource?.requestTypeField?.jqlTerm;
    const hasError = !loading && !term;
    (0, $eJOHy.useEffect)(()=>{
        if (hasError) $28929482cb0982b0$var$reportError({
            error: new Error('Error while getting request type jql term.'),
            id: 'rtJqlTerm'
        });
    }, [
        hasError
    ]);
    return term;
};

});
const $0bd75f18b7489379$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskProjectSummary';
const $0bd75f18b7489379$export$d57b6b390e78d90f = 'jsd-shield';
const $0bd75f18b7489379$export$2c388650eabddf5e = 'request type';
const $0bd75f18b7489379$export$2fcf90614ee15858 = 'service desk origin';
const $0bd75f18b7489379$export$43482ff574598f59 = 'cf[10010]';

const $42f9b927391b9e5b$export$546e90157aa718d4 = `
query findFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;
const $42f9b927391b9e5b$export$2b91517d6d5b4365 = `
query requestTypeFieldQuery($cloudId: ID!) {
  jira {
    requestTypeField(cloudId: $cloudId) {
      displayName
      jqlTerm
      operators
      searchTemplate {
        key
      }
      type
    }
  }
}
`;


parcelRegister("fJ5dc", function(module, exports) {

$parcel$export(module.exports, "projectSummaryPageEntryPoint", () => $46870e29bf457de0$export$ae7c241893e7dab9);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $11R8p = parcelRequire("11R8p");
const $46870e29bf457de0$export$ae7c241893e7dab9 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $11R8p.projectSummaryEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("11R8p", function(module, exports) {

$parcel$export(module.exports, "projectSummaryEntryPoint", () => $9bca175a61886899$export$95a2fe4e495efca5);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $9bca175a61886899$export$95a2fe4e495efca5 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("5Tfwu")), {
        moduleId: "ac794fd1",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5Tfwu", function(module, exports) {

let $449e215c03c65850$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $449e215c03c65850$var$load("1VRB2"),
    $449e215c03c65850$var$load("bABhq"),
    $449e215c03c65850$var$load("jxemT")
]).then(()=>parcelRequire('hSsJp'));

});




parcelRegister("dut0s", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesAddonRouteEntry", () => $3e9b2605dd3ac19b$export$23a16f20b48235b3);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $ldq55 = parcelRequire("ldq55");

var $aQoXd = parcelRequire("aQoXd");

var $8VBYs = parcelRequire("8VBYs");
const $3e9b2605dd3ac19b$export$23a16f20b48235b3 = (0, $6xToB.createEntry)((0, $ldq55.servicedeskQueuesAddonRoute), ()=>({
        group: 'servicedesk',
        component: (0, $8VBYs.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8VBYs.LazyServicedeskQueuesAddonView)
        ]
    }));

});
parcelRegister("ldq55", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesAddonRoute", () => $6f4fd92a4be5db43$export$1465f05b88a63f13);
const $6f4fd92a4be5db43$export$1465f05b88a63f13 = {
    name: 'servicedesk-queues-addon',
    path: '/jira/servicedesk/projects/:projectKey/queues/addon/:addonKey',
    exact: true
};

});

parcelRegister("8VBYs", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesAddonView", () => $8d94c4424336b5f0$export$451a7cce84b6b1e6);
$parcel$export(module.exports, "default", () => $8d94c4424336b5f0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $8d94c4424336b5f0$export$451a7cce84b6b1e6 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("72qxW")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-addon-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8d94c4424336b5f0$export$2e2bcd8739ae039 = ({ match: match })=>{
    const addonKey = match.params && match.params.addonKey || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8d94c4424336b5f0$export$451a7cce84b6b1e6,
        pageId: `spa-apps/servicedesk/queues/addon/${addonKey}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("72qxW", function(module, exports) {

let $51fd4fe6274fa732$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $51fd4fe6274fa732$var$load("2X5SD").then(()=>parcelRequire('gl9mP'));

});



parcelRegister("jUCVx", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesEditRouteEntry", () => $a74f7bf5770ccdab$export$ae7b71ac953d95bf);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $2sgSn = parcelRequire("2sgSn");

var $aQoXd = parcelRequire("aQoXd");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $6sU1E = parcelRequire("6sU1E");

var $5NcGG = parcelRequire("5NcGG");

var $eOSoz = parcelRequire("eOSoz");
const $a74f7bf5770ccdab$export$ae7b71ac953d95bf = (0, $6xToB.createEntry)((0, $2sgSn.servicedeskQueuesEditRoute), ()=>({
        group: 'servicedesk',
        component: (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $5NcGG.ServicedeskQueuesConfig), (0, $6sU1E.default)),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $1PvPk.getIssueListSsrResource)(),
            ...(0, $1PvPk.getQueueConfigResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $5NcGG.LazyServicedeskQueuesConfig) : (0, $6sU1E.LazyServicedeskQueuesEditView)
        ],
        ufoName: 'service-management.queues.edit',
        pageId: ({ query: query, match: match })=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $eOSoz.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("2sgSn", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesEditRoute", () => $1ed2945b87561a61$export$f8fd3a1f8c33aff8);
const $1ed2945b87561a61$export$f8fd3a1f8c33aff8 = {
    name: 'servicedesk-queues-edit',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit',
    exact: true,
    query: [
        'config?'
    ]
};

});


parcelRegister("fBXou", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesIssueRouteEntry", () => $91c504e19cabc48a$export$2e4931acac9270fc);

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $4AdSe = parcelRequire("4AdSe");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $agdZX = parcelRequire("agdZX");
const $91c504e19cabc48a$export$2e4931acac9270fc = (0, $6xToB.createEntry)((0, $4AdSe.servicedeskQueuesIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $agdZX.default),
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            ...(0, $1PvPk.getKnowledgeBaseResources)(),
            ...(0, $1PvPk.getInsightResources)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $5nfTh.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $agdZX.LazyServicedeskQueuesIssueView)
        ]
    }));

});
parcelRegister("4AdSe", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesIssueRoute", () => $4d6f79fa426e9eb4$export$52a24b9cf42d208b);
const $4d6f79fa426e9eb4$export$52a24b9cf42d208b = {
    name: 'servicedesk-queues-issue',
    path: '/jira/servicedesk/projects/:projectKey/queues/issue/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});


parcelRegister("28WgX", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesLandingRouteEntry", () => $48defd3eae31c60a$export$4242a81237c45c7d);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $dLY60 = parcelRequire("dLY60");

var $aQoXd = parcelRequire("aQoXd");

var $iY8Cx = parcelRequire("iY8Cx");
const $48defd3eae31c60a$export$4242a81237c45c7d = (0, $6xToB.createEntry)((0, $dLY60.servicedeskQueuesLandingRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: (0, $iY8Cx.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iY8Cx.LazyServicedeskQueuesLanding)
        ]
    }));

});
parcelRegister("dLY60", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesLandingRoute", () => $9ec641c326b4c107$export$52b4c044e4929ebc);
const $9ec641c326b4c107$export$52b4c044e4929ebc = {
    name: 'servicedesk-queues-landing',
    // Supporting optional /default for legacy backwards compatability
    path: '/jira/servicedesk/projects/:projectKey/queues/(default|custom)?',
    exact: true
};

});


parcelRegister("ekqRf", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesManageViewRouteEntry", () => $f051a68b43a3d3d6$export$7e9e2984a94a07b0);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $1tbYm = parcelRequire("1tbYm");

var $aQoXd = parcelRequire("aQoXd");

var $9btrJ = parcelRequire("9btrJ");
const $f051a68b43a3d3d6$export$7e9e2984a94a07b0 = (0, $6xToB.createEntry)((0, $1tbYm.servicedeskQueuesManageViewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $9btrJ.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: (0, $1PvPk.getQueuesResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9btrJ.LazyServicedeskQueuesManageView)
        ]
    }));

});
parcelRegister("1tbYm", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesManageViewRoute", () => $8dcc08deb10df733$export$7f30d40b906894c5);
const $8dcc08deb10df733$export$7f30d40b906894c5 = {
    name: 'servicedesk-queues-manage-view',
    path: '/jira/servicedesk/projects/:projectKey/queues/queue-settings',
    exact: true
};

});


parcelRegister("fPxUZ", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesNewRouteEntry", () => $5d91902509562084$export$9f7cc3294b3141b1);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $l3Qgv = parcelRequire("l3Qgv");

var $aQoXd = parcelRequire("aQoXd");

var $96Gso = parcelRequire("96Gso");
const $5d91902509562084$export$9f7cc3294b3141b1 = (0, $6xToB.createEntry)((0, $l3Qgv.servicedeskQueuesNewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $96Gso.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $96Gso.LazyServicedeskQueuesCreateView)
        ],
        ufoName: 'service-management.queues.new'
    }));

});
parcelRegister("l3Qgv", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesNewRoute", () => $c1aa695ea886f7a2$export$c1908994722d1e73);
const $c1aa695ea886f7a2$export$c1908994722d1e73 = {
    name: 'servicedesk-queues-new',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};

});


parcelRegister("gqwG0", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesViewsConfigRouteEntry", () => $0849a57e91a980b7$export$a5000d326f347afb);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $8eSoC = parcelRequire("8eSoC");

var $aQoXd = parcelRequire("aQoXd");

var $dZRaT = parcelRequire("dZRaT");

var $7jTnu = parcelRequire("7jTnu");

var $9BJU1 = parcelRequire("9BJU1");

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $fbgOh = parcelRequire("fbgOh");

var $eOSoz = parcelRequire("eOSoz");

var $igFet = parcelRequire("igFet");
const $0849a57e91a980b7$export$a5000d326f347afb = (0, $6xToB.createEntry)((0, $8eSoC.servicedeskQueuesViewsConfigRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            ...(0, $1PvPk.getQueueViewConfigResource)(),
            (0, $fbgOh.getEditModelResource)(),
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $igFet.LazyServicedeskQueuesViewsConfig)
        ],
        ufoName: 'service-management.views.config',
        component: (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $igFet.ServicedeskQueuesViewsConfig), (0, $9BJU1.default)),
        pageId: ({ query: query, match: match })=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $eOSoz.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("8eSoC", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesViewsConfigRoute", () => $53cc1a88c632276b$export$eea17b09d67a7980);
const $53cc1a88c632276b$export$eea17b09d67a7980 = {
    name: 'servicedesk-queues-views-config',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit/:boardId',
    query: [
        'config?'
    ],
    exact: true
};

});


parcelRegister("8CLhe", function(module, exports) {

$parcel$export(module.exports, "servicedeskReports1RouteEntry", () => $551f6c55cc81b799$export$8055c8b2162cf5bd);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $5RW99 = parcelRequire("5RW99");

var $6zXPf = parcelRequire("6zXPf");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $13axY = parcelRequire("13axY");

var $aQoXd = parcelRequire("aQoXd");

var $2mHfh = parcelRequire("2mHfh");


var $7G9Jw = parcelRequire("7G9Jw");

var $hv2KL = parcelRequire("hv2KL");
const $551f6c55cc81b799$var$DefaultReportsRedirect = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/servicedesk/projects/${String(match.params.projectKey)}${(0, $f57740b93b9bf8e8$export$ddc580d759168f88)}`
    });
const $551f6c55cc81b799$export$8055c8b2162cf5bd = (0, $6xToB.createEntry)((0, $13axY.servicedeskReports1Route), ()=>({
        group: 'servicedesk',
        component: (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), (0, $hv2KL.default), $551f6c55cc81b799$var$DefaultReportsRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $7G9Jw.getReportsWithKbResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $hv2KL.LazyServicedeskReportsHomePage)
        ]
    }));

});
parcelRegister("13axY", function(module, exports) {

$parcel$export(module.exports, "servicedeskReports1Route", () => $4269b3d8c3a8ca1f$export$f5adfd681a4e85ad);
const $4269b3d8c3a8ca1f$export$f5adfd681a4e85ad = {
    name: 'servicedesk-reports',
    path: '/jira/servicedesk/projects/:projectKey/reports',
    exact: true
};

});

const $f57740b93b9bf8e8$export$e4c007d05145b8c2 = '/reports/all-rating';
const $f57740b93b9bf8e8$export$ddc580d759168f88 = '/reports/workload';
const $f57740b93b9bf8e8$export$13bdc187fca9c33e = '/reports';

parcelRegister("7G9Jw", function(module, exports) {

$parcel$export(module.exports, "getReportsWithKbResources", () => $1674ce2fc5697ee1$export$1a63e9cdf8268e40);

var $85Ze9 = parcelRequire("85Ze9");

var $1PvPk = parcelRequire("1PvPk");
const $1674ce2fc5697ee1$export$1a63e9cdf8268e40 = ()=>[
        ...(0, $1PvPk.getServicedeskPageContextResources)(),
        (0, $85Ze9.kbConfluenceContextResource)
    ];

});

parcelRegister("hv2KL", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsHomePage", () => $8c18fd454e6d69a2$export$121b9cfb2b001a53);
$parcel$export(module.exports, "default", () => $8c18fd454e6d69a2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");


const $8c18fd454e6d69a2$export$121b9cfb2b001a53 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("k7X6q"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-home-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c18fd454e6d69a2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8c18fd454e6d69a2$export$121b9cfb2b001a53,
        pageId: `spa-apps/servicedesk${(0, $f57740b93b9bf8e8$export$13bdc187fca9c33e)}}`,
        shouldShowSpinner: true
    });

});
parcelRegister("k7X6q", function(module, exports) {

let $ea724ea74180a5b0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ea724ea74180a5b0$var$load("kFibK").then(()=>parcelRequire('iAmkR'));

});



parcelRegister("d3dv3", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustom4RouteEntry", () => $e0cdfbcd0097506f$export$5ef62fad7280cd08);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $5xu11 = parcelRequire("5xu11");

var $aQoXd = parcelRequire("aQoXd");

var $ZPF1t = parcelRequire("ZPF1t");
const $e0cdfbcd0097506f$export$5ef62fad7280cd08 = (0, $6xToB.createEntry)((0, $5xu11.servicedeskReportsCustom4Route), ()=>({
        group: 'servicedesk',
        component: (0, $ZPF1t.default),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ZPF1t.LazyServicedeskReportsCustom)
        ],
        ufoName: 'service-management-custom-reports'
    }));

});
parcelRegister("5xu11", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustom4Route", () => $1e925efc5e5b93c3$export$39325072940fb58c);
const $1e925efc5e5b93c3$export$39325072940fb58c = {
    name: 'servicedesk-reports-custom',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId'
};

});

parcelRegister("ZPF1t", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsCustom", () => $03e63ef9506cc9fb$export$3ec5c3d7729889b9);
$parcel$export(module.exports, "default", () => $03e63ef9506cc9fb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $03e63ef9506cc9fb$export$3ec5c3d7729889b9 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("1Rc8S"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$03e63ef9506cc9fb$export$2e2bcd8739ae039 = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $03e63ef9506cc9fb$export$3ec5c3d7729889b9,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("1Rc8S", function(module, exports) {

let $15a428ddd28bc8e4$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $15a428ddd28bc8e4$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $15a428ddd28bc8e4$var$load("deNlq")
        ]);
    }),
    $15a428ddd28bc8e4$var$load("1VRB2"),
    $15a428ddd28bc8e4$var$load("bABhq"),
    $15a428ddd28bc8e4$var$load("b76nQ")
]).then(()=>parcelRequire('fcyuR'));

});



parcelRegister("izixQ", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomCreateRouteEntry", () => $d6b028ada9d65ba8$export$b806d1abc9172b6d);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $3hVFo = parcelRequire("3hVFo");

var $aQoXd = parcelRequire("aQoXd");

var $61hEw = parcelRequire("61hEw");
const $d6b028ada9d65ba8$export$b806d1abc9172b6d = (0, $6xToB.createEntry)((0, $3hVFo.servicedeskReportsCustomCreateRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.custom-create',
        component: (0, $61hEw.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $61hEw.LazyServicedeskReportsCustomCreate)
        ]
    }));

});
parcelRegister("3hVFo", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomCreateRoute", () => $76bb61216459ac82$export$333e623d5eb41af0);
const $76bb61216459ac82$export$333e623d5eb41af0 = {
    name: 'servicedesk-reports-custom-create',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/new'
};

});

parcelRegister("61hEw", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsCustomCreate", () => $2084475c9f57a500$export$821b8201b24f8b7d);
$parcel$export(module.exports, "default", () => $2084475c9f57a500$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $2084475c9f57a500$export$821b8201b24f8b7d = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("aVEqk"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-create/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2084475c9f57a500$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $2084475c9f57a500$export$821b8201b24f8b7d,
        pageId: "spa-apps/servicedesk/reports/custom/create",
        shouldShowSpinner: true
    });

});
parcelRegister("aVEqk", function(module, exports) {

let $7f4e958edacf4323$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7f4e958edacf4323$var$load("eWjNO").then(()=>parcelRequire('85UpT'));

});



parcelRegister("gZq43", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomEditRouteEntry", () => $10f23d5e001aa6e0$export$c4c3dcf824e7036e);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $aGjJ2 = parcelRequire("aGjJ2");

var $aQoXd = parcelRequire("aQoXd");

var $9nZlY = parcelRequire("9nZlY");
const $10f23d5e001aa6e0$export$c4c3dcf824e7036e = (0, $6xToB.createEntry)((0, $aGjJ2.servicedeskReportsCustomEditRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.custom-edit-view',
        component: (0, $9nZlY.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9nZlY.LazyServicedeskReportsCustomEdit)
        ]
    }));

});
parcelRegister("aGjJ2", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomEditRoute", () => $06d5e4805a57e63d$export$3b6b3105a9ef9b83);
const $06d5e4805a57e63d$export$3b6b3105a9ef9b83 = {
    name: 'servicedesk-reports-custom-edit',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/edit'
};

});

parcelRegister("9nZlY", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsCustomEdit", () => $439c03f9484ddcec$export$53def03ace9a6c5b);
$parcel$export(module.exports, "default", () => $439c03f9484ddcec$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $439c03f9484ddcec$export$53def03ace9a6c5b = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4d9KO"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-edit/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$439c03f9484ddcec$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { reportId: reportId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $439c03f9484ddcec$export$53def03ace9a6c5b,
        pageId: `spa-apps/servicedesk/reports/custom/${reportId || ''}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("4d9KO", function(module, exports) {

let $310ff1459e0b37b4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $310ff1459e0b37b4$var$load("jkHEs").then(()=>parcelRequire('blaFr'));

});



parcelRegister("9uidf", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomIssueRouteEntry", () => $69fe67613c59ffae$export$222c6398b69dbc6d);

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $rKG3R = parcelRequire("rKG3R");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $dsXZq = parcelRequire("dsXZq");
const $69fe67613c59ffae$export$222c6398b69dbc6d = (0, $6xToB.createEntry)((0, $rKG3R.servicedeskReportsCustomIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $dsXZq.default),
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $5nfTh.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dsXZq.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue'
    }));

});
parcelRegister("rKG3R", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomIssueRoute", () => $092cd251c5406435$export$1cfe539c854438e8);
const $092cd251c5406435$export$1cfe539c854438e8 = {
    name: 'servicedesk-reports-custom-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});


parcelRegister("lHdES", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRouteEntry", () => $d275633bf5b9223f$export$508d5e1a59322a54);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lyDxh = parcelRequire("lyDxh");

var $aQoXd = parcelRequire("aQoXd");

var $ZPF1t = parcelRequire("ZPF1t");
const $d275633bf5b9223f$export$508d5e1a59322a54 = (0, $6xToB.createEntry)((0, $lyDxh.servicedeskReportsCustomTimeScaleRoute), ()=>({
        group: 'servicedesk',
        component: (0, $ZPF1t.default),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ZPF1t.LazyServicedeskReportsCustom)
        ],
        ufoName: 'service-management-custom-reports'
    }));

});
parcelRegister("lyDxh", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRoute", () => $bbe48c9bada8af71$export$eae9a65fe3f035ef);
const $bbe48c9bada8af71$export$eae9a65fe3f035ef = {
    name: 'servicedesk-reports-custom-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId'
};

});


parcelRegister("8gAuW", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfaction2RouteEntry", () => $7de484313564e1e2$export$d6fb66bfd4a40ef);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $7NlI4 = parcelRequire("7NlI4");

var $aQoXd = parcelRequire("aQoXd");

var $b2D0H = parcelRequire("b2D0H");
const $7de484313564e1e2$export$d6fb66bfd4a40ef = (0, $6xToB.createEntry)((0, $7NlI4.servicedeskReportsSatisfaction2Route), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.satisfaction',
        component: (0, $b2D0H.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b2D0H.LazyServicedeskReportsSatisfaction)
        ]
    }));

});
parcelRegister("7NlI4", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfaction2Route", () => $de33d10e8b2cbc09$export$22fd25b495033fdf);
const $de33d10e8b2cbc09$export$22fd25b495033fdf = {
    name: 'servicedesk-reports-satisfaction',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating'
};

});

parcelRegister("b2D0H", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsSatisfaction", () => $cc61ac2d1c6d5141$export$8edc7b9d922cd22f);
$parcel$export(module.exports, "default", () => $cc61ac2d1c6d5141$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");


const $cc61ac2d1c6d5141$export$8edc7b9d922cd22f = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("dWZfn"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-satisfaction/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cc61ac2d1c6d5141$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cc61ac2d1c6d5141$export$8edc7b9d922cd22f,
        pageId: `spa-apps/servicedesk${(0, $f57740b93b9bf8e8$export$e4c007d05145b8c2)}}`,
        shouldShowSpinner: true
    });

});
parcelRegister("dWZfn", function(module, exports) {

let $a280338c0d8533e1$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $a280338c0d8533e1$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $a280338c0d8533e1$var$load("deNlq")
        ]);
    }),
    $a280338c0d8533e1$var$load("1VRB2"),
    $a280338c0d8533e1$var$load("bABhq"),
    $a280338c0d8533e1$var$load("hTPqf")
]).then(()=>parcelRequire('kSbNs'));

});



parcelRegister("jgRv0", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRouteEntry", () => $fd016a0d038c0b93$export$6b98300c0f2ab048);

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $bC1pm = parcelRequire("bC1pm");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $dsXZq = parcelRequire("dsXZq");
const $fd016a0d038c0b93$export$6b98300c0f2ab048 = (0, $6xToB.createEntry)((0, $bC1pm.servicedeskReportsSatisfactionIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $dsXZq.default),
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $5nfTh.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dsXZq.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue'
    }));

});
parcelRegister("bC1pm", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRoute", () => $60c5c0ccf4ee7e43$export$da606765550c7e7);
const $60c5c0ccf4ee7e43$export$da606765550c7e7 = {
    name: 'servicedesk-reports-satisfaction-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});


parcelRegister("iBcSa", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRouteEntry", () => $af9cac09f3adfb4b$export$8d7026b8c74a8be8);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $a70DC = parcelRequire("a70DC");

var $aQoXd = parcelRequire("aQoXd");

var $b2D0H = parcelRequire("b2D0H");
const $af9cac09f3adfb4b$export$8d7026b8c74a8be8 = (0, $6xToB.createEntry)((0, $a70DC.servicedeskReportsSatisfactionTimeScaleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.satisfaction',
        component: (0, $b2D0H.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b2D0H.LazyServicedeskReportsSatisfaction)
        ]
    }));

});
parcelRegister("a70DC", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRoute", () => $48815a74eb4d4417$export$64ae70b2d6b34c4e);
const $48815a74eb4d4417$export$64ae70b2d6b34c4e = {
    name: 'servicedesk-reports-satisfaction-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId'
};

});


parcelRegister("bJiYi", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsTypeRouteEntry", () => $0f1490c3cc3f6edf$export$bc47b2df6d39fd3f);

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $4kpMv = parcelRequire("4kpMv");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $7G9Jw = parcelRequire("7G9Jw");

var $a2QDq = parcelRequire("a2QDq");
const $0f1490c3cc3f6edf$export$bc47b2df6d39fd3f = (0, $6xToB.createEntry)((0, $4kpMv.servicedeskReportsTypeRoute), ()=>({
        group: 'servicedesk',
        component: (0, $a2QDq.default),
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $7G9Jw.getReportsWithKbResources)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $5nfTh.getAIContextPanelResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $a2QDq.LazyServicedeskReports)
        ]
    }));

});
parcelRegister("4kpMv", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsTypeRoute", () => $8bd962dfa1123299$export$b955ac7f09c5dbb);
const $8bd962dfa1123299$export$b955ac7f09c5dbb = {
    name: 'servicedesk-reports-type',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportType/:reportId?/:reportsAction?/:timescaleId?/:issueKey?',
    query: [
        'oldIssueView?'
    ]
};

});

parcelRegister("a2QDq", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReports", () => $be7c5421343376b1$export$75e043cf7a4e3661);
$parcel$export(module.exports, "default", () => $be7c5421343376b1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $be7c5421343376b1$export$75e043cf7a4e3661 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("82wdD")), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports/src/index.tsx"
});
var /**
 * Dynamically loads the ServicedeskReports component, enhancing user experience by using deferred loading with a visual feedback.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$be7c5421343376b1$export$2e2bcd8739ae039 = ({ match: match })=>{
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $be7c5421343376b1$export$75e043cf7a4e3661,
        pageId: `spa-apps/servicedesk/reports/${match ? match.url : ''}${oldIssueView}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("82wdD", function(module, exports) {

let $5da780a04033b43d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5da780a04033b43d$var$load("cCd1H").then(()=>parcelRequire('jgLAY'));

});



parcelRegister("9NWq7", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsWorkloadRouteEntry", () => $25d788556d086de5$export$793ba749f18b4dd4);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $8vMpR = parcelRequire("8vMpR");

var $aQoXd = parcelRequire("aQoXd");

var $6VsbM = parcelRequire("6VsbM");
const $25d788556d086de5$export$793ba749f18b4dd4 = (0, $6xToB.createEntry)((0, $8vMpR.servicedeskReportsWorkloadRoute), ()=>({
        group: 'servicedesk',
        component: (0, $6VsbM.default),
        perfMetricKey: 'service-management.reports.workload',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6VsbM.LazyServicedeskReportsWorkload)
        ]
    }));

});
parcelRegister("8vMpR", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsWorkloadRoute", () => $ad733e0550e439cb$export$ce9b409ccf53e93c);
const $ad733e0550e439cb$export$ce9b409ccf53e93c = {
    name: 'servicedesk-reports-workload',
    path: '/jira/servicedesk/projects/:projectKey/reports/workload',
    exact: true
};

});

parcelRegister("6VsbM", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsWorkload", () => $544e9b94745fff6c$export$e805fb47fdcd991);
$parcel$export(module.exports, "default", () => $544e9b94745fff6c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");


const $544e9b94745fff6c$export$e805fb47fdcd991 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("gjR7k"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-workload/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$544e9b94745fff6c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $544e9b94745fff6c$export$e805fb47fdcd991,
        pageId: `spa-apps/servicedesk${(0, $f57740b93b9bf8e8$export$ddc580d759168f88)}}`,
        shouldShowSpinner: true
    });

});
parcelRegister("gjR7k", function(module, exports) {

let $be179fa331e22133$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $be179fa331e22133$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $be179fa331e22133$var$load("deNlq")
        ]);
    }),
    $be179fa331e22133$var$load("hPqWR")
]).then(()=>parcelRequire('mEhhU'));

});



parcelRegister("hnYNr", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceDetailsRouteEntry", () => $00afac8ec962371b$export$48af7c0b8f21929b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $79Ghk = parcelRequire("79Ghk");

var $aQoXd = parcelRequire("aQoXd");

var $5gvIY = parcelRequire("5gvIY");
const $00afac8ec962371b$export$48af7c0b8f21929b = (0, $6xToB.createEntry)((0, $79Ghk.servicedeskServiceDetailsRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.service-details',
        component: (0, $5gvIY.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $5gvIY.LazyServicedeskServiceDetailsWithProjectContext)
        ]
    }));

});
parcelRegister("79Ghk", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceDetailsRoute", () => $15d8d61b27289c0f$export$fe5fe00b6d5eab87);
const $15d8d61b27289c0f$export$fe5fe00b6d5eab87 = {
    name: 'servicedesk-service-details',
    path: '/jira/servicedesk/projects/:projectKey/services/:serviceAri'
};

});

parcelRegister("5gvIY", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServiceDetailsWithProjectContext", () => $ea17f08be7017d11$export$b154597f29589502);
$parcel$export(module.exports, "default", () => $ea17f08be7017d11$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ea17f08be7017d11$export$b154597f29589502 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3JKT1"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-details-with-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ea17f08be7017d11$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ea17f08be7017d11$export$b154597f29589502,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });

});
parcelRegister("3JKT1", function(module, exports) {

let $2b89f1b77d9ad3b1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $2b89f1b77d9ad3b1$var$load("1VRB2"),
    $2b89f1b77d9ad3b1$var$load("bABhq"),
    $2b89f1b77d9ad3b1$var$load("eDzss"),
    $2b89f1b77d9ad3b1$var$load("cDofx")
]).then(()=>parcelRequire('9AdN4'));

});



parcelRegister("gSlgn", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRouteEntry", () => $a94d0bbd44e10c80$export$de2e645f69483ce);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $5AOEW = parcelRequire("5AOEW");

var $fSkHJ = parcelRequire("fSkHJ");
const $a94d0bbd44e10c80$export$de2e645f69483ce = (0, $6xToB.createEntry)((0, $5AOEW.serviceDeskServiceDetailsWithoutProjectRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.service-details-without-project',
        component: (0, $fSkHJ.default),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fSkHJ.LazyServicedeskServiceDetailsWithoutProjectContext)
        ],
        meta: {
            reporting: {
                id: 'servicedesk-service-details-without-project',
                packageName: 'jiraSpaAppsServicedeskServiceDetailsWithoutProjectContext"',
                teamName: 'Falcons'
            }
        }
    }));

});
parcelRegister("5AOEW", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRoute", () => $8a43f77fceee2a10$export$25e1d58db18a7c8b);
const $8a43f77fceee2a10$export$25e1d58db18a7c8b = {
    name: 'servicedesk-service-details-without-project',
    path: '/jira/servicedesk/services/:serviceAri'
};

});

parcelRegister("fSkHJ", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServiceDetailsWithoutProjectContext", () => $d15ce4ba34a89a13$export$ba1931edde0ce20c);
$parcel$export(module.exports, "default", () => $d15ce4ba34a89a13$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $d15ce4ba34a89a13$export$ba1931edde0ce20c = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("1U9d0"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-details-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d15ce4ba34a89a13$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d15ce4ba34a89a13$export$ba1931edde0ce20c,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });

});
parcelRegister("1U9d0", function(module, exports) {

let $16322a134c397949$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $16322a134c397949$var$load("1VRB2"),
    $16322a134c397949$var$load("bABhq"),
    $16322a134c397949$var$load("eDzss"),
    $16322a134c397949$var$load("5Ih5G")
]).then(()=>parcelRequire('aABDg'));

});



parcelRegister("cENRX", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalEditRouteEntry", () => $b607b283991c2282$export$5698449b623d4af);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $dZqwQ = parcelRequire("dZqwQ");

var $aQoXd = parcelRequire("aQoXd");

var $1ILcj = parcelRequire("1ILcj");
const $b607b283991c2282$export$5698449b623d4af = (0, $6xToB.createEntry)((0, $dZqwQ.servicedeskServiceModalEditRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1ILcj.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1ILcj.LazyServiceUpdateModalWithProjectContext)
        ]
    }));

});
parcelRegister("dZqwQ", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalEditRoute", () => $14c2f2afdcb283d2$export$319fbbab5eb49cbf);
const $14c2f2afdcb283d2$export$319fbbab5eb49cbf = {
    name: 'servicedesk-service-modal-edit',
    path: '/jira/servicedesk/service-modal/:serviceAri'
};

});

parcelRegister("1ILcj", function(module, exports) {

$parcel$export(module.exports, "LazyServiceUpdateModalWithProjectContext", () => $b2db2b8efacb9515$export$8984aadca7e15d1);
$parcel$export(module.exports, "default", () => $b2db2b8efacb9515$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $b2db2b8efacb9515$export$8984aadca7e15d1 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("5Dcxu")), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-update-modal-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b2db2b8efacb9515$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $b2db2b8efacb9515$export$8984aadca7e15d1,
        pageId: "spa-apps/servicedesk/service-update-modal",
        shouldShowSpinner: true
    });

});
parcelRegister("5Dcxu", function(module, exports) {

let $419a52426c17dfcd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $419a52426c17dfcd$var$load("lbJex").then(()=>parcelRequire('1UoO4'));

});



parcelRegister("f0Lah", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalNewRouteEntry", () => $5b24e81971b22b88$export$75c24699abe8e616);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $ajYrT = parcelRequire("ajYrT");

var $aQoXd = parcelRequire("aQoXd");

var $jqwxn = parcelRequire("jqwxn");
const $5b24e81971b22b88$export$75c24699abe8e616 = (0, $6xToB.createEntry)((0, $ajYrT.servicedeskServiceModalNewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $jqwxn.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jqwxn.LazyServiceCreateModalWithProjectContext)
        ]
    }));

});
parcelRegister("ajYrT", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalNewRoute", () => $35fbc3635db8acab$export$5b5ea97286af2784);
const $35fbc3635db8acab$export$5b5ea97286af2784 = {
    name: 'servicedesk-service-modal-new',
    path: '/jira/servicedesk/service-modal',
    exact: true
};

});

parcelRegister("jqwxn", function(module, exports) {

$parcel$export(module.exports, "LazyServiceCreateModalWithProjectContext", () => $9182c78be0917279$export$7f4092c8e7b7d3ec);
$parcel$export(module.exports, "default", () => $9182c78be0917279$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $9182c78be0917279$export$7f4092c8e7b7d3ec = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("6Masi")), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-create-modal-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9182c78be0917279$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $9182c78be0917279$export$7f4092c8e7b7d3ec,
        pageId: "spa-apps/servicedesk/service-create-modal",
        shouldShowSpinner: true
    });

});
parcelRegister("6Masi", function(module, exports) {

let $4eef55f8b3590436$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4eef55f8b3590436$var$load("jSTNV").then(()=>parcelRequire('1FtPF'));

});



parcelRegister("5psoN", function(module, exports) {

$parcel$export(module.exports, "servicedeskServicesRouteEntry", () => $c0b6c1a06fc90883$export$5df203501090bc7f);

var $kHlOR = parcelRequire("kHlOR");

var $8rDuZ = parcelRequire("8rDuZ");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $4sInV = parcelRequire("4sInV");

var $aQoXd = parcelRequire("aQoXd");

var $3wAw4 = parcelRequire("3wAw4");
const $c0b6c1a06fc90883$export$5df203501090bc7f = (0, $6xToB.createEntry)((0, $4sInV.servicedeskServicesRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.services',
        component: (0, $3wAw4.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $8rDuZ.AsyncJSMOperationsHorizontalNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8rDuZ.LazyJSMOperationsHorizontalNav),
            (0, $3wAw4.LazyServicedeskServicesWithProjectContext)
        ]
    }));

});
parcelRegister("4sInV", function(module, exports) {

$parcel$export(module.exports, "servicedeskServicesRoute", () => $305cdadd1f4abb12$export$4a800381bda6d53c);
const $305cdadd1f4abb12$export$4a800381bda6d53c = {
    name: 'servicedesk-services',
    path: '/jira/servicedesk/projects/:projectKey/services',
    exact: true
};

});

parcelRegister("3wAw4", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServicesWithProjectContext", () => $038ecf0527590e0e$export$4aa60213b3477cf6);
$parcel$export(module.exports, "default", () => $038ecf0527590e0e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $038ecf0527590e0e$export$4aa60213b3477cf6 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("jVFqh")), {
    moduleId: "./src/packages/spa-apps/servicedesk/services-with-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$038ecf0527590e0e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $038ecf0527590e0e$export$4aa60213b3477cf6,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });

});
parcelRegister("jVFqh", function(module, exports) {

let $e82378e85e22203d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e82378e85e22203d$var$load("iw3hw").then(()=>parcelRequire('01pGG'));

});



parcelRegister("1kaFK", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServicesWithoutProjectRouteEntry", () => $bd8e45aaeda080de$export$7031f96c25be5e14);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $8JPxs = parcelRequire("8JPxs");

var $cEzES = parcelRequire("cEzES");
const $bd8e45aaeda080de$export$7031f96c25be5e14 = (0, $6xToB.createEntry)((0, $8JPxs.serviceDeskServicesWithoutProjectRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.services-without-project',
        component: (0, $cEzES.default),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cEzES.LazyServicedeskServicesWithoutProjectContext)
        ],
        meta: {
            reporting: {
                id: 'servicedesk-services-without-project',
                packageName: 'jiraSpaAppsServicedeskServicesWithoutProjectContext"',
                teamName: 'Falcons'
            }
        }
    }));

});
parcelRegister("8JPxs", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServicesWithoutProjectRoute", () => $3971f3d82c3b4181$export$3210e7c54c21be97);
const $3971f3d82c3b4181$export$3210e7c54c21be97 = {
    name: 'servicedesk-services-without-project',
    path: '/jira/servicedesk/services',
    exact: true
};

});

parcelRegister("cEzES", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServicesWithoutProjectContext", () => $26888c8245e85d33$export$fc385e1392a8e28);
$parcel$export(module.exports, "default", () => $26888c8245e85d33$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $26888c8245e85d33$export$fc385e1392a8e28 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("deuJe")), {
    moduleId: "./src/packages/spa-apps/servicedesk/services-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$26888c8245e85d33$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $26888c8245e85d33$export$fc385e1392a8e28,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });

});
parcelRegister("deuJe", function(module, exports) {

let $9a246b3d58db4170$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9a246b3d58db4170$var$load("e5gfy").then(()=>parcelRequire('3MZo0'));

});



parcelRegister("kRlsB", function(module, exports) {

$parcel$export(module.exports, "servicedeskSlaSettingsRouteEntry", () => $8f63217d9286cc79$export$472949ed4e9ddfb0);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $khUom = parcelRequire("khUom");

var $hsEQN = parcelRequire("hsEQN");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $b1D7S = parcelRequire("b1D7S");
const $8f63217d9286cc79$export$472949ed4e9ddfb0 = (0, $6xToB.createEntry)((0, $hsEQN.servicedeskSlaSettingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).SLA_SETTINGS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).SLA_SETTINGS),
                teamName: 'bumblebee'
            }
        },
        perfMetricKey: 'jsm-sla-settings',
        component: (0, $b1D7S.ServiceDeskSlaSettings),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $khUom.slaMetricsDataResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b1D7S.LazyProjectSettingsServiceDeskSlaSettings)
        ]
    }));

});
parcelRegister("khUom", function(module, exports) {

$parcel$export(module.exports, "slaMetricsDataResource", () => $09c09289e12893aa$export$6cdfca3e816e9661);

var $l1VxS = parcelRequire("l1VxS");
const $09c09289e12893aa$export$c5fa03c9ad8df0e2 = 'SLA_METRICS';

const $09c09289e12893aa$export$6cdfca3e816e9661 = (0, $l1VxS.createResource)({
    type: $09c09289e12893aa$export$c5fa03c9ad8df0e2,
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("lpdPD")),
    maxAge: Infinity
});

});
parcelRegister("lpdPD", function(module, exports) {

let $f956a97d8e797b6a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f956a97d8e797b6a$var$load("4FcAF").then(()=>parcelRequire('8MiMS'));

});


parcelRegister("b1D7S", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskSlaSettings", () => $c3089fab82ff5c6f$export$a6694c07cb5be8c1);
$parcel$export(module.exports, "ServiceDeskSlaSettings", () => $c3089fab82ff5c6f$export$c56fde3803c5a1a3);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $16sa1 = parcelRequire("16sa1");

var $gzcjr = parcelRequire("gzcjr");

const $c3089fab82ff5c6f$export$a6694c07cb5be8c1 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fzq0U"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-sla-settings/src/index.tsx"
});
const $c3089fab82ff5c6f$export$c56fde3803c5a1a3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "project-settings-service-desk-sla-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c3089fab82ff5c6f$export$a6694c07cb5be8c1,
        pageId: "project-settings-service-desk-sla-settings",
        shouldShowSpinner: true
    }));

});
parcelRegister("fzq0U", function(module, exports) {

let $b55e4dac06b1118d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $b55e4dac06b1118d$var$load("1VRB2"),
    $b55e4dac06b1118d$var$load("bABhq"),
    $b55e4dac06b1118d$var$load("iEIco")
]).then(()=>parcelRequire('auMmF'));

});



parcelRegister("cK5xr", function(module, exports) {

$parcel$export(module.exports, "servicedeskWorkflowConfigRouteEntry", () => $bb839972f7d7949d$export$212f7f79630d5adc);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $jOpgR = parcelRequire("jOpgR");

var $aQoXd = parcelRequire("aQoXd");

var $iTAO8 = parcelRequire("iTAO8");
const $bb839972f7d7949d$var$workflowSchemeConfigPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iTAO8.workflowSchemeConfigEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $bb839972f7d7949d$export$212f7f79630d5adc = (0, $6xToB.createEntry)((0, $jOpgR.servicedeskWorkflowConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        entryPoint () {
            return $bb839972f7d7949d$var$workflowSchemeConfigPageEntrypoint;
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.workflow-scheme-config',
                packageName: 'projectSettingsWorkflowSchemeConfig',
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-workflow-scheme-config'
    }));

});
parcelRegister("iTAO8", function(module, exports) {

$parcel$export(module.exports, "workflowSchemeConfigEntrypoint", () => $f6ce23326fb8eb0c$export$12ccdf1d30de8ac);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $f6ce23326fb8eb0c$export$12ccdf1d30de8ac = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("5HyQu")), {
        moduleId: "6be3e66b",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5HyQu", function(module, exports) {

let $426bff7f85c9ab90$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $426bff7f85c9ab90$var$load("4E3uY").then(()=>parcelRequire('h5RId'));

});



parcelRegister("43qOr", function(module, exports) {

$parcel$export(module.exports, "settingsAutomationRouteEntry", () => $bbbfcd07506793c7$export$4df9f9dcaf8565c9);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $2UlkX = parcelRequire("2UlkX");

var $5fjzQ = parcelRequire("5fjzQ");

var $bhnHT = parcelRequire("bhnHT");
const $bbbfcd07506793c7$export$4df9f9dcaf8565c9 = (0, $6xToB.createEntry)((0, $2UlkX.settingsAutomationRoute), ()=>({
        group: 'global-settings',
        component: (0, $bhnHT.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bhnHT.LazyGlobalAutomation)
        ]
    }));

});
parcelRegister("2UlkX", function(module, exports) {

$parcel$export(module.exports, "settingsAutomationRoute", () => $92b8636abff4a3a7$export$b314ab31b2da625b);
const $92b8636abff4a3a7$export$b314ab31b2da625b = {
    name: 'global-automation',
    path: '/jira/settings/automation',
    exact: true
};

});

parcelRegister("bhnHT", function(module, exports) {

$parcel$export(module.exports, "LazyGlobalAutomation", () => $1c58a18722fba62a$export$4189991a2992b828);
$parcel$export(module.exports, "default", () => $1c58a18722fba62a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3Q6BV = parcelRequire("3Q6BV");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $91g62 = parcelRequire("91g62");

const $1c58a18722fba62a$export$4189991a2992b828 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3cxED"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/automation/src/index.tsx"
});
const $1c58a18722fba62a$export$7c85ddcd4f0a813f = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $3Q6BV.qs).stringify(rest, true);
        return `/automation${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $91g62.RedirectToProjectType), {
        page: page
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1c58a18722fba62a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1c58a18722fba62a$export$4189991a2992b828,
        pageId: "global-automation",
        shouldShowSpinner: false
    });

});
parcelRegister("91g62", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $e899c557b5b01570$export$8a3df560509448b8);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $dZRaT = parcelRequire("dZRaT");

var $iIqWW = parcelRequire("iIqWW");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");
var $gCY1z = parcelRequire("gCY1z");
const $e899c557b5b01570$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $2mHfh.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $gCeeo.fireUIAnalytics), page: page, useAnalyticsEvents: // eslint-disable-next-line react-hooks/react-compiler
useAnalyticsEvents = (0, $f1Zdy.useAnalyticsEvents), useResource: // eslint-disable-next-line react-hooks/react-compiler
useResource = (0, $eJrcF.useResource), useRouter: // eslint-disable-next-line react-hooks/react-compiler
useRouter = (0, $gCY1z.useRouter), useSpaStateTransition: // eslint-disable-next-line react-hooks/react-compiler
useSpaStateTransition = (0, $iIqWW.useSpaStateTransition) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ match: match, query: query, route: route }] = useRouter();
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: data } = useResource((0, $dZRaT.projectContextResource));
    // eslint-disable-next-line react-hooks/react-compiler
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eJOHy.useRef)(createAnalyticsEvent({}));
    (0, $eJOHy.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $ln6Iy.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $ln6Iy.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});

parcelRegister("3cxED", function(module, exports) {

let $254c992aa2cdc983$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $254c992aa2cdc983$var$load("6Fyu0").then(()=>parcelRequire('gpOYK'));

});



parcelRegister("gYfl3", function(module, exports) {

$parcel$export(module.exports, "settingsCmdbFieldConfigRouteEntry", () => $adcda12683ff0089$export$c68a412f25295511);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $7CgsF = parcelRequire("7CgsF");

var $ePaI2 = parcelRequire("ePaI2");

var $9871O = parcelRequire("9871O");
const $adcda12683ff0089$export$c68a412f25295511 = (0, $6xToB.createEntry)((0, $7CgsF.settingsCmdbFieldConfigRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.cmdb-field-config',
        component: (0, $9871O.AsyncCmdbFieldConfigPage),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9871O.LazyCMDBFieldConfigAdmin)
        ]
    }));

});
parcelRegister("7CgsF", function(module, exports) {

$parcel$export(module.exports, "settingsCmdbFieldConfigRoute", () => $a9db28a7b62798b9$export$5097bfaa68f86ca6);
const $a9db28a7b62798b9$export$5097bfaa68f86ca6 = {
    name: 'global-settings-issues-cmdb-field-config',
    path: '/secure/admin/CmdbObjectFieldConfiguration'
};

});

parcelRegister("9871O", function(module, exports) {

$parcel$export(module.exports, "LazyCMDBFieldConfigAdmin", () => $1912288813b3af7b$export$ccc6da5137e23637);
$parcel$export(module.exports, "AsyncCmdbFieldConfigPage", () => $1912288813b3af7b$export$8dfbe255f554ebab);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $1912288813b3af7b$export$ccc6da5137e23637 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("dPT3d"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/cmdb-field-config/src/index.tsx"
});
const $1912288813b3af7b$export$8dfbe255f554ebab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1912288813b3af7b$export$ccc6da5137e23637,
        pageId: "admin-pages-cmdb-field-config",
        shouldShowSpinner: true
    });

});
parcelRegister("dPT3d", function(module, exports) {

let $a12abdb9202ed84a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a12abdb9202ed84a$var$load("iIJ4I").then(()=>parcelRequire('a6mRS'));

});



parcelRegister("jo8cE", function(module, exports) {

$parcel$export(module.exports, "settingsOauthCredentialsRouteEntry", () => $c9dcac9b1618c585$export$d1c67ceb7c5e2d6a);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $6xToB = parcelRequire("6xToB");

var $g3UVq = parcelRequire("g3UVq");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $9W50L = parcelRequire("9W50L");

var $8PGkM = parcelRequire("8PGkM");
const $c9dcac9b1618c585$export$d1c67ceb7c5e2d6a = (0, $6xToB.createEntry)((0, $9W50L.settingsOauthCredentialsRoute), ()=>({
        group: 'global-settings',
        component: (0, $8PGkM.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gKFn0.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $g3UVq.adminOauthCredentialsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8PGkM.LazyOAuthCredentialsAdmin)
        ],
        ufoName: 'admin.oauth-credentials'
    }));

});
parcelRegister("g3UVq", function(module, exports) {

$parcel$export(module.exports, "adminOauthCredentialsResource", () => $072ab8081c2d6bff$export$870d7919c1ca4482);

var $l1VxS = parcelRequire("l1VxS");
const $072ab8081c2d6bff$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS = 'ADMIN_OAUTH_CREDENTIALS';

const $072ab8081c2d6bff$export$870d7919c1ca4482 = (0, $l1VxS.createResource)({
    type: $072ab8081c2d6bff$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("5h5fO"))
});

});
parcelRegister("5h5fO", function(module, exports) {

let $3d729d9b49cbaa13$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3d729d9b49cbaa13$var$load("d8o6f").then(()=>parcelRequire('lHApX'));

});


parcelRegister("9W50L", function(module, exports) {

$parcel$export(module.exports, "settingsOauthCredentialsRoute", () => $37d6367249c470a6$export$c0ee28def7ef8783);
const $37d6367249c470a6$export$c0ee28def7ef8783 = {
    name: 'admin-oauth-credentials',
    path: '/secure/admin/oauth-credentials'
};

});

parcelRegister("8PGkM", function(module, exports) {

$parcel$export(module.exports, "LazyOAuthCredentialsAdmin", () => $ccc03c004161bf3e$export$101baa25055633e8);
$parcel$export(module.exports, "default", () => $ccc03c004161bf3e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ccc03c004161bf3e$export$101baa25055633e8 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7OpRS"))), {
    moduleId: "./src/packages/spa-apps/admin-oauth-credentials/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ccc03c004161bf3e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ccc03c004161bf3e$export$101baa25055633e8,
        pageId: "admin-oauth-credentials",
        shouldShowSpinner: true
    });

});
parcelRegister("7OpRS", function(module, exports) {

let $5b0144c46a877c04$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5b0144c46a877c04$var$load("1VRB2"),
    $5b0144c46a877c04$var$load("bABhq"),
    $5b0144c46a877c04$var$load("6PbWK")
]).then(()=>parcelRequire('d0bjG'));

});



parcelRegister("kKMOG", function(module, exports) {

$parcel$export(module.exports, "settingsRouteEntry", () => $346d0e15f71a3dee$export$1d28e19560927106);

var $igNUx = parcelRequire("igNUx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $8Ewej = parcelRequire("8Ewej");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $7i1ou = parcelRequire("7i1ou");

var $g8uYY = parcelRequire("g8uYY");

var $eN8Nn = parcelRequire("eN8Nn");

var $cAYFR = parcelRequire("cAYFR");
const $346d0e15f71a3dee$var$settingsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $eN8Nn.settingsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $346d0e15f71a3dee$export$1d28e19560927106 = (0, $6xToB.createEntry)((0, $8Ewej.settingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $igNUx.isFedRamp)()) return undefined;
            return $346d0e15f71a3dee$var$settingsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $7i1ou.VirtualAgentSettingsSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("8Ewej", function(module, exports) {

$parcel$export(module.exports, "settingsRoute", () => $7d6cb131d28dfa23$export$847a7c378c11c645);
const $7d6cb131d28dfa23$export$847a7c378c11c645 = {
    name: 'project-settings-servicedesk-virtualagent-settings',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings/:tab(basic|channels)?'
};

});

parcelRegister("7i1ou", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentSettingsSkeleton", () => $d66400ba919edfd7$export$429c43ddcb09c14c);
/* VirtualAgentSettingsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $5p5Nf = parcelRequire("5p5Nf");
const $d66400ba919edfd7$var$customCssStyles = null;
const $d66400ba919edfd7$export$429c43ddcb09c14c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5p5Nf))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("5p5Nf", function(module, exports) {
module.exports = new URL("virtual-agent-settings-app-skeleton.tpl.1a9c03fe.svg", import.meta.url).toString();

});


parcelRegister("eN8Nn", function(module, exports) {

$parcel$export(module.exports, "settingsEntryPoint", () => $1cede4a6264e1977$export$d34e7816b7ac181a);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $gn5xr = parcelRequire("gn5xr");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $inQqC = parcelRequire("inQqC");

const $1cede4a6264e1977$export$d34e7816b7ac181a = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(0, $inQqC.clientSideOnly)((parcelRequire("6bXf7"))), {
        moduleId: "ed4de71b",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $gn5xr.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("gn5xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6354353d6b1a3a4c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6a8b54dff6bd67d9f566bb4eac1d257a>>
 * @relayHash 7189bee0c97cc09b10f8e1589368c2de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 392629a596a95c19575393c3c0047883914bb7cb4d8de01d923e7684c2f31d13

var $be7rL = parcelRequire("be7rL");

var $bXR9c = parcelRequire("bXR9c");

var $Ic6R7 = parcelRequire("Ic6R7");
const $6354353d6b1a3a4c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "392629a596a95c19575393c3c0047883914bb7cb4d8de01d923e7684c2f31d13",
        "metadata": {},
        "name": "srcVirtualAgentSettingsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableaianswerspagerelayprovider": (0, $be7rL.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": (0, $Ic6R7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $6354353d6b1a3a4c$export$2e2bcd8739ae039 = $6354353d6b1a3a4c$var$node;

});
parcelRegister("be7rL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb6c68a3b3294a2b$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $bb6c68a3b3294a2b$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jsm_va_enable_ai_answers_page');
    }
};

});


parcelRegister("6bXf7", function(module, exports) {

let $4821b988192b70a5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4821b988192b70a5$var$load("dszwr").then(()=>parcelRequire('i8TG9'));

});



parcelRegister("aNCbW", function(module, exports) {

$parcel$export(module.exports, "softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry", () => $c5f3a1cd0ce4a0a8$export$4652a26319dca4d0);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1rAxS = parcelRequire("1rAxS");

var $7fTjp = parcelRequire("7fTjp");

var $iIcBn = parcelRequire("iIcBn");
const $c5f3a1cd0ce4a0a8$export$4652a26319dca4d0 = (0, $6xToB.createEntry)((0, $1rAxS.softwareAdvancedRoadmapsGettingStartedRedirectRoute), ()=>({
        group: 'software',
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
                to: "/jira/plans?create-sample-plan=true"
            }),
        isRedirect: true,
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iIcBn.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("1rAxS", function(module, exports) {

$parcel$export(module.exports, "softwareAdvancedRoadmapsGettingStartedRedirectRoute", () => $5bbae3dea39fe9e8$export$38c76ea9ddc85b3);
const $5bbae3dea39fe9e8$export$38c76ea9ddc85b3 = {
    name: 'software-advanced-roadmaps-getting-started-redirect',
    path: '/secure/PortfolioGettingStarted.jspa'
};

});


parcelRegister("2AYKc", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogEmbedRouteEntry", () => $9e4ad6e06a75fe7d$export$7cd14dee22609378);


var $eJe5A = parcelRequire("eJe5A");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $90zcE = parcelRequire("90zcE");

var $gujXH = parcelRequire("gujXH");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $cxQGT = parcelRequire("cxQGT");

var $kAY5R = parcelRequire("kAY5R");

var $e1vE6 = parcelRequire("e1vE6");

var $5L7qx = parcelRequire("5L7qx");

var $epTsa = parcelRequire("epTsa");

var $v9AFd = parcelRequire("v9AFd");

var $2KSGq = parcelRequire("2KSGq");
const $9e4ad6e06a75fe7d$export$7cd14dee22609378 = (0, $6xToB.createEntry)((0, $kAY5R.softwareBacklogEmbedRoute), ()=>({
        group: 'software',
        component: (0, $2KSGq.BacklogPage),
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $90zcE.backlogResource),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $epTsa.expVal)('filter_refinement_in_tmp_backlog', 'isEnabled', false), (0, $v9AFd.customFiltersResource)),
            (0, $gujXH.backlogFilterRefinementResource),
            (0, $hHbzj.forgeBacklogModuleResource),
            (0, $hHbzj.forgeSprintModuleResource),
            (0, $cxQGT.themePreferenceResource),
            (0, $e1vE6.aiEntitlementResource)
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $2KSGq.LazyBacklogPage)
        ],
        ufoName: 'next-gen-backlog-embed',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$c17f34c425972af1)
        }
    }));

});
parcelRegister("90zcE", function(module, exports) {

$parcel$export(module.exports, "backlogResource", () => $58e7789c76a50fcb$export$31d171ba71468137);

var $l1VxS = parcelRequire("l1VxS");


const $58e7789c76a50fcb$export$31d171ba71468137 = (0, $l1VxS.createResource)({
    type: (0, $8740982aac8b017b$export$a0ef589381533a7c),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("kjORK")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});

});
const $8740982aac8b017b$export$faa68b3df5415bcb = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
const $8740982aac8b017b$export$214238a9ff4636a = 'NEXTGEN_BACKLOG_FILTER_REFINEMENT';
const $8740982aac8b017b$export$a0ef589381533a7c = 'NEXTGEN_BACKLOG';

parcelRegister("kjORK", function(module, exports) {

let $ecad09e6b3dfd22a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ecad09e6b3dfd22a$var$load("4sDgu").then(()=>parcelRequire('jhz3p'));

});


parcelRegister("gujXH", function(module, exports) {

$parcel$export(module.exports, "backlogFilterRefinementResource", () => $977032b4b33698a9$export$f9d71cb27b4dd1d8);

var $j4oe4 = parcelRequire("j4oe4");

var $5L7qx = parcelRequire("5L7qx");

var $epTsa = parcelRequire("epTsa");

var $8oKDI = parcelRequire("8oKDI");

var $5EQLQ = parcelRequire("5EQLQ");

var $l1VxS = parcelRequire("l1VxS");

var $7zZ4w = parcelRequire("7zZ4w");

const $977032b4b33698a9$export$f9d71cb27b4dd1d8 = (0, $5L7qx.resourceWithCondition2)(()=>(0, $epTsa.expVal)('filter_refinement_in_tmp_backlog', 'isEnabled', false), (0, $l1VxS.createResource)({
    type: (0, $8740982aac8b017b$export$214238a9ff4636a),
    getKey: ()=>'backlog-filter-refinement-relay',
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const variables = {
            cloudId: tenantContext.cloudId,
            jql: query.jql ?? '',
            boardId: (0, $8oKDI.createAri)({
                resourceOwner: 'jira-software',
                cloudId: tenantContext.cloudId,
                resourceType: 'board',
                resourceId: String(match.params.boardId)
            }),
            filterRefinementScope: {
                backlog: {
                    boardId: Number(match.params.boardId)
                }
            }
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $5EQLQ.default), variables, {
            fetchPolicy: 'store-and-network'
        });
        return queryReference;
    },
    isBrowserOnly: true,
    maxAge: 0
}));

});
parcelRegister("5EQLQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b11829064dc24ace$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<38cef98c44dd3e578da4e6b818898188>>
 * @relayHash fc25c87c64c90bb0fea80756cd9aa3be
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b8e629667f63aa2e4f893827457e519864aa139f6bc57f7d478a579c9b3c644c
const $b11829064dc24ace$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b8e629667f63aa2e4f893827457e519864aa139f6bc57f7d478a579c9b3c644c",
        "metadata": {},
        "name": "backlogFilterRefinementQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b11829064dc24ace$export$2e2bcd8739ae039 = $b11829064dc24ace$var$node;

});


parcelRegister("kAY5R", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogEmbedRoute", () => $8ec0d0dc88b6fdf8$export$bc022a39c42aba2f);
const $8ec0d0dc88b6fdf8$export$bc022a39c42aba2f = {
    name: 'software-backlog-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog/embed',
    exact: true
};

});

parcelRegister("v9AFd", function(module, exports) {

$parcel$export(module.exports, "customFiltersResource", () => $980e206f0066c16a$export$3e390340716755de);

var $8oKDI = parcelRequire("8oKDI");

var $9FYIg = parcelRequire("9FYIg");

var $1WHGo = parcelRequire("1WHGo");

const $980e206f0066c16a$export$3e390340716755de = (0, $9FYIg.createRelayResource)({
    type: (0, $8740982aac8b017b$export$faa68b3df5415bcb),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $1WHGo.default),
            variables: {
                boardId: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    captureErrors: true,
    isBrowserOnly: true
});

});
parcelRegister("1WHGo", function(module, exports) {

$parcel$export(module.exports, "default", () => $72ce06bc2d802e83$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<066895e3c0e872466470887b4350609b>>
 * @relayHash 8bb4d5e3e502ca70e90f4e1bb2f1614f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082
const $72ce06bc2d802e83$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "customFilter_softwareFilters_CustomFilterRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082",
            "metadata": {},
            "name": "viewBacklogCustomFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$72ce06bc2d802e83$var$node.hash = "071c255f9696fe84a9c3982d42cfa5c0";
var $72ce06bc2d802e83$export$2e2bcd8739ae039 = $72ce06bc2d802e83$var$node;

});


parcelRegister("2KSGq", function(module, exports) {

$parcel$export(module.exports, "LazyBacklogPage", () => $cf6cd6155216962a$export$edb4b8cf67d7d767);
$parcel$export(module.exports, "BacklogPage", () => $cf6cd6155216962a$export$471ffbe87b75af04);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $e4c90 = parcelRequire("e4c90");

const $cf6cd6155216962a$export$edb4b8cf67d7d767 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("dQetM"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});
const $cf6cd6155216962a$export$471ffbe87b75af04 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cf6cd6155216962a$export$edb4b8cf67d7d767,
        pageId: `next-gen-backlog-${(0, $e4c90.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("e4c90", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $480069ddc1b8be2e$export$557c2f222778cea6);

var $b5RwB = parcelRequire("b5RwB");
const $480069ddc1b8be2e$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(location.search);
    return rapidView;
};

});



parcelRegister("cJqhS", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogRouteEntry", () => $1f110322ba1d3ae8$export$a5f8ba02d2755510);


var $7jTnu = parcelRequire("7jTnu");

var $hS1gr = parcelRequire("hS1gr");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $90zcE = parcelRequire("90zcE");

var $gujXH = parcelRequire("gujXH");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $6nGIP = parcelRequire("6nGIP");

var $9ZjGp = parcelRequire("9ZjGp");

var $8FCAy = parcelRequire("8FCAy");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $e1vE6 = parcelRequire("e1vE6");

var $epTsa = parcelRequire("epTsa");

var $v9AFd = parcelRequire("v9AFd");

var $63moR = parcelRequire("63moR");
const $1f110322ba1d3ae8$export$a5f8ba02d2755510 = (0, $6xToB.createEntry)((0, $6nGIP.softwareBacklogRoute), ()=>({
        group: 'software',
        skeleton: (0, $9ZjGp.NextGenBacklogSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $7jTnu.fg)('jfp-magma-fix-nav4-sidebar-client-api-call') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-fix-nav4-sidebar-client-api-call')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3Only),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResourceOnNav3Only),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $90zcE.backlogResource),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $epTsa.expVal)('filter_refinement_in_tmp_backlog', 'isEnabled', false), (0, $v9AFd.customFiltersResource)),
            (0, $gujXH.backlogFilterRefinementResource),
            (0, $hHbzj.forgeBacklogModuleResource),
            (0, $hHbzj.forgeSprintModuleResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $e1vE6.aiEntitlementResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-backlog-early-entry'
            ]
        },
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        ufoName: 'next-gen-backlog',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$c17f34c425972af1)
        },
        entryPoint: ()=>(0, $63moR.backlogPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("6nGIP", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogRoute", () => $ae3d39c5830d8333$export$fb454ec14936c0ab);
const $ae3d39c5830d8333$export$fb454ec14936c0ab = {
    name: 'software-backlog',
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog'
};

});

parcelRegister("63moR", function(module, exports) {

$parcel$export(module.exports, "backlogPageEntrypoint", () => $81d0d04f32a7298c$export$1ccf08591607897d);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $cw1BI = parcelRequire("cw1BI");
const $81d0d04f32a7298c$export$1ccf08591607897d = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cw1BI.nextGenBacklogEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("ejo5K", function(module, exports) {

$parcel$export(module.exports, "softwareBoardEmbedRouteEntry", () => $8de7d489f7b08ccf$export$ff8632c8a0f5d984);


var $eJe5A = parcelRequire("eJe5A");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4f4nP = parcelRequire("4f4nP");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $cxQGT = parcelRequire("cxQGT");

var $eLjrd = parcelRequire("eLjrd");

var $lM6Lx = parcelRequire("lM6Lx");

var $dOwkS = parcelRequire("dOwkS");

var $kjtKR = parcelRequire("kjtKR");

var $b8mAd = parcelRequire("b8mAd");

var $5ObVX = parcelRequire("5ObVX");
const $8de7d489f7b08ccf$export$ff8632c8a0f5d984 = (0, $6xToB.createEntry)((0, $eLjrd.softwareBoardEmbedRoute), ()=>({
        group: 'software',
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $lM6Lx.conditionalBoardNBTOptInResource),
            (0, $kjtKR.conditionalBoardResource),
            (0, $dOwkS.conditionalBoardRelayResource),
            (0, $4f4nP.boardFilterRefinementResource),
            (0, $b8mAd.conditionalCustomFiltersResource),
            (0, $cxQGT.themePreferenceResource),
            (0, $hHbzj.forgeBoardModuleResource)
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $5ObVX.softwareBoardPageEntrypoint),
        ufoName: 'next-gen-board-embed',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$f364828958cffad0)
        }
    }));

});
parcelRegister("4f4nP", function(module, exports) {

$parcel$export(module.exports, "boardResource", () => $380e54478f9157ea$export$286b76e0f2661cfb);
$parcel$export(module.exports, "customFiltersResource", () => $380e54478f9157ea$export$3e390340716755de);
$parcel$export(module.exports, "boardFilterRefinementResource", () => $380e54478f9157ea$export$283d16e3e02421f0);
$parcel$export(module.exports, "boardRelayResource", () => $380e54478f9157ea$export$81ac23db76b1f935);
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config

var $epTsa = parcelRequire("epTsa");

var $8oKDI = parcelRequire("8oKDI");

var $9FYIg = parcelRequire("9FYIg");

var $dyhDN = parcelRequire("dyhDN");

var $iAXqa = parcelRequire("iAXqa");

var $cOAoV = parcelRequire("cOAoV");

var $5L7qx = parcelRequire("5L7qx");

var $l1VxS = parcelRequire("l1VxS");


const $380e54478f9157ea$export$286b76e0f2661cfb = (0, $l1VxS.createResource)({
    type: (0, $611489349b87bf12$export$a38ac7339e3f31db),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("95Jdb")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});
const $380e54478f9157ea$export$3e390340716755de = (0, $9FYIg.createRelayResource)({
    type: (0, $611489349b87bf12$export$b48bcc76a0105016),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $iAXqa.default),
            variables: {
                boardId: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
});
const $380e54478f9157ea$export$283d16e3e02421f0 = (0, $5L7qx.resourceWithCondition2)(()=>(0, $epTsa.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false), (0, $9FYIg.createRelayResource)({
    type: (0, $611489349b87bf12$export$339da8fd7fc0a8e9),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $cOAoV.default),
            variables: {
                cloudId: tenantContext.cloudId,
                boardId: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                filterRefinementScope: {
                    board: {
                        boardId: Number(match.params.boardId)
                    }
                }
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
}));
const $380e54478f9157ea$export$81ac23db76b1f935 = (0, $9FYIg.createRelayResource)({
    type: (0, $611489349b87bf12$export$5cef388780439aec),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $dyhDN.default),
            variables: {
                boardId: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
});

});
parcelRegister("dyhDN", function(module, exports) {

$parcel$export(module.exports, "default", () => $200eaff81ed40be8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<916f92cb49153da25a6abe2a4d651185>>
 * @relayHash 1b45667561f9430ea4e961757485983b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67
const $200eaff81ed40be8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67",
        "metadata": {},
        "name": "boardWithRouterRelayQuery",
        "operationKind": "query",
        "text": null
    }
};
var $200eaff81ed40be8$export$2e2bcd8739ae039 = $200eaff81ed40be8$var$node;

});

parcelRegister("iAXqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c84fb719b191c9eb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e40c06e874adef0395c5788a7d119a9>>
 * @relayHash fa277d121f8f09e75035802d7ede6889
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b
const $c84fb719b191c9eb$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b",
        "metadata": {},
        "name": "viewBoardCustomFiltersQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c84fb719b191c9eb$export$2e2bcd8739ae039 = $c84fb719b191c9eb$var$node;

});

parcelRegister("cOAoV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dd6dbaf9d10d522$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2791ce93d3a0a0e17fee486ad965601>>
 * @relayHash 5c749d389bf268ee9226560ad568adcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9283dbd6d43bd23893ba0d1fb905c533d07635b370710c93db0ea67cb8b41e06
const $7dd6dbaf9d10d522$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9283dbd6d43bd23893ba0d1fb905c533d07635b370710c93db0ea67cb8b41e06",
        "metadata": {},
        "name": "boardFilterRefinementQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7dd6dbaf9d10d522$export$2e2bcd8739ae039 = $7dd6dbaf9d10d522$var$node;

});

const $611489349b87bf12$export$a38ac7339e3f31db = 'NEXTGEN_BOARD';
const $611489349b87bf12$export$b48bcc76a0105016 = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
const $611489349b87bf12$export$5cef388780439aec = 'NEXTGEN_BOARD_RELAY';
const $611489349b87bf12$export$339da8fd7fc0a8e9 = 'NEXTGEN_BOARD_FILTER_REFINEMENT';

parcelRegister("95Jdb", function(module, exports) {

let $69e7a6c35813e232$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $69e7a6c35813e232$var$load("hwlgY"),
    $69e7a6c35813e232$var$load("5sr1O")
]).then(()=>parcelRequire('5P2oX'));

});


parcelRegister("eLjrd", function(module, exports) {

$parcel$export(module.exports, "softwareBoardEmbedRoute", () => $228b49f1be9e4c68$export$f55626b64e3fcb4f);
const $228b49f1be9e4c68$export$f55626b64e3fcb4f = {
    name: 'software-boards-embed',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/embed'
};

});

parcelRegister("lM6Lx", function(module, exports) {

$parcel$export(module.exports, "conditionalBoardNBTOptInResource", () => $77bca784f22b7832$export$3cdaa13b878c3c59);

var $igNUx = parcelRequire("igNUx");

var $b8mPY = parcelRequire("b8mPY");

var $5L7qx = parcelRequire("5L7qx");
const $77bca784f22b7832$export$3cdaa13b878c3c59 = (0, $5L7qx.resourceWithCondition2)(()=>!(0, $igNUx.isFedRamp)(), (0, $b8mPY.nextBestTaskFeatureResource));

});

parcelRegister("dOwkS", function(module, exports) {

$parcel$export(module.exports, "conditionalBoardRelayResource", () => $563e2ea3976e600f$export$ce009bf1a33fb264);

var $7jTnu = parcelRequire("7jTnu");

var $4f4nP = parcelRequire("4f4nP");

var $5L7qx = parcelRequire("5L7qx");
const $563e2ea3976e600f$export$ce009bf1a33fb264 = (0, $5L7qx.resourceWithCondition)(()=>(0, $7jTnu.fg)('critical_board_query_with_relay'), (0, $4f4nP.boardRelayResource));

});

parcelRegister("kjtKR", function(module, exports) {

$parcel$export(module.exports, "conditionalBoardResource", () => $c527a3878e878781$export$2ba7dfd4089a1a57);

var $7jTnu = parcelRequire("7jTnu");

var $4f4nP = parcelRequire("4f4nP");

var $5L7qx = parcelRequire("5L7qx");
const $c527a3878e878781$export$2ba7dfd4089a1a57 = (0, $5L7qx.resourceWithCondition)(()=>!(0, $7jTnu.fg)('critical_board_query_with_relay'), (0, $4f4nP.boardResource));

});

parcelRegister("b8mAd", function(module, exports) {

$parcel$export(module.exports, "conditionalCustomFiltersResource", () => $71e03cdfec5f880f$export$ad9ac1bd5f72148c);

var $epTsa = parcelRequire("epTsa");

var $4f4nP = parcelRequire("4f4nP");

var $5L7qx = parcelRequire("5L7qx");
const $71e03cdfec5f880f$export$ad9ac1bd5f72148c = (0, $5L7qx.resourceWithCondition2)(()=>!(0, $epTsa.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false), (0, $4f4nP.customFiltersResource));

});

parcelRegister("5ObVX", function(module, exports) {

$parcel$export(module.exports, "softwareBoardPageEntrypoint", () => $2cb160a154536b24$export$89009c28cae628ae);

var $g8uYY = parcelRequire("g8uYY");

var $9n5I0 = parcelRequire("9n5I0");

var $iJnZt = parcelRequire("iJnZt");

var $5RW99 = parcelRequire("5RW99");
const $2cb160a154536b24$export$89009c28cae628ae = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iJnZt.nextGenBoardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("hnRYr", function(module, exports) {

$parcel$export(module.exports, "softwareBoardRouteEntry", () => $32f85b5eedeef97d$export$2964ea1cdd5afa39);


var $hS1gr = parcelRequire("hS1gr");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4f4nP = parcelRequire("4f4nP");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $jmzgU = parcelRequire("jmzgU");

var $h1VgH = parcelRequire("h1VgH");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $8FCAy = parcelRequire("8FCAy");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $8vmEP = parcelRequire("8vmEP");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $lM6Lx = parcelRequire("lM6Lx");

var $dOwkS = parcelRequire("dOwkS");

var $kjtKR = parcelRequire("kjtKR");

var $b8mAd = parcelRequire("b8mAd");

var $5ObVX = parcelRequire("5ObVX");
const $32f85b5eedeef97d$var$getColoredLabelsResource = ()=>{
    return (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? [
        (0, $8vmEP.coloredLabelsResource)
    ] : [];
};
const $32f85b5eedeef97d$export$2964ea1cdd5afa39 = (0, $6xToB.createEntry)((0, $jmzgU.softwareBoardRoute), ()=>({
        group: 'software',
        skeleton: (0, $h1VgH.NextGenBoardSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3Only),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResourceOnNav3Only),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $kjtKR.conditionalBoardResource),
            (0, $b8mAd.conditionalCustomFiltersResource),
            (0, $4f4nP.boardFilterRefinementResource),
            (0, $dOwkS.conditionalBoardRelayResource),
            (0, $lM6Lx.conditionalBoardNBTOptInResource),
            (0, $hHbzj.forgeBoardModuleResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource)),
            ...$32f85b5eedeef97d$var$getColoredLabelsResource()
        ],
        preloadOptions: {
            earlyChunks: [
                'software-board-early-entry'
            ]
        },
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $5ObVX.softwareBoardPageEntrypoint),
        ufoName: 'next-gen-board',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$f364828958cffad0)
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("jmzgU", function(module, exports) {

$parcel$export(module.exports, "softwareBoardRoute", () => $082ff7e9e2fdd717$export$9ae2c0a566d4e0f6);
const $082ff7e9e2fdd717$export$9ae2c0a566d4e0f6 = {
    name: 'software-boards',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("h1VgH", function(module, exports) {

$parcel$export(module.exports, "NextGenBoardSkeleton", () => $74b97cceeddc70ee$export$25a9d0fbcb127c90);
/* NextGenBoardSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $EMeai = parcelRequire("EMeai");
const $74b97cceeddc70ee$var$customCssStyles = null;
const $74b97cceeddc70ee$export$25a9d0fbcb127c90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($EMeai))),
        className: (0, $hcewu.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("EMeai", function(module, exports) {
module.exports = new URL("next-gen-board-app-skeleton.tpl.d10f8ca5.svg", import.meta.url).toString();

});



parcelRegister("88nEe", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundClassicRouteEntry", () => $ef672e9ab2c49de9$export$bdd0e204be6866cd);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8Dimt = parcelRequire("8Dimt");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $38Nv8 = parcelRequire("38Nv8");
const $ef672e9ab2c49de9$export$bdd0e204be6866cd = (0, $6xToB.createEntry)((0, $8Dimt.softwareBoardViewNotFoundClassicRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $38Nv8.boardViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("8Dimt", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundClassicRoute", () => $8c3566b128826553$export$b31cf885abe93fbf);
const $8c3566b128826553$export$b31cf885abe93fbf = {
    name: 'software-board-view-not-found-classic',
    exact: true,
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/not-found'
};

});

parcelRegister("38Nv8", function(module, exports) {

$parcel$export(module.exports, "boardViewNotFoundPageEntrypoint", () => $59e711c8d04a000f$export$7f51979492148d53);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $f3Kvz = parcelRequire("f3Kvz");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

const $59e711c8d04a000f$var$main = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("hb8i0")), {
        moduleId: "83a02129",
        moduleName: "BoardViewNotFound",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const boardId = context.match.params.boardId;
        if (boardId == null) throw new Error('Board id missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $f3Kvz.default,
                    variables: {
                        boardId: `ari:cloud:jira-software:${cloudId}:board/${boardId}`
                    }
                }
            }
        };
    }
});
const $59e711c8d04a000f$export$7f51979492148d53 = (0, $g8uYY.createPageEntryPoint)({
    main: $59e711c8d04a000f$var$main,
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("f3Kvz", function(module, exports) {

$parcel$export(module.exports, "default", () => $972ecde19466b0e4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39b4c2382e9edb79ca18ee82cc3dcb5e>>
 * @relayHash c015acb85644d3bee5c8b2cb145b1d66
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 082161233dbd381be9ed014242444b47bd21443811aada3c5cc8c3c2e46e7c51
const $972ecde19466b0e4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "082161233dbd381be9ed014242444b47bd21443811aada3c5cc8c3c2e46e7c51",
        "metadata": {},
        "name": "BoardViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $972ecde19466b0e4$export$2e2bcd8739ae039 = $972ecde19466b0e4$var$node;

});

parcelRegister("hb8i0", function(module, exports) {

let $c819e4e11f87b4dd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c819e4e11f87b4dd$var$load("kN9H0").then(()=>parcelRequire('cU5Kj'));

});



parcelRegister("4nTz0", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundRouteEntry", () => $bd94b282acc6ce41$export$70fda0ba037c81ca);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $eCRwp = parcelRequire("eCRwp");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $38Nv8 = parcelRequire("38Nv8");
const $bd94b282acc6ce41$export$70fda0ba037c81ca = (0, $6xToB.createEntry)((0, $eCRwp.softwareBoardViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $38Nv8.boardViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("eCRwp", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundRoute", () => $8fbbb35e24a43ebd$export$4c5eaffb9e70d071);
const $8fbbb35e24a43ebd$export$4c5eaffb9e70d071 = {
    name: 'software-board-view-not-found',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/not-found'
};

});


parcelRegister("8W2c8", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicCustomEmbedRouteEntry", () => $20639c7a493d5f77$export$406edd4ac84413cc);

var $6xToB = parcelRequire("6xToB");

var $4DCrA = parcelRequire("4DCrA");

var $dsh9d = parcelRequire("dsh9d");

var $7K5Ea = parcelRequire("7K5Ea");

var $cxQGT = parcelRequire("cxQGT");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $7jTnu = parcelRequire("7jTnu");

var $hXFFJ = parcelRequire("hXFFJ");
const $20639c7a493d5f77$export$406edd4ac84413cc = (0, $6xToB.createEntry)((0, $4DCrA.softwareCalendarClassicCustomEmbedRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $dsh9d.CalendarEmbedSkeleton),
        component: (0, $dsh9d.CalendarEmbedSkeleton),
        entryPoint () {
            return 0, $hXFFJ.softwareCalendarRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $cxQGT.themePreferenceResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        ufoName: 'classic-calendar-embed',
        EXPERIMENTAL__shouldReload: (0, $7jTnu.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined
    }));

});
parcelRegister("4DCrA", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicCustomEmbedRoute", () => $04236a0a1bec0b5a$export$15e88f3b033926ec);
const $04236a0a1bec0b5a$export$15e88f3b033926ec = {
    name: 'software-calendar-classic-custom-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/:itemId/embed',
    query: [
        'date?'
    ]
};

});

parcelRegister("hXFFJ", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarRouteEntry", () => $58d826ffc1c36292$export$83b1b9036cc7961a);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $eAYvp = parcelRequire("eAYvp");

var $9n5I0 = parcelRequire("9n5I0");
const $58d826ffc1c36292$export$83b1b9036cc7961a = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $eAYvp.calendarEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("eAYvp", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $36959cde1662fa07$export$19cf4b398f638dc6);

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $dW8bA = parcelRequire("dW8bA");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");
const $36959cde1662fa07$var$SETTINGS_STORAGE_KEY = 'calendar:settings:software';
function $36959cde1662fa07$var$getViewSettings(key) {
    try {
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
function $36959cde1662fa07$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $36959cde1662fa07$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $36959cde1662fa07$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
/* Given the current constraints that prevent importing route name constants into the entrypoint,
we are re-defining these constants here in order to perform a route name check.
Consider breaking this entrypoint per route to avoid these types of checks and dependencies. */ const $36959cde1662fa07$var$SOFTWARE_CALENDAR = 'software-calendar';
const $36959cde1662fa07$var$SOFTWARE_CALENDAR_EMBED = 'software-calendar-embed';
const $36959cde1662fa07$var$SOFTWARE_CALENDAR_CUSTOM_EMBED = 'software-calendar-custom-embed';
const $36959cde1662fa07$var$TEAM_MANAGED_CALENDAR_ROUTES = [
    $36959cde1662fa07$var$SOFTWARE_CALENDAR,
    $36959cde1662fa07$var$SOFTWARE_CALENDAR_EMBED,
    $36959cde1662fa07$var$SOFTWARE_CALENDAR_CUSTOM_EMBED
];
function $36959cde1662fa07$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { cloudId: cloudId } = tenantContext;
    const isTMP = $36959cde1662fa07$var$TEAM_MANAGED_CALENDAR_ROUTES.includes(context.route.name);
    return {
        type: 'board',
        boardId: $36959cde1662fa07$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: isTMP ? [
            String(context.match.params.projectKey)
        ] : []
    };
}
function $36959cde1662fa07$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    const scopeInput = {
        ids: [
            scope.boardId
        ]
    };
    if ((0, $7jTnu.fg)('jira_calendar_load_more_pagination') || scope.projectKeys && scope.projectKeys.length > 0) return {
        ...scopeInput,
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
    return scopeInput;
}
function $36959cde1662fa07$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $36959cde1662fa07$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $36959cde1662fa07$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $36959cde1662fa07$var$toMidnightUTCString(selectedDate),
        mode: $36959cde1662fa07$var$toViewMode(viewRange),
        weekStart: $36959cde1662fa07$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField,
        viewId: null
    };
}
function $36959cde1662fa07$var$buildIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $36959cde1662fa07$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $36959cde1662fa07$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $36959cde1662fa07$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}

const $36959cde1662fa07$export$19cf4b398f638dc6 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("lE1Lv")), {
        moduleId: "57ee20a5",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $36959cde1662fa07$var$createScope(entryPointRouteParams);
        const { date: date } = context.query;
        const selectedDate = $36959cde1662fa07$var$toDate(date);
        const boardId = String(context.match.params.boardId);
        const settings = (0, $7jTnu.fg)('jira_calendar_load_more_pagination') ? $36959cde1662fa07$var$getViewSettings($36959cde1662fa07$var$SETTINGS_STORAGE_KEY) : undefined;
        const viewRange = 'month';
        const weekStartsOn = (0, $7jTnu.fg)('jira_calendar_load_more_pagination') ? settings?.weekStartsOn ?? 'sunday' : 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $dW8bA.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $36959cde1662fa07$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $36959cde1662fa07$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesPageSize: 200,
                        issuesSearchInput: $36959cde1662fa07$var$buildIssuesSearchInput(),
                        unscheduledIssuesSearchInput: $36959cde1662fa07$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $36959cde1662fa07$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $36959cde1662fa07$var$buildSprintsSearchInput(),
                        includeRecurrenceIndicator: (0, $epTsa.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true),
                        skipSprintSearch: false,
                        viewId: null,
                        schedulePermissionsEnabled: (0, $7jTnu.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $7jTnu.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV2Search: false,
                        pageLoadMoreEnabledViewSettings: (0, $7jTnu.fg)('jira_calendar_load_more_pagination_view_settings'),
                        skipUserPreferences: false,
                        hasSavedFilterCapability: (0, $epTsa.expValEquals)('atlas-96240_saved_views_calendar', 'enabled', true, false)
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                boardId: boardId,
                hasRecurrenceItemIndicator: (0, $epTsa.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true)
            }
        };
    }
});

});
parcelRegister("lE1Lv", function(module, exports) {

let $fc1eb3f66d03961a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $fc1eb3f66d03961a$var$load("1VRB2"),
    $fc1eb3f66d03961a$var$load("bABhq"),
    $fc1eb3f66d03961a$var$load("7vqGd"),
    $fc1eb3f66d03961a$var$load("1Y4bq"),
    $fc1eb3f66d03961a$var$load("hrvPo")
]).then(()=>parcelRequire('7IGR2'));

});




parcelRegister("5gnJR", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicEmbedRouteEntry", () => $b3792522cdd81cc5$export$6a544072729c1964);

var $6xToB = parcelRequire("6xToB");

var $8Q4qB = parcelRequire("8Q4qB");

var $dsh9d = parcelRequire("dsh9d");

var $7K5Ea = parcelRequire("7K5Ea");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $cxQGT = parcelRequire("cxQGT");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $7jTnu = parcelRequire("7jTnu");

var $hXFFJ = parcelRequire("hXFFJ");
const $b3792522cdd81cc5$export$6a544072729c1964 = (0, $6xToB.createEntry)((0, $8Q4qB.softwareCalendarClassicEmbedRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $dsh9d.CalendarEmbedSkeleton),
        component: (0, $dsh9d.CalendarEmbedSkeleton),
        entryPoint () {
            if (false && !(0, $7jTnu.fg)('blu-7930-skip-ssr-using-index-server-tsx')) return undefined;
            return 0, $hXFFJ.softwareCalendarRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $cxQGT.themePreferenceResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        ufoName: 'classic-calendar-embed',
        EXPERIMENTAL__shouldReload: (0, $7jTnu.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined
    }));

});
parcelRegister("8Q4qB", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicEmbedRoute", () => $8889ea7696c77d51$export$ced2612fe5124ff8);
const $8889ea7696c77d51$export$ced2612fe5124ff8 = {
    name: 'software-calendar-classic-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/embed',
    query: [
        'date?'
    ]
};

});


parcelRegister("gkm2X", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicRouteEntry", () => $8d695f3e68aff2e9$export$17ea82bdc641d5ce);

var $6xToB = parcelRequire("6xToB");

var $7jTnu = parcelRequire("7jTnu");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $buqv4 = parcelRequire("buqv4");

var $dsh9d = parcelRequire("dsh9d");

var $6dwgv = parcelRequire("6dwgv");

var $8FCAy = parcelRequire("8FCAy");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $eJe5A = parcelRequire("eJe5A");

var $kHlOR = parcelRequire("kHlOR");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $hXFFJ = parcelRequire("hXFFJ");
const $8d695f3e68aff2e9$export$17ea82bdc641d5ce = (0, $6xToB.createEntry)((0, $buqv4.softwareCalendarClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $dsh9d.CalendarSkeleton),
        component: (0, $dsh9d.CalendarSkeleton),
        entryPoint () {
            // TODO: Adopt sidebar entrypoints when calender route enables SSR
            if (false && !(0, $7jTnu.fg)('blu-7930-skip-ssr-using-index-server-tsx')) return undefined;
            return 0, $hXFFJ.softwareCalendarRouteEntry;
        },
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.classicSoftwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        ufoName: 'classic-calendar',
        EXPERIMENTAL__shouldReload: (0, $7jTnu.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined,
        supportsPreviewPanel: true
    }));

});
parcelRegister("buqv4", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicRoute", () => $f71d2edc535c1029$export$f2c3b99639d54eb8);
const $f71d2edc535c1029$export$f2c3b99639d54eb8 = {
    name: 'software-calendar-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/:itemId?',
    query: [
        'date?'
    ]
};

});


parcelRegister("csjBW", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarCustomEmbedRouteEntry", () => $3dd664dc7cf1ee31$export$bfbf26d8d634e108);

var $7K5Ea = parcelRequire("7K5Ea");

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $2xzsN = parcelRequire("2xzsN");

var $dsh9d = parcelRequire("dsh9d");

var $cxQGT = parcelRequire("cxQGT");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $918ZE = parcelRequire("918ZE");
const $3dd664dc7cf1ee31$export$bfbf26d8d634e108 = (0, $6xToB.createEntry)((0, $2xzsN.softwareCalendarCustomEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $dsh9d.CalendarEmbedSkeleton),
        component: (0, $dsh9d.CalendarEmbedSkeleton),
        entryPoint () {
            return 0, $918ZE.calendarRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $cxQGT.themePreferenceResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        ufoName: 'next-gen-calendar-embed',
        EXPERIMENTAL__shouldReload: (0, $7jTnu.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined
    }));

});
parcelRegister("2xzsN", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarCustomEmbedRoute", () => $0266de42d58cebf1$export$c933cc18934d5dbd);
const $0266de42d58cebf1$export$c933cc18934d5dbd = {
    name: 'software-calendar-custom-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/:itemId/embed',
    query: [
        'date?'
    ]
};

});

parcelRegister("918ZE", function(module, exports) {

$parcel$export(module.exports, "calendarRouteEntry", () => $9c81707e353f7761$export$d154630e8966be91);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $eAYvp = parcelRequire("eAYvp");

var $9n5I0 = parcelRequire("9n5I0");
const $9c81707e353f7761$export$d154630e8966be91 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $eAYvp.calendarEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("lj5Av", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarEmbedRouteEntry", () => $1c02e8919743f490$export$24fc07c22f0d06);

var $7K5Ea = parcelRequire("7K5Ea");

var $7jTnu = parcelRequire("7jTnu");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $cxQGT = parcelRequire("cxQGT");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $8OUu2 = parcelRequire("8OUu2");

var $dsh9d = parcelRequire("dsh9d");

var $918ZE = parcelRequire("918ZE");
const $1c02e8919743f490$export$24fc07c22f0d06 = (0, $6xToB.createEntry)((0, $8OUu2.softwareCalendarEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $dsh9d.CalendarEmbedSkeleton),
        component: (0, $dsh9d.CalendarEmbedSkeleton),
        entryPoint () {
            if (false && !(0, $7jTnu.fg)('blu-7930-skip-ssr-using-index-server-tsx')) return undefined;
            return 0, $918ZE.calendarRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $cxQGT.themePreferenceResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        ufoName: 'next-gen-calendar-embed',
        EXPERIMENTAL__shouldReload: (0, $7jTnu.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined
    }));

});
parcelRegister("8OUu2", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarEmbedRoute", () => $5b181687afcf3816$export$b55c4d4efb097c1c);
const $5b181687afcf3816$export$b55c4d4efb097c1c = {
    name: 'software-calendar-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/embed',
    query: [
        'date?'
    ]
};

});


parcelRegister("byNoq", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarRouteEntry", () => $20ad68e0a08bd95e$export$83b1b9036cc7961a);

var $kHlOR = parcelRequire("kHlOR");

var $7jTnu = parcelRequire("7jTnu");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $2wgfj = parcelRequire("2wgfj");

var $dsh9d = parcelRequire("dsh9d");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $918ZE = parcelRequire("918ZE");
const $20ad68e0a08bd95e$export$83b1b9036cc7961a = (0, $6xToB.createEntry)((0, $2wgfj.softwareCalendarRoute), ()=>({
        group: 'software',
        skeleton: (0, $dsh9d.CalendarSkeleton),
        component: (0, $dsh9d.CalendarSkeleton),
        entryPoint () {
            // TODO: Adopt sidebar entrypoints when calender route enables SSR
            if (false && !(0, $7jTnu.fg)('blu-7930-skip-ssr-using-index-server-tsx')) return undefined;
            return 0, $918ZE.calendarRouteEntry;
        },
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        ufoName: 'next-gen-calendar',
        EXPERIMENTAL__shouldReload: (0, $7jTnu.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined,
        supportsPreviewPanel: true
    }));

});
parcelRegister("2wgfj", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarRoute", () => $93c04b7043a930e3$export$d6730f103a4ad844);
const $93c04b7043a930e3$export$d6730f103a4ad844 = {
    name: 'software-calendar',
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/:itemId?',
    query: [
        'date?'
    ]
};

});


parcelRegister("lMawn", function(module, exports) {

$parcel$export(module.exports, "softwareCapacityCustomEmbedRouteEntry", () => $e4455247d96e426a$export$f0fad2bbd5fe5686);

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $92GIJ = parcelRequire("92GIJ");

var $4T7iD = parcelRequire("4T7iD");

var $cxQGT = parcelRequire("cxQGT");

var $hwf64 = parcelRequire("hwf64");
const $e4455247d96e426a$export$f0fad2bbd5fe5686 = (0, $6xToB.createEntry)((0, $92GIJ.softwareCapacityCustomEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $4T7iD.CapacityEmbedSkeleton),
        component: (0, $4T7iD.CapacityEmbedSkeleton),
        entryPoint () {
            return 0, $hwf64.capacityRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        ufoName: 'next-gen-capacity-embed'
    }));

});
parcelRegister("92GIJ", function(module, exports) {

$parcel$export(module.exports, "softwareCapacityCustomEmbedRoute", () => $c733dd404ab724a1$export$8664e61943fd500b);
const $c733dd404ab724a1$export$8664e61943fd500b = {
    name: 'software-capacity-custom-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/capacity/:itemId/embed',
    query: []
};

});

parcelRegister("4T7iD", function(module, exports) {

$parcel$export(module.exports, "CapacitySkeleton", () => $2d60b56c36f63984$export$79fcfa58dbcaf030);
$parcel$export(module.exports, "CapacityEmbedSkeleton", () => $2d60b56c36f63984$export$27d33e13f167f420);
/* CapacitySkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $9cOeh = parcelRequire("9cOeh");

var $dVTwj = parcelRequire("dVTwj");

var $iLLmk = parcelRequire("iLLmk");
const $2d60b56c36f63984$var$customCssStyles = null;
const $2d60b56c36f63984$export$79fcfa58dbcaf030 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9cOeh)))
    });
const $2d60b56c36f63984$export$27d33e13f167f420 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dVTwj)))
    });
const $2d60b56c36f63984$export$a0dc4c0a6f5a9296 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iLLmk))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("9cOeh", function(module, exports) {
module.exports = new URL("calendar-app-skeleton.tpl.77b09222.svg", import.meta.url).toString();

});

parcelRegister("dVTwj", function(module, exports) {
module.exports = new URL("calendar-embed-app-skeleton.tpl.29c9a641.svg", import.meta.url).toString();

});

parcelRegister("iLLmk", function(module, exports) {
module.exports = new URL("calendar-no-header-skeleton.tpl.d6779107.svg", import.meta.url).toString();

});


parcelRegister("hwf64", function(module, exports) {

$parcel$export(module.exports, "capacityRouteEntry", () => $1bbc471d32e6e232$export$721be00e430c45e);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $ctnaK = parcelRequire("ctnaK");

var $9n5I0 = parcelRequire("9n5I0");
const $1bbc471d32e6e232$export$721be00e430c45e = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $ctnaK.capacityEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("ctnaK", function(module, exports) {

$parcel$export(module.exports, "capacityEntryPoint", () => $b64c2ecdacfcfb4c$export$2ea9514c195131bd);

var $bdhwY = parcelRequire("bdhwY");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $b64c2ecdacfcfb4c$export$2ea9514c195131bd = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("lPIAS")), {
        moduleId: "b5f200d9",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { tenantContext: { cloudId: cloudId } } = entryPointRouteParams;
        return {
            queries: {
                capacityData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $bdhwY.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});

});
parcelRegister("bdhwY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0222775157c27924$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<66622cd1682455d26171850d25c18656>>
 * @relayHash 9952eb4a38738a32d15d54f2992af91d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 63784c0e3f8f71c0e6a8570b627d79bbb0c8b71596cfc7f6621046abcaa215c4
const $0222775157c27924$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "63784c0e3f8f71c0e6a8570b627d79bbb0c8b71596cfc7f6621046abcaa215c4",
        "metadata": {},
        "name": "ui_jiraCapacityQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0222775157c27924$export$2e2bcd8739ae039 = $0222775157c27924$var$node;

});

parcelRegister("lPIAS", function(module, exports) {

let $fe50f3c928d2b342$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fe50f3c928d2b342$var$load("eyfXZ").then(()=>parcelRequire('1lRYl'));

});




parcelRegister("hK8mq", function(module, exports) {

$parcel$export(module.exports, "softwareCapacityEmbedRouteEntry", () => $dfe056c5da77a155$export$cb54c8dddff6b9ec);

var $7K5Ea = parcelRequire("7K5Ea");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $cxQGT = parcelRequire("cxQGT");

var $cAVBV = parcelRequire("cAVBV");

var $4T7iD = parcelRequire("4T7iD");

var $hwf64 = parcelRequire("hwf64");
const $dfe056c5da77a155$export$cb54c8dddff6b9ec = (0, $6xToB.createEntry)((0, $cAVBV.softwareCapacityEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $4T7iD.CapacityEmbedSkeleton),
        component: (0, $4T7iD.CapacityEmbedSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $hwf64.capacityRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $cxQGT.themePreferenceResource)
        ],
        ufoName: 'next-gen-capacity-embed'
    }));

});
parcelRegister("cAVBV", function(module, exports) {

$parcel$export(module.exports, "softwareCapacityEmbedRoute", () => $deb13b96ce3baf6e$export$110f0eb799e55036);
const $deb13b96ce3baf6e$export$110f0eb799e55036 = {
    name: 'software-capacity-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/capacity/embed',
    query: []
};

});


parcelRegister("33rS9", function(module, exports) {

$parcel$export(module.exports, "softwareCapacityRouteEntry", () => $04c34d38079b626f$export$7c0a73481693ad26);

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $5dG6f = parcelRequire("5dG6f");

var $4T7iD = parcelRequire("4T7iD");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $hwf64 = parcelRequire("hwf64");
const $04c34d38079b626f$export$7c0a73481693ad26 = (0, $6xToB.createEntry)((0, $5dG6f.softwareCapacityRoute), ()=>({
        group: 'software',
        skeleton: (0, $4T7iD.CapacitySkeleton),
        component: (0, $4T7iD.CapacitySkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $hwf64.capacityRouteEntry;
        },
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource))
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        ufoName: 'next-gen-capacity',
        supportsPreviewPanel: true
    }));

});
parcelRegister("5dG6f", function(module, exports) {

$parcel$export(module.exports, "softwareCapacityRoute", () => $e6505fe1f858e9cb$export$57ddb8414c776aa1);
const $e6505fe1f858e9cb$export$57ddb8414c776aa1 = {
    name: 'software-capacity',
    path: '/jira/software/projects/:projectKey/boards/:boardId/capacity/:itemId?',
    query: []
};

});


parcelRegister("6PPxR", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectEmbedRouteEntry", () => $b63b5b0e2ecb1474$export$fdc2679a6c96e9fa);

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $57pa9 = parcelRequire("57pa9");

var $7K5Ea = parcelRequire("7K5Ea");

var $cuS8Q = parcelRequire("cuS8Q");
const $b63b5b0e2ecb1474$export$fdc2679a6c96e9fa = (0, $6xToB.createEntry)((0, $57pa9.softwareClassicProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'classic-software',
        component: (0, $cuS8Q.default),
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $cuS8Q.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("57pa9", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectEmbedRoute", () => $826edc65664f9b16$export$16987cdd084cceba);
const $826edc65664f9b16$export$16987cdd084cceba = {
    name: 'classic-software-proforma-issue-forms-direct-embed',
    path: '/jira/software/c/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});

parcelRegister("cuS8Q", function(module, exports) {

$parcel$export(module.exports, "LazyProformaIssueFormsDirectEmbed", () => $3155c18e256636f9$export$22681210aaeb910f);
$parcel$export(module.exports, "default", () => $3155c18e256636f9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $3155c18e256636f9$export$22681210aaeb910f = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("gcxyH")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3155c18e256636f9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3155c18e256636f9$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });

});


parcelRegister("5JTZa", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectRouteEntry", () => $3abe2c698c8344e5$export$8fd8b0cbd2b8730d);

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $4W8oE = parcelRequire("4W8oE");

var $8FCAy = parcelRequire("8FCAy");

var $dZRaT = parcelRequire("dZRaT");

var $eSmGL = parcelRequire("eSmGL");
const $3abe2c698c8344e5$export$8fd8b0cbd2b8730d = (0, $6xToB.createEntry)((0, $4W8oE.softwareClassicProformaIssueFormsDirectRoute), ()=>({
        group: 'classic-software',
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        entryPoint: ()=>(0, $eSmGL.proformaIssueFormsDirectPageEntryPoint),
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("4W8oE", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectRoute", () => $6bdce9ddbe68bb44$export$92f34907c6bf7007);
const $6bdce9ddbe68bb44$export$92f34907c6bf7007 = {
    name: 'classic-software-proforma-issue-forms-direct',
    path: '/jira/software/c/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});

parcelRegister("eSmGL", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsDirectPageEntryPoint", () => $a5339dfb4f906c10$export$dc0bb5719ae7aab4);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $cZ31R = parcelRequire("cZ31R");
const $a5339dfb4f906c10$export$dc0bb5719ae7aab4 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cZ31R.proformaIssueFormsDirectEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});


parcelRegister("jSZVk", function(module, exports) {

$parcel$export(module.exports, "softwareCodeClassicRouteEntry", () => $c4dc8daca42ff91d$export$6acfada96c85cfaa);

var $6xToB = parcelRequire("6xToB");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $5RW99 = parcelRequire("5RW99");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $2t6re = parcelRequire("2t6re");

var $69OMV = parcelRequire("69OMV");

var $jom8W = parcelRequire("jom8W");

var $8FCAy = parcelRequire("8FCAy");

var $k6duF = parcelRequire("k6duF");

var $kSeQy = parcelRequire("kSeQy");

var $7jTnu = parcelRequire("7jTnu");

var $5L7qx = parcelRequire("5L7qx");

var $9yLWd = parcelRequire("9yLWd");
const $c4dc8daca42ff91d$export$6acfada96c85cfaa = (0, $6xToB.createEntry)((0, $2t6re.softwareCodeClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('jira-code-page-to-ugs-v2'), (0, $69OMV.codePageResource))
        ],
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        entryPoint: ()=>{
            if ((0, $jom8W.isDevopsFeatureDisabledInFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $9yLWd.softwareCodeClassicPageEntrypoint) : (0, $9yLWd.softwareCodeClassicPageEntrypointOld);
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("2t6re", function(module, exports) {

$parcel$export(module.exports, "softwareCodeClassicRoute", () => $2c7f122e1ae77465$export$d92cd77785d00ff);
const $2c7f122e1ae77465$export$d92cd77785d00ff = {
    name: 'software-code-classic',
    path: '/jira/software/c/projects/:projectKey/code'
};

});

parcelRegister("69OMV", function(module, exports) {

$parcel$export(module.exports, "codePageResource", () => $3422c76a34780ba7$export$642ce64cf3689406);

var $9FYIg = parcelRequire("9FYIg");

var $j75rV = parcelRequire("j75rV");

var $6Izrp = parcelRequire("6Izrp");

let $3422c76a34780ba7$var$numPullRequestsToFetch = 0;
const $3422c76a34780ba7$export$642ce64cf3689406 = (0, $9FYIg.createRelayResource)({
    type: (0, $7139579265915770$export$94a43d2ac55ac375),
    getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId } }) {
        const isCodeRoute = name === 'software-code' || name === 'software-code-classic';
        // Set numPullRequestsToFetch on initial call only and not on every query param change
        if (!$3422c76a34780ba7$var$numPullRequestsToFetch && isCodeRoute) $3422c76a34780ba7$var$numPullRequestsToFetch = (0, $6Izrp.getNumPullRequestsToFetch)(query);
        // Reset numPullRequestsToFetch when navigating away from the code page
        if (!isCodeRoute) $3422c76a34780ba7$var$numPullRequestsToFetch = 0;
        return {
            parameters: (0, $j75rV.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudId: cloudId,
                projectKey: params.projectKey ?? '',
                pullRequestsUpdatedFrom: (0, $6Izrp.getPullRequestsUpdatedFromDate)(),
                numPullRequestsToFetch: $3422c76a34780ba7$var$numPullRequestsToFetch,
                siteAri: `ari:cloud:jira::site/${cloudId}`
            }
        };
    }
});

});
parcelRegister("j75rV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6a8e21de6cc5ec6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e4d6b6379280bbf391f7e2d315a8c2a>>
 * @relayHash 389fdeea048c66525e3cec717b045093
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 065a174c5747d32e4ac04da08516b772ae16f6995b07756d19cd3af74fa4c4bb
const $d6a8e21de6cc5ec6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numPullRequestsToFetch"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pullRequestsUpdatedFrom"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "siteAri"
        },
        {
            "kind": "Literal",
            "name": "providerTypes",
            "value": [
                "DEV_INFO"
            ]
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "concreteType": "JiraConfigStateConnection",
        "kind": "LinkedField",
        "name": "config",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraConfigState",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "appId"
                    },
                    v10 /*: any*/ 
                ]
            }
        ]
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = [
        v7 /*: any*/ 
    ], v14 = [
        {
            "kind": "Literal",
            "name": "appId",
            "value": "bitbucket"
        },
        v8 /*: any*/ 
    ], v15 = [
        v8 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v16 = [
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "lastModified": {
                    "direction": "DESC",
                    "priority": 1
                }
            }
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = [
        v11 /*: any*/ ,
        v17 /*: any*/ 
    ], v19 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v20 = {
        "kind": "ScalarField",
        "name": "url"
    }, v21 = [
        v17 /*: any*/ 
    ], v22 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v23 = [
        v7 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "accountId"
        },
        v6 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v17 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainCodeInJiraUpdatedQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "DevOpsProviders",
                                    "kind": "LinkedField",
                                    "name": "providers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsDevInfoProvider",
                                            "kind": "LinkedField",
                                            "name": "devInfoProviders",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "JiraAppConfigState",
                                                    "kind": "LinkedField",
                                                    "name": "configState",
                                                    "plural": false,
                                                    "selections": v12 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.providers"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v9 /*: any*/ ,
                        "concreteType": "CodeInJira",
                        "kind": "LinkedField",
                        "name": "codeInJira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CodeInJiraUserConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CodeInJiraBitbucketWorkspace",
                                                "kind": "LinkedField",
                                                "name": "ownedBitbucketWorkspaces",
                                                "plural": true,
                                                "selections": v13 /*: any*/ 
                                            },
                                            "action": "THROW",
                                            "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "codeInJira.userConfiguration"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "codeInJira"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                    "kind": "LinkedField",
                                    "name": "repositories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v13 /*: any*/ 
                                        }
                                    ],
                                    "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_MainPage"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_Header"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_ConnectionPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainCodeInJiraUpdatedQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "DevOpsProviders",
                            "kind": "LinkedField",
                            "name": "providers",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsDevInfoProvider",
                                    "kind": "LinkedField",
                                    "name": "devInfoProviders",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "args": v9 /*: any*/ ,
                                            "concreteType": "JiraAppConfigState",
                                            "kind": "LinkedField",
                                            "name": "configState",
                                            "plural": false,
                                            "selections": v18 /*: any*/ 
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "homeUrl"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "namespace"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "CodeInJira",
                    "kind": "LinkedField",
                    "name": "codeInJira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CodeInJiraUserConfiguration",
                            "kind": "LinkedField",
                            "name": "userConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CodeInJiraBitbucketWorkspace",
                                    "kind": "LinkedField",
                                    "name": "ownedBitbucketWorkspaces",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "uuid"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": v18 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                    "kind": "LinkedField",
                                    "name": "repositories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerId"
                                                                },
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "avatarUrl"
                                                                },
                                                                v20 /*: any*/ 
                                                            ],
                                                            "type": "DevOpsRepository"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                },
                                v17 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "updatedFrom",
                                                    "variableName": "pullRequestsUpdatedFrom"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "numPullRequestsToFetch"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": {
                                                "lastUpdatedSortDirection": "DESC"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "project-associated-pr"
                                        }
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "devOpsEntityRelationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryName"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryId"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "author",
                                                                                    "plural": false,
                                                                                    "selections": v23 /*: any*/ 
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsReviewer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "reviewers",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v23 /*: any*/ 
                                                                                        },
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "approvalStatus"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userId"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "title"
                                                                                },
                                                                                v17 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "commentCount"
                                                                                },
                                                                                v20 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsBranchInfo",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "destinationBranch",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "pullRequestInternalId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "authorId"
                                                                                }
                                                                            ],
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraAutodevJob"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        }
                                                                    ]
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "065a174c5747d32e4ac04da08516b772ae16f6995b07756d19cd3af74fa4c4bb",
            "metadata": {},
            "name": "mainCodeInJiraUpdatedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d6a8e21de6cc5ec6$var$node.hash = "e7b0f6a6904c8a1f0dcd2b6cc16ebe99";
var $d6a8e21de6cc5ec6$export$2e2bcd8739ae039 = $d6a8e21de6cc5ec6$var$node;

});

parcelRegister("6Izrp", function(module, exports) {

$parcel$export(module.exports, "isBitbucketProvider", () => $019a3c4cc0709d97$export$1f508885be28c4e);
$parcel$export(module.exports, "codeErrorBoundaryAttributes", () => $019a3c4cc0709d97$export$ea10bb8bdf2072e5);
$parcel$export(module.exports, "toSanitizedUrl", () => $019a3c4cc0709d97$export$36fdccbdcd093523);
$parcel$export(module.exports, "useIsOverflowWidth", () => $019a3c4cc0709d97$export$2dcd60313c8d761b);
$parcel$export(module.exports, "getPullRequestsUpdatedFromDate", () => $019a3c4cc0709d97$export$3784bdf6b4807521);
$parcel$export(module.exports, "getNumPullRequestsToFetch", () => $019a3c4cc0709d97$export$a837c7c9c7670570);

var $eJOHy = parcelRequire("eJOHy");

var $2Cxb3 = parcelRequire("2Cxb3");

var $2InI0 = parcelRequire("2InI0");
var $8XZn3 = parcelRequire("8XZn3");

var $9soX0 = parcelRequire("9soX0");

var $jqVmJ = parcelRequire("jqVmJ");
const $019a3c4cc0709d97$export$36ebc9cd52c6b517 = (repository)=>repository === (0, $jqVmJ.RepositoryTypes).REPO_BITBUCKET;
const $019a3c4cc0709d97$export$1f508885be28c4e = (providerId)=>providerId === (0, $9soX0.VcsProviderIds).BITBUCKET || providerId === (0, $9soX0.DataDepotProviderIds).BITBUCKET_PROD || providerId === (0, $9soX0.DataDepotProviderIds).BITBUCKET_STG;
const $019a3c4cc0709d97$var$shouldCountToReliability = (error)=>{
    const okayErrors = [
        ...(0, $9soX0.nonCriticalGqlErrors),
        ...(0, $9soX0.nonReliabilityCriticalErrors)
    ];
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"HTTP status [403] while retrieving Bitbucket repository." | "HTTP status [404] while retrieving Bitbucket repository." | "Failed to retrieve Bitbucket repository because the user wasn't authorized." | "HTTP status [429] while retrieving Bitbucket repository." | "The user does not have 'View Development Tools' permi...'.
    return !okayErrors.includes(error.message);
};
const $019a3c4cc0709d97$export$ea10bb8bdf2072e5 = (error)=>{
    if (error instanceof Error) return {
        countToReliability: $019a3c4cc0709d97$var$shouldCountToReliability(error)
    };
    return {
        countToReliability: true
    };
};
const $019a3c4cc0709d97$export$36fdccbdcd093523 = (url)=>(0, $2Cxb3.sanitizeUrl)(url);
const $019a3c4cc0709d97$export$2dcd60313c8d761b = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref, callback)=>{
    const [isOverflow, setIsOverflow] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        const { current: current } = ref;
        const trigger = ()=>{
            const hasOverflow = current.scrollWidth > current.clientWidth;
            setIsOverflow(hasOverflow);
            if (callback) callback(hasOverflow);
        };
        if (current) {
            if ('ResizeObserver' in window) new ResizeObserver(trigger).observe(current);
            trigger();
        }
    }, [
        callback,
        ref
    ]);
    return isOverflow;
};
const $019a3c4cc0709d97$export$3784bdf6b4807521 = ()=>(0, $2InI0.default)((0, $8XZn3.default)(new Date(), {
        days: (0, $9soX0.PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS)
    })).toISOString();
const $019a3c4cc0709d97$export$a837c7c9c7670570 = (queryParams)=>{
    const hasFilterOrSortQueryParam = Object.entries(queryParams).some(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ([key, value])=>(0, $9soX0.queryParamsToWatch).includes(key) && value !== '');
    return hasFilterOrSortQueryParam ? (0, $9soX0.MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY) : (0, $9soX0.PULL_REQUESTS_TABLE_PAGE_SIZE);
};

});
parcelRegister("2Cxb3", function(module, exports) {
'use strict';
var $1e88ddb581a2ec8f$var$invalidPrototcolRegex = /^(%20|\s)*(javascript|data)/im;
var $1e88ddb581a2ec8f$var$ctrlCharactersRegex = /[^\x20-\x7E]/gmi;
var $1e88ddb581a2ec8f$var$urlSchemeRegex = /^([^:]+):/gm;
var $1e88ddb581a2ec8f$var$relativeFirstCharacters = [
    '.',
    '/'
];
function $1e88ddb581a2ec8f$var$isRelativeUrl(url) {
    return $1e88ddb581a2ec8f$var$relativeFirstCharacters.indexOf(url[0]) > -1;
}
function $1e88ddb581a2ec8f$var$sanitizeUrl(url) {
    if (!url) return 'about:blank';
    var urlScheme, urlSchemeParseResults;
    var sanitizedUrl = url.replace($1e88ddb581a2ec8f$var$ctrlCharactersRegex, '');
    if ($1e88ddb581a2ec8f$var$isRelativeUrl(sanitizedUrl)) return sanitizedUrl;
    urlSchemeParseResults = sanitizedUrl.match($1e88ddb581a2ec8f$var$urlSchemeRegex);
    if (!urlSchemeParseResults) return 'about:blank';
    urlScheme = urlSchemeParseResults[0];
    if ($1e88ddb581a2ec8f$var$invalidPrototcolRegex.test(urlScheme)) return 'about:blank';
    return sanitizedUrl;
}
module.exports = {
    sanitizeUrl: $1e88ddb581a2ec8f$var$sanitizeUrl
};

});

parcelRegister("9soX0", function(module, exports) {

$parcel$export(module.exports, "nonCriticalGqlErrors", () => $08bf2cda6ff24883$export$4b1abe4db5ed7515);
$parcel$export(module.exports, "nonReliabilityCriticalErrors", () => $08bf2cda6ff24883$export$687544614e0812da);
$parcel$export(module.exports, "MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY", () => $08bf2cda6ff24883$export$f84c6b6609a3dd30);
$parcel$export(module.exports, "PULL_REQUESTS_TABLE_PAGE_SIZE", () => $08bf2cda6ff24883$export$ea15b38f3901f518);
$parcel$export(module.exports, "PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS", () => $08bf2cda6ff24883$export$2b8b0a4489f9147b);
$parcel$export(module.exports, "COLLAPSIBLE_REGION_ID", () => $08bf2cda6ff24883$export$3b8f88133d28aaa6);
$parcel$export(module.exports, "REPOSITORIES_HEADER_ID", () => $08bf2cda6ff24883$export$256a9f141103f328);
$parcel$export(module.exports, "COLLAPSIBLE_REGION_DESCRIPTION_ID", () => $08bf2cda6ff24883$export$b0d4e90e40369b80);
$parcel$export(module.exports, "featureIdToHelpMap", () => $08bf2cda6ff24883$export$1de4eaccc23a8747);
$parcel$export(module.exports, "FILTER_CONTAINER_TEST_ID", () => $08bf2cda6ff24883$export$5c00a6bedc2037c8);
$parcel$export(module.exports, "NO_RESULTS_CLEAR_FILTERS_BUTTON_TEST_ID", () => $08bf2cda6ff24883$export$f70ce14ba902adcb);
$parcel$export(module.exports, "PULL_REQUESTS_TABLE_TEST_ID", () => $08bf2cda6ff24883$export$19381ed4387aa05b);
$parcel$export(module.exports, "PULL_REQUESTS_DYNAMIC_TABLE_TEST_ID", () => $08bf2cda6ff24883$export$f3e116f999d4c5c1);
$parcel$export(module.exports, "PULL_REQUESTS_EMPTY_STATE_TEST_ID", () => $08bf2cda6ff24883$export$c28f1cd40ae0394c);
$parcel$export(module.exports, "SUMMARY_CELL_TEST_ID", () => $08bf2cda6ff24883$export$f69d7aa9c5e17d55);
$parcel$export(module.exports, "SUMMARY_CELL_TITLE_LINK_TEST_ID", () => $08bf2cda6ff24883$export$4ed9a8a7faf641f);
$parcel$export(module.exports, "SUMMARY_CELL_TARGET_BRANCH_LINK_TEST_ID", () => $08bf2cda6ff24883$export$c5322e755fd1028d);
$parcel$export(module.exports, "SUMMARY_CELL_REPOSITORY_LINK_TEST_ID", () => $08bf2cda6ff24883$export$72fcd104fde041d6);
$parcel$export(module.exports, "REVIEWERS_CELL_TEST_ID", () => $08bf2cda6ff24883$export$d8f600a480a9c2d4);
$parcel$export(module.exports, "STATUS_CELL_TEST_ID", () => $08bf2cda6ff24883$export$9d9ab707c4e446cc);
$parcel$export(module.exports, "COMMENTS_CELL_TEST_ID", () => $08bf2cda6ff24883$export$4da3056fdbfaf111);
$parcel$export(module.exports, "LAST_UPDATED_CELL_TEST_ID", () => $08bf2cda6ff24883$export$e1134688b6a1032);
$parcel$export(module.exports, "PULL_REQUESTS_ERROR_STATE_TEST_ID", () => $08bf2cda6ff24883$export$143249aa50321d51);
$parcel$export(module.exports, "REPOSITORIES_ERROR_STATE_TEST_ID", () => $08bf2cda6ff24883$export$a46febdd3fe90de0);
$parcel$export(module.exports, "IMPROVED_SCM_CONFIG_SCREEN_ERROR_TEST_ID", () => $08bf2cda6ff24883$export$333db4cac7ee017);
$parcel$export(module.exports, "IMPROVE_READY_TO_CONNECT_EMPTY_STATE_TEST_ID", () => $08bf2cda6ff24883$export$5cbae081959768bd);
$parcel$export(module.exports, "REPOSITORIES_FILTER_BUTTON_TEST_ID", () => $08bf2cda6ff24883$export$4939c117ba49bc9e);
$parcel$export(module.exports, "AUTHOR_FILTER_BUTTON_TEST_ID", () => $08bf2cda6ff24883$export$5a92d7579dac6294);
$parcel$export(module.exports, "REVIEWERS_FILTER_BUTTON_TEST_ID", () => $08bf2cda6ff24883$export$a77ea162c15f0290);
$parcel$export(module.exports, "STATUS_FILTER_BUTTON_TEST_ID", () => $08bf2cda6ff24883$export$b7477204cae64b46);
$parcel$export(module.exports, "QUERY_PARAM_SUMMARY", () => $08bf2cda6ff24883$export$39983b6fb040a5eb);
$parcel$export(module.exports, "QUERY_PARAM_AUTHORS", () => $08bf2cda6ff24883$export$3d96f5f9ccd35be6);
$parcel$export(module.exports, "QUERY_PARAM_REVIEWERS", () => $08bf2cda6ff24883$export$8a8927c29ab32b10);
$parcel$export(module.exports, "QUERY_PARAM_STATUS", () => $08bf2cda6ff24883$export$3e8168848b996f7);
$parcel$export(module.exports, "QUERY_PARAM_REPOSITORIES", () => $08bf2cda6ff24883$export$4adc519ba40b72a6);
$parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", () => $08bf2cda6ff24883$export$6da773286c35ef41);
$parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", () => $08bf2cda6ff24883$export$810a1f7ed2facfcb);
$parcel$export(module.exports, "queryParamsToWatch", () => $08bf2cda6ff24883$export$ba75fb5089c0eb0b);
$parcel$export(module.exports, "VcsProviderIds", () => $08bf2cda6ff24883$export$7d5c3d28df5f438a);
$parcel$export(module.exports, "DataDepotProviderIds", () => $08bf2cda6ff24883$export$7912a169c18abe9d);
$parcel$export(module.exports, "FEEDBACK_COLLECTOR_LOCATION", () => $08bf2cda6ff24883$export$74189cec821240a6);
$parcel$export(module.exports, "eligibleForConfigurationScreenStatuses", () => $08bf2cda6ff24883$export$3f3fc252f5066c72);
$parcel$export(module.exports, "notEligibleForConfigurationScreenStatuses", () => $08bf2cda6ff24883$export$9ce5b1bba5f17875);
$parcel$export(module.exports, "CODE_TAB_NAMESPACE", () => $08bf2cda6ff24883$export$f3873cacb48e85d4);
$parcel$export(module.exports, "LOCAL_STORAGE_GO_TO_DEVELOPMENT_KEY", () => $08bf2cda6ff24883$export$e9ce282f5e635322);
$parcel$export(module.exports, "CODE_TAB_MIGRATION_ANALYTICS", () => $08bf2cda6ff24883$export$49902d80a065c2d5);
const $08bf2cda6ff24883$export$4b1abe4db5ed7515 = [
    'HTTP status [403] while retrieving Bitbucket repository.',
    'HTTP status [404] while retrieving Bitbucket repository.',
    "Failed to retrieve Bitbucket repository because the user wasn't authorized."
];
const $08bf2cda6ff24883$export$687544614e0812da = [
    'HTTP status [429] while retrieving Bitbucket repository.',
    "The user does not have 'View Development Tools' permission for the Jira project or the project does not exist",
    'The user does not have admin permission for the site, Jira, project or the project does not exist.',
    'Unable to get providers when contacting Jira due to 401 Unauthorized'
];
const $08bf2cda6ff24883$export$7527a73da794030d = "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)";
const $08bf2cda6ff24883$export$2ecfdc24b216c295 = "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"; // we use  in package.json file, so box-shadow here must be a value, cannot use elevation
const $08bf2cda6ff24883$export$f84c6b6609a3dd30 = 1000;
const $08bf2cda6ff24883$export$ea15b38f3901f518 = 12;
const $08bf2cda6ff24883$export$2b8b0a4489f9147b = 30;
const $08bf2cda6ff24883$export$3b8f88133d28aaa6 = 'collapsible-repository-list';
const $08bf2cda6ff24883$export$256a9f141103f328 = 'repository-list-header';
const $08bf2cda6ff24883$export$b0d4e90e40369b80 = 'repository-list-description';
const $08bf2cda6ff24883$export$1de4eaccc23a8747 = {
    'repository-list.pull-requests.empty-state': {
        helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
        href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
    },
    'repository-list.pull-requests.description': {
        helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
        href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
    }
};
const $08bf2cda6ff24883$export$5c00a6bedc2037c8 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.filter-container';
const $08bf2cda6ff24883$export$f70ce14ba902adcb = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.no-results.clearfiltersbutton';
const $08bf2cda6ff24883$export$19381ed4387aa05b = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table';
const $08bf2cda6ff24883$export$f3e116f999d4c5c1 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table.dynamic-table';
const $08bf2cda6ff24883$export$c28f1cd40ae0394c = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-empty-state';
const $08bf2cda6ff24883$export$f69d7aa9c5e17d55 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.summary-cell';
const $08bf2cda6ff24883$export$4ed9a8a7faf641f = `${$08bf2cda6ff24883$export$f69d7aa9c5e17d55}.title-link`;
const $08bf2cda6ff24883$export$c5322e755fd1028d = `${$08bf2cda6ff24883$export$f69d7aa9c5e17d55}.target-branch-link`;
const $08bf2cda6ff24883$export$72fcd104fde041d6 = `${$08bf2cda6ff24883$export$f69d7aa9c5e17d55}.repository-link`;
const $08bf2cda6ff24883$export$d8f600a480a9c2d4 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.reviewers-cell';
const $08bf2cda6ff24883$export$9d9ab707c4e446cc = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.status-cell';
const $08bf2cda6ff24883$export$4da3056fdbfaf111 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.comments-cell';
const $08bf2cda6ff24883$export$e1134688b6a1032 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.last-updated-cell';
const $08bf2cda6ff24883$export$143249aa50321d51 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-error-state';
const $08bf2cda6ff24883$export$a46febdd3fe90de0 = 'software-code-page.ui.pages.main-page.repositories.repository-error-state';
const $08bf2cda6ff24883$export$333db4cac7ee017 = 'software-code-page.ui.pages.improved-configure-step-error-state';
const $08bf2cda6ff24883$export$5cbae081959768bd = 'software-code-page.ui.pages.ready-to-connect-empty-state-error-state';
const $08bf2cda6ff24883$export$4939c117ba49bc9e = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.repository-filter.filter-button';
const $08bf2cda6ff24883$export$5a92d7579dac6294 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.author-filter.filter-button';
const $08bf2cda6ff24883$export$a77ea162c15f0290 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.reviewers-filter.filter-button';
const $08bf2cda6ff24883$export$b7477204cae64b46 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.status-filter.filter-button';
const $08bf2cda6ff24883$export$39983b6fb040a5eb = 'summaryFilter';
const $08bf2cda6ff24883$export$3d96f5f9ccd35be6 = 'authorsFilter';
const $08bf2cda6ff24883$export$8a8927c29ab32b10 = 'reviewersFilter';
const $08bf2cda6ff24883$export$3e8168848b996f7 = 'statusFilter';
const $08bf2cda6ff24883$export$4adc519ba40b72a6 = 'repositoriesFilter';
const $08bf2cda6ff24883$export$6da773286c35ef41 = 'sortKey';
const $08bf2cda6ff24883$export$810a1f7ed2facfcb = 'sortOrder';
const $08bf2cda6ff24883$export$ba75fb5089c0eb0b = [
    $08bf2cda6ff24883$export$39983b6fb040a5eb,
    $08bf2cda6ff24883$export$3d96f5f9ccd35be6,
    $08bf2cda6ff24883$export$8a8927c29ab32b10,
    $08bf2cda6ff24883$export$3e8168848b996f7,
    $08bf2cda6ff24883$export$4adc519ba40b72a6,
    $08bf2cda6ff24883$export$6da773286c35ef41,
    $08bf2cda6ff24883$export$810a1f7ed2facfcb
];
const $08bf2cda6ff24883$export$7d5c3d28df5f438a = {
    BITBUCKET: 'bitbucket'
};
const $08bf2cda6ff24883$export$7912a169c18abe9d = {
    BITBUCKET_PROD: 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9',
    BITBUCKET_STG: 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N',
    GITHUB_PROD: 'com.github.integration.production',
    GITHUB_STG: 'com.github.integration.staging'
};
const $08bf2cda6ff24883$export$74189cec821240a6 = 'jsw.code.page.header';
const $08bf2cda6ff24883$export$3f3fc252f5066c72 = [
    'NOT_CONFIGURED',
    'NOT_SET',
    'PARTIALLY_CONFIGURED'
];
const $08bf2cda6ff24883$export$9ce5b1bba5f17875 = [
    'CONFIGURED',
    'PROVIDER_ACTION_CONFIGURED',
    'PROVIDER_ACTION_NOT_CONFIGURED'
];
const $08bf2cda6ff24883$export$f3873cacb48e85d4 = 'jira-software-code-tab';
const $08bf2cda6ff24883$export$e9ce282f5e635322 = 'clickedGoToDevelopment';
const $08bf2cda6ff24883$export$49902d80a065c2d5 = 'jiraCodePageMigrationModal';

});

parcelRegister("jqVmJ", function(module, exports) {

$parcel$export(module.exports, "numberToTimestamp", () => $dd855e50f62453b1$export$9a7be8324d19a048);
$parcel$export(module.exports, "toProjectAri", () => $dd855e50f62453b1$export$9429718a5f74f761);
$parcel$export(module.exports, "RepositoryTypes", () => $dd855e50f62453b1$export$b5ab924fb433d9ea);
/**
 * Opaque types
 */ const $dd855e50f62453b1$export$9a7be8324d19a048 = (time)=>{
    if (time < 0) throw new Error(`Trying to case invalid number(${time}) to Timestamp opaque type`);
    return time;
};
const $dd855e50f62453b1$export$9429718a5f74f761 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $dd855e50f62453b1$export$b5ab924fb433d9ea = {
    REPO_BITBUCKET: 'REPO_BITBUCKET',
    REPO_GITHUB: 'REPO_GITHUB',
    REPO_GITLAB: 'REPO_GITLAB'
};
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $dd855e50f62453b1$var$VcsProviderNamespaces = {
    CLASSIC: 'classic',
    OAUTH: 'oauth',
    BITBUCKET: 'bitbucket'
};

});


const $7139579265915770$export$94a43d2ac55ac375 = 'SOFTWARE_CODE';


parcelRegister("9yLWd", function(module, exports) {

$parcel$export(module.exports, "softwareCodeClassicPageEntrypointOld", () => $19ad5b2dbdf460d4$export$2618796c138bd026);
$parcel$export(module.exports, "softwareCodeClassicPageEntrypoint", () => $19ad5b2dbdf460d4$export$10463031c8017b);

var $8BZWz = parcelRequire("8BZWz");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $19ad5b2dbdf460d4$export$2618796c138bd026 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8BZWz.softwareCodeEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $19ad5b2dbdf460d4$export$10463031c8017b = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8BZWz.softwareCodeEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("8BZWz", function(module, exports) {

$parcel$export(module.exports, "softwareCodeEntrypoint", () => $13570c8fe94ae953$export$7dbaba2b508f1f10);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $7jTnu = parcelRequire("7jTnu");

const $13570c8fe94ae953$export$7dbaba2b508f1f10 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("aunuA")).then(({ default: CodeSpa, CodeSpaV2: CodeSpaV2 })=>{
            if ((0, $7jTnu.fg)('jira-code-page-to-ugs-v2')) return CodeSpaV2;
            return CodeSpa;
        }), {
        moduleId: "ba9a9980",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aunuA", function(module, exports) {

let $7a2eedcba16775da$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7a2eedcba16775da$var$load("ZyY2Z").then(()=>parcelRequire('4oP0D'));

});




parcelRegister("8JIqa", function(module, exports) {

$parcel$export(module.exports, "softwareCodeRouteEntry", () => $7b3764e94a4ccc52$export$eac18b7aea4cb524);

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $69OMV = parcelRequire("69OMV");

var $bTfc4 = parcelRequire("bTfc4");

var $9BJU1 = parcelRequire("9BJU1");

var $jG8Tx = parcelRequire("jG8Tx");

var $jom8W = parcelRequire("jom8W");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $7jTnu = parcelRequire("7jTnu");

var $kSeQy = parcelRequire("kSeQy");

var $5L7qx = parcelRequire("5L7qx");

var $flbHM = parcelRequire("flbHM");

var $f2u3c = parcelRequire("f2u3c");
const $7b3764e94a4ccc52$var$getHorizontalNavResource = ()=>(0, $7jTnu.fg)('entrypoint_migration_for_software_code') ? [] : [
        (0, $b4jBr.horizontalNavJiraResource)
    ];
const $7b3764e94a4ccc52$export$eac18b7aea4cb524 = (0, $6xToB.createEntry)((0, $jG8Tx.softwareCodeRoute), ()=>({
        group: 'software',
        component: (0, $f2JN3.componentWithCondition)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $flbHM.CodePageNextGen)),
        layout: (0, $8FCAy.softwareProjectLayoutCode),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            ...$7b3764e94a4ccc52$var$getHorizontalNavResource(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('jira-code-page-to-ugs-v2'), (0, $69OMV.codePageResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $flbHM.LazyCode)
        ],
        entryPoint: ()=>{
            if ((0, $7jTnu.fg)('entrypoint_migration_for_software_code')) return (0, $jom8W.isDevopsFeatureDisabledInFedRamp)() ? (0, $kSeQy.notFoundPageEntrypoint) : (0, $f2u3c.softwareCodeNextGenPageEntrypoint);
            return undefined;
        },
        ufoName: 'next-gen-code',
        supportsPreviewPanel: true
    }));

});
parcelRegister("jG8Tx", function(module, exports) {

$parcel$export(module.exports, "softwareCodeRoute", () => $8320cfb3935b8230$export$9d24fc75b0f1d9a0);
const $8320cfb3935b8230$export$9d24fc75b0f1d9a0 = {
    name: 'software-code',
    path: '/jira/software/projects/:projectKey/code'
};

});

parcelRegister("flbHM", function(module, exports) {

$parcel$export(module.exports, "LazyCode", () => $4912de0d99590b51$export$4beafd9dbad29bff);
$parcel$export(module.exports, "CodePageNextGen", () => $4912de0d99590b51$export$d9e8184332f86b53);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $jKFLP = parcelRequire("jKFLP");

const $4912de0d99590b51$export$4beafd9dbad29bff = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4PWAv"))), {
    moduleId: "./src/packages/spa-apps/code/src/ui/index-old.tsx"
});
const $4912de0d99590b51$export$d9e8184332f86b53 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4912de0d99590b51$export$4beafd9dbad29bff,
        pageId: `next-gen-code-${(0, $jKFLP.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("jKFLP", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $d146cc2717f20ff5$export$557c2f222778cea6);

var $b5RwB = parcelRequire("b5RwB");
const $d146cc2717f20ff5$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(location.search);
    return rapidView;
};

});

parcelRegister("4PWAv", function(module, exports) {

let $38595f2aaa943b50$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $38595f2aaa943b50$var$load("fMQBV").then(()=>parcelRequire('ipuf7'));

});


parcelRegister("f2u3c", function(module, exports) {

$parcel$export(module.exports, "softwareCodeNextGenPageEntrypoint", () => $6bf2061c65d8ce3b$export$bba7318d4079a95);

var $8BZWz = parcelRequire("8BZWz");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");
const $6bf2061c65d8ce3b$export$bba7318d4079a95 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8BZWz.softwareCodeEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("bTXFE", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsClassicRouteEntry", () => $e1dfb90c5fd4fe56$export$dcf1f9ba660dedf6);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $kFkcB = parcelRequire("kFkcB");

var $bTfc4 = parcelRequire("bTfc4");

var $96VSM = parcelRequire("96VSM");

var $jom8W = parcelRequire("jom8W");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $kSeQy = parcelRequire("kSeQy");

var $kylqU = parcelRequire("kylqU");
const $e1dfb90c5fd4fe56$export$dcf1f9ba660dedf6 = (0, $6xToB.createEntry)((0, $96VSM.softwareDeploymentsClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $kFkcB.deploymentPreconditionRelayResource),
            (0, $dZRaT.projectContextResource)
        ],
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        entryPoint: ()=>(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() ? (0, $kSeQy.notFoundPageEntrypoint) : (0, $kylqU.softwareDeploymentsPageEntrypoint),
        meta: {
            reporting: {
                id: 'software-deployments-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-deployments-classic'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("kFkcB", function(module, exports) {

$parcel$export(module.exports, "deploymentPreconditionRelayResource", () => $9ffc505b6a6bfcb8$export$50e4eedb9e6127c8);

var $9FYIg = parcelRequire("9FYIg");

var $2BkdW = parcelRequire("2BkdW");

var $l1VxS = parcelRequire("l1VxS");


const $9ffc505b6a6bfcb8$export$a1c09d7f7318f85c = (0, $l1VxS.createResource)({
    type: (0, $65b5c35a4ec942b1$export$2171160371fac588),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("4v2zu")),
    maxAge: 60000
});
const $9ffc505b6a6bfcb8$export$50e4eedb9e6127c8 = (0, $9FYIg.createRelayResource)({
    type: (0, $65b5c35a4ec942b1$export$a969d0487e348031),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $2BkdW.default),
            variables: {
                cloudId: tenantContext.cloudId,
                projectKey: String(match.params.projectKey)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("2BkdW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1e9fc8e8b3f01de$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<946bfee09c64f3e6ddd3c9cbab07a461>>
 * @relayHash ea273678a5c985c0053babf0f185662a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2
const $c1e9fc8e8b3f01de$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "deploymentsFeaturePreconditionByProjectKey"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v1 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira.deploymentsFeaturePreconditionByProjectKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2",
            "metadata": {},
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c1e9fc8e8b3f01de$var$node.hash = "3337e3d6b76da02b643c63aacd15b239";
var $c1e9fc8e8b3f01de$export$2e2bcd8739ae039 = $c1e9fc8e8b3f01de$var$node;

});

const $65b5c35a4ec942b1$export$2171160371fac588 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION';
const $65b5c35a4ec942b1$export$a969d0487e348031 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION_RELAY';

parcelRegister("4v2zu", function(module, exports) {

let $346c0d4fe37d6e8e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $346c0d4fe37d6e8e$var$load("icNJK").then(()=>parcelRequire('gzIjF'));

});


parcelRegister("96VSM", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsClassicRoute", () => $98821db9f1d4db09$export$485e4a7b82f29d70);
const $98821db9f1d4db09$export$485e4a7b82f29d70 = {
    name: 'software-deployments-classic',
    path: '/jira/software/c/projects/:projectKey/deployments'
};

});

parcelRegister("kylqU", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsPageEntrypoint", () => $6dda230467864fac$export$44d7744645dea53c);

var $g8uYY = parcelRequire("g8uYY");

var $9n5I0 = parcelRequire("9n5I0");

var $5RW99 = parcelRequire("5RW99");

var $k6TPZ = parcelRequire("k6TPZ");
const $6dda230467864fac$export$44d7744645dea53c = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $k6TPZ.softwareDeploymentsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("k6TPZ", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsEntrypoint", () => $6e18ab705d1455cf$export$c51c7780e55a0186);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $6e18ab705d1455cf$export$c51c7780e55a0186 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("7AhRz")), {
        moduleId: "12d277d5",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7AhRz", function(module, exports) {

let $5859c06c02a44cd1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5859c06c02a44cd1$var$load("7vqGd"),
    $5859c06c02a44cd1$var$load("1Y4bq"),
    $5859c06c02a44cd1$var$load("gnjUc")
]).then(()=>parcelRequire('8pGkY'));

});




parcelRegister("exjbO", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsNextGenRouteEntry", () => $6403acfa15eb01d4$export$7e5ccb20ad8e1612);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $kFkcB = parcelRequire("kFkcB");

var $bTfc4 = parcelRequire("bTfc4");

var $bQ4pb = parcelRequire("bQ4pb");

var $jom8W = parcelRequire("jom8W");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $kSeQy = parcelRequire("kSeQy");

var $kylqU = parcelRequire("kylqU");
const $6403acfa15eb01d4$export$7e5ccb20ad8e1612 = (0, $6xToB.createEntry)((0, $bQ4pb.softwareDeploymentsNextGenRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $kFkcB.deploymentPreconditionRelayResource),
            (0, $dZRaT.projectContextResource)
        ],
        entryPoint: ()=>(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() ? (0, $kSeQy.notFoundPageEntrypoint) : (0, $kylqU.softwareDeploymentsPageEntrypoint),
        meta: {
            reporting: {
                id: 'software-deployments',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-deployments'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("bQ4pb", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsNextGenRoute", () => $968c98efc1239f57$export$4b0939825a323ea5);
const $968c98efc1239f57$export$4b0939825a323ea5 = {
    name: 'software-deployments',
    path: '/jira/software/projects/:projectKey/deployments'
};

});


parcelRegister("37n4w", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderClassicRouteEntry", () => $a5b197477aa02b32$export$96aa488380334044);

var $6xToB = parcelRequire("6xToB");

var $f2JN3 = parcelRequire("f2JN3");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $6m3Bu = parcelRequire("6m3Bu");

var $8MGdZ = parcelRequire("8MGdZ");

var $9n5I0 = parcelRequire("9n5I0");

var $8FCAy = parcelRequire("8FCAy");

var $k6duF = parcelRequire("k6duF");

var $g8uYY = parcelRequire("g8uYY");

var $6zXPf = parcelRequire("6zXPf");

var $hS1gr = parcelRequire("hS1gr");

var $ebuR2 = parcelRequire("ebuR2");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $7jTnu = parcelRequire("7jTnu");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $a5b197477aa02b32$var$formBuilderPageEntrypointOld = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8MGdZ.formBuilderEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $a5b197477aa02b32$var$formBuilderPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8MGdZ.formBuilderEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $a5b197477aa02b32$export$96aa488380334044 = (0, $6xToB.createEntry)((0, $6m3Bu.softwareFormBuilderClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-builder',
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), (0, $hS1gr.AsyncHorizontalNavJira), ()=>null),
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingM2Enabled)(), (0, $1G20J.projectThemeResource))
        ],
        entryPoint: ()=>(0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? $a5b197477aa02b32$var$formBuilderPageEntrypoint : $a5b197477aa02b32$var$formBuilderPageEntrypointOld,
        supportsPreviewPanel: true
    }));

});
parcelRegister("6m3Bu", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderClassicRoute", () => $ee3a4667f2706e1b$export$f6cfee0232aa1e);
const $ee3a4667f2706e1b$export$f6cfee0232aa1e = {
    name: 'software-form-builder-classic',
    path: '/jira/software/c/projects/:projectKey/form/:formId/builder',
    exact: true
};

});

parcelRegister("8MGdZ", function(module, exports) {

$parcel$export(module.exports, "formBuilderEntrypoint", () => $c0d821b26f00e7c8$export$6d3c9fa7232f412c);

var $cLcpr = parcelRequire("cLcpr");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $c0d821b26f00e7c8$export$6d3c9fa7232f412c = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("7i6Pr")), {
        moduleId: "a7e5ed4a",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formBuilderQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $cLcpr.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("cLcpr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5949a75758897289$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cd13e4f001483f4b52003ed8bc472792>>
 * @relayHash e8f0191fa153f065f7266afab384a46c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 165f5de6118450a4d0cf4ac24900ba8099a89412eebcbf8f5dee46032eb83e21
const $5949a75758897289$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "165f5de6118450a4d0cf4ac24900ba8099a89412eebcbf8f5dee46032eb83e21",
        "metadata": {},
        "name": "src_jiraSoftwareFormBuilderQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5949a75758897289$export$2e2bcd8739ae039 = $5949a75758897289$var$node;

});

parcelRegister("7i6Pr", function(module, exports) {

let $54ef82e6d3199251$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $54ef82e6d3199251$var$load("1VRB2"),
    $54ef82e6d3199251$var$load("bABhq"),
    $54ef82e6d3199251$var$load("1T7b8")
]).then(()=>parcelRequire('gfKpr'));

});



parcelRegister("l7Kcl", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderRouteEntry", () => $61d7218194c95f0b$export$e8dede7671fad23d);

var $epTsa = parcelRequire("epTsa");

var $f2JN3 = parcelRequire("f2JN3");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6zXPf = parcelRequire("6zXPf");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $ebuR2 = parcelRequire("ebuR2");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $kSeQy = parcelRequire("kSeQy");

var $h6XNG = parcelRequire("h6XNG");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $8MGdZ = parcelRequire("8MGdZ");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");
const $61d7218194c95f0b$var$formBuilderPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8MGdZ.formBuilderEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $61d7218194c95f0b$export$e8dede7671fad23d = (0, $6xToB.createEntry)((0, $h6XNG.softwareFormBuilderRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-builder',
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), (0, $hS1gr.AsyncHorizontalNavJira), ()=>null)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingM2Enabled)(), (0, $1G20J.projectThemeResource))
        ],
        entryPoint: ()=>{
            return (0, $epTsa.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $61d7218194c95f0b$var$formBuilderPageEntrypoint : (0, $kSeQy.notFoundPageEntrypoint);
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("h6XNG", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderRoute", () => $9cbe7e4d60be9b83$export$c5589046ee2a390d);
const $9cbe7e4d60be9b83$export$c5589046ee2a390d = {
    name: 'software-form-builder',
    path: '/jira/software/projects/:projectKey/form/:formId/builder',
    exact: true
};

});


parcelRegister("kbvuM", function(module, exports) {

$parcel$export(module.exports, "softwareFormClassicRouteEntry", () => $75b37ca109f0b5ff$export$4bb0f20ad6471148);

var $6xToB = parcelRequire("6xToB");

var $f2JN3 = parcelRequire("f2JN3");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $9n5I0 = parcelRequire("9n5I0");

var $ebuR2 = parcelRequire("ebuR2");

var $fZgSW = parcelRequire("fZgSW");

var $a7sAc = parcelRequire("a7sAc");

var $g8uYY = parcelRequire("g8uYY");

var $8FCAy = parcelRequire("8FCAy");

var $k6duF = parcelRequire("k6duF");

var $6zXPf = parcelRequire("6zXPf");

var $hS1gr = parcelRequire("hS1gr");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $7jTnu = parcelRequire("7jTnu");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $75b37ca109f0b5ff$var$formPageEntrypointOld = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $a7sAc.formEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $75b37ca109f0b5ff$var$formPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $a7sAc.formEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $75b37ca109f0b5ff$export$4bb0f20ad6471148 = (0, $6xToB.createEntry)((0, $fZgSW.softwareFormClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form',
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), (0, $hS1gr.AsyncHorizontalNavJira), ()=>null),
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingM2Enabled)(), (0, $1G20J.projectThemeResource))
        ],
        entryPoint: ()=>(0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? $75b37ca109f0b5ff$var$formPageEntrypoint : $75b37ca109f0b5ff$var$formPageEntrypointOld,
        supportsPreviewPanel: true
    }));

});
parcelRegister("fZgSW", function(module, exports) {

$parcel$export(module.exports, "softwareFormClassicRoute", () => $eba04b6d56c03ae9$export$ae560ee5b676193d);
const $eba04b6d56c03ae9$export$ae560ee5b676193d = {
    name: 'software-form-classic',
    path: '/jira/software/c/projects/:projectKey/form',
    exact: true
};

});

parcelRegister("a7sAc", function(module, exports) {

$parcel$export(module.exports, "formEntrypoint", () => $898b31bc54797eaa$export$b931eb60522f687a);

var $3s00s = parcelRequire("3s00s");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $898b31bc54797eaa$export$b931eb60522f687a = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("aCDet")), {
        moduleId: "34421974",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $3s00s.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("3s00s", function(module, exports) {

$parcel$export(module.exports, "default", () => $0549385f49bf1ddd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3232935a5b9879fc4ee86b3cbc2c9c83>>
 * @relayHash 499a6633134d808842c9e8cd05fbcda0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 10cd467b6a17d91893094678f3292542a4270c9ce4e2a820600612d50bb642b5
const $0549385f49bf1ddd$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "10cd467b6a17d91893094678f3292542a4270c9ce4e2a820600612d50bb642b5",
        "metadata": {},
        "name": "src_jiraSoftwareFormQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0549385f49bf1ddd$export$2e2bcd8739ae039 = $0549385f49bf1ddd$var$node;

});

parcelRegister("aCDet", function(module, exports) {

let $7bbbe2bd7d66d669$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7bbbe2bd7d66d669$var$load("k22tL").then(()=>parcelRequire('lh64p'));

});



parcelRegister("1XNI6", function(module, exports) {

$parcel$export(module.exports, "softwareFormRouteEntry", () => $703a9c7badaed8d3$export$563e3b39911993a0);

var $epTsa = parcelRequire("epTsa");

var $f2JN3 = parcelRequire("f2JN3");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6zXPf = parcelRequire("6zXPf");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $ebuR2 = parcelRequire("ebuR2");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $kSeQy = parcelRequire("kSeQy");

var $eIYCl = parcelRequire("eIYCl");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $a7sAc = parcelRequire("a7sAc");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");
const $703a9c7badaed8d3$var$formPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $a7sAc.formEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $703a9c7badaed8d3$export$563e3b39911993a0 = (0, $6xToB.createEntry)((0, $eIYCl.softwareFormRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form',
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), (0, $hS1gr.AsyncHorizontalNavJira), ()=>null),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingM2Enabled)(), (0, $1G20J.projectThemeResource))
        ],
        entryPoint: ()=>{
            return (0, $epTsa.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $703a9c7badaed8d3$var$formPageEntrypoint : (0, $kSeQy.notFoundPageEntrypoint);
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("eIYCl", function(module, exports) {

$parcel$export(module.exports, "softwareFormRoute", () => $216549ad7f75ac2f$export$a46217d369231a5);
const $216549ad7f75ac2f$export$a46217d369231a5 = {
    name: 'software-form',
    path: '/jira/software/projects/:projectKey/form',
    exact: true
};

});


parcelRegister("8RT9n", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicPublicRouteEntry", () => $896536a7fbfeb4e7$export$df7e146d38db5cc0);

var $6xToB = parcelRequire("6xToB");

var $kSeQy = parcelRequire("kSeQy");

var $epTsa = parcelRequire("epTsa");

var $lahED = parcelRequire("lahED");

var $cxQGT = parcelRequire("cxQGT");

var $7K5Ea = parcelRequire("7K5Ea");

var $7TTbh = parcelRequire("7TTbh");
const $896536a7fbfeb4e7$export$df7e146d38db5cc0 = (0, $6xToB.createEntry)((0, $lahED.softwareFormSubmitClassicPublicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit-public',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        entryPoint: ()=>(0, $epTsa.expVal)('jira_forms_public_access_experiment', 'isEnabled', 'false') ? (0, $7TTbh.formSubmitPageEntrypoint) : (0, $kSeQy.notFoundPageEntrypoint)
    }));

});
parcelRegister("lahED", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicPublicRoute", () => $cc78b2ecc013efd7$export$c66ba06e288dec3f);
const $cc78b2ecc013efd7$export$c66ba06e288dec3f = {
    name: 'software-form-submit-classic-public',
    path: '/jira/software/c/form/:formUuid',
    exact: true
};

});


parcelRegister("9kqeg", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicRouteEntry", () => $70ca0463cf4e995d$export$a7c8812838762453);

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $kSeQy = parcelRequire("kSeQy");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $aoaVN = parcelRequire("aoaVN");

var $g8uYY = parcelRequire("g8uYY");

var $epTsa = parcelRequire("epTsa");

var $ebuR2 = parcelRequire("ebuR2");

var $ckYat = parcelRequire("ckYat");

var $7K5Ea = parcelRequire("7K5Ea");
const $70ca0463cf4e995d$var$formSubmitPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $aoaVN.formSubmitEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $70ca0463cf4e995d$export$a7c8812838762453 = (0, $6xToB.createEntry)((0, $ckYat.softwareFormSubmitClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit',
        layout: (0, $7K5Ea.chromelessLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $epTsa.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $70ca0463cf4e995d$var$formSubmitPageEntrypoint : (0, $kSeQy.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("aoaVN", function(module, exports) {

$parcel$export(module.exports, "formSubmitEntrypoint", () => $54930d830c3d9282$export$d33b8db02e0a0cb5);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $54930d830c3d9282$export$d33b8db02e0a0cb5 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("jYdv4")), {
        moduleId: "3c821c06",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jYdv4", function(module, exports) {

let $e89e17c50fe46c41$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $e89e17c50fe46c41$var$load("1VRB2"),
    $e89e17c50fe46c41$var$load("bABhq"),
    $e89e17c50fe46c41$var$load("cyxF2")
]).then(()=>parcelRequire('geWLV'));

});


parcelRegister("ckYat", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicRoute", () => $bb161fe5a17a8e14$export$91d6851bf27349);
const $bb161fe5a17a8e14$export$91d6851bf27349 = {
    name: 'software-form-submit-classic',
    path: '/jira/software/c/projects/:projectKey/form/:formId',
    exact: true
};

});


parcelRegister("hRXMa", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedClassicRouteEntry", () => $f63f40f2e0871124$export$ffc85d68201bbe35);

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $ebuR2 = parcelRequire("ebuR2");

var $7K5Ea = parcelRequire("7K5Ea");

var $16OA8 = parcelRequire("16OA8");

var $9j04o = parcelRequire("9j04o");

var $g8uYY = parcelRequire("g8uYY");
const $f63f40f2e0871124$var$formSubmitEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $9j04o.formSubmitEmbedEntrypoint)
});
const $f63f40f2e0871124$export$ffc85d68201bbe35 = (0, $6xToB.createEntry)((0, $16OA8.softwareFormSubmitEmbedClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit-embed',
        layout: (0, $7K5Ea.chromelessLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        // eslint-disable-next-line camelcase
        resources: [
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return $f63f40f2e0871124$var$formSubmitEmbedPageEntrypoint;
        }
    }));

});
parcelRegister("16OA8", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedClassicRoute", () => $8e9c0ddaa7da9036$export$812703a022333f7c);
const $8e9c0ddaa7da9036$export$812703a022333f7c = {
    name: 'software-form-submit-classic-embed',
    path: '/jira/software/c/projects/:projectKey/form/:formId/embed',
    exact: true
};

});

parcelRegister("9j04o", function(module, exports) {

$parcel$export(module.exports, "formSubmitEmbedEntrypoint", () => $ed5c84a8270281c4$export$4c748d8ca82fc24);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $ed5c84a8270281c4$export$4c748d8ca82fc24 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("8dtxe")), {
        moduleId: "d6417f2e",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8dtxe", function(module, exports) {

let $5fb672a5838f6b60$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5fb672a5838f6b60$var$load("1VRB2"),
    $5fb672a5838f6b60$var$load("bABhq"),
    $5fb672a5838f6b60$var$load("c0omH")
]).then(()=>parcelRequire('1VFmu'));

});



parcelRegister("lPhuN", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedRouteEntry", () => $482b5af550825591$export$ac2e374edf86801f);

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $ebuR2 = parcelRequire("ebuR2");

var $apFR8 = parcelRequire("apFR8");

var $9j04o = parcelRequire("9j04o");

var $g8uYY = parcelRequire("g8uYY");
const $482b5af550825591$var$formSubmitEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $9j04o.formSubmitEmbedEntrypoint)
});
const $482b5af550825591$export$ac2e374edf86801f = (0, $6xToB.createEntry)((0, $apFR8.softwareFormSubmitEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit-embed',
        layout: (0, $7K5Ea.chromelessLayout),
        // eslint-disable-next-line camelcase
        resources: [
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return $482b5af550825591$var$formSubmitEmbedPageEntrypoint;
        }
    }));

});
parcelRegister("apFR8", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedRoute", () => $2bba8b7741d3b01b$export$2bee26f083dc2946);
const $2bba8b7741d3b01b$export$2bee26f083dc2946 = {
    name: 'software-form-submit-embed',
    path: '/jira/software/projects/:projectKey/form/:formId/embed',
    exact: true
};

});


parcelRegister("4Cdj7", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitPublicRouteEntry", () => $6a0a3672e2de4170$export$70893a47a5c041fd);

var $6xToB = parcelRequire("6xToB");

var $kSeQy = parcelRequire("kSeQy");

var $epTsa = parcelRequire("epTsa");

var $4PECA = parcelRequire("4PECA");

var $7K5Ea = parcelRequire("7K5Ea");

var $7TTbh = parcelRequire("7TTbh");

var $cxQGT = parcelRequire("cxQGT");
const $6a0a3672e2de4170$export$70893a47a5c041fd = (0, $6xToB.createEntry)((0, $4PECA.softwareFormSubmitPublicRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit-public',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        entryPoint: ()=>{
            return (0, $epTsa.expVal)('jira_forms_public_access_experiment', 'isEnabled', 'false') ? (0, $7TTbh.formSubmitPageEntrypoint) : (0, $kSeQy.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("4PECA", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitPublicRoute", () => $31da028c314c8c30$export$d238522bd96fb720);
const $31da028c314c8c30$export$d238522bd96fb720 = {
    name: 'software-form-submit-public',
    path: '/jira/software/form/:formUuid',
    exact: true
};

});


parcelRegister("lxvYO", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitRouteEntry", () => $9737d374115af89f$export$752724866670c36);

var $7K5Ea = parcelRequire("7K5Ea");

var $epTsa = parcelRequire("epTsa");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $ebuR2 = parcelRequire("ebuR2");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $kSeQy = parcelRequire("kSeQy");

var $kYILW = parcelRequire("kYILW");

var $aoaVN = parcelRequire("aoaVN");

var $g8uYY = parcelRequire("g8uYY");
const $9737d374115af89f$var$formSubmitPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $aoaVN.formSubmitEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $9737d374115af89f$export$752724866670c36 = (0, $6xToB.createEntry)((0, $kYILW.softwareFormSubmitRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit',
        layout: (0, $7K5Ea.chromelessLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $epTsa.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $9737d374115af89f$var$formSubmitPageEntrypoint : (0, $kSeQy.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("kYILW", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitRoute", () => $692ae5036e20b0c9$export$75b28ee1c7f02f00);
const $692ae5036e20b0c9$export$75b28ee1c7f02f00 = {
    name: 'software-form-submit',
    path: '/jira/software/projects/:projectKey/form/:formId',
    exact: true
};

});


parcelRegister("6XvFv", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsClassicRouteEntry", () => $cd936b756ae58dd5$export$58d10390fc181fcf);

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $k6duF = parcelRequire("k6duF");

var $hS1gr = parcelRequire("hS1gr");

var $fOnfM = parcelRequire("fOnfM");

var $7jTnu = parcelRequire("7jTnu");

var $4mGMh = parcelRequire("4mGMh");
const $cd936b756ae58dd5$export$58d10390fc181fcf = (0, $6xToB.createEntry)((0, $fOnfM.softwareGoalsClassicRoute), ()=>({
        group: 'classic-software',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            }),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $4mGMh.softwareGoalsClassicPageEntrypoint) : (0, $4mGMh.softwareGoalsClassicPageEntrypointOld),
        supportsPreviewPanel: true
    }));

});
parcelRegister("fOnfM", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsClassicRoute", () => $9780f726a01368f9$export$d12f3924cf53b545);
const $9780f726a01368f9$export$d12f3924cf53b545 = {
    name: 'software-goals-classic',
    path: '/jira/software/c/projects/:projectKey/goals'
};

});

parcelRegister("4mGMh", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsClassicPageEntrypointOld", () => $ffec8a7226240934$export$9eef20e3df8edb8f);
$parcel$export(module.exports, "softwareGoalsClassicPageEntrypoint", () => $ffec8a7226240934$export$6c6f7e606a16292);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $gH6fd = parcelRequire("gH6fd");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $ffec8a7226240934$export$9eef20e3df8edb8f = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $gH6fd.softwareGoalsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $ffec8a7226240934$export$6c6f7e606a16292 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $gH6fd.softwareGoalsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("gH6fd", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsEntrypoint", () => $51e615ef72ff06ac$export$a75f86449cc34a72);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $51e615ef72ff06ac$export$a75f86449cc34a72 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("6o0a6")), {
        moduleId: "a5f3007b",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6o0a6", function(module, exports) {

let $4a651c1acf0e432c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4a651c1acf0e432c$var$load("kX0HU").then(()=>parcelRequire('7zEKu'));

});




parcelRegister("jZv6V", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsRouteEntry", () => $09cbb40265f2eee4$export$d3fcc412edfa2068);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $ldZEd = parcelRequire("ldZEd");

var $hS1gr = parcelRequire("hS1gr");

var $39DKk = parcelRequire("39DKk");
const $09cbb40265f2eee4$export$d3fcc412edfa2068 = (0, $6xToB.createEntry)((0, $ldZEd.softwareGoalsRoute), ()=>({
        group: 'software',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $39DKk.softwareGoalsPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("ldZEd", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsRoute", () => $7cd62da4d350af82$export$2328fed7ebee3cce);
const $7cd62da4d350af82$export$2328fed7ebee3cce = {
    name: 'software-goals',
    exact: true,
    path: '/jira/software/projects/:projectKey/goals'
};

});

parcelRegister("39DKk", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsPageEntrypoint", () => $3e4b808774818d32$export$6c63903b420029c0);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $gH6fd = parcelRequire("gH6fd");
const $3e4b808774818d32$export$6c63903b420029c0 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $gH6fd.softwareGoalsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("b5gw6", function(module, exports) {

$parcel$export(module.exports, "softwareInboxClassicRouteEntry", () => $ee645864532557ea$export$ca6aeb36a7b6211d);

var $7mF43 = parcelRequire("7mF43");

var $6OkvA = parcelRequire("6OkvA");

var $7jTnu = parcelRequire("7jTnu");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4jA39 = parcelRequire("4jA39");

var $hS1gr = parcelRequire("hS1gr");

var $kSeQy = parcelRequire("kSeQy");

var $bQFhw = parcelRequire("bQFhw");

var $36VZX = parcelRequire("36VZX");
const $ee645864532557ea$export$ca6aeb36a7b6211d = (0, $6xToB.createEntry)((0, $6OkvA.softwareInboxClassicRoute), ()=>({
        group: 'classic-software',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            reporting: {
                id: 'software-inbox-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-inbox-classic'),
                teamName: 'boysenberry'
            }
        },
        skeleton: (0, $4jA39.InboxViewTableSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.ForPaintClassicSoftwareProjectSidebar),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $6dwgv.createLayout)((0, $ioHIu.genericProjectLayout)),
        entryPoint: ()=>(0, $7jTnu.fg)('jcs_developer_escalations') ? (0, $36VZX.inboxPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("6OkvA", function(module, exports) {

$parcel$export(module.exports, "softwareInboxClassicRoute", () => $72f32152ce37bb03$export$a3612f128eff4e3c);
const $72f32152ce37bb03$export$a3612f128eff4e3c = {
    name: 'inbox-classic',
    path: '/jira/software/c/projects/:projectKey/inbox/:issueKey?'
};

});

parcelRegister("4jA39", function(module, exports) {

$parcel$export(module.exports, "InboxViewTableSkeleton", () => $55c791cd780e415e$export$24aae43683500596);
/* InboxViewTableSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $kzDJ9 = parcelRequire("kzDJ9");
const $55c791cd780e415e$var$customCssStyles = null;
const $55c791cd780e415e$var$containerStyles = {
    height: '448px'
};
const $55c791cd780e415e$export$24aae43683500596 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kzDJ9))),
        containerStyles: $55c791cd780e415e$var$containerStyles,
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("kzDJ9", function(module, exports) {
module.exports = new URL("inbox-view-table-skeleton.tpl.3e3d3620.svg", import.meta.url).toString();

});


parcelRegister("36VZX", function(module, exports) {

$parcel$export(module.exports, "inboxPageEntryPoint", () => $048efea0d807b562$export$6da9e4ae87b73009);

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");

var $gzDVg = parcelRequire("gzDVg");
const $048efea0d807b562$export$6da9e4ae87b73009 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $gzDVg.customerServiceInboxPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("gzDVg", function(module, exports) {

$parcel$export(module.exports, "customerServiceInboxPageEntrypoint", () => $265dab3b08058bf8$export$bf72eb0f567836ce);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $265dab3b08058bf8$export$bf72eb0f567836ce = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("Dgu11")), {
        moduleId: "9cc840e3",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("Dgu11", function(module, exports) {

let $07606dd6689dba40$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $07606dd6689dba40$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $07606dd6689dba40$var$load("deNlq")
        ]);
    }),
    $07606dd6689dba40$var$load("1MkO4")
]).then(()=>parcelRequire('3rHYj'));

});




parcelRegister("2YbyC", function(module, exports) {

$parcel$export(module.exports, "softwareInboxNextGenRouteEntry", () => $b60c0ea8a781935e$export$22d61f7936797fc0);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $7jTnu = parcelRequire("7jTnu");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $3l4Y5 = parcelRequire("3l4Y5");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $4jA39 = parcelRequire("4jA39");

var $kSeQy = parcelRequire("kSeQy");

var $bQFhw = parcelRequire("bQFhw");

var $36VZX = parcelRequire("36VZX");
const $b60c0ea8a781935e$export$22d61f7936797fc0 = (0, $6xToB.createEntry)((0, $3l4Y5.softwareInboxNextGenRoute), ()=>({
        group: 'software',
        meta: {
            reporting: {
                id: 'software-inbox-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-inbox-classic'),
                teamName: 'boysenberry'
            }
        },
        skeleton: (0, $4jA39.InboxViewTableSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.ForPaintSoftwareProjectSidebar),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $6dwgv.createLayout)((0, $8FCAy.softwareProjectLayoutNoOnboarding)),
        entryPoint: ()=>(0, $7jTnu.fg)('jcs_developer_escalations') ? (0, $36VZX.inboxPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("3l4Y5", function(module, exports) {

$parcel$export(module.exports, "softwareInboxNextGenRoute", () => $57961f30aea50012$export$e44454ed868d0941);
const $57961f30aea50012$export$e44454ed868d0941 = {
    name: 'inbox',
    path: '/jira/software/projects/:projectKey/inbox/:issueKey?'
};

});


parcelRegister("hykoI", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsClassicRouteEntry", () => $0a569651542444d3$export$c7d98bfe75274932);

var $7mF43 = parcelRequire("7mF43");

var $7jTnu = parcelRequire("7jTnu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $6RR4t = parcelRequire("6RR4t");

var $7nY0O = parcelRequire("7nY0O");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $8hufg = parcelRequire("8hufg");

var $2L04M = parcelRequire("2L04M");
const $0a569651542444d3$export$c7d98bfe75274932 = (0, $6xToB.createEntry)((0, $6RR4t.softwareIncidentsClassicRoute), ()=>({
        group: 'classic-software',
        entryPoint () {
            return (0, $7jTnu.fg)('corex_operandi_incidents_page_in_jira') ? (0, $8hufg.entryPoint) : (0, $2L04M.entryPointDeprecated);
        },
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        skeleton: (0, $7nY0O.IncidentsPageSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $bTfc4.incidentsInitialPageChecksResource),
            (0, $bTfc4.incidentsCustomFieldIdResource)
        ],
        meta: {
            reporting: {
                id: 'software-incidents-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-incidents-classic'),
                teamName: 'operandi'
            }
        },
        ufoName: 'software-incidents',
        supportsPreviewPanel: true
    }));

});
parcelRegister("6RR4t", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsClassicRoute", () => $59ff647f7edd0c65$export$3356a7870a2717f4);
const $59ff647f7edd0c65$export$3356a7870a2717f4 = {
    name: 'software-incidents-classic',
    path: '/jira/software/c/projects/:projectKey/incidents'
};

});

parcelRegister("7nY0O", function(module, exports) {

$parcel$export(module.exports, "IncidentsPageSkeleton", () => $5367e10b141c586b$export$3105d59d9ca899bd);
$parcel$export(module.exports, "IncidentsTableSkeleton", () => $5367e10b141c586b$export$7092b8ea63ebf9be);
/* IncidentsPageSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $7vCEx = parcelRequire("7vCEx");

var $dGkyH = parcelRequire("dGkyH");
const $5367e10b141c586b$var$incidentsPageSkeletonStyles = null;
const $5367e10b141c586b$var$incidentsTableSkeletonStyles = null;
const $5367e10b141c586b$export$3105d59d9ca899bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-page",
        className: (0, $hcewu.default)([
            "_1bsb1x27 _4t3i1osq _ca0q1ejb _19bv1jfw _u5f31jfw _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7vCEx)))
    }));
const $5367e10b141c586b$export$7092b8ea63ebf9be = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-table",
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dGkyH)))
    }));

});
parcelRegister("7vCEx", function(module, exports) {
module.exports = new URL("incidents-page-app-skeleton.tpl.5b656159.svg", import.meta.url).toString();

});

parcelRegister("dGkyH", function(module, exports) {
module.exports = new URL("incidents-page-table-skeleton.tpl.e8f337f1.svg", import.meta.url).toString();

});


parcelRegister("8hufg", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $5da3e540de98aaf6$export$6333901e831d7af0);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $3uujZ = parcelRequire("3uujZ");

var $9n5I0 = parcelRequire("9n5I0");
const $5da3e540de98aaf6$export$6333901e831d7af0 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $3uujZ.incidentsPageEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("3uujZ", function(module, exports) {

$parcel$export(module.exports, "incidentsPageEntryPoint", () => $03cfa6df2508a282$export$a59477eea6e8cd7f);

var $egj7Q = parcelRequire("egj7Q");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");
const $03cfa6df2508a282$var$AriGraphSortOrderInput = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $03cfa6df2508a282$var$QUERY_PARAM_SEARCH = 'search';
const $03cfa6df2508a282$var$QUERY_PARAM_PRIORITY = 'priority';
const $03cfa6df2508a282$var$QUERY_PARAM_AFFECTED_SERVICE = 'affected-service';
const $03cfa6df2508a282$var$QUERY_PARAM_STATUS = 'status';
const $03cfa6df2508a282$var$QUERY_PARAM_SORT_BY = 'sortBy';
const $03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER = 'sortOrder';
const $03cfa6df2508a282$var$STATUS_SORT_KEY = 'status';
const $03cfa6df2508a282$var$CREATED_SORT_KEY = 'created';
const $03cfa6df2508a282$var$PRIORITY_SORT_KEY = 'priority';
const $03cfa6df2508a282$var$SUMMARY_SORT_KEY = 'key';
const $03cfa6df2508a282$var$ASC_SORT_KEY = 'ASC';
const $03cfa6df2508a282$var$DESC_SORT_KEY = 'DESC';
function $03cfa6df2508a282$var$notEmpty(value) {
    return Boolean(value);
}
const $03cfa6df2508a282$var$isPriority = $03cfa6df2508a282$var$notEmpty;
const $03cfa6df2508a282$var$isStatus = (val)=>val === 'resolved' || val === 'open';
const $03cfa6df2508a282$var$isSortBy = (val)=>val === $03cfa6df2508a282$var$STATUS_SORT_KEY || val === $03cfa6df2508a282$var$CREATED_SORT_KEY || val === $03cfa6df2508a282$var$PRIORITY_SORT_KEY || val === $03cfa6df2508a282$var$SUMMARY_SORT_KEY;
const $03cfa6df2508a282$var$isSortOrder = (val)=>val === $03cfa6df2508a282$var$ASC_SORT_KEY || val === $03cfa6df2508a282$var$DESC_SORT_KEY;
const $03cfa6df2508a282$var$isAffectedService = $03cfa6df2508a282$var$notEmpty;
function $03cfa6df2508a282$var$parseParameter(parameter, parameterValidationFn) {
    return parameter == null ? undefined : parameter.split(',').map((str)=>str.trim()).filter(parameterValidationFn);
}
const $03cfa6df2508a282$var$parseQueryParams = (paramsRaw)=>{
    const result = {
        [$03cfa6df2508a282$var$QUERY_PARAM_SORT_BY]: paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_SORT_BY] && $03cfa6df2508a282$var$isSortBy(paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_SORT_BY]) ? paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_SORT_BY] : $03cfa6df2508a282$var$CREATED_SORT_KEY,
        [$03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER]: paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER] && $03cfa6df2508a282$var$isSortOrder(paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER]) ? paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER] : $03cfa6df2508a282$var$DESC_SORT_KEY
    };
    result[$03cfa6df2508a282$var$QUERY_PARAM_AFFECTED_SERVICE] = $03cfa6df2508a282$var$parseParameter(paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_AFFECTED_SERVICE], $03cfa6df2508a282$var$isAffectedService);
    result[$03cfa6df2508a282$var$QUERY_PARAM_STATUS] = $03cfa6df2508a282$var$parseParameter(paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_STATUS], $03cfa6df2508a282$var$isStatus);
    result[$03cfa6df2508a282$var$QUERY_PARAM_SEARCH] = paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_SEARCH] ?? undefined;
    result[$03cfa6df2508a282$var$QUERY_PARAM_PRIORITY] = $03cfa6df2508a282$var$parseParameter(paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_PRIORITY], $03cfa6df2508a282$var$isPriority);
    return result;
};
const $03cfa6df2508a282$var$getFilterValue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
values)=>({
        ...values.length > 0 ? {
            is: values
        } : {}
    });
const $03cfa6df2508a282$var$parseStatusToFilterValues = (status)=>status.flatMap((stat)=>{
        switch(stat){
            case 'open':
                return [
                    'NEW',
                    'INDETERMINATE'
                ];
            case 'resolved':
                return [
                    'DONE'
                ];
            default:
                return [
                    'UNDEFINED'
                ];
        }
    });
const $03cfa6df2508a282$var$getGqlFiltersFromQueryParams = (parsedQueryParams)=>({
        and: [
            {
                to_status: $03cfa6df2508a282$var$getFilterValue($03cfa6df2508a282$var$parseStatusToFilterValues(parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_STATUS] ?? [])),
                to_priority: $03cfa6df2508a282$var$getFilterValue(parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_PRIORITY] ?? []),
                to_affectedServiceAris: $03cfa6df2508a282$var$getFilterValue(parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_AFFECTED_SERVICE] ?? [])
            }
        ]
    });
const $03cfa6df2508a282$var$parseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $03cfa6df2508a282$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $03cfa6df2508a282$var$AriGraphSortOrderInput.ASC;
        case $03cfa6df2508a282$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $03cfa6df2508a282$var$AriGraphSortOrderInput.DESC;
        default:
            return defaultValue;
    }
};
const $03cfa6df2508a282$var$getSortValue = (sortOrder)=>({
        priority: 2,
        direction: $03cfa6df2508a282$var$parseSortDirection(sortOrder, $03cfa6df2508a282$var$AriGraphSortOrderInput.DESC)
    });
// Added Inverse sort fn as data in AGS is indexed in reverse order for priority
const $03cfa6df2508a282$var$parseInverseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $03cfa6df2508a282$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $03cfa6df2508a282$var$AriGraphSortOrderInput.DESC;
        case $03cfa6df2508a282$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $03cfa6df2508a282$var$AriGraphSortOrderInput.ASC;
        default:
            return defaultValue;
    }
};
const $03cfa6df2508a282$var$getInverseSortValue = (sortOrder)=>({
        priority: 2,
        direction: $03cfa6df2508a282$var$parseInverseSortDirection(sortOrder, $03cfa6df2508a282$var$AriGraphSortOrderInput.ASC)
    });
const $03cfa6df2508a282$var$getGraphStoreSortFromQueryParams = (parsedQueryParams)=>({
        lastModified: {
            priority: 1,
            direction: $03cfa6df2508a282$var$AriGraphSortOrderInput.DESC
        },
        ...$03cfa6df2508a282$var$STATUS_SORT_KEY === parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_SORT_BY] ? {
            to_status: $03cfa6df2508a282$var$getSortValue(parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$03cfa6df2508a282$var$PRIORITY_SORT_KEY === parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_SORT_BY] ? {
            to_priority: $03cfa6df2508a282$var$getInverseSortValue(parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$03cfa6df2508a282$var$CREATED_SORT_KEY === parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_SORT_BY] ? {
            createdAt: $03cfa6df2508a282$var$getSortValue(parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER])
        } : {}
    });

const $03cfa6df2508a282$export$a59477eea6e8cd7f = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("fstKd")).then((mod)=>mod.IncidentsPageWrapper), {
        moduleId: "5b8b4ff7",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $egj7Q.default,
                    variables: {
                        incidentPageSize: 30,
                        servicePageSize: 30,
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        filter: $03cfa6df2508a282$var$getGqlFiltersFromQueryParams($03cfa6df2508a282$var$parseQueryParams(context.query)),
                        sort: $03cfa6df2508a282$var$getGraphStoreSortFromQueryParams($03cfa6df2508a282$var$parseQueryParams(context.query)),
                        siteAri: `ari:cloud:jira::site/${cloudId}`
                    }
                }
            }
        })
});

});
parcelRegister("egj7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7271a6c53691feb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<535af53561736a2d836fc81ae5b4bf2f>>
 * @relayHash ab315f9ffdcbe8bd8ba7b5de061e5649
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46b09365c92c616fad0f3bc4329e6d2421389f9a3a81cc6bcfaa80c14a330137
const $b7271a6c53691feb$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "46b09365c92c616fad0f3bc4329e6d2421389f9a3a81cc6bcfaa80c14a330137",
        "metadata": {
            "connection": [
                {
                    "count": "servicePageSize",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "linkedOperationsComponentsByProject"
                    ]
                }
            ]
        },
        "name": "srcIncidentsPageInternalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b7271a6c53691feb$export$2e2bcd8739ae039 = $b7271a6c53691feb$var$node;

});

parcelRegister("fstKd", function(module, exports) {

let $b4108b27acbb8fc8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $b4108b27acbb8fc8$var$load("1VRB2"),
    $b4108b27acbb8fc8$var$load("bABhq"),
    $b4108b27acbb8fc8$var$load("7Wy9c")
]).then(()=>parcelRequire('4Muh9'));

});



parcelRegister("2L04M", function(module, exports) {

$parcel$export(module.exports, "entryPointDeprecated", () => $d5d3b4f6512fd8ee$export$821fec5ea5acc81d);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $do0fs = parcelRequire("do0fs");

var $9n5I0 = parcelRequire("9n5I0");
const $d5d3b4f6512fd8ee$export$821fec5ea5acc81d = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $do0fs.incidentsPageEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("do0fs", function(module, exports) {

$parcel$export(module.exports, "incidentsPageEntryPoint", () => $f5481b44e016e698$export$a59477eea6e8cd7f);

var $cOFzb = parcelRequire("cOFzb");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $f5481b44e016e698$export$a59477eea6e8cd7f = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("7JJBV")).then((mod)=>mod.IncidentsPageLinkedServicesWrapper), {
        moduleId: "d6132459",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $cOFzb.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("cOFzb", function(module, exports) {

$parcel$export(module.exports, "default", () => $470733dd7cdc1a43$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7699704d0995bbdc63133dc84290d5de>>
 * @relayHash bf929c95e6738104436e6a3b1e6f48cd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf
const $470733dd7cdc1a43$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "associatedComponents"
                    ]
                }
            ]
        },
        "name": "srcIncidentsLinkedServicesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $470733dd7cdc1a43$export$2e2bcd8739ae039 = $470733dd7cdc1a43$var$node;

});

parcelRegister("7JJBV", function(module, exports) {

let $5a201db09e399870$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5a201db09e399870$var$load("1VRB2"),
    $5a201db09e399870$var$load("bABhq"),
    $5a201db09e399870$var$load("kKVm9")
]).then(()=>parcelRequire('3wXGb'));

});




parcelRegister("2dAZL", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsNextGenRouteEntry", () => $006e613ff5d52bac$export$fd29243dbe4103);

var $7mF43 = parcelRequire("7mF43");

var $7jTnu = parcelRequire("7jTnu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $eyX6G = parcelRequire("eyX6G");

var $7nY0O = parcelRequire("7nY0O");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $8hufg = parcelRequire("8hufg");

var $2L04M = parcelRequire("2L04M");
const $006e613ff5d52bac$export$fd29243dbe4103 = (0, $6xToB.createEntry)((0, $eyX6G.softwareIncidentsNextGenRoute), ()=>({
        group: 'software',
        entryPoint () {
            return (0, $7jTnu.fg)('corex_operandi_incidents_page_in_jira') ? (0, $8hufg.entryPoint) : (0, $2L04M.entryPointDeprecated);
        },
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        skeleton: (0, $7nY0O.IncidentsPageSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $bTfc4.incidentsInitialPageChecksResource),
            (0, $bTfc4.incidentsCustomFieldIdResource)
        ],
        meta: {
            reporting: {
                id: 'software-incidents',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-incidents'),
                teamName: 'operandi'
            }
        },
        ufoName: 'software-incidents',
        supportsPreviewPanel: true
    }));

});
parcelRegister("eyX6G", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsNextGenRoute", () => $e8081ff7de272d80$export$12e1ca6c7cfdfd49);
const $e8081ff7de272d80$export$12e1ca6c7cfdfd49 = {
    name: 'software-incidents',
    path: '/jira/software/projects/:projectKey/incidents'
};

});


parcelRegister("6Rmp2", function(module, exports) {

$parcel$export(module.exports, "softwareListClassicRouteEntry", () => $dc36dcb442488afe$export$4e2a0a97feb715a5);

var $6xToB = parcelRequire("6xToB");

var $5S55b = parcelRequire("5S55b");

var $6dwgv = parcelRequire("6dwgv");

var $8FCAy = parcelRequire("8FCAy");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $jt5VP = parcelRequire("jt5VP");

var $hS1gr = parcelRequire("hS1gr");

var $ho9E1 = parcelRequire("ho9E1");

var $cV98p = parcelRequire("cV98p");

var $ebuR2 = parcelRequire("ebuR2");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $ebWJz = parcelRequire("ebWJz");

var $eJe5A = parcelRequire("eJe5A");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $7jTnu = parcelRequire("7jTnu");


var $d4NVH = parcelRequire("d4NVH");

var $gwH93 = parcelRequire("gwH93");

var $fYGKn = parcelRequire("fYGKn");

var $ioHIu = parcelRequire("ioHIu");

var $bQFhw = parcelRequire("bQFhw");

var $4a0D4 = parcelRequire("4a0D4");
const $dc36dcb442488afe$export$4e2a0a97feb715a5 = (0, $6xToB.createEntry)((0, $jt5VP.softwareListClassicRoute), ()=>({
        group: 'classic-software',
        meta: (0, $7jTnu.fg)('jira_list_nin_merge') ? {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        } : undefined,
        skeleton: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $gwH93.ProjectIssueNavigatorSkeleton) : (0, $5S55b.ListSkeleton),
        entryPoint () {
            if ((0, $7jTnu.fg)('jira_list_nin_merge')) return (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $fYGKn.issueNavigatorPageEntryPointWithNested) : (0, $fYGKn.issueNavigatorPageEntryPoint);
            return (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $4a0D4.softwareListRouteEntry) : (0, $4a0D4.softwareListRouteEntryOld);
        },
        layout: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $6dwgv.createLayout)((0, $ioHIu.genericProjectLayout)) : (0, $6dwgv.composeLayouts)((0, $8FCAy.classicSoftwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareListClassicRouteEntry.tsx',
                whichExportToUse: 'softwareListClassicRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-navigator.json',
            // An increase from 1.2s default to 1.5s will comfortably cater for P95 of issue search requests
            // For more insights into this decision, see https://jplat.atlassian.net/browse/EM-9249
            fetchTimeout: (0, $7jTnu.fg)('increase_server_fetch_timeouts_for_nin_bifrost') ? 1500 : undefined
        },
        navigation: (0, $7jTnu.fg)('jira_list_nin_merge') ? {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.ForPaintClassicSoftwareProjectSidebar),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        } : {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        // TODO: This is a copy of getProjectViewResources, but it has been copied in order to replace
        //  with .
        resources: (0, $7jTnu.fg)('jira_list_nin_merge') ? [
            ...(0, $bQFhw.getCommonProjectResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            })
        ] : [
            // the below 5 resources are copied from getBusinessProjectResources
            // they should be feature flagged and removed when it is safe to do so or
            // moved out of business packages
            // start getBusinessProjectResources
            (0, $ho9E1.projectCreatePermissionsResource),
            (0, $cV98p.navigationResource),
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            // end getBusinessProjectResources
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $ebWJz.fieldsResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource))
        ],
        afterPaint: (0, $7jTnu.fg)('jira_list_nin_merge') ? undefined : [
            (0, $eJe5A.LazyIssueApp)
        ],
        ufoName: (0, $7jTnu.fg)('jira_list_nin_merge') ? 'classic-list-nin' : 'classic-list',
        supportsPreviewPanel: true
    }));

});
parcelRegister("5S55b", function(module, exports) {

$parcel$export(module.exports, "ListSkeleton", () => $44111d7f433e10a3$export$cbc3335f7a517046);
$parcel$export(module.exports, "ListEmbedSkeleton", () => $44111d7f433e10a3$export$2638f1c98fe91c13);

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $4HXfG = parcelRequire("4HXfG");

var $8fOtE = parcelRequire("8fOtE");
const $44111d7f433e10a3$export$cbc3335f7a517046 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4HXfG)))
    });
const $44111d7f433e10a3$export$2638f1c98fe91c13 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8fOtE)))
    });

});
parcelRegister("4HXfG", function(module, exports) {
module.exports = new URL("list-app-skeleton.tpl.82508714.svg", import.meta.url).toString();

});

parcelRegister("8fOtE", function(module, exports) {
module.exports = new URL("list-embed-app-skeleton.tpl.de94c811.svg", import.meta.url).toString();

});


parcelRegister("jt5VP", function(module, exports) {

$parcel$export(module.exports, "softwareListClassicRoute", () => $e15439174684b802$export$1bf758507ca6b2);
const $e15439174684b802$export$1bf758507ca6b2 = {
    name: 'software-list-classic',
    path: '/jira/software/c/projects/:projectKey/list/:itemId?'
};

});

parcelRegister("4a0D4", function(module, exports) {

$parcel$export(module.exports, "softwareListRouteEntryOld", () => $4885cc90f98ee7d9$export$e844b8d1d10f4a38);
$parcel$export(module.exports, "softwareListRouteEntry", () => $4885cc90f98ee7d9$export$f30a66efa682bf2d);
$parcel$export(module.exports, "softwareListEmbedRouteEntry", () => $4885cc90f98ee7d9$export$1099e0e49394fa9a);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $7nbE3 = parcelRequire("7nbE3");

var $9n5I0 = parcelRequire("9n5I0");

var $iyUFz = parcelRequire("iyUFz");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $4885cc90f98ee7d9$export$e844b8d1d10f4a38 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iyUFz.listEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $4885cc90f98ee7d9$export$f30a66efa682bf2d = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iyUFz.listEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $4885cc90f98ee7d9$export$1099e0e49394fa9a = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $7nbE3.listEmbedEntryPoint)
});

});
parcelRegister("7nbE3", function(module, exports) {

$parcel$export(module.exports, "listEmbedEntryPoint", () => $ee75376db34fe720$export$519bb55e1612f243);

var $KREkC = parcelRequire("KREkC");

var $ho04S = parcelRequire("ho04S");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");
const $ee75376db34fe720$var$FORMAT_RULES_FIRST = 20;

const $ee75376db34fe720$export$519bb55e1612f243 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("3qccW")), {
        moduleId: "5ed7fb43",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $ho04S.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $KREkC.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $ee75376db34fe720$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("ho04S", function(module, exports) {

$parcel$export(module.exports, "default", () => $451844dde7d71ff7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<834fddde735677817bb414d426c4ffa7>>
 * @relayHash b1d5bddbd0778f4be3f4876e1525e6f4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 661dfc8e2a4d3163499a24e3bae8c13315e369090fa8e455d22560e15a9e00f4
const $451844dde7d71ff7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "661dfc8e2a4d3163499a24e3bae8c13315e369090fa8e455d22560e15a9e00f4",
        "metadata": {},
        "name": "src_jiraSoftwareListEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $451844dde7d71ff7$export$2e2bcd8739ae039 = $451844dde7d71ff7$var$node;

});

parcelRegister("3qccW", function(module, exports) {

let $27dd44ff11035eea$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $27dd44ff11035eea$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $27dd44ff11035eea$var$load("e7BS9")
        ]);
    }),
    $27dd44ff11035eea$var$load("1VRB2"),
    $27dd44ff11035eea$var$load("bABhq"),
    $27dd44ff11035eea$var$load("4ZOZZ")
]).then(()=>parcelRequire('7l8Rz'));

});


parcelRegister("iyUFz", function(module, exports) {

$parcel$export(module.exports, "listEntryPoint", () => $959b649eb5b17e7a$export$6be4f10150ff6073);

var $KREkC = parcelRequire("KREkC");

var $59fcn = parcelRequire("59fcn");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");
const $959b649eb5b17e7a$var$FORMAT_RULES_FIRST = 20;

const $959b649eb5b17e7a$export$6be4f10150ff6073 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("1i8qt")), {
        moduleId: "a7ba8596",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $59fcn.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $KREkC.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $959b649eb5b17e7a$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("59fcn", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f77be600e9fed68$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9589819072a0d79deedb3286a1ad0e09>>
 * @relayHash 7ca7a7e73175fabcafbcca8378817432
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e63ab64e310db9403bb03770e66a53a6920f135e0096a5f8f31a3ac88d170c0b
const $6f77be600e9fed68$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e63ab64e310db9403bb03770e66a53a6920f135e0096a5f8f31a3ac88d170c0b",
        "metadata": {},
        "name": "src_jiraSoftwareListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6f77be600e9fed68$export$2e2bcd8739ae039 = $6f77be600e9fed68$var$node;

});

parcelRegister("1i8qt", function(module, exports) {

let $0f0e0219e74bb9ff$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $0f0e0219e74bb9ff$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $0f0e0219e74bb9ff$var$load("e7BS9")
        ]);
    }),
    $0f0e0219e74bb9ff$var$load("1VRB2"),
    $0f0e0219e74bb9ff$var$load("bABhq"),
    $0f0e0219e74bb9ff$var$load("1kbQp")
]).then(()=>parcelRequire('31Gwz'));

});




parcelRegister("3FQCK", function(module, exports) {

$parcel$export(module.exports, "softwareListCustomEmbedClassicRouteEntry", () => $923e3c6a829c6ce2$export$1bf6c018ccb88bd6);

var $6xToB = parcelRequire("6xToB");

var $jVX4d = parcelRequire("jVX4d");

var $5S55b = parcelRequire("5S55b");

var $7K5Ea = parcelRequire("7K5Ea");

var $ho9E1 = parcelRequire("ho9E1");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $ebWJz = parcelRequire("ebWJz");

var $eJe5A = parcelRequire("eJe5A");

var $cV98p = parcelRequire("cV98p");


var $d4NVH = parcelRequire("d4NVH");

var $bQFhw = parcelRequire("bQFhw");

var $hFWLB = parcelRequire("hFWLB");

var $fYGKn = parcelRequire("fYGKn");

var $kSeQy = parcelRequire("kSeQy");

var $7jTnu = parcelRequire("7jTnu");

var $ebuR2 = parcelRequire("ebuR2");

var $4a0D4 = parcelRequire("4a0D4");
const $923e3c6a829c6ce2$export$1bf6c018ccb88bd6 = (0, $6xToB.createEntry)((0, $jVX4d.softwareListCustomEmbedClassicRoute), ()=>({
        group: 'classic-software',
        meta: (0, $7jTnu.fg)('jira_list_nin_merge') ? {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        } : undefined,
        skeleton: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $hFWLB.EmbedIssueNavigatorSkeleton) : (0, $5S55b.ListEmbedSkeleton),
        entryPoint () {
            if ((0, $7jTnu.fg)('jira_list_nin_merge')) return (0, $7jTnu.fg)('jira_nin_smart_link') ? (0, $fYGKn.issueNavigatorEmbedPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint);
            return 0, $4a0D4.softwareListEmbedRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        // eslint-disable-next-line jira/ff/no-preconditioning
        isHydrateRootEnabled: (0, $7jTnu.fg)('jira_list_nin_merge') && (0, $7jTnu.fg)('nin-full-page-hydrate-root'),
        // TODO: This is a copy of getProjectViewResources, but it has been copied in order to expand getNavigationSidebarProjectResource
        resources: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $bQFhw.getCommonProjectResources)() : [
            // the below 5 resources are copied from getBusinessProjectResources
            // they should be feature flagged and removed when it is safe to do so or
            // moved out of business packages
            // start getBusinessProjectResources
            (0, $ho9E1.projectCreatePermissionsResource),
            (0, $cV98p.navigationResource),
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            // end getBusinessProjectResources
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $ebWJz.fieldsResource)
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        ufoName: (0, $7jTnu.fg)('jira_list_nin_merge') ? 'classic-list-custom-nin-embed' : 'classic-list-embed'
    }));

});
parcelRegister("jVX4d", function(module, exports) {

$parcel$export(module.exports, "softwareListCustomEmbedClassicRoute", () => $33b99cc7997b9313$export$1273c580eb34bde5);
const $33b99cc7997b9313$export$1273c580eb34bde5 = {
    name: 'software-list-classic-custom-embed',
    path: '/jira/software/c/projects/:projectKey/list/:itemId/embed'
};

});


parcelRegister("5v5xs", function(module, exports) {

$parcel$export(module.exports, "softwareListCustomEmbedRouteEntry", () => $6144b1a1e33a7014$export$4387d360bb5b569b);

var $7K5Ea = parcelRequire("7K5Ea");

var $g8uYY = parcelRequire("g8uYY");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $k451s = parcelRequire("k451s");

var $5S55b = parcelRequire("5S55b");

var $7nbE3 = parcelRequire("7nbE3");

var $hFWLB = parcelRequire("hFWLB");

var $4VIcO = parcelRequire("4VIcO");

var $bQFhw = parcelRequire("bQFhw");

var $kSeQy = parcelRequire("kSeQy");

var $fYGKn = parcelRequire("fYGKn");

var $7jTnu = parcelRequire("7jTnu");

var $5EAnX = parcelRequire("5EAnX");
const $6144b1a1e33a7014$var$listEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $7nbE3.listEmbedEntryPoint)
});
const $6144b1a1e33a7014$export$4387d360bb5b569b = (0, $6xToB.createEntry)((0, $k451s.softwareListCustomEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $hFWLB.EmbedIssueNavigatorSkeleton) : (0, $5S55b.ListEmbedSkeleton),
        entryPoint () {
            if ((0, $7jTnu.fg)('jira_list_nin_merge')) return (0, $7jTnu.fg)('jira_nin_smart_link') ? (0, $fYGKn.issueNavigatorEmbedPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint);
            return $6144b1a1e33a7014$var$listEmbedPageEntrypoint;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: (0, $7jTnu.fg)('jira_list_nin_merge') ? [
            ...(0, $bQFhw.getCommonProjectResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ] : [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $5EAnX.getListProjectResources)()
        ],
        ufoName: (0, $7jTnu.fg)('jira_list_nin_merge') ? 'software-list-custom-nin-embed' : 'next-gen-list-embed'
    }));

});
parcelRegister("k451s", function(module, exports) {

$parcel$export(module.exports, "softwareListCustomEmbedRoute", () => $04f35509239ad479$export$2565ab956bab3afb);
const $04f35509239ad479$export$2565ab956bab3afb = {
    name: 'software-list-custom-embed',
    path: '/jira/software/projects/:projectKey/list/:itemId/embed'
};

});

parcelRegister("5EAnX", function(module, exports) {

$parcel$export(module.exports, "getListProjectResources", () => $63a87f99e1fe46e6$export$7bd00eef349a268a);

var $ebWJz = parcelRequire("ebWJz");

var $cV98p = parcelRequire("cV98p");

var $ebuR2 = parcelRequire("ebuR2");

var $ho9E1 = parcelRequire("ho9E1");
const $63a87f99e1fe46e6$export$7bd00eef349a268a = ()=>[
        (0, $ho9E1.projectCreatePermissionsResource),
        (0, $cV98p.navigationResource),
        // eslint-disable-next-line camelcase
        (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $ebWJz.fieldsResource)
    ];

});


parcelRegister("9vlCj", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedClassicRouteEntry", () => $2b73652cc806b11b$export$bdb096e193b6e97b);

var $6xToB = parcelRequire("6xToB");

var $2qTdf = parcelRequire("2qTdf");

var $5S55b = parcelRequire("5S55b");

var $7K5Ea = parcelRequire("7K5Ea");

var $ho9E1 = parcelRequire("ho9E1");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $ebWJz = parcelRequire("ebWJz");

var $eJe5A = parcelRequire("eJe5A");

var $cV98p = parcelRequire("cV98p");

var $ebuR2 = parcelRequire("ebuR2");

var $7jTnu = parcelRequire("7jTnu");


var $d4NVH = parcelRequire("d4NVH");

var $bQFhw = parcelRequire("bQFhw");

var $fYGKn = parcelRequire("fYGKn");

var $kSeQy = parcelRequire("kSeQy");

var $hFWLB = parcelRequire("hFWLB");

var $4a0D4 = parcelRequire("4a0D4");
const $2b73652cc806b11b$export$bdb096e193b6e97b = (0, $6xToB.createEntry)((0, $2qTdf.softwareListEmbedClassicRoute), ()=>({
        group: 'classic-software',
        meta: (0, $7jTnu.fg)('jira_list_nin_merge') ? {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        } : undefined,
        skeleton: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $hFWLB.EmbedIssueNavigatorSkeleton) : (0, $5S55b.ListEmbedSkeleton),
        entryPoint () {
            if ((0, $7jTnu.fg)('jira_list_nin_merge')) return (0, $7jTnu.fg)('jira_nin_smart_link') ? (0, $fYGKn.issueNavigatorEmbedPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint);
            return 0, $4a0D4.softwareListEmbedRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        // TODO: This is a copy of getProjectViewResources, but it has been copied in order to expand getNavigationSidebarProjectResource
        resources: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $bQFhw.getCommonProjectResources)() : [
            // the below 5 resources are copied from getBusinessProjectResources
            // they should be feature flagged and removed when it is safe to do so or
            // moved out of business packages
            // start getBusinessProjectResources
            (0, $ho9E1.projectCreatePermissionsResource),
            (0, $cV98p.navigationResource),
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            // end getBusinessProjectResources
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $ebWJz.fieldsResource)
        ],
        // eslint-disable-next-line jira/ff/no-preconditioning
        isHydrateRootEnabled: (0, $7jTnu.fg)('nin-full-page-hydrate-root') && (0, $7jTnu.fg)('jira_list_nin_merge'),
        afterPaint: (0, $7jTnu.fg)('jira_list_nin_merge') ? undefined : [
            (0, $eJe5A.LazyIssueApp)
        ],
        ufoName: (0, $7jTnu.fg)('jira_list_nin_merge') ? 'classic-list-nin-embed' : 'classic-list-embed'
    }));

});
parcelRegister("2qTdf", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedClassicRoute", () => $caddb762ada20d2e$export$de5fcecec40b3c98);
const $caddb762ada20d2e$export$de5fcecec40b3c98 = {
    name: 'software-list-classic-embed',
    path: '/jira/software/c/projects/:projectKey/list/embed'
};

});


parcelRegister("algSY", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedRouteEntry", () => $1034395cbcfb7fb6$export$1099e0e49394fa9a);

var $7K5Ea = parcelRequire("7K5Ea");

var $g8uYY = parcelRequire("g8uYY");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $jw1kr = parcelRequire("jw1kr");

var $5S55b = parcelRequire("5S55b");

var $7nbE3 = parcelRequire("7nbE3");

var $hFWLB = parcelRequire("hFWLB");

var $4VIcO = parcelRequire("4VIcO");

var $bQFhw = parcelRequire("bQFhw");

var $kSeQy = parcelRequire("kSeQy");

var $fYGKn = parcelRequire("fYGKn");

var $7jTnu = parcelRequire("7jTnu");

var $5EAnX = parcelRequire("5EAnX");
const $1034395cbcfb7fb6$var$listEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $7nbE3.listEmbedEntryPoint)
});
const $1034395cbcfb7fb6$export$1099e0e49394fa9a = (0, $6xToB.createEntry)((0, $jw1kr.softwareListEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $hFWLB.EmbedIssueNavigatorSkeleton) : (0, $5S55b.ListEmbedSkeleton),
        entryPoint () {
            if ((0, $7jTnu.fg)('jira_list_nin_merge')) return (0, $7jTnu.fg)('jira_nin_smart_link') ? (0, $fYGKn.issueNavigatorEmbedPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint);
            return $1034395cbcfb7fb6$var$listEmbedPageEntrypoint;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: (0, $7jTnu.fg)('jira_list_nin_merge') ? [
            ...(0, $bQFhw.getCommonProjectResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ] : [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $5EAnX.getListProjectResources)()
        ],
        ufoName: (0, $7jTnu.fg)('jira_list_nin_merge') ? 'software-list-nin-embed' : 'next-gen-list-embed'
    }));

});
parcelRegister("jw1kr", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedRoute", () => $ab3952bf527f58c5$export$70dd8df584442004);
const $ab3952bf527f58c5$export$70dd8df584442004 = {
    name: 'software-list-embed',
    path: '/jira/software/projects/:projectKey/list/embed'
};

});


parcelRegister("chmwv", function(module, exports) {

$parcel$export(module.exports, "softwareListRouteEntry", () => $664d587836ff333f$export$f30a66efa682bf2d);

var $g8uYY = parcelRequire("g8uYY");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $5UsLt = parcelRequire("5UsLt");

var $5S55b = parcelRequire("5S55b");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $iyUFz = parcelRequire("iyUFz");

var $9n5I0 = parcelRequire("9n5I0");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $7jTnu = parcelRequire("7jTnu");

var $gwH93 = parcelRequire("gwH93");


var $d4NVH = parcelRequire("d4NVH");

var $bQFhw = parcelRequire("bQFhw");

var $fYGKn = parcelRequire("fYGKn");

var $5EAnX = parcelRequire("5EAnX");
const $664d587836ff333f$var$listPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iyUFz.listEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $664d587836ff333f$export$f30a66efa682bf2d = (0, $6xToB.createEntry)((0, $5UsLt.softwareListRoute), ()=>({
        group: 'software',
        skeleton: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $gwH93.ProjectIssueNavigatorSkeleton) : (0, $5S55b.ListSkeleton),
        entryPoint () {
            return (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $fYGKn.issueNavigatorPageEntryPoint) : $664d587836ff333f$var$listPageEntrypoint;
        },
        meta: (0, $7jTnu.fg)('jira_list_nin_merge') ? {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        } : undefined,
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-list-entries/src/softwareListRouteEntry.tsx',
                whichExportToUse: 'softwareListRouteEntry'
            },
            manifestName: 'jira-spa-issue-navigator.json',
            enabled: true
        },
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: (0, $7jTnu.fg)('jira_list_nin_merge') ? (0, $bQFhw.getCommonProjectResources)() : [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5EAnX.getListProjectResources)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource))
        ],
        afterPaint: (0, $7jTnu.fg)('jira_list_nin_merge') ? undefined : [
            (0, $eJe5A.LazyIssueApp)
        ],
        ufoName: (0, $7jTnu.fg)('jira_list_nin_merge') ? 'software-list-nin' : 'next-gen-list',
        supportsPreviewPanel: true
    }));

});
parcelRegister("5UsLt", function(module, exports) {

$parcel$export(module.exports, "softwareListRoute", () => $b86fcd0eabaec86d$export$f3a5b1b732315e13);
const $b86fcd0eabaec86d$export$f3a5b1b732315e13 = {
    name: 'software-list',
    path: '/jira/software/projects/:projectKey/list/:itemId?'
};

});


parcelRegister("ilU7w", function(module, exports) {

$parcel$export(module.exports, "softwareNextgenRedirectRouteEntry", () => $5d875391cc80dcd3$export$e328d22412aeb5cf);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dUnSO = parcelRequire("dUnSO");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $2mHfh = parcelRequire("2mHfh");

var $gzcjr = parcelRequire("gzcjr");

var $2dJFW = parcelRequire("2dJFW");

var $jmnFB = parcelRequire("jmnFB");
const $5d875391cc80dcd3$var$SoftwareNextgenRedirectComponent = ({ location: location })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: (0, $jmnFB.pickNextGenView)(location)
    });

const $5d875391cc80dcd3$var$LazyBoardPage = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4kmpi"))), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
});
const $5d875391cc80dcd3$export$e328d22412aeb5cf = (0, $6xToB.createEntry)((0, $dUnSO.softwareNextgenRedirectRoute), ()=>({
        group: 'software',
        component: $5d875391cc80dcd3$var$SoftwareNextgenRedirectComponent,
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $5d875391cc80dcd3$var$LazyBoardPage
        ]
    }));

});
parcelRegister("dUnSO", function(module, exports) {

$parcel$export(module.exports, "softwareNextgenRedirectRoute", () => $72f8b419477b36bd$export$6072946fe7f2d45a);
const $72f8b419477b36bd$export$6072946fe7f2d45a = {
    name: 'software-nextgen-redirect',
    path: '/secure/NextGen.jspa'
};

});

parcelRegister("jmnFB", function(module, exports) {

$parcel$export(module.exports, "pickNextGenView", () => $cec8248a7320298f$export$8c47088cd9b527ba);

var $b5RwB = parcelRequire("b5RwB");
const $cec8248a7320298f$var$PLAN = 'planning';
const $cec8248a7320298f$var$REPORTING = 'reporting';
const $cec8248a7320298f$var$REPORTS = 'reports';
const $cec8248a7320298f$var$constructUrlForView = (url, view, searchResult)=>{
    if (view.startsWith($cec8248a7320298f$var$PLAN)) return `${url}/backlog`;
    if (view.startsWith($cec8248a7320298f$var$REPORTING) || view.startsWith($cec8248a7320298f$var$REPORTS)) {
        if (searchResult.report) return `${url}/reports/${searchResult.report}`;
        return `${url}/reports`;
    }
    return url;
};
const $cec8248a7320298f$var$KNOWN_KEYS = [
    'rapidView',
    'projectKey',
    'view',
    'report'
];
const $cec8248a7320298f$var$forwardUnknownQueryParams = (url, queryParams)=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(Object.entries(queryParams).filter(([k])=>!$cec8248a7320298f$var$KNOWN_KEYS.includes(k)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, [k, v])=>({
            [k]: v,
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result
        }), {}));
    if (query) return `${url}?${query}`;
    return url;
};
const $cec8248a7320298f$export$8c47088cd9b527ba = (location)=>{
    const searchResult = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(location.search);
    const url = `/jira/software/projects/${searchResult.projectKey}/boards/${searchResult.rapidView}`;
    if (searchResult.view) return $cec8248a7320298f$var$forwardUnknownQueryParams($cec8248a7320298f$var$constructUrlForView(url, searchResult.view, searchResult), searchResult);
    return $cec8248a7320298f$var$forwardUnknownQueryParams(url, searchResult);
};

});


parcelRegister("1DVzF", function(module, exports) {

$parcel$export(module.exports, "softwareOnboardingRouteEntry", () => $a98ae10c4a769c67$export$bb72a943d2340466);

var $7jTnu = parcelRequire("7jTnu");

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $a0jfQ = parcelRequire("a0jfQ");

var $cxQGT = parcelRequire("cxQGT");

var $ghDQJ = parcelRequire("ghDQJ");

var $ho9E1 = parcelRequire("ho9E1");

var $5L7qx = parcelRequire("5L7qx");

var $7GmqV = parcelRequire("7GmqV");
const $a98ae10c4a769c67$export$bb72a943d2340466 = (0, $6xToB.createEntry)((0, $ghDQJ.softwareOnboardingRoute), ()=>({
        group: 'software',
        component: (0, $7GmqV.SoftwareOnboardingPage),
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $a0jfQ.jswOnboardingResource),
            (0, $cxQGT.themePreferenceResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('onboarding_get_create_project_permission'), (0, $ho9E1.projectCreatePermissionsResource))
        ],
        forPaint: [
            (0, $7GmqV.LazySoftwareOnboardingPage)
        ],
        canTransitionIn: ()=>false
    }));

});
parcelRegister("a0jfQ", function(module, exports) {

$parcel$export(module.exports, "jswOnboardingResource", () => $0f3f44fb824b4a6b$export$be21a2d8a350a80);
$parcel$export(module.exports, "useJswOnboardingResource", () => $0f3f44fb824b4a6b$export$83f546a45ad58d0a);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $0f3f44fb824b4a6b$export$be21a2d8a350a80 = (0, $l1VxS.createResource)({
    type: (0, $550128173520f259$export$692203fca66f4d77),
    getKey: ()=>'jsw_onboarding',
    getDataLoader: ()=>(parcelRequire("kkuEO"))
});
const $0f3f44fb824b4a6b$export$83f546a45ad58d0a = ()=>(0, $eJrcF.useResource)($0f3f44fb824b4a6b$export$be21a2d8a350a80);

});
const $550128173520f259$export$692203fca66f4d77 = 'RESOURCE_TYPE_SOFTWARE_ONBOARDING';

parcelRegister("kkuEO", function(module, exports) {

let $eccd74c9065a1195$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $eccd74c9065a1195$var$load("9YMrH").then(()=>parcelRequire('3u0fx'));

});


parcelRegister("ghDQJ", function(module, exports) {

$parcel$export(module.exports, "softwareOnboardingRoute", () => $288e5ff1ef6a8f93$export$5e6c92d2f34c1e48);
const $288e5ff1ef6a8f93$export$5e6c92d2f34c1e48 = {
    name: 'software-onboarding',
    path: '/welcome/software',
    exact: true
};

});

parcelRegister("7GmqV", function(module, exports) {

$parcel$export(module.exports, "LazySoftwareOnboardingPage", () => $b08568a458389499$export$31e9f06d3389e445);
$parcel$export(module.exports, "SoftwareOnboardingPage", () => $b08568a458389499$export$ee768d69c6e3a8bd);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $b08568a458389499$export$31e9f06d3389e445 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("6ioYo"))), {
    moduleId: "./src/packages/spa-apps/software/onboarding/src/index.tsx"
});
const $b08568a458389499$export$ee768d69c6e3a8bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $b08568a458389499$export$31e9f06d3389e445,
        pageId: "software-onboarding",
        shouldShowSpinner: false
    });

});
parcelRegister("6ioYo", function(module, exports) {

let $4957cba12f6bc6dd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $4957cba12f6bc6dd$var$load("7vqGd"),
    $4957cba12f6bc6dd$var$load("1Y4bq"),
    $4957cba12f6bc6dd$var$load("dFBmQ")
]).then(()=>parcelRequire('jrWYq'));

});



parcelRegister("7ccps", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeClassicRouteEntry", () => $abbad57df163322a$export$d7d49c1a51b3c0a9);

var $7mF43 = parcelRequire("7mF43");

var $igNUx = parcelRequire("igNUx");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $ihgGc = parcelRequire("ihgGc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8Duuj = parcelRequire("8Duuj");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $kSeQy = parcelRequire("kSeQy");

var $lb6FK = parcelRequire("lb6FK");

var $7jTnu = parcelRequire("7jTnu");

var $iQ6xi = parcelRequire("iQ6xi");
const $abbad57df163322a$export$d7d49c1a51b3c0a9 = (0, $6xToB.createEntry)((0, $8Duuj.softwarePeriscopeClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $ihgGc.Skeleton),
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $lb6FK.rovoEntitlementResource)
        ],
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        entryPoint: ()=>{
            if ((0, $igNUx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $iQ6xi.periscopeEntryPoint) : (0, $iQ6xi.periscopeEntryPointOld);
        },
        meta: {
            reporting: {
                id: 'software-periscope-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-periscope-classic'),
                teamName: 'jolt'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("ihgGc", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $6dd3ea49a6940f01$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "InsightsSkeleton", () => $6dd3ea49a6940f01$export$dd0b74c715df3275);
$parcel$export(module.exports, "SuggestionsSkeleton", () => $6dd3ea49a6940f01$export$91f27b306afd627b);
$parcel$export(module.exports, "WorkItemsSkeleton", () => $6dd3ea49a6940f01$export$1660f3159b79b22b);
$parcel$export(module.exports, "WorkItemsVulnTabSkeleton", () => $6dd3ea49a6940f01$export$5aea7d4ed03d6ea6);
$parcel$export(module.exports, "WorkItemsDeploymentTabSkeleton", () => $6dd3ea49a6940f01$export$ff38ee81427877e9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $dhRXV = parcelRequire("dhRXV");
var $gPqEA = parcelRequire("gPqEA");

var $lRq8t = parcelRequire("lRq8t");

var $bq5gY = parcelRequire("bq5gY");

var $6snra = parcelRequire("6snra");
const $6dd3ea49a6940f01$var$styles = {
    mainContainer: "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _1e0c1txw _vchhusvi",
    leftColumn: "_16jlcs5v _1o9zkb7n _i0dlf1ug",
    rightColumn: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    suggestionsContainer: "_1reo15vq _18m915vq _1bsb1osq _4t3istmo _vchhusvi",
    insightsContainer: "_1reo15vq _18m915vq _1bsb1osq _4t3i1iym _vchhusvi",
    workItemsContainer: "_1reo15vq _18m915vq _1bsb1osq _4t3i1ogm _vchhusvi",
    workItemsVulnTabContainer: "_1reo15vq _18m915vq _1bsb1osq _4t3i1pna _vchhusvi"
};
const $6dd3ea49a6940f01$export$8f31e4c4a37b8e9c = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPqEA.default), {
        xcss: $6dd3ea49a6940f01$var$styles.mainContainer,
        "data-testId": "software-periscope-periscope-page.ui.loading",
        "aria-label": formatMessage((0, $6snra.default).label),
        gap: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPqEA.default), {
        xcss: $6dd3ea49a6940f01$var$styles.leftColumn,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $6dd3ea49a6940f01$var$styles.insightsContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.PeriscopeInsightsSkeleton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $6dd3ea49a6940f01$var$styles.workItemsContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.PeriscopeWorkItemsSkeleton), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPqEA.default), {
        xcss: $6dd3ea49a6940f01$var$styles.rightColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $6dd3ea49a6940f01$var$styles.suggestionsContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.PeriscopeSuggestionsSkeleton), null))));
};
const $6dd3ea49a6940f01$export$dd0b74c715df3275 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $6dd3ea49a6940f01$var$styles.insightsContainer,
        "data-testId": "software-periscope-periscope-page.insights-ui.loading",
        "aria-label": formatMessage((0, $6snra.default).insightsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.PeriscopeInsightsSkeleton), null));
};
const $6dd3ea49a6940f01$export$91f27b306afd627b = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $6dd3ea49a6940f01$var$styles.suggestionsContainer,
        "data-testId": "software-periscope-periscope-page.suggestions-ui.loading",
        "aria-label": formatMessage((0, $6snra.default).suggestionsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.PeriscopeSuggestionsSkeleton), null));
}; // Extend this for loading screen
const $6dd3ea49a6940f01$export$1660f3159b79b22b = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $6dd3ea49a6940f01$var$styles.workItemsContainer,
        "aria-label": formatMessage((0, $6snra.default).workItemsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.PeriscopeWorkItemsSkeleton), null));
};
const $6dd3ea49a6940f01$export$5aea7d4ed03d6ea6 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $6dd3ea49a6940f01$var$styles.workItemsVulnTabContainer,
        "aria-label": formatMessage((0, $6snra.default).workItemsVulnTabLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.DevelopmentPageWorkItemsVulnTabSkeleton), null));
};
const $6dd3ea49a6940f01$export$ff38ee81427877e9 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        xcss: $6dd3ea49a6940f01$var$styles.workItemsContainer,
        "aria-label": formatMessage((0, $6snra.default).workItemsDeploymentTabLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.DevelopmentPageWorkItemsDeploymentTabSkeleton), null));
};

});
parcelRegister("bq5gY", function(module, exports) {

$parcel$export(module.exports, "PeriscopeSuggestionsSkeleton", () => $21284f9e6dec4f7d$export$176dfe4c14771136);
$parcel$export(module.exports, "PeriscopeInsightsSkeleton", () => $21284f9e6dec4f7d$export$afb44f298901be44);
$parcel$export(module.exports, "PeriscopeWorkItemsSkeleton", () => $21284f9e6dec4f7d$export$298a6b6a251923c2);
$parcel$export(module.exports, "DevelopmentPageWorkItemsVulnTabSkeleton", () => $21284f9e6dec4f7d$export$8940e0b80e4066d6);
$parcel$export(module.exports, "DevelopmentPageWorkItemsDeploymentTabSkeleton", () => $21284f9e6dec4f7d$export$2f5ed71a7df2d4e6);
$parcel$export(module.exports, "DevelopmentPageCodeAgentsTabSkeleton", () => $21284f9e6dec4f7d$export$e3f7fac0f7e53296);
/* PeriscopeSuggestionsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $wgo5W = parcelRequire("wgo5W");

var $c0DTX = parcelRequire("c0DTX");

var $azeIm = parcelRequire("azeIm");

var $ik1tL = parcelRequire("ik1tL");

var $lV0UB = parcelRequire("lV0UB");

var $54e6S = parcelRequire("54e6S");

var $cGkWv = parcelRequire("cGkWv");

var $hRkYx = parcelRequire("hRkYx");
const $21284f9e6dec4f7d$var$PeriscopePageSkeletonStyles = null;
const $21284f9e6dec4f7d$export$4aecc030c4d69f74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-skeleton-image-periscope-page-new",
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ik1tL)))
    }));
const $21284f9e6dec4f7d$export$176dfe4c14771136 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-suggestions-skeleton",
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lV0UB)))
    }));
const $21284f9e6dec4f7d$export$afb44f298901be44 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-insights-skeleton",
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c0DTX)))
    }));
const $21284f9e6dec4f7d$export$298a6b6a251923c2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cGkWv)))
    }));
const $21284f9e6dec4f7d$export$8940e0b80e4066d6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($54e6S)))
    }));
const $21284f9e6dec4f7d$export$2f5ed71a7df2d4e6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($wgo5W)))
    }));
const $21284f9e6dec4f7d$export$e70f5fa3451855e2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-on-call-panel-skeleton",
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($azeIm)))
    }));
const $21284f9e6dec4f7d$export$e3f7fac0f7e53296 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.code-agents-tab-skeleton",
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hRkYx)))
    }));

});
parcelRegister("wgo5W", function(module, exports) {
module.exports = new URL("deployment-tab-skeleton.tpl.6442d1f9.svg", import.meta.url).toString();

});

parcelRegister("c0DTX", function(module, exports) {
module.exports = new URL("insights.tpl.c29b665e.svg", import.meta.url).toString();

});

parcelRegister("azeIm", function(module, exports) {
module.exports = new URL("on-call-panel-skeleton.tpl.d7139b03.svg", import.meta.url).toString();

});

parcelRegister("ik1tL", function(module, exports) {
module.exports = new URL("periscope-page-full-layout.tpl.762dcdba.svg", import.meta.url).toString();

});

parcelRegister("lV0UB", function(module, exports) {
module.exports = new URL("suggestions.tpl.52cb06d0.svg", import.meta.url).toString();

});

parcelRegister("54e6S", function(module, exports) {
module.exports = new URL("vuln-tab-skeleton.tpl.1a18ea24.svg", import.meta.url).toString();

});

parcelRegister("cGkWv", function(module, exports) {
module.exports = new URL("work-items.tpl.4ee9e4f3.svg", import.meta.url).toString();

});

parcelRegister("hRkYx", function(module, exports) {
module.exports = new URL("code-agents-tab-skeleton.tpl.874ad579.svg", import.meta.url).toString();

});


parcelRegister("6snra", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1f4839c9651f4bd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c1f4839c9651f4bd$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    label: {
        "id": "periscope.skeleton.label",
        "defaultMessage": "Loading"
    },
    suggestionsLabel: {
        "id": "periscope.suggestions-skeleton.label",
        "defaultMessage": "Suggestions loading"
    },
    insightsLabel: {
        "id": "periscope.insights-skeleton.label",
        "defaultMessage": "Developer insights loading"
    },
    workItemsLabel: {
        "id": "periscope.work-items-skeleton.work-items-label",
        "defaultMessage": "Work items loading"
    },
    workItemsVulnTabLabel: {
        "id": "periscope.work-items-skeleton.work-items-vuln-tab-label",
        "defaultMessage": "Work items vulnerability tab loading"
    },
    workItemsDeploymentTabLabel: {
        "id": "periscope.work-items-skeleton.work-items-deployment-tab-label",
        "defaultMessage": "Work items deployment tab loading"
    },
    onCallPanelLabel: {
        "id": "periscope.on-call-skeleton.label",
        "defaultMessage": "On call panel loading"
    }
});

});


parcelRegister("8Duuj", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeClassicRoute", () => $b296b78af627ca8d$export$cb5cec74f302b3c6);
const $b296b78af627ca8d$export$cb5cec74f302b3c6 = {
    name: 'software-periscope-classic',
    path: '/jira/software/c/projects/:projectKey/development'
};

});

parcelRegister("iQ6xi", function(module, exports) {

$parcel$export(module.exports, "periscopeEntryPointOld", () => $8713fae315175651$export$22d8ad69d1439a09);
$parcel$export(module.exports, "periscopeEntryPoint", () => $8713fae315175651$export$5a8cf468a1d46d4);

var $5Z0i1 = parcelRequire("5Z0i1");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $8713fae315175651$export$22d8ad69d1439a09 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $5Z0i1.periscopeEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $8713fae315175651$export$5a8cf468a1d46d4 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $5Z0i1.periscopeEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("5Z0i1", function(module, exports) {

$parcel$export(module.exports, "periscopeEntrypoint", () => $9542f40912d211bc$export$89ba9048c6fd23c6);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $9542f40912d211bc$export$89ba9048c6fd23c6 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("daqEJ")), {
        moduleId: "11456a6c",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("daqEJ", function(module, exports) {

let $9960e2dbd37ad288$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $9960e2dbd37ad288$var$load("1VRB2"),
    $9960e2dbd37ad288$var$load("bABhq"),
    $9960e2dbd37ad288$var$load("eDzss"),
    $9960e2dbd37ad288$var$load("7EBG7")
]).then(()=>parcelRequire('jRIB1'));

});




parcelRegister("1Pj99", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeNextGenRouteEntry", () => $f6c1a3e1213b5a6a$export$7db4d910357a4d89);

var $7mF43 = parcelRequire("7mF43");

var $igNUx = parcelRequire("igNUx");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $ihgGc = parcelRequire("ihgGc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $5Gd4r = parcelRequire("5Gd4r");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $kSeQy = parcelRequire("kSeQy");

var $lb6FK = parcelRequire("lb6FK");

var $iQ6xi = parcelRequire("iQ6xi");
const $f6c1a3e1213b5a6a$export$7db4d910357a4d89 = (0, $6xToB.createEntry)((0, $5Gd4r.softwarePeriscopeNextGenRoute), ()=>({
        group: 'software',
        skeleton: (0, $ihgGc.Skeleton),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $lb6FK.rovoEntitlementResource)
        ],
        entryPoint: ()=>{
            return (0, $igNUx.isFedRamp)() ? (0, $kSeQy.notFoundPageEntrypoint) : (0, $iQ6xi.periscopeEntryPoint);
        },
        meta: {
            reporting: {
                id: 'software-periscope',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-periscope'),
                teamName: 'jolt'
            }
        }
    }));

});
parcelRegister("5Gd4r", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeNextGenRoute", () => $6eacf1339da179d9$export$9d0f329211395c25);
const $6eacf1339da179d9$export$9d0f329211395c25 = {
    name: 'software-periscope',
    path: '/jira/software/projects/:projectKey/development'
};

});


parcelRegister("ff5dM", function(module, exports) {

$parcel$export(module.exports, "softwarePlanCalendarRouteEntry", () => $8ea2ef86e0348cc9$export$67c64fea9be584ed);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");


var $k8mcw = parcelRequire("k8mcw");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $18dXS = parcelRequire("18dXS");

var $dsh9d = parcelRequire("dsh9d");

var $5C8kQ = parcelRequire("5C8kQ");
const $8ea2ef86e0348cc9$export$67c64fea9be584ed = (0, $6xToB.createEntry)((0, $18dXS.softwarePlanCalendarRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-calendar',
        skeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dsh9d.CalendarSkeleton), null),
        entryPoint () {
            (0, $k8mcw.setCapability)((0, $652f5f63189f3e2a$export$f999749ac7a2cd1));
            return 0, $5C8kQ.planCalendarPageEntryPoint;
        },
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        meta: {
            capability: (0, $652f5f63189f3e2a$export$f999749ac7a2cd1)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("18dXS", function(module, exports) {

$parcel$export(module.exports, "softwarePlanCalendarRoute", () => $8b0145615736bea4$export$ca4c39d60ec156a2);
const $8b0145615736bea4$export$ca4c39d60ec156a2 = {
    name: 'software-plan-calendar',
    path: '/jira/plans/:planId/scenarios/:scenarioId/calendar'
};

});

parcelRegister("5C8kQ", function(module, exports) {

$parcel$export(module.exports, "planCalendarPageEntryPoint", () => $c6647949b071ac81$export$6e8a1c5de1f63c61);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $i9Kzd = parcelRequire("i9Kzd");

var $dGTIT = parcelRequire("dGTIT");
const $c6647949b071ac81$export$6e8a1c5de1f63c61 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $i9Kzd.calendarEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint)
});

});


parcelRegister("aLXiu", function(module, exports) {

$parcel$export(module.exports, "softwarePlanDependenciesRouteEntry", () => $7c3bee9d98118448$export$103062f08086fba0);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $6DfBR = parcelRequire("6DfBR");

var $7jTnu = parcelRequire("7jTnu");

var $bNk7b = parcelRequire("bNk7b");

var $2WqIS = parcelRequire("2WqIS");
const $7c3bee9d98118448$export$103062f08086fba0 = (0, $6xToB.createEntry)((0, $6DfBR.softwarePlanDependenciesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $7jTnu.fg)('migrate_plans_to_entrypoints') ? (0, $2WqIS.planDependenciesReportPageEntryPoint) : undefined,
        component: (0, $bNk7b.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bNk7b.LazyPlanDependenciesReport)
        ]
    }));

});
parcelRegister("6DfBR", function(module, exports) {

$parcel$export(module.exports, "softwarePlanDependenciesRoute", () => $3d92c2ce628de7b9$export$ad8296aa5394f696);
const $3d92c2ce628de7b9$export$ad8296aa5394f696 = {
    name: 'software-plan-dependencies',
    path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies'
};

});

parcelRegister("bNk7b", function(module, exports) {

$parcel$export(module.exports, "LazyPlanDependenciesReport", () => $8b7896f3a2fbf85d$export$d4669c7a2f17c261);
$parcel$export(module.exports, "default", () => $8b7896f3a2fbf85d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $8b7896f3a2fbf85d$export$d4669c7a2f17c261 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("1TpUQ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8b7896f3a2fbf85d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8b7896f3a2fbf85d$export$d4669c7a2f17c261,
        pageId: "plan-dependencies-report",
        shouldShowSpinner: true
    });

});

parcelRegister("2WqIS", function(module, exports) {

$parcel$export(module.exports, "planDependenciesReportPageEntryPoint", () => $04f834ad566e4087$export$1d873335adb647af);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $3nt6g = parcelRequire("3nt6g");

var $dGTIT = parcelRequire("dGTIT");
const $04f834ad566e4087$export$1d873335adb647af = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $3nt6g.planDependenciesReportEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint)
});

});


parcelRegister("kHsPZ", function(module, exports) {

$parcel$export(module.exports, "softwarePlanReleasesRouteEntry", () => $ae86115cee0664c5$export$b874fabd66f10ff4);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $k4JTJ = parcelRequire("k4JTJ");

var $7jTnu = parcelRequire("7jTnu");

var $awsZY = parcelRequire("awsZY");

var $iHLLP = parcelRequire("iHLLP");
const $ae86115cee0664c5$export$b874fabd66f10ff4 = (0, $6xToB.createEntry)((0, $k4JTJ.softwarePlanReleasesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $7jTnu.fg)('migrate_plans_to_entrypoints') ? (0, $iHLLP.planReleasesPageEntryPoint) : undefined,
        component: (0, $awsZY.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $awsZY.LazyPlanReleases)
        ]
    }));

});
parcelRegister("k4JTJ", function(module, exports) {

$parcel$export(module.exports, "softwarePlanReleasesRoute", () => $d1e7a57f049a4400$export$850236b64b0aa28b);
const $d1e7a57f049a4400$export$850236b64b0aa28b = {
    name: 'software-plan-releases',
    path: '/jira/plans/:planId/scenarios/:scenarioId/releases'
};

});

parcelRegister("awsZY", function(module, exports) {

$parcel$export(module.exports, "LazyPlanReleases", () => $88a9c1780c47d6b1$export$749f5d2513e04ec0);
$parcel$export(module.exports, "default", () => $88a9c1780c47d6b1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $88a9c1780c47d6b1$export$749f5d2513e04ec0 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3g9QL"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-releases/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$88a9c1780c47d6b1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $88a9c1780c47d6b1$export$749f5d2513e04ec0,
        pageId: "plan-releases",
        shouldShowSpinner: true
    });

});
parcelRegister("3g9QL", function(module, exports) {

let $25fa81b8ade770af$var$load = (parcelRequire("gLHA4"))(4);





module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $25fa81b8ade770af$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $25fa81b8ade770af$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $25fa81b8ade770af$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $25fa81b8ade770af$var$load("kZxiU")
        ]);
    }),
    $25fa81b8ade770af$var$load("7vqGd"),
    $25fa81b8ade770af$var$load("1Y4bq"),
    $25fa81b8ade770af$var$load("1VRB2"),
    $25fa81b8ade770af$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("1d25A"), 4)),
    $25fa81b8ade770af$var$load("eDzss"),
    $25fa81b8ade770af$var$load("4IS8t")
]).then(()=>parcelRequire('kR6P1'));

});


parcelRegister("iHLLP", function(module, exports) {

$parcel$export(module.exports, "planReleasesPageEntryPoint", () => $9e9f8fc1cf847fdb$export$accb0033190d648e);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $a7imf = parcelRequire("a7imf");

var $dGTIT = parcelRequire("dGTIT");
const $9e9f8fc1cf847fdb$export$accb0033190d648e = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $a7imf.planReleasesEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint)
});

});
parcelRegister("a7imf", function(module, exports) {

$parcel$export(module.exports, "planReleasesEntryPoint", () => $87c1d93c31895bf7$export$4e18896acd7f3236);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $87c1d93c31895bf7$export$4e18896acd7f3236 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("7RjfA")), {
        moduleId: "e3e1145d",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7RjfA", function(module, exports) {

let $5b8c6a5dce5c93b0$var$load = (parcelRequire("gLHA4"))(4);





module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $5b8c6a5dce5c93b0$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $5b8c6a5dce5c93b0$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $5b8c6a5dce5c93b0$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $5b8c6a5dce5c93b0$var$load("kZxiU")
        ]);
    }),
    $5b8c6a5dce5c93b0$var$load("7vqGd"),
    $5b8c6a5dce5c93b0$var$load("1Y4bq"),
    $5b8c6a5dce5c93b0$var$load("1VRB2"),
    $5b8c6a5dce5c93b0$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("lbw16"), 4)),
    $5b8c6a5dce5c93b0$var$load("eDzss"),
    $5b8c6a5dce5c93b0$var$load("9mFM9")
]).then(()=>parcelRequire('2IyKF'));

});




parcelRegister("30PHd", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsAutoSchedulerRouteEntry", () => $ebe2d9db7034294d$export$fc7007717398c727);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $eJBj5 = parcelRequire("eJBj5");

var $7AOfB = parcelRequire("7AOfB");
const $ebe2d9db7034294d$export$fc7007717398c727 = (0, $6xToB.createEntry)((0, $eJBj5.softwarePlanSettingsAutoSchedulerRoute), ()=>({
        group: 'software',
        component: (0, $7AOfB.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7AOfB.LazyPlanSettingsAutoScheduler)
        ]
    }));

});
parcelRegister("eJBj5", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsAutoSchedulerRoute", () => $bf574ac126f3c13e$export$e44088b2cc0206cf);
const $bf574ac126f3c13e$export$e44088b2cc0206cf = {
    name: 'plan-settings-auto-scheduler',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/auto-scheduler'
};

});

parcelRegister("7AOfB", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsAutoScheduler", () => $96272ebfe2b6bb42$export$8bcf7155849993f5);
$parcel$export(module.exports, "default", () => $96272ebfe2b6bb42$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $96272ebfe2b6bb42$export$8bcf7155849993f5 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("hqyHH"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/auto-scheduler/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$96272ebfe2b6bb42$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $96272ebfe2b6bb42$export$8bcf7155849993f5,
        pageId: "plan-settings-auto-scheduler",
        shouldShowSpinner: true
    });

});
parcelRegister("hqyHH", function(module, exports) {

let $caffc8d9ddee80e7$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("akOSC"), 4)),
    $caffc8d9ddee80e7$var$load("gtT1C")
]).then(()=>parcelRequire('aIwYI'));

});



parcelRegister("aGFMx", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsCustomFieldsRouteEntry", () => $a3f3b097c6b64180$export$89472d9db6946668);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $hoP2D = parcelRequire("hoP2D");

var $hYyEK = parcelRequire("hYyEK");
const $a3f3b097c6b64180$export$89472d9db6946668 = (0, $6xToB.createEntry)((0, $hoP2D.softwarePlanSettingsCustomFieldsRoute), ()=>({
        group: 'software',
        component: (0, $hYyEK.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $hYyEK.LazyPlanSettingsCustomFields)
        ]
    }));

});
parcelRegister("hoP2D", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsCustomFieldsRoute", () => $ce6b53953112c5de$export$2634cd63c73f7a35);
const $ce6b53953112c5de$export$2634cd63c73f7a35 = {
    name: 'plan-settings-custom-fields',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/custom-fields'
};

});

parcelRegister("hYyEK", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsCustomFields", () => $500352ce4889d822$export$72bf44dbae2383e5);
$parcel$export(module.exports, "default", () => $500352ce4889d822$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $500352ce4889d822$export$72bf44dbae2383e5 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("g1rWJ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/custom-fields/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$500352ce4889d822$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $500352ce4889d822$export$72bf44dbae2383e5,
        pageId: "plan-settings-custom-fields",
        shouldShowSpinner: true
    });

});
parcelRegister("g1rWJ", function(module, exports) {

let $baa26ae972788e1c$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    $baa26ae972788e1c$var$load("1VRB2"),
    $baa26ae972788e1c$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("6xfdp"), 4)),
    $baa26ae972788e1c$var$load("4UOoE")
]).then(()=>parcelRequire('hk4tW'));

});



parcelRegister("fFZgu", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsExclusionRulesRouteEntry", () => $265bba88c56b1ffd$export$cd1b612d0c014154);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $jjFZG = parcelRequire("jjFZG");

var $edgkW = parcelRequire("edgkW");
const $265bba88c56b1ffd$export$cd1b612d0c014154 = (0, $6xToB.createEntry)((0, $jjFZG.softwarePlanSettingsExclusionRulesRoute), ()=>({
        group: 'software',
        component: (0, $edgkW.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $edgkW.LazyPlanSettingsExclusionRules)
        ]
    }));

});
parcelRegister("jjFZG", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsExclusionRulesRoute", () => $0e7e623baf5dec5c$export$358b0ca69a4bd731);
const $0e7e623baf5dec5c$export$358b0ca69a4bd731 = {
    name: 'plan-settings-exclusion-rules',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/exclusion-rules'
};

});

parcelRegister("edgkW", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsExclusionRules", () => $c9345d7804a4ef5d$export$78f61b03c267e6d9);
$parcel$export(module.exports, "default", () => $c9345d7804a4ef5d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $c9345d7804a4ef5d$export$78f61b03c267e6d9 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ljoVf"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/exclusion-rules/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c9345d7804a4ef5d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c9345d7804a4ef5d$export$78f61b03c267e6d9,
        pageId: "plan-settings-exclusion-rules",
        shouldShowSpinner: true
    });

});
parcelRegister("ljoVf", function(module, exports) {

let $f83eb465d4110479$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("3deuD"), 4)),
    $f83eb465d4110479$var$load("3i979")
]).then(()=>parcelRequire('jIXzu'));

});



parcelRegister("hAVk6", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFeaturesRouteEntry", () => $89f75d6f39c73a44$export$591e778de9bccacd);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $epTsa = parcelRequire("epTsa");

var $3jB8o = parcelRequire("3jB8o");

var $1S3r8 = parcelRequire("1S3r8");
const $89f75d6f39c73a44$export$591e778de9bccacd = (0, $6xToB.createEntry)((0, $3jB8o.softwarePlanSettingsFeaturesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $epTsa.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? (0, $1S3r8.planSettingsFeaturesRouteEntry) : undefined,
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("3jB8o", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFeaturesRoute", () => $758ef62398fd6fce$export$2e79af7413eb4921);
const $758ef62398fd6fce$export$2e79af7413eb4921 = {
    name: 'plan-settings-features',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/features'
};

});

parcelRegister("1S3r8", function(module, exports) {

$parcel$export(module.exports, "planSettingsFeaturesRouteEntry", () => $a09cd3e6d9fa9196$export$2cf26c8369ef29cd);

var $g8uYY = parcelRequire("g8uYY");

var $9GNeY = parcelRequire("9GNeY");

var $5RW99 = parcelRequire("5RW99");
const $a09cd3e6d9fa9196$export$2cf26c8369ef29cd = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9GNeY.planSettingsFeaturesEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS
});

});
parcelRegister("9GNeY", function(module, exports) {

$parcel$export(module.exports, "planSettingsFeaturesEntryPoint", () => $5074ac9e656339bd$export$ae1839f07bffa153);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $eozQK = parcelRequire("eozQK");

const $5074ac9e656339bd$export$ae1839f07bffa153 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("772JH")), {
        moduleId: "3d5245c7",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointParams)=>{
        return {
            entryPoints: {
                preLoadFeaturesEntryPoint: {
                    entryPoint: (0, $eozQK.featuresEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
    }
});

});
parcelRegister("eozQK", function(module, exports) {

$parcel$export(module.exports, "featuresEntryPoint", () => $2ef2594cc5316609$export$e283e7092d12783d);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

var $bvWVK = parcelRequire("bvWVK");

var $7jTnu = parcelRequire("7jTnu");
const $2ef2594cc5316609$var$toPlanAri = ({ siteId: siteId, activationId: activationId, planId: planId })=>{
    return `ari:cloud:jira:${siteId}:plan/activation/${activationId}/${planId}`;
};

const $2ef2594cc5316609$export$e283e7092d12783d = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("8q98q")), {
        moduleId: "2bffebe5",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: tenantContext })=>{
        return {
            queries: {
                plan: {
                    variables: {
                        planId: $2ef2594cc5316609$var$toPlanAri({
                            siteId: tenantContext.cloudId,
                            activationId: tenantContext.activationId,
                            planId: String(match.params.planId)
                        }),
                        releasesFeatureGateEnabled: (0, $7jTnu.fg)('simple-plans-m2-release-feature-toggle'),
                        planSettingRefreshEnabled: (0, $7jTnu.fg)('plan_settings_refresh')
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $bvWVK.default
                }
            }
        };
    }
});

});
parcelRegister("bvWVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $149737881f2fbdc9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7ba327901bde6343f0f8977263495a61>>
 * @relayHash 3005ddf30678cbf39055c070ff7f15ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e5b4e28fbfa841edf74d46388681eb22eb60b2c617054dc398ec9b08607cea
const $149737881f2fbdc9$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "44e5b4e28fbfa841edf74d46388681eb22eb60b2c617054dc398ec9b08607cea",
        "metadata": {},
        "name": "uiFeaturesPlansSettingsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $149737881f2fbdc9$export$2e2bcd8739ae039 = $149737881f2fbdc9$var$node;

});

parcelRegister("8q98q", function(module, exports) {

let $6217d67336fede6d$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("hyWP2"), 4)),
    $6217d67336fede6d$var$load("dcnIy")
]).then(()=>parcelRequire('j5C3s'));

});


parcelRegister("772JH", function(module, exports) {

let $52db4f2e808b23ff$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("1JYiB"), 4)),
    $52db4f2e808b23ff$var$load("hHgmj")
]).then(()=>parcelRequire('4POhN'));

});




parcelRegister("72a1U", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFindYourIssueRouteEntry", () => $07600df33fa9e5d1$export$2f975c505121e139);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $8gYxy = parcelRequire("8gYxy");

var $lNE5T = parcelRequire("lNE5T");
const $07600df33fa9e5d1$export$2f975c505121e139 = (0, $6xToB.createEntry)((0, $8gYxy.softwarePlanSettingsFindYourIssueRoute), ()=>({
        group: 'software',
        component: (0, $lNE5T.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $lNE5T.LazyPlanSettingsFindYourIssue)
        ]
    }));

});
parcelRegister("8gYxy", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFindYourIssueRoute", () => $3e705bf91ee82323$export$ab61883f74eb27c2);
const $3e705bf91ee82323$export$ab61883f74eb27c2 = {
    name: 'plan-settings-find-your-issue',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/find-your-issue'
};

});

parcelRegister("lNE5T", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsFindYourIssue", () => $2becb75d109e50ab$export$731998664b7d5e72);
$parcel$export(module.exports, "default", () => $2becb75d109e50ab$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $2becb75d109e50ab$export$731998664b7d5e72 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("65bhQ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/find-your-issue/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2becb75d109e50ab$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $2becb75d109e50ab$export$731998664b7d5e72,
        pageId: "plan-settings-find-your-issue",
        shouldShowSpinner: true
    });

});
parcelRegister("65bhQ", function(module, exports) {

let $46dbf704e45d81f3$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("60onN"), 4)),
    $46dbf704e45d81f3$var$load("1PHzf")
]).then(()=>parcelRequire('7g6vL'));

});



parcelRegister("luRFY", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsIssueSourcesRouteEntry", () => $25304d26e67fc6ad$export$f0b7e9788ab79be0);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $aaSxy = parcelRequire("aaSxy");

var $54xqO = parcelRequire("54xqO");
const $25304d26e67fc6ad$export$f0b7e9788ab79be0 = (0, $6xToB.createEntry)((0, $aaSxy.softwarePlanSettingsIssueSourcesRoute), ()=>({
        group: 'software',
        component: (0, $54xqO.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $54xqO.LazyPlanSettingsIssueSources)
        ]
    }));

});
parcelRegister("aaSxy", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsIssueSourcesRoute", () => $be54de734395d2e7$export$fa18324265e4400c);
const $be54de734395d2e7$export$fa18324265e4400c = {
    name: 'plan-settings-issue-sources',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/issue-sources'
};

});

parcelRegister("54xqO", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsIssueSources", () => $ec2c571598fcd399$export$7ba4b487efcedeb3);
$parcel$export(module.exports, "default", () => $ec2c571598fcd399$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ec2c571598fcd399$export$7ba4b487efcedeb3 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2eprg"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/issue-sources/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ec2c571598fcd399$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ec2c571598fcd399$export$7ba4b487efcedeb3,
        pageId: "plan-settings-issue-sources",
        shouldShowSpinner: !(0, $7jTnu.fg)('plan_settings_refresh')
    });

});
parcelRegister("2eprg", function(module, exports) {

let $1a009f32f38b4265$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    $1a009f32f38b4265$var$load("1VRB2"),
    $1a009f32f38b4265$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("zTH5g"), 4)),
    $1a009f32f38b4265$var$load("lJWkV")
]).then(()=>parcelRequire('2F6ud'));

});



parcelRegister("3dqLQ", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPermissionsRouteEntry", () => $9c524ee5be436c95$export$1afc7a9efa99340);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $gcKb3 = parcelRequire("gcKb3");

var $ljkv8 = parcelRequire("ljkv8");
const $9c524ee5be436c95$export$1afc7a9efa99340 = (0, $6xToB.createEntry)((0, $gcKb3.softwarePlanSettingsPermissionsRoute), ()=>({
        group: 'software',
        component: (0, $ljkv8.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ljkv8.LazyPlanSettingsPermissions)
        ]
    }));

});
parcelRegister("gcKb3", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPermissionsRoute", () => $ed8fa3156ca6cb63$export$6734c29372722a5e);
const $ed8fa3156ca6cb63$export$6734c29372722a5e = {
    name: 'plan-settings-permissions',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/permissions'
};

});

parcelRegister("ljkv8", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsPermissions", () => $4424f64bc52cfe12$export$49f5b76ad5c06a42);
$parcel$export(module.exports, "default", () => $4424f64bc52cfe12$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $4424f64bc52cfe12$export$49f5b76ad5c06a42 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("l2pKw"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/permissions/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4424f64bc52cfe12$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4424f64bc52cfe12$export$49f5b76ad5c06a42,
        pageId: "plan-settings-permissions",
        shouldShowSpinner: true
    });

});
parcelRegister("l2pKw", function(module, exports) {

let $f50dc22a5c63e5a3$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("03gRt"), 4)),
    $f50dc22a5c63e5a3$var$load("klx1w")
]).then(()=>parcelRequire('iNQES'));

});



parcelRegister("gxAJV", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPlanInfoRouteEntry", () => $3891a8b9ceef0222$export$1d6300da0c837e02);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $aWIMa = parcelRequire("aWIMa");

var $g3zm3 = parcelRequire("g3zm3");
const $3891a8b9ceef0222$export$1d6300da0c837e02 = (0, $6xToB.createEntry)((0, $aWIMa.softwarePlanSettingsPlanInfoRoute), ()=>({
        group: 'software',
        component: (0, $g3zm3.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $g3zm3.LazyPlanSettingsPlanInfo)
        ]
    }));

});
parcelRegister("aWIMa", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPlanInfoRoute", () => $361c0444b958f959$export$76e6bdc959f6fa97);
const $361c0444b958f959$export$76e6bdc959f6fa97 = {
    name: 'plan-settings-plan-info',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/plan-info'
};

});

parcelRegister("g3zm3", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsPlanInfo", () => $a4d3dcfb1f50f946$export$c1344fd7d24991b3);
$parcel$export(module.exports, "default", () => $a4d3dcfb1f50f946$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $7jTnu = parcelRequire("7jTnu");

const $a4d3dcfb1f50f946$export$c1344fd7d24991b3 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("aS6Nk"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/plan-info/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a4d3dcfb1f50f946$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a4d3dcfb1f50f946$export$c1344fd7d24991b3,
        pageId: "plan-settings-plan-info",
        shouldShowSpinner: !(0, $7jTnu.fg)('plan_settings_refresh')
    });

});
parcelRegister("aS6Nk", function(module, exports) {

let $7ea437cd69f72aff$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("32kTW"), 4)),
    $7ea437cd69f72aff$var$load("lj0cl")
]).then(()=>parcelRequire('kRwCG'));

});



parcelRegister("dLExR", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsProgramBoardsRouteEntry", () => $27f2bf42140fda69$export$be96222796ad98f0);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $97z4K = parcelRequire("97z4K");

var $kfMVX = parcelRequire("kfMVX");
const $27f2bf42140fda69$export$be96222796ad98f0 = (0, $6xToB.createEntry)((0, $97z4K.softwarePlanSettingsProgramBoardsRoute), ()=>({
        group: 'software',
        component: (0, $kfMVX.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kfMVX.LazyPlanSettingsProgramBoards)
        ]
    }));

});
parcelRegister("97z4K", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsProgramBoardsRoute", () => $51968d20998f144d$export$3d54c48a91a178c0);
const $51968d20998f144d$export$3d54c48a91a178c0 = {
    name: 'plan-settings-program-boards',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/program-boards'
};

});

parcelRegister("kfMVX", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsProgramBoards", () => $ec6a0e983d42f556$export$ffdec728a47c437c);
$parcel$export(module.exports, "default", () => $ec6a0e983d42f556$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ec6a0e983d42f556$export$ffdec728a47c437c = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("kaDRB"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/program-boards/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ec6a0e983d42f556$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ec6a0e983d42f556$export$ffdec728a47c437c,
        pageId: "plan-settings-program-boards",
        shouldShowSpinner: true
    });

});
parcelRegister("kaDRB", function(module, exports) {

let $03ca1fa4b4842cb3$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("2ggVv"), 4)),
    $03ca1fa4b4842cb3$var$load("2uSFX")
]).then(()=>parcelRequire('egoXV'));

});



parcelRegister("5zVch", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsRemovedIssuesRouteEntry", () => $1d419df2ff4a54b2$export$53a9ea0e0b05ceb5);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $9AdMQ = parcelRequire("9AdMQ");

var $jVxAw = parcelRequire("jVxAw");
const $1d419df2ff4a54b2$export$53a9ea0e0b05ceb5 = (0, $6xToB.createEntry)((0, $9AdMQ.softwarePlanSettingsRemovedIssuesRoute), ()=>({
        group: 'software',
        component: (0, $jVxAw.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jVxAw.LazyPlanSettingsRemovedIssues)
        ]
    }));

});
parcelRegister("9AdMQ", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsRemovedIssuesRoute", () => $d8656b48bf5bac26$export$8b77532ba9798e64);
const $d8656b48bf5bac26$export$8b77532ba9798e64 = {
    name: 'plan-settings-removed-issues',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/removed-issues'
};

});

parcelRegister("jVxAw", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsRemovedIssues", () => $4ee08e20301e5255$export$759df6301ec72119);
$parcel$export(module.exports, "default", () => $4ee08e20301e5255$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $4ee08e20301e5255$export$759df6301ec72119 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("hqk38"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/removed-issues/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4ee08e20301e5255$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4ee08e20301e5255$export$759df6301ec72119,
        pageId: "plan-settings-removed-issues",
        shouldShowSpinner: true
    });

});
parcelRegister("hqk38", function(module, exports) {

let $caf46aca9c3fdad1$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    $caf46aca9c3fdad1$var$load("1VRB2"),
    $caf46aca9c3fdad1$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("7e1z0"), 4)),
    $caf46aca9c3fdad1$var$load("8P5gY")
]).then(()=>parcelRequire('atQfO'));

});



parcelRegister("2ZnyJ", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSavedViewsRouteEntry", () => $4dd2f754021029da$export$64d5b46da2e58194);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $bbCSS = parcelRequire("bbCSS");

var $c6UN7 = parcelRequire("c6UN7");
const $4dd2f754021029da$export$64d5b46da2e58194 = (0, $6xToB.createEntry)((0, $bbCSS.softwarePlanSettingsSavedViewsRoute), ()=>({
        group: 'software',
        component: (0, $c6UN7.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c6UN7.LazyPlanSettingsSavedViews)
        ]
    }));

});
parcelRegister("bbCSS", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSavedViewsRoute", () => $248b0510532bb809$export$a0fec30f475e8756);
const $248b0510532bb809$export$a0fec30f475e8756 = {
    name: 'plan-settings-saved-views',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/saved-views'
};

});

parcelRegister("c6UN7", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsSavedViews", () => $473181a46b14ce3b$export$a5398542699d356a);
$parcel$export(module.exports, "default", () => $473181a46b14ce3b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $7jTnu = parcelRequire("7jTnu");

const $473181a46b14ce3b$export$a5398542699d356a = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("dXBnw"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/saved-views/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$473181a46b14ce3b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $473181a46b14ce3b$export$a5398542699d356a,
        pageId: "plan-settings-saved-views",
        shouldShowSpinner: !(0, $7jTnu.fg)('plan_settings_refresh')
    });

});
parcelRegister("dXBnw", function(module, exports) {

let $a29dc79f64dfe519$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    $a29dc79f64dfe519$var$load("1VRB2"),
    $a29dc79f64dfe519$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("4amyp"), 4)),
    $a29dc79f64dfe519$var$load("ckllH")
]).then(()=>parcelRequire('dkKSy'));

});



parcelRegister("lGz7G", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsScenariosRouteEntry", () => $1f4048c57f0fce3c$export$9b6e6b5d471b90f);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $dQz6Y = parcelRequire("dQz6Y");

var $6FXeu = parcelRequire("6FXeu");
const $1f4048c57f0fce3c$export$9b6e6b5d471b90f = (0, $6xToB.createEntry)((0, $dQz6Y.softwarePlanSettingsScenariosRoute), ()=>({
        group: 'software',
        component: (0, $6FXeu.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6FXeu.LazyPlanSettingsScenarios)
        ]
    }));

});
parcelRegister("dQz6Y", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsScenariosRoute", () => $7bd5cf26036d351a$export$d32efeefb944c6b7);
const $7bd5cf26036d351a$export$d32efeefb944c6b7 = {
    name: 'plan-settings-scenarios',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scenarios'
};

});

parcelRegister("6FXeu", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsScenarios", () => $fa8d70102ba2fe73$export$94104fcc1a6f460f);
$parcel$export(module.exports, "default", () => $fa8d70102ba2fe73$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $fa8d70102ba2fe73$export$94104fcc1a6f460f = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5ANhs"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scenarios/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fa8d70102ba2fe73$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fa8d70102ba2fe73$export$94104fcc1a6f460f,
        pageId: "plan-settings-scenarios",
        shouldShowSpinner: true
    });

});
parcelRegister("5ANhs", function(module, exports) {

let $41268a9d17868150$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("8iwQH"), 4)),
    $41268a9d17868150$var$load("gxJdz")
]).then(()=>parcelRequire('bwkSx'));

});



parcelRegister("aPs1z", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSchedulingRouteEntry", () => $b5f6b3aa4894cdd9$export$c1319dec79812860);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $12tkp = parcelRequire("12tkp");

var $8mUfY = parcelRequire("8mUfY");
const $b5f6b3aa4894cdd9$export$c1319dec79812860 = (0, $6xToB.createEntry)((0, $12tkp.softwarePlanSettingsSchedulingRoute), ()=>({
        group: 'software',
        component: (0, $8mUfY.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8mUfY.LazyPlanSettingsScheduling)
        ]
    }));

});
parcelRegister("12tkp", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSchedulingRoute", () => $ac65e04ce8614138$export$a215ef374dd2a8a9);
const $ac65e04ce8614138$export$a215ef374dd2a8a9 = {
    name: 'plan-settings-scheduling',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scheduling'
};

});

parcelRegister("8mUfY", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsScheduling", () => $51c6b5d8e750230c$export$3bf11db1bbeae73e);
$parcel$export(module.exports, "default", () => $51c6b5d8e750230c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $7jTnu = parcelRequire("7jTnu");

var $gzcjr = parcelRequire("gzcjr");

const $51c6b5d8e750230c$export$3bf11db1bbeae73e = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("05jan"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scheduling/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$51c6b5d8e750230c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $51c6b5d8e750230c$export$3bf11db1bbeae73e,
        pageId: "plan-settings-scheduling",
        shouldShowSpinner: !(0, $7jTnu.fg)('plan_settings_refresh')
    });

});
parcelRegister("05jan", function(module, exports) {

let $00ff55c939a65462$var$load = (parcelRequire("gLHA4"))(4);





module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $00ff55c939a65462$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $00ff55c939a65462$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $00ff55c939a65462$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $00ff55c939a65462$var$load("kZxiU")
        ]);
    }),
    $00ff55c939a65462$var$load("7vqGd"),
    $00ff55c939a65462$var$load("1Y4bq"),
    $00ff55c939a65462$var$load("1VRB2"),
    $00ff55c939a65462$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("e7yAH"), 4)),
    $00ff55c939a65462$var$load("eDzss"),
    $00ff55c939a65462$var$load("7cniY")
]).then(()=>parcelRequire('h4lm7'));

});



parcelRegister("91LPB", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSummaryRouteEntry", () => $8599f2df48e20cd0$export$4bc10767887a84cc);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $jmv36 = parcelRequire("jmv36");

var $9NmsS = parcelRequire("9NmsS");

var $4made = parcelRequire("4made");

var $7jTnu = parcelRequire("7jTnu");

var $8LEOe = parcelRequire("8LEOe");

var $3IEdy = parcelRequire("3IEdy");
const $8599f2df48e20cd0$export$4bc10767887a84cc = (0, $6xToB.createEntry)((0, $4made.softwarePlanSummaryRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $7jTnu.fg)('migrate_plans_to_entrypoints') ? (0, $3IEdy.planSummaryPageEntryPoint) : undefined,
        ufoName: 'software-advanced-roadmaps-summary',
        component: (0, $8LEOe.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $jmv36.advancedRoadmapsSummaryDataResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8LEOe.LazyPlanSummary)
        ]
    }));

});
parcelRegister("4made", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSummaryRoute", () => $c93c14dbb7c5a41f$export$25a8cf27557a612d);
const $c93c14dbb7c5a41f$export$25a8cf27557a612d = {
    name: 'software-plan-summary',
    path: '/jira/plans/:planId/scenarios/:scenarioId/summary'
};

});

parcelRegister("8LEOe", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSummary", () => $db2e9315c0d2e007$export$c717f0d9d7f11b49);
$parcel$export(module.exports, "default", () => $db2e9315c0d2e007$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $db2e9315c0d2e007$export$c717f0d9d7f11b49 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("21dEL"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$db2e9315c0d2e007$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $db2e9315c0d2e007$export$c717f0d9d7f11b49,
        pageId: "plan-summary",
        shouldShowSpinner: true
    });

});

parcelRegister("3IEdy", function(module, exports) {

$parcel$export(module.exports, "planSummaryPageEntryPoint", () => $2c4236ffd8d0ff93$export$a3858cce1e973f19);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $legH4 = parcelRequire("legH4");

var $dGTIT = parcelRequire("dGTIT");
const $2c4236ffd8d0ff93$export$a3858cce1e973f19 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $legH4.planSummaryEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint)
});

});


parcelRegister("e6ehT", function(module, exports) {

$parcel$export(module.exports, "softwarePlanTeamsRouteEntry", () => $2b87ec832fba9563$export$cc5b7d3f8546a313);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $2ibNL = parcelRequire("2ibNL");

var $7jTnu = parcelRequire("7jTnu");

var $FENpN = parcelRequire("FENpN");

var $2NmIZ = parcelRequire("2NmIZ");
const $2b87ec832fba9563$export$cc5b7d3f8546a313 = (0, $6xToB.createEntry)((0, $2ibNL.softwarePlanTeamsRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $7jTnu.fg)('migrate_plans_to_entrypoints') ? (0, $2NmIZ.planTeamsPageEntryPoint) : undefined,
        component: (0, $FENpN.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $FENpN.LazyPlanTeams)
        ]
    }));

});
parcelRegister("2ibNL", function(module, exports) {

$parcel$export(module.exports, "softwarePlanTeamsRoute", () => $02246c8c6d90d7a6$export$fc66f5c0de18ddc7);
const $02246c8c6d90d7a6$export$fc66f5c0de18ddc7 = {
    name: 'software-plan-teams',
    path: '/jira/plans/:planId/scenarios/:scenarioId/teams'
};

});

parcelRegister("FENpN", function(module, exports) {

$parcel$export(module.exports, "LazyPlanTeams", () => $53f9b9a1089de614$export$f85952f98f28fed0);
$parcel$export(module.exports, "default", () => $53f9b9a1089de614$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $53f9b9a1089de614$export$f85952f98f28fed0 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("eKCn3"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-teams/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$53f9b9a1089de614$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $53f9b9a1089de614$export$f85952f98f28fed0,
        pageId: "plan-teams",
        shouldShowSpinner: true
    });

});
parcelRegister("eKCn3", function(module, exports) {

let $abd3203768734969$var$load = (parcelRequire("gLHA4"))(4);





module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $abd3203768734969$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $abd3203768734969$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $abd3203768734969$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $abd3203768734969$var$load("kZxiU")
        ]);
    }),
    $abd3203768734969$var$load("7vqGd"),
    $abd3203768734969$var$load("1Y4bq"),
    $abd3203768734969$var$load("1VRB2"),
    $abd3203768734969$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("3bUlI"), 4)),
    $abd3203768734969$var$load("eDzss"),
    $abd3203768734969$var$load("cmi7o")
]).then(()=>parcelRequire('jeqsm'));

});


parcelRegister("2NmIZ", function(module, exports) {

$parcel$export(module.exports, "planTeamsPageEntryPoint", () => $962e8dac00cd052f$export$e75b3c6626974862);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $1zgTH = parcelRequire("1zgTH");

var $dGTIT = parcelRequire("dGTIT");
const $962e8dac00cd052f$export$e75b3c6626974862 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1zgTH.planTeamsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint)
});

});
parcelRegister("1zgTH", function(module, exports) {

$parcel$export(module.exports, "planTeamsEntryPoint", () => $65620f7d12f16aed$export$afd1c95955e9abac);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $65620f7d12f16aed$export$afd1c95955e9abac = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("aCqxS")), {
        moduleId: "8c4bf459",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aCqxS", function(module, exports) {

let $7bb20b5723f1d3b8$var$load = (parcelRequire("gLHA4"))(4);





module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $7bb20b5723f1d3b8$var$load("047zq")
        ]);
    }, function() {
        return Promise.all([
            $7bb20b5723f1d3b8$var$load("e7BS9")
        ]);
    }),
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $7bb20b5723f1d3b8$var$load("guvnw")
        ]);
    }, function() {
        return Promise.all([
            $7bb20b5723f1d3b8$var$load("kZxiU")
        ]);
    }),
    $7bb20b5723f1d3b8$var$load("7vqGd"),
    $7bb20b5723f1d3b8$var$load("1Y4bq"),
    $7bb20b5723f1d3b8$var$load("1VRB2"),
    $7bb20b5723f1d3b8$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("dGtAv"), 4)),
    $7bb20b5723f1d3b8$var$load("eDzss"),
    $7bb20b5723f1d3b8$var$load("aEsyk")
]).then(()=>parcelRequire('lNSe1'));

});




parcelRegister("gAUgF", function(module, exports) {

$parcel$export(module.exports, "softwarePlanTimelineRouteEntry", () => $2fda052cc6ca3459$export$c5b46ecd4d9a8abd);

var $kHlOR = parcelRequire("kHlOR");

var $7jTnu = parcelRequire("7jTnu");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $iArJs = parcelRequire("iArJs");

var $iIcBn = parcelRequire("iIcBn");

var $9iLyn = parcelRequire("9iLyn");
const $2fda052cc6ca3459$export$c5b46ecd4d9a8abd = (0, $6xToB.createEntry)((0, $iArJs.softwarePlanTimelineRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $7jTnu.fg)('migrate_plans_to_entrypoints') ? (0, $9iLyn.planTimelinePageEntryPoint) : undefined,
        component: (0, $iIcBn.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iIcBn.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("9iLyn", function(module, exports) {

$parcel$export(module.exports, "planTimelinePageEntryPoint", () => $411c11165b1d57e9$export$7ee5b399f9530a72);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $iyaX4 = parcelRequire("iyaX4");

var $dGTIT = parcelRequire("dGTIT");
const $411c11165b1d57e9$export$7ee5b399f9530a72 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iyaX4.planTimelineEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint)
});

});


parcelRegister("7eIYH", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectEmbedRouteEntry", () => $f024ecf422071a5c$export$6df3cef5dab31b3b);

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $kHymb = parcelRequire("kHymb");

var $kWsG7 = parcelRequire("kWsG7");
const $f024ecf422071a5c$export$6df3cef5dab31b3b = (0, $6xToB.createEntry)((0, $kHymb.softwareProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'software',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        component: (0, $kWsG7.default),
        forPaint: [
            (0, $kWsG7.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("kHymb", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectEmbedRoute", () => $19fff290c5a771c2$export$6d1b944aeb758fdb);
const $19fff290c5a771c2$export$6d1b944aeb758fdb = {
    name: 'software-proforma-issue-forms-direct-embed',
    path: '/jira/software/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});


parcelRegister("6dPXJ", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectRouteEntry", () => $6c7e0fc2c82459ef$export$552db754a91368f3);

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $6lBzs = parcelRequire("6lBzs");

var $8FCAy = parcelRequire("8FCAy");

var $d017r = parcelRequire("d017r");
const $6c7e0fc2c82459ef$export$552db754a91368f3 = (0, $6xToB.createEntry)((0, $6lBzs.softwareProformaIssueFormsDirectRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayout),
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        entryPoint: ()=>(0, $d017r.proformaIssueFormsDirectPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("6lBzs", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectRoute", () => $19c8fa51ef1b7123$export$69db7046ead228b9);
const $19c8fa51ef1b7123$export$69db7046ead228b9 = {
    name: 'software-proforma-issue-forms-direct',
    path: '/jira/software/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});


parcelRegister("k80dv", function(module, exports) {

$parcel$export(module.exports, "softwareReleaseNotesRouteEntry", () => $7b06764fef8eab48$export$543aad2020051ecb);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $7aNAF = parcelRequire("7aNAF");

var $8FCAy = parcelRequire("8FCAy");

var $bMm2d = parcelRequire("bMm2d");
const $7b06764fef8eab48$export$543aad2020051ecb = (0, $6xToB.createEntry)((0, $7aNAF.softwareReleaseNotesRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        component: (0, $bMm2d.SpaReleaseNoteRedirectToVersionDetails),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("7aNAF", function(module, exports) {

$parcel$export(module.exports, "softwareReleaseNotesRoute", () => $e99ebbe378b89573$export$a0223091962262d4);
const $e99ebbe378b89573$export$a0223091962262d4 = {
    name: 'software-release-notes',
    path: '/secure/ReleaseNote.jspa',
    query: [
        'projectId'
    ]
};

});


parcelRegister("dw2ce", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurndownRouteEntry", () => $886379cbecc8f508$export$c54d6c6781ad5beb);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $iJuQx = parcelRequire("iJuQx");

var $8FCAy = parcelRequire("8FCAy");

var $3dfhx = parcelRequire("3dfhx");

var $8Q6IF = parcelRequire("8Q6IF");
const $886379cbecc8f508$export$c54d6c6781ad5beb = (0, $6xToB.createEntry)((0, $iJuQx.softwareReportsBurndownRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.burndown-chart',
        entryPoint: ()=>(0, $8Q6IF.BurnDownReportPageEntrypoint),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("iJuQx", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurndownRoute", () => $1c25666ba02dff6f$export$e0d8c26cb1430ae4);
const $1c25666ba02dff6f$export$e0d8c26cb1430ae4 = {
    name: 'software-reports-burndown',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burndown'
};

});

parcelRegister("3dfhx", function(module, exports) {

$parcel$export(module.exports, "getTMPReportsCommonResource", () => $f157f2314f14e946$export$f234446c23dc22a);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $f157f2314f14e946$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $f157f2314f14e946$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});

parcelRegister("8Q6IF", function(module, exports) {

$parcel$export(module.exports, "BurnDownReportPageEntrypoint", () => $e0fcf0f663f86f08$export$4cba13cb70183e0e);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $kYF9G = parcelRequire("kYF9G");
const $e0fcf0f663f86f08$export$4cba13cb70183e0e = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $kYF9G.burnDownReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("kYF9G", function(module, exports) {

$parcel$export(module.exports, "burnDownReportEntrypoint", () => $0e28d81199b47059$export$ca10f29d444e87e0);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $0e28d81199b47059$export$ca10f29d444e87e0 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("9J0lD")), {
        moduleId: "24e2d8d6",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9J0lD", function(module, exports) {

let $714896234cc8dbb7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $714896234cc8dbb7$var$load("1VRB2"),
    $714896234cc8dbb7$var$load("bABhq"),
    $714896234cc8dbb7$var$load("8zt8a")
]).then(()=>parcelRequire('dk4Fo'));

});




parcelRegister("eSIYo", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurnupRouteEntry", () => $07e110ef487292bf$export$e53193d8a7e7d068);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $7XWOG = parcelRequire("7XWOG");

var $8FCAy = parcelRequire("8FCAy");

var $3dfhx = parcelRequire("3dfhx");

var $bmAy4 = parcelRequire("bmAy4");
const $07e110ef487292bf$export$e53193d8a7e7d068 = (0, $6xToB.createEntry)((0, $7XWOG.softwareReportsBurnupRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.burnup-chart',
        entryPoint: ()=>(0, $bmAy4.BurnUpReportPageEntrypoint),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("7XWOG", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurnupRoute", () => $ff38cc37be870bc6$export$5b818a6914ca8376);
const $ff38cc37be870bc6$export$5b818a6914ca8376 = {
    name: 'software-reports-burnup',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burnup'
};

});

parcelRegister("bmAy4", function(module, exports) {

$parcel$export(module.exports, "BurnUpReportPageEntrypoint", () => $c55c58b92207cefb$export$5901b46abc65034e);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $4BOCg = parcelRequire("4BOCg");
const $c55c58b92207cefb$export$5901b46abc65034e = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $4BOCg.burnUpReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("4BOCg", function(module, exports) {

$parcel$export(module.exports, "burnUpReportEntrypoint", () => $99bff690215a4f22$export$dfec2f14e71954f6);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $99bff690215a4f22$export$dfec2f14e71954f6 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("7EQGd")), {
        moduleId: "a1ebcc2d",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7EQGd", function(module, exports) {

let $593521f75fd5b604$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $593521f75fd5b604$var$load("1VRB2"),
    $593521f75fd5b604$var$load("bABhq"),
    $593521f75fd5b604$var$load("48J2u")
]).then(()=>parcelRequire('4e6Iv'));

});




parcelRegister("gLWOL", function(module, exports) {

$parcel$export(module.exports, "softwareReportsControlRouteEntry", () => $a1b0a281a03b8537$export$3cb9570ca242f2a2);

var $7mF43 = parcelRequire("7mF43");

var $7jTnu = parcelRequire("7jTnu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $gc43N = parcelRequire("gc43N");

var $kSeQy = parcelRequire("kSeQy");

var $jom8W = parcelRequire("jom8W");

var $8FCAy = parcelRequire("8FCAy");

var $3dfhx = parcelRequire("3dfhx");

var $cF2st = parcelRequire("cF2st");
const $a1b0a281a03b8537$export$3cb9570ca242f2a2 = (0, $6xToB.createEntry)((0, $gc43N.softwareReportsControlRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.control-chart',
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>!(0, $7jTnu.fg)('jsw_enable_avp_control_chart') || (0, $jom8W.isDevopsFeatureDisabledInFedRamp)() ? (0, $kSeQy.notFoundPageEntrypoint) : (0, $cF2st.softwareReportsControlPageEntrypoint),
        meta: {
            reporting: {
                id: 'software-reports-control',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-reports-control'),
                teamName: 'helios-headcoach'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("gc43N", function(module, exports) {

$parcel$export(module.exports, "softwareReportsControlRoute", () => $e9071b86792dced4$export$8c91815cd4b1c078);
const $e9071b86792dced4$export$8c91815cd4b1c078 = {
    name: 'software-reports-control',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/control'
};

});

parcelRegister("cF2st", function(module, exports) {

$parcel$export(module.exports, "softwareReportsControlPageEntrypoint", () => $34c60a09339837cb$export$a35d50a33df2f6d5);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $elSyw = parcelRequire("elSyw");
const $34c60a09339837cb$export$a35d50a33df2f6d5 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $elSyw.softwareReportsControlEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("elSyw", function(module, exports) {

$parcel$export(module.exports, "softwareReportsControlEntrypoint", () => $5de751e2909da174$export$240870c8f3915828);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $5de751e2909da174$export$240870c8f3915828 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("iczun")), {
        moduleId: "00c05b16",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iczun", function(module, exports) {

let $d404e05764940f8e$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    $d404e05764940f8e$var$load("1VRB2"),
    $d404e05764940f8e$var$load("bABhq"),
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("7pAtr"), 4)),
    $d404e05764940f8e$var$load("7vqGd"),
    $d404e05764940f8e$var$load("1Y4bq"),
    $d404e05764940f8e$var$load("eDzss"),
    $d404e05764940f8e$var$load("i8XS6")
]).then(()=>parcelRequire('90UZu'));

});




parcelRegister("YXwcg", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCumulativeRouteEntry", () => $04be22af72b1ce63$export$7ace4d0363d78b41);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $Cx6WS = parcelRequire("Cx6WS");

var $8FCAy = parcelRequire("8FCAy");

var $3dfhx = parcelRequire("3dfhx");

var $9zSDE = parcelRequire("9zSDE");
const $04be22af72b1ce63$export$7ace4d0363d78b41 = (0, $6xToB.createEntry)((0, $Cx6WS.softwareReportsCumulativeRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.cumulative-flow-diagram',
        entryPoint: ()=>(0, $9zSDE.CumulativeReportPageEntrypoint),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("Cx6WS", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCumulativeRoute", () => $8aa53e8f2d3e5994$export$3c48ddd40d00b0d2);
const $8aa53e8f2d3e5994$export$3c48ddd40d00b0d2 = {
    name: 'software-reports-cumulative',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cumulative'
};

});

parcelRegister("9zSDE", function(module, exports) {

$parcel$export(module.exports, "CumulativeReportPageEntrypoint", () => $5e1de5498f5ca52d$export$2f3ad380ae691fb5);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $8SPy1 = parcelRequire("8SPy1");
const $5e1de5498f5ca52d$export$2f3ad380ae691fb5 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8SPy1.cumulativeReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("8SPy1", function(module, exports) {

$parcel$export(module.exports, "cumulativeReportEntrypoint", () => $5bfd1c5e0dd3c442$export$f01a8d84f5a47478);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $5bfd1c5e0dd3c442$export$f01a8d84f5a47478 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("ahsWd")), {
        moduleId: "d640aef5",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("ahsWd", function(module, exports) {

let $77c1f0675473d909$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $77c1f0675473d909$var$load("1VRB2"),
    $77c1f0675473d909$var$load("bABhq"),
    $77c1f0675473d909$var$load("9GjHX")
]).then(()=>parcelRequire('38vJk'));

});




parcelRegister("lFKeR", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicBoardRouteEntry", () => $2cff0793907edbb0$export$9c40eb459ce6a0bc);

var $7mF43 = parcelRequire("7mF43");

var $6xToB = parcelRequire("6xToB");

var $fMdRQ = parcelRequire("fMdRQ");

var $f2JN3 = parcelRequire("f2JN3");

var $jom8W = parcelRequire("jom8W");

var $9BJU1 = parcelRequire("9BJU1");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $gzlQL = parcelRequire("gzlQL");

var $kHlOR = parcelRequire("kHlOR");

var $igNUx = parcelRequire("igNUx");

var $kSeQy = parcelRequire("kSeQy");

var $7jTnu = parcelRequire("7jTnu");

var $3FUST = parcelRequire("3FUST");

var $awzH2 = parcelRequire("awzH2");

var $sXRDv = parcelRequire("sXRDv");
const $2cff0793907edbb0$export$9c40eb459ce6a0bc = (0, $6xToB.createEntry)((0, $fMdRQ.softwareReportsCycleTimeClassicBoardRoute), ()=>({
        group: 'classic-software',
        component: (0, $f2JN3.componentWithCondition)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $3FUST.CycleTimeReportClassic)),
        entryPoint: ()=>{
            if ((0, $igNUx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $sXRDv.cycleTimeReportClassicPageEntrypoint) : (0, $sXRDv.cycleTimeReportClassicPageEntrypointOld);
        },
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $awzH2.getReportsCommonResource)(),
            (0, $gzlQL.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $3FUST.LazyCycleTimeReport)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3FUST.LazyCycleTimeReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-cycle-time-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-reports-cycle-time-classic'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("fMdRQ", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicBoardRoute", () => $c07f7815a00490db$export$12423e360eb5fa9d);
const $c07f7815a00490db$export$12423e360eb5fa9d = {
    name: 'software-reports-cycle-time-classic-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/cycle-time',
    exact: true
};

});

parcelRegister("gzlQL", function(module, exports) {

$parcel$export(module.exports, "devOpsProviderResource", () => $1272457585d4dae5$export$19e58e21b24ae0d8);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $1272457585d4dae5$export$19e58e21b24ae0d8 = (0, $l1VxS.createResource)({
    type: (0, $c723c3992e1330b3$export$5f92e516f4b78544),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("ceP51")),
    maxAge: 60000
});
const $1272457585d4dae5$export$b80f5852c41a5ca8 = ()=>(0, $eJrcF.useResource)($1272457585d4dae5$export$19e58e21b24ae0d8);

});
const $c723c3992e1330b3$export$5f92e516f4b78544 = 'SOFTWARE_DEVOPS_PROVIDERS';
const $c723c3992e1330b3$export$d7f081d6dd0e72fc = 'bitbucket';
const $c723c3992e1330b3$export$832d1d859726f915 = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
const $c723c3992e1330b3$export$5007979ef33118fc = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';

parcelRegister("ceP51", function(module, exports) {

let $8e8e6a41c318cf79$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8e8e6a41c318cf79$var$load("lc5n8").then(()=>parcelRequire('jMyUD'));

});


parcelRegister("3FUST", function(module, exports) {

$parcel$export(module.exports, "LazyCycleTimeReport", () => $086a5c0618ce384d$export$956f830ed027f1fb);
$parcel$export(module.exports, "CycleTimeReportClassic", () => $086a5c0618ce384d$export$237924ba64065cc3);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $086a5c0618ce384d$export$956f830ed027f1fb = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("dSREX")), {
    moduleId: "./src/packages/spa-apps/cycle-time-report/src/ui/index-old.tsx"
});
const $086a5c0618ce384d$export$e16ce0656a74a015 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $086a5c0618ce384d$export$956f830ed027f1fb,
        pageId: "cycleTimeReportNextGen",
        shouldShowSpinner: true
    });
const $086a5c0618ce384d$export$237924ba64065cc3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $086a5c0618ce384d$export$956f830ed027f1fb,
        pageId: "cycleTimeReportClassic",
        shouldShowSpinner: true
    });

});
parcelRegister("dSREX", function(module, exports) {

let $a1b9f1345038e8d7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $a1b9f1345038e8d7$var$load("1VRB2"),
    $a1b9f1345038e8d7$var$load("bABhq"),
    $a1b9f1345038e8d7$var$load("kmf3V")
]).then(()=>parcelRequire('8jisX'));

});


parcelRegister("sXRDv", function(module, exports) {

$parcel$export(module.exports, "cycleTimeReportClassicPageEntrypointOld", () => $120412b894561719$export$c404b50e5fd8e03b);
$parcel$export(module.exports, "cycleTimeReportClassicPageEntrypoint", () => $120412b894561719$export$2dba7a1bad1f01b2);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $jHE2Y = parcelRequire("jHE2Y");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $120412b894561719$export$c404b50e5fd8e03b = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jHE2Y.cycleTimeReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $120412b894561719$export$2dba7a1bad1f01b2 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jHE2Y.cycleTimeReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    }
});

});
parcelRegister("jHE2Y", function(module, exports) {

$parcel$export(module.exports, "cycleTimeReportEntrypoint", () => $559d3e6fe810deb2$export$a4c2e42865ef5d9d);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $559d3e6fe810deb2$export$a4c2e42865ef5d9d = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("bN8YT")), {
        moduleId: "4e89963f",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bN8YT", function(module, exports) {

let $895b3ccc480f7550$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $895b3ccc480f7550$var$load("1VRB2"),
    $895b3ccc480f7550$var$load("bABhq"),
    $895b3ccc480f7550$var$load("alYqH")
]).then(()=>parcelRequire('3M9k7'));

});




parcelRegister("1xutc", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicRouteEntry", () => $1a2920e61c54804f$export$1bbbe71c256ed1d0);

var $7mF43 = parcelRequire("7mF43");

var $6xToB = parcelRequire("6xToB");

var $kKxRa = parcelRequire("kKxRa");

var $f2JN3 = parcelRequire("f2JN3");

var $jom8W = parcelRequire("jom8W");

var $9BJU1 = parcelRequire("9BJU1");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $gzlQL = parcelRequire("gzlQL");

var $kHlOR = parcelRequire("kHlOR");

var $igNUx = parcelRequire("igNUx");

var $kSeQy = parcelRequire("kSeQy");

var $7jTnu = parcelRequire("7jTnu");

var $3FUST = parcelRequire("3FUST");

var $awzH2 = parcelRequire("awzH2");

var $sXRDv = parcelRequire("sXRDv");
const $1a2920e61c54804f$export$1bbbe71c256ed1d0 = (0, $6xToB.createEntry)((0, $kKxRa.softwareReportsCycleTimeClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $f2JN3.componentWithCondition)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $3FUST.CycleTimeReportClassic)),
        entryPoint: ()=>{
            if ((0, $igNUx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $sXRDv.cycleTimeReportClassicPageEntrypoint) : (0, $sXRDv.cycleTimeReportClassicPageEntrypointOld);
        },
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $awzH2.getReportsCommonResource)(),
            (0, $gzlQL.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $3FUST.LazyCycleTimeReport)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3FUST.LazyCycleTimeReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-cycle-time-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-reports-cycle-time-classic'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("kKxRa", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicRoute", () => $bed42164d105061a$export$1e5e610e11119ea7);
const $bed42164d105061a$export$1e5e610e11119ea7 = {
    name: 'software-reports-cycle-time-classic',
    path: '/jira/software/c/projects/:projectKey/reports/cycle-time',
    exact: true
};

});


parcelRegister("ed2hW", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeRouteEntry", () => $87c505443e4f25dc$export$8aee4b14556485d5);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $kSeQy = parcelRequire("kSeQy");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $gzlQL = parcelRequire("gzlQL");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $l0iSy = parcelRequire("l0iSy");

var $jom8W = parcelRequire("jom8W");

var $8FCAy = parcelRequire("8FCAy");

var $3dfhx = parcelRequire("3dfhx");

var $4xORh = parcelRequire("4xORh");
const $87c505443e4f25dc$export$8aee4b14556485d5 = (0, $6xToB.createEntry)((0, $l0iSy.softwareReportsCycleTimeRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)(),
            (0, $gzlQL.devOpsProviderResource)
        ],
        entryPoint: ()=>{
            if ((0, $jom8W.isDevopsFeatureDisabledInFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return 0, $4xORh.cycleTimeReportPageEntrypoint;
        },
        meta: {
            reporting: {
                id: 'software-reports-cycle-time',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-reports-cycle-time'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("l0iSy", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeRoute", () => $93c4e645cb3314ae$export$c777bb8f2591081);
const $93c4e645cb3314ae$export$c777bb8f2591081 = {
    name: 'software-reports-cycle-time',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cycle-time'
};

});

parcelRegister("4xORh", function(module, exports) {

$parcel$export(module.exports, "cycleTimeReportPageEntrypoint", () => $9056a57a889fc21c$export$465717d84afb3d8f);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $jHE2Y = parcelRequire("jHE2Y");
const $9056a57a889fc21c$export$465717d84afb3d8f = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jHE2Y.cycleTimeReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});


parcelRegister("9iKlG", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicBoardRouteEntry", () => $b0ce4f346a28d976$export$e0c7b9ad9dd8b956);

var $7mF43 = parcelRequire("7mF43");

var $6xToB = parcelRequire("6xToB");

var $f2JN3 = parcelRequire("f2JN3");

var $9BJU1 = parcelRequire("9BJU1");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $kHlOR = parcelRequire("kHlOR");

var $b7Xft = parcelRequire("b7Xft");

var $jom8W = parcelRequire("jom8W");

var $ioHIu = parcelRequire("ioHIu");

var $aDtWM = parcelRequire("aDtWM");

var $gzlQL = parcelRequire("gzlQL");

var $igNUx = parcelRequire("igNUx");

var $kSeQy = parcelRequire("kSeQy");

var $7jTnu = parcelRequire("7jTnu");

var $6A5Fj = parcelRequire("6A5Fj");

var $awzH2 = parcelRequire("awzH2");

var $2xG2I = parcelRequire("2xG2I");
const $b0ce4f346a28d976$export$e0c7b9ad9dd8b956 = (0, $6xToB.createEntry)((0, $b7Xft.softwareReportsDeploymentFrequencyClassicBoardRoute), ()=>({
        group: 'classic-software',
        component: (0, $f2JN3.componentWithCondition)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $6A5Fj.DeploymentFrequencyReportClassic)),
        entryPoint: ()=>{
            if ((0, $igNUx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $2xG2I.deploymentFrequencyReportPageEntrypoint) : (0, $2xG2I.deploymentFrequencyReportPageEntrypointOld);
        },
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $awzH2.getReportsCommonResource)(),
            (0, $gzlQL.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $6A5Fj.LazyDeploymentFrequencyReport)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6A5Fj.LazyDeploymentFrequencyReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-reports-deployment-frequency-classic'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("b7Xft", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicBoardRoute", () => $4752db660fb86ac9$export$56d4754499615215);
const $4752db660fb86ac9$export$56d4754499615215 = {
    name: 'software-reports-deployment-frequency-classic-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/deployment-frequency',
    exact: true
};

});

parcelRegister("6A5Fj", function(module, exports) {

$parcel$export(module.exports, "LazyDeploymentFrequencyReport", () => $588f28ff82bfbb44$export$5113b2b19ec1fb53);
$parcel$export(module.exports, "DeploymentFrequencyReportClassic", () => $588f28ff82bfbb44$export$655707e8ae1053d3);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $588f28ff82bfbb44$export$5113b2b19ec1fb53 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("jL5lq")), {
    moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
});
const $588f28ff82bfbb44$export$e2db9c7426cdb53 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $588f28ff82bfbb44$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportNextGen",
        shouldShowSpinner: true
    });
const $588f28ff82bfbb44$export$655707e8ae1053d3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $588f28ff82bfbb44$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportClassic",
        shouldShowSpinner: true
    });

});
parcelRegister("jL5lq", function(module, exports) {

let $e6268d72dfcf8bc1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $e6268d72dfcf8bc1$var$load("1VRB2"),
    $e6268d72dfcf8bc1$var$load("bABhq"),
    $e6268d72dfcf8bc1$var$load("h6MxW")
]).then(()=>parcelRequire('9Qu19'));

});


parcelRegister("2xG2I", function(module, exports) {

$parcel$export(module.exports, "deploymentFrequencyReportPageEntrypointOld", () => $9bd95bbe0ff6fc20$export$a53f3dd319021fba);
$parcel$export(module.exports, "deploymentFrequencyReportPageEntrypoint", () => $9bd95bbe0ff6fc20$export$2a837f21eaa534d9);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $htIIj = parcelRequire("htIIj");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $9bd95bbe0ff6fc20$export$a53f3dd319021fba = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $htIIj.deploymentFrequencyReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $9bd95bbe0ff6fc20$export$2a837f21eaa534d9 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $htIIj.deploymentFrequencyReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    }
});

});
parcelRegister("htIIj", function(module, exports) {

$parcel$export(module.exports, "deploymentFrequencyReportEntrypoint", () => $f66fd7583b1cb90a$export$7377438ce2792970);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $f66fd7583b1cb90a$export$7377438ce2792970 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("kDvAT")), {
        moduleId: "1be0b680",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kDvAT", function(module, exports) {

let $f05ff51a9b0f478c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $f05ff51a9b0f478c$var$load("1VRB2"),
    $f05ff51a9b0f478c$var$load("bABhq"),
    $f05ff51a9b0f478c$var$load("7OUZq")
]).then(()=>parcelRequire('10Q59'));

});




parcelRegister("dfVfw", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicRouteEntry", () => $e9ea6db22e38de60$export$e5eaafb1fb588922);

var $7mF43 = parcelRequire("7mF43");

var $6xToB = parcelRequire("6xToB");

var $f2JN3 = parcelRequire("f2JN3");

var $9BJU1 = parcelRequire("9BJU1");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $kHlOR = parcelRequire("kHlOR");

var $3mkiQ = parcelRequire("3mkiQ");

var $jom8W = parcelRequire("jom8W");

var $ioHIu = parcelRequire("ioHIu");

var $aDtWM = parcelRequire("aDtWM");

var $gzlQL = parcelRequire("gzlQL");

var $igNUx = parcelRequire("igNUx");

var $kSeQy = parcelRequire("kSeQy");

var $7jTnu = parcelRequire("7jTnu");

var $6A5Fj = parcelRequire("6A5Fj");

var $awzH2 = parcelRequire("awzH2");

var $2xG2I = parcelRequire("2xG2I");
const $e9ea6db22e38de60$export$e5eaafb1fb588922 = (0, $6xToB.createEntry)((0, $3mkiQ.softwareReportsDeploymentFrequencyClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $f2JN3.componentWithCondition)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $6A5Fj.DeploymentFrequencyReportClassic)),
        entryPoint: ()=>{
            if ((0, $igNUx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $2xG2I.deploymentFrequencyReportPageEntrypoint) : (0, $2xG2I.deploymentFrequencyReportPageEntrypointOld);
        },
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $awzH2.getReportsCommonResource)(),
            (0, $gzlQL.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $6A5Fj.LazyDeploymentFrequencyReport)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6A5Fj.LazyDeploymentFrequencyReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-reports-deployment-frequency-classic'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("3mkiQ", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicRoute", () => $b1309c22ec4c6966$export$312c410cb3b49afe);
const $b1309c22ec4c6966$export$312c410cb3b49afe = {
    name: 'software-reports-deployment-frequency-classic',
    path: '/jira/software/c/projects/:projectKey/reports/deployment-frequency',
    exact: true
};

});


parcelRegister("fWDhV", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyRouteEntry", () => $7cef6b32dc1a62ce$export$c87b25c0997e584d);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $gzlQL = parcelRequire("gzlQL");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $hz88a = parcelRequire("hz88a");

var $igNUx = parcelRequire("igNUx");

var $8FCAy = parcelRequire("8FCAy");

var $kSeQy = parcelRequire("kSeQy");

var $3dfhx = parcelRequire("3dfhx");

var $bYZ9r = parcelRequire("bYZ9r");
const $7cef6b32dc1a62ce$export$c87b25c0997e584d = (0, $6xToB.createEntry)((0, $hz88a.softwareReportsDeploymentFrequencyRoute), ()=>({
        group: 'software',
        entryPoint: ()=>{
            if ((0, $igNUx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return 0, $bYZ9r.DeploymentFrequencyPageEntrypoint;
        },
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)(),
            (0, $gzlQL.devOpsProviderResource)
        ],
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-reports-deployment-frequency'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("hz88a", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyRoute", () => $1b79a97a1b727ec4$export$bbf45ab0423b990);
const $1b79a97a1b727ec4$export$bbf45ab0423b990 = {
    name: 'software-reports-deployment-frequency',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/deployment-frequency'
};

});

parcelRegister("bYZ9r", function(module, exports) {

$parcel$export(module.exports, "DeploymentFrequencyPageEntrypoint", () => $3bc6abe94725b005$export$76cc51683254a696);

var $g8uYY = parcelRequire("g8uYY");

var $htIIj = parcelRequire("htIIj");

var $5RW99 = parcelRequire("5RW99");
const $3bc6abe94725b005$export$76cc51683254a696 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $htIIj.deploymentFrequencyReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});


parcelRegister("khKzX", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewBoardlessRouteEntry", () => $371cacbbea6193ab$export$1341f3a3578e9e4);

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $7jTnu = parcelRequire("7jTnu");

var $k6duF = parcelRequire("k6duF");

var $eaH7J = parcelRequire("eaH7J");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $hS1gr = parcelRequire("hS1gr");

var $g8uYY = parcelRequire("g8uYY");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $ho3Tv = parcelRequire("ho3Tv");

var $8FCAy = parcelRequire("8FCAy");

var $dZRaT = parcelRequire("dZRaT");

var $lvjEc = parcelRequire("lvjEc");

var $9n5I0 = parcelRequire("9n5I0");

var $jKVxM = parcelRequire("jKVxM");
const $371cacbbea6193ab$var$reportsOverviewPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $lvjEc.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $371cacbbea6193ab$export$1341f3a3578e9e4 = (0, $6xToB.createEntry)((0, $eaH7J.softwareReportsOverviewBoardlessRoute), ()=>({
        group: 'software-reports-boardless',
        skeleton: (0, $jKVxM.ReportsOverviewSkeleton),
        entryPoint () {
            return (0, $7jTnu.fg)('reports-overview-page-migration') ? $371cacbbea6193ab$var$reportsOverviewPageEntryPoint : undefined;
        },
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $ho3Tv.staticSidebarJSWReportsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        ufoName: 'reports-overview',
        supportsPreviewPanel: true
    }));

});
parcelRegister("eaH7J", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewBoardlessRoute", () => $90592983eb49cde1$export$e2f371bced79a0e4);
const $90592983eb49cde1$export$e2f371bced79a0e4 = {
    name: 'software-reports-boardless',
    path: '/jira/software/c/projects/:projectKey/reports',
    exact: true
};

});

parcelRegister("jKVxM", function(module, exports) {

$parcel$export(module.exports, "ReportsOverviewSkeleton", () => $3b4ee2f5bd5730b4$export$c70e702bcad58c36);
/* ReportsOverviewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $4EId7 = parcelRequire("4EId7");
const $3b4ee2f5bd5730b4$var$containerStyles = {
    maxWidth: '100%'
};
const $3b4ee2f5bd5730b4$var$customCssStyles = null;
const $3b4ee2f5bd5730b4$export$c70e702bcad58c36 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4EId7))),
        containerStyles: $3b4ee2f5bd5730b4$var$containerStyles,
        className: (0, $hcewu.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("4EId7", function(module, exports) {
module.exports = new URL("report-categories-skeleton.tpl.5b53a8d3.svg", import.meta.url).toString();

});



parcelRegister("kzxfE", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewRouteEntry", () => $0e7b01ecb44cfb16$export$705071d2eca06bf9);

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $7jTnu = parcelRequire("7jTnu");

var $k6duF = parcelRequire("k6duF");

var $gMeDw = parcelRequire("gMeDw");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $hS1gr = parcelRequire("hS1gr");

var $g8uYY = parcelRequire("g8uYY");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $8FCAy = parcelRequire("8FCAy");

var $dZRaT = parcelRequire("dZRaT");

var $lvjEc = parcelRequire("lvjEc");

var $9n5I0 = parcelRequire("9n5I0");

var $jKVxM = parcelRequire("jKVxM");
const $0e7b01ecb44cfb16$var$reportsOverviewPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $lvjEc.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $0e7b01ecb44cfb16$export$705071d2eca06bf9 = (0, $6xToB.createEntry)((0, $gMeDw.softwareReportsOverviewRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $jKVxM.ReportsOverviewSkeleton),
        entryPoint () {
            return (0, $7jTnu.fg)('reports-overview-page-migration') ? $0e7b01ecb44cfb16$var$reportsOverviewPageEntryPoint : undefined;
        },
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        ufoName: 'reports-overview',
        supportsPreviewPanel: true
    }));

});
parcelRegister("gMeDw", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewRoute", () => $c2b35267a6214f58$export$f38928477442c9cf);
const $c2b35267a6214f58$export$f38928477442c9cf = {
    name: 'software-reports',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports'
};

});


parcelRegister("eF6xc", function(module, exports) {

$parcel$export(module.exports, "softwareReportsRouteEntry", () => $f29ab9272aada8c6$export$2eee2f4f773d5b1f);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $ahPxX = parcelRequire("ahPxX");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $lvjEc = parcelRequire("lvjEc");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");

var $7jTnu = parcelRequire("7jTnu");

var $3dfhx = parcelRequire("3dfhx");

var $iG7PY = parcelRequire("iG7PY");
const $f29ab9272aada8c6$var$tmpReportsOverviewPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $lvjEc.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $f29ab9272aada8c6$export$2eee2f4f773d5b1f = (0, $6xToB.createEntry)((0, $ahPxX.softwareReportsRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)()
        ],
        entryPoint () {
            return (0, $7jTnu.fg)('uxissue_545_migrate_tmp_reports_overview_page') ? $f29ab9272aada8c6$var$tmpReportsOverviewPageEntrypoint : (0, $iG7PY.reportsOverviewPageEntrypoint);
        },
        ufoName: 'software-reports.overview',
        supportsPreviewPanel: true
    }));

});
parcelRegister("ahPxX", function(module, exports) {

$parcel$export(module.exports, "softwareReportsRoute", () => $fe91805d7867e83d$export$5bf75a5d8c554930);
const $fe91805d7867e83d$export$5bf75a5d8c554930 = {
    name: 'software-reports',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports'
};

});

parcelRegister("iG7PY", function(module, exports) {

$parcel$export(module.exports, "reportsOverviewPageEntrypoint", () => $d1f26e1e2f56c173$export$d9a1db2306b376e2);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $bcil9 = parcelRequire("bcil9");
const $d1f26e1e2f56c173$export$d9a1db2306b376e2 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $bcil9.reportsOverviewEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("bcil9", function(module, exports) {

$parcel$export(module.exports, "reportsOverviewEntrypoint", () => $d317074d693e2940$export$bb9acba529741f89);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $d317074d693e2940$export$bb9acba529741f89 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("98GOE")), {
        moduleId: "6be6e255",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("98GOE", function(module, exports) {

let $6a7612c4afcd756d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6a7612c4afcd756d$var$load("dak0x").then(()=>parcelRequire('eT9yw'));

});




parcelRegister("7wJLb", function(module, exports) {

$parcel$export(module.exports, "softwareReportsVelocityRouteEntry", () => $345adc2cf37b98b1$export$7d814f4300d0e318);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $l7qZA = parcelRequire("l7qZA");

var $8FCAy = parcelRequire("8FCAy");

var $3dfhx = parcelRequire("3dfhx");

var $8iZ3C = parcelRequire("8iZ3C");
const $345adc2cf37b98b1$export$7d814f4300d0e318 = (0, $6xToB.createEntry)((0, $l7qZA.softwareReportsVelocityRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.velocity-report',
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>(0, $8iZ3C.velocityReportPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("l7qZA", function(module, exports) {

$parcel$export(module.exports, "softwareReportsVelocityRoute", () => $3c0e8e01898141a2$export$cde83a6497756848);
const $3c0e8e01898141a2$export$cde83a6497756848 = {
    name: 'software-reports-velocity',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/velocity'
};

});


parcelRegister("hN6Yh", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapClassicRouteEntry", () => $640ae557c113772a$export$17cff822dd3757db);

var $6xToB = parcelRequire("6xToB");

var $eXgQz = parcelRequire("eXgQz");

var $dZ1hs = parcelRequire("dZ1hs");

var $6dwgv = parcelRequire("6dwgv");

var $8FCAy = parcelRequire("8FCAy");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $b4jBr = parcelRequire("b4jBr");

var $5AZok = parcelRequire("5AZok");

var $eJe5A = parcelRequire("eJe5A");

var $kHlOR = parcelRequire("kHlOR");

var $66fuO = parcelRequire("66fuO");

var $aUtR9 = parcelRequire("aUtR9");
const $640ae557c113772a$export$17cff822dd3757db = (0, $6xToB.createEntry)((0, $eXgQz.softwareRoadmapClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $66fuO.TimelineRedirect),
        skeleton: (0, $dZ1hs.RoadmapSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayoutCode), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $hHbzj.forgeProjectModuleResourceOnNav3Only),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5AZok.classicRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $aUtR9.LazyRoadmapViewClassic)
        ],
        ufoName: 'classic-roadmap',
        supportsPreviewPanel: true
    }));

});
parcelRegister("eXgQz", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapClassicRoute", () => $cba708c24b5f6176$export$79089e2853f04197);
const $cba708c24b5f6176$export$79089e2853f04197 = {
    name: 'software-roadmap-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/roadmap'
};

});

parcelRegister("dZ1hs", function(module, exports) {

$parcel$export(module.exports, "RoadmapSkeleton", () => $c9db1b5a08dde725$export$66a1e8bb48359566);
/* RoadmapSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $f2JN3 = parcelRequire("f2JN3");

var $6zXPf = parcelRequire("6zXPf");

var $6XJko = parcelRequire("6XJko");

var $hwuZ0 = parcelRequire("hwuZ0");

var $lQl4L = parcelRequire("lQl4L");

var $jr8na = parcelRequire("jr8na");
const $c9db1b5a08dde725$var$customCssStyles = null;
const $c9db1b5a08dde725$export$66a1e8bb48359566 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c9db1b5a08dde725$var$AppSkeletonImageContainer, null, (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lQl4L))),
        className: (0, $hcewu.default)([
            "_2zz1idpf"
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jr8na))),
        className: (0, $hcewu.default)([
            "_2zz1idpf"
        ])
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $c9db1b5a08dde725$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});
const $c9db1b5a08dde725$var$AppSkeletonImageContainer = (0, $f2JN3.componentWithCondition)(()=>(0, $6XJko.isVisualRefreshEnabled)(), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c9db1b5a08dde725$var$Wrapper, null, children), (0, $eJOHy.Fragment));

});
parcelRegister("lQl4L", function(module, exports) {
module.exports = new URL("roadmap-app-skeleton-nav-refresh.tpl.ce6eb42e.svg", import.meta.url).toString();

});

parcelRegister("jr8na", function(module, exports) {
module.exports = new URL("roadmap-app-skeleton.tpl.a54a882d.svg", import.meta.url).toString();

});


parcelRegister("5AZok", function(module, exports) {

$parcel$export(module.exports, "classicRoadmapResource", () => $eb43dc5ccade4bc8$export$e755913caca1ab8e);

var $l1VxS = parcelRequire("l1VxS");


const $eb43dc5ccade4bc8$export$e755913caca1ab8e = (0, $l1VxS.createResource)({
    type: (0, $0a39a0a4006d2a49$export$e3b1cd17bd82de3d),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("cwYnY")),
    isBrowserOnly: true
});

});
parcelRegister("cwYnY", function(module, exports) {

let $91f7508a1b9c13d4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $91f7508a1b9c13d4$var$load("62AgM").then(()=>parcelRequire('5X6Mk'));

});


parcelRegister("66fuO", function(module, exports) {

$parcel$export(module.exports, "TimelineRedirect", () => $8b10fa8925fc70ad$export$c70b8d9ef0c891b2);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
var $gCY1z = parcelRequire("gCY1z");
const $8b10fa8925fc70ad$export$c70b8d9ef0c891b2 = ()=>{
    const [{ query: query, match: match }] = (0, $gCY1z.useRouter)();
    const queryParams = new URLSearchParams(query).toString();
    const { projectKey: projectKey, boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: {
            pathname: `/jira/software/c/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};

});

parcelRegister("aUtR9", function(module, exports) {

$parcel$export(module.exports, "LazyRoadmapViewClassic", () => $ff5085c44ca1869d$export$84165bb08bf42eef);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ff5085c44ca1869d$export$84165bb08bf42eef = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5Xkzw"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/classic/index-old.tsx"
});
var /** @deprecated Use entrypoint roadmapViewClassicPageEntrypoint */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff5085c44ca1869d$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ff5085c44ca1869d$export$84165bb08bf42eef,
        pageId: `classic-roadmap-${boardId || ''}`,
        shouldShowSpinner: false
    });
};

});
parcelRegister("5Xkzw", function(module, exports) {

let $45626b93b794315a$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $45626b93b794315a$var$load("esKGV")
        ]);
    }, function() {
        return Promise.all([
            $45626b93b794315a$var$load("7uqQP")
        ]);
    }),
    $45626b93b794315a$var$load("1VRB2"),
    $45626b93b794315a$var$load("bABhq"),
    $45626b93b794315a$var$load("6se8Z")
]).then(()=>parcelRequire('5zjoc'));

});



parcelRegister("5dzzd", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRedirectRouteEntry", () => $d090343e177b9d37$export$4180bde2c4464aed);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $kHlOR = parcelRequire("kHlOR");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $93J6P = parcelRequire("93J6P");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $2mHfh = parcelRequire("2mHfh");

var $4LGud = parcelRequire("4LGud");
const $d090343e177b9d37$var$SoftwareTimelineLegacyRedirect = ({ query: query })=>{
    const { projectKey: projectKey, rapidView: rapidView, ...restQuery } = query;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: {
            pathname: `/jira/software/projects/${projectKey}/boards/${rapidView}/timeline`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(restQuery)
        }
    });
};
const $d090343e177b9d37$export$4180bde2c4464aed = (0, $6xToB.createEntry)((0, $93J6P.softwareRoadmapRedirectRoute), ()=>({
        group: 'software',
        component: $d090343e177b9d37$var$SoftwareTimelineLegacyRedirect,
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4LGud.LazyNextGenRoadmap)
        ]
    }));

});
parcelRegister("93J6P", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRedirectRoute", () => $d0c162cea111bf8b$export$866215abd09c0f4d);
const $d0c162cea111bf8b$export$866215abd09c0f4d = {
    name: 'software-roadmap-redirect',
    path: '/secure/Roadmap.jspa'
};

});

parcelRegister("4LGud", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenRoadmap", () => $f82715ba08d30b86$export$1339c847cf4ab57);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $f82715ba08d30b86$export$1339c847cf4ab57 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("65RKy"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f82715ba08d30b86$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f82715ba08d30b86$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });

});
parcelRegister("65RKy", function(module, exports) {

let $46fce752d96179fb$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $46fce752d96179fb$var$load("esKGV")
        ]);
    }, function() {
        return Promise.all([
            $46fce752d96179fb$var$load("7uqQP")
        ]);
    }),
    $46fce752d96179fb$var$load("1VRB2"),
    $46fce752d96179fb$var$load("bABhq"),
    $46fce752d96179fb$var$load("aEM8b")
]).then(()=>parcelRequire('6KC4T'));

});



parcelRegister("eyWIM", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRouteEntry", () => $92fa8a9c26166803$export$c1d875e34d537389);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $gVZAI = parcelRequire("gVZAI");

var $bTfc4 = parcelRequire("bTfc4");

var $i7iuH = parcelRequire("i7iuH");

var $dZ1hs = parcelRequire("dZ1hs");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $2mHfh = parcelRequire("2mHfh");

var $96amU = parcelRequire("96amU");
const $92fa8a9c26166803$var$SoftwareTimelineRedirect = ({ match: { params: { projectKey: projectKey, boardId: boardId } }, query: query })=>{
    const queryParams = new URLSearchParams(query).toString();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: {
            pathname: `/jira/software/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};
const $92fa8a9c26166803$export$c1d875e34d537389 = (0, $6xToB.createEntry)((0, $i7iuH.softwareRoadmapRoute), ()=>({
        group: 'software',
        component: $92fa8a9c26166803$var$SoftwareTimelineRedirect,
        skeleton: (0, $dZ1hs.RoadmapSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayoutCode), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dZRaT.projectContextResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $hHbzj.forgeProjectModuleResourceOnNav3Only),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gVZAI.nextGenRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $96amU.LazyNextGenRoadmap)
        ],
        ufoName: 'next-gen-roadmap',
        supportsPreviewPanel: true
    }));

});
parcelRegister("gVZAI", function(module, exports) {

$parcel$export(module.exports, "nextGenRoadmapResource", () => $0c00376fc9bc583d$export$2750f87d68dfb02a);

var $l1VxS = parcelRequire("l1VxS");


const $0c00376fc9bc583d$export$2750f87d68dfb02a = (0, $l1VxS.createResource)({
    type: (0, $0a39a0a4006d2a49$export$75dfa03544a19422),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("a9PAu")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});

});
parcelRegister("a9PAu", function(module, exports) {

let $7652c2d5ae82b69b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7652c2d5ae82b69b$var$load("hwlgY"),
    $7652c2d5ae82b69b$var$load("jOz8Z")
]).then(()=>parcelRequire('Qdom1'));

});


parcelRegister("i7iuH", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRoute", () => $f49120ba3bc21202$export$a4a573c36fc75b30);
const $f49120ba3bc21202$export$a4a573c36fc75b30 = {
    name: 'software-roadmap',
    path: '/jira/software/projects/:projectKey/boards/:boardId/roadmap'
};

});

parcelRegister("96amU", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenRoadmap", () => $f258a8020d4f8f78$export$1339c847cf4ab57);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $f258a8020d4f8f78$export$1339c847cf4ab57 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("65RKy"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f258a8020d4f8f78$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f258a8020d4f8f78$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });

});


parcelRegister("5OhH5", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityClassicRouteEntry", () => $b89e1ae3273c2965$export$8acfebad16c9d6f2);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $j9Woh = parcelRequire("j9Woh");

var $bjzwt = parcelRequire("bjzwt");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $kSeQy = parcelRequire("kSeQy");

var $aw3pZ = parcelRequire("aw3pZ");

var $1CTcA = parcelRequire("1CTcA");
const $b89e1ae3273c2965$export$8acfebad16c9d6f2 = (0, $6xToB.createEntry)((0, $bjzwt.softwareSecurityClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $j9Woh.securityPageResource)
        ],
        ufoName: 'software-security-combined',
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        meta: {
            reporting: {
                id: 'software-security-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-security-classic'),
                teamName: 'fusion-isotopes'
            }
        },
        entryPoint: ()=>(0, $aw3pZ.isSecurityPageEnabled)() ? (0, $1CTcA.securityPageEntrypoint) : (0, $kSeQy.notFoundPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("j9Woh", function(module, exports) {

$parcel$export(module.exports, "securityPageResource", () => $b9560db29d07486a$export$2c5e3c161b8fe98);

var $8oKDI = parcelRequire("8oKDI");

var $9FYIg = parcelRequire("9FYIg");

var $7jTnu = parcelRequire("7jTnu");

var $lGgMT = parcelRequire("lGgMT");

var $kCapU = parcelRequire("kCapU");

const $b9560db29d07486a$var$getNumberOfVulnerabilitiesToFetch = ()=>40;
const $b9560db29d07486a$var$getNumberOfSecurityContainersToFetch = ()=>100;
let $b9560db29d07486a$var$filters;
const $b9560db29d07486a$export$2c5e3c161b8fe98 = (0, $9FYIg.createRelayResource)({
    type: (0, $392f4051a7d4e158$export$f24db22c3c834cb1),
    getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId, activationId: activationId } }) {
        const isSecRoute = name === 'software-security' || name === 'software-security-classic';
        // Set filters on initial call only and not on every query param change
        if (!$b9560db29d07486a$var$filters && isSecRoute) {
            const connectionAri = (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                resourceType: 'security-container',
                cloudId: cloudId,
                activationId: activationId,
                resourceId: ''
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            $b9560db29d07486a$var$filters = (0, $kCapU.getGqlFiltersFromQueryParams)(query, connectionAri);
        }
        // Reset filters when navigating away from the security page
        if (!isSecRoute) $b9560db29d07486a$var$filters = undefined;
        return {
            parameters: (0, $lGgMT.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudAri: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: cloudId
                }),
                cloudId: cloudId,
                projectKey: params.projectKey ?? '',
                numberOfVulnsToFetch: $b9560db29d07486a$var$getNumberOfVulnerabilitiesToFetch(),
                getContainers: false,
                numberOfContainersToFetch: $b9560db29d07486a$var$getNumberOfSecurityContainersToFetch(),
                filter: $b9560db29d07486a$var$filters,
                isVulnsListFixEnabled: (0, $7jTnu.fg)('jira-security-vulns-list-fix-enabled')
            }
        };
    }
});

});
parcelRegister("lGgMT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e75e22b5bae4767f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa025ac439b416a5321ca0c6f97dc5bd>>
 * @relayHash fcc81036b313cdc379e986cf0a3136da
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cc10cd43053a8820b5cdd778d95d9c93f16c20b4910bb0240ea20f73dbdfb458
const $e75e22b5bae4767f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "getContainers"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isVulnsListFixEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfContainersToFetch"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfVulnsToFetch"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v9 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v10 = {
        "kind": "ScalarField",
        "name": "totalLinkedSecurityContainerCount"
    }, v11 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "numberOfContainersToFetch"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v13 = [
        v12 /*: any*/ 
    ], v14 = {
        "kind": "InlineFragment",
        "selections": v13 /*: any*/ ,
        "type": "ThirdPartySecurityContainer"
    }, v15 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v16 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "numberOfVulnsToFetch"
    }, v17 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "and": {
                    "lastUpdated": {
                        "sort": {
                            "order": "ASC",
                            "priority": 1
                        }
                    }
                }
            }
        },
        v16 /*: any*/ 
    ], v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = {
        "kind": "ScalarField",
        "name": "name"
    }, v20 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v21 = {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "cloudAri"
                    },
                    {
                        "kind": "Literal",
                        "name": "providerTypes",
                        "value": [
                            "SECURITY"
                        ]
                    }
                ],
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "DevOpsSecurityProvider",
                        "kind": "LinkedField",
                        "name": "securityProviders",
                        "plural": true,
                        "selections": [
                            v18 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "appInstallationId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "logoUrl"
                            },
                            v19 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 100
                                    }
                                ],
                                "concreteType": "AriGraphRelationshipConnection",
                                "kind": "LinkedField",
                                "name": "linkedWorkspaces",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "AriGraphRelationship",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v20 /*: any*/ 
                                        ]
                                    }
                                ],
                                "storageKey": "linkedWorkspaces(first:100)"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v22 = [
        v18 /*: any*/ 
    ], v23 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "DevOpsFeatureFlag"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "DevOpsOperationsComponentDetails"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "DevOpsOperationsIncidentDetails"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "DevOpsOperationsPostIncidentReviewDetails"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "DevOpsPullRequestDetails"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "DevOpsRepository"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "DevOpsSecurityVulnerabilityDetails"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "JiraAutodevJob"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "JiraConfluenceRemoteIssueLink"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "JiraCustomRemoteIssueLink"
    }, v34 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "JiraIssueRemoteIssueLink"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "JiraWebRemoteIssueLink"
    }, v36 = [
        v9 /*: any*/ ,
        v16 /*: any*/ 
    ], v37 = {
        "kind": "ScalarField",
        "name": "url"
    }, v38 = {
        "kind": "ScalarField",
        "name": "key"
    }, v39 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v40 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v41 = [
        {
            "concreteType": "GraphJiraVulnerabilityEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "GraphJiraVulnerability",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                            "kind": "LinkedField",
                            "name": "vulnerability",
                            "plural": false,
                            "selections": [
                                v20 /*: any*/ ,
                                v18 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainSecurityInJiraQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v8 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "getContainers",
                                                "variableName": "getContainers"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isVulnsListFixEnabled",
                                                "variableName": "isVulnsListFixEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "numberOfContainersToFetch",
                                                "variableName": "numberOfContainersToFetch"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "main_softwareSecurityPage_MainPage"
                                    },
                                    v10 /*: any*/ ,
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v11 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "getContainers",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "data",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v14 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v15 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraProjectByKey.linkedSecurityContainers"
                                    },
                                    {
                                        "alias": "linkedVulnsForAnalytics",
                                        "args": v17 /*: any*/ ,
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "condition": "getContainers",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                        "kind": "LinkedField",
                                                                        "name": "vulnerability",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ThirdPartySecurityContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "securityContainer",
                                                                                "plural": false,
                                                                                "selections": v13 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.jiraProjectByKey"
                        }
                    ]
                },
                v21 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainSecurityInJiraQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                v18 /*: any*/ ,
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityContainers",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v20 /*: any*/ ,
                                                                                v14 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v18 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        v9 /*: any*/ 
                                    ],
                                    "kind": "ScalarField",
                                    "name": "totalLinkedSecurityVulnerabilityCount"
                                },
                                {
                                    "args": v36 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                            "kind": "LinkedField",
                                                            "name": "vulnerability",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v18 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityIdentifier",
                                                                    "kind": "LinkedField",
                                                                    "name": "identifiers",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayName"
                                                                        },
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityAdditionalInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "additionalInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "content"
                                                                        },
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "status"
                                                                },
                                                                {
                                                                    "concreteType": "AriGraphRelationshipConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "linkedJiraIssues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AriGraphRelationship",
                                                                            "kind": "LinkedField",
                                                                            "name": "nodes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "to",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v18 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "data",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "idsOrAliases",
                                                                                                                    "value": [
                                                                                                                        "summary",
                                                                                                                        "assignee",
                                                                                                                        "status",
                                                                                                                        "issuetype"
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldsByIdOrAlias",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v20 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "status",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusCategory",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v38 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusField"
                                                                                                                },
                                                                                                                v18 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "fieldId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "text"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "picture"
                                                                                                                                },
                                                                                                                                v18 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "small"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v18 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "issueId"
                                                                                                        },
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "webUrl"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssue"
                                                                                                },
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ ,
                                                                                                v25 /*: any*/ ,
                                                                                                v26 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v29 /*: any*/ ,
                                                                                                v30 /*: any*/ ,
                                                                                                v31 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v34 /*: any*/ ,
                                                                                                v35 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                },
                                                                v18 /*: any*/ ,
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "introducedDate"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerVulnerabilityId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "securityContainerId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "severity"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "description"
                                                                }
                                                            ]
                                                        },
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                },
                                                v39 /*: any*/ 
                                            ]
                                        },
                                        v40 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v36 /*: any*/ ,
                                    "filters": [
                                        "filter"
                                    ],
                                    "handle": "connection",
                                    "key": "security__linkedSecurityVulnerabilitiesByProject",
                                    "kind": "LinkedHandle",
                                    "name": "linkedSecurityVulnerabilitiesByProject"
                                },
                                {
                                    "alias": "linkedVulnsForAnalytics",
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "condition": "getContainers",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "vulnerability",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v12 /*: any*/ ,
                                                                                v18 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "getContainers",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v11 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v20 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v19 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "icon"
                                                                                        },
                                                                                        v37 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "providerName"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "lastUpdated"
                                                                                        },
                                                                                        v15 /*: any*/ ,
                                                                                        v18 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ThirdPartySecurityContainer"
                                                                                },
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v39 /*: any*/ 
                                                    ]
                                                },
                                                v40 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v11 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "security__linkedSecurityContainers",
                                            "kind": "LinkedHandle",
                                            "name": "linkedSecurityContainers"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isVulnsListFixEnabled",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectHaveVulnerabilityCheckFirst",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1
                                                }
                                            ],
                                            "concreteType": "GraphJiraVulnerabilityConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityVulnerabilitiesByProject",
                                            "plural": false,
                                            "selections": v41 /*: any*/ ,
                                            "storageKey": "linkedSecurityVulnerabilitiesByProject(first:1)"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isVulnsListFixEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "projectHaveVulnerabilityCheck",
                                            "concreteType": "GraphJiraVulnerabilityConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityVulnerabilitiesByProject",
                                            "plural": false,
                                            "selections": v41 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v21 /*: any*/ 
            ]
        },
        "params": {
            "id": "cc10cd43053a8820b5cdd778d95d9c93f16c20b4910bb0240ea20f73dbdfb458",
            "metadata": {},
            "name": "mainSecurityInJiraQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e75e22b5bae4767f$var$node.hash = "13b399a98e02ad00fbb7180d9f2cb96e";
var $e75e22b5bae4767f$export$2e2bcd8739ae039 = $e75e22b5bae4767f$var$node;

});

parcelRegister("kCapU", function(module, exports) {

$parcel$export(module.exports, "getGqlFiltersFromQueryParams", () => $d9ad221b33bcb19d$export$2af359d48d48e5f1);

var $6u3tP = parcelRequire("6u3tP");

var $bC2b5 = parcelRequire("bC2b5");

var $9FOZi = parcelRequire("9FOZi");
const $d9ad221b33bcb19d$var$getFilterValue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
values, fieldStortKey, sortKey = (0, $bC2b5.initialVulnerabilityTableOptions).sortKey, sortOrder = (0, $bC2b5.initialVulnerabilityTableOptions).sortOrder)=>({
        ...values.length > 0 ? {
            values: values
        } : {},
        ...sortKey === fieldStortKey && {
            sort: {
                priority: 2,
                order: (0, $9FOZi.parseSortDirection)(sortOrder, (0, $6u3tP.AriGraphSortOrderInput).DESC)
            }
        }
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d9ad221b33bcb19d$var$getOrDefault = (input, defaultArray)=>input.length ? input : defaultArray;
const $d9ad221b33bcb19d$export$2af359d48d48e5f1 = (queryParams, connectionAri)=>{
    const containerValues = $d9ad221b33bcb19d$var$getOrDefault((0, $9FOZi.connectionQueryParamToFilter)(queryParams[0, $bC2b5.QUERY_PARAM_CONTAINER], connectionAri).filter(Boolean), (0, $bC2b5.initialVulnerabilityTableOptions).connectionFilter);
    const statusQueryParams = (0, $9FOZi.arrayQueryParamToFilter)(queryParams[0, $bC2b5.QUERY_PARAM_VULN_STATUS]);
    return {
        and: [
            {
                lastUpdated: {
                    sort: {
                        priority: 1,
                        order: (0, $6u3tP.AriGraphSortOrderInput).DESC
                    }
                },
                to_severity: $d9ad221b33bcb19d$var$getFilterValue($d9ad221b33bcb19d$var$getOrDefault((0, $9FOZi.arrayQueryParamToFilter)(queryParams[0, $bC2b5.QUERY_PARAM_SEVERITY]).map((0, $9FOZi.parseSeverity)).filter(Boolean), (0, $bC2b5.initialVulnerabilityTableOptions).severityFilter), 'severity', queryParams[0, $bC2b5.QUERY_PARAM_SORT_KEY], queryParams[0, $bC2b5.QUERY_PARAM_SORT_ORDER]),
                to_status: $d9ad221b33bcb19d$var$getFilterValue(statusQueryParams.includes((0, $bC2b5.NO_FILTER_VULN_STATUS)) ? [] : $d9ad221b33bcb19d$var$getOrDefault(statusQueryParams.map((0, $9FOZi.parseStatus)).filter(Boolean), (0, $bC2b5.initialVulnerabilityTableOptions).statusFilter), 'status', queryParams[0, $bC2b5.QUERY_PARAM_SORT_KEY], queryParams[0, $bC2b5.QUERY_PARAM_SORT_ORDER]),
                createdAt: {
                    ...queryParams[0, $bC2b5.QUERY_PARAM_SORT_KEY] === 'introduced' && {
                        sort: {
                            priority: 2,
                            order: (0, $9FOZi.parseSortDirection)(queryParams[0, $bC2b5.QUERY_PARAM_SORT_ORDER], (0, $6u3tP.AriGraphSortOrderInput).DESC)
                        }
                    }
                },
                to_container: {
                    containerAri: {
                        value: {
                            ...containerValues.length > 0 ? {
                                values: containerValues
                            } : {}
                        }
                    }
                }
            }
        ]
    };
};

});
parcelRegister("6u3tP", function(module, exports) {

$parcel$export(module.exports, "AriGraphSortOrderInput", () => $1a6d09a85edfc6f2$export$3b69903df4cd6048);
const $1a6d09a85edfc6f2$export$3b69903df4cd6048 = {
    ASC: 'ASC',
    DESC: 'DESC'
};

});

parcelRegister("bC2b5", function(module, exports) {

$parcel$export(module.exports, "QUERY_PARAM_SEARCH", () => $aef224468a7f8afa$export$a181206198b7f50c);
$parcel$export(module.exports, "QUERY_PARAM_CONTAINER", () => $aef224468a7f8afa$export$3873b20ffa21b004);
$parcel$export(module.exports, "QUERY_PARAM_SEVERITY", () => $aef224468a7f8afa$export$af01a3d59250f3d3);
$parcel$export(module.exports, "QUERY_PARAM_VULN_STATUS", () => $aef224468a7f8afa$export$c315695f017955dc);
$parcel$export(module.exports, "QUERY_PARAM_ISSUE_STATUS", () => $aef224468a7f8afa$export$2e69a24fe65d4109);
$parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", () => $aef224468a7f8afa$export$6da773286c35ef41);
$parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", () => $aef224468a7f8afa$export$810a1f7ed2facfcb);
$parcel$export(module.exports, "NO_FILTER_VULN_STATUS", () => $aef224468a7f8afa$export$d8115099d465de4c);
$parcel$export(module.exports, "initialVulnerabilityTableOptions", () => $aef224468a7f8afa$export$e9b4ea84d666c490);
const $aef224468a7f8afa$export$a181206198b7f50c = 'search';
const $aef224468a7f8afa$export$3873b20ffa21b004 = 'container';
const $aef224468a7f8afa$export$af01a3d59250f3d3 = 'severity';
const $aef224468a7f8afa$export$c315695f017955dc = 'vulnerabilityStatus';
const $aef224468a7f8afa$export$2e69a24fe65d4109 = 'issueStatus';
const $aef224468a7f8afa$export$6da773286c35ef41 = 'sortKey';
const $aef224468a7f8afa$export$810a1f7ed2facfcb = 'sortOrder';
const $aef224468a7f8afa$export$d8115099d465de4c = 'NO-FILTERS';
const $aef224468a7f8afa$var$initialVulnerabilityTableFilters = {
    searchFilter: '',
    connectionFilter: [],
    severityFilter: [],
    statusFilter: [
        'OPEN'
    ],
    jiraIssueStatusFilter: []
};
const $aef224468a7f8afa$export$e9b4ea84d666c490 = {
    sortKey: 'severity',
    sortOrder: 'DESC',
    ...$aef224468a7f8afa$var$initialVulnerabilityTableFilters
};

});

parcelRegister("9FOZi", function(module, exports) {

$parcel$export(module.exports, "arrayQueryParamToFilter", () => $62d341b4235d71c0$export$7500862c6689a767);
$parcel$export(module.exports, "arrayFilterToQueryParam", () => $62d341b4235d71c0$export$b0dee3c5bfc7249e);
$parcel$export(module.exports, "connectionFilterToQueryParam", () => $62d341b4235d71c0$export$a6950ca4fdc8498f);
$parcel$export(module.exports, "connectionQueryParamToFilter", () => $62d341b4235d71c0$export$1040034504af5b41);
$parcel$export(module.exports, "parseSeverity", () => $62d341b4235d71c0$export$3551b8a2cbdb5162);
$parcel$export(module.exports, "parseStatus", () => $62d341b4235d71c0$export$2188844eb84f7f06);
$parcel$export(module.exports, "parseSortDirection", () => $62d341b4235d71c0$export$85cf5c73b48a482e);

var $5FdZg = parcelRequire("5FdZg");

var $79hL0 = parcelRequire("79hL0");

var $6u3tP = parcelRequire("6u3tP");

var $5mYxp = parcelRequire("5mYxp");
const $62d341b4235d71c0$var$DELIMITER = ',';
const $62d341b4235d71c0$var$ENCODED_DELIMITER = encodeURIComponent($62d341b4235d71c0$var$DELIMITER);
// We encode the delimiter to protect the values from containing
// the same character that delimits the list.
// e.g.
// env names = ["prod,east", "prod,west"] -> "prod,east,prod,west"
const $62d341b4235d71c0$var$encodeDelimiter = (input)=>{
    const regex = new RegExp($62d341b4235d71c0$var$DELIMITER, 'g');
    return input.replace(regex, $62d341b4235d71c0$var$ENCODED_DELIMITER);
};
const $62d341b4235d71c0$var$decodeDelimiter = (input)=>{
    const regex = new RegExp($62d341b4235d71c0$var$ENCODED_DELIMITER, 'g');
    return input.replace(regex, $62d341b4235d71c0$var$DELIMITER);
};
const $62d341b4235d71c0$export$7500862c6689a767 = (queryParamString)=>queryParamString?.split($62d341b4235d71c0$var$DELIMITER)?.map($62d341b4235d71c0$var$decodeDelimiter) ?? [];
const $62d341b4235d71c0$export$b0dee3c5bfc7249e = (filterArray)=>{
    if (filterArray.length === 0) return undefined;
    return filterArray.map((entity)=>$62d341b4235d71c0$var$encodeDelimiter(entity)).join($62d341b4235d71c0$var$DELIMITER);
};
const $62d341b4235d71c0$export$a6950ca4fdc8498f = (connectionArray)=>{
    if (connectionArray.length === 0) return undefined;
    const groupedConnectionsByAppKey = connectionArray.reduce((acc, connection)=>{
        const [, , , , securityParts] = connection.split(':');
        const [, , , appKey, ...containerId] = securityParts.split('/');
        if (!acc[appKey]) acc[appKey] = [];
        acc[appKey].push(containerId.join('/'));
        return acc;
    }, {});
    return JSON.stringify(groupedConnectionsByAppKey);
};
const $62d341b4235d71c0$export$1040034504af5b41 = (queryParamString, connectionAri)=>{
    if (!queryParamString) return [];
    const groupedConnectionsByAppKey = JSON.parse(queryParamString);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FdZg)))(groupedConnectionsByAppKey, (containerIds, appKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($79hL0)))(containerIds, (containerId)=>`${connectionAri}${appKey}/${containerId}`));
};
const $62d341b4235d71c0$export$3551b8a2cbdb5162 = (maybeSeverity)=>{
    switch(maybeSeverity?.toUpperCase()){
        case (0, $5mYxp.VulnerabilitySeverityEnums).CRITICAL.toUpperCase():
            return (0, $5mYxp.VulnerabilitySeverityEnums).CRITICAL;
        case (0, $5mYxp.VulnerabilitySeverityEnums).HIGH.toUpperCase():
            return (0, $5mYxp.VulnerabilitySeverityEnums).HIGH;
        case (0, $5mYxp.VulnerabilitySeverityEnums).LOW.toUpperCase():
            return (0, $5mYxp.VulnerabilitySeverityEnums).LOW;
        case (0, $5mYxp.VulnerabilitySeverityEnums).MEDIUM.toUpperCase():
            return (0, $5mYxp.VulnerabilitySeverityEnums).MEDIUM;
        case (0, $5mYxp.VulnerabilitySeverityEnums).UNKNOWN.toUpperCase():
            return (0, $5mYxp.VulnerabilitySeverityEnums).UNKNOWN;
        default:
            return undefined;
    }
};
const $62d341b4235d71c0$export$2188844eb84f7f06 = (maybeStatus)=>{
    switch(maybeStatus?.toUpperCase()){
        case (0, $5mYxp.VulnerabilityStatusEnums).OPEN.toUpperCase():
            return (0, $5mYxp.VulnerabilityStatusEnums).OPEN;
        case (0, $5mYxp.VulnerabilityStatusEnums).UNKNOWN.toUpperCase():
            return (0, $5mYxp.VulnerabilityStatusEnums).UNKNOWN;
        case (0, $5mYxp.VulnerabilityStatusEnums).CLOSED.toUpperCase():
            return (0, $5mYxp.VulnerabilityStatusEnums).CLOSED;
        case (0, $5mYxp.VulnerabilityStatusEnums).IGNORED.toUpperCase():
            return (0, $5mYxp.VulnerabilityStatusEnums).IGNORED;
        default:
            return undefined;
    }
};
const $62d341b4235d71c0$export$85cf5c73b48a482e = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case (0, $6u3tP.AriGraphSortOrderInput).ASC.toUpperCase():
            return (0, $6u3tP.AriGraphSortOrderInput).ASC;
        case (0, $6u3tP.AriGraphSortOrderInput).DESC.toUpperCase():
            return (0, $6u3tP.AriGraphSortOrderInput).DESC;
        default:
            return defaultValue;
    }
};

});
parcelRegister("5FdZg", function(module, exports) {

var $72Qfa = parcelRequire("72Qfa");

var $79hL0 = parcelRequire("79hL0");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $41fba19db79c4e52$var$flatMap(collection, iteratee) {
    return $72Qfa($79hL0(collection, iteratee), 1);
}
module.exports = $41fba19db79c4e52$var$flatMap;

});
parcelRegister("79hL0", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $1lM9j = parcelRequire("1lM9j");

var $k0Eii = parcelRequire("k0Eii");

var $4sprp = parcelRequire("4sprp");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $534725d937053460$var$map(collection, iteratee) {
    var func = $4sprp(collection) ? $lylkU : $k0Eii;
    return func(collection, $1lM9j(iteratee, 3));
}
module.exports = $534725d937053460$var$map;

});
parcelRegister("k0Eii", function(module, exports) {

var $c3u3c = parcelRequire("c3u3c");

var $7H30b = parcelRequire("7H30b");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e9131047aaeaff47$var$baseMap(collection, iteratee) {
    var index = -1, result = $7H30b(collection) ? Array(collection.length) : [];
    $c3u3c(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $e9131047aaeaff47$var$baseMap;

});



parcelRegister("5mYxp", function(module, exports) {

$parcel$export(module.exports, "VulnerabilitySeverityEnums", () => $7f64af12791e5419$export$c1a102938d8dc10);
$parcel$export(module.exports, "VulnerabilityStatusEnums", () => $7f64af12791e5419$export$2d6749bded378262);
const $7f64af12791e5419$export$c1a102938d8dc10 = {
    CRITICAL: 'CRITICAL',
    HIGH: 'HIGH',
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    UNKNOWN: 'UNKNOWN'
};
const $7f64af12791e5419$export$2d6749bded378262 = {
    CLOSED: 'CLOSED',
    IGNORED: 'IGNORED',
    OPEN: 'OPEN',
    UNKNOWN: 'UNKNOWN'
};
const $7f64af12791e5419$var$VulnerabilityTypeEnums = {
    DAST: 'DAST',
    SAST: 'SAST',
    SCA: 'SCA',
    UNKNOWN: 'UNKNOWN'
};

});



const $392f4051a7d4e158$export$f24db22c3c834cb1 = 'SOFTWARE_SECURITY';


parcelRegister("bjzwt", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityClassicRoute", () => $7db17db105cc905d$export$b7285748f1151353);
const $7db17db105cc905d$export$b7285748f1151353 = {
    name: 'software-security-classic',
    path: '/jira/software/c/projects/:projectKey/security'
};

});

parcelRegister("aw3pZ", function(module, exports) {

$parcel$export(module.exports, "isSecurityPageEnabled", () => $f49535f297d83487$export$f99b2868577ed515);

var $7jTnu = parcelRequire("7jTnu");

var $jom8W = parcelRequire("jom8W");
const $f49535f297d83487$export$f99b2868577ed515 = ()=>!(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && (0, $7jTnu.fg)('isotopes-security-page-in-jira-enabled-v2');

});

parcelRegister("1CTcA", function(module, exports) {

$parcel$export(module.exports, "securityPageEntrypoint", () => $3c47774a85afa42a$export$5f2f9dbf41e3e769);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $1P5CH = parcelRequire("1P5CH");

var $9n5I0 = parcelRequire("9n5I0");
const $3c47774a85afa42a$export$5f2f9dbf41e3e769 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1P5CH.securityEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("1P5CH", function(module, exports) {

$parcel$export(module.exports, "securityEntrypoint", () => $beb98f489acbae48$export$63f7fc80f88b035a);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $beb98f489acbae48$export$63f7fc80f88b035a = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("92cgC")), {
        moduleId: "c02ceeea",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("92cgC", function(module, exports) {

let $693dd0f4305d1f44$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $693dd0f4305d1f44$var$load("1VRB2"),
    $693dd0f4305d1f44$var$load("bABhq"),
    $693dd0f4305d1f44$var$load("cCNDn")
]).then(()=>parcelRequire('2OTd5'));

});




parcelRegister("eOJip", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityNextGenRouteEntry", () => $9f7db4d6db645085$export$a8dcfae475505e7a);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $j9Woh = parcelRequire("j9Woh");

var $jg3Gs = parcelRequire("jg3Gs");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $kSeQy = parcelRequire("kSeQy");

var $aw3pZ = parcelRequire("aw3pZ");

var $1CTcA = parcelRequire("1CTcA");
const $9f7db4d6db645085$export$a8dcfae475505e7a = (0, $6xToB.createEntry)((0, $jg3Gs.softwareSecurityNextGenRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        ufoName: 'software-security-combined',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $j9Woh.securityPageResource)
        ],
        meta: {
            reporting: {
                id: 'software-security',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-security'),
                teamName: 'fusion-isotopes'
            }
        },
        entryPoint: ()=>(0, $aw3pZ.isSecurityPageEnabled)() ? (0, $1CTcA.securityPageEntrypoint) : (0, $kSeQy.notFoundPageEntrypoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("jg3Gs", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityNextGenRoute", () => $111df9a77319612f$export$a2aed78ebacc3233);
const $111df9a77319612f$export$a2aed78ebacc3233 = {
    name: 'software-security',
    path: '/jira/software/projects/:projectKey/security'
};

});


parcelRegister("jG7gV", function(module, exports) {

$parcel$export(module.exports, "softwareStaffingRouteEntry", () => $8ae2acec77d84478$export$71a3a4cc27cbe00a);

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $kSeQy = parcelRequire("kSeQy");

var $dZRaT = parcelRequire("dZRaT");

var $gVZAI = parcelRequire("gVZAI");

var $bTfc4 = parcelRequire("bTfc4");

var $5QMeL = parcelRequire("5QMeL");

var $dZ1hs = parcelRequire("dZ1hs");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $7jTnu = parcelRequire("7jTnu");

var $kRcgT = parcelRequire("kRcgT");
const $8ae2acec77d84478$export$71a3a4cc27cbe00a = (0, $6xToB.createEntry)((0, $5QMeL.softwareStaffingRoute), ()=>({
        group: 'software',
        skeleton: (0, $dZ1hs.RoadmapSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gVZAI.nextGenRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $7jTnu.fg)('staffing') ? (0, $kRcgT.staffingRouteEntrypoint) : (0, $kSeQy.notFoundPageEntrypoint),
        ufoName: 'next-gen-roadmap',
        supportsPreviewPanel: true
    }));

});
parcelRegister("5QMeL", function(module, exports) {

$parcel$export(module.exports, "softwareStaffingRoute", () => $be49f3a1685b518a$export$aa817709e0cb3b6d);
const $be49f3a1685b518a$export$aa817709e0cb3b6d = {
    name: 'software-staffing',
    path: '/jira/software/projects/:projectKey/boards/:boardId/staffing',
    query: [
        'issueKey?'
    ]
};

});

parcelRegister("kRcgT", function(module, exports) {

$parcel$export(module.exports, "staffingRouteEntrypoint", () => $2ca0dfc58ba98ae8$export$3a16ef365bcb8560);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $jYjM2 = parcelRequire("jYjM2");
const $2ca0dfc58ba98ae8$export$3a16ef365bcb8560 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jYjM2.staffingEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("jYjM2", function(module, exports) {

$parcel$export(module.exports, "staffingEntrypoint", () => $9150db313441eed0$export$94a659cc78d2756a);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $9150db313441eed0$export$94a659cc78d2756a = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("2iP4l")), {
        moduleId: "39c7d120",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2iP4l", function(module, exports) {

let $1ad4e0772f67f010$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1ad4e0772f67f010$var$load("1VRB2"),
    $1ad4e0772f67f010$var$load("bABhq"),
    $1ad4e0772f67f010$var$load("lHxNU")
]).then(()=>parcelRequire('ei39Q'));

});




parcelRegister("P4w4L", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryClassicRouteEntry", () => $60452c0180eff06d$export$f81c7c178a9483e8);

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $k6duF = parcelRequire("k6duF");

var $hS1gr = parcelRequire("hS1gr");

var $gSnkQ = parcelRequire("gSnkQ");

var $1uH1V = parcelRequire("1uH1V");

var $8FCAy = parcelRequire("8FCAy");

var $kHlOR = parcelRequire("kHlOR");

var $1tc80 = parcelRequire("1tc80");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $7jTnu = parcelRequire("7jTnu");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $60452c0180eff06d$var$summarySoftwarePageEntrypointOld = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1tc80.summarySoftwareEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $60452c0180eff06d$var$summarySoftwarePageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1tc80.summarySoftwareEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $60452c0180eff06d$export$f81c7c178a9483e8 = (0, $6xToB.createEntry)((0, $gSnkQ.softwareSummaryClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-summary',
        component: (0, $1uH1V.SummaryPage),
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            }),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1uH1V.LazySummaryView)
        ],
        entryPoint: ()=>(0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? $60452c0180eff06d$var$summarySoftwarePageEntrypoint : $60452c0180eff06d$var$summarySoftwarePageEntrypointOld,
        supportsPreviewPanel: true
    }));

});
parcelRegister("gSnkQ", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryClassicRoute", () => $19cfe75a59dcddc0$export$b5046fccf399983f);
const $19cfe75a59dcddc0$export$b5046fccf399983f = {
    name: 'software-summary-classic',
    path: '/jira/software/c/projects/:projectKey/summary'
};

});

parcelRegister("1uH1V", function(module, exports) {

$parcel$export(module.exports, "LazySummaryView", () => $df1656b2af7a06cb$export$68c09444cc6f2843);
$parcel$export(module.exports, "SummaryPage", () => $df1656b2af7a06cb$export$893608e1a22999b9);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $df1656b2af7a06cb$export$68c09444cc6f2843 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("k57um")), {
    moduleId: "./src/packages/spa-apps/software/summary/src/index.tsx"
});
const $df1656b2af7a06cb$export$893608e1a22999b9 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $df1656b2af7a06cb$export$68c09444cc6f2843,
        pageId: "software-summary",
        shouldShowSpinner: true
    });
};

});
parcelRegister("k57um", function(module, exports) {

let $e9ea15622c0fe015$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $e9ea15622c0fe015$var$load("1VRB2"),
    $e9ea15622c0fe015$var$load("bABhq"),
    $e9ea15622c0fe015$var$load("eDzss"),
    $e9ea15622c0fe015$var$load("knh3t")
]).then(()=>parcelRequire('krF71'));

});


parcelRegister("1tc80", function(module, exports) {

$parcel$export(module.exports, "summarySoftwareEntrypoint", () => $ff01ce3b8769d54f$export$6c7cf31fcbd213b8);

var $4Pmgf = parcelRequire("4Pmgf");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $ff01ce3b8769d54f$export$6c7cf31fcbd213b8 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("kxIHR")), {
        moduleId: "078ea488",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $4Pmgf.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("4Pmgf", function(module, exports) {

$parcel$export(module.exports, "default", () => $27e7fb29833522e9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2c0776ec3e9f6a74e53887f11a831651>>
 * @relayHash 51efb3864f270fc508c3c4676be5d9f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b8af805c4172b0ed36c74fe68563d0a938d57e1cf91158c7fa6cbe92c6dc022
const $27e7fb29833522e9$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8b8af805c4172b0ed36c74fe68563d0a938d57e1cf91158c7fa6cbe92c6dc022",
        "metadata": {},
        "name": "src_jiraSummarySoftwareQuery",
        "operationKind": "query",
        "text": null
    }
};
var $27e7fb29833522e9$export$2e2bcd8739ae039 = $27e7fb29833522e9$var$node;

});

parcelRegister("kxIHR", function(module, exports) {

let $ef499180799a4aa4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ef499180799a4aa4$var$load("1VRB2"),
    $ef499180799a4aa4$var$load("bABhq"),
    $ef499180799a4aa4$var$load("eDzss"),
    $ef499180799a4aa4$var$load("9Mg7t")
]).then(()=>parcelRequire('1ztFw'));

});



parcelRegister("8mw4w", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedClassicRouteEntry", () => $aff05c9a79c12694$export$1dc5e581d8ca39ac);

var $6xToB = parcelRequire("6xToB");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $klcPs = parcelRequire("klcPs");

var $aLyHG = parcelRequire("aLyHG");

var $7K5Ea = parcelRequire("7K5Ea");

var $6HzGw = parcelRequire("6HzGw");

var $g8uYY = parcelRequire("g8uYY");
const $aff05c9a79c12694$var$summarySoftwareEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $6HzGw.summarySoftwareEmbedEntrypoint)
});
const $aff05c9a79c12694$export$1dc5e581d8ca39ac = (0, $6xToB.createEntry)((0, $klcPs.softwareSummaryEmbedClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-summary',
        component: (0, $aLyHG.SummaryEmbedPage),
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource)
        ],
        forPaint: [
            (0, $aLyHG.LazySummaryEmbedView)
        ],
        entryPoint: ()=>{
            return $aff05c9a79c12694$var$summarySoftwareEmbedPageEntrypoint;
        }
    }));

});
parcelRegister("klcPs", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedClassicRoute", () => $6383f16946545167$export$7fa3d3891ccec782);
const $6383f16946545167$export$7fa3d3891ccec782 = {
    name: 'software-summary-classic-embed',
    path: '/jira/software/c/projects/:projectKey/summary/embed'
};

});

parcelRegister("aLyHG", function(module, exports) {

$parcel$export(module.exports, "LazySummaryEmbedView", () => $1b51973b94153624$export$f3f4cdbc1967d695);
$parcel$export(module.exports, "SummaryEmbedPage", () => $1b51973b94153624$export$f811b1e7f401bfca);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $1b51973b94153624$export$f3f4cdbc1967d695 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("kCMxS")), {
    moduleId: "./src/packages/spa-apps/software/summary-embed/src/index.tsx"
});
const $1b51973b94153624$export$f811b1e7f401bfca = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1b51973b94153624$export$f3f4cdbc1967d695,
        pageId: "software-summary-embed",
        shouldShowSpinner: true
    });
};

});
parcelRegister("kCMxS", function(module, exports) {

let $f03d0357f00e8db9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $f03d0357f00e8db9$var$load("1VRB2"),
    $f03d0357f00e8db9$var$load("bABhq"),
    $f03d0357f00e8db9$var$load("eDzss"),
    $f03d0357f00e8db9$var$load("foJ1m")
]).then(()=>parcelRequire('g47mS'));

});


parcelRegister("6HzGw", function(module, exports) {

$parcel$export(module.exports, "summarySoftwareEmbedEntrypoint", () => $05a7199529b59515$export$4eeb5d2e0e9b94b6);

var $4Ys8W = parcelRequire("4Ys8W");

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $05a7199529b59515$export$4eeb5d2e0e9b94b6 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("fEG60")), {
        moduleId: "192c966d",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $4Ys8W.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("4Ys8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cc8acf451e49995$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<28aa849ce641b8c8bef67b5f178b9188>>
 * @relayHash 886a8ebe0b7faaa17276f23a1313cc2e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ec953cd8f672124749ec67356940dfd48e2bc1b926c2f3ce46d963fbecdceed3
const $0cc8acf451e49995$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ec953cd8f672124749ec67356940dfd48e2bc1b926c2f3ce46d963fbecdceed3",
        "metadata": {},
        "name": "src_jiraSummarySoftwareEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0cc8acf451e49995$export$2e2bcd8739ae039 = $0cc8acf451e49995$var$node;

});

parcelRegister("fEG60", function(module, exports) {

let $b65b3ecbdf7c7fd7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $b65b3ecbdf7c7fd7$var$load("1VRB2"),
    $b65b3ecbdf7c7fd7$var$load("bABhq"),
    $b65b3ecbdf7c7fd7$var$load("eDzss"),
    $b65b3ecbdf7c7fd7$var$load("9lOvc")
]).then(()=>parcelRequire('jUUzt'));

});



parcelRegister("gJeDi", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedRouteEntry", () => $4acec4b40dd21904$export$d0dcb1130082d8e);

var $7mF43 = parcelRequire("7mF43");

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $lqXVd = parcelRequire("lqXVd");

var $hHbzj = parcelRequire("hHbzj");

var $dZRaT = parcelRequire("dZRaT");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $6HzGw = parcelRequire("6HzGw");

var $g8uYY = parcelRequire("g8uYY");

var $aLyHG = parcelRequire("aLyHG");
const $4acec4b40dd21904$var$summarySoftwareEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $6HzGw.summarySoftwareEmbedEntrypoint)
});
const $4acec4b40dd21904$export$d0dcb1130082d8e = (0, $6xToB.createEntry)((0, $lqXVd.softwareSummaryEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-summary-embed',
        component: (0, $aLyHG.SummaryEmbedPage),
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource)
        ],
        forPaint: [
            (0, $aLyHG.LazySummaryEmbedView)
        ],
        meta: {
            reporting: {
                id: 'software-summary-embed',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-summary-embed'),
                teamName: 'Helios - HeadCoach'
            }
        },
        entryPoint: ()=>$4acec4b40dd21904$var$summarySoftwareEmbedPageEntrypoint
    }));

});
parcelRegister("lqXVd", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedRoute", () => $21733fd4911a9716$export$11863f01f5694529);
const $21733fd4911a9716$export$11863f01f5694529 = {
    name: 'software-summary-embed',
    path: '/jira/software/projects/:projectKey/summary/embed'
};

});


parcelRegister("sK3EH", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryRouteEntry", () => $a04a5c9ffa7e9f47$export$a2560b0baf928c49);

var $7mF43 = parcelRequire("7mF43");

var $kHlOR = parcelRequire("kHlOR");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $jnf2p = parcelRequire("jnf2p");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $1tc80 = parcelRequire("1tc80");

var $9n5I0 = parcelRequire("9n5I0");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $1uH1V = parcelRequire("1uH1V");
const $a04a5c9ffa7e9f47$var$summarySoftwarePageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1tc80.summarySoftwareEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $a04a5c9ffa7e9f47$export$a2560b0baf928c49 = (0, $6xToB.createEntry)((0, $jnf2p.softwareSummaryRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-summary',
        component: (0, $1uH1V.SummaryPage),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1uH1V.LazySummaryView)
        ],
        meta: {
            reporting: {
                id: 'software-summary',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-summary'),
                teamName: 'Helios - HeadCoach'
            }
        },
        entryPoint: ()=>$a04a5c9ffa7e9f47$var$summarySoftwarePageEntrypoint,
        supportsPreviewPanel: true
    }));

});
parcelRegister("jnf2p", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryRoute", () => $75af821138bed7de$export$c6629202e90df62a);
const $75af821138bed7de$export$c6629202e90df62a = {
    name: 'software-summary',
    path: '/jira/software/projects/:projectKey/summary'
};

});


parcelRegister("cOBeu", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineClassicRouteEntry", () => $2e392201bb2d8213$export$a822ee67d4c66296);

var $6xToB = parcelRequire("6xToB");

var $7K3zE = parcelRequire("7K3zE");

var $dZ1hs = parcelRequire("dZ1hs");

var $6dwgv = parcelRequire("6dwgv");

var $8FCAy = parcelRequire("8FCAy");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $5AZok = parcelRequire("5AZok");

var $eJe5A = parcelRequire("eJe5A");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $7jTnu = parcelRequire("7jTnu");

var $10HnM = parcelRequire("10HnM");
const $2e392201bb2d8213$export$a822ee67d4c66296 = (0, $6xToB.createEntry)((0, $7K3zE.softwareTimelineClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $dZ1hs.RoadmapSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayoutCode), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $hHbzj.forgeProjectModuleResourceOnNav3Only),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5AZok.classicRoadmapResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        ufoName: 'classic-roadmap',
        entryPoint: ()=>(0, $7jTnu.fg)('jfp-magma-sidenav-cmp-ssr') ? (0, $10HnM.roadmapViewClassicPageEntrypoint) : (0, $10HnM.roadmapViewClassicPageEntrypointOld),
        supportsPreviewPanel: true
    }));

});
parcelRegister("7K3zE", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineClassicRoute", () => $87a72ac71d826c06$export$ce5173f7e8fa932b);
const $87a72ac71d826c06$export$ce5173f7e8fa932b = {
    name: 'software-timeline-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline'
};

});

parcelRegister("10HnM", function(module, exports) {

$parcel$export(module.exports, "roadmapViewClassicPageEntrypointOld", () => $19e4ed228bf9a578$export$8bbfd4eae92754d2);
$parcel$export(module.exports, "roadmapViewClassicPageEntrypoint", () => $19e4ed228bf9a578$export$af2674d32463682f);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9l6MC = parcelRequire("9l6MC");

var $9n5I0 = parcelRequire("9n5I0");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $19e4ed228bf9a578$export$8bbfd4eae92754d2 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9l6MC.roadmapViewClassicEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $19e4ed228bf9a578$export$af2674d32463682f = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9l6MC.roadmapViewClassicEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("9l6MC", function(module, exports) {

$parcel$export(module.exports, "roadmapViewClassicEntrypoint", () => $0627e011b9c3909f$export$583357f75b3be3a7);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $0627e011b9c3909f$export$583357f75b3be3a7 = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("SX4qK")), {
        moduleId: "7a5c4192",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("SX4qK", function(module, exports) {

let $0a52dd6c57e0a707$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $0a52dd6c57e0a707$var$load("esKGV")
        ]);
    }, function() {
        return Promise.all([
            $0a52dd6c57e0a707$var$load("7uqQP")
        ]);
    }),
    $0a52dd6c57e0a707$var$load("1VRB2"),
    $0a52dd6c57e0a707$var$load("bABhq"),
    $0a52dd6c57e0a707$var$load("fo5MZ")
]).then(()=>parcelRequire('cfAGP'));

});




parcelRegister("b4ktm", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineRouteEntry", () => $2ae5fd59ddeb8280$export$ace6a996c7e99f3);

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $gVZAI = parcelRequire("gVZAI");

var $bTfc4 = parcelRequire("bTfc4");

var $6200o = parcelRequire("6200o");

var $dZ1hs = parcelRequire("dZ1hs");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $7jTnu = parcelRequire("7jTnu");

var $9HMp0 = parcelRequire("9HMp0");
const $2ae5fd59ddeb8280$export$ace6a996c7e99f3 = (0, $6xToB.createEntry)((0, $6200o.softwareTimelineRoute), ()=>({
        group: 'software',
        skeleton: (0, $dZ1hs.RoadmapSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayoutCode), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dZRaT.projectContextResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $hHbzj.forgeProjectModuleResourceOnNav3Only),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gVZAI.nextGenRoadmapResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $9HMp0.softwareTimelinePageEntrypoint),
        ufoName: 'next-gen-roadmap',
        supportsPreviewPanel: true
    }));

});
parcelRegister("6200o", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineRoute", () => $add6335d703ccc5e$export$d25dafcda96d5af9);
const $add6335d703ccc5e$export$d25dafcda96d5af9 = {
    name: 'software-timeline',
    path: '/jira/software/projects/:projectKey/boards/:boardId/timeline'
};

});

parcelRegister("9HMp0", function(module, exports) {

$parcel$export(module.exports, "softwareTimelinePageEntrypoint", () => $6639053e514fce7b$export$3315ee4fac32ee8);

var $g8uYY = parcelRequire("g8uYY");

var $9n5I0 = parcelRequire("9n5I0");

var $5RW99 = parcelRequire("5RW99");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $1tNcH = parcelRequire("1tNcH");
const $6639053e514fce7b$export$3315ee4fac32ee8 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1tNcH.softwareTimelineEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("1tNcH", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineEntrypoint", () => $99541c1075010b47$export$85a905c235ac34bb);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $99541c1075010b47$export$85a905c235ac34bb = (0, $4BK1O.createEntryPoint)({
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("65RKy")), {
        moduleId: "7e6b0610",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});



parcelRegister("bbpTw", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailEmbedRouteEntry", () => $4efa1afec1282a7c$export$83102a6097008c79);

var $7mF43 = parcelRequire("7mF43");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $e8qID = parcelRequire("e8qID");

var $biYD4 = parcelRequire("biYD4");

var $pXQf9 = parcelRequire("pXQf9");

var $b9TxA = parcelRequire("b9TxA");
const $4efa1afec1282a7c$export$83102a6097008c79 = (0, $6xToB.createEntry)((0, $biYD4.softwareVersionDetailEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'software.version-details-page-embed',
        component: (0, $b9TxA.VersionDetailPage),
        skeleton: (0, $pXQf9.VersionDetailSkeleton),
        canTransitionIn: ()=>true,
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $e8qID.versionDetailsRelayResourceCustom),
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $b9TxA.LazyVersionDetail)
        ],
        meta: {
            reporting: {
                id: 'software-version-detail-embed',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-version-detail-embed'),
                teamName: 'jolt'
            }
        }
    }));

});
parcelRegister("e8qID", function(module, exports) {

$parcel$export(module.exports, "versionDetailsRelayResourceCustom", () => $093af761ad29e12a$export$c56c5b19da4d0fd1);
/* eslint-disable jira/import-whitelist */ 
var $j4oe4 = parcelRequire("j4oe4");

var $8oKDI = parcelRequire("8oKDI");

var $7zZ4w = parcelRequire("7zZ4w");

var $7797X = parcelRequire("7797X");

var $9FYIg = parcelRequire("9FYIg");

var $7jTnu = parcelRequire("7jTnu");

var $gxaZP = parcelRequire("gxaZP");

var $jom8W = parcelRequire("jom8W");

var $lmneG = parcelRequire("lmneG");

var $aV23b = parcelRequire("aV23b");

var $l1VxS = parcelRequire("l1VxS");

const $093af761ad29e12a$export$c56c5b19da4d0fd1 = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $c2c2624ba1e66154$export$9fe575a15a87a796)}`,
    // Deliberately returning the static key, not to rerun query by resource, as different key returns null queryReference shortly while the query is running, when filter query parameter is changed,
    // which is believed to be a bug in react-resource-router part, but we don't know the reason yet.
    // Context: https://atlassian.slack.com/archives/CFLN3FEF8/p1680495188086669
    // Due to the same bug, issue navigator team is doing the similar technique: src/packages/routes/src/ui/spa/issue-navigator/resources/index.tsx
    getKey: ({ match: match })=>{
        const { versionId: versionId } = match.params;
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        return `jsw-releases-version-details-main-query-relay-${parsedVersionId}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { versionId: versionId, projectKey: projectKey } = match.params;
        const { filters: filters, sortBy: sortBy } = (0, $lmneG.toVersionIssuesGraphQLVariables)(query);
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        // eslint-disable-next-line jira/ff/inline-usage
        const variables = {
            cloudAri: (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                resourceType: 'site',
                resourceId: tenantContext.cloudId
            }),
            versionAri: (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'version/activation',
                resourceId: String(`${tenantContext.activationId}/${parsedVersionId}`)
            }),
            sortBy: sortBy,
            filters: filters,
            skip: !(0, $aV23b.checkAuthentication)(tenantContext) || parsedVersionId.length === 0,
            isDevopsFeatureDisabledInFedRamp: (0, $jom8W.isDevopsFeatureDisabledInFedRamp)(),
            shouldIncludeDevOpsFieldsViaAgs: !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)(),
            cloudId: tenantContext.cloudId,
            projectKey: projectKey || '',
            isReleasesUpdateStatusPermissionFixEnabled: (0, $7jTnu.fg)('jira-releases-update-status-permission-fix')
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $gxaZP.default), variables, {
            fetchPolicy: 'store-or-network'
        });
        if (false && queryReference.id != null) await (0, $7797X.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("gxaZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $910b8eb3fcf5cae4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d80440392fbc1a8dc71584d6ecd98b2>>
 * @relayHash a880580d17ea37c1ecf818a2e8b64373
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 272a4ac907ee41981af68e0c4a9bc140b3018d431ffc6ce53d40294d2a147114
const $910b8eb3fcf5cae4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "272a4ac907ee41981af68e0c4a9bc140b3018d431ffc6ce53d40294d2a147114",
        "metadata": {},
        "name": "uiVersionDetailsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $910b8eb3fcf5cae4$export$2e2bcd8739ae039 = $910b8eb3fcf5cae4$var$node;

});

parcelRegister("lmneG", function(module, exports) {

$parcel$export(module.exports, "toVersionIssuesGraphQLVariables", () => $453b056fc5ef9815$export$72df1c7780b3e8e2);
$parcel$export(module.exports, "useVersionIssuesGraphQLVariables", () => $453b056fc5ef9815$export$3d12d3ffbce57135);

var $9TL1j = parcelRequire("9TL1j");


var $lFI9l = parcelRequire("lFI9l");

var $fnAle = parcelRequire("fnAle");
const $453b056fc5ef9815$var$accountIdToAriStr = (accountIds)=>{
    if (accountIds == null) return null;
    return accountIds.map((accountId)=>accountId === 'UNASSIGNED' ? null : `ari:cloud:identity::user/${accountId}`);
};
const $453b056fc5ef9815$export$72df1c7780b3e8e2 = (queryParams)=>{
    const parsedQueryParams = (0, $fnAle.parseQueryParams)(queryParams);
    return {
        filters: {
            searchStr: parsedQueryParams[0, $3b2c8cea68e59ddc$export$e39925d10cebc0b] ?? null,
            epicIds: parsedQueryParams[0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac] ?? null,
            statusCategories: parsedQueryParams[0, $3b2c8cea68e59ddc$export$c307007520232013] != null ? parsedQueryParams[0, $3b2c8cea68e59ddc$export$c307007520232013].filter((0, $lFI9l.isVersionStatusCategory)) : null,
            warningCategories: parsedQueryParams[0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd] ?? null,
            assigneeAccountIds: $453b056fc5ef9815$var$accountIdToAriStr(parsedQueryParams[0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2])
        },
        sortBy: {
            sortByField: parsedQueryParams[0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6] ?? 'CREATED',
            order: parsedQueryParams[0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb] ?? 'ASC'
        }
    };
};
const $453b056fc5ef9815$export$3d12d3ffbce57135 = ()=>{
    const [queryParams] = (0, $9TL1j.useQueryParams)((0, $3b2c8cea68e59ddc$export$e39925d10cebc0b), (0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac), (0, $3b2c8cea68e59ddc$export$c307007520232013), (0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd), (0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2), (0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6), (0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb));
    return $453b056fc5ef9815$export$72df1c7780b3e8e2(queryParams);
};

});
parcelRegister("9TL1j", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $9b93c18fc273cb0f$export$b37ee0d76c6d2fbc);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $jPROM = parcelRequire("jPROM");

var $4lYQk = parcelRequire("4lYQk");

var $b5RwB = parcelRequire("b5RwB");

var $7jTnu = parcelRequire("7jTnu");

var $hrKgE = parcelRequire("hrKgE");

var $gCY1z = parcelRequire("gCY1z");
const $9b93c18fc273cb0f$export$b37ee0d76c6d2fbc = (...unstableQueryParamsToWatch)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push, replace: replace }] = (0, $gCY1z.useRouter)();
    const queryParamsRef = (0, $eJOHy.useRef)({});
    // ensure queryParamsToWatch is not a new array on every invocation
    const queryParamsToWatch = (0, $hrKgE.useShallowStableReference)(unstableQueryParamsToWatch, (0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
    const parsedQueryParams = (0, $eJOHy.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = queryParamsToWatch.reduce((accumulator, currentValue)=>{
            accumulator[currentValue] = query[currentValue] || undefined;
            return accumulator;
        }, {});
        // update cache only when one of requested params actually changed
        // otherwise return cached value to avoid changing return object reference
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(queryParamsRef.current, newQueryParams)) queryParamsRef.current = newQueryParams;
        return queryParamsRef.current;
    }, [
        query,
        queryParamsToWatch
    ]);
    const setQueryParams = (0, $eJOHy.useCallback)((newQueryParams, options)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
            ...query,
            ...newQueryParams
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value));
        const { updateType: updateType, ...stringifyOptions } = options ?? {};
        // @ts-expect-error - TS2559 - Type '{ sort?: false | ((a: string, b: string) => number) | undefined; }' has no properties in common with type 'StringifyOptions'.
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(parsedSearch, stringifyOptions);
        const url = pathname + (strSearch !== '' ? `?${strSearch}` : '');
        updateType === 'replace' ? replace(url) : push(url);
    }, [
        pathname,
        push,
        replace,
        query
    ]);
    return [
        parsedQueryParams,
        setQueryParams
    ];
};

});

const $3b2c8cea68e59ddc$export$e39925d10cebc0b = 'text';
const $3b2c8cea68e59ddc$export$b98a7875ddbefaac = 'epics';
const $3b2c8cea68e59ddc$export$c307007520232013 = 'statusCategory';
const $3b2c8cea68e59ddc$export$2552faed9df6a2cd = 'warnings';
const $3b2c8cea68e59ddc$export$f78d8c81fcad32a2 = 'assignee';
const $3b2c8cea68e59ddc$export$13d5b2891ca65cd6 = 'sortBy';
const $3b2c8cea68e59ddc$export$810a1f7ed2facfcb = 'sortOrder';

parcelRegister("lFI9l", function(module, exports) {

$parcel$export(module.exports, "isWarningsFilterValue", () => $f1972a48dcbcd304$export$5c25bcf27380084);
$parcel$export(module.exports, "toWarningsFilterValue", () => $f1972a48dcbcd304$export$ac3017cd78edb8a1);
$parcel$export(module.exports, "isVersionStatusCategory", () => $f1972a48dcbcd304$export$3af93bbba0d4241a);
$parcel$export(module.exports, "isSortBy", () => $f1972a48dcbcd304$export$472650e4cbd40b70);
$parcel$export(module.exports, "isSortOrder", () => $f1972a48dcbcd304$export$dfece8cb679d32a3);

var $7keuM = parcelRequire("7keuM");
const $f1972a48dcbcd304$export$5c25bcf27380084 = (val)=>val === 'OPEN_PULL_REQUEST' || val === 'UNREVIEWED_CODE' || val === 'FAILING_BUILD' || val === 'OPEN_REVIEW';
const $f1972a48dcbcd304$export$ac3017cd78edb8a1 = (statusCategoryFromQueryParam)=>statusCategoryFromQueryParam.filter($f1972a48dcbcd304$export$5c25bcf27380084);
const $f1972a48dcbcd304$export$3af93bbba0d4241a = (val)=>val === (0, $7keuM.TODO) || val === (0, $7keuM.IN_PROGRESS) || val === (0, $7keuM.DONE);
const $f1972a48dcbcd304$export$472650e4cbd40b70 = (val)=>val === 'ASSIGNEE' || val === 'CREATED' || val === 'KEY' || val === 'PRIORITY' || val === 'STATUS' || val === 'TYPE';
const $f1972a48dcbcd304$export$dfece8cb679d32a3 = (val)=>val === 'ASC' || val === 'DESC';

});
parcelRegister("7keuM", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e9fafd5bde6d9f47$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e9fafd5bde6d9f47$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e9fafd5bde6d9f47$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e9fafd5bde6d9f47$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e9fafd5bde6d9f47$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e9fafd5bde6d9f47$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e9fafd5bde6d9f47$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e9fafd5bde6d9f47$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e9fafd5bde6d9f47$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e9fafd5bde6d9f47$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e9fafd5bde6d9f47$export$d928f247c903643a);
const $e9fafd5bde6d9f47$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e9fafd5bde6d9f47$export$aa456a5030160740 = 'TODO';
const $e9fafd5bde6d9f47$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e9fafd5bde6d9f47$export$71efb3495f6084f2 = 'DONE';
const $e9fafd5bde6d9f47$export$d9119300f9d9a815 = [
    $e9fafd5bde6d9f47$export$6db089fe7b26f5b6,
    $e9fafd5bde6d9f47$export$aa456a5030160740,
    $e9fafd5bde6d9f47$export$5a9ac66c2785cc13,
    $e9fafd5bde6d9f47$export$71efb3495f6084f2
];
const $e9fafd5bde6d9f47$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e9fafd5bde6d9f47$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e9fafd5bde6d9f47$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e9fafd5bde6d9f47$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e9fafd5bde6d9f47$export$71efb3495f6084f2
    }
];
const $e9fafd5bde6d9f47$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e9fafd5bde6d9f47$export$3f42f49c284d5b58 = Object.freeze({
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.NEW]: 2,
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.DONE]: 3,
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e9fafd5bde6d9f47$export$f3f919dc0f56d9eb = Object.values($e9fafd5bde6d9f47$export$5d42a08d46cffe7);
const $e9fafd5bde6d9f47$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e9fafd5bde6d9f47$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e9fafd5bde6d9f47$export$6db089fe7b26f5b6;
};
const $e9fafd5bde6d9f47$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e9fafd5bde6d9f47$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e9fafd5bde6d9f47$export$d928f247c903643a = (key)=>$e9fafd5bde6d9f47$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("fnAle", function(module, exports) {

$parcel$export(module.exports, "isAnyFilterApplied", () => $3d595c70b0b1b789$export$e6b3ec1d09429da8);
$parcel$export(module.exports, "parseQueryParams", () => $3d595c70b0b1b789$export$67c4cee80a3410cd);

var $ljej9 = parcelRequire("ljej9");


var $lFI9l = parcelRequire("lFI9l");
const $3d595c70b0b1b789$export$e6b3ec1d09429da8 = (parsedQueryParams)=>parsedQueryParams[0, $3b2c8cea68e59ddc$export$e39925d10cebc0b] != null && parsedQueryParams[0, $3b2c8cea68e59ddc$export$e39925d10cebc0b].length > 0 || parsedQueryParams[0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac] != null && parsedQueryParams[0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac].length > 0 || parsedQueryParams[0, $3b2c8cea68e59ddc$export$c307007520232013] != null && parsedQueryParams[0, $3b2c8cea68e59ddc$export$c307007520232013].length > 0 || parsedQueryParams[0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd] != null && parsedQueryParams[0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd].length > 0 || parsedQueryParams[0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2] != null && parsedQueryParams[0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2].length > 0;
const $3d595c70b0b1b789$export$2a2e94972ab280d4 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).map((0, $ljej9.toIssueId));
const $3d595c70b0b1b789$export$fb136b568c6d78b5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).filter((0, $lFI9l.isVersionStatusCategory));
const $3d595c70b0b1b789$export$5cb324c621ca24e8 = (paramValue)=>paramValue == null ? undefined : (0, $lFI9l.toWarningsFilterValue)(paramValue.split(',').map((str)=>str.trim()));
const $3d595c70b0b1b789$export$6c8eda0352c7cf5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>(0, $ljej9.toAccountId)(str.trim()));
const $3d595c70b0b1b789$export$67c4cee80a3410cd = (paramsRaw)=>{
    const result = {};
    result[0, $3b2c8cea68e59ddc$export$e39925d10cebc0b] = paramsRaw[0, $3b2c8cea68e59ddc$export$e39925d10cebc0b];
    result[0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac] = $3d595c70b0b1b789$export$2a2e94972ab280d4(paramsRaw[0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac]);
    result[0, $3b2c8cea68e59ddc$export$c307007520232013] = $3d595c70b0b1b789$export$fb136b568c6d78b5(paramsRaw[0, $3b2c8cea68e59ddc$export$c307007520232013]);
    result[0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd] = $3d595c70b0b1b789$export$5cb324c621ca24e8(paramsRaw[0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd]);
    result[0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2] = $3d595c70b0b1b789$export$6c8eda0352c7cf5(paramsRaw[0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2]);
    result[0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6] = paramsRaw[0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6] && (0, $lFI9l.isSortBy)(paramsRaw[0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6]) ? paramsRaw[0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6] : 'CREATED';
    result[0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb] = paramsRaw[0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb] && (0, $lFI9l.isSortOrder)(paramsRaw[0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb]) ? paramsRaw[0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb] : 'ASC';
    return result;
};

});


const $c2c2624ba1e66154$export$9fe575a15a87a796 = 'PROJECTS_VERSION_DETAILS';


parcelRegister("biYD4", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailEmbedRoute", () => $db2f0457e0cd0a5e$export$78d11017d9c9ed74);
const $db2f0457e0cd0a5e$export$78d11017d9c9ed74 = {
    name: 'software-version-detail-embed',
    path: '/projects/:projectKey/versions/:versionId/tab/:tab/embed',
    exact: true
};

});

parcelRegister("pXQf9", function(module, exports) {

$parcel$export(module.exports, "VersionDetailSkeleton", () => $57678ade70775797$export$b3661a594ba34350);

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $fRM1z = parcelRequire("fRM1z");
const $57678ade70775797$export$b3661a594ba34350 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fRM1z)))
    });

});
parcelRegister("fRM1z", function(module, exports) {
module.exports = new URL("version-detail-skeleton.tpl.c4c4fc18.svg", import.meta.url).toString();

});


parcelRegister("b9TxA", function(module, exports) {

$parcel$export(module.exports, "LazyVersionDetail", () => $b47f0cbc811edfc4$export$2d31f5f47e6584e0);
$parcel$export(module.exports, "VersionDetailPage", () => $b47f0cbc811edfc4$export$231cc5186b991031);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $b47f0cbc811edfc4$export$2d31f5f47e6584e0 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("kKfX4"))), {
    moduleId: "./src/packages/spa-apps/version-detail/src/index.tsx"
});
const $b47f0cbc811edfc4$export$231cc5186b991031 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $b47f0cbc811edfc4$export$2d31f5f47e6584e0,
        pageId: "version-detail",
        shouldShowSpinner: false
    });

});
parcelRegister("kKfX4", function(module, exports) {

let $f1a47a31a897f626$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $f1a47a31a897f626$var$load("1VRB2"),
    $f1a47a31a897f626$var$load("bABhq"),
    $f1a47a31a897f626$var$load("657el")
]).then(()=>parcelRequire('dHrmQ'));

});



parcelRegister("hSovm", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailLegacyRedirectRouteEntry", () => $7deeca3407c19851$export$f29aafdff734071c);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $i5UPO = parcelRequire("i5UPO");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $b9TxA = parcelRequire("b9TxA");

var $6sjNg = parcelRequire("6sjNg");
const $7deeca3407c19851$export$f29aafdff734071c = (0, $6xToB.createEntry)((0, $i5UPO.softwareVersionDetailLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $6sjNg.VersionDetailPageLegacyRedirect),
        canTransitionIn: ()=>true,
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: [
                (0, $gHEJe.default),
                (0, $k6duF.default)
            ],
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b9TxA.LazyVersionDetail)
        ]
    }));

});
parcelRegister("i5UPO", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailLegacyRedirectRoute", () => $a0f678f2aeb0b7bf$export$3fc8dbcec208bca0);
const $a0f678f2aeb0b7bf$export$3fc8dbcec208bca0 = {
    name: 'software-version-detail-legacy-redirect',
    path: '/browse/:projectKey/fixforversion/:versionId'
};

});

parcelRegister("6sjNg", function(module, exports) {

$parcel$export(module.exports, "VersionDetailPageLegacyRedirect", () => $8e2c5568143424b0$export$8524eef1a0d9339);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $8e2c5568143424b0$export$8524eef1a0d9339 = ({ match: { params: { projectKey: projectKey, versionId: versionId, tab: tab } } })=>{
    // This should never happen as if it wasn't matched, this won't be rendered unless someone re-used this component in a wrong route.
    if (projectKey == null || versionId == null) throw Error('projectKey or versionId not found in match object of RouteContext');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/projects/${projectKey}/versions/${versionId}/tab/${tab != null ? tab : 'release-report-all-issues'}`
    });
};

});


parcelRegister("bwfaS", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailNoTabPathRedirectRouteEntry", () => $7489c06f979d3a22$export$28d16aae32969765);

var $kHlOR = parcelRequire("kHlOR");

var $hS1gr = parcelRequire("hS1gr");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $luYFh = parcelRequire("luYFh");

var $8FCAy = parcelRequire("8FCAy");

var $b9TxA = parcelRequire("b9TxA");

var $6sjNg = parcelRequire("6sjNg");
const $7489c06f979d3a22$export$28d16aae32969765 = (0, $6xToB.createEntry)((0, $luYFh.softwareVersionDetailNoTabPathRedirectRoute), ()=>({
        group: 'software',
        component: (0, $6sjNg.VersionDetailPageLegacyRedirect),
        canTransitionIn: ()=>true,
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: [
                (0, $gHEJe.default),
                (0, $k6duF.default)
            ],
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b9TxA.LazyVersionDetail)
        ]
    }));

});
parcelRegister("luYFh", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailNoTabPathRedirectRoute", () => $487375562c86a47b$export$f22288f2d2f1b9ea);
const $487375562c86a47b$export$f22288f2d2f1b9ea = {
    name: 'software-version-detail-no-tab-path',
    path: '/projects/:projectKey/versions/:versionId'
};

});


parcelRegister("3B2tH", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailRouteEntry", () => $056260fcccda16c0$export$c97dabcfe9d495fa);

var $7mF43 = parcelRequire("7mF43");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $e8qID = parcelRequire("e8qID");

var $jGzvY = parcelRequire("jGzvY");

var $pXQf9 = parcelRequire("pXQf9");

var $8FCAy = parcelRequire("8FCAy");

var $b9TxA = parcelRequire("b9TxA");
const $056260fcccda16c0$export$c97dabcfe9d495fa = (0, $6xToB.createEntry)((0, $jGzvY.softwareVersionDetailRoute), ()=>({
        group: 'software',
        ufoName: 'software.version-details-page',
        component: (0, $b9TxA.VersionDetailPage),
        skeleton: (0, $pXQf9.VersionDetailSkeleton),
        canTransitionIn: ()=>true,
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: [
                (0, $gHEJe.default),
                (0, $k6duF.default)
            ]
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $e8qID.versionDetailsRelayResourceCustom),
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b9TxA.LazyVersionDetail)
        ],
        meta: {
            reporting: {
                id: 'software-version-detail',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-version-detail'),
                teamName: 'jolt'
            }
        },
        supportsPreviewPanel: true
    }));

});
parcelRegister("jGzvY", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailRoute", () => $c01056ae20384729$export$eb3633614d0521b0);
const $c01056ae20384729$export$eb3633614d0521b0 = {
    name: 'software-version-detail',
    path: '/projects/:projectKey/versions/:versionId/tab/:tab'
};

});


parcelRegister("k5ls9", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundClassicRouteEntry", () => $4613376441cf04e1$export$191700cbad42b1f0);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $iUszy = parcelRequire("iUszy");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $lqm4V = parcelRequire("lqm4V");
const $4613376441cf04e1$export$191700cbad42b1f0 = (0, $6xToB.createEntry)((0, $iUszy.softwareViewNotFoundClassicRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $lqm4V.projectViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("iUszy", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundClassicRoute", () => $1971c449be2d04e5$export$7d9d54603ab2405d);
const $1971c449be2d04e5$export$7d9d54603ab2405d = {
    name: 'software-view-not-found-classic',
    exact: true,
    path: '/jira/software/c/projects/:projectKey/not-found'
};

});


parcelRegister("4MZMG", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundRouteEntry", () => $d56fcee8471bd245$export$7dab5fe9ccb76142);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $lMlAU = parcelRequire("lMlAU");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $lqm4V = parcelRequire("lqm4V");
const $d56fcee8471bd245$export$7dab5fe9ccb76142 = (0, $6xToB.createEntry)((0, $lMlAU.softwareViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $lqm4V.projectViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("lMlAU", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundRoute", () => $f907c0d8f3b26026$export$d72ea457f192511a);
const $f907c0d8f3b26026$export$d72ea457f192511a = {
    name: 'software-view-not-found',
    exact: true,
    path: '/jira/software/projects/:projectKey/not-found'
};

});


parcelRegister("24gKw", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRedirectRouteEntry", () => $2ee8742bdcb17b15$export$7c2e1ea4fc4a192f);

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $aNm4v = parcelRequire("aNm4v");

var $bIKjp = parcelRequire("bIKjp");

var $ddnsq = parcelRequire("ddnsq");
const $2ee8742bdcb17b15$export$7c2e1ea4fc4a192f = (0, $6xToB.createEntry)((0, $bIKjp.systemConfigurationRedirectRoute), ()=>({
        group: 'global-settings',
        component: (0, $ddnsq.default),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $aNm4v.systemConfigurationGeneralResource)
        ]
    }));

});
parcelRegister("bIKjp", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRedirectRoute", () => $3c632af1592fd7a2$export$fe4807c49c838619);
const $3c632af1592fd7a2$export$fe4807c49c838619 = {
    name: 'system-configuration-general-redirect',
    path: '/secure/admin/ViewApplicationProperties.jspa',
    exact: true
};

});

parcelRegister("ddnsq", function(module, exports) {

$parcel$export(module.exports, "default", () => $15de031707fe4265$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$15de031707fe4265$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/settings/system/general-configuration"
    });

});


parcelRegister("g09EF", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRouteEntry", () => $ebc71916855bf4f7$export$360a82088f35f2f);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $aNm4v = parcelRequire("aNm4v");

var $abqtT = parcelRequire("abqtT");

var $5fjzQ = parcelRequire("5fjzQ");

var $lglN2 = parcelRequire("lglN2");
const $ebc71916855bf4f7$export$360a82088f35f2f = (0, $6xToB.createEntry)((0, $abqtT.systemConfigurationRoute), ()=>({
        group: 'global-settings',
        component: (0, $lglN2.default),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $aNm4v.systemConfigurationGeneralResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $lglN2.LazySystemConfigurationGeneral)
        ]
    }));

});
parcelRegister("abqtT", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRoute", () => $874d4d0fe60ce0f1$export$6823cb5626e61bc7);
const $874d4d0fe60ce0f1$export$6823cb5626e61bc7 = {
    name: 'system-configuration-general',
    path: '/jira/settings/system/general-configuration',
    exact: true
};

});

parcelRegister("lglN2", function(module, exports) {

$parcel$export(module.exports, "LazySystemConfigurationGeneral", () => $a9db316bd4d3ce4b$export$c452a8c622781ccd);
$parcel$export(module.exports, "default", () => $a9db316bd4d3ce4b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $a9db316bd4d3ce4b$export$c452a8c622781ccd = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3FofB"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/system-configuration-general/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a9db316bd4d3ce4b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a9db316bd4d3ce4b$export$c452a8c622781ccd,
        pageId: "system-configuration-general",
        shouldShowSpinner: false
    });

});
parcelRegister("3FofB", function(module, exports) {

let $2ab80321bc973303$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2ab80321bc973303$var$load("fCxGX").then(()=>parcelRequire('r0ivy'));

});



parcelRegister("as2yW", function(module, exports) {

$parcel$export(module.exports, "systemDashboardEditRouteEntry", () => $144f46dad9ea25f5$export$15f76f1b0d2d671);

var $kHlOR = parcelRequire("kHlOR");

var $7IYIF = parcelRequire("7IYIF");

var $1wb5r = parcelRequire("1wb5r");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $jlaZM = parcelRequire("jlaZM");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $5iRTf = parcelRequire("5iRTf");

var $en43l = parcelRequire("en43l");
const $144f46dad9ea25f5$export$15f76f1b0d2d671 = (0, $6xToB.createEntry)((0, $5iRTf.systemDashboardEditRoute), ()=>({
        group: 'dashboard',
        component: (0, $en43l.SystemDashboardEditPage),
        layout: (0, $6dwgv.composeLayouts)((0, $yRJUA.globalSettingsLayout), (0, $7IYIF.dashboardBackgroundScriptsLayout)),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            // IMPORTANT - SSR requires wrm resource must come first
            ...(0, $en43l.dashboardResources)(),
            (0, $jlaZM.gadgetDirectoryResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $en43l.LazySystemDashboardEdit)
        ],
        earlyAssets: (0, $1wb5r.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("5iRTf", function(module, exports) {

$parcel$export(module.exports, "systemDashboardEditRoute", () => $b761190ac823a0c8$export$7367fb465296c7dd);
const $b761190ac823a0c8$export$7367fb465296c7dd = {
    name: 'system-dashboard-edit',
    path: '/secure/admin/EditDefaultDashboard(!default)?.jspa',
    query: [
        'maximized?'
    ]
};

});


parcelRegister("jlw0X", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationCreateRouteEntry", () => $979152fb4a409e56$export$83aea99d18750f08);

var $lTVHD = parcelRequire("lTVHD");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $duKeY = parcelRequire("duKeY");

var $9bIMK = parcelRequire("9bIMK");

var $cbgXG = parcelRequire("cbgXG");

var $h5q0o = parcelRequire("h5q0o");
const $979152fb4a409e56$export$83aea99d18750f08 = (0, $6xToB.createEntry)((0, $duKeY.teamIntegrationCreateRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $9bIMK.IntegrationAutomation),
        layout: (0, $igwPu.opsTeamLayout),
        slot: (0, $cbgXG.IntegrationCreate),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $lTVHD.resources).configuredIntegrationsResource,
            (0, $lTVHD.resources).integrationListResource,
            (0, $lTVHD.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("duKeY", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationCreateRoute", () => $ccfe59fd8411d71c$export$a2ec7da6c43acbbf);
const $ccfe59fd8411d71c$export$a2ec7da6c43acbbf = {
    name: 'eoc-team-integration-create',
    path: '/jira/ops/teams/:teamId/integrations/create/:type',
    exact: true
};

});


parcelRegister("VMQYl", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationDetailRouteEntry", () => $71d5a5878a50c5c7$export$7e0b6b79953422c1);

var $lTVHD = parcelRequire("lTVHD");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $gdMif = parcelRequire("gdMif");

var $9bIMK = parcelRequire("9bIMK");

var $6M51H = parcelRequire("6M51H");

var $h5q0o = parcelRequire("h5q0o");
const $71d5a5878a50c5c7$export$7e0b6b79953422c1 = (0, $6xToB.createEntry)((0, $gdMif.teamIntegrationDetailRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $9bIMK.IntegrationAutomation),
        layout: (0, $igwPu.opsTeamLayout),
        slot: (0, $6M51H.IntegrationDetail),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $lTVHD.resources).configuredIntegrationsResource,
            (0, $lTVHD.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("gdMif", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationDetailRoute", () => $684ec74b48219eb6$export$72169399df792b7c);
const $684ec74b48219eb6$export$72169399df792b7c = {
    name: 'eoc-team-integration-detail',
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId',
    exact: true
};

});


parcelRegister("8t3Bs", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationListRouteEntry", () => $710d56bcd50cac17$export$52ee366e7b51f38d);

var $lTVHD = parcelRequire("lTVHD");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $2KkZM = parcelRequire("2KkZM");

var $9bIMK = parcelRequire("9bIMK");

var $juImm = parcelRequire("juImm");

var $h5q0o = parcelRequire("h5q0o");
const $710d56bcd50cac17$export$52ee366e7b51f38d = (0, $6xToB.createEntry)((0, $2KkZM.teamIntegrationListRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $9bIMK.IntegrationAutomation),
        layout: (0, $igwPu.opsTeamLayout),
        slot: (0, $juImm.IntegrationList),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $lTVHD.resources).integrationListResource,
            (0, $lTVHD.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("2KkZM", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationListRoute", () => $e9f54f716c255223$export$b8218f375778e6d7);
const $e9f54f716c255223$export$b8218f375778e6d7 = {
    name: 'eoc-team-integration-list',
    path: '/jira/ops/teams/:teamId/integrations/list',
    exact: true
};

});


parcelRegister("gqlkg", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationLogRouteEntry", () => $4364bc433855a188$export$d5e169223d2a5d1d);

var $72NQI = parcelRequire("72NQI");

var $lTVHD = parcelRequire("lTVHD");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $88S91 = parcelRequire("88S91");

var $9bIMK = parcelRequire("9bIMK");

var $1MNgS = parcelRequire("1MNgS");

var $h5q0o = parcelRequire("h5q0o");
const $4364bc433855a188$export$d5e169223d2a5d1d = (0, $6xToB.createEntry)((0, $88S91.teamIntegrationLogRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $9bIMK.IntegrationAutomation),
        slot: (0, $1MNgS.IntegrationLog),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)(),
            ...(0, $72NQI.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $lTVHD.resources).configuredIntegrationsResource,
            (0, $lTVHD.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("88S91", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationLogRoute", () => $5d4695307e8439a2$export$ca02d7b2c7df3d60);
const $5d4695307e8439a2$export$ca02d7b2c7df3d60 = {
    name: 'eoc-team-integration-log',
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId/logs',
    exact: true
};

});


parcelRegister("4W2Ve", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationsRouteEntry", () => $64bd8ddf48bac1a1$export$ded9494f81dd2a4d);

var $lTVHD = parcelRequire("lTVHD");

var $io7oY = parcelRequire("io7oY");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $3nX4f = parcelRequire("3nX4f");

var $9bIMK = parcelRequire("9bIMK");

var $h5q0o = parcelRequire("h5q0o");
const $64bd8ddf48bac1a1$export$ded9494f81dd2a4d = (0, $6xToB.createEntry)((0, $3nX4f.teamIntegrationsRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $9bIMK.IntegrationAutomation),
        layout: (0, $igwPu.opsTeamLayout),
        slot: null,
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $io7oY.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $lTVHD.resources).configuredIntegrationsResource,
            (0, $lTVHD.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("3nX4f", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationsRoute", () => $897708057bb41356$export$400ead354c81dee3);
const $897708057bb41356$export$400ead354c81dee3 = {
    name: 'eoc-team-integrations',
    path: '/jira/ops/teams/:teamId/integrations',
    exact: true
};

});


parcelRegister("2qWaR", function(module, exports) {

$parcel$export(module.exports, "trashedPlanDirectLinkRouteEntry", () => $9b6487b6b97ef74d$export$dbcd0bd16f12397d);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $d0o9Z = parcelRequire("d0o9Z");

var $3C9Q1 = parcelRequire("3C9Q1");
const $9b6487b6b97ef74d$export$dbcd0bd16f12397d = (0, $6xToB.createEntry)((0, $d0o9Z.trashedPlanDirectLinkRoute), ()=>({
        group: 'software',
        component: (0, $3C9Q1.TrashedPlanDirectLink),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3C9Q1.LazyTrashedPlanDirectLink)
        ],
        ufoName: 'plan-trashed'
    }));

});
parcelRegister("d0o9Z", function(module, exports) {

$parcel$export(module.exports, "trashedPlanDirectLinkRoute", () => $9c159671bcfb1c40$export$1a9edb72cd49ca79);
const $9c159671bcfb1c40$export$1a9edb72cd49ca79 = {
    name: 'trashed-plan-direct-link',
    path: '/jira/plans/plan-trashed',
    exact: true
};

});

parcelRegister("3C9Q1", function(module, exports) {

$parcel$export(module.exports, "LazyTrashedPlanDirectLink", () => $fafa1802058f3c13$export$20a71ac28e6a3c8f);
$parcel$export(module.exports, "TrashedPlanDirectLink", () => $fafa1802058f3c13$export$38f3a061bb1fceee);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $fafa1802058f3c13$export$20a71ac28e6a3c8f = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("hTJkD"))), {
    moduleId: "./src/packages/portfolio-3/plan-trashed-direct-link/src/index.tsx"
});
const $fafa1802058f3c13$export$38f3a061bb1fceee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fafa1802058f3c13$export$20a71ac28e6a3c8f,
        pageId: "trashed-plan-direct-link",
        shouldShowSpinner: false
    });

});
parcelRegister("hTJkD", function(module, exports) {

let $d07abcb375ba1fab$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d07abcb375ba1fab$var$load("2MPdE").then(()=>parcelRequire('6Ivy0'));

});



parcelRegister("1rAP5", function(module, exports) {

$parcel$export(module.exports, "trashPlansRouteEntry", () => $f8fc780667250079$export$eabcbe4dd6fc9f1f);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $gbuVC = parcelRequire("gbuVC");

var $dPDum = parcelRequire("dPDum");
const $f8fc780667250079$export$eabcbe4dd6fc9f1f = (0, $6xToB.createEntry)((0, $gbuVC.trashPlansRoute), ()=>({
        group: 'software',
        component: (0, $dPDum.TrashedPlansDirectory),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dPDum.LazyTrashedPlans)
        ]
    }));

});
parcelRegister("gbuVC", function(module, exports) {

$parcel$export(module.exports, "trashPlansRoute", () => $cbeed289af2ec573$export$6f5b50c5dc090fd1);
const $cbeed289af2ec573$export$6f5b50c5dc090fd1 = {
    name: 'trash-plans-directory',
    path: '/jira/plans/settings/trash',
    exact: true
};

});

parcelRegister("dPDum", function(module, exports) {

$parcel$export(module.exports, "LazyTrashedPlans", () => $cf22b7bcbd5e853d$export$6ac18b311b7e51a1);
$parcel$export(module.exports, "TrashedPlansDirectory", () => $cf22b7bcbd5e853d$export$b145fa65818ff157);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $cf22b7bcbd5e853d$export$6ac18b311b7e51a1 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("biZNU")).then((module)=>module.TrashedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages/trashed-plans/src/index.tsx"
});
const $cf22b7bcbd5e853d$export$b145fa65818ff157 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cf22b7bcbd5e853d$export$6ac18b311b7e51a1,
        pageId: "trashed-plans",
        shouldShowSpinner: true
    });

});
parcelRegister("biZNU", function(module, exports) {

let $83b1512614ba9329$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $83b1512614ba9329$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $83b1512614ba9329$var$load("deNlq")
        ]);
    }),
    $83b1512614ba9329$var$load("2LcFU")
]).then(()=>parcelRequire('7nySO'));

});



parcelRegister("4MsHe", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRedirectRouteEntry", () => $605eb15b2e7b45d8$export$8ea64bac0a832a5c);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $vJYlr = parcelRequire("vJYlr");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $g0FMn = parcelRequire("g0FMn");

var $w3dqA = parcelRequire("w3dqA");

var $kIClG = parcelRequire("kIClG");
const $605eb15b2e7b45d8$export$8ea64bac0a832a5c = (0, $6xToB.createEntry)((0, $g0FMn.trashProjectsDirectoryRedirectRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.trashed-projects',
        component: (0, $w3dqA.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $vJYlr.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kIClG.LazyTrashedProjectsAdmin)
        ],
        isRedirect: true
    }));

});
parcelRegister("g0FMn", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRedirectRoute", () => $18a05d65567ca0ae$export$6eafffd4489b3d4);
const $18a05d65567ca0ae$export$6eafffd4489b3d4 = {
    name: 'trash-projects-directory',
    path: '/secure/projects/trash',
    exact: true
};

});

parcelRegister("w3dqA", function(module, exports) {

$parcel$export(module.exports, "default", () => $358bdfe51ee3c740$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");

var $2mHfh = parcelRequire("2mHfh");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$358bdfe51ee3c740$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: "projectsTrashRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: "/jira/settings/projects/trash"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null));

});

parcelRegister("kIClG", function(module, exports) {

$parcel$export(module.exports, "LazyTrashedProjectsAdmin", () => $ec446fe789f8875f$export$dd65a8ee0a9ac24f);
$parcel$export(module.exports, "default", () => $ec446fe789f8875f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $ec446fe789f8875f$export$dd65a8ee0a9ac24f = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("areYw"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/trashed-projects/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ec446fe789f8875f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ec446fe789f8875f$export$dd65a8ee0a9ac24f,
        pageId: "trashed-projects",
        shouldShowSpinner: true
    });

});
parcelRegister("areYw", function(module, exports) {

let $79980ac073da126d$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $79980ac073da126d$var$load("amle7")
        ]);
    }, function() {
        return Promise.all([
            $79980ac073da126d$var$load("deNlq")
        ]);
    }),
    $79980ac073da126d$var$load("eDzss"),
    $79980ac073da126d$var$load("734v6")
]).then(()=>parcelRequire('7G6RL'));

});



parcelRegister("ASOiD", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRouteEntry", () => $a8c661d1e519471b$export$27d1f352c2f7acae);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $vJYlr = parcelRequire("vJYlr");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $1sNDy = parcelRequire("1sNDy");

var $kIClG = parcelRequire("kIClG");
const $a8c661d1e519471b$export$27d1f352c2f7acae = (0, $6xToB.createEntry)((0, $1sNDy.trashProjectsDirectoryRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.trashed-projects',
        component: (0, $kIClG.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $vJYlr.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kIClG.LazyTrashedProjectsAdmin)
        ]
    }));

});
parcelRegister("1sNDy", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRoute", () => $3bcd89231fd04722$export$74ec9fecd42fa96e);
const $3bcd89231fd04722$export$74ec9fecd42fa96e = {
    name: 'trash-projects-directory',
    path: '/jira/settings/projects/trash',
    exact: true
};

});


parcelRegister("bxGoH", function(module, exports) {

$parcel$export(module.exports, "unlockOperationsRouteEntry", () => $85ea48dda587c266$export$c058f4d1c0667ce1);

var $kHlOR = parcelRequire("kHlOR");

var $fz8gQ = parcelRequire("fz8gQ");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $f2vqd = parcelRequire("f2vqd");

var $9NmsS = parcelRequire("9NmsS");

var $fVIsa = parcelRequire("fVIsa");

var $3eS82 = parcelRequire("3eS82");
const $85ea48dda587c266$export$c058f4d1c0667ce1 = (0, $6xToB.createEntry)((0, $fVIsa.unlockOperationsRoute), ()=>({
        group: 'eoc',
        layout: (0, $fz8gQ.eocChangeboardingLayout),
        component: (0, $3eS82.default),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $f2vqd.resources)()
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3eS82.LazyUnlockOperations)
        ]
    }));

});
parcelRegister("f2vqd", function(module, exports) {

$parcel$export(module.exports, "resources", () => $dbc35bf824907b7b$export$bc99aaabaf7b70a7);

var $f20Ew = parcelRequire("f20Ew");

const $dbc35bf824907b7b$export$bc99aaabaf7b70a7 = ()=>[
        (0, $f20Ew.transitioningDetailsResource)
    ];

});
parcelRegister("f20Ew", function(module, exports) {

$parcel$export(module.exports, "transitioningDetailsResource", () => $bba77ebbf0bab0ad$export$850d76e0c9ffbdeb);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");
const $bba77ebbf0bab0ad$export$7985153d37586c9a = (cloudId)=>(0, $jGzN3.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/transitioning-details`).catch((err)=>{
        (0, $gYnSx.default)({
            meta: {
                id: 'getTransitioningDetails',
                packageName: 'jiraRouterResourcesEocUnlockOperations',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
const $bba77ebbf0bab0ad$export$850d76e0c9ffbdeb = (0, $l1VxS.createResource)({
    type: 'EOC_UNLOCK_OPERATIONS',
    getKey: ()=>'eoc-unlock-operations',
    getData: async (_, { tenantContext: { cloudId: cloudId } })=>$bba77ebbf0bab0ad$export$7985153d37586c9a(cloudId),
    maxAge: 0,
    isBrowserOnly: true
});

});


parcelRegister("fVIsa", function(module, exports) {

$parcel$export(module.exports, "unlockOperationsRoute", () => $9fab4d9817e1d941$export$30306de7e00bc5a2);
const $9fab4d9817e1d941$export$30306de7e00bc5a2 = {
    name: 'eoc-unlock-operations',
    path: '/jira/settings/products/ops/unlock',
    exact: true
};

});

parcelRegister("3eS82", function(module, exports) {

$parcel$export(module.exports, "LazyUnlockOperations", () => $bced93423642f8ef$export$55e4754d556d072);
$parcel$export(module.exports, "default", () => $bced93423642f8ef$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $bced93423642f8ef$export$55e4754d556d072 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8W2eB")), {
    moduleId: "./src/packages/eoc/unlock-operations/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bced93423642f8ef$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $bced93423642f8ef$export$55e4754d556d072,
        pageId: "eoc-products-unlock-operations",
        shouldShowSpinner: false
    });

});
parcelRegister("8W2eB", function(module, exports) {

let $6815793c620e7c9b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6815793c620e7c9b$var$load("huYsO").then(()=>parcelRequire('gwOgn'));

});



parcelRegister("7dAIb", function(module, exports) {

$parcel$export(module.exports, "userBoardRouteEntry", () => $e55a384a1e4ec903$export$cde4dacc737dc0f1);

var $1wb5r = parcelRequire("1wb5r");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $27Owl = parcelRequire("27Owl");

var $fbgOh = parcelRequire("fbgOh");

var $alzbz = parcelRequire("alzbz");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $5PY5j = parcelRequire("5PY5j");

var $zNGiI = parcelRequire("zNGiI");

var $hS1gr = parcelRequire("hS1gr");

var $1iLM1 = parcelRequire("1iLM1");
const $e55a384a1e4ec903$export$cde4dacc737dc0f1 = (0, $6xToB.createEntry)((0, $5PY5j.userBoardRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $zNGiI.ClassicBoardSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)(),
            (0, $5L7qx.resourceWithCondition2)((0, $alzbz.shouldLoadUIFBoardResources), (0, $c0h8V.uifBoardResource)),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-board-early-entry'
            ]
        },
        earlyAssets: (0, $1wb5r.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        entryPoint: ()=>(0, $1iLM1.userBoardPageEntrypoint)
    }));

});
parcelRegister("5PY5j", function(module, exports) {

$parcel$export(module.exports, "userBoardRoute", () => $c671295e8f87ee59$export$57a2a0fe739f16);
const $c671295e8f87ee59$export$57a2a0fe739f16 = {
    name: 'rapidboard-user-board',
    path: '/jira/people/:accountId/boards/:boardId'
};

});

parcelRegister("1iLM1", function(module, exports) {

$parcel$export(module.exports, "userBoardPageEntrypoint", () => $4fbbdeaf51ac3b77$export$606f36f7912a11ef);

var $g8uYY = parcelRequire("g8uYY");

var $9n5I0 = parcelRequire("9n5I0");

var $iJnZt = parcelRequire("iJnZt");

var $5RW99 = parcelRequire("5RW99");
const $4fbbdeaf51ac3b77$export$606f36f7912a11ef = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iJnZt.nextGenBoardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("53Ske", function(module, exports) {

$parcel$export(module.exports, "userBoardSettingsRouteEntry", () => $c8ec312a14fc7a1e$export$f8e56ba3f544195d);

var $ioHIu = parcelRequire("ioHIu");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $27Owl = parcelRequire("27Owl");

var $fbgOh = parcelRequire("fbgOh");

var $alzbz = parcelRequire("alzbz");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $enr75 = parcelRequire("enr75");

var $zNGiI = parcelRequire("zNGiI");

var $a4jDB = parcelRequire("a4jDB");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");
const $c8ec312a14fc7a1e$export$f8e56ba3f544195d = (0, $6xToB.createEntry)((0, $enr75.userBoardSettingsRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        skeleton: (0, $zNGiI.ClassicBoardSkeleton),
        entryPoint: ()=>(0, $a4jDB.boardSettingsPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).BOARD_SETTINGS
        },
        layout: (0, $ioHIu.genericProjectLayout),
        // This list is based on the resources needed by ./userBoardRouteEntry.tsx
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)(),
            (0, $5L7qx.resourceWithCondition2)((0, $alzbz.shouldLoadUIFBoardResources), (0, $c0h8V.uifBoardResource)),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)()
        ]
    }));

});
parcelRegister("enr75", function(module, exports) {

$parcel$export(module.exports, "userBoardSettingsRoute", () => $406f872a5975d70b$export$a6e04dfbb956c677);
const $406f872a5975d70b$export$a6e04dfbb956c677 = {
    name: 'rapidboard-user-board-settings',
    path: '/jira/people/:accountId/boards/:boardId/settings/:config',
    query: [
        'from-backlog?'
    ]
};

});


parcelRegister("l6W7I", function(module, exports) {

$parcel$export(module.exports, "userBoardVelocityRouteEntry", () => $7f61842d2f1b4d7b$export$ba0f726701b9e407);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $ioHIu = parcelRequire("ioHIu");

var $ctYnk = parcelRequire("ctYnk");

var $ftHHz = parcelRequire("ftHHz");
const $7f61842d2f1b4d7b$export$ba0f726701b9e407 = (0, $6xToB.createEntry)((0, $ctYnk.userBoardVelocityRoute), ()=>({
        group: 'classic-software',
        ufoName: 'software-reports.velocity-report-cmp',
        component: (0, $ftHHz.default),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ftHHz.LazyNextGenVelocityReport)
        ],
        supportsPreviewPanel: true
    }));

});
parcelRegister("ctYnk", function(module, exports) {

$parcel$export(module.exports, "userBoardVelocityRoute", () => $5fb890b5d4a064a4$export$57431a0e4f3a32e8);
const $5fb890b5d4a064a4$export$57431a0e4f3a32e8 = {
    name: 'software-reports-velocity-user-board',
    path: '/jira/people/:accountId/boards/:boardId/reports/velocity'
};

});

parcelRegister("ftHHz", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenVelocityReport", () => $adbe3280275e9b37$export$a2ca519c668b2f72);
$parcel$export(module.exports, "default", () => $adbe3280275e9b37$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

var $jKFLP = parcelRequire("jKFLP");

const $adbe3280275e9b37$export$a2ca519c668b2f72 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("gpSQC"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/velocity/src/index-old.tsx"
});
var /** @deprecated delete file after all usages have been migrated to use entry points */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$adbe3280275e9b37$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $adbe3280275e9b37$export$a2ca519c668b2f72,
        pageId: `next-gen-reports-velocity-${(0, $jKFLP.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("gpSQC", function(module, exports) {

let $bf3986c65aabe69d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $bf3986c65aabe69d$var$load("1VRB2"),
    $bf3986c65aabe69d$var$load("bABhq"),
    $bf3986c65aabe69d$var$load("iZc1w")
]).then(()=>parcelRequire('aD5wE'));

});



parcelRegister("77YbO", function(module, exports) {

$parcel$export(module.exports, "userBoardViewNotFoundRouteEntry", () => $126b9e2a62933b1e$export$a2bfa34d08651f6d);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $hLmQ9 = parcelRequire("hLmQ9");

var $hS1gr = parcelRequire("hS1gr");

var $38Nv8 = parcelRequire("38Nv8");
const $126b9e2a62933b1e$export$a2bfa34d08651f6d = (0, $6xToB.createEntry)((0, $hLmQ9.userBoardViewNotFoundRoute), ()=>({
        group: 'classic-software',
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $38Nv8.boardViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("hLmQ9", function(module, exports) {

$parcel$export(module.exports, "userBoardViewNotFoundRoute", () => $5cc754400276a6f5$export$ad6b96e14e735ed7);
const $5cc754400276a6f5$export$ad6b96e14e735ed7 = {
    name: 'rapidboard-user-board-view-not-found',
    path: '/jira/people/:accountId/boards/:boardId/not-found'
};

});


parcelRegister("dNIAB", function(module, exports) {

$parcel$export(module.exports, "userSegmentationRouteEntry", () => $0603f41bf05dd551$export$2af76482b576a135);

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $dEVZB = parcelRequire("dEVZB");

var $eY3tt = parcelRequire("eY3tt");
const $0603f41bf05dd551$export$2af76482b576a135 = (0, $6xToB.createEntry)((0, $dEVZB.userSegmentationRoute), ()=>({
        ufoName: 'user-segmentation',
        component: (0, $eY3tt.UserSegmentation),
        layout: (0, $7K5Ea.chromelessLayout),
        forPaint: [
            (0, $eY3tt.LazyUserSegmentation)
        ]
    }));

});
parcelRegister("dEVZB", function(module, exports) {

$parcel$export(module.exports, "userSegmentationRoute", () => $26a7b7b3b5d63a29$export$b0b13170cadf6395);
const $26a7b7b3b5d63a29$export$b0b13170cadf6395 = {
    name: 'user-segmentation',
    path: '/jira/get-started',
    exact: true
};

});

parcelRegister("eY3tt", function(module, exports) {

$parcel$export(module.exports, "LazyUserSegmentation", () => $cba88a776b834181$export$bf9c9e0729c919f5);
$parcel$export(module.exports, "UserSegmentation", () => $cba88a776b834181$export$15f8c5ccbb9c7ec3);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $cba88a776b834181$export$bf9c9e0729c919f5 = (0, $gzcjr.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2r5Hc"))), {
    moduleId: "./src/packages/user-segmentation/src/index.tsx"
});
const $cba88a776b834181$export$15f8c5ccbb9c7ec3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cba88a776b834181$export$bf9c9e0729c919f5,
        pageId: "user-segmentation",
        shouldShowSpinner: true
    });

});
parcelRegister("2r5Hc", function(module, exports) {

let $1c628575a6af8948$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1c628575a6af8948$var$load("fFmJI").then(()=>parcelRequire('821j5'));

});



parcelRegister("zhYLc", function(module, exports) {

$parcel$export(module.exports, "viewIntentRouteEntry", () => $aab34f17fed1aeeb$export$e693459ab8454027);

var $igNUx = parcelRequire("igNUx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $3RrQa = parcelRequire("3RrQa");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $jQAEu = parcelRequire("jQAEu");

var $6PeVL = parcelRequire("6PeVL");

var $g8uYY = parcelRequire("g8uYY");

var $cAYFR = parcelRequire("cAYFR");
const $aab34f17fed1aeeb$var$viewIntentPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $6PeVL.viewIntentEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $aab34f17fed1aeeb$export$e693459ab8454027 = (0, $6xToB.createEntry)((0, $3RrQa.viewIntentRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $igNUx.isFedRamp)()) return undefined;
            return $aab34f17fed1aeeb$var$viewIntentPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $jQAEu.VirtualAgentViewIntentSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("3RrQa", function(module, exports) {

$parcel$export(module.exports, "viewIntentRoute", () => $351e6af2b89773e7$export$bf8131fb060d0e73);
const $351e6af2b89773e7$export$bf8131fb060d0e73 = {
    name: 'project-settings-servicedesk-virtualagent-view-intent',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents/:intentId/:tab(flow|training|settings)?'
};

});

parcelRegister("jQAEu", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentViewIntentSkeleton", () => $2e6f43333d437777$export$72b20c10a0f18a2f);
/* VirtualAgentViewIntentSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $3CeSt = parcelRequire("3CeSt");
const $2e6f43333d437777$var$customCssStyles = null;
const $2e6f43333d437777$export$72b20c10a0f18a2f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3CeSt))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("3CeSt", function(module, exports) {
module.exports = new URL("virtual-agent-view-intent-app-skeleton.tpl.5dd31cbb.svg", import.meta.url).toString();

});


parcelRegister("6PeVL", function(module, exports) {

$parcel$export(module.exports, "viewIntentEntryPoint", () => $9c17a74ebb05f28c$export$f51df662bd71ce39);

var $dMKjC = parcelRequire("dMKjC");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $9c17a74ebb05f28c$export$f51df662bd71ce39 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("51Egh")), {
        moduleId: "bc04de30",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $dMKjC.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        intentId: context.match.params.intentId ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("dMKjC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fc9034941b3dcd3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dedde06316e2afe5acc862762a93f4dd>>
 * @relayHash cb914e8d2219b7f49741872ae7f6d037
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a770411d52534005c4d94e2f61c74a98ed117522669e7af7701400ccbf2323f3

var $bXR9c = parcelRequire("bXR9c");
const $4fc9034941b3dcd3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a770411d52534005c4d94e2f61c74a98ed117522669e7af7701400ccbf2323f3",
        "metadata": {},
        "name": "srcVirtualAgentViewIntentQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $4fc9034941b3dcd3$export$2e2bcd8739ae039 = $4fc9034941b3dcd3$var$node;

});

parcelRegister("51Egh", function(module, exports) {

let $3a8c46d9f79e8ecb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $3a8c46d9f79e8ecb$var$load("1VRB2"),
    $3a8c46d9f79e8ecb$var$load("bABhq"),
    $3a8c46d9f79e8ecb$var$load("6prS0")
]).then(()=>parcelRequire('ben1W'));

});



parcelRegister("kZdpv", function(module, exports) {

$parcel$export(module.exports, "viewStandardFlowRouteEntry", () => $d954ddb264861fd9$export$84dc2dfc944b0434);

var $igNUx = parcelRequire("igNUx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $jrJ8D = parcelRequire("jrJ8D");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $8kk2y = parcelRequire("8kk2y");

var $g8uYY = parcelRequire("g8uYY");

var $dCreL = parcelRequire("dCreL");

var $cAYFR = parcelRequire("cAYFR");
const $d954ddb264861fd9$var$viewStandardFlowPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $dCreL.viewStandardFlowEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $d954ddb264861fd9$export$84dc2dfc944b0434 = (0, $6xToB.createEntry)((0, $jrJ8D.viewStandardFlowRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $igNUx.isFedRamp)()) return undefined;
            return $d954ddb264861fd9$var$viewStandardFlowPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $8kk2y.VirtualAgentViewStandardFlowSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("jrJ8D", function(module, exports) {

$parcel$export(module.exports, "viewStandardFlowRoute", () => $a0de3a8c88387eae$export$c74dca8be49046ea);
const $a0de3a8c88387eae$export$c74dca8be49046ea = {
    name: 'project-settings-servicedesk-virtualagent-view-standard-flow',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows/:flowId/:tab(flow|settings)?'
};

});

parcelRegister("8kk2y", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentViewStandardFlowSkeleton", () => $36de680e203abb4c$export$c6d3f04e6931e3f6);
/* VirtualAgentViewStandardFlowSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $ejHix = parcelRequire("ejHix");
const $36de680e203abb4c$var$customCssStyles = null;
const $36de680e203abb4c$export$c6d3f04e6931e3f6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ejHix))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("ejHix", function(module, exports) {
module.exports = new URL("virtual-agent-view-standard-flow-app-skeleton.tpl.ec3b149b.svg", import.meta.url).toString();

});


parcelRegister("dCreL", function(module, exports) {

$parcel$export(module.exports, "viewStandardFlowEntryPoint", () => $608dd8acb516b7cf$export$4fd7bf09308d4abd);

var $a6h56 = parcelRequire("a6h56");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

var $7jTnu = parcelRequire("7jTnu");

const $608dd8acb516b7cf$export$4fd7bf09308d4abd = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("6AgnA")), {
        moduleId: "8e1cdfbd",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $a6h56.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        flowId: context.match.params.flowId ?? '',
                        offerEscalationEnabled: (0, $7jTnu.fg)('toggle_offer_escalation_standard_flow_feature') ?? false
                    }
                }
            }
        })
});

});
parcelRegister("a6h56", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5307e82a51c8698$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c672df7540026746c518fc6252bb9853>>
 * @relayHash 03d60ddb2ab7e66f9166484b433a6391
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID edf50ab9067bb9d2788c9b405debcf23a384aa2eb6e7a5692942760f437f397f

var $bXR9c = parcelRequire("bXR9c");
const $e5307e82a51c8698$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "edf50ab9067bb9d2788c9b405debcf23a384aa2eb6e7a5692942760f437f397f",
        "metadata": {},
        "name": "srcVirtualAgentViewStandardFlowQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $e5307e82a51c8698$export$2e2bcd8739ae039 = $e5307e82a51c8698$var$node;

});

parcelRegister("6AgnA", function(module, exports) {

let $4cb2cf77218cb9b8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4cb2cf77218cb9b8$var$load("eiG33").then(()=>parcelRequire('4MbRw'));

});



parcelRegister("g70C8", function(module, exports) {

$parcel$export(module.exports, "whoIsOnCallRouteEntry", () => $a978136123c31dea$export$fee33ca9661e49dd);

var $dwa8t = parcelRequire("dwa8t");

var $kHlOR = parcelRequire("kHlOR");

var $fz8gQ = parcelRequire("fz8gQ");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $h2Unl = parcelRequire("h2Unl");

var $cUt8w = parcelRequire("cUt8w");
const $a978136123c31dea$var$getWhoIsOnCallResources = ()=>(0, $dwa8t.resources);
const $a978136123c31dea$export$fee33ca9661e49dd = (0, $6xToB.createEntry)((0, $h2Unl.whoIsOnCallRoute), ()=>({
        group: 'eoc',
        layout: (0, $fz8gQ.eocChangeboardingLayout),
        component: (0, $cUt8w.WhoIsOnCallComponent),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...$a978136123c31dea$var$getWhoIsOnCallResources()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cUt8w.LazyWhoIsOnCall)
        ]
    }));

});
parcelRegister("h2Unl", function(module, exports) {

$parcel$export(module.exports, "whoIsOnCallRoute", () => $2a0b4e97ee858f6e$export$26b06efd7311586b);
const $2a0b4e97ee858f6e$export$26b06efd7311586b = {
    name: 'eoc-who-is-on-call',
    path: '/jira/ops/who-is-on-call',
    exact: true
};

});

parcelRegister("cUt8w", function(module, exports) {

$parcel$export(module.exports, "LazyWhoIsOnCall", () => $14f758de812bc6b6$export$7b03e7437c5d4f77);
$parcel$export(module.exports, "WhoIsOnCallComponent", () => $14f758de812bc6b6$export$51430a0cf6ef3c09);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $gzcjr = parcelRequire("gzcjr");

const $14f758de812bc6b6$export$7b03e7437c5d4f77 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("eJr64")), {
    moduleId: "./src/packages/eoc/who-is-on-call/src/ui/index.tsx"
});
const $14f758de812bc6b6$export$51430a0cf6ef3c09 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $14f758de812bc6b6$export$7b03e7437c5d4f77,
        pageId: "async-jira-eoc-who-is-on-call",
        shouldShowSpinner: false
    });

});
parcelRegister("eJr64", function(module, exports) {

let $ab9a498f3122def0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ab9a498f3122def0$var$load("dFJs1").then(()=>parcelRequire('iJQmu'));

});



parcelRegister("ckYTZ", function(module, exports) {

$parcel$export(module.exports, "workItemRouteEntry", () => $5504bb4056a8d605$export$2fea809b4007e17d);

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $5H8cn = parcelRequire("5H8cn");

var $gmPbY = parcelRequire("gmPbY");
const $5504bb4056a8d605$export$2fea809b4007e17d = (0, $6xToB.createEntry)((0, $5H8cn.workItemRoute), ()=>({
        group: 'work-item',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [],
        // bifrost property is set up, which is required for Bifrost SSR onboarding
        bifrost: {
            bifrostGroup: 'issue-view',
            bundling: {
                packageName: '@atlassian/jira-router-routes-work-items-entries/src/workItemRouteEntry.tsx',
                whichExportToUse: 'workItemRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-view.json'
        },
        entryPoint: ()=>(0, $gmPbY.workItemPageEntrypoint),
        ufoName: 'work-item',
        supportsPreviewPanel: true
    }));

});
parcelRegister("5H8cn", function(module, exports) {

$parcel$export(module.exports, "workItemRoute", () => $ecc9b08418ae3378$export$cdf7747c91065c7f);
const $ecc9b08418ae3378$export$cdf7747c91065c7f = {
    name: 'work-item',
    exact: true,
    path: '/browse/work-item/:issueKey'
};

});

parcelRegister("gmPbY", function(module, exports) {

$parcel$export(module.exports, "workItemPageEntrypoint", () => $15c6244449723ce2$export$16cd62cd4baaf460);

var $k46A3 = parcelRequire("k46A3");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");
const $15c6244449723ce2$export$16cd62cd4baaf460 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $k46A3.workItemEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("k46A3", function(module, exports) {

$parcel$export(module.exports, "workItemEntrypoint", () => $db2e192c7fe6ed75$export$7776ba0e0fd82365);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $db2e192c7fe6ed75$export$7776ba0e0fd82365 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("2chVr")), {
        moduleId: "90c59854",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2chVr", function(module, exports) {

let $199a9b68737a4221$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $199a9b68737a4221$var$load("8tKyy").then(()=>parcelRequire('8ZIUK'));

});





parcelRegister("dVYsb", function(module, exports) {

$parcel$export(module.exports, "startJiraSpa", () => $67aea0c62c200796$export$f71867a5b2484020);

var $eJOHy = parcelRequire("eJOHy");

var $jFHCE = parcelRequire("jFHCE");

var $8sbs2 = parcelRequire("8sbs2");

var $g1P4j = parcelRequire("g1P4j");

var $5QkZY = parcelRequire("5QkZY");

var $2JM8Q = parcelRequire("2JM8Q");

var $2NzEL = parcelRequire("2NzEL");

var $xTtyc = parcelRequire("xTtyc");

var $gC446 = parcelRequire("gC446");

var $f0nBN = parcelRequire("f0nBN");

var $1Q1XT = parcelRequire("1Q1XT");


var $k8mcw = parcelRequire("k8mcw");
parcelRequire("lXp9u");

var $6uWhG = parcelRequire("6uWhG");

var $aYncF = parcelRequire("aYncF");

var $2dBpR = parcelRequire("2dBpR");

var $1KdDN = parcelRequire("1KdDN");

var $epTsa = parcelRequire("epTsa");

var $3KIqP = parcelRequire("3KIqP");

var $7jTnu = parcelRequire("7jTnu");

var $3Zulo = parcelRequire("3Zulo");

var $hW27F = parcelRequire("hW27F");

var $kQnVX = parcelRequire("kQnVX");

var $hih5V = parcelRequire("hih5V");

var $1PSAp = parcelRequire("1PSAp");

var $e8u2a = parcelRequire("e8u2a");

var $lmqkh = parcelRequire("lmqkh");

var $b2uWc = parcelRequire("b2uWc");

var $7grfV = parcelRequire("7grfV");

var $dydef = parcelRequire("dydef");

var $fmwpb = parcelRequire("fmwpb");

var $gNSxk = parcelRequire("gNSxk");

var $ccydf = parcelRequire("ccydf");

var $lZMpx = parcelRequire("lZMpx");

var $aqRAv = parcelRequire("aqRAv");

var $16sa1 = parcelRequire("16sa1");

var $3Te4N = parcelRequire("3Te4N");

var $9aXOX = parcelRequire("9aXOX");

var $1jgVa = parcelRequire("1jgVa");
var $gAzn8 = parcelRequire("gAzn8");

var $MBWwk = parcelRequire("MBWwk");

var $30bwc = parcelRequire("30bwc");
var $83DiZ = parcelRequire("83DiZ");

var $jqynJ = parcelRequire("jqynJ");

var $kfvK2 = parcelRequire("kfvK2");

var $9kysr = parcelRequire("9kysr");

var $a0zLT = parcelRequire("a0zLT");

var $9Szlh = parcelRequire("9Szlh");

var $ceCro = parcelRequire("ceCro");
parcelRequire("cxSoK");

var $5eRs1 = parcelRequire("5eRs1");
// Set SPA global
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window.__SPA__ = true;
const $67aea0c62c200796$var$altBootstrapEnabled = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
!false && typeof window !== 'undefined' && window.__SPA_BOOTSTRAP_ALT;
// In the experiment scenario, I'm moving the side-effect from immediate execution to function execution.
if (!$67aea0c62c200796$var$altBootstrapEnabled) (0, $1jgVa.LooselyLazy).init({
    mode: (0, $5eRs1.getIsSsrHydrationEnabled)() ? (0, $gAzn8.MODE).HYDRATE : (0, $gAzn8.MODE).RENDER,
    crossOrigin: 'anonymous',
    // hide fg access from eslint, we can do it on "pure client
    react18: (()=>(0, $7jTnu.fg)('jfp_magma_jira-rll-react-18-render'))(),
    usePostTaskPhases: (()=>(0, $7jTnu.fg)('jfp-jira-remove-rll-subscriptions'))(),
    trackDuplicateLazyIds: (()=>(0, $7jTnu.fg)('jfp-magma-rll-track-duplicated-lazy-ids'))(),
    htmlPlaceholders: (()=>(0, $7jTnu.fg)('jfp_magma_jira-rll-html-placeholder'))(),
    markedForPreload: (()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        (0, $7jTnu.fg)('jfp_magma_jira-rll-client-preload') ? window.SPA_STATE?.rll_preload : undefined)()
});

const $67aea0c62c200796$var$getMessages = ()=>{
    (0, $6uWhG.setMark)('jira-spa/language-pack.start');
    const messages = (parcelRequire("hXmA9"));
    (0, $6uWhG.setMark)('jira-spa/language-pack.end');
    return messages;
};
const $67aea0c62c200796$var$superbatchInit = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.DeferScripts = {
        deferState: 'done'
    };
    if ((0, $7jTnu.fg)('remove_deferred_class_remove')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    {
        if (document.body?.classList.contains('deferred')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body?.classList.remove('deferred');
    } else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body && document.body.classList.remove('deferred');
};
const $67aea0c62c200796$var$globalSettingsArgs = {
    navigation: false,
    upflow: false
};
const $67aea0c62c200796$var$InstallGlobalComponentsOnce = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $7jTnu.fg)('remove_priority_ranking_for_global_spa')) (0, $9Szlh.default).installLowPrioritySPAApps();
        else (0, $9Szlh.default).installLowPriorityAppsOld(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'LowPriorityAppsArgs'.
        (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))($67aea0c62c200796$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        (0, $6uWhG.setMark)('JIRA_SPA_ENTRY_GLOBAL_INSTALL');
    }, []);
    return null;
};
// this will move low priority apps to after TTAI (currently just the async-profilecard (legacy profilecard, only used on legacy experiences like GIN and legacy GIC))
const $67aea0c62c200796$var$LoadPhaseSwitcher = ()=>{
    if ((0, $7jTnu.fg)('remove_priority_ranking_for_global_spa')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MBWwk.BackgroundPriority), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67aea0c62c200796$var$InstallGlobalComponentsOnce, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Zulo.NonCritical), {
        id: "spa-main.client-router.non-critical",
        teamName: "delorean-spa"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67aea0c62c200796$var$InstallGlobalComponentsOnce, null));
};
const $67aea0c62c200796$var$updateCapability = (capability)=>{
    (0, $k8mcw.setCapability)(capability);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (capability === null && window.AJS?.$?.ajaxSettings?.headers?.[0, $652f5f63189f3e2a$export$9a80695e72849f84]) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.AJS.$.ajaxSettings.headers[0, $652f5f63189f3e2a$export$9a80695e72849f84];
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS?.$?.ajaxSetup({
        headers: {
            [(0, $652f5f63189f3e2a$export$9a80695e72849f84)]: capability
        }
    });
};
// @ts-expect-error - TS7031 - Binding element 'routes' implicitly has an 'any' type.
const $67aea0c62c200796$var$CapabilityTrackerConnector = ({ routes: routes })=>{
    const { registerBlock: registerBlock } = (0, $83DiZ.useRouterActions)();
    registerBlock((nextLocation)=>{
        const nextMatchObject = (0, $30bwc.default)(routes, nextLocation.pathname, nextLocation.search, '');
        $67aea0c62c200796$var$updateCapability(nextMatchObject?.route.meta?.capability || null);
        return true;
    });
    const route = (0, $hih5V.useCurrentRoute)();
    $67aea0c62c200796$var$updateCapability(route.meta?.capability || null);
    return null;
};
const $67aea0c62c200796$var$main = async (getInitialRoutes, loadLazyRoutes)=>{
    (0, $5QkZY.collectSSRPlaceholderDimensions)(document, window, true);
    (0, $aqRAv.default)();
    (0, $1Q1XT.initBrowserMetrics3)();
    (0, $3KIqP.initPlatformFeatureFlags)((0, $9aXOX.visualRefreshResolverOverride));
    (0, $a0zLT.initEntryPointConfig)();
    (0, $3Te4N.getClientReceiver)();
    (0, $fmwpb.addInitialPageLoadTimings)();
    (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/init', 'jira-spa.js:eval-start');
    (0, $6uWhG.setMark)('jira-spa/setup.start');
    const routes = (0, $dydef.measureInitialPageLoadTiming)('jira-spa/setup/routes', ()=>getInitialRoutes());
    const history = (0, $dydef.measureInitialPageLoadTiming)('jira-spa/setup/history', ()=>(0, $ccydf.default)(routes));
    const initRoute = (0, $dydef.measureInitialPageLoadTiming)('jira-spa/setup/match-route', ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const matchedRoute = (0, $30bwc.default)(routes, window.location.pathname, window.location.search);
        (0, $kQnVX.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
        return matchedRoute;
    });
    if (initRoute != null) {
        const ufoName = (0, $g1P4j.default)(initRoute.route);
        (0, $2JM8Q.default)(ufoName, initRoute.route.name);
    }
    const BrowserMetricsConnector = ()=>{
        const route = (0, $hih5V.useCurrentRoute)();
        (0, $gC446.browserMetrics).setRoute(route.name);
        (0, $2NzEL.useUFOTransitionCompleter)();
        (0, $9kysr.GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey || 'UNKNOWN');
        return null;
    };
    (0, $9kysr.GlobalPageLoadExperience).startPageLoad('UNKNOWN', true);
    const messages = $67aea0c62c200796$var$getMessages();
    const tenantContext = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const { locale: locale } = tenantContext;
    const routerProps = {
        history: history,
        routes: routes,
        basePath: '',
        initialRoute: initRoute?.route,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        resourceData: window.SPA_STATE,
        resourceContext: (0, $lZMpx.getSpaRouterContext)({
            tenantContext: tenantContext
        }),
        onPrefetch: ({ route: route, match: match })=>{
            (0, $gNSxk.setPrefetchStartMark)(match);
            if (!route.forPaint) return;
            route.forPaint.map((component)=>component.preload && component.preload());
        },
        isLazyRoutes: typeof loadLazyRoutes === 'function'
    };
    const SpaClientRouterTemplate = ({ children: children, trackedRoutes: trackedRoutes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmqkh.SpaRouter), {
            routerProps: routerProps,
            before: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
                id: "spa-main.client-router",
                packageName: "jiraEntry",
                fallback: "unmount",
                teamName: "delorean-spa"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jqynJ.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67aea0c62c200796$var$CapabilityTrackerConnector, {
                routes: trackedRoutes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7grfV.default), null)),
            after: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67aea0c62c200796$var$LoadPhaseSwitcher, null)
        }, children);
    let SpaClientRouter;
    if (typeof loadLazyRoutes === 'function') {
        const useRouterRoutes = (0, $kfvK2.createRouterSelector)((state)=>state.routes);
        SpaClientRouter = ({ children: children })=>{
            const actions = (0, $kfvK2.useRouterStoreActions)();
            const currentRoutes = useRouterRoutes();
            (0, $eJOHy.useEffect)(()=>{
                let isCancelled = false;
                const loadRoutes = async ()=>{
                    if (!isCancelled) {
                        const getLazyRoutes = await loadLazyRoutes();
                        await actions.setRoutes(getLazyRoutes());
                    }
                };
                loadRoutes();
                return ()=>{
                    isCancelled = true;
                };
            }, [
                actions
            ]);
            return (0, $7jTnu.fg)('jfp_magma_jira-use-id-sync') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SpaClientRouterTemplate, {
                trackedRoutes: currentRoutes
            }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2uWc.Router), routerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
                id: "spa-main.client-router",
                packageName: "jiraEntry",
                fallback: "unmount",
                teamName: "delorean-spa"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jqynJ.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67aea0c62c200796$var$CapabilityTrackerConnector, {
                routes: currentRoutes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7grfV.default), null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67aea0c62c200796$var$LoadPhaseSwitcher, null));
        };
    } else SpaClientRouter = ({ children: children })=>(0, $7jTnu.fg)('jfp_magma_jira-use-id-sync') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SpaClientRouterTemplate, {
            trackedRoutes: routes
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2uWc.Router), routerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
            id: "spa-main.client-router",
            packageName: "jiraEntry",
            fallback: "unmount",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jqynJ.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67aea0c62c200796$var$CapabilityTrackerConnector, {
            routes: routes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7grfV.default), null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67aea0c62c200796$var$LoadPhaseSwitcher, null));
    const AppWithoutPlaceholders = ({ entryPointPlaceholders: entryPointPlaceholders })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PSAp.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
            name: "jira-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointPlaceholderContext).Provider, {
            value: entryPointPlaceholders
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hW27F.Spa), {
            locale: locale,
            messages: messages,
            Router: SpaClientRouter,
            initRoute: initRoute,
            routes: routes,
            routerLinkComponent: (0, $e8u2a.JiraRouterLinkConfiguration)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__NAV_VERSION__ = '3.0.0';
    (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/setup', 'jira-spa/setup.start', true);
    (0, $6uWhG.setMark)('_jira-spa/spa-shell.start');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const container = document.getElementById('jira-frontend');
    if (container) {
        (0, $xTtyc.getVCObserver)().setSSRElement(container);
        (0, $xTtyc.getVCObserver)().setReactRootRenderStart();
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                (0, $xTtyc.getVCObserver)().setReactRootRenderStop();
            });
        });
        const entryPointPlaceholders = (0, $2dBpR.getPlaceholdersFromHTML)();
        (0, $5eRs1.renderReactApp)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AppWithoutPlaceholders, {
            entryPointPlaceholders: entryPointPlaceholders
        }), {
            isSsrHydrationEnabled: (0, $5eRs1.getIsSsrHydrationEnabled)(),
            container: container
        });
    }
    (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/spa-shell', '_jira-spa/spa-shell.start');
    (0, $6uWhG.setMark)('JIRA_SPA_ENTRY_REACT_DOM_RENDER');
    setTimeout(()=>{
        (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-stop');
    });
    if ((0, $epTsa.expVal)('uip_preprod_slow', 'value', 0) > 0) {
        (0, $6uWhG.setMark)('slow-start');
        const end = performance.now() + (0, $epTsa.expVal)('uip_preprod_slow', 'value', 0);
        while(performance.now() < end);
        (0, $6uWhG.setMark)('slow-stop');
    }
    if ((0, $7jTnu.fg)('remove_priority_ranking_for_global_spa')) (0, $9Szlh.default).installHighPrioritySPAApps();
    else (0, $9Szlh.default).installHighPriorityAppsOld(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'HighPriorityAppsArgs'.
    (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))($67aea0c62c200796$var$globalSettingsArgs, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
    $67aea0c62c200796$var$superbatchInit();
    return null;
};
const $67aea0c62c200796$export$f71867a5b2484020 = async (getInitialRoutes, loadLazyRoutes)=>{
    if ((0, $7jTnu.fg)('jfp-magma-reduce-react-fallback-throttle')) globalThis.REACT_FALLBACK_THROTTLE_MS = (0, $epTsa.expVal)('jfp-magma-initial-react-fallback-throttle-ms', 'fallback_throttle_ms', 10 // 500 is the default value internally in react-dom, but we reduced it to 10ms with jfp-magma-reduce-react-fallback-throttle
    );
    if ($67aea0c62c200796$var$altBootstrapEnabled) (0, $1jgVa.LooselyLazy).init({
        mode: (0, $gAzn8.MODE).RENDER,
        crossOrigin: 'anonymous'
    });
    return $67aea0c62c200796$var$main(getInitialRoutes, loadLazyRoutes).catch((reason)=>(0, $f0nBN.reportBootstrapError)(reason)).finally(()=>{
        (0, $ceCro.reportUnreportedStatsigInitialisationError)();
    });
};

});
parcelRegister("g1P4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $b24338726c37481e$export$2e2bcd8739ae039);
function $b24338726c37481e$var$getUFORouteName(route) {
    if (route.ufoName != null) return route.ufoName;
    return route.name;
}
var $b24338726c37481e$export$2e2bcd8739ae039 = $b24338726c37481e$var$getUFORouteName;

});

parcelRegister("5QkZY", function(module, exports) {

$parcel$export(module.exports, "collectSSRPlaceholderDimensions", () => $d127e97f5f58098a$export$aee7516e57289027);
// lightweight script to scan the SSR response and collect all elements with data-ssr-placeholder attribute
// and save their size/positions in a map __SSR_PLACEHOLDERS_DIMENSIONS__ on the Window object. Each placeholderId is
// unique and maps to its corresponding elements bounding client rectangle dimensions.
function $d127e97f5f58098a$export$aee7516e57289027(document, window, enablePageLayoutPlaceholder = false) {
    const ssrPlaceholders = document?.querySelectorAll('[data-ssr-placeholder]');
    ssrPlaceholders.forEach((elem)=>{
        const placeholderId = elem.getAttribute('data-ssr-placeholder');
        const boundingClient = elem.getBoundingClientRect();
        if (placeholderId) {
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__[placeholderId] = boundingClient;
        }
    });
    if (enablePageLayoutPlaceholder) {
        const pageLayoutRoot = document?.getElementById('unsafe-design-system-page-layout-root');
        if (pageLayoutRoot) {
            const boundingClient = pageLayoutRoot.getBoundingClientRect();
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__['page-layout.root'] = boundingClient;
        }
    }
}

});

parcelRegister("2JM8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb2854f642c92638$export$2e2bcd8739ae039);
$parcel$export(module.exports, "updatePageloadName", () => $fb2854f642c92638$export$d0f99433cd4f4028);

var $aXKmr = parcelRequire("aXKmr");

var $5XGBO = parcelRequire("5XGBO");

var $e2Aj8 = parcelRequire("e2Aj8");

var $kTF8d = parcelRequire("kTF8d");

var $1JCFI = parcelRequire("1JCFI");

var $3TY2E = parcelRequire("3TY2E");

var $7HqSC = parcelRequire("7HqSC");
const $fb2854f642c92638$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $fb2854f642c92638$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    const activeInteraction = (0, $3TY2E.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $7HqSC.default).current = routeName || null;
    const rate = ufoName ? (0, $e2Aj8.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $5XGBO.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        const newId = (0, $aXKmr.v4)();
        (0, $1JCFI.DefaultInteractionID).current = newId;
        (0, $3TY2E.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $kTF8d.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $3TY2E.addHoldByID)(newId, [], $fb2854f642c92638$var$AWAITING_PAGELOAD_NAME, $fb2854f642c92638$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $3TY2E.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $3TY2E.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $3TY2E.removeHoldByID)(activeInteraction.id, $fb2854f642c92638$var$AWAITING_PAGELOAD_NAME);
    }
}
var $fb2854f642c92638$export$2e2bcd8739ae039 = $fb2854f642c92638$var$traceUFOPageLoad;
function $fb2854f642c92638$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    const interaction = (0, $3TY2E.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $e2Aj8.getInteractionRate)(ufoName, 'page_load');
        (0, $3TY2E.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $5XGBO.default)(rate)) (0, $7HqSC.default).current = ufoName;
        else (0, $3TY2E.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $3TY2E.removeHoldByID)(interaction.id, $fb2854f642c92638$var$AWAITING_PAGELOAD_NAME);
}

});

parcelRegister("f0nBN", function(module, exports) {

$parcel$export(module.exports, "reportBootstrapError", () => $58510e6dcc5284d7$export$a5c16644a2d3c205);

var $exfGR = parcelRequire("exfGR");

var $mjinE = parcelRequire("mjinE");

var $lpMrC = parcelRequire("lpMrC");

var $aYncF = parcelRequire("aYncF");

var $gYnSx = parcelRequire("gYnSx");


var $fEmyV = parcelRequire("fEmyV");
const $58510e6dcc5284d7$export$649804097de83b3b = [
    // https://jplat.jira.atlassian.cloud/browse/MAGMA-2440
    {
        browser: 'Chrome',
        browserVersion: '116.0.0',
        errorMessage: /Cannot read properties of undefined \(reading 'target'\)/
    }
];
const $58510e6dcc5284d7$var$checkBrowserCondition = (error, filterCriteria)=>filterCriteria.browser != null ? (0, $lpMrC.getBrowser)().name === filterCriteria.browser : true;
const $58510e6dcc5284d7$var$checkBrowserVersionCondition = (error, filterCriteria)=>filterCriteria.browserVersion != null ? (0, $lpMrC.getBrowser)().version === filterCriteria.browserVersion : true;
const $58510e6dcc5284d7$var$checkErrorMessageCondition = (error, filterCriteria)=>filterCriteria.errorMessage != null ? error.message.match(filterCriteria.errorMessage) : true;
const $58510e6dcc5284d7$export$a66ce4bea8340820 = (error, errorFilteringCriterias)=>{
    try {
        // condition checkers must return true if they don't apply, so an empty filterCriteria will match (and block) ALL errors
        const conditionCheckers = [
            $58510e6dcc5284d7$var$checkBrowserCondition,
            $58510e6dcc5284d7$var$checkBrowserVersionCondition,
            $58510e6dcc5284d7$var$checkErrorMessageCondition
        ];
        // Should send analytics if no filtering conditions are met
        return !errorFilteringCriterias.some((filterCriteria)=>conditionCheckers.every((conditionChecker)=>conditionChecker(error, filterCriteria)));
    } catch (e) {
        // If any error occurs during filtering, experience analytics should still be sent
        return true;
    }
};
const $58510e6dcc5284d7$export$a5c16644a2d3c205 = async (error)=>{
    const tenantContextData = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    // We probably already have analytics initialised but we could have failed earlier than it
    (0, $exfGR.default)(tenantContextData);
    // Experience analytics should only be sent if it is not filtered
    if ($58510e6dcc5284d7$export$a66ce4bea8340820(error, $58510e6dcc5284d7$export$649804097de83b3b)) (0, $mjinE.default)({
        analyticsSource: (0, $60d311439a302207$export$c9e16a15d65437),
        experience: (0, $60d311439a302207$export$b1534bc11f201efd),
        wasExperienceSuccesful: false,
        location: (0, $60d311439a302207$export$7dfef0177e883b05),
        application: (0, $60d311439a302207$export$aa6008fe0169b864),
        edition: (0, $60d311439a302207$export$39418a21fbb51487),
        additionalAttributes: (0, $fEmyV.routeAnalyticsAttributes)
    });
    (0, $gYnSx.default)({
        meta: {
            packageName: 'jiraBootstrapSlaReporter',
            id: 'bootstrap-failure',
            teamName: 'magma'
        },
        error: error,
        attributes: (0, $fEmyV.routeAnalyticsAttributes)
    });
    throw error;
};

});
const $60d311439a302207$export$c9e16a15d65437 = 'navigationNext';
const $60d311439a302207$export$b1534bc11f201efd = 'jiraPageContainer';
const $60d311439a302207$export$fa4bbc89fd1f1a7 = null;
const $60d311439a302207$export$aa6008fe0169b864 = null;
const $60d311439a302207$export$39418a21fbb51487 = null;
const $60d311439a302207$export$7dfef0177e883b05 = 'entry.jira-spa';
const $60d311439a302207$var$PAGE_CONTAINER_MARK = 'jira-spa/spa-shell/page-container';
const $60d311439a302207$export$7114284ca03133ee = `_${$60d311439a302207$var$PAGE_CONTAINER_MARK}.end`;
const $60d311439a302207$export$21473105c510aacc = 'jira-spa/spa-shell/page-layout';
const $60d311439a302207$export$898b6208220685b0 = 'jira-spa/spa-shell/global-containers';
const $60d311439a302207$export$e2bc63118050de32 = `_${$60d311439a302207$export$898b6208220685b0}.start`;
const $60d311439a302207$export$59f83d43fe209319 = `_${$60d311439a302207$export$898b6208220685b0}.end`;
const $60d311439a302207$export$fb9876ab4228d985 = 'jira-spa/spa-shell/global-components';
const $60d311439a302207$export$c20831be6f780cb5 = `_${$60d311439a302207$export$fb9876ab4228d985}.start`;
const $60d311439a302207$export$398df1bca49f9884 = `_${$60d311439a302207$export$fb9876ab4228d985}.end`;
const $60d311439a302207$export$7048c99f32c60b34 = 'jira-spa/spa-shell/global-containers/app-base';
const $60d311439a302207$export$3c2d8af5c7577fe7 = `_${$60d311439a302207$export$7048c99f32c60b34}.start`;
const $60d311439a302207$export$aac77afee74c49d0 = `_${$60d311439a302207$export$7048c99f32c60b34}.end`;
const $60d311439a302207$export$4f341d86a3c214 = 'jira-spa/spa-shell/global-containers/router';
const $60d311439a302207$export$16e7ead3a8b5c366 = `_${$60d311439a302207$export$4f341d86a3c214}.start`;
const $60d311439a302207$export$c389f0b50840d5ca = `_${$60d311439a302207$export$4f341d86a3c214}.end`;

parcelRegister("fEmyV", function(module, exports) {

$parcel$export(module.exports, "routeAnalyticsAttributes", () => $4b8de68fd53e342b$export$c71778b3a4356b04);

var $kQnVX = parcelRequire("kQnVX");

var $7A5g5 = parcelRequire("7A5g5");
const $4b8de68fd53e342b$export$c71778b3a4356b04 = Object.defineProperties({}, {
    routeName: {
        enumerable: true,
        get: (0, $kQnVX.getRouteName)
    },
    userLocation: {
        enumerable: true,
        get: (0, $kQnVX.getUserLocation)
    },
    previousSubProduct: {
        enumerable: true,
        get: (0, $kQnVX.getPreviousSubProduct)
    },
    isProjectAdmin: {
        enumerable: true,
        get: (0, $7A5g5.getIsProjectAdmin)
    }
});

});


parcelRegister("lXp9u", function(module, exports) {
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $awqaz = parcelRequire("awqaz");

if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("lhLuV"));
    const isDevMode = false;
    (0, $awqaz.default).devtools = isDevMode && (()=>({
            serialize: {
                // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
                replacer: (key, value)=>value instanceof HTMLElement ? {
                        data: {
                            tagName: value.tagName,
                            className: value.className,
                            id: value.id,
                            __SANITIZED__: true
                        },
                        __serializedType__: 'HTMLElement'
                    } : value
            }
        }));
    (0, $awqaz.default).batchUpdates = !false;
    Object.freeze((0, $awqaz.default));
    $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
}

});
parcelRegister("lhLuV", function(module, exports) {
const $f7f007904598d8b9$var$style = document.createElement('style');
$f7f007904598d8b9$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);-ms-overflow-style:-ms-autohiding-scrollbar;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ul style:first-child~*+ul,ol ul:not(:first-child),ol style:first-child~*+ul,ul ol:not(:first-child),ul style:first-child~*+ol,ol ol:not(:first-child),ol style:first-child~*+ol{margin-top:var(--ds-space-050,4px)}p:first-child,style:first-child+p,ul:first-child,style:first-child+ul,ol:first-child,style:first-child+ol,dl:first-child,style:first-child+dl,h1:first-child,style:first-child+h1,h2:first-child,style:first-child+h2,h3:first-child,style:first-child+h3,h4:first-child,style:first-child+h4,h5:first-child,style:first-child+h5,h6:first-child,style:first-child+h6,blockquote:first-child,style:first-child+blockquote,pre:first-child,style:first-child+pre,form:first-child,style:first-child+form,table:first-child,style:first-child+table{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font:var(--ds-font-body-small,normal 400 11px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif)}code,kbd{font-family:var(--ds-font-family-code,ui-monospace,Menlo,"Segoe UI Mono","Ubuntu Mono",monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:1px var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{color-scheme:light}[data-color-mode=dark]{color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:2px solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,style:first-child+td,th:first-child,style:first-child+th{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
document.querySelector('head').appendChild($f7f007904598d8b9$var$style);

});


parcelRegister("3KIqP", function(module, exports) {

$parcel$export(module.exports, "initPlatformFeatureFlags", () => $ed64a16fdeb4cbad$export$2d291317456ada16);

var $8XtVW = parcelRequire("8XtVW");

var $7jTnu = parcelRequire("7jTnu");

var $bi9FK = parcelRequire("bi9FK");
const $ed64a16fdeb4cbad$export$2d291317456ada16 = ([isOverride, resolver])=>{
    (0, $8XtVW.setBooleanFeatureFlagResolver)((flagKey)=>// disable existence check as platform feature >flags< might not be gates
        (0, $7jTnu.withoutFeatureExistenceCheck)(()=>isOverride(flagKey) ? resolver(flagKey) : (0, $7jTnu.fg)(flagKey) || (0, $bi9FK.ff)(flagKey)));
};

});
parcelRegister("bi9FK", function(module, exports) {

$parcel$export(module.exports, "ff", () => $af7a0b2e539364ac$export$f59495b1b7502b33);
$parcel$export(module.exports, "getMultivariateFeatureFlag", () => $af7a0b2e539364ac$export$757bc67afadef4a0);
$parcel$export(module.exports, "getFeatureFlagValue", () => $af7a0b2e539364ac$export$7064bb599f663d7e);

var $Buq00 = parcelRequire("Buq00");

var $6eHOp = parcelRequire("6eHOp");

var $9DwQv = parcelRequire("9DwQv");

var $4ajKf = parcelRequire("4ajKf");
function $af7a0b2e539364ac$export$a6dcfcb59016e126(featureFlagName, defaultValue) {
    const client = (0, $4ajKf.getFeatureFlagClient)();
    const flag = client.getFlagEvaluation(featureFlagName, {
        default: defaultValue
    });
    if (!flag) return defaultValue;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return flag.value;
}
const $af7a0b2e539364ac$var$getBooleanFeatureFlagUsingClient = (featureFlagName, defaultValue)=>{
    const client = (0, $4ajKf.getFeatureFlagClient)();
    return client.getBooleanValue(featureFlagName, {
        default: defaultValue,
        shouldTrackExposureEvent: false
    });
};
const $af7a0b2e539364ac$var$getMultivariateFeatureFlagUsingClient = (featureFlagName, defaultValue, possibleValues)=>{
    const client = (0, $4ajKf.getFeatureFlagClient)();
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'T'.
    return client.getVariantValue(featureFlagName, {
        default: defaultValue,
        // @ts-expect-error - TS2322 - Type 'T[]' is not assignable to type 'string[]'.
        oneOf: possibleValues,
        shouldTrackExposureEvent: false
    });
};
/**
 * The feature flag client can be configured to fire automatic exposure events when evaluating
 * feature flag values. For the Track All Changes project, we need all flag evaluations to go
 * through this client so that we can collect these events for all feature flags.
 * See https://hello.atlassian.net/browse/FD-18145 for more information.
 */ const $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations = ()=>(0, $9DwQv.isAutomaticExposureCollectionEnabled)();
const $af7a0b2e539364ac$export$f59495b1b7502b33 = (featureFlagName, defaultValue = false)=>{
    const impl = $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations() ? $af7a0b2e539364ac$var$getBooleanFeatureFlagUsingClient : (0, $6eHOp.ff);
    const value = impl(featureFlagName, defaultValue);
    (0, $Buq00.addFeatureFlagAccessed)(featureFlagName, value);
    return value;
};
function $af7a0b2e539364ac$export$757bc67afadef4a0(featureFlagName, defaultValue, possibleValues) {
    const impl = $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations() ? $af7a0b2e539364ac$var$getMultivariateFeatureFlagUsingClient : (0, $6eHOp.getMultivariateFeatureFlag);
    const value = impl(featureFlagName, defaultValue, possibleValues);
    (0, $Buq00.addFeatureFlagAccessed)(featureFlagName, value);
    return value;
}
function $af7a0b2e539364ac$export$7064bb599f663d7e(featureFlagName, defaultValue) {
    const impl = $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations() ? $af7a0b2e539364ac$export$a6dcfcb59016e126 : (0, $6eHOp.getFeatureFlagValue);
    const value = impl(featureFlagName, defaultValue);
    (0, $Buq00.addFeatureFlagAccessed)(featureFlagName, value);
    return impl(featureFlagName, defaultValue);
}

});
parcelRegister("6eHOp", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagValue", () => $da6d0b5f6a4027e4$export$7064bb599f663d7e);
$parcel$export(module.exports, "ff", () => $da6d0b5f6a4027e4$export$f59495b1b7502b33);
$parcel$export(module.exports, "getMultivariateFeatureFlag", () => $da6d0b5f6a4027e4$export$757bc67afadef4a0);
function $da6d0b5f6a4027e4$export$7064bb599f663d7e(_featureFlagName, defaultValue) {
    return defaultValue;
}
const $da6d0b5f6a4027e4$export$f59495b1b7502b33 = (featureFlagName, defaultValue = false)=>{
    const flagValue = $da6d0b5f6a4027e4$export$7064bb599f663d7e(featureFlagName, defaultValue);
    const isValid = typeof flagValue === 'boolean';
    return isValid ? flagValue : defaultValue;
};
const $da6d0b5f6a4027e4$export$757bc67afadef4a0 = (featureFlagName, defaultValue, possibleValues)=>{
    const flagValue = $da6d0b5f6a4027e4$export$7064bb599f663d7e(featureFlagName, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    defaultValue);
    const isValid = typeof flagValue === 'string' && possibleValues.includes(flagValue);
    return isValid ? flagValue : defaultValue;
};

});

parcelRegister("4ajKf", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagClient", () => $236e6674104348c2$export$43a6e0552eef5ca9);

var $LFmXM = parcelRequire("LFmXM");
parcelRequire("bNJKC");
var $9Bj3Q = parcelRequire("9Bj3Q");

var $j500r = parcelRequire("j500r");

var $2Mqjh = parcelRequire("2Mqjh");
const $236e6674104348c2$var$getAnalyticsClientInstance = ()=>(0, $2Mqjh.getAnalyticsWebClientPromise)().then((analyticsClient)=>analyticsClient.getInstance());
const $236e6674104348c2$var$createFeatureFlagClient = ()=>{
    const client = new (0, $9Bj3Q.default)({
        analyticsHandler: {
            sendOperationalEvent: async (event)=>{
                if (!false) $236e6674104348c2$var$getAnalyticsClientInstance().then((analyticsClient)=>{
                    // SSR doesn't have an analytics client
                    if (!analyticsClient) return;
                    // customize event data here if needed
                    analyticsClient.sendOperationalEvent(event);
                });
            }
        },
        flags: undefined
    });
    return client;
};
const $236e6674104348c2$var$featureFlagClient = $236e6674104348c2$var$createFeatureFlagClient();
const $236e6674104348c2$var$getFeatureFlags = ()=>{
    const flags = (0, $j500r.default)();
    if (Object.keys(flags).length === 0) {
        if (false) {
            const err = new Error("Feature flags are not available yet. The feature flag client can't be initialized");
            // print out the stack trace for SSR, so we can have better understanding on
            // which module is using the client too early.
            // in SSR, we use bunyan to replace the console.error, so we can use the standard
            // log format for apps.
            // eslint-disable-next-line no-console
            console.error({
                err: err
            });
        } else // eslint-disable-next-line no-console
        console.error("Feature flags are not available yet. The feature flag client can't be initialized");
    }
    return flags;
};
const $236e6674104348c2$var$configureFeatureFlagClient = ()=>{
    const flags = $236e6674104348c2$var$getFeatureFlags();
    // @ts-expect-error - TS2345 - Argument of type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/utils/feature-flagging-using-meta/src/common/types").Flags' is not assignable to parameter of type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/@atlaskit/feature-flag-client/dist/types/types").Flags'.
    $236e6674104348c2$var$featureFlagClient.setFlags(flags);
    if (!false) $236e6674104348c2$var$featureFlagClient.setIsAutomaticExposuresEnabled(true);
    return $236e6674104348c2$var$featureFlagClient;
};
// NOTE: `memoizeOne` is doing unnecessary checks, what we need in this file is
// a simple local variable implementation, if local variable doesn't exist then
// create it.
const $236e6674104348c2$var$getMemoizedFeatureFlagClient = (0, $LFmXM.default)($236e6674104348c2$var$configureFeatureFlagClient);
let $236e6674104348c2$var$builtFeatureFlagClient;
const $236e6674104348c2$export$43a6e0552eef5ca9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (globalVar.isReorderEarlyScriptsEnabled === true) {
        if (typeof $236e6674104348c2$var$builtFeatureFlagClient === 'undefined' || globalVar.invalidateFeatureFlagsClient_DO_NOT_USE === true) {
            globalVar.invalidateFeatureFlagsClient_DO_NOT_USE = false;
            $236e6674104348c2$var$builtFeatureFlagClient = (0, $LFmXM.default)($236e6674104348c2$var$configureFeatureFlagClient);
        }
        return $236e6674104348c2$var$builtFeatureFlagClient();
    }
    return $236e6674104348c2$var$getMemoizedFeatureFlagClient();
};

});
parcelRegister("bNJKC", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("9Bj3Q")).default);

var $9Bj3Q = parcelRequire("9Bj3Q");

var $kQbIk = parcelRequire("kQbIk");

});
parcelRegister("9Bj3Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bb02a5e0f121f41$export$2e2bcd8739ae039);

var $kQbIk = parcelRequire("kQbIk");

var $6WJMJ = parcelRequire("6WJMJ");

var $224NY = parcelRequire("224NY");

var $3fqqy = parcelRequire("3fqqy");
class $8bb02a5e0f121f41$export$2e2bcd8739ae039 {
    constructor(options){
        (0, $6WJMJ.enforceAttributes)(options, [
            'analyticsHandler'
        ], 'Feature Flag Client');
        const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
        this.flags = new Map();
        this.flagWrapperCache = new Map();
        this.customAttributesExposuresCache = new Set();
        this.trackedFlags = new Set();
        this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
        this.ignoreTypes = ignoreTypes || false;
        this.setFlags(flags || {});
        this.setAnalyticsHandler(analyticsHandler);
    }
    setFlags(flags) {
        if (!(0, $6WJMJ.isObject)(flags)) return;
        Object.entries(flags).forEach(([flagKey, flag])=>{
            this.flags.set(flagKey, flag);
        });
        // Clear any cached data for flags that have been passed in again,
        // in case they have different values or explanations
        for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
    }
    setAnalyticsHandler(analyticsHandler) {
        this.analyticsHandler = analyticsHandler;
    }
    setIsAutomaticExposuresEnabled(isEnabled) {
        this.isAutomaticExposuresEnabled = isEnabled;
    }
    /**
	 * This method returns the wrapper object for the given flag key.
	 * If the flag does not exist, this will return a stubbed flag following the null-object pattern,
	 * so it is always guaranteed to return an object.
	 */ getFlagWrapper(flagKey) {
        let wrapper = this.flagWrapperCache.get(flagKey);
        if (wrapper !== undefined) return wrapper;
        const flag = this.flags.get(flagKey);
        if (flag) wrapper = new (0, $3fqqy.default)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
        else wrapper = new (0, $224NY.default)();
        this.flagWrapperCache.set(flagKey, wrapper);
        return wrapper;
    }
    clear() {
        this.flags.clear();
        this.flagWrapperCache.clear();
        this.trackedFlags.clear();
    }
    getBooleanValue(flagKey, options) {
        (0, $6WJMJ.enforceAttributes)(options, [
            'default'
        ], 'getBooleanValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getBooleanValue(options);
    }
    getVariantValue(flagKey, options) {
        (0, $6WJMJ.enforceAttributes)(options, [
            'default',
            'oneOf'
        ], 'getVariantValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getVariantValue(options);
    }
    getJSONValue(flagKey) {
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getJSONValue();
    }
    getRawValue(flagKey, options) {
        (0, $6WJMJ.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getRawValue(options);
    }
    getFlagEvaluation(flagKey, options) {
        (0, $6WJMJ.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getFlagEvaluation(options);
    }
    /**
	 * This method combines both the trackExposure and sendAutomaticExposure flows into
	 * one endpoint. Depending on the passed in trigger reason a manual or automatic exposure
	 * is sent.
	 **/ trackFeatureFlag(flagKey, options = {}) {
        const triggerReason = options?.triggerReason ? options.triggerReason : (0, $kQbIk.ExposureTriggerReason).Manual;
        const isValueSet = this.flags.has(flagKey) || 'value' in options;
        if (!isValueSet) {
            // eslint-disable-next-line no-console
            console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
            return;
        }
        // if no values for flagValue and explanation supplied then retrieve them from the flags map
        const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
        const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
        if (triggerReason === (0, $kQbIk.ExposureTriggerReason).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
        else // default to fire a manual track exposure
        this._trackExposure(flagKey, {
            value: flagValue,
            explanation: flagExplanation
        }, triggerReason);
    }
    trackExposure(flagKey, flag, exposureData = {}) {
        return this._trackExposure(flagKey, flag, (0, $kQbIk.ExposureTriggerReason).Manual, exposureData);
    }
    _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
        if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
        (0, $6WJMJ.checkForReservedAttributes)(exposureData);
        const flagAttributes = {
            flagKey: flagKey,
            reason: flag.explanation.kind,
            ruleId: flag.explanation.ruleId,
            value: flag.value
        };
        this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
    }
    shouldSendEvent(flagKey, customAttributes) {
        return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $6WJMJ.isObjectEmptyOrUndefined)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
    }
    sendAutomaticExposure(flagKey, value, flagExplanation) {
        if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
        const flagAttributes = {
            flagKey: flagKey,
            value: value,
            reason: flagExplanation.kind || 'SIMPLE_EVAL',
            ruleId: flagExplanation.ruleId,
            errorKind: flagExplanation.errorKind
        };
        this.sendExposureEvent(flagAttributes, (0, $kQbIk.ExposureTriggerReason).AutoExposure);
    }
    sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
        if (!this.trackedFlags.has(attributes.flagKey)) {
            const exposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: attributes,
                tags: [
                    'measurement',
                    exposureTriggerReason
                ],
                highPriority: false,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(exposureEvent);
            this.trackedFlags.add(attributes.flagKey);
        }
        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (!(0, $6WJMJ.isObjectEmptyOrUndefined)(customAttributes)) {
            const customeAttributesExposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: Object.assign({}, attributes, customAttributes),
                tags: [
                    'measurement',
                    (0, $kQbIk.ExposureTriggerReason).hasCustomAttributes,
                    exposureTriggerReason
                ],
                highPriority: true,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
            this.customAttributesExposuresCache.add(attributes.flagKey);
        }
    }
    getFlagStats() {
        const flagStats = {};
        for (const [flagKey, wrapper] of this.flagWrapperCache){
            const { evaluationCount: evaluationCount } = wrapper;
            flagStats[flagKey] = {
                evaluationCount: evaluationCount
            };
        }
        return flagStats;
    }
}

});
parcelRegister("kQbIk", function(module, exports) {

$parcel$export(module.exports, "ExposureTriggerReason", () => $d2b4e10cf5f66d35$export$2c20ffeba7dbc068);
var $d2b4e10cf5f66d35$export$2c20ffeba7dbc068 = /*#__PURE__*/ function(ExposureTriggerReason) {
    ExposureTriggerReason["OptIn"] = "optInExposure";
    ExposureTriggerReason["Manual"] = "manualExposure";
    ExposureTriggerReason["Default"] = "defaultExposure";
    ExposureTriggerReason["AutoExposure"] = "autoExposure";
    ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    return ExposureTriggerReason;
}({});

});

parcelRegister("6WJMJ", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $a1bfd1d7716613a1$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isObjectEmptyOrUndefined", () => $a1bfd1d7716613a1$export$8ed1df9dbe2e9a7d);
$parcel$export(module.exports, "enforceAttributes", () => $a1bfd1d7716613a1$export$c7d37910dd25ecbf);
$parcel$export(module.exports, "checkForReservedAttributes", () => $a1bfd1d7716613a1$export$891630e169ca14a4);
const $a1bfd1d7716613a1$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
const $a1bfd1d7716613a1$export$8ed1df9dbe2e9a7d = (obj)=>{
    return obj ? Object.keys(obj).length === 0 : true;
};
const $a1bfd1d7716613a1$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
    attributes.forEach((attribute)=>{
        if (!(attribute in obj)) {
            const title = identifier ? `${identifier}: ` : '';
            throw new Error(`${title}Missing ${attribute}`);
        }
    });
};
const $a1bfd1d7716613a1$export$891630e169ca14a4 = (customAttributes)=>{
    const reservedAttributes = [
        'flagKey',
        'ruleId',
        'reason',
        'value',
        'errorKind'
    ];
    const keys = customAttributes ? Object.keys(customAttributes) : [];
    if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
};
const $a1bfd1d7716613a1$var$validateFlag = (flagKey, flag)=>{
    if ($a1bfd1d7716613a1$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
};
const $a1bfd1d7716613a1$export$410eec87ab950965 = (flags)=>{
    Object.keys(flags).forEach((key)=>$a1bfd1d7716613a1$var$validateFlag(key, flags[key]));
};

});

parcelRegister("224NY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef639bb38eb56f9b$export$2e2bcd8739ae039);
const $ef639bb38eb56f9b$export$933245d8afcc8872 = {
    kind: 'ERROR',
    errorKind: 'FLAG_NOT_FOUND'
};
class $ef639bb38eb56f9b$export$2e2bcd8739ae039 {
    evaluate(defaultValue) {
        return defaultValue;
    }
    getBooleanValue(options) {
        return this.evaluate(options.default);
    }
    getVariantValue(options) {
        return this.evaluate(options.default);
    }
    getJSONValue() {
        return this.evaluate({});
    }
    getRawValue(options) {
        return this.evaluate(options.default);
    }
    getFlagEvaluation(options) {
        const value = this.evaluate(options.default);
        return {
            value: value,
            explanation: $ef639bb38eb56f9b$export$933245d8afcc8872
        };
    }
    constructor(){
        // Unused but required for type
        this.evaluationCount = -1;
    }
}

});

parcelRegister("3fqqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ce9526e046a6baf$export$2e2bcd8739ae039);

var $kQbIk = parcelRequire("kQbIk");
class $3ce9526e046a6baf$export$2e2bcd8739ae039 {
    constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
        this.flagKey = flagKey;
        this.flag = flag;
        this.evaluationCount = 0;
        this.trackExposure = trackExposure;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.ignoreTypes = ignoreTypes;
    }
    getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let exposureTriggerReason = (0, $kQbIk.ExposureTriggerReason).OptIn;
        if (shouldTrackExposureEvent === undefined) {
            shouldTrackExposureEvent = true;
            exposureTriggerReason = (0, $kQbIk.ExposureTriggerReason).Default;
        }
        // It is very common for products to call this method many times for the same flag key,
        // as flag evaluations are often done inside action callbacks and/or inside components with many instances.
        // We can cache the result of the first evaluation to avoid doing the same validation checks on every call.
        if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
            oneOf: oneOf,
            ignoreTypes: ignoreTypes
        });
        let value = this.evaluationResult.value;
        if (this.evaluationResult.didFallbackToDefaultValue) // Use the default that was passed in, just in case it's different to what it was in the initial evaluation
        value = defaultValue;
        else if (shouldTrackExposureEvent) // For backwards compability, only fire the opt-in exposure event in valid evaluations.
        this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
        this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
        this.evaluationCount++;
        return {
            value: value,
            explanation: this.evaluationResult.explanation
        };
    }
    computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let result = {
            value: this.flag.value,
            explanation: this.flag.explanation,
            didFallbackToDefaultValue: false
        };
        if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'WRONG_TYPE'
            };
        } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'VALIDATION_ERROR'
            };
        }
        return result;
    }
    getBooleanValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: undefined,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getVariantValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: options.oneOf,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getJSONValue() {
        return this.getCachedResultOrCompute({}, {
            shouldTrackExposureEvent: false,
            ignoreTypes: this.ignoreTypes
        }).value;
    }
    getRawValue(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            oneOf: undefined,
            ignoreTypes: true
        }).value;
    }
    getFlagEvaluation(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            ignoreTypes: this.ignoreTypes || false
        });
    }
}

});






parcelRegister("3Zulo", function(module, exports) {

$parcel$export(module.exports, "NonCritical", () => $35e7d40f521eb281$export$20fd89b1bf707b1a);
$parcel$export(module.exports, "default", () => $35e7d40f521eb281$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $9XYcy = parcelRequire("9XYcy");
const $35e7d40f521eb281$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
    const [{ isReady: isReady }] = (0, $9XYcy.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eJOHy.useState)(true);
    const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (timerThreshold != null) setTimeout(()=>{
            setHasThresholdTimerExpired(true);
        }, timerThreshold);
    }, [
        timerThreshold
    ]);
    if (!isFirstRun || isReady || hasThresholdTimerExpired) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    }
    return null;
};
const $35e7d40f521eb281$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($35e7d40f521eb281$export$83d969795398ec56, props));
/**
 * Delays rendering its children until the page is deemed ready, optimizing for a smoother initial load. Suitable for content that is not immediately necessary.
 */ const $35e7d40f521eb281$var$NonCriticalComponent = (props)=>{
    const [{ isReady: isReady }] = (0, $9XYcy.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eJOHy.useState)(true);
    if (!isFirstRun || isReady) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    }
    return null;
};
const $35e7d40f521eb281$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($35e7d40f521eb281$var$NonCriticalComponent, props));
var $35e7d40f521eb281$export$2e2bcd8739ae039 = $35e7d40f521eb281$var$NonCriticalComponent;

});
parcelRegister("9XYcy", function(module, exports) {

$parcel$export(module.exports, "useSpaStatePageReady", () => $a46c4d7909adbd26$export$ea2491906b753456);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $6XFSq = parcelRequire("6XFSq");
const $a46c4d7909adbd26$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    return {
        isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
    };
};
const $a46c4d7909adbd26$export$ea2491906b753456 = (0, $iJq0l.createHook)((0, $6XFSq.default), {
    selector: $a46c4d7909adbd26$export$e6897aa59ee7aee5
});

});


parcelRegister("hW27F", function(module, exports) {

$parcel$export(module.exports, "Spa", () => $293e894cae72421f$export$6d4069f4b64f7492);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");


var $dydef = parcelRequire("dydef");

var $7jTnu = parcelRequire("7jTnu");

var $drMaP = parcelRequire("drMaP");

var $286cZ = parcelRequire("286cZ");

var $ieHpw = parcelRequire("ieHpw");

var $kUiAZ = parcelRequire("kUiAZ");

var $aQwf0 = parcelRequire("aQwf0");

var $dvkro = parcelRequire("dvkro");
const $293e894cae72421f$var$FaviconService = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-stability-favicon-service'), ()=>{
    (0, $drMaP.useFaviconService)();
    return null;
});
const $293e894cae72421f$export$6d4069f4b64f7492 = ({ locale: locale, messages: messages, isPrewarming: isPrewarming = false, Router: Router, routes: routes, routerLinkComponent: routerLinkComponent, initRoute: initRoute })=>{
    const pageContainerPerformanceTiming = (0, $eJOHy.useCallback)(()=>{
        (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)((0, $60d311439a302207$export$21473105c510aacc), (0, $60d311439a302207$export$59f83d43fe209319), (0, $60d311439a302207$export$7114284ca03133ee), true, true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ieHpw.PageContainer), {
        id: false ? 'jira.entry.ssr' : 'spa',
        locale: locale,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, (0, $7jTnu.fg)('jira_frontend_memory_monitor') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aQwf0.MemoryMonitor), null), (0, $7jTnu.fg)('blu-7193-new-jira-favicons') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($293e894cae72421f$var$FaviconService, null), (0, $7jTnu.fg)('jfp_magma_jira-readiness-event') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dvkro.ReadinessTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$7114284ca03133ee),
        onSet: pageContainerPerformanceTiming
    }), isPrewarming !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kUiAZ.Content), {
        initRoute: initRoute,
        routes: routes
    }));
};

});
parcelRegister("eK5AI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c5afae322a0f6fe$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6uWhG = parcelRequire("6uWhG");
const $7c5afae322a0f6fe$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
    const renderRef = (0, $eJOHy.useRef)(false);
    if (!renderRef.current) {
        renderRef.current = true;
        (0, $6uWhG.setMark)(metricKey);
        onSet && onSet();
    }
    return null;
};
var $7c5afae322a0f6fe$export$2e2bcd8739ae039 = $7c5afae322a0f6fe$var$PerformanceMark;

});

parcelRegister("drMaP", function(module, exports) {

$parcel$export(module.exports, "useFaviconService", () => $bb123c007f6169ba$export$c5544731c404c896);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $hWeHP = parcelRequire("hWeHP");

var $eNgPF = parcelRequire("eNgPF");

var $eWzpp = parcelRequire("eWzpp");

var $kfvK2 = parcelRequire("kfvK2");

var $f27gy = parcelRequire("f27gy");

var $ioe9k = parcelRequire("ioe9k");

var $19s6n = parcelRequire("19s6n");

var $kzQ4b = parcelRequire("kzQ4b");

var $giO3L = parcelRequire("giO3L");
const $bb123c007f6169ba$export$f948ae143e35cfaf = 'ajs-fspage-favicon-prefixed';
const $bb123c007f6169ba$export$c9e8acb6bea47122 = 'ajs-fspage-favicon';
const $bb123c007f6169ba$export$7ef9895286e10387 = 'ajs-favicon-use-projecticon';
const $bb123c007f6169ba$var$useRouteGroup = (0, $kfvK2.createRouterSelector)((state)=>state.route.group);
const $bb123c007f6169ba$var$getCustomFavicon = ()=>{
    // Some instances might not have the prefixed metadata key, so we fallback to the original key
    const faviconPath = (0, $7jTnu.fg)('hot-117083-blu-7193-custom-favicon-fix') ? (0, $hWeHP.default)($bb123c007f6169ba$export$f948ae143e35cfaf) || (0, $hWeHP.default)($bb123c007f6169ba$export$c9e8acb6bea47122) : (0, $hWeHP.default)($bb123c007f6169ba$export$f948ae143e35cfaf);
    // Check if favicon is default or custom by matching the image path with pattern "favicon.*.ico"
    if (faviconPath) {
        const imagePath = faviconPath.split('/').at(-1);
        const defaultFaviconPattern = /^favicon.*\.ico$/;
        if (imagePath && !defaultFaviconPattern.test(imagePath)) return faviconPath;
    }
    return null;
};
const $bb123c007f6169ba$export$c5544731c404c896 = false ? ()=>undefined : ()=>{
    const routeGroup = $bb123c007f6169ba$var$useRouteGroup();
    const { data: project } = (0, $eWzpp.useProject)();
    const isProjectFaviconEnabled = (0, $hWeHP.default)($bb123c007f6169ba$export$7ef9895286e10387) === 'true';
    const productName = (0, $eNgPF.useProductName)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const iconEle = document.querySelector("link[rel='shortcut icon']");
    // Keep a copy of the default favicon
    const defaultFavicon = (0, $eJOHy.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
        iconEle
    ]);
    const customFavicon = $bb123c007f6169ba$var$getCustomFavicon();
    (0, $eJOHy.useEffect)(()=>{
        let faviconPath = defaultFavicon;
        if (routeGroup === 'assets' && (0, $7jTnu.fg)('assets_as_an_app_v2')) {
            // Assets is currently a specific set of routes, and doesn't exist as a separate "product" as per `productName`.
            // Assets is moving towards being a platform outside of Jira (rendering its own Bifrost app etc), so it doesn't
            // make sense to register it as a Jira sub-product.
            if (customFavicon && (0, $7jTnu.fg)('assets_nav_customisation_fix')) faviconPath = customFavicon;
            else faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($f27gy)));
        } else if (isProjectFaviconEnabled && project) faviconPath = project.avatarUrl;
        else if (customFavicon) faviconPath = customFavicon;
        else if (productName === 'serviceDesk') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($kzQ4b)));
        else if (productName === 'product-discovery') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($19s6n)));
        else if (productName === 'customer-service') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($giO3L)));
        else if (productName === 'jira' || productName === 'core' || productName === 'software') faviconPath = (0, (/*@__PURE__*/$parcel$interopDefault($ioe9k)));
        if (iconEle instanceof HTMLLinkElement && (0, $7jTnu.fg)('blu-7193-new-jira-favicons')) iconEle.href = faviconPath;
        // Cleanup: Restore default favicon when component unmounts
        return ()=>{
            if (iconEle instanceof HTMLLinkElement && (0, $7jTnu.fg)('blu-7193-new-jira-favicons')) iconEle.href = defaultFavicon;
        };
    }, [
        routeGroup,
        productName,
        defaultFavicon,
        iconEle,
        customFavicon,
        isProjectFaviconEnabled,
        project
    ]);
};

});
parcelRegister("f27gy", function(module, exports) {
module.exports = new URL("favicon-temp-assets.25c6fb39.png", import.meta.url).toString();

});

parcelRegister("ioe9k", function(module, exports) {
module.exports = new URL("favicon-temp-family.656d6159.png", import.meta.url).toString();

});

parcelRegister("19s6n", function(module, exports) {
module.exports = new URL("favicon-temp-jpd.0a166bf7.png", import.meta.url).toString();

});

parcelRegister("kzQ4b", function(module, exports) {
module.exports = new URL("favicon-temp-jsm.45cc4563.png", import.meta.url).toString();

});

parcelRegister("giO3L", function(module, exports) {
module.exports = new URL("favicon-temp-csm.54dd99fd.png", import.meta.url).toString();

});


parcelRegister("ieHpw", function(module, exports) {

$parcel$export(module.exports, "PageContainer", () => $054f27dea2055bd3$export$5f86df0ee0a255b5);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8aMsX = parcelRequire("8aMsX");

var $dhRXV = parcelRequire("dhRXV");

var $16sa1 = parcelRequire("16sa1");

var $eK5AI = parcelRequire("eK5AI");

var $1KdDN = parcelRequire("1KdDN");

var $f2JN3 = parcelRequire("f2JN3");

var $i0Aal = parcelRequire("i0Aal");

var $5bzWA = parcelRequire("5bzWA");

var $1DCdi = parcelRequire("1DCdi");

var $fvzyF = parcelRequire("fvzyF");

var $6nQNr = parcelRequire("6nQNr");

var $6zXPf = parcelRequire("6zXPf");

var $5NguO = parcelRequire("5NguO");

var $EzBXZ = parcelRequire("EzBXZ");

var $dzLcO = parcelRequire("dzLcO");


var $jIGRF = parcelRequire("jIGRF");

var $bv6dN = parcelRequire("bv6dN");

var $3pkO9 = parcelRequire("3pkO9");

var $d56U1 = parcelRequire("d56U1");

var $4xbv3 = parcelRequire("4xbv3");

var $2PrU6 = parcelRequire("2PrU6");

var $djhHt = parcelRequire("djhHt");

var $dydef = parcelRequire("dydef");

var $7jTnu = parcelRequire("7jTnu");

var $bJscI = parcelRequire("bJscI");

var $kfvK2 = parcelRequire("kfvK2");

var $gp9Js = parcelRequire("gp9Js");

var $k2tOc = parcelRequire("k2tOc");

var $8hKqe = parcelRequire("8hKqe");

var $jjTNC = parcelRequire("jjTNC");

var $1302Y = parcelRequire("1302Y");

var $3ipHb = parcelRequire("3ipHb");

var $eAwT1 = parcelRequire("eAwT1");

var $ltfhl = parcelRequire("ltfhl");

var $DrDtQ = parcelRequire("DrDtQ");

var $gSyZa = parcelRequire("gSyZa");

var $m9A8V = parcelRequire("m9A8V");

var $eTZyL = parcelRequire("eTZyL");

var $dtNAy = parcelRequire("dtNAy");

var $Gbl9s = parcelRequire("Gbl9s");

var $3sFnL = parcelRequire("3sFnL");

var $hOLtL = parcelRequire("hOLtL");

var $d9aSP = parcelRequire("d9aSP");
const $054f27dea2055bd3$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "page-container-v2-main-wrapper"
    }, children), (0, $eJOHy.Fragment));
const $054f27dea2055bd3$var$mainWrapperStyles = {
    root: "_4t3i1osq _1e0c1txw _2lx21bp4 _9beo1bgi",
    themedOld: "_11q7mmei _11q31r52",
    themed: "_11q7mmei _11q3ne5i"
};
/**
 * These test IDs are used in pollinator tests. Do not change lightly.
 */ const $054f27dea2055bd3$var$ROOT_TEST_ID = 'page-layout.root';
const $054f27dea2055bd3$var$MAIN_TEST_ID = 'page-layout.main';
/* IMPORTANT:
 * When making any changes to the Nav3 component, please ensure that you also make the same changes to the
 * Nav4 component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $054f27dea2055bd3$var$DefaultLayoutNav4 = ({ children: children })=>{
    const [isChromeless] = (0, $i0Aal.useIsChromeless)();
    const [isFullscreen] = (0, $5bzWA.useIsFullscreen)();
    const showBanner = !isChromeless && !isFullscreen;
    const showTopNav = !isChromeless && !isFullscreen;
    const showSidebar = !isChromeless && !isFullscreen;
    const showHorizontalNav = !isChromeless;
    const showRightSidebar = !isChromeless && !isFullscreen;
    const showLayoutRemoteStateUpdater = !isChromeless && !isFullscreen;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.PageLayout), {
        skipLinksLabel: "",
        testId: $054f27dea2055bd3$var$ROOT_TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $EzBXZ.RenderOnClient), {
        fg: "jfp_magma_jira-render-on-client-batch-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjTNC.IntegrationsWhichRequireNavigationRoot), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5NguO.Nav4BenefitsModalTrigger), null)), showBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "banner",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eAwT1.Banner), null)), showTopNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "top-nav",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dtNAy.TopNav), null)), showSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eTZyL.Sidebar), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($054f27dea2055bd3$var$MainWrapper, null, showHorizontalNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gSyZa.HorizontalNav), null), children), showRightSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $m9A8V.RightSidebar), null)), (0, $7jTnu.fg)('jira-glance-panel') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "preview-panel",
        packageName: "jiraPageContainerV2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3ipHb.PreviewPanel), null)), showLayoutRemoteStateUpdater && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraPageContainerV2",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1DCdi.LayoutRemoteStateUpdater), null)));
};
function $054f27dea2055bd3$var$MainWrapper(props) {
    const { hasTheming: hasTheming } = (0, $2PrU6.useProjectTheme)();
    const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, $jIGRF.useBannerJsmPackagingUpdates)();
    const { isEnabled: isJsmGracePeriodBannerEnabled } = (0, $bv6dN.useJsmGracePeriodBanner)();
    const currentRoute = $054f27dea2055bd3$var$useRouterRoute();
    const isIssueOrSystemAdminPage = (0, $gp9Js.isSystemNavPath)(currentRoute.path) || (0, $k2tOc.isIssuesNavPath)(currentRoute.path);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.Main), {
        isFixed: true,
        testId: $054f27dea2055bd3$var$MAIN_TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($054f27dea2055bd3$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-vc": "page-container-v2-main-wrapper",
        className: (0, $hcewu.default)([
            $054f27dea2055bd3$var$mainWrapperStyles.root,
            hasTheming && !(0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)() && $054f27dea2055bd3$var$mainWrapperStyles.themedOld,
            hasTheming && (0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)() && $054f27dea2055bd3$var$mainWrapperStyles.themed
        ])
    }, isJsmGracePeriodBannerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3pkO9.JSMGracePeriodBannerAsync), null), isJsmPackagingUpdatesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d56U1.BannerJsmPackagingUpdateAsync), null), isIssueOrSystemAdminPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8hKqe.JiraTopBannerPlacement), null), props.children)));
}
const $054f27dea2055bd3$var$DefaultLayoutNav3 = ({ children: children })=>{
    const HorizontalNavComponent = (0, $6nQNr.useHorizontalNavComponent)();
    const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, $jIGRF.useBannerJsmPackagingUpdates)();
    const { isEnabled: isJsmGracePeriodBannerEnabled } = (0, $bv6dN.useJsmGracePeriodBanner)();
    const currentRoute = $054f27dea2055bd3$var$useRouterRoute();
    const isIssueOrSystemAdminPage = (0, $gp9Js.isSystemNavPath)(currentRoute.path) || (0, $k2tOc.isIssuesNavPath)(currentRoute.path);
    let contentChildren = isJsmPackagingUpdatesEnabled || isIssueOrSystemAdminPage || isJsmGracePeriodBannerEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), null, isJsmGracePeriodBannerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3pkO9.JSMGracePeriodBannerAsync), null), isJsmPackagingUpdatesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d56U1.BannerJsmPackagingUpdateAsync), null), isIssueOrSystemAdminPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8hKqe.JiraTopBannerPlacement), null), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    if (HorizontalNavComponent != null) contentChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gSyZa.HorizontalNavWrapper), {
        navComponent: HorizontalNavComponent
    }, isJsmGracePeriodBannerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3pkO9.JSMGracePeriodBannerAsync), null), isJsmPackagingUpdatesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d56U1.BannerJsmPackagingUpdateAsync), null), isIssueOrSystemAdminPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8hKqe.JiraTopBannerPlacement), null), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Gbl9s.FullHeight), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.PageLayout), {
        skipLinksLabel: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $EzBXZ.RenderOnClient), {
        fg: "jfp_magma_jira-render-on-client-batch-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjTNC.IntegrationsWhichRequireNavigationRoot), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5NguO.Nav4BenefitsModalTrigger), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "banner",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eAwT1.Banner), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "top-nav",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dtNAy.TopNav), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.LeftPanel), {
        width: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.Content), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "sidebar",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eTZyL.Sidebar), null)), contentChildren, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $m9A8V.RightSidebar), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "page-container",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1DCdi.LayoutRemoteStateUpdater), null))));
};
const $054f27dea2055bd3$var$useRouterRoute = (0, $kfvK2.createRouterSelector)((state)=>state.route);
const $054f27dea2055bd3$var$LayoutNav4 = (props)=>{
    const { LayoutOverrideComponent: LayoutOverrideComponent } = $054f27dea2055bd3$var$useRouterRoute();
    if (LayoutOverrideComponent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(LayoutOverrideComponent, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($054f27dea2055bd3$var$DefaultLayoutNav4, props);
};
const $054f27dea2055bd3$var$LayoutNav3 = (props)=>{
    const { LayoutOverrideComponent: LayoutOverrideComponent } = $054f27dea2055bd3$var$useRouterRoute();
    if (LayoutOverrideComponent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(LayoutOverrideComponent, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($054f27dea2055bd3$var$DefaultLayoutNav3, props);
};
const $054f27dea2055bd3$var$PageContainerNav4 = (props)=>{
    const { id: id, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent } = props;
    const pageContainerPerformanceTiming = (0, $eJOHy.useCallback)(()=>{
        (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)((0, $60d311439a302207$export$898b6208220685b0), (0, $60d311439a302207$export$e2bc63118050de32), (0, $60d311439a302207$export$59f83d43fe209319), true, false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$e2bc63118050de32)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $DrDtQ.GlobalContainers), {
        id: id,
        locale: locale,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3sFnL.GlobalThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hOLtL.ProjectThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($054f27dea2055bd3$var$LayoutNav4, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ltfhl.GlobalComponents), {
        sharedGlobalComponents: (0, $djhHt.sharedLayout).globalComponents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fvzyF.GlobalBottomRightCornerContainer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9aSP.PageContainerSuccessTracker), null), (0, $7jTnu.fg)('jfp-magma-3742-report-hydration-stats') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8aMsX.HydrationStatsReporter), null))));
};
/**
 * Serves as a comprehensive layout manager, orchestrating the assembly of global containers,
 * navigation components, and performance metrics into a cohesive page structure. It enhances user
 * interface by conditionally incorporating additional UI elements and ensures a uniform
 * appearance and behavior across pages through global styling. Moreover, it facilitates
 * performance optimization and analytics integration for improved user experience and
 * insights.
 */ const $054f27dea2055bd3$var$PageContainerNav3 = (props)=>{
    const { id: id, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent } = props;
    const pageContainerPerformanceTiming = (0, $eJOHy.useCallback)(()=>{
        (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)((0, $60d311439a302207$export$898b6208220685b0), (0, $60d311439a302207$export$e2bc63118050de32), (0, $60d311439a302207$export$59f83d43fe209319), true, false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$e2bc63118050de32)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $DrDtQ.GlobalContainers), {
        id: id,
        locale: locale,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3sFnL.GlobalThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hOLtL.ProjectThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($054f27dea2055bd3$var$LayoutNav3, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ltfhl.GlobalComponents), {
        sharedGlobalComponents: (0, $djhHt.sharedLayout).globalComponents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fvzyF.GlobalBottomRightCornerContainer), null), (0, $7jTnu.fg)('jfp-magma-3742-report-hydration-stats') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8aMsX.HydrationStatsReporter), null))));
};
const $054f27dea2055bd3$export$5f86df0ee0a255b5 = (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), $054f27dea2055bd3$var$PageContainerNav4, $054f27dea2055bd3$var$PageContainerNav3);

});
parcelRegister("8aMsX", function(module, exports) {

$parcel$export(module.exports, "HydrationStatsReporter", () => $1008a912b4257ecd$export$9fda4732f2f0c3db);
$parcel$export(module.exports, "getReactHydrationStats", () => $1008a912b4257ecd$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "enableHydrationStatReporting", () => $1008a912b4257ecd$export$6e74f32ea46916a6);
$parcel$export(module.exports, "addErrorForHydrationStats", () => $1008a912b4257ecd$export$14e23415a0e3da58);

var $eJOHy = parcelRequire("eJOHy");

var $kfvK2 = parcelRequire("kfvK2");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $eSnSE = parcelRequire("eSnSE");

var $6XSXq = parcelRequire("6XSXq");
const $1008a912b4257ecd$var$HYDRATION_STATS = {
    enabled: false,
    hasFatalError: false,
    warningCount: 0,
    minErrorComponentDepth: null,
    maxErrorComponentDepth: null
};
const $1008a912b4257ecd$var$useRouteName = (0, $kfvK2.createRouterSelector)((state)=>state.route.name);
// Wait until React hydration is done. This is a bit crude, but we chain together a few idle callbacks with some space
// in case React pauses work for a bit, in which case we would incorrectly capture metrics before hydration is complete.
const $1008a912b4257ecd$var$delayUntilHydrationCompleted = (callback)=>{
    (0, $6XSXq.callWhenIdle)(()=>{
        setTimeout(()=>{
            (0, $6XSXq.callWhenIdle)(()=>{
                setTimeout(()=>{
                    (0, $6XSXq.callWhenIdle)(callback);
                }, 2500);
            });
        }, 2500);
    });
};
const $1008a912b4257ecd$export$9fda4732f2f0c3db = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const initialRouteName = $1008a912b4257ecd$var$useRouteName();
    // Using state here because we want to capture the route name on initial render, and not have it change when the effect runs
    const [routeName] = (0, $eJOHy.useState)(initialRouteName);
    const captured = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!$1008a912b4257ecd$var$HYDRATION_STATS.enabled || captured.current) return;
        captured.current = true;
        let cancelled = false;
        $1008a912b4257ecd$var$delayUntilHydrationCompleted(()=>{
            if (cancelled) return;
            const { hasFatalError: hasFatalError, warningCount: warningCount, minErrorComponentDepth: minErrorComponentDepth, maxErrorComponentDepth: maxErrorComponentDepth } = $1008a912b4257ecd$var$HYDRATION_STATS;
            const successful = !hasFatalError;
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), successful ? 'reactHydrate success' : 'reactHydrate failure', {
                warningCount: $1008a912b4257ecd$export$3bf82299f486a7ff(warningCount),
                routeName: routeName
            });
            (0, $eSnSE.default).safeInfoWithoutCustomerData('react-hydration-reporting', successful ? 'Hydration success' : 'Hydration failure', {
                warningCount: warningCount,
                routeName: routeName,
                minErrorComponentDepth: minErrorComponentDepth,
                maxErrorComponentDepth: maxErrorComponentDepth
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        createAnalyticsEvent,
        routeName
    ]);
    return null;
};
const $1008a912b4257ecd$export$2d8f8d64dc343d7b = ()=>{
    if (!$1008a912b4257ecd$var$HYDRATION_STATS.enabled) return undefined;
    return {
        successful: !$1008a912b4257ecd$var$HYDRATION_STATS.hasFatalError,
        warningCount: $1008a912b4257ecd$var$HYDRATION_STATS.warningCount,
        minWarningComponentDepth: $1008a912b4257ecd$var$HYDRATION_STATS.minErrorComponentDepth ?? undefined,
        maxWarningComponentDepth: $1008a912b4257ecd$var$HYDRATION_STATS.maxErrorComponentDepth ?? undefined
    };
};
const $1008a912b4257ecd$export$3bf82299f486a7ff = (warningCount)=>{
    if (warningCount <= 9) return warningCount.toString();
    return '10+';
};
const $1008a912b4257ecd$export$6e74f32ea46916a6 = ()=>{
    $1008a912b4257ecd$var$HYDRATION_STATS.enabled = true;
};
const $1008a912b4257ecd$export$14e23415a0e3da58 = (error, errorInfo)=>{
    switch($1008a912b4257ecd$export$e577dd64062c400a(error)){
        case $1008a912b4257ecd$var$HYDRATION_FATAL_ERROR:
            $1008a912b4257ecd$var$HYDRATION_STATS.hasFatalError = true;
            $1008a912b4257ecd$var$recordComponentDepthStats(errorInfo);
            break;
        case $1008a912b4257ecd$var$HYDRATION_WARNING:
            $1008a912b4257ecd$var$HYDRATION_STATS.warningCount++;
            $1008a912b4257ecd$var$recordComponentDepthStats(errorInfo);
            break;
        default:
            break;
    }
};
const $1008a912b4257ecd$var$HYDRATION_FATAL_ERROR = 'fatal';
const $1008a912b4257ecd$var$HYDRATION_WARNING = 'warning';
const $1008a912b4257ecd$export$e577dd64062c400a = ({ message: message })=>{
    var fatal, warning;
    if ($1008a912b4257ecd$var$PROD_FATAL_MESSAGES.some((fatal)=>message.includes(fatal))) return $1008a912b4257ecd$var$HYDRATION_FATAL_ERROR;
    if ($1008a912b4257ecd$var$PROD_WARNING_MESSAGES.some((warning)=>message.includes(warning))) return $1008a912b4257ecd$var$HYDRATION_WARNING;
    return null;
};
const $1008a912b4257ecd$var$PROD_FATAL_MESSAGES = [
    407,
    419,
    421,
    422,
    423,
    424
].map((code)=>`Minified React error #${code}`);
const $1008a912b4257ecd$var$PROD_WARNING_MESSAGES = [
    418,
    425
].map((code)=>`Minified React error #${code}`);
const $1008a912b4257ecd$var$DEV_FATAL_MESSAGES = [
    'to client rendering'
];
const $1008a912b4257ecd$var$DEV_WARNING_MESSAGES = [
    'Hydration failed because the initial UI does not match what was rendered on the server',
    'Text content does not match server-rendered HTML'
];
const $1008a912b4257ecd$var$recordComponentDepthStats = ({ componentStack: componentStack })=>{
    if (!componentStack) return;
    // Number of components = number of lines after the error message
    const componentStackDepth = componentStack.match(/\n/g)?.length ?? 1;
    $1008a912b4257ecd$var$HYDRATION_STATS.minErrorComponentDepth = Math.min(componentStackDepth, $1008a912b4257ecd$var$HYDRATION_STATS.minErrorComponentDepth ?? Number.MAX_SAFE_INTEGER);
    $1008a912b4257ecd$var$HYDRATION_STATS.maxErrorComponentDepth = Math.max(componentStackDepth, $1008a912b4257ecd$var$HYDRATION_STATS.maxErrorComponentDepth ?? 0);
};

});
parcelRegister("6XSXq", function(module, exports) {

$parcel$export(module.exports, "callWhenIdle", () => $8638770e300a4099$export$d2542992df1e054);
const $8638770e300a4099$export$d2542992df1e054 = (callback, timeout = 200)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof window.requestIdleCallback === 'function') {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const callbackId = window.requestIdleCallback(callback);
        return ()=>cancelIdleCallback(callbackId);
    }
    const timer = setTimeout(callback, timeout);
    return ()=>{
        clearTimeout(timer);
    };
};

});


parcelRegister("i0Aal", function(module, exports) {

$parcel$export(module.exports, "useIsChromeless", () => $5b596af44974a488$export$c88b74884f5222ba);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $fZsy4 = parcelRequire("fZsy4");
const $5b596af44974a488$export$c88b74884f5222ba = (0, $iJq0l.createHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>state.isChromeless
});

});

parcelRegister("5bzWA", function(module, exports) {

$parcel$export(module.exports, "useIsFullscreen", () => $c5e933a3117521b9$export$d397eccea5f37b0a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $fZsy4 = parcelRequire("fZsy4");
const $c5e933a3117521b9$export$d397eccea5f37b0a = (0, $iJq0l.createHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>state.isFullscreen
});

});

parcelRegister("1DCdi", function(module, exports) {

$parcel$export(module.exports, "LayoutRemoteStateUpdater", () => $b1ab69780e7853e9$export$b9f3a70460995c32);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

var $f2JN3 = parcelRequire("f2JN3");

var $6zXPf = parcelRequire("6zXPf");

var $dzLcO = parcelRequire("dzLcO");


var $dfh4P = parcelRequire("dfh4P");

var $8q7lT = parcelRequire("8q7lT");

var $eJrcF = parcelRequire("eJrcF");

var $7jTnu = parcelRequire("7jTnu");

var $fZsy4 = parcelRequire("fZsy4");

var $cUxaS = parcelRequire("cUxaS");

var $dfP3D = parcelRequire("dfP3D");

var $85mYL = parcelRequire("85mYL");

var $g3dwt = parcelRequire("g3dwt");
const $b1ab69780e7853e9$var$LayoutRemoteStateUpdaterOld = ()=>{
    // This prevents eccessive state updates on page loads
    const [initialLoad, setInitialLoad] = (0, $eJOHy.useState)(true);
    const [localLeftSidebarWidthState, setLocalLeftSidebarWidthState] = (0, $eJOHy.useState)();
    const [localLeftSidebarCollapsedState, setLocalLeftSidebarCollapsedState] = (0, $eJOHy.useState)();
    const [localRightSidebarState, setLocalRightSidebarState] = (0, $eJOHy.useState)();
    const [localPreviewPanelState, setLocalPreviewPanelState] = (0, $eJOHy.useState)();
    // left-sidebar
    const { leftSidebarState: leftSidebarState } = (0, $dzLcO.usePageLayoutResize)();
    const { isFlyoutOpen: isFlyoutOpen, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
    const resolvedLeftSidebarWidth = Math.max(leftSidebarWidth, (0, $fZsy4.DEFAULT_LEFT_SIDEBAR_WIDTH));
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $fZsy4.useLayoutStoreActions)();
    const isCollapsed = leftSidebarState.isLeftSidebarCollapsed;
    // right-sidebar
    const rightSidebarState = (0, $dfP3D.useRightSidebarState)();
    const accountId = (0, $8q7lT.useAccountId)();
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)((0, $dfh4P.navigationUiStateResource));
    const isLayoutStateReady = leftSidebarWidth !== 0 && leftSidebarState.lastLeftSidebarWidth !== 0;
    // preview panel
    const previewPanelState = (0, $85mYL.usePreviewPanelState)();
    // compares local vs external state coming via chain of callbacks
    // to determine if we really need to send an update of layout state
    const sideBarChanged = (0, $eJOHy.useCallback)((externalLeftSidebarWidth, externalIsLeftSidebarCollapsed, externalRightSidebarState, externalPreviewPanelState)=>{
        let changeDetected = false;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalLeftSidebarWidth, localLeftSidebarWidthState)) {
            setLocalLeftSidebarWidthState(externalLeftSidebarWidth);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalIsLeftSidebarCollapsed, localLeftSidebarCollapsedState)) {
            setLocalLeftSidebarCollapsedState(externalIsLeftSidebarCollapsed);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalRightSidebarState, localRightSidebarState)) {
            setLocalRightSidebarState(externalRightSidebarState);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalPreviewPanelState, localPreviewPanelState)) {
            setLocalPreviewPanelState(externalPreviewPanelState);
            changeDetected = true;
        }
        return changeDetected;
    }, [
        localLeftSidebarCollapsedState,
        localLeftSidebarWidthState,
        localRightSidebarState,
        localPreviewPanelState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isLayoutStateReady) return;
        if (error) return;
        setLeftSidebarState({
            width: resolvedLeftSidebarWidth,
            isCollapsed: isCollapsed,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            isFlyoutOpen: isFlyoutOpen,
            isVisible: true
        });
    }, [
        error,
        isCollapsed,
        isFlyoutOpen,
        isLayoutStateReady,
        resolvedLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const updateData = (0, $eJOHy.useCallback)(async ()=>{
        if (loading) return;
        if (error) return;
        if (!isLayoutStateReady) return;
        if (!sideBarChanged(resolvedLeftSidebarWidth, isLeftSidebarCollapsed, rightSidebarState, previewPanelState)) return;
        const remoteData = {
            ...data,
            leftSidebar: {
                width: resolvedLeftSidebarWidth,
                isCollapsed: isLeftSidebarCollapsed
            },
            rightSidebar: rightSidebarState,
            ...(0, $7jTnu.fg)('jira-glance-panel') && {
                previewPanel: previewPanelState
            }
        };
        if (accountId) try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8), JSON.stringify(remoteData));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gYnSx.default)({
                error: e,
                meta: {
                    id: 'updateServerLayoutState',
                    packageName: 'jiraLayoutController',
                    teamName: 'magma'
                }
            });
        }
    }, [
        accountId,
        data,
        error,
        isLayoutStateReady,
        isLeftSidebarCollapsed,
        loading,
        resolvedLeftSidebarWidth,
        rightSidebarState,
        previewPanelState,
        sideBarChanged
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (initialLoad) {
            setInitialLoad(false);
            setLocalLeftSidebarWidthState(resolvedLeftSidebarWidth);
            setLocalLeftSidebarCollapsedState(isLeftSidebarCollapsed);
            setLocalRightSidebarState(rightSidebarState);
        } else updateData();
    }, [
        isLeftSidebarCollapsed,
        resolvedLeftSidebarWidth,
        updateData,
        rightSidebarState,
        initialLoad
    ]);
    return null;
};
const $b1ab69780e7853e9$var$LayoutRemoteStateUpdaterNew = ()=>{
    const accountId = (0, $8q7lT.useAccountId)();
    const leftSidebar = (0, $cUxaS.useLeftSidebarState)();
    const rightSidebar = (0, $dfP3D.useRightSidebarState)();
    const previewPanel = (0, $85mYL.usePreviewPanelState)();
    const isLeftSidebarCollapsed = leftSidebar.isCollapsed;
    const leftSidebarWidth = leftSidebar.width;
    // This prevents eccessive state updates on page loads
    const [initialLoad, setInitialLoad] = (0, $eJOHy.useState)(true);
    const [localLeftSidebarWidthState, setLocalLeftSidebarWidthState] = (0, $eJOHy.useState)();
    const [localLeftSidebarCollapsedState, setLocalLeftSidebarCollapsedState] = (0, $eJOHy.useState)();
    const [localRightSidebarState, setLocalRightSidebarState] = (0, $eJOHy.useState)();
    const [localPreviewPanelState, setLocalPreviewPanelState] = (0, $eJOHy.useState)();
    // compares local vs external state coming via chain of callbacks
    // to determine if we really need to send an update of layout state
    const sideBarChanged = (0, $eJOHy.useCallback)((externalLeftSidebarWidth, externalIsLeftSidebarCollapsed, externalRightSidebarState, externalPreviewPanelState)=>{
        let changeDetected = false;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalLeftSidebarWidth, localLeftSidebarWidthState)) {
            setLocalLeftSidebarWidthState(externalLeftSidebarWidth);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalIsLeftSidebarCollapsed, localLeftSidebarCollapsedState)) {
            setLocalLeftSidebarCollapsedState(externalIsLeftSidebarCollapsed);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalRightSidebarState, localRightSidebarState)) {
            setLocalRightSidebarState(externalRightSidebarState);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(externalPreviewPanelState, localPreviewPanelState)) {
            setLocalPreviewPanelState(externalPreviewPanelState);
            changeDetected = true;
        }
        return changeDetected;
    }, [
        localLeftSidebarCollapsedState,
        localLeftSidebarWidthState,
        localRightSidebarState,
        localPreviewPanelState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!accountId) return;
        if (initialLoad) {
            setInitialLoad(false);
            setLocalLeftSidebarWidthState(leftSidebarWidth);
            setLocalLeftSidebarCollapsedState(isLeftSidebarCollapsed);
            setLocalRightSidebarState(rightSidebar);
            setLocalPreviewPanelState(previewPanel);
            return;
        }
        if (!sideBarChanged(leftSidebarWidth, isLeftSidebarCollapsed, rightSidebar, previewPanel)) return;
        (0, $g3dwt.setRemoteLayoutState)({
            accountId: accountId,
            state: {
                rightSidebar: rightSidebar,
                leftSidebar: {
                    isCollapsed: isLeftSidebarCollapsed,
                    width: leftSidebarWidth
                },
                ...(0, $7jTnu.fg)('jira-glance-panel') && {
                    previewPanel: previewPanel
                }
            }
        });
    }, [
        accountId,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        rightSidebar,
        initialLoad,
        previewPanel,
        sideBarChanged
    ]);
    return null;
};
const $b1ab69780e7853e9$export$b9f3a70460995c32 = (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), $b1ab69780e7853e9$var$LayoutRemoteStateUpdaterNew, $b1ab69780e7853e9$var$LayoutRemoteStateUpdaterOld);

});
parcelRegister("dzLcO", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $599f2c8065b963c5$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $599f2c8065b963c5$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $599f2c8065b963c5$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $599f2c8065b963c5$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebar", () => $599f2c8065b963c5$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $599f2c8065b963c5$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $599f2c8065b963c5$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $599f2c8065b963c5$export$84d58c19c21f637f);
$parcel$export(module.exports, "RightPanel", () => $599f2c8065b963c5$export$364a989a35814102);
$parcel$export(module.exports, "useCustomSkipLink", () => $599f2c8065b963c5$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $599f2c8065b963c5$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $599f2c8065b963c5$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $599f2c8065b963c5$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $599f2c8065b963c5$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $599f2c8065b963c5$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $599f2c8065b963c5$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $599f2c8065b963c5$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $599f2c8065b963c5$export$d697087c06fd5e25);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $iLCep = parcelRequire("iLCep");
var $lmxjs = parcelRequire("lmxjs");
var $4DcbV = parcelRequire("4DcbV");
var $2UIsd = parcelRequire("2UIsd");
var $eJFXe = parcelRequire("eJFXe");
var $3wlub = parcelRequire("3wlub");
var $1q4rm = parcelRequire("1q4rm");
var $fz8sx = parcelRequire("fz8sx");
var $c20Px = parcelRequire("c20Px");
var $liAXQ = parcelRequire("liAXQ");
var $6Eilf = parcelRequire("6Eilf");
var $86K7A = parcelRequire("86K7A");

var $joH5p = parcelRequire("joH5p");
var $b71aK = parcelRequire("b71aK");
var $6CdwK = parcelRequire("6CdwK");
var $j5DfN = parcelRequire("j5DfN");
var $kmjf0 = parcelRequire("kmjf0");
var $2JS8w = parcelRequire("2JS8w");
var $2ON3f = parcelRequire("2ON3f");

var $6zXPf = parcelRequire("6zXPf");
function $599f2c8065b963c5$export$6d1402fb58384e4f(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kmjf0.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1q4rm.default), props);
}
function $599f2c8065b963c5$export$3b4e64e77073e307(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b71aK.Banner), {
        height: props.height,
        testId: props.testId,
        id: props.id
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iLCep.default), props);
}
function $599f2c8065b963c5$export$8a421bddecb2bf5b(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ON3f.TopNav), {
        height: props.height,
        testId: props.testId,
        UNSAFE_theme: props.theme
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $liAXQ.default), props);
}
function $599f2c8065b963c5$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $6zXPf.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4DcbV.default), props);
}
function $599f2c8065b963c5$export$43ae342508cf8cc9(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2JS8w.SideNav), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJFXe.default), props);
}
function $599f2c8065b963c5$export$3cabf771c4f2de(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2JS8w.SideNav), {
        defaultCollapsed: props.collapsedState === 'collapsed',
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2UIsd.default), props);
}
function $599f2c8065b963c5$export$861edd1ccea2f746(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6CdwK.Main), {
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3wlub.default), props);
}
function $599f2c8065b963c5$export$7c6e2c02157bb7d2(props) {
    return (0, $6zXPf.getWillShowNav4)() ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmxjs.default), props);
}
function $599f2c8065b963c5$export$84d58c19c21f637f(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $joH5p.Aside), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c20Px.default), props);
}
function $599f2c8065b963c5$export$364a989a35814102(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j5DfN.Panel), {
        xcss: $599f2c8065b963c5$var$rightPanelStyles.root,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fz8sx.default), props);
}
const $599f2c8065b963c5$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $6zXPf.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $6Eilf.useCustomSkipLink)(id, title, index);
const $599f2c8065b963c5$export$94561f6055639ef7 = ()=>(0, $6zXPf.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $86K7A.useLeftSidebarFlyoutLock)();
// A mock value is needed to match the signature of the hook
const $599f2c8065b963c5$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    },
    setLeftSidebarState: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $599f2c8065b963c5$export$10c7104037a7af62 = ()=>(0, $6zXPf.getWillShowNav4)() ? $599f2c8065b963c5$var$mockPageLayoutResize : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $86K7A.usePageLayoutResize)();
const $599f2c8065b963c5$var$rightPanelStyles = {
    root: "_bfhk1bhr"
};
const $599f2c8065b963c5$export$991ef8098f87814a = (0, $c6b3f4cb88c9ac2a$export$ed7cc0d417ee89e);
const $599f2c8065b963c5$export$7eaf986ecb4d5cac = (0, $c6b3f4cb88c9ac2a$export$f963aecf2d4465bd);
const $599f2c8065b963c5$export$e95b388ca8c92019 = (0, $c6b3f4cb88c9ac2a$export$f897e1ed9f8ed251);
const $599f2c8065b963c5$export$2ab8b83eed76656c = (0, $c6b3f4cb88c9ac2a$export$750459958906793);
const $599f2c8065b963c5$export$ac017575d43f5da = (0, $c6b3f4cb88c9ac2a$export$b44ab66843c05a69);
const $599f2c8065b963c5$export$d697087c06fd5e25 = (0, $c6b3f4cb88c9ac2a$export$aeff86a16f13529);

});

parcelRegister("cUxaS", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $2ce27f19e394981e$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $2ce27f19e394981e$export$900f29014a48fb23);

var $eJOHy = parcelRequire("eJOHy");

var $dzLcO = parcelRequire("dzLcO");

var $iJq0l = parcelRequire("iJq0l");

var $fZsy4 = parcelRequire("fZsy4");
const $2ce27f19e394981e$var$useSweetStateLeftSidebarState = (0, $iJq0l.createHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $2ce27f19e394981e$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $2ce27f19e394981e$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $2ce27f19e394981e$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $dzLcO.usePageLayoutResize)();
    return (0, $eJOHy.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});

parcelRegister("85mYL", function(module, exports) {

$parcel$export(module.exports, "usePreviewPanelState", () => $414cfbe9209d0c3f$export$69e98a9119b24908);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $fZsy4 = parcelRequire("fZsy4");
const $414cfbe9209d0c3f$export$69e98a9119b24908 = (0, $iJq0l.createStateHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>({
            ...state.content.previewPanel
        })
});

});

parcelRegister("g3dwt", function(module, exports) {

$parcel$export(module.exports, "setRemoteLayoutState", () => $ccc52bab2bfda316$export$ad53b565e6cd4261);

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

async function $ccc52bab2bfda316$export$ad53b565e6cd4261({ accountId: accountId, state: state }) {
    try {
        await (0, $FppkK.setUserProperties)(accountId, (0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8), JSON.stringify(state));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gYnSx.default)({
            error: e,
            meta: {
                id: 'updateServerLayoutState',
                packageName: 'jiraLayoutController',
                teamName: 'jfp-team'
            }
        });
    }
}

});


parcelRegister("fvzyF", function(module, exports) {

$parcel$export(module.exports, "GlobalBottomRightCornerContainer", () => $84994e06d9fdcaa4$export$715c8d5890c054bb);
$parcel$export(module.exports, "GlobalBottomRightCornerContainerProvider", () => $84994e06d9fdcaa4$export$1e86e3484191597c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $h47gY = parcelRequire("h47gY");

var $16sa1 = parcelRequire("16sa1");

var $k6EUZ = parcelRequire("k6EUZ");

var $7jTnu = parcelRequire("7jTnu");

var $fqYrC = parcelRequire("fqYrC");

var $dfP3D = parcelRequire("dfP3D");

var $fZsy4 = parcelRequire("fZsy4");
function $84994e06d9fdcaa4$export$e112b78171de7a6({ bottomOffset: bottomOffset, rightOffset: rightOffset }) {
    const [{ width: width }] = (0, $fZsy4.useDetailPanelWidth)();
    const rightSidebar = (0, $dfP3D.useActiveRightSidebarState)();
    const { registerBottomRightCornerContainer: registerBottomRightCornerContainer } = (0, $fqYrC.useBottomRightCornerActions)();
    const isSidebarOpen = rightSidebar && !rightSidebar.isCollapsed && !rightSidebar.isMinimised;
    const rightSidebarWidth = isSidebarOpen ? rightSidebar.width : 0;
    const rightSidebarOffset = isSidebarOpen ? rightSidebarWidth : 0;
    let distanceFromRightSidebar = width + rightOffset + rightSidebarOffset;
    /**
   * Preview panel also opens inside RightPanel and is resizable. And it has default width of 400px,
   * which is more than width of RightSidebar (386px)
   */ // Preview panel takes precedence over sidebar when open
    if ((0, $7jTnu.fg)('jira-glance-panel')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const panel = (0, $k6EUZ.useCurrentPreviewPanel)();
        if (panel) distanceFromRightSidebar = panel.width + rightOffset;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84994e06d9fdcaa4$var$StyledContainer, {
        ref: registerBottomRightCornerContainer,
        "data-testid": "layout-controller.ui.bottom-right-corner.container.styled-container",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            right: `calc(${distanceFromRightSidebar}px + ${"var(--ds-space-300, 24px)"})`,
            bottom: `calc(${"var(--ds-space-300, 24px)"} + ${bottomOffset}px)`
        }
    });
}
const $84994e06d9fdcaa4$export$715c8d5890c054bb = ({ bottomOffset: bottomOffset = 0, rightOffset: rightOffset = 0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "bottom-right-corner-container",
        packageName: "jira-bottom-right-corner-controller"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84994e06d9fdcaa4$export$e112b78171de7a6, {
        bottomOffset: bottomOffset,
        rightOffset: rightOffset
    }));
const $84994e06d9fdcaa4$export$1e86e3484191597c = ({ children: children })=>{
    const container = (0, $fqYrC.useBottomRightCornerContainer)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "global-bottom-right-corner"
    }, container && children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84994e06d9fdcaa4$export$715c8d5890c054bb, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84994e06d9fdcaa4$var$StyledContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reoewfl _18m9ewfl _kqsw1n9t _1e0c1txw _1pbyfjpv _4cvresu3 _lcxvglyw",
            __cmplp.className
        ])
    });
});
$84994e06d9fdcaa4$var$StyledContainer.displayName = 'StyledContainer';

});
parcelRegister("k6EUZ", function(module, exports) {

$parcel$export(module.exports, "useCurrentPreviewPanel", () => $549146e41225d7b0$export$5351114e92b31bc6);

var $fmVXt = parcelRequire("fmVXt");
const $549146e41225d7b0$export$5351114e92b31bc6 = ()=>{
    const context = (0, $fmVXt.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    return {
        ...context.state.panel,
        width: context.state.width,
        setWidth: context.setPanelWidth
    };
};

});
parcelRegister("fmVXt", function(module, exports) {

$parcel$export(module.exports, "PreviewPanelsProvider", () => $da21ee82f5c26c58$export$65ae37e9c61321f9);
$parcel$export(module.exports, "usePreviewPanelsContext", () => $da21ee82f5c26c58$export$609db4be92d0fad8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1hB0o = parcelRequire("1hB0o");
const $da21ee82f5c26c58$var$noop = (props)=>{};
const $da21ee82f5c26c58$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    width: 400,
    onOpen: $da21ee82f5c26c58$var$noop,
    onClose: $da21ee82f5c26c58$var$noop
};
const $da21ee82f5c26c58$export$f473d225913e225d = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $da21ee82f5c26c58$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'SET_PANEL_WIDTH':
            return {
                ...state,
                width: action.width
            };
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $da21ee82f5c26c58$var$noop,
                onClose: $da21ee82f5c26c58$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
				When opening a new preview panel, if the current panel is of the same type we don't
				want to close the panel, but rather swap out the content. If the panel types don't match
				we close the current panel and open the new one.
				ex: A Goals panel is already open, and user tries to open a different Goals panel.
				Parent Products must pass their preview panel close functions to the Preview Panel provider
				via the `onPreviewPanelClose` prop.
			*/ if (state.panel && !(0, $1hB0o.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                width: params.width ?? state.width,
                onOpen: params.onOpen || $da21ee82f5c26c58$var$initialState.onOpen,
                onClose: params.onClose || $da21ee82f5c26c58$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $da21ee82f5c26c58$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, children: children })=>{
    const [state, dispatch] = (0, $eJOHy.useReducer)($da21ee82f5c26c58$var$previewPanelsReducer, {
        ...$da21ee82f5c26c58$var$initialState,
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $eJOHy.useCallback)((width)=>dispatch?.({
            type: 'SET_PANEL_WIDTH',
            width: width
        }), [
        dispatch
    ]);
    const close = (0, $eJOHy.useCallback)((onClose)=>dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        }), [
        dispatch
    ]);
    const open = (0, $eJOHy.useCallback)((params)=>dispatch?.({
            type: 'OPEN',
            params: params
        }), [
        dispatch
    ]);
    const context = (0, $eJOHy.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            setPanelWidth: setPanelWidth
        }), [
        state,
        open,
        close,
        setPanelWidth
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($da21ee82f5c26c58$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
const $da21ee82f5c26c58$export$609db4be92d0fad8 = ()=>{
    const context = (0, $eJOHy.useContext)($da21ee82f5c26c58$export$f473d225913e225d);
    return context;
};

});
parcelRegister("1hB0o", function(module, exports) {

$parcel$export(module.exports, "doPreviewPanelTypesMatch", () => $c4a2794d8137972e$export$eb89e687f2b278d7);

var $gtr2v = parcelRequire("gtr2v");
const $c4a2794d8137972e$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $gtr2v.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $gtr2v.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};

});



parcelRegister("fqYrC", function(module, exports) {

$parcel$export(module.exports, "useBottomRightCornerContainer", () => $0e623b1898935128$export$84542488b6b6c309);
$parcel$export(module.exports, "useBottomRightCornerActions", () => $0e623b1898935128$export$de496fd0e0151c81);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $fZsy4 = parcelRequire("fZsy4");
const $0e623b1898935128$export$84542488b6b6c309 = (0, $iJq0l.createStateHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>state.bottomRightCorner.container
});
const $0e623b1898935128$export$de496fd0e0151c81 = (0, $iJq0l.createActionsHook)((0, $fZsy4.layoutStore));

});


parcelRegister("6nQNr", function(module, exports) {

$parcel$export(module.exports, "useHorizontalNavComponent", () => $fad07f088ee1c47d$export$205771a0e64e4c7c);

var $hS1gr = parcelRequire("hS1gr");

var $ln6Iy = parcelRequire("ln6Iy");

var $i0Aal = parcelRequire("i0Aal");

var $6zXPf = parcelRequire("6zXPf");

var $hih5V = parcelRequire("hih5V");

var $2aY2d = parcelRequire("2aY2d");

var $iZ2Qf = parcelRequire("iZ2Qf");

var $kfvK2 = parcelRequire("kfvK2");

const $fad07f088ee1c47d$export$965942f8308cd740 = (0, $kfvK2.createRouterSelector)((state)=>(0, $iZ2Qf.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(state.query.config));
const $fad07f088ee1c47d$export$205771a0e64e4c7c = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const { data: projectData } = (0, $2aY2d.useProjectContext)();
    const hasBoardSettingsPageQueryParam = $fad07f088ee1c47d$export$965942f8308cd740();
    // chromeless mode is handled in page-container package with nav4
    if (!(0, $6zXPf.getWillShowNav4)()) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isChromeless] = (0, $i0Aal.useIsChromeless)();
        if (isChromeless) return null;
    }
    if (route.navigation?.horizontal == null) return null;
    // Shared horizontal navigation routes that currently live in business projects on prod
    // but we want to remove horizontal navigation on with the navigation redesign
    if (route.navigation.horizontal === (0, $aa97a50ba70be130$export$712453ef44fd2eba)) {
        if ((0, $6zXPf.getWillShowNav4)()) return null;
        switch(projectData?.projectType){
            case 0, $ln6Iy.CORE_PROJECT:
                return 0, $hS1gr.AsyncHorizontalNavJira;
            default:
                return null;
        }
    }
    // Board settings pages should not show the horizontal nav.
    // This is a workaround due to the fact that the software CMP board/backlog pages share the same route name
    // as the board settings pages. This code should be removed once the board settings pages have
    // their own dedicated route names.
    if (route.group === 'classic-software' && hasBoardSettingsPageQueryParam && (0, $6zXPf.getWillShowNav4)()) return null;
    if (route.navigation.horizontal === (0, $aa97a50ba70be130$export$9ab1d1d726b36319)) switch(projectData?.projectType){
        case 0, $ln6Iy.CORE_PROJECT:
            return 0, $hS1gr.AsyncHorizontalNavJira;
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            if ((0, $6zXPf.getWillShowNav4)()) return 0, $hS1gr.AsyncHorizontalNavJira;
            return null;
        default:
            return null;
    }
    // TODO: Remove this during jira_nav4 cleanup
    if ('onlyShowHorizontalOnNav4' in route.navigation && route.navigation.onlyShowHorizontalOnNav4) return (0, $6zXPf.getWillShowNav4)() ? route.navigation.horizontal : null;
    return route.navigation.horizontal;
};

});
parcelRegister("iZ2Qf", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_METRICS_HISTOGRAM", () => $06745e3d238ee19b$export$128e24da52662cdd);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION", () => $06745e3d238ee19b$export$efdecbe4c9f1cd2c);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_SAC_URL_CONFIG_DISABLE_SECTION", () => $06745e3d238ee19b$export$1154ed64d0d99951);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION_ANALYTICS_ID", () => $06745e3d238ee19b$export$7cadd2a48a9ff918);
$parcel$export(module.exports, "DEFAULT_LEVEL_ONE_NAME", () => $06745e3d238ee19b$export$a546b6d48878ce6f);
$parcel$export(module.exports, "BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES", () => $06745e3d238ee19b$export$8cc83ae2b6885e0);
$parcel$export(module.exports, "boardSettingsQueryConfigParamValues", () => $06745e3d238ee19b$export$a9ebdab56bd9c0c3);
$parcel$export(module.exports, "SETTINGS_CONFIG", () => $06745e3d238ee19b$export$2a56ee2f9c41b5a7);
$parcel$export(module.exports, "EDIT_BOARD_CONFIG", () => $06745e3d238ee19b$export$b893894941c14e43);
$parcel$export(module.exports, "ADMINISTER_PARENT_PROJECT", () => $06745e3d238ee19b$export$d14d5a7c294329c5);
$parcel$export(module.exports, "USER_PICKER_PROJECT_PERMISSION_KEY", () => $06745e3d238ee19b$export$1e63b013f0e45de0);
$parcel$export(module.exports, "ADMINISTER_PROJECT_PERMISSION_KEY", () => $06745e3d238ee19b$export$68030ac1ea4abd4c);
$parcel$export(module.exports, "BACKLOG_FEATURE_KEY", () => $06745e3d238ee19b$export$e1671d3447ddd5ad);
$parcel$export(module.exports, "SPRINTS_FEATURE_KEY", () => $06745e3d238ee19b$export$46efc2c8d8106cff);
const $06745e3d238ee19b$export$128e24da52662cdd = '1000_1500_2000_2500_3000_4000';
const $06745e3d238ee19b$export$efdecbe4c9f1cd2c = '2QE2xWf0TpDbYpk4oY9aQr';
const $06745e3d238ee19b$export$1154ed64d0d99951 = 'https://support.atlassian.com/jira-software-cloud/docs/how-do-jira-permissions-work/';
const $06745e3d238ee19b$export$7cadd2a48a9ff918 = `${$06745e3d238ee19b$export$efdecbe4c9f1cd2c}.config-disabled-section.article.analytics`;
const $06745e3d238ee19b$export$a546b6d48878ce6f = 'Epic';
const $06745e3d238ee19b$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES = [
    'cardColors',
    'cardLayout',
    'columns',
    'default',
    'estimation',
    'filter',
    'swimlanes',
    'time',
    'timelineConfig',
    'quickFilters',
    'dateFields'
];
const $06745e3d238ee19b$export$8cc83ae2b6885e0 = new Set($06745e3d238ee19b$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES);
const $06745e3d238ee19b$export$a9ebdab56bd9c0c3 = Object.fromEntries($06745e3d238ee19b$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES.map((key)=>[
        key,
        key
    ]));
const $06745e3d238ee19b$export$2a56ee2f9c41b5a7 = {
    default: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.filter,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isCalendarEnabled: isCalendarEnabled, isBoardEnabled: isBoardEnabled })=>isCalendarEnabled || isBoardEnabled,
        jswAllowed: true
    },
    filter: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.filter,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isCalendarEnabled: isCalendarEnabled, isBoardEnabled: isBoardEnabled })=>isCalendarEnabled || isBoardEnabled,
        jswAllowed: true
    },
    columns: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.columns,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    swimlanes: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.swimlanes,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    quickFilters: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.quickFilters,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    cardColors: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.cardColors,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    cardLayout: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.cardLayout,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    estimation: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.estimation,
        userLocatedBoardAllowed: true,
        kanbanAllowed: false,
        isJsmFeatureVisible: ()=>false,
        jswAllowed: true
    },
    time: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.time,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ()=>false,
        jswAllowed: true
    },
    timelineConfig: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.timelineConfig,
        userLocatedBoardAllowed: false,
        kanbanAllowed: true,
        isJsmFeatureVisible: ()=>false,
        jswAllowed: true
    },
    dateFields: {
        configQuery: $06745e3d238ee19b$export$a9ebdab56bd9c0c3.dateFields,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isCalendarEnabled: isCalendarEnabled })=>isCalendarEnabled,
        jswAllowed: false
    }
};
const $06745e3d238ee19b$export$773ca4f5fb67778b = 60000;
const $06745e3d238ee19b$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
const $06745e3d238ee19b$export$d14d5a7c294329c5 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
'ADMINISTER_PARENT_PROJECT';
const $06745e3d238ee19b$export$1e63b013f0e45de0 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
'USER_PICKER';
const $06745e3d238ee19b$export$68030ac1ea4abd4c = 'ADMINISTER';
const $06745e3d238ee19b$export$e1671d3447ddd5ad = 'BACKLOG';
const $06745e3d238ee19b$export$46efc2c8d8106cff = 'SPRINTS';
const $06745e3d238ee19b$export$a1046f102eae498 = 'ENABLED';

});


parcelRegister("5NguO", function(module, exports) {

$parcel$export(module.exports, "Nav4BenefitsModalTrigger", () => $33c00166c1465f5c$export$b750743fcff63c29);

var $eJOHy = parcelRequire("eJOHy");

var $bbdV2 = parcelRequire("bbdV2");

var $cBavF = parcelRequire("cBavF");

var $bJscI = parcelRequire("bJscI");

var $4Kb71 = parcelRequire("4Kb71");

var $4bRwX = parcelRequire("4bRwX");
const $33c00166c1465f5c$export$b750743fcff63c29 = (0, $bJscI.componentWithFG)('jira_nav4_benefits_modal_v2', $33c00166c1465f5c$var$Nav4BenefitsModalTriggerActual, (0, $eJOHy.Fragment));
function $33c00166c1465f5c$var$Nav4BenefitsModalTriggerActual({ testOverride: testOverride }) {
    const { shouldShowModal: shouldShowModal, setModalShown: setModalShown, onDismiss: onDismiss } = (0, $4Kb71.useBenefitsModal)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            onShow: ()=>setModalShown(true),
            onDismiss: onDismiss
        }), [
        setModalShown,
        onDismiss
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $4bRwX.benefitsModalEntryPoint), entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        const shouldShow = shouldShowModal();
        // Determine if the modal should show
        if (testOverride || shouldShow) entryPointActions.load();
        else if (testOverride && !shouldShow) // Only unload during testing
        entryPointActions.unload();
    }, [
        testOverride,
        shouldShowModal,
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        // Required props for error JSErrorBoundary.
        id: "nav4-onboarding-benefits-modal-ep-container",
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Props for the root component.
        runtimeProps: {},
        ...entryPointParams
    });
}

});
parcelRegister("4Kb71", function(module, exports) {

$parcel$export(module.exports, "useBenefitsModal", () => $9b2b85971aaf60d3$export$327bfa75bb9c0d3);

var $eJOHy = parcelRequire("eJOHy");

var $dnU6V = parcelRequire("dnU6V");

var $7YGYY = parcelRequire("7YGYY");
const $9b2b85971aaf60d3$var$JIRA_NAV4_BENEFITS_MODAL_KEY = 'jiraNav4BenefitsModal';
const $9b2b85971aaf60d3$var$MODAL_DELAY = 171900000; // 47.75 hours
function $9b2b85971aaf60d3$export$a86190deb5c4a8d0() {
    return Date.now();
}
function $9b2b85971aaf60d3$export$327bfa75bb9c0d3() {
    const [isModalShown, setModalShown] = (0, $eJOHy.useState)(false);
    const storage = (0, $dnU6V.createLocalStorageProvider)('jira-nav4-benefits-modal');
    const lastShown = Number(storage.get($9b2b85971aaf60d3$var$JIRA_NAV4_BENEFITS_MODAL_KEY) || 0);
    const { isEligible: isEligible } = (0, $7YGYY.useShowBenefitsModalV2)();
    const dismissed = (0, $eJOHy.useMemo)(()=>{
        return storage.get(`${$9b2b85971aaf60d3$var$JIRA_NAV4_BENEFITS_MODAL_KEY}_dismissed`) ?? false;
    }, [
        storage
    ]);
    const onDismiss = (0, $eJOHy.useCallback)(()=>{
        storage.set(`${$9b2b85971aaf60d3$var$JIRA_NAV4_BENEFITS_MODAL_KEY}_dismissed`, true);
    }, [
        storage
    ]);
    const shouldShowModal = (0, $eJOHy.useCallback)(()=>{
        if (dismissed) return false;
        const isModalDelayFinished = lastShown + $9b2b85971aaf60d3$var$MODAL_DELAY < $9b2b85971aaf60d3$export$a86190deb5c4a8d0();
        return isEligible && isModalDelayFinished;
    }, [
        dismissed,
        lastShown,
        isEligible
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isModalShown) // Update the local storage
        storage.set($9b2b85971aaf60d3$var$JIRA_NAV4_BENEFITS_MODAL_KEY, Date.now());
    }, [
        isModalShown,
        storage
    ]);
    return {
        shouldShowModal: shouldShowModal,
        setModalShown: setModalShown,
        onDismiss: onDismiss
    };
}

});
parcelRegister("7YGYY", function(module, exports) {

$parcel$export(module.exports, "useShowBenefitsModalV2", () => $eb5e978a2c68692e$export$c0d697431493505d);

var $eJOHy = parcelRequire("eJOHy");

var $nK7ig = parcelRequire("nK7ig");

var $aSNIR = parcelRequire("aSNIR");

var $7jTnu = parcelRequire("7jTnu");
const $eb5e978a2c68692e$export$c0d697431493505d = ()=>{
    const isEligible = (0, $eJOHy.useMemo)(()=>{
        if (!(0, $7jTnu.fg)('jira_nav4_benefits_modal_v2')) return false;
        // Bail early for non-admin users.
        if (!(0, $nK7ig.getIsAdmin)()) return false;
        // If the tenant has already been opted in, we don't need to sell them the benefits again
        if ((0, $nK7ig.getIsNav4TenantOptIn)()) return false;
        // Show the modal to admins who can opt the tenant in
        return (0, $aSNIR.getWillShowNav4TenantOptIn)();
    }, []);
    return {
        isEligible: isEligible
    };
};

});
parcelRegister("aSNIR", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4TenantOptIn", () => $477700e6f4aeb53e$export$f0df1010850076cf);

var $7jTnu = parcelRequire("7jTnu");

var $nK7ig = parcelRequire("nK7ig");

var $l6ErE = parcelRequire("l6ErE");
const $477700e6f4aeb53e$export$f0df1010850076cf = ()=>{
    if (!(0, $7jTnu.fg)('jira_nav4')) return false;
    // Previous stages were mutually exclusive. GA is not.
    // Therefore, we need to make sure the customer is not in another stage before showing tenant opt in.
    if ((0, $l6ErE.getIsInPreGaStage)()) return false;
    // Later GA phases eclipse earlier phases.
    if ((0, $7jTnu.fg)('jira_nav4_ga_phase-3') || (0, $7jTnu.fg)('jira_nav4_ga_phase-2') || (0, $7jTnu.fg)('jira_nav4_ga_phase-1-5')) return false;
    return (0, $7jTnu.fg)('jira_nav4_ga_phase-1') && (0, $nK7ig.getIsAdmin)();
};

});
parcelRegister("l6ErE", function(module, exports) {

$parcel$export(module.exports, "getIsInPreGaStage", () => $fc5c3b78107beb17$export$a57a1aacc1a1fc6e);

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");
const $fc5c3b78107beb17$export$a57a1aacc1a1fc6e = ()=>(0, $7jTnu.fg)('jira_nav4_dogfooding') || (0, $7jTnu.fg)('jira_nav4_beta_sandboxes') || (0, $epTsa.expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false) || (0, $epTsa.expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false) || (0, $epTsa.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false);

});




parcelRegister("4bRwX", function(module, exports) {

$parcel$export(module.exports, "benefitsModalEntryPoint", () => $a74ec0e0b40647aa$export$326866d1edcc87f5);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $a74ec0e0b40647aa$export$326866d1edcc87f5 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("a3rLN")).then(({ Nav4BenefitsModal: Nav4BenefitsModal })=>Nav4BenefitsModal), {
        moduleId: "104c29e0",
        moduleName: "Nav4BenefitsModal",
        priority: "interaction"
    }),
    getPreloadProps: ({ onShow: onShow, onDismiss: onDismiss })=>{
        return {
            extraProps: {
                onShow: onShow,
                onDismiss: onDismiss
            }
        };
    }
});

});
parcelRegister("a3rLN", function(module, exports) {

let $751fb9b2d253e2a3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $751fb9b2d253e2a3$var$load("2CVPV").then(()=>parcelRequire('3tP3L'));

});



parcelRegister("EzBXZ", function(module, exports) {

$parcel$export(module.exports, "RenderOnClient", () => $8d2b8b6c60c3fc0f$export$f7ced6922b75ec11);

var $7jTnu = parcelRequire("7jTnu");

var $cSOX1 = parcelRequire("cSOX1");
const $8d2b8b6c60c3fc0f$export$f7ced6922b75ec11 = ({ children: children, fg: featureGateName })=>{
    const isClientReady = (0, $cSOX1.useIsClientReady)();
    // eslint-disable-next-line jira/ff/static-feature-flags
    if (featureGateName && !(0, $7jTnu.fg)(featureGateName)) return children;
    if (isClientReady) return children;
    return null;
};

});
parcelRegister("cSOX1", function(module, exports) {

$parcel$export(module.exports, "useIsClientReady", () => $ee41adecc45b8369$export$d2ab98824add97fa);

var $eJOHy = parcelRequire("eJOHy");
const $ee41adecc45b8369$export$d2ab98824add97fa = ()=>{
    const [ready, setReady] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        (0, $eJOHy.startTransition)(()=>setReady(true));
    }, []);
    return ready;
};

});


parcelRegister("jIGRF", function(module, exports) {

$parcel$export(module.exports, "useBannerJsmPackagingUpdates", () => $298482280a4ff589$export$a0dde3f151a99607);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $7jTnu = parcelRequire("7jTnu");

var $hih5V = parcelRequire("hih5V");

var $2aY2d = parcelRequire("2aY2d");

var $l9Rnx = parcelRequire("l9Rnx");

var $8q7lT = parcelRequire("8q7lT");

var $lhG7N = parcelRequire("lhG7N");
const $298482280a4ff589$export$a0dde3f151a99607 = ()=>{
    const currentRoute = (0, $hih5V.useCurrentRoute)();
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const accountId = (0, $8q7lT.useAccountId)();
    const isServiceProject = project?.projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT);
    const isInJsmBoundary = (0, $eJOHy.useMemo)(()=>(0, $lhG7N.isInJsmGlobalSettingsBoundary)(currentRoute.path) || isServiceProject, [
        isServiceProject,
        currentRoute.path
    ]);
    const { shouldShow: shouldShow, dismissAnnouncement: dismissAnnouncement } = (0, $l9Rnx.useJsmRepackagingAnnouncementResource)(accountId);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: isInJsmBoundary && shouldShow && (0, $7jTnu.fg)('jsm-packaging-pricing-changes-announcement'),
            dismissAnnouncement: dismissAnnouncement
        }), [
        dismissAnnouncement,
        isInJsmBoundary,
        shouldShow
    ]);
};

});
parcelRegister("l9Rnx", function(module, exports) {

$parcel$export(module.exports, "useJsmRepackagingAnnouncementResource", () => $9c32e00a59efd70e$export$47d5fef12f2d184b);

var $eJOHy = parcelRequire("eJOHy");

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $lg2sd = parcelRequire("lg2sd");

const $9c32e00a59efd70e$var$getDataLoader = ()=>(parcelRequire("8Gkgq"));
const $9c32e00a59efd70e$export$750cb6ed3dfc6a3 = (0, $l1VxS.createResource)({
    type: 'JSM_REPACKAGING_ANNOUNCEMENT',
    getKey: ()=>'JSM_REPACKAGING_ANNOUNCEMENT',
    getDataLoader: $9c32e00a59efd70e$var$getDataLoader,
    maxAge: Infinity
});
const $9c32e00a59efd70e$export$47d5fef12f2d184b = (accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, $eJrcF.useResource)($9c32e00a59efd70e$export$750cb6ed3dfc6a3);
    const loadingRef = (0, $eJOHy.useRef)(false);
    const errorRef = (0, $eJOHy.useRef)();
    const [userPropertiesError, setUserPropertiesError] = (0, $eJOHy.useState)();
    errorRef.current = userPropertiesError || error;
    const dismissAnnouncement = (0, $eJOHy.useCallback)(()=>{
        const announcementDismissState = {
            shouldShow: false
        };
        update(()=>({
                announcementDismissState: announcementDismissState
            }));
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $gYnSx.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                        teamName: '50cent'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $FppkK.setUserProperties)(accountId, (0, $lg2sd.JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY), JSON.stringify(announcementDismissState)).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                (0, $gYnSx.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                        teamName: '50cent'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                loadingRef.current = false;
            });
        }
    }, [
        accountId,
        update
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (errorRef.current || loading || !data || !accountId) return {
            shouldShow: false,
            dismissAnnouncement: dismissAnnouncement
        };
        const { announcementDismissState: announcementDismissState } = data;
        if (!announcementDismissState) return {
            shouldShow: false,
            dismissAnnouncement: dismissAnnouncement
        };
        return {
            ...announcementDismissState,
            dismissAnnouncement: dismissAnnouncement
        };
    }, [
        loading,
        data,
        accountId,
        dismissAnnouncement
    ]);
};

});
parcelRegister("lg2sd", function(module, exports) {

$parcel$export(module.exports, "JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY", () => $5f1876ad0974700e$export$d2137827dc00e559);
$parcel$export(module.exports, "DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE", () => $5f1876ad0974700e$export$341176bfdf8c92);
const $5f1876ad0974700e$export$d2137827dc00e559 = 'jsm-repackaging-announcement-dismiss-state';
const $5f1876ad0974700e$export$341176bfdf8c92 = {
    shouldShow: true
};

});

parcelRegister("8Gkgq", function(module, exports) {

let $6521f6f1d4e73f9a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6521f6f1d4e73f9a$var$load("1U0fK").then(()=>parcelRequire('eH95J'));

});


parcelRegister("lhG7N", function(module, exports) {

$parcel$export(module.exports, "isInJsmGlobalSettingsBoundary", () => $fe9eb9c81551c0a4$export$c28a66ae6d31a34b);
const $fe9eb9c81551c0a4$var$jsmGlobalSettingsPages = [
    '/jira/settings/products/jira-service-management-configuration',
    '/jira/settings/products/jira-service-management-email-requests',
    '/jira/settings/products/servicedesk/customer-access',
    '/jira/settings/products/servicedesk/authentication',
    '/jira/settings/products/servicedesk/organizations',
    '/jira/settings/products/jira-service-management-incident-management-tools',
    '/jira/settings/products/jira-service-management-compliance',
    '/jira/settings/products/servicedesk/feature-usage'
];
const $fe9eb9c81551c0a4$var$eocGlobalSettingsPages = [
    '/jira/settings/products/ops/roles',
    '/jira/settings/products/ops/role-assignment',
    '/jira/settings/products/ops/role-based-notifications',
    '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
    '/jira/settings/products/ops/integrations',
    '/jira/settings/products/ops/heartbeats',
    '/jira/settings/products/ops/syncs',
    '/jira/settings/products/ops/policies',
    '/jira/settings/products/ops/maintenance',
    '/jira/settings/products/ops/escalation-policies',
    '/jira/settings/products/ops/incoming-call',
    '/jira/settings/products/ops/jira-service-management-audit-logs',
    '/jira/settings/products/ops/reports'
];
const $fe9eb9c81551c0a4$var$isJsmGlobalSettingsPage = (route)=>$fe9eb9c81551c0a4$var$jsmGlobalSettingsPages.includes(route);
const $fe9eb9c81551c0a4$var$isEocGlobalSettingsPage = (route)=>$fe9eb9c81551c0a4$var$eocGlobalSettingsPages.includes(route);
const $fe9eb9c81551c0a4$export$c28a66ae6d31a34b = (route)=>$fe9eb9c81551c0a4$var$isJsmGlobalSettingsPage(route) || $fe9eb9c81551c0a4$var$isEocGlobalSettingsPage(route);

});


parcelRegister("bv6dN", function(module, exports) {

$parcel$export(module.exports, "useJsmGracePeriodBanner", () => $511fa62b6da1a92e$export$cb2cdbdc1bcc9ace);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $7jTnu = parcelRequire("7jTnu");

var $hih5V = parcelRequire("hih5V");

var $2aY2d = parcelRequire("2aY2d");

var $lhG7N = parcelRequire("lhG7N");
const $511fa62b6da1a92e$export$cb2cdbdc1bcc9ace = ()=>{
    const currentRoute = (0, $hih5V.useCurrentRoute)();
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const isServiceProject = project?.projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT);
    const isInJsmBoundary = (0, $eJOHy.useMemo)(()=>(0, $lhG7N.isInJsmGlobalSettingsBoundary)(currentRoute.path) || isServiceProject, [
        isServiceProject,
        currentRoute.path
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: isInJsmBoundary && (0, $7jTnu.fg)('jsm_gp_announcements_banner')
        }), [
        isInJsmBoundary
    ]);
};

});

parcelRegister("3pkO9", function(module, exports) {

$parcel$export(module.exports, "JSMGracePeriodBannerAsync", () => $dd4967033b8f5eaa$export$5f656c66df6dad60);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $1KdDN = parcelRequire("1KdDN");

var $gzcjr = parcelRequire("gzcjr");

const $dd4967033b8f5eaa$var$JSMGracePeriodBannerLazy = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("7cd3U")).then((module)=>module.JSMGracePeriodBanner), {
    moduleId: "./src/packages/servicedesk/jsm-grace-period-banner/src/ui/index.tsx"
});
const $dd4967033b8f5eaa$export$5f656c66df6dad60 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "async.jsm-grace-period-banner",
        teamName: "Sequoia",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-jsm-grace-period-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dd4967033b8f5eaa$var$JSMGracePeriodBannerLazy, null)));
};

});
parcelRegister("7cd3U", function(module, exports) {

let $53d3c93fcee03d99$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $53d3c93fcee03d99$var$load("3F4vn").then(()=>parcelRequire('d8ZiM'));

});


parcelRegister("d56U1", function(module, exports) {

$parcel$export(module.exports, "BannerJsmPackagingUpdateAsync", () => $fc485ba35452b76d$export$76c6ab35aee49900);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $fc485ba35452b76d$var$BannerTransition = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("cw0M3")).then((module)=>module.BannerJsmPackagingUpdate), {
    moduleId: "./src/packages/platform/ui/banners/jsm-packaging-updates/src/ui/banner/index.tsx"
});
const $fc485ba35452b76d$export$76c6ab35aee49900 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-banner-jsm-packaging-updates",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fc485ba35452b76d$var$BannerTransition, null));

});
parcelRegister("cw0M3", function(module, exports) {

let $91c912e9e74080b1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $91c912e9e74080b1$var$load("cKwzf").then(()=>parcelRequire('c7IiQ'));

});


parcelRegister("2PrU6", function(module, exports) {

$parcel$export(module.exports, "useProjectTheme", () => $bde3db500fc78c9b$export$18084206b9430153);

var $eJOHy = parcelRequire("eJOHy");

var $kfvK2 = parcelRequire("kfvK2");

var $gYW18 = parcelRequire("gYW18");

var $hS1gr = parcelRequire("hS1gr");

var $epTsa = parcelRequire("epTsa");

var $9R5AI = parcelRequire("9R5AI");

var $6nQNr = parcelRequire("6nQNr");

var $6zXPf = parcelRequire("6zXPf");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $hbF3h = parcelRequire("hbF3h");

var $5OvV4 = parcelRequire("5OvV4");
const $bde3db500fc78c9b$export$94f987aa4379ed89 = (0, $kfvK2.createRouterSelector)((state)=>state.route.name);
const $bde3db500fc78c9b$export$89f90ea8776fdb88 = (0, $kfvK2.createRouterSelector)((state)=>state.route.group);
const $bde3db500fc78c9b$export$4747cad4fc91185 = (0, $kfvK2.createRouterSelector)((state)=>state.match.params);
const $bde3db500fc78c9b$var$defaultProjectTheme = {
    hasTheming: false,
    hasProjectViewNavigation: false,
    isInset: false
};
const $bde3db500fc78c9b$export$25cf5728a2514195 = ()=>{
    const routeName = $bde3db500fc78c9b$export$94f987aa4379ed89();
    const routeGroup = $bde3db500fc78c9b$export$89f90ea8776fdb88();
    const HorizontalNavComponent = (0, $6nQNr.useHorizontalNavComponent)();
    const { hasSoftwareTheming: hasSoftwareTheming, isSoftwareFullTheming: isSoftwareFullTheming, isSoftwareProject: isSoftwareProject } = (0, $1302Y.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kUoGK.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false,
        isSoftwareProject: false
    };
    const isBusinessRouteGroup = routeGroup === 'classic-business';
    const hasProjectViewNavigation = (0, $6zXPf.getWillShowNav4)() ? HorizontalNavComponent != null : HorizontalNavComponent === (0, $hS1gr.AsyncHorizontalNavJira) || HorizontalNavComponent === (0, $gYW18.AsyncHorizontalOverviewNav) || HorizontalNavComponent === (0, $9R5AI.AsyncHorizontalNavPlans);
    let hasTheming;
    if ((0, $6zXPf.getWillShowNav4)()) {
        const isSoftwareCalendarRoute = routeName === 'software-calendar' || routeName === 'software-calendar-classic';
        if (isSoftwareCalendarRoute && !(0, $1302Y.getIsSoftwareThemingM2Enabled)()) // remove this condition completely on m2 exp cleanup
        hasTheming = false;
        else if (isSoftwareProject) hasTheming = hasSoftwareTheming;
        else hasTheming = HorizontalNavComponent === (0, $hS1gr.AsyncHorizontalNavJira) || HorizontalNavComponent === (0, $gYW18.AsyncHorizontalOverviewNav) || routeName === 'issue';
    } else hasTheming = hasProjectViewNavigation;
    // Routes showing a themed inset layout are:
    // - all routes with the business project view navigation
    // - select software routes with contoured theming
    // - except for the routes with business group (as they already cater for the theme)
    const isInset = hasTheming && !isBusinessRouteGroup && !isSoftwareFullTheming;
    return {
        isInset: isInset,
        hasTheming: hasTheming,
        hasProjectViewNavigation: hasProjectViewNavigation
    };
};
const $bde3db500fc78c9b$var$useProjectThemeSimplified = ()=>{
    const routeName = $bde3db500fc78c9b$export$94f987aa4379ed89();
    const routeGroup = $bde3db500fc78c9b$export$89f90ea8776fdb88();
    const isBusinessProject = (0, $5OvV4.BUSINESS_PROJECT_THEMED_ROUTES).has(routeName);
    const { allThemedSoftwareProjectRoutes: allThemedSoftwareProjectRoutes } = (0, $kUoGK.getSoftwareThemedRoutes)();
    const isSoftwareProject = allThemedSoftwareProjectRoutes.has(routeName);
    const isIssueView = routeName === 'issue';
    const isBusinessRouteGroup = routeGroup === 'classic-business';
    const { hasSoftwareTheming: hasSoftwareTheming, isSoftwareFullTheming: isSoftwareFullTheming } = (0, $1302Y.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kUoGK.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false
    };
    return (0, $eJOHy.useMemo)(()=>{
        if (isIssueView) return {
            hasTheming: true,
            hasProjectViewNavigation: false,
            isInset: true
        };
        if (!isBusinessProject && !isSoftwareProject) return $bde3db500fc78c9b$var$defaultProjectTheme;
        // Remove this if clause once when cleaning up getIsSoftwareThemingEnabled
        // Will would get contoured theming on project pages if we don't have this check
        if ((0, $5OvV4.SHARED_THEMED_ROUTES).has(routeName)) {
            if (routeName === 'project-pages') return {
                hasTheming: true,
                hasProjectViewNavigation: true,
                isInset: false
            };
            return {
                hasTheming: true,
                hasProjectViewNavigation: true,
                isInset: true
            };
        }
        if (isSoftwareProject) {
            if (!(0, $1302Y.getIsSoftwareThemingEnabled)()) return $bde3db500fc78c9b$var$defaultProjectTheme;
            const isSoftwareCalendarRoute = routeName === 'software-calendar' || routeName === 'software-calendar-classic';
            if (isSoftwareCalendarRoute && !(0, $1302Y.getIsSoftwareThemingM2Enabled)()) return {
                hasTheming: false,
                hasProjectViewNavigation: true,
                isInset: false
            };
            return {
                hasTheming: hasSoftwareTheming,
                hasProjectViewNavigation: true,
                isInset: hasSoftwareTheming && !isSoftwareFullTheming
            };
        }
        if (isBusinessProject) {
            const hasProjectViewNavigation = (0, $5OvV4.BUSINESS_PROJECT_THEMED_ROUTES).has(routeName);
            const hasTheming = hasProjectViewNavigation;
            const isInset = hasTheming && !isBusinessRouteGroup || (0, $5OvV4.getBusinessProjectForcedInsetRoutes)().has(routeName);
            return {
                hasTheming: hasTheming,
                hasProjectViewNavigation: hasProjectViewNavigation,
                isInset: isInset
            };
        }
        return $bde3db500fc78c9b$var$defaultProjectTheme;
    }, [
        isIssueView,
        isBusinessProject,
        isSoftwareProject,
        routeName,
        isBusinessRouteGroup,
        hasSoftwareTheming,
        isSoftwareFullTheming
    ]);
};
const $bde3db500fc78c9b$export$18084206b9430153 = (0, $hbF3h.functionWithCondition)(()=>(0, $6zXPf.getWillShowNav4)() && (0, $epTsa.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false), $bde3db500fc78c9b$var$useProjectThemeSimplified, $bde3db500fc78c9b$export$25cf5728a2514195);

});
parcelRegister("9R5AI", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalNavPlans", () => $37bd3dfaad7af547$export$84e1a5f003939496);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $37bd3dfaad7af547$var$LazyHorizontalPlansNav = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("2mBgR")).then(({ HorizontalPlansNav: HorizontalPlansNav })=>HorizontalPlansNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-plans/src/ui/index.tsx"
});
const $37bd3dfaad7af547$export$84e1a5f003939496 = ({ store: store })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "horizontal-software-plans-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37bd3dfaad7af547$var$LazyHorizontalPlansNav, {
        store: store
    }));

});
parcelRegister("2mBgR", function(module, exports) {

let $1b8a8c139e0c836b$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve("vqJ0J"), 4)),
    $1b8a8c139e0c836b$var$load("hwlgY"),
    $1b8a8c139e0c836b$var$load("k4gbU"),
    $1b8a8c139e0c836b$var$load("eDzss"),
    $1b8a8c139e0c836b$var$load("1VRB2"),
    $1b8a8c139e0c836b$var$load("bABhq"),
    $1b8a8c139e0c836b$var$load("7vqGd"),
    $1b8a8c139e0c836b$var$load("1Y4bq"),
    $1b8a8c139e0c836b$var$load("a7TG1")
]).then(()=>parcelRequire('6UdDE'));

});


parcelRegister("kUoGK", function(module, exports) {

$parcel$export(module.exports, "getSoftwareThemedRoutes", () => $792c5cf1d308dd5d$export$8b0967e3892c7b59);
$parcel$export(module.exports, "useSoftwareProjectTheming", () => $792c5cf1d308dd5d$export$4c26676caf6bb553);

var $eJOHy = parcelRequire("eJOHy");

var $kfvK2 = parcelRequire("kfvK2");

var $2aY2d = parcelRequire("2aY2d");

var $ln6Iy = parcelRequire("ln6Iy");

var $1302Y = parcelRequire("1302Y");

var $epTsa = parcelRequire("epTsa");

var $hbF3h = parcelRequire("hbF3h");

var $i7yNt = parcelRequire("i7yNt");
const $792c5cf1d308dd5d$var$defaultValues = {
    hasSoftwareTheming: false,
    isSoftwareFullTheming: false,
    isSoftwareProject: false
};
const $792c5cf1d308dd5d$export$c4b7ea2942f2d0e = (0, $kfvK2.createRouterSelector)((state)=>state.route.name);
const $792c5cf1d308dd5d$export$8838ccecebb0c319 = (0, $kfvK2.createRouterSelector)((state)=>state.match.url);
const $792c5cf1d308dd5d$export$52b606e2ebcbaae2 = ()=>{
    if (!(0, $1302Y.getIsSoftwareThemingEnabled)()) return $792c5cf1d308dd5d$var$defaultValues;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: projectData } = (0, $2aY2d.useProjectContext)();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const currentRoute = $792c5cf1d308dd5d$export$c4b7ea2942f2d0e();
    const isSoftwareProject = projectData?.projectType === (0, $ln6Iy.SOFTWARE_PROJECT);
    if (!isSoftwareProject) return $792c5cf1d308dd5d$var$defaultValues;
    // temporarily disable theming for calendar
    // the logic matches with the one in src/packages/platform/project-theme/page-container/src/controllers/project-theme/index.tsx
    const isSoftwareCalendarRoute = currentRoute === 'software-calendar' || currentRoute === 'software-calendar-classic';
    if (isSoftwareCalendarRoute && !(0, $1302Y.getIsSoftwareThemingM2Enabled)()) return {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false,
        isSoftwareProject: isSoftwareProject
    };
    const isM2Enabled = (0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)();
    const hasSoftwareTheming = isM2Enabled ? isSoftwareProject && (0, $i7yNt.getSoftwareThemeRoutesM2)().has(currentRoute) && (0, $1302Y.getIsSoftwareThemingM2Enabled)() // Only fire exposure if we are on a themed route
     : isSoftwareProject && (0, $i7yNt.getSoftwareThemeRoutes)().has(currentRoute) && !isSoftwareCalendarRoute;
    const isSoftwareFullTheming = isM2Enabled ? hasSoftwareTheming && (0, $i7yNt.getSoftwareFullThemeRoutesM2)().has(currentRoute) : hasSoftwareTheming && (0, $i7yNt.getSoftwareFullThemeRoutes)().has(currentRoute);
    return {
        hasSoftwareTheming: hasSoftwareTheming,
        isSoftwareFullTheming: isSoftwareFullTheming,
        isSoftwareProject: isSoftwareProject
    };
};
const $792c5cf1d308dd5d$export$8b0967e3892c7b59 = ()=>{
    const allThemedSoftwareProjectRoutes = (0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)() ? (0, $i7yNt.getSoftwareThemeRoutesM2)() : (0, $i7yNt.getSoftwareThemeRoutes)();
    const fullThemedSoftwareProjectRoutes = (0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)() ? (0, $i7yNt.getSoftwareFullThemeRoutesM2)() : (0, $i7yNt.getSoftwareFullThemeRoutes)();
    // Enable theming for the shared routes no matter which milestone we are in
    allThemedSoftwareProjectRoutes.add('project-pages');
    allThemedSoftwareProjectRoutes.add('project-components');
    fullThemedSoftwareProjectRoutes.add('project-pages');
    return {
        allThemedSoftwareProjectRoutes: allThemedSoftwareProjectRoutes,
        fullThemedSoftwareProjectRoutes: fullThemedSoftwareProjectRoutes
    };
};
const $792c5cf1d308dd5d$var$useSoftwareProjectThemingSimplified = ()=>{
    const currentRoute = $792c5cf1d308dd5d$export$c4b7ea2942f2d0e();
    const currentUrl = $792c5cf1d308dd5d$export$8838ccecebb0c319();
    const { allThemedSoftwareProjectRoutes: allThemedSoftwareProjectRoutes, fullThemedSoftwareProjectRoutes: fullThemedSoftwareProjectRoutes } = $792c5cf1d308dd5d$export$8b0967e3892c7b59();
    const isSoftwareProject = allThemedSoftwareProjectRoutes.has(currentRoute) && (currentUrl.includes('/jira/software/projects/') || currentUrl.includes('/jira/software/c/projects/') || currentRoute === 'issue');
    const isSoftwareCalendarRoute = currentRoute === 'software-calendar' || currentRoute === 'software-calendar-classic';
    return (0, $eJOHy.useMemo)(()=>{
        if (!isSoftwareProject || !(0, $1302Y.getIsSoftwareThemingEnabled)()) return $792c5cf1d308dd5d$var$defaultValues;
        // temporarily disable theming for calendar
        // the logic matches with the one in src/packages/platform/project-theme/page-container/src/controllers/project-theme/index.tsx
        if (isSoftwareCalendarRoute && !(0, $1302Y.getIsSoftwareThemingM2Enabled)()) return {
            hasSoftwareTheming: false,
            isSoftwareFullTheming: false,
            isSoftwareProject: isSoftwareProject
        };
        return {
            hasSoftwareTheming: allThemedSoftwareProjectRoutes.has(currentRoute),
            isSoftwareFullTheming: fullThemedSoftwareProjectRoutes.has(currentRoute),
            isSoftwareProject: isSoftwareProject
        };
    }, [
        isSoftwareProject,
        isSoftwareCalendarRoute,
        allThemedSoftwareProjectRoutes,
        currentRoute,
        fullThemedSoftwareProjectRoutes
    ]);
};
const $792c5cf1d308dd5d$export$4c26676caf6bb553 = (0, $hbF3h.functionWithCondition)(()=>(0, $epTsa.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false), $792c5cf1d308dd5d$var$useSoftwareProjectThemingSimplified, $792c5cf1d308dd5d$export$52b606e2ebcbaae2);

});
parcelRegister("i7yNt", function(module, exports) {

$parcel$export(module.exports, "getSoftwareFullThemeRoutes", () => $686f9881c0e0ac79$export$2763881c45550362);
$parcel$export(module.exports, "getSoftwareFullThemeRoutesM2", () => $686f9881c0e0ac79$export$b8224211dbf2b52);
$parcel$export(module.exports, "getSoftwareThemeRoutes", () => $686f9881c0e0ac79$export$89c22b5407a942a4);
$parcel$export(module.exports, "getSoftwareThemeRoutesM2", () => $686f9881c0e0ac79$export$1801e4f1cddaf84b);
// consolidate the software themed routes to src/packages/platform/project-theme/page-container/src/controllers/project-theme/constants.tsx
// when we migrate the software project theming to business

var $7jTnu = parcelRequire("7jTnu");
const $686f9881c0e0ac79$export$3c8d79af57f2246c = ()=>{
    if ((0, $7jTnu.fg)('jira_list_nin_merge')) return new Set([
        'issue',
        'software-backlog',
        'rapidboard-backlog',
        'software-timeline',
        'software-timeline-classic',
        'software-issue-navigator',
        'software-list',
        'software-list-classic',
        'issue-navigator-classic'
    ]);
    return new Set([
        'issue',
        'software-backlog',
        'rapidboard-backlog',
        'software-timeline',
        'software-timeline-classic',
        'software-issue-navigator',
        'issue-navigator-classic'
    ]);
};
const $686f9881c0e0ac79$export$2763881c45550362 = ()=>{
    if ((0, $7jTnu.fg)('jira_list_nin_merge')) return new Set([
        'software-boards',
        'rapidboard-board',
        'software-calendar',
        'software-calendar-classic',
        'software-summary',
        'software-summary-classic'
    ]);
    return new Set([
        'software-boards',
        'rapidboard-board',
        'software-calendar',
        'software-calendar-classic',
        'software-list',
        'software-list-classic',
        'software-summary',
        'software-summary-classic'
    ]);
};
const $686f9881c0e0ac79$export$3d9f5dde05195378 = ()=>{
    if ((0, $7jTnu.fg)('jira_list_nin_merge')) return new Set([
        'issue',
        'software-timeline',
        'software-timeline-classic',
        'software-issue-navigator',
        'software-list',
        'software-list-classic',
        'issue-navigator-classic'
    ]);
    return new Set([
        'issue',
        'software-timeline',
        'software-timeline-classic',
        'software-issue-navigator',
        'issue-navigator-classic'
    ]);
};
const $686f9881c0e0ac79$export$b8224211dbf2b52 = ()=>{
    if ((0, $7jTnu.fg)('jira_list_nin_merge')) return new Set([
        'software-boards',
        'rapidboard-board',
        'software-calendar',
        'software-calendar-classic',
        'software-summary',
        'software-summary-classic',
        'software-backlog',
        'rapidboard-backlog',
        'project-pages',
        'software-form-classic',
        'software-form',
        'software-form-builder-classic',
        'software-form-builder'
    ]);
    return new Set([
        'software-boards',
        'rapidboard-board',
        'software-calendar',
        'software-calendar-classic',
        'software-list',
        'software-list-classic',
        'software-summary',
        'software-summary-classic',
        'software-backlog',
        'rapidboard-backlog',
        'project-pages',
        'software-form-classic',
        'software-form',
        'software-form-builder-classic',
        'software-form-builder'
    ]);
};
const $686f9881c0e0ac79$export$89c22b5407a942a4 = ()=>new Set([
        ...$686f9881c0e0ac79$export$3c8d79af57f2246c(),
        ...$686f9881c0e0ac79$export$2763881c45550362()
    ]);
const $686f9881c0e0ac79$export$1801e4f1cddaf84b = ()=>new Set([
        ...$686f9881c0e0ac79$export$3d9f5dde05195378(),
        ...$686f9881c0e0ac79$export$b8224211dbf2b52()
    ]);

});


parcelRegister("5OvV4", function(module, exports) {

$parcel$export(module.exports, "SHARED_THEMED_ROUTES", () => $5c8700be19e573c2$export$6e841237e4270ee5);
$parcel$export(module.exports, "getBusinessProjectForcedInsetRoutes", () => $5c8700be19e573c2$export$2648e960168c60eb);
$parcel$export(module.exports, "BUSINESS_PROJECT_THEMED_ROUTES", () => $5c8700be19e573c2$export$92da73f6b515b9da);

var $7jTnu = parcelRequire("7jTnu");
const $5c8700be19e573c2$export$6e841237e4270ee5 = new Set([
    'project-components',
    'project-pages'
]);
const $5c8700be19e573c2$export$2648e960168c60eb = ()=>{
    if ((0, $7jTnu.fg)('jira_list_nin_merge')) return new Set([
        'classic-business-list'
    ]);
    return new Set([]);
};
const $5c8700be19e573c2$export$92da73f6b515b9da = new Set([
    'classic-business-approvals',
    'classic-business-overview-calendar',
    'classic-business-sample-onboarding',
    'classic-business-form-submit',
    'classic-business-reports-overview',
    'classic-business-overview-summary',
    'classic-business-view-not-found',
    'classic-business-form-submit-public',
    'classic-business-shortcut',
    'classic-business-form-builder',
    'classic-business-form',
    'classic-business-timeline',
    'classic-business-attachments',
    'classic-business-overview-redirect',
    'classic-business-redirect',
    'classic-business-list',
    'classic-business-board',
    'classic-business-calendar',
    'classic-business-overview-timeline',
    'classic-business-summary',
    'issue-navigator-core',
    'classic-business-archived-work-items',
    ...$5c8700be19e573c2$export$6e841237e4270ee5
]);

});


parcelRegister("djhHt", function(module, exports) {

$parcel$export(module.exports, "sharedLayout", () => $dfa1b1acb991d626$export$5f4dc7c98070d93e);

var $eJOHy = parcelRequire("eJOHy");

var $6XXs7 = parcelRequire("6XXs7");

var $ln6Iy = parcelRequire("ln6Iy");

var $8R3rZ = parcelRequire("8R3rZ");

var $71DNl = parcelRequire("71DNl");

var $56K43 = parcelRequire("56K43");

var $cKuba = parcelRequire("cKuba");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $2HxHL = parcelRequire("2HxHL");

var $epTsa = parcelRequire("epTsa");

var $bJscI = parcelRequire("bJscI");

var $86XkI = parcelRequire("86XkI");

var $MBWwk = parcelRequire("MBWwk");

var $7jTnu = parcelRequire("7jTnu");

var $28GDA = parcelRequire("28GDA");

var $aY5Xx = parcelRequire("aY5Xx");

var $cosWN = parcelRequire("cosWN");

var $hWQJk = parcelRequire("hWQJk");

var $eWzpp = parcelRequire("eWzpp");

var $imyEu = parcelRequire("imyEu");

var $e5yn1 = parcelRequire("e5yn1");

var $38W5l = parcelRequire("38W5l");

var $6u6pq = parcelRequire("6u6pq");

var $3Kq2h = parcelRequire("3Kq2h");

var $6dwgv = parcelRequire("6dwgv");

var $fp9AW = parcelRequire("fp9AW");

var $hMGR1 = parcelRequire("hMGR1");

var $kEUB1 = parcelRequire("kEUB1");

var $7Wekb = parcelRequire("7Wekb");

var $b4mGA = parcelRequire("b4mGA");

var $bwRvc = parcelRequire("bwRvc");

var $gzcjr = parcelRequire("gzcjr");

var $bGKoK = parcelRequire("bGKoK");

var $gsuME = parcelRequire("gsuME");

var $lvKO5 = parcelRequire("lvKO5");

var $HPMxS = parcelRequire("HPMxS");

var $lb6FK = parcelRequire("lb6FK");

var $lHlwJ = parcelRequire("lHlwJ");

var $a8idd = parcelRequire("a8idd");

var $41vjk = parcelRequire("41vjk");

var $6Yzhs = parcelRequire("6Yzhs");

var $ajCkH = parcelRequire("ajCkH");

var $7cv6Z = parcelRequire("7cv6Z");

var $jjTNC = parcelRequire("jjTNC");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfa1b1acb991d626$var$Global = (0, $gzcjr.lazy)(()=>(parcelRequire("5zkGh")), {
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/global/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfa1b1acb991d626$var$Navigation = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("hwbH7")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/navigation/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfa1b1acb991d626$var$Trackers = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("kjETs")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/trackers/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfa1b1acb991d626$var$RemoteActions = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("6XNiP")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/remote-actions/index.tsx"
});

// No need for a whole chunk for a single component
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfa1b1acb991d626$var$AfterPaintIssuePreEval = (0, $gzcjr.lazyAfterPaint)(/* eslint-disable-next-line jira/import/webpack-magic-comment-entries */ ()=>(parcelRequire("5lLid")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/after-paint-issue-preeval/AfterPaintIssuePreEval.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfa1b1acb991d626$var$AsyncBrowserStorageControlsInit = (0, $gzcjr.lazy)(()=>(parcelRequire("54ZXa")).then(({ BrowserStorageControlsInit: BrowserStorageControlsInit })=>BrowserStorageControlsInit), {
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/browser-storage-controls-init/index.tsx"
});
const $dfa1b1acb991d626$var$runtimeProps = {};
const $dfa1b1acb991d626$var$entryPointParams = {};
const $dfa1b1acb991d626$export$3859d35c5447350b = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $fp9AW.rovoVideoModalEntryPoint), $dfa1b1acb991d626$var$entryPointParams);
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId, isAnonymous: isAnonymous } = (0, $lvKO5.useTenantContext)();
    const { loading: loadingProject, data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $ln6Iy.toProjectType)(project?.type);
    const { start: messageStarted } = (0, $HPMxS.useCoordinationClient)();
    const rovoEntitlement = (0, $lb6FK.useRovoEntitlementResource)();
    const isRovoLLMEnabled = !!rovoEntitlement?.data?.isRovoLLMEnabled;
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        const shouldShowRovoVideoModal = async ()=>{
            const hasSeenRovoOnboarding = await (0, $gsuME.getRovoVideoOnboardingHash)(atlassianAccountId);
            if (// eslint-disable-next-line jira/ff/no-preconditioning
            !loadingProject && (0, $bGKoK.isJiraSoftware)(projectType) && (0, $7jTnu.fg)('rovo_video_player_gate') && !hasSeenRovoOnboarding && !isAnonymous && isRovoLLMEnabled) {
                const hasMessageStarted = await messageStarted();
                if (hasMessageStarted) entryPointActions.load();
            }
        };
        shouldShowRovoVideoModal();
    }, [
        atlassianAccountId,
        cloudId,
        entryPointActions,
        isAnonymous,
        loadingProject,
        messageStarted,
        projectType,
        isRovoLLMEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "growth.rovoVideoPlayer",
        packageName: "rovo-video-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $dfa1b1acb991d626$var$runtimeProps
    });
};
const $dfa1b1acb991d626$export$39abefd31dfea2bd = ()=>{
    const { data: project } = (0, $eWzpp.useProject)();
    const projectId = String(project?.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Wekb.AsyncTrialSprintBoardModalEntryPoint), {
        currentProjectId: projectId
    });
};
const $dfa1b1acb991d626$export$bb0d8fff645668ce = ()=>{
    const cloudID = (0, $kEUB1.useCloudId)();
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $ln6Iy.toProjectType)(project?.type) || null;
    const productKey = (0, $ln6Iy.projectTypeToCanonicalId)(projectType);
    const deferEditionModalEntryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudID,
            productKey: productKey,
            // When cleaning up servco-defer-edition-modal, this param can be removed and graphQL query updated to always include
            isCollectionEnabled: (0, $7jTnu.fg)('servco-defer-edition-modal')
        }), [
        cloudID,
        productKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $56K43.jiraDeferEditionModalEntryPoint), deferEditionModalEntryPointParams);
    const onComplete = (0, $eJOHy.useCallback)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $71DNl.AsyncDeferEditionEPCheckWrapper), {
        onComplete: onComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "growth.jiraDeferEditionModal",
        packageName: "jira-defer-edition-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $dfa1b1acb991d626$var$runtimeProps
    }));
};
const $dfa1b1acb991d626$var$EndOfTrialModalEntryPoint = ()=>{
    const hasLoaded = (0, $eJOHy.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $cKuba.endOfTrialExtensionEntryPoint), {});
    if (!hasLoaded.current) {
        hasLoaded.current = true;
        entryPointActions.load();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "growth.endOfTrialExtension",
        packageName: "jira-end-of-trial-extension",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $dfa1b1acb991d626$var$runtimeProps
    });
};
const $dfa1b1acb991d626$var$ConditionalCrossJoinNudge = (0, $bJscI.componentWithFG)('groot-1154-cjn-global-home', (0, $lHlwJ.CrossJoinNudges), ()=>null);
const $dfa1b1acb991d626$var$DeferRovoVideoModal = (0, $bJscI.componentWithFG)('rovo_video_player_gate', $dfa1b1acb991d626$export$3859d35c5447350b, ()=>null);
const $dfa1b1acb991d626$var$DeferTrialSprintBoardModal = (0, $bJscI.componentWithFG)('jsw-trial-sprint-board-modal-gate-v2', $dfa1b1acb991d626$export$39abefd31dfea2bd, ()=>null);
const $dfa1b1acb991d626$var$AsyncRecommendPremiumToStandardModal = (0, $bJscI.componentWithFG)('recommend_standard_in_jira_eot_shared_layout_', (0, $3Kq2h.AsyncRecommendPremiumToStandardModalWrapper), ()=>null);
const $dfa1b1acb991d626$var$ConditionalEndOfTrialExtensionModal = (0, $bJscI.componentWithFG)('end_of_trial_extension_kill_switch', $dfa1b1acb991d626$var$EndOfTrialModalEntryPoint, ()=>null);
$dfa1b1acb991d626$var$ConditionalCrossJoinNudge.displayName = 'ConditionalCrossJoinNudge';
$dfa1b1acb991d626$export$bb0d8fff645668ce.displayName = 'DeferEditionModal';
$dfa1b1acb991d626$var$DeferRovoVideoModal.displayName = 'DeferRovoVideoModal';
$dfa1b1acb991d626$var$DeferTrialSprintBoardModal.displayName = 'DeferTrialSprintBoardModal';
$dfa1b1acb991d626$var$AsyncRecommendPremiumToStandardModal.displayName = 'AsyncRecommendPremiumToStandardModal';
$dfa1b1acb991d626$var$ConditionalEndOfTrialExtensionModal.displayName = 'ConditionalEndOfTrialExtensionModal';
const $dfa1b1acb991d626$var$sharedGlobalComponents = [
    ...false ? [] : [
        (0, $86XkI.PriorityManager),
        (0, $e5yn1.MatchedRouteListener),
        (0, $38W5l.PreviousRouterStateListener),
        (0, $ajCkH.LoadingPhaseManager),
        (0, $28GDA.LoadingBarUIController),
        (0, $6XXs7.default),
        (0, $6Yzhs.BreadcrumbAdapter),
        (0, $6u6pq.default),
        (0, $imyEu.PageDwellAnalyticsListener),
        (0, $hWQJk.ImperativeAPI),
        (0, $7cv6Z.TrackClicksBeforeTTI),
        (0, $hMGR1.default),
        (0, $b4mGA.AsyncUpflowIframeComponent),
        (0, $bwRvc.JiraHeritageLoader),
        $dfa1b1acb991d626$var$AsyncBrowserStorageControlsInit,
        $dfa1b1acb991d626$var$ConditionalCrossJoinNudge,
        (0, $2HxHL.default),
        $dfa1b1acb991d626$var$RemoteActions,
        $dfa1b1acb991d626$export$bb0d8fff645668ce,
        $dfa1b1acb991d626$var$DeferRovoVideoModal,
        $dfa1b1acb991d626$var$DeferTrialSprintBoardModal,
        $dfa1b1acb991d626$var$AsyncRecommendPremiumToStandardModal,
        $dfa1b1acb991d626$var$ConditionalEndOfTrialExtensionModal,
        (0, $41vjk.AsyncSSRFailureDisplay),
        // Integrations - Issue View Modal, Create Project Drawer & Create dashboard modal
        (0, $jjTNC.Integrations)
    ],
    $dfa1b1acb991d626$var$Global,
    $dfa1b1acb991d626$var$Navigation,
    $dfa1b1acb991d626$var$Trackers,
    (0, $MBWwk.renderInBackgroundPriority)($dfa1b1acb991d626$var$AfterPaintIssuePreEval, ()=>!(0, $7jTnu.fg)('jfp_magma_delay_issue-view-pre-eval'))
];
const $dfa1b1acb991d626$var$SafeEmbeddedConfluencePanelWithExperiments = ()=>{
    const [expConfig] = (0, $epTsa.UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
    return expConfig.get('cohort', 'not-enrolled') === 'experiment' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cosWN.SafeEmbeddedConfluencePanel), null) : null;
};
const $dfa1b1acb991d626$var$SafeIssueRovoAiPanelFG = ()=>{
    return (0, $epTsa.expValEquals)('jira_ai_rovo_button', 'treatment', 'B', 'A') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a8idd.SafeRovoPanelSidebar), null) : null;
};
const $dfa1b1acb991d626$export$5f4dc7c98070d93e = (0, $6dwgv.createLayout)({
    rightSidebars: [
        (0, $aY5Xx.SafeHelpPanel),
        (0, $8R3rZ.SafeConversationAssistantPanel),
        $dfa1b1acb991d626$var$SafeEmbeddedConfluencePanelWithExperiments,
        $dfa1b1acb991d626$var$SafeIssueRovoAiPanelFG
    ],
    globalComponents: $dfa1b1acb991d626$var$sharedGlobalComponents
});

});
parcelRegister("6XXs7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c657447b4ed1c88b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8q7lT = parcelRequire("8q7lT");

var $6O0zm = parcelRequire("6O0zm");
const $c657447b4ed1c88b$var$CacheRegistry = ()=>{
    const accountIdLoggedInUser = (0, $8q7lT.useAccountId)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $6O0zm.default).set(accountIdLoggedInUser ?? 'anonymous');
    }, [
        accountIdLoggedInUser
    ]);
    return null;
};
var $c657447b4ed1c88b$export$2e2bcd8739ae039 = $c657447b4ed1c88b$var$CacheRegistry;

});
parcelRegister("6O0zm", function(module, exports) {

$parcel$export(module.exports, "CACHE_PREFIX", () => $24dcac986fde8d1b$export$69ca515e4489d790);
$parcel$export(module.exports, "scopeGuard", () => $24dcac986fde8d1b$export$653cd03438bb0386);
$parcel$export(module.exports, "default", () => $24dcac986fde8d1b$export$2e2bcd8739ae039);

var $dnU6V = parcelRequire("dnU6V");
let $24dcac986fde8d1b$var$resolveCachePromise;
const $24dcac986fde8d1b$var$cachePromise = new Promise((resolve)=>{
    $24dcac986fde8d1b$var$resolveCachePromise = resolve;
});
const $24dcac986fde8d1b$export$27be962d708928a = '__scope_key__';
const $24dcac986fde8d1b$export$69ca515e4489d790 = 'cache_prefix';
const $24dcac986fde8d1b$var$TIMEOUT = 10000;
const $24dcac986fde8d1b$var$promiseWithMaxExecutionTime = (ms, promise)=>{
    let id;
    const timeout = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        id = setTimeout(()=>{
            const storage = (0, $dnU6V.createLocalStorageProvider)($24dcac986fde8d1b$export$69ca515e4489d790);
            storage.clearAll();
            reject(new Error(`Cache scope was not set within ${$24dcac986fde8d1b$var$TIMEOUT}ms`));
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then((result)=>{
        clearTimeout(id);
        return result;
    });
};
const $24dcac986fde8d1b$export$653cd03438bb0386 = ()=>$24dcac986fde8d1b$var$promiseWithMaxExecutionTime($24dcac986fde8d1b$var$TIMEOUT, $24dcac986fde8d1b$var$cachePromise);
const $24dcac986fde8d1b$var$config = {
    devTools: false,
    scopes: {
        prev: null,
        current: null
    },
    set (scopeKey) {
        const storage = (0, $dnU6V.createLocalStorageProvider)($24dcac986fde8d1b$export$69ca515e4489d790);
        const scopeKeyInStorage = storage.get($24dcac986fde8d1b$export$27be962d708928a);
        // init value
        if (this.scopes.prev === null && this.scopes.current === null) {
            if (scopeKeyInStorage) {
                // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
                this.scopes.prev = scopeKeyInStorage;
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scopes.current = scopeKeyInStorage;
            }
        }
        // same account id
        if (this.scopes.current !== scopeKey) {
            // diffrent account id
            if (this.scopes.current !== null) // scope has changed during session
            storage.clearAll();
            // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
            this.scopes.prev = this.scopes.current;
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.scopes.current = scopeKey;
            storage.set($24dcac986fde8d1b$export$27be962d708928a, scopeKey);
        }
        // @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
        $24dcac986fde8d1b$var$resolveCachePromise();
    },
    get () {
        return this.scopes.current;
    }
};
var $24dcac986fde8d1b$export$2e2bcd8739ae039 = $24dcac986fde8d1b$var$config;

});


parcelRegister("8R3rZ", function(module, exports) {

$parcel$export(module.exports, "SafeConversationAssistantPanel", () => $3cc317a76d5032d1$export$453401d0b697d2db);

var $eJOHy = parcelRequire("eJOHy");

var $gn32L = parcelRequire("gn32L");

var $6CCPu = parcelRequire("6CCPu");


var $1KdDN = parcelRequire("1KdDN");

var $dfP3D = parcelRequire("dfP3D");

var $f1Zdy = parcelRequire("f1Zdy");

var $6zXPf = parcelRequire("6zXPf");

var $lRq8t = parcelRequire("lRq8t");

var $3S9KP = parcelRequire("3S9KP");

var $8xKig = parcelRequire("8xKig");
const $3cc317a76d5032d1$var$PanelInLayout = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $eJOHy.useState)();
    const prevPanelIdRef = (0, $eJOHy.useRef)();
    const delayRef = (0, $eJOHy.useRef)(null);
    const { closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const panelId = rightSidebarCurrentState?.panelId;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const handleResizeComplete = (0, $eJOHy.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'aiMatePanel',
            tags: [
                'atlaskit',
                'aiMate'
            ]
        }).fire((0, $gn32L.FabricChannel).aiMate);
    }, [
        createAnalyticsEvent
    ]);
    /**
   * This use effect is used to add (when is necessary) a delay
   * in the panelId => localPanelId syncing
   */ (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $e65eaf0201568b8c$export$dffb4ed44e20ea9a)) {
            /**
       * The right-sidebar is showing the conversation assistant...
       */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
         * and is open, not collapsed and we want to show a panel
         * with an ID !== CONVERSATION_ASSISTANT_CONTAINER_ID
         */ setLocalPanelId(panelId);
            else /**
         * and we want to close it
         */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
                createAnalyticsEvent({
                    action: 'closed',
                    actionSubject: 'aiMatePanel',
                    source: 'AIMate',
                    tags: [
                        'atlaskit',
                        'aiMate'
                    ]
                }).fire((0, $gn32L.FabricChannel).aiMate);
            }, 310);
        } else /**
       * If the right sidebar is not showing the conversation assistant,
       * we just keep localPanelId in sync with panelId
       */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        createAnalyticsEvent,
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $e65eaf0201568b8c$export$dffb4ed44e20ea9a)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $6zXPf.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6CCPu.PanelSplitter), {
        label: formatMessage((0, $8xKig.default).panelSplitter),
        onResizeEnd: handleResizeComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3S9KP.JiraConversationAssistant), {
        onClosePanel: closeCurrentRightSidebar
    }));
};
const $3cc317a76d5032d1$export$453401d0b697d2db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-conversation-assistant-panel",
        packageName: "jiraConversationAssistant"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3cc317a76d5032d1$var$PanelInLayout, null));

});
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $e65eaf0201568b8c$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $e65eaf0201568b8c$export$64aee74ba59709e5 = 439; // px
const $e65eaf0201568b8c$export$1c07393c5bb1bc27 = 439; // px
const $e65eaf0201568b8c$export$aa3478deee7adbeb = 350; // px
const $e65eaf0201568b8c$export$21e515a86cd1733b = 'Chat';

parcelRegister("3S9KP", function(module, exports) {

$parcel$export(module.exports, "JiraConversationAssistant", () => $63db3c7564c5518e$export$da8473714271a41d);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $73hW5 = parcelRequire("73hW5");
var $l2krx = parcelRequire("l2krx");


var $7jTnu = parcelRequire("7jTnu");

var $hWeHP = parcelRequire("hWeHP");

var $dfP3D = parcelRequire("dfP3D");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $g9Vr6 = parcelRequire("g9Vr6");

var $4ihOZ = parcelRequire("4ihOZ");

var $kEUB1 = parcelRequire("kEUB1");

var $6zXPf = parcelRequire("6zXPf");
const $63db3c7564c5518e$var$SYNTHETIC_HEADER = 'x-issynthetic-traffic';
const $63db3c7564c5518e$export$da8473714271a41d = ({ onClosePanel: onClosePanel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const activationId = (0, $4ihOZ.useActivationId)();
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const isNav4Enabled = (0, $6zXPf.getWillShowNav4)();
    const isSyntheticTenant = (0, $hWeHP.default)('ajs-is-synthetic') === 'true' || (0, $7jTnu.fg)('is_synthetic_tenant');
    const config = (0, $eJOHy.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            activationId: activationId,
            product: 'jira',
            orgId: orgId,
            experienceId: 'ai-mate',
            assistanceServiceConfig: {
                // TODO: type `AssistanceServiceConfig` should be decoupled from headers to prevent the need for other required keys which shouldn't need to be defined here (`product` and `experienceId`)
                headers: isSyntheticTenant ? {
                    [$63db3c7564c5518e$var$SYNTHETIC_HEADER]: String(isSyntheticTenant)
                } : {},
                // Rename to `urlPrefix` in the package; baseUrl is a deprecated concept
                baseUrl: '/gateway/api/assist'
            }
        }), [
        cloudId,
        activationId,
        orgId,
        isSyntheticTenant
    ]);
    const handleResizeComplete = (0, $eJOHy.useCallback)((width)=>{
        openRightSidebar((0, $e65eaf0201568b8c$export$dffb4ed44e20ea9a), width);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'aiMatePanel'
        }));
    }, [
        openRightSidebar,
        createAnalyticsEvent
    ]);
    // ROVOFE-76 - No resize wrapper for nav4 as it uses PanelSplitter now
    if (isNav4Enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $63db3c7564c5518e$var$conversationAssistantWrapperNav4Styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $73hW5.default), {
        testId: "conversation-assistant.ui.conversation-assistant",
        onCloseChat: onClosePanel,
        config: config,
        isNav4Enabled: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l2krx.ResizeWrapper), {
        onResizeComplete: handleResizeComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $63db3c7564c5518e$var$conversationAssistantWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $73hW5.default), {
        testId: "conversation-assistant.ui.conversation-assistant",
        onCloseChat: onClosePanel,
        config: config
    })));
};
const $63db3c7564c5518e$var$conversationAssistantWrapperStyles = (0, $5Wv5g.xcss)({
    width: '100%'
});
const $63db3c7564c5518e$var$conversationAssistantWrapperNav4Styles = (0, $5Wv5g.xcss)({
    width: '100%',
    height: '100%'
});

});
parcelRegister("73hW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c16aa6c4048bae$export$2e2bcd8739ae039);

var $joSn0 = parcelRequire("joSn0");

var $h1VbR = parcelRequire("h1VbR");
const $35c16aa6c4048bae$var$createLoadingComponent = ()=>{
    return (0, $h1VbR.default)({
        name: 'LoadingConversationAssistantBundle'
    });
};

var $35c16aa6c4048bae$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("5ybyg")).then((m)=>m.default || m),
    loading: $35c16aa6c4048bae$var$createLoadingComponent
});

});
parcelRegister("joSn0", function(module, exports) {
"use strict";
var $e1fa6eff9b7fbc13$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $e1fa6eff9b7fbc13$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e1fa6eff9b7fbc13$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e1fa6eff9b7fbc13$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $eJOHy = parcelRequire("eJOHy");

var $cT3Ey = parcelRequire("cT3Ey");
var $e1fa6eff9b7fbc13$var$ALL_INITIALIZERS = [];
var $e1fa6eff9b7fbc13$var$READY_INITIALIZERS = [];
function $e1fa6eff9b7fbc13$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $e1fa6eff9b7fbc13$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $e1fa6eff9b7fbc13$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $e1fa6eff9b7fbc13$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $e1fa6eff9b7fbc13$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $e1fa6eff9b7fbc13$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $e1fa6eff9b7fbc13$var$render(loaded, props) {
    return $eJOHy.createElement($e1fa6eff9b7fbc13$var$resolve(loaded), props);
}
function $e1fa6eff9b7fbc13$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $e1fa6eff9b7fbc13$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $e1fa6eff9b7fbc13$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $e1fa6eff9b7fbc13$var$READY_INITIALIZERS.push(function() {
        if ($e1fa6eff9b7fbc13$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $e1fa6eff9b7fbc13$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $e1fa6eff9b7fbc13$var$_classCallCheck(this, LoadableComponent);
            var _this = $e1fa6eff9b7fbc13$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $eJOHy.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($eJOHy.Component), _class.contextTypes = {
        loadable: $cT3Ey.shape({
            report: $cT3Ey.func.isRequired
        })
    }, _temp;
}
function $e1fa6eff9b7fbc13$var$Loadable(opts) {
    return $e1fa6eff9b7fbc13$var$createLoadableComponent($e1fa6eff9b7fbc13$var$load, opts);
}
function $e1fa6eff9b7fbc13$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $e1fa6eff9b7fbc13$var$createLoadableComponent($e1fa6eff9b7fbc13$var$loadMap, opts);
}
$e1fa6eff9b7fbc13$var$Loadable.Map = $e1fa6eff9b7fbc13$var$LoadableMap;
var $e1fa6eff9b7fbc13$var$Capture = function(_React$Component2) {
    $e1fa6eff9b7fbc13$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $e1fa6eff9b7fbc13$var$_classCallCheck(this, Capture);
        return $e1fa6eff9b7fbc13$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $eJOHy.Children.only(this.props.children);
    };
    return Capture;
}($eJOHy.Component);
$e1fa6eff9b7fbc13$var$Capture.propTypes = {
    report: $cT3Ey.func.isRequired
};
$e1fa6eff9b7fbc13$var$Capture.childContextTypes = {
    loadable: $cT3Ey.shape({
        report: $cT3Ey.func.isRequired
    }).isRequired
};
$e1fa6eff9b7fbc13$var$Loadable.Capture = $e1fa6eff9b7fbc13$var$Capture;
function $e1fa6eff9b7fbc13$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $e1fa6eff9b7fbc13$var$flushInitializers(initializers);
    });
}
$e1fa6eff9b7fbc13$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $e1fa6eff9b7fbc13$var$flushInitializers($e1fa6eff9b7fbc13$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$e1fa6eff9b7fbc13$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $e1fa6eff9b7fbc13$var$flushInitializers($e1fa6eff9b7fbc13$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $e1fa6eff9b7fbc13$var$Loadable;

});

parcelRegister("5ybyg", function(module, exports) {

let $40a916a958c36149$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $40a916a958c36149$var$load("k4gbU"),
    $40a916a958c36149$var$load("eDzss"),
    $40a916a958c36149$var$load("1VRB2"),
    $40a916a958c36149$var$load("bABhq"),
    $40a916a958c36149$var$load("7vqGd"),
    $40a916a958c36149$var$load("1Y4bq"),
    $40a916a958c36149$var$load("dskPi")
]).then(()=>parcelRequire('g8QJP'));

});


parcelRegister("l2krx", function(module, exports) {

$parcel$export(module.exports, "ResizeWrapper", () => $f6c1af82025a3bec$export$c7990a6594835e51);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4eDgu = parcelRequire("4eDgu");

const $f6c1af82025a3bec$var$styles = {
    root: "_1xi2ze3t _1e0c1txw _kqsw1n9t _4t3i1i8v",
    handle: "_v564jkaz _1kl7j1ic _80omuf7j _uiztglyw _kqswstnw _154ipxbi _94n5ze3t _1ltvze3t _1bsb1tcg _13lipd34 _1jvv1bty",
    handleSpacer: "_1bsb1tcg _kqswstnw _1e0c1ule _1ltv2bgk _154ize3t _94n5ze3t"
};
const $f6c1af82025a3bec$export$c7990a6594835e51 = ({ children: children, onResizeComplete: onResizeComplete, initialWidth: initialWidth = (0, $e65eaf0201568b8c$export$64aee74ba59709e5), minWidth: minWidth = (0, $e65eaf0201568b8c$export$64aee74ba59709e5), maxWidth: maxWidth = '50vw' })=>{
    const [width, setWidth] = (0, $eJOHy.useState)(initialWidth);
    const wrapperRef = (0, $eJOHy.useRef)(null);
    const isDraggingRef = (0, $eJOHy.useRef)(false);
    const initialMousePositionRef = (0, $eJOHy.useRef)(0);
    const prevDistanceMovedRef = (0, $eJOHy.useRef)(0);
    const rafRef = (0, $eJOHy.useRef)(null);
    const getWrapperWidth = ()=>{
        return wrapperRef.current?.getBoundingClientRect()?.width || 0;
    };
    const handleMouseMove = (0, $eJOHy.useCallback)((event)=>{
        if (!isDraggingRef.current) return;
        const distanceMoved = event.clientX - initialMousePositionRef.current;
        let updatedWidth;
        const currentWidth = getWrapperWidth();
        // Ignore events without change
        if (distanceMoved === prevDistanceMovedRef.current || distanceMoved === 0) return;
        // Acknowledge latest direction adjustment
        prevDistanceMovedRef.current = distanceMoved;
        // Clear queued animation frame
        if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
        rafRef.current = requestAnimationFrame(()=>{
            // Update widths with upper and lower limits respected when `minWidth` and `maxWidth` are `number`
            // When `string`, we'll respect this value on the styles of the wrapper for use-cases such as '100%', '70vw' etc.
            if (distanceMoved < 0) {
                updatedWidth = currentWidth + Math.abs(distanceMoved);
                if (typeof maxWidth === 'number' && !isNaN(maxWidth)) updatedWidth = Math.min(updatedWidth, maxWidth);
            } else {
                updatedWidth = currentWidth - distanceMoved;
                if (typeof minWidth === 'number' && !isNaN(minWidth)) updatedWidth = Math.max(updatedWidth, minWidth);
            }
            setWidth(updatedWidth);
            initialMousePositionRef.current = event.clientX;
        });
    }, [
        maxWidth,
        minWidth
    ]);
    const handleMouseDown = (0, $eJOHy.useCallback)((event)=>{
        // Indicate dragging
        isDraggingRef.current = true;
        // Indicate starting point
        initialMousePositionRef.current = event.clientX;
    }, []);
    const handleMouseUp = (0, $eJOHy.useCallback)(()=>{
        if (isDraggingRef.current && onResizeComplete) onResizeComplete(wrapperRef.current?.getBoundingClientRect().width || width);
        isDraggingRef.current = false;
    }, [
        onResizeComplete,
        width
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const mouseMoveHandler = (0, $4eDgu.bind)(window, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        const mouseUpHandler = (0, $4eDgu.bind)(window, {
            type: 'mouseup',
            listener: handleMouseUp
        });
        return ()=>{
            mouseMoveHandler();
            mouseUpHandler();
            if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
        };
    }, [
        handleMouseMove,
        handleMouseUp
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ref: wrapperRef,
        role: "presentation",
        "data-testid": "panel-resize-wrapper",
        style: {
            width: width,
            maxWidth: maxWidth,
            minWidth: minWidth
        },
        className: (0, $hcewu.default)([
            $f6c1af82025a3bec$var$styles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                "data-testid": "panel-resize-handle",
                onMouseDown: handleMouseDown,
                className: (0, $hcewu.default)([
                    $f6c1af82025a3bec$var$styles.handle
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f6c1af82025a3bec$var$styles.handleSpacer
                    ])
                })
            }),
            children
        ]
    });
};

});


parcelRegister("8xKig", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b781c538b551238$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7b781c538b551238$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    panelSplitter: {
        "id": "platform-conversation-assistant.panelSplitter.label",
        "defaultMessage": "Resize panel"
    }
});

});


parcelRegister("71DNl", function(module, exports) {

$parcel$export(module.exports, "AsyncDeferEditionEPCheckWrapper", () => $bbc5703f5246e31a$export$4fa5b26bccc7e3df);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $5kYyR = parcelRequire("5kYyR");

var $gzcjr = parcelRequire("gzcjr");


// We are using an async here in addition to the jiraDeferEditionModalEntryPoint in ./entrypoint.tsx since
// we want to avoid unnecessarily preloading the expensive graphql query on each page load. Instead
// we load an async component that checks engagement-platform first if we are to show the modal or not.
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $bbc5703f5246e31a$var$AsyncDeferEditionEPCheck = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("6kley")).then(({ EPCheck: EPCheck })=>EPCheck), {
    ssr: false,
    moduleId: "./src/packages/growth/defer-edition-modal/src/EPCheck.tsx"
});
const $bbc5703f5246e31a$export$4fa5b26bccc7e3df = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "defer-edition-ep-check-async",
        packageName: (0, $94ac5b9dc076858e$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        teamName: (0, $94ac5b9dc076858e$export$d57b6b390e78d90f),
        id: "defer-edition-ep-check-async",
        packageName: (0, $94ac5b9dc076858e$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bbc5703f5246e31a$var$AsyncDeferEditionEPCheck, props)));

});
const $94ac5b9dc076858e$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $94ac5b9dc076858e$export$d57b6b390e78d90f = 'transmuters-growth';
const $94ac5b9dc076858e$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $94ac5b9dc076858e$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $94ac5b9dc076858e$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $94ac5b9dc076858e$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $94ac5b9dc076858e$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $94ac5b9dc076858e$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $94ac5b9dc076858e$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $94ac5b9dc076858e$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';
const $94ac5b9dc076858e$export$d62ac9eaaf8c4436 = 'COLLECTION';

parcelRegister("6kley", function(module, exports) {

let $49b514e65f857a47$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $49b514e65f857a47$var$load("h0xE5").then(()=>parcelRequire('lstlq'));

});


parcelRegister("56K43", function(module, exports) {

$parcel$export(module.exports, "jiraDeferEditionModalEntryPoint", () => $89b0b4353885eda5$export$51f384a783f47807);

var $2sxuZ = parcelRequire("2sxuZ");

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $89b0b4353885eda5$export$51f384a783f47807 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(async ()=>(parcelRequire("jQYR9")).then(({ DeferEditionModalComponent: DeferEditionModalComponent })=>DeferEditionModalComponent), {
        moduleId: "fe342c6b",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey, isCollectionEnabled: isCollectionEnabled })=>({
            queries: {
                deferEditionModal: {
                    parameters: (0, $2sxuZ.default),
                    variables: {
                        cloudId: cloudId,
                        productKey: productKey,
                        isCollectionEnabled: isCollectionEnabled
                    }
                }
            }
        })
});

});
parcelRegister("2sxuZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c3fcab19c9d85b8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b8237d9ade119c89ec60d5df73a7b79>>
 * @relayHash 314dcaae70a91a8c2aec9b2c04dbb828
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29c7a3076bb6bd5678012e8694b3490becab3269842600c69ef20ab8ad2ecaea
const $0c3fcab19c9d85b8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "29c7a3076bb6bd5678012e8694b3490becab3269842600c69ef20ab8ad2ecaea",
        "metadata": {},
        "name": "src_DeferEditionModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0c3fcab19c9d85b8$export$2e2bcd8739ae039 = $0c3fcab19c9d85b8$var$node;

});

parcelRegister("jQYR9", function(module, exports) {

let $e742147051e3e034$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e742147051e3e034$var$load("8c39O").then(()=>parcelRequire('9oxFb'));

});


parcelRegister("cKuba", function(module, exports) {

$parcel$export(module.exports, "endOfTrialExtensionEntryPoint", () => $6e2b158e89dfab56$export$dd41abc64eb3ea80);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $6e2b158e89dfab56$export$dd41abc64eb3ea80 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("kaOtR")), {
        moduleId: "13487943",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kaOtR", function(module, exports) {

let $eafbe6362326ccfa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $eafbe6362326ccfa$var$load("lx2bO").then(()=>parcelRequire('2Wlt9'));

});


parcelRegister("86XkI", function(module, exports) {

$parcel$export(module.exports, "useCurrentPriority", () => $fa905a6dfa088034$export$ea2f0151c2177b4c);
$parcel$export(module.exports, "loadingPriority", () => $fa905a6dfa088034$export$9d1e6d89fa244199);
$parcel$export(module.exports, "PriorityManager", () => $fa905a6dfa088034$export$7099b16a7996ef6c);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $9XYcy = parcelRequire("9XYcy");
const $fa905a6dfa088034$var$store = (0, $GtRbT.createStore)({
    name: 'priority-manager',
    initialState: {
        tier: 1
    },
    actions: {
        setTier: (tier)=>({ setState: setState, getState: getState })=>setState({
                    tier: Math.max(getState().tier, tier)
                })
    }
});
const $fa905a6dfa088034$export$5761757a15d758a = (0, $iJq0l.createActionsHook)($fa905a6dfa088034$var$store);
const $fa905a6dfa088034$export$ea2f0151c2177b4c = (0, $iJq0l.createStateHook)($fa905a6dfa088034$var$store, {
    selector: (state)=>state.tier
});
// allow max 5 seconds between tier 2(app ready) and tier 3(work is done)
const $fa905a6dfa088034$var$MAX_TIME_IN_TIER_2 = 5000;
const $fa905a6dfa088034$export$9d1e6d89fa244199 = {
    // tier 0 - "early scripts" is outside of this component reach and responsibility
    /**
	 * Tier 1 - initial loading phase, everything is critical
	 */ critical: 1,
    /**
	 * Tier 2 - app is ready, but some work is still in progress
	 * This is the phase where we can start loading non-critical resources
	 */ nonCritical: 2,
    /**
	 * Tier 3 - background phase, all work is done, we can load background resources
	 * This is the phase where we can start loading background resources
	 */ background: 3
};
function $fa905a6dfa088034$export$7099b16a7996ef6c() {
    const [{ isReady: isReady }] = (0, $9XYcy.useSpaStatePageReady)();
    const { setTier: setTier } = $fa905a6dfa088034$export$5761757a15d758a();
    (0, $eJOHy.useEffect)(()=>{
        if (isReady) {
            performance.mark('priority:non-critical-phase');
            setTier($fa905a6dfa088034$export$9d1e6d89fa244199.nonCritical);
            // ensure we are advancing in no later than MAX_TIME_IN_TIER_2
            const tm = setTimeout(()=>setTier($fa905a6dfa088034$export$9d1e6d89fa244199.background), $fa905a6dfa088034$var$MAX_TIME_IN_TIER_2);
            return ()=>{
                clearTimeout(tm);
            };
        }
    }, [
        isReady,
        setTier
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            const onPageReady = ()=>{
                performance.mark('priority:background-phase');
                setTier($fa905a6dfa088034$export$9d1e6d89fa244199.background);
            };
            window.addEventListener('UFO_FINISH_INTERACTION', onPageReady);
            return ()=>{
                window.removeEventListener('UFO_FINISH_INTERACTION', onPageReady);
            };
        }
    }, [
        setTier
    ]);
    return null;
}

});

parcelRegister("MBWwk", function(module, exports) {

$parcel$export(module.exports, "BackgroundPriority", () => $728e2a9794674636$export$ae957da140356154);
$parcel$export(module.exports, "renderInBackgroundPriority", () => $728e2a9794674636$export$92ab163f92594a98);

var $eJOHy = parcelRequire("eJOHy");

var $86XkI = parcelRequire("86XkI");
const $728e2a9794674636$export$ae957da140356154 = ({ children: children, forceRender: forceRender })=>{
    const tier = (0, $86XkI.useCurrentPriority)();
    if (!forceRender && tier < (0, $86XkI.loadingPriority).background) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $728e2a9794674636$export$92ab163f92594a98 = (Component, bypassCondition)=>{
    const wrappedComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($728e2a9794674636$export$ae957da140356154, {
            forceRender: bypassCondition ? bypassCondition() : false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, null));
    wrappedComponent.displayName = `BackgroundPriority(${Component.displayName || Component.name})`;
    return wrappedComponent;
};

});

parcelRegister("28GDA", function(module, exports) {

$parcel$export(module.exports, "LoadingBarUIController", () => $73dce8556544b0ee$export$39bdf67fc71ce8c8);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $fqbMu = parcelRequire("fqbMu");

var $jEvkf = parcelRequire("jEvkf");

var $iIqWW = parcelRequire("iIqWW");

var $gCY1z = parcelRequire("gCY1z");

var $1fv87 = parcelRequire("1fv87");

var $2G3oS = parcelRequire("2G3oS");
const $73dce8556544b0ee$export$54128ad8de32b897 = ({ startLoading: startLoading, resetLoading: resetLoading, finishLoading: finishLoading })=>{
    const [loadedState] = (0, $jEvkf.default)();
    (0, $eJOHy.useEffect)(()=>{
        startLoading();
        return ()=>{
            resetLoading();
        };
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (loadedState.hasLoaded) finishLoading();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
/**
 * Sets up the loading bar stylesheet and controller purely in the client
 * This is a fallback if SSR fails
 *
 */ const $73dce8556544b0ee$var$LoadingBarUI = ({ shouldRender: shouldRender, routeIdentifier: routeIdentifier })=>{
    const [actions, setActions] = (0, $eJOHy.useState)({});
    const sheetRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLStyleElement | null'.
        const loadingBarActions = (0, $fqbMu.createLoadingBarActionController)(sheetRef.current);
        setActions(loadingBarActions || {});
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLStyleElement> | undefined'.
        ref: sheetRef,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    ${(0, $1fv87.LOADER_STYLES_CSS_SELECTOR)} {
                        ${(0, $2G3oS.generateLoadingBarStyles)(0, (0, $1fv87.getLoadingBarColor)())}
                    }
                `
        }
    }), shouldRender && actions.START && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73dce8556544b0ee$export$54128ad8de32b897, {
        key: routeIdentifier,
        // @ts-expect-error - TS2339 - Property 'START' does not exist on type '{}'.
        startLoading: actions.START,
        // @ts-expect-error - TS2339 - Property 'RESET' does not exist on type '{}'.
        resetLoading: actions.RESET,
        // @ts-expect-error - TS2339 - Property 'FINISH' does not exist on type '{}'.
        finishLoading: actions.FINISH
    }));
};
const $73dce8556544b0ee$export$e068deb20d61b035 = ()=>{
    let currentTransitionsCount = 0;
    let currentRouteIdentifier = '';
    let currentRouteMatch = '';
    let hasTransitioned = false;
    let key = 0;
    return (transitionsCount, routeIdentifier, routeMatch)=>{
        if (transitionsCount !== currentTransitionsCount) {
            currentTransitionsCount = transitionsCount;
            hasTransitioned = true;
        }
        if (routeIdentifier !== null && routeIdentifier !== currentRouteIdentifier || routeIdentifier === currentRouteIdentifier && routeMatch !== currentRouteMatch) {
            currentRouteIdentifier = routeIdentifier;
            currentRouteMatch = routeMatch;
            if (hasTransitioned) {
                hasTransitioned = false;
                key = currentTransitionsCount;
            }
        }
        return key;
    };
};
const $73dce8556544b0ee$var$getUniqueTransitionKey = $73dce8556544b0ee$export$e068deb20d61b035();
/**
 * Determines if the <LoadingBarController> should render or re-render
 * Injects dependencies into <LoadingBarController />
 *
 */ const $73dce8556544b0ee$export$39bdf67fc71ce8c8 = ()=>{
    const [routerState] = (0, $gCY1z.useRouter)();
    const [{ transitionsCount: transitionsCount }] = (0, $iIqWW.useSpaStateTransition)();
    const currentRoute = routerState.route && routerState.route.name;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const loaderFailedInSSR = !window.JIRA_LOADING_BAR;
    const shouldRender = (0, $1fv87.getAllowedRoutes)().includes(currentRoute);
    // we generate a unique route identifier each time a transition happens
    // we use this key to force re-render of the <LoadingBarController />
    const routeIdentifier = (0, $eJOHy.useMemo)(()=>$73dce8556544b0ee$var$getUniqueTransitionKey(transitionsCount, currentRoute, JSON.stringify(routerState.match)), [
        transitionsCount,
        currentRoute,
        routerState.match
    ]);
    // We always expect the loading bar to be initialised in SSR for any route in ALLOWED_ROUTES
    // If this doesn't happen, it means SSR failed or the loading bar code in SSR failed
    (0, $eJOHy.useEffect)(()=>{
        if (shouldRender && loaderFailedInSSR) (0, $eSnSE.default).safeWarnWithoutCustomerData('global-loading-bar', 'Loading bar failed to initialise in SSR. This may be because SSR failed or a bug in the loading bar code.');
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loaderFailedInSSR
    ]);
    // If the loading bar fails to setup in SSR, we set up the action controller AND stylesheet in the client
    // We also do this if SSR renders a page that does not have the loading bar enabled (eg !shouldRender)
    if (loaderFailedInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73dce8556544b0ee$var$LoadingBarUI, {
        shouldRender: shouldRender,
        routeIdentifier: routeIdentifier
    });
    // if the loading bar is succesfully setup in SSR, all the client needs to do is dispatch loading actions
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (shouldRender && window.JIRA_LOADING_BAR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73dce8556544b0ee$export$54128ad8de32b897, {
        key: routeIdentifier,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        startLoading: window.JIRA_LOADING_BAR.START,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        resetLoading: window.JIRA_LOADING_BAR.RESET,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        finishLoading: window.JIRA_LOADING_BAR.FINISH
    });
    return null;
};

});
parcelRegister("fqbMu", function(module, exports) {

$parcel$export(module.exports, "createLoadingBarActionController", () => $dcb56f90df5e9022$export$55d67d61d9d2ad3b);
// BE VERY CAREFUL IMPORTING ANY PACKAGES IN THIS FILE
// THIS CODE IS AN INLINE FRAGMENT AND RUNS BEFORE POLYFILLS AND MAY BREAK IE

var $aKnYw = parcelRequire("aKnYw");
const $dcb56f90df5e9022$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
const $dcb56f90df5e9022$export$899393f3e23f724b = 15000;
const $dcb56f90df5e9022$export$7868b416d8929c55 = 40000;
const $dcb56f90df5e9022$var$LOADER_STYLES_CSS_SELECTOR = 'body::before';
const $dcb56f90df5e9022$var$EXIT_ANIMATION_SPEED = 300;
const $dcb56f90df5e9022$export$99d4e8974a739853 = ()=>(0, $aKnYw.getMeta)('ajs-lf-navigation-highlightcolour') || $dcb56f90df5e9022$export$53d51cc6d57e44da;
const $dcb56f90df5e9022$export$4fb8742b05de9693 = (duration)=>`
    ${$dcb56f90df5e9022$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0.99);
        transition-duration: ${duration}ms;
        transition-timing-function: cubic-bezier(0,1,0.5,1);
    }
`;
const $dcb56f90df5e9022$export$5a43e0f09174e553 = ()=>`
    ${$dcb56f90df5e9022$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(1);
        transition-duration: ${$dcb56f90df5e9022$var$EXIT_ANIMATION_SPEED}ms;
        animation: none;
        background-image: none;
    }
`;
const $dcb56f90df5e9022$export$6beef8c645a63156 = ()=>`
    ${$dcb56f90df5e9022$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0);
        transition-duration: 0ms;
        animation: none;
        background-image: none;
    }
`;
const $dcb56f90df5e9022$export$610cb442736abf53 = ()=>`
    @keyframes shimmer {
        from {
            left: -80%;
            width: 80%;
        }

        to {
            left: 110%;
            width: 10%;
        }
    }
`;
const $dcb56f90df5e9022$export$959e9e99fba397f1 = (loadingBarColor)=>`
        ${$dcb56f90df5e9022$var$LOADER_STYLES_CSS_SELECTOR} {
            transform: scaleX(1);
            transition-duration: 0ms;
            background: ${loadingBarColor};
            animation: shimmer 2s infinite;
        }
    `;
const $dcb56f90df5e9022$var$browserFocusCheck = (action)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document && document.hidden) action();
    else requestAnimationFrame(()=>{
        action();
    });
};
const $dcb56f90df5e9022$export$55d67d61d9d2ad3b = (stylesheet)=>{
    const { sheet: sheet } = stylesheet || {};
    if (!sheet) return undefined;
    let isRunning = false;
    let isDelayed = false;
    let exitAnimationTimer;
    let delayedAnimationTimer;
    let timeoutTimer;
    return {
        START: (duration = $dcb56f90df5e9022$export$899393f3e23f724b)=>{
            if (isRunning) return;
            isRunning = true;
            // requestAnimationFrame will not run until the browser tab is focused
            // if a user opens a new tab the start animation will not begin until the tab is focused
            // this can cause the loading bar css to be applied in the incorrect order
            // to solve this we remove requestAnimationFrame if the tab is not focused
            $dcb56f90df5e9022$var$browserFocusCheck(()=>{
                sheet.insertRule($dcb56f90df5e9022$export$4fb8742b05de9693(duration), sheet.cssRules.length);
            });
            // Set a new delayed animation if loader hasn't finished after `${duration}` ms
            delayedAnimationTimer = setTimeout(()=>{
                if (!isRunning) return;
                isDelayed = true;
                $dcb56f90df5e9022$var$browserFocusCheck(()=>{
                    sheet.insertRule($dcb56f90df5e9022$export$610cb442736abf53(), sheet.cssRules.length);
                    sheet.insertRule($dcb56f90df5e9022$export$959e9e99fba397f1($dcb56f90df5e9022$export$99d4e8974a739853()), sheet.cssRules.length);
                });
            }, $dcb56f90df5e9022$export$899393f3e23f724b);
            // Remove the loader if it hasn't finished after `${TIMEOUT_TIMER}` ms
            timeoutTimer = setTimeout(()=>{
                if (!isRunning) return;
                isRunning = false;
                isDelayed = false;
                $dcb56f90df5e9022$var$browserFocusCheck(()=>{
                    sheet.insertRule($dcb56f90df5e9022$export$6beef8c645a63156(), sheet.cssRules.length);
                });
                clearTimeout(exitAnimationTimer);
                clearTimeout(delayedAnimationTimer);
                clearTimeout(timeoutTimer);
            }, $dcb56f90df5e9022$export$7868b416d8929c55);
        },
        FINISH: ()=>{
            if (!isRunning) return;
            isRunning = false;
            if (isDelayed) {
                isDelayed = false;
                clearTimeout(exitAnimationTimer);
                clearTimeout(timeoutTimer);
                clearTimeout(delayedAnimationTimer);
                $dcb56f90df5e9022$var$browserFocusCheck(()=>{
                    sheet.insertRule($dcb56f90df5e9022$export$6beef8c645a63156(), sheet.cssRules.length);
                });
                return;
            }
            $dcb56f90df5e9022$var$browserFocusCheck(()=>{
                sheet.insertRule($dcb56f90df5e9022$export$5a43e0f09174e553(), sheet.cssRules.length);
            });
            exitAnimationTimer = setTimeout(()=>{
                clearTimeout(exitAnimationTimer);
                clearTimeout(timeoutTimer);
                clearTimeout(delayedAnimationTimer);
                $dcb56f90df5e9022$var$browserFocusCheck(()=>{
                    sheet.insertRule($dcb56f90df5e9022$export$6beef8c645a63156(), sheet.cssRules.length);
                });
            }, $dcb56f90df5e9022$var$EXIT_ANIMATION_SPEED + 500);
        },
        RESET: ()=>{
            isRunning = false;
            isDelayed = false;
            clearTimeout(exitAnimationTimer);
            clearTimeout(delayedAnimationTimer);
            clearTimeout(timeoutTimer);
            $dcb56f90df5e9022$var$browserFocusCheck(()=>{
                sheet.insertRule($dcb56f90df5e9022$export$6beef8c645a63156(), sheet.cssRules.length);
            });
        }
    };
};
const $dcb56f90df5e9022$var$setupLoadingBarActionController = ()=>{
    const LOADER_STYLESHEET_ID = 'loaderStylesheet';
    // @ts-expect-error - TS2322 - Type 'HTMLElement | null' is not assignable to type 'HTMLStyleElement | null'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const styleSheet = document.getElementById(LOADER_STYLESHEET_ID);
    // SSR will not attach the stylesheet for routes not included in ALLOWED_ROUTES
    if (!styleSheet || !styleSheet.sheet) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JIRA_LOADING_BAR = $dcb56f90df5e9022$export$55d67d61d9d2ad3b(styleSheet);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JIRA_LOADING_BAR && window.JIRA_LOADING_BAR.START) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JIRA_LOADING_BAR.START();
};
$dcb56f90df5e9022$var$setupLoadingBarActionController();

});
parcelRegister("aKnYw", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $da448b1af413b2fc$export$c47913ca32a5c6f7);
const $da448b1af413b2fc$export$c47913ca32a5c6f7 = (name)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const node = document.querySelector(`meta[name="${name}"]`);
    const metaValue = node && node.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
};

});


parcelRegister("1fv87", function(module, exports) {

$parcel$export(module.exports, "LOADER_STYLES_CSS_SELECTOR", () => $edb941f6bee7be00$export$2a3dd4ccb7b0a764);
$parcel$export(module.exports, "LOADER_STYLESHEET_ID", () => $edb941f6bee7be00$export$79456f717d4431da);
$parcel$export(module.exports, "getAllowedRoutes", () => $edb941f6bee7be00$export$c82eb262b97a76f1);
$parcel$export(module.exports, "getLoadingBarColor", () => $edb941f6bee7be00$export$cf3a5ed89e041425);

var $LFmXM = parcelRequire("LFmXM");

var $hWeHP = parcelRequire("hWeHP");
const $edb941f6bee7be00$var$FIRST_RELEASE_ROUTES = [
    'issue',
    'issue-embed',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-report',
    'your-work',
    'projects-directory',
    'boards-directory',
    'filters-directory',
    'dashboards-directory',
    'dashboards-directory-secure',
    'project-components',
    'project-pages',
    'project-versions',
    'software-boards',
    'software-backlog',
    'software-timeline',
    'software-roadmap',
    'software-roadmap-classic',
    'software-timeline-classic',
    'software-reports',
    'software-reports-burnup',
    'software-reports-burndown',
    'software-reports-cumulative',
    'software-reports-velocity',
    'issue-navigator',
    'global-issue-navigator',
    'issue-navigator-classic',
    'issue-navigator-core',
    'software-issue-navigator',
    'system-dashboard-edit'
];
const $edb941f6bee7be00$export$2a3dd4ccb7b0a764 = 'body::before';
const $edb941f6bee7be00$export$79456f717d4431da = 'loaderStylesheet';
const $edb941f6bee7be00$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
const $edb941f6bee7be00$export$c82eb262b97a76f1 = (0, $LFmXM.default)(()=>{
    const ALLOWED_ROUTES = $edb941f6bee7be00$var$FIRST_RELEASE_ROUTES;
    return ALLOWED_ROUTES;
});
const $edb941f6bee7be00$export$cf3a5ed89e041425 = (0, $LFmXM.default)(()=>(0, $hWeHP.default)('ajs-lf-navigation-highlightcolour') || $edb941f6bee7be00$export$53d51cc6d57e44da);

});

parcelRegister("2G3oS", function(module, exports) {

$parcel$export(module.exports, "generateLoadingBarStyles", () => $2240c5c719a7d109$export$3036104bc81246b1);

var $dPMMf = parcelRequire("dPMMf");

var $1fv87 = parcelRequire("1fv87");
const $2240c5c719a7d109$export$3036104bc81246b1 = (initalProgressValue, loadingBarColor)=>`
    content: '';
    display: block;
    background: ${loadingBarColor};
    height: 3px;
    z-index: ${(0, $dPMMf.layers).navigation + 10};
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    transform: scaleX(${initalProgressValue});
    transform-origin: 0 0;
    will-change: transform;
`;
const $2240c5c719a7d109$export$85e33a4b3d661500 = (initialProgressValue = 0.3)=>`
        <style id=${0, $1fv87.LOADER_STYLESHEET_ID}>
            ${0, $1fv87.LOADER_STYLES_CSS_SELECTOR} {${$2240c5c719a7d109$export$3036104bc81246b1(initialProgressValue, (0, $1fv87.getLoadingBarColor)())}}
        </style>`;

});


parcelRegister("aY5Xx", function(module, exports) {

$parcel$export(module.exports, "SafeHelpPanel", () => $eab455e5758ae8ec$export$cd2ada2fb14048fc);

var $eJOHy = parcelRequire("eJOHy");

var $FppkK = parcelRequire("FppkK");

var $1KdDN = parcelRequire("1KdDN");

var $hLzUY = parcelRequire("hLzUY");

var $3VPsL = parcelRequire("3VPsL");


var $5bQ7z = parcelRequire("5bQ7z");

var $29oTB = parcelRequire("29oTB");

var $dfP3D = parcelRequire("dfP3D");

var $8q7lT = parcelRequire("8q7lT");
const $eab455e5758ae8ec$var$HelpPanel = ()=>{
    const [{ navigationData: navigationData, releaseNotesNotifications: releaseNotesNotifications }, { setNavigationData: setNavigationData, setReleaseNotesNotifications: setReleaseNotesNotifications }] = (0, $3VPsL.useHelpPanel)();
    const { closeRightSidebar: closeRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    const accountId = (0, $8q7lT.useAccountId)();
    (0, $eJOHy.useEffect)(()=>{
        const restoreReleaseNotesNotifications = async ()=>{
            if (accountId) try {
                // @ts-expect-error - Property 'helpPanel' does not exist on type 'unknown'.
                const { helpPanel: userPropertiesHelpPanelValue } = await (0, $FppkK.getUserProperty)(accountId, (0, $efba850e54af37c8$export$783d7c02e3a0cbf));
                setReleaseNotesNotifications(userPropertiesHelpPanelValue.releaseNotesNotifications);
            } catch (err) {
                /* getUserProperty throws if not found */ setReleaseNotesNotifications(0);
            }
            else setReleaseNotesNotifications(0);
        };
        restoreReleaseNotesNotifications();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5bQ7z.RemoteStateUpdater), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $29oTB.LazyHelpPanel), {
        isOpen: !rightSidebarCurrentState?.isCollapsed,
        navigationData: navigationData,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        releaseNotesNotificationsSetter: setReleaseNotesNotifications,
        hasBeenRendered: !rightSidebarCurrentState?.isCollapsed,
        onCloseHelpPanel: closeRightSidebar
    }));
};
const $eab455e5758ae8ec$var$HelpPanelInLayout = ()=>{
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $eJOHy.useState)();
    const prevPanelIdRef = (0, $eJOHy.useRef)();
    const delayRef = (0, $eJOHy.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $hLzUY.HELP_PANEL_ID)) {
            /**
			 * The right-sidebar is showing the help-panel...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== HELP_PANEL_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            }, 310);
        } else /**
			 * If the right sidebar is not showing the help-panel,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $hLzUY.HELP_PANEL_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eab455e5758ae8ec$var$HelpPanel, null);
};
const $eab455e5758ae8ec$export$cd2ada2fb14048fc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-help-panel",
        packageName: "@atlassian/jira-help-panel-right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eab455e5758ae8ec$var$HelpPanelInLayout, null));

});
parcelRegister("hLzUY", function(module, exports) {

$parcel$export(module.exports, "HELP_PANEL_VERSION", () => $60b564818f0d5fed$export$c43c7444da662fa1);
$parcel$export(module.exports, "HELP_PANEL_ID", () => $60b564818f0d5fed$export$e99efa3985fa3c26);
$parcel$export(module.exports, "HELP_PANEL_WIDTH", () => $60b564818f0d5fed$export$23aa6670f346c214);

var $dPMMf = parcelRequire("dPMMf");
const $60b564818f0d5fed$export$c43c7444da662fa1 = '1';
const $60b564818f0d5fed$export$e99efa3985fa3c26 = 'helpPanel';
const $60b564818f0d5fed$export$23aa6670f346c214 = (0, $dPMMf.gridSize) * 46;

});

parcelRegister("3VPsL", function(module, exports) {

$parcel$export(module.exports, "useHelpPanel", () => $39739d0e1c6f9274$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $39739d0e1c6f9274$export$c61f56f4797e22db);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $ht3nQ = parcelRequire("ht3nQ");

var $6wZ6K = parcelRequire("6wZ6K");
const $39739d0e1c6f9274$export$3fe94d66377a53b8 = (0, $iJq0l.createHook)((0, $6wZ6K.default));
const $39739d0e1c6f9274$export$c61f56f4797e22db = (0, $iJq0l.createHook)((0, $6wZ6K.default), {
    selector: null
});
const $39739d0e1c6f9274$export$513717a84f55db1a = (0, $ht3nQ.createSubscriber)((0, $6wZ6K.default), {
    displayName: 'HelpPanelSubscriber'
});
const $39739d0e1c6f9274$export$5f4de38bd79f4446 = (0, $ht3nQ.createSubscriber)((0, $6wZ6K.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("6wZ6K", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0401c126f56172a$export$2e2bcd8739ae039);

var $4elgJ = parcelRequire("4elgJ");

var $GtRbT = parcelRequire("GtRbT");

var $efQxP = parcelRequire("efQxP");
let $e0401c126f56172a$var$iphStorage;
const $e0401c126f56172a$var$createStorage = ()=>{
    if ($e0401c126f56172a$var$iphStorage) return $e0401c126f56172a$var$iphStorage;
    $e0401c126f56172a$var$iphStorage = (0, $4elgJ.createSessionStorageProvider)('iph');
    return $e0401c126f56172a$var$iphStorage;
};
const $e0401c126f56172a$var$initialState = {
    navigationData: {
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        // FIXME: initialState breaks SSR
        history: false ? [] : $e0401c126f56172a$var$createStorage().get('navigationData') || []
    },
    releaseNotesNotifications: 100
};
var $e0401c126f56172a$export$2e2bcd8739ae039 = (0, $GtRbT.createStore)({
    name: 'help-panel',
    initialState: $e0401c126f56172a$var$initialState,
    actions: $efQxP
});

});
parcelRegister("efQxP", function(module, exports) {

$parcel$export(module.exports, "setNavigationData", () => $b1de94cedbb71714$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $b1de94cedbb71714$export$cdabe01d01a8da1e);

var $4elgJ = parcelRequire("4elgJ");
const $b1de94cedbb71714$var$iphStorage = (0, $4elgJ.createSessionStorageProvider)('iph');
const $b1de94cedbb71714$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        $b1de94cedbb71714$var$iphStorage.set('history', []);
    };
const $b1de94cedbb71714$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});



const $efba850e54af37c8$export$783d7c02e3a0cbf = 'help_panel_ui_state';

parcelRegister("5bQ7z", function(module, exports) {

$parcel$export(module.exports, "RemoteStateUpdater", () => $5652fb65b99633f4$export$3db011870dd4330f);

var $eJOHy = parcelRequire("eJOHy");

var $1kTCl = parcelRequire("1kTCl");

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

var $8q7lT = parcelRequire("8q7lT");

var $3VPsL = parcelRequire("3VPsL");

const $5652fb65b99633f4$var$DEBOUNCE_TIME = 1000;
const $5652fb65b99633f4$export$3db011870dd4330f = ()=>{
    // right-sidebar
    const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, $3VPsL.useHelpPanel)();
    const [releaseNotesNotificationsTemp, setReleaseNotesNotificationsTemp] = (0, $eJOHy.useState)(releaseNotesNotifications);
    const accountId = (0, $8q7lT.useAccountId)();
    const [debouncedUpdateData] = (0, $1kTCl.default)(async (newReleaseNotesNotifications)=>{
        const remoteData = {
            helpPanel: {
                releaseNotesNotifications: newReleaseNotesNotifications
            }
        };
        if (accountId) try {
            await (0, $FppkK.setUserProperties)(accountId, (0, $efba850e54af37c8$export$783d7c02e3a0cbf), JSON.stringify(remoteData));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gYnSx.default)({
                error: e,
                meta: {
                    id: 'updateServerHelpPanelState',
                    packageName: 'jiraHelpPanelServices',
                    teamName: 'self-help-experiences'
                }
            });
        }
    }, $5652fb65b99633f4$var$DEBOUNCE_TIME);
    (0, $eJOHy.useEffect)(()=>{
        if (releaseNotesNotificationsTemp !== releaseNotesNotifications) {
            setReleaseNotesNotificationsTemp(releaseNotesNotifications);
            debouncedUpdateData(releaseNotesNotifications);
        }
    }, [
        debouncedUpdateData,
        releaseNotesNotifications,
        releaseNotesNotificationsTemp
    ]);
    return null;
};

});

parcelRegister("29oTB", function(module, exports) {

$parcel$export(module.exports, "LazyHelpPanel", () => $3b7f9896b69ebb12$export$51c79455aef7d178);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $5kYyR = parcelRequire("5kYyR");

var $epTsa = parcelRequire("epTsa");

var $ch9En = parcelRequire("ch9En");

var $3MbOI = parcelRequire("3MbOI");

var $4xbv3 = parcelRequire("4xbv3");

var $fgHyA = parcelRequire("fgHyA");

var $2iwcU = parcelRequire("2iwcU");

var $e8WdG = parcelRequire("e8WdG");

var $iPI5r = parcelRequire("iPI5r");
const $3b7f9896b69ebb12$export$51c79455aef7d178 = ({ navigationData: { articleId: articleId, history: history }, setNavigationData: setNavigationData, releaseNotesNotifications: releaseNotesNotifications, releaseNotesNotificationsSetter: releaseNotesNotificationsSetter, isOpen: isOpen, onCloseHelpPanel: onCloseHelpPanel, hasBeenRendered: hasBeenRendered, routeGroup: routeGroup, routeName: routeName })=>{
    const user = (0, $3MbOI.useCurrentUser)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "help-panel",
        packageName: "jiraHelpPanel",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2iwcU.default), {
                loadingArticle: articleId.id !== ''
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        id: "root",
        packageName: "jiraHelpPanel",
        teamName: "self-help-experiences"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e8WdG.SearchContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        tags: [
            'iph'
        ],
        sourceName: "jiraHelpPanel",
        sourceType: (0, $466f60259c330878$export$9d2de6eebf7462b5),
        attributes: {
            searchService: (0, $epTsa.expVal)('20240422_self_help_iph_ms3_expt', 'iph_ms3_experience_display_flag', false) ? 'help-aggregator' : 'algolia',
            routeGroup: routeGroup,
            routeName: routeName,
            userId: user?.data?.user?.accountId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgHyA.LazyWait), {
        until: hasBeenRendered
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-lazy-help-panel",
        fallback: isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2iwcU.default), {
            loadingArticle: articleId.id !== ''
        }) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iPI5r.AsyncLazyHelpPanel), {
        navigationData: {
            articleId: articleId,
            history: history
        },
        releaseNotesNotificationsSetter: releaseNotesNotificationsSetter,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        isOpen: isOpen,
        onCloseHelpPanel: onCloseHelpPanel,
        routeGroup: routeGroup,
        routeName: routeName
    })))))));
};

});
parcelRegister("2iwcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8125c878b5cd420f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $66x0e = parcelRequire("66x0e");
const $8125c878b5cd420f$var$HelpPanelLoading = ({ loadingArticle: loadingArticle = false })=>loadingArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $66x0e.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        role: "img",
        "aria-label": "help panel loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-250, 20px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "90%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "70%"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $66x0e.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-500, 40px)",
        marginTop: "var(--ds-space-100, 8px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadignArticleList, {
        role: "img"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8125c878b5cd420f$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })))));
var $8125c878b5cd420f$export$2e2bcd8739ae039 = $8125c878b5cd420f$var$HelpPanelLoading;
/**
 * Header
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8125c878b5cd420f$var$LoadingContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $8125c878b5cd420f$var$HeaderLoading = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zlnq84 _4t3ixncg _bfhkfg4m _1bah1yb4 _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $8125c878b5cd420f$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8125c878b5cd420f$var$LoadingRectangle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { contentHeight: contentHeight, marginTop: marginTop, contentWidth: contentWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_l7mdyr": (0, $awdRS.default)(__cmplp.contentHeight),
            "--_1fj4wta": (0, $awdRS.default)(__cmplp.marginTop),
            "--_7n1eiw": (0, $awdRS.default)(__cmplp.contentWidth)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkov77o _kqswh2mm _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhk1v33 _1itkaioo _12vemgnk",
            __cmplp.contentHeight != null ? "_4t3i6c59" : "_4t3ipxbi",
            __cmplp.marginTop != null ? "_19pkmye1" : "_19pku2gc",
            __cmplp.contentWidth != null ? "_1bsbwd3v" : "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $8125c878b5cd420f$var$LoadignArticleList = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _19pku2gc _2hwxidpf _otyridpf _18u0idpf _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _vchhusvi",
            __cmplp.className
        ])
    });
});
const $8125c878b5cd420f$var$LoadignArticleListItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1ule _1bsb1osq _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("66x0e", function(module, exports) {

$parcel$export(module.exports, "HelpPanelContainer", () => $e7337023f734e957$export$37cd645d7678f7d4);
$parcel$export(module.exports, "HelpPanelContainerV2", () => $e7337023f734e957$export$1df7e3ebfc4c9b06);
$parcel$export(module.exports, "HelpPanelSectionMessageContainer", () => $e7337023f734e957$export$9f6251c714594f23);
$parcel$export(module.exports, "HelpPanelContentContainer", () => $e7337023f734e957$export$1cdb922eed7271d1);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7jTnu = parcelRequire("7jTnu");

var $6zXPf = parcelRequire("6zXPf");
const $e7337023f734e957$export$37cd645d7678f7d4 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _vchhusvi _2lx21bp4 _1bsb1feq _4t3i1osq _kqsw1n9t",
            !((0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('platform_design_system_nav4_panel_default_border')) && "_1kl7pu5c",
            __cmplp.className
        ])
    });
});
const $e7337023f734e957$export$1df7e3ebfc4c9b06 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $e7337023f734e957$export$37cd645d7678f7d4, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1i8v _bfhk1bhr",
            __cmplp.className
        ])
    });
});
const $e7337023f734e957$export$9f6251c714594f23 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _ca0qpxbi _u5f3pxbi _n3tdidpf _19bvpxbi _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $e7337023f734e957$export$1cdb922eed7271d1 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1tkeidpf _kqswh2mm _18m91wug _1reo15vq _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ae4v1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});

});


parcelRegister("e8WdG", function(module, exports) {

$parcel$export(module.exports, "useSearchContext", () => $566b0e2b04e0ed5d$export$67b98b1b880a048b);
$parcel$export(module.exports, "SearchContextProvider", () => $566b0e2b04e0ed5d$export$6bd70292443463a4);

var $eJOHy = parcelRequire("eJOHy");

var $iITas = parcelRequire("iITas");
const [$566b0e2b04e0ed5d$export$67b98b1b880a048b, $566b0e2b04e0ed5d$export$70af50e847ce290a] = (0, $iITas.createCtx)();
const $566b0e2b04e0ed5d$export$6bd70292443463a4 = ({ children: children })=>{
    const [searchContext, setSearchContext] = (0, $eJOHy.useState)({});
    const addClickedArticleIds = (0, $eJOHy.useCallback)((query, clickedArticleId)=>{
        setSearchContext((prev)=>({
                ...prev,
                [query]: {
                    ...prev[query],
                    clickedArticleIds: prev[query]?.clickedArticleIds ? [
                        ...prev[query].clickedArticleIds,
                        clickedArticleId
                    ] : [
                        clickedArticleId
                    ]
                }
            }));
    }, []);
    const addFetchedArticleIds = (0, $eJOHy.useCallback)((query, fetchedArticles)=>{
        setSearchContext((prev)=>({
                ...prev,
                [query]: {
                    ...prev[query],
                    fetchedArticleIds: fetchedArticles
                }
            }));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($566b0e2b04e0ed5d$export$70af50e847ce290a, {
        value: {
            searchContext: searchContext,
            addClickedArticleIds: addClickedArticleIds,
            addFetchedArticleIds: addFetchedArticleIds
        }
    }, children);
};

});
parcelRegister("iITas", function(module, exports) {

$parcel$export(module.exports, "createCtx", () => $2159147717cc56e1$export$d653a1a643c9a98c);

var $eJOHy = parcelRequire("eJOHy");
function $2159147717cc56e1$export$d653a1a643c9a98c() {
    const ctx = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
    function useCtx() {
        const c = (0, $eJOHy.useContext)(ctx);
        if (!c) throw new Error('useCtx must be inside a Provider with a value');
        return c;
    }
    return [
        useCtx,
        ctx.Provider
    ];
}

});


parcelRegister("iPI5r", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyHelpPanel", () => $aa0bb30697b38a66$export$7ff46d33d0f13518);

var $gzcjr = parcelRequire("gzcjr");

const $aa0bb30697b38a66$export$7ff46d33d0f13518 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("lCTuS")).then(({ HelpPanel: HelpPanel })=>HelpPanel), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/help-panel/src/ui/index.tsx"
});

});
parcelRegister("lCTuS", function(module, exports) {

let $fbe83221df116059$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $fbe83221df116059$var$load("1VRB2"),
    $fbe83221df116059$var$load("bABhq"),
    $fbe83221df116059$var$load("k4gbU"),
    $fbe83221df116059$var$load("7wH3v")
]).then(()=>parcelRequire('8be30'));

});




parcelRegister("cosWN", function(module, exports) {

$parcel$export(module.exports, "SafeEmbeddedConfluencePanel", () => $5af1d35198948c0c$export$2d901a489872dd0d);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $7qNGi = parcelRequire("7qNGi");

var $vztq1 = parcelRequire("vztq1");

var $1KdDN = parcelRequire("1KdDN");

var $dfP3D = parcelRequire("dfP3D");

var $80rW8 = parcelRequire("80rW8");
const $5af1d35198948c0c$var$DELAY = 310;
const $5af1d35198948c0c$export$2db0a2e0275af8b8 = ()=>{
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    const [{ panel: isOpen }] = (0, $vztq1.useEmbeddedConfluenceSidePanel)();
    const [localPanelId, setLocalPanelId] = (0, $eJOHy.useState)();
    const prevPanelIdRef = (0, $eJOHy.useRef)();
    const delayRef = (0, $eJOHy.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    const { entryPointActions: entryPointActions, entryPoint: entryPoint } = (0, $80rW8.useEmbeddedPanelEntryPoint)();
    (0, $eJOHy.useEffect)(()=>{
        if (isOpen) entryPointActions?.load();
    }, [
        isOpen,
        entryPointActions,
        localPanelId
    ]);
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $7qNGi.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) {
            /**
			 * The right-sidebar is showing the embedded confluence content...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            // TODO: trigger close analytics event
            }, $5af1d35198948c0c$var$DELAY);
        } else /**
			 * If the right sidebar is not showing the embedded confluence content,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $7qNGi.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $5af1d35198948c0c$var$panelStyles
    }, entryPoint);
};
const $5af1d35198948c0c$export$2d901a489872dd0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-embedded-confluence-panel",
        packageName: "jiraIssueCreateConfluenceContent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $vztq1.EmbeddedConfluenceSidepanelContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5af1d35198948c0c$export$2db0a2e0275af8b8, null)));
const $5af1d35198948c0c$var$panelStyles = (0, $5Wv5g.xcss)({
    padding: 'space.100',
    height: 'calc(100vh - (var(--topNavigationHeight, 0px) + var(--bannerHeight, 0px)))'
});

});
parcelRegister("7qNGi", function(module, exports) {

$parcel$export(module.exports, "ConfluenceFeatureKeys", () => $0226e4fb226e1b22$export$746d4746bf07dd70);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_KEY", () => $0226e4fb226e1b22$export$6247c7e19b71f4e);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_KEY", () => $0226e4fb226e1b22$export$e34c4c923d934e7a);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY", () => $0226e4fb226e1b22$export$ffe60197eb59ca73);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY", () => $0226e4fb226e1b22$export$8d0c4a26241944b8);
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID", () => $0226e4fb226e1b22$export$a497288e64e9a343);
const $0226e4fb226e1b22$export$746d4746bf07dd70 = {
    ENABLE_CONFLUENCE_SIGNUP: 'jira.admin.confluence.enable-integrations',
    SPRINT_RETRO: 'jira.admin.confluence.enable-sprint-retros',
    CREATE_MENU_TOP_ACTIONS: 'jira.admin.confluence.enable-content-creation-issue-top-actions',
    CREATE_MENU_CONFLUENCE_CONTENT: 'jira.admin.confluence.enable-content-creation-issue-confluence-content'
};
const $0226e4fb226e1b22$export$6247c7e19b71f4e = 'confluence-integration-controls';
const $0226e4fb226e1b22$export$e34c4c923d934e7a = 'user-confluence-access';
const $0226e4fb226e1b22$export$ffe60197eb59ca73 = 'confluence-integration-controls-session-storage';
const $0226e4fb226e1b22$export$8d0c4a26241944b8 = 'confluence-permissions-session-storage';
const $0226e4fb226e1b22$export$a497288e64e9a343 = 'embedded-confluence-panel-container';

});

parcelRegister("vztq1", function(module, exports) {

$parcel$export(module.exports, "EmbeddedConfluenceSidepanelContainer", () => $c7edbeb9f475152a$export$a5c1c168018f0f16);
$parcel$export(module.exports, "useEmbeddedConfluenceSidePanel", () => $c7edbeb9f475152a$export$518aeea31a00450e);

var $eJOHy = parcelRequire("eJOHy");

var $bmoS1 = parcelRequire("bmoS1");

var $dfP3D = parcelRequire("dfP3D");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7qNGi = parcelRequire("7qNGi");

var $4Ip8A = parcelRequire("4Ip8A");

var $ajyyy = parcelRequire("ajyyy");

var $lYAmh = parcelRequire("lYAmh");
/**
 * Container for {@link useEmbeddedConfluenceSidePanel}. Any component that uses this hook
 * must be wrapped in this container.
 */ const $c7edbeb9f475152a$var$Container = (0, $6E16M.createContainer)();
const $c7edbeb9f475152a$var$DefaultStore = (0, $GtRbT.createStore)({
    actions: $4Ip8A.actions,
    containedBy: $c7edbeb9f475152a$var$Container,
    initialState: $4Ip8A.initialState,
    name: (0, $7qNGi.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
});
const $c7edbeb9f475152a$export$a5c1c168018f0f16 = ({ children: children })=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    /*
	In order for each usage of the store to manage the same state irregardless of
	their location in the component tree, we need to wrap components in a container
	with the same scope value. This is why we use the issueKey in the scope value.
	see https://atlassian.github.io/react-sweet-state/#/advanced/container?id=scoped-data-sharing
	for more information about scoped data sharing.

	*/ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7edbeb9f475152a$var$Container, {
        scope: `embedded-confluence-sidepanel-${issueKey}`
    }, children);
};
const $c7edbeb9f475152a$var$defaultStoreHook = (0, $iJq0l.createHook)($c7edbeb9f475152a$var$DefaultStore);
const $c7edbeb9f475152a$export$518aeea31a00450e = (embeddedConfluenceSource)=>{
    const [state, { closeSidePanel: closeSidePanelAction, openSidePanel: openSidePanelAction, setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection, setDeferredSpaceData: setDeferredSpaceData, toggleExpandedState: toggleExpandedState, setIsDraftState: setIsDraftState, setConfluenceData: setConfluenceData }] = $c7edbeb9f475152a$var$defaultStoreHook();
    const { closeRightSidebar: closeRightSidebar, openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const openSidePanel = (0, $eJOHy.useCallback)(({ contentId: contentId, contentType: contentType, data: data, hostname: hostname, isDraft: isDraft, isLive: isLive, onLinkPage: onLinkPage, onPublish: onPublish, openInModal: openInModal, mode: mode, url: url, title: title })=>{
        const { initialWidth: initialWidth, displayType: displayType } = (0, $lYAmh.getDisplayInformation)();
        const shouldOpenPanel = displayType === (0, $ajyyy.DisplayTypes).PANEL;
        if (shouldOpenPanel) {
            openSidePanelAction({
                contentId: contentId,
                contentType: contentType,
                embeddedConfluenceSource: embeddedConfluenceSource,
                data: data,
                displayType: displayType,
                initialWidth: initialWidth,
                hostname: hostname,
                isDraft: isDraft,
                isLive: isLive,
                mode: mode,
                onLinkPage: onLinkPage,
                onPublish: onPublish,
                shouldOpenModal: !shouldOpenPanel,
                url: url,
                title: title
            });
            openRightSidebar((0, $7qNGi.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID), initialWidth, false, true);
        } else openInModal();
    }, [
        embeddedConfluenceSource,
        openRightSidebar,
        openSidePanelAction
    ]);
    const closeSidePanel = (0, $eJOHy.useCallback)(()=>{
        closeRightSidebar((0, $7qNGi.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID));
        closeSidePanelAction();
    }, [
        closeRightSidebar,
        closeSidePanelAction
    ]);
    return [
        state,
        {
            openSidePanel: openSidePanel,
            closeSidePanel: closeSidePanel,
            setDeferredSpaceData: setDeferredSpaceData,
            setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection,
            toggleExpandedState: toggleExpandedState,
            setIsDraftState: setIsDraftState,
            setConfluenceData: setConfluenceData
        }
    ];
};

});
parcelRegister("4Ip8A", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $03f714671d0d2aa4$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "actions", () => $03f714671d0d2aa4$export$e324594224ef24da);

var $3sdFo = parcelRequire("3sdFo");
var $3pzvh = parcelRequire("3pzvh");

var $ajyyy = parcelRequire("ajyyy");
const $03f714671d0d2aa4$export$d4c72bab9d6cc13a = {
    confluenceData: {
        contentId: '',
        contentUrl: '',
        contentData: null,
        mode: (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        isDraft: false,
        isLive: false
    },
    contentActions: {},
    contentType: (0, $ajyyy.ConfluenceContentTypes).PAGE,
    embeddedConfluenceSource: '',
    displayType: (0, $ajyyy.DisplayTypes).PANEL,
    panel: {
        initialWidth: 0,
        isOpen: false,
        isLoading: false,
        isExpanded: false
    },
    modal: {
        isOpen: false
    }
};
const $03f714671d0d2aa4$export$aa5d06fef96639ba = ({ contentId: contentId, contentType: contentType, embeddedConfluenceSource: embeddedConfluenceSource, data: data, displayType: displayType, initialWidth: initialWidth, hostname: hostname, isDraft: isDraft, isLive: isLive, isExpanded: isExpanded, mode: mode, onLinkPage: onLinkPage, onPublish: onPublish, shouldOpenModal: shouldOpenModal, url: url, title: title })=>({ setState: setState })=>{
        setState({
            confluenceData: {
                contentId: contentId,
                contentUrl: url,
                contentData: data,
                hostname: hostname,
                mode: mode,
                isDraft: isDraft,
                isLive: isLive,
                title: title,
                spaceKey: (0, $3pzvh.parseUrl)(url)?.spaceKey
            },
            contentActions: {
                onLinkPage: onLinkPage,
                onPublish: onPublish
            },
            embeddedConfluenceSource: embeddedConfluenceSource,
            contentType: contentType,
            displayType: displayType,
            panel: {
                initialWidth: initialWidth,
                isOpen: !shouldOpenModal,
                isExpanded: isExpanded
            },
            modal: {
                isOpen: shouldOpenModal
            }
        });
    };
const $03f714671d0d2aa4$export$e81b26ab493ca52a = ()=>({ setState: setState })=>{
        setState($03f714671d0d2aa4$export$d4c72bab9d6cc13a);
    };
const $03f714671d0d2aa4$export$473e6cac57a0d506 = (deferredSpaceName, deferredSpaceKey)=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                deferredSpaceName: deferredSpaceName,
                spaceKey: deferredSpaceKey || confluenceData.spaceKey
            },
            ...prevState
        });
    };
const $03f714671d0d2aa4$export$db9852cd4946540a = ({ isLoading: isLoading, isDeferSpaceSelection: isDeferSpaceSelection })=>({ setState: setState, getState: getState })=>{
        const { panel: panel, ...prevState } = getState();
        setState({
            ...prevState,
            isDeferSpaceSelection: isDeferSpaceSelection,
            panel: {
                ...panel,
                isLoading: isLoading
            }
        });
    };
const $03f714671d0d2aa4$export$b29d56f843007f2b = ()=>({ setState: setState, getState: getState })=>{
        const { panel: panel, ...prevState } = getState();
        const isCurrentlyExpanded = panel.isExpanded;
        setState({
            panel: {
                ...panel,
                isExpanded: !isCurrentlyExpanded
            },
            ...prevState
        });
    };
const $03f714671d0d2aa4$export$5d0561abb73760f = ({ newIsDraftState: newIsDraftState })=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                isDraft: newIsDraftState
            },
            ...prevState
        });
    };
const $03f714671d0d2aa4$export$1a8782a287467f35 = (newData)=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                ...newData
            },
            ...prevState
        });
    };
const $03f714671d0d2aa4$export$e324594224ef24da = {
    closeSidePanel: $03f714671d0d2aa4$export$e81b26ab493ca52a,
    openSidePanel: $03f714671d0d2aa4$export$aa5d06fef96639ba,
    setDeferredSpaceData: $03f714671d0d2aa4$export$473e6cac57a0d506,
    setIsDraftState: $03f714671d0d2aa4$export$5d0561abb73760f,
    setIsLoadingForDeferSpaceSelection: $03f714671d0d2aa4$export$db9852cd4946540a,
    toggleExpandedState: $03f714671d0d2aa4$export$b29d56f843007f2b,
    setConfluenceData: $03f714671d0d2aa4$export$1a8782a287467f35
};

});
parcelRegister("3sdFo", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", () => $31a354f40c53f142$export$816ef638e478449a);
var $31a354f40c53f142$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});

});

parcelRegister("3pzvh", function(module, exports) {

$parcel$export(module.exports, "parsePageProps", () => $e703d189721728d6$export$41eb0a358b69a9df);
$parcel$export(module.exports, "parseUrl", () => $e703d189721728d6$export$7a5253c0f62e0150);
parcelRequire("79acB");
var $ddbcJ = parcelRequire("ddbcJ");

var $e8PG7 = parcelRequire("e8PG7");

var $eSxF2 = parcelRequire("eSxF2");

var $3sdFo = parcelRequire("3sdFo");

var $eVRlo = parcelRequire("eVRlo");
function $e703d189721728d6$export$41eb0a358b69a9df(props) {
    let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, showFooter: showFooter, ...passThroughProps } = props;
    const parsedAllowedFeatures = $e703d189721728d6$export$350c411f568eceb9(allowedFeatures);
    if (!url) return {
        contentId: contentId,
        hostname: hostname,
        parentProduct: parentProduct,
        spaceKey: spaceKey,
        protocol: 'https:',
        mode: mode ?? (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const parsedProps = $e703d189721728d6$export$7a5253c0f62e0150(url);
    if (!parsedProps) return {
        hostname: hostname,
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        mode: mode,
        protocol: 'https:',
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const themeStateParsedObject = parsedProps.themeState ? (0, $e8PG7.themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
    // Override with URL-extracted props
    contentId = contentId || parsedProps.contentId;
    parentProduct = parentProduct || parsedProps.parentProduct || '';
    hostname = hostname || parsedProps.hostname || window.location.hostname;
    spaceKey = spaceKey || parsedProps.spaceKey;
    draftShareId = draftShareId || parsedProps.draftShareId;
    hash = hash || parsedProps.hash;
    themeState = themeState || themeStateParsedObject;
    let modeFromUrl;
    switch(parsedProps.route){
        case (0, $eVRlo.VIEW_PAGE).name:
        case (0, $eVRlo.VIEW_BLOG).name:
        case (0, $eVRlo.VIEW_BLOG_DATE_LEGACY).name:
            modeFromUrl = (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
            break;
        case (0, $eVRlo.EDIT_PAGE_EMBED).name:
        case (0, $eVRlo.EDIT_PAGE_V2).name:
            modeFromUrl = (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
            break;
        case (0, $eVRlo.WHITEBOARD).name:
    }
    const contentSlug = parsedProps.route === (0, $eVRlo.VIEW_BLOG_DATE_LEGACY).name ? undefined : parsedProps.contentSlug;
    return {
        allowedFeatures: parsedAllowedFeatures,
        contentId: contentId,
        draftShareId: draftShareId,
        hash: hash,
        hostname: hostname,
        mode: mode || modeFromUrl,
        parentProduct: parentProduct,
        protocol: parsedProps.protocol,
        spaceKey: spaceKey,
        themeState: themeState,
        contentSlug: contentSlug,
        showFooter: showFooter,
        ...passThroughProps
    };
}
function $e703d189721728d6$export$7a5253c0f62e0150(url) {
    if (!url) return null;
    const matchedRoute = $e703d189721728d6$var$findAndMatchRoute((0, $eVRlo.namedRoutes), url);
    if (!matchedRoute) return null;
    const { routeName: routeName, ...match } = matchedRoute;
    const { year: year, month: month, day: day, contentId: contentId } = match.params;
    // Validate date parameters
    const isValidYear = /^\d+$/.test(year || '');
    const isValidMonth = /^\d+$/.test(month || '');
    const isValidDay = /^\d+$/.test(day || '');
    const isValidContentId = /^\d+$/.test(contentId || '');
    // If route requires validation, and any parameter is invalid, return null
    if (routeName === (0, $eVRlo.VIEW_BLOG_DATE_LEGACY).name && (!isValidYear || !isValidMonth || !isValidDay || !isValidContentId)) return null;
    return {
        route: routeName,
        hostname: match.host,
        protocol: match.protocol,
        contentId: contentId || '',
        spaceKey: match.params.spaceKey || '',
        hash: match.hash || '',
        // EP currently supports only 1 parent product, no more than 1 parent product should be passed in
        parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
        draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
        themeState: match.query.themeState,
        contentSlug: match.params.contentSlug || undefined,
        query: match.query
    };
}
function $e703d189721728d6$var$findAndMatchRoute(routes, url) {
    for (const routeKey of Object.keys(routes)){
        const route = routes[routeKey];
        const match = $e703d189721728d6$var$matchUrl(route.pattern, url);
        if (match) return {
            routeName: route.name,
            ...match
        };
    }
    return null;
}
function $e703d189721728d6$var$isValidURL(url) {
    try {
        new URL(url, window.location.origin);
        return true;
    } catch  {
        return false;
    }
}
function $e703d189721728d6$var$matchUrl(pattern, url) {
    if (!$e703d189721728d6$var$isValidURL(url)) return null;
    const parsed = new URL(url, window.location.origin);
    const pathname = parsed.pathname || '';
    const search = parsed.search || '';
    let match = (0, $ddbcJ.matchPath)({
        path: pattern,
        end: true
    }, pathname);
    // If initial match fails and the route requires query parameters, attempt to match including search
    // some of our routes need query params to match
    if (!match && search) match = (0, $ddbcJ.matchPath)({
        path: pattern,
        end: true
    }, `${pathname}${search}`);
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match.params) {
        for (const [key, value] of Object.entries(match.params))if (value !== undefined) decodedParams[key] = value;
    }
    return {
        url: url,
        protocol: parsed.protocol,
        host: parsed.host,
        pathname: pathname,
        search: parsed.search,
        hash: parsed.hash,
        pattern: pattern,
        params: decodedParams,
        query: Object.fromEntries(parsed.searchParams.entries())
    };
}
function $e703d189721728d6$export$350c411f568eceb9(allowedFeatures) {
    let parsedAllowedFeatures = {
        view: allowedFeatures?.view,
        edit: allowedFeatures?.edit
    };
    if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
        ...(0, $eSxF2.DEFAULT_ALLOWED_FEATURES).view,
        'edit'
    ];
    else if (Array.isArray(allowedFeatures.view)) parsedAllowedFeatures.view = [
        ...allowedFeatures.view,
        'edit'
    ];
    return parsedAllowedFeatures;
}

});
parcelRegister("79acB", function(module, exports) {

$parcel$export(module.exports, "matchPath", () => (parcelRequire("ddbcJ")).matchPath);
/**
 * React Router v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $ddbcJ = parcelRequire("ddbcJ");
function $534149a31c60d01f$var$_extends() {
    $534149a31c60d01f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $534149a31c60d01f$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $534149a31c60d01f$export$3add0d5dce533e2e = /*#__PURE__*/ $eJOHy.createContext(null);
const $534149a31c60d01f$export$145dfa71566a64dc = /*#__PURE__*/ $eJOHy.createContext(null);
const $534149a31c60d01f$var$AwaitContext = /*#__PURE__*/ $eJOHy.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $534149a31c60d01f$export$26749e8557646306 = /*#__PURE__*/ $eJOHy.createContext(null);
const $534149a31c60d01f$export$c7914228fb69b0f5 = /*#__PURE__*/ $eJOHy.createContext(null);
const $534149a31c60d01f$export$9072aa6dd1f93057 = /*#__PURE__*/ $eJOHy.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $534149a31c60d01f$var$RouteErrorContext = /*#__PURE__*/ $eJOHy.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $534149a31c60d01f$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$534149a31c60d01f$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $eJOHy.useContext($534149a31c60d01f$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $534149a31c60d01f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $ddbcJ.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $534149a31c60d01f$export$9c954a9d03d32f4a() {
    return $eJOHy.useContext($534149a31c60d01f$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $534149a31c60d01f$export$45d76561a5302f2b() {
    !$534149a31c60d01f$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    return $eJOHy.useContext($534149a31c60d01f$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $534149a31c60d01f$export$1b3f31771c5d07c() {
    return $eJOHy.useContext($534149a31c60d01f$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $534149a31c60d01f$export$6c330e8992e8a295(pattern) {
    !$534149a31c60d01f$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { pathname: pathname } = $534149a31c60d01f$export$45d76561a5302f2b();
    return $eJOHy.useMemo(()=>(0, $ddbcJ.matchPath)(pattern, (0, $ddbcJ.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $534149a31c60d01f$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $534149a31c60d01f$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $eJOHy.useContext($534149a31c60d01f$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eJOHy.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $534149a31c60d01f$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $eJOHy.useContext($534149a31c60d01f$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $534149a31c60d01f$var$useNavigateStable() : $534149a31c60d01f$var$useNavigateUnstable();
}
function $534149a31c60d01f$var$useNavigateUnstable() {
    !$534149a31c60d01f$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let dataRouterContext = $eJOHy.useContext($534149a31c60d01f$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $eJOHy.useContext($534149a31c60d01f$export$26749e8557646306);
    let { matches: matches } = $eJOHy.useContext($534149a31c60d01f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $534149a31c60d01f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ddbcJ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $eJOHy.useRef(false);
    $534149a31c60d01f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eJOHy.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $ddbcJ.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $ddbcJ.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $534149a31c60d01f$var$OutletContext = /*#__PURE__*/ $eJOHy.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $534149a31c60d01f$export$4138103a3ae699cc() {
    return $eJOHy.useContext($534149a31c60d01f$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $534149a31c60d01f$export$a3be3530d8e40d0b(context) {
    let outlet = $eJOHy.useContext($534149a31c60d01f$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $534149a31c60d01f$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $eJOHy.useContext($534149a31c60d01f$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $534149a31c60d01f$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $eJOHy.useContext($534149a31c60d01f$export$26749e8557646306);
    let { matches: matches } = $eJOHy.useContext($534149a31c60d01f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $534149a31c60d01f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ddbcJ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $eJOHy.useMemo(()=>(0, $ddbcJ.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $534149a31c60d01f$export$5d3fca4a98652595(routes, locationArg) {
    return $534149a31c60d01f$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $534149a31c60d01f$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$534149a31c60d01f$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { navigator: navigator } = $eJOHy.useContext($534149a31c60d01f$export$26749e8557646306);
    let { matches: parentMatches } = $eJOHy.useContext($534149a31c60d01f$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $534149a31c60d01f$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $ddbcJ.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $ddbcJ.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $ddbcJ.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $534149a31c60d01f$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $ddbcJ.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $ddbcJ.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $534149a31c60d01f$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $ddbcJ.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $534149a31c60d01f$var$DefaultErrorComponent() {
    let error = $534149a31c60d01f$export$ed527bf60f6e05f2();
    let message = (0, $ddbcJ.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $eJOHy.createElement($eJOHy.Fragment, null, /*#__PURE__*/ $eJOHy.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $eJOHy.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $eJOHy.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $534149a31c60d01f$var$defaultErrorElement = /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$var$DefaultErrorComponent, null);
class $534149a31c60d01f$var$RenderErrorBoundary extends $eJOHy.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $534149a31c60d01f$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $eJOHy.useContext($534149a31c60d01f$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $534149a31c60d01f$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $ddbcJ.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $534149a31c60d01f$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $534149a31c60d01f$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $eJOHy.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $534149a31c60d01f$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($534149a31c60d01f$var$DataRouterHook || {});
var $534149a31c60d01f$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($534149a31c60d01f$var$DataRouterStateHook || {});
function $534149a31c60d01f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $534149a31c60d01f$var$useDataRouterContext(hookName) {
    let ctx = $eJOHy.useContext($534149a31c60d01f$export$3add0d5dce533e2e);
    !ctx && (0, $ddbcJ.UNSAFE_invariant)(false);
    return ctx;
}
function $534149a31c60d01f$var$useDataRouterState(hookName) {
    let state = $eJOHy.useContext($534149a31c60d01f$export$145dfa71566a64dc);
    !state && (0, $ddbcJ.UNSAFE_invariant)(false);
    return state;
}
function $534149a31c60d01f$var$useRouteContext(hookName) {
    let route = $eJOHy.useContext($534149a31c60d01f$export$9072aa6dd1f93057);
    !route && (0, $ddbcJ.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $534149a31c60d01f$var$useCurrentRouteId(hookName) {
    let route = $534149a31c60d01f$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $ddbcJ.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $534149a31c60d01f$export$5fc8298006ad9e58() {
    return $534149a31c60d01f$var$useCurrentRouteId($534149a31c60d01f$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $534149a31c60d01f$export$d0fd4b7106de2769() {
    let state = $534149a31c60d01f$var$useDataRouterState($534149a31c60d01f$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $534149a31c60d01f$export$600dc272ed516c15() {
    let dataRouterContext = $534149a31c60d01f$var$useDataRouterContext($534149a31c60d01f$var$DataRouterHook.UseRevalidator);
    let state = $534149a31c60d01f$var$useDataRouterState($534149a31c60d01f$var$DataRouterStateHook.UseRevalidator);
    return $eJOHy.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $534149a31c60d01f$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $534149a31c60d01f$var$useDataRouterState($534149a31c60d01f$var$DataRouterStateHook.UseMatches);
    return $eJOHy.useMemo(()=>matches.map((m)=>(0, $ddbcJ.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $534149a31c60d01f$export$1448a5050d252c4d() {
    let state = $534149a31c60d01f$var$useDataRouterState($534149a31c60d01f$var$DataRouterStateHook.UseLoaderData);
    let routeId = $534149a31c60d01f$var$useCurrentRouteId($534149a31c60d01f$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $534149a31c60d01f$export$fd5d37484eab868d(routeId) {
    let state = $534149a31c60d01f$var$useDataRouterState($534149a31c60d01f$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $534149a31c60d01f$export$fdc00f3f26066d5e() {
    let state = $534149a31c60d01f$var$useDataRouterState($534149a31c60d01f$var$DataRouterStateHook.UseActionData);
    let routeId = $534149a31c60d01f$var$useCurrentRouteId($534149a31c60d01f$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $534149a31c60d01f$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $eJOHy.useContext($534149a31c60d01f$var$RouteErrorContext);
    let state = $534149a31c60d01f$var$useDataRouterState($534149a31c60d01f$var$DataRouterStateHook.UseRouteError);
    let routeId = $534149a31c60d01f$var$useCurrentRouteId($534149a31c60d01f$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $534149a31c60d01f$export$78a72ddb39bdd145() {
    let value = $eJOHy.useContext($534149a31c60d01f$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $534149a31c60d01f$export$17f53340677d5831() {
    let value = $eJOHy.useContext($534149a31c60d01f$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $534149a31c60d01f$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $534149a31c60d01f$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $534149a31c60d01f$var$useDataRouterContext($534149a31c60d01f$var$DataRouterHook.UseBlocker);
    let state = $534149a31c60d01f$var$useDataRouterState($534149a31c60d01f$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $eJOHy.useState("");
    let blockerFunction = $eJOHy.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $534149a31c60d01f$var$_extends({}, currentLocation, {
                pathname: (0, $ddbcJ.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $534149a31c60d01f$var$_extends({}, nextLocation, {
                pathname: (0, $ddbcJ.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $eJOHy.useEffect(()=>{
        let key = String(++$534149a31c60d01f$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $eJOHy.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $ddbcJ.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $534149a31c60d01f$var$useNavigateStable() {
    let { router: router } = $534149a31c60d01f$var$useDataRouterContext($534149a31c60d01f$var$DataRouterHook.UseNavigateStable);
    let id = $534149a31c60d01f$var$useCurrentRouteId($534149a31c60d01f$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $eJOHy.useRef(false);
    $534149a31c60d01f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eJOHy.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $534149a31c60d01f$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $534149a31c60d01f$var$alreadyWarned$1 = {};
function $534149a31c60d01f$var$warningOnce(key, cond, message) {
    if (!cond && !$534149a31c60d01f$var$alreadyWarned$1[key]) $534149a31c60d01f$var$alreadyWarned$1[key] = true;
}
const $534149a31c60d01f$var$alreadyWarned = {};
function $534149a31c60d01f$var$warnOnce(key, message) {
    if (!$534149a31c60d01f$var$alreadyWarned[message]) {
        $534149a31c60d01f$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $534149a31c60d01f$var$logDeprecation = (flag, msg, link)=>$534149a31c60d01f$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $534149a31c60d01f$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if (!(renderFuture != null && renderFuture.v7_startTransition)) $534149a31c60d01f$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if (!(renderFuture != null && renderFuture.v7_relativeSplatPath) && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $534149a31c60d01f$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (!routerFuture.v7_fetcherPersist) $534149a31c60d01f$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (!routerFuture.v7_normalizeFormMethod) $534149a31c60d01f$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (!routerFuture.v7_partialHydration) $534149a31c60d01f$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (!routerFuture.v7_skipActionErrorRevalidation) $534149a31c60d01f$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $534149a31c60d01f$var$START_TRANSITION = "startTransition";
const $534149a31c60d01f$var$startTransitionImpl = $eJOHy[$534149a31c60d01f$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $534149a31c60d01f$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eJOHy.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eJOHy.useCallback((newState)=>{
        if (v7_startTransition && $534149a31c60d01f$var$startTransitionImpl) $534149a31c60d01f$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eJOHy.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $eJOHy.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eJOHy.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eJOHy.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $eJOHy.useEffect(()=>$534149a31c60d01f$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eJOHy.createElement($eJOHy.Fragment, null, /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $534149a31c60d01f$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $534149a31c60d01f$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $534149a31c60d01f$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $eJOHy.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ddbcJ.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eJOHy.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eJOHy.useCallback((newState)=>{
        v7_startTransition && $534149a31c60d01f$var$startTransitionImpl ? $534149a31c60d01f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eJOHy.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eJOHy.useEffect(()=>$534149a31c60d01f$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $534149a31c60d01f$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$534149a31c60d01f$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $eJOHy.useContext($534149a31c60d01f$export$26749e8557646306);
    let { matches: matches } = $eJOHy.useContext($534149a31c60d01f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $534149a31c60d01f$export$45d76561a5302f2b();
    let navigate = $534149a31c60d01f$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $ddbcJ.resolveTo)(to, (0, $ddbcJ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $eJOHy.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $534149a31c60d01f$export$910ae8079b2c2852(props) {
    return $534149a31c60d01f$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $534149a31c60d01f$export$e7b0ac011bb776c6(_props) {
    (0, $ddbcJ.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $534149a31c60d01f$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $ddbcJ.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$534149a31c60d01f$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $eJOHy.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $534149a31c60d01f$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $ddbcJ.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $eJOHy.useMemo(()=>{
        let trailingPathname = (0, $ddbcJ.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $534149a31c60d01f$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $534149a31c60d01f$export$5d3fca4a98652595($534149a31c60d01f$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $534149a31c60d01f$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$var$ResolveAwait, null, children));
}
var $534149a31c60d01f$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($534149a31c60d01f$var$AwaitRenderStatus || {});
const $534149a31c60d01f$var$neverSettledPromise = new Promise(()=>{});
class $534149a31c60d01f$var$AwaitErrorBoundary extends $eJOHy.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $534149a31c60d01f$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $534149a31c60d01f$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $534149a31c60d01f$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $534149a31c60d01f$var$AwaitRenderStatus.error : "_data" in promise ? $534149a31c60d01f$var$AwaitRenderStatus.success : $534149a31c60d01f$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $534149a31c60d01f$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $534149a31c60d01f$var$AwaitRenderStatus.error && promise._error instanceof (0, $ddbcJ.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $534149a31c60d01f$var$neverSettledPromise;
        if (status === $534149a31c60d01f$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $534149a31c60d01f$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $534149a31c60d01f$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $eJOHy.createElement($534149a31c60d01f$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $534149a31c60d01f$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $534149a31c60d01f$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $eJOHy.createElement($eJOHy.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $534149a31c60d01f$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $eJOHy.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $eJOHy.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $eJOHy.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $534149a31c60d01f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $534149a31c60d01f$export$e7b0ac011bb776c6) && (0, $ddbcJ.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $ddbcJ.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $534149a31c60d01f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $534149a31c60d01f$export$daf73786167a7f72(matches) {
    return $534149a31c60d01f$var$_renderMatches(matches);
}
function $534149a31c60d01f$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $eJOHy.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $eJOHy.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $eJOHy.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $534149a31c60d01f$export$f30f7e456d254e83(routes, opts) {
    return (0, $ddbcJ.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $534149a31c60d01f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ddbcJ.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $534149a31c60d01f$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});
parcelRegister("ddbcJ", function(module, exports) {

$parcel$export(module.exports, "Action", () => $99e52e32e89932ac$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $99e52e32e89932ac$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $99e52e32e89932ac$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $99e52e32e89932ac$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "UNSAFE_invariant", () => $99e52e32e89932ac$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $99e52e32e89932ac$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $99e52e32e89932ac$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $99e52e32e89932ac$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $99e52e32e89932ac$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $99e52e32e89932ac$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $99e52e32e89932ac$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $99e52e32e89932ac$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $99e52e32e89932ac$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $99e52e32e89932ac$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "isRouteErrorResponse", () => $99e52e32e89932ac$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $99e52e32e89932ac$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $99e52e32e89932ac$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $99e52e32e89932ac$var$_extends() {
    $99e52e32e89932ac$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $99e52e32e89932ac$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $99e52e32e89932ac$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($99e52e32e89932ac$export$e19cd5f9376f8cee || ($99e52e32e89932ac$export$e19cd5f9376f8cee = {}));
const $99e52e32e89932ac$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $99e52e32e89932ac$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $99e52e32e89932ac$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $99e52e32e89932ac$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $99e52e32e89932ac$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $99e52e32e89932ac$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to);
    }
    return $99e52e32e89932ac$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $99e52e32e89932ac$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $99e52e32e89932ac$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $99e52e32e89932ac$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $99e52e32e89932ac$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $99e52e32e89932ac$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $99e52e32e89932ac$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $99e52e32e89932ac$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $99e52e32e89932ac$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $99e52e32e89932ac$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $99e52e32e89932ac$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $99e52e32e89932ac$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $99e52e32e89932ac$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $99e52e32e89932ac$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $99e52e32e89932ac$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $99e52e32e89932ac$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($99e52e32e89932ac$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
        let location = $99e52e32e89932ac$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $99e52e32e89932ac$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
        let location = $99e52e32e89932ac$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $99e52e32e89932ac$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $99e52e32e89932ac$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($99e52e32e89932ac$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($99e52e32e89932ac$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $99e52e32e89932ac$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($99e52e32e89932ac$var$ResultType || ($99e52e32e89932ac$var$ResultType = {}));
const $99e52e32e89932ac$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $99e52e32e89932ac$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $99e52e32e89932ac$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $99e52e32e89932ac$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $99e52e32e89932ac$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($99e52e32e89932ac$var$isIndexRoute(route)) {
            let indexRoute = $99e52e32e89932ac$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $99e52e32e89932ac$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $99e52e32e89932ac$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $99e52e32e89932ac$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $99e52e32e89932ac$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $99e52e32e89932ac$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $99e52e32e89932ac$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $99e52e32e89932ac$var$flattenRoutes(routes);
    $99e52e32e89932ac$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $99e52e32e89932ac$export$30d21fd6d7295f52(pathname);
        matches = $99e52e32e89932ac$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $99e52e32e89932ac$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $99e52e32e89932ac$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $99e52e32e89932ac$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $99e52e32e89932ac$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $99e52e32e89932ac$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $99e52e32e89932ac$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $99e52e32e89932ac$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $99e52e32e89932ac$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $99e52e32e89932ac$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $99e52e32e89932ac$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $99e52e32e89932ac$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $99e52e32e89932ac$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $99e52e32e89932ac$var$paramRe = /^:[\w-]+$/;
const $99e52e32e89932ac$var$dynamicSegmentValue = 3;
const $99e52e32e89932ac$var$indexRouteValue = 2;
const $99e52e32e89932ac$var$emptySegmentValue = 1;
const $99e52e32e89932ac$var$staticSegmentValue = 10;
const $99e52e32e89932ac$var$splatPenalty = -2;
const $99e52e32e89932ac$var$isSplat = (s)=>s === "*";
function $99e52e32e89932ac$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($99e52e32e89932ac$var$isSplat)) initialScore += $99e52e32e89932ac$var$splatPenalty;
    if (index) initialScore += $99e52e32e89932ac$var$indexRouteValue;
    return segments.filter((s)=>!$99e52e32e89932ac$var$isSplat(s)).reduce((score, segment)=>score + ($99e52e32e89932ac$var$paramRe.test(segment) ? $99e52e32e89932ac$var$dynamicSegmentValue : segment === "" ? $99e52e32e89932ac$var$emptySegmentValue : $99e52e32e89932ac$var$staticSegmentValue), initialScore);
}
function $99e52e32e89932ac$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $99e52e32e89932ac$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $99e52e32e89932ac$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $99e52e32e89932ac$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $99e52e32e89932ac$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $99e52e32e89932ac$export$a5c6d149b50c1d86($99e52e32e89932ac$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $99e52e32e89932ac$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $99e52e32e89932ac$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $99e52e32e89932ac$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $99e52e32e89932ac$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $99e52e32e89932ac$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $99e52e32e89932ac$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $99e52e32e89932ac$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $99e52e32e89932ac$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $99e52e32e89932ac$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $99e52e32e89932ac$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $99e52e32e89932ac$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $99e52e32e89932ac$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $99e52e32e89932ac$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $99e52e32e89932ac$var$normalizeSearch(search),
        hash: $99e52e32e89932ac$var$normalizeHash(hash)
    };
}
function $99e52e32e89932ac$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $99e52e32e89932ac$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $99e52e32e89932ac$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $99e52e32e89932ac$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $99e52e32e89932ac$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $99e52e32e89932ac$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $99e52e32e89932ac$export$8ccf933b0513f8d0(toArg);
    else {
        to = $99e52e32e89932ac$var$_extends({}, toArg);
        $99e52e32e89932ac$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $99e52e32e89932ac$var$getInvalidPathError("?", "pathname", "search", to));
        $99e52e32e89932ac$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $99e52e32e89932ac$var$getInvalidPathError("#", "pathname", "hash", to));
        $99e52e32e89932ac$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $99e52e32e89932ac$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $99e52e32e89932ac$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $99e52e32e89932ac$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $99e52e32e89932ac$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $99e52e32e89932ac$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $99e52e32e89932ac$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $99e52e32e89932ac$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $99e52e32e89932ac$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $99e52e32e89932ac$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $99e52e32e89932ac$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $99e52e32e89932ac$export$4051a07651545597(data, init) {
    return new $99e52e32e89932ac$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $99e52e32e89932ac$export$42a99a7a4bc0e76a extends Error {
}
class $99e52e32e89932ac$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $99e52e32e89932ac$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $99e52e32e89932ac$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $99e52e32e89932ac$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $99e52e32e89932ac$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $99e52e32e89932ac$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $99e52e32e89932ac$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $99e52e32e89932ac$var$unwrapTrackedPromise(value) {
    if (!$99e52e32e89932ac$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $99e52e32e89932ac$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $99e52e32e89932ac$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $99e52e32e89932ac$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $99e52e32e89932ac$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $99e52e32e89932ac$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $99e52e32e89932ac$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $99e52e32e89932ac$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $99e52e32e89932ac$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $99e52e32e89932ac$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $99e52e32e89932ac$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $99e52e32e89932ac$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $99e52e32e89932ac$var$validMutationMethods = new Set($99e52e32e89932ac$var$validMutationMethodsArr);
const $99e52e32e89932ac$var$validRequestMethodsArr = [
    "get",
    ...$99e52e32e89932ac$var$validMutationMethodsArr
];
const $99e52e32e89932ac$var$validRequestMethods = new Set($99e52e32e89932ac$var$validRequestMethodsArr);
const $99e52e32e89932ac$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $99e52e32e89932ac$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $99e52e32e89932ac$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $99e52e32e89932ac$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $99e52e32e89932ac$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $99e52e32e89932ac$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $99e52e32e89932ac$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $99e52e32e89932ac$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $99e52e32e89932ac$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $99e52e32e89932ac$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $99e52e32e89932ac$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $99e52e32e89932ac$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $99e52e32e89932ac$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $99e52e32e89932ac$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$99e52e32e89932ac$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$99e52e32e89932ac$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $99e52e32e89932ac$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $99e52e32e89932ac$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $99e52e32e89932ac$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $99e52e32e89932ac$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$99e52e32e89932ac$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($99e52e32e89932ac$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $99e52e32e89932ac$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $99e52e32e89932ac$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $99e52e32e89932ac$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $99e52e32e89932ac$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $99e52e32e89932ac$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($99e52e32e89932ac$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $99e52e32e89932ac$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $99e52e32e89932ac$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $99e52e32e89932ac$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $99e52e32e89932ac$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $99e52e32e89932ac$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $99e52e32e89932ac$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $99e52e32e89932ac$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $99e52e32e89932ac$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $99e52e32e89932ac$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $99e52e32e89932ac$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $99e52e32e89932ac$var$findNearestBoundary(matches).route.id,
            {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $99e52e32e89932ac$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($99e52e32e89932ac$var$isErrorResult(result) && $99e52e32e89932ac$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $99e52e32e89932ac$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $99e52e32e89932ac$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $99e52e32e89932ac$var$_extends({
            matches: updatedMatches || matches
        }, $99e52e32e89932ac$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $99e52e32e89932ac$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $99e52e32e89932ac$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $99e52e32e89932ac$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $99e52e32e89932ac$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $99e52e32e89932ac$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: $99e52e32e89932ac$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($99e52e32e89932ac$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $99e52e32e89932ac$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($99e52e32e89932ac$var$isDeferredResult(result)) throw $99e52e32e89932ac$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $99e52e32e89932ac$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $99e52e32e89932ac$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($99e52e32e89932ac$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $99e52e32e89932ac$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $99e52e32e89932ac$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $99e52e32e89932ac$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $99e52e32e89932ac$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $99e52e32e89932ac$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $99e52e32e89932ac$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $99e52e32e89932ac$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $99e52e32e89932ac$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $99e52e32e89932ac$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$99e52e32e89932ac$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $99e52e32e89932ac$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $99e52e32e89932ac$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $99e52e32e89932ac$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $99e52e32e89932ac$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $99e52e32e89932ac$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $99e52e32e89932ac$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $99e52e32e89932ac$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $99e52e32e89932ac$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $99e52e32e89932ac$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $99e52e32e89932ac$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $99e52e32e89932ac$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($99e52e32e89932ac$var$isRedirectResult(actionResult) || $99e52e32e89932ac$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($99e52e32e89932ac$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $99e52e32e89932ac$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($99e52e32e89932ac$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($99e52e32e89932ac$var$isDeferredResult(actionResult)) throw $99e52e32e89932ac$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $99e52e32e89932ac$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $99e52e32e89932ac$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $99e52e32e89932ac$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $99e52e32e89932ac$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $99e52e32e89932ac$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $99e52e32e89932ac$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $99e52e32e89932ac$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $99e52e32e89932ac$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $99e52e32e89932ac$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $99e52e32e89932ac$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $99e52e32e89932ac$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $99e52e32e89932ac$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $99e52e32e89932ac$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $99e52e32e89932ac$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $99e52e32e89932ac$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($99e52e32e89932ac$var$isDeferredResult(result)) result = await $99e52e32e89932ac$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($99e52e32e89932ac$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $99e52e32e89932ac$export$3e9cee6b33872309(!$99e52e32e89932ac$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $99e52e32e89932ac$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $99e52e32e89932ac$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $99e52e32e89932ac$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($99e52e32e89932ac$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $99e52e32e89932ac$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace : $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $99e52e32e89932ac$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($99e52e32e89932ac$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $99e52e32e89932ac$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $99e52e32e89932ac$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $99e52e32e89932ac$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $99e52e32e89932ac$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $99e52e32e89932ac$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($99e52e32e89932ac$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $99e52e32e89932ac$var$ResultType.redirect,
                response: $99e52e32e89932ac$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $99e52e32e89932ac$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $99e52e32e89932ac$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $99e52e32e89932ac$var$ResultType.error,
                    error: $99e52e32e89932ac$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $99e52e32e89932ac$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $99e52e32e89932ac$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $99e52e32e89932ac$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $99e52e32e89932ac$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $99e52e32e89932ac$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $99e52e32e89932ac$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $99e52e32e89932ac$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $99e52e32e89932ac$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $99e52e32e89932ac$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $99e52e32e89932ac$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $99e52e32e89932ac$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$99e52e32e89932ac$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $99e52e32e89932ac$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $99e52e32e89932ac$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $99e52e32e89932ac$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $99e52e32e89932ac$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $99e52e32e89932ac$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $99e52e32e89932ac$export$4d0306f8f6a4585b = Symbol("deferred");
function $99e52e32e89932ac$export$3336b097a6fbc59a(routes, opts) {
    $99e52e32e89932ac$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $99e52e32e89932ac$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $99e52e32e89932ac$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $99e52e32e89932ac$var$createLocation("", $99e52e32e89932ac$export$fe53371bee54353d(url), null, "default");
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$99e52e32e89932ac$var$isValidMethod(method) && method !== "HEAD") {
            let error = $99e52e32e89932ac$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $99e52e32e89932ac$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($99e52e32e89932ac$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $99e52e32e89932ac$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $99e52e32e89932ac$var$createLocation("", $99e52e32e89932ac$export$fe53371bee54353d(url), null, "default");
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$99e52e32e89932ac$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $99e52e32e89932ac$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $99e52e32e89932ac$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $99e52e32e89932ac$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($99e52e32e89932ac$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$99e52e32e89932ac$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $99e52e32e89932ac$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($99e52e32e89932ac$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $99e52e32e89932ac$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $99e52e32e89932ac$var$isResponse(result) ? result : $99e52e32e89932ac$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($99e52e32e89932ac$var$isDataStrategyResult(e) && $99e52e32e89932ac$var$isResponse(e.result)) {
                if (e.type === $99e52e32e89932ac$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($99e52e32e89932ac$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $99e52e32e89932ac$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $99e52e32e89932ac$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($99e52e32e89932ac$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($99e52e32e89932ac$var$isDeferredResult(result)) {
            let error = $99e52e32e89932ac$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($99e52e32e89932ac$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $99e52e32e89932ac$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $99e52e32e89932ac$var$_extends({}, context, {
                statusCode: $99e52e32e89932ac$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $99e52e32e89932ac$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $99e52e32e89932ac$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $99e52e32e89932ac$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $99e52e32e89932ac$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $99e52e32e89932ac$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $99e52e32e89932ac$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $99e52e32e89932ac$var$callDataStrategyImpl(dataStrategy || $99e52e32e89932ac$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($99e52e32e89932ac$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $99e52e32e89932ac$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($99e52e32e89932ac$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $99e52e32e89932ac$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $99e52e32e89932ac$export$fec11da027c70692(routes, context, error) {
    let newContext = $99e52e32e89932ac$var$_extends({}, context, {
        statusCode: $99e52e32e89932ac$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $99e52e32e89932ac$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $99e52e32e89932ac$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $99e52e32e89932ac$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $99e52e32e89932ac$export$cae722b0cc860f13(to ? to : ".", $99e52e32e89932ac$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $99e52e32e89932ac$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $99e52e32e89932ac$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $99e52e32e89932ac$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $99e52e32e89932ac$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $99e52e32e89932ac$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$99e52e32e89932ac$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$99e52e32e89932ac$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $99e52e32e89932ac$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $99e52e32e89932ac$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $99e52e32e89932ac$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$99e52e32e89932ac$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$99e52e32e89932ac$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $99e52e32e89932ac$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $99e52e32e89932ac$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $99e52e32e89932ac$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $99e52e32e89932ac$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $99e52e32e89932ac$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($99e52e32e89932ac$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $99e52e32e89932ac$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $99e52e32e89932ac$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $99e52e32e89932ac$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $99e52e32e89932ac$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $99e52e32e89932ac$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($99e52e32e89932ac$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $99e52e32e89932ac$var$shouldRevalidateLoader(match, $99e52e32e89932ac$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $99e52e32e89932ac$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $99e52e32e89932ac$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $99e52e32e89932ac$var$shouldRevalidateLoader(fetcherMatch, $99e52e32e89932ac$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $99e52e32e89932ac$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $99e52e32e89932ac$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $99e52e32e89932ac$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $99e52e32e89932ac$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $99e52e32e89932ac$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $99e52e32e89932ac$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$99e52e32e89932ac$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $99e52e32e89932ac$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$99e52e32e89932ac$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $99e52e32e89932ac$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $99e52e32e89932ac$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $99e52e32e89932ac$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$99e52e32e89932ac$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $99e52e32e89932ac$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $99e52e32e89932ac$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $99e52e32e89932ac$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $99e52e32e89932ac$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $99e52e32e89932ac$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $99e52e32e89932ac$var$ResultType.data,
                result: undefined
            });
        };
        return $99e52e32e89932ac$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $99e52e32e89932ac$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $99e52e32e89932ac$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $99e52e32e89932ac$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $99e52e32e89932ac$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $99e52e32e89932ac$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $99e52e32e89932ac$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $99e52e32e89932ac$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($99e52e32e89932ac$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: e
            };
        }
        if (type === $99e52e32e89932ac$var$ResultType.error) return {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: new $99e52e32e89932ac$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $99e52e32e89932ac$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $99e52e32e89932ac$var$ResultType.error) {
        if ($99e52e32e89932ac$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $99e52e32e89932ac$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $99e52e32e89932ac$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: result,
            statusCode: $99e52e32e89932ac$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($99e52e32e89932ac$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $99e52e32e89932ac$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($99e52e32e89932ac$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $99e52e32e89932ac$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $99e52e32e89932ac$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $99e52e32e89932ac$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $99e52e32e89932ac$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$99e52e32e89932ac$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $99e52e32e89932ac$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $99e52e32e89932ac$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($99e52e32e89932ac$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $99e52e32e89932ac$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $99e52e32e89932ac$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($99e52e32e89932ac$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $99e52e32e89932ac$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $99e52e32e89932ac$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $99e52e32e89932ac$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $99e52e32e89932ac$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $99e52e32e89932ac$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $99e52e32e89932ac$export$3e9cee6b33872309(!$99e52e32e89932ac$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $99e52e32e89932ac$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($99e52e32e89932ac$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $99e52e32e89932ac$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $99e52e32e89932ac$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $99e52e32e89932ac$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($99e52e32e89932ac$var$isErrorResult(result)) {
            let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $99e52e32e89932ac$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($99e52e32e89932ac$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $99e52e32e89932ac$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($99e52e32e89932ac$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $99e52e32e89932ac$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $99e52e32e89932ac$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $99e52e32e89932ac$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $99e52e32e89932ac$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $99e52e32e89932ac$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $99e52e32e89932ac$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $99e52e32e89932ac$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $99e52e32e89932ac$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $99e52e32e89932ac$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $99e52e32e89932ac$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($99e52e32e89932ac$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $99e52e32e89932ac$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(path) : path;
    return $99e52e32e89932ac$export$fe53371bee54353d($99e52e32e89932ac$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $99e52e32e89932ac$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $99e52e32e89932ac$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $99e52e32e89932ac$var$ResultType.data || result.type === $99e52e32e89932ac$var$ResultType.error);
}
function $99e52e32e89932ac$var$isRedirectDataStrategyResultResult(result) {
    return $99e52e32e89932ac$var$isResponse(result.result) && $99e52e32e89932ac$var$redirectStatusCodes.has(result.result.status);
}
function $99e52e32e89932ac$var$isDeferredResult(result) {
    return result.type === $99e52e32e89932ac$var$ResultType.deferred;
}
function $99e52e32e89932ac$var$isErrorResult(result) {
    return result.type === $99e52e32e89932ac$var$ResultType.error;
}
function $99e52e32e89932ac$var$isRedirectResult(result) {
    return (result && result.type) === $99e52e32e89932ac$var$ResultType.redirect;
}
function $99e52e32e89932ac$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $99e52e32e89932ac$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $99e52e32e89932ac$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $99e52e32e89932ac$var$isRedirectResponse(result) {
    if (!$99e52e32e89932ac$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $99e52e32e89932ac$var$isValidMethod(method) {
    return $99e52e32e89932ac$var$validRequestMethods.has(method.toLowerCase());
}
function $99e52e32e89932ac$var$isMutationMethod(method) {
    return $99e52e32e89932ac$var$validMutationMethods.has(method.toLowerCase());
}
async function $99e52e32e89932ac$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$99e52e32e89932ac$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($99e52e32e89932ac$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $99e52e32e89932ac$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $99e52e32e89932ac$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($99e52e32e89932ac$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $99e52e32e89932ac$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $99e52e32e89932ac$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $99e52e32e89932ac$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $99e52e32e89932ac$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $99e52e32e89932ac$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $99e52e32e89932ac$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $99e52e32e89932ac$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $99e52e32e89932ac$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $99e52e32e89932ac$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $99e52e32e89932ac$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $99e52e32e89932ac$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $99e52e32e89932ac$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $99e52e32e89932ac$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $99e52e32e89932ac$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $99e52e32e89932ac$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $99e52e32e89932ac$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($99e52e32e89932ac$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $99e52e32e89932ac$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($99e52e32e89932ac$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $99e52e32e89932ac$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});


parcelRegister("eSxF2", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ALLOWED_FEATURES", () => $1b73ed7f1dee66f6$export$a33327ada3a6ee4a);
$parcel$export(module.exports, "getAllowedFeatures", () => $1b73ed7f1dee66f6$export$3207c60940c4a9b0);

var $eVetS = parcelRequire("eVetS");
var $3sdFo = parcelRequire("3sdFo");
var $1b73ed7f1dee66f6$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $1b73ed7f1dee66f6$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        'template-browser',
        'inline-comments',
        'disable-publish-close-buttons'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $1b73ed7f1dee66f6$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $1b73ed7f1dee66f6$var$pageAllowedFeatures = {
    [(0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $1b73ed7f1dee66f6$export$a3fda3dcee62e1cc.edit,
    [(0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $1b73ed7f1dee66f6$export$a3fda3dcee62e1cc.view
};
const $1b73ed7f1dee66f6$var$blogPostAllowedFeatures = {
    [(0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $1b73ed7f1dee66f6$export$a3fda3dcee62e1cc.edit,
    [(0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $1b73ed7f1dee66f6$export$a3fda3dcee62e1cc.view
};
const $1b73ed7f1dee66f6$var$whiteboardAllowedFeatures = {
    [(0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $1b73ed7f1dee66f6$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $1b73ed7f1dee66f6$export$a3fda3dcee62e1cc.whiteboard
};
const $1b73ed7f1dee66f6$var$contentTypeAllowedFeatures = {
    [(0, $eVetS.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $1b73ed7f1dee66f6$var$pageAllowedFeatures,
    [(0, $eVetS.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $1b73ed7f1dee66f6$var$blogPostAllowedFeatures,
    [(0, $eVetS.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $1b73ed7f1dee66f6$var$whiteboardAllowedFeatures
};
const $1b73ed7f1dee66f6$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$1b73ed7f1dee66f6$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];

});
parcelRegister("eVetS", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_CONTENT_TYPE", () => $79761a298495b709$export$942a5fac9b8c9dc2);
var $79761a298495b709$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});

});


parcelRegister("eVRlo", function(module, exports) {

$parcel$export(module.exports, "EDIT_PAGE_EMBED", () => $63ee1853c326457f$export$e63a462ee45b57cf);
$parcel$export(module.exports, "EDIT_PAGE_V2", () => $63ee1853c326457f$export$7b1285e36c635f1f);
$parcel$export(module.exports, "VIEW_PAGE", () => $63ee1853c326457f$export$9257b5b55c8e2555);
$parcel$export(module.exports, "VIEW_BLOG", () => $63ee1853c326457f$export$91f49e7b30a9d34);
$parcel$export(module.exports, "VIEW_BLOG_DATE_LEGACY", () => $63ee1853c326457f$export$bd2c9bb170b3681d);
$parcel$export(module.exports, "WHITEBOARD", () => $63ee1853c326457f$export$fbefbcc1445e8d74);
$parcel$export(module.exports, "namedRoutes", () => $63ee1853c326457f$export$d4971375353d0454);
$parcel$export(module.exports, "EMBEDDED_PARENT_PRODUCTS", () => $63ee1853c326457f$export$5c59aa0922e65f1a);
const $63ee1853c326457f$export$e63a462ee45b57cf = {
    name: 'EDIT_PAGE_EMBED',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-embed/:contentId/:contentSlug?'
};
const $63ee1853c326457f$export$7b1285e36c635f1f = {
    name: 'EDIT_PAGE_V2',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-v2/:contentId/:contentSlug?'
};
const $63ee1853c326457f$export$65b723bb995d4fb6 = {
    name: 'SPACE_OVERVIEW',
    pattern: '/wiki/spaces/:spaceKey/overview'
};
const $63ee1853c326457f$export$9257b5b55c8e2555 = {
    name: 'VIEW_PAGE',
    pattern: '/wiki/spaces/:spaceKey/pages/:contentId/:contentSlug?'
};
const $63ee1853c326457f$export$91f49e7b30a9d34 = {
    name: 'VIEW_BLOG',
    pattern: '/wiki/spaces/:spaceKey/blog/:contentId/:contentSlug?'
};
const $63ee1853c326457f$export$bd2c9bb170b3681d = {
    name: 'VIEW_BLOG_DATE_LEGACY',
    pattern: '/wiki/spaces/:spaceKey/blog/:year/:month/:day/:contentId/:contentSlug?'
};
const $63ee1853c326457f$export$fbefbcc1445e8d74 = {
    name: 'WHITEBOARD',
    pattern: '/wiki/spaces/:spaceKey/whiteboard/:contentId/:contentSlug?'
};
const $63ee1853c326457f$export$d4971375353d0454 = {
    EDIT_PAGE_EMBED: $63ee1853c326457f$export$e63a462ee45b57cf,
    EDIT_PAGE_V2: $63ee1853c326457f$export$7b1285e36c635f1f,
    SPACE_OVERVIEW: $63ee1853c326457f$export$65b723bb995d4fb6,
    VIEW_PAGE: $63ee1853c326457f$export$9257b5b55c8e2555,
    VIEW_BLOG: $63ee1853c326457f$export$91f49e7b30a9d34,
    VIEW_BLOG_DATE_LEGACY: $63ee1853c326457f$export$bd2c9bb170b3681d,
    WHITEBOARD: $63ee1853c326457f$export$fbefbcc1445e8d74
};
const $63ee1853c326457f$export$5c59aa0922e65f1a = {
    JSM_PORTAL: 'JSM-Portal',
    JSM: 'JSM',
    JSW: 'JSW',
    JWM: 'JWM'
};

});


parcelRegister("ajyyy", function(module, exports) {

$parcel$export(module.exports, "ConfluenceContentTypes", () => $7b8095db702ea031$export$b39616d00ee96d40);
$parcel$export(module.exports, "DisplayTypes", () => $7b8095db702ea031$export$c294d3f3727c1a0);
const $7b8095db702ea031$export$b39616d00ee96d40 = {
    WHITEBOARD: 'whiteboard',
    PAGE: 'page'
};
const $7b8095db702ea031$export$c294d3f3727c1a0 = {
    MODAL: 'modal',
    PANEL: 'panel'
};

});


parcelRegister("lYAmh", function(module, exports) {

$parcel$export(module.exports, "getDisplayInformation", () => $123b26f4f0abb32c$export$ee79869f97207574);
$parcel$export(module.exports, "convertUrlByContentState", () => $123b26f4f0abb32c$export$d41c9cdfa202e9a7);

var $3sdFo = parcelRequire("3sdFo");

var $ajyyy = parcelRequire("ajyyy");
const $123b26f4f0abb32c$export$37e31995727dc8d7 = 0.5;
const $123b26f4f0abb32c$export$ee79869f97207574 = ()=>{
    /*
	We set the screen width to 50% of the screen width if the screen
	width is larger than 1024px because we want the Embedded Confluence in the side panel to
	take up half the screen width. The max of the side panel is 50% of the screen width and
	we are not able to set it wider. Jira Issue details panel will be forced down around 1875px
	screen width.
	If the screen width is less than 1024px, we'll set the panel width to 0 because we will be
	opening the EmbeddedContentModal instead and set displayType to Modal.
	This also assumes that we are currently on the full page version of a Jira Issue.
	*/ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1024) return {
        initialWidth: screenWidth * $123b26f4f0abb32c$export$37e31995727dc8d7,
        displayType: (0, $ajyyy.DisplayTypes).PANEL
    };
    return {
        initialWidth: 0,
        displayType: (0, $ajyyy.DisplayTypes).MODAL
    };
};
const $123b26f4f0abb32c$export$d41c9cdfa202e9a7 = ({ mode: mode, isDraft: isDraft, contentUrl: contentUrl, spaceKey: spaceKey })=>{
    // update spaceKey
    let newUrl = contentUrl.replace(/\/spaces\/.*?\/pages\//, `/spaces/${spaceKey}/pages/`);
    if (!isDraft) {
        // remove `draftShareId={id}` and the preceding `&` if it exists
        newUrl = newUrl.replace(/[&]*draftShareId=[^&]*/, '');
        if (mode === (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE) {
            if (!newUrl.includes('edit-embed')) newUrl = newUrl.replace('/pages/', '/pages/edit-embed/');
        } else if (mode === (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) // Replaces /pages/edit-v2/ or /pages/edit-embed/ with /pages/
        newUrl = newUrl.replace(/\/pages\/edit[^/]*\//, '/pages/');
    }
    return newUrl;
};

});


parcelRegister("80rW8", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPanelEntryPoint", () => $8712743e7c4b6c83$export$75ef2f025ecbf1de);

var $eJOHy = parcelRequire("eJOHy");

var $5M7r5 = parcelRequire("5M7r5");

var $3sdFo = parcelRequire("3sdFo");
var $3pzvh = parcelRequire("3pzvh");

var $vztq1 = parcelRequire("vztq1");

var $lYAmh = parcelRequire("lYAmh");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $iIbix = parcelRequire("iIbix");

var $4NvcV = parcelRequire("4NvcV");

var $2khbo = parcelRequire("2khbo");

var $7UlSU = parcelRequire("7UlSU");

var $cBx21 = parcelRequire("cBx21");

var $fBOqJ = parcelRequire("fBOqJ");

var $1u0iy = parcelRequire("1u0iy");

var $1VTE7 = parcelRequire("1VTE7");

var $iiTqV = parcelRequire("iiTqV");
const $8712743e7c4b6c83$var$entryPointParams = {};
const $8712743e7c4b6c83$export$12346a674644c156 = 'operational';
const $8712743e7c4b6c83$export$b81d6f4511cb89a5 = (action, eventName, params)=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent, setConfluenceData: setConfluenceData, contentUrl: contentUrl, embeddedConfluenceSourceForPanel: embeddedConfluenceSourceForPanel, isOpen: isOpen, mode: mode } = params;
    fireAnalyticsEvent({
        action: action,
        eventName: eventName,
        embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
        eventType: $8712743e7c4b6c83$export$12346a674644c156
    });
    if (isOpen) {
        if (eventName === 'edit-page/close') setConfluenceData({
            contentUrl: contentUrl,
            mode: (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
        });
        if (eventName === 'edit-page/load' && action === 'taskSuccess') {
            if (mode === (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) setConfluenceData({
                contentUrl: contentUrl,
                mode: (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE
            });
        }
        if (eventName === 'edit-page/publish' && action === 'taskSuccess') {
            if (mode === (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE) setConfluenceData({
                isDraft: false,
                contentUrl: contentUrl,
                mode: (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
            });
        }
    }
};
const $8712743e7c4b6c83$export$75ef2f025ecbf1de = ()=>{
    const { locale: locale } = (0, $lRq8t.default)();
    const [state, actions] = (0, $vztq1.useEmbeddedConfluenceSidePanel)();
    const { contentType: contentType, confluenceData: { contentId: contentId, contentUrl: contentUrl, hostname: hostname, isLive: isLive, isDraft: isDraft, title: title, mode: mode }, isDeferSpaceSelection: isDeferSpaceSelection, contentActions: { onLinkPage: onLinkPage }, panel: { isOpen: isOpen, isExpanded: isExpanded }, embeddedConfluenceSource: embeddedConfluenceSource } = state;
    const isPageDraft = isDraft && contentType === (0, $4NvcV.CONTENT_TYPE).PAGE;
    const parentProduct = (0, $1VTE7.useParentProduct)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $7UlSU.embeddedPanelEntrypoint), $8712743e7c4b6c83$var$entryPointParams);
    const embeddedConfluenceSourceForPanel = `${embeddedConfluenceSource}Panel`;
    const fireAnalyticsEvent = (0, $1u0iy.useEmbeddedPageTracking)();
    const themeState = (0, $5M7r5.default)();
    /*
  	If the user is on a custom domain, we need to update the
  	hostname to reflect the parentProduct's hostname. By providing the hostname
  	prop we will force EP to use the parentProduct's hostname instead of the content's hostname
  	when on a custom domain (see EP code here https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/confluence/embedded-confluence-common/src/page/parsePageProps.ts#75).
  */ const contentHostname = (0, $cBx21.setHostnameForContent)(contentUrl, hostname);
    const onContentAction = (0, $eJOHy.useCallback)((action, eventName)=>{
        $8712743e7c4b6c83$export$b81d6f4511cb89a5(action, eventName, {
            fireAnalyticsEvent: fireAnalyticsEvent,
            setConfluenceData: actions.setConfluenceData,
            contentUrl: contentUrl,
            embeddedConfluenceSourceForPanel: embeddedConfluenceSourceForPanel,
            isOpen: isOpen,
            mode: mode
        });
    }, [
        actions,
        contentUrl,
        fireAnalyticsEvent,
        embeddedConfluenceSourceForPanel,
        isOpen,
        mode
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            eventName: 'closeEmbeddedConfluencePanel',
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel
        });
        entryPointActions.unload();
        actions.closeSidePanel();
    }, [
        actions,
        fireAnalyticsEvent,
        entryPointActions,
        embeddedConfluenceSourceForPanel
    ]);
    const editAllowedFeatures = (0, $eJOHy.useMemo)(()=>[
            ...isDeferSpaceSelection ? [
                'publish-modal'
            ] : [],
            'template-browser'
        ], [
        isDeferSpaceSelection
    ]);
    const shouldApplyEditFeatures = editAllowedFeatures.length > 0 && isDraft;
    const shouldOpenPanel = isOpen && contentUrl;
    const { entryPointActions: epDraftModalActions, entryPointReferenceSubject: epDraftModalSubject } = (0, $bbdV2.useEntryPoint)((0, $2khbo.draftEmbeddedPageModalEntrypoint), {});
    const { entryPointActions: epModalActions, entryPointReferenceSubject: epModalSubject } = (0, $bbdV2.useEntryPoint)((0, $iIbix.embeddedConfluencePageModalEntrypoint), {});
    const { entryPointActions: whiteboardModalActions, entryPointReferenceSubject: whiteboardModalSubject } = (0, $bbdV2.useEntryPoint)((0, $iiTqV.embeddedWhiteboardModalEntrypoint), {});
    const { openContinueDraftModal: openContinueDraftModal, handleEmbeddedContentAction: handleDraftContentAction, epMode: epMode } = (0, $fBOqJ.useEmbeddedPageDraft)({
        url: contentUrl,
        isLive: isLive,
        embeddedConfluenceSource: embeddedConfluenceSource,
        onEmbeddedContentAction: onContentAction,
        onClose: onClose,
        linkConfluencePage: onLinkPage
    });
    const handleOnModalClose = (0, $eJOHy.useCallback)(()=>{
        actions.closeSidePanel();
        if (contentType === 'whiteboard' && (0, $7jTnu.fg)('jira_issue_view_modeless_whiteboard')) whiteboardModalActions.unload();
        else if (contentType === 'page') isPageDraft ? epDraftModalActions.unload() : epModalActions.unload();
    }, [
        actions,
        isPageDraft,
        epDraftModalActions,
        epModalActions,
        whiteboardModalActions,
        contentType
    ]);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            locale: locale,
            hasFooterLogo: false,
            isDraft: isDraft,
            isLive: isLive,
            hostname: contentHostname,
            panelTitle: title,
            navigationPolicy: undefined,
            onClose: onClose,
            onContentAction: onContentAction,
            parentProduct: parentProduct,
            spaceKey: (0, $3pzvh.parseUrl)(contentUrl)?.spaceKey,
            themeState: themeState,
            url: (0, $lYAmh.convertUrlByContentState)({
                mode: mode,
                isDraft: isDraft,
                contentUrl: contentUrl,
                spaceKey: (0, $3pzvh.parseUrl)(contentUrl)?.spaceKey
            }),
            mode: isPageDraft ? epMode : mode,
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
            contentId: contentId,
            contentType: contentType,
            onPublish: actions.setDeferredSpaceData,
            allowedFeatures: {
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-comments',
                    'page-reactions',
                    'inline-comments',
                    'non-licensed-share'
                ],
                ...shouldApplyEditFeatures && {
                    edit: editAllowedFeatures
                }
            },
            linkConfluencePage: onLinkPage
        }), [
        actions.setDeferredSpaceData,
        contentId,
        contentUrl,
        editAllowedFeatures,
        embeddedConfluenceSourceForPanel,
        contentHostname,
        isDraft,
        isLive,
        locale,
        title,
        mode,
        epMode,
        onClose,
        onContentAction,
        onLinkPage,
        parentProduct,
        themeState,
        shouldApplyEditFeatures,
        isPageDraft,
        contentType
    ]);
    const whiteboardModalRuntimeProps = (0, $eJOHy.useMemo)(()=>({
            isOpen: true,
            locale: locale,
            hasFooterLogo: false,
            hostname: contentHostname,
            panelTitle: title,
            navigationPolicy: undefined,
            enableContract: true,
            onClose: onClose,
            onEmbeddedContentAction: onContentAction,
            onContract: actions.toggleExpandedState,
            parentProduct: parentProduct,
            spaceKey: (0, $3pzvh.parseUrl)(contentUrl)?.spaceKey,
            themeState: themeState,
            url: contentUrl,
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
            contentId: contentId || (0, $3pzvh.parseUrl)(contentUrl)?.contentId || '',
            contentType: contentType
        }), [
        contentId,
        contentType,
        contentUrl,
        embeddedConfluenceSourceForPanel,
        contentHostname,
        locale,
        title,
        onClose,
        onContentAction,
        parentProduct,
        themeState,
        actions.toggleExpandedState
    ]);
    const epModalRuntimeProps = (0, $eJOHy.useMemo)(()=>({
            locale: locale,
            hasFooterLogo: false,
            isDraft: isDraft,
            isOpen: true,
            enableContract: true,
            onClose: ()=>{
                isPageDraft ? openContinueDraftModal() : handleOnModalClose();
            },
            onContract: actions.toggleExpandedState,
            parentProduct: parentProduct,
            url: (0, $lYAmh.convertUrlByContentState)({
                mode: mode,
                isDraft: isDraft,
                contentUrl: contentUrl,
                spaceKey: (0, $3pzvh.parseUrl)(contentUrl)?.spaceKey
            }),
            mode: isPageDraft ? epMode : mode,
            isLive: isLive,
            embeddedConfluenceSource: embeddedConfluenceSource,
            spaceKey: (0, $3pzvh.parseUrl)(contentUrl)?.spaceKey,
            contentId: (0, $3pzvh.parseUrl)(contentUrl)?.contentId,
            onPublish: actions.setDeferredSpaceData,
            allowedFeatures: {
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-comments',
                    'page-reactions',
                    'inline-comments',
                    'non-licensed-share'
                ],
                ...shouldApplyEditFeatures && {
                    edit: editAllowedFeatures
                }
            },
            linkConfluencePage: onLinkPage,
            themeState: themeState,
            onPageAction: isPageDraft ? handleDraftContentAction : onContentAction,
            navigationPolicy: undefined,
            hostname: contentHostname,
            isFullScreenEmbedView: true
        }), [
        locale,
        isDraft,
        actions.toggleExpandedState,
        actions.setDeferredSpaceData,
        parentProduct,
        isPageDraft,
        mode,
        epMode,
        contentUrl,
        isLive,
        embeddedConfluenceSource,
        themeState,
        handleDraftContentAction,
        onContentAction,
        contentHostname,
        openContinueDraftModal,
        handleOnModalClose,
        onLinkPage,
        editAllowedFeatures,
        shouldApplyEditFeatures
    ]);
    const setEntrypointActions = ()=>{
        if (!isExpanded) return entryPointActions;
        if (contentType === 'whiteboard' && (0, $7jTnu.fg)('jira_issue_view_modeless_whiteboard')) return whiteboardModalActions;
        if (contentType === 'page' && (0, $7jTnu.fg)('jira_issue_view_modeless_whiteboard')) return isDraft ? epDraftModalActions : epModalActions;
        // TODO remove this when cleaning up jira_issue_view_modeless_whiteboard
        return isDraft ? epDraftModalActions : epModalActions;
    };
    const setExpandedEntryPointData = ()=>{
        if (contentType === 'page') {
            if (isDraft) return {
                id: 'epDraftModalEntrypointContainer',
                entryPointReferenceSubject: epDraftModalSubject,
                runtimeProps: epModalRuntimeProps
            };
            return {
                id: 'epModalEntrypointContainer',
                entryPointReferenceSubject: epModalSubject,
                runtimeProps: epModalRuntimeProps
            };
        }
        if (contentType === 'whiteboard') return {
            id: 'embeddedWhiteboardModalEntrypointContainer',
            entryPointReferenceSubject: whiteboardModalSubject,
            runtimeProps: whiteboardModalRuntimeProps
        };
    };
    const entryPointData = setExpandedEntryPointData();
    // TODO remove this when cleaning up fg('jira_issue_view_modeless_whiteboard')
    const entryPointIdOld = isPageDraft ? 'epDraftModalEntrypointContainer' : 'epModalEntrypointContainer';
    // TODO remove this when cleaning up fg('jira_issue_view_modeless_whiteboard')
    const entryPointSubjectOld = isPageDraft ? epDraftModalSubject : epModalSubject;
    const expandedEntryPointContainer = ()=>{
        if ((0, $7jTnu.fg)('jira_issue_view_modeless_whiteboard')) {
            if (contentType === 'page') {
                if (isDraft) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                    entryPointReferenceSubject: epDraftModalSubject,
                    id: "epDraftModalEntrypointContainer",
                    packageName: "@atlassian/jira-issue-create-confluence-content",
                    teamName: "confluence-better-together",
                    runtimeProps: epModalRuntimeProps
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                    entryPointReferenceSubject: epModalSubject,
                    id: "epModalEntrypointContainer",
                    packageName: "@atlassian/jira-issue-create-confluence-content",
                    teamName: "confluence-better-together",
                    runtimeProps: epModalRuntimeProps
                });
            }
            if (contentType === 'whiteboard') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: whiteboardModalSubject,
                id: "embeddedWhiteboardModalEntrypointContainer",
                packageName: "@atlassian/jira-issue-create-confluence-content",
                teamName: "confluence-better-together",
                runtimeProps: whiteboardModalRuntimeProps
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointSubjectOld,
            id: entryPointIdOld,
            packageName: "@atlassian/jira-issue-create-confluence-content",
            teamName: "confluence-better-together",
            runtimeProps: epModalRuntimeProps
        });
    };
    return shouldOpenPanel && entryPointData ? {
        entryPointActions: setEntrypointActions(),
        entryPoint: isExpanded ? expandedEntryPointContainer() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "epPanelEntrypointContainer",
            packageName: "@atlassian/jira-issue-create-confluence-content",
            teamName: "confluence-better-together",
            runtimeProps: runtimeProps
        })
    } : {
        ref: undefined,
        entryPoint: null
    };
};

});
parcelRegister("iIbix", function(module, exports) {

$parcel$export(module.exports, "embeddedConfluencePageModalEntrypoint", () => $b5642349ee0495da$export$2798102ac94287d0);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $b5642349ee0495da$export$2798102ac94287d0 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("lTTqA")), {
        moduleId: "73170883",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lTTqA", function(module, exports) {

let $ff19bad4b1e41a5c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ff19bad4b1e41a5c$var$load("bIsJp").then(()=>parcelRequire('avGlQ'));

});


parcelRegister("4NvcV", function(module, exports) {

$parcel$export(module.exports, "LINK_CREATE_DRAFT_STATUS", () => $8de3213391b5815c$export$b86d51ea0323efca);
$parcel$export(module.exports, "CONTENT_TYPE", () => $8de3213391b5815c$export$a982aaff75f1c348);
$parcel$export(module.exports, "CONTENT_TYPE_TO_ENTITY_KEYS", () => $8de3213391b5815c$export$de75e0e058bd457c);

var $bVH5F = parcelRequire("bVH5F");
const $8de3213391b5815c$export$b86d51ea0323efca = 'draft';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $8de3213391b5815c$var$LINK_CREATE_PUBLISH_STATUS = 'current';
const $8de3213391b5815c$export$a982aaff75f1c348 = {
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
const $8de3213391b5815c$export$de75e0e058bd457c = {
    [$8de3213391b5815c$export$a982aaff75f1c348.PAGE]: (0, $bVH5F.entityKeys).confluencePage,
    [$8de3213391b5815c$export$a982aaff75f1c348.WHITEBOARD]: (0, $bVH5F.entityKeys).confluenceWhiteboard
};

});
parcelRegister("bVH5F", function(module, exports) {

$parcel$export(module.exports, "entityKeys", () => $f97d56dcf278ff25$export$be0551febfd6121e);
$parcel$export(module.exports, "ContentTypes", () => $f97d56dcf278ff25$export$b9e669a853ca2f38);
$parcel$export(module.exports, "Fields", () => $f97d56dcf278ff25$export$833b3e5a19fb8939);
$parcel$export(module.exports, "testIds", () => $f97d56dcf278ff25$export$800daf5fbbe96aff);
$parcel$export(module.exports, "CONFLUENCE_EVENT_NAME", () => $f97d56dcf278ff25$export$c312550dc4e28902);
const $f97d56dcf278ff25$export$be0551febfd6121e = {
    confluencePage: 'confluence-page',
    confluenceWhiteboard: 'confluence-whiteboard'
};
const $f97d56dcf278ff25$export$b9e669a853ca2f38 = {
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
var $f97d56dcf278ff25$export$833b3e5a19fb8939 = /*#__PURE__*/ function(Fields) {
    Fields["Title"] = "title";
    Fields["Site"] = "site";
    Fields["SpacePage"] = "space_or_page";
    return Fields;
}({});
const $f97d56dcf278ff25$export$800daf5fbbe96aff = {
    form: 'link-create-confluence-form',
    title: 'link-create-confluence-title',
    site: 'link-create-confluence-site-picker',
    space: 'link-create-confluence-space-picker',
    error: 'link-create-confluence-form-error'
};
const $f97d56dcf278ff25$export$c312550dc4e28902 = {
    EDIT_PAGE: 'edit-page',
    EDIT_PAGE_LOAD: 'edit-page/load',
    EDIT_PAGE_PUBLISH: 'edit-page/publish',
    EDIT_PAGE_CLOSE: 'edit-page/close'
};

});


parcelRegister("2khbo", function(module, exports) {

$parcel$export(module.exports, "draftEmbeddedPageModalEntrypoint", () => $064c0a03614f0cdf$export$11fd8fc5a8657f8);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $064c0a03614f0cdf$export$11fd8fc5a8657f8 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("dXKlz")), {
        moduleId: "a0941f4e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dXKlz", function(module, exports) {

let $a2a4bc95f79b535e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a2a4bc95f79b535e$var$load("bS9ef").then(()=>parcelRequire('ay6y4'));

});


parcelRegister("7UlSU", function(module, exports) {

$parcel$export(module.exports, "embeddedPanelEntrypoint", () => $dd9a0baadba26f74$export$32561f984de7bece);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $dd9a0baadba26f74$export$32561f984de7bece = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("7Zm1l")), {
        moduleId: "293c24d0",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7Zm1l", function(module, exports) {

let $5d0f4fbc84a851d1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5d0f4fbc84a851d1$var$load("kEfah").then(()=>parcelRequire('2SBvi'));

});


parcelRegister("cBx21", function(module, exports) {

$parcel$export(module.exports, "createActivePageUrl", () => $cb0bb56c18e3edd5$export$83c6318baef117fe);
$parcel$export(module.exports, "getURLFromConfluencePageResponse", () => $cb0bb56c18e3edd5$export$e87b28852220b5cd);
$parcel$export(module.exports, "setHostnameForContent", () => $cb0bb56c18e3edd5$export$8ccd4cc378896990);
$parcel$export(module.exports, "constructUrlIfCustomDomain", () => $cb0bb56c18e3edd5$export$a63ef4c6a1286e2a);
$parcel$export(module.exports, "createLinkCreatePayload", () => $cb0bb56c18e3edd5$export$af98278c506da0f4);

var $gRw8I = parcelRequire("gRw8I");

var $2Z8x4 = parcelRequire("2Z8x4");

var $jaAj7 = parcelRequire("jaAj7");
const $cb0bb56c18e3edd5$export$f31b9480a5e4fdcf = (uri)=>{
    if (!uri || uri === '') return '';
    const matches = uri.match(/draftShareId=([^&])*/g);
    return matches ? matches[0].split('=')[1] : '';
};
const $cb0bb56c18e3edd5$export$be3b1ed3560ef0e6 = ({ url: url, spaceId: spaceId, spaceKey: spaceKey })=>{
    if (!(url && spaceId && spaceKey)) return '';
    return url.replace(`spaces/${spaceId}`, `spaces/${spaceKey}`);
};
const $cb0bb56c18e3edd5$export$83c6318baef117fe = (createPayload)=>{
    const { data: data, url: url } = createPayload;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const links = data?.links;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const spaceKey = data?.spaceKey;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const spaceId = data?.spaceId;
    const linkableUrl = $cb0bb56c18e3edd5$export$be3b1ed3560ef0e6({
        url: url,
        spaceId: spaceId,
        spaceKey: spaceKey
    });
    if (data?.subType === 'live') return `${linkableUrl}`;
    return `${linkableUrl}?draftShareId=${$cb0bb56c18e3edd5$export$f31b9480a5e4fdcf(links?.editui)}`;
};
const $cb0bb56c18e3edd5$export$e87b28852220b5cd = ({ id: id, spaceKey: spaceKey, hostname: hostname })=>`${hostname}/wiki/spaces/${spaceKey}/pages/edit-v2/${id}/`;
const $cb0bb56c18e3edd5$var$isUrlCustomDomain = (parentHost, url)=>{
    const hostname = (0, $2Z8x4.getHostnameFromUrl)(url);
    return (0, $jaAj7.isCustomDomain)(parentHost) || hostname && (0, $jaAj7.isCustomDomain)(hostname);
};
const $cb0bb56c18e3edd5$export$8ccd4cc378896990 = (url, hostname)=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const parentHost = window?.location?.origin || '';
    const contentHost = hostname ?? (0, $2Z8x4.getHostnameFromUrl)(url);
    return $cb0bb56c18e3edd5$var$isUrlCustomDomain(parentHost, url) ? (0, $2Z8x4.getHostnameFromUrl)(parentHost) : contentHost;
};
const $cb0bb56c18e3edd5$export$a63ef4c6a1286e2a = ({ id: id, originalDomain: originalDomain, originalUrl: originalUrl, spaceKey: spaceKey, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl })=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const currentHostname = window?.location?.origin || '';
    const hostnameFromUrl = (0, $2Z8x4.getHostnameFromUrl)(originalDomain);
    const systemHostName = (0, $2Z8x4.getHostnameFromUrl)(systemConfluenceAppLinkUrl);
    /*
		If content is not on the same tenant, and custom domain is enabled, we need to update the hostname
		to reflect the parentProduct's hostname
	*/ if (systemHostName !== hostnameFromUrl && $cb0bb56c18e3edd5$var$isUrlCustomDomain(currentHostname, originalDomain)) return $cb0bb56c18e3edd5$export$e87b28852220b5cd({
        id: id,
        spaceKey: spaceKey,
        hostname: currentHostname
    });
    return originalUrl;
};
const $cb0bb56c18e3edd5$export$af98278c506da0f4 = (createResponse, url, space, cloudId)=>({
        url: url,
        ari: `ari:cloud:confluence:${cloudId}:page/${createResponse.id}`,
        objectId: createResponse.id,
        objectType: 'page',
        data: {
            spaceId: space.spaceId,
            spaceKey: space.spaceKey,
            spaceName: space.spaceName,
            status: createResponse.status,
            subType: createResponse.subtype,
            links: createResponse._links
        }
    });

});
parcelRegister("2Z8x4", function(module, exports) {

$parcel$export(module.exports, "getHostnameFromUrl", () => $f54eb56cec144daa$export$280e79c794cf814e);

var $5Zp9R = parcelRequire("5Zp9R");
const $f54eb56cec144daa$export$280e79c794cf814e = (url)=>(0, $5Zp9R.isValidUrl)(url) ? new URL(url)?.hostname : '';

});
parcelRegister("5Zp9R", function(module, exports) {

$parcel$export(module.exports, "isValidUrl", () => $be8dc3f2b7c2d95b$export$bef94a5618bf18bf);
const $be8dc3f2b7c2d95b$export$bef94a5618bf18bf = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};

});


parcelRegister("jaAj7", function(module, exports) {

$parcel$export(module.exports, "isCustomDomain", () => $d8c7d440b951ac72$export$97f4c254b641e719);
const $d8c7d440b951ac72$var$atlassianDomains = [
    '.atlassian.com',
    '.atlassian.net',
    '.jira-dev.com',
    '.jira.com',
    '.atlassian-stg-fedm.net',
    '.atlassian-us-gov-mod.net',
    '.atlassian-us-gov-mod.com'
];
const $d8c7d440b951ac72$export$97f4c254b641e719 = (hostname)=>!$d8c7d440b951ac72$var$atlassianDomains.some((domain)=>hostname.endsWith(domain));

});


parcelRegister("fBOqJ", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageDraft", () => $d606de9c6c8551af$export$8df6d110f6d46988);

var $eJOHy = parcelRequire("eJOHy");

var $3sdFo = parcelRequire("3sdFo");

var $vztq1 = parcelRequire("vztq1");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $f1Zdy = parcelRequire("f1Zdy");


var $ZosAp = parcelRequire("ZosAp");

var $1u0iy = parcelRequire("1u0iy");

var $dNEIK = parcelRequire("dNEIK");
const $d606de9c6c8551af$export$f0ebd8c41d592251 = 'success';
const $d606de9c6c8551af$export$12346a674644c156 = 'operational';
const $d606de9c6c8551af$export$8df6d110f6d46988 = ({ isLive: isLive, embeddedConfluenceSource: embeddedConfluenceSource, onClose: onClose, url: url, onEmbeddedContentAction: onEmbeddedContentAction, linkConfluencePage: linkConfluencePage })=>{
    const [{ panel: { isOpen: isOpen } }, actions] = (0, $vztq1.useEmbeddedConfluenceSidePanel)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [isContinueDraftOpen, setIsContinueDraftOpen] = (0, $eJOHy.useState)(false);
    const [isPublished, setIsPublished] = (0, $eJOHy.useState)(false);
    const [epMode, setEpMode] = (0, $eJOHy.useState)(isLive ? (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE : (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const fireAnalyticsEvent = (0, $1u0iy.useEmbeddedPageTracking)();
    const handledLiveDocUrls = (0, $eJOHy.useRef)(new Set());
    const openContinueDraftModal = (0, $eJOHy.useCallback)(()=>{
        if (!isPublished) {
            setIsContinueDraftOpen(true);
            fireAnalyticsEvent({
                action: 'clicked',
                eventName: isLive ? 'closeLiveDoc' : 'closeUnpublishedDraft',
                embeddedConfluenceSource: embeddedConfluenceSource
            });
        } else onClose && onClose();
    }, [
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        isLive,
        isPublished,
        onClose
    ]);
    const closeContinueDraftModal = ()=>{
        setIsContinueDraftOpen(false);
    };
    const closeAll = ()=>{
        closeContinueDraftModal();
        onClose && onClose();
    };
    const handleEmbeddedContentAction = (0, $eJOHy.useCallback)((action, name)=>{
        const linkingSuccessDescriptionMessage = ()=>{
            if ((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3')) return isLive ? (0, $dNEIK.default).linkLiveDocSuccessDescriptionIssueTermRefresh : (0, $dNEIK.default).publishAndLinkPageSuccessDescriptionIssueTermRefresh;
            return isLive ? (0, $dNEIK.default).linkLiveDocSuccessDescription : (0, $dNEIK.default).publishAndLinkPageSuccessDescription;
        };
        if (name === 'edit-page/close') {
            if (isPublished) {
                setEpMode((0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE);
                if (isOpen) actions.setConfluenceData({
                    contentUrl: url,
                    mode: (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
                });
            } else openContinueDraftModal();
        }
        if (name === 'edit-page/load' && action === 'taskSuccess') {
            if (epMode === (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) {
                setEpMode((0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                if (isOpen) actions.setConfluenceData({
                    contentUrl: url,
                    mode: (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE
                });
            }
        }
        if (name === 'edit-page/publish' && action === 'taskSuccess') {
            if (isOpen) actions.setConfluenceData({
                contentUrl: url,
                isDraft: false,
                mode: (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
            });
            fireAnalyticsEvent({
                action: $d606de9c6c8551af$export$f0ebd8c41d592251,
                eventName: isLive ? 'createLiveDoc' : 'publishDraftPage',
                embeddedConfluenceSource: embeddedConfluenceSource,
                eventType: $d606de9c6c8551af$export$12346a674644c156
            });
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            if (isPublished && !isLive) showFlag({
                key: (0, $hrodw.toFlagId)((0, $1976977ff3d9f14f$export$e80a06e24863c775)),
                type: 'success',
                title: formatMessage((0, $dNEIK.default).publishPageSuccessTitle),
                description: formatMessage((0, $dNEIK.default).publishPageSuccessDescription),
                messageId: 'issue-create-confluence-content.controllers.use-embedded-page-draft.show-flag.success.publish-draft-success-flag',
                messageType: 'transactional'
            });
            else {
                setIsPublished(true);
                if (isOpen) actions.setConfluenceData({
                    contentUrl: url,
                    isDraft: false
                });
                // TODO this is a temporary solution, remove when https://hello.atlassian.net/jira/software/projects/CBT/boards/4465?selectedIssue=CBT-2895 is complete
                setTimeout(()=>{
                    try {
                        if (linkConfluencePage) {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            linkConfluencePage((0, $ZosAp.convertToViewPageUrl)(url), analyticsEvent);
                            fireAnalyticsEvent({
                                action: $d606de9c6c8551af$export$f0ebd8c41d592251,
                                eventName: isLive ? 'linkConfluenceLiveDoc' : 'linkConfluencePage',
                                embeddedConfluenceSource: embeddedConfluenceSource,
                                eventType: $d606de9c6c8551af$export$12346a674644c156
                            });
                            showFlag({
                                key: (0, $hrodw.toFlagId)((0, $1976977ff3d9f14f$export$26c0043b48580bae)),
                                type: 'success',
                                title: formatMessage(isLive ? (0, $dNEIK.default).linkLiveDocSuccessTitle : (0, $dNEIK.default).publishAndLinkPageSuccessTitle),
                                description: formatMessage(linkingSuccessDescriptionMessage()),
                                messageId: 'issue-create-confluence-content.controllers.use-embedded-page-draft.show-flag.success.link-page-success-flag',
                                messageType: 'transactional'
                            });
                        }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        (0, $gYnSx.default)({
                            meta: {
                                id: isLive ? 'linkConfluenceLiveDoc' : 'linkConfluencePage',
                                teamName: 'confluence-better-together'
                            },
                            attributes: {
                                embeddedConfluenceSource: embeddedConfluenceSource
                            },
                            error: error
                        });
                        showFlag({
                            key: (0, $hrodw.toFlagId)((0, $1976977ff3d9f14f$export$4164631cfaaf3681)),
                            type: 'error',
                            title: formatMessage((0, $dNEIK.default).linkPageFailedTitle),
                            description: formatMessage((0, $dNEIK.default).linkPageFailedDescription),
                            messageId: 'issue-create-confluence-content.controllers.use-embedded-page-draft.show-flag.error.link-page-failed-flag',
                            messageType: 'transactional'
                        });
                    }
                }, 3500);
            }
        }
        if (name === 'edit-page/publish' && action === 'taskFail') (0, $gYnSx.default)({
            meta: {
                id: isLive ? 'createLiveDoc' : 'publishDraftPage',
                teamName: 'confluence-better-together'
            },
            attributes: {
                embeddedConfluenceSource: embeddedConfluenceSource
            },
            error: new Error(`Error publishing draft page: {name: ${name}, action: ${action}}`)
        });
        onEmbeddedContentAction && onEmbeddedContentAction(action, name);
    }, [
        createAnalyticsEvent,
        embeddedConfluenceSource,
        epMode,
        fireAnalyticsEvent,
        formatMessage,
        isPublished,
        linkConfluencePage,
        onEmbeddedContentAction,
        openContinueDraftModal,
        showFlag,
        url,
        actions,
        isOpen,
        isLive
    ]);
    // This is a little weird, but to avoid duplicating the code above, if the page is live and state local state is !isPublished,
    // we simulate the action of publishing from inside the ep modal. This in turn displays the view page, link the page to the issue
    // and show the flag about the page being published and linked.
    (0, $eJOHy.useEffect)(()=>{
        if (isLive && embeddedConfluenceSource?.endsWith('Panel') && !handledLiveDocUrls.current.has(url)) {
            handledLiveDocUrls.current.add(url);
            if (handledLiveDocUrls.current.has(url)) handleEmbeddedContentAction('taskSuccess', 'edit-page/publish');
            else handleEmbeddedContentAction('taskFail', 'edit-page/publish');
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLive,
        url
    ]);
    // in the case that the user creates a live doc and then wants to create a page, we must ensure we open the draft for the page in edit mode
    (0, $eJOHy.useEffect)(()=>{
        setEpMode(isLive ? (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE : (0, $3sdFo.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
    }, [
        isLive
    ]);
    return {
        isContinueDraftOpen: isContinueDraftOpen,
        openContinueDraftModal: openContinueDraftModal,
        closeContinueDraftModal: closeContinueDraftModal,
        closeAll: closeAll,
        handleEmbeddedContentAction: handleEmbeddedContentAction,
        fireAnalyticsEvent: fireAnalyticsEvent,
        epMode: epMode
    };
};

});
const $1976977ff3d9f14f$export$e80a06e24863c775 = 'publishDraftSuccess';
const $1976977ff3d9f14f$export$26c0043b48580bae = 'linkPageSuccess';
const $1976977ff3d9f14f$export$7600137866a0229f = 'publishDraftFailed';
const $1976977ff3d9f14f$export$4164631cfaaf3681 = 'linkPageFailed';

parcelRegister("ZosAp", function(module, exports) {

$parcel$export(module.exports, "convertToViewPageUrl", () => $498314633327a16f$export$fbd50b21ccd324a6);
const $498314633327a16f$export$fbd50b21ccd324a6 = (url)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    url.split('/').filter((part)=>part !== 'edit-v2').join('/');

});

parcelRegister("1u0iy", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageTracking", () => $0b8aa5d46ca9b666$export$9fcd107e4ed1de75);

var $eJOHy = parcelRequire("eJOHy");

var $bmoS1 = parcelRequire("bmoS1");

var $f1Zdy = parcelRequire("f1Zdy");

var $lvKO5 = parcelRequire("lvKO5");

var $iVGww = parcelRequire("iVGww");

var $jRzGn = parcelRequire("jRzGn");
const $0b8aa5d46ca9b666$export$9fcd107e4ed1de75 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const source = (0, $bmoS1.useAnalyticsSource)();
    const trackEmbeddedConfluence = (0, $eJOHy.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, contentType: contentType, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', flow: flow, userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct, isLivePage: isLivePage, linkObjectType: linkObjectType, confluenceContentId: confluenceContentId })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject ?? `${eventName}`
        });
        const attributes = {
            parentProduct: (0, $jRzGn.getParentProduct)(projectType),
            tenantEditions: tenantContext?.appEditions,
            productEntitlementDetails: tenantContext?.productEntitlementDetails,
            embeddedConfluenceSource: embeddedConfluenceSource,
            flow: flow,
            jiraIssueSurfaceArea: source,
            userHasConfluenceAccess: userHasConfluenceAccess,
            tenantHasConfluence: tenantHasConfluence,
            crossJoinStatus: crossJoinStatus,
            originProduct: originProduct,
            requestedProduct: requestedProduct,
            isLivePage: isLivePage,
            isSiteAdmin: tenantContext?.isSiteAdmin,
            linkObjectType: linkObjectType,
            confluenceContentId: confluenceContentId,
            contentType: contentType
        };
        (0, $iVGww.fireEmbeddedConfluenceAnalytics)({
            analyticsEvent: analyticsEvent,
            attributes: attributes,
            eventType: eventType,
            eventName: `${actionSubject ?? eventName} ${action}`
        });
    }, [
        source,
        tenantContext,
        createAnalyticsEvent
    ]);
    return trackEmbeddedConfluence;
};

});
parcelRegister("iVGww", function(module, exports) {

$parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", () => $fe1a92e0c124c21f$export$864bc2da9014e8e9);

var $gCeeo = parcelRequire("gCeeo");
const $fe1a92e0c124c21f$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
    switch(eventType){
        case 'ui':
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, attributes);
            break;
        case 'operational':
            (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        case 'track':
            (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        default:
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, attributes);
            break;
    }
};

});

parcelRegister("jRzGn", function(module, exports) {

$parcel$export(module.exports, "ACCESS_REQUEST_CAPABILITIES", () => $9a2cffb8cd0a43d3$export$b4e6d6efc113ca5);
$parcel$export(module.exports, "VALID_DIRECT_ACCESS_STATUS", () => $9a2cffb8cd0a43d3$export$bf1e31028b579014);
$parcel$export(module.exports, "ACCESS_DENIED_STATUSES", () => $9a2cffb8cd0a43d3$export$2fe5bb2d968b01fc);
$parcel$export(module.exports, "LICENCE_EXCEEDED_STATUS", () => $9a2cffb8cd0a43d3$export$56360b096b4b4439);
$parcel$export(module.exports, "getParentProduct", () => $9a2cffb8cd0a43d3$export$e873edb2560a07ef);

var $ln6Iy = parcelRequire("ln6Iy");




const $9a2cffb8cd0a43d3$export$b4e6d6efc113ca5 = {
    ACCESS_GRANTED: 'ACCESS_GRANTED',
    ACCESS_EXISTS: 'ACCESS_EXISTS',
    DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
    DIRECT_ACCESS: 'DIRECT_ACCESS',
    FORBIDDEN: 'FORBIDDEN',
    PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
    REQUEST_ACCESS: 'REQUEST_ACCESS'
};
const $9a2cffb8cd0a43d3$export$bf1e31028b579014 = [
    $9a2cffb8cd0a43d3$export$b4e6d6efc113ca5.ACCESS_EXISTS,
    $9a2cffb8cd0a43d3$export$b4e6d6efc113ca5.ACCESS_GRANTED,
    $9a2cffb8cd0a43d3$export$b4e6d6efc113ca5.PENDING_REQUEST_EXISTS
];
const $9a2cffb8cd0a43d3$export$2fe5bb2d968b01fc = [
    $9a2cffb8cd0a43d3$export$b4e6d6efc113ca5.FORBIDDEN,
    $9a2cffb8cd0a43d3$export$b4e6d6efc113ca5.DENIED_REQUEST_EXISTS
];
const $9a2cffb8cd0a43d3$export$56360b096b4b4439 = 'licence-exceeded';
const $9a2cffb8cd0a43d3$export$e873edb2560a07ef = (projectType)=>{
    switch(projectType){
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $ln6Iy.CORE_PROJECT:
            return 'JWM';
        default:
            return 'JSW';
    }
};

});


parcelRegister("dNEIK", function(module, exports) {

$parcel$export(module.exports, "default", () => $6991b9cb99d4b8bc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6991b9cb99d4b8bc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    publishPageSuccessTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-success-title",
        "defaultMessage": "Published!"
    },
    publishPageSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-success-description",
        "defaultMessage": "Successfully published page"
    },
    deferSpacePublishPageSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.defer-space-publish-page-success-description",
        "defaultMessage": "Your page was successfully published in the {spaceName} space"
    },
    publishPageFailedTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-failed-title",
        "defaultMessage": "Something went wrong"
    },
    publishPageFailedDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-failed-description",
        "defaultMessage": "We are unable to publish your page at this time"
    },
    linkPageFailedTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-page-failed-title",
        "defaultMessage": "Something went wrong."
    },
    linkPageFailedDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-page-failed-description",
        "defaultMessage": "We are unable to link your page at this time"
    },
    publishAndLinkPageSuccessTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-and-link-page-success-title",
        "defaultMessage": "Published!"
    },
    publishAndLinkPageSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-and-link-page-success-description",
        "defaultMessage": "Your page has been published and linked to your Jira issue."
    },
    publishAndLinkPageSuccessDescriptionIssueTermRefresh: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-and-link-page-success-description-issue-term-refresh",
        "defaultMessage": "Your page has been published and linked to your Jira work item."
    },
    linkLiveDocSuccessTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-live-doc-success-title",
        "defaultMessage": "Live doc created"
    },
    linkLiveDocSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-live-doc-success-description",
        "defaultMessage": "A live doc was created and linked to your Jira issue."
    },
    linkLiveDocSuccessDescriptionIssueTermRefresh: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-live-doc-success-description-issue-term-refresh",
        "defaultMessage": "A live doc was created and linked to your Jira work item."
    }
});

});


parcelRegister("1VTE7", function(module, exports) {

$parcel$export(module.exports, "useParentProduct", () => $9e4c426c0a6578b5$export$1b09c6e3737c8eb7);

var $2aY2d = parcelRequire("2aY2d");

var $jRzGn = parcelRequire("jRzGn");
const $9e4c426c0a6578b5$export$1b09c6e3737c8eb7 = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    const projectType = data?.projectType;
    return (0, $jRzGn.getParentProduct)(projectType);
};

});

parcelRegister("iiTqV", function(module, exports) {

$parcel$export(module.exports, "embeddedWhiteboardModalEntrypoint", () => $48c35621d2e08c98$export$652b3f11839af9e6);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $48c35621d2e08c98$export$652b3f11839af9e6 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("azRdC")), {
        moduleId: "d273fc0f",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("azRdC", function(module, exports) {

let $7b3674669d8e8331$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7b3674669d8e8331$var$load("l5ujq").then(()=>parcelRequire('8XGHT'));

});




parcelRegister("hWQJk", function(module, exports) {

$parcel$export(module.exports, "ImperativeAPI", () => $dc9d639c7b80dafe$export$e2ad0ff52e7f8c84);

var $eJOHy = parcelRequire("eJOHy");

var $jCQk5 = parcelRequire("jCQk5");

var $8MGwS = parcelRequire("8MGwS");
const $dc9d639c7b80dafe$export$e2ad0ff52e7f8c84 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jCQk5.Consumer), null, ({ getManager: getManager })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8MGwS.ImperativeAPI), {
            getItemManager: getManager
        }));

});
parcelRegister("jCQk5", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $3f9151ab3ad2c0bf$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $3f9151ab3ad2c0bf$export$b3bffd4bb7da6b8f);

var $eJOHy = parcelRequire("eJOHy");

var $jFHCE = parcelRequire("jFHCE");

var $b1B2B = parcelRequire("b1B2B");

var $aRKGc = parcelRequire("aRKGc");
const $3f9151ab3ad2c0bf$var$Context = (0, $b1B2B.default)('ItemManagers');
const $3f9151ab3ad2c0bf$export$275138de3066e8b3 = 30000;
class $3f9151ab3ad2c0bf$export$2881499e37b75b9a extends (0, $eJOHy.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3f9151ab3ad2c0bf$var$Context.Provider, {
            value: this.manager
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            managers: {}
        }, this.getManager = (managerKey)=>{
            const { managers: managers } = this.state;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
            const manager = managers[managerKey];
            if (manager) return manager;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return new Promise((resolve, reject)=>{
                const message = `Timeout. "${(0, $aRKGc.fromManagerKey)(managerKey)}" wasn't registered after ${$3f9151ab3ad2c0bf$export$275138de3066e8b3}ms`;
                const rejectTimeoutId = setTimeout(()=>reject(new Error(message)), $3f9151ab3ad2c0bf$export$275138de3066e8b3);
                const { pendingManagers: pendingManagers } = this;
                pendingManagers[managerKey] || (pendingManagers[managerKey] = []);
                pendingManagers[managerKey].push((methods)=>{
                    clearTimeout(rejectTimeoutId);
                    resolve(methods);
                });
            });
        }, this.registerManager = (managerKey, methods)=>{
            this.setState((previousState)=>{
                if (methods == null) return {
                    managers: (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(previousState.managers, managerKey)
                };
                const managerResolvers = this.pendingManagers[managerKey];
                if (managerResolvers && managerResolvers.length) {
                    managerResolvers.forEach((resolve)=>resolve(methods));
                    managerResolvers.length = 0;
                }
                return {
                    managers: {
                        ...previousState.managers,
                        [managerKey]: Promise.resolve(methods)
                    }
                };
            });
        }, this.pendingManagers = {}, this.manager = {
            getManager: this.getManager,
            registerManager: this.registerManager
        };
    }
}
const { Consumer: $3f9151ab3ad2c0bf$export$b3bffd4bb7da6b8f } = $3f9151ab3ad2c0bf$var$Context;

});
parcelRegister("b1B2B", function(module, exports) {

$parcel$export(module.exports, "default", () => $a91f7719f34a5690$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a91f7719f34a5690$export$2e2bcd8739ae039 = (name)=>{
    const contextObjName = name || '';
    const defaultGetter = ()=>{
        throw new Error(`The Consumer for ${contextObjName} Context Object does not have a correct value. Maybe, it needs to be wrapped in its corresponding Provider`);
    };
    const Context = /*#__PURE__*/ (0, $eJOHy.createContext)(defaultGetter);
    const ContextConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Context.Consumer, null, (getValue)=>{
            const value = getValue();
            return props.children(value);
        });
    const ContextProvider = ({ value: value, children: children })=>{
        const getValue = ()=>value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Context.Provider, {
            value: getValue
        }, children);
    };
    ContextProvider.displayName = `${contextObjName}SafeProvider`;
    ContextConsumer.displayName = `${contextObjName}SafeConsumer`;
    // @ts-expect-error - TS2741 - Property '$$typeof' is missing in type '{ ({ value, children }: ProviderProps<T>): JSX.Element; displayName: string; }' but required in type 'ProviderExoticComponent<ProviderProps<T>>'. | TS2741 - Property '$$typeof' is missing in type '{ (props: Props<T>): JSX.Element; displayName: string; }' but required in type 'ExoticComponent<ConsumerProps<T>>'.
    return {
        Provider: ContextProvider,
        Consumer: ContextConsumer
    };
};

});

parcelRegister("aRKGc", function(module, exports) {

$parcel$export(module.exports, "fromManagerKey", () => $c188336fc6742526$export$fef172a673b3ef47);
const $c188336fc6742526$export$e6ee4c5f89b06a38 = (managerKey)=>managerKey;
const $c188336fc6742526$export$fef172a673b3ef47 = (managerKey)=>String(managerKey);

});


parcelRegister("8MGwS", function(module, exports) {

$parcel$export(module.exports, "ImperativeAPI", () => $36dc8c660a943928$export$e2ad0ff52e7f8c84);

var $eJOHy = parcelRequire("eJOHy");

var $iyT45 = parcelRequire("iyT45");

var $eSnSE = parcelRequire("eSnSE");

var $i6rzz = parcelRequire("i6rzz");

var $4FEgv = parcelRequire("4FEgv");

var $cUxaS = parcelRequire("cUxaS");

var $dSkLG = parcelRequire("dSkLG");

var $7pRCV = parcelRequire("7pRCV");

var $aRKGc = parcelRequire("aRKGc");

var $83DiZ = parcelRequire("83DiZ");

var $hBVia = parcelRequire("hBVia");
const $36dc8c660a943928$var$ERROR_LOCATION = 'legacy.imperative-api';
const $36dc8c660a943928$export$e2ad0ff52e7f8c84 = ({ getItemManager: getItemManager })=>{
    const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, $cUxaS.useLeftSidebarController)();
    const { refresh: refresh } = (0, $dSkLG.useProjectSidebarNavigation)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const sidebarState = (0, $cUxaS.useLeftSidebarState)();
    const sidebarRef = (0, $eJOHy.useRef)(sidebarState);
    const refreshSidebarRef = (0, $eJOHy.useRef)(refresh);
    const imperativeAPIRef = (0, $eJOHy.useRef)({
        viewIds: $hBVia.viewIds,
        itemIds: $hBVia.itemIds,
        expand: expandLeftSidebar,
        collapse: collapseLeftSidebar,
        isCollapsed: ()=>sidebarRef.current.isCollapsed,
        onCollapse: ()=>undefined,
        onCollapseStart: ()=>undefined,
        onCollapseEnd: ()=>undefined,
        onExpand: ()=>undefined,
        onExpandStart: ()=>undefined,
        onExpandEnd: ()=>undefined,
        onItemClick: ()=>undefined,
        setView: ()=>undefined,
        updateActiveView: ()=>undefined,
        setProjectRootView: ()=>undefined,
        getActiveViewItems: ()=>[],
        isInProjectContext: ()=>false,
        updateContext: ()=>undefined,
        updateData: ()=>{
            refreshSidebarRef.current();
        },
        getItemManager: (itemManagerKey)=>getItemManager(itemManagerKey).catch((e)=>{
                (0, $eSnSE.default).safeErrorWithoutCustomerData($36dc8c660a943928$var$ERROR_LOCATION, `There was a problem getting "${(0, $aRKGc.fromManagerKey)(itemManagerKey)}" item manager`, e);
                throw e;
            }),
        createBoard: ()=>{
            (0, $4FEgv.default)();
        },
        modalOpen: ()=>undefined,
        modalClose: ()=>undefined,
        navigate: (url)=>push(url)
    });
    sidebarRef.current = sidebarState;
    refreshSidebarRef.current = refresh;
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $iyT45.loadBridgeWeak)({
            name: 'jira/navigation/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(imperativeAPIRef.current);
        });
        (0, $i6rzz.provideNavigationApi)({
            navigate: push
        });
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7pRCV.NavigationUIContainer), {
        isGlobal: true
    });
};

});
parcelRegister("i6rzz", function(module, exports) {

$parcel$export(module.exports, "provideNavigationApi", () => $8e042d89b6822ab4$export$26d28e8849b2805f);
$parcel$export(module.exports, "isInIframe", () => $8e042d89b6822ab4$export$9f140ed41af5108c);
$parcel$export(module.exports, "canSpaTransition", () => $8e042d89b6822ab4$export$59e771495885068f);
$parcel$export(module.exports, "getContainerApi", () => $8e042d89b6822ab4$export$91ed870fd8df2bcb);
$parcel$export(module.exports, "getNavigationApi", () => $8e042d89b6822ab4$export$da4e5a44286a0dd0);
// Old AMD key: `ac/spa-context`
// TODO: we will improve the type later when we know the code better.
let $8e042d89b6822ab4$var$containerApi = null;
let $8e042d89b6822ab4$var$navigationApi = null;
const $8e042d89b6822ab4$export$3927fb5df700a968 = (api)=>{
    $8e042d89b6822ab4$var$containerApi = api;
};
const $8e042d89b6822ab4$export$26d28e8849b2805f = (api)=>{
    $8e042d89b6822ab4$var$navigationApi = api;
};
const $8e042d89b6822ab4$export$9f140ed41af5108c = ()=>$8e042d89b6822ab4$var$containerApi !== null;
const $8e042d89b6822ab4$export$59e771495885068f = ()=>$8e042d89b6822ab4$var$navigationApi !== null;
const $8e042d89b6822ab4$export$91ed870fd8df2bcb = ()=>$8e042d89b6822ab4$var$containerApi;
const $8e042d89b6822ab4$export$da4e5a44286a0dd0 = ()=>$8e042d89b6822ab4$var$navigationApi;
const $8e042d89b6822ab4$export$6ba42130b045ede1 = ()=>{
    $8e042d89b6822ab4$var$containerApi = null;
    $8e042d89b6822ab4$var$navigationApi = null;
};

});

parcelRegister("4FEgv", function(module, exports) {

$parcel$export(module.exports, "default", () => $299bc7b5e43caf95$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $97BGz = parcelRequire("97BGz");
const $299bc7b5e43caf95$var$amdModuleName = 'jira-agile/sidebar/create-board-adg3';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$299bc7b5e43caf95$export$2e2bcd8739ae039 = async ()=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    const module = await (0, $97BGz.loadBridgeStrict)({
        name: $299bc7b5e43caf95$var$amdModuleName,
        wrmKeys: [
            'wrc!com.pyxis.greenhopper.jira:gh-create-board'
        ]
    });
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    return module.openCreateBoardModal();
};

});

parcelRegister("7pRCV", function(module, exports) {

$parcel$export(module.exports, "NavigationUISubscriber", () => $a02d5a296098bc51$export$d3dc1c18cfde5ddd);
$parcel$export(module.exports, "NavigationUIContainer", () => $a02d5a296098bc51$export$339ec9ca159ad81f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $ht3nQ = parcelRequire("ht3nQ");

var $fCjE9 = parcelRequire("fCjE9");
const $a02d5a296098bc51$export$d3dc1c18cfde5ddd = (0, $ht3nQ.createSubscriber)((0, $fCjE9.default), {
    displayName: 'NavigationUISubscriber',
    selector: null
});
const $a02d5a296098bc51$export$339ec9ca159ad81f = (0, $6E16M.createContainer)((0, $fCjE9.default));

});
parcelRegister("fCjE9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7179e181487f7eb$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $GtRbT = parcelRequire("GtRbT");

var $li6to = parcelRequire("li6to");
const $e7179e181487f7eb$var$initialState = {
    collapseStart: new Set(),
    collapseEnd: new Set(),
    expandStart: new Set(),
    expandEnd: new Set()
};
var $e7179e181487f7eb$export$2e2bcd8739ae039 = (0, $GtRbT.createStore)({
    name: 'navigation-ui',
    initialState: $e7179e181487f7eb$var$initialState,
    actions: $li6to.default
});

});
parcelRegister("li6to", function(module, exports) {

$parcel$export(module.exports, "default", () => $a55c108ac4cff354$export$2e2bcd8739ae039);

var $hp56f = parcelRequire("hp56f");
var $g0YFq = parcelRequire("g0YFq");
var $lyMVt = parcelRequire("lyMVt");
var $bo6Al = parcelRequire("bo6Al");
const $a55c108ac4cff354$var$actions = {
    collapseStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($hp56f.default('collapseStart', cb)),
    collapseStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($lyMVt.default('collapseStart', cb)),
    collapseStartClear: ()=>({ dispatch: dispatch })=>dispatch($g0YFq.default('collapseStart')),
    collapseStartRun: ()=>({ dispatch: dispatch })=>dispatch($bo6Al.default('collapseStart')),
    collapseEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($hp56f.default('collapseEnd', cb)),
    collapseEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($lyMVt.default('collapseEnd', cb)),
    collapseEndClear: ()=>({ dispatch: dispatch })=>dispatch($g0YFq.default('collapseEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    collapseEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($bo6Al.default('collapseEnd', cb)),
    expandStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($hp56f.default('expandStart', cb)),
    expandStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($lyMVt.default('expandStart', cb)),
    expandStartClear: ()=>({ dispatch: dispatch })=>dispatch($g0YFq.default('expandStart')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandStartRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($bo6Al.default('expandStart', cb)),
    expandEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($hp56f.default('expandEnd', cb)),
    expandEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($lyMVt.default('expandEnd', cb)),
    expandEndClear: ()=>({ dispatch: dispatch })=>dispatch($g0YFq.default('expandEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($bo6Al.default('expandEnd', cb)),
    clearAll: ()=>({ dispatch: dispatch })=>{
            dispatch($a55c108ac4cff354$var$actions.collapseStartClear());
            dispatch($a55c108ac4cff354$var$actions.collapseEndClear());
            dispatch($a55c108ac4cff354$var$actions.expandStartClear());
            dispatch($a55c108ac4cff354$var$actions.expandEndClear());
        }
};
var $a55c108ac4cff354$export$2e2bcd8739ae039 = $a55c108ac4cff354$var$actions;

});
parcelRegister("hp56f", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a3f0e85b6e83418$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $lyMVt = parcelRequire("lyMVt");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0a3f0e85b6e83418$export$2e2bcd8739ae039 = (key, callback)=>// @ts-expect-error - TS2322 - Type '({ setState, getState, dispatch }: StoreActionApi<T>) => () => void' is not assignable to type 'Action<T, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set(getState()[key]).add(callback)
        });
        return ()=>dispatch((0, $lyMVt.default)(key, callback));
    };

});
parcelRegister("lyMVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5f584ef21926573$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d5f584ef21926573$export$2e2bcd8739ae039 = (key, callback)=>({ setState: setState, getState: getState })=>{
        if (!getState()[key]) return;
        const slice = new Set(getState()[key]);
        slice.delete(callback);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: slice
        });
    };

});


parcelRegister("g0YFq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a31c73f70da8801$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4a31c73f70da8801$export$2e2bcd8739ae039 = (key)=>({ setState: setState })=>// @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set()
        });

});

parcelRegister("bo6Al", function(module, exports) {

$parcel$export(module.exports, "default", () => $b478fc90550f7514$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b478fc90550f7514$export$2e2bcd8739ae039 = (key, ...args)=>({ getState: getState })=>// @ts-expect-error - TS2339 - Property 'forEach' does not exist on type 'Set<unknown> | T[string]'. | TS7006 - Parameter 'cb' implicitly has an 'any' type.
        (getState()[key] || new Set()).forEach((cb)=>cb(...args));

});




parcelRegister("hBVia", function(module, exports) {

$parcel$export(module.exports, "itemIds", () => $915933f8c524e7d3$export$443ec49e59de3663);
$parcel$export(module.exports, "viewIds", () => $915933f8c524e7d3$export$8ee2fd038785d9dc);

var $hEw7G = parcelRequire("hEw7G");
const $915933f8c524e7d3$var$ROOT = 'root/index';
const $915933f8c524e7d3$var$ISSUES = 'root/issues';
const $915933f8c524e7d3$var$DASHBOARDS = 'root/dashboards';
const $915933f8c524e7d3$var$PORTFOLIO = 'root/portfolio';
const $915933f8c524e7d3$var$WORK_SCRUM = 'work-scrum';
const $915933f8c524e7d3$var$PLAN_SCRUM = 'plan-scrum';
const $915933f8c524e7d3$var$WORK_KANBAN = 'work-kanban';
const $915933f8c524e7d3$var$PLAN_KANBAN = 'plan-kanban';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES = 'pin-filter-myopenissues';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES = 'pin-filter-reportedbyme';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES = 'pin-filter-allissues';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES = 'pin-filter-allopenissues';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES = 'pin-filter-doneissues';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES = 'pin-filter-recentlyviewed';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES = 'pin-filter-addedrecently';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES = 'pin-filter-resolvedrecently';
const $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES = 'pin-filter-updatedrecently';
const $915933f8c524e7d3$var$AGILITY = 'project/agility/index';
const $915933f8c524e7d3$var$BUSINESS = 'project/business/index';
const $915933f8c524e7d3$var$OPS = 'project/ops/index';
const $915933f8c524e7d3$var$SOFTWARE = 'project/software/index';
const $915933f8c524e7d3$var$SOFTWARE_ISSUES = 'project/software/issues';
const $915933f8c524e7d3$var$SOFTWARE_REPORTS = 'project/software/reports';
const $915933f8c524e7d3$var$USER = 'user/index';
const $915933f8c524e7d3$var$USER_REPORTS = 'user/reports';
const $915933f8c524e7d3$var$rootProjectViewIds = {
    AGILITY: $915933f8c524e7d3$var$AGILITY,
    SERVICE_DESK: $hEw7G.SERVICE_DESK,
    OPS: $915933f8c524e7d3$var$OPS,
    BUSINESS: $915933f8c524e7d3$var$BUSINESS,
    SOFTWARE: $915933f8c524e7d3$var$SOFTWARE
};
const $915933f8c524e7d3$var$rootViewIds = {
    ROOT: $915933f8c524e7d3$var$ROOT,
    ISSUES: $915933f8c524e7d3$var$ISSUES,
    DASHBOARDS: $915933f8c524e7d3$var$DASHBOARDS,
    PORTFOLIO: $915933f8c524e7d3$var$PORTFOLIO
};
const $915933f8c524e7d3$export$443ec49e59de3663 = {
    WORK_SCRUM: $915933f8c524e7d3$var$WORK_SCRUM,
    PLAN_SCRUM: $915933f8c524e7d3$var$PLAN_SCRUM,
    WORK_KANBAN: $915933f8c524e7d3$var$WORK_KANBAN,
    PLAN_KANBAN: $915933f8c524e7d3$var$PLAN_KANBAN,
    PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES: $915933f8c524e7d3$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES,
    ...(0, $hEw7G.SERVICE_DESK_ITEMS)
};
const $915933f8c524e7d3$export$8ee2fd038785d9dc = {
    ...$915933f8c524e7d3$var$rootViewIds,
    ...$915933f8c524e7d3$var$rootProjectViewIds,
    SOFTWARE_ISSUES: $915933f8c524e7d3$var$SOFTWARE_ISSUES,
    SOFTWARE_REPORTS: $915933f8c524e7d3$var$SOFTWARE_REPORTS,
    SERVICE_DESK_ISSUES: $hEw7G.SERVICE_DESK_ISSUES,
    SERVICE_DESK_QUEUES: $hEw7G.SERVICE_DESK_QUEUES,
    SERVICE_DESK_REPORTS: $hEw7G.SERVICE_DESK_REPORTS,
    SERVICE_DESK_SETTINGS: $hEw7G.SERVICE_DESK_SETTINGS,
    SERVICE_DESK_LANGUAGES: $hEw7G.SERVICE_DESK_LANGUAGES,
    SERVICE_DESK_LEGACY_TICKET_TYPES: $hEw7G.SERVICE_DESK_LEGACY_TICKET_TYPES,
    SERVICE_DESK_TRANSLATIONS: $hEw7G.SERVICE_DESK_TRANSLATIONS,
    SERVICE_DESK_AUTOMATION_SUB_NAV: $hEw7G.SERVICE_DESK_AUTOMATION_SUB_NAV,
    SERVICE_DESK_KNOWLEDGE_HUB: $hEw7G.SERVICE_DESK_KNOWLEDGE_HUB,
    USER: $915933f8c524e7d3$var$USER,
    USER_REPORTS: $915933f8c524e7d3$var$USER_REPORTS
};

});
parcelRegister("hEw7G", function(module, exports) {

$parcel$export(module.exports, "REPORTS_IDS", () => $67699a75a06dd97b$export$1f70a76cb421b107);
$parcel$export(module.exports, "HOME_ITEMS_IDS", () => $67699a75a06dd97b$export$9afbea2cbd37e16d);
$parcel$export(module.exports, "PRACTICES_IDS", () => $67699a75a06dd97b$export$a37f4f7add086a3);
$parcel$export(module.exports, "SERVICE_DESK_ITEMS", () => $67699a75a06dd97b$export$2108a7f32cd0bb12);
$parcel$export(module.exports, "REQUEST_TYPE_PRACTICE_NAV_ONBOARDING", () => $67699a75a06dd97b$export$712b4b205a2bcf1e);
$parcel$export(module.exports, "STARRED_QUEUE_SPOTLIGHT", () => $67699a75a06dd97b$export$e2d46b728fe0a15a);
$parcel$export(module.exports, "SERVICE_DESK", () => $67699a75a06dd97b$export$c8c1c8c3f8ddba61);
$parcel$export(module.exports, "SERVICE_DESK_ISSUES", () => $67699a75a06dd97b$export$51fa1147c138a6ed);
$parcel$export(module.exports, "SERVICE_DESK_QUEUES", () => $67699a75a06dd97b$export$456b3cfbf5e37bd8);
$parcel$export(module.exports, "SERVICE_DESK_KNOWLEDGE_HUB", () => $67699a75a06dd97b$export$9ccc8d85b210b219);
$parcel$export(module.exports, "SERVICE_DESK_REPORTS", () => $67699a75a06dd97b$export$707771f2f7e60575);
$parcel$export(module.exports, "SERVICE_DESK_SETTINGS", () => $67699a75a06dd97b$export$a87fc635598d2d50);
$parcel$export(module.exports, "SERVICE_DESK_LEGACY_TICKET_TYPES", () => $67699a75a06dd97b$export$b6bda26b77269209);
$parcel$export(module.exports, "SERVICE_DESK_LANGUAGES", () => $67699a75a06dd97b$export$776199f9e99c88e2);
$parcel$export(module.exports, "SERVICE_DESK_TRANSLATIONS", () => $67699a75a06dd97b$export$d70ba5c124463035);
$parcel$export(module.exports, "SERVICE_DESK_AUTOMATION_SUB_NAV", () => $67699a75a06dd97b$export$9a6deaa9c1af559f);
const $67699a75a06dd97b$var$HOME_QUEUES = 'queues';
const $67699a75a06dd97b$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT = 'all-itsm-queues-spotlight';
const $67699a75a06dd97b$var$HOME_ALL_TICKETS_SPOTLIGHT = 'all-tickets-spotlight';
const $67699a75a06dd97b$var$HOME_TICKET_CATEGORIES_SPOTLIGHT = 'ticket-categories-spotlight';
const $67699a75a06dd97b$var$HOME_SERVICE_REQUESTS = 'service-requests';
const $67699a75a06dd97b$var$HOME_INCIDENTS = 'incidents';
const $67699a75a06dd97b$var$HOME_CHANGES = 'changes';
const $67699a75a06dd97b$var$HOME_PROBLEMS = 'problems';
const $67699a75a06dd97b$var$HOME_POST_INCIDENT_REVIEWS = 'post-incident-reviews';
const $67699a75a06dd97b$var$HOME_CUSTOMERS = 'customers';
const $67699a75a06dd97b$var$HOME_REPORTS = 'reports';
const $67699a75a06dd97b$var$HOME_RAISE_REQUEST = 'raise-request';
const $67699a75a06dd97b$var$HOME_ISSUES = 'issues';
const $67699a75a06dd97b$var$HOME_CUSTOMER_CHANNELS = 'customer-channels';
const $67699a75a06dd97b$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT = 'customer-channels-spotlight';
const $67699a75a06dd97b$var$HOME_JSD_CHANNELS_DIALOG = 'jsd-channels-dialog';
const $67699a75a06dd97b$var$HOME_KNOWLEDGE_BASE = 'knowledge-base';
const $67699a75a06dd97b$var$HOME_KNOWLEDGE_BASE_HUB = 'knowledge-hub';
const $67699a75a06dd97b$var$HOME_KNOWLEDGE_BASE_HUB_NESTED = 'knowledge-hub-nested';
const $67699a75a06dd97b$var$HOME_INVITE_TEAM = 'invite-team';
const $67699a75a06dd97b$var$HOME_GIVE_FEEDBACK = 'give-feedback';
const $67699a75a06dd97b$var$HOME_SERVICES = 'services';
const $67699a75a06dd97b$var$HOME_SERVICES_SPOTLIGHT = 'services-spotlight';
const $67699a75a06dd97b$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT = 'alerts-and-on-call-spotlight';
const $67699a75a06dd97b$var$HOME_CHANGE_CALENDAR_SPOTLIGHT = 'change-calendar-spotlight';
const $67699a75a06dd97b$export$1f70a76cb421b107 = {
    REPORTS_CUSTOM: 'sd-reports-custom',
    REPORTS_ADDONS: 'sd-reports-addons',
    REPORTS_NAV_CUSTOM_ACTIONS: 'sd-reports-nav-custom-actions',
    REPORTS_NAV_TEAM: 'sd-reports-nav-team',
    REPORTS_NAV_KB: 'sd-reports-nav-kb'
};
const $67699a75a06dd97b$export$9afbea2cbd37e16d = {
    QUEUES: $67699a75a06dd97b$var$HOME_QUEUES,
    ALL_ITSM_QUEUES_SPOTLIGHT: $67699a75a06dd97b$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT,
    ALL_TICKETS_SPOTLIGHT: $67699a75a06dd97b$var$HOME_ALL_TICKETS_SPOTLIGHT,
    TICKET_CATEGORIES_SPOTLIGHT: $67699a75a06dd97b$var$HOME_TICKET_CATEGORIES_SPOTLIGHT,
    SERVICE_REQUEST: $67699a75a06dd97b$var$HOME_SERVICE_REQUESTS,
    INCIDENTS: $67699a75a06dd97b$var$HOME_INCIDENTS,
    CHANGES: $67699a75a06dd97b$var$HOME_CHANGES,
    PROBLEMS: $67699a75a06dd97b$var$HOME_PROBLEMS,
    CUSTOMERS: $67699a75a06dd97b$var$HOME_CUSTOMERS,
    POST_INCIDENT_REVIEWS: $67699a75a06dd97b$var$HOME_POST_INCIDENT_REVIEWS,
    REPORTS: $67699a75a06dd97b$var$HOME_REPORTS,
    RAISE_REQUEST: $67699a75a06dd97b$var$HOME_RAISE_REQUEST,
    ISSUES: $67699a75a06dd97b$var$HOME_ISSUES,
    CUSTOMER_CHANNELS: $67699a75a06dd97b$var$HOME_CUSTOMER_CHANNELS,
    CUSTOMER_CHANNELS_SPOTLIGHT: $67699a75a06dd97b$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT,
    JSD_CHANNELS_DIALOG: $67699a75a06dd97b$var$HOME_JSD_CHANNELS_DIALOG,
    KNOWLEDGE_BASE: $67699a75a06dd97b$var$HOME_KNOWLEDGE_BASE,
    KNOWLEDGE_BASE_HUB: $67699a75a06dd97b$var$HOME_KNOWLEDGE_BASE_HUB,
    KNOWLEDGE_BASE_HUB_NESTED: $67699a75a06dd97b$var$HOME_KNOWLEDGE_BASE_HUB_NESTED,
    INVITE_TEAM: $67699a75a06dd97b$var$HOME_INVITE_TEAM,
    GIVE_FEEDBACK: $67699a75a06dd97b$var$HOME_GIVE_FEEDBACK,
    SERVICES: $67699a75a06dd97b$var$HOME_SERVICES,
    SERVICES_SPOTLIGHT: $67699a75a06dd97b$var$HOME_SERVICES_SPOTLIGHT,
    ALERTS_AND_ON_CALL_SPOTLIGHT: $67699a75a06dd97b$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT,
    CHANGE_CALENDAR_SPOTLIGHT: $67699a75a06dd97b$var$HOME_CHANGE_CALENDAR_SPOTLIGHT
};
const $67699a75a06dd97b$var$KNOWLEDGE_BASE_IDS = {
    TOP_ACTIONS: 'knowledge-hub-top-actions',
    ALL_ARTICLES: 'knowledge-hub-all-articles',
    CATEGORIES: 'knowledge-hub-categories',
    CATEGORIES_CONTEXT: 'knowledge-hub-categories-context',
    BOTTOM_ACTIONS: 'knowledge-hub-bottom-actions',
    ADD_CATEGORY: 'knowledge-hub-new-category',
    LEAVE_FEEDBACK: 'knowledge-hub-leave-feedback'
};
const $67699a75a06dd97b$var$SETTINGS_IDS = {
    DETAILS: 'details',
    PEOPLE: 'people',
    ITSM_FEATURES: 'itsm-features',
    SUMMARY: 'summary',
    DELETE_PROJECT: 'delete-project',
    ISSUE_TYPES: 'issue-types',
    FEATURES: 'features',
    REQUEST_TYPES: 'sd-request-types',
    TICKET_TYPES: 'sd-ticket-types',
    CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
    LANGUAGE_SUPPORT: 'sd-language-support',
    PORTAL_SETTINGS: 'sd-portal-settings',
    EMAIL_REQUESTS: 'sd-email-requests',
    CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
    PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
    PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
    PROJECT_ASSETS_AD: 'sd-project-assets-ad',
    SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
    KNOWLEDGE_BASE: 'sd-knowledge-base',
    SLAS: 'sd-slas',
    AUTOMATION: 'sd-automation',
    PLAYBOOKS: 'playbooks',
    JIRA_AUTOMATION: 'jira-automation',
    AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
    JSD_APP_DISCOVERY: 'sd-app-discovery',
    JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
    JSD_CHANGE_MANAGEMENT: 'sd-change-management',
    WORKFLOWS: 'workflows',
    SCREENS: 'screens',
    FIELDS: 'fields',
    VERSIONS: 'versions',
    COMPONENTS: 'components',
    PERMISSIONS: 'permissions',
    ISSUE_SECURITY: 'issue-security',
    NOTIFICATIONS: 'notifications',
    HIPCHAT: 'hipchat',
    ISSUE_COLLECTORS: 'issue-collectors'
};
const $67699a75a06dd97b$var$QUEUES_IDS = {
    QUEUE_NEW: 'queue-new',
    QUEUE_MANAGE: 'queue-manage',
    QUEUES_ADDONS: 'sd-queues-addons',
    QUEUES_CUSTOM_ACTIONS: 'sd-queues-custom-actions',
    SD_QUEUES_CUSTOM: 'sd-queues-custom'
};
const $67699a75a06dd97b$export$a37f4f7add086a3 = {
    ADDITIONAL_ITEMS: 'sd-practices-additional-items',
    CHANGES_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-changes-queue-title-spotlight',
    CHANGES_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-changes-queue-items-spotlight',
    INCIDENTS_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-incidents-queue-title-spotlight',
    INCIDENTS_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-incidents-queue-items-spotlight'
};
const $67699a75a06dd97b$export$2108a7f32cd0bb12 = {
    SERVICE_DESK: {
        HOME: $67699a75a06dd97b$export$9afbea2cbd37e16d,
        KNOWLEDGE_BASE: $67699a75a06dd97b$var$KNOWLEDGE_BASE_IDS,
        SETTINGS: $67699a75a06dd97b$var$SETTINGS_IDS,
        QUEUES: $67699a75a06dd97b$var$QUEUES_IDS,
        REPORTS: $67699a75a06dd97b$export$1f70a76cb421b107
    }
};
const $67699a75a06dd97b$export$712b4b205a2bcf1e = {
    PRACTICE_NAV_SPOTLIGHT: 'request-type-practice-nav-spotlight',
    UNASSIGNED_NAV_SPOTLIGHT: 'request-type-unassgined-nav-spotlight'
};
const $67699a75a06dd97b$export$e2d46b728fe0a15a = 'jsm-team-starred-onboarding';
const $67699a75a06dd97b$export$c8c1c8c3f8ddba61 = 'project/service-desk/index';
const $67699a75a06dd97b$export$51fa1147c138a6ed = 'project/service-desk/issues';
const $67699a75a06dd97b$export$456b3cfbf5e37bd8 = 'project/service-desk/queues';
const $67699a75a06dd97b$export$9ccc8d85b210b219 = 'project/service-desk/knowledge-hub';
const $67699a75a06dd97b$export$707771f2f7e60575 = 'project/service-desk/reports';
const $67699a75a06dd97b$export$a87fc635598d2d50 = 'project/service-desk/settings';
const $67699a75a06dd97b$export$b6bda26b77269209 = 'project/service-desk/legacy-ticket-types';
const $67699a75a06dd97b$export$776199f9e99c88e2 = 'project/service-desk/languages';
const $67699a75a06dd97b$export$d70ba5c124463035 = 'project/service-desk/translations';
const $67699a75a06dd97b$export$9a6deaa9c1af559f = 'project/service-desk/settings/automation-sub-nav';

});




parcelRegister("imyEu", function(module, exports) {

$parcel$export(module.exports, "PageDwellAnalyticsListener", () => $9d12160bc6dda165$export$6cf89f098b551dad);

var $eJOHy = parcelRequire("eJOHy");

var $cUxaS = parcelRequire("cUxaS");

var $hih5V = parcelRequire("hih5V");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $2aY2d = parcelRequire("2aY2d");

var $9XYcy = parcelRequire("9XYcy");

var $4VR5y = parcelRequire("4VR5y");
const $9d12160bc6dda165$var$WAIT_DURATION = 5000;
/**
 * Dispatches AnalyticsEvent for when a user stays on a page for a set period of time
 */ const $9d12160bc6dda165$export$6cf89f098b551dad = ()=>{
    const [hasFired, setHasFired] = (0, $eJOHy.useState)(false);
    const route = (0, $hih5V.useCurrentRoute)();
    const routeName = route.name;
    const [{ isReady: isReady }] = (0, $9XYcy.useSpaStatePageReady)();
    const isVisible = (0, $4VR5y.usePageVisibility)();
    const interval = (0, $eJOHy.useRef)(null);
    const { data: projectData } = (0, $2aY2d.useProjectContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { isCollapsed: isLeftSidebarCollapsed } = (0, $cUxaS.useLeftSidebarState)();
    (0, $eJOHy.useEffect)(()=>{
        setHasFired(false);
    }, [
        routeName
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isReady) {
            interval.current = null;
            return;
        }
        // If the page is visible, set the analytics event to run after the specified duration
        if (isVisible && !hasFired) interval.current = setTimeout(()=>{
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'page dwelled', routeName, {
                containerId: projectData?.projectId,
                containerType: projectData?.projectType,
                isLeftSidebarCollapsed: isLeftSidebarCollapsed
            });
            setHasFired(true);
        }, $9d12160bc6dda165$var$WAIT_DURATION);
        return ()=>{
            // @ts-expect-error - TS2769 - No overload matches this call.
            interval.current = clearTimeout(interval.current);
        };
    }, [
        createAnalyticsEvent,
        hasFired,
        isReady,
        isVisible,
        routeName,
        projectData?.projectId,
        projectData?.projectType,
        isLeftSidebarCollapsed
    ]);
    return null;
};

});
parcelRegister("4VR5y", function(module, exports) {

$parcel$export(module.exports, "usePageVisibility", () => $e67041c651799768$export$6c98eb2f12f4ec61);

var $eJOHy = parcelRequire("eJOHy");

var $jzYet = parcelRequire("jzYet");
const $e67041c651799768$export$6c98eb2f12f4ec61 = ()=>{
    const [isVisible, setIsVisible] = (0, $eJOHy.useState)((0, $jzYet.isPageVisible)());
    (0, $eJOHy.useEffect)(()=>{
        const onVisibilityChange = ()=>setIsVisible((0, $jzYet.isPageVisible)());
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('visibilitychange', onVisibilityChange);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);
    return isVisible;
};

});
parcelRegister("jzYet", function(module, exports) {

$parcel$export(module.exports, "supportedVisiblityEvent", () => $e5424949077e4f69$export$f7132cb36c80dad);
$parcel$export(module.exports, "isPageVisible", () => $e5424949077e4f69$export$ae4f9b990bc70f70);
const $e5424949077e4f69$var$visibilityMap = {
    // document property: event name
    hidden: 'visibilitychange',
    mozHidden: 'mozvisibilitychange',
    msHidden: 'msvisibilitychange',
    webkitHidden: 'webkitvisibilitychange'
};
const $e5424949077e4f69$var$supportedHiddenKey = Object.keys($e5424949077e4f69$var$visibilityMap).find(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Document'.
(key)=>typeof document !== 'undefined' && typeof document[key] !== 'undefined');
const $e5424949077e4f69$export$f7132cb36c80dad = $e5424949077e4f69$var$visibilityMap[$e5424949077e4f69$var$supportedHiddenKey];
const $e5424949077e4f69$export$ae4f9b990bc70f70 = ()=>typeof document !== 'undefined' && !document[$e5424949077e4f69$var$supportedHiddenKey];

});



parcelRegister("e5yn1", function(module, exports) {

$parcel$export(module.exports, "MatchedRouteListener", () => $6a5c3e88966e65c9$export$c6d9204abc182c3b);

var $eJOHy = parcelRequire("eJOHy");

var $kQnVX = parcelRequire("kQnVX");

var $gCY1z = parcelRequire("gCY1z");
const $6a5c3e88966e65c9$export$c6d9204abc182c3b = ()=>{
    const [{ route: route, match: match }] = (0, $gCY1z.useRouter)();
    (0, $eJOHy.useMemo)(()=>(0, $kQnVX.setMatchedRoute)(route, match), [
        route,
        match
    ]);
    return null;
};

});

parcelRegister("38W5l", function(module, exports) {

$parcel$export(module.exports, "PreviousRouterStateListener", () => $6dbb6c87215e8abb$export$49e28489f2124002);

var $eJOHy = parcelRequire("eJOHy");

var $6d9QY = parcelRequire("6d9QY");

var $kQnVX = parcelRequire("kQnVX");

var $ivzXw = parcelRequire("ivzXw");
const $6dbb6c87215e8abb$export$3fd5ddd6b8e9a200 = ({ routerState: routerState })=>{
    const previousRouterState = (0, $6d9QY.usePrevious)(routerState);
    (0, $eJOHy.useEffect)(()=>{
        (0, $kQnVX.setPreviousRouterState)(previousRouterState ?? null);
    }, [
        previousRouterState
    ]);
    return null;
};
const $6dbb6c87215e8abb$export$49e28489f2124002 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivzXw.RouterSubscriber), null, (routerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6dbb6c87215e8abb$export$3fd5ddd6b8e9a200, {
            routerState: routerState
        })));
$6dbb6c87215e8abb$export$49e28489f2124002.displayName = 'PreviousRouterStateListener';

});

parcelRegister("6u6pq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6b786fc3210ac1a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $3aa9n = parcelRequire("3aa9n");

var $e342q = parcelRequire("e342q");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");

var $lcB5K = parcelRequire("lcB5K");
var $ivzXw = parcelRequire("ivzXw");

var $epTsa = parcelRequire("epTsa");

var $jLNSr = parcelRequire("jLNSr");
/**
 * Defines the component for the `querystring-notifier` module.
 */ const $d6b786fc3210ac1a$var$QueryStringNotifier = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$1171103ea9083ffa),
        sourceName: "querystringNotifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e342q.default), null, (flagService)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivzXw.RouterSubscriber), null, ({ location: { search: search } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ replace: replace })=>{
                const { showFlag: showFlag, ...query } = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(search);
                if (!showFlag) return null;
                const notificationMessages = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $jLNSr.notificationMessagesWithoutProjectTerm) : (0, $jLNSr.notificationMessagesWithProjectTerm);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, notificationMessages[showFlag] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireOperationalAnalytics), {
                    eventName: "querystringNotification shown",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireOperationalAnalytics), {
                    eventName: "querystringNotification notFound",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3aa9n.default), {
                    op: ()=>{
                        if (notificationMessages[showFlag]) flagService.showFlag(notificationMessages[showFlag]);
                        replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(query)}`);
                    }
                }));
            }))));
var $d6b786fc3210ac1a$export$2e2bcd8739ae039 = $d6b786fc3210ac1a$var$QueryStringNotifier;

});
parcelRegister("3aa9n", function(module, exports) {

$parcel$export(module.exports, "default", () => $8027defe1b946cc9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
// eslint-disable-next-line jira/react/no-class-components
class $8027defe1b946cc9$var$OpTrigger extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $8027defe1b946cc9$export$2e2bcd8739ae039 = $8027defe1b946cc9$var$OpTrigger;

});

parcelRegister("e342q", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd16d6aeb0fd5c81$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bILK0 = parcelRequire("bILK0");
const $dd16d6aeb0fd5c81$var$FlagServiceSubscriber = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children((0, $bILK0.flagService)));
var $dd16d6aeb0fd5c81$export$2e2bcd8739ae039 = $dd16d6aeb0fd5c81$var$FlagServiceSubscriber;

});

parcelRegister("jLNSr", function(module, exports) {

$parcel$export(module.exports, "notificationMessagesWithProjectTerm", () => $7906ae57d76a25b2$export$29d79c6c9f4a7eec);
$parcel$export(module.exports, "notificationMessagesWithoutProjectTerm", () => $7906ae57d76a25b2$export$c8ca2015225638f9);

var $hrodw = parcelRequire("hrodw");

var $9f84N = parcelRequire("9f84N");
const $7906ae57d76a25b2$export$29d79c6c9f4a7eec = {
    'jsw.board-not-found': {
        id: (0, $hrodw.toFlagId)('jsw.board-not-found'),
        type: 'error',
        title: (0, $9f84N.default).boardNotFound,
        description: (0, $9f84N.default).boardNotFoundDescription,
        messageId: 'query-string-notifier.common.flag.error.error.jsw.board-not-found',
        messageType: 'transactional'
    },
    'jsw.project-not-found': {
        id: (0, $hrodw.toFlagId)('jsw.project-not-found'),
        type: 'error',
        title: (0, $9f84N.default).projectNotFound,
        description: (0, $9f84N.default).projectNotFoundDescription,
        messageId: 'query-string-notifier.common.flag.error.error.jsw.project-not-found',
        messageType: 'transactional'
    }
};
const $7906ae57d76a25b2$export$c8ca2015225638f9 = {
    'jsw.board-not-found': {
        id: (0, $hrodw.toFlagId)('jsw.board-not-found'),
        type: 'error',
        title: (0, $9f84N.default).boardNotFound,
        description: (0, $9f84N.default).boardNotFoundDescriptionGalaxia,
        messageId: 'query-string-notifier.common.flag.error.error.jsw.board-not-found.1',
        messageType: 'transactional'
    },
    'jsw.project-not-found': {
        id: (0, $hrodw.toFlagId)('jsw.project-not-found'),
        type: 'error',
        title: (0, $9f84N.default).projectNotFoundGalaxia,
        description: (0, $9f84N.default).projectNotFoundDescription,
        messageId: 'query-string-notifier.common.flag.error.error.jsw.project-not-found.1',
        messageType: 'transactional'
    }
};

});
parcelRegister("9f84N", function(module, exports) {

$parcel$export(module.exports, "default", () => $34589732b7bc6c73$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
// Don't confuse Intl messages with `Flag`s
const $34589732b7bc6c73$var$messages = (0, $7qGN1.defineMessages)({
    boardNotFound: {
        "id": "query-string-notifier.common.board-not-found",
        "defaultMessage": "Board not found"
    },
    boardNotFoundDescription: {
        "id": "query-string-notifier.common.board-not-found-description",
        "defaultMessage": "You tried to access a board that doesn't exist or that you don't have permission to see."
    },
    projectNotFound: {
        "id": "query-string-notifier.common.project-not-found",
        "defaultMessage": "Project not found"
    },
    projectNotFoundDescription: {
        "id": "query-string-notifier.common.project-not-found-description",
        "defaultMessage": "You tried to access a project that doesn't exist or that you don't have permission to see."
    },
    boardNotFoundDescriptionGalaxia: {
        "id": "query-string-notifier.common.board-not-found-description-galaxia",
        "defaultMessage": "Space not found"
    },
    projectNotFoundGalaxia: {
        "id": "query-string-notifier.common.project-not-found-galaxia",
        "defaultMessage": "You tried to access a space that doesn't exist or that you don't have permission to see."
    }
});
var $34589732b7bc6c73$export$2e2bcd8739ae039 = $34589732b7bc6c73$var$messages;

});



parcelRegister("3Kq2h", function(module, exports) {

$parcel$export(module.exports, "AsyncRecommendPremiumToStandardModalWrapper", () => $b881d19f08db553c$export$2a43717c77dd3a56);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $5kYyR = parcelRequire("5kYyR");

var $gzcjr = parcelRequire("gzcjr");

var $5Ej1c = parcelRequire("5Ej1c");

const $b881d19f08db553c$var$AsyncRecommendPremiumToStandardModalComponent = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("840gJ")).then(({ RecommendPremiumToStandardModalComponent: RecommendPremiumToStandardModalComponent })=>RecommendPremiumToStandardModalComponent), {
    moduleId: "./src/packages/growth/recommend-premium-to-standard-modal/src/index.tsx"
});
const $b881d19f08db553c$export$2a43717c77dd3a56 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $5Ej1c.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        teamName: (0, $5Ej1c.TEAM_NAME),
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $5Ej1c.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b881d19f08db553c$var$AsyncRecommendPremiumToStandardModalComponent, null)));
};

});
parcelRegister("5Ej1c", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $cada512a9167af5d$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $cada512a9167af5d$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ANALYTICS_SOURCE_NAME", () => $cada512a9167af5d$export$48e1d3fa57b0a2d5);
$parcel$export(module.exports, "STARGATE_URL", () => $cada512a9167af5d$export$c7e6a6b283196232);
$parcel$export(module.exports, "RECC_STANDARD_MESSAGE_ID", () => $cada512a9167af5d$export$de9f5b160db96e26);
const $cada512a9167af5d$export$b8b9d90f9e5bd72b = '@atlassian/jira-recommend-premium-to-standard-modal';
const $cada512a9167af5d$export$d57b6b390e78d90f = 'growth-tako';
const $cada512a9167af5d$export$48e1d3fa57b0a2d5 = 'recommendPremiumToStandard';
const $cada512a9167af5d$export$c7e6a6b283196232 = '/gateway/api';
const $cada512a9167af5d$export$de9f5b160db96e26 = new Map([
    [
        5,
        'prj-grace-period-recc-standard-msg-1'
    ],
    [
        3,
        'prj-grace-period-recc-standard-msg-2'
    ],
    [
        1,
        'prj-grace-period-recc-standard-msg-3'
    ]
]);

});

parcelRegister("840gJ", function(module, exports) {

let $5deee7d377d68a71$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5deee7d377d68a71$var$load("k19qV").then(()=>parcelRequire('1uyZT'));

});


parcelRegister("fp9AW", function(module, exports) {

$parcel$export(module.exports, "rovoVideoModalEntryPoint", () => $e0979c685e92cfe9$export$2f67fedc6d5555a5);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $e0979c685e92cfe9$export$2f67fedc6d5555a5 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(async ()=>(parcelRequire("aN4LA")).then(({ RovoVideoModal: RovoVideoModal })=>RovoVideoModal), {
        moduleId: "3a307b00",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aN4LA", function(module, exports) {

let $7db22d7e7d7258bb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7db22d7e7d7258bb$var$load("8sH7f").then(()=>parcelRequire('5R9cq'));

});


parcelRegister("hMGR1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3eaab86218c0fb0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3Q6BV = parcelRequire("3Q6BV");

var $iqtgH = parcelRequire("iqtgH");

var $dZRaT = parcelRequire("dZRaT");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");
var $gCY1z = parcelRequire("gCY1z");
/**
 * Ensures users are redirected to the correct project URL when there's a mismatch in the project key.
 * It preserves query parameters during redirection and logs the event for analytics.
 */ const $a3eaab86218c0fb0$var$ProjectKeyRedirect = ({ FireOperationalAnalytics: FireOperationalAnalytics = (0, $iqtgH.FireOperationalAnalytics), Redirect: Redirect = (0, $2mHfh.Redirect), useResource: // eslint-disable-next-line react-hooks/react-compiler
useResource = (0, $eJrcF.useResource), useRouter: // eslint-disable-next-line react-hooks/react-compiler
useRouter = (0, $gCY1z.useRouter) })=>{
    const [{ location: location, match: { params: params, url: url }, query: query }] = useRouter();
    const projectKey = params.projectKey ?? query.projectKey;
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: projectContext } = useResource((0, $dZRaT.projectContextResource));
    if (!projectKey || !projectContext?.projectKey) return null;
    if (projectKey === projectContext.projectKey) return null;
    const search = {
        ...query,
        ...query.projectKey ? {
            projectKey: projectContext.projectKey
        } : {}
    };
    // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
    const queryString = (0, $3Q6BV.qs).stringify(search, Object.entries(search).length > 0);
    // Just a slight risk mitigation - only do the string replace if the match param is there
    const path = params.projectKey != null ? url.replace(projectKey, projectContext.projectKey) : url;
    const to = `${path}${queryString}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FireOperationalAnalytics, {
        eventName: "ProjectKeyRedirect loaded",
        componentName: "ProjectKeyRedirect",
        attributes: {
            location: location,
            projectContext: projectContext
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Redirect, {
        to: to
    }));
};
var $a3eaab86218c0fb0$export$2e2bcd8739ae039 = $a3eaab86218c0fb0$var$ProjectKeyRedirect;

});

parcelRegister("7Wekb", function(module, exports) {

$parcel$export(module.exports, "AsyncTrialSprintBoardModalEntryPoint", () => $4d1070d273b97315$export$ba04f28d78ea7267);

var $eJOHy = parcelRequire("eJOHy");

var $3CprG = parcelRequire("3CprG");

var $9zZj0 = parcelRequire("9zZj0");

var $cystD = parcelRequire("cystD");

var $bbdV2 = parcelRequire("bbdV2");

var $h47gY = parcelRequire("h47gY");

var $5kYyR = parcelRequire("5kYyR");

var $kEUB1 = parcelRequire("kEUB1");

var $g9Vr6 = parcelRequire("g9Vr6");

var $eWzpp = parcelRequire("eWzpp");

var $ln6Iy = parcelRequire("ln6Iy");

var $9HmCl = parcelRequire("9HmCl");

var $8vyDv = parcelRequire("8vyDv");

var $a9ldn = parcelRequire("a9ldn");

var $afhk3 = parcelRequire("afhk3");


var $dK3dZ = parcelRequire("dK3dZ");

var $6HNEd = parcelRequire("6HNEd");

var $1FwBg = parcelRequire("1FwBg");

var $i2j7n = parcelRequire("i2j7n");
const $4d1070d273b97315$export$5f395c9784fafd48 = ({ ctaLink: ctaLink })=>{
    /**
	 * Makes the final checks before calling EP
	 * - Site must be in their 10/11th, 12/13th or 14th+ day in trial
	 */ const cloudId = (0, $kEUB1.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $ln6Iy.toProjectType)(project?.type);
    const productEntitlementDetails = (0, $9HmCl.useProductEntitlementDetails)();
    const productKey = projectType && (0, $ln6Iy.projectTypeToCanonicalId)(projectType);
    const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
    const daysLeft = (0, $afhk3.useMemoizedTrialDaysLeftFromTrialEndTime)(entitlementDetails?.trialEndTime) ?? 0;
    // Show the modal three times 10/11, 12/13 and 14+ days after site creation
    const eligibleForFirstModal = daysLeft === 20 || daysLeft === 19;
    const eligibleForSecondModal = daysLeft === 18 || daysLeft === 17;
    const eligibleForThirdModal = daysLeft <= 16;
    const eligibleDaysLeft = eligibleForFirstModal || eligibleForSecondModal || eligibleForThirdModal;
    const messageId = (0, $i2j7n.getMessageId)(daysLeft);
    const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, (0, $bde8866fb5971372$export$c7e6a6b283196232), false, orgId, 'engagement'), [
        cloudId,
        orgId
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>{
        if (messageId) coordinationClient.stop(messageId);
    }, [
        coordinationClient,
        messageId
    ]);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            ctaLink: ctaLink,
            onClose: onClose,
            messageId: messageId ?? '',
            coordinationClient: coordinationClient
        }), [
        coordinationClient,
        ctaLink,
        messageId,
        onClose
    ]);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({}), []);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $1FwBg.trialSprintBoardModalEntryPoint), entryPointParams);
    const isEligible = eligibleDaysLeft && messageId;
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isEligible) {
            const conditionallyLoadEntryPoint = async ()=>{
                const started = await coordinationClient.start(messageId);
                if (started) entryPointActions.load();
            };
            conditionallyLoadEntryPoint();
        }
    }, [
        coordinationClient,
        entryPointActions,
        daysLeft,
        messageId,
        isEligible
    ]);
    return isEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3CprG.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cystD.ModalEntryPointContainer), {
        id: (0, $bde8866fb5971372$export$48e1d3fa57b0a2d5),
        packageName: (0, $bde8866fb5971372$export$b8b9d90f9e5bd72b),
        teamName: (0, $bde8866fb5971372$export$d57b6b390e78d90f),
        errorFallback: "unmount",
        runtimeProps: runtimeProps,
        entryPointActions: entryPointActions,
        entryPointReferenceSubject: entryPointReferenceSubject
    }));
};
const $4d1070d273b97315$export$34d6cccb83207ca5 = ({ currentProjectId: currentProjectId })=>{
    /**
	 * Makes the follow up dynamic eligibility checks for the Trial Sprint Board modal
	 * - Current project is NOT the trial sprint board (via comparison of projectId against TSB projectId stored in traits)
	 * - CTA Link has been generated correctly (via GraphQL query - only works for JSW TMP projects)
	 * - Modal must not have been dismissed forever by user (value stored in local storage)
	 */ const isNotTrialSprintBoardProject = (0, $dK3dZ.useIsNotTrialSprintBoardProject)(currentProjectId);
    const ctaLink = (0, $dK3dZ.useTrialSprintBoardCtaLink)();
    const hasModalBeenDismissed = (0, $6HNEd.getIsTrialSprintBoardModalDismissed)() === true;
    const isEligible = isNotTrialSprintBoardProject && Boolean(ctaLink) && !hasModalBeenDismissed;
    return isEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4d1070d273b97315$export$5f395c9784fafd48, {
        ctaLink: ctaLink
    });
};
const $4d1070d273b97315$export$738784b961d0b111 = (props)=>{
    /**
	 * Makes the initial static eligibility checks for the Trial Sprint Board modal
	 * - Must currently be on a JSW Project
	 * - Must be on Premium Edition of JSW
	 */ const appEditions = (0, $8vyDv.useAppEditions)();
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $ln6Iy.toProjectType)(project?.type);
    const isJswProject = projectType === (0, $ln6Iy.SOFTWARE_PROJECT);
    const isOnPremiumJsw = appEditions.software === (0, $a9ldn.PREMIUM_EDITION);
    const isEligible = isJswProject && isOnPremiumJsw;
    return isEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4d1070d273b97315$export$34d6cccb83207ca5, props);
};
const $4d1070d273b97315$export$ba04f28d78ea7267 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: `async-${(0, $bde8866fb5971372$export$48e1d3fa57b0a2d5)}`,
        packageName: (0, $bde8866fb5971372$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        teamName: (0, $bde8866fb5971372$export$d57b6b390e78d90f),
        id: `async-${(0, $bde8866fb5971372$export$48e1d3fa57b0a2d5)}`,
        packageName: (0, $bde8866fb5971372$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4d1070d273b97315$export$738784b961d0b111, props)));
};

});
parcelRegister("9zZj0", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $14e1efc63586f987$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $14e1efc63586f987$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h1MRb = parcelRequire("h1MRb");

var $9Vh43 = parcelRequire("9Vh43");
var $8de03 = parcelRequire("8de03");

var $cnm9v = parcelRequire("cnm9v");

var $3CprG = parcelRequire("3CprG");

var $SyPNn = parcelRequire("SyPNn");

var $aYncF = parcelRequire("aYncF");

var $7jTnu = parcelRequire("7jTnu");

var $hWeHP = parcelRequire("hWeHP");

var $g9Vr6 = parcelRequire("g9Vr6");

var $c9z5K = parcelRequire("c9z5K");
const $14e1efc63586f987$var$isSyntheticTenant = ()=>(0, $hWeHP.default)('ajs-is-synthetic') === 'true';
class $14e1efc63586f987$export$580a2294c917898c extends (0, $8de03.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
        const environment = (0, $c9z5K.toEnvironment)((0, $hWeHP.default)('ajs-environment'));
        const getEnvironmentType = (env)=>{
            if (env === 'prod') return (0, $h1MRb.envType).PROD;
            if (env === 'staging') return (0, $h1MRb.envType).STAGING;
            return (0, $h1MRb.envType).DEV;
        };
        // If a ancestor (e.g. CoordinationClient wraps CoordinationClient) is already choreographed,
        // we should not re-choreograph this CoordinationClient
        const enableChoreographer = (0, $SyPNn.shouldBeChoreographed)({
            messageType: messageType
        }) && !isAlreadyChoreographedAtAncestor;
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: getEnvironmentType(environment),
            additionalData: {
                sourceProductId: (0, $cnm9v.ProductIds).JIRA
            }
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $14e1efc63586f987$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $7jTnu.fg)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $cnm9v.MessageDeliveryStatus).STARTED : (0, $cnm9v.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $cnm9v.MessageDeliveryStatus).STOPPED : (0, $cnm9v.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $cnm9v.MessageDeliveryStatus).STARTED : (0, $cnm9v.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $cnm9v.MessageDeliveryStatus).STOPPED : (0, $cnm9v.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $14e1efc63586f987$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $3CprG.useChoreographedStatusContext)();
    const client = new $14e1efc63586f987$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3CprG.ChoreographerContextProvider), {
        isChoreographed: client.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Vh43.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children));
}

});

const $bde8866fb5971372$export$b8b9d90f9e5bd72b = '@atlassian/jira-trial-sprint-board';
const $bde8866fb5971372$export$d57b6b390e78d90f = 'growth-tako';
const $bde8866fb5971372$export$48e1d3fa57b0a2d5 = 'trialSprintBoard';
const $bde8866fb5971372$export$cf8de4fabae858f0 = 'jira_premium_sample_project_id';
const $bde8866fb5971372$export$c7e6a6b283196232 = '/gateway/api';
const $bde8866fb5971372$export$e663120dbb5b4d95 = 'prj-trial-sprint-board-v2-msg-1';
const $bde8866fb5971372$export$a248637601302a6b = 'prj-trial-sprint-board-v2-msg-2';
const $bde8866fb5971372$export$389fc29b60f6a76b = 'prj-trial-sprint-board-v2-msg-3';
const $bde8866fb5971372$export$87b7067777cb7156 = 'trial-sprint-board';
const $bde8866fb5971372$export$a8c0b3da0abca1ac = 'trial-sprint-board-dismissed';

parcelRegister("dK3dZ", function(module, exports) {

$parcel$export(module.exports, "useCreateTrialSprintBoard", () => $e929cad234d3a793$export$22329068885bcc27);
$parcel$export(module.exports, "useIsNotTrialSprintBoardProject", () => $e929cad234d3a793$export$8b329ff03fe43c53);
$parcel$export(module.exports, "useTrialSprintBoardCtaLink", () => $e929cad234d3a793$export$a731bac57ab8049d);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3osLr = parcelRequire("3osLr");

var $lctcw = parcelRequire("lctcw");

var $kEUB1 = parcelRequire("kEUB1");

var $f1Zdy = parcelRequire("f1Zdy");

var $gYnSx = parcelRequire("gYnSx");


var $fl3S5 = parcelRequire("fl3S5");

var $6HNEd = parcelRequire("6HNEd");

var $8ERPY = parcelRequire("8ERPY");
function $e929cad234d3a793$export$22329068885bcc27() {
    const isEligibleForExperiment = (0, $fl3S5.useIsEligibleForTrialSprintBoard)();
    return ()=>{
        if (isEligibleForExperiment) (0, $6HNEd.createTrialSprintBoard)();
    };
}
const $e929cad234d3a793$export$dca4afd9682f517e = async (cloudId)=>{
    const siteTraits = await (0, $lctcw.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    const trialSprintBoardTrait = siteTraits.find((traits)=>traits.name === (0, $bde8866fb5971372$export$cf8de4fabae858f0));
    if (typeof trialSprintBoardTrait?.value !== 'string') return undefined;
    return trialSprintBoardTrait.value;
};
const $e929cad234d3a793$export$5efe839f0f2e520e = async (cloudId, projectId)=>{
    const trialSprintBoardId = await $e929cad234d3a793$export$dca4afd9682f517e(cloudId);
    return trialSprintBoardId === projectId;
};
const $e929cad234d3a793$export$3b897619e437256e = async (cloudId, relayEnvironment, createAnalyticsEvent)=>{
    try {
        const trialSprintBoardId = await $e929cad234d3a793$export$dca4afd9682f517e(cloudId);
        if (trialSprintBoardId === undefined) return false;
        const projectAri = (0, $3osLr.JiraProjectAri).create({
            siteId: cloudId,
            projectId: trialSprintBoardId
        }).toString();
        const { isProjectActive: isProjectActive, projectCreated: projectCreated } = await (0, $6HNEd.getTrialSprintBoardProjectData)(projectAri, relayEnvironment, createAnalyticsEvent);
        const millisDay = 86400000;
        const daysLeft = projectCreated ? Math.ceil((projectCreated + 30 * millisDay - Date.now()) / millisDay) : -1;
        return isProjectActive && daysLeft > 0;
    } catch (error) {
        if (error instanceof Error) {
            const event = createAnalyticsEvent({});
            (0, $gYnSx.default)({
                event: event,
                error: new Error(`Failed to get trial sprint active status: ${error.message}`),
                meta: {
                    id: 'isTrialSprintBoardProjectActive',
                    packageName: (0, $bde8866fb5971372$export$b8b9d90f9e5bd72b),
                    teamName: (0, $bde8866fb5971372$export$d57b6b390e78d90f)
                },
                skipSentry: (0, $8ERPY.shouldSkipErrorReporting)(error)
            });
        }
        return false;
    }
};
const $e929cad234d3a793$export$d5193e0cb6586d5 = async (cloudId, relayEnvironment, createAnalyticsEvent)=>{
    try {
        const trialSprintBoardId = await $e929cad234d3a793$export$dca4afd9682f517e(cloudId);
        if (trialSprintBoardId === undefined) return undefined;
        const projectAri = (0, $3osLr.JiraProjectAri).create({
            siteId: cloudId,
            projectId: trialSprintBoardId
        }).toString();
        const { projectKey: projectKey, boardId: boardId } = await (0, $6HNEd.getTrialSprintBoardProjectData)(projectAri, relayEnvironment, createAnalyticsEvent);
        if (projectKey === null || boardId === null) return undefined;
        const projectBoardWithIssueSelectedPath = `/jira/software/projects/${projectKey}/boards/${boardId}?selectedIssue=LEARNJIRA-1`;
        return projectBoardWithIssueSelectedPath;
    } catch (error) {
        if (error instanceof Error) {
            const event = createAnalyticsEvent({});
            (0, $gYnSx.default)({
                event: event,
                error: new Error(`Failed to get trial sprint board path: ${error.message}`),
                meta: {
                    id: 'getTrialSprintBoardPath',
                    packageName: (0, $bde8866fb5971372$export$b8b9d90f9e5bd72b),
                    teamName: (0, $bde8866fb5971372$export$d57b6b390e78d90f)
                },
                skipSentry: (0, $8ERPY.shouldSkipErrorReporting)(error)
            });
        }
        return undefined;
    }
};
const $e929cad234d3a793$export$8b329ff03fe43c53 = (currentProjectId)=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const [isNotTsbProject, setIsNotTsbProject] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        $e929cad234d3a793$export$5efe839f0f2e520e(cloudId, currentProjectId).then((isTsbProject)=>setIsNotTsbProject(!isTsbProject));
    }, [
        cloudId,
        currentProjectId
    ]);
    return isNotTsbProject;
};
const $e929cad234d3a793$export$a731bac57ab8049d = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const relayEnvironment = (0, $j4oe4.useRelayEnvironment)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [ctaLink, setCtaLink] = (0, $eJOHy.useState)('');
    (0, $eJOHy.useEffect)(()=>{
        const getCtaLink = async ()=>{
            const isProjectAvailable = await $e929cad234d3a793$export$3b897619e437256e(cloudId, relayEnvironment, createAnalyticsEvent);
            if (isProjectAvailable) {
                const tsbIssuePath = await $e929cad234d3a793$export$d5193e0cb6586d5(cloudId, relayEnvironment, createAnalyticsEvent);
                if (tsbIssuePath !== undefined) setCtaLink(tsbIssuePath);
            }
        };
        getCtaLink().catch((e)=>{
            (0, $gYnSx.default)({
                error: e,
                meta: {
                    id: 'getTrialSprintBoardProjectCtaLink',
                    packageName: (0, $bde8866fb5971372$export$b8b9d90f9e5bd72b),
                    teamName: (0, $bde8866fb5971372$export$d57b6b390e78d90f)
                }
            });
        });
    }, [
        cloudId,
        createAnalyticsEvent,
        relayEnvironment
    ]);
    return ctaLink;
};

});
parcelRegister("fl3S5", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleForTrialSprintBoard", () => $5eb588c9cb170b66$export$e6f5647df30a55f2);

var $eJOHy = parcelRequire("eJOHy");


var $a9ldn = parcelRequire("a9ldn");

var $hmtVp = parcelRequire("hmtVp");

var $8vyDv = parcelRequire("8vyDv");

var $8wUZn = parcelRequire("8wUZn");

var $b9nqM = parcelRequire("b9nqM");

var $9HmCl = parcelRequire("9HmCl");

var $afhk3 = parcelRequire("afhk3");
function $5eb588c9cb170b66$export$e6f5647df30a55f2() {
    const appEditions = (0, $8vyDv.useAppEditions)();
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const licenseStates = (0, $8wUZn.useLicenseStates)();
    const productEntitlementDetails = (0, $9HmCl.useProductEntitlementDetails)();
    const jswAppEdition = appEditions.software;
    // Only has JSW in licenses, assumed to be active given we are in onboarding flow
    const hasActiveJswLicense = licensedProducts[0, $e08dff4ae358d899$export$1346c9aa3cbb477d] && licenseStates.software === (0, $hmtVp.LICENSE_STATE_ACTIVE) && Object.keys(licensedProducts).length === 1;
    // JSW Premium
    const isOnPremiumJsw = jswAppEdition === (0, $a9ldn.PREMIUM_EDITION);
    // On a trial
    const entitlementDetails = productEntitlementDetails?.[0, $e08dff4ae358d899$export$1346c9aa3cbb477d];
    const trialDaysLeft = (0, $eJOHy.useMemo)(()=>(0, $afhk3.getTrialDaysLeftFromTrialEndTime)(entitlementDetails?.trialEndTime) ?? 0, [
        entitlementDetails?.trialEndTime
    ]);
    const isOnTrial = trialDaysLeft >= 0;
    return hasActiveJswLicense && isOnPremiumJsw && isOnTrial;
}

});

parcelRegister("6HNEd", function(module, exports) {

$parcel$export(module.exports, "createTrialSprintBoard", () => $a9fdfcfba4d5e2d8$export$37cea344fdf9b6ed);
$parcel$export(module.exports, "getTrialSprintBoardProjectData", () => $a9fdfcfba4d5e2d8$export$83e8cdb22fb8892d);
$parcel$export(module.exports, "getIsTrialSprintBoardModalDismissed", () => $a9fdfcfba4d5e2d8$export$2e4dd8ccc94e5fa);
$parcel$export(module.exports, "setIsTrialSprintBoardModalDismissed", () => $a9fdfcfba4d5e2d8$export$ad35b736c85ccec3);

var $9g2KR = parcelRequire("9g2KR");

var $37Ewn = parcelRequire("37Ewn");

var $ln6Iy = parcelRequire("ln6Iy");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $gCeeo = parcelRequire("gCeeo");

var $dnU6V = parcelRequire("dnU6V");

function $a9fdfcfba4d5e2d8$export$37cea344fdf9b6ed() {
    (0, $jGzN3.performPostRequest)('/rest/trial-project/v1/create').catch((error)=>{
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'createTrialSprintBoard',
                packageName: (0, $bde8866fb5971372$export$b8b9d90f9e5bd72b),
                teamName: (0, $bde8866fb5971372$export$d57b6b390e78d90f)
            }
        });
    });
}
const $a9fdfcfba4d5e2d8$export$83e8cdb22fb8892d = async (projectAri, relayEnvironment, createAnalyticsEvent)=>{
    return new Promise((resolve, reject)=>{
        (0, $37Ewn.fetchQuery)(relayEnvironment, (0, $9g2KR.default), {
            projectAri: projectAri
        }, {
            fetchPolicy: 'store-or-network'
        }).toPromise().then((data)=>{
            const project = data?.jira?.jiraProject;
            const isProjectActive = project?.status === (0, $ln6Iy.JIRA_PROJECT_STATUS_ACTIVE);
            const projectKey = project?.key;
            const boardId = project?.tmpBoardId;
            const projectCreated = project?.created ? new Date(project.created).getTime() : null;
            if (!project) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'trialSprintBoardProject notFound', {});
            else if (!projectKey || !boardId || !project.status || !projectCreated) {
                const event = createAnalyticsEvent({});
                (0, $gYnSx.default)({
                    event: event,
                    error: new Error('Could not retrieve all trial sprint board project data'),
                    meta: {
                        id: 'getTrialSprintBoardProjectData',
                        packageName: (0, $bde8866fb5971372$export$b8b9d90f9e5bd72b),
                        teamName: (0, $bde8866fb5971372$export$d57b6b390e78d90f)
                    },
                    attributes: {
                        isProjectActive: isProjectActive,
                        activeStatusIsPresent: !!project?.status,
                        projectKeyIsPresent: !!projectKey,
                        boardId: boardId ?? null,
                        projectCreated: projectCreated,
                        projectStyle: project?.projectStyle,
                        projectType: project?.projectType,
                        projectKeyIsLearnJira: projectKey === 'LEARNJIRA',
                        projectId: project?.id
                    }
                });
            }
            resolve({
                isProjectActive: isProjectActive,
                projectKey: projectKey ?? null,
                boardId: boardId ?? null,
                projectCreated: projectCreated
            });
        }).catch((error)=>{
            reject(error);
        });
    });
};
const $a9fdfcfba4d5e2d8$var$tsbLocalStorage = (0, $dnU6V.createLocalStorageProvider)((0, $bde8866fb5971372$export$87b7067777cb7156));
const $a9fdfcfba4d5e2d8$export$2e4dd8ccc94e5fa = ()=>{
    return $a9fdfcfba4d5e2d8$var$tsbLocalStorage.get((0, $bde8866fb5971372$export$a8c0b3da0abca1ac)) === true;
};
const $a9fdfcfba4d5e2d8$export$ad35b736c85ccec3 = ()=>{
    $a9fdfcfba4d5e2d8$var$tsbLocalStorage.set((0, $bde8866fb5971372$export$a8c0b3da0abca1ac), true);
};

});
parcelRegister("9g2KR", function(module, exports) {

$parcel$export(module.exports, "default", () => $04c47c44dce384e6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1a068650687102c6acf15dd70947df44>>
 * @relayHash 11df15622137d899ae3fbfec59ad8686
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f1ec6c80450d3ba722ab175466c2c311ff006aefb1ddfb712d5f8a3db7c3bbb0
const $04c47c44dce384e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "projectAri"
                        }
                    ],
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jiraProject",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "created"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tmpBoardId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectStyle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "servicesTrialSprintBoardProjectDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "servicesTrialSprintBoardProjectDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "f1ec6c80450d3ba722ab175466c2c311ff006aefb1ddfb712d5f8a3db7c3bbb0",
            "metadata": {},
            "name": "servicesTrialSprintBoardProjectDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$04c47c44dce384e6$var$node.hash = "4f66359ce8fd45935ef44b8742014c34";
var $04c47c44dce384e6$export$2e2bcd8739ae039 = $04c47c44dce384e6$var$node;

});


parcelRegister("8ERPY", function(module, exports) {

$parcel$export(module.exports, "shouldSkipErrorReporting", () => $1e4802dc79fe1d53$export$cbe7250175797ee6);
/**
 * These are errors which we ignore from SLO reporting to ensure we reporting on errors we can action
 */ const $1e4802dc79fe1d53$var$skippedErrors = [
    /failed to fetch/i,
    /Fetch call failed with status code: 401/i,
    /NetworkError when attempting to fetch resource./i,
    /The operation was aborted./i
];
function $1e4802dc79fe1d53$export$cbe7250175797ee6(error) {
    // Just checks that none of our non slo errors match the error
    return $1e4802dc79fe1d53$var$skippedErrors.some((msg)=>msg.test(error.message));
}

});


parcelRegister("1FwBg", function(module, exports) {

$parcel$export(module.exports, "trialSprintBoardModalEntryPoint", () => $641f102666a4f0fa$export$ee8e5ecce2602f9);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $641f102666a4f0fa$export$ee8e5ecce2602f9 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("bWrUI")).then(({ TrialSprintBoardModalEntryPoint: TrialSprintBoardModalEntryPoint })=>TrialSprintBoardModalEntryPoint), {
        moduleId: "d60f0bc1",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bWrUI", function(module, exports) {

let $8b1ac39457040984$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8b1ac39457040984$var$load("5XFTT").then(()=>parcelRequire('8Gmh9'));

});


parcelRegister("i2j7n", function(module, exports) {

$parcel$export(module.exports, "getMessageId", () => $e9fabd0dcf646850$export$7a6ec380c1221521);

const $e9fabd0dcf646850$export$7a6ec380c1221521 = (daysLeft)=>{
    if (daysLeft === 20 || daysLeft === 19) return 0, $bde8866fb5971372$export$e663120dbb5b4d95;
    if (daysLeft === 18 || daysLeft === 17) return 0, $bde8866fb5971372$export$a248637601302a6b;
    if (daysLeft <= 16) return 0, $bde8866fb5971372$export$389fc29b60f6a76b;
};

});


parcelRegister("b4mGA", function(module, exports) {

$parcel$export(module.exports, "AsyncUpflowIframeComponent", () => $d07fd6705d6948df$export$7f34679273a30171);

var $eJOHy = parcelRequire("eJOHy");

var $gzcjr = parcelRequire("gzcjr");

var $bJscI = parcelRequire("bJscI");

var $bbdV2 = parcelRequire("bbdV2");

var $cBavF = parcelRequire("cBavF");

var $gGLWS = parcelRequire("gGLWS");

var $8PILw = parcelRequire("8PILw");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d07fd6705d6948df$var$AsyncUpflowIframeComponentOld = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("1WOax")).then((exportedModule)=>exportedModule.UpflowIframeComponent), {
    ssr: false,
    moduleId: "./src/packages/growth/up-flow/upflow-iframe-plugin/src/main.tsx"
});
const $d07fd6705d6948df$var$entryPointParams = {};
const $d07fd6705d6948df$var$props = {};
const $d07fd6705d6948df$var$AsyncUpflowIframeComponentNew = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $gGLWS.upflowIframeComponentEntrypoint), $d07fd6705d6948df$var$entryPointParams);
    const [{ renderUpflowModal: renderUpflowModal }] = (0, $8PILw.useUpflowModal)();
    // Violating react-entrypoint/no-load-in-hooks so we can experiment faster: https://hello.atlassian.net/wiki/spaces/JIE/pages/4772823699/LDR+Entrypoint+Load+Via+Hooks+For+Faster+Experimentation
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (renderUpflowModal) entryPointActions.load();
    }, [
        entryPointActions,
        renderUpflowModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "issue-onboarding-modal-lazy",
        packageName: "AsyncUpflowIframeComponent",
        placeholderName: "async-upflow-iframe-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $d07fd6705d6948df$var$props
    });
};
const $d07fd6705d6948df$export$7f34679273a30171 = (0, $bJscI.componentWithFG)('upflow_iframe_iv_llc_unnecessary_bundles', $d07fd6705d6948df$var$AsyncUpflowIframeComponentNew, $d07fd6705d6948df$var$AsyncUpflowIframeComponentOld);

});
parcelRegister("gGLWS", function(module, exports) {

$parcel$export(module.exports, "upflowIframeComponentEntrypoint", () => $25257faefdcca7e8$export$92c53bb1afc6d332);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $25257faefdcca7e8$export$92c53bb1afc6d332 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("1WOax")).then(({ UpflowIframeComponent: UpflowIframeComponent })=>UpflowIframeComponent), {
        moduleId: "caf60ffd",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1WOax", function(module, exports) {

let $16b21fba85d98500$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $16b21fba85d98500$var$load("e2AmU").then(()=>parcelRequire('fAnet'));

});


parcelRegister("8PILw", function(module, exports) {

$parcel$export(module.exports, "useUpflowModal", () => $6e82c436675b8525$export$7025cc2729b71e44);

var $a9ldn = parcelRequire("a9ldn");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

const $6e82c436675b8525$var$initialState = {
    renderUpflowModal: false,
    product: 'jira-software',
    touchpointId: '',
    flow: 'learn-more',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: ()=>{},
    targetEdition: (0, $a9ldn.FREE_EDITION)
};
const $6e82c436675b8525$var$actions = {
    mountUpflowModal: ({ targetEdition: targetEdition, product: product, flow: flow, touchpointId: touchpointId, subRoute: subRoute, onClose: onClose, onOpen: onOpen })=>({ setState: setState })=>{
            setState({
                targetEdition: targetEdition,
                product: product,
                flow: flow,
                touchpointId: touchpointId,
                subRoute: subRoute,
                onClose: onClose,
                onOpen: onOpen,
                renderUpflowModal: true
            });
        },
    unMountUpflowModal: ()=>({ setState: setState })=>{
            setState({
                renderUpflowModal: false
            });
        }
};
const $6e82c436675b8525$var$Store = (0, $GtRbT.createStore)({
    name: (0, $9b7b66af426873ce$export$675a4427bf3750a2),
    initialState: $6e82c436675b8525$var$initialState,
    actions: $6e82c436675b8525$var$actions
});
const $6e82c436675b8525$export$6d73384be122c2dd = (0, $ht3nQ.createSubscriber)($6e82c436675b8525$var$Store);
const $6e82c436675b8525$export$e672be732bd57171 = (0, $6E16M.createContainer)($6e82c436675b8525$var$Store);
const $6e82c436675b8525$export$7025cc2729b71e44 = (0, $iJq0l.createHook)($6e82c436675b8525$var$Store);

});
const $9b7b66af426873ce$export$675a4427bf3750a2 = 'upflow-modal-store';



parcelRegister("bwRvc", function(module, exports) {

$parcel$export(module.exports, "JiraHeritageLoader", () => $5bf9aa1d151b028a$export$9499deca9933db5b);

var $eJOHy = parcelRequire("eJOHy");

var $4T9yL = parcelRequire("4T9yL");

var $avFP5 = parcelRequire("avFP5");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $hih5V = parcelRequire("hih5V");

var $9XYcy = parcelRequire("9XYcy");

var $a8PVz = parcelRequire("a8PVz");

var $6zKhT = parcelRequire("6zKhT");

var $bKAVn = parcelRequire("bKAVn");
const $5bf9aa1d151b028a$var$JiraHeritageLoaderOld = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const [{ isReady: isReady }] = (0, $9XYcy.useSpaStatePageReady)();
    const [hasHeritageDownloaded, setHasHeritageDownloaded] = (0, $eJOHy.useState)(false);
    (0, $bKAVn.useWrmStatsEffects)();
    /* eslint-disable jira/wrm/no-load-bridge */ const loadJiraHeritageDependencies = (0, $eJOHy.useCallback)(()=>{
        setHasHeritageDownloaded(true);
        (0, $a8PVz.asyncWrmRequire)([
            ...(0, $avFP5.jiraSuperBatchDependencies),
            ...(0, $6zKhT.getJiraHeritageDependencies)()
        ]).then(()=>(0, $4T9yL.waitForHeritage)()?.resolve?.());
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (isReady && !hasHeritageDownloaded) loadJiraHeritageDependencies();
    }, [
        hasHeritageDownloaded,
        isReady,
        loadJiraHeritageDependencies,
        route
    ]);
    return null;
};
const $5bf9aa1d151b028a$var$JiraHeritageLoaderNew = (0, $eJOHy.Fragment);
const $5bf9aa1d151b028a$export$9499deca9933db5b = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('no-wrm-heritage-loader'), $5bf9aa1d151b028a$var$JiraHeritageLoaderNew, $5bf9aa1d151b028a$var$JiraHeritageLoaderOld);
$5bf9aa1d151b028a$export$9499deca9933db5b.displayName = 'JiraHeritageLoader';

});
parcelRegister("6zKhT", function(module, exports) {

$parcel$export(module.exports, "getJiraHeritageDependencies", () => $539a5051f395af45$export$e8f6d7acd5817fa2);
const $539a5051f395af45$export$e8f6d7acd5817fa2 = ()=>[
        // superbatch resources
        // analytics
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
        // dependencies from HeaderFooterRendering
        'wrc!jira.webresources:key-commands',
        'wrc!jira.webresources:header',
        // . dialog
        'wrc!com.atlassian.administration.atlassian-admin-quicksearch-jira:admin-quicksearch-webresources',
        // overrides for AUI, styles and bridge apis
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
        'wrc!jira.webresources:global-static',
        // browser metrics
        'wrc!com.atlassian.jira.plugins.jira-browser-metrics:contrib',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:impl',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
        // repository shortcuts from navigation
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next',
        // issue view resources
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources-init',
        // create board dialog
        'wrc!com.pyxis.greenhopper.jira:gh-create-board-adg3-no-condition',
        // old analytics library
        'wrc!com.atlassian.analytics.analytics-client:js-events',
        // frontend cache
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:global-cache',
        // impersonation flag (logged as someone)
        'wrc!com.atlassian.crowd.user-provisioning-vertigo-plugin:impersonation-resources',
        // flag displayed when there are too many emails on the instance
        'wrc!jira.webresources:spam-protection-flags',
        // in-product announcements (displayed e.g. if there is an incident)
        'wrc!com.atlassian.pas:pas-everypage-static',
        // Bento resources
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:fileviewer',
        'wrc!com.atlassian.auiplugin:dialog2',
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:atlassian-fileviewer',
        'wrc!com.atlassian.jira.jira-issue-nav-plugin:stylesheets'
    ];

});

parcelRegister("bKAVn", function(module, exports) {

$parcel$export(module.exports, "useWrmStatsEffects", () => $948bb977c99e63f3$export$7ff53723d9d2886d);

var $eJOHy = parcelRequire("eJOHy");

var $9XYcy = parcelRequire("9XYcy");

var $iIqWW = parcelRequire("iIqWW");
const $948bb977c99e63f3$export$7ff53723d9d2886d = ()=>{
    const [{ isReady: isReady }] = (0, $9XYcy.useSpaStatePageReady)();
    const [{ transitionsCount: transitionsCount }] = (0, $iIqWW.useSpaStateTransition)();
    (0, $eJOHy.useEffect)(()=>{
        if (isReady && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__ && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        !window.__WRM_INTERNAL_STATS__.isPageInteractive) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__.isPageInteractive = true;
    }, [
        isReady
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (transitionsCount > 0) // clear stats on transition
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__ = {};
    }, [
        transitionsCount
    ]);
};

});


parcelRegister("bGKoK", function(module, exports) {

$parcel$export(module.exports, "isJiraSoftware", () => $d2b6d95a40bb4ce2$export$1810b10f6a208e90);

var $ln6Iy = parcelRequire("ln6Iy");
const $d2b6d95a40bb4ce2$export$1810b10f6a208e90 = (projectType)=>projectType && projectType === (0, $ln6Iy.SOFTWARE_PROJECT);

});

parcelRegister("gsuME", function(module, exports) {

$parcel$export(module.exports, "getRovoVideoOnboardingHash", () => $3c47356d01f894fe$export$7ed5123ac12331e6);
$parcel$export(module.exports, "setRovoVideoOnboardingSeen", () => $3c47356d01f894fe$export$88c0db0edebd3404);

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");
const $3c47356d01f894fe$export$9e35978d27ff337f = 'rovoVideoPlayerSeen';
const $3c47356d01f894fe$export$7ed5123ac12331e6 = async (accountId)=>{
    try {
        return accountId != null ? (await (0, $FppkK.getUserProperty)(accountId, $3c47356d01f894fe$export$9e35978d27ff337f)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $gYnSx.trackFetchErrors)({
            error: error,
            id: 'rovoUserDismissGet',
            packageName: 'jiraRovoVideoModal'
        });
        throw error;
    }
};
const $3c47356d01f894fe$export$88c0db0edebd3404 = async (accountId, hashId)=>{
    try {
        if (accountId != null) return await (0, $FppkK.setUserProperties)(accountId, $3c47356d01f894fe$export$9e35978d27ff337f, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.trackFetchErrors)({
            error: error,
            id: 'rovoUserDismissSet',
            packageName: 'jiraRovoVideoModal'
        });
        throw error;
    }
};

});

parcelRegister("HPMxS", function(module, exports) {

$parcel$export(module.exports, "useCoordinationClient", () => $1247038ceb4cff5e$export$ddc368dc94a41e62);

var $eJOHy = parcelRequire("eJOHy");

var $9zZj0 = parcelRequire("9zZj0");

var $g9Vr6 = parcelRequire("g9Vr6");

var $lvKO5 = parcelRequire("lvKO5");
const $1247038ceb4cff5e$export$ddc368dc94a41e62 = ()=>{
    const epMessageId = 'jira_rovo_video_modal_ga';
    const { cloudId: cloudId } = (0, $lvKO5.useTenantContext)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, '/gateway/api', false, orgId, 'engagement'), [
        cloudId,
        orgId
    ]);
    const start = (0, $eJOHy.useCallback)(async ()=>{
        if (!epMessageId) return false;
        return coordinationClient.start(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    const stop = (0, $eJOHy.useCallback)(()=>{
        if (!epMessageId) return false;
        return coordinationClient.stop(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    return {
        coordinationClient: coordinationClient,
        start: start,
        stop: stop
    };
};

});

parcelRegister("lHlwJ", function(module, exports) {

$parcel$export(module.exports, "CrossJoinNudges", () => $39900d9eaea5ee9b$export$40390e43fcc876d);
$parcel$export(module.exports, "useCrossJoinNudges", () => $39900d9eaea5ee9b$export$b73ba4b3997f9abe);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $ljWHg = parcelRequire("ljWHg");

var $1y5hE = parcelRequire("1y5hE");

var $4mlPC = parcelRequire("4mlPC");

var $aL0ae = parcelRequire("aL0ae");

var $lvTzp = parcelRequire("lvTzp");

var $efQhD = parcelRequire("efQhD");

var $lnwEo = parcelRequire("lnwEo");

var $cGeZ5 = parcelRequire("cGeZ5");

var $b66qx = parcelRequire("b66qx");
const $39900d9eaea5ee9b$export$40390e43fcc876d = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "JiraCrossJoinNudges",
        teamName: "groot",
        packageName: "jiraCrossJoinNudges"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($39900d9eaea5ee9b$var$CrossJoinNudgesWithoutErrorBoundary, null));
};
const $39900d9eaea5ee9b$export$b73ba4b3997f9abe = (execNudge = true)=>{
    const getJpdCrossJoinNudgeEligibility = (0, $aL0ae.useJpdCrossJoinNudgeEligibility)();
    const getConfluenceCrossJoinNudgeEligibility = (0, $lvTzp.useConfluenceCrossJoinNudgeEligibility)();
    const showJpdNudge = (0, $efQhD.useJpdCrossJoinNudge)();
    const showConfluenceNudge = (0, $lnwEo.useConfluenceCrossJoinNudge)();
    const getLlmConfEligibility = (0, $lvTzp.useLlmConfluenceCrossJoinNudgeEligibility)();
    const getHasSeenConfLlm = (0, $lvTzp.useHasSeenConfLlm)();
    const getHasSeenNudgesBefore = (0, $b66qx.useHasSeenNudgesBefore)();
    const { fireMsrAaExposureTrackEvent: fireMsrAaExposureTrackEvent, fireMsrAaFetchTrackEvent: fireMsrAaFetchTrackEvent } = (0, $1y5hE.useMsrAaTest)();
    const executeMSRNudge = (0, $4mlPC.useExecuteMSRNudge)();
    (0, $eJOHy.useEffect)(()=>{
        async function executeNudges({ allowLoom: allowLoom = true, allowLlm: allowLlm = true }) {
            if (allowLoom) // TODO: implement loom nudge here
            // NOTE: AA Test events, to be removed
            fireMsrAaExposureTrackEvent('twcg-442-cjn-jira-loom');
            if (allowLlm) // NOTE: AA Test events, to be removed
            fireMsrAaExposureTrackEvent('grw-1755-growth-exp-jira-cjn-llm');
            const jpdEligibilityResult = await getJpdCrossJoinNudgeEligibility();
            if (jpdEligibilityResult.isEligible) {
                showJpdNudge();
                return;
            }
            const confluenceEligibilityResult = await getConfluenceCrossJoinNudgeEligibility();
            if (confluenceEligibilityResult.isEligible) showConfluenceNudge(confluenceEligibilityResult.data, allowLlm);
        }
        async function executeNudgesWithMsr() {
            await (0, $cGeZ5.setEnrolledInMsr)();
            // NOTE: AA Test, to be removed
            if ((0, $epTsa.expVal)('aa_for_twcg-437-cjn-msr-m1', 'cohort', 'not-enrolled') !== 'not-enrolled') {
                fireMsrAaExposureTrackEvent('aa_for_twcg-437-cjn-msr-m1', (0, $epTsa.expVal)('aa_for_twcg-437-cjn-msr-m1', 'cohort', 'not-enrolled'));
                if ((0, $epTsa.expValEquals)('aa_for_twcg-437-cjn-msr-m1', 'cohort', 'variation', 'not-enrolled')) fireMsrAaFetchTrackEvent();
            }
            // TODO: add more enrolment criteria here (locale etc)
            if ((0, $epTsa.expValEquals)('twcg-437-cjn-msr-m1', 'cohort', 'variation', 'not-enrolled')) executeMSRNudge();
            else executeNudges({
                allowLoom: false,
                allowLlm: false
            });
        }
        async function orchestrateNudges() {
            if ((0, $7jTnu.fg)('puma-296-cjn-orchestrator')) {
                const hasLocalStorage = await (0, $ljWHg.isLocalStorageEnabled)();
                if (!hasLocalStorage) return;
                const enrolledInMsr = await (0, $cGeZ5.getHasBeenEnrolledInMsr)();
                // User already belongs to MSR control/variation
                if (enrolledInMsr) {
                    executeNudgesWithMsr();
                    return;
                }
                const hasSeenLlm = await getHasSeenConfLlm();
                // User already has seen LLM variation
                if (hasSeenLlm) {
                    executeNudges({
                        allowLoom: false,
                        allowLlm: true
                    });
                    return;
                }
                // kill switch to prevent new users or LLM control users from being sent to LLM
                if ((0, $7jTnu.fg)('puma-296-cjn-orchestrator-llm')) {
                    const isLLMEligible = await getLlmConfEligibility();
                    // User would belong to LLM control
                    if (isLLMEligible.isEligible) {
                        executeNudges({
                            allowLoom: false,
                            allowLlm: true
                        });
                        return;
                    }
                }
                // User has seen any other nudge so they should not be part of MSR
                // User might be part of Loom variation, so they should not be part of LLM
                const isLoomGroup = await getHasSeenNudgesBefore();
                if (isLoomGroup) {
                    executeNudges({
                        allowLoom: true,
                        allowLlm: false
                    });
                    return;
                }
                // User doesn't belong in any other experiment so they should be sent to MSR control/variation
                executeNudgesWithMsr();
            } else // Default control for non-MSR experiments
            executeNudges({
                allowLlm: true,
                allowLoom: false
            });
        }
        if (execNudge) orchestrateNudges();
    }, [
        fireMsrAaExposureTrackEvent,
        fireMsrAaFetchTrackEvent,
        execNudge,
        getConfluenceCrossJoinNudgeEligibility,
        getHasSeenConfLlm,
        getHasSeenNudgesBefore,
        getJpdCrossJoinNudgeEligibility,
        getLlmConfEligibility,
        showConfluenceNudge,
        showJpdNudge,
        executeMSRNudge
    ]);
};
const $39900d9eaea5ee9b$var$CrossJoinNudgesWithoutErrorBoundary = ()=>{
    $39900d9eaea5ee9b$export$b73ba4b3997f9abe(true);
    return null;
};
var $39900d9eaea5ee9b$export$2e2bcd8739ae039 = $39900d9eaea5ee9b$export$40390e43fcc876d;

});
parcelRegister("ljWHg", function(module, exports) {

$parcel$export(module.exports, "crossJoinNudgeVisitedCache", () => $85f3c48b465caa03$export$9e1407fde36d61e4);
$parcel$export(module.exports, "cjnEligibilityCacheHandler", () => $85f3c48b465caa03$export$beb12117dd89482e);
$parcel$export(module.exports, "withEligibilityCache", () => $85f3c48b465caa03$export$86938f072bd79cac);
$parcel$export(module.exports, "isLocalStorageEnabled", () => $85f3c48b465caa03$export$6515f7b9b46b3e7a);
$parcel$export(module.exports, "getOrUpdateFeatureVisited", () => $85f3c48b465caa03$export$fd94e26348dead8f);
$parcel$export(module.exports, "getFeatureVisited", () => $85f3c48b465caa03$export$ee4ac5fe77f8084a);
$parcel$export(module.exports, "setFeatureVisited", () => $85f3c48b465caa03$export$7c52d8e39da481c4);
$parcel$export(module.exports, "removeFeatureVisited", () => $85f3c48b465caa03$export$fcf4f05929d7c90b);
$parcel$export(module.exports, "snoozeFeatureFor30Days", () => $85f3c48b465caa03$export$788659dbff920e5f);
$parcel$export(module.exports, "getFeatureVisitedCount", () => $85f3c48b465caa03$export$64c6861c3bbd89a2);
$parcel$export(module.exports, "increaseFeatureVisitedCount", () => $85f3c48b465caa03$export$41554dcbb74e65ef);
$parcel$export(module.exports, "getCountCacheKey", () => $85f3c48b465caa03$export$1577cce2b8cadf);
$parcel$export(module.exports, "useSnooze", () => $85f3c48b465caa03$export$26ba987533188b38);

var $eJOHy = parcelRequire("eJOHy");

var $dnU6V = parcelRequire("dnU6V");

var $gYnSx = parcelRequire("gYnSx");

var $8q7lT = parcelRequire("8q7lT");

var $2ZrIe = parcelRequire("2ZrIe");

var $kwi6w = parcelRequire("kwi6w");
const $85f3c48b465caa03$var$VISITED_COUNT_KEY = 'CROSS_JOIN_NUDGE_CONFLUENCE_VISITED_COUNT';
const $85f3c48b465caa03$export$afe713ceb95e80be = 'CROSS_JOIN_NUDGE_CONFLUENCE_LLM_VISITED_COUNT';
const $85f3c48b465caa03$var$ONE_DAY_IN_MILLISECONDS = 86400000;
const $85f3c48b465caa03$export$9e1407fde36d61e4 = (0, $dnU6V.createLocalStorageProvider)('cross-join-nudge-visited');
const $85f3c48b465caa03$var$visitedKeys = {
    crossJoinNudgesConfluence: 'cross.join.nudges.confluence.visited',
    crossJoinNudgesJiraToJpd: 'cross.join.nudges.jpd.visited',
    crossJoinNudgesYourWork: 'cross.join.nudges.your.work',
    crossJoinNudgesLLMAA: 'cross.join.nudges.llm.aa',
    crossJoinNudgesMsr: 'cross.join.nudges.msr'
};
const $85f3c48b465caa03$export$ab87107a670964ea = (0, $2ZrIe.default)({
    size: 30,
    cacheKey: 'cjn-eligibility-cache',
    storageType: (0, $8da4e41a25982619$export$2670cb7d5d4f7184)
});
const $85f3c48b465caa03$export$beb12117dd89482e = {
    get: (key)=>$85f3c48b465caa03$export$ab87107a670964ea.get(key),
    set: (key, value)=>$85f3c48b465caa03$export$ab87107a670964ea.set(key, value),
    remove: (key)=>$85f3c48b465caa03$export$ab87107a670964ea.remove(key)
};
function $85f3c48b465caa03$export$86938f072bd79cac(key, eligibilityCheck, daysToLive) {
    return async (...args)=>{
        try {
            const cachedValue = await $85f3c48b465caa03$export$beb12117dd89482e.get(key);
            if (cachedValue !== null && cachedValue !== undefined) {
                if (!cachedValue.ttl || cachedValue.ttl > Date.now()) return cachedValue.value;
            }
        } catch (e) {
        // cache get fail, do nothing
        }
        const result = await eligibilityCheck(...args);
        try {
            const ttlTimestamp = daysToLive !== undefined ? new Date().getTime() + $85f3c48b465caa03$var$ONE_DAY_IN_MILLISECONDS * daysToLive : undefined;
            await $85f3c48b465caa03$export$beb12117dd89482e.set(key, {
                value: result,
                ttl: ttlTimestamp
            });
        } catch (e) {
        // cache set fail, do nothing
        }
        return result;
    };
}
const $85f3c48b465caa03$export$6515f7b9b46b3e7a = async ()=>{
    await $85f3c48b465caa03$export$ab87107a670964ea.set('local_storage_enabled', {
        value: true
    });
    const value = await $85f3c48b465caa03$export$ab87107a670964ea.get('local_storage_enabled');
    return value?.value === true;
};
const $85f3c48b465caa03$export$fd94e26348dead8f = (keyName, snoozeForDays)=>{
    try {
        if ($85f3c48b465caa03$export$ee4ac5fe77f8084a(keyName)) return true;
        $85f3c48b465caa03$export$7c52d8e39da481c4(keyName, snoozeForDays);
        // A small cohort of users have local storage completely disabled.
        // This code detects that and always returns visited=true for those users
        if (!$85f3c48b465caa03$export$ee4ac5fe77f8084a(keyName)) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'featureVisitedLocalStorageNotAvailabe',
                    packageName: 'jiraCrossJoinNudges'
                }
            });
            return true;
        }
        return false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'useFeatureVisited',
                packageName: 'jiraCrossJoinNudges'
            },
            error: error,
            skipSentry: true,
            sendToPrivacyUnsafeSplunk: true
        });
        return true;
    }
};
const $85f3c48b465caa03$export$fcf4f05929d7c90b = (keyName)=>{
    const key = $85f3c48b465caa03$var$visitedKeys[keyName];
    $85f3c48b465caa03$export$9e1407fde36d61e4.remove(key);
};
const $85f3c48b465caa03$export$7c52d8e39da481c4 = (keyName, numOfDaysSnoozed)=>{
    const key = $85f3c48b465caa03$var$visitedKeys[keyName];
    const SNOOZE_UNTIL_TIMESTAMP = new Date().getTime() + $85f3c48b465caa03$var$ONE_DAY_IN_MILLISECONDS * numOfDaysSnoozed;
    $85f3c48b465caa03$export$9e1407fde36d61e4.set(key, SNOOZE_UNTIL_TIMESTAMP);
};
const $85f3c48b465caa03$export$7a91674e4b755c4b = (keyName)=>{
    $85f3c48b465caa03$export$7c52d8e39da481c4(keyName, 7);
};
const $85f3c48b465caa03$export$788659dbff920e5f = (keyName)=>{
    $85f3c48b465caa03$export$7c52d8e39da481c4(keyName, 30);
};
const $85f3c48b465caa03$export$ee4ac5fe77f8084a = (keyName)=>{
    const key = $85f3c48b465caa03$var$visitedKeys[keyName];
    const snoozeUntilTimestampString = $85f3c48b465caa03$export$9e1407fde36d61e4.get(key);
    if (snoozeUntilTimestampString !== null) {
        const SNOOZE_UNTIL_TIMESTAMP = parseInt(snoozeUntilTimestampString, 10);
        const TIMESTAMP = new Date().getTime();
        if (!Number.isNaN(SNOOZE_UNTIL_TIMESTAMP) && TIMESTAMP < SNOOZE_UNTIL_TIMESTAMP) return true;
    }
    return false;
};
const $85f3c48b465caa03$export$64c6861c3bbd89a2 = async (accountId, propertyKey = $85f3c48b465caa03$var$VISITED_COUNT_KEY)=>{
    if (!accountId) return 0;
    const visitedCount = await (0, $kwi6w.getUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        defaultValue: 0
    });
    return !Number.isNaN(visitedCount.value) ? visitedCount.value : 0;
};
const $85f3c48b465caa03$export$41554dcbb74e65ef = async (accountId, incrementedCount, propertyKey = $85f3c48b465caa03$var$VISITED_COUNT_KEY)=>{
    await (0, $kwi6w.setUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        propertyValue: incrementedCount
    });
};
const $85f3c48b465caa03$export$1577cce2b8cadf = (keyName)=>{
    const key = $85f3c48b465caa03$var$visitedKeys[keyName];
    return `${key}.count`;
};
const $85f3c48b465caa03$export$26ba987533188b38 = (keyName)=>{
    const accountId = (0, $8q7lT.useAccountId)() || '';
    const countKey = $85f3c48b465caa03$export$1577cce2b8cadf(keyName);
    return (0, $eJOHy.useMemo)(()=>({
            snoozeFor7Days: ()=>$85f3c48b465caa03$export$7a91674e4b755c4b(keyName),
            snoozeFor30Days: ()=>$85f3c48b465caa03$export$788659dbff920e5f(keyName),
            getVisitedCount: ()=>$85f3c48b465caa03$export$64c6861c3bbd89a2(accountId, countKey),
            increaseVisitedCount: (incrementedCount)=>$85f3c48b465caa03$export$41554dcbb74e65ef(accountId, incrementedCount, countKey),
            isVisited: ()=>$85f3c48b465caa03$export$ee4ac5fe77f8084a(keyName)
        }), [
        accountId,
        countKey,
        keyName
    ]);
};

});
parcelRegister("2ZrIe", function(module, exports) {

$parcel$export(module.exports, "default", () => $68c90beac6bbcd15$export$2e2bcd8739ae039);

var $dQ3qN = parcelRequire("dQ3qN");
const $68c90beac6bbcd15$var$pNothing = ()=>Promise.resolve();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$68c90beac6bbcd15$export$2e2bcd8739ae039 = (config)=>{
    if (!false) {
        const Cache = (0, $dQ3qN.default)(config);
        const getAll = ()=>Cache.then((cache)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $68c90beac6bbcd15$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $68c90beac6bbcd15$var$pNothing,
        update: $68c90beac6bbcd15$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $68c90beac6bbcd15$var$pNothing
    };
};

});
parcelRegister("dQ3qN", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $dad4e0b94ce9085b$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $dad4e0b94ce9085b$export$2e2bcd8739ae039);

var $dnU6V = parcelRequire("dnU6V");

var $4elgJ = parcelRequire("4elgJ");

var $eSnSE = parcelRequire("eSnSE");


var $6O0zm = parcelRequire("6O0zm");
const $dad4e0b94ce9085b$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $dad4e0b94ce9085b$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $6O0zm.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $8da4e41a25982619$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $dad4e0b94ce9085b$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $8da4e41a25982619$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $dad4e0b94ce9085b$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $8da4e41a25982619$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $8da4e41a25982619$export$2670cb7d5d4f7184)) storage = (0, $dnU6V.createLocalStorageProvider)((0, $6O0zm.CACHE_PREFIX));
        else storage = (0, $4elgJ.createSessionStorageProvider)((0, $6O0zm.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $8da4e41a25982619$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $8da4e41a25982619$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $8da4e41a25982619$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $eSnSE.default).safeWarnWithoutCustomerData((0, $8da4e41a25982619$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $8da4e41a25982619$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $8da4e41a25982619$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $8da4e41a25982619$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $6O0zm.default).scopes.current !== (0, $6O0zm.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dad4e0b94ce9085b$var$cacheMap = {};
const $dad4e0b94ce9085b$var$getCache = async (props)=>{
    await (0, $6O0zm.scopeGuard)().catch((error)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $dad4e0b94ce9085b$var$cacheMap[cacheKey] = $dad4e0b94ce9085b$var$cacheMap[cacheKey] || new $dad4e0b94ce9085b$export$94affb487e701bf2(props);
    return $dad4e0b94ce9085b$var$cacheMap[cacheKey];
};
const $dad4e0b94ce9085b$export$710d301bf26d9700 = ()=>{
    Object.values($dad4e0b94ce9085b$var$cacheMap).forEach((cache)=>cache.clear());
};
var $dad4e0b94ce9085b$export$2e2bcd8739ae039 = $dad4e0b94ce9085b$var$getCache;

});
const $8da4e41a25982619$export$7271276960377470 = 'common-cache';
const $8da4e41a25982619$export$a61768fefd33fcb1 = 'capacity exceeded';
const $8da4e41a25982619$export$6c4d37c7f376a1de = 'clear';
const $8da4e41a25982619$export$e271b26eefe41db8 = 'update';
const $8da4e41a25982619$export$4bd2facc4a3e6aa1 = 'delete';
const $8da4e41a25982619$export$26d12233004a7a60 = 'delete stale entry';
const $8da4e41a25982619$export$1bb358554aac31c1 = 'get';
const $8da4e41a25982619$export$61f74127e2b53cbe = 'hydrate';
const $8da4e41a25982619$export$5e8f180ef0142226 = 'set';
const $8da4e41a25982619$export$9eb68924983e00fb = 'get entries';
const $8da4e41a25982619$export$bf340b99118a1511 = 'memory';
const $8da4e41a25982619$export$2670cb7d5d4f7184 = 'local';
const $8da4e41a25982619$export$b796061ff0c82e1a = 'session';



parcelRegister("kwi6w", function(module, exports) {

$parcel$export(module.exports, "setUserProperty", () => $729b1eda9f96bbc5$export$ba821ce5e177c7ef);
$parcel$export(module.exports, "getUserProperty", () => $729b1eda9f96bbc5$export$b3126db2ef6e34ed);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $729b1eda9f96bbc5$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $729b1eda9f96bbc5$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $729b1eda9f96bbc5$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $jGzN3.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: `SET_${propertyKey}`,
                packageName: 'jiraCrossJoinNudges'
            },
            error: error
        });
    }
};
const $729b1eda9f96bbc5$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $729b1eda9f96bbc5$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await (0, $jGzN3.performGetRequest)(url);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};

});


parcelRegister("1y5hE", function(module, exports) {

$parcel$export(module.exports, "useMsrAaTest", () => $ec8e11d26c3aa2a8$export$d35252311cd7d338);

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");
const $ec8e11d26c3aa2a8$export$d35252311cd7d338 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    /**
	 * Used to gauge the amount of requests we'll be sending to GRS
	 */ const fireMsrAaFetchTrackEvent = ()=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'cjnMsrRecommendations fetched');
    };
    /**
	 * Used to detect possible cohort pollution between different experiments
	 */ const fireMsrAaExposureTrackEvent = (aaExperiment, cohort)=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
            cohort: cohort,
            flagKey: 'aa_for_twcg-437-cjn-msr-m1',
            aaExperiment: aaExperiment
        });
    };
    return {
        fireMsrAaExposureTrackEvent: fireMsrAaExposureTrackEvent,
        fireMsrAaFetchTrackEvent: fireMsrAaFetchTrackEvent
    };
};

});

parcelRegister("4mlPC", function(module, exports) {

$parcel$export(module.exports, "useExecuteMSRNudge", () => $cac686abe28163b1$export$1ae8ed46ebb1741f);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $kEUB1 = parcelRequire("kEUB1");

var $d2DJQ = parcelRequire("d2DJQ");

var $ljWHg = parcelRequire("ljWHg");

var $8Ujbi = parcelRequire("8Ujbi");

var $hOhO7 = parcelRequire("hOhO7");

var $dhnSG = parcelRequire("dhnSG");

var $3gS0H = parcelRequire("3gS0H");

var $awEIK = parcelRequire("awEIK");

var $9nFEq = parcelRequire("9nFEq");

var $gEsbZ = parcelRequire("gEsbZ");
const $cac686abe28163b1$var$RECOMMENDATION_PRODUCT_KEYS = {
    JPD: 'cjn-jira-jpd',
    CONFLUENCE: 'cjn-jira-conf-v2'
};
const $cac686abe28163b1$export$1ae8ed46ebb1741f = ()=>{
    const sessionId = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    const cloudId = (0, $kEUB1.useCloudId)();
    const getMSRNudgeRecommendations = (0, $d2DJQ.useMSRNudgeRecommendations)({
        sessionId: sessionId.current
    });
    const getMsrJpdCrossJoinNudgeEligibility = (0, $awEIK.useMsrJpdCrossJoinNudgeEligibility)();
    const getMsrConfluenceCrossJoinNudgeEligibility = (0, $9nFEq.useMsrConfluenceCrossJoinNudgeEligibility)();
    const { blockEligibilityUntilTomorrow: blockEligibilityUntilTomorrow, snooze: snooze } = (0, $gEsbZ.useMsrSnoozeHandler)();
    const showJpdMsrCrossJoinNudge = (0, $hOhO7.useJpdMsrCrossJoinNudge)();
    const showMsrConfluenceCrossJoinNudge = (0, $3gS0H.useMsrConfluenceCrossJoinNudge)();
    const withOverrides = (0, $dhnSG.useOverrides)('cjn_msr_overrides');
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            if (withOverrides('feature_visited_too_recently', (0, $ljWHg.getFeatureVisited)('crossJoinNudgesMsr'))) return;
            const [jpdResult, confluenceResult] = await Promise.all([
                getMsrJpdCrossJoinNudgeEligibility(),
                getMsrConfluenceCrossJoinNudgeEligibility()
            ]);
            const rerankList = [];
            if (jpdResult.isEligible) rerankList.push($cac686abe28163b1$var$RECOMMENDATION_PRODUCT_KEYS.JPD);
            if (confluenceResult.isEligible) rerankList.push($cac686abe28163b1$var$RECOMMENDATION_PRODUCT_KEYS.CONFLUENCE);
            if (rerankList.length === 0) {
                snooze();
                return;
            }
            const recommendation = await getMSRNudgeRecommendations(rerankList);
            if (!recommendation) {
                blockEligibilityUntilTomorrow();
                return;
            }
            switch(recommendation){
                case $cac686abe28163b1$var$RECOMMENDATION_PRODUCT_KEYS.JPD:
                    showJpdMsrCrossJoinNudge();
                    break;
                case $cac686abe28163b1$var$RECOMMENDATION_PRODUCT_KEYS.CONFLUENCE:
                    showMsrConfluenceCrossJoinNudge();
                    break;
                default:
            }
            snooze();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('executeMSRNudge', error, {
                cloudId: cloudId
            });
            // TODO: up to discussion if we should snooze here
            snooze();
        }
    }, [
        cloudId,
        getMsrJpdCrossJoinNudgeEligibility,
        getMsrConfluenceCrossJoinNudgeEligibility,
        getMSRNudgeRecommendations,
        blockEligibilityUntilTomorrow,
        showJpdMsrCrossJoinNudge,
        showMsrConfluenceCrossJoinNudge,
        withOverrides,
        snooze
    ]);
};

});
parcelRegister("d2DJQ", function(module, exports) {

$parcel$export(module.exports, "useNudgeRecommendations", () => $8279b568d170b0bc$export$20e6812ba5f3fc39);
$parcel$export(module.exports, "useMSRNudgeRecommendations", () => $8279b568d170b0bc$export$e87e269d0f71e3a3);

var $eJOHy = parcelRequire("eJOHy");

var $7rUgh = parcelRequire("7rUgh");

var $gYnSx = parcelRequire("gYnSx");

var $figsJ = parcelRequire("figsJ");

var $kEUB1 = parcelRequire("kEUB1");

var $5QB52 = parcelRequire("5QB52");
const $8279b568d170b0bc$var$CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE = 'crossJoinNudge';
const $8279b568d170b0bc$var$MSR_CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE = 'crossJoinNudgeFlags';
function $8279b568d170b0bc$export$20e6812ba5f3fc39({ sessionId: sessionId }) {
    const cloudId = (0, $kEUB1.useCloudId)();
    const subProduct = (0, $figsJ.useSubProduct)();
    const contextResolver = (0, $eJOHy.useCallback)(()=>({
            product: 'jira',
            useCase: $8279b568d170b0bc$var$CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE,
            tenantId: cloudId,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            subproduct: subProduct,
            sessionId: sessionId
        }), [
        cloudId,
        subProduct,
        sessionId
    ]);
    const { getRecommendations: getRecommendations } = (0, $7rUgh.default)({
        contextResolver: contextResolver
    });
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const result = await getRecommendations(1, $8279b568d170b0bc$var$asEntityIdList((0, $5QB52.EntityList)));
            const { response: { data: data } = {} } = result;
            // This type assertion is necessary because useRecommendations don't support generic entityId
            const recommendedEntityId = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            data && data.length > 0 && data[0].entityId || undefined;
            return recommendedEntityId;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'recommendationFetchFailed',
                    packageName: 'jiraCrossJoinNudges',
                    teamName: 'groot-growth'
                },
                error: error
            });
            throw new Error('Get nudge recommendations error');
        }
    }, [
        getRecommendations
    ]);
}
function $8279b568d170b0bc$export$e87e269d0f71e3a3({ sessionId: sessionId }) {
    const cloudId = (0, $kEUB1.useCloudId)();
    const subProduct = (0, $figsJ.useSubProduct)();
    const contextResolver = (0, $eJOHy.useCallback)(()=>({
            product: 'jira',
            useCase: $8279b568d170b0bc$var$MSR_CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE,
            tenantId: cloudId,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            subproduct: subProduct,
            sessionId: sessionId
        }), [
        cloudId,
        subProduct,
        sessionId
    ]);
    const { getRecommendations: getRecommendations } = (0, $7rUgh.default)({
        contextResolver: contextResolver
    });
    return (0, $eJOHy.useCallback)(async (rerankList)=>{
        try {
            const result = await getRecommendations(1, rerankList.map((entityId)=>({
                    entityId: entityId
                })));
            const { response: { data: data } = {} } = result;
            const recommendedEntityId = data && data.length > 0 && data[0].entityId || undefined;
            return recommendedEntityId;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'recommendationMsrFetchFailed',
                    packageName: 'jiraCrossJoinNudges',
                    teamName: 'puma-growth'
                },
                error: error
            });
            // TODO: should we snooze or try tomorrow again? Because this will snooze it.
            throw new Error('Get MSR nudge recommendations error');
        }
    }, [
        getRecommendations
    ]);
}
const $8279b568d170b0bc$var$asEntityIdList = (entities)=>entities.map((entity)=>({
            entityId: entity
        }));

});
parcelRegister("5QB52", function(module, exports) {

$parcel$export(module.exports, "EntityList", () => $b173ac9c27d8f86f$export$8bb466c13870163e);
$parcel$export(module.exports, "getDynamicMessages", () => $b173ac9c27d8f86f$export$b916a1b5c615f6eb);

var $epTsa = parcelRequire("epTsa");

var $6Jmsm = parcelRequire("6Jmsm");
const $b173ac9c27d8f86f$export$8bb466c13870163e = [
    'nudgeCandidate01',
    'nudgeCandidate02',
    'nudgeCandidate03',
    'nudgeCandidate04',
    'nudgeCandidate05',
    'nudgeCandidate06',
    'nudgeCandidate07'
];
const $b173ac9c27d8f86f$var$messageVariantsKeyMap = {
    default: {
        title: 'title',
        description: 'description',
        joinButton: 'joinButton'
    },
    nudgeCandidate01: {
        title: 'titleNudgeCandidate01',
        description: 'descriptionNudgeCandidate01',
        joinButton: 'joinButtonNudgeCandidate01'
    },
    nudgeCandidate02: {
        title: 'titleNudgeCandidate02',
        description: 'descriptionNudgeCandidate02',
        joinButton: 'joinButtonNudgeCandidate02'
    },
    nudgeCandidate03: {
        title: 'titleNudgeCandidate03',
        description: 'descriptionNudgeCandidate03',
        joinButton: 'joinButtonNudgeCandidate03'
    },
    nudgeCandidate04: {
        title: 'titleNudgeCandidate04',
        description: 'descriptionNudgeCandidate04',
        joinButton: 'joinButtonNudgeCandidate04'
    },
    nudgeCandidate05: {
        title: 'titleNudgeCandidate05',
        description: 'descriptionNudgeCandidate05',
        joinButton: 'joinButtonNudgeCandidate05'
    },
    nudgeCandidate06: {
        title: 'titleNudgeCandidate06',
        description: 'descriptionNudgeCandidate06',
        joinButton: 'joinButtonNudgeCandidate06'
    },
    nudgeCandidate07: {
        title: 'titleNudgeCandidate07',
        description: 'descriptionNudgeCandidate07',
        joinButton: 'joinButtonNudgeCandidate07'
    },
    defaultGalaxia: {
        title: 'title',
        description: 'descriptionGalaxia',
        joinButton: 'joinButton'
    },
    nudgeCandidate01Galaxia: {
        title: 'titleNudgeCandidate01',
        description: 'descriptionNudgeCandidate01Galaxia',
        joinButton: 'joinButtonNudgeCandidate01'
    },
    nudgeCandidate02Galaxia: {
        title: 'titleNudgeCandidate02',
        description: 'descriptionNudgeCandidate02',
        joinButton: 'joinButtonNudgeCandidate02'
    },
    nudgeCandidate03Galaxia: {
        title: 'titleNudgeCandidate03',
        description: 'descriptionNudgeCandidate03Galaxia',
        joinButton: 'joinButtonNudgeCandidate03'
    },
    nudgeCandidate04Galaxia: {
        title: 'titleNudgeCandidate04Galaxia',
        description: 'descriptionNudgeCandidate04Galaxia',
        joinButton: 'joinButtonNudgeCandidate04'
    },
    nudgeCandidate05Galaxia: {
        title: 'titleNudgeCandidate05Galaxia',
        description: 'descriptionNudgeCandidate05Galaxia',
        joinButton: 'joinButtonNudgeCandidate05'
    },
    nudgeCandidate06Galaxia: {
        title: 'titleNudgeCandidate06',
        description: 'descriptionNudgeCandidate06',
        joinButton: 'joinButtonNudgeCandidate06'
    },
    nudgeCandidate07Galaxia: {
        title: 'titleNudgeCandidate07',
        description: 'descriptionNudgeCandidate07Galaxia',
        joinButton: 'joinButtonNudgeCandidate07'
    }
};
const $b173ac9c27d8f86f$export$b916a1b5c615f6eb = (isContextualBandit, entityId)=>{
    // Handle case when entityId is unexpected
    if (!(entityId in $b173ac9c27d8f86f$var$messageVariantsKeyMap)) return undefined;
    // If v2B is not enabled we just passthrough default message keys
    const usedEntityId = isContextualBandit ? entityId : 'default';
    // if experiment is enabled and usedEntityIdGalaxia exists then use it
    // else use the usedEntityId
    const entityIdToUse = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? `${usedEntityId}Galaxia` : usedEntityId;
    const titleKey = $b173ac9c27d8f86f$var$messageVariantsKeyMap[entityIdToUse].title;
    const descriptionKey = $b173ac9c27d8f86f$var$messageVariantsKeyMap[entityIdToUse].description;
    const joinButtonKey = $b173ac9c27d8f86f$var$messageVariantsKeyMap[entityIdToUse].joinButton;
    return {
        title: (0, $6Jmsm.messages)[titleKey],
        description: (0, $6Jmsm.messages)[descriptionKey],
        joinButton: (0, $6Jmsm.messages)[joinButtonKey]
    };
};

});
parcelRegister("6Jmsm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2515efbbf3bb8f39$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2515efbbf3bb8f39$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title",
        "defaultMessage": "Your team is now using Confluence"
    },
    titleNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-01",
        "defaultMessage": "Join your teammates in Confluence"
    },
    titleNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-02",
        "defaultMessage": "Collaborate together in Confluence"
    },
    titleNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-03",
        "defaultMessage": "Your team is working in Confluence"
    },
    titleNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-04",
        "defaultMessage": "Unify your projects in Confluence"
    },
    titleNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-05",
        "defaultMessage": "Bring projects together in Confluence"
    },
    titleNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-06",
        "defaultMessage": "Create a single source of truth"
    },
    titleNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-07",
        "defaultMessage": "Create a single source of truth"
    },
    description: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description",
        "defaultMessage": "Organize team knowledge, capture ideas, and share requirements for your Jira projects."
    },
    descriptionNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-01",
        "defaultMessage": "Create a single source of truth for project decisions and software documentation."
    },
    descriptionNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-02",
        "defaultMessage": "Capture, consolidate, and share team knowledge, in one centralized place."
    },
    descriptionNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-03",
        "defaultMessage": "Create project pages to build a shared understanding for better decision-making."
    },
    descriptionNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-04",
        "defaultMessage": "Organize project information and sync it to Jira tasks to track and hit your goals faster."
    },
    descriptionNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-05",
        "defaultMessage": "Capture information in project pages and sync to Jira tasks to track your milestones."
    },
    descriptionNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-06",
        "defaultMessage": "Consolidate information in one place and sync to Jira tasks for automatic updates."
    },
    descriptionNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-07",
        "defaultMessage": "Join your team in Confluence to consolidate project information in one place."
    },
    joinButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button",
        "defaultMessage": "Join your team"
    },
    joinButtonLlmGenerated: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-llm-generated",
        "defaultMessage": "Try Confluence"
    },
    joinButtonNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-01",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-02",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-03",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-04",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-05",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-06",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-07",
        "defaultMessage": "Join Confluence"
    },
    remindMeLaterButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.remind-me-later-button",
        "defaultMessage": "Remind me later"
    },
    notInterestedButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.not-interested-button",
        "defaultMessage": "Not interested"
    },
    urgencyTitle: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.urgency-title",
        "defaultMessage": "{viewCount, select, 0 {Your team is now using Confluence} 1 {Your team is working in Confluence} other {Your team is waiting for you in Confluence}}"
    },
    titleJpdNudge: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-jpd-nudge",
        "defaultMessage": "Join your team in using Jira Product Discovery"
    },
    descriptionJpdNudge: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-jpd-nudge",
        "defaultMessage": "Prioritize ideas, share custom roadmaps, and unify your workflow from discovery to delivery."
    },
    getStartedButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.get-started-button",
        "defaultMessage": "Get started"
    },
    doNotShowAgainButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.do-not-show-again-button",
        "defaultMessage": "Don't show again"
    },
    titleNudgeCandidate04Galaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-04-galaxia",
        "defaultMessage": "Unify your work in Confluence"
    },
    titleNudgeCandidate05Galaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-05-galaxia",
        "defaultMessage": "Bring work together in Confluence"
    },
    descriptionGalaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-galaxia",
        "defaultMessage": "Organize team knowledge, capture ideas, and share requirements for your Jira spaces."
    },
    descriptionNudgeCandidate01Galaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-01-galaxia",
        "defaultMessage": "Create a single source of truth for team decisions and software documentation."
    },
    descriptionNudgeCandidate03Galaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-03-galaxia",
        "defaultMessage": "Create pages to build a shared understanding for better decision-making."
    },
    descriptionNudgeCandidate04Galaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-04-galaxia",
        "defaultMessage": "Organize information and sync it to Jira tasks to track and hit your goals faster."
    },
    descriptionNudgeCandidate05Galaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-05-galaxia",
        "defaultMessage": "Capture information in pages and sync to Jira tasks to track your milestones."
    },
    descriptionNudgeCandidate07Galaxia: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-07-galaxia",
        "defaultMessage": "Join your team in Confluence to consolidate work in one place."
    }
});

});



parcelRegister("8Ujbi", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $499c57cf6f6c3e89$export$a27c21aa3ed8f0f1);
$parcel$export(module.exports, "fireSiteOptedOutAnalytics", () => $499c57cf6f6c3e89$export$b6a30d1aef42926f);

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");
const $499c57cf6f6c3e89$export$a27c21aa3ed8f0f1 = (id, error, attributes = {})=>(0, $gYnSx.default)({
        meta: {
            id: id,
            packageName: 'jiraCrossJoinNudges'
        },
        attributes: attributes,
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
const $499c57cf6f6c3e89$export$b6a30d1aef42926f = (createAnalyticsEvent, integration)=>{
    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'eligibility checked', {
        flagKey: 'NON_CONTEXTUAL_CJNS',
        ineligibilityReason: 'SITE_OPTED_OUT',
        integration: integration
    });
};

});

parcelRegister("hOhO7", function(module, exports) {

$parcel$export(module.exports, "useJpdMsrCrossJoinNudge", () => $aabff5965eb19c36$export$2c32fd73409bafb7);

var $eJOHy = parcelRequire("eJOHy");

var $f1Zdy = parcelRequire("f1Zdy");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $83DiZ = parcelRequire("83DiZ");

var $iaIqW = parcelRequire("iaIqW");

var $8Ujbi = parcelRequire("8Ujbi");

var $cYLBX = parcelRequire("cYLBX");

var $ct7dg = parcelRequire("ct7dg");

var $hgSiz = parcelRequire("hgSiz");

var $1p1B7 = parcelRequire("1p1B7");
const $aabff5965eb19c36$var$MAX_NUMBER_OF_JPD_COLLABORATORS = 10;
const $aabff5965eb19c36$export$2c32fd73409bafb7 = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const userId = (0, $8q7lT.useAccountId)() || '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const getFilteredCollaborators = (0, $cYLBX.useFilteredUsersFromCollaborationGraph)(cloudId, 'jira-product-discovery', $aabff5965eb19c36$var$MAX_NUMBER_OF_JPD_COLLABORATORS);
    const showMsrRequestAccessPromptFlag = (0, $1p1B7.useMsrRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $hgSiz.useMsrRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $ct7dg.useMsrRequestAccessErrorFlag)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const startTimestamp = Date.now();
            const collaboratorsOnJpd = await getFilteredCollaborators();
            const onSubmit = async ()=>{
                try {
                    const accessStatus = await (0, $iaIqW.requestAccess)('jira-product-discovery', cloudId, userId, 'crossJoinNudgesJiraToJpd', createAnalyticsEvent);
                    if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/jira/projects');
                    else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                    else showErrorFlag('jira-product-discovery');
                } catch  {
                    showErrorFlag('jira-product-discovery');
                }
            };
            showMsrRequestAccessPromptFlag({
                users: collaboratorsOnJpd,
                onSubmit: onSubmit,
                targetProduct: 'jira-product-discovery',
                integration: 'crossJoinNudgesJiraToJpd',
                eventAttributes: (0, $1p1B7.getAnalyticsAttributes)({
                    userId: userId,
                    users: collaboratorsOnJpd,
                    startTimestamp: startTimestamp
                })
            });
        // TODO: fire operational analytics for MSR JPD
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('useJpdMsrCrossJoinNudge', error, {
                cloudId: cloudId
            });
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        getFilteredCollaborators,
        push,
        showErrorFlag,
        showMsrRequestAccessPromptFlag,
        showSuccessFlag,
        userId
    ]);
};

});
parcelRegister("iaIqW", function(module, exports) {

$parcel$export(module.exports, "requestAccess", () => $63e38b087ccad084$export$cd9e5995821603e1);

var $1Ozm9 = parcelRequire("1Ozm9");

var $gCeeo = parcelRequire("gCeeo");

var $8Ujbi = parcelRequire("8Ujbi");
const $63e38b087ccad084$var$URL = '/gateway/api/invitations/v1/access-requests/request';
const $63e38b087ccad084$export$cd9e5995821603e1 = async (product, cloudId, userId, integration, createAnalyticsEvent)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    try {
        const response = await (0, $1Ozm9.default)($63e38b087ccad084$var$URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource
            })
        });
        const { results: results } = response;
        const result = results[resource];
        const analyticsAttributes = {
            userId: userId,
            products: [
                product
            ],
            inviteResult: [
                {
                    resourceAri: resource,
                    status: result
                }
            ],
            integration: integration
        };
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'productAccess requested', userId, analyticsAttributes);
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $8Ujbi.fireErrorAnalytics)(integration, error);
        throw new Error(`${integration} request access error`);
    }
};

});

parcelRegister("cYLBX", function(module, exports) {

$parcel$export(module.exports, "useUsersFromCollaborationGraph", () => $92c00d70753dc437$export$b05786e1a14be004);
$parcel$export(module.exports, "useFilteredUsersFromCollaborationGraph", () => $92c00d70753dc437$export$4509f086e4a8422);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $lvKO5 = parcelRequire("lvKO5");

var $8NEWZ = parcelRequire("8NEWZ");
const $92c00d70753dc437$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $92c00d70753dc437$export$b05786e1a14be004 = (cloudId)=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $lvKO5.useTenantContext)();
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const payload = {
                context: {
                    contextType: 'crossJoinNudges',
                    principalId: atlassianAccountId,
                    siteId: cloudId
                },
                modelRequestParams: {
                    experience: 'CgUserNearbyUser'
                },
                expanded: true,
                maxNumberOfResults: $92c00d70753dc437$var$COLLABORATION_GRAPH_MAX_RESULTS,
                userId: atlassianAccountId
            };
            const options = {
                body: JSON.stringify(payload)
            };
            return (0, $jGzN3.performPostRequest)('/gateway/api/collaboration/v1/collaborationgraph/user/user', options).then((entities)=>entities.collaborationGraphEntities.filter((en)=>en.userProfile !== undefined && en.userProfile?.account_type !== 'app' && en.userProfile?.account_status !== 'deactivated' && en.userProfile?.account_status !== 'deleted').map((en)=>({
                        id: en.userProfile.account_id,
                        name: en.userProfile.name,
                        avatar: en.userProfile.picture
                    })));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'useUsersFromCollaborationGraph',
                    packageName: 'jiraCrossJoinNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Get collaborators error');
        }
    }, [
        atlassianAccountId,
        cloudId
    ]);
};
const $92c00d70753dc437$export$4509f086e4a8422 = (cloudId, targetProduct, maxCollaborators)=>{
    const getCollaborators = $92c00d70753dc437$export$b05786e1a14be004(cloudId);
    return (0, $eJOHy.useCallback)(async ()=>{
        const collaborators = await getCollaborators();
        let collaboratorsOnTargetProduct;
        if (targetProduct === 'confluence') collaboratorsOnTargetProduct = await (0, $8NEWZ.getConfluenceUsers)(collaborators, cloudId);
        else collaboratorsOnTargetProduct = await (0, $8NEWZ.getUsersWithProductAccess)(cloudId, targetProduct, collaborators);
        return collaboratorsOnTargetProduct.slice(0, maxCollaborators);
    }, [
        cloudId,
        getCollaborators,
        targetProduct,
        maxCollaborators
    ]);
};

});
parcelRegister("8NEWZ", function(module, exports) {

$parcel$export(module.exports, "getConfluenceUsers", () => $81b2981c4970f883$export$71bcfe5bb11155f7);
$parcel$export(module.exports, "getUsersWithProductAccess", () => $81b2981c4970f883$export$a68fadaa3a8b5e25);

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");
const $81b2981c4970f883$var$URL = '/gateway/api/growth/cross-join-nudges-confluence/get-permitted-confluence-users';
const $81b2981c4970f883$export$71bcfe5bb11155f7 = async (collaborators, cloudId)=>{
    try {
        if (!collaborators || collaborators.length === 0) return [];
        const accountIds = collaborators.map((c)=>c.id);
        const confluenceUsers = await (0, $1Ozm9.default)($81b2981c4970f883$var$URL, {
            method: 'POST',
            body: JSON.stringify({
                cloudId: cloudId,
                accountIds: accountIds
            })
        });
        return collaborators.filter((c)=>confluenceUsers.includes(c.id));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'getConfluenceUsers',
                packageName: 'jiraCrossJoinNudges'
            },
            attributes: {
                cloudId: cloudId,
                accountIds: JSON.stringify(collaborators.map((c)=>c.id)),
                errorResponse: $81b2981c4970f883$var$getErrorResponse(error)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error('Get Confluence users error');
    }
};
const $81b2981c4970f883$var$getErrorResponse = (error)=>{
    try {
        return JSON.stringify(error);
    } catch (e) {
        // Swallow error as the error is already in the analytic event.
        return undefined;
    }
};
const $81b2981c4970f883$var$getInviteesUrl = '/gateway/api/growth/invite-on-link-insert/get-invitees';
const $81b2981c4970f883$export$a68fadaa3a8b5e25 = async (cloudId, product, collaborators)=>{
    const accountIds = collaborators.map((u)=>u.id);
    const lackingAccess = await (0, $1Ozm9.default)($81b2981c4970f883$var$getInviteesUrl, {
        method: 'POST',
        body: JSON.stringify({
            cloudId: cloudId,
            product: product,
            accountIds: accountIds
        })
    });
    return collaborators.filter((c)=>!lackingAccess.includes(c.id));
};

});


parcelRegister("ct7dg", function(module, exports) {

$parcel$export(module.exports, "useMsrRequestAccessErrorFlag", () => $9f56cc675bf711b9$export$cf482a46968d8cd8);

var $eJOHy = parcelRequire("eJOHy");

var $90d5q = parcelRequire("90d5q");
var $a9cht = parcelRequire("a9cht");
var $bILK0 = parcelRequire("bILK0");

var $6MSla = parcelRequire("6MSla");

var $csiXm = parcelRequire("csiXm");
const $9f56cc675bf711b9$export$cf482a46968d8cd8 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagService)();
    return (0, $eJOHy.useCallback)((product)=>{
        const id = `error-${(0, $csiXm.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $90d5q.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MSla.RequestAccessErrorFlag), {
                    ...props,
                    id: id,
                    targetProduct: product,
                    onDismiss: dismiss,
                    flagComponent: (0, $a9cht.ErrorFlag)
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};

});
parcelRegister("csiXm", function(module, exports) {

$parcel$export(module.exports, "generateId", () => $28da6ed710c628f5$export$567fc7097e064344);
let $28da6ed710c628f5$var$id = 0;
const $28da6ed710c628f5$export$567fc7097e064344 = ()=>{
    $28da6ed710c628f5$var$id += 1;
    return String($28da6ed710c628f5$var$id);
};
function $28da6ed710c628f5$export$e86e19342bc4850e(operation, ms) {
    const startTime = Date.now();
    const timeoutPromise = new Promise((resolve)=>{
        setTimeout(()=>{
            resolve({
                timedOut: true,
                result: null,
                elapsedMs: Date.now() - startTime
            });
        }, ms);
    });
    const operationPromise = operation().then((result)=>({
            timedOut: false,
            result: result,
            elapsedMs: Date.now() - startTime
        }));
    return Promise.race([
        operationPromise,
        timeoutPromise
    ]);
}

});


parcelRegister("hgSiz", function(module, exports) {

$parcel$export(module.exports, "useMsrRequestAccessSuccessFlag", () => $272d37bddfc24429$export$aad2705851f163f9);

var $eJOHy = parcelRequire("eJOHy");

var $90d5q = parcelRequire("90d5q");
var $a9cht = parcelRequire("a9cht");
var $bILK0 = parcelRequire("bILK0");

var $4F4L7 = parcelRequire("4F4L7");

var $csiXm = parcelRequire("csiXm");
const $272d37bddfc24429$export$aad2705851f163f9 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagService)();
    return (0, $eJOHy.useCallback)(()=>{
        const id = `success-${(0, $csiXm.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $90d5q.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4F4L7.RequestAccessSuccessFlag), {
                    ...props,
                    id: id,
                    onDismiss: dismiss,
                    flagComponent: (0, $a9cht.SuccessFlag)
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};

});

parcelRegister("1p1B7", function(module, exports) {

$parcel$export(module.exports, "useMsrRequestAccessPromptFlag", () => $754557b51f68548a$export$2a55db9aab2015e8);
$parcel$export(module.exports, "getAnalyticsAttributes", () => $754557b51f68548a$export$e748b6351ba5f204);

var $eJOHy = parcelRequire("eJOHy");

var $90d5q = parcelRequire("90d5q");
var $a9cht = parcelRequire("a9cht");
var $bILK0 = parcelRequire("bILK0");

var $1I5yn = parcelRequire("1I5yn");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $csiXm = parcelRequire("csiXm");

var $eTZwC = parcelRequire("eTZwC");
const $754557b51f68548a$export$2a55db9aab2015e8 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)(async ({ users: users, onSubmit: onSubmit, targetProduct: targetProduct, integration: integration, eventAttributes: eventAttributes })=>{
        const id = `request-access-${(0, $csiXm.generateId)()}`;
        const dismissTheFlag = ()=>dismissFlag((0, $90d5q.dismissFlag)(id));
        const submit = async ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', eventAttributes);
            dismissTheFlag();
            await onSubmit();
        };
        const dismiss = ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', eventAttributes);
            dismissTheFlag();
        };
        const dismissAndSnooze = ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'flag snoozed', eventAttributes);
            dismissTheFlag();
        };
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'nudge viewed', eventAttributes);
        const featureVisitedCount = (0, $eTZwC.getMsrFeatureVisitedCount)();
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1I5yn.RequestAccessPromptFlag), {
                    ...props,
                    id: id,
                    collaborators: users,
                    onDismiss: dismiss,
                    onSnoozeAndDismiss: dismissAndSnooze,
                    onOptoutAndDismiss: dismissAndSnooze,
                    onSubmit: submit,
                    integration: integration,
                    targetProduct: targetProduct,
                    viewCount: featureVisitedCount,
                    flagComponent: (0, $a9cht.InfoFlag)
                })
        });
    }, [
        createAnalyticsEvent,
        dismissFlag,
        showFlag
    ]);
};
function $754557b51f68548a$export$af59011edc35e856(timestampInMs) {
    const currentTime = Date.now();
    return ((currentTime - timestampInMs) / 1000).toFixed(3);
}
const $754557b51f68548a$export$e748b6351ba5f204 = ({ users: users, userId: userId, sessionId: sessionId, startTimestamp: startTimestamp })=>{
    return {
        collaborators: users.length,
        userId: userId,
        sessionId: sessionId,
        eligibilityLatencySeconds: $754557b51f68548a$export$af59011edc35e856(startTimestamp)
    };
};

});
parcelRegister("eTZwC", function(module, exports) {

$parcel$export(module.exports, "getMsrFeatureVisitedCount", () => $401eabcd2734e32c$export$f2efafc0691e783);
$parcel$export(module.exports, "incrementMsrFeatureVisitedCount", () => $401eabcd2734e32c$export$bd1fff62f54dc22e);

var $ljWHg = parcelRequire("ljWHg");
const $401eabcd2734e32c$var$MSR_COUNT_CACHE_KEY = 'CROSS_JOIN_NUDGE_MSR_VISITED_COUNT';
const $401eabcd2734e32c$export$f2efafc0691e783 = ()=>{
    const val = Number((0, $ljWHg.crossJoinNudgeVisitedCache).get($401eabcd2734e32c$var$MSR_COUNT_CACHE_KEY));
    if (Number.isNaN(val)) return 0;
    return val;
};
const $401eabcd2734e32c$export$bd1fff62f54dc22e = ()=>{
    const currentCount = $401eabcd2734e32c$export$f2efafc0691e783();
    const newCount = currentCount + 1;
    (0, $ljWHg.crossJoinNudgeVisitedCache).set($401eabcd2734e32c$var$MSR_COUNT_CACHE_KEY, newCount);
    return newCount;
};

});



parcelRegister("dhnSG", function(module, exports) {

$parcel$export(module.exports, "useOverrides", () => $b043d097f992b8a9$export$ab0d8295b09da679);

var $95O7y = parcelRequire("95O7y");
const $b043d097f992b8a9$export$ab0d8295b09da679 = (queryKey)=>{
    const [value] = (0, $95O7y.useQueryParam)(queryKey);
    let overrides = {};
    if (value) overrides = JSON.parse(value);
    return $b043d097f992b8a9$export$583909077c804932(overrides);
};
function $b043d097f992b8a9$export$583909077c804932(overrides) {
    return (key, val)=>{
        if (Object.prototype.hasOwnProperty.call(overrides, key)) {
            const overrideVal = overrides[key];
            if (typeof overrideVal === 'boolean') return overrideVal;
        }
        return val;
    };
}

});

parcelRegister("3gS0H", function(module, exports) {

$parcel$export(module.exports, "useMsrConfluenceCrossJoinNudge", () => $95f3ad384849b2c7$export$b83779e1eaa5d4de);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $83DiZ = parcelRequire("83DiZ");

var $2UBs9 = parcelRequire("2UBs9");

var $kEanc = parcelRequire("kEanc");

var $iaIqW = parcelRequire("iaIqW");

var $8Ujbi = parcelRequire("8Ujbi");

var $cYLBX = parcelRequire("cYLBX");

var $ct7dg = parcelRequire("ct7dg");

var $hgSiz = parcelRequire("hgSiz");

var $1p1B7 = parcelRequire("1p1B7");
const $95f3ad384849b2c7$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS = 5;
const $95f3ad384849b2c7$export$b83779e1eaa5d4de = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const userId = (0, $8q7lT.useAccountId)() || '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const getFilteredCollaborators = (0, $cYLBX.useFilteredUsersFromCollaborationGraph)(cloudId, 'confluence', $95f3ad384849b2c7$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS);
    const showMsrRequestAccessPromptFlag = (0, $1p1B7.useMsrRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $hgSiz.useMsrRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $ct7dg.useMsrRequestAccessErrorFlag)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const requestAccessService = (0, $7jTnu.fg)('expansion_services_in_cjn') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2UBs9.useService)((0, $kEanc.requestAccess)) : null;
    return (0, $eJOHy.useCallback)(async ()=>{
        const startTimestamp = Date.now();
        try {
            const collaboratorsOnConfluence = await getFilteredCollaborators();
            async function onSubmit() {
                try {
                    try {
                        let accessStatus;
                        if (requestAccessService && (0, $7jTnu.fg)('expansion_services_in_cjn')) {
                            const serviceResult = await requestAccessService({
                                product: 'confluence',
                                integration: 'crossJoinNudgesConfluence'
                            });
                            if (serviceResult.error) {
                                (0, $8Ujbi.fireErrorAnalytics)('crossJoinNudgesConfluence serviceResult.error', serviceResult.error);
                                throw serviceResult.error;
                            }
                            accessStatus = serviceResult.result;
                        } else accessStatus = await (0, $iaIqW.requestAccess)('confluence', cloudId, userId, 'crossJoinNudgesConfluence', createAnalyticsEvent);
                        if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/wiki');
                        else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                        else showErrorFlag('confluence');
                    } catch  {
                        showErrorFlag('confluence');
                    }
                } catch  {
                    showErrorFlag('confluence');
                }
            }
            showMsrRequestAccessPromptFlag({
                users: collaboratorsOnConfluence,
                onSubmit: onSubmit,
                targetProduct: 'confluence',
                integration: 'crossJoinNudgesJiraToConfluence',
                eventAttributes: (0, $1p1B7.getAnalyticsAttributes)({
                    userId: userId,
                    users: collaboratorsOnConfluence,
                    startTimestamp: startTimestamp
                })
            });
            // TODO: fire operational analytics for MSR
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'slo.crossJoinNudgesConfluence succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('useMsrConfluenceCrossJoinNudge', error, {
                cloudId: cloudId
            });
        }
    }, [
        cloudId,
        userId,
        createAnalyticsEvent,
        getFilteredCollaborators,
        push,
        requestAccessService,
        showErrorFlag,
        showSuccessFlag,
        showMsrRequestAccessPromptFlag
    ]);
};

});

parcelRegister("awEIK", function(module, exports) {

$parcel$export(module.exports, "useMsrJpdCrossJoinNudgeEligibility", () => $f4adfa384d732d13$export$58cb5e32a1c0739);

var $eJOHy = parcelRequire("eJOHy");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $b9nqM = parcelRequire("b9nqM");

var $f1Zdy = parcelRequire("f1Zdy");

var $kfvK2 = parcelRequire("kfvK2");

var $8Ujbi = parcelRequire("8Ujbi");

var $dWhgU = parcelRequire("dWhgU");

var $fWKBM = parcelRequire("fWKBM");

var $gnRyQ = parcelRequire("gnRyQ");

var $hQEY6 = parcelRequire("hQEY6");

var $lUO6r = parcelRequire("lUO6r");

var $dhnSG = parcelRequire("dhnSG");
const $f4adfa384d732d13$export$58cb5e32a1c0739 = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const userId = (0, $8q7lT.useAccountId)() || '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const isJpdRoute = (0, $kfvK2.useIsActiveRoute)('polaris-ideas');
    const withOverrides = (0, $dhnSG.useOverrides)('cjn_jpd_overrides');
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            if (withOverrides('is_jpd_route', isJpdRoute)) return {
                isEligible: false,
                reason: 'is_jpd_route'
            };
            if (withOverrides('site_has_no_licensed_jpd', !licensedProducts['jira-product-discovery'])) return {
                isEligible: false,
                reason: 'site_has_no_licensed_jpd'
            };
            if (withOverrides('site_is_opted_out', await (0, $dWhgU.isSiteOptedOut)(cloudId))) {
                (0, $8Ujbi.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesJiraToJpd');
                return {
                    isEligible: false,
                    reason: 'site_is_opted_out'
                };
            }
            if (withOverrides('jpd_is_too_new', !await (0, $fWKBM.isSite7DaysOld)('jira-product-discovery', cloudId))) return {
                isEligible: false,
                reason: 'jpd_is_too_new'
            };
            if (withOverrides('user_is_too_new', await (0, $gnRyQ.isNewActiveUser)(cloudId, userId))) return {
                isEligible: false,
                reason: 'user_is_too_new'
            };
            if (withOverrides('user_already_has_jpd', await (0, $hQEY6.hasProductAccess)('jira-product-discovery', cloudId))) return {
                isEligible: false,
                reason: 'user_already_has_jpd'
            };
            if (withOverrides('user_cannot_request_jpd_access', !await (0, $lUO6r.fetchIsRequestAccessCapable)('jira-product-discovery', cloudId))) return {
                isEligible: false,
                reason: 'user_cannot_request_jpd_access'
            };
            return {
                isEligible: true
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('crossJoinNudgesJiraToJpd', error, {
                cloudId: cloudId
            });
            return {
                isEligible: false,
                reason: 'unexpected error'
            };
        }
    }, [
        cloudId,
        userId,
        createAnalyticsEvent,
        isJpdRoute,
        licensedProducts,
        withOverrides
    ]);
};

});
parcelRegister("dWhgU", function(module, exports) {

$parcel$export(module.exports, "isSiteOptedOut", () => $7e925e1d07159dc3$export$3475487c10c1ac17);

var $lctcw = parcelRequire("lctcw");
const $7e925e1d07159dc3$export$3475487c10c1ac17 = async (cloudId)=>{
    const siteTraits = await (0, $lctcw.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    const optoutTraitValue = siteTraits.find((trait)=>trait.name === 'optout_all_messages')?.value;
    return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};

});

parcelRegister("fWKBM", function(module, exports) {

$parcel$export(module.exports, "isSite7DaysOld", () => $a9d6cb12118148cb$export$23b7746c9e6ae406);

var $lctcw = parcelRequire("lctcw");
const $a9d6cb12118148cb$var$ACTIVATION_TRAITS = {
    confluence: 'confluence.ondemand.activationDate',
    'jira-product-discovery': 'jira-product-discovery.activationDate'
};
const $a9d6cb12118148cb$export$23b7746c9e6ae406 = async (product, cloudId)=>{
    const siteTraits = await (0, $lctcw.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    return $a9d6cb12118148cb$var$findAndCheckActivationDate(product, siteTraits);
};
const $a9d6cb12118148cb$var$findAndCheckActivationDate = (product, traits)=>{
    const traitName = $a9d6cb12118148cb$var$ACTIVATION_TRAITS[product] || undefined;
    if (!traitName) throw Error(`Unknown activation trait key for site product ${product}`);
    const activationTrait = traits.find((trait)=>trait.name === traitName);
    if (activationTrait?.value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const oneWeekLaterActivation = new Date(activationTrait?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return false;
};

});

parcelRegister("gnRyQ", function(module, exports) {

$parcel$export(module.exports, "isNewActiveUser", () => $63575b3cc2f8f421$export$b4712e67f435e1dc);

var $lFovQ = parcelRequire("lFovQ");
const $63575b3cc2f8f421$export$b4712e67f435e1dc = async (cloudId, userId)=>{
    const userTraits = await (0, $lFovQ.memoizedFetchSiteUserPersonalization)({
        cloudId: cloudId,
        userId: userId
    });
    return $63575b3cc2f8f421$var$findAndCheckActiveDate(userTraits);
};
const $63575b3cc2f8f421$var$findAndCheckActiveDate = (traits)=>{
    const traitName = 'jira_first_active';
    const firstActiveTrait = traits.find((trait)=>trait.name === traitName);
    if (firstActiveTrait?.value) {
        const oneWeekActive = new Date(firstActiveTrait?.value.toString());
        oneWeekActive.setDate(oneWeekActive.getDate() + 7);
        const today = new Date();
        return today <= oneWeekActive;
    }
    return true;
};

});

parcelRegister("hQEY6", function(module, exports) {

$parcel$export(module.exports, "hasProductAccess", () => $720d3c5dda9fece8$export$61073fd69a83a1e3);
$parcel$export(module.exports, "fetchCachedAccessCheck", () => $720d3c5dda9fece8$export$cd2f9bc003d00b45);

var $dnU6V = parcelRequire("dnU6V");

var $1Ozm9 = parcelRequire("1Ozm9");

var $gCeeo = parcelRequire("gCeeo");
const $720d3c5dda9fece8$var$URL = '/gateway/api/permissions/permitted';
const $720d3c5dda9fece8$export$61073fd69a83a1e3 = async (product, cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:${product}::site/${cloudId}`
    };
    const response = await (0, $1Ozm9.default)($720d3c5dda9fece8$var$URL, {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response.permitted;
};
// Purposefully set this to 7 days as it's unlikely user can be kicked out of Confluence when they already have access
const $720d3c5dda9fece8$var$PERMISSION_CACHE_KEY_EXPIRY_MS = 604800000;
const $720d3c5dda9fece8$var$crossJoinApiCache = (0, $dnU6V.createLocalExpirableStorageProvider)('cross-join-nudge-conf-perms-api-cache');
const $720d3c5dda9fece8$export$cd2f9bc003d00b45 = async (createAnalyticsEvent, product, cloudId, touchpoint)=>{
    const cacheKey = `cross.join.${product}.cache.key`;
    let permissionResponse = $720d3c5dda9fece8$var$crossJoinApiCache.get(cacheKey);
    if (permissionResponse === undefined) {
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheMiss', {
            touchpoint: touchpoint,
            product: product
        });
        try {
            permissionResponse = await $720d3c5dda9fece8$export$61073fd69a83a1e3(product, cloudId);
        } catch (err) {
            // No PII from identity exception so fire operational analytics consistently
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck fetchError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        try {
            $720d3c5dda9fece8$var$crossJoinApiCache.set(cacheKey, permissionResponse, Date.now() + $720d3c5dda9fece8$var$PERMISSION_CACHE_KEY_EXPIRY_MS);
        } catch (err) {
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck setError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                skipSentry: true
            });
            return permissionResponse;
        }
        return permissionResponse;
    }
    (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheHit', {
        touchpoint: touchpoint,
        product: product
    });
    return permissionResponse;
};

});

parcelRegister("lUO6r", function(module, exports) {

$parcel$export(module.exports, "fetchIsRequestAccessCapable", () => $22792cce0cce9606$export$c75518284e8dee24);
$parcel$export(module.exports, "fetchCachedIsConfluenceRACapable", () => $22792cce0cce9606$export$f5767c68446c14cb);
$parcel$export(module.exports, "resetRACapableCache", () => $22792cce0cce9606$export$5191fc85eb825b4b);

var $dnU6V = parcelRequire("dnU6V");

var $1Ozm9 = parcelRequire("1Ozm9");

var $gCeeo = parcelRequire("gCeeo");
const $22792cce0cce9606$export$c75518284e8dee24 = async (product, cloudId)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    const params = new URLSearchParams({
        resource: resource
    });
    const URL = `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
    const response = await (0, $1Ozm9.default)(URL, {
        credentials: 'include'
    });
    const requestCapabilities = response.results[resource];
    return requestCapabilities === 'DIRECT_ACCESS' || requestCapabilities === 'REQUEST_ACCESS';
};
const $22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY = 'cross.join.confluence-capabilities.cache.key';
// This is set to 1 day only as capabilties has many more states e.g PENDING_REQUEST_EXISTS, APPROVED_REQUEST_EXISTS etc
// We expect capabilities to change more often than product access
const $22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS = 86400000;
const $22792cce0cce9606$var$crossJoinApiCache = (0, $dnU6V.createLocalExpirableStorageProvider)('cross-join-nudge-conf-capabilities-api-cache');
const $22792cce0cce9606$export$f5767c68446c14cb = async (createAnalyticsEvent, cloudId, touchpoint)=>{
    let isRACapable = $22792cce0cce9606$var$crossJoinApiCache.get($22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
    if (isRACapable === undefined) {
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheMiss', {
            touchpoint: touchpoint
        });
        try {
            isRACapable = await $22792cce0cce9606$export$c75518284e8dee24('confluence', cloudId);
        } catch (err) {
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck fetchError', {
                touchpoint: touchpoint,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        $22792cce0cce9606$export$a901680cf5ecfb6c(createAnalyticsEvent, isRACapable, touchpoint);
        return isRACapable;
    }
    (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheHit', {
        touchpoint: touchpoint
    });
    return isRACapable;
};
const $22792cce0cce9606$export$a901680cf5ecfb6c = (createAnalyticsEvent, value, touchpoint)=>{
    try {
        $22792cce0cce9606$var$crossJoinApiCache.set($22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY, value, Date.now() + $22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS);
    } catch (err) {
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck setError', {
            touchpoint: touchpoint,
            err: err,
            skipSentry: true
        });
    }
};
const $22792cce0cce9606$export$5191fc85eb825b4b = ()=>{
    $22792cce0cce9606$var$crossJoinApiCache.remove($22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
};

});


parcelRegister("9nFEq", function(module, exports) {

$parcel$export(module.exports, "useMsrConfluenceCrossJoinNudgeEligibility", () => $a860566d09d380cb$export$2d12472ad22403f3);

var $eJOHy = parcelRequire("eJOHy");

var $f1Zdy = parcelRequire("f1Zdy");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $b9nqM = parcelRequire("b9nqM");

var $kfvK2 = parcelRequire("kfvK2");

var $8Ujbi = parcelRequire("8Ujbi");

var $ljWHg = parcelRequire("ljWHg");

var $hQEY6 = parcelRequire("hQEY6");

var $lUO6r = parcelRequire("lUO6r");

var $fWKBM = parcelRequire("fWKBM");

var $dWhgU = parcelRequire("dWhgU");

var $gnRyQ = parcelRequire("gnRyQ");

var $dhnSG = parcelRequire("dhnSG");
const $a860566d09d380cb$export$2d12472ad22403f3 = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const userId = (0, $8q7lT.useAccountId)() || '';
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const isYourWorkRoute = (0, $kfvK2.useIsActiveRoute)('your-work');
    const withOverrides = (0, $dhnSG.useOverrides)('cjn_conf_overrides');
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const cachedIsSiteOptedOut = (0, $ljWHg.withEligibilityCache)('site_is_opted_out', (0, $dWhgU.isSiteOptedOut), 0.2);
            const cachedHasProductAccess = (0, $ljWHg.withEligibilityCache)('user_already_has_confluence', (0, $hQEY6.hasProductAccess), 0.2);
            const cachedUserCanRequestAccess = (0, $ljWHg.withEligibilityCache)('user_cannot_request_confluence_access', (0, $lUO6r.fetchIsRequestAccessCapable), 0.2);
            if (withOverrides('is_your_work_route', isYourWorkRoute)) return {
                isEligible: false,
                reason: 'is_your_work_route'
            };
            if (withOverrides('site_has_no_licensed_confluence', !licensedProducts.confluence)) return {
                isEligible: false,
                reason: 'site_has_no_licensed_confluence'
            };
            if (withOverrides('site_is_opted_out', await cachedIsSiteOptedOut(cloudId))) {
                (0, $8Ujbi.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesConfluence');
                return {
                    isEligible: false,
                    reason: 'site_is_opted_out'
                };
            }
            const userHasProductAccess = await cachedHasProductAccess('confluence', cloudId);
            if (withOverrides('user_already_has_confluence', userHasProductAccess)) return {
                isEligible: false,
                reason: 'user_already_has_confluence'
            };
            const userCanRequestAccessToConfluence = await cachedUserCanRequestAccess('confluence', cloudId);
            if (withOverrides('user_cannot_request_confluence_access', !userCanRequestAccessToConfluence)) return {
                isEligible: false,
                reason: 'user_cannot_request_confluence_access'
            };
            if (withOverrides('confluence_is_too_new', !await (0, $fWKBM.isSite7DaysOld)('confluence', cloudId))) return {
                isEligible: false,
                reason: 'confluence_is_too_new'
            };
            if (withOverrides('user_is_too_new', await (0, $gnRyQ.isNewActiveUser)(cloudId, userId))) return {
                isEligible: false,
                reason: 'user_is_too_new'
            };
            return {
                isEligible: true
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('useCrossJoinNudges', error, {
                cloudId: cloudId
            });
            return {
                isEligible: false,
                reason: 'unexpected error'
            };
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        isYourWorkRoute,
        licensedProducts.confluence,
        userId,
        withOverrides
    ]);
};

});

parcelRegister("gEsbZ", function(module, exports) {

$parcel$export(module.exports, "useMsrSnoozeHandler", () => $246fc9a736d8f9cf$export$929578679169c83e);

var $eJOHy = parcelRequire("eJOHy");

var $ljWHg = parcelRequire("ljWHg");

var $eTZwC = parcelRequire("eTZwC");
const $246fc9a736d8f9cf$var$SNOOZE_INTERVALS = {
    0: 7,
    1: 14,
    2: 30,
    3: 90
};
const $246fc9a736d8f9cf$export$929578679169c83e = ()=>{
    const blockEligibilityUntilTomorrow = (0, $eJOHy.useCallback)(()=>{
        (0, $ljWHg.setFeatureVisited)('crossJoinNudgesMsr', 1);
    }, []);
    const snooze = (0, $eJOHy.useCallback)(()=>{
        const visitedCount = (0, $eTZwC.getMsrFeatureVisitedCount)();
        // We are going to loop the last nudge indefinitely
        const loopedVisitedCount = Math.min(visitedCount, Object.keys($246fc9a736d8f9cf$var$SNOOZE_INTERVALS).length - 1);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const snoozeInterval = $246fc9a736d8f9cf$var$SNOOZE_INTERVALS[loopedVisitedCount];
        (0, $ljWHg.setFeatureVisited)('crossJoinNudgesMsr', snoozeInterval);
        (0, $eTZwC.incrementMsrFeatureVisitedCount)();
    }, []);
    return {
        snooze: snooze,
        blockEligibilityUntilTomorrow: blockEligibilityUntilTomorrow
    };
};

});


parcelRegister("aL0ae", function(module, exports) {

$parcel$export(module.exports, "useJpdCrossJoinNudgeEligibility", () => $b68a717b2bd198f7$export$cf17b7d2f952c993);

var $eJOHy = parcelRequire("eJOHy");

var $f1Zdy = parcelRequire("f1Zdy");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $b9nqM = parcelRequire("b9nqM");

var $kfvK2 = parcelRequire("kfvK2");

var $8Ujbi = parcelRequire("8Ujbi");

var $ljWHg = parcelRequire("ljWHg");

var $lIThU = parcelRequire("lIThU");
const $b68a717b2bd198f7$export$cf17b7d2f952c993 = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const userId = (0, $8q7lT.useAccountId)() || '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const isJpdRoute = (0, $kfvK2.useIsActiveRoute)('polaris-ideas');
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            if ((0, $ljWHg.getOrUpdateFeatureVisited)('crossJoinNudgesJiraToJpd', 30)) return {
                isEligible: false,
                inelligibleReason: 'feature visited too recently'
            };
            if (isJpdRoute) return {
                isEligible: false,
                inelligibleReason: 'jpd route'
            };
            const eligibilityResponse = await (0, $lIThU.checkJpdCrossJoinNudgeEligibility)({
                cloudId: cloudId,
                userId: userId,
                licensedProducts: licensedProducts
            });
            if (!eligibilityResponse.eligible) {
                if (eligibilityResponse.ineligibilityReason === 'SITE_OPTED_OUT') (0, $8Ujbi.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesJiraToJpd');
                return {
                    isEligible: false,
                    inelligibleReason: eligibilityResponse.ineligibilityReason
                };
            }
            return {
                isEligible: true,
                data: {}
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('crossJoinNudgesJiraToJpd', error, {
                cloudId: cloudId
            });
            return {
                isEligible: false,
                inelligibleReason: 'unexpected error'
            };
        }
    }, [
        cloudId,
        userId,
        createAnalyticsEvent,
        isJpdRoute,
        licensedProducts
    ]);
};

});
parcelRegister("lIThU", function(module, exports) {

$parcel$export(module.exports, "checkJpdCrossJoinNudgeEligibility", () => $d5febf352f541134$export$db3bc6af881f6bd0);

var $hQEY6 = parcelRequire("hQEY6");

var $lUO6r = parcelRequire("lUO6r");

var $fWKBM = parcelRequire("fWKBM");

var $dWhgU = parcelRequire("dWhgU");

var $gnRyQ = parcelRequire("gnRyQ");
const $d5febf352f541134$export$db3bc6af881f6bd0 = async ({ cloudId: cloudId, userId: userId, licensedProducts: licensedProducts })=>{
    if (!licensedProducts['jira-product-discovery']) return {
        eligible: false,
        ineligibilityReason: 'NO_JPD_LICENCE'
    };
    if (await (0, $dWhgU.isSiteOptedOut)(cloudId)) return {
        eligible: false,
        ineligibilityReason: 'SITE_OPTED_OUT'
    };
    if (!await (0, $fWKBM.isSite7DaysOld)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NEW_SITE_LESS_THAN_7_DAYS_OLD'
    };
    if (await (0, $gnRyQ.isNewActiveUser)(cloudId, userId)) return {
        eligible: false,
        ineligibilityReason: 'NEW_ACTIVE_USER'
    };
    if (await (0, $hQEY6.hasProductAccess)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'ALREADY_HAVE_ACCESS'
    };
    if (!await (0, $lUO6r.fetchIsRequestAccessCapable)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
    };
    return {
        eligible: true
    };
};

});


parcelRegister("lvTzp", function(module, exports) {

$parcel$export(module.exports, "useConfluenceCrossJoinNudgeEligibility", () => $dcb33797a02a8fc9$export$a3f7303bbd08ef0d);
$parcel$export(module.exports, "useLlmConfluenceCrossJoinNudgeEligibility", () => $dcb33797a02a8fc9$export$3bcfe3104ff90dce);
$parcel$export(module.exports, "useHasSeenConfLlm", () => $dcb33797a02a8fc9$export$269024ef75d7c956);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $b9nqM = parcelRequire("b9nqM");

var $kfvK2 = parcelRequire("kfvK2");

var $2cfd4 = parcelRequire("2cfd4");

var $8Ujbi = parcelRequire("8Ujbi");

var $ljWHg = parcelRequire("ljWHg");

var $cYLBX = parcelRequire("cYLBX");

var $2G4e8 = parcelRequire("2G4e8");

var $hQEY6 = parcelRequire("hQEY6");

var $lUO6r = parcelRequire("lUO6r");

var $fWKBM = parcelRequire("fWKBM");

var $dWhgU = parcelRequire("dWhgU");

var $dK92f = parcelRequire("dK92f");

var $gnRyQ = parcelRequire("gnRyQ");


var $dhnSG = parcelRequire("dhnSG");
const $dcb33797a02a8fc9$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS = 5;
const $dcb33797a02a8fc9$export$a3f7303bbd08ef0d = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const getFilteredCollaborators = (0, $cYLBX.useFilteredUsersFromCollaborationGraph)(cloudId, 'confluence', $dcb33797a02a8fc9$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS);
    const { getNudgeState: getNudgeStateV2a } = (0, $2G4e8.useNudgeStateV2a)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const userId = (0, $8q7lT.useAccountId)() || '';
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const isYourWorkRoute = (0, $kfvK2.useIsActiveRoute)('your-work');
    const locale = (0, $2cfd4.useLocale)();
    const withOverrides = (0, $dhnSG.useOverrides)('cjn_conf_overrides');
    return (0, $eJOHy.useCallback)(async ()=>{
        const startTimestamp = Date.now();
        try {
            const cachedIsSiteOptedOut = (0, $ljWHg.withEligibilityCache)('site_is_opted_out', (0, $dWhgU.isSiteOptedOut), 0.2);
            const cachedHasProductAccess = (0, $ljWHg.withEligibilityCache)('user_already_has_confluence', (0, $hQEY6.hasProductAccess), 0.2);
            const cachedUserCanRequestAccess = (0, $ljWHg.withEligibilityCache)('user_cannot_request_confluence_access', (0, $lUO6r.fetchIsRequestAccessCapable), 0.2);
            if (withOverrides('is_your_work_route', isYourWorkRoute)) return {
                isEligible: false,
                inelligibleReason: 'is_your_work_route'
            };
            if (withOverrides('site_has_no_licensed_confluence', !licensedProducts.confluence)) return {
                isEligible: false,
                inelligibleReason: 'site_has_no_licensed_confluence'
            };
            if (withOverrides('feature_visited_too_recently', (0, $ljWHg.getOrUpdateFeatureVisited)('crossJoinNudgesConfluence', 30))) return {
                isEligible: false,
                inelligibleReason: 'feature_visited_too_recently'
            };
            if (withOverrides('site_is_opted_out', await cachedIsSiteOptedOut(cloudId))) {
                (0, $8Ujbi.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesConfluence');
                return {
                    isEligible: false,
                    inelligibleReason: 'site_is_opted_out'
                };
            }
            const userHasProductAccess = await cachedHasProductAccess('confluence', cloudId);
            if (withOverrides('user_already_has_confluence', userHasProductAccess)) return {
                isEligible: false,
                inelligibleReason: 'user_already_has_confluence'
            };
            const userCanRequestAccessToConfluence = await cachedUserCanRequestAccess('confluence', cloudId);
            if (withOverrides('user_cannot_request_confluence_access', !userCanRequestAccessToConfluence)) return {
                isEligible: false,
                inelligibleReason: 'user_cannot_request_confluence_access'
            };
            if (withOverrides('confluence_is_too_new', !await (0, $fWKBM.isSite7DaysOld)('confluence', cloudId))) return {
                isEligible: false,
                inelligibleReason: 'confluence_is_too_new'
            };
            if (withOverrides('user_is_too_new', await (0, $gnRyQ.isNewActiveUser)(cloudId, userId))) return {
                isEligible: false,
                inelligibleReason: 'user_is_too_new'
            };
            // Since V2A Rollout to 100%, all nudge will use V2A Logic
            if (withOverrides('nudge_already_dismissed', await getNudgeStateV2a() === 'DISMISSED')) return {
                isEligible: false,
                inelligibleReason: 'nudge_already_dismissed'
            };
            const featureVisitedCount = await (0, $ljWHg.getFeatureVisitedCount)(userId);
            const isEnglishLocale = locale && locale.startsWith('en');
            // NOTE: This AA test shouldn't be run in parallel with the AB 'grw-1755-growth-exp-jira-cjn-llm' experiment. Ensure flags are properly coordinated in statsig.
            if (isEnglishLocale && (0, $7jTnu.fg)('grw-1755-growth-exp-jira-cjn-llm-aa')) (async function() {
                try {
                    if (!(0, $ljWHg.getOrUpdateFeatureVisited)('crossJoinNudgesLLMAA', 7)) {
                        const collaborators = await getFilteredCollaborators();
                        const hasNoCollaborators = collaborators.length === 0;
                        if (!hasNoCollaborators) // user is part of v2a
                        return;
                        await (0, $dK92f.generateCJNContent)();
                        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
                            flagKey: 'grw-1755-growth-exp-jira-cjn-llm-aa',
                            featureVisitedCount: featureVisitedCount,
                            msSinceStart: startTimestamp - Date.now()
                        });
                    }
                } catch (error) {
                // We're running an AA test, so there's no user-facing error handling
                // The error is already captured in analytics
                }
            })();
            if (withOverrides('nudge_seen_too_many_times', featureVisitedCount >= (0, $c7deaa9431a15ff8$export$a4b45159adbcc3d7))) return {
                isEligible: false,
                inelligibleReason: 'nudge_seen_too_many_times'
            };
            return {
                isEligible: true,
                data: {
                    featureVisitedCount: featureVisitedCount
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('useCrossJoinNudges', error, {
                cloudId: cloudId
            });
            return {
                isEligible: false,
                inelligibleReason: 'unexpected error'
            };
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        getFilteredCollaborators,
        getNudgeStateV2a,
        isYourWorkRoute,
        licensedProducts.confluence,
        locale,
        userId,
        withOverrides
    ]);
};
const $dcb33797a02a8fc9$export$3bcfe3104ff90dce = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const getFilteredCollaborators = (0, $cYLBX.useFilteredUsersFromCollaborationGraph)(cloudId, 'confluence', $dcb33797a02a8fc9$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS);
    const locale = (0, $2cfd4.useLocale)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const withOverrides = (0, $dhnSG.useOverrides)('cjn_conf_overrides');
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const cachedIsSiteOptedOut = (0, $ljWHg.withEligibilityCache)('site_is_opted_out', (0, $dWhgU.isSiteOptedOut), 0.2);
            const cachedHasProductAccess = (0, $ljWHg.withEligibilityCache)('user_already_has_confluence', (0, $hQEY6.hasProductAccess), 0.2);
            const cachedUserCanRequestAccess = (0, $ljWHg.withEligibilityCache)('user_cannot_request_confluence_access', (0, $lUO6r.fetchIsRequestAccessCapable), 0.2);
            async function hasCollaborators() {
                const collaborators = (await getFilteredCollaborators()).length ?? 0;
                return collaborators > 0;
            }
            const hasCollaboratorsWithCache = (0, $ljWHg.withEligibilityCache)('has_collaborators', hasCollaborators, 7);
            const isEnglishLocale = locale && locale.startsWith('en');
            if (!isEnglishLocale) return {
                isEligible: false,
                inelligibleReason: 'not_english_locale'
            };
            if (withOverrides('site_has_no_licensed_confluence', !licensedProducts.confluence)) return {
                isEligible: false,
                inelligibleReason: 'site_has_no_licensed_confluence'
            };
            if (withOverrides('site_is_opted_out', await cachedIsSiteOptedOut(cloudId))) {
                (0, $8Ujbi.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesConfluence');
                return {
                    isEligible: false,
                    inelligibleReason: 'site_is_opted_out'
                };
            }
            const userHasProductAccess = await cachedHasProductAccess('confluence', cloudId);
            if (withOverrides('user_already_has_confluence', userHasProductAccess)) return {
                isEligible: false,
                inelligibleReason: 'user_already_has_confluence'
            };
            const userCanRequestAccessToConfluence = await cachedUserCanRequestAccess('confluence', cloudId);
            if (withOverrides('user_cannot_request_confluence_access', !userCanRequestAccessToConfluence)) return {
                isEligible: false,
                inelligibleReason: 'user_cannot_request_confluence_access'
            };
            if (await hasCollaboratorsWithCache()) return {
                isEligible: false,
                inelligibleReason: 'has_collaborators'
            };
            return {
                isEligible: true,
                data: {}
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('useCrossJoinNudges', error, {
                cloudId: cloudId
            });
            return {
                isEligible: false,
                inelligibleReason: 'unexpected error'
            };
        }
    }, [
        cloudId,
        getFilteredCollaborators,
        locale,
        createAnalyticsEvent,
        licensedProducts.confluence,
        withOverrides
    ]);
};
const $dcb33797a02a8fc9$export$269024ef75d7c956 = ()=>{
    return (0, $eJOHy.useCallback)(()=>{
        return (0, $ljWHg.cjnEligibilityCacheHandler).get('has_seen_conf_llm');
    }, []);
};

});
parcelRegister("2G4e8", function(module, exports) {

$parcel$export(module.exports, "useNudgeStateV2a", () => $51c7f399587b4997$export$1721ab60f4854021);
$parcel$export(module.exports, "useNudgeStateYourWork", () => $51c7f399587b4997$export$766742495b6411cb);
$parcel$export(module.exports, "useNudgeStateJiraToJpd", () => $51c7f399587b4997$export$13bdd3f195e673d5);

var $eJOHy = parcelRequire("eJOHy");

var $8q7lT = parcelRequire("8q7lT");

var $kwi6w = parcelRequire("kwi6w");
const $51c7f399587b4997$var$getNudgeState = async (key, accountId)=>{
    if (!accountId) return 'NONE';
    const nudgeState = await (0, $kwi6w.getUserProperty)({
        accountId: accountId,
        propertyKey: key,
        defaultValue: 'NONE'
    });
    return nudgeState.value;
};
const $51c7f399587b4997$var$setNudgeDismissState = async (key, accountId)=>{
    if (!accountId) return;
    await (0, $kwi6w.setUserProperty)({
        accountId: accountId,
        propertyKey: key,
        propertyValue: 'DISMISSED'
    });
};
const $51c7f399587b4997$var$useNudgeState = (key)=>{
    const accountId = (0, $8q7lT.useAccountId)();
    return (0, $eJOHy.useMemo)(()=>({
            getNudgeState: ()=>$51c7f399587b4997$var$getNudgeState(key, accountId),
            setNudgeDismissed: ()=>$51c7f399587b4997$var$setNudgeDismissState(key, accountId)
        }), [
        accountId,
        key
    ]);
};
const $51c7f399587b4997$export$1721ab60f4854021 = ()=>$51c7f399587b4997$var$useNudgeState('CROSS_JOIN_NUDGES_CONFLUENCE_V2A');
const $51c7f399587b4997$export$766742495b6411cb = ()=>$51c7f399587b4997$var$useNudgeState('CROSS_JOIN_NUDGES_YOUR_WORK');
const $51c7f399587b4997$export$13bdd3f195e673d5 = ()=>$51c7f399587b4997$var$useNudgeState('CROSS_JOIN_NUDGES_JIRA_TO_JPD');

});

parcelRegister("dK92f", function(module, exports) {

$parcel$export(module.exports, "generateCJNContent", () => $5cbb915e5e1affc3$export$8f35cea1f9221030);

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");
const $5cbb915e5e1affc3$var$GCGS_JIRA_SPOTLIGHT_URL = '/gateway/api/gcg/api/v1/generate/team_growth/cross_join_nudge/jira_spotlight';
const $5cbb915e5e1affc3$var$ATLASSIAN_ACCOUNT_URL = '/gateway/api/me';
const $5cbb915e5e1affc3$export$8f35cea1f9221030 = async ()=>{
    try {
        const me = await (0, $1Ozm9.default)($5cbb915e5e1affc3$var$ATLASSIAN_ACCOUNT_URL);
        const response = await (0, $1Ozm9.default)($5cbb915e5e1affc3$var$GCGS_JIRA_SPOTLIGHT_URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                contact_name: me.nickname || me.name,
                domain: me.email.split('@')[1],
                product: 'confluence',
                job_title: me.extended_profile.job_title,
                department: me.extended_profile.department,
                team_type: me.extended_profile.team_type
            })
        });
        return {
            title: response.title,
            body: response.body,
            metadata: {
                companyName: response.metadata.company_name,
                firstName: response.metadata.first_name
            },
            // TODO: GROOT-1944 we should remove special handling for this scenario and just throw when we have better overall handling in place that doesn't cause a snooze
            ready: response.status !== 'PROCESSING'
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'generateCJNContentFetchFailed',
                packageName: 'jiraCrossJoinNudges',
                teamName: 'groot-growth'
            },
            error: error
        });
        throw new Error('Failed to generate nudge content');
    }
};

});

const $c7deaa9431a15ff8$export$a4b45159adbcc3d7 = 3;


parcelRegister("efQhD", function(module, exports) {

$parcel$export(module.exports, "useJpdCrossJoinNudge", () => $0ff9578fdc96521c$export$b59148260d6e0135);

var $eJOHy = parcelRequire("eJOHy");

var $f1Zdy = parcelRequire("f1Zdy");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $83DiZ = parcelRequire("83DiZ");

var $iaIqW = parcelRequire("iaIqW");

var $8Ujbi = parcelRequire("8Ujbi");

var $ljWHg = parcelRequire("ljWHg");

var $cYLBX = parcelRequire("cYLBX");

var $2G4e8 = parcelRequire("2G4e8");

var $aruII = parcelRequire("aruII");

var $blDud = parcelRequire("blDud");

var $5Ilbg = parcelRequire("5Ilbg");

const $0ff9578fdc96521c$var$MAX_NUMBER_OF_JPD_COLLABORATORS = 10;
const $0ff9578fdc96521c$export$b59148260d6e0135 = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const userId = (0, $8q7lT.useAccountId)() || '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const getFilteredCollaborators = (0, $cYLBX.useFilteredUsersFromCollaborationGraph)(cloudId, 'jira-product-discovery', $0ff9578fdc96521c$var$MAX_NUMBER_OF_JPD_COLLABORATORS);
    const showRequestAccessPromptFlag = (0, $blDud.useRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $5Ilbg.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $aruII.useRequestAccessErrorFlag)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { snoozeFor30Days: snoozeFor30Days, getVisitedCount: getVisitedCount, increaseVisitedCount: increaseVisitedCount } = (0, $ljWHg.useSnooze)('crossJoinNudgesJiraToJpd');
    const { getNudgeState: getNudgeState, setNudgeDismissed: setNudgeDismissed } = (0, $2G4e8.useNudgeStateJiraToJpd)();
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const startTimestamp = Date.now();
            const collaboratorsOnJpd = await getFilteredCollaborators();
            const onSubmit = async ()=>{
                try {
                    const accessStatus = await (0, $iaIqW.requestAccess)('jira-product-discovery', cloudId, userId, 'crossJoinNudgesJiraToJpd', createAnalyticsEvent);
                    if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/jira/projects');
                    else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                    else showErrorFlag('jira-product-discovery');
                } catch  {
                    showErrorFlag('jira-product-discovery');
                }
            };
            const isUserOptOut = await getNudgeState() === 'DISMISSED';
            const featureVisitedCount = await getVisitedCount();
            if (isUserOptOut || featureVisitedCount >= (0, $c7deaa9431a15ff8$export$a4b45159adbcc3d7)) return;
            showRequestAccessPromptFlag({
                users: collaboratorsOnJpd,
                onSubmit: onSubmit,
                onOptout: setNudgeDismissed,
                snoozeFor30Days: snoozeFor30Days,
                integration: 'crossJoinNudgesJiraToJpd',
                featureVisitedCount: featureVisitedCount,
                messageParser: (0, $blDud.getJPDCJNMessageStrings),
                eventAttributes: (0, $blDud.getAnalyticsAttributes)({
                    userId: userId,
                    users: collaboratorsOnJpd,
                    featureVisitedCount: featureVisitedCount,
                    startTimestamp: startTimestamp
                })
            });
            await Promise.all([
                increaseVisitedCount(featureVisitedCount + 1),
                (0, $ljWHg.cjnEligibilityCacheHandler).set('has_seen_jpd', {
                    value: true
                })
            ]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('crossJoinNudgesJiraToJpd', error, {
                cloudId: cloudId
            });
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        getFilteredCollaborators,
        getNudgeState,
        getVisitedCount,
        increaseVisitedCount,
        push,
        setNudgeDismissed,
        showErrorFlag,
        showRequestAccessPromptFlag,
        showSuccessFlag,
        snoozeFor30Days,
        userId
    ]);
};

});
parcelRegister("aruII", function(module, exports) {

$parcel$export(module.exports, "useRequestAccessErrorFlag", () => $cd3ee887d4b607ed$export$d8e2d94eec4efe85);

var $eJOHy = parcelRequire("eJOHy");

var $51Gwp = parcelRequire("51Gwp");

var $7jTnu = parcelRequire("7jTnu");

var $90d5q = parcelRequire("90d5q");
var $a9cht = parcelRequire("a9cht");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $fnw8E = parcelRequire("fnw8E");

var $csiXm = parcelRequire("csiXm");

var $iOI0S = parcelRequire("iOI0S");
const $cd3ee887d4b607ed$export$d8e2d94eec4efe85 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagService)();
    return (0, $eJOHy.useCallback)((product)=>{
        const id = `error-${(0, $csiXm.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $90d5q.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd3ee887d4b607ed$export$e1d0d64874873c8b, {
                    ...props,
                    id: id,
                    product: product,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $cd3ee887d4b607ed$var$JIRA_SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $cd3ee887d4b607ed$export$e1d0d64874873c8b = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.ErrorFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $iOI0S.messages).title, {
            productDisplayName: (0, $fnw8E.ProductDisplayNames)[props.product]
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $iOI0S.messages).description), (0, $7jTnu.fg)('replace-anchor-with-link__groot-growth') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
            href: $cd3ee887d4b607ed$var$JIRA_SUPPORT_LINK
        }, formatMessage((0, $iOI0S.messages).action)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
            href: $cd3ee887d4b607ed$var$JIRA_SUPPORT_LINK
        }, formatMessage((0, $iOI0S.messages).action)), "."))
    });
};

});
parcelRegister("fnw8E", function(module, exports) {

$parcel$export(module.exports, "ProductDisplayNames", () => $234d97a33b81d80d$export$46d857911d19ac95);
const $234d97a33b81d80d$export$46d857911d19ac95 = {
    confluence: 'Confluence',
    'jira-product-discovery': 'Jira Product Discovery'
};

});

parcelRegister("iOI0S", function(module, exports) {

$parcel$export(module.exports, "messages", () => $66d518c3cbacea68$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $66d518c3cbacea68$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "cross-join-nudges.request-access-error-flag.title",
        "defaultMessage": "We couldn't add you to {productDisplayName}"
    },
    description: {
        "id": "cross-join-nudges.request-access-error-flag.description",
        "defaultMessage": "Try again in a few minutes. If you still aren't able to join, "
    },
    action: {
        "id": "cross-join-nudges.request-access-error-flag.action",
        "defaultMessage": "contact support"
    }
});

});


parcelRegister("blDud", function(module, exports) {

$parcel$export(module.exports, "useRequestAccessPromptFlag", () => $b205f495b5e2eb08$export$233a6a0aca8c9091);
$parcel$export(module.exports, "getAnalyticsAttributes", () => $b205f495b5e2eb08$export$e748b6351ba5f204);
$parcel$export(module.exports, "getContextualBanditAnalyticsAttributes", () => $b205f495b5e2eb08$export$53c813e9a54d378a);
$parcel$export(module.exports, "getLLMAnalyticsAttributes", () => $b205f495b5e2eb08$export$882b0d75f031b08b);
$parcel$export(module.exports, "getContextualBanditCJNMessageParser", () => $b205f495b5e2eb08$export$7e2ad46880c00991);
$parcel$export(module.exports, "getJPDCJNMessageStrings", () => $b205f495b5e2eb08$export$77b0d0ed99f701d0);
$parcel$export(module.exports, "getLLMCJNMessageParser", () => $b205f495b5e2eb08$export$d9d7a49d4bfff37f);

var $eJOHy = parcelRequire("eJOHy");

var $90d5q = parcelRequire("90d5q");
var $bILK0 = parcelRequire("bILK0");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $lRq8t = parcelRequire("lRq8t");

var $5QB52 = parcelRequire("5QB52");

var $csiXm = parcelRequire("csiXm");

var $6Jmsm = parcelRequire("6Jmsm");

var $b6Mjq = parcelRequire("b6Mjq");
const $b205f495b5e2eb08$export$233a6a0aca8c9091 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $eJOHy.useCallback)(({ users: users, onOptout: onOptout, onSubmit: onSubmit, snoozeFor30Days: snoozeFor30Days, integration: integration, eventAttributes: eventAttributes, messageParser: messageParser, featureVisitedCount: featureVisitedCount = 0 })=>{
        const id = `request-access-${(0, $csiXm.generateId)()}`;
        const dismissTheFlag = ()=>dismissFlag((0, $90d5q.dismissFlag)(id));
        const submit = async ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', integration, eventAttributes);
            dismissTheFlag();
            await onSubmit();
        };
        const dismiss = ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', integration, eventAttributes);
            dismissTheFlag();
        };
        const dismissAndOptout = ()=>{
            dismiss();
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'flag optedOut', integration, eventAttributes);
            onOptout();
        };
        const dismissAndSnooze = ()=>{
            dismissTheFlag();
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'flag snoozed', integration, eventAttributes);
            snoozeFor30Days();
        };
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'nudge viewed', integration, eventAttributes);
        const cjnMessages = messageParser(formatMessage);
        const avatarOrientation = integration === 'crossJoinNudgesJiraToJpd' ? 'horizontal' : 'vertical';
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b6Mjq.RequestAccessPromptFlag), {
                    ...props,
                    id: id,
                    users: users,
                    onDismiss: dismiss,
                    onSnoozeAndDismiss: dismissAndSnooze,
                    onOptoutAndDismiss: dismissAndOptout,
                    onSubmit: submit,
                    avatarOrientation: avatarOrientation,
                    messages: cjnMessages,
                    featureVisitedCount: featureVisitedCount
                })
        });
    }, [
        formatMessage,
        createAnalyticsEvent,
        dismissFlag,
        showFlag
    ]);
};
function $b205f495b5e2eb08$export$af59011edc35e856(timestampInMs) {
    const currentTime = Date.now();
    return ((currentTime - timestampInMs) / 1000).toFixed(3);
}
const $b205f495b5e2eb08$export$e748b6351ba5f204 = ({ users: users, userId: userId, sessionId: sessionId, featureVisitedCount: featureVisitedCount, startTimestamp: startTimestamp })=>{
    return {
        collaborators: users.length,
        userId: userId,
        sessionId: sessionId,
        featureVisitedCount: featureVisitedCount,
        eligibilityLatencySeconds: $b205f495b5e2eb08$export$af59011edc35e856(startTimestamp)
    };
};
const $b205f495b5e2eb08$export$53c813e9a54d378a = ({ entityId: entityId, isContextualBandit: isContextualBandit, ...args })=>{
    return {
        ...$b205f495b5e2eb08$export$e748b6351ba5f204(args),
        isContextualBandit: isContextualBandit,
        entityId: entityId
    };
};
const $b205f495b5e2eb08$export$882b0d75f031b08b = ({ firstName: firstName, companyName: companyName, generatedTitle: generatedTitle, generatedBody: generatedBody, ...rest })=>{
    function normalize(content) {
        return content.replaceAll(/[\W\d_]/g, '').toLowerCase();
    }
    function hasMatchingValue(value) {
        const r = new RegExp(normalize(value));
        return Boolean(value && (r.test(normalize(generatedTitle)) || r.test(normalize(generatedBody))));
    }
    return {
        ...$b205f495b5e2eb08$export$e748b6351ba5f204(rest),
        contentHasFirstName: hasMatchingValue(firstName),
        contentHasCompanyName: hasMatchingValue(companyName),
        isLLM: true
    };
};
const $b205f495b5e2eb08$export$7e2ad46880c00991 = ({ isContextualBandit: isContextualBandit, entityId: entityId, featureVisitedCount: featureVisitedCount })=>{
    return (formatMessage)=>{
        const dynamicMessages = (0, $5QB52.getDynamicMessages)(isContextualBandit, entityId) || (0, $6Jmsm.messages);
        const infoFlagTitle = isContextualBandit ? formatMessage((0, $6Jmsm.messages).title) : formatMessage((0, $6Jmsm.messages).urgencyTitle, {
            viewCount: featureVisitedCount
        });
        return {
            title: infoFlagTitle,
            description: formatMessage(dynamicMessages.description),
            joinButton: formatMessage(dynamicMessages.joinButton),
            remindMeLaterButton: formatMessage((0, $6Jmsm.messages).remindMeLaterButton),
            notInterestedButton: formatMessage((0, $6Jmsm.messages).notInterestedButton)
        };
    };
};
const $b205f495b5e2eb08$export$77b0d0ed99f701d0 = (formatMessage)=>{
    return {
        title: formatMessage((0, $6Jmsm.messages).titleJpdNudge),
        description: formatMessage((0, $6Jmsm.messages).descriptionJpdNudge),
        joinButton: formatMessage((0, $6Jmsm.messages).getStartedButton),
        remindMeLaterButton: formatMessage((0, $6Jmsm.messages).remindMeLaterButton),
        notInterestedButton: formatMessage((0, $6Jmsm.messages).doNotShowAgainButton)
    };
};
const $b205f495b5e2eb08$export$d9d7a49d4bfff37f = ({ title: title, description: description })=>{
    return (formatMessage)=>{
        return {
            title: title,
            description: description,
            joinButton: formatMessage((0, $6Jmsm.messages).joinButtonLlmGenerated),
            remindMeLaterButton: formatMessage((0, $6Jmsm.messages).remindMeLaterButton),
            notInterestedButton: formatMessage((0, $6Jmsm.messages).notInterestedButton)
        };
    };
};

});
parcelRegister("b6Mjq", function(module, exports) {

$parcel$export(module.exports, "RequestAccessPromptFlag", () => $06b71c6e3e5de02d$export$9b8813c3601640da);
/* flag-common.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lU1m0 = parcelRequire("lU1m0");

var $bL3dk = parcelRequire("bL3dk");
var $cPbpX = parcelRequire("cPbpX");
var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");

var $a9cht = parcelRequire("a9cht");

var $3SOCn = parcelRequire("3SOCn");

var $hUlSA = parcelRequire("hUlSA");
const $06b71c6e3e5de02d$export$9b8813c3601640da = ({ users: users, onSubmit: onSubmit, onDismiss: onDismiss, onOptoutAndDismiss: onOptoutAndDismiss, onSnoozeAndDismiss: onSnoozeAndDismiss, messages: messages, avatarOrientation: avatarOrientation, featureVisitedCount: featureVisitedCount, ...props })=>{
    const handleOnSubmit = (0, $eJOHy.useCallback)(async ()=>{
        await onSubmit();
    }, [
        onSubmit
    ]);
    const customFlagFooterProps = (0, $eJOHy.useMemo)(()=>({
            // Workaround to achieve primary button + avatars in the footer.
            //
            // How this works:
            // We pass a dummy `action` that gets displayed in the Flag's footer
            // by the custom `linkComponent`. The component displays our actual footer.
            // This way, we don't occupy the limited space inside `description`.
            //
            // Why not use `actions` normally?
            // Because our Avatar Group is not an action, and even our Submit button
            // should be bold & blue (appearance="primary") which is not supported
            // by the AK Flag.
            //
            // Why not put this in `description`?
            // Because that one has a max height equivalent to 5 lines of text,
            // and our footer is taller than 2, causing an unwanted scrollbar
            // to show.
            actions: [
                {
                    content: '',
                    onClick: (0, $3SOCn.noop)
                }
            ],
            linkComponent: ()=>{
                let secondETA = null;
                if (featureVisitedCount === 1) secondETA = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cPbpX.default), {
                    xcss: $06b71c6e3e5de02d$var$linkButtonStyles,
                    onClick: onSnoozeAndDismiss
                }, messages.remindMeLaterButton);
                else if (featureVisitedCount > 1) secondETA = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cPbpX.default), {
                    xcss: $06b71c6e3e5de02d$var$linkButtonStyles,
                    onClick: onOptoutAndDismiss
                }, messages.notInterestedButton);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
                    alignInline: "start",
                    grow: "fill",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cPbpX.default), {
                    xcss: $06b71c6e3e5de02d$var$linkButtonStyles,
                    onClick: handleOnSubmit
                }, messages.joinButton), !!secondETA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
                    className: (0, $hcewu.default)([
                        "_1kt95qml _fntnutpp _eid3utpp"
                    ])
                }), secondETA);
            }
        }), [
        featureVisitedCount,
        handleOnSubmit,
        messages,
        onSnoozeAndDismiss,
        onOptoutAndDismiss
    ]);
    const customIcon = (0, $eJOHy.useMemo)(()=>{
        return users.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hUlSA.FlagCompatibleAvatarGroup), {
            alignment: avatarOrientation,
            maxAvatarCount: 2,
            tooltipPosition: "bottom",
            data: users.map((user)=>({
                    name: user.name,
                    src: user.avatar,
                    appearance: 'circle'
                })),
            size: "small",
            boundariesElement: "scrollParent"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lU1m0))), {
            spacing: "spacious",
            color: "var(--ds-icon-information, #1D7AFC)",
            label: ""
        });
    }, [
        users,
        avatarOrientation
    ]);
    const FLAG_MESSAGE_TYPE = 'marketing';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.InfoFlag), {
        ...props,
        ...customFlagFooterProps,
        onDismissed: featureVisitedCount === 0 ? onDismiss : onSnoozeAndDismiss,
        title: messages.title,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", {
            className: (0, $hcewu.default)([
                "_1reoewfl _18m9ewfl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0ccj1k _sudp1e54 _otyru2gc"
            ])
        }, messages.description)),
        icon: customIcon,
        messageType: FLAG_MESSAGE_TYPE,
        messageId: "cross-join-nudges.ui.request-access-prompt-flag.info-flag.request-access-prompt-flag"
    });
};
const $06b71c6e3e5de02d$var$linkButtonStyles = (0, $5Wv5g.xcss)({
    maxWidth: '150',
    maxHeight: '3lh',
    overflow: 'hidden',
    color: 'color.link',
    backgroundColor: 'color.background.neutral.subtle',
    borderWidth: '0',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    cursor: 'pointer',
    padding: '0',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $06b71c6e3e5de02d$var$linkButtonSeparatorStyles = null;
const $06b71c6e3e5de02d$var$mainContentContainerStyles = null;

});
parcelRegister("3SOCn", function(module, exports) {

$parcel$export(module.exports, "noop", () => $4339374a2a8f4e6a$export$8793edee2d425525);
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $4339374a2a8f4e6a$export$8793edee2d425525 = ()=>{};

});

parcelRegister("hUlSA", function(module, exports) {

$parcel$export(module.exports, "FlagCompatibleAvatarGroup", () => $a339e7e80c202910$export$29beada2d5f93289);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $hoFhq = parcelRequire("hoFhq");

var $ciKIV = parcelRequire("ciKIV");

var $3SOCn = parcelRequire("3SOCn");
const $a339e7e80c202910$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED = 99;
const $a339e7e80c202910$var$OVERFLOW_USER_MARKER = '$$$overflow-user-marker';
const $a339e7e80c202910$export$29beada2d5f93289 = ({ alignment: alignment, maxAvatarCount: maxAvatarCount, tooltipPosition: tooltipPosition, data: data, ...props })=>{
    const { data: customData, overrides: customOverrides } = (0, $eJOHy.useMemo)(()=>$a339e7e80c202910$export$bc55c1ff86d63c4d({
            data: data,
            maxAvatarCount: maxAvatarCount
        }), [
        data,
        maxAvatarCount
    ]);
    const avatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ciKIV.default), {
        maxCount: maxAvatarCount,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ // @ts-ignore
        tooltipPosition: tooltipPosition,
        onMoreClick: (0, $3SOCn.noop),
        ...props
    });
    if (alignment === 'vertical') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a339e7e80c202910$var$VerticalAvatarGroupContainer, null, avatarGroup);
    return avatarGroup;
};
const $a339e7e80c202910$export$bc55c1ff86d63c4d = ({ data: users, maxAvatarCount: maxAvatarCount })=>{
    const overflows = users.length > maxAvatarCount;
    const lastFeaturedUser = maxAvatarCount - 1;
    const featuredUsers = users.slice(0, lastFeaturedUser);
    const overflowUsers = users.slice(lastFeaturedUser);
    const overflowMarkerDummyUser = $a339e7e80c202910$export$1b8d8867a2d1ffbd(overflowUsers);
    const processedUsers = overflows ? [
        ...featuredUsers,
        overflowMarkerDummyUser
    ] : users;
    const overrides = {
        Avatar: {
            render: (AvatarComponent, avatarProps)=>{
                if (avatarProps.name === overflowMarkerDummyUser.name && avatarProps.key === overflowMarkerDummyUser.key) return $a339e7e80c202910$var$renderAvatarWithOverflowCount(AvatarComponent, avatarProps, overflowUsers.length);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AvatarComponent, avatarProps);
            }
        }
    };
    return {
        overrides: overrides,
        data: processedUsers
    };
};
const $a339e7e80c202910$export$1b8d8867a2d1ffbd = (overflowUsers)=>({
        name: overflowUsers.map((u)=>u.name).join(', '),
        key: $a339e7e80c202910$var$OVERFLOW_USER_MARKER
    });
const $a339e7e80c202910$var$renderAvatarWithOverflowCount = (AvatarComponent, avatarProps, overflowCount)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AvatarComponent, {
        name: avatarProps.name,
        appearance: avatarProps.appearance,
        size: avatarProps.size,
        borderColor: avatarProps.borderColor,
        stackIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hoFhq.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a339e7e80c202910$var$AvatarOverflowCountContainer, null, `+${Math.min(overflowCount, $a339e7e80c202910$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED)}`)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a339e7e80c202910$var$AvatarOverflowCountContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _6a6z1h6o _1bsb1osq _4t3i1osq _1e0c11p5 _bfhkm7j4 _syaz1fxt _y3gn1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
});
const $a339e7e80c202910$var$VerticalAvatarGroupContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ogvv1bp4 _3mc9idpf _1hlaidpf _1qu0x0bf",
            __cmplp.className
        ])
    });
});

});



parcelRegister("5Ilbg", function(module, exports) {

$parcel$export(module.exports, "useRequestAccessSuccessFlag", () => $d17f1500a13d668e$export$184b02cbba392fc0);

var $eJOHy = parcelRequire("eJOHy");

var $90d5q = parcelRequire("90d5q");
var $a9cht = parcelRequire("a9cht");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $csiXm = parcelRequire("csiXm");

var $b4yA6 = parcelRequire("b4yA6");
const $d17f1500a13d668e$export$184b02cbba392fc0 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagService)();
    return (0, $eJOHy.useCallback)(()=>{
        const id = `success-${(0, $csiXm.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $90d5q.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d17f1500a13d668e$export$567128fc1024c9cf, {
                    ...props,
                    id: id,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $d17f1500a13d668e$export$567128fc1024c9cf = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.SuccessFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $b4yA6.messages).title),
        // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $b4yA6.messages).description))
    });
};

});
parcelRegister("b4yA6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1a8ff2ae59932fa6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1a8ff2ae59932fa6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "cross-join-nudges.request-access-success-flag.title",
        "defaultMessage": "A request was sent to your admins"
    },
    description: {
        "id": "cross-join-nudges.request-access-success-flag.description",
        "defaultMessage": "You'll receive an email once they've reviewed it."
    }
});

});



parcelRegister("lnwEo", function(module, exports) {

$parcel$export(module.exports, "useConfluenceCrossJoinNudge", () => $b19d5fb78027e87b$export$83876d794dc56d4f);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $83DiZ = parcelRequire("83DiZ");

var $epTsa = parcelRequire("epTsa");

var $2UBs9 = parcelRequire("2UBs9");

var $kEanc = parcelRequire("kEanc");

var $2cfd4 = parcelRequire("2cfd4");

var $iaIqW = parcelRequire("iaIqW");

var $8Ujbi = parcelRequire("8Ujbi");

var $ljWHg = parcelRequire("ljWHg");

var $cYLBX = parcelRequire("cYLBX");

var $2G4e8 = parcelRequire("2G4e8");

var $d2DJQ = parcelRequire("d2DJQ");

var $dK92f = parcelRequire("dK92f");

var $aruII = parcelRequire("aruII");

var $blDud = parcelRequire("blDud");

var $5Ilbg = parcelRequire("5Ilbg");
const $b19d5fb78027e87b$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS = 5;
const $b19d5fb78027e87b$export$83876d794dc56d4f = ()=>{
    const sessionId = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    const getNudgeRecommendations = (0, $d2DJQ.useNudgeRecommendations)({
        sessionId: sessionId.current
    });
    const cloudId = (0, $kEUB1.useCloudId)();
    const getFilteredCollaborators = (0, $cYLBX.useFilteredUsersFromCollaborationGraph)(cloudId, 'confluence', $b19d5fb78027e87b$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS);
    const showRequestAccessPromptFlag = (0, $blDud.useRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $5Ilbg.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $aruII.useRequestAccessErrorFlag)();
    const { setNudgeDismissed: setNudgeDismissedV2a } = (0, $2G4e8.useNudgeStateV2a)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const userId = (0, $8q7lT.useAccountId)() || '';
    const locale = (0, $2cfd4.useLocale)();
    const requestAccessService = (0, $7jTnu.fg)('expansion_services_in_cjn') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2UBs9.useService)((0, $kEanc.requestAccess)) : null;
    return (0, $eJOHy.useCallback)(async ({ featureVisitedCount: featureVisitedCount }, allowLlm = true)=>{
        const startTimestamp = Date.now();
        try {
            async function onSubmit() {
                try {
                    try {
                        let accessStatus;
                        if (requestAccessService && (0, $7jTnu.fg)('expansion_services_in_cjn')) {
                            const serviceResult = await requestAccessService({
                                product: 'confluence',
                                integration: 'crossJoinNudgesConfluence'
                            });
                            if (serviceResult.error) {
                                (0, $8Ujbi.fireErrorAnalytics)('crossJoinNudgesConfluence', serviceResult.error);
                                throw serviceResult.error;
                            }
                            accessStatus = serviceResult.result;
                        } else accessStatus = await (0, $iaIqW.requestAccess)('confluence', cloudId, userId, 'crossJoinNudgesConfluence', createAnalyticsEvent);
                        if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/wiki');
                        else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                        else showErrorFlag('confluence');
                    } catch  {
                        showErrorFlag('confluence');
                    }
                } catch  {
                    showErrorFlag('confluence');
                }
            }
            const isEnglishLocale = locale && locale.startsWith('en');
            const collaborators = await getFilteredCollaborators();
            const hasNoCollaborators = collaborators.length === 0;
            const cachedLlmNewUser = (0, $ljWHg.withEligibilityCache)('user_new_for_llm_exp', ()=>Promise.resolve(featureVisitedCount === 0));
            const userNeverSawConfNudgeBeforeLlmExp = await cachedLlmNewUser();
            if ((0, $7jTnu.fg)('grw-1755-growth-exp-jira-cjn-llm-gate')) {
                if (allowLlm && isEnglishLocale && hasNoCollaborators && userNeverSawConfNudgeBeforeLlmExp === true) {
                    /**
						 * In order to avoid an experiment bias for grw-1755-growth-exp-jira-cjn-llm we need to
						 * pregenerate content and return early for all cohorts if content isn't available
						 * https://atlassian.slack.com/archives/C08RDQB03EJ/p1755151418360249?thread_ts=1755147153.025819&cid=C08RDQB03EJ
						 */ const result = await (0, $dK92f.generateCJNContent)();
                    if (!result.ready) {
                        (0, $ljWHg.removeFeatureVisited)('crossJoinNudgesConfluence');
                        return;
                    }
                    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
                        flagKey: 'grw-1755-growth-exp-jira-cjn-llm',
                        enrolment: (0, $epTsa.expVal)('grw-1755-growth-exp-jira-cjn-llm', 'cohort', 'not_enrolled')
                    });
                    if ((0, $epTsa.expValEquals)('grw-1755-growth-exp-jira-cjn-llm', 'cohort', 'Variation')) {
                        showRequestAccessPromptFlag({
                            users: collaborators,
                            onSubmit: onSubmit,
                            onOptout: setNudgeDismissedV2a,
                            snoozeFor30Days: ()=>(0, $ljWHg.snoozeFeatureFor30Days)('crossJoinNudgesConfluence'),
                            integration: 'crossJoinNudgesConfluence',
                            featureVisitedCount: featureVisitedCount,
                            messageParser: (0, $blDud.getLLMCJNMessageParser)({
                                title: result.title,
                                description: result.body
                            }),
                            eventAttributes: (0, $blDud.getLLMAnalyticsAttributes)({
                                users: collaborators,
                                userId: userId,
                                sessionId: sessionId.current,
                                featureVisitedCount: featureVisitedCount,
                                startTimestamp: startTimestamp,
                                companyName: result.metadata.companyName,
                                firstName: result.metadata.firstName,
                                generatedBody: result.body,
                                generatedTitle: result.title
                            })
                        });
                        await Promise.all([
                            (0, $ljWHg.increaseFeatureVisitedCount)(userId, featureVisitedCount + 1),
                            (0, $ljWHg.cjnEligibilityCacheHandler).set('has_seen_conf', {
                                value: true
                            }),
                            (0, $ljWHg.cjnEligibilityCacheHandler).set('has_seen_conf_llm', {
                                value: true
                            })
                        ]);
                        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'slo.crossJoinNudgesConfluence succeeded');
                        return;
                    }
                }
            }
            const entityId = hasNoCollaborators ? await getNudgeRecommendations() : undefined;
            showRequestAccessPromptFlag({
                users: collaborators,
                onSubmit: onSubmit,
                onOptout: setNudgeDismissedV2a,
                snoozeFor30Days: ()=>(0, $ljWHg.snoozeFeatureFor30Days)('crossJoinNudgesConfluence'),
                integration: 'crossJoinNudgesConfluence',
                featureVisitedCount: featureVisitedCount,
                messageParser: (0, $blDud.getContextualBanditCJNMessageParser)({
                    isContextualBandit: hasNoCollaborators,
                    entityId: entityId || 'default',
                    featureVisitedCount: featureVisitedCount
                }),
                eventAttributes: (0, $blDud.getContextualBanditAnalyticsAttributes)({
                    users: collaborators,
                    userId: userId,
                    entityId: entityId || 'default',
                    sessionId: sessionId.current,
                    isContextualBandit: hasNoCollaborators,
                    featureVisitedCount: featureVisitedCount,
                    startTimestamp: startTimestamp
                })
            });
            await Promise.all([
                (0, $ljWHg.increaseFeatureVisitedCount)(userId, featureVisitedCount + 1),
                (0, $ljWHg.cjnEligibilityCacheHandler).set('has_seen_conf', {
                    value: true
                })
            ]);
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'slo.crossJoinNudgesConfluence succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('useCrossJoinNudges', error, {
                cloudId: cloudId
            });
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        getFilteredCollaborators,
        getNudgeRecommendations,
        locale,
        push,
        requestAccessService,
        setNudgeDismissedV2a,
        showErrorFlag,
        showRequestAccessPromptFlag,
        showSuccessFlag,
        userId
    ]);
};

});

parcelRegister("cGeZ5", function(module, exports) {

$parcel$export(module.exports, "getHasBeenEnrolledInMsr", () => $a6ece8b7d2b0cc00$export$a03fea1e8104a2a4);
$parcel$export(module.exports, "setEnrolledInMsr", () => $a6ece8b7d2b0cc00$export$31ce9592444f963b);

var $ljWHg = parcelRequire("ljWHg");
const $a6ece8b7d2b0cc00$export$a03fea1e8104a2a4 = ()=>{
    const cachedHasEnrolledMsr = (0, $ljWHg.withEligibilityCache)('has_enrolled_msr', async ()=>{
        // The first time this is accessed without being set, it will be set false
        return false;
    });
    return cachedHasEnrolledMsr();
};
const $a6ece8b7d2b0cc00$export$31ce9592444f963b = ()=>{
    return (0, $ljWHg.cjnEligibilityCacheHandler).set('has_enrolled_msr', {
        value: true
    });
};

});

parcelRegister("b66qx", function(module, exports) {

$parcel$export(module.exports, "useHasSeenNudgesBefore", () => $1b4c7c805d728733$export$550b3148800324ae);

var $eJOHy = parcelRequire("eJOHy");

var $8q7lT = parcelRequire("8q7lT");

var $ljWHg = parcelRequire("ljWHg");
const $1b4c7c805d728733$export$550b3148800324ae = ()=>{
    const userId = (0, $8q7lT.useAccountId)() || '';
    return (0, $eJOHy.useCallback)(async ()=>{
        function hasSeenJpdNudge() {
            const cachedHasSeenJpd = (0, $ljWHg.withEligibilityCache)('has_seen_jpd', async ()=>{
                const count = await (0, $ljWHg.getFeatureVisitedCount)(userId, (0, $ljWHg.getCountCacheKey)('crossJoinNudgesJiraToJpd'));
                return count > 0;
            });
            return cachedHasSeenJpd();
        }
        function hasSeenConfluenceNudge() {
            const cachedHasSeenConf = (0, $ljWHg.withEligibilityCache)('has_seen_conf', async ()=>{
                const count = await (0, $ljWHg.getFeatureVisitedCount)(userId, (0, $ljWHg.getCountCacheKey)('crossJoinNudgesConfluence'));
                return count > 0;
            });
            return cachedHasSeenConf();
        }
        const hasSeenConfluence = hasSeenConfluenceNudge();
        const hasSeenJpd = hasSeenJpdNudge();
        const hasSeenOtherNudges = await Promise.all([
            hasSeenConfluence,
            hasSeenJpd
        ]);
        return hasSeenOtherNudges.some((check)=>check);
    }, [
        userId
    ]);
};

});


parcelRegister("a8idd", function(module, exports) {

$parcel$export(module.exports, "SafeRovoPanelSidebar", () => $d37decb99e95b354$export$93b3f27ddebdc4f3);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $dfP3D = parcelRequire("dfP3D");

var $9bGDL = parcelRequire("9bGDL");

var $9PuSc = parcelRequire("9PuSc");
const $d37decb99e95b354$var$JIRA_ISSUE_ROVO_AI_CONTAINER_ID = 'jira-issue-rovo-ai-container';
const $d37decb99e95b354$var$RovoPanelSidebar = ()=>{
    const { closePanel: closePanel } = (0, $9PuSc.useSidebarApiObject)();
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    if (rightSidebarCurrentState?.panelId !== $d37decb99e95b354$var$JIRA_ISSUE_ROVO_AI_CONTAINER_ID) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9bGDL.AsyncAiRovoPanel), {
        onClosePanel: closePanel
    });
};
const $d37decb99e95b354$export$93b3f27ddebdc4f3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-issue-rovo-side-panel",
        packageName: "jiraIssueRovoSidePanel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d37decb99e95b354$var$RovoPanelSidebar, null));

});
parcelRegister("9bGDL", function(module, exports) {

$parcel$export(module.exports, "AsyncAiRovoPanel", () => $593213892901032f$export$8d699c2969060ba3);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $d8qKQ = parcelRequire("d8qKQ");
const $593213892901032f$var$entrypointParams = {};
const $593213892901032f$export$8d699c2969060ba3 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $d8qKQ.aiRovoPanelEntryPoint), $593213892901032f$var$entrypointParams);
    /*
		Handle the loading of the panel module when the button clicked. The preload
		has already been done as part of the trigger AiRovoButton
	*/ // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const { onClosePanel: onClosePanel } = props;
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            onClosePanel: onClosePanel
        }), [
        onClosePanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jiraIssueAiRovoPanelEntryPoint",
        packageName: "jira-issue-ai-rovo-panel",
        teamName: "gravity-ai",
        fallback: null,
        runtimeProps: runtimeProps
    });
};

});
parcelRegister("d8qKQ", function(module, exports) {

$parcel$export(module.exports, "aiRovoPanelEntryPoint", () => $fd3399f1928b5793$export$7a19c022e3c20af3);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $fd3399f1928b5793$export$7a19c022e3c20af3 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("XRdBk")).then((module)=>module.AiRovoPanelEntryPointComponent), {
        moduleId: "002341ee",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("XRdBk", function(module, exports) {

let $0b3ecadcfb45dc42$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $0b3ecadcfb45dc42$var$load("1VRB2"),
    $0b3ecadcfb45dc42$var$load("bABhq"),
    $0b3ecadcfb45dc42$var$load("eDzss"),
    $0b3ecadcfb45dc42$var$load("7vqGd"),
    $0b3ecadcfb45dc42$var$load("1Y4bq"),
    $0b3ecadcfb45dc42$var$load("jFCO1")
]).then(()=>parcelRequire('3J4eP'));

});



parcelRegister("9PuSc", function(module, exports) {

$parcel$export(module.exports, "useSidebarApiObject", () => $d9d49cebee7993ad$export$11e1b622a0c58b7a);

var $eJOHy = parcelRequire("eJOHy");

var $dfP3D = parcelRequire("dfP3D");
const $d9d49cebee7993ad$export$afb7bfe33aacaa2d = 'jira-issue-rovo-ai-container';
const $d9d49cebee7993ad$export$fbdf13058c11cad7 = 400; // px
function $d9d49cebee7993ad$export$11e1b622a0c58b7a() {
    const { openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const { panelId: panelId, isCollapsed: isCollapsed } = (0, $dfP3D.useActiveRightSidebarState)() || {};
    const isActive = panelId === $d9d49cebee7993ad$export$afb7bfe33aacaa2d && !isCollapsed;
    const isOtherPanelActive = panelId !== $d9d49cebee7993ad$export$afb7bfe33aacaa2d && !isCollapsed;
    const openPanel = (0, $eJOHy.useCallback)(()=>{
        isOtherPanelActive && closeCurrentRightSidebar();
        openRightSidebar($d9d49cebee7993ad$export$afb7bfe33aacaa2d, $d9d49cebee7993ad$export$fbdf13058c11cad7);
    }, [
        closeCurrentRightSidebar,
        isOtherPanelActive,
        openRightSidebar
    ]);
    const closePanel = (0, $eJOHy.useCallback)(()=>{
        closeRightSidebar($d9d49cebee7993ad$export$afb7bfe33aacaa2d);
    }, [
        closeRightSidebar
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            isPanelOpen: ()=>isActive,
            openPanel: openPanel,
            closePanel: closePanel
        }), [
        isActive,
        openPanel,
        closePanel
    ]);
}

});


parcelRegister("41vjk", function(module, exports) {

$parcel$export(module.exports, "AsyncSSRFailureDisplay", () => $7d4b7128b78443ac$export$ce3da1faaf6198d1);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $bbdV2 = parcelRequire("bbdV2");

var $cBavF = parcelRequire("cBavF");

var $2JDwW = parcelRequire("2JDwW");
const $7d4b7128b78443ac$var$EMPTY_OBJECT = {};
const $7d4b7128b78443ac$var$LoadEntryPoint = ()=>{
    const hasLoadedEntryPoint = (0, $eJOHy.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $2JDwW.ssrFailureDisplayEntryPoint), $7d4b7128b78443ac$var$EMPTY_OBJECT);
    // Docs say to do this not in an effect :/ https://hello.atlassian.net/wiki/spaces/UAF/pages/2333138515/Deprecated+Tutorial+How+to+render+your+EntryPoint+for+async+components#Option-3%3A-Using-useRef-without-user-interaction
    // And they have eslint rules to enforce it
    if (!hasLoadedEntryPoint.current) {
        hasLoadedEntryPoint.current = true;
        entryPointActions.load();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "ssr-failure-display",
        packageName: "@atlassian/jira-ssr-render-guard",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $7d4b7128b78443ac$var$EMPTY_OBJECT
    });
};
const $7d4b7128b78443ac$export$ce3da1faaf6198d1 = ()=>{
    if (!(0, $7jTnu.fg)('staging-only-show-ssr-error')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7d4b7128b78443ac$var$LoadEntryPoint, null);
};
$7d4b7128b78443ac$export$ce3da1faaf6198d1.displayName = 'AsyncSSRFailureDisplay';

});
parcelRegister("2JDwW", function(module, exports) {

$parcel$export(module.exports, "ssrFailureDisplayEntryPoint", () => $0c786d303caf8346$export$3e34e661c7d77f3e);

var $j3Ybe = parcelRequire("j3Ybe");

var $4BK1O = parcelRequire("4BK1O");

const $0c786d303caf8346$export$3e34e661c7d77f3e = (0, $4BK1O.createEntryPoint)({
    // eslint-disable-next-line jira/jira-ssr/wrong-entrypoint-usage
    root: (0, $j3Ybe.JSResourceForUserVisible)(()=>(parcelRequire("anLcP")).then((module)=>module.SSRFailureDisplay), {
        moduleId: "3b05423d",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("anLcP", function(module, exports) {

let $78f0ab7876e27a3d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $78f0ab7876e27a3d$var$load("b0eiE").then(()=>parcelRequire('jqi1P'));

});



parcelRegister("6Yzhs", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbAdapter", () => $5c0bddfcda9f792c$export$2255367d5c9162b3);

var $eJOHy = parcelRequire("eJOHy");

var $aD6E2 = parcelRequire("aD6E2");
function $5c0bddfcda9f792c$export$2255367d5c9162b3() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aD6E2.default), null);
}

});
parcelRegister("aD6E2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2abfbd012269b86$export$2e2bcd8739ae039);

var $2QUmO = parcelRequire("2QUmO");

var $2lb3i = parcelRequire("2lb3i");

var $ad5bB = parcelRequire("ad5bB");

var $iiaiu = parcelRequire("iiaiu");

var $cpZiR = parcelRequire("cpZiR");

var $9CWi2 = parcelRequire("9CWi2");
var $f2abfbd012269b86$export$2e2bcd8739ae039 = (0, $2QUmO.default)((0, $2lb3i.default), {
    LegacyApiBridge: // @ts-expect-error - Type 'FunctionComponent<Omit<PropsWithDefault, keyof AnalyticsEvents>>' is not assignable to type 'ComponentType<Props> | undefined'.
    $ad5bB.default,
    LegacyBreadcrumbConnector: $iiaiu.default,
    LegacyBreadcrumbState: // @ts-expect-error - TS2322 - Type 'typeof LegacyBreadcrumbState' is not assignable to type 'ComponentType<LegacyBreadcrumbStateProviderProps> | undefined'.
    $9CWi2.default,
    LegacyBreadcrumbRenderer: $cpZiR.default
});

});
parcelRegister("2QUmO", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $602ff2c1b8bdf3ea$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $602ff2c1b8bdf3ea$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $602ff2c1b8bdf3ea$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $602ff2c1b8bdf3ea$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$602ff2c1b8bdf3ea$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $602ff2c1b8bdf3ea$export$2e2bcd8739ae039 = $602ff2c1b8bdf3ea$var$withInjectedProps;

});

parcelRegister("2lb3i", function(module, exports) {

$parcel$export(module.exports, "default", () => $258e6bab6cebbb40$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $BwaQq = parcelRequire("BwaQq");

var $h47gY = parcelRequire("h47gY");

const $258e6bab6cebbb40$var$LegacyBreadcrumbAdapter = ({ LegacyBreadcrumbRenderer: LegacyBreadcrumbRenderer, LegacyBreadcrumbState: LegacyBreadcrumbState, LegacyApiBridge: LegacyApiBridge, LegacyBreadcrumbConnector: LegacyBreadcrumbConnector })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(LegacyBreadcrumbState, null, ({ api: api, state: state })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(LegacyApiBridge, {
            onInsertItem: api.insertItem,
            onRemoveItem: api.removeItem,
            onSetRenderTarget: api.setTargetElement
        }), // Only activate the breadcrumb connector if there is a breadcrumb render target
        state.targetElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
            id: "legacy-breadcrumb-adapter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(LegacyBreadcrumbConnector, {
            legacyTrail: state.trail
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(LegacyBreadcrumbRenderer, {
            targetElement: state.targetElement
        }))));
var $258e6bab6cebbb40$export$2e2bcd8739ae039 = (0, $BwaQq.AnalyticsSource)('legacyBreadcrumbs', (0, $466f60259c330878$export$f636b5b56f1d624a))($258e6bab6cebbb40$var$LegacyBreadcrumbAdapter);

});

parcelRegister("ad5bB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a2a6224131035ea$export$2e2bcd8739ae039);

var $aKfba = parcelRequire("aKfba");

var $2QUmO = parcelRequire("2QUmO");

var $lPFaz = parcelRequire("lPFaz");
const $7a2a6224131035ea$var$analyticsEvents = {
    onInsertItemFired: (analyticsEvent)=>(0, $aKfba.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'insertItem'
            }
        }),
    onRemoveItemFired: (analyticsEvent)=>(0, $aKfba.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'removeItem'
            }
        }),
    onSetRenderTargetFired: (analyticsEvent)=>(0, $aKfba.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'render'
            }
        }),
    onOnBreadCrumbsUpdateFired: (analyticsEvent)=>(0, $aKfba.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'onBreadCrumbsUpdate'
            }
        })
};
var $7a2a6224131035ea$export$2e2bcd8739ae039 = (0, $2QUmO.default)((0, $lPFaz.default), $7a2a6224131035ea$var$analyticsEvents);

});
parcelRegister("aKfba", function(module, exports) {

$parcel$export(module.exports, "fireOperationalAnalytics", () => $6f5cebdfb2ef1a38$export$79f423cc3fd39762);

var $9pL9Y = parcelRequire("9pL9Y");

var $gYnSx = parcelRequire("gYnSx");

var $iM63C = parcelRequire("iM63C");

var $5nSuO = parcelRequire("5nSuO");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $6f5cebdfb2ef1a38$var$isNotUndefined = (a)=>a !== undefined;
const $6f5cebdfb2ef1a38$var$mapPayload = (payload)=>{
    const context = (0, $5nSuO.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $6f5cebdfb2ef1a38$var$isNotUndefined);
};
const $6f5cebdfb2ef1a38$export$79f423cc3fd39762 = (event, payload)=>{
    // Causes issues with mounting the src/packages/confluence/project-pages/src/view/examples.js component in storybook tests.
    // This is due to node_modules/@atlassiansox/analytics-web-client/dist/analytics-web-client.with-deps.js producing a reference error with the normalize function
    // This is possibly due to some scope hoisting issue with jest that is not present in the browser
    try {
        event.update({
            ...$6f5cebdfb2ef1a38$var$mapPayload(payload),
            analyticsType: (0, $iM63C.OPERATIONAL_EVENT_TYPE)
        }).fire();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gYnSx.default)({
            event: event,
            error: e,
            meta: {
                id: 'fireOperationalAnalytics',
                packageName: 'jiraAnalyticsWebReact',
                teamName: 'legacy-jfp-team-do-not-use'
            }
        });
    }
};

});
parcelRegister("5nSuO", function(module, exports) {

$parcel$export(module.exports, "default", () => $fff538d0ffacbfcb$export$2e2bcd8739ae039);

var $6dPbw = parcelRequire("6dPbw");

var $4lYQk = parcelRequire("4lYQk");
var // AnalyticsDataPayload is cast to inexact type so that it can also accept subtypes
// eslint-disable-next-line jira/import/no-anonymous-default-export
$fff538d0ffacbfcb$export$2e2bcd8739ae039 = (payload)=>{
    const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
        tags: tags,
        containerId: containerId,
        containers: containers,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw))));
};

});


parcelRegister("lPFaz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8270f6571ddd31$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7kixv = parcelRequire("7kixv");
parcelRequire("1AyD5");

var $aBFKZ = parcelRequire("aBFKZ");

var $9GRvA = parcelRequire("9GRvA");
// eslint-disable-next-line jira/react/no-class-components
class $9c8270f6571ddd31$var$LegacyApiBridge extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { onInsertItem: onInsertItem, onRemoveItem: onRemoveItem, onSetRenderTarget: onSetRenderTarget, onBreadCrumbsUpdate: onBreadCrumbsUpdate } = this;
        (0, $9GRvA.default)({
            insertItem: onInsertItem,
            removeItem: onRemoveItem,
            render: onSetRenderTarget,
            onBreadCrumbsUpdate: onBreadCrumbsUpdate
        });
    }
    /* eslint-enable jira/react-no-unneeded-arrow-function-properties */ render() {
        return null;
    }
    constructor(...args){
        super(...args), /* eslint-disable jira/react-no-unneeded-arrow-function-properties */ this.onInsertItem = (item)=>{
            const { onInsertItem: onInsertItem, onInsertItemFired: onInsertItemFired } = this.props;
            onInsertItemFired();
            onInsertItem(item);
        }, this.onRemoveItem = (itemId)=>{
            const { onRemoveItem: onRemoveItem, onRemoveItemFired: onRemoveItemFired } = this.props;
            onRemoveItemFired();
            onRemoveItem(itemId);
        }, this.onSetRenderTarget = (element)=>{
            const { onSetRenderTarget: onSetRenderTarget, onSetRenderTargetFired: onSetRenderTargetFired } = this.props;
            onSetRenderTargetFired();
            onSetRenderTarget(element);
        }, this.onBreadCrumbsUpdate = ()=>{
            const { onOnBreadCrumbsUpdateFired: onOnBreadCrumbsUpdateFired } = this.props;
            onOnBreadCrumbsUpdateFired();
            return (0, $7kixv.Observable).empty();
        };
    }
}
var $9c8270f6571ddd31$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('legacyApiBridge', {
    onInsertItemFired: 'apiMethodCalled',
    onRemoveItemFired: 'apiMethodCalled',
    onSetRenderTargetFired: 'apiMethodCalled',
    onOnBreadCrumbsUpdateFired: 'apiMethodCalled'
})($9c8270f6571ddd31$var$LegacyApiBridge);

});
parcelRegister("9GRvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f05a97f8287ffc0$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");

var $eSnSE = parcelRequire("eSnSE");

var $7jTnu = parcelRequire("7jTnu");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5f05a97f8287ffc0$export$2e2bcd8739ae039 = (legacyAPI)=>{
    if ((0, $7jTnu.fg)('firefox_issue_view_memory_leak_v1')) // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $4T9yL.waitForHeritage)()?.then(()=>// eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $97BGz.loadBridgeStrict)({
            name: 'jira/globalnavigator/breadcrumbs/bridge',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-atlaskit-plugin:breadcrumbs'
            ]
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(legacyAPI);
        }).catch((err)=>(0, $eSnSE.default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString())));
    // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $iyT45.loadBridgeWeak)({
        name: 'jira/globalnavigator/breadcrumbs/bridge'
    }).then((bridge)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        bridge(legacyAPI);
    }).catch((err)=>(0, $eSnSE.default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString()));
};

});



parcelRegister("iiaiu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a462245b40551ea$export$2e2bcd8739ae039);

var $2QUmO = parcelRequire("2QUmO");

var $6T1wD = parcelRequire("6T1wD");

var $jATfF = parcelRequire("jATfF");

var $gFB4g = parcelRequire("gFB4g");

var $4nWs2 = parcelRequire("4nWs2");

var $dnzxN = parcelRequire("dnzxN");

var $h0N9h = parcelRequire("h0N9h");
var $1a462245b40551ea$export$2e2bcd8739ae039 = (0, $2QUmO.default)((0, $dnzxN.default), {
    Breadcrumb: $6T1wD.default,
    ProjectBreadcrumb: $gFB4g.default,
    BoardBreadcrumb: // @ts-expect-error - TS2322 - Type '{ ({  children, boardId, boardName, isSimplifiedProject, projectId, }: BoardBreadcrumbProps): JSX.Element; defaultProps: { children: null; isSimplifiedProject: boolean; projectId: undefined; }; }' is not assignable to type 'ComponentType<Partial<BoardBreadcrumbProps>> | undefined'.
    $jATfF.default,
    UserBreadcrumb: $4nWs2.default,
    ContextProvider: $h0N9h.default
});

});
parcelRegister("6T1wD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6260e98de9a16198$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $aXKmr = parcelRequire("aXKmr");

var $ifPW4 = parcelRequire("ifPW4");
// eslint-disable-next-line jira/react/no-class-components
class $6260e98de9a16198$var$BreadcrumbOps extends (0, $eJOHy.Component) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props), this.id = '';
        this.id = (0, $aXKmr.v4)();
        if (false) this.onPushBreadcrumb();
    }
    componentDidMount() {
        this.onPushBreadcrumb();
    }
    componentDidUpdate(prevProps) {
        const { breadcrumb: prevBreadcrumb } = prevProps;
        const { api: api, breadcrumb: breadcrumb } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevBreadcrumb, breadcrumb)) api.updateBreadcrumb({
            id: this.id,
            ...breadcrumb
        });
    }
    componentWillUnmount() {
        const { api: api } = this.props;
        api.popBreadcrumb();
    }
    onPushBreadcrumb() {
        const { api: api, breadcrumb: breadcrumb } = this.props;
        api.pushBreadcrumb({
            id: this.id,
            ...breadcrumb
        });
    }
    render() {
        return null;
    }
}
const $6260e98de9a16198$var$Breadcrumb = ({ breadcrumb: breadcrumb, children: children })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ifPW4.BreadcrumbActions), null, (__, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6260e98de9a16198$var$BreadcrumbOps, {
            api: actions,
            breadcrumb: breadcrumb
        }), children));
$6260e98de9a16198$var$Breadcrumb.defaultProps = {
    children: null
};
var $6260e98de9a16198$export$2e2bcd8739ae039 = $6260e98de9a16198$var$Breadcrumb;

});
parcelRegister("ifPW4", function(module, exports) {

$parcel$export(module.exports, "useBreadcrumbs", () => $8a41e5f96d7bfaa5$export$8cefe241bd876ca0);
$parcel$export(module.exports, "BreadcrumbActions", () => $8a41e5f96d7bfaa5$export$9862c338ec0a6884);
$parcel$export(module.exports, "BreadcrumbContainer", () => $8a41e5f96d7bfaa5$export$c7432936d9c50db7);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $8a41e5f96d7bfaa5$var$initialState = {
    trail: []
};
const $8a41e5f96d7bfaa5$export$e324594224ef24da = {
    pushBreadcrumb: (breadcrumb)=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            setState({
                trail: [
                    ...getState().trail,
                    breadcrumb
                ]
            });
        },
    popBreadcrumb: ()=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            setState({
                trail: getState().trail.slice(0, -1)
            });
        },
    updateBreadcrumb: (breadcrumb)=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
            const newTrail = getState().trail.map((item)=>item.id === breadcrumb.id ? breadcrumb : item);
            setState({
                trail: newTrail
            });
        }
};
const $8a41e5f96d7bfaa5$var$Store = (0, $GtRbT.createStore)({
    initialState: $8a41e5f96d7bfaa5$var$initialState,
    actions: $8a41e5f96d7bfaa5$export$e324594224ef24da,
    name: 'BreadcrumbSweetState'
});
const $8a41e5f96d7bfaa5$var$_BreadcrumbSubscriber = (0, $ht3nQ.createSubscriber)($8a41e5f96d7bfaa5$var$Store);
const $8a41e5f96d7bfaa5$export$8cefe241bd876ca0 = (0, $iJq0l.createHook)($8a41e5f96d7bfaa5$var$Store);
const $8a41e5f96d7bfaa5$export$9862c338ec0a6884 = (0, $ht3nQ.createSubscriber)($8a41e5f96d7bfaa5$var$Store, {
    selector: null
});
const $8a41e5f96d7bfaa5$export$c7432936d9c50db7 = (0, $6E16M.createContainer)($8a41e5f96d7bfaa5$var$Store);

});


parcelRegister("jATfF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f3af3d5c1409945$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6T1wD = parcelRequire("6T1wD");

var $cqjwJ = parcelRequire("cqjwJ");
const $4f3af3d5c1409945$var$BoardBreadcrumb = ({ children: children, boardId: boardId, boardName: boardName, isSimplifiedProject: isSimplifiedProject, projectId: projectId })=>{
    const breadcrumb = {
        href: (0, $cqjwJ.createBoardUrl)(boardId),
        text: boardName,
        type: 'boardName',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToSubProject',
            containerId: projectId,
            containerType: 'project'
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6T1wD.default), {
        breadcrumb: breadcrumb
    }, children);
};
$4f3af3d5c1409945$var$BoardBreadcrumb.defaultProps = {
    children: null,
    isSimplifiedProject: false,
    projectId: undefined
};
var $4f3af3d5c1409945$export$2e2bcd8739ae039 = $4f3af3d5c1409945$var$BoardBreadcrumb;

});
parcelRegister("cqjwJ", function(module, exports) {

$parcel$export(module.exports, "createProjectUrl", () => $811fe0c2dfc0e0a8$export$1bdb1f038c5a2a90);
$parcel$export(module.exports, "createProjectSettingsUrl", () => $811fe0c2dfc0e0a8$export$c435fcb42a65af32);
$parcel$export(module.exports, "createBoardUrl", () => $811fe0c2dfc0e0a8$export$7037e05c8c7af6dc);

var $47Jx0 = parcelRequire("47Jx0");
const $811fe0c2dfc0e0a8$export$1bdb1f038c5a2a90 = (projectKey)=>`/browse/${encodeURIComponent(projectKey)}`;
const $811fe0c2dfc0e0a8$export$c435fcb42a65af32 = (projectKey, projectType, isSimplified)=>{
    if (isSimplified) return (0, $47Jx0.getNextgenSettingsUrl)(projectType, projectKey);
    return `/projects/${projectKey}/settings`;
};
const $811fe0c2dfc0e0a8$export$7037e05c8c7af6dc = (boardId)=>`/secure/RapidBoard.jspa?rapidView=${boardId}`;

});


parcelRegister("gFB4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $3452bb6d3c06ed91$export$2e2bcd8739ae039);

var $idGBm = parcelRequire("idGBm");

var $42mMa = parcelRequire("42mMa");
var $3452bb6d3c06ed91$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)((0, $42mMa.default));

});
parcelRegister("42mMa", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbbdb57854bad193$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6T1wD = parcelRequire("6T1wD");

var $cqjwJ = parcelRequire("cqjwJ");

var $an84N = parcelRequire("an84N");
const $bbbdb57854bad193$var$ProjectBreadcrumb = ({ isSimplifiedProject: isSimplifiedProject, children: children, projectKey: projectKey, projectName: projectName, projectId: projectId, intl: { formatMessage: formatMessage } })=>{
    const ProjectsBreadcrumb = {
        href: '/jira/projects',
        text: formatMessage((0, $an84N.default).projectsTitle),
        type: 'projectsDirectory',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToProjectsList'
        }
    };
    if (projectKey != null && projectName != null) {
        const breadcrumb = {
            href: (0, $cqjwJ.createProjectUrl)(projectKey),
            text: projectName,
            type: 'projectName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToProject',
                containerId: projectId,
                containerType: 'project'
            }
        };
        const ProjectNameBreadcrumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6T1wD.default), {
            breadcrumb: breadcrumb
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6T1wD.default), {
            breadcrumb: ProjectsBreadcrumb
        }, ProjectNameBreadcrumb);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6T1wD.default), {
        breadcrumb: ProjectsBreadcrumb
    }, children);
};
$bbbdb57854bad193$var$ProjectBreadcrumb.defaultProps = {
    children: null,
    isSimplifiedProject: false,
    projectId: undefined,
    projectKey: undefined,
    projectName: undefined
};
var $bbbdb57854bad193$export$2e2bcd8739ae039 = $bbbdb57854bad193$var$ProjectBreadcrumb;

});
parcelRegister("an84N", function(module, exports) {

$parcel$export(module.exports, "default", () => $24bfd47e3e5279c7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $24bfd47e3e5279c7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projectsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title",
        "defaultMessage": "Projects"
    }
});

});



parcelRegister("4nWs2", function(module, exports) {

$parcel$export(module.exports, "default", () => $244a424f0e6a95b7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6T1wD = parcelRequire("6T1wD");
const $244a424f0e6a95b7$var$UserBreadcrumb = ({ children: children, name: name, profileUrl: profileUrl })=>{
    const breadcrumb = {
        href: profileUrl,
        text: name,
        type: 'userName'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6T1wD.default), {
        breadcrumb: breadcrumb
    }, children);
};
var $244a424f0e6a95b7$export$2e2bcd8739ae039 = $244a424f0e6a95b7$var$UserBreadcrumb;

});

parcelRegister("dnzxN", function(module, exports) {

$parcel$export(module.exports, "default", () => $7509a3f9880b0955$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $7509a3f9880b0955$var$toBreadcrumbData = ({ id: id, index: index, ...legacyCrumb })=>({
        ...legacyCrumb,
        legacyId: id,
        type: 'legacy'
    });
const $7509a3f9880b0955$var$ContextBreadcrumbs = ({ ContextProvider: ContextProvider, ProjectBreadcrumb: ProjectBreadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ContextProvider, null, ({ data: data })=>{
        if (!data) return children;
        const boardBreadcrumb = data.scope ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BoardBreadcrumb, {
            boardId: data.scope.id,
            boardName: data.scope.name || 'Board'
        }, children) : children;
        return data.contextType === 'user' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(UserBreadcrumb, {
            profileUrl: data.user.profileUrl,
            name: data.user.name
        }, boardBreadcrumb) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ProjectBreadcrumb, {
            projectKey: data.project.key,
            projectName: data.project.name,
            projectId: data.project.id,
            isSimplifiedProject: data.project.isSimplified
        }, boardBreadcrumb);
    });
const $7509a3f9880b0955$var$LegacyBreadcrumbConnector = ({ legacyTrail: legacyTrail, Breadcrumb: Breadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, ProjectBreadcrumb: ProjectBreadcrumb, ContextProvider: ContextProvider })=>{
    const accumulateBreadcrumb = (accumulatedCrumbs, currentCrumb)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Breadcrumb, {
            breadcrumb: currentCrumb
        }, accumulatedCrumbs);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7509a3f9880b0955$var$ContextBreadcrumbs, {
        BoardBreadcrumb: BoardBreadcrumb,
        ProjectBreadcrumb: ProjectBreadcrumb,
        UserBreadcrumb: UserBreadcrumb,
        ContextProvider: ContextProvider
    }, legacyTrail.map($7509a3f9880b0955$var$toBreadcrumbData).reverse().reduce(accumulateBreadcrumb, null));
};
var $7509a3f9880b0955$export$2e2bcd8739ae039 = $7509a3f9880b0955$var$LegacyBreadcrumbConnector;

});

parcelRegister("h0N9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc21dcf75aeeb73e$export$2e2bcd8739ae039);

var $jFHCE = parcelRequire("jFHCE");

var $6nVJI = parcelRequire("6nVJI");

var $2FqDG = parcelRequire("2FqDG");
var $95O7y = parcelRequire("95O7y");
const $dc21dcf75aeeb73e$export$9f27bc3417b4524d = ({ children: children })=>{
    const [boardId] = (0, $2FqDG.usePathParam)('boardId');
    const [rapidView] = (0, $95O7y.useQueryParam)('rapidView');
    const [{ data: ctxData, loading: loading, error: error }] = (0, $6nVJI.useContainerContext)();
    /* Don't provide scope data if boardId does not exist in the URL as
	 * we don't want to show the board breadcrumb in this case since it
	 * indicates that we aren't in a scope context even though one may
	 * exist. */ const data = ctxData == null || boardId != null || rapidView != null ? ctxData : (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(ctxData, 'scope');
    // @ts-expect-error - TS2322 - Type 'Pick<ProjectContext | UserContext, "contextType"> | null' is not assignable to type 'ContainerContext | null'. | TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null'.
    return children({
        data: data,
        loading: loading,
        error: error
    });
};
var $dc21dcf75aeeb73e$export$2e2bcd8739ae039 = $dc21dcf75aeeb73e$export$9f27bc3417b4524d;

});


parcelRegister("cpZiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $effa889623729e5e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $eSnSE = parcelRequire("eSnSE");

var $h6slU = parcelRequire("h6slU");
const $effa889623729e5e$var$LOCATION = 'breadcrumbs.legacy-adapter.legacy-renderer';
class $effa889623729e5e$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    componentDidCatch(error) {
        /*
            This error boundary is added to adapt to a runtime error caused by createPortal method in IE 11
        */ const { targetElement: targetElement } = this.props;
        const targetId = targetElement ? targetElement.id : 'not-found';
        (0, $eSnSE.default).safeErrorWithoutCustomerData($effa889623729e5e$var$LOCATION, `Failed to createPortal on ${targetId}`, error);
    }
    render() {
        const { targetElement: targetElement } = this.props;
        return /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h6slU.default), null), targetElement);
    }
}

});
parcelRegister("h6slU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6676a876f48d07e8$export$2e2bcd8739ae039);

var $aKfba = parcelRequire("aKfba");

var $2QUmO = parcelRequire("2QUmO");

var $lvKO5 = parcelRequire("lvKO5");

var $7KRE0 = parcelRequire("7KRE0");
const $6676a876f48d07e8$var$fireAnalytics = (analyticsEvent)=>(0, $aKfba.fireOperationalAnalytics)(analyticsEvent, {
        name: 'breadcrumbRendererMounted'
    });
var $6676a876f48d07e8$export$2e2bcd8739ae039 = (0, $2QUmO.default)((0, $7KRE0.default), {
    onMount: $6676a876f48d07e8$var$fireAnalytics,
    TenantContextSubscriber: $lvKO5.TenantContextSubscriber
});

});
parcelRegister("7KRE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbcac1f9f03b3741$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $aBFKZ = parcelRequire("aBFKZ");

var $7wjKL = parcelRequire("7wjKL");

var $ifPW4 = parcelRequire("ifPW4");
// Adapt to prop type from breadcrumbs app
const $cbcac1f9f03b3741$var$mapTrailToBreadcrumbItems = (trail)=>trail.map((crumb)=>({
            ...crumb,
            target: crumb.target || '_self'
        }));
const $cbcac1f9f03b3741$var$BreadcrumbRenderer = ({ onMount: onMount })=>{
    const [{ trail: trail }] = (0, $ifPW4.useBreadcrumbs)();
    const items = (0, $eJOHy.useMemo)(()=>$cbcac1f9f03b3741$var$mapTrailToBreadcrumbItems(trail), [
        trail
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(onMount, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1tke1tcg"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wjKL.default), {
        isVisible: true,
        items: items
    }));
};
var $cbcac1f9f03b3741$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('breadcrumbsRenderer', {
    onMount: 'mounted'
})($cbcac1f9f03b3741$var$BreadcrumbRenderer);
const $cbcac1f9f03b3741$var$breadcrumbsWrapperStyles = null;

});
parcelRegister("7wjKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec7e757ad8d6637b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7iHUq = parcelRequire("7iHUq");

var $bX4vO = parcelRequire("bX4vO");
function $ec7e757ad8d6637b$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bX4vO.default), {
        isVisible: isVisible,
        items: items
    }));
}

});
parcelRegister("bX4vO", function(module, exports) {

$parcel$export(module.exports, "default", () => $27d452b5bc0f0d47$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");

var $12DRg = parcelRequire("12DRg");

var $erdIZ = parcelRequire("erdIZ");
var $9bgYW = parcelRequire("9bgYW");

var $lRq8t = parcelRequire("lRq8t");

var $c9uTK = parcelRequire("c9uTK");

var $jdVvc = parcelRequire("jdVvc");

var $24Eev = parcelRequire("24Eev");
const $27d452b5bc0f0d47$export$67abef37aa2929b0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        ...props,
        ref: ref,
        type: "a"
    }));
function $27d452b5bc0f0d47$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const totalItems = items.length;
    return isVisible ? // onExpand is required prop in atlaskit's breadcrumbitem component
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9bgYW.default), {
        onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(items) ? // This is needed in order to render an empty breadcrumb for SSR, to avoid visual jumping when javascript kicks in.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $erdIZ.default), {
        text: "",
        "aria-label": formatMessage((0, $24Eev.default).breadcrumbsLabel)
    }) : items.map((breadcrumb, index)=>{
        const breadcrumbItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdVvc.default), {
            key: index,
            index: index,
            ariaCurrent: index + 1 === totalItems ? 'page' : undefined,
            hasSeparator: true,
            text: breadcrumb.text,
            target: __SPA__ ? undefined : breadcrumb.target,
            href: breadcrumb.href,
            component: __SPA__ ? $27d452b5bc0f0d47$export$67abef37aa2929b0 : undefined,
            legacyId: breadcrumb.legacyId,
            type: breadcrumb.type,
            analyticsAttributes: breadcrumb.analyticsAttributes,
            analyticsFields: breadcrumb.analyticsFields
        });
        return breadcrumbItem;
    }))) : null;
}

});
parcelRegister("jdVvc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddd4b61d0ffad6f1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $erdIZ = parcelRequire("erdIZ");

var $1nkcA = parcelRequire("1nkcA");
class $ddd4b61d0ffad6f1$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            href: undefined,
            legacyId: undefined,
            type: 'unspecified',
            analyticsAttributes: {},
            analyticsFields: {},
            ariaCurrent: undefined
        };
    }
    render() {
        const { index: index, text: text, target: target, href: href, component: component, ariaCurrent: ariaCurrent } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $erdIZ.default), {
            key: index,
            text: text,
            // @ts-expect-error - TS2322 - Type '(event: Event, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type '(event: MouseEvent<Element, MouseEvent>) => void'.
            onClick: this.onBreadCrumbClick,
            target: target,
            href: href,
            component: component,
            "aria-current": ariaCurrent
        });
    }
    constructor(...args){
        super(...args), this.onBreadCrumbClick = (event, analyticsEvent)=>{
            const { legacyId: legacyId, index: index, type: type, analyticsAttributes: analyticsAttributes, analyticsFields: analyticsFields } = this.props;
            (0, $1nkcA.fireUiAnalytics)(analyticsEvent, {
                name: '',
                attributes: {
                    legacyId: legacyId,
                    // change this depth value to be zero based, once Jira home crumb is added
                    depth: index + 1,
                    type: type,
                    ...analyticsAttributes
                },
                ...analyticsFields
            });
        };
    }
}

});
parcelRegister("1nkcA", function(module, exports) {

$parcel$export(module.exports, "fireUiAnalytics", () => $cf5f26e81f7d5e54$export$4909253b5bf1eed7);

var $9pL9Y = parcelRequire("9pL9Y");

var $iM63C = parcelRequire("iM63C");

var $5nSuO = parcelRequire("5nSuO");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $cf5f26e81f7d5e54$var$isNotUndefined = (a)=>a !== undefined;
const $cf5f26e81f7d5e54$var$mapPayload = (payload)=>{
    const context = (0, $5nSuO.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $cf5f26e81f7d5e54$var$isNotUndefined);
};
const $cf5f26e81f7d5e54$export$4909253b5bf1eed7 = (event, payload)=>{
    event.update({
        ...$cf5f26e81f7d5e54$var$mapPayload(payload),
        analyticsType: (0, $iM63C.UI_EVENT_TYPE)
    }).fire();
};

});


parcelRegister("24Eev", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd0c10b6a62c0885$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bd0c10b6a62c0885$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    breadcrumbsLabel: {
        "id": "navigation-apps.breadcrumbs.aria-label",
        "defaultMessage": "Empty Breadcrumbs item"
    }
});

});






parcelRegister("9CWi2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a78872c21791ffa$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $8a78872c21791ffa$var$compareBreadcrumbs = (a, b)=>a.index - b.index;
const $8a78872c21791ffa$var$defaultInitialState = {
    trail: [],
    targetElement: null
};
class $8a78872c21791ffa$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            initialState: $8a78872c21791ffa$var$defaultInitialState
        };
    }
    constructor(props){
        super(props), this.onInsertItem = (item)=>{
            this.setState((state)=>({
                    trail: [
                        ...state.trail,
                        item
                    ].sort($8a78872c21791ffa$var$compareBreadcrumbs)
                }));
        }, this.onRemoveItem = (id)=>{
            this.setState((state)=>({
                    trail: state.trail.filter((b)=>b.id !== id)
                }));
        }, /* eslint-disable react/no-unused-state */ this.onTargetSet = (targetElement)=>{
            this.setState({
                targetElement: targetElement
            });
        }, /* eslint-enable react/no-unused-state */ this.api = {
            setTargetElement: this.onTargetSet,
            insertItem: this.onInsertItem,
            removeItem: this.onRemoveItem
        };
        this.state = props.initialState;
    }
    render() {
        const { children: children } = this.props;
        return children({
            state: this.state,
            api: this.api
        });
    }
}

});



parcelRegister("ajCkH", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $b198b00a4924b5f8$export$6e4bfef9e80c7eb0);

var $eJOHy = parcelRequire("eJOHy");

var $jEvkf = parcelRequire("jEvkf");

var $6VquU = parcelRequire("6VquU");

var $7jTnu = parcelRequire("7jTnu");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b198b00a4924b5f8$export$6e4bfef9e80c7eb0 = ()=>{
    const [{ hasLoaded: hasLoaded }] = (0, $jEvkf.default)();
    const { resetPhase: resetPhase, startNextPhase: startNextPhase } = (0, $6VquU.useLazyPhase)();
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $7jTnu.fg)('iv_load_after_paint_phase_on_page_early')) {
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        } else if (hasLoaded) {
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        } else resetPhase();
    }, [
        hasLoaded,
        resetPhase,
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("7cv6Z", function(module, exports) {

$parcel$export(module.exports, "TrackClicksBeforeTTI", () => $1629e14fab0142f6$export$2846c12b8c092470);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $9XYcy = parcelRequire("9XYcy");

var $4elgJ = parcelRequire("4elgJ");

var $7jTnu = parcelRequire("7jTnu");
const $1629e14fab0142f6$var$cleanUrl = (pathname)=>{
    let url = pathname.replace(/\/$/, '');
    // /browse redirects or sw classic redirects
    if (/\/browse\/\w+$/.test(url)) url = 'browse';
    // replaces any occurrence of two or more capital letters,
    // or one capital letter followed by a number and also
    // two or more capital letters followed by a dash and any amount of numbers
    // (should catch all project and issue keys)
    if (/[A-Z][A-Z0-9]+(-[\d]+)*/g.test(url)) url = url.replace(/[A-Z][A-Z0-9]+(-[\d]+)*/g, 'XX');
    return url;
};
const $1629e14fab0142f6$var$sessionStorageProvider = (0, $4elgJ.createSessionStorageProvider)('', false);
/**
 * Handles the collection and processing of user interactions that occur before the page becomes fully interactive. This enhances the understanding of user behavior during the initial loading phase.
 */ const $1629e14fab0142f6$export$2846c12b8c092470 = ()=>{
    const [{ isReady: isReady }] = (0, $9XYcy.useSpaStatePageReady)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (!isReady) return;
        try {
            const sessionStorageItems = (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $1629e14fab0142f6$var$sessionStorageProvider.get('clicks-before-tti') : sessionStorage.getItem('clicks-before-tti');
            if (sessionStorageItems == null || sessionStorageItems === '') return;
            const items = JSON.parse(sessionStorageItems);
            items.forEach((item)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                let extras = {
                    elementId: item.dataId,
                    currentUrl: $1629e14fab0142f6$var$cleanUrl(item.currentUrl),
                    bundleId: item.bundleId,
                    time: item.time
                };
                if (item.redirectUrl !== '') extras = {
                    ...extras,
                    redirectUrl: $1629e14fab0142f6$var$cleanUrl(item.redirectUrl)
                };
                (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({
                    action: 'clicked'
                }), 'nonInteractiveElement clicked', '', extras);
            });
            (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $1629e14fab0142f6$var$sessionStorageProvider.remove('clicks-before-tti') : sessionStorage.removeItem('clicks-before-tti');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }, [
        createAnalyticsEvent,
        isReady
    ]);
    return null;
};

});

parcelRegister("jjTNC", function(module, exports) {

$parcel$export(module.exports, "Integrations", () => $8f85ccb8e16b890f$export$99d02219d259eb94);
$parcel$export(module.exports, "IntegrationsWhichRequireNavigationRoot", () => $8f85ccb8e16b890f$export$26605c981d761e9d);

var $eJOHy = parcelRequire("eJOHy");

var $2Mg44 = parcelRequire("2Mg44");

var $hH1AY = parcelRequire("hH1AY");

var $3Fjdk = parcelRequire("3Fjdk");

var $1TFt8 = parcelRequire("1TFt8");
function $8f85ccb8e16b890f$export$99d02219d259eb94() {
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hH1AY.IssueViewModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1TFt8.Projects), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Mg44.Dashboards), null));
    return null;
}
$8f85ccb8e16b890f$export$99d02219d259eb94.displayName = 'Integrations'; // This is needed to pass the test.tsx's uniqueness-test. Without it, the component appears as 'ComponentWithCondition[]', which already exists in the list.
function $8f85ccb8e16b890f$export$26605c981d761e9d() {
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Fjdk.KeyboardShortcuts), null);
    return null;
}

});
parcelRegister("2Mg44", function(module, exports) {

$parcel$export(module.exports, "Dashboards", () => $5f666e9c6a9fda8c$export$dd47e695f88fad71);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $7EgC9 = parcelRequire("7EgC9");

var $hih5V = parcelRequire("hih5V");

var $9o3jI = parcelRequire("9o3jI");

var $cECwI = parcelRequire("cECwI");

var $02kpm = parcelRequire("02kpm");
var $83DiZ = parcelRequire("83DiZ");

var $kO1ht = parcelRequire("kO1ht");
const $5f666e9c6a9fda8c$var$styles = (0, $5Wv5g.xcss)({
    position: 'absolute'
});
const $5f666e9c6a9fda8c$export$dd47e695f88fad71 = ()=>{
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const [isOpen, { off: modalClose }] = (0, $9o3jI.useSwitchModals)((0, $kO1ht.MODAL_ID).DASHBOARD_CREATE);
    const { path: path } = (0, $hih5V.useRouteByName)('dashboard-edit') ?? {};
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const onSuccess = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7031 - Binding element 'id' implicitly has an 'any' type.
    (_, { id: id })=>{
        path && push((0, $02kpm.generatePath)(path, {
            dashboardId: id
        }));
        modalClose();
    }, [
        modalClose,
        path,
        push
    ]);
    if (isAnonymous) return null;
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $5f666e9c6a9fda8c$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7EgC9.default), {
        onSuccess: onSuccess,
        onCancel: modalClose
    })) : null;
};

});

parcelRegister("hH1AY", function(module, exports) {

$parcel$export(module.exports, "IssueViewModal", () => $830b1428deefed01$export$e6a284da53c503a6);

var $eJOHy = parcelRequire("eJOHy");

var $dBLLk = parcelRequire("dBLLk");

var $lbDFC = parcelRequire("lbDFC");

var $ch9En = parcelRequire("ch9En");

var $ljej9 = parcelRequire("ljej9");

var $gzcjr = parcelRequire("gzcjr");

const $830b1428deefed01$export$b61e79ae300e872f = (0, $gzcjr.lazy)(()=>(parcelRequire("1ezJg")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});
const $830b1428deefed01$export$e6a284da53c503a6 = ()=>{
    const [{ isModalOpen: isModalOpen, issueKey: issueKey, onClose: onClose, packageName: packageName, analyticsSource: analyticsSource }] = (0, $lbDFC.useTriggerIssueViewModal)();
    return isModalOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dBLLk.ModalBoundary), {
        packageName: packageName,
        id: "issue-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "modal-issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($830b1428deefed01$export$b61e79ae300e872f, {
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'AnalyticsSource'.
        analyticsSource: analyticsSource,
        issueKey: (0, $ljej9.toIssueKey)(issueKey),
        onClose: onClose
    }))) : null;
};

});
parcelRegister("dBLLk", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $499cc98a8c07c323$export$c3f500e812fb1bb3);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $1qbKn = parcelRequire("1qbKn");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");
const $499cc98a8c07c323$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eJOHy.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: id,
        fallback: fallback
    }, children));
};

});

parcelRegister("lbDFC", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueViewModal", () => $68046280a2fbb8d9$export$fb8fdfbeb70f910c);

var $12DRg = parcelRequire("12DRg");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $68046280a2fbb8d9$export$d4c72bab9d6cc13a = {
    isModalOpen: false,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    issueKey: '',
    packageName: '',
    analyticsSource: '',
    issueCreateSessionId: undefined
};
const $68046280a2fbb8d9$export$e324594224ef24da = {
    openIssueViewModal: (nextState)=>({ setState: setState })=>{
            setState({
                ...$68046280a2fbb8d9$export$d4c72bab9d6cc13a,
                ...nextState,
                isModalOpen: true
            });
        },
    closeIssueViewModal: ()=>({ setState: setState })=>{
            setState({
                ...$68046280a2fbb8d9$export$d4c72bab9d6cc13a,
                isModalOpen: false
            });
        },
    setIssueCreateSessionId: (issueCreateSessionId)=>({ setState: setState })=>{
            setState({
                issueCreateSessionId: issueCreateSessionId
            });
        }
};
const $68046280a2fbb8d9$var$store = (0, $GtRbT.createStore)({
    name: 'issue-view.controllers.open-issue-view-modal',
    initialState: $68046280a2fbb8d9$export$d4c72bab9d6cc13a,
    actions: $68046280a2fbb8d9$export$e324594224ef24da
});
const $68046280a2fbb8d9$export$fb8fdfbeb70f910c = (0, $iJq0l.createHook)($68046280a2fbb8d9$var$store);

});


parcelRegister("3Fjdk", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcuts", () => $39af270327288b6c$export$5176144edf2bef2b);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $5qPoO = parcelRequire("5qPoO");

var $ixiAQ = parcelRequire("ixiAQ");


var $1KdDN = parcelRequire("1KdDN");

var $7jTnu = parcelRequire("7jTnu");

var $hLzUY = parcelRequire("hLzUY");

var $frzkV = parcelRequire("frzkV");

var $dfP3D = parcelRequire("dfP3D");

var $5RW99 = parcelRequire("5RW99");

var $gOfBc = parcelRequire("gOfBc");

var $84DOT = parcelRequire("84DOT");

var $jipjz = parcelRequire("jipjz");

var $ch9En = parcelRequire("ch9En");

var $dRfS0 = parcelRequire("dRfS0");

var $eJrcF = parcelRequire("eJrcF");
// Retaining the old name to avoid breaking any dashboards that may break due to this refactor
const $39af270327288b6c$var$PACKAGE_NAME = '@atlassian/jira-atlassian-navigation';
const $39af270327288b6c$var$KeyboardShortcuts = ()=>{
    const [, { on: on }] = (0, $gOfBc.useTopMenus)((0, $5RW99.MENU_ID).SEARCH);
    const [, { off: closeAllMenus }] = (0, $gOfBc.useTopMenus)();
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const rightSidebarState = (0, $dfP3D.useActiveRightSidebarState)();
    const [{ isInitialLoad: isInitialLoad }, actions] = (0, $5qPoO.useIsInitialLoadLegacyIssueCreate)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const isInitialLoadRef = (0, $eJOHy.useRef)(false);
    isInitialLoadRef.current = isInitialLoad;
    const openSearch = (0, $eJOHy.useCallback)(()=>requestAnimationFrame(()=>{
            on();
        }), [
        on
    ]);
    let currentIssueCreateVisibility = null;
    if ((0, $7jTnu.fg)('render_modern_global_issue_create_modal_experience')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data } = (0, $eJrcF.useResource)((0, $dRfS0.gicOptInStatusResources));
        currentIssueCreateVisibility = data && data?.gicOptInStatus;
    }
    const openIssueCreate = (0, $eJOHy.useCallback)(()=>{
        if ((0, $7jTnu.fg)('render_modern_global_issue_create_modal_experience')) {
            if (currentIssueCreateVisibility !== null) {
                if (currentIssueCreateVisibility.isEnabled) openIssueCreateModal({
                    triggerPointKey: (0, $84DOT.GENERIC_KEYBOARD_SHORTCUT)
                });
                else {
                    (0, $ixiAQ.default)({
                        isInitialLoad: isInitialLoadRef.current,
                        triggerSource: (0, $8b9f565bf0bbac99$export$7e22286cafe320a7)
                    });
                    if (isInitialLoadRef.current) actions.clearInitialLoaded();
                }
            } else (0, $eSnSE.default).safeErrorWithoutCustomerData('global-issue-create', 'visibility data is still getting downloaded');
        } else {
            (0, $ixiAQ.default)({
                isInitialLoad: isInitialLoadRef.current,
                triggerSource: (0, $8b9f565bf0bbac99$export$7e22286cafe320a7)
            });
            if (isInitialLoadRef.current) actions.clearInitialLoaded();
        }
    }, [
        actions,
        currentIssueCreateVisibility,
        openIssueCreateModal
    ]);
    const toggleHelpPanel = (0, $eJOHy.useCallback)(()=>{
        closeAllMenus();
        if (!rightSidebarState?.isCollapsed && rightSidebarState?.panelId === (0, $hLzUY.HELP_PANEL_ID)) closeCurrentRightSidebar();
        else openRightSidebar((0, $hLzUY.HELP_PANEL_ID), (0, $hLzUY.HELP_PANEL_WIDTH));
    }, [
        closeAllMenus,
        closeCurrentRightSidebar,
        openRightSidebar,
        rightSidebarState?.isCollapsed,
        rightSidebarState?.panelId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "integrations.keyboard-shortcuts",
        packageName: $39af270327288b6c$var$PACKAGE_NAME,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "lazy-shortcuts",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $frzkV.KeyboardShortcuts), {
        showIssueCreate: openIssueCreate,
        showSearch: openSearch,
        toggleHelpPanel: toggleHelpPanel,
        shouldUseHelpShortcut: true
    })));
};
const $39af270327288b6c$var$DummyComponent = ()=>null;
// https://jplat.atlassian.net/browse/JFP-3418
// This component currently crashes the page during Hot Module Replacement. So
// we're disabling this component when HMR is enabled (i.e. the --hmr flag is
// present). This a temporary measure until we find a proper fix. This will not
// affect regular development or the customer experience.
const $39af270327288b6c$export$5176144edf2bef2b = $39af270327288b6c$var$KeyboardShortcuts;

});
parcelRegister("5qPoO", function(module, exports) {

$parcel$export(module.exports, "useIsInitialLoadLegacyIssueCreate", () => $62891830fba96f35$export$8a73e89ffc4b9342);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $62891830fba96f35$var$initialState = {
    isInitialLoad: true
};
const $62891830fba96f35$export$e324594224ef24da = {
    clearInitialLoaded: ()=>({ setState: setState, getState: getState })=>{
            if (getState().isInitialLoad) setState({
                isInitialLoad: false
            });
        }
};
const $62891830fba96f35$var$store = (0, $GtRbT.createStore)({
    name: 'is-initial-load-create-issue-legacy',
    initialState: $62891830fba96f35$var$initialState,
    actions: $62891830fba96f35$export$e324594224ef24da
});
const $62891830fba96f35$export$8a73e89ffc4b9342 = (0, $iJq0l.createHook)($62891830fba96f35$var$store);

});

parcelRegister("ixiAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d65f09fde2c4e2e$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $gjeS9 = parcelRequire("gjeS9");

var $7jTnu = parcelRequire("7jTnu");

var $kxCpN = parcelRequire("kxCpN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8d65f09fde2c4e2e$export$2e2bcd8739ae039 = ({ timeout: timeout, tentatives: tentatives, isInitialLoad: // isInitialLoad tracks the initial render of global issue create dialog through this entry point (presently called from navigation create button and keyboard shortcut)
isInitialLoad, triggerSource: triggerSource, showModern: showModern } = {})=>{
    (0, $kxCpN.sendStartMarkForLegacyIssueCreate)({
        isInitialLoad: isInitialLoad,
        triggerSource: triggerSource
    });
    // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $gjeS9.loadBridge)({
        name: 'quick-edit/init/create-dialogs',
        wrmKeys: [
            'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue-bootstrap',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs'
        ],
        timeout: timeout,
        tentatives: tentatives
    }).then((api)=>{
        if ((0, $7jTnu.fg)('render_modern_global_issue_create_modal_experience')) {
            if (showModern === true) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api.hideLoadingIndicator(false);
            else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api.showCreateDialog({
                showModern: showModern
            });
        } else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        api.showCreateDialog({});
        (0, $kxCpN.sendEndMarkForLegacyIssueCreate)({
            isInitialLoad: isInitialLoad
        });
    });
};

});
parcelRegister("kxCpN", function(module, exports) {

$parcel$export(module.exports, "sendStartMarkForLegacyIssueCreate", () => $4bd568bdda78fab3$export$7dbcbf47a4e0e00f);
$parcel$export(module.exports, "sendEndMarkForLegacyIssueCreate", () => $4bd568bdda78fab3$export$b5c5d408bb7fd104);

var $2QTvK = parcelRequire("2QTvK");

var $cKx4P = parcelRequire("cKx4P");
const $4bd568bdda78fab3$export$7dbcbf47a4e0e00f = ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    if (typeof isInitialLoad === 'boolean' && triggerSource !== undefined) {
        if (isInitialLoad) (0, $cKx4P.legacyIssueCreateInitialRenderInteraction).start();
        else (0, $cKx4P.legacyIssueCreateTransitionInteraction).start();
        (0, $cKx4P.legacyIssueCreateCombinedInteraction).start();
    }
};
const $4bd568bdda78fab3$export$b5c5d408bb7fd104 = async ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    const Events = await (0, $2QTvK.apiReady)();
    const onCreateIssueDialogRendered = ()=>{
        if (typeof isInitialLoad === 'boolean') {
            if (isInitialLoad) (0, $cKx4P.legacyIssueCreateInitialRenderInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            else (0, $cKx4P.legacyIssueCreateTransitionInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            (0, $cKx4P.legacyIssueCreateCombinedInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
        }
        Events.unbind('createIssueDialogRendered', onCreateIssueDialogRendered);
    };
    Events.bind('createIssueDialogRendered', onCreateIssueDialogRendered);
};

});
parcelRegister("2QTvK", function(module, exports) {

$parcel$export(module.exports, "apiReady", () => $8b17da24b9e1b1f2$export$330fb1a04c974aad);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $gjeS9 = parcelRequire("gjeS9");
let $8b17da24b9e1b1f2$var$currentBridge;
const $8b17da24b9e1b1f2$export$330fb1a04c974aad = async ()=>{
    if ($8b17da24b9e1b1f2$var$currentBridge) return $8b17da24b9e1b1f2$var$currentBridge;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/wrm/no-load-bridge
    const Events = await (0, $gjeS9.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    });
    $8b17da24b9e1b1f2$var$currentBridge = Events;
    return Events;
};

});

parcelRegister("cKx4P", function(module, exports) {

$parcel$export(module.exports, "legacyIssueCreateInitialRenderInteraction", () => $b0beec06c3c56c69$export$2bc24132dfd54487);
$parcel$export(module.exports, "legacyIssueCreateTransitionInteraction", () => $b0beec06c3c56c69$export$ba0054dee3105c90);
$parcel$export(module.exports, "legacyIssueCreateCombinedInteraction", () => $b0beec06c3c56c69$export$52353a8848646ccd);

var $4WXKS = parcelRequire("4WXKS");
const $b0beec06c3c56c69$export$2bc24132dfd54487 = (0, $4WXKS.metrics).interaction({
    key: 'legacy-issue-create.initial-render'
});
const $b0beec06c3c56c69$export$ba0054dee3105c90 = (0, $4WXKS.metrics).interaction({
    key: 'legacy-issue-create.transition'
});
const $b0beec06c3c56c69$export$52353a8848646ccd = (0, $4WXKS.metrics).interaction({
    key: 'legacy-issue-create.combined'
});

});



const $8b9f565bf0bbac99$export$d983e94cf86f65d = 'global-create-button';
const $8b9f565bf0bbac99$export$7e22286cafe320a7 = 'keyboard-shortcut';

parcelRegister("frzkV", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcuts", () => $4a70226b9a3bb88c$export$5176144edf2bef2b);

var $gzcjr = parcelRequire("gzcjr");

const $4a70226b9a3bb88c$export$5176144edf2bef2b = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("khiXN")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/keyboard-shortcuts/src/view/index.tsx"
});

});
parcelRegister("khiXN", function(module, exports) {

let $ec341ae694b1066b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ec341ae694b1066b$var$load("1VRB2"),
    $ec341ae694b1066b$var$load("bABhq"),
    $ec341ae694b1066b$var$load("7eAAS")
]).then(()=>parcelRequire('ksNs6'));

});


parcelRegister("gOfBc", function(module, exports) {

$parcel$export(module.exports, "useTopMenus", () => $2279d013e3a03311$export$6591d6b6c4546423);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");

var $dA7TN = parcelRequire("dA7TN");
const { SwitchContainer: $2279d013e3a03311$var$SwitchContainer, useSwitch: $2279d013e3a03311$var$useSwitch } = (0, $dA7TN.createSwitchController)('atlassian-navigation-top-menus');
const $2279d013e3a03311$export$45ccf7b2695bac19 = $2279d013e3a03311$var$SwitchContainer;
const $2279d013e3a03311$var$useTopMenusBase = $2279d013e3a03311$var$useSwitch;
const $2279d013e3a03311$export$6591d6b6c4546423 = (props)=>{
    const switcher = $2279d013e3a03311$var$useTopMenusBase(props);
    const [{ isOpen: isCommandPaletteOpen }] = (0, $g51Bg.useCommandPaletteIsOpen)();
    const [isSwitchOpen, { off: off }] = switcher;
    (0, $eJOHy.useEffect)(()=>{
        if (isSwitchOpen && isCommandPaletteOpen) off();
    }, [
        isCommandPaletteOpen,
        isSwitchOpen,
        off
    ]);
    return switcher;
};

});
parcelRegister("g51Bg", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $b0966e39df9c724a$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $b0966e39df9c724a$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $b0966e39df9c724a$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $b0966e39df9c724a$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $b0966e39df9c724a$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $b0966e39df9c724a$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $b0966e39df9c724a$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $b0966e39df9c724a$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $b0966e39df9c724a$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $b0966e39df9c724a$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $b0966e39df9c724a$export$bbc05723eb144e03);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $2OtIa = parcelRequire("2OtIa");

var $1kl5C = parcelRequire("1kl5C");
const $b0966e39df9c724a$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $b0966e39df9c724a$var$store = (0, $GtRbT.createStore)({
    initialState: $b0966e39df9c724a$var$initialState,
    actions: $1kl5C.actions,
    name: 'commandPalette'
});
const $b0966e39df9c724a$export$6b58f9610017fbb7 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store);
const $b0966e39df9c724a$export$72aa7bc7c6a83c36 = (0, $iJq0l.createActionsHook)($b0966e39df9c724a$var$store);
const $b0966e39df9c724a$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $b0966e39df9c724a$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $b0966e39df9c724a$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $2OtIa.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $2OtIa.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $2OtIa.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $b0966e39df9c724a$export$1f90c8f89f98110e = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: $b0966e39df9c724a$export$56f06313122d0aac
});
const $b0966e39df9c724a$export$cc979be9b69236df = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $b0966e39df9c724a$export$a18633b655403b12 = (0, $iJq0l.createStateHook)($b0966e39df9c724a$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $b0966e39df9c724a$export$af8fd8cd4b048315 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $b0966e39df9c724a$export$4372697329bd9cbe = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $b0966e39df9c724a$export$7422170a403e909 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $b0966e39df9c724a$export$282aa48e4a3afada = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $b0966e39df9c724a$export$96819dfb22ad05d3 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $b0966e39df9c724a$export$a40e8ae3e53feab0 = (0, $4MchI.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $2OtIa.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $b0966e39df9c724a$export$f893891deedab3c6 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: $b0966e39df9c724a$export$a40e8ae3e53feab0
});
const $b0966e39df9c724a$export$bbc05723eb144e03 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("2OtIa", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $94a7203ed38fd013$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $94a7203ed38fd013$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $94a7203ed38fd013$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $94a7203ed38fd013$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $94a7203ed38fd013$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $94a7203ed38fd013$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $94a7203ed38fd013$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $94a7203ed38fd013$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $94a7203ed38fd013$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $94a7203ed38fd013$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $94a7203ed38fd013$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $94a7203ed38fd013$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $94a7203ed38fd013$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $94a7203ed38fd013$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $94a7203ed38fd013$export$c3d20e8c1e93a572);

var $eJOHy = parcelRequire("eJOHy");

var $jhs3c = parcelRequire("jhs3c");

var $4Wnht = parcelRequire("4Wnht");

var $cMTOh = parcelRequire("cMTOh");

var $hf4h9 = parcelRequire("hf4h9");
const $94a7203ed38fd013$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $94a7203ed38fd013$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$94a7203ed38fd013$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $94a7203ed38fd013$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $94a7203ed38fd013$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $94a7203ed38fd013$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $94a7203ed38fd013$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $94a7203ed38fd013$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $94a7203ed38fd013$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $94a7203ed38fd013$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $94a7203ed38fd013$export$389b0273703d5c48(sections)
    };
};
const $94a7203ed38fd013$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $94a7203ed38fd013$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$94a7203ed38fd013$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$94a7203ed38fd013$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$94a7203ed38fd013$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $94a7203ed38fd013$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $94a7203ed38fd013$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $94a7203ed38fd013$export$daa5beabdf8d9fc3 = (event)=>(0, $4Wnht.isMacOs)() ? event.metaKey : event.ctrlKey;
const $94a7203ed38fd013$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $hf4h9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $hf4h9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $hf4h9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $94a7203ed38fd013$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $94a7203ed38fd013$export$fa1c95a5ffa92036 = (str)=>(0, $jhs3c.createHash)().update(str).digest('hex');
const $94a7203ed38fd013$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $94a7203ed38fd013$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $94a7203ed38fd013$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $94a7203ed38fd013$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("4Wnht", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $54e7240a1362d417$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $54e7240a1362d417$export$fe66dae91c68619b);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $54e7240a1362d417$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $54e7240a1362d417$export$fe66dae91c68619b = ()=>$54e7240a1362d417$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("cMTOh", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $8120698a127d7ee3$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $8120698a127d7ee3$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $8120698a127d7ee3$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $8120698a127d7ee3$export$894e19fc96687503);
// EVENT TYPES
const $8120698a127d7ee3$export$a1562d08625f5d7e = 'UI';
const $8120698a127d7ee3$export$947dac6c72b26f81 = 'TRACK';
const $8120698a127d7ee3$export$f1d537d508d2945a = 'SCREEN';
const $8120698a127d7ee3$export$12346a674644c156 = 'OPERATIONAL';
var $8120698a127d7ee3$export$1ee9d153576afd13 = /*#__PURE__*/ function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
    return SHORTCUT_ELEMENT_TYPES;
}({});
const $8120698a127d7ee3$export$894e19fc96687503 = 250;

});

parcelRegister("hf4h9", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $1ef2266e5ff751a8$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $1ef2266e5ff751a8$export$904b2a0e38a1bef3);
var $1ef2266e5ff751a8$export$f041b1b117ab382f = /*#__PURE__*/ function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
    return CommandActionType;
}({});
const $1ef2266e5ff751a8$export$3e448fd53031e13c = Object.values($1ef2266e5ff751a8$export$f041b1b117ab382f);
const $1ef2266e5ff751a8$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("1kl5C", function(module, exports) {

$parcel$export(module.exports, "actions", () => $fa5d3433a241f524$export$e324594224ef24da);

var $jvwCK = parcelRequire("jvwCK");

var $aXKmr = parcelRequire("aXKmr");

var $jwVGf = parcelRequire("jwVGf");

var $7bnK6 = parcelRequire("7bnK6");

var $4Wnht = parcelRequire("4Wnht");

var $gYnSx = parcelRequire("gYnSx");

var $cMTOh = parcelRequire("cMTOh");

var $hf4h9 = parcelRequire("hf4h9");

var $2OtIa = parcelRequire("2OtIa");

var $1tIH1 = parcelRequire("1tIH1");

var $aJbE4 = parcelRequire("aJbE4");

var $7RhQ7 = parcelRequire("7RhQ7");
const $fa5d3433a241f524$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $fa5d3433a241f524$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        if (!getState().isOpen) (0, $7bnK6.default)('command-palette-opened');
        setState({
            commandPaletteSessionId: (0, $aXKmr.v4)(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $fa5d3433a241f524$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$fa5d3433a241f524$var$rootCommands
        });
    };
const $fa5d3433a241f524$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, $aXKmr.v4)() : '',
            ...!isOpen ? $fa5d3433a241f524$var$rootCommands : {}
        });
    };
const $fa5d3433a241f524$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $fa5d3433a241f524$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $fa5d3433a241f524$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $fa5d3433a241f524$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $fa5d3433a241f524$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $fa5d3433a241f524$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $fa5d3433a241f524$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $cMTOh.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $fa5d3433a241f524$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $fa5d3433a241f524$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $fa5d3433a241f524$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $2OtIa.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $fa5d3433a241f524$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $7bnK6.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $cMTOh.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $gYnSx.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $jwVGf.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $fa5d3433a241f524$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $1tIH1.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $2OtIa.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        (0, $7RhQ7.setEventAttribute)(analyticsAttributes);
        const currentCommandAction = (0, $2OtIa.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $cMTOh.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $2OtIa.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $hf4h9.CommandActionType).PERFORM;
        if (command.mode) newState.shouldForceSearchValue = true;
        if (shouldLoadChildren) {
            (0, $7bnK6.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $aJbE4.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $hf4h9.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $cMTOh.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $cMTOh.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $4Wnht.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $7bnK6.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $cMTOh.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $gYnSx.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $jwVGf.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $fa5d3433a241f524$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $fa5d3433a241f524$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $fa5d3433a241f524$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $fa5d3433a241f524$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $fa5d3433a241f524$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $fa5d3433a241f524$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $fa5d3433a241f524$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $fa5d3433a241f524$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $fa5d3433a241f524$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $fa5d3433a241f524$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $fa5d3433a241f524$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $fa5d3433a241f524$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $fa5d3433a241f524$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $fa5d3433a241f524$export$e324594224ef24da = {
    open: $fa5d3433a241f524$var$open,
    toggle: $fa5d3433a241f524$var$toggle,
    close: $fa5d3433a241f524$var$close,
    addCommands: $fa5d3433a241f524$var$addCommands,
    removeCommands: $fa5d3433a241f524$var$removeCommands,
    handleSearch: $fa5d3433a241f524$var$handleSearch,
    forceFocusSearch: $fa5d3433a241f524$var$forceFocusSearch,
    setActiveIndex: $fa5d3433a241f524$var$setActiveIndex,
    executeCommand: $fa5d3433a241f524$var$executeCommand,
    goBackLevel: $fa5d3433a241f524$var$goBackLevel,
    setChildCommands: $fa5d3433a241f524$var$setChildCommands,
    setLoadingList: $fa5d3433a241f524$var$setLoadingList,
    setFocusInput: $fa5d3433a241f524$var$setFocusInput,
    registerSections: $fa5d3433a241f524$var$registerSections,
    unregisterSections: $fa5d3433a241f524$var$unregisterSections,
    markAsLoaded: $fa5d3433a241f524$var$markAsLoaded,
    getAnalyticsAttributes: $fa5d3433a241f524$var$getAnalyticsAttributes,
    setIsDisabled: $fa5d3433a241f524$var$setIsDisabled,
    setRegistry: $fa5d3433a241f524$var$setRegistry,
    updateActiveRegistry: $fa5d3433a241f524$var$updateActiveRegistry,
    removeCommandsById: $fa5d3433a241f524$var$removeCommandsById,
    removeFromActiveRegistry: $fa5d3433a241f524$var$removeFromActiveRegistry,
    performDialogCloseCommand: $fa5d3433a241f524$var$performDialogCloseCommand,
    setAnalytics: $fa5d3433a241f524$var$setAnalytics,
    setFallbackOverride: $fa5d3433a241f524$var$setFallbackOverride,
    setHasPopupOverlay: $fa5d3433a241f524$var$setHasPopupOverlay,
    forceSearchValue: $fa5d3433a241f524$var$forceSearchValue,
    resetShouldForceSearchValue: $fa5d3433a241f524$var$resetShouldForceSearchValue
};

});
parcelRegister("1tIH1", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $494c53c0493f50d3$export$639b7f41b0b47a01);

var $hf4h9 = parcelRequire("hf4h9");
const $494c53c0493f50d3$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("aJbE4", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $8d0720613ed3e2cc$export$d75616d77443fe4e);

var $hf4h9 = parcelRequire("hf4h9");
const $8d0720613ed3e2cc$export$d75616d77443fe4e = (action)=>action?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});

parcelRegister("7RhQ7", function(module, exports) {

$parcel$export(module.exports, "setEventAttribute", () => $45c284350ab5fd95$export$7c0a9f4caaf7cfce);

var $814y1 = parcelRequire("814y1");

var $d2AGn = parcelRequire("d2AGn");
const $45c284350ab5fd95$var$ACTIONS_TO_WATCH = [
    'unassign',
    'assignToMe'
];
const $45c284350ab5fd95$export$7c0a9f4caaf7cfce = (attributes)=>{
    if (attributes.actionCategory === 'issueActions' && typeof attributes.action === 'string' && $45c284350ab5fd95$var$ACTIONS_TO_WATCH.includes(attributes.action)) (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setAttributes((0, $814y1.ASSIGNEE_TYPE), {
        isCommandPaletteEditing: true
    });
};

});
parcelRegister("d2AGn", function(module, exports) {

$parcel$export(module.exports, "eventFlowManager", () => $84369507dcd887ed$export$87846400a9b428fc);
$parcel$export(module.exports, "getUpdateAnalyticsFlowHelper", () => $84369507dcd887ed$export$f3b2b77402b2631f);

var $aXKmr = parcelRequire("aXKmr");

var $eSnSE = parcelRequire("eSnSE");

var $gCeeo = parcelRequire("gCeeo");

var $3bSs8 = parcelRequire("3bSs8");

var $aW71L = parcelRequire("aW71L");
/**
 * A singleton class to provide a sessionId to track update of fields
 */ class $84369507dcd887ed$var$EventFlowManager {
    reset() {
        this.ids.clear();
        this.extraAttributes.clear();
    }
    push(key) {
        const id = (0, $aXKmr.v4)();
        this.ids.set(key, id);
        return id;
    }
    pull(key, shouldDelete = true) {
        const value = this.ids.get(key);
        if (shouldDelete) this.ids.delete(key);
        return value;
    }
    constructor(){
        this.ids = new Map();
        this.extraAttributes = new Map();
    }
}
const $84369507dcd887ed$export$87846400a9b428fc = new $84369507dcd887ed$var$EventFlowManager();
/**
 * Concatenates updateSessionId, default attributes and the attributes sent through
 *  the event and/or setAttributes
 */ const $84369507dcd887ed$var$concatAttributes = (fieldKey, updateSessionId, attributes)=>{
    let fieldTypeValue = attributes.fieldType;
    const extraAttributes = $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.get(fieldKey);
    fieldTypeValue = extraAttributes?.fieldType ?? fieldTypeValue;
    const fieldType = fieldTypeValue && (0, $3bSs8.FIELD_TYPE_MAP)[fieldTypeValue] ? (0, $3bSs8.FIELD_TYPE_MAP)[fieldTypeValue] : fieldTypeValue;
    return {
        updateSessionId: updateSessionId,
        ...(0, $3bSs8.DEFAULT_ATTRIBUTES),
        ...attributes,
        ...extraAttributes,
        fieldKey: fieldKey,
        fieldType: fieldType
    };
};
const $84369507dcd887ed$var$hasError = (e)=>e instanceof Error;
/**
 * Provides three events START {@link fireAnalyticsStart},
 * END {@link fireAnalyticsEnd} to track the user flow when updating
 * a field and setAttributes{@link setAttributes} to set specific
 * fields attributes
 */ const $84369507dcd887ed$var$updateAnalyticsFlowHelper = {
    fireAnalyticsStart (fieldKey, params) {
        try {
            const { assigneeId: assigneeId, product: product } = (0, $aW71L.getContextAssigneeIdAndProduct)(params.analytics.context);
            if (product === 'serviceDesk') return;
            $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                ...params.attributes,
                assigneeId: assigneeId
            });
            const sessionid = $84369507dcd887ed$export$87846400a9b428fc.push(fieldKey);
            const attributes = $84369507dcd887ed$var$concatAttributes(fieldKey, sessionid, params.attributes);
            attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $gCeeo.fireUIAnalytics)(params.analytics, `${(0, $3bSs8.START_ACTION_SUBJECT)} ${(0, $3bSs8.START_ACTION)}`, (0, $3bSs8.START_ACTION_SUBJECT_ID), attributes);
        } catch (e) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsStart', $84369507dcd887ed$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    fireAnalyticsEnd (fieldKey, params, isEndOfSession = true) {
        try {
            if ((0, $aW71L.getContextProduct)(params.analytics.context) === 'serviceDesk') return;
            const sessionid = $84369507dcd887ed$export$87846400a9b428fc.pull(fieldKey, isEndOfSession);
            const isFieldKeyUnknown = (0, $3bSs8.UNKNOWN_FIELD_IDS).includes(fieldKey);
            const actualFieldKey = isFieldKeyUnknown && params.attributes.fieldKey && typeof params.attributes.fieldKey === 'string' ? params.attributes.fieldKey : fieldKey;
            const attributes = $84369507dcd887ed$var$concatAttributes(actualFieldKey, sessionid, params.attributes);
            if (isEndOfSession) {
                if (isFieldKeyUnknown) $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
                $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.delete(actualFieldKey);
            }
            attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $gCeeo.fireTrackAnalytics)(params.analytics, `${(0, $3bSs8.END_ACTION_SUBJECT)} ${(0, $3bSs8.END_ACTION)}`, (0, $3bSs8.END_ACTION_SUBJECT_ID), {
                ...attributes,
                is_new_1event: true
            });
        } catch (e) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsEnd', $84369507dcd887ed$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    setAttributes (fieldKey, attributes) {
        const currentAttributes = $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.get(fieldKey);
        $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
            ...currentAttributes,
            ...attributes
        });
    },
    setActionTakenAttributes (fieldKey, oldValId, newValId) {
        if (oldValId !== newValId) this.setAttributes(fieldKey, {
            oldValId: oldValId,
            newValId: newValId,
            actionTaken: (0, $aW71L.getActionTaken)(oldValId, newValId)
        });
    },
    // Use this to clean up session without firing analytics event. This happens for entity fields when
    // multiple end events can be fired after a start event
    endSession (fieldKey) {
        $84369507dcd887ed$export$87846400a9b428fc.pull(fieldKey);
        $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
    },
    reset () {
        $84369507dcd887ed$export$87846400a9b428fc.reset();
    }
};
const $84369507dcd887ed$export$f3b2b77402b2631f = ()=>$84369507dcd887ed$var$updateAnalyticsFlowHelper;

});
parcelRegister("3bSs8", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ATTRIBUTES", () => $0694d3ffaf31cb5e$export$69665899d8392309);
$parcel$export(module.exports, "START_ACTION", () => $0694d3ffaf31cb5e$export$c0a4673e0c78e972);
$parcel$export(module.exports, "START_ACTION_SUBJECT", () => $0694d3ffaf31cb5e$export$34a5ae354a38cc7e);
$parcel$export(module.exports, "START_ACTION_SUBJECT_ID", () => $0694d3ffaf31cb5e$export$bc373f59492dc6e2);
$parcel$export(module.exports, "END_ACTION", () => $0694d3ffaf31cb5e$export$b19686c1fe99f85a);
$parcel$export(module.exports, "END_ACTION_SUBJECT", () => $0694d3ffaf31cb5e$export$4ce67e80878d47ed);
$parcel$export(module.exports, "END_ACTION_SUBJECT_ID", () => $0694d3ffaf31cb5e$export$e3d957ccc2d46469);
$parcel$export(module.exports, "ACTION_TAKEN_ADD", () => $0694d3ffaf31cb5e$export$3b3e3ac6d7f6e219);
$parcel$export(module.exports, "ACTION_TAKEN_REMOVE", () => $0694d3ffaf31cb5e$export$6137e1b2fcde2333);
$parcel$export(module.exports, "DRAG_DROP_UNKNOWN_FIELD_ID", () => $0694d3ffaf31cb5e$export$6d8c364f9d389764);
$parcel$export(module.exports, "UNKNOWN_FIELD_IDS", () => $0694d3ffaf31cb5e$export$7d1d20ff891eeb26);
$parcel$export(module.exports, "FIELD_TYPE_MAP", () => $0694d3ffaf31cb5e$export$d8ccf495ccc97a69);
$parcel$export(module.exports, "ENTITY_FIELD_KEYS", () => $0694d3ffaf31cb5e$export$7d9dd31e187cb2db);

var $814y1 = parcelRequire("814y1");
const $0694d3ffaf31cb5e$export$69665899d8392309 = {
    isInlineEditing: false,
    isCommandPaletteEditing: false,
    isDragEditing: false,
    isContextMenuEditing: false,
    isIssueViewEditing: false
};
const $0694d3ffaf31cb5e$export$c0a4673e0c78e972 = 'clicked';
const $0694d3ffaf31cb5e$export$34a5ae354a38cc7e = 'item';
const $0694d3ffaf31cb5e$export$bc373f59492dc6e2 = 'issue';
const $0694d3ffaf31cb5e$export$b19686c1fe99f85a = 'updated';
const $0694d3ffaf31cb5e$export$4ce67e80878d47ed = 'issue';
const $0694d3ffaf31cb5e$export$e3d957ccc2d46469 = 'ended';
const $0694d3ffaf31cb5e$export$3b3e3ac6d7f6e219 = 'add';
const $0694d3ffaf31cb5e$export$6137e1b2fcde2333 = 'remove';
const $0694d3ffaf31cb5e$export$6d8c364f9d389764 = 'unknown';
const $0694d3ffaf31cb5e$export$7d1d20ff891eeb26 = [
    $0694d3ffaf31cb5e$export$6d8c364f9d389764
];
const $0694d3ffaf31cb5e$export$403ea87111529de = {
    [(0, $814y1.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $814y1.FIX_VERSIONS_TYPE)]: 'versions',
    [(0, $814y1.VERSION_CF_TYPE)]: 'versions',
    [(0, $814y1.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $814y1.SPRINT_TYPE)]: 'link',
    [(0, $814y1.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $814y1.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $814y1.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $814y1.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $814y1.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $814y1.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $814y1.USER_CF_TYPE)]: 'singleUser',
    [(0, $814y1.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $814y1.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $814y1.URL_CF_TYPE)]: 'url',
    [(0, $814y1.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $814y1.MULTI_GROUP_CF_TYPE)]: 'multiGroup'
};
const $0694d3ffaf31cb5e$export$d8ccf495ccc97a69 = {
    [(0, $814y1.AFFECTS_VERSIONS_TYPE)]: 'affectsVersions',
    [(0, $814y1.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $814y1.ATTACHMENT_TYPE)]: 'attachment',
    [(0, $814y1.CASCADING_SELECT_CF_TYPE)]: 'cascadingSelect',
    [(0, $814y1.COMPONENTS_TYPE)]: 'components',
    [(0, $814y1.DATE_CF_TYPE)]: 'date',
    [(0, $814y1.DATETIME_CF_TYPE)]: 'dateTime',
    [(0, $814y1.DESCRIPTION_TYPE)]: 'richText',
    [(0, $814y1.DUE_DATE_TYPE)]: 'date',
    [(0, $814y1.FIX_VERSIONS_TYPE)]: 'fixVersions',
    [(0, $814y1.FLAGGED_CF_TYPE)]: 'flag',
    [(0, $814y1.GOALS_CF_TYPE)]: 'goals',
    [(0, $814y1.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $814y1.ISSUE_TYPE)]: 'issuetype',
    [(0, $814y1.LABELS_CF_TYPE)]: 'labels',
    [(0, $814y1.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $814y1.MULTI_GROUP_CF_TYPE)]: 'multiGroup',
    [(0, $814y1.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $814y1.MULTI_USER_CF_TYPE)]: 'multiUser',
    [(0, $814y1.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $814y1.NUMBER_CF_TYPE)]: 'float',
    [(0, $814y1.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $814y1.PARENT_TYPE)]: 'parent',
    [(0, $814y1.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $814y1.PRIORITY_TYPE)]: 'priority',
    [(0, $814y1.PROJECT_PICKER_CF_TYPE)]: 'project',
    [(0, $814y1.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $814y1.RANK_CF_TYPE)]: 'rank',
    [(0, $814y1.START_DATE_TYPE)]: 'date',
    [(0, $814y1.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $814y1.SPRINT_TYPE)]: 'sprint',
    [(0, $814y1.STATUS_TYPE)]: 'status',
    [(0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE)]: 'storyPointEstimate',
    [(0, $814y1.STORY_POINTS_TYPE)]: 'storyPointEstimate',
    [(0, $814y1.SUMMARY_TYPE)]: 'singleLineText',
    [(0, $814y1.TEAMS_PLATFORM_CF_TYPE)]: 'team',
    [(0, $814y1.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $814y1.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $814y1.TIME_ESTIMATE_TYPE)]: 'originalTimeEstimate',
    [(0, $814y1.TIME_TRACKING_TYPE)]: 'timeTracking',
    [(0, $814y1.URL_CF_TYPE)]: 'url',
    [(0, $814y1.USER_CF_TYPE)]: 'singleUser',
    [(0, $814y1.VERSION_CF_TYPE)]: 'version',
    [(0, $814y1.VOTES_TYPE)]: 'votes',
    [(0, $814y1.WATCHES_TYPE)]: 'watchers'
};
const $0694d3ffaf31cb5e$export$7d9dd31e187cb2db = {
    WEB_LINK: 'weblink',
    ATTACHMENT: 'attachment',
    ISSUE_LINKS: 'linkIssue',
    PARENT: 'parent'
};

});

parcelRegister("aW71L", function(module, exports) {

$parcel$export(module.exports, "getActionTaken", () => $56306893bffbb0cd$export$9d814e3464362b48);
$parcel$export(module.exports, "getContextAssigneeIdAndProduct", () => $56306893bffbb0cd$export$e6dd41ec8f1794f6);
$parcel$export(module.exports, "getContextProduct", () => $56306893bffbb0cd$export$4cb0aa9574634a48);

var $3bSs8 = parcelRequire("3bSs8");
const $56306893bffbb0cd$export$9d814e3464362b48 = (oldValId, newValId)=>{
    if (oldValId !== newValId) {
        if (newValId === null) return 0, $3bSs8.ACTION_TAKEN_REMOVE;
        if (oldValId === null || oldValId === undefined) return 0, $3bSs8.ACTION_TAKEN_ADD;
    }
    return undefined;
};
const $56306893bffbb0cd$export$e6dd41ec8f1794f6 = (context)=>{
    let assigneeId;
    let product;
    for (const item of context){
        if (item?.attributes?.assigneeId) assigneeId = item.attributes.assigneeId;
        if (item?.attributes?.previousSubProduct) product = item.attributes.previousSubProduct;
        if (assigneeId && product) break;
    }
    return {
        assigneeId: assigneeId,
        product: product
    };
};
const $56306893bffbb0cd$export$4cb0aa9574634a48 = (context)=>{
    for (const item of context){
        if (item?.attributes?.previousSubProduct) return item.attributes.previousSubProduct;
    }
};

});






parcelRegister("84DOT", function(module, exports) {

$parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", () => $0cf751b242c962b3$export$a05673a22505d5ee);
$parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", () => $0cf751b242c962b3$export$c78d329777576aa0);
$parcel$export(module.exports, "MOBILE_GLOBAL_CREATE_BUTTON", () => $0cf751b242c962b3$export$992ab052fd10f8e8);
$parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", () => $0cf751b242c962b3$export$affdc3af7a9a4677);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", () => $0cf751b242c962b3$export$7e9cfd1f59e60910);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", () => $0cf751b242c962b3$export$708499dcd016e5e9);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", () => $0cf751b242c962b3$export$e1c8789144c4c810);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", () => $0cf751b242c962b3$export$c5afabb7a17e802);
$parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", () => $0cf751b242c962b3$export$2086a63173b79b56);
$parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", () => $0cf751b242c962b3$export$fe1e5e4597147709);
$parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", () => $0cf751b242c962b3$export$9bc326812a93707);
$parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", () => $0cf751b242c962b3$export$f352934e06f44599);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", () => $0cf751b242c962b3$export$6ae07c77acc64360);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", () => $0cf751b242c962b3$export$b41d0684e4b6ab1);
$parcel$export(module.exports, "JSM_CREATE_PROBLEM_FROM_INCIDENT_AI", () => $0cf751b242c962b3$export$1110454816343634);
$parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", () => $0cf751b242c962b3$export$be9b2b1329ff7ec9);
$parcel$export(module.exports, "JSM_PROJECT_SUMMARY_CREATE_REQUEST", () => $0cf751b242c962b3$export$bc365eb0775af583);
$parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", () => $0cf751b242c962b3$export$aa348159181703a0);
$parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", () => $0cf751b242c962b3$export$f90eec3841adf619);
$parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", () => $0cf751b242c962b3$export$718822a309bffada);
$parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", () => $0cf751b242c962b3$export$2753dafac81e805c);
$parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", () => $0cf751b242c962b3$export$7c4d5cc5711d9294);
$parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", () => $0cf751b242c962b3$export$998dfc72404b9e14);
$parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", () => $0cf751b242c962b3$export$fc180a4b5785d2f4);
$parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", () => $0cf751b242c962b3$export$946ec0b21cb84fd0);
$parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", () => $0cf751b242c962b3$export$5b97e2844e620e54);
$parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", () => $0cf751b242c962b3$export$b99842c2cf46f6be);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", () => $0cf751b242c962b3$export$8d987f6e80b74000);
$parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", () => $0cf751b242c962b3$export$8de9fa43731c4b5b);
$parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", () => $0cf751b242c962b3$export$87249ccbfd10fb78);
$parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", () => $0cf751b242c962b3$export$c0eeeb31d264de76);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", () => $0cf751b242c962b3$export$f546e18e46478c84);
$parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", () => $0cf751b242c962b3$export$1784e634ba79f1f9);
$parcel$export(module.exports, "JWM_INLINE_CREATE", () => $0cf751b242c962b3$export$145eb8935a34e85e);
$parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", () => $0cf751b242c962b3$export$32648b574a536c8b);
$parcel$export(module.exports, "JIRA_ISSUE_COMMENT", () => $0cf751b242c962b3$export$220cd7b39e0b57a);
$parcel$export(module.exports, "JIRA_INBOX_CREATE_WORK_ITEM", () => $0cf751b242c962b3$export$ab926dced0f69c1e);
$parcel$export(module.exports, "UC_ATLASSIAN_HOME_CREATE_ISSUE", () => $0cf751b242c962b3$export$d3df6a0ce4e0bc8b);
$parcel$export(module.exports, "JIRA_ISSUE_TABLE_TRIGGER", () => $0cf751b242c962b3$export$99b5cdc74c6071b4);
$parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", () => $0cf751b242c962b3$export$c0e2ab74dfaa67cc);
$parcel$export(module.exports, "LIST_OF_CHILD_ISSUES_TRIGGER_POINTS", () => $0cf751b242c962b3$export$7a8328e1f8bd992b);
const $0cf751b242c962b3$export$a05673a22505d5ee = 'forge-open-issue-create';
const $0cf751b242c962b3$export$c78d329777576aa0 = 'global-create-button';
const $0cf751b242c962b3$export$992ab052fd10f8e8 = 'mobile-global-create-button';
const $0cf751b242c962b3$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $0cf751b242c962b3$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $0cf751b242c962b3$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $0cf751b242c962b3$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $0cf751b242c962b3$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $0cf751b242c962b3$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $0cf751b242c962b3$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $0cf751b242c962b3$export$9bc326812a93707 = 'jsw-security-create-issue';
const $0cf751b242c962b3$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $0cf751b242c962b3$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $0cf751b242c962b3$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $0cf751b242c962b3$export$1110454816343634 = 'jsm-create-problem-from-incident-ai';
const $0cf751b242c962b3$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $0cf751b242c962b3$export$bc365eb0775af583 = 'jsm-project-summary-create-request';
const $0cf751b242c962b3$export$235b856f54db8916 = 'jwm-board-create-issue';
const $0cf751b242c962b3$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $0cf751b242c962b3$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $0cf751b242c962b3$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $0cf751b242c962b3$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $0cf751b242c962b3$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $0cf751b242c962b3$export$aa348159181703a0 = 'software-create-issue-dialog';
const $0cf751b242c962b3$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $0cf751b242c962b3$export$718822a309bffada = 'create-linked-issue-command-palette';
const $0cf751b242c962b3$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $0cf751b242c962b3$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $0cf751b242c962b3$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $0cf751b242c962b3$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $0cf751b242c962b3$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $0cf751b242c962b3$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $0cf751b242c962b3$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $0cf751b242c962b3$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $0cf751b242c962b3$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $0cf751b242c962b3$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $0cf751b242c962b3$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $0cf751b242c962b3$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $0cf751b242c962b3$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $0cf751b242c962b3$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $0cf751b242c962b3$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $0cf751b242c962b3$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $0cf751b242c962b3$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $0cf751b242c962b3$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $0cf751b242c962b3$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $0cf751b242c962b3$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $0cf751b242c962b3$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $0cf751b242c962b3$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $0cf751b242c962b3$export$145eb8935a34e85e = 'jwm-inline-create';
const $0cf751b242c962b3$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $0cf751b242c962b3$export$818f24c6c32e18a = 'jira-calendar-create-issue';
const $0cf751b242c962b3$export$220cd7b39e0b57a = 'jira-issue-comment';
const $0cf751b242c962b3$export$ab926dced0f69c1e = 'jira-inbox-create-work-item';
const $0cf751b242c962b3$export$d3df6a0ce4e0bc8b = 'uc-atlassian-home-create-issue';
const $0cf751b242c962b3$export$99b5cdc74c6071b4 = 'jira-issue-table-trigger';
const $0cf751b242c962b3$export$c0e2ab74dfaa67cc = {
    FIELD_IDS: [
        'description'
    ],
    TRIGGER_POINTS: [
        'service-desk-gen-ai-pir'
    ]
};
const $0cf751b242c962b3$export$7a8328e1f8bd992b = [
    $0cf751b242c962b3$export$7e9cfd1f59e60910,
    $0cf751b242c962b3$export$708499dcd016e5e9,
    $0cf751b242c962b3$export$e1c8789144c4c810,
    $0cf751b242c962b3$export$c5afabb7a17e802
];

});

parcelRegister("jipjz", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $fd6d975a09a2a8e6$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $fd6d975a09a2a8e6$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $fd6d975a09a2a8e6$export$558a195c5bfe3787);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $iIqFO = parcelRequire("iIqFO");

var $3UrQk = parcelRequire("3UrQk");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $dRfS0 = parcelRequire("dRfS0");

var $eJrcF = parcelRequire("eJrcF");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

var $7jTnu = parcelRequire("7jTnu");

var $84DOT = parcelRequire("84DOT");

var $bitlK = parcelRequire("bitlK");

var $hBHUL = parcelRequire("hBHUL");
const $fd6d975a09a2a8e6$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $3UrQk.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // onSiteSelection is called when a site is selected in the site picker
    onSiteSelection: null,
    // onProjectSelection is called when a project is selected in the project picker
    onProjectSelection: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $84DOT.TRIGGER_POINT_KEY_NOT_DEFINED),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // optional component - Renders external component above form fields
    ExternalControls: undefined,
    // Analytics property for board with custom filter and icc enabled
    // Delete when cleaning up remove_temporary_analytics_attributes_icc
    isCustomBoardWithIcc: false,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // Analytics property for board with swimlane enabled
    // Delete when cleaning up remove_temporary_analytics_attributes_icc
    swimlaneMode: undefined,
    // prefilled custom Fields if any
    prefilledCustomFields: {},
    // callback for ecosystem API to execute
    ecosystemCallback: undefined,
    // product where issue create anywhere modal is used
    product: undefined,
    // what's the consumer of the issue create anywhere modal in a product
    actionSource: undefined,
    // Field IDs that will remain visible even when the smart fields feature recommends them to be hidden.
    optOutSmartFieldIds: undefined,
    // refrence of the button from where GIC modal is triggered
    triggerButtonRef: null
};
const $fd6d975a09a2a8e6$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $hBHUL.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $hBHUL.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $hBHUL.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $hBHUL.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $fd6d975a09a2a8e6$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                if ((0, $7jTnu.fg)('fix-gryf-a11y-issues')) {
                    /*
					 * This is done to always focus the Issue Create Modal trigger button whenever it's clicked
					 * so that we can store the reference of this
					 * and use that to re-focus the button whenever the modal is closed
					 */ let triggerButton;
                    const handleButtonClick = (event)=>{
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        const triggerButtonTarget = event.target;
                        triggerButton = triggerButtonTarget?.closest('button');
                        triggerButton?.focus();
                    };
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    document.addEventListener('click', handleButtonClick);
                    setTimeout(()=>{
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        document.removeEventListener('click', handleButtonClick);
                    }, 0);
                    setTimeout(()=>{
                        setState({
                            ...$fd6d975a09a2a8e6$export$d4c72bab9d6cc13a,
                            ...isDiscoverabilityPushEnabled && {
                                minimizableModalView: nextModalView,
                                persistentModalView: currentState.persistentModalView,
                                ...(0, $hBHUL.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                            },
                            inProgressIssueID: (0, $aXKmr.v4)(),
                            isSubsequentLoad: currentState.isSubsequentLoad,
                            isModalOpen: true,
                            wasModalRetriggered: currentState.isModalOpen,
                            ...(0, $7jTnu.fg)('quick_actions_with_hotkeys_ga') ? {
                                triggeredViaHotKey: !!nextState?.triggeredViaHotKey
                            } : {},
                            ...nextState,
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
                            triggerButtonRef: triggerButton || document.activeElement
                        });
                    }, 0);
                } else setState({
                    ...$fd6d975a09a2a8e6$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $hBHUL.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, $aXKmr.v4)(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...(0, $7jTnu.fg)('quick_actions_with_hotkeys_ga') ? {
                        triggeredViaHotKey: !!nextState?.triggeredViaHotKey
                    } : {},
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $hBHUL.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$fd6d975a09a2a8e6$export$d4c72bab9d6cc13a,
                callbackPayload: undefined,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $iIqFO.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $hBHUL.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$fd6d975a09a2a8e6$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $fd6d975a09a2a8e6$var$store = (0, $GtRbT.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $fd6d975a09a2a8e6$export$d4c72bab9d6cc13a,
    actions: $fd6d975a09a2a8e6$export$e324594224ef24da
});
const $fd6d975a09a2a8e6$var$useTriggerIssueCreateModalState = (0, $iJq0l.createStateHook)($fd6d975a09a2a8e6$var$store);
const $fd6d975a09a2a8e6$var$useTriggerIssueCreateModalActions = (0, $iJq0l.createActionsHook)($fd6d975a09a2a8e6$var$store);
const $fd6d975a09a2a8e6$export$71e0eb7b8a91a156 = ()=>{
    const createState = $fd6d975a09a2a8e6$var$useTriggerIssueCreateModalState();
    const createActions = $fd6d975a09a2a8e6$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $eJOHy.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.addChildWorkItemTriggerSource && (0, $7jTnu.fg)('jira-contextual-create-child-linked-entrypoint-fg') ? {
                addChildWorkItemTriggerSource: nextState?.addChildWorkItemTriggerSource
            } : {},
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {}
        };
        (0, $gCeeo.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $fd6d975a09a2a8e6$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $fd6d975a09a2a8e6$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [, { setSitePickerState: setSitePickerState }] = (0, $bitlK.useSitePickerContext)();
    return (0, $eJOHy.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {},
            ...nextState?.addChildWorkItemTriggerSource && (0, $7jTnu.fg)('jira-contextual-create-child-linked-entrypoint-fg') ? {
                addChildWorkItemTriggerSource: nextState?.addChildWorkItemTriggerSource
            } : {}
        };
        (0, $gCeeo.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        // overrideCloudId only used for embedded GIC
        if (nextState?.payload?.overrideCloudId) // set cloudId inside the state if there's an override
        setSitePickerState({
            selectedCloudId: nextState?.payload?.overrideCloudId
        });
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal,
        setSitePickerState
    ]);
};
const $fd6d975a09a2a8e6$export$4c674fe824b8f278 = (0, $ht3nQ.createSubscriber)($fd6d975a09a2a8e6$var$store);
function $fd6d975a09a2a8e6$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $fd6d975a09a2a8e6$export$71e0eb7b8a91a156();
        const { data: data } = (0, $eJrcF.useResource)((0, $dRfS0.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("iIqFO", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $e524612cc2a761dc$export$cd75c112ac11a83b);
$parcel$export(module.exports, "EditIssueTypeUFOExperience", () => $e524612cc2a761dc$export$7d25d25bed94d6e2);
$parcel$export(module.exports, "CreateIssueTypeUFOExperience", () => $e524612cc2a761dc$export$fda88e8e14acb615);
$parcel$export(module.exports, "StatusFieldLoad", () => $e524612cc2a761dc$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $e524612cc2a761dc$export$70208657c8d471a7);
$parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", () => $e524612cc2a761dc$export$b2d8f8edec75f571);

var $aRK4c = parcelRequire("aRK4c");
var $9GzfC = parcelRequire("9GzfC");
const $e524612cc2a761dc$export$cd75c112ac11a83b = new (0, $9GzfC.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $aRK4c.ExperienceTypes).Experience,
    performanceType: (0, $aRK4c.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $e524612cc2a761dc$export$7d25d25bed94d6e2 = new (0, $9GzfC.UFOExperience)('global-issue-create.create-issue.issue-type-field.edit-issue-type', {
    type: (0, $aRK4c.ExperienceTypes).Operation,
    performanceType: (0, $aRK4c.ExperiencePerformanceTypes).Custom
});
const $e524612cc2a761dc$export$fda88e8e14acb615 = new (0, $9GzfC.UFOExperience)('global-issue-create.create-issue.issue-type-field.create-issue-type', {
    type: (0, $aRK4c.ExperienceTypes).Operation,
    performanceType: (0, $aRK4c.ExperiencePerformanceTypes).Custom
});
const $e524612cc2a761dc$export$e890e797a25e655c = new (0, $9GzfC.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $aRK4c.ExperienceTypes).Load,
    performanceType: (0, $aRK4c.ExperiencePerformanceTypes).PageSegmentLoad
});
const $e524612cc2a761dc$export$70208657c8d471a7 = new (0, $9GzfC.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $aRK4c.ExperienceTypes).Experience,
    performanceType: (0, $aRK4c.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});
const $e524612cc2a761dc$export$b2d8f8edec75f571 = new (0, $9GzfC.UFOExperience)('ecosystem-api-new-gic-prefilling', {
    type: (0, $aRK4c.ExperienceTypes).Experience,
    performanceType: (0, $aRK4c.ExperiencePerformanceTypes).Custom,
    category: 'ecosystem-api-new-gic-prefilling'
});

});

parcelRegister("3UrQk", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $7fffaa4718e25dbf$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $7fffaa4718e25dbf$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $7fffaa4718e25dbf$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $7fffaa4718e25dbf$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $7fffaa4718e25dbf$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $7fffaa4718e25dbf$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $7fffaa4718e25dbf$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $7fffaa4718e25dbf$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $7fffaa4718e25dbf$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $7fffaa4718e25dbf$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $7fffaa4718e25dbf$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $7fffaa4718e25dbf$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $7fffaa4718e25dbf$export$8170252f0ea43511);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $7fffaa4718e25dbf$export$17bcab948893a9ba = 'worklog';
const $7fffaa4718e25dbf$export$b1c05b34d317c074 = 'REQUIRED';
const $7fffaa4718e25dbf$export$f10b32dfda12e96e = 'unknown';
const $7fffaa4718e25dbf$export$e5e4b8c32e68dd0b = 'networkError';
const $7fffaa4718e25dbf$export$2d06efb8146cd043 = 'graphQLError';
const $7fffaa4718e25dbf$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $7fffaa4718e25dbf$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $7fffaa4718e25dbf$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $7fffaa4718e25dbf$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $7fffaa4718e25dbf$export$aac4661200ba4104 = 'worklog_startDate';
const $7fffaa4718e25dbf$export$a23c32d5cf54cba0 = 'worklog_description';
const $7fffaa4718e25dbf$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $7fffaa4718e25dbf$export$63fd567c1d0aca19 = [
    ...$7fffaa4718e25dbf$export$74ab3898ae683660,
    $7fffaa4718e25dbf$export$a1a7caa1e4a73c9f,
    $7fffaa4718e25dbf$export$cf70f9220e6a2f50,
    $7fffaa4718e25dbf$export$aac4661200ba4104,
    $7fffaa4718e25dbf$export$a23c32d5cf54cba0
];
const $7fffaa4718e25dbf$export$983715bb9b0f9b2c = {
    [$7fffaa4718e25dbf$export$17bcab948893a9ba]: $7fffaa4718e25dbf$export$63fd567c1d0aca19
};
const $7fffaa4718e25dbf$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $7fffaa4718e25dbf$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $7fffaa4718e25dbf$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $7fffaa4718e25dbf$export$8170252f0ea43511 = 'QuickCreateIssue';

});

parcelRegister("bitlK", function(module, exports) {

$parcel$export(module.exports, "useSitePickerContext", () => $c532dbef0009ad59$export$f8b5aae013e4cf77);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $c532dbef0009ad59$export$d4c72bab9d6cc13a = {
    selectedCloudId: '',
    siteDomain: ''
};
const $c532dbef0009ad59$export$e324594224ef24da = {
    setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                selectedCloudId: selectedCloudId || '',
                siteDomain: siteDomain || ''
            });
        }
};
const $c532dbef0009ad59$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue.fields.site-picker',
    initialState: $c532dbef0009ad59$export$d4c72bab9d6cc13a,
    actions: $c532dbef0009ad59$export$e324594224ef24da
});
const $c532dbef0009ad59$export$f8b5aae013e4cf77 = (0, $iJq0l.createHook)($c532dbef0009ad59$export$6f57813fe9f31bf9);

});

parcelRegister("hBHUL", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $ead5ae5f9543822b$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $ead5ae5f9543822b$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $ead5ae5f9543822b$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $ead5ae5f9543822b$export$720579602bb055a2);

var $7bnK6 = parcelRequire("7bnK6");

var $iIqFO = parcelRequire("iIqFO");

var $bVObd = parcelRequire("bVObd");

var $Gb6hR = parcelRequire("Gb6hR");
const $ead5ae5f9543822b$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $iIqFO.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $bVObd.globalIssueCreateModalLoadSubsequent) : (0, $bVObd.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $7bnK6.default)('global-issue.create-modal-subsequent');
    else (0, $7bnK6.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $Gb6hR.startGlobalIssueCreateTTIWithAdjustments)();
};
const $ead5ae5f9543822b$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $ead5ae5f9543822b$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $ead5ae5f9543822b$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("bVObd", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $4372308d4d36906f$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $4372308d4d36906f$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $4372308d4d36906f$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $4372308d4d36906f$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $4372308d4d36906f$export$c1592e4d8d98963e);

var $4WXKS = parcelRequire("4WXKS");
const $4372308d4d36906f$export$5a01a7fa84b239c8 = (0, $4WXKS.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $4372308d4d36906f$export$c50ad3c31b6fcfc6 = (0, $4WXKS.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $4372308d4d36906f$export$4b2382574525bb0f = (0, $4WXKS.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $4372308d4d36906f$export$7839bdaa2f6a2385 = (0, $4WXKS.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $4372308d4d36906f$export$c1592e4d8d98963e = (0, $4WXKS.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("Gb6hR", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $4ce0298162374e06$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $4ce0298162374e06$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $4ce0298162374e06$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $4ce0298162374e06$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $4ce0298162374e06$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $4ce0298162374e06$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $4ce0298162374e06$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $4ce0298162374e06$export$d86f4868694f2aa7);
/**
 * For issue view, we moved similar constants to view-specific packages.
 * However, for GIC, such a move causes a circular dependency with @atlassian/jira-packages-controllers-use-trigger-issue-create-modal package,
 * since view-specific/gic imports trigger points constants from @atlassian/jira-packages-controllers-use-trigger-issue-create-modal.
 * Therefore, for now, let's keep it here.
 */ 
var $4WXKS = parcelRequire("4WXKS");
const $4ce0298162374e06$export$9f3d6f17e1da7874 = (0, $4WXKS.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ]
});
const $4ce0298162374e06$export$457c9fb71ad5b3a9 = ()=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.start();
};
const $4ce0298162374e06$export$ef664dac649a716c = ()=>$4ce0298162374e06$export$9f3d6f17e1da7874.mark('gic-tti');
const $4ce0298162374e06$export$30ca4c461fab486c = (customData)=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $4ce0298162374e06$export$27f2445288b528c = ()=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.cancel();
};
const $4ce0298162374e06$export$7a2709fc1e33401a = ()=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $4ce0298162374e06$export$cf3893335c93e33b = ()=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $4ce0298162374e06$export$d86f4868694f2aa7 = ()=>{
    $4ce0298162374e06$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});




parcelRegister("1TFt8", function(module, exports) {

$parcel$export(module.exports, "Projects", () => $9ed00373928c2d2a$export$ca6fbb51b35e375c);

var $eJOHy = parcelRequire("eJOHy");

var $8dKc6 = parcelRequire("8dKc6");

var $9pWNg = parcelRequire("9pWNg");

var $9o3jI = parcelRequire("9o3jI");

var $kO1ht = parcelRequire("kO1ht");
const $9ed00373928c2d2a$export$90cfe4f15bb50f58 = ({ open: open, close: close, setOnCloseCallback: setOnCloseCallback })=>{
    const [{ canCreateClassicProject: canCreateClassicProject }] = (0, $8dKc6.useCreateProjectPermission)();
    (0, $eJOHy.useEffect)(()=>{
        open && open({
            source: 'navigationNext',
            isNextGen: !canCreateClassicProject
        });
        setOnCloseCallback && setOnCloseCallback(close);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    return null;
};
const $9ed00373928c2d2a$export$ca6fbb51b35e375c = ()=>{
    const [isProjectCreateDrawerOpen, { off: closeProjectCreateDrawer }] = (0, $9o3jI.useSwitchModals)((0, $kO1ht.MODAL_ID).PROJECT_CREATE);
    if (!isProjectCreateDrawerOpen) return null;
    // ProjectCreateDrawerProvider is in page container/navigaiton
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9pWNg.ProjectCreateDrawerConsumer), null, ({ methods: { open: open, setOnCloseCallback: setOnCloseCallback } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9ed00373928c2d2a$export$90cfe4f15bb50f58, {
            open: open,
            close: closeProjectCreateDrawer,
            setOnCloseCallback: setOnCloseCallback
        }));
};

});
parcelRegister("8dKc6", function(module, exports) {

$parcel$export(module.exports, "useCreateProjectPermission", () => $9fccc9c30225a879$export$c92733e8f8c1640f);
$parcel$export(module.exports, "useCreateProjectPermissionActions", () => $9fccc9c30225a879$export$d2b8d6f60fe99e2a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4TumU = parcelRequire("4TumU");
const $9fccc9c30225a879$var$Store = (0, $GtRbT.createStore)({
    name: 'create-project-permissions',
    initialState: {
        canCreateProject: false,
        shouldDisplayCreateProject: false,
        canCreateClassicProject: false,
        canCreateNextGenProject: false,
        isFetching: false,
        fetchError: null,
        promise: null,
        hasFetchedOnce: false,
        hasSuccessOnce: false
    },
    actions: $4TumU.actions
});
const $9fccc9c30225a879$export$5a47fbae725b8f2 = (0, $6E16M.createContainer)($9fccc9c30225a879$var$Store);
const $9fccc9c30225a879$export$c92733e8f8c1640f = (0, $iJq0l.createHook)($9fccc9c30225a879$var$Store);
const $9fccc9c30225a879$export$d2b8d6f60fe99e2a = (0, $iJq0l.createHook)($9fccc9c30225a879$var$Store, {
    selector: null
});

});
parcelRegister("4TumU", function(module, exports) {

$parcel$export(module.exports, "actions", () => $652d08a3c7ccaa32$export$e324594224ef24da);

var $1Ozm9 = parcelRequire("1Ozm9");
const $652d08a3c7ccaa32$export$963556ef97965f0b = async ()=>{
    const url = '/rest/internal/2/projectpermissions';
    const result = await (0, $1Ozm9.default)(url);
    return result;
};
const $652d08a3c7ccaa32$var$handleFetch = ()=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
    async ({ setState: setState, getState: getState })=>{
        const { isFetching: isFetching } = getState();
        if (!isFetching) try {
            const result = await $652d08a3c7ccaa32$export$963556ef97965f0b();
            setState({
                ...result,
                isFetching: false,
                fetchError: null,
                hasFetchedOnce: true,
                hasSuccessOnce: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                canCreateProject: false,
                canCreateClassicProject: false,
                canCreateNextGenProject: false,
                isFetching: false,
                fetchError: error,
                hasFetchedOnce: true
            });
        }
    };
const $652d08a3c7ccaa32$export$e324594224ef24da = {
    fetchCreateProjectPermission: ()=>async ({ setState: setState, dispatch: dispatch })=>{
            const promise = dispatch($652d08a3c7ccaa32$var$handleFetch());
            setState({
                isFetching: true,
                promise: // @ts-expect-error - TS2322 - Type 'Promise<void>' is not assignable to type 'Promise<undefined>'.
                promise
            });
        }
};

});


parcelRegister("9pWNg", function(module, exports) {

$parcel$export(module.exports, "ProjectCreateDrawerProvider", () => $57e246fe6ba8231d$export$9a1c5dbd93c42bca);
$parcel$export(module.exports, "ProjectCreateDrawerConsumer", () => $57e246fe6ba8231d$export$9a8662cd60931de1);
$parcel$export(module.exports, "useProjectCreateDrawer", () => $57e246fe6ba8231d$export$8172ff4ed0f75a1e);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $dhdXs = parcelRequire("dhdXs");

var $3KcCl = parcelRequire("3KcCl");

var $83DiZ = parcelRequire("83DiZ");

var $g27SL = parcelRequire("g27SL");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $57e246fe6ba8231d$var$Context = /*#__PURE__*/ (0, $eJOHy.createContext)({
    data: {
        shouldRenderDrawer: false,
        isOpen: false,
        isNextGen: false,
        showExperienceSelection: true,
        recommendedTemplate: undefined,
        defaultSelectedTemplateKey: '',
        source: '',
        isTemplatePickerOpenInitially: false,
        isImportProjectOpenInitially: false,
        selectedProjectType: null,
        recommendationSessionId: undefined
    },
    methods: {
        open: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        close: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onCreateStarted: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        setOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        clearOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }
});
const $57e246fe6ba8231d$export$839a70d8fbc9d356 = class ProjectCreateDrawerProvider extends (0, $eJOHy.Component) {
    render() {
        const { children: children } = this.props;
        const { isOpen: isOpen, isNextGen: isNextGen, source: source, showExperienceSelection: showExperienceSelection, shouldRenderDrawer: shouldRenderDrawer, recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey, isTemplatePickerOpenInitially: isTemplatePickerOpenInitially, isImportProjectOpenInitially: isImportProjectOpenInitially, selectedProjectType: selectedProjectType, recommendationSessionId: recommendationSessionId } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($57e246fe6ba8231d$var$Context.Provider, {
            value: {
                data: {
                    isOpen: isOpen,
                    isNextGen: isNextGen,
                    source: source,
                    showExperienceSelection: showExperienceSelection,
                    shouldRenderDrawer: shouldRenderDrawer,
                    recommendedTemplate: recommendedTemplate,
                    defaultSelectedTemplateKey: defaultSelectedTemplateKey,
                    isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
                    isImportProjectOpenInitially: isImportProjectOpenInitially,
                    selectedProjectType: selectedProjectType,
                    recommendationSessionId: recommendationSessionId
                },
                methods: {
                    open: this.open,
                    close: this.close,
                    onSuccess: this.onSuccess,
                    onCreateStarted: this.onCreateStarted,
                    setOnCloseCallback: this.setOnCloseCallback,
                    clearOnCloseCallback: this.clearOnCloseCallback
                }
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: false,
            shouldRenderDrawer: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined,
            onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onSuccess = (projectKey)=>{
            if (projectKey) {
                this.props.setLocation(projectKey.returnUrl);
                this.close(true);
            } else this.close(false);
        }, // Callback that is called once when the drawer is closed.
        this.setOnCloseCallback = (callback)=>{
            this.setState({
                onCloseCallback: callback
            });
        }, this.clearOnCloseCallback = ()=>{
            this.setState({
                onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
            });
        }, this.open = (attributes = {})=>{
            // @ts-expect-error - TS2345 - Argument of type '{ isNextGen?: boolean | undefined; showExperienceSelection?: boolean | undefined; recommendedTemplate?: { templateKey: string; isSimplified: boolean; } | undefined; defaultSelectedTemplateKey?: string | undefined; ... 4 more ...; shouldRenderDrawer: true; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "source" | "isOpen" | "isNextGen" | ... 5 more ... | "isTemplatePickerOpenInitially"> | null) | Pick<...> | null'.
            this.setState({
                isOpen: true,
                shouldRenderDrawer: true,
                ...attributes
            });
        }, this.close = (projectCreated)=>{
            const callOnCloseCallBack = this.state.source === 'navigationNext' || !projectCreated;
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                isImportProjectOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            if (callOnCloseCallBack) // Call the added callback
            this.state.onCloseCallback();
        }, this.closeOld = ()=>{
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            this.state.onCloseCallback();
        }, this.onCreateStarted = (projectKey, templateKey)=>{
            if ((0, $dhdXs.getIsJsmBlankProjectTemplate)(templateKey)) (0, $3KcCl.LazyComponent).preload();
            (0, $g27SL.clearResourcesAssociatedWithProjectKey)(projectKey);
        };
    }
};
const $57e246fe6ba8231d$export$9a1c5dbd93c42bca = (props)=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($57e246fe6ba8231d$export$839a70d8fbc9d356, {
        ...props,
        setLocation: push
    });
};
const { Consumer: $57e246fe6ba8231d$export$9a8662cd60931de1 } = $57e246fe6ba8231d$var$Context;
$57e246fe6ba8231d$var$Context.displayName = 'ProjectCreateDrawerConsumer';
const $57e246fe6ba8231d$export$8172ff4ed0f75a1e = ()=>{
    const projectCreateDrawer = (0, $eJOHy.useContext)($57e246fe6ba8231d$var$Context);
    if (!projectCreateDrawer) throw new Error('useProjectCreateDrawer must be used within a ProjectCreateDrawerProvider');
    return projectCreateDrawer;
};

});
parcelRegister("3KcCl", function(module, exports) {

$parcel$export(module.exports, "LazyComponent", () => $fc3d1cf7a1b986e8$export$31f1740ae531af94);
$parcel$export(module.exports, "AsyncProjectBuilderDrawer", () => $fc3d1cf7a1b986e8$export$54a4eade9eae9473);
$parcel$export(module.exports, "canUseProjectBuilder", () => $fc3d1cf7a1b986e8$export$ff317c5d87147a19);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $2wyE1 = parcelRequire("2wyE1");

var $gzcjr = parcelRequire("gzcjr");

const $fc3d1cf7a1b986e8$export$31f1740ae531af94 = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("i31XA")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/project-builder/src/ui/index.tsx"
});
const $fc3d1cf7a1b986e8$export$54a4eade9eae9473 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "bundle-async-project-builder",
        packageName: "jira-servicedesk-project-builder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        fallback: null,
        name: "jsm-project-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wyE1.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fc3d1cf7a1b986e8$export$31f1740ae531af94, {
        isOpenInitial: !!props.isOpenInitial,
        ...props
    }))));
const $fc3d1cf7a1b986e8$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;

});
parcelRegister("2wyE1", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $8f31292a89ad467e$export$ac31f8f3368d6881);

var $eJOHy = parcelRequire("eJOHy");

var $4xbv3 = parcelRequire("4xbv3");

var $6nVJI = parcelRequire("6nVJI");

var $cu1g7 = parcelRequire("cu1g7");
const $8f31292a89ad467e$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $eJOHy.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
$8f31292a89ad467e$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $cu1g7.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $6nVJI.useContainerContext)
};

});

parcelRegister("i31XA", function(module, exports) {

let $d23a0705eda5f540$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $d23a0705eda5f540$var$load("k4gbU"),
    $d23a0705eda5f540$var$load("4v8VH"),
    $d23a0705eda5f540$var$load("fh2Sv"),
    $d23a0705eda5f540$var$load("hwlgY"),
    $d23a0705eda5f540$var$load("1VRB2"),
    $d23a0705eda5f540$var$load("bABhq"),
    $d23a0705eda5f540$var$load("fAbxa"),
    $d23a0705eda5f540$var$load("7vqGd"),
    $d23a0705eda5f540$var$load("1Y4bq"),
    $d23a0705eda5f540$var$load("fMOSo"),
    $d23a0705eda5f540$var$load("jhiae"),
    $d23a0705eda5f540$var$load("eULBs")
]).then(()=>parcelRequire('3Kug5'));

});


parcelRegister("g27SL", function(module, exports) {

$parcel$export(module.exports, "clearResourcesAssociatedWithProjectKey", () => $ec92c92c2fa09fd5$export$c0c81c1828c7638c);

var $gYnSx = parcelRequire("gYnSx");

var $uCHeL = parcelRequire("uCHeL");
const $ec92c92c2fa09fd5$export$c0c81c1828c7638c = (projectKey)=>{
    try {
        const { storeState: storeState } = (0, $uCHeL.getResourceStore)();
        const prevState = storeState.getState();
        storeState.setState({
            ...prevState,
            data: Object.fromEntries(Object.entries(prevState?.data).map(([resourceType, value])=>{
                // This will not clear resources that are keyed with project key as a subset of the key,
                // e.g. `projectKey-${projectKey}` or similar, so those resources may still have stale data.
                const { [projectKey]: _, ...rest } = value;
                return [
                    resourceType,
                    rest
                ];
            }))
        });
    } catch (e) {
        (0, $gYnSx.default)({
            meta: {
                id: 'clearResourcesAssociatedWithProjectKey',
                packageName: 'jiraProjectCreateDrawerContext',
                teamName: 'helix'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: e instanceof Error ? e : new Error('Error occured in clearResourcesAssociatedWithProjectKey')
        });
    }
};

});




parcelRegister("5zkGh", function(module, exports) {

let $40e0436b80867be7$var$load = (parcelRequire("gLHA4"))(4);


module.exports = Promise.all([
    (parcelRequire("g81qY"))('box_afterpaint_command_palette_integration', function() {
        return Promise.all([
            $40e0436b80867be7$var$load("KPeeu"),
            $40e0436b80867be7$var$load("bABhq"),
            $40e0436b80867be7$var$load("1VRB2"),
            $40e0436b80867be7$var$load("fh2Sv"),
            $40e0436b80867be7$var$load("4v8VH")
        ]);
    }, function() {
        return Promise.all([
            $40e0436b80867be7$var$load("rsAQC")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-after-paint-issue-create-trigger-bundle', function() {
        return Promise.all([
            $40e0436b80867be7$var$load("cPaJS")
        ]);
    }, function() {
        return Promise.all([
            $40e0436b80867be7$var$load("fHLON")
        ]);
    }),
    $40e0436b80867be7$var$load("eOYvf")
]).then(()=>parcelRequire('5Uzk2'));

});

parcelRegister("hwbH7", function(module, exports) {

let $cc0e7f148d364072$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cc0e7f148d364072$var$load("6tyb4").then(()=>parcelRequire('eRtVx'));

});

parcelRegister("kjETs", function(module, exports) {

let $eca54d94e8bf8579$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $eca54d94e8bf8579$var$load("9ghXP").then(()=>parcelRequire('61Hor'));

});

parcelRegister("6XNiP", function(module, exports) {

let $511e7f3d6485c5de$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $511e7f3d6485c5de$var$load("6XETi").then(()=>parcelRequire('fRcce'));

});

parcelRegister("5lLid", function(module, exports) {

let $3e5399423e7f825c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3e5399423e7f825c$var$load("bshiF").then(()=>parcelRequire('aL23w'));

});

parcelRegister("54ZXa", function(module, exports) {

let $3b2d6218e0d3b0cc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3b2d6218e0d3b0cc$var$load("kSZEc").then(()=>parcelRequire('3g0Pk'));

});


parcelRegister("k2tOc", function(module, exports) {

$parcel$export(module.exports, "getIssuesNavigationPaths", () => $33bfc194c14bada1$export$a33a4d7b083ee85);
$parcel$export(module.exports, "isIssuesNavPath", () => $33bfc194c14bada1$export$f38c22a081278057);
const $33bfc194c14bada1$export$a33a4d7b083ee85 = ()=>({
        // Features
        newIssueSearchTransition: '/jira/settings/issues/new-issue-search-transition',
        timeTrackingItem: '/secure/admin/TimeTrackingAdmin.jspa',
        issueLinkingItem: '/secure/admin/ViewLinkTypes!default.jspa',
        // IssueTypes
        issueTypesHierarchyItem: '/jira/settings/issues/issue-hierarchy',
        issueTypesItem: '/jira/settings/issues/issue-types',
        issueTypeSchemesItem: '/jira/settings/issues/issue-type-schemes',
        issueTypesSubTasksItem: '/secure/admin/subtasks/ManageSubTasks.jspa',
        // Workflows
        workflowsItem: '/jira/settings/issues/workflows',
        workflowSchemesItem: '/secure/admin/ViewWorkflowSchemes.jspa',
        // Screens
        screensItem: '/jira/settings/issues/screens',
        screenSchemesItem: '/jira/settings/issues/screen-schemes',
        screensIssueTypeScreenSchemesMenu: '/jira/settings/issues/issue-type-screen-schemes',
        // Fields
        fieldsManagement: '/jira/settings/issues/fields',
        customFieldsItem: '/secure/admin/ViewCustomFields.jspa',
        fieldConfigurationsItem: '/secure/admin/ViewFieldLayouts.jspa',
        fieldConfigurationSchemes: '/secure/admin/ViewFieldLayoutSchemes.jspa',
        fieldSchemes: '/jira/settings/issues/field-schemes',
        // Priorities
        prioritiesItem: '/jira/settings/issues/priorities',
        prioritySchemesItem: '/jira/settings/issues/priority-schemes',
        // Forms
        dataConnectionsItem: '/jira/settings/forms/data-connections',
        // IssueAttributes
        statusesItem: '/secure/admin/ViewStatuses.jspa',
        resolutionsItem: '/secure/admin/ViewResolutions.jspa',
        issueSecuritySchemesItem: '/secure/admin/ViewIssueSecuritySchemes.jspa',
        notificationSchemesItem: '/secure/admin/ViewNotificationSchemes.jspa',
        permissionSchemesItem: '/secure/admin/ViewPermissionSchemes.jspa'
    });
const $33bfc194c14bada1$var$getIssuesNavPaths = ()=>{
    return [
        '/jira/settings/issues/new-issue-search-transition',
        '/secure/admin/TimeTrackingAdmin',
        '/secure/admin/ViewLinkTypes',
        '/jira/settings/issues/issue-hierarchy',
        '/jira/settings/issues/issue-types',
        '/jira/settings/issues/issue-type-schemes',
        '/secure/admin/subtasks/ManageSubTasks',
        '/jira/settings/issues/workflows',
        '/secure/admin/ViewWorkflowSchemes',
        '/jira/settings/issues/screens',
        '/jira/settings/issues/screen-schemes',
        '/jira/settings/issues/issue-type-screen-schemes',
        '/jira/settings/issues/fields',
        '/jira/settings/issues/field-schemes',
        '/secure/admin/ViewCustomFields',
        '/secure/admin/ViewFieldLayouts',
        '/secure/admin/ViewFieldLayoutSchemes',
        '/jira/settings/issues/priorities',
        '/jira/settings/issues/priority-schemes',
        '/secure/admin/ViewStatuses',
        '/secure/admin/ViewResolutions',
        '/secure/admin/ViewIssueSecuritySchemes',
        '/secure/admin/ViewNotificationSchemes',
        '/secure/admin/ViewPermissionSchemes'
    ];
};
const $33bfc194c14bada1$export$f38c22a081278057 = (path)=>{
    const paths = $33bfc194c14bada1$var$getIssuesNavPaths();
    return path && paths.some((p)=>path.includes(p));
};

});

parcelRegister("8hKqe", function(module, exports) {

$parcel$export(module.exports, "JiraTopBannerPlacement", () => $49990ce1545b6c59$export$2a9156f5c2a2410e);

var $eJOHy = parcelRequire("eJOHy");

var $5PJSo = parcelRequire("5PJSo");

var $1KdDN = parcelRequire("1KdDN");

var $7jTnu = parcelRequire("7jTnu");

var $1gHmu = parcelRequire("1gHmu");

var $grotr = parcelRequire("grotr");

var $7oY9g = parcelRequire("7oY9g");

var $5fjzQ = parcelRequire("5fjzQ");

var $9I7ft = parcelRequire("9I7ft");
const $49990ce1545b6c59$var$PLACEMENT_ID = 'jira-top-banner';
const $49990ce1545b6c59$var$TopBannerPlacement = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "topBannerPlacement",
        packageName: "top-banner-placement",
        teamName: "post-office",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1gHmu.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "top-banner-placement.jira-top-banner-placement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $grotr.PlacementFetchProvider), {
        resource: (0, $5fjzQ.postOfficeJiraTopBannerResource)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9I7ft.default), {
        placementId: $49990ce1545b6c59$var$PLACEMENT_ID,
        // Post Office and Jira uses different versions of react-error-boundary - https://atlassian.slack.com/archives/CL6HC337Z/p1741218999095929
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $5PJSo.default)
    })))));
};
const $49990ce1545b6c59$export$2a9156f5c2a2410e = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    if (!(0, $7oY9g.default)('killswitch_post_office_in_jira') && (0, $7jTnu.fg)('jira-issue-term-refresh-banner')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($49990ce1545b6c59$var$TopBannerPlacement, null);
    return null;
});

});
parcelRegister("5PJSo", function(module, exports) {

$parcel$export(module.exports, "default", () => $955c722df0dd3529$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $gFu5h = parcelRequire("gFu5h");

var $3o8lc = parcelRequire("3o8lc");

var $5H93L = parcelRequire("5H93L");

var $eJOHy = parcelRequire("eJOHy");

var $fmdjn = parcelRequire("fmdjn");


var $8ozTH = parcelRequire("8ozTH");
const $955c722df0dd3529$export$a4ee24848b29490b = (0, $8ozTH.withJiraTopBannerIntlProvider)((0, $3o8lc.createPlacementComponent)((0, $cc2adc46e79f09dd$export$a5cfae247d8360ef), ({ initialData: initialData })=>{
    const { data: data, isLoading: isLoading } = (0, $5H93L.useInitialData)(initialData);
    const [{ message: message, status: status }, setMessageState] = (0, $eJOHy.useState)({
        message: undefined,
        status: 'loading'
    });
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $gFu5h.useMessagePlacementHooks)();
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        setMessageState({
            message: undefined,
            status: 'done'
        });
    }, []);
    (0, $eJOHy.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss,
        handleDismiss
    ]);
    (0, $eJOHy.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked,
        handleDismiss
    ]);
    (0, $eJOHy.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze,
        handleDismiss
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isLoading) {
            const newMessage = data?.messages[0];
            setMessageState({
                message: newMessage,
                status: 'done'
            });
        }
    }, [
        data,
        isLoading
    ]);
    if (isLoading || status === 'loading') return null;
    return message && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fmdjn.MessageRenderer), {
        ...message,
        messageInstanceId: message.messageInstanceId
    });
}, {
    choreographer: {
        isDefaultEnabled: false
    }
}));
var $955c722df0dd3529$export$2e2bcd8739ae039 = $955c722df0dd3529$export$a4ee24848b29490b;

});
parcelRegister("gFu5h", function(module, exports) {

$parcel$export(module.exports, "createMessagePlacementValues", () => $822527ba496b7006$export$a28a0c048b24fc5a);
$parcel$export(module.exports, "MessagePlacementProvider", () => $822527ba496b7006$export$c7535f8ebc5b75a9);
$parcel$export(module.exports, "useMessagePlacementHooks", () => $822527ba496b7006$export$89f8e1f623d8f5ac);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
/**
 * Creates a Publish-Subscribe pattern for managing callbacks.
 * @returns {Array<Subscribe, Publish>} An array containing a Subscribe function and a Publish function.
 */ const $822527ba496b7006$var$createPubSub = ()=>{
    const subscribers = new Map();
    /**
	 * Subscribes a callback function to the pub-sub system.
	 * @param {Callback} subscriber - The callback function to subscribe.
	 * @returns A function to unsubscribe the callback.
	 */ const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    /**
	 * Publishes the payload to all subscribed callbacks.
	 * @param {Callback} payload - The payload to publish to the subscribers.
	 */ const publish = (payload)=>{
        subscribers.forEach((cb)=>cb(payload));
    };
    return [
        subscribe,
        publish
    ];
};
const $822527ba496b7006$export$a28a0c048b24fc5a = ()=>{
    const [onMessageSnooze, snoozeMessageFromPlacement] = $822527ba496b7006$var$createPubSub();
    const [onMessageDismiss, dismissMessageFromPlacement] = $822527ba496b7006$var$createPubSub();
    const [onMessageRead, markReadFromPlacement] = $822527ba496b7006$var$createPubSub();
    const [onMessageViewed, markViewedFromPlacement] = $822527ba496b7006$var$createPubSub();
    const [onMessageClicked, markClickedFromPlacement] = $822527ba496b7006$var$createPubSub();
    return {
        onMessageSnooze: onMessageSnooze,
        snoozeMessageFromPlacement: snoozeMessageFromPlacement,
        onMessageDismiss: onMessageDismiss,
        dismissMessageFromPlacement: dismissMessageFromPlacement,
        onMessageRead: onMessageRead,
        markReadFromPlacement: markReadFromPlacement,
        onMessageViewed: onMessageViewed,
        markViewedFromPlacement: markViewedFromPlacement,
        onMessageClicked: onMessageClicked,
        markClickedFromPlacement: markClickedFromPlacement
    };
};
const $822527ba496b7006$export$ea58328f3ceee4d4 = /*#__PURE__*/ (0, $eJOHy.createContext)($822527ba496b7006$export$a28a0c048b24fc5a());
const $822527ba496b7006$export$c7535f8ebc5b75a9 = $822527ba496b7006$export$ea58328f3ceee4d4.Provider;
const $822527ba496b7006$export$c4b5cec0911af177 = ()=>({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)($822527ba496b7006$export$c7535f8ebc5b75a9, {
            value: $822527ba496b7006$export$a28a0c048b24fc5a(),
            children: children
        });
const $822527ba496b7006$export$89f8e1f623d8f5ac = ()=>(0, $eJOHy.useContext)($822527ba496b7006$export$ea58328f3ceee4d4);

});

parcelRegister("3o8lc", function(module, exports) {

$parcel$export(module.exports, "createPlacementComponent", () => $efc9d2af5d704d59$export$8a57effc6307f916);

var $bbUVZ = parcelRequire("bbUVZ");
const $efc9d2af5d704d59$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $bbUVZ.createPlacementComponent)(placementId, Component, placementConfigurationOptions);

});
parcelRegister("bbUVZ", function(module, exports) {

$parcel$export(module.exports, "createPlacementComponent", () => $b12970ee97911384$export$8a57effc6307f916);

var $gt9Am = parcelRequire("gt9Am");

var $gPxoe = parcelRequire("gPxoe");

var $7L8gp = parcelRequire("7L8gp");

var $1GwKy = parcelRequire("1GwKy");

var $izK75 = parcelRequire("izK75");
var $e9z5H = parcelRequire("e9z5H");

var $jGob4 = parcelRequire("jGob4");
const $b12970ee97911384$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $jGob4.withErrorBoundary)((props)=>{
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        const stableContext = (0, $gPxoe.useStableObject)(context);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $izK75.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e9z5H.StableProviders), {
                route: route,
                context: stableContext,
                placement: {
                    placementId: placementId
                },
                choreographer: placementConfigurationOptions?.choreographer,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    context: stableContext,
                    initialData: initialData,
                    ...componentProps
                })
            })
        });
    });
const $b12970ee97911384$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $b12970ee97911384$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $1GwKy.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $7L8gp.ERROR_BOUNDARY_LOCATION),
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};

});
parcelRegister("gPxoe", function(module, exports) {

$parcel$export(module.exports, "useStableObject", () => $bd220258ff52630c$export$ed02d4adf2068b08);

var $eJOHy = parcelRequire("eJOHy");
function $bd220258ff52630c$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $bd220258ff52630c$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $eJOHy.useMemo)(()=>obj, $bd220258ff52630c$export$cdf98ded28406f69(obj));
}

});

parcelRegister("7L8gp", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $5637f623c8f8ddb8$export$9c542858adf7dcd0);
$parcel$export(module.exports, "ERROR_BOUNDARY_LOCATION", () => $5637f623c8f8ddb8$export$71ff7382870ef1b0);
const $5637f623c8f8ddb8$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $5637f623c8f8ddb8$export$71ff7382870ef1b0 = 'create-placement-component';

});

parcelRegister("1GwKy", function(module, exports) {

$parcel$export(module.exports, "useComponentErrorHandling", () => $f3e8ea2320233e31$export$3d127465d22fe4e5);

var $eJOHy = parcelRequire("eJOHy");
const $f3e8ea2320233e31$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $eJOHy.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};

});

parcelRegister("izK75", function(module, exports) {

$parcel$export(module.exports, "PerformanceTracking", () => $eba98b606d7a2a83$export$9a335a42ce02bdb8);
$parcel$export(module.exports, "PerformanceTrackingSegment", () => $eba98b606d7a2a83$export$b35129264a401b3c);

var $gt9Am = parcelRequire("gt9Am");

var $21HMC = parcelRequire("21HMC");

var $22L9h = parcelRequire("22L9h");

var $eJOHy = parcelRequire("eJOHy");

var $izw77 = parcelRequire("izw77");

var $huesZ = parcelRequire("huesZ");
const $eba98b606d7a2a83$export$9a335a42ce02bdb8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ children: children, ...props })=>{
    const isUFOEnabled = (0, $21HMC.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $huesZ.usePerformanceTracking)(props);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $22L9h.UFOv2).UFOLoadHold, {
                name: (0, $22L9h.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $izw77.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
});
const $eba98b606d7a2a83$export$b35129264a401b3c = /*#__PURE__*/ (0, $eJOHy.memo)(({ placementId: placementId, children: children })=>{
    const isEnabled = (0, $21HMC.default).checkGate('post_office_update_ufov2_placements');
    /**
		 * If feature gate is not enabled, then we just return the children without the
		 * UFO segments attached.
		 */ if (!isEnabled) return children;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $22L9h.UFOv2).UFOSegment, {
        name: (0, $22L9h.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $22L9h.UFOv2).UFOSegment, {
            name: `${(0, $22L9h.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
});

});
parcelRegister("22L9h", function(module, exports) {

$parcel$export(module.exports, "UFOv2", () => $37722661d2dcb304$export$c91b09caa8ecbab1);

var $h1VbR = parcelRequire("h1VbR");

var $gaiLP = parcelRequire("gaiLP");
const $37722661d2dcb304$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: $h1VbR.default,
    UFOSegment: $gaiLP.default
};

});

parcelRegister("izw77", function(module, exports) {

$parcel$export(module.exports, "TrackMount", () => $689b1b49f22fff52$export$21b400a8c8ebc91a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $689b1b49f22fff52$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $eJOHy.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});

parcelRegister("huesZ", function(module, exports) {

$parcel$export(module.exports, "usePerformanceTracking", () => $2bf48d43821b4dd3$export$317d52099614f316);

var $eJOHy = parcelRequire("eJOHy");
const $2bf48d43821b4dd3$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(true);
    const onMount = (0, $eJOHy.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $eJOHy.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};

});


parcelRegister("e9z5H", function(module, exports) {

$parcel$export(module.exports, "StableProviders", () => $9198255ed60ce179$export$2b6596bcb1383a71);

var $gt9Am = parcelRequire("gt9Am");

var $aeX5C = parcelRequire("aeX5C");

var $7hdd6 = parcelRequire("7hdd6");

var $hqm0R = parcelRequire("hqm0R");

var $20lF8 = parcelRequire("20lF8");

var $koBcx = parcelRequire("koBcx");

var $lMwWM = parcelRequire("lMwWM");

var $izK75 = parcelRequire("izK75");
const $9198255ed60ce179$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $20lF8.StableContextProvider), {
        context: context,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $koBcx.StablePlacementProvider), {
            placement: placement,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lMwWM.StableRouteProvider), {
                route: route,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7hdd6.StableAnaltyicsProvider), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hqm0R.StableChoreographerProvider), {
                        choreographer: choreographer,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aeX5C.RenderTrackerProvider), {
                            placementId: placement.placementId,
                            children: children
                        })
                    })
                })
            })
        })
    });

});
parcelRegister("aeX5C", function(module, exports) {

$parcel$export(module.exports, "RenderTrackerProvider", () => $8530f1c89a7955a3$export$2d84fd9af6c9e378);

var $gt9Am = parcelRequire("gt9Am");

var $e0Nss = parcelRequire("e0Nss");

var $eJOHy = parcelRequire("eJOHy");
/**
 * List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
 */ const $8530f1c89a7955a3$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    'screen-space-flags'
];
const $8530f1c89a7955a3$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $e0Nss.useFirePostOfficeAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if ($8530f1c89a7955a3$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'placement'
        });
    }, [
        fireAnalyticsEvent,
        placementId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});
parcelRegister("e0Nss", function(module, exports) {

$parcel$export(module.exports, "useFirePostOfficeAnalyticsEvents", () => $53f77a075e28746a$export$57d19d18d6e255a5);

var $f1Zdy = parcelRequire("f1Zdy");

var $eJOHy = parcelRequire("eJOHy");
const $53f77a075e28746a$export$85183a312807388d = 'postOffice';
const $53f77a075e28746a$export$57d19d18d6e255a5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $eJOHy.useCallback)((eventPayload, attributes)=>{
        createAnalyticsEvent({
            ...eventPayload,
            side: 'client',
            attributes: {
                ...eventPayload.attributes,
                ...attributes
            }
        }).fire($53f77a075e28746a$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};

});


parcelRegister("7hdd6", function(module, exports) {

$parcel$export(module.exports, "StableAnaltyicsProvider", () => $ae67d55b02feaef3$export$5a66cdc9893b43e);

var $gt9Am = parcelRequire("gt9Am");

var $kxsjC = parcelRequire("kxsjC");
const $ae67d55b02feaef3$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: undefined,
            b: undefined,
            t: undefined
        }
    }
};
const $ae67d55b02feaef3$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxsjC.PostOfficeAnalyticsContext), {
        data: $ae67d55b02feaef3$var$postOfficeAnalyticsContextData,
        children: children
    });
};

});

parcelRegister("hqm0R", function(module, exports) {

$parcel$export(module.exports, "StableChoreographerProvider", () => $a56e13478927927c$export$e68b2c75bfb5682a);
$parcel$export(module.exports, "useChoreographerContext", () => $a56e13478927927c$export$cab5a8adbabcee23);

var $gt9Am = parcelRequire("gt9Am");

var $5ZQPg = parcelRequire("5ZQPg");
var $8OhYX = parcelRequire("8OhYX");

var $eJOHy = parcelRequire("eJOHy");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
const $a56e13478927927c$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;
const $a56e13478927927c$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $a56e13478927927c$var$defaultContext = {
    choreographerEnabled: $a56e13478927927c$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $a56e13478927927c$var$ChoreographerContext = /*#__PURE__*/ (0, $eJOHy.createContext)($a56e13478927927c$var$defaultContext);

const $a56e13478927927c$export$e68b2c75bfb5682a = ({ children: children, choreographer: choreographer })=>{
    const [choreographerFactory, setChoreographerFactory] = (0, $eJOHy.useState)(undefined);
    const [choreographerEnabled, setChoreographerEnabled] = (0, $eJOHy.useState)(choreographer?.isDefaultEnabled ?? $a56e13478927927c$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $8OhYX.usePostOfficeEnvironment)();
    const context = (0, $5ZQPg.usePostOfficeContext)();
    (0, $eJOHy.useEffect)(()=>{
        if (choreographerEnabled) (parcelRequire("Ocqkm")).then((m)=>{
            const module = $a56e13478927927c$var$importHelper(m);
            setChoreographerFactory(new module.ChoreographerRegistry(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory());
        }).catch(()=>{
            setChoreographerEnabled(false);
        });
    }, [
        choreographerEnabled,
        context.product,
        environmentContext.currentEnv
    ]);
    const stableChoreographerContext = (0, $eJOHy.useMemo)(()=>({
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        }), [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($a56e13478927927c$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext,
        children: children
    });
};
const $a56e13478927927c$export$cab5a8adbabcee23 = ()=>(0, $eJOHy.useContext)($a56e13478927927c$var$ChoreographerContext);

});
parcelRegister("5ZQPg", function(module, exports) {

$parcel$export(module.exports, "defaultPostOfficeContextValue", () => $7b9cba7703be3d11$export$da5dc9062cba6715);
$parcel$export(module.exports, "InternalPostOfficeContextProvider", () => $7b9cba7703be3d11$export$3a10495c2cd2db0c);
$parcel$export(module.exports, "PostOfficeContextProvider", () => $7b9cba7703be3d11$export$b77983be89bb0a4e);
$parcel$export(module.exports, "usePostOfficeContext", () => $7b9cba7703be3d11$export$5bd9099e0ae94a43);

var $eJOHy = parcelRequire("eJOHy");
const $7b9cba7703be3d11$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $7b9cba7703be3d11$export$a228be81fcb77b42 = (0, $eJOHy.createContext)($7b9cba7703be3d11$export$da5dc9062cba6715);
const $7b9cba7703be3d11$export$3a10495c2cd2db0c = $7b9cba7703be3d11$export$a228be81fcb77b42.Provider;
const $7b9cba7703be3d11$export$b77983be89bb0a4e = $7b9cba7703be3d11$export$3a10495c2cd2db0c;
const $7b9cba7703be3d11$export$5bd9099e0ae94a43 = ()=>(0, $eJOHy.useContext)($7b9cba7703be3d11$export$a228be81fcb77b42);

});

parcelRegister("Ocqkm", function(module, exports) {

let $096e4eb3956fa159$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $096e4eb3956fa159$var$load("4Xopf").then(()=>parcelRequire('9uZIS'));

});


parcelRegister("20lF8", function(module, exports) {

$parcel$export(module.exports, "StableContextProvider", () => $38e79a77623fe555$export$d4982c0a28b18f63);

var $gt9Am = parcelRequire("gt9Am");

var $5ZQPg = parcelRequire("5ZQPg");
var $gPxoe = parcelRequire("gPxoe");

var $7L8gp = parcelRequire("7L8gp");
const $38e79a77623fe555$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $gPxoe.useStableObject)({
        ...(0, $7L8gp.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5ZQPg.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};

});

parcelRegister("koBcx", function(module, exports) {

$parcel$export(module.exports, "StablePlacementProvider", () => $f68fef1836a5bc30$export$e9fd288527498af6);

var $gt9Am = parcelRequire("gt9Am");

var $gPxoe = parcelRequire("gPxoe");

var $iqAhj = parcelRequire("iqAhj");
const $f68fef1836a5bc30$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $gPxoe.useStableObject)(placement);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iqAhj.PlacementProvider), {
        value: stableValue,
        children: children
    });
};

});
parcelRegister("iqAhj", function(module, exports) {

$parcel$export(module.exports, "PlacementProvider", () => $d31fc8c1af20b34f$export$6272e220478c7f1d);
$parcel$export(module.exports, "usePlacementContext", () => $d31fc8c1af20b34f$export$4fc0446ee742ad80);

var $gt9Am = parcelRequire("gt9Am");

var $kxsjC = parcelRequire("kxsjC");

var $jZBfv = parcelRequire("jZBfv");

var $eJOHy = parcelRequire("eJOHy");
const $d31fc8c1af20b34f$export$6394bf86db095a8 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    placementId: undefined
});
const $d31fc8c1af20b34f$export$6272e220478c7f1d = ({ value: value, children: children })=>{
    const memoizedValue = (0, $eJOHy.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $jZBfv.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d31fc8c1af20b34f$export$6394bf86db095a8.Provider, {
        value: memoizedValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxsjC.PostOfficeAnalyticsContext), {
            data: memoizedValue,
            children: children
        })
    });
};
const $d31fc8c1af20b34f$export$4fc0446ee742ad80 = ()=>(0, $eJOHy.useContext)($d31fc8c1af20b34f$export$6394bf86db095a8);

});
parcelRegister("jZBfv", function(module, exports) {

$parcel$export(module.exports, "PostOfficeScreenContextProvider", () => $f751e6f5daa3b0e2$export$ca77a8cbe94108fe);
$parcel$export(module.exports, "usePostOfficeScreenPlacement", () => $f751e6f5daa3b0e2$export$f51d04a086368016);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ecpoB = parcelRequire("ecpoB");
const $f751e6f5daa3b0e2$var$initialPlacementState = {
    currentlyMounted: [],
    hasMounted: []
};
const $f751e6f5daa3b0e2$var$PostOfficeScreenContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    placements: $f751e6f5daa3b0e2$var$initialPlacementState
});
const $f751e6f5daa3b0e2$export$70e19226ddeaf957 = ()=>(0, $eJOHy.useContext)($f751e6f5daa3b0e2$var$PostOfficeScreenContext);
const $f751e6f5daa3b0e2$var$PostOfficeScreenUpdateContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    placementMount: ()=>{},
    placementUnmount: ()=>{}
});
const $f751e6f5daa3b0e2$export$5d27c0ee02be2a23 = ()=>(0, $eJOHy.useContext)($f751e6f5daa3b0e2$var$PostOfficeScreenUpdateContext);
const $f751e6f5daa3b0e2$export$ca77a8cbe94108fe = ({ children: children })=>{
    const [placements, setPlacements] = (0, $eJOHy.useState)($f751e6f5daa3b0e2$var$initialPlacementState);
    const placementMount = (0, $eJOHy.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: (0, $ecpoB.uniqueArray)([
                    ...state.currentlyMounted,
                    placementId
                ]),
                hasMounted: (0, $ecpoB.uniqueArray)([
                    ...state.hasMounted,
                    placementId
                ])
            }), []);
    const placementUnmount = (0, $eJOHy.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
            }), []);
    const postOfficeScreenUpdateContext = (0, $eJOHy.useMemo)(()=>({
            placementMount: placementMount,
            placementUnmount: placementUnmount
        }), [
        placementMount,
        placementUnmount
    ]);
    const postOfficeScreenContext = (0, $eJOHy.useMemo)(()=>({
            placements: placements
        }), [
        placements
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($f751e6f5daa3b0e2$var$PostOfficeScreenUpdateContext.Provider, {
        value: postOfficeScreenUpdateContext,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($f751e6f5daa3b0e2$var$PostOfficeScreenContext.Provider, {
            value: postOfficeScreenContext,
            children: children
        })
    });
};
const $f751e6f5daa3b0e2$export$f51d04a086368016 = ({ placementId: placementId })=>{
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $f751e6f5daa3b0e2$export$5d27c0ee02be2a23();
    (0, $eJOHy.useEffect)(()=>{
        if (!placementId) return;
        placementMount({
            placementId: placementId
        });
        return ()=>{
            placementUnmount({
                placementId: placementId
            });
        };
    }, [
        placementId,
        placementMount,
        placementUnmount
    ]);
};

});
parcelRegister("ecpoB", function(module, exports) {

$parcel$export(module.exports, "uniqueArray", () => $4ae0c2c407301424$export$bbd17ecb0679edd7);
const $4ae0c2c407301424$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());

});




parcelRegister("lMwWM", function(module, exports) {

$parcel$export(module.exports, "StableRouteProvider", () => $bc419d39fcd049a1$export$ce13d00e696dfc96);

var $gt9Am = parcelRequire("gt9Am");

var $l2WwY = parcelRequire("l2WwY");
var $gPxoe = parcelRequire("gPxoe");

var $5mznv = parcelRequire("5mznv");
const $bc419d39fcd049a1$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $5mznv.useLocationHref)();
    const stableRoute = (0, $gPxoe.useStableObject)(route ?? {
        previous: href,
        current: href
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l2WwY.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};

});
parcelRegister("l2WwY", function(module, exports) {

$parcel$export(module.exports, "PostOfficeRouteContext", () => $2859662988273f77$export$f7f47a74e8b47b1f);
$parcel$export(module.exports, "PostOfficeRouteProvider", () => $2859662988273f77$export$89eadc6b3e5f4e9e);
$parcel$export(module.exports, "usePostOfficeRoute", () => $2859662988273f77$export$79301b66f7808cd8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $g5PZJ = parcelRequire("g5PZJ");

var $gPxoe = parcelRequire("gPxoe");
const $2859662988273f77$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $2859662988273f77$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $2859662988273f77$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $g5PZJ.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $gPxoe.useStableObject)(route);
};
const $2859662988273f77$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $2859662988273f77$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$2859662988273f77$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $2859662988273f77$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $eJOHy.createContext)($2859662988273f77$var$initialState);
const $2859662988273f77$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $eJOHy.useRef)();
    if (!ref.current) ref.current = $2859662988273f77$export$98c77e1bd702ed15(props);
    const route = $2859662988273f77$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($2859662988273f77$export$f7f47a74e8b47b1f.Provider, {
        value: route,
        children: children
    });
};
const $2859662988273f77$export$79301b66f7808cd8 = ()=>(0, $eJOHy.useContext)($2859662988273f77$export$f7f47a74e8b47b1f); //Route listener

});

parcelRegister("5mznv", function(module, exports) {

$parcel$export(module.exports, "useLocationHref", () => $cfff6f4acb59e800$export$49fc3f3d8c7f99);
const $cfff6f4acb59e800$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $cfff6f4acb59e800$export$49fc3f3d8c7f99 = ()=>{
    return $cfff6f4acb59e800$var$isLocationAvailable() ? globalThis.location.href : undefined;
};

});



parcelRegister("jGob4", function(module, exports) {

$parcel$export(module.exports, "withErrorBoundary", () => $9fc8f4eb05132161$export$f0c7a449e0cfaec7);

var $gt9Am = parcelRequire("gt9Am");


var $e0Nss = parcelRequire("e0Nss");

var $hyAWM = parcelRequire("hyAWM");
const $9fc8f4eb05132161$export$f0c7a449e0cfaec7 = (Component)=>({ errorBoundaryLocation: errorBoundaryLocation, fallbackRender: fallbackRender, onError: onError, ...data })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $e0Nss.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $27c7fc6638bd7614$export$12346a674644c156),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: error,
                    info: info
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $gt9Am.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hyAWM.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation
            }, onError),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...data
            })
        });
    };

});
parcelRegister("hyAWM", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $cc82458fa89597c0$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");
'use client';
const $cc82458fa89597c0$export$b16d9fb1a22de840 = (0, $eJOHy.createContext)(null);
const $cc82458fa89597c0$var$initialState = {
    didCatch: false,
    error: null
};
class $cc82458fa89597c0$export$e926676385687eaf extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $cc82458fa89597c0$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($cc82458fa89597c0$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $cc82458fa89597c0$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($cc82458fa89597c0$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $eJOHy.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $eJOHy.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $eJOHy.createElement)($cc82458fa89597c0$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $cc82458fa89597c0$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $cc82458fa89597c0$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $cc82458fa89597c0$export$c052f6604b7d51fe() {
    const context = (0, $eJOHy.useContext)($cc82458fa89597c0$export$b16d9fb1a22de840);
    $cc82458fa89597c0$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $eJOHy.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $eJOHy.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $cc82458fa89597c0$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $eJOHy.forwardRef)((props, ref)=>(0, $eJOHy.createElement)($cc82458fa89597c0$export$e926676385687eaf, errorBoundaryProps, (0, $eJOHy.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});




parcelRegister("5H93L", function(module, exports) {

$parcel$export(module.exports, "useInitialData", () => $823a21d66186d4fa$export$5523c5f3222291d0);

var $eJOHy = parcelRequire("eJOHy");

var $fUF6P = parcelRequire("fUF6P");
const $823a21d66186d4fa$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $eJOHy.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $fUF6P.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};

});
parcelRegister("fUF6P", function(module, exports) {

$parcel$export(module.exports, "AlreadyRunningError", () => $f73ff55a31199da5$export$8c5224d3af2f3c8b);
$parcel$export(module.exports, "useData", () => $f73ff55a31199da5$export$c1cf1cf4c5d51937);

var $e0Nss = parcelRequire("e0Nss");

var $7mF43 = parcelRequire("7mF43");

var $eJOHy = parcelRequire("eJOHy");

var $8cMw1 = parcelRequire("8cMw1");
class $f73ff55a31199da5$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $f73ff55a31199da5$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $eJOHy.useState)((0, $8cMw1.toLoading)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $e0Nss.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $eJOHy.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then((0, $8cMw1.assertResponseIsOk)).then((res)=>res.json()).then((data)=>{
            setState((0, $8cMw1.toData)(data));
            fireAnalyticsEvent({
                action: 'resolved',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes
                }
            });
        }).catch((err)=>{
            if (err instanceof $f73ff55a31199da5$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $8cMw1.toError)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};

});
parcelRegister("8cMw1", function(module, exports) {

$parcel$export(module.exports, "assertResponseIsOk", () => $f2b66d76bd5a4a23$export$b3732c8ff6f9c463);
$parcel$export(module.exports, "toLoading", () => $f2b66d76bd5a4a23$export$f9a5bd0ffba29ffc);
$parcel$export(module.exports, "toError", () => $f2b66d76bd5a4a23$export$cc3b967c039ed3e7);
$parcel$export(module.exports, "toData", () => $f2b66d76bd5a4a23$export$24a6b176bdc41ce5);
const $f2b66d76bd5a4a23$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $f2b66d76bd5a4a23$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($f2b66d76bd5a4a23$export$18a0019e5439b209(res));
};
const $f2b66d76bd5a4a23$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $f2b66d76bd5a4a23$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $f2b66d76bd5a4a23$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });

});



parcelRegister("fmdjn", function(module, exports) {

$parcel$export(module.exports, "MessageRenderer", () => $185687c074585c5d$export$2df1250b8f917a59);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $7IIUN = parcelRequire("7IIUN");

var $gjY6u = parcelRequire("gjY6u");

var $cKSFQ = parcelRequire("cKSFQ");
const $185687c074585c5d$export$e30378e28ad3e6ab = {
    ...(0, $gjY6u.default),
    ...(0, $cKSFQ.default)
};
const { initializeMessageRenderer: $185687c074585c5d$export$bce4e5106d86e473, MessageRenderer: $185687c074585c5d$export$2df1250b8f917a59 } = (0, $7IIUN.asMessageRenderer)($185687c074585c5d$export$e30378e28ad3e6ab);

});
parcelRegister("7IIUN", function(module, exports) {

$parcel$export(module.exports, "MaybeSuspenseBoundary", () => $0a24ac31e87f0bd2$export$9750eb54d7c7e789);
$parcel$export(module.exports, "asMessageRenderer", () => $0a24ac31e87f0bd2$export$7b7e5a348ef9a7c1);
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $gt9Am = parcelRequire("gt9Am");

var $21HMC = parcelRequire("21HMC");

var $gPxoe = parcelRequire("gPxoe");

var $54eF4 = parcelRequire("54eF4");
var $22L9h = parcelRequire("22L9h");

var $klIRK = parcelRequire("klIRK");

var $3wnx0 = parcelRequire("3wnx0");

var $hUaXr = parcelRequire("hUaXr");

var $drfKs = parcelRequire("drfKs");

var $ejO2l = parcelRequire("ejO2l");

var $izw77 = parcelRequire("izw77");

var $jGob4 = parcelRequire("jGob4");

var $3hO6D = parcelRequire("3hO6D");

var $eJOHy = parcelRequire("eJOHy");

var $10fiw = parcelRequire("10fiw");
const $0a24ac31e87f0bd2$var$STABLE_EMPTY_OBJECT = {};
const $0a24ac31e87f0bd2$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        ...props,
        children: children
    });
};
const $0a24ac31e87f0bd2$export$7b7e5a348ef9a7c1 = (messageComponents, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $eJOHy.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, SuspenseBoundary: SuspenseBoundary = (0, $eJOHy.Suspense), ...data })=>{
            const isUFOEnabled = (0, $21HMC.default).checkGate('enable_ufo_tracking_in_post_office');
            const recommendationSessionStable = (0, $gPxoe.useStableObject)(recommendationSession ?? $0a24ac31e87f0bd2$var$STABLE_EMPTY_OBJECT);
            const postOfficeStable = (0, $gPxoe.useStableObject)(postOffice ?? $0a24ac31e87f0bd2$var$STABLE_EMPTY_OBJECT);
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $eJOHy.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $54eF4.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $izw77.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $eJOHy.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $klIRK.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $klIRK.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $eJOHy.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $22L9h.UFOv2).UFOLoadHold, {
                        name: (0, $22L9h.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
                        children: loadingFallback ?? null
                    }), [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                const componentPropsStable = (0, $gPxoe.useStableObject)(componentProps);
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                return (0, $21HMC.default).checkGate('po-refactor-message-renderer-provider') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $drfKs.MessageRendererProvider), {
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    recommendationSession: recommendationSessionStable === $0a24ac31e87f0bd2$var$STABLE_EMPTY_OBJECT ? undefined : recommendationSessionStable,
                    messageSuccessComponent: messageSuccessComponent,
                    componentProps: componentPropsStable,
                    loadingFallback: loadingFallback,
                    triggerId: triggerId,
                    messageCreationType: messageCreationType,
                    postOffice: postOfficeStable,
                    isUFOEnabled: isUFOEnabled,
                    SuspenseBoundary: SuspenseBoundary,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                        onError: onError,
                        ...componentProps
                    })
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $10fiw.ChoreographerWrapper), {
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ejO2l.FeatureFlaggedUfoWrapper), {
                        messageTemplateId: messageTemplateId,
                        isEnabled: isUFOEnabled,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3wnx0.MessageContextProvider), {
                            value: {
                                messageInstanceId: messageInstanceId,
                                messageTemplateId: messageTemplateId,
                                triggerId: triggerId,
                                messageCreationType: messageCreationType,
                                transactionAccountId: componentProps.transactionAccountId,
                                analyticsDetails: postOffice?.analyticsDetails,
                                journeyId: journeyId,
                                journeyTriggerId: journeyTriggerId
                            },
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3hO6D.RecommendationProvider), {
                                value: recommendationSession ?? {},
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)(SuspenseBoundary, {
                                    fallback: loadingComponent,
                                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hUaXr.MessageAnalyticsContextProvider), {
                                        children: [
                                            messageSuccessComponent,
                                            /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                                                onError: onError,
                                                ...componentProps
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                });
            };
            return (0, $jGob4.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};

});
parcelRegister("54eF4", function(module, exports) {

$parcel$export(module.exports, "UFOv1", () => $a9c69873a61d25b9$export$96236906ebaa7f87);

var $4WE5p = parcelRequire("4WE5p");

var $3U7Cz = parcelRequire("3U7Cz");
const $a9c69873a61d25b9$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $4WE5p.MessagePerformanceTracker,
    PlacementPerformanceTracker: $3U7Cz.PlacementPerformanceTracker
};

});
parcelRegister("4WE5p", function(module, exports) {

$parcel$export(module.exports, "MessagePerformanceTracker", () => $d950c0f3c135497c$export$ae5c73c7c4f454e6);

var $aRK4c = parcelRequire("aRK4c");
var $9GzfC = parcelRequire("9GzfC");

var $61Vg7 = parcelRequire("61Vg7");
class $d950c0f3c135497c$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $9GzfC.UFOExperience)((0, $61Vg7.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $aRK4c.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $aRK4c.ExperienceTypes).Load,
            platform: {
                component: (0, $61Vg7.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $9GzfC.UFOExperience)(`${(0, $61Vg7.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $aRK4c.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $aRK4c.ExperienceTypes).Load,
            platform: {
                component: (0, $61Vg7.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}

});
parcelRegister("61Vg7", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceNames", () => $625dc9ee613ea877$export$cc7ddf8ca628f6f1);
$parcel$export(module.exports, "POST_OFFICE_PLATFORM_NAME", () => $625dc9ee613ea877$export$6d482cfa20c9d220);
const $625dc9ee613ea877$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $625dc9ee613ea877$export$6d482cfa20c9d220 = 'post-office';

});


parcelRegister("3U7Cz", function(module, exports) {

$parcel$export(module.exports, "PlacementPerformanceTracker", () => $adea6e7984c598d2$export$8b48c2105ba0b35a);

var $aRK4c = parcelRequire("aRK4c");
var $9GzfC = parcelRequire("9GzfC");

var $61Vg7 = parcelRequire("61Vg7");
const $adea6e7984c598d2$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $adea6e7984c598d2$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $aRK4c.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $aRK4c.ExperienceTypes).Load,
    platform: {
        component: (0, $61Vg7.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$adea6e7984c598d2$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$adea6e7984c598d2$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$adea6e7984c598d2$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$adea6e7984c598d2$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$adea6e7984c598d2$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$adea6e7984c598d2$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$adea6e7984c598d2$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$adea6e7984c598d2$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $adea6e7984c598d2$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$adea6e7984c598d2$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$adea6e7984c598d2$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$adea6e7984c598d2$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $adea6e7984c598d2$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $adea6e7984c598d2$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$adea6e7984c598d2$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $adea6e7984c598d2$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $9GzfC.UFOExperience)((0, $61Vg7.UFOExperienceNames).PLACEMENT, $adea6e7984c598d2$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $9GzfC.UFOExperience)(`${(0, $61Vg7.UFOExperienceNames).PLACEMENT}.${placementId}`, $adea6e7984c598d2$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}

});


parcelRegister("klIRK", function(module, exports) {

$parcel$export(module.exports, "PostOfficeErrorCodes", () => $7bf18c590334d6b1$export$b9722560029694e7);
$parcel$export(module.exports, "PostOfficeError", () => $7bf18c590334d6b1$export$d145ea5319863172);
$parcel$export(module.exports, "InvalidMessageTemplateIdError", () => $7bf18c590334d6b1$export$19cb89dd679394cb);
$parcel$export(module.exports, "MessageRendererEmptyValidationResponseError", () => $7bf18c590334d6b1$export$3dfc27a8d3942f4d);
var $7bf18c590334d6b1$export$b9722560029694e7 = /*#__PURE__*/ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    return PostOfficeErrorCodes;
}({});
class $7bf18c590334d6b1$export$46f86d28cd0a5d38 extends Error {
}
class $7bf18c590334d6b1$export$627bc00a5ef5f6ae extends Error {
}
class $7bf18c590334d6b1$export$d145ea5319863172 extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), this.code = code;
    }
}
function $7bf18c590334d6b1$export$4cb1ea6034a33155(error) {
    return typeof error === 'object' && !!error && 'status' in error && typeof error.status === 'number';
}
function $7bf18c590334d6b1$export$aed524b0009b5631(error) {
    return typeof error === 'object' && !!error && 'logLevel' in error && typeof error.logLevel === 'string';
}
class $7bf18c590334d6b1$export$ed601cd0dc1a1be7 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(args){
        /**
		 * It is expected that this error message can be not deterministic.
		 * This error message can be displayed in the "Failures" and "Preview It" tabs for message makers.
		 * Showing the error cause helps them understand what was the problem with their payload.
		 *
		 * On Post Office (platform) side, we use "instanceof MessageTemplateError" check
		 * to distinguish between message makers code errors and platform errors,
		 * but we don't rely on the error message itself.
		 */ const errMessage = args.cause instanceof Error ? args.cause.message : 'Error in message template code';
        super(errMessage, "MessageTemplateError", args.cause);
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$8d39b103586e9fd4 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(message, cause){
        super(message, "NotAbleToProcessEmailTemplateError", cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$f649da38897d27f7 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$c2852c1c4d9aba3e extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$4b7b4e09547e4bb3 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$360a094a97597d87 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$4d068b43eb55165b extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$ac007ee150add337 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$19cb89dd679394cb extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$78651662ad470cc5 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(){
        super('Message Template not found', "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$8a5041670cdd8db2 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(){
        super('Journey not found', "JourneyNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$1240ddc25cf964e6 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(){
        super('Message Template action handler validation error', "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$3c4884b7ae7fe517 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$913b8e68dc7ae8fe extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(){
        super('Placement not found', "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$3dfc27a8d3942f4d extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(){
        super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$e5ccdf8bbfead7a2 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$823733742d803ae6 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$1caa32527f23acd2 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(errorCause){
        super('Failed to send digest event to orchestration queue', "DigestEngineFailedSendError");
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$a6f2aad8fa094b39 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? 'Unable to get user details for the given account ID', "UnableToGetUserDetailsError"), this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$2f1e27130c2bf271 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError");
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$d0dc094613469f2b extends $7bf18c590334d6b1$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message);
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$5603eab37ce562f5 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(fileType){
        super('The attachment file is not supported', "UnsupportedAttachmentType");
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$e0e9aa0e9c6b37ff extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader");
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$3ad818f64601e141 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$25470bb6cba4fba0 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$ce14d445679448b6 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? 'unknown error', "HydrationFailureAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
}
class $7bf18c590334d6b1$export$c9a26a17db1045c8 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super('All messages failed at placement', "AllMessagesFailureHydrationAtPlacementError");
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$8ab4fb362168b928 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(){
        super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$2afd69f57fe5285f extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(){
        super('Recipient expander not found for mapper', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$7635d2b1a281d626 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError");
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$9e1c6d00e675bc86 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor(message, recipient){
        super(message, "RichRecipientError");
        this.name = this.constructor.name;
        this.recipient = recipient;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$90bef7fa95eca3fa extends Error {
    constructor(status){
        super('Posting Mobile Notifications message failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$6d1a4929f6ff1a32 extends $7bf18c590334d6b1$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$c19fc5e8aa4e064d extends Error {
    constructor(){
        super('Ingestion source is required when custom profile is specified');
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$2d3a68dab93b8cc4 extends Error {
    constructor(){
        super('A renderRedacted function is required when redactionLevel is set to a non-null value');
        this.name = this.constructor.name;
    }
}
class $7bf18c590334d6b1$export$175c1dbb0d7c238a extends Error {
    constructor(status){
        super('Enqueueing email failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$23fab744b3076342 extends Error {
    constructor(message, status){
        super(message), this.message = message, this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $7bf18c590334d6b1$export$194adecfa0265ea1 extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg);
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
}
class $7bf18c590334d6b1$export$c504492f06c975b5 extends $7bf18c590334d6b1$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super('hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user', "HydrationDeliveryNoDataFoundError");
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
}

});

parcelRegister("3wnx0", function(module, exports) {

$parcel$export(module.exports, "MessageContextProvider", () => $4ee168becd320498$export$42de33f7652dc3de);
$parcel$export(module.exports, "useMessageContext", () => $4ee168becd320498$export$a5b6d14a2e25725a);

var $eJOHy = parcelRequire("eJOHy");
const $4ee168becd320498$var$initialValue = {};
const $4ee168becd320498$export$b060d577040138d8 = (0, $eJOHy.createContext)($4ee168becd320498$var$initialValue);
const $4ee168becd320498$export$42de33f7652dc3de = $4ee168becd320498$export$b060d577040138d8.Provider;
const $4ee168becd320498$export$a5b6d14a2e25725a = ()=>(0, $eJOHy.useContext)($4ee168becd320498$export$b060d577040138d8);

});

parcelRegister("hUaXr", function(module, exports) {

$parcel$export(module.exports, "MessageAnalyticsContextProvider", () => $e189475e26bb704e$export$1737ab199e83455e);
$parcel$export(module.exports, "useMessageAnalyticsContext", () => $e189475e26bb704e$export$bb426ba114b64992);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $e189475e26bb704e$var$defaultMessageAnalyticsContextValue = {
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
};
const $e189475e26bb704e$export$c81717973c6c4a90 = /*#__PURE__*/ (0, $eJOHy.createContext)($e189475e26bb704e$var$defaultMessageAnalyticsContextValue);
const $e189475e26bb704e$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $eJOHy.useRef)(false);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($e189475e26bb704e$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
const $e189475e26bb704e$export$bb426ba114b64992 = ()=>(0, $eJOHy.useContext)($e189475e26bb704e$export$c81717973c6c4a90);

});

parcelRegister("drfKs", function(module, exports) {

$parcel$export(module.exports, "MessageRendererProvider", () => $8e3f9c5f2c8f2cf5$export$5fe06fe68913d493);

var $gt9Am = parcelRequire("gt9Am");

var $22L9h = parcelRequire("22L9h");

var $3wnx0 = parcelRequire("3wnx0");

var $3hO6D = parcelRequire("3hO6D");

var $eJOHy = parcelRequire("eJOHy");

var $hG1FG = parcelRequire("hG1FG");

var $ejO2l = parcelRequire("ejO2l");

var $hUaXr = parcelRequire("hUaXr");
const $8e3f9c5f2c8f2cf5$var$DEFAULT_RECOMMENDATION_SESSION = {};
const $8e3f9c5f2c8f2cf5$export$5fe06fe68913d493 = ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, recommendationSession: recommendationSession, messageSuccessComponent: messageSuccessComponent, componentProps: componentProps, loadingFallback: loadingFallback, triggerId: triggerId, messageCreationType: messageCreationType, postOffice: postOffice, isUFOEnabled: isUFOEnabled, children: children, SuspenseBoundary: SuspenseBoundary = (0, $eJOHy.Suspense) })=>{
    const loadingComponent = (0, $eJOHy.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $22L9h.UFOv2).UFOLoadHold, {
            name: (0, $22L9h.UFOv2).HoldNames.MESSAGE,
            children: loadingFallback ?? null
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: loadingFallback ?? null
        }), [
        loadingFallback,
        isUFOEnabled
    ]);
    const messageContextMemo = (0, $eJOHy.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            componentProps: componentProps,
            postOffice: postOffice
        }), [
        messageInstanceId,
        messageTemplateId,
        triggerId,
        messageCreationType,
        componentProps,
        postOffice
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hG1FG.ChoreographerWrapper), {
        messageId: messageInstanceId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ejO2l.FeatureFlaggedUfoWrapper), {
            messageTemplateId: messageTemplateId,
            isEnabled: isUFOEnabled,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3wnx0.MessageContextProvider), {
                value: messageContextMemo,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3hO6D.RecommendationProvider), {
                    value: recommendationSession ?? $8e3f9c5f2c8f2cf5$var$DEFAULT_RECOMMENDATION_SESSION,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(SuspenseBoundary, {
                        fallback: loadingComponent,
                        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hUaXr.MessageAnalyticsContextProvider), {
                            children: [
                                messageSuccessComponent,
                                children
                            ]
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("3hO6D", function(module, exports) {

$parcel$export(module.exports, "RecommendationProvider", () => $3f1968808f4afdef$export$f60e87d7b5f59562);
$parcel$export(module.exports, "useRecommendationContext", () => $3f1968808f4afdef$export$3321c0b02f750bcc);

var $gt9Am = parcelRequire("gt9Am");

var $44Rr3 = parcelRequire("44Rr3");

var $eJOHy = parcelRequire("eJOHy");
const $3f1968808f4afdef$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    sessionId: undefined,
    entityId: undefined
});
const $3f1968808f4afdef$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($3f1968808f4afdef$export$ba2f44035effd9c1.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44Rr3.default), {
            data: value,
            children: children
        })
    });
};
const $3f1968808f4afdef$export$3321c0b02f750bcc = ()=>(0, $eJOHy.useContext)($3f1968808f4afdef$export$ba2f44035effd9c1);

});

parcelRegister("hG1FG", function(module, exports) {

$parcel$export(module.exports, "ChoreographerWrapper", () => $a5126d5d856a3c2d$export$8db7ba034addcd65);

var $gt9Am = parcelRequire("gt9Am");

var $21HMC = parcelRequire("21HMC");

var $e0Nss = parcelRequire("e0Nss");

var $eJOHy = parcelRequire("eJOHy");

var $hqm0R = parcelRequire("hqm0R");
const $a5126d5d856a3c2d$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
    return null;
};
const $a5126d5d856a3c2d$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $hqm0R.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $e0Nss.useFirePostOfficeAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $21HMC.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $21HMC.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $gt9Am.jsx)($a5126d5d856a3c2d$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});

parcelRegister("ejO2l", function(module, exports) {

$parcel$export(module.exports, "FeatureFlaggedUfoWrapper", () => $3f6b667621add5f8$export$8e6fb7035018b3e4);

var $gt9Am = parcelRequire("gt9Am");

var $22L9h = parcelRequire("22L9h");
const $3f6b667621add5f8$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $22L9h.UFOv2).UFOSegment, {
        name: (0, $22L9h.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $22L9h.UFOv2).UFOSegment, {
            name: `${(0, $22L9h.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});


parcelRegister("10fiw", function(module, exports) {

$parcel$export(module.exports, "ChoreographerWrapper", () => $d8817003f068faee$export$8db7ba034addcd65);

var $gt9Am = parcelRequire("gt9Am");

var $21HMC = parcelRequire("21HMC");

var $e0Nss = parcelRequire("e0Nss");

var $hqm0R = parcelRequire("hqm0R");

var $eJOHy = parcelRequire("eJOHy");
const $d8817003f068faee$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
    return null;
};
const $d8817003f068faee$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $hqm0R.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $e0Nss.useFirePostOfficeAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $21HMC.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $21HMC.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $gt9Am.jsx)($d8817003f068faee$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});


parcelRegister("gjY6u", function(module, exports) {

$parcel$export(module.exports, "default", () => $800b3efd7bdf9e1d$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $ghQoi = parcelRequire("ghQoi");
var $800b3efd7bdf9e1d$export$2e2bcd8739ae039 = {
    'jira-ipm-issue-to-work-top-banner': (0, $ghQoi.default)
};

});
parcelRegister("ghQoi", function(module, exports) {

$parcel$export(module.exports, "default", () => $af37463d53bc52fa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $hc5Dc = parcelRequire("hc5Dc");

var $9vhhA = parcelRequire("9vhhA");
const $af37463d53bc52fa$export$b3890eb0ae9dca99 = (0, $9vhhA.createRender)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hc5Dc.TopBannerMessage), {}));
var $af37463d53bc52fa$export$2e2bcd8739ae039 = $af37463d53bc52fa$export$b3890eb0ae9dca99;

});
parcelRegister("hc5Dc", function(module, exports) {

$parcel$export(module.exports, "TopBannerMessage", () => $be1883ea7bed32dc$export$71f678cc6412ce95);
/* top-banner-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $2Eu5z = parcelRequire("2Eu5z");

var $dPUtJ = parcelRequire("dPUtJ");
var $dhRXV = parcelRequire("dhRXV");
var $9M9zY = parcelRequire("9M9zY");
var $hBR2B = parcelRequire("hBR2B");
var $h8epd = parcelRequire("h8epd");

var $guu3z = parcelRequire("guu3z");

var $4vp0Q = parcelRequire("4vp0Q");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
const $be1883ea7bed32dc$var$styles = {
    pressable: "_4bfu18uv _1hms8stv _ajmmnqa1 _syaz15cr _80omtlke _9oik18uv _1bnx8stv _jf4cnqa1 _30l315cr _1nrm18uv _c2waglyw _1iohnqa1",
    onClickBackgroundColor: "_bfhkcdhy"
};
const $be1883ea7bed32dc$var$ComingSoonMessage = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        id: "post-office.placement.jira-top-banner.primary-message",
        description: "Coming soon message for the Jira top banner",
        defaultMessage: "As we roll out 'work' as the new term for items tracked in Jira, you may still see 'issue' in some areas."
    });
const $be1883ea7bed32dc$var$ReadMoreLink = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dPUtJ.default), {
        href: "https://community.atlassian.com/t5/Jira-articles/It-s-here-Work-is-the-new-collective-term-for-all-items-you/ba-p/2954892",
        rel: "noopener noreferrer",
        target: "_blank",
        xcss: $be1883ea7bed32dc$var$styles.pressable,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "st-office.placement.jira-top-banner.primary-cta-text",
            description: "Read more link for the Jira top banner",
            defaultMessage: "Read about this terminology change"
        })
    });
const $be1883ea7bed32dc$export$71f678cc6412ce95 = ()=>{
    const { messageDismissed: messageDismissed } = (0, $4vp0Q.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $guu3z.useMessageInstanceEvent)();
    const onClickDismiss = (0, $eJOHy.useCallback)(()=>{
        messageDismissed();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
    }, [
        messageDismissed,
        messageInstanceClicked
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
        backgroundColor: "color.background.neutral.bold",
        padding: "space.200",
        testId: "jira-top-banner",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9M9zY.default), {
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $h8epd.default), {
                    color: "color.text.inverse",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)($be1883ea7bed32dc$var$ComingSoonMessage, {}),
                        "\xa0",
                        /*#__PURE__*/ (0, $gt9Am.jsx)($be1883ea7bed32dc$var$ReadMoreLink, {})
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hBR2B.default), {
                    xcss: $be1883ea7bed32dc$var$styles.onClickBackgroundColor,
                    onClick: onClickDismiss,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Eu5z))), {
                        color: "var(--ds-text-inverse, #FFFFFF)",
                        label: "Dismiss"
                    })
                })
            ]
        })
    });
};

});
parcelRegister("guu3z", function(module, exports) {

$parcel$export(module.exports, "useMessageInstanceEvent", () => $d2feb5c33549d10b$export$39b0f5626e96f41e);

var $5ZQPg = parcelRequire("5ZQPg");

var $3wnx0 = parcelRequire("3wnx0");

var $iqAhj = parcelRequire("iqAhj");

var $3hO6D = parcelRequire("3hO6D");

var $eJOHy = parcelRequire("eJOHy");

var $eUjlj = parcelRequire("eUjlj");

var $kvmaQ = parcelRequire("kvmaQ");
const $d2feb5c33549d10b$export$39b0f5626e96f41e = ()=>{
    if (!globalThis.window.postOfficeMessageInstanceEventClient) globalThis.window.postOfficeMessageInstanceEventClient = new (0, $kvmaQ.MessageInstanceEventClient)();
    const client = globalThis.window.postOfficeMessageInstanceEventClient;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId = null, triggerId: messageTriggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, analyticsDetails: analyticsDetails = null } = (0, $3wnx0.useMessageContext)();
    const { placementId: placementId } = (0, $iqAhj.usePlacementContext)();
    const browserContext = (0, $5ZQPg.usePostOfficeContext)();
    const recommendationContext = (0, $3hO6D.useRecommendationContext)();
    const messageInstanceDeliveredSuccessfully = (0, $eJOHy.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $eUjlj.MessageInstanceEventContextError)());
            return;
        }
        const event = {
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId
    ]);
    const messageInstanceViewed = (0, $eJOHy.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $eUjlj.MessageInstanceEventContextError)());
            return;
        }
        const event = {
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId
    ]);
    const messageInstanceClicked = (0, $eJOHy.useCallback)(async (params)=>{
        if (!messageInstanceId && !params.messageInstanceId || !messageTemplateId && !params.messageTemplateId || !placementId || !messageCreationType && !params.messageCreationType || !messageTriggerId && !params.messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $eUjlj.MessageInstanceEventContextError)());
            return;
        }
        const clickEventPayload = {
            messageInstanceId: params.messageInstanceId ?? messageInstanceId,
            messageTemplateId: params.messageTemplateId ?? messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            messageCreationType: params.messageCreationType ?? messageCreationType,
            messageTriggerId: params.messageTriggerId ?? messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            ...params,
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...params.additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(clickEventPayload);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId
    ]);
    return {
        messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully,
        messageInstanceViewed: messageInstanceViewed,
        messageInstanceClicked: messageInstanceClicked
    };
};

});
parcelRegister("eUjlj", function(module, exports) {

$parcel$export(module.exports, "MessageInstanceEventContextError", () => $9e94ec93be86ab65$export$9ffc53d3edc152da);
class $9e94ec93be86ab65$export$9ffc53d3edc152da extends Error {
    constructor(){
        super('useMessageInstanceEvent must be used inside a Message template render component.');
    }
}
class $9e94ec93be86ab65$export$6c3423e1c9ff4d5b extends Error {
    constructor(){
        super('Unknown action type');
    }
}

});

parcelRegister("kvmaQ", function(module, exports) {

$parcel$export(module.exports, "MessageInstanceEventClient", () => $cb27152f092044d4$export$4564cfc2de39be55);
const $cb27152f092044d4$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/message-instance-event/bulk`;
const $cb27152f092044d4$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $cb27152f092044d4$var$MESSAGE_EVENTS_BATCH_SIZE = 30;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("7WsxX"));
class $cb27152f092044d4$export$4564cfc2de39be55 {
    async sendMessageInstanceEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $cb27152f092044d4$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async sendEventsToBackend(events) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $cb27152f092044d4$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $cb27152f092044d4$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendEventsToBackend(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($cb27152f092044d4$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $cb27152f092044d4$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendEventsToBackend(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $cb27152f092044d4$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});
parcelRegister("7WsxX", function(module, exports) {

$parcel$export(module.exports, "Headers", () => $5c8417fc15f82fb3$export$79b704688b15c0f4);
$parcel$export(module.exports, "Request", () => $5c8417fc15f82fb3$export$7fa6c5b6f8193917);
$parcel$export(module.exports, "Response", () => $5c8417fc15f82fb3$export$9f633d56d7ec90d3);
$parcel$export(module.exports, "DOMException", () => $5c8417fc15f82fb3$export$fe58bcf938607f6a);
$parcel$export(module.exports, "fetch", () => $5c8417fc15f82fb3$export$e7aa7bc5c1b3cfb3);
/* eslint-disable no-prototype-builtins */ var $5c8417fc15f82fb3$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $5c8417fc15f82fb3$var$support = {
    searchParams: 'URLSearchParams' in $5c8417fc15f82fb3$var$g,
    iterable: 'Symbol' in $5c8417fc15f82fb3$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $5c8417fc15f82fb3$var$g && 'Blob' in $5c8417fc15f82fb3$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $5c8417fc15f82fb3$var$g,
    arrayBuffer: 'ArrayBuffer' in $5c8417fc15f82fb3$var$g
};
function $5c8417fc15f82fb3$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($5c8417fc15f82fb3$var$support.arrayBuffer) {
    var $5c8417fc15f82fb3$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $5c8417fc15f82fb3$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $5c8417fc15f82fb3$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $5c8417fc15f82fb3$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $5c8417fc15f82fb3$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $5c8417fc15f82fb3$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($5c8417fc15f82fb3$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $5c8417fc15f82fb3$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $5c8417fc15f82fb3$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $5c8417fc15f82fb3$var$normalizeName(name);
    value = $5c8417fc15f82fb3$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$5c8417fc15f82fb3$var$normalizeName(name)];
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $5c8417fc15f82fb3$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($5c8417fc15f82fb3$var$normalizeName(name));
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$5c8417fc15f82fb3$var$normalizeName(name)] = $5c8417fc15f82fb3$var$normalizeValue(value);
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $5c8417fc15f82fb3$var$iteratorFor(items);
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $5c8417fc15f82fb3$var$iteratorFor(items);
};
$5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $5c8417fc15f82fb3$var$iteratorFor(items);
};
if ($5c8417fc15f82fb3$var$support.iterable) $5c8417fc15f82fb3$export$79b704688b15c0f4.prototype[Symbol.iterator] = $5c8417fc15f82fb3$export$79b704688b15c0f4.prototype.entries;
function $5c8417fc15f82fb3$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $5c8417fc15f82fb3$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $5c8417fc15f82fb3$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $5c8417fc15f82fb3$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $5c8417fc15f82fb3$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $5c8417fc15f82fb3$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $5c8417fc15f82fb3$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $5c8417fc15f82fb3$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $5c8417fc15f82fb3$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($5c8417fc15f82fb3$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($5c8417fc15f82fb3$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($5c8417fc15f82fb3$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($5c8417fc15f82fb3$var$support.arrayBuffer && $5c8417fc15f82fb3$var$support.blob && $5c8417fc15f82fb3$var$isDataView(body)) {
            this._bodyArrayBuffer = $5c8417fc15f82fb3$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($5c8417fc15f82fb3$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $5c8417fc15f82fb3$var$isArrayBufferView(body))) this._bodyArrayBuffer = $5c8417fc15f82fb3$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($5c8417fc15f82fb3$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($5c8417fc15f82fb3$var$support.blob) this.blob = function() {
        var rejected = $5c8417fc15f82fb3$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $5c8417fc15f82fb3$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($5c8417fc15f82fb3$var$support.blob) return this.blob().then($5c8417fc15f82fb3$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $5c8417fc15f82fb3$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $5c8417fc15f82fb3$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($5c8417fc15f82fb3$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($5c8417fc15f82fb3$var$support.formData) this.formData = function() {
        return this.text().then($5c8417fc15f82fb3$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $5c8417fc15f82fb3$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $5c8417fc15f82fb3$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $5c8417fc15f82fb3$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $5c8417fc15f82fb3$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $5c8417fc15f82fb3$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $5c8417fc15f82fb3$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $5c8417fc15f82fb3$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $5c8417fc15f82fb3$export$79b704688b15c0f4(options.headers);
    this.method = $5c8417fc15f82fb3$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $5c8417fc15f82fb3$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$5c8417fc15f82fb3$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $5c8417fc15f82fb3$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $5c8417fc15f82fb3$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $5c8417fc15f82fb3$var$parseHeaders(rawHeaders) {
    var headers = new $5c8417fc15f82fb3$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$5c8417fc15f82fb3$var$Body.call($5c8417fc15f82fb3$export$7fa6c5b6f8193917.prototype);
function $5c8417fc15f82fb3$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $5c8417fc15f82fb3$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $5c8417fc15f82fb3$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$5c8417fc15f82fb3$var$Body.call($5c8417fc15f82fb3$export$9f633d56d7ec90d3.prototype);
$5c8417fc15f82fb3$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $5c8417fc15f82fb3$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $5c8417fc15f82fb3$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$5c8417fc15f82fb3$export$9f633d56d7ec90d3.error = function() {
    var response = new $5c8417fc15f82fb3$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $5c8417fc15f82fb3$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$5c8417fc15f82fb3$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($5c8417fc15f82fb3$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $5c8417fc15f82fb3$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $5c8417fc15f82fb3$export$fe58bcf938607f6a = $5c8417fc15f82fb3$var$g.DOMException;
try {
    new $5c8417fc15f82fb3$export$fe58bcf938607f6a();
} catch (err) {
    $5c8417fc15f82fb3$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $5c8417fc15f82fb3$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $5c8417fc15f82fb3$export$fe58bcf938607f6a.prototype.constructor = $5c8417fc15f82fb3$export$fe58bcf938607f6a;
}
function $5c8417fc15f82fb3$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $5c8417fc15f82fb3$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $5c8417fc15f82fb3$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $5c8417fc15f82fb3$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $5c8417fc15f82fb3$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $5c8417fc15f82fb3$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $5c8417fc15f82fb3$var$g.location.href ? $5c8417fc15f82fb3$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($5c8417fc15f82fb3$var$support.blob) xhr.responseType = 'blob';
            else if ($5c8417fc15f82fb3$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $5c8417fc15f82fb3$export$79b704688b15c0f4 || $5c8417fc15f82fb3$var$g.Headers && init.headers instanceof $5c8417fc15f82fb3$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($5c8417fc15f82fb3$var$normalizeName(name));
                xhr.setRequestHeader(name, $5c8417fc15f82fb3$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$5c8417fc15f82fb3$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$5c8417fc15f82fb3$var$g.fetch) {
    $5c8417fc15f82fb3$var$g.fetch = $5c8417fc15f82fb3$export$e7aa7bc5c1b3cfb3;
    $5c8417fc15f82fb3$var$g.Headers = $5c8417fc15f82fb3$export$79b704688b15c0f4;
    $5c8417fc15f82fb3$var$g.Request = $5c8417fc15f82fb3$export$7fa6c5b6f8193917;
    $5c8417fc15f82fb3$var$g.Response = $5c8417fc15f82fb3$export$9f633d56d7ec90d3;
}

});



parcelRegister("4vp0Q", function(module, exports) {

$parcel$export(module.exports, "useMessageEvent", () => $fab62bd119f7a5b6$export$3cbbf1e81e2ecb39);

var $gFu5h = parcelRequire("gFu5h");
var $5ZQPg = parcelRequire("5ZQPg");

var $3wnx0 = parcelRequire("3wnx0");

var $iqAhj = parcelRequire("iqAhj");

var $3hO6D = parcelRequire("3hO6D");

var $eJOHy = parcelRequire("eJOHy");

var $gdAOG = parcelRequire("gdAOG");

var $7cEQI = parcelRequire("7cEQI");

var $du1m6 = parcelRequire("du1m6");
const $fab62bd119f7a5b6$export$3cbbf1e81e2ecb39 = ()=>{
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $7cEQI.MessageEventClient)();
    const client = globalThis.window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, $gFu5h.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $3wnx0.useMessageContext)();
    const { placementId: placementId } = (0, $iqAhj.usePlacementContext)();
    const browserContext = (0, $5ZQPg.usePostOfficeContext)();
    const recommendationContext = (0, $3hO6D.useRecommendationContext)();
    const context = {
        browser: browserContext,
        recommendation: recommendationContext
    };
    /**
	 * Marks all messages as read. Calls markAllAsReadEvent() as the API call
	 */ const markAllAsRead = (0, $eJOHy.useCallback)(async (messages)=>{
        const messagesEventPostPayload = messages.map((message)=>{
            const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $gdAOG.MessageLifecycleContextError)();
            return {
                messageInstanceId: message['messageInstanceId'],
                messageTemplateId: message['messageTemplateId'],
                type: (0, $du1m6.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            };
        });
        try {
            await client.markAllAsReadEvent(messagesEventPostPayload);
        } catch (error) {
            throw new (0, $gdAOG.MessageLifecycleClientError)();
        }
    }, [
        client,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as read. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageRead = (0, $eJOHy.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $gdAOG.MessageLifecycleContextError)();
        markReadFromPlacement({
            messageInstanceId: messageInstanceId
        });
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $du1m6.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        } catch (error) {
            throw new (0, $gdAOG.MessageLifecycleClientError)();
        }
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        markReadFromPlacement
    ]);
    /**
	 * Marks a message as unread. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageUnread = (0, $eJOHy.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $gdAOG.MessageLifecycleContextError)();
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $du1m6.InAppMessageEventType).Unread,
                placement: placementId,
                createdAt: Date.now(),
                context: context,
                analyticsDetails: analyticsDetails
            });
        } catch (error) {
            throw new (0, $gdAOG.MessageLifecycleClientError)();
        }
    }, [
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as viewed. This event is fired automatically and should not need to be fired manually in the message component.
	 */ const messageViewed = (0, $eJOHy.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $gdAOG.MessageLifecycleContextError)();
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $du1m6.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markViewedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClicked = (0, $eJOHy.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $gdAOG.MessageLifecycleContextError)();
        markClickedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $du1m6.InAppMessageEventType).Clicked,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markClickedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Lower value than messageClicked (use for options like: "Learn More"), not to be used as a dismiss
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClickedSecondary = (0, $eJOHy.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $gdAOG.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $du1m6.InAppMessageEventType).ClickedSecondary,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as acknowledged
	 */ const messageAcknowledged = (0, $eJOHy.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $gdAOG.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $du1m6.InAppMessageEventType).Acknowledged,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as dismissed.
	 * This event is used as a negative reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageDismissed = (0, $eJOHy.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $gdAOG.MessageLifecycleContextError)();
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $du1m6.InAppMessageEventType).Dismissed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        dismissMessageFromPlacement
    ]);
    /**
	 * Marks a message as snoozed.
	 * This event is not used to train the Post Office Defacto Bandit ML Model.
	 */ const messageSnoozed = (0, $eJOHy.useCallback)(async (snoozeDays)=>{
        const MILLIS_IN_A_DAY = 86400000;
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $gdAOG.MessageLifecycleContextError)();
        snoozeMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $du1m6.InAppMessageEventType).Snoozed,
            placement: placementId,
            createdAt: Date.now(),
            statusExpiryTime: statusExpiryTime,
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        snoozeMessageFromPlacement
    ]);
    return {
        markAllAsRead: markAllAsRead,
        messageRead: messageRead,
        messageUnread: messageUnread,
        messageViewed: messageViewed,
        messageClicked: messageClicked,
        messageClickedSecondary: messageClickedSecondary,
        messageAcknowledged: messageAcknowledged,
        messageDismissed: messageDismissed,
        messageSnoozed: messageSnoozed
    };
};

});
parcelRegister("gdAOG", function(module, exports) {

$parcel$export(module.exports, "MessageLifecycleContextError", () => $3a93fca1065fee29$export$12bb62b204112f55);
$parcel$export(module.exports, "MessageLifecycleClientError", () => $3a93fca1065fee29$export$44f397e2afeb89e0);
class $3a93fca1065fee29$export$12bb62b204112f55 extends Error {
    constructor(){
        super('useMessageLifecycle must be used inside a Message template render component.');
    }
}
class $3a93fca1065fee29$export$44f397e2afeb89e0 extends Error {
    constructor(){
        super('API call to /messages failed due to an error');
    }
}

});

parcelRegister("7cEQI", function(module, exports) {

$parcel$export(module.exports, "MessageEventClient", () => $4c3527e1dfb2d638$export$ae86a6dabe385178);
const $4c3527e1dfb2d638$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
const $4c3527e1dfb2d638$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $4c3527e1dfb2d638$var$MESSAGE_EVENTS_BATCH_SIZE = 250;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("7WsxX"));
class $4c3527e1dfb2d638$export$ae86a6dabe385178 {
    async sendEvent(event) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(event)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    batchSendEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $4c3527e1dfb2d638$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async markAllAsReadEvent(messages) {
        this.batchEvents.push(...messages);
        await this.flushBatchEvents();
    }
    async sendMessageEvents(events) {
        const url = `${this.endpointUrl}/bulk`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $4c3527e1dfb2d638$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $4c3527e1dfb2d638$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendMessageEvents(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($4c3527e1dfb2d638$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $4c3527e1dfb2d638$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendMessageEvents(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $4c3527e1dfb2d638$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});

parcelRegister("du1m6", function(module, exports) {

$parcel$export(module.exports, "InAppMessageEventType", () => $58f553b9b9eff6b2$export$b31ffc6f7c85f1b);
var $58f553b9b9eff6b2$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});

});



parcelRegister("9vhhA", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $404fc1d69cae5759$export$78c758434c34d601);

var $ayGpT = parcelRequire("ayGpT");
const { createRender: $404fc1d69cae5759$export$78c758434c34d601, createValidate: $404fc1d69cae5759$export$2859a83e4d6da57d } = (0, $ayGpT.createClientPipeline)();
const { createHydrate: $404fc1d69cae5759$export$c905bc718befd59b, createHydrateExample: $404fc1d69cae5759$export$1f41223e5b0a6622, createTransformMetadata: $404fc1d69cae5759$export$88fe13b4d13f8423 } = (0, $ayGpT.createServerPipeline)();

});
parcelRegister("ayGpT", function(module, exports) {

$parcel$export(module.exports, "createServerPipeline", () => $49f0bd5f603ce943$export$b8fedcd4634de5cd);
$parcel$export(module.exports, "createClientPipeline", () => $49f0bd5f603ce943$export$7d57dbe7f7617174);

var $gt9Am = parcelRequire("gt9Am");

var $lNEyB = parcelRequire("lNEyB");
const $49f0bd5f603ce943$export$7693b71d48f1bf7e = ()=>(render)=>(renderProps)=>{
            const rendered = render(renderProps);
            if (rendered === null) return null;
            return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lNEyB.MessageViewed), {}),
                    rendered
                ]
            });
        };
const $49f0bd5f603ce943$export$b4a84c754a962eee = ()=>(transformMetadata)=>(params)=>transformMetadata(params);
const $49f0bd5f603ce943$export$62864968b8b09cdf = ()=>(hydrate)=>(requestContext, placementContext, messageContext)=>hydrate(requestContext, placementContext, messageContext);
const $49f0bd5f603ce943$var$exampleHydrator = (hydrateExample, config)=>(_requestContext, placementContext, messageContext)=>{
        const _config = config;
        return {
            ...hydrateExample({
                ..._config?.requestContext ?? {}
            }, placementContext, messageContext),
            ..._config?.additionalRenderProps ?? {}
        };
    };
const $49f0bd5f603ce943$export$803c53721d530406 = ()=>(hydrateExample, config)=>$49f0bd5f603ce943$var$exampleHydrator(hydrateExample, config);
const $49f0bd5f603ce943$var$initializeValidate = ()=>(validate)=>(apiResponse)=>{
            try {
                validate(apiResponse);
            } catch (error) {
                throw error instanceof Error ? error : new Error(typeof error === 'string' ? error : 'Unknown validation error');
            }
            return apiResponse;
        };
const $49f0bd5f603ce943$export$b8fedcd4634de5cd = ()=>({
        createHydrate: $49f0bd5f603ce943$export$62864968b8b09cdf(),
        createHydrateExample: $49f0bd5f603ce943$export$803c53721d530406(),
        createTransformMetadata: $49f0bd5f603ce943$export$b4a84c754a962eee()
    });
const $49f0bd5f603ce943$export$7d57dbe7f7617174 = ()=>({
        createValidate: $49f0bd5f603ce943$var$initializeValidate(),
        createRender: $49f0bd5f603ce943$export$7693b71d48f1bf7e()
    });

});
parcelRegister("lNEyB", function(module, exports) {

$parcel$export(module.exports, "ManualMessageViewedEvent", () => $21889611b57cd62f$export$de534803cb07dfcc);
$parcel$export(module.exports, "MessageViewed", () => $21889611b57cd62f$export$14fe1fc3395b6e3f);

var $gt9Am = parcelRequire("gt9Am");

var $guu3z = parcelRequire("guu3z");

var $4vp0Q = parcelRequire("4vp0Q");

var $eJOHy = parcelRequire("eJOHy");

var $6TYxj = parcelRequire("6TYxj");

var $hUaXr = parcelRequire("hUaXr");

var $izw77 = parcelRequire("izw77");
const $21889611b57cd62f$export$de534803cb07dfcc = ({ children: children })=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent, setFireMessageViewedInMessageComponent: setFireMessageViewedInMessageComponent } = (0, $hUaXr.useMessageAnalyticsContext)();
    if (fireMessageViewedInMessageComponent) setFireMessageViewedInMessageComponent(true);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};
const $21889611b57cd62f$export$14fe1fc3395b6e3f = ()=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent } = (0, $hUaXr.useMessageAnalyticsContext)();
    const { messageViewed: messageViewed } = (0, $4vp0Q.useMessageEvent)();
    const { messageInstanceViewed: messageInstanceViewed, messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $guu3z.useMessageInstanceEvent)();
    const hasDeliveredSuccessfullyBeenFired = (0, $eJOHy.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $eJOHy.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    // messageViewed returns a promise of void, which is incompatible with the TrackMount onMount prop
    const messageViewedVoidFunction = (0, $eJOHy.useCallback)(()=>{
        // Only fire the message viewed event if the message viewed event is not fired in the message component.
        if (fireMessageViewedInMessageComponent && !fireMessageViewedInMessageComponent.current) {
            messageViewed();
            messageInstanceViewed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $izw77.TrackMount), {
        onMount: messageViewedVoidFunction
    });
};
const $21889611b57cd62f$export$4c73c6f545b966b7 = ({ children: children })=>{
    const messageRef = (0, $eJOHy.useRef)(null);
    const { messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $guu3z.useMessageInstanceEvent)();
    const { inViewport: inViewport, enterCount: enterCount } = (0, $6TYxj.useInViewport)(messageRef, {});
    const hasDeliveredSuccessfullyBeenFired = (0, $eJOHy.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $eJOHy.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("section", {
        ref: messageRef,
        children: [
            inViewport && enterCount >= 1 ? /*#__PURE__*/ (0, $gt9Am.jsx)($21889611b57cd62f$export$14fe1fc3395b6e3f, {}) : null,
            children
        ]
    });
};

});
parcelRegister("6TYxj", function(module, exports) {

$parcel$export(module.exports, "useInViewport", () => $5066d660cd389c08$export$6215040b989f9b0f, (v) => $5066d660cd389c08$export$6215040b989f9b0f = v);
var $5066d660cd389c08$export$1e511d4a378977f5;
var $5066d660cd389c08$export$6215040b989f9b0f;
var $5066d660cd389c08$export$436b63fa4855237f;
var $5066d660cd389c08$export$2e2bcd8739ae039;
var $5066d660cd389c08$export$95cef81be5ddcfd4;
"use strict";
$5066d660cd389c08$export$1e511d4a378977f5 = true;
$5066d660cd389c08$export$6215040b989f9b0f = $5066d660cd389c08$export$436b63fa4855237f = $5066d660cd389c08$export$2e2bcd8739ae039 = $5066d660cd389c08$export$95cef81be5ddcfd4 = void 0;

var $5066d660cd389c08$var$_handleViewport = $5066d660cd389c08$var$_interopRequireDefault((parcelRequire("fFVXE")));
$5066d660cd389c08$export$436b63fa4855237f = $5066d660cd389c08$var$_handleViewport.default;

var $5066d660cd389c08$var$_useInViewport = $5066d660cd389c08$var$_interopRequireDefault((parcelRequire("wxg9p")));
$5066d660cd389c08$export$6215040b989f9b0f = $5066d660cd389c08$var$_useInViewport.default;
function $5066d660cd389c08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $5066d660cd389c08$var$customProps = $5066d660cd389c08$export$95cef81be5ddcfd4 = [
    'inViewport',
    'enterCount',
    'leaveCount'
];
var $5066d660cd389c08$var$_default = $5066d660cd389c08$export$2e2bcd8739ae039 = $5066d660cd389c08$var$_handleViewport.default;

});
parcelRegister("fFVXE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $b697a5333b073082$export$1e511d4a378977f5, (v) => $b697a5333b073082$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $b697a5333b073082$export$2e2bcd8739ae039, (v) => $b697a5333b073082$export$2e2bcd8739ae039 = v);
var $b697a5333b073082$export$1e511d4a378977f5;
var $b697a5333b073082$export$2e2bcd8739ae039;
"use strict";
$b697a5333b073082$export$1e511d4a378977f5 = true;
$b697a5333b073082$export$2e2bcd8739ae039 = void 0;

var $eJOHy = parcelRequire("eJOHy");

var $b697a5333b073082$var$_hoistNonReactStatics = $b697a5333b073082$var$_interopRequireDefault((parcelRequire("cjwij")));

var $b697a5333b073082$var$_useInViewport = $b697a5333b073082$var$_interopRequireDefault((parcelRequire("wxg9p")));

var $lDsjs = parcelRequire("lDsjs");

var $gt9Am = parcelRequire("gt9Am");
var $b697a5333b073082$var$_excluded = [
    "onEnterViewport",
    "onLeaveViewport"
];
function $b697a5333b073082$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $b697a5333b073082$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $b697a5333b073082$var$_extends() {
    return $b697a5333b073082$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b697a5333b073082$var$_extends.apply(null, arguments);
}
function $b697a5333b073082$var$handleViewport(TargetComponent, options, config) {
    if (options === void 0) options = $lDsjs.defaultOptions;
    if (config === void 0) config = $lDsjs.defaultConfig;
    var ForwardedRefComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
        var refProps = {
            forwardedRef: ref
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)(TargetComponent, $b697a5333b073082$var$_extends({}, props, refProps));
    });
    var InViewport = (_ref)=>{
        var { onEnterViewport: onEnterViewport = $lDsjs.noop, onLeaveViewport: onLeaveViewport = $lDsjs.noop } = _ref, restProps = $b697a5333b073082$var$_objectWithoutPropertiesLoose(_ref, $b697a5333b073082$var$_excluded);
        var node = (0, $eJOHy.useRef)(null);
        var { inViewport: inViewport, enterCount: enterCount, leaveCount: leaveCount } = (0, $b697a5333b073082$var$_useInViewport.default)(node, options, config, {
            onEnterViewport: onEnterViewport,
            onLeaveViewport: onLeaveViewport
        });
        var props = $b697a5333b073082$var$_extends({}, restProps, {
            inViewport: inViewport,
            enterCount: enterCount,
            leaveCount: leaveCount
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)(ForwardedRefComponent, $b697a5333b073082$var$_extends({}, props, {
            ref: node
        }));
    };
    var name = TargetComponent.displayName || TargetComponent.name || 'Component';
    InViewport.displayName = "handleViewport(" + name + ")";
    return (0, $b697a5333b073082$var$_hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}
var $b697a5333b073082$var$_default = $b697a5333b073082$export$2e2bcd8739ae039 = $b697a5333b073082$var$handleViewport;

});
parcelRegister("wxg9p", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $061cc9eaade77258$export$1e511d4a378977f5, (v) => $061cc9eaade77258$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $061cc9eaade77258$export$2e2bcd8739ae039, (v) => $061cc9eaade77258$export$2e2bcd8739ae039 = v);
var $061cc9eaade77258$export$1e511d4a378977f5;
var $061cc9eaade77258$export$2e2bcd8739ae039;
"use strict";
$061cc9eaade77258$export$1e511d4a378977f5 = true;
$061cc9eaade77258$export$2e2bcd8739ae039 = void 0;

var $eJOHy = parcelRequire("eJOHy");

var $lDsjs = parcelRequire("lDsjs");
var $061cc9eaade77258$var$defaultMutationObserverOption = {
    attributes: true,
    childList: true,
    subtree: true
};
var $061cc9eaade77258$var$useInViewport = function useInViewport(target, options, config, props) {
    if (options === void 0) options = $lDsjs.defaultOptions;
    if (config === void 0) config = $lDsjs.defaultConfig;
    if (props === void 0) props = $lDsjs.defaultProps;
    var { onEnterViewport: onEnterViewport, onLeaveViewport: onLeaveViewport } = props;
    var [, forceUpdate] = (0, $eJOHy.useState)();
    var observer = (0, $eJOHy.useRef)();
    var inViewportRef = (0, $eJOHy.useRef)(false);
    var intersected = (0, $eJOHy.useRef)(false);
    var enterCountRef = (0, $eJOHy.useRef)(0);
    var leaveCountRef = (0, $eJOHy.useRef)(0);
    // State to track when target is available
    var [isTargetReady, setIsTargetReady] = (0, $eJOHy.useState)(Boolean(target.current));
    function startObserver(_ref) {
        var { observerRef: observerRef } = _ref;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.observe(node);
        }
    }
    function stopObserver(_ref2) {
        var { observerRef: observerRef } = _ref2;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.unobserve(node);
        }
        observerRef == null || observerRef.disconnect();
        observer.current = null;
    }
    var handleIntersection = (entries)=>{
        var entry = entries[0] || {};
        var { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = entry;
        var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;
        // enter
        if (!intersected.current && isInViewport) {
            intersected.current = true;
            onEnterViewport == null || onEnterViewport();
            enterCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
            return;
        }
        // leave
        if (intersected.current && !isInViewport) {
            intersected.current = false;
            onLeaveViewport == null || onLeaveViewport();
            if (config.disconnectOnLeave && observer.current) // disconnect observer on leave
            observer.current.disconnect();
            leaveCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
        }
    };
    function initIntersectionObserver(_ref3) {
        var { observerRef: observerRef } = _ref3;
        if (!observerRef) {
            observer.current = new IntersectionObserver(handleIntersection, options);
            return observer.current;
        }
        return observerRef;
    }
    (0, $eJOHy.useEffect)(()=>{
        var observerRef = observer.current;
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        observerRef = initIntersectionObserver({
            observerRef: observerRef
        });
        startObserver({
            observerRef: observerRef
        });
        return ()=>{
            stopObserver({
                observerRef: observerRef
            });
        };
    }, [
        target.current,
        options,
        config,
        onEnterViewport,
        onLeaveViewport
    ]);
    // Use MutationObserver to detect when `target.current` becomes non-null
    // only at start up
    (0, $eJOHy.useEffect)(()=>{
        var currentElement = target.current;
        var mutationObserver = null;
        // MutationObserver callback to check when the target ref is assigned
        var handleOnChange = ()=>{
            if (target.current && !isTargetReady) {
                setIsTargetReady(true);
                if (mutationObserver) mutationObserver.disconnect();
            }
        };
        if (currentElement) setIsTargetReady(true); // If target is already available, mark it ready
        else {
            // Observe changes to detect when `target.current` becomes non-null
            mutationObserver = new MutationObserver(handleOnChange);
            mutationObserver.observe(document.body, $061cc9eaade77258$var$defaultMutationObserverOption);
        }
        // Cleanup function to stop observing when the component unmounts
        return ()=>{
            if (mutationObserver) mutationObserver.disconnect();
        };
    }, [
        target.current
    ]);
    return {
        inViewport: inViewportRef.current,
        enterCount: enterCountRef.current,
        leaveCount: leaveCountRef.current
    };
};
var $061cc9eaade77258$var$_default = $061cc9eaade77258$export$2e2bcd8739ae039 = $061cc9eaade77258$var$useInViewport;

});
parcelRegister("lDsjs", function(module, exports) {

$parcel$export(module.exports, "noop", () => $fc0333d9692336a6$export$8793edee2d425525, (v) => $fc0333d9692336a6$export$8793edee2d425525 = v);
$parcel$export(module.exports, "defaultProps", () => $fc0333d9692336a6$export$9c21a3269931e1e6, (v) => $fc0333d9692336a6$export$9c21a3269931e1e6 = v);
$parcel$export(module.exports, "defaultOptions", () => $fc0333d9692336a6$export$ba43bf67f3d48107, (v) => $fc0333d9692336a6$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "defaultConfig", () => $fc0333d9692336a6$export$f84bd70098573c5c, (v) => $fc0333d9692336a6$export$f84bd70098573c5c = v);
var $fc0333d9692336a6$export$1e511d4a378977f5;
var $fc0333d9692336a6$export$8793edee2d425525;
var $fc0333d9692336a6$export$9c21a3269931e1e6;
var $fc0333d9692336a6$export$ba43bf67f3d48107;
var $fc0333d9692336a6$export$f84bd70098573c5c;
"use strict";
$fc0333d9692336a6$export$1e511d4a378977f5 = true;
$fc0333d9692336a6$export$8793edee2d425525 = $fc0333d9692336a6$export$9c21a3269931e1e6 = $fc0333d9692336a6$export$ba43bf67f3d48107 = $fc0333d9692336a6$export$f84bd70098573c5c = void 0;
var $fc0333d9692336a6$var$defaultOptions = $fc0333d9692336a6$export$ba43bf67f3d48107 = {};
var $fc0333d9692336a6$var$defaultConfig = $fc0333d9692336a6$export$f84bd70098573c5c = {
    disconnectOnLeave: false
};
var $fc0333d9692336a6$var$noop = ()=>{};
$fc0333d9692336a6$export$8793edee2d425525 = $fc0333d9692336a6$var$noop;
var $fc0333d9692336a6$var$defaultProps = $fc0333d9692336a6$export$9c21a3269931e1e6 = {
    onEnterViewport: $fc0333d9692336a6$var$noop,
    onLeaveViewport: $fc0333d9692336a6$var$noop
};

});









parcelRegister("cKSFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a62b833ccc95a2$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $e4nep = parcelRequire("e4nep");
var $69a62b833ccc95a2$export$2e2bcd8739ae039 = {
    'message-template-template': (0, $e4nep.default)
};

});
parcelRegister("e4nep", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ca1cf0abad6c3b4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $hc5Dc = parcelRequire("hc5Dc");
parcelRequire("eJOHy");

var $8qI23 = parcelRequire("8qI23");
const $2ca1cf0abad6c3b4$export$b3890eb0ae9dca99 = (0, $8qI23.createRender)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hc5Dc.TopBannerMessage), {}));
var $2ca1cf0abad6c3b4$export$2e2bcd8739ae039 = $2ca1cf0abad6c3b4$export$b3890eb0ae9dca99;

});
parcelRegister("8qI23", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $ad036b356eea270a$export$78c758434c34d601);

var $ayGpT = parcelRequire("ayGpT");
const { createRender: $ad036b356eea270a$export$78c758434c34d601, createValidate: $ad036b356eea270a$export$2859a83e4d6da57d } = (0, $ayGpT.createClientPipeline)();
const { createHydrate: $ad036b356eea270a$export$c905bc718befd59b, createHydrateExample: $ad036b356eea270a$export$1f41223e5b0a6622, createTransformMetadata: $ad036b356eea270a$export$88fe13b4d13f8423 } = (0, $ayGpT.createServerPipeline)();

});




/* GeneratedContentHash: 90a7d45c313eaf24d28f3e71b65ecf55df9e4f5806226e92484289f49713e5bf */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $cc2adc46e79f09dd$export$a5cfae247d8360ef = 'jira-top-banner';

parcelRegister("8ozTH", function(module, exports) {

$parcel$export(module.exports, "withJiraTopBannerIntlProvider", () => $5530fb441c468c2e$export$2a49ebed7015cea4);
/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $9XuVH = parcelRequire("9XuVH");

var $1dUmv = parcelRequire("1dUmv");

var $4GHII = parcelRequire("4GHII");
const $5530fb441c468c2e$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $1dUmv.messagesLoader)(locale),
        (0, $4GHII.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $5530fb441c468c2e$export$2a49ebed7015cea4 = (Component)=>{
    return (0, $9XuVH.withIntlProvider)({
        messagesLoader: $5530fb441c468c2e$export$d5a462ce7bd04520
    }, Component);
};

});
parcelRegister("9XuVH", function(module, exports) {

$parcel$export(module.exports, "withIntlProvider", () => $4646f2243514b56d$export$a5d940130f33be3f);

var $gt9Am = parcelRequire("gt9Am");

var $3Y3pj = parcelRequire("3Y3pj");
const $4646f2243514b56d$export$a5d940130f33be3f = (intlProviderProps, Component)=>({ preloadedMessages: preloadedMessages, ...props })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Y3pj.IntlProvider), {
            ...intlProviderProps,
            messages: preloadedMessages,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...props
            })
        });
    };

});
parcelRegister("3Y3pj", function(module, exports) {

$parcel$export(module.exports, "IntlProvider", () => $7c42f52a08547565$export$480518999dfc4151);

var $gt9Am = parcelRequire("gt9Am");

var $e0Nss = parcelRequire("e0Nss");

var $4nehu = parcelRequire("4nehu");
var $lRq8t = parcelRequire("lRq8t");

var $kSoGg = parcelRequire("kSoGg");
function $7c42f52a08547565$var$useFetchLocale() {
    let locale = 'en';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $e0Nss.useFirePostOfficeAnalyticsEvents)();
    try {
        const { locale: intlLocale } = (0, $lRq8t.default)();
        locale = intlLocale;
    } catch (err) {
        fireAnalyticsEvent({
            action: 'errored',
            actionSubject: 'intlProvider',
            eventType: 'operational',
            attributes: {
                errorMessage: err
            }
        });
    }
    return {
        locale: locale
    };
}
function $7c42f52a08547565$export$480518999dfc4151(props) {
    const { locale: locale } = $7c42f52a08547565$var$useFetchLocale();
    const messages = (0, $kSoGg.useIntlMessages)(locale, props.messagesLoader, props.messages);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: locale,
        messages: messages,
        children: props.children
    });
}

});
parcelRegister("kSoGg", function(module, exports) {

$parcel$export(module.exports, "useIntlMessages", () => $d89549e27c6d119b$export$2641ec9a2025a81f);

var $e0Nss = parcelRequire("e0Nss");

var $eJOHy = parcelRequire("eJOHy");
const $d89549e27c6d119b$export$2641ec9a2025a81f = (locale, messageLoader, initialMessages)=>{
    const [messages, setMessages] = (0, $eJOHy.useState)(initialMessages);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $e0Nss.useFirePostOfficeAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (initialMessages) return;
        messageLoader(locale).then((loadedMessages)=>{
            if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
            if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlMessagesLoader',
                eventType: 'operational',
                attributes: {
                    locale: locale,
                    errorMessage: loadedMessages.errors
                }
            });
        })// eslint-disable-next-line no-console
        .catch(console.error);
    }, [
        locale,
        initialMessages
    ]);
    return messages;
};

});



parcelRegister("1dUmv", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $25eca56673f43709$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $9gaVw = parcelRequire("9gaVw");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $25eca56673f43709$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $25eca56673f43709$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("iID65")));
        case 'da':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("jbTEY")));
        case 'de':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("g5fCb")));
        case 'en-GB':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("azP87")));
        case 'en-US':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("foiqs")));
        case 'en-XA':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("2jtEt")));
        case 'en-XB':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("fbjyA")));
        case 'en-ZZ':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("fFK9p")));
        case 'en':
            return $25eca56673f43709$var$importHelper(await Promise.resolve((parcelRequire("9gaVw"))));
        case 'es':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("5vH1F")));
        case 'et':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("jSUUy")));
        case 'fi':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("6iQB6")));
        case 'fr':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("7hiF0")));
        case 'hr':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("6fEEs")));
        case 'hu':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("ktl6I")));
        case 'it':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("7cMV5")));
        case 'ja':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("h0s0u")));
        case 'ko':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("8gcpy")));
        case 'nb':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("3TyxK")));
        case 'nl':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("1SQyj")));
        case 'pl':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("bu2dH")));
        case 'pt-BR':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("15chK")));
        case 'ro':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("eiNXg")));
        case 'ru':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("69QyJ")));
        case 'sl':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("19wx1")));
        case 'sr-RS':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("7FNO1")));
        case 'sr-YR':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("42kgl")));
        case 'sr':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("9T7WM")));
        case 'sv':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("el2Jz")));
        case 'th':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("9ahb6")));
        case 'tr':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("51xXu")));
        case 'uk':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("1e0BM")));
        case 'vi':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("j8T0v")));
        case 'zh-CN':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("ddEeN")));
        case 'zh-TW':
            return $25eca56673f43709$var$importHelper(await (parcelRequire("87gNs")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9gaVw));
    }
};

});
parcelRegister("9gaVw", function(module, exports) {
module.exports = JSON.parse('{"jira-issueview-quickactions.src.ui.index.recommended-for-you":[{"type":0,"value":"Recommended for you"}],"jira-pulsar.common.components.cross-flow.dismiss":[{"type":0,"value":"Dismiss"}],"jira-pulsar.common.components.issue-view-description-ad.close":[{"type":0,"value":"Close"}],"jira-pulsar.jira-common.celebration-icon.body_image_alt":[{"type":0,"value":"Celebration icon"}],"jira-pulsar.jira-common.exclamation-icon.body_image_alt":[{"type":0,"value":"Exclamation icon"}],"jira-pulsar.jira-common.message-template.text.body.display.old.field.value":[{"type":0,"value":"was: "},{"type":1,"value":"oldFieldValue"}],"jira-pulsar.jira-common.right-arrow-icon.no-translate":[{"type":0,"value":"&#x2192;"}],"jira-pulsar.jira-contact-admin.message-template.email.body.from.contact.admin":[{"type":0,"value":"From:"}],"jira-pulsar.jira-contact-admin.message-template.email.body.new.message.from.contact.admin":[{"type":0,"value":"New message from Contact Administrators page"}],"jira-pulsar.jira-contact-admin.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"}],"jira-pulsar.jira-issue-approval-decided.right.arrow.image.alt.no-translate":[{"type":0,"value":"->"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers.plus.no-translate":[{"type":0,"value":"+"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.subject":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.declined.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required":[{"type":1,"value":"issueLink"},{"type":0,"value":" requires your approval"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"jira-pulsar.jira-issue-approval.message-template.email.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-archived.message-template.redacted.email.subject":[{"type":0,"value":"("},{"type":1,"value":"issueKey"},{"type":0,"value":") work item was archived"}],"jira-pulsar.jira-issue-assign.message-template-template.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"assigned"}],"type":8,"value":"b"},{"type":0,"value":" this work item to you"}],"jira-pulsar.jira-issue-assign.message-template.email.html.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assign.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assigned.email.body.assignee":[{"type":0,"value":"Assignee"}],"jira-pulsar.jira-issue-assigned.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-comment-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-delete.message-template.hipppa.view.update":[{"type":0,"value":"Comment: "},{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-comment-delete.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment-update.email.body.added":[{"type":0,"value":"Added"}],"jira-pulsar.jira-issue-comment-update.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-comment-update.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira-pulsar.jira-issue-comment-update.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment.body_image_alt":[{"type":0,"value":"Icon for comment on a Jira issue"}],"jira-pulsar.jira-issue-comment.email.body.add-comment":[{"type":0,"value":"Add comment"}],"jira-pulsar.jira-issue-comment.email.body.view-comment":[{"type":0,"value":"View comment"}],"jira-pulsar.jira-issue-comment.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-create.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-moved.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-moved.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"issueKey"},{"type":0,"value":" Work item was updated"}],"jira-pulsar.jira-issue-reopen.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-pulsar.jira-issue-reopen.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"jira-pulsar.jira-issue-reopened.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-update.email.body.slash.no-translate":[{"type":0,"value":" \u2192 "}],"jira-pulsar.jira-issue-update.message-template.changeby":[{"type":0,"value":"Change by: "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-update.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.hipppa.view.update":[{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-work-started.message-template.email.body.started":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"started work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-started.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.body.stopped":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"stopped work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-worklog-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-delete.email.body.work.log.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.add.worklog.title":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a worklog"}],"type":8,"value":"strong"},{"type":0,"value":" on "},{"children":[{"type":1,"value":"issueKey"}],"type":8,"value":"b"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.change.by":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.add.comment":[{"children":[{"type":0,"value":"Add Comment"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.description":[{"children":[{"type":0,"value":"View work description"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.entry.logged.by":[{"type":1,"value":"entry"},{"type":0,"value":" logged by "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklogged.body_image_alt":[{"type":0,"value":"Product logo"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.titleForIssueComment":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.titleForIssueDescription":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.page":[{"type":0,"value":"Page"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment":[{"type":0,"value":"Capture ideas and insights"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription":[{"type":0,"value":"Capture ideas and insights"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.titleForIssueDescription":[{"type":0,"value":"Idea"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.idea":[{"type":0,"value":"Idea"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Record a comment"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.descriptionForIssueDescription":[{"type":0,"value":"Use video to explain the work"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.titleForIssueDescription":[{"type":0,"value":"Record your screen"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.video":[{"type":0,"value":"Video"}],"jira.default.subject":[{"type":0,"value":"[JIRA] Project Update: "},{"type":1,"value":"projectName"},{"type":0,"value":" ("},{"type":1,"value":"projectKey"},{"type":0,"value":")"}],"jira.jira-bulk.message-template.email.header":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"sent you"}],"type":8,"value":"strong"},{"type":0,"value":" a message."}],"jira.jira-bulk.message-template.email.subject.user.provided.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"subject"}],"jira.jira-bulk.message-template.text.message":[{"type":1,"value":"user"},{"type":0,"value":" sent you a message"}],"jira.jira-common.email.footer.get.apps":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "}],"jira.jira-common.email.footer.get.apps.new":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "},{"children":[{"type":0,"value":"Android"}],"type":8,"value":"a1"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"iOS"}],"type":8,"value":"a2"},{"type":0,"value":"."}],"jira.jira-common.email.footer.give.feedback":[{"type":0,"value":"Give feedback"}],"jira.jira-common.email.footer.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.email.footer.open.attachment":[{"type":0,"value":"Open the work item to view attachments over 100 KB"}],"jira.jira-common.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-common.email.footer.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.email.slash.no-translate":[{"type":0,"value":"\\/"}],"jira.jira-common.message-template.text.body.assignee.label":[{"type":0,"value":"Assignee:"}],"jira.jira-common.message-template.text.body.attachments.label":[{"type":0,"value":"Attachments:"}],"jira.jira-common.message-template.text.body.key.label":[{"type":0,"value":"Key:"}],"jira.jira-common.message-template.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.message-template.text.body.priority.label":[{"type":0,"value":"Priority:"}],"jira.jira-common.message-template.text.body.project.label":[{"type":0,"value":"Project:"}],"jira.jira-common.message-template.text.body.reporter.heading":[{"type":0,"value":"Reporter: "}],"jira.jira-common.message-template.text.body.reporter.label":[{"type":0,"value":"Reporter:"}],"jira.jira-common.message-template.text.body.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.message-template.text.body.work.type.label":[{"type":0,"value":"Work type:"}],"jira.jira-filter-subscription.message-template.email.table.filter-label":[{"type":0,"value":"Filter: "}],"jira.jira-filter-subscription.message-template.email.table.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-filter-subscription.message-template.email.table.subscriber-label":[{"type":0,"value":"Subscriber:"}],"jira.jira-issue-approval-decided.message-template.approval.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval-decided.message-template.approval.event.allapproved.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.plural":[{"type":1,"value":"remainingApprovals"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.singular":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.declined.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.declined.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval.message-template.approval.required.title":[{"type":1,"value":"issueLabel"},{"type":0,"value":" requires your approval"}],"jira.jira-issue-approval.message-template.approval.title.all-approved":[{"type":1,"value":"issueLink"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.approval.approved":[{"type":0,"value":"Approved"}],"jira.jira-issue-approval.message-template.email.approval.approvers.remaining":[{"type":1,"value":"remainingApprovers"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira.jira-issue-approval.message-template.email.approval.declined":[{"type":0,"value":"Declined"}],"jira.jira-issue-approval.message-template.email.approval.declined.transition":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"declinedStatus"}],"jira.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira.jira-issue-approval.message-template.email.approval.one.approver.remaining":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.view.work.item":[{"type":0,"value":"View "},{"type":1,"value":"issueType"}],"jira.jira-issue-approval.message-template.email.approved.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.declined.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.footer.contact.us":[{"type":0,"value":"Contact Us"}],"jira.jira-issue-approval.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jira.jira-issue-approval.message-template.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-issue-approval.message-template.email.issue.approved":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.issue.has.moved.from":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-archived.message-template.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.redacted.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.text.archived.work.item":[{"type":1,"value":"user"},{"type":0,"value":" archived "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-assign.text.body.assigned":[{"type":0,"value":" "},{"type":1,"value":"user"},{"type":0,"value":" reassigned "},{"type":1,"value":"issueKey"}],"jira.jira-issue-assign.text.body.assignee.update":[{"type":0,"value":"Assignee: "},{"type":1,"value":"assigneeName"},{"type":0,"value":" was: ("},{"type":1,"value":"oldAssigneeName"},{"type":0,"value":")"}],"jira.jira-issue-assign.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-batch.email.body.issue.comments.heading":[{"type":0,"value":"Comments"}],"jira.jira-issue-batch.email.body.issue.created.heading":[{"type":0,"value":"Work item created"}],"jira.jira-issue-batch.email.body.issue.updates.heading":[{"type":0,"value":"Updates"}],"jira.jira-issue-batch.email.body.issue.worklog.heading":[{"type":0,"value":"Work log"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a new comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.created.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a work item"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work items"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.dot":[{"type":0,"value":". "}],"jira.jira-issue-batch.email.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.separator.comma":[{"type":0,"value":", "}],"jira.jira-issue-batch.email.body.summary.issue.updates.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"type":1,"value":"count"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.updates.multiple.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.updates.two.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"type":1,"value":"user1"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" started a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueId"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-batch.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] Updates for "},{"type":1,"value":"issueId"}],"jira.jira-issue-closed.message-template.email.body.closed":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"closed a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-closed.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" closed "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment-delete.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-delete.message-template.text.comment.was.deleted":[{"type":0,"value":"Comment: was deleted"}],"jira.jira-issue-comment-delete.message-template.text.updated.work.item":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-comment-update.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"edited a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-update.message-template.text.body.comment.was":[{"type":0,"value":"was (Author: "},{"type":1,"value":"authorName"},{"type":0,"value":"):"}],"jira.jira-issue-comment-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" edited a comment on "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-common.message-template.text.body.common.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-common.message-template.text.body.common.issue.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-create.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-create.email.body.view.attachments":[{"type":0,"value":"View Attachments"}],"jira.jira-issue-create.email.body.view.components":[{"type":0,"value":"View Components"}],"jira.jira-issue-create.email.body.view.description":[{"type":0,"value":"View description"}],"jira.jira-issue-create.email.body.view.environment":[{"type":0,"value":"View environment"}],"jira.jira-issue-create.email.body.view.labels":[{"type":0,"value":"View labels"}],"jira.jira-issue-create.email.body.view.work.type":[{"type":0,"value":"View Work Type"}],"jira.jira-issue-create.message-template.email.original.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueKey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-create.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" created "},{"type":1,"value":"issueKey"}],"jira.jira-issue-create.message-template.text.body.common.issue.key":[{"type":0,"value":"Key"}],"jira.jira-issue-create.message-template.text.body.common.summary":[{"type":0,"value":"Summary"}],"jira.jira-issue-create.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"jira.jira-issue-create.text.body.common.assignee":[{"type":0,"value":"Assignee"}],"jira.jira-issue-create.text.body.common.attachments":[{"type":0,"value":"Attachments"}],"jira.jira-issue-create.text.body.common.created":[{"type":0,"value":"Created"}],"jira.jira-issue-create.text.body.common.description":[{"type":0,"value":"Description"}],"jira.jira-issue-create.text.body.common.priority":[{"type":0,"value":"Priority"}],"jira.jira-issue-create.text.body.common.reporter":[{"type":0,"value":"Reporter"}],"jira.jira-issue-create.text.body.common.status":[{"type":0,"value":"Status"}],"jira.jira-issue-create.text.body.common.work.type":[{"type":0,"value":"Work type"}],"jira.jira-issue-delete.message-template.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" deleted this work item at "},{"type":1,"value":"timestamp"}],"jira.jira-issue-delete.message-template.redacted.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted"}],"type":8,"value":"strong"},{"type":0,"value":" a work item"}],"jira.jira-issue-delete.message-template.text.deleted.work.item":[{"type":1,"value":"user"},{"type":0,"value":" deleted "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-filter-subscription.message-template.email.subject":[{"type":0,"value":"[JIRA] Subscription: "},{"type":1,"value":"filterName"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.filter-name":[{"type":0,"value":"Filter: "},{"type":1,"value":"filterName"},{"type":1,"value":"count"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.subscriber-info":[{"type":0,"value":"Subscriber: "},{"type":1,"value":"subscriberName"}],"jira.jira-issue-mention.email.body.colon.no-translate":[{"type":0,"value":": "}],"jira.jira-issue-mention.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"mentioned you"}],"type":8,"value":"strong"},{"type":0,"value":" on a work item"}],"jira.jira-issue-mention.email.body.mentioned.you":[{"type":0,"value":" mentioned you "}],"jira.jira-issue-mention.email.body.onWorkItem.you":[{"type":0,"value":" on a work item "}],"jira.jira-issue-mention.email.body.spaces.no-translate":[{"type":0,"value":"&nbsp;&nbsp;"}],"jira.jira-issue-mention.email.body.view.work.item":[{"type":0,"value":" View work item "}],"jira.jira-issue-mention.email.subject.mention":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-mention.push.mentioned.you":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"jira.jira-issue-mention.push.mentioned.you.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on this work item"}],"jira.jira-issue-mention.text.body.addComment":[{"type":0,"value":" Add Comment: "}],"jira.jira-issue-mention.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-issue-mention.text.body.mention.hint":[{"type":0,"value":" Hint: You can mention someone in a work item description or comment by typing  \\"@\\" in front of their username."}],"jira.jira-issue-mention.text.body.mentioned":[{"type":0,"value":" mentioned you on "}],"jira.jira-issue-mention.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-mention.text.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira.jira-issue-mention.text.body.viewOnline":[{"type":0,"value":" View Online: "}],"jira.jira-issue-moved.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"moved a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-moved.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-notify.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"b"},{"type":0,"value":" a work item with you"}],"jira.jira-issue-notify.email.subject.notify":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared \\""},{"type":1,"value":"issueKey"},{"type":0,"value":" "},{"type":1,"value":"summary"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-reopened.message-template.email.body.reopened":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"reopened a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-reopened.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" reopened "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-resolved.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-search.message-template.email.subject.filter.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared the filter \\""},{"type":1,"value":"filterName"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-search.message-template.email.subject.search.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.email.header.filter":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a filter with you."}],"jira.jira-issue-share.message-template.email.header.results":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a search result with you."}],"jira.jira-issue-share.message-template.email.shared-with":[{"type":0,"value":" Also shared with "}],"jira.jira-issue-share.message-template.email.view.results":[{"type":0,"value":"View search results"}],"jira.jira-issue-share.message-template.text.shared.filter.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a filter with you"}],"jira.jira-issue-share.message-template.text.shared.results.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.text.shared.with.others":[{"type":0,"value":"Also shared with"}],"jira.jira-issue-test.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] test template "},{"type":1,"value":"issueKey"}],"jira.jira-issue-update.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-update.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-work-started.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"made "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" update"}]},"other":{"value":[{"type":7},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfUpdates"}],"type":8,"value":"strong"}],"jira.jira-issue-work-started.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" started by "},{"type":1,"value":"user"}],"jira.jira-issue-work-stopped.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" stopped by "},{"type":1,"value":"user"}],"jira.jira-issue-worklog-delete.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-deleted.message-template.text.email.body.deleted.worklog":[{"type":0,"value":"The following worklog was deleted:"}],"jira.jira-issue-worklog-update.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-update.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-updated.message-template.email.body.description":[{"type":0,"value":"Description"}],"jira.jira-issue-worklog-updated.message-template.email.body.timeLogged":[{"type":0,"value":"Time logged"}],"jira.jira-issue-worklogged.message-template.email.body.description":[{"type":0,"value":"Description: "}],"jira.jira-issue-worklogged.message-template.email.body.logTitle":[{"type":0,"value":"Work log"}],"jira.jira-issue-worklogged.message-template.email.body.timelogged":[{"type":0,"value":"Time logged: "}],"jira.jira-issue-worklogged.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"added 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklogged.message-template.email.body.updateTitle":[{"type":0,"value":"Updates"}],"jira.jira-issue-worklogged.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-worklogged.message-template.email.body.worklog.entry":[{"type":0,"value":"Worklog entry:"}],"jira.jira-issue-worklogged.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.body.common.change.by":[{"type":0,"value":"Change by"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.created.on":[{"type":0,"value":"Created on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.by":[{"type":0,"value":"Edited by:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.on":[{"type":0,"value":"Edited on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.key":[{"type":0,"value":"Key:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.worklog.entry.label":[{"type":0,"value":"Worklog entry"}],"jira.jira-issue-worklogged.message-template.text.body.common.project":[{"type":0,"value":"Project:"}],"jira.jira-issue-worklogged.message-template.text.body.common.start.date":[{"type":0,"value":"Start Date:"}],"jira.jira-issue-worklogged.message-template.text.body.common.time.spent":[{"type":0,"value":"Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.common.url":[{"type":0,"value":"URL:"}],"jira.jira-issue-worklogged.message-template.text.body.common.view.work.description":[{"type":0,"value":"View work description"}],"jira.jira-issue-worklogged.message-template.text.body.common.work.type":[{"type":0,"value":"Work type:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.body":[{"type":0,"value":"Work Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description":[{"type":0,"value":"Worklog Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description.was":[{"type":0,"value":"Worklog Description was:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.id":[{"type":0,"value":"Worklog Id:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.estimated":[{"type":0,"value":"Remaining Estimate:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.spent":[{"type":0,"value":"Worklog Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.redacted.logged.by":[{"type":1,"value":"worklogEntry"},{"type":0,"value":" logged by "},{"type":1,"value":"actioner"}],"jira.jira-issue-worklogged.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.email.body.tracking":[{"type":0,"value":"Issue time Tracking"}],"jira.jira-project-deletion-reminder.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"},{"type":0,"value":" "}],"jira.jira-project-event-archived-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from archive "}],"jira.jira-project-event-archived.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project archived"}],"jira.jira-project-event-delete-failed.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Could not permanently delete the project "}],"jira.jira-project-event-deleted-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from trash"}],"jira.jira-project-event-deleted.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project moved to trash"}],"jira.jira-project-event-user-invited.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"userName"},{"type":0,"value":") invited you to ("},{"type":1,"value":"projectName"},{"type":0,"value":")  "}],"jira.user.premium-plan.requested.email.explaination":[{"type":0,"value":"You can try Jira Premium for free with no commitment. This trial period includes access\\n\\t\\t\\t\\tto our advanced planning features plus other great functionalities that unlock new ways\\n\\t\\t\\t\\tof working for your teams."}],"jira.user.premium-plan.requested.email.greeting":[{"type":0,"value":"Hi,"}],"jira.user.premium-plan.requested.email.learn-more":[{"type":0,"value":"Learn more about Jira Premium."}],"jira.user.premium-plan.requested.email.start-trial":[{"type":0,"value":"Start your Jira Premium trial"}],"jira.user.premium-plan.requested.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium"}],"jira.user.premium-plan.requested.email.text":[{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium."}],"note.added.by.user":[{"type":1,"value":"userName"},{"type":0,"value":" added this note"}],"post-office.jira-pulsar.jira-issue-approval.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-archived.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-closed.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-generic.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-moved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-resolved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.placement.jira-top-banner.primary-message":[{"type":0,"value":"As we roll out \'work\' as the new term for items tracked in Jira, you may still see \'issue\' in some areas."}],"postoffice.jira.issue.common.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.common.reply-button":[{"type":0,"value":"Reply"}],"postoffice.jira.issue.common.visibility-level":[{"type":0,"value":"Restricted to "},{"children":[{"type":1,"value":"name"}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"type"}],"postoffice.jira.issue.metioned.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.share-search.shared-with.no-translate":[{"type":0,"value":"sharedWithUser"}],"postoffice.jira.issue.work.started.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.work.stopped.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.worklogged.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.project.event.avatar.no-translate":[{"type":0,"value":"avatar"}],"postoffice.jira.project.event.blueprint.no-translate":[{"type":0,"value":"blueprintLogo"}],"postoffice.jira.project.event.globe.no-translate":[{"type":0,"value":"globeLogo"}],"postoffice.jira.project.event.logo.no-translate":[{"type":0,"value":"logo"}],"postoffice.jira.project.event.write.no-translate":[{"type":0,"value":"writeLogo"}],"push.mobile.issue.approval.requested.description":[{"type":0,"value":"on "},{"type":1,"value":"summary"}],"push.mobile.issue.approval.requested.title":[{"type":0,"value":"Approval requested"}],"push.mobile.issue.assignment.description.assigned.others":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"assignee"}],"push.mobile.issue.assignment.description.assigned.you":[{"type":1,"value":"user"},{"type":0,"value":" assigned you to "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.others":[{"type":1,"value":"user"},{"type":0,"value":" unassigned "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" from "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.you":[{"type":1,"value":"user"},{"type":0,"value":" unassigned you from "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment to "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment"}],"push.mobile.issue.comment.added.android.description":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.added.ios.body.redacted":[{"type":0,"value":"commented on this work item"}],"push.mobile.issue.comment.added.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on this work item"}],"push.mobile.issue.create.android.description":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.create.android.title":[{"type":0,"value":"Work item Created"}],"push.mobile.issue.create.ios.body.redacted":[{"type":0,"value":"Open to view work item details"}],"push.mobile.issue.create.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.transition.description.resolved":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"summary"}],"push.mobile.issue.transition.description.resolved.redacted":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved this work item"}],"push.mobile.issue.transition.ios.description":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"push.mobile.issue.transition.ios.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"st-office.placement.jira-top-banner.primary-cta-text":[{"type":0,"value":"Read about this terminology change"}],"template..project-deletion-reminder.restore-link.multiple-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.restore-link.single-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.trash-link.multiple-project":[{"type":0,"value":" Trash"}],"template.project-deletion-reminder.generic-message.mutiple-projects":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" project"}]},"other":{"value":[{"type":7},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"projectCount"},{"type":0,"value":" will be permanently deleted in 7 days "}],"template.project-deletion-reminder.generic-message.single-project":[{"type":0,"value":"The project will be permanently deleted in 7 days "}],"template.project-deletion-reminder.view-more-projects-message":[{"type":0,"value":"+ "},{"type":1,"value":"remainingProjectCount"},{"type":0,"value":" other projects currently in "}],"template.project-event-user-invited.invited-message":[{"type":1,"value":"userName"},{"type":0,"value":"  invited you to "},{"children":[{"type":0,"value":" "},{"type":1,"value":"projectName"},{"type":0,"value":" "}],"type":8,"value":"b"}],"template.project.archived.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the project."}],"template.project.deleted.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the project."}],"template.project.event.project.archive.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from archive on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" archived this project on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template.generic.message":[{"type":0,"value":"This project and its issues, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" archive "}],"type":8,"value":"a"},{"type":0,"value":" forever"}],"template.project.event.project.deleted.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" moved this project to trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deleted.body.template.generic.message":[{"type":0,"value":"The project, including all its issues, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" trash "}],"type":8,"value":"a"},{"type":0,"value":" for 60 days after which it will be permanently deleted."}],"template.project.event.project.deleted.failure.body.template.generic.message":[{"type":0,"value":"It\'s probably a temporary problem. "},{"children":[{"type":0,"value":" Go to trash "}],"type":8,"value":"a"},{"type":0,"value":" and try again. If it persists, please contact support."}],"template.project.event.project.deleted.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deletion.failure.body.template":[{"type":0,"value":"We couldn\'t delete this project"}],"template.project.event.project.privacy.contactus.template":[{"type":0,"value":"Contact us"}],"template.project.event.project.privacy.copyright.template":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"template.project.event.project.privacy.location.template":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"template.project.event.project.privacy.policy.template":[{"type":0,"value":"Privacy policy"}],"template.project.event.project.privacy.policy.template.dot":[{"type":0,"value":"."}],"template.project.event.project.user.invited.collborate.message":[{"type":0,"value":"Collaborate, align, and deliver work, all in "},{"children":[{"type":0,"value":" one place "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.collect.message":[{"type":0,"value":"Collect and send work to other teams or stakeholders using "},{"children":[{"type":0,"value":" forms "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.join.link":[{"type":0,"value":"Join the Project"}],"template.project.event.project.user.invited.learn.more.message":[{"type":0,"value":"Learn more about Jira "}],"template.project.event.project.user.invited.use.jira.generic.message":[{"type":0,"value":"Use Jira to..."}],"template.project.event.project.user.invited.view.work.message":[{"type":0,"value":"View work your way using the "},{"children":[{"type":0,"value":" list, board, calendar "}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":" timeline "}],"type":8,"value":"b"},{"type":0,"value":" views"}],"template.subscription.filter.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.html.subset.issue-term-refresh":[{"type":0,"value":"Displaying "},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" matched work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" matched work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":". "}],"template.subscription.filter.html.view.filter.work-items":[{"type":0,"value":"View all of them"}],"template.subscription.filter.redacted.html.edit":[{"type":0,"value":"You may edit this subscription "},{"children":[{"type":0,"value":" here "}],"type":8,"value":"a"},{"type":0,"value":" "}],"template.subscription.filter.redacted.html.view.filter":[{"type":0,"value":"Details are hidden to protect sensitive data. "},{"children":[{"type":0,"value":" View the filter "}],"type":8,"value":"a"},{"type":0,"value":" in Jira"}],"template.subscription.filter.subcount.issue-term-refresh":[{"type":0,"value":"  ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"template.subscription.filter.text.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.text.subcount.issue-term-refresh":[{"type":0,"value":" ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"user.avatar.alt":[{"type":0,"value":"User avatar"}]}');

});

parcelRegister("iID65", function(module, exports) {

let $da0aa9f194815215$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $da0aa9f194815215$var$load("hRAqP").then(()=>parcelRequire('kD4O5'));

});

parcelRegister("jbTEY", function(module, exports) {

let $df8a3847ab48aa4a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $df8a3847ab48aa4a$var$load("6XFnD").then(()=>parcelRequire('8g71V'));

});

parcelRegister("g5fCb", function(module, exports) {

let $bb5939c3de6ef7ff$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bb5939c3de6ef7ff$var$load("9uTyl").then(()=>parcelRequire('fWEZ9'));

});

parcelRegister("azP87", function(module, exports) {

let $7b34d59c378106a6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7b34d59c378106a6$var$load("i3I67").then(()=>parcelRequire('lsbXr'));

});

parcelRegister("foiqs", function(module, exports) {

let $b34763da55f8ca19$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b34763da55f8ca19$var$load("4eUwy").then(()=>parcelRequire('gWqGK'));

});

parcelRegister("2jtEt", function(module, exports) {

let $1af45b55fac12b80$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1af45b55fac12b80$var$load("jYD3i").then(()=>parcelRequire('QheRk'));

});

parcelRegister("fbjyA", function(module, exports) {

let $b0d70dab185ab4a5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b0d70dab185ab4a5$var$load("ezl8m").then(()=>parcelRequire('fr8hS'));

});

parcelRegister("fFK9p", function(module, exports) {

let $b68e7beb8bd26a81$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b68e7beb8bd26a81$var$load("3ycyp").then(()=>parcelRequire('5ZL9h'));

});

parcelRegister("5vH1F", function(module, exports) {

let $40313907695ba858$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $40313907695ba858$var$load("4ohcI").then(()=>parcelRequire('gJIKo'));

});

parcelRegister("jSUUy", function(module, exports) {

let $e79f34d565b170e4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e79f34d565b170e4$var$load("b21OQ").then(()=>parcelRequire('kPgOo'));

});

parcelRegister("6iQB6", function(module, exports) {

let $496d394a2b29d0cf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $496d394a2b29d0cf$var$load("aynSB").then(()=>parcelRequire('g5emD'));

});

parcelRegister("7hiF0", function(module, exports) {

let $54c898799c00e3c1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $54c898799c00e3c1$var$load("dScwK").then(()=>parcelRequire('Sif8l'));

});

parcelRegister("6fEEs", function(module, exports) {

let $48d3ad59e32ee38c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $48d3ad59e32ee38c$var$load("hUanw").then(()=>parcelRequire('caUD4'));

});

parcelRegister("ktl6I", function(module, exports) {

let $ee76e3879bca5b49$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ee76e3879bca5b49$var$load("i82yy").then(()=>parcelRequire('9muA9'));

});

parcelRegister("7cMV5", function(module, exports) {

let $53ef99d9c83c3a03$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $53ef99d9c83c3a03$var$load("k4oEp").then(()=>parcelRequire('ampJ8'));

});

parcelRegister("h0s0u", function(module, exports) {

let $c6182954f05e39c9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c6182954f05e39c9$var$load("XE8J3").then(()=>parcelRequire('k8PFv'));

});

parcelRegister("8gcpy", function(module, exports) {

let $603971f7af985634$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $603971f7af985634$var$load("3KeH7").then(()=>parcelRequire('kjKLL'));

});

parcelRegister("3TyxK", function(module, exports) {

let $2d614db8300561a7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2d614db8300561a7$var$load("46Hmq").then(()=>parcelRequire('juUs9'));

});

parcelRegister("1SQyj", function(module, exports) {

let $15f3996a9457270f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $15f3996a9457270f$var$load("40C6Q").then(()=>parcelRequire('6T6f6'));

});

parcelRegister("bu2dH", function(module, exports) {

let $85c437e887e50624$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $85c437e887e50624$var$load("i4fjZ").then(()=>parcelRequire('6WtE4'));

});

parcelRegister("15chK", function(module, exports) {

let $0c9fc9a663e8a010$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0c9fc9a663e8a010$var$load("5FOKY").then(()=>parcelRequire('hz8Pp'));

});

parcelRegister("eiNXg", function(module, exports) {

let $a6997f25f33fa392$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a6997f25f33fa392$var$load("8gPkx").then(()=>parcelRequire('4NjvR'));

});

parcelRegister("69QyJ", function(module, exports) {

let $47bc5a852a9532d0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $47bc5a852a9532d0$var$load("dR2PL").then(()=>parcelRequire('89axY'));

});

parcelRegister("19wx1", function(module, exports) {

let $0d6fddcbaff37cb0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0d6fddcbaff37cb0$var$load("20ZGM").then(()=>parcelRequire('15WEP'));

});

parcelRegister("7FNO1", function(module, exports) {

let $5962ff1be5b97cc8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5962ff1be5b97cc8$var$load("goiHr").then(()=>parcelRequire('3FO5J'));

});

parcelRegister("42kgl", function(module, exports) {

let $2f071114c394bb81$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2f071114c394bb81$var$load("75jkn").then(()=>parcelRequire('kH1Cd'));

});

parcelRegister("9T7WM", function(module, exports) {

let $732f6a3e28dfc6bb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $732f6a3e28dfc6bb$var$load("kn527").then(()=>parcelRequire('6eoXv'));

});

parcelRegister("el2Jz", function(module, exports) {

let $a70525c0e150b15a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a70525c0e150b15a$var$load("3HKAc").then(()=>parcelRequire('blyO3'));

});

parcelRegister("9ahb6", function(module, exports) {

let $6ac25f7085e93e2a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6ac25f7085e93e2a$var$load("efNtD").then(()=>parcelRequire('a2gqT'));

});

parcelRegister("51xXu", function(module, exports) {

let $3a8763378652bc55$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3a8763378652bc55$var$load("5l4Gb").then(()=>parcelRequire('8uwgL'));

});

parcelRegister("1e0BM", function(module, exports) {

let $0e47920d3ef77edd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0e47920d3ef77edd$var$load("4IJwN").then(()=>parcelRequire('fZDTG'));

});

parcelRegister("j8T0v", function(module, exports) {

let $def96ef4e60613c8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $def96ef4e60613c8$var$load("jRcl2").then(()=>parcelRequire('el0Xc'));

});

parcelRegister("ddEeN", function(module, exports) {

let $99fbb3a128d6f040$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $99fbb3a128d6f040$var$load("e0Nbv").then(()=>parcelRequire('8E1jo'));

});

parcelRegister("87gNs", function(module, exports) {

let $5e8c01a1a4ab7aae$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5e8c01a1a4ab7aae$var$load("1tVNO").then(()=>parcelRequire('88FtU'));

});


parcelRegister("4GHII", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $7a77ca98c53d1b98$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $fzi7b = parcelRequire("fzi7b");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a77ca98c53d1b98$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $7a77ca98c53d1b98$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("es9os")));
        case 'da':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("g75ag")));
        case 'de':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("dnRhk")));
        case 'en-GB':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("6IvB6")));
        case 'en-US':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("gBqZv")));
        case 'en-XA':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("hnfsd")));
        case 'en-XB':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("4a4Zz")));
        case 'en-ZZ':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("eewXH")));
        case 'en':
            return $7a77ca98c53d1b98$var$importHelper(await Promise.resolve((parcelRequire("fzi7b"))));
        case 'es':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("8VY2T")));
        case 'et':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("gAnVo")));
        case 'fi':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("92dDc")));
        case 'fr':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("j2aS3")));
        case 'hr':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("f1RUA")));
        case 'hu':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("b8WPk")));
        case 'it':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("i8DdC")));
        case 'ja':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("1WuVU")));
        case 'ko':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("gIpGq")));
        case 'nb':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("3hug4")));
        case 'nl':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("3Qoes")));
        case 'pl':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("csRsS")));
        case 'pt-BR':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("46qkJ")));
        case 'ro':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("abMgg")));
        case 'ru':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("kZnjx")));
        case 'sl':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("lecCa")));
        case 'sr-RS':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("jqa7i")));
        case 'sr-YR':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("ehrol")));
        case 'sr':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("e4qm5")));
        case 'sv':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("8Hees")));
        case 'th':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("7gPgQ")));
        case 'tr':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("gZdIf")));
        case 'uk':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("jrE3d")));
        case 'vi':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("ShxUi")));
        case 'zh-CN':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("cmLRp")));
        case 'zh-TW':
            return $7a77ca98c53d1b98$var$importHelper(await (parcelRequire("e7e4D")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fzi7b));
    }
};

});
parcelRegister("fzi7b", function(module, exports) {
module.exports = JSON.parse("{\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.titleForIssueComment\":[{\"type\":0,\"value\":\"Record your screen\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.titleForIssueDescription\":[{\"type\":0,\"value\":\"Record your screen\"}],\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.message-template.microsoft-teams.hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");

});

parcelRegister("es9os", function(module, exports) {

let $a85af78a17122fb9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a85af78a17122fb9$var$load("jg1xY").then(()=>parcelRequire('flE1t'));

});

parcelRegister("g75ag", function(module, exports) {

let $bbb14e5b97c9305e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bbb14e5b97c9305e$var$load("ht06K").then(()=>parcelRequire('3bN1V'));

});

parcelRegister("dnRhk", function(module, exports) {

let $9be6c051573b84a8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9be6c051573b84a8$var$load("9MswH").then(()=>parcelRequire('TIzkx'));

});

parcelRegister("6IvB6", function(module, exports) {

let $4e3f5cc09f37989d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4e3f5cc09f37989d$var$load("gVUKe").then(()=>parcelRequire('4DFJ7'));

});

parcelRegister("gBqZv", function(module, exports) {

let $c16509eb288aba2a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c16509eb288aba2a$var$load("4T9OV").then(()=>parcelRequire('cxVB9'));

});

parcelRegister("hnfsd", function(module, exports) {

let $ca60927ebd7ba4e0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ca60927ebd7ba4e0$var$load("3pWBu").then(()=>parcelRequire('47tX7'));

});

parcelRegister("4a4Zz", function(module, exports) {

let $307bf7ed29c76784$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $307bf7ed29c76784$var$load("1cXxZ").then(()=>parcelRequire('jyOKS'));

});

parcelRegister("eewXH", function(module, exports) {

let $a5cbf1063452d89a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a5cbf1063452d89a$var$load("g8S6a").then(()=>parcelRequire('iRQwD'));

});

parcelRegister("8VY2T", function(module, exports) {

let $6812396860782295$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6812396860782295$var$load("4XRWH").then(()=>parcelRequire('bWMku'));

});

parcelRegister("gAnVo", function(module, exports) {

let $c1329114447c569b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c1329114447c569b$var$load("7tcNI").then(()=>parcelRequire('60ftt'));

});

parcelRegister("92dDc", function(module, exports) {

let $693edfd316b8a97c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $693edfd316b8a97c$var$load("kEYA6").then(()=>parcelRequire('3dc4C'));

});

parcelRegister("j2aS3", function(module, exports) {

let $ddb6a2f5557a1c03$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ddb6a2f5557a1c03$var$load("55r5F").then(()=>parcelRequire('5lDrq'));

});

parcelRegister("f1RUA", function(module, exports) {

let $af10c4c09dce024f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $af10c4c09dce024f$var$load("5V2YV").then(()=>parcelRequire('3suHD'));

});

parcelRegister("b8WPk", function(module, exports) {

let $0217f80bddb6b060$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0217f80bddb6b060$var$load("0ObRN").then(()=>parcelRequire('67aJm'));

});

parcelRegister("i8DdC", function(module, exports) {

let $d34765596e9cc041$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d34765596e9cc041$var$load("ethRp").then(()=>parcelRequire('eKpub'));

});

parcelRegister("1WuVU", function(module, exports) {

let $16a333da318ef41d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $16a333da318ef41d$var$load("enBNT").then(()=>parcelRequire('ktBzZ'));

});

parcelRegister("gIpGq", function(module, exports) {

let $c2b4ad94570443f7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c2b4ad94570443f7$var$load("hUjek").then(()=>parcelRequire('dXskC'));

});

parcelRegister("3hug4", function(module, exports) {

let $263a6e413f949a94$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $263a6e413f949a94$var$load("59Jz6").then(()=>parcelRequire('eHaR8'));

});

parcelRegister("3Qoes", function(module, exports) {

let $2cc9066fef6d1812$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2cc9066fef6d1812$var$load("8H0Nt").then(()=>parcelRequire('4EzFn'));

});

parcelRegister("csRsS", function(module, exports) {

let $91319289e9743fc8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $91319289e9743fc8$var$load("jRlJi").then(()=>parcelRequire('jDUy8'));

});

parcelRegister("46qkJ", function(module, exports) {

let $2fcc2634994aa48a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2fcc2634994aa48a$var$load("lmStR").then(()=>parcelRequire('flhHW'));

});

parcelRegister("abMgg", function(module, exports) {

let $76b05e238cfe92f2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $76b05e238cfe92f2$var$load("eSg4S").then(()=>parcelRequire('bLtYl'));

});

parcelRegister("kZnjx", function(module, exports) {

let $f47b96df6dd2acf1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f47b96df6dd2acf1$var$load("kJdgW").then(()=>parcelRequire('aDTYq'));

});

parcelRegister("lecCa", function(module, exports) {

let $f744b0c76602c884$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f744b0c76602c884$var$load("M7pwQ").then(()=>parcelRequire('3eGO1'));

});

parcelRegister("jqa7i", function(module, exports) {

let $e2384b01a8cb3553$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e2384b01a8cb3553$var$load("1aldJ").then(()=>parcelRequire('ivE07'));

});

parcelRegister("ehrol", function(module, exports) {

let $a657e6a3659fc248$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a657e6a3659fc248$var$load("cfx9a").then(()=>parcelRequire('ggOfM'));

});

parcelRegister("e4qm5", function(module, exports) {

let $a3e5e1fdbcf18da5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a3e5e1fdbcf18da5$var$load("csaMP").then(()=>parcelRequire('8ZwvJ'));

});

parcelRegister("8Hees", function(module, exports) {

let $654d611311e5a685$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $654d611311e5a685$var$load("811Ph").then(()=>parcelRequire('emNsB'));

});

parcelRegister("7gPgQ", function(module, exports) {

let $54b1cc4e0f40a64f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $54b1cc4e0f40a64f$var$load("9uzRe").then(()=>parcelRequire('85mpN'));

});

parcelRegister("gZdIf", function(module, exports) {

let $c5dcfae7db758ebb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c5dcfae7db758ebb$var$load("lpFtM").then(()=>parcelRequire('2Ym7p'));

});

parcelRegister("jrE3d", function(module, exports) {

let $e27f9b322664520e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e27f9b322664520e$var$load("daKXi").then(()=>parcelRequire('jlwBg'));

});

parcelRegister("ShxUi", function(module, exports) {

let $0a32a78214f4a31c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0a32a78214f4a31c$var$load("4Xz2b").then(()=>parcelRequire('aX3jW'));

});

parcelRegister("cmLRp", function(module, exports) {

let $900caa2b7fdcc65c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $900caa2b7fdcc65c$var$load("b3ypU").then(()=>parcelRequire('abC4K'));

});

parcelRegister("e7e4D", function(module, exports) {

let $a46ca2e8df073208$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a46ca2e8df073208$var$load("iuAzj").then(()=>parcelRequire('aVnTp'));

});




parcelRegister("1gHmu", function(module, exports) {

$parcel$export(module.exports, "PostOfficeProvider", () => $aa6d0b2a252623bf$export$fb465b6e855c1e85);
$parcel$export(module.exports, "PostOfficeRouterListener", () => $aa6d0b2a252623bf$export$9f8d3084fd3d5fc0);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $7jTnu = parcelRequire("7jTnu");

var $7oY9g = parcelRequire("7oY9g");

var $eWzpp = parcelRequire("eWzpp");

var $g9Vr6 = parcelRequire("g9Vr6");

var $4ihOZ = parcelRequire("4ihOZ");

var $8vyDv = parcelRequire("8vyDv");

var $kEUB1 = parcelRequire("kEUB1");

var $g1NZW = parcelRequire("g1NZW");

var $lUto7 = parcelRequire("lUto7");

var $2cfd4 = parcelRequire("2cfd4");

var $gCv1j = parcelRequire("gCv1j");
var $jCoJl = parcelRequire("jCoJl");

var $gCY1z = parcelRequire("gCY1z");

var $gZTP9 = parcelRequire("gZTP9");

var $dCq6B = parcelRequire("dCq6B");

var $goNRN = parcelRequire("goNRN");

var $42nVO = parcelRequire("42nVO");
const $aa6d0b2a252623bf$var$JiraPostOfficeProvider = ({ children: children })=>{
    const { data: data } = (0, $eWzpp.useProject)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const activationId = (0, $4ihOZ.useActivationId)();
    const locale = (0, $2cfd4.useLocale)();
    const environment = (0, $g1NZW.useEnvironment)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const editions = (0, $8vyDv.useAppEditions)();
    const subproduct = data?.type;
    const edition = (0, $dCq6B.subproductToEdition)(subproduct, editions);
    const additionalContext = (0, $eJOHy.useContext)((0, $goNRN.CrossFlowPostOfficeContext));
    const context = (0, $eJOHy.useMemo)(()=>{
        return {
            current: {
                ...(0, $dCq6B.tenantToPostOfficeContext)({
                    activationId: activationId,
                    cloudId: cloudId,
                    isAdmin: isAdmin,
                    isSiteAdmin: isSiteAdmin,
                    locale: locale
                }),
                orgId: orgId,
                productEdition: edition || undefined,
                subproduct: subproduct,
                ...(0, $7jTnu.fg)('jira_xflow_quick_actions') ? additionalContext : {},
                ...(0, $7jTnu.fg)('jira-onboarding-hub-gate') ? (0, $42nVO.getOnboardingParams)() : {}
            }
        };
    }, [
        cloudId,
        orgId,
        activationId,
        subproduct,
        isSiteAdmin,
        isAdmin,
        locale,
        edition,
        additionalContext
    ]);
    const env = (0, $eJOHy.useMemo)(()=>({
            env: (0, $dCq6B.transformJiraEnvToPostOfficeEnvironment)(environment)
        }), [
        environment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gCv1j.PostOfficeProvider), {
        context: context,
        environment: env
    }, children);
};
const $aa6d0b2a252623bf$export$fb465b6e855c1e85 = ({ children: children })=>{
    // Using the Feature Gate used for the placement app-switcher-discovery-section because PostOfficeProvider is always needed when the app-switcher-discovery-section is enabled
    const isPostOfficeEnabled = !(0, $7oY9g.default)('killswitch_post_office_in_jira');
    return isPostOfficeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "postOfficeJiraProvider",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa6d0b2a252623bf$var$JiraPostOfficeProvider, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $aa6d0b2a252623bf$var$ReactResourceRouterListener = ({ children: children })=>{
    const [route] = (0, $gCY1z.useRouter)();
    (0, $jCoJl.usePostOfficeRouteUpdate)([
        route.basePath,
        route.location.pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $aa6d0b2a252623bf$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
    const isPostOfficeEnabled = !(0, $7oY9g.default)('killswitch_post_office_in_jira');
    return isPostOfficeEnabled && (0, $7jTnu.fg)('post-office-screen-space-overlay-jfe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa6d0b2a252623bf$var$ReactResourceRouterListener, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};

});
parcelRegister("gCv1j", function(module, exports) {

$parcel$export(module.exports, "PostOfficeProvider", () => $af19596fe2502758$export$fb465b6e855c1e85);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5ZQPg = parcelRequire("5ZQPg");

var $8OhYX = parcelRequire("8OhYX");

var $jCoJl = parcelRequire("jCoJl");

var $jZBfv = parcelRequire("jZBfv");

var $iEZnr = parcelRequire("iEZnr");

var $gPxoe = parcelRequire("gPxoe");

var $gFu5h = parcelRequire("gFu5h");

var $9MbD1 = parcelRequire("9MbD1");
const $af19596fe2502758$export$fb465b6e855c1e85 = ({ environment: envWithOverrides, context: context, children: children })=>{
    const stableEnvironment = (0, $gPxoe.useStableObject)((0, $9MbD1.generateEnvironmentConfigWithOverrides)((0, $8OhYX.defaultEnvironmentValues), envWithOverrides));
    const stableContext = (0, $gPxoe.useStableObject)($af19596fe2502758$var$composeConfig((0, $5ZQPg.defaultPostOfficeContextValue), context.current));
    const memoizedMessagePlacementValues = (0, $eJOHy.useMemo)(()=>(0, $gFu5h.createMessagePlacementValues)(), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8OhYX.PostOfficeEnvironmentProvider), {
        value: stableEnvironment,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5ZQPg.InternalPostOfficeContextProvider), {
            value: stableContext,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jZBfv.PostOfficeScreenContextProvider), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gFu5h.MessagePlacementProvider), {
                    value: memoizedMessagePlacementValues,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jCoJl.RouteListenerProvider), {
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iEZnr.TriggerContextProvider), {
                            children: children
                        })
                    })
                })
            })
        })
    });
};
const $af19596fe2502758$var$composeConfig = (base, ...rest)=>rest.reduce((acc, v)=>{
        // Bring logic inline with lodash merge
        // Iterator (right) properties that resolve to undefined are skipped if an Accumulator (left) value already exists
        for(const key in v)if (typeof v[key] === 'undefined') delete v[key];
        return {
            ...acc,
            ...v
        };
    }, {
        ...base
    });

});
parcelRegister("jCoJl", function(module, exports) {

$parcel$export(module.exports, "usePostOfficeRouteUpdate", () => $75fe01e9a7e4e958$export$bb606326acdd1a64);
$parcel$export(module.exports, "RouteListenerProvider", () => $75fe01e9a7e4e958$export$31986273b686f5ea);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gcT3Q = parcelRequire("gcT3Q");

var $l2WwY = parcelRequire("l2WwY");
const $75fe01e9a7e4e958$var$noop = ()=>{};
const $75fe01e9a7e4e958$var$RouteListenerContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    update: $75fe01e9a7e4e958$var$noop
});
const $75fe01e9a7e4e958$export$7a2084f4baac29a7 = ()=>(0, $gcT3Q.createSimplePubSub)();
const $75fe01e9a7e4e958$export$72fd8977abf03d60 = ()=>(0, $eJOHy.useContext)($75fe01e9a7e4e958$var$RouteListenerContext);
const $75fe01e9a7e4e958$export$755edb1665399d41 = ()=>{
    const ref = (0, $eJOHy.useRef)();
    if (!ref.current) ref.current = $75fe01e9a7e4e958$export$7a2084f4baac29a7();
    const [routeSubscriber, updateRoute] = ref.current;
    const routeConfig = (0, $eJOHy.useMemo)(()=>({
            initialUrl: new URL(window.location.href),
            routeSubscriber: routeSubscriber
        }), [
        routeSubscriber
    ]);
    const routeUpdater = (0, $eJOHy.useMemo)(()=>({
            update: updateRoute
        }), [
        updateRoute
    ]);
    return [
        routeConfig,
        routeUpdater
    ];
};
const $75fe01e9a7e4e958$export$bb606326acdd1a64 = (deps)=>{
    const { update: update } = $75fe01e9a7e4e958$export$72fd8977abf03d60();
    (0, $eJOHy.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        update({
            next: new URL(window.location.href)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const $75fe01e9a7e4e958$export$31986273b686f5ea = ({ children: children })=>{
    const [route, routeUpdater] = $75fe01e9a7e4e958$export$755edb1665399d41();
    return /*#__PURE__*/ (0, $gt9Am.jsx)($75fe01e9a7e4e958$var$RouteListenerContext.Provider, {
        value: routeUpdater,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l2WwY.PostOfficeRouteProvider), {
            ...route,
            children: children
        })
    });
};

});
parcelRegister("gcT3Q", function(module, exports) {

$parcel$export(module.exports, "createSimplePubSub", () => $fe161fc5f2ca6387$export$92469b55607f005b);
const $fe161fc5f2ca6387$export$92469b55607f005b = ()=>{
    const subscribers = new Map();
    const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const publish = (payload)=>{
        subscribers.forEach((callback)=>callback(payload));
    };
    return [
        subscribe,
        publish
    ];
};

});


parcelRegister("iEZnr", function(module, exports) {

$parcel$export(module.exports, "TriggerContextProvider", () => $289a722448d5c012$export$e80a5720bb4c8fe3);
$parcel$export(module.exports, "useTrigger", () => $289a722448d5c012$export$3b196fe93a948c18);
$parcel$export(module.exports, "useFirePostOfficeTrigger", () => $289a722448d5c012$export$83b33e5fe4cce64);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $289a722448d5c012$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $289a722448d5c012$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $289a722448d5c012$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($289a722448d5c012$var$initialActiveTriggerState);
const $289a722448d5c012$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($289a722448d5c012$var$initialTriggerDispatchState);
const $289a722448d5c012$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $eJOHy.useState)($289a722448d5c012$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $eJOHy.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $eJOHy.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $eJOHy.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($289a722448d5c012$var$TriggerContext.Provider, {
        value: triggerContextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($289a722448d5c012$var$TriggerDispatchContext.Provider, {
            value: triggerContexDispatchValue,
            children: children
        })
    });
};
const $289a722448d5c012$export$454c1d7c35958f5e = ()=>(0, $eJOHy.useContext)($289a722448d5c012$var$TriggerContext);
const $289a722448d5c012$export$23cbf084e08bdb93 = ()=>(0, $eJOHy.useContext)($289a722448d5c012$var$TriggerDispatchContext);
const $289a722448d5c012$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $289a722448d5c012$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $289a722448d5c012$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $289a722448d5c012$export$23cbf084e08bdb93();
    const fireTrigger = (0, $eJOHy.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};

});

parcelRegister("9MbD1", function(module, exports) {

$parcel$export(module.exports, "generateEnvironmentConfigWithOverrides", () => $9f90e93985f6f19f$export$ae3dab16eb1fc2cc);
const $9f90e93985f6f19f$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
    const { env: env, overrides: overrides } = environmentWithOverrides;
    return {
        currentEnv: env,
        envConfigs: {
            ...defaultEnvironmentValues.envConfigs,
            [env]: {
                remoteModule: {
                    origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                    pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                    searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                },
                api: {
                    origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                    pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                    searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                }
            }
        }
    };
};

});


parcelRegister("goNRN", function(module, exports) {

$parcel$export(module.exports, "CrossFlowPostOfficeContext", () => $203de4cdbe788221$export$2e4aec418d6136f);
$parcel$export(module.exports, "CrossFlowPostOfficeProvider", () => $203de4cdbe788221$export$de3f510d70d6c70c);

var $eJOHy = parcelRequire("eJOHy");

var $gZTP9 = parcelRequire("gZTP9");

var $bEiQD = parcelRequire("bEiQD");

var $5EgB1 = parcelRequire("5EgB1");

var $dyOHn = parcelRequire("dyOHn");

var $6d9QY = parcelRequire("6d9QY");

var $b9nqM = parcelRequire("b9nqM");

var $k3AHU = parcelRequire("k3AHU");

var $lUto7 = parcelRequire("lUto7");

var $lXMdI = parcelRequire("lXMdI");
const $203de4cdbe788221$export$2e4aec418d6136f = /*#__PURE__*/ (0, $eJOHy.createContext)({
    loomTouchpointVariant: null,
    isAdmin: null,
    isOrgAdmin: null,
    hasActiveJpdLicense: null,
    tenantHasConfluence: null,
    canProvisionConfluenceEndUser: null,
    areProductSuggestionsEnabled: null,
    isAiEligibleAndTriggered: null
});
const $203de4cdbe788221$export$de3f510d70d6c70c = ({ children: children, loomTouchpointVariant: loomTouchpointVariant, isAiEligibleAndTriggered: isAiEligibleAndTriggered })=>{
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const tenantHasConfluence = licensedProducts?.confluence === true;
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const { canProvisionConfluenceEndUser: canProvisionConfluenceEndUser } = (0, $k3AHU.useUserHasAddProductPermissions)({
        skip: isSiteAdmin || tenantHasConfluence
    });
    const areProductSuggestionsEnabled = (0, $lXMdI.useAreProductSuggestionsEnabled)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const hasActiveJpdLicense = (0, $dyOHn.useSelector)((0, $5EgB1.tenantHasActiveProductDiscoveryLicenseSelector));
    // isOrgAdmin is fetched from an api call and the initial value of loading is false
    // so it changes from false to true and then back to false
    // we need to wait for the loading to be true and then false again before we can render the children
    // this is to avoid re render of post office placement
    // to achieve this, we use usePrevious hook to check the previous value of isOrgAdminLoading
    // and only render the children when the previous value is true and the current value is false
    const { isOrgAdmin: isOrgAdmin, loading: isOrgAdminLoading } = (0, $bEiQD.useIsOrgAdmin)();
    const previousIsOrgAdminLoading = (0, $6d9QY.usePreviousPersistent)(isOrgAdminLoading);
    const context = (0, $eJOHy.useMemo)(()=>{
        return {
            loomTouchpointVariant: loomTouchpointVariant,
            isAdmin: isAdmin,
            isOrgAdmin: isOrgAdmin,
            hasActiveJpdLicense: hasActiveJpdLicense,
            tenantHasConfluence: tenantHasConfluence,
            canProvisionConfluenceEndUser: canProvisionConfluenceEndUser,
            areProductSuggestionsEnabled: areProductSuggestionsEnabled,
            isAiEligibleAndTriggered: !!isAiEligibleAndTriggered
        };
    }, [
        loomTouchpointVariant,
        isAdmin,
        isOrgAdmin,
        hasActiveJpdLicense,
        tenantHasConfluence,
        canProvisionConfluenceEndUser,
        areProductSuggestionsEnabled,
        isAiEligibleAndTriggered
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($203de4cdbe788221$export$2e4aec418d6136f.Provider, {
        value: context
    }, previousIsOrgAdminLoading && !isOrgAdminLoading && children);
};

});
parcelRegister("5EgB1", function(module, exports) {

$parcel$export(module.exports, "contextSelector", () => $8996f8462702b38d$export$c420c9f40402ab6d);
$parcel$export(module.exports, "accountIdloggedInUserSelector", () => $8996f8462702b38d$export$cb29341089829e17);
$parcel$export(module.exports, "orgIdSelector", () => $8996f8462702b38d$export$24984a39db14d8);
$parcel$export(module.exports, "loginRedirectUrlSelector", () => $8996f8462702b38d$export$767583fcce1653ec);
$parcel$export(module.exports, "issueKeySelector", () => $8996f8462702b38d$export$d22bc6271070f453);
$parcel$export(module.exports, "issueIdSelector", () => $8996f8462702b38d$export$31efbca30077ec1e);
$parcel$export(module.exports, "projectKeySelector", () => $8996f8462702b38d$export$404de5ac601b84bc);
$parcel$export(module.exports, "analyticsSourceSelector", () => $8996f8462702b38d$export$85a9d212d56669b4);
$parcel$export(module.exports, "cloudIdSelector", () => $8996f8462702b38d$export$b5a643cfff945455);
$parcel$export(module.exports, "issueAriSelector", () => $8996f8462702b38d$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "commentAriSelector", () => $8996f8462702b38d$export$b600fd41c88f35c8);
$parcel$export(module.exports, "isAnonymousSelector", () => $8996f8462702b38d$export$a165ec261432d0b8);
$parcel$export(module.exports, "localeSelector", () => $8996f8462702b38d$export$f7b7935883444b11);
$parcel$export(module.exports, "issueActionsSelector", () => $8996f8462702b38d$export$b62cb5286b153905);
$parcel$export(module.exports, "applicationKeySelector", () => $8996f8462702b38d$export$6c7d07328f197de7);
$parcel$export(module.exports, "isMobileSelector", () => $8996f8462702b38d$export$4cbb8c74e98876a5);
$parcel$export(module.exports, "isBitbucketSelector", () => $8996f8462702b38d$export$245e5ba54167b84a);
$parcel$export(module.exports, "isServiceDeskSelector", () => $8996f8462702b38d$export$43d733e4b7e8c7d0);
$parcel$export(module.exports, "isEcosystemEnabledSelector", () => $8996f8462702b38d$export$9bffc1987c753bd9);
$parcel$export(module.exports, "rapidViewIdSelector", () => $8996f8462702b38d$export$718e830000b27a0e);
$parcel$export(module.exports, "boardTypeSelector", () => $8996f8462702b38d$export$5af08fd769c0f0);
$parcel$export(module.exports, "boardIdSelector", () => $8996f8462702b38d$export$955e7dbf76b61f80);
$parcel$export(module.exports, "siteAdminStatusSelector", () => $8996f8462702b38d$export$93badd2a066af8bd);
$parcel$export(module.exports, "appPermissionsSelector", () => $8996f8462702b38d$export$5b71e1eb43056b6c);
$parcel$export(module.exports, "isModalSelector", () => $8996f8462702b38d$export$5fa593caa6a15917);
$parcel$export(module.exports, "shouldRenderHeaderSelector", () => $8996f8462702b38d$export$631793d49dec78de);
$parcel$export(module.exports, "viewModeSelector", () => $8996f8462702b38d$export$1f11fe78e4f22d45);
$parcel$export(module.exports, "appEditionsSelector", () => $8996f8462702b38d$export$28ca74e18c8f4529);
$parcel$export(module.exports, "tenantHasActiveServiceDeskLicenseSelector", () => $8996f8462702b38d$export$96c87532aec3474a);
$parcel$export(module.exports, "tenantHasActiveProductDiscoveryLicenseSelector", () => $8996f8462702b38d$export$f049ad7141428191);
$parcel$export(module.exports, "hasActivatedConfluenceWithinFourteenDaysSelector", () => $8996f8462702b38d$export$2b8e6729c89e24f5);
$parcel$export(module.exports, "hasActivatedConfluenceWithinSixtythreeDaysSelector", () => $8996f8462702b38d$export$a7671b4425572dc1);
$parcel$export(module.exports, "hasActivatedConfluenceWithinThirtyDaysSelector", () => $8996f8462702b38d$export$2321d15582b8ce8a);

var $ahm5r = parcelRequire("ahm5r");

var $1xngw = parcelRequire("1xngw");
var $lR3AG = parcelRequire("lR3AG");
var $kQ82p = parcelRequire("kQ82p");
var $2InI0 = parcelRequire("2InI0");
var $iux1t = parcelRequire("iux1t");


var $aYncF = parcelRequire("aYncF");

var $dNyY6 = parcelRequire("dNyY6");

var $8oOr4 = parcelRequire("8oOr4");

var $ljej9 = parcelRequire("ljej9");

var $hmtVp = parcelRequire("hmtVp");

var $8oKDI = parcelRequire("8oKDI");
const $8996f8462702b38d$export$c420c9f40402ab6d = (state)=>state.context;
const $8996f8462702b38d$export$cb29341089829e17 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.atlassianAccountId);
const $8996f8462702b38d$export$24984a39db14d8 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context?.orgId || null);
const $8996f8462702b38d$export$767583fcce1653ec = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.loginRedirectUrl);
const $8996f8462702b38d$export$d22bc6271070f453 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>(0, $ljej9.toIssueKey)(context.issueKey));
const $8996f8462702b38d$export$31efbca30077ec1e = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.issueId);
const $8996f8462702b38d$export$404de5ac601b84bc = (0, $ahm5r.createSelector)($8996f8462702b38d$export$d22bc6271070f453, (issueKey)=>(0, $dNyY6.extractProjectKey)(issueKey));
const $8996f8462702b38d$export$85a9d212d56669b4 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.analyticsSource !== undefined ? context.analyticsSource : undefined);
const $8996f8462702b38d$export$b5a643cfff945455 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.cloudId || (0, $ljej9.toCloudId)(''));
const $8996f8462702b38d$export$a2cdbba2136e72d3 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$b5a643cfff945455, $8996f8462702b38d$export$31efbca30077ec1e, (cloudId, issueId)=>(0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    }));
const $8996f8462702b38d$export$b600fd41c88f35c8 = (commentId)=>(0, $ahm5r.createSelector)($8996f8462702b38d$export$b5a643cfff945455, $8996f8462702b38d$export$31efbca30077ec1e, (cloudId, issueId)=>`ari:cloud:jira:${cloudId}:issue-comment/${issueId ?? ''}/${commentId}`);
const $8996f8462702b38d$export$2335b963a9875096 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.activationId || (0, $ljej9.toActivationId)(''));
const $8996f8462702b38d$export$a165ec261432d0b8 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.isAnonymous);
const $8996f8462702b38d$export$f7b7935883444b11 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.locale);
const $8996f8462702b38d$export$b62cb5286b153905 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.issueActions || []);
const $8996f8462702b38d$export$6c7d07328f197de7 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.applicationKey);
const $8996f8462702b38d$export$4cbb8c74e98876a5 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$8996f8462702b38d$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $d851676a1c983028$export$ce88447986394f2d));
const $8996f8462702b38d$export$6fbe1dbaf5b67cc5 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $8oOr4.simpleSoftwareBoardConfiguration)().applicationKey || applicationKey === (0, $8oOr4.standardRoadmapConfiguration)().applicationKey);
const $8996f8462702b38d$export$7479ef2453efd3b4 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $8oOr4.softwareConfiguration)().applicationKey);
const $8996f8462702b38d$export$245e5ba54167b84a = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$8996f8462702b38d$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $d851676a1c983028$export$7552fe2669628499));
const $8996f8462702b38d$export$43d733e4b7e8c7d0 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $8oOr4.serviceDeskConfiguration)().applicationKey);
const $8996f8462702b38d$export$9bffc1987c753bd9 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>!!context.ecosystemEnabled);
const $8996f8462702b38d$export$718e830000b27a0e = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.rapidViewId);
const $8996f8462702b38d$export$8065de5fbcf23af5 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.estimationStatistic || null);
const $8996f8462702b38d$export$5af08fd769c0f0 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.boardType);
const $8996f8462702b38d$export$955e7dbf76b61f80 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.boardId);
const $8996f8462702b38d$export$93badd2a066af8bd = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.siteAdminStatus);
const $8996f8462702b38d$export$b468116a08f9183e = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.productCrossSellConfig);
const $8996f8462702b38d$export$f29192b357e6beca = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.licensedProducts);
const $8996f8462702b38d$export$5b71e1eb43056b6c = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.appPermissions);
const $8996f8462702b38d$export$5fa593caa6a15917 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.isModal);
const $8996f8462702b38d$export$631793d49dec78de = (0, $ahm5r.createSelector)($8996f8462702b38d$export$5fa593caa6a15917, $8996f8462702b38d$export$4cbb8c74e98876a5, (isModal, isMobile)=>!isModal && !isMobile);
const $8996f8462702b38d$export$1f11fe78e4f22d45 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.viewMode);
const $8996f8462702b38d$export$28ca74e18c8f4529 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.appEditions);
const $8996f8462702b38d$export$beea798086c18f0a = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.licenseStates);
const $8996f8462702b38d$export$40487a15195e570e = (0, $ahm5r.createSelector)($8996f8462702b38d$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.serviceDesk === (0, $hmtVp.LICENSE_STATE_ACTIVE));
const $8996f8462702b38d$export$96c87532aec3474a = (0, $ahm5r.createSelector)($8996f8462702b38d$export$f29192b357e6beca, $8996f8462702b38d$export$40487a15195e570e, (licensedProducts, isServiceDeskLicenseActive)=>licensedProducts && licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).JIRA_SERVICEDESK] && isServiceDeskLicenseActive);
const $8996f8462702b38d$export$2fa17c0746682b0b = (0, $ahm5r.createSelector)($8996f8462702b38d$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.productDiscovery === (0, $hmtVp.LICENSE_STATE_ACTIVE));
const $8996f8462702b38d$export$f049ad7141428191 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$f29192b357e6beca, $8996f8462702b38d$export$2fa17c0746682b0b, (licensedProducts, isProductDiscoveryLicenseActive)=>Boolean(licensedProducts && licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).JIRA_PRODUCT_DISCOVERY] && isProductDiscoveryLicenseActive));
const $8996f8462702b38d$export$747a61878b414bda = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.confluenceActivationDate);
const $8996f8462702b38d$export$2b8e6729c89e24f5 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $1xngw.default)(new Date());
        const fourteenDaysAgo = (0, $2InI0.default)((0, $iux1t.default)(today, 14));
        const dateToCheck = (0, $kQ82p.default)(confluenceActivationDate);
        return (0, $lR3AG.default)(dateToCheck, {
            start: fourteenDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
});
const $8996f8462702b38d$export$a7671b4425572dc1 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$747a61878b414bda, (confluenceActivationDate)=>{
    if (!confluenceActivationDate) return false;
    const today = (0, $1xngw.default)(new Date());
    const sixtythreeDaysAgo = (0, $2InI0.default)((0, $iux1t.default)(today, 63));
    const dateToCheck = (0, $kQ82p.default)(confluenceActivationDate);
    return (0, $lR3AG.default)(dateToCheck, {
        start: sixtythreeDaysAgo,
        end: today
    });
});
const $8996f8462702b38d$export$2321d15582b8ce8a = (0, $ahm5r.createSelector)($8996f8462702b38d$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $1xngw.default)(new Date());
        const thirtyDaysAgo = (0, $2InI0.default)((0, $iux1t.default)(today, 31)); // 31 days to account for the 30 day trial
        const dateToCheck = (0, $kQ82p.default)(confluenceActivationDate);
        return (0, $lR3AG.default)(dateToCheck, {
            start: thirtyDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
});

});
parcelRegister("8oOr4", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $78be9cd6dc1a4416$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $78be9cd6dc1a4416$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $78be9cd6dc1a4416$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $78be9cd6dc1a4416$export$289917d9a7031e1d);
$parcel$export(module.exports, "SECURITY", () => $78be9cd6dc1a4416$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ASSIGNEE", () => $78be9cd6dc1a4416$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $78be9cd6dc1a4416$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $78be9cd6dc1a4416$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $78be9cd6dc1a4416$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $78be9cd6dc1a4416$export$79b91d4669dcadcb);
$parcel$export(module.exports, "EPIC", () => $78be9cd6dc1a4416$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $78be9cd6dc1a4416$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $78be9cd6dc1a4416$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $78be9cd6dc1a4416$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $78be9cd6dc1a4416$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $78be9cd6dc1a4416$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $78be9cd6dc1a4416$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $78be9cd6dc1a4416$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SUMMARY", () => $78be9cd6dc1a4416$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $78be9cd6dc1a4416$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $78be9cd6dc1a4416$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $78be9cd6dc1a4416$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $78be9cd6dc1a4416$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $78be9cd6dc1a4416$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $78be9cd6dc1a4416$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $78be9cd6dc1a4416$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $78be9cd6dc1a4416$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $78be9cd6dc1a4416$export$aba22e09a66f6826);
$parcel$export(module.exports, "SELECT_CUSTOM_FIELD_TYPE", () => $78be9cd6dc1a4416$export$826d657005bbe54c);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $78be9cd6dc1a4416$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $78be9cd6dc1a4416$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $78be9cd6dc1a4416$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $78be9cd6dc1a4416$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $78be9cd6dc1a4416$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $78be9cd6dc1a4416$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $78be9cd6dc1a4416$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $78be9cd6dc1a4416$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $78be9cd6dc1a4416$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $78be9cd6dc1a4416$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $78be9cd6dc1a4416$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $78be9cd6dc1a4416$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $78be9cd6dc1a4416$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $78be9cd6dc1a4416$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $78be9cd6dc1a4416$export$902f6c5cc939598a);

var $kkiRT = parcelRequire("kkiRT");

var $ln6Iy = parcelRequire("ln6Iy");

var $814y1 = parcelRequire("814y1");
const $78be9cd6dc1a4416$export$ebb48b08205007c5 = 'issuetype';
const $78be9cd6dc1a4416$export$a464614f8f5fe986 = 'summary';
const $78be9cd6dc1a4416$export$a311a3c9b207604e = 'parent';
const $78be9cd6dc1a4416$export$2a4f270075a033de = 'parent-issue';
const $78be9cd6dc1a4416$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $78be9cd6dc1a4416$export$289917d9a7031e1d = 'watches';
const $78be9cd6dc1a4416$export$81614f6dc3be5b00 = 'votes';
const $78be9cd6dc1a4416$export$72a5630aa398d6b4 = 'security';
const $78be9cd6dc1a4416$export$caf1ff54fbdf44bf = 'issuerestriction';
const $78be9cd6dc1a4416$export$f8f7545d2bb78afb = 'assignee';
const $78be9cd6dc1a4416$export$6d7021166edc895c = 'reporter';
const $78be9cd6dc1a4416$export$cf7e173386d30cdd = 'duedate';
const $78be9cd6dc1a4416$export$bb34f3538ba26c7e = 'priority';
const $78be9cd6dc1a4416$export$79b91d4669dcadcb = 'labels';
const $78be9cd6dc1a4416$export$cbedbfe2cd0caec7 = 'components';
const $78be9cd6dc1a4416$export$950d47e775e208ee = 'devSummary';
const $78be9cd6dc1a4416$export$f91d2bb4cc99fa5e = 'releases';
const $78be9cd6dc1a4416$export$a316570a0dbfd2b0 = 'sprint';
const $78be9cd6dc1a4416$export$405b6d72f2d243a9 = 'storyPointsField';
const $78be9cd6dc1a4416$export$3cb4a99a332e4186 = 'epic';
const $78be9cd6dc1a4416$export$d7e18f5730074533 = 'fixVersions';
const $78be9cd6dc1a4416$export$c435f0000304e508 = 'versions';
const $78be9cd6dc1a4416$export$ee99ef6ee562a446 = 'timetracking';
const $78be9cd6dc1a4416$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $78be9cd6dc1a4416$export$e50006273435e7d4 = 'status';
const $78be9cd6dc1a4416$export$f1a6ce22cbb7eb32 = 'resolution';
const $78be9cd6dc1a4416$export$ff39ebd4bb12b718 = 'created';
const $78be9cd6dc1a4416$export$cd8e68094cb5c3cb = 'updated';
const $78be9cd6dc1a4416$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $78be9cd6dc1a4416$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $78be9cd6dc1a4416$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $78be9cd6dc1a4416$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $78be9cd6dc1a4416$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $78be9cd6dc1a4416$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $78be9cd6dc1a4416$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $78be9cd6dc1a4416$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $78be9cd6dc1a4416$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $78be9cd6dc1a4416$export$913055729e1380b2 = 'summary';
const $78be9cd6dc1a4416$export$d44826c816b5619b = 'description';
const $78be9cd6dc1a4416$export$a29989082612d0d9 = 'comment';
const $78be9cd6dc1a4416$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $78be9cd6dc1a4416$export$3b3d0889022c85b3 = 'children-issues';
const $78be9cd6dc1a4416$export$be46596bc6608f3b = 'environment';
const $78be9cd6dc1a4416$export$f528fadbfdb3c25e = 'subtasks';
const $78be9cd6dc1a4416$export$f10e53e8928b61bd = 'dataclassification';
const $78be9cd6dc1a4416$export$e0dfb65d1047c53c = (0, $814y1.PARENT_CF_TYPE);
const $78be9cd6dc1a4416$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $78be9cd6dc1a4416$export$826d657005bbe54c = (0, $814y1.SELECT_CF_TYPE);
const $78be9cd6dc1a4416$export$cdbd1eb3b05729e0 = 'flagActions';
const $78be9cd6dc1a4416$export$c161a774ec2e7e56 = 'cardCoverActions';
const $78be9cd6dc1a4416$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$78be9cd6dc1a4416$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$78be9cd6dc1a4416$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$78be9cd6dc1a4416$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $814y1.TEAM_CF_TYPE)]: (0, $814y1.TEAM_CF_TYPE),
        [(0, $814y1.PARENT_CF_TYPE)]: (0, $814y1.PARENT_CF_TYPE),
        [(0, $814y1.BASELINE_START_CF_TYPE)]: (0, $814y1.BASELINE_START_CF_TYPE),
        [(0, $814y1.BASELINE_END_CF_TYPE)]: (0, $814y1.BASELINE_END_CF_TYPE),
        [(0, $814y1.COLOR_CF_TYPE)]: (0, $814y1.COLOR_CF_TYPE),
        [(0, $814y1.EPIC_COLOR_TYPE)]: (0, $814y1.EPIC_COLOR_TYPE),
        [(0, $814y1.EPIC_NAME_TYPE)]: (0, $814y1.EPIC_NAME_TYPE)
    };
    return fields;
};
const $78be9cd6dc1a4416$export$87934b3672715c91 = [
    (0, $814y1.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $814y1.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $814y1.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $814y1.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $78be9cd6dc1a4416$var$serviceDeskCustomFields = [
    (0, $814y1.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $814y1.ORGANIZATIONS_CF_TYPE),
    (0, $814y1.REQUEST_LANGUAGE_CF_TYPE),
    (0, $814y1.REQUEST_FEEDBACK_CF_TYPE),
    (0, $814y1.APPROVALS_CF_TYPE),
    (0, $814y1.APPROVERS_LIST_CF_TYPE),
    (0, $814y1.REQUEST_TYPE_CF_TYPE),
    (0, $814y1.CMDB_OBJECT_CF_TYPE),
    (0, $814y1.RESPONDERS_CF_TYPE),
    (0, $814y1.MAJOR_INCIDENT_CF_TYPE),
    (0, $814y1.ENTITLEMENT_CF_TYPE),
    (0, $814y1.SENTIMENT_CF_TYPE),
    (0, $814y1.ORGANIZATION_CF_TYPE)
];
const $78be9cd6dc1a4416$export$efd443bccc4c01ed = ()=>[
        (0, $814y1.LABELS_CF_TYPE),
        (0, $814y1.TEXT_CF_TYPE),
        (0, $814y1.MULTI_USER_CF_TYPE),
        (0, $814y1.PARTICIPANTS_CF_TYPE),
        (0, $814y1.URL_CF_TYPE),
        (0, $814y1.NUMBER_CF_TYPE),
        (0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $814y1.SELECT_CF_TYPE),
        (0, $814y1.MULTI_SELECT_CF_TYPE),
        (0, $814y1.VERSION_CF_TYPE),
        (0, $814y1.TEXT_AREA_CF_TYPE),
        (0, $814y1.MULTI_VERSION_CF_TYPE),
        (0, $814y1.DATE_CF_TYPE),
        (0, $814y1.GROUP_CF_TYPE),
        (0, $814y1.MULTI_GROUP_CF_TYPE),
        (0, $814y1.USER_CF_TYPE),
        (0, $814y1.MULTI_CHECKBOXES_CF_TYPE),
        (0, $814y1.RADIO_BUTTONS_CF_TYPE),
        (0, $814y1.DATETIME_CF_TYPE),
        (0, $814y1.ASSETS_CF_TYPE),
        (0, $814y1.SERVICE_ENTITY_CF_TYPE),
        (0, $814y1.PEOPLE_CF_TYPE),
        (0, $814y1.CASCADING_SELECT_CF_TYPE),
        (0, $814y1.PROJECT_PICKER_CF_TYPE),
        (0, $814y1.TEAMS_PLATFORM_CF_TYPE),
        (0, $814y1.READ_ONLY_CF_TYPE),
        (0, $814y1.EPIC_STATUS_TYPE),
        (0, $814y1.MESSAGE_VIEW_CF_TYPE),
        (0, $814y1.MESSAGE_EDIT_CF_TYPE),
        (0, $814y1.CATEGORY_TYPE),
        (0, $814y1.GOALS_CF_TYPE),
        ...$78be9cd6dc1a4416$export$87934b3672715c91,
        ...$78be9cd6dc1a4416$var$serviceDeskCustomFields
    ];
const $78be9cd6dc1a4416$export$a18b3a656ee9c709 = {
    [(0, $ln6Iy.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $ln6Iy.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $ln6Iy.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $78be9cd6dc1a4416$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $78be9cd6dc1a4416$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $kkiRT.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $kkiRT.default).SOFTWARE_ISSUE,
        issueActions: [
            $78be9cd6dc1a4416$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $kkiRT.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $78be9cd6dc1a4416$export$cdbd1eb3b05729e0,
            $78be9cd6dc1a4416$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $kkiRT.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $78be9cd6dc1a4416$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $kkiRT.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $78be9cd6dc1a4416$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $kkiRT.default).MOBILE_ISSUE,
        issueActions: []
    });
const $78be9cd6dc1a4416$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $kkiRT.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $kkiRT.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            if (config.isSimplified) return $78be9cd6dc1a4416$export$aebf676dfa727a1c();
            return $78be9cd6dc1a4416$export$27e0678365e5dcff();
        case 0, $ln6Iy.CORE_PROJECT:
            return $78be9cd6dc1a4416$export$381ce08838c53afa();
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return $78be9cd6dc1a4416$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $78be9cd6dc1a4416$export$27e0678365e5dcff();
    }
    return $78be9cd6dc1a4416$export$27e0678365e5dcff();
};

});


parcelRegister("k3AHU", function(module, exports) {

$parcel$export(module.exports, "useUserHasAddProductPermissions", () => $111926defb1457f6$export$d223ceb381c5cc91);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $kEUB1 = parcelRequire("kEUB1");

var $9HmCl = parcelRequire("9HmCl");


var $dnU6V = parcelRequire("dnU6V");

var $7jTnu = parcelRequire("7jTnu");

var $8vyDv = parcelRequire("8vyDv");

var $a9ldn = parcelRequire("a9ldn");

var $k6kDZ = parcelRequire("k6kDZ");
const $111926defb1457f6$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY = 'confluence-add-product-permission';
const $111926defb1457f6$export$8e35886de8a54f45 = ()=>{
    const localStorageProvider = (0, $dnU6V.createLocalExpirableStorageProvider)('placeholderTemplateAddProductPermissionStorage');
    const getLocalStorage = ()=>localStorageProvider.get($111926defb1457f6$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY);
    const LOCAL_STORAGE_EXPIRY_MS = 86400000; // one day
    const setLocalStorage = (value)=>localStorageProvider.set($111926defb1457f6$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY, value, Date.now() + LOCAL_STORAGE_EXPIRY_MS);
    return {
        getLocalStorage: getLocalStorage,
        setLocalStorage: setLocalStorage
    };
};
const $111926defb1457f6$export$d223ceb381c5cc91 = ({ skip: skip = false })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const appEditions = (0, $8vyDv.useAppEditions)();
    const productEntitlementDetails = (0, $9HmCl.useProductEntitlementDetails)();
    const isBillingSystemCcp = productEntitlementDetails?.[0, $e08dff4ae358d899$export$1346c9aa3cbb477d]?.billingSourceSystem === 'CCP';
    const { getLocalStorage: getLocalStorage, setLocalStorage: setLocalStorage } = (0, $eJOHy.useMemo)(()=>$111926defb1457f6$export$8e35886de8a54f45(), []);
    const cachedStatus = getLocalStorage();
    const initialStatus = cachedStatus || {
        canProvisionConfluenceEndUser: false,
        fetchStatus: 'pending'
    };
    const [status, setStatus] = (0, $eJOHy.useState)(initialStatus);
    const handleFetchPermissions = (0, $eJOHy.useCallback)(async ()=>{
        try {
            let newStatus;
            if ((0, $7jTnu.fg)('end_user_activate_eligibility_check')) {
                const endUserResponse = await (0, $k6kDZ.fetchEndUserAddProductPermissions)(cloudId, isBillingSystemCcp);
                newStatus = {
                    canProvisionConfluenceEndUser: endUserResponse?.eligible,
                    fetchStatus: 'resolved'
                };
            } else // If the feature flag is not enabled, set default status
            newStatus = {
                canProvisionConfluenceEndUser: appEditions.software === (0, $a9ldn.FREE_EDITION),
                fetchStatus: 'resolved'
            };
            setStatus(newStatus);
            setLocalStorage(newStatus);
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: $111926defb1457f6$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY,
                    packageName: 'jiraIssueViewBase',
                    teamName: 'starburst'
                },
                error: new Error(`Failed to get ${$111926defb1457f6$var$CONFLUENCE_ADD_PRODUCT_PERMISSION_STORAGE_KEY} status: ${error}`)
            });
            const errorStatus = {
                canProvisionConfluenceEndUser: false,
                fetchStatus: 'failed'
            };
            setStatus(errorStatus);
            setLocalStorage(errorStatus);
        }
    }, [
        cloudId,
        isBillingSystemCcp,
        appEditions.software,
        setLocalStorage
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!skip && cloudId && !cachedStatus) handleFetchPermissions();
    }, [
        cloudId,
        skip,
        cachedStatus,
        handleFetchPermissions
    ]);
    return status;
};

});
parcelRegister("k6kDZ", function(module, exports) {

$parcel$export(module.exports, "fetchEndUserAddProductPermissions", () => $6964fed97a21128d$export$e9573be2f5180789);

var $4mEPL = parcelRequire("4mEPL");
const $6964fed97a21128d$var$CONFLUENCE_FREE_OFFERING_KEY = '7547cfd6-a804-4e42-8bed-e656d49ea09e';
const $6964fed97a21128d$export$e9573be2f5180789 = async (cloudId, isBillingSystemCcp)=>{
    const response = await (0, $4mEPL.default)('/gateway/api/bxp/signup/product/end-user-activate-eligible-check', {
        method: 'POST',
        body: JSON.stringify({
            cloudId: cloudId,
            isCCP: isBillingSystemCcp,
            offerings: [
                {
                    offeringId: $6964fed97a21128d$var$CONFLUENCE_FREE_OFFERING_KEY,
                    chargeElement: 'user',
                    pricingType: 'FREE'
                }
            ]
        })
    }, 'confluence-content-placeholder-template/src/services/user-product-permission');
    return response;
};

});


parcelRegister("lXMdI", function(module, exports) {

$parcel$export(module.exports, "useAreProductSuggestionsEnabled", () => $68a6afaf8a18ec63$export$3fb3b8b7f13e1089);

var $lvKO5 = parcelRequire("lvKO5");
const $68a6afaf8a18ec63$export$3fb3b8b7f13e1089 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.areProductSuggestionsEnabled || false;
};

});


parcelRegister("42nVO", function(module, exports) {

$parcel$export(module.exports, "getOnboardingParams", () => $808d76b09bff5815$export$e7ff252d67c56b90);

var $igOPg = parcelRequire("igOPg");
const $808d76b09bff5815$export$296e41ed2dc54bb0 = ()=>{
    const teamType = (0, $igOPg.get)('teamType');
    if (!teamType || typeof teamType.value !== 'string') return null;
    return teamType.value;
};
const $808d76b09bff5815$export$e7ff252d67c56b90 = ()=>({
        teamType: $808d76b09bff5815$export$296e41ed2dc54bb0()
    });

});
parcelRegister("igOPg", function(module, exports) {

$parcel$export(module.exports, "set", () => $473de7edbdc54263$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "get", () => $473de7edbdc54263$export$3988ae62b71be9a3);

var $LFmXM = parcelRequire("LFmXM");

var $4elgJ = parcelRequire("4elgJ");
const $473de7edbdc54263$var$getStore = (0, $LFmXM.default)(()=>(0, $4elgJ.createSessionStorageProvider)('onboarding'));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $473de7edbdc54263$var$createStoredItem = (value, accessedAt)=>({
        value: value,
        accessedAt: accessedAt ?? null
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $473de7edbdc54263$var$isItemValid = (item)=>typeof item === 'object' && !Array.isArray(item) && item !== null && 'value' in item && 'accessedAt' in item;
const $473de7edbdc54263$export$adaa4cf7ef1b65be = (key, value)=>{
    const store = $473de7edbdc54263$var$getStore();
    store.set(key, JSON.stringify($473de7edbdc54263$var$createStoredItem(value)));
};
const $473de7edbdc54263$export$3988ae62b71be9a3 = (key)=>{
    const store = $473de7edbdc54263$var$getStore();
    const item = store.get(key);
    try {
        const parsed = item && JSON.parse(item);
        if ($473de7edbdc54263$var$isItemValid(parsed)) {
            store.set(key, JSON.stringify($473de7edbdc54263$var$createStoredItem(parsed.value, Date.now())));
            return parsed;
        }
        return null;
    } catch  {
        return null;
    }
};

});



parcelRegister("grotr", function(module, exports) {

$parcel$export(module.exports, "PlacementFetchProvider", () => $796e82ba6da1934d$export$9be10e5cc29463c9);

var $eJOHy = parcelRequire("eJOHy");

var $agxmR = parcelRequire("agxmR");

var $2xVkf = parcelRequire("2xVkf");
const $796e82ba6da1934d$export$9be10e5cc29463c9 = ({ children: children, resource: resource })=>{
    const fetch = (0, $2xVkf.usePlacementSSRFetch)(resource);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $agxmR.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};

});
parcelRegister("agxmR", function(module, exports) {

$parcel$export(module.exports, "usePlacementFetchingContext", () => $bace5bbd8947a888$export$e1e2cdb0425a9fa8);
$parcel$export(module.exports, "PlacementFetchingProvider", () => $bace5bbd8947a888$export$5f25a6ddf0324fa8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $bace5bbd8947a888$export$afec669dc416ee7e = /*#__PURE__*/ (0, $eJOHy.createContext)({
    fetch: (...args)=>globalThis.fetch(...args)
});
const $bace5bbd8947a888$export$e1e2cdb0425a9fa8 = ()=>(0, $eJOHy.useContext)($bace5bbd8947a888$export$afec669dc416ee7e);
const $bace5bbd8947a888$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
    const value = (0, $eJOHy.useMemo)(()=>({
            fetch: fetch
        }), [
        fetch
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($bace5bbd8947a888$export$afec669dc416ee7e.Provider, {
        value: value,
        children: children
    });
};

});


parcelRegister("9I7ft", function(module, exports) {

$parcel$export(module.exports, "default", () => $44d65b8e760fe0c4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $gPxoe = parcelRequire("gPxoe");

var $4IxUc = parcelRequire("4IxUc");

var $3o8lc = parcelRequire("3o8lc");

var $izK75 = parcelRequire("izK75");

var $eJOHy = parcelRequire("eJOHy");

var $7e1Ft = parcelRequire("7e1Ft");

const $44d65b8e760fe0c4$var$STABLE_OBJECT = {};
const $44d65b8e760fe0c4$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $eJOHy.useMemo)(()=>(0, $3o8lc.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $gPxoe.useStableObject)(placementProps ?? $44d65b8e760fe0c4$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $izK75.PerformanceTrackingSegment), {
        placementId: placementId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4IxUc.default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7e1Ft.default), {
                    analyticsChannel: (0, $cd09b9221a52ab11$export$85183a312807388d),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
        })
    });
};
var $44d65b8e760fe0c4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($44d65b8e760fe0c4$var$Placement);

});
parcelRegister("4IxUc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f1183baa74671ac$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $kxsjC = parcelRequire("kxsjC");

var $5ZQPg = parcelRequire("5ZQPg");
var $l2WwY = parcelRequire("l2WwY");
var $gPxoe = parcelRequire("gPxoe");

var $54eF4 = parcelRequire("54eF4");

var $agxmR = parcelRequire("agxmR");

var $eJOHy = parcelRequire("eJOHy");


var $a9pdq = parcelRequire("a9pdq");

var $6BWwr = parcelRequire("6BWwr");
const $7f1183baa74671ac$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $agxmR.usePlacementFetchingContext)();
    return (0, $eJOHy.useMemo)(()=>disableInitialData ? undefined : (0, $a9pdq.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
const $7f1183baa74671ac$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $l2WwY.usePostOfficeRoute)();
    const context = (0, $5ZQPg.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $6BWwr.useBuildBasePath)();
    const stableContextWithRoute = (0, $gPxoe.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $eJOHy.useMemo)(()=>isUFOEnabled ? new (0, $54eF4.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    // Callback function to listen to the different stages of the remote component and track its performance
    const remoteComponentOnEvent = (0, $eJOHy.useCallback)(({ type: type, error: error })=>{
        placementOnEvent?.({
            type: type,
            error: error
        });
        switch(type){
            case 'fetch-complete':
                ufoV1PlacementTracker?.markFetchComplete();
                break;
            case 'fetch-error':
                ufoV1PlacementTracker?.markFetchFailure(error);
                break;
            case 'render-complete':
                ufoV1PlacementTracker?.markRenderComplete();
                break;
            case 'render-error':
                ufoV1PlacementTracker?.markRenderFailure(error);
                break;
            case 'initial-data-complete':
                ufoV1PlacementTracker?.markInitialDataComplete();
                break;
            case 'initial-data-error':
                ufoV1PlacementTracker?.markInitialDataFailure(error);
                break;
            case 'component-error':
                ufoV1PlacementTracker?.markComponentFailure(error);
                break;
            case 'component-ready':
                ufoV1PlacementTracker?.markComponentReady();
                break;
            case 'unmount':
                ufoV1PlacementTracker?.markComponentAborted();
                break;
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker
    ]);
    const initialData = $7f1183baa74671ac$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $eJOHy.useMemo)(()=>({
            source: (0, $ea571868bb38bc74$export$f7109619a5e9e0d6),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxsjC.PostOfficeAnalyticsContext), {
        data: placementAnalyticsContext,
        children: children({
            initialData: initialData,
            context: stableContextWithRoute,
            onEvent: remoteComponentOnEvent
        })
    });
};
var $7f1183baa74671ac$export$2e2bcd8739ae039 = $7f1183baa74671ac$var$Placement;

});
const $ea571868bb38bc74$export$85183a312807388d = 'postOffice';
const $ea571868bb38bc74$export$f7109619a5e9e0d6 = 'post-office-frontend';

parcelRegister("6BWwr", function(module, exports) {

$parcel$export(module.exports, "useBuildBasePath", () => $190c870f839bb35e$export$83d6c58b7ab7ae67);

var $fikfn = parcelRequire("fikfn");
var $8OhYX = parcelRequire("8OhYX");

var $eJOHy = parcelRequire("eJOHy");
const $190c870f839bb35e$export$83d6c58b7ab7ae67 = ()=>{
    const postOfficeEnvironment = (0, $8OhYX.usePostOfficeEnvironment)();
    return (0, $eJOHy.useMemo)(()=>(0, $fikfn.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};

});


parcelRegister("7e1Ft", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2fd34f8495bfff2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $aN4Pk = parcelRequire("aN4Pk");

var $eJOHy = parcelRequire("eJOHy");
class $c2fd34f8495bfff2$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
}
var $c2fd34f8495bfff2$export$2e2bcd8739ae039 = (0, $aN4Pk.default)()($c2fd34f8495bfff2$var$ErrorBoundary);

});

const $cd09b9221a52ab11$export$85183a312807388d = 'postOffice';



parcelRegister("3ipHb", function(module, exports) {

$parcel$export(module.exports, "PreviewPanel", () => $b0ae65c56f2d002e$export$9520f072db304aa0);

var $gOhSQ = parcelRequire("gOhSQ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6CCPu = parcelRequire("6CCPu");

var $dzLcO = parcelRequire("dzLcO");

var $k6EUZ = parcelRequire("k6EUZ");

var $dTocu = parcelRequire("dTocu");

var $9FYIg = parcelRequire("9FYIg");

var $hXbwo = parcelRequire("hXbwo");

var $fZsy4 = parcelRequire("fZsy4");

var $ehizH = parcelRequire("ehizH");
const $b0ae65c56f2d002e$var$PreviewPanelInternal = ({ queryReference: queryReference })=>{
    const panel = (0, $k6EUZ.useCurrentPreviewPanel)();
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const [, { setPreviewPanelState: setPreviewPanelState }] = (0, $fZsy4.useLayoutStoreActions)();
    const [useLocalWidth, setUseLocalWidth] = (0, $eJOHy.useState)(false);
    const onResizeEnd = (0, $eJOHy.useCallback)(({ finalWidth: finalWidth })=>{
        panel?.setWidth?.(finalWidth);
        setPreviewPanelState({
            width: finalWidth
        });
        setUseLocalWidth(true);
    }, [
        panel,
        setPreviewPanelState
    ]);
    const data = (0, $j4oe4.usePreloadedQuery)((0, $gOhSQ.default), queryReference);
    if (panel === null) return null;
    const { content: PanelContent } = panel;
    const previewPanelWidth = useLocalWidth ? panel?.width : data?.jira?.navigationUIState?.previewPanel?.width ?? panel?.width;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.RightPanel), {
        width: previewPanelWidth,
        testId: "preview-panels.preview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PanelContent, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6CCPu.PanelSplitter), {
        label: formatMessage((0, $ehizH.messages).previewPanelSplitterLabel),
        onResizeEnd: onResizeEnd,
        testId: "preview-panels.panel-splitter"
    }));
};
const $b0ae65c56f2d002e$export$9520f072db304aa0 = ()=>{
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $hXbwo.previewPanelStateResource));
    if (!queryReference) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b0ae65c56f2d002e$var$PreviewPanelInternal, {
        queryReference: queryReference
    });
};

});
parcelRegister("dTocu", function(module, exports) {

$parcel$export(module.exports, "useIntlV2", () => $3e10afa6ddf4542a$export$d82607073b68786);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");
const $3e10afa6ddf4542a$export$d82607073b68786 = ()=>{
    const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $lRq8t.default)();
    // Only recreate intl object if reference to originral intl changes.
    const memoisedIntl = (0, $eJOHy.useMemo)(()=>{
        const modifiedIntl = {
            messages: // @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
            messages,
            locale: locale,
            formats: formats,
            formatDate: formatDate,
            formatMessage: formatMessage,
            formatNumber: formatNumber,
            formatPlural: formatPlural,
            formatTime: formatTime
        };
        return modifiedIntl;
    }, [
        formatDate,
        formatMessage,
        formatPlural,
        formatTime,
        formatNumber,
        formats,
        locale,
        messages
    ]);
    return memoisedIntl;
};

});

parcelRegister("ehizH", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2cddfb84b2ec9e3c$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2cddfb84b2ec9e3c$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    previewPanelSplitterLabel: {
        "id": "page-container-v2.common.preview-panel.preview-panel-splitter-label",
        "defaultMessage": "Resize preview panel"
    }
});

});


parcelRegister("eAwT1", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $c0bc063a19dc8ff6$export$3b4e64e77073e307);

var $dJSyP = parcelRequire("dJSyP");
const $c0bc063a19dc8ff6$export$3b4e64e77073e307 = (0, $dJSyP.Banner);

});
parcelRegister("dJSyP", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $91521b72f2da56fc$export$3b4e64e77073e307);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $dPMMf = parcelRequire("dPMMf");


var $dnZnj = parcelRequire("dnZnj");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $2fi2L = parcelRequire("2fi2L");

var $hRIa5 = parcelRequire("hRIa5");

var $6zXPf = parcelRequire("6zXPf");

var $dzLcO = parcelRequire("dzLcO");

var $5zoYi = parcelRequire("5zoYi");

var $3x4I8 = parcelRequire("3x4I8");

var $7mXaF = parcelRequire("7mXaF");

var $gyJiG = parcelRequire("gyJiG");

var $35T6Y = parcelRequire("35T6Y");

var $1QsMF = parcelRequire("1QsMF");

var $2UuhW = parcelRequire("2UuhW");

var $010oY = parcelRequire("010oY");

var $jMu4X = parcelRequire("jMu4X");

var $16sa1 = parcelRequire("16sa1");


var $5fjeK = parcelRequire("5fjeK");


var $lxKFg = parcelRequire("lxKFg");

var $khNDs = parcelRequire("khNDs");


var $kxYB3 = parcelRequire("kxYB3");
/**
 * This ID is used in pollinator tests and by JPD. Do not change lightly.
 */ const $91521b72f2da56fc$var$BANNER_ID = 'page-layout.banner';
const $91521b72f2da56fc$export$496ffd8dda3bf451 = ()=>{
    const banner = (0, $5zoYi.useBanner)();
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.Banner), {
        height: banner.height,
        testId: $91521b72f2da56fc$var$BANNER_ID,
        id: $91521b72f2da56fc$var$BANNER_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($91521b72f2da56fc$var$BannerContent, {
        bannerName: banner.name
    }))) : null;
};
const $91521b72f2da56fc$export$b5cfff585ada92ce = ()=>{
    const banner = (0, $5zoYi.useBanner)();
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kxYB3.ZIndexWrapper), {
        zIndex: (0, $dPMMf.layers).banner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.Banner), {
        height: banner.height,
        id: $91521b72f2da56fc$var$BANNER_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($91521b72f2da56fc$var$BannerContent, {
        bannerName: banner.name
    })))) : null;
};
const $91521b72f2da56fc$var$BannerContent = ({ bannerName: bannerName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, bannerName === (0, $3x4I8.NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7mXaF.BannerAnnouncementAsync), null), bannerName === (0, $2fi2L.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRIa5.IPBlocklistingBannerAsync), null), bannerName === (0, $010oY.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMu4X.ReturnToMobileBanner), null), bannerName === (0, $5dc1b04ccd518917$export$41956b146268af93) && (0, $7jTnu.fg)('jfp-magma-cookie-controls-banner-show') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dnZnj.CookieConsentBannerAsync), null), bannerName === (0, $gyJiG.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $35T6Y.BannerTransitionAsync), null), bannerName === (0, $1QsMF.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2UuhW.MailExpiryBannerAsync), null), bannerName === (0, $55277db52986c11b$export$41956b146268af93) && (0, $7jTnu.fg)('polaris_pol-15006_premium_onboarding_banner') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5fjeK.AsyncJpdPremiumOnboardingBanner), null), bannerName === (0, $27294eb882c7c50f$export$41956b146268af93) && (0, $7jTnu.fg)('upsell_jira_global_automations_limit_banner_fg') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lxKFg.AutomationLimitAwarenessBannerAsync), null), bannerName === (0, $225b7a1fbba60a47$export$7b746a9f691e0529) && (0, $7jTnu.fg)('eoc_consolidation_cohort_3_banner') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $khNDs.Cohort3BannerAsync), null));
const $91521b72f2da56fc$export$3b4e64e77073e307 = (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), $91521b72f2da56fc$export$496ffd8dda3bf451, $91521b72f2da56fc$export$b5cfff585ada92ce);

});
const $5dc1b04ccd518917$export$41956b146268af93 = 'COOKIE_CONSENT_BANNER';
const $5dc1b04ccd518917$export$ed7cc0d417ee89e = 74;
const $5dc1b04ccd518917$export$ff6e18f7d82b549c = 320;

parcelRegister("dnZnj", function(module, exports) {

$parcel$export(module.exports, "CookieConsentBannerAsync", () => $1fce724c9fba4e10$export$f110a9cbbbd3fa3a);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $7jTnu = parcelRequire("7jTnu");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1fce724c9fba4e10$var$LazyCookieConsentBanner = (0, $gzcjr.lazy)(()=>// chunk name is async-ccb to avoid scripts with cookie/banner keywords getting blocked
    (parcelRequire("hLdc9")).then(({ CookieConsentBanner: CookieConsentBanner })=>CookieConsentBanner), {
    moduleId: "./src/packages/platform/ui/banners/cookie-consent/src/ui/banner/CookieConsentBanner.tsx"
});

const $1fce724c9fba4e10$var$LazyForPaintCookieConsentBanner = (0, $gzcjr.lazyForPaint)(()=>// chunk name is async-cc-banner to avoid scripts with cookie/banner keywords getting blocked
    (parcelRequire("hLdc9")).then(({ CookieConsentBanner: CookieConsentBanner })=>CookieConsentBanner), {
    ssr: true,
    moduleId: "./src/packages/platform/ui/banners/cookie-consent/src/ui/banner/CookieConsentBanner.tsx"
});
const $1fce724c9fba4e10$export$f110a9cbbbd3fa3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $1fce724c9fba4e10$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "async-cookie-consent-banner",
        packageName: "jiraCookieConsentBanner",
        teamName: "Magma"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-cookie-consent-banner",
        fallback: null
    }, (0, $7jTnu.fg)('jfp-magma-ssr-iv-cookie-consent-banner') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1fce724c9fba4e10$var$LazyForPaintCookieConsentBanner, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1fce724c9fba4e10$var$LazyCookieConsentBanner, null))));
const $1fce724c9fba4e10$var$boxStyles = (0, $5Wv5g.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    height: '100%'
});

});
parcelRegister("hLdc9", function(module, exports) {

let $035635ee3bc6b2f3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $035635ee3bc6b2f3$var$load("h1z4o").then(()=>parcelRequire('aMyAY'));

});


parcelRegister("2fi2L", function(module, exports) {

$parcel$export(module.exports, "bannerHeight", () => $5eaeff4aff080d2f$export$86047f02632f9f5b);
$parcel$export(module.exports, "BANNER_NAME", () => $5eaeff4aff080d2f$export$41956b146268af93);

var $dPMMf = parcelRequire("dPMMf");
const $5eaeff4aff080d2f$export$86047f02632f9f5b = (0, $dPMMf.gridSize) * 7;
const $5eaeff4aff080d2f$export$41956b146268af93 = 'IP_BLOCK_LISTING_BANNER';

});

parcelRegister("hRIa5", function(module, exports) {

$parcel$export(module.exports, "IPBlocklistingBannerAsync", () => $090474c8a4a63807$export$fafc306b802ab39d);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $090474c8a4a63807$var$IPBlocklistingBannerComp = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("lhXWE")).then((m)=>m.IPBlocklistingBanner), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/ip-block-listing-banner/src/main.tsx"
});
const $090474c8a4a63807$export$fafc306b802ab39d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-ip-block-listing-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($090474c8a4a63807$var$IPBlocklistingBannerComp, null));

});
parcelRegister("lhXWE", function(module, exports) {

let $f7f9af5367af91da$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f7f9af5367af91da$var$load("8SW0d").then(()=>parcelRequire('bv20m'));

});


parcelRegister("5zoYi", function(module, exports) {

$parcel$export(module.exports, "useBanner", () => $106b08f2e31362e2$export$de40f69ba30f2376);

var $eJOHy = parcelRequire("eJOHy");

var $1avbn = parcelRequire("1avbn");

var $7jTnu = parcelRequire("7jTnu");

var $a1Ug2 = parcelRequire("a1Ug2");

var $i0Aal = parcelRequire("i0Aal");

var $c6HIQ = parcelRequire("c6HIQ");

var $gcHrf = parcelRequire("gcHrf");

var $5k2IH = parcelRequire("5k2IH");

var $f3QKI = parcelRequire("f3QKI");

var $70SSM = parcelRequire("70SSM");

var $jZ7Bs = parcelRequire("jZ7Bs");

var $gsCE0 = parcelRequire("gsCE0");
const $106b08f2e31362e2$var$noBanner = {
    name: null,
    height: 0,
    isEnabled: false
};
const $106b08f2e31362e2$export$de40f69ba30f2376 = ()=>{
    const [isChromeless] = (0, $i0Aal.useIsChromeless)();
    const announcement = (0, $c6HIQ.useBannerAnnouncement)();
    const transition = (0, $gcHrf.useBannerEocTransition)();
    const returnToMobile = (0, $f3QKI.useBannerReturnToMobile)();
    const IPBlocklisting = (0, $a1Ug2.useBannerIPBlocklisting)();
    // eslint-disable-next-line react-hooks/react-compiler
    const cohort3CustomersBanner = (0, $7jTnu.fg)('eoc_consolidation_cohort_3_banner') // eslint-disable-next-line react-hooks/rules-of-hooks
     ? (0, $gsCE0.useCohort3CustomersBanner)() : undefined;
    // eslint-disable-next-line react-hooks/react-compiler
    const cookieConsent = (0, $7jTnu.fg)('jfp-magma-cookie-controls-banner-show') // eslint-disable-next-line react-hooks/rules-of-hooks
     ? (0, $1avbn.useBannerCookieConsent)() : undefined;
    const mailExpiry = (0, $5k2IH.useBannerMailExpiry)();
    const jpdPremiumOnboarding = (0, $70SSM.useBannerJpdPremiumOnboarding)();
    // eslint-disable-next-line react-hooks/react-compiler
    const automationLimitAwareness = (0, $7jTnu.fg)('upsell_jira_global_automations_limit_banner_fg') // eslint-disable-next-line react-hooks/rules-of-hooks
     ? (0, $jZ7Bs.useBannerAutomationLimitAwareness)() : undefined;
    return (0, $eJOHy.useMemo)(()=>{
        // cookie consent banner has the highest priority
        if (cookieConsent?.isEnabled) return cookieConsent;
        if (isChromeless) return $106b08f2e31362e2$var$noBanner;
        if (IPBlocklisting.isEnabled) return IPBlocklisting;
        if (returnToMobile.isEnabled) return returnToMobile;
        if (announcement.isEnabled) return announcement;
        if (transition?.isEnabled) return transition;
        if (mailExpiry?.isEnabled) return mailExpiry;
        if (jpdPremiumOnboarding.isEnabled) return jpdPremiumOnboarding;
        if (automationLimitAwareness?.isEnabled) return automationLimitAwareness;
        if (cohort3CustomersBanner?.isEnabled) return cohort3CustomersBanner;
        return $106b08f2e31362e2$var$noBanner;
    }, [
        cookieConsent,
        isChromeless,
        IPBlocklisting,
        returnToMobile,
        announcement,
        transition,
        mailExpiry,
        jpdPremiumOnboarding,
        automationLimitAwareness,
        cohort3CustomersBanner
    ]);
};

});
parcelRegister("1avbn", function(module, exports) {

$parcel$export(module.exports, "useBannerCookieConsent", () => $1c2cfc50aff7eb61$export$c7a51b5ee06f5794);

var $eJOHy = parcelRequire("eJOHy");

var $cPjBd = parcelRequire("cPjBd");

var $7jTnu = parcelRequire("7jTnu");

var $5MeEd = parcelRequire("5MeEd");

var $hbF3h = parcelRequire("hbF3h");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");


var $lwlmQ = parcelRequire("lwlmQ");
const $1c2cfc50aff7eb61$export$5503c67b1001ec45 = (data)=>{
    if (false && !(0, $7jTnu.fg)('jfp-magma-ssr-iv-cookie-consent-banner')) return false;
    try {
        if ((0, $7jTnu.fg)('jfp-magma-ssr-iv-cookie-consent-banner')) {
            /**
			 * If we are using the cookie data to verify if we show the banner, and we don't use ATLASSIAN_SHOW_BANNER_COOKIE_KEY
			 * we end up in a situation where the banner is shown,
			 * then the client renders ConsentBanner from '@atlassian/browser-storage-controls'
			 * which then checks that cookie and if it's false
			 * and then we dismiss the banner anyway
			 *
			 * This is because the cookie consent logic does not set the 'fallback' cookie when we prefetch the data
			 * Because of this, shouldRenderBannerPrefetched will always end up returning true if we prefetch
			 *
			 * If we look at the getShowBanner code platform/packages/policy-platform/browser-storage-controls/src/ui/consent-banner/use-banner-visibility/index.ts
			 * We can see that it will use this show banner cookie to determine if the banner should be shown
			 * as long as we aren't in localConsentMode (which we aren't since we do not pass localConsentMode=true to ConsentBanner
			 * in jira/src/packages/platform/ui/banners/cookie-consent/src/ui/banner/CookieConsentBanner.tsx)
			 *
			 * So we can use the ATLASSIAN_SHOW_BANNER_COOKIE_KEY to determine if the banner should be shown instead if it is set
			 */ if (data?.shouldShowBanner !== undefined) return data.shouldShowBanner;
        }
        if ((0, $7jTnu.fg)('fedramp-jira-banner-fix')) return data === null || (0, $cPjBd.shouldRenderBannerPrefetched)(data);
        return data && (0, $cPjBd.shouldRenderBannerPrefetched)(data);
    } catch (e) {
        return true;
    }
};
const $1c2cfc50aff7eb61$var$useBannerCookieConsentOld = ()=>{
    const [{ isDismissed: isDismissed, height: height }, { onShow: onShow }] = (0, $lwlmQ.useCookieConsentBannerSettings)();
    const { data: data } = (0, $5MeEd.useConsentBannerUserPreferencesResource)();
    (0, $eJOHy.useEffect)(()=>{
        const shouldRender = $1c2cfc50aff7eb61$export$5503c67b1001ec45(data);
        // only show banner if banner should be shown and not in iframe
        if (shouldRender && !(0, $lwlmQ.isInIframe)()) // the initial state of banner is "Dismissed" so we need to show it if we "think" it should be shown
        // in case we are making a mistake and CookieBanner will not display
        // it will inform us via `onConsentBannerBailOut` and we will dismiss the banner again.
        onShow();
    }, [
        data,
        onShow
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: !isDismissed,
            name: (0, $5dc1b04ccd518917$export$41956b146268af93),
            height: height
        }), [
        isDismissed,
        height
    ]);
};
const $1c2cfc50aff7eb61$var$useBannerCookieConsentNew = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [{ isDismissed: isDismissed, height: height, hasInit: hasInit }, { onShow: onShow, init: init }] = (0, $lwlmQ.useCookieConsentBannerSettings)();
    const { data: data, loading: loading, error: error } = (0, $5MeEd.useConsentBannerUserPreferencesResource)();
    // This is the initial state of the banner esp in ssr land
    const [initialShouldShow] = (0, $eJOHy.useState)(()=>{
        if (loading) return false;
        if (error) return true;
        return Boolean($1c2cfc50aff7eb61$export$5503c67b1001ec45(data) && !(0, $lwlmQ.isInIframe)());
    });
    const shouldShow = (0, $eJOHy.useMemo)(()=>hasInit ? !isDismissed : initialShouldShow, [
        hasInit,
        initialShouldShow,
        isDismissed
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (hasInit || loading) return;
        // Now that we're in the client render, let's re-verify if we should show the banner
        // Eg to verify if we are in an iframe
        const shouldRender = Boolean(error || $1c2cfc50aff7eb61$export$5503c67b1001ec45(data) && !(0, $lwlmQ.isInIframe)());
        init(!shouldRender);
        // We should verify how often we end up having a mismatch between the initial render (probably ssr) and init render (client)
        if (!(0, $7jTnu.fg)('killswitch-analytics-ssr-cookie-consent-banner')) {
            if (initialShouldShow !== shouldRender) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'cookieConsentBanner showBannerMismatch', {
                isInIframe: (0, $lwlmQ.isInIframe)(),
                initialShouldShow: initialShouldShow,
                initShouldShow: shouldRender
            });
        }
    }, [
        createAnalyticsEvent,
        data,
        error,
        hasInit,
        init,
        initialShouldShow,
        loading,
        onShow
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: shouldShow,
            name: (0, $5dc1b04ccd518917$export$41956b146268af93),
            height: height
        }), [
        shouldShow,
        height
    ]);
};
const $1c2cfc50aff7eb61$export$c7a51b5ee06f5794 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-ssr-iv-cookie-consent-banner'), $1c2cfc50aff7eb61$var$useBannerCookieConsentNew, $1c2cfc50aff7eb61$var$useBannerCookieConsentOld);

});
parcelRegister("cPjBd", function(module, exports) {

$parcel$export(module.exports, "shouldRenderBannerPrefetched", () => $10504b8f6d71d0cf$export$6406464aa126433e);

var $8XtVW = parcelRequire("8XtVW");

var $6vyNn = parcelRequire("6vyNn");

var $c2OhR = parcelRequire("c2OhR");

var $nurtv = parcelRequire("nurtv");
const $10504b8f6d71d0cf$export$6406464aa126433e = (prefetchedPreferencesData)=>{
    if ((0, $8XtVW.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If the bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $c2OhR.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $nurtv.getBannerVisibility)(prefetchedPreferencesData) : true;
    }
    // We've been given ConsentHub response data, format it appropriately
    const consentPrefsData = (0, $6vyNn.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $nurtv.getBannerVisibility)(consentPrefsData);
};

});

parcelRegister("lwlmQ", function(module, exports) {

$parcel$export(module.exports, "isInIframe", () => $f6f060ec33615eca$export$9f140ed41af5108c);
$parcel$export(module.exports, "useCookieConsentBannerSettings", () => $f6f060ec33615eca$export$ae97931560f092a4);
$parcel$export(module.exports, "useCookieConsentBannerSettingsActions", () => $f6f060ec33615eca$export$ecbab4dc5f9ad844);

var $gRw8I = parcelRequire("gRw8I");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7jTnu = parcelRequire("7jTnu");

const $f6f060ec33615eca$export$9f140ed41af5108c = ()=>{
    (0, $gRw8I.di)(window);
    if (false) return false;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window !== window.top;
};
const $f6f060ec33615eca$export$aa1483cc2e197f6e = ()=>{
    if (false) return false;
    return true;
};
const $f6f060ec33615eca$export$d4c72bab9d6cc13a = {
    get isDismissed () {
        return (0, $7jTnu.fg)('magma-3429_banners_in_modern_ssr') ? true : $f6f060ec33615eca$export$aa1483cc2e197f6e();
    },
    get height () {
        return (0, $7jTnu.fg)('jfp-magma-ssr-iv-cookie-consent-banner') ? (0, $5dc1b04ccd518917$export$ed7cc0d417ee89e) : 0;
    },
    hasInit: false
};
const $f6f060ec33615eca$export$e324594224ef24da = {
    onShow: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...(0, $7jTnu.fg)('jfp-magma-ssr-iv-cookie-consent-banner') ? {} : getState(),
                isDismissed: false
            });
        },
    onDismiss: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...(0, $7jTnu.fg)('jfp-magma-ssr-iv-cookie-consent-banner') ? {} : getState(),
                isDismissed: true
            });
        },
    setHeight: (height)=>({ getState: getState, setState: setState })=>{
            setState({
                ...(0, $7jTnu.fg)('jfp-magma-ssr-iv-cookie-consent-banner') ? {} : getState(),
                height: height
            });
        },
    init: (isDismissed)=>({ setState: setState })=>{
            setState({
                isDismissed: isDismissed,
                hasInit: true
            });
        }
};
const $f6f060ec33615eca$var$Store = (0, $GtRbT.createStore)({
    name: 'cookie-consent-banner',
    initialState: $f6f060ec33615eca$export$d4c72bab9d6cc13a,
    actions: $f6f060ec33615eca$export$e324594224ef24da
});
const $f6f060ec33615eca$export$ae97931560f092a4 = (0, $iJq0l.createHook)($f6f060ec33615eca$var$Store);
const $f6f060ec33615eca$export$ecbab4dc5f9ad844 = (0, $iJq0l.createActionsHook)($f6f060ec33615eca$var$Store);

});


parcelRegister("a1Ug2", function(module, exports) {

$parcel$export(module.exports, "useBannerIPBlocklisting", () => $91f5fab890bd5376$export$564412c1d9cd4ccc);

var $eJOHy = parcelRequire("eJOHy");

var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");

var $7jTnu = parcelRequire("7jTnu");

var $2fi2L = parcelRequire("2fi2L");
const $91f5fab890bd5376$export$564412c1d9cd4ccc = ()=>{
    const [shouldShowBanner, setBannerState] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $7jTnu.fg)('firefox_issue_view_memory_leak_v1')) // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $4T9yL.waitForHeritage)()?.then(()=>// eslint-disable-next-line jira/wrm/no-load-bridge
            (0, $97BGz.loadBridgeStrict)({
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-atlaskit-plugin:ipblocklisting'
                ],
                name: 'jira/global-components/ipblocklisting/bridge'
            }).then((bridge)=>{
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                bridge({
                    showIPBlocklistBanner: ()=>setBannerState(true),
                    hideIPBlocklistBanner: ()=>setBannerState(false)
                });
            }));
        else // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $iyT45.loadBridgeWeak)({
            name: 'jira/global-components/ipblocklisting/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge({
                showIPBlocklistBanner: ()=>setBannerState(true),
                hideIPBlocklistBanner: ()=>setBannerState(false)
            });
        });
    }, []);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: shouldShowBanner,
            name: (0, $2fi2L.BANNER_NAME),
            height: (0, $2fi2L.bannerHeight)
        }), [
        shouldShowBanner
    ]);
};

});

parcelRegister("c6HIQ", function(module, exports) {

$parcel$export(module.exports, "useBannerAnnouncement", () => $03910aaf8b8451fd$export$1e775b1ab04f2888);

var $eJOHy = parcelRequire("eJOHy");

var $hTrTW = parcelRequire("hTrTW");

var $cECwI = parcelRequire("cECwI");

var $3x4I8 = parcelRequire("3x4I8");
const $03910aaf8b8451fd$export$1e775b1ab04f2888 = ()=>{
    const { data: data } = (0, $hTrTW.useAnnouncementBannerSettingsV4Resource)();
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: Boolean(data?.isEnabled) && !data?.isDismissed && (data?.visibility === 'private' && !isAnonymous || data?.visibility === 'public'),
            name: (0, $3x4I8.NAME),
            height: (0, $3x4I8.HEIGHT)
        }), [
        data?.isDismissed,
        data?.isEnabled,
        data?.visibility,
        isAnonymous
    ]);
};

});
parcelRegister("3x4I8", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $69f60eadef6768b2$export$809d2b099693a9a8);
$parcel$export(module.exports, "NAME", () => $69f60eadef6768b2$export$3c5e605ca7ade9f2);

var $dPMMf = parcelRequire("dPMMf");
const $69f60eadef6768b2$export$809d2b099693a9a8 = (0, $dPMMf.gridSize) * 8;
const $69f60eadef6768b2$export$3c5e605ca7ade9f2 = 'ANNOUNCEMENT';

});


parcelRegister("gcHrf", function(module, exports) {

$parcel$export(module.exports, "useBannerEocTransition", () => $4fb08c6d42c0025d$export$b6539a8209f95b48);

var $eJOHy = parcelRequire("eJOHy");

var $5bYCj = parcelRequire("5bYCj");

var $ltvrD = parcelRequire("ltvrD");

var $gDXSd = parcelRequire("gDXSd");

var $gZTP9 = parcelRequire("gZTP9");

var $lUto7 = parcelRequire("lUto7");

var $gyJiG = parcelRequire("gyJiG");
const $4fb08c6d42c0025d$export$b6539a8209f95b48 = ()=>{
    const { data: data, error: error } = (0, $5bYCj.useOgConsolidationUserState)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const { isTransitionEligible: isTransitionEligible, error: tenantInfoError } = (0, $gDXSd.useOgTenantInfo)();
    const isEnabled = Boolean((isAdmin || isSiteAdmin) && // Tenant info
    !tenantInfoError && isTransitionEligible && // User state
    !error && data && (!data.isTransitionBannerDismissed || (0, $ltvrD.shouldRenderBenefitModal)({
        bannerDismissedAt: data.transitionBannerDismissedAt,
        isDismissed: data.isBenefitModalDismissed
    })));
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $gyJiG.BANNER_NAME),
            height: data && (0, $ltvrD.shouldRenderBenefitModal)({
                bannerDismissedAt: data.transitionBannerDismissedAt
            }) ? 0 : (0, $gyJiG.HEIGHT)
        }), [
        data,
        isEnabled
    ]);
};

});
parcelRegister("5bYCj", function(module, exports) {

$parcel$export(module.exports, "useOgConsolidationUserState", () => $0219b617ddf086fe$export$c35632c02599163f);

var $eJOHy = parcelRequire("eJOHy");

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $4I3Mw = parcelRequire("4I3Mw");

var $graie = parcelRequire("graie");

var $lvKO5 = parcelRequire("lvKO5");

var $eJrcF = parcelRequire("eJrcF");

var $bZ2Xv = parcelRequire("bZ2Xv");
const $0219b617ddf086fe$export$c35632c02599163f = ()=>{
    const errorRef = (0, $eJOHy.useRef)();
    const loadingRef = (0, $eJOHy.useRef)(false);
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { data: data, update: updateTransitionResource, error: transitionResourceError } = (0, $eJrcF.useResource)((0, $graie.consolidationUserStateResource));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [userPropertiesError, setUserPropertiesError] = (0, $eJOHy.useState)();
    errorRef.current = userPropertiesError || transitionResourceError;
    const { atlassianAccountId: accountId } = (0, $lvKO5.useTenantContext)();
    const update = (0, $eJOHy.useCallback)((newState)=>{
        if (errorRef.current) // If there is an error on resource or update, we don't want to update the state
        return Promise.reject(errorRef.current);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        let updatedData = {};
        updateTransitionResource((oldState)=>{
            updatedData = {
                ...oldState,
                ...newState
            };
            return updatedData;
        });
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $gYnSx.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $FppkK.setUserProperties)(accountId, (0, $4I3Mw.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY), JSON.stringify(updatedData)).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                showFlag({
                    type: 'error',
                    isAutoDismiss: true,
                    title: formatMessage((0, $bZ2Xv.default).errorFlagTitle),
                    messageId: 'eoc-changeboarding.controllers.use-og-consolidation-user-state.show-flag.error.jira-modal',
                    messageType: 'transactional'
                });
                (0, $gYnSx.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                loadingRef.current = false;
            });
        }
        return Promise.resolve();
    }, [
        updateTransitionResource,
        accountId,
        formatMessage,
        showFlag
    ]);
    const reopenTransitionLozenge = (0, $eJOHy.useCallback)(()=>{
        update({
            isTransitionHomeHidden: false
        });
    }, [
        update
    ]);
    return {
        data: data,
        update: update,
        error: errorRef.current,
        reopenTransitionLozenge: reopenTransitionLozenge
    };
};

});
parcelRegister("bZ2Xv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d01a20d87d825d5b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d01a20d87d825d5b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorFlagTitle: {
        "id": "eoc-changeboarding.controllers.use-og-consolidation-user-state.error-flag-title",
        "defaultMessage": "Something went wrong while updating user properties."
    }
});

});


parcelRegister("ltvrD", function(module, exports) {

$parcel$export(module.exports, "shouldRenderBenefitModal", () => $e7555031055c9d59$export$25a52eb2dc74e2f9);
const $e7555031055c9d59$export$25a52eb2dc74e2f9 = ({ isDismissed: isDismissed, bannerDismissedAt: bannerDismissedAt })=>{
    if (!bannerDismissedAt || isDismissed) return false;
    return Math.ceil((new Date().getTime() - bannerDismissedAt) / 1000 / 60 / 60 / 24) >= 14;
};

});

parcelRegister("gyJiG", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $d9444cff34d1ab64$export$809d2b099693a9a8);
$parcel$export(module.exports, "BANNER_NAME", () => $d9444cff34d1ab64$export$41956b146268af93);

var $dPMMf = parcelRequire("dPMMf");
const $d9444cff34d1ab64$export$809d2b099693a9a8 = (0, $dPMMf.gridSize) * 6;
const $d9444cff34d1ab64$export$41956b146268af93 = 'EOC_TRANSITION';

});


parcelRegister("5k2IH", function(module, exports) {

$parcel$export(module.exports, "useBannerMailExpiry", () => $2d1be9dfb49d960c$export$3906461ac9b87d2);

var $eJOHy = parcelRequire("eJOHy");

var $7KVqh = parcelRequire("7KVqh");

var $1QsMF = parcelRequire("1QsMF");

var $kTerl = parcelRequire("kTerl");
const $2d1be9dfb49d960c$export$3906461ac9b87d2 = ()=>{
    const { responseStatus: responseStatus, state: state } = (0, $7KVqh.useIncomingMailExpiryStatus)();
    const { onStateFetch: onStateFetch } = (0, $kTerl.useBannerActions)();
    const { isBannerShown: isBannerShown } = (0, $kTerl.useBannerState)();
    (0, $eJOHy.useEffect)(()=>{
        if (responseStatus === 'error') {
            onStateFetch((0, $7KVqh.DEFAULT_RESPONSE));
            return;
        }
        if (responseStatus === 'success') onStateFetch(state);
    }, [
        onStateFetch,
        responseStatus,
        state
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: isBannerShown,
            name: (0, $1QsMF.BANNER_NAME),
            height: (0, $1QsMF.HEIGHT)
        }), [
        isBannerShown
    ]);
};

});
parcelRegister("1QsMF", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $b469e0c8d9aee89c$export$809d2b099693a9a8);
$parcel$export(module.exports, "BANNER_NAME", () => $b469e0c8d9aee89c$export$41956b146268af93);

var $dPMMf = parcelRequire("dPMMf");
const $b469e0c8d9aee89c$export$809d2b099693a9a8 = (0, $dPMMf.gridSize) * 6;
const $b469e0c8d9aee89c$export$41956b146268af93 = 'MAIL_EXPIRY_REMINDER';

});

parcelRegister("kTerl", function(module, exports) {

$parcel$export(module.exports, "useBannerActions", () => $900e5237903630fd$export$664f3e2467f0f5af);
$parcel$export(module.exports, "useBannerState", () => $900e5237903630fd$export$fa4ffa872ee90bd0);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $900e5237903630fd$export$d4c72bab9d6cc13a = {
    isBannerShown: false,
    isAdmin: false,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $900e5237903630fd$export$e324594224ef24da = {
    onDismiss: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: false
            });
        },
    onStateFetch: ({ showBanner: showBanner, isAdmin: isAdmin, OauthTypes: OauthTypes = [
        'GMAIL_OAUTH'
    ] })=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: showBanner && isAdmin,
                isAdmin: isAdmin,
                OauthTypes: OauthTypes
            });
        }
};
const $900e5237903630fd$var$Store = (0, $GtRbT.createStore)({
    name: 'mail-expiry-banner',
    initialState: $900e5237903630fd$export$d4c72bab9d6cc13a,
    actions: $900e5237903630fd$export$e324594224ef24da
});
const $900e5237903630fd$export$664f3e2467f0f5af = (0, $iJq0l.createActionsHook)($900e5237903630fd$var$Store);
const $900e5237903630fd$export$fa4ffa872ee90bd0 = (0, $iJq0l.createStateHook)($900e5237903630fd$var$Store);

});


parcelRegister("f3QKI", function(module, exports) {

$parcel$export(module.exports, "useBannerReturnToMobileState", () => $e57df8779bd25ced$export$571311559507e90);
$parcel$export(module.exports, "useBannerReturnToMobile", () => $e57df8779bd25ced$export$a898dd7b7ec9917a);

var $eJOHy = parcelRequire("eJOHy");

var $l7Alo = parcelRequire("l7Alo");

var $fYeTG = parcelRequire("fYeTG");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $010oY = parcelRequire("010oY");
const $e57df8779bd25ced$var$initialState = ()=>({
        // reads FG early
        isEnabled: (0, $l7Alo.shouldShowReturnToMobileBanner)()
    });
const $e57df8779bd25ced$var$actions = {
    disable: ()=>({ setState: setState })=>{
            setState({
                isEnabled: false
            });
        }
};
const $e57df8779bd25ced$var$store = (0, $GtRbT.createStore)({
    initialState: $e57df8779bd25ced$var$initialState,
    actions: $e57df8779bd25ced$var$actions
});
const $e57df8779bd25ced$export$571311559507e90 = (0, $iJq0l.createHook)($e57df8779bd25ced$var$store);
const $e57df8779bd25ced$export$a898dd7b7ec9917a = ()=>{
    const [{ isEnabled: isEnabledOriginal }] = $e57df8779bd25ced$export$571311559507e90();
    const isEnabled = (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)() ? isEnabledOriginal && (0, $l7Alo.shouldShowReturnToMobileBannerMobileMvp)() : isEnabledOriginal;
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $010oY.BANNER_NAME),
            height: (0, $010oY.mobileBannerHeight)
        }), [
        isEnabled
    ]);
};

});
parcelRegister("010oY", function(module, exports) {

$parcel$export(module.exports, "mobileBannerHeight", () => $68c768b7bbc0a026$export$aa875602f5712b77);
$parcel$export(module.exports, "BANNER_NAME", () => $68c768b7bbc0a026$export$41956b146268af93);
$parcel$export(module.exports, "ENCODED_APPLE_APP_STORE_URL", () => $68c768b7bbc0a026$export$698c82a2c8445300);

var $dPMMf = parcelRequire("dPMMf");
const $68c768b7bbc0a026$export$aa875602f5712b77 = (0, $dPMMf.gridSize) * 6;
const $68c768b7bbc0a026$export$41956b146268af93 = 'RETURN_TO_MOBILE_BANNER';
const $68c768b7bbc0a026$export$698c82a2c8445300 = encodeURIComponent('https://itunes.apple.com/app/apple-store/id1006972087');

});


parcelRegister("70SSM", function(module, exports) {

$parcel$export(module.exports, "useBannerJpdPremiumOnboarding", () => $e65817140c3e22be$export$433a8becd2c7b601);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $7jTnu = parcelRequire("7jTnu");

var $2aY2d = parcelRequire("2aY2d");

var $8q7lT = parcelRequire("8q7lT");


var $g4zHL = parcelRequire("g4zHL");

var $hzSMw = parcelRequire("hzSMw");
const $e65817140c3e22be$export$433a8becd2c7b601 = ()=>{
    const hasPolarisInPath = (0, $hzSMw.useHasPolarisInPath)();
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const accountId = (0, $8q7lT.useAccountId)();
    const { isDismissed: isDismissed, height: height, shouldShow: shouldShow, isLoading: isLoading } = (0, $g4zHL.useJpdPremiumOnboardingBannerState)();
    const { fetchBannerVisibility: fetchBannerVisibility } = (0, $g4zHL.useJpdPremiumOnboardingBannerActions)();
    const isDiscoveryProject = project?.projectType === (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT);
    const isInJpdBoundary = (0, $eJOHy.useMemo)(()=>hasPolarisInPath || isDiscoveryProject, [
        isDiscoveryProject,
        hasPolarisInPath
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!accountId || !(0, $7jTnu.fg)('polaris_pol-15006_premium_onboarding_banner') || !(0, $7jTnu.fg)('polaris_eap_customers')) return;
        fetchBannerVisibility(accountId);
    }, [
        accountId,
        fetchBannerVisibility
    ]);
    // use `polaris_eap_customers` to check if the customer is in the EAP
    // use `polaris_pol-15006_premium_onboarding_banner` as a kill switch
    // If I'll use `polaris_eap_customers` only, we won't have a quick way to disable the banner
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: // eslint-disable-next-line jira/ff/no-preconditioning
            isInJpdBoundary && shouldShow && !isDismissed && !isLoading && (0, $7jTnu.fg)('polaris_eap_customers') && (0, $7jTnu.fg)('polaris_pol-15006_premium_onboarding_banner'),
            name: (0, $55277db52986c11b$export$41956b146268af93),
            height: height
        }), [
        isInJpdBoundary,
        shouldShow,
        isDismissed,
        height,
        isLoading
    ]);
};

});
const $55277db52986c11b$export$41956b146268af93 = 'JPD_PREMIUM_ONBOARDING_BANNER';
const $55277db52986c11b$export$ed7cc0d417ee89e = 40;
const $55277db52986c11b$export$ff6e18f7d82b549c = 320;
const $55277db52986c11b$export$a07dab5608229ea3 = 'jira.polaris.premium-onboarding-banner';
const $55277db52986c11b$export$b8b9d90f9e5bd72b = 'jiraPolarisComponentPremiumOnboardingBanner';

parcelRegister("g4zHL", function(module, exports) {

$parcel$export(module.exports, "useJpdPremiumOnboardingBannerState", () => $c99725c8527cc841$export$7241553ec2c3a71a);
$parcel$export(module.exports, "useJpdPremiumOnboardingBannerActions", () => $c99725c8527cc841$export$b0b24f21e4ac85cd);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

var $7e8wG = parcelRequire("7e8wG");

var $hThlN = parcelRequire("hThlN");

var $8KUFq = parcelRequire("8KUFq");

var $1uIew = parcelRequire("1uIew");

var $7jTnu = parcelRequire("7jTnu");

function $c99725c8527cc841$var$getError(error) {
    if (error instanceof Error) return error;
    if ((0, $7jTnu.fg)('polaris_log_unknown_error_premium_banner')) // By using `UnknownError` here we can pass extra data to Sentry
    // and it will be captured in the error details
    return new (0, $hThlN.UnknownError)('Retrieved non-standard error', error);
    return new Error('Unknown error');
}
const $c99725c8527cc841$export$d4c72bab9d6cc13a = {
    isDismissed: false,
    height: (0, $55277db52986c11b$export$ed7cc0d417ee89e),
    shouldShow: true,
    isLoading: true
};
const $c99725c8527cc841$export$e324594224ef24da = {
    onDismiss: (accountId)=>async ({ setState: setState })=>{
            if (!accountId) return;
            try {
                await (0, $FppkK.setUserProperties)(accountId, (0, $55277db52986c11b$export$41956b146268af93), 'false');
                setState({
                    isDismissed: true
                });
            } catch (error) {
                setState({
                    isDismissed: true
                });
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.jpd-premium-onboarding.banner-dismissed', $c99725c8527cc841$var$getError(error)));
            }
        },
    fetchBannerVisibility: (accountId)=>async ({ setState: setState })=>{
            if (!accountId) return;
            try {
                const value = await (0, $FppkK.getUserProperty)(accountId, (0, $55277db52986c11b$export$41956b146268af93));
                setState({
                    shouldShow: value,
                    isLoading: false
                });
            } catch (error) {
                setState({
                    isLoading: false
                });
                if (error instanceof (0, $1uIew.default) && error.statusCode === 404 || (0, $8KUFq.isClientFetchError)(error)) return;
                (0, $gYnSx.default)((0, $7e8wG.createErrorAnalytics)('polaris.jpd-premium-onboarding.banner-dismissed', $c99725c8527cc841$var$getError(error)));
            }
        }
};
const $c99725c8527cc841$var$Store = (0, $GtRbT.createStore)({
    name: 'PolarisPremiumOnboardingBanner',
    initialState: $c99725c8527cc841$export$d4c72bab9d6cc13a,
    actions: $c99725c8527cc841$export$e324594224ef24da
});
const $c99725c8527cc841$export$7241553ec2c3a71a = (0, $iJq0l.createStateHook)($c99725c8527cc841$var$Store);
const $c99725c8527cc841$export$b0b24f21e4ac85cd = (0, $iJq0l.createActionsHook)($c99725c8527cc841$var$Store);

});

parcelRegister("hzSMw", function(module, exports) {

$parcel$export(module.exports, "useHasPolarisInPath", () => $229762275fcf8ed5$export$b9f1d0d4eba42cdb);

var $kfvK2 = parcelRequire("kfvK2");
const $229762275fcf8ed5$export$b9f1d0d4eba42cdb = (0, $kfvK2.createRouterSelector)(({ location: location })=>{
    return location.pathname.includes('/jira/polaris');
});

});


parcelRegister("jZ7Bs", function(module, exports) {

$parcel$export(module.exports, "useBannerAutomationLimitAwareness", () => $b67017d020386fbf$export$721b128dc6e2747d);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ 
var $eJOHy = parcelRequire("eJOHy");

var $3QMHH = parcelRequire("3QMHH");


var $aofWR = parcelRequire("aofWR");
const $b67017d020386fbf$export$721b128dc6e2747d = ()=>{
    const state = (0, $3QMHH.useAutomationLimitBannerState)();
    const { isEligible: isEligible, cohort: cohort, projectType: projectType, bannerType: bannerType } = (0, $aofWR.useStandardAutomationLimitAwarenessExperiment)();
    const isEnabled = Boolean(isEligible && projectType && bannerType && cohort !== 'not-enrolled' && !state[projectType].isDismissed && !state[projectType].isLoading);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $27294eb882c7c50f$export$41956b146268af93),
            height: isEnabled && projectType && cohort === 'treatment' ? state[projectType].height : 0
        }), [
        isEnabled,
        cohort,
        state,
        projectType
    ]);
};

});
parcelRegister("3QMHH", function(module, exports) {

$parcel$export(module.exports, "useAutomationLimitBannerState", () => $58ad8e28c2bf9311$export$90e145919b624840);
$parcel$export(module.exports, "useAutomationLimitBannerActions", () => $58ad8e28c2bf9311$export$602681b371abcfed);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $dnU6V = parcelRequire("dnU6V");

const $58ad8e28c2bf9311$export$d4c72bab9d6cc13a = {
    software: {
        isDismissed: false,
        height: 0,
        isLoading: false
    },
    service_desk: {
        isDismissed: false,
        height: 0,
        isLoading: false
    }
};
const $58ad8e28c2bf9311$export$5b435f40f36f752b = (prefix)=>(0, $dnU6V.createLocalStorageProvider)(`${prefix}-${(0, $27294eb882c7c50f$export$a9066c48870ddcc5)}`);
const $58ad8e28c2bf9311$var$getCurrentMonth = ()=>new Date().getMonth();
const $58ad8e28c2bf9311$export$bce50709089bc65b = {
    software: {
        month: $58ad8e28c2bf9311$var$getCurrentMonth(),
        '80_90': false,
        '90_100': false,
        gte100: false
    },
    service_desk: {
        month: $58ad8e28c2bf9311$var$getCurrentMonth(),
        '80_90': false,
        '90_100': false,
        gte100: false
    }
};
const $58ad8e28c2bf9311$export$e324594224ef24da = {
    dismissBanner: (cloudId, projectType, bannerType)=>async ({ setState: setState })=>{
            if (!cloudId || bannerType !== '80_90' && bannerType !== '90_100' && bannerType !== 'gte100') return;
            try {
                const localStorageProvider = $58ad8e28c2bf9311$export$5b435f40f36f752b(cloudId);
                const currentData = localStorageProvider.get((0, $27294eb882c7c50f$export$a9066c48870ddcc5)) || {
                    ...$58ad8e28c2bf9311$export$bce50709089bc65b
                };
                currentData[projectType][bannerType] = true;
                localStorageProvider.set((0, $27294eb882c7c50f$export$a9066c48870ddcc5), currentData);
                setState({
                    [projectType]: {
                        isDismissed: true,
                        height: 0
                    }
                });
            } catch (error) {
                setState({
                    [projectType]: {
                        isDismissed: true,
                        height: 0
                    }
                });
            }
        },
    checkDismissalState: (cloudId, projectType, bannerType)=>async ({ setState: setState })=>{
            setState({
                [projectType]: {
                    isLoading: true
                }
            });
            if (!cloudId || !bannerType || projectType !== 'software' && projectType !== 'service_desk') {
                setState({
                    [projectType]: {
                        isDismissed: true,
                        isLoading: false,
                        height: 0
                    }
                });
                return;
            }
            try {
                const localStorageProvider = $58ad8e28c2bf9311$export$5b435f40f36f752b(cloudId);
                const localStorageData = localStorageProvider.get((0, $27294eb882c7c50f$export$a9066c48870ddcc5));
                let productBannerDismissedStates;
                // reset state if it doesn't exist or it's expired
                if (!localStorageData || localStorageData[projectType]?.month !== $58ad8e28c2bf9311$var$getCurrentMonth()) {
                    productBannerDismissedStates = $58ad8e28c2bf9311$export$bce50709089bc65b[projectType];
                    localStorageProvider.set((0, $27294eb882c7c50f$export$a9066c48870ddcc5), {
                        ...$58ad8e28c2bf9311$export$bce50709089bc65b
                    });
                } else productBannerDismissedStates = localStorageData[projectType];
                const isDismissed = productBannerDismissedStates[bannerType] === true;
                setState({
                    [projectType]: {
                        isDismissed: isDismissed,
                        isLoading: false,
                        height: isDismissed ? 0 : (0, $27294eb882c7c50f$export$ed7cc0d417ee89e)
                    }
                });
            } catch (error) {
                setState({
                    [projectType]: {
                        isDismissed: false,
                        isLoading: false,
                        height: 0
                    }
                });
            }
        }
};
const $58ad8e28c2bf9311$var$Store = (0, $GtRbT.createStore)({
    name: 'AutomationLimitAwarenessBanner',
    initialState: $58ad8e28c2bf9311$export$d4c72bab9d6cc13a,
    actions: $58ad8e28c2bf9311$export$e324594224ef24da
});
const $58ad8e28c2bf9311$export$90e145919b624840 = (0, $iJq0l.createStateHook)($58ad8e28c2bf9311$var$Store);
const $58ad8e28c2bf9311$export$602681b371abcfed = (0, $iJq0l.createActionsHook)($58ad8e28c2bf9311$var$Store);

});
const $27294eb882c7c50f$export$a9066c48870ddcc5 = 'upsell_jira_global_automations_limit_banner';
const $27294eb882c7c50f$export$41956b146268af93 = 'AUTOMATION_LIMIT_AWARENESS';
const $27294eb882c7c50f$export$ed7cc0d417ee89e = 56;


parcelRegister("aofWR", function(module, exports) {

$parcel$export(module.exports, "convertTraitsToBannerType", () => $0ba425f43b8581f3$export$a8802aa133ba235b);
$parcel$export(module.exports, "useStandardAutomationLimitAwarenessExperiment", () => $0ba425f43b8581f3$export$e3859be76d81263c);
/* eslint-disable jira/ff/unsafe-no-exposure */ 
var $epTsa = parcelRequire("epTsa");

var $2emAF = parcelRequire("2emAF");

var $eJrcF = parcelRequire("eJrcF");

var $6zXPf = parcelRequire("6zXPf");

var $7jTnu = parcelRequire("7jTnu");

var $5L7qx = parcelRequire("5L7qx");

var $1L5N6 = parcelRequire("1L5N6");
const $0ba425f43b8581f3$var$jiraTrait = 'upsell_jsw_tenants_gte_80_percent_automation_usage';
const $0ba425f43b8581f3$var$jsmTrait = 'upsell_jsm_tenants_gte_80_percent_automation_usage';
const $0ba425f43b8581f3$var$jiraLimit = 1700;
const $0ba425f43b8581f3$var$jsmLimit = 5000;
const $0ba425f43b8581f3$var$getProductSpecificTrait = (siteTraitsData, productType)=>{
    return siteTraitsData && productType ? siteTraitsData.find((trait)=>{
        if (!trait) return;
        switch(productType){
            case 'software':
                return trait.name === $0ba425f43b8581f3$var$jiraTrait;
            case 'service_desk':
                return trait.name === $0ba425f43b8581f3$var$jsmTrait;
            default:
                return false;
        }
    }) : undefined;
};
const $0ba425f43b8581f3$export$a8802aa133ba235b = (limit, automationCount)=>{
    if (automationCount) {
        const percentage = automationCount / limit * 100;
        if (percentage >= 80 && percentage < 90) return '80_90';
        if (percentage >= 90 && percentage < 100) return '90_100';
        if (percentage >= 100) return 'gte100';
    }
    return undefined;
};
const $0ba425f43b8581f3$export$e3859be76d81263c = ()=>{
    const { isEligible: isEligible, projectType: projectType } = (0, $1L5N6.useBasicEligibilityCriteriaCheck)();
    const siteTraitsResource = (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('blu-3929-sidebar-menu-recommended'), (0, $2emAF.fetchSiteTraitsResource));
    const { data: siteTraitsData } = (0, $eJrcF.useResource)(siteTraitsResource);
    const [expConfig, fireStatsigExposure] = (0, $epTsa.UNSAFE_noExposureExp)('upsell_jira_global_automations_limit_banner');
    const productTrait = $0ba425f43b8581f3$var$getProductSpecificTrait(siteTraitsData, projectType);
    const cohort = expConfig.get('cohort', 'not-enrolled');
    const automationsLimit = projectType === 'software' ? $0ba425f43b8581f3$var$jiraLimit : $0ba425f43b8581f3$var$jsmLimit;
    const automationsUsedCount = productTrait?.value ? Number(productTrait?.value) : undefined;
    const bannerType = productTrait?.value ? $0ba425f43b8581f3$export$a8802aa133ba235b(automationsLimit, automationsUsedCount) : undefined;
    return {
        isEligible: isEligible,
        cohort: cohort,
        projectType: projectType,
        bannerType: bannerType,
        automationsUsedCount: automationsUsedCount,
        automationsLimit: automationsLimit,
        fireStatsigExposure: fireStatsigExposure
    };
};

});
parcelRegister("1L5N6", function(module, exports) {

$parcel$export(module.exports, "useBasicEligibilityCriteriaCheck", () => $c6807effd0a03872$export$1e8e626d62656418);

var $2aY2d = parcelRequire("2aY2d");

var $8vyDv = parcelRequire("8vyDv");

var $bRJAs = parcelRequire("bRJAs");

var $a9ldn = parcelRequire("a9ldn");

var $ln6Iy = parcelRequire("ln6Iy");

var $lUto7 = parcelRequire("lUto7");

var $9HmCl = parcelRequire("9HmCl");
const $c6807effd0a03872$export$1e8e626d62656418 = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    const appEditions = (0, $8vyDv.useAppEditions)();
    const productEntitlementDetails = (0, $9HmCl.useProductEntitlementDetails)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const projectType = data?.projectType;
    const isEligibleProduct = projectType === (0, $ln6Iy.SOFTWARE_PROJECT) || projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT);
    const application = projectType ? (0, $bRJAs.getApplicationForProject)(projectType) : null;
    const edition = application ? (0, $a9ldn.getEdition)(application, appEditions) : null;
    const isStandard = edition === (0, $a9ldn.STANDARD_EDITION);
    const productKey = projectType && (0, $ln6Iy.projectTypeToCanonicalId)(projectType);
    const isNotInTrial = productKey && productEntitlementDetails && productEntitlementDetails[productKey]?.trialEndTime === undefined;
    const isEligible = Boolean(isSiteAdmin && isEligibleProduct && isStandard && isNotInTrial);
    const validProjectType = projectType && [
        'software',
        'service_desk'
    ].includes(projectType) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
     ? projectType : undefined;
    return {
        isEligible: isEligible,
        projectType: validProjectType
    };
};

});



parcelRegister("gsCE0", function(module, exports) {

$parcel$export(module.exports, "useCohort3CustomersBanner", () => $b50c7cca26c0f4af$export$9dd28ddfa301aa73);

var $eJOHy = parcelRequire("eJOHy");

var $lUto7 = parcelRequire("lUto7");

var $gZTP9 = parcelRequire("gZTP9");

var $8q7lT = parcelRequire("8q7lT");


var $5bM57 = parcelRequire("5bM57");
const $b50c7cca26c0f4af$export$9dd28ddfa301aa73 = ()=>{
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const accountId = (0, $8q7lT.useAccountId)();
    const { isDismissed: isDismissed, height: height } = (0, $5bM57.useCohort3CustomerBannerState)();
    const { fetchBannerVisibility: fetchBannerVisibility } = (0, $5bM57.useCohort3CustomerBannerActions)();
    (0, $eJOHy.useEffect)(()=>{
        if (!accountId) return;
        fetchBannerVisibility(accountId);
    }, [
        accountId,
        fetchBannerVisibility
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            isEnabled: Boolean((isAdmin || isSiteAdmin) && !isDismissed),
            name: (0, $225b7a1fbba60a47$export$7b746a9f691e0529),
            height: height
        }), [
        isAdmin,
        isSiteAdmin,
        isDismissed,
        height
    ]);
};

});
const $225b7a1fbba60a47$export$7b746a9f691e0529 = 'EOC-COHORT3-CONSOLIDATION-BANNER';
const $225b7a1fbba60a47$export$ed7cc0d417ee89e = 50;

parcelRegister("5bM57", function(module, exports) {

$parcel$export(module.exports, "useCohort3CustomerBannerState", () => $b6e4bc4e636e41a0$export$5c26fb28abd3eaaf);
$parcel$export(module.exports, "useCohort3CustomerBannerActions", () => $b6e4bc4e636e41a0$export$1935eaf1458de3aa);
/* eslint-disable jira/restricted/@atlassian/react-sweet-state */ 
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

var $1uIew = parcelRequire("1uIew");

const $b6e4bc4e636e41a0$export$d4c72bab9d6cc13a = {
    isDismissed: false,
    height: (0, $225b7a1fbba60a47$export$ed7cc0d417ee89e),
    isLoading: true
};
const $b6e4bc4e636e41a0$export$e324594224ef24da = {
    onDismiss: (accountId)=>async ({ setState: setState })=>{
            if (!accountId) {
                (0, $gYnSx.default)({
                    meta: {
                        id: 'onDismiss',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: new Error('Account id is not available'),
                    sendToPrivacyUnsafeSplunk: true
                });
                return;
            }
            try {
                await (0, $FppkK.setUserProperties)(accountId, (0, $225b7a1fbba60a47$export$7b746a9f691e0529), 'true');
                setState({
                    isDismissed: true
                });
            } catch (error) {
                setState({
                    isDismissed: true
                });
                (0, $gYnSx.default)({
                    meta: {
                        id: 'useCohort3CustomersBanner',
                        packageName: 'Cohort3CustomerBanner',
                        teamName: 'alexstrasza'
                    },
                    error: error instanceof Error ? error : new Error(String(error)),
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        },
    fetchBannerVisibility: (accountId)=>async ({ setState: setState })=>{
            if (!accountId) {
                (0, $gYnSx.default)({
                    meta: {
                        id: 'fetchBannerVisibility',
                        packageName: 'Cohort3CustomerBanner',
                        teamName: 'alexstrasza'
                    },
                    error: new Error('Account id is not available'),
                    sendToPrivacyUnsafeSplunk: true
                });
                return;
            }
            try {
                const value = await (0, $FppkK.getUserProperty)(accountId, (0, $225b7a1fbba60a47$export$7b746a9f691e0529));
                setState({
                    isDismissed: Boolean(value),
                    isLoading: false
                });
            } catch (error) {
                if (error instanceof (0, $1uIew.default) && (error.statusCode === 404 || error.statusCode === 403)) setState({
                    isLoading: false,
                    isDismissed: false
                });
            }
        }
};
const $b6e4bc4e636e41a0$var$Store = (0, $GtRbT.createStore)({
    name: 'Cohort3CustomerBannerStore',
    initialState: $b6e4bc4e636e41a0$export$d4c72bab9d6cc13a,
    actions: $b6e4bc4e636e41a0$export$e324594224ef24da
});
const $b6e4bc4e636e41a0$export$5c26fb28abd3eaaf = (0, $iJq0l.createStateHook)($b6e4bc4e636e41a0$var$Store);
const $b6e4bc4e636e41a0$export$1935eaf1458de3aa = (0, $iJq0l.createActionsHook)($b6e4bc4e636e41a0$var$Store);

});



parcelRegister("7mXaF", function(module, exports) {

$parcel$export(module.exports, "BannerAnnouncementAsync", () => $579735ab5635c514$export$aa03f7909e0828ec);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $579735ab5635c514$var$BannerAnnouncement = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("Yumo1")).then((module)=>module.BannerAnnouncement), {
    ssr: true,
    moduleId: "./src/packages/platform/ui/banners/announcement/src/ui/banner-v2/BannerAnnouncement.tsx"
});
const $579735ab5635c514$export$aa03f7909e0828ec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-platform-ui-banners-announcement",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($579735ab5635c514$var$BannerAnnouncement, null));

});
parcelRegister("Yumo1", function(module, exports) {

let $0b5d2796e6f8c074$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0b5d2796e6f8c074$var$load("utu6q").then(()=>parcelRequire('gBJum'));

});


parcelRegister("35T6Y", function(module, exports) {

$parcel$export(module.exports, "BannerTransitionAsync", () => $837d4f5a5fc37164$export$8bf182764b9d2eb8);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $837d4f5a5fc37164$var$BannerTransition = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("6f513")).then((module)=>module.BannerTransition), {
    moduleId: "./src/packages/platform/ui/banners/eoc-transition/src/ui/banner/index.tsx"
});
const $837d4f5a5fc37164$export$8bf182764b9d2eb8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-banner-eoc-transition",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($837d4f5a5fc37164$var$BannerTransition, null));

});
parcelRegister("6f513", function(module, exports) {

let $48b808dd7640ac17$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $48b808dd7640ac17$var$load("jFIrN").then(()=>parcelRequire('cgNt3'));

});


parcelRegister("2UuhW", function(module, exports) {

$parcel$export(module.exports, "MailExpiryBannerAsync", () => $1c954177add9c7b4$export$11a26ffa2d1b48ed);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $1c954177add9c7b4$var$LazyMailExpiryBanner = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("eI6J7")).then(({ MailExpiryReminder: MailExpiryReminder })=>MailExpiryReminder), {
    moduleId: "./src/packages/platform/ui/banners/mail-expiry-reminder/src/ui/view.tsx"
});
const $1c954177add9c7b4$export$11a26ffa2d1b48ed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "async-mail-expiry-banner",
        packageName: "jiraPlatformUiMailExpiryReminder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-mail-expiry-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c954177add9c7b4$var$LazyMailExpiryBanner, null)));

});
parcelRegister("eI6J7", function(module, exports) {

let $ab5a6484220b3b78$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ab5a6484220b3b78$var$load("PTAHI").then(()=>parcelRequire('8LFOm'));

});


parcelRegister("jMu4X", function(module, exports) {

$parcel$export(module.exports, "ReturnToMobileBanner", () => $8bba80be16bd93ae$export$81c4f1e869d5a87);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8bba80be16bd93ae$var$LazyReturnToMobileBanner = (0, $gzcjr.lazy)(()=>(parcelRequire("aArTP")).then(({ ReturnToMobileBanner: ReturnToMobileBanner })=>ReturnToMobileBanner), {
    moduleId: "./src/packages/platform/ui/return-to-mobile-banner/src/ReturnToMobileBanner.tsx"
});
const $8bba80be16bd93ae$export$81c4f1e869d5a87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-return-to-mobile-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8bba80be16bd93ae$var$LazyReturnToMobileBanner, null));

});
parcelRegister("aArTP", function(module, exports) {

let $7b52e8720b8e5759$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7b52e8720b8e5759$var$load("BaXAm").then(()=>parcelRequire('1neYb'));

});


parcelRegister("5fjeK", function(module, exports) {

$parcel$export(module.exports, "AsyncJpdPremiumOnboardingBanner", () => $cef6462fb70ba94b$export$bd441b93ed6c70f2);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $8CBsq = parcelRequire("8CBsq");

const $cef6462fb70ba94b$var$useEntrypoint = ()=>{
    const entryPointParams = (0, $eJOHy.useMemo)(()=>{
        return {};
    }, []);
    const hasLoadedEntrypoint = (0, $eJOHy.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $8CBsq.jpdPremiumOnboardingBannerEntryPoint), entryPointParams);
    if (!hasLoadedEntrypoint.current) {
        entryPointActions.load();
        hasLoadedEntrypoint.current = true;
    }
    return {
        entryPointReferenceSubject: entryPointReferenceSubject
    };
};
const $cef6462fb70ba94b$export$bd441b93ed6c70f2 = ()=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = $cef6462fb70ba94b$var$useEntrypoint();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: (0, $55277db52986c11b$export$a07dab5608229ea3),
        packageName: (0, $55277db52986c11b$export$b8b9d90f9e5bd72b),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {}
    });
};

});
parcelRegister("8CBsq", function(module, exports) {

$parcel$export(module.exports, "jpdPremiumOnboardingBannerEntryPoint", () => $8befe1b864ea7e9e$export$6bace03c2b9f4126);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $8befe1b864ea7e9e$export$6bace03c2b9f4126 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("dIabn")), {
        moduleId: "24b76c7f",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dIabn", function(module, exports) {

let $9fb7486eb5b30644$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9fb7486eb5b30644$var$load("2WXL2").then(()=>parcelRequire('ja2u9'));

});



parcelRegister("lxKFg", function(module, exports) {

$parcel$export(module.exports, "AutomationLimitAwarenessBannerAsync", () => $a2ee9750c044f1f5$export$4e92366fe348a487);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $7jTnu = parcelRequire("7jTnu");

const $a2ee9750c044f1f5$export$7fb60303fc5d9ba5 = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("fAgO6")).then((module)=>module.AutomationLimitAwarenessBanner), {
    ssr: true,
    moduleId: "./src/packages/growth/jira-standard-automation-limit-awareness-modal/src/ui/banner/banner.tsx"
});
const $a2ee9750c044f1f5$export$4e92366fe348a487 = ()=>{
    if ((0, $7jTnu.fg)('upsell_jira_global_automations_limit_banner_fg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-automation-limit-awareness-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a2ee9750c044f1f5$export$7fb60303fc5d9ba5, null));
};

});
parcelRegister("fAgO6", function(module, exports) {

let $b58741586699a00d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b58741586699a00d$var$load("4uThv").then(()=>parcelRequire('k7UXO'));

});


parcelRegister("khNDs", function(module, exports) {

$parcel$export(module.exports, "Cohort3BannerAsync", () => $544212cb5e12a371$export$c596c0a1bde2cc92);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $544212cb5e12a371$var$Cohort3Banner = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("ePEpi")).then((module)=>module.Cohort3CustomerBanner), {
    moduleId: "./src/packages/platform/ui/banners/eoc-cohort3-customers-banner/src/ui/banner/index.tsx"
});
const $544212cb5e12a371$export$c596c0a1bde2cc92 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-banner-eoc-cohort3-customers",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($544212cb5e12a371$var$Cohort3Banner, null));

});
parcelRegister("ePEpi", function(module, exports) {

let $acc52c1e886ab0c9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $acc52c1e886ab0c9$var$load("88qqS").then(()=>parcelRequire('5ACVQ'));

});


parcelRegister("kxYB3", function(module, exports) {

$parcel$export(module.exports, "ZIndexWrapper", () => $f4a445f5bc0608f3$export$6bdda512681a5774);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $f4a445f5bc0608f3$export$6bdda512681a5774 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, top: top, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w6mvmh": (0, $awdRS.default)(__cmplp.zIndex),
            "--_1vj9tq": (0, $awdRS.default)(__cmplp.top)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1pby1fcb _kqswh2mm _154i1ter",
            __cmplp.className
        ])
    });
});

});



parcelRegister("ltfhl", function(module, exports) {

$parcel$export(module.exports, "GlobalComponents", () => $f67b539b3f61d14e$export$461c2ed3163c74ff);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $286cZ = parcelRequire("286cZ");

var $7jTnu = parcelRequire("7jTnu");

var $1KdDN = parcelRequire("1KdDN");

var $EzBXZ = parcelRequire("EzBXZ");


var $hih5V = parcelRequire("hih5V");

var $6dwgv = parcelRequire("6dwgv");

var $dydef = parcelRequire("dydef");

var $4Oene = parcelRequire("4Oene");
const $f67b539b3f61d14e$var$routeComponents = [];
const $f67b539b3f61d14e$var$RouteGlobalComponents = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $6dwgv.renderGlobalComponents)(route.layout?.globalComponents || $f67b539b3f61d14e$var$routeComponents));
};
// This component is necessary to ensure that the error boundary picks up errors in the renderGlobalComponents function
const $f67b539b3f61d14e$var$SharedGlobalComponents = ({ sharedGlobalComponents: sharedGlobalComponents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $6dwgv.renderGlobalComponents)(sharedGlobalComponents));
const $f67b539b3f61d14e$var$GlobalComponentsInternal = ({ sharedGlobalComponents: sharedGlobalComponents })=>{
    const globalComponentsPerformanceTiming = (0, $eJOHy.useCallback)(()=>{
        (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)((0, $60d311439a302207$export$fb9876ab4228d985), (0, $60d311439a302207$export$c20831be6f780cb5), (0, $60d311439a302207$export$398df1bca49f9884), true, true);
    }, []);
    /**
	 * !!! DO NOT ADD INDIVIDUAL COMPONENTS TO THIS FILE !!!
	 *
	 * They should be defined as part of the `sharedGlobalComponents` constant, or defined on the route
	 * definition `layout` key.
	 *
	 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/platform/ui/layouts/jira-shared-layout/README.md
	 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/platform/ui/layouts/README.md
	 */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$c20831be6f780cb5)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $EzBXZ.RenderOnClient), {
        fg: "jfp_magma_jira-render-on-client-batch-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "shared-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f67b539b3f61d14e$var$SharedGlobalComponents, {
        sharedGlobalComponents: sharedGlobalComponents
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "route-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "route-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f67b539b3f61d14e$var$RouteGlobalComponents, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$398df1bca49f9884),
        onSet: globalComponentsPerformanceTiming
    }));
};
const $f67b539b3f61d14e$export$461c2ed3163c74ff = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp_magma_shared-component-perf-1'), $f67b539b3f61d14e$var$GlobalComponentsInternal);

});
parcelRegister("4Oene", function(module, exports) {

$parcel$export(module.exports, "default", () => $18f4020e0393d087$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cv2et = parcelRequire("cv2et");

var $diF0M = parcelRequire("diF0M");

var $25NU0 = parcelRequire("25NU0");
const $18f4020e0393d087$var$newContextWithUfoContext = (context, interactionContext)=>context && interactionContext && {
        ...context,
        getInteractionContext: ()=>interactionContext
    };
const $18f4020e0393d087$var$flowRight = (functionList)=>(arg)=>functionList.reduceRight((acc, fn)=>fn(acc), arg);
const $18f4020e0393d087$var$renderContextProviderIfNonNull = (Context, contextValue)=>(node)=>contextValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Context.Provider, {
            value: contextValue
        }, node) : node;
function $18f4020e0393d087$var$JiraUFOLabelWrapper({ children: children }) {
    const context = (0, $cv2et.useInteractionContext)();
    const rllProfilerContext = (0, $eJOHy.useContext)((0, $25NU0.ProfilerContext));
    const relayProfilerContext = (0, $eJOHy.useContext)((0, $j4oe4.ProfilerContext));
    const newRllProfilerContext = (0, $eJOHy.useMemo)(()=>({
            current: $18f4020e0393d087$var$newContextWithUfoContext(rllProfilerContext?.current, context)
        }), [
        context,
        rllProfilerContext
    ]);
    const newRelayProfilerContext = (0, $eJOHy.useMemo)(()=>$18f4020e0393d087$var$newContextWithUfoContext(relayProfilerContext, context), [
        context,
        relayProfilerContext
    ]);
    // Produces the following but only renders a provider if its context is not null
    // <RelayProfilerContext.Provider ...>
    //   <RLLProfilerContext.Provider ...>
    //     {children}
    //   </...etc
    return $18f4020e0393d087$var$flowRight([
        $18f4020e0393d087$var$renderContextProviderIfNonNull((0, $j4oe4.ProfilerContext), newRelayProfilerContext),
        $18f4020e0393d087$var$renderContextProviderIfNonNull((0, $25NU0.ProfilerContext), newRllProfilerContext)
    ])(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children));
}
function $18f4020e0393d087$export$2e2bcd8739ae039({ name: name, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diF0M.default), {
        name: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($18f4020e0393d087$var$JiraUFOLabelWrapper, null, children));
}

});
parcelRegister("diF0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fc0fc77444cbbcb$export$2e2bcd8739ae039);

var $6lqNe = parcelRequire("6lqNe");
var $3fc0fc77444cbbcb$export$2e2bcd8739ae039 = (0, $6lqNe.default);

});
parcelRegister("6lqNe", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b7e425139537eef$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cv2et = parcelRequire("cv2et");
function $9b7e425139537eef$export$2e2bcd8739ae039({ name: name, children: children }) {
    const context = (0, $cv2et.useInteractionContext)();
    const newContext = (0, $eJOHy.useMemo)(()=>{
        if (context) return {
            ...context,
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [
                ...context.labelStack,
                {
                    name: name
                }
            ]
        };
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cv2et.default).Provider, {
        value: newContext,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
}

});




parcelRegister("DrDtQ", function(module, exports) {

$parcel$export(module.exports, "GlobalContainers", () => $5db94805500b593d$export$3b677a7048d7ae0);

var $eJOHy = parcelRequire("eJOHy");

var $lot2g = parcelRequire("lot2g");

var $286cZ = parcelRequire("286cZ");

var $7jTnu = parcelRequire("7jTnu");

var $2I68T = parcelRequire("2I68T");

var $fakPW = parcelRequire("fakPW");

var $eK5AI = parcelRequire("eK5AI");

var $7lk3V = parcelRequire("7lk3V");

var $hWeHP = parcelRequire("hWeHP");

var $cbCSE = parcelRequire("cbCSE");

var $6zXPf = parcelRequire("6zXPf");


var $fEmyV = parcelRequire("fEmyV");

var $1gHmu = parcelRequire("1gHmu");

var $7lboZ = parcelRequire("7lboZ");

var $5HFSX = parcelRequire("5HFSX");

var $g9Vr6 = parcelRequire("g9Vr6");

var $dydef = parcelRequire("dydef");

var $lvKO5 = parcelRequire("lvKO5");

var $6bLlX = parcelRequire("6bLlX");

var $bJscI = parcelRequire("bJscI");

var $aoTms = parcelRequire("aoTms");

var $gzwmK = parcelRequire("gzwmK");

var $5PTRS = parcelRequire("5PTRS");

var $bea4o = parcelRequire("bea4o");

var $jFTjK = parcelRequire("jFTjK");

var $bDTmj = parcelRequire("bDTmj");

var $hxAu9 = parcelRequire("hxAu9");

var $2pOx9 = parcelRequire("2pOx9");

var $gOC9D = parcelRequire("gOC9D");
const $5db94805500b593d$var$MaybePreviewPanelsProvider = (0, $bJscI.componentWithFG)('jira-glance-panel', (0, $6bLlX.PreviewPanelsProvider), (0, $eJOHy.Fragment));
const $5db94805500b593d$var$EventHorizon = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp_magma_shared-component-perf-1'), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children));
/**
 * Serves as the foundational component orchestrating the integration of internationalization,
 * analytics, performance monitoring, and feature-flag based conditional rendering. It ensures a consistent
 * application structure and style setup, facilitating performance tracking and user experience improvements.
 */ const $5db94805500b593d$var$GlobalContainersInternal = ({ id: id, children: children, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
    const globalContainersPerformanceTiming = (0, $eJOHy.useCallback)(()=>{
        (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)((0, $60d311439a302207$export$4f341d86a3c214), (0, $60d311439a302207$export$16e7ead3a8b5c366), (0, $60d311439a302207$export$c389f0b50840d5ca), true, true);
        (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)((0, $60d311439a302207$export$7048c99f32c60b34), (0, $60d311439a302207$export$3c2d8af5c7577fe7), (0, $60d311439a302207$export$aac77afee74c49d0), true, true);
    }, []);
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const MonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: `
                        body#jira {
                            overflow-x: hidden;
                            overflow-y: auto;
                        }

                        #jira-frontend {
                            background: ${"var(--ds-surface, #FFFFFF)"};
                        }

                        #jira_request_timing_info {
                            margin: 0;
                        }
                    `
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5PTRS.IntlProviders), {
        messages: messages,
        locale: locale
    }, __SPA__ && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvKO5.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $hWeHP.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2I68T.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7lk3V.default), {
        orgId: orgId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fakPW.ViewExperienceTrackingProvider), {
        analyticsSource: (0, $60d311439a302207$export$c9e16a15d65437),
        experience: (0, $60d311439a302207$export$b1534bc11f201efd),
        experienceId: (0, $60d311439a302207$export$fa4bbc89fd1f1a7),
        application: (0, $60d311439a302207$export$aa6008fe0169b864),
        edition: (0, $60d311439a302207$export$39418a21fbb51487),
        additionalAttributes: (0, $fEmyV.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gzwmK.ErrorBoundary), {
        id: id,
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$16e7ead3a8b5c366)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Router, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lot2g.default), {
        UNSAFE_isThemingDisabled: true,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$c389f0b50840d5ca)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bDTmj.PageConfigContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bea4o.MetricsContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5HFSX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jFTjK.NavigationContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2pOx9.UserContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hxAu9.UiManagers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$3c2d8af5c7577fe7)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1gHmu.PostOfficeRouterListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5db94805500b593d$var$MaybePreviewPanelsProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gOC9D.LinkingProviders), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aoTms.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: (0, $60d311439a302207$export$aac77afee74c49d0),
        onSet: globalContainersPerformanceTiming
    }), (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cbCSE.SidebarNav4ControllerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5db94805500b593d$var$EventHorizon, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5db94805500b593d$var$EventHorizon, null, children))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7lboZ.ScreenSpaceFlagsPlacement), null)))))))))))))));
};
const $5db94805500b593d$export$3b677a7048d7ae0 = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp_magma_shared-component-perf-1'), $5db94805500b593d$var$GlobalContainersInternal);

});
parcelRegister("lot2g", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e04db9add5caefe$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gJfLm = parcelRequire("gJfLm");

var $dOd8C = parcelRequire("dOd8C");
const $0e04db9add5caefe$var$InsideAppProviderContext = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function $0e04db9add5caefe$var$AppProvider({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
    const isInsideAppProvider = (0, $eJOHy.useContext)($0e04db9add5caefe$var$InsideAppProviderContext);
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    const routerLinkProvider = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gJfLm.default), {
        routerLinkComponent: routerLinkComponent,
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($0e04db9add5caefe$var$InsideAppProviderContext.Provider, {
        value: true,
        children: UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dOd8C.default), {
            defaultColorMode: defaultColorMode,
            defaultTheme: defaultTheme,
            children: routerLinkProvider
        })
    });
}
var $0e04db9add5caefe$export$2e2bcd8739ae039 = $0e04db9add5caefe$var$AppProvider;

});

parcelRegister("fakPW", function(module, exports) {

$parcel$export(module.exports, "ViewExperienceTrackingProvider", () => $60f4a864d45647c7$export$a5efa46877be148f);
$parcel$export(module.exports, "SubExperienceTrackingProvider", () => $60f4a864d45647c7$export$e0241c84ce5db240);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $6DllT = parcelRequire("6DllT");

var $1cD2y = parcelRequire("1cD2y");

var $04GBe = parcelRequire("04GBe");
const $60f4a864d45647c7$export$a5efa46877be148f = ({ isExperienceReady: isExperienceReady, experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes, children: children })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $04GBe.default), {
        isExperienceReady: isExperienceReady,
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: additionalAttributes
    }, children);
$60f4a864d45647c7$export$a5efa46877be148f.defaultProps = {
    isExperienceReady: true,
    experienceId: null,
    additionalAttributes: {}
};
var $60f4a864d45647c7$export$2e2bcd8739ae039 = $60f4a864d45647c7$export$a5efa46877be148f;
const $60f4a864d45647c7$export$e0241c84ce5db240 = ({ children: children, location: location, parentProviders: parentProviders })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : // DO NOT use `useContext` or `static contextType = ...` to consume this context
    // as the tree walker used in SSR does not support hooks
    // and SSR does not support `static contextType` setting
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6DllT.default).Consumer, null, (context)=>{
        if (context == null) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('experience-sub-provider.missing-provider', 'Experience sub-provider rendered without a parent provider');
            return children;
        }
        const { experienceId: experienceId } = context;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cD2y.ExperienceTracker), {
            location: location,
            parentProviders: parentProviders
        }, (trackerCallbacks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $04GBe.default), {
                parentTrackerCallbacks: trackerCallbacks,
                experience: location,
                experienceId: experienceId,
                analyticsSource: null,
                application: null,
                edition: null,
                isExperienceReady: true
            }, children));
    });
$60f4a864d45647c7$export$e0241c84ce5db240.defaultProps = {
    parentProviders: null
};

});
parcelRegister("04GBe", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fd0a0af92633c2f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $mjinE = parcelRequire("mjinE");


var $6DllT = parcelRequire("6DllT");
class $1fd0a0af92633c2f$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            parentTrackerCallbacks: null,
            additionalAttributes: {}
        };
    }
    constructor(props){
        super(props), this.onPending = ()=>{
            this.pendingCount += 1;
            this.shouldTrackExperience = true;
            this.checkAndStartTimer();
        }, this.onSuccess = ()=>{
            this.pendingCount -= 1;
            this.checkAndStartTimer();
        }, this.onFailure = (location, additionalAttributes)=>{
            // We need to track failure *immediately*, otherwise this component may
            // be unmounted and we'd miss our chance.
            this.trackExperience({
                wasExperienceSuccesful: false,
                location: location,
                additionalAttributes: additionalAttributes
            });
        }, this.onAbort = (location, additionalAttributes)=>{
            this.trackExperience({
                wasExperienceSuccesful: false,
                action: (0, $f17fa9e5c82da056$export$aeeb00d0845d24d8),
                location: location,
                additionalAttributes: additionalAttributes
            });
        };
        this.resetExperience();
    }
    componentDidMount() {
        this.checkAndStartTimer();
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
    }
    componentDidCatch(error) {
        // This catches any errors that bubble up to the Provider that
        // may not be caught by any ExperienceTrackers
        this.trackExperience({
            wasExperienceSuccesful: false,
            location: 'error-reached-provider',
            additionalAttributes: {
                errorMessage: error.message,
                errorName: error.name,
                ...this.props?.additionalAttributes
            }
        });
        // We're deliberately rethrowing the error here because we don't want to interfere with
        // any error handling the container app may have in place.
        throw error;
    }
    componentWillUnmount() {
        clearTimeout(this.timerId);
    }
    checkAndStartTimer() {
        if (this.shouldTrackExperience && this.props.isExperienceReady) this.startTimer();
    }
    startTimer() {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(()=>{
            if (this.pendingCount === 0) this.trackExperience({
                wasExperienceSuccesful: true
            });
        }, 1000);
    }
    // Resetting must not call setState since this can be executed in the render phase
    resetExperience() {
        clearTimeout(this.timerId);
        this.timerId = undefined;
        this.shouldTrackExperience = false;
        this.hasTrackedExperience = false;
        this.pendingCount = 0;
        this.memoizedContext = {
            consumerCallbacks: {
                onPending: this.onPending,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure,
                onAbort: this.onAbort
            },
            experienceId: this.props.experienceId,
            experience: this.props.experience
        };
    }
    trackExperience({ wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, additionalAttributes: additionalAttributes }) {
        if (this.hasTrackedExperience) // We only ever want to send a single success/failure event for an experience
        return;
        this.hasTrackedExperience = true;
        const { parentTrackerCallbacks: parentTrackerCallbacks, additionalAttributes: additionalAttributesFromProps } = this.props;
        if (parentTrackerCallbacks) {
            if (wasExperienceSuccesful) parentTrackerCallbacks.onExperienceSuccess();
            else parentTrackerCallbacks.onExperienceFailure(location, {
                ...additionalAttributesFromProps,
                ...additionalAttributes
            });
        } else {
            const { experience: experience } = this.memoizedContext;
            const { analyticsSource: analyticsSource, application: application, edition: edition } = this.props;
            analyticsSource && (0, $mjinE.default)({
                experience: experience,
                action: action,
                wasExperienceSuccesful: wasExperienceSuccesful,
                location: location,
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: {
                    ...additionalAttributesFromProps,
                    ...additionalAttributes
                }
            });
        }
    }
    // Check every render to reset the experience state instance variables
    checkExperienceIdForExperienceReset() {
        if (this.memoizedContext.experienceId !== this.props.experienceId) this.resetExperience();
    }
    render() {
        this.checkExperienceIdForExperienceReset();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6DllT.default).Provider, {
            value: this.memoizedContext
        }, this.props.children);
    }
}

});
const $f17fa9e5c82da056$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $f17fa9e5c82da056$export$b48b3d1872522384 = 'taskFail';
const $f17fa9e5c82da056$export$aeeb00d0845d24d8 = 'taskAbort';



parcelRegister("7lboZ", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceFlagsPlacement", () => $97dcf5616e9373e4$export$f6564e60882bdf90);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $jMTnD = parcelRequire("jMTnD");

var $7jTnu = parcelRequire("7jTnu");

var $bILK0 = parcelRequire("bILK0");

var $7oY9g = parcelRequire("7oY9g");

var $9I7ft = parcelRequire("9I7ft");

var $kv6e6 = parcelRequire("kv6e6");

const $97dcf5616e9373e4$var$PLACEMENT_ID = 'screen-space-flags';
const $97dcf5616e9373e4$export$f6564e60882bdf90 = ()=>{
    const flagsService = (0, $7jTnu.fg)('inject_jira_feature_flags_service_into_post_office') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $bILK0.useFlagsService)() : {
        dismissFlag: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        hasFlag: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        showFlag: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    };
    const stablePlacementProps = (0, $eJOHy.useMemo)(()=>({
            jiraFlagsService: {
                dismissFlag: flagsService.dismissFlag,
                hasFlag: flagsService.hasFlag,
                showFlag: flagsService.showFlag
            }
        }), [
        flagsService?.dismissFlag,
        flagsService?.hasFlag,
        flagsService?.showFlag
    ]);
    return !false && !(0, $7oY9g.default)((0, $c335d71b7e366e9d$export$37d4bb5bc0e315db)) && (0, $7jTnu.fg)('post-office-screen-space-overlay-jfe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kv6e6.ScreenSpaceFlagPlacementPreviewSwitcher), {
        // https://switcheroo.atlassian.com/ui/gates/8fe500fb-6c32-48c7-be3f-caf511e97a8e/key/post-office_enable_screen-space-preview_jfe
        isEnabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9I7ft.default), {
        placementId: $97dcf5616e9373e4$var$PLACEMENT_ID,
        PlacementComponent: (0, $jMTnD.default),
        disableInitialData: true,
        ...(0, $7jTnu.fg)('inject_jira_feature_flags_service_into_post_office') ? {
            placementProps: stablePlacementProps
        } : undefined
    })) : null;
};

});
parcelRegister("jMTnD", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceFlagsPlacementComponent", () => $0676b105c67a9731$export$c60b43809441c5b0);
$parcel$export(module.exports, "default", () => $0676b105c67a9731$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $21HMC = parcelRequire("21HMC");

var $aCSH2 = parcelRequire("aCSH2");
var $gFu5h = parcelRequire("gFu5h");

var $e0Nss = parcelRequire("e0Nss");

var $3o8lc = parcelRequire("3o8lc");

var $7IIUN = parcelRequire("7IIUN");

var $5H93L = parcelRequire("5H93L");

var $9OKmd = parcelRequire("9OKmd");

var $btb4b = parcelRequire("btb4b");

var $1G9dl = parcelRequire("1G9dl");


var $6cGp0 = parcelRequire("6cGp0");
const $0676b105c67a9731$export$c32237a999261c49 = (input)=>(0, $aCSH2.createMatchScopes)({
        scopes: $btb4b.scopes
    })(input);
const $0676b105c67a9731$export$c60b43809441c5b0 = (0, $6cGp0.withScreenSpaceFlagsIntlProvider)((0, $3o8lc.createPlacementComponent)((0, $4208604c26752028$export$a5cfae247d8360ef), /*#__PURE__*/ (0, $eJOHy.memo)(({ initialData: initialData, preloadedInitialData: preloadedInitialData, setPreloadedInitialData: setPreloadedInitialData, jiraFlagsService: jiraFlagsService, reportExpectedError: reportExpectedError, reportUnexpectedError: reportUnexpectedError })=>{
    const [localMessageState, setLocalMessageState] = (0, $eJOHy.useState)(()=>{
        if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? preloadedInitialData?.messages : undefined;
        return undefined;
    });
    (0, $5H93L.useInitialData)(initialData);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $gFu5h.useMessagePlacementHooks)();
    const handleDismiss = (0, $eJOHy.useCallback)(({ messageInstanceId: messageInstanceId })=>{
        setLocalMessageState((current)=>{
            if (current) {
                const newState = current.filter((e)=>e.messageInstanceId !== messageInstanceId);
                if (typeof setPreloadedInitialData === 'function') setPreloadedInitialData({
                    messages: newState
                });
                return newState;
            }
            return undefined;
        });
    }, [
        setPreloadedInitialData
    ]);
    const onDismissed = (0, $eJOHy.useCallback)(()=>{
        setLocalMessageState([]);
        if (typeof setPreloadedInitialData === 'function') setPreloadedInitialData({
            messages: []
        });
    }, [
        setPreloadedInitialData
    ]);
    (0, $eJOHy.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss
    ]);
    (0, $eJOHy.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked
    ]);
    (0, $eJOHy.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze
    ]);
    const activeScopes = (0, $aCSH2.usePostOfficeContextScope)({
        scopes: $btb4b.scopes
    });
    const messagesState = (0, $9OKmd.usePlacementApi)('/update-messages', {
        queryParams: {
            updateKey: activeScopes.updateKey ?? ''
        },
        requestOptions: {
            method: 'POST',
            body: JSON.stringify(activeScopes)
        },
        throttleTime: 100,
        autoRefetch: {
            isEnabled: !!activeScopes.updateKey && typeof localMessageState === 'undefined',
            updateKey: activeScopes.updateKey ?? ''
        }
    });
    (0, $eJOHy.useEffect)(()=>{
        if (messagesState?.data?.messages?.length) setLocalMessageState(messagesState.data.messages);
    }, [
        messagesState.data
    ]);
    return (0, $21HMC.default).checkGate('post-office-screen-space-flags-shadow') ? /*#__PURE__*/ (0, $gt9Am.jsx)($0676b105c67a9731$var$SuppressIfModalIsPresent, {
        children: localMessageState?.slice(0, 1).map(({ messageInstanceId: messageInstanceId, ...props })=>// Adding @ts-ingore to suppress the error in confluence typecheck and below error is not thrown in post-office typecheck
            // This error exists because confluence is using react 16 and post-office is using react 18
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - 'ReactNode | ReactElement<any, any>' is not a valid JSX element.
            /*#__PURE__*/ (0, $eJOHy.createElement)((0, $1G9dl.MessageRenderer), {
                ...props,
                key: messageInstanceId,
                id: messageInstanceId,
                messageInstanceId: messageInstanceId,
                onDismissed: onDismissed,
                SuspenseBoundary: (0, $7IIUN.MaybeSuspenseBoundary),
                jiraFlagsService: jiraFlagsService,
                onError: reportUnexpectedError,
                reportExpectedError: reportExpectedError
            }))
    }) : null;
}), {
    choreographer: {
        isDefaultEnabled: true
    }
}));
var $0676b105c67a9731$export$2e2bcd8739ae039 = $0676b105c67a9731$export$c60b43809441c5b0;
const $0676b105c67a9731$var$SuppressIfModalIsPresent = ({ children: children })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $e0Nss.useFirePostOfficeAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, $eJOHy.useState)(true);
    const handleVisibilityChange = (0, $eJOHy.useCallback)((modalOnScreen)=>{
        const shouldShow = !modalOnScreen;
        if (!shouldShow) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'suppressed',
            actionSubject: 'screenSpaceFlags'
        });
        setIsVisible(shouldShow);
    }, [
        fireAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const modalOnScreen = !!globalThis.document.querySelector('.atlaskit-portal-container .atlaskit-portal [role=dialog]');
        handleVisibilityChange(modalOnScreen);
    }, [
        handleVisibilityChange
    ]);
    return (0, $21HMC.default).checkGate('post-office-screen-space-flags-modal-detector') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: isVisible && children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});
parcelRegister("aCSH2", function(module, exports) {

$parcel$export(module.exports, "usePostOfficeContextScope", () => $5a8e3842b71c6030$export$daf66a67c26dc848);
$parcel$export(module.exports, "createMatchScopes", () => $5a8e3842b71c6030$export$ec890b48cae4cc1c);

var $eJOHy = parcelRequire("eJOHy");

var $bruOW = parcelRequire("bruOW");

var $5ZQPg = parcelRequire("5ZQPg");

var $l2WwY = parcelRequire("l2WwY");

var $gcT3Q = parcelRequire("gcT3Q");
const $5a8e3842b71c6030$export$daf66a67c26dc848 = (config)=>{
    const scopeNames = $5a8e3842b71c6030$var$scopesNamesAsString(config.scopes);
    const matchScopes = (0, $eJOHy.useCallback)((input)=>$5a8e3842b71c6030$export$ec890b48cae4cc1c(config)(input), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        scopeNames
    ]);
    const [state, setState] = (0, $eJOHy.useState)($5a8e3842b71c6030$var$initialState);
    const route = (0, $l2WwY.usePostOfficeRoute)();
    const context = (0, $5ZQPg.usePostOfficeContext)();
    const next = matchScopes({
        route: route,
        context: context
    });
    $5a8e3842b71c6030$var$usePostOfficeScopeSpy(state, config);
    (0, $eJOHy.useEffect)(()=>{
        if ($5a8e3842b71c6030$export$fcc046cb16c47539({
            next: next,
            state: state
        })) setState(({ current: current })=>({
                updateKey: Math.random().toString(36).substring(2),
                current: next,
                previous: current
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $5a8e3842b71c6030$var$scopesNamesAsString(next)
    ]);
    return state;
};
const $5a8e3842b71c6030$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
const $5a8e3842b71c6030$var$initialState = {
    updateKey: undefined,
    current: [],
    previous: []
};
const $5a8e3842b71c6030$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
        const contextMatch = route ? 'pathname' in route ? {
            route: route,
            context: context
        } : route.current ? {
            route: $5a8e3842b71c6030$var$extractRelevantUrlFields(route.current),
            context: context
        } : {
            route: undefined,
            context: context
        } : {
            route: undefined,
            context: context
        };
        const inputMatch = input.when;
        return $5a8e3842b71c6030$export$5c1cef6f5f213829({
            contextMatch: contextMatch,
            inputMatch: inputMatch
        });
    };
const $5a8e3842b71c6030$var$extractRelevantUrlFields = (route)=>{
    const { hostname: hostname, pathname: pathname, search: search } = new URL(route);
    return {
        hostname: hostname,
        pathname: pathname,
        search: search
    };
};
const $5a8e3842b71c6030$export$5c1cef6f5f213829 = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, (/*@__PURE__*/$parcel$interopDefault($bruOW)))(contextMatch, inputMatch, (contextValue, inputValue)=>$5a8e3842b71c6030$var$isValueMatchDeep({
            contextValue: contextValue,
            inputValue: inputValue
        }));
const $5a8e3842b71c6030$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
    if (!contextValue || !inputValue) return false;
    if (typeof inputValue === 'string') return contextValue === inputValue;
    if (inputValue?.equals) return contextValue === inputValue.equals;
    if (!inputValue?.matches) return false;
    if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
    return new RegExp(inputValue.matches).test(contextValue);
};
const $5a8e3842b71c6030$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $5a8e3842b71c6030$export$5c1cef6f5f213829({
        contextMatch: contextValue,
        inputMatch: inputValue
    }) : $5a8e3842b71c6030$var$isValueMatch({
        contextValue: contextValue,
        inputValue: inputValue
    });
const $5a8e3842b71c6030$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($5a8e3842b71c6030$var$createMatchScope(input)).map((scope)=>({
                name: scope.name
            }));
const $5a8e3842b71c6030$export$fcc046cb16c47539 = ({ next: next, state: state })=>{
    const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
    const nextSet = Array.from(new Set(next.map((e)=>e.name)));
    if (nextSet.length !== currentSet.length) return true;
    return !nextSet.every((e)=>currentSet.includes(e));
};
// Scope Spy
const $5a8e3842b71c6030$var$usePostOfficeScopeSpy = (state, config)=>{
    if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
        const [listen, update] = (0, $gcT3Q.createSimplePubSub)();
        window.postOffice = {
            ...window.postOffice,
            scopes: {
                [config?.consoleSpy.name]: {
                    listen: listen,
                    update: update,
                    list: config.scopes
                }
            }
        };
    }
    (0, $eJOHy.useEffect)(()=>{
        if (!config?.consoleSpy) return;
        if (!window.postOffice?.scopes) return;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $5a8e3842b71c6030$var$scopesNamesAsString(state.current)
    ]);
};

});
parcelRegister("bruOW", function(module, exports) {

var $8KEeP = parcelRequire("8KEeP");

var $kMuiR = parcelRequire("kMuiR");
/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */ function $854a1facb4ffc478$var$isMatchWith(object, source, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $8KEeP(object, source, $kMuiR(source), customizer);
}
module.exports = $854a1facb4ffc478$var$isMatchWith;

});


parcelRegister("9OKmd", function(module, exports) {

$parcel$export(module.exports, "usePlacementApi", () => $7cb92c9867a342fa$export$201bbce8187a6e3c);

var $5ZQPg = parcelRequire("5ZQPg");

var $agxmR = parcelRequire("agxmR");

var $iqAhj = parcelRequire("iqAhj");

var $gr1uu = parcelRequire("gr1uu");

var $eJOHy = parcelRequire("eJOHy");
const $7cb92c9867a342fa$export$201bbce8187a6e3c = (path, config)=>{
    const { placementId: placementId } = (0, $iqAhj.usePlacementContext)();
    const context = (0, $5ZQPg.usePostOfficeContext)();
    const fetcher = (0, $agxmR.usePlacementFetchingContext)();
    const placementApi = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (!placementId) return ()=>({
                isLoading: false,
                data: undefined,
                error: new Error('No placementId found, make this is used as a child of PlacementProvider')
            });
        return (0, $gr1uu.createUsePlacement)(placementId, fetcher);
    }, [
        placementId,
        fetcher
    ]);
    const { queryParams: queryParams = {} } = config ?? {};
    const placementParams = {
        ...context,
        ...queryParams
    };
    return placementApi(path, placementParams, config?.requestOptions, {
        throttleTime: config?.throttleTime,
        isEnabled: config?.autoRefetch?.isEnabled,
        deps: [
            config?.autoRefetch?.updateKey
        ]
    });
};

});
parcelRegister("gr1uu", function(module, exports) {

$parcel$export(module.exports, "createUsePlacement", () => $b7b1c38dce8603d7$export$ee1d67e435d25cb5);

var $cp0sJ = parcelRequire("cp0sJ");

var $eJOHy = parcelRequire("eJOHy");

var $fUF6P = parcelRequire("fUF6P");
const $b7b1c38dce8603d7$var$depsIsValid = (deps)=>Array.isArray(deps);
const $b7b1c38dce8603d7$export$ee1d67e435d25cb5 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const dependencyList = $b7b1c38dce8603d7$var$depsIsValid(config?.deps) ? [
            ...config.deps,
            config?.isEnabled
        ] : [
            path,
            config?.isEnabled
        ];
        const timerRef = (0, $eJOHy.useRef)();
        const isRunningPromise = (0, $eJOHy.useRef)(false);
        (0, $eJOHy.useEffect)(()=>{
            return ()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            };
        }, []);
        const promiseToResolve = (0, $eJOHy.useMemo)(()=>{
            if (config?.isEnabled === false) return undefined;
            return ({ signal: signal })=>{
                if (isRunningPromise.current) return Promise.reject(new (0, $fUF6P.AlreadyRunningError)());
                isRunningPromise.current = true;
                timerRef.current = setTimeout(()=>{
                    isRunningPromise.current = false;
                }, config?.throttleTime ?? 0);
                return (0, $cp0sJ.fetchPlacementData)(placementId, path, context, fetcher, {
                    ...requestOptions,
                    signal: signal
                });
            };
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        dependencyList);
        return (0, $fUF6P.useData)(promiseToResolve, {
            analytics: {
                name: placementId,
                path: path
            }
        });
    };
};

});
parcelRegister("cp0sJ", function(module, exports) {

$parcel$export(module.exports, "fetchPlacementData", () => $cf01a95b31ec57c5$export$ce743d02f83ee521);
const $cf01a95b31ec57c5$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $cf01a95b31ec57c5$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $cf01a95b31ec57c5$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$cf01a95b31ec57c5$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $cf01a95b31ec57c5$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
    const defaultHeaders = {
        credentials: 'include',
        mode: 'cors',
        'Content-Type': 'application/json'
    };
    const normalizedPath = path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const contextAsSearchParams = new URLSearchParams($cf01a95b31ec57c5$var$stringifyObjectValues(context)).toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$cf01a95b31ec57c5$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return fetcher.fetch(url, {
        ...requestOptions,
        headers: {
            ...defaultHeaders,
            ...requestOptions?.headers
        }
    });
};

});



parcelRegister("btb4b", function(module, exports) {

$parcel$export(module.exports, "scopes", () => $595dab0647de652e$export$54a06e3f4a159ad8);
const $595dab0647de652e$export$54a06e3f4a159ad8 = [
    {
        name: 'all',
        when: {
            route: {
                pathname: {
                    matches: '.*'
                }
            }
        }
    },
    {
        name: 'admin/all',
        when: {
            context: {
                product: 'admin'
            }
        }
    },
    {
        name: 'admin/products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'products'
                }
            }
        }
    },
    {
        name: 'admin/discovered-products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'discovered-products'
                }
            }
        }
    },
    {
        name: 'admin/domains',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'domains'
                }
            }
        }
    },
    {
        name: 'admin/user-access-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-access-settings'
                }
            }
        }
    },
    {
        name: 'admin/authentication-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'authentication-policies'
                }
            }
        }
    },
    {
        name: 'admin/users',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'users'
                }
            }
        }
    },
    {
        name: 'admin/audit-log',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'audit-log'
                }
            }
        }
    },
    {
        name: 'admin/billing-preview',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'billing-preview'
                }
            }
        }
    },
    {
        name: 'admin/data-security-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'data-security-policies'
                }
            }
        }
    },
    {
        name: 'jira/all',
        when: {
            context: {
                product: 'jira'
            }
        }
    },
    {
        name: 'jira/kanban',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'board'
                }
            }
        }
    },
    {
        name: 'confluence/all',
        when: {
            context: {
                product: 'confluence'
            }
        }
    },
    {
        name: 'confluence/wiki-home',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/home'
                }
            }
        }
    },
    {
        name: 'confluence/pages-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/pages/(?!edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'confluence/blogs-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/blog/(?!edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'confluence/pages',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/pages/.*'
                }
            }
        }
    },
    {
        name: 'confluence/wiki-space-settings',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.+?/settings(/.*)?$'
                }
            }
        }
    },
    {
        name: 'confluence/blogs',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/blog/.*'
                }
            }
        }
    },
    {
        name: 'pop3/all',
        when: {
            context: {
                product: 'pop3'
            }
        }
    },
    {
        name: 'pop3/send-it',
        when: {
            context: {
                product: 'pop3'
            },
            route: {
                pathname: {
                    matches: 'send-it'
                }
            }
        }
    },
    {
        name: 'trello/all',
        when: {
            context: {
                product: 'trello'
            }
        }
    },
    {
        name: 'jira/queue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'queue'
                }
            }
        }
    },
    {
        name: 'jira/browse',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'browse'
                }
            }
        }
    },
    {
        name: 'jira/issues',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'issues'
                }
            }
        }
    },
    {
        name: 'jira/project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/issues(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/global-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '/issues'
                },
                search: {
                    matches: '.*filter.*'
                }
            }
        }
    },
    {
        name: 'jira/issues-full-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'issues'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/software',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software'
                }
            }
        }
    },
    {
        name: 'jira/polaris',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/polaris'
                }
            }
        }
    },
    {
        name: 'jira/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'backlog'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk'
                }
            }
        }
    },
    {
        // Any pages within Jira Plan
        name: 'jira/plan',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*'
                }
            }
        }
    },
    {
        // Jira Plans timeline/list view
        name: 'jira/plan/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/timeline?vid=.*'
                }
            }
        }
    },
    {
        // Jira Plans calendar view
        name: 'jira/plan/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/calendar'
                }
            }
        }
    },
    {
        // Jira Plans program board
        name: 'jira/plan/program',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/program'
                }
            }
        }
    },
    {
        name: 'jira/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*(?=.*project)(?=.*setting).*'
                }
            }
        }
    },
    {
        name: 'jira/your-work',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'your-work'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings/request-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings/request-types(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/business/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/board'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/list'
                }
            }
        }
    },
    {
        name: 'jira/business/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/list'
                }
            }
        }
    },
    {
        // Handles both CMP Software and Business
        name: 'jira/cmp/project-settings/people',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/people'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        // Any project route in JSW
        name: 'jira/software/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?'
                }
            }
        }
    },
    {
        // Any project settings route in JSW
        name: 'jira/software/project-settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/settings/.*?'
                }
            }
        }
    },
    {
        // Any project route in JWM
        name: 'jira/business/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?'
                }
            }
        }
    },
    {
        // Any project settings route in JWM
        name: 'jira/business/project-settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/.*?'
                }
            }
        }
    },
    {
        // Project directory
        name: 'jira/projects',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/projects'
                }
            }
        }
    },
    {
        name: 'loom/all',
        when: {
            context: {
                product: 'loom'
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/fields',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/fields'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/fields',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/fields'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-builder',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form/.*?/builder'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-builder',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form/.*?/builder'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/issue-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/issuetypes/.*?'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/issue-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/issuetypes/.*?'
                }
            }
        }
    }
];

});

parcelRegister("1G9dl", function(module, exports) {

$parcel$export(module.exports, "MessageRenderer", () => $27e3c2bc05c354fe$export$2df1250b8f917a59);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $7IIUN = parcelRequire("7IIUN");

var $eC7eK = parcelRequire("eC7eK");

var $ec24C = parcelRequire("ec24C");

var $4PltH = parcelRequire("4PltH");

var $atlER = parcelRequire("atlER");

var $37pC5 = parcelRequire("37pC5");

var $4a1FS = parcelRequire("4a1FS");

var $8vocK = parcelRequire("8vocK");

var $gyZey = parcelRequire("gyZey");

var $7tDpZ = parcelRequire("7tDpZ");

var $fjHXa = parcelRequire("fjHXa");

var $b9gra = parcelRequire("b9gra");

var $7GpKb = parcelRequire("7GpKb");

var $1zW1H = parcelRequire("1zW1H");

var $a2XgR = parcelRequire("a2XgR");

var $3ZaeY = parcelRequire("3ZaeY");

var $7hffc = parcelRequire("7hffc");

var $crJw6 = parcelRequire("crJw6");

var $hRkNp = parcelRequire("hRkNp");
const $27e3c2bc05c354fe$export$e30378e28ad3e6ab = {
    ...(0, $eC7eK.default),
    ...(0, $ec24C.default),
    ...(0, $4PltH.default),
    ...(0, $atlER.default),
    ...(0, $37pC5.default),
    ...(0, $4a1FS.default),
    ...(0, $8vocK.default),
    ...(0, $gyZey.default),
    ...(0, $7tDpZ.default),
    ...(0, $fjHXa.default),
    ...(0, $b9gra.default),
    ...(0, $7GpKb.default),
    ...(0, $1zW1H.default),
    ...(0, $a2XgR.default),
    ...(0, $3ZaeY.default),
    ...(0, $7hffc.default),
    ...(0, $crJw6.default),
    ...(0, $hRkNp.default)
};
const { initializeMessageRenderer: $27e3c2bc05c354fe$export$bce4e5106d86e473, MessageRenderer: $27e3c2bc05c354fe$export$2df1250b8f917a59 } = (0, $7IIUN.asMessageRenderer)($27e3c2bc05c354fe$export$e30378e28ad3e6ab);

});
parcelRegister("eC7eK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bd2e0548cc3141d$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $7bd2e0548cc3141d$export$2e2bcd8739ae039 = {
    'confluence-fast-and-snappy-survey': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5tmWY")))
};

});
parcelRegister("5tmWY", function(module, exports) {

let $3fc1769884d1bd17$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3fc1769884d1bd17$var$load("bStar").then(()=>parcelRequire('g7E4j'));

});


parcelRegister("ec24C", function(module, exports) {

$parcel$export(module.exports, "default", () => $94e2487c31539794$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $94e2487c31539794$export$2e2bcd8739ae039 = {
    'confluence-lovability-survey': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bs6Cu")))
};

});
parcelRegister("bs6Cu", function(module, exports) {

let $856771c9c83b870b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $856771c9c83b870b$var$load("ks2O4").then(()=>parcelRequire('c4ciH'));

});


parcelRegister("4PltH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1279695f1d186443$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");






var $1279695f1d186443$export$2e2bcd8739ae039 = {
    'confluence-commented-on-page-nudge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2jity"))),
    'confluence-continue-reading-nudge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1aLgn"))),
    'confluence-inline-reactions-nudge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cWmLg"))),
    'confluence-mentioned-in-comment-nudge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("bFG0f"))),
    'confluence-mentioned-on-page-nudge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7bXKL"))),
    'confluence-nudge-for-jira': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7Kzrw")))
};

});
parcelRegister("2jity", function(module, exports) {

let $1aebb007097d56be$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1aebb007097d56be$var$load("1VRB2"),
    $1aebb007097d56be$var$load("bABhq"),
    $1aebb007097d56be$var$load("dPdEQ")
]).then(()=>parcelRequire('hIHCn'));

});

parcelRegister("1aLgn", function(module, exports) {

let $0dab63179e4140ff$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0dab63179e4140ff$var$load("7bRRN").then(()=>parcelRequire('g3s4M'));

});

parcelRegister("cWmLg", function(module, exports) {

let $96bc8ec02368b15c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $96bc8ec02368b15c$var$load("1VRB2"),
    $96bc8ec02368b15c$var$load("bABhq"),
    $96bc8ec02368b15c$var$load("bLgGF")
]).then(()=>parcelRequire('cXsju'));

});

parcelRegister("bFG0f", function(module, exports) {

let $87f41afa6acd62f3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $87f41afa6acd62f3$var$load("1VRB2"),
    $87f41afa6acd62f3$var$load("bABhq"),
    $87f41afa6acd62f3$var$load("9EwZb")
]).then(()=>parcelRequire('dr4Pc'));

});

parcelRegister("7bXKL", function(module, exports) {

let $53c7e93883453368$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $53c7e93883453368$var$load("1VRB2"),
    $53c7e93883453368$var$load("bABhq"),
    $53c7e93883453368$var$load("55HIW")
]).then(()=>parcelRequire('an2in'));

});

parcelRegister("7Kzrw", function(module, exports) {

let $5a485287381cc673$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5a485287381cc673$var$load("8Fw7s").then(()=>parcelRequire('k09sk'));

});


parcelRegister("atlER", function(module, exports) {

$parcel$export(module.exports, "default", () => $e09edccb5140cad5$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");


var $e09edccb5140cad5$export$2e2bcd8739ae039 = {
    'jira-plan-add-user-changeboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5XqgS"))),
    'jira-plans-efa-change-boarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("hY47n")))
};

});
parcelRegister("5XqgS", function(module, exports) {

let $4566d760421b89fb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4566d760421b89fb$var$load("3CXO8").then(()=>parcelRequire('9rW5V'));

});

parcelRegister("hY47n", function(module, exports) {

let $d14b3bfdd21c857a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d14b3bfdd21c857a$var$load("jQB8z").then(()=>parcelRequire('hquAq'));

});


parcelRegister("37pC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5708909df93de49a$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $5708909df93de49a$export$2e2bcd8739ae039 = {
    'jira-board-inline-editing-onboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4BRnv")))
};

});
parcelRegister("4BRnv", function(module, exports) {

let $35b405e98a039211$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $35b405e98a039211$var$load("1C6bF").then(()=>parcelRequire('gSsHR'));

});


parcelRegister("4a1FS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b101aaad37910588$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");



var $b101aaad37910588$export$2e2bcd8739ae039 = {
    'filter-refinement-in-tmp-backlog': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("iYJO3"))),
    'jira-nin-list-merge-modal-onboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5e0Sq"))),
    'jira-nin-list-merge-spotlight-onboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aQf6R")))
};

});
parcelRegister("iYJO3", function(module, exports) {

let $dd115cc1282a6066$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dd115cc1282a6066$var$load("4MaCI").then(()=>parcelRequire('feJPn'));

});

parcelRegister("5e0Sq", function(module, exports) {

let $3cdef0ad6e624d67$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3cdef0ad6e624d67$var$load("5GZg9").then(()=>parcelRequire('12CqQ'));

});

parcelRegister("aQf6R", function(module, exports) {

let $7e4a7b2a8e4efd2d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7e4a7b2a8e4efd2d$var$load("1Ma7y").then(()=>parcelRequire('5dzxP'));

});


parcelRegister("8vocK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ab566274b7df42f$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $4ab566274b7df42f$export$2e2bcd8739ae039 = {
    'jira-nin-grid-navigation-onboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("46XKh")))
};

});
parcelRegister("46XKh", function(module, exports) {

let $2fe611260b64d9ca$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2fe611260b64d9ca$var$load("c6NDQ").then(()=>parcelRequire('3NlhR'));

});


parcelRegister("gyZey", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c0fee04e74d150$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");


var $35c0fee04e74d150$export$2e2bcd8739ae039 = {
    'jira-access-page-contact-sales-nudge': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("TdMwz"))),
    'jira-onboarding-hub-welcome-modal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3LUmO")))
};

});
parcelRegister("TdMwz", function(module, exports) {

let $0a5fd3eae5611eeb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0a5fd3eae5611eeb$var$load("j10aK").then(()=>parcelRequire('82Jkf'));

});

parcelRegister("3LUmO", function(module, exports) {

let $2bf17c349e7c93a4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $2bf17c349e7c93a4$var$load("eDzss"),
    $2bf17c349e7c93a4$var$load("j6dW4")
]).then(()=>parcelRequire('4jyb8'));

});


parcelRegister("7tDpZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2be6af0f21f37f3$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");




var $c2be6af0f21f37f3$export$2e2bcd8739ae039 = {
    'jira-forms-conditional-fields-changeboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1hBgt"))),
    'jira-forms-public-forms-changeboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1Q0o0"))),
    'jira-forms-public-forms-changeboarding-flag': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cgB4A"))),
    'jira-in-context-config-sidebar-changeboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("61JE8")))
};

});
parcelRegister("1hBgt", function(module, exports) {

let $0ef448f312bd2454$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0ef448f312bd2454$var$load("4pGiD").then(()=>parcelRequire('8vTtc'));

});

parcelRegister("1Q0o0", function(module, exports) {

let $156af27c6fe16d52$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $156af27c6fe16d52$var$load("01Bed").then(()=>parcelRequire('cvVne'));

});

parcelRegister("cgB4A", function(module, exports) {

let $8ee3bc94503b6a6a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8ee3bc94503b6a6a$var$load("3lVRw").then(()=>parcelRequire('iKD35'));

});

parcelRegister("61JE8", function(module, exports) {

let $46363e81ffb74f52$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $46363e81ffb74f52$var$load("8rcFF").then(()=>parcelRequire('7g8mO'));

});


parcelRegister("fjHXa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2cab90cea0ed1fd$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $f2cab90cea0ed1fd$export$2e2bcd8739ae039 = {
    'jira-issueview-layouts': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aryDr")))
};

});
parcelRegister("aryDr", function(module, exports) {

let $79a74ace11fd0a07$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $79a74ace11fd0a07$var$load("6XALf").then(()=>parcelRequire('guqMM'));

});


parcelRegister("b9gra", function(module, exports) {

$parcel$export(module.exports, "default", () => $54cd6ce0561df0f6$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");


var $54cd6ce0561df0f6$export$2e2bcd8739ae039 = {
    'frozen-columns-onboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("7Bhub"))),
    'jira-nin-group-by-any-field-changeboarding': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("byfGG")))
};

});
parcelRegister("7Bhub", function(module, exports) {

let $58898d6c91a2f8c6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $58898d6c91a2f8c6$var$load("g21oD").then(()=>parcelRequire('lxtog'));

});

parcelRegister("byfGG", function(module, exports) {

let $868f09e47c370290$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $868f09e47c370290$var$load("6Sdtm").then(()=>parcelRequire('6CEHP'));

});


parcelRegister("7GpKb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1bbb135ee6fd978$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $a1bbb135ee6fd978$export$2e2bcd8739ae039 = {
    'welcome-to-premium-flag': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9IhGt")))
};

});
parcelRegister("9IhGt", function(module, exports) {

let $7125f0c9a3cf682f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7125f0c9a3cf682f$var$load("90J03").then(()=>parcelRequire('2DkYf'));

});


parcelRegister("1zW1H", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c2c82f7a9179e26$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $4c2c82f7a9179e26$export$2e2bcd8739ae039 = {
    'marketing-screen-space-flag-contentful-usecase': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("fZYtC")))
};

});
parcelRegister("fZYtC", function(module, exports) {

let $ba5b76f3f595f5a7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ba5b76f3f595f5a7$var$load("iowxZ").then(()=>parcelRequire('8qUH2'));

});


parcelRegister("a2XgR", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b262bd486db730d$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $3b262bd486db730d$export$2e2bcd8739ae039 = {
    'mercury-edit-hierarchy-spotlight': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kGdvD")))
};

});
parcelRegister("kGdvD", function(module, exports) {

let $f0e2358889906824$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f0e2358889906824$var$load("gg1X0").then(()=>parcelRequire('fROby'));

});


parcelRegister("3ZaeY", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbbc2f57be4d0121$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $fbbc2f57be4d0121$export$2e2bcd8739ae039 = {
    'end-of-trial-extension': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4QnN4")))
};

});
parcelRegister("4QnN4", function(module, exports) {

let $386e790f1f932b43$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $386e790f1f932b43$var$load("b0Pcy").then(()=>parcelRequire('2FMcf'));

});


parcelRegister("7hffc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f56c9c8978c818c$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $8f56c9c8978c818c$export$2e2bcd8739ae039 = {
    'jira-messaging-research-recruitment': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1Pkao")))
};

});
parcelRegister("1Pkao", function(module, exports) {

let $154a32842bd9a061$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $154a32842bd9a061$var$load("4t91Z").then(()=>parcelRequire('eZaoE'));

});


parcelRegister("crJw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $111929a711673f83$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");

var $111929a711673f83$export$2e2bcd8739ae039 = {
    'message-template-template': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("adUQe")))
};

});
parcelRegister("adUQe", function(module, exports) {

let $771735d04b73190f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $771735d04b73190f$var$load("57Wgr").then(()=>parcelRequire('fqmfI'));

});


parcelRegister("hRkNp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e762571fcf234ab$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eJOHy = parcelRequire("eJOHy");




var $8e762571fcf234ab$export$2e2bcd8739ae039 = {
    'test-message-inapp': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("3Bw1I"))),
    'test-message-inapp-ep-modal': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("i0Gpu"))),
    'test-message-inapp-implicit-pendo': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lLdiE"))),
    'test-message-tap-ingestion-trigger-subscription': /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aro7E")))
};

});
parcelRegister("3Bw1I", function(module, exports) {

let $29fdaba680774bda$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $29fdaba680774bda$var$load("6iF26").then(()=>parcelRequire('7yrXW'));

});

parcelRegister("i0Gpu", function(module, exports) {

let $d1c91fdf932a69a0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d1c91fdf932a69a0$var$load("8Sa9p").then(()=>parcelRequire('6YlfJ'));

});

parcelRegister("lLdiE", function(module, exports) {

let $fd784dd46adf668c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fd784dd46adf668c$var$load("amewD").then(()=>parcelRequire('jw7UH'));

});

parcelRegister("aro7E", function(module, exports) {

let $799f2334dfec9863$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $799f2334dfec9863$var$load("2YBop").then(()=>parcelRequire('brvPa'));

});



/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $4208604c26752028$export$a5cfae247d8360ef = 'screen-space-flags';

parcelRegister("6cGp0", function(module, exports) {

$parcel$export(module.exports, "withScreenSpaceFlagsIntlProvider", () => $6bdc9d3c1cdbe641$export$b0eee5de066b2bf5);
/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $9XuVH = parcelRequire("9XuVH");

var $aUpmE = parcelRequire("aUpmE");

var $9jEMs = parcelRequire("9jEMs");

var $g5Whu = parcelRequire("g5Whu");

var $7X2MP = parcelRequire("7X2MP");

var $aaLWf = parcelRequire("aaLWf");

var $cJHqL = parcelRequire("cJHqL");

var $j8GN9 = parcelRequire("j8GN9");

var $9poyK = parcelRequire("9poyK");

var $d9B3I = parcelRequire("d9B3I");

var $dxNP7 = parcelRequire("dxNP7");

var $9f5AT = parcelRequire("9f5AT");

var $hMT3U = parcelRequire("hMT3U");

var $h2eQn = parcelRequire("h2eQn");

var $2d46t = parcelRequire("2d46t");

var $jt2vt = parcelRequire("jt2vt");

var $3c2oE = parcelRequire("3c2oE");

var $4GHII = parcelRequire("4GHII");

var $dINkw = parcelRequire("dINkw");
const $6bdc9d3c1cdbe641$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $aUpmE.messagesLoader)(locale),
        (0, $9jEMs.messagesLoader)(locale),
        (0, $g5Whu.messagesLoader)(locale),
        (0, $7X2MP.messagesLoader)(locale),
        (0, $aaLWf.messagesLoader)(locale),
        (0, $cJHqL.messagesLoader)(locale),
        (0, $j8GN9.messagesLoader)(locale),
        (0, $9poyK.messagesLoader)(locale),
        (0, $d9B3I.messagesLoader)(locale),
        (0, $dxNP7.messagesLoader)(locale),
        (0, $9f5AT.messagesLoader)(locale),
        (0, $hMT3U.messagesLoader)(locale),
        (0, $h2eQn.messagesLoader)(locale),
        (0, $2d46t.messagesLoader)(locale),
        (0, $jt2vt.messagesLoader)(locale),
        (0, $3c2oE.messagesLoader)(locale),
        (0, $4GHII.messagesLoader)(locale),
        (0, $dINkw.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $6bdc9d3c1cdbe641$export$b0eee5de066b2bf5 = (Component)=>{
    return (0, $9XuVH.withIntlProvider)({
        messagesLoader: $6bdc9d3c1cdbe641$export$d5a462ce7bd04520
    }, Component);
};

});
parcelRegister("aUpmE", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $4d214ead0f4a42b0$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $biazy = parcelRequire("biazy");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4d214ead0f4a42b0$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $4d214ead0f4a42b0$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("gvKnN")));
        case 'da':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("3zfwq")));
        case 'de':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("gtfF7")));
        case 'en-GB':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("9UygW")));
        case 'en-US':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("aNQWF")));
        case 'en-XA':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("gG1zz")));
        case 'en-XB':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("aIqkW")));
        case 'en-ZZ':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("dTBrB")));
        case 'en':
            return $4d214ead0f4a42b0$var$importHelper(await Promise.resolve((parcelRequire("biazy"))));
        case 'es':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("isOCu")));
        case 'et':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("8jfiO")));
        case 'fi':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("7OBvO")));
        case 'fr':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("gSLjY")));
        case 'hr':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("glZ0Q")));
        case 'hu':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("aI0tK")));
        case 'it':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("jL2yc")));
        case 'ja':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("5n9h6")));
        case 'ko':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("1SNyX")));
        case 'nb':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("amRzh")));
        case 'nl':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("6VBPO")));
        case 'pl':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("lCBPs")));
        case 'pt-BR':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("6Leuz")));
        case 'ro':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("8EbY6")));
        case 'ru':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("acglD")));
        case 'sl':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("aPtZ7")));
        case 'sr-RS':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("92Wo6")));
        case 'sr-YR':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("lWRX4")));
        case 'sr':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("4MLHq")));
        case 'sv':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("3qht8")));
        case 'th':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("6ixby")));
        case 'tr':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("5YDXh")));
        case 'uk':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("42pFA")));
        case 'vi':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("9mIWR")));
        case 'zh-CN':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("iD2AL")));
        case 'zh-TW':
            return $4d214ead0f4a42b0$var$importHelper(await (parcelRequire("c53Ir")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($biazy));
    }
};

});
parcelRegister("biazy", function(module, exports) {
module.exports = JSON.parse('{"cc-flywheel-activation.confluence-personalized-use-case-expansion.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.part1":[{"type":0,"value":"Your teammates are using Confluence to share project context, capture decisions, and more in "},{"type":1,"value":"projectName"},{"type":0,"value":"."}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.part2":[{"type":0,"value":"Here\'s what they\'ve recently linked to your Jira project:"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.message-template.email.subject":[{"type":0,"value":"Your team in "},{"type":1,"value":"projectName"},{"type":0,"value":" is using Confluence for project docs--see what they\u2019ve added"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.message-template.footer.text":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.test-message.email.body.button-cta":[{"type":0,"value":"Open Confluence"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.test-message.email.body.signoff":[{"type":0,"value":"See what else is happening across your company:"}],"confluence.fastAndSnappy.survey.question":[{"type":0,"value":"To what extent do you agree or disagree with the following statement?"}],"confluence.fastAndSnappy.survey.statement":[{"type":0,"value":"Confluence feels fast and snappy."}],"post-office-team.confluence-reactivate-inactive-link-paste-in-jira-email.atlassian-logo":[{"type":0,"value":"Atlassian Logo"}]}');

});

parcelRegister("gvKnN", function(module, exports) {

let $c0538546b87a8993$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c0538546b87a8993$var$load("1QYjV").then(()=>parcelRequire('dXg2V'));

});

parcelRegister("3zfwq", function(module, exports) {

let $2990ae50fd98898d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2990ae50fd98898d$var$load("38qnB").then(()=>parcelRequire('jc49a'));

});

parcelRegister("gtfF7", function(module, exports) {

let $bfdb80f276482770$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bfdb80f276482770$var$load("7csV4").then(()=>parcelRequire('jbYLG'));

});

parcelRegister("9UygW", function(module, exports) {

let $7373edc1375c67f6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7373edc1375c67f6$var$load("kOLc9").then(()=>parcelRequire('kGhZE'));

});

parcelRegister("aNQWF", function(module, exports) {

let $7dd78ccd6347ffe7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7dd78ccd6347ffe7$var$load("cBOTI").then(()=>parcelRequire('jI6Z8'));

});

parcelRegister("gG1zz", function(module, exports) {

let $c241c9e3054d7297$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c241c9e3054d7297$var$load("E1KGe").then(()=>parcelRequire('7OqJ3'));

});

parcelRegister("aIqkW", function(module, exports) {

let $7cd2715b03f8b2a4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7cd2715b03f8b2a4$var$load("lcKeP").then(()=>parcelRequire('d6iwk'));

});

parcelRegister("dTBrB", function(module, exports) {

let $a1dd751452660875$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a1dd751452660875$var$load("9YU5K").then(()=>parcelRequire('3ttyH'));

});

parcelRegister("isOCu", function(module, exports) {

let $d7121b8f6ce567be$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d7121b8f6ce567be$var$load("5VOTO").then(()=>parcelRequire('4pmfo'));

});

parcelRegister("8jfiO", function(module, exports) {

let $60cbf7d457e479d8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $60cbf7d457e479d8$var$load("ceKOo").then(()=>parcelRequire('LRI21'));

});

parcelRegister("7OBvO", function(module, exports) {

let $5b0a4d0f2e6c0438$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5b0a4d0f2e6c0438$var$load("01Q2k").then(()=>parcelRequire('feUOr'));

});

parcelRegister("gSLjY", function(module, exports) {

let $c4a6657861b24168$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c4a6657861b24168$var$load("imPvR").then(()=>parcelRequire('eiw4W'));

});

parcelRegister("glZ0Q", function(module, exports) {

let $be7def53cc1fdd41$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $be7def53cc1fdd41$var$load("ijzWC").then(()=>parcelRequire('5R1Z3'));

});

parcelRegister("aI0tK", function(module, exports) {

let $7cbe628b1a54645d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7cbe628b1a54645d$var$load("iO6qJ").then(()=>parcelRequire('02dy1'));

});

parcelRegister("jL2yc", function(module, exports) {

let $e624629432c9af3d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e624629432c9af3d$var$load("92IA9").then(()=>parcelRequire('gEEFv'));

});

parcelRegister("5n9h6", function(module, exports) {

let $3e964b889ca7f060$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3e964b889ca7f060$var$load("ictsr").then(()=>parcelRequire('3pRq5'));

});

parcelRegister("1SNyX", function(module, exports) {

let $15f147b62dde56f2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $15f147b62dde56f2$var$load("etecT").then(()=>parcelRequire('21wJH'));

});

parcelRegister("amRzh", function(module, exports) {

let $78c582f9c8d07109$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $78c582f9c8d07109$var$load("loJln").then(()=>parcelRequire('3Ng4S'));

});

parcelRegister("6VBPO", function(module, exports) {

let $50b56a214d046213$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $50b56a214d046213$var$load("bAFxM").then(()=>parcelRequire('lS6K3'));

});

parcelRegister("lCBPs", function(module, exports) {

let $fbda7d9e01ccf3d4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fbda7d9e01ccf3d4$var$load("6Zzx2").then(()=>parcelRequire('jbPIJ'));

});

parcelRegister("6Leuz", function(module, exports) {

let $4ec25faf22cef5f8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4ec25faf22cef5f8$var$load("hDtyl").then(()=>parcelRequire('fg5yC'));

});

parcelRegister("8EbY6", function(module, exports) {

let $64bb57d388d8e07e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $64bb57d388d8e07e$var$load("48jgJ").then(()=>parcelRequire('kxezz'));

});

parcelRegister("acglD", function(module, exports) {

let $76c7b4be34c770e1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $76c7b4be34c770e1$var$load("2cOKM").then(()=>parcelRequire('82RQQ'));

});

parcelRegister("aPtZ7", function(module, exports) {

let $7e25ed25aa7bc084$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7e25ed25aa7bc084$var$load("lCP55").then(()=>parcelRequire('de1RJ'));

});

parcelRegister("92Wo6", function(module, exports) {

let $6961978b5ea80f2d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6961978b5ea80f2d$var$load("bU60b").then(()=>parcelRequire('bfd2g'));

});

parcelRegister("lWRX4", function(module, exports) {

let $ffa8dd7149ab20bb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ffa8dd7149ab20bb$var$load("kdiCG").then(()=>parcelRequire('d1eke'));

});

parcelRegister("4MLHq", function(module, exports) {

let $37c0a53d84109078$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $37c0a53d84109078$var$load("9UCJC").then(()=>parcelRequire('eu2vc'));

});

parcelRegister("3qht8", function(module, exports) {

let $27e159c9d7c26b12$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $27e159c9d7c26b12$var$load("k9wwY").then(()=>parcelRequire('aaDwL'));

});

parcelRegister("6ixby", function(module, exports) {

let $495e2a720e7b26df$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $495e2a720e7b26df$var$load("cm4XQ").then(()=>parcelRequire('ebw2k'));

});

parcelRegister("5YDXh", function(module, exports) {

let $45a18c9e4ef9d138$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $45a18c9e4ef9d138$var$load("kXPm0").then(()=>parcelRequire('77Dhz'));

});

parcelRegister("42pFA", function(module, exports) {

let $2f0b42d0908808f5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2f0b42d0908808f5$var$load("gUUMv").then(()=>parcelRequire('kyDQW'));

});

parcelRegister("9mIWR", function(module, exports) {

let $6d1908f3877039b9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6d1908f3877039b9$var$load("aFtz6").then(()=>parcelRequire('k00Hx'));

});

parcelRegister("iD2AL", function(module, exports) {

let $d8fde1394ce9d644$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d8fde1394ce9d644$var$load("gmE8n").then(()=>parcelRequire('0lYgH'));

});

parcelRegister("c53Ir", function(module, exports) {

let $8cb8d58de3e520de$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8cb8d58de3e520de$var$load("lWhyb").then(()=>parcelRequire('cLgtP'));

});


parcelRegister("9jEMs", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $40852f8c1700c069$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8T5Pj = parcelRequire("8T5Pj");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $40852f8c1700c069$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $40852f8c1700c069$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("b7pF6")));
        case 'da':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("5eZWt")));
        case 'de':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("hzQEB")));
        case 'en-GB':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("5VoPY")));
        case 'en-US':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("7Db7X")));
        case 'en-XA':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("jNgG3")));
        case 'en-XB':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("iKbZp")));
        case 'en-ZZ':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("1TdYC")));
        case 'en':
            return $40852f8c1700c069$var$importHelper(await Promise.resolve((parcelRequire("8T5Pj"))));
        case 'es':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("dW2ZO")));
        case 'et':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("cripv")));
        case 'fi':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("jE6oU")));
        case 'fr':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("8XmLE")));
        case 'hr':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("fNCqH")));
        case 'hu':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("hKrj7")));
        case 'it':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("fSTuK")));
        case 'ja':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("inIAA")));
        case 'ko':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("bJzLC")));
        case 'nb':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("h8U5s")));
        case 'nl':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("5GV3f")));
        case 'pl':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("6QrmJ")));
        case 'pt-BR':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("8PYQO")));
        case 'ro':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("kEOlv")));
        case 'ru':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("4zr37")));
        case 'sl':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("69oHk")));
        case 'sr-RS':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("bjWIn")));
        case 'sr-YR':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("llGP8")));
        case 'sr':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("8SWA9")));
        case 'sv':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("5HcFk")));
        case 'th':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("hbMju")));
        case 'tr':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("dTMle")));
        case 'uk':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("kzv6G")));
        case 'vi':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("6BJfP")));
        case 'zh-CN':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("eVrUI")));
        case 'zh-TW':
            return $40852f8c1700c069$var$importHelper(await (parcelRequire("haM7D")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8T5Pj));
    }
};

});
parcelRegister("8T5Pj", function(module, exports) {
module.exports = JSON.parse("{\"confluence.lovability.survey.question\":[{\"type\":0,\"value\":\"To what extent do you agree or disagree with the following statement?\"}],\"confluence.lovability.survey.statement\":[{\"type\":0,\"value\":\"Confluence is a product I love using.\"}]}");

});

parcelRegister("b7pF6", function(module, exports) {

let $8184411558435482$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8184411558435482$var$load("hAm6L").then(()=>parcelRequire('aFnA4'));

});

parcelRegister("5eZWt", function(module, exports) {

let $3d0e4efb1f8b805c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3d0e4efb1f8b805c$var$load("b68ik").then(()=>parcelRequire('1D2of'));

});

parcelRegister("hzQEB", function(module, exports) {

let $ccbe8c8a126a40fa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ccbe8c8a126a40fa$var$load("dJpwR").then(()=>parcelRequire('10pWu'));

});

parcelRegister("5VoPY", function(module, exports) {

let $45058acd9f16ebd5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $45058acd9f16ebd5$var$load("8QX3J").then(()=>parcelRequire('10njk'));

});

parcelRegister("7Db7X", function(module, exports) {

let $58e4ce9732571100$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $58e4ce9732571100$var$load("hudf2").then(()=>parcelRequire('ebNr6'));

});

parcelRegister("jNgG3", function(module, exports) {

let $e68f87b06d159973$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e68f87b06d159973$var$load("kkCAt").then(()=>parcelRequire('lqYd1'));

});

parcelRegister("iKbZp", function(module, exports) {

let $da55d2bbc93075d5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $da55d2bbc93075d5$var$load("bj62i").then(()=>parcelRequire('aeLdT'));

});

parcelRegister("1TdYC", function(module, exports) {

let $1605c4fccf6ad762$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1605c4fccf6ad762$var$load("h4FWM").then(()=>parcelRequire('fS9mq'));

});

parcelRegister("dW2ZO", function(module, exports) {

let $a2530419a9cd9f0d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a2530419a9cd9f0d$var$load("dgPTw").then(()=>parcelRequire('hfB7r'));

});

parcelRegister("cripv", function(module, exports) {

let $90e6498ca8da32ba$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $90e6498ca8da32ba$var$load("6VIiv").then(()=>parcelRequire('aQPzP'));

});

parcelRegister("jE6oU", function(module, exports) {

let $e4d6b7ca386891fb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e4d6b7ca386891fb$var$load("avRAc").then(()=>parcelRequire('eUUrI'));

});

parcelRegister("8XmLE", function(module, exports) {

let $68557e99382137c8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $68557e99382137c8$var$load("DJlhp").then(()=>parcelRequire('bP7Q5'));

});

parcelRegister("fNCqH", function(module, exports) {

let $b8093def84f9d1bb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b8093def84f9d1bb$var$load("iVwP8").then(()=>parcelRequire('lu138'));

});

parcelRegister("hKrj7", function(module, exports) {

let $cebbea3dc2fcc27e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cebbea3dc2fcc27e$var$load("1N7gw").then(()=>parcelRequire('i1W0V'));

});

parcelRegister("fSTuK", function(module, exports) {

let $b906f24f8e21af82$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b906f24f8e21af82$var$load("5dpYK").then(()=>parcelRequire('1A1t7'));

});

parcelRegister("inIAA", function(module, exports) {

let $d61cf670f8dcc005$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d61cf670f8dcc005$var$load("1sN38").then(()=>parcelRequire('5MuG8'));

});

parcelRegister("bJzLC", function(module, exports) {

let $88afa43e9244e98a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $88afa43e9244e98a$var$load("4amzA").then(()=>parcelRequire('3XlTo'));

});

parcelRegister("h8U5s", function(module, exports) {

let $c7aeb0bb3fdcf7f6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c7aeb0bb3fdcf7f6$var$load("9w5a0").then(()=>parcelRequire('gXI8G'));

});

parcelRegister("5GV3f", function(module, exports) {

let $424d2134d9efca70$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $424d2134d9efca70$var$load("fL9Kf").then(()=>parcelRequire('3FWJZ'));

});

parcelRegister("6QrmJ", function(module, exports) {

let $4fbcd3aba68980cc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4fbcd3aba68980cc$var$load("kT4ph").then(()=>parcelRequire('aI5CM'));

});

parcelRegister("8PYQO", function(module, exports) {

let $66f249d76334888d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $66f249d76334888d$var$load("2URfK").then(()=>parcelRequire('QF5VQ'));

});

parcelRegister("kEOlv", function(module, exports) {

let $f09e98b979ee045e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f09e98b979ee045e$var$load("1UwuA").then(()=>parcelRequire('lMu9R'));

});

parcelRegister("4zr37", function(module, exports) {

let $353f69b7ecf35b5a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $353f69b7ecf35b5a$var$load("fi5PA").then(()=>parcelRequire('hbner'));

});

parcelRegister("69oHk", function(module, exports) {

let $47a6bdd52f91e1ae$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $47a6bdd52f91e1ae$var$load("3gbm8").then(()=>parcelRequire('9mQ48'));

});

parcelRegister("bjWIn", function(module, exports) {

let $83df039346e5b84f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $83df039346e5b84f$var$load("5j6eH").then(()=>parcelRequire('emvhV'));

});

parcelRegister("llGP8", function(module, exports) {

let $f8acc70de2f34a0d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f8acc70de2f34a0d$var$load("9jv1m").then(()=>parcelRequire('fMqvp'));

});

parcelRegister("8SWA9", function(module, exports) {

let $6780cf142d94255f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6780cf142d94255f$var$load("hFJxG").then(()=>parcelRequire('pp4u2'));

});

parcelRegister("5HcFk", function(module, exports) {

let $425acb050131d03b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $425acb050131d03b$var$load("014EM").then(()=>parcelRequire('8ivwg'));

});

parcelRegister("hbMju", function(module, exports) {

let $c838f0c24dbeb821$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c838f0c24dbeb821$var$load("hZkF4").then(()=>parcelRequire('ddMpa'));

});

parcelRegister("dTMle", function(module, exports) {

let $a1e5e901a157cf46$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a1e5e901a157cf46$var$load("1KTlA").then(()=>parcelRequire('gRoGe'));

});

parcelRegister("kzv6G", function(module, exports) {

let $ef9f34aef3daa1a8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ef9f34aef3daa1a8$var$load("1Bw2E").then(()=>parcelRequire('3fBSP'));

});

parcelRegister("6BJfP", function(module, exports) {

let $4cf94d5d3934d9f3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4cf94d5d3934d9f3$var$load("aLqud").then(()=>parcelRequire('caIj8'));

});

parcelRegister("eVrUI", function(module, exports) {

let $addc0aa7ba0f8b73$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $addc0aa7ba0f8b73$var$load("cDU6I").then(()=>parcelRequire('ilPsA'));

});

parcelRegister("haM7D", function(module, exports) {

let $c808b2e4673e1a68$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c808b2e4673e1a68$var$load("5jfco").then(()=>parcelRequire('4nDbi'));

});


parcelRegister("g5Whu", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $42f4fcbe01480d69$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $juaFV = parcelRequire("juaFV");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $42f4fcbe01480d69$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;




































const $42f4fcbe01480d69$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("znUes")));
        case 'da':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("i7hFu")));
        case 'de':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("iMCGr")));
        case 'en-GB':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("6SRrD")));
        case 'en-US':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("kDZN2")));
        case 'en-XA':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("7ettD")));
        case 'en-XB':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("6RSP6")));
        case 'en-ZZ':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("i7xOV")));
        case 'en':
            return $42f4fcbe01480d69$var$importHelper(await Promise.resolve((parcelRequire("juaFV"))));
        case 'es':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("lOgX2")));
        case 'et':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("2Knuu")));
        case 'fi':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("2PmNA")));
        case 'fr':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("FxYyx")));
        case 'hr':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("d61fr")));
        case 'hu':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("fCoT2")));
        case 'it':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("9GLuS")));
        case 'ja':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("6DcNY")));
        case 'ko':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("cHByF")));
        case 'nb':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("d6NZo")));
        case 'nl':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("eW8Qj")));
        case 'pl':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("dhuV2")));
        case 'pt-BR':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("ihbIl")));
        case 'ro':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("hYKPy")));
        case 'ru':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("8bQmu")));
        case 'sl':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("4b3gb")));
        case 'sr-RS':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("3JTW0")));
        case 'sr-YR':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("bGcku")));
        case 'sr':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("eVQ1V")));
        case 'sv':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("7nqOY")));
        case 'th':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("5xC7l")));
        case 'tr':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("9ryUu")));
        case 'uk':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("dwcXb")));
        case 'vi':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("amouk")));
        case 'zh-CN':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("afRGP")));
        case 'zh-TW':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("eCnaq")));
        case 'zh':
            return $42f4fcbe01480d69$var$importHelper(await (parcelRequire("afRGP")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($juaFV));
    }
};

});
parcelRegister("juaFV", function(module, exports) {
module.exports = JSON.parse('{"app-switcher-discovery-section.discover-more-products":[{"type":0,"value":"Discover more apps"}],"app-switcher-discovery-section.more-atlassian-products":[{"type":0,"value":"More Atlassian apps"}],"app-switcher-discovery-section.recommended-for-your-team":[{"type":0,"value":"Recommended for your team"}],"confluence.continue.reading.body":[{"children":[{"type":0,"value":"Related reading from "},{"type":1,"value":"pageOwnerName"}],"type":8,"value":"text"}],"confluence.continue.reading.read-now":[{"type":0,"value":"Read now"}],"continue-reading.ai-footer.content-quality":[{"children":[{"type":0,"value":"Content quality may vary"}],"type":8,"value":"text"}],"continue-reading.ai-footer.powered-by-ai":[{"children":[{"type":0,"value":"Powered by AI"}],"type":8,"value":"text"}],"cross-flow-itsm-template.jsm.title":[{"type":0,"value":"Collect IT requests"}],"cross-flow-product-request-pending.jpd.title":[{"type":0,"value":"Product roadmap"}],"cross-flow-product-request-pending.jsm.title":[{"type":0,"value":"Work requests"}],"cross-flow-product-roadmap-template.jpd.title":[{"type":0,"value":"Create a roadmap"}],"cross-flow-work-requests-template.jsm.title":[{"type":0,"value":"Collect requests"}],"first-party-recommendation.reason-1":[{"type":0,"value":"the size of your team"}],"first-party-recommendation.reason-2":[{"type":0,"value":"your existing Atlassian products"}],"growth.admin-hub-recommendation.actions-heading":[{"type":0,"value":"Actions"}],"growth.admin-hub-recommendation.free-plan":[{"type":0,"value":"Free, cancel anytime"}],"growth.admin-hub-recommendation.heading":[{"type":0,"value":"Recommended based on your existing products"}],"growth.admin-hub-recommendation.plan-heading":[{"type":0,"value":"Plan"}],"growth.admin-hub-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"growth.app-switcher-discovery-section.flag.description":[{"type":0,"value":"You won\u2019t see this here as often."}],"growth.app-switcher-discovery-section.flag.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"growth.app-switcher-discovery-section.wac-toast.close.aria-label":[{"type":0,"value":"Dismiss toast"}],"growth.confluence-nudge-for-jira.action":[{"type":0,"value":"Accept invitation"}],"growth.confluence-nudge-for-jira.description":[{"type":0,"value":"Accept your invitation to make sure you\'re not missing any project updates."}],"growth.confluence-nudge-for-jira.title":[{"type":0,"value":"Your team invited you to Jira"}],"growth.confluenceNudgeFlag.flagHeadline.commentedOnPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" commented on your page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInComment.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you in a comment"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you on a page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.repliedSuccessFlagTitle.text":[{"type":0,"value":"Reply sent to "},{"type":1,"value":"mentionerName"}],"growth.confluenceNudgeFlag.reply-cancel-button":[{"type":0,"value":"Cancel"}],"growth.confluenceNudgeFlag.reply-confirm-button":[{"type":0,"value":"Reply"}],"growth.confluenceNudgeFlag.reply-on-page-confirm-button.text":[{"children":[{"type":0,"value":"Reply on page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.replyFieldGenericError":[{"type":0,"value":"Failed to send comment. Please try again later."}],"growth.confluenceNudgeFlag.see-page-confirm-button":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.see-page-confirm-button.success.flag":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.viewReactionsError":[{"type":0,"value":"Reactions failed to load"}],"growth.placement-v2.atlas-side-nav-app-recommendation-menu-item.try-new-product":[{"type":0,"value":"TRY"}],"growth.recommendation-atlas.value-proposition":[{"type":0,"value":"Your company\'s teamwork directory"}],"growth.recommendation-confluence.cta.label":[{"type":0,"value":"Try Confluence"}],"growth.recommendation-confluence.jira-your-work.description":[{"type":0,"value":"Create a centralized space to organize requirements, release notes, goals, and more."}],"growth.recommendation-confluence.jira-your-work.header":[{"type":0,"value":"Get everyone on the same page"}],"growth.recommendation-confluence.jira-your-work.header-image-alt-text":[{"type":0,"value":"Multiple people collaborating and commenting on the same page at the same time"}],"growth.recommendation-confluence.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.page-template-description":[{"type":0,"value":"Draft plans and capture decisions"}],"growth.recommendation-confluence.page-template-title":[{"type":0,"value":"Project Documentation"}],"growth.recommendation-confluence.product-alt-text":[{"type":0,"value":"A document titled quarterly planning. The document has details like mission, scope and a monthly plan."}],"growth.recommendation-confluence.product-heading":[{"type":0,"value":"Create one source of truth, for all"}],"growth.recommendation-confluence.product-name.header":[{"type":0,"value":"Collaborate on pages in real-time"}],"growth.recommendation-confluence.product-subheading":[{"type":0,"value":"Create and link documents like release notes, product requirements, and roadmaps from a single place."}],"growth.recommendation-confluence.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.value-proposition":[{"type":0,"value":"Document collaboration"}],"growth.recommendation-jira.product-alt-text":[{"type":0,"value":"A board view to move tasks from to do, to in progress to done"}],"growth.recommendation-jira.product-heading":[{"type":0,"value":"Plan and track work across teams"}],"growth.recommendation-jira.product-subheading":[{"type":0,"value":"Break big ideas down into achievable steps. Organize work, create milestones, map dependencies, and get visibility across all teams."}],"growth.recommendation-jpd-product-roadmap.value-proposition":[{"type":0,"value":"Align everyone with custom roadmaps"}],"growth.recommendation-jpd.admin-hub-recommendation-value-proposition":[{"type":0,"value":"Plan and deliver all on the same platform"}],"growth.recommendation-jpd.cta.label":[{"type":0,"value":"Try Jira Product Discovery"}],"growth.recommendation-jpd.jira-your-work.description":[{"type":0,"value":"Prioritize your ideas then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.jira-your-work.header":[{"type":0,"value":"Build right features, the right way"}],"growth.recommendation-jpd.jira-your-work.header-image-alt-text":[{"type":0,"value":"An idea in Jira Product Discovery automatically turning into an Epic in Jira"}],"growth.recommendation-jpd.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.product-alt-text":[{"type":0,"value":"Five ideas are all organized into now, next and later groups, with a goal, score and effort ranking connected to each idea."}],"growth.recommendation-jpd.product-heading":[{"type":0,"value":"Build the right features, the right way"}],"growth.recommendation-jpd.product-name.header":[{"type":0,"value":"Transform insights into action plans"}],"growth.recommendation-jpd.product-subheading":[{"type":0,"value":"Capture and prioritize your ideas, then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.value-proposition":[{"type":0,"value":"Prioritize, collaborate, and deliver new ideas"}],"growth.recommendation-jsm-work-request.value-proposition":[{"type":0,"value":"Create one place to manage requests"}],"growth.recommendation-jsm.admin-hub-recommendation-value-prop":[{"type":0,"value":"Bring your developers, IT, and operations onto the same platform."}],"growth.recommendation-jsm.cta.label":[{"type":0,"value":"Try Jira Service Management"}],"growth.recommendation-jsm.jira-your-work.description":[{"type":0,"value":"Connect support teams with development teams to get the full picture, from request to resolution."}],"growth.recommendation-jsm.jira-your-work.header":[{"type":0,"value":"Link your teams, make work visible"}],"growth.recommendation-jsm.jira-your-work.header-image-alt-text":[{"type":0,"value":"Requests from Slack, Teams and email turning into a Jira Service Management request automatically"}],"growth.recommendation-jsm.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.product-alt-text":[{"type":0,"value":"Seven requests are all organized in one place, with a status and project connected to each request."}],"growth.recommendation-jsm.product-heading":[{"type":0,"value":"Make your work more visible"}],"growth.recommendation-jsm.product-name.header":[{"type":0,"value":"Automate workflows for faster resolutions"}],"growth.recommendation-jsm.product-subheading":[{"type":0,"value":"Connect Dev and Ops teams on a single platform to collaborate and connect the whole picture, from request to resolution."}],"growth.recommendation-jsm.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.value-proposition":[{"type":0,"value":"Collaborative IT service management"}],"growth.recommendation-jsw-dynamic-description.value-proposition":[{"type":0,"value":"Plan, track, and organize any project"}],"growth.recommendation-jsw-visualize-work.cta.label":[{"type":0,"value":"Try Jira"}],"growth.recommendation-jsw-visualize-work.product-name.header":[{"type":0,"value":"Visualize your projects in lists, boards, and more"}],"growth.recommendation-jsw-visualize-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsw.recommendations.dropdown-menu-trigger.aria-label":[{"type":1,"value":"productName"},{"type":0,"value":" options"}],"growth.recommendation-jsw.value-proposition":[{"type":0,"value":"Project and issue tracking"}],"growth.recommendation-jwm.value-proposition":[{"type":0,"value":"ITSM that unlocks high-velocity teams"}],"growth.recommendation-loom.cta.label":[{"type":0,"value":"Try Loom"}],"growth.recommendation-loom.product-name.header":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-loom.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-loom.value-proposition":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-opsgenie.value-proposition":[{"type":0,"value":"Modern incident management"}],"growth.recommendation-product-store.learn-cta-button-text":[{"type":0,"value":"Learn more"}],"growth.recommendation-product-store.try-cta-button-text":[{"type":0,"value":"Try it now"}],"growth.recommendation-twc.confluence-apps-description":[{"type":0,"value":"Jira, video, and AI"}],"growth.recommendation-twc.confluence-apps-title":[{"type":0,"value":"Apps that click with Confluence"}],"growth.recommendation-twc.image-alt-text":[{"type":0,"value":"Rovo and Loom"}],"growth.recommendation-twc.jira-apps-description":[{"type":0,"value":"Elevate workflows with video and AI"}],"growth.recommendation-twc.jira-apps-title":[{"type":0,"value":"Apps that click with Jira"}],"growth.team-25-ipm.jira-your-work.call-to-action.watch-now.text":[{"type":0,"value":"Watch now"}],"growth.team-25-ipm.jira-your-work.description":[{"type":0,"value":"See how Rovo can improve the way you work with AI search, chat, and agents."}],"growth.team-25-ipm.jira-your-work.header-image-alt-text":[{"type":0,"value":"See the Rovo announcement!"}],"growth.team-25-ipm.jira-your-work.reasons-modal.message":[{"type":0,"value":"Atlassian recently shared multiple announcements at Team \'25, and we wanted to make sure you know about our new capabilities."}],"growth.team-25-ipm.jira-your-work.title":[{"type":0,"value":"Work better with Rovo"}],"jpd.customRoadmapsPlacementHeader":[{"type":0,"value":"Custom roadmaps"}],"jpd.customRoadmapsPlacementTagLine":[{"type":0,"value":"Create and share high-level plans"}],"jpd.deliveryProgressPlacementHeader":[{"type":0,"value":"Delivery progress"}],"jpd.deliveryProgressPlacementTagLine":[{"type":0,"value":"Connect ideas to delivery status"}],"jpd.ideasAndPrioritiesPlacementHeader":[{"type":0,"value":"Ideas and priorities"}],"jpd.ideasAndPrioritiesPlacementTagLine":[{"type":0,"value":"Use RICE and data to prioritize ideas"}],"jpd.insightsAndIdeasPlacementHeader":[{"type":0,"value":"Insights and ideas"}],"jpd.insightsAndIdeasPlacementTagLine":[{"type":0,"value":"See ideas and feedback in one place"}],"jsm.assetsPlacementHeader":[{"type":0,"value":"Assets"}],"jsm.assetsPlacementTagLine":[{"type":0,"value":"Bring your enterprise assets together"}],"jsm.bugTrackingPlacementHeader":[{"type":0,"value":"Bug tracking"}],"jsm.bugTrackingPlacementTagLine":[{"type":0,"value":"Gather and resolve bugs in one place"}],"jsm.changeManagementPlacementHeader":[{"type":0,"value":"Change management"}],"jsm.changeManagementPlacementTagLine":[{"type":0,"value":"Create one place to manage changes"}],"jsm.customerServicePlacementHeader":[{"type":0,"value":"Customer service"}],"jsm.customerServicePlacementTagLine":[{"type":0,"value":"Help people get service and support"}],"jsm.helpDeskPlacementHeader":[{"type":0,"value":"Help desk"}],"jsm.helpDeskPlacementTagLine":[{"type":0,"value":"Receive requests and provide support"}],"jsm.issueManagementPlacementHeader":[{"type":0,"value":"Issue management"}],"jsm.issueManagementPlacementTagLine":[{"type":0,"value":"Capture and resolve issues"}],"jsm.onCallSchedulesPlacementHeader":[{"type":0,"value":"On-call schedules"}],"jsm.onCallSchedulesPlacementTagLine":[{"type":0,"value":"Create schedules, rotations, and more"}],"jsm.workRequestsPlacementHeader":[{"type":0,"value":"Work requests"}],"jsm.workRequestsPlacementTagLine":[{"type":0,"value":"Create one place to manage requests"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.suggested-next-steps":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.message":[{"type":0,"value":"You\'re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag-message.recommendation-basis":[{"type":0,"value":"You\u2019re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-mcu-nudge-flag-reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-mcu-nudge-flag-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag.suggestions":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.custom-reason.existing-products.no-translate":[{"type":0,"value":"the second reason for displaying the message to the customer"}],"post-office.ad-controls.custom-reason.team-size.no-translate":[{"type":0,"value":"the first reason for displaying the message to the customer"}],"post-office.ad-controls.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"post-office.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"post-office.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls.dropdown-item.remind-me-later.label":[{"type":0,"value":"Remind me later"}],"post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls.next-best-action-message.recommendation-basis":[{"type":0,"value":"This recommendation is based on:"}],"post-office.ad-controls.next-best-action-reason.actions-done-so-far":[{"type":0,"value":"What you\u2019ve done so far in the product"}],"post-office.ad-controls.next-best-action-reason.suggestions":[{"type":0,"value":"What we suggest to help you get the most value from Atlassian"}],"post-office.ad-controls.next-best-action-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.close-button.tooltip":[{"type":0,"value":"Close"}],"post-office.confluence-banner-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.confluence-side-nav.next-best-action.aifc-onboarding":[{"type":0,"value":"Create in Confluence using Rovo AI"}],"post-office.confluence-side-nav.next-best-action.aifc-onboarding-message":[{"type":0,"value":"Open Rovo create"}],"post-office.confluence-side-nav.next-best-action.craete-space-header":[{"type":0,"value":"Centralize your team\'s projects, and docs."}],"post-office.confluence-side-nav.next-best-action.create-page-cta-message":[{"type":0,"value":"Create page"}],"post-office.confluence-side-nav.next-best-action.create-page-header":[{"type":0,"value":"Plan projects, take notes, and track tasks."}],"post-office.confluence-side-nav.next-best-action.create-space-cta-message":[{"type":0,"value":"Create space"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message":[{"type":0,"value":"Create whiteboard"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-header":[{"type":0,"value":"Dream up new ideas, and visualize your work."}],"post-office.example-message-template.example-placement.cta-button.no-translate":[{"type":0,"value":"Try now"}],"post-office.example-placement-advanced.learn-more-modal.done-button-text.no-translate":[{"type":0,"value":"Done"}],"post-office.example-placement-quick-start.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.growth.jira-activation-project-recommendation.hello-message.no-translate":[{"type":0,"value":"\uD83D\uDC4B Hey "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"post-office.growth.jira-activation-project-recommendation.message-text.no-translate":[{"type":0,"value":"Have you checked to see if any of your projects are being tracked in your team\u2019s Jira? You may be missing out on updates."}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-multiple-projects":[{"type":0,"value":":wave: Just a heads up \u2014 you have *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one project"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfProjects"}]}},"type":5,"value":"numberOfProjects"},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"},{"type":0,"value":"* assigned to you with new work items you haven\'t checked out yet."}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-one-project-work-items":[{"type":0,"value":":wave: Just a heads up \u2014 you were assigned "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"a work item in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]},"other":{"value":[{"type":0,"value":"some work items in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":" over three days ago."}],"post-office.growth.jira-assigned-nudge-digest.max-top-work-items-message":[{"type":0,"value":"You\'ve got *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one item"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfWorkItems"}]}},"type":5,"value":"numberOfWorkItems"},{"type":0,"value":" items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":"* to check on \u2014 here are three:"}],"post-office.growth.jira-assigned-nudge-digest.plural-cta-message":[{"type":0,"value":"See inactive "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"item"}]},"other":{"value":[{"type":0,"value":"items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"}],"post-office.growth.jira-assigned-nudge-digest.top-projects-message":[{"type":0,"value":"Here are three to get you started:"}],"post-office.growth.recommendation-jpd.confluence-home-banner.description":[{"type":0,"value":"Make sure your team is building the right things with Jira Product Discovery."}],"post-office.growth.recommendation-jpd.confluence-home-banner.header":[{"type":0,"value":"Capture your ideas and customer feedback all in one place"}],"post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Discovery Product Logo"}],"post-office.growth.recommendation-jsm.confluence-home-banner.description":[{"type":0,"value":"Automatically turn Slack, Teams, and email requests into tickets."}],"post-office.growth.recommendation-jsm.confluence-home-banner.header":[{"type":0,"value":"See the whole picture, from request to resolution"}],"post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Service Management Product Logo"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description":[{"type":0,"value":"See analytics and insights about what your team is working on at any moment"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header":[{"type":0,"value":"Sync real-time data from Jira to any document in Confluence"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description":[{"type":0,"value":"76% customers shipped projects faster after adding Confluence and Jira."}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header":[{"type":0,"value":"Build world-class products, fast"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description":[{"type":0,"value":"Jira lets you view your project and tasks in a way that works for you and your team."}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header":[{"type":0,"value":"Visualize any project in a list, board, backlog, and more"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.jira-side-nav-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.jira-your-work-first-party-recommendation.learn-more":[{"type":0,"value":"Learn more"}],"post-office.jira-your-work-first-party-recommendation.learn-more.alt-text":[{"type":0,"value":"Discover more about "},{"type":1,"value":"product"}],"post-office.jira-your-work-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.jira-your-work-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.nav-4-projects-recommendations.cta-button-dimissal":[{"type":0,"value":"Dismiss"}],"post-office.nav-4-projects-recommendations.cta-button-lozenge-try":[{"type":0,"value":"Try"}],"post-office.nav-4-projects-recommendations.dropdown-menu-open-label":[{"type":0,"value":"Open"}],"post-office.nav-4-projects-recommendations.section-heading":[{"type":0,"value":"Recommended"}],"post-office.nav-4-requested-item.cta-button-dimissal":[{"type":0,"value":"Dismiss"}],"post-office.nav-4-requested-item.cta-button-lozenge-pending":[{"type":0,"value":"Pending"}],"post-office.nav-4-requested-item.product-roadmap-icon-alt-text":[{"type":0,"value":"Icon for product roadmap"}],"post-office.nav-4-requested-item.work-requests-icon-alt-text":[{"type":0,"value":"Icon for work requests"}],"post-office.placement-v2-nav-4-section.requested-main-heading":[{"type":0,"value":"Requested"}],"post-office.test-placement.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.test-placement.test-message.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"post-office.test-placement.test-message.learn-more-button.no-translate":[{"type":0,"value":"Learn more"}],"recommendation-controls.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"recommendation-controls.team-size":[{"type":0,"value":"the size of your team"}],"recommendations.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"recommendations.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"recommendations.ad-controls.reasons-modal.accept-button.label":[{"type":0,"value":"Ok"}],"recommendations.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"recommendations.ad-controls.reasons-modal.body":[{"type":0,"value":"We think that "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"recommendations.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"recommendations.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"switcher.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"test":[{"type":0,"value":"default message"}]}');

});

parcelRegister("znUes", function(module, exports) {

let $06a5d03a1cbf0c92$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $06a5d03a1cbf0c92$var$load("aP4vg").then(()=>parcelRequire('21LCd'));

});

parcelRegister("i7hFu", function(module, exports) {

let $d30695fb5eaa1672$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d30695fb5eaa1672$var$load("inT6W").then(()=>parcelRequire('au4PU'));

});

parcelRegister("iMCGr", function(module, exports) {

let $dacab769101ffe61$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dacab769101ffe61$var$load("cUnvu").then(()=>parcelRequire('8L8nA'));

});

parcelRegister("6SRrD", function(module, exports) {

let $50313e36a0e4a22c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $50313e36a0e4a22c$var$load("kAcHr").then(()=>parcelRequire('igGaK'));

});

parcelRegister("kDZN2", function(module, exports) {

let $f077615daf091ed0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f077615daf091ed0$var$load("fDRtU").then(()=>parcelRequire('hwuvN'));

});

parcelRegister("7ettD", function(module, exports) {

let $5440b4bd1a362626$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5440b4bd1a362626$var$load("iGRnw").then(()=>parcelRequire('8F6L9'));

});

parcelRegister("6RSP6", function(module, exports) {

let $500238103711e01f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $500238103711e01f$var$load("6oLUM").then(()=>parcelRequire('3tzrO'));

});

parcelRegister("i7xOV", function(module, exports) {

let $d3131d79e732f196$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d3131d79e732f196$var$load("lhUFp").then(()=>parcelRequire('f9udV'));

});

parcelRegister("lOgX2", function(module, exports) {

let $fe0b6aab88b818b7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fe0b6aab88b818b7$var$load("jGDMD").then(()=>parcelRequire('1o2yO'));

});

parcelRegister("2Knuu", function(module, exports) {

let $2002196c46073bd1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2002196c46073bd1$var$load("94Arw").then(()=>parcelRequire('kQco9'));

});

parcelRegister("2PmNA", function(module, exports) {

let $20f2078b52118621$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $20f2078b52118621$var$load("4IrAd").then(()=>parcelRequire('3SrYr'));

});

parcelRegister("FxYyx", function(module, exports) {

let $07ce2f517846ccbb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $07ce2f517846ccbb$var$load("jBVae").then(()=>parcelRequire('ek02X'));

});

parcelRegister("d61fr", function(module, exports) {

let $988ccdb9e7b2bfb5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $988ccdb9e7b2bfb5$var$load("hX9ox").then(()=>parcelRequire('dYY69'));

});

parcelRegister("fCoT2", function(module, exports) {

let $b5edb59bc21f295c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b5edb59bc21f295c$var$load("gQ8vT").then(()=>parcelRequire('84npC'));

});

parcelRegister("9GLuS", function(module, exports) {

let $70dce1368a813c55$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $70dce1368a813c55$var$load("521NH").then(()=>parcelRequire('hJeQk'));

});

parcelRegister("6DcNY", function(module, exports) {

let $4d40516bb45bd7db$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4d40516bb45bd7db$var$load("4akyD").then(()=>parcelRequire('5AA9m'));

});

parcelRegister("cHByF", function(module, exports) {

let $93f6a2799de8b868$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $93f6a2799de8b868$var$load("4F8wc").then(()=>parcelRequire('swWWI'));

});

parcelRegister("d6NZo", function(module, exports) {

let $98b29cb637502d6f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $98b29cb637502d6f$var$load("akSqD").then(()=>parcelRequire('2UKdY'));

});

parcelRegister("eW8Qj", function(module, exports) {

let $adfd577a8c583286$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $adfd577a8c583286$var$load("037wd").then(()=>parcelRequire('jYxAl'));

});

parcelRegister("dhuV2", function(module, exports) {

let $9ab4d8bdfc67f582$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9ab4d8bdfc67f582$var$load("e6zj1").then(()=>parcelRequire('9GPuz'));

});

parcelRegister("ihbIl", function(module, exports) {

let $d4e2e6ba05d19849$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d4e2e6ba05d19849$var$load("fJSsX").then(()=>parcelRequire('9564Q'));

});

parcelRegister("hYKPy", function(module, exports) {

let $d16c5dd095ad41f6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d16c5dd095ad41f6$var$load("RCmoB").then(()=>parcelRequire('h3JkE'));

});

parcelRegister("8bQmu", function(module, exports) {

let $5f67f7bf98420370$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5f67f7bf98420370$var$load("ezdlR").then(()=>parcelRequire('1wwqO'));

});

parcelRegister("4b3gb", function(module, exports) {

let $30aab7df6c3ea94b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $30aab7df6c3ea94b$var$load("6noB0").then(()=>parcelRequire('fq1Kf'));

});

parcelRegister("3JTW0", function(module, exports) {

let $2b90f67be651c395$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2b90f67be651c395$var$load("5F0Ab").then(()=>parcelRequire('lx8et'));

});

parcelRegister("bGcku", function(module, exports) {

let $880d2e5789d99bc5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $880d2e5789d99bc5$var$load("anv5S").then(()=>parcelRequire('doCdU'));

});

parcelRegister("eVQ1V", function(module, exports) {

let $adeebfa4fe3389e5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $adeebfa4fe3389e5$var$load("4Uj0T").then(()=>parcelRequire('5uBHY'));

});

parcelRegister("7nqOY", function(module, exports) {

let $55ef7c83dbac3779$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $55ef7c83dbac3779$var$load("lCLd4").then(()=>parcelRequire('g5JRD'));

});

parcelRegister("5xC7l", function(module, exports) {

let $408d9a22d14aff60$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $408d9a22d14aff60$var$load("1voYG").then(()=>parcelRequire('ale1i'));

});

parcelRegister("9ryUu", function(module, exports) {

let $6e01b712e43f4db0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6e01b712e43f4db0$var$load("4c16y").then(()=>parcelRequire('cOc7U'));

});

parcelRegister("dwcXb", function(module, exports) {

let $9d784fd3ae9cdfe8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9d784fd3ae9cdfe8$var$load("ab5wh").then(()=>parcelRequire('8dIBs'));

});

parcelRegister("amouk", function(module, exports) {

let $78aef452116e9d11$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $78aef452116e9d11$var$load("lSOlX").then(()=>parcelRequire('beXbM'));

});

parcelRegister("afRGP", function(module, exports) {

let $7774f3cb88f9acaa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7774f3cb88f9acaa$var$load("ge8o5").then(()=>parcelRequire('9cznU'));

});

parcelRegister("eCnaq", function(module, exports) {

let $aa4695d18b6bd212$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $aa4695d18b6bd212$var$load("267CN").then(()=>parcelRequire('2fN1T'));

});


parcelRegister("7X2MP", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $8183d8340bc03897$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $iZLE9 = parcelRequire("iZLE9");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8183d8340bc03897$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8183d8340bc03897$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("7ULI1")));
        case 'da':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("gDYS4")));
        case 'de':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("eB9B7")));
        case 'en-GB':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("JOJzk")));
        case 'en-US':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("6SPcW")));
        case 'en-XA':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("jO1M9")));
        case 'en-XB':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("aWx60")));
        case 'en-ZZ':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("dMwz0")));
        case 'en':
            return $8183d8340bc03897$var$importHelper(await Promise.resolve((parcelRequire("iZLE9"))));
        case 'es':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("5mPZu")));
        case 'et':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("6qKN2")));
        case 'fi':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("H4Lhl")));
        case 'fr':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("hYscG")));
        case 'hr':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("bywzC")));
        case 'hu':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("qxrtp")));
        case 'it':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("eAR1f")));
        case 'ja':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("eIMzO")));
        case 'ko':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("ddcy6")));
        case 'nb':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("2khQ1")));
        case 'nl':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("cnsvO")));
        case 'pl':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("lOOZP")));
        case 'pt-BR':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("fmShI")));
        case 'ro':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("hfjxM")));
        case 'ru':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("e62fr")));
        case 'sl':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("42ixm")));
        case 'sr-RS':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("d4Tsy")));
        case 'sr-YR':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("lP6as")));
        case 'sr':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("iHNvI")));
        case 'sv':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("7H13K")));
        case 'th':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("dT4Yv")));
        case 'tr':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("g2mxY")));
        case 'uk':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("a4MvO")));
        case 'vi':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("5oMhF")));
        case 'zh-CN':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("2rTEY")));
        case 'zh-TW':
            return $8183d8340bc03897$var$importHelper(await (parcelRequire("3uFRD")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($iZLE9));
    }
};

});
parcelRegister("iZLE9", function(module, exports) {
module.exports = JSON.parse("{\"jira-chronos.jira-plans-user-invited.message-template.email.body.avatar.no-translate\":[{\"type\":0,\"value\":\"avatar\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.blueprint.no-translate\":[{\"type\":0,\"value\":\"blueprintLogo\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.collborate.message\":[{\"type\":0,\"value\":\"Collaborate, align, and deliver work, all in \"},{\"children\":[{\"type\":0,\"value\":\" one place \"}],\"type\":8,\"value\":\"b\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.collect.message\":[{\"type\":0,\"value\":\"Collect and send work to other teams or stakeholders using \"},{\"children\":[{\"type\":0,\"value\":\" forms \"}],\"type\":8,\"value\":\"b\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.globe.no-translate\":[{\"type\":0,\"value\":\"globeLogo\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.invited-message\":[{\"type\":1,\"value\":\"userName\"},{\"type\":0,\"value\":\"  invited you to \"},{\"children\":[{\"type\":0,\"value\":\" \"},{\"type\":1,\"value\":\"planTitle\"},{\"type\":0,\"value\":\" \"}],\"type\":8,\"value\":\"b\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.join.link\":[{\"type\":0,\"value\":\"Join the Plan\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.learn.more.message\":[{\"type\":0,\"value\":\"Learn more about Jira\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.logo.no-translate\":[{\"type\":0,\"value\":\"logo\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.contactus.template\":[{\"type\":0,\"value\":\"Contact us\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.copyright.template\":[{\"type\":0,\"value\":\"Copyright 2025 Atlassian Pty Ltd. All rights reserved.\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.location.template\":[{\"type\":0,\"value\":\"We are located at 341 George Street, Sydney, NSW, 2000, Australia.\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.policy.template\":[{\"type\":0,\"value\":\"Privacy policy\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.policy.template.dot\":[{\"type\":0,\"value\":\".\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.use.jira.generic.message\":[{\"type\":0,\"value\":\"Use Jira to...\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.view.work.message\":[{\"type\":0,\"value\":\"View work your way using the \"},{\"children\":[{\"type\":0,\"value\":\" list, board, calendar \"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" and \"},{\"children\":[{\"type\":0,\"value\":\" timeline \"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" views\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.body.write.no-translate\":[{\"type\":0,\"value\":\"writeLogo\"}],\"jira-chronos.jira-plans-user-invited.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"[JIRA] (\"},{\"type\":1,\"value\":\"userName\"},{\"type\":0,\"value\":\") invited you to (\"},{\"type\":1,\"value\":\"planTitle\"},{\"type\":0,\"value\":\")\"}],\"jira-plan-add-user-changeboarding.message-templates.spotlight-body\":[{\"type\":0,\"value\":\"Use \"},{\"children\":[{\"type\":0,\"value\":\"Add people\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" in this menu to share this plan with people outside of your organization.\"}],\"jira-plan-add-user-changeboarding.message-templates.spotlight-cta\":[{\"type\":0,\"value\":\"Close\"}],\"jira-plan-add-user-changeboarding.message-templates.spotlight-header\":[{\"type\":0,\"value\":\"Spread the good word\"}],\"jira-plans-efa-change-boarding.message-templates.flag.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-plans-efa-change-boarding.message-templates.flag.read-more\":[{\"type\":0,\"value\":\"Read more\"}],\"jira-plans-efa-change-boarding.message-templates.flag.text.non-final\":[{\"type\":0,\"value\":\"Some fields in Timeline might no longer be available for your projects.\"}]}");

});

parcelRegister("7ULI1", function(module, exports) {

let $5c32c568cf443e5f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5c32c568cf443e5f$var$load("kI2yK").then(()=>parcelRequire('gZbZg'));

});

parcelRegister("gDYS4", function(module, exports) {

let $c1df81960c6da6cc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c1df81960c6da6cc$var$load("2npMO").then(()=>parcelRequire('5feyh'));

});

parcelRegister("eB9B7", function(module, exports) {

let $aa0bf75023684d25$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $aa0bf75023684d25$var$load("i4tj1").then(()=>parcelRequire('gbYQq'));

});

parcelRegister("JOJzk", function(module, exports) {

let $089b8ecbc2a5f0f8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $089b8ecbc2a5f0f8$var$load("gj1Mh").then(()=>parcelRequire('h42SG'));

});

parcelRegister("6SPcW", function(module, exports) {

let $502f8207e198781a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $502f8207e198781a$var$load("24xvg").then(()=>parcelRequire('8QKlS'));

});

parcelRegister("jO1M9", function(module, exports) {

let $e6b4106e45df89a1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e6b4106e45df89a1$var$load("1doau").then(()=>parcelRequire('hdvaV'));

});

parcelRegister("aWx60", function(module, exports) {

let $7f78fe4a98acfd7d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7f78fe4a98acfd7d$var$load("5Us6B").then(()=>parcelRequire('8FWQu'));

});

parcelRegister("dMwz0", function(module, exports) {

let $a0890488c578243f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a0890488c578243f$var$load("1lFmF").then(()=>parcelRequire('2eZuo'));

});

parcelRegister("5mPZu", function(module, exports) {

let $3e8756153a24500f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3e8756153a24500f$var$load("45Jeg").then(()=>parcelRequire('1rLIn'));

});

parcelRegister("6qKN2", function(module, exports) {

let $4ae977503bff998d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4ae977503bff998d$var$load("2lVtw").then(()=>parcelRequire('hGUUu'));

});

parcelRegister("H4Lhl", function(module, exports) {

let $0817b5d067f095c8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0817b5d067f095c8$var$load("8ahsG").then(()=>parcelRequire('amGNd'));

});

parcelRegister("hYscG", function(module, exports) {

let $d15deaebb87c8f1c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d15deaebb87c8f1c$var$load("1pgcF").then(()=>parcelRequire('gea55'));

});

parcelRegister("bywzC", function(module, exports) {

let $869c2314bee2994b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $869c2314bee2994b$var$load("dzrgP").then(()=>parcelRequire('4tpnI'));

});

parcelRegister("qxrtp", function(module, exports) {

let $04fc5ebb060fb8e0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $04fc5ebb060fb8e0$var$load("2azdn").then(()=>parcelRequire('5d02Y'));

});

parcelRegister("eAR1f", function(module, exports) {

let $a9fd8dfe0d66501c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a9fd8dfe0d66501c$var$load("bzdFa").then(()=>parcelRequire('bkWua'));

});

parcelRegister("eIMzO", function(module, exports) {

let $ab7adb136a85a2e9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ab7adb136a85a2e9$var$load("4eK2n").then(()=>parcelRequire('6F9N3'));

});

parcelRegister("ddcy6", function(module, exports) {

let $99e63942c88f63b1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $99e63942c88f63b1$var$load("kPM3D").then(()=>parcelRequire('fXNSd'));

});

parcelRegister("2khQ1", function(module, exports) {

let $1b1b4947e503dffe$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1b1b4947e503dffe$var$load("gGwtG").then(()=>parcelRequire('f57dT'));

});

parcelRegister("cnsvO", function(module, exports) {

let $902dbfef2d451abd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $902dbfef2d451abd$var$load("kfygw").then(()=>parcelRequire('kyErz'));

});

parcelRegister("lOOZP", function(module, exports) {

let $fe25d346edc19491$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fe25d346edc19491$var$load("1pRzg").then(()=>parcelRequire('QmCwl'));

});

parcelRegister("fmShI", function(module, exports) {

let $b30304e8e704fb9f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b30304e8e704fb9f$var$load("g9GjC").then(()=>parcelRequire('8MNo4'));

});

parcelRegister("hfjxM", function(module, exports) {

let $c8e2ff5f8982f843$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c8e2ff5f8982f843$var$load("5PeIp").then(()=>parcelRequire('9VzqH'));

});

parcelRegister("e62fr", function(module, exports) {

let $a4335ea489f59b1c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a4335ea489f59b1c$var$load("hHCDI").then(()=>parcelRequire('9avbu'));

});

parcelRegister("42ixm", function(module, exports) {

let $2f05ba6444c36799$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2f05ba6444c36799$var$load("jnMhq").then(()=>parcelRequire('lm91R'));

});

parcelRegister("d4Tsy", function(module, exports) {

let $9856ab2e95305f58$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9856ab2e95305f58$var$load("9UCAa").then(()=>parcelRequire('3eA06'));

});

parcelRegister("lP6as", function(module, exports) {

let $fe33252b4625d0d5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fe33252b4625d0d5$var$load("dKiFj").then(()=>parcelRequire('a2gpy'));

});

parcelRegister("iHNvI", function(module, exports) {

let $d9e2a5e384170855$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d9e2a5e384170855$var$load("kdI8V").then(()=>parcelRequire('9Orpa'));

});

parcelRegister("7H13K", function(module, exports) {

let $599d5ef1e9c3dbe1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $599d5ef1e9c3dbe1$var$load("5GZT7").then(()=>parcelRequire('jsvoT'));

});

parcelRegister("dT4Yv", function(module, exports) {

let $a1c4454ee54d42cc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a1c4454ee54d42cc$var$load("bNlqx").then(()=>parcelRequire('8jl7A'));

});

parcelRegister("g2mxY", function(module, exports) {

let $bace529e0cbbc74e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bace529e0cbbc74e$var$load("hGTmb").then(()=>parcelRequire('9P6pN'));

});

parcelRegister("a4MvO", function(module, exports) {

let $755fe896ae6b492b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $755fe896ae6b492b$var$load("20PrQ").then(()=>parcelRequire('ha4BE'));

});

parcelRegister("5oMhF", function(module, exports) {

let $3ee4a5d29f29b93f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3ee4a5d29f29b93f$var$load("gkUAv").then(()=>parcelRequire('i393D'));

});

parcelRegister("2rTEY", function(module, exports) {

let $1c8947488a5b51f4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1c8947488a5b51f4$var$load("9dxd9").then(()=>parcelRequire('3OlyS'));

});

parcelRegister("3uFRD", function(module, exports) {

let $28b4a5c0dba665d6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $28b4a5c0dba665d6$var$load("cLYXz").then(()=>parcelRequire('2CjZW'));

});


parcelRegister("aaLWf", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $3f0b6ba577191c46$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $4HRIW = parcelRequire("4HRIW");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3f0b6ba577191c46$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $3f0b6ba577191c46$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("g1H97")));
        case 'da':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("7MSII")));
        case 'de':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("1sBZ2")));
        case 'en-GB':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("8IJqB")));
        case 'en-US':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("86NZ2")));
        case 'en-XA':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("fjgPi")));
        case 'en-XB':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("5ogL1")));
        case 'en-ZZ':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("3eBPT")));
        case 'en':
            return $3f0b6ba577191c46$var$importHelper(await Promise.resolve((parcelRequire("4HRIW"))));
        case 'es':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("bOfab")));
        case 'et':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("4HwHh")));
        case 'fi':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("hoZ4N")));
        case 'fr':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("d32xV")));
        case 'hr':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("ihYFl")));
        case 'hu':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("8eSx8")));
        case 'it':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("aHrvX")));
        case 'ja':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("iMWdF")));
        case 'ko':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("aj9Jd")));
        case 'nb':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("29t4a")));
        case 'nl':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("9G09i")));
        case 'pl':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("gaUpY")));
        case 'pt-BR':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("aLv4G")));
        case 'ro':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("bMC1U")));
        case 'ru':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("32wAX")));
        case 'sl':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("4WimX")));
        case 'sr-RS':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("2DEdR")));
        case 'sr-YR':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("5n6py")));
        case 'sr':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("kEJ4Z")));
        case 'sv':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("34Kpo")));
        case 'th':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("iPMDU")));
        case 'tr':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("7Nq8x")));
        case 'uk':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("5PTIY")));
        case 'vi':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("bf6Hi")));
        case 'zh-CN':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("go1u9")));
        case 'zh-TW':
            return $3f0b6ba577191c46$var$importHelper(await (parcelRequire("jjuIM")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4HRIW));
    }
};

});
parcelRegister("4HRIW", function(module, exports) {
module.exports = JSON.parse("{\"jira-board-inline-editing-onboarding.message-templates.ok-button\":[{\"type\":0,\"value\":\"OK\"}],\"jira-board-inline-editing-onboarding.message-templates.spotlight-body\":[{\"type\":0,\"value\":\"You can now edit fields like the summary, assignee, parent and estimate. Select the fields to edit them.\"}],\"jira-board-inline-editing-onboarding.message-templates.spotlight-header\":[{\"type\":0,\"value\":\"Edit details of the work item directly in the board\"}]}");

});

parcelRegister("g1H97", function(module, exports) {

let $baae353bb7b8be5f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $baae353bb7b8be5f$var$load("6xtAY").then(()=>parcelRequire('1XNBy'));

});

parcelRegister("7MSII", function(module, exports) {

let $5ab776611f3ea1f4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5ab776611f3ea1f4$var$load("jIYXm").then(()=>parcelRequire('emLXy'));

});

parcelRegister("1sBZ2", function(module, exports) {

let $1105deae8f0c8515$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1105deae8f0c8515$var$load("jWczE").then(()=>parcelRequire('4DMlO'));

});

parcelRegister("8IJqB", function(module, exports) {

let $6595abe1e576c0e7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6595abe1e576c0e7$var$load("iB7lv").then(()=>parcelRequire('7SHoI'));

});

parcelRegister("86NZ2", function(module, exports) {

let $5e75a7f63e094d8e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5e75a7f63e094d8e$var$load("gbFsY").then(()=>parcelRequire('dQRpn'));

});

parcelRegister("fjgPi", function(module, exports) {

let $b255aeb6d0e0174a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b255aeb6d0e0174a$var$load("c3zvC").then(()=>parcelRequire('9HkxA'));

});

parcelRegister("5ogL1", function(module, exports) {

let $3ecc31511085e749$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3ecc31511085e749$var$load("9PqYA").then(()=>parcelRequire('eaEMq'));

});

parcelRegister("3eBPT", function(module, exports) {

let $25b00751b52bc6a8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $25b00751b52bc6a8$var$load("dj7Zx").then(()=>parcelRequire('63KJl'));

});

parcelRegister("bOfab", function(module, exports) {

let $899020573bc1c060$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $899020573bc1c060$var$load("g3Bbf").then(()=>parcelRequire('baEvu'));

});

parcelRegister("4HwHh", function(module, exports) {

let $36c48a8274000df8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $36c48a8274000df8$var$load("jcu06").then(()=>parcelRequire('6mmdF'));

});

parcelRegister("hoZ4N", function(module, exports) {

let $cab40e0b7558f576$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cab40e0b7558f576$var$load("24CbH").then(()=>parcelRequire('3YjeN'));

});

parcelRegister("d32xV", function(module, exports) {

let $97fd87c822f452bb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $97fd87c822f452bb$var$load("cxTe4").then(()=>parcelRequire('kd5jR'));

});

parcelRegister("ihYFl", function(module, exports) {

let $d508df852c01cd11$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d508df852c01cd11$var$load("ecAF2").then(()=>parcelRequire('96MKb'));

});

parcelRegister("8eSx8", function(module, exports) {

let $5ff9eebfadb3ce45$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5ff9eebfadb3ce45$var$load("l94tN").then(()=>parcelRequire('dGeJo'));

});

parcelRegister("aHrvX", function(module, exports) {

let $7ca3435061f07753$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7ca3435061f07753$var$load("5jqhd").then(()=>parcelRequire('h37Gf'));

});

parcelRegister("iMWdF", function(module, exports) {

let $dad9dedd50dacaf5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dad9dedd50dacaf5$var$load("kr8C5").then(()=>parcelRequire('l1hP5'));

});

parcelRegister("aj9Jd", function(module, exports) {

let $78133994ef6b2afb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $78133994ef6b2afb$var$load("b2wu6").then(()=>parcelRequire('6MegR'));

});

parcelRegister("29t4a", function(module, exports) {

let $1912f7f50a5f1592$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1912f7f50a5f1592$var$load("TjtPr").then(()=>parcelRequire('3eqTq'));

});

parcelRegister("9G09i", function(module, exports) {

let $70b826e0b62a2556$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $70b826e0b62a2556$var$load("F4P23").then(()=>parcelRequire('ihB5c'));

});

parcelRegister("gaUpY", function(module, exports) {

let $bc6957ea00bd61aa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bc6957ea00bd61aa$var$load("1lybJ").then(()=>parcelRequire('fwZt1'));

});

parcelRegister("aLv4G", function(module, exports) {

let $7d6665f27c9290cc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7d6665f27c9290cc$var$load("lqU6m").then(()=>parcelRequire('a6Hy1'));

});

parcelRegister("bMC1U", function(module, exports) {

let $8941ad5599dd7bad$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8941ad5599dd7bad$var$load("bgGzk").then(()=>parcelRequire('iVHD9'));

});

parcelRegister("32wAX", function(module, exports) {

let $236ad7b3968ecf98$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $236ad7b3968ecf98$var$load("4QAoN").then(()=>parcelRequire('hMUZI'));

});

parcelRegister("4WimX", function(module, exports) {

let $398ad3f114680002$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $398ad3f114680002$var$load("45Dnd").then(()=>parcelRequire('dfmdX'));

});

parcelRegister("2DEdR", function(module, exports) {

let $1ebe6ca16ab33d2c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1ebe6ca16ab33d2c$var$load("hpyIR").then(()=>parcelRequire('4xK4c'));

});

parcelRegister("5n6py", function(module, exports) {

let $3e9412d527ae2c1c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3e9412d527ae2c1c$var$load("15Qlg").then(()=>parcelRequire('bIMkm'));

});

parcelRegister("kEJ4Z", function(module, exports) {

let $f09a82e68738ff5e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f09a82e68738ff5e$var$load("hw5Ed").then(()=>parcelRequire('exZ75'));

});

parcelRegister("34Kpo", function(module, exports) {

let $23d5be9627536903$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $23d5be9627536903$var$load("lIiR7").then(()=>parcelRequire('g9JW2'));

});

parcelRegister("iPMDU", function(module, exports) {

let $db62b8dc2aa9afb4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $db62b8dc2aa9afb4$var$load("lWv9v").then(()=>parcelRequire('574Oo'));

});

parcelRegister("7Nq8x", function(module, exports) {

let $5ad16235389b4f44$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5ad16235389b4f44$var$load("7VYIX").then(()=>parcelRequire('70Qdg'));

});

parcelRegister("5PTIY", function(module, exports) {

let $43fcf0e0c0b20544$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $43fcf0e0c0b20544$var$load("kvT1Q").then(()=>parcelRequire('8esTS'));

});

parcelRegister("bf6Hi", function(module, exports) {

let $82f64a5c69fbd1d1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $82f64a5c69fbd1d1$var$load("eUr2C").then(()=>parcelRequire('3ozTs'));

});

parcelRegister("go1u9", function(module, exports) {

let $bee00a353e3b49f4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bee00a353e3b49f4$var$load("i4V7c").then(()=>parcelRequire('kYBdD'));

});

parcelRegister("jjuIM", function(module, exports) {

let $e0f79f40501a008b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e0f79f40501a008b$var$load("2k6s7").then(()=>parcelRequire('cwU5K'));

});


parcelRegister("cJHqL", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $ed5ab329465a7634$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $j2Wv9 = parcelRequire("j2Wv9");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ed5ab329465a7634$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $ed5ab329465a7634$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("37SZP")));
        case 'da':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("hpshN")));
        case 'de':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("6CkkH")));
        case 'en-GB':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("laqDd")));
        case 'en-US':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("32zpK")));
        case 'en-XA':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("3K4dd")));
        case 'en-XB':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("lmDCP")));
        case 'en-ZZ':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("f4Hmm")));
        case 'en':
            return $ed5ab329465a7634$var$importHelper(await Promise.resolve((parcelRequire("j2Wv9"))));
        case 'es':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("5ImGL")));
        case 'et':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("deRKD")));
        case 'fi':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("cSK1O")));
        case 'fr':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("aRTtq")));
        case 'hr':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("9rlH4")));
        case 'hu':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("egtke")));
        case 'it':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("lS7Z0")));
        case 'ja':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("QNUNO")));
        case 'ko':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("836kF")));
        case 'nb':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("fnvDM")));
        case 'nl':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("SjX1F")));
        case 'pl':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("3QsSC")));
        case 'pt-BR':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("4LX27")));
        case 'ro':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("cFZsE")));
        case 'ru':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("lojFE")));
        case 'sl':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("8n5xj")));
        case 'sr-RS':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("aRSGF")));
        case 'sr-YR':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("4yltO")));
        case 'sr':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("fJ5qy")));
        case 'sv':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("jcuUq")));
        case 'th':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("eVrTK")));
        case 'tr':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("cX70Q")));
        case 'uk':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("4XpB6")));
        case 'vi':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("iktt2")));
        case 'zh-CN':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("67u36")));
        case 'zh-TW':
            return $ed5ab329465a7634$var$importHelper(await (parcelRequire("kVzh2")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($j2Wv9));
    }
};

});
parcelRegister("j2Wv9", function(module, exports) {
module.exports = JSON.parse("{\"jira-nin-list-merge-modal-onboarding.closeButton\":[{\"type\":0,\"value\":\"Close\"}],\"jira-nin-list-merge-modal-onboarding.copyListSettingsDescription\":[{\"type\":0,\"value\":\"Want us to apply your current filter and group settings to this new List view?\"}],\"jira-nin-list-merge-modal-onboarding.copyListSettingsNo\":[{\"type\":0,\"value\":\"No\"}],\"jira-nin-list-merge-modal-onboarding.copyListSettingsYes\":[{\"type\":0,\"value\":\"Yes\"}],\"jira-nin-list-merge-modal-onboarding.description\":[{\"type\":0,\"value\":\"We've merged the best of List and All Work into a faster, accessible experience. Core features such as sorting and conditional formatting will still be available\"}],\"jira-nin-list-merge-modal-onboarding.exploreListViewButtonLabel\":[{\"type\":0,\"value\":\"Explore List view\"}],\"jira-nin-list-merge-modal-onboarding.heading\":[{\"type\":0,\"value\":\"We've merged List and All Work views\"}],\"jira-nin-list-merge-modal-onboarding.learnMoreLink\":[{\"type\":0,\"value\":\"Read our community post about the merge of List and All Work views\"}],\"jira-nin-list-merge-spotlight-onboarding.spotlight.body\":[{\"type\":0,\"value\":\"We've merged the best of List and All Work into a faster, accessible experience.\"}],\"jira-nin-list-merge-spotlight-onboarding.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-nin-list-merge-spotlight-onboarding.spotlight.filter\":[{\"type\":0,\"value\":\"One place to search work and filter results to find what you need.\"}],\"jira-nin-list-merge-spotlight-onboarding.spotlight.heading\":[{\"type\":0,\"value\":\"We've merged List and All Work views\"}],\"jira-nin-list-merge-spotlight-onboarding.spotlight.more-actions\":[{\"type\":0,\"value\":\"Dive deeper - view work items as a chart, use format rules to highlight key work, and more.\"}],\"jira-nin-list-merge-spotlight-onboarding.spotlight.next\":[{\"type\":0,\"value\":\"Next\"}],\"jira-nin-list-merge-spotlight-onboarding.spotlight.ok\":[{\"type\":0,\"value\":\"OK\"}],\"jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more\":[{\"type\":0,\"value\":\"Tell me more\"}],\"jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more-aria-label\":[{\"type\":0,\"value\":\"Read our community post about the merge of List and All Work views\"}]}");

});

parcelRegister("37SZP", function(module, exports) {

let $246cafa4a52d0147$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $246cafa4a52d0147$var$load("3MBvw").then(()=>parcelRequire('csceK'));

});

parcelRegister("hpshN", function(module, exports) {

let $cacab682122ff8d4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cacab682122ff8d4$var$load("1pT0P").then(()=>parcelRequire('1l3Am'));

});

parcelRegister("6CkkH", function(module, exports) {

let $4d161062785e1c12$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4d161062785e1c12$var$load("cSRE0").then(()=>parcelRequire('errV0'));

});

parcelRegister("laqDd", function(module, exports) {

let $f68f30a09fe4dfd7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f68f30a09fe4dfd7$var$load("kFSxg").then(()=>parcelRequire('bWsYN'));

});

parcelRegister("32zpK", function(module, exports) {

let $236d078494290d58$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $236d078494290d58$var$load("6Bs42").then(()=>parcelRequire('228sO'));

});

parcelRegister("3K4dd", function(module, exports) {

let $2b98ef724a25bcc7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2b98ef724a25bcc7$var$load("doBB1").then(()=>parcelRequire('7Zu1M'));

});

parcelRegister("lmDCP", function(module, exports) {

let $f8da63c7e1025e23$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f8da63c7e1025e23$var$load("dBjT3").then(()=>parcelRequire('hV43N'));

});

parcelRegister("f4Hmm", function(module, exports) {

let $af98dd0af95f373e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $af98dd0af95f373e$var$load("idAAc").then(()=>parcelRequire('hSB6E'));

});

parcelRegister("5ImGL", function(module, exports) {

let $4292a94eed23dc91$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4292a94eed23dc91$var$load("5D3Lh").then(()=>parcelRequire('hQP06'));

});

parcelRegister("deRKD", function(module, exports) {

let $9a36470298eb61f8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9a36470298eb61f8$var$load("662HK").then(()=>parcelRequire('462vF'));

});

parcelRegister("cSK1O", function(module, exports) {

let $026b959a8d151aa9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $026b959a8d151aa9$var$load("fAH1c").then(()=>parcelRequire('dBHFg'));

});

parcelRegister("aRTtq", function(module, exports) {

let $7e99e285a6687705$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7e99e285a6687705$var$load("1uSat").then(()=>parcelRequire('9vAY3'));

});

parcelRegister("9rlH4", function(module, exports) {

let $6df776967d9c2726$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6df776967d9c2726$var$load("7rCzU").then(()=>parcelRequire('XEoyG'));

});

parcelRegister("egtke", function(module, exports) {

let $a6294eb89960825c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a6294eb89960825c$var$load("fUaEn").then(()=>parcelRequire('iTOvX'));

});

parcelRegister("lS7Z0", function(module, exports) {

let $fec4d5619c5c6e8a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fec4d5619c5c6e8a$var$load("3b6eH").then(()=>parcelRequire('8J1qf'));

});

parcelRegister("QNUNO", function(module, exports) {

let $09eb938e72751a2d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $09eb938e72751a2d$var$load("3T1Ai").then(()=>parcelRequire('a9dSI'));

});

parcelRegister("836kF", function(module, exports) {

let $5dc3840592cba5d7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5dc3840592cba5d7$var$load("ewCZz").then(()=>parcelRequire('fsEoe'));

});

parcelRegister("fnvDM", function(module, exports) {

let $b3218c29df21db6a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b3218c29df21db6a$var$load("czb1b").then(()=>parcelRequire('g3fVc'));

});

parcelRegister("SjX1F", function(module, exports) {

let $0a34851e88aee3ac$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0a34851e88aee3ac$var$load("aObNP").then(()=>parcelRequire('jXzH5'));

});

parcelRegister("3QsSC", function(module, exports) {

let $2ccca165fdc8292f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2ccca165fdc8292f$var$load("3Rmf4").then(()=>parcelRequire('atJwN'));

});

parcelRegister("4LX27", function(module, exports) {

let $379957fdd2f5eaac$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $379957fdd2f5eaac$var$load("47Sh4").then(()=>parcelRequire('idIFf'));

});

parcelRegister("cFZsE", function(module, exports) {

let $93a8fd46c90dbcc8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $93a8fd46c90dbcc8$var$load("j2RmT").then(()=>parcelRequire('68koE'));

});

parcelRegister("lojFE", function(module, exports) {

let $f92b19100233a108$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f92b19100233a108$var$load("qhIUQ").then(()=>parcelRequire('2P489'));

});

parcelRegister("8n5xj", function(module, exports) {

let $6184c41a69092694$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6184c41a69092694$var$load("3hMl6").then(()=>parcelRequire('lVZMq'));

});

parcelRegister("aRSGF", function(module, exports) {

let $7e9946550eff387a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7e9946550eff387a$var$load("9GLzo").then(()=>parcelRequire('3npjX'));

});

parcelRegister("4yltO", function(module, exports) {

let $350affd90015d06d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $350affd90015d06d$var$load("6aSaJ").then(()=>parcelRequire('gEVtY'));

});

parcelRegister("fJ5qy", function(module, exports) {

let $b72f44b7e950b03e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b72f44b7e950b03e$var$load("hBBJq").then(()=>parcelRequire('8TOB0'));

});

parcelRegister("jcuUq", function(module, exports) {

let $dfa71d3800a5091b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dfa71d3800a5091b$var$load("bnXvl").then(()=>parcelRequire('if0R5'));

});

parcelRegister("eVrTK", function(module, exports) {

let $addc078d9d7f829e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $addc078d9d7f829e$var$load("1AVO6").then(()=>parcelRequire('5ofNh'));

});

parcelRegister("cX70Q", function(module, exports) {

let $96e06f44047d1d74$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $96e06f44047d1d74$var$load("klF89").then(()=>parcelRequire('aQptP'));

});

parcelRegister("4XpB6", function(module, exports) {

let $39c087404625fdaa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $39c087404625fdaa$var$load("emEnl").then(()=>parcelRequire('9F3mr'));

});

parcelRegister("iktt2", function(module, exports) {

let $d580f3dec822386c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d580f3dec822386c$var$load("2npkB").then(()=>parcelRequire('fdWPZ'));

});

parcelRegister("67u36", function(module, exports) {

let $474ab49ce5f84112$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $474ab49ce5f84112$var$load("8KfBL").then(()=>parcelRequire('ehzs4'));

});

parcelRegister("kVzh2", function(module, exports) {

let $f3c47e257358e5b1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f3c47e257358e5b1$var$load("ctJd9").then(()=>parcelRequire('4oDCw'));

});


parcelRegister("j8GN9", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $770f10fa33df70cb$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $d6CPN = parcelRequire("d6CPN");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $770f10fa33df70cb$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $770f10fa33df70cb$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("6c2vK")));
        case 'da':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("bGu4d")));
        case 'de':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("bmPmj")));
        case 'en-GB':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("4wVVw")));
        case 'en-US':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("egKnl")));
        case 'en-XA':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("5fevp")));
        case 'en-XB':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("30FVf")));
        case 'en-ZZ':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("fKD9F")));
        case 'en':
            return $770f10fa33df70cb$var$importHelper(await Promise.resolve((parcelRequire("d6CPN"))));
        case 'es':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("3CluT")));
        case 'et':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("4ekP8")));
        case 'fi':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("badTm")));
        case 'fr':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("1Xzay")));
        case 'hr':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("2ZZnK")));
        case 'hu':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("bCQqA")));
        case 'it':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("cKtl5")));
        case 'ja':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("eiT4o")));
        case 'ko':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("is5OJ")));
        case 'nb':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("4MymN")));
        case 'nl':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("42pVn")));
        case 'pl':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("bmy4p")));
        case 'pt-BR':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("49Vd6")));
        case 'ro':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("iDgBT")));
        case 'ru':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("gJZsK")));
        case 'sl':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("keJvz")));
        case 'sr-RS':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("63yAm")));
        case 'sr-YR':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("8u4vd")));
        case 'sr':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("aNZri")));
        case 'sv':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("39cN6")));
        case 'th':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("8MI4I")));
        case 'tr':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("jGFNZ")));
        case 'uk':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("bZJUA")));
        case 'vi':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("8vu4A")));
        case 'zh-CN':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("dzpg6")));
        case 'zh-TW':
            return $770f10fa33df70cb$var$importHelper(await (parcelRequire("2vkCK")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($d6CPN));
    }
};

});
parcelRegister("d6CPN", function(module, exports) {
module.exports = JSON.parse("{\"jira-nin-grid-navigation-onboarding.closeButton\":[{\"type\":0,\"value\":\"Close\"}],\"jira-nin-grid-navigation-onboarding.enterEscapeNavigation\":[{\"children\":[{\"type\":0,\"value\":\"Enter\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" activates inline edit mode while \"},{\"children\":[{\"type\":0,\"value\":\"Escape\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" returns you to cell navigation.\"}],\"jira-nin-grid-navigation-onboarding.heading\":[{\"type\":0,\"value\":\"Improved keyboard navigation\"}],\"jira-nin-grid-navigation-onboarding.homeEndPageNavigation\":[{\"children\":[{\"type\":0,\"value\":\"Home\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" skips to the first cell in a row, \"},{\"children\":[{\"type\":0,\"value\":\"End\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" to the last. \"},{\"children\":[{\"type\":0,\"value\":\"Page Down\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" scrolls 1 page down, \"},{\"children\":[{\"type\":0,\"value\":\"Page Up\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" scrolls 1 page up, keeping focus in the same cell.\"}],\"jira-nin-grid-navigation-onboarding.moreShortcuts\":[{\"type\":0,\"value\":\"More shortcuts\"}],\"jira-nin-grid-navigation-onboarding.okButton\":[{\"type\":0,\"value\":\"Ok\"}],\"jira-nin-grid-navigation-onboarding.tabAndArrowNavigation\":[{\"children\":[{\"type\":0,\"value\":\"Tab\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" into and out of the view quickly, and use \"},{\"children\":[{\"type\":0,\"value\":\"arrow keys\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" to navigate cells.\"}]}");

});

parcelRegister("6c2vK", function(module, exports) {

let $4825cfb21cba8964$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4825cfb21cba8964$var$load("5IUGw").then(()=>parcelRequire('9xFQP'));

});

parcelRegister("bGu4d", function(module, exports) {

let $881af0a6ece7603e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $881af0a6ece7603e$var$load("8ZuEk").then(()=>parcelRequire('9wBqm'));

});

parcelRegister("bmPmj", function(module, exports) {

let $84699698e65c3b93$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $84699698e65c3b93$var$load("1mgb7").then(()=>parcelRequire('h58Wv'));

});

parcelRegister("4wVVw", function(module, exports) {

let $34c715a1303d2d6b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $34c715a1303d2d6b$var$load("cXTpS").then(()=>parcelRequire('l4rkB'));

});

parcelRegister("egKnl", function(module, exports) {

let $a636888c2cf4529d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a636888c2cf4529d$var$load("jnh6c").then(()=>parcelRequire('aa5Ec'));

});

parcelRegister("5fevp", function(module, exports) {

let $3d199af36349a567$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3d199af36349a567$var$load("gzeTK").then(()=>parcelRequire('lOEXe'));

});

parcelRegister("30FVf", function(module, exports) {

let $2311e412fe2abc8e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2311e412fe2abc8e$var$load("fSlgw").then(()=>parcelRequire('jzdDW'));

});

parcelRegister("fKD9F", function(module, exports) {

let $b779863cfd902689$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b779863cfd902689$var$load("dWn5S").then(()=>parcelRequire('1anPL'));

});

parcelRegister("3CluT", function(module, exports) {

let $2a2598a2163701d8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2a2598a2163701d8$var$load("lHQSK").then(()=>parcelRequire('cCJ7U'));

});

parcelRegister("4ekP8", function(module, exports) {

let $31489f664a428fee$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $31489f664a428fee$var$load("4h23l").then(()=>parcelRequire('eaTi4'));

});

parcelRegister("badTm", function(module, exports) {

let $820b67865c287d89$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $820b67865c287d89$var$load("3rar8").then(()=>parcelRequire('gChmG'));

});

parcelRegister("1Xzay", function(module, exports) {

let $16d6950365c3aeda$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $16d6950365c3aeda$var$load("hKRyr").then(()=>parcelRequire('fOLR4'));

});

parcelRegister("2ZZnK", function(module, exports) {

let $22f0e47b6e1effba$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $22f0e47b6e1effba$var$load("2GQ7v").then(()=>parcelRequire('caTIf'));

});

parcelRegister("bCQqA", function(module, exports) {

let $876be96245db3ce1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $876be96245db3ce1$var$load("5qN11").then(()=>parcelRequire('jh96n'));

});

parcelRegister("cKtl5", function(module, exports) {

let $94808a0b17c3f37a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $94808a0b17c3f37a$var$load("s6DP3").then(()=>parcelRequire('3Turf'));

});

parcelRegister("eiT4o", function(module, exports) {

let $a69d76de65539df2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a69d76de65539df2$var$load("d23c8").then(()=>parcelRequire('kYkoO'));

});

parcelRegister("is5OJ", function(module, exports) {

let $d6ef5aba3d790252$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d6ef5aba3d790252$var$load("dbq8T").then(()=>parcelRequire('9T3M5'));

});

parcelRegister("4MymN", function(module, exports) {

let $37b64d9e3f8ceca1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $37b64d9e3f8ceca1$var$load("a6cu4").then(()=>parcelRequire('jyEiO'));

});

parcelRegister("42pVn", function(module, exports) {

let $2f0b7562a23a4e48$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2f0b7562a23a4e48$var$load("k1Iwj").then(()=>parcelRequire('fAkQo'));

});

parcelRegister("bmy4p", function(module, exports) {

let $845c2d633c4ce925$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $845c2d633c4ce925$var$load("gdsrn").then(()=>parcelRequire('hxewn'));

});

parcelRegister("49Vd6", function(module, exports) {

let $30746172691dfee9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $30746172691dfee9$var$load("cTAL9").then(()=>parcelRequire('5z6tZ'));

});

parcelRegister("iDgBT", function(module, exports) {

let $d908c0f3da9a9d49$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d908c0f3da9a9d49$var$load("e26hO").then(()=>parcelRequire('ewP6I'));

});

parcelRegister("gJZsK", function(module, exports) {

let $c30086892d154bb3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c30086892d154bb3$var$load("j6zlk").then(()=>parcelRequire('jykQ3'));

});

parcelRegister("keJvz", function(module, exports) {

let $ebb86a6e29d00976$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ebb86a6e29d00976$var$load("6a6sS").then(()=>parcelRequire('9cCuA'));

});

parcelRegister("63yAm", function(module, exports) {

let $468dd9d52f6954b4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $468dd9d52f6954b4$var$load("2nPur").then(()=>parcelRequire('6FbQJ'));

});

parcelRegister("8u4vd", function(module, exports) {

let $62d49e2e2f732f39$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $62d49e2e2f732f39$var$load("9JRdD").then(()=>parcelRequire('5TQRA'));

});

parcelRegister("aNZri", function(module, exports) {

let $7dde2388dee2d8d0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7dde2388dee2d8d0$var$load("lAiG0").then(()=>parcelRequire('6qPsy'));

});

parcelRegister("39cN6", function(module, exports) {

let $24ac226891e36e7f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $24ac226891e36e7f$var$load("fpgs8").then(()=>parcelRequire('9GYPy'));

});

parcelRegister("8MI4I", function(module, exports) {

let $6654fecee86f98ed$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6654fecee86f98ed$var$load("7kcm0").then(()=>parcelRequire('fHT56'));

});

parcelRegister("jGFNZ", function(module, exports) {

let $e5525e38fb62b811$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e5525e38fb62b811$var$load("afhs6").then(()=>parcelRequire('2hFyC'));

});

parcelRegister("bZJUA", function(module, exports) {

let $8bb9015497d61bbe$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8bb9015497d61bbe$var$load("YBxHx").then(()=>parcelRequire('fNcOI'));

});

parcelRegister("8vu4A", function(module, exports) {

let $63188bdee4bc9ef9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $63188bdee4bc9ef9$var$load("5kBej").then(()=>parcelRequire('c72ix'));

});

parcelRegister("dzpg6", function(module, exports) {

let $9e122317facefadc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9e122317facefadc$var$load("5VyIc").then(()=>parcelRequire('Lckso'));

});

parcelRegister("2vkCK", function(module, exports) {

let $1d2e7984971c0456$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1d2e7984971c0456$var$load("cLNSA").then(()=>parcelRequire('7iUYY'));

});


parcelRegister("9poyK", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $7808f08de44406b5$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $98XtD = parcelRequire("98XtD");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7808f08de44406b5$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $7808f08de44406b5$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("lgm1p")));
        case 'da':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("bRiL0")));
        case 'de':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("dP1ON")));
        case 'en-GB':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("iCQT0")));
        case 'en-US':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("lEe7r")));
        case 'en-XA':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("2xIvo")));
        case 'en-XB':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("dXAhQ")));
        case 'en-ZZ':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("lqBYm")));
        case 'en':
            return $7808f08de44406b5$var$importHelper(await Promise.resolve((parcelRequire("98XtD"))));
        case 'es':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("k1lTI")));
        case 'et':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("9NxIo")));
        case 'fi':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("aLKTa")));
        case 'fr':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("fp7Dx")));
        case 'hr':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("2EbTD")));
        case 'hu':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("eVOox")));
        case 'it':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("1JPGj")));
        case 'ja':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("iMk2y")));
        case 'ko':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("4TvM1")));
        case 'nb':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("6oR3V")));
        case 'nl':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("f4oSp")));
        case 'pl':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("kZ0cC")));
        case 'pt-BR':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("lWYFZ")));
        case 'ro':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("iUHI4")));
        case 'ru':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("e7g7D")));
        case 'sl':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("juvIE")));
        case 'sr-RS':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("iknOH")));
        case 'sr-YR':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("htihg")));
        case 'sr':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("lt2Te")));
        case 'sv':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("9c91g")));
        case 'th':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("gtsmY")));
        case 'tr':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("5OTVk")));
        case 'uk':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("aligT")));
        case 'vi':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("kSygp")));
        case 'zh-CN':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("7rFoP")));
        case 'zh-TW':
            return $7808f08de44406b5$var$importHelper(await (parcelRequire("1m5TX")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($98XtD));
    }
};

});
parcelRegister("98XtD", function(module, exports) {
module.exports = JSON.parse("{\"jira-pandora.common.footer.address.no-translate\":[{\"type\":0,\"value\":\"341 George Street, Sydney, NSW, 2000, Australia\"}],\"jira-pandora.common.footer.copyright.no-translate\":[{\"type\":0,\"value\":\"Copyright 2025 Atlassian Pty Ltd. All rights reserved.\"}],\"jira-pandora.common.project-access-email.banner.alt\":[{\"type\":0,\"value\":\"Jira banner image\"}],\"jira-pandora.jira-project-access-granted.email.body.content\":[{\"type\":0,\"value\":\"You can now access \"},{\"children\":[{\"type\":1,\"value\":\"projectName\"}],\"type\":8,\"value\":\"b\"}],\"jira-pandora.jira-project-access-granted.email.body.redacted.content\":[{\"children\":[{\"type\":0,\"value\":\"You can now access your Jira project\"}],\"type\":8,\"value\":\"b\"}],\"jira-pandora.jira-project-access-granted.email.button.redacted.text\":[{\"type\":0,\"value\":\"View project\"}],\"jira-pandora.jira-project-access-granted.email.button.text\":[{\"type\":0,\"value\":\"View project\"}],\"jira-pandora.jira-project-access-granted.message-template.email.redacted.subject\":[{\"type\":0,\"value\":\"You've been granted access to your project\"}],\"jira-pandora.jira-project-access-granted.message-template.email.subject\":[{\"type\":0,\"value\":\"You've been granted access to \"},{\"type\":1,\"value\":\"projectName\"}],\"jira-pandora.jira-project-access-request-reminder.email.body.content\":[{\"type\":0,\"value\":\"Users have requested to join \"},{\"children\":[{\"type\":1,\"value\":\"projectName\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" project\"}],\"jira-pandora.jira-project-access-request-reminder.email.body.redacted.content\":[{\"children\":[{\"type\":0,\"value\":\"Users have requested to join your Jira project\"}],\"type\":8,\"value\":\"b\"}],\"jira-pandora.jira-project-access-request-reminder.email.button.redacted.text\":[{\"type\":0,\"value\":\"View access requests\"}],\"jira-pandora.jira-project-access-request-reminder.email.button.text\":[{\"type\":0,\"value\":\"View access requests\"}],\"jira-pandora.jira-project-access-request-reminder.message-template.email.redacted.subject\":[{\"type\":0,\"value\":\"Access request for your project\"}],\"jira-pandora.jira-project-access-request-reminder.message-template.email.subject\":[{\"type\":0,\"value\":\"Access request for \"},{\"type\":1,\"value\":\"projectName\"}],\"jira.jira-notify-reaction.message-template.text.single-reaction-with-name\":[{\"type\":0,\"value\":\":bell: *\"},{\"type\":1,\"value\":\"userName\"},{\"type\":0,\"value\":\" reacted to your comment*\"}],\"jira.jira-notify-reaction.message-template.text.view-comment\":[{\"type\":0,\"value\":\"View comment\"}]}");

});

parcelRegister("lgm1p", function(module, exports) {

let $f7ac2caa24457bae$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f7ac2caa24457bae$var$load("bKVkB").then(()=>parcelRequire('2b9uc'));

});

parcelRegister("bRiL0", function(module, exports) {

let $8a2331b440402edf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8a2331b440402edf$var$load("3DlbP").then(()=>parcelRequire('h2lmi'));

});

parcelRegister("dP1ON", function(module, exports) {

let $a10172d54bc5f1dd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a10172d54bc5f1dd$var$load("jUpaR").then(()=>parcelRequire('gu5vB'));

});

parcelRegister("iCQT0", function(module, exports) {

let $d8f4ccb07dbeb66c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d8f4ccb07dbeb66c$var$load("chaGt").then(()=>parcelRequire('9OFtl'));

});

parcelRegister("lEe7r", function(module, exports) {

let $fc28492ac1266d2a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fc28492ac1266d2a$var$load("j67qD").then(()=>parcelRequire('2BAYU'));

});

parcelRegister("2xIvo", function(module, exports) {

let $1da12faf1b77cef1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1da12faf1b77cef1$var$load("lorSs").then(()=>parcelRequire('iLS5D'));

});

parcelRegister("dXAhQ", function(module, exports) {

let $a29ceeda1ce8ae6a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a29ceeda1ce8ae6a$var$load("5EDIj").then(()=>parcelRequire('bjrfb'));

});

parcelRegister("lqBYm", function(module, exports) {

let $f9997b444aa47854$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f9997b444aa47854$var$load("kA9cs").then(()=>parcelRequire('gyaLD'));

});

parcelRegister("k1lTI", function(module, exports) {

let $e934e308820e70ee$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e934e308820e70ee$var$load("8XYfv").then(()=>parcelRequire('1kMiN'));

});

parcelRegister("9NxIo", function(module, exports) {

let $7222d7be969c939a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7222d7be969c939a$var$load("86nM4").then(()=>parcelRequire('56AgQ'));

});

parcelRegister("aLKTa", function(module, exports) {

let $7d72aa4ccb961a8b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7d72aa4ccb961a8b$var$load("jcRNK").then(()=>parcelRequire('B1ne2'));

});

parcelRegister("fp7Dx", function(module, exports) {

let $b36f1d490421e7d5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b36f1d490421e7d5$var$load("3jfbU").then(()=>parcelRequire('d9bwX'));

});

parcelRegister("2EbTD", function(module, exports) {

let $1ed88b8b036ba062$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1ed88b8b036ba062$var$load("aXOdd").then(()=>parcelRequire('3kgCV'));

});

parcelRegister("eVOox", function(module, exports) {

let $aded7ae88d8d3968$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $aded7ae88d8d3968$var$load("aXK4o").then(()=>parcelRequire('cJvuJ'));

});

parcelRegister("1JPGj", function(module, exports) {

let $144215403085f951$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $144215403085f951$var$load("1s3js").then(()=>parcelRequire('aC7UW'));

});

parcelRegister("iMk2y", function(module, exports) {

let $dabc41469705e630$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dabc41469705e630$var$load("hH3lR").then(()=>parcelRequire('4888h'));

});

parcelRegister("4TvM1", function(module, exports) {

let $3904f205dc394f97$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3904f205dc394f97$var$load("ekGFu").then(()=>parcelRequire('f5w5R'));

});

parcelRegister("6oR3V", function(module, exports) {

let $4a8e250fe14b4f47$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4a8e250fe14b4f47$var$load("8ZhTx").then(()=>parcelRequire('7ipU1'));

});

parcelRegister("f4oSp", function(module, exports) {

let $af8a86b01330164e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $af8a86b01330164e$var$load("hdlH9").then(()=>parcelRequire('571oA'));

});

parcelRegister("kZ0cC", function(module, exports) {

let $f469a95d749cc137$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f469a95d749cc137$var$load("c4khM").then(()=>parcelRequire('eY85d'));

});

parcelRegister("lWYFZ", function(module, exports) {

let $ffae14cd3b001090$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ffae14cd3b001090$var$load("fM4zh").then(()=>parcelRequire('9YMyX'));

});

parcelRegister("iUHI4", function(module, exports) {

let $dc4f5cd435585808$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dc4f5cd435585808$var$load("90own").then(()=>parcelRequire('5Z2pt'));

});

parcelRegister("e7g7D", function(module, exports) {

let $a46e39a9b8d17ace$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a46e39a9b8d17ace$var$load("djKbH").then(()=>parcelRequire('6TKTG'));

});

parcelRegister("juvIE", function(module, exports) {

let $e3096c6b92587c49$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e3096c6b92587c49$var$load("l6Wer").then(()=>parcelRequire('idcsq'));

});

parcelRegister("iknOH", function(module, exports) {

let $d57c91c45d5a3cb0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d57c91c45d5a3cb0$var$load("cUEuF").then(()=>parcelRequire('bQgi1'));

});

parcelRegister("htihg", function(module, exports) {

let $cb8352a3aaeb45d7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cb8352a3aaeb45d7$var$load("aQfBA").then(()=>parcelRequire('dsHlI'));

});

parcelRegister("lt2Te", function(module, exports) {

let $fa0e8c48f9ef85f9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fa0e8c48f9ef85f9$var$load("azRCz").then(()=>parcelRequire('egJZc'));

});

parcelRegister("9c91g", function(module, exports) {

let $6b1c3b220bdf53b1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6b1c3b220bdf53b1$var$load("k4s35").then(()=>parcelRequire('54Zkt'));

});

parcelRegister("gtsmY", function(module, exports) {

let $bfe55c5ed09367f7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bfe55c5ed09367f7$var$load("jH9xE").then(()=>parcelRequire('6ngXy'));

});

parcelRegister("5OTVk", function(module, exports) {

let $43cd008695b8dec4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $43cd008695b8dec4$var$load("c4yF3").then(()=>parcelRequire('7xGVB'));

});

parcelRegister("aligT", function(module, exports) {

let $787a09dd826218d2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $787a09dd826218d2$var$load("4hNqf").then(()=>parcelRequire('1ApTr'));

});

parcelRegister("kSygp", function(module, exports) {

let $f3336dd7e7142cf7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f3336dd7e7142cf7$var$load("3opSF").then(()=>parcelRequire('dpmKi'));

});

parcelRegister("7rFoP", function(module, exports) {

let $56bb2b1120873a72$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $56bb2b1120873a72$var$load("lrNdG").then(()=>parcelRequire('dwAAL'));

});

parcelRegister("1m5TX", function(module, exports) {

let $0fcc6c714bac1b43$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0fcc6c714bac1b43$var$load("4atYr").then(()=>parcelRequire('5ClB1'));

});


parcelRegister("d9B3I", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $8a8e072f5766b982$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $de5BD = parcelRequire("de5BD");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8a8e072f5766b982$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8a8e072f5766b982$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("7T38u")));
        case 'da':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("cSZJM")));
        case 'de':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("a7eGJ")));
        case 'en-GB':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("c6a8Q")));
        case 'en-US':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("bSrB6")));
        case 'en-XA':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("8Ymw0")));
        case 'en-XB':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("aDufW")));
        case 'en-ZZ':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("hwPuM")));
        case 'en':
            return $8a8e072f5766b982$var$importHelper(await Promise.resolve((parcelRequire("de5BD"))));
        case 'es':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("4jP9G")));
        case 'et':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("9w3YN")));
        case 'fi':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("4s7vP")));
        case 'fr':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("hW54W")));
        case 'hr':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("h6GFT")));
        case 'hu':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("hgznh")));
        case 'it':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("4j9NX")));
        case 'ja':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("bSuaz")));
        case 'ko':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("kj15r")));
        case 'nb':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("8ZApZ")));
        case 'nl':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("gPmMx")));
        case 'pl':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("cS7M2")));
        case 'pt-BR':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("d1awV")));
        case 'ro':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("41Cto")));
        case 'ru':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("kSQpB")));
        case 'sl':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("lY3Af")));
        case 'sr-RS':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("2fPas")));
        case 'sr-YR':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("5ChrQ")));
        case 'sr':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("jIu2y")));
        case 'sv':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("6NxrJ")));
        case 'th':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("h95c2")));
        case 'tr':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("39Ya7")));
        case 'uk':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("lna1A")));
        case 'vi':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("QJrED")));
        case 'zh-CN':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("vZRCz")));
        case 'zh-TW':
            return $8a8e072f5766b982$var$importHelper(await (parcelRequire("40bC1")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($de5BD));
    }
};

});
parcelRegister("de5BD", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("7T38u", function(module, exports) {

let $5be01a2b75005e6e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5be01a2b75005e6e$var$load("QVSOX").then(()=>parcelRequire('9Q5UB'));

});

parcelRegister("cSZJM", function(module, exports) {

let $961a6aecfb88bbf3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $961a6aecfb88bbf3$var$load("j7ii7").then(()=>parcelRequire('gkmqD'));

});

parcelRegister("a7eGJ", function(module, exports) {

let $75d5f39ff90ea677$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $75d5f39ff90ea677$var$load("7PYQv").then(()=>parcelRequire('fYFKI'));

});

parcelRegister("c6a8Q", function(module, exports) {

let $8cede97e03e98921$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8cede97e03e98921$var$load("iI6Wp").then(()=>parcelRequire('7FWgx'));

});

parcelRegister("bSrB6", function(module, exports) {

let $8a5a251c623c13ee$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8a5a251c623c13ee$var$load("bJXTb").then(()=>parcelRequire('d8Yv3'));

});

parcelRegister("8Ymw0", function(module, exports) {

let $68856461a36e2ec5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $68856461a36e2ec5$var$load("e7pD7").then(()=>parcelRequire('8qjPL'));

});

parcelRegister("aDufW", function(module, exports) {

let $7be5041dd4c2aeeb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7be5041dd4c2aeeb$var$load("6WyOI").then(()=>parcelRequire('iGJUY'));

});

parcelRegister("hwPuM", function(module, exports) {

let $cc2d5ec4a91148e1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cc2d5ec4a91148e1$var$load("7f8Lc").then(()=>parcelRequire('dAZRd'));

});

parcelRegister("4jP9G", function(module, exports) {

let $32509e21a8011feb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $32509e21a8011feb$var$load("3Hdow").then(()=>parcelRequire('gHUxu'));

});

parcelRegister("9w3YN", function(module, exports) {

let $6eda307a8ac26376$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6eda307a8ac26376$var$load("JWfrj").then(()=>parcelRequire('giYEN'));

});

parcelRegister("4s7vP", function(module, exports) {

let $33df9ac00048bead$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $33df9ac00048bead$var$load("3yT5F").then(()=>parcelRequire('3Nn1I'));

});

parcelRegister("hW54W", function(module, exports) {

let $d0ebcafb468e56de$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d0ebcafb468e56de$var$load("dpoav").then(()=>parcelRequire('8dXAE'));

});

parcelRegister("h6GFT", function(module, exports) {

let $c744198107ed32cd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c744198107ed32cd$var$load("cWnjP").then(()=>parcelRequire('cZQRI'));

});

parcelRegister("hgznh", function(module, exports) {

let $c91f5eedc9d5746c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c91f5eedc9d5746c$var$load("4BzAB").then(()=>parcelRequire('8LOHN'));

});

parcelRegister("4j9NX", function(module, exports) {

let $32308acab932675e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $32308acab932675e$var$load("94azF").then(()=>parcelRequire('eQMJa'));

});

parcelRegister("bSuaz", function(module, exports) {

let $8a5c23dcb29222eb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8a5c23dcb29222eb$var$load("dgYAh").then(()=>parcelRequire('gnFAu'));

});

parcelRegister("kj15r", function(module, exports) {

let $ec866cd4477f0169$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ec866cd4477f0169$var$load("jbdTv").then(()=>parcelRequire('fEkZA'));

});

parcelRegister("8ZApZ", function(module, exports) {

let $68c0452579ba58f7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $68c0452579ba58f7$var$load("SvzwF").then(()=>parcelRequire('hU9hV'));

});

parcelRegister("gPmMx", function(module, exports) {

let $c40314c5f123cefe$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c40314c5f123cefe$var$load("biDsp").then(()=>parcelRequire('lfsug'));

});

parcelRegister("cS7M2", function(module, exports) {

let $95f08ee48cd25bf3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $95f08ee48cd25bf3$var$load("kSPUR").then(()=>parcelRequire('joGfK'));

});

parcelRegister("d1awV", function(module, exports) {

let $97a3896dbdf00b49$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $97a3896dbdf00b49$var$load("7GYyU").then(()=>parcelRequire('aW5Fo'));

});

parcelRegister("41Cto", function(module, exports) {

let $2ee51958c39d14a2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2ee51958c39d14a2$var$load("hvwKl").then(()=>parcelRequire('dssDu'));

});

parcelRegister("kSQpB", function(module, exports) {

let $f34181b8aba72134$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f34181b8aba72134$var$load("7Hj79").then(()=>parcelRequire('kPQos'));

});

parcelRegister("lY3Af", function(module, exports) {

let $ffe1fb3828b1ca23$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ffe1fb3828b1ca23$var$load("biZmA").then(()=>parcelRequire('k0U8a'));

});

parcelRegister("2fPas", function(module, exports) {

let $1a44ac4f14924d45$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1a44ac4f14924d45$var$load("3lifp").then(()=>parcelRequire('eULDn'));

});

parcelRegister("5ChrQ", function(module, exports) {

let $416e092f00e140a4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $416e092f00e140a4$var$load("gqoEW").then(()=>parcelRequire('cB9Ii'));

});

parcelRegister("jIu2y", function(module, exports) {

let $e5a96dbfddcbb913$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e5a96dbfddcbb913$var$load("2o7eN").then(()=>parcelRequire('gnrpv'));

});

parcelRegister("6NxrJ", function(module, exports) {

let $4f3143665bcacd80$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4f3143665bcacd80$var$load("3qcaL").then(()=>parcelRequire('dkise'));

});

parcelRegister("h95c2", function(module, exports) {

let $c7b74e35181f3d47$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c7b74e35181f3d47$var$load("c5P9r").then(()=>parcelRequire('5AySZ'));

});

parcelRegister("39Ya7", function(module, exports) {

let $24d0e155a7c5caa4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $24d0e155a7c5caa4$var$load("fl0ra").then(()=>parcelRequire('bTuqU'));

});

parcelRegister("lna1A", function(module, exports) {

let $f8f385a72b8a952d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f8f385a72b8a952d$var$load("lb93B").then(()=>parcelRequire('klnn3'));

});

parcelRegister("QJrED", function(module, exports) {

let $09e81be1bfdf73d9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $09e81be1bfdf73d9$var$load("UUR5i").then(()=>parcelRequire('8gqEr'));

});

parcelRegister("vZRCz", function(module, exports) {

let $0602e23d02a5f8c3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0602e23d02a5f8c3$var$load("grTZR").then(()=>parcelRequire('egUxK'));

});

parcelRegister("40bC1", function(module, exports) {

let $2ea02b75ba3f78e2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2ea02b75ba3f78e2$var$load("83tod").then(()=>parcelRequire('jYjaL'));

});


parcelRegister("dxNP7", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $4c0c68fb4d683bbf$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $j5e4f = parcelRequire("j5e4f");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4c0c68fb4d683bbf$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $4c0c68fb4d683bbf$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("1UHQ7")));
        case 'da':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("eHumf")));
        case 'de':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("ir0Bm")));
        case 'en-GB':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("iuMgk")));
        case 'en-US':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("l9v2D")));
        case 'en-XA':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("cqB6o")));
        case 'en-XB':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("hioPs")));
        case 'en-ZZ':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("b38Vb")));
        case 'en':
            return $4c0c68fb4d683bbf$var$importHelper(await Promise.resolve((parcelRequire("j5e4f"))));
        case 'es':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("1sgIK")));
        case 'et':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("ezXOl")));
        case 'fi':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("5KUH6")));
        case 'fr':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("4Q5fO")));
        case 'hr':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("aLNR0")));
        case 'hu':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("fs3kf")));
        case 'it':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("haUJS")));
        case 'ja':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("7RSZo")));
        case 'ko':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("1xcPZ")));
        case 'nb':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("g3PtK")));
        case 'nl':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("2t5yD")));
        case 'pl':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("jJar4")));
        case 'pt-BR':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("amnZK")));
        case 'ro':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("87bZ1")));
        case 'ru':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("cUgAo")));
        case 'sl':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("8iiZg")));
        case 'sr-RS':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("2Y0an")));
        case 'sr-YR':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("bnn9w")));
        case 'sr':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("GqZTl")));
        case 'sv':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("9Pxck")));
        case 'th':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("2vqLV")));
        case 'tr':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("fQJKl")));
        case 'uk':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("8MIUI")));
        case 'vi':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("iLqKf")));
        case 'zh-CN':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("dQTYv")));
        case 'zh-TW':
            return $4c0c68fb4d683bbf$var$importHelper(await (parcelRequire("eiWZt")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($j5e4f));
    }
};

});
parcelRegister("j5e4f", function(module, exports) {
module.exports = JSON.parse('{"dismiss":[{"type":0,"value":"Dismiss"}],"jira-issueview-layouts.issue-view-layout-picker-changeboarding-body":[{"type":0,"value":"Choose a layout that works best for you."}],"jira-issueview-layouts.issue-view-layout-picker-changeboarding-heading":[{"type":0,"value":"Customise your view"}],"jira-thor.jira-notifications-project-recap.issue-row.work-item-key":[{"type":1,"value":"workItemKey"}],"jira-thor.jira-notifications-project-recap.issue-row.work-item-summary":[{"type":1,"value":"workItemSummary"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.body":[{"type":0,"value":"Don\'t let this work slip under the radar. Keep an eye on these unassigned work items by watching them, or assign them to yourself."}],"jira-thor.jira-notifications-project-recap.message-template-template.email.heading":[{"type":0,"value":"This work hasn\'t been assigned to anyone"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.manage-notifications":[{"type":0,"value":"Manage notifications"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.privacy-policy":[{"type":0,"value":"Privacy policy"}],"jira-thor.jira-notifications-project-recap.message-template-template.email.separator-dot":[{"type":0,"value":"\u2022"}],"jira-thor.jira-notifications-project-recap.message-template-template.issue.assign.action":[{"type":0,"value":"Assign to me"}],"jira-thor.jira-notifications-project-recap.message-template-template.issue.watch.action":[{"type":0,"value":"Watch"}],"jira-thor.jira-notifications-project-recap.message-template-template.project.remaining.items":[{"type":0,"value":"+"},{"type":1,"value":"remaining"},{"type":0,"value":" more..."}],"jira-thor.jira-notifications-project-recap.message-template-template.project.total.unassigned.items":[{"type":0,"value":"Unassigned work items ("},{"type":1,"value":"totalCount"},{"type":0,"value":")"}],"jira-thor.jira-notifications-project-recap.message-template-template.project.view.all":[{"type":0,"value":"View all in Jira"}],"jira-thor.jira-notifications-project-recap.message-template.email.subject.no-translate":[{"type":1,"value":"name"},{"type":0,"value":", don\'t miss this week\'s unassigned work items"}],"jira.jira-notifications-project-recap.message-template-template.email.contact-us":[{"type":0,"value":"Contact us"}],"jira.jira-notifications-project-recap.message-template-template.email.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"jira.jira-notifications-project-recap.message-template-template.email.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"try-now":[{"type":0,"value":"Try now"}]}');

});

parcelRegister("1UHQ7", function(module, exports) {

let $164d0708fefddcb8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $164d0708fefddcb8$var$load("hGPh6").then(()=>parcelRequire('hIl2C'));

});

parcelRegister("eHumf", function(module, exports) {

let $ab3ca140de8b6e55$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ab3ca140de8b6e55$var$load("16iby").then(()=>parcelRequire('5chbj'));

});

parcelRegister("ir0Bm", function(module, exports) {

let $d6bb37177fd73264$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d6bb37177fd73264$var$load("gq7w5").then(()=>parcelRequire('aXCNF'));

});

parcelRegister("iuMgk", function(module, exports) {

let $03798e4f63ce671b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $03798e4f63ce671b$var$load("4Bvqp").then(()=>parcelRequire('aW0al'));

});

parcelRegister("l9v2D", function(module, exports) {

let $f66284724abfe968$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f66284724abfe968$var$load("dT3VX").then(()=>parcelRequire('kz4jV'));

});

parcelRegister("cqB6o", function(module, exports) {

let $90c4b1782c712ad3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $90c4b1782c712ad3$var$load("btKDj").then(()=>parcelRequire('3g1DP'));

});

parcelRegister("hioPs", function(module, exports) {

let $c977609f61f1f200$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c977609f61f1f200$var$load("gQIjL").then(()=>parcelRequire('fUHXv'));

});

parcelRegister("b38Vb", function(module, exports) {

let $80b6e518eaaa78d8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $80b6e518eaaa78d8$var$load("9CdKh").then(()=>parcelRequire('jSJKE'));

});

parcelRegister("1sgIK", function(module, exports) {

let $10f5605e986ef022$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $10f5605e986ef022$var$load("SVPcl").then(()=>parcelRequire('kdDRA'));

});

parcelRegister("ezXOl", function(module, exports) {

let $a9d2bac558856c81$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a9d2bac558856c81$var$load("8rX6R").then(()=>parcelRequire('5CSrG'));

});

parcelRegister("5KUH6", function(module, exports) {

let $430d39e9a545e8dd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $430d39e9a545e8dd$var$load("8Qeq1").then(()=>parcelRequire('8XOut'));

});

parcelRegister("4Q5fO", function(module, exports) {

let $386018130e848633$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $386018130e848633$var$load("lp75f").then(()=>parcelRequire('lb9DU'));

});

parcelRegister("aLNR0", function(module, exports) {

let $7d74f71e4baa0f79$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7d74f71e4baa0f79$var$load("e3D03").then(()=>parcelRequire('hRNhn'));

});

parcelRegister("fs3kf", function(module, exports) {

let $b3fc0cf3eb7491b9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b3fc0cf3eb7491b9$var$load("6nfwP").then(()=>parcelRequire('dcr2y'));

});

parcelRegister("haUJS", function(module, exports) {

let $c80f6200a209e21f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c80f6200a209e21f$var$load("cBNw7").then(()=>parcelRequire('b6sIZ'));

});

parcelRegister("7RSZo", function(module, exports) {

let $5ba8235bd0550b57$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5ba8235bd0550b57$var$load("9eIB1").then(()=>parcelRequire('gUWcK'));

});

parcelRegister("1xcPZ", function(module, exports) {

let $11e2d4ce0a62aaf1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $11e2d4ce0a62aaf1$var$load("fGHyc").then(()=>parcelRequire('4PkZO'));

});

parcelRegister("g3PtK", function(module, exports) {

let $bb14dbc436702f71$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bb14dbc436702f71$var$load("5zjn7").then(()=>parcelRequire('270v6'));

});

parcelRegister("2t5yD", function(module, exports) {

let $1cc299db6dbb3521$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1cc299db6dbb3521$var$load("bnyEp").then(()=>parcelRequire('i0GLi'));

});

parcelRegister("jJar4", function(module, exports) {

let $e5ca5094bb3c9e77$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e5ca5094bb3c9e77$var$load("4rCIH").then(()=>parcelRequire('8Yrtf'));

});

parcelRegister("amnZK", function(module, exports) {

let $78ae925ebf8662c6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $78ae925ebf8662c6$var$load("iuzjJ").then(()=>parcelRequire('6tp1k'));

});

parcelRegister("87bZ1", function(module, exports) {

let $5e8845ccdb0b5beb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5e8845ccdb0b5beb$var$load("gbYF2").then(()=>parcelRequire('hx2Mk'));

});

parcelRegister("cUgAo", function(module, exports) {

let $9657949c1e5f76ef$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9657949c1e5f76ef$var$load("fgsUs").then(()=>parcelRequire('7flzs'));

});

parcelRegister("8iiZg", function(module, exports) {

let $609ebb99755930b8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $609ebb99755930b8$var$load("dCqO4").then(()=>parcelRequire('e38GI'));

});

parcelRegister("2Y0an", function(module, exports) {

let $22915069634d6588$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $22915069634d6588$var$load("1cM1v").then(()=>parcelRequire('hSeen'));

});

parcelRegister("bnn9w", function(module, exports) {

let $8483cd4e5597c329$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8483cd4e5597c329$var$load("7JdU2").then(()=>parcelRequire('fX04P'));

});

parcelRegister("GqZTl", function(module, exports) {

let $07f8dd7342556212$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $07f8dd7342556212$var$load("aBQmo").then(()=>parcelRequire('l4cmC'));

});

parcelRegister("9Pxck", function(module, exports) {

let $7282a0e4130206fe$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7282a0e4130206fe$var$load("hTQ3h").then(()=>parcelRequire('ia2CI'));

});

parcelRegister("2vqLV", function(module, exports) {

let $1d333e6177cc7314$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1d333e6177cc7314$var$load("97rrQ").then(()=>parcelRequire('eOjR2'));

});

parcelRegister("fQJKl", function(module, exports) {

let $b89f32a4e57caf23$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b89f32a4e57caf23$var$load("gAx1D").then(()=>parcelRequire('lPBpl'));

});

parcelRegister("8MIUI", function(module, exports) {

let $6655a55d112c0723$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6655a55d112c0723$var$load("bQt3p").then(()=>parcelRequire('4mku1'));

});

parcelRegister("iLqKf", function(module, exports) {

let $da915cc6d480fbd9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $da915cc6d480fbd9$var$load("ayZCv").then(()=>parcelRequire('9ZrI0'));

});

parcelRegister("dQTYv", function(module, exports) {

let $a15b8d23cb3966ef$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a15b8d23cb3966ef$var$load("5tfTS").then(()=>parcelRequire('dNY83'));

});

parcelRegister("eiWZt", function(module, exports) {

let $a6a0816a99c06bed$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a6a0816a99c06bed$var$load("aaqRc").then(()=>parcelRequire('hzkk4'));

});


parcelRegister("9f5AT", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $e2723125e1e657c3$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $9DgUZ = parcelRequire("9DgUZ");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e2723125e1e657c3$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $e2723125e1e657c3$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("j4A9t")));
        case 'da':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("gTrzF")));
        case 'de':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("cGXU0")));
        case 'en-GB':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("kN4EW")));
        case 'en-US':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("jvzzH")));
        case 'en-XA':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("9lIdn")));
        case 'en-XB':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("hFbEs")));
        case 'en-ZZ':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("1ME1H")));
        case 'en':
            return $e2723125e1e657c3$var$importHelper(await Promise.resolve((parcelRequire("9DgUZ"))));
        case 'es':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("lzhFB")));
        case 'et':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("lecD6")));
        case 'fi':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("7etbK")));
        case 'fr':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("a1j6H")));
        case 'hr':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("2E0Xw")));
        case 'hu':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("bljtt")));
        case 'it':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("9snJw")));
        case 'ja':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("8DUqr")));
        case 'ko':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("i7i47")));
        case 'nb':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("7sMYr")));
        case 'nl':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("91lnE")));
        case 'pl':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("3dyEL")));
        case 'pt-BR':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("6a4Ti")));
        case 'ro':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("6UmJv")));
        case 'ru':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("9V74n")));
        case 'sl':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("lbQTZ")));
        case 'sr-RS':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("516Ih")));
        case 'sr-YR':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("lMAG2")));
        case 'sr':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("hzXnL")));
        case 'sv':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("lMffO")));
        case 'th':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("5ZvPf")));
        case 'tr':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("9w8pl")));
        case 'uk':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("hTCyk")));
        case 'vi':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("5DjHi")));
        case 'zh-CN':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("b4fwx")));
        case 'zh-TW':
            return $e2723125e1e657c3$var$importHelper(await (parcelRequire("dyEaw")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9DgUZ));
    }
};

});
parcelRegister("9DgUZ", function(module, exports) {
module.exports = JSON.parse("{\"frozen-columns-onboarding.spotlight.body\":[{\"type\":0,\"value\":\"Sort, freeze and resize Work from a single control.\"}],\"frozen-columns-onboarding.spotlight.dismiss\":[{\"type\":0,\"value\":\"OK\"}],\"frozen-columns-onboarding.spotlight.heading\":[{\"type\":0,\"value\":\"Manage Work\"}],\"jira-nin-group-by-any-field-changeboarding.spotlight.body\":[{\"type\":0,\"value\":\"Group work by fields including versions, labels, work types and more.\"}],\"jira-nin-group-by-any-field-changeboarding.spotlight.dismiss\":[{\"type\":0,\"value\":\"OK\"}],\"jira-nin-group-by-any-field-changeboarding.spotlight.heading\":[{\"type\":0,\"value\":\"Group work to stay organized\"}]}");

});

parcelRegister("j4A9t", function(module, exports) {

let $de2a6f07aa620d28$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $de2a6f07aa620d28$var$load("8ipDY").then(()=>parcelRequire('20cgP'));

});

parcelRegister("gTrzF", function(module, exports) {

let $c4c72c129cc98f29$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c4c72c129cc98f29$var$load("bBjmE").then(()=>parcelRequire('5YINV'));

});

parcelRegister("cGXU0", function(module, exports) {

let $93d7dfa1c90503a3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $93d7dfa1c90503a3$var$load("bURLL").then(()=>parcelRequire('5NDue'));

});

parcelRegister("kN4EW", function(module, exports) {

let $f22bff833923f433$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f22bff833923f433$var$load("aIm4U").then(()=>parcelRequire('akyGK'));

});

parcelRegister("jvzzH", function(module, exports) {

let $e33c81fe36135cda$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e33c81fe36135cda$var$load("ia6rp").then(()=>parcelRequire('gOEsr'));

});

parcelRegister("9lIdn", function(module, exports) {

let $6ce85f56981b960a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6ce85f56981b960a$var$load("5IIIt").then(()=>parcelRequire('ynPfc'));

});

parcelRegister("hFbEs", function(module, exports) {

let $cdbf4dc0057420dd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cdbf4dc0057420dd$var$load("iOHdJ").then(()=>parcelRequire('aMBfP'));

});

parcelRegister("1ME1H", function(module, exports) {

let $14c95290021070bb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $14c95290021070bb$var$load("kyI2t").then(()=>parcelRequire('ipDbH'));

});

parcelRegister("lzhFB", function(module, exports) {

let $fb3a92bbc8552b00$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fb3a92bbc8552b00$var$load("89syl").then(()=>parcelRequire('g0TDK'));

});

parcelRegister("lecD6", function(module, exports) {

let $f744b3c2d5f50706$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f744b3c2d5f50706$var$load("fMGQb").then(()=>parcelRequire('iio47'));

});

parcelRegister("7etbK", function(module, exports) {

let $54407b750527ff41$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $54407b750527ff41$var$load("9zpxW").then(()=>parcelRequire('lgC8P'));

});

parcelRegister("a1j6H", function(module, exports) {

let $74b8d1a2700f236d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $74b8d1a2700f236d$var$load("5zFdo").then(()=>parcelRequire('gvciZ'));

});

parcelRegister("2E0Xw", function(module, exports) {

let $1ed00fa0de03526b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1ed00fa0de03526b$var$load("hqj3L").then(()=>parcelRequire('1pjWi'));

});

parcelRegister("bljtt", function(module, exports) {

let $8420c3168afdfacc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8420c3168afdfacc$var$load("8HU4U").then(()=>parcelRequire('ziHeW'));

});

parcelRegister("9snJw", function(module, exports) {

let $6e29237eb7d0d55e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6e29237eb7d0d55e$var$load("9W8k9").then(()=>parcelRequire('71ckt'));

});

parcelRegister("8DUqr", function(module, exports) {

let $64adbc26a7143ad2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $64adbc26a7143ad2$var$load("kKkfL").then(()=>parcelRequire('dPxWb'));

});

parcelRegister("i7i47", function(module, exports) {

let $d306e4dc16f381e9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d306e4dc16f381e9$var$load("jZW0y").then(()=>parcelRequire('7cVfW'));

});

parcelRegister("7sMYr", function(module, exports) {

let $56f12318307ddc01$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $56f12318307ddc01$var$load("5HG05").then(()=>parcelRequire('cayzW'));

});

parcelRegister("91lnE", function(module, exports) {

let $6914cac942059aa9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6914cac942059aa9$var$load("43nyV").then(()=>parcelRequire('goNXA'));

});

parcelRegister("3dyEL", function(module, exports) {

let $257d780e96ffffc2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $257d780e96ffffc2$var$load("hV24V").then(()=>parcelRequire('aS5s4'));

});

parcelRegister("6a4Ti", function(module, exports) {

let $47c77876a6e79760$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $47c77876a6e79760$var$load("bb8NG").then(()=>parcelRequire('cEzj3'));

});

parcelRegister("6UmJv", function(module, exports) {

let $50799b5164f76b03$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $50799b5164f76b03$var$load("grVt7").then(()=>parcelRequire('DbfwT'));

});

parcelRegister("9V74n", function(module, exports) {

let $738eebc9bd04fe9f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $738eebc9bd04fe9f$var$load("fwcU4").then(()=>parcelRequire('02g5O'));

});

parcelRegister("lbQTZ", function(module, exports) {

let $f6d3a946f531a151$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f6d3a946f531a151$var$load("7b9dD").then(()=>parcelRequire('dFgQw'));

});

parcelRegister("516Ih", function(module, exports) {

let $3a7240dea6f6afa4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3a7240dea6f6afa4$var$load("aR247").then(()=>parcelRequire('7OXI9'));

});

parcelRegister("lMAG2", function(module, exports) {

let $fdba87f9c1897c87$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fdba87f9c1897c87$var$load("13sKr").then(()=>parcelRequire('fEApM'));

});

parcelRegister("hzXnL", function(module, exports) {

let $ccc3c49e9b5089d0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ccc3c49e9b5089d0$var$load("hBubd").then(()=>parcelRequire('7Hsq0'));

});

parcelRegister("lMffO", function(module, exports) {

let $fda9e9d19d21caae$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fda9e9d19d21caae$var$load("ein1a").then(()=>parcelRequire('glKIl'));

});

parcelRegister("5ZvPf", function(module, exports) {

let $45cb562d6996ae26$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $45cb562d6996ae26$var$load("klsUi").then(()=>parcelRequire('2HNP7'));

});

parcelRegister("9w8pl", function(module, exports) {

let $6edd9fcf3187a7d5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6edd9fcf3187a7d5$var$load("1M5GC").then(()=>parcelRequire('dipsJ'));

});

parcelRegister("hTCyk", function(module, exports) {

let $d0757a81a82970db$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d0757a81a82970db$var$load("hFvR4").then(()=>parcelRequire('8RWgm'));

});

parcelRegister("5DjHi", function(module, exports) {

let $419fdfc11c20c5b6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $419fdfc11c20c5b6$var$load("4GI48").then(()=>parcelRequire('33DBj'));

});

parcelRegister("b4fwx", function(module, exports) {

let $80ec1c20c0d9539d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $80ec1c20c0d9539d$var$load("bUbik").then(()=>parcelRequire('9QZTS'));

});

parcelRegister("dyEaw", function(module, exports) {

let $9ded9c055f25900b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9ded9c055f25900b$var$load("fSKqa").then(()=>parcelRequire('7o7gM'));

});


parcelRegister("hMT3U", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $7807746d2dda62d7$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $dQfXF = parcelRequire("dQfXF");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7807746d2dda62d7$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $7807746d2dda62d7$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("9xfii")));
        case 'da':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("2SuxU")));
        case 'de':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("iwcAO")));
        case 'en-GB':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("fK7xD")));
        case 'en-US':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("2a4FP")));
        case 'en-XA':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("lTwzw")));
        case 'en-XB':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("eCYwh")));
        case 'en-ZZ':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("B2YJz")));
        case 'en':
            return $7807746d2dda62d7$var$importHelper(await Promise.resolve((parcelRequire("dQfXF"))));
        case 'es':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("femJs")));
        case 'et':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("3jpM4")));
        case 'fi':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("h3Mt9")));
        case 'fr':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("9iPlp")));
        case 'hr':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("bkE0x")));
        case 'hu':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("5Nd3o")));
        case 'it':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("dHf18")));
        case 'ja':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("a5zdQ")));
        case 'ko':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("jnoir")));
        case 'nb':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("avhut")));
        case 'nl':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("aeQVN")));
        case 'pl':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("bRdve")));
        case 'pt-BR':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("ce6PO")));
        case 'ro':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("4i3OK")));
        case 'ru':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("gEl7P")));
        case 'sl':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("pZdTM")));
        case 'sr-RS':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("2iDQq")));
        case 'sr-YR':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("2CNMj")));
        case 'sr':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("1gJbY")));
        case 'sv':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("5XMAA")));
        case 'th':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("hC9Lv")));
        case 'tr':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("2eOtE")));
        case 'uk':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("9Cmro")));
        case 'vi':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("j7k7i")));
        case 'zh-CN':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("9VSM4")));
        case 'zh-TW':
            return $7807746d2dda62d7$var$importHelper(await (parcelRequire("lk5ek")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($dQfXF));
    }
};

});
parcelRegister("dQfXF", function(module, exports) {
module.exports = JSON.parse("{\"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.heading\":[{\"type\":0,\"value\":\"Consumption-based pricing will come into effect soon\"}],\"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.intro\":[{\"type\":0,\"value\":\"This is a reminder that consumption-based pricing begins on \"},{\"type\":1,\"value\":\"cbpEffectiveDate\"},{\"type\":0,\"value\":\". Extra usage of Assets and the virtual service agent will incur charges.\"}],\"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.need-to-know\":[{\"type\":0,\"value\":\"Helpful things to know:\"}],\"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.comment.alt-text\":[{\"type\":0,\"value\":\"comment\"}],\"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.lightbulb.alt-text\":[{\"type\":0,\"value\":\"lightbulb\"}],\"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.optimize-schema\":[{\"children\":[{\"type\":0,\"value\":\"Contact support\"}],\"type\":8,\"value\":\"a\"},{\"type\":0,\"value\":\" if you have any questions\"}],\"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.usage-limit\":[{\"type\":0,\"value\":\"Consider \"},{\"children\":[{\"type\":0,\"value\":\"optimizing the structure of your schemas\"}],\"type\":8,\"value\":\"a\"}],\"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.more-details-button\":[{\"type\":0,\"value\":\"More details\"}],\"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Consumption-based pricing starts in \"},{\"type\":1,\"value\":\"daysRemaining\"},{\"type\":0,\"value\":\" days from \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\".\"}],\"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.support.annual.feature-usage-limits-guide\":[{\"type\":0,\"value\":\"For more information, read more about \"},{\"children\":[{\"type\":0,\"value\":\"how feature usage limits work\"}],\"type\":8,\"value\":\"a\"},{\"type\":0,\"value\":\".\"}],\"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.view-and-manage-usage-button\":[{\"type\":0,\"value\":\"View and manage usage\"}]}");

});

parcelRegister("9xfii", function(module, exports) {

let $6f130f34f8320517$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6f130f34f8320517$var$load("9YxI0").then(()=>parcelRequire('4OEKA'));

});

parcelRegister("2SuxU", function(module, exports) {

let $218851b6c7e2121e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $218851b6c7e2121e$var$load("bvnd6").then(()=>parcelRequire('dSA4C'));

});

parcelRegister("iwcAO", function(module, exports) {

let $d7b4fbce7dc1157e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d7b4fbce7dc1157e$var$load("kFn8H").then(()=>parcelRequire('dRzrP'));

});

parcelRegister("fK7xD", function(module, exports) {

let $b76100785c31ceea$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b76100785c31ceea$var$load("cS0ge").then(()=>parcelRequire('f1nou'));

});

parcelRegister("2a4FP", function(module, exports) {

let $19302403ee10ec96$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $19302403ee10ec96$var$load("iTLuW").then(()=>parcelRequire('3itZu'));

});

parcelRegister("lTwzw", function(module, exports) {

let $ff08001e42b3c6f0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ff08001e42b3c6f0$var$load("6Euzu").then(()=>parcelRequire('58XcK'));

});

parcelRegister("eCYwh", function(module, exports) {

let $aa638f437b2e9edd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $aa638f437b2e9edd$var$load("66WQc").then(()=>parcelRequire('5OdIN'));

});

parcelRegister("B2YJz", function(module, exports) {

let $06f5c44cda3cc41a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $06f5c44cda3cc41a$var$load("eo45s").then(()=>parcelRequire('egQeB'));

});

parcelRegister("femJs", function(module, exports) {

let $b169cbf1518c9356$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b169cbf1518c9356$var$load("cN9nx").then(()=>parcelRequire('jjyoV'));

});

parcelRegister("3jpM4", function(module, exports) {

let $269723b412071511$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $269723b412071511$var$load("j5GZL").then(()=>parcelRequire('7U09P'));

});

parcelRegister("h3Mt9", function(module, exports) {

let $c6b8506f13048a17$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c6b8506f13048a17$var$load("a6mib").then(()=>parcelRequire('eGYFU'));

});

parcelRegister("9iPlp", function(module, exports) {

let $6c5d9f69d46911fb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6c5d9f69d46911fb$var$load("hnnop").then(()=>parcelRequire('eC58q'));

});

parcelRegister("bkE0x", function(module, exports) {

let $840098a53b148f71$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $840098a53b148f71$var$load("6fWxc").then(()=>parcelRequire('jBKzU'));

});

parcelRegister("5Nd3o", function(module, exports) {

let $437ba78a471636ef$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $437ba78a471636ef$var$load("1DaWw").then(()=>parcelRequire('bWnFb'));

});

parcelRegister("dHf18", function(module, exports) {

let $9f8af0a52ebb1d38$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9f8af0a52ebb1d38$var$load("21kaI").then(()=>parcelRequire('9tCt2'));

});

parcelRegister("a5zdQ", function(module, exports) {

let $7585b16816f27195$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7585b16816f27195$var$load("higlt").then(()=>parcelRequire('c0eCa'));

});

parcelRegister("jnoir", function(module, exports) {

let $e1b3030ec54a7487$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e1b3030ec54a7487$var$load("jrkDM").then(()=>parcelRequire('6H3bU'));

});

parcelRegister("avhut", function(module, exports) {

let $7a5a5de84443e3fb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7a5a5de84443e3fb$var$load("czOn2").then(()=>parcelRequire('aeIN5'));

});

parcelRegister("aeQVN", function(module, exports) {

let $77444532da28111c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $77444532da28111c$var$load("3bCff").then(()=>parcelRequire('dDESh'));

});

parcelRegister("bRdve", function(module, exports) {

let $8a1f1e50ca5168de$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8a1f1e50ca5168de$var$load("ZHxAo").then(()=>parcelRequire('Zp1ZQ'));

});

parcelRegister("ce6PO", function(module, exports) {

let $8e6c181684e61c93$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8e6c181684e61c93$var$load("d9JQ8").then(()=>parcelRequire('2WmnO'));

});

parcelRegister("4i3OK", function(module, exports) {

let $31fbcded4c3a737b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $31fbcded4c3a737b$var$load("a7VyR").then(()=>parcelRequire('fisB5'));

});

parcelRegister("gEl7P", function(module, exports) {

let $c1f0c4d32c8dda40$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c1f0c4d32c8dda40$var$load("hrbV8").then(()=>parcelRequire('9bygV'));

});

parcelRegister("pZdTM", function(module, exports) {

let $04e1d38f90b9a117$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $04e1d38f90b9a117$var$load("couKE").then(()=>parcelRequire('hbTPX'));

});

parcelRegister("2iDQq", function(module, exports) {

let $1acc2b7edf544258$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1acc2b7edf544258$var$load("j3xlk").then(()=>parcelRequire('gFkmv'));

});

parcelRegister("2CNMj", function(module, exports) {

let $1e95be4be0ecb4bd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1e95be4be0ecb4bd$var$load("5N6oA").then(()=>parcelRequire('i2WCZ'));

});

parcelRegister("1gJbY", function(module, exports) {

let $0eca57469bfc46bf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0eca57469bfc46bf$var$load("kPqUj").then(()=>parcelRequire('8p6Xj'));

});

parcelRegister("5XMAA", function(module, exports) {

let $45782735c7af55ca$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $45782735c7af55ca$var$load("kavb3").then(()=>parcelRequire('3egU0'));

});

parcelRegister("hC9Lv", function(module, exports) {

let $cd2d8f778c899a62$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cd2d8f778c899a62$var$load("5CTxy").then(()=>parcelRequire('at5JH'));

});

parcelRegister("2eOtE", function(module, exports) {

let $1a140b4ac6e2a532$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1a140b4ac6e2a532$var$load("6jJjg").then(()=>parcelRequire('8meaX'));

});

parcelRegister("9Cmro", function(module, exports) {

let $700911f183f24f93$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $700911f183f24f93$var$load("53niU").then(()=>parcelRequire('jktHu'));

});

parcelRegister("j7k7i", function(module, exports) {

let $deae468811564572$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $deae468811564572$var$load("33Br8").then(()=>parcelRequire('lK5PN'));

});

parcelRegister("9VSM4", function(module, exports) {

let $73b3ecf31d5ad28c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $73b3ecf31d5ad28c$var$load("lABNP").then(()=>parcelRequire('5NGkA'));

});

parcelRegister("lk5ek", function(module, exports) {

let $f85f85d592c06ebd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f85f85d592c06ebd$var$load("8SwRB").then(()=>parcelRequire('9yWvT'));

});


parcelRegister("h2eQn", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $ba3cd8f5b552c521$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $aE23y = parcelRequire("aE23y");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ba3cd8f5b552c521$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $ba3cd8f5b552c521$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("hw6Vu")));
        case 'da':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("fcjtR")));
        case 'de':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("fYrAu")));
        case 'en-GB':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("aNRxu")));
        case 'en-US':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("d0dzY")));
        case 'en-XA':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("a2gvg")));
        case 'en-XB':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("8oqNW")));
        case 'en-ZZ':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("99nTb")));
        case 'en':
            return $ba3cd8f5b552c521$var$importHelper(await Promise.resolve((parcelRequire("aE23y"))));
        case 'es':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("eH3hV")));
        case 'et':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("90QX5")));
        case 'fi':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("5xwM8")));
        case 'fr':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("lE2YA")));
        case 'hr':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("f1O1A")));
        case 'hu':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("h7oym")));
        case 'it':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("50j7g")));
        case 'ja':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("lxd1k")));
        case 'ko':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("bphZf")));
        case 'nb':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("6lLj0")));
        case 'nl':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("dOgDu")));
        case 'pl':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("lSYGQ")));
        case 'pt-BR':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("4Ik5k")));
        case 'ro':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("lwZaC")));
        case 'ru':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("kU6Tu")));
        case 'sl':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("9cVIN")));
        case 'sr-RS':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("bK9Df")));
        case 'sr-YR':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("kQHCI")));
        case 'sr':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("dhszE")));
        case 'sv':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("gjwkn")));
        case 'th':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("4WId3")));
        case 'tr':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("eorxu")));
        case 'uk':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("jCAtd")));
        case 'vi':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("3TrBv")));
        case 'zh-CN':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("4gcmD")));
        case 'zh-TW':
            return $ba3cd8f5b552c521$var$importHelper(await (parcelRequire("5181f")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($aE23y));
    }
};

});
parcelRegister("aE23y", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("hw6Vu", function(module, exports) {

let $cc0acc3d6766ed07$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cc0acc3d6766ed07$var$load("8uIyz").then(()=>parcelRequire('1zuht'));

});

parcelRegister("fcjtR", function(module, exports) {

let $b107166d938959d6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b107166d938959d6$var$load("dNStH").then(()=>parcelRequire('6XOy1'));

});

parcelRegister("fYrAu", function(module, exports) {

let $ba11dbecaf0f2625$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ba11dbecaf0f2625$var$load("bg82e").then(()=>parcelRequire('5E9tt'));

});

parcelRegister("aNRxu", function(module, exports) {

let $7dd802be134d8eb3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7dd802be134d8eb3$var$load("ltE4B").then(()=>parcelRequire('4fIvg'));

});

parcelRegister("d0dzY", function(module, exports) {

let $9775cf01b0c3c697$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9775cf01b0c3c697$var$load("3bgZL").then(()=>parcelRequire('aIvO4'));

});

parcelRegister("a2gvg", function(module, exports) {

let $74e6e47a698a0f82$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $74e6e47a698a0f82$var$load("ajDa5").then(()=>parcelRequire('jjh87'));

});

parcelRegister("8oqNW", function(module, exports) {

let $61c55b74be9de823$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $61c55b74be9de823$var$load("7Cvl1").then(()=>parcelRequire('9LY86'));

});

parcelRegister("99nTb", function(module, exports) {

let $6a977c2e18b93546$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6a977c2e18b93546$var$load("elXny").then(()=>parcelRequire('7RNil'));

});

parcelRegister("eH3hV", function(module, exports) {

let $ab27a1c626e5d7d8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ab27a1c626e5d7d8$var$load("bTdSs").then(()=>parcelRequire('klOXt'));

});

parcelRegister("90QX5", function(module, exports) {

let $68fd304d1c742026$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $68fd304d1c742026$var$load("jbkLN").then(()=>parcelRequire('i3RrI'));

});

parcelRegister("5xwM8", function(module, exports) {

let $408975506d7581ef$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $408975506d7581ef$var$load("65zZm").then(()=>parcelRequire('AhNeZ'));

});

parcelRegister("lE2YA", function(module, exports) {

let $fc1fa46ab25a3fc3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fc1fa46ab25a3fc3$var$load("daChK").then(()=>parcelRequire('2SaoT'));

});

parcelRegister("f1O1A", function(module, exports) {

let $af0dc0d50d3354f5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $af0dc0d50d3354f5$var$load("3a3Sw").then(()=>parcelRequire('7nMm9'));

});

parcelRegister("h7oym", function(module, exports) {

let $c76622dc2e41c4c6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c76622dc2e41c4c6$var$load("6hQlf").then(()=>parcelRequire('7tFy0'));

});

parcelRegister("50j7g", function(module, exports) {

let $3a4bc7e30c6438c3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3a4bc7e30c6438c3$var$load("99sEl").then(()=>parcelRequire('8W8KR'));

});

parcelRegister("lxd1k", function(module, exports) {

let $fad6c79c6cb7feca$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fad6c79c6cb7feca$var$load("cDuk7").then(()=>parcelRequire('bAN7L'));

});

parcelRegister("bphZf", function(module, exports) {

let $84dffb56b4f067cc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $84dffb56b4f067cc$var$load("8TE7B").then(()=>parcelRequire('3X2Sq'));

});

parcelRegister("6lLj0", function(module, exports) {

let $49f966239068542f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $49f966239068542f$var$load("ayXl2").then(()=>parcelRequire('jECnr'));

});

parcelRegister("dOgDu", function(module, exports) {

let $a0dcd9678bc45089$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a0dcd9678bc45089$var$load("cVEsS").then(()=>parcelRequire('4Ie0g'));

});

parcelRegister("lSYGQ", function(module, exports) {

let $feedb7e804d84c4e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $feedb7e804d84c4e$var$load("9VZW9").then(()=>parcelRequire('lvblZ'));

});

parcelRegister("4Ik5k", function(module, exports) {

let $36ead9f0e3843554$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $36ead9f0e3843554$var$load("9Ptnv").then(()=>parcelRequire('lgOGE'));

});

parcelRegister("lwZaC", function(module, exports) {

let $facc0941dfea063b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $facc0941dfea063b$var$load("bP7DT").then(()=>parcelRequire('kOut0'));

});

parcelRegister("kU6Tu", function(module, exports) {

let $f37e629dc2192fdd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f37e629dc2192fdd$var$load("8aZAA").then(()=>parcelRequire('keo9w'));

});

parcelRegister("9cVIN", function(module, exports) {

let $6b420253e9fcf841$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6b420253e9fcf841$var$load("6rK1d").then(()=>parcelRequire('d1McP'));

});

parcelRegister("bK9Df", function(module, exports) {

let $88cb7653fe13a1bb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $88cb7653fe13a1bb$var$load("66dfM").then(()=>parcelRequire('b95sl'));

});

parcelRegister("kQHCI", function(module, exports) {

let $f2da80b25071bef8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f2da80b25071bef8$var$load("3DhjB").then(()=>parcelRequire('iLY7E'));

});

parcelRegister("dhszE", function(module, exports) {

let $9ab3071ce78069ae$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9ab3071ce78069ae$var$load("cZflE").then(()=>parcelRequire('h6d0j'));

});

parcelRegister("gjwkn", function(module, exports) {

let $be077f4bab8b2e5b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $be077f4bab8b2e5b$var$load("6aOjI").then(()=>parcelRequire('03rC8'));

});

parcelRegister("4WId3", function(module, exports) {

let $399edf4a4b8c4359$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $399edf4a4b8c4359$var$load("9R8Je").then(()=>parcelRequire('lfMHA'));

});

parcelRegister("eorxu", function(module, exports) {

let $a7a8ab4ae119352d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a7a8ab4ae119352d$var$load("3U0W5").then(()=>parcelRequire('bRSJv'));

});

parcelRegister("jCAtd", function(module, exports) {

let $e48ddb28c49a7cc6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e48ddb28c49a7cc6$var$load("dkF2x").then(()=>parcelRequire('a4Ffo'));

});

parcelRegister("3TrBv", function(module, exports) {

let $2d5bebb38c00e22d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2d5bebb38c00e22d$var$load("806CI").then(()=>parcelRequire('4fHu8'));

});

parcelRegister("4gcmD", function(module, exports) {

let $31a23f4b157da323$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $31a23f4b157da323$var$load("iBk9V").then(()=>parcelRequire('6ApDn'));

});

parcelRegister("5181f", function(module, exports) {

let $3a7344329ba80081$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3a7344329ba80081$var$load("l2frS").then(()=>parcelRequire('68fcm'));

});


parcelRegister("2d46t", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $a87376497e168230$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $aBhzr = parcelRequire("aBhzr");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a87376497e168230$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a87376497e168230$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a87376497e168230$var$importHelper(await (parcelRequire("e6xKE")));
        case 'da':
            return $a87376497e168230$var$importHelper(await (parcelRequire("ioE8W")));
        case 'de':
            return $a87376497e168230$var$importHelper(await (parcelRequire("hwxwE")));
        case 'en-GB':
            return $a87376497e168230$var$importHelper(await (parcelRequire("dVN6w")));
        case 'en-US':
            return $a87376497e168230$var$importHelper(await (parcelRequire("lPV1C")));
        case 'en-XA':
            return $a87376497e168230$var$importHelper(await (parcelRequire("1KTnH")));
        case 'en-XB':
            return $a87376497e168230$var$importHelper(await (parcelRequire("kCtLr")));
        case 'en-ZZ':
            return $a87376497e168230$var$importHelper(await (parcelRequire("7KLMX")));
        case 'en':
            return $a87376497e168230$var$importHelper(await Promise.resolve((parcelRequire("aBhzr"))));
        case 'es':
            return $a87376497e168230$var$importHelper(await (parcelRequire("33gWL")));
        case 'et':
            return $a87376497e168230$var$importHelper(await (parcelRequire("lgvVd")));
        case 'fi':
            return $a87376497e168230$var$importHelper(await (parcelRequire("5Cqtb")));
        case 'fr':
            return $a87376497e168230$var$importHelper(await (parcelRequire("g9GqP")));
        case 'hr':
            return $a87376497e168230$var$importHelper(await (parcelRequire("66LtI")));
        case 'hu':
            return $a87376497e168230$var$importHelper(await (parcelRequire("kFr6D")));
        case 'it':
            return $a87376497e168230$var$importHelper(await (parcelRequire("gZTv6")));
        case 'ja':
            return $a87376497e168230$var$importHelper(await (parcelRequire("bWAjR")));
        case 'ko':
            return $a87376497e168230$var$importHelper(await (parcelRequire("2C3to")));
        case 'nb':
            return $a87376497e168230$var$importHelper(await (parcelRequire("hAUxw")));
        case 'nl':
            return $a87376497e168230$var$importHelper(await (parcelRequire("jAKm3")));
        case 'pl':
            return $a87376497e168230$var$importHelper(await (parcelRequire("jNmGl")));
        case 'pt-BR':
            return $a87376497e168230$var$importHelper(await (parcelRequire("4HR5C")));
        case 'ro':
            return $a87376497e168230$var$importHelper(await (parcelRequire("gMdBI")));
        case 'ru':
            return $a87376497e168230$var$importHelper(await (parcelRequire("ag5Oy")));
        case 'sl':
            return $a87376497e168230$var$importHelper(await (parcelRequire("6FNKm")));
        case 'sr-RS':
            return $a87376497e168230$var$importHelper(await (parcelRequire("fHL6j")));
        case 'sr-YR':
            return $a87376497e168230$var$importHelper(await (parcelRequire("5larS")));
        case 'sr':
            return $a87376497e168230$var$importHelper(await (parcelRequire("3BbhA")));
        case 'sv':
            return $a87376497e168230$var$importHelper(await (parcelRequire("a9Bbe")));
        case 'th':
            return $a87376497e168230$var$importHelper(await (parcelRequire("9FxYO")));
        case 'tr':
            return $a87376497e168230$var$importHelper(await (parcelRequire("itTua")));
        case 'uk':
            return $a87376497e168230$var$importHelper(await (parcelRequire("k6Ofq")));
        case 'vi':
            return $a87376497e168230$var$importHelper(await (parcelRequire("8NKOf")));
        case 'zh-CN':
            return $a87376497e168230$var$importHelper(await (parcelRequire("ur8jq")));
        case 'zh-TW':
            return $a87376497e168230$var$importHelper(await (parcelRequire("E8B28")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($aBhzr));
    }
};

});
parcelRegister("aBhzr", function(module, exports) {
module.exports = JSON.parse("{\"got-it\":[{\"type\":0,\"value\":\"Got it\"}],\"mercury.email.footer.sent-by\":[{\"type\":0,\"value\":\"This message was sent to you by Atlassian Focus\"}],\"mercury.email.footer.unsubscribe\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"mercury.focus-areas.arrow-icon.alt\":[{\"type\":0,\"value\":\"arrow-icon\"}],\"mercury.focus-areas.arrow-right-icon.alt\":[{\"type\":0,\"value\":\"arrow-right-icon\"}],\"mercury.focus-areas.calendar-icon.alt\":[{\"type\":0,\"value\":\"calendar-icon\"}],\"mercury.focus-areas.date-changed\":[{\"type\":0,\"value\":\"Date Changed\"}],\"mercury.focus-areas.focus-area.alt\":[{\"type\":0,\"value\":\"focus-area-icon\"}],\"mercury.focus-areas.focus-footer.alt\":[{\"type\":0,\"value\":\"Atlassian footer\"}],\"mercury.focus-areas.focus-icon.alt\":[{\"type\":0,\"value\":\"Focus area icon\"}],\"mercury.focus-areas.for\":[{\"type\":0,\"value\":\"for\"}],\"mercury.focus-areas.heading\":[{\"type\":0,\"value\":\"You're following \"},{\"type\":1,\"value\":\"total\"},{\"type\":0,\"value\":\" active focus areas, here's the breakdown.\"}],\"mercury.focus-areas.no-target-date.alt\":[{\"type\":0,\"value\":\"No target date set\"}],\"mercury.focus-areas.status-changed\":[{\"type\":0,\"value\":\"Status changed\"}],\"mercury.focus-areas.view-area\":[{\"type\":0,\"value\":\"View Focus Area\"}],\"mercury.focus.catch.up.link\":[{\"type\":0,\"value\":\"Jump into Atlassian Focus\"}],\"mercury.focus.catch.up.text\":[{\"type\":0,\"value\":\"Want to catch up on previous updates? \"},{\"type\":1,\"value\":\"link\"}],\"mercury.mercury-monthly-digest.message-template.email.subject.no-translate\":[{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\", here are your monthly focus area updates\"}],\"mercury.message-templates.edit-focus-area-heirarchy-spotlight-body\":[{\"type\":0,\"value\":\"Whenever you need to make changes to your hierarchy you can do so from settings.\"}],\"mercury.message-templates.edit-focus-area-heirarchy-spotlight-heading\":[{\"type\":0,\"value\":\"Edit your focus area hierarchy\"}]}");

});

parcelRegister("e6xKE", function(module, exports) {

let $a44bce953286f7ac$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a44bce953286f7ac$var$load("hV93e").then(()=>parcelRequire('b8F2s'));

});

parcelRegister("ioE8W", function(module, exports) {

let $d6499b7d4d062560$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d6499b7d4d062560$var$load("2G3bq").then(()=>parcelRequire('j6Sd4'));

});

parcelRegister("hwxwE", function(module, exports) {

let $cc1f6e54d9077eb0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cc1f6e54d9077eb0$var$load("a3F58").then(()=>parcelRequire('2h7Hs'));

});

parcelRegister("dVN6w", function(module, exports) {

let $a246b04c7a9fd39a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a246b04c7a9fd39a$var$load("eR2nK").then(()=>parcelRequire('4aNjK'));

});

parcelRegister("lPV1C", function(module, exports) {

let $fe5a98670d6401f7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fe5a98670d6401f7$var$load("irOJX").then(()=>parcelRequire('2zhgf'));

});

parcelRegister("1KTnH", function(module, exports) {

let $14750bdfbaa1feaf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $14750bdfbaa1feaf$var$load("bkJFU").then(()=>parcelRequire('d7yQV'));

});

parcelRegister("kCtLr", function(module, exports) {

let $f02e71cf5da55b90$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f02e71cf5da55b90$var$load("eAeDH").then(()=>parcelRequire('a69Eu'));

});

parcelRegister("7KLMX", function(module, exports) {

let $5a51e61c631a02a9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5a51e61c631a02a9$var$load("jsHlj").then(()=>parcelRequire('58Ado'));

});

parcelRegister("33gWL", function(module, exports) {

let $238ecc325d97c4a1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $238ecc325d97c4a1$var$load("eXojs").then(()=>parcelRequire('bVh0O'));

});

parcelRegister("lgvVd", function(module, exports) {

let $f7b3da9cd02e379e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f7b3da9cd02e379e$var$load("jh6XZ").then(()=>parcelRequire('g2OsH'));

});

parcelRegister("5Cqtb", function(module, exports) {

let $417508ac09e74827$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $417508ac09e74827$var$load("i7Xtw").then(()=>parcelRequire('kfd8P'));

});

parcelRegister("g9GqP", function(module, exports) {

let $bc2e66afa5bad706$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bc2e66afa5bad706$var$load("jah6k").then(()=>parcelRequire('1BaKO'));

});

parcelRegister("66LtI", function(module, exports) {

let $472821cef6e6418d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $472821cef6e6418d$var$load("6SgY5").then(()=>parcelRequire('e9Yul'));

});

parcelRegister("kFr6D", function(module, exports) {

let $f0bca9b23f4ee315$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f0bca9b23f4ee315$var$load("9lZiy").then(()=>parcelRequire('bDKzk'));

});

parcelRegister("gZTv6", function(module, exports) {

let $c5fd651b638a6298$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c5fd651b638a6298$var$load("lnlQe").then(()=>parcelRequire('flXL3'));

});

parcelRegister("bWAjR", function(module, exports) {

let $8b2148c04e7a147a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8b2148c04e7a147a$var$load("exRjv").then(()=>parcelRequire('82ZVm'));

});

parcelRegister("2C3to", function(module, exports) {

let $1e71d3156d7ba932$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1e71d3156d7ba932$var$load("lzR72").then(()=>parcelRequire('d5DYf'));

});

parcelRegister("hAUxw", function(module, exports) {

let $ccf1a811ab0b4b32$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ccf1a811ab0b4b32$var$load("jtJPi").then(()=>parcelRequire('eUoUJ'));

});

parcelRegister("jAKm3", function(module, exports) {

let $e435563845f547b7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e435563845f547b7$var$load("fIsRB").then(()=>parcelRequire('6uHdJ'));

});

parcelRegister("jNmGl", function(module, exports) {

let $e69430180d997c02$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e69430180d997c02$var$load("1FVck").then(()=>parcelRequire('qPVD8'));

});

parcelRegister("4HR5C", function(module, exports) {

let $36d45c128c60ecd3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $36d45c128c60ecd3$var$load("cYpv7").then(()=>parcelRequire('gzc5t'));

});

parcelRegister("gMdBI", function(module, exports) {

let $c36baf2e97fbc82d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c36baf2e97fbc82d$var$load("5Jlnx").then(()=>parcelRequire('4Ssxb'));

});

parcelRegister("ag5Oy", function(module, exports) {

let $777fe899b2783157$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $777fe899b2783157$var$load("6oDC2").then(()=>parcelRequire('ktNDO'));

});

parcelRegister("6FNKm", function(module, exports) {

let $4dbd29154730f0a2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4dbd29154730f0a2$var$load("kSF0i").then(()=>parcelRequire('iNc5h'));

});

parcelRegister("fHL6j", function(module, exports) {

let $b6ef686611db49d5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b6ef686611db49d5$var$load("3l2k7").then(()=>parcelRequire('dt1pm'));

});

parcelRegister("5larS", function(module, exports) {

let $3e3704d223ee1de0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3e3704d223ee1de0$var$load("hyNDZ").then(()=>parcelRequire('jns75'));

});

parcelRegister("3BbhA", function(module, exports) {

let $29ed9452417cacf3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $29ed9452417cacf3$var$load("6qrPg").then(()=>parcelRequire('chcwo'));

});

parcelRegister("a9Bbe", function(module, exports) {

let $764795de135e9982$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $764795de135e9982$var$load("ZREsz").then(()=>parcelRequire('1qhkR'));

});

parcelRegister("9FxYO", function(module, exports) {

let $70a24d16274bfd6e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $70a24d16274bfd6e$var$load("NtjmT").then(()=>parcelRequire('8ZcFH'));

});

parcelRegister("itTua", function(module, exports) {

let $d745f9b51d53d9f7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d745f9b51d53d9f7$var$load("jzQAC").then(()=>parcelRequire('aFAR0'));

});

parcelRegister("k6Ofq", function(module, exports) {

let $ea3b5859182985c8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ea3b5859182985c8$var$load("4MCvh").then(()=>parcelRequire('jlr7a'));

});

parcelRegister("8NKOf", function(module, exports) {

let $668735b4762e62ce$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $668735b4762e62ce$var$load("5NLSq").then(()=>parcelRequire('f2uwm'));

});

parcelRegister("ur8jq", function(module, exports) {

let $05b7d984d03eaa42$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $05b7d984d03eaa42$var$load("7zCoO").then(()=>parcelRequire('94GFK'));

});

parcelRegister("E8B28", function(module, exports) {

let $078a6797263f3feb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $078a6797263f3feb$var$load("b32cU").then(()=>parcelRequire('50ola'));

});


parcelRegister("jt2vt", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $9e659eb07b3c334d$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $39Iwj = parcelRequire("39Iwj");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9e659eb07b3c334d$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $9e659eb07b3c334d$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("53Khq")));
        case 'da':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("22Wpi")));
        case 'de':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("gXUjP")));
        case 'en-GB':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("6rw48")));
        case 'en-US':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("4plTT")));
        case 'en-XA':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("hqkUU")));
        case 'en-XB':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("5cV32")));
        case 'en-ZZ':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("fN9dO")));
        case 'en':
            return $9e659eb07b3c334d$var$importHelper(await Promise.resolve((parcelRequire("39Iwj"))));
        case 'es':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("aYv5p")));
        case 'et':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("4KQx6")));
        case 'fi':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("1e3g6")));
        case 'fr':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("lQ618")));
        case 'hr':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("9nYg2")));
        case 'hu':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("4XebG")));
        case 'it':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("e1c8c")));
        case 'ja':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("iOof0")));
        case 'ko':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("9zfUK")));
        case 'nb':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("czdhK")));
        case 'nl':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("4cCgh")));
        case 'pl':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("2OMa3")));
        case 'pt-BR':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("bOT0T")));
        case 'ro':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("d5I28")));
        case 'ru':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("i7HXS")));
        case 'sl':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("bfhjW")));
        case 'sr-RS':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("dA0Y1")));
        case 'sr-YR':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("1PnBL")));
        case 'sr':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("cvb3d")));
        case 'sv':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("dsQmw")));
        case 'th':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("dCsf0")));
        case 'tr':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("hnxtW")));
        case 'uk':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("3FU3N")));
        case 'vi':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("5w1DM")));
        case 'zh-CN':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("hTq8E")));
        case 'zh-TW':
            return $9e659eb07b3c334d$var$importHelper(await (parcelRequire("jubAi")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($39Iwj));
    }
};

});
parcelRegister("39Iwj", function(module, exports) {
module.exports = JSON.parse('{"app.accept":[{"type":0,"value":"Accept"}],"app.reject":[{"type":0,"value":"Reject"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"ecosystem-forge-apps.ecosystem-forge-apps-in-app.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"jira.jira-project-pages-gdrive-deprecation.message-template.email.subject":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-1":[{"type":0,"value":"We\'re reaching out to notify you that from April 23rd 2024, syncing Google Drive shared drives will no longer be supported in Project Pages for the users in your site. Users will no longer be able to access their shared drives Jira as we are removing the feature, but they will still be able to sync Confluence spaces to Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-2":[{"type":0,"value":"Please note that we are not deleting any data within Google Drive itself. The change only affects the ability to sync, link, and access Google Shared Drives from Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-3":[{"type":0,"value":"This is part of our ongoing efforts to streamline our services and ensure the highest quality experience for our users."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-4":[{"type":0,"value":"Next steps:"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-5":[{"type":0,"value":"We are committed to providing you with the best possible experience, and appreciate your understanding as we make these necessary improvements. Thank you for your continued support."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-1":[{"type":0,"value":"No immediate action is required from your end regarding this deprecation. However, we understand that this change may impact your workflow, and we are here to support you through this transition."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-3":[{"type":0,"value":"For any feedback, or further questions and assistance with change management, please contact jnguyen2@atlassian.com"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.greeting":[{"type":0,"value":"Dear Admin,"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.title":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-weekly-digest.message-template.email.subject":[{"type":0,"value":"Your weekly digest for Jira project: "},{"type":1,"value":"projectName"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCompletion":[{"type":0,"value":"issues completed in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCreated":[{"type":0,"value":"issues created in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesUpdated":[{"type":0,"value":"issues updated in the past week"}],"jira.jira-weekly-digest.test-message.email.body.plusSign":[{"type":0,"value":"+"}],"jira.jira-weekly-digest.test-message.email.header":[{"type":0,"value":"Here\'s your weekly digest for Jira ("},{"type":1,"value":"projectName"},{"type":0,"value":") over the past week"}],"jira.jira-weekly-digest.test-message.email.headerDescription":[{"type":0,"value":"You\u2019re receiving this email because you have opted in to receive weekly updates for this project in Jira."}],"jira.jira-weekly-digest.test-message.email.playbookBodyText":[{"type":0,"value":"Atlassian Playbook"}],"jira.jira-weekly-digest.test-message.email.playbookHeader":[{"type":0,"value":"Has your team conducted a retrospective recently?"}],"jira.jira-weekly-digest.test-message.email.playbookSubheader":[{"type":0,"value":"A retrospective gives you an opportunity to review your latest project progress and make improvements for the future. Find out more at "},{"type":1,"value":"link"},{"type":0,"value":"."}],"jira.jira-weekly-digest.test-message.email.tableHeader":[{"type":0,"value":"Weekly Summary"}],"jira.suppression-email-notification-email.contact-us":[{"type":0,"value":"contact us"}],"jira.suppression-email-notification-email.email.body":[{"type":0,"value":"This is an automatated message to notify you that the jira "},{"type":1,"value":"emailType"},{"type":0,"value":" email \\n\\t\\t\\t\\t\\t\\tto "},{"type":1,"value":"affectedUserEmail"},{"type":0,"value":" has been suppressed. Please visit this "},{"type":1,"value":"unsuppressApiLink"},{"type":0,"value":" to unsuppress the user\'s email."}],"jira.suppression-email-notification-email.email.body.goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" if the issue persists, we\'re always happy to help."}],"jira.suppression-email-notification-email.email.body.regards":[{"type":0,"value":"Jira Notifications Team"}],"jira.suppression-email-notification-email.email.body.signoff":[{"type":0,"value":"Regards,"}],"jira.suppression-email-notification-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"jira.suppression-email-notification-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira.suppression-email-notification-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"playground.playground-local-execution-message.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"playground.playground-local-execution-message.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"playground.playground-local-execution-message.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hello, fellow child "},{"type":1,"value":"name"},{"type":0,"value":","}],"playground.playground-local-execution-message.test-message.email.body.no-translate":[{"type":0,"value":"We are currently trying to locally execute this message!"}],"playground.playground-local-execution-message.test-message.email.body.regards.no-translate":[{"type":0,"value":"Playground Team"}],"playground.playground-local-execution-message.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"playground.playground-local-execution-message.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office.commerce-common.unsuppress-email-link":[{"type":0,"value":"link"}],"post-office.jira-email.contact-us":[{"type":0,"value":"contact us"}],"post-office.playground.go-faster-techops-rollup-notifier.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.playground.test-playground-message.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}]}');

});

parcelRegister("53Khq", function(module, exports) {

let $3af121cb3d08da2f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3af121cb3d08da2f$var$load("3SonL").then(()=>parcelRequire('kNpjt'));

});

parcelRegister("22Wpi", function(module, exports) {

let $17d9131aac1c809f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $17d9131aac1c809f$var$load("klZt6").then(()=>parcelRequire('9OQJ3'));

});

parcelRegister("gXUjP", function(module, exports) {

let $c59dd7c107f2da88$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c59dd7c107f2da88$var$load("SNZYM").then(()=>parcelRequire('kvBW2'));

});

parcelRegister("6rw48", function(module, exports) {

let $4b0e234ba3d18b01$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4b0e234ba3d18b01$var$load("13NiA").then(()=>parcelRequire('7RyY1'));

});

parcelRegister("4plTT", function(module, exports) {

let $335a7c32fb506979$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $335a7c32fb506979$var$load("eaQJy").then(()=>parcelRequire('hiB2k'));

});

parcelRegister("hqkUU", function(module, exports) {

let $caf5170809ef8b00$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $caf5170809ef8b00$var$load("6B9mS").then(()=>parcelRequire('haejE'));

});

parcelRegister("5cV32", function(module, exports) {

let $3caa534c7d824056$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3caa534c7d824056$var$load("7vQEF").then(()=>parcelRequire('4RT06'));

});

parcelRegister("fN9dO", function(module, exports) {

let $b7f295e47698cee6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b7f295e47698cee6$var$load("dy2hK").then(()=>parcelRequire('cNVtU'));

});

parcelRegister("aYv5p", function(module, exports) {

let $7fd79f09a38aab57$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7fd79f09a38aab57$var$load("7DCFN").then(()=>parcelRequire('ilYIz'));

});

parcelRegister("4KQx6", function(module, exports) {

let $37643539077e2764$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $37643539077e2764$var$load("57Xj9").then(()=>parcelRequire('lEdTH'));

});

parcelRegister("1e3g6", function(module, exports) {

let $0e49a05ae6a31fda$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0e49a05ae6a31fda$var$load("fzavG").then(()=>parcelRequire('lWeFp'));

});

parcelRegister("lQ618", function(module, exports) {

let $fe631f3a6b686486$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fe631f3a6b686486$var$load("lfoGx").then(()=>parcelRequire('2RbH3'));

});

parcelRegister("9nYg2", function(module, exports) {

let $6d5500f8f246006c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6d5500f8f246006c$var$load("cuXw5").then(()=>parcelRequire('3xZRJ'));

});

parcelRegister("4XebG", function(module, exports) {

let $39b7ad7531e86447$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $39b7ad7531e86447$var$load("kskDk").then(()=>parcelRequire('6fyRV'));

});

parcelRegister("e1c8c", function(module, exports) {

let $a34a91b511bd2597$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a34a91b511bd2597$var$load("aZ85n").then(()=>parcelRequire('iDELx'));

});

parcelRegister("iOof0", function(module, exports) {

let $db1fb348c4e4e5c0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $db1fb348c4e4e5c0$var$load("4xDUb").then(()=>parcelRequire('5A4HG'));

});

parcelRegister("9zfUK", function(module, exports) {

let $6f73ba2ccaef114d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6f73ba2ccaef114d$var$load("612V0").then(()=>parcelRequire('2DBCt'));

});

parcelRegister("czdhK", function(module, exports) {

let $92630f14ca360b49$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $92630f14ca360b49$var$load("kqYwk").then(()=>parcelRequire('bBee1'));

});

parcelRegister("4cCgh", function(module, exports) {

let $30f5f65a08c0452f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $30f5f65a08c0452f$var$load("6ar5P").then(()=>parcelRequire('cTXqI'));

});

parcelRegister("2OMa3", function(module, exports) {

let $20d59c11453e1acd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $20d59c11453e1acd$var$load("1Rxfs").then(()=>parcelRequire('kXEPy'));

});

parcelRegister("bOT0T", function(module, exports) {

let $89af09c2fcebaf45$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $89af09c2fcebaf45$var$load("6TSII").then(()=>parcelRequire('cLL7N'));

});

parcelRegister("d5I28", function(module, exports) {

let $987de61bb357ccbe$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $987de61bb357ccbe$var$load("4Fk7W").then(()=>parcelRequire('dc7Qn'));

});

parcelRegister("i7HXS", function(module, exports) {

let $0367a9397441384e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0367a9397441384e$var$load("5wSxD").then(()=>parcelRequire('81m8J'));

});

parcelRegister("bfhjW", function(module, exports) {

let $82fe87f3d4dfbdfd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $82fe87f3d4dfbdfd$var$load("dVpI2").then(()=>parcelRequire('dxuid'));

});

parcelRegister("dA0Y1", function(module, exports) {

let $9e2f6338462d9161$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9e2f6338462d9161$var$load("aermH").then(()=>parcelRequire('e5FhB'));

});

parcelRegister("1PnBL", function(module, exports) {

let $154cddf3e7bcae12$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $154cddf3e7bcae12$var$load("k5sUd").then(()=>parcelRequire('iyw1R'));

});

parcelRegister("cvb3d", function(module, exports) {

let $91a0f3bf3929bd60$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $91a0f3bf3929bd60$var$load("hGjza").then(()=>parcelRequire('CX2pr'));

});

parcelRegister("dsQmw", function(module, exports) {

let $9cd681f228e210d9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9cd681f228e210d9$var$load("17r9Y").then(()=>parcelRequire('gxpYa'));

});

parcelRegister("dCsf0", function(module, exports) {

let $9ea4bb13fd85d050$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9ea4bb13fd85d050$var$load("l3Has").then(()=>parcelRequire('1K8fD'));

});

parcelRegister("hnxtW", function(module, exports) {

let $ca6e8e7718c21bff$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ca6e8e7718c21bff$var$load("azEaY").then(()=>parcelRequire('k3r3P'));

});

parcelRegister("3FU3N", function(module, exports) {

let $2ad0afd43415a056$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2ad0afd43415a056$var$load("g6nxr").then(()=>parcelRequire('aRsrZ'));

});

parcelRegister("5w1DM", function(module, exports) {

let $404136b1bf13b4ee$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $404136b1bf13b4ee$var$load("dc8pH").then(()=>parcelRequire('Ef3fe'));

});

parcelRegister("hTq8E", function(module, exports) {

let $d06bd94d77dc1777$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d06bd94d77dc1777$var$load("992h7").then(()=>parcelRequire('aQZJC'));

});

parcelRegister("jubAi", function(module, exports) {

let $e2f9ce16b02fe44f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e2f9ce16b02fe44f$var$load("6wNQH").then(()=>parcelRequire('kriir'));

});


parcelRegister("3c2oE", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $73a92322e92dc4ab$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $3hVdC = parcelRequire("3hVdC");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73a92322e92dc4ab$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $73a92322e92dc4ab$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("cZfe9")));
        case 'da':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("kFpCS")));
        case 'de':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("lGFdo")));
        case 'en-GB':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("hCOV0")));
        case 'en-US':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("lmrwL")));
        case 'en-XA':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("dytBF")));
        case 'en-XB':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("kSTjb")));
        case 'en-ZZ':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("3U6cK")));
        case 'en':
            return $73a92322e92dc4ab$var$importHelper(await Promise.resolve((parcelRequire("3hVdC"))));
        case 'es':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("gk7CZ")));
        case 'et':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("f3CwY")));
        case 'fi':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("lA0hk")));
        case 'fr':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("7dxA6")));
        case 'hr':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("2DyII")));
        case 'hu':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("cFgQc")));
        case 'it':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("h4Nla")));
        case 'ja':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("iVbWJ")));
        case 'ko':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("73NFx")));
        case 'nb':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("xpflk")));
        case 'nl':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("aTCFX")));
        case 'pl':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("51Ayb")));
        case 'pt-BR':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("cySty")));
        case 'ro':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("fR6Qr")));
        case 'ru':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("5vCSA")));
        case 'sl':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("iRSfp")));
        case 'sr-RS':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("d3nrG")));
        case 'sr-YR':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("6dogW")));
        case 'sr':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("9knJP")));
        case 'sv':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("8xVsr")));
        case 'th':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("iKYxT")));
        case 'tr':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("aTR5Q")));
        case 'uk':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("hUq3b")));
        case 'vi':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("9P6rR")));
        case 'zh-CN':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("iG9nR")));
        case 'zh-TW':
            return $73a92322e92dc4ab$var$importHelper(await (parcelRequire("dHTsY")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($3hVdC));
    }
};

});
parcelRegister("3hVdC", function(module, exports) {
module.exports = JSON.parse('{"feedback-collector.can-be-enrolled-label.text":[{"type":0,"value":"Atlassian can contact me about this feedback. See our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"feedback-collector.enroll-in-research-label.text":[{"type":0,"value":"I\'d like to help improve Atlassian products by joining the"},{"type":1,"value":"nbsp"},{"type":1,"value":"n"},{"type":1,"value":"t"},{"type":1,"value":"t"},{"children":[{"type":0,"value":"Atlassian Research Group"}],"type":8,"value":"enrollLink"}],"feedback-collector.feedback-title-details.component":[{"type":0,"value":"For help with billing or other issues, visit our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"documentation"}],"type":8,"value":"documentationLink"},{"type":1,"value":"nbsp"},{"type":0,"value":"or contact"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"support"}],"type":8,"value":"supportLink"}],"no-notifications-fallback.learn-more-link.text":[{"type":0,"value":"Learn more about this feature"}],"no-notifications-fallback.no-notifications.text":[{"type":0,"value":"Check back soon. No notifications yet."}],"notifications.error-fallback-error-reason.text":[{"type":0,"value":"We\'re unable to load notifications"}],"notifications.error-fallback-proposed-solution.text":[{"type":0,"value":"Refresh the page or try again later"}],"post-office-team.confluence-recommended-following-feed.add-comment-button":[{"type":0,"value":"Comment"}],"post-office-team.confluence-recommended-following-feed.add-emoji-button-alt-text":[{"type":0,"value":"Add Emoji"}],"post-office-team.confluence-recommended-following-feed.atlassian-logo":[{"type":0,"value":"Atlassian Logo"}],"post-office-team.confluence-recommended-following-feed.blog-icon":[{"type":0,"value":"Blog icon"}],"post-office-team.confluence-recommended-following-feed.clap-button-alt-text":[{"type":0,"value":"Clap"}],"post-office-team.confluence-recommended-following-feed.database-icon":[{"type":0,"value":"Database icon"}],"post-office-team.confluence-recommended-following-feed.email-unsubscribe-text":[{"children":[{"type":0,"value":"Update your email settings"}],"type":8,"value":"trackedLink"},{"type":0,"value":" to customize or stop receiving this email."}],"post-office-team.confluence-recommended-following-feed.email.body.hello":[{"type":0,"value":"G\'day "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.confluence-recommended-following-feed.email.body.summary":[{"type":0,"value":"Here are pages your team is reading, don\'t miss out on the conversation."}],"post-office-team.confluence-recommended-following-feed.email.ios-android-text":[{"type":0,"value":"Download the Confluence mobile app on "},{"children":[{"type":0,"value":"iOS"}],"type":8,"value":"iosLink"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"Android"}],"type":8,"value":"androidLink"},{"type":0,"value":" to read notifications and comment on the go."}],"post-office-team.confluence-recommended-following-feed.email.privacy-policy-text":[{"type":0,"value":"This email was sent by Atlassian Confluence  \u2022  "},{"children":[{"type":0,"value":"Privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"post-office-team.confluence-recommended-following-feed.email.subject":[{"type":1,"value":"name"},{"type":0,"value":", your team is working on these pages -- join the conversation"}],"post-office-team.confluence-recommended-following-feed.email.subject.variant-a":[{"type":1,"value":"name"},{"type":0,"value":", "},{"type":1,"value":"pageTitle"},{"type":0,"value":" plus more pages your team is working on"}],"post-office-team.confluence-recommended-following-feed.header.confluence-icon.alt-text":[{"type":0,"value":"Confluence Icon"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted":[{"children":[{"type":1,"value":"firstUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"secondUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.no-comments":[{"type":0,"value":"Be the first to comment"}],"post-office-team.confluence-recommended-following-feed.no-reactions-text":[{"type":0,"value":"Be the first to react"}],"post-office-team.confluence-recommended-following-feed.number-of-comments":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comment"}]},"other":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comments"}]}},"pluralType":"cardinal","type":6,"value":"commentCount"}],"post-office-team.confluence-recommended-following-feed.number-of-users-reacted":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"reactionCount"}],"post-office-team.confluence-recommended-following-feed.owned-by":[{"type":0,"value":"Owned by "},{"type":1,"value":"ownerName"}],"post-office-team.confluence-recommended-following-feed.party-popper-button-alt-text":[{"type":0,"value":"Party Popper"}],"post-office-team.confluence-recommended-following-feed.read-more-link":[{"type":0,"value":"Read more"}],"post-office-team.confluence-recommended-following-feed.thumbs-up-button-alt-text":[{"type":0,"value":"Thumbs up"}],"post-office-team.confluence-recommended-following-feed.user-profile-picture-alt-text":[{"type":1,"value":"name"},{"type":0,"value":"\'s profile picture"}],"post-office-team.confluence-recommended-following-feed.whiteboard-icon":[{"type":0,"value":"Whiteboard icon"}],"post-office-team.email-with-tracking-links.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.email-with-tracking-links.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.email-with-tracking-links.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.email-with-tracking-links.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.email-with-tracking-links.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.email-with-tracking-links.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.email-with-tracking-links.test-message.email.confluence-link.text.no-translate":[{"type":0,"value":"Go to Confluence link"}],"post-office-team.email-with-tracking-links.test-message.email.jira-link.text.no-translate":[{"type":0,"value":"Go to Jira link"}],"post-office-team.email-with-tracking-links.test-message.email.trello-link.text.no-translate":[{"type":0,"value":"Go to Trello board"}],"post-office-team.push-msg-object-tracking.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.push-msg-object-tracking.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.push-msg-object-tracking.message-template.microsoft-teams.hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office-team.push-msg-object-tracking.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.push-msg-object-tracking.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.push-msg-object-tracking.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.push-msg-object-tracking.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.push-msg-object-tracking.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office.admin-hub.end-of-notifications.description":[{"type":0,"value":"That\'s all your notifications from the last 90 days"}],"post-office.post-office-team-components.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"post-office.post-office-team-components.email.footer.office-address":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.post-office-team-components.email.footer.why-am-i-receiving-this-email":[{"type":0,"value":"You are receiving this email because this is an important message regarding your account and products you are using. You are not allowed to unsubscribe from this type of message."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.cta-link":[{"type":0,"value":"Get started"}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.description":[{"type":0,"value":"Help us improve messaging for Atlassian Admins! Answer a few short questions, and our\\n\\t\\t\\t\\t\\tResearch team will contact you for a 60-minute Zoom session if you qualify."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.header":[{"type":0,"value":"Share your experience for $120 USD"}],"post-office.post-office-team.push-msg-object-tracking.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.post-office-team.push-msg-object-tracking.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}]}');

});

parcelRegister("cZfe9", function(module, exports) {

let $9746fe59e7898e93$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9746fe59e7898e93$var$load("l1hqw").then(()=>parcelRequire('9UBR8'));

});

parcelRegister("kFpCS", function(module, exports) {

let $f0bb83c5527bc9aa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f0bb83c5527bc9aa$var$load("1IEIx").then(()=>parcelRequire('X8nGW'));

});

parcelRegister("lGFdo", function(module, exports) {

let $fc9d7da6c9d662dd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fc9d7da6c9d662dd$var$load("ez8EO").then(()=>parcelRequire('601gj'));

});

parcelRegister("hCOV0", function(module, exports) {

let $cd4d7ba3d8f07b97$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cd4d7ba3d8f07b97$var$load("eZtPU").then(()=>parcelRequire('5GsU0'));

});

parcelRegister("lmrwL", function(module, exports) {

let $f8d1016f09800287$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f8d1016f09800287$var$load("5NpNL").then(()=>parcelRequire('eQwNS'));

});

parcelRegister("dytBF", function(module, exports) {

let $9de56a906e023ea5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9de56a906e023ea5$var$load("isakX").then(()=>parcelRequire('8wUap'));

});

parcelRegister("kSTjb", function(module, exports) {

let $f343c0e603190bd2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f343c0e603190bd2$var$load("jQzVH").then(()=>parcelRequire('lGJKr'));

});

parcelRegister("3U6cK", function(module, exports) {

let $2d7b6a2445cacd21$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2d7b6a2445cacd21$var$load("5mwZx").then(()=>parcelRequire('bi2Xc'));

});

parcelRegister("gk7CZ", function(module, exports) {

let $be246e5076536a66$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $be246e5076536a66$var$load("eMuX0").then(()=>parcelRequire('5Xf71'));

});

parcelRegister("f3CwY", function(module, exports) {

let $02d435c71f72d1d4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $02d435c71f72d1d4$var$load("iruRN").then(()=>parcelRequire('4R6MI'));

});

parcelRegister("lA0hk", function(module, exports) {

let $fb5d2d13fb61a59a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fb5d2d13fb61a59a$var$load("aVZQy").then(()=>parcelRequire('41MNu'));

});

parcelRegister("7dxA6", function(module, exports) {

let $5413cbdf7dcbb44c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5413cbdf7dcbb44c$var$load("aSF6R").then(()=>parcelRequire('8YU3Y'));

});

parcelRegister("2DyII", function(module, exports) {

let $1eba2805e98b22f9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1eba2805e98b22f9$var$load("f5fb8").then(()=>parcelRequire('jJZ4s'));

});

parcelRegister("cFgQc", function(module, exports) {

let $9386609d0f507c9a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9386609d0f507c9a$var$load("gDCSQ").then(()=>parcelRequire('5bNgn'));

});

parcelRegister("h4Nla", function(module, exports) {

let $c6e91558d8439150$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c6e91558d8439150$var$load("3n0RW").then(()=>parcelRequire('8KFqz'));

});

parcelRegister("iVbWJ", function(module, exports) {

let $dc66d126709a8dd4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dc66d126709a8dd4$var$load("giktG").then(()=>parcelRequire('bcyKq'));

});

parcelRegister("73NFx", function(module, exports) {

let $523f5772597ce161$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $523f5772597ce161$var$load("4xVRm").then(()=>parcelRequire('12aPw'));

});

parcelRegister("xpflk", function(module, exports) {

let $0646aa9ad58a3ea6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0646aa9ad58a3ea6$var$load("9dToX").then(()=>parcelRequire('40jEh'));

});

parcelRegister("aTCFX", function(module, exports) {

let $7eed0aa4281ca7dd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7eed0aa4281ca7dd$var$load("aPmWA").then(()=>parcelRequire('3u4TQ'));

});

parcelRegister("51Ayb", function(module, exports) {

let $3a8965e5b992714c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3a8965e5b992714c$var$load("hdJk1").then(()=>parcelRequire('a9RXo'));

});

parcelRegister("cySty", function(module, exports) {

let $9252eac11b974f5a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9252eac11b974f5a$var$load("gOnQk").then(()=>parcelRequire('lKf5G'));

});

parcelRegister("fR6Qr", function(module, exports) {

let $b8b11d79178f7385$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b8b11d79178f7385$var$load("hbNdj").then(()=>parcelRequire('1NdMy'));

});

parcelRegister("5vCSA", function(module, exports) {

let $402e01aa094cca8d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $402e01aa094cca8d$var$load("cd11l").then(()=>parcelRequire('2RqpB'));

});

parcelRegister("iRSfp", function(module, exports) {

let $dbc741a67199771f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dbc741a67199771f$var$load("8im7n").then(()=>parcelRequire('lzQeM'));

});

parcelRegister("d3nrG", function(module, exports) {

let $980dbdfb206a5fb9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $980dbdfb206a5fb9$var$load("gEwxU").then(()=>parcelRequire('e4SsG'));

});

parcelRegister("6dogW", function(module, exports) {

let $4866c8f1a9504f38$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4866c8f1a9504f38$var$load("bg7vG").then(()=>parcelRequire('56OMm'));

});

parcelRegister("9knJP", function(module, exports) {

let $6ca8653c4adbcb24$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6ca8653c4adbcb24$var$load("6lzrL").then(()=>parcelRequire('eUK88'));

});

parcelRegister("8xVsr", function(module, exports) {

let $638df9b39c21181c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $638df9b39c21181c$var$load("8jXvV").then(()=>parcelRequire('hy0QA'));

});

parcelRegister("iKYxT", function(module, exports) {

let $da7b7cfcd81d2343$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $da7b7cfcd81d2343$var$load("eERVP").then(()=>parcelRequire('5kjtA'));

});

parcelRegister("aTR5Q", function(module, exports) {

let $7ef839a1dd8d208b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7ef839a1dd8d208b$var$load("9vJfz").then(()=>parcelRequire('4HoF6'));

});

parcelRegister("hUq3b", function(module, exports) {

let $d09bdfaefefd4ab6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d09bdfaefefd4ab6$var$load("1S3yg").then(()=>parcelRequire('6ncWe'));

});

parcelRegister("9P6rR", function(module, exports) {

let $726de0faeccb02e3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $726de0faeccb02e3$var$load("lWvOi").then(()=>parcelRequire('gsecg'));

});

parcelRegister("iG9nR", function(module, exports) {

let $d9936daeb9f527e7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d9936daeb9f527e7$var$load("lkkU7").then(()=>parcelRequire('4oofM'));

});

parcelRegister("dHTsY", function(module, exports) {

let $9faa50f9ea8a4998$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9faa50f9ea8a4998$var$load("2apTK").then(()=>parcelRequire('cTtD6'));

});


parcelRegister("dINkw", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $a0ad1b0a4ac398d9$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $eAckq = parcelRequire("eAckq");

var $keNcc = parcelRequire("keNcc");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a0ad1b0a4ac398d9$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a0ad1b0a4ac398d9$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $keNcc.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("5pIql")));
        case 'da':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("c8o3V")));
        case 'de':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("3w8ZN")));
        case 'en-GB':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("iP6po")));
        case 'en-US':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("beAJR")));
        case 'en-XA':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("j0Vqw")));
        case 'en-XB':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("faEGq")));
        case 'en-ZZ':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("krbn2")));
        case 'en':
            return $a0ad1b0a4ac398d9$var$importHelper(await Promise.resolve((parcelRequire("eAckq"))));
        case 'es':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("4ZvXI")));
        case 'et':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("7ePqP")));
        case 'fi':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("fgHfp")));
        case 'fr':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("k2QHi")));
        case 'hr':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("kIXbO")));
        case 'hu':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("diqqs")));
        case 'it':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("cuNPG")));
        case 'ja':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("d2hWN")));
        case 'ko':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("aCHCK")));
        case 'nb':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("hLawL")));
        case 'nl':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("jsFIF")));
        case 'pl':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("eOX68")));
        case 'pt-BR':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("5nWH0")));
        case 'ro':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("bXFuC")));
        case 'ru':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("7Yagc")));
        case 'sl':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("1f3Aj")));
        case 'sr-RS':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("aGfrG")));
        case 'sr-YR':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("4GL40")));
        case 'sr':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("a2BxO")));
        case 'sv':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("cxxut")));
        case 'th':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("4L1Z0")));
        case 'tr':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("fsZEq")));
        case 'uk':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("cEwCa")));
        case 'vi':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("2kHgF")));
        case 'zh-CN':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("509ao")));
        case 'zh-TW':
            return $a0ad1b0a4ac398d9$var$importHelper(await (parcelRequire("cOq7c")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($eAckq));
    }
};

});
parcelRegister("eAckq", function(module, exports) {
module.exports = JSON.parse("{\"admin-hub.ci-test.message-template-template-hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"ci-generation.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"ci-generation.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"ci-generation.email.body.img.alt\":[{\"type\":0,\"value\":\"This is the alt text for the image\"}],\"ci-generation.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"ci-generation.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"ci-generation.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"ci-generation.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.test-message-digest-email-template.test-message.email.body.digest-title\":[{\"type\":0,\"value\":\"You have \"},{\"type\":1,\"value\":\"numberOfMsg\"},{\"type\":0,\"value\":\" new messages!\"}],\"post-office.test-message-digest-email-template.test-message.email.body.message-body\":[{\"type\":1,\"value\":\"defaultMessage\"}],\"post-office.test-message-microsoft-teams.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, this is test message from Post Office: \"},{\"type\":1,\"value\":\"text\"}],\"post-office.test-message.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\".\"}],\"post-office.test-messages.test-message-load-test-push-flow-email-mobile-push.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push-jira-ugc.redacted.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a redacted test mobile push notification from post office.\"}],\"post-office.test-messages.test-message-mobile-push-jira-ugc.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push.redacted.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a redacted mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-transform-metadata.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.test-slack-notification.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"product-store-personal-use-case.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}],\"test-messages.app-switcher-discovery-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-discovery-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.app-switcher-upgrade-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-upgrade-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.in-app-example.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.jira-navigation-topbar-edition-awareness.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.redacted-email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.team-message-email-ugc.message-template.email.redacted.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Redacted Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-content-diffing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-content-diffing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-content-diffing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-content-diffing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-content-diffing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-content-diffing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-content-diffing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-digest-email.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-digest-email.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-email.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hey \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-digest-email.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. Here is your daily digest (rick) rollup for the \"},{\"type\":1,\"value\":\"site\"},{\"type\":0,\"value\":\" workspace\"}],\"test-messages.test-message-digest-email.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-digest-email.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-digest-email.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-digest-local.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-digest-local.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-local.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-digest-local.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-digest-local.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-digest-local.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-digest-local.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-cdn.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-cdn.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-cdn.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-cdn.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-experiment-exposure.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-experiment-exposure.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.body.button.no-translate\":[{\"type\":0,\"value\":\"Click me!\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-experiment-exposure.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-high-priority.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-high-priority.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-high-priority.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-high-priority.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-mfc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-mfc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-ugc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-ugc.message-template-template.email.redacted.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-ugc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-ugc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-ugc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-ugc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-ugc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.no-translate\":[{\"type\":0,\"value\":\"This is a redacted test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-ugc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-grouped-recipients.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hello\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-marketing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-marketing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-marketing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-marketing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-message-failures.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-message-failures.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-message-failures.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-message-failures.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-message-failures.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-message-failures.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-message-failures.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-persona-email.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-persona-email.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-persona-email.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-persona-email.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-persona-email.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-persona-email.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-raw-recipients.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.greeting.no-translate\":[{\"type\":1,\"value\":\"greeting\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.name.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi,\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-transform-metadata.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-transform-metadata.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-transform-metadata.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.app.img.alt.large\":[{\"type\":0,\"value\":\"test image 2\"}],\"test-messages.test-message.app.img.alt.plant\":[{\"type\":0,\"value\":\"test image 1\"}],\"test-messages.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.redacted-email.body\":[{\"type\":0,\"value\":\"This is the redacted version of the test email message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.redacted-email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.redacted-email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.redacted-email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.redacted-email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"wac-global-nav-product-recommendation.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}]}");

});

parcelRegister("5pIql", function(module, exports) {

let $3f11bf31bb9dcd81$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3f11bf31bb9dcd81$var$load("zSFtB").then(()=>parcelRequire('e0alp'));

});

parcelRegister("c8o3V", function(module, exports) {

let $8d58e5a85d009258$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8d58e5a85d009258$var$load("1STpj").then(()=>parcelRequire('83JeN'));

});

parcelRegister("3w8ZN", function(module, exports) {

let $28fb569e5f591f4e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $28fb569e5f591f4e$var$load("9tDxK").then(()=>parcelRequire('kApYp'));

});

parcelRegister("iP6po", function(module, exports) {

let $db41f60bbd8e0446$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $db41f60bbd8e0446$var$load("31BpD").then(()=>parcelRequire('abVdH'));

});

parcelRegister("beAJR", function(module, exports) {

let $82dd8007bd8d435d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $82dd8007bd8d435d$var$load("ftISw").then(()=>parcelRequire('7WDcj'));

});

parcelRegister("j0Vqw", function(module, exports) {

let $dd7a902ea59fb47d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dd7a902ea59fb47d$var$load("dDjdj").then(()=>parcelRequire('lwP0b'));

});

parcelRegister("faEGq", function(module, exports) {

let $b0b759092098f451$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b0b759092098f451$var$load("2PkJq").then(()=>parcelRequire('3yhan'));

});

parcelRegister("krbn2", function(module, exports) {

let $ee0f26380737365c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ee0f26380737365c$var$load("8WnDC").then(()=>parcelRequire('84Pac'));

});

parcelRegister("4ZvXI", function(module, exports) {

let $3a25a6f74a412a93$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3a25a6f74a412a93$var$load("bbCh8").then(()=>parcelRequire('34b1R'));

});

parcelRegister("7ePqP", function(module, exports) {

let $5451bc7d2b6922d1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5451bc7d2b6922d1$var$load("7VaC6").then(()=>parcelRequire('cBZAY'));

});

parcelRegister("fgHfp", function(module, exports) {

let $b1d9e5b91c37cfdd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b1d9e5b91c37cfdd$var$load("jTaD5").then(()=>parcelRequire('8kKdu'));

});

parcelRegister("k2QHi", function(module, exports) {

let $e97cdf2a04d21c10$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e97cdf2a04d21c10$var$load("97sTn").then(()=>parcelRequire('VL6gs'));

});

parcelRegister("kIXbO", function(module, exports) {

let $f165d47f13d22a9f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f165d47f13d22a9f$var$load("2eUYM").then(()=>parcelRequire('faQcr'));

});

parcelRegister("diqqs", function(module, exports) {

let $9ae17463452158b2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9ae17463452158b2$var$load("7L14N").then(()=>parcelRequire('1vW3k'));

});

parcelRegister("cuNPG", function(module, exports) {

let $918ef11546a9fafb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $918ef11546a9fafb$var$load("7sH2a").then(()=>parcelRequire('ffdwt'));

});

parcelRegister("d2hWN", function(module, exports) {

let $97d962365c4d37cf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $97d962365c4d37cf$var$load("lBI3c").then(()=>parcelRequire('6rRBo'));

});

parcelRegister("aCHCK", function(module, exports) {

let $7bbf4acd4edcbbc6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7bbf4acd4edcbbc6$var$load("jB6vu").then(()=>parcelRequire('ah5Gl'));

});

parcelRegister("hLawL", function(module, exports) {

let $cedefdf81cf8d9e9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cedefdf81cf8d9e9$var$load("I6dvG").then(()=>parcelRequire('jDGC9'));

});

parcelRegister("jsFIF", function(module, exports) {

let $e2b0fe731b2717d8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e2b0fe731b2717d8$var$load("ddbe5").then(()=>parcelRequire('3gyTM'));

});

parcelRegister("eOX68", function(module, exports) {

let $aca393d1d5e3c2bc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $aca393d1d5e3c2bc$var$load("feB1q").then(()=>parcelRequire('4p0xg'));

});

parcelRegister("5nWH0", function(module, exports) {

let $3ebca0ddb5f6a9d6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3ebca0ddb5f6a9d6$var$load("gb5wM").then(()=>parcelRequire('1bZfn'));

});

parcelRegister("bXFuC", function(module, exports) {

let $8b5564065055bc66$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8b5564065055bc66$var$load("fAMKZ").then(()=>parcelRequire('dmGK7'));

});

parcelRegister("7Yagc", function(module, exports) {

let $5cd618775221b746$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5cd618775221b746$var$load("5NVoc").then(()=>parcelRequire('30kwF'));

});

parcelRegister("1f3Aj", function(module, exports) {

let $0e79f901f1a52f6c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0e79f901f1a52f6c$var$load("glR37").then(()=>parcelRequire('2pPDu'));

});

parcelRegister("aGfrG", function(module, exports) {

let $7c69cecaaca71063$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7c69cecaaca71063$var$load("h9OSu").then(()=>parcelRequire('5D77T'));

});

parcelRegister("4GL40", function(module, exports) {

let $369f978404aeb6c9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $369f978404aeb6c9$var$load("4LEfs").then(()=>parcelRequire('5HA2F'));

});

parcelRegister("a2BxO", function(module, exports) {

let $74f736d15c884687$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $74f736d15c884687$var$load("etnfr").then(()=>parcelRequire('haUwJ'));

});

parcelRegister("cxxut", function(module, exports) {

let $92128b9d28012f72$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $92128b9d28012f72$var$load("fYw43").then(()=>parcelRequire('81QDr'));

});

parcelRegister("4L1Z0", function(module, exports) {

let $376d16f9c4bcf3f9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $376d16f9c4bcf3f9$var$load("dFQJ2").then(()=>parcelRequire('lPgS5'));

});

parcelRegister("fsZEq", function(module, exports) {

let $b4294b2ace2baca8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b4294b2ace2baca8$var$load("9L5qf").then(()=>parcelRequire('bd4XN'));

});

parcelRegister("cEwCa", function(module, exports) {

let $9362850893217657$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9362850893217657$var$load("9YE2Z").then(()=>parcelRequire('iOHsU'));

});

parcelRegister("2kHgF", function(module, exports) {

let $1b2f031df2db1740$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1b2f031df2db1740$var$load("hArgm").then(()=>parcelRequire('6db6g'));

});

parcelRegister("509ao", function(module, exports) {

let $3a4410267d823701$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3a4410267d823701$var$load("532rv").then(()=>parcelRequire('0Zx9T'));

});

parcelRegister("cOq7c", function(module, exports) {

let $953e697cc2241e61$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $953e697cc2241e61$var$load("iYFO1").then(()=>parcelRequire('ckSuW'));

});




parcelRegister("kv6e6", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceFlagPlacementPreviewSwitcher", () => $f3056587d1c9db6b$export$46db7cd62b063064);

var $gt9Am = parcelRequire("gt9Am");

var $l2WwY = parcelRequire("l2WwY");

var $a6btX = parcelRequire("a6btX");

var $jMTnD = parcelRequire("jMTnD");

var $ekrKP = parcelRequire("ekrKP");

var $9I7ft = parcelRequire("9I7ft");
const $f3056587d1c9db6b$export$16e97e6603eadea = ({ PlacementComponent: PlacementComponent, placementId: placementId, eligibleMessages: eligibleMessages, errorFallback: errorFallback = null, onError: onError, returnOverride: returnOverride, disableInitialData: disableInitialData })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $ekrKP.ErrorBoundary), {
        fallback: errorFallback,
        onError: onError,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $a6btX.PlacementPreviewProvider), {
            eligibleMessages: eligibleMessages,
            returnOverride: returnOverride,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9I7ft.default), {
                PlacementComponent: PlacementComponent,
                placementId: placementId,
                disableInitialData: disableInitialData
            })
        })
    });
const $f3056587d1c9db6b$export$46db7cd62b063064 = ({ isEnabled: isEnabled, children: children })=>{
    const { searchParams: searchParams } = (0, $l2WwY.usePostOfficeRoute)();
    const previewId = searchParams?.get('contentfulPreviewId');
    const hasPreviewType = Boolean(searchParams?.get('contentfulPreviewId'));
    const eligibleMessage = [
        {
            messageInstanceId: 'messageInstanceId',
            messageTemplateId: 'marketing-screen-space-flag-contentful-usecase',
            messageCategory: 'Engagement',
            context: {
                id: previewId
            },
            createdAt: new Date().toString(),
            eventTime: new Date().toString(),
            triggerId: 'triggerId',
            messageCreationType: 'explicit'
        }
    ];
    if (isEnabled && hasPreviewType) return /*#__PURE__*/ (0, $gt9Am.jsx)($f3056587d1c9db6b$export$16e97e6603eadea, {
        placementId: "screen-space-flags",
        PlacementComponent: (0, $jMTnD.ScreenSpaceFlagsPlacementComponent),
        eligibleMessages: eligibleMessage
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});
parcelRegister("a6btX", function(module, exports) {

$parcel$export(module.exports, "PlacementPreviewProvider", () => $3f4f912545d6242d$export$52e362b70e115c68);

var $gt9Am = parcelRequire("gt9Am");

var $agxmR = parcelRequire("agxmR");

var $eJOHy = parcelRequire("eJOHy");
const $3f4f912545d6242d$export$e5ffd38dcf6e5c53 = `/gateway/api/post-office/api/v1/placements/`;
const $3f4f912545d6242d$export$85c4756977e87c75 = `/gateway/api/post-office/api/v1/placement-preview/`;
const $3f4f912545d6242d$export$52e362b70e115c68 = ({ returnOverride: returnOverride, eligibleMessages: eligibleMessages, children: children })=>{
    const fetch = (0, $eJOHy.useMemo)(()=>{
        if (returnOverride) return $3f4f912545d6242d$export$fb5156757134712c({
            returnOverride: returnOverride
        });
        return $3f4f912545d6242d$export$c05392ff95b4319d({
            eligibleMessages: eligibleMessages
        });
    }, [
        eligibleMessages,
        returnOverride
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $agxmR.PlacementFetchingProvider), {
        fetch: fetch,
        children: children
    });
};
const $3f4f912545d6242d$export$fb5156757134712c = ({ returnOverride: returnOverride })=>async ()=>{
        return new Response(JSON.stringify(returnOverride), {
            status: 200,
            statusText: 'ok'
        });
    };
const $3f4f912545d6242d$export$c05392ff95b4319d = ({ eligibleMessages: eligibleMessages })=>(url, options)=>{
        const finalUrl = url.replace($3f4f912545d6242d$export$e5ffd38dcf6e5c53, $3f4f912545d6242d$export$85c4756977e87c75);
        const payload = {
            originalMethod: options?.method || 'GET',
            originalBody: $3f4f912545d6242d$var$parseBody(options?.body),
            eligibleMessages: eligibleMessages
        };
        return globalThis.fetch(finalUrl, {
            ...options,
            method: 'POST',
            headers: {
                ...options?.headers || {}
            },
            body: $3f4f912545d6242d$var$stringifyPayload(payload)
        });
    };
const $3f4f912545d6242d$var$objectHasKeys = (input)=>!!Object.keys(input).length;
const $3f4f912545d6242d$var$parseBody = (body)=>{
    if (typeof body === 'undefined' || body === null) return undefined;
    try {
        const parsedBody = JSON.parse(body);
        if ($3f4f912545d6242d$var$objectHasKeys(parsedBody)) return parsedBody;
        throw new Error();
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};
const $3f4f912545d6242d$var$stringifyPayload = (payload)=>{
    try {
        return JSON.stringify(payload);
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};

});

parcelRegister("ekrKP", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $a6e8765e65df2e7f$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");
'use client';
const $a6e8765e65df2e7f$export$b16d9fb1a22de840 = (0, $eJOHy.createContext)(null);
const $a6e8765e65df2e7f$var$initialState = {
    didCatch: false,
    error: null
};
class $a6e8765e65df2e7f$export$e926676385687eaf extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $a6e8765e65df2e7f$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($a6e8765e65df2e7f$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $a6e8765e65df2e7f$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($a6e8765e65df2e7f$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $eJOHy.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $eJOHy.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $eJOHy.createElement)($a6e8765e65df2e7f$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $a6e8765e65df2e7f$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $a6e8765e65df2e7f$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $a6e8765e65df2e7f$export$c052f6604b7d51fe() {
    const context = (0, $eJOHy.useContext)($a6e8765e65df2e7f$export$b16d9fb1a22de840);
    $a6e8765e65df2e7f$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $eJOHy.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $eJOHy.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $a6e8765e65df2e7f$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $eJOHy.forwardRef)((props, ref)=>(0, $eJOHy.createElement)($a6e8765e65df2e7f$export$e926676385687eaf, errorBoundaryProps, (0, $eJOHy.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});


const $c335d71b7e366e9d$export$37d4bb5bc0e315db = 'killswitch_post_office_in_jira';


parcelRegister("6bLlX", function(module, exports) {

$parcel$export(module.exports, "PreviewPanelsProvider", () => $036914669073f5bb$export$65ae37e9c61321f9);
$parcel$export(module.exports, "useGlobalObjectPreviewPanels", () => $036914669073f5bb$export$70bcacea0b970dee);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $kfvK2 = parcelRequire("kfvK2");

var $7jTnu = parcelRequire("7jTnu");

var $kEUB1 = parcelRequire("kEUB1");

var $2i2kT = parcelRequire("2i2kT");
var $fkpSV = parcelRequire("fkpSV");

var $fmVXt = parcelRequire("fmVXt");
var $aSfxo = parcelRequire("aSfxo");
const $036914669073f5bb$var$SUPPORT_PANEL_TYPES_MILESTONE_ONE = [
    'identity-team',
    'confluence-page',
    'townsquare-goal',
    'townsquare-project'
];
const $036914669073f5bb$var$JiraPreviewPanelsContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $036914669073f5bb$export$eed91152c097781f = (0, $kfvK2.createRouterSelector)(({ route: route, location: location })=>route.supportsPreviewPanel ? `${route.name}:${location.pathname}` : null);
const $036914669073f5bb$var$JiraPreviewPanelsProvider = ({ children: children, subscribe: subscribe })=>{
    (0, $gRw8I.di)(window);
    const cloudId = (0, $kEUB1.useCloudId)();
    const { close: close } = (0, $aSfxo.usePreviewPanelsActions)();
    const enabledRoute = $036914669073f5bb$export$eed91152c097781f();
    const isIssueEmbed = enabledRoute?.split(':')[0] === 'issue-embed';
    let supportedObjects = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $7jTnu.fg)('jira_preview_panel_m1_2') && (0, $7jTnu.fg)('jira-glance-panel') ? undefined : $036914669073f5bb$var$SUPPORT_PANEL_TYPES_MILESTONE_ONE;
    // If the route is an issue embed, we can get the supported objects from the URL search params.
    // This allows us to support custom objects in the preview panel for the host application.
    if (isIssueEmbed && typeof window !== 'undefined') {
        const urlSearchParams = new URLSearchParams(window.location.search);
        supportedObjects = urlSearchParams.get('previewPanels')?.split(',')?.map((0, $2i2kT.asGlobalObjectType));
    }
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $fkpSV.useGlobalObjectPreviewPanels)('jira', cloudId, {
        supportedObjects: supportedObjects,
        enabled: enabledRoute !== null
    });
    (0, $fkpSV.usePreviewPanelIFrameCommunication)(openPreviewPanel);
    (0, $eJOHy.useEffect)(()=>()=>{
            // automatically close the preview panel when the route changes
            close();
        }, [
        enabledRoute,
        close
    ]);
    const value = (0, $eJOHy.useMemo)(()=>({
            subscribe: subscribe,
            openPreviewPanel: openPreviewPanel,
            isPreviewPanelAvailable: isPreviewPanelAvailable
        }), [
        subscribe,
        openPreviewPanel,
        isPreviewPanelAvailable
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($036914669073f5bb$var$JiraPreviewPanelsContext.Provider, {
        value: value
    }, children);
};
const $036914669073f5bb$export$65ae37e9c61321f9 = ({ children: children })=>{
    const subscribers = (0, $eJOHy.useRef)(new Set());
    const notifySubscribers = (0, $eJOHy.useCallback)((event)=>{
        subscribers.current.forEach((callback)=>callback(event));
    }, []);
    const handlePreviewPanelOpen = (0, $eJOHy.useCallback)((panel)=>notifySubscribers({
            action: 'open',
            panel: panel
        }), [
        notifySubscribers
    ]);
    const handlePreviewPanelClose = (0, $eJOHy.useCallback)((panel)=>notifySubscribers({
            action: 'close',
            panel: panel
        }), [
        notifySubscribers
    ]);
    const subscribe = (0, $eJOHy.useCallback)((callback)=>{
        subscribers.current.add(callback);
        return ()=>{
            subscribers.current.delete(callback);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fmVXt.PreviewPanelsProvider), {
        onPreviewPanelOpen: handlePreviewPanelOpen,
        onPreviewPanelClose: handlePreviewPanelClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($036914669073f5bb$var$JiraPreviewPanelsProvider, {
        subscribe: subscribe
    }, children));
};
const $036914669073f5bb$export$70bcacea0b970dee = ()=>{
    const context = (0, $eJOHy.useContext)($036914669073f5bb$var$JiraPreviewPanelsContext);
    if (!context) throw new Error('useGlobalObjectPreviewPanels must be used within a PreviewPanelsProvider');
    const { openPreviewPanel: openPreviewPanel, isPreviewPanelAvailable: isPreviewPanelAvailable } = context;
    return {
        openPreviewPanel: openPreviewPanel,
        isPreviewPanelAvailable: isPreviewPanelAvailable
    };
};
const $036914669073f5bb$export$5e98dc0fae8a152c = (callback)=>{
    const { subscribe: subscribe } = (0, $eJOHy.useContext)($036914669073f5bb$var$JiraPreviewPanelsContext) ?? {};
    (0, $eJOHy.useEffect)(()=>{
        if (!subscribe) return;
        const unsubscribe = subscribe(callback);
        return ()=>unsubscribe();
    }, [
        subscribe,
        callback
    ]);
};

});
parcelRegister("2i2kT", function(module, exports) {

$parcel$export(module.exports, "isInIframe", () => $55ff57a232bfc261$export$9f140ed41af5108c);
$parcel$export(module.exports, "asGlobalObjectType", () => $55ff57a232bfc261$export$5b60458e6ab1ba54);
$parcel$export(module.exports, "buildIssueViewEmbedUrl", () => $55ff57a232bfc261$export$4e691bca3211cc2f);

var $1bpEm = parcelRequire("1bpEm");
const $55ff57a232bfc261$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $55ff57a232bfc261$export$5b60458e6ab1ba54 = (value)=>{
    if (!(0, $1bpEm.ALL_SUPPORTED_OBJECTS).includes(value)) throw new Error(`Unsupported global object type: ${value}`);
    return value;
};
const $55ff57a232bfc261$export$4e691bca3211cc2f = (url, supportedObjects)=>{
    try {
        const urlObj = new URL(url);
        // Ensure there's no trailing slash before appending '/embed'
        urlObj.pathname = urlObj.pathname.replace(/\/$/, '') + '/embed';
        // Add previewPanels to existing search params
        urlObj.searchParams.set('previewPanels', supportedObjects.join(','));
        // Return the full URL as a string
        return urlObj.toString();
    } catch  {
        // Fallback for invalid URLs
        return `${url}/embed?previewPanels=${encodeURIComponent(supportedObjects.join(','))}`;
    }
};

});
parcelRegister("1bpEm", function(module, exports) {

$parcel$export(module.exports, "ALL_SUPPORTED_OBJECTS", () => $3e133e77fec0e7e5$export$cec6f7cb9c99f251);
const $3e133e77fec0e7e5$export$cec6f7cb9c99f251 = [
    'jira-issue',
    'confluence-page',
    'identity-team',
    'townsquare-goal',
    'townsquare-project'
];

});


parcelRegister("fkpSV", function(module, exports) {

$parcel$export(module.exports, "useGlobalObjectPreviewPanels", () => $5f14729e7441ba3c$export$70bcacea0b970dee);
$parcel$export(module.exports, "usePreviewPanelIFrameCommunication", () => $5f14729e7441ba3c$export$3cfc2fe60a8f0a1c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $j4oe4 = parcelRequire("j4oe4");

var $4BXjD = parcelRequire("4BXjD");

var $46Ypp = parcelRequire("46Ypp");

var $33MRY = parcelRequire("33MRY");

var $g6zOZ = parcelRequire("g6zOZ");

var $11wRG = parcelRequire("11wRG");

var $aRqXC = parcelRequire("aRqXC");

var $gtr2v = parcelRequire("gtr2v");

var $jL1Iu = parcelRequire("jL1Iu");

var $dvckl = parcelRequire("dvckl");

var $aSfxo = parcelRequire("aSfxo");

var $jSP0D = parcelRequire("jSP0D");

var $h2Da7 = parcelRequire("h2Da7");

var $4to9f = parcelRequire("4to9f");

var $1bpEm = parcelRequire("1bpEm");

var $b2aI6 = parcelRequire("b2aI6");

var $k9ymy = parcelRequire("k9ymy");

var $4OWGC = parcelRequire("4OWGC");

var $2i2kT = parcelRequire("2i2kT");
const $5f14729e7441ba3c$var$getGlobalObjectType = (ari)=>{
    const parsedAri = (0, $gtr2v.AnyAri).parse(ari);
    return `${parsedAri.resourceOwner}-${parsedAri.resourceType}`;
};
const $5f14729e7441ba3c$export$70bcacea0b970dee = (product, cloudId, options)=>{
    const { enabled: enabled = true, supportedObjects: supportedObjects = (0, $1bpEm.ALL_SUPPORTED_OBJECTS) } = options ?? {};
    const environmentProvider = (0, $h2Da7.useRelayEnvironmentProvider)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { open: open } = (0, $aSfxo.usePreviewPanelsActions)();
    const isPreviewPanelAvailable = (0, $eJOHy.useCallback)(({ ari: ari })=>enabled && supportedObjects.includes($5f14729e7441ba3c$var$getGlobalObjectType(ari)), [
        enabled,
        supportedObjects
    ]);
    const openPreviewPanel = (0, $eJOHy.useCallback)(({ url: url, ari: ari, name: name })=>{
        const globalObjectType = $5f14729e7441ba3c$var$getGlobalObjectType(ari);
        if (!isPreviewPanelAvailable({
            ari: ari
        })) throw new Error(`Preview panel for ${globalObjectType} with ARI ${ari} is not supported.`);
        // Check if we're in an iframe (not the top-most frame)
        if ((0, $2i2kT.isInIframe)()) {
            // Post message to parent frame to open the panel
            window.parent.postMessage({
                type: 'OPEN_PREVIEW_PANEL',
                payload: {
                    url: url,
                    ari: ari,
                    name: name
                }
            }, '*');
            return;
        }
        let panelContent;
        switch(globalObjectType){
            case 'jira-issue':
                panelContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OWGC.IFramePreviewPanel), {
                    name: formatMessage((0, $b2aI6.default).workItem),
                    url: url,
                    iframeUrl: (0, $2i2kT.buildIssueViewEmbedUrl)(url, supportedObjects),
                    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aRqXC))), {
                        label: ""
                    })
                });
                break;
            case 'identity-team':
                const teamEntryPointReference = (0, $j4oe4.loadEntryPoint)(environmentProvider, (0, $4to9f.default), {
                    cloudId: cloudId
                });
                panelContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9ymy.EntryPointPreviewPanel), {
                    entryPoint: (0, $4to9f.default),
                    preloadedEntryPointReference: teamEntryPointReference,
                    runtimeProps: {
                        url: url,
                        parentProduct: product,
                        ari: ari,
                        cloudId: cloudId,
                        openPreviewPanel: openPreviewPanel
                    },
                    globalObject: {
                        name: formatMessage((0, $b2aI6.default).team),
                        url: url,
                        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6zOZ))), {
                            label: ""
                        })
                    }
                });
                break;
            case 'townsquare-goal':
                const entryPointReference = (0, $j4oe4.loadEntryPoint)(environmentProvider, (0, $dvckl.default), {
                    ari: ari
                });
                panelContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9ymy.EntryPointPreviewPanel), {
                    entryPoint: (0, $dvckl.default),
                    preloadedEntryPointReference: entryPointReference,
                    runtimeProps: {
                        url: url
                    },
                    globalObject: {
                        name: formatMessage((0, $b2aI6.default).goal),
                        url: url,
                        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4BXjD))), {
                            label: ""
                        })
                    }
                });
                break;
            case 'townsquare-project':
                {
                    const entryPointReference = (0, $j4oe4.loadEntryPoint)(environmentProvider, (0, $jSP0D.default), {
                        ari: ari
                    });
                    panelContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9ymy.EntryPointPreviewPanel), {
                        entryPoint: (0, $jSP0D.default),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url
                        },
                        globalObject: {
                            name: formatMessage((0, $b2aI6.default).project),
                            url: url,
                            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($33MRY))), {
                                label: ""
                            })
                        }
                    });
                    break;
                }
            case 'confluence-page':
                {
                    const entryPointReference = (0, $j4oe4.loadEntryPoint)(environmentProvider, (0, $jL1Iu.confluencePagePreviewPanelEntryPoint), {});
                    panelContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9ymy.EntryPointPreviewPanel), {
                        entryPoint: (0, $jL1Iu.confluencePagePreviewPanelEntryPoint),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product
                        },
                        globalObject: {
                            name: formatMessage((0, $b2aI6.default).page),
                            url: url,
                            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($46Ypp))), {
                                label: ""
                            })
                        }
                    });
                    break;
                }
            case 'confluence-whiteboard':
                {
                    const entryPointReference = (0, $j4oe4.loadEntryPoint)(environmentProvider, (0, $jL1Iu.confluencePagePreviewPanelEntryPoint), {});
                    panelContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9ymy.EntryPointPreviewPanel), {
                        entryPoint: (0, $jL1Iu.confluencePagePreviewPanelEntryPoint),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product
                        },
                        globalObject: {
                            name: formatMessage((0, $b2aI6.default).whiteboard),
                            url: url,
                            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($11wRG))), {
                                label: ""
                            })
                        }
                    });
                    break;
                }
            default:
                throw new Error(`Unsupported global object type: ${globalObjectType}`);
        }
        open({
            panel: {
                id: ari,
                type: globalObjectType,
                content: ()=>panelContent
            }
        });
    }, [
        isPreviewPanelAvailable,
        open,
        formatMessage,
        supportedObjects,
        environmentProvider,
        product,
        cloudId
    ]);
    return {
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
};
const $5f14729e7441ba3c$export$3cfc2fe60a8f0a1c = (openPreviewPanel)=>{
    // Listen for messages from iframes to open panels
    (0, $eJOHy.useEffect)(()=>{
        const handleMessage = (event)=>{
            // Only handle messages with the expected type
            if (event.data?.type !== 'OPEN_PREVIEW_PANEL') return;
            const { payload: payload } = event.data;
            if (payload?.url && payload?.ari && payload?.name) openPreviewPanel({
                url: payload.url,
                ari: payload.ari,
                name: payload.name
            });
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        openPreviewPanel
    ]);
};

});
parcelRegister("11wRG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b17a1d467ee36b565800b9226ad47576>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0bef60b7ea564b69$var$_react = $0bef60b7ea564b69$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0bef60b7ea564b69$var$_baseNew = $0bef60b7ea564b69$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $0bef60b7ea564b69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Whiteboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for whiteboards in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0bef60b7ea564b69$var$WhiteboardIcon = (props)=>/*#__PURE__*/ $0bef60b7ea564b69$var$_react.default.createElement($0bef60b7ea564b69$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.162 2.177c-.714.282-1.28.817-1.449 1.338l-1.426-.463C6.637 1.97 7.633 1.168 8.61.782c.943-.372 2.248-.49 3.09.375.346.356.536.777.548 1.236.011.437-.14.827-.323 1.144-.228.394-.557.761-.876 1.074 1.466-.136 2.717.239 3.421 1.134.827 1.05.644 2.464-.256 3.697l-1.212-.884c.66-.905.556-1.547.29-1.885-.305-.387-1.095-.757-2.524-.512-.521.09-.935.138-1.236.13a1.4 1.4 0 0 1-.537-.11.9.9 0 0 1-.345-.278.85.85 0 0 1-.164-.495 1.02 1.02 0 0 1 .197-.586c.077-.112.171-.215.256-.3.14-.143.323-.306.499-.464l.101-.09c.453-.407.87-.806 1.087-1.181.102-.178.124-.292.123-.354-.002-.04-.01-.113-.124-.23-.2-.204-.716-.321-1.464-.026M3.75 5.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M0 7.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m10.25.75a.75.75 0 0 1 .643.364l3 5A.75.75 0 0 1 13.25 15h-6a.75.75 0 0 1-.643-1.136l3-5a.75.75 0 0 1 .643-.364m-1.675 5h3.35l-1.675-2.792z" clip-rule="evenodd"/>`
    }, props));
$0bef60b7ea564b69$var$WhiteboardIcon.displayName = 'WhiteboardIcon';
var $0bef60b7ea564b69$var$_default = module.exports.default = $0bef60b7ea564b69$var$WhiteboardIcon;

});

parcelRegister("aRqXC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16b1a013266ea85d8875a6b5e1d2412a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e83c474a208cd3c$var$_react = $7e83c474a208cd3c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7e83c474a208cd3c$var$_baseNew = $7e83c474a208cd3c$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $7e83c474a208cd3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e83c474a208cd3c$var$WorkItemIcon = (props)=>/*#__PURE__*/ $7e83c474a208cd3c$var$_react.default.createElement($7e83c474a208cd3c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$7e83c474a208cd3c$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $7e83c474a208cd3c$var$_default = module.exports.default = $7e83c474a208cd3c$var$WorkItemIcon;

});

parcelRegister("jL1Iu", function(module, exports) {

$parcel$export(module.exports, "confluencePagePreviewPanelEntryPoint", () => $cfafe725472b203e$export$a50c261b4b52f403);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $cfafe725472b203e$export$a50c261b4b52f403 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("iEiF4")), {
        moduleId: "d73b44f1",
        priority: "interaction",
        moduleId: 'confluence-preview-panel-entrypoint'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iEiF4", function(module, exports) {

let $d93a7037bbb25d52$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d93a7037bbb25d52$var$load("3spVg").then(()=>parcelRequire('1K8xm'));

});


parcelRegister("dvckl", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b3077139381679f$export$2e2bcd8739ae039);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

var $7iQEK = parcelRequire("7iQEK");
const $8b3077139381679f$var$fetchPolicy = 'network-only';

const $8b3077139381679f$var$atlasGoalEntryPoint = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("njN9s")).then((mod)=>mod.GoalPanel), {
        moduleId: "ba76ccc1",
        moduleName: "GoalPanel",
        priority: "interaction",
        moduleId: 'atlas-goal-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>({
            queries: {
                queryReference: {
                    parameters: $7iQEK.default,
                    variables: {
                        ari: ari
                    },
                    options: {
                        fetchPolicy: $8b3077139381679f$var$fetchPolicy
                    }
                }
            }
        })
});
var $8b3077139381679f$export$2e2bcd8739ae039 = $8b3077139381679f$var$atlasGoalEntryPoint;

});
parcelRegister("7iQEK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f82f9f9392a5b1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8efa5df8062babdfaca82fa6954405b3>>
 * @relayHash 52c2e9c282fa494e9cb9ba77bca44621
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 08d32f5d1de3dd5b4653e029b42a96d5d742c892f800c32eadf8aa8f8d43b7fe
const $f6f82f9f9392a5b1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "ari",
            "variableName": "ari"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "url"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v6 /*: any*/ ,
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = {
        "kind": "ScalarField",
        "name": "value"
    }, v10 = [
        v9 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "score"
        }
    ], v11 = {
        "concreteType": "TownsquareGoalTypeIcon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            v8 /*: any*/ 
        ]
    }, v12 = [
        v9 /*: any*/ 
    ], v13 = {
        "kind": "ScalarField",
        "name": "percentage"
    }, v14 = {
        "kind": "ScalarField",
        "name": "type"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isArchived"
    }, v16 = {
        "concreteType": "TownsquareStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v17 = {
        "concreteType": "TownsquareGoalType",
        "kind": "LinkedField",
        "name": "goalType",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v1 /*: any*/ 
        ]
    }, v18 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "description"
    }, v20 = {
        "kind": "ScalarField",
        "name": "creationDate"
    }, v21 = {
        "concreteType": "TownsquareCommentConnection",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareCommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareComment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                    v6 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v3 /*: any*/ ,
                                    v1 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "commentText"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v23 = [
        {
            "kind": "ScalarField",
            "name": "label"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "TownsquareQueryApi",
                    "kind": "LinkedField",
                    "name": "townsquare",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalPanelTitleField"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalStatus"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalType"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalOwner"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalMetrics"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalTargetDate"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ParentGoal"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SubGoals"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalTags"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalFollowers"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalStartDate"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalPanelTabs"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalActions"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "GoalTeams"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v7 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "TownsquareQueryApi",
                    "kind": "LinkedField",
                    "name": "townsquare",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalIcon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "appearance"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": v10 /*: any*/ 
                                },
                                {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "goalType",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v12 /*: any*/ ,
                                                    "type": "TownsquareGoalTypeCustomName"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "defaultValue"
                                                        }
                                                    ],
                                                    "type": "TownsquareLocalizationField"
                                                }
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "owner",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "concreteType": "TownsquareGoalProgress",
                                    "kind": "LinkedField",
                                    "name": "progress",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareGoalConnection",
                                    "kind": "LinkedField",
                                    "name": "subGoals",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoalEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareGoal",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalProgress",
                                                            "kind": "LinkedField",
                                                            "name": "progress",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        v1 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v18 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "concreteType": "MetricTargetConnection",
                                            "kind": "LinkedField",
                                            "name": "metricTargets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "MetricTargetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "MetricTarget",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "concreteType": "Metric",
                                                                    "kind": "LinkedField",
                                                                    "name": "metric",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "uuid"
                                                                        },
                                                                        v2 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "subType"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "archived"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "externalEntityId"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MetricValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "snapshotValue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "startValue"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "targetValue"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareTargetDate",
                                    "kind": "LinkedField",
                                    "name": "targetDate",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTargetDateRange",
                                            "kind": "LinkedField",
                                            "name": "dateRange",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "start"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "end"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "parentGoal",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v2 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v1 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareTagConnection",
                                    "kind": "LinkedField",
                                    "name": "tags",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTagEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareTag",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "usageCount"
                                                        },
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                }
                                            ]
                                        },
                                        v18 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareUserConnection",
                                    "kind": "LinkedField",
                                    "name": "watchers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareUserEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v1 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "startDate"
                                },
                                v20 /*: any*/ ,
                                v19 /*: any*/ ,
                                v21 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalUpdateConnection",
                                    "kind": "LinkedField",
                                    "name": "updates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoalUpdateEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareGoalUpdate",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "ari"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "missedUpdate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "summary"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "creator",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                v1 /*: any*/ ,
                                                                v22 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareTargetDate",
                                                            "kind": "LinkedField",
                                                            "name": "newDueDate",
                                                            "plural": false,
                                                            "selections": v23 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "TownsquareGoalState",
                                                            "kind": "LinkedField",
                                                            "name": "newState",
                                                            "plural": false,
                                                            "selections": v10 /*: any*/ 
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "lastEditedBy",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v22 /*: any*/ ,
                                                                v2 /*: any*/ ,
                                                                v1 /*: any*/ 
                                                            ]
                                                        },
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "editDate"
                                                        },
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareGoalState",
                                                            "kind": "LinkedField",
                                                            "name": "oldState",
                                                            "plural": false,
                                                            "selections": v10 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "TownsquareTargetDate",
                                                            "kind": "LinkedField",
                                                            "name": "oldDueDate",
                                                            "plural": false,
                                                            "selections": v23 /*: any*/ 
                                                        },
                                                        v21 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v15 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalTeamConnection",
                                    "kind": "LinkedField",
                                    "name": "teams",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoalTeamEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TeamV2",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "displayName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "smallAvatarImageUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isVerified"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "profileUrl"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v18 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "08d32f5d1de3dd5b4653e029b42a96d5d742c892f800c32eadf8aa8f8d43b7fe",
            "metadata": {},
            "name": "GoalPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f6f82f9f9392a5b1$var$node.hash = "8a5bbc584da619c003c6a20b7be6c1a7";
var $f6f82f9f9392a5b1$export$2e2bcd8739ae039 = $f6f82f9f9392a5b1$var$node;

});

parcelRegister("njN9s", function(module, exports) {

let $04618054549c56d7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $04618054549c56d7$var$load("1VRB2"),
    $04618054549c56d7$var$load("bABhq"),
    $04618054549c56d7$var$load("eDzss"),
    $04618054549c56d7$var$load("7vqGd"),
    $04618054549c56d7$var$load("1Y4bq"),
    $04618054549c56d7$var$load("2rB2L")
]).then(()=>parcelRequire('b2xY2'));

});


parcelRegister("aSfxo", function(module, exports) {

$parcel$export(module.exports, "usePreviewPanelsActions", () => $514ca4bf1cee67ed$export$5f5debba1692bf40);

var $fmVXt = parcelRequire("fmVXt");
const $514ca4bf1cee67ed$var$noop = (props)=>{};
const $514ca4bf1cee67ed$export$5f5debba1692bf40 = ()=>{
    const context = (0, $fmVXt.usePreviewPanelsContext)();
    if (!context) return {
        open: $514ca4bf1cee67ed$var$noop,
        close: $514ca4bf1cee67ed$var$noop,
        setPanelWidth: $514ca4bf1cee67ed$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};

});

parcelRegister("jSP0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e09f2e231855213$export$2e2bcd8739ae039);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

var $9It3z = parcelRequire("9It3z");
const $0e09f2e231855213$var$fetchPolicy = 'network-only';

const $0e09f2e231855213$var$atlasProjectEntryPoint = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("dILW0")).then((mod)=>mod.ProjectPanel), {
        moduleId: "db5db9ea",
        moduleName: "ProjectPanel",
        priority: "interaction",
        moduleId: 'atlas-project-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>({
            queries: {
                queryReference: {
                    parameters: $9It3z.default,
                    variables: {
                        ari: ari
                    },
                    options: {
                        fetchPolicy: $0e09f2e231855213$var$fetchPolicy
                    }
                }
            }
        })
});
var $0e09f2e231855213$export$2e2bcd8739ae039 = $0e09f2e231855213$var$atlasProjectEntryPoint;

});
parcelRegister("9It3z", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aec0ff1275f283e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7115b63890639cd879854e7d724c6542>>
 * @relayHash c790bf1cb0343b5d2375105968529a4d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6568d8f59b726ae044628fd250f2a2857c6167bc3c36ffde762892747314db78
const $6aec0ff1275f283e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "ari",
            "variableName": "ari"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "url"
    }, v7 = {
        "kind": "ScalarField",
        "name": "canEditMembers"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "dark"
    }, v10 = {
        "kind": "ScalarField",
        "name": "light"
    }, v11 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "label"
    }, v13 = {
        "kind": "ScalarField",
        "name": "value"
    }, v14 = [
        {
            "concreteType": "TownsquareLinkEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "TownsquareLink",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v6 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        v11 /*: any*/ 
    ], v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "creationDate"
    }, v17 = [
        v8 /*: any*/ ,
        v4 /*: any*/ ,
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ 
    ], v18 = [
        v13 /*: any*/ 
    ], v19 = {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v1 /*: any*/ 
        ]
    }, v20 = {
        "concreteType": "TownsquareCommentConnection",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareCommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareComment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v19 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "commentText"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v21 = [
        v12 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "TownsquareQueryApi",
                        "kind": "LinkedField",
                        "name": "townsquare",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "TownsquareProject",
                                    "kind": "LinkedField",
                                    "name": "project",
                                    "plural": false,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectPanelHeader"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectTags"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectTargetDate"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectStatus"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectOwner"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectLinks"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectWorkTracked"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectStartDate"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "RelatedProjects"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectContributesTo"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectContributors"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectFollowers"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectActionsContent"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectPanelTabs"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "townsquare.project"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "townsquare"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "TownsquareQueryApi",
                    "kind": "LinkedField",
                    "name": "townsquare",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "TownsquareProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareWorkspace",
                                    "kind": "LinkedField",
                                    "name": "workspace",
                                    "plural": false,
                                    "selections": [
                                        v1 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareIconURIs",
                                    "kind": "LinkedField",
                                    "name": "iconUrl",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareThemeURIs",
                                            "kind": "LinkedField",
                                            "name": "roundedSquare",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareTagConnection",
                                    "kind": "LinkedField",
                                    "name": "tags",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTagEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareTag",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "usageCount"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareTargetDate",
                                    "kind": "LinkedField",
                                    "name": "dueDate",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTargetDateRange",
                                            "kind": "LinkedField",
                                            "name": "dateRange",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "start"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "end"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareProjectState",
                                    "kind": "LinkedField",
                                    "name": "state",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "owner",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v1 /*: any*/ ,
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": v14 /*: any*/ 
                                },
                                {
                                    "alias": "workTrackingLinks",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "WORK_TRACKING"
                                        }
                                    ],
                                    "concreteType": "TownsquareLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": v14 /*: any*/ ,
                                    "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
                                },
                                {
                                    "concreteType": "TownsquareFusionDetails",
                                    "kind": "LinkedField",
                                    "name": "fusion",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "synced"
                                        },
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "startDate"
                                },
                                v16 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareContributorConnection",
                                    "kind": "LinkedField",
                                    "name": "contributors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareContributorEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareContributor",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareTeamContributor",
                                                            "kind": "LinkedField",
                                                            "name": "teamContributor",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "contributingMembers",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareUserEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v17 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "TeamV2",
                                                                    "kind": "LinkedField",
                                                                    "name": "team",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "smallAvatarImageUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "profileUrl"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "userContributor",
                                                            "plural": false,
                                                            "selections": v17 /*: any*/ 
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ]
                                },
                                v15 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareProjectDependencyConnection",
                                    "kind": "LinkedField",
                                    "name": "dependencies",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProjectDependencyEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareProjectDependency",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "linkType"
                                                        },
                                                        {
                                                            "concreteType": "TownsquareProject",
                                                            "kind": "LinkedField",
                                                            "name": "outgoingProject",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v2 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "concreteType": "TownsquareIconURIs",
                                                                    "kind": "LinkedField",
                                                                    "name": "iconUrl",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareThemeURIs",
                                                                            "kind": "LinkedField",
                                                                            "name": "square",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                v9 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareGoalConnection",
                                    "kind": "LinkedField",
                                    "name": "goals",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoalEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareGoal",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": v18 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "TownsquareGoalType",
                                                            "kind": "LinkedField",
                                                            "name": "goalType",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalTypeIcon",
                                                                    "kind": "LinkedField",
                                                                    "name": "icon",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                },
                                                                v1 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareUserConnection",
                                    "kind": "LinkedField",
                                    "name": "watchers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareUserEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v1 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isArchived"
                                },
                                {
                                    "concreteType": "TownsquareProjectDescription",
                                    "kind": "LinkedField",
                                    "name": "description",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "what"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "why"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "measurement"
                                        }
                                    ]
                                },
                                v20 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareProjectUpdateConnection",
                                    "kind": "LinkedField",
                                    "name": "updates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProjectUpdateEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareProjectUpdate",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "ari"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "missedUpdate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "summary"
                                                        },
                                                        v16 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareTargetDate",
                                                            "kind": "LinkedField",
                                                            "name": "newDueDate",
                                                            "plural": false,
                                                            "selections": v21 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "TownsquareProjectState",
                                                            "kind": "LinkedField",
                                                            "name": "newState",
                                                            "plural": false,
                                                            "selections": v18 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "TownsquareProjectState",
                                                            "kind": "LinkedField",
                                                            "name": "oldState",
                                                            "plural": false,
                                                            "selections": v18 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "TownsquareTargetDate",
                                                            "kind": "LinkedField",
                                                            "name": "oldDueDate",
                                                            "plural": false,
                                                            "selections": v21 /*: any*/ 
                                                        },
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6568d8f59b726ae044628fd250f2a2857c6167bc3c36ffde762892747314db78",
            "metadata": {},
            "name": "ProjectPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6aec0ff1275f283e$var$node.hash = "6a0e741dc1c90dba980eec96ed395bce";
var $6aec0ff1275f283e$export$2e2bcd8739ae039 = $6aec0ff1275f283e$var$node;

});

parcelRegister("dILW0", function(module, exports) {

let $9fd49134e26a6aa1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $9fd49134e26a6aa1$var$load("1VRB2"),
    $9fd49134e26a6aa1$var$load("bABhq"),
    $9fd49134e26a6aa1$var$load("eDzss"),
    $9fd49134e26a6aa1$var$load("7vqGd"),
    $9fd49134e26a6aa1$var$load("1Y4bq"),
    $9fd49134e26a6aa1$var$load("OUb0O")
]).then(()=>parcelRequire('9f68Y'));

});


parcelRegister("4to9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $2799be9d5056e685$export$2e2bcd8739ae039);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

var $SPRTq = parcelRequire("SPRTq");
const $2799be9d5056e685$var$fetchPolicy = 'network-only';

const $2799be9d5056e685$var$teamPreviewPanelEntryPoint = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("belOW")).then((mod)=>mod.TeamPreviewPanel), {
        moduleId: "bc41c2d8",
        priority: "interaction",
        moduleId: 'team-preview-panel-entrypoint'
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryReference: {
                    parameters: $SPRTq.default,
                    variables: {
                        cloudId: cloudId
                    },
                    options: {
                        fetchPolicy: $2799be9d5056e685$var$fetchPolicy
                    }
                }
            }
        })
});
var $2799be9d5056e685$export$2e2bcd8739ae039 = $2799be9d5056e685$var$teamPreviewPanelEntryPoint;

});
parcelRegister("SPRTq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e470b6a075479e14$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<be9d76f63db93553bbb649b37a6b4c41>>
 * @relayHash 91adf951953bfe64ddb250042a4a0511
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527
const $e470b6a075479e14$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "args": [
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "cloudIds.0",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
            }
        ],
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "orgId"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "teamPreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                v2 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "teamPreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                v2 /*: any*/ 
            ]
        },
        "params": {
            "id": "1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527",
            "metadata": {},
            "name": "teamPreviewPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e470b6a075479e14$var$node.hash = "6b8a5c1e76dd69e5d8daea6919628199";
var $e470b6a075479e14$export$2e2bcd8739ae039 = $e470b6a075479e14$var$node;

});

parcelRegister("belOW", function(module, exports) {

let $82d1eda395e096a8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $82d1eda395e096a8$var$load("1VRB2"),
    $82d1eda395e096a8$var$load("bABhq"),
    $82d1eda395e096a8$var$load("fMOSo"),
    $82d1eda395e096a8$var$load("jhiae"),
    $82d1eda395e096a8$var$load("eDzss"),
    $82d1eda395e096a8$var$load("7vqGd"),
    $82d1eda395e096a8$var$load("1Y4bq"),
    $82d1eda395e096a8$var$load("atu8H")
]).then(()=>parcelRequire('4win8'));

});


parcelRegister("b2aI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4600c809cd2ee49$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d4600c809cd2ee49$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    workItem: {
        id: 'navigation.preview-panel-global-objects.workItem',
        defaultMessage: 'Work item',
        description: 'Title for the work item preview panel'
    },
    project: {
        id: 'navigation.preview-panel-global-objects.project',
        defaultMessage: 'Project',
        description: 'Title for the project preview panel'
    },
    goal: {
        id: 'navigation.preview-panel-global-objects.goal',
        defaultMessage: 'Goal',
        description: 'Title for the goal preview panel'
    },
    team: {
        id: 'navigation.preview-panel-global-objects.team',
        defaultMessage: 'Team',
        description: 'Title for the team preview panel'
    },
    page: {
        id: 'navigation.preview-panel-global-objects.page',
        defaultMessage: 'Confluence Page',
        description: 'Title for the Confluence page preview panel'
    },
    whiteboard: {
        id: 'navigation.preview-panel-global-objects.whiteboard',
        defaultMessage: 'Confluence Whiteboard',
        description: 'Title for the Confluence whiteboard preview panel'
    }
});

});

parcelRegister("k9ymy", function(module, exports) {

$parcel$export(module.exports, "EntryPointPreviewPanel", () => $470109817750f0b2$export$2ace74dd551e05c1);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4moNR = parcelRequire("4moNR");

var $bkOM5 = parcelRequire("bkOM5");

var $7kB7b = parcelRequire("7kB7b");
const $470109817750f0b2$var$emptyEntryPointProps = {};
const $470109817750f0b2$export$2ace74dd551e05c1 = ({ entryPoint: entryPoint, preloadedEntryPointReference: preloadedEntryPointReference, runtimeProps: runtimeProps = $470109817750f0b2$var$emptyEntryPointProps, globalObject: globalObject })=>{
    const id = (0, $eJOHy.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4moNR.InternalEntryPointContainer), {
        id: id,
        entryPointReference: preloadedEntryPointReference,
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7kB7b.FallbackPreviewPanel), {
            ...globalObject
        }),
        errorFallback: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $bkOM5.ErrorFallbackPreviewPanel), {
                ...globalObject
            }),
        runtimeProps: runtimeProps
    });
};

});
parcelRegister("bkOM5", function(module, exports) {

$parcel$export(module.exports, "ErrorFallbackPreviewPanel", () => $f0a16ea2eb1921ec$export$9f31ac9d4b42e91c);
/* ErrorFallbackPreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6vd3O = parcelRequire("6vd3O");

var $51Gwp = parcelRequire("51Gwp");

var $gcesi = parcelRequire("gcesi");
var $j4VPn = parcelRequire("j4VPn");
var $807KM = parcelRequire("807KM");
var $iNZsx = parcelRequire("iNZsx");

var $aSfxo = parcelRequire("aSfxo");

var $7SEcE = parcelRequire("7SEcE");

var $hkU4g = parcelRequire("hkU4g");
const $f0a16ea2eb1921ec$var$styles = {
    body: "_bozgxncg _y4tixncg _1q511ejb _85i51ejb"
};
const $f0a16ea2eb1921ec$export$9f31ac9d4b42e91c = /*#__PURE__*/ (0, $eJOHy.memo)(({ url: url, name: name, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { close: close } = (0, $aSfxo.usePreviewPanelsActions)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gcesi.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $807KM.PreviewPanelHeader), {
                onClose: close,
                url: url,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iNZsx.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j4VPn.PreviewPanelBody), {
                styles: $f0a16ea2eb1921ec$var$styles.body,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6vd3O.default), {
                    header: formatMessage((0, $hkU4g.messages).errorHeader),
                    description: formatMessage((0, $hkU4g.messages).errorDescription, {
                        link: (chunks)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $51Gwp.default), {
                                href: "https://status.atlassian.com/",
                                children: chunks
                            })
                    }),
                    headingLevel: 2,
                    imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7SEcE)))
                })
            })
        ]
    });
});

});
parcelRegister("gcesi", function(module, exports) {

$parcel$export(module.exports, "PreviewPanel", () => $4d9b1bddfabd034f$export$9520f072db304aa0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aRh7I = parcelRequire("aRh7I");
const $4d9b1bddfabd034f$var$styles = {
    wrapper: "_1h6dmuej _ngwonqa1 _tml8e4h9 _4t3i1osq _bfhkvuon"
};
const $4d9b1bddfabd034f$export$9520f072db304aa0 = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aRh7I.default), {
        xcss: $4d9b1bddfabd034f$var$styles.wrapper,
        testId: testId,
        children: children
    });
};

});

parcelRegister("j4VPn", function(module, exports) {

$parcel$export(module.exports, "PreviewPanelBody", () => $f1c3c380da67a9d2$export$cda5e69749e7aeee);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $i7XOj = parcelRequire("i7XOj");

var $dhRXV = parcelRequire("dhRXV");
const $f1c3c380da67a9d2$export$cda5e69749e7aeee = ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, styles: styles })=>{
    (0, $eJOHy.useEffect)(()=>{
        if (analyticsClient) analyticsClient.sendTrackEvent({
            action: 'viewed',
            actionSubject: 'preview-panel',
            actionSubjectId: 'preview-panel-view',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
    }, [
        analyticsClient,
        parentProduct,
        panelType
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
        xcss: (0, $i7XOj.cx)(!!styles && styles),
        children: children
    });
};

});

parcelRegister("807KM", function(module, exports) {

$parcel$export(module.exports, "PreviewPanelHeader", () => $d964a35fc883c621$export$426d4171de44bac0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $4BzUI = parcelRequire("4BzUI");

var $2Eu5z = parcelRequire("2Eu5z");

var $6L9RF = parcelRequire("6L9RF");

var $gPqEA = parcelRequire("gPqEA");
var $9M9zY = parcelRequire("9M9zY");

var $7Coz1 = parcelRequire("7Coz1");
const $d964a35fc883c621$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $d964a35fc883c621$var$styles = {
    header: "_1h6dmuej _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _12ornqa1 _1r62e4h9 _4t3i8vuz",
    childWrapper: "_16jlkb7n"
};
const $d964a35fc883c621$export$426d4171de44bac0 = ({ children: children, onClose: onClose, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        if (url) window.open($d964a35fc883c621$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9M9zY.default), {
        xcss: $d964a35fc883c621$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9M9zY.default), {
                xcss: $d964a35fc883c621$var$styles.childWrapper,
                spread: "space-between",
                alignBlock: "center",
                space: "space.100",
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gPqEA.default), {
                gap: "space.100",
                children: [
                    url && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6L9RF))),
                        appearance: "subtle",
                        label: formatMessage((0, $7Coz1.default).previewPanelOpenInNewWindowLabel),
                        onClick: onOpenInNewWindow,
                        testId: testId && `${testId}.open-in-new-window-button`
                    }),
                    moreActions,
                    onClose && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Eu5z))), {
                                ...iconProps,
                                size: "small"
                            }),
                        label: formatMessage((0, $7Coz1.default).previewPanelCloseButtonLabel),
                        onClick: onPanelClose,
                        testId: testId && `${testId}.close-button`
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("7Coz1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4213c869b5242076$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4213c869b5242076$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: 'navigation.preview-panel.preview-panel-header.close-button-label',
        defaultMessage: 'Close',
        description: 'Label for the close button in the preview panel'
    },
    previewPanelExpandActionLabel: {
        id: 'navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label',
        defaultMessage: 'Expand',
        description: 'Label for the expand action in the preview panel'
    },
    previewPanelNewTabActionLabel: {
        id: 'navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label',
        defaultMessage: 'Open in new tab',
        description: 'Label for the open in new tab action in the preview panel'
    },
    previewPanelMoreDropdownActionLabel: {
        id: 'navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label',
        defaultMessage: 'More',
        description: 'Label for the more dropdown action in the preview panel'
    },
    previewPanelOpenInNewWindowLabel: {
        id: 'navigation.preview-panel.preview-panel-header.open-in-new-window-label',
        defaultMessage: 'Open in new window',
        description: 'Label for the open in new window button in the preview panel header'
    }
});

});


parcelRegister("iNZsx", function(module, exports) {

$parcel$export(module.exports, "PreviewPanelTitle", () => $2c4a243072986bc4$export$92a58681483f4529);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $9M9zY = parcelRequire("9M9zY");
var $h8epd = parcelRequire("h8epd");
const $2c4a243072986bc4$export$92a58681483f4529 = ({ title: title, icon: icon, color: color })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9M9zY.default), {
        space: "space.100",
        alignBlock: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8epd.default), {
                weight: "bold",
                maxLines: 1,
                color: color,
                children: title
            })
        ]
    });
};

});

parcelRegister("7SEcE", function(module, exports) {
module.exports = new URL("ErrorGeneric.d6dc5451.svg", import.meta.url).toString();

});

parcelRegister("hkU4g", function(module, exports) {

$parcel$export(module.exports, "messages", () => $faef742cd6fcfa23$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $faef742cd6fcfa23$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    errorHeader: {
        id: 'navigation.preview-panel-global-objects.panels.error-header',
        defaultMessage: "Can\u2019t load details",
        description: 'Header for the preview panel error state'
    },
    errorDescription: {
        id: 'navigation.preview-panel-global-objects.panels.error-description',
        defaultMessage: "We\u2019ve got all hands on deck working to get you back up and running. For more information, <link>check our status page</link>.",
        description: 'Description for the preview panel error state'
    }
});

});


parcelRegister("7kB7b", function(module, exports) {

$parcel$export(module.exports, "FallbackPreviewPanel", () => $38edd7a54260cfcf$export$97ea7ee86eec0667);
/* FallbackPreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gcesi = parcelRequire("gcesi");
var $j4VPn = parcelRequire("j4VPn");
var $807KM = parcelRequire("807KM");
var $iNZsx = parcelRequire("iNZsx");

var $aSfxo = parcelRequire("aSfxo");
const $38edd7a54260cfcf$var$styles = {
    body: "_zulppxbi _1e0c1txw _2lx21bp4 _16jlkb7n _18m91wug _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi",
    skeleton: "_2rkoiti9 _1e0c1txw _bfhkn82g _4t3igktf",
    skeletonRow1: "_1bsb1osq",
    skeletonRow2: "_1bsb1nrf",
    skeletonRow3: "_1bsb1w8u",
    skeletonRow4: "_1bsbhwvj"
};
const $38edd7a54260cfcf$export$97ea7ee86eec0667 = /*#__PURE__*/ (0, $eJOHy.memo)(({ url: url, name: name, icon: icon })=>{
    const { close: close } = (0, $aSfxo.usePreviewPanelsActions)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gcesi.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $807KM.PreviewPanelHeader), {
                onClose: close,
                url: url,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iNZsx.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $j4VPn.PreviewPanelBody), {
                styles: $38edd7a54260cfcf$var$styles.body,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $38edd7a54260cfcf$var$styles.skeleton,
                            $38edd7a54260cfcf$var$styles.skeletonRow1
                        ])
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $38edd7a54260cfcf$var$styles.skeleton,
                            $38edd7a54260cfcf$var$styles.skeletonRow2
                        ])
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $38edd7a54260cfcf$var$styles.skeleton,
                            $38edd7a54260cfcf$var$styles.skeletonRow3
                        ])
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $38edd7a54260cfcf$var$styles.skeleton,
                            $38edd7a54260cfcf$var$styles.skeletonRow4
                        ])
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $38edd7a54260cfcf$var$styles.skeleton,
                            $38edd7a54260cfcf$var$styles.skeletonRow1
                        ])
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $38edd7a54260cfcf$var$styles.skeleton,
                            $38edd7a54260cfcf$var$styles.skeletonRow2
                        ])
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $38edd7a54260cfcf$var$styles.skeleton,
                            $38edd7a54260cfcf$var$styles.skeletonRow3
                        ])
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $38edd7a54260cfcf$var$styles.skeleton,
                            $38edd7a54260cfcf$var$styles.skeletonRow4
                        ])
                    })
                ]
            })
        ]
    });
});

});


parcelRegister("4OWGC", function(module, exports) {

$parcel$export(module.exports, "IFramePreviewPanel", () => $dfe82a930d65a51c$export$83f0623b6f97b032);
/* IFramePreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gcesi = parcelRequire("gcesi");
var $j4VPn = parcelRequire("j4VPn");
var $807KM = parcelRequire("807KM");
var $iNZsx = parcelRequire("iNZsx");

var $aSfxo = parcelRequire("aSfxo");
const $dfe82a930d65a51c$var$styles = {
    iframe: "_19itglyw _1bsb1osq _4t3i1osq",
    body: "_1e0c1txw _16jlkb7n _18m91wug"
};
const $dfe82a930d65a51c$export$83f0623b6f97b032 = /*#__PURE__*/ (0, $eJOHy.memo)(({ url: url, iframeUrl: iframeUrl, name: name, icon: icon })=>{
    const { close: close } = (0, $aSfxo.usePreviewPanelsActions)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gcesi.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $807KM.PreviewPanelHeader), {
                onClose: close,
                url: url,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iNZsx.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j4VPn.PreviewPanelBody), {
                styles: $dfe82a930d65a51c$var$styles.body,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
                    src: iframeUrl,
                    title: name,
                    className: (0, $hcewu.default)([
                        $dfe82a930d65a51c$var$styles.iframe
                    ])
                })
            })
        ]
    });
});

});



parcelRegister("gzwmK", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $304ec733ca6ad2a8$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $h47gY = parcelRequire("h47gY");
const $304ec733ca6ad2a8$export$e926676385687eaf = ({ children: children, id: id, withExperienceTracker: withExperienceTracker })=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: id
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: id,
        packageName: "jiraEntry",
        fallback: "page",
        withExperienceTracker: withExperienceTracker
    }, children);
};

});

parcelRegister("5PTRS", function(module, exports) {

$parcel$export(module.exports, "IntlProviders", () => $3910e304ad37bfd3$export$c9d8cd4516cc55a8);

var $eJOHy = parcelRequire("eJOHy");

var $4qiFT = parcelRequire("4qiFT");

var $3nRRD = parcelRequire("3nRRD");

var $igDjg = parcelRequire("igDjg");
const $3910e304ad37bfd3$export$c9d8cd4516cc55a8 = ({ children: children, locale: locale, messages: messages })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nRRD.IntlProvider), {
        messages: messages,
        locale: (0, $4qiFT.standardizeLocale)(locale),
        onError: (err)=>{
            // Do not spam local devloop with missing translation errors
            //
            // See: https://github.com/formatjs/formatjs/issues/465#issuecomment-643887472
            // Note the default error handler: https://github.com/formatjs/formatjs/blob/d0b80fd9a814d1427b73577aebb7ccdb80b9ae94/packages/intl/src/utils.ts#L43
            if ($igDjg?.env?.NODE_ENV !== 'production' && err?.code !== 'MISSING_TRANSLATION') // eslint-disable-next-line no-console
            console.error(err);
        }
    }, children);

});
parcelRegister("3nRRD", function(module, exports) {

$parcel$export(module.exports, "IntlProvider", () => $d9df13873493f54a$export$480518999dfc4151);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
const $d9df13873493f54a$export$480518999dfc4151 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4nehu.default), {
        ...props,
        defaultLocale: props.locale
    }, children);

});


parcelRegister("bea4o", function(module, exports) {

$parcel$export(module.exports, "MetricsContainers", () => $5e82a563385f6127$export$2d1617bc0040e5d9);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $k9PyW = parcelRequire("k9PyW");

var $fEmyV = parcelRequire("fEmyV");

var $4xbv3 = parcelRequire("4xbv3");

var $f6YCy = parcelRequire("f6YCy");
const $5e82a563385f6127$export$2d1617bc0040e5d9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: (0, $fEmyV.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k9PyW.ExperienceTrackerProvider), null, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "metrics-containers-subproduct-updater",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f6YCy.SubProductForAnalyticsUpdater), null)), children));

});
parcelRegister("k9PyW", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerProvider", () => $f93b157208a07da2$export$6f49c95a810d59fa);

var $eJOHy = parcelRequire("eJOHy");

var $iZRoS = parcelRequire("iZRoS");
var $7H45T = parcelRequire("7H45T");

var $50BUM = parcelRequire("50BUM");
const $f93b157208a07da2$var$useUnmount = (callback)=>(0, $eJOHy.useEffect)(()=>callback, [
        callback
    ]);
const $f93b157208a07da2$export$6f49c95a810d59fa = ({ children: children })=>{
    const [experienceTracker] = (0, $eJOHy.useState)(new (0, $iZRoS.ExperienceTracker)());
    const [cleanupSliSub] = (0, $eJOHy.useState)(()=>experienceTracker.subscribe((0, $50BUM.sliSubscriber)));
    const cleanup = (0, $eJOHy.useCallback)(()=>{
        cleanupSliSub();
    }, [
        cleanupSliSub
    ]);
    $f93b157208a07da2$var$useUnmount(cleanup);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7H45T.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, children);
};

});
parcelRegister("iZRoS", function(module, exports) {

$parcel$export(module.exports, "ExperienceTracker", () => $7cab408cf15cfb9d$export$12b6b072930fd68f);

var $6NlBe = parcelRequire("6NlBe");
class $7cab408cf15cfb9d$export$12b6b072930fd68f {
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $6NlBe.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
}

});
parcelRegister("6NlBe", function(module, exports) {

$parcel$export(module.exports, "Experience", () => $c3f48982fe5189a0$export$c90b54e658fc4d7c);

var $aK2Mm = parcelRequire("aK2Mm");
function $c3f48982fe5189a0$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $c3f48982fe5189a0$export$c90b54e658fc4d7c {
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this._hasStopped = false;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $c3f48982fe5189a0$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $c3f48982fe5189a0$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $aK2Mm.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $c3f48982fe5189a0$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
}

});
parcelRegister("aK2Mm", function(module, exports) {

$parcel$export(module.exports, "ExperienceTimeoutError", () => $430f159f63ba0962$export$d27a2b6293f7631c);
class $430f159f63ba0962$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}

});



parcelRegister("50BUM", function(module, exports) {

$parcel$export(module.exports, "sliSubscriber", () => $b6949126dda90aac$export$db0b99fe17114899);

var $2Mqjh = parcelRequire("2Mqjh");

var $bRJAs = parcelRequire("bRJAs");

var $a9ldn = parcelRequire("a9ldn");

const $b6949126dda90aac$var$transformApplication = (application)=>{
    switch(application){
        case 0, $bRJAs.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $bRJAs.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $bRJAs.JIRA_CORE:
            return 'jira-core';
        case 0, $bRJAs.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $bRJAs.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $b6949126dda90aac$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $a9ldn.FREE_EDITION:
            return 'jedi';
        case 0, $a9ldn.STANDARD_EDITION:
            return 'standard';
        case 0, $a9ldn.PREMIUM_EDITION:
            return 'premium';
        case 0, $a9ldn.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $b6949126dda90aac$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: action,
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            // any attribute on top of this is overridable by any tracker
            task: experience,
            reason: location,
            analyticsSource: analyticsSource,
            application: $b6949126dda90aac$var$transformApplication(application),
            edition: $b6949126dda90aac$var$transformEdition(edition),
            ...errorMessage && {
                errorMessage: errorMessage
            }
        }
    });
const $b6949126dda90aac$var$reportSli = (experienceDescription)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $b6949126dda90aac$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};
const $b6949126dda90aac$export$db0b99fe17114899 = (event)=>{
    const { name: name, action: action } = event;
    // @ts-expect-error - TS2339 - Property 'disableSli' does not exist on type '{}'. | TS2339 - Property 'analyticsSource' does not exist on type '{}'. | TS2339 - Property 'application' does not exist on type '{}'. | TS2339 - Property 'edition' does not exist on type '{}'. | TS2339 - Property 'location' does not exist on type '{}'.
    const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
    if (disableSli) return;
    switch(action){
        case 0, $f17fa9e5c82da056$export$627ef4c1ed2d7a9a:
            $b6949126dda90aac$var$reportSli({
                experience: name,
                action: (0, $f17fa9e5c82da056$export$627ef4c1ed2d7a9a),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $f17fa9e5c82da056$export$b48b3d1872522384:
            $b6949126dda90aac$var$reportSli({
                experience: name,
                action: (0, $f17fa9e5c82da056$export$b48b3d1872522384),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                ...event.error && {
                    errorMessage: String(event.error)
                },
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $f17fa9e5c82da056$export$aeeb00d0845d24d8:
            $b6949126dda90aac$var$reportSli({
                experience: name,
                action: (0, $f17fa9e5c82da056$export$aeeb00d0845d24d8),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                additionalAttributes: additionalAttributes
            });
            break;
        default:
    }
};

});


parcelRegister("f6YCy", function(module, exports) {

$parcel$export(module.exports, "SubProductForAnalyticsUpdater", () => $9b9313a64c71dc7d$export$2f8fd5150032da73);

var $eJOHy = parcelRequire("eJOHy");

var $kQnVX = parcelRequire("kQnVX");

var $figsJ = parcelRequire("figsJ");
const $9b9313a64c71dc7d$export$2f8fd5150032da73 = ()=>{
    const subProduct = (0, $figsJ.useSubProductForAnalytics)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $kQnVX.setSubProduct)(subProduct);
    }, [
        subProduct
    ]);
    return null;
};

});


parcelRegister("jFTjK", function(module, exports) {

$parcel$export(module.exports, "NavigationContainers", () => $3105c9d1784441dd$export$36f9ed697cae18ae);

var $eJOHy = parcelRequire("eJOHy");

var $7XGx3 = parcelRequire("7XGx3");
const $3105c9d1784441dd$var$ServerContainers = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
const $3105c9d1784441dd$export$36f9ed697cae18ae = ({ children: children })=>{
    const Containers = !false ? (0, $7XGx3.ClientOnlyNavigationContainers) : $3105c9d1784441dd$var$ServerContainers;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Containers, null, children);
};

});
parcelRegister("7XGx3", function(module, exports) {

$parcel$export(module.exports, "ClientOnlyNavigationContainers", () => $8293891f5492a13e$export$68d7c1e44acfd599);

var $eJOHy = parcelRequire("eJOHy");

var $jCQk5 = parcelRequire("jCQk5");
const $8293891f5492a13e$export$68d7c1e44acfd599 = ({ children: children })=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jCQk5.Provider), null, children);
    return null;
};

});


parcelRegister("bDTmj", function(module, exports) {

$parcel$export(module.exports, "PageConfigContainers", () => $8aa1d096109b963f$export$9c661932489b4130);

var $eJOHy = parcelRequire("eJOHy");

var $575d2 = parcelRequire("575d2");

var $hWeHP = parcelRequire("hWeHP");

var $kfvK2 = parcelRequire("kfvK2");

var $baxYj = parcelRequire("baxYj");

var $l8oW2 = parcelRequire("l8oW2");
const $8aa1d096109b963f$var$useRouterRoute = (0, $kfvK2.createRouterSelector)((state)=>state.route);
const $8aa1d096109b963f$export$9c661932489b4130 = ({ children: children })=>{
    const { PageConfigContainerOverride: PageConfigContainerOverride } = $8aa1d096109b963f$var$useRouterRoute();
    if (PageConfigContainerOverride !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PageConfigContainerOverride, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $575d2.ThemeContainer), {
        isGlobal: true,
        getMeta: (0, $hWeHP.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $baxYj.DocumentTitleContainer), {
        titleSuffix: (0, $l8oW2.ripTitleTemplateFromMeta)((0, $hWeHP.default))
    }, children));
};

});
parcelRegister("575d2", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $68e241df896657e0$export$93d4e7f90805808f);
$parcel$export(module.exports, "ThemeContainer", () => $68e241df896657e0$export$11eb671888ed6e7d);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

var $2evd1 = parcelRequire("2evd1");
const $68e241df896657e0$var$initialState = {
    navigationTheme: {
        shouldShowTitle: false,
        logoUrl: '',
        usesCustomColours: false,
        backgroundColor: '',
        highlightColor: ''
    }
};
const $68e241df896657e0$var$Store = (0, $GtRbT.createStore)({
    name: 'theme',
    initialState: $68e241df896657e0$var$initialState,
    actions: $2evd1
});
const $68e241df896657e0$export$74e6aa5aeff5e82e = (0, $ht3nQ.createSubscriber)($68e241df896657e0$var$Store);
const $68e241df896657e0$export$93d4e7f90805808f = (0, $iJq0l.createHook)($68e241df896657e0$var$Store);
const $68e241df896657e0$export$11eb671888ed6e7d = (0, $6E16M.createContainer)($68e241df896657e0$var$Store, {
    onInit: $2evd1.bootstrap
});

});
parcelRegister("2evd1", function(module, exports) {

$parcel$export(module.exports, "bootstrap", () => $c655e5e5256464c4$export$36aff1fbb4f5dfc6);
$parcel$export(module.exports, "update", () => $c655e5e5256464c4$export$722fbec263ad908a);

const $c655e5e5256464c4$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
        const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
        const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
        // we need to use color code directly here to compare it with hex code in meta tags
        const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $135dba7912433cc2$exports).N0 || ajsHighlightColor !== (0, $135dba7912433cc2$exports).B400);
        const navigationTheme = {
            shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
            usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
            backgroundColor: ajsBackgroundColor || "var(--ds-background-inverse-subtle, #00000029)",
            highlightColor: ajsHighlightColor || "var(--ds-text-brand, #0C66E4)"
        };
        if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
        setState({
            navigationTheme: navigationTheme
        });
    };
const $c655e5e5256464c4$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
        const navigationTheme = {
            ...getState().navigationTheme,
            ...item
        };
        setState({
            navigationTheme: navigationTheme
        });
    };

});


parcelRegister("baxYj", function(module, exports) {

$parcel$export(module.exports, "useDocumentTitleActions", () => $3c296a66cba128e6$export$57c0fda036e12d67);
$parcel$export(module.exports, "DocumentTitleContainer", () => $3c296a66cba128e6$export$1aad43993172f16f);
$parcel$export(module.exports, "DocumentTitleSubscriber", () => $3c296a66cba128e6$export$b88d5abf3e0bec8c);
$parcel$export(module.exports, "DocumentTitleHelper", () => $3c296a66cba128e6$export$573bf8d2ae7d60dc);
$parcel$export(module.exports, "DocumentTitleHelperOld", () => $3c296a66cba128e6$export$1b644a069f382802);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

var $4Kr5L = parcelRequire("4Kr5L");

var $l8oW2 = parcelRequire("l8oW2");
const $3c296a66cba128e6$var$initialState = {
    title: '',
    defaultTitle: '',
    contextArray: []
};
const $3c296a66cba128e6$var$Store = (0, $GtRbT.createStore)({
    name: 'document-title',
    initialState: $3c296a66cba128e6$var$initialState,
    actions: $4Kr5L.actions
});
const $3c296a66cba128e6$export$57c0fda036e12d67 = (0, $iJq0l.createActionsHook)($3c296a66cba128e6$var$Store);
const $3c296a66cba128e6$export$4b208edda918084f = (0, $iJq0l.createHook)($3c296a66cba128e6$var$Store);
const $3c296a66cba128e6$export$1aad43993172f16f = (0, $6E16M.createContainer)($3c296a66cba128e6$var$Store, {
    displayName: 'DocumentTitleContainer'
});
const $3c296a66cba128e6$export$b88d5abf3e0bec8c = (0, $ht3nQ.createSubscriber)($3c296a66cba128e6$var$Store, {
    displayName: 'DocumentTitleSubscriber'
});
const $3c296a66cba128e6$export$573bf8d2ae7d60dc = ({ title: title })=>{
    const { addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle, updateTitle: updateTitle } = $3c296a66cba128e6$export$57c0fda036e12d67();
    const identifierRef = (0, $eJOHy.useRef)(Symbol(title));
    const onUpdate = (0, $eJOHy.useCallback)(()=>{
        updateTitle(title, identifierRef.current);
    }, [
        updateTitle,
        title
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const titleRef = identifierRef.current;
        addDocumentTitle(titleRef, title);
        return ()=>{
            removeDocumentTitle(titleRef);
            onUpdate();
        };
    }, [
        addDocumentTitle,
        onUpdate,
        removeDocumentTitle,
        title
    ]);
    (0, $eJOHy.useEffect)(()=>{
        onUpdate();
    }, [
        onUpdate
    ]);
    return null;
};
class $3c296a66cba128e6$export$1b644a069f382802 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.myself = Symbol('document title identifier');
        this.props.addDocumentTitle(this.myself);
    }
    componentDidMount() {
        this.updateTitle();
    }
    componentDidUpdate() {
        this.updateTitle();
    }
    componentWillUnmount() {
        this.props.removeDocumentTitle(this.myself);
        this.updateTitle();
    }
    updateTitle() {
        if ((0, $l8oW2.checkDocumentTitle)(this.myself, this.props.contextArray)) this.props.setTitle(this.props.title);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4Kr5L", function(module, exports) {

$parcel$export(module.exports, "actions", () => $6308c1fa1982f2c0$export$e324594224ef24da);

var $lRC98 = parcelRequire("lRC98");

var $lssTN = parcelRequire("lssTN");

var $eWjRe = parcelRequire("eWjRe");

var $hfEoN = parcelRequire("hfEoN");
const $6308c1fa1982f2c0$export$e324594224ef24da = {
    setTitle: $lRC98.setTitle,
    addDocumentTitle: $lssTN.addDocumentTitle,
    removeDocumentTitle: $eWjRe.removeDocumentTitle,
    updateTitle: $hfEoN.updateTitle
};

});
parcelRegister("lRC98", function(module, exports) {

$parcel$export(module.exports, "setTitle", () => $4e71aca911f1bb86$export$420a7f2fd9cad6f6);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $l8oW2 = parcelRequire("l8oW2");
const $4e71aca911f1bb86$export$420a7f2fd9cad6f6 = (title)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
        const state = getState();
        const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
        const newTitle = (0, $l8oW2.createTitleFromTemplate)(title, titleTemplate);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.title = newTitle;
        setState({
            ...state,
            title: newTitle
        });
    };

});
parcelRegister("l8oW2", function(module, exports) {

$parcel$export(module.exports, "createTitleFromTemplate", () => $040a2099102c0019$export$3795256dd54a9c9d);
$parcel$export(module.exports, "ripTitleTemplateFromMeta", () => $040a2099102c0019$export$b7d18105f80195c);
$parcel$export(module.exports, "checkDocumentTitle", () => $040a2099102c0019$export$7f8be70a0bed1bae);

var $7jTnu = parcelRequire("7jTnu");
const $040a2099102c0019$export$3795256dd54a9c9d = (title, template)=>template.replace(/%s/, title);
const $040a2099102c0019$export$b7d18105f80195c = (getMeta)=>getMeta('ajs-app-title');
const $040a2099102c0019$export$7f8be70a0bed1bae = (symbol, contextArray)=>{
    const lastDocumentTitle = contextArray[contextArray.length - 1];
    if ((0, $7jTnu.fg)('jira-concurrent-document-title')) {
        if (typeof lastDocumentTitle === 'object' && lastDocumentTitle.symbol === symbol) return true;
        return false;
    }
    if (lastDocumentTitle === symbol) return true;
    return false;
};

});


parcelRegister("lssTN", function(module, exports) {

$parcel$export(module.exports, "addDocumentTitle", () => $74f5f89874b47894$export$a0c188c0ea474bb8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7jTnu = parcelRequire("7jTnu");
const $74f5f89874b47894$export$a0c188c0ea474bb8 = (symbol, title)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        title && (0, $7jTnu.fg)('jira-concurrent-document-title') ? contextArray.push({
            title: title,
            symbol: symbol
        }) : contextArray.push(symbol);
        setState({
            contextArray: contextArray
        });
    };

});

parcelRegister("eWjRe", function(module, exports) {

$parcel$export(module.exports, "removeDocumentTitle", () => $266ca598e8a9565c$export$e844009b77f80a72);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7jTnu = parcelRequire("7jTnu");
const $266ca598e8a9565c$export$e844009b77f80a72 = (titleSymbol)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        setState({
            contextArray: (0, $7jTnu.fg)('jira-concurrent-document-title') ? contextArray.filter((titleContext)=>typeof titleContext === 'object' && titleContext.symbol !== titleSymbol) : contextArray.filter((symbol)=>symbol !== titleSymbol)
        });
    };

});

parcelRegister("hfEoN", function(module, exports) {

$parcel$export(module.exports, "updateTitle", () => $2b252423f2f06165$export$bf6f7165e46e2479);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7jTnu = parcelRequire("7jTnu");

var $l8oW2 = parcelRequire("l8oW2");
const $2b252423f2f06165$var$generateTitle = (title, titleSuffix)=>{
    const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
    const newTitle = (0, $l8oW2.createTitleFromTemplate)(title, titleTemplate);
    return newTitle;
};
const $2b252423f2f06165$export$bf6f7165e46e2479 = (title, context)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
        const state = getState();
        const contextItem = state.contextArray.find((item)=>{
            if (typeof item === 'object') return item.symbol === context;
            return false;
        });
        // If there is no contextItem, it means that the component has been unmounted
        // And we'll just use the last used title from the contextArray
        if (!contextItem && state.contextArray.length && (0, $7jTnu.fg)('jira-concurrent-document-title')) {
            const lastContextItem = state.contextArray[state.contextArray.length - 1];
            let newTitle = '';
            // This will always be an object but we have to check it to make TS happy
            if (typeof lastContextItem === 'object') newTitle = $2b252423f2f06165$var$generateTitle(lastContextItem.title, titleSuffix);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.title = newTitle;
            setState({
                title: newTitle
            });
            return;
        }
        if ((0, $l8oW2.checkDocumentTitle)(context, state.contextArray)) {
            const newTitle = $2b252423f2f06165$var$generateTitle(title, titleSuffix);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.title = newTitle;
            setState({
                title: newTitle
            });
        }
    };

});




parcelRegister("hxAu9", function(module, exports) {

$parcel$export(module.exports, "UiManagers", () => $c70783e9b064ee1e$export$41286c339a88ca24);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $gNYyp = parcelRequire("gNYyp");

var $fBBqI = parcelRequire("fBBqI");

var $4cLUT = parcelRequire("4cLUT");
const $c70783e9b064ee1e$var$Filler = ()=>null;
const $c70783e9b064ee1e$var$Nest = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
const $c70783e9b064ee1e$var$ClientManagerServerVersion = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Nest, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Nest, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Filler, {
        for: "SpotLightMaanger"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Nest, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Nest, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Filler, {
        for: "ModalContextProvider"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Filler, {
        for: "FlagsProvider"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c70783e9b064ee1e$var$Filler, {
        for: "CrossFlowProvider"
    }));
const $c70783e9b064ee1e$export$41286c339a88ca24 = ({ children: children })=>{
    // eslint-disable-next-line no-nested-ternary
    const ClientUiManagers = !false ? (0, $4cLUT.ClientUiManagers) : (0, $7jTnu.fg)('jfp_magma_jira-use-id-sync') ? $c70783e9b064ee1e$var$ClientManagerServerVersion : (0, $eJOHy.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fBBqI.LayoutManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gNYyp.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ClientUiManagers, null, children)));
};

});
parcelRegister("gNYyp", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbManager", () => $53ba883a1237d88c$export$cd5073909dd92c28);

var $eJOHy = parcelRequire("eJOHy");

var $ifPW4 = parcelRequire("ifPW4");
const $53ba883a1237d88c$export$cd5073909dd92c28 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ifPW4.BreadcrumbContainer), null, children);

});

parcelRegister("fBBqI", function(module, exports) {

$parcel$export(module.exports, "LayoutManager", () => $293ac920f10af9e7$export$4a04ad01c410b415);

var $eJOHy = parcelRequire("eJOHy");

var $dfh4P = parcelRequire("dfh4P");

var $kfvK2 = parcelRequire("kfvK2");
var $eJrcF = parcelRequire("eJrcF");

var $6E16M = parcelRequire("6E16M");

var $4BzWx = parcelRequire("4BzWx");

var $fZsy4 = parcelRequire("fZsy4");
const $293ac920f10af9e7$var$LayoutContainer = (0, $6E16M.createContainer)((0, $fZsy4.layoutStore), {
    displayName: 'JiraLayoutContainer',
    onInit: ()=>({ dispatch: dispatch }, { leftSidebar: leftSidebar, rightSidebar: rightSidebar, isChromeless: isChromeless })=>{
            dispatch((0, $4BzWx.actions).setIsChromeless(isChromeless));
            dispatch((0, $4BzWx.actions).setLeftSidebarState(leftSidebar));
            dispatch((0, $4BzWx.actions).setRightSidebarState(rightSidebar));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { isChromeless: isChromeless })=>{
            dispatch((0, $4BzWx.actions).setIsChromeless(isChromeless));
        }
});
const $293ac920f10af9e7$var$DEFFAULT_RIGHT_SIDEBAR_STATE = {
    stackState: []
};
const $293ac920f10af9e7$var$useIsChromeless = (0, $kfvK2.createRouterSelector)((state)=>state.route.layout?.isChromeless === true || state.route.entryPoint?.()?.toString() === 'ChromelessEntryPoint');
const $293ac920f10af9e7$export$4a04ad01c410b415 = ({ children: children })=>{
    const { data: data } = (0, $eJrcF.useResource)((0, $dfh4P.navigationUiStateResource));
    const isChromeless = $293ac920f10af9e7$var$useIsChromeless();
    const isLeftSidebarCollapsed = data?.leftSidebar?.isCollapsed ?? false;
    const leftSidebarWidth = data?.leftSidebar?.width ?? (0, $fZsy4.DEFAULT_LEFT_SIDEBAR_WIDTH);
    const leftSidebar = (0, $eJOHy.useMemo)(()=>({
            isVisible: true,
            isCollapsed: isLeftSidebarCollapsed,
            width: leftSidebarWidth,
            isFlyoutOpen: false
        }), [
        isLeftSidebarCollapsed,
        leftSidebarWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($293ac920f10af9e7$var$LayoutContainer, {
        isGlobal: true,
        isChromeless: isChromeless,
        leftSidebar: leftSidebar,
        rightSidebar: $293ac920f10af9e7$var$DEFFAULT_RIGHT_SIDEBAR_STATE
    }, children);
};

});

parcelRegister("4cLUT", function(module, exports) {

$parcel$export(module.exports, "ClientUiManagers", () => $5d953a9b6bf2524b$export$d1db6ae5bf84e489);

var $eJOHy = parcelRequire("eJOHy");

var $hZUwi = parcelRequire("hZUwi");

var $a6a0a = parcelRequire("a6a0a");

var $emaA9 = parcelRequire("emaA9");

var $beI5n = parcelRequire("beI5n");

var $bILK0 = parcelRequire("bILK0");

var $iOVHp = parcelRequire("iOVHp");

var $1gHmu = parcelRequire("1gHmu");

var $9pWNg = parcelRequire("9pWNg");
const $5d953a9b6bf2524b$export$d1db6ae5bf84e489 = ({ children: children })=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emaA9.CrossFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1gHmu.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9pWNg.ProjectCreateDrawerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $beI5n.FavoriteChangeProvider), {
        onShowFlag: showFlag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hZUwi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a6a0a.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iOVHp.ModalContextProvider), null, children)))))));
};

});
parcelRegister("emaA9", function(module, exports) {

$parcel$export(module.exports, "CrossFlowProvider", () => $223acf4d26345749$export$d900e4062895cd7c);

var $eJOHy = parcelRequire("eJOHy");

var $iL3Rn = parcelRequire("iL3Rn");

var $2Mqjh = parcelRequire("2Mqjh");

var $kEUB1 = parcelRequire("kEUB1");

var $2cfd4 = parcelRequire("2cfd4");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");

var $lXldF = parcelRequire("lXldF");

var $kFfY1 = parcelRequire("kFfY1");
// DELOR-412 Remove explicit mock once we make analytics a no-op in SSR
const $223acf4d26345749$var$getAnalyticsInstance = ()=>false ? Promise.resolve({
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendUIEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendOperationalEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendTrackEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendScreenEvent: ()=>{}
    }) : (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
const $223acf4d26345749$export$d900e4062895cd7c = ({ children: children })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const locale = (0, $2cfd4.useLocale)();
    const analyticsClient = (0, $fAZgY.useMemoWithCondition)(()=>$223acf4d26345749$var$getAnalyticsInstance(), [], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
    const plugins = (0, $fAZgY.useMemoWithCondition)(()=>[
            (0, $lXldF.getContainersPlugin),
            (0, $kFfY1.getUsersPlugin)
        ], [], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iL3Rn.default), {
        cloudId: cloudId,
        // @ts-expect-error - TS2322 - Type 'Promise<typeof AnalyticsWebClient> | Promise<{ sendUIEvent: () => void; sendOperationalEvent: () => void; sendTrackEvent: () => void; sendScreenEvent: () => void; }>' is not assignable to type 'MaybePromise<AnalyticsWebClientInterface>'.
        analyticsClient: analyticsClient,
        locale: locale,
        plugins: plugins
    }, children);
};

});
parcelRegister("iL3Rn", function(module, exports) {

$parcel$export(module.exports, "default", () => $125d1677be6ece76$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $iTuQf = parcelRequire("iTuQf");

const $125d1677be6ece76$var$JiraProvider = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iTuQf.CrossFlowProvider), {
        ...props,
        originProduct: "jira"
    });
};
var $125d1677be6ece76$export$2e2bcd8739ae039 = $125d1677be6ece76$var$JiraProvider;

});
parcelRegister("iTuQf", function(module, exports) {

$parcel$export(module.exports, "CrossFlowProvider", () => $db3abcfb6626c118$export$d900e4062895cd7c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $givfd = parcelRequire("givfd");

var $ib39d = parcelRequire("ib39d");

var $3HQon = parcelRequire("3HQon");

var $bl9ag = parcelRequire("bl9ag");

var $a1Ecg = parcelRequire("a1Ecg");

var $lAFrK = parcelRequire("lAFrK");

var $5DeAW = parcelRequire("5DeAW");

var $7wx9T = parcelRequire("7wx9T");

var $9JVK1 = parcelRequire("9JVK1");

const $db3abcfb6626c118$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("nVfTN")));
const $db3abcfb6626c118$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
        const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
        const onCloseResolver = (0, $eJOHy.useRef)();
        const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $eJOHy.useState)(false);
        const fireEvent = (0, $eJOHy.useMemo)(()=>(0, $3HQon.analyticsWrapper)(analyticsClient), [
            analyticsClient
        ]);
        const [requestOptions, setRequestOptions] = (0, $eJOHy.useState)();
        const onAnalyticsEvent = (0, $eJOHy.useCallback)((payload)=>{
            const gasV3Event = (0, $bl9ag.transformEvent)(payload);
            if (gasV3Event) {
                const enrichedEvent = (0, $7wx9T.enrichWithRequestOptions)((0, $5DeAW.enrichWithPackageDetails)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        const onHandShake = (0, $eJOHy.useCallback)((appName)=>{
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $27c7fc6638bd7614$export$12346a674644c156),
                        action: (0, $9JVK1.uiInitialized),
                        actionSubject: (0, $9JVK1.crossFlowActionSubject),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: $9JVK1.source
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        const onOpen = (0, $eJOHy.useCallback)((options)=>{
            /**
     * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
     * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
     */ setFirstHandshakeReceived(false);
            const analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $7wx9T.enrichWithRequestOptions)({
                    eventType: (0, $27c7fc6638bd7614$export$12346a674644c156),
                    action: (0, $9JVK1.openInvoked),
                    actionSubject: (0, $9JVK1.crossFlowActionSubject)
                }, options),
                context: [
                    {
                        source: $9JVK1.source
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $givfd.Journeys).GET_STARTED && redirectToWac) {
                (0, $a1Ecg.setProductSignUpLocation)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                const completionStatus = {};
                return Promise.resolve(completionStatus);
            }
            const updatedExperimentalOptions = {
                ...globalExperimentalOptions || {},
                // "globalExperimentalOptions" will be injected to EVERY crossFlow invoke
                ...options.experimentalOptions || {} // "options.experimentalOptions" takes care of passing experimentalOptions to ONE specific crossFlow invoke
            };
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise((resolve)=>{
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        const onClose = (0, $eJOHy.useCallback)((completionStatus)=>{
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        const { colorMode: colorMode } = (0, $ib39d.default)();
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $givfd.BaseCrossFlowApiProvider), {
            onOpen: onOpen,
            children: [
                children,
                requestOptions && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lAFrK.ErrorBoundary), {
                    onAnalyticsEvent: onAnalyticsEvent,
                    onError: onError,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                        fallback: null,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)(IntegrationView, {
                            ...baseProviderProps,
                            ...requestOptions,
                            onAnalyticsEvent: onAnalyticsEvent,
                            originProduct: originProduct,
                            theme: colorMode,
                            onClose: onClose,
                            onHandShake: onHandShake,
                            plugins: plugins,
                            env: env,
                            redirectToWac: redirectToWac,
                            zIndex: requestOptions.zIndex ?? 1000
                        })
                    })
                })
            ]
        });
    };
const $db3abcfb6626c118$export$d900e4062895cd7c = $db3abcfb6626c118$export$79d79d8dd8574306($db3abcfb6626c118$var$IntegrationView);

});
parcelRegister("3HQon", function(module, exports) {

$parcel$export(module.exports, "analyticsWrapper", () => $2d8b1abb265fc718$export$91b4dd3bfc301325);

const $2d8b1abb265fc718$export$91b4dd3bfc301325 = (analyticsClient)=>{
    return (event)=>{
        return Promise.resolve(analyticsClient).then((client)=>{
            switch(event.eventType){
                case 0, $27c7fc6638bd7614$export$a1562d08625f5d7e:
                    client.sendUIEvent(event);
                    break;
                case 0, $27c7fc6638bd7614$export$947dac6c72b26f81:
                    client.sendTrackEvent(event);
                    break;
                case 0, $27c7fc6638bd7614$export$12346a674644c156:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $27c7fc6638bd7614$export$f1d537d508d2945a:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};

});

parcelRegister("bl9ag", function(module, exports) {

$parcel$export(module.exports, "transformEvent", () => $f3efa070e70777bb$export$3f40e8c44448be30);
// Copied from xflow-ui. We post raw analytics events (context and payload only) from xflow-ui to consumer (CFE), transform on consumer and post to gasv3.

const $f3efa070e70777bb$var$GROWTH_TAG = 'growth';
const $f3efa070e70777bb$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $f3efa070e70777bb$var$getSources = (context)=>$f3efa070e70777bb$var$extractFromEventContext([
        'source'
    ], context);
const $f3efa070e70777bb$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
        const newAttributes = {
            ...ans,
            ...contextProps
        };
        return attributes ? {
            ...newAttributes,
            ...attributes
        } : newAttributes;
    }, {});
const $f3efa070e70777bb$var$getPackageInfo = (context)=>context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $f3efa070e70777bb$var$last = (values)=>values[values.length - 1];
const $f3efa070e70777bb$export$3f40e8c44448be30 = (event)=>{
    const { context: context, payload: payload } = event;
    if (!payload) return null;
    const sources = $f3efa070e70777bb$var$getSources(context);
    const source = $f3efa070e70777bb$var$last(sources) || (0, $27c7fc6638bd7614$export$b055de0e665cb20c);
    const extraAttributes = $f3efa070e70777bb$var$getExtraAttributes(context);
    const { packageName: packageName, packageVersion: packageVersion } = $f3efa070e70777bb$var$last($f3efa070e70777bb$var$getPackageInfo(context)) || {};
    const { eventType: eventType = (0, $27c7fc6638bd7614$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
    const attributes = {
        packageName: packageName,
        packageVersion: packageVersion,
        ...extraAttributes,
        ...payloadAttributes
    };
    const tags = payload.tags || [];
    tags.push($f3efa070e70777bb$var$GROWTH_TAG);
    switch(eventType){
        case 0, $27c7fc6638bd7614$export$a1562d08625f5d7e:
        case 0, $27c7fc6638bd7614$export$12346a674644c156:
        case 0, $27c7fc6638bd7614$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $27c7fc6638bd7614$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};

});

parcelRegister("a1Ecg", function(module, exports) {

$parcel$export(module.exports, "setProductSignUpLocation", () => $029a6b3c00573988$export$2827e2473cb9a346);

var $lbX5P = parcelRequire("lbX5P");


var $byRbk = parcelRequire("byRbk");
const $029a6b3c00573988$var$utmCampaignMap = {
    'atlassian-switcher': (0, $byRbk.UtmCampaign)['atlassian-switcher']
};
const $029a6b3c00573988$var$isBundledProduct = (productKey)=>{
    return [
        (0, $lbX5P.Targets).JIRA_SOFTWARE,
        (0, $lbX5P.Targets).JIRA_SERVICE_DESK,
        (0, $lbX5P.Targets).JIRA_CORE,
        (0, $lbX5P.Targets).CONFLUENCE
    ].includes(productKey);
};
const $029a6b3c00573988$var$getBundleSignUpParams = (productKey)=>{
    const bundles = {
        [(0, $lbX5P.Targets).JIRA_SOFTWARE]: 'jira-software',
        [(0, $lbX5P.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
        [(0, $lbX5P.Targets).JIRA_CORE]: 'jira-core',
        [(0, $lbX5P.Targets).CONFLUENCE]: 'confluence'
    };
    // Bundles default to free
    return `bundle=${bundles[productKey]}&edition=free`;
};
const $029a6b3c00573988$var$isProductWithCustomSignUpPath = (productKey)=>{
    return [
        (0, $lbX5P.Targets).OPSGENIE
    ].includes(productKey);
};
const $029a6b3c00573988$var$getProductCustomSignUpPath = (productKey)=>{
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    const links = {
        [(0, $lbX5P.Targets).OPSGENIE]: (0, $011534f3f9fbaea5$export$fb1e43fdafe12e9b)
    };
    return links[productKey];
};
const $029a6b3c00573988$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
    return Boolean($029a6b3c00573988$var$utmCampaignMap[sourceComponent]);
};
const $029a6b3c00573988$var$getUtmParams = (sourceComponent, sourceContext)=>{
    let utmParams = '';
    if (sourceComponent && $029a6b3c00573988$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + `utm_campaign=${$029a6b3c00573988$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
        if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
    }
    return utmParams;
};
const $029a6b3c00573988$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
    const wacUrl = env === 'staging' ? (0, $011534f3f9fbaea5$export$c37558e5c67d2b01) : (0, $011534f3f9fbaea5$export$f199baf8dfc7621e);
    const utmParams = $029a6b3c00573988$var$getUtmParams(sourceComponent, sourceContext);
    let queryParams = '';
    let bundleParams = '';
    let path = (0, $011534f3f9fbaea5$export$2a45a00073911255);
    if ($029a6b3c00573988$var$isBundledProduct(productKey)) {
        path = (0, $011534f3f9fbaea5$export$e6c04a1dd86d1c14);
        bundleParams = $029a6b3c00573988$var$getBundleSignUpParams(productKey);
    } else if ($029a6b3c00573988$var$isProductWithCustomSignUpPath(productKey)) path = $029a6b3c00573988$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
    return wacUrl + path + queryParams;
};
const $029a6b3c00573988$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
    const url = $029a6b3c00573988$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, '_blank');
};

});
const $011534f3f9fbaea5$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $011534f3f9fbaea5$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $011534f3f9fbaea5$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $011534f3f9fbaea5$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $011534f3f9fbaea5$export$2a45a00073911255 = '/software';

parcelRegister("byRbk", function(module, exports) {

$parcel$export(module.exports, "UtmCampaign", () => $364b46f3b251b64b$export$fc604aa353a97e10);
var $364b46f3b251b64b$export$fc604aa353a97e10 = /*#__PURE__*/ function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    return UtmCampaign;
}({});

});


parcelRegister("lAFrK", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $2b8a19c9ec82ee97$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");

var $9JVK1 = parcelRequire("9JVK1");
const $2b8a19c9ec82ee97$var$name = "platform-pkg";
const $2b8a19c9ec82ee97$var$version = "0.0.0-use.local";
const $2b8a19c9ec82ee97$var$payload = {
    eventType: (0, $27c7fc6638bd7614$export$12346a674644c156),
    action: (0, $9JVK1.errorBoundaryAction),
    actionSubject: (0, $9JVK1.errorBoundaryActionSubject)
};
const $2b8a19c9ec82ee97$var$context = [
    {
        source: $9JVK1.source
    },
    {
        packageName: $2b8a19c9ec82ee97$var$name,
        packageVersion: $2b8a19c9ec82ee97$var$version
    }
];
class $2b8a19c9ec82ee97$export$e926676385687eaf extends (0, $eJOHy.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        this.props.onAnalyticsEvent({
            payload: $2b8a19c9ec82ee97$var$payload,
            context: $2b8a19c9ec82ee97$var$context
        });
        if (this.props.onError) this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}

});
parcelRegister("9JVK1", function(module, exports) {

$parcel$export(module.exports, "source", () => $72e9c1ae9f44f56d$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "errorBoundaryAction", () => $72e9c1ae9f44f56d$export$9d8252a268f4fa72);
$parcel$export(module.exports, "errorBoundaryActionSubject", () => $72e9c1ae9f44f56d$export$1045419caf49b395);
$parcel$export(module.exports, "crossFlowActionSubject", () => $72e9c1ae9f44f56d$export$d54c183f56e39aa5);
$parcel$export(module.exports, "uiInitialized", () => $72e9c1ae9f44f56d$export$e5c2c058fa8068a6);
$parcel$export(module.exports, "openInvoked", () => $72e9c1ae9f44f56d$export$e67cdcb8867a3bd0);

const $72e9c1ae9f44f56d$export$b4d5da5f34fb77ad = 'crossFlowProvider';
const $72e9c1ae9f44f56d$export$9d8252a268f4fa72 = 'errorCaught';
const $72e9c1ae9f44f56d$export$1045419caf49b395 = 'errorBoundary';
const $72e9c1ae9f44f56d$export$d54c183f56e39aa5 = 'crossFlowSupport';
const $72e9c1ae9f44f56d$export$e5c2c058fa8068a6 = 'uiInitialized';
const $72e9c1ae9f44f56d$export$e67cdcb8867a3bd0 = 'openInvoked';

});


parcelRegister("5DeAW", function(module, exports) {

$parcel$export(module.exports, "enrichWithPackageDetails", () => $614a6b9cd83acb07$export$59518efab336a8b5);
const $614a6b9cd83acb07$var$version = "0.0.0-use.local";
const $614a6b9cd83acb07$export$84f9cf7ef89d4c26 = {
    version: $614a6b9cd83acb07$var$version
};
const $614a6b9cd83acb07$export$59518efab336a8b5 = (event)=>{
    const attributes = {
        ...event.attributes || {},
        crossFlowSupport: $614a6b9cd83acb07$export$84f9cf7ef89d4c26
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("7wx9T", function(module, exports) {

$parcel$export(module.exports, "enrichWithRequestOptions", () => $765cc5449b706059$export$a5a156dc5df42f0);
const $765cc5449b706059$export$a5a156dc5df42f0 = (event, requestOptions)=>{
    if (!requestOptions) return event;
    const attributes = {
        // Spread the extra analytics attributes first, because we don't want consumers to override any event attributes below
        ...requestOptions.extraAnalyticsAttributes || {},
        ...event.attributes || {},
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("nVfTN", function(module, exports) {

let $047e8fd566c6059b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $047e8fd566c6059b$var$load("7vqGd"),
    $047e8fd566c6059b$var$load("1Y4bq"),
    $047e8fd566c6059b$var$load("1VRB2"),
    $047e8fd566c6059b$var$load("bABhq"),
    $047e8fd566c6059b$var$load("89s5w")
]).then(()=>parcelRequire('n7rqo'));

});



parcelRegister("lXldF", function(module, exports) {

$parcel$export(module.exports, "getContainersPlugin", () => $5b0f94b5f2363f0d$export$81d1d40061d190bc);
parcelRequire("2cz7v");
var $1GCwR = parcelRequire("1GCwR");
var $2cz7v = parcelRequire("2cz7v");

var $aYncF = parcelRequire("aYncF");
const $5b0f94b5f2363f0d$var$getCloudId = async ()=>{
    const { cloudName: cloudName, cloudId: cloudId } = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const containers = [
        {
            id: cloudId,
            displayName: cloudName,
            type: (0, $1GCwR.ContainerTypes).ATLASSIAN_CLOUD_ID
        }
    ];
    return {
        type: (0, $1GCwR.ContainerTypes).ATLASSIAN_CLOUD_ID,
        containers: containers
    };
};
const $5b0f94b5f2363f0d$export$81d1d40061d190bc = (0, $2cz7v.createGetContainersPlugin)($5b0f94b5f2363f0d$var$getCloudId);

});
parcelRegister("2cz7v", function(module, exports) {

$parcel$export(module.exports, "createGetContainersPlugin", () => $6ef569260daeff0f$export$76378b0f825c024c);
$parcel$export(module.exports, "createGetUsersPlugin", () => $6ef569260daeff0f$export$8feb7eae83cf8cd5);
$parcel$export(module.exports, "ContainerTypes", () => (parcelRequire("1GCwR")).ContainerTypes);
$parcel$export(module.exports, "UserIdTypes", () => (parcelRequire("1GCwR")).UserIdTypes);

var $1GCwR = parcelRequire("1GCwR");
const $6ef569260daeff0f$export$76378b0f825c024c = (fetch)=>{
    return [
        (0, $1GCwR.PluginTypes).GetContainers,
        fetch
    ];
};
const $6ef569260daeff0f$export$8feb7eae83cf8cd5 = (fetch)=>{
    return [
        (0, $1GCwR.PluginTypes).GetUsers,
        fetch
    ];
};
const $6ef569260daeff0f$export$21d120847be2aff4 = (fetch)=>{
    return [
        (0, $1GCwR.PluginTypes).GetSuggestedSiteNames,
        fetch
    ];
};
const $6ef569260daeff0f$export$d7c1699c6a2ca18a = (fetch)=>{
    return [
        (0, $1GCwR.PluginTypes).GetAvailableSites,
        fetch
    ];
};

});
parcelRegister("1GCwR", function(module, exports) {

$parcel$export(module.exports, "PluginTypes", () => $0ad6a0dc40b5eeae$export$a235a73f7b906dce);
$parcel$export(module.exports, "ContainerTypes", () => $0ad6a0dc40b5eeae$export$6e383182a26455ff);
$parcel$export(module.exports, "UserIdTypes", () => $0ad6a0dc40b5eeae$export$e391bab95adb8396);
// Data Plugin definition and utility types
const $0ad6a0dc40b5eeae$export$a235a73f7b906dce = {
    GetContainers: 'GetContainers',
    GetUsers: 'GetUsers',
    GetSuggestedSiteNames: 'GetSuggestedSiteNames',
    GetAvailableSites: 'GetAvailableSites'
};
const $0ad6a0dc40b5eeae$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: 'bitbucket-workspace',
    ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
    JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
};
const $0ad6a0dc40b5eeae$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
    TRELLO_ID: 'TRELLO_ID'
};
const $0ad6a0dc40b5eeae$export$4f378ba35c571906 = {
    JIRA_BUSINESS: 'JIRA_BUSINESS',
    JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
    JIRA_SOFTWARE: 'JIRA_SOFTWARE',
    CONFLUENCE: 'CONFLUENCE',
    OPSGENIE: 'OPSGENIE',
    BITBUCKET: 'BITBUCKET',
    STATUSPAGE: 'STATUSPAGE',
    TRELLO: 'TRELLO',
    COMPASS: 'COMPASS'
};

});



parcelRegister("kFfY1", function(module, exports) {

$parcel$export(module.exports, "getUsersPlugin", () => $14708db97c3990f1$export$7c44908d2777db01);

var $2cz7v = parcelRequire("2cz7v");
var $1GCwR = parcelRequire("1GCwR");
const $14708db97c3990f1$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await fetch(getUsersUrl, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    id: value.id,
                    idType: (0, $1GCwR.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $14708db97c3990f1$export$7c44908d2777db01 = (0, $2cz7v.createGetUsersPlugin)($14708db97c3990f1$var$getUsers);

});


parcelRegister("iOVHp", function(module, exports) {

$parcel$export(module.exports, "ModalContextProvider", () => $0dd8465d29e789ed$export$7c9538f5f3c365e9);

var $eJOHy = parcelRequire("eJOHy");

var $jC5ye = parcelRequire("jC5ye");

var $7lK6t = parcelRequire("7lK6t");
const $0dd8465d29e789ed$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $eJOHy.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $eJOHy.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $0dd8465d29e789ed$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $eJOHy.useRef)(1);
    const [modals, setModals] = (0, $eJOHy.useState)([]);
    const modalContext = (0, $eJOHy.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7lK6t.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jC5ye.default), null, modals.map((modal)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0dd8465d29e789ed$var$RenderModal, {
            key: modal.key,
            modal: modal
        });
    })));
}

});



parcelRegister("2pOx9", function(module, exports) {

$parcel$export(module.exports, "UserContainers", () => $291f37c68c8832ac$export$c1b371eec908681a);

var $eJOHy = parcelRequire("eJOHy");

var $exvGe = parcelRequire("exvGe");

var $c9f6v = parcelRequire("c9f6v");
const $291f37c68c8832ac$export$c1b371eec908681a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9f6v.UserContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $exvGe.UserPreferencesContainer), {
        isGlobal: true
    }, children));

});
parcelRegister("exvGe", function(module, exports) {

$parcel$export(module.exports, "UserPreferencesContainer", () => $32653931dc796f02$export$aa278641ded1adf);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $ht3nQ = parcelRequire("ht3nQ");

var $6Wa1P = parcelRequire("6Wa1P");
const $32653931dc796f02$export$be74e04eaea4530 = (0, $ht3nQ.createSubscriber)((0, $6Wa1P.default), {
    displayName: 'UserPreferencesSubscriber'
});
const $32653931dc796f02$export$aa278641ded1adf = (0, $6E16M.createContainer)((0, $6Wa1P.default));

});
parcelRegister("6Wa1P", function(module, exports) {

$parcel$export(module.exports, "default", () => $10c3f4f356fe3b4a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $GtRbT = parcelRequire("GtRbT");

var $8XoVi = parcelRequire("8XoVi");
const $10c3f4f356fe3b4a$var$initialState = {
    'issue-view-experiment': {
        data: {
            value: false
        },
        loading: false,
        error: null
    }
};
var // @ts-expect-error - TS2344 - Type 'typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/user-preferences/src/actions/index")' does not satisfy the constraint 'Record<string, ActionThunk<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/user-preferences/src/actions/index")>>'.
$10c3f4f356fe3b4a$export$2e2bcd8739ae039 = (0, $GtRbT.createStore)({
    name: 'user-preference',
    initialState: $10c3f4f356fe3b4a$var$initialState,
    actions: $8XoVi
});

});
parcelRegister("8XoVi", function(module, exports) {

$parcel$export(module.exports, "fetch", () => (parcelRequire("1VzWr")).default);
$parcel$export(module.exports, "fetchIssueCreate", () => (parcelRequire("3PeHv")).default);
$parcel$export(module.exports, "updateExperiment", () => (parcelRequire("eSwk7")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $1VzWr = parcelRequire("1VzWr");

var $3PeHv = parcelRequire("3PeHv");

var $eSwk7 = parcelRequire("eSwk7");

});
parcelRegister("1VzWr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2074ff714333c08$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6Gokh = parcelRequire("6Gokh");
var /**
 * Initiates data retrieval for a user preference, ensuring no duplicate requests are made.
 * Updates the application state with retrieved data or an error, accordingly.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$e2074ff714333c08$export$2e2bcd8739ae039 = (preferenceKey)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'.
        if (currentState[preferenceKey] && currentState[preferenceKey].loading) return;
        setState({
            [preferenceKey]: {
                data: currentState.data,
                loading: true,
                error: null
            }
        });
        try {
            const data = await (0, $6Gokh.default)({
                preferenceKey: preferenceKey
            });
            setState({
                [preferenceKey]: {
                    data: data,
                    loading: false,
                    error: null
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                [preferenceKey]: {
                    data: getState().data,
                    loading: false,
                    error: err
                }
            });
        }
    };

});
parcelRegister("6Gokh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9dd397dac673eb5$export$2e2bcd8739ae039);

var $j4vKK = parcelRequire("j4vKK");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d9dd397dac673eb5$export$2e2bcd8739ae039 = async ({ preferenceKey: preferenceKey })=>{
    try {
        const result = await (0, $j4vKK.fetchData)(preferenceKey);
        return {
            value: result
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        if (e.statusCode === 404) return {
            value: undefined
        };
        throw e;
    }
};

});
parcelRegister("j4vKK", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $d0f15c4264be95bd$export$8134c072fddab6a5);

var $jGzN3 = parcelRequire("jGzN3");
const $d0f15c4264be95bd$export$8134c072fddab6a5 = (key)=>{
    const requestUrl = `/rest/api/3/mypreferences?key=${key}`;
    return (0, $jGzN3.performGetRequest)(requestUrl);
};

});



parcelRegister("3PeHv", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa84bc4b0ad6e6a2$export$2e2bcd8739ae039);

var $1VzWr = parcelRequire("1VzWr");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aa84bc4b0ad6e6a2$export$2e2bcd8739ae039 = ()=>(0, $1VzWr.default)('issue-create');

});

parcelRegister("eSwk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $480202df9bc0845f$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$480202df9bc0845f$export$2e2bcd8739ae039 = (experimentKey, value)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: { data: { value: boolean; }; loading: false; error: null; }; }' is not assignable to parameter of type 'Partial<State>'.
        setState({
            [experimentKey]: {
                data: {
                    value: value
                },
                loading: false,
                error: null
            }
        });
    };

});





parcelRegister("gOC9D", function(module, exports) {

$parcel$export(module.exports, "LinkingProviders", () => $e619cded00452e61$export$a7964d2bf9ff001);

var $eJOHy = parcelRequire("eJOHy");

var $eF8Gn = parcelRequire("eF8Gn");

var $2aY2d = parcelRequire("2aY2d");

var $7jTnu = parcelRequire("7jTnu");

var $6bLlX = parcelRequire("6bLlX");

var $idqmr = parcelRequire("idqmr");
const $e619cded00452e61$export$a7964d2bf9ff001 = ({ children: children })=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    const product = $e619cded00452e61$var$getProductForSmartCardProvider(data);
    const atlassianIntelligenceProps = (0, $eJOHy.useMemo)(()=>{
        if (!(0, $7jTnu.fg)('jira-cc-ai-snippet-gate') || !data?.isAIEnabled) return {};
        return {
            renderers: {
                snippet: (0, $idqmr.JiraSnippetRenderer)
            }
        };
    }, [
        data?.isAIEnabled
    ]);
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $7jTnu.fg)('jira-glance-panel') && (0, $7jTnu.fg)('jira_preview_panel_m_1_rollout')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const smartCardProviderProps = (0, $6bLlX.useGlobalObjectPreviewPanels)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eF8Gn.SmartCardProvider), {
            ...smartCardProviderProps,
            product: product,
            isAdminHubAIEnabled: data?.isAIEnabled ?? false,
            ...atlassianIntelligenceProps
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eF8Gn.SmartCardProvider), {
        product: product,
        isAdminHubAIEnabled: data?.isAIEnabled ?? false,
        ...atlassianIntelligenceProps
    }, children);
};
const $e619cded00452e61$var$getProductForSmartCardProvider = (project)=>{
    switch(project?.projectType){
        case 'software':
            return 'JSW';
        case 'business':
            return 'JWM';
        case 'service_desk':
            return 'JSM';
        case 'product_discovery':
            return 'JPD';
        default:
            return undefined;
    }
};

});
parcelRegister("eF8Gn", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $7dac66447cdd5bfb$export$497ecb0280204df4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7HHI1 = parcelRequire("7HHI1");

var $1O6Yz = parcelRequire("1O6Yz");

var $1ok3x = parcelRequire("1ok3x");

var $3rFoe = parcelRequire("3rFoe");

var $52nW6 = parcelRequire("52nW6");

var $7aAkp = parcelRequire("7aAkp");

var $1FJdc = parcelRequire("1FJdc");
function $7dac66447cdd5bfb$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel }) {
    const parentContext = (0, $eJOHy.useContext)((0, $7aAkp.SmartCardContext));
    const defaultInitialState = (0, $eJOHy.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $eJOHy.useMemo)(()=>{
        return (0, $7HHI1.createStore)((0, $52nW6.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $eJOHy.useMemo)(()=>{
        const client = customClient || new (0, $1FJdc.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, // @deprecated The support for platform will be removed and default to `web`
        platform)=>{
            const cardState = (0, $1ok3x.getUrl)(store, url);
            return cardState.details ? (0, $3rFoe.extractSmartLinkEmbed)(cardState.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        };
    }, [
        customAuthFlow,
        customClient,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        store
    ]);
    const value = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7aAkp.SmartCardContext).Provider, {
        value: value,
        children: children
    });
}
var $7dac66447cdd5bfb$export$2e2bcd8739ae039 = $7dac66447cdd5bfb$export$497ecb0280204df4;

});
parcelRegister("1ok3x", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $b9cc5cdaa584a743$export$94df0e59ebebf4a7);
const $b9cc5cdaa584a743$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("3rFoe", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkTitle", () => $0ba58418755fd795$export$3eda18658b66108);
$parcel$export(module.exports, "extractSmartLinkUrl", () => $0ba58418755fd795$export$7ba9b12c6a1b73de);
$parcel$export(module.exports, "extractSmartLinkAri", () => $0ba58418755fd795$export$16b02be3e2bb31ad);
$parcel$export(module.exports, "extractSmartLinkEmbed", () => $0ba58418755fd795$export$864b719baf5d744d);
$parcel$export(module.exports, "extractSmartLinkProvider", () => $0ba58418755fd795$export$ff753ed519e96e9e);
$parcel$export(module.exports, "extractSmartLinkCreatedOn", () => $0ba58418755fd795$export$7a685df468cbf38f);
$parcel$export(module.exports, "extractSmartLinkModifiedOn", () => $0ba58418755fd795$export$75047940e157fd1f);
$parcel$export(module.exports, "extractSmartLinkCreatedBy", () => $0ba58418755fd795$export$242875b46118beb2);
$parcel$export(module.exports, "extractSmartLinkAuthorGroup", () => $0ba58418755fd795$export$41fc716e1bc2dc90);
$parcel$export(module.exports, "extractSmartLinkModifiedBy", () => $0ba58418755fd795$export$7f099a839071a190);
$parcel$export(module.exports, "extractSmartLinkDownloadUrl", () => $0ba58418755fd795$export$96ed4c1b14ac210a);

var $3ChdD = parcelRequire("3ChdD");
var $3pkPB = parcelRequire("3pkPB");
var $3J5h6 = parcelRequire("3J5h6");
var $2B48d = parcelRequire("2B48d");
var $dZPRN = parcelRequire("dZPRN");
var $ewN3T = parcelRequire("ewN3T");
var $mioNk = parcelRequire("mioNk");
var $gIdC1 = parcelRequire("gIdC1");

var $2p6FD = parcelRequire("2p6FD");

var $Y08NT = parcelRequire("Y08NT");
const $0ba58418755fd795$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ((0, $Y08NT.isEntityPresent)(response)) return (0, $Y08NT.extractEntity)(response)?.displayName;
    return (0, $gIdC1.extractTitle)(response?.data, removeTextHighlightingFromTitle);
};
const $0ba58418755fd795$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $Y08NT.isEntityPresent)(response)) return (0, $Y08NT.extractEntity)(response)?.url;
    return (0, $2B48d.extractLink)(response?.data);
};
const $0ba58418755fd795$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $Y08NT.isEntityPresent)(response)) return (0, $Y08NT.extractEntity)(response)?.ari || (0, $Y08NT.extractEntity)(response)?.thirdPartyAri;
    const data = response?.data;
    return (0, $3ChdD.extractAri)(data);
};
const $0ba58418755fd795$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $Y08NT.isEntityPresent)(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = (0, $Y08NT.extractEntityEmbedUrl)(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return (0, $2p6FD.extractPreview)(response?.data, 'web', iframeUrlType);
};
const $0ba58418755fd795$export$ff753ed519e96e9e = (response)=>{
    if ((0, $Y08NT.isEntityPresent)(response)) return (0, $Y08NT.extractEntityProvider)(response);
    return response?.data && (0, $mioNk.extractProvider)(response?.data);
};
const $0ba58418755fd795$export$7a685df468cbf38f = (response)=>{
    if ((0, $Y08NT.isEntityPresent)(response)) return (0, $Y08NT.extractEntity)(response)?.createdAt;
    return response?.data && (0, $3pkPB.extractDateCreated)(response.data);
};
const $0ba58418755fd795$export$75047940e157fd1f = (response)=>{
    if ((0, $Y08NT.isEntityPresent)(response)) return (0, $Y08NT.extractEntity)(response)?.lastUpdatedAt;
    return response?.data && (0, $3J5h6.extractDateUpdated)(response.data);
};
const $0ba58418755fd795$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $Y08NT.isEntityPresent)(response)) return (0, $Y08NT.extractEntity)(response)?.createdBy?.displayName;
    const persons = (0, $dZPRN.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $0ba58418755fd795$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $Y08NT.isEntityPresent)(response)) {
        const entity = (0, $Y08NT.extractEntity)(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $dZPRN.extractPersonCreatedBy)(response.data);
};
const $0ba58418755fd795$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $Y08NT.isEntityPresent)(response)) return (0, $Y08NT.extractEntity)(response)?.lastUpdatedBy?.displayName;
    const person = (0, $ewN3T.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
const $0ba58418755fd795$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $Y08NT.isEntityPresent)(response)) {
        const entity = (0, $Y08NT.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};

});
parcelRegister("3ChdD", function(module, exports) {

$parcel$export(module.exports, "extractAri", () => $0f6853655ff8fd36$export$be18a6294fd426ec);
const $0f6853655ff8fd36$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
};

});

parcelRegister("3pkPB", function(module, exports) {

$parcel$export(module.exports, "extractDateCreated", () => $60168dd5bb9f0dda$export$e1226a5e0bbbf862);
const $60168dd5bb9f0dda$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
};

});

parcelRegister("3J5h6", function(module, exports) {

$parcel$export(module.exports, "extractDateUpdated", () => $acec268ad73f3e95$export$7fc2f5e6f9d22ae7);
const $acec268ad73f3e95$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
};

});

parcelRegister("2B48d", function(module, exports) {

$parcel$export(module.exports, "extractLink", () => $3a56a8e0fb6b32b2$export$63f54cf4c5883620);

var $cmpmn = parcelRequire("cmpmn");
const $3a56a8e0fb6b32b2$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $cmpmn.extractUrlFromLinkJsonLd)(url);
    }
};

});
parcelRegister("cmpmn", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $edefe21c02d28557$export$396ba4ef2e37dc65);
const $edefe21c02d28557$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $edefe21c02d28557$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("dZPRN", function(module, exports) {

$parcel$export(module.exports, "extractPersonCreatedBy", () => $7135f4de5148adfc$export$a66235cba0c9d11a);

var $lVngh = parcelRequire("lVngh");
const $7135f4de5148adfc$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $lVngh.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $lVngh.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
};

});
parcelRegister("lVngh", function(module, exports) {

$parcel$export(module.exports, "extractPersonFromJsonLd", () => $16dc0eae5e29259c$export$c471ae5fddcf1392);

var $fffDh = parcelRequire("fffDh");
const $16dc0eae5e29259c$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $fffDh.extractUrlFromIconJsonLd)(person.icon)
        };
    }
};

});
parcelRegister("fffDh", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $39b4afc5df4881ff$export$67f3d92c824fd850);

var $cmpmn = parcelRequire("cmpmn");
const $39b4afc5df4881ff$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $cmpmn.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $cmpmn.extractUrlFromLinkJsonLd)(icon.url);
    }
};

});



parcelRegister("ewN3T", function(module, exports) {

$parcel$export(module.exports, "extractPersonUpdatedBy", () => $e8b3a7dd6bc27ac9$export$8a2d1ed7e6f336f0);

var $lVngh = parcelRequire("lVngh");
const $e8b3a7dd6bc27ac9$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $lVngh.extractPersonFromJsonLd)(updatedBy);
};

});

parcelRegister("mioNk", function(module, exports) {

$parcel$export(module.exports, "extractProvider", () => $fe28922d89c4c113$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $fe28922d89c4c113$export$6fb636a2ac885215);
$parcel$export(module.exports, "isConfluenceGenerator", () => $fe28922d89c4c113$export$38df542ff03a4183);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8uw8h = parcelRequire("8uw8h");

var $8uw8h = parcelRequire("8uw8h");


var $fffDh = parcelRequire("fffDh");
var $cmpmn = parcelRequire("cmpmn");
const $fe28922d89c4c113$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $fe28922d89c4c113$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $fe28922d89c4c113$var$extractProviderImage(generator.image)
            };
        }
    }
};
const $fe28922d89c4c113$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $2dc5f8dfac97a472$export$cee224b5de4d6d66)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
        else if (id === (0, $2dc5f8dfac97a472$export$f654d825189934a7)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.JiraIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
    }
    if (icon) return (0, $fffDh.extractUrlFromIconJsonLd)(icon);
};
const $fe28922d89c4c113$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $cmpmn.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $cmpmn.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};
const $fe28922d89c4c113$export$38df542ff03a4183 = (id)=>{
    return id === (0, $2dc5f8dfac97a472$export$cee224b5de4d6d66);
};

});
const $2dc5f8dfac97a472$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $2dc5f8dfac97a472$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $2dc5f8dfac97a472$export$84a73a0383f58180 = 'JiraTask';
const $2dc5f8dfac97a472$export$c6c83963a9378a67 = 'JiraSubTask';
const $2dc5f8dfac97a472$export$58af3c426c111a6d = 'JiraStory';
const $2dc5f8dfac97a472$export$ac9898a63417219e = 'JiraBug';
const $2dc5f8dfac97a472$export$54db5e3fb12e39cd = 'JiraEpic';
const $2dc5f8dfac97a472$export$2f54a5a217202c85 = 'JiraIncident';
const $2dc5f8dfac97a472$export$d097371052bfc411 = 'JiraServiceRequest';
const $2dc5f8dfac97a472$export$efd9452ad16c6676 = 'JiraChange';
const $2dc5f8dfac97a472$export$2e7e70abb5d81f67 = 'JiraProblem';
const $2dc5f8dfac97a472$export$ce25cfc40b280dbc = 'JiraCustomTaskType';


parcelRegister("gIdC1", function(module, exports) {

$parcel$export(module.exports, "extractTitle", () => $5b786b1792eac561$export$b05803156e5015b6);

var $kyS4m = parcelRequire("kyS4m");

var $hMIGE = parcelRequire("hMIGE");
const $5b786b1792eac561$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $kyS4m.extractContext)(jsonLd);
    const type = (0, $hMIGE.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};

});
parcelRegister("kyS4m", function(module, exports) {

$parcel$export(module.exports, "extractContext", () => $3e0938d1636c3760$export$efdbd45f3e77a161);

var $hMIGE = parcelRequire("hMIGE");

var $fffDh = parcelRequire("fffDh");
const $3e0938d1636c3760$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $fffDh.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $hMIGE.extractType)(context)
            };
        }
    }
};

});
parcelRegister("hMIGE", function(module, exports) {

$parcel$export(module.exports, "extractType", () => $b5da9fd36250f536$export$2e9ae379995d99e3);
const $b5da9fd36250f536$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
};

});



parcelRegister("2p6FD", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $2285ff74aae43617$export$4b0d98b1b7f6d115);

var $e4IRJ = parcelRequire("e4IRJ");

var $cmpmn = parcelRequire("cmpmn");
const $2285ff74aae43617$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $e4IRJ.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $cmpmn.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $cmpmn.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("e4IRJ", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $6124e4e872338eea$export$3e8ad908070b68b2);
const $6124e4e872338eea$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});


parcelRegister("Y08NT", function(module, exports) {

$parcel$export(module.exports, "extractEntity", () => $7f49044a966f0e71$export$8beff7405d020ddf);
$parcel$export(module.exports, "isEntityPresent", () => $7f49044a966f0e71$export$c7168210b81d9383);
$parcel$export(module.exports, "extractEntityEmbedUrl", () => $7f49044a966f0e71$export$f97663ee76ac5b24);
$parcel$export(module.exports, "extractEntityProvider", () => $7f49044a966f0e71$export$ad879f2c9d5100a0);
$parcel$export(module.exports, "extractEntityIcon", () => $7f49044a966f0e71$export$19346520e937a99f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8uw8h = parcelRequire("8uw8h");

var $8uw8h = parcelRequire("8uw8h");

const $7f49044a966f0e71$export$8beff7405d020ddf = (response)=>response?.entityData;
const $7f49044a966f0e71$export$c7168210b81d9383 = (response)=>Boolean($7f49044a966f0e71$export$8beff7405d020ddf(response));
const $7f49044a966f0e71$export$f97663ee76ac5b24 = (response)=>{
    const entity = $7f49044a966f0e71$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $7f49044a966f0e71$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $2dc5f8dfac97a472$export$cee224b5de4d6d66:
            providerIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.ConfluenceIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        case 0, $2dc5f8dfac97a472$export$f654d825189934a7:
            providerIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.JiraIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url
    };
};
const $7f49044a966f0e71$export$19346520e937a99f = (response)=>{
    const entity = $7f49044a966f0e71$export$8beff7405d020ddf(response);
    let url;
    if (entity) url = 'iconUrl' in entity && typeof entity?.iconUrl === 'string' ? entity.iconUrl : response?.meta.generator?.icon?.url;
    return {
        url: url,
        label: entity?.displayName
    };
};

});


parcelRegister("52nW6", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $a28fc5cbb34b335c$export$3c7c3113a97b6492);

var $eFmhx = parcelRequire("eFmhx");
var $czLUE = parcelRequire("czLUE");
const $a28fc5cbb34b335c$var$isCardAction = (action)=>{
    return [
        (0, $eFmhx.ACTION_PENDING),
        (0, $eFmhx.ACTION_RESOLVING),
        (0, $eFmhx.ACTION_RESOLVED),
        (0, $eFmhx.ACTION_RELOADING),
        (0, $eFmhx.ACTION_ERROR),
        (0, $eFmhx.ACTION_ERROR_FALLBACK),
        (0, $eFmhx.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $a28fc5cbb34b335c$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $czLUE.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $a28fc5cbb34b335c$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $eFmhx.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $eFmhx.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $eFmhx.ACTION_RESOLVED:
            return $a28fc5cbb34b335c$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $eFmhx.ACTION_RELOADING:
            return $a28fc5cbb34b335c$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $eFmhx.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $eFmhx.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $eFmhx.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $a28fc5cbb34b335c$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$a28fc5cbb34b335c$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $a28fc5cbb34b335c$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("eFmhx", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $97b1f20771a07d2b$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $97b1f20771a07d2b$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $97b1f20771a07d2b$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $97b1f20771a07d2b$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $97b1f20771a07d2b$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $97b1f20771a07d2b$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $97b1f20771a07d2b$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $97b1f20771a07d2b$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $97b1f20771a07d2b$export$6e470aad5ba8952e = 'pending';
const $97b1f20771a07d2b$export$9a6a932a0a39498e = 'resolving';
const $97b1f20771a07d2b$export$63ec8bc7a8a75482 = 'resolved';
const $97b1f20771a07d2b$export$b8cfaa842c9ab487 = 'reloading';
const $97b1f20771a07d2b$export$6d8ed3f9433dd372 = 'errored';
const $97b1f20771a07d2b$export$cfbbb7126bc8a0c6 = 'fallback';
const $97b1f20771a07d2b$export$76b5c1aca20759c6 = 'preload';
const $97b1f20771a07d2b$export$2c5edb971b673330 = 'metadata';
const $97b1f20771a07d2b$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("czLUE", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $64fb226577801a4c$export$b70265791d2079d4);
const $64fb226577801a4c$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $64fb226577801a4c$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $64fb226577801a4c$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("7aAkp", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $69bece72476480ca$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $69bece72476480ca$export$e1d190b530cf0ee9);
$parcel$export(module.exports, "useSmartCardContext", () => $69bece72476480ca$export$10e9cca30e50f657);
$parcel$export(module.exports, "EditorSmartCardProviderValueGuard", () => $69bece72476480ca$export$797e3658f090919c);
$parcel$export(module.exports, "EditorSmartCardProvider", () => $69bece72476480ca$export$2a29ca11e08dc129);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

const $69bece72476480ca$export$156b523e63b4f63a = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
function $69bece72476480ca$export$e1d190b530cf0ee9() {
    const context = (0, $eJOHy.useContext)($69bece72476480ca$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $69bece72476480ca$export$10e9cca30e50f657 = ()=>$69bece72476480ca$var$useContextMemoized($69bece72476480ca$export$156b523e63b4f63a);
const $69bece72476480ca$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $69bece72476480ca$export$10e9cca30e50f657();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};
function $69bece72476480ca$var$useContextMemoized(reactContext) {
    const value = (0, $eJOHy.useContext)(reactContext);
    const context = (0, $eJOHy.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $69bece72476480ca$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $69bece72476480ca$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Provider, {
        value: cardContext.value,
        children: children
    });
};
var $69bece72476480ca$export$2e2bcd8739ae039 = $69bece72476480ca$export$156b523e63b4f63a;

});

parcelRegister("1FJdc", function(module, exports) {

$parcel$export(module.exports, "default", () => $640929609833b1e4$export$2e2bcd8739ae039);

var $79KwK = parcelRequire("79KwK");

var $caODW = parcelRequire("caODW");

var $6lERA = parcelRequire("6lERA");

var $7sKFl = parcelRequire("7sKFl");

var $9zZgx = parcelRequire("9zZgx");
var $fjDLw = parcelRequire("fjDLw");
var $czLUE = parcelRequire("czLUE");
var $dk2Up = parcelRequire("dk2Up");

var $aOj8V = parcelRequire("aOj8V");

var $7xkt0 = parcelRequire("7xkt0");

var $jOCpp = parcelRequire("jOCpp");

var $8XtVW = parcelRequire("8XtVW");
const $640929609833b1e4$var$MAX_BATCH_SIZE = 50;
const $640929609833b1e4$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $640929609833b1e4$var$URL_RESPONSE_CACHE_SIZE = 100;
const $640929609833b1e4$export$d6a66073b5d79eb3 = new (0, $7xkt0.LRUMap)($640929609833b1e4$var$URL_RESPONSE_CACHE_SIZE);
class $640929609833b1e4$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($jOCpp)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...(0, $caODW.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $dk2Up.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $dk2Up.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $aOj8V.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...(0, $caODW.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $dk2Up.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $dk2Up.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $aOj8V.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>resource.resourceUrl);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $fjDLw.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    /**
	 * Set custom headers to be sent with each request to the resolver.
	 *
	 * @param headers - Object containing headers to be sent with each request.
	 */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($7sKFl)))({
            limit: 1,
            interval: $640929609833b1e4$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $640929609833b1e4$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($7sKFl)))({
            limit: 1,
            interval: $640929609833b1e4$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $640929609833b1e4$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $640929609833b1e4$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            if ((0, $8XtVW.fg)('platform_linking_force_no_cache_smart_card_client')) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined
                });
            } else responsePromise = loader.load(url);
            $640929609833b1e4$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $640929609833b1e4$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $aOj8V.isSuccessfulResponse)(response) || (0, $czLUE.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $640929609833b1e4$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $aOj8V.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($6lERA)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $aOj8V.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $aOj8V.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($6lERA)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $aOj8V.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $dk2Up.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $dk2Up.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $aOj8V.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $dk2Up.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $dk2Up.NetworkError)) return new (0, $9zZgx.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $9zZgx.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $9zZgx.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    return new (0, $9zZgx.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $9zZgx.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $9zZgx.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("79KwK", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $535d76fea738a4fd$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $535d76fea738a4fd$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $535d76fea738a4fd$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $535d76fea738a4fd$var$getValidCacheKeyFn(options);
        this._cacheMap = $535d76fea738a4fd$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $535d76fea738a4fd$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $535d76fea738a4fd$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$535d76fea738a4fd$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $535d76fea738a4fd$var$enqueuePostPromiseJob = typeof $igDjg === 'object' && typeof $igDjg.nextTick === 'function' ? function(fn) {
    if (!$535d76fea738a4fd$var$resolvedPromise) $535d76fea738a4fd$var$resolvedPromise = Promise.resolve();
    $535d76fea738a4fd$var$resolvedPromise.then(function() {
        $igDjg.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $535d76fea738a4fd$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $535d76fea738a4fd$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $535d76fea738a4fd$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $535d76fea738a4fd$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $535d76fea738a4fd$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $535d76fea738a4fd$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $535d76fea738a4fd$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$535d76fea738a4fd$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $535d76fea738a4fd$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $535d76fea738a4fd$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $535d76fea738a4fd$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $535d76fea738a4fd$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $535d76fea738a4fd$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $535d76fea738a4fd$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $535d76fea738a4fd$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $535d76fea738a4fd$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $535d76fea738a4fd$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $535d76fea738a4fd$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $535d76fea738a4fd$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $535d76fea738a4fd$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $535d76fea738a4fd$var$DataLoader;

});

parcelRegister("caODW", function(module, exports) {

$parcel$export(module.exports, "expValEquals", () => $edff9721098cfc1a$export$45abdb3f977b5b14);

var $hLozS = parcelRequire("hLozS");
function $edff9721098cfc1a$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $hLozS.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("hLozS", function(module, exports) {

$parcel$export(module.exports, "expValEqualsInternal", () => $435f6918af1e7300$export$58e581060588c6bb);

var $21HMC = parcelRequire("21HMC");

var $kbFHF = parcelRequire("kbFHF");
function $435f6918af1e7300$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $kbFHF._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $kbFHF._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $21HMC.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $21HMC.default).getExperimentValue(experimentName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("kbFHF", function(module, exports) {

$parcel$export(module.exports, "_overrides", () => $9d4502c203dcd78f$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $9d4502c203dcd78f$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $9d4502c203dcd78f$export$cf7305fc65acbf0d);
$parcel$export(module.exports, "setupEditorExperiments", () => $9d4502c203dcd78f$export$1c2b6dbf79eb3560);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $jX9uz = parcelRequire("jX9uz");

var $gZFmM = parcelRequire("gZFmM");
let $9d4502c203dcd78f$export$e5d73bf4f8e2ae96 = {};
let $9d4502c203dcd78f$export$4e849416bb5c5b52 = {};
let $9d4502c203dcd78f$export$cf7305fc65acbf0d;
function $9d4502c203dcd78f$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $jX9uz.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $9d4502c203dcd78f$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test') {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        const testOverrides = Object.fromEntries(Object.entries((0, $jX9uz.editorExperimentsConfig)).map(([key, value])=>{
            const defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                groupOverrides?.[key] ?? (0, $gZFmM.testMultivariateOverrides)[key] ?? (0, $gZFmM.testBooleanOverrides)[key] ?? defaultValue
            ];
        }));
        $9d4502c203dcd78f$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $9d4502c203dcd78f$export$cf7305fc65acbf0d = product;
    $9d4502c203dcd78f$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("jX9uz", function(module, exports) {

$parcel$export(module.exports, "editorExperimentsConfig", () => $441cfeabbd2aa475$export$6cbb856f286b07ef);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $28E3Q = parcelRequire("28E3Q");
const $441cfeabbd2aa475$export$6cbb856f286b07ef = {
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_memoized_node_check: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_memoized_node_check'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_media_card_vc_wrapper_attribute: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_card_vc_wrapper_attribute'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_prevent_numbered_column_too_big_jira_1: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            jira: 'editor_prevent_numbered_column_too_big_jira_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_control_optimise_render'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $28E3Q.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-28
    platform_editor_controls_performance_fixes: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_performance_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $28E3Q.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $28E3Q.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-01
    platform_editor_controls_block_controls_state_fix: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_block_controls_state_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_smart_link_cmd_ctrl_click: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smart_link_cmd_ctrl_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 28-02-2025
    platform_editor_insertion: (0, $28E3Q.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_insertion'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_vanilla_dom/setup
    platform_editor_vanilla_dom: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vanilla_dom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $28E3Q.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    editor_ai_inline_suggestion_date_v2: (0, $28E3Q.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_ai_inline_suggestion_date_v2'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    platform_editor_usesharedpluginstatewithselector: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstatewithselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_media_floating_toolbar_early_exit: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_floating_toolbar_early_exit'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_stop_width_reflows: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_stop_width_reflows'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-08
    platform_editor_core_static_emotion: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_emotion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-11
    platform_editor_core_static_emotion_non_central: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_emotion_non_central'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-14
    platform_editor_jira_advanced_code_blocks: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_jira_advanced_code_blocks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-21
    platform_editor_nodevisibility: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nodevisibility'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-28
    platform_editor_toolbar_rerender_optimization_exp: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_rerender_optimization_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_fold_gutter'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-18
    platform_editor_ai_iw_adf_streaming: (0, $28E3Q.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf',
            'adf_personalisation'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-18
    platform_editor_ai_ct_sg_adf_streaming: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_ct_sg_adf_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-20
    platform_editor_ai_non_iw_adf_streaming: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_non_iw_adf_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_ai_remove_trivial_prompts_cc: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_remove_trivial_prompts_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-25
    platform_editor_extension_styles: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_extension_styles'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-20
    confluence_whiteboards_quick_insert_aa: (0, $28E3Q.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    confluence_whiteboards_quick_insert: (0, $28E3Q.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // added out of order to avoid known conflict that will occur otherwise
    // Added 2025-07-11
    cc_editor_ufo_hold_table_till_resize_complete: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_ufo_hold_table_till_resize_complete'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_feedback_mandatory_rating'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_drag_handle_aria_label: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_drag_handle_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_toggle_expand_on_match_found: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toggle_expand_on_match_found'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_smart_card_otp: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smart_card_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_responsiveness'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_linking_exp',
            jira: 'platform_editor_preview_panel_linking_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $28E3Q.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    platform_editor_renderer_breakout_fix: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_breakout_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_enghealth_hyperlink_toolbar_aria_values: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enghealth_hyperlink_toolbar_aria_values'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-011
    cc_editor_interactions_trigger_traceufointeraction: (0, $28E3Q.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_interactions_trigger_traceufointeraction'
        },
        param: 'cohort',
        values: [
            'control',
            'all_events',
            'only_mousedown_event'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-07-14
    platform_editor_add_orange_highlight_color: (0, $28E3Q.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_orange_highlight_color'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc',
            confluence: 'platform_editor_toolbar_aifc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-08-13
    platform_editor_ai_aifc: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_ai_aifc_jira',
            confluence: 'platform_editor_ai_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-04
    platform_editor_floating_toolbar_button_aria_label: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_floating_toolbar_button_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    platform_editor_enghealth_table_plugin_lable_rule: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enghealth_table_plugin_lable_rule'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-28
    platform_editor_create_link_on_blur: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_create_link_on_blur'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-29
    cc_comments_include_path_for_renderer_emojis: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_comments_include_path_for_renderer_emojis'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_pasting_nested_table_fix: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_pasting_nested_table_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 20205-07-28
    platform_editor_fix_quick_insert_consistency_exp: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_quick_insert_consistency_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_fix_a11y_aria_posinset_0: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_a11y_aria_posinset_0'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-06
    cc_editor_limited_mode: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_limited_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_support: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_tables_scaling_css: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_scaling_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-06
    cc_improve_writing_on_paste: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_improve_writing_on_paste'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_find_replace_a11y_fixes: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_replace_a11y_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-19
    platform_editor_breakout_resizing_vc90_fix: (0, $28E3Q.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing_vc90_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};

});
parcelRegister("28E3Q", function(module, exports) {

$parcel$export(module.exports, "createBooleanExperiment", () => $5e468edca29198bb$export$456f1587c9c92021);
$parcel$export(module.exports, "createMultivariateExperiment", () => $5e468edca29198bb$export$fb89e8a786694d1);

var $561cz = parcelRequire("561cz");
function $5e468edca29198bb$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $561cz.isBoolean),
        defaultValue: config.defaultValue
    };
}
function $5e468edca29198bb$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        typeGuard: (0, $561cz.oneOf)(config.values),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("561cz", function(module, exports) {

$parcel$export(module.exports, "isBoolean", () => $a48d6c1549c06b1c$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $a48d6c1549c06b1c$export$a9a18ae5ba42aeab);
function $a48d6c1549c06b1c$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $a48d6c1549c06b1c$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($a48d6c1549c06b1c$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $a48d6c1549c06b1c$var$IS_TESTING_ENV = false;

});



parcelRegister("gZFmM", function(module, exports) {

$parcel$export(module.exports, "testMultivariateOverrides", () => $4fbcc4ca7dfc9e10$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $4fbcc4ca7dfc9e10$export$54960937bb713f97);
const $4fbcc4ca7dfc9e10$export$7e849a84a00ffd1c = {
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_ai_proactive_ai_nudge_parameters: 'control',
    platform_editor_controls: 'control',
    confluence_whiteboards_quick_insert_aa: 'control',
    confluence_whiteboards_quick_insert: 'control',
    cc_editor_interactions_trigger_traceufointeraction: 'control',
    platform_editor_insertion: 'control',
    editor_ai_inline_suggestion_date_v2: 'control',
    platform_editor_add_orange_highlight_color: 'control',
    platform_editor_ai_iw_adf_streaming: 'control',
    platform_hover_card_preview_panel: 'control'
};
const $4fbcc4ca7dfc9e10$export$54960937bb713f97 = {
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    platform_editor_renderer_breakout_fix: false,
    platform_editor_toolbar_aifc: false,
    platform_editor_memoized_node_check: false,
    platform_editor_media_card_vc_wrapper_attribute: false,
    platform_editor_block_control_optimise_render: false,
    'test-new-experiments-package': false,
    support_table_in_comment: false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_controls_performance_fixes: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    support_table_in_comment_jira: false,
    'nested-tables-in-tables': false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_element_drag_and_drop_multiselect: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_smart_link_cmd_ctrl_click: false,
    platform_editor_vanilla_dom: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_editor_media_floating_toolbar_early_exit: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_stop_width_reflows: false,
    platform_editor_core_static_emotion: false,
    platform_editor_core_static_emotion_non_central: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_nodevisibility: false,
    platform_editor_breakout_resizing: false,
    platform_editor_ai_quickstart_command: false,
    platform_editor_toolbar_rerender_optimization_exp: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_ai_remove_trivial_prompts_cc: false,
    platform_editor_find_and_replace_improvements: false,
    cc_editor_ufo_hold_table_till_resize_complete: false,
    platform_editor_toggle_expand_on_match_found: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    cc_improve_writing_on_paste: false,
    platform_editor_ai_aifc: false
};

});




parcelRegister("6lERA", function(module, exports) {
// Packages

var $gwOtK = parcelRequire("gwOtK");
function $49f466d51d14dc95$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $gwOtK.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $49f466d51d14dc95$var$retry;

});
parcelRegister("gwOtK", function(module, exports) {

module.exports = (parcelRequire("jTUm8"));

});
parcelRegister("jTUm8", function(module, exports) {

var $kGZfu = parcelRequire("kGZfu");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $kGZfu(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("kGZfu", function(module, exports) {
function $f1073d9d808c3152$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $f1073d9d808c3152$var$RetryOperation;
$f1073d9d808c3152$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$f1073d9d808c3152$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$f1073d9d808c3152$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$f1073d9d808c3152$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$f1073d9d808c3152$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$f1073d9d808c3152$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$f1073d9d808c3152$var$RetryOperation.prototype.start = $f1073d9d808c3152$var$RetryOperation.prototype.try;
$f1073d9d808c3152$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$f1073d9d808c3152$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$f1073d9d808c3152$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("7sKFl", function(module, exports) {
'use strict';
class $56ef58d037e115c4$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $56ef58d037e115c4$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $56ef58d037e115c4$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $56ef58d037e115c4$var$pThrottle;
module.exports.AbortError = $56ef58d037e115c4$var$AbortError;

});

parcelRegister("9zZgx", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $98aed17e7a2b4b42$export$3e5b797e39668f84);
class $98aed17e7a2b4b42$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("fjDLw", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $8456044617785227$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $8456044617785227$export$dc37652c1696f231);
const $8456044617785227$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $8456044617785227$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $8456044617785227$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $8456044617785227$export$e2b040f052407032 = {
    dev: $8456044617785227$var$devBaseUrl,
    development: $8456044617785227$var$devBaseUrl,
    stg: $8456044617785227$var$stgBaseUrl,
    staging: $8456044617785227$var$stgBaseUrl,
    prd: $8456044617785227$var$prodBaseUrl,
    prod: $8456044617785227$var$prodBaseUrl,
    production: $8456044617785227$var$prodBaseUrl
};
const $8456044617785227$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? $8456044617785227$var$prodBaseUrl;
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $8456044617785227$export$e2b040f052407032 ? $8456044617785227$export$e2b040f052407032[envKey] : $8456044617785227$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $8456044617785227$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $8456044617785227$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $8456044617785227$export$2e2bcd8739ae039 = $8456044617785227$export$e2b040f052407032;

});

parcelRegister("dk2Up", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $5d6f3d2813099d60$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $5d6f3d2813099d60$export$b5fe3f66a567bec0);
const $5d6f3d2813099d60$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $5d6f3d2813099d60$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $5d6f3d2813099d60$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $5d6f3d2813099d60$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $5d6f3d2813099d60$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("aOj8V", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $63b890cc5f39c94c$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $63b890cc5f39c94c$export$bea7bee8a87e7c52);
const $63b890cc5f39c94c$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $63b890cc5f39c94c$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("7xkt0", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});



parcelRegister("idqmr", function(module, exports) {

$parcel$export(module.exports, "JiraSnippetRenderer", () => $69d9315ac50d969d$export$350494aed20b1067);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $epTsa = parcelRequire("epTsa");

var $igNUx = parcelRequire("igNUx");

var $48iZ8 = parcelRequire("48iZ8");
const $69d9315ac50d969d$export$350494aed20b1067 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $48iZ8.aiSnippetEntryPoint), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            contentId: props.contentId,
            contentType: props.contentType,
            cloudId: props.cloudId,
            fallbackText: props.fallbackText,
            fallbackComponent: props.fallbackComponent,
            isHidden: props.isHidden,
            maxLines: props.maxLines,
            showFooter: props.showFooter
        }), [
        props.contentId,
        props.contentType,
        props.cloudId,
        props.fallbackText,
        props.fallbackComponent,
        props.isHidden,
        props.maxLines,
        props.showFooter
    ]);
    if ((0, $igNUx.isFedRamp)() || !(0, $epTsa.expVal)('jira-cc-ai-snippet-experiment', 'should_render_ai_snippet', false)) return props.fallbackComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira.smartcard.ai-snippet",
        packageName: "jiraSmartcardAiSnippet",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: runtimeProps,
        fallback: props.fallbackComponent
    });
};

});
parcelRegister("48iZ8", function(module, exports) {

$parcel$export(module.exports, "aiSnippetEntryPoint", () => $fa1672fa6312100f$export$d03f6bd89a6edd19);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $fa1672fa6312100f$export$d03f6bd89a6edd19 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("6yd5k")), {
        moduleId: "6db951f1",
        priority: "interaction",
        moduleId: 'ai-snippet-entrypoint'
    }),
    getPreloadProps: ()=>({})
});

const $fa1672fa6312100f$export$594ea4c115483206 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("fcWI0")), {
        moduleId: "a7f3e824",
        priority: "interaction",
        moduleId: 'ai-snippet-with-relay-environment-entrypoint'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6yd5k", function(module, exports) {

let $4c501178bac59e74$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $4c501178bac59e74$var$load("1VRB2"),
    $4c501178bac59e74$var$load("bABhq"),
    $4c501178bac59e74$var$load("5i3lx")
]).then(()=>parcelRequire('eQugs'));

});

parcelRegister("fcWI0", function(module, exports) {

let $b1258458b29f14f6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $b1258458b29f14f6$var$load("1VRB2"),
    $b1258458b29f14f6$var$load("bABhq"),
    $b1258458b29f14f6$var$load("lPDX7")
]).then(()=>parcelRequire('43IaQ'));

});





parcelRegister("gSyZa", function(module, exports) {

$parcel$export(module.exports, "HorizontalNav", () => $2e63b1463a86de86$export$3821fe730064297d);
$parcel$export(module.exports, "HorizontalNavWrapper", () => $2e63b1463a86de86$export$8798384053a023ae);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $6nQNr = parcelRequire("6nQNr");

var $302Lx = parcelRequire("302Lx");

var $jrulJ = parcelRequire("jrulJ");


var $16sa1 = parcelRequire("16sa1");

var $1KdDN = parcelRequire("1KdDN");

var $2dBpR = parcelRequire("2dBpR");

var $iX5t3 = parcelRequire("iX5t3");

var $6zXPf = parcelRequire("6zXPf");

var $7wkp5 = parcelRequire("7wkp5");
const $2e63b1463a86de86$var$NavErrorBoundaryFallback = ()=>// null = equivalent of "unmount"
    // We should do more graceful degradation.
    // Let's review this after dogfooding:
    // Tracked https://hello.jira.atlassian.cloud/browse/SEA-3059
    null;
const $2e63b1463a86de86$var$entrypointContainerProps = {};
const $2e63b1463a86de86$export$3821fe730064297d = ()=>{
    const HorizontalNavComponent = (0, $6nQNr.useHorizontalNavComponent)();
    // Consume the horizontal nav entry point if defined, otherwise fallback to the old horizontal nav component
    const horizontalNavEntryPointReference = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$948d4d345566aed3));
    const horizontalNavFallback = horizontalNavEntryPointReference?.extraProps?.fallback || (0, $iX5t3.HorizontalNavSkeleton);
    if (horizontalNavEntryPointReference && (0, $6zXPf.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $302Lx.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wkp5.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "horizontal-nav-through-entry-point"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "horizontal-nav-through-entry-point",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        name: "horizontal-nav-through-entry-point",
        fallback: horizontalNavFallback(),
        entryPointReference: horizontalNavEntryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: horizontalNavEntryPointReference,
        props: $2e63b1463a86de86$var$entrypointContainerProps
    })))));
    return HorizontalNavComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $302Lx.NavErrorBoundary), {
        packageName: "page-container",
        id: "spa-horizontal-nav",
        fallback: $2e63b1463a86de86$var$NavErrorBoundaryFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $302Lx.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wkp5.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HorizontalNavComponent, null));
};
const $2e63b1463a86de86$export$8798384053a023ae = ({ children: children, navComponent: HorizontalNavComponent })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2e63b1463a86de86$var$ThemedContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $302Lx.NavErrorBoundary), {
        packageName: "page-container",
        id: "spa-horizontal-nav",
        fallback: $2e63b1463a86de86$var$NavErrorBoundaryFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $302Lx.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wkp5.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HorizontalNavComponent, null)), children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2e63b1463a86de86$var$ThemedContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11q7mmei _1reo15vq _18m915vq _11q31r52",
            __cmplp.className
        ])
    });
});

});
parcelRegister("302Lx", function(module, exports) {

$parcel$export(module.exports, "NavErrorBoundary", () => $db292bc365ee15db$export$afc779e659fd533f);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $1KdDN = parcelRequire("1KdDN");

var $gYnSx = parcelRequire("gYnSx");

var $f2JN3 = parcelRequire("f2JN3");

var $6zXPf = parcelRequire("6zXPf");
const $db292bc365ee15db$export$1d1321d2b374d697 = ()=>{
    if ((0, $7jTnu.fg)('is_overriding_fragments_analytics_prop')) {
        const re = /^(JF-TEST|MRJF-BB(\d+)?-\d+)$/;
        const buildKey = typeof window !== 'undefined' ? window?.BUILD_KEY : globalThis?.BUILD_KEY;
        return buildKey ? re.test(buildKey) : false;
    }
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};
function $db292bc365ee15db$var$inferNavRevision() {
    // This is brittle since we have several FFs https://hello.atlassian.net/wiki/spaces/SEA/pages/3841892327/Jira+Nav+v4+Feature+Flags
    // if possible, try to pass the revision explicitly as a prop
    return (0, $6zXPf.getWillShowNav4)() ? 'v4' : 'v3';
}
function $db292bc365ee15db$var$getExtraAttributes(_error) {
    const attributes = {
        rev: $db292bc365ee15db$var$inferNavRevision()
    };
    return attributes;
}
function $db292bc365ee15db$var$getAnalyticsPayload(error, meta, navRevision) {
    const payload = {
        error: error,
        meta: {
            // intentionally fixed metas
            // so that we generate a unique event signature
            // so that we can register it in the analytics portal: https://data-portal.internal.atlassian.com/analytics/registry/67955
            // so that we get the attributes to show up in Splunk: https://splunk.paas-inf.net/en-GB/app/search/2024_sea2744_jira_nav_v4_container_navigation
            id: 'logic',
            packageName: 'JiraNav'
        },
        attributes: {
            ...$db292bc365ee15db$var$getExtraAttributes(error),
            // forward the original meta as attributes to identify the location
            pkg: meta.packageName,
            id: meta.id,
            // if explicitly passed, override the rev
            ...navRevision && {
                rev: navRevision
            }
        },
        skipSentry: true
    };
    return payload;
}
const $db292bc365ee15db$export$5ac21f1e947e70d6 = (props)=>{
    const { id: id, packageName: packageName, navRevision: navRevision } = props;
    const onError = (0, $eJOHy.useMemo)(()=>{
        const meta = {
            id: id,
            packageName: packageName
        };
        const _onError = (...args)=>{
            if ($db292bc365ee15db$export$1d1321d2b374d697()) // this is a local test environment, don't send anything
            return;
            const [_, error] = args;
            (0, $gYnSx.default)($db292bc365ee15db$var$getAnalyticsPayload(error, meta, navRevision));
        };
        return _onError;
    }, [
        id,
        packageName,
        navRevision
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        ...props,
        onError: onError
    });
};
const $db292bc365ee15db$export$afc779e659fd533f = (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($db292bc365ee15db$export$5ac21f1e947e70d6, props), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), props));

});

parcelRegister("7wkp5", function(module, exports) {

$parcel$export(module.exports, "TopNavigationSkipLink", () => $594f97eae5faa7ac$export$47de2191d46337b7);
$parcel$export(module.exports, "LeftSidebarSkipLink", () => $594f97eae5faa7ac$export$46697df0d7c5e8be);
$parcel$export(module.exports, "ProjectViewNavigationSkipLink", () => $594f97eae5faa7ac$export$2e2fc9c237996c06);
$parcel$export(module.exports, "MainContentSkipLink", () => $594f97eae5faa7ac$export$b1498dd122ea3284);

var $lRq8t = parcelRequire("lRq8t");

var $dzLcO = parcelRequire("dzLcO");

var $7iEoF = parcelRequire("7iEoF");
const $594f97eae5faa7ac$export$47de2191d46337b7 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $dzLcO.useCustomSkipLink)('ak-jira-navigation', formatMessage((0, $7iEoF.default).skipToJiraNavigation), 0);
    return null;
};
const $594f97eae5faa7ac$export$46697df0d7c5e8be = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $dzLcO.useCustomSkipLink)('ak-side-navigation', formatMessage((0, $7iEoF.default).skipToSideNavigation), 1);
    return null;
};
const $594f97eae5faa7ac$export$2e2fc9c237996c06 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $dzLcO.useCustomSkipLink)('ak-project-view-navigation', formatMessage((0, $7iEoF.default).skipToProjectViewNavigation), 2);
    return null;
};
const $594f97eae5faa7ac$export$b1498dd122ea3284 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $dzLcO.useCustomSkipLink)('ak-main-content', formatMessage((0, $7iEoF.default).skipToMainContent), 3);
    return null;
};

});
parcelRegister("7iEoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c051cce56b2d289f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c051cce56b2d289f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    skipToJiraNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-jira-navigation",
        "defaultMessage": "Skip to Jira Navigation"
    },
    skipToSideNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-side-navigation",
        "defaultMessage": "Skip to Side Navigation"
    },
    skipToProjectViewNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-project-view-navigation",
        "defaultMessage": "Skip to View Navigation"
    },
    skipToMainContent: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-main-content",
        "defaultMessage": "Skip to Main Content"
    }
});

});



parcelRegister("m9A8V", function(module, exports) {

$parcel$export(module.exports, "RightSidebar", () => $dcf86e52707dff44$export$84d58c19c21f637f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");


var $jrulJ = parcelRequire("jrulJ");

var $2dBpR = parcelRequire("2dBpR");

var $1KdDN = parcelRequire("1KdDN");

var $f2JN3 = parcelRequire("f2JN3");

var $dfP3D = parcelRequire("dfP3D");

var $6zXPf = parcelRequire("6zXPf");

var $dzLcO = parcelRequire("dzLcO");

var $hih5V = parcelRequire("hih5V");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $6dwgv = parcelRequire("6dwgv");

var $djhHt = parcelRequire("djhHt");

var $16sa1 = parcelRequire("16sa1");
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 * It's only added once the component is rendered client-side.
 */ const $dcf86e52707dff44$var$TEST_ID = 'page-layout.aside';
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $dcf86e52707dff44$var$routeComponents = [];
const $dcf86e52707dff44$var$SharedRightSidebars = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $6dwgv.renderGlobalComponents)((0, $djhHt.sharedLayout).rightSidebars));
const $dcf86e52707dff44$var$RightSidebarRouteComponents = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $6dwgv.renderGlobalComponents)(route.layout?.rightSidebars || $dcf86e52707dff44$var$routeComponents));
};
const $dcf86e52707dff44$export$fb85bbdbfb3e6869 = ()=>null;
const $dcf86e52707dff44$var$RightSidebarThroughEntrypoint = ()=>{
    const rightSideBarEntryPointReference = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$7bf43119a6b49ddb));
    if (!rightSideBarEntryPointReference) return null;
    const rightSideBarFallback = rightSideBarEntryPointReference?.extraProps?.fallback || $dcf86e52707dff44$export$fb85bbdbfb3e6869;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "right-sidebar-through-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-through-entrypoint",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        name: "right-sidebar-through-entrypoint",
        fallback: rightSideBarFallback(),
        entryPointReference: rightSideBarEntryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: rightSideBarEntryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }))));
};
const $dcf86e52707dff44$var$NewRightSidebar = ()=>{
    const lastPanelIdRef = (0, $eJOHy.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
            panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
            isClosed: rightSidebarCurrentState?.panelId == null,
            isMinimised: !!rightSidebarCurrentState?.isMinimised,
            isCollapsed: !!rightSidebarCurrentState?.isCollapsed
        });
        lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
    }, [
        createAnalyticsEvent,
        rightSidebarCurrentState?.panelId,
        rightSidebarCurrentState?.isMinimised,
        rightSidebarCurrentState?.isCollapsed
    ]);
    if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.RightPanel), {
        width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0,
        testId: $dcf86e52707dff44$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-right-sidebars",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcf86e52707dff44$var$SharedRightSidebars, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-route-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcf86e52707dff44$var$RightSidebarRouteComponents, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcf86e52707dff44$var$RightSidebarThroughEntrypoint, null))));
};
/**
 * Manages visibility and behavior of the right sidebar in the user interface, adapting to user interactions and system events. It enhances user experience by providing dynamic control over the sidebar's presentation, including features for collapsing and minimizing, alongside tracking user interactions for analytical purposes.
 */ const $dcf86e52707dff44$var$OldRightSidebar = ()=>{
    const lastPanelIdRef = (0, $eJOHy.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
            panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
            isClosed: rightSidebarCurrentState?.panelId == null,
            isMinimised: !!rightSidebarCurrentState?.isMinimised,
            isCollapsed: !!rightSidebarCurrentState?.isCollapsed
        });
        lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
    }, [
        createAnalyticsEvent,
        rightSidebarCurrentState?.panelId,
        rightSidebarCurrentState?.isMinimised,
        rightSidebarCurrentState?.isCollapsed
    ]);
    if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcf86e52707dff44$var$RightSidebarPanelWrapper, {
        id: "right-sidebar-panel-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.RightSidebar), {
        width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-right-sidebars",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcf86e52707dff44$var$SharedRightSidebars, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-route-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcf86e52707dff44$var$RightSidebarRouteComponents, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcf86e52707dff44$var$RightSidebarThroughEntrypoint, null)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dcf86e52707dff44$var$RightSidebarPanelWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1bgi _iu1g1fl4 _1ej2b4wl",
            __cmplp.className
        ])
    });
});
const $dcf86e52707dff44$export$84d58c19c21f637f = (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), $dcf86e52707dff44$var$NewRightSidebar, $dcf86e52707dff44$var$OldRightSidebar);

});

parcelRegister("eTZyL", function(module, exports) {

$parcel$export(module.exports, "Sidebar", () => $13c248c2a5a8eec0$export$1ba59dacbcbf90fe);

var $hOoYL = parcelRequire("hOoYL");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $5Wv5g = parcelRequire("5Wv5g");

var $6CCPu = parcelRequire("6CCPu");
var $2JS8w = parcelRequire("2JS8w");
var $92EGY = parcelRequire("92EGY");

var $2Bv8P = parcelRequire("2Bv8P");

var $dPMMf = parcelRequire("dPMMf");

var $1KdDN = parcelRequire("1KdDN");

var $f2JN3 = parcelRequire("f2JN3");

var $bJscI = parcelRequire("bJscI");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $bILK0 = parcelRequire("bILK0");

var $dTocu = parcelRequire("dTocu");

var $cUxaS = parcelRequire("cUxaS");

var $fZsy4 = parcelRequire("fZsy4");

var $43SpR = parcelRequire("43SpR");

var $8Q9Ns = parcelRequire("8Q9Ns");

var $dpxw4 = parcelRequire("dpxw4");

var $6zXPf = parcelRequire("6zXPf");

var $5Q9JR = parcelRequire("5Q9JR");

var $hN5kE = parcelRequire("hN5kE");

var $dzLcO = parcelRequire("dzLcO");

var $ch9En = parcelRequire("ch9En");

var $hih5V = parcelRequire("hih5V");

var $9FYIg = parcelRequire("9FYIg");

var $6dnL8 = parcelRequire("6dnL8");

var $4WnjH = parcelRequire("4WnjH");

var $figsJ = parcelRequire("figsJ");

var $cECwI = parcelRequire("cECwI");

var $2cfd4 = parcelRequire("2cfd4");

var $16sa1 = parcelRequire("16sa1");

var $g5Uuh = parcelRequire("g5Uuh");

var $YVvuv = parcelRequire("YVvuv");

var $gkQFl = parcelRequire("gkQFl");

var $cfS4j = parcelRequire("cfS4j");

var $e5TCl = parcelRequire("e5TCl");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $7wkp5 = parcelRequire("7wkp5");

var $7b66t = parcelRequire("7b66t");

var $kP5Da = parcelRequire("kP5Da");
const $13c248c2a5a8eec0$var$footerStyles = {
    root: "_bfhkhp5a"
}; /**
    * This test ID is used in pollinator tests. Do not change lightly.
    */ 
const $13c248c2a5a8eec0$var$TEST_ID = 'page-layout.sidebar'; // TODO: use importCond() here
const $13c248c2a5a8eec0$var$SidebarNew = (0, $bJscI.componentWithFG)('navx-global-side-nav', (0, $e5TCl.NavPlatformSidebar), $13c248c2a5a8eec0$var$SidebarNav4);
const $13c248c2a5a8eec0$export$1ba59dacbcbf90fe = (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), $13c248c2a5a8eec0$var$SidebarNew, $13c248c2a5a8eec0$var$SidebarOld);
function $13c248c2a5a8eec0$var$SidebarNav4() {
    const isAnonymous = (0, $cECwI.useIsAnonymous)(); // TODO: Ask Matt why we use the Relay resource here, instead of inside SidebarInternal.
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $43SpR.sidebarNav4UiStateResource));
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "sidebar.anonymous"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderNew), {
        name: "nav4-ignore.sidebar.anonymous"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13c248c2a5a8eec0$var$SidebarInternalAnonymous, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4.sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderNew), {
        name: "nav4-ignore.sidebar"
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13c248c2a5a8eec0$var$SidebarInternal, {
        queryReference: queryReference
    }) : null));
}
function $13c248c2a5a8eec0$var$SidebarInternalAnonymous() {
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const defaultCollapsed = false;
    const defaultWidth = 340;
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $fZsy4.useLayoutStoreActions)();
    const onExpand = (0, $eJOHy.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: false
        });
    }, [
        setLeftSidebarState
    ]);
    const onCollapse = (0, $eJOHy.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: true
        });
    }, [
        setLeftSidebarState
    ]);
    const onResizeEnd = (0, $eJOHy.useCallback)(({ finalWidth: finalWidth })=>{
        setLeftSidebarState({
            width: finalWidth
        });
    }, [
        setLeftSidebarState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dpxw4.SidebarNav4ContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2JS8w.SideNav), {
        testId: $13c248c2a5a8eec0$var$TEST_ID,
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        onExpand: onExpand,
        onCollapse: onCollapse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gkQFl.SidebarEntryPointSelector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6CCPu.PanelSplitter), {
        label: formatMessage((0, $7b66t.messages).sideBarPanelSplitterLabel),
        onResizeEnd: onResizeEnd,
        testId: "page-container-v2.common.ui.sidebar.panel-splitter"
    })));
}
function $13c248c2a5a8eec0$var$SidebarInternal({ queryReference: queryReference }) {
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const subProduct = (0, $figsJ.useSubProduct)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const data = (0, $j4oe4.usePreloadedQuery)((0, $hOoYL.default), queryReference); /*
                                                                                               	Backend may respond with an error with the reason as Navigation UI state user property does not exist
                                                                                               	under a scenario where a new user joins an existing Jira site.
                                                                                               	When this happens, UI would not have data coming through from sidebarSelectorQuery.
                                                                                               	So, default values are used in such a case.
                                                                                               */ 
    const defaultCollapsed = data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, $5Q9JR.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT);
    const defaultWidth = data?.jira?.navigationUIState?.leftSidebarWidth ?? (0, $5Q9JR.LEFT_SIDEBAR_EXPANDED_MIN_WIDTH);
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $fZsy4.useLayoutStoreActions)();
    const onExpand = (0, $eJOHy.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: false
        });
    }, [
        setLeftSidebarState
    ]);
    const onCollapse = (0, $eJOHy.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: true
        });
    }, [
        setLeftSidebarState
    ]);
    const onResizeEnd = (0, $eJOHy.useCallback)(({ initialWidth: initialWidth, finalWidth: finalWidth })=>{
        setLeftSidebarState({
            width: finalWidth
        });
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'sidebar'
        }), {
            initialWidth: initialWidth,
            finalWidth: finalWidth
        });
    }, [
        createAnalyticsEvent,
        setLeftSidebarState
    ]);
    const locale = (0, $2cfd4.useLocale)();
    const showPersistentInvite = // Ensure that we can turn off the locale check with a feature gate if needed
    // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $7jTnu.fg)('navx_persistent_invite_jira_new_non_free') && // Do not trigger an exposure on the experiment for non-English locales
    (locale?.toLowerCase().startsWith('en') ?? false) && (0, $epTsa.expVal)('navx_persistent_invite_jira_new_non_free_exp', 'global_invite_enabled', false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dpxw4.SidebarNav4ContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2JS8w.SideNav), {
        testId: $13c248c2a5a8eec0$var$TEST_ID,
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        onExpand: onExpand,
        onCollapse: onCollapse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gkQFl.SidebarEntryPointSelector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $92EGY.SideNavFooter), {
        xcss: $13c248c2a5a8eec0$var$footerStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cfS4j.Nav4JiraSideNavRecommendation), null), showPersistentInvite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $13c248c2a5a8eec0$var$globalInviteButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Bv8P.GlobalInvite), {
        testId: "page-container-v2.common.ui.sidebar.global-invite",
        product: "jira",
        subProduct: subProduct ?? undefined,
        showFlag: showFlag
    }, formatMessage((0, $7b66t.messages).globalInviteButtonLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4WnjH.SidebarFeedbackButton), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4WnjH.SidebarFeedbackButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6CCPu.PanelSplitter), {
        label: formatMessage((0, $7b66t.messages).sideBarPanelSplitterLabel),
        onResizeEnd: onResizeEnd,
        testId: "page-container-v2.common.ui.sidebar.panel-splitter"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g5Uuh.AsyncNudgeBundledUsersFlagContainer), null), (0, $7jTnu.fg)('jira-nudge-confluence-inactive-users-eligible') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $YVvuv.AsyncNudgeInactiveConfluenceUserFlagContainer), null)));
}
const $13c248c2a5a8eec0$var$SIDEBAR_TEST_ID = 'ContextualNavigation';
const $13c248c2a5a8eec0$var$SIDEBAR_TRACE_KEY = 'sidebar';
const $13c248c2a5a8eec0$var$sidebarOverrides = {
    ResizeButton: {
        render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
                id: "sidebar-resize-tooltip",
                packageName: "page-container",
                fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props)
            }, (0, $7jTnu.fg)('jiv-blindspot-fixes-2025-07-01') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
                name: "side-bar-button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
                name: "side_bar_button",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kP5Da.AsyncResizeButtonTooltip), {
                isLeftSidebarCollapsed: props.isLeftSidebarCollapsed
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
                name: "side_bar_button",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kP5Da.AsyncResizeButtonTooltip), {
                isLeftSidebarCollapsed: props.isLeftSidebarCollapsed
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props))))
    }
};
function $13c248c2a5a8eec0$var$SidebarInternalOld({ sidebar: sidebar }) {
    const { width: width, isCollapsed: isCollapsed } = (0, $cUxaS.useLeftSidebarState)();
    const route = (0, $hih5V.useCurrentRoute)();
    const intl = (0, $dTocu.useIntlV2)();
    const shouldNotRenderSidebarInServerSide = false && isCollapsed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "left-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13c248c2a5a8eec0$var$SidebarStyleOverrides, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "leftSidebarSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wkp5.LeftSidebarSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.LeftSidebar), {
        isFixed: true,
        width: width,
        testId: $13c248c2a5a8eec0$var$SIDEBAR_TEST_ID,
        resizeButtonLabel: intl.formatMessage((0, $7b66t.messages).sidebarNavigation),
        collapsedState: isCollapsed ? 'collapsed' : 'expanded',
        overrides: $13c248c2a5a8eec0$var$sidebarOverrides,
        id: "ak-side-navigation"
    }, !shouldNotRenderSidebarInServerSide && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, route !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Q9Ns.SidebarStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dnL8.RenderTracerMark), {
        type: "start",
        traceKey: $13c248c2a5a8eec0$var$SIDEBAR_TRACE_KEY
    })), sidebar, route !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dnL8.RenderTracerMark), {
        type: "end",
        traceKey: $13c248c2a5a8eec0$var$SIDEBAR_TRACE_KEY
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g5Uuh.AsyncNudgeBundledUsersFlagContainer), null), (0, $7jTnu.fg)('jira-nudge-confluence-inactive-users-eligible') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $YVvuv.AsyncNudgeInactiveConfluenceUserFlagContainer), null)));
}
const $13c248c2a5a8eec0$var$SidebarInternalOldMemo = /*#__PURE__*/ (0, $eJOHy.memo)($13c248c2a5a8eec0$var$SidebarInternalOld, (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))); // moved children as function outside the `Sidebar` so that the function is not re-created every time `Sidebar` is re-rendered.
const $13c248c2a5a8eec0$var$renderChildren = (sidebar)=>sidebar !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13c248c2a5a8eec0$var$SidebarInternalOldMemo, {
        sidebar: sidebar
    }) : null;
function $13c248c2a5a8eec0$var$SidebarOld() {
    const { shouldRender: shouldRender } = (0, $cUxaS.useLeftSidebarState)();
    const route = (0, $hih5V.useCurrentRoute)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hN5kE.SidebarSelectorProvider), {
        sidebar: route.navigation?.sidebar ?? null
    }, $13c248c2a5a8eec0$var$renderChildren);
} /**
   * In the @atlaskit/page-layout, resize control uses button for
   * the grab area. At the same time, legacy batch.css reset all
   * the button to have a box-shadow when focused. So when user
   * resizing the sidebar, they will see two blue lines around
   * the grab area.
   */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $13c248c2a5a8eec0$var$SidebarStyleOverrides = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1d7w7yr": (0, $awdRS.default)((0, $dPMMf.layers).leftSidebar)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1pbyg9ti _14c1glyw",
            __cmplp.className
        ])
    });
});
const $13c248c2a5a8eec0$var$globalInviteButtonStyles = (0, $5Wv5g.xcss)({
    flexGrow: 1
});

});
parcelRegister("92EGY", function(module, exports) {

$parcel$export(module.exports, "SideNavFooter", () => $cc4f0f3815fd8511$export$b773c4c9cf740fbe);
/* side-nav-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $cc4f0f3815fd8511$var$styles = {
    root: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _7myae4h9 _1sw7nqa1 _qgnumuej"
};
const $cc4f0f3815fd8511$export$b773c4c9cf740fbe = ({ children: /**
   * The content of the layout area.
   */ children, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $cc4f0f3815fd8511$var$styles.root,
            xcss
        ]),
        children: children
    });
};

});

parcelRegister("2Bv8P", function(module, exports) {

$parcel$export(module.exports, "GlobalInvite", () => $9d1936580e24d26e$export$93cb436db3d27b7e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $5NGNw = parcelRequire("5NGNw");

var $8XtVW = parcelRequire("8XtVW");

var $7nvrE = parcelRequire("7nvrE");

var $7CxdL = parcelRequire("7CxdL");

var $7JnfB = parcelRequire("7JnfB");

var $cfdzS = parcelRequire("cfdzS");

var $fW5eq = parcelRequire("fW5eq");
const $9d1936580e24d26e$export$93cb436db3d27b7e = (0, $fW5eq.withModalDialog)($9d1936580e24d26e$var$AsyncGlobalInviteModalDialogContent);
var $9d1936580e24d26e$export$2e2bcd8739ae039 // This is only needed to support the Atlaskit docs. See https://hello.atlassian.net/wiki/spaces/navx/pages/5305993008/Platform+Guide#Atlaskit-%3CProps%3E-component-not-rendering
 = $9d1936580e24d26e$var$AsyncGlobalInviteModalDialogContent;
function $9d1936580e24d26e$var$AsyncGlobalInviteModalDialogContent(props) {
    const modalContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7JnfB.ErrorState), {}),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
            fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cfdzS.LoadingState), {}),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($9d1936580e24d26e$var$LazyGlobalInviteModalDialogContent, {
                ...props
            })
        })
    });
    return (0, $8XtVW.fg)('global_invite_uses_intl_provider') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5NGNw.default), {
        defaultMessages: (0, $7CxdL.default),
        loaderFn: (0, $7nvrE.fetchMessages),
        children: modalContent
    }) : modalContent;
}

const $9d1936580e24d26e$var$LazyGlobalInviteModalDialogContent = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("1vefA")).then((module)=>({
            default: module.ModalDialogContent
        })));

});
parcelRegister("7nvrE", function(module, exports) {

$parcel$export(module.exports, "fetchMessages", () => $2204c160d0153971$export$e4882a930a0d91f2);

var $7CxdL = parcelRequire("7CxdL");

var $2TbeP = parcelRequire("2TbeP");
const $2204c160d0153971$export$e4882a930a0d91f2 = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $2TbeP.asyncLanguages) ? locale : locale.replace(/-/g, '_') in (0, $2TbeP.asyncLanguages) ? locale.replace(/-/g, '_') : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $2TbeP.asyncLanguages)[languageLocale]?.();
        return localeMessages?.default ?? (0, $7CxdL.default);
    } catch (e) {
    // ignore
    }
    return 0, $7CxdL.default;
};

});
parcelRegister("7CxdL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $502b0c9fbeeda128$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $koaVW = parcelRequire("koaVW");
var $502b0c9fbeeda128$export$2e2bcd8739ae039 = (0, $koaVW.default);

});
parcelRegister("koaVW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0310ccf46447dfb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $f0310ccf46447dfb$export$2e2bcd8739ae039 = {
    'navigation.global-invite.error-state-description': 'Try refreshing the page or contact us if the problem persists.',
    'navigation.global-invite.error-state-heading': "We can't load the invite list right now",
    'navigation.global-invite.loading-visually-hidden-label': 'Loading',
    'navigation.global-invite.modal-dialog-label': 'Invite people'
};

});


parcelRegister("2TbeP", function(module, exports) {

$parcel$export(module.exports, "asyncLanguages", () => $e5dccc098e0079d3$export$3770c7a7737d463c);
// https://parceljs.org/features/dependency-resolution/#glob-specifiers

























const $e5dccc098e0079d3$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("chK27")),
    da: ()=>(parcelRequire("jrYBJ")),
    de: ()=>(parcelRequire("2xPlm")),
    'en-GB': ()=>(parcelRequire("hFe3y")),
    'en-ZZ': ()=>(parcelRequire("eoEzj")),
    en: ()=>Promise.resolve((parcelRequire("7CxdL"))),
    es: ()=>(parcelRequire("dPMiI")),
    fi: ()=>(parcelRequire("lIoDe")),
    fr: ()=>(parcelRequire("eGX3R")),
    hu: ()=>(parcelRequire("9JRFR")),
    it: ()=>(parcelRequire("6geIX")),
    ja: ()=>(parcelRequire("i4jUj")),
    ko: ()=>(parcelRequire("5J8pH")),
    nb: ()=>(parcelRequire("kXmlx")),
    nl: ()=>(parcelRequire("9hwr5")),
    pl: ()=>(parcelRequire("h61So")),
    'pt-BR': ()=>(parcelRequire("bQPDl")),
    ru: ()=>(parcelRequire("cE439")),
    sv: ()=>(parcelRequire("9EXm4")),
    th: ()=>(parcelRequire("lhlHh")),
    tr: ()=>(parcelRequire("dZorg")),
    uk: ()=>(parcelRequire("28Lqk")),
    vi: ()=>(parcelRequire("9CLmP")),
    zh_TW: ()=>(parcelRequire("bQhPV")),
    zh: ()=>(parcelRequire("cy1Wl"))
};

});
parcelRegister("chK27", function(module, exports) {

let $8f1ac7ccd052fe80$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8f1ac7ccd052fe80$var$load("8zjxL").then(()=>parcelRequire('2QplL'));

});

parcelRegister("jrYBJ", function(module, exports) {

let $e28f8d565dbcb6ea$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e28f8d565dbcb6ea$var$load("iD9FZ").then(()=>parcelRequire('5Lqbj'));

});

parcelRegister("2xPlm", function(module, exports) {

let $1da67d935d910e0c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1da67d935d910e0c$var$load("fCQMI").then(()=>parcelRequire('6Wmu0'));

});

parcelRegister("hFe3y", function(module, exports) {

let $cdc12b49265f0379$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cdc12b49265f0379$var$load("jBiWk").then(()=>parcelRequire('ktG6Q'));

});

parcelRegister("eoEzj", function(module, exports) {

let $a7b2c6a5e961c08e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a7b2c6a5e961c08e$var$load("gdw08").then(()=>parcelRequire('4SqO0'));

});

parcelRegister("dPMiI", function(module, exports) {

let $a12581595849f9e3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a12581595849f9e3$var$load("5Qi9b").then(()=>parcelRequire('5S20M'));

});

parcelRegister("lIoDe", function(module, exports) {

let $fcf0d06555c71855$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fcf0d06555c71855$var$load("kpZlt").then(()=>parcelRequire('crE60'));

});

parcelRegister("eGX3R", function(module, exports) {

let $ab22cd45009100d7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ab22cd45009100d7$var$load("dJmIN").then(()=>parcelRequire('Y0dve'));

});

parcelRegister("9JRFR", function(module, exports) {

let $7171f397b40ab51e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7171f397b40ab51e$var$load("fgifk").then(()=>parcelRequire('gzKcL'));

});

parcelRegister("6geIX", function(module, exports) {

let $48efa8975358c557$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $48efa8975358c557$var$load("eDSSt").then(()=>parcelRequire('16IqT'));

});

parcelRegister("i4jUj", function(module, exports) {

let $d2780ae6ec62b9b7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d2780ae6ec62b9b7$var$load("02oPr").then(()=>parcelRequire('a8bDa'));

});

parcelRegister("5J8pH", function(module, exports) {

let $42b7ae7a1a53fd42$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $42b7ae7a1a53fd42$var$load("jrYhm").then(()=>parcelRequire('huDmq'));

});

parcelRegister("kXmlx", function(module, exports) {

let $f41aa6dcff0c514b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f41aa6dcff0c514b$var$load("3cy5Z").then(()=>parcelRequire('ecW2K'));

});

parcelRegister("9hwr5", function(module, exports) {

let $6c1edca9d411ef89$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6c1edca9d411ef89$var$load("hWVg2").then(()=>parcelRequire('kgzlz'));

});

parcelRegister("h61So", function(module, exports) {

let $c72473d0f07f4113$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c72473d0f07f4113$var$load("9noST").then(()=>parcelRequire('g0mZZ'));

});

parcelRegister("bQPDl", function(module, exports) {

let $8a0c9a671774f46e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8a0c9a671774f46e$var$load("dWLFj").then(()=>parcelRequire('h65xt'));

});

parcelRegister("cE439", function(module, exports) {

let $934c5caa0b8ee13f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $934c5caa0b8ee13f$var$load("f7tTB").then(()=>parcelRequire('6sgtH'));

});

parcelRegister("9EXm4", function(module, exports) {

let $7085e420ece03a21$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7085e420ece03a21$var$load("etF3G").then(()=>parcelRequire('fK6Uj'));

});

parcelRegister("lhlHh", function(module, exports) {

let $f7dc0416c98b3dd0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f7dc0416c98b3dd0$var$load("9JC7b").then(()=>parcelRequire('8BBo0'));

});

parcelRegister("dZorg", function(module, exports) {

let $a2f3eddf13e5c105$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a2f3eddf13e5c105$var$load("9VI1t").then(()=>parcelRequire('kP2J3'));

});

parcelRegister("28Lqk", function(module, exports) {

let $18f11d74c5dde546$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $18f11d74c5dde546$var$load("5Sh4K").then(()=>parcelRequire('lhvQw'));

});

parcelRegister("9CLmP", function(module, exports) {

let $701c67cb25cb7763$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $701c67cb25cb7763$var$load("dXTcK").then(()=>parcelRequire('dJ0w6'));

});

parcelRegister("bQhPV", function(module, exports) {

let $89f262f9aa467a82$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $89f262f9aa467a82$var$load("jo42m").then(()=>parcelRequire('7i9qa'));

});

parcelRegister("cy1Wl", function(module, exports) {

let $922a2a4879119286$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $922a2a4879119286$var$load("gPN24").then(()=>parcelRequire('kcIs9'));

});



parcelRegister("7JnfB", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $e291fcd9ef482232$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bvFRW = parcelRequire("bvFRW");

var $9LyfF = parcelRequire("9LyfF");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $h8z0a = parcelRequire("h8z0a");
const $e291fcd9ef482232$var$styles = (0, $5Wv5g.xcss)({
    paddingBlock: 'space.1000',
    paddingInline: 'space.100',
    textAlign: 'center'
});
function $e291fcd9ef482232$export$c1ed4f415b9e7023() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9LyfF.default), {
        space: "space.050",
        testId: "global-invite--error-state",
        xcss: $e291fcd9ef482232$var$styles,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvFRW.default), {
                size: "xsmall",
                children: formatMessage((0, $h8z0a.messages).errorStateHeading)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jvsV6.default), {
                size: "small",
                color: "color.text.subtle",
                children: formatMessage((0, $h8z0a.messages).errorStateDescription)
            })
        ]
    });
}

});
parcelRegister("h8z0a", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f410c5469717c109$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $f410c5469717c109$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    errorStateHeading: {
        id: 'navigation.global-invite.error-state-heading',
        description: "Heading of the error state UI indicating we couldn't load the invite people widget.",
        defaultMessage: "We can't load the invite list right now"
    },
    errorStateDescription: {
        id: 'navigation.global-invite.error-state-description',
        description: "Description of the error state UI indicating we couldn't load the invite people widget.",
        defaultMessage: 'Try refreshing the page or contact us if the problem persists.'
    }
});

});


parcelRegister("cfdzS", function(module, exports) {

$parcel$export(module.exports, "LoadingState", () => $eeabc528782122d1$export$62aa48085237e36f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bxHeV = parcelRequire("bxHeV");
var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");

var $aVwGC = parcelRequire("aVwGC");

var $1otFb = parcelRequire("1otFb");

var $dWuD3 = parcelRequire("dWuD3");
const $eeabc528782122d1$var$styles = (0, $5Wv5g.xcss)({
    paddingBlock: 'space.500',
    paddingInline: 'space.300'
});
function $eeabc528782122d1$export$62aa48085237e36f() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const items = Array.from({
        length: 5
    }, (_, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $aVwGC.default), {
            isShimmering: true,
            width: "100%",
            height: "var(--ds-space-200, 16px)",
            testId: "skeleton-shimmering"
        }, index));
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bxHeV.default), {
        xcss: $eeabc528782122d1$var$styles,
        testId: "global-invite--loading-state",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1otFb.default), {
                children: formatMessage((0, $dWuD3.messages).loadingLabel)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9LyfF.default), {
                space: "space.100",
                testId: "skeleton-group",
                children: items
            })
        ]
    });
}

});
parcelRegister("dWuD3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $205dbc2ab5696400$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $205dbc2ab5696400$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    loadingLabel: {
        id: 'navigation.global-invite.loading-visually-hidden-label',
        description: 'Visually hidden text to indicate the invite people UI is loading.',
        defaultMessage: 'Loading'
    }
});

});


parcelRegister("fW5eq", function(module, exports) {

$parcel$export(module.exports, "withModalDialog", () => $01ddc2b718a320e1$export$2d7d84d397d9a585);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");


var $f1Zdy = parcelRequire("f1Zdy");

var $alkjW = parcelRequire("alkjW");

var $jdbsD = parcelRequire("jdbsD");
var $6sWr0 = parcelRequire("6sWr0");
var $jC5ye = parcelRequire("jC5ye");


var $j2XgC = parcelRequire("j2XgC");

var $bRbk5 = parcelRequire("bRbk5");
function $01ddc2b718a320e1$export$2d7d84d397d9a585(Content) {
    return function ModalDialog({ testId: testId = (0, $d314b382ef448e6c$export$bb76aeb9f599715c), triggerElement: TriggerElement, children: children, ...props }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, $lRq8t.default)();
        const [isModalDialogOpen, setIsModalDialogOpen] = (0, $eJOHy.useState)(false);
        const [adminHasNavigatedAway, setAdminHasNavigatedAway] = (0, $eJOHy.useState)(false);
        const openModalDialog = (0, $eJOHy.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $27c7fc6638bd7614$export$a1562d08625f5d7e),
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'globalInviteButton',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $d314b382ef448e6c$export$85183a312807388d));
            setIsModalDialogOpen(true);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const onAdminMenuItemClick = (0, $eJOHy.useCallback)((event)=>{
            // See packages/people-and-teams/invite-people/src/components/DropdownMenu/AdminMenuGroup.tsx for where these items are created.
            // Handle the click event happening on a link directly, or on an inner <span> or similar
            const isLink = event?.target?.tagName === 'A';
            const link = isLink ? event?.target : event?.target?.closest('a');
            if (link && (link?.getAttribute('target') === 'new' || link?.getAttribute('target') === '_blank')) setAdminHasNavigatedAway(true);
        }, []);
        const onCancel = (0, $eJOHy.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $27c7fc6638bd7614$export$a1562d08625f5d7e),
                action: adminHasNavigatedAway ? 'closed' : 'cancelled',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $d314b382ef448e6c$export$85183a312807388d));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product,
            adminHasNavigatedAway
        ]);
        const onInviteCompleted = (0, $eJOHy.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $27c7fc6638bd7614$export$a1562d08625f5d7e),
                action: 'completed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $d314b382ef448e6c$export$85183a312807388d));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const focusDialog = (0, $eJOHy.useCallback)((node)=>{
            // Focus the dialog's container when it finishes opening
            node.focus();
        }, []);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2XgC.AnalyticsContextWrapper), {
            product: props.product,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                "data-testid": testId,
                children: [
                    TriggerElement ? /*#__PURE__*/ (0, $gt9Am.jsx)(TriggerElement, {
                        onClick: openModalDialog
                    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $alkjW.default), {
                        shouldFitContainer: true,
                        onClick: openModalDialog,
                        testId: `${testId}--${(0, $d314b382ef448e6c$export$1dab7caa4b20a4cc)}`,
                        children: children
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jC5ye.default), {
                        children: isModalDialogOpen ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdbsD.default), {
                            width: "small",
                            shouldScrollInViewport: true,
                            shouldReturnFocus: true,
                            onClose: onCancel,
                            onOpenComplete: focusDialog,
                            label: formatMessage((0, $bRbk5.messages).modalDialogLabel),
                            testId: `${testId}--${(0, $d314b382ef448e6c$export$7622d28bacf170d1)}`,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6sWr0.default), {
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Content, {
                                    onAdminMenuItemClick: onAdminMenuItemClick,
                                    onCancel: onCancel,
                                    onInviteCompleted: onInviteCompleted,
                                    ...props
                                })
                            })
                        }) : null
                    })
                ]
            })
        });
    };
}

});
const $d314b382ef448e6c$export$bb76aeb9f599715c = 'global-invite';
const $d314b382ef448e6c$export$7622d28bacf170d1 = 'modal-dialog';
const $d314b382ef448e6c$export$1dab7caa4b20a4cc = 'trigger-element';
const $d314b382ef448e6c$export$85183a312807388d = 'navigation';

parcelRegister("j2XgC", function(module, exports) {

$parcel$export(module.exports, "AnalyticsContextWrapper", () => $3191d1d51459e1b3$export$804bcbe0913c6ba3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxsjC = parcelRequire("kxsjC");
function $3191d1d51459e1b3$export$804bcbe0913c6ba3({ product: product, children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxsjC.NavigationAnalyticsContext), {
        data: {
            componentName: 'globalInvite',
            source: 'globalInviteButton',
            product: product
        },
        children: children
    });
}

});

parcelRegister("bRbk5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0fe32c3660319b7c$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $0fe32c3660319b7c$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    modalDialogLabel: {
        id: 'navigation.global-invite.modal-dialog-label',
        description: 'Accessible label of the modal dialog for assistive technologies users.',
        defaultMessage: 'Invite people'
    }
});

});


parcelRegister("1vefA", function(module, exports) {

let $1183bd80be2d1a1c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1183bd80be2d1a1c$var$load("7vqGd"),
    $1183bd80be2d1a1c$var$load("1Y4bq"),
    $1183bd80be2d1a1c$var$load("90aBN")
]).then(()=>parcelRequire('i2Jng'));

});


parcelRegister("hN5kE", function(module, exports) {

$parcel$export(module.exports, "SidebarSelectorProvider", () => $8fb9ef607a91b40c$export$6af584355cfb32c6);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $ln6Iy = parcelRequire("ln6Iy");

var $eWzpp = parcelRequire("eWzpp");

var $gpE1B = parcelRequire("gpE1B");

var $7zL9d = parcelRequire("7zL9d");

var $8mNJo = parcelRequire("8mNJo");

var $37etw = parcelRequire("37etw");

var $ghtZl = parcelRequire("ghtZl");

var $8lf8T = parcelRequire("8lf8T");

var $48yDM = parcelRequire("48yDM");

var $9UaKV = parcelRequire("9UaKV");

var $hUdoF = parcelRequire("hUdoF");

var $hiOwQ = parcelRequire("hiOwQ");

var $fzU9D = parcelRequire("fzU9D");

var $kQnBg = parcelRequire("kQnBg");

var $aDtWM = parcelRequire("aDtWM");

var $gKFn0 = parcelRequire("gKFn0");

var $2nHUF = parcelRequire("2nHUF");

var $k4mZn = parcelRequire("k4mZn");

var $gHEJe = parcelRequire("gHEJe");

var $it9UZ = parcelRequire("it9UZ");

var $kenvB = parcelRequire("kenvB");

var $1f2LE = parcelRequire("1f2LE");

var $k6duF = parcelRequire("k6duF");

var $3V6se = parcelRequire("3V6se");

var $7FIkD = parcelRequire("7FIkD");

var $eJrcF = parcelRequire("eJrcF");
const $8fb9ef607a91b40c$var$renderProjectSidebar = ({ data: project, loading: loading })=>{
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gpE1B.Skeleton), {
        isFull: true
    });
    if (!project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3V6se.default), null);
    switch(project.type){
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
        case 0, $ln6Iy.CUSTOMER_SERVICE_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1f2LE.default), null);
        case 0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kenvB.default), null);
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            if (project.isSimplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHEJe.default), null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k6duF.default), null);
        // delete when cleaning up getWillShowNav4
        case 0, $ln6Iy.CORE_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hiOwQ.default), null);
        default:
            // TODO: render error
            return null;
    }
};
// Since argument of `renderProjectSidebar` is similar to `props` object of a React component
// so we can convert normal function to functional component
const $8fb9ef607a91b40c$var$ProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)($8fb9ef607a91b40c$var$renderProjectSidebar, (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj))));
const $8fb9ef607a91b40c$export$6af584355cfb32c6 = ({ sidebar: sidebar, children: children })=>{
    const projectState = (0, $eWzpp.useProject)();
    const isInsightMenuSelected = (0, $8lf8T.useInsight)();
    const shouldRenderInsightObjectSchemaSidebar = (0, $8lf8T.useInsightObjectSchemaSidebar)();
    const { selected: pSelected, loading: pLoading } = (0, $hUdoF.useProjectConnectItems)();
    const { selected: prSelected, loading: prLoading } = (0, $48yDM.useProjectReportsConnectItems)();
    const { selected: psSelected, loading: psLoading } = (0, $9UaKV.useProjectSettingsConnectItems)();
    const { selected: gSelected, loading: gLoading } = (0, $ghtZl.useGlobalConnectItems)();
    const { selected: gsSelected, loading: gsLoading } = (0, $37etw.useGlobalSettingsConnectItems)();
    const { selected: gssSelected, loading: gssLoading } = (0, $8mNJo.useGlobalSettingsSystemConnectItems)();
    const { data: gresData, loading: gresLoading } = (0, $eJrcF.useResource)((0, $7FIkD.connectGeneralResources));
    const { sections: fgSections, loading: fgLoading } = (0, $kQnBg.useForgeGlobalPageItems)();
    // CHOOK-247 - move to 'servicedesk-cmdb-object-schema' route in packages/routes/src/ui/spa/servicedesk/cmdb/index.js
    // once new page is rolled out. Hard-coded here since it isn't possible to have the Route navigation.sidebar
    // property change dynamically at runtime.
    if (shouldRenderInsightObjectSchemaSidebar) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k4mZn.default), null));
    if (isInsightMenuSelected) // fullscreen connect with no sidebar
    return null;
    if (sidebar === (0, $it9UZ.default)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $it9UZ.default), null));
    if (sidebar === (0, $fzU9D.default)) {
        if (fgLoading) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gpE1B.Skeleton), {
            isFull: true
        }));
        if (fgSections?.length) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fzU9D.default), null));
        return children(null);
    }
    if (!Array.isArray(sidebar)) {
        const Sidebar = sidebar;
        return children(Sidebar != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Sidebar, null) : null);
    }
    if (sidebar === (0, $aDtWM.genericConnectSidebars)) {
        const foundInProject = pSelected || prSelected || psSelected || [
            'jiraProjectAdminTabPanels'
        ].includes(gresData?.moduleType);
        const foundSomewhere = foundInProject || gSelected || gsSelected || gssSelected;
        const stillLoading = pLoading || prLoading || psLoading || gLoading || gsLoading || gssLoading || gresLoading;
        if (stillLoading && !foundSomewhere) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gpE1B.Skeleton), {
            isFull: true
        }));
        if (foundInProject) {
            const projectSidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8fb9ef607a91b40c$var$ProjectSidebar, projectState);
            return children(projectSidebar);
        }
        if (gSelected) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7zL9d.default), null));
        if (gsSelected || [
            'configurePage',
            'postInstallPage'
        ].includes(gresData?.moduleType)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gKFn0.default), null));
        if (gssSelected || [
            'adminPages'
        ].includes(gresData?.moduleType)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2nHUF.default), null));
        // not found, assume fullscreen connect with no sidebar
        return children(null);
    }
    const projectSidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8fb9ef607a91b40c$var$ProjectSidebar, projectState);
    return children(projectSidebar);
};

});
parcelRegister("37etw", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsConnectItems", () => $fafe3d5300cf642f$export$f0785b98c99d344c);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $dGS6y = parcelRequire("dGS6y");

var $gCY1z = parcelRequire("gCY1z");

var $3uU3k = parcelRequire("3uU3k");

var $e4GDd = parcelRequire("e4GDd");

var $7Q6ai = parcelRequire("7Q6ai");
// use memoised functions per hook to avoid re-computation between same hooks
const $fafe3d5300cf642f$var$getItemsMemo = (0, $LFmXM.default)((d)=>(0, $e4GDd.getLinks)(d, [
        'admin_plugins_menu'
    ], {
        skipFilter: true
    })// remove sections also statically defined
    .filter((v)=>![
            'upm_section',
            'jpo-ws-admin'
        ].includes(v.id)).map((0, $7Q6ai.transformLink)).filter(Boolean));
const $fafe3d5300cf642f$var$findItemAndStackMemo = (0, $LFmXM.default)((0, $3uU3k.findItemAndStack));
const $fafe3d5300cf642f$export$f0785b98c99d344c = ()=>{
    const [{ route: route, location: location }] = (0, $gCY1z.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $dGS6y.useNavigationGlobalResource)();
    const items = (0, $eJOHy.useMemo)(()=>data && $fafe3d5300cf642f$var$getItemsMemo(data), [
        data
    ]);
    const found = (0, $eJOHy.useMemo)(()=>route && items && $fafe3d5300cf642f$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("ghtZl", function(module, exports) {

$parcel$export(module.exports, "useGlobalConnectItems", () => $dddabca531740415$export$ee355b2e42d6462b);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $dGS6y = parcelRequire("dGS6y");

var $gCY1z = parcelRequire("gCY1z");

var $3uU3k = parcelRequire("3uU3k");

var $e4GDd = parcelRequire("e4GDd");

var $7Q6ai = parcelRequire("7Q6ai");
// use memoised functions per hook to avoid re-computation between same hooks
const $dddabca531740415$var$getItemsMemo = (0, $LFmXM.default)((d)=>(0, $e4GDd.getLinks)(d, [
        'global-navigation-product'
    ]).map((0, $7Q6ai.transformLink)).filter((item)=>item != null && item.items));
const $dddabca531740415$var$findItemAndStackMemo = (0, $LFmXM.default)((0, $3uU3k.findItemAndStack));
const $dddabca531740415$export$ee355b2e42d6462b = ()=>{
    const [{ route: route, location: location }] = (0, $gCY1z.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $dGS6y.useNavigationGlobalResource)();
    const sidebars = (0, $eJOHy.useMemo)(()=>data && $dddabca531740415$var$getItemsMemo(data), [
        data
    ]);
    const searchResult = (0, $eJOHy.useMemo)(()=>{
        let result = {
            stack: [],
            selected: null,
            title: null,
            data: null
        };
        if (sidebars != null) sidebars.some((sidebar)=>{
            const { items: items } = sidebar || {};
            if (!sidebar || !route || items == null) return false;
            const found = $dddabca531740415$var$findItemAndStackMemo(items, route.name, location);
            if (found) {
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'null'. | TS2322 - Type 'ConnectDataItem[]' is not assignable to type 'null'.
                result = {
                    ...found,
                    title: sidebar.name,
                    data: items
                };
                return true;
            }
            return false;
        });
        return result;
    }, [
        sidebars,
        route,
        location
    ]);
    return {
        ...searchResult,
        loading: loading,
        error: error
    };
};

});

parcelRegister("8lf8T", function(module, exports) {

$parcel$export(module.exports, "useInsight", () => $a491243a94026ab0$export$e24dad0705701755);
$parcel$export(module.exports, "useInsightObjectSchemaSidebar", () => $a491243a94026ab0$export$1f0bd21403710fc);

var $6zXPf = parcelRequire("6zXPf");

var $hih5V = parcelRequire("hih5V");
const $a491243a94026ab0$export$e24dad0705701755 = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    if (route.navigation) return route.navigation.menuId === 'INSIGHT';
    return false;
};
const $a491243a94026ab0$export$1f0bd21403710fc = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    if ((0, $6zXPf.getWillShowNav4)()) return false;
    return route.name === 'servicedesk-cmdb-object-schema';
};

});

parcelRegister("48yDM", function(module, exports) {

$parcel$export(module.exports, "useProjectReportsConnectItems", () => $831f0d8055348a56$export$a1c75c386c088992);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $dSkLG = parcelRequire("dSkLG");

var $gCY1z = parcelRequire("gCY1z");

var $3uU3k = parcelRequire("3uU3k");

var $7Q6ai = parcelRequire("7Q6ai");
const $831f0d8055348a56$var$findItemAndStackMemo = (0, $LFmXM.default)((0, $3uU3k.findItemAndStack));
const $831f0d8055348a56$export$a1c75c386c088992 = ()=>{
    const [{ route: route, location: location }] = (0, $gCY1z.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $dSkLG.useProjectReportsSidebarConnectNavigation)();
    const items = (0, $eJOHy.useMemo)(()=>data != null ? data.map((0, $7Q6ai.transformLinkV4)).filter(Boolean) : [], [
        data
    ]);
    const found = (0, $eJOHy.useMemo)(()=>route && items && $831f0d8055348a56$var$findItemAndStackMemo(items, route.name, location, [
            'reports'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        error: error,
        loading: loading,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("9UaKV", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $7c27396d9060b138$export$41a50100db18b578);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $dSkLG = parcelRequire("dSkLG");

var $gCY1z = parcelRequire("gCY1z");

var $3uU3k = parcelRequire("3uU3k");

var $7Q6ai = parcelRequire("7Q6ai");
// use memoised functions per hook to avoid re-computation between same hooks
const $7c27396d9060b138$var$findItemAndStackMemo = (0, $LFmXM.default)((0, $3uU3k.findItemAndStack));
const $7c27396d9060b138$export$41a50100db18b578 = ()=>{
    const [{ route: route, location: location }] = (0, $gCY1z.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $dSkLG.useProjectSettingsSidebarConnectNavigation)();
    const items = (0, $eJOHy.useMemo)(()=>data && data.map((0, $7Q6ai.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $eJOHy.useMemo)(()=>route && items && $7c27396d9060b138$var$findItemAndStackMemo(items, route.name, location, [
            'settings'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("hUdoF", function(module, exports) {

$parcel$export(module.exports, "useProjectConnectItems", () => $f2257c405ceef2b8$export$f23d0c24c77d7608);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $dSkLG = parcelRequire("dSkLG");

var $gCY1z = parcelRequire("gCY1z");

var $3uU3k = parcelRequire("3uU3k");

var $7Q6ai = parcelRequire("7Q6ai");
const $f2257c405ceef2b8$var$findItemAndStackMemo = (0, $LFmXM.default)((0, $3uU3k.findItemAndStack));
const $f2257c405ceef2b8$export$f23d0c24c77d7608 = ()=>{
    const [{ route: route, location: location }] = (0, $gCY1z.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $dSkLG.useProjectSidebarConnectNavigation)();
    const items = (0, $eJOHy.useMemo)(()=>data && data.map((0, $7Q6ai.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $eJOHy.useMemo)(()=>route && items && $f2257c405ceef2b8$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("kQnBg", function(module, exports) {

$parcel$export(module.exports, "useForgeGlobalPageItems", () => $4c5613335eb90b3a$export$ff333fd2f0bf5254);

var $eJOHy = parcelRequire("eJOHy");

var $kAWUp = parcelRequire("kAWUp");

var $cIeoi = parcelRequire("cIeoi");

var $ew1wJ = parcelRequire("ew1wJ");

var $gCY1z = parcelRequire("gCY1z");
const $4c5613335eb90b3a$export$ff333fd2f0bf5254 = ()=>{
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    const { data: modules, loading: loading, error: error } = (0, $kAWUp.useGlobalForgeApps)();
    const extension = (0, $ew1wJ.useMatchedExtension)({
        modules: modules,
        match: match
    });
    const sections = (0, $eJOHy.useMemo)(()=>extension && (0, $cIeoi.toSections)(extension), [
        extension
    ]);
    return {
        extension: extension,
        sections: sections,
        loading: loading,
        error: error
    };
};

});
parcelRegister("kAWUp", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $9bb328f2d74bd123$export$ed6342e0e28465a6);
$parcel$export(module.exports, "useGlobalForgeApps", () => $9bb328f2d74bd123$export$f834c14187f80532);

var $eJOHy = parcelRequire("eJOHy");

var $ePLco = parcelRequire("ePLco");

var $kU13U = parcelRequire("kU13U");

var $hHbzj = parcelRequire("hHbzj");

var $eJrcF = parcelRequire("eJrcF");
const $9bb328f2d74bd123$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `/jira/apps/${appId}/${envId}`;
};
const $9bb328f2d74bd123$export$f834c14187f80532 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)((0, $hHbzj.forgeGlobalModuleResource));
    return (0, $eJOHy.useMemo)(()=>({
            data: data ? data.filter((0, $kU13U.isExtensionVisible)) : null,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("kU13U", function(module, exports) {

$parcel$export(module.exports, "isExtensionVisible", () => $6d662423b598e6b2$export$41e48b53c2cc2013);
$parcel$export(module.exports, "isExtensionHidden", () => $6d662423b598e6b2$export$3f5b3e61d567ef3);
$parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", () => $6d662423b598e6b2$export$5c38dfa9d1f96e61);
const $6d662423b598e6b2$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
const $6d662423b598e6b2$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
const $6d662423b598e6b2$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
const $6d662423b598e6b2$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';

});


parcelRegister("cIeoi", function(module, exports) {

$parcel$export(module.exports, "toSections", () => $b85249c542836091$export$29678d1e04c0e8c4);

var $LFmXM = parcelRequire("LFmXM");
/**
 * Just in case someone passes a broken object we don't want to blow up the sidebar
 */ const $b85249c542836091$var$normalizeSection = (section)=>({
        header: section?.header,
        pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                icon: page?.icon,
                route: page?.route,
                title: page?.title
            })) : []
    });
const $b85249c542836091$export$29678d1e04c0e8c4 = (0, $LFmXM.default)((extension)=>{
    const { properties: properties } = extension;
    // Only Custom UI supports subpages
    if (typeof properties.resource !== 'string') return [];
    // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.pages !== 'undefined' && properties.pages?.length) // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return [
        {
            pages: properties.pages
        }
    ].map($b85249c542836091$var$normalizeSection);
    // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.sections !== 'undefined' && properties.sections?.length) // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return properties.sections.map($b85249c542836091$var$normalizeSection);
    return [];
});

});

parcelRegister("ew1wJ", function(module, exports) {

$parcel$export(module.exports, "useMatchedExtension", () => $f86adfa34dae31c9$export$13375c0abccaf6f6);
$parcel$export(module.exports, "useExtensionBasePath", () => $f86adfa34dae31c9$export$25abed85383f0fbb);

var $eJOHy = parcelRequire("eJOHy");

var $ePLco = parcelRequire("ePLco");
const $f86adfa34dae31c9$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $eJOHy.useMemo)(()=>(modules || []).find((app)=>{
            const parsedExtensionId = (0, $ePLco.parseExtensionId)(app.id);
            return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
        }), [
        modules,
        match.params.appId,
        match.params.envId
    ]);
const $f86adfa34dae31c9$export$25abed85383f0fbb = (basePath, route)=>route !== undefined ? basePath.replace(/\/?$/, '').slice(0, -route.length - 1) : basePath.replace(/\/?$/, '');

});


parcelRegister("k4mZn", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd13e27cb4a0fcc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $bcd13e27cb4a0fcc$var$LazyInsightObjectSchemaSidebar = (0, $gzcjr.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("bBgUs")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/insight-object-schema/src/index.tsx"
});
const $bcd13e27cb4a0fcc$var$InsightObjectSchemaSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "insight-object-schema-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcd13e27cb4a0fcc$var$LazyInsightObjectSchemaSidebar, null)));
$bcd13e27cb4a0fcc$var$InsightObjectSchemaSidebar.displayName = 'InsightObjectSchemaSidebar';
var $bcd13e27cb4a0fcc$export$2e2bcd8739ae039 = $bcd13e27cb4a0fcc$var$InsightObjectSchemaSidebar;

});
parcelRegister("bBgUs", function(module, exports) {

let $8720444a89aa2982$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8720444a89aa2982$var$load("k4gbU"),
    $8720444a89aa2982$var$load("7vqGd"),
    $8720444a89aa2982$var$load("1Y4bq"),
    $8720444a89aa2982$var$load("fMOSo"),
    $8720444a89aa2982$var$load("jhiae"),
    $8720444a89aa2982$var$load("kYdbl")
]).then(()=>parcelRequire('bJ1vE'));

});


parcelRegister("kenvB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcc41d65a539a2ac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $gzcjr = parcelRequire("gzcjr");

const $fcc41d65a539a2ac$var$LazyPolarisProjectSidebar = (0, $gzcjr.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("cVpr7")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/polaris/src/index.tsx"
});
const $fcc41d65a539a2ac$var$PolarisProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "polarisProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fcc41d65a539a2ac$var$LazyPolarisProjectSidebar, null)));
$fcc41d65a539a2ac$var$PolarisProjectSidebar.displayName = 'PolarisProjectSidebar';
var $fcc41d65a539a2ac$export$2e2bcd8739ae039 = $fcc41d65a539a2ac$var$PolarisProjectSidebar;

});
parcelRegister("cVpr7", function(module, exports) {

let $968e8a0f228e2acd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $968e8a0f228e2acd$var$load("1VRB2"),
    $968e8a0f228e2acd$var$load("bABhq"),
    $968e8a0f228e2acd$var$load("h16d2")
]).then(()=>parcelRequire('5p73P'));

});



parcelRegister("4WnjH", function(module, exports) {

$parcel$export(module.exports, "SidebarFeedbackButton", () => $7fffab35036bc322$export$b270ed097d20c023);

var $eJOHy = parcelRequire("eJOHy");

var $alkjW = parcelRequire("alkjW");
var $4BzUI = parcelRequire("4BzUI");

var $3FEs8 = parcelRequire("3FEs8");

var $51Gwp = parcelRequire("51Gwp");

var $9JB3T = parcelRequire("9JB3T");

var $h8epd = parcelRequire("h8epd");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $5dqlp = parcelRequire("5dqlp");

var $igGHJ = parcelRequire("igGHJ");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $5Q9JR = parcelRequire("5Q9JR");

var $kkHo2 = parcelRequire("kkHo2");

var $kEUB1 = parcelRequire("kEUB1");

var $g1NZW = parcelRequire("g1NZW");

var $2cfd4 = parcelRequire("2cfd4");

var $6hoYB = parcelRequire("6hoYB");
function $7fffab35036bc322$export$b270ed097d20c023() {
    const environment = (0, $g1NZW.useEnvironment)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { openFeedbackCollector: openFeedbackCollector, closeFeedbackCollector: closeFeedbackCollector } = (0, $igGHJ.useFeedbackCollectorActions)();
    const formattedMessageNode = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $6hoYB.default).feedbackTitleDetailsNoLink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
            href: "https://support.atlassian.com/jira-software-cloud/docs/what-is-the-new-navigation-in-jira/",
            onClick: closeFeedbackCollector,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $6hoYB.default).feedbackTitleLearnMoreLinkText)));
    }, [
        closeFeedbackCollector
    ]);
    const onClickHandler = (0, $eJOHy.useCallback)(()=>{
        openFeedbackCollector({
            entrypointId: (0, $5dqlp.ENTRYPOINT_ID_NAVIGATION_REFRESH),
            feedbackContext: [
                {
                    id: 'environment',
                    value: environment
                },
                {
                    id: 'cloud-id',
                    value: cloudId
                },
                {
                    id: 'location',
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    value: (0, $kkHo2.default)(window?.location?.href ?? '')
                }
            ],
            feedbackGroupId: (0, $5Q9JR.NAV4_GENERAL_FEEDBACK_GROUP_ID),
            feedbackTitle: formatMessage((0, $6hoYB.default).feedbackTitle),
            feedbackTitleDetails: formattedMessageNode
        });
    }, [
        cloudId,
        environment,
        formatMessage,
        formattedMessageNode,
        openFeedbackCollector
    ]);
    const locale = (0, $2cfd4.useLocale)();
    const showPersistentInvite = // Ensure that we can turn off the locale check with a feature gate if needed
    // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $7jTnu.fg)('navx_persistent_invite_jira_new_non_free') && // Do not trigger an exposure on the experiment for non-English locales
    (locale?.toLowerCase().startsWith('en') ?? false) && (0, $epTsa.expVal)('navx_persistent_invite_jira_new_non_free_exp', 'global_invite_enabled', false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: formatMessage((0, $6hoYB.default).sidebarFeedbackButtonLabel),
        position: "top"
    }, showPersistentInvite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BzUI.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3FEs8))),
        onClick: onClickHandler,
        label: formatMessage((0, $6hoYB.default).sidebarFeedbackButtonLabel)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($3FEs8))),
        appearance: "subtle",
        onClick: onClickHandler
    }, formatMessage((0, $6hoYB.default).sidebarFeedbackButtonLabel)));
}

});
parcelRegister("3FEs8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c12e14f5c33454d538618fce8415497d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ac49483e8e577cb$var$_react = $2ac49483e8e577cb$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2ac49483e8e577cb$var$_baseNew = $2ac49483e8e577cb$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $2ac49483e8e577cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ac49483e8e577cb$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $2ac49483e8e577cb$var$_react.default.createElement($2ac49483e8e577cb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3.096a.5.5 0 0 0-.686-.464L7.5 4.758v4.734l5.314 2.126a.5.5 0 0 0 .686-.464zm-6 8.012 4.757 1.903A2 2 0 0 0 15 11.154V3.096a2 2 0 0 0-2.743-1.857L6.606 3.5H3a2 2 0 0 0-2 2v3.25a2 2 0 0 0 2 2h.5V13a2 2 0 0 0 2 2h1.25a.75.75 0 0 0 .75-.75zM6 9.25H3a.5.5 0 0 1-.5-.5V5.5A.5.5 0 0 1 3 5h3zm0 1.5v2.75h-.5A.5.5 0 0 1 5 13v-2.25z" clip-rule="evenodd"/>`
    }, props));
$2ac49483e8e577cb$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $2ac49483e8e577cb$var$_default = module.exports.default = $2ac49483e8e577cb$var$MegaphoneIcon;

});

parcelRegister("5dqlp", function(module, exports) {

$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $ee7e4c92cf35d1d1$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $ee7e4c92cf35d1d1$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $ee7e4c92cf35d1d1$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $ee7e4c92cf35d1d1$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $ee7e4c92cf35d1d1$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $ee7e4c92cf35d1d1$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $ee7e4c92cf35d1d1$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $ee7e4c92cf35d1d1$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", () => $ee7e4c92cf35d1d1$export$5bd148c13bb23f7a);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $ee7e4c92cf35d1d1$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $ee7e4c92cf35d1d1$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $ee7e4c92cf35d1d1$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", () => $ee7e4c92cf35d1d1$export$23f6d7b16d2210c1);
$parcel$export(module.exports, "ENTRY_POINT_ID_AUTODEV", () => $ee7e4c92cf35d1d1$export$1b65c2053cba0686);
$parcel$export(module.exports, "ENTRYPOINT_ID_PROJECT_BACKGROUNDS", () => $ee7e4c92cf35d1d1$export$9a234699f0515bf);
$parcel$export(module.exports, "ENTRY_POINT_ID_JOURNEY_BUILDER", () => $ee7e4c92cf35d1d1$export$f24169c529e6c9b5);
$parcel$export(module.exports, "EntryKeys", () => $ee7e4c92cf35d1d1$export$12d01b6c311a909a);
// Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $ee7e4c92cf35d1d1$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $ee7e4c92cf35d1d1$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $ee7e4c92cf35d1d1$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $ee7e4c92cf35d1d1$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $ee7e4c92cf35d1d1$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $ee7e4c92cf35d1d1$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $ee7e4c92cf35d1d1$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $ee7e4c92cf35d1d1$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $ee7e4c92cf35d1d1$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
const $ee7e4c92cf35d1d1$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $ee7e4c92cf35d1d1$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $ee7e4c92cf35d1d1$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $ee7e4c92cf35d1d1$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
const $ee7e4c92cf35d1d1$export$1b65c2053cba0686 = '88d39839-ba5c-4704-bfd6-7fe57ed8016b';
const $ee7e4c92cf35d1d1$export$86e0eeb08f5b7ea6 = 'ee8a71e7-85aa-4121-b455-e6316922e894';
const $ee7e4c92cf35d1d1$export$9a234699f0515bf = 'd0f0863a-fe78-4d40-b4f0-451c268594cc';
const $ee7e4c92cf35d1d1$export$f24169c529e6c9b5 = 'd5f62dde-d505-413b-a417-c2dd6979cac2';
const $ee7e4c92cf35d1d1$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment',
    SMART_REPLIES: 'smart-replies',
    COLLABORATIVE_SPRINTS: 'collaborative-sprints',
    PROJECT_RECAP_FEEDBACK_GROUP_ID: 'jira-notifications-project-recap'
});

});

parcelRegister("igGHJ", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $c308bdd6cba7f75a$export$4be696be8a3bff13);
$parcel$export(module.exports, "useFeedbackCollectorActions", () => $c308bdd6cba7f75a$export$dfb2ee2d9e73fa48);
$parcel$export(module.exports, "FeedbackActionsSubscriber", () => $c308bdd6cba7f75a$export$c35dbf16ebe9df04);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $c308bdd6cba7f75a$export$d4c72bab9d6cc13a = {
    isFeedbackCollectorOpen: false,
    entrypointId: undefined,
    email: undefined,
    additionalFields: undefined,
    feedbackTitle: undefined,
    feedbackContext: undefined,
    feedbackCollectorId: undefined,
    // default value of this prop is true so making sure inititally it is true
    showTypeField: true,
    submitButtonLabel: undefined,
    canBeContactedLabel: undefined,
    summaryPlaceholder: undefined,
    feedbackGroupLabels: undefined,
    onClose: undefined,
    feedbackTitleDetails: undefined,
    triggerRef: undefined,
    renderCustomContent: undefined,
    customFeedbackOptions: []
};
const $c308bdd6cba7f75a$export$e324594224ef24da = {
    openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
            // Reset to initial state to clear any leftover state
            dispatch($c308bdd6cba7f75a$export$e324594224ef24da.resetFeedbackCollectorState());
            setState({
                ...feedbackCollectorProps,
                isFeedbackCollectorOpen: true
            });
        },
    closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
            const { triggerRef: triggerRef } = getState();
            if (triggerRef) // Unfortunately we need a setTimeout here to delay the execution cycle because modal is yet to be closed
            setTimeout(()=>triggerRef.current?.focus(), 50);
            setState({
                isFeedbackCollectorOpen: false,
                triggerRef: undefined
            });
        },
    resetFeedbackCollectorState: ()=>({ setState: setState })=>{
            setState({
                ...$c308bdd6cba7f75a$export$d4c72bab9d6cc13a
            });
        },
    updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
            setState({
                renderCustomContent: updatedCustomRenderContent
            });
        },
    updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
            setState({
                additionalFields: updatedAdditionalFields
            });
        }
};
const $c308bdd6cba7f75a$var$Store = (0, $GtRbT.createStore)({
    name: 'feedback-collector',
    initialState: $c308bdd6cba7f75a$export$d4c72bab9d6cc13a,
    actions: $c308bdd6cba7f75a$export$e324594224ef24da
});
const $c308bdd6cba7f75a$export$4be696be8a3bff13 = (0, $iJq0l.createHook)($c308bdd6cba7f75a$var$Store);
const $c308bdd6cba7f75a$export$dfb2ee2d9e73fa48 = (0, $iJq0l.createActionsHook)($c308bdd6cba7f75a$var$Store);
const $c308bdd6cba7f75a$export$c35dbf16ebe9df04 = (0, $ht3nQ.createSubscriber)($c308bdd6cba7f75a$var$Store, {
    selector: null
});

});

parcelRegister("6hoYB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c970bb9b15a2743$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2c970bb9b15a2743$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    sidebarFeedbackButtonLabel: {
        "id": "sidebar-nav4-feedback-button.sidebar-feedback-button-label",
        "defaultMessage": "Give feedback on the new navigation"
    },
    feedbackTitle: {
        "id": "sidebar-nav4-feedback-button.utils.use-nav4-feedback-collector.feedback-title",
        "defaultMessage": "Help us improve the new navigation"
    },
    feedbackTitleDetailsWithLink: {
        "id": "sidebar-nav4-feedback-button.feedback-title-details",
        "defaultMessage": "We\u2019d love to hear about your experience with the new navigation. If needed, <a>you can switch back to the old navigation</a>."
    },
    feedbackTitleDetailsNoLink: {
        "id": "sidebar-nav4-feedback-button.feedback-title-details-no-link",
        "defaultMessage": "We\u2019d love to hear about your experience with the new navigation."
    },
    feedbackTitleLearnMoreLinkText: {
        "id": "sidebar-nav4-feedback-button.feedback-title-learn-more-link-text",
        "defaultMessage": "Learn more about the new navigation"
    }
});

});


parcelRegister("g5Uuh", function(module, exports) {

$parcel$export(module.exports, "AsyncNudgeBundledUsersFlagContainer", () => $3646062ad1682347$export$30d9dff000fbaa2d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $16sa1 = parcelRequire("16sa1");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $7jTnu = parcelRequire("7jTnu");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3646062ad1682347$var$NudgeBundledUsersFlagContainer = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("9EsCx")).then((module)=>module.NudgeBundledUsersXflow), {
    ssr: false,
    moduleId: "./src/packages/growth/nudge-bundled-users-to-join-connie/src/ui/index.tsx"
});
const $3646062ad1682347$export$30d9dff000fbaa2d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "nudgeBundledUserFlag",
        packageName: "nudgeBundledUsersToJoinConnie",
        fallback: "unmount",
        teamName: "confluenceOnboarding"
    }, (0, $7jTnu.fg)('jiv-blindspot-fixes-2025-07-01') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nudge-bundled-users-flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nudge-bundled-users-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3646062ad1682347$var$NudgeBundledUsersFlagContainer, null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nudge-bundled-users-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3646062ad1682347$var$NudgeBundledUsersFlagContainer, null)));

});
parcelRegister("9EsCx", function(module, exports) {

let $706e0ceec5b785b0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $706e0ceec5b785b0$var$load("fp08L").then(()=>parcelRequire('9EcbH'));

});


parcelRegister("YVvuv", function(module, exports) {

$parcel$export(module.exports, "AsyncNudgeInactiveConfluenceUserFlagContainer", () => $5dfcf891840b088d$export$ab9e9eb42f22ca03);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $4xbv3 = parcelRequire("4xbv3");

var $16sa1 = parcelRequire("16sa1");

var $gzcjr = parcelRequire("gzcjr");

var $7jTnu = parcelRequire("7jTnu");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5dfcf891840b088d$var$NudgeInactiveConfluenceUserFlagContainer = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("4w2Hr")).then((module)=>module.NudgeInactiveConfluenceUser), {
    ssr: false,
    moduleId: "./src/packages/growth/nudge-inactive-confluence-user/src/ui/index.tsx"
});
const $5dfcf891840b088d$export$ab9e9eb42f22ca03 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "nudgeInactiveConfluenceUserFlag",
        packageName: "nudgeInactiveConfluenceUser",
        fallback: "unmount",
        teamName: "cc-flywheel-adoption"
    }, (0, $7jTnu.fg)('jiv-blindspot-fixes-2025-07-01') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nudge-inactive-confluence-user-flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nudge-inactive-confluence-user-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: "nudgeInactiveConfluenceUserFlag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5dfcf891840b088d$var$NudgeInactiveConfluenceUserFlagContainer, null)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nudge-inactive-confluence-user-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: "nudgeInactiveConfluenceUserFlag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5dfcf891840b088d$var$NudgeInactiveConfluenceUserFlagContainer, null))));

});
parcelRegister("4w2Hr", function(module, exports) {

let $349c3eb031c4fb9f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $349c3eb031c4fb9f$var$load("kvG67").then(()=>parcelRequire('hPeTv'));

});


parcelRegister("gkQFl", function(module, exports) {

$parcel$export(module.exports, "SidebarEntryPointSelector", () => $868be1a8e0d262cb$export$7b792d211e60bd1d);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jrulJ = parcelRequire("jrulJ");


var $2dBpR = parcelRequire("2dBpR");

var $1KdDN = parcelRequire("1KdDN");

var $8vXrD = parcelRequire("8vXrD");

var $16sa1 = parcelRequire("16sa1");

var $hih5V = parcelRequire("hih5V");

var $iMOVa = parcelRequire("iMOVa");




var $iyTaR = parcelRequire("iyTaR");

var $4xbv3 = parcelRequire("4xbv3");

var $e9N38 = parcelRequire("e9N38");

var $20Hsz = parcelRequire("20Hsz");
function $868be1a8e0d262cb$export$7b792d211e60bd1d() {
    const currentRoute = (0, $hih5V.useCurrentRoute)();
    const paramsForGetNav4SidebarId = (0, $20Hsz.useGetParamsForGetNav4SidebarId)();
    const currentSidebarId = (0, $20Hsz.getNav4SidebarId)(paramsForGetNav4SidebarId);
    const currentEntryPointRef = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$50ea883ba6f28ff5));
    const [sidebarConfig, setSidebarConfig] = (0, $eJOHy.useState)(()=>{
        // We want to avoid switching between the SidebarSelector and the sidebar entryPoint as we navigate through the SPA.
        // To do that, we need to keep using the __initial__ sidebar entryPoint if we haven't changed sidebars.
        // When we do switch sidebars, keep using SidebarSelector from that point onwards (for now).
        // When all of the sidebars are using entryPoints, we can deprecate the SidebarSelector.
        const attributes = {
            navigationLayer: (0, $002870cfa80d64f4$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $95eb6070d868c1b7$export$2ee9e5a3556c1e43),
            navState: (0, $107c403b1827dc68$export$2bd315ece9f68967),
            stage: (0, $iyTaR.getNav4Rollout)().stage
        };
        return {
            Component: ()=>currentEntryPointRef && currentRoute.navigation?.sidebarId === currentSidebarId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
                    name: "nav4-sidebar-entrypoint"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
                    fallback: "flag",
                    id: "nav4-sidebar-entrypoint",
                    packageName: "jira-page-container-v2"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMOVa.NavigateBackProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
                    attributes: attributes
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
                    name: "nav4-sidebar-entrypoint-placeholder",
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null),
                    entryPointReference: currentEntryPointRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
                    entryPointReference: currentEntryPointRef,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    props: {}
                })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e9N38.SidebarSelector), null),
            sidebarId: currentSidebarId
        };
    });
    (0, $eJOHy.useEffect)(()=>{
        if (sidebarConfig.sidebarId !== currentSidebarId) setSidebarConfig({
            Component: (0, $e9N38.SidebarSelector),
            sidebarId: currentSidebarId
        });
    }, [
        currentSidebarId,
        sidebarConfig.sidebarId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(sidebarConfig.Component, null);
}

});
parcelRegister("iyTaR", function(module, exports) {

$parcel$export(module.exports, "getNav4Rollout", () => $de9022033aff0d17$export$84a05d3b37ec5d2);

var $3ZJvm = parcelRequire("3ZJvm");

var $9hKkF = parcelRequire("9hKkF");

var $26U8a = parcelRequire("26U8a");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $8LbXh = parcelRequire("8LbXh");

var $lgw54 = parcelRequire("lgw54");

var $f4RbK = parcelRequire("f4RbK");

var $lrIjf = parcelRequire("lrIjf");
const $de9022033aff0d17$export$84a05d3b37ec5d2 = (0, (/*@__PURE__*/$parcel$interopDefault($3ZJvm)))([
    [
        ()=>!(0, $7jTnu.fg)('jira_nav4'),
        (0, (/*@__PURE__*/$parcel$interopDefault($9hKkF)))((0, $8LbXh.NAV4_ROLLOUT_NONE))
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_dogfooding'),
        (0, $f4RbK.getNav4RolloutForDogfooding)
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_beta_sandboxes'),
        (0, $lgw54.getNav4RolloutForBetaCohort)('sandboxes')
    ],
    [
        ()=>(0, $epTsa.expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false),
        (0, $lgw54.getNav4RolloutForBetaCohort)('free-customers')
    ],
    [
        ()=>(0, $epTsa.expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false),
        (0, $lgw54.getNav4RolloutForBetaCohort)('new-customers')
    ],
    [
        ()=>(0, $epTsa.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false),
        (0, $lgw54.getNav4RolloutForBetaCohort)('new-customers-x')
    ],
    // Break up cond for easier testing.
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($26U8a))),
        ()=>(0, $lrIjf.getNav4RolloutForGaAndBeyond)()
    ]
]);

});
parcelRegister("8LbXh", function(module, exports) {

$parcel$export(module.exports, "NAV4_ROLLOUT_NONE", () => $8b7cc1a01a020390$export$3b602cac1f385c06);
$parcel$export(module.exports, "NAV4_ROLLOUT_MOBILE", () => $8b7cc1a01a020390$export$e748a16828d2f61f);
const $8b7cc1a01a020390$export$3b602cac1f385c06 = {
    stage: 'none'
};
const $8b7cc1a01a020390$export$e748a16828d2f61f = {
    stage: 'mobile'
};

});

parcelRegister("lgw54", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForBetaCohort", () => $319abb71143623a2$export$d0b7d7e3a8d0a0c9);
const $319abb71143623a2$export$d0b7d7e3a8d0a0c9 = (cohort)=>()=>({
            stage: 'beta',
            cohort: cohort
        });

});

parcelRegister("f4RbK", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForDogfooding", () => $050075f20fb5392b$export$f1e751a9a9d68fb5);

var $3ZJvm = parcelRequire("3ZJvm");

var $26U8a = parcelRequire("26U8a");

var $7jTnu = parcelRequire("7jTnu");

var $nK7ig = parcelRequire("nK7ig");
const $050075f20fb5392b$var$dogfoodingPhase = (phase)=>()=>phase !== 3 ? {
            stage: 'dogfooding',
            phase: phase,
            isUserOptOut: (0, $nK7ig.getIsNav4UserOptOut)()
        } : {
            stage: 'dogfooding',
            phase: phase
        };
const $050075f20fb5392b$export$f1e751a9a9d68fb5 = (0, (/*@__PURE__*/$parcel$interopDefault($3ZJvm)))([
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_dogfooding_phase-2'),
        $050075f20fb5392b$var$dogfoodingPhase(2)
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_dogfooding_phase-1'),
        $050075f20fb5392b$var$dogfoodingPhase(1)
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($26U8a))),
        $050075f20fb5392b$var$dogfoodingPhase(3)
    ]
]);

});

parcelRegister("lrIjf", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForGaAndBeyond", () => $cdb71e5e4666ce0e$export$99bed161b1040362);

var $3ZJvm = parcelRequire("3ZJvm");

var $9hKkF = parcelRequire("9hKkF");

var $26U8a = parcelRequire("26U8a");

var $7jTnu = parcelRequire("7jTnu");

var $fYeTG = parcelRequire("fYeTG");

var $nK7ig = parcelRequire("nK7ig");

var $8LbXh = parcelRequire("8LbXh");
const $cdb71e5e4666ce0e$export$99bed161b1040362 = (0, (/*@__PURE__*/$parcel$interopDefault($3ZJvm)))([
    // Later GA phases eclipse earlier phases.
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_ga_phase-3'),
        ()=>({
                stage: 'ga',
                phase: 3
            })
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_ga_phase-2'),
        ()=>({
                stage: 'ga',
                phase: 2,
                isUserOptOut: (0, $nK7ig.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_ga_phase-1-5'),
        ()=>({
                stage: 'ga',
                phase: 1.5,
                isAdmin: (0, $nK7ig.getIsAdmin)(),
                isTenantOptOut: (0, $nK7ig.getIsNav4TenantOptOut)(),
                isUserOptOut: (0, $nK7ig.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_ga_phase-1'),
        ()=>({
                stage: 'ga',
                phase: 1,
                isAdmin: (0, $nK7ig.getIsAdmin)(),
                isTenantOptIn: (0, $nK7ig.getIsNav4TenantOptIn)(),
                isUserOptIn: (0, $nK7ig.getIsNav4UserOptIn)(),
                isUserOptOut: (0, $nK7ig.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_ga_sandboxes'),
        ()=>({
                stage: 'ga',
                cohort: 'sandboxes',
                isUserOptIn: (0, $nK7ig.getIsNav4UserOptIn)()
            })
    ],
    [
        ()=>(0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)(),
        (0, (/*@__PURE__*/$parcel$interopDefault($9hKkF)))((0, $8LbXh.NAV4_ROLLOUT_MOBILE))
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($26U8a))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9hKkF)))((0, $8LbXh.NAV4_ROLLOUT_NONE))
    ]
]);

});


parcelRegister("e9N38", function(module, exports) {

$parcel$export(module.exports, "SidebarSelector", () => $7f3ec08940bc1134$export$7937e2d32a777fcb);

var $eJOHy = parcelRequire("eJOHy");

var $jRu18 = parcelRequire("jRu18");

var $ln6Iy = parcelRequire("ln6Iy");

var $gDXSd = parcelRequire("gDXSd");

var $7jTnu = parcelRequire("7jTnu");

var $5RW99 = parcelRequire("5RW99");




var $iyTaR = parcelRequire("iyTaR");

var $iMOVa = parcelRequire("iMOVa");

var $iIXZF = parcelRequire("iIXZF");

var $7dhle = parcelRequire("7dhle");

var $bfoC6 = parcelRequire("bfoC6");

var $2EmlI = parcelRequire("2EmlI");

var $kSAnj = parcelRequire("kSAnj");

var $19oS3 = parcelRequire("19oS3");

var $kA5R0 = parcelRequire("kA5R0");

var $av7W4 = parcelRequire("av7W4");

var $fXF6E = parcelRequire("fXF6E");

var $fJ06f = parcelRequire("fJ06f");

var $b2wim = parcelRequire("b2wim");

var $fIogS = parcelRequire("fIogS");

var $a7qPX = parcelRequire("a7qPX");

var $85ZZg = parcelRequire("85ZZg");

var $b2Fy3 = parcelRequire("b2Fy3");

var $jyuS3 = parcelRequire("jyuS3");

var $8vXrD = parcelRequire("8vXrD");

var $1Wo5Y = parcelRequire("1Wo5Y");

var $kDeux = parcelRequire("kDeux");

var $dKJXK = parcelRequire("dKJXK");

var $2ZbI9 = parcelRequire("2ZbI9");

var $1eGpA = parcelRequire("1eGpA");

var $6tXQB = parcelRequire("6tXQB");

var $9b0Rz = parcelRequire("9b0Rz");

var $4xbv3 = parcelRequire("4xbv3");

var $2aY2d = parcelRequire("2aY2d");

var $iZ2Qf = parcelRequire("iZ2Qf");

var $kfvK2 = parcelRequire("kfvK2");

var $kfvK2 = parcelRequire("kfvK2");

var $dmxJQ = parcelRequire("dmxJQ");
const $7f3ec08940bc1134$var$entitySettingsSidebarAnalyticsAttributes = {
    navigationLayer: (0, $002870cfa80d64f4$export$33d8c916a600c5e9)
};
const $7f3ec08940bc1134$var$ProjectSettingsSidebarSelector = ()=>{
    const { data: project, loading: loading, error: error } = (0, $2aY2d.useProjectContext)();
    let sidebar = null;
    if (loading) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null);
    if (error) throw error;
    if (project?.projectType === (0, $ln6Iy.CORE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jyuS3.default), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2Fy3.default), {
        project: project
    });
    if (project?.projectType === (0, $ln6Iy.SOFTWARE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9b0Rz.default), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6tXQB.default), {
        project: project
    });
    if (project?.projectType === (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT)) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDeux.default), {
        project: project
    });
    if (project?.projectType === (0, $ln6Iy.CUSTOMER_SERVICE_PROJECT) && (0, $7jTnu.fg)('jcs_project_type_m3')) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1eGpA.AsyncJcsProjectSettingsSidebar), {
        project: project
    });
    if (project?.projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT) || project?.projectType === (0, $ln6Iy.CUSTOMER_SERVICE_PROJECT) && !(0, $7jTnu.fg)('jcs_project_type_m3')) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZbI9.AsyncJsmTmpProjectSettingsSidebar), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKJXK.AsyncJsmCmpProjectSettingsSidebar), {
        project: project
    });
    if (!sidebar) throw new Error(`No project settings sidebar found for the project type: ${project?.projectType}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        containerId: project ? String(project.projectId) : undefined,
        containerType: "project",
        attributes: $7f3ec08940bc1134$var$entitySettingsSidebarAnalyticsAttributes
    }, sidebar);
};
const $7f3ec08940bc1134$var$ConnectAppSidebarSelector = ()=>{
    const { isActive: isProjectSettingsConnectAppActive } = (0, $1Wo5Y.useIsConnectAppActive)();
    return isProjectSettingsConnectAppActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f3ec08940bc1134$var$ProjectSettingsSidebarSelector, null) : null;
};
const $7f3ec08940bc1134$var$BoardSettingsSidebar = ()=>{
    const { data: project, loading: loading, error: error } = (0, $2aY2d.useProjectContext)();
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bfoC6.Skeleton), null);
    if (error) throw error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        containerId: project ? String(project.projectId) : undefined,
        containerType: "project",
        attributes: $7f3ec08940bc1134$var$entitySettingsSidebarAnalyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7dhle.default), null));
};
const $7f3ec08940bc1134$var$REDIRECT_ROUTES_NAMES = new Set([
    'browse-project-redirect',
    'servicedesk-redirect'
]);
const $7f3ec08940bc1134$var$getSidebarForRoute = (state, { configParam: configParam, shouldUseJSM: shouldUseJSM, isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive, isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive, isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive })=>{
    const sidebarId = state.route.navigation?.sidebarId;
    const pathname = state.location.pathname;
    switch(sidebarId){
        case (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85ZZg.default), null);
        case (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS:
            if (!pathname.includes('/discover')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kSAnj.default), null);
            break;
        case (0, $5RW99.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $av7W4.default), null);
        case (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $19oS3.default), null);
        case (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS:
            if (pathname.includes('/jira-service-management-chatops-and-video-tools') && shouldUseJSM) break;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kA5R0.default), null);
        case (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2wim.default), null);
        case (0, $5RW99.SIDEBAR_ID).PERSONAL_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a7qPX.default), null);
        case (0, $5RW99.SIDEBAR_ID).HELP_CENTER_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fIogS.default), null);
        case (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f3ec08940bc1134$var$ProjectSettingsSidebarSelector, null);
        case (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fXF6E.default), null);
        default:
            break;
    }
    if (state.route.name === 'polaris-ideas' && state.match.params.section === 'settings') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f3ec08940bc1134$var$ProjectSettingsSidebarSelector, null);
    if (state.route.name === 'your-work') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iIXZF.SidebarContent), null);
    if (isProjectSettingsConnectAppActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f3ec08940bc1134$var$ConnectAppSidebarSelector, null);
    if (state.route.group === 'classic-software' && (0, $iZ2Qf.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(configParam)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f3ec08940bc1134$var$BoardSettingsSidebar, null);
    if (isGlobalAppsSettingsConnectItemActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kSAnj.default), null);
    if (isGlobalSystemSettingsConnectItemActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2wim.default), null);
};
const $7f3ec08940bc1134$export$ac727539f28734c4 = (state)=>{
    return !$7f3ec08940bc1134$var$REDIRECT_ROUTES_NAMES.has(state.route.name);
};
const $7f3ec08940bc1134$export$7ea19f35e3a0b199 = (0, $kfvK2.createRouterSelector)($7f3ec08940bc1134$export$ac727539f28734c4);
const $7f3ec08940bc1134$export$b1253b9403840da1 = ()=>{
    const { saveCurrentRoute: saveCurrentRoute } = (0, $iMOVa.useNavigateBack)();
    const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, $2EmlI.useGlobalAppsSettingsConnectItemActive)();
    const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, $fJ06f.useGlobalSystemSettingsConnectItemActive)();
    const { isActive: isProjectSettingsConnectAppActive } = (0, $1Wo5Y.useIsConnectAppActive)();
    const { shouldUseJSM: shouldUseJSM } = (0, $gDXSd.useOgTenantInfo)();
    const isNonRedirectRoute = $7f3ec08940bc1134$export$7ea19f35e3a0b199();
    const configParam = (0, $dmxJQ.useMaybeConfigParam)() || '';
    const location = (0, $jRu18.useLocation)();
    const [sidebar, setSidebar] = (0, $eJOHy.useState)($7f3ec08940bc1134$var$getSidebarForRoute((0, $kfvK2.getRouterState)(), {
        configParam: configParam,
        shouldUseJSM: shouldUseJSM,
        isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive,
        isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive,
        isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive
    }));
    (0, $eJOHy.useEffect)(()=>{
        return (0, $kfvK2.addRouteListener)((state)=>{
            setSidebar($7f3ec08940bc1134$var$getSidebarForRoute(state, {
                configParam: state.query.config || state.match.params.config || '',
                isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive,
                isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive,
                isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive,
                shouldUseJSM: shouldUseJSM
            }));
        });
    }, [
        isGlobalAppsSettingsConnectItemActive,
        isGlobalSystemSettingsConnectItemActive,
        isProjectSettingsConnectAppActive,
        shouldUseJSM
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // NOTE: We need to AVOID saving the route if we're on a connect app...
        if (!sidebar && isNonRedirectRoute && !isProjectSettingsConnectAppActive) {
            const url = `${location.pathname}${location.search}${location.hash}`;
            saveCurrentRoute(url);
        }
        if (!sidebar && isProjectSettingsConnectAppActive) setSidebar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f3ec08940bc1134$var$ConnectAppSidebarSelector, null));
    }, [
        isNonRedirectRoute,
        isProjectSettingsConnectAppActive,
        location,
        saveCurrentRoute,
        sidebar
    ]);
    if (sidebar) return sidebar;
    // Main nav (with "Your work", Starred, Recent items etc.)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iIXZF.SidebarContent), null);
};
const $7f3ec08940bc1134$export$7937e2d32a777fcb = ()=>{
    const attributes = (0, $eJOHy.useMemo)(()=>({
            navigationLayer: (0, $002870cfa80d64f4$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $95eb6070d868c1b7$export$2ee9e5a3556c1e43),
            navState: (0, $107c403b1827dc68$export$2bd315ece9f68967),
            stage: (0, $iyTaR.getNav4Rollout)().stage
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMOVa.NavigateBackProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f3ec08940bc1134$export$b1253b9403840da1, null)));
};

});
parcelRegister("7dhle", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe1bdaf97010e9b1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $bfoC6 = parcelRequire("bfoC6");

const $fe1bdaf97010e9b1$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("1Ds5S")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/board/src/ui/main.tsx"
});
const $fe1bdaf97010e9b1$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.board-settings",
        packageName: "jiraNavigationAppsSidebarNav4BoardSettings",
        ufoName: "nav4.sidebar.board-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.board-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bfoC6.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe1bdaf97010e9b1$var$LazySidebarContent, null)));
var $fe1bdaf97010e9b1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($fe1bdaf97010e9b1$var$AsyncSidebar);

});
parcelRegister("bfoC6", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $fde18349018998e4$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");
const $fde18349018998e4$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $fde18349018998e4$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $fde18349018998e4$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $fde18349018998e4$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $fde18349018998e4$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $fde18349018998e4$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $fde18349018998e4$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $fde18349018998e4$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $fde18349018998e4$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $fde18349018998e4$var$menuItem
    })));
const $fde18349018998e4$var$containerStyles = (0, $5Wv5g.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $fde18349018998e4$var$backButton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $fde18349018998e4$var$headingSkeleton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $fde18349018998e4$var$menuItem = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});


parcelRegister("2EmlI", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsConnectItems", () => $e4ae8c2197518c01$export$f0785b98c99d344c);
$parcel$export(module.exports, "useIsAppsSettingsConnectAppModule", () => $e4ae8c2197518c01$export$8dd86b1eb9fdf786);
$parcel$export(module.exports, "useGlobalAppsSettingsConnectItemActive", () => $e4ae8c2197518c01$export$83008eebb9fccef3);

var $eJOHy = parcelRequire("eJOHy");

var $jImTl = parcelRequire("jImTl");

var $gcPEx = parcelRequire("gcPEx");

var $4J9V1 = parcelRequire("4J9V1");

var $8zPcN = parcelRequire("8zPcN");

var $7FIkD = parcelRequire("7FIkD");

var $jRu18 = parcelRequire("jRu18");

var $QaFzq = parcelRequire("QaFzq");
const $e4ae8c2197518c01$var$getItems = (d)=>(0, $gcPEx.getLinks)(d, [
        'admin_plugins_menu'
    ], {
        skipFilter: true
    }).filter((v)=>![
            'upm_section',
            'jpo-ws-admin'
        ].includes(v.id)) // remove sections also statically defined
    .map((0, $4J9V1.transformLink)) // Apply transformation to each link
    .filter(Boolean); // Remove falsy values
const $e4ae8c2197518c01$export$f0785b98c99d344c = ()=>{
    const { data: data, loading: loading, error: error } = (0, $8zPcN.useNavigationGlobalResource)();
    const items = (0, $eJOHy.useMemo)(()=>data && $e4ae8c2197518c01$var$getItems(data), [
        data
    ]);
    return {
        data: items,
        loading: loading,
        error: error
    };
};
const $e4ae8c2197518c01$export$ae997bf97ec22b71 = new Set([
    'configurePage',
    'postInstallPage'
]);
const $e4ae8c2197518c01$export$8dd86b1eb9fdf786 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $7FIkD.useConnectGeneralResource)();
    return {
        isActive: $e4ae8c2197518c01$export$ae997bf97ec22b71.has(data?.moduleType),
        loading: loading,
        error: error
    };
};
const $e4ae8c2197518c01$export$83008eebb9fccef3 = ()=>{
    const location = (0, $jRu18.useLocation)();
    const route = (0, $QaFzq.useRoute)();
    const { data: data, loading: loading, error: error } = $e4ae8c2197518c01$export$f0785b98c99d344c();
    const { isActive: isAppsSettingsConnectAppModuleActive, loading: isAppsSettingsConnectAppModuleLoading, error: isAppsSettingsConnectAppModuleError } = $e4ae8c2197518c01$export$8dd86b1eb9fdf786();
    const isActive = (0, $eJOHy.useMemo)(()=>Boolean(route && data && (0, $jImTl.findItemAndStack)(data, route.name, location)?.selected), [
        data,
        route,
        location
    ]);
    return {
        isActive: isActive || isAppsSettingsConnectAppModuleActive,
        loading: loading || isAppsSettingsConnectAppModuleLoading,
        error: error || isAppsSettingsConnectAppModuleError
    };
};

});
parcelRegister("jImTl", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $423836af2db17ab5$export$751e2e6237002565);

var $cSmYj = parcelRequire("cSmYj");

var $7ZUpE = parcelRequire("7ZUpE");
// JSPA-1062 remove qs items that might not always be there
const $423836af2db17ab5$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $423836af2db17ab5$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $423836af2db17ab5$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $7ZUpE.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $423836af2db17ab5$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $423836af2db17ab5$var$splitRelevantQs(itemQs);
        const sameQuery = $423836af2db17ab5$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $423836af2db17ab5$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});

parcelRegister("gcPEx", function(module, exports) {

$parcel$export(module.exports, "getLinks", () => $2b95da89bb9dc6db$export$8054dcb2b42da45c);

var $b6kVM = parcelRequire("b6kVM");
const $2b95da89bb9dc6db$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
        if (item.id === legacyId) return item.links;
        return item.links && $2b95da89bb9dc6db$var$findChildLinks(item.links, legacyId);
    }).find(Boolean);
const $2b95da89bb9dc6db$var$getLinksFromSidebar = (sidebarConfig, legacyId)=>{
    const links = legacyId != null ? $2b95da89bb9dc6db$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
    return links || [];
};
const $2b95da89bb9dc6db$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
    const acc = [];
    locations.forEach((location)=>{
        const links = $2b95da89bb9dc6db$var$getLinksFromSidebar(sidebarConfig, location);
        if (omitSections === true) {
            // merge 2 arrays in good performance way
            Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
            return;
        }
        // merge 2 arrays in good performance way
        Array.prototype.push.apply(acc, links);
    });
    return acc.filter((item)=>{
        if (!item) return false;
        if (skipFilter === true) return true;
        const hasConnectPrefix = item.id && item.id.includes((0, $b6kVM.connectPrefix));
        if (hasConnectPrefix) return true;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"sd-reports-addons" | "sd-queues-addons" | "com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent"'.
        const isConnectSection = (0, $b6kVM.connectSections).includes(item.id);
        if (isConnectSection) return true;
        const isJsdConnectSection = item.id && item.id.includes((0, $b6kVM.jsdConnectPrefix));
        if (isJsdConnectSection) return true;
        return false;
    });
};

});
parcelRegister("b6kVM", function(module, exports) {

$parcel$export(module.exports, "connectPrefix", () => $97b53aed42af60a7$export$196d83ebd873fb40);
$parcel$export(module.exports, "jsdConnectPrefix", () => $97b53aed42af60a7$export$7fac8f726f52d70);
$parcel$export(module.exports, "connectSections", () => $97b53aed42af60a7$export$b1c2c1fc5d10280);

var $hEw7G = parcelRequire("hEw7G");
const $97b53aed42af60a7$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
const $97b53aed42af60a7$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
const $97b53aed42af60a7$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const $97b53aed42af60a7$var$jsdQueuesConnectSection = 'sd-queues-addons';
const $97b53aed42af60a7$export$b1c2c1fc5d10280 = [
    $97b53aed42af60a7$var$legacyAddonPanelLinkId,
    (0, $hEw7G.REPORTS_IDS).REPORTS_ADDONS,
    $97b53aed42af60a7$var$jsdQueuesConnectSection
];

});


parcelRegister("4J9V1", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $eb68c1498c872b65$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $eb68c1498c872b65$export$27267b6b6650eaa5);
const $eb68c1498c872b65$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($eb68c1498c872b65$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $eb68c1498c872b65$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($eb68c1498c872b65$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});

parcelRegister("8zPcN", function(module, exports) {

$parcel$export(module.exports, "useNavigationGlobalResource", () => $1b2e4ec3360c640b$export$1e1c317ed5b99faa);

var $enHI7 = parcelRequire("enHI7");

var $eJrcF = parcelRequire("eJrcF");
const $1b2e4ec3360c640b$export$1e1c317ed5b99faa = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)((0, $enHI7.navigationSidebarGlobalResource));
    return {
        data: data && data.response,
        loading: loading,
        error: error
    };
};

});


parcelRegister("kSAnj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d321428aa869415$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $bYKAe = parcelRequire("bYKAe");

var $er9fy = parcelRequire("er9fy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $8d321428aa869415$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("5NSsm")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/apps/src/ui/main.tsx"
});
const $8d321428aa869415$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.apps-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsAppsSettings",
        ufoName: "nav4.sidebar.global-settings.apps-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYKAe.SidebarContent), {
        currentPageName: "apps",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-apps.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.global-settings.apps-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $er9fy.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8d321428aa869415$var$LazySidebarContent, null))));
};
var $8d321428aa869415$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($8d321428aa869415$var$AsyncSidebar);

});
parcelRegister("5NSsm", function(module, exports) {

let $439bc549bdc56e3e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $439bc549bdc56e3e$var$load("9A9u4").then(()=>parcelRequire('kNLEl'));

});


parcelRegister("19oS3", function(module, exports) {

$parcel$export(module.exports, "default", () => $778f70e057490678$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $bYKAe = parcelRequire("bYKAe");

var $er9fy = parcelRequire("er9fy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $778f70e057490678$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("gILNU")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/issues/src/ui/main.tsx"
});
const $778f70e057490678$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.issues-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsIssuesSettings",
        ufoName: "nav4.sidebar.global-settings.issues-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYKAe.SidebarContent), {
        currentPageName: "issues",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-issues.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.global-settings.issues-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $er9fy.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($778f70e057490678$var$LazySidebarContent, null))));
};
var $778f70e057490678$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($778f70e057490678$var$AsyncSidebar);

});
parcelRegister("gILNU", function(module, exports) {

let $c2c5d64a41bd277b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c2c5d64a41bd277b$var$load("eIAMz").then(()=>parcelRequire('8gRGg'));

});


parcelRegister("kA5R0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfd553c106a4aa5c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $bYKAe = parcelRequire("bYKAe");

var $er9fy = parcelRequire("er9fy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $bfd553c106a4aa5c$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("eMfQU")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/products/src/ui/main.tsx"
});
const $bfd553c106a4aa5c$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.products-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProductsSettings",
        ufoName: "nav4.sidebar.global-settings.products-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYKAe.SidebarContent), {
        currentPageName: "products",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.global-settings.products-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $er9fy.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bfd553c106a4aa5c$var$LazySidebarContent, null))));
};
var $bfd553c106a4aa5c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($bfd553c106a4aa5c$var$AsyncSidebar);

});
parcelRegister("eMfQU", function(module, exports) {

let $ac21d850ee68e7a6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ac21d850ee68e7a6$var$load("2UG02").then(()=>parcelRequire('5dOp9'));

});


parcelRegister("av7W4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e88c301d43faf3c1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $bYKAe = parcelRequire("bYKAe");

var $er9fy = parcelRequire("er9fy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $e88c301d43faf3c1$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("7uCMB")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/projects/src/ui/main.tsx"
});
const $e88c301d43faf3c1$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.projects-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProjectsSettings",
        ufoName: "nav4.sidebar.global-settings.projects-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYKAe.SidebarContent), {
        currentPageName: "projects",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-projects.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.global-settings.projects-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $er9fy.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e88c301d43faf3c1$var$LazySidebarContent, null))));
};
var $e88c301d43faf3c1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($e88c301d43faf3c1$var$AsyncSidebar);

});
parcelRegister("7uCMB", function(module, exports) {

let $57496b3c9fa38be9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $57496b3c9fa38be9$var$load("6a3lM").then(()=>parcelRequire('1P2v5'));

});


parcelRegister("fJ06f", function(module, exports) {

$parcel$export(module.exports, "useGlobalSystemSettingsConnectItems", () => $3b048a44b2aa0633$export$68950d4e14439158);
$parcel$export(module.exports, "useGlobalSystemSettingsConnectItemActive", () => $3b048a44b2aa0633$export$5efb701a2106707a);

var $eJOHy = parcelRequire("eJOHy");

var $jImTl = parcelRequire("jImTl");

var $gcPEx = parcelRequire("gcPEx");

var $4J9V1 = parcelRequire("4J9V1");

var $azlgS = parcelRequire("azlgS");

var $8zPcN = parcelRequire("8zPcN");

var $7FIkD = parcelRequire("7FIkD");

var $jRu18 = parcelRequire("jRu18");

var $QaFzq = parcelRequire("QaFzq");
const $3b048a44b2aa0633$var$getItems = (d)=>(0, $gcPEx.getLinks)(d, [
        'admin_system_menu'
    ], {
        skipFilter: true
    }).map((0, $4J9V1.transformLink)) // Apply transformation to each link
    .filter(Boolean); // Remove falsy values
const $3b048a44b2aa0633$export$68950d4e14439158 = (0, $azlgS.withThrowOnError)(()=>{
    const { data: data, loading: loading, error: error } = (0, $8zPcN.useNavigationGlobalResource)();
    const items = (0, $eJOHy.useMemo)(()=>data && $3b048a44b2aa0633$var$getItems(data), [
        data
    ]);
    return {
        data: items,
        loading: loading,
        error: error
    };
});
const $3b048a44b2aa0633$export$5efb701a2106707a = ()=>{
    const location = (0, $jRu18.useLocation)();
    const route = (0, $QaFzq.useRoute)();
    const { data: data, loading: loading, error: error } = $3b048a44b2aa0633$export$68950d4e14439158();
    const { data: connectGeneralData, loading: connectGeneralResourceLoading, error: connectGeneralResourceError } = (0, $7FIkD.useConnectGeneralResource)();
    const isActive = (0, $eJOHy.useMemo)(()=>Boolean(route && data && (0, $jImTl.findItemAndStack)(data, route.name, location)?.selected), [
        data,
        route,
        location
    ]);
    return {
        isActive: isActive || connectGeneralData?.moduleType === 'adminPages',
        loading: loading || connectGeneralResourceLoading,
        error: error || connectGeneralResourceError
    };
};

});
parcelRegister("azlgS", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $bf2fcf741dfd4e8c$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $gRw8I = parcelRequire("gRw8I");
const $bf2fcf741dfd4e8c$var$isDataEmpty = (data)=>data == null;
function $bf2fcf741dfd4e8c$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $gRw8I.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $bf2fcf741dfd4e8c$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});


parcelRegister("b2wim", function(module, exports) {

$parcel$export(module.exports, "default", () => $e339f81da27d71ae$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $bYKAe = parcelRequire("bYKAe");

var $er9fy = parcelRequire("er9fy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $e339f81da27d71ae$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("bJNh9")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/system/src/ui/main.tsx"
});
const $e339f81da27d71ae$var$AsyncSidebar = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.system-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsSystemSettings",
        ufoName: "nav4.sidebar.global-settings.system-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYKAe.SidebarContent), {
        currentPageName: "system",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-system.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.global-settings.system-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $er9fy.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e339f81da27d71ae$var$LazySidebarContent, null))));
};
var $e339f81da27d71ae$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($e339f81da27d71ae$var$AsyncSidebar);

});
parcelRegister("bJNh9", function(module, exports) {

let $88ba1ec5748dee93$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $88ba1ec5748dee93$var$load("kv0YL").then(()=>parcelRequire('a6h8L'));

});


parcelRegister("fIogS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7867dc9df0604916$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $5p56C = parcelRequire("5p56C");

const $7867dc9df0604916$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("iR6yp")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/help-center/src/ui/main.tsx"
});
const $7867dc9df0604916$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.help-center-settings",
        packageName: "jiraNavigationAppsSidebarNav4HelpCenterSettings",
        ufoName: "nav4.sidebar.help-center-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.help-center-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5p56C.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7867dc9df0604916$var$LazySidebarContent, null)));
var $7867dc9df0604916$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($7867dc9df0604916$var$AsyncSidebar);

});
parcelRegister("5p56C", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $27a902687dbbc5d1$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");
const $27a902687dbbc5d1$var$ItemSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $27a902687dbbc5d1$var$iconSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $27a902687dbbc5d1$var$itemSkeleton
    }));
const $27a902687dbbc5d1$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.300",
        xcss: $27a902687dbbc5d1$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $27a902687dbbc5d1$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $27a902687dbbc5d1$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $27a902687dbbc5d1$var$iconSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $27a902687dbbc5d1$var$titleSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27a902687dbbc5d1$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27a902687dbbc5d1$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27a902687dbbc5d1$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27a902687dbbc5d1$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27a902687dbbc5d1$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27a902687dbbc5d1$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27a902687dbbc5d1$var$ItemSkeleton, null)));
const $27a902687dbbc5d1$var$containerStyles = (0, $5Wv5g.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $27a902687dbbc5d1$var$backButton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100'
});
const $27a902687dbbc5d1$var$iconSkeleton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $27a902687dbbc5d1$var$titleSkeleton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    width: '50%',
    borderRadius: 'border.radius.100'
});
const $27a902687dbbc5d1$var$headingSkeleton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    width: "var(--ds-space-1000, 80px)",
    borderRadius: 'border.radius.100'
});
const $27a902687dbbc5d1$var$itemSkeleton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100',
    flex: 1
});

});

parcelRegister("iR6yp", function(module, exports) {

let $dba242b29d00cf2c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dba242b29d00cf2c$var$load("bAXWz").then(()=>parcelRequire('deSfB'));

});


parcelRegister("a7qPX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2dc5fcce37e96cd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $bgC0Q = parcelRequire("bgC0Q");

const $f2dc5fcce37e96cd$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("jklZl")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/personal/src/ui/main.tsx"
});
const $f2dc5fcce37e96cd$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.personal-settings",
        packageName: "jiraNavigationAppsSidebarNav4PersonalSettings",
        ufoName: "nav4.sidebar.personal-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.personal-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bgC0Q.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f2dc5fcce37e96cd$var$LazySidebarContent, null)));
var $f2dc5fcce37e96cd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($f2dc5fcce37e96cd$var$AsyncSidebar);

});
parcelRegister("bgC0Q", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $4d914ed51273bbce$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");
const $4d914ed51273bbce$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $4d914ed51273bbce$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $4d914ed51273bbce$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $4d914ed51273bbce$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $4d914ed51273bbce$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $4d914ed51273bbce$var$menuItem
    })));
const $4d914ed51273bbce$var$containerStyles = (0, $5Wv5g.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $4d914ed51273bbce$var$backButton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $4d914ed51273bbce$var$headingSkeleton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $4d914ed51273bbce$var$menuItem = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("jklZl", function(module, exports) {

let $e120f102c3c952f8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e120f102c3c952f8$var$load("5ZB52").then(()=>parcelRequire('Dk01j'));

});


parcelRegister("85ZZg", function(module, exports) {

$parcel$export(module.exports, "default", () => $adb8e919f75d8865$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $3ixBB = parcelRequire("3ixBB");

const $adb8e919f75d8865$var$LazyPlanSettingsSidebar = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("ev9kB")).then(({ PlanSettingsSidebar: PlanSettingsSidebar })=>PlanSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/plan/src/ui/main.tsx"
});
const $adb8e919f75d8865$var$AsyncSidebar = ({ store: store })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "asyncSidebarPlanSettings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3ixBB.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($adb8e919f75d8865$var$LazyPlanSettingsSidebar, {
        store: store
    }));
var $adb8e919f75d8865$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($adb8e919f75d8865$var$AsyncSidebar);

});
parcelRegister("3ixBB", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $6d76922a3f445a6a$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $9LyfF = parcelRequire("9LyfF");
var $5Wv5g = parcelRequire("5Wv5g");

var $epTsa = parcelRequire("epTsa");
const $6d76922a3f445a6a$export$8f31e4c4a37b8e9c = ()=>{
    return (0, $epTsa.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$titleSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$titleSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $6d76922a3f445a6a$var$menuItem
    })));
};
const $6d76922a3f445a6a$var$titleSkeleton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-800, 64px)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});
const $6d76922a3f445a6a$var$backButton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});
const $6d76922a3f445a6a$var$headingSkeleton = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $6d76922a3f445a6a$var$menuItem = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $6d76922a3f445a6a$var$subtitleItem = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    width: "var(--ds-space-1000, 80px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("ev9kB", function(module, exports) {

let $a8eb32f45a14b56b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a8eb32f45a14b56b$var$load("jeVD8").then(()=>parcelRequire('3rsEl'));

});


parcelRegister("b2Fy3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2694bb894d56fbb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $b2694bb894d56fbb$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("fHQww")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/company-managed/src/ui/main.tsx"
});
const $b2694bb894d56fbb$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.business.company-managed",
        packageName: "jiraNavigationAppsSidebarNav4BusinessCompanyManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.business.company-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.project-settings.business.company-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b2694bb894d56fbb$var$LazySidebarContent, {
        project: project
    })));
var $b2694bb894d56fbb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($b2694bb894d56fbb$var$AsyncSidebar);

});
parcelRegister("fHQww", function(module, exports) {

let $b6f39d3b21c79246$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b6f39d3b21c79246$var$load("irI1V").then(()=>parcelRequire('7zTBI'));

});


parcelRegister("jyuS3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4134fdc89dd9f47b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $4134fdc89dd9f47b$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8QRVP")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/team-managed/src/ui/main.tsx"
});
const $4134fdc89dd9f47b$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.business.team-managed",
        packageName: "jiraNavigationAppsSidebarNav4BusinessTeamManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.business.team-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.project-settings.business.team-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4134fdc89dd9f47b$var$LazySidebarContent, {
        project: project
    })));
var $4134fdc89dd9f47b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($4134fdc89dd9f47b$var$AsyncSidebar);

});
parcelRegister("8QRVP", function(module, exports) {

let $671d03c45e4cce82$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $671d03c45e4cce82$var$load("alDoT").then(()=>parcelRequire('hW326'));

});


parcelRegister("1Wo5Y", function(module, exports) {

$parcel$export(module.exports, "useIsConnectAppActive", () => $85b7951919a1c173$export$249b2e8512031cae);

var $eJOHy = parcelRequire("eJOHy");

var $jImTl = parcelRequire("jImTl");

var $jRu18 = parcelRequire("jRu18");

var $QaFzq = parcelRequire("QaFzq");

var $8KylV = parcelRequire("8KylV");
const $85b7951919a1c173$export$249b2e8512031cae = ()=>{
    const location = (0, $jRu18.useLocation)();
    const route = (0, $QaFzq.useRoute)();
    const { data: connectApps, error: error, loading: loading } = (0, $8KylV.useConnectApps)();
    const isActive = (0, $eJOHy.useMemo)(()=>Boolean((0, $jImTl.findItemAndStack)(connectApps, route.name, location)?.selected), [
        connectApps,
        location,
        route.name
    ]);
    return {
        isActive: isActive,
        loading: loading,
        error: error
    };
};

});
parcelRegister("8KylV", function(module, exports) {

$parcel$export(module.exports, "useConnectApps", () => $10406f6bfbc50847$export$4864478dcab77643);

var $eJOHy = parcelRequire("eJOHy");

var $cY5nO = parcelRequire("cY5nO");

var $4J9V1 = parcelRequire("4J9V1");

var $g0WOk = parcelRequire("g0WOk");
const $10406f6bfbc50847$export$4864478dcab77643 = ()=>{
    const { data: connectResourceItems, error: error, loading: loading } = (0, $cY5nO.useProjectSettingsSidebarConnectAddonsNavigationResource)();
    const connectApps = (0, $eJOHy.useMemo)(()=>{
        if (connectResourceItems == null) return [];
        const transformedConnectApps = [];
        for (const item of connectResourceItems){
            const transformedItem = (0, $4J9V1.transformLinkV4)(item);
            if (transformedItem && !(0, $g0WOk.LEGACY_CONNECT_ITEM_IDS).has(transformedItem.id)) transformedConnectApps.push(transformedItem);
        }
        return transformedConnectApps;
    }, [
        connectResourceItems
    ]);
    return {
        data: connectApps,
        loading: loading,
        error: error
    };
};

});
parcelRegister("g0WOk", function(module, exports) {

$parcel$export(module.exports, "LEGACY_CONNECT_ITEM_IDS", () => $73c7e3e67b5a3022$export$911a3d81a5d162b6);
// This is a list of known legacy connect item IDs that is used to filter out unecessary connect items
// from being rendered in the connect sections
const $73c7e3e67b5a3022$export$911a3d81a5d162b6 = new Set([
    // Global Settings Static Legacy IDs
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy IDs
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation.moderate__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation',
    'com.codebarrel.addons.automation.moderate__cb-automation'
]);

});



parcelRegister("kDeux", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0f96829bc22173a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $e0f96829bc22173a$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("24P7z")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/product-discovery/src/ui/main.tsx"
});
const $e0f96829bc22173a$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.jpd-settings",
        packageName: "jiraNavigationAppsSidebarNav4ProjectSettingsJpdSettings",
        ufoName: "nav4.sidebar.project-settings.jpd-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.project-settings.jpd-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e0f96829bc22173a$var$LazySidebarContent, {
        project: project
    })));
var $e0f96829bc22173a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($e0f96829bc22173a$var$AsyncSidebar);

});
parcelRegister("24P7z", function(module, exports) {

let $18339c0d8c746434$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $18339c0d8c746434$var$load("hQqdL").then(()=>parcelRequire('5ARi3'));

});


parcelRegister("dKJXK", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmCmpProjectSettingsSidebar", () => $f80defbe5baaf5f3$export$2ce6ad449436c545);

var $eJOHy = parcelRequire("eJOHy");

var $jsesb = parcelRequire("jsesb");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $fTzDU = parcelRequire("fTzDU");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $f80defbe5baaf5f3$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("ayMVt")).then(({ JSMCmpProjectSettingsSidebar: JSMCmpProjectSettingsSidebar })=>JSMCmpProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/company-managed/src/main.tsx"
});
const $f80defbe5baaf5f3$var$analyticsAttributes = {
    projectStyle: 'cmp',
    // reset '3' being sent from outside-of-nav4 Context. navState is used instead.
    // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
    navVersion: undefined
};
const $f80defbe5baaf5f3$export$2ce6ad449436c545 = /*#__PURE__*/ (0, $eJOHy.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.jsm-cmp-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JsmCmpProjectSettings",
        teamName: "jsm-getting-started",
        ufoName: "nav4.sidebar.jsm-cmp-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jsesb.ContextualAnalyticsData), {
        menuId: (0, $fTzDU.MENU_ID_JSM_SETTINGS),
        attributes: $f80defbe5baaf5f3$var$analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.jsm-cmp-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f80defbe5baaf5f3$var$LazySidebarContent, {
        project: project
    })))));

});
parcelRegister("fTzDU", function(module, exports) {

$parcel$export(module.exports, "MENU_ID_JSM_SETTINGS", () => $6b652dd92d2b3e17$export$4c5fa21d31710030);
$parcel$export(module.exports, "PROJECT_SETTINGS_COMMON_ANALYTICS_ATTRIBUTES", () => $6b652dd92d2b3e17$export$8092325c2fa271de);


const $6b652dd92d2b3e17$export$4c5fa21d31710030 = 'project/service-desk/settings';
const $6b652dd92d2b3e17$var$COMMON_ANALYTICS_ATTRIBUTES = {
    componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
    level: 1
};
const $6b652dd92d2b3e17$export$8092325c2fa271de = {
    ...$6b652dd92d2b3e17$var$COMMON_ANALYTICS_ATTRIBUTES,
    actionSubjectId: (0, $16a7021d28f78da7$export$13171e509c859bbf)
};

});

parcelRegister("ayMVt", function(module, exports) {

let $7b0308064683aea4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7b0308064683aea4$var$load("br9a1").then(()=>parcelRequire('1fWHc'));

});


parcelRegister("2ZbI9", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmTmpProjectSettingsSidebar", () => $591aed44a3fa3192$export$dadf0f8c840cb26d);

var $eJOHy = parcelRequire("eJOHy");

var $jsesb = parcelRequire("jsesb");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $fTzDU = parcelRequire("fTzDU");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $591aed44a3fa3192$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("l3neW")).then(({ JSMTmpProjectSettingsSidebar: JSMTmpProjectSettingsSidebar })=>JSMTmpProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/team-managed/src/main.tsx"
});
const $591aed44a3fa3192$var$analyticsAttributes = {
    projectStyle: 'tmp',
    // reset '3' being sent from outside-of-nav4 Context. navState is used instead.
    // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
    navVersion: undefined
};
const $591aed44a3fa3192$export$dadf0f8c840cb26d = /*#__PURE__*/ (0, $eJOHy.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.jsm-tmp-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JsmTmpProjectSettings",
        teamName: "jsm-getting-started",
        ufoName: "nav4.sidebar.jsm-tmp-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jsesb.ContextualAnalyticsData), {
        menuId: (0, $fTzDU.MENU_ID_JSM_SETTINGS),
        attributes: $591aed44a3fa3192$var$analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.jsm-tmp-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($591aed44a3fa3192$var$LazySidebarContent, {
        project: project
    })))));

});
parcelRegister("l3neW", function(module, exports) {

let $f53be7c2b3f2a663$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $f53be7c2b3f2a663$var$load("1VRB2"),
    $f53be7c2b3f2a663$var$load("bABhq"),
    $f53be7c2b3f2a663$var$load("2rjP7")
]).then(()=>parcelRequire('6uevy'));

});


parcelRegister("1eGpA", function(module, exports) {

$parcel$export(module.exports, "AsyncJcsProjectSettingsSidebar", () => $c51b1ed2b58dd2aa$export$e82f1de9c94b7cd9);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $c51b1ed2b58dd2aa$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8rGvY")).then(({ JcsProjectSettingsSidebar: JcsProjectSettingsSidebar })=>JcsProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/customer-service/src/main.tsx"
});
const $c51b1ed2b58dd2aa$export$e82f1de9c94b7cd9 = /*#__PURE__*/ (0, $eJOHy.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.jcs-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JCSProjectSettings",
        teamName: "Boysenberry",
        ufoName: "nav4.sidebar.jcs-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.jcs-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c51b1ed2b58dd2aa$var$LazySidebarContent, {
        project: project
    }))));

});
parcelRegister("8rGvY", function(module, exports) {

let $6261d2dd8938b149$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6261d2dd8938b149$var$load("8OtMy").then(()=>parcelRequire('ejhdy'));

});


parcelRegister("6tXQB", function(module, exports) {

$parcel$export(module.exports, "default", () => $70785d1074b7d721$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $70785d1074b7d721$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8rvIE")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/company-managed/src/ui/main.tsx"
});
const $70785d1074b7d721$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.software.company-managed",
        packageName: "jiraNavigationAppsSidebarNav4SoftwareCompanyManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.software.company-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.project-settings.software.company-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($70785d1074b7d721$var$LazySidebarContent, {
        project: project
    })));
var $70785d1074b7d721$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($70785d1074b7d721$var$AsyncSidebar);

});
parcelRegister("8rvIE", function(module, exports) {

let $62597318b6affbaf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $62597318b6affbaf$var$load("br9vN").then(()=>parcelRequire('hlIyV'));

});


parcelRegister("9b0Rz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f9a196fb91bbe76$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hZzG = parcelRequire("2hZzG");

var $8vXrD = parcelRequire("8vXrD");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $9f9a196fb91bbe76$var$LazySidebarContent = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("i7iZE")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/team-managed/src/ui/main.tsx"
});
const $9f9a196fb91bbe76$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2hZzG.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.software.team-managed",
        packageName: "jiraNavigationAppsSidebarNav4SoftwareTeamManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.software.team-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav4.sidebar.project-settings.software.team-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8vXrD.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f9a196fb91bbe76$var$LazySidebarContent, {
        project: project
    })));
var $9f9a196fb91bbe76$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($9f9a196fb91bbe76$var$AsyncSidebar);

});
parcelRegister("i7iZE", function(module, exports) {

let $d3079d1c13dc61a9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d3079d1c13dc61a9$var$load("35nqH").then(()=>parcelRequire('ixBjC'));

});


parcelRegister("dmxJQ", function(module, exports) {

$parcel$export(module.exports, "useConfigParam", () => $db223141e45f9c7c$export$b8842df7174e4acb);
$parcel$export(module.exports, "useMaybeConfigParam", () => $db223141e45f9c7c$export$2135334620af5209);

var $2FqDG = parcelRequire("2FqDG");
var $95O7y = parcelRequire("95O7y");

var $iZ2Qf = parcelRequire("iZ2Qf");
function $db223141e45f9c7c$export$b8842df7174e4acb() {
    const configParam = $db223141e45f9c7c$export$2135334620af5209();
    if (!configParam) throw new Error('No config param found');
    const result = $db223141e45f9c7c$var$isConfigQuery(configParam) ? configParam : null;
    return result;
}
function $db223141e45f9c7c$export$2135334620af5209() {
    const [configPath] = (0, $2FqDG.usePathParam)('config');
    const [configQuery] = (0, $95O7y.useQueryParam)('config');
    return configPath || configQuery;
}
const $db223141e45f9c7c$var$isConfigQuery = (configQuery)=>(0, $iZ2Qf.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(configQuery);

});


parcelRegister("20Hsz", function(module, exports) {

$parcel$export(module.exports, "getNav4SidebarId", () => $5bcf7de15fdd54d8$export$8cea2a93fc3986aa);
$parcel$export(module.exports, "useGetParamsForGetNav4SidebarId", () => $5bcf7de15fdd54d8$export$e102a5137dc15645);

var $eJOHy = parcelRequire("eJOHy");

var $5RW99 = parcelRequire("5RW99");

var $iZ2Qf = parcelRequire("iZ2Qf");

var $2EmlI = parcelRequire("2EmlI");

var $fJ06f = parcelRequire("fJ06f");

var $1Wo5Y = parcelRequire("1Wo5Y");

var $gDXSd = parcelRequire("gDXSd");

var $kfvK2 = parcelRequire("kfvK2");

var $dmxJQ = parcelRequire("dmxJQ");
function $5bcf7de15fdd54d8$export$8cea2a93fc3986aa(params) {
    const { configParam: configParam, isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive, isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive, isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive, routerState: routerState, shouldUseJSM: shouldUseJSM } = params;
    const sidebarId = routerState.route.navigation?.sidebarId;
    const pathname = routerState.location.pathname;
    // Deal with the exceptions...
    if (sidebarId === (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS && !pathname.includes('/discover')) return sidebarId;
    if (sidebarId === (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS) {
        if (pathname.includes('/jira-service-management-chatops-and-video-tools') && shouldUseJSM) return (0, $5RW99.SIDEBAR_ID).CONTENT;
        return sidebarId;
    }
    // Project settings sidebars
    if (routerState.route.name === 'polaris-ideas' && routerState.match.params.section === 'settings' || isProjectSettingsConnectAppActive) return (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS;
    // Board settings sidebar
    if (routerState.route.group === 'classic-software' && (0, $iZ2Qf.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(configParam)) return (0, $5RW99.SIDEBAR_ID).BOARD_SETTINGS;
    if (isGlobalAppsSettingsConnectItemActive) return (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS;
    if (isGlobalSystemSettingsConnectItemActive) return (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS;
    return sidebarId || (0, $5RW99.SIDEBAR_ID).CONTENT;
}
function $5bcf7de15fdd54d8$export$e102a5137dc15645(params = {}) {
    const { routerState: routerState = (0, $kfvK2.getRouterState)() } = params;
    const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, $2EmlI.useGlobalAppsSettingsConnectItemActive)();
    const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, $fJ06f.useGlobalSystemSettingsConnectItemActive)();
    const { isActive: isProjectSettingsConnectAppActive } = (0, $1Wo5Y.useIsConnectAppActive)();
    const { shouldUseJSM: shouldUseJSM } = (0, $gDXSd.useOgTenantInfo)();
    const configParam = (0, $dmxJQ.useMaybeConfigParam)() || '';
    const data = (0, $eJOHy.useMemo)(()=>({
            configParam: configParam,
            isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive,
            isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive,
            isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive,
            routerState: routerState,
            shouldUseJSM: shouldUseJSM
        }), [
        configParam,
        isGlobalAppsSettingsConnectItemActive,
        isGlobalSystemSettingsConnectItemActive,
        isProjectSettingsConnectAppActive,
        routerState,
        shouldUseJSM
    ]);
    return data;
}

});


parcelRegister("cfS4j", function(module, exports) {

$parcel$export(module.exports, "Nav4JiraSideNavRecommendation", () => $59c97720cc169a5c$export$ecec3671e31d76fc);
$parcel$export(module.exports, "JswSideNavRecommendation", () => $59c97720cc169a5c$export$6bbd8731fa84c19f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $3Va4b = parcelRequire("3Va4b");

var $1KdDN = parcelRequire("1KdDN");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $1gHmu = parcelRequire("1gHmu");

var $grotr = parcelRequire("grotr");

var $7oY9g = parcelRequire("7oY9g");

var $5fjzQ = parcelRequire("5fjzQ");

var $9I7ft = parcelRequire("9I7ft");
const $59c97720cc169a5c$var$PLACEMENT_ID = 'jira-side-nav';
const $59c97720cc169a5c$var$SideNavPlacement = ({ onHasMessageChanged: onHasMessageChanged })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9I7ft.default), {
        placementId: $59c97720cc169a5c$var$PLACEMENT_ID,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $3Va4b.default),
        placementProps: {
            onHasMessageChanged: onHasMessageChanged
        }
    });
const $59c97720cc169a5c$var$SideNavRecommendation = ({ onHasMessageChanged: onHasMessageChanged })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "sideNavRecommendation",
        packageName: "side-nav-recommendation",
        teamName: "post-office",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1gHmu.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "side-nav-recommendation.jira-side-nav"
    }, (0, $7jTnu.fg)('post_office_ssr_jira_side_nav_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $grotr.PlacementFetchProvider), {
        resource: (0, $5fjzQ.postOfficeJiraSideNavResource)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59c97720cc169a5c$var$SideNavPlacement, {
        onHasMessageChanged: onHasMessageChanged
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59c97720cc169a5c$var$SideNavPlacement, {
        onHasMessageChanged: onHasMessageChanged
    }))));
};
const $59c97720cc169a5c$export$ecec3671e31d76fc = /*#__PURE__*/ (0, $eJOHy.memo)(({ onHasMessageChanged: onHasMessageChanged })=>{
    if (!(0, $7oY9g.default)('killswitch_post_office_in_jira') && (0, $7jTnu.fg)('post-office-jira-side-nav-in-nav4')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59c97720cc169a5c$var$SideNavRecommendation, {
        onHasMessageChanged: onHasMessageChanged
    });
    return null;
});
const $59c97720cc169a5c$export$6bbd8731fa84c19f = /*#__PURE__*/ (0, $eJOHy.memo)(({ onHasMessageChanged: onHasMessageChanged })=>{
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    !(0, $7oY9g.default)('killswitch_post_office_in_jira') && (0, $7jTnu.fg)('post-office_enable_jira_sidenav_rec_msr_experiment') && (0, $epTsa.expVal)('post_office_jira_side_nav_exp_msr_vs_no_rec', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59c97720cc169a5c$var$SideNavRecommendation, {
        onHasMessageChanged: onHasMessageChanged
    });
    return null;
});

});
parcelRegister("3Va4b", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b9eb1d3b0028984$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $gFu5h = parcelRequire("gFu5h");

var $3o8lc = parcelRequire("3o8lc");

var $7IIUN = parcelRequire("7IIUN");

var $5H93L = parcelRequire("5H93L");

var $eJOHy = parcelRequire("eJOHy");

var $itr48 = parcelRequire("itr48");

const $9b9eb1d3b0028984$var$excludedMessages = new Set([
    'test-message-inapp',
    'message-template-template'
]);
const $9b9eb1d3b0028984$export$5f4d7e99d8732fe7 = (0, $3o8lc.createPlacementComponent)((0, $dbfbf1ad464393a8$export$a5cfae247d8360ef), /*#__PURE__*/ (0, $eJOHy.memo)(({ initialData: initialData, onHasMessageChanged: onHasMessageChanged, preloadedInitialData: preloadedInitialData })=>{
    const { data: data, isLoading: isLoading } = (0, $5H93L.useInitialData)(initialData);
    const [{ message: message, status: status }, setMessageState] = (0, $eJOHy.useState)(()=>{
        if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? {
            message: preloadedInitialData?.messages[0],
            status: 'done'
        } : {
            message: undefined,
            status: 'done'
        };
        return {
            message: undefined,
            status: 'loading'
        };
    });
    const handleOnDismissed = (0, $eJOHy.useCallback)(()=>{
        setMessageState({
            message: undefined,
            status: 'done'
        });
        onHasMessageChanged?.(false);
    }, [
        onHasMessageChanged
    ]);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $gFu5h.useMessagePlacementHooks)();
    (0, $eJOHy.useEffect)(()=>onMessageDismiss(handleOnDismissed), [
        onMessageDismiss,
        handleOnDismissed
    ]);
    (0, $eJOHy.useEffect)(()=>onMessageClicked(handleOnDismissed), [
        onMessageClicked,
        handleOnDismissed
    ]);
    (0, $eJOHy.useEffect)(()=>onMessageSnooze(handleOnDismissed), [
        onMessageSnooze,
        handleOnDismissed
    ]);
    const isDone = status === 'done';
    (0, $eJOHy.useEffect)(()=>{
        if (!isLoading && !isDone) {
            const newMessage = (data?.messages || []).filter((dataMessage)=>!$9b9eb1d3b0028984$var$excludedMessages.has(dataMessage.messageTemplateId))[0];
            setMessageState({
                message: newMessage,
                status: 'done'
            });
            onHasMessageChanged?.(newMessage !== undefined);
        }
    }, [
        data,
        isLoading,
        isDone,
        onHasMessageChanged
    ]);
    if (status === 'loading') return null;
    return message && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $itr48.MessageRenderer), {
        ...message,
        id: message.messageInstanceId,
        onDismissed: handleOnDismissed,
        SuspenseBoundary: (0, $7IIUN.MaybeSuspenseBoundary)
    });
}), {
    choreographer: {
        isDefaultEnabled: false
    }
});
var $9b9eb1d3b0028984$export$2e2bcd8739ae039 = $9b9eb1d3b0028984$export$5f4d7e99d8732fe7;

});
parcelRegister("itr48", function(module, exports) {

$parcel$export(module.exports, "MessageRenderer", () => $94ae2385ed84caa4$export$2df1250b8f917a59);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $7IIUN = parcelRequire("7IIUN");

var $fDDJR = parcelRequire("fDDJR");

var $jzweC = parcelRequire("jzweC");

var $bhOW3 = parcelRequire("bhOW3");
const $94ae2385ed84caa4$export$e30378e28ad3e6ab = {
    ...(0, $fDDJR.default),
    ...(0, $jzweC.default),
    ...(0, $bhOW3.default)
};
const { initializeMessageRenderer: $94ae2385ed84caa4$export$bce4e5106d86e473, MessageRenderer: $94ae2385ed84caa4$export$2df1250b8f917a59 } = (0, $7IIUN.asMessageRenderer)($94ae2385ed84caa4$export$e30378e28ad3e6ab);

});
parcelRegister("fDDJR", function(module, exports) {

$parcel$export(module.exports, "default", () => $315cd48ce1234e8d$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eRGmQ = parcelRequire("eRGmQ");

var $dUXRQ = parcelRequire("dUXRQ");

var $fJnRN = parcelRequire("fJnRN");

var $03RUE = parcelRequire("03RUE");

var $c01QG = parcelRequire("c01QG");
var $315cd48ce1234e8d$export$2e2bcd8739ae039 = {
    'recommendation-confluence': (0, $eRGmQ.default),
    'recommendation-jpd': (0, $dUXRQ.default),
    'recommendation-jsm': (0, $fJnRN.default),
    'recommendation-jsw-visualize-work': (0, $03RUE.default),
    'recommendation-loom': (0, $c01QG.default)
};

});
parcelRegister("eRGmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $abbbb37c4259651b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $8uw8h = parcelRequire("8uw8h");

var $j8vlL = parcelRequire("j8vlL");

var $7szcD = parcelRequire("7szcD");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $bbGLc = parcelRequire("bbGLc");
const $abbbb37c4259651b$var$CCP_PRODUCT_ID = '6aab3f4e-cc71-474d-8d28-abef8b057808';
const $abbbb37c4259651b$var$HAMS_PRODUCT_ID = 'confluence.ondemand';
const $abbbb37c4259651b$var$PRODUCT_NAME = 'Confluence';
const $abbbb37c4259651b$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "growth.recommendation-confluence.reasons-modal.message",
            defaultMessage: "We think {confluence} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the Confluence recommendation will be relevant to the customer.",
            values: {
                confluence: /*#__PURE__*/ (0, $gt9Am.jsx)("strong", {
                    children: $abbbb37c4259651b$var$PRODUCT_NAME
                })
            }
        })
    }),
    reasons: (0, $j8vlL.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $abbbb37c4259651b$export$b3890eb0ae9dca99 = (0, $bbGLc.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7szcD.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: $abbbb37c4259651b$var$HAMS_PRODUCT_ID,
            ccpProductId: $abbbb37c4259651b$var$CCP_PRODUCT_ID,
            logo: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.ConfluenceIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-confluence.product-name.header",
                description: "Header for Confluence recommendation message in Jira Side Nav",
                defaultMessage: "Collaborate on pages in real-time"
            }),
            ctaMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-confluence.cta.label",
                description: "CTA text for Confluence recommendation message in Jira Side Nav",
                defaultMessage: "Try Confluence"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $abbbb37c4259651b$var$whyAmISeeingThisModalContent
    }));
var $abbbb37c4259651b$export$2e2bcd8739ae039 = $abbbb37c4259651b$export$b3890eb0ae9dca99;

});
parcelRegister("j8vlL", function(module, exports) {

$parcel$export(module.exports, "whyAmISeeingThisRecommendationMessageDefaultReason", () => $7de99a6491e3db7c$export$5a12ae0dd15a31ed);

var $gt9Am = parcelRequire("gt9Am");

var $kDaaB = parcelRequire("kDaaB");
const $7de99a6491e3db7c$export$5a12ae0dd15a31ed = [
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        id: "post-office.ad-controls.default-reason.team-size",
        description: "the first reason for displaying the message to the customer: the size of the customer's team",
        defaultMessage: "the size of your team"
    }),
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        id: "post-office.ad-controls.default-reason.existing-products",
        description: "the second reason for displaying the message to the customer: the customer's existing Atlassian products",
        defaultMessage: "your existing Atlassian products"
    })
];

});

parcelRegister("7szcD", function(module, exports) {

$parcel$export(module.exports, "JiraSideNavFirstPartyRecommendation", () => $86a585f41677021f$export$35f6f23f7684ff6);

var $gt9Am = parcelRequire("gt9Am");

var $bvFRW = parcelRequire("bvFRW");

var $aRh7I = parcelRequire("aRh7I");

var $8g6pr = parcelRequire("8g6pr");

var $3wnx0 = parcelRequire("3wnx0");

var $6GaT5 = parcelRequire("6GaT5");
const $86a585f41677021f$var$BodyContent = ({ app: app })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $aRh7I.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                children: app.logo
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvFRW.default), {
                size: "xsmall",
                children: app.header
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6GaT5.CTAButton), {
                app: app
            })
        ]
    });
};
const $86a585f41677021f$export$35f6f23f7684ff6 = ({ app: app, onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent })=>{
    const { messageInstanceId: messageInstanceId } = (0, $3wnx0.useMessageContext)();
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8g6pr.JiraSideNavMessage), {
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
        bodyContent: /*#__PURE__*/ (0, $gt9Am.jsx)($86a585f41677021f$var$BodyContent, {
            app: app
        })
    });
};

});
parcelRegister("8g6pr", function(module, exports) {

$parcel$export(module.exports, "JiraSideNavMessage", () => $27f2ec2bc64593f8$export$ee97a7edb31193a8);
/* message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3wnx0 = parcelRequire("3wnx0");

var $buRhT = parcelRequire("buRhT");
const $27f2ec2bc64593f8$var$jiraSideNavMessageStyle = null;
const $27f2ec2bc64593f8$export$ee97a7edb31193a8 = ({ onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, bodyContent: bodyContent, showRemindMeLater: showRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis })=>{
    const { messageInstanceId: messageInstanceId } = (0, $3wnx0.useMessageContext)();
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": "jira-side-nav-message",
        className: (0, $hcewu.default)([
            "_2rkoop52 _18zrpxbi _1rjcutpp _kqswh2mm _1e0c1txw _bfhk1hdx _otyru2gc _1pbyidpf"
        ]),
        children: [
            bodyContent,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $buRhT.Actions), {
                whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
                onDismissed: ()=>onDismissed?.(messageInstanceId),
                showRemindMeLater: showRemindMeLater,
                showWhyAmISeeingThis: showWhyAmISeeingThis
            })
        ]
    });
};

});
parcelRegister("buRhT", function(module, exports) {

$parcel$export(module.exports, "Actions", () => $9cd8de886434c2b1$export$b52183d5cfb26dc9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8bIif = parcelRequire("8bIif");
const $9cd8de886434c2b1$var$actionsStyles = null;
const $9cd8de886434c2b1$export$b52183d5cfb26dc9 = ({ onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, showRemindMeLater: showRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1yt4u2gc _kqswstnw _1e0c1txw _154iidpf _1xi2idpf"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8bIif.AdControls), {
            iconSize: "small",
            onDismissed: onDismissed,
            showWhyAmISeeingThis: showWhyAmISeeingThis ?? true,
            whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
            showRemindMeLater: showRemindMeLater
        })
    });
};

});
parcelRegister("8bIif", function(module, exports) {

$parcel$export(module.exports, "AdControls", () => $11f7df9825f7eef9$export$c25b8b7217045de9);

var $gt9Am = parcelRequire("gt9Am");

var $4BzUI = parcelRequire("4BzUI");

var $gtHL8 = parcelRequire("gtHL8");

var $4poV0 = parcelRequire("4poV0");

var $9JB3T = parcelRequire("9JB3T");

var $e0Nss = parcelRequire("e0Nss");

var $3wnx0 = parcelRequire("3wnx0");

var $guu3z = parcelRequire("guu3z");

var $4vp0Q = parcelRequire("4vp0Q");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $jXbaK = parcelRequire("jXbaK");

var $2BIfx = parcelRequire("2BIfx");

var $hSwu9 = parcelRequire("hSwu9");
const $11f7df9825f7eef9$var$DropdownTrigger = ({ triggerRef: triggerRef, name: name, iconSize: iconSize = 'small', iconColor: iconColor, spacing: spacing = 'default', ...triggerProps })=>{
    const intl = (0, $lRq8t.default)();
    const ariaLabel = intl.formatMessage({
        id: 'post-office.ad-controls.dropdown-menu-trigger.aria-label',
        defaultMessage: '{messageInstanceId} options menu',
        description: 'Options menu ad controls'
    }, {
        messageInstanceId: name
    });
    const tooltip = intl.formatMessage({
        id: 'post-office.ad-controls.dropdown-menu-trigger.tooltip',
        defaultMessage: 'More actions',
        description: 'Tooltip for ad-controls dropdown'
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9JB3T.default), {
        content: tooltip,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
            ...triggerProps,
            label: ariaLabel,
            appearance: "subtle",
            ref: triggerRef,
            spacing: spacing,
            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4poV0))), {
                    ...iconProps,
                    color: iconColor,
                    size: iconSize
                })
        })
    });
};
const $11f7df9825f7eef9$export$c25b8b7217045de9 = ({ onDismissed: onDismissed, iconSize: iconSize, iconColor: iconColor, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, showWhyAmISeeingThis: showWhyAmISeeingThis, showRemindMeLater: showRemindMeLater, additionalAnalyticsAttributes: additionalAnalyticsAttributes = {}, zIndex: zIndex, spacing: spacing = 'default' })=>{
    const [isWhyAmISeeingThisModelOpened, setIsWhyAmISeeingThisModelOpened] = (0, $eJOHy.useState)(false);
    const { messageDismissed: messageDismissed, messageAcknowledged: messageAcknowledged } = (0, $4vp0Q.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $guu3z.useMessageInstanceEvent)();
    const { messageInstanceId: messageInstanceId } = (0, $3wnx0.useMessageContext)();
    const [currIconColor, setCurrIconColor] = (0, $eJOHy.useState)(iconColor);
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $e0Nss.useFirePostOfficeAnalyticsEvents)();
    const [showDismissedFlag, setShowDismissedFlag] = (0, $eJOHy.useState)(false);
    const { messageSnoozed: messageSnoozed } = (0, $4vp0Q.useMessageEvent)();
    const handleRemindMeLater = async ()=>{
        // https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/pre-defined-filters/#snooze-check-filter
        messageSnoozed(1); // DEPRECATED, but used alongside the messageInstanceClicked function just in case. See above page for documentation
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'remindMeLater',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'snooze',
                snoozeDuration: 1 // Snooze message for 1 day
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'remindMeLater'
        }, {
            ...additionalAnalyticsAttributes
        });
        setShowDismissedFlag(true);
    };
    const handleNotInterested = async ()=>{
        await messageDismissed();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'notInterested',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'notInterested'
        }, {
            ...additionalAnalyticsAttributes
        });
        if (messageInstanceId && typeof onDismissed === 'function') // integrating with useMessagePlacementHooks removes the need to pass this callback
        onDismissed(messageInstanceId);
        setShowDismissedFlag(true);
    };
    const handleWhyAmISeeingThis = async ()=>{
        setIsWhyAmISeeingThisModelOpened(true);
        await messageAcknowledged();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'adControlsReasons',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsReasons'
        }, {
            ...additionalAnalyticsAttributes
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gtHL8.default), {
                testId: "post-office-ad-controls-dropdown",
                trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)($11f7df9825f7eef9$var$DropdownTrigger, {
                        name: messageInstanceId,
                        triggerRef: triggerRef,
                        iconSize: iconSize,
                        iconColor: currIconColor,
                        spacing: spacing,
                        ...triggerProps
                    }),
                ...zIndex && {
                    zIndex: zIndex
                },
                onOpenChange: (args)=>{
                    if (args.isOpen) {
                        fireAnalyticsEvent({
                            eventType: 'ui',
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'adControlsDropdown'
                        });
                        setCurrIconColor("var(--ds-icon-selected, #0C66E4)");
                    } else setCurrIconColor(iconColor);
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2BIfx.AdControlsDropdown), {
                    onNotInterested: handleNotInterested,
                    onWhyAmISeeingThis: handleWhyAmISeeingThis,
                    onRemindMeLater: handleRemindMeLater,
                    showWhyAmISeeingThis: showWhyAmISeeingThis,
                    showRemindMeLater: showRemindMeLater ? true : false
                })
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hSwu9.WhyAmISeeingThisModal), {
                content: whyAmISeeingThisModalContent,
                isOpen: isWhyAmISeeingThisModelOpened,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes,
                onClose: ()=>{
                    setIsWhyAmISeeingThisModelOpened(false);
                    fireAnalyticsEvent({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'adControlsReasonsClose'
                    }, {
                        ...additionalAnalyticsAttributes
                    });
                }
            }),
            showDismissedFlag && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jXbaK.AdControlsFlag), {
                messageInstanceId: messageInstanceId,
                onCloseFlag: ()=>setShowDismissedFlag(false)
            })
        ]
    });
};

});
parcelRegister("jXbaK", function(module, exports) {

$parcel$export(module.exports, "AdControlsFlag", () => $132839bdeee1966a$export$6eb98925a948bca3);
/* dismissalFlag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $iFpLg = parcelRequire("iFpLg");
var $f9pXS = parcelRequire("f9pXS");

var $g4ST9 = parcelRequire("g4ST9");

var $dhRXV = parcelRequire("dhRXV");


var $kDaaB = parcelRequire("kDaaB");

var $cI08a = parcelRequire("cI08a");
const $132839bdeee1966a$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER = 'post-office-ad-controls-flag-wrapper';
/**-Title--**/ const $132839bdeee1966a$var$titleContainerStyles = {
    font: "_11c8140y"
};
const $132839bdeee1966a$var$Title = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
        xcss: $132839bdeee1966a$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "post-office.ad-controls.dismiss-flag.not-interested.title",
            defaultMessage: "Got it, thanks for letting us know",
            description: "The title for a flag which is displayed when the Not Interested button is pressed. https://hello.atlassian.net/l/cp/ssoqm2Fq"
        })
    });
/**--Description--**/ const $132839bdeee1966a$var$Description = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        id: "post-office.ad-controls.dismiss-flag.not-interested.subtitle",
        defaultMessage: "You won\u2019t see this here as often.",
        description: "The subtitle for a flag which is displayed when the Not Interested button is pressed. https://hello.atlassian.net/l/cp/ssoqm2Fq"
    });
/**--Confirm Icon--*/ const $132839bdeee1966a$var$ConfirmIcon = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g4ST9))), {
        spacing: "spacious",
        label: "Success",
        color: `var(--ds-icon-success, ${(0, $135dba7912433cc2$export$940e1f69e873f202)})`
    });
const $132839bdeee1966a$export$6eb98925a948bca3 = ({ messageInstanceId: messageInstanceId, onCloseFlag: onCloseFlag })=>{
    (0, $cI08a.portalZIndexFix)($132839bdeee1966a$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f9pXS.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            id: $132839bdeee1966a$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iFpLg.default), {
                icon: /*#__PURE__*/ (0, $gt9Am.jsx)($132839bdeee1966a$var$ConfirmIcon, {}),
                title: /*#__PURE__*/ (0, $gt9Am.jsx)($132839bdeee1966a$var$Title, {}),
                description: /*#__PURE__*/ (0, $gt9Am.jsx)($132839bdeee1966a$var$Description, {}),
                id: messageInstanceId,
                onDismissed: ()=>onCloseFlag()
            }, messageInstanceId)
        })
    });
};

});
parcelRegister("cI08a", function(module, exports) {

$parcel$export(module.exports, "portalZIndexFix", () => $e8f5756c572035ba$export$cef2f5415067aeab);
const $e8f5756c572035ba$var$collectionHas = (all, curr)=>{
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
};
const $e8f5756c572035ba$var$findParentBySelector = (elm, selector)=>{
    const all = globalThis.document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$e8f5756c572035ba$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
};
const $e8f5756c572035ba$export$cef2f5415067aeab = (wrapperId)=>{
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    setTimeout(()=>{
        if (globalThis.document) {
            const modalContent = globalThis.document.getElementById(wrapperId);
            const portalSelector = '.atlaskit-portal';
            const parentPortal = $e8f5756c572035ba$var$findParentBySelector(modalContent, portalSelector);
            if (parentPortal) parentPortal.setAttribute('style', 'z-index:900;');
        }
    });
// DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
};

});


parcelRegister("2BIfx", function(module, exports) {

$parcel$export(module.exports, "AdControlsDropdown", () => $13ee3febdefe8c91$export$ba7539b3ac68f9f1);

var $gt9Am = parcelRequire("gt9Am");

var $7Ga8U = parcelRequire("7Ga8U");
var $lfSKL = parcelRequire("lfSKL");

var $kDaaB = parcelRequire("kDaaB");
const $13ee3febdefe8c91$export$99f2c116e7ad8950 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Ga8U.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label",
            defaultMessage: "Why am I seeing this?",
            description: "The text for the button which opens a modal showing the reasons a message has been displayed."
        })
    });
const $13ee3febdefe8c91$export$80eb3e3679dfe382 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Ga8U.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "post-office.ad-controls.dropdown-item.not-interested.label",
            defaultMessage: "Not interested",
            description: "The text for the button which removes a message from a placement."
        })
    });
const $13ee3febdefe8c91$export$c3a3ff4a62111967 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Ga8U.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "post-office.ad-controls.dropdown-item.remind-me-later.label",
            defaultMessage: "Remind me later",
            description: "The text for the button which removes a message from a placement and makes it reappear at a later date."
        })
    });
const $13ee3febdefe8c91$export$ba7539b3ac68f9f1 = ({ onWhyAmISeeingThis: onWhyAmISeeingThis, onNotInterested: onNotInterested, onRemindMeLater: onRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis = true, showRemindMeLater: showRemindMeLater })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lfSKL.default), {
        children: [
            showRemindMeLater && /*#__PURE__*/ (0, $gt9Am.jsx)($13ee3febdefe8c91$export$c3a3ff4a62111967, {
                testId: "ad-controls-dropdown-remind-me-later",
                onClick: onRemindMeLater
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)($13ee3febdefe8c91$export$80eb3e3679dfe382, {
                testId: "ad-controls-dropdown-not-interested",
                onClick: onNotInterested
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $gt9Am.jsx)($13ee3febdefe8c91$export$99f2c116e7ad8950, {
                testId: "ad-controls-dropdown-why-am-I-seeing-this",
                onClick: onWhyAmISeeingThis
            })
        ]
    });

});

parcelRegister("hSwu9", function(module, exports) {

$parcel$export(module.exports, "WhyAmISeeingThisModal", () => $14d8d6f9299e0ee4$export$b29014abf8076d54);
/* modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $dKpTa = parcelRequire("dKpTa");

var $51Gwp = parcelRequire("51Gwp");

var $jdbsD = parcelRequire("jdbsD");
var $6sWr0 = parcelRequire("6sWr0");
var $3Zn1o = parcelRequire("3Zn1o");
var $15cpG = parcelRequire("15cpG");
var $i237T = parcelRequire("i237T");
var $jC5ye = parcelRequire("jC5ye");

var $dhRXV = parcelRequire("dhRXV");

var $e0Nss = parcelRequire("e0Nss");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $cI08a = parcelRequire("cI08a");
const $14d8d6f9299e0ee4$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT = 'why-am-i-seeing-this-modal-content';
const $14d8d6f9299e0ee4$export$2b77a92f1a5ad772 = ({ children: children, isOpen: isOpen, onClose: onClose })=>{
    (0, $cI08a.portalZIndexFix)($14d8d6f9299e0ee4$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jC5ye.default), {
        children: isOpen && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdbsD.default), {
            shouldCloseOnEscapePress: true,
            onClose: onClose,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                id: $14d8d6f9299e0ee4$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT,
                children: children
            })
        })
    });
};
const $14d8d6f9299e0ee4$var$AcceptButton = ({ onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dKpTa.default), {
        appearance: "primary",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "post-office.ad-controls.reasons-modal.accept-button.label-ok",
            defaultMessage: "OK",
            description: "The text on the button that dismisses a modal which provides reasons a message has been displayed"
        })
    });
/*--Title--*/ const $14d8d6f9299e0ee4$var$titleContainerStyles = {
    font: "_11c8lodh"
};
const $14d8d6f9299e0ee4$var$Title = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
        xcss: $14d8d6f9299e0ee4$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "post-office.ad-controls.reasons-modal.title",
            defaultMessage: "Why am I seeing this?",
            description: "The title for a modal that displays the reasons a message was displayed."
        })
    });
/*--Body--*/ const $14d8d6f9299e0ee4$var$DefaultBody = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "post-office.ad-controls.reasons-modal.body",
            defaultMessage: "We think you'd find this relevant. This is based on:",
            description: "Explanation of why we think the message will be releavant to the customer."
        })
    });
const $14d8d6f9299e0ee4$var$reasonsListStyles = null;
const $14d8d6f9299e0ee4$var$ReasonsList = ({ reasons: reasons })=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        className: (0, $hcewu.default)([
            "_2mzu1wth _19bvv47k _19pkutpp"
        ]),
        children: reasons.map((reason, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)("li", {
                children: reason
            }, index))
    });
const $14d8d6f9299e0ee4$var$privacyPolicyLinkWrapperStyles = null;
const $14d8d6f9299e0ee4$export$fdd773f48aebb8ab = ({ onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_19pkutpp"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $51Gwp.default), {
            href: 'https://www.atlassian.com/legal/privacy-policy',
            target: "_blank",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "post-office.ad-controls.reasons-modal.privacy-policy-link.text",
                defaultMessage: "Learn more about your data privacy with Atlassian",
                description: "The text linking to Atlassian's privacy policy. https://hello.atlassian.net/l/cp/ssoqm2Fq"
            })
        })
    });
const $14d8d6f9299e0ee4$var$ReasonsModalDefaultBody = ({ onClose: onClose, content: content, additionalAnalyticsAttributes: additionalAnalyticsAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $e0Nss.useFirePostOfficeAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'adControlsReasonsModal'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        fireAnalyticsEvent,
        additionalAnalyticsAttributes
    ]);
    const handleOnPrivacyPolicy = ()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'adControlsPrivacyPolicy'
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $15cpG.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i237T.default), {
                    children: content?.title || /*#__PURE__*/ (0, $gt9Am.jsx)($14d8d6f9299e0ee4$var$Title, {})
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6sWr0.default), {
                children: content?.body || /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        content?.message || /*#__PURE__*/ (0, $gt9Am.jsx)($14d8d6f9299e0ee4$var$DefaultBody, {}),
                        content?.reasons && /*#__PURE__*/ (0, $gt9Am.jsx)($14d8d6f9299e0ee4$var$ReasonsList, {
                            reasons: content.reasons
                        }),
                        content?.privacyPolicy || /*#__PURE__*/ (0, $gt9Am.jsx)($14d8d6f9299e0ee4$export$fdd773f48aebb8ab, {
                            onClick: ()=>handleOnPrivacyPolicy()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Zn1o.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($14d8d6f9299e0ee4$var$AcceptButton, {
                    onClick: onClose
                })
            })
        ]
    });
};
const $14d8d6f9299e0ee4$export$b29014abf8076d54 = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($14d8d6f9299e0ee4$export$2b77a92f1a5ad772, {
        isOpen: props.isOpen,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($14d8d6f9299e0ee4$var$ReasonsModalDefaultBody, {
            ...props
        })
    });
};

});




parcelRegister("6GaT5", function(module, exports) {

$parcel$export(module.exports, "CTAButton", () => $e89d4a1fee9cf45b$export$bd36621ef7814117);

var $gt9Am = parcelRequire("gt9Am");

var $5Wv5g = parcelRequire("5Wv5g");

var $6XPwf = parcelRequire("6XPwf");
const $e89d4a1fee9cf45b$var$JOURNEY = 'get-started';
const $e89d4a1fee9cf45b$var$SOURCE_COMPONENT = 'jira-side-nav';
const $e89d4a1fee9cf45b$var$SOURCE_CONTEXT = 'tryItNow';
const $e89d4a1fee9cf45b$var$ctaButtonStyles = (0, $5Wv5g.xcss)({
    color: 'color.link',
    backgroundColor: 'color.background.accent.blue.subtlest',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    paddingLeft: '0'
});
const $e89d4a1fee9cf45b$export$bd36621ef7814117 = ({ app: app })=>{
    const crossflowOptions = {
        targetProduct: app.hamsIdentifier,
        journey: $e89d4a1fee9cf45b$var$JOURNEY,
        sourceComponent: $e89d4a1fee9cf45b$var$SOURCE_COMPONENT,
        sourceContext: $e89d4a1fee9cf45b$var$SOURCE_CONTEXT
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XPwf.CrossflowCtaPrimaryPressable), {
        crossflowOptions: crossflowOptions,
        ctaText: app.ctaMessage,
        pressableStyle: $e89d4a1fee9cf45b$var$ctaButtonStyles
    });
};

});
parcelRegister("6XPwf", function(module, exports) {

$parcel$export(module.exports, "CrossflowCtaPrimaryLinkButton", () => $401172d9225878ee$export$55d6f395fee83ac9);
$parcel$export(module.exports, "CrossflowCtaPrimaryPressable", () => $401172d9225878ee$export$585a4ef79f2a8b77);
$parcel$export(module.exports, "CrossflowCtaSecondaryPressable", () => $401172d9225878ee$export$ba0dce35a480e0b4);

var $gt9Am = parcelRequire("gt9Am");

var $alkjW = parcelRequire("alkjW");

var $cPbpX = parcelRequire("cPbpX");

var $l2hye = parcelRequire("l2hye");
const $401172d9225878ee$var$PRIMARY_LINK_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'primary'
};
const $401172d9225878ee$export$55d6f395fee83ac9 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, appearance: appearance, alt: alt })=>{
    const { handleClick: handleClick } = (0, $l2hye.useCrossflowMessageClicked)(crossflowOptions, $401172d9225878ee$var$PRIMARY_LINK_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $alkjW.default), {
        onClick: handleClick,
        appearance: appearance,
        "aria-label": alt,
        children: ctaText
    });
};
const $401172d9225878ee$var$PRIMARY_BUTTON_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'primary'
};
const $401172d9225878ee$export$585a4ef79f2a8b77 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, pressableStyle: pressableStyle, alt: alt })=>{
    const { handleClick: handleClick } = (0, $l2hye.useCrossflowMessageClicked)(crossflowOptions, $401172d9225878ee$var$PRIMARY_BUTTON_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cPbpX.default), {
        onClick: handleClick,
        xcss: pressableStyle,
        "aria-label": alt,
        children: ctaText
    });
};
const $401172d9225878ee$var$SECONDARY_BUTTON_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'secondary'
};
const $401172d9225878ee$export$ba0dce35a480e0b4 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, pressableStyle: pressableStyle, alt: alt })=>{
    const { handleClick: handleClick } = (0, $l2hye.useCrossflowMessageClicked)(crossflowOptions, $401172d9225878ee$var$SECONDARY_BUTTON_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cPbpX.default), {
        onClick: handleClick,
        xcss: pressableStyle,
        "aria-label": alt,
        children: ctaText
    });
};

});
parcelRegister("l2hye", function(module, exports) {

$parcel$export(module.exports, "useCrossflowMessageClicked", () => $51de4ccc95358dd4$export$1c3f82bc53516a2a);

var $givfd = parcelRequire("givfd");

var $guu3z = parcelRequire("guu3z");

var $4vp0Q = parcelRequire("4vp0Q");

var $eJOHy = parcelRequire("eJOHy");
const $51de4ccc95358dd4$export$1c3f82bc53516a2a = (crossflowOptions, clickedElement)=>{
    const crossflow = (0, $givfd.useCrossFlow)();
    const { messageClicked: messageClicked } = (0, $4vp0Q.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $guu3z.useMessageInstanceEvent)();
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        messageClicked().catch(()=>{});
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: clickedElement,
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        }).catch(()=>{});
        if (crossflow.isEnabled) crossflow.api.open(crossflowOptions).catch(()=>{});
    }, [
        crossflow,
        crossflowOptions,
        clickedElement,
        messageClicked,
        messageInstanceClicked
    ]);
    return {
        handleClick: handleClick
    };
};

});




parcelRegister("bbGLc", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $f8eaa8be4de93db5$export$78c758434c34d601);

var $ayGpT = parcelRequire("ayGpT");
const { createRender: $f8eaa8be4de93db5$export$78c758434c34d601, createValidate: $f8eaa8be4de93db5$export$2859a83e4d6da57d } = (0, $ayGpT.createClientPipeline)();
const { createHydrate: $f8eaa8be4de93db5$export$c905bc718befd59b, createHydrateExample: $f8eaa8be4de93db5$export$1f41223e5b0a6622, createTransformMetadata: $f8eaa8be4de93db5$export$88fe13b4d13f8423 } = (0, $ayGpT.createServerPipeline)();

});


parcelRegister("dUXRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3507e801b9561a7b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $8uw8h = parcelRequire("8uw8h");

var $j8vlL = parcelRequire("j8vlL");

var $7szcD = parcelRequire("7szcD");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $cjPj9 = parcelRequire("cjPj9");
const $3507e801b9561a7b$var$CCP_PRODUCT_ID = 'a6f908c8-709c-45f4-9e2d-eca25b93b94a';
const $3507e801b9561a7b$var$HAMS_PRODUCT_ID = 'jira-product-discovery';
const $3507e801b9561a7b$var$PRODUCT_NAME = 'Jira Product Discovery';
const $3507e801b9561a7b$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "growth.recommendation-jpd.reasons-modal.message",
            defaultMessage: "We think {jpd} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the JPD recommendation will be relevant to the customer.",
            values: {
                jpd: /*#__PURE__*/ (0, $gt9Am.jsx)("strong", {
                    children: $3507e801b9561a7b$var$PRODUCT_NAME
                })
            }
        })
    }),
    reasons: (0, $j8vlL.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $3507e801b9561a7b$export$b3890eb0ae9dca99 = (0, $cjPj9.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7szcD.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: $3507e801b9561a7b$var$HAMS_PRODUCT_ID,
            ccpProductId: $3507e801b9561a7b$var$CCP_PRODUCT_ID,
            logo: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.JiraProductDiscoveryIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-jpd.product-name.header",
                description: "Header for Jira Product Discovery recommendation message in Jira Side Nav",
                defaultMessage: "Transform insights into action plans"
            }),
            ctaMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-jpd.cta.label",
                description: "CTA text for Jira Product Discovery recommendation message in Jira Side Nav",
                defaultMessage: "Try Jira Product Discovery"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $3507e801b9561a7b$var$whyAmISeeingThisModalContent
    }));
var $3507e801b9561a7b$export$2e2bcd8739ae039 = $3507e801b9561a7b$export$b3890eb0ae9dca99;

});
parcelRegister("cjPj9", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $681d83f9b67173e4$export$78c758434c34d601);

var $ayGpT = parcelRequire("ayGpT");
const { createRender: $681d83f9b67173e4$export$78c758434c34d601, createValidate: $681d83f9b67173e4$export$2859a83e4d6da57d } = (0, $ayGpT.createClientPipeline)();
const { createHydrate: $681d83f9b67173e4$export$c905bc718befd59b, createHydrateExample: $681d83f9b67173e4$export$1f41223e5b0a6622, createTransformMetadata: $681d83f9b67173e4$export$88fe13b4d13f8423 } = (0, $ayGpT.createServerPipeline)();

});


parcelRegister("fJnRN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0364894363726e6f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $8uw8h = parcelRequire("8uw8h");

var $j8vlL = parcelRequire("j8vlL");

var $7szcD = parcelRequire("7szcD");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $2QsU0 = parcelRequire("2QsU0");
const $0364894363726e6f$export$3678c6c473f30928 = 'de63a248-1f93-46ed-b6ea-ab8e38af1c88';
const $0364894363726e6f$export$5fca8a2477be63d = 'jira-servicedesk.ondemand';
const $0364894363726e6f$var$PRODUCT_NAME = 'Jira Service Management';
const $0364894363726e6f$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "growth.recommendation-jsm.reasons-modal.message",
            defaultMessage: "We think {jsm} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the JSM recommendation will be relevant to the customer.",
            values: {
                jsm: /*#__PURE__*/ (0, $gt9Am.jsx)("strong", {
                    children: $0364894363726e6f$var$PRODUCT_NAME
                })
            }
        })
    }),
    reasons: (0, $j8vlL.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $0364894363726e6f$export$b3890eb0ae9dca99 = (0, $2QsU0.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7szcD.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: $0364894363726e6f$export$5fca8a2477be63d,
            ccpProductId: $0364894363726e6f$export$3678c6c473f30928,
            logo: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.JiraServiceManagementIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-jsm.product-name.header",
                description: "Header for Jira Service Management recommendation message in Jira Side Nav",
                defaultMessage: "Automate workflows for faster resolutions"
            }),
            ctaMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-jsm.cta.label",
                description: "CTA text for Jira Service Management recommendation message in Jira Side Nav",
                defaultMessage: "Try Jira Service Management"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $0364894363726e6f$var$whyAmISeeingThisModalContent
    }));
var $0364894363726e6f$export$2e2bcd8739ae039 = $0364894363726e6f$export$b3890eb0ae9dca99;

});
parcelRegister("2QsU0", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $7ad1eba558f0df8a$export$78c758434c34d601);

var $ayGpT = parcelRequire("ayGpT");
const { createRender: $7ad1eba558f0df8a$export$78c758434c34d601, createValidate: $7ad1eba558f0df8a$export$2859a83e4d6da57d } = (0, $ayGpT.createClientPipeline)();
const { createHydrate: $7ad1eba558f0df8a$export$c905bc718befd59b, createHydrateExample: $7ad1eba558f0df8a$export$1f41223e5b0a6622, createTransformMetadata: $7ad1eba558f0df8a$export$88fe13b4d13f8423 } = (0, $ayGpT.createServerPipeline)();

});


parcelRegister("03RUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6f03571c8409bfe$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $8uw8h = parcelRequire("8uw8h");

var $j8vlL = parcelRequire("j8vlL");

var $7szcD = parcelRequire("7szcD");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $djbrP = parcelRequire("djbrP");

const $a6f03571c8409bfe$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "growth.recommendation-jsw-visualize-work.reasons-modal.message",
            defaultMessage: "We think {product} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the Jira recommendation will be relevant to the customer.",
            values: {
                product: /*#__PURE__*/ (0, $gt9Am.jsx)("strong", {
                    children: (0, $8f1b9fdaa47e85a7$export$a75e537c279a265a)
                })
            }
        })
    }),
    reasons: (0, $j8vlL.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $a6f03571c8409bfe$export$b3890eb0ae9dca99 = (0, $djbrP.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7szcD.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: (0, $8f1b9fdaa47e85a7$export$5fca8a2477be63d),
            ccpProductId: (0, $8f1b9fdaa47e85a7$export$3678c6c473f30928),
            logo: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.JiraIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-jsw-visualize-work.product-name.header",
                description: "Header for Jira recommendation message in Jira Side Nav",
                defaultMessage: "Visualize your projects in lists, boards, and more"
            }),
            ctaMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-jsw-visualize-work.cta.label",
                description: "CTA text for Jira recommendation message in Jira Side Nav",
                defaultMessage: "Try Jira"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $a6f03571c8409bfe$var$whyAmISeeingThisModalContent
    }));
var $a6f03571c8409bfe$export$2e2bcd8739ae039 = $a6f03571c8409bfe$export$b3890eb0ae9dca99;

});
parcelRegister("djbrP", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $c0f1b35ad52c81d7$export$78c758434c34d601);

var $ayGpT = parcelRequire("ayGpT");
const { createRender: $c0f1b35ad52c81d7$export$78c758434c34d601, createValidate: $c0f1b35ad52c81d7$export$2859a83e4d6da57d } = (0, $ayGpT.createClientPipeline)();
const { createHydrate: $c0f1b35ad52c81d7$export$c905bc718befd59b, createHydrateExample: $c0f1b35ad52c81d7$export$1f41223e5b0a6622, createTransformMetadata: $c0f1b35ad52c81d7$export$88fe13b4d13f8423 } = (0, $ayGpT.createServerPipeline)();

});

const $8f1b9fdaa47e85a7$export$3678c6c473f30928 = 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f';
const $8f1b9fdaa47e85a7$export$5fca8a2477be63d = 'jira-software.ondemand';
const $8f1b9fdaa47e85a7$export$a75e537c279a265a = 'Jira';


parcelRegister("c01QG", function(module, exports) {

$parcel$export(module.exports, "default", () => $207e4aae61b326ef$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $8uw8h = parcelRequire("8uw8h");

var $j8vlL = parcelRequire("j8vlL");

var $7szcD = parcelRequire("7szcD");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $4N5sm = parcelRequire("4N5sm");

const $207e4aae61b326ef$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "growth.recommendation-loom.reasons-modal.message",
            defaultMessage: "We think {product} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the Loom recommendation will be relevant to the customer.",
            values: {
                product: /*#__PURE__*/ (0, $gt9Am.jsx)("strong", {
                    children: (0, $a5dd4e27c8a9a36f$export$a75e537c279a265a)
                })
            }
        })
    }),
    reasons: (0, $j8vlL.whyAmISeeingThisRecommendationMessageDefaultReason)
};
const $207e4aae61b326ef$export$b3890eb0ae9dca99 = (0, $4N5sm.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7szcD.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: (0, $a5dd4e27c8a9a36f$export$5fca8a2477be63d),
            ccpProductId: (0, $a5dd4e27c8a9a36f$export$3678c6c473f30928),
            logo: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uw8h.LoomIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-loom.product-name.header",
                description: "Header for Loom recommendation message in Jira Side Nav",
                defaultMessage: "Record and share videos easily"
            }),
            ctaMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                id: "growth.recommendation-loom.cta.label",
                description: "CTA text for Loom recommendation message in Jira Side Nav",
                defaultMessage: "Try Loom"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $207e4aae61b326ef$var$whyAmISeeingThisModalContent
    }));
var $207e4aae61b326ef$export$2e2bcd8739ae039 = $207e4aae61b326ef$export$b3890eb0ae9dca99;

});
parcelRegister("4N5sm", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $080553b75f2a9521$export$78c758434c34d601);

var $ayGpT = parcelRequire("ayGpT");
const { createRender: $080553b75f2a9521$export$78c758434c34d601, createValidate: $080553b75f2a9521$export$2859a83e4d6da57d } = (0, $ayGpT.createClientPipeline)();
const { createHydrate: $080553b75f2a9521$export$c905bc718befd59b, createHydrateExample: $080553b75f2a9521$export$1f41223e5b0a6622, createTransformMetadata: $080553b75f2a9521$export$88fe13b4d13f8423 } = (0, $ayGpT.createServerPipeline)();

});

const $a5dd4e27c8a9a36f$export$ea76e6b040284832 = 'loom';
const $a5dd4e27c8a9a36f$export$5fca8a2477be63d = 'loom';
const $a5dd4e27c8a9a36f$export$a75e537c279a265a = 'Loom';
const $a5dd4e27c8a9a36f$export$3678c6c473f30928 = '7683a73e-423d-41a1-b43f-d497656f8b5d';



parcelRegister("jzweC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4515250e3831fce7$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $2RSCh = parcelRequire("2RSCh");
var $4515250e3831fce7$export$2e2bcd8739ae039 = {
    'message-template-template': (0, $2RSCh.default)
};

});
parcelRegister("2RSCh", function(module, exports) {

$parcel$export(module.exports, "default", () => $167ba8acd91d8c2f$export$2e2bcd8739ae039);
/* eslint-disable formatjs/no-literal-string-in-jsx */ 
var $gt9Am = parcelRequire("gt9Am");

var $hvhZq = parcelRequire("hvhZq");
const $167ba8acd91d8c2f$export$b3890eb0ae9dca99 = (0, $hvhZq.createRender)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)("button", {
        children: `Hello world!`
    }));
var $167ba8acd91d8c2f$export$2e2bcd8739ae039 = $167ba8acd91d8c2f$export$b3890eb0ae9dca99;

});
parcelRegister("hvhZq", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $e7fa76bbc70f1814$export$78c758434c34d601);

var $ayGpT = parcelRequire("ayGpT");
const { createRender: $e7fa76bbc70f1814$export$78c758434c34d601, createValidate: $e7fa76bbc70f1814$export$2859a83e4d6da57d } = (0, $ayGpT.createClientPipeline)();
const { createHydrate: $e7fa76bbc70f1814$export$c905bc718befd59b, createHydrateExample: $e7fa76bbc70f1814$export$1f41223e5b0a6622, createTransformMetadata: $e7fa76bbc70f1814$export$88fe13b4d13f8423 } = (0, $ayGpT.createServerPipeline)();

});



parcelRegister("bhOW3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6dff0105a43c877$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $f3NrQ = parcelRequire("f3NrQ");
var $b6dff0105a43c877$export$2e2bcd8739ae039 = {
    'test-message-inapp': (0, $f3NrQ.default)
};

});
parcelRegister("f3NrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5bdec6d9cf6918a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $2Nv0V = parcelRequire("2Nv0V");
const $e5bdec6d9cf6918a$export$b3890eb0ae9dca99 = (0, $2Nv0V.createRender)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)("button", {
        children: "This is an example test button"
    }));
var $e5bdec6d9cf6918a$export$2e2bcd8739ae039 = $e5bdec6d9cf6918a$export$b3890eb0ae9dca99;

});
parcelRegister("2Nv0V", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $2c2b83e48e32020d$export$78c758434c34d601);

var $ayGpT = parcelRequire("ayGpT");
const { createRender: $2c2b83e48e32020d$export$78c758434c34d601, createValidate: $2c2b83e48e32020d$export$2859a83e4d6da57d } = (0, $ayGpT.createClientPipeline)();
const { createHydrate: $2c2b83e48e32020d$export$c905bc718befd59b, createHydrateExample: $2c2b83e48e32020d$export$1f41223e5b0a6622, createTransformMetadata: $2c2b83e48e32020d$export$88fe13b4d13f8423 } = (0, $ayGpT.createServerPipeline)();

});




/* GeneratedContentHash: 9c47655ae0da7c4a10425612f1be5cf9c57ec22e23c4d4b1e4a2589c469dc001 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $dbfbf1ad464393a8$export$a5cfae247d8360ef = 'jira-side-nav';



parcelRegister("e5TCl", function(module, exports) {

$parcel$export(module.exports, "NavPlatformSidebar", () => $819bf05af8d51eaf$export$7d687ab114dcac8a);

var $eJOHy = parcelRequire("eJOHy");

var $20Hsz = parcelRequire("20Hsz");

var $7ox54 = parcelRequire("7ox54");

var $lTExG = parcelRequire("lTExG");
function $819bf05af8d51eaf$export$7d687ab114dcac8a() {
    /*
		1. Add UFOSegment
		2. Determine which sidebar to show
		  a. If NOT content sidebar,
		    1. render other sidebars within `postMainElement`
			2. disable customisation
			3. Return GSN component
		  b. Otherwise,
		    1. Get items-config (default config), using custom components


	*/ /*
		Use same sidebar-selector logic as in navigation-apps/sidebar-nav4/sidebar-selector/src/ui/entrypoint/index.tsx
	*/ const paramsForGetNav4SidebarId = (0, $20Hsz.useGetParamsForGetNav4SidebarId)();
    const currentSidebarId = (0, $20Hsz.getNav4SidebarId)(paramsForGetNav4SidebarId);
    if (currentSidebarId === 'CONTENT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ox54.GSNForContentSidebar), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTExG.GSNForOtherSidebars), {
        sidebarId: currentSidebarId
    });
}

});
parcelRegister("7ox54", function(module, exports) {

$parcel$export(module.exports, "GSNForContentSidebar", () => $ae9c45f14bc9869f$export$a507175eae481438);

var $QuA6u = parcelRequire("QuA6u");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5DOjx = parcelRequire("5DOjx");

var $9FYIg = parcelRequire("9FYIg");

var $dpxw4 = parcelRequire("dpxw4");

var $5n5Xi = parcelRequire("5n5Xi");

var $8IuE5 = parcelRequire("8IuE5");

var $41vqi = parcelRequire("41vqi");

var $2wp9U = parcelRequire("2wp9U");

var $4P1EM = parcelRequire("4P1EM");

var $hcSA5 = parcelRequire("hcSA5");

var $7u7ku = parcelRequire("7u7ku");

var $gk3Hc = parcelRequire("gk3Hc");

var $49MXG = parcelRequire("49MXG");

var $9VG2G = parcelRequire("9VG2G");

var $iPxs6 = parcelRequire("iPxs6");

var $2geah = parcelRequire("2geah");

var $cRvJm = parcelRequire("cRvJm");

var $cRLIL = parcelRequire("cRLIL");

var $iFx8E = parcelRequire("iFx8E");

var $g0Ue2 = parcelRequire("g0Ue2");

var $i8N06 = parcelRequire("i8N06");

var $7jTnu = parcelRequire("7jTnu");

var $eJYI8 = parcelRequire("eJYI8");

var $99tvj = parcelRequire("99tvj");

var $24QYf = parcelRequire("24QYf");

var $753q2 = parcelRequire("753q2");

var $6JmRt = parcelRequire("6JmRt");

var $kEUB1 = parcelRequire("kEUB1");

var $4ihOZ = parcelRequire("4ihOZ");

var $8q7lT = parcelRequire("8q7lT");

var $7Cu03 = parcelRequire("7Cu03");

var $goBB5 = parcelRequire("goBB5");

var $a62R3 = parcelRequire("a62R3");

var $eL2Ux = parcelRequire("eL2Ux");

var $d5UZJ = parcelRequire("d5UZJ");

var $lRq8t = parcelRequire("lRq8t");

var $6VUpl = parcelRequire("6VUpl");
const $ae9c45f14bc9869f$var$forYouConfig = (0, $6VUpl.getForYouConfig)();
function $ae9c45f14bc9869f$export$a507175eae481438() {
    /*
  	TODO: Add support for entryPoint routes
  	*/ // This is the non-EP solution for loading the data
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $6JmRt.navPlatformSidebarResource));
    const queryReferenceRef = (0, $eJOHy.useRef)(null);
    // We don't want to use nullable query references. So only remember the non-null ones,
    // and pass the non-null query reference to the children.
    // From Slack: https://atlassian.slack.com/archives/C01E2MPPLE4/p1654736794416059?thread_ts=1654051102.548519&cid=C01E2MPPLE4
    if (queryReference) queryReferenceRef.current = queryReference;
    else if (!queryReferenceRef.current) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ae9c45f14bc9869f$var$GSNForContentSidebarInner, {
        queryReference: queryReferenceRef.current
    });
}
function $ae9c45f14bc9869f$var$GSNForContentSidebarInner(props) {
    const { queryReference: queryReference } = props;
    const queryRef = (0, $j4oe4.usePreloadedQuery)(/* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ (0, $QuA6u.default), queryReference);
    const shouldRenderOverviews = (0, $eJYI8.useShouldRenderOverviews)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const activationId = (0, $4ihOZ.useActivationId)();
    const ownerId = (0, $8q7lT.useAccountId)();
    const navItems = (0, $99tvj.useFilterL1MenuItemsByEditionAndLicense)((0, $24QYf.USER_NAVIGATION_CONFIGURATION_DEFAULT).navItems);
    const items = $ae9c45f14bc9869f$var$useItemConfig(navItems, queryRef, shouldRenderOverviews);
    const networkStorageParams = (0, $eJOHy.useMemo)(()=>{
        const entityAri = (0, $goBB5.JiraWorkspaceAri).create({
            siteId: cloudId,
            activationId: activationId
        }).toString();
        const ownerAri = ownerId && (0, $7Cu03.IdentityUserAri).create({
            userId: ownerId
        }).toString() || '';
        return {
            entityAri: entityAri,
            ownerAri: ownerAri,
            queryRef: queryRef
        };
    }, [
        cloudId,
        activationId,
        ownerId,
        queryRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dpxw4.SidebarNav4ContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DOjx.GlobalSideNavigation), {
        app: "jira",
        appLabel: "Jira",
        customizationStore: "network",
        forYou: $ae9c45f14bc9869f$var$forYouConfig,
        items: items,
        networkStorageParams: networkStorageParams,
        testId: "nav-platform-integration-sidebar.ui.global-side-navigation"
    }));
}
function $ae9c45f14bc9869f$var$useItemConfig(navItems, queryRef, shouldRenderOverviews) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const components = (0, $eJOHy.useMemo)(()=>{
        const componentProps = {
            isExpanded: false,
            queryRef: queryRef
        };
        const USER_NAVIGATION_ITEM_LINKS = (0, $41vqi.getUserNavigationItemLinks)();
        return navItems.map(({ menuId: menuId })=>{
            switch(menuId){
                case (0, $8IuE5.L1_MENU_ID).APPS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wp9U.Nav4Apps), componentProps);
                case (0, $8IuE5.L1_MENU_ID).ASSETS:
                    /* remove this case on
           * assets_as_an_app_v2 cleanup
           */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4P1EM.Nav4Assets), {
                        isExpanded: componentProps.isExpanded
                    });
                case (0, $8IuE5.L1_MENU_ID).DASHBOARDS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gk3Hc.Nav4Dashboards), {
                        isExpanded: componentProps.isExpanded
                    });
                case (0, $8IuE5.L1_MENU_ID).FILTERS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5n5Xi.Nav4Filters), componentProps);
                case (0, $8IuE5.L1_MENU_ID).GOALS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $753q2.Stub), {
                        menuId: (0, $8IuE5.L1_MENU_ID).GOALS,
                        href: USER_NAVIGATION_ITEM_LINKS[(0, $8IuE5.L1_MENU_ID).GOALS]
                    });
                case (0, $8IuE5.L1_MENU_ID).OPERATIONS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $49MXG.Nav4Operations), componentProps);
                case (0, $8IuE5.L1_MENU_ID).COMMUNICATION:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9VG2G.Nav4Communications), {
                        isExpanded: componentProps.isExpanded
                    });
                case (0, $8IuE5.L1_MENU_ID).PLANS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2geah.Nav4Plans), componentProps);
                case (0, $8IuE5.L1_MENU_ID).OVERVIEWS:
                    return shouldRenderOverviews && (0, $7jTnu.fg)('blu-2858-sidebar-menu-overviews') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iPxs6.Nav4Overviews), componentProps) : null;
                case (0, $8IuE5.L1_MENU_ID).PROJECTS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cRvJm.Nav4Projects), componentProps);
                case (0, $8IuE5.L1_MENU_ID).RECENT:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cRLIL.Recent), null);
                case (0, $8IuE5.L1_MENU_ID).ROADMAPS:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iFx8E.Nav4Roadmaps), {
                        isExpanded: componentProps.isExpanded
                    });
                case (0, $8IuE5.L1_MENU_ID).STARRED:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g0Ue2.Starred), null);
                case (0, $8IuE5.L1_MENU_ID).TEAMS:
                    return !(0, $a62R3.isTeamsAppEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8N06.Teams), null) : null;
                case (0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE:
                    return (0, $7jTnu.fg)('jcs_master_flag') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7u7ku.CustomerService), null) : null;
                case (0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS:
                    return (0, $7jTnu.fg)('jcs-analytics-page') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hcSA5.CustomerServiceAnalytics), null) : null;
                default:
                    return null;
            }
        });
    }, [
        navItems,
        queryRef,
        shouldRenderOverviews
    ]);
    return (0, $eJOHy.useMemo)(()=>navItems.reduce((acc, navItem, index)=>{
            const component = components[index];
            // We need a configurable menu id and a component to continue
            if ((0, $d5UZJ.isConfigurableMenuId)(navItem.menuId) && component) {
                const { message: message, Icon: Icon } = (0, $eL2Ux.getConfigurableMessageAndIcon)(navItem.menuId);
                const label = formatMessage(message);
                // See src/packages/navigation-apps/sidebar-nav4/sidebars/common/core/src/common/utils/use-formatted-message-and-icon/index.tsx
                const elemBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
                    label: label,
                    spacing: "spacious",
                    color: "currentColor"
                });
                acc[navItem.menuId] = {
                    type: 'custom',
                    elemBefore: elemBefore,
                    label: label,
                    Component: ()=>component
                };
            }
            return acc;
        }, {}), [
        components,
        formatMessage,
        navItems
    ]);
}

});
parcelRegister("5DOjx", function(module, exports) {

$parcel$export(module.exports, "GlobalSideNavigation", () => $dea400e52a7f5b1a$export$e3822b656235cd34);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8XtVW = parcelRequire("8XtVW");

var $aoTms = parcelRequire("aoTms");

var $7SKIr = parcelRequire("7SKIr");
var $4PPPq = parcelRequire("4PPPq");

var $i2hNi = parcelRequire("i2hNi");

var $fvlFa = parcelRequire("fvlFa");

var $2KHoH = parcelRequire("2KHoH");

var $6Xw13 = parcelRequire("6Xw13");

var $lQEtx = parcelRequire("lQEtx");

var $jm3ec = parcelRequire("jm3ec");

var $lvjcp = parcelRequire("lvjcp");
const $dea400e52a7f5b1a$export$e3822b656235cd34 = (0, $i2hNi.withSideNavigationAnalyticsContext)($dea400e52a7f5b1a$var$RawGlobalSideNavigation);
var $dea400e52a7f5b1a$export$2e2bcd8739ae039 // This is only needed to support the Atlaskit docs. See https://hello.atlassian.net/wiki/spaces/navx/pages/5305993008/Platform+Guide#Atlaskit-%3CProps%3E-component-not-rendering
 = $dea400e52a7f5b1a$var$RawGlobalSideNavigation;
function $dea400e52a7f5b1a$var$RawGlobalSideNavigation(props) {
    const { app: app, appLabel: appLabel, cloudId: cloudId, customizationStore: customizationStore = 'local', disableMenuCustomization: disableMenuCustomization = false, isShortcutsStatic: isShortcutsStatic, networkStorageParams: networkStorageParams, orgId: orgId, peekMenuId: peekMenuId, userId: userId, ...innerProps } = props;
    const Store = (0, $eJOHy.useMemo)(()=>{
        return customizationStore === 'local' ? (0, $lQEtx.LocalStore) : (0, $jm3ec.NetworkStore);
    }, [
        customizationStore
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fvlFa.AsyncIntlProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aoTms.ModalContextProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4PPPq.BFFProvider), {
                consumer: (0, $7SKIr.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2KHoH.OptionsProvider), {
                    app: app,
                    appLabel: appLabel,
                    cloudId: cloudId,
                    customizationStore: customizationStore,
                    disableMenuCustomization: disableMenuCustomization,
                    isShortcutsStatic: isShortcutsStatic,
                    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                    l1DragAndDropEnabled: !disableMenuCustomization && (0, $8XtVW.fg)('navx-515-l1-dnd-support'),
                    networkStorageParams: networkStorageParams,
                    orgId: orgId,
                    userId: userId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Xw13.PeekMenuIdProviders), {
                        value: peekMenuId,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Store, {
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lvjcp.SideNav), {
                                ...innerProps
                            })
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("i2hNi", function(module, exports) {

$parcel$export(module.exports, "withSideNavigationAnalyticsContext", () => $65082f97679cc83b$export$6d30b5ca07993d23);
$parcel$export(module.exports, "withSideNavigationAnalyticsListener", () => $65082f97679cc83b$export$b46bb3dcfcaed790);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxsjC = parcelRequire("kxsjC");

var $dbq8g = parcelRequire("dbq8g");

function $65082f97679cc83b$export$6d30b5ca07993d23(WrappedComponent) {
    return (props)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxsjC.NavigationAnalyticsContext), {
            data: {
                ...$65082f97679cc83b$var$contextData,
                attributes: {
                    screen: props.app || 'unknown'
                }
            },
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                ...props
            })
        });
    };
}
const $65082f97679cc83b$export$b46bb3dcfcaed790 = (children, cb)=>{
    const handleOnEvent = (event)=>{
        // Make sure we only listen to click events and fires our event inside the callback function
        event._isUIAnalyticsEvent && event.payload?.action === 'clicked' && cb?.();
    };
    return(// Only listen to events from the ATLASKIT_CHANNEL to narrow down the payloads we receive
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dbq8g.default), {
        channel: (0, $9900fe341890aa8c$export$3b03fceec8e67395),
        onEvent: handleOnEvent,
        children: children
    }));
};
const $65082f97679cc83b$var$packageMetadata = {
    source: 'topNav',
    componentName: (0, $9900fe341890aa8c$export$fc44104665f4d1e5),
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $65082f97679cc83b$var$sourceMetadata = {
    navLayer: 'global',
    navContainer: 'top',
    navVersion: '4'
};
const $65082f97679cc83b$var$sideNavMetadata = {
    screen: 'unknown'
};
const $65082f97679cc83b$var$contextData = {
    ...$65082f97679cc83b$var$packageMetadata,
    attributes: {
        ...$65082f97679cc83b$var$sideNavMetadata,
        ...$65082f97679cc83b$var$sourceMetadata
    }
};

});
const $9900fe341890aa8c$export$3f072f06b90c3985 = 'navigation';
const $9900fe341890aa8c$export$fc44104665f4d1e5 = 'GlobalSideNavigation';
const $9900fe341890aa8c$export$3b03fceec8e67395 = 'atlaskit';


parcelRegister("fvlFa", function(module, exports) {

$parcel$export(module.exports, "AsyncIntlProvider", () => $23976a00991e5a3c$export$2f688dfcc031530a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NGNw = parcelRequire("5NGNw");

var $2Y7zM = parcelRequire("2Y7zM");

var $kvNDr = parcelRequire("kvNDr");
const $23976a00991e5a3c$var$fetchMessagesForLocale = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $kvNDr.asyncLanguages) ? locale : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $kvNDr.asyncLanguages)[languageLocale]?.();
        return localeMessages?.default ?? (0, $2Y7zM.default);
    } catch  {
    // ignore
    }
    return 0, $2Y7zM.default;
};
const $23976a00991e5a3c$export$2f688dfcc031530a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5NGNw.default), {
        defaultMessages: (0, $2Y7zM.default),
        loaderFn: $23976a00991e5a3c$var$fetchMessagesForLocale,
        children: children
    });
};

});
parcelRegister("2Y7zM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f85bbd00b42c8cdc$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $dMoTg = parcelRequire("dMoTg");
var $f85bbd00b42c8cdc$export$2e2bcd8739ae039 = (0, $dMoTg.default);

});
parcelRegister("dMoTg", function(module, exports) {

$parcel$export(module.exports, "default", () => $503cbce8ef28a807$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $503cbce8ef28a807$export$2e2bcd8739ae039 = {
    'navigation-global-side-navigation.object-list-flyout.empty-state.description': "Once you visit, edit, or create projects, issues, boards, filters, and dashboards, they\u2019ll show up here.",
    'navigation-global-side-navigation.object-list-flyout.empty-state.header': 'Nothing to see here!',
    'navigation-global-side-navigation.object-list-flyout.error-state.description': 'Refresh the page and try again.',
    'navigation-global-side-navigation.object-list-flyout.error-state.header': "We couldn't fetch your items",
    'navigation-global-side-navigation.object-list-flyout.loading-state.accessible-name': 'Content is loading',
    'navigation.global-side-navigation.customization-modal.actions-icon-button-label': 'Actions for {menuName} item',
    'navigation.global-side-navigation.customization-modal.app-items-list-description': 'The following Atlassian apps are available for your organization.',
    'navigation.global-side-navigation.customization-modal.app-items-list-label': 'App shortcuts',
    'navigation.global-side-navigation.customization-modal.app-items-list-title': 'App shortcuts',
    'navigation.global-side-navigation.customization-modal.close-button-label': 'Cancel changes to your sidebar',
    'navigation.global-side-navigation.customization-modal.close-button-text': 'Cancel',
    'navigation.global-side-navigation.customization-modal.close-icon-button-label': 'Close and cancel changes to your sidebar',
    'navigation.global-side-navigation.customization-modal.heading-body.heading-body-text': 'Selected items will always be visible in the sidebar. You can still access unselected items from the <b>More</b> menu in the sidebar.',
    'navigation.global-side-navigation.customization-modal.heading-body.heading-body-text-info': 'The changes you make here only affect you and not anyone else on your site.',
    'navigation.global-side-navigation.customization-modal.heading-text': 'Customize your sidebar',
    'navigation.global-side-navigation.customization-modal.hide-item-action-label': 'Hide {menuName} from sidebar',
    'navigation.global-side-navigation.customization-modal.hide-item-action-text': 'Hide item from sidebar',
    'navigation.global-side-navigation.customization-modal.hide-item-checkbox-label': 'Hide {menuName} section in sidebar',
    'navigation.global-side-navigation.customization-modal.move-item-actions-label': 'Move {menuName}',
    'navigation.global-side-navigation.customization-modal.move-item-actions-text': 'Move item within sidebar',
    'navigation.global-side-navigation.customization-modal.move-item-bottom-label': 'Move {menuName} to bottom',
    'navigation.global-side-navigation.customization-modal.move-item-bottom-text': 'Move {menuName} to bottom',
    'navigation.global-side-navigation.customization-modal.move-item-down-label': 'Move {menuName} down',
    'navigation.global-side-navigation.customization-modal.move-item-down-text': 'Move down',
    'navigation.global-side-navigation.customization-modal.move-item-top-label': 'Move {menuName} to top',
    'navigation.global-side-navigation.customization-modal.move-item-top-text': 'Move {menuName} to top',
    'navigation.global-side-navigation.customization-modal.move-item-up-label': 'Move {menuName} up',
    'navigation.global-side-navigation.customization-modal.move-item-up-text': 'Move up',
    'navigation.global-side-navigation.customization-modal.product-items-list-description': 'The following navigation items are available in {app}.',
    'navigation.global-side-navigation.customization-modal.product-items-list-label': 'Customize {app} navigation',
    'navigation.global-side-navigation.customization-modal.product-items-list-title': '{app} navigation',
    'navigation.global-side-navigation.customization-modal.save-button-label': 'Save customization to your sidebar',
    'navigation.global-side-navigation.customization-modal.save-button-text': 'Save changes',
    'navigation.global-side-navigation.customization-modal.show-item-action-label': 'Show {menuName} in sidebar',
    'navigation.global-side-navigation.customization-modal.show-item-action-text': 'Show item in sidebar',
    'navigation.global-side-navigation.customization-modal.show-item-checkbox-label': 'Show {menuName} section in sidebar',
    'navigation.global-side-navigation.customize-sidebar-menu-item.label': 'Customize sidebar',
    'navigation.global-side-navigation.for-you.label': 'For you',
    'navigation.global-side-navigation.more-menu-item.link-external-item-label': 'Open external link icon',
    'navigation.global-side-navigation.more-menu.label': 'More',
    'navigation.global-side-navigation.object-list-flyout.clearSearchIconLabel': 'Clear search',
    'navigation.global-side-navigation.object-list-flyout.filterIconLabel': 'Filters',
    'navigation.global-side-navigation.object-list-flyout.removeFilterIconLabel': 'Remove',
    'navigation.global-side-navigation.object-list-flyout.searchPlaceholder': 'Search...',
    'navigation.global-side-navigation.object-list-flyout.selectedFilters': 'Selected filters',
    'navigation.global-side-navigation.onboarding-menu.give-feedback': 'Give feedback',
    'navigation.global-side-navigation.onboarding-menu.guided-tour': 'Take a guided tour',
    'navigation.global-side-navigation.onboarding-menu.navigation-docs': 'Read about the new navigation',
    'navigation.global-side-navigation.panel-splitter.label': 'Resize panel',
    'navigation.global-side-navigation.recents.label': 'Recent',
    'navigation.global-side-navigation.recents.viewAllRecentsLabel': 'View all recent items',
    'navigation.global-side-navigation.recentsSearchPlaceholder': 'Search recent items',
    'navigation.global-side-navigation.starred.label': 'Starred',
    'navigation.global-side-navigation.starred.viewAllStarredLabel': 'View all starred items',
    'navigation.global-side-navigation.starredSearchPlaceholder': 'Search starred items',
    'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-hidden': 'The top level menu item {label} has been hidden and moved to the More menu.',
    'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-reordered': 'The top level menu item {label} has been moved from position {startIndex} to {finishIndex}.'
};

});


parcelRegister("kvNDr", function(module, exports) {

$parcel$export(module.exports, "asyncLanguages", () => $01615cf2c2ca9902$export$3770c7a7737d463c);
// https://parceljs.org/features/dependency-resolution/#glob-specifiers





























const $01615cf2c2ca9902$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("8kVUk")),
    da: ()=>(parcelRequire("aEjEO")),
    de: ()=>(parcelRequire("gjSMr")),
    'en-GB': ()=>(parcelRequire("gNfKa")),
    'en-ZZ': ()=>(parcelRequire("bj648")),
    en: ()=>Promise.resolve((parcelRequire("2Y7zM"))),
    es: ()=>(parcelRequire("6Z7AS")),
    fi: ()=>(parcelRequire("kWx3y")),
    fr: ()=>(parcelRequire("56XAH")),
    hr: ()=>(parcelRequire("loDPW")),
    hu: ()=>(parcelRequire("dyg13")),
    it: ()=>(parcelRequire("krJsn")),
    ja: ()=>(parcelRequire("3dVNn")),
    ko: ()=>(parcelRequire("U5f59")),
    nb: ()=>(parcelRequire("h4fbq")),
    nl: ()=>(parcelRequire("1t27Q")),
    pl: ()=>(parcelRequire("aJi3E")),
    'pt-BR': ()=>(parcelRequire("bvup0")),
    ru: ()=>(parcelRequire("44GzV")),
    sl: ()=>(parcelRequire("2tHyo")),
    'sr-RS': ()=>(parcelRequire("eSrG2")),
    'sr-YR': ()=>(parcelRequire("38yJ3")),
    sv: ()=>(parcelRequire("7k1zQ")),
    th: ()=>(parcelRequire("fAvVh")),
    tr: ()=>(parcelRequire("4TmtN")),
    uk: ()=>(parcelRequire("2ig4q")),
    vi: ()=>(parcelRequire("iQqcz")),
    zh_TW: ()=>(parcelRequire("eY1sM")),
    zh: ()=>(parcelRequire("jbcNW"))
};

});
parcelRegister("8kVUk", function(module, exports) {

let $611d1c3b6144e350$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $611d1c3b6144e350$var$load("9TUee").then(()=>parcelRequire('dxQye'));

});

parcelRegister("aEjEO", function(module, exports) {

let $7c0ce352f2346984$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7c0ce352f2346984$var$load("9JkRX").then(()=>parcelRequire('ctHGN'));

});

parcelRegister("gjSMr", function(module, exports) {

let $be18e9e8f513da0e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $be18e9e8f513da0e$var$load("d9XLj").then(()=>parcelRequire('dw3sN'));

});

parcelRegister("gNfKa", function(module, exports) {

let $c39d6f4f3ff980f5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c39d6f4f3ff980f5$var$load("ftflT").then(()=>parcelRequire('gEsta'));

});

parcelRegister("bj648", function(module, exports) {

let $83b62c9662e45224$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $83b62c9662e45224$var$load("f8dGU").then(()=>parcelRequire('gr6ru'));

});

parcelRegister("6Z7AS", function(module, exports) {

let $515e5492d4cae07b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $515e5492d4cae07b$var$load("5CTFD").then(()=>parcelRequire('dRWPy'));

});

parcelRegister("kWx3y", function(module, exports) {

let $f3f2ddbb754cb8f1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f3f2ddbb754cb8f1$var$load("fgcbB").then(()=>parcelRequire('hInYD'));

});

parcelRegister("56XAH", function(module, exports) {

let $3b8bbcd10a8757f5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3b8bbcd10a8757f5$var$load("9AUbI").then(()=>parcelRequire('3iEQ0'));

});

parcelRegister("loDPW", function(module, exports) {

let $f93abd99db4fd573$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f93abd99db4fd573$var$load("1cjw8").then(()=>parcelRequire('bT6aJ'));

});

parcelRegister("dyg13", function(module, exports) {

let $9ddadfcdab856fd4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9ddadfcdab856fd4$var$load("7kf6h").then(()=>parcelRequire('NehGg'));

});

parcelRegister("krJsn", function(module, exports) {

let $ee299707f9f9ef61$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ee299707f9f9ef61$var$load("eHfT2").then(()=>parcelRequire('g4on5'));

});

parcelRegister("3dVNn", function(module, exports) {

let $258f6af22723eaa4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $258f6af22723eaa4$var$load("8YZsJ").then(()=>parcelRequire('72xKc'));

});

parcelRegister("U5f59", function(module, exports) {

let $0a894c14a04ce7a9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0a894c14a04ce7a9$var$load("iwsPE").then(()=>parcelRequire('6PdyO'));

});

parcelRegister("h4fbq", function(module, exports) {

let $c6ce967d721295af$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c6ce967d721295af$var$load("gUhyV").then(()=>parcelRequire('bd4JL'));

});

parcelRegister("1t27Q", function(module, exports) {

let $111a25f494301be1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $111a25f494301be1$var$load("8pp2V").then(()=>parcelRequire('6tAlt'));

});

parcelRegister("aJi3E", function(module, exports) {

let $7cfc1d413abc2731$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7cfc1d413abc2731$var$load("kiK6G").then(()=>parcelRequire('eADmZ'));

});

parcelRegister("bvup0", function(module, exports) {

let $860a2c34b74e4d24$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $860a2c34b74e4d24$var$load("7ZZvM").then(()=>parcelRequire('6FaAz'));

});

parcelRegister("44GzV", function(module, exports) {

let $2f789054cdcce060$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2f789054cdcce060$var$load("hztiH").then(()=>parcelRequire('6wOJs'));

});

parcelRegister("2tHyo", function(module, exports) {

let $1ce01316de77a642$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1ce01316de77a642$var$load("4ACOY").then(()=>parcelRequire('hqCKK'));

});

parcelRegister("eSrG2", function(module, exports) {

let $ad4b93ec37dd09fb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ad4b93ec37dd09fb$var$load("hlQr6").then(()=>parcelRequire('icsrq'));

});

parcelRegister("38yJ3", function(module, exports) {

let $248d0e3f64dd50ca$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $248d0e3f64dd50ca$var$load("jOibR").then(()=>parcelRequire('hC1Pn'));

});

parcelRegister("7k1zQ", function(module, exports) {

let $554b9fddd3472a05$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $554b9fddd3472a05$var$load("5vYsU").then(()=>parcelRequire('dgbJm'));

});

parcelRegister("fAvVh", function(module, exports) {

let $b592fb06ad1e40e5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b592fb06ad1e40e5$var$load("8b4Dz").then(()=>parcelRequire('edUBx'));

});

parcelRegister("4TmtN", function(module, exports) {

let $38fdbc75c004f94c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $38fdbc75c004f94c$var$load("hZgpv").then(()=>parcelRequire('2ZQ2v'));

});

parcelRegister("2ig4q", function(module, exports) {

let $1ab9ba75c2218a82$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1ab9ba75c2218a82$var$load("ddTGs").then(()=>parcelRequire('hZcDG'));

});

parcelRegister("iQqcz", function(module, exports) {

let $db8168723a66f852$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $db8168723a66f852$var$load("aF1Yu").then(()=>parcelRequire('cZOrH'));

});

parcelRegister("eY1sM", function(module, exports) {

let $02cfde28c10148fc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $02cfde28c10148fc$var$load("4OdGi").then(()=>parcelRequire('gvwzK'));

});

parcelRegister("jbcNW", function(module, exports) {

let $df68fa18f91cf0d3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $df68fa18f91cf0d3$var$load("7CxL6").then(()=>parcelRequire('7dow1'));

});



parcelRegister("2KHoH", function(module, exports) {

$parcel$export(module.exports, "OptionsProvider", () => $d44e681093f2f7c5$export$1238f6fc6d9e005a);
$parcel$export(module.exports, "useOptions", () => $d44e681093f2f7c5$export$b8ae39f344200a7d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");
const $d44e681093f2f7c5$export$b709306b005c3ef = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
function $d44e681093f2f7c5$export$1238f6fc6d9e005a({ app: app, appLabel: appLabel, children: children, cloudId: cloudId, customizationStore: customizationStore, disableMenuCustomization: disableMenuCustomization, isShortcutsStatic: isShortcutsStatic, l1DragAndDropEnabled: l1DragAndDropEnabled, networkStorageParams: networkStorageParams, orgId: orgId, userId: userId }) {
    const options = (0, $eJOHy.useMemo)(()=>({
            app: app,
            appLabel: appLabel,
            cloudId: cloudId,
            customizationStore: customizationStore,
            disableMenuCustomization: disableMenuCustomization,
            isShortcutsStatic: isShortcutsStatic,
            l1DragAndDropEnabled: l1DragAndDropEnabled,
            networkStorageParams: networkStorageParams,
            orgId: orgId,
            userId: userId
        }), [
        app,
        appLabel,
        cloudId,
        customizationStore,
        disableMenuCustomization,
        isShortcutsStatic,
        l1DragAndDropEnabled,
        networkStorageParams,
        orgId,
        userId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d44e681093f2f7c5$export$b709306b005c3ef.Provider, {
        value: options,
        children: children
    });
}
const $d44e681093f2f7c5$export$b8ae39f344200a7d = ()=>{
    const options = (0, $eJOHy.useContext)($d44e681093f2f7c5$export$b709306b005c3ef);
    (0, $8GOss.default)(options, 'useOptions must be used inside an initialized OptionsProvider');
    return options;
};

});

parcelRegister("6Xw13", function(module, exports) {

$parcel$export(module.exports, "usePeekMenuId", () => $432412999859d20a$export$5d097184c0f78e68);
$parcel$export(module.exports, "useSetPeekMenuId", () => $432412999859d20a$export$a90578dce3c14324);
$parcel$export(module.exports, "PeekMenuIdProviders", () => $432412999859d20a$export$781f6b5709acd16f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $432412999859d20a$export$390c771b9e3f4124 = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $432412999859d20a$export$4146a0b5f40d20d7 = /*#__PURE__*/ (0, $eJOHy.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));
const $432412999859d20a$export$5d097184c0f78e68 = ()=>(0, $eJOHy.useContext)($432412999859d20a$export$390c771b9e3f4124);
const $432412999859d20a$export$a90578dce3c14324 = ()=>(0, $eJOHy.useContext)($432412999859d20a$export$4146a0b5f40d20d7);
const $432412999859d20a$export$781f6b5709acd16f = ({ children: children, value: value })=>{
    // There are two ways for `peekMenuId` to change.
    // One is if the `peekMenuId` prop (i.e. `value`) changes, likely due to a route change.
    // The other is internally via `setPeekMenuId`, e.g. the more menu.
    // Each will override the other, the last one to change/call will be the current state.
    const [peekMenuId, setPeekMenuId] = (0, $eJOHy.useState)(value);
    // If the `peekMenuId` prop (i.e. `value`) changes, set state before render.
    // Note, we don't need to validate `peekMenuId`.
    // If `peekMenuId` doesn't match an existing menu id, it's equivalent to setting undefined.
    (0, $eJOHy.useLayoutEffect)(()=>{
        setPeekMenuId(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($432412999859d20a$export$390c771b9e3f4124.Provider, {
        value: peekMenuId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($432412999859d20a$export$4146a0b5f40d20d7.Provider, {
            value: setPeekMenuId,
            children: children
        })
    });
};

});

parcelRegister("lQEtx", function(module, exports) {

$parcel$export(module.exports, "LocalStore", () => $dfdb1e44e7c20211$export$9adaf932dcd02b00);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2KHoH = parcelRequire("2KHoH");

var $8p5rT = parcelRequire("8p5rT");

var $ym94S = parcelRequire("ym94S");
function $dfdb1e44e7c20211$export$9adaf932dcd02b00({ children: children }) {
    const { app: app } = (0, $2KHoH.useOptions)();
    // This is user data for the menu and the sidebar
    const userStoreProps = (0, $8p5rT.useLocalSideNavUserData)({
        app: app
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ym94S.StoreProviders), {
        ...userStoreProps,
        children: children
    });
}

});
parcelRegister("8p5rT", function(module, exports) {

$parcel$export(module.exports, "useLocalSideNavUserData", () => $d71b3951687628f3$export$4714a0d7e8941053);

var $eJOHy = parcelRequire("eJOHy");

const $d71b3951687628f3$var$nullState = {
    userSideNavData: {
        defaultWidth: undefined,
        defaultCollapsed: undefined
    },
    userMenuData: []
};
// Allow the key to be extended (by adding a prefix or suffix)
let $d71b3951687628f3$var$LS_KEY = (0, $6663014c72fb18a4$export$42cf6fc952b8bebd);
function $d71b3951687628f3$export$4714a0d7e8941053({ app: app }) {
    $d71b3951687628f3$var$setLocalStorageKey(app);
    const [sideNavState, setSideNavState] = (0, $eJOHy.useReducer)($d71b3951687628f3$var$reducer, $d71b3951687628f3$var$getInitialState());
    const setUserMenuData = (0, $eJOHy.useCallback)(async (userMenuData)=>{
        setSideNavState({
            userMenuData: userMenuData
        });
    }, []);
    const setUserSideNavData = (0, $eJOHy.useCallback)(async (userSideNavData)=>{
        setSideNavState({
            userSideNavData: {
                ...sideNavState.userSideNavData,
                ...userSideNavData
            }
        });
    }, [
        sideNavState
    ]);
    return {
        ...sideNavState,
        setUserMenuData: setUserMenuData,
        setUserSideNavData: setUserSideNavData
    };
}
function $d71b3951687628f3$var$setLocalStorageKey(suffix) {
    $d71b3951687628f3$var$LS_KEY = [
        (0, $6663014c72fb18a4$export$42cf6fc952b8bebd),
        suffix
    ].join('-');
}
function $d71b3951687628f3$var$getInitialState() {
    const storedState = $d71b3951687628f3$var$parseLocalStorageState(localStorage.getItem($d71b3951687628f3$var$LS_KEY));
    if (storedState) return storedState;
    $d71b3951687628f3$var$setLocalStorageState($d71b3951687628f3$var$nullState);
    return $d71b3951687628f3$var$nullState;
}
function $d71b3951687628f3$var$reducer(state, payload) {
    const newState = {
        ...state,
        ...payload
    };
    // Update localStorage with the new state
    $d71b3951687628f3$var$setLocalStorageState(newState);
    return newState;
}
function $d71b3951687628f3$var$setLocalStorageState(state) {
    localStorage.setItem($d71b3951687628f3$var$LS_KEY, JSON.stringify(state));
}
function $d71b3951687628f3$var$parseLocalStorageState(state) {
    if (!state) return;
    try {
        const parsedState = JSON.parse(state);
        // This check should return true for the nullState
        if (parsedState?.userSideNavData && Array.isArray(parsedState.userMenuData) && typeof parsedState.userSideNavData === 'object') return parsedState;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    // something went wrong with parsing, return undefined
    }
}

});
const $6663014c72fb18a4$export$42cf6fc952b8bebd = 'nav-platform-sidebar-state';


parcelRegister("ym94S", function(module, exports) {

$parcel$export(module.exports, "StoreProviders", () => $94956f60d5aa9a36$export$54ef25ae025e12ab);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j4RIQ = parcelRequire("j4RIQ");

var $6zp45 = parcelRequire("6zp45");
function $94956f60d5aa9a36$export$54ef25ae025e12ab(props) {
    const { children: children, userMenuData: userMenuData, userSideNavData: userSideNavData, setUserMenuData: setUserMenuData, setUserSideNavData: setUserSideNavData } = props;
    // Split the data into two separate contexts, as they are edited at 2 different times.
    // (but we must always send an update with both data-sets inside)
    const userMenuValue = (0, $eJOHy.useMemo)(()=>({
            userMenuData: userMenuData,
            setUserMenuData: setUserMenuData
        }), [
        userMenuData,
        setUserMenuData
    ]);
    const userSideNavValue = (0, $eJOHy.useMemo)(()=>({
            userSideNavData: userSideNavData,
            setUserSideNavData: setUserSideNavData
        }), [
        userSideNavData,
        setUserSideNavData
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j4RIQ.UserMenuDataProvider), {
        value: userMenuValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6zp45.UserSideNavDataProvider), {
            value: userSideNavValue,
            children: children
        })
    });
}

});
parcelRegister("j4RIQ", function(module, exports) {

$parcel$export(module.exports, "UserMenuDataProvider", () => $36e5b632280977ff$export$8192e39428f09c3a);
$parcel$export(module.exports, "useUserMenuData", () => $36e5b632280977ff$export$f881c7978b5fc9af);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");
const $36e5b632280977ff$export$f9cc2a90ebfc5ef4 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
function $36e5b632280977ff$export$8192e39428f09c3a({ children: children, value: value }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($36e5b632280977ff$export$f9cc2a90ebfc5ef4.Provider, {
        value: value,
        children: children
    });
}
function $36e5b632280977ff$export$f881c7978b5fc9af() {
    const context = (0, $eJOHy.useContext)($36e5b632280977ff$export$f9cc2a90ebfc5ef4);
    (0, $8GOss.default)(context, 'useUserMenuData must be used inside an initialized UserMenuDataProvider');
    return context;
}

});

parcelRegister("6zp45", function(module, exports) {

$parcel$export(module.exports, "UserSideNavDataProvider", () => $89dc0c5d2c421964$export$3a3991a402cbd83e);
$parcel$export(module.exports, "useUserSideNavData", () => $89dc0c5d2c421964$export$bc6989c74d1be5d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");
const $89dc0c5d2c421964$export$19e418f3273659ff = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
function $89dc0c5d2c421964$export$3a3991a402cbd83e({ children: children, value: value }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($89dc0c5d2c421964$export$19e418f3273659ff.Provider, {
        value: value,
        children: children
    });
}
function $89dc0c5d2c421964$export$bc6989c74d1be5d() {
    const context = (0, $eJOHy.useContext)($89dc0c5d2c421964$export$19e418f3273659ff);
    (0, $8GOss.default)(context, 'useUserSideNavData must be used inside a UserSideNavDataProvider');
    return context;
}

});



parcelRegister("jm3ec", function(module, exports) {

$parcel$export(module.exports, "NetworkStore", () => $80248b9b11708097$export$711a2621397f25fc);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $2KHoH = parcelRequire("2KHoH");

var $7FVum = parcelRequire("7FVum");

var $ym94S = parcelRequire("ym94S");
function $80248b9b11708097$export$711a2621397f25fc({ children: children }) {
    const { networkStorageParams: networkStorageParams } = (0, $2KHoH.useOptions)();
    (0, $8GOss.default)(networkStorageParams?.entityAri && networkStorageParams?.ownerAri && networkStorageParams?.queryRef, 'Please provide networkStorageParams when using customization');
    // This is user data for the menu and the sidebar
    const userStoreProps = (0, $7FVum.useNetworkSideNavUserData)(networkStorageParams);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ym94S.StoreProviders), {
        ...userStoreProps,
        children: children
    });
}

});
parcelRegister("7FVum", function(module, exports) {

$parcel$export(module.exports, "useNetworkSideNavUserData", () => $793b363be017e58e$export$caed0b91aaed2955);

var $fFnC1 = parcelRequire("fFnC1");

var $kbw8U = parcelRequire("kbw8U");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");
const $793b363be017e58e$var$DEFAULT_COLLAPSED_KEY = 'defaultCollapsed';
const $793b363be017e58e$var$DEFAULT_WIDTH_KEY = 'defaultWidth';
function $793b363be017e58e$export$caed0b91aaed2955(params) {
    const { entityAri: entityAri, ownerAri: ownerAri, queryRef: queryRef } = params;
    const queryData = $793b363be017e58e$var$useLocalFragment(queryRef);
    const mutation = $793b363be017e58e$var$useLocalMutation();
    // We store the state of the properties & customizationItems, as the sidebar state can change without any
    // new calls to the local queryRef (to read the value back). So we persist it in this component.
    const [sideNavProperties, setSideNavProperties] = (0, $eJOHy.useState)({
        defaultWidth: (queryData?.userSideNavSettings?.properties?.nodes ?? [
            {
                key: $793b363be017e58e$var$DEFAULT_WIDTH_KEY,
                value: undefined
            }
        ]).find((item)=>item?.key === $793b363be017e58e$var$DEFAULT_WIDTH_KEY)?.value ?? '',
        defaultCollapsed: (queryData?.userSideNavSettings?.properties?.nodes ?? [
            {
                key: $793b363be017e58e$var$DEFAULT_COLLAPSED_KEY,
                value: undefined
            }
        ]).find((item)=>item?.key === $793b363be017e58e$var$DEFAULT_COLLAPSED_KEY)?.value ?? ''
    });
    const [customizationItems, setCustomizationItems] = (0, $eJOHy.useState)($793b363be017e58e$var$repairCustomizationItems(queryData?.userSideNavSettings?.sidebar?.nodes || []));
    // Create two callback functions - one for each user data-prop.
    // Not sure how performant this is, but it simplifies updates (because the caller doesn't need to know about the other half of the data)
    const setUserMenuData = (0, $eJOHy.useCallback)(async (userMenuData)=>{
        const sidebar = userMenuData;
        setCustomizationItems(sidebar);
        const properties = [
            {
                key: $793b363be017e58e$var$DEFAULT_WIDTH_KEY,
                value: sideNavProperties.defaultWidth
            },
            {
                key: $793b363be017e58e$var$DEFAULT_COLLAPSED_KEY,
                value: sideNavProperties.defaultCollapsed
            }
        ];
        return $793b363be017e58e$var$executeMutation({
            mutation: mutation,
            variables: {
                entityAri: entityAri,
                ownerAri: ownerAri,
                properties: properties,
                sidebar: sidebar
            }
        });
    }, [
        entityAri,
        mutation,
        ownerAri,
        sideNavProperties
    ]);
    const setUserSideNavData = (0, $eJOHy.useCallback)(async (userSideNavData)=>{
        const sidebar = customizationItems;
        const newState = {
            defaultWidth: String(userSideNavData.defaultWidth ?? sideNavProperties.defaultWidth) || '',
            defaultCollapsed: String(userSideNavData.defaultCollapsed ?? sideNavProperties.defaultCollapsed) || 'false'
        };
        setSideNavProperties(newState);
        const properties = [
            {
                key: $793b363be017e58e$var$DEFAULT_WIDTH_KEY,
                value: newState.defaultWidth
            },
            {
                key: $793b363be017e58e$var$DEFAULT_COLLAPSED_KEY,
                value: newState.defaultCollapsed
            }
        ];
        return $793b363be017e58e$var$executeMutation({
            mutation: mutation,
            variables: {
                entityAri: entityAri,
                ownerAri: ownerAri,
                properties: properties,
                sidebar: sidebar
            }
        });
    }, [
        entityAri,
        mutation,
        ownerAri,
        customizationItems,
        sideNavProperties
    ]);
    // Create a nicer shape for the data.
    // For the userSideNavData, it is ok for the values to be undefined,
    // as the ADS component will know what to do.
    const niceUserData = {
        userMenuData: customizationItems,
        userSideNavData: {
            defaultWidth: sideNavProperties.defaultWidth === '' ? undefined : Number(sideNavProperties.defaultWidth),
            defaultCollapsed: sideNavProperties.defaultCollapsed === '' ? undefined : sideNavProperties.defaultCollapsed === 'true'
        }
    };
    return {
        ...niceUserData,
        setUserMenuData: setUserMenuData,
        setUserSideNavData: setUserSideNavData
    };
}
/**
 * Make the Relay data look "normal" to the outside world.
 */ function $793b363be017e58e$var$repairCustomizationItems(value) {
    return value;
}
function $793b363be017e58e$var$useLocalFragment(queryRef) {
    /* eslint-disable @atlassian/relay/no-wrapping-hooks */ /* eslint-disable @atlassian/relay/unused-fields */ /* eslint-disable @atlassian/relay/graphql-naming */ return (0, $j4oe4.useFragment)((0, $kbw8U.default), queryRef);
/* eslint-enable @atlassian/relay/unused-fields */ }
function $793b363be017e58e$var$useLocalMutation() {
    return (0, $j4oe4.useMutation)((0, $fFnC1.default))[0];
}
function $793b363be017e58e$var$executeMutation({ mutation: mutation, variables: variables }) {
    try {
        return mutation({
            variables: variables,
            onCompleted: ()=>{
            // TODO: fire analytic event for success after NAVX-490 is merged
            },
            onError: ()=>{
            // TODO: fire analytic event for success after NAVX-490 is merged
            }
        });
    } catch  {}
}

});
parcelRegister("fFnC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $465e17b37333dfa0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d0457520107accd0b712e336a38545f>>
 * @relayHash 84329df47f1d11ef5ea22b051cd3cb10
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf42e7ddc009675a1a3a9d923a4bd3521ec33bd4d30cc6125170cdf92f31cb44
const $465e17b37333dfa0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "properties"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sidebar"
    }, v4 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAri"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                },
                {
                    "kind": "Variable",
                    "name": "properties",
                    "variableName": "properties"
                },
                {
                    "kind": "Variable",
                    "name": "sidebar",
                    "variableName": "sidebar"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v5 = {
        "concreteType": "SettingsMenuItemConnection",
        "kind": "LinkedField",
        "name": "sidebar",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsMenuItem",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "menuId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "visible"
                    }
                ]
            }
        ]
    }, v6 = {
        "concreteType": "SettingsDisplayPropertyConnection",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsDisplayProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useNetworkSideNavUserDataMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_updateNavigationCustomisation",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useNetworkSideNavUserDataMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_updateNavigationCustomisation",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bf42e7ddc009675a1a3a9d923a4bd3521ec33bd4d30cc6125170cdf92f31cb44",
            "metadata": {},
            "name": "useNetworkSideNavUserDataMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$465e17b37333dfa0$var$node.hash = "166e48d711d0b7e49b146e7ff8ab2745";
var $465e17b37333dfa0$export$2e2bcd8739ae039 = $465e17b37333dfa0$var$node;

});

parcelRegister("kbw8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70564ef16ff66ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cea65a1be7471930ba24878928a0bb2a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d70564ef16ff66ac$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "entityAriUserSideNavSettings"
        },
        {
            "kind": "RootArgument",
            "name": "ownerAri"
        }
    ],
    "kind": "Fragment",
    "name": "useNetworkSideNavUserData",
    "selections": [
        {
            "alias": "userSideNavSettings",
            "args": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriUserSideNavSettings"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                }
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsMenuItemConnection",
                    "kind": "LinkedField",
                    "name": "sidebar",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsMenuItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "menuId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "visible"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "SettingsDisplayPropertyConnection",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsDisplayProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$d70564ef16ff66ac$var$node.hash = "48a417a1d2876624970df89dfa84bb10";
var $d70564ef16ff66ac$export$2e2bcd8739ae039 = $d70564ef16ff66ac$var$node;

});



parcelRegister("lvjcp", function(module, exports) {

$parcel$export(module.exports, "SideNav", () => $17adb255f8969355$export$1a35787d6353cf6a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8aRgF = parcelRequire("8aRgF");

var $omzn0 = parcelRequire("omzn0");

var $2y3Ci = parcelRequire("2y3Ci");

var $dv8dh = parcelRequire("dv8dh");

var $kmSBH = parcelRequire("kmSBH");

var $ejb84 = parcelRequire("ejb84");

var $52lff = parcelRequire("52lff");

var $8bGNP = parcelRequire("8bGNP");

var $fJeBB = parcelRequire("fJeBB");

var $6Gcou = parcelRequire("6Gcou");

var $g2wqm = parcelRequire("g2wqm");

var $2KHoH = parcelRequire("2KHoH");

var $gPnUs = parcelRequire("gPnUs");

var $7bSed = parcelRequire("7bSed");

var $j4RIQ = parcelRequire("j4RIQ");


var $4S1V1 = parcelRequire("4S1V1");

var $caj2z = parcelRequire("caj2z");

var $jUg2Q = parcelRequire("jUg2Q");

var $9yMD5 = parcelRequire("9yMD5");

var $4l66K = parcelRequire("4l66K");
function $17adb255f8969355$export$1a35787d6353cf6a(props) {
    const { bottomElem: bottomElem, items: items, forYou: forYou, postItemsElem: postItemsElem, postMainElem: postMainElem, shortcuts: shortcuts, growthItemShortcuts: growthItemShortcuts, topElem: topElem } = props;
    const { userMenuData: userMenuData, setUserMenuData: setUserMenuData } = (0, $j4RIQ.useUserMenuData)();
    const { disableMenuCustomization: disableMenuCustomization } = (0, $2KHoH.useOptions)();
    const { fireViewSideNavEvent: fireViewSideNavEvent, fireClickSideNavNavItemEvent: fireClickSideNavNavItemEvent } = (0, $6Gcou.useNavAnalytics)();
    const { modifyNavItemForAnalytics: modifyNavItemForAnalytics } = (0, $fJeBB.useModifyNavItemForAnalytics)();
    // # region Global items
    const forYouNavItem = (0, $4S1V1.useForYouNavItem)(forYou);
    const recentNavItem = (0, $9yMD5.useRecentNavItem)(forYou);
    const starredNavItem = (0, $4l66K.useStarredNavItem)(forYou);
    const globalItems = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>new Map([
            ...forYouNavItem,
            ...recentNavItem,
            ...starredNavItem
        ]), [
        forYouNavItem,
        recentNavItem,
        starredNavItem
    ]);
    // # endregion
    // #region Items data
    const allNavItems = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>({
            ...Object.fromEntries(globalItems),
            ...items
        }), [
        globalItems,
        items
    ]);
    // todo: Move this to the outer context for customization data. We only need one.
    const sideNavMenuData = (0, $eJOHy.useMemo)(()=>{
        const navData = (0, $ejb84.buildCustomizationDataShapes)(allNavItems, shortcuts ? Object.keys(shortcuts) : [], // All menu items are visible when there is no customization data
        disableMenuCustomization ? [] : userMenuData);
        return {
            ...navData,
            setUserMenuData: setUserMenuData
        };
    }, [
        allNavItems,
        disableMenuCustomization,
        setUserMenuData,
        shortcuts,
        userMenuData
    ]);
    // #endregion
    // #region Analytics
    // Used for analytics, add +1 for more menu/customise button & bottomElem to globalItemsCount
    const additionalGlobalItemsCount = (disableMenuCustomization ? 0 : 1) + (bottomElem ? 1 : 0);
    const growthItemsCount = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>Object.keys(growthItemShortcuts ?? {}).length, [
        growthItemShortcuts
    ]);
    const totalNavItemsCount = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>sideNavMenuData.visibleMenuIds.length + additionalGlobalItemsCount + growthItemsCount, [
        additionalGlobalItemsCount,
        growthItemsCount,
        sideNavMenuData.visibleMenuIds.length
    ]);
    // #endregion
    // #region Nav item rendering
    const renderNavItem = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((id, index)=>{
        const handleClickSideNavItem = ()=>{
            fireClickSideNavNavItemEvent(id, index, items, globalItems, sideNavMenuData, totalNavItemsCount, additionalGlobalItemsCount);
        };
        const item = modifyNavItemForAnalytics(id, allNavItems[id], globalItems, items, sideNavMenuData.visibleItemMenuIds);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kmSBH.default), {
            id: id,
            item: item,
            onClick: handleClickSideNavItem
        }, id);
    }, [
        additionalGlobalItemsCount,
        allNavItems,
        fireClickSideNavNavItemEvent,
        globalItems,
        items,
        modifyNavItemForAnalytics,
        sideNavMenuData,
        totalNavItemsCount
    ]);
    // #endregion
    // #region Drag and drop
    // Element registry for L1 items
    const [elementRegistry] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState((0, $g2wqm.createElementRegistry));
    const { dragAndDropSave: dragAndDropSave } = (0, $7bSed.useDragAndDropSave)(sideNavMenuData, elementRegistry);
    const [draggingL1Item, setDraggingL1Item] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        return (0, $dv8dh.monitorForElements)({
            canMonitor: ({ source: source })=>(0, $52lff.isL1ItemData)(source.data),
            onDragStart ({ source: source }) {
                if (!(0, $52lff.isL1ItemData)(source.data)) return;
                setDraggingL1Item(true);
            },
            onDrop ({ source: source, location: location }) {
                const dragging = source.data;
                setDraggingL1Item(false);
                const [innerMost] = location.current.dropTargets;
                if (!innerMost) return;
                const dropTargetData = innerMost.data;
                const instruction = (0, $omzn0.extractInstruction)(dropTargetData);
                if (!instruction) return;
                if ((0, $52lff.isL1ItemData)(dragging) && (0, $52lff.isL1ItemData)(dropTargetData)) {
                    dragAndDropSave({
                        type: 'item-reorder',
                        draggedMenuItemId: dragging.menuItemId,
                        draggedMenuItemLabel: dragging.label,
                        droppedOnMenuItemId: dropTargetData.menuItemId,
                        instruction: instruction,
                        trigger: 'pointer'
                    });
                    return;
                }
                if ((0, $52lff.isL1ItemData)(dragging) && (0, $52lff.isMoreMenuData)(dropTargetData)) {
                    dragAndDropSave({
                        type: 'item-hide',
                        draggedMenuItemId: dragging.menuItemId,
                        draggedMenuItemLabel: dragging.label,
                        instruction: instruction,
                        trigger: 'pointer'
                    });
                    return;
                }
            }
        });
    }, [
        dragAndDropSave
    ]);
    const { groupDropIndicatorRef: groupDropIndicatorRef } = (0, $8bGNP.useL1DragState)();
    // #endregion
    (0, $eJOHy.useLayoutEffect)(()=>{
        fireViewSideNavEvent(forYou, sideNavMenuData, Object.keys(items), !disableMenuCustomization, !!bottomElem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // #region Core rendering
    const mainNavItems = sideNavMenuData.visibleItemMenuIds.map(renderNavItem);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPnUs.SideNavDataProvider), {
        value: sideNavMenuData,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g2wqm.ElementRegistryProvider), {
            registry: elementRegistry,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $caj2z.SideNavigationLayout), {
                testId: props.testId ?? (0, $64bd3c81b9041d83$export$5678faf50a8e9276),
                preMainElem: topElem,
                postMainElem: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jUg2Q.PostMainItems), {
                    postItemsElem: postItemsElem,
                    postMainElem: postMainElem,
                    globalItems: globalItems,
                    shortcuts: shortcuts,
                    allNavItems: allNavItems,
                    growthItemsCount: growthItemsCount,
                    growthItemShortcuts: growthItemShortcuts,
                    totalNavItemsCount: totalNavItemsCount,
                    additionalGlobalItemsCount: additionalGlobalItemsCount,
                    draggingL1Item: draggingL1Item
                }),
                bottomElem: bottomElem,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2y3Ci.MenuList), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8aRgF.GroupDropIndicator), {
                        ref: groupDropIndicatorRef,
                        isActive: draggingL1Item,
                        children: mainNavItems
                    })
                })
            })
        })
    });
// #endregion
}

});
parcelRegister("kmSBH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a884ba9d4f08daa6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kRcOu = parcelRequire("kRcOu");
var $aasrU = parcelRequire("aasrU");
var $ilbtc = parcelRequire("ilbtc");

var $fHvuI = parcelRequire("fHvuI");
var $yAFiV = parcelRequire("yAFiV");
var $3HUFo = parcelRequire("3HUFo");

var $d9oCz = parcelRequire("d9oCz");
var $5jwgZ = parcelRequire("5jwgZ");
var $63KSu = parcelRequire("63KSu");

var $efkYy = parcelRequire("efkYy");

var $k4Frd = parcelRequire("k4Frd");

var $gAkgF = parcelRequire("gAkgF");

var $6b0Yn = parcelRequire("6b0Yn");

var $gw0jg = parcelRequire("gw0jg");
function $a884ba9d4f08daa6$export$2e2bcd8739ae039({ id: id, item: item, peek: peek = false, isInMoreMenu: isInMoreMenu = false, onClick: onClick }) {
    const { type: type } = item;
    const { isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, isExpandable: isExpandable } = (0, $6b0Yn.useExpandOpenState)(item, peek);
    const { draggableRef: draggableRef, isItemDraggable: isItemDraggable, isDragging: isDragging, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview } = (0, $gw0jg.useItemDragAndDrop)({
        item: item,
        id: id,
        isExpandable: isExpandable,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle,
        isInMoreMenu: isInMoreMenu,
        peek: peek
    });
    if ((0, $gAkgF.isCustomItemConfig)(item)) // If the item is a custom item, render it directly
    // TODO: Add customizationHandlers prop when ready
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $ilbtc.MenuListItem), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)(item.Component, {
                isInMoreMenu: false,
                isPeeked: peek,
                onClick: (...args)=>{
                    item.Component.defaultProps?.onClick?.(...args);
                    onClick?.();
                },
                hasDragIndicator: isItemDraggable ? isItemDraggable : undefined,
                draggableRef: draggableRef,
                isDragging: isDragging,
                dropIndicator: dropIndicator,
                visualContentRef: dropTargetRef
            }),
            maybeDragPreview
        ]
    });
    if ((0, $gAkgF.isObjectListFlyoutItemConfig)(item)) {
        const objectListFlyoutProps = (0, $k4Frd.omitSafely)(item, 'type', 'isOpen', 'onOpenChange');
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $efkYy.ObjectListFlyout), {
                    ...objectListFlyoutProps,
                    onClick: (...args)=>{
                        // Toggle the flyout open state
                        onExpandFlyoutToggle(!isExpandOrFlyoutOpen);
                        objectListFlyoutProps.onClick?.(...args);
                        onClick?.();
                    },
                    isOpen: isExpandOrFlyoutOpen,
                    onOpenChange: onExpandFlyoutToggle,
                    hasDragIndicator: isItemDraggable,
                    triggerRef: draggableRef,
                    isDragging: isDragging,
                    dropIndicator: dropIndicator,
                    visualContentRef: dropTargetRef
                }),
                maybeDragPreview
            ]
        });
    }
    switch(type){
        case 'link':
            {
                const { label: label, labelElem: labelElem, ...linkMenuItemProps } = (0, $k4Frd.omitSafely)(item, 'type');
                return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aasrU.LinkMenuItem), {
                            ...linkMenuItemProps,
                            onClick: (...args)=>{
                                linkMenuItemProps.onClick?.(...args);
                                onClick?.();
                            },
                            hasDragIndicator: isItemDraggable,
                            ref: draggableRef,
                            isDragging: isDragging,
                            dropIndicator: dropIndicator,
                            visualContentRef: dropTargetRef,
                            children: labelElem ?? label
                        }),
                        maybeDragPreview
                    ]
                });
            }
        case 'button':
            {
                const { label: label, labelElem: labelElem, ...buttonMenuItemProps } = (0, $k4Frd.omitSafely)(item, 'type');
                return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kRcOu.ButtonMenuItem), {
                            ...buttonMenuItemProps,
                            onClick: (...args)=>{
                                buttonMenuItemProps.onClick?.(...args);
                                onClick?.();
                            },
                            hasDragIndicator: isItemDraggable,
                            ref: draggableRef,
                            isDragging: isDragging,
                            dropIndicator: dropIndicator,
                            visualContentRef: dropTargetRef,
                            children: labelElem ?? label
                        }),
                        maybeDragPreview
                    ]
                });
            }
        case 'expand':
            {
                const { children: children, elemBefore: elemBefore, label: label, labelElem: labelElem, ...triggerProps } = (0, $k4Frd.omitSafely)(item, 'type', 'isDefaultExpanded', 'isExpanded', 'onExpansionToggle');
                return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fHvuI.ExpandableMenuItem), {
                            isExpanded: isExpandOrFlyoutOpen,
                            onExpansionToggle: onExpandFlyoutToggle,
                            dropIndicator: dropIndicator,
                            ref: dropTargetRef,
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3HUFo.ExpandableMenuItemTrigger), {
                                    ...triggerProps,
                                    onClick: (...args)=>{
                                        triggerProps.onClick?.(...args);
                                        onClick?.();
                                    },
                                    // During drags, custom elemBefore is not shown
                                    // https://atlassian.design/components/navigation-system/side-nav-items/drag-and-drop#drag-start
                                    elemBefore: isDragging ? null : elemBefore,
                                    hasDragIndicator: isItemDraggable,
                                    ref: draggableRef,
                                    isDragging: isDragging,
                                    children: labelElem ?? label
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $yAFiV.ExpandableMenuItemContent), {
                                    children: children
                                })
                            ]
                        }),
                        maybeDragPreview
                    ]
                });
            }
        case 'flyout':
            {
                const { children: children, label: label, labelElem: labelElem, ...triggerProps } = (0, $k4Frd.omitSafely)(item, 'type', 'isDefaultOpen', 'isOpen', 'onOpenChange');
                return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $d9oCz.FlyoutMenuItem), {
                            isOpen: isExpandOrFlyoutOpen,
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $63KSu.FlyoutMenuItemTrigger), {
                                    ...triggerProps,
                                    onClick: (...args)=>{
                                        // Toggle the flyout open state
                                        onExpandFlyoutToggle(!isExpandOrFlyoutOpen);
                                        triggerProps.onClick?.(...args);
                                        onClick?.();
                                    },
                                    hasDragIndicator: isItemDraggable,
                                    ref: draggableRef,
                                    isDragging: isDragging,
                                    dropIndicator: dropIndicator,
                                    visualContentRef: dropTargetRef,
                                    children: labelElem ?? label
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5jwgZ.FlyoutMenuItemContent), {
                                    children: children
                                })
                            ]
                        }),
                        maybeDragPreview
                    ]
                });
            }
        default:
            return null;
    }
}

});
parcelRegister("efkYy", function(module, exports) {

$parcel$export(module.exports, "ObjectListFlyout", () => $015f73850607bfff$export$8c8993cce765101e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lFdcD = parcelRequire("lFdcD");

var $hGuij = parcelRequire("hGuij");
function $015f73850607bfff$export$8c8993cce765101e(props) {
    const { dropIndicator: dropIndicator, elemBefore: elemBefore, hasDragIndicator: hasDragIndicator, isDragging: isDragging, label: label, labelElem: labelElem, onClick: onClick, onOpenChange: onOpenChange, testId: testId, triggerRef: triggerRef, visualContentRef: visualContentRef, isDefaultOpen: isDefaultOpen } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lFdcD.FlyoutTrigger), {
        entryPoint: (0, $hGuij.objectListFlyoutEntrypoint),
        entryPointProps: props,
        isDefaultOpen: isDefaultOpen,
        onOpenChange: onOpenChange,
        triggerProps: {
            elemBefore: elemBefore,
            children: labelElem ?? label,
            onClick: onClick,
            testId: testId,
            hasDragIndicator: hasDragIndicator,
            isDragging: isDragging,
            dropIndicator: dropIndicator,
            triggerRef: triggerRef,
            visualContentRef: visualContentRef
        }
    });
}

});
parcelRegister("lFdcD", function(module, exports) {

$parcel$export(module.exports, "FlyoutTrigger", () => $5918e0830797785c$export$4ebbeeb2921cde03);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kmlzw = parcelRequire("kmlzw");

var $d9oCz = parcelRequire("d9oCz");
var $5jwgZ = parcelRequire("5jwgZ");
var $63KSu = parcelRequire("63KSu");

var $dPlS8 = parcelRequire("dPlS8");

var $1HG9X = parcelRequire("1HG9X");

var $4moNR = parcelRequire("4moNR");

var $h2Da7 = parcelRequire("h2Da7");

var $4UiNx = parcelRequire("4UiNx");
const $5918e0830797785c$var$emptyEntryPointParams = {};
const $5918e0830797785c$var$emptyEntryPointProps = {};
function $5918e0830797785c$export$4ebbeeb2921cde03({ triggerProps: triggerProps, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, onOpenChange: onOpenChange, isDefaultOpen: isDefaultOpen = false, ...flyoutProps }) {
    const environmentProvider = (0, $h2Da7.useRelayEnvironmentProvider)();
    const hasRun = (0, $eJOHy.useRef)(false);
    const id = (0, $eJOHy.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [content, setContent] = (0, $eJOHy.useState)(null);
    const handleOpen = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const onFlyoutOpenChange = (0, $eJOHy.useCallback)((open)=>{
        setIsOpen(open);
        onOpenChange?.(open);
    }, [
        onOpenChange
    ]);
    const load = (0, $eJOHy.useCallback)(()=>(0, $j4oe4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $5918e0830797785c$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $eJOHy.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing flyout
        if (isOpen) return;
        handleOpen();
        setContent(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4moNR.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dPlS8.default), {}),
            errorFallback: errorFallback,
            runtimeProps: {
                ...entryPointProps ?? $5918e0830797785c$var$emptyEntryPointProps,
                closeFlyout: handleClose
            },
            onError: onError
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        errorFallback,
        handleOpen,
        onError,
        handleClose
    ]);
    // Auto-open on first render if isDefaultOpen is true
    (0, $eJOHy.useEffect)(()=>{
        if (isDefaultOpen && !hasRun.current) {
            handleOpen();
            onLoad({
                reference: load()
            });
            hasRun.current = true;
        }
    }, [
        handleOpen,
        isDefaultOpen,
        load,
        onLoad
    ]);
    const triggerCloseRef = (0, $4UiNx.useClickToCloseRef)({
        isOpen: isOpen,
        handleClose: handleClose
    });
    const triggerRef = (0, $1HG9X.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const flyoutTriggerRef = (0, $eJOHy.useMemo)(()=>{
        const refs = [
            triggerRef,
            triggerCloseRef
        ];
        if (triggerProps?.triggerRef) refs.push(triggerProps.triggerRef);
        return (0, $kmlzw.mergeRefs)(refs);
    }, [
        triggerRef,
        triggerCloseRef,
        triggerProps.triggerRef
    ]);
    const flyoutContent = (0, $eJOHy.useCallback)(()=>content, [
        content
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $d9oCz.FlyoutMenuItem), {
        ...flyoutProps,
        isOpen: isOpen,
        onOpenChange: onFlyoutOpenChange,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $63KSu.FlyoutMenuItemTrigger), {
                ...triggerProps,
                ref: flyoutTriggerRef
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5jwgZ.FlyoutMenuItemContent), {
                onClose: handleClose,
                children: flyoutContent()
            })
        ]
    });
}

});
parcelRegister("4UiNx", function(module, exports) {

$parcel$export(module.exports, "useClickToCloseRef", () => $b61b736cf17e8780$export$46ec6629f411921d);

var $eJOHy = parcelRequire("eJOHy");
function $b61b736cf17e8780$export$46ec6629f411921d({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const clickListener = ()=>{
            if (isOpen) handleClose(null);
        };
        el.addEventListener('click', clickListener);
        return ()=>{
            el.removeEventListener('click', clickListener);
        };
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
}

});


parcelRegister("hGuij", function(module, exports) {

$parcel$export(module.exports, "objectListFlyoutEntrypoint", () => $9b6fe5594e936c9b$export$34c0c9850f758c93);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $9b6fe5594e936c9b$export$34c0c9850f758c93 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("4IalR")), {
        moduleId: "06e38b41",
        priority: "interaction",
        moduleId: 'objectListFlyoutEntrypoint'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4IalR", function(module, exports) {

let $36e34d1e33e14155$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $36e34d1e33e14155$var$load("8Y4uc").then(()=>parcelRequire('4XbAh'));

});



parcelRegister("k4Frd", function(module, exports) {

$parcel$export(module.exports, "omitSafely", () => $da8ae75157307b98$export$d6eadbd047ebd460);

var $jFHCE = parcelRequire("jFHCE");
const $da8ae75157307b98$export$d6eadbd047ebd460 = (item, ...properties)=>(0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(item, ...properties);

});

parcelRegister("gAkgF", function(module, exports) {

$parcel$export(module.exports, "isButtonItemConfig", () => $92743db234458e38$export$cd440346ca02126b);
$parcel$export(module.exports, "isCustomItemConfig", () => $92743db234458e38$export$8e525d5a1e55be8f);
$parcel$export(module.exports, "isExpandableItemConfig", () => $92743db234458e38$export$e5ec7109da4bc094);
$parcel$export(module.exports, "isFlyoutItemConfig", () => $92743db234458e38$export$ee29322ec7068717);
$parcel$export(module.exports, "isLinkItemConfig", () => $92743db234458e38$export$4fdefbbdae1adf42);
$parcel$export(module.exports, "isObjectListFlyoutItemConfig", () => $92743db234458e38$export$10dd63e15344d4ca);
const $92743db234458e38$export$cd440346ca02126b = (item)=>item.type === 'button';
const $92743db234458e38$export$8e525d5a1e55be8f = (item)=>item.type === 'custom';
const $92743db234458e38$export$e5ec7109da4bc094 = (item)=>item.type === 'expand';
const $92743db234458e38$export$ee29322ec7068717 = (item)=>item.type === 'flyout';
const $92743db234458e38$export$4fdefbbdae1adf42 = (item)=>item.type === 'link';
const $92743db234458e38$export$10dd63e15344d4ca = (item)=>item.type === 'object-list-flyout';

});

parcelRegister("6b0Yn", function(module, exports) {

$parcel$export(module.exports, "useExpandOpenState", () => $d326e1e9fe2081ce$export$e66526057f4a5c1e);

var $eJOHy = parcelRequire("eJOHy");
function $d326e1e9fe2081ce$export$e66526057f4a5c1e(item, peek) {
    // We need to manage the state of expands and flyouts open state here so that we can collapse them during drag. But
    // the consuming app may also want to control this state. So, we will track the open state here and also listen for
    // the corresponding props in a useEffect so we can update our internal state if the app is controlling it.
    const { type: type } = item;
    const isExpandable = [
        'expand',
        'flyout',
        'object-list-flyout'
    ].includes(type);
    const isExpandedFromProps = type === 'expand' ? item.isExpanded : undefined;
    const isOpenFromProps = type === 'flyout' || type === 'object-list-flyout' ? item.isOpen : undefined;
    const isExpandedOrOpenFromProps = typeof isExpandedFromProps === 'boolean' ? isExpandedFromProps : isOpenFromProps;
    const isDefaultExpandedOrOpenFromProps = type === 'expand' && item.isDefaultExpanded || (type === 'flyout' || type === 'object-list-flyout') && item.isDefaultOpen;
    const [isExpandOrFlyoutOpen, setIsExpandOrFlyoutOpen] = (0, $eJOHy.useState)(// Prioritize controlled props if available, otherwise use default expanded/open state or peek state
    typeof isExpandedOrOpenFromProps === 'boolean' ? isExpandedOrOpenFromProps : isDefaultExpandedOrOpenFromProps || peek);
    (0, $eJOHy.useEffect)(()=>{
        if (!isExpandable || typeof isExpandedOrOpenFromProps !== 'boolean') return;
        if (isExpandedOrOpenFromProps !== isExpandOrFlyoutOpen) setIsExpandOrFlyoutOpen(isExpandedOrOpenFromProps);
    }, [
        isExpandable,
        isExpandOrFlyoutOpen,
        isExpandedOrOpenFromProps
    ]);
    const maybeOnExpansionToggle = type === 'expand' ? item.onExpansionToggle : undefined;
    const maybeOnOpenChange = type === 'flyout' || type === 'object-list-flyout' ? item.onOpenChange : undefined;
    const onExpandFlyoutToggle = (0, $eJOHy.useCallback)((isExpandedOrOpen)=>{
        if (type === 'expand') {
            setIsExpandOrFlyoutOpen(isExpandedOrOpen);
            maybeOnExpansionToggle?.(isExpandedOrOpen);
        } else if (type === 'flyout' || type === 'object-list-flyout') {
            setIsExpandOrFlyoutOpen(isExpandedOrOpen);
            maybeOnOpenChange?.(isExpandedOrOpen);
        }
    }, [
        type,
        maybeOnExpansionToggle,
        maybeOnOpenChange
    ]);
    // If an item is being peeked and it is controlled, open/expand it by calling the toggle function
    const prevPeek = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (peek && peek !== prevPeek.current && isExpandable && !isExpandOrFlyoutOpen) onExpandFlyoutToggle(true);
        prevPeek.current = peek;
    }, [
        peek,
        prevPeek,
        isExpandable,
        isExpandOrFlyoutOpen,
        onExpandFlyoutToggle
    ]);
    return {
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle,
        isExpandable: isExpandable
    };
}

});

parcelRegister("gw0jg", function(module, exports) {

$parcel$export(module.exports, "useItemDragAndDrop", () => $883127d0b4df8d2d$export$4696d1da23170d9a);

var $eJOHy = parcelRequire("eJOHy");

var $2GdJz = parcelRequire("2GdJz");

var $g2wqm = parcelRequire("g2wqm");

var $2KHoH = parcelRequire("2KHoH");

var $52lff = parcelRequire("52lff");

var $1nRec = parcelRequire("1nRec");
function $883127d0b4df8d2d$export$4696d1da23170d9a({ item: item, id: id, isExpandable: isExpandable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, isInMoreMenu: isInMoreMenu, onExpandFlyoutToggle: onExpandFlyoutToggle, peek: peek }) {
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $2KHoH.useOptions)();
    const isItemDraggable = l1DragAndDropEnabled && !isInMoreMenu && // TODO: NAVX-1172 Once we support unhiding items using drag and drop, we should remove this check and adjust the
    // logic below to handle dragging a peeked item into the main list to unhide it
    !peek && (item.isHideable !== false || item.isReorderable !== false) && // Custom items must explicitly opt-in to being draggable since they need to consume the refs for it to work
    (item.type !== 'custom' || !!item.isDraggable);
    const { draggableAnchorRef: draggableAnchorRef, draggableButtonRef: draggableButtonRef, state: dragState, dragPreview: dragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $2GdJz.useMenuItemDragAndDrop)({
        ...isItemDraggable && {
            draggable: {
                getInitialData: ()=>(0, $52lff.getL1ItemData)({
                        menuItemId: id,
                        label: item.label,
                        isHidden: false,
                        isHideable: item.isHideable !== false,
                        isReorderable: item.isReorderable !== false
                    }),
                getDragPreviewPieces: ()=>({
                        elemBefore: (0, $1nRec.getElemBeforeForItem)(item),
                        content: (0, $1nRec.getDragPreviewContentForItem)(item)
                    })
            },
            dropTarget: {
                getData: ()=>(0, $52lff.getL1ItemData)({
                        menuItemId: id,
                        label: item.label,
                        isHidden: false,
                        isHideable: item.isHideable !== false,
                        isReorderable: item.isReorderable !== false
                    }),
                getOperations: ()=>({
                        'reorder-before': 'available',
                        'reorder-after': 'available'
                    }),
                canDrop: ({ source: source })=>{
                    return (0, $52lff.isL1ItemData)(source.data) && source.data.menuItemId !== id && source.data.isReorderable;
                }
            }
        }
    });
    const registry = (0, $g2wqm.useElementRegistry)();
    const registrationRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const draggableRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((element)=>{
        if (!element) {
            registrationRef.current?.();
            registrationRef.current = null;
            draggableAnchorRef.current = null;
            draggableButtonRef.current = null;
            return;
        }
        // Set to appropriate ref from the drag and drop hook
        if (element instanceof HTMLAnchorElement) draggableAnchorRef.current = element;
        else draggableButtonRef.current = element;
        // Unregister the previous element if it exists
        if (registrationRef.current) registrationRef.current();
        // Register the element with the registry
        registrationRef.current = registry.registerL1Item({
            id: id,
            element: element
        });
    }, [
        id,
        registry,
        draggableAnchorRef,
        draggableButtonRef,
        registrationRef
    ]);
    const isDragging = isItemDraggable && dragState.type === 'dragging';
    const expandableClosedForDrag = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useLayoutEffect(()=>{
        if (!isExpandable || !isItemDraggable) return;
        if (isDragging && isExpandOrFlyoutOpen) {
            // Close the expandable when dragging starts
            onExpandFlyoutToggle(false);
            // Keep track of whether we closed the expandable for drag
            expandableClosedForDrag.current = true;
        } else if (!isDragging && expandableClosedForDrag.current) {
            // If we were dragging and now we're not, reopen the expandable if it was closed
            onExpandFlyoutToggle(true);
            expandableClosedForDrag.current = false;
        }
    }, [
        isDragging,
        isExpandable,
        isExpandOrFlyoutOpen,
        isItemDraggable,
        expandableClosedForDrag,
        onExpandFlyoutToggle
    ]);
    return {
        draggableRef: isItemDraggable ? draggableRef : undefined,
        isItemDraggable: isItemDraggable,
        isDragging: isDragging,
        dropTargetRef: isItemDraggable ? dropTargetRef : undefined,
        dropIndicator: isItemDraggable ? dropIndicator : undefined,
        maybeDragPreview: isItemDraggable ? dragPreview : null
    };
}

});
parcelRegister("g2wqm", function(module, exports) {

$parcel$export(module.exports, "createElementRegistry", () => $2bda70c7b1225b15$export$b8d30beb0c187a7);
$parcel$export(module.exports, "ElementRegistryProvider", () => $2bda70c7b1225b15$export$ce0cc6a5e9b6a71a);
$parcel$export(module.exports, "useElementRegistry", () => $2bda70c7b1225b15$export$9a176103b34f9da9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");
// When a user drags & drops a navigation item, ADS recommends that we flash the item visually, and if the move was
// triggered by keyboard, also set focus to the moved item. This element registry allows GSN to keep track of the
// actual HTML elements of the L1 items, so that we can flash and focus them after the drag & drop action is performed.
// This pattern is recommended by AtlasKit in the side nav drag & drop documentation:
// https://atlassian.design/components/navigation-system/side-nav-items/drag-and-drop#on-drop
const $2bda70c7b1225b15$var$MORE_MENU_ID = Symbol('moreMenuId');
function $2bda70c7b1225b15$export$b8d30beb0c187a7() {
    const registry = new Map();
    function registerL1Item({ id: id, element: element }) {
        registry.set(id, element);
        return function cleanup() {
            registry.delete(id);
        };
    }
    function getL1ItemElement(id) {
        return registry.get(id);
    }
    function registerMoreMenuItem(element) {
        return registerL1Item({
            id: $2bda70c7b1225b15$var$MORE_MENU_ID,
            element: element
        });
    }
    function getMoreMenuElement() {
        return getL1ItemElement($2bda70c7b1225b15$var$MORE_MENU_ID);
    }
    return {
        registerL1Item: registerL1Item,
        getL1ItemElement: getL1ItemElement,
        registerMoreMenuItem: registerMoreMenuItem,
        getMoreMenuElement: getMoreMenuElement
    };
}
const $2bda70c7b1225b15$var$ElementRegistryContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
function $2bda70c7b1225b15$export$ce0cc6a5e9b6a71a({ children: children, registry: registry }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($2bda70c7b1225b15$var$ElementRegistryContext.Provider, {
        value: registry,
        children: children
    });
}
function $2bda70c7b1225b15$export$9a176103b34f9da9() {
    const elementRegistry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($2bda70c7b1225b15$var$ElementRegistryContext);
    (0, $8GOss.default)(elementRegistry, 'useElementRegistry must be used within an ElementRegistryProvider');
    return elementRegistry;
}

});

parcelRegister("52lff", function(module, exports) {

$parcel$export(module.exports, "getL1ItemData", () => $d07892cb3d25426e$export$e9f7c92759d0f281);
$parcel$export(module.exports, "isL1ItemData", () => $d07892cb3d25426e$export$e52c346726a16591);
$parcel$export(module.exports, "getMoreMenuData", () => $d07892cb3d25426e$export$e74f096ffe08821d);
$parcel$export(module.exports, "isMoreMenuData", () => $d07892cb3d25426e$export$e37de48254c6595e);
const $d07892cb3d25426e$var$l1ItemKey = Symbol('l1ItemKey');
const $d07892cb3d25426e$var$moreMenuKey = Symbol('moreMenuKey');
function $d07892cb3d25426e$export$e9f7c92759d0f281({ menuItemId: menuItemId, label: label, isHidden: isHidden, isHideable: isHideable, isReorderable: isReorderable }) {
    return {
        menuItemId: menuItemId,
        label: label,
        isHidden: isHidden,
        isHideable: isHideable,
        isReorderable: isReorderable,
        [$d07892cb3d25426e$var$l1ItemKey]: true
    };
}
function $d07892cb3d25426e$export$e52c346726a16591(data) {
    return data[$d07892cb3d25426e$var$l1ItemKey] === true;
}
const $d07892cb3d25426e$export$7960450fbf5a0a72 = Symbol('moreMenuId');
function $d07892cb3d25426e$export$e74f096ffe08821d() {
    return {
        menuItemId: $d07892cb3d25426e$export$7960450fbf5a0a72,
        [$d07892cb3d25426e$var$moreMenuKey]: true
    };
}
function $d07892cb3d25426e$export$e37de48254c6595e(data) {
    return data[$d07892cb3d25426e$var$moreMenuKey] === true;
}

});

parcelRegister("1nRec", function(module, exports) {

$parcel$export(module.exports, "getElemBeforeForItem", () => $dcfcb9a9d468d790$export$9d7e63760538f47f);
$parcel$export(module.exports, "getDragPreviewContentForItem", () => $dcfcb9a9d468d790$export$d5d05b25e1604a8f);
function $dcfcb9a9d468d790$export$9d7e63760538f47f(item) {
    if (item.type === 'custom' && item.dragPreviewContent) // If the custom item has a drag preview content, we should assume it contains the icon already
    return undefined;
    return item.elemBefore;
}
function $dcfcb9a9d468d790$export$d5d05b25e1604a8f(item) {
    if (item.type === 'custom' && item.dragPreviewContent) // Custom items may return their drag preview content as a React node
    return item.dragPreviewContent;
    // If not custom or drag preview content not present, use the label
    return item.labelElem ?? item.label;
}

});



parcelRegister("ejb84", function(module, exports) {

$parcel$export(module.exports, "buildCustomizationDataShapes", () => $58cbe97ab652c61a$export$8c9c2865d610ab5f);

var $2zs80 = parcelRequire("2zs80");

var $eP8ll = parcelRequire("eP8ll");

var $6eEAT = parcelRequire("6eEAT");

var $dU2XQ = parcelRequire("dU2XQ");
const $58cbe97ab652c61a$export$8c9c2865d610ab5f = (items, defaultShortcutMenuIds, rawCustomizationData)=>{
    const defaultItemMenuIds = Object.keys(items);
    const repairedDefaultItemMenuIds = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(defaultItemMenuIds, defaultShortcutMenuIds);
    const itemCustomizationData = $58cbe97ab652c61a$var$repair(rawCustomizationData, repairedDefaultItemMenuIds);
    const shortcutCustomizationData = $58cbe97ab652c61a$var$repair(rawCustomizationData, defaultShortcutMenuIds);
    const customizationData = itemCustomizationData.concat(shortcutCustomizationData);
    const [visibleItemMenuIds, hiddenItemMenuIds] = (0, $6eEAT.getMenuIdsByVisible)(itemCustomizationData);
    const [visibleShortcutMenuIds, hiddenShortcutMenuIds] = (0, $6eEAT.getMenuIdsByVisible)(shortcutCustomizationData);
    const visibleMenuIds = visibleItemMenuIds.concat(visibleShortcutMenuIds);
    const hiddenMenuIds = hiddenItemMenuIds.concat(hiddenShortcutMenuIds);
    return {
        customizationData: customizationData,
        visibleMenuIds: visibleMenuIds,
        hiddenMenuIds: hiddenMenuIds,
        itemCustomizationData: itemCustomizationData,
        visibleItemMenuIds: visibleItemMenuIds,
        hiddenItemMenuIds: hiddenItemMenuIds,
        shortcutCustomizationData: shortcutCustomizationData,
        visibleShortcutMenuIds: visibleShortcutMenuIds,
        hiddenShortcutMenuIds: hiddenShortcutMenuIds
    };
};
const $58cbe97ab652c61a$var$repair = (rawCustomizationData, defaultMenuItems)=>(0, $dU2XQ.repairItems)(rawCustomizationData ?? [], (0, $eP8ll.createDefaultCustomizationItems)(defaultMenuItems));

});
parcelRegister("eP8ll", function(module, exports) {

$parcel$export(module.exports, "createDefaultCustomizationItems", () => $2a1fdbe6e796877e$export$cb9a19d9328f4a2f);
function $2a1fdbe6e796877e$export$cb9a19d9328f4a2f(menuIds) {
    return menuIds.map((menuId)=>({
            menuId: menuId,
            visible: true
        }));
}

});

parcelRegister("6eEAT", function(module, exports) {

$parcel$export(module.exports, "getMenuIdsByVisible", () => $af36a0a5d6df6f19$export$ac81be4e21f7c439);

var $5BoOG = parcelRequire("5BoOG");

var $7vAYP = parcelRequire("7vAYP");
const $af36a0a5d6df6f19$export$ac81be4e21f7c439 = (items)=>(0, $7vAYP.partitionByVisible)(items).map((0, $5BoOG.getMenuIds));

});
parcelRegister("5BoOG", function(module, exports) {

$parcel$export(module.exports, "getMenuIds", () => $8d51fffc59a8d028$export$df4a614c56950314);
const $8d51fffc59a8d028$export$df4a614c56950314 = (items)=>items.map((item)=>item.menuId);

});

parcelRegister("7vAYP", function(module, exports) {

$parcel$export(module.exports, "partitionByVisible", () => $9e2772f5e185747a$export$98e5c4110cac6c24);

var $a6gy0 = parcelRequire("a6gy0");
const $9e2772f5e185747a$export$98e5c4110cac6c24 = (items)=>(0, (/*@__PURE__*/$parcel$interopDefault($a6gy0)))(items, (item)=>item.visible);

});


parcelRegister("dU2XQ", function(module, exports) {

$parcel$export(module.exports, "repairItems", () => $a8ff49ffb61353e9$export$ce0466efa278e488);

var $4q8Hz = parcelRequire("4q8Hz");
const $a8ff49ffb61353e9$export$ce0466efa278e488 = (items, defaultItems)=>(0, (/*@__PURE__*/$parcel$interopDefault($4q8Hz)))(items.concat(defaultItems), defaultItems, (item)=>item.menuId);

});
parcelRegister("4q8Hz", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $lk1pL = parcelRequire("lk1pL");

var $1lM9j = parcelRequire("1lM9j");

var $l76qh = parcelRequire("l76qh");

var $9gcs2 = parcelRequire("9gcs2");

var $1ilzu = parcelRequire("1ilzu");
/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */ var $33805722d8bf59dd$var$intersectionBy = $l76qh(function(arrays) {
    var iteratee = $1ilzu(arrays), mapped = $lylkU(arrays, $9gcs2);
    if (iteratee === $1ilzu(mapped)) iteratee = undefined;
    else mapped.pop();
    return mapped.length && mapped[0] === arrays[0] ? $lk1pL(mapped, $1lM9j(iteratee, 2)) : [];
});
module.exports = $33805722d8bf59dd$var$intersectionBy;

});
parcelRegister("lk1pL", function(module, exports) {

var $4hmxn = parcelRequire("4hmxn");

var $40QQB = parcelRequire("40QQB");

var $e2REr = parcelRequire("e2REr");

var $lylkU = parcelRequire("lylkU");

var $cUaWv = parcelRequire("cUaWv");

var $fAWNe = parcelRequire("fAWNe");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f85c901f5c390ec4$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $f85c901f5c390ec4$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $e2REr : $40QQB, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $lylkU(array, $cUaWv(iteratee));
        maxLength = $f85c901f5c390ec4$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $4hmxn(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $fAWNe(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $fAWNe(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $f85c901f5c390ec4$var$baseIntersection;

});

parcelRegister("9gcs2", function(module, exports) {

var $d1ShJ = parcelRequire("d1ShJ");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $6bdf44410d0452f9$var$castArrayLikeObject(value) {
    return $d1ShJ(value) ? value : [];
}
module.exports = $6bdf44410d0452f9$var$castArrayLikeObject;

});




parcelRegister("8bGNP", function(module, exports) {

$parcel$export(module.exports, "useL1DragState", () => $800a068f04ee55a1$export$89eb3dcfeb3560d4);

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $dv8dh = parcelRequire("dv8dh");

var $2KHoH = parcelRequire("2KHoH");

var $52lff = parcelRequire("52lff");
function $800a068f04ee55a1$export$89eb3dcfeb3560d4() {
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $2KHoH.useOptions)();
    const groupDropIndicatorRef = (0, $eJOHy.useRef)(null);
    const [dragState, setDragState] = (0, $eJOHy.useState)('idle');
    (0, $eJOHy.useEffect)(()=>{
        if (!l1DragAndDropEnabled) return;
        const l1GroupDropIndicator = groupDropIndicatorRef.current;
        (0, $8GOss.default)(l1GroupDropIndicator, 'l1GroupDropIndicatorRef should not be null');
        return (0, $dv8dh.dropTargetForElements)({
            element: l1GroupDropIndicator,
            canDrop: ({ source: source })=>(0, $52lff.isL1ItemData)(source.data),
            onDragStart () {
                setDragState('is-over');
            },
            onDragEnter () {
                setDragState('is-over');
            },
            onDragLeave () {
                setDragState('idle');
            },
            onDrop () {
                setDragState('idle');
            }
        });
    }, [
        l1DragAndDropEnabled
    ]);
    return {
        groupDropIndicatorRef: groupDropIndicatorRef,
        dragState: dragState
    };
}

});

parcelRegister("fJeBB", function(module, exports) {

$parcel$export(module.exports, "useModifyNavItemForAnalytics", () => $5fb0ec640b27546f$export$66c1c1d1fa542654);

var $i2hNi = parcelRequire("i2hNi");

var $6Gcou = parcelRequire("6Gcou");
function $5fb0ec640b27546f$export$66c1c1d1fa542654() {
    const { fireViewSideNavSubMenuEvent: fireViewSideNavSubMenuEvent, fireClickedSideNavSubMenuItemEvent: fireClickedSideNavSubMenuItemEvent } = (0, $6Gcou.useNavAnalytics)();
    function modifyNavItemForAnalytics(id, item, globalItems, items, visibleItemMenuIds, isInMore) {
        let newItem = {
            ...item
        };
        switch(item.type){
            case 'expand':
                {
                    const onExpansionToggle = (isExpanded)=>{
                        item.onExpansionToggle?.(isExpanded);
                        if (isExpanded) fireViewSideNavSubMenuEvent(id, globalItems, items, visibleItemMenuIds, undefined, isInMore);
                    };
                    // Wrap children with our analytics listener to capture their click events
                    const wrappedChildren = (0, $i2hNi.withSideNavigationAnalyticsListener)(item.children, ()=>fireClickedSideNavSubMenuItemEvent(id, globalItems, items, visibleItemMenuIds, undefined, isInMore));
                    newItem = {
                        ...item,
                        onExpansionToggle: onExpansionToggle,
                        children: wrappedChildren
                    };
                    break;
                }
            case 'flyout':
                {
                    const onFlyoutOpenChange = (isOpen)=>{
                        item.onOpenChange?.(isOpen);
                        if (isOpen) fireViewSideNavSubMenuEvent(id, globalItems, items, visibleItemMenuIds, undefined, isInMore);
                    };
                    // Wrap children with our analytics listener to capture their click events
                    const wrappedChildren = (0, $i2hNi.withSideNavigationAnalyticsListener)(item.children, ()=>fireClickedSideNavSubMenuItemEvent(id, globalItems, items, visibleItemMenuIds));
                    newItem = {
                        ...item,
                        onOpenChange: onFlyoutOpenChange,
                        children: wrappedChildren
                    };
                    break;
                }
            case 'object-list-flyout':
                {
                    const subItemsCount = item.useItems('', []).sections?.flatMap((section)=>section.items)?.length;
                    const onOpenChange = (isOpen)=>{
                        item.onOpenChange?.(isOpen);
                        if (isOpen) fireViewSideNavSubMenuEvent(id, globalItems, items, visibleItemMenuIds, subItemsCount, isInMore);
                    };
                    // Callback to handle click events on sub-menu items
                    const onSubMenuItemClick = ()=>fireClickedSideNavSubMenuItemEvent(id, globalItems, items, visibleItemMenuIds, subItemsCount, isInMore);
                    newItem = {
                        ...item,
                        onOpenChange: onOpenChange,
                        onSubMenuItemClick: onSubMenuItemClick
                    };
                    break;
                }
        }
        return newItem;
    }
    return {
        modifyNavItemForAnalytics: modifyNavItemForAnalytics
    };
}

});
parcelRegister("6Gcou", function(module, exports) {

$parcel$export(module.exports, "useNavAnalytics", () => $395e8721c8d1c473$export$8d6902e2f27b22d5);


var $3G7eh = parcelRequire("3G7eh");
function $395e8721c8d1c473$export$8d6902e2f27b22d5() {
    const { fireEvent: fireEvent } = (0, $3G7eh.useAnalyticsEvents)();
    const fireViewSideNavEvent = (forYou, sideNavMenuData, appSpecificItemsList, isCustomizationEnabled, hasBottomElem)=>{
        const moreMenuItems = sideNavMenuData.hiddenItemMenuIds.concat(sideNavMenuData.hiddenShortcutMenuIds);
        const globalItemsList = [
            ...!forYou.hideForYou ? [
                forYou.forYouMenuItemId ?? 'global.sidebar.forYou'
            ] : [],
            ...!forYou.hideRecents ? [
                forYou.recentsMenuItemId ?? 'global.sidebar.recents'
            ] : [],
            ...!forYou.hideStarred ? [
                forYou.starredMenuItemId ?? 'global.sidebar.starred'
            ] : [],
            ...isCustomizationEnabled ? [
                moreMenuItems.length ? (0, $d9a5c367bff5e590$export$9536180777e6913e) : (0, $d9a5c367bff5e590$export$60e3e06657245ab)
            ] : [],
            ...hasBottomElem ? [
                'global.sidebar.bottomElem'
            ] : []
        ];
        const appShortcutItemsList = sideNavMenuData.visibleShortcutMenuIds;
        fireEvent('ui.sideNav.viewed.sideNavMenu', {
            globalItemsCount: globalItemsList.length,
            globalItemsList: globalItemsList,
            appSpecificItemsCount: appSpecificItemsList.length,
            appSpecificItemsList: appSpecificItemsList,
            appShortcutItemsCount: appShortcutItemsList.length,
            appShortcutItemsList: appShortcutItemsList,
            inMoreItemsCount: moreMenuItems.length,
            inMoreItemsList: moreMenuItems
        });
    };
    const fireClickSideNavNavItemEvent = (id, index, items, globalItems, sideNavMenuData, totalNavItemsCount, additionalGlobalItemsCount, isInMore = false)=>{
        const isAppSpecificItem = Object.keys(items).includes(id);
        const currentGroupItems = sideNavMenuData.visibleItemMenuIds.filter((id)=>isAppSpecificItem ? !globalItems.has(id) : globalItems.has(id));
        fireClickSideNavItemEvent({
            navLayoutComponent: 'main',
            navItemsCount: totalNavItemsCount,
            navItemsIndex: index,
            group: isAppSpecificItem ? 'appSpecific' : 'global',
            groupItemsCount: isAppSpecificItem ? currentGroupItems.length : currentGroupItems.length + additionalGlobalItemsCount,
            groupItemsIndex: currentGroupItems.findIndex((menuId)=>menuId === id),
            groupItem: id,
            isInMore: isInMore
        });
    };
    const fireClickSideNavShortcutItemEvent = (shortcutId, index, hydratedShortcuts, sideNavMenuData, totalNavItemsCount, growthItemsCount)=>{
        const visibleShortcutItems = sideNavMenuData.visibleShortcutMenuIds.filter((id)=>hydratedShortcuts?.[id]);
        fireClickSideNavItemEvent({
            navLayoutComponent: 'postMain',
            navItemsCount: totalNavItemsCount,
            navItemsIndex: sideNavMenuData.visibleItemMenuIds.length + index,
            group: 'appShortcut',
            groupItemsCount: visibleShortcutItems.length + growthItemsCount,
            groupItemsIndex: index,
            groupItem: shortcutId,
            isInMore: false
        });
    };
    const fireClickSideNavMoreMenuItemEvent = (globalItems, sideNavMenuData, totalNavItemsCount, additionalGlobalItemsCount, growthItemsCount)=>{
        const visibleGlobalItems = sideNavMenuData.visibleItemMenuIds.filter((id)=>globalItems.has(id));
        fireClickSideNavItemEvent({
            navLayoutComponent: 'postMain',
            navItemsCount: totalNavItemsCount,
            navItemsIndex: sideNavMenuData.visibleMenuIds.length + growthItemsCount,
            group: 'global',
            groupItemsCount: visibleGlobalItems.length + additionalGlobalItemsCount,
            groupItemsIndex: visibleGlobalItems.length,
            groupItem: 'more',
            isInMore: false
        });
    };
    const fireClickSideNavCustomizeSidebarItemEvent = (globalItems, sideNavMenuData, totalNavItemsCount, additionalGlobalItemsCount, growthItemsCount)=>{
        const visibleGlobalItems = sideNavMenuData.visibleItemMenuIds.filter((id)=>globalItems.has(id));
        const isInMore = !!sideNavMenuData.hiddenMenuIds.length; // is in more menu if there are any hidden items
        fireClickSideNavItemEvent({
            navLayoutComponent: 'postMain',
            navItemsCount: isInMore ? sideNavMenuData.hiddenMenuIds.length + 1 : totalNavItemsCount,
            navItemsIndex: isInMore ? sideNavMenuData.hiddenMenuIds.length : sideNavMenuData.visibleMenuIds.length + growthItemsCount,
            group: 'global',
            groupItemsCount: isInMore ? 1 : visibleGlobalItems.length + additionalGlobalItemsCount,
            groupItemsIndex: isInMore ? 0 : visibleGlobalItems.length,
            groupItem: (0, $d9a5c367bff5e590$export$60e3e06657245ab),
            isInMore: isInMore
        });
    };
    const fireClickSideNavItemEvent = (attributes)=>fireEvent('ui.sideNav.clicked.sideNavItem', attributes);
    const fireViewSideNavSubMenuEvent = (id, globalItems, appSpecificItems, visibleItemMenuIds, subItemsCount, isInMore = false)=>{
        const isGlobal = globalItems.has(id);
        const visibleGlobalItems = visibleItemMenuIds.filter((id)=>globalItems.has(id));
        const visibleAppSpecificItems = visibleItemMenuIds.filter((id)=>appSpecificItems[id]);
        const currentGroup = isGlobal ? visibleGlobalItems : visibleAppSpecificItems;
        fireEvent('ui.sideNav.viewed.sideNavSubMenu', {
            navLayoutComponent: 'main',
            group: isGlobal ? 'global' : 'appSpecific',
            groupItemsCount: currentGroup.length,
            groupItemsIndex: currentGroup.findIndex((key)=>key === id),
            groupItem: id,
            isInMore: isInMore,
            groupSubItemCount: subItemsCount ?? null
        });
    };
    const fireScrollSideNavEvent = (scrollDirection)=>{
        fireEvent('ui.sideNav.scrolled.sideNavMenu', {
            scrollDirection: scrollDirection
        });
    };
    const getCustomizationModalAttributes = (appSpecificItemsList, appShortcutItemsList)=>{
        const checkedItems = [
            ...appSpecificItemsList,
            ...appShortcutItemsList
        ].filter((item)=>item.visible).map((item)=>item.menuId);
        return {
            appSpecificItemsCount: appSpecificItemsList.length,
            appSpecificItemsList: appSpecificItemsList.map((item)=>item.menuId),
            appShortcutItemsCount: appShortcutItemsList.length,
            appShortcutItemsList: appShortcutItemsList.map((item)=>item.menuId),
            isCheckedItemsCount: checkedItems.length,
            isCheckedItemsList: checkedItems
        };
    };
    const fireViewedCustomizeModalEvent = (appSpecificItemsList, appShortcutItemsList)=>fireEvent('ui.customizationModal.viewed.customizationModalMenu', getCustomizationModalAttributes(appSpecificItemsList, appShortcutItemsList));
    const fireClickCustomizeModalSaveEvent = (appSpecificItemsList, appShortcutItemsList)=>fireEvent('ui.customizationModal.clicked.customizationModalSave', getCustomizationModalAttributes(appSpecificItemsList, appShortcutItemsList));
    const fireClickCustomizeModalCancelEvent = (appSpecificItemsList, appShortcutItemsList)=>fireEvent('ui.customizationModal.clicked.customizationModalCancel', getCustomizationModalAttributes(appSpecificItemsList, appShortcutItemsList));
    const fireViewedShortcutsEvent = (shortcuts)=>{
        const attributes = {
            appShortcutItemsCount: shortcuts.length,
            appShortcutItemsList: shortcuts.map((item)=>item.label)
        };
        fireEvent('ui.sideNav.viewed.sideNavAppShortcutsSection', attributes);
    };
    const fireClickedSideNavSubMenuItemEvent = (id, globalItems, appSpecificItems, visibleItemMenuIds, subItemsCount, isInMore = false)=>{
        const isGlobal = globalItems.has(id);
        const visibleGlobalItems = visibleItemMenuIds.filter((id)=>globalItems.has(id));
        const visibleAppSpecificItems = visibleItemMenuIds.filter((id)=>appSpecificItems[id]);
        const currentGroup = isGlobal ? visibleGlobalItems : visibleAppSpecificItems;
        fireEvent('ui.sideNav.clicked.sideNavSubItem', {
            navLayoutComponent: 'main',
            group: isGlobal ? 'global' : 'appSpecific',
            groupItemsCount: currentGroup.length,
            groupItemsIndex: currentGroup.findIndex((key)=>key === id),
            groupItem: id,
            isInMore: isInMore,
            groupSubItemCount: subItemsCount ?? null,
            groupSubItemIndex: null,
            groupSubItem: null
        });
    };
    return {
        fireViewSideNavEvent: fireViewSideNavEvent,
        fireClickSideNavNavItemEvent: fireClickSideNavNavItemEvent,
        fireClickSideNavShortcutItemEvent: fireClickSideNavShortcutItemEvent,
        fireClickSideNavMoreMenuItemEvent: fireClickSideNavMoreMenuItemEvent,
        fireClickSideNavCustomizeSidebarItemEvent: fireClickSideNavCustomizeSidebarItemEvent,
        fireClickSideNavItemEvent: fireClickSideNavItemEvent,
        fireScrollSideNavEvent: fireScrollSideNavEvent,
        fireViewSideNavSubMenuEvent: fireViewSideNavSubMenuEvent,
        fireViewedCustomizeModalEvent: fireViewedCustomizeModalEvent,
        fireClickCustomizeModalSaveEvent: fireClickCustomizeModalSaveEvent,
        fireClickCustomizeModalCancelEvent: fireClickCustomizeModalCancelEvent,
        fireViewedShortcutsEvent: fireViewedShortcutsEvent,
        fireClickedSideNavSubMenuItemEvent: fireClickedSideNavSubMenuItemEvent
    };
}

});
const $d9a5c367bff5e590$export$60e3e06657245ab = 'gsn-customize-sidebar';
const $d9a5c367bff5e590$export$9536180777e6913e = 'gsn-more-menu';

parcelRegister("3G7eh", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $b0c0b6ca58c45ac6$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::b3c61250a84f619b4027771ee5c5ce69>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen global-side-navigation
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $f1Zdy = parcelRequire("f1Zdy");


var $laHz3 = parcelRequire("laHz3");
const $b0c0b6ca58c45ac6$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const fireEvent = (0, $eJOHy.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $laHz3.default)(...params));
        event.fire((0, $9900fe341890aa8c$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("laHz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $58d85b733b804e3d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::104fd57c141a6ef812e2ef73c24c1bba>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen global-side-navigation
 */ const $58d85b733b804e3d$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $58d85b733b804e3d$export$2e2bcd8739ae039 = $58d85b733b804e3d$var$createEventPayload;

});




parcelRegister("gPnUs", function(module, exports) {

$parcel$export(module.exports, "SideNavDataProvider", () => $83966f2d79db6a0b$export$e8cf6894e0873d93);
$parcel$export(module.exports, "useSideNavData", () => $83966f2d79db6a0b$export$89056b79b690b438);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");
const $83966f2d79db6a0b$export$33f9eded602e3caf = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
function $83966f2d79db6a0b$export$e8cf6894e0873d93({ children: children, value: value }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($83966f2d79db6a0b$export$33f9eded602e3caf.Provider, {
        value: value,
        children: children
    });
}
const $83966f2d79db6a0b$export$89056b79b690b438 = ()=>{
    const customizationDataShapes = (0, $eJOHy.useContext)($83966f2d79db6a0b$export$33f9eded602e3caf);
    (0, $8GOss.default)(customizationDataShapes, 'useSideNavData must be used inside an initialized SideNavDataProvider');
    return customizationDataShapes;
};

});

parcelRegister("7bSed", function(module, exports) {

$parcel$export(module.exports, "useDragAndDropSave", () => $3ca71e413c40c149$export$440b6dd66925f04d);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $8GOss = parcelRequire("8GOss");

var $hSKbU = parcelRequire("hSKbU");

var $4U7Uj = parcelRequire("4U7Uj");
parcelRequire("e1Hsg");
var $ayN1P = parcelRequire("ayN1P");

var $iX2nw = parcelRequire("iX2nw");
function $3ca71e413c40c149$export$440b6dd66925f04d(sideNavMenuData, elementRegistry) {
    /*
	Get current order of items and shortcuts
	Apply reorder or hide operation
	Save the updated data using onSave
	*/ const intl = (0, $lRq8t.default)();
    const [lastDragAndDropAction, setLastDragAndDropAction] = (0, $eJOHy.useState)(null);
    // Clean up live region when unmounted
    (0, $eJOHy.useEffect)(()=>{
        return ()=>$4U7Uj.cleanup();
    }, []);
    const dragAndDropSave = (0, $eJOHy.useCallback)(async (action)=>{
        // Item reordering
        if ($3ca71e413c40c149$var$isItemReorderAction(action)) {
            (0, $8GOss.default)(action.droppedOnMenuItemId, 'item-reorder action must have droppedOnMenuItemId');
            const startIndex = sideNavMenuData.customizationData.findIndex((datum)=>datum.menuId === action.draggedMenuItemId);
            const itemsAndShortcutsIdsWithoutDraggedItem = sideNavMenuData.customizationData.map((datum)=>datum.menuId).filter((id)=>id !== action.draggedMenuItemId);
            const dropTargetIndex = itemsAndShortcutsIdsWithoutDraggedItem.indexOf(action.droppedOnMenuItemId);
            if (startIndex === -1) // TODO: NAVX-1289 Track this error case somehow - maybe analytics
            return;
            if (dropTargetIndex === -1) // TODO: NAVX-1289 Track this error case somehow - maybe analytics
            return;
            const finishIndex = action.instruction.operation === 'reorder-after' ? dropTargetIndex + 1 : dropTargetIndex;
            const visibleStartIndex = sideNavMenuData.visibleItemMenuIds.indexOf(action.draggedMenuItemId);
            const visibleDropTargetIndex = sideNavMenuData.visibleItemMenuIds.filter((id)=>id !== action.draggedMenuItemId).indexOf(action.droppedOnMenuItemId);
            if (visibleStartIndex === -1) // TODO: NAVX-1289 Track this error case somehow - maybe analytics
            return;
            if (visibleDropTargetIndex === -1) // TODO: NAVX-1289 Track this error case somehow - maybe analytics
            return;
            const visibleFinishIndex = action.instruction.operation === 'reorder-after' ? visibleDropTargetIndex + 1 : visibleDropTargetIndex;
            const reordered = (0, $ayN1P.reorder)({
                list: sideNavMenuData.customizationData,
                startIndex: startIndex,
                finishIndex: finishIndex
            });
            await sideNavMenuData.setUserMenuData(reordered);
            setLastDragAndDropAction({
                ...action,
                startIndex: visibleStartIndex,
                finishIndex: visibleFinishIndex
            });
            return;
        }
        // Item hiding into More menu
        if ($3ca71e413c40c149$var$isItemHideAction(action)) {
            const dataWithHiddenItem = sideNavMenuData.customizationData.map((datum)=>{
                if (datum.menuId === action.draggedMenuItemId) return {
                    ...datum,
                    visible: false
                };
                return datum;
            });
            await sideNavMenuData.setUserMenuData(dataWithHiddenItem);
            setLastDragAndDropAction(action);
            return;
        }
        // Shortcut reordering
        if ($3ca71e413c40c149$var$isShortcutReorderAction(action)) // TODO: NAVX-1004 Implement shortcut reordering and hiding logic
        return;
        // Shortcut hiding into More menu
        if ($3ca71e413c40c149$var$isShortcutHideAction(action)) // TODO: NAVX-1004 Implement shortcut reordering and hiding logic
        return;
    }, [
        sideNavMenuData
    ]);
    // After action has been performed, announce & flash the item
    (0, $eJOHy.useEffect)(()=>{
        if (!lastDragAndDropAction) return;
        if ($3ca71e413c40c149$var$isItemReorderAction(lastDragAndDropAction)) {
            const label = lastDragAndDropAction.draggedMenuItemLabel || lastDragAndDropAction.draggedMenuItemId;
            const element = elementRegistry.getL1ItemElement(lastDragAndDropAction.draggedMenuItemId);
            if (element) {
                // Flash the moved item
                (0, $hSKbU.triggerPostMoveFlash)(element);
                // Focus the moved item if move was triggered by keyboard
                if (lastDragAndDropAction.trigger === 'keyboard') // Per Atlaskit team, .focus() seems to be more reliable in the next task when used with VoiceOver
                setTimeout(()=>element.focus());
                // Announce the move for assistive technology users
                $4U7Uj.announce(intl.formatMessage((0, $iX2nw.messages).a11yAnnouncementItemReordered, {
                    label: label,
                    startIndex: lastDragAndDropAction.startIndex + 1,
                    finishIndex: lastDragAndDropAction.finishIndex + 1
                }));
            }
            return;
        }
        if ($3ca71e413c40c149$var$isItemHideAction(lastDragAndDropAction)) {
            const label = lastDragAndDropAction.draggedMenuItemLabel || lastDragAndDropAction.draggedMenuItemId;
            const moreMenuElement = elementRegistry.getMoreMenuElement();
            if (moreMenuElement) {
                // Flash the More menu
                (0, $hSKbU.triggerPostMoveFlash)(moreMenuElement);
                // Focus the More menu if move was triggered by keyboard
                if (lastDragAndDropAction.trigger === 'keyboard') // Per Atlaskit team, .focus() seems to be more reliable in the next task when used with VoiceOver
                setTimeout(()=>moreMenuElement.focus());
                // Announce the hide for assistive technology users
                $4U7Uj.announce(intl.formatMessage((0, $iX2nw.messages).a11yAnnouncementItemHidden, {
                    label: label
                }));
            }
        }
    }, [
        elementRegistry,
        intl,
        lastDragAndDropAction
    ]);
    return {
        dragAndDropSave: dragAndDropSave
    };
}
function $3ca71e413c40c149$var$isItemReorderAction(action) {
    return action.type === 'item-reorder';
}
function $3ca71e413c40c149$var$isItemHideAction(action) {
    return action.type === 'item-hide';
}
function $3ca71e413c40c149$var$isShortcutReorderAction(action) {
    return action.type === 'shortcut-reorder';
}
function $3ca71e413c40c149$var$isShortcutHideAction(action) {
    return action.type === 'shortcut-hide';
}

});
parcelRegister("4U7Uj", function(module, exports) {

$parcel$export(module.exports, "announce", () => $10bddc54bf5892ec$export$a9b970dcc4ae71a9);
$parcel$export(module.exports, "cleanup", () => $10bddc54bf5892ec$export$de863c629cb9919d);

let $10bddc54bf5892ec$var$node = null;
const $10bddc54bf5892ec$var$size = '1px';
const $10bddc54bf5892ec$var$visuallyHiddenStyles = {
    // Standard visually hidden styles.
    // Copied from our VisuallyHidden (react) package.
    width: $10bddc54bf5892ec$var$size,
    height: $10bddc54bf5892ec$var$size,
    padding: '0',
    position: 'absolute',
    border: '0',
    clip: `rect(${$10bddc54bf5892ec$var$size}, ${$10bddc54bf5892ec$var$size}, ${$10bddc54bf5892ec$var$size}, ${$10bddc54bf5892ec$var$size})`,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    // Pulling upwards slightly to prevent the page
    // from growing when appended to a body that contains
    // an element with height:100%
    marginTop: `-${$10bddc54bf5892ec$var$size}`,
    // Just being safe and letting this element not interfere with hitboxes
    pointerEvents: 'none'
};
/**
 * Creates a live region node, appends it to the body, and returns it.
 */ function $10bddc54bf5892ec$var$createNode() {
    const node = document.createElement('div');
    /**
	 * Using `role="status"` instead of `role="alert"` so that the message
	 * can be queued and read when able.
	 *
	 * We found with `role="alert"` the message was not reliably read when
	 * focus changed.
	 */ node.setAttribute('role', 'status');
    Object.assign(node.style, $10bddc54bf5892ec$var$visuallyHiddenStyles);
    document.body.append(node);
    return node;
}
/**
 * Returns the live region node, creating one if necessary.
 */ function $10bddc54bf5892ec$var$getNode() {
    if ($10bddc54bf5892ec$var$node === null) $10bddc54bf5892ec$var$node = $10bddc54bf5892ec$var$createNode();
    return $10bddc54bf5892ec$var$node;
}
let $10bddc54bf5892ec$var$timerId = null;
function $10bddc54bf5892ec$var$tryClearTimer() {
    if ($10bddc54bf5892ec$var$timerId !== null) clearTimeout($10bddc54bf5892ec$var$timerId);
    $10bddc54bf5892ec$var$timerId = null;
}
function $10bddc54bf5892ec$export$a9b970dcc4ae71a9(message) {
    /**
	 * Calling this immediately to ensure a node exists and has time to be parsed
	 * and exposed in the accessibility tree.
	 */ $10bddc54bf5892ec$var$getNode();
    /**
	 * Updating the message in a timeout so that it's less likely to be interrupted.
	 *
	 * This function is often called right before focus changes,
	 * because the user has just taken an action.
	 * This focus change would often cause the message to be skipped / interrupted.
	 */ $10bddc54bf5892ec$var$tryClearTimer();
    $10bddc54bf5892ec$var$timerId = setTimeout(()=>{
        $10bddc54bf5892ec$var$timerId = null;
        const node = $10bddc54bf5892ec$var$getNode();
        node.textContent = message;
    }, (0, $9dd2a022d21b018e$export$a88f30567ea7367a));
    return;
}
function $10bddc54bf5892ec$export$de863c629cb9919d() {
    $10bddc54bf5892ec$var$tryClearTimer();
    $10bddc54bf5892ec$var$node?.remove();
    $10bddc54bf5892ec$var$node = null;
}

});
/**
 * Delay until the text content of the live region is updated.
 *
 * This value was reached through some experimentation, and may need tweaking in the future.
 */ const $9dd2a022d21b018e$export$a88f30567ea7367a = 1000;


parcelRegister("e1Hsg", function(module, exports) {

$parcel$export(module.exports, "reorder", () => (parcelRequire("ayN1P")).reorder);

var $ayN1P = parcelRequire("ayN1P");

});
parcelRegister("ayN1P", function(module, exports) {

$parcel$export(module.exports, "reorder", () => $ec01675a2579b978$export$fc77a6137e3f91c);
/**
 * A function that will reorder an array (`list`).
 * `reorder` returns a new array with reordered items and does not
 *  modify the original array. The items in the array are also not modified.
 */ function $ec01675a2579b978$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) // Making this function consistently return a new array reference.
    // This is consistent with .toSorted() which always returns a new array
    // even when it does not do anything
    return Array.from(list);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}

});


parcelRegister("iX2nw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e2c227419148503d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e2c227419148503d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    a11yAnnouncementItemHidden: {
        id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-hidden',
        defaultMessage: 'The top level menu item {label} has been hidden and moved to the More menu.',
        description: 'Announcement for assistive technology users when a top level menu item is hidden in the global side navigation.'
    },
    a11yAnnouncementItemReordered: {
        id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-reordered',
        defaultMessage: 'The top level menu item {label} has been moved from position {startIndex} to {finishIndex}.',
        description: 'Announcement for assistive technology users when a top level menu item is reordered in the global side navigation.'
    }
});

});


const $64bd3c81b9041d83$export$5678faf50a8e9276 = 'global-side-nav-test-id';
const $64bd3c81b9041d83$export$88dd4a9e4ffa4ec2 = 'gsn-peek';
const $64bd3c81b9041d83$export$ee2a9579670b9420 = 'gsn-global-shortcuts';

parcelRegister("4S1V1", function(module, exports) {

$parcel$export(module.exports, "useForYouNavItem", () => $5cdddb117789e8ba$export$a2a6512e1bd9d273);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6mPMG = parcelRequire("6mPMG");


var $jEMWI = parcelRequire("jEMWI");
const $5cdddb117789e8ba$var$elemBefore = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6mPMG))), {
    label: ""
});
function $5cdddb117789e8ba$export$a2a6512e1bd9d273(forYou) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // Some type magic so we can get the dependencies right for the memo and keep TypeScript happy.
    // Only use this constant when `forYou.hideForYou` is false.
    const forYouShown = forYou;
    return (0, $eJOHy.useMemo)(()=>{
        if (forYou.hideForYou) return [];
        else {
            const common = {
                elemBefore: $5cdddb117789e8ba$var$elemBefore,
                label: formatMessage((0, $jEMWI.messages).label),
                isSelected: forYouShown.forYouIsSelected,
                testId: (0, $e5680cb19ce5772b$export$f47cf802fb7ac2e6),
                isHideable: false,
                isReorderable: false
            };
            const value = forYouShown.forYouUrl ? {
                type: 'link',
                href: forYouShown.forYouUrl,
                onClick: forYouShown.forYouOnClick,
                ...common
            } : {
                type: 'button',
                onClick: forYouShown.forYouOnClick,
                ...common
            };
            return [
                [
                    forYouShown.forYouMenuItemId ?? 'global.sidebar.forYou',
                    value
                ]
            ];
        }
    }, [
        forYou.hideForYou,
        forYouShown.forYouIsSelected,
        forYouShown.forYouMenuItemId,
        forYouShown.forYouOnClick,
        forYouShown.forYouUrl,
        formatMessage
    ]);
}

});
const $e5680cb19ce5772b$export$f47cf802fb7ac2e6 = 'gsn-for-you';

parcelRegister("jEMWI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2597e004240284c3$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2597e004240284c3$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-side-navigation.for-you.label',
        description: 'Label on For You button in the side navigation. Typically takes users to an app-specific page showing user content',
        defaultMessage: 'For you'
    }
});

});


parcelRegister("caj2z", function(module, exports) {

$parcel$export(module.exports, "SideNavigationLayout", () => $ac532d1fc19eb593$export$610d5f09b69fac71);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $8GOss = parcelRequire("8GOss");

var $6CCPu = parcelRequire("6CCPu");
var $2JS8w = parcelRequire("2JS8w");
var $1Can4 = parcelRequire("1Can4");
var $92EGY = parcelRequire("92EGY");
var $2klPI = parcelRequire("2klPI");
var $hylcg = parcelRequire("hylcg");

var $8sPIa = parcelRequire("8sPIa");

var $fvlFa = parcelRequire("fvlFa");

var $6Gcou = parcelRequire("6Gcou");

var $1BH2d = parcelRequire("1BH2d");

var $2KHoH = parcelRequire("2KHoH");

var $6zp45 = parcelRequire("6zp45");

var $2l757 = parcelRequire("2l757");

var $lKoXh = parcelRequire("lKoXh");
function $ac532d1fc19eb593$export$610d5f09b69fac71(props) {
    const { setUserSideNavData: setUserSideNavData } = (0, $6zp45.useUserSideNavData)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fvlFa.AsyncIntlProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l757.SideNavVisibilityProvider), {
            setUserSideNavData: setUserSideNavData,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($ac532d1fc19eb593$var$SideNavigationLayoutComponent, {
                ...props
            })
        })
    });
}
function $ac532d1fc19eb593$var$SideNavigationLayoutComponent({ preMainElem: preMainElem, postMainElem: postMainElem, bottomElem: bottomElem, children: children, testId: testId }) {
    const intl = (0, $lRq8t.default)();
    const { userSideNavData: userSideNavData } = (0, $6zp45.useUserSideNavData)();
    const { onCollapse: onCollapse, onExpand: onExpand, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd } = (0, $2l757.useSideNavVisibility)();
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $2KHoH.useOptions)();
    const sideNavContentRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const scrollDirection = (0, $1BH2d.default)(sideNavContentRef);
    const navAnalytics = (0, $6Gcou.useNavAnalytics)();
    (0, $eJOHy.useEffect)(()=>{
        if (scrollDirection) navAnalytics.fireScrollSideNavEvent(scrollDirection);
    }, [
        navAnalytics,
        scrollDirection
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!l1DragAndDropEnabled) return;
        const scrollable = sideNavContentRef.current;
        (0, $8GOss.default)(scrollable, 'sideNavContentRef must be set');
        return (0, $8sPIa.autoScrollForElements)({
            element: scrollable,
            canScroll: ({ source: source })=>source.data.type === 'menu-item'
        });
    }, [
        l1DragAndDropEnabled
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2JS8w.SideNav), {
        testId: testId,
        onExpand: onExpand,
        onCollapse: onCollapse,
        defaultWidth: userSideNavData.defaultWidth,
        defaultCollapsed: userSideNavData.defaultCollapsed,
        children: [
            preMainElem && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2klPI.SideNavHeader), {
                children: preMainElem
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1Can4.SideNavContent), {
                ref: sideNavContentRef,
                children: [
                    children,
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hylcg.TopLevelSpacer), {}),
                    postMainElem
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6CCPu.PanelSplitter), {
                onResizeEnd: onResizeEnd,
                onResizeStart: onResizeStart,
                label: intl.formatMessage((0, $lKoXh.messages).panelSplitterLabel)
            }),
            bottomElem && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $92EGY.SideNavFooter), {
                children: bottomElem
            })
        ]
    });
}

});
parcelRegister("8sPIa", function(module, exports) {

$parcel$export(module.exports, "autoScrollForElements", () => $892361c1b9c9bc23$export$4b66ee8317094cdb);
$parcel$export(module.exports, "autoScrollWindowForElements", () => $892361c1b9c9bc23$export$c9168f41de61f525);

var $dv8dh = parcelRequire("dv8dh");

var $1qG4q = parcelRequire("1qG4q");
const $892361c1b9c9bc23$var$api = (0, $1qG4q.makeApi)({
    monitor: (0, $dv8dh.monitorForElements)
});
const $892361c1b9c9bc23$export$4b66ee8317094cdb = $892361c1b9c9bc23$var$api.autoScroll;
const $892361c1b9c9bc23$export$c9168f41de61f525 = $892361c1b9c9bc23$var$api.autoScrollWindow;

});
parcelRegister("1qG4q", function(module, exports) {

$parcel$export(module.exports, "makeApi", () => $39d2dbf7600f8eef$export$b8fa21320a811083);

var $hHuhV = parcelRequire("hHuhV");
parcelRequire("5VknV");
var $9TlpJ = parcelRequire("9TlpJ");

var $lNMG9 = parcelRequire("lNMG9");

var $hHp7S = parcelRequire("hHp7S");

var $3SvvN = parcelRequire("3SvvN");
function $39d2dbf7600f8eef$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        const cleanup = (0, $hHuhV.combine)((0, $hHp7S.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        return (0, $9TlpJ.once)(cleanup);
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        function cleanup() {
            windowRegistry.delete(unique);
        }
        return (0, $9TlpJ.once)(cleanup);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $3SvvN.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $lNMG9.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}

});
parcelRegister("5VknV", function(module, exports) {

$parcel$export(module.exports, "once", () => (parcelRequire("9TlpJ")).once);

var $9TlpJ = parcelRequire("9TlpJ");

});

parcelRegister("lNMG9", function(module, exports) {

$parcel$export(module.exports, "getScheduler", () => $1da8397bd86ee760$export$5cff7ac265db316a);
parcelRequire("hTJ0P");
var $kchZy = parcelRequire("kchZy");

var $hA6v0 = parcelRequire("hA6v0");
// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $1da8397bd86ee760$var$schedulers = new Map();
function $1da8397bd86ee760$export$5cff7ac265db316a(monitor) {
    const scheduler = $1da8397bd86ee760$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $1da8397bd86ee760$var$makeScheduler(monitor);
    $1da8397bd86ee760$var$schedulers.set(monitor, created);
    return created;
}
function $1da8397bd86ee760$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $kchZy.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $hA6v0.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $hA6v0.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}

});
parcelRegister("hTJ0P", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("kchZy")).getElementFromPointWithoutHoneypot);

var $kchZy = parcelRequire("kchZy");

});

parcelRegister("hA6v0", function(module, exports) {

$parcel$export(module.exports, "markAndGetEngagement", () => $732c34bfb1a342c9$export$8c764c3f2fc3d2d2);
$parcel$export(module.exports, "clearUnusedEngagements", () => $732c34bfb1a342c9$export$991e77dd347f3df1);
$parcel$export(module.exports, "clearEngagementHistory", () => $732c34bfb1a342c9$export$13ae770ed39b71ea);
const $732c34bfb1a342c9$var$ledger = new Map();
const $732c34bfb1a342c9$var$requested = new Set();
function $732c34bfb1a342c9$export$8c764c3f2fc3d2d2(element) {
    $732c34bfb1a342c9$export$1cb7cbb266b6f6fa(element);
    const entry = $732c34bfb1a342c9$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $732c34bfb1a342c9$var$ledger.set(element, fresh);
    return fresh;
}
function $732c34bfb1a342c9$export$1cb7cbb266b6f6fa(element) {
    $732c34bfb1a342c9$var$requested.add(element);
}
function $732c34bfb1a342c9$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $732c34bfb1a342c9$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $732c34bfb1a342c9$var$ledger.forEach((_, element)=>{
        if (!$732c34bfb1a342c9$var$requested.has(element)) $732c34bfb1a342c9$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $732c34bfb1a342c9$var$requested.clear();
}
function $732c34bfb1a342c9$export$13ae770ed39b71ea() {
    $732c34bfb1a342c9$var$ledger.clear();
}

});


parcelRegister("hHp7S", function(module, exports) {

$parcel$export(module.exports, "selector", () => $052a6169b6ddd6c9$export$aea217a45095ce11);
$parcel$export(module.exports, "addScrollableAttribute", () => $052a6169b6ddd6c9$export$4ec12fb57dfebd53);
const $052a6169b6ddd6c9$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $052a6169b6ddd6c9$export$aea217a45095ce11 = `[${$052a6169b6ddd6c9$export$4b152ab55cad4fd6}="true"]`;
function $052a6169b6ddd6c9$export$4ec12fb57dfebd53(element) {
    element.setAttribute($052a6169b6ddd6c9$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($052a6169b6ddd6c9$export$4b152ab55cad4fd6);
}

});

parcelRegister("3SvvN", function(module, exports) {

$parcel$export(module.exports, "tryScroll", () => $ebbf135031ee688c$export$233199807749476d);

var $gctfj = parcelRequire("gctfj");

var $hA6v0 = parcelRequire("hA6v0");

var $hHp7S = parcelRequire("hHp7S");

var $gnz2a = parcelRequire("gnz2a");
function $ebbf135031ee688c$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $ebbf135031ee688c$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$ebbf135031ee688c$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $hHp7S.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $ebbf135031ee688c$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $hA6v0.markAndGetEngagement)(element);
    const config = (0, $gctfj.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $gnz2a.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $ebbf135031ee688c$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $hA6v0.markAndGetEngagement)(element);
        const config = (0, $gctfj.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $gnz2a.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $ebbf135031ee688c$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $ebbf135031ee688c$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$ebbf135031ee688c$var$isScrollingAvailable(remainder)) return;
    $ebbf135031ee688c$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}

});
parcelRegister("gctfj", function(module, exports) {

$parcel$export(module.exports, "getInternalConfig", () => $2a459dbbca0128bb$export$e96028ec7ff9d079);
const $2a459dbbca0128bb$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $2a459dbbca0128bb$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $2a459dbbca0128bb$export$e96028ec7ff9d079(provided) {
    return {
        ...$2a459dbbca0128bb$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $2a459dbbca0128bb$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}

});

parcelRegister("gnz2a", function(module, exports) {

$parcel$export(module.exports, "getScrollBy", () => $9b472fbdc22c7b0e$export$6cfa6dfe6898b98f);

var $brtHj = parcelRequire("brtHj");

var $fp4ZZ = parcelRequire("fp4ZZ");

var $4YNIi = parcelRequire("4YNIi");

var $bJ1UT = parcelRequire("bJ1UT");

var $arAyX = parcelRequire("arAyX");

var $9ld2I = parcelRequire("9ld2I");
function $9b472fbdc22c7b0e$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $9b472fbdc22c7b0e$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $9b472fbdc22c7b0e$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $fp4ZZ.edges).reduce((map, edge)=>{
        const hitbox = (0, $4YNIi.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $fp4ZZ.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $arAyX.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $9ld2I.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $brtHj.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $bJ1UT.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $bJ1UT.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $bJ1UT.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $bJ1UT.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("brtHj", function(module, exports) {

$parcel$export(module.exports, "canScrollOnEdge", () => $6372a348d5400f2b$export$ccd6d9407403fcad);
const $6372a348d5400f2b$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};

});

parcelRegister("fp4ZZ", function(module, exports) {

$parcel$export(module.exports, "edges", () => $c5d74bede8e99c4d$export$4544a00f8eb65eb2);
$parcel$export(module.exports, "edgeAxisLookup", () => $c5d74bede8e99c4d$export$7fc144124ccf8292);
const $c5d74bede8e99c4d$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $c5d74bede8e99c4d$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};

});

parcelRegister("4YNIi", function(module, exports) {

$parcel$export(module.exports, "getOverElementHitbox", () => $52e7a2030cc8203f$export$b9a449c20abb0e9);

var $hJEfQ = parcelRequire("hJEfQ");

var $lA5Aw = parcelRequire("lA5Aw");
function $52e7a2030cc8203f$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $hJEfQ.axisLookup)[axis];
        const side = (0, $lA5Aw.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $52e7a2030cc8203f$export$b9a449c20abb0e9 = {
    top: $52e7a2030cc8203f$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $52e7a2030cc8203f$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $52e7a2030cc8203f$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $52e7a2030cc8203f$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};

});
parcelRegister("hJEfQ", function(module, exports) {

$parcel$export(module.exports, "axisLookup", () => $f7d6bdcb9a0502dd$export$42e42cdab35a2b96);
const $f7d6bdcb9a0502dd$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $f7d6bdcb9a0502dd$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $f7d6bdcb9a0502dd$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $f7d6bdcb9a0502dd$var$vertical,
        crossAxis: $f7d6bdcb9a0502dd$var$horizontal
    },
    horizontal: {
        mainAxis: $f7d6bdcb9a0502dd$var$horizontal,
        crossAxis: $f7d6bdcb9a0502dd$var$vertical
    }
};

});

parcelRegister("lA5Aw", function(module, exports) {

$parcel$export(module.exports, "mainAxisSideLookup", () => $86e52e6b6ba897ff$export$a45c0cd714a4dbaa);
const $86e52e6b6ba897ff$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};

});


parcelRegister("bJ1UT", function(module, exports) {

$parcel$export(module.exports, "getScrollChange", () => $999d0f66178cbf4d$export$470a2ff46db8cee8);

var $hJEfQ = parcelRequire("hJEfQ");

var $0Rn7O = parcelRequire("0Rn7O");

var $lA5Aw = parcelRequire("lA5Aw");
// We want a consistent scroll speed across devices, regardless of framerate
function $999d0f66178cbf4d$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $999d0f66178cbf4d$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $hJEfQ.axisLookup)[axis];
    const side = (0, $lA5Aw.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $0Rn7O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $0Rn7O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $999d0f66178cbf4d$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $999d0f66178cbf4d$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $999d0f66178cbf4d$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $0Rn7O.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $lA5Aw.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}

});
parcelRegister("0Rn7O", function(module, exports) {

$parcel$export(module.exports, "getPercentageInRange", () => $ac941dd07ba774d3$export$1a29de000a332d74);
function $ac941dd07ba774d3$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}

});


parcelRegister("arAyX", function(module, exports) {

$parcel$export(module.exports, "isAxisAllowed", () => $046803f24b78878c$export$7120fdbd90bd1292);
function $046803f24b78878c$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}

});

parcelRegister("9ld2I", function(module, exports) {

$parcel$export(module.exports, "isWithin", () => $487fe506b7900819$export$cda7a9d4399bf2e3);
function $487fe506b7900819$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}

});





parcelRegister("1BH2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8bbab71682a086c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $3s8bj = parcelRequire("3s8bj");
const $e8bbab71682a086c$var$DEBOUNCE_DURATION = 50;
const $e8bbab71682a086c$var$MIN_SCROLL_OFFSET = 0;
function $e8bbab71682a086c$export$2e2bcd8739ae039(ref) {
    const lastScrollY = (0, $eJOHy.useRef)(0);
    const [scrollDirection, setScrollDirection] = (0, $eJOHy.useState)(undefined);
    const [, forceUpdate] = (0, $eJOHy.useReducer)((x)=>x + 1, 0);
    (0, $eJOHy.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const onScroll = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            const scrollY = ref.current.scrollTop;
            const direction = scrollY > lastScrollY.current ? 'down' : 'up';
            if (scrollY - lastScrollY.current > $e8bbab71682a086c$var$MIN_SCROLL_OFFSET || scrollY - lastScrollY.current < -1 * $e8bbab71682a086c$var$MIN_SCROLL_OFFSET) {
                // Force an update to ensure the component re-triggers the event
                if (direction === scrollDirection) forceUpdate();
                else setScrollDirection(direction);
            }
            lastScrollY.current = scrollY > 0 ? scrollY : 0;
        }, $e8bbab71682a086c$var$DEBOUNCE_DURATION);
        // Bind returns an unbind function, which we can use to clean up the event listener
        // when the component unmounts or ref changes.
        return (0, $4eDgu.bind)(ref.current, {
            type: 'scroll',
            listener: onScroll,
            options: {
                capture: true
            }
        });
    }, [
        ref,
        scrollDirection
    ]);
    return scrollDirection;
}

});

parcelRegister("2l757", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibility", () => $1636aa0af17c65dc$export$4a602ad7e09bdb2c);
$parcel$export(module.exports, "SideNavVisibilityProvider", () => $1636aa0af17c65dc$export$aac8e996360f6ad9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $3G7eh = parcelRequire("3G7eh");
const $1636aa0af17c65dc$export$afc6d5ca319092bd = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $1636aa0af17c65dc$export$4a602ad7e09bdb2c = ()=>{
    const context = (0, $eJOHy.useContext)($1636aa0af17c65dc$export$afc6d5ca319092bd);
    (0, $8GOss.default)(context, 'useSideNavVisibility must be used within an SideNavVisibilityProvider');
    return context;
};
function $1636aa0af17c65dc$export$aac8e996360f6ad9({ children: children, onCollapse: onCollapse, onExpand: onExpand, onResizeEnd: onResizeEnd, onResizeStart: onResizeStart, setUserSideNavData: setUserSideNavData }) {
    const { fireEvent: fireEvent } = (0, $3G7eh.useAnalyticsEvents)();
    const onCollapseHandler = (0, $eJOHy.useCallback)((args)=>{
        fireEvent('ui.sideNav.collapsed', {
            ...args
        });
        setUserSideNavData({
            defaultCollapsed: true
        });
        onCollapse?.(args);
    }, [
        fireEvent,
        onCollapse,
        setUserSideNavData
    ]);
    const onExpandHandler = (0, $eJOHy.useCallback)((args)=>{
        fireEvent('ui.sideNav.expanded', {
            ...args
        });
        setUserSideNavData({
            defaultCollapsed: false
        });
        onExpand?.(args);
    }, [
        fireEvent,
        onExpand,
        setUserSideNavData
    ]);
    const onResizeStartHandler = (0, $eJOHy.useCallback)((args)=>{
        fireEvent('ui.sideNav.resizeStart', {
            ...args
        });
        onResizeStart?.(args);
    }, [
        fireEvent,
        onResizeStart
    ]);
    const onResizeEndHandler = (0, $eJOHy.useCallback)((args)=>{
        fireEvent('ui.sideNav.resizeEnd', {
            ...args
        });
        setUserSideNavData({
            defaultWidth: args.finalWidth
        });
        onResizeEnd?.(args);
    }, [
        fireEvent,
        onResizeEnd,
        setUserSideNavData
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($1636aa0af17c65dc$export$afc6d5ca319092bd.Provider, {
        value: {
            onExpand: onExpandHandler,
            onCollapse: onCollapseHandler,
            onResizeEnd: onResizeEndHandler,
            onResizeStart: onResizeStartHandler
        },
        children: children
    });
}

});

parcelRegister("lKoXh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a4a1a61f300c2778$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a4a1a61f300c2778$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    panelSplitterLabel: {
        id: 'navigation.global-side-navigation.panel-splitter.label',
        description: 'The accessible label for the panel splitter. Visually hidden but read by screen readers.',
        defaultMessage: 'Resize panel'
    }
});

});


parcelRegister("jUg2Q", function(module, exports) {

$parcel$export(module.exports, "PostMainItems", () => $80254d260d81ab07$export$b540acb5f181a91e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $i7XOj = parcelRequire("i7XOj");

var $8aRgF = parcelRequire("8aRgF");

var $bxHeV = parcelRequire("bxHeV");

var $9LyfF = parcelRequire("9LyfF");

var $iIz45 = parcelRequire("iIz45");
var $6ZAY2 = parcelRequire("6ZAY2");

var $kmSBH = parcelRequire("kmSBH");

var $321HW = parcelRequire("321HW");

var $8bGNP = parcelRequire("8bGNP");

var $fJeBB = parcelRequire("fJeBB");

var $6Gcou = parcelRequire("6Gcou");

var $2KHoH = parcelRequire("2KHoH");

var $6Xw13 = parcelRequire("6Xw13");

var $gPnUs = parcelRequire("gPnUs");


var $cg9jE = parcelRequire("cg9jE");

var $GsKHX = parcelRequire("GsKHX");
function $80254d260d81ab07$export$b540acb5f181a91e({ allNavItems: allNavItems, additionalGlobalItemsCount: additionalGlobalItemsCount, globalItems: globalItems, growthItemsCount: growthItemsCount, growthItemShortcuts: growthItemShortcuts, shortcuts: shortcuts, totalNavItemsCount: totalNavItemsCount, postItemsElem: postItemsElem, postMainElem: postMainElem, draggingL1Item: draggingL1Item = false }) {
    const { appLabel: appLabel, cloudId: cloudId, orgId: orgId, isShortcutsStatic: isShortcutsStatic, disableMenuCustomization: disableMenuCustomization, l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $2KHoH.useOptions)();
    const peekMenuId = (0, $6Xw13.usePeekMenuId)();
    const sideNavMenuData = (0, $gPnUs.useSideNavData)();
    const { fireClickSideNavShortcutItemEvent: fireClickSideNavShortcutItemEvent, fireClickSideNavMoreMenuItemEvent: fireClickSideNavMoreMenuItemEvent, fireClickSideNavNavItemEvent: fireClickSideNavNavItemEvent, fireClickSideNavCustomizeSidebarItemEvent: fireClickSideNavCustomizeSidebarItemEvent } = (0, $6Gcou.useNavAnalytics)();
    const { modifyNavItemForAnalytics: modifyNavItemForAnalytics } = (0, $fJeBB.useModifyNavItemForAnalytics)();
    const containerRef = (0, $eJOHy.useRef)(null);
    const { hasBeenInViewport: hasBeenInViewport } = (0, $321HW.useInViewport)({
        ref: containerRef
    });
    const hydratedShortcuts = (0, $6ZAY2.useGlobalShortcutsData)({
        shortcutsConfig: shortcuts,
        cloudId: cloudId,
        orgId: orgId,
        isShortcutsStatic: isShortcutsStatic
    });
    const handleShortcutItemClick = (0, $eJOHy.useCallback)((shortcutId, index)=>{
        fireClickSideNavShortcutItemEvent(shortcutId, index, hydratedShortcuts, sideNavMenuData, totalNavItemsCount, growthItemsCount);
    }, [
        fireClickSideNavShortcutItemEvent,
        growthItemsCount,
        hydratedShortcuts,
        sideNavMenuData,
        totalNavItemsCount
    ]);
    const shortcutItems = (0, $eJOHy.useMemo)(()=>{
        const availableShortcuts = sideNavMenuData.visibleShortcutMenuIds.reduce((acc, id)=>{
            const shortcut = hydratedShortcuts?.[id];
            if (shortcut) acc.push(shortcut);
            return acc;
        }, []);
        if (growthItemShortcuts) availableShortcuts.push(...Object.values(growthItemShortcuts));
        return availableShortcuts.map((shortcut, index)=>({
                ...shortcut,
                onClick: ()=>{
                    shortcut.onClick?.();
                    handleShortcutItemClick(shortcut.analyticsName ?? shortcut.label, index);
                }
            }));
    }, [
        sideNavMenuData.visibleShortcutMenuIds,
        growthItemShortcuts,
        hydratedShortcuts,
        handleShortcutItemClick
    ]);
    const { groupDropIndicatorRef: groupDropIndicatorRef } = (0, $8bGNP.useL1DragState)();
    const handleClickMoreMenuItem = (0, $eJOHy.useCallback)(()=>{
        fireClickSideNavMoreMenuItemEvent(globalItems, sideNavMenuData, totalNavItemsCount, additionalGlobalItemsCount, growthItemsCount);
    }, [
        additionalGlobalItemsCount,
        fireClickSideNavMoreMenuItemEvent,
        globalItems,
        growthItemsCount,
        sideNavMenuData,
        totalNavItemsCount
    ]);
    const handleClickCustomizeItem = (0, $eJOHy.useCallback)(()=>{
        fireClickSideNavCustomizeSidebarItemEvent(globalItems, sideNavMenuData, totalNavItemsCount, additionalGlobalItemsCount, growthItemsCount);
    }, [
        additionalGlobalItemsCount,
        fireClickSideNavCustomizeSidebarItemEvent,
        globalItems,
        growthItemsCount,
        sideNavMenuData,
        totalNavItemsCount
    ]);
    const handleClickSideNavItemPeeked = (0, $eJOHy.useCallback)(()=>{
        if (!peekMenuId) return;
        fireClickSideNavNavItemEvent(peekMenuId, 0, // index of peeked item is always 0
        allNavItems, globalItems, sideNavMenuData, totalNavItemsCount, additionalGlobalItemsCount, true // isInMore
        );
    }, [
        additionalGlobalItemsCount,
        allNavItems,
        fireClickSideNavNavItemEvent,
        globalItems,
        peekMenuId,
        sideNavMenuData,
        totalNavItemsCount
    ]);
    const peekItem = !!peekMenuId && sideNavMenuData.hiddenItemMenuIds.includes(peekMenuId) && modifyNavItemForAnalytics(peekMenuId, allNavItems[peekMenuId], globalItems, allNavItems, sideNavMenuData.visibleItemMenuIds, true // isInMore
    );
    const moreMenu = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cg9jE.default), {
        items: allNavItems,
        shortcutItems: shortcuts,
        itemIds: sideNavMenuData.hiddenItemMenuIds,
        shortcutItemIds: sideNavMenuData.hiddenShortcutMenuIds,
        appLabel: appLabel,
        onClickMoreMenuTrigger: handleClickMoreMenuItem,
        onClickCustomizeSidebarMenuItem: handleClickCustomizeItem
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9LyfF.default), {
        space: "space.100",
        children: [
            postItemsElem,
            !!shortcutItems.length && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.Box), {
                ref: containerRef,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($80254d260d81ab07$var$GlobalAppShortcuts, {
                    shortcutItems: shortcutItems,
                    hasBeenInViewport: hasBeenInViewport
                })
            }),
            peekItem && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.Box), {
                testId: (0, $64bd3c81b9041d83$export$88dd4a9e4ffa4ec2),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kmSBH.default), {
                    id: peekMenuId,
                    item: peekItem,
                    onClick: handleClickSideNavItemPeeked,
                    peek: true
                }, peekMenuId)
            }),
            !disableMenuCustomization && (l1DragAndDropEnabled ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8aRgF.GroupDropIndicator), {
                ref: groupDropIndicatorRef,
                isActive: draggingL1Item,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.Box), {
                        xcss: (0, $i7XOj.cx)(draggingL1Item ? $80254d260d81ab07$var$styles.hidden : $80254d260d81ab07$var$styles.visible),
                        children: moreMenu
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.Box), {
                        xcss: (0, $i7XOj.cx)(draggingL1Item ? $80254d260d81ab07$var$styles.visible : $80254d260d81ab07$var$styles.hidden),
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $GsKHX.HideFromSidebarButton), {})
                    })
                ]
            }) : moreMenu),
            postMainElem
        ]
    });
}
const $80254d260d81ab07$var$styles = {
    visible: "_1e0c1ule",
    hidden: "_1e0cglyw"
};
function $80254d260d81ab07$var$GlobalAppShortcuts({ shortcutItems: shortcutItems, hasBeenInViewport: hasBeenInViewport }) {
    const { app: app, cloudId: cloudId, userId: userId, orgId: orgId } = (0, $2KHoH.useOptions)();
    const { fireViewedShortcutsEvent: fireViewedShortcutsEvent } = (0, $6Gcou.useNavAnalytics)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (hasBeenInViewport) fireViewedShortcutsEvent(shortcutItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasBeenInViewport
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iIz45.default), {
        promoteSite: true,
        orgId: orgId,
        cloudId: cloudId,
        userId: userId,
        product: app,
        forceStatic: true,
        testId: (0, $64bd3c81b9041d83$export$ee2a9579670b9420),
        shortcutItems: shortcutItems
    });
}

});
parcelRegister("6ZAY2", function(module, exports) {

$parcel$export(module.exports, "useGlobalShortcutsData", () => $891a36143a5bde34$export$bc8645ef40313f94);

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");

var $7SKIr = parcelRequire("7SKIr");
var $9nsoK = parcelRequire("9nsoK");

var $aQp9j = parcelRequire("aQp9j");
const $891a36143a5bde34$export$bc8645ef40313f94 = ({ shortcutsConfig: shortcutsConfig, cloudId: cloudId, orgId: orgId, isShortcutsStatic: isShortcutsStatic })=>{
    const { buildURLAndFetchData: buildURLAndFetchData, status: status, productLinks: productLinks } = (0, $9nsoK.useBFFDataProvider)({
        request: {},
        cloudId: cloudId,
        orgId: orgId,
        forceStatic: isShortcutsStatic
    });
    // fetch the data from the bff if required
    (0, $eJOHy.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(shortcutsConfig) || isShortcutsStatic) return;
        buildURLAndFetchData();
    }, [
        buildURLAndFetchData,
        shortcutsConfig,
        isShortcutsStatic
    ]);
    // associate shortcuts with the returned bff data
    const hydratedAppShortcuts = (0, $eJOHy.useMemo)(()=>{
        if (status === (0, $7SKIr.RequestStatus).COMPLETE && Object.keys(productLinks).length) {
            const entries = Object.entries(shortcutsConfig || {});
            return entries.reduce((acc, [key, value])=>{
                // if config does not need a data reference, just return the value
                if (!value.apsKey) {
                    acc[key] = value;
                    return acc;
                }
                // if config requires the bff to determine the data reference
                const productLink = productLinks[value.apsKey];
                if (productLink) {
                    const filteredProductLink = cloudId ? productLink.filter((0, $aQp9j.productLinksWorkspaceCloudIdFilter)(cloudId))[0] : productLink[0];
                    acc[key] = {
                        ...value,
                        url: filteredProductLink.url
                    };
                    return acc;
                }
                return acc;
            }, {});
        }
        return shortcutsConfig;
    }, [
        productLinks,
        status,
        shortcutsConfig,
        cloudId
    ]);
    return hydratedAppShortcuts;
};

});

parcelRegister("321HW", function(module, exports) {

$parcel$export(module.exports, "useInViewport", () => $736df12206adf770$export$6215040b989f9b0f);

var $eJOHy = parcelRequire("eJOHy");
const $736df12206adf770$export$6215040b989f9b0f = ({ ref: ref })=>{
    const [hasBeenInViewport, setHasBeenInViewport] = (0, $eJOHy.useState)(false);
    const observer = (0, $eJOHy.useMemo)(()=>new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) setHasBeenInViewport(entry.isIntersecting);
        }, {
            rootMargin: '0px 0px 200px 0px'
        }), []);
    (0, $eJOHy.useEffect)(()=>{
        if (ref.current) {
            observer.observe(ref.current);
            return ()=>observer.disconnect();
        }
    }, [
        observer,
        ref
    ]);
    return {
        hasBeenInViewport: hasBeenInViewport
    };
};

});

parcelRegister("cg9jE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5db89b5f6b8d41e2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $2y3Ci = parcelRequire("2y3Ci");

var $18SQd = parcelRequire("18SQd");

var $6Gcou = parcelRequire("6Gcou");

var $6Xw13 = parcelRequire("6Xw13");


var $fPHd0 = parcelRequire("fPHd0");

var $dpGtl = parcelRequire("dpGtl");

var $7jMF2 = parcelRequire("7jMF2");
function $5db89b5f6b8d41e2$export$2e2bcd8739ae039({ items: items, shortcutItems: shortcutItems = {}, itemIds: itemIds, shortcutItemIds: shortcutItemIds, appLabel: appLabel, onClickMoreMenuTrigger: onClickMoreMenuTrigger, onClickCustomizeSidebarMenuItem: onClickCustomizeSidebarMenuItem }) {
    const { fireClickSideNavItemEvent: fireClickSideNavItemEvent } = (0, $6Gcou.useNavAnalytics)();
    const peekMenuId = (0, $6Xw13.usePeekMenuId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const menuItemComponent = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(({ closeMenu: closeMenu, menuId: menuId })=>{
        const fireMoreMenuItemClickedEvent = ()=>{
            const isShortcutItem = shortcutItemIds.includes(menuId);
            const currentGroup = isShortcutItem ? shortcutItemIds : itemIds;
            const index = currentGroup.findIndex((key)=>key === menuId);
            closeMenu();
            fireClickSideNavItemEvent({
                navLayoutComponent: 'postMain',
                group: isShortcutItem ? 'appShortcut' : 'appSpecific',
                groupItemsCount: currentGroup.length,
                groupItemsIndex: index,
                groupItem: menuId,
                isInMore: true,
                navItemsCount: itemIds.length + shortcutItemIds.length + 1,
                navItemsIndex: isShortcutItem ? itemIds.length - 1 + index : index
            });
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7jMF2.default), {
            id: menuId,
            items: items,
            shortcutItems: shortcutItems,
            onClick: fireMoreMenuItemClickedEvent
        }, menuId);
    }, [
        itemIds,
        items,
        fireClickSideNavItemEvent,
        shortcutItemIds,
        shortcutItems
    ]);
    const productItemsData = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        return itemIds.map((menuId)=>({
                menuId: menuId,
                visible: false
            }));
    }, [
        itemIds
    ]);
    const appItemsData = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        return shortcutItemIds.map((menuId)=>({
                menuId: menuId,
                visible: false
            }));
    }, [
        shortcutItemIds
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2y3Ci.MenuList), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $18SQd.GlobalMoreMenu), {
            productItemsData: productItemsData,
            appItemsData: appItemsData,
            menuItemComponent: menuItemComponent,
            customizeSidebarMenuItem: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fPHd0.CustomizeSidebarMenuItem), {
                items: items,
                shortcuts: shortcutItems,
                testId: (0, $d9a5c367bff5e590$export$60e3e06657245ab),
                appLabel: appLabel,
                onClick: onClickCustomizeSidebarMenuItem
            }),
            moreMenuItemLabel: formatMessage((0, $dpGtl.messages).moreMenuLabel),
            peekingMenuIds: peekMenuId ? [
                peekMenuId
            ] : undefined,
            testId: (0, $d9a5c367bff5e590$export$9536180777e6913e),
            onClickMoreMenuTrigger: onClickMoreMenuTrigger
        })
    });
}

});
parcelRegister("fPHd0", function(module, exports) {

$parcel$export(module.exports, "CustomizeSidebarMenuItem", () => $1c332a57f9537acd$export$b7fa0daee00ba08b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $clUC1 = parcelRequire("clUC1");

var $kRcOu = parcelRequire("kRcOu");

var $k3Ztu = parcelRequire("k3Ztu");

var $dtD2S = parcelRequire("dtD2S");

var $gPnUs = parcelRequire("gPnUs");

var $bu2es = parcelRequire("bu2es");

var $at40v = parcelRequire("at40v");

var $hF6l1 = parcelRequire("hF6l1");

var $6t8fR = parcelRequire("6t8fR");
const $1c332a57f9537acd$export$b7fa0daee00ba08b = ({ appLabel: appLabel, items: items, shortcuts: shortcuts, testId: testId, onClick: onClick })=>{
    const getMenuIconAndLabel = (0, $hF6l1.useGetMenuIconAndLabel)(items, shortcuts);
    const { itemCustomizationData: itemCustomizationData, shortcutCustomizationData: shortcutCustomizationData } = (0, $gPnUs.useSideNavData)();
    const extendedItemCustomizationData = (0, $dtD2S.extendWithCustomizationOptions)(itemCustomizationData, items);
    const onSave = (0, $6t8fR.useOnSave)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k3Ztu.ModalTrigger), {
        entryPoint: (0, $bu2es.customizationModalEntryPoint),
        entryPointProps: {
            getMenuIconAndLabel: getMenuIconAndLabel,
            itemCustomizationData: extendedItemCustomizationData,
            shortcutCustomizationData: shortcutCustomizationData,
            onSave: onSave,
            appLabel: appLabel
        },
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kRcOu.ButtonMenuItem), {
                elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clUC1))), {
                    label: ""
                }),
                ref: ref,
                testId: testId,
                onClick: onClick,
                children: formatMessage((0, $at40v.messages).customizeSidebarMenuItemLabel)
            })
    });
};

});
parcelRegister("dtD2S", function(module, exports) {

$parcel$export(module.exports, "extendWithCustomizationOptions", () => $9a9605f15209cdb0$export$fc8975fe9e50b6c4);
function $9a9605f15209cdb0$export$fc8975fe9e50b6c4(customizationData, items) {
    return customizationData.map((item)=>{
        const itemConfig = items[item.menuId];
        if (!itemConfig) return item;
        return {
            ...item,
            isNotCustomizable: itemConfig.isReorderable === false,
            isNotToggleable: itemConfig.isHideable === false
        };
    });
}

});

parcelRegister("bu2es", function(module, exports) {

$parcel$export(module.exports, "customizationModalEntryPoint", () => $7ae1fb03c0498c48$export$ce0411fdea635705);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $7ae1fb03c0498c48$export$ce0411fdea635705 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>// eslint-disable-next-line import/dynamic-import-chunkname
        (parcelRequire("8yCh1")).then(({ CustomizationModal: CustomizationModal })=>CustomizationModal), {
        moduleId: "b2e7e7c1",
        priority: "interaction",
        moduleId: 'navigation.global-side-navigation.customization-modal'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8yCh1", function(module, exports) {

let $63af30034bd431a7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $63af30034bd431a7$var$load("jdNGW").then(()=>parcelRequire('bhXVJ'));

});


parcelRegister("at40v", function(module, exports) {

$parcel$export(module.exports, "messages", () => $62ee4653dbfddf87$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $62ee4653dbfddf87$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    customizeSidebarMenuItemLabel: {
        id: 'navigation.global-side-navigation.customize-sidebar-menu-item.label',
        description: 'Label on Customize button in the side navigation. Shows a modal with options to customize the sidebar.',
        defaultMessage: 'Customize sidebar'
    }
});

});

parcelRegister("hF6l1", function(module, exports) {

$parcel$export(module.exports, "useGetMenuIconAndLabel", () => $9bc705a486037efa$export$946f6bdd4c4f6c7);

var $eJOHy = parcelRequire("eJOHy");

var $8j35r = parcelRequire("8j35r");
const $9bc705a486037efa$export$946f6bdd4c4f6c7 = (items, shortcuts)=>(0, $eJOHy.useCallback)((menuId)=>(0, $8j35r.getMenuIconAndLabel)(items, shortcuts)(menuId), [
        items,
        shortcuts
    ]);

});
parcelRegister("8j35r", function(module, exports) {

$parcel$export(module.exports, "getMenuIconAndLabel", () => $15a739dc5c1edfcd$export$5412ec86882b110d);
const $15a739dc5c1edfcd$export$5412ec86882b110d = (items, shortcuts)=>(menuId)=>{
        const item = items[menuId];
        if (item) {
            const { elemBefore: icon, label: label } = item;
            return {
                icon: icon,
                label: label
            };
        }
        const shortcut = shortcuts[menuId];
        if (shortcut) {
            const { icon: icon, label: label } = shortcut;
            return {
                icon: icon,
                label: label
            };
        }
        throw Error(`Menu id ${menuId} not found in either items or shortcuts`);
    };

});


parcelRegister("6t8fR", function(module, exports) {

$parcel$export(module.exports, "useOnSave", () => $950dca650f4b018d$export$ecbfe7cad2f40363);

var $eJOHy = parcelRequire("eJOHy");

var $j4RIQ = parcelRequire("j4RIQ");
const $950dca650f4b018d$export$ecbfe7cad2f40363 = ()=>{
    const { setUserMenuData: setUserMenuData } = (0, $j4RIQ.useUserMenuData)();
    return (0, $eJOHy.useCallback)((updatedItemCustomizationData, updatedShortcutCustomizationData)=>setUserMenuData(updatedItemCustomizationData.concat(updatedShortcutCustomizationData)), [
        setUserMenuData
    ]);
};

});


parcelRegister("dpGtl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9c8236bb9f79726c$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $9c8236bb9f79726c$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    moreMenuLabel: {
        id: 'navigation.global-side-navigation.more-menu.label',
        description: 'Label on More menu button in the side navigation. Shows a popout with items that are hidden from the main navigation.',
        defaultMessage: 'More'
    }
});

});

parcelRegister("7jMF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1037e0789aaee393$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6L9RF = parcelRequire("6L9RF");

var $aasrU = parcelRequire("aasrU");

var $8l3lF = parcelRequire("8l3lF");

var $kmSBH = parcelRequire("kmSBH");

var $gAkgF = parcelRequire("gAkgF");

var $6Xw13 = parcelRequire("6Xw13");

var $21zwQ = parcelRequire("21zwQ");
function $1037e0789aaee393$export$2e2bcd8739ae039({ id: id, items: items, shortcutItems: shortcutItems, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const setPeekMenuId = (0, $6Xw13.useSetPeekMenuId)();
    const shortcutItem = shortcutItems?.[id];
    if (shortcutItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aasrU.LinkMenuItem), {
        elemBefore: shortcutItem.icon,
        elemAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6L9RF))), {
            size: "small",
            label: formatMessage((0, $21zwQ.messages).linkExternalIconLabel),
            spacing: "spacious"
        }),
        onClick: onClick,
        href: (0, $8l3lF.getUrlMaybe)(shortcutItem) || '#',
        target: "_blank",
        children: shortcutItem.label
    });
    // Check if the item is in the items map
    const item = items[id];
    if (!item) throw new Error(`NavItem: No item found for id "${id}". Ensure the item is defined in appItems or globalItems.`);
    if ((0, $gAkgF.isCustomItemConfig)(item)) // If the item is a custom item, render it directly
    return /*#__PURE__*/ (0, $gt9Am.jsx)(item.Component, {
        onPeek: ()=>setPeekMenuId(id),
        isInMoreMenu: true,
        onClick: onClick
    });
    const moreItem = $1037e0789aaee393$var$buildMoreItem({
        id: id,
        item: item,
        onClick: onClick,
        onPeek: setPeekMenuId
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kmSBH.default), {
        id: id,
        item: moreItem,
        isInMoreMenu: true
    });
}
function $1037e0789aaee393$var$buildMoreItem({ id: id, item: item, onClick: onClick, onPeek: onPeek }) {
    if ((0, $gAkgF.isExpandableItemConfig)(item) || (0, $gAkgF.isFlyoutItemConfig)(item) || (0, $gAkgF.isObjectListFlyoutItemConfig)(item)) return $1037e0789aaee393$var$buildMoreItemFromExpandableOrFlyout({
        id: id,
        item: item,
        onClick: onClick,
        onPeek: onPeek
    });
    else if ((0, $gAkgF.isButtonItemConfig)(item) || (0, $gAkgF.isLinkItemConfig)(item)) return $1037e0789aaee393$var$buildMoreItemFromButtonOrLink({
        item: item,
        onClick: onClick
    });
    // If the item is not a button, link, expandable, or flyout, return as is
    return item;
}
function $1037e0789aaee393$var$buildMoreItemFromExpandableOrFlyout({ id: id, item: item, onClick: onClick, onPeek: onPeek }) {
    const { elemBefore: elemBefore, label: label } = item;
    const onClickActual = $1037e0789aaee393$var$combineHandlerAndActions(// ExpandableItemConfig['onClick'] has a third parameter we're not currently providing
    item.onClick, onClick, onPeek && (()=>onPeek(id)));
    // If the item is in the more menu and is an expandable or flyout item, render as a button with peek
    return {
        type: 'button',
        elemBefore: elemBefore,
        label: label,
        onClick: onClickActual
    };
}
function $1037e0789aaee393$var$buildMoreItemFromButtonOrLink({ item: item, onClick: onClick }) {
    const onClickActual = $1037e0789aaee393$var$combineHandlerAndActions(item.onClick, onClick);
    return {
        ...item,
        // Remove props that are not appropriate for the more menu
        actions: undefined,
        actionsOnHover: undefined,
        elemAfter: undefined,
        labelElem: undefined,
        onClick: onClickActual
    };
}
const $1037e0789aaee393$var$combineHandlerAndActions = (handler, ...actions)=>(...args)=>{
        handler?.(...args);
        actions.forEach((action)=>{
            action?.();
        });
    };

});
parcelRegister("21zwQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cb5a92fdd9bf4346$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $cb5a92fdd9bf4346$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    linkExternalIconLabel: {
        id: 'navigation.global-side-navigation.more-menu-item.link-external-item-label',
        description: 'Label for the link external icon',
        defaultMessage: 'Open external link icon'
    }
});

});



parcelRegister("GsKHX", function(module, exports) {

$parcel$export(module.exports, "HideFromSidebarButton", () => $c2cfce68c8b127e9$export$48ac5b0d18731d0f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $8xh4x = parcelRequire("8xh4x");

var $kRcOu = parcelRequire("kRcOu");

var $4frkm = parcelRequire("4frkm");

var $3rze2 = parcelRequire("3rze2");
function $c2cfce68c8b127e9$export$48ac5b0d18731d0f() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { dropIndicator: dropIndicator, dropTargetRef: dropTargetRef, moreButtonRef: moreButtonRef } = (0, $3rze2.useMoreMenuDragAndDrop)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kRcOu.ButtonMenuItem), {
        elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8xh4x))), {
            label: ""
        }),
        ref: moreButtonRef,
        dropIndicator: dropIndicator,
        visualContentRef: dropTargetRef,
        children: formatMessage((0, $4frkm.messages).hideFromSidebar)
    });
}

});
parcelRegister("8xh4x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c90f995a462686dc43276b76786a54f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $636ea5f65e46242d$var$_react = $636ea5f65e46242d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $636ea5f65e46242d$var$_baseNew = $636ea5f65e46242d$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $636ea5f65e46242d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Intended uses: unwatch page in Confluence, hide password in text field, and unfollow in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $636ea5f65e46242d$var$EyeOpenStrikethroughIcon = (props)=>/*#__PURE__*/ $636ea5f65e46242d$var$_react.default.createElement($636ea5f65e46242d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zm8.74 10.86 1.24 1.24A8.5 8.5 0 0 1 8 14C4.43 14 1.32 11.77.17 8.62c-.15-.4-.15-.84 0-1.24a8 8 0 0 1 1.51-2.53l1.06 1.06a6.5 6.5 0 0 0-1.16 1.98.3.3 0 0 0 0 .21c.93 2.56 3.48 4.4 6.42 4.4q.62 0 1.21-.11M8 2a8.5 8.5 0 0 0-2.45.36L6.79 3.6q.59-.1 1.21-.1c2.94 0 5.49 1.85 6.42 4.4a.3.3 0 0 1 0 .21 6.5 6.5 0 0 1-1.16 1.98l1.06 1.06a8 8 0 0 0 1.51-2.53c.15-.4.15-.84 0-1.24C14.68 4.23 11.57 2 8 2"/>`
    }, props));
$636ea5f65e46242d$var$EyeOpenStrikethroughIcon.displayName = 'EyeOpenStrikethroughIcon';
var $636ea5f65e46242d$var$_default = module.exports.default = $636ea5f65e46242d$var$EyeOpenStrikethroughIcon;

});

parcelRegister("4frkm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5478853a7ee76d4b$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $5478853a7ee76d4b$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    hideFromSidebar: {
        id: 'navigation.global-side-navigation.more-menu.hide-from-sidebar.label',
        description: 'Label on Hide from sidebar button in the side navigation. Button appears in place of the More menu when items are being dragged.',
        defaultMessage: 'Hide from sidebar'
    }
});

});

parcelRegister("3rze2", function(module, exports) {

$parcel$export(module.exports, "useMoreMenuDragAndDrop", () => $b5792399eb3a66c4$export$b4c5199e460b5544);

var $eJOHy = parcelRequire("eJOHy");

var $2GdJz = parcelRequire("2GdJz");

var $52lff = parcelRequire("52lff");

var $g2wqm = parcelRequire("g2wqm");

var $2KHoH = parcelRequire("2KHoH");
function $b5792399eb3a66c4$export$b4c5199e460b5544() {
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $2KHoH.useOptions)();
    const { dropIndicator: dropIndicator, dropTargetRef: dropTargetRef } = (0, $2GdJz.useMenuItemDragAndDrop)({
        // If the More menu will not be shown (e.g. no hidden items), we shouldn't set up drag and drop
        ...l1DragAndDropEnabled && {
            dropTarget: {
                getData: ()=>(0, $52lff.getMoreMenuData)(),
                getOperations: ()=>({
                        combine: 'available'
                    }),
                canDrop: ({ source: source })=>{
                    return (0, $52lff.isL1ItemData)(source.data) && source.data.isHideable;
                }
            }
        }
    });
    const registry = (0, $g2wqm.useElementRegistry)();
    const registrationRef = (0, $eJOHy.useRef)(null);
    const moreButtonRef = (0, $eJOHy.useCallback)((element)=>{
        if (!element) {
            registrationRef.current?.();
            registrationRef.current = null;
            return;
        }
        // Unregister previous element if exists
        if (registrationRef.current) registrationRef.current();
        // Register the new element with the registry
        registrationRef.current = registry.registerMoreMenuItem(element);
    }, [
        registrationRef,
        registry
    ]);
    return {
        dropIndicator: dropIndicator,
        dropTargetRef: dropTargetRef,
        moreButtonRef: moreButtonRef
    };
}

});



parcelRegister("9yMD5", function(module, exports) {

$parcel$export(module.exports, "useRecentNavItem", () => $13b1019ff0380163$export$df1ef6bc89e1ae21);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $lers0 = parcelRequire("lers0");

var $2IWvf = parcelRequire("2IWvf");


var $21m5n = parcelRequire("21m5n");
const $13b1019ff0380163$var$elemBefore = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2IWvf))), {
    label: ""
});
function $13b1019ff0380163$export$df1ef6bc89e1ae21(forYou) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // Some type magic so we can get the dependencies right for the memo and keep TypeScript happy.
    // Only use this constant when `forYou.hideRecents` is false.
    const recentShown = forYou;
    return (0, $eJOHy.useMemo)(()=>{
        if (forYou.hideRecents) return [];
        else {
            const actions = recentShown.viewAllRecentsUrl ? [
                {
                    elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lers0))), {
                        label: ''
                    }),
                    label: formatMessage((0, $21m5n.messages).viewAllRecentItemsLabel),
                    href: recentShown.viewAllRecentsUrl,
                    onClick: recentShown.viewAllRecentsOnClick
                }
            ] : recentShown.viewAllRecentsOnClick && [
                {
                    elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lers0))), {
                        label: ''
                    }),
                    label: formatMessage((0, $21m5n.messages).viewAllRecentItemsLabel),
                    onClick: recentShown.viewAllRecentsOnClick
                }
            ];
            const filterConfig = recentShown.recentsFilters ? {
                filters: recentShown.recentsFilters
            } : undefined;
            const value = {
                type: 'object-list-flyout',
                elemBefore: $13b1019ff0380163$var$elemBefore,
                label: formatMessage((0, $21m5n.messages).label),
                actions: actions,
                filterConfig: filterConfig,
                isSearchable: recentShown.recentsIsSearchable,
                searchPlaceholder: formatMessage((0, $21m5n.messages).searchPlaceholder),
                testId: (0, $c67599cf3de7177d$export$cfead128731b1701),
                useItems: recentShown.useRecentItems
            };
            return [
                [
                    recentShown.recentsMenuItemId ?? 'global.sidebar.recent',
                    value
                ]
            ];
        }
    }, [
        forYou.hideRecents,
        formatMessage,
        recentShown.recentsFilters,
        recentShown.recentsIsSearchable,
        recentShown.recentsMenuItemId,
        recentShown.useRecentItems,
        recentShown.viewAllRecentsOnClick,
        recentShown.viewAllRecentsUrl
    ]);
}

});
const $c67599cf3de7177d$export$cfead128731b1701 = 'gsn-recent';

parcelRegister("21m5n", function(module, exports) {

$parcel$export(module.exports, "messages", () => $797f226b41e410b0$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $797f226b41e410b0$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-side-navigation.recents.label',
        description: 'Label on Recent button in the side navigation. Shows a flyout with recent items.',
        defaultMessage: 'Recent'
    },
    searchPlaceholder: {
        id: 'navigation.global-side-navigation.recentsSearchPlaceholder',
        description: 'Placeholder for the search input in the recents flyout list.',
        defaultMessage: 'Search recent items'
    },
    viewAllRecentItemsLabel: {
        id: 'navigation.global-side-navigation.recents.viewAllRecentsLabel',
        description: 'Label on View all recent items button in the recents flyout list.',
        defaultMessage: 'View all recent items'
    }
});

});


parcelRegister("4l66K", function(module, exports) {

$parcel$export(module.exports, "useStarredNavItem", () => $165ab46a9cf07adb$export$80b87278b6bf3ebc);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $lers0 = parcelRequire("lers0");

var $1jsTl = parcelRequire("1jsTl");


var $9lmre = parcelRequire("9lmre");
const $165ab46a9cf07adb$var$elemBefore = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1jsTl))), {
    label: ""
});
function $165ab46a9cf07adb$export$80b87278b6bf3ebc(forYou) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // Some type magic so we can get the dependencies right for the memo and keep TypeScript happy.
    // Only use this constant when `forYou.hideStarred` is false.
    const starredShown = forYou;
    return (0, $eJOHy.useMemo)(()=>{
        if (forYou.hideStarred) return [];
        else {
            const actions = starredShown.viewAllStarredUrl ? [
                {
                    elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lers0))), {
                        label: ''
                    }),
                    label: formatMessage((0, $9lmre.messages).viewAllStarredItemsLabel),
                    href: starredShown.viewAllStarredUrl,
                    onClick: starredShown.viewAllStarredOnClick
                }
            ] : starredShown.viewAllStarredOnClick && [
                {
                    elemBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lers0))), {
                        label: ''
                    }),
                    label: formatMessage((0, $9lmre.messages).viewAllStarredItemsLabel),
                    onClick: starredShown.viewAllStarredOnClick
                }
            ];
            const filterConfig = starredShown.starredFilters ? {
                filters: starredShown.starredFilters
            } : undefined;
            const value = {
                type: 'object-list-flyout',
                elemBefore: $165ab46a9cf07adb$var$elemBefore,
                label: formatMessage((0, $9lmre.messages).label),
                actions: actions,
                filterConfig: filterConfig,
                isSearchable: starredShown.starredIsSearchable,
                searchPlaceholder: formatMessage((0, $9lmre.messages).searchPlaceholder),
                testId: (0, $566610a84141684e$export$d8547b5f8547ae9a),
                useItems: starredShown.useStarredItems
            };
            return [
                [
                    starredShown.starredMenuItemId ?? 'global.sidebar.starred',
                    value
                ]
            ];
        }
    }, [
        forYou.hideStarred,
        formatMessage,
        starredShown.starredFilters,
        starredShown.starredIsSearchable,
        starredShown.starredMenuItemId,
        starredShown.useStarredItems,
        starredShown.viewAllStarredOnClick,
        starredShown.viewAllStarredUrl
    ]);
}

});
const $566610a84141684e$export$d8547b5f8547ae9a = 'gsn-starred';
const $566610a84141684e$export$838ebd0369d69280 = 'gsn-starred-hidden';

parcelRegister("9lmre", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bafedc410e94deaa$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $bafedc410e94deaa$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        id: 'navigation.global-side-navigation.starred.label',
        description: 'Label on Starred button in the side navigation. Shows a flyout with starred items.',
        defaultMessage: 'Starred'
    },
    searchPlaceholder: {
        id: 'navigation.global-side-navigation.starredSearchPlaceholder',
        description: 'Placeholder for the search input in the starred flyout list.',
        defaultMessage: 'Search starred items'
    },
    viewAllStarredItemsLabel: {
        id: 'navigation.global-side-navigation.starred.viewAllStarredLabel',
        description: 'Label on View all starred items button in the starred flyout list.',
        defaultMessage: 'View all starred items'
    }
});

});




parcelRegister("6VUpl", function(module, exports) {

$parcel$export(module.exports, "getForYouConfig", () => $507c6bfc6023e77b$export$7929fceb464f62e7);
function $507c6bfc6023e77b$export$7929fceb464f62e7() {
    return {
        hideForYou: true,
        hideRecents: true,
        hideStarred: true
    };
}

});


parcelRegister("lTExG", function(module, exports) {

$parcel$export(module.exports, "GSNForOtherSidebars", () => $af8f2e8e7500cecf$export$8c6d29ef23f67ed7);

var $eJOHy = parcelRequire("eJOHy");

var $5DOjx = parcelRequire("5DOjx");

var $6VUpl = parcelRequire("6VUpl");
const $af8f2e8e7500cecf$var$forYouConfig = (0, $6VUpl.getForYouConfig)();
function $af8f2e8e7500cecf$export$8c6d29ef23f67ed7({ sidebarId: sidebarId }) {
    /*
	  TODO:
		    1. render other sidebars within `postMainElement`
			2. disable customisation
			3. Return GSN component
	*/ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DOjx.GlobalSideNavigation), {
        app: "jira",
        appLabel: "Jira",
        customizationStore: "local",
        forYou: $af8f2e8e7500cecf$var$forYouConfig,
        items: {},
        testId: "nav-platform-integration-sidebar.ui.jira-other-sidebars"
    });
}

});


parcelRegister("7b66t", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c0c17209c0996f78$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $c0c17209c0996f78$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    sidebarNavigation: {
        "id": "page-container-v2.common.sidebar.sidebar-navigation",
        "defaultMessage": "Sidebar navigation"
    },
    sideBarPanelSplitterLabel: {
        "id": "page-container-v2.common.sidebar.side-bar-panel-splitter-label",
        "defaultMessage": "Resize side navigation panel"
    },
    globalInviteButtonLabel: {
        "id": "page-container-v2.common.sidebar.global-invite-button-label",
        "defaultMessage": "Invite people"
    }
});

});

parcelRegister("kP5Da", function(module, exports) {

$parcel$export(module.exports, "AsyncResizeButtonTooltip", () => $ff4b46e40c22620c$export$e12f5b3a390577de);

var $gzcjr = parcelRequire("gzcjr");

const $ff4b46e40c22620c$export$e12f5b3a390577de = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("effY9")), {
    ssr: false,
    moduleId: "./src/packages/page-container-v2/src/common/ui/sidebar/resize-button-tooltip/main.tsx"
});

});
parcelRegister("effY9", function(module, exports) {

let $a5eeda8cec773868$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a5eeda8cec773868$var$load("7XiwF").then(()=>parcelRequire('bLk1w'));

});



parcelRegister("dtNAy", function(module, exports) {

$parcel$export(module.exports, "TopNav", () => $521256873ada116f$export$41d0d88a6b0e456f);

var $eJOHy = parcelRequire("eJOHy");

var $hOBHo = parcelRequire("hOBHo");

var $03pp6 = parcelRequire("03pp6");

var $kO1ht = parcelRequire("kO1ht");

var $kvNRH = parcelRequire("kvNRH");

var $bDJm5 = parcelRequire("bDJm5");

var $gjMiF = parcelRequire("gjMiF");


var $dPMMf = parcelRequire("dPMMf");

var $1KdDN = parcelRequire("1KdDN");

var $aqnJa = parcelRequire("aqnJa");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $1khoQ = parcelRequire("1khoQ");

var $gdLX3 = parcelRequire("gdLX3");

var $hTuwP = parcelRequire("hTuwP");

var $6zXPf = parcelRequire("6zXPf");

var $dzLcO = parcelRequire("dzLcO");

var $ch9En = parcelRequire("ch9En");

var $6dnL8 = parcelRequire("6dnL8");

var $16sa1 = parcelRequire("16sa1");

var $7wkp5 = parcelRequire("7wkp5");

var $kxYB3 = parcelRequire("kxYB3");

var $9bSFg = parcelRequire("9bSFg");
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $521256873ada116f$var$APP_NAVIGATION_TRACE_KEY = 'app_navigation';
const $521256873ada116f$var$LegacyPageNavigationStyles = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #page-body { width: 100vw; max-width: 100%; }
                    #cloneissueprogressform { margin-top: ${(0, $dPMMf.gridSize) * 3}px; }
                    [data-testid="Content"] {margin-top: calc(${(0, $bf1c59a4164b2d18$export$d60454526e2281af)})!important;}
                    #view-projects-content { margin-top: calc(-1 * ${(0, $bf1c59a4164b2d18$export$d60454526e2281af)}); } /* admin project dir hack */
                `
        }
    });
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 * It's only added once the component is rendered client-side.
 */ const $521256873ada116f$var$TEST_ID = 'page-layout.top-nav';
function $521256873ada116f$var$NewTopNav() {
    const { shouldRender: shouldRender } = (0, $gdLX3.useTopNavState)();
    const theme = (0, $bDJm5.useNav4Theme)();
    // Signal that Nav4 has been seen. Memoized, so it's safe to use it like this.
    if ((0, $7jTnu.fg)('jira_nav_version_exposure')) (0, $hTuwP.sendNavExposure)({
        componentName: 'nav4'
    });
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav4.topNav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "topNavigationSkipLink",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wkp5.TopNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($521256873ada116f$var$LegacyPageNavigationStyles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.TopNavigation), {
        isFixed: true,
        testId: $521256873ada116f$var$TEST_ID,
        theme: theme
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kvNRH.AtlassianNavigationStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "navigation.atlassian-navigation",
        packageName: "jiraPageContainerV2",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderNew), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gjMiF.JiraAtlassianNavigationSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9bSFg.AsyncAtlassianNavigation), null)))));
}
/**
 * This has been inlined from `@atlassian/jira-common-constants/src/page-layout`
 * because it isn't used anywhere else, and to prevent new usage.
 */ const $521256873ada116f$var$HORIZONTAL_GLOBAL_NAV_HEIGHT = 56;
/**
 * Implements a responsive top navigation bar that adjusts for fullscreen view and renders
 * based on application state. It ensures seamless navigation experience across different
 * sections of the application while handling errors gracefully and tracking performance.
 */ function $521256873ada116f$var$OldTopNav() {
    const fullscreenRef = (0, $eJOHy.useRef)(null);
    const { isFullscreen: isFullscreen } = (0, $1khoQ.useIsFullscreen)(fullscreenRef.current);
    const { shouldRender: shouldRender } = (0, $gdLX3.useTopNavState)();
    const onFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $kO1ht.EXPERIENCE_NAVIGATION_TOP_MAIN)
    });
    if ((0, $7jTnu.fg)('jira_nav_version_exposure')) (0, $hTuwP.sendNavExposure)({
        componentName: 'nav3'
    });
    const height = isFullscreen ? 0 : $521256873ada116f$var$HORIZONTAL_GLOBAL_NAV_HEIGHT;
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "top-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "topNavigationSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wkp5.TopNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($521256873ada116f$var$LegacyPageNavigationStyles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kxYB3.ZIndexWrapper), {
        zIndex: (0, $dPMMf.layers).navigation,
        // @ts-expect-error - TS2322 - Type '{ children: Element; zIndex: 200; top: string; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, any>, any, any>> & Readonly<...> & Readonly<...>'.
        top: (0, $dzLcO.UNSAFE_DO_NOT_USE_BANNER_HEIGHT),
        "data-fullscreen-id": "fullscreen.page-container-v2.topnav",
        ref: fullscreenRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.TopNavigation), {
        isFixed: true,
        height: height,
        id: "ak-jira-navigation"
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kvNRH.AtlassianNavigationStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "navigation.atlassian-navigation",
        packageName: "jiraPageContainer",
        fallback: "flag",
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gjMiF.JiraAtlassianNavigationSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavTopPerformanceMark), {
        metricKey: (0, $hOBHo.NAVIGATION_TOP_MARKS).bundleLoadStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dnL8.RenderTracerMark), {
        type: "start",
        traceKey: $521256873ada116f$var$APP_NAVIGATION_TRACE_KEY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9bSFg.AsyncAtlassianNavigation), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dnL8.RenderTracerMark), {
        type: "end",
        traceKey: $521256873ada116f$var$APP_NAVIGATION_TRACE_KEY
    }))))));
}
const $521256873ada116f$export$41d0d88a6b0e456f = (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), $521256873ada116f$var$NewTopNav, $521256873ada116f$var$OldTopNav);

});
parcelRegister("kvNRH", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigationStart", () => $ecb494ba00cee566$export$831e6a6e875b5ef8);

var $eJOHy = parcelRequire("eJOHy");

var $8Uqf3 = parcelRequire("8Uqf3");

var $dpFVo = parcelRequire("dpFVo");


var $il8Fk = parcelRequire("il8Fk");

var $TLYhw = parcelRequire("TLYhw");

var $gCY1z = parcelRequire("gCY1z");

var $kO1ht = parcelRequire("kO1ht");
const $ecb494ba00cee566$export$831e6a6e875b5ef8 = ()=>{
    const [{ location: location }] = (0, $gCY1z.useRouter)();
    const { setAppStartWithAppId: setAppStartWithAppId } = (0, $il8Fk.useSpaStateActions)();
    const pageId = (0, $TLYhw.usePageId)();
    const startRef = (0, $eJOHy.useRef)({
        location: location,
        startTime: Date.now()
    });
    (0, $eJOHy.useMemo)(()=>{
        if (location !== startRef.current.location) startRef.current = {
            location: location,
            startTime: Date.now()
        };
    }, [
        location
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        setAppStartWithAppId((0, $ceaa13d70a0542eb$export$3a54edb6ba4daa82), startRef.current.startTime);
    }, [
        location,
        setAppStartWithAppId
    ]);
    return (0, $dpFVo.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Uqf3.ExperienceStart), {
        experience: (0, $kO1ht.EXPERIENCE_NAVIGATION_TOP_MAIN),
        analyticsSource: "atlassian-navigation",
        experienceId: pageId
    });
};

});

parcelRegister("bDJm5", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $c4cdf8cd9afe6fcf$export$93d4e7f90805808f);
$parcel$export(module.exports, "useNav4Theme", () => $c4cdf8cd9afe6fcf$export$b761e7abf0bdf352);

var $eJOHy = parcelRequire("eJOHy");

var $3mrb5 = parcelRequire("3mrb5");

var $fMf5E = parcelRequire("fMf5E");
var $5M7r5 = parcelRequire("5M7r5");

var $575d2 = parcelRequire("575d2");

var $cxQGT = parcelRequire("cxQGT");

var $3PoVU = parcelRequire("3PoVU");

var $lDk1y = parcelRequire("lDk1y");
const $c4cdf8cd9afe6fcf$var$caseInsensitiveEquals = (one, two)=>one.toLowerCase() === two.toLowerCase();
const $c4cdf8cd9afe6fcf$var$calculateBackground = (backgroundColor, isDarkMode)=>{
    // White is a proxy for 'default' when setting accent colours, we really want to default to 'elevation.surface'
    if ($c4cdf8cd9afe6fcf$var$caseInsensitiveEquals(backgroundColor, '#ffffff')) {
        // getTokenValue doesn't work in SSR thus hardcode, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
        const fallback = isDarkMode ? '#1d2125' : '#ffffff';
        // Can't be getToken() as AK Nav needs a hex string. It parses it to determine the correct text color
        return (0, $fMf5E.default)('elevation.surface', fallback);
    }
    return isDarkMode ? (0, $lDk1y.capLightness)(backgroundColor, 35) : backgroundColor;
};
const $c4cdf8cd9afe6fcf$var$useIsDarkThemeResolver = ()=>{
    // The best source of theme info. But doesn't work in SSR, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
    const { colorMode: colorMode } = (0, $5M7r5.default)();
    // This works in SSR, but we need the browser to resolve 'auto', so we are wrong in SSR if 'auto' resolves to 'dark'
    const { theme: preference } = (0, $cxQGT.useThemePreference)();
    return false ? preference === 'dark' : colorMode === 'dark';
};
const $c4cdf8cd9afe6fcf$export$93d4e7f90805808f = ()=>{
    const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $575d2.useTheme)();
    const isDarkMode = $c4cdf8cd9afe6fcf$var$useIsDarkThemeResolver();
    const bg = (0, $eJOHy.useMemo)(()=>$c4cdf8cd9afe6fcf$var$calculateBackground(backgroundColor, isDarkMode), [
        backgroundColor,
        isDarkMode
    ]);
    (0, $eJOHy.useEffect)(()=>{
        (0, $3PoVU.addThemeColor)(bg);
    }, [
        bg
    ]);
    if (!usesCustomColours) return undefined;
    return (0, $3mrb5.generateTheme)({
        name: 'jira',
        backgroundColor: bg,
        highlightColor: highlightColor
    });
};
const $c4cdf8cd9afe6fcf$export$b761e7abf0bdf352 = ()=>{
    /**
   * The colors chosen by the site admin in the site settings
   */ const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $575d2.useTheme)();
    /**
   * Whether the user is currently using dark mode,
   * or their configured preference if this is SSR.
   */ const isDarkMode = $c4cdf8cd9afe6fcf$var$useIsDarkThemeResolver();
    /**
   * The adjusted background color.
   *
   * When the user is in dark mode, the lightness of the background color is capped.
   */ const bg = (0, $eJOHy.useMemo)(()=>$c4cdf8cd9afe6fcf$var$calculateBackground(backgroundColor, isDarkMode), [
        backgroundColor,
        isDarkMode
    ]);
    /**
   * Creates / updates a theme-color meta tag:
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta/name/theme-color
   *
   * Some browsers will use this to change the color of their UI.
   */ (0, $eJOHy.useEffect)(()=>{
        (0, $3PoVU.addThemeColor)(bg);
    }, [
        bg
    ]);
    if (!usesCustomColours) return undefined;
    return {
        backgroundColor: bg,
        highlightColor: highlightColor
    };
};

});
parcelRegister("3PoVU", function(module, exports) {

$parcel$export(module.exports, "addThemeColor", () => $bcdd7f881bea77b5$export$7b20d133831b2b0f);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
const $bcdd7f881bea77b5$var$getMetaNode = (name)=>document.querySelector(`meta[name="${name}"]`);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $bcdd7f881bea77b5$var$getHead = ()=>document.head || document.querySelector('head');
const $bcdd7f881bea77b5$export$7b20d133831b2b0f = (content)=>{
    if (!content || typeof document === 'undefined' || false) return;
    const existingMeta = $bcdd7f881bea77b5$var$getMetaNode('theme-color');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = content;
    if (existingMeta) existingMeta.replaceWith?.(meta);
    else {
        const head = $bcdd7f881bea77b5$var$getHead();
        if (head) head.appendChild?.(meta);
    }
};

});

parcelRegister("lDk1y", function(module, exports) {

$parcel$export(module.exports, "capLightness", () => $084b53f1ef2a6c95$export$8b5544bab97b10dd);
const $084b53f1ef2a6c95$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $084b53f1ef2a6c95$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $084b53f1ef2a6c95$var$rgbFromHex = (input)=>{
    const fullHex = $084b53f1ef2a6c95$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $084b53f1ef2a6c95$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $084b53f1ef2a6c95$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $084b53f1ef2a6c95$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $084b53f1ef2a6c95$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $084b53f1ef2a6c95$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $084b53f1ef2a6c95$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $084b53f1ef2a6c95$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $084b53f1ef2a6c95$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $084b53f1ef2a6c95$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $084b53f1ef2a6c95$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $084b53f1ef2a6c95$var$rgbToLch = (rgb)=>$084b53f1ef2a6c95$var$labToLch($084b53f1ef2a6c95$var$xyzToLab($084b53f1ef2a6c95$var$rgbToXyz(rgb)));
const $084b53f1ef2a6c95$var$lchToRgb = (lch)=>$084b53f1ef2a6c95$var$xyzToRgb($084b53f1ef2a6c95$var$labToXyz($084b53f1ef2a6c95$var$lchToLab(lch)));
const $084b53f1ef2a6c95$export$8b5544bab97b10dd = (color, capPercent)=>{
    const rgb = $084b53f1ef2a6c95$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $084b53f1ef2a6c95$var$rgbToLch(rgb);
    if (lch.l > capPercent) lch.l = $084b53f1ef2a6c95$var$clamp(capPercent, 0, 100);
    return $084b53f1ef2a6c95$var$rgbToHex($084b53f1ef2a6c95$var$lchToRgb(lch));
};

});


parcelRegister("gjMiF", function(module, exports) {

$parcel$export(module.exports, "JiraAtlassianNavigationSkeleton", () => $44487e9ee0b8d1f5$export$38e532bc6b824200);

var $eJOHy = parcelRequire("eJOHy");

var $gSDm2 = parcelRequire("gSDm2");

var $h1VbR = parcelRequire("h1VbR");

var $bDJm5 = parcelRequire("bDJm5");
const $44487e9ee0b8d1f5$export$38e532bc6b824200 = ()=>{
    const theme = (0, $bDJm5.useTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1VbR.default), {
        name: "top-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gSDm2.NavigationSkeleton), {
        theme: theme
    }));
};

});

parcelRegister("1khoQ", function(module, exports) {

$parcel$export(module.exports, "useIsFullscreen", () => $e8ffbbf61d2e2952$export$d397eccea5f37b0a);

var $eJOHy = parcelRequire("eJOHy");
const $e8ffbbf61d2e2952$var$fullscreenClassnameExists = (target)=>target?.classList.contains('fullscreen') ?? false;
const $e8ffbbf61d2e2952$export$d397eccea5f37b0a = (target)=>{
    const [isFullscreen, setIsFullscreen] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        const handleFullscreen = ()=>{
            setIsFullscreen($e8ffbbf61d2e2952$var$fullscreenClassnameExists(target));
        };
        const mutationObserver = new MutationObserver(handleFullscreen);
        if (target) mutationObserver.observe(target, {
            attributes: true
        });
        return ()=>mutationObserver.disconnect();
    }, [
        target
    ]);
    return {
        isFullscreen: isFullscreen
    };
};

});

parcelRegister("gdLX3", function(module, exports) {

$parcel$export(module.exports, "useTopNavState", () => $a16764cec6e50c95$export$bccbd45ab793bd09);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $fZsy4 = parcelRequire("fZsy4");
const $a16764cec6e50c95$var$useTopNav = (0, $iJq0l.createHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>({
            ...state.topNavigation,
            shouldRender: !state.isChromeless
        })
});
const $a16764cec6e50c95$export$bccbd45ab793bd09 = ()=>{
    const [state] = $a16764cec6e50c95$var$useTopNav();
    return state;
};

});

parcelRegister("hTuwP", function(module, exports) {

$parcel$export(module.exports, "sendNavExposure", () => $83dd387850082fa0$export$4d75b96ec704d87d);

var $5PQOA = parcelRequire("5PQOA");

var $7jTnu = parcelRequire("7jTnu");

var $iyTaR = parcelRequire("iyTaR");

var $2Mqjh = parcelRequire("2Mqjh");
const $83dd387850082fa0$export$4d75b96ec704d87d = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))($83dd387850082fa0$var$_sendNavExposure, (p)=>p.componentName);
/**
 * Note: The componentName is being used as the actionSubject.
 *       When a new navigation-version is released, it will require registering
 *       a new GASv3 event and a new trait. THIS IS BY DESIGN, as the creation
 *       of new navigation systems is infrequent (every 2-3 years).
 */ function $83dd387850082fa0$var$_sendNavExposure(params) {
    const { componentName: componentName } = params;
    if ((0, $7jTnu.fg)('jira_mobile_opt_out_nav4_trait')) {
        const nav4RolloutStage = (0, $iyTaR.getNav4Rollout)().stage;
        /**
		 * Prevent mobile nav4 views from registering the trait as having seen Nav4
		 * This is because mobile users have only seen a small subset of Nav4
		 */ if (nav4RolloutStage === 'mobile') // Return the component name to help memoize do it's job
        return componentName;
    }
    // This analytics event updates it's corresponding TAP trait,
    // once the GAS event is registered, and then the TAP trait is registered.
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        client.getInstance().sendTrackEvent({
            actionSubject: componentName,
            action: 'viewed',
            source: 'navExposure',
            attributes: {}
        });
    });
    // Return the component name to help memoize do it's job
    return componentName;
}

});

parcelRegister("9bSFg", function(module, exports) {

$parcel$export(module.exports, "AsyncAtlassianNavigation", () => $7b51abe6795970ed$export$932edb7b1b20d079);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8xgJ5 = parcelRequire("8xgJ5");

var $96SSt = parcelRequire("96SSt");

var $gjMiF = parcelRequire("gjMiF");

var $cJAh3 = parcelRequire("cJAh3");


var $jrulJ = parcelRequire("jrulJ");

var $2dBpR = parcelRequire("2dBpR");

var $dydef = parcelRequire("dydef");
const $7b51abe6795970ed$export$932edb7b1b20d079 = ()=>{
    const topNavEntryPointReference = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$bec6dca2e63de4ae));
    (0, $eJOHy.useState)(()=>{
        if (!false && topNavEntryPointReference) /* @ts-expect-error - TS2339 - We're using JSResourceReference from @atlassian/react-async. */ (0, $8xgJ5.topNavigationEntryPoint).root.onComplete(()=>{
            (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $cJAh3.JS_EVAL_START))) {
                (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                break;
            }
        });
        return undefined;
    });
    return topNavEntryPointReference ? // There is already a Placeholder in parent
    // remove this one when EntryPointPlaceholder merges with Placeholder
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gjMiF.JiraAtlassianNavigationSkeleton), null),
        entryPointReference: topNavEntryPointReference
    }, topNavEntryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: topNavEntryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $96SSt.AtlassianNavigation), null);
};

});
parcelRegister("96SSt", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigation", () => $aadd0010df9e09c6$export$f66ccb39f60980e5);

var $eJOHy = parcelRequire("eJOHy");

var $ijkT7 = parcelRequire("ijkT7");

var $hOBHo = parcelRequire("hOBHo");

var $03pp6 = parcelRequire("03pp6");

var $87u0A = parcelRequire("87u0A");

var $gtcB9 = parcelRequire("gtcB9");

var $fhzEL = parcelRequire("fhzEL");

var $4PyXW = parcelRequire("4PyXW");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $7oY9g = parcelRequire("7oY9g");

var $fYeTG = parcelRequire("fYeTG");

var $cfwEM = parcelRequire("cfwEM");

var $h8yfz = parcelRequire("h8yfz");

var $6zXPf = parcelRequire("6zXPf");

var $hih5V = parcelRequire("hih5V");

var $2aY2d = parcelRequire("2aY2d");

var $qzoYE = parcelRequire("qzoYE");

var $iW0U8 = parcelRequire("iW0U8");

var $kEUB1 = parcelRequire("kEUB1");

var $cECwI = parcelRequire("cECwI");

var $lUto7 = parcelRequire("lUto7");

var $f2JN3 = parcelRequire("f2JN3");

var $ch9En = parcelRequire("ch9En");

var $9bIvg = parcelRequire("9bIvg");

var $aN4LZ = parcelRequire("aN4LZ");

var $bU7HL = parcelRequire("bU7HL");

var $bDJm5 = parcelRequire("bDJm5");

var $gjMiF = parcelRequire("gjMiF");

var $gg3l6 = parcelRequire("gg3l6");

var $edDe8 = parcelRequire("edDe8");

var $dgOrd = parcelRequire("dgOrd");

var $kjqBp = parcelRequire("kjqBp");

var $5kUfs = parcelRequire("5kUfs");

var $crIFg = parcelRequire("crIFg");

var $jILIS = parcelRequire("jILIS");

var $gWKt4 = parcelRequire("gWKt4");

var $et1RD = parcelRequire("et1RD");

var $6wuXc = parcelRequire("6wuXc");

var $kv0Iu = parcelRequire("kv0Iu");

var $2olUi = parcelRequire("2olUi");

var $6phAP = parcelRequire("6phAP");

var $caHVZ = parcelRequire("caHVZ");
const $aadd0010df9e09c6$var$isSPA = ()=>{
    if (false) return false;
    if (typeof window !== 'undefined') return window.__SPA__;
    return false;
};
const $aadd0010df9e09c6$var$TopNavComponent = (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), $aadd0010df9e09c6$var$Nav4TopNav, $aadd0010df9e09c6$var$Nav3TopNav);
const $aadd0010df9e09c6$var$Nav4RolloutAnalyticsMaybeSync = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-concurrent-nav4-1'), (0, $9bIvg.Nav4RolloutAnalytics), (0, $h8yfz.default));
function $aadd0010df9e09c6$export$f66ccb39f60980e5() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aadd0010df9e09c6$var$TopNavComponent, null), (0, $7jTnu.fg)('jira_nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aadd0010df9e09c6$var$Nav4RolloutAnalyticsMaybeSync, null), (0, $7jTnu.fg)('jira_mobile_web_mvp_2_feature_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fYeTG.MobileWebExperimentExposure), null), (0, $7jTnu.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fYeTG.MobileWebExperimentViewPanelNewTenantsExposure), null), (0, $7jTnu.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fYeTG.MobileWebExperimentViewPanelExistingUserExposure), null));
}
function $aadd0010df9e09c6$var$Nav4TopNav() {
    const theme = (0, $bDJm5.useTheme)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const isMobileExperience = (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)();
    const nav4NavigationProps = (0, $eJOHy.useMemo)(()=>isMobileExperience ? {
            hideSideNavToggleButton: true,
            renderSearch: (0, $fYeTG.isMobileAndInViewPanelIterationExperiment)() ? (0, $kv0Iu.Search) : undefined,
            renderNotifications: (0, $fYeTG.isMobileAndInViewPanelIterationExperiment)() ? (0, $jILIS.Notifications) : undefined
        } : {
            renderAppSwitcher: (0, $aN4LZ.default),
            renderSearch: (0, $kv0Iu.Search),
            renderEditionAwareness: (0, $cfwEM.EditionAwareness),
            renderHelp: (0, $kjqBp.Help),
            renderNotifications: (0, $jILIS.Notifications),
            renderConversationAssistant: (0, $edDe8.ConversationAssistant),
            renderSettings: (0, $2olUi.Settings),
            renderProfile: (0, $et1RD.Profile),
            renderSignIn: (0, $6phAP.SignIn)
        }, [
        isMobileExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ijkT7.TopNav4), {
        renderProductHome: (0, $gWKt4.ProductHome),
        renderCreate: (0, $dgOrd.Create),
        renderNav4Notifications: (0, $caHVZ.Nav4NotificationsData),
        ...nav4NavigationProps,
        theme: theme,
        label: formatMessage((0, $crIFg.default).topNav)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6wuXc.NavigationRouterListener), null), isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fhzEL.default), null));
}
function $aadd0010df9e09c6$var$Nav3TopNav() {
    const topNavSegment = (0, $03pp6.useNavPerformanceMetrics)();
    topNavSegment.mark((0, $hOBHo.NAVIGATION_TOP_MARKS).renderStart);
    const cloudId = (0, $kEUB1.useCloudId)();
    const applicationPermissions = (0, $iW0U8.useApplicationPermissions)();
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const route = (0, $hih5V.useCurrentRoute)();
    const renderNavigation = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $7jTnu.fg)('jfp-magma-concurrent-fix-entrypoint-placeholder') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
            name: "atlassian-navigation-top-nav-3-placeholder",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gjMiF.JiraAtlassianNavigationSkeleton), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gg3l6.TopNav3Async), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gg3l6.TopNav3Async), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !isAnonymous && !(0, $7oY9g.default)('navigation.disable.prefetched.data.for.dropdowns') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kUfs.InitialDataLoader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gtcB9.RecommendationLoader), {
            recommendations: (0, $87u0A.recommendations)
        })))), [
        isAnonymous
    ]);
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const projectContext = (0, $2aY2d.useProjectContext)();
    const customData = (0, $eJOHy.useMemo)(()=>{
        return {
            route: routeName,
            projectType: projectContext?.data?.projectType ?? 'UNKNOWN',
            isSPA: $aadd0010df9e09c6$var$isSPA()
        };
    }, [
        routeName,
        projectContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bU7HL.NavigationSuccessTrackerForNav3), null, isAnonymous ? renderNavigation() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $qzoYE.RecentsContainer), {
        isGlobal: true,
        cloudId: cloudId,
        applicationPermissions: applicationPermissions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4PyXW.FavoritesContainer), {
        isGlobal: true,
        applicationPermissions: applicationPermissions
    }, renderNavigation()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6wuXc.NavigationRouterListener), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavTopPerformanceMark), {
        metricKey: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavTopPerformanceReport), {
        customData: customData
    }), isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fhzEL.default), null));
}

});
parcelRegister("ijkT7", function(module, exports) {

$parcel$export(module.exports, "TopNav4", () => $1ff9eefd8d7d9ace$export$76799253f2c58923);

var $eJOHy = parcelRequire("eJOHy");

var $16sa1 = parcelRequire("16sa1");

var $1KdDN = parcelRequire("1KdDN");


var $hWeHP = parcelRequire("hWeHP");

var $7sLlL = parcelRequire("7sLlL");
function $1ff9eefd8d7d9ace$export$76799253f2c58923(props) {
    // This is defensive code to prevent making a request for data that will never be returned.
    // Only Customer Accounts have customer service access. These are non-Atlassian accounts considered
    // second-party party customers and should only have access to the JSM Help Center. They should
    // never have access to the regular Jira UI so should never see this top navigation. If we detect
    // that this is a customer account request we will not render the top navigation at all.
    // See https://jplat.atlassian.net/browse/BLU-7341 for context.
    if ((0, $hWeHP.default)('ajs-account-type') === 'customer') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "atlaskit-atlassian-navigation-nav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "AtlaskitAtlassianNavigationNav4",
        packageName: (0, $982bab3922601ed3$export$b8b9d90f9e5bd72b),
        teamName: (0, $982bab3922601ed3$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7sLlL.AtlassianNavigationNav4), props)));
}

});
const $982bab3922601ed3$export$b8b9d90f9e5bd72b = 'jiraAtlassianNavigationNav4';
const $982bab3922601ed3$export$d57b6b390e78d90f = 'jira-cosmos';
const $982bab3922601ed3$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $982bab3922601ed3$export$eed606b4351295d7 = 'login';
const $982bab3922601ed3$export$35e541d26a145a7c = 'logout';

parcelRegister("7sLlL", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigationNav4", () => $2d59af443761ac7b$export$40fab2fde5132498);

var $54NUw = parcelRequire("54NUw");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cw4We = parcelRequire("cw4We");
var $dKgZn = parcelRequire("dKgZn");
var $ARVpU = parcelRequire("ARVpU");
var $2qG4O = parcelRequire("2qG4O");

var $iQQxP = parcelRequire("iQQxP");

var $1qb7e = parcelRequire("1qb7e");

var $2Of18 = parcelRequire("2Of18");

var $lRq8t = parcelRequire("lRq8t");

var $8J0lu = parcelRequire("8J0lu");




var $2LcvY = parcelRequire("2LcvY");

var $iyTaR = parcelRequire("iyTaR");

var $5Q9JR = parcelRequire("5Q9JR");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");

var $9FYIg = parcelRequire("9FYIg");

var $cECwI = parcelRequire("cECwI");

var $f58lN = parcelRequire("f58lN");

var $7jTnu = parcelRequire("7jTnu");

var $kyPau = parcelRequire("kyPau");

var $2qDaO = parcelRequire("2qDaO");

var $8aPak = parcelRequire("8aPak");
function $2d59af443761ac7b$export$40fab2fde5132498(props) {
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $8J0lu.topNav4UIStateResource)); // This intermediate step is to avoid using a null queryReference.
    // Maybe this should be a skeleton? Or is that taken care of by the page-container-v2?
    return queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d59af443761ac7b$export$b2b29f12a28e3baa, {
        queryReference: queryReference,
        ...props
    });
}
function $2d59af443761ac7b$export$b2b29f12a28e3baa({ hideSideNavToggleButton: hideSideNavToggleButton, queryReference: queryReference, renderCreate: Create, renderHelp: Help, renderAppSwitcher: AppSwitcher, renderNotifications: Notifications, renderNav4Notifications: Nav4NotificationsData, renderConversationAssistant: ConversationAssistant, renderProductHome: ProductHome, renderSettings: Settings, renderSearch: Search, renderEditionAwareness: EditionAwareness }) {
    const data = (0, $j4oe4.usePreloadedQuery)((0, $54NUw.default), queryReference);
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const siteTitleData = (0, $8aPak.useSiteTitle)();
    const siteTitle = siteTitleData.shouldShow && siteTitleData.value || undefined;
    const attributes = (0, $eJOHy.useMemo)(()=>({
            navigationLayer: (0, $002870cfa80d64f4$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $95eb6070d868c1b7$export$793ed84f5e13fedc),
            navState: (0, $107c403b1827dc68$export$2bd315ece9f68967),
            stage: (0, $iyTaR.getNav4Rollout)().stage
        }), []);
    const onClickSideNavToggleButton = (0, $eJOHy.useCallback)((_, analyticsEvent, _attributes)=>{
        const payload = (0, $2LcvY.getSideNavToggleButtonAnalyticEventPayload)(_attributes?.isSideNavVisible, (0, $iyTaR.getNav4Rollout)().stage);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, payload);
    }, []);
    const renderNotificationsForNavVersion = (0, $eJOHy.useCallback)(()=>{
        if (Notifications !== undefined) {
            if (Nav4NotificationsData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Nav4NotificationsData, {
                queryReference: data
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Notifications, null);
        }
        return null;
    }, [
        Nav4NotificationsData,
        Notifications,
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG4O.TopNavStart), null, hideSideNavToggleButton ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Of18.OnboardingSpotlightMaybe), {
        spotlight: (0, $1qb7e.Nav4OnboardingComponentNames).JIRA_SIDEBAR_TOGGLE_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cw4We.SideNavToggleButton), {
        defaultCollapsed: data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, $5Q9JR.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT),
        onClick: onClickSideNavToggleButton,
        collapseLabel: formatMessage((0, $kyPau.messages).sideNavToggleButtonCollapseLabel),
        expandLabel: formatMessage((0, $kyPau.messages).sideNavToggleButtonExpandLabel)
    })), AppSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ProductHome, null), siteTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iQQxP.CustomTitle), null, siteTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ARVpU.TopNavMiddle), null, Search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Search, null), Create && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Create, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKgZn.TopNavEnd), null, (0, $7jTnu.fg)('jsm_gp_awareness_pill') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58lN.GpAwarenessPill), {
        analyticsOrigin: "navBar"
    }), EditionAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(EditionAwareness, null), !isAnonymous && ConversationAssistant && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ConversationAssistant, null), !isAnonymous && renderNotificationsForNavVersion(), Help && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Help, null), Settings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Settings, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qDaO.Nav4Profile), {
        queryReference: data
    })));
}

});
parcelRegister("f58lN", function(module, exports) {

$parcel$export(module.exports, "GpAwarenessPill", () => $1cf1a2633a5769f2$export$8c31c24d0f64d27a);

var $eJOHy = parcelRequire("eJOHy");

var $lw3Pj = parcelRequire("lw3Pj");

var $6CZxU = parcelRequire("6CZxU");

var $cPbpX = parcelRequire("cPbpX");
var $5Wv5g = parcelRequire("5Wv5g");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");

var $lzT4f = parcelRequire("lzT4f");

var $22xih = parcelRequire("22xih");

var $8q7lT = parcelRequire("8q7lT");

var $gOf4q = parcelRequire("gOf4q");

var $1LRl2 = parcelRequire("1LRl2");
var $9WpOs = parcelRequire("9WpOs");

var $8vyDv = parcelRequire("8vyDv");

var $a9ldn = parcelRequire("a9ldn");

var $lUto7 = parcelRequire("lUto7");

var $1KdDN = parcelRequire("1KdDN");

var $5g5cw = parcelRequire("5g5cw");

var $9HmCl = parcelRequire("9HmCl");


var $7jTnu = parcelRequire("7jTnu");

var $hYOCy = parcelRequire("hYOCy");
const $1cf1a2633a5769f2$export$8c31c24d0f64d27a = ({ analyticsOrigin: analyticsOrigin })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const accountId = (0, $8q7lT.useAccountId)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const appEditions = (0, $8vyDv.useAppEditions)();
    const { product: product } = (0, $5g5cw.useProductAndEdition)();
    const { gpEndDate: gpEndDate, gpEndDateDetails: gpEndDateDetails, loading: gpEndDateLoading } = (0, $lzT4f.useJsmGracePeriodAnnouncementGpEndDateResource)();
    const { displayState: bannerDisplayState, loading: bannerDisplayStateLoading } = (0, $lzT4f.useJsmGracePeriodAnnouncementDisplayStateResource)(accountId);
    const { Panel: Panel, trigger: trigger } = (0, $9WpOs.usePanel)();
    const productEntitlementDetails = (0, $9HmCl.useProductEntitlementDetails)();
    const isCCP = productEntitlementDetails?.[0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61]?.billingSourceSystem === 'CCP';
    const daysLeft = (0, $lw3Pj.default)(gpEndDate ? new Date(gpEndDate) : (0, $22xih.FALLBACK_GP_END_DATE), new Date(Date.now()));
    const isGPFinished = daysLeft <= 0;
    const isGPMonthlyBilling = gpEndDateDetails?.billingPeriod === 'MONTHLY';
    const announcementType = daysLeft > 30 ? 'T90' : 'T30';
    const fallbackDaysLeft = announcementType === 'T90' ? 90 : 30;
    // We accidentally released the new T90 state for all customers
    // even if they had more than 90 days left in their GP.
    // Some of these customers might have already dismissed the banner
    // so we need to use the new state for the banner if their GP end date is after Nov 5, 2025
    // to for storing their T90 banner display state
    const useNewT90State = gpEndDate && gpEndDate > new Date('11/5/2025') && (0, $7jTnu.fg)('jsm_use_new_t90_state_jsm_gp_announcements');
    const handleOnClick = (_, analyticsEvent)=>{
        if (analyticsOrigin) (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'jsmGracePeriodPill', {
            origin: analyticsOrigin
        });
    };
    const bannerIsVisible = announcementType === 'T90' && !bannerDisplayState?.hideT90Banner && !useNewT90State || announcementType === 'T90' && !bannerDisplayState?.hideT90BannerNew && useNewT90State || announcementType === 'T30' && !bannerDisplayState?.hideT30Banner;
    if (!isSiteAdmin || appEditions.serviceDesk !== (0, $a9ldn.STANDARD_EDITION) || gpEndDateLoading || bannerDisplayStateLoading || bannerIsVisible || product !== 'jira-service-management' || isGPFinished || !isCCP || !isGPMonthlyBilling || daysLeft > 90) return;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jsm-grace-period-banner.ui.gp-awareness-pill",
        packageName: "jsm-grace-period-awareness-pill",
        teamName: "Sequoia",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "jsmGracePeriodPill",
        sourceType: (0, $466f60259c330878$export$238d30785c4bca84),
        attributes: {
            daysLeftInGP: daysLeft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1LRl2.Trigger), {
        trigger: trigger,
        entryPoint: (0, $gOf4q.premiumLandingPageEntryPoint),
        entryPointProps: {
            origin: 'NAV_BAR',
            onClose: ()=>{
                trigger.setPanel(null);
            }
        }
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cPbpX.default), {
            onClick: handleOnClick,
            xcss: [
                $1cf1a2633a5769f2$var$pressableStyles,
                announcementType === 'T30' && $1cf1a2633a5769f2$var$warningStyles
            ],
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            testId: "jsm-grace-period-banner.ui.gp-awareness-pill.button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6CZxU))), {
            label: "",
            color: "var(--ds-icon-warning, #E56910)"
        }), formatMessage((0, $hYOCy.default).daysLeft, {
            days: gpEndDate ? daysLeft : fallbackDaysLeft,
            symbol: gpEndDate ? '' : '+'
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Panel, null));
};
const $1cf1a2633a5769f2$var$pressableStyles = (0, $5Wv5g.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    textDecoration: 'none !important',
    backgroundColor: 'color.background.neutral.subtle',
    display: 'inline-flex',
    border: `1px solid ${"var(--ds-border-warning, #E56910)"}`,
    borderRadius: 'border.radius.100',
    color: 'color.text.warning',
    flexShrink: 0,
    height: '2rem',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.075',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out',
    alignItems: 'center',
    gap: 'space.075',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $1cf1a2633a5769f2$var$warningStyles = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.background.warning',
    ':hover': {
        backgroundColor: 'color.background.warning.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.warning.pressed'
    }
});

});
parcelRegister("gOf4q", function(module, exports) {

$parcel$export(module.exports, "premiumLandingPageEntryPoint", () => $3faad70fc7c8ef01$export$eeb372f43c6f209);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $3faad70fc7c8ef01$export$eeb372f43c6f209 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("3y4Sr")), {
        moduleId: "3167f693",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3y4Sr", function(module, exports) {

let $2958548d5a6930cb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $2958548d5a6930cb$var$load("7vqGd"),
    $2958548d5a6930cb$var$load("1Y4bq"),
    $2958548d5a6930cb$var$load("1VRB2"),
    $2958548d5a6930cb$var$load("bABhq"),
    $2958548d5a6930cb$var$load("9fotH")
]).then(()=>parcelRequire('8mWe6'));

});


parcelRegister("5g5cw", function(module, exports) {

$parcel$export(module.exports, "useProductAndEdition", () => $f7ef38d657c642b2$export$b0f1c0403c557678);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $eWzpp = parcelRequire("eWzpp");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");

var $8JLU7 = parcelRequire("8JLU7");
const $f7ef38d657c642b2$export$b0f1c0403c557678 = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    const { loading: loading, data: project } = (0, $eWzpp.useProject)();
    const siteHasOnlyJira = (0, $8JLU7.useSiteHasOnlyJira)();
    // Show premium pill button for JSM premium trial experiment
    const projectType = (0, $eJOHy.useMemo)(()=>{
        if (loading) return;
        const type = (0, $ln6Iy.toProjectType)(project?.type);
        if (type) return type;
        if (siteHasOnlyJira) return 0, $ln6Iy.SOFTWARE_PROJECT;
    }, [
        loading,
        project?.type,
        siteHasOnlyJira
    ]);
    const localEdition = (0, $eJOHy.useMemo)(()=>{
        if (!projectType) return;
        return (0, $a9ldn.getEditionForProject)(projectType, appEditions);
    }, [
        appEditions,
        projectType
    ]);
    const { product: product, edition: edition } = (0, $eJOHy.useMemo)(()=>{
        if (!projectType || !localEdition) // We don't have a product or edition, so return nothing
        return {};
        if (projectType === (0, $ln6Iy.CORE_PROJECT) && !siteHasOnlyJira) // We are supporting only JWM implicit licensing when the parent license is JSW
        // Do not show on core products if site does not have only Jira
        return {};
        return {
            product: $f7ef38d657c642b2$var$getEaProduct(projectType),
            edition: $f7ef38d657c642b2$var$getEaEdition(localEdition)
        };
    }, [
        localEdition,
        projectType,
        siteHasOnlyJira
    ]);
    return {
        product: product,
        edition: edition
    };
};
const $f7ef38d657c642b2$var$getEaEdition = (e)=>{
    if (e === 'FREE_EDITION') return 'free';
    if (e === 'STANDARD_EDITION') return 'standard';
    if (e === 'PREMIUM_EDITION') return 'premium';
};
const $f7ef38d657c642b2$var$getEaProduct = (p)=>{
    if (p === (0, $ln6Iy.SOFTWARE_PROJECT)) return 'jira';
    if (p === (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT)) return 'jira-product-discovery';
    if (p === (0, $ln6Iy.SERVICE_DESK_PROJECT)) return 'jira-service-management';
    if (p === (0, $ln6Iy.CORE_PROJECT)) return 'jira';
};

});
parcelRegister("8JLU7", function(module, exports) {

$parcel$export(module.exports, "useSiteHasOnlyJira", () => $62dd0a3ee4d4593e$export$8ce0db5ac54a6136);

var $kFw1p = parcelRequire("kFw1p");


var $lvKO5 = parcelRequire("lvKO5");
function $62dd0a3ee4d4593e$export$8ce0db5ac54a6136() {
    const tenantContext = (0, $lvKO5.useTenantContext)();
    try {
        const [firstExplicitlyLicensedProduct, ...rest] = (0, $kFw1p.default)(tenantContext);
        return rest.length === 0 && firstExplicitlyLicensedProduct === (0, $e08dff4ae358d899$export$1346c9aa3cbb477d);
    } catch  {
        return false;
    }
}

});


parcelRegister("hYOCy", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a384cf7db166527$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3a384cf7db166527$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    daysLeft: {
        "id": "jsm-grace-period-banner.gp-awareness-pill.days-left",
        "defaultMessage": " {days, plural, one {#{symbol} day} other {#{symbol} days}} left"
    }
});

});


parcelRegister("kyPau", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c807c28021f273ee$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $c807c28021f273ee$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    sideNavToggleButtonCollapseLabel: {
        "id": "atlassian-navigation-nav4.atlaskit-atlassian-navigation-nav4.side-nav-toggle-button-collapse-label",
        "defaultMessage": "Collapse sidebar ["
    },
    sideNavToggleButtonExpandLabel: {
        "id": "atlassian-navigation-nav4.atlaskit-atlassian-navigation-nav4.side-nav-toggle-button-expand-label",
        "defaultMessage": "Expand sidebar ["
    }
});

});

parcelRegister("2qDaO", function(module, exports) {

$parcel$export(module.exports, "Nav4Profile", () => $9f311efe117b416c$export$c928b6dc7cf1e4c6);

var $eg7wv = parcelRequire("eg7wv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kxsjC = parcelRequire("kxsjC");

var $k9JE4 = parcelRequire("k9JE4");

var $cECwI = parcelRequire("cECwI");

var $RXvVX = parcelRequire("RXvVX");

var $cailY = parcelRequire("cailY");

var $g1NZW = parcelRequire("g1NZW");

var $e442c = parcelRequire("e442c");
var $7uEI2 = parcelRequire("7uEI2");
var $hEQwH = parcelRequire("hEQwH");

var $7jTnu = parcelRequire("7jTnu");


var $6Si1n = parcelRequire("6Si1n");
function $9f311efe117b416c$export$c928b6dc7cf1e4c6({ queryReference: queryReference }) {
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kxsjC.NavigationAnalyticsContext), {
        data: (0, $hEQwH.ANALYTICS_CONTEXT)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e442c.AccountMenuIntlProvider), null, isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f311efe117b416c$var$Nav4ProfileAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f311efe117b416c$var$Nav4ProfileLoggedIn, {
        queryReference: queryReference
    })));
}
function $9f311efe117b416c$var$Nav4ProfileLoggedIn({ queryReference: queryReference }) {
    const data = (0, $j4oe4.useFragment)((0, $eg7wv.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Si1n.Nav4AccountMenu), {
        testId: (0, $RXvVX.testIdGenerate)('secondary-actions', 'profile'),
        picture: data?.user?.picture,
        email: data?.user?.email ?? ''
    });
}
function $9f311efe117b416c$var$Nav4ProfileAnonymous() {
    const environment = (0, $g1NZW.useEnvironment)();
    const identityEnv = (0, $cailY.getIdentityEnv)(environment);
    const currentWindow = (0, $cailY.getWindow)();
    const links = (0, $k9JE4.useAccountLinks)({
        email: '',
        identityEnvironment: identityEnv,
        application: 'jira',
        continueUrl: (0, $7jTnu.fg)('blu-7750_sign_in_button_to_original_location') ? (0, $cailY.getContinueUrl)({
            type: (0, $982bab3922601ed3$export$eed606b4351295d7)
        }) : (0, $cailY.getSiteUrl)(currentWindow),
        isLoggedOut: true
    });
    return links?.logInLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7uEI2.AccountMenuLoggedOutStateNav3), {
        testId: (0, $RXvVX.testIdGenerate)('secondary-actions', 'profile'),
        logInLink: links.logInLink
    });
}

});
parcelRegister("eg7wv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b3f7a2ef4e9bc7d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfd54e9247740605775ae15e963f8bce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4b3f7a2ef4e9bc7d$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "atlassianAccountId"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Profile",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "atlassianAccountId"
                }
            ],
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "email"
                        }
                    ],
                    "type": "AtlassianAccountUser"
                }
            ]
        }
    ],
    "type": "Query"
};
$4b3f7a2ef4e9bc7d$var$node.hash = "6d28f09535aba53e908aff58b1a38fdd";
var $4b3f7a2ef4e9bc7d$export$2e2bcd8739ae039 = $4b3f7a2ef4e9bc7d$var$node;

});

parcelRegister("RXvVX", function(module, exports) {

$parcel$export(module.exports, "testIdConcat", () => $233d588e07ae49d0$export$794609946480f79c);
$parcel$export(module.exports, "testIdGenerate", () => $233d588e07ae49d0$export$3b86b974ae586844);
const $233d588e07ae49d0$var$PREFIX = 'atlassian-navigation-';
const $233d588e07ae49d0$var$SEPARATOR = '--';
const $233d588e07ae49d0$var$isValid = (value)=>value != null && value !== '';
const $233d588e07ae49d0$export$794609946480f79c = (id, ...items)=>[
        id,
        ...items
    ].filter(Boolean).join($233d588e07ae49d0$var$SEPARATOR).toLowerCase();
const $233d588e07ae49d0$export$3b86b974ae586844 = (first, ...rest)=>// @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
    $233d588e07ae49d0$export$794609946480f79c($233d588e07ae49d0$var$PREFIX + ($233d588e07ae49d0$var$isValid(first) ? `-${first}` : ''), ...rest);

});

parcelRegister("cailY", function(module, exports) {

$parcel$export(module.exports, "getWindow", () => $8de64f7cb31a9d85$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getSiteUrl", () => $8de64f7cb31a9d85$export$63fdf20f02fdbaf2);
$parcel$export(module.exports, "getContinueUrl", () => $8de64f7cb31a9d85$export$8c0854445d46e88e);
$parcel$export(module.exports, "getIdentityEnv", () => $8de64f7cb31a9d85$export$b3f2b8c6cd294d68);

var $dOwXt = parcelRequire("dOwXt");

const $8de64f7cb31a9d85$export$38b2d434cce3ea22 = ()=>false ? null : window;
const $8de64f7cb31a9d85$export$63fdf20f02fdbaf2 = (currentWindow)=>{
    if (currentWindow && !currentWindow.false) return `${currentWindow.location.protocol}//${currentWindow.location.host}`;
    return '';
};
const $8de64f7cb31a9d85$export$8c0854445d46e88e = ({ type: type })=>{
    const { href: href = '', protocol: protocol = '', host: host = '' } = (0, $dOwXt.default)() ?? {};
    if (type === (0, $982bab3922601ed3$export$eed606b4351295d7)) return href;
    if (type === (0, $982bab3922601ed3$export$35e541d26a145a7c)) return protocol && host ? `${protocol}//${host}` : '';
    return '';
};
const $8de64f7cb31a9d85$export$b3f2b8c6cd294d68 = (env)=>{
    switch(env){
        case 'local':
            return 'staging';
        case 'dev':
            return 'staging';
        case 'staging':
            return 'staging';
        case 'prod':
            return 'prod';
        default:
            return 'prod';
    }
};

});
parcelRegister("dOwXt", function(module, exports) {

$parcel$export(module.exports, "default", () => $802e6117e996a19b$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $802e6117e996a19b$export$2e2bcd8739ae039 = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};

});


parcelRegister("6Si1n", function(module, exports) {

$parcel$export(module.exports, "Nav4AccountMenu", () => $a56b19ed2544e06a$export$793e3aab7101233f);

var $eJOHy = parcelRequire("eJOHy");

var $5UxOh = parcelRequire("5UxOh");

var $dPlS8 = parcelRequire("dPlS8");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $gbiVe = parcelRequire("gbiVe");

var $aMaHz = parcelRequire("aMaHz");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $ciFJV = parcelRequire("ciFJV");

var $fwPtS = parcelRequire("fwPtS");

var $7jTnu = parcelRequire("7jTnu");

var $286cZ = parcelRequire("286cZ");

var $8q7lT = parcelRequire("8q7lT");
const $a56b19ed2544e06a$export$793e3aab7101233f = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-2'), ({ testId: testId, picture: picture, email: email })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const atlassianAccountId = (0, $8q7lT.useAccountId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            atlassianAccountId: atlassianAccountId ?? '',
            jiraOnboardingHubGateEnabled: (0, $7jTnu.fg)('jira-onboarding-hub-gate') ?? false
        }), [
        atlassianAccountId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $fwPtS.Nav4ProfileMenuEntryPoint), entryPointParams);
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            onClosePopup: ()=>{
                setIsOpen(false);
            },
            testId: testId
        }), [
        testId
    ]);
    const TriggerInternal = (0, $eJOHy.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a56b19ed2544e06a$var$Trigger, {
            triggerRef: triggerRef,
            setIsOpen: setIsOpen,
            testId: testId,
            picture: picture,
            email: email,
            isOpen: isOpen,
            triggerProps: triggerProps
        });
    }, [
        triggerRef,
        setIsOpen,
        testId,
        picture,
        email,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5UxOh.default), {
        isOpen: isOpen,
        onClose: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-2') ? (0, $eJOHy.useCallback)(()=>{
            setIsOpen(false);
        }, []) : ()=>{
            setIsOpen(false);
        },
        testId: testId,
        placement: "bottom",
        trigger: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-2') ? TriggerInternal : (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), {
                name: "profile-spotlight"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a56b19ed2544e06a$var$AccountMenuTrigger, {
                ref: (element)=>{
                    triggerRef(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                },
                onClick: ()=>{
                    setIsOpen((open)=>!open);
                },
                testId: testId && `${testId}--trigger`,
                picture: picture,
                trustPicture: true,
                email: email,
                "aria-expanded": isOpen,
                "aria-haspopup": true,
                "aria-controls": testId && `${testId}--content`,
                "data-ds--level": triggerProps['data-ds--level']
            }));
        },
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "atlassian-navigation-profile-menu",
                packageName: "atlassian-navigation-profile-menu",
                errorFallback: "flag",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
                    xcss: $a56b19ed2544e06a$var$Nav4AccountMenuContentSkeletonStyles,
                    padding: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPlS8.default), null)),
                runtimeProps: runtimeProps
            })
    });
});
const $a56b19ed2544e06a$var$AccountMenuTrigger = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-stability-fixes-nav-misc'), (0, $aMaHz.AccountMenuTriggerNav3));
function $a56b19ed2544e06a$var$Trigger({ triggerRef: triggerRef, setIsOpen: setIsOpen, testId: testId, picture: picture, email: email, isOpen: isOpen, triggerProps: triggerProps }) {
    const ref = (0, $eJOHy.useCallback)((element)=>{
        triggerRef(element);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        triggerProps.ref(element);
    }, [
        triggerRef,
        triggerProps.ref
    ]);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        setIsOpen((open)=>!open);
    }, [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), {
        name: "profile-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a56b19ed2544e06a$var$AccountMenuTrigger, {
        ref: ref,
        onClick: onClick,
        testId: testId && `${testId}--trigger`,
        picture: picture,
        trustPicture: true,
        email: email,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        "aria-controls": testId && `${testId}--content`,
        "data-ds--level": triggerProps['data-ds--level']
    }));
}
// These styles are defined to ensure that the initial popup for the AccountMenu content is the same width when
// displaying the skeleton loader as when displaying the actual content.
const $a56b19ed2544e06a$var$Nav4AccountMenuContentSkeletonStyles = (0, $5Wv5g.xcss)({
    width: '304px',
    height: '307px'
});

});
parcelRegister("fwPtS", function(module, exports) {

$parcel$export(module.exports, "Nav4ProfileMenuEntryPoint", () => $ec6e142b597062c3$export$e30a856958207b6);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

var $h5mlg = parcelRequire("h5mlg");

const $ec6e142b597062c3$export$e30a856958207b6 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("f8QFI")), {
        moduleId: "18b1d8bb",
        priority: "interaction"
    }),
    getPreloadProps: ({ atlassianAccountId: atlassianAccountId, jiraOnboardingHubGateEnabled: jiraOnboardingHubGateEnabled })=>({
            queries: {
                profileMenuQuery: {
                    parameters: $h5mlg.default,
                    variables: {
                        atlassianAccountId: atlassianAccountId ?? '',
                        jiraOnboardingHubGateEnabled: jiraOnboardingHubGateEnabled ?? false
                    }
                }
            }
        })
});

});
parcelRegister("h5mlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $669665a4e48b53e3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d155cb2e0d5640cdfc10ad50cf7d787d>>
 * @relayHash 7b6d9b50a8d296f1b6e608205a17bd15
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 22cb9b11a294000ed03564f054cbd9a524df4c24bfed99bd87a8c708a4bdf01b
const $669665a4e48b53e3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "22cb9b11a294000ed03564f054cbd9a524df4c24bfed99bd87a8c708a4bdf01b",
        "metadata": {},
        "name": "profileMenuQuery",
        "operationKind": "query",
        "text": null
    }
};
var $669665a4e48b53e3$export$2e2bcd8739ae039 = $669665a4e48b53e3$var$node;

});

parcelRegister("f8QFI", function(module, exports) {

let $b06075e9a15b2c32$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('edition_awareness_upsell_jira_ab_fg', function() {
        return Promise.all([
            $b06075e9a15b2c32$var$load("1hIxm")
        ]);
    }, function() {
        return Promise.all([
            $b06075e9a15b2c32$var$load("hBjLQ")
        ]);
    }),
    $b06075e9a15b2c32$var$load("3XpF0")
]).then(()=>parcelRequire('e6Taa'));

});




parcelRegister("8aPak", function(module, exports) {

$parcel$export(module.exports, "useSiteTitle", () => $059c3e654e9e086d$export$3e157e0d79928990);

var $eJOHy = parcelRequire("eJOHy");

var $hWeHP = parcelRequire("hWeHP");
const $059c3e654e9e086d$export$3e157e0d79928990 = ()=>(0, $eJOHy.useMemo)(()=>({
            shouldShow: (0, $hWeHP.default)('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            value: (0, $hWeHP.default)('ajs-app-title')
        }), []);

});



parcelRegister("87u0A", function(module, exports) {

$parcel$export(module.exports, "recommendations", () => $510ce4ad72b2e837$export$b7e5cef71fa42514);

var $caHnk = parcelRequire("caHnk");


const $510ce4ad72b2e837$var$createRecommendationsList = ()=>{
    const recommendationsList = [];
    recommendationsList.push((0, $caHnk.default));
    // Add your own templates
    return recommendationsList;
};
const $510ce4ad72b2e837$export$b7e5cef71fa42514 = $510ce4ad72b2e837$var$createRecommendationsList();

});
parcelRegister("caHnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fcb9b776265e310$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $73iKQ = parcelRequire("73iKQ");

var $givfd = parcelRequire("givfd");
var $lbX5P = parcelRequire("lbX5P");

var $dKpTa = parcelRequire("dKpTa");

var $6alcT = parcelRequire("6alcT");

var $h8epd = parcelRequire("h8epd");

var $7Upta = parcelRequire("7Upta");

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $8q7lT = parcelRequire("8q7lT");

var $g1NZW = parcelRequire("g1NZW");

var $1q7fs = parcelRequire("1q7fs");

var $7jTnu = parcelRequire("7jTnu");

var $8KUFq = parcelRequire("8KUFq");

var $4FrS0 = parcelRequire("4FrS0");

var $cLFIu = parcelRequire("cLFIu");

var $aX78d = parcelRequire("aX78d");

var $6aTry = parcelRequire("6aTry");

var $7hxvl = parcelRequire("7hxvl");

var $gIEls = parcelRequire("gIEls");

var $9H8WG = parcelRequire("9H8WG");

var $eZXlj = parcelRequire("eZXlj");

var $bwx4r = parcelRequire("bwx4r");

var $cd5tM = parcelRequire("cd5tM");

var $3yAD7 = parcelRequire("3yAD7");
const $6fcb9b776265e310$export$da956fe610b96f73 = ()=>{
    const reasonsModalBulletTwoAppify = (0, $7jTnu.fg)('product-terminology-refresh') ? (0, $cd5tM.default).reasonsModalBulletTwoAppify : (0, $cd5tM.default).reasonsModalBulletTwo;
    const [moreInformationModal, setMoreInformationModal] = (0, $eJOHy.useState)(false);
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $1q7fs.useFireCrossFlowAnalyticsEvents)();
    const [, { setRecommendationDismissal: setRecommendationDismissal }] = (0, $7hxvl.useProjectMenuRecommendations)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const accountId = (0, $8q7lT.useAccountId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const crossFlow = (0, $givfd.useCrossFlow)();
    const environment = (0, $g1NZW.useEnvironment)();
    const jpdCloudCCPProductID = (0, $bwx4r.getProductTypeCcpReferenceIdMapForEnv)(environment).PRODUCT_DISCOVERY;
    (0, $eJOHy.useEffect)(()=>{
        if (crossFlow.isEnabled) fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'projectsMenu'
        }, {
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            source: 'projectsMenuSection'
        }, {
            navigationVersion: 'v3'
        });
        else (0, $gYnSx.default)({
            error: new Error(crossFlow.reason),
            meta: {
                id: crossFlow.reason,
                packageName: 'jiraAtlassianNavigationRecommendations'
            }
        });
    }, [
        createAnalyticsEvent,
        crossFlow,
        fireViewedUIEvent,
        jpdCloudCCPProductID
    ]);
    const openCrossFlow = (0, $eJOHy.useCallback)(async (templateId)=>{
        const extensions = (0, $73iKQ.createProvisioningPageExtensions)({
            actions: {
                primary: {
                    behaviour: (0, $73iKQ.Behaviours).LAND,
                    prompt: (0, $73iKQ.Prompts).NEXT,
                    options: {
                        targetTab: (0, $73iKQ.TargetTabs).SAME,
                        urlParams: {
                            templateId: templateId
                        }
                    }
                }
            }
        });
        if (crossFlow.isEnabled) crossFlow.apiV1.open({
            journey: (0, $givfd.Journeys).GET_STARTED,
            targetProduct: (0, $lbX5P.Targets).JIRA_PRODUCT_DISCOVERY,
            sourceComponent: 'projectsMenu',
            sourceContext: 'tryThisRecommendation',
            extensions: extensions,
            v1: true
        });
    }, [
        crossFlow
    ]);
    const onRecommendationClicked = (0, $eJOHy.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryThisRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v3'
        });
        openCrossFlow((0, $bwx4r.JPD_ROADMAP_KEY));
    }, [
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        openCrossFlow
    ]);
    const onLearnMoreClicked = (0, $eJOHy.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v3'
        });
        setMoreInformationModal(true);
    }, [
        fireInteractedUIEvent,
        jpdCloudCCPProductID
    ]);
    const onLearnMoreClosed = (0, $eJOHy.useCallback)(()=>{
        setMoreInformationModal(false);
    }, []);
    const onDismissClicked = (0, $eJOHy.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'dismissRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v3'
        });
        setRecommendationDismissal();
        if (accountId) (0, $FppkK.setUserProperties)(accountId, (0, $bwx4r.JPD_RECOMMENDATION_DISMISS_USER_PROPERTY), 'true').catch((error)=>(0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'dismissJpdRecommendation',
                    packageName: 'jiraAtlassianNavigationRecommendations',
                    teamName: 'navigation'
                }
            }));
    }, [
        accountId,
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        setRecommendationDismissal
    ]);
    const onClickPrivacyPolicy = (0, $eJOHy.useCallback)(()=>{
        const clickedLinkBaseEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $gCeeo.fireUIAnalytics)(clickedLinkBaseEvent, 'adControlsPrivacyPolicy');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4FrS0.RecommendationContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cLFIu.RecommendationHeader), {
        title: formatMessage((0, $cd5tM.default).recommendedText),
        onDismissClicked: onDismissClicked,
        onLearnMoreClicked: onLearnMoreClicked
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aX78d.RecommendationMenuItem), {
        title: formatMessage((0, $cd5tM.default).projectTitleProductRoadmap),
        description: formatMessage((0, $cd5tM.default).projectDescriptionProductRoadmap),
        onClick: onRecommendationClicked,
        lozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
            appearance: "new",
            isBold: false
        }, formatMessage((0, $cd5tM.default).lozengeText)),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eZXlj.default), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6aTry.RecommendationModal), {
        isOpen: moreInformationModal,
        onClose: onLearnMoreClosed,
        title: formatMessage((0, $cd5tM.default).reasonsModalTitle),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $cd5tM.default).reasonsModalExplanation, {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
                    as: "strong"
                }, chunks)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", null, formatMessage((0, $cd5tM.default).reasonsModalBulletOneSpork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", null, formatMessage(reasonsModalBulletTwoAppify))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
            appearance: "link",
            spacing: "none",
            href: (0, $bwx4r.DATA_PRIVACY_LINK),
            target: "_blank",
            onClick: onClickPrivacyPolicy
        }, formatMessage((0, $cd5tM.default).privacyPolicy))),
        primaryCta: formatMessage((0, $cd5tM.default).reasonsModalButtonOk)
    }));
};
const $6fcb9b776265e310$var$checkEligibility = async (recommendationContext, analyticsEvent)=>{
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled, licensedProducts: licensedProducts, canCreateProject: canCreateProject, accountId: accountId, cloudId: cloudId, environment: environment, isInFedRamp: isInFedRamp } = recommendationContext;
    if ((0, $7jTnu.fg)('optout_all_messages_grw-1467')) {
        const { optoutStatus: optoutStatus } = await (0, $7Upta.isOptoutAllMessages)('grw-1467-jpd-recommendation-nav3', cloudId, accountId, analyticsEvent);
        switch(optoutStatus){
            case 'error':
                return {
                    isEligible: false,
                    reason: 'Failed to check if opted out of all messages'
                };
            case 'is-opted-out':
                return {
                    isEligible: false,
                    reason: 'Opted out of all messages'
                };
            default:
                break;
        }
    }
    if ((0, $7jTnu.fg)('grw-1467_jpd_reco_eligibility_override_gate')) return {
        isEligible: true,
        reason: 'Eligibility override gate is enabled'
    };
    if (!areProductSuggestionsEnabled) return {
        isEligible: false,
        reason: 'Product suggestions are disabled'
    };
    if ((0, $3yAD7.hasJpdLicense)(licensedProducts)) return {
        isEligible: false,
        reason: 'Instance has JPD license'
    };
    if (!canCreateProject) return {
        isEligible: false,
        reason: 'User cannot create projects'
    };
    if (isInFedRamp) return {
        isEligible: false,
        reason: 'User is in FedRamp'
    };
    const [dismissed, appRecommendations] = await Promise.all([
        (0, $FppkK.getUserProperty)(accountId, (0, $bwx4r.JPD_RECOMMENDATION_DISMISS_USER_PROPERTY)).catch((error)=>{
            // If not found, then the user hasn't dismissed the ad.
            // 404 - user property not found,
            if (error.statusCode === 404) return false;
            const expectedErrors = [
                429,
                // rate limit exceeded
                401,
                // unauthorised
                403,
                // forbidden
                null,
                // client error
                undefined // client error
            ];
            // 50x - network errors
            // We shouldn't see the recommendation
            if (expectedErrors.includes(error.statusCode) || error.statusCode >= 500 || (0, $8KUFq.isClientFetchError)(error)) return true;
            throw Error(`${error.statusCode}, JPD recommendation dismissal failed. ${error.name}: ${error.message}`, error);
        }),
        (0, $9H8WG.fetchAppRecommendations)(cloudId, environment, analyticsEvent)
    ]);
    if (dismissed) return {
        isEligible: false,
        reason: 'JPD recommendation dismissed'
    };
    if (!appRecommendations?.some((recommendation)=>recommendation?.entityId === (0, $bwx4r.JPD_ENTITY_ID))) return {
        isEligible: false,
        reason: 'JPD was not in the recommend apps'
    };
    return {
        isEligible: true,
        reason: 'Pass all checks'
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6fcb9b776265e310$export$2e2bcd8739ae039 = {
    key: (0, $bwx4r.JPD_RECOMMENDATION_KEY),
    shouldRender: async (recommendationContext, analyticsEvent)=>{
        (0, $gIEls.projectsMenuDropdownLoadJpdRecommendation).start();
        const { isEligible: isEligible, reason: reason } = await $6fcb9b776265e310$var$checkEligibility(recommendationContext, analyticsEvent);
        if ((0, $7jTnu.fg)('pm_jpd_reco_operational_event_activated')) (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.loadJpdRecommendation succeeded', {
            reason: reason,
            isEligible: isEligible
        });
        (0, $gIEls.projectsMenuDropdownLoadJpdRecommendation).success();
        return isEligible;
    },
    onLoadError: (error)=>{
        (0, $gIEls.projectsMenuDropdownLoadJpdRecommendation).failure();
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'loadJpdRecommendation',
                packageName: 'jiraAtlassianNavigationRecommendations',
                teamName: 'navigation'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    },
    Component: $6fcb9b776265e310$export$da956fe610b96f73
};

});
parcelRegister("4FrS0", function(module, exports) {

$parcel$export(module.exports, "RecommendationContainer", () => $c63ca43168294d3d$export$97f31f44c68c1d5);

var $eJOHy = parcelRequire("eJOHy");

var $7R1al = parcelRequire("7R1al");

var $4xbv3 = parcelRequire("4xbv3");
const $c63ca43168294d3d$export$97f31f44c68c1d5 = ({ children: children, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
        hasSeparator: true
    }, children));

});

parcelRegister("cLFIu", function(module, exports) {

$parcel$export(module.exports, "RecommendationHeader", () => $e61c4b01c1cd3dd5$export$3beeaceb068c75b1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dKpTa = parcelRequire("dKpTa");

var $bvFRW = parcelRequire("bvFRW");

var $bAxQs = parcelRequire("bAxQs");

var $1AUsu = parcelRequire("1AUsu");
var $MlWTN = parcelRequire("MlWTN");
var $7R1al = parcelRequire("7R1al");

var $bL3dk = parcelRequire("bL3dk");
var $5Wv5g = parcelRequire("5Wv5g");

var $lRq8t = parcelRequire("lRq8t");

var $cNe2t = parcelRequire("cNe2t");

var $233v7 = parcelRequire("233v7");
const $e61c4b01c1cd3dd5$export$3beeaceb068c75b1 = ({ title: title, onDismissClicked: onDismissClicked, onLearnMoreClicked: onLearnMoreClicked })=>{
    const [isActionsMenuOpen, setIsActionsMenuOpen] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        xcss: $e61c4b01c1cd3dd5$var$HeadingItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        xcss: $e61c4b01c1cd3dd5$var$TitleItemStyles
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isActionsMenuOpen,
        placement: "bottom-start",
        messageId: "atlassian-navigation-recommendations.common.ui.recommendation-section.recommendation-header.popup",
        messageType: "transactional",
        onClose: ()=>setIsActionsMenuOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), {
                onClick: (e)=>e.stopPropagation()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
                onClick: onDismissClicked
            }, formatMessage((0, $233v7.default).dismissButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
                onClick: onLearnMoreClicked
            }, formatMessage((0, $233v7.default).learnMoreButtonText)))),
        shouldUseCaptureOnOutsideClick: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e61c4b01c1cd3dd5$var$MeatballMenuTrigger, {
                ...triggerProps,
                appearance: "subtle",
                onClick: ()=>setIsActionsMenuOpen(()=>!isActionsMenuOpen),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bAxQs))), {
                    LEGACY_size: "medium",
                    spacing: "spacious",
                    label: formatMessage((0, $233v7.default).moreButtonLabel, {
                        title: title
                    })
                })
            }),
        shouldRenderToParent: true
    }));
};
const $e61c4b01c1cd3dd5$var$HeadingItemStyles = (0, $5Wv5g.xcss)({
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    marginTop: 'space.050'
});
const $e61c4b01c1cd3dd5$var$TitleItemStyles = (0, $5Wv5g.xcss)({
    color: 'color.text.accent.gray'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e61c4b01c1cd3dd5$var$MeatballMenuTrigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $dKpTa.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbzwfg _4t3izwfg _1di6fg4m",
            __cmplp.className
        ])
    });
});

});
parcelRegister("233v7", function(module, exports) {

$parcel$export(module.exports, "default", () => $72a8f8d1b78c0d1e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $72a8f8d1b78c0d1e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    learnMoreButtonText: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.learn-more-button-text",
        "defaultMessage": "Why am I seeing this?"
    },
    dismissButtonText: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.dismiss-button-text",
        "defaultMessage": "Not interested"
    },
    dismissConfirmationText: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.dismiss-confirmation-text",
        "defaultMessage": "You won't be seeing this here anymore"
    },
    moreButtonLabel: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.more-button-label",
        "defaultMessage": "More options for {title} section"
    }
});

});


parcelRegister("aX78d", function(module, exports) {

$parcel$export(module.exports, "RecommendationMenuItem", () => $25bd38d9df6318d5$export$aab9ce3de285230c);

var $eJOHy = parcelRequire("eJOHy");

var $apGPk = parcelRequire("apGPk");

var $dhRXV = parcelRequire("dhRXV");
var $9M9zY = parcelRequire("9M9zY");
const $25bd38d9df6318d5$export$aab9ce3de285230c = ({ iconBefore: iconBefore, onClick: onClick, title: title, lozenge: lozenge = null, description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apGPk.default), {
        iconBefore: iconBefore,
        onClick: onClick,
        description: description,
        href: "#"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        space: "space.100"
    }, title, lozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), null, lozenge)));

});

parcelRegister("6aTry", function(module, exports) {

$parcel$export(module.exports, "RecommendationModal", () => $501b2c7193d8358f$export$d5c06ba24e862b67);

var $eJOHy = parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");

var $6sWr0 = parcelRequire("6sWr0");
var $3Zn1o = parcelRequire("3Zn1o");
var $15cpG = parcelRequire("15cpG");
var $i237T = parcelRequire("i237T");
var $jC5ye = parcelRequire("jC5ye");

var $h8epd = parcelRequire("h8epd");

var $aC4Bh = parcelRequire("aC4Bh");
const $501b2c7193d8358f$export$d5c06ba24e862b67 = ({ isOpen: isOpen, onClose: onClose, title: title, body: body, primaryCta: primaryCta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jC5ye.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        messageId: "atlassian-navigation-recommendations.common.ui.recommendation-section.recommendation-modal.modal",
        messageType: "transactional",
        shouldCloseOnEscapePress: true,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $15cpG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i237T.default), null, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6sWr0.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
        as: "p"
    }, body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Zn1o.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        appearance: "primary",
        onClick: onClose
    }, primaryCta))));

});

parcelRegister("7hxvl", function(module, exports) {

$parcel$export(module.exports, "useProjectMenuRecommendations", () => $e0626afa1a25b365$export$d4048a5b8ab1acff);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $9674h = parcelRequire("9674h");
const $e0626afa1a25b365$var$initialState = {
    status: 'idle'
};
const $e0626afa1a25b365$var$store = (0, $GtRbT.createStore)({
    actions: $9674h.actions,
    initialState: $e0626afa1a25b365$var$initialState,
    name: 'atlassian-navigation-recommendation'
});
const $e0626afa1a25b365$export$d4048a5b8ab1acff = (0, $iJq0l.createHook)($e0626afa1a25b365$var$store);

});
parcelRegister("9674h", function(module, exports) {

$parcel$export(module.exports, "actions", () => $f61f423f655a6dd8$export$e324594224ef24da);

var $8eEu3 = parcelRequire("8eEu3");
const $f61f423f655a6dd8$export$e95368803793838f = (recommendations, recommendationContext, analyticsEvent)=>async ({ getState: getState, setState: setState })=>{
        const { status: status } = getState();
        if (status !== 'idle') return;
        setState({
            status: 'loading'
        });
        const shuffledRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($8eEu3)))(recommendations);
        try {
            const recommendationStatus = await Promise.all(shuffledRecommendations.map(async (recommendation)=>{
                let isEnabled = false;
                try {
                    isEnabled = await recommendation.shouldRender(recommendationContext, analyticsEvent);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    recommendation.onLoadError(error);
                }
                return {
                    key: recommendation.key,
                    isEnabled: isEnabled
                };
            }));
            const selectedRecommendation = recommendationStatus.find((result)=>result.isEnabled);
            setState({
                status: 'success',
                recommendationKey: selectedRecommendation?.key || null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                status: 'error',
                error: error
            });
        }
    };
const $f61f423f655a6dd8$var$setRecommendationDismissal = ()=>({ setState: setState })=>{
        setState({
            recommendationKey: null
        });
    };
const $f61f423f655a6dd8$export$e324594224ef24da = {
    loadRecommendations: $f61f423f655a6dd8$export$e95368803793838f,
    setRecommendationDismissal: $f61f423f655a6dd8$var$setRecommendationDismissal
};

});


parcelRegister("gIEls", function(module, exports) {

$parcel$export(module.exports, "projectsMenuDropdownRecommendationSelector", () => $553dc7fe31eb9dbb$export$2b83859c1548ffb5);
$parcel$export(module.exports, "projectsMenuDropdownLoadJpdRecommendation", () => $553dc7fe31eb9dbb$export$a784c5bbb21ea554);

var $aRK4c = parcelRequire("aRK4c");
var $9GzfC = parcelRequire("9GzfC");
const $553dc7fe31eb9dbb$export$2b83859c1548ffb5 = new (0, $9GzfC.UFOExperience)('projects-menu-dropdown.recommendation-selector', {
    type: (0, $aRK4c.ExperienceTypes).Experience,
    performanceType: (0, $aRK4c.ExperiencePerformanceTypes).InlineResult
});
const $553dc7fe31eb9dbb$export$a784c5bbb21ea554 = new (0, $9GzfC.UFOExperience)('projects-menu-dropdown.load-jpd-recommendation', {
    type: (0, $aRK4c.ExperienceTypes).Experience,
    performanceType: (0, $aRK4c.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("9H8WG", function(module, exports) {

$parcel$export(module.exports, "fetchAppRecommendations", () => $3daa5e94c231e3c5$export$8665956217263d00);

var $irJPe = parcelRequire("irJPe");

var $j4oe4 = parcelRequire("j4oe4");

var $gCeeo = parcelRequire("gCeeo");

var $8KUFq = parcelRequire("8KUFq");


var $aAige = parcelRequire("aAige");
const $3daa5e94c231e3c5$export$f2d50cdc12f57d0b = (0, $irJPe.default);
const $3daa5e94c231e3c5$export$8665956217263d00 = async (cloudId, environment, analyticsEvent)=>{
    const appRecommendationState = (0, $aAige.getCachedAppRecommendationState)();
    if (appRecommendationState !== null && Date.now() - appRecommendationState.fetchRecommendationTimeStamp < (0, $96342a03fb08dcff$export$424ba99fce04562)) return appRecommendationState.appRecommendations ?? [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const data = await (0, $j4oe4.fetchQuery)(environment, $3daa5e94c231e3c5$export$f2d50cdc12f57d0b, {
        cloudId: cloudId
    }).toPromise().catch((err)=>{
        const expectedErrors = [
            401,
            // Unauthorised
            403,
            // Forbidden
            null,
            // Client error
            undefined // Client error
        ];
        if (expectedErrors.includes(err.statusCode) || (0, $8KUFq.isClientFetchError)(err)) return {};
        throw Error(`App recommendation ${err.name} error: ${err.message}`, {
            cause: err
        });
    });
    const appRecommendations = data?.growthRecommendations?.recommendations?.data;
    if (!appRecommendations) (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.fetchAppRecommendations empty', {
        response: `${JSON.stringify(data)}`
    });
    (0, $aAige.setCachedAppRecommendationState)({
        appRecommendations: appRecommendations,
        fetchRecommendationTimeStamp: Date.now()
    });
    return appRecommendations ?? [];
};

});
parcelRegister("irJPe", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9546b0610d048c5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63d29fc2e4b7b13b5431ad6d77aafb97>>
 * @relayHash e631e61cba47acbda6811ed1a287d9f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 620b7134d06fa893e7db6526963c4d8afbe3dc9c5b0428d93f35a2c73fa2ea86
const $c9546b0610d048c5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "product",
                    "value": "jira"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Literal",
                    "name": "useCase",
                    "value": "jiraProjectMenuRecommendations"
                }
            ],
            "kind": "ObjectValue",
            "name": "context"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 2
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "entityId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchAppRecommendationsV2Query",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v2 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "growthRecommendations.recommendations.data.entityId"
                                                        }
                                                    ],
                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchAppRecommendationsV2Query",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ],
                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "620b7134d06fa893e7db6526963c4d8afbe3dc9c5b0428d93f35a2c73fa2ea86",
            "metadata": {},
            "name": "fetchAppRecommendationsV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c9546b0610d048c5$var$node.hash = "eaaab66d3f41b01ce8e8a969a422ff60";
var $c9546b0610d048c5$export$2e2bcd8739ae039 = $c9546b0610d048c5$var$node;

});

const $96342a03fb08dcff$export$424ba99fce04562 = 600000;

parcelRegister("aAige", function(module, exports) {

$parcel$export(module.exports, "setCachedAppRecommendationState", () => $5efbc1684db39884$export$4bb2da71ae03947f);
$parcel$export(module.exports, "getCachedAppRecommendationState", () => $5efbc1684db39884$export$951c5f8396f4dcb);

var $dnU6V = parcelRequire("dnU6V");
const $5efbc1684db39884$var$store = (0, $dnU6V.createLocalStorageProvider)('projects-menu-jpd-recommendation');
const $5efbc1684db39884$var$APP_RECOMMENDATION_STATE = 'app-recommendation-state';
function $5efbc1684db39884$export$4bb2da71ae03947f(appRecommendationState) {
    $5efbc1684db39884$var$store.set($5efbc1684db39884$var$APP_RECOMMENDATION_STATE, JSON.stringify(appRecommendationState));
}
function $5efbc1684db39884$export$951c5f8396f4dcb() {
    const state = $5efbc1684db39884$var$store.get($5efbc1684db39884$var$APP_RECOMMENDATION_STATE);
    return state ? JSON.parse(state) : null;
}
function $5efbc1684db39884$export$a73955031198b1b8() {
    $5efbc1684db39884$var$store.remove($5efbc1684db39884$var$APP_RECOMMENDATION_STATE);
}

});


parcelRegister("eZXlj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca50fc94bbff9c4d$export$2e2bcd8739ae039);
/* product-roadmap-project-avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6q0fu = parcelRequire("6q0fu");

var $kjFxJ = parcelRequire("kjFxJ");
const $ca50fc94bbff9c4d$var$ProductRoadmapProjectAvatar = ()=>{
    return /*#__PURE__*/ $eJOHy.createElement((0, $6q0fu.default), {
        appearance: "square",
        borderColor: "transparent",
        size: "small",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kjFxJ))),
        name: "Jira Product Discovery Roadmap Template"
    });
};
var $ca50fc94bbff9c4d$export$2e2bcd8739ae039 = $ca50fc94bbff9c4d$var$ProductRoadmapProjectAvatar;

});
parcelRegister("kjFxJ", function(module, exports) {
module.exports = new URL("product-roadmap-project-icon.7eb40fb0.svg", import.meta.url).toString();

});


parcelRegister("bwx4r", function(module, exports) {

$parcel$export(module.exports, "JPD_RECOMMENDATION_KEY", () => $37066f42c08c30e3$export$3e6ff24c4f517c4f);
$parcel$export(module.exports, "JPD_ROADMAP_KEY", () => $37066f42c08c30e3$export$c11145b8eb60b18b);
$parcel$export(module.exports, "JPD_RECOMMENDATION_DISMISS_USER_PROPERTY", () => $37066f42c08c30e3$export$52b9dedc0088f8);
$parcel$export(module.exports, "DATA_PRIVACY_LINK", () => $37066f42c08c30e3$export$aefe1c8741b24a28);
$parcel$export(module.exports, "JPD_ENTITY_ID", () => $37066f42c08c30e3$export$909712ccf16883d);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $37066f42c08c30e3$export$29629758934356a6);

var $jaw0k = parcelRequire("jaw0k");
const $37066f42c08c30e3$export$3e6ff24c4f517c4f = 'jpd-recommendation';
const $37066f42c08c30e3$export$a9c4e38d8a74acd2 = 'jpd.product-discovery';
const $37066f42c08c30e3$export$c11145b8eb60b18b = 'jpd.product-roadmap';
const $37066f42c08c30e3$export$52b9dedc0088f8 = 'JpdRecommendationDismissed';
const $37066f42c08c30e3$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';
const $37066f42c08c30e3$export$909712ccf16883d = 'jira.polaris:discovery';
const $37066f42c08c30e3$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $jaw0k.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $jaw0k.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $jaw0k.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $jaw0k.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("cd5tM", function(module, exports) {

$parcel$export(module.exports, "default", () => $97b5efe7fd154f51$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $97b5efe7fd154f51$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    learnMoreButtonText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.learn-more-button-text",
        "defaultMessage": "Why am I seeing this?"
    },
    projectDescription: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-description",
        "defaultMessage": "Capture ideas with Jira Product Discovery"
    },
    projectDescriptionProductRoadmap: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-description-roadmap",
        "defaultMessage": "Jira Product Discovery project"
    },
    lozengeText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.lozenge-text",
        "defaultMessage": "try"
    },
    dismissButtonText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.dismiss-button-text",
        "defaultMessage": "Not interested"
    },
    recommendedText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.recommended-text",
        "defaultMessage": "Recommended"
    },
    dismissConfirmationTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.dismiss-confirmation-title",
        "defaultMessage": "Got it, thanks for letting us know"
    },
    dismissConfirmationText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.dismiss-confirmation-text",
        "defaultMessage": "You won't be seeing this here anymore"
    },
    projectTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title",
        "defaultMessage": "New discovery project"
    },
    projectTitleProductRoadmap: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title-product-roadmap",
        "defaultMessage": "Create a roadmap"
    },
    reasonsModalTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOneSpork: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
        "defaultMessage": "the tools you use (Jira)"
    },
    reasonsModalBulletTwo: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
        "defaultMessage": "the way you use your existing tools and products"
    },
    privacyPolicy: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    reasonsModalButtonOk: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
        "defaultMessage": "Ok"
    },
    reasonsModalButtonOkCapitalised: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok-capitalised",
        "defaultMessage": "OK"
    },
    reasonsModalBulletTwoAppify: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two-appify",
        "defaultMessage": "the way you use your existing tools and apps"
    }
});

});

parcelRegister("3yAD7", function(module, exports) {

$parcel$export(module.exports, "hasJpdLicense", () => $a6ad5fae97e43582$export$2ea69a0925803655);
const $a6ad5fae97e43582$export$2ea69a0925803655 = (licensedProducts)=>licensedProducts['jira-product-discovery'] === true;

});



parcelRegister("gtcB9", function(module, exports) {

$parcel$export(module.exports, "RecommendationLoader", () => $0b6ce50f1f5fc095$export$f17bc1d33db805f2);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $f1Zdy = parcelRequire("f1Zdy");

var $8dKc6 = parcelRequire("8dKc6");

var $8q7lT = parcelRequire("8q7lT");

var $8vyDv = parcelRequire("8vyDv");

var $kEUB1 = parcelRequire("kEUB1");

var $01Isa = parcelRequire("01Isa");

var $b9nqM = parcelRequire("b9nqM");

var $2cfd4 = parcelRequire("2cfd4");

var $lvKO5 = parcelRequire("lvKO5");

var $igNUx = parcelRequire("igNUx");

var $7hxvl = parcelRequire("7hxvl");
const $0b6ce50f1f5fc095$export$f17bc1d33db805f2 = ({ recommendations: recommendations })=>{
    const [, { loadRecommendations: loadRecommendations }] = (0, $7hxvl.useProjectMenuRecommendations)();
    const accountId = (0, $8q7lT.useAccountId)();
    const locale = (0, $2cfd4.useLocale)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const firstActivationDateMs = (0, $01Isa.useFirstActivationDateMs)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const { software: edition } = (0, $8vyDv.useAppEditions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [{ hasSuccessOnce: hasSuccessOnce, canCreateProject: canCreateProject }] = (0, $8dKc6.useCreateProjectPermission)();
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $lvKO5.useTenantContext)();
    const isInFedRamp = (0, $igNUx.isFedRamp)();
    (0, $eJOHy.useEffect)(()=>{
        if (hasSuccessOnce && accountId) loadRecommendations(recommendations, {
            locale: locale,
            accountId: accountId,
            cloudId: cloudId,
            licensedProducts: licensedProducts,
            firstActivationDateMs: firstActivationDateMs,
            areProductSuggestionsEnabled: areProductSuggestionsEnabled,
            edition: edition,
            environment: environment,
            canCreateProject: canCreateProject,
            isInFedRamp: isInFedRamp
        }, createAnalyticsEvent({}));
    }, [
        hasSuccessOnce,
        canCreateProject,
        accountId,
        loadRecommendations,
        createAnalyticsEvent,
        locale,
        cloudId,
        licensedProducts,
        firstActivationDateMs,
        areProductSuggestionsEnabled,
        edition,
        environment,
        recommendations,
        isInFedRamp
    ]);
    return null;
};

});

parcelRegister("fhzEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a179485b68d7ae10$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a179485b68d7ae10$var$LazyCustomThemeAdminFlag = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("fR5YF")), {
    ssr: false,
    moduleId: "./src/packages/theme/custom-theme-admin-flag/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a179485b68d7ae10$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "async.jira.custom-theme-admin-flag",
        packageName: "customThemeAdminFlag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "custom-theme-admin-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a179485b68d7ae10$var$LazyCustomThemeAdminFlag, null)));

});
parcelRegister("fR5YF", function(module, exports) {

let $b8b07141b58b2a8f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b8b07141b58b2a8f$var$load("1gaTk").then(()=>parcelRequire('gE9ms'));

});


parcelRegister("4PyXW", function(module, exports) {

$parcel$export(module.exports, "useFavoriteActions", () => $f06d3e9cba2eb15c$export$e17993c41bc4dc38);
$parcel$export(module.exports, "useFavoriteBoards", () => $f06d3e9cba2eb15c$export$896ce0ae2b68d03a);
$parcel$export(module.exports, "useFavoriteDashboards", () => $f06d3e9cba2eb15c$export$7f929adce53e9217);
$parcel$export(module.exports, "useFavoriteProjects", () => $f06d3e9cba2eb15c$export$e92f6fc9e0c6d135);
$parcel$export(module.exports, "useFavoriteFilters", () => $f06d3e9cba2eb15c$export$49e6afd92506d2b4);
$parcel$export(module.exports, "useFavoriteQueues", () => $f06d3e9cba2eb15c$export$b09f7ee747d8bc9);
$parcel$export(module.exports, "useFavoritePlans", () => $f06d3e9cba2eb15c$export$56f40dc3d5e1af94);
$parcel$export(module.exports, "FavoritesContainer", () => $f06d3e9cba2eb15c$export$878515009e0790e0);


var $fILaE = parcelRequire("fILaE");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

const $f06d3e9cba2eb15c$var$emptyItemState = {
    items: null,
    isFetching: false,
    fetchError: null,
    promise: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false
};
const $f06d3e9cba2eb15c$export$d4c72bab9d6cc13a = {
    [(0, $530fa672789495a8$export$f95f1a684a17f189)]: {
        ...$f06d3e9cba2eb15c$var$emptyItemState
    },
    [(0, $530fa672789495a8$export$6e58b6b0aa48a271)]: {
        ...$f06d3e9cba2eb15c$var$emptyItemState
    },
    [(0, $530fa672789495a8$export$6737b9227f60f39d)]: {
        ...$f06d3e9cba2eb15c$var$emptyItemState
    },
    [(0, $530fa672789495a8$export$91a9dba2d38d9a6f)]: {
        ...$f06d3e9cba2eb15c$var$emptyItemState
    },
    [(0, $530fa672789495a8$export$20f1031cc9fdf29e)]: {
        ...$f06d3e9cba2eb15c$var$emptyItemState
    },
    [(0, $530fa672789495a8$export$eebccb886b064713)]: {
        ...$f06d3e9cba2eb15c$var$emptyItemState
    }
};
const $f06d3e9cba2eb15c$var$transformItems = (items)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    items.reduce((acc, itemResponse)=>{
        if (itemResponse.id === 'favourite-boards') acc[0, $530fa672789495a8$export$f95f1a684a17f189] = itemResponse.items;
        if (itemResponse.id === 'favourite-filters') acc[0, $530fa672789495a8$export$6737b9227f60f39d] = itemResponse.items;
        if (itemResponse.id === 'favourite-dashboards') acc[0, $530fa672789495a8$export$6e58b6b0aa48a271] = itemResponse.items;
        if (itemResponse.id === 'favourite-projects') acc[0, $530fa672789495a8$export$91a9dba2d38d9a6f] = itemResponse.items;
        if (itemResponse.id === 'favourite-queues') acc[0, $530fa672789495a8$export$20f1031cc9fdf29e] = itemResponse.items;
        if (itemResponse.id === 'favourite-plans') acc[0, $530fa672789495a8$export$eebccb886b064713] = itemResponse.items;
        return acc;
    }, {});
const $f06d3e9cba2eb15c$var$loadFavoriteItems = (amount = (0, $afbb2078a4e12c1d$export$ea341e6cc435ed40), types)=>async ({ setState: setState, getState: getState })=>{
        const typesToFetch = types.filter((type)=>!getState()[type].isFetching);
        if (typesToFetch.length) try {
            const promise = (0, $fILaE.fetchFavoriteItems)({
                count: amount,
                types: typesToFetch
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const loadingState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                };
                return acc;
            }, {});
            setState(loadingState);
            const itemResponse = await promise;
            const transformed = $f06d3e9cba2eb15c$var$transformItems(itemResponse);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const responseState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    items: transformed[type],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                };
                return acc;
            }, {});
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                };
                return acc;
            }, {});
            setState(errorState);
        }
    };
const $f06d3e9cba2eb15c$export$e324594224ef24da = {
    loadFavoriteAll: (amount)=>async (actions2, props)=>{
            $f06d3e9cba2eb15c$var$loadFavoriteItems(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $530fa672789495a8$export$f95f1a684a17f189) : undefined,
                (0, $530fa672789495a8$export$6e58b6b0aa48a271),
                (0, $530fa672789495a8$export$91a9dba2d38d9a6f),
                (0, $530fa672789495a8$export$6737b9227f60f39d),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $530fa672789495a8$export$20f1031cc9fdf29e) : undefined,
                props.applicationPermissions.hasSoftwareAccess ? (0, $530fa672789495a8$export$eebccb886b064713) : undefined
            ].filter(Boolean))(actions2);
        },
    loadFavouriteBoards: (amount)=>$f06d3e9cba2eb15c$var$loadFavoriteItems(amount, [
            (0, $530fa672789495a8$export$f95f1a684a17f189)
        ]),
    loadFavoriteProjects: (amount)=>$f06d3e9cba2eb15c$var$loadFavoriteItems(amount, [
            (0, $530fa672789495a8$export$91a9dba2d38d9a6f)
        ]),
    loadFavoriteDashboards: (amount)=>$f06d3e9cba2eb15c$var$loadFavoriteItems(amount, [
            (0, $530fa672789495a8$export$6e58b6b0aa48a271)
        ]),
    loadFavoriteFilters: (amount)=>$f06d3e9cba2eb15c$var$loadFavoriteItems(amount, [
            (0, $530fa672789495a8$export$6737b9227f60f39d)
        ]),
    loadFavouriteQueues: (amount)=>$f06d3e9cba2eb15c$var$loadFavoriteItems(amount, [
            (0, $530fa672789495a8$export$20f1031cc9fdf29e)
        ]),
    loadFavoritePlans: (amount)=>$f06d3e9cba2eb15c$var$loadFavoriteItems(amount, [
            (0, $530fa672789495a8$export$eebccb886b064713)
        ])
};
const $f06d3e9cba2eb15c$var$store = (0, $GtRbT.createStore)({
    name: (0, $afbb2078a4e12c1d$export$7a3d0824e907e616),
    actions: $f06d3e9cba2eb15c$export$e324594224ef24da,
    initialState: $f06d3e9cba2eb15c$export$d4c72bab9d6cc13a
});
const $f06d3e9cba2eb15c$export$e17993c41bc4dc38 = (0, $iJq0l.createHook)($f06d3e9cba2eb15c$var$store, {
    selector: null
});
const $f06d3e9cba2eb15c$export$896ce0ae2b68d03a = (0, $iJq0l.createHook)($f06d3e9cba2eb15c$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$f95f1a684a17f189]
});
const $f06d3e9cba2eb15c$export$7f929adce53e9217 = (0, $iJq0l.createHook)($f06d3e9cba2eb15c$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$6e58b6b0aa48a271]
});
const $f06d3e9cba2eb15c$export$e92f6fc9e0c6d135 = (0, $iJq0l.createHook)($f06d3e9cba2eb15c$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$91a9dba2d38d9a6f]
});
const $f06d3e9cba2eb15c$export$49e6afd92506d2b4 = (0, $iJq0l.createHook)($f06d3e9cba2eb15c$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$6737b9227f60f39d]
});
const $f06d3e9cba2eb15c$export$b09f7ee747d8bc9 = (0, $iJq0l.createHook)($f06d3e9cba2eb15c$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$20f1031cc9fdf29e]
});
const $f06d3e9cba2eb15c$export$56f40dc3d5e1af94 = (0, $iJq0l.createHook)($f06d3e9cba2eb15c$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$eebccb886b064713]
});
const $f06d3e9cba2eb15c$export$878515009e0790e0 = (0, $6E16M.createContainer)($f06d3e9cba2eb15c$var$store);

});
const $530fa672789495a8$export$91a9dba2d38d9a6f = 'projects';
const $530fa672789495a8$export$ebb48b08205007c5 = 'issues';
const $530fa672789495a8$export$6737b9227f60f39d = 'filters';
const $530fa672789495a8$export$6e58b6b0aa48a271 = 'dashboards';
const $530fa672789495a8$export$20f1031cc9fdf29e = 'queues';
const $530fa672789495a8$export$f95f1a684a17f189 = 'boards';
const $530fa672789495a8$export$3c11110d46d67e8c = 'jwmBoards';
const $530fa672789495a8$export$5e2cc09b58170ca2 = 'addons';
const $530fa672789495a8$export$eebccb886b064713 = 'plans';
const $530fa672789495a8$export$1c2ea36059c73937 = 'alerts';

parcelRegister("fILaE", function(module, exports) {

$parcel$export(module.exports, "fetchFavoriteItems", () => $58e8c8fbf2cc723a$export$ba7e2966560509a6);

var $ecVtO = parcelRequire("ecVtO");

var $b5RwB = parcelRequire("b5RwB");

var $1oMOM = parcelRequire("1oMOM");

var $4FYpn = parcelRequire("4FYpn");

const $58e8c8fbf2cc723a$var$handleError = (error)=>{
    throw error;
};
// This is horrible but the API is wrong: the type returned is singular while
// everywhere else (even in add/remove) is plural
// @ts-expect-error - TS7031 - Binding element 'items' implicitly has an 'any' type.
const $58e8c8fbf2cc723a$var$convertTypeToPlural = ({ items: items, ...rest })=>({
        ...rest,
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        items: items.filter(Boolean).map((item)=>({
                ...item,
                type: `${item.type}s`
            }))
    });
const $58e8c8fbf2cc723a$export$ba7e2966560509a6 = async ({ count: count, types: types = [
    (0, $530fa672789495a8$export$91a9dba2d38d9a6f),
    (0, $530fa672789495a8$export$6e58b6b0aa48a271),
    (0, $530fa672789495a8$export$6737b9227f60f39d),
    (0, $530fa672789495a8$export$eebccb886b064713)
] })=>{
    const query = (0, $b5RwB.stringify)((0, (/*@__PURE__*/$parcel$interopDefault($ecVtO)))(types.map((type)=>[
            type,
            count
        ])));
    const url = `/rest/internal/2/favourites?${query}`;
    try {
        const response = await fetch(url, (0, $1oMOM.getDefaultOptions)(url));
        if (!response.ok) {
            const errorCode = response.status;
            if (errorCode === 401) return $58e8c8fbf2cc723a$var$handleError(new (0, $4FYpn.AuthenticationError)(`${errorCode}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $58e8c8fbf2cc723a$var$handleError(new Error(errorCode));
        }
        const resp = await response.json();
        return resp.map($58e8c8fbf2cc723a$var$convertTypeToPlural);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $58e8c8fbf2cc723a$var$handleError(error);
    }
};
const $58e8c8fbf2cc723a$export$77fc2acdef452939 = async (item)=>{
    const url = '/rest/internal/2/favourites';
    try {
        const response = await fetch(url, {
            ...(0, $1oMOM.getDefaultOptions)(url),
            method: 'POST',
            body: JSON.stringify({
                entity: {
                    id: item.id,
                    type: item.type
                },
                beforeEntityPosition: null
            })
        });
        if (!response.ok) {
            const errorCode = response.status;
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $58e8c8fbf2cc723a$var$handleError(new Error(errorCode));
        }
        const result = await response.json();
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $58e8c8fbf2cc723a$var$handleError(error);
    }
};
const $58e8c8fbf2cc723a$export$acbe6ca9570854bd = async (item)=>{
    const url = `/rest/internal/2/favourites/${item.type}/${item.id}`;
    try {
        const response = await fetch(url, {
            ...(0, $1oMOM.getDefaultOptions)(url),
            method: 'DELETE'
        });
        if (!response.ok) {
            const errorCode = response.status;
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $58e8c8fbf2cc723a$var$handleError(new Error(errorCode));
        }
        const result = await response.json();
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $58e8c8fbf2cc723a$var$handleError(error);
    }
};

});
parcelRegister("4FYpn", function(module, exports) {

$parcel$export(module.exports, "AuthenticationError", () => $a395b712d4589999$export$cf0c46b07324e9c5);
class $a395b712d4589999$export$cf0c46b07324e9c5 extends Error {
    constructor(message){
        super(message);
        this.name = 'AuthenticationError';
        this.skipSentry = true;
        this.statusCode = 401;
    }
}

});


const $afbb2078a4e12c1d$export$ea341e6cc435ed40 = 15;
const $afbb2078a4e12c1d$export$7a3d0824e907e616 = 'navigation-favourite-store';


parcelRegister("cfwEM", function(module, exports) {

$parcel$export(module.exports, "EditionAwareness", () => $7991a2b5dc7ebd5f$export$a55b02efe3d62583);

var $eJOHy = parcelRequire("eJOHy");

var $9Xpv1 = parcelRequire("9Xpv1");

var $dTV4H = parcelRequire("dTV4H");

var $1KdDN = parcelRequire("1KdDN");

var $4xbv3 = parcelRequire("4xbv3");
var $f1Zdy = parcelRequire("f1Zdy");

var $lUto7 = parcelRequire("lUto7");

var $gZTP9 = parcelRequire("gZTP9");

var $16sa1 = parcelRequire("16sa1");

var $k9fVH = parcelRequire("k9fVH");

var $4icxE = parcelRequire("4icxE");

var $kEUB1 = parcelRequire("kEUB1");

var $lctcw = parcelRequire("lctcw");

var $gYnSx = parcelRequire("gYnSx");

var $8q7lT = parcelRequire("8q7lT");

var $g1NZW = parcelRequire("g1NZW");

var $7jTnu = parcelRequire("7jTnu");

var $igNUx = parcelRequire("igNUx");

var $euq3J = parcelRequire("euq3J");

var $5zh0z = parcelRequire("5zh0z");
const $7991a2b5dc7ebd5f$var$EditionAwarenessPlatformInnerWithRTCheck = (props)=>{
    const { isReady: isReady, isInReverseTrial: isInReverseTrial, onOpenOnboardingMenu: onOpenOnboardingMenu } = (0, $5zh0z.useReverseTrials)();
    // We need to wait for the reverse trial check to be complete before rendering the button
    const canRender = props.canRender && isReady;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k9fVH.EditionAwareness), {
        ...props,
        isInReverseTrial: isInReverseTrial,
        onOpenOnboardingMenu: onOpenOnboardingMenu,
        canRender: canRender
    });
};
const $7991a2b5dc7ebd5f$var$EditionAwarenessPlatformInner = (props)=>{
    const { isDismissed: isDismissed, handleDismiss: handleDismiss } = (0, $9Xpv1.useIsEditionAwarenessPillDismissed)(props.product);
    const { isEligibleForUpsellEa: isEligibleForUpsellEa } = (0, $dTV4H.useIsEligibleForUpsellEa)({
        product: props.product,
        edition: props.edition,
        isSiteAdmin: Boolean(props.userRoles?.includes('SITE_ADMIN'))
    });
    return isEligibleForUpsellEa ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4icxE.EditionAwarenessUpsell), (({ product: product, cloudId: cloudId, edition: edition, userRoles: userRoles })=>({
            product: product,
            cloudId: cloudId,
            edition: edition,
            userRoles: userRoles,
            hasDismissedButton: isDismissed,
            onDismissButton: handleDismiss
        }))(props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k9fVH.EditionAwareness), props);
};
const $7991a2b5dc7ebd5f$var$EditionAwarenessPlatform = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const accountId = (0, $8q7lT.useAccountId)();
    const environment = (0, $g1NZW.useEnvironment)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const isJiraAdmin = (0, $gZTP9.useIsAdmin)();
    const { product: product, edition: edition } = (0, $euq3J.useProductAndEdition)();
    const isFedRampEnv = (0, $igNUx.isFedRamp)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const userRoles = (0, $eJOHy.useMemo)(()=>{
        const roles = [];
        if (isSiteAdmin) roles.push('SITE_ADMIN');
        if (isJiraAdmin) roles.push('JIRA_ADMIN');
        return roles;
    }, [
        isSiteAdmin,
        isJiraAdmin
    ]);
    // Calculate which editions need to fetch traits
    const [siteTraits, setSiteTraits] = (0, $eJOHy.useState)(()=>{
        if (edition === 'standard' && product === 'jira') return undefined;
        return edition === 'free' ? undefined : [];
    });
    (0, $eJOHy.useEffect)(()=>{
        if (siteTraits === undefined) (0, $lctcw.memoizedFetchSitePersonalization)({
            cloudId: cloudId
        }).then((traits)=>{
            setSiteTraits(traits);
        }).catch((e)=>{
            setSiteTraits([]);
            const event = createAnalyticsEvent({});
            (0, $gYnSx.default)({
                event: event,
                meta: {
                    id: 'editionAwarenessGrowthCohortTrait',
                    packageName: 'edition-awareness',
                    teamName: 'growth-tako'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        cloudId,
        createAnalyticsEvent,
        edition,
        siteTraits
    ]);
    // We need to wait for the siteType to be set before rendering the button
    const canRender = siteTraits !== undefined;
    // eslint-disable-next-line no-nested-ternary
    const editionAwarenessProps = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-2') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>{
        if (!product || !edition) return null;
        if (!accountId && (0, $7jTnu.fg)('edition_awareness_account_id_required')) // We don't render when the customer is not logged in
        return null;
        return {
            edition: edition,
            cloudId: cloudId,
            product: product,
            accountId: accountId,
            environment: environment,
            userRoles: userRoles,
            siteTraits: siteTraits,
            canRender: canRender
        };
    }, [
        accountId,
        canRender,
        cloudId,
        edition,
        environment,
        userRoles,
        product,
        siteTraits
    ]) : !product || !edition || !accountId && (0, $7jTnu.fg)('edition_awareness_account_id_required') ? null : {
        edition: edition,
        cloudId: cloudId,
        product: product,
        accountId: accountId,
        environment: environment,
        userRoles: userRoles,
        siteTraits: siteTraits,
        canRender: canRender
    };
    if (!(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-2')) {
        // we are now doing these check within the editionAwarenessProps memo, and if editionAwarenessProps is null we return null later
        if (!product || !edition) return null;
        if (!accountId && (0, $7jTnu.fg)('edition_awareness_account_id_required')) // We don't render when the customer is not logged in
        return null;
    }
    if (!editionAwarenessProps) return null;
    if (isFedRampEnv && (0, $7jTnu.fg)('edition_awareness_fed_ramp_exclusion')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: {
            isSiteAdmin: isSiteAdmin,
            product: product,
            edition: edition
        }
    }, edition === 'premium' && product === 'jira' ? // We need to call a few hooks to check RT, could be cleaned up in the future
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7991a2b5dc7ebd5f$var$EditionAwarenessPlatformInnerWithRTCheck, editionAwarenessProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7991a2b5dc7ebd5f$var$EditionAwarenessPlatformInner, editionAwarenessProps));
};
const $7991a2b5dc7ebd5f$export$a55b02efe3d62583 = ()=>{
    // This component is not rendered on the server, we don't have enough information to determine if it will be renderer or not
    // Don't remove because it may cause the SSR to fail, at this point it because the EditonAwarenessButton is using useLazyLoadQuery
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "edition-awareness"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "EditionAwareness",
        packageName: "jiraNavigationAppsSidebarEditionAwareness",
        fallback: "unmount",
        teamName: "growth-tako"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7991a2b5dc7ebd5f$var$EditionAwarenessPlatform, null)));
};

});
parcelRegister("9Xpv1", function(module, exports) {

$parcel$export(module.exports, "useIsEditionAwarenessPillDismissed", () => $8282dbcbead58be8$export$7cb865d6d91f9a4d);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $188GL = parcelRequire("188GL");
const $8282dbcbead58be8$export$7cb865d6d91f9a4d = (product)=>{
    const [hasFetched, setHasFetched] = (0, $eJOHy.useState)(false);
    const [isDismissed, setIsDismissed] = (0, $eJOHy.useState)(true);
    const canDismiss = product === 'jira-product-discovery' ? (0, $7jTnu.fg)('upsell_edition_awareness_jpd_fg') : (0, $7jTnu.fg)('edition_awareness_upsell_jira_ab_fg');
    (0, $eJOHy.useEffect)(()=>{
        if (canDismiss) (0, $188GL.fetchEditionAwarenessPillDismissed)().then((result)=>{
            // if result is undefined, it means the call failed and we can't be certain if the user dismissed the pill or not
            if (result !== undefined) {
                setIsDismissed(!!result);
                setHasFetched(true);
            }
        });
    }, [
        canDismiss
    ]);
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        if (canDismiss) {
            setIsDismissed(true);
            (0, $188GL.setEditionAwarenessPillDismissed)(true);
        }
    }, [
        canDismiss
    ]);
    return {
        hasFetched: hasFetched,
        isDismissed: isDismissed,
        handleDismiss: handleDismiss
    };
};

});
parcelRegister("188GL", function(module, exports) {

$parcel$export(module.exports, "setEditionAwarenessPillDismissed", () => $d518b7568ce924cc$export$b0b754c480c139ac);
$parcel$export(module.exports, "fetchEditionAwarenessPillDismissed", () => $d518b7568ce924cc$export$1eb6cd4dd0048115);

var $9DB7T = parcelRequire("9DB7T");

var $gYnSx = parcelRequire("gYnSx");

const $d518b7568ce924cc$var$ProductKeyToHAMSMap = {
    jira: 'jira-software',
    'jira-product-discovery': 'jira-product-discovery',
    'jira-service-management': 'jira-servicedesk'
};
const $d518b7568ce924cc$export$291d012eb0744b34 = (product)=>{
    return $d518b7568ce924cc$var$ProductKeyToHAMSMap[product];
};
const $d518b7568ce924cc$export$b0b754c480c139ac = async (value)=>{
    try {
        await (0, $9DB7T.userPreferenceAPI).set((0, $e6e0b17becc5e339$export$83e119fb36bc846a), value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $gYnSx.default)({
            error: err,
            meta: {
                id: 'setEditionAwarenessPillDismissed',
                packageName: (0, $e6e0b17becc5e339$export$52483b87432059f1)
            }
        });
    }
};
const $d518b7568ce924cc$export$1eb6cd4dd0048115 = async ()=>{
    try {
        return await (0, $9DB7T.userPreferenceAPI).get((0, $e6e0b17becc5e339$export$83e119fb36bc846a));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // 404 is acceptable as it means user hasn't dismissed it yet
        if (err.statusCode === 404) return null;
        (0, $gYnSx.default)({
            error: err,
            meta: {
                id: 'fetchEditionAwarenessPillDismissed',
                packageName: (0, $e6e0b17becc5e339$export$52483b87432059f1)
            }
        });
        return undefined;
    }
};

});
const $e6e0b17becc5e339$export$52483b87432059f1 = 'jiraEditionAwarenessForStandardToPremium';
const $e6e0b17becc5e339$export$83e119fb36bc846a = 'jira.user.theme.standard-to-premium-ea-pill.dismissed';



parcelRegister("dTV4H", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleForUpsellEa", () => $cb664e593b493fd5$export$d937ac4841c15ef7);
/* eslint-disable jira/ff/unsafe-no-exposure */ /* eslint-disable jira/deprecations/ban-identifiers */ 

var $9HmCl = parcelRequire("9HmCl");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $afhk3 = parcelRequire("afhk3");
const $cb664e593b493fd5$export$d937ac4841c15ef7 = ({ product: product, edition: edition, isSiteAdmin: isSiteAdmin })=>{
    const isJpd = product === (0, $e08dff4ae358d899$export$202f50ee62667e32);
    const [expConfig] = isJpd ? (0, $epTsa.UNSAFE_noExposureExp)('edition_awareness_upsell_jpd') : (0, $epTsa.UNSAFE_noExposureExp)('edition_awareness_upsell_jira_ab');
    const passesFeatureGate = isJpd ? (0, $7jTnu.fg)('upsell_edition_awareness_jpd_fg') : (0, $7jTnu.fg)('edition_awareness_upsell_jira_ab_fg');
    const productEntitlementDetails = (0, $9HmCl.useProductEntitlementDetails)();
    const cohort = expConfig.get('cohort', 'not-enrolled');
    const enrolled = cohort !== 'not-enrolled';
    // Trial State logic
    let productKey;
    switch(product){
        case 'jira':
            productKey = (0, $e08dff4ae358d899$export$1346c9aa3cbb477d);
            break;
        case 'jira-service-management':
            productKey = (0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61);
            break;
        case 0, $e08dff4ae358d899$export$202f50ee62667e32:
            productKey = (0, $e08dff4ae358d899$export$202f50ee62667e32);
            break;
        default:
    }
    const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
    const trialDaysLeft = (0, $afhk3.getTrialDaysLeftFromTrialEndTime)(entitlementDetails?.trialEndTime);
    const isInTrial = !entitlementDetails ? undefined : !!trialDaysLeft && trialDaysLeft > 0;
    // Check if site is in pre-dunning period
    // If firstPredunningEndTime exists and current time is before it, site is in pre-dunning
    // If firstPredunningEndTime doesn't exist, site is not in pre-dunning
    const isInPreDunning = !entitlementDetails ? undefined : entitlementDetails.firstPredunningEndTime !== undefined && Date.now() <= entitlementDetails.firstPredunningEndTime;
    const isEligibleForUpsellEa = edition === 'standard' && enrolled && isInTrial === false && isInPreDunning === false && isSiteAdmin && passesFeatureGate;
    return {
        isEligibleForUpsellEa: isEligibleForUpsellEa,
        cohort: cohort
    };
};

});

parcelRegister("euq3J", function(module, exports) {

$parcel$export(module.exports, "useProductAndEdition", () => $ff20f75f2ccd94bd$export$b0f1c0403c557678);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $eWzpp = parcelRequire("eWzpp");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");

var $8JLU7 = parcelRequire("8JLU7");
const $ff20f75f2ccd94bd$export$8aab08255f8e5ef0 = {
    FREE_EDITION: 'free',
    STANDARD_EDITION: 'standard',
    PREMIUM_EDITION: 'premium'
};
const $ff20f75f2ccd94bd$export$7e5a22794fbe56f2 = {
    [(0, $ln6Iy.SOFTWARE_PROJECT)]: 'jira',
    [(0, $ln6Iy.CORE_PROJECT)]: 'jira',
    [(0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT)]: 'jira-product-discovery',
    [(0, $ln6Iy.SERVICE_DESK_PROJECT)]: 'jira-service-management'
};
const $ff20f75f2ccd94bd$export$b0f1c0403c557678 = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    const { loading: loading, data: project } = (0, $eWzpp.useProject)();
    const siteHasOnlyJira = (0, $8JLU7.useSiteHasOnlyJira)();
    // Show premium pill button for JSM premium trial experiment
    const projectType = (0, $eJOHy.useMemo)(()=>{
        if (loading) return;
        const type = (0, $ln6Iy.toProjectType)(project?.type);
        if (type) return type;
        if (siteHasOnlyJira) return 0, $ln6Iy.SOFTWARE_PROJECT;
    }, [
        loading,
        project?.type,
        siteHasOnlyJira
    ]);
    const applicationEdition = (0, $eJOHy.useMemo)(()=>{
        if (!projectType) return;
        if (siteHasOnlyJira) return (0, $a9ldn.getEditionForProject)((0, $ln6Iy.SOFTWARE_PROJECT), appEditions);
        return (0, $a9ldn.getEditionForProject)(projectType, appEditions);
    }, [
        appEditions,
        projectType,
        siteHasOnlyJira
    ]);
    const { product: product, edition: edition } = (0, $eJOHy.useMemo)(()=>{
        if (!projectType || !applicationEdition) // We don't have a product or edition, so return nothing
        return {};
        if (projectType === (0, $ln6Iy.CORE_PROJECT) && !siteHasOnlyJira) // We are supporting only JWM implicit licensing when the parent license is JSW
        // Do not show on core products if site does not have only Jira
        return {};
        return {
            product: $ff20f75f2ccd94bd$export$7e5a22794fbe56f2[projectType],
            edition: $ff20f75f2ccd94bd$export$8aab08255f8e5ef0[applicationEdition]
        };
    }, [
        applicationEdition,
        projectType,
        siteHasOnlyJira
    ]);
    return {
        product: product,
        edition: edition
    };
};

});

parcelRegister("5zh0z", function(module, exports) {

$parcel$export(module.exports, "useReverseTrials", () => $fcb777164f524568$export$8f6d4c7745b1e143);

var $eJOHy = parcelRequire("eJOHy");

var $6BWBy = parcelRequire("6BWBy");

var $9ycBx = parcelRequire("9ycBx");

var $gxP9D = parcelRequire("gxP9D");

var $157bu = parcelRequire("157bu");
const $fcb777164f524568$export$8f6d4c7745b1e143 = ()=>{
    const openChecklist = (0, $157bu.useOpenChecklist)();
    const [{ currentTaskGroupParent: currentTaskGroupParent }, { changeTaskGroupParent: changeTaskGroupParent, nextOpenTask: nextOpenTask }] = (0, $gxP9D.useJswOnboarding)();
    const { isInReverseTrial: isInReverseTrial, isReady: isRTReady } = (0, $6BWBy.useInReverseTrial)();
    const onOpenOnboardingMenu = (0, $eJOHy.useCallback)(()=>{
        const taskGroupToEnter = (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK);
        if (currentTaskGroupParent !== taskGroupToEnter) changeTaskGroupParent(taskGroupToEnter);
        openChecklist({
            trigger: 'ReverseTrialPopup'
        });
        nextOpenTask((0, $9ycBx.ADVANCED_ROADMAPS_TASK), {
            closeNudge: true
        });
    }, [
        currentTaskGroupParent,
        openChecklist,
        nextOpenTask,
        changeTaskGroupParent
    ]);
    if (!isRTReady) return {
        isReady: false,
        isInReverseTrial: undefined,
        onOpenOnboardingMenu: undefined
    };
    return {
        isReady: true,
        isInReverseTrial: isInReverseTrial,
        onOpenOnboardingMenu: onOpenOnboardingMenu
    };
};

});
parcelRegister("6BWBy", function(module, exports) {

$parcel$export(module.exports, "useInReverseTrial", () => $794f89c220c2a333$export$76f7829aa123c9c4);

var $01Isa = parcelRequire("01Isa");

var $cfSuG = parcelRequire("cfSuG");
/**
 * This hook is used to check if the user is signed up in a reverse trial
 * and also user is within the attribution window
 * which identify the user is currently in the 'first' reverse trial
 */ const $794f89c220c2a333$var$ATTRIBUTION_WINDOW = 45; // days
const $794f89c220c2a333$export$750abf5956643c1a = 86400000;
const $794f89c220c2a333$export$76f7829aa123c9c4 = ()=>{
    const firstActivationDate = (0, $01Isa.useFirstActivationDateMs)();
    const { premiumTrialOnSignup: premiumTrialOnSignup, isReady: isReady } = (0, $cfSuG.useFetchOnboardingReverseTrial)();
    if (isReady) return {
        isInReverseTrial: premiumTrialOnSignup && !!firstActivationDate && Date.now() - firstActivationDate <= $794f89c220c2a333$var$ATTRIBUTION_WINDOW * $794f89c220c2a333$export$750abf5956643c1a,
        isReady: isReady
    };
    return {
        isInReverseTrial: undefined,
        isReady: isReady
    };
};

});
parcelRegister("cfSuG", function(module, exports) {

$parcel$export(module.exports, "useFetchOnboardingReverseTrial", () => $5c65dd7c35521683$export$349fbee95cd03b58);

var $eJOHy = parcelRequire("eJOHy");

var $kGrDm = parcelRequire("kGrDm");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $6o0qB = parcelRequire("6o0qB");

var $6zABd = parcelRequire("6zABd");
const $5c65dd7c35521683$var$store = (0, $GtRbT.createStore)({
    name: 'jsw-onboarding-reverse-trial',
    initialState: (0, $kGrDm.initialCachedEndpointState),
    actions: $6zABd.actions
});
const $5c65dd7c35521683$export$6758b294795e1644 = (0, $iJq0l.createHook)($5c65dd7c35521683$var$store);
const $5c65dd7c35521683$export$349fbee95cd03b58 = ()=>{
    const isTargetedForReverseTrials = (0, $6o0qB.useIsTargetedForReverseTrials)();
    const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { getPremiumTrialOnSignup: getPremiumTrialOnSignup }] = $5c65dd7c35521683$export$6758b294795e1644();
    (0, $eJOHy.useEffect)(()=>{
        if (isTargetedForReverseTrials && !fetchedOnce && !isFetching && data === undefined) // @ts-expect-error Arguments for the rest parameter 'args' were not provided.
        getPremiumTrialOnSignup();
    }, [
        data,
        fetchedOnce,
        getPremiumTrialOnSignup,
        isFetching,
        isTargetedForReverseTrials
    ]);
    if (!isTargetedForReverseTrials) // If not targeted, no fetching is done. Data is ready to be read
    return {
        premiumTrialOnSignup: undefined,
        reverseTrialCohort: data?.reverseTrialCohort,
        isReady: true
    };
    return {
        premiumTrialOnSignup: data?.premiumTrialOnSignup,
        reverseTrialCohort: data?.reverseTrialCohort,
        isReady: fetchedOnce && !isFetching
    };
};

});
parcelRegister("kGrDm", function(module, exports) {

$parcel$export(module.exports, "initialCachedEndpointState", () => $dc3f78aa52a1e2f1$export$aaed2d023c5dc2c);
const $dc3f78aa52a1e2f1$export$aaed2d023c5dc2c = {
    isFetching: false,
    wasFetched: false,
    fetchedOnce: false,
    fetchError: null
};

});

parcelRegister("6o0qB", function(module, exports) {

$parcel$export(module.exports, "useIsTargetedForReverseTrials", () => $4e29293fe8e38e32$export$897219a3ca9649b9);

var $ln6Iy = parcelRequire("ln6Iy");

var $2aY2d = parcelRequire("2aY2d");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");
const $4e29293fe8e38e32$export$897219a3ca9649b9 = ()=>{
    const { data: projectContextData } = (0, $2aY2d.useProjectContext)();
    const jswEdition = (0, $8vyDv.useAppEditions)().software;
    const isCurrentProjectJSW = projectContextData?.projectType === (0, $ln6Iy.SOFTWARE_PROJECT);
    if (jswEdition === (0, $a9ldn.PREMIUM_EDITION) && isCurrentProjectJSW) return true;
    return false;
};

});

parcelRegister("6zABd", function(module, exports) {

$parcel$export(module.exports, "actions", () => $6e7dc5974142688f$export$e324594224ef24da);

var $2GZwt = parcelRequire("2GZwt");

var $31GRl = parcelRequire("31GRl");
const $6e7dc5974142688f$var$getPremiumTrialOnSignup = (0, $2GZwt.cachedEndpointCall)((0, $31GRl.getOnboardingPremiumTrialWithRethrow));
const $6e7dc5974142688f$export$e324594224ef24da = {
    getPremiumTrialOnSignup: $6e7dc5974142688f$var$getPremiumTrialOnSignup
};

});
parcelRegister("2GZwt", function(module, exports) {

$parcel$export(module.exports, "cachedEndpointCall", () => $8df7eb92b5eb0600$export$9ab04ab45a9b99da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $8df7eb92b5eb0600$export$9ab04ab45a9b99da = (call)=>(params)=>async ({ getState: getState, setState: setState })=>{
            const { isFetching: isFetching, wasFetched: wasFetched, fetchedOnce: fetchedOnce } = getState();
            if (isFetching || wasFetched) return;
            setState({
                isFetching: true
            });
            try {
                const data = await call(params);
                if (data !== null) setState({
                    data: data,
                    wasFetched: true
                });
                else setState({
                    wasFetched: fetchedOnce
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    fetchedOnce: true
                });
            }
        };

});




parcelRegister("157bu", function(module, exports) {

$parcel$export(module.exports, "useOpenChecklist", () => $cf9cb09864191601$export$318fa8576ad8aa73);

var $f1Zdy = parcelRequire("f1Zdy");

var $dfP3D = parcelRequire("dfP3D");

var $dslup = parcelRequire("dslup");

var $9ycBx = parcelRequire("9ycBx");

var $gxP9D = parcelRequire("gxP9D");

var $dELL6 = parcelRequire("dELL6");
const $cf9cb09864191601$export$318fa8576ad8aa73 = ()=>{
    const [{ openTask: currentOpenTask }, { nextSetChecklistIsOpen: nextSetChecklistIsOpen, nextSetChecklistIsDismissed: nextSetChecklistIsDismissed, nextOpenTask: nextOpenTask }] = (0, $gxP9D.useJswOnboarding)();
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [quickstartStatus] = (0, $gxP9D.useQuickstartUiStatus)();
    const currentRightSidebarState = (0, $dfP3D.useActiveRightSidebarState)();
    const currentPanelId = currentRightSidebarState?.panelId;
    const openChecklist = ({ trigger: trigger, openTask: openTask })=>{
        if (openTask && openTask !== currentOpenTask) nextOpenTask(openTask);
        openRightSidebar((0, $dslup.PANEL_ID), (0, $dslup.PANEL_WIDTH), false, true);
        (0, $dELL6.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
            quickstartStatus: quickstartStatus,
            currentRightSidebarPanelId: currentPanelId || '',
            openRightSidebarToTop: true,
            trigger: trigger
        });
        if (quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED) nextSetChecklistIsDismissed(false);
        else nextSetChecklistIsOpen(true);
    };
    return openChecklist;
};

});
parcelRegister("dslup", function(module, exports) {

$parcel$export(module.exports, "PANEL_ID", () => $cfc5e4d2583c224c$export$e1d562d81d0e502d);
$parcel$export(module.exports, "PANEL_WIDTH", () => $cfc5e4d2583c224c$export$e05cfff20e9274e6);
$parcel$export(module.exports, "PERFORMANCE_METRIC_PREFIX", () => $cfc5e4d2583c224c$export$495d0560d6ea05d0);
$parcel$export(module.exports, "PERFORMANCE_MARK", () => $cfc5e4d2583c224c$export$5da8d06749e84d86);
const $cfc5e4d2583c224c$export$e1d562d81d0e502d = 'jsw-nux-onboarding-checklist';
const $cfc5e4d2583c224c$export$e05cfff20e9274e6 = 360;
const $cfc5e4d2583c224c$export$495d0560d6ea05d0 = 'onboarding-quickstart';
const $cfc5e4d2583c224c$export$5da8d06749e84d86 = {
    BUNDLE_LOAD_START: 'bundleLoaded',
    BUNDLE_LOAD_END: 'bundleLoadedEnd'
};

});




parcelRegister("h8yfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ce1d7efa695a958$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $2ce1d7efa695a958$var$LazyNav4RolloutAnalytics = (0, $gzcjr.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("9bIvg"))).then(({ Nav4RolloutAnalytics: Nav4RolloutAnalytics })=>Nav4RolloutAnalytics), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/rollout/analytics/src/index.tsx"
});
const $2ce1d7efa695a958$var$AsyncNav4RolloutAnalytics = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "async-nav4-rollout-analytics",
        fallback: "unmount",
        packageName: "jiraNavigationAppsSidebarNav4RolloutAnalytics",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "lazy-nav4-rollout-analytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2ce1d7efa695a958$var$LazyNav4RolloutAnalytics, null)));
$2ce1d7efa695a958$var$AsyncNav4RolloutAnalytics.displayName = 'AsyncNav4RolloutAnalytics';
var $2ce1d7efa695a958$export$2e2bcd8739ae039 = $2ce1d7efa695a958$var$AsyncNav4RolloutAnalytics;

});
parcelRegister("9bIvg", function(module, exports) {

$parcel$export(module.exports, "Nav4RolloutAnalytics", () => $16fdd4347716eb59$export$89671fab480c820b);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $iyTaR = parcelRequire("iyTaR");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $eFrz1 = parcelRequire("eFrz1");

var $6zXPf = parcelRequire("6zXPf");


const $16fdd4347716eb59$export$89671fab480c820b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "nav4-rollout-analytics",
        fallback: "unmount",
        packageName: (0, $d6576400092700bc$export$b8b9d90f9e5bd72b),
        teamName: (0, $d6576400092700bc$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16fdd4347716eb59$export$4bf890a38f5eb199, props));
const $16fdd4347716eb59$export$4bf890a38f5eb199 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    // This should only run once. Fix for https://jplat.atlassian.net/browse/BLU-5516
    // and for React Concurrent.
    (0, $eFrz1.useEffectWithoutConcurrency)(()=>{
        const nav4Rollout = (0, $iyTaR.getNav4Rollout)();
        // Now that the GA stage has started, nearly all tenants should be in a rollout stage.
        // Don't exclude tenants with a stage of 'none' as we may need to know who they are.
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'topNav viewed', {
            ...nav4Rollout,
            navState: (0, $6zXPf.getWillShowNav4)() ? (0, $107c403b1827dc68$export$2bd315ece9f68967) : (0, $107c403b1827dc68$export$d2aa6c54a5925f01)
        });
    }, [
        createAnalyticsEvent
    ]);
    return null;
};

});
const $d6576400092700bc$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4RolloutAnalytics';
const $d6576400092700bc$export$d57b6b390e78d90f = 'jira-cosmos';



parcelRegister("qzoYE", function(module, exports) {

$parcel$export(module.exports, "useRecentActions", () => $28b016429ca0fd70$export$5c0647984dfa7d27);
$parcel$export(module.exports, "useRecentAllSingleList", () => $28b016429ca0fd70$export$9a54f46f5b7734c);
$parcel$export(module.exports, "useWorkedOnAllSingleList", () => $28b016429ca0fd70$export$e8278a7bcff1ec98);
$parcel$export(module.exports, "useRecentBoards", () => $28b016429ca0fd70$export$3731bd023be4f71);
$parcel$export(module.exports, "useRecentDashboards", () => $28b016429ca0fd70$export$81cb5beef51d43ca);
$parcel$export(module.exports, "useRecentProjects", () => $28b016429ca0fd70$export$f6b9a13c4ec08b45);
$parcel$export(module.exports, "useRecentFilters", () => $28b016429ca0fd70$export$8d2bfb6d3657bae2);
$parcel$export(module.exports, "useRecentQueues", () => $28b016429ca0fd70$export$8756abb0bb90a56e);
$parcel$export(module.exports, "RecentsContainer", () => $28b016429ca0fd70$export$5de14a1c1400859e);


var $4k95d = parcelRequire("4k95d");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

const $28b016429ca0fd70$var$emptyItemState = {
    items: null,
    isFetching: false,
    fetchError: null,
    promise: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false
};
const $28b016429ca0fd70$export$d4c72bab9d6cc13a = {
    [(0, $530fa672789495a8$export$f95f1a684a17f189)]: {
        ...$28b016429ca0fd70$var$emptyItemState
    },
    [(0, $530fa672789495a8$export$6e58b6b0aa48a271)]: {
        ...$28b016429ca0fd70$var$emptyItemState
    },
    [(0, $530fa672789495a8$export$6737b9227f60f39d)]: {
        ...$28b016429ca0fd70$var$emptyItemState
    },
    [(0, $530fa672789495a8$export$91a9dba2d38d9a6f)]: {
        ...$28b016429ca0fd70$var$emptyItemState
    },
    [(0, $530fa672789495a8$export$20f1031cc9fdf29e)]: {
        ...$28b016429ca0fd70$var$emptyItemState
    },
    workedOn: {
        ...$28b016429ca0fd70$var$emptyItemState
    },
    all: {
        ...$28b016429ca0fd70$var$emptyItemState
    }
};
const $28b016429ca0fd70$var$transformItems = (items)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    items.reduce((acc, itemResponse)=>{
        if (itemResponse.id === 'quick-search-boards') acc[0, $530fa672789495a8$export$f95f1a684a17f189] = itemResponse.items;
        if (itemResponse.id === 'quick-search-filters') acc[0, $530fa672789495a8$export$6737b9227f60f39d] = itemResponse.items;
        if (itemResponse.id === 'quick-search-dashboards') acc[0, $530fa672789495a8$export$6e58b6b0aa48a271] = itemResponse.items;
        if (itemResponse.id === 'quick-search-projects') acc[0, $530fa672789495a8$export$91a9dba2d38d9a6f] = itemResponse.items;
        if (itemResponse.id === 'quick-search-queues') acc[0, $530fa672789495a8$export$20f1031cc9fdf29e] = itemResponse.items;
        return acc;
    }, {});
const $28b016429ca0fd70$var$transformWorkedOnItems = (response)=>// select the right data and rename it
    response.data.activities.myActivities.workedOn.nodes.map(({ object: { id: id, localResourceId: localResourceId, name: name, extension: extension, iconUrl: iconUrl, url: url, containers: containers, type: type } })=>({
            id: id,
            localResourceId: localResourceId,
            title: name,
            metadata: extension.issueKey,
            avatarUrl: iconUrl,
            url: url,
            attributes: {
                containerName: containers.find((container)=>container.type === 'PROJECT')?.name
            },
            type: `${type.toLowerCase()}s`
        }));
const $28b016429ca0fd70$var$getQueryConfig = (amount, types)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    types.reduce((acc, type)=>{
        acc[type] = amount;
        return acc;
    }, {});
const $28b016429ca0fd70$var$loadRecentItems = (amount = (0, $ed46f2cd980f21d3$export$22ea57e66775a6b2), types)=>async ({ setState: setState, getState: getState })=>{
        const typesToFetch = types.filter((type)=>!getState()[type].isFetching);
        if (typesToFetch.length) try {
            const promise = (0, $4k95d.fetchRecentItems)({
                counts: $28b016429ca0fd70$var$getQueryConfig(amount, typesToFetch)
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const loadingState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                };
                return acc;
            }, {});
            setState(loadingState);
            const itemResponse = await promise;
            const transformed = $28b016429ca0fd70$var$transformItems(itemResponse || []);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const responseState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    items: transformed[type],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                };
                return acc;
            }, {});
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                };
                return acc;
            }, {});
            setState(errorState);
        }
    };
const $28b016429ca0fd70$var$loadRecentItemsSingleList = (amount = (0, $ed46f2cd980f21d3$export$5f1b6c5e9d257e5e), types)=>async ({ setState: setState, getState: getState })=>{
        if (types.length) try {
            const promise = (0, $4k95d.fetchRecentItemsSingleList)({
                types: types,
                limit: amount
            });
            const loadingState = {
                all: {
                    ...getState().all,
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            };
            setState(loadingState);
            const itemResponse = await promise;
            const responseState = {
                all: {
                    items: itemResponse != null ? itemResponse[0].items : [],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                }
            };
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            const errorState = {
                all: {
                    ...getState().all,
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                }
            };
            setState(errorState);
        }
    };
const $28b016429ca0fd70$var$loadWorkedOnItems = (amount = (0, $ed46f2cd980f21d3$export$8666f31c8873bff))=>async ({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        try {
            const promise = (0, $4k95d.fetchWorkedOnItems)({
                cloudId: cloudId,
                amount: amount
            });
            const loadingState = {
                workedOn: {
                    ...getState().workedOn,
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            };
            setState(loadingState);
            const itemResponse = await promise;
            const transformedItems = $28b016429ca0fd70$var$transformWorkedOnItems(itemResponse);
            const responseState = {
                workedOn: {
                    items: transformedItems,
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                }
            };
            // @ts-expect-error - TS2345 - Argument of type '{ workedOn: { items: { id: string | number; localResourceId: string; title: string; metadata: string; avatarUrl: string; url: string; attributes: { containerName: string | null | undefined; }; type: string; }[]; ... 4 more ...; hasSuccessOnce: boolean; }; }' is not assignable to parameter of type 'Partial<State>'.
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            const errorState = {
                workedOn: {
                    ...getState().workedOn,
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                }
            };
            setState(errorState);
        }
    };
const $28b016429ca0fd70$export$e324594224ef24da = {
    loadRecentAll: (amount)=>async (actions2, props)=>{
            $28b016429ca0fd70$var$loadRecentItems(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $530fa672789495a8$export$f95f1a684a17f189) : undefined,
                (0, $530fa672789495a8$export$6e58b6b0aa48a271),
                (0, $530fa672789495a8$export$91a9dba2d38d9a6f),
                (0, $530fa672789495a8$export$6737b9227f60f39d),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $530fa672789495a8$export$20f1031cc9fdf29e) : undefined
            ].filter(Boolean))(actions2);
        },
    loadRecentAllSingleList: (amount)=>async (actions2, props)=>{
            $28b016429ca0fd70$var$loadRecentItemsSingleList(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $530fa672789495a8$export$f95f1a684a17f189) : undefined,
                (0, $530fa672789495a8$export$6e58b6b0aa48a271),
                (0, $530fa672789495a8$export$91a9dba2d38d9a6f),
                (0, $530fa672789495a8$export$6737b9227f60f39d),
                (0, $530fa672789495a8$export$ebb48b08205007c5),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $530fa672789495a8$export$20f1031cc9fdf29e) : undefined
            ].filter(Boolean))(actions2);
        },
    loadWorkedOnAllSingleList: $28b016429ca0fd70$var$loadWorkedOnItems,
    loadRecentBoards: (amount)=>$28b016429ca0fd70$var$loadRecentItems(amount, [
            (0, $530fa672789495a8$export$f95f1a684a17f189)
        ]),
    loadRecentProjects: (amount)=>$28b016429ca0fd70$var$loadRecentItems(amount, [
            (0, $530fa672789495a8$export$91a9dba2d38d9a6f)
        ]),
    loadRecentDashboards: (amount)=>$28b016429ca0fd70$var$loadRecentItems(amount, [
            (0, $530fa672789495a8$export$6e58b6b0aa48a271)
        ]),
    loadRecentFilters: (amount)=>$28b016429ca0fd70$var$loadRecentItems(amount, [
            (0, $530fa672789495a8$export$6737b9227f60f39d)
        ]),
    loadRecentQueues: (amount)=>$28b016429ca0fd70$var$loadRecentItems(amount, [
            (0, $530fa672789495a8$export$20f1031cc9fdf29e)
        ])
};
const $28b016429ca0fd70$var$store = (0, $GtRbT.createStore)({
    name: (0, $ed46f2cd980f21d3$export$eb2b39783d051b9),
    actions: $28b016429ca0fd70$export$e324594224ef24da,
    initialState: $28b016429ca0fd70$export$d4c72bab9d6cc13a
});
const $28b016429ca0fd70$export$5c0647984dfa7d27 = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: null
});
const $28b016429ca0fd70$export$9a54f46f5b7734c = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: (state)=>state.all
});
const $28b016429ca0fd70$export$e8278a7bcff1ec98 = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: (state)=>state.workedOn
});
const $28b016429ca0fd70$export$3731bd023be4f71 = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$f95f1a684a17f189]
});
const $28b016429ca0fd70$export$81cb5beef51d43ca = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$6e58b6b0aa48a271]
});
const $28b016429ca0fd70$export$f6b9a13c4ec08b45 = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$91a9dba2d38d9a6f]
});
const $28b016429ca0fd70$export$8d2bfb6d3657bae2 = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$6737b9227f60f39d]
});
const $28b016429ca0fd70$export$8756abb0bb90a56e = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$20f1031cc9fdf29e]
});
const $28b016429ca0fd70$export$5de14a1c1400859e = (0, $6E16M.createContainer)($28b016429ca0fd70$var$store);

});
parcelRegister("4k95d", function(module, exports) {

$parcel$export(module.exports, "fetchRecentItems", () => $5fc362b79c81ddfc$export$20d49db97b653a7b);
$parcel$export(module.exports, "fetchRecentItemsSingleList", () => $5fc362b79c81ddfc$export$a00963dad78984b8);
$parcel$export(module.exports, "fetchWorkedOnItems", () => $5fc362b79c81ddfc$export$f3763cb0ecc90572);

var $b5RwB = parcelRequire("b5RwB");


var $1oMOM = parcelRequire("1oMOM");

var $4FYpn = parcelRequire("4FYpn");

const $5fc362b79c81ddfc$var$PATH_BUCKETED = '/rest/internal/2/productsearch/search';
const $5fc362b79c81ddfc$var$PATH_SINGLE_LIST = '/rest/internal/2/productsearch/singleRecentList';
// dummy handle error
const $5fc362b79c81ddfc$var$handleError = (error)=>{
    throw error;
};
const $5fc362b79c81ddfc$var$toQuery = ({ counts: counts })=>// @ts-expect-error - TS2769 - No overload matches this call.
    Object.keys(counts) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, itemType)=>{
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<ItemType, number>>'.
        result.push(`${itemType}=${counts[itemType]}`);
        return result;
    }, []).join(',');
const $5fc362b79c81ddfc$export$20d49db97b653a7b = async ({ counts: counts })=>{
    const url = `${$5fc362b79c81ddfc$var$PATH_BUCKETED}?${(0, $b5RwB.stringify)({
        counts: $5fc362b79c81ddfc$var$toQuery({
            counts: counts
        }),
        type: Object.keys(counts).join(',')
    })}`;
    try {
        const response = await fetch(url, (0, $1oMOM.getDefaultOptions)(url));
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $44ccf6b895337c89$export$67d19e9a991baa07)) return $5fc362b79c81ddfc$var$handleError(new (0, $4FYpn.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $5fc362b79c81ddfc$var$handleError(new Error(status));
        }
        if (status === (0, $44ccf6b895337c89$export$3288b14b6745c572)) return null;
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $5fc362b79c81ddfc$var$handleError(error);
    }
};
const $5fc362b79c81ddfc$export$a00963dad78984b8 = async ({ types: types, limit: limit })=>{
    const url = $5fc362b79c81ddfc$var$PATH_SINGLE_LIST;
    try {
        const response = await fetch(url, {
            ...(0, $1oMOM.getDefaultOptions)(url),
            method: 'POST',
            body: JSON.stringify({
                groups: [
                    {
                        types: types,
                        limit: limit
                    }
                ]
            })
        });
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $44ccf6b895337c89$export$67d19e9a991baa07)) return $5fc362b79c81ddfc$var$handleError(new (0, $4FYpn.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $5fc362b79c81ddfc$var$handleError(new Error(status));
        }
        if (status === (0, $44ccf6b895337c89$export$3288b14b6745c572)) return null;
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $5fc362b79c81ddfc$var$handleError(error);
    }
};
const $5fc362b79c81ddfc$export$f3763cb0ecc90572 = async ({ cloudId: cloudId, amount: amount })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                operationName: 'jira_NavigationActivity',
                query: (0, $91b4cfd47cb3a0c0$export$2b91517d6d5b4365),
                variables: {
                    first: amount,
                    cloudID: cloudId
                }
            })
        });
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $44ccf6b895337c89$export$67d19e9a991baa07)) return $5fc362b79c81ddfc$var$handleError(new (0, $4FYpn.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $5fc362b79c81ddfc$var$handleError(new Error(status));
        }
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $5fc362b79c81ddfc$var$handleError(error);
    }
};

});
const $91b4cfd47cb3a0c0$export$2b91517d6d5b4365 = `
fragment NavigationActivityItem on ActivitiesItem {
  id
  timestamp
  object {
    id
    name
    localResourceId
    type
    url
    iconUrl
    containers {
      name
      type
    }
    extension {
      ... on ActivitiesJiraIssue {
        issueKey
      }
    }
  }
}

query jira_NavigationActivity($first: Int, $cloudID: ID!) {
  activities {
    myActivities {
      workedOn(
        first: $first,
        filters: [
          {
            type: AND,
            arguments: {
              cloudIds: [$cloudID],
              products: [JIRA, JIRA_BUSINESS, JIRA_SOFTWARE, JIRA_OPS, JIRA_SERVICE_DESK]
            }
          }
        ]
      ) {
        nodes {
          ...NavigationActivityItem
        }
      }
    }
  }
}

`;


const $ed46f2cd980f21d3$export$eb2b39783d051b9 = 'navigation-recents-store';
const $ed46f2cd980f21d3$export$22ea57e66775a6b2 = 5;
const $ed46f2cd980f21d3$export$8666f31c8873bff = 10;
const $ed46f2cd980f21d3$export$5f1b6c5e9d257e5e = 20;


parcelRegister("aN4LZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9245a40e4559b38$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5RW99 = parcelRequire("5RW99");

var $cRsK6 = parcelRequire("cRsK6");

var $gy5H8 = parcelRequire("gy5H8");
function $d9245a40e4559b38$var$AppSwitcher() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cRsK6.TopLevelErrorBoundary), {
        id: (0, $5RW99.MENU_ID).APP_SWITCHER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gy5H8.AppSwitcherTrigger), null));
}
var $d9245a40e4559b38$export$2e2bcd8739ae039 = $d9245a40e4559b38$var$AppSwitcher;

});
parcelRegister("cRsK6", function(module, exports) {

$parcel$export(module.exports, "TopLevelErrorBoundary", () => $3d19846c898db570$export$b70f1d8bd509b358);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

const $3d19846c898db570$export$b70f1d8bd509b358 = ({ id: id, children: children })=>{
    const EVENT_DATA = (0, $eJOHy.useMemo)(()=>({
            id: id
        }), [
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: `${(0, $0c5166c52045dbc3$export$4766f0c4b6fe35dc)}.${id}`,
        packageName: (0, $0c5166c52045dbc3$export$b8b9d90f9e5bd72b),
        extraEventData: EVENT_DATA,
        fallback: "unmount"
    }, children);
};

});
const $0c5166c52045dbc3$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
const $0c5166c52045dbc3$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $0c5166c52045dbc3$export$9934c8d98fd9e572 = 'atlassianSwitcher';


parcelRegister("gy5H8", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherTrigger", () => $3e4e40eb05838d12$export$dc8723dff0e69fcb);

var $eJOHy = parcelRequire("eJOHy");

var $dIoeE = parcelRequire("dIoeE");


var $5RW99 = parcelRequire("5RW99");

var $gOfBc = parcelRequire("gOfBc");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $lHlwJ = parcelRequire("lHlwJ");

var $7jTnu = parcelRequire("7jTnu");

var $8GjHG = parcelRequire("8GjHG");

var $eMKWj = parcelRequire("eMKWj");

var $hZvWR = parcelRequire("hZvWR");
function $3e4e40eb05838d12$export$dc8723dff0e69fcb() {
    const [isOpen, { on: openMenu, off: closeMenu }] = (0, $gOfBc.useTopMenus)((0, $5RW99.MENU_ID).APP_SWITCHER);
    const triggerAnalytics = (0, $dIoeE.useNavigationItemAnalytics)({
        navigationItemId: (0, $0c5166c52045dbc3$export$9934c8d98fd9e572)
    });
    const onOpen = (0, $eJOHy.useCallback)(()=>{
        openMenu();
        triggerAnalytics();
    }, [
        openMenu,
        triggerAnalytics
    ]);
    (0, $lHlwJ.useCrossJoinNudges)(!(0, $7jTnu.fg)('groot-1154-cjn-global-home'));
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            isOpen: isOpen,
            onClose: closeMenu,
            onOpen: onOpen
        }), [
        isOpen,
        closeMenu,
        onOpen
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $8GjHG.AppSwitcherIntegrationEntrypoint), entryPointParams);
    const entrypointRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eMKWj.AppSwitcherPlaceholderButton), {
        onOpen: onOpen,
        ref: entrypointRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "app-switcher-content",
        packageName: "jira-navigation-apps-topnav4-app-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hZvWR.AppSwitcherPlaceholderWithLoadingPopup), null),
        errorFallback: "flag",
        runtimeProps: entryPointParams
    }));
}

});
parcelRegister("dIoeE", function(module, exports) {

$parcel$export(module.exports, "useNavigationItemAnalytics", () => $83dfceb6ad9d0bb5$export$444d136efe970fd3);

var $eJOHy = parcelRequire("eJOHy");

var $eY50e = parcelRequire("eY50e");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");
function $83dfceb6ad9d0bb5$export$444d136efe970fd3({ navigationItemId: navigationItemId }) {
    const { isVisible: isVisible } = (0, $eY50e.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((attributes = {})=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, navigationItemId, {
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            ...attributes,
            isInMore: !isVisible,
            navigationLayer: 'global'
        });
    }, [
        createAnalyticsEvent,
        isVisible,
        navigationItemId
    ]);
}

});

parcelRegister("8GjHG", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherIntegrationEntrypoint", () => $b75db2fe04fc9a57$export$7b5dbeab5e41f2a4);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $b75db2fe04fc9a57$export$7b5dbeab5e41f2a4 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("8S8SH")), {
        moduleId: "9be44a41",
        priority: "interaction"
    }),
    getPreloadProps: (params)=>({
            extraProps: params
        })
});

});
parcelRegister("8S8SH", function(module, exports) {

let $675a417beeb7f99c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $675a417beeb7f99c$var$load("1VRB2"),
    $675a417beeb7f99c$var$load("bABhq"),
    $675a417beeb7f99c$var$load("93KGn")
]).then(()=>parcelRequire('dCJZe'));

});


parcelRegister("eMKWj", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherPlaceholderButton", () => $bd851b7a65927949$export$46b00316abad4d7b);

var $eJOHy = parcelRequire("eJOHy");

var $8wfPR = parcelRequire("8wfPR");

var $gbiVe = parcelRequire("gbiVe");

var $l42vY = parcelRequire("l42vY");

var $9MZ39 = parcelRequire("9MZ39");

var $bJscI = parcelRequire("bJscI");

var $7jTnu = parcelRequire("7jTnu");
const $bd851b7a65927949$export$46b00316abad4d7b = /*#__PURE__*/ (0, $eJOHy.forwardRef)($bd851b7a65927949$var$AppSwitcherPBWithRef);
function $bd851b7a65927949$var$AppSwitcherPBWithRef({ onOpen: onOpen, onMouseEnter: onMouseEnter }, ref) {
    if (false) {
        // Merge and remove "ForBrowser" component when cleaning jfp-magma-4013-fix-top-nav-ssr-hydration
        if (!(0, $7jTnu.fg)('jfp-magma-4013-fix-top-nav-ssr-hydration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l42vY.AppSwitcher), {
            label: (0, $9MZ39.SwitchToTooltipText),
            ref: ref
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd851b7a65927949$var$AppSwitcherPlaceholderButtonForBrowser, {
        ref: ref,
        onOpen: onOpen,
        onMouseEnter: onMouseEnter
    });
}
const $bd851b7a65927949$var$AppSwitcherPlaceholderButtonForBrowser = /*#__PURE__*/ (0, $eJOHy.forwardRef)($bd851b7a65927949$var$AppSwitcherPlaceholderButtonForBrowserWithRef);
function $bd851b7a65927949$var$AppSwitcherPlaceholderButtonForBrowserWithRef({ onOpen: onOpen, onMouseEnter: onMouseEnter }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd851b7a65927949$var$AppSwitcherLightWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l42vY.AppSwitcher), {
        ref: ref,
        onClick: onOpen,
        onMouseEnter: onMouseEnter,
        label: (0, $9MZ39.SwitchToTooltipText),
        "aria-expanded": false,
        "aria-haspopup": true
    }));
}
const $bd851b7a65927949$var$AppSwitcherLightWrapper = (0, $bJscI.componentWithFG)('app_switcher_spotlight_gate', $bd851b7a65927949$var$SpotLightWrapper, (0, $eJOHy.Fragment));
function $bd851b7a65927949$var$SpotLightWrapper(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), {
        name: "app-switcher-spotlight"
    }, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wfPR.EngagementSpotlight), {
        engagementId: "app-switcher-spotlight"
    }));
}

});

parcelRegister("hZvWR", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherPlaceholderWithLoadingPopup", () => $e93f75f8c9c8190b$export$35c8740d616fd043);

var $eJOHy = parcelRequire("eJOHy");

var $aVwGC = parcelRequire("aVwGC");

var $i8x5n = parcelRequire("i8x5n");
var $dtyGQ = parcelRequire("dtyGQ");
var $5Wv5g = parcelRequire("5Wv5g");

var $l42vY = parcelRequire("l42vY");

var $cNe2t = parcelRequire("cNe2t");

var $9MZ39 = parcelRequire("9MZ39");
function $e93f75f8c9c8190b$export$35c8740d616fd043() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e93f75f8c9c8190b$var$SkeletonContent, null),
        isOpen: true,
        messageId: "navigation-apps-topnav4-app-switcher.ui.trigger.popup.loading.popup",
        messageType: "transactional",
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: $e93f75f8c9c8190b$var$Trigger
    });
}
function $e93f75f8c9c8190b$var$Trigger(triggerProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l42vY.AppSwitcher), {
        ...triggerProps,
        label: (0, $9MZ39.SwitchToTooltipText),
        "aria-expanded": false,
        "aria-haspopup": true
    });
}
function $e93f75f8c9c8190b$var$SkeletonContent() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dtyGQ.default), {
        xcss: $e93f75f8c9c8190b$var$containerStyles,
        rowGap: "space.200",
        columnGap: "space.150",
        templateColumns: "32px 1fr"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e93f75f8c9c8190b$var$SkeletonItems, null));
}
function $e93f75f8c9c8190b$var$SkeletonItems() {
    return Array.from({
        length: 5
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
            width: "32px",
            height: "32px",
            isShimmering: true,
            borderRadius: "8px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
            justifyContent: "center",
            direction: "column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVwGC.default), {
            width: "100%",
            height: "10px",
            isShimmering: true,
            borderRadius: "4px"
        }))));
}
const $e93f75f8c9c8190b$var$containerStyles = (0, $5Wv5g.xcss)({
    width: '250px',
    padding: 'space.200'
});

});



parcelRegister("bU7HL", function(module, exports) {

$parcel$export(module.exports, "NavigationSuccessTrackerForNav3", () => $e1917730e2b34524$export$9013eebe7301dfe1);

var $eJOHy = parcelRequire("eJOHy");

var $hya93 = parcelRequire("hya93");

var $4ctwv = parcelRequire("4ctwv");

var $f2JN3 = parcelRequire("f2JN3");

var $dpFVo = parcelRequire("dpFVo");

var $hih5V = parcelRequire("hih5V");

var $kO1ht = parcelRequire("kO1ht");
const $e1917730e2b34524$var$EmptyFragment = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
const $e1917730e2b34524$var$NavigationSuccessTracker = ({ children: children })=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const ViewExperienceSuccessTrackerComponent = route.isRedirect === true ? $e1917730e2b34524$var$EmptyFragment : (0, $hya93.ExperienceSuccessTracker);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ViewExperienceSuccessTrackerComponent, {
        location: "atlassian-navigation-main",
        parentProviders: null,
        failureEventAttributes: null
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: (0, $kO1ht.EXPERIENCE_NAVIGATION_TOP_MAIN)
    }));
};
const $e1917730e2b34524$export$9013eebe7301dfe1 = (0, $f2JN3.componentWithCondition)((0, $dpFVo.getWillShowNav3), $e1917730e2b34524$var$NavigationSuccessTracker, (0, $eJOHy.Fragment));

});

parcelRegister("gg3l6", function(module, exports) {

$parcel$export(module.exports, "TopNav3Async", () => $e0f566809935efb8$export$1aaa7ad7dec6338c);

var $cJAh3 = parcelRequire("cJAh3");

var $dydef = parcelRequire("dydef");

var $gzcjr = parcelRequire("gzcjr");

const $e0f566809935efb8$export$1aaa7ad7dec6338c = (0, $gzcjr.lazyForPaint)(()=>{
    const bundleReady = (parcelRequire("4Cj6A")).then(({ TopNav3Sync: TopNav3Sync })=>TopNav3Sync);
    if (!false) bundleReady.then(()=>{
        (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $cJAh3.JS_EVAL_START))) {
            (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/top-nav/TopNav3Sync.tsx"
});

});
parcelRegister("4Cj6A", function(module, exports) {

let $35c987f3e81e3df1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $35c987f3e81e3df1$var$load("1G8UW"),
    $35c987f3e81e3df1$var$load("iSk93"),
    $35c987f3e81e3df1$var$load("7vqGd"),
    $35c987f3e81e3df1$var$load("1Y4bq"),
    $35c987f3e81e3df1$var$load("1VRB2"),
    $35c987f3e81e3df1$var$load("bABhq"),
    $35c987f3e81e3df1$var$load("56bXg")
]).then(()=>parcelRequire('cbP62'));

});


parcelRegister("edDe8", function(module, exports) {

$parcel$export(module.exports, "ConversationAssistant", () => $8ec718333c3707da$export$9777b121d71c4de1);

var $eJOHy = parcelRequire("eJOHy");

var $dhRXV = parcelRequire("dhRXV");

var $6qEVr = parcelRequire("6qEVr");

var $46nCP = parcelRequire("46nCP");

var $4ADJk = parcelRequire("4ADJk");

var $6UsU7 = parcelRequire("6UsU7");


var $f2JN3 = parcelRequire("f2JN3");

var $dfP3D = parcelRequire("dfP3D");

var $gOfBc = parcelRequire("gOfBc");

var $6zXPf = parcelRequire("6zXPf");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $lb6FK = parcelRequire("lb6FK");

var $kEUB1 = parcelRequire("kEUB1");

var $kO1ht = parcelRequire("kO1ht");

var $3nihz = parcelRequire("3nihz");
const $8ec718333c3707da$var$AssistantButton = (0, $f2JN3.componentWithCondition)(()=>(0, $6zXPf.getWillShowNav4)(), (0, $6UsU7.ConversationAssistantButtonNav4), (0, $6UsU7.ConversationAssistantButton));
const $8ec718333c3707da$var$ConversationAssistantButton = ()=>{
    const [_topMenusValue, { off: closeAllMenus }] = (0, $gOfBc.useTopMenus)();
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const { panelId: panelId, isCollapsed: isCollapsed } = (0, $dfP3D.useActiveRightSidebarState)() || {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const isActive = panelId === (0, $e65eaf0201568b8c$export$dffb4ed44e20ea9a) && !isCollapsed;
    const onButtonClickOld = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), 'aiMate', {
            opened: isCollapsed,
            isActive: isActive
        });
        if (isActive) closeCurrentRightSidebar();
        else openRightSidebar((0, $e65eaf0201568b8c$export$dffb4ed44e20ea9a), (0, $e65eaf0201568b8c$export$64aee74ba59709e5), false, true);
        closeAllMenus();
    }, [
        closeAllMenus,
        closeCurrentRightSidebar,
        createAnalyticsEvent,
        isActive,
        isCollapsed,
        openRightSidebar
    ]);
    const onButtonClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), 'aiMate', {
            opened: !isActive,
            isActive: isActive
        });
        isActive ? closeCurrentRightSidebar() : openRightSidebar((0, $e65eaf0201568b8c$export$dffb4ed44e20ea9a), (0, $e65eaf0201568b8c$export$64aee74ba59709e5), false, true);
        closeAllMenus();
    }, [
        isActive,
        closeAllMenus,
        closeCurrentRightSidebar,
        openRightSidebar,
        createAnalyticsEvent
    ]);
    const buttonRender = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        as: "span",
        paddingInlineStart: (0, $6zXPf.getWillShowNav4)() ? undefined : 'space.050',
        testId: "atlassian-navigation.ui.conversation-assistant.app-navigation-ai-mate",
        role: // This element is a direct descendant of the top nav actions list, so needs the listitem role.
        // While the button is internally wrapped in a listitem, screen readers do not pick this up due to multiple wrapper elements.
        (0, $6zXPf.getWillShowNav4)() ? 'listitem' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ec718333c3707da$var$AssistantButton, {
        onClick: (0, $6zXPf.getWillShowNav4)() ? onButtonClick : onButtonClickOld,
        isActive: isActive,
        siteId: cloudId,
        productKey: "jira"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, buttonRender, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ADJk.ChatContextSubscriber), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6qEVr.ChatOpenerSubscriber), {
        onTriggerOpeningChat: ()=>{
            if (!isActive) openRightSidebar((0, $e65eaf0201568b8c$export$dffb4ed44e20ea9a), (0, $e65eaf0201568b8c$export$64aee74ba59709e5), false, true);
        }
    }));
};
const $8ec718333c3707da$export$9777b121d71c4de1 = ()=>{
    const { data: data } = (0, $lb6FK.useRovoEntitlementResource)();
    const shouldShowConversationAssistantButton = data?.isRovoLLMEnabled ?? false;
    const buttonRender = shouldShowConversationAssistantButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ec718333c3707da$var$ConversationAssistantButton, null) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).CONVERSATION_ASSISTANT
    }, buttonRender, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $46nCP.RovoEntitlementSetter), {
        isRovoEnabled: shouldShowConversationAssistantButton
    }));
};

});
parcelRegister("3nihz", function(module, exports) {

$parcel$export(module.exports, "TopLevelErrorBoundary", () => $3ce55d8dd154bd7e$export$b70f1d8bd509b358);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $kO1ht = parcelRequire("kO1ht");
const $3ce55d8dd154bd7e$export$b70f1d8bd509b358 = ({ id: id, children: children })=>{
    const EVENT_DATA = (0, $eJOHy.useMemo)(()=>({
            id: id
        }), [
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: `${(0, $kO1ht.TOP_LEVEL_ERROR_BOUNDARY_ID)}.${id}`,
        packageName: (0, $kO1ht.PACKAGE_NAME),
        extraEventData: EVENT_DATA,
        fallback: "unmount"
    }, children);
};

});


parcelRegister("dgOrd", function(module, exports) {

$parcel$export(module.exports, "Create", () => $cc348fb5bec9260f$export$8ade6fcbf3a7de5d);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $5qPoO = parcelRequire("5qPoO");

var $ixiAQ = parcelRequire("ixiAQ");


var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $hu0Oo = parcelRequire("hu0Oo");

var $fYeTG = parcelRequire("fYeTG");

var $RXvVX = parcelRequire("RXvVX");

var $84DOT = parcelRequire("84DOT");

var $jipjz = parcelRequire("jipjz");

var $dRfS0 = parcelRequire("dRfS0");

var $dkTXM = parcelRequire("dkTXM");

var $cECwI = parcelRequire("cECwI");

var $eJrcF = parcelRequire("eJrcF");

var $kO1ht = parcelRequire("kO1ht");

var $cgeq2 = parcelRequire("cgeq2");

var $3nihz = parcelRequire("3nihz");

var $4BIvh = parcelRequire("4BIvh");

var $72yuq = parcelRequire("72yuq");

var $9HAHw = parcelRequire("9HAHw");

var $eqj3a = parcelRequire("eqj3a");
const $cc348fb5bec9260f$var$noop = ()=>undefined;
const $cc348fb5bec9260f$var$Create = ({ AkCreate: AkCreate = (0, $cgeq2.Create), NudgeTooltip: NudgeTooltip = (0, $dkTXM.NavigationCreateIssueButtonWrapperNudgeAsync), onCreateClick: onCreateClick = (0, $ixiAQ.default), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $4BIvh.useNavigationItemAnalytics), useIsInitialLoadLegacyIssueCreate: // @ts-expect-error - TS2339 - Property 'useIsInitialLoadLegacyIssueCreate' does not exist on type 'CreateProps'.
useIsInitialLoadLegacyIssueCreate = (0, $5qPoO.useIsInitialLoadLegacyIssueCreate) })=>{
    const testId = (0, $RXvVX.testIdGenerate)('create');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    (0, $hu0Oo.useInitializePersistentIssueCreateModalView)();
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).CREATE
    });
    const [{ isInitialLoad: isInitialLoad }, actions] = useIsInitialLoadLegacyIssueCreate();
    let currentIssueCreateVisibility = null;
    const gicOptInStateOverridden = (0, $eJOHy.useRef)(false);
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const isMobileExperienceEnabled = (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)();
    if ((0, $7jTnu.fg)('render_modern_global_issue_create_modal_experience')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data, update: update } = (0, $eJrcF.useResource)((0, $dRfS0.gicOptInStatusResources));
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useLayoutEffect)(()=>{
            if ((0, $7jTnu.fg)('jfp-magma-concurrent-fix-gic-modern')) {
                if (isAnonymous && !gicOptInStateOverridden.current) {
                    update(()=>({
                            gicOptInStatus: {
                                isEnabled: true
                            }
                        }));
                    gicOptInStateOverridden.current = true;
                }
            }
        }, [
            isAnonymous,
            update
        ]);
        if (!(0, $7jTnu.fg)('jfp-magma-concurrent-fix-gic-modern')) {
            if (isAnonymous && !gicOptInStateOverridden.current) {
                update(()=>({
                        gicOptInStatus: {
                            isEnabled: true
                        }
                    }));
                gicOptInStateOverridden.current = true;
            }
        }
        currentIssueCreateVisibility = data && data?.gicOptInStatus;
    }
    const onClick = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        if ((0, $7jTnu.fg)('render_modern_global_issue_create_modal_experience')) {
            if (currentIssueCreateVisibility !== null) {
                if (currentIssueCreateVisibility.isEnabled) {
                    (0, $72yuq.GlobalIssueCreateFromTopNav).abort({
                        force: true
                    });
                    (0, $72yuq.GlobalIssueCreateFromTopNav).start();
                    (0, $72yuq.GlobalIssueCreateFromTopNav).addMetadata({
                        inputDelay: Math.round(performance.now() - e.timeStamp)
                    });
                    const nextState = {
                        disableCreationSuccessFlag: (0, $eqj3a.shouldDisableGICFlagCreation)(),
                        triggerPointKey: (0, $84DOT.GENERIC_GLOBAL_CREATE_BUTTON),
                        ...isMobileExperienceEnabled ? {
                            displayMinimizableButtons: false,
                            displayCreateAnotherIssueToggle: false,
                            triggerPointKey: (0, $84DOT.MOBILE_GLOBAL_CREATE_BUTTON)
                        } : {}
                    };
                    openIssueCreateModal(nextState);
                } else {
                    onCreateClick({
                        isInitialLoad: isInitialLoad,
                        triggerSource: (0, $8b9f565bf0bbac99$export$d983e94cf86f65d)
                    });
                    if (isInitialLoad) actions.clearInitialLoaded();
                }
            } else (0, $eSnSE.default).safeErrorWithoutCustomerData('global-issue-create', 'visibility data is still getting downloaded');
        } else {
            onCreateClick({
                isInitialLoad: isInitialLoad,
                triggerSource: (0, $8b9f565bf0bbac99$export$d983e94cf86f65d)
            });
            if (isInitialLoad) actions.clearInitialLoaded();
        }
        triggerAnalytics();
    }, [
        actions,
        currentIssueCreateVisibility,
        isInitialLoad,
        isMobileExperienceEnabled,
        onCreateClick,
        openIssueCreateModal,
        triggerAnalytics
    ]);
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NudgeTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AkCreate, {
        onClick: onClick,
        text: formatMessage((0, $9HAHw.default).create),
        testId: testId,
        label: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $9HAHw.default).createButtonAriaLabelIssueTermRefresh : (0, $9HAHw.default).createButtonAriaLabel)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AkCreate, {
        onClick: $cc348fb5bec9260f$var$noop,
        text: formatMessage((0, $9HAHw.default).create),
        testId: testId,
        label: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $9HAHw.default).createButtonAriaLabelIssueTermRefresh : (0, $9HAHw.default).createButtonAriaLabel)
    });
};
const $cc348fb5bec9260f$export$8ade6fcbf3a7de5d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cc348fb5bec9260f$var$Create, props));

});
parcelRegister("hu0Oo", function(module, exports) {

$parcel$export(module.exports, "useInitializePersistentIssueCreateModalView", () => $ddec5dddf62df382$export$9086117e14a55509);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $fYeTG = parcelRequire("fYeTG");

var $jipjz = parcelRequire("jipjz");

var $2aY2d = parcelRequire("2aY2d");

var $80UiT = parcelRequire("80UiT");
const $ddec5dddf62df382$export$9086117e14a55509 = ()=>{
    const [{ shouldShowMiniModalSpotlight: shouldShowMiniModalSpotlight }, { setShouldPushMiniModalDiscoverability: setShouldPushMiniModalDiscoverability, setPersistentModalView: setPersistentModalView }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const hasUserSeenMiniModal = (0, $eJOHy.useRef)(false);
    const isJSM = projectContext?.projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT);
    const { data: resource } = (0, $80UiT.usePersistentIssueCreateModalViewResource)();
    const isMobileExperienceEnabled = (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)();
    /**
	 * It only handles the initialization part as after the modal is opened the persistentModalView
	 * would be handled by the `actions` of `useTriggerIssueCreateModal`.
	 */ (0, $eJOHy.useEffect)(()=>{
        setPersistentModalView(resource?.view || 'modal');
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
	 * JSM has opted out so we update the `shouldPushMiniModalDiscoverability` on every project change
	 * until the discoverability push has been done, meaning that the user has seen the mini modal being
	 * shown as the default modal.
	 *
	 * Mobile is also opting out of having any mini modal discoverability and not interacting with any of the discoverability state
	 * for if the user returns to desktop.
	 *
	 * If the user has seen the mini modal from discoverability push (hasUserSeenMiniModal) or
	 * dismiss its nudge (isDiscoPushComplete), shouldPushMiniModalDiscoverability should never be true again.
	 */ (0, $eJOHy.useEffect)(()=>{
        if (resource?.isDiscoPushComplete || hasUserSeenMiniModal.current) setShouldPushMiniModalDiscoverability(false);
        else setShouldPushMiniModalDiscoverability(!isJSM && !isMobileExperienceEnabled);
    }, [
        resource?.isDiscoPushComplete,
        setShouldPushMiniModalDiscoverability,
        isJSM,
        isMobileExperienceEnabled
    ]);
    /**
	 * `shouldShowMiniModalSpotlight` can be used to determine if user has seen the mini modal
	 * as it is only set `onModalOpen`, which means, if it is true, the modal is opened with mini view
	 * and the user will see it.
	 */ (0, $eJOHy.useEffect)(()=>{
        if (shouldShowMiniModalSpotlight && !hasUserSeenMiniModal.current) hasUserSeenMiniModal.current = true;
    }, [
        shouldShowMiniModalSpotlight
    ]);
    return null;
};

});
parcelRegister("80UiT", function(module, exports) {

$parcel$export(module.exports, "usePersistentIssueCreateModalViewResource", () => $950c6fd53d168168$export$20dbed3226e737bc);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $9DB7T = parcelRequire("9DB7T");

var $eJrcF = parcelRequire("eJrcF");


var $cqUpU = parcelRequire("cqUpU");
const $950c6fd53d168168$export$20dbed3226e737bc = ()=>{
    const { data: data, update: update } = (0, $eJrcF.useResource)((0, $cqUpU.persistentIssueCreateModalViewResource));
    const updateView = (0, $eJOHy.useCallback)(async (view)=>{
        try {
            await (0, $9DB7T.userPreferenceAPI).set((0, $0f8f8ea7f8143316$export$15187a597cef02df), view);
            update((state)=>({
                    ...state,
                    view: view
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'persistentIssueCreateModalViewState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    const updateIsDiscoPushComplete = (0, $eJOHy.useCallback)(async (isDiscoPushComplete = true)=>{
        try {
            await (0, $9DB7T.userPreferenceAPI).set((0, $0f8f8ea7f8143316$export$8977f91a75d8d265), isDiscoPushComplete);
            update((state)=>({
                    ...state,
                    isDiscoPushComplete: isDiscoPushComplete
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'miniModalDiscoverabilityPushState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    return {
        data: data,
        updateView: updateView,
        updateIsDiscoPushComplete: updateIsDiscoPushComplete
    };
};

});


parcelRegister("dkTXM", function(module, exports) {

$parcel$export(module.exports, "NavigationCreateIssueButtonWrapperNudgeAsync", () => $0482641ed1be2c55$export$fc0840474cb1fce9);

var $eJOHy = parcelRequire("eJOHy");


var $kMreM = parcelRequire("kMreM");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $9CROC = parcelRequire("9CROC");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0482641ed1be2c55$var$NavigationCreateIssueButtonLazy = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("ho6gN")).then((exportedModule)=>exportedModule.NavigationCreateIssueButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-create-issue/index.tsx"
});
const $0482641ed1be2c55$export$fc0840474cb1fce9 = ({ children: children })=>{
    const shouldShowNudge = (0, $9CROC.useCanShowQuickstartNudge)();
    if (!shouldShowNudge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kMreM.OnboardingNudgeErrorBoundary), {
        id: (0, $2b839a8453de5367$export$aba87e019f5ccb8d),
        fallback: children,
        attributes: {
            nudgeId: (0, $2b839a8453de5367$export$aba87e019f5ccb8d)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "software-onboarding-navigation-create-issue-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0482641ed1be2c55$var$NavigationCreateIssueButtonLazy, {
        nudgeId: (0, $2b839a8453de5367$export$aba87e019f5ccb8d)
    }, children)));
};

});
parcelRegister("9CROC", function(module, exports) {

$parcel$export(module.exports, "useCanShowQuickstartNudge", () => $048e6c5f7b64d681$export$b687eb4905cdc15a);

var $5Xqpk = parcelRequire("5Xqpk");
const $048e6c5f7b64d681$export$b687eb4905cdc15a = ()=>{
    const [{ hasOpened: hasOpened }] = (0, $5Xqpk.useHasOpened)();
    return hasOpened;
};

});

parcelRegister("ho6gN", function(module, exports) {

let $ca898aa664da50d1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ca898aa664da50d1$var$load("1Js7B").then(()=>parcelRequire('gytUr'));

});


parcelRegister("cgeq2", function(module, exports) {

$parcel$export(module.exports, "Create", () => $5b89414d4be457db$export$8ade6fcbf3a7de5d);

var $eJOHy = parcelRequire("eJOHy");

var $lFIpZ = parcelRequire("lFIpZ");

var $d081a = parcelRequire("d081a");

var $dhRXV = parcelRequire("dhRXV");

var $hMd9j = parcelRequire("hMd9j");

var $eES78 = parcelRequire("eES78");

var $gQZTc = parcelRequire("gQZTc");

var $6zXPf = parcelRequire("6zXPf");

var $7jTnu = parcelRequire("7jTnu");
// This id is required to ensure pollinator tests work between Nav3 and Nav4
const $5b89414d4be457db$var$TEST_ID_NAV_4 = 'atlassian-navigation--create-button';
const $5b89414d4be457db$export$8ade6fcbf3a7de5d = (props)=>{
    // This feature gate disables the server-specific code path, aligning SSR and CSR content for hydration
    if (false && !(0, $7jTnu.fg)('jfp-magma-4013-fix-top-nav-ssr-hydration')) {
        if ((0, $6zXPf.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hMd9j.CreateButton), {
            testId: $5b89414d4be457db$var$TEST_ID_NAV_4
        }, props.text);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d081a.SkeletonCreateButton), {
            text: props.text,
            testId: props.testId
        });
    }
    if ((0, $6zXPf.getWillShowNav4)()) {
        const { onClick: onClick, text: text } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gQZTc.SpotlightTarget), {
            name: (0, $eES78.GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hMd9j.CreateButton), {
            onClick: onClick,
            testId: $5b89414d4be457db$var$TEST_ID_NAV_4
        }, text)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lFIpZ.Create), props);
};

});
parcelRegister("gQZTc", function(module, exports) {

$parcel$export(module.exports, "SpotlightTarget", () => $53951e7fd16438ee$export$e29577842f211e22);

var $eJOHy = parcelRequire("eJOHy");

var $gbiVe = parcelRequire("gbiVe");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $dZidf = parcelRequire("dZidf");
const $53951e7fd16438ee$var$SpotlightTargetWrapper = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $53951e7fd16438ee$var$SpotlightTargetOld = (0, $dZidf.withNestingOptimisation)($53951e7fd16438ee$var$SpotlightTargetWrapper);
const $53951e7fd16438ee$export$e29577842f211e22 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-4013-fix-top-nav-ssr-hydration'), $53951e7fd16438ee$var$SpotlightTargetWrapper, $53951e7fd16438ee$var$SpotlightTargetOld);

});
parcelRegister("dZidf", function(module, exports) {

$parcel$export(module.exports, "withNestingOptimisation", () => $b09755e6dde7543f$export$ee1cb2a8280d8710);

var $eJOHy = parcelRequire("eJOHy");

var $eGPDm = parcelRequire("eGPDm");

var $2QUmO = parcelRequire("2QUmO");
const $b09755e6dde7543f$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $eGPDm.useShouldNestedElementRender)().shouldRender && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $2QUmO.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});



parcelRegister("4BIvh", function(module, exports) {

$parcel$export(module.exports, "useNavigationItemAnalytics", () => $902255c41cfb9464$export$444d136efe970fd3);

var $eJOHy = parcelRequire("eJOHy");

var $eY50e = parcelRequire("eY50e");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");
const $902255c41cfb9464$export$444d136efe970fd3 = ({ navigationItemId: navigationItemId })=>{
    const { isVisible: isVisible } = (0, $eY50e.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((attributes = {})=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, navigationItemId, {
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            ...attributes,
            isInMore: !isVisible,
            navigationLayer: 'global'
        });
    }, [
        createAnalyticsEvent,
        isVisible,
        navigationItemId
    ]);
};

});

parcelRegister("72yuq", function(module, exports) {

$parcel$export(module.exports, "GlobalIssueCreateFromTopNav", () => $9bb546db11179a36$export$177dc7755a3f80f2);

var $aRK4c = parcelRequire("aRK4c");
var $9GzfC = parcelRequire("9GzfC");
var $7zzNO = parcelRequire("7zzNO");
const $9bb546db11179a36$export$177dc7755a3f80f2 = new (0, $9GzfC.UFOExperience)('global-issue-create-from-top-nav', {
    type: (0, $aRK4c.ExperienceTypes).Operation,
    performanceType: (0, $aRK4c.ExperiencePerformanceTypes).Custom,
    until: (0, $7zzNO.untilAll)([
        {
            category: 'global-issue-create.create-issue'
        }
    ])
});
const $9bb546db11179a36$export$2b83859c1548ffb5 = new (0, $9GzfC.UFOExperience)('projects-menu-dropdown.recommendation-selector', {
    type: (0, $aRK4c.ExperienceTypes).Experience,
    performanceType: (0, $aRK4c.ExperiencePerformanceTypes).InlineResult
});
const $9bb546db11179a36$export$a784c5bbb21ea554 = new (0, $9GzfC.UFOExperience)('projects-menu-dropdown.load-jpd-recommendation', {
    type: (0, $aRK4c.ExperienceTypes).Experience,
    performanceType: (0, $aRK4c.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("9HAHw", function(module, exports) {

$parcel$export(module.exports, "default", () => $db8fb5b2eada5689$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $db8fb5b2eada5689$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    create: {
        "id": "atlassian-navigation.create.create",
        "defaultMessage": "Create"
    },
    createButtonAriaLabel: {
        "id": "atlassian-navigation.create.create-button-aria-label",
        "defaultMessage": "Create issue"
    },
    createButtonAriaLabelIssueTermRefresh: {
        "id": "atlassian-navigation.create.create-button-aria-label-issue-term-refresh",
        "defaultMessage": "Create"
    }
});

});

parcelRegister("eqj3a", function(module, exports) {

$parcel$export(module.exports, "shouldDisableGICFlagCreation", () => $ebcdc5f6d6996655$export$fc4d210bb6a1528a);

var $gRw8I = parcelRequire("gRw8I");

var $kO1ht = parcelRequire("kO1ht");
const $ebcdc5f6d6996655$export$fc4d210bb6a1528a = ()=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return (0, $kO1ht.JSW_TMP_BACKLOG_BOARD_REGEXP).test(window.location.pathname);
};

});


parcelRegister("kjqBp", function(module, exports) {

$parcel$export(module.exports, "Help", () => $cfea47f9fb354a21$export$1be7516c0280bee8);

var $eJOHy = parcelRequire("eJOHy");

var $8wfPR = parcelRequire("8wfPR");

var $gbiVe = parcelRequire("gbiVe");

var $dmNlg = parcelRequire("dmNlg");

var $2aY2d = parcelRequire("2aY2d");

var $cECwI = parcelRequire("cECwI");

var $6d9QY = parcelRequire("6d9QY");

var $RXvVX = parcelRequire("RXvVX");

var $5RW99 = parcelRequire("5RW99");

var $dfP3D = parcelRequire("dfP3D");

var $lRq8t = parcelRequire("lRq8t");

var $gOfBc = parcelRequire("gOfBc");

var $7jTnu = parcelRequire("7jTnu");

var $hLzUY = parcelRequire("hLzUY");

var $3VPsL = parcelRequire("3VPsL");

var $f2JN3 = parcelRequire("f2JN3");

var $6z8y4 = parcelRequire("6z8y4");

var $6zXPf = parcelRequire("6zXPf");

var $gxP9D = parcelRequire("gxP9D");

var $a87C3 = parcelRequire("a87C3");

var $5Xqpk = parcelRequire("5Xqpk");

var $9ycBx = parcelRequire("9ycBx");

var $17J0V = parcelRequire("17J0V");

var $1Isrc = parcelRequire("1Isrc");

var $kO1ht = parcelRequire("kO1ht");

var $4BIvh = parcelRequire("4BIvh");

var $3nihz = parcelRequire("3nihz");

var $1zJmr = parcelRequire("1zJmr");

var $hlQB8 = parcelRequire("hlQB8");
const $cfea47f9fb354a21$export$70a45859468ee32a = (0, $f2JN3.componentWithCondition)(()=>(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('blu-5788-spotlight-help-button'), $cfea47f9fb354a21$var$JWMFeedbackSpotlightWrapper, $cfea47f9fb354a21$var$SpotlightTargetComponentOriginal);
function $cfea47f9fb354a21$var$SpotlightTargetComponentOriginal({ children: children }) {
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cfea47f9fb354a21$var$SpotlightTarget, {
        name: (0, $kO1ht.HELP_SPOTLIGHT_KEY)
    }, children), (0, $7jTnu.fg)('add_engagement_spotlight_to_navbar_button') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wfPR.EngagementSpotlight), {
        name: (0, $kO1ht.HELP_SPOTLIGHT_KEY)
    }));
}
function $cfea47f9fb354a21$var$SpotlightTarget({ children: children, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
}
function $cfea47f9fb354a21$var$JWMFeedbackSpotlightWrapper({ children: children }) {
    const renderNudgeWrapper = (0, $eJOHy.useCallback)((kids)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a87C3.FeedbackNudgeAsync), null, kids), []);
    const [{ hasOpened: shouldShowNudge }] = (0, $5Xqpk.useHasOpened)();
    const [isUnloaded] = (0, $gxP9D.useIsDismissed)();
    const [openTask] = (0, $gxP9D.useOpenTask)();
    const [, { setHasNudgeActive: setHasNudgeActive }] = (0, $gxP9D.useQuickstartActions)();
    (0, $eJOHy.useEffect)(()=>{
        if (!isUnloaded && openTask === (0, $9ycBx.JWM_FEEDBACK_TASK) && shouldShowNudge) setHasNudgeActive(true);
    }, [
        isUnloaded,
        openTask,
        shouldShowNudge,
        setHasNudgeActive
    ]);
    return !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6z8y4.QuickstartNudge), {
        renderWrapper: renderNudgeWrapper
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cfea47f9fb354a21$var$SpotlightTargetComponentOriginal, null, children);
}
const $cfea47f9fb354a21$var$Help = ()=>{
    const isProjectSimplified = (0, $2aY2d.useIsSimplifiedProject)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isMenuOpen, { off: closeMenu, on: openMenu }] = (0, $gOfBc.useTopMenus)((0, $5RW99.MENU_ID).HELP);
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const [topMenusValue, { off: closeAllMenus }] = (0, $gOfBc.useTopMenus)();
    const [, { setNavigationData: setNavigationData }] = (0, $3VPsL.useHelpPanelActions)();
    const { releaseNotesNotifications: releaseNotesNotifications, setReleaseNotesNotifications: setReleaseNotesNotifications } = (0, $17J0V.useHelpButtonState)();
    const helpButtonRef = (0, $eJOHy.useRef)(null);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const attributes = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-2') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>({
            helpPanelVersion: (0, $hLzUY.HELP_PANEL_VERSION),
            helpPanelType: 'inProductHelp',
            nextGenProject: isProjectSimplified
        }), [
        isProjectSimplified
    ]) : {
        helpPanelVersion: (0, $hLzUY.HELP_PANEL_VERSION),
        helpPanelType: 'inProductHelp',
        nextGenProject: isProjectSimplified
    };
    const triggerAnalytics = (0, $4BIvh.useNavigationItemAnalytics)({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).HELP
    });
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const currentRightSidebarState = (0, $dfP3D.useActiveRightSidebarState)();
    const isHelpPanelOpenedPreviously = (0, $6d9QY.usePrevious)(currentRightSidebarState);
    const testIdPrefix = (0, $RXvVX.testIdGenerate)('secondary-actions', 'help');
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (currentRightSidebarState && currentRightSidebarState.panelId === (0, $hLzUY.HELP_PANEL_ID) && !currentRightSidebarState.isCollapsed) closeCurrentRightSidebar();
        else openRightSidebar((0, $hLzUY.HELP_PANEL_ID), (0, $hLzUY.HELP_PANEL_WIDTH), false, true);
        closeAllMenus();
        setNavigationData({
            articleId: {
                id: '',
                type: (0, $dmNlg.ARTICLE_TYPE).HELP_ARTICLE
            },
            history: []
        });
        // Shows if the help panel is currently open or closed
        const isPanelOpen = currentRightSidebarState?.panelId === (0, $hLzUY.HELP_PANEL_ID) && !currentRightSidebarState?.isCollapsed;
        triggerAnalytics({
            ...attributes,
            isOpened: !isPanelOpen
        });
    }, [
        triggerAnalytics,
        attributes,
        currentRightSidebarState,
        closeAllMenus,
        setNavigationData,
        closeCurrentRightSidebar,
        openRightSidebar
    ]);
    const badge = (0, $eJOHy.useCallback)(()=>{
        if (isAnonymous) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hlQB8.Badge), {
            releaseNotesNotifications: releaseNotesNotifications ?? 0
        });
    }, [
        isAnonymous,
        releaseNotesNotifications
    ]);
    // Restore the notifications count when the help panel is opened and the notifications count is not 0
    // We explicitly check for the collapsed state, as currentRightSidebarState is null when the sidebar is closed
    // and we don't want to set the notifications count to 0 in that case
    const shouldRestoreNotificationsCount = currentRightSidebarState?.isCollapsed === false && releaseNotesNotifications !== 0;
    (0, $eJOHy.useEffect)(()=>{
        if (shouldRestoreNotificationsCount) setReleaseNotesNotifications(0);
    }, [
        setReleaseNotesNotifications,
        shouldRestoreNotificationsCount
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (currentRightSidebarState?.panelId === (0, $hLzUY.HELP_PANEL_ID) && !currentRightSidebarState?.isCollapsed) openMenu();
        else {
            closeMenu();
            if (isHelpPanelOpenedPreviously?.panelId === (0, $hLzUY.HELP_PANEL_ID) && !currentRightSidebarState) requestAnimationFrame(()=>helpButtonRef.current?.focus());
        }
    }, [
        closeMenu,
        currentRightSidebarState,
        isHelpPanelOpenedPreviously,
        openMenu,
        topMenusValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $RXvVX.testIdConcat)(testIdPrefix, 'menu-trigger'),
        "data-vc": `atlassian-navigation-help${false ? '-ssr' : ''}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cfea47f9fb354a21$export$70a45859468ee32a, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Isrc.Help), {
        "aria-expanded": false,
        "aria-haspopup": false,
        isSelected: isMenuOpen,
        badge: badge,
        onClick: onClick,
        tooltip: formatMessage((0, $1zJmr.default).tooltip),
        label: formatMessage((0, $1zJmr.default).label),
        ref: helpButtonRef
    })));
};
const $cfea47f9fb354a21$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).HELP
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cfea47f9fb354a21$var$Help, null)));

});
parcelRegister("6z8y4", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $0e38737f31212e98$export$bd61ee610c74db6c);

var $eJOHy = parcelRequire("eJOHy");

var $keu3i = parcelRequire("keu3i");

var $dZidf = parcelRequire("dZidf");
const $0e38737f31212e98$export$bd61ee610c74db6c = (0, $dZidf.withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
    const isFullyExpanded = (0, $keu3i.useIsFullyExpanded)();
    return isFullyExpanded ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
});

});
parcelRegister("keu3i", function(module, exports) {

$parcel$export(module.exports, "useIsFullyExpanded", () => $80a581cbcefc9920$export$7212b6b01271f5d1);

var $eJOHy = parcelRequire("eJOHy");

var $cUxaS = parcelRequire("cUxaS");
const $80a581cbcefc9920$var$TIMEOUT = 500;
const $80a581cbcefc9920$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $eJOHy.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $cUxaS.useLeftSidebarState)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $80a581cbcefc9920$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});


parcelRegister("a87C3", function(module, exports) {

$parcel$export(module.exports, "FeedbackNudgeAsync", () => $adabcd0aead62617$export$be3f2958452e7be9);

var $eJOHy = parcelRequire("eJOHy");

var $kMreM = parcelRequire("kMreM");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $adabcd0aead62617$var$FeedbackNudgeLazy = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("9uHCI")).then((exportedModule)=>exportedModule.FeedbackNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-feedback/index.tsx"
});
const $adabcd0aead62617$export$be3f2958452e7be9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kMreM.OnboardingNudgeErrorBoundary), {
        id: (0, $44259bc988b99eaa$export$e9e47a7ad42e71f5),
        fallback: children,
        attributes: {
            nudgeId: (0, $44259bc988b99eaa$export$e9e47a7ad42e71f5)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "feedback-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($adabcd0aead62617$var$FeedbackNudgeLazy, null, children)));
$adabcd0aead62617$export$be3f2958452e7be9.displayName = 'FeedbackNudgeAsync';

});
parcelRegister("9uHCI", function(module, exports) {

let $6e98c11f8bf273fe$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6e98c11f8bf273fe$var$load("cWqbr").then(()=>parcelRequire('9CIPb'));

});


parcelRegister("17J0V", function(module, exports) {

$parcel$export(module.exports, "useHelpButtonState", () => $8fb3dbf61041bfa1$export$e3d3de46b23d1ede);

var $eJOHy = parcelRequire("eJOHy");

var $8q7lT = parcelRequire("8q7lT");

var $6ygRm = parcelRequire("6ygRm");
const $8fb3dbf61041bfa1$export$53f45136e435c2fd = 'help_button_ui_state';
const $8fb3dbf61041bfa1$export$e3d3de46b23d1ede = ()=>{
    const [releaseNotesNotifications, setReleaseNotesNotifications] = (0, $eJOHy.useState)(null);
    const [userReleaseNotesNotifications, setUserReleaseNotesNotifications] = (0, $eJOHy.useState)(null);
    const accountId = (0, $8q7lT.useAccountId)();
    const updateData = (0, $eJOHy.useCallback)(()=>{
        if (userReleaseNotesNotifications !== null) {
            const newReleaseNotesNotificationsValue = userReleaseNotesNotifications !== undefined ? userReleaseNotesNotifications : 100;
            if (releaseNotesNotifications !== null) {
                if (userReleaseNotesNotifications !== releaseNotesNotifications) {
                    const remoteData = {
                        helpPanelMenu: {
                            releaseNotesNotifications: releaseNotesNotifications
                        }
                    };
                    (0, $6ygRm.updateHelpButtonState)(accountId, remoteData);
                }
            } else setReleaseNotesNotifications(newReleaseNotesNotificationsValue);
        }
    }, [
        accountId,
        releaseNotesNotifications,
        userReleaseNotesNotifications
    ]);
    const restoreReleaseNotesNotifications = (0, $eJOHy.useCallback)(async ()=>{
        if (accountId) {
            const userPropertiesHelpButtonValue = await (0, $6ygRm.getHelpButtonState)(accountId);
            setUserReleaseNotesNotifications(userPropertiesHelpButtonValue?.releaseNotesNotifications);
        } else setUserReleaseNotesNotifications(0);
    }, [
        accountId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (userReleaseNotesNotifications === null) restoreReleaseNotesNotifications();
        else updateData();
    }, [
        userReleaseNotesNotifications,
        restoreReleaseNotesNotifications,
        updateData
    ]);
    return {
        releaseNotesNotifications: releaseNotesNotifications,
        setReleaseNotesNotifications: setReleaseNotesNotifications
    };
};

});
parcelRegister("6ygRm", function(module, exports) {

$parcel$export(module.exports, "updateHelpButtonState", () => $c9661ca80e500d81$export$c70764abdc0ffd52);
$parcel$export(module.exports, "getHelpButtonState", () => $c9661ca80e500d81$export$9716b2ae6c8887b0);

var $LFmXM = parcelRequire("LFmXM");

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

var $hbF3h = parcelRequire("hbF3h");

var $7jTnu = parcelRequire("7jTnu");

const $c9661ca80e500d81$export$c70764abdc0ffd52 = async (accountId, data)=>{
    if (accountId !== null) try {
        await (0, $FppkK.setUserProperties)(accountId, (0, $6684ec2238b90c47$export$53f45136e435c2fd), JSON.stringify(data));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gYnSx.default)({
            error: e,
            meta: {
                id: 'updateServerHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
};
const $c9661ca80e500d81$var$getHelpButtonStateNew = (0, $LFmXM.default)(async (accountId)=>{
    try {
        // @ts-expect-error - Property 'helpPanelMenu' does not exist on type 'unknown'.
        const { helpPanelMenu: userPropertiesHelpButtonValue } = await (0, $FppkK.getUserProperty)(accountId, (0, $6684ec2238b90c47$export$53f45136e435c2fd));
        return userPropertiesHelpButtonValue;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gYnSx.default)({
            error: e,
            meta: {
                id: 'getHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
    return null;
});
const $c9661ca80e500d81$var$getHelpButtonStateOld = async (accountId)=>{
    try {
        // @ts-expect-error - Property 'helpPanelMenu' does not exist on type 'unknown'.
        const { helpPanelMenu: userPropertiesHelpButtonValue } = await (0, $FppkK.getUserProperty)(accountId, (0, $6684ec2238b90c47$export$53f45136e435c2fd));
        return userPropertiesHelpButtonValue;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gYnSx.default)({
            error: e,
            meta: {
                id: 'getHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
    return null;
};
const $c9661ca80e500d81$export$9716b2ae6c8887b0 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('user-properties-iv-llc-unnecessary-api'), $c9661ca80e500d81$var$getHelpButtonStateNew, $c9661ca80e500d81$var$getHelpButtonStateOld);

});
const $6684ec2238b90c47$export$53f45136e435c2fd = 'help_button_ui_state';



parcelRegister("1Isrc", function(module, exports) {

$parcel$export(module.exports, "Help", () => $ded8b32ea79727d1$export$1be7516c0280bee8);

var $eJOHy = parcelRequire("eJOHy");

var $dLfgl = parcelRequire("dLfgl");

var $coyik = parcelRequire("coyik");

var $6zXPf = parcelRequire("6zXPf");
const $ded8b32ea79727d1$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    if ((0, $6zXPf.getWillShowNav4)()) {
        const { badge: badge, onClick: onClick, isSelected: isSelected, label: label } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coyik.Help), {
            badge: badge,
            label: label,
            onClick: onClick,
            isSelected: isSelected,
            ref: ref
        });
    }
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLfgl.Help), buttonProps);
});

});

parcelRegister("1zJmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $200d37e9ffd771a9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $200d37e9ffd771a9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.help.tooltip",
        "defaultMessage": "Help"
    },
    label: {
        "id": "atlassian-navigation.help.label",
        "defaultMessage": "Help"
    }
});

});

parcelRegister("hlQB8", function(module, exports) {

$parcel$export(module.exports, "Badge", () => $4f77d4f43bcb6c5d$export$37acb3580601e69a);

var $eJOHy = parcelRequire("eJOHy");

var $eIatj = parcelRequire("eIatj");
const $4f77d4f43bcb6c5d$export$37acb3580601e69a = ({ releaseNotesNotifications: releaseNotesNotifications = 0 })=>{
    return releaseNotesNotifications > 0 && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eIatj.LazyNotifications), {
        max: 3,
        appearance: "primary"
    }, releaseNotesNotifications) : null;
};

});
parcelRegister("eIatj", function(module, exports) {

$parcel$export(module.exports, "LazyNotifications", () => $13a6cf3756795afc$export$eebecbd0322becdd);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $kO1ht = parcelRequire("kO1ht");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $13a6cf3756795afc$var$Notifications = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("ixjDC")), {
    ssr: false,
    moduleId: "../platform/packages/design-system/badge/src/index.tsx"
});
const $13a6cf3756795afc$export$eebecbd0322becdd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "help.atlaskit-badge",
        packageName: (0, $kO1ht.PACKAGE_NAME),
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "lazy-notification-badge",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13a6cf3756795afc$var$Notifications, props)));

});
parcelRegister("ixjDC", function(module, exports) {

let $d7ea8ac5b9976970$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d7ea8ac5b9976970$var$load("81ZQf").then(()=>parcelRequire('bxua8'));

});




parcelRegister("5kUfs", function(module, exports) {

$parcel$export(module.exports, "InitialDataLoader", () => $1b81bbaa6d93c8a7$export$867ec025b81eadf3);

var $eJOHy = parcelRequire("eJOHy");

var $iUTi1 = parcelRequire("iUTi1");


var $4PyXW = parcelRequire("4PyXW");

var $dWBDy = parcelRequire("dWBDy");

var $dS8Qn = parcelRequire("dS8Qn");

var $8dKc6 = parcelRequire("8dKc6");

var $qzoYE = parcelRequire("qzoYE");

var $jEvkf = parcelRequire("jEvkf");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $cECwI = parcelRequire("cECwI");
const $1b81bbaa6d93c8a7$export$867ec025b81eadf3 = ()=>{
    const [, { loadRecentAll: loadRecentAll }] = (0, $qzoYE.useRecentActions)();
    const [, { loadFavoriteAll: loadFavoriteAll }] = (0, $4PyXW.useFavoriteActions)();
    const [, { fetchCreateProjectPermission: fetchCreateProjectPermission }] = (0, $8dKc6.useCreateProjectPermissionActions)();
    const [, { load: loadForgeGlobalItem }] = (0, $dWBDy.useForgeGlobalItems)();
    const [, { load: loadForgePersonalSettingsItem }] = (0, $dS8Qn.useForgePersonalSettingsItems)();
    const [, { load: loadAddons }] = (0, $iUTi1.useAddon)();
    const hasFetchedAll = (0, $eJOHy.useRef)(false);
    const [{ hasLoaded: hasLoaded }] = (0, $jEvkf.default)();
    const [hasTimedOut, setHasTimedOut] = (0, $eJOHy.useState)(false);
    const accountId = (0, $8q7lT.useAccountId)();
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const cloudId = (0, $kEUB1.useCloudId)();
    (0, $eJOHy.useEffect)(()=>{
        if ((hasLoaded || hasTimedOut) && !hasFetchedAll.current) {
            loadRecentAll();
            loadFavoriteAll((0, $afbb2078a4e12c1d$export$ea341e6cc435ed40));
            loadForgeGlobalItem({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            });
            loadForgePersonalSettingsItem({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            });
            fetchCreateProjectPermission();
            loadAddons();
            hasFetchedAll.current = true;
        }
    }, [
        hasLoaded,
        hasTimedOut,
        hasFetchedAll,
        loadRecentAll,
        loadFavoriteAll,
        fetchCreateProjectPermission,
        loadForgeGlobalItem,
        loadForgePersonalSettingsItem,
        loadAddons,
        accountId,
        cloudId,
        isAnonymous
    ]);
    // given not all pages use SpaStateReady yet, we fallback to timeout
    // so we preload nav items anyway after some time
    (0, $eJOHy.useEffect)(()=>{
        let t;
        if (!hasLoaded) t = setTimeout(()=>setHasTimedOut(true), 10000);
        return ()=>clearTimeout(t);
    }, [
        hasLoaded,
        setHasTimedOut
    ]);
    return null;
};

});
parcelRegister("iUTi1", function(module, exports) {

$parcel$export(module.exports, "useAddon", () => $418ab0c2b113178e$export$550c6d89b9b85724);

var $3EspY = parcelRequire("3EspY");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $418ab0c2b113178e$var$handleFetch = ()=>async ({ setState: setState, getState: getState })=>{
        const { fetchAddons: fetchAddons, fetchAddonContext: fetchAddonContext, isFetching: isFetching } = getState();
        if (!isFetching) try {
            const promise = fetchAddons(fetchAddonContext);
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const items = await promise;
            setState({
                items: items,
                hasFetchedOnce: true,
                hasSuccessOnce: true,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError,
                hasFetchedOnce: true,
                isFetching: false,
                promise: null
            });
        }
    };
const $418ab0c2b113178e$var$actions = {
    load: ()=>async ({ dispatch: dispatch })=>{
            const promise = dispatch($418ab0c2b113178e$var$handleFetch());
            await promise;
        },
    setFavourite: (item, isAddon)=>async ({ setState: setState, getState: getState })=>{
            const { items: items, addToFavorite: addToFavorite, removeFromFavorite: removeFromFavorite } = getState();
            const newItemData = {
                ...item,
                favourite: true
            };
            if (isAddon) {
                setState({
                    items: [
                        newItemData,
                        ...items
                    ]
                });
                await addToFavorite(newItemData);
            } else {
                setState({
                    items: items.filter((theItem)=>theItem.id !== item.id)
                });
                await removeFromFavorite(item);
            }
        },
    setContext: (context)=>({ setState: setState })=>{
            setState({
                fetchAddonContext: context
            });
        }
};
const $418ab0c2b113178e$export$f350d6bef9972cd3 = (defaults)=>{
    const initialState = {
        fetchAddons: defaults.fetchAddons,
        fetchAddonContext: {},
        addToFavorite: defaults.addToFavorite,
        removeFromFavorite: defaults.removeFromFavorite,
        hasFetchedOnce: false,
        hasSuccessOnce: false,
        items: [],
        fetchError: null,
        promise: null,
        isFetching: false
    };
    const Store = (0, $GtRbT.createStore)({
        name: 'addon-store',
        actions: $418ab0c2b113178e$var$actions,
        initialState: initialState
    });
    const AddonContainer = (0, $6E16M.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState({
                    fetchAddons: props.fetchAddons,
                    addToFavorite: props.addToFavorite,
                    removeFromFavorite: props.removeFromFavorite
                });
            }
    });
    const AddonTestContainer = (0, $6E16M.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState(props);
            }
    });
    const selector = ({ items: items, hasFetchedOnce: hasFetchedOnce, fetchError: fetchError, promise: promise, hasSuccessOnce: hasSuccessOnce, isFetching: isFetching })=>({
            items: items,
            hasFetchedOnce: hasFetchedOnce,
            hasSuccessOnce: hasSuccessOnce,
            fetchError: fetchError,
            promise: promise,
            isFetching: isFetching
        });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const AddonSubscriber = (0, $ht3nQ.createSubscriber)(Store, {
        displayName: 'AddonSubscriber',
        selector: selector
    }); // Bug with createSubscriber type means that React children end up "never"
    // Deprecated: to be removed
    const useAddonActions = (0, $iJq0l.createHook)(Store, {
        selector: selector
    });
    const useAddon = (0, $iJq0l.createHook)(Store, {
        selector: selector
    });
    return {
        AddonSubscriber: AddonSubscriber,
        useAddonActions: useAddonActions,
        useAddon: useAddon,
        AddonTestContainer: AddonTestContainer,
        AddonContainer: AddonContainer
    };
};
const $418ab0c2b113178e$var$defaultAddToFavorite = ()=>// TODO: to be implemented when api is ready
    new Promise(()=>null);
const $418ab0c2b113178e$var$defaultRemoveFromFavorite = ()=>// TODO: to be implemented when api is ready
    new Promise(()=>null);
const { useAddon: $418ab0c2b113178e$export$550c6d89b9b85724 } = $418ab0c2b113178e$export$f350d6bef9972cd3({
    fetchAddons: (0, $3EspY.fetchAddonItems),
    addToFavorite: $418ab0c2b113178e$var$defaultAddToFavorite,
    removeFromFavorite: $418ab0c2b113178e$var$defaultRemoveFromFavorite
});

});
parcelRegister("3EspY", function(module, exports) {

$parcel$export(module.exports, "fetchAddonItems", () => $90b59852607fb885$export$fe5ef9b24322d3c1);

var $1uIew = parcelRequire("1uIew");

var $1oMOM = parcelRequire("1oMOM");

var $4FYpn = parcelRequire("4FYpn");

const $90b59852607fb885$var$handleError = (error)=>{
    // Temp
    throw error;
};
const $90b59852607fb885$export$fe5ef9b24322d3c1 = async (context)=>{
    const params = $90b59852607fb885$var$getContextParams(context);
    const url = `/rest/navigation/3/global/addons${params ? `?${params}` : ''}`;
    try {
        const response = await fetch(url, (0, $1oMOM.getDefaultOptions)(url));
        if (!response.ok) {
            const errorCode = response.status;
            if (errorCode === 401) return $90b59852607fb885$var$handleError(new (0, $4FYpn.AuthenticationError)(`${errorCode}`));
            return $90b59852607fb885$var$handleError(new (0, $1uIew.default)(errorCode, response.statusText));
        }
        const addonsItems = await response.json();
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        return addonsItems.map((item)=>({
                id: item.id,
                title: item.name,
                avatarUrl: item.iconUrl,
                type: (0, $530fa672789495a8$export$5e2cc09b58170ca2),
                url: item.url,
                className: item.styleClass
            }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // network issue
        return $90b59852607fb885$var$handleError(error);
    }
};
function $90b59852607fb885$var$getContextParams(context) {
    const filteredParams = Object.fromEntries(Object.entries(context || {}).filter(([, value])=>!!value));
    return new URLSearchParams(filteredParams).toString();
}

});


parcelRegister("dWBDy", function(module, exports) {

$parcel$export(module.exports, "useForgeGlobalItems", () => $9d1e51491ba4a3e2$export$fa6081acdcc112a0);

var $fohjD = parcelRequire("fohjD");

var $ePLco = parcelRequire("ePLco");

var $kU13U = parcelRequire("kU13U");

var $dhAnj = parcelRequire("dhAnj");

var $6zXPf = parcelRequire("6zXPf");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $9d1e51491ba4a3e2$var$getItemHref = (extension)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `/jira/apps/${appId}/${envId}`;
};
const $9d1e51491ba4a3e2$var$transformTitle = (title, environmentType, environmentKey)=>{
    if (environmentType === (0, $fohjD.DEVELOPMENT_ENVIRONMENT) && environmentKey !== (0, $fohjD.DEFAULT_ENVIRONMENT_KEY)) return `${title} - ${environmentKey}`;
    return title;
};
const $9d1e51491ba4a3e2$var$handleFetch = ({ cloudId: cloudId, isAnonymous: isAnonymous })=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
    async ({ setState: setState, getState: getState })=>{
        const { isFetching: isFetching } = getState();
        if (!isFetching) try {
            // If Nav4 is enabled, we don't need to fetch global items since they are implemented elsewhere.
            if ((0, $6zXPf.getWillShowNav4)()) return;
            const promise = (0, $dhAnj.fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                context: {},
                includeHidden: true,
                types: [
                    (0, $fohjD.GLOBAL_PAGE_MODULE)
                ],
                source: (0, $fohjD.SOURCE_NAVIGATION)
            });
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const data = await promise;
            const globalPageData = data ? data[0, $fohjD.GLOBAL_PAGE_MODULE] : [];
            const items = globalPageData.filter((0, $kU13U.isExtensionVisible)).map((extension)=>({
                    id: extension.id,
                    title: $9d1e51491ba4a3e2$var$transformTitle(extension.properties.title, extension.environmentType, extension.environmentKey),
                    avatarUrl: extension.properties.icon,
                    url: $9d1e51491ba4a3e2$var$getItemHref(extension),
                    environmentType: extension.environmentType,
                    module: (0, $fohjD.GLOBAL_PAGE_MODULE)
                }));
            setState({
                items: items,
                hasFetchedOnce: true,
                hasSuccessOnce: true,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError,
                hasFetchedOnce: true,
                isFetching: false,
                promise: null
            });
        }
    };
const $9d1e51491ba4a3e2$var$actions = {
    load: ({ cloudId: cloudId, isAnonymous: isAnonymous })=>async ({ dispatch: dispatch })=>{
            const promise = dispatch($9d1e51491ba4a3e2$var$handleFetch({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            }));
            await promise;
        }
};
const $9d1e51491ba4a3e2$export$a87c2a3d589b7efd = ()=>{
    const initialState = {
        hasFetchedOnce: false,
        hasSuccessOnce: false,
        items: [],
        promise: null,
        fetchError: null,
        isFetching: false
    };
    const Store = (0, $GtRbT.createStore)({
        name: 'forge-global-items-store',
        actions: // @ts-expect-error - TS2322 - Type '{ readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<void>; }' is not assignable to type 'Record<string, ActionThunk<{ fetchForgeModule: (arg1: { cloudId: string; moduleName: FullPageModule; }) => Promise<FullPage[] | null>; hasFetchedOnce: boolean; ... 4 more ...; isFetching: boolean; }, { ...; }>>'.
        $9d1e51491ba4a3e2$var$actions,
        initialState: initialState
    });
    // @ts-expect-error - TS2344 - Type '{ readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<void>; }' does not satisfy the constraint 'Record<string, ActionThunk<GenericState<I>, { readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<...>; }>>'.
    const ForgeGlobalItemsTestContainer = (0, $6E16M.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState(props);
            }
    });
    const selector = ({ items: // @ts-expect-error - TS7031 - Binding element 'items' implicitly has an 'any' type.
    items, hasFetchedOnce: // @ts-expect-error - TS7031 - Binding element 'hasFetchedOnce' implicitly has an 'any' type.
    hasFetchedOnce, fetchError: // @ts-expect-error - TS7031 - Binding element 'fetchError' implicitly has an 'any' type.
    fetchError, promise: // @ts-expect-error - TS7031 - Binding element 'promise' implicitly has an 'any' type.
    promise, hasSuccessOnce: // @ts-expect-error - TS7031 - Binding element 'hasSuccessOnce' implicitly has an 'any' type.
    hasSuccessOnce, isFetching: // @ts-expect-error - TS7031 - Binding element 'isFetching' implicitly has an 'any' type.
    isFetching })=>({
            items: items,
            hasFetchedOnce: hasFetchedOnce,
            fetchError: fetchError,
            promise: promise,
            hasSuccessOnce: hasSuccessOnce,
            isFetching: isFetching
        });
    // @ts-expect-error - TS2344 - Type '{ readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<void>; }' does not satisfy the constraint 'Record<string, ActionThunk<GenericState<I>, { readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<...>; }>>'.
    const ForgeGlobalItemsSubscriber = (0, $ht3nQ.createSubscriber)(Store, {
        displayName: 'ForgeGlobalItemsSubscriber',
        selector: selector
    });
    const useForgeGlobalItems = (0, $iJq0l.createHook)(Store, {
        selector: selector
    });
    // @ts-expect-error - TS2322 - Type 'HookFunction<{ items: any; hasFetchedOnce: any; fetchError: any; promise: any; hasSuccessOnce: any; isFetching: any; }, BoundActions<{ fetchForgeModule: (arg1: { cloudId: string; moduleName: FullPageModule; }) => Promise<...>; ... 5 more ...; isFetching: boolean; }, Record<...>>, void>' is not assignable to type '() => HookReturnValue<GenericPublicState<I>, { readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<...>; }>'.
    return {
        ForgeGlobalItemsSubscriber: ForgeGlobalItemsSubscriber,
        useForgeGlobalItems: useForgeGlobalItems,
        ForgeGlobalItemsTestContainer: ForgeGlobalItemsTestContainer
    };
};
const { useForgeGlobalItems: $9d1e51491ba4a3e2$export$fa6081acdcc112a0 } = $9d1e51491ba4a3e2$export$a87c2a3d589b7efd();

});

parcelRegister("dS8Qn", function(module, exports) {

$parcel$export(module.exports, "useForgePersonalSettingsItems", () => $16a98aa15a8407c8$export$455fadc65ea0bef0);

var $9Dhvc = parcelRequire("9Dhvc");

var $fohjD = parcelRequire("fohjD");

var $ePLco = parcelRequire("ePLco");

var $dhAnj = parcelRequire("dhAnj");

var $6zXPf = parcelRequire("6zXPf");

var $bxWdr = parcelRequire("bxWdr");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $16a98aa15a8407c8$var$getItemHref = (extension)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `${(0, $bxWdr.getAppsPersonalSettingsPath)()}/${appId}/${envId}`;
};
const $16a98aa15a8407c8$var$handleFetch = ({ cloudId: cloudId, isAnonymous: isAnonymous })=>async ({ setState: setState, getState: getState })=>{
        const { fetchForgeModule: fetchForgeModule, isFetching: isFetching } = getState();
        if (!isFetching) try {
            // If Nav4 is enabled, we don't need to fetch personalSettings items since they are implemented elsewhere.
            if ((0, $6zXPf.getWillShowNav4)()) return;
            const promise = fetchForgeModule({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                context: {},
                includeHidden: false,
                types: [
                    (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE)
                ],
                source: (0, $fohjD.SOURCE_NAVIGATION)
            });
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const data = await promise;
            const personalSettingsPageData = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(data, (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE)) || [];
            const items = personalSettingsPageData.map((extension)=>({
                    id: extension.id,
                    title: extension.properties.title,
                    avatarUrl: extension.properties.icon,
                    url: $16a98aa15a8407c8$var$getItemHref(extension),
                    environmentType: extension.environmentType,
                    environmentKey: extension.environmentKey,
                    module: (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE)
                }));
            setState({
                items: items,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError instanceof Error ? fetchError : null,
                promise: null
            });
        }
    };
const $16a98aa15a8407c8$var$actions = {
    load: ({ cloudId: cloudId, isAnonymous: isAnonymous })=>async ({ dispatch: dispatch })=>{
            await dispatch($16a98aa15a8407c8$var$handleFetch({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            }));
        }
};
const $16a98aa15a8407c8$export$a51e606fadb150f6 = (defaults)=>{
    const initialState = {
        fetchForgeModule: defaults.fetchForgeModule,
        items: [],
        promise: null,
        fetchError: null,
        isFetching: false
    };
    const Store = (0, $GtRbT.createStore)({
        name: 'forge-personal-settings-items-store',
        actions: $16a98aa15a8407c8$var$actions,
        initialState: initialState
    });
    const ForgePersonalSettingsItemsTestContainer = (0, $6E16M.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState(props);
            }
    });
    const selector = ({ items: items, fetchError: fetchError, promise: promise, isFetching: isFetching })=>({
            items: items,
            fetchError: fetchError,
            promise: promise,
            isFetching: isFetching
        });
    const ForgePersonalSettingsItemsSubscriber = (0, $ht3nQ.createSubscriber)(Store, {
        displayName: 'ForgePersonalSettingsItemsSubscriber',
        selector: selector
    });
    const useForgePersonalSettingsItems = (0, $iJq0l.createHook)(Store, {
        selector: selector
    });
    return {
        ForgePersonalSettingsItemsSubscriber: ForgePersonalSettingsItemsSubscriber,
        useForgePersonalSettingsItems: useForgePersonalSettingsItems,
        ForgePersonalSettingsItemsTestContainer: ForgePersonalSettingsItemsTestContainer
    };
};
const { useForgePersonalSettingsItems: $16a98aa15a8407c8$export$455fadc65ea0bef0 } = $16a98aa15a8407c8$export$a51e606fadb150f6({
    fetchForgeModule: (0, $dhAnj.fetchModules)
});

});


parcelRegister("crIFg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9693522152d1aa59$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9693522152d1aa59$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    topNav: {
        "id": "atlassian-navigation.top-nav",
        "defaultMessage": "Primary"
    },
    more: {
        "id": "atlassian-navigation.more",
        "defaultMessage": "More"
    }
});

});

parcelRegister("jILIS", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $5b37db828d9d955f$export$36ba2f559d49a8f6);
$parcel$export(module.exports, "NotificationsContentWrapper", () => $5b37db828d9d955f$export$34c02505a1643f00);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5UxOh = parcelRequire("5UxOh");

var $6u5q7 = parcelRequire("6u5q7");

var $1KdDN = parcelRequire("1KdDN");

var $8Uqf3 = parcelRequire("8Uqf3");

var $dTocu = parcelRequire("dTocu");

var $5RW99 = parcelRequire("5RW99");

var $gOfBc = parcelRequire("gOfBc");

var $RXvVX = parcelRequire("RXvVX");

var $fYeTG = parcelRequire("fYeTG");

var $ch9En = parcelRequire("ch9En");

var $cECwI = parcelRequire("cECwI");

var $gzcjr = parcelRequire("gzcjr");

var $f2JN3 = parcelRequire("f2JN3");

var $bJscI = parcelRequire("bJscI");

var $kO1ht = parcelRequire("kO1ht");

var $3nihz = parcelRequire("3nihz");

var $isgAI = parcelRequire("isgAI");

var $4BIvh = parcelRequire("4BIvh");

var $jRdpz = parcelRequire("jRdpz");


var $ebmHm = parcelRequire("ebmHm");

const $5b37db828d9d955f$var$BadgeDI = (0, $gzcjr.lazy)(()=>(parcelRequire("10sPL")).then(({ Badge: Badge })=>Badge), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/badge/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5b37db828d9d955f$var$MenuDI = (0, $gzcjr.lazy)(()=>(parcelRequire("b5Qrn")).then(({ Menu: Menu })=>Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/menu/index.tsx"
});
const $5b37db828d9d955f$var$Notifications = ({ Badge: Badge = $5b37db828d9d955f$var$BadgeDI, ErrorBoundary: ErrorBoundary = (0, $1KdDN.JSErrorBoundary), Icon: Icon = (0, $isgAI.Notification), Menu: Menu = $5b37db828d9d955f$var$MenuDI, NotificationContentFrame: NotificationContentFrame = $5b37db828d9d955f$var$NotificationContentFrameDI, Popup: Popup = (0, $5UxOh.default), useExperienceStart: useExperienceStart = (0, $8Uqf3.useExperienceStart), useIntl: useIntl = (0, $dTocu.useIntlV2), useIsAnonymous: useIsAnonymous = (0, $cECwI.useIsAnonymous), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $4BIvh.useNavigationItemAnalytics), useTopMenus: useTopMenus = (0, $gOfBc.useTopMenus) })=>{
    const testIdPrefix = (0, $RXvVX.testIdGenerate)('secondary-actions', 'notifications');
    const { formatMessage: formatMessage } = useIntl();
    const isAnonymous = useIsAnonymous();
    const [isNotificationCleared, setIsNotificationCleared] = (0, $eJOHy.useState)(false);
    const [notificationCount, setNotificationCount] = (0, $eJOHy.useState)(0);
    const handleCountUpdate = (0, $eJOHy.useCallback)((newCount)=>{
        setNotificationCount(newCount);
    }, []);
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu, on: openMenu }] = useTopMenus((0, $5RW99.MENU_ID).NOTIFICATIONS);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).NOTIFICATIONS
    });
    const onStart = useExperienceStart({
        experience: (0, $kO1ht.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $kO1ht.NAVIGATION_ITEM_ID).NOTIFICATIONS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (isMenuOpen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.clearMarks('notification.list.render.start');
        else performance.mark('notification.list.render.start');
        onStart();
        toggleMenu();
        triggerAnalytics();
        setIsNotificationCleared(true);
    }, [
        isMenuOpen,
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    const handleNotificationIconHover = ()=>{
        $5b37db828d9d955f$var$MenuDI.preload();
    };
    (0, $jRdpz.useRegisterNotificationsInCommandPalette)(onClick);
    const content = (0, $eJOHy.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NotificationContentFrame, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ErrorBoundary, {
            id: "notifications.list.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
            name: "notification-menu-native",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Menu, {
            scheduleUpdate: update,
            testIdPrefix: testIdPrefix
        })))), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        testIdPrefix
    ]);
    const badge = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ErrorBoundary, {
            id: "notifications.badge.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation",
            fallback: "unmount"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
            name: "badge",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Badge, {
            isNotificationCleared: isNotificationCleared,
            setIsNotificationCleared: setIsNotificationCleared,
            isNotificationDrawerOpen: isMenuOpen,
            onNotificationCountChange: handleCountUpdate
        }))), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isNotificationCleared,
        isMenuOpen
    ]);
    const badgeEmpty = (0, $eJOHy.useCallback)(()=>null, []);
    const notificationsLabel = notificationCount < (0, $fd3ecb7812b98df6$export$14c62ba6f49b806f) ? formatMessage((0, $ebmHm.default).label, {
        count: notificationCount
    }) : formatMessage((0, $ebmHm.default).overNineNotifications);
    const trigger = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": (0, $RXvVX.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": `atlassian-navigation-notifications${false ? '-ssr' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
            ...triggerProps,
            badge: badge,
            isSelected: isMenuOpen,
            onClick: onClick,
            onMouseEnter: handleNotificationIconHover,
            tooltip: formatMessage((0, $ebmHm.default).tooltip),
            label: notificationsLabel,
            onViewRequests: openMenu
        })), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        badge,
        isMenuOpen,
        onClick,
        formatMessage,
        testIdPrefix,
        notificationCount
    ]);
    if (isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        badge: badgeEmpty,
        tooltip: formatMessage((0, $ebmHm.default).tooltip)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Popup, {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        trigger: trigger,
        shouldRenderToParent: true,
        shouldFitViewport: (0, $fYeTG.isMobileAndInViewPanelIterationExperiment)() ? true : undefined
    });
};
const $5b37db828d9d955f$export$36ba2f559d49a8f6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).NOTIFICATIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6u5q7.UsingNotificationsToImproveAdminApprovalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5b37db828d9d955f$var$Notifications, props)));
const $5b37db828d9d955f$var$notificationContentFrameStyles = null;
const $5b37db828d9d955f$var$notificationContentFrameStylesUpdatedHeight = null;
const $5b37db828d9d955f$var$NotificationContentFrameDIWithResponsiveWidthUpdatedHeight = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1bsb1xd4 _4t3i1vpj _1e0c1txw _g7111w2c"
        ])
    }, children);
};
const $5b37db828d9d955f$var$NotificationContentFrameDIWithResponsiveWidthLongHeight = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1bsb1xd4 _4t3i54ef _1e0c1txw _g7111w2c"
        ])
    }, children);
};
const $5b37db828d9d955f$var$NotificationContentFrameDIWithResponsiveWidth = (0, $bJscI.componentWithFG)('jira-jjj-adjust-notifs-panel-height', $5b37db828d9d955f$var$NotificationContentFrameDIWithResponsiveWidthUpdatedHeight, $5b37db828d9d955f$var$NotificationContentFrameDIWithResponsiveWidthLongHeight); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, jira/styled/styled-component-order -- To migrate as part of go/ui-styling-standard
const $5b37db828d9d955f$var$NotificationContentFrameDIOldLongHeight = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1w2c _4t3i54ef _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, jira/styled/styled-component-order -- To migrate as part of go/ui-styling-standard
const $5b37db828d9d955f$var$NotificationContentFrameDIOldUpdatedHeight = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1w2c _4t3i1vpj _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $5b37db828d9d955f$var$NotificationContentFrameDIOld = (0, $bJscI.componentWithFG)('jira-jjj-adjust-notifs-panel-height', $5b37db828d9d955f$var$NotificationContentFrameDIOldUpdatedHeight, $5b37db828d9d955f$var$NotificationContentFrameDIOldLongHeight); // TODO: When the cleanup is done, remove the exported wrapper component below please (see NotificationsContentWrapper)
//       Add fix the import in the Nav4Notifications componponent (which is colocated)
const $5b37db828d9d955f$var$NotificationContentFrameDI = (0, $f2JN3.componentWithCondition)(()=>(0, $fYeTG.isMobileAndInViewPanelIterationExperiment)(), $5b37db828d9d955f$var$NotificationContentFrameDIWithResponsiveWidth, $5b37db828d9d955f$var$NotificationContentFrameDIOld); // This has been created to circumvent a ratcheting rule and avoid an ESLint suppression
const $5b37db828d9d955f$export$34c02505a1643f00 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5b37db828d9d955f$var$NotificationContentFrameDI, null, children);
};

});
parcelRegister("6u5q7", function(module, exports) {

$parcel$export(module.exports, "CoordinationStopProvider", () => $a21922d4f991da23$export$83d026e3dd5706d);
$parcel$export(module.exports, "UsingNotificationsToImproveAdminApprovalProvider", () => $a21922d4f991da23$export$a5554f3421878be1);
$parcel$export(module.exports, "useUsingNotificationsToImproveAdminApprovalContext", () => $a21922d4f991da23$export$3e450d633150d6ca);

var $eJOHy = parcelRequire("eJOHy");

var $dnU6V = parcelRequire("dnU6V");

var $lvKO5 = parcelRequire("lvKO5");

const $a21922d4f991da23$var$TouchpointContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    hasSpotlightBeenShown: true,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    markSpotlightAsShown: ()=>{}
});
const $a21922d4f991da23$var$localStorage = (0, $dnU6V.createLocalStorageProvider)((0, $f71427a7081a8d43$export$67a034c701fa7ff6));
const $a21922d4f991da23$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $a21922d4f991da23$export$a5554f3421878be1 = ({ children: children })=>{
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = (0, $lvKO5.useTenantContext)();
    const [hasSpotlightBeenShown, setHasSpotlightBeenShown] = (0, $eJOHy.useState)(true);
    const spotlightLocalStorageKey = `${(0, $f71427a7081a8d43$export$7a86d77850136bf4)}_${cloudId}_${atlassianAccountId}`;
    (0, $eJOHy.useEffect)(()=>{
        setHasSpotlightBeenShown($a21922d4f991da23$var$localStorage.get(spotlightLocalStorageKey) || false);
    }, [
        spotlightLocalStorageKey
    ]);
    const markSpotlightAsShown = (0, $eJOHy.useCallback)(()=>{
        $a21922d4f991da23$var$localStorage.set(spotlightLocalStorageKey, true);
        setHasSpotlightBeenShown(true);
    }, [
        setHasSpotlightBeenShown,
        spotlightLocalStorageKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a21922d4f991da23$var$TouchpointContext.Provider, {
        value: {
            hasSpotlightBeenShown: hasSpotlightBeenShown,
            markSpotlightAsShown: markSpotlightAsShown
        }
    }, children);
};
const $a21922d4f991da23$export$3e450d633150d6ca = ()=>(0, $eJOHy.useContext)($a21922d4f991da23$var$TouchpointContext);

});
const $f71427a7081a8d43$export$67a034c701fa7ff6 = 'uniapa';
const $f71427a7081a8d43$export$7a86d77850136bf4 = 'has-spotlight-been-shown';
const $f71427a7081a8d43$export$d2ea4f931a71a509 = 'jira-admin-product-request-spotlight';


parcelRegister("isgAI", function(module, exports) {

$parcel$export(module.exports, "Notification", () => $a08e7caad0c9155b$export$14834abbfce3b8cd);

var $eJOHy = parcelRequire("eJOHy");

var $d8Igr = parcelRequire("d8Igr");

var $eE4Eu = parcelRequire("eE4Eu");

var $hZUwi = parcelRequire("hZUwi");
var $gbiVe = parcelRequire("gbiVe");
var $REcGP = parcelRequire("REcGP");

var $4F2el = parcelRequire("4F2el");


var $6u5q7 = parcelRequire("6u5q7");

var $bae93 = parcelRequire("bae93");

var $9zZj0 = parcelRequire("9zZj0");

var $6zXPf = parcelRequire("6zXPf");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $lvKO5 = parcelRequire("lvKO5");
// Should this live in the migration layer (@atlassian/jira-navigation-system) instead?
const $a08e7caad0c9155b$var$renderNotifications = (props, ref)=>{
    const { onViewRequests: onViewRequests, ...notificationProps } = props;
    if ((0, $6zXPf.getWillShowNav4)()) {
        const { badge: badge, onClick: onClick, isSelected: isSelected, label: label } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4F2el.Notifications), {
            badge: badge,
            label: label,
            onClick: onClick,
            isSelected: isSelected,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- PLEASE FIX - ENABLING FLAT LINT CONFIG
            ref: ref
        });
    }
    const buttonProps = {
        ...notificationProps,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d8Igr.Notifications), buttonProps);
};
const $a08e7caad0c9155b$export$14834abbfce3b8cd = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { markSpotlightAsShown: markSpotlightAsShown, hasSpotlightBeenShown: hasSpotlightBeenShown } = (0, $6u5q7.useUsingNotificationsToImproveAdminApprovalContext)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eJOHy.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin } = (0, $lvKO5.useTenantContext)();
    // As an experiment we will bypass the SSR route for notifications so that instead of rendering
    // a skeleton component that will be replaced by the real component, we will render the real component.
    // This means that TTVC should increase because there will be less work to do on the client side.
    if (!(0, $6zXPf.getWillShowNav4)() && false) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eE4Eu.SkeletonNotificationButton), {
        label: props.tooltip
    });
    const { onViewRequests: onViewRequests, ...notificationProps } = props;
    /**
	 * Send analytics event when user clicks "Close" or "View requests" button on the request spotlight
	 * Event registry - https://data-portal.internal.atlassian.com/analytics/registry/52348
	 * @param {"close"|"viewRequests"} buttonType
	 */ const handleSendAnalyticsEventForClickRequestSpotlightButton = (buttonType)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'requestSpotlightButton', {
            buttonType: buttonType,
            isSiteAdmin: isSiteAdmin
        });
    };
    const shouldShowRequestsSpotlight = isSiteAdmin && !hasSpotlightBeenShown;
    if (!shouldShowRequestsSpotlight) return $a08e7caad0c9155b$var$renderNotifications(notificationProps, ref);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hZUwi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), {
        name: "admin-request-spotlight"
    }, $a08e7caad0c9155b$var$renderNotifications(notificationProps, ref)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $REcGP.default), null, isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9zZj0.default), {
        messageId: (0, $f71427a7081a8d43$export$d2ea4f931a71a509),
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6u5q7.CoordinationStopProvider), null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bae93.UsingNotificationsToImproveAdminApprovalSpotlight), {
            onViewRequests: ()=>{
                setIsSpotlightActive(false);
                markSpotlightAsShown();
                onViewRequests && onViewRequests();
                handleSendAnalyticsEventForClickRequestSpotlightButton('viewRequests');
                stop && stop();
            },
            onClose: ()=>{
                setIsSpotlightActive(false);
                markSpotlightAsShown();
                handleSendAnalyticsEventForClickRequestSpotlightButton('close');
                stop && stop();
            }
        })))));
});

});
parcelRegister("bae93", function(module, exports) {

$parcel$export(module.exports, "UsingNotificationsToImproveAdminApprovalSpotlight", () => $38e02a2f9bd83fb4$export$aa9f9fc1c08b114f);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");

var $9HHOs = parcelRequire("9HHOs");

var $lvKO5 = parcelRequire("lvKO5");

var $8xcML = parcelRequire("8xcML");
const $38e02a2f9bd83fb4$export$aa9f9fc1c08b114f = ({ onViewRequests: onViewRequests, onClose: onClose })=>{
    const uniapaSpotlightNotificationTextAppify = (0, $7jTnu.fg)('product-terminology-refresh') ? (0, $8xcML.default).uniapaSpotlightNotificationTextAppify : (0, $8xcML.default).uniapaSpotlightNotificationText;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $lvKO5.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$cae2783c9279926),
        sourceName: "requestSpotlight",
        attributes: {
            isSiteAdmin: isSiteAdmin
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), {
        actions: [
            {
                onClick: onViewRequests,
                text: formatMessage((0, $8xcML.default).uniapaSpotlightViewRequestsButtonText)
            },
            {
                onClick: onClose,
                text: formatMessage((0, $8xcML.default).uniapaSpotlightCloseButtonText),
                appearance: 'subtle'
            }
        ],
        target: "admin-request-spotlight",
        key: "admin-request-spotlight",
        targetRadius: 100,
        dialogPlacement: "bottom right",
        dialogWidth: 275,
        targetBgColor: "var(--ds-icon-inverse, #FFFFFF)",
        messageId: "cross-flow-using-notifications-to-improve-admin-approval.ui.jira-spotlight.admin-request-spotlight",
        messageType: "engagement"
    }, formatMessage(uniapaSpotlightNotificationTextAppify))));
};

});
parcelRegister("8xcML", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4cc9c7efe80dbc9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a4cc9c7efe80dbc9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    uniapaSpotlightNotificationText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-notification-text",
        "defaultMessage": "When someone in your team requests a new product you'll get a notification here now."
    },
    uniapaSpotlightCloseButtonText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-close-button-text",
        "defaultMessage": "Close"
    },
    uniapaSpotlightViewRequestsButtonText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-view-requests-button-text",
        "defaultMessage": "View requests"
    },
    uniapaSpotlightNotificationTextAppify: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-notification-text-appify",
        "defaultMessage": "When someone in your team requests a new app you'll get a notification here now."
    }
});

});



parcelRegister("jRdpz", function(module, exports) {

$parcel$export(module.exports, "useRegisterNotificationsInCommandPalette", () => $be8c1958e80f2b2b$export$1859b18f10ade54c);

var $eJOHy = parcelRequire("eJOHy");

var $9nbQZ = parcelRequire("9nbQZ");

var $1Zcfy = parcelRequire("1Zcfy");

var $ii7Oz = parcelRequire("ii7Oz");

var $itdlt = parcelRequire("itdlt");

var $fWwfy = parcelRequire("fWwfy");

var $fGVnv = parcelRequire("fGVnv");

var $hf4h9 = parcelRequire("hf4h9");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");


var $eoFNL = parcelRequire("eoFNL");
const $be8c1958e80f2b2b$export$1859b18f10ade54c = (onClick)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getKeywords: getKeywords } = (0, $itdlt.useCommandKeywords)();
    const commands = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-2') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>[
            {
                id: (0, $0da9307007fc60c1$export$e0226a83abddbd07),
                name: formatMessage((0, $eoFNL.messages).checkNotifications),
                primaryAction: {
                    type: (0, $hf4h9.CommandActionType).PERFORM,
                    perform: onClick
                },
                keywords: getKeywords('checkNotificationsSynonyms'),
                section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickActions,
                priority: (0, $ii7Oz.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).checkNotifications,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nbQZ))), {
                            spacing: "spacious",
                            label: formatMessage((0, $eoFNL.messages).checkNotifications)
                        })
                },
                analytics: {
                    action: 'checkNotifications'
                }
            }
        ], [
        formatMessage,
        getKeywords,
        onClick
    ]) : [
        {
            id: (0, $0da9307007fc60c1$export$e0226a83abddbd07),
            name: formatMessage((0, $eoFNL.messages).checkNotifications),
            primaryAction: {
                type: (0, $hf4h9.CommandActionType).PERFORM,
                perform: onClick
            },
            keywords: getKeywords('checkNotificationsSynonyms'),
            section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickActions,
            priority: (0, $ii7Oz.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).checkNotifications,
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nbQZ))), {
                        spacing: "spacious",
                        label: formatMessage((0, $eoFNL.messages).checkNotifications)
                    })
            },
            analytics: {
                action: 'checkNotifications'
            }
        }
    ];
    (0, $fGVnv.useRegisterCommands)((0, $fWwfy.COMMAND_PALETTE_REGISTRY_IDS).CHECK_NOTIFICATIONS, commands);
};

});
parcelRegister("1Zcfy", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $9047f4ba14bb7637$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $9047f4ba14bb7637$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $9047f4ba14bb7637$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $9047f4ba14bb7637$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $9047f4ba14bb7637$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $9047f4ba14bb7637$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $9047f4ba14bb7637$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $9047f4ba14bb7637$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $9047f4ba14bb7637$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $9047f4ba14bb7637$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $9047f4ba14bb7637$export$16b06d29ef8f802b = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["containerNavigation"] = "container-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
    COMMAND_PALETTE_SECTIONS["forge"] = "forge";
    return COMMAND_PALETTE_SECTIONS;
}({});
const $9047f4ba14bb7637$export$156ebd2354e25466 = 'issueActions';
const $9047f4ba14bb7637$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $9047f4ba14bb7637$export$9f646ab88e1d2b14 = 'commandPalette';
var $9047f4ba14bb7637$export$abf26cc5daebd2c8 = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["containerNavigation"] = 2] = "containerNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["forge"] = 9] = "forge";
    return COMMAND_PALETTE_SECTIONS_PRIORITY;
}({});
var $9047f4ba14bb7637$export$12514ca8899b0521 = /*#__PURE__*/ function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
    return COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY;
}({});
var $9047f4ba14bb7637$export$5fa0bcf59f933c21 = /*#__PURE__*/ function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
    return COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY;
}({});
var $9047f4ba14bb7637$export$7d9743be0b7d862f = /*#__PURE__*/ function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
    return COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY;
}({});
var $9047f4ba14bb7637$export$b4e1633c86db2b70 = /*#__PURE__*/ function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewMyIssues"] = 0] = "viewMyIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 1] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 2] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 3] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 4] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 5] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 6] = "goToPlans";
    return COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY;
}({});
var $9047f4ba14bb7637$export$5e5a87aac5d9771f = /*#__PURE__*/ function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
    return COMMAND_PALETTE_HELP_PRIORITY;
}({});

});

parcelRegister("ii7Oz", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $4dacf61939d854f6$export$5ea2dca0a260365d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $4dacf61939d854f6$export$5ea2dca0a260365d = /*#__PURE__*/ function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openFilterPopup"] = 5] = "openFilterPopup";
    return COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY;
}({});

});

parcelRegister("itdlt", function(module, exports) {

$parcel$export(module.exports, "useCommandKeywords", () => $ee480ed0df38ab27$export$4d8fe3ef6385358);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $cnlru = parcelRequire("cnlru");
const $ee480ed0df38ab27$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getKeywords = (0, $eJOHy.useCallback)((keywordGroup)=>(0, $cnlru.messages)[keywordGroup] ? formatMessage((0, $cnlru.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("cnlru", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b90e6119f7427a6f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b90e6119f7427a6f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    },
    goToIssuesSynonymsIssueTermRefresh: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms-issue-term-refresh",
        "defaultMessage": "Advanced work item search Project Filter JQL search list View all"
    },
    viewAllIssuesSynonymsIssueTermRefresh: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms-issue-term-refresh",
        "defaultMessage": "Site work items JQL View all"
    },
    goToIssuesSynonymsIssueTermRefreshGalaxia: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms-issue-term-refresh-galaxia",
        "defaultMessage": "Advanced work item search Space Filter JQL search list View all"
    },
    viewMyOpenIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-my-open-issues-synonyms",
        "defaultMessage": "Issues assigned in-progress"
    },
    viewIssuesReportedByMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-issues-reported-by-me-synonyms",
        "defaultMessage": "Issues created"
    }
});

});


parcelRegister("fWwfy", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $67a434ec4fcbe6f3$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $67a434ec4fcbe6f3$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $67a434ec4fcbe6f3$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE',
    FORGE: 'FORGE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $67a434ec4fcbe6f3$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $67a434ec4fcbe6f3$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.COPY_URL,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.DESCRIPTION,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.LOG_WORK,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.PARENT,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.QUICK_ADD,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.QUICK_SEARCH,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.SHORTCUTS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.STATUS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.STORY_POINTS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.THEME_MODE,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    }
};

});

parcelRegister("fGVnv", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommands", () => $e29b438fb88ad88a$export$3f626f8a5dbc29e4);

var $cQKVu = parcelRequire("cQKVu");
const $e29b438fb88ad88a$export$3f626f8a5dbc29e4 = (0, $cQKVu.useRegisterCommandsWithRegistry);

});
parcelRegister("cQKVu", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $6d5c9742963ffdc5$export$8a824ae164ff968d);

var $eJOHy = parcelRequire("eJOHy");

var $iTb6Y = parcelRequire("iTb6Y");
function $6d5c9742963ffdc5$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $iTb6Y.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $eJOHy.useRef)(commands);
    (0, $eJOHy.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("iTb6Y", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $bd9364f64b41cfe5$export$880fc01e31710b27);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");
function $bd9364f64b41cfe5$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $g51Bg.useActionsCommandPalette)();
    const subscribe = (0, $eJOHy.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});



const $0da9307007fc60c1$export$e0226a83abddbd07 = 'check-notifications';

parcelRegister("eoFNL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a6950214edaf98a8$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a6950214edaf98a8$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    checkNotifications: {
        "id": "atlassian-navigation.notifications.command-palette.check-notifications",
        "defaultMessage": "Check notifications"
    }
});

});


const $fd3ecb7812b98df6$export$14c62ba6f49b806f = 9;

parcelRegister("ebmHm", function(module, exports) {

$parcel$export(module.exports, "default", () => $99a38bbac9e95618$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $99a38bbac9e95618$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.notifications.tooltip",
        "defaultMessage": "Notifications"
    },
    oldLabel: {
        "id": "atlassian-navigation.notifications.old-label",
        "defaultMessage": "Notifications"
    },
    label: {
        "id": "atlassian-navigation.notifications.label",
        "defaultMessage": "{count, plural, =0{ Notifications} one{{count, number} Notification} other{{count, number} Notifications}}"
    },
    overNineNotifications: {
        "id": "atlassian-navigation.notifications.over-nine-notifications",
        "defaultMessage": "Over 9 Notifications"
    }
});

});

parcelRegister("10sPL", function(module, exports) {

let $0bbc28554fc94236$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0bbc28554fc94236$var$load("l0OZ8").then(()=>parcelRequire('hTcRh'));

});

parcelRegister("b5Qrn", function(module, exports) {

let $8138d6f1ba321848$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8138d6f1ba321848$var$load("1VRB2"),
    $8138d6f1ba321848$var$load("bABhq"),
    $8138d6f1ba321848$var$load("lKM4l")
]).then(()=>parcelRequire('3rrmj'));

});


parcelRegister("gWKt4", function(module, exports) {

$parcel$export(module.exports, "ProductHome", () => $58482d1c10676c6d$export$32d61f70e04b6020);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $22O5h = parcelRequire("22O5h");
var $jvdnf = parcelRequire("jvdnf");

var $8uw8h = parcelRequire("8uw8h");

var $fBXRE = parcelRequire("fBXRE");

var $lTMKF = parcelRequire("lTMKF");

var $5Pk0T = parcelRequire("5Pk0T");

var $7fOZl = parcelRequire("7fOZl");

var $dhRXV = parcelRequire("dhRXV");

var $17rpD = parcelRequire("17rpD");
var $aVvsS = parcelRequire("aVvsS");

var $7jTnu = parcelRequire("7jTnu");

var $f2JN3 = parcelRequire("f2JN3");

var $lRq8t = parcelRequire("lRq8t");

var $RXvVX = parcelRequire("RXvVX");

var $6zXPf = parcelRequire("6zXPf");

var $eNgPF = parcelRequire("eNgPF");

var $83DiZ = parcelRequire("83DiZ");

var $kO1ht = parcelRequire("kO1ht");

var $3nihz = parcelRequire("3nihz");

var $70LOs = parcelRequire("70LOs");

var $4BIvh = parcelRequire("4BIvh");

var $cchh5 = parcelRequire("cchh5");

var $dzJfX = parcelRequire("dzJfX");
const $58482d1c10676c6d$export$6d49a893c897b0cc = {
    jira: {
        icon: (0, $8uw8h.JiraIcon),
        logo: (0, $fBXRE.JiraLogo),
        name: 'Jira'
    },
    serviceDesk: {
        icon: (0, $8uw8h.JiraServiceManagementIcon),
        logo: (0, $lTMKF.JiraServiceManagementLogo),
        name: 'Jira Service Management'
    },
    'product-discovery': {
        icon: (0, $8uw8h.JiraProductDiscoveryIcon),
        logo: (0, $5Pk0T.JiraProductDiscoveryLogo),
        name: 'Jira Product Discovery'
    },
    'customer-service': {
        icon: (0, $8uw8h.CustomerServiceManagementIcon),
        logo: (0, $7fOZl.CustomerServiceManagementLogo),
        name: 'Customer Service Management'
    }
};
const $58482d1c10676c6d$var$ProductHome = (0, $f2JN3.componentWithCondition)(()=>(0, $6zXPf.getWillShowNav4)(), $58482d1c10676c6d$var$ProductHomeNew, $58482d1c10676c6d$var$ProductHomeOld);
const $58482d1c10676c6d$export$32d61f70e04b6020 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).HOME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58482d1c10676c6d$var$ProductHome, props));
function $58482d1c10676c6d$var$ProductHomeOld({ AkCustomProductHome: AkCustomProductHome = (0, $22O5h.default), AkProductHome: AkProductHome = (0, $jvdnf.default), useCustomLogo: useCustomLogo = (0, $70LOs.useCustomLogo), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $4BIvh.useNavigationItemAnalytics), useProductName: useProductName = (0, $eNgPF.useProductName), useRouterActions: useRouterActions = (0, $83DiZ.useRouterActions), useSiteTitle: useSiteTitle = (0, $cchh5.useSiteTitle) }) {
    const testIdPrefix = (0, $RXvVX.testIdGenerate)('product-home-');
    const logoUrl = useCustomLogo();
    const productName = useProductName();
    const siteTitleData = useSiteTitle();
    const siteTitle = siteTitleData.shouldShow && siteTitleData.value || undefined;
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).LOGO
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { push: push } = useRouterActions();
    const homeUrl = '/jira';
    const navigateToHome = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'ev' implicitly has an 'any' type.
    (ev)=>{
        triggerAnalytics();
        if (ev.ctrlKey || ev.metaKey) return;
        ev.preventDefault();
        push(homeUrl);
    }, [
        triggerAnalytics,
        push,
        homeUrl
    ]);
    if (logoUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AkCustomProductHome, {
        iconUrl: logoUrl,
        logoUrl: logoUrl,
        logoAlt: formatMessage((0, $dzJfX.default).customLogoAltText),
        iconAlt: formatMessage((0, $dzJfX.default).customIconAltText),
        href: homeUrl,
        onClick: navigateToHome,
        siteTitle: siteTitle,
        testId: testIdPrefix
    });
    const label = $58482d1c10676c6d$var$getLogoLabel(formatMessage, productName);
    const { icon: Icon, logo: Logo } = (0, $7jTnu.fg)('jiv-20710-fix-nav-rerender') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>$58482d1c10676c6d$var$getProductIconAndLogo(productName, undefined, label), [
        productName,
        label
    ]) : $58482d1c10676c6d$var$getProductIconAndLogo(productName, undefined, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AkProductHome, {
        icon: Icon,
        logo: Logo,
        href: homeUrl,
        onClick: navigateToHome,
        siteTitle: siteTitle,
        testId: testIdPrefix
    });
}
function $58482d1c10676c6d$var$ProductHomeNew({ useCustomLogo: useCustomLogo = (0, $70LOs.useCustomLogo), useCustomIcon: useCustomIcon = (0, $70LOs.useCustomIcon), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $4BIvh.useNavigationItemAnalytics), useProductName: useProductName = (0, $eNgPF.useProductName), useRouterActions: useRouterActions = (0, $83DiZ.useRouterActions) }) {
    const testIdPrefix = (0, $RXvVX.testIdGenerate)('product-home-');
    const logoUrl = useCustomLogo();
    const iconUrl = useCustomIcon();
    const productName = useProductName();
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).LOGO
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { push: push } = useRouterActions();
    const homeUrl = '/jira';
    const navigateToHome = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'ev' implicitly has an 'any' type.
    (ev)=>{
        triggerAnalytics();
        if (ev.ctrlKey || ev.metaKey) return;
        ev.preventDefault();
        push(homeUrl);
    }, [
        triggerAnalytics,
        push,
        homeUrl
    ]);
    const { icon: ProductIcon, logo: ProductLogo, name: logoName } = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') || (0, $7jTnu.fg)('jiv-20710-fix-nav-rerender') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>$58482d1c10676c6d$var$getProductIconAndLogo(productName, testIdPrefix), [
        productName,
        testIdPrefix
    ]) : $58482d1c10676c6d$var$getProductIconAndLogo(productName, testIdPrefix);
    const Logo = (0, $eJOHy.useMemo)(()=>logoUrl ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58482d1c10676c6d$var$CustomImgNav4, {
                alt: formatMessage((0, $dzJfX.default).customLogoAltText),
                src: logoUrl,
                testId: `${testIdPrefix}-logo`
            }) : ProductLogo, [
        logoUrl,
        ProductLogo,
        formatMessage,
        testIdPrefix
    ]);
    const Icon = (0, $eJOHy.useMemo)(()=>logoUrl && iconUrl ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58482d1c10676c6d$var$CustomImgNav4, {
                alt: formatMessage((0, $dzJfX.default).customIconAltText),
                src: iconUrl,
                testId: `${testIdPrefix}-icon`
            }) : ProductIcon, [
        logoUrl,
        iconUrl,
        ProductIcon,
        testIdPrefix,
        formatMessage
    ]);
    const label = $58482d1c10676c6d$var$getLogoLabel(formatMessage, productName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        testId: `${testIdPrefix}-container`
    }, (0, $7jTnu.fg)('jira-nav-logo-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $17rpD.AppLogo), {
        name: logoName,
        label: label,
        icon: Icon,
        href: homeUrl,
        onClick: navigateToHome
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVvsS.CustomLogo), {
        label: label,
        icon: Icon,
        logo: Logo,
        href: homeUrl,
        onClick: navigateToHome
    }));
}
// formatMessage is intentionally an any type due to absence of easily importable type, and because actual
// type definition contains any as well!
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $58482d1c10676c6d$var$getLogoLabel(formatMessage, productName) {
    let label = '';
    if (productName === 'serviceDesk') label = formatMessage((0, $dzJfX.default).jsmLogoLabel);
    else if (productName === 'product-discovery') label = formatMessage((0, $dzJfX.default).jpdLogoLabel);
    else if (productName === 'customer-service') label = formatMessage((0, $dzJfX.default).jcsLogoLabel);
    else label = formatMessage((0, $dzJfX.default).jiraLogoLabel);
    return label;
} /**
   * Due to typescript limitations (props type clashes), we need to handle the icon and logo components differently for the
   * new and old navigation apps. This function returns the appropriate components based on the product name.
   */ 
function $58482d1c10676c6d$var$getProductIconAndLogo(productName, testIdPrefix, label) {
    const productKey = productName === 'core' || productName === 'software' ? 'jira' : productName;
    const { icon: NewIconComponent, logo: NewLogoComponent, name: logoName } = $58482d1c10676c6d$export$6d49a893c897b0cc[productKey];
    const createComponent = (Component, type, shouldUseNewLogoDesign)=>(props)=>{
            const additionalProps = {}; // Nav v3 sets a testId, Nav v4 sets a label
            if (testIdPrefix) additionalProps.testId = `${testIdPrefix}-${type}`;
            if (label) additionalProps.label = label;
            additionalProps.shouldUseNewLogoDesign = shouldUseNewLogoDesign; // Casting required due to complexities of the different component prop types
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
                ...props,
                ...additionalProps
            });
        };
    const newIcon = createComponent(NewIconComponent, 'icon', true);
    const newLogo = createComponent(NewLogoComponent, 'logo');
    return {
        icon: newIcon,
        logo: newLogo,
        name: logoName
    };
}
function $58482d1c10676c6d$var$CustomImgNav4({ alt: alt, src: src, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: src,
        alt: alt,
        "data-testid": testId
    });
}

});
parcelRegister("70LOs", function(module, exports) {

$parcel$export(module.exports, "useCustomLogo", () => $c349fa689f3f300f$export$9891fb86d6b41647);
$parcel$export(module.exports, "useCustomIcon", () => $c349fa689f3f300f$export$9e69c21df0138642);

var $eJOHy = parcelRequire("eJOHy");

var $hWeHP = parcelRequire("hWeHP");
const $c349fa689f3f300f$export$9891fb86d6b41647 = ()=>(0, $eJOHy.useMemo)(()=>(0, $hWeHP.default)('ajs-lf-top-adg3-logourl'), []);
const $c349fa689f3f300f$export$9e69c21df0138642 = ()=>(0, $eJOHy.useMemo)(()=>(0, $hWeHP.default)('ajs-fspage-favicon'), []);

});

parcelRegister("cchh5", function(module, exports) {

$parcel$export(module.exports, "useSiteTitle", () => $da78b00b5fdd3314$export$3e157e0d79928990);

var $eJOHy = parcelRequire("eJOHy");

var $hWeHP = parcelRequire("hWeHP");
const $da78b00b5fdd3314$export$3e157e0d79928990 = ()=>(0, $eJOHy.useMemo)(()=>({
            shouldShow: (0, $hWeHP.default)('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            value: (0, $hWeHP.default)('ajs-app-title')
        }), []);

});

parcelRegister("dzJfX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f59ab0f5a9a64a4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4f59ab0f5a9a64a4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    customLogoAltText: {
        "id": "atlassian-navigation.product-home.custom-logo-alt-text",
        "defaultMessage": "Jira homepage"
    },
    customIconAltText: {
        "id": "atlassian-navigation.product-home.custom-icon-alt-text",
        "defaultMessage": "Custom Jira icon"
    },
    jiraLogoLabel: {
        "id": "atlassian-navigation.product-home.jira-logo-label",
        "defaultMessage": "Go to your Jira homepage"
    },
    jsmLogoLabel: {
        "id": "atlassian-navigation.product-home.jsm-logo-label",
        "defaultMessage": "Go to your Jira Service Management homepage"
    },
    jpdLogoLabel: {
        "id": "atlassian-navigation.product-home.jpd-logo-label",
        "defaultMessage": "Go to your Jira Product Discovery homepage"
    },
    jcsLogoLabel: {
        "id": "atlassian-navigation.product-home.jcs-logo-label",
        "defaultMessage": "Go to your Jira Customer Service homepage"
    }
});

});


parcelRegister("et1RD", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $4be68d757c0fd608$export$5120f2d0b8d4cab8);

var $eJOHy = parcelRequire("eJOHy");

var $8wfPR = parcelRequire("8wfPR");

var $3ly0u = parcelRequire("3ly0u");

var $6q0fu = parcelRequire("6q0fu");

var $gbiVe = parcelRequire("gbiVe");

var $5UxOh = parcelRequire("5UxOh");

var $7Horz = parcelRequire("7Horz");

var $7W9z8 = parcelRequire("7W9z8");

var $8Uqf3 = parcelRequire("8Uqf3");

var $dTocu = parcelRequire("dTocu");

var $5RW99 = parcelRequire("5RW99");

var $gOfBc = parcelRequire("gOfBc");

var $lVMSx = parcelRequire("lVMSx");

var $RXvVX = parcelRequire("RXvVX");

var $6zXPf = parcelRequire("6zXPf");


var $gxP9D = parcelRequire("gxP9D");

var $3MbOI = parcelRequire("3MbOI");

var $cxQGT = parcelRequire("cxQGT");

var $9uckF = parcelRequire("9uckF");

var $2XhVc = parcelRequire("2XhVc");

var $fegFz = parcelRequire("fegFz");

var $dS8Qn = parcelRequire("dS8Qn");

var $kEUB1 = parcelRequire("kEUB1");

var $kO1ht = parcelRequire("kO1ht");

var $3nihz = parcelRequire("3nihz");

var $4BIvh = parcelRequire("4BIvh");

var $b2fGl = parcelRequire("b2fGl");

var $hQCAT = parcelRequire("hQCAT");

var $1Ha2j = parcelRequire("1Ha2j");

var $9tkvq = parcelRequire("9tkvq");
const $4be68d757c0fd608$var$SpotlightTargetDI = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $4be68d757c0fd608$var$handleMouseEnter = ()=>{
    (0, $fegFz.LazyOpenMenuItem).preload();
    (0, $2XhVc.NavigationProfileNavItemWrapperNudgeLazy).preload();
};
const $4be68d757c0fd608$var$Nav3Profile = ({ AkProfile: AkProfile = (0, $3ly0u.Profile), Avatar: Avatar = (0, $6q0fu.default), Menu: Menu = (0, $1Ha2j.Menu), Popup: Popup = (0, $5UxOh.default), SpotlightTarget: SpotlightTarget = $4be68d757c0fd608$var$SpotlightTargetDI, useCurrentUser: useCurrentUser = (0, $3MbOI.useCurrentUser), useExperienceStart: useExperienceStart = (0, $8Uqf3.useExperienceStart), useIntl: useIntl = (0, $dTocu.useIntlV2), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $4BIvh.useNavigationItemAnalytics), useTopMenus: useTopMenus = (0, $gOfBc.useTopMenus), useUserBoardId: useUserBoardId = (0, $b2fGl.useUserBoardId) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu }] = useTopMenus((0, $5RW99.MENU_ID).PROFILE);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).PROFILE
    });
    const { data: { user: user } } = useCurrentUser();
    const onStart = useExperienceStart({
        experience: (0, $kO1ht.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $kO1ht.NAVIGATION_ITEM_ID).PROFILE,
        analyticsSource: 'atlassian-navigation'
    });
    const [nudgeStep] = (0, $gxP9D.useNudgeStep)();
    const [hasNudgeActive] = (0, $gxP9D.useHasNudgeActive)();
    const [userBoardId, userBoardOwnerAccountId] = useUserBoardId(isMenuOpen);
    const testIdPrefix = (0, $RXvVX.testIdGenerate)('secondary-actions', 'profile');
    const [userTraits, { setUserTraits: setUserTraits }] = (0, $7W9z8.useUserTraits)();
    const fetchUserTraits = (0, $7W9z8.useFetchUserTraitsOld)();
    const [, { load: loadForgePersonalSettingsItem }] = (0, $dS8Qn.useForgePersonalSettingsItems)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const setUserTraitsIfNotAvailable = (0, $eJOHy.useCallback)(async ()=>{
        if (user.isAnonymous) return;
        if (!userTraits?.attributes?.length && userTraits?.attributes !== null) {
            const newTraits = await fetchUserTraits();
            // We must explicitly check for false because fetchUserTraits returns "false" when pending, and "null" when traits are empty.
            if (newTraits !== false) setUserTraits(newTraits);
        }
    }, [
        user.isAnonymous,
        userTraits?.attributes,
        fetchUserTraits,
        setUserTraits
    ]);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        onStart();
        loadForgePersonalSettingsItem({
            cloudId: cloudId,
            isAnonymous: user.isAnonymous
        });
        toggleMenu();
        triggerAnalytics();
    }, [
        onStart,
        toggleMenu,
        triggerAnalytics,
        loadForgePersonalSettingsItem,
        cloudId,
        user.isAnonymous
    ]);
    const content = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Menu, {
            userBoardId: userBoardId,
            userBoardOwnerAccountId: userBoardOwnerAccountId,
            testIdPrefix: testIdPrefix
        }), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        userBoardId,
        userBoardOwnerAccountId,
        testIdPrefix
    ]);
    const Trigger = (0, $eJOHy.useCallback)((triggerProps)=>// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": (0, $RXvVX.testIdConcat)(testIdPrefix, 'menu-trigger'),
            onMouseOver: setUserTraitsIfNotAvailable,
            onFocus: setUserTraitsIfNotAvailable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9uckF.ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: (0, $2b839a8453de5367$export$7aa8bceae32c7862) === nudgeStep && hasNudgeActive,
            Wrapper: (0, $2XhVc.NavigationProfileNavItemWrapperNudgeAsync)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AkProfile, {
            ...triggerProps,
            icon: // NOTE: This SpotlightTarget can be used throughout Jira not just within
            // the current package. They're often used for onboarding or changeboarding
            // experiences and allow an Atlaskit spotlight to be attached to page elements.
            // If you need to change this, make sure you check where the target ID is being used
            // and contact the relevant team as necessary. This Sourcegraph link should help :)
            // http://go/src/PROFILE_SPOTLIGHT_KEY
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SpotlightTarget, {
                name: (0, $kO1ht.PROFILE_SPOTLIGHT_KEY)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Avatar, {
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                src: user.avatarUrls ? user.avatarUrls['48x48'] : undefined,
                size: "small",
                borderColor: "transparent"
            })),
            isSelected: isMenuOpen,
            onClick: onClick,
            tooltip: formatMessage((0, $9tkvq.default).tooltip),
            onMouseEnter: $4be68d757c0fd608$var$handleMouseEnter,
            "aria-label": formatMessage((0, $9tkvq.default).tooltip),
            id: "atlassian-navigation.ui.profile.icon"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wfPR.EngagementSpotlight), {
            engagementId: (0, $kO1ht.PROFILE_SPOTLIGHT_KEY)
        })), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        formatMessage,
        isMenuOpen,
        onClick,
        testIdPrefix,
        user,
        nudgeStep,
        hasNudgeActive
    ]);
    if (user.isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Popup, {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: Trigger,
        label: formatMessage((0, $9tkvq.default).tooltip),
        role: "menu"
    });
};
const $4be68d757c0fd608$var$Nav4Profile = ({ AccountMenu: AccountMenu = (0, $7Horz.AccountMenuNav3), MenuNav4: MenuNav4 = (0, $hQCAT.MenuNav4), useCurrentUser: // eslint-disable-next-line react-hooks/react-compiler
useCurrentUser = (0, $3MbOI.useCurrentUser), useUserBoardId: // eslint-disable-next-line react-hooks/react-compiler
useUserBoardId = (0, $b2fGl.useUserBoardId) })=>{
    const { theme: theme, setTheme: setTheme } = (0, $cxQGT.useThemePreference)();
    const { data: { user: user } } = useCurrentUser();
    // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & User)'.
    const emailAddress = user.emailAddress || '';
    const atlassianSettingsLink = (0, $lVMSx.useAtlassianPersonalSettingsLink)(emailAddress);
    const switchAccountLink = (0, $lVMSx.useSwitchAccountLink)();
    const profileLink = (0, $lVMSx.useProfileLink)();
    // eslint-disable-next-line react-hooks/react-compiler
    const [userBoardId, userBoardOwnerAccountId] = useUserBoardId(false);
    const testIdPrefix = (0, $RXvVX.testIdGenerate)('secondary-actions', 'profile');
    if (user.isAnonymous) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AccountMenu, {
        testId: testIdPrefix,
        // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'DataBasic | (DataBasic & User)'.
        name: user.displayName,
        // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & User)'.
        picture: user.avatarUrls ? user.avatarUrls['48x48'] : undefined,
        email: emailAddress,
        viewProfileLink: profileLink,
        manageProfileLink: atlassianSettingsLink,
        switchAccountLink: switchAccountLink,
        logOutLink: "/logout",
        onThemeChange: setTheme,
        currentTheme: theme,
        extraMenuItems: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MenuNav4, {
            userBoardId: userBoardId,
            userBoardOwnerAccountId: userBoardOwnerAccountId,
            testIdPrefix: testIdPrefix
        })
    });
};
const $4be68d757c0fd608$var$Profile = (props)=>(0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4be68d757c0fd608$var$Nav4Profile, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4be68d757c0fd608$var$Nav3Profile, props);
const $4be68d757c0fd608$export$5120f2d0b8d4cab8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).PROFILE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4be68d757c0fd608$var$Profile, props));

});
parcelRegister("7W9z8", function(module, exports) {

$parcel$export(module.exports, "useFetchUserTraitsOld", () => $d003f74303bc6234$export$d5a27009aa54a078);
$parcel$export(module.exports, "useUserTraits", () => $d003f74303bc6234$export$49363c8b904e0dc7);

var $eJOHy = parcelRequire("eJOHy");

var $jGzN3 = parcelRequire("jGzN3");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $d003f74303bc6234$var$setUserTraits = (newTraits)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        setState({
            ...currentUserTraits,
            attributes: newTraits
        });
    };
const $d003f74303bc6234$var$addUserTrait = (trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        if (currentUserTraits.attributes?.some((t)=>t.name === trait.name)) return;
        setState({
            attributes: currentUserTraits.attributes?.concat(trait) ?? [
                trait
            ]
        });
    };
const $d003f74303bc6234$var$fetchUserTraits = (cloudId, accountId)=>async ({ getState: getState, setState: setState })=>{
        if (!accountId) return null;
        const state = getState();
        if (state.attributes !== null) return;
        const getUserTraits = async ()=>{
            try {
                const userTraitsData = await (0, $jGzN3.performGetRequest)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`);
                return userTraitsData?.attributes ?? [];
            } catch  {
                return null;
            }
        };
        const userTraits = await getUserTraits();
        setState({
            attributes: userTraits
        });
    };
const $d003f74303bc6234$var$actions = {
    setUserTraits: $d003f74303bc6234$var$setUserTraits,
    fetchUserTraits: $d003f74303bc6234$var$fetchUserTraits,
    addUserTrait: $d003f74303bc6234$var$addUserTrait
};
const $d003f74303bc6234$var$initialState = {
    attributes: null
};
const $d003f74303bc6234$export$d5a27009aa54a078 = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const accountId = (0, $8q7lT.useAccountId)();
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    return (0, $eJOHy.useCallback)(async ()=>{
        if (!accountId) return null;
        const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const getUserTraits = async ()=>{
            try {
                setLoading(true);
                const userTraitsData = await (0, $jGzN3.performGetRequest)(url);
                // If a user has no attributes on their account, return null so we know
                // not to keep trying to fetch data.
                return !userTraitsData?.attributes?.length ? null : userTraitsData?.attributes;
            } catch  {
                return null;
            } finally{
                setLoading(false);
            }
        };
        if (!loading) {
            const userTraits = await getUserTraits();
            return userTraits;
        }
        return false;
    }, [
        accountId,
        cloudId,
        loading
    ]);
};
const $d003f74303bc6234$export$6e688ed53ae076d5 = (0, $GtRbT.createStore)({
    initialState: $d003f74303bc6234$var$initialState,
    actions: $d003f74303bc6234$var$actions,
    name: 'UserTraits'
});
const $d003f74303bc6234$export$49363c8b904e0dc7 = (0, $iJq0l.createHook)($d003f74303bc6234$export$6e688ed53ae076d5);
const $d003f74303bc6234$export$4f249a943026a90b = (0, $iJq0l.createActionsHook)($d003f74303bc6234$export$6e688ed53ae076d5);

});

parcelRegister("lVMSx", function(module, exports) {

$parcel$export(module.exports, "useAtlassianPersonalSettingsLink", () => $77ba1c58fea86490$export$8ac70acdad00754b);
$parcel$export(module.exports, "useSwitchAccountLink", () => $77ba1c58fea86490$export$dce6af3168fb6ced);
$parcel$export(module.exports, "useProfileLink", () => $77ba1c58fea86490$export$b8f25e615dd30d7b);
$parcel$export(module.exports, "getBeforeEntity", () => $77ba1c58fea86490$export$5b8580d0254a9349);
$parcel$export(module.exports, "getBoardLink", () => $77ba1c58fea86490$export$ff5c49b7852aca68);
$parcel$export(module.exports, "getLinkFromProject", () => $77ba1c58fea86490$export$dd9458ee44edd0c6);
$parcel$export(module.exports, "getQueueLink", () => $77ba1c58fea86490$export$b44363840d1b683e);
$parcel$export(module.exports, "getIsClassicSoftwareProject", () => $77ba1c58fea86490$export$286ea82aef1c76e9);
$parcel$export(module.exports, "getUsersApps", () => $77ba1c58fea86490$export$ad0fd737fbd4a083);

var $b5RwB = parcelRequire("b5RwB");

var $9id36 = parcelRequire("9id36");

var $dOwXt = parcelRequire("dOwXt");

var $d3wpJ = parcelRequire("d3wpJ");

var $1xlYL = parcelRequire("1xlYL");

var $eWDmv = parcelRequire("eWDmv");

var $lzHTu = parcelRequire("lzHTu");

var $8LnTF = parcelRequire("8LnTF");

var $7MMy7 = parcelRequire("7MMy7");

var $jmzgU = parcelRequire("jmzgU");

var $k7VE6 = parcelRequire("k7VE6");

var $5PY5j = parcelRequire("5PY5j");

var $eULUA = parcelRequire("eULUA");

var $8q7lT = parcelRequire("8q7lT");

var $5RW99 = parcelRequire("5RW99");

var $RXvVX = parcelRequire("RXvVX");
const $77ba1c58fea86490$export$ab902790e443b0ec = ()=>`${(0, $9id36.getATLContextUrl)('id')}/login`;
const $77ba1c58fea86490$export$8ac70acdad00754b = (destinationAccountEmail)=>{
    const loginLink = $77ba1c58fea86490$export$ab902790e443b0ec();
    const destinationUrl = `${(0, $9id36.getATLContextUrl)('id')}/manage-profile/profile-and-visibility`;
    return destinationAccountEmail ? `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
        application: 'jira',
        continue: destinationUrl,
        login_hint: destinationAccountEmail,
        prompt: 'none'
    })}` : destinationUrl;
};
const $77ba1c58fea86490$export$dce6af3168fb6ced = ()=>{
    const loginLink = $77ba1c58fea86490$export$ab902790e443b0ec();
    const { href: href } = (0, $dOwXt.default)() || {};
    return `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
        application: 'jira',
        continue: href,
        prompt: 'select_account'
    })}`;
};
const $77ba1c58fea86490$export$b8f25e615dd30d7b = ()=>{
    const accountId = (0, $8q7lT.useAccountId)();
    return `/jira/people/${accountId || ''}`;
};
const $77ba1c58fea86490$export$5b8580d0254a9349 = (favoriteItems)=>favoriteItems && favoriteItems.length > 0 ? {
        id: String(favoriteItems[0].id),
        type: favoriteItems[0].type
    } : {
        id: undefined,
        type: undefined
    };
const $77ba1c58fea86490$export$ff5c49b7852aca68 = (item)=>{
    const { attributes: attributes, attributes: { parentType: parentType }, id: id } = item;
    const boardId = String(id);
    if (parentType === 'project') {
        // @ts-expect-error - TS2339 - Property 'nextgen' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectKey' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectType' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { nextgen: nextgen, projectKey: projectKey, projectType: projectType } = attributes;
        if (projectType === 'business') return {
            params: {
                projectKey: projectKey
            },
            query: {},
            route: (0, $1xlYL.jiraBusinessProjectRedirectRoute)
        };
        if (projectType === 'service_desk') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $eWDmv.jsmBoardRoute)
        };
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $jmzgU.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $k7VE6.classicSoftwareBoardRoute)
        };
    }
    if (parentType === 'user') {
        // @ts-expect-error - TS2339 - Property 'userAccountId' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { userAccountId: accountId } = attributes;
        return {
            params: {
                boardId: boardId,
                accountId: accountId
            },
            query: {},
            route: (0, $5PY5j.userBoardRoute)
        };
    }
    return {
        params: undefined,
        query: undefined,
        route: undefined
    };
};
const $77ba1c58fea86490$export$dd9458ee44edd0c6 = (item)=>{
    const { attributes: { projectType: projectType, boardId: boardId, nextgen: nextgen, projectKey: projectKey } } = item;
    if (projectType === 'business') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $1xlYL.jiraBusinessProjectRedirectRoute)
    };
    if (boardId !== undefined) {
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $jmzgU.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $k7VE6.classicSoftwareBoardRoute)
        };
    }
    if (projectType === 'service_desk') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $lzHTu.projectServiceDeskRoute)
    };
    return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $d3wpJ.browseProjectRedirectRoute)
    };
};
const $77ba1c58fea86490$export$b44363840d1b683e = (item)=>{
    const { attributes: { projectKey: projectKey, queuesCategory: queuesCategory }, id: id } = item;
    return {
        params: {
            projectKey: projectKey,
            ...queuesCategory != null && queuesCategory !== '' ? {
                practiceType: (0, $eULUA.toShortFormItsmPractice)(queuesCategory)
            } : {},
            queueId: String(id)
        },
        route: queuesCategory != null && queuesCategory !== '' ? (0, $8LnTF.customPracticeQueueRoute) : (0, $7MMy7.customQueueRoute)
    };
};
const $77ba1c58fea86490$export$286ea82aef1c76e9 = (attributes)=>attributes.parentType === 'user' || attributes.parentType === 'project' && attributes.projectType === 'software' && attributes.nextgen === 'false';
const $77ba1c58fea86490$export$ad0fd737fbd4a083 = (items)=>items.filter((item)=>item.id !== (0, $5RW99.ADDON_ID).DISCOVER);

});
parcelRegister("eULUA", function(module, exports) {

$parcel$export(module.exports, "toShortFormItsmPractice", () => $b467ca1786f529f0$export$db58a56259f511a2);

var $jlJsl = parcelRequire("jlJsl");
const $b467ca1786f529f0$var$longToShortConversionMap = {
    [(0, $jlJsl.CHANGES)]: (0, $jlJsl.SHORT_FORM_CHANGES),
    [(0, $jlJsl.INCIDENTS)]: (0, $jlJsl.SHORT_FORM_INCIDENTS),
    [(0, $jlJsl.PROBLEMS)]: (0, $jlJsl.SHORT_FORM_PROBLEMS),
    [(0, $jlJsl.SERVICE_REQUEST)]: (0, $jlJsl.SHORT_FORM_SERVICE_REQUEST),
    [(0, $jlJsl.POST_INCIDENT_REVIEWS)]: (0, $jlJsl.SHORT_FORM_POST_INCIDENT_REVIEWS),
    [(0, $jlJsl.DEVELOPER_ESCALATION)]: (0, $jlJsl.SHORT_FORM_DEVELOPER_ESCALATION)
};
function $b467ca1786f529f0$var$isLongForm(workCategoryKey) {
    return !!workCategoryKey && workCategoryKey in $b467ca1786f529f0$var$longToShortConversionMap;
}
const $b467ca1786f529f0$export$db58a56259f511a2 = (workCategoryKey)=>{
    if ($b467ca1786f529f0$var$isLongForm(workCategoryKey)) return $b467ca1786f529f0$var$longToShortConversionMap[workCategoryKey];
    return null;
};

});


parcelRegister("9uckF", function(module, exports) {

$parcel$export(module.exports, "ConditionalNudgeWrapper", () => $8fba9741fd796652$export$56d544c4f479b7fb);

var $eJOHy = parcelRequire("eJOHy");
const $8fba9741fd796652$export$56d544c4f479b7fb = ({ children: children, Wrapper: Wrapper, conditionsToApplyWrapper: conditionsToApplyWrapper, ...restProps })=>{
    if (conditionsToApplyWrapper && !false && children !== null && children !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, restProps, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};

});

parcelRegister("2XhVc", function(module, exports) {

$parcel$export(module.exports, "NavigationProfileNavItemWrapperNudgeLazy", () => $d9deb472c5fd4c00$export$3651b15d92c1c280);
$parcel$export(module.exports, "NavigationProfileNavItemWrapperNudgeAsync", () => $d9deb472c5fd4c00$export$deb2cae843941204);

var $eJOHy = parcelRequire("eJOHy");


var $kMreM = parcelRequire("kMreM");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

const $d9deb472c5fd4c00$export$3651b15d92c1c280 = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("iKK6Q")).then((exportedModule)=>exportedModule.NavigationProfileNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-profile/index.tsx"
});
const $d9deb472c5fd4c00$export$deb2cae843941204 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kMreM.OnboardingNudgeErrorBoundary), {
        id: "asyncProfileNudge",
        fallback: children,
        attributes: {
            NAVIGATION_APPS_PROFILE_ITEM_NUDGE_ID: $2b839a8453de5367$export$7aa8bceae32c7862
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "navigation-profile-nav-item-wrapper-nudge-lazy",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d9deb472c5fd4c00$export$3651b15d92c1c280, {
        nudgeId: (0, $2b839a8453de5367$export$7aa8bceae32c7862)
    }, children)));
$d9deb472c5fd4c00$export$deb2cae843941204.displayName = 'NavigationProfileNavItemWrapperNudgeAsync';

});
parcelRegister("iKK6Q", function(module, exports) {

let $da704a37c078c712$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $da704a37c078c712$var$load("7YW2q").then(()=>parcelRequire('9wucx'));

});


parcelRegister("fegFz", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklist", () => $547e7c79cce2b88f$export$aea93106aaeec3fc);
$parcel$export(module.exports, "JswOnboardingButton", () => $547e7c79cce2b88f$export$c0cbc1198da400db);
$parcel$export(module.exports, "LazyOpenMenuItem", () => $547e7c79cce2b88f$export$e6a8d3e2a6acc946);
$parcel$export(module.exports, "OpenMenuItem", () => $547e7c79cce2b88f$export$67c4b22563f33286);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $1KdDN = parcelRequire("1KdDN");

var $dslup = parcelRequire("dslup");

var $8TWuG = parcelRequire("8TWuG");

var $eYe3w = parcelRequire("eYe3w");

var $i5x17 = parcelRequire("i5x17");

var $16sa1 = parcelRequire("16sa1");

var $gzcjr = parcelRequire("gzcjr");

var $iqzS0 = parcelRequire("iqzS0");

var $7jTnu = parcelRequire("7jTnu");

var $2JwiI = parcelRequire("2JwiI");
const $547e7c79cce2b88f$var$FallbackChecklist = ()=>{
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $8TWuG.qsChecklistAutoLoadTime).start();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
};
const $547e7c79cce2b88f$export$aea93106aaeec3fc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "quickstart"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "asyncChecklistComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $eYe3w.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderUFOMigration), {
        name: "software-onboarding-checklist-new",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($547e7c79cce2b88f$var$FallbackChecklist, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqzS0.JswOnboardingChecklistNext), null))));
const $547e7c79cce2b88f$var$FallbackButton = ()=>{
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $8TWuG.qsButtonAutoLoadTime).start();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
};
const $547e7c79cce2b88f$export$c0cbc1198da400db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "asyncChecklistButtonComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $eYe3w.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderUFOMigration), {
        name: "software-onboarding-checklist-button-new",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($547e7c79cce2b88f$var$FallbackButton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i5x17.QuickstartPillVisibilityContainer), {
        scope: "ListPageQuickstartPill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2JwiI.JswOnboardingButtonNext), null))));

const $547e7c79cce2b88f$export$e6a8d3e2a6acc946 = (0, $gzcjr.lazy)(()=>(parcelRequire("4SBee")).then(({ OpenMenuItem: OpenMenuItem })=>{
        if (!(0, $7jTnu.fg)('jira-onboarding-disable-bm3-ufo-instrument')) (0, $8TWuG.openMenuItemLoadTime).mark((0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_END);
        return OpenMenuItem;
    }), {
    moduleId: "./src/packages/software/onboarding-quickstart/src/ui/open-menu-item/index.tsx"
});
const $547e7c79cce2b88f$var$SubmitOpenMenuItemLoadStart = ()=>{
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!(0, $7jTnu.fg)('jira-onboarding-disable-bm3-ufo-instrument')) {
            (0, $8TWuG.openMenuItemLoadTime).start();
            (0, $8TWuG.openMenuItemLoadTime).mark((0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_START);
        }
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
};
const $547e7c79cce2b88f$export$67c4b22563f33286 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "asyncOpenMenuItemComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $eYe3w.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderUFOMigration), {
        name: "software-onboarding-checklist-open-menu-item",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($547e7c79cce2b88f$var$SubmitOpenMenuItemLoadStart, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($547e7c79cce2b88f$export$e6a8d3e2a6acc946, props)));

});
parcelRegister("8TWuG", function(module, exports) {

$parcel$export(module.exports, "isMetricRunning", () => $5a1cd387bc2f0023$export$5c2d3e87043198cf);
$parcel$export(module.exports, "openMenuItemLoadTime", () => $5a1cd387bc2f0023$export$9aef270bc11ae96b);
$parcel$export(module.exports, "qsButtonAutoLoadTime", () => $5a1cd387bc2f0023$export$844f48c93ed69757);
$parcel$export(module.exports, "qsChecklistAutoLoadTime", () => $5a1cd387bc2f0023$export$c501d2dfab0e9e45);
$parcel$export(module.exports, "qsChecklistMinimiseInteraction", () => $5a1cd387bc2f0023$export$ac78fba7425e64da);
$parcel$export(module.exports, "qsChecklistDismissInteraction", () => $5a1cd387bc2f0023$export$494d4094aaa2bc4d);
$parcel$export(module.exports, "qsButtonOpenInteraction", () => $5a1cd387bc2f0023$export$da7d38041ee220c8);
$parcel$export(module.exports, "qsButtonDismissInteraction", () => $5a1cd387bc2f0023$export$ce2841e9d619cdfd);
// @ts-expect-error - TS2305 - Module '"@atlassian/browser-metrics"' has no exported member 'BaseMetric'.

var $4WXKS = parcelRequire("4WXKS");

var $dslup = parcelRequire("dslup");
const $5a1cd387bc2f0023$export$5c2d3e87043198cf = (metric)=>metric?.state === 'started';
const $5a1cd387bc2f0023$export$9aef270bc11ae96b = (0, $4WXKS.metrics).custom({
    key: `${(0, $dslup.PERFORMANCE_METRIC_PREFIX)}.open.menu-item.load`,
    timings: [
        {
            key: (0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $5a1cd387bc2f0023$export$844f48c93ed69757 = (0, $4WXKS.metrics).custom({
    key: `${(0, $dslup.PERFORMANCE_METRIC_PREFIX)}.button.load`,
    timings: [
        {
            key: (0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $5a1cd387bc2f0023$export$c501d2dfab0e9e45 = (0, $4WXKS.metrics).custom({
    key: `${(0, $dslup.PERFORMANCE_METRIC_PREFIX)}.checklist.load`,
    timings: [
        {
            key: (0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $5a1cd387bc2f0023$export$ac78fba7425e64da = (0, $4WXKS.metrics).interaction({
    key: `${(0, $dslup.PERFORMANCE_METRIC_PREFIX)}.checklist.minimize`
});
const $5a1cd387bc2f0023$export$494d4094aaa2bc4d = (0, $4WXKS.metrics).interaction({
    key: `${(0, $dslup.PERFORMANCE_METRIC_PREFIX)}.checklist.dismiss`
});
const $5a1cd387bc2f0023$export$da7d38041ee220c8 = (0, $4WXKS.metrics).interaction({
    key: `${(0, $dslup.PERFORMANCE_METRIC_PREFIX)}.button.open`
});
const $5a1cd387bc2f0023$export$ce2841e9d619cdfd = (0, $4WXKS.metrics).interaction({
    key: `${(0, $dslup.PERFORMANCE_METRIC_PREFIX)}.button.dismiss`
});

});

parcelRegister("i5x17", function(module, exports) {

$parcel$export(module.exports, "QuickstartPillVisibilityContainer", () => $755a5efa3d0f2fe2$export$1a5202e8ea7b76ab);
$parcel$export(module.exports, "useQuickstartPillVisibilityStore", () => $755a5efa3d0f2fe2$export$70dc54081d2075ff);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $755a5efa3d0f2fe2$var$actions = {
    toggleShowQuickstart: ({ showQuickstartPill: showQuickstartPill })=>({ setState: setState })=>{
            setState({
                showQuickstartPill: showQuickstartPill
            });
        }
};
const $755a5efa3d0f2fe2$var$initialState = {
    showQuickstartPill: null
};
const $755a5efa3d0f2fe2$var$Store = (0, $GtRbT.createStore)({
    initialState: $755a5efa3d0f2fe2$var$initialState,
    actions: $755a5efa3d0f2fe2$var$actions,
    name: 'JiraQuickstartPillVisibility'
});
const $755a5efa3d0f2fe2$export$1a5202e8ea7b76ab = (0, $6E16M.createContainer)($755a5efa3d0f2fe2$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                ...$755a5efa3d0f2fe2$var$initialState
            });
        }
});
const $755a5efa3d0f2fe2$export$70dc54081d2075ff = (0, $iJq0l.createHook)($755a5efa3d0f2fe2$var$Store);

});

parcelRegister("iqzS0", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklistNext", () => $dac1900256d0d277$export$bbc4e97e9a15a84b);

var $eJOHy = parcelRequire("eJOHy");

var $f1Zdy = parcelRequire("f1Zdy");

var $h1VbR = parcelRequire("h1VbR");

var $ch9En = parcelRequire("ch9En");

var $1KdDN = parcelRequire("1KdDN");

var $dfP3D = parcelRequire("dfP3D");

var $eYe3w = parcelRequire("eYe3w");

var $9ycBx = parcelRequire("9ycBx");

var $gxP9D = parcelRequire("gxP9D");

var $dELL6 = parcelRequire("dELL6");

var $7jTnu = parcelRequire("7jTnu");

var $dslup = parcelRequire("dslup");

var $8TWuG = parcelRequire("8TWuG");

var $e34lC = parcelRequire("e34lC");
const $dac1900256d0d277$export$bbc4e97e9a15a84b = ()=>{
    const [quickstartStatus] = (0, $gxP9D.useQuickstartUiStatus)();
    const { openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const currentRightSidebarState = (0, $dfP3D.useActiveRightSidebarState)();
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const isRightSidePanelMinimised = currentRightSidebarState?.isMinimised ?? false;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>()=>{
            closeRightSidebar((0, $dslup.PANEL_ID));
            (0, $dELL6.fireAnalyticsOnCloseRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                trigger: 'JswOnboardingChecklistNext'
            });
        }, // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $7jTnu.fg)('jira-onboarding-disable-bm3-ufo-instrument') && (quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED || quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED) && (0, $8TWuG.isMetricRunning)((0, $8TWuG.qsChecklistAutoLoadTime))) // QS Checklist loading cancelled for page load action
        (0, $8TWuG.qsChecklistAutoLoadTime).cancel();
        if (!(0, $7jTnu.fg)('jira-onboarding-disable-bm3-ufo-instrument') && quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED && (0, $8TWuG.isMetricRunning)((0, $8TWuG.qsChecklistDismissInteraction))) // User interaction completed for QS Checklist dismiss action
        (0, $8TWuG.qsChecklistDismissInteraction).stop();
        if (quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED && currentRightSidebarPanelId === (0, $dslup.PANEL_ID)) {
            closeRightSidebar((0, $dslup.PANEL_ID));
            (0, $dELL6.fireAnalyticsOnCloseRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                trigger: 'JswOnboardingChecklistNext'
            });
            return;
        }
        if (quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN && currentRightSidebarPanelId !== (0, $dslup.PANEL_ID)) {
            openRightSidebar((0, $dslup.PANEL_ID), (0, $dslup.PANEL_WIDTH));
            (0, $dELL6.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                openRightSidebarAsMinimised: false,
                openRightSidebarToTop: false,
                trigger: 'JswOnboardingChecklistNext'
            });
        }
    }, [
        currentRightSidebarPanelId,
        openRightSidebar,
        closeRightSidebar,
        quickstartStatus,
        createAnalyticsEvent,
        isRightSidePanelMinimised
    ]);
    if (quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1VbR.default), {
        name: "quickstart-fetching-data"
    });
    if (quickstartStatus !== (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "internalChecklistComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $eYe3w.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderUFOMigration), {
        name: "software-onboarding-checklist-next",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e34lC.AsyncJswOnboardingChecklistInternal), null)));
};

});
parcelRegister("e34lC", function(module, exports) {

$parcel$export(module.exports, "AsyncJswOnboardingChecklistInternal", () => $60838450286e3537$export$9f3262905af42485);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $7jTnu = parcelRequire("7jTnu");

var $dslup = parcelRequire("dslup");

var $8TWuG = parcelRequire("8TWuG");

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
const $60838450286e3537$var$Checklist = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("dmGKx")).then(({ JswOnboardingChecklistFinal: JswOnboardingChecklistFinal })=>{
        if (!(0, $7jTnu.fg)('jira-onboarding-disable-bm3-ufo-instrument')) (0, $8TWuG.qsChecklistAutoLoadTime).mark((0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_END);
        return JswOnboardingChecklistFinal;
    }), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/onboarding/onboarding-checklist-next/src/ui/onboarding-checklist/checklist/index.tsx"
});
const $60838450286e3537$var$ChecklistInternalLoadStart = ()=>{
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!(0, $7jTnu.fg)('jira-onboarding-disable-bm3-ufo-instrument')) (0, $8TWuG.qsChecklistAutoLoadTime).mark((0, $dslup.PERFORMANCE_MARK).BUNDLE_LOAD_START);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
};
const $60838450286e3537$export$9f3262905af42485 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "software-onboarding-checklist-view-internal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($60838450286e3537$var$ChecklistInternalLoadStart, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($60838450286e3537$var$Checklist, null));

});
parcelRegister("dmGKx", function(module, exports) {

let $9bae7d9be5c52f7a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $9bae7d9be5c52f7a$var$load("hwlgY"),
    $9bae7d9be5c52f7a$var$load("7vqGd"),
    $9bae7d9be5c52f7a$var$load("1Y4bq"),
    $9bae7d9be5c52f7a$var$load("1VRB2"),
    $9bae7d9be5c52f7a$var$load("bABhq"),
    $9bae7d9be5c52f7a$var$load("kw8Fe")
]).then(()=>parcelRequire('aUkI4'));

});



parcelRegister("2JwiI", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingButtonNext", () => $8b90c3e5f52c63c4$export$bc3535037a418fa9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $f1Zdy = parcelRequire("f1Zdy");

var $1KdDN = parcelRequire("1KdDN");

var $dfP3D = parcelRequire("dfP3D");

var $elL9D = parcelRequire("elL9D");

var $dslup = parcelRequire("dslup");

var $8TWuG = parcelRequire("8TWuG");

var $eYe3w = parcelRequire("eYe3w");

var $9ycBx = parcelRequire("9ycBx");

var $dt54n = parcelRequire("dt54n");

var $gxP9D = parcelRequire("gxP9D");

var $dELL6 = parcelRequire("dELL6");

var $hih5V = parcelRequire("hih5V");

var $i5x17 = parcelRequire("i5x17");

var $95O7y = parcelRequire("95O7y");

var $7jTnu = parcelRequire("7jTnu");

var $byils = parcelRequire("byils");
const $8b90c3e5f52c63c4$export$7127386abbb0f79c = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const [selectedIssueValue] = (0, $95O7y.useQueryParam)('selectedIssue');
    const [viewValue] = (0, $95O7y.useQueryParam)('view');
    const isInRoadMapRoute = (0, $dt54n.isRoadmapRoute)(route?.name);
    const isInBacklogRoute = route?.name === 'software-backlog';
    const isInBoardRoute = route?.name === 'software-boards';
    const isInRapidBoardBacklogRoute = route?.name === 'rapidboard-backlog';
    const isInRapidBoardBoardRoute = route?.name === 'rapidboard-board';
    // CMP & TMP Roadmap, and TMP backlog & board use selectedIssue query param
    if ((isInRoadMapRoute || isInBacklogRoute || isInBoardRoute) && Boolean(selectedIssueValue)) return true;
    // CMP backlog use view="detail" query param
    // (detail view can be triggered from the meatball menu on the issue modal)
    if (isInRapidBoardBacklogRoute) return viewValue === 'detail';
    // CMP Active Sprints and Kanban board uses view=detail query param
    // (detail view can be triggered from the meatball menu on the issue modal)
    if (isInRapidBoardBoardRoute && viewValue === 'detail') return true;
    return false;
};
const $8b90c3e5f52c63c4$export$bc3535037a418fa9 = ()=>{
    const [quickstartStatus] = (0, $gxP9D.useQuickstartUiStatus)();
    const isIssueViewOpened = $8b90c3e5f52c63c4$export$7127386abbb0f79c();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const currentRightSidebarState = (0, $dfP3D.useActiveRightSidebarState)();
    const isRightSidePanelMinimised = currentRightSidebarState?.isMinimised ?? false;
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const [{ showQuickstartPill: showQuickstartPill }] = (0, $i5x17.useQuickstartPillVisibilityStore)();
    (0, $eJOHy.useEffect)(()=>{
        if ((quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED || quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN) && (0, $8TWuG.isMetricRunning)((0, $8TWuG.qsButtonAutoLoadTime))) // QS Button loading cancelled for page load action
        (0, $8TWuG.qsButtonAutoLoadTime).cancel();
        if (!(0, $7jTnu.fg)('jira-onboarding-disable-bm3-ufo-instrument') && quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED && (0, $8TWuG.isMetricRunning)((0, $8TWuG.qsButtonDismissInteraction))) // User interaction completed for QS Button dismiss action
        (0, $8TWuG.qsButtonDismissInteraction).stop();
        if (quickstartStatus !== (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED) return;
        // check if quickstart panel is already shown in minimised state in right-hand sidebar
        if (currentRightSidebarPanelId === (0, $dslup.PANEL_ID) && isRightSidePanelMinimised === true) return;
        openRightSidebar((0, $dslup.PANEL_ID), (0, $dslup.PANEL_WIDTH), true);
        (0, $dELL6.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
            quickstartStatus: quickstartStatus,
            isRightSidePanelCollapsed: isRightSidePanelMinimised,
            isRightSidePanelMinimised: isRightSidePanelMinimised,
            currentRightSidebarPanelId: currentRightSidebarPanelId || '',
            openRightSidebarAsMinimised: true,
            openRightSidebarToTop: false,
            trigger: 'JswOnboardingButtonNext'
        });
    }, [
        isRightSidePanelMinimised,
        openRightSidebar,
        currentRightSidebarPanelId,
        quickstartStatus,
        createAnalyticsEvent
    ]);
    if (quickstartStatus !== (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED || showQuickstartPill !== null && !showQuickstartPill && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.pathname.endsWith('/list')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "internalChecklistButtonComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $eYe3w.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $elL9D.JiraBottomRightCornerOutlet), {
        orderFromRight: 1,
        id: "software-onboarding-quickstart-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b90c3e5f52c63c4$var$QuickstartButtonContainer, {
        isIssueViewOpened: isIssueViewOpened,
        "data-testid": "software-onboarding-quickstart.ui.onboarding-button.onboarding-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $byils.JswOnboardingChecklistButton), null))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8b90c3e5f52c63c4$var$QuickstartButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIssueViewOpened: isIssueViewOpened, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isIssueViewOpened ? "_1e0cglyw" : "_1e0c1kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("elL9D", function(module, exports) {

$parcel$export(module.exports, "JiraBottomRightCornerOutlet", () => $ef1c857e9098bbfe$export$ee54e6ed235df65e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aQK2r = parcelRequire("aQK2r");

var $gFqQp = parcelRequire("gFqQp");

var $h47gY = parcelRequire("h47gY");

var $7jTnu = parcelRequire("7jTnu");

var $fqYrC = parcelRequire("fqYrC");
const $ef1c857e9098bbfe$var$OutletWithPortalBroken = ({ orderFromRight: orderFromRight, children: children, id: id, testId: testId })=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const portalWrapper = (0, $eJOHy.useRef)(document.createElement('div'));
    if (testId) portalWrapper.current.setAttribute('data-testid', testId);
    const container = (0, $fqYrC.useBottomRightCornerContainer)();
    if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
    const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, $fqYrC.useBottomRightCornerActions)();
    (0, $eJOHy.useEffect)(()=>{
        if (container) {
            const indexToRender = insertBottomRightCornerPortal({
                orderFromRight: orderFromRight,
                id: id
            });
            container.insertBefore(portalWrapper.current, container.children[indexToRender]);
        }
        // required as eslint complains about the ref in cleanup function
        const portalCurrent = portalWrapper.current;
        return ()=>{
            container?.removeChild(portalCurrent);
            removeBottomRightCornerPortal(id);
        };
    }, [
        container,
        id,
        orderFromRight,
        insertBottomRightCornerPortal,
        removeBottomRightCornerPortal
    ]);
    return /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef1c857e9098bbfe$var$StyledOutlet, null, children), portalWrapper.current);
};
const $ef1c857e9098bbfe$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id, testId: testId })=>{
    const [portalWrapper, setPortalWrapper] = (0, $eJOHy.useState)(null);
    const container = (0, $fqYrC.useBottomRightCornerContainer)();
    const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, $fqYrC.useBottomRightCornerActions)();
    (0, $eJOHy.useEffect)(()=>{
        // Portal wrapper creation deferred to after hydration is completed
        const document1 = (0, $gFqQp.getDocument)();
        if (document1 != null) {
            const portalEl = document1.createElement('div');
            if (testId) portalEl.setAttribute('data-testid', testId);
            setPortalWrapper(portalEl);
        }
    }, [
        testId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!portalWrapper) return;
        if (container) {
            const indexToRender = insertBottomRightCornerPortal({
                orderFromRight: orderFromRight,
                id: id
            });
            container.insertBefore(portalWrapper, container.children[indexToRender]);
        }
        return ()=>{
            container?.removeChild(portalWrapper);
            removeBottomRightCornerPortal(id);
        };
    }, [
        container,
        id,
        orderFromRight,
        insertBottomRightCornerPortal,
        removeBottomRightCornerPortal,
        portalWrapper
    ]);
    if (portalWrapper != null) return /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef1c857e9098bbfe$var$StyledOutlet, null, children), portalWrapper);
    return null;
};
const $ef1c857e9098bbfe$export$ee54e6ed235df65e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "bottom-right-corner-outlet",
        packageName: "jira-bottom-right-corner-controller",
        extraEventData: {
            portalId: props.id
        }
    }, (0, $7jTnu.fg)('jfp_magma_fix_jirabottomrightcorneroutlet_ssr') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef1c857e9098bbfe$var$OutletWithPortal, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef1c857e9098bbfe$var$OutletWithPortalBroken, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef1c857e9098bbfe$var$StyledOutlet = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1vgl1wug _1ko9pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("byils", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklistButton", () => $f385b19bae52ef7a$export$235000cc42ca709a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fanr2 = parcelRequire("fanr2");

var $f1Zdy = parcelRequire("f1Zdy");

var $dfP3D = parcelRequire("dfP3D");

var $dslup = parcelRequire("dslup");

var $8TWuG = parcelRequire("8TWuG");


var $9ycBx = parcelRequire("9ycBx");

var $46NrI = parcelRequire("46NrI");

var $gxP9D = parcelRequire("gxP9D");

var $7jTnu = parcelRequire("7jTnu");

var $dELL6 = parcelRequire("dELL6");

var $hjf2q = parcelRequire("hjf2q");
var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");


var $157bu = parcelRequire("157bu");
const $f385b19bae52ef7a$var$ChecklistButtonAnaylticsWrapper = (0, $hjf2q.AnalyticsEventToProps)('button', {
    onClick: 'clicked'
})((0, $fanr2.default));
const $f385b19bae52ef7a$export$235000cc42ca709a = ()=>{
    const currentRightSidebarState = (0, $dfP3D.useActiveRightSidebarState)();
    const [, { nextSetChecklistIsDismissed: nextSetChecklistIsDismissed, setNudgeStep: setNudgeStep, setHasNudgeActive: setHasNudgeActive }] = (0, $gxP9D.useQuickstartActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const openChecklist = (0, $157bu.useOpenChecklist)();
    const [quickstartStatus] = (0, $gxP9D.useQuickstartUiStatus)();
    const [remoteStateFromHook] = (0, $gxP9D.useJswOnboarding)();
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const onDismiss = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        if (!(0, $7jTnu.fg)('jira-onboarding-disable-bm3-ufo-instrument')) (0, $8TWuG.qsButtonDismissInteraction).start();
        nextSetChecklistIsDismissed(true);
        setNudgeStep((0, $2b839a8453de5367$export$7aa8bceae32c7862));
        setHasNudgeActive(true);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $dELL6.fireAnalyticsOnQuickstartDismiss)(analyticsEvent, {
            projectId: remoteStateFromHook.projectState?.projectId,
            productType: (0, $46NrI.getProductType)(remoteStateFromHook.projectState?.projectType)
        }, 'button');
    }, [
        createAnalyticsEvent,
        nextSetChecklistIsDismissed,
        setNudgeStep,
        setHasNudgeActive,
        remoteStateFromHook
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if ((0, $8TWuG.isMetricRunning)((0, $8TWuG.qsButtonAutoLoadTime))) // QS Button loading completed on page load action
        (0, $8TWuG.qsButtonAutoLoadTime).stop();
        if (!(0, $7jTnu.fg)('jira-onboarding-disable-bm3-ufo-instrument') && (0, $8TWuG.isMetricRunning)((0, $8TWuG.qsChecklistMinimiseInteraction))) // User interaction completed for QS Checklist minimise action
        (0, $8TWuG.qsChecklistMinimiseInteraction).stop();
    }, []);
    const projectKey = remoteStateFromHook.projectState?.projectKey;
    if (projectKey && (0, $9ycBx.SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON).includes(projectKey) && (0, $7jTnu.fg)('jfind-mature-example-project-gate')) return;
    if (currentRightSidebarPanelId !== (0, $dslup.PANEL_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f385b19bae52ef7a$var$TriggerWrapper, {
        reposition: quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$9d2de6eebf7462b5),
        sourceName: (0, $6a5cf820a64a0990$export$75cc63c8ac8ae533)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
        attributes: {
            projectId: remoteStateFromHook.projectState?.projectId,
            productType: (0, $46NrI.getProductType)(remoteStateFromHook.projectState?.projectType)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f385b19bae52ef7a$var$ChecklistButtonAnaylticsWrapper, {
        isOpen: quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED,
        title: "Quickstart",
        onClick: (event, analyticsEvent)=>{
            if (!(0, $7jTnu.fg)('jira-onboarding-disable-bm3-ufo-instrument')) (0, $8TWuG.qsButtonOpenInteraction).start();
            openChecklist({
                trigger: 'JswOnboardingChecklistButton'
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, (0, $6a5cf820a64a0990$export$75cc63c8ac8ae533), {
                projectId: remoteStateFromHook.projectState?.projectId,
                productType: (0, $46NrI.getProductType)(remoteStateFromHook.projectState?.projectType)
            });
        },
        onDismiss: onDismiss
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f385b19bae52ef7a$var$TriggerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { reposition: reposition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564vccv _syaz1gjq _80omtlke",
            __cmplp.reposition ? "_otyr8vuz" : "_otyridpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hjf2q", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $1d3706030416e425$export$3e9ef96ba97ea9dc);

var $aN4Pk = parcelRequire("aN4Pk");
const $1d3706030416e425$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $1d3706030416e425$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $aN4Pk.default)($1d3706030416e425$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

// Used for analytics event context for secondary (floating button) view
const $6a5cf820a64a0990$export$75cc63c8ac8ae533 = 'nuxOnboardingQuickstartButton';



parcelRegister("4SBee", function(module, exports) {

let $38d91563a2618539$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $38d91563a2618539$var$load("3iYzK").then(()=>parcelRequire('9Yoaw'));

});


parcelRegister("b2fGl", function(module, exports) {

$parcel$export(module.exports, "useUserBoardId", () => $3c72783d3dc78d70$export$e6e895063f36c814);

var $eJOHy = parcelRequire("eJOHy");

var $jGzN3 = parcelRequire("jGzN3");

var $9XYcy = parcelRequire("9XYcy");
const $3c72783d3dc78d70$export$e6e895063f36c814 = (shouldRun)=>{
    const [{ isReady: isReady }] = (0, $9XYcy.useSpaStatePageReady)();
    const [userBoard, setUserBoard] = (0, $eJOHy.useState)(null);
    const shouldFetch = shouldRun || isReady;
    (0, $eJOHy.useEffect)(()=>{
        if (!shouldFetch || userBoard) return;
        setUserBoard(null);
        const requestUrl = '/rest/greenhopper/1.0/rapidviews/recent?maxResults=1&userBoard=true';
        (0, $jGzN3.performGetRequest)(requestUrl).then((result)=>{
            const [board] = result.views;
            if (board) setUserBoard(board);
        }).catch(()=>{
        // user board fetch failed, ignore
        });
    }, [
        shouldFetch,
        userBoard,
        setUserBoard
    ]);
    return userBoard && userBoard.location ? [
        userBoard.id,
        userBoard.location.accountId
    ] : [
        null,
        null
    ];
};

});

parcelRegister("hQCAT", function(module, exports) {

$parcel$export(module.exports, "MenuNav4", () => $5fe9c7bb35cc433b$export$60113ca6a29c7a92);
/* main-nav4.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $eRYig = parcelRequire("eRYig");
var $7R1al = parcelRequire("7R1al");

var $ln6Iy = parcelRequire("ln6Iy");

var $4ctwv = parcelRequire("4ctwv");

var $lRq8t = parcelRequire("lRq8t");

var $RXvVX = parcelRequire("RXvVX");

var $2aY2d = parcelRequire("2aY2d");

var $5PY5j = parcelRequire("5PY5j");


var $gA6Um = parcelRequire("gA6Um");

var $fegFz = parcelRequire("fegFz");

var $kO1ht = parcelRequire("kO1ht");

var $1hBLh = parcelRequire("1hBLh");

var $b5gS8 = parcelRequire("b5gS8");

var $i32yb = parcelRequire("i32yb");

var $hRfDr = parcelRequire("hRfDr");


const $5fe9c7bb35cc433b$var$StandardToPremiumPubTouchpoint = (parcelRequire("3EEM2")).default;
const $5fe9c7bb35cc433b$export$60113ca6a29c7a92 = ({ testIdPrefix: testIdPrefix, userBoardId: userBoardId, userBoardOwnerAccountId: userBoardOwnerAccountId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $kO1ht.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $eJOHy.useEffect)(()=>{
        onSuccess();
    }, [
        onSuccess
    ]);
    const testId = (0, $RXvVX.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdContent = (0, $RXvVX.testIdConcat)(testId, 'content');
    const { data: projectContextData } = (0, $2aY2d.useProjectContext)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $gA6Um.useJsmOnboardingType)();
    (0, $eJOHy.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    const showInJwmProjects = projectContextData?.projectType === (0, $ln6Iy.CORE_PROJECT);
    const showInSoftwareProjects = projectContextData?.projectType === (0, $ln6Iy.SOFTWARE_PROJECT);
    const showInJsmProjects = projectContextData?.projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e6294c08fdc1cc17$export$6f454e69bce3a691);
    let yourBoardsRoute;
    let yourBoardsParams;
    let yourBoardsQuery;
    if (userBoardId != null) {
        yourBoardsRoute = (0, $5PY5j.userBoardRoute);
        yourBoardsParams = {
            accountId: userBoardOwnerAccountId,
            boardId: String(userBoardId)
        };
    }
    const boardOffset = userBoardId == null ? -1 : 0;
    const showQuickstartOpenMenuItem = showInJwmProjects || showInSoftwareProjects || showInJsmProjects;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuList), null, showQuickstartOpenMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fegFz.OpenMenuItem), {
        MenuItem: (0, $1hBLh.MenuItem)
    }), userBoardId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
        hasSeparator: true,
        testId: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $RXvVX.testIdConcat)(testIdContent, 'jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eRYig.default), {
        testId: (0, $RXvVX.testIdConcat)(testIdContent, 'jira', 'heading')
    }, formatMessage((0, $hRfDr.default).jira)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuListItem), {
        ariaLabel: formatMessage((0, $hRfDr.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1hBLh.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'your-boards',
            menuItemType: 'jira',
            position: 1
        },
        href: `/jira/people/${String(userBoardOwnerAccountId)}/boards/${userBoardId}`,
        params: yourBoardsParams,
        query: yourBoardsQuery,
        testId: (0, $RXvVX.testIdConcat)(testIdContent, 'jira', 'item-your-boards'),
        to: yourBoardsRoute
    }, formatMessage((0, $hRfDr.default).yourBoards))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5fe9c7bb35cc433b$var$StandardToPremiumPubTouchpoint, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i32yb.ExtraItemsNav4), {
        startPosition: 5 + boardOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $hRfDr.default).jira)
    }));
};

});
const $e6294c08fdc1cc17$export$6f454e69bce3a691 = 'business';
const $e6294c08fdc1cc17$export$e6952b12ade67489 = 'default';

parcelRegister("gA6Um", function(module, exports) {

$parcel$export(module.exports, "useJsmOnboardingType", () => $9b7107bc0a7cf7b4$export$5daaa68c3a578af9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $gjl0t = parcelRequire("gjl0t");
const $9b7107bc0a7cf7b4$export$d4c72bab9d6cc13a = {
    projectId: undefined,
    data: undefined,
    error: undefined,
    isLoading: false
};
const $9b7107bc0a7cf7b4$var$Store = (0, $GtRbT.createStore)({
    initialState: $9b7107bc0a7cf7b4$export$d4c72bab9d6cc13a,
    actions: $gjl0t.actions,
    name: 'JSMOnboardingType'
});
const $9b7107bc0a7cf7b4$export$5daaa68c3a578af9 = (0, $iJq0l.createHook)($9b7107bc0a7cf7b4$var$Store);

});
parcelRegister("gjl0t", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d999595a94332453$export$e324594224ef24da);

var $6wO5O = parcelRequire("6wO5O");
const $d999595a94332453$export$e324594224ef24da = {
    fetchOnboardingType: $6wO5O.fetchOnboardingType
};

});
parcelRegister("6wO5O", function(module, exports) {

$parcel$export(module.exports, "fetchOnboardingType", () => $76364540b36f58b7$export$ea62467635172b55);

var $ln6Iy = parcelRequire("ln6Iy");

var $1Ozm9 = parcelRequire("1Ozm9");
const $76364540b36f58b7$var$getOnboardingTypeUrl = (projectId)=>`/rest/servicedesk/onboarding/1/onboarding-type/project/${projectId}`;
const $76364540b36f58b7$export$ea62467635172b55 = (projectId, projectType)=>async ({ getState: getState, setState: setState })=>{
        if (!projectId || projectType !== (0, $ln6Iy.SERVICE_DESK_PROJECT)) return;
        const { data: data, isLoading: isLoading, projectId: oldProjectId } = getState();
        if (projectId !== oldProjectId) setState({
            data: undefined,
            projectId: undefined
        });
        if (data || isLoading) return;
        setState({
            projectId: projectId,
            isLoading: true,
            error: undefined
        });
        try {
            const onboardingTypeResponse = await (0, $1Ozm9.default)($76364540b36f58b7$var$getOnboardingTypeUrl(String(projectId)));
            setState({
                isLoading: false,
                data: onboardingTypeResponse
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isLoading: false,
                error: error
            });
        }
    };

});



parcelRegister("1hBLh", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $b8cb90b7a2b1b478$export$2ce376c2cc3355c8);

var $eJOHy = parcelRequire("eJOHy");

var $1AUsu = parcelRequire("1AUsu");

var $6uJ4f = parcelRequire("6uJ4f");

var $9ZZNx = parcelRequire("9ZZNx");

var $2MUA0 = parcelRequire("2MUA0");
const $b8cb90b7a2b1b478$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, params: params, query: query, replace: replace, target: target, to: to, type: type, ...rest }, ref)=>{
    const onClickHandler = (0, $2MUA0.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    if (to != null && __SPA__) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ZZNx.RouteLinkItem), {
        ref: ref,
        onClick: onClickHandler,
        params: params,
        query: query,
        replace: replace,
        target: target,
        to: to,
        type: type,
        ...rest
    });
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6uJ4f.LinkItem), {
        ref: ref,
        href: href,
        target: target,
        onClick: onClickHandler,
        ...rest
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
        ref: ref,
        onClick: onClickHandler,
        ...rest
    });
});

});
parcelRegister("6uJ4f", function(module, exports) {

$parcel$export(module.exports, "LinkItem", () => $5e13ec63c364dbe8$export$532cb6865ebe8946);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8DtAB = parcelRequire("8DtAB");
var $apGPk = parcelRequire("apGPk");

var $7jTnu = parcelRequire("7jTnu");

var $g0rPQ = parcelRequire("g0rPQ");

var $5zy3q = parcelRequire("5zy3q");
const $5e13ec63c364dbe8$var$AkLinkWithUnwrappedInteractiveChildren = (0, $g0rPQ.WithUnwrappedInteractiveChildren)((0, $apGPk.default));
const $5e13ec63c364dbe8$export$532cb6865ebe8946 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ href: href, target: target, onClick: onClick, ...rest }, ref)=>{
    const Item = (0, $7jTnu.fg)('jfp-a11y-team_interactive-elements-nesting') ? (0, $8DtAB.default) : $5e13ec63c364dbe8$export$8c0773eab230d49e;
    const navigate = (0, $5zy3q.useNavigate)({
        href: href,
        onClick: onClick,
        target: target
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Item, {
        ...(0, $7jTnu.fg)('jfp-a11y-team_interactive-elements-nesting') && {
            component: $5e13ec63c364dbe8$var$AkLinkWithUnwrappedInteractiveChildren
        },
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : '',
        onClick: navigate,
        ref: ref,
        ...rest
    });
});
const $5e13ec63c364dbe8$export$8c0773eab230d49e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $apGPk.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1nrm18uv _1a3b18uv _9oik18uv _c2wa1kw7 _4fpr1kw7 _1bnx1kw7 _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g0rPQ", function(module, exports) {

$parcel$export(module.exports, "WithUnwrappedInteractiveChildren", () => $8e3cb6783ee29076$export$aecb71b5768388c7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $8e3cb6783ee29076$var$MenuItemCss = null;
const $8e3cb6783ee29076$var$StretchedBlanketCss = null;
// This blank space is needed to enforce React Router to render the empty anchor tag
const $8e3cb6783ee29076$var$BLANKET_CONTENT = ' ';
const $8e3cb6783ee29076$export$aecb71b5768388c7 = (InteractiveBlanket)=>/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
            className: (0, $hcewu.default)([
                "_kqswh2mm",
                className
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(InteractiveBlanket, {
            ref: ref,
            ...props,
            className: (0, $hcewu.default)([
                "_kqswstnw _1bsb1osq _4t3i1osq _154ize3t _1ltvze3t _1cwg1i6y _13ro1i6y _1bg41i6y _1ah31i6y"
            ])
        }, $8e3cb6783ee29076$var$BLANKET_CONTENT), children));

});

parcelRegister("5zy3q", function(module, exports) {

$parcel$export(module.exports, "useNavigate", () => $31d694917f726592$export$9770f232ac06a008);

var $eJOHy = parcelRequire("eJOHy");

var $83DiZ = parcelRequire("83DiZ");
const $31d694917f726592$export$9770f232ac06a008 = ({ href: href, target: target, onClick: onClick, useRouterActions: // eslint-disable-next-line react-hooks/react-compiler
useRouterActions = (0, $83DiZ.useRouterActions), useCallback: // eslint-disable-next-line react-hooks/react-compiler
useCallback = (0, $eJOHy.useCallback) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const { push: push } = useRouterActions();
    // eslint-disable-next-line react-hooks/react-compiler
    return useCallback((event)=>{
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey || event.defaultPrevented || target === '_blank') return;
        event.preventDefault();
        push(href);
    }, [
        push,
        href,
        target,
        onClick
    ]);
};

});


parcelRegister("9ZZNx", function(module, exports) {

$parcel$export(module.exports, "RouteLinkItem", () => $904f689b4d0846c3$export$5885e1e37551a766);

var $eJOHy = parcelRequire("eJOHy");

var $8DtAB = parcelRequire("8DtAB");

var $7jTnu = parcelRequire("7jTnu");

var $c9uTK = parcelRequire("c9uTK");

var $g0rPQ = parcelRequire("g0rPQ");
const $904f689b4d0846c3$var$LinkWithUnwrappedInteractiveChildren = (0, $g0rPQ.WithUnwrappedInteractiveChildren)((0, $c9uTK.Link));
const $904f689b4d0846c3$export$5885e1e37551a766 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ rel: rel, target: target, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8DtAB.default), {
        component: (0, $7jTnu.fg)('jfp-a11y-team_interactive-elements-nesting') ? $904f689b4d0846c3$var$LinkWithUnwrappedInteractiveChildren : (0, $c9uTK.Link),
        rel: rel ?? (target === '_blank' ? 'noopener noreferrer' : ''),
        target: target,
        prefetch: "hover",
        ref: ref,
        ...props
    }));

});

parcelRegister("2MUA0", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $01ccf45946b66b19$export$a81c45382e7253ac);

var $eY50e = parcelRequire("eY50e");

var $gOfBc = parcelRequire("gOfBc");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");
const $01ccf45946b66b19$export$a81c45382e7253ac = ({ analytics: analytics, fireUIAnalytics: fireUIAnalytics = (0, $gCeeo.fireUIAnalytics), onClick: onClick, useAnalyticsEvents: // eslint-disable-next-line react-hooks/react-compiler
useAnalyticsEvents = (0, $f1Zdy.useAnalyticsEvents), useOverflowStatus: // eslint-disable-next-line react-hooks/react-compiler
useOverflowStatus = (0, $eY50e.useOverflowStatus), useTopMenus: // eslint-disable-next-line react-hooks/react-compiler
useTopMenus = (0, $gOfBc.useTopMenus) } = {})=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [, { off: closeMenu }] = useTopMenus();
    // eslint-disable-next-line react-hooks/react-compiler
    const { isVisible: isVisible, closeOverflowMenu: closeOverflowMenu } = useOverflowStatus();
    // eslint-disable-next-line react-hooks/react-compiler
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const { actionSubjectId: actionSubjectId, ...analyticsRest } = analytics;
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationMenuItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fireUIAnalytics(analyticsEvent, actionSubjectId, {
            ...analyticsRest,
            isInMore: !isVisible
        });
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey) return;
        closeMenu();
        closeOverflowMenu();
    };
};

});


parcelRegister("b5gS8", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $6c2299870bb261e7$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "MenuListItem", () => $6c2299870bb261e7$export$6c2f3257abc4825b);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $7jTnu = parcelRequire("7jTnu");
const $6c2299870bb261e7$export$d4c4e98c5044dc8 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        as: "ul",
        xcss: $6c2299870bb261e7$var$removeDefaultListStyles
    }, children);
const $6c2299870bb261e7$export$6c2f3257abc4825b = ({ children: children, ariaLabel: ariaLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        as: "li",
        xcss: (0, $7jTnu.fg)('blu-7838_fix_bullet_styling_in_top_nav_menu') ? [
            $6c2299870bb261e7$var$removeDefaultListStyles,
            $6c2299870bb261e7$var$removeListStyle
        ] : $6c2299870bb261e7$var$removeDefaultListStyles,
        "aria-label": ariaLabel
    }, children);
const $6c2299870bb261e7$var$removeDefaultListStyles = (0, $5Wv5g.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $6c2299870bb261e7$var$removeListStyle = (0, $5Wv5g.xcss)({
    listStyleType: 'none'
});

});

parcelRegister("i32yb", function(module, exports) {

$parcel$export(module.exports, "ExtraItems", () => $31c3553643237a3a$export$56021421a935c353);
$parcel$export(module.exports, "ExtraItemsNav4", () => $31c3553643237a3a$export$ee2972db91c46b97);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $7R1al = parcelRequire("7R1al");

var $cGvTS = parcelRequire("cGvTS");

var $RXvVX = parcelRequire("RXvVX");

var $enHI7 = parcelRequire("enHI7");

var $eJrcF = parcelRequire("eJrcF");

var $1hBLh = parcelRequire("1hBLh");

var $b5gS8 = parcelRequire("b5gS8");
const $31c3553643237a3a$var$useConnectItems = ()=>{
    const { data: resourceData, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)((0, $enHI7.navigationSidebarGlobalResource));
    const data = resourceData?.response;
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        error,
        loading,
        refresh
    ]);
    return data ? (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(data, 'global.profile.items', []).filter((item)=>![
            'view_profile',
            'log_out'
        ].includes(item.id)) : [];
};
const $31c3553643237a3a$var$Item = ({ url: url, name: name, id: id, styleClass: styleClass, itemAriaLabel: itemAriaLabel, position: position, testId: testId })=>{
    const webItemRef = (0, $eJOHy.useRef)(null);
    const isDialog = styleClass && (0, $cGvTS.isConnectDialogWebItem)(styleClass);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (isDialog) (0, $cGvTS.withConnectHost)((connectHost)=>{
            if (styleClass && webItemRef.current) connectHost.triggerWebItem(webItemRef.current, styleClass, url);
        });
    }, [
        isDialog,
        styleClass,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuListItem), {
        key: url,
        ariaLabel: itemAriaLabel || ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1hBLh.MenuItem), {
        ref: webItemRef,
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: id,
            menuItemType: 'jira',
            position: position
        },
        href: isDialog ? undefined : url,
        onClick: isDialog ? onClick : undefined,
        testId: testId
    }, name));
};
const $31c3553643237a3a$export$56021421a935c353 = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const connectItems = $31c3553643237a3a$var$useConnectItems();
    if (!connectItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, connectItems.map(({ id: id, name: name, url: url, styleClass: styleClass }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31c3553643237a3a$var$Item, {
            key: url,
            url: url,
            name: name,
            id: id,
            styleClass: styleClass,
            itemAriaLabel: itemAriaLabel,
            position: startPosition + idx,
            testId: (0, $RXvVX.testIdConcat)(testIdPrefix, `item-addon-${idx}`)
        });
    }));
};
const $31c3553643237a3a$export$ee2972db91c46b97 = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const connectItems = $31c3553643237a3a$var$useConnectItems();
    if (!connectItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
        hasSeparator: true
    }, connectItems.map(({ id: id, name: name, url: url, styleClass: styleClass }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31c3553643237a3a$var$Item, {
            key: url,
            url: url,
            name: name,
            id: id,
            styleClass: styleClass,
            itemAriaLabel: itemAriaLabel,
            position: startPosition + idx,
            testId: (0, $RXvVX.testIdConcat)(testIdPrefix, `item-addon-${idx}`)
        });
    }));
};

});

parcelRegister("hRfDr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ef73779f73e7b8a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4ef73779f73e7b8a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    giveFeedback: {
        "id": "atlassian-navigation.profile.menu.give-feedback",
        "defaultMessage": "Give us feedback"
    },
    yourBoards: {
        "id": "atlassian-navigation.profile.menu.your-boards",
        "defaultMessage": "Your boards"
    },
    new: {
        "id": "atlassian-navigation.profile.menu.new",
        "defaultMessage": "new"
    },
    personalSettings: {
        "id": "atlassian-navigation.profile.menu.personal-settings",
        "defaultMessage": "Personal settings"
    },
    logout: {
        "id": "atlassian-navigation.profile.menu.logout",
        "defaultMessage": "Log out"
    },
    jira: {
        "id": "atlassian-navigation.profile.menu.jira",
        "defaultMessage": "Jira"
    },
    account: {
        "id": "atlassian-navigation.profile.menu.account",
        "defaultMessage": "Account"
    },
    profile: {
        "id": "atlassian-navigation.profile.menu.profile",
        "defaultMessage": "Profile"
    },
    notifications: {
        "id": "atlassian-navigation.profile.menu.notifications",
        "defaultMessage": "Notifications"
    }
});

});

parcelRegister("3EEM2", function(module, exports) {

module.exports = (parcelRequire("g81qY"))('edition_awareness_upsell_jira_ab_fg', function() {
    return parcelRequire('hDqVc');
}, function() {
    return parcelRequire('29Vb5');
});

});


parcelRegister("1Ha2j", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $661950c9d75b1d9d$export$d9b273488cd8ce6f);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8wfPR = parcelRequire("8wfPR");

var $6alcT = parcelRequire("6alcT");

var $eRYig = parcelRequire("eRYig");
var $7R1al = parcelRequire("7R1al");

var $gbiVe = parcelRequire("gbiVe");

var $7W9z8 = parcelRequire("7W9z8");

var $ln6Iy = parcelRequire("ln6Iy");

var $4ctwv = parcelRequire("4ctwv");

var $lRq8t = parcelRequire("lRq8t");

var $lVMSx = parcelRequire("lVMSx");

var $RXvVX = parcelRequire("RXvVX");

var $bxWdr = parcelRequire("bxWdr");

var $3MbOI = parcelRequire("3MbOI");

var $2aY2d = parcelRequire("2aY2d");

var $eR19P = parcelRequire("eR19P");

var $4wyu4 = parcelRequire("4wyu4");

var $53QWl = parcelRequire("53QWl");

var $5PY5j = parcelRequire("5PY5j");


var $gA6Um = parcelRequire("gA6Um");

var $fegFz = parcelRequire("fegFz");

var $8q7lT = parcelRequire("8q7lT");

var $kO1ht = parcelRequire("kO1ht");

var $1hBLh = parcelRequire("1hBLh");

var $4BXz7 = parcelRequire("4BXz7");

var $b5gS8 = parcelRequire("b5gS8");

var $59s9h = parcelRequire("59s9h");

var $i32yb = parcelRequire("i32yb");

var $cf9wr = parcelRequire("cf9wr");

var $hRfDr = parcelRequire("hRfDr");

var $56EPd = parcelRequire("56EPd");


const $661950c9d75b1d9d$var$UpgradeEditionMenuItem = (parcelRequire("fVSRD")).default;


const $661950c9d75b1d9d$var$StandardToPremiumPubTouchpoint = (parcelRequire("3EEM2")).default;
const $661950c9d75b1d9d$export$d9b273488cd8ce6f = ({ testIdPrefix: testIdPrefix, userBoardId: userBoardId, userBoardOwnerAccountId: userBoardOwnerAccountId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { data: { user: user } } = (0, $3MbOI.useCurrentUser)();
    const accountId = (0, $8q7lT.useAccountId)();
    const profileLink = (0, $lVMSx.useProfileLink)();
    const onSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $kO1ht.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $eJOHy.useEffect)(()=>{
        onSuccess();
    }, [
        onSuccess
    ]);
    const profileParams = {
        subPath: accountId
    };
    const testId = (0, $RXvVX.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdContent = (0, $RXvVX.testIdConcat)(testId, 'content');
    const testIdFooter = (0, $RXvVX.testIdConcat)(testId, 'footer');
    const [upgradeEditionMenuShown, setUpgradeEditionMenuShown] = (0, $eJOHy.useState)(false);
    const { data: projectContextData } = (0, $2aY2d.useProjectContext)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $gA6Um.useJsmOnboardingType)();
    (0, $eJOHy.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    const showInJwmProjects = projectContextData?.projectType === (0, $ln6Iy.CORE_PROJECT);
    const showInSoftwareProjects = projectContextData?.projectType === (0, $ln6Iy.SOFTWARE_PROJECT);
    const showInJsmProjects = projectContextData?.projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e6294c08fdc1cc17$export$6f454e69bce3a691);
    let yourBoardsRoute;
    let yourBoardsParams;
    let yourBoardsQuery;
    if (userBoardId != null) {
        yourBoardsRoute = (0, $5PY5j.userBoardRoute);
        yourBoardsParams = {
            accountId: userBoardOwnerAccountId,
            boardId: String(userBoardId)
        };
    }
    const boardOffset = userBoardId == null ? -1 : 0;
    const [userTraits] = (0, $7W9z8.useUserTraits)();
    const showNotificationsNewLozenge = (0, $eJOHy.useMemo)(()=>{
        const accountCreationDate = userTraits?.attributes?.find((trait)=>trait?.name === 'jira_first_active')?.value;
        const aWeekAgo = new Date(Date.now() - 604800000);
        let isNewUser = false;
        if (accountCreationDate && typeof accountCreationDate === 'string') isNewUser = new Date(accountCreationDate) > aWeekAgo;
        return !isNewUser;
    }, [
        userTraits
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // The Spotlight components listen to the resize event to
        // update their positioning. This will fix Spotlights pulse overlap
        // that are shown on Menu items. Without this the pulse are located
        /// at incorrect position.
        setTimeout(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.dispatchEvent(new Event('resize'));
        }, 0);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": testId,
        role: "dialog",
        "aria-labelledby": "atlassian-navigation-account-dialog-heading",
        className: (0, $hcewu.default)([
            "_syaz1fxt"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BXz7.MenuLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
        "data-testid": (0, $RXvVX.testIdConcat)(testIdContent, 'account')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eRYig.default), {
        id: "atlassian-navigation-account-dialog-heading",
        testId: (0, $RXvVX.testIdConcat)(testIdContent, 'account', 'heading')
    }, formatMessage((0, $hRfDr.default).account)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59s9h.AccountDetails // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    ), {
        email: user.emailAddress || '',
        userFullname: user.userFullname,
        avatarSrc: user.avatarUrls ? user.avatarUrls['32x32'] : undefined,
        testId: (0, $RXvVX.testIdConcat)(testIdContent, 'account')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($661950c9d75b1d9d$var$StandardToPremiumPubTouchpoint, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
        hasSeparator: upgradeEditionMenuShown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($661950c9d75b1d9d$var$UpgradeEditionMenuItem, {
        setUpgradeEditionMenuShown: setUpgradeEditionMenuShown
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
        hasSeparator: upgradeEditionMenuShown || !upgradeEditionMenuShown,
        testId: testIdContent
    }, (showInJwmProjects || showInSoftwareProjects || showInJsmProjects) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fegFz.OpenMenuItem), {
        MenuItem: (0, $1hBLh.MenuItem)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $RXvVX.testIdConcat)(testIdContent, 'jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eRYig.default), {
        testId: (0, $RXvVX.testIdConcat)(testIdContent, 'jira', 'heading')
    }, formatMessage((0, $hRfDr.default).jira)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuListItem), {
        ariaLabel: formatMessage((0, $hRfDr.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1hBLh.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'profile',
            menuItemType: 'jira',
            position: 0
        },
        href: profileLink,
        params: profileParams,
        testId: (0, $RXvVX.testIdConcat)(testIdContent, 'jira', 'item-profile'),
        to: (0, $eR19P.peopleProfilesRoute)
    }, formatMessage((0, $hRfDr.default).profile))), userBoardId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuListItem), {
        ariaLabel: formatMessage((0, $hRfDr.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1hBLh.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'your-boards',
            menuItemType: 'jira',
            position: 1
        },
        href: `/jira/people/${String(userBoardOwnerAccountId)}/boards/${userBoardId}`,
        params: yourBoardsParams,
        query: yourBoardsQuery,
        testId: (0, $RXvVX.testIdConcat)(testIdContent, 'jira', 'item-your-boards'),
        to: yourBoardsRoute
    }, formatMessage((0, $hRfDr.default).yourBoards))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuListItem), {
        ariaLabel: formatMessage((0, $hRfDr.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1hBLh.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'personal-settings',
            menuItemType: 'jira',
            position: 2 + boardOffset
        },
        href: (0, $bxWdr.getGeneralPersonalSettingsPath)(),
        testId: (0, $RXvVX.testIdConcat)(testIdContent, 'jira', 'item-personal-settings'),
        to: (0, $4wyu4.generalPersonalSettingsRoute)
    }, formatMessage((0, $hRfDr.default).personalSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuListItem), {
        ariaLabel: formatMessage((0, $hRfDr.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), {
        name: "notifications-menu-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1hBLh.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'notifications',
            menuItemType: 'jira',
            position: 3 + boardOffset
        },
        href: (0, $bxWdr.getNotificationsPersonalSettingsPath)(),
        testId: (0, $RXvVX.testIdConcat)(testIdContent, 'jira', 'item-notifications'),
        to: (0, $53QWl.notificationsPersonalSettingsRoute),
        iconAfter: showNotificationsNewLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
            appearance: "new"
        }, formatMessage((0, $hRfDr.default).new)) : null
    }, formatMessage((0, $hRfDr.default).notifications)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wfPR.EngagementSpotlight), {
        engagementId: "notifications-menu-spotlight"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuListItem), {
        ariaLabel: formatMessage((0, $hRfDr.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $56EPd.default), {
        testId: (0, $RXvVX.testIdConcat)(testIdContent, 'jira', 'item-theme'),
        itemPosition: 4 + boardOffset
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i32yb.ExtraItems), {
        startPosition: 5 + boardOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $hRfDr.default).jira)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cf9wr.ForgeItems), {
        startPosition: 6 + boardOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $hRfDr.default).jira)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
        hasSeparator: true,
        testId: testIdFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $RXvVX.testIdConcat)(testIdFooter, 'items')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1hBLh.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'logout',
            menuItemType: 'action',
            position: 0
        },
        href: "/logout",
        testId: (0, $RXvVX.testIdConcat)(testIdFooter, 'items', 'item-log-out')
    }, formatMessage((0, $hRfDr.default).logout))))));
};
const $661950c9d75b1d9d$var$styles = null;

});
parcelRegister("4BXz7", function(module, exports) {

$parcel$export(module.exports, "MenuLayout", () => $6a05bda3114a4f20$export$dc2a07138b27c65b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $MlWTN = parcelRequire("MlWTN");

var $dPMMf = parcelRequire("dPMMf");
const $6a05bda3114a4f20$export$dc2a07138b27c65b = ({ children: children, isWide: isWide = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6a05bda3114a4f20$var$Wrapper, {
        isWide: isWide
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MlWTN.default), {
        maxHeight: $6a05bda3114a4f20$var$maxHeight
    }, children));
const $6a05bda3114a4f20$var$starStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a05bda3114a4f20$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isWide: isWide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1d8u6ab": (0, $awdRS.default)(__cmplp.isWide ? `${(0, $dPMMf.gridSize) * 40}px` : `${(0, $dPMMf.gridSize) * 29.25}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ul911kg _p12f1c3h _107nidpf _js70kb7n _nqzgkb7n _ziy7kb7n",
            __cmplp.className
        ])
    });
});
const $6a05bda3114a4f20$var$maxHeight = `calc(100vh - ${(0, $dPMMf.gridSize) * 25}px)`;

});

parcelRegister("59s9h", function(module, exports) {

$parcel$export(module.exports, "AccountDetails", () => $2563c49a38d88273$export$66e04d0aacdb3b2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6q0fu = parcelRequire("6q0fu");

var $eIhG2 = parcelRequire("eIhG2");

var $apGPk = parcelRequire("apGPk");

var $lRq8t = parcelRequire("lRq8t");

var $lVMSx = parcelRequire("lVMSx");

var $RXvVX = parcelRequire("RXvVX");

var $1hBLh = parcelRequire("1hBLh");

var $b5gS8 = parcelRequire("b5gS8");

var $fYvol = parcelRequire("fYvol");
const $2563c49a38d88273$export$66e04d0aacdb3b2 = ({ email: email, userFullname: userFullname, avatarSrc: avatarSrc, testId: testId })=>{
    const atlassianSettingsLink = (0, $lVMSx.useAtlassianPersonalSettingsLink)(email);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2563c49a38d88273$export$8f1912fff52a55aa, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2563c49a38d88273$export$33e9904f45a9e453, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2563c49a38d88273$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6q0fu.default), {
        appearance: "circle",
        size: "medium",
        src: avatarSrc
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2563c49a38d88273$export$e0d971bef63c8b8f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2563c49a38d88273$export$101fbca3a406e1fd, null, userFullname), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("small", null, email)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1hBLh.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'manage-account',
            menuItemType: 'account',
            position: 1
        },
        href: atlassianSettingsLink,
        testId: (0, $RXvVX.testIdConcat)(testId, 'manage-account'),
        target: "_blank",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eIhG2))), {
            LEGACY_size: "small",
            color: "var(--ds-icon-subtle, #626F86)",
            label: ""
        })
    }, formatMessage((0, $fYvol.default).manageAccount)))));
};
const $2563c49a38d88273$export$8f1912fff52a55aa = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $apGPk.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_lcxvglyw",
            __cmplp.className
        ])
    });
});
const $2563c49a38d88273$export$33e9904f45a9e453 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $2563c49a38d88273$export$f7513421c53ce141 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $2563c49a38d88273$export$101fbca3a406e1fd = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_vwz4gktf",
            __cmplp.className
        ])
    });
});
const $2563c49a38d88273$export$e0d971bef63c8b8f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2lx29ee3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fYvol", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a755fa9e66f225d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3a755fa9e66f225d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    manageAccount: {
        "id": "atlassian-navigation.profile.menu.account-details.manage-account",
        "defaultMessage": "Manage account"
    }
});

});


parcelRegister("cf9wr", function(module, exports) {

$parcel$export(module.exports, "ForgeItems", () => $69eed3987a8f2786$export$ee772b0fa73d37fd);

var $eJOHy = parcelRequire("eJOHy");

var $dS8Qn = parcelRequire("dS8Qn");

var $aeOhE = parcelRequire("aeOhE");

var $8PvQT = parcelRequire("8PvQT");

var $fohjD = parcelRequire("fohjD");

var $kXs0B = parcelRequire("kXs0B");

var $74bkD = parcelRequire("74bkD");

var $ePLco = parcelRequire("ePLco");

var $RXvVX = parcelRequire("RXvVX");

var $bxWdr = parcelRequire("bxWdr");

var $1hBLh = parcelRequire("1hBLh");

var $b5gS8 = parcelRequire("b5gS8");
const $69eed3987a8f2786$var$BaseForgeItems = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const [{ items: forgeStoreItems }] = (0, $dS8Qn.useForgePersonalSettingsItems)();
    const shouldTriggerForgeScreenEvent = forgeStoreItems && forgeStoreItems.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (forgeStoreItems || []).map((item, idx)=>{
        const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(item.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuListItem), {
            key: item.id,
            ariaLabel: itemAriaLabel || ''
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1hBLh.MenuItem), {
            analytics: {
                actionSubjectId: 'profileNavigationMenuItem',
                menuItemId: item.id,
                menuItemType: 'jira',
                position: startPosition + idx
            },
            href: `${(0, $bxWdr.getAppsPersonalSettingsPath)()}/${appId}/${envId}`,
            testId: (0, $RXvVX.testIdConcat)(testIdPrefix, `item-addon-${idx}`),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kXs0B.ForgeIcon), {
                url: item.avatarUrl
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $74bkD.ExtensionTitle), {
            extensionEnvType: item.environmentType,
            extensionEnvKey: item.environmentKey,
            extensionName: item.title,
            autoTruncate: true
        })));
    }), shouldTriggerForgeScreenEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE)
        }
    }));
};
const $69eed3987a8f2786$export$ee772b0fa73d37fd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8PvQT.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69eed3987a8f2786$var$BaseForgeItems, props));

});
parcelRegister("8PvQT", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $d37d14948a8f563c$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $d37d14948a8f563c$export$e1a79e3d472c925a);

var $eJOHy = parcelRequire("eJOHy");

var $fohjD = parcelRequire("fohjD");

var $aeOhE = parcelRequire("aeOhE");

var $9gq2c = parcelRequire("9gq2c");
const $d37d14948a8f563c$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $d37d14948a8f563c$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE),
        ...props,
        moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER)
    });

});

parcelRegister("kXs0B", function(module, exports) {

$parcel$export(module.exports, "ForgeIcon", () => $4d2cd94a5a5977aa$export$fe0464db4dc93ab4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $jSYec = parcelRequire("jSYec");

var $aNxjx = parcelRequire("aNxjx");
const $4d2cd94a5a5977aa$export$fe0464db4dc93ab4 = ({ url: url })=>{
    return url && String(url).trim().length > 0 ? /*#__PURE__*/ $eJOHy.createElement((0, $aNxjx.IconCustom), {
        shouldChangeFillColor: false,
        url: url
    }) : /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jSYec))), {
        color: "var(--ds-icon, #44546F)",
        spacing: "spacious",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    });
};

});

parcelRegister("74bkD", function(module, exports) {

$parcel$export(module.exports, "ExtensionTitle", () => $2c6827ff4fa2d881$export$3aa4a75e461c581c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $fohjD = parcelRequire("fohjD");

var $iMZxW = parcelRequire("iMZxW");
const $2c6827ff4fa2d881$var$shouldShowEnv = (extensionEnvType)=>[
        (0, $fohjD.STAGING_ENVIRONMENT),
        (0, $fohjD.DEVELOPMENT_ENVIRONMENT)
    ].includes(extensionEnvType);
const $2c6827ff4fa2d881$var$ExtensionTitleText = /*#__PURE__*/ (0, $eJOHy.memo)(({ text: text, autoTruncate: autoTruncate })=>{
    if (!autoTruncate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, text, " ");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $2c6827ff4fa2d881$var$extensionTitleTextWrapperStyles
    }, text);
});
const $2c6827ff4fa2d881$export$3aa4a75e461c581c = ({ extensionEnvType: extensionEnvType, extensionEnvKey: extensionEnvKey, extensionName: extensionName, autoTruncate: autoTruncate })=>{
    if (!$2c6827ff4fa2d881$var$shouldShowEnv(extensionEnvType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, extensionName);
    const Wrapper = autoTruncate ? $2c6827ff4fa2d881$var$TruncatableExtensionTitleWrapper : $2c6827ff4fa2d881$var$ExtensionTitleWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2c6827ff4fa2d881$var$ExtensionTitleText, {
        text: (0, $iMZxW.nameWithCustomEnvironment)(extensionName, extensionEnvType, extensionEnvKey),
        autoTruncate: !!autoTruncate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMZxW.EnvironmentLozenge), {
        environmentType: extensionEnvType
    }));
};
const $2c6827ff4fa2d881$var$extensionTitleTextWrapperStyles = (0, $5Wv5g.xcss)({
    paddingRight: 'space.050',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexGrow: 1
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2c6827ff4fa2d881$var$ExtensionTitleWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1q9y _13aiidpf",
            __cmplp.className
        ])
    });
});
const $2c6827ff4fa2d881$var$TruncatableExtensionTitleWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1q9y _13aiidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iMZxW", function(module, exports) {

$parcel$export(module.exports, "EnvironmentLozenge", () => $7f2b53f517ab6796$export$278f8e01799d0418);
$parcel$export(module.exports, "nameWithCustomEnvironment", () => $7f2b53f517ab6796$export$f9338c21ba7c7334);

var $eJOHy = parcelRequire("eJOHy");

var $6alcT = parcelRequire("6alcT");

var $fohjD = parcelRequire("fohjD");

var $kDaaB = parcelRequire("kDaaB");

var $bh015 = parcelRequire("bh015");
const $7f2b53f517ab6796$export$50589a87e4fb3dae = (environmentType)=>{
    switch(environmentType){
        case 0, $fohjD.DEVELOPMENT_ENVIRONMENT:
            return (0, $bh015.messages).developmentEnvironmentLozenge;
        case 0, $fohjD.STAGING_ENVIRONMENT:
            return (0, $bh015.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $7f2b53f517ab6796$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $7f2b53f517ab6796$export$50589a87e4fb3dae(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
        appearance: environmentType === (0, $fohjD.DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), labelKey)) : null;
};
const $7f2b53f517ab6796$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
    if (environmentType === (0, $fohjD.DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, $fohjD.DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
    return name;
};

});
parcelRegister("bh015", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e5510659054de5bf$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e5510659054de5bf$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    developmentEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
        "defaultMessage": "DEV"
    },
    stagingEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
        "defaultMessage": "STG"
    }
});

});




parcelRegister("56EPd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d3a3fbddee09083$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $ik2fc = parcelRequire("ik2fc");

const $7d3a3fbddee09083$export$31f1740ae531af94 = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("61R3D")), {
    moduleId: "./src/packages/navigation-apps/theme-switcher-menu/src/index.tsx"
});
const $7d3a3fbddee09083$var$AsyncThemeSwitcherItem = ({ testId: testId, itemPosition: itemPosition })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav-theme-options-list-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik2fc.default), {
            testId: testId,
            itemPosition: itemPosition,
            isDisabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7d3a3fbddee09083$export$31f1740ae531af94, {
        renderTriggerButton: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik2fc.default), {
                testId: testId,
                itemPosition: itemPosition,
                ...props
            })
    }));
var $7d3a3fbddee09083$export$2e2bcd8739ae039 = $7d3a3fbddee09083$var$AsyncThemeSwitcherItem;

});
parcelRegister("ik2fc", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbc7f0ee8830b3aa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $fUE0d = parcelRequire("fUE0d");

var $1AUsu = parcelRequire("1AUsu");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $fwTBw = parcelRequire("fwTBw");
const $dbc7f0ee8830b3aa$var$TriggerButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ testId: testId, itemPosition: itemPosition, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AUsu.default), {
        ...rest,
        ref: ref,
        onClick: (e)=>{
            e.stopPropagation();
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'navigationMenuItem'
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'profileNavigationMenuItem', {
                menuItemId: 'theme',
                menuItemType: 'jira',
                position: itemPosition
            });
        },
        testId: testId,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fUE0d))), {
            spacing: "spacious",
            color: "var(--ds-icon-subtle, #626F86)",
            label: "",
            size: "small"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dbc7f0ee8830b3aa$var$Text, null, formatMessage((0, $fwTBw.default).text)));
});
var $dbc7f0ee8830b3aa$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $dbc7f0ee8830b3aa$var$TriggerButton;
const $dbc7f0ee8830b3aa$var$Text = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fwTBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $77128dcc467f6674$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $77128dcc467f6674$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    text: {
        "id": "atlassian-navigation.profile.menu.theme-switcher-item.trigger-button.text",
        "defaultMessage": "Theme"
    }
});

});


parcelRegister("61R3D", function(module, exports) {

let $463bfe31b9642204$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $463bfe31b9642204$var$load("jo9ew").then(()=>parcelRequire('41Sye'));

});


parcelRegister("fVSRD", function(module, exports) {

module.exports = (parcelRequire("g81qY"))('jira-concurrent-update-while-rendering', function() {
    return parcelRequire('alNK3');
}, function() {
    return parcelRequire('aGKZb');
});

});


parcelRegister("9tkvq", function(module, exports) {

$parcel$export(module.exports, "default", () => $02442c43a01744dc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $02442c43a01744dc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.profile.tooltip",
        "defaultMessage": "Your profile and settings"
    }
});

});


parcelRegister("6wuXc", function(module, exports) {

$parcel$export(module.exports, "NavigationRouterListener", () => $964f4c5b44d5b7e0$export$85575e1c48f0a517);

var $eJOHy = parcelRequire("eJOHy");

var $gCY1z = parcelRequire("gCY1z");

var $75n38 = parcelRequire("75n38");
const $964f4c5b44d5b7e0$export$85575e1c48f0a517 = ()=>{
    const [{ route: route, location: location, match: match }] = (0, $gCY1z.useRouter)();
    const onEnd = (0, $75n38.useAtlassianNavigationEnd)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        onEnd();
    }, [
        route,
        match,
        location,
        onEnd
    ]);
    return null;
};

});
parcelRegister("75n38", function(module, exports) {

$parcel$export(module.exports, "useAtlassianNavigationEnd", () => $f1fedb5d802fcf31$export$4b9602c0fdb8b1bb);

var $eJOHy = parcelRequire("eJOHy");


var $il8Fk = parcelRequire("il8Fk");
const $f1fedb5d802fcf31$export$4b9602c0fdb8b1bb = ()=>{
    const { setAppReadyWithAppId: setAppReadyWithAppId } = (0, $il8Fk.useSpaStateActions)();
    return (0, $eJOHy.useCallback)(()=>{
        setAppReadyWithAppId((0, $ceaa13d70a0542eb$export$3a54edb6ba4daa82));
    }, [
        setAppReadyWithAppId
    ]);
};

});


parcelRegister("kv0Iu", function(module, exports) {

$parcel$export(module.exports, "Search", () => $73babe0a2f637785$export$4b85d3515bd863a5);

var $eJOHy = parcelRequire("eJOHy");

var $cPbpX = parcelRequire("cPbpX");
var $5Wv5g = parcelRequire("5Wv5g");

var $1KdDN = parcelRequire("1KdDN");

var $lRq8t = parcelRequire("lRq8t");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $dzruH = parcelRequire("dzruH");

var $gOfBc = parcelRequire("gOfBc");

var $5RW99 = parcelRequire("5RW99");

var $6zXPf = parcelRequire("6zXPf");

var $f2JN3 = parcelRequire("f2JN3");

var $epTsa = parcelRequire("epTsa");

var $16sa1 = parcelRequire("16sa1");

var $95O7y = parcelRequire("95O7y");
var $83DiZ = parcelRequire("83DiZ");

var $kO1ht = parcelRequire("kO1ht");

var $lgloJ = parcelRequire("lgloJ");

var $dcU1k = parcelRequire("dcU1k");

var $biHUf = parcelRequire("biHUf");

var $5W7YN = parcelRequire("5W7YN");

var $jNsQF = parcelRequire("jNsQF");

var $1sMAF = parcelRequire("1sMAF");
const $73babe0a2f637785$export$8f0d616c2469c6b6 = ({ setShowRealExperience: setShowRealExperience, injectValue: injectValue, useTopMenus: // eslint-disable-next-line react-hooks/react-compiler
useTopMenus = (0, $gOfBc.useTopMenus) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [_, { on: openMenu }] = useTopMenus((0, $5RW99.MENU_ID).SEARCH);
    const isNav4Enabled = (0, $6zXPf.getWillShowNav4)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        (0, $jNsQF.searchLoadOnIntentMetricStartFromSkeleton)();
        setShowRealExperience?.(true);
        openMenu();
    }, [
        setShowRealExperience,
        openMenu
    ]);
    const onMouseOver = (0, $eJOHy.useCallback)(()=>{
        setShowRealExperience?.(true);
    }, [
        setShowRealExperience
    ]);
    const onEnter = (0, $eJOHy.useCallback)((e)=>{
        const target = e.target;
        if (target instanceof HTMLInputElement) {
            target.blur();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const url = (0, $1sMAF.buildJiraAdvancedSearchUrl)(target.value, window.location.origin);
            push(url.href);
        }
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cPbpX.default), {
        inputMode: "search",
        onClick: onClick,
        onMouseOver: onMouseOver,
        onFocus: onClick,
        xcss: $73babe0a2f637785$var$quickFindSkeletonStyle,
        testId: "atlassian-navigation.ui.search.quickfind-skeleton-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzruH.QuickFindSkeleton), {
        onEnter: onEnter,
        isNav4Enabled: isNav4Enabled,
        injectValue: injectValue
    }));
};
const $73babe0a2f637785$var$LoadingSkeleton = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $biHUf.Skeleton), {
        placeholder: formatMessage((0, $lgloJ.default).interactiveSearchSkeletonPlaceholder),
        ariaLabel: formatMessage((0, $lgloJ.default).interactiveSearchSkeletonAriaLabel)
    });
};
const $73babe0a2f637785$var$LoadingSkeletonInteractive = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5W7YN.SkeletonInteractive), {
        placeholder: formatMessage((0, $lgloJ.default).interactiveSearchSkeletonPlaceholder),
        ariaLabel: formatMessage((0, $lgloJ.default).interactiveSearchSkeletonAriaLabel)
    });
};
const $73babe0a2f637785$var$SearchDialogMetricStart = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        (0, $dcU1k.searchDialogMetric).startFromPageLoad();
        (0, $dcU1k.searchDialogMetric).mark((0, $dcU1k.SEARCH_DIALOG_DOWNLOAD_START_MARK));
    }, []);
    return null;
};
const $73babe0a2f637785$var$SearchDialogMetricEnd = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        (0, $dcU1k.searchDialogMetric).mark((0, $dcU1k.SEARCH_DIALOG_DOWNLOAD_END_MARK));
    }, []);
    return null;
};

const $73babe0a2f637785$export$964f3f99df662c38 = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("aTnn6")).then((m)=>m.Search), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/search/main.tsx"
});
const $73babe0a2f637785$export$d8beef0361e69378 = (props)=>{
    const [injectValue] = (0, $95O7y.useQueryParam)('text');
    const isQuickFindEnabled = (0, $1sMAF.useQuickFindEnabled)();
    const loadingSkeleton = (0, $epTsa.expVal)('jfp-magma-concurrent-load-search-on-intent-exp', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$export$e455d67f280c301f, {
        useTopMenus: props.useTopMenus
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$var$LoadingSkeleton, null);
    const skeleton = isQuickFindEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$export$8f0d616c2469c6b6, {
        useTopMenus: props.useTopMenus,
        injectValue: injectValue
    }) : loadingSkeleton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "search",
        packageName: (0, $kO1ht.PACKAGE_NAME),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$var$SearchDialogMetricStart, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "lazy-search",
        fallback: skeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$export$964f3f99df662c38, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$var$SearchDialogMetricEnd, null), (0, $epTsa.expVal)('jfp-magma-concurrent-load-search-on-intent-exp', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jNsQF.SearchLoadOnIntentMetricEnd), null)));
};
const $73babe0a2f637785$var$loadingSkeletonExpandableWrapperStyle = {
    width: '100%'
}; // only for nav4
const $73babe0a2f637785$export$e455d67f280c301f = ({ setShowRealExperience: setShowRealExperience, useTopMenus: // eslint-disable-next-line react-hooks/react-compiler
useTopMenus = (0, $gOfBc.useTopMenus) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [_, { on: openMenu }] = useTopMenus((0, $5RW99.MENU_ID).SEARCH);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        (0, $jNsQF.searchLoadOnIntentMetricStartFromSkeleton)();
        setShowRealExperience?.(true);
        openMenu();
    }, [
        setShowRealExperience,
        openMenu
    ]);
    const onMouseOver = (0, $eJOHy.useCallback)(()=>{
        setShowRealExperience?.(true);
    }, [
        setShowRealExperience
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "atlassian-navigation.ui.search.loading-skeleton-expandable",
        onClick: onClick,
        onKeyDown: onClick,
        onMouseOver: onMouseOver,
        onFocus: onClick,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: (0, $6zXPf.getWillShowNav4)() ? $73babe0a2f637785$var$loadingSkeletonExpandableWrapperStyle : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$var$LoadingSkeletonInteractive, null)));
};
const $73babe0a2f637785$export$49f3879f38fced1b = (props)=>{
    const [injectValue] = (0, $95O7y.useQueryParam)('text');
    const isQuickFindEnabled = (0, $1sMAF.useQuickFindEnabled)();
    // eslint-disable-next-line react-hooks/react-compiler
    const { useTopMenus: useTopMenus = (0, $gOfBc.useTopMenus) } = props;
    // eslint-disable-next-line react-hooks/react-compiler
    const [isSearchMenuOpen] = useTopMenus((0, $5RW99.MENU_ID).SEARCH);
    const [showRealExperience, setShowRealExperience] = (0, $eJOHy.useState)(isSearchMenuOpen);
    (0, $eJOHy.useEffect)(()=>{
        if (isSearchMenuOpen) setShowRealExperience(true);
    }, [
        isSearchMenuOpen,
        setShowRealExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "atlassian-navigation-search"
    }, showRealExperience ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "atlassian-navigation-search-experience"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$export$d8beef0361e69378, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "atlassian-navigation-search-loading-skeleton-expandable"
    }, isQuickFindEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$export$8f0d616c2469c6b6, {
        // eslint-disable-next-line react-hooks/react-compiler
        useTopMenus: useTopMenus,
        setShowRealExperience: setShowRealExperience,
        injectValue: injectValue
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73babe0a2f637785$export$e455d67f280c301f, {
        // eslint-disable-next-line react-hooks/react-compiler
        useTopMenus: useTopMenus,
        setShowRealExperience: setShowRealExperience
    })));
};
const $73babe0a2f637785$export$4b85d3515bd863a5 = (0, $f2JN3.componentWithCondition)(()=>(0, $epTsa.expVal)('jfp-magma-concurrent-load-search-on-intent-exp', 'isEnabled', false), $73babe0a2f637785$export$49f3879f38fced1b, $73babe0a2f637785$export$d8beef0361e69378);
const $73babe0a2f637785$var$quickFindSkeletonStyle = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    width: '100%',
    padding: 'space.0'
});

});
parcelRegister("lgloJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f067d9e90684ac6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8f067d9e90684ac6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    updated: {
        "id": "atlassian-navigation.search.updated",
        "defaultMessage": "Updated"
    },
    interactiveSearchSkeletonPlaceholder: {
        "id": "atlassian-navigation.search.interactive-search-skeleton-placeholder",
        "defaultMessage": "Search"
    },
    interactiveSearchSkeletonAriaLabel: {
        "id": "atlassian-navigation.search.interactive-search-skeleton-aria-label",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("dcU1k", function(module, exports) {

$parcel$export(module.exports, "SEARCH_DIALOG_DOWNLOAD_START_MARK", () => $52e559471117562f$export$8cd6a987249a6f33);
$parcel$export(module.exports, "SEARCH_DIALOG_DOWNLOAD_END_MARK", () => $52e559471117562f$export$80ab6637ae730993);
$parcel$export(module.exports, "searchDialogMetric", () => $52e559471117562f$export$46d64d80a1040e9b);

var $4WXKS = parcelRequire("4WXKS");
const $52e559471117562f$var$SEARCH_DIALOG_METRIC_KEY = 'search-dialog';
const $52e559471117562f$export$8cd6a987249a6f33 = 'download-start';
const $52e559471117562f$export$80ab6637ae730993 = 'download-end';
const $52e559471117562f$export$46d64d80a1040e9b = (0, $4WXKS.metrics).pageSegmentLoad({
    key: $52e559471117562f$var$SEARCH_DIALOG_METRIC_KEY,
    timings: [
        {
            key: 'download',
            startMark: $52e559471117562f$export$8cd6a987249a6f33,
            endMark: $52e559471117562f$export$80ab6637ae730993
        }
    ]
});

});

parcelRegister("biHUf", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $11ad57b3d4c8d7c6$export$8f31e4c4a37b8e9c);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $8YkgQ = parcelRequire("8YkgQ");

var $6zXPf = parcelRequire("6zXPf");

var $71BQm = parcelRequire("71BQm");

var $7jTnu = parcelRequire("7jTnu");

var $bDJm5 = parcelRequire("bDJm5");
const $11ad57b3d4c8d7c6$export$8f31e4c4a37b8e9c = ({ ProductSearchInputSkeleton: ProductSearchInputSkeleton = (0, $71BQm.ProductSearchInputSkeleton), useTheme: // eslint-disable-next-line react-hooks/react-compiler
useTheme = (0, $bDJm5.useTheme), placeholder: placeholder, ariaLabel: ariaLabel })=>{
    /**
	 * The nav3 custom theme object
	 */ // eslint-disable-next-line react-hooks/react-compiler
    const theme = useTheme();
    /**
	 * A nav4 search theme that works with the nav3 theming API
	 */ const newTheme = (0, $8YkgQ.useLegacySearchTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ProductSearchInputSkeleton, {
        shouldFillContainer: (0, $6zXPf.getWillShowNav4)(),
        theme: (0, $6zXPf.getWillShowNav4)() ? newTheme : theme && theme.mode && theme.mode.search,
        placeholder: placeholder,
        ariaLabel: ariaLabel,
        dataSsrPlaceholder: (0, $7jTnu.fg)('qs-7058-remove-experiment-call-search-dialog') ? 'nav4-search-bar' : undefined
    });
};

});

parcelRegister("5W7YN", function(module, exports) {

$parcel$export(module.exports, "SkeletonInteractive", () => $e2d0b85fee46ea69$export$f6cad695c873cb36);

var $eJOHy = parcelRequire("eJOHy");

var $8YkgQ = parcelRequire("8YkgQ");

var $7jTnu = parcelRequire("7jTnu");

var $6zXPf = parcelRequire("6zXPf");

var $71BQm = parcelRequire("71BQm");
var $fhDS2 = parcelRequire("fhDS2");

var $bDJm5 = parcelRequire("bDJm5");
const $e2d0b85fee46ea69$export$f6cad695c873cb36 = ({ useTheme: useTheme = (0, $bDJm5.useTheme), placeholder: placeholder, ariaLabel: ariaLabel })=>{
    /**
	 * The nav3 custom theme object
	 */ // eslint-disable-next-line react-hooks/react-compiler
    const theme = useTheme();
    /**
	 * A nav4 search theme that works with the nav3 theming API
	 */ const newTheme = (0, $8YkgQ.useLegacySearchTheme)();
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $71BQm.ProductSearchInputSkeleton), {
        shouldFillContainer: (0, $6zXPf.getWillShowNav4)(),
        theme: (0, $6zXPf.getWillShowNav4)() ? newTheme : theme && theme.mode && theme.mode.search,
        placeholder: placeholder,
        ariaLabel: ariaLabel,
        dataSsrPlaceholder: (0, $7jTnu.fg)('qs-7058-remove-experiment-call-search-dialog') ? 'nav4-search-bar' : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fhDS2.ProductSearchInputSkeletonInteractive), {
        shouldFillContainer: (0, $6zXPf.getWillShowNav4)(),
        theme: (0, $6zXPf.getWillShowNav4)() ? newTheme : theme && theme.mode && theme.mode.search,
        placeholder: placeholder || '',
        stickySearchEnabled: true
    });
};

});

parcelRegister("jNsQF", function(module, exports) {

$parcel$export(module.exports, "searchLoadOnIntentMetricStartFromSkeleton", () => $3fe7e4aabe209800$export$a9b73ef5805d7ce);
$parcel$export(module.exports, "SearchLoadOnIntentMetricEnd", () => $3fe7e4aabe209800$export$c802bd101ecfea1);
$parcel$export(module.exports, "searchLoadOnIntentMetricFromSearchFire", () => $3fe7e4aabe209800$export$5c176f125966323d);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");
// eslint-disable-next-line no-restricted-properties, jira/jira-ssr/no-unchecked-globals-usage
const $3fe7e4aabe209800$var$getNow = ()=>window?.performance?.now?.();
class $3fe7e4aabe209800$var$SearchLoadOnIntentMetric {
    start(isStartFromSkeleton, startTime = $3fe7e4aabe209800$var$getNow()) {
        if (this.startTime !== null) return;
        this.isStartFromSkeleton = isStartFromSkeleton;
        this.startTime = startTime;
    }
    stop(analyticsEvent, endTime = $3fe7e4aabe209800$var$getNow()) {
        if (this.startTime === null || this.stopTime !== null || this.hasFired) return;
        this.stopTime = endTime;
        (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'searchDialog firstOpen', {
            startTime: Math.round(this.startTime),
            duration: Math.round((this.stopTime || 0) - (this.startTime || 0)),
            isStartFromSkeleton: this.isStartFromSkeleton
        });
        this.hasFired = true;
    }
    constructor(){
        this.hasFired = false;
        this.startTime = null;
        this.stopTime = null;
        this.isStartFromSkeleton = false;
    }
}
let $3fe7e4aabe209800$var$searchLoadOnIntentMetric = new $3fe7e4aabe209800$var$SearchLoadOnIntentMetric();
const $3fe7e4aabe209800$export$b2204437a87141a9 = ()=>$3fe7e4aabe209800$var$searchLoadOnIntentMetric;
const $3fe7e4aabe209800$export$69e5d67124dcdbcb = ()=>{
    $3fe7e4aabe209800$var$searchLoadOnIntentMetric = new $3fe7e4aabe209800$var$SearchLoadOnIntentMetric();
};
const $3fe7e4aabe209800$export$a9b73ef5805d7ce = (startTime)=>{
    $3fe7e4aabe209800$var$searchLoadOnIntentMetric.start(true, startTime);
};
const $3fe7e4aabe209800$export$c802bd101ecfea1 = ({ endTime: endTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        $3fe7e4aabe209800$var$searchLoadOnIntentMetric.stop(createAnalyticsEvent({}), endTime);
    }, [
        createAnalyticsEvent,
        endTime
    ]);
    return null;
};
const $3fe7e4aabe209800$export$5c176f125966323d = (analyticsEvent, now = $3fe7e4aabe209800$var$getNow())=>{
    if ($3fe7e4aabe209800$var$searchLoadOnIntentMetric.hasFired || $3fe7e4aabe209800$var$searchLoadOnIntentMetric.startTime !== null) return;
    $3fe7e4aabe209800$var$searchLoadOnIntentMetric.start(false, now);
    $3fe7e4aabe209800$var$searchLoadOnIntentMetric.stop(analyticsEvent, now);
};

});

parcelRegister("1sMAF", function(module, exports) {

$parcel$export(module.exports, "buildJiraAdvancedSearchUrl", () => $d8486820a9ae8b64$export$b5c6d8d10f4438a4);
$parcel$export(module.exports, "useQuickFindEnabled", () => $d8486820a9ae8b64$export$a5c820d7542f98bf);

var $21HMC = parcelRequire("21HMC");

var $24Lc7 = parcelRequire("24Lc7");

var $lb6FK = parcelRequire("lb6FK");

var $7jTnu = parcelRequire("7jTnu");
const $d8486820a9ae8b64$var$ISSUE_NAVIGATOR_URL = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`;
const $d8486820a9ae8b64$var$buildJiraSearchUrl = (query)=>`/jira/search?searchString=${encodeURIComponent(query)}`;
const $d8486820a9ae8b64$var$buildSmartQueryAdvancedSearchUrl = (query)=>`/secure/QuickSearch.jspa?searchString=${encodeURIComponent(query)}`;
const $d8486820a9ae8b64$var$buildJQLAdvancedIssueUrl = (jql)=>`/issues/?jql=${jql}`;
const $d8486820a9ae8b64$export$772e48b507423c7c = (query, jql)=>{
    const trimmedQuery = query.trim();
    if (!trimmedQuery) // If query is empty, we utilise a spa transition with ISSUE_NAVIGATOR_URL
    return query === '' ? $d8486820a9ae8b64$var$ISSUE_NAVIGATOR_URL : $d8486820a9ae8b64$var$buildSmartQueryAdvancedSearchUrl(query);
    if (jql) // if JQL is provided, we build the work items URL with JQL
    return $d8486820a9ae8b64$var$buildJQLAdvancedIssueUrl(jql);
    // we navigate to the search page to handle the single work item page in case the query is a work item key
    return $d8486820a9ae8b64$var$buildJiraSearchUrl(trimmedQuery);
};
const $d8486820a9ae8b64$export$b5c6d8d10f4438a4 = (query, jql, siteUrl)=>{
    return new URL($d8486820a9ae8b64$export$772e48b507423c7c(query, jql), siteUrl ?? '');
};
const $d8486820a9ae8b64$export$a5c820d7542f98bf = (experimentConfig)=>{
    const rovoEntitlement = (0, $lb6FK.useRovoEntitlementResource)();
    // Enable quick find by feature flag as priority to
    // allow easier internal dogfooding
    if ((0, $7jTnu.fg)('rovo_search_jira_enable_quick_find')) return true;
    if (!rovoEntitlement?.data?.isRovoEnabled) return false;
    let isExperimentEnabled = false;
    let isRovoSearchExperienceEnabledByExperiment = false;
    if (!experimentConfig) {
        const layer = (0, $21HMC.default).getLayer((0, $24Lc7.STATSIG_SEARCH_PLATFORM_JIRA_LAYER_TENANTS_BASED), {
            fireLayerExposure: false
        });
        const uiFeatures = layer.get('uiFeatures', {
            rovoSearchExperienceEnabled: false
        });
        isExperimentEnabled = layer.get('enabled', false);
        isRovoSearchExperienceEnabledByExperiment = uiFeatures.rovoSearchExperienceEnabled;
    } else {
        isExperimentEnabled = experimentConfig.combinedExperiment?.enabled ?? false;
        isRovoSearchExperienceEnabledByExperiment = experimentConfig.combinedExperiment?.uiFeatures?.rovoSearchExperienceEnabled ?? false;
    }
    if (!isExperimentEnabled) return false;
    return isRovoSearchExperienceEnabledByExperiment;
};

});

parcelRegister("aTnn6", function(module, exports) {

let $7ee12b8792ccdef8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7ee12b8792ccdef8$var$load("k4gbU"),
    $7ee12b8792ccdef8$var$load("eDzss"),
    $7ee12b8792ccdef8$var$load("1VRB2"),
    $7ee12b8792ccdef8$var$load("bABhq"),
    $7ee12b8792ccdef8$var$load("iatVn")
]).then(()=>parcelRequire('1s2AM'));

});


parcelRegister("2olUi", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $a615229afd1abf39$export$c72f6eaae7b9adff);

var $eJOHy = parcelRequire("eJOHy");

var $o0Fzr = parcelRequire("o0Fzr");

var $7R1al = parcelRequire("7R1al");

var $9Y5m0 = parcelRequire("9Y5m0");

var $8Uqf3 = parcelRequire("8Uqf3");

var $7jTnu = parcelRequire("7jTnu");

var $gZTP9 = parcelRequire("gZTP9");

var $lRq8t = parcelRequire("lRq8t");

var $5RW99 = parcelRequire("5RW99");

var $gOfBc = parcelRequire("gOfBc");

var $RXvVX = parcelRequire("RXvVX");

var $6zXPf = parcelRequire("6zXPf");

var $cNe2t = parcelRequire("cNe2t");

var $cECwI = parcelRequire("cECwI");

var $bbdV2 = parcelRequire("bbdV2");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $kO1ht = parcelRequire("kO1ht");

var $hzuxP = parcelRequire("hzuxP");

var $4BIvh = parcelRequire("4BIvh");

var $4BXz7 = parcelRequire("4BXz7");

var $1tzLb = parcelRequire("1tzLb");

var $jTzOc = parcelRequire("jTzOc");

var $3nihz = parcelRequire("3nihz");

var $5lAC9 = parcelRequire("5lAC9");

var $2pW8u = parcelRequire("2pW8u");
const $a615229afd1abf39$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).SETTINGS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a615229afd1abf39$var$SettingsContainer, null));
});
function $a615229afd1abf39$var$SettingsContainer() {
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    if (isAnonymous) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a615229afd1abf39$var$SettingsInner, null);
}
const $a615229afd1abf39$var$EMPTY_OBJECT = {};
function $a615229afd1abf39$var$SettingsInner() {
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, { toggle: toggleMenu, off: closeMenu }] = (0, $gOfBc.useTopMenus)((0, $5RW99.MENU_ID).SETTINGS);
    const triggerAnalytics = (0, $4BIvh.useNavigationItemAnalytics)({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).SETTINGS
    });
    const onStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $kO1ht.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $kO1ht.NAVIGATION_ITEM_ID).SETTINGS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (!(0, $6zXPf.getWillShowNav4)()) onStart();
        toggleMenu();
        triggerAnalytics({
            shownCommandPalettePrompt: isAdmin
        });
    }, [
        isAdmin,
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    const testIdPrefix = (0, $RXvVX.testIdGenerate)('secondary-actions', 'settings');
    // replace this with useId from react 18 when stable
    const id = (0, $o0Fzr.useUID)();
    const titleId = `top-navigation-settings-header-${id}-title`;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $5lAC9.settingsMenuEntryPoint), (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-2') ? $a615229afd1abf39$var$EMPTY_OBJECT : {});
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const Trigger = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": (0, $RXvVX.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": `atlassian-navigation-settings${false ? '-ssr' : ''}`
        }, (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Y5m0.Settings), {
            ...triggerProps,
            ref: (element)=>{
                triggerRef(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref?.(element);
            },
            onClick: onClick,
            isSelected: isOpen,
            interactionName: "nav4-topNav-settings",
            label: formatMessage((0, $2pW8u.default).settings)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hzuxP.Settings), {
            ...triggerProps,
            ref: (element)=>{
                triggerRef(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref?.(element);
            },
            onClick: onClick,
            tooltip: formatMessage((0, $2pW8u.default).settings),
            isSelected: isOpen
        })), [
        formatMessage,
        isOpen,
        onClick,
        testIdPrefix,
        triggerRef
    ]);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        titleId: titleId,
        isOpen: isOpen,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                id: "nav4-topNav-settings",
                entryPointReferenceSubject: entryPointReferenceSubject,
                packageName: (0, $kO1ht.PACKAGE_NAME),
                errorFallback: "flag",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BXz7.MenuLayout), {
                    isWide: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
                    isScrollable: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tzLb.MenuSkeletonContent), {
                    testIdPrefix: testIdPrefix
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7R1al.default), {
                    hasSeparator: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jTzOc.MenuSkeletonFooter), {
                    testIdPrefix: testIdPrefix
                }))),
                runtimeProps: {
                    testIdPrefix: testIdPrefix,
                    titleId: titleId
                }
            }),
        onClose: closeMenu,
        placement: "bottom-end",
        messageId: "atlassian-navigation.ui.settings.popup",
        messageType: "transactional",
        trigger: Trigger,
        label: formatMessage((0, $2pW8u.default).settings),
        shouldRenderToParent: true
    });
}

});
parcelRegister("hzuxP", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $15e2e8507ea0cb4c$export$c72f6eaae7b9adff);

var $eJOHy = parcelRequire("eJOHy");

var $cMG3s = parcelRequire("cMG3s");

var $hHbpa = parcelRequire("hHbpa");

var $6zXPf = parcelRequire("6zXPf");
const $15e2e8507ea0cb4c$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    if (false) {
        if ((0, $6zXPf.getWillShowNav4)()) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hHbpa.Nav4SkeletonSettingsButton), {
            label: props.tooltip
        });
        // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hHbpa.SkeletonSettingsButton), {
            label: props.tooltip
        });
    }
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cMG3s.Settings), buttonProps);
});

});

parcelRegister("1tzLb", function(module, exports) {

$parcel$export(module.exports, "MenuSkeletonContent", () => $b675ff5052172406$export$8db7a6d33c26b25f);

var $eJOHy = parcelRequire("eJOHy");

var $8Xotl = parcelRequire("8Xotl");
var $f9Ihw = parcelRequire("f9Ihw");

var $RXvVX = parcelRequire("RXvVX");
const $b675ff5052172406$export$8db7a6d33c26b25f = ({ testIdPrefix: testIdPrefix })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $RXvVX.testIdConcat)(testIdPrefix, 'skeleton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Xotl.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), {
        hasIcon: true,
        width: "62.5%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), {
        hasIcon: true,
        width: "50%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), {
        hasIcon: true,
        width: "62.5%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), {
        hasIcon: true,
        width: "50%"
    }));

});

parcelRegister("jTzOc", function(module, exports) {

$parcel$export(module.exports, "MenuSkeletonFooter", () => $b870bf9dd361e2dd$export$efa6bae06cf20a1);

var $eJOHy = parcelRequire("eJOHy");

var $f9Ihw = parcelRequire("f9Ihw");

var $RXvVX = parcelRequire("RXvVX");
const $b870bf9dd361e2dd$export$efa6bae06cf20a1 = ({ testIdPrefix: testIdPrefix, numItems: numItems = 2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $RXvVX.testIdConcat)(testIdPrefix, 'skeleton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), {
        width: "50%"
    }), numItems >= 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9Ihw.default), {
        width: "50%"
    }));

});

parcelRegister("5lAC9", function(module, exports) {

$parcel$export(module.exports, "settingsMenuEntryPoint", () => $3186560596db5716$export$61e5d93bdc8bc226);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $3186560596db5716$export$61e5d93bdc8bc226 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("bRpQ3")).then(({ MenuWithEntryPoint: MenuWithEntryPoint })=>MenuWithEntryPoint), {
        moduleId: "c918b04e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bRpQ3", function(module, exports) {

let $8a28aff9a7663a95$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8a28aff9a7663a95$var$load("1VRB2"),
    $8a28aff9a7663a95$var$load("bABhq"),
    $8a28aff9a7663a95$var$load("aulmF")
]).then(()=>parcelRequire('2aspo'));

});


parcelRegister("2pW8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b6f0250d98cd0ef$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0b6f0250d98cd0ef$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    settings: {
        "id": "atlassian-navigation.settings.menu.settings",
        "defaultMessage": "Settings"
    }
});

});


parcelRegister("6phAP", function(module, exports) {

$parcel$export(module.exports, "SignIn", () => $fcb27fd0e80c4f6a$export$b64708c6f1b3ed96);

var $eJOHy = parcelRequire("eJOHy");

var $i0PfN = parcelRequire("i0PfN");

var $g0uPB = parcelRequire("g0uPB");

var $dTocu = parcelRequire("dTocu");

var $6zXPf = parcelRequire("6zXPf");

var $cECwI = parcelRequire("cECwI");

var $kO1ht = parcelRequire("kO1ht");

var $3nihz = parcelRequire("3nihz");

var $4BIvh = parcelRequire("4BIvh");

var $2YGcG = parcelRequire("2YGcG");

var $2RKQ2 = parcelRequire("2RKQ2");
const $fcb27fd0e80c4f6a$var$SignIn = ({ useDestinationParam: // eslint-disable-next-line react-hooks/react-compiler
useDestinationParam = (0, $2RKQ2.useDestinationParam), useIntl: // eslint-disable-next-line react-hooks/react-compiler
useIntl = (0, $dTocu.useIntlV2), useNavigationItemAnalytics: // eslint-disable-next-line react-hooks/react-compiler
useNavigationItemAnalytics = (0, $4BIvh.useNavigationItemAnalytics), useIsAnonymous: // eslint-disable-next-line react-hooks/react-compiler
useIsAnonymous = (0, $cECwI.useIsAnonymous) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const destinationParam = useDestinationParam();
    // eslint-disable-next-line react-hooks/react-compiler
    const isAnonymous = useIsAnonymous();
    // eslint-disable-next-line react-hooks/react-compiler
    const { formatMessage: formatMessage } = useIntl();
    // eslint-disable-next-line react-hooks/react-compiler
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).SIGN_IN
    });
    if (!isAnonymous) return null;
    if ((0, $6zXPf.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0PfN.default), {
        href: `/login.jsp?${destinationParam}`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g0uPB))),
        label: formatMessage((0, $2YGcG.default).signIn),
        isTooltipDisabled: false,
        appearance: "subtle",
        // @ts-expect-error - TS2769 - No overload matches this call.
        onClick: triggerAnalytics
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0PfN.default), {
        href: `/login.jsp?${destinationParam}`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g0uPB))),
        label: formatMessage((0, $2YGcG.default).signIn),
        isTooltipDisabled: false,
        appearance: "subtle",
        // @ts-expect-error - TS2769 - No overload matches this call.
        onClick: triggerAnalytics
    }));
};
const $fcb27fd0e80c4f6a$export$b64708c6f1b3ed96 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nihz.TopLevelErrorBoundary), {
        id: (0, $kO1ht.NAVIGATION_ITEM_ID).SIGN_IN
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fcb27fd0e80c4f6a$var$SignIn, props));

});
parcelRegister("2YGcG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca58326d942b0996$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ca58326d942b0996$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    signIn: {
        "id": "atlassian-navigation.sign-in.sign-in",
        "defaultMessage": "Sign in"
    }
});

});

parcelRegister("2RKQ2", function(module, exports) {

$parcel$export(module.exports, "useDestinationParam", () => $ea863dfe961f37ea$export$c9c176e0725165cc);

var $dOwXt = parcelRequire("dOwXt");
const $ea863dfe961f37ea$export$c9c176e0725165cc = ()=>{
    const { href: href = null } = (0, $dOwXt.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return `os_destination=${encodedRedirectUrl}`;
    }
    return '';
};

});


parcelRegister("caHVZ", function(module, exports) {

$parcel$export(module.exports, "Nav4NotificationsData", () => $0f2abd1a0cdee471$export$4be76e93f368ccd9);

var $35SIo = parcelRequire("35SIo");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $1KdDN = parcelRequire("1KdDN");

var $kO1ht = parcelRequire("kO1ht");

var $xmBsk = parcelRequire("xmBsk");
const $0f2abd1a0cdee471$export$4be76e93f368ccd9 = (props)=>{
    const { queryReference: queryReference } = props;
    const fragmentData = (0, $j4oe4.useFragment)((0, $35SIo.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "nav4-notifications-error-boundary",
        packageName: (0, $kO1ht.PACKAGE_NAME),
        teamName: (0, $kO1ht.TEAM_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xmBsk.Nav4Notifications), {
        fragmentData: fragmentData
    }));
};

});
parcelRegister("35SIo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f1859d8ed54515b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab5a4efb2e4c302f6507731481aad167>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f1859d8ed54515b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4NotificationsData",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4Notifications"
        }
    ],
    "type": "Query"
};
$6f1859d8ed54515b$var$node.hash = "359a3dc4bc79536755e5a1c2e1775462";
var $6f1859d8ed54515b$export$2e2bcd8739ae039 = $6f1859d8ed54515b$var$node;

});

parcelRegister("xmBsk", function(module, exports) {

$parcel$export(module.exports, "Nav4Notifications", () => $d4ac2ed6fb5a42aa$export$c50c32b171c62438);

var $fIYVt = parcelRequire("fIYVt");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5UxOh = parcelRequire("5UxOh");

var $gFqQp = parcelRequire("gFqQp");

var $RXvVX = parcelRequire("RXvVX");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gOfBc = parcelRequire("gOfBc");

var $5RW99 = parcelRequire("5RW99");

var $8Uqf3 = parcelRequire("8Uqf3");

var $lRq8t = parcelRequire("lRq8t");

var $gzcjr = parcelRequire("gzcjr");

var $fYeTG = parcelRequire("fYeTG");

var $8Z2t0 = parcelRequire("8Z2t0");

var $eSnSE = parcelRequire("eSnSE");

var $7jTnu = parcelRequire("7jTnu");

var $kO1ht = parcelRequire("kO1ht");

var $4BIvh = parcelRequire("4BIvh");

var $isgAI = parcelRequire("isgAI");

var $TTU2Q = parcelRequire("TTU2Q");

var $jILIS = parcelRequire("jILIS");

var $6ajYG = parcelRequire("6ajYG");


var $ebmHm = parcelRequire("ebmHm");

var $jRdpz = parcelRequire("jRdpz");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d4ac2ed6fb5a42aa$var$LazyMenu = (0, $gzcjr.lazy)(()=>(parcelRequire("b5Qrn")).then(({ Menu: Menu })=>Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/menu/index.tsx"
});
const $d4ac2ed6fb5a42aa$export$c50c32b171c62438 = (props)=>{
    const { fragmentData: fragmentData } = props;
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const [_queryRef, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $8Z2t0.default));
    const [data] = (0, $j4oe4.useRefetchableFragment)((0, $fIYVt.default), fragmentData);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // Check for new notifications every 5 minutes. This is currently done through polling because
    // Relay subscriptions are not yet supported server side. This polling will need to be replaced with
    // a subscription in the future (when notifications are migrated to Post Office).
    (0, $TTU2Q.usePolling)((0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-2') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)(()=>{
        if ((0, $7jTnu.fg)('blu-7858-only-poll-notifications-active-tabs')) {
            if ((0, $gFqQp.getDocument)()?.hidden) return;
        }
        (0, $j4oe4.fetchQuery)(environment, (0, $8Z2t0.default), {}).subscribe({
            complete: ()=>{
                loadQuery({}, {
                    fetchPolicy: 'store-and-network'
                });
            },
            error: (error)=>{
                (0, $eSnSE.default).safeErrorWithoutCustomerData(`${(0, $kO1ht.PACKAGE_NAME)}.Nav4Notifications`, 'Error fetching notification', error);
            }
        });
    }, [
        environment,
        loadQuery
    ]) : ()=>{
        if ((0, $7jTnu.fg)('blu-7858-only-poll-notifications-active-tabs')) {
            if ((0, $gFqQp.getDocument)()?.hidden) return;
        }
        (0, $j4oe4.fetchQuery)(environment, (0, $8Z2t0.default), {}).subscribe({
            complete: ()=>{
                loadQuery({}, {
                    fetchPolicy: 'store-and-network'
                });
            },
            error: (error)=>{
                (0, $eSnSE.default).safeErrorWithoutCustomerData(`${(0, $kO1ht.PACKAGE_NAME)}.Nav4Notifications`, 'Error fetching notification', error);
            }
        });
    }, 300000);
    const fetchedNotificationsCount = data.notifications?.unseenNotificationCount ?? 0;
    // Initialise the state to false on page load, but use an effect to update it if the unseen notification
    // count changes (i.e. as a result of polling) to ensure the badge is shown when there are new notifications.
    const [isNotificationCleared, setIsNotificationCleared] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (fetchedNotificationsCount > 0) setIsNotificationCleared(false);
    }, [
        fetchedNotificationsCount
    ]);
    // If notifications have been cleared, force the badge to be 0. This crudely addresses a race condition where
    // opening the menu (which resets the unseen notification count) does not complete before a refetch completes.
    const notificationsCount = isNotificationCleared ? 0 : fetchedNotificationsCount;
    const testIdPrefix = (0, $RXvVX.testIdGenerate)('secondary-actions', 'notifications');
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu, on: openMenu }] = (0, $gOfBc.useTopMenus)((0, $5RW99.MENU_ID).NOTIFICATIONS);
    const content = (0, $eJOHy.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jILIS.NotificationsContentWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
            id: "notifications.list.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
            name: "notification-menu-native",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d4ac2ed6fb5a42aa$var$LazyMenu, {
            scheduleUpdate: update,
            testIdPrefix: testIdPrefix
        })))), [
        testIdPrefix
    ]);
    const triggerAnalytics = (0, $4BIvh.useNavigationItemAnalytics)({
        navigationItemId: (0, $kO1ht.NAVIGATION_ITEM_ID).NOTIFICATIONS
    });
    const onStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $kO1ht.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $kO1ht.NAVIGATION_ITEM_ID).NOTIFICATIONS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (isMenuOpen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.clearMarks('notification.list.render.start');
        else performance.mark('notification.list.render.start');
        onStart();
        toggleMenu();
        triggerAnalytics();
        // Always set isNotificationCleared to true when the menu trigger is clicked
        // that there are no unseen notifications).
        setIsNotificationCleared(true);
    // PLEASE NOTE: Refetching the notifications does not occur here because for some reason
    // it blocks the popup from being closed.
    }, [
        isMenuOpen,
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    (0, $jRdpz.useRegisterNotificationsInCommandPalette)(onClick);
    const badge = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ajYG.Nav4NotificationsBadge), {
            count: notificationsCount
        }), [
        notificationsCount
    ]);
    const notificationsLabel = notificationsCount < (0, $fd3ecb7812b98df6$export$14c62ba6f49b806f) ? formatMessage((0, $ebmHm.default).label, {
        count: notificationsCount
    }) : formatMessage((0, $ebmHm.default).overNineNotifications);
    const trigger = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": (0, $RXvVX.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": `atlassian-navigation-notifications${false ? '-ssr' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $isgAI.Notification), {
            ...triggerProps,
            badge: badge,
            isSelected: isMenuOpen,
            onClick: onClick,
            tooltip: formatMessage((0, $ebmHm.default).tooltip),
            label: notificationsLabel,
            onViewRequests: openMenu
        })), [
        badge,
        formatMessage,
        isMenuOpen,
        notificationsLabel,
        onClick,
        openMenu,
        testIdPrefix
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5UxOh.default), {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        trigger: trigger,
        shouldRenderToParent: true,
        shouldFitViewport: (0, $fYeTG.isMobileAndInViewPanelIterationExperiment)() ? true : undefined
    });
};

});
parcelRegister("fIYVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ad9d47e70a9730e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39ea3d6e0f88481971cec9a363b97835>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $8Z2t0 = parcelRequire("8Z2t0");
const $8ad9d47e70a9730e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $8Z2t0.default)
        }
    },
    "name": "Nav4Notifications",
    "selections": [
        {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "unseenNotificationCount"
                }
            ]
        }
    ],
    "type": "Query"
};
$8ad9d47e70a9730e$var$node.hash = "9fa4e72bf771cce7bab0cd69ec168049";
var $8ad9d47e70a9730e$export$2e2bcd8739ae039 = $8ad9d47e70a9730e$var$node;

});
parcelRegister("8Z2t0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ec3eb787f1d119b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e946028ffc3086f1d9efb784e3dbaa5>>
 * @relayHash b27ca3910e82a09b8cdc053e9a61ed19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f56bec76aa8f8c1f4592fbdd8e4dc7b3b3e88310f264e6c19fece22372dba44e
const $4ec3eb787f1d119b$var$node = {
    "fragment": {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4NotificationsRefetchableQuery",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "Nav4Notifications"
            }
        ],
        "type": "Query"
    },
    "kind": "Request",
    "operation": {
        "argumentDefinitions": [],
        "kind": "Operation",
        "name": "Nav4NotificationsRefetchableQuery",
        "selections": [
            {
                "concreteType": "InfluentsNotificationQuery",
                "kind": "LinkedField",
                "name": "notifications",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "unseenNotificationCount"
                    }
                ]
            }
        ]
    },
    "params": {
        "id": "f56bec76aa8f8c1f4592fbdd8e4dc7b3b3e88310f264e6c19fece22372dba44e",
        "metadata": {},
        "name": "Nav4NotificationsRefetchableQuery",
        "operationKind": "query",
        "text": null
    }
};
$4ec3eb787f1d119b$var$node.hash = "9fa4e72bf771cce7bab0cd69ec168049";
var $4ec3eb787f1d119b$export$2e2bcd8739ae039 = $4ec3eb787f1d119b$var$node;

});


parcelRegister("TTU2Q", function(module, exports) {

$parcel$export(module.exports, "usePolling", () => $f53ec338019a0340$export$a11f73e3adecd502);

var $eJOHy = parcelRequire("eJOHy");
const $f53ec338019a0340$export$a11f73e3adecd502 = (callback, delay)=>{
    const callbackRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const tick = ()=>{
            if (callbackRef.current) callbackRef.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
    }, [
        delay
    ]);
};

});

parcelRegister("6ajYG", function(module, exports) {

$parcel$export(module.exports, "Nav4NotificationsBadge", () => $ea15bcfae5c6ade8$export$c4129d57a4559409);

var $eJOHy = parcelRequire("eJOHy");

var $55K0G = parcelRequire("55K0G");
const $ea15bcfae5c6ade8$export$c4129d57a4559409 = (props)=>{
    const { count: count } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $55K0G.Nav4NotificationsIndicator), {
        count: count
    });
};

});
parcelRegister("55K0G", function(module, exports) {

$parcel$export(module.exports, "Nav4NotificationsIndicator", () => $82f2bc9d98d1c209$export$6891e3964002ac9);

var $eJOHy = parcelRequire("eJOHy");

var $eE9zS = parcelRequire("eE9zS");
const $82f2bc9d98d1c209$var$MAX_NOTIFICATIONS_COUNT = 9;
const $82f2bc9d98d1c209$export$6891e3964002ac9 = (props)=>{
    const { appearance: appearance = 'important', count: count, max: max = $82f2bc9d98d1c209$var$MAX_NOTIFICATIONS_COUNT } = props;
    return count ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-test-selector": "NotificationIndicator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eE9zS.default), {
        testId: "atlassian-navigation.ui.notifications.notification-indicator-badge",
        max: max,
        appearance: appearance
    }, count)) : null;
};

});







parcelRegister("Gbl9s", function(module, exports) {

$parcel$export(module.exports, "FullHeight", () => $295aff1e029b1c93$export$33e617ec5e4e4f76);

var $eJOHy = parcelRequire("eJOHy");
const $295aff1e029b1c93$var$styleFullHeight = {
    height: '100vh'
};
const $295aff1e029b1c93$export$33e617ec5e4e4f76 = ({ children: children })=>// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        style: $295aff1e029b1c93$var$styleFullHeight
    }, children);

});

parcelRegister("3sFnL", function(module, exports) {

$parcel$export(module.exports, "GlobalThemeSetter", () => $318c931c19d8fe29$export$c8947eb2c95eab56);

var $eJOHy = parcelRequire("eJOHy");

var $9QXjP = parcelRequire("9QXjP");
var $5M7r5 = parcelRequire("5M7r5");

var $gFqQp = parcelRequire("gFqQp");

var $7jTnu = parcelRequire("7jTnu");

var $2Mqjh = parcelRequire("2Mqjh");

var $cxQGT = parcelRequire("cxQGT");

var $eJrcF = parcelRequire("eJrcF");

var $6XSXq = parcelRequire("6XSXq");

var $98XEE = parcelRequire("98XEE");
var $kvZl9 = parcelRequire("kvZl9");
const $318c931c19d8fe29$var$darkThemeMediaMatchQuery = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
function $318c931c19d8fe29$var$setThemeCookieWhenIdle(theme) {
    if (!false) {
        if ((0, $7jTnu.fg)('jfp-magma-dark-mode-flash-fix')) // this is an optimization to ensure that we don't get a white "flash" when dark mode is on, allowing
        // SSR to flush an <html> tag with the theme set.
        return (0, $6XSXq.callWhenIdle)(()=>{
            if (!theme) (0, $98XEE.deleteCookie)('jira_theme');
            else (0, $kvZl9.setCookie)('jira_theme', theme, {
                expires: 30,
                secure: true,
                sameSite: 'strict'
            });
        }, 1000);
    }
}

const $318c931c19d8fe29$export$c8947eb2c95eab56 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)((0, $cxQGT.themePreferenceResource));
    const { colorMode: colorMode } = (0, $5M7r5.default)();
    const [isThemeStylesInHead, setIsThemeStylesInHead] = (0, $eJOHy.useState)(()=>{
        if (!(0, $7jTnu.fg)('jfp_magma_jira-global-theme-hydration')) // the original implementation
        return false;
        if (loading || error || !data) // actually that's a misconfiguration and should never happen
        // but we still need to check (and it did happen in the past)
        return false;
        if (false) // let's make SSR behavior more explicit - no, styles are not in the head, render them
        return false;
        // check if the theme styles are already in the <head />.
        return Boolean((0, $gFqQp.getDocument)()?.head.querySelector('style[data-theme]'));
    });
    const setThemeWithToken = (0, $eJOHy.useCallback)(async (theme)=>{
        if (theme !== colorMode) {
            const { loadThemeTokens: loadThemeTokens } = await (parcelRequire("JmjTh"));
            loadThemeTokens(theme);
        }
    }, [
        colorMode
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (loading || error || !data) return undefined;
        let cleanupIdleCallback;
        // Combine the themes 'dark', 'light' and 'auto' after @atlaskit/tokens@1.0.0
        // https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/27634
        if (data?.theme === 'auto') {
            const token = $318c931c19d8fe29$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light';
            setThemeWithToken(token);
            cleanupIdleCallback = $318c931c19d8fe29$var$setThemeCookieWhenIdle(token);
            const handler = (e)=>{
                const tokenValue = e.matches ? 'dark' : 'light';
                setThemeWithToken(tokenValue);
                cleanupIdleCallback = $318c931c19d8fe29$var$setThemeCookieWhenIdle(tokenValue);
            };
            $318c931c19d8fe29$var$darkThemeMediaMatchQuery?.addEventListener('change', handler);
            return ()=>{
                $318c931c19d8fe29$var$darkThemeMediaMatchQuery?.removeEventListener('change', handler);
                cleanupIdleCallback?.();
            };
        }
        if (data?.theme === 'dark' || data?.theme === 'light') {
            setThemeWithToken(data?.theme);
            cleanupIdleCallback = $318c931c19d8fe29$var$setThemeCookieWhenIdle(data?.theme);
        }
        if (!data?.theme) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement.removeAttribute('data-theme');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement.removeAttribute('data-color-mode');
            cleanupIdleCallback = $318c931c19d8fe29$var$setThemeCookieWhenIdle(null);
        }
        return cleanupIdleCallback;
    }, [
        data,
        loading,
        error,
        setThemeWithToken
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (loading || error || !data) return;
        (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
            if (data?.theme) client.setUIViewedAttributes({
                theme: data.theme
            });
            else client.removeUIViewedAttribute('theme');
        });
    }, [
        data,
        loading,
        error
    ]);
    (0, $eJOHy.useEffect)(()=>{
        (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
            client.setUIViewedAttributes({
                OStheme: $318c931c19d8fe29$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light'
            });
        });
    }, []);
    // @atlaskit/tokens expects the theme styles to be in the <head /> but they're
    // initially rendered in the "jira-ssr" container in the <body /> and then moved to the
    // <head />. The following prevents the styles from being re-rendered in the <body />.
    (0, $eJOHy.useEffect)(()=>{
        // this useEffect will be executed after the "move script" right below regardless of the SSR presence or absence
        // safe to say - setIsThemeStylesInHead wil be always true after the first render
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.head.querySelector('style[data-theme]')) setIsThemeStylesInHead(true);
    }, []);
    if (!data?.theme || !data?.attrs || !data?.styles) return null;
    const ssrAutoScript = (0, $9QXjP.default)(data.theme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !isThemeStylesInHead ? data.styles.map((theme)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
            key: theme.id,
            ...theme.attrs,
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: theme.css
            }
        })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: data.styles.map((theme)=>`document.head.appendChild(document.body.querySelector('style[data-theme="${theme.id}"]'));`).join('\n')
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: Object.entries(data.attrs).map(([key, val])=>{
                if (key === 'data-color-mode' && ssrAutoScript) return '';
                return `document.documentElement.setAttribute("${key}", "${val}");`;
            }).join('\n')
        }
    }), ssrAutoScript ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: ssrAutoScript
        }
    }) : null);
};

});
parcelRegister("98XEE", function(module, exports) {

$parcel$export(module.exports, "deleteCookie", () => $a470d9b51aeecb3e$export$b43e45590305ffaa);

var $5H4WP = parcelRequire("5H4WP");

var $8XtVW = parcelRequire("8XtVW");

var $gUpg5 = parcelRequire("gUpg5");

var $c6wvU = parcelRequire("c6wvU");
const $a470d9b51aeecb3e$export$b43e45590305ffaa = (key, attributes)=>{
    if ((0, $8XtVW.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).remove(key, attributes);
    else try {
        (0, $gUpg5.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).remove(key, attributes);
    } catch (e) {
        (0, $c6wvU.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
    }
};

});

parcelRegister("kvZl9", function(module, exports) {

$parcel$export(module.exports, "setCookie", () => $8f036dc9f4dd3bc2$export$110700823644f4a6);

var $5H4WP = parcelRequire("5H4WP");

var $8XtVW = parcelRequire("8XtVW");

var $gx7dg = parcelRequire("gx7dg");
var $gUpg5 = parcelRequire("gUpg5");

var $9IrYG = parcelRequire("9IrYG");

var $c6wvU = parcelRequire("c6wvU");

var $iKmqD = parcelRequire("iKmqD");
const $8f036dc9f4dd3bc2$export$110700823644f4a6 = async (key, value, attributes)=>{
    if ((0, $8XtVW.fg)('platform_moonjelly_bsc_master_killswitch')) {
        // Set the cookie without checking user preferences
        // when master killswitch is enabled
        (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
        return (0, $iKmqD.Status).SUCCESS;
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    const productName = (0, $gx7dg.getBscGlobalState)().product;
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetCookie = await (0, $9IrYG.isProcessingAllowedByPreferences)({
        itemKey: key,
        storageType: (0, $iKmqD.CategoryStorageType).Cookies,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetCookie,
        cookieKey: key
    };
    try {
        (0, $gUpg5.sendPackageOperationalEvent)({
            action: 'usedSetCookie',
            attributes: eventAttributes
        });
        if (shouldSetCookie) {
            (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).set(key, value, {
                ...attributes,
                'atl-set-cookie': true
            });
            return (0, $iKmqD.Status).SUCCESS;
        } else return (0, $iKmqD.Status).BLOCKED;
    } catch (e) {
        (0, $c6wvU.Logger).errorWithOperationalEvent({
            action: 'usedSetCookieError',
            attributes: eventAttributes,
            message: `Failed to use set cookie. ${e.message || ''}`
        });
        return (0, $iKmqD.Status).BLOCKED;
    }
};

});

parcelRegister("JmjTh", function(module, exports) {

let $08858455a3f9c44d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $08858455a3f9c44d$var$load("gcTGS").then(()=>parcelRequire('135mT'));

});


parcelRegister("hOLtL", function(module, exports) {

$parcel$export(module.exports, "ProjectThemeSetter", () => $98214d48e1d4cd49$export$fd1b0084c5bb04a9);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $9FYIg = parcelRequire("9FYIg");

var $fICTM = parcelRequire("fICTM");

var $1G20J = parcelRequire("1G20J");

var $epTsa = parcelRequire("epTsa");

var $6w7uw = parcelRequire("6w7uw");

var $2PrU6 = parcelRequire("2PrU6");
const $98214d48e1d4cd49$export$fd1b0084c5bb04a9 = ()=>{
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $1G20J.projectThemeResource));
    const { hasTheming: hasTheming } = (0, $epTsa.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2PrU6.useProjectTheme)() : {
        hasTheming: false
    };
    if (!queryReference || !hasTheming && (0, $epTsa.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false)) /* The resource is available only for routes enabled for theming.
		We still need to set the default token color by using ThemeTokenSetter for all other routes.
		This can be removed once theming is enabled for all pages. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w7uw.ThemeTokensSetter), {
        themeSetting: null
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "projectThemeSetter",
        packageName: "jiraPageContainerV2",
        teamName: "deliveroo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "project-theme-setter-placeholder",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fICTM.ThemeSetter), {
        queryReference: queryReference
    })));
};

});
parcelRegister("fICTM", function(module, exports) {

$parcel$export(module.exports, "ThemeSetter", () => $da96f3e70bcac92c$export$ce1303eaa27a0d3a);

var $hnsXL = parcelRequire("hnsXL");

var $5V48N = parcelRequire("5V48N");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aBAcl = parcelRequire("aBAcl");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $6zXPf = parcelRequire("6zXPf");

var $hih5V = parcelRequire("hih5V");

var $6w7uw = parcelRequire("6w7uw");

var $5mfAj = parcelRequire("5mfAj");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $epTsa = parcelRequire("epTsa");

var $1uv7v = parcelRequire("1uv7v");

var $7jTnu = parcelRequire("7jTnu");
const $da96f3e70bcac92c$export$28580a1170c06a39 = {
    type: 'color',
    value: (0, $1uv7v.NO_BACKGROUND_CONFIG).name
};
const $da96f3e70bcac92c$export$ce1303eaa27a0d3a = ({ queryReference: queryReference })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const data = (0, $j4oe4.usePreloadedQuery)((0, $5V48N.default), queryReference);
    const backgroundData = (0, $j4oe4.useFragment)((0, $hnsXL.default), data.jira_projectByIdOrKey?.background ?? null);
    const { hasSoftwareTheming: hasSoftwareTheming, isSoftwareProject: isSoftwareProjectFromHook } = (0, $1302Y.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kUoGK.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false,
        isSoftwareProject: false
    };
    const isSoftwareProjectFromQuery = data.jira_projectByIdOrKey?.projectType === 'SOFTWARE';
    const isSoftwareProject = (0, $epTsa.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false) ? isSoftwareProjectFromQuery : isSoftwareProjectFromHook;
    const media = (0, $eJOHy.useMemo)(()=>{
        return data.jira.mediaClientId && data.jira.mediaExternalEndpointUrl ? {
            clientId: data.jira.mediaClientId,
            externalEndpointUrl: data.jira.mediaExternalEndpointUrl
        } : null;
    }, [
        data.jira.mediaClientId,
        data.jira.mediaExternalEndpointUrl
    ]);
    const isColorOnly = isSoftwareProject && !(0, $1302Y.getIsSoftwareThemingM2Enabled)();
    const projectTheme = (0, $eJOHy.useMemo)(()=>{
        let themeSetting = null;
        if (!backgroundData) return null;
        switch(backgroundData.__typename){
            case 'JiraColorBackground':
                themeSetting = {
                    type: 'color',
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    value: backgroundData.colorValue
                };
                break;
            case 'JiraGradientBackground':
                themeSetting = isColorOnly ? $da96f3e70bcac92c$export$28580a1170c06a39 : {
                    type: 'color',
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    value: backgroundData.gradientValue
                };
                break;
            case 'JiraMediaBackground':
                if (isColorOnly) themeSetting = $da96f3e70bcac92c$export$28580a1170c06a39;
                else if (backgroundData.customBackground != null) {
                    const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText, dominantColor: dominantColor, brightness: brightness } = backgroundData.customBackground;
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    themeSetting = {
                        type: 'image',
                        value: 'image',
                        id: id,
                        mediaApiFileId: mediaApiFileId,
                        mediaReadToken: mediaReadToken,
                        sourceType: sourceType,
                        sourceIdentifier: sourceIdentifier,
                        altText: altText,
                        ...isSoftwareProject && (0, $1302Y.getIsSoftwareThemingM2Enabled)() && {
                            dominantColor: dominantColor,
                            brightness: brightness
                        }
                    };
                }
                break;
            default:
                themeSetting = null;
        }
        return themeSetting ? {
            themeSetting: themeSetting,
            entityId: `project/${data.jira_projectByIdOrKey?.projectId}`
        } : null;
    }, [
        backgroundData,
        data.jira_projectByIdOrKey?.projectId,
        isColorOnly,
        isSoftwareProject
    ]);
    const overviewTheme = (0, $aBAcl.useOverviewTheme)();
    const route = (0, $hih5V.useCurrentRoute)();
    const entityTheme = (0, $eJOHy.useMemo)(()=>{
        let result = projectTheme ?? overviewTheme;
        if (result != null) {
            const isFormSubmitView = route.name === 'classic-business-form-submit' || route.name === 'classic-business-form-submit-embed';
            // the form submit view doesn't use the project theme colors
            // since it is accessed externally to the project
            // remove themeSetting for pages in software projects that don't support theming yet
            if (isFormSubmitView || isSoftwareProject && !hasSoftwareTheming) result = {
                ...result,
                themeSetting: null
            };
        }
        return result;
    }, [
        projectTheme,
        overviewTheme,
        route.name,
        isSoftwareProject,
        hasSoftwareTheming
    ]);
    const sourceType = entityTheme?.themeSetting?.type === 'image' && (0, $7jTnu.fg)('project_theming_m2_fast_follow_4') ? entityTheme.themeSetting.sourceType : undefined;
    (0, $eJOHy.useEffect)(()=>{
        const projectId = data.jira_projectByIdOrKey?.projectId;
        if (projectId) {
            if (data.jira_projectByIdOrKey?.projectType === 'BUSINESS' || data.jira_projectByIdOrKey?.projectType === 'SOFTWARE' && (0, $1302Y.getIsSoftwareThemingEnabled)()) {
                const theme = sourceType === 'UNSPLASH' ? 'unsplash-image' : entityTheme?.themeSetting?.value;
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'theme evaluated', {
                    theme: theme,
                    projectId: projectId
                });
            }
        }
    }, [
        entityTheme?.themeSetting?.value,
        sourceType,
        data.jira_projectByIdOrKey?.projectId,
        data.jira_projectByIdOrKey?.projectType,
        createAnalyticsEvent
    ]);
    if ((0, $6zXPf.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w7uw.ThemeTokensSetter), {
        media: media,
        themeSetting: entityTheme?.themeSetting || null,
        projectType: data.jira_projectByIdOrKey?.projectType
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, entityTheme != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5mfAj.ThemeContainerOld), {
        isGlobal: true,
        ...entityTheme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w7uw.ThemeTokensSetter), {
        media: media,
        themeSetting: entityTheme?.themeSetting || null,
        projectType: data.jira_projectByIdOrKey?.projectType
    }));
};

});
parcelRegister("hnsXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $7babf48681331e34$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<374b66672720180e9e36deb3d82661fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7babf48681331e34$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ThemeSetterBackground",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorValue"
                }
            ],
            "type": "JiraColorBackground"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "gradientValue"
                }
            ],
            "type": "JiraGradientBackground"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraCustomBackground",
                    "kind": "LinkedField",
                    "name": "customBackground",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "mediaApiFileId"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "durationInSeconds",
                                    "value": 900
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "mediaReadToken",
                            "storageKey": "mediaReadToken(durationInSeconds:900)"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "sourceType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "sourceIdentifier"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "altText"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "dominantColor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "brightness"
                        }
                    ]
                }
            ],
            "type": "JiraMediaBackground"
        }
    ],
    "type": "JiraActiveBackgroundDetailsResult",
    "abstractKey": "__isJiraActiveBackgroundDetailsResult"
};
$7babf48681331e34$var$node.hash = "3c41e5a508924f980b8234232721902b";
var $7babf48681331e34$export$2e2bcd8739ae039 = $7babf48681331e34$var$node;

});

parcelRegister("aBAcl", function(module, exports) {

$parcel$export(module.exports, "useOverviewTheme", () => $9416d6987f1b2f90$export$a55763fd17eab357);

var $1uv7v = parcelRequire("1uv7v");

var $iXIhG = parcelRequire("iXIhG");
const $9416d6987f1b2f90$export$a55763fd17eab357 = ()=>{
    const { data: data } = (0, $iXIhG.useOverview)();
    if (data != null) return {
        themeSetting: {
            type: 'color',
            value: data.theme ?? (0, $1uv7v.DEFAULT_BACKGROUND_CONFIG).name
        },
        entityId: `overview/${data.id}`
    };
    return null;
};

});

parcelRegister("6w7uw", function(module, exports) {

$parcel$export(module.exports, "ThemeTokensSetter", () => $bfddee756a826c8f$export$41f41c7ff10d45cd);

var $eJOHy = parcelRequire("eJOHy");

var $1O6Yz = parcelRequire("1O6Yz");

var $dPMMf = parcelRequire("dPMMf");

var $ln6Iy = parcelRequire("ln6Iy");

var $1uv7v = parcelRequire("1uv7v");

var $lXVKI = parcelRequire("lXVKI");

var $6zXPf = parcelRequire("6zXPf");


var $1302Y = parcelRequire("1302Y");

var $j0wJ6 = parcelRequire("j0wJ6");

var $fsk2i = parcelRequire("fsk2i");
/**
 * Will merge multiple themes together, with the last theme taking precedence.
 * The first argument is the base theme, and the rest are partial themes that
 * will be merged into the base theme.
 */ function $bfddee756a826c8f$var$mergeThemes(theme, ...partialThemes) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, theme, ...partialThemes);
}
const $bfddee756a826c8f$var$buildHorizontalNavVariables = ({ theme: theme })=>{
    if ((0, $6zXPf.getWillShowNav4)()) return `${0, $204d4b1cf07e6083$export$539c074adec2188a}: ${theme['color.link']};
${0, $204d4b1cf07e6083$export$1cfe9795423425c}: ${theme['color.background.neutral.hovered']};
${0, $204d4b1cf07e6083$export$6f76912df5477959}: ${theme['color.link.pressed']};
${0, $204d4b1cf07e6083$export$fac615ceaa871e35}: ${theme['color.text.subtle']};
${0, $204d4b1cf07e6083$export$7748fdcd335afdc0}: ${theme['color.text']};
${0, $204d4b1cf07e6083$export$88e550ed188132a7}: ${theme['color.elevation.surface']};
${0, $204d4b1cf07e6083$export$e2e8fadb946a45d2}: ${theme['color.border.selected']};
${0, $204d4b1cf07e6083$export$4cd72d361867c565}: ${theme['color.border']};
${0, $204d4b1cf07e6083$export$be4d7e23cb48401e}:  ${theme['color.background.neutral']};`;
    return '';
};
const $bfddee756a826c8f$var$buildThemeVariables = (config, backgroundImageUrl, isDarkMode, isSoftwareProject, themeSetting)=>{
    const applicationColorMode = isDarkMode ? 'dark' : 'light';
    const brightnessOverrides = config.brightness === 'high' && !isDarkMode ? (0, $1uv7v.HIGH_BRIGHTNESS_THEME) : (0, $1uv7v.LOW_BRIGHTNESS_THEME);
    const isImageConfig = config.name === 'image';
    const isGradientConfig = (0, $lXVKI.themeManager).isGradientTheme(config.name);
    /**
   * The base theme and the custom theme get merged here, with the custom theme taking precedence.
   * If you want to override configurations globally, then you should make modifications to the
   * BASE_THEME, while if you want to customize a specific theme, then you should make modifications
   * in the theme's themselves.
   */ const theme = $bfddee756a826c8f$var$mergeThemes(// the base theme for the application
    (0, $1uv7v.BASE_THEME), // the brightness overrides
    isImageConfig && !(isSoftwareProject && (0, $1302Y.getIsSoftwareThemingM2Enabled)()) ? {} : brightnessOverrides, // gradient specific overrides
    isGradientConfig ? (0, $1uv7v.GRADIENT_THEME) : {}, // The custom background configuration
    config.theme[applicationColorMode]);
    let elevationSurface = theme['elevation.surface'] ?? theme['color.elevation.surface'];
    let colorElevationSurface = theme['color.elevation.surface'];
    if (backgroundImageUrl) {
        if (isSoftwareProject && themeSetting?.type === 'image' && !!themeSetting.dominantColor && (0, $1302Y.getIsSoftwareThemingM2Enabled)()) {
            const adjustedColor = (0, $fsk2i.getAdjustedColor)({
                dominantColor: themeSetting.dominantColor,
                isDarkMode: isDarkMode
            });
            if (adjustedColor) {
                elevationSurface = `linear-gradient(hsl(${adjustedColor} / 0.9) 0px, hsl(${adjustedColor} / 0.85) 130px, hsl(${adjustedColor} / 0.7) 230px, hsl(${adjustedColor} / 0.5) 310px, hsl(${adjustedColor} / 0.3) 380px, hsl(${adjustedColor} / 0.15) 440px, hsl(${adjustedColor} / 0) 500px), url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
                colorElevationSurface = `hsl(${adjustedColor} / 1)`;
            }
        } else // in dark mode, the image will be darkened by blending with a black transparent background
        elevationSurface = `url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
    } else if (applicationColorMode === 'dark') {
        if ((0, $1uv7v.NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig && !(0, $1302Y.getIsSoftwareThemingEnabled)() || (0, $1uv7v.NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig && (0, $1302Y.getIsSoftwareThemingEnabled)() && !isSoftwareProject) /**
       * Add a gradient to the elevation surface for any themes in dark mode. This could be done in the
       * meta configuration but it's easier to do bulk edits here.
       */ elevationSurface = `linear-gradient(180deg, ${theme['color.elevation.surface']} 0%, ${"var(--ds-surface, #FFFFFF)"} 400px)`;
    }
    // Wrapper configuration
    const withWrapper = config.name !== (0, $1uv7v.DEFAULT_BACKGROUND_CONFIG).name;
    const wrapperBackground = withWrapper ? "var(--ds-surface, #FFFFFF)" : 'unset';
    const wrapperBorderRadius = withWrapper ? `${0, $dPMMf.gridSize}px` : '0';
    const isNav4 = (0, $6zXPf.getWillShowNav4)();
    const businessWrapperWithBackgroundHeight = isNav4 ? (0, $1uv7v.NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, $1uv7v.BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT);
    const businessWrapperHeight = isNav4 ? (0, $1uv7v.NAV4_BUSINESS_WRAPPER_HEIGHT) : (0, $1uv7v.BUSINESS_WRAPPER_HEIGHT);
    const wrapperHeight = withWrapper ? businessWrapperWithBackgroundHeight : businessWrapperHeight;
    const wrapperPadding = withWrapper ? `${0, $1uv7v.BUSINESS_WRAPPER_PADDING}px` : '0';
    const wrapperWidth = withWrapper ? (0, $1uv7v.BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH) : (0, $1uv7v.BUSINESS_WRAPPER_WIDTH);
    return `
${(0, $1uv7v.Variables).BACKDROP_FILTER}: ${isImageConfig && !(isSoftwareProject && (0, $1302Y.getIsSoftwareThemingM2Enabled)()) ? 'blur(8px)' : 'none'};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST}: ${theme['color.background.neutral.subtle.hovered.contrast']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_ACCENT_SELECTED}: ${theme['color.background.accent.selected']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_BRAND_BOLD}: ${theme['color.background.brand.bold']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_BRAND_BOLD_HOVERED}: ${theme['color.background.brand.bold.hovered']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_BRAND_BOLD_PRESSED}: ${theme['color.background.brand.bold.pressed']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_DISABLED}: ${theme['color.background.disabled']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_INPUT}: ${theme['color.background.input']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_NEUTRAL}: ${theme['color.background.neutral']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_NEUTRAL_HOVERED}: ${theme['color.background.neutral.hovered']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_NEUTRAL_PRESSED}: ${theme['color.background.neutral.pressed']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED}: ${theme['color.background.neutral.subtle.hovered']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED}: ${theme['color.background.neutral.subtle.pressed']};
${(0, $1uv7v.Variables).COLOR_BACKGROUND_SELECTED}: ${theme['color.background.selected']};
${(0, $1uv7v.Variables).COLOR_BORDER}: ${theme['color.border']};
${(0, $1uv7v.Variables).COLOR_BORDER_INPUT}: ${theme['color.border.input']};
${(0, $1uv7v.Variables).COLOR_BORDER_INVERSE}: ${theme['color.border.inverse']};
${(0, $1uv7v.Variables).COLOR_BORDER_SELECTED}: ${theme['color.border.selected']};
${(0, $1uv7v.Variables).COLOR_ELEVATION_SURFACE}: ${colorElevationSurface};
${(0, $1uv7v.Variables).COLOR_ELEVATION_SURFACE_SUNKEN}: ${theme['color.elevation.surface.sunken']};
${(0, $1uv7v.Variables).COLOR_ICON_DANGER}: ${theme['color.icon.danger']};
${(0, $1uv7v.Variables).COLOR_ICON_INFORMATION}: ${theme['color.icon.information']};
${(0, $1uv7v.Variables).COLOR_ICON_SUCCESS}: ${theme['color.icon.success']};
${(0, $1uv7v.Variables).COLOR_ICON_WARNING}: ${theme['color.icon.warning']};
${(0, $1uv7v.Variables).COLOR_LINK}: ${theme['color.link']};
${(0, $1uv7v.Variables).COLOR_LINK_PRESSED}: ${theme['color.link.pressed']};
${(0, $1uv7v.Variables).COLOR_SKELETON}: ${theme['color.skeleton']};
${(0, $1uv7v.Variables).COLOR_TEXT}: ${theme['color.text']};
${(0, $1uv7v.Variables).COLOR_TEXT_ACCENT_SELECTED}: ${theme['color.text.accent.selected']};
${(0, $1uv7v.Variables).COLOR_TEXT_DISABLED}: ${theme['color.text.disabled']};
${(0, $1uv7v.Variables).COLOR_TEXT_INVERSE}: ${theme['color.text.inverse']};
${(0, $1uv7v.Variables).COLOR_TEXT_SELECTED}: ${theme['color.text.selected']};
${(0, $1uv7v.Variables).COLOR_TEXT_SUBTLE}: ${theme['color.text.subtle']};
${(0, $1uv7v.Variables).COLOR_TEXT_SUBTLEST}: ${theme['color.text.subtlest']};
${(0, $1uv7v.Variables).CONTENT_HEIGHT}: ${businessWrapperHeight};
${(0, $1uv7v.Variables).CONTENT_WIDTH}: ${0, $1uv7v.BUSINESS_WRAPPER_WIDTH};
${(0, $1uv7v.Variables).ELEVATION_SURFACE}: ${elevationSurface};
${(0, $1uv7v.Variables).ELEVATION_SURFACE_CONTRAST}: ${theme['elevation.surface.contrast']};
${(0, $1uv7v.Variables).ELEVATION_SURFACE_CONTRAST_BOLDER}: ${theme['elevation.surface.contrast.bolder']};
${(0, $1uv7v.Variables).ELEVATION_SURFACE_BLEND_MODE}: ${theme['elevation.surface.blend.mode']};
${(0, $1uv7v.Variables).WRAPPER_BACKGROUND}: ${wrapperBackground};
${(0, $1uv7v.Variables).WRAPPER_BORDER_RADIUS}: ${wrapperBorderRadius};
${(0, $1uv7v.Variables).WRAPPER_HEIGHT}: ${wrapperHeight};
${(0, $1uv7v.Variables).WRAPPER_PADDING}: ${wrapperPadding};
${(0, $1uv7v.Variables).WRAPPER_WIDTH}: ${wrapperWidth};
${$bfddee756a826c8f$var$buildHorizontalNavVariables({
        theme: theme
    })}`;
};
const $bfddee756a826c8f$export$41f41c7ff10d45cd = /*#__PURE__*/ (0, $eJOHy.memo)(({ themeSetting: themeSetting, media: media, projectType: projectType = null })=>{
    const isSoftwareProject = (projectType || '').toUpperCase() === (0, $ln6Iy.SOFTWARE_PROJECT).toUpperCase();
    const backgroundConfig = (0, $lXVKI.themeManager).get({
        themeSetting: themeSetting,
        enableImages: true,
        isSoftwareProject: isSoftwareProject && (0, $1302Y.getIsSoftwareThemingM2Enabled)()
    });
    const backgroundImageUrl = (0, $j0wJ6.useBackgroundImageUrl)(themeSetting, media);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `:root{ ${$bfddee756a826c8f$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, false, isSoftwareProject, isSoftwareProject && (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? themeSetting : undefined)} }
        [data-color-mode=dark]{ ${$bfddee756a826c8f$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, true, isSoftwareProject, isSoftwareProject && (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? themeSetting : undefined)} }`
        }
    }));
});

});
parcelRegister("lXVKI", function(module, exports) {

$parcel$export(module.exports, "themeManager", () => $ea5cb24d1e06d3dc$export$aba92a7f3273f617);
$parcel$export(module.exports, "generateMediaImageUrl", () => $ea5cb24d1e06d3dc$export$fe2402bbc6ac3125);
$parcel$export(module.exports, "getBackgroundConfigs", () => $ea5cb24d1e06d3dc$export$224c78c119a97f91);

var $1uv7v = parcelRequire("1uv7v");
const $ea5cb24d1e06d3dc$var$ALL_COLOR_BACKGROUND_CONFIGS = [
    ...(0, $1uv7v.FIXED_COLOR_BACKGROUND_CONFIGS),
    ...(0, $1uv7v.ADAPTIVE_COLOR_BACKGROUND_CONFIGS),
    (0, $1uv7v.NO_BACKGROUND_CONFIG)
];
const $ea5cb24d1e06d3dc$var$ALL_GRADIENT_BACKGROUND_CONFIGS = [
    ...(0, $1uv7v.GRADIENT_BACKGROUND_CONFIGS),
    ...(0, $1uv7v.ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS)
];
/**
 * This is a temporary class that will be used to transition between the old
 * and new theme systems. Once the old theme system is removed, this class
 * will be removed as well.
 */ class $ea5cb24d1e06d3dc$var$ThemeManager {
    init() {
        $ea5cb24d1e06d3dc$var$ALL_GRADIENT_BACKGROUND_CONFIGS.forEach((theme)=>{
            this.gradients.set(theme.name, theme);
            this.gradientNames.add(theme.name);
        });
        $ea5cb24d1e06d3dc$var$ALL_COLOR_BACKGROUND_CONFIGS.forEach((theme)=>{
            this.colors.set(theme.name, theme);
            this.colorNames.add(theme.name);
        });
        (0, $1uv7v.BACKGROUND_CONFIGS_OLD).forEach((theme)=>{
            this.oldColorNames.add(theme.name);
        });
    }
    isColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.colorNames.has(themeName);
    }
    isOldColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.oldColorNames.has(themeName);
    }
    isGradientTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.gradientNames.has(themeName);
    }
    isImageTheme(themeSetting) {
        return themeSetting.type === 'image';
    }
    getGradient(themeName) {
        return this.gradients.get(themeName);
    }
    getColor(themeName) {
        return this.colors.get(themeName);
    }
    /**
	 * Gets the theme meta for the given theme setting and version.
	 * This is used because we want to handle cases where users get flag
	 * variations during rollout that change what background is allowed.
	 * For example, if you have a new background color, but the flag is off,
	 * we want to revert back to the default background color instead.
	 * @param themeSetting the name setting with its type and value.
	 * @param enableImages determines if image backgrounds are enabled.
	 * @returns the meta information for the theme.
	 */ get({ themeSetting: themeSetting, enableImages: enableImages, isSoftwareProject: isSoftwareProject }) {
        if (!themeSetting) return 0, $1uv7v.DEFAULT_BACKGROUND_CONFIG;
        if (enableImages && themeSetting.type === 'image') return isSoftwareProject ? (0, $1uv7v.ADAPTIVE_IMAGE_BACKGROUND_CONFIG) : (0, $1uv7v.IMAGE_BACKGROUND_CONFIG);
        if (this.isGradientTheme(themeSetting.value)) return this.getGradient(themeSetting.value) ?? (0, $1uv7v.DEFAULT_BACKGROUND_CONFIG);
        if (this.isColorTheme(themeSetting.value)) return this.getColor(themeSetting.value) ?? (0, $1uv7v.DEFAULT_BACKGROUND_CONFIG);
        // we have an old color on the image version
        return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $1uv7v.OLD_TO_NEW_BACKGROUND_CONFIG_MAP)[themeSetting.value] ?? (0, $1uv7v.DEFAULT_BACKGROUND_CONFIG));
    }
    constructor(){
        this.gradients = new Map();
        this.gradientNames = new Set();
        this.colors = new Map();
        this.colorNames = new Set();
        this.oldColorNames = new Set();
        this.isValidTheme = (themeSetting)=>this.isColorTheme(themeSetting.value) || this.isOldColorTheme(themeSetting.value) || this.isGradientTheme(themeSetting.value) || this.isImageTheme(themeSetting);
    }
}
const $ea5cb24d1e06d3dc$export$aba92a7f3273f617 = new $ea5cb24d1e06d3dc$var$ThemeManager();
$ea5cb24d1e06d3dc$export$aba92a7f3273f617.init();
function $ea5cb24d1e06d3dc$export$fe2402bbc6ac3125({ mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaEndpoint: mediaEndpoint, ...queryParams }) {
    const url = new URL(`${mediaExternalEndpointUrl}/file/${mediaApiFileId}/${mediaEndpoint}`);
    url.searchParams.append('client', mediaClientId);
    Object.entries(queryParams).forEach(([param, value])=>url.searchParams.append(param, String(value)));
    return url.toString();
}
function $ea5cb24d1e06d3dc$export$224c78c119a97f91(withAdaptiveColorTheme) {
    return withAdaptiveColorTheme ? {
        backgroundColorConfigs: (0, $1uv7v.ADAPTIVE_COLOR_BACKGROUND_CONFIGS),
        gradientBackgroundConfigs: (0, $1uv7v.ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS)
    } : {
        backgroundColorConfigs: (0, $1uv7v.FIXED_COLOR_BACKGROUND_CONFIGS),
        gradientBackgroundConfigs: (0, $1uv7v.GRADIENT_BACKGROUND_CONFIGS)
    };
}

});

const $204d4b1cf07e6083$export$d1b9ea3245b6a5de = 3;
const $204d4b1cf07e6083$export$d07bba395c9390f1 = 32;
const $204d4b1cf07e6083$export$29911ec08ab2ca2d = 5;
const $204d4b1cf07e6083$export$b61e6f89a9db76de = 4;
const $204d4b1cf07e6083$export$7fd2e391116c6ef5 = 9;
const $204d4b1cf07e6083$export$e1633e494d305bfb = 'MORE';
const $204d4b1cf07e6083$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $204d4b1cf07e6083$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $204d4b1cf07e6083$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $204d4b1cf07e6083$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $204d4b1cf07e6083$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $204d4b1cf07e6083$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $204d4b1cf07e6083$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $204d4b1cf07e6083$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
const $204d4b1cf07e6083$export$be4d7e23cb48401e = '--horizontal-navigation-color-background-neutral';
const $204d4b1cf07e6083$export$8dd437f6d09d567 = '--horizontal-navigation-color-background-neutral-selected';
const $204d4b1cf07e6083$export$cf26c31143daa350 = '--hn-yjlbv';

parcelRegister("j0wJ6", function(module, exports) {

$parcel$export(module.exports, "useBackgroundImageUrl", () => $a555468b4cb0c8fc$export$16f28a2a10ece447);

var $eJOHy = parcelRequire("eJOHy");

var $lXVKI = parcelRequire("lXVKI");

var $gYnSx = parcelRequire("gYnSx");

var $8KUFq = parcelRequire("8KUFq");

var $9h7fx = parcelRequire("9h7fx");
const $a555468b4cb0c8fc$export$16f28a2a10ece447 = (themeSetting, media)=>{
    const lowResUrl = (0, $eJOHy.useMemo)(()=>media && themeSetting?.type === 'image' ? (0, $lXVKI.generateMediaImageUrl)({
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            mediaApiFileId: themeSetting.mediaApiFileId,
            token: themeSetting.mediaReadToken,
            mediaEndpoint: 'image',
            width: 1000,
            'max-age': Number.MAX_SAFE_INTEGER
        }) : null, [
        media,
        themeSetting
    ]);
    const [imageUrl, setImageUrl] = (0, $eJOHy.useState)(lowResUrl);
    const previousThemeId = (0, $eJOHy.useRef)(null);
    const abortControllerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (themeSetting?.type !== 'image') {
            previousThemeId.current = null;
            setImageUrl(null);
            return;
        }
        if (previousThemeId.current !== themeSetting.id && media) {
            if (abortControllerRef.current) abortControllerRef.current.abort();
            abortControllerRef.current = new AbortController();
            previousThemeId.current = themeSetting.id;
            setImageUrl(lowResUrl);
            // build a new URL to the /binary path
            const binaryUrl = (0, $lXVKI.generateMediaImageUrl)({
                mediaClientId: media.clientId,
                mediaExternalEndpointUrl: media.externalEndpointUrl,
                mediaApiFileId: themeSetting.mediaApiFileId,
                mediaEndpoint: 'binary',
                'max-age': Number.MAX_SAFE_INTEGER
            });
            // send a request to fetch the image with the binary URL with bearer token authentication
            fetch(binaryUrl.toString(), {
                headers: {
                    Authorization: `Bearer ${themeSetting.mediaReadToken}`
                },
                signal: abortControllerRef.current?.signal
            }).then((response)=>response.blob()).then((blob)=>{
                const objectUrl = URL.createObjectURL(blob);
                setImageUrl(objectUrl);
                // send viewing analytics to Unsplash for Unsplash images
                if (themeSetting.sourceType === 'UNSPLASH' && themeSetting.sourceIdentifier) (0, $9h7fx.unsplashTracker).trackImage(themeSetting.sourceIdentifier);
            }).catch((error)=>{
                if (error.name === 'AbortError') return;
                // only fire error analytics if the error is not a client fetch error (e.g. network error, aborted)
                if (!(0, $8KUFq.isClientFetchError)(error)) (0, $gYnSx.default)({
                    meta: {
                        id: 'fetchBinaryBackgroundImage',
                        packageName: 'jiraProjectThemeComponents',
                        teamName: 'work-management-frontier'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }
        return ()=>{
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, [
        themeSetting,
        media,
        lowResUrl
    ]);
    return imageUrl;
};

});
parcelRegister("9h7fx", function(module, exports) {

$parcel$export(module.exports, "unsplashTracker", () => $0511e851a2fb1fa1$export$1869e04dbed4c16c);

var $lsLcV = parcelRequire("lsLcV");

var $3s8bj = parcelRequire("3s8bj");
const $0511e851a2fb1fa1$var$APP_ID = '7066';
const $0511e851a2fb1fa1$export$ca6dda5263526f75 = `https://views.unsplash.com/v?app_id=${$0511e851a2fb1fa1$var$APP_ID}`;
const $0511e851a2fb1fa1$var$MAX_URL_LENGTH = 2083; // the maximum length of a URL in most browsers
const $0511e851a2fb1fa1$var$ID_LENGTH = 12; // the length of an unsplash image id
const $0511e851a2fb1fa1$export$28219189b23a0628 = Math.floor($0511e851a2fb1fa1$var$MAX_URL_LENGTH / $0511e851a2fb1fa1$var$ID_LENGTH);
/**
 * This class is responsible for tracking unsplash images that are displayed in the app.
 * This is needed for legal reasons to comply with the Unsplash API terms of service.
 * It will track the image when it is displayed and then track it again every 10 minutes.
 */ class $0511e851a2fb1fa1$var$UnsplashTracker {
    /**
	 * Send a request to the Unsplash API to track the image views.
	 * This will send a request for all the images in the queue.
	 * If the request fails, the images will be added back to the queue.
	 */ send() {
        if (this.queue.size === 0) return;
        const imageIds = Array.from(this.queue);
        this.queue.clear();
        (0, (/*@__PURE__*/$parcel$interopDefault($lsLcV)))(imageIds, $0511e851a2fb1fa1$export$28219189b23a0628).forEach((chunkIds)=>{
            const url = `${$0511e851a2fb1fa1$export$ca6dda5263526f75}&photoId=${chunkIds.join(',')}`;
            const now = new Date();
            imageIds.forEach((imageId)=>{
                this.trackedImages.set(imageId, now);
            });
            const handleFailure = ()=>{
                // if the request fails, add the image ids back to the queue
                imageIds.forEach((imageId)=>{
                    this.queue.add(imageId);
                    this.trackedImages.delete(imageId);
                });
            };
            fetch(url).then((response)=>{
                if (!response.ok) handleFailure();
            }).catch(()=>handleFailure());
        });
    }
    /**
	 * Track an image view. This will add the image to the queue to be tracked.
	 * If the image was tracked less than 10 minutes ago, it will not be added to the queue.
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns void
	 */ trackImage(sourceIdentifier) {
        const imageId = sourceIdentifier.split('-').pop(); // photo-1696144706485-ff7825ec8481 -> ff7825ec8481
        if (!imageId) return;
        const lastTracked = this.trackedImages.get(imageId);
        if (lastTracked && Date.now() - lastTracked.getTime() < this.trackingInterval) return;
        this.queue.add(imageId);
        this.sendDebounced();
    }
    /**
	 * Track an image view while it is in the viewport. This will track the image when it is displayed
	 * and then track it again every 10 minutes.
	 * @param element The element that contains the image
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns A function to stop tracking the image
	 */ trackWhileInViewport(element, sourceIdentifier) {
        let trackIntervalId = null;
        const observer = new IntersectionObserver((entry)=>{
            if (entry[0].isIntersecting && !trackIntervalId) {
                $0511e851a2fb1fa1$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                trackIntervalId = window.setInterval(()=>{
                    $0511e851a2fb1fa1$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                }, this.trackingInterval + 10); // extra 10ms to ensure the interval is always greater than 10 minutes
            } else if (trackIntervalId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearInterval(trackIntervalId);
        }, {
            rootMargin: '0px',
            threshold: 1.0
        });
        observer.observe(element);
        return ()=>{
            observer.disconnect();
            if (trackIntervalId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearInterval(trackIntervalId);
        };
    }
    static getInstance() {
        if (!$0511e851a2fb1fa1$var$UnsplashTracker.instance) $0511e851a2fb1fa1$var$UnsplashTracker.instance = new $0511e851a2fb1fa1$var$UnsplashTracker();
        return $0511e851a2fb1fa1$var$UnsplashTracker.instance;
    }
    constructor(){
        this.trackedImages = new Map();
        this.trackingInterval = 600000 // 10 minutes
        ;
        this.queue = new Set();
        this.sendDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(this.send, 1000);
    }
}
const $0511e851a2fb1fa1$export$1869e04dbed4c16c = $0511e851a2fb1fa1$var$UnsplashTracker.getInstance();

});
parcelRegister("lsLcV", function(module, exports) {

var $1FqKq = parcelRequire("1FqKq");

var $eA1it = parcelRequire("eA1it");

var $c9FP3 = parcelRequire("c9FP3");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $fa00d4eb66826668$var$nativeCeil = Math.ceil, $fa00d4eb66826668$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $fa00d4eb66826668$var$chunk(array, size, guard) {
    if (guard ? $eA1it(array, size, guard) : size === undefined) size = 1;
    else size = $fa00d4eb66826668$var$nativeMax($c9FP3(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($fa00d4eb66826668$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $1FqKq(array, index, index += size);
    return result;
}
module.exports = $fa00d4eb66826668$var$chunk;

});



parcelRegister("fsk2i", function(module, exports) {

$parcel$export(module.exports, "getAdjustedColor", () => $a553b5580e1bf809$export$e7544aa016cb7a22);
/**
 * Converts a hex color string to HSL (Hue, Saturation, Lightness) values
 * Reference: W3C CSS Color Module Level 4
 * https://www.w3.org/TR/css-color-4/#rgb-to-hsl
 *
 * The conversion process:
 * 1. Convert hex to RGB (base 16 to decimal, normalized to [0,1])
 * 2. Find the minimum and maximum RGB values to determine lightness
 * 3. Calculate saturation based on lightness
 * 4. Calculate hue based on which RGB component is the maximum
 */ function $a553b5580e1bf809$var$hexToHSL(hexProp) {
    let hex = hexProp.replace(/^#/, '');
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    const r = parseInt(hex.slice(0, 2), 16) / 255;
    const g = parseInt(hex.slice(2, 4), 16) / 255;
    const b = parseInt(hex.slice(4, 6), 16) / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h;
    let s;
    const l = (max + min) / 2;
    if (max === min) {
        h = 0;
        s = 0;
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
            default:
                h = (r - g) / d + 4;
                break;
        }
        h *= 60;
    }
    return {
        h: Math.round(h),
        s: Math.round(s * 100),
        l: Math.round(l * 100)
    };
}
function $a553b5580e1bf809$export$e7544aa016cb7a22({ dominantColor: dominantColor, isDarkMode: isDarkMode }) {
    // Convert the hex to HSL
    const { h: h, s: s, l: l } = $a553b5580e1bf809$var$hexToHSL(dominantColor);
    if (isDarkMode) // Dont need much adjustment for dark mode - just darken it
    return `${h} ${s}% ${Math.min(l, 26)}%`;
    const LIGHTNESS_TARGET = 75;
    const HIGH_LIGHTNESS_THRESHOLD = 70;
    if (l > HIGH_LIGHTNESS_THRESHOLD || l > 53 && s > 60) // Text already readable
    return `${h} ${s}% ${Math.max(l, 64)}%`;
    let saturation = s;
    // Cap over-saturated blues
    if (h >= 200 && h <= 220 && s > 65) saturation = 65;
    return `${h} ${saturation}% ${LIGHTNESS_TARGET}%`;
}

});


parcelRegister("5mfAj", function(module, exports) {

$parcel$export(module.exports, "ThemeContainerOld", () => $61d0dba4d4a2f187$export$c6e50a832af54243);
// Delete file when cleaning up getWillShowNav4

var $cSmYj = parcelRequire("cSmYj");

var $lXVKI = parcelRequire("lXVKI");

var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $61d0dba4d4a2f187$var$setTheme = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if ((0, $lXVKI.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(themeSetting?.value, newTheme?.value)) setState({
            entityId: entityId,
            selectedThemeSetting: selectedThemeSetting,
            themeSetting: newTheme
        });
    };
const $61d0dba4d4a2f187$var$setSelectedThemeSetting = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if (newTheme === null || (0, $lXVKI.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(selectedThemeSetting?.type === 'image' ? selectedThemeSetting?.id : selectedThemeSetting?.value, newTheme?.type === 'image' ? newTheme?.id : newTheme?.value)) setState({
            entityId: entityId,
            themeSetting: themeSetting,
            selectedThemeSetting: newTheme
        });
    };
const $61d0dba4d4a2f187$var$actions = {
    setTheme: $61d0dba4d4a2f187$var$setTheme,
    setSelectedThemeSetting: $61d0dba4d4a2f187$var$setSelectedThemeSetting
};
const $61d0dba4d4a2f187$var$initialState = {
    themeSetting: null,
    selectedThemeSetting: null,
    entityId: ''
};
const $61d0dba4d4a2f187$var$Store = (0, $GtRbT.createStore)({
    initialState: $61d0dba4d4a2f187$var$initialState,
    actions: $61d0dba4d4a2f187$var$actions,
    name: 'ProjectTheme'
});
const $61d0dba4d4a2f187$export$c6e50a832af54243 = (0, $6E16M.createContainer)($61d0dba4d4a2f187$var$Store, {
    onInit: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme),
    onUpdate: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme)
});

});



parcelRegister("d9aSP", function(module, exports) {

$parcel$export(module.exports, "PageContainerSuccessTracker", () => $bdf74b3dc5938c8d$export$495692882694bf09);

var $eJOHy = parcelRequire("eJOHy");

var $hya93 = parcelRequire("hya93");

var $4ctwv = parcelRequire("4ctwv");

var $1KdDN = parcelRequire("1KdDN");
/**
 * PageContainerSuccessTracker is a copy of the old NavigationSuccessTracker component from this path:
 * jira/src/packages/navigation-apps/atlassian-navigation/src/controllers/navigation-success-tracker/main.tsx
 * Which used to mount on every page. But now it doesn't we aren't getting page container success events.
 *
 * So we are mounting ExperienceSuccessTracker here just so the parent event fires and our SLO works again.
 * See this thread for more info: https://atlassian.slack.com/archives/C075QTJBJ6S/p1752445800976529
 *
 * Not sure if ExperienceSuccess is explicitly required here, but it was in the old component, so we are keeping it for now.
 */ function $bdf74b3dc5938c8d$var$PageContainerSuccessTrackerInner() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "pageContainerSuccessTracker",
        packageName: "jiraPageContainerV2",
        teamName: "jfp-magma",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hya93.ExperienceSuccessTracker), {
        location: "pageContainer",
        parentProviders: null,
        failureEventAttributes: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: "pageContainer"
    })));
}
const $bdf74b3dc5938c8d$export$495692882694bf09 = /*#__PURE__*/ (0, $eJOHy.memo)($bdf74b3dc5938c8d$var$PageContainerSuccessTrackerInner);

});


parcelRegister("kUiAZ", function(module, exports) {

$parcel$export(module.exports, "Content", () => $f010e46d30bde794$export$7c6e2c02157bb7d2);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $f2JN3 = parcelRequire("f2JN3");

var $6DnFA = parcelRequire("6DnFA");

var $6zXPf = parcelRequire("6zXPf");

var $dzLcO = parcelRequire("dzLcO");

var $2PrU6 = parcelRequire("2PrU6");

var $fBTBC = parcelRequire("fBTBC");

var $6dnL8 = parcelRequire("6dnL8");

var $fXCOi = parcelRequire("fXCOi");

var $kfvK2 = parcelRequire("kfvK2");

var $7wkp5 = parcelRequire("7wkp5");

var $cMOjO = parcelRequire("cMOjO");
/* IMPORTANT:
 * When making any changes to the Nav3 component, please ensure that you also make the same changes to the
 * Nav4 component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $f010e46d30bde794$var$SPA_TRACE_KEY = 'spa';
const $f010e46d30bde794$var$DefaultLayoutContentNav4 = (props)=>{
    const { isInset: isInset, hasTheming: hasTheming } = (0, $2PrU6.useProjectTheme)();
    const renderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "mainContentSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wkp5.MainContentSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dnL8.RenderTracerMark), {
        traceKey: $f010e46d30bde794$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fXCOi.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dnL8.RenderTracerMark), {
        traceKey: $f010e46d30bde794$var$SPA_TRACE_KEY,
        type: "end"
    }));
    if (hasTheming) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fBTBC.ThemedContentLayout), {
        appearance: isInset ? 'inset' : 'default'
    }, renderContent);
    return renderContent;
};
const $f010e46d30bde794$var$DefaultLayoutContentNav3 = (props)=>{
    const { isInset: isInset, hasProjectViewNavigation: hasProjectViewNavigation } = (0, $2PrU6.useProjectTheme)();
    const renderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6DnFA.MainHeightFixCss), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "mainContentSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wkp5.MainContentSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzLcO.Main), {
        id: "ak-main-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dnL8.RenderTracerMark), {
        traceKey: $f010e46d30bde794$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fXCOi.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dnL8.RenderTracerMark), {
        traceKey: $f010e46d30bde794$var$SPA_TRACE_KEY,
        type: "end"
    })));
    if (hasProjectViewNavigation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fBTBC.ProjectThemeWrapper), {
        withWhiteBackground: isInset
    }, renderContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cMOjO.LayoutMainWrapper), null, renderContent);
};
const $f010e46d30bde794$var$DefaultLayoutContent = (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), $f010e46d30bde794$var$DefaultLayoutContentNav4, $f010e46d30bde794$var$DefaultLayoutContentNav3);
const $f010e46d30bde794$var$useRouterRoute = (0, $kfvK2.createRouterSelector)((state)=>state.route);
const $f010e46d30bde794$export$7c6e2c02157bb7d2 = (props)=>{
    const { LayoutOverrideComponent: LayoutOverrideComponent } = $f010e46d30bde794$var$useRouterRoute();
    if (LayoutOverrideComponent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dnL8.RenderTracerMark), {
        traceKey: $f010e46d30bde794$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fXCOi.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dnL8.RenderTracerMark), {
        traceKey: $f010e46d30bde794$var$SPA_TRACE_KEY,
        type: "end"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f010e46d30bde794$var$DefaultLayoutContent, props);
};

});
parcelRegister("6DnFA", function(module, exports) {

$parcel$export(module.exports, "MainHeightFixCss", () => $9778425636bcbbb9$export$2fcd4100c556a49e);

var $eJOHy = parcelRequire("eJOHy");

const $9778425636bcbbb9$export$2fcd4100c556a49e = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `[data-ds--page-layout--slot="main"] { height: calc(100vh - ${(0, $bf1c59a4164b2d18$export$d60454526e2281af)}) }`
        }
    });

});

parcelRegister("fBTBC", function(module, exports) {

$parcel$export(module.exports, "ThemedContentLayout", () => $add86d391dcd4b8c$export$c2c3c7c0b13a1f9d);
$parcel$export(module.exports, "ProjectThemeWrapper", () => $add86d391dcd4b8c$export$65c56727ada4372d);
/* ProjectThemeWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6zXPf = parcelRequire("6zXPf");

var $b2TM0 = parcelRequire("b2TM0");
const $add86d391dcd4b8c$var$styles = {
    rootOld: "_kqswh2mm",
    root: "_kqswh2mm",
    fullHeight: "_1tkeidpf _4t3i1osq",
    insetRoot: "_1yt4y9h4",
    insetContainer: "_2rko1gnp _bfhkp043"
};
const $add86d391dcd4b8c$export$c2c3c7c0b13a1f9d = ({ children: children, appearance: appearance })=>/*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            (0, $6zXPf.getWillShowNav4)() && $add86d391dcd4b8c$var$styles.root,
            !(0, $6zXPf.getWillShowNav4)() && $add86d391dcd4b8c$var$styles.rootOld,
            $add86d391dcd4b8c$var$styles.fullHeight,
            appearance === 'inset' && $add86d391dcd4b8c$var$styles.insetRoot
        ])
    }, /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $add86d391dcd4b8c$var$styles.fullHeight,
            appearance === 'inset' && $add86d391dcd4b8c$var$styles.insetContainer
        ])
    }, children));
const $add86d391dcd4b8c$export$65c56727ada4372d = ({ withWhiteBackground: withWhiteBackground, children: children })=>{
    if (withWhiteBackground) return /*#__PURE__*/ $eJOHy.createElement((0, $b2TM0.OuterWrapperWithBackground), null, /*#__PURE__*/ $eJOHy.createElement((0, $b2TM0.InnerWrapperWithBackground), null, children));
    return /*#__PURE__*/ $eJOHy.createElement((0, $b2TM0.OuterWrapper), null, /*#__PURE__*/ $eJOHy.createElement((0, $b2TM0.InnerWrapper), null, children));
};

});
parcelRegister("b2TM0", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $be68f6d721067018$export$edaaad985a878983);
$parcel$export(module.exports, "OuterWrapperWithBackground", () => $be68f6d721067018$export$69c6ec128d3729c9);
$parcel$export(module.exports, "InnerWrapper", () => $be68f6d721067018$export$f185744748c379a7);
$parcel$export(module.exports, "InnerWrapperWithBackground", () => $be68f6d721067018$export$2e149d12a18af14b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $f2JN3 = parcelRequire("f2JN3");

var $6zXPf = parcelRequire("6zXPf");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $be68f6d721067018$var$Nav3OuterWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _154i14em",
            __cmplp.className
        ])
    });
});
const $be68f6d721067018$var$Nav4OuterWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _154i1l8a",
            __cmplp.className
        ])
    });
});
const $be68f6d721067018$export$edaaad985a878983 = (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), $be68f6d721067018$var$Nav4OuterWrapper, $be68f6d721067018$var$Nav3OuterWrapper);
const $be68f6d721067018$export$69c6ec128d3729c9 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $be68f6d721067018$export$edaaad985a878983, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1yt4y9h4",
            __cmplp.className
        ])
    });
});
const $be68f6d721067018$export$f185744748c379a7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_iu1g1fl4 _fok81wug _q7c11wug _2d3f3q3i _japi1o48",
            __cmplp.className
        ])
    });
});
const $be68f6d721067018$export$2e149d12a18af14b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $be68f6d721067018$export$f185744748c379a7, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1gnp _bfhkp043 _2d3f15y4 _japizntk",
            __cmplp.className
        ])
    });
});

});


parcelRegister("fXCOi", function(module, exports) {

$parcel$export(module.exports, "default", () => $a78fe1bd9ed3a8fd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $dydef = parcelRequire("dydef");

var $iLmfS = parcelRequire("iLmfS");
const $a78fe1bd9ed3a8fd$var$onSpaShellReady = ()=>{
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/spa-shell/core', '_jira-spa/spa-shell.start', 'JIRA_SPA_SHELL_READY');
};
const $a78fe1bd9ed3a8fd$var$Spa = ({ initRoute: initRoute = null, routes: routes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: "JIRA_SPA_SHELL_READY",
        onSet: $a78fe1bd9ed3a8fd$var$onSpaShellReady
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iLmfS.default), {
        initRoute: initRoute,
        routes: routes
    }));
var $a78fe1bd9ed3a8fd$export$2e2bcd8739ae039 = $a78fe1bd9ed3a8fd$var$Spa;

});
parcelRegister("iLmfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f2d77943b841e4c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3vr70 = parcelRequire("3vr70");

var $grrUi = parcelRequire("grrUi");

var $g1P4j = parcelRequire("g1P4j");

var $d8mHf = parcelRequire("d8mHf");

var $6OSA0 = parcelRequire("6OSA0");

var $6uWhG = parcelRequire("6uWhG");

var $eSnSE = parcelRequire("eSnSE");

var $1KdDN = parcelRequire("1KdDN");

var $286cZ = parcelRequire("286cZ");

var $7jTnu = parcelRequire("7jTnu");

var $ch9En = parcelRequire("ch9En");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $dydef = parcelRequire("dydef");

var $il8Fk = parcelRequire("il8Fk");

var $6dNf1 = parcelRequire("6dNf1");

var $4Oene = parcelRequire("4Oene");

var $kfvK2 = parcelRequire("kfvK2");
var $30bwc = parcelRequire("30bwc");
var $83DiZ = parcelRequire("83DiZ");

var $r7SLR = parcelRequire("r7SLR");

var $9kysr = parcelRequire("9kysr");

var $bJscI = parcelRequire("bJscI");

var $59iVY = parcelRequire("59iVY");

var $jdsvc = parcelRequire("jdsvc");
const $9f2d77943b841e4c$var$REMOTE_ACTIONS_OFF = 'OFF';
const $9f2d77943b841e4c$var$REMOTE_ACTIONS_PERFORM = 'PERFORM';
const $9f2d77943b841e4c$var$useRouterLocation = (0, $kfvK2.createRouterSelector)((state)=>state.location);
const $9f2d77943b841e4c$var$useRouterAction = (0, $kfvK2.createRouterSelector)((state)=>state.action);
const $9f2d77943b841e4c$var$useRouterQuery = (0, $kfvK2.createRouterSelector)((state)=>state.query);
const $9f2d77943b841e4c$var$useRouterRoute = (0, $kfvK2.createRouterSelector)((state)=>state.route);
const $9f2d77943b841e4c$var$useRouterMatch = (0, $kfvK2.createRouterSelector)((state)=>state.match);
const $9f2d77943b841e4c$var$useRouterRoutes = (0, $kfvK2.createRouterSelector)((state)=>state.routes);
const $9f2d77943b841e4c$var$useIsLazyRoutes = (0, $kfvK2.createRouterSelector)((state)=>state.isLazyRoutes);
let $9f2d77943b841e4c$var$hasPendingForceReloadAction = false;
const $9f2d77943b841e4c$var$getRemoteActionsRolloutStage = ()=>(0, $7jTnu.fg)('remote_actions_-_killswitch_-_temporary') ? $9f2d77943b841e4c$var$REMOTE_ACTIONS_PERFORM : $9f2d77943b841e4c$var$REMOTE_ACTIONS_OFF;
const $9f2d77943b841e4c$export$88fe66870dd8f843 = (value)=>{
    $9f2d77943b841e4c$var$hasPendingForceReloadAction = value;
};
const $9f2d77943b841e4c$export$39e8f9fc07dd3395 = ()=>$9f2d77943b841e4c$var$hasPendingForceReloadAction;
const $9f2d77943b841e4c$var$fireRemoteActionAnalytics = (analyticsEvent, eventAction, remoteAction, currentRoute, targetRoute, attempts, lastAttemptedAt)=>(0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, `remoteAction ${eventAction}`, {
        source: 'transitionBlocker',
        actionId: remoteAction != null && remoteAction.id != null ? String(remoteAction.id) : '',
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        frontendVersion: window.BUILD_KEY,
        currentRouteName: currentRoute?.route.name || '',
        targetRouteName: targetRoute?.route.name || '',
        remoteActionsRolloutStage: $9f2d77943b841e4c$var$getRemoteActionsRolloutStage(),
        attempts: attempts,
        lastAttemptedAt: lastAttemptedAt
    });
const $9f2d77943b841e4c$var$updateSentryBreadcrumb = (route, nextRoute)=>{
    const from = route.path + (route.query ? `?${route.query.join('&')}` : '');
    const to = nextRoute?.path + (nextRoute?.query ? `?${nextRoute.query.join('&')}` : '');
    (0, $3vr70.addBreadcrumb)({
        type: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
};
const $9f2d77943b841e4c$export$ef0074adc0f6b96d = (search)=>{
    const searchParams = new URLSearchParams(search);
    if (!searchParams.has('ignoreStickyVersion')) searchParams.append('ignoreStickyVersion', 'true');
    return `?${searchParams}`;
};
/**
 * Manages the routing, analytics, and remote actions within a single-page application (SPA).
 * This component sets up initial routes, enables analytics tracking, and handles SPA transitions.
 * It incorporates custom logic for page reloading or redirection under certain conditions
 * and ensures safe rendering of route components within an error boundary context.
 */ const $9f2d77943b841e4c$var$SpaOld = ({ routes: routes, initRoute: initRoute = null })=>{
    (0, $eJOHy.useMemo)(()=>{
        (0, $6uWhG.setMark)('jira-spa/view.start');
    }, []);
    const checkShouldResetPage = (0, $eJOHy.useMemo)(()=>(0, $6dNf1.createCheckShouldResetPage)(), []);
    const currentMatchObjectRef = (0, $eJOHy.useRef)(initRoute);
    (0, $eJOHy.useEffect)(()=>{
        (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/view', 'jira-spa/view.start', true);
    }, []);
    const { registerBlock: registerBlock } = (0, $83DiZ.useRouterActions)();
    const location = $9f2d77943b841e4c$var$useRouterLocation();
    const action = $9f2d77943b841e4c$var$useRouterAction();
    const query = $9f2d77943b841e4c$var$useRouterQuery();
    const route = $9f2d77943b841e4c$var$useRouterRoute();
    const match = $9f2d77943b841e4c$var$useRouterMatch();
    const isLazyRoutes = $9f2d77943b841e4c$var$useIsLazyRoutes();
    const routerRoutes = $9f2d77943b841e4c$var$useRouterRoutes();
    // If the Lazy Route Map experiment is enabled, we want to use the routes from
    // the router, not from props as they will be changing dynamically during page lifetime
    if (isLazyRoutes) // eslint-disable-next-line no-param-reassign
    routes = routerRoutes;
    const { shouldPerformAction: shouldPerformAction, performAction: performAction } = (0, $r7SLR.useShouldPerformAction)({
        actionName: 'forceReload'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    /* We update currentMatch only if it's not a redirect. So in canTransitionIn we can compare
	 * actual routes instead of comparing against the redirect one */ if (route.isRedirect !== true) currentMatchObjectRef.current = {
        route: route,
        match: match
    };
    const { resetCurrentPage: resetCurrentPage } = (0, $il8Fk.useSpaStateActions)();
    /* We regiser the blocker on every render to be sure that it gets added as first item
	 * even when the route changes (so it gets called last). It will be added only once anyway.
	 * This is our custom block() API that accepts promises.
	 * This code allows us to disable an SPA transition and trigger a full page reload
	 * in case the route we are moving out (or in) needs it. */ const transitionBlocker = (0, $eJOHy.useCallback)((nextLocation, nextAction)=>{
        const nextMatch = (0, $30bwc.default)(routes, nextLocation.pathname, nextLocation.search);
        const canDo = (0, $59iVY.default)(currentMatchObjectRef.current, nextMatch);
        // Checking how many routes is a proxy for determining whether the lazy routes have been loaded
        // canDo might still be true if this is a transition from an issue to an issue
        if (isLazyRoutes && !canDo && routes.length <= 3) (0, $eSnSE.default).safeInfoWithoutCustomerData('lazy_routes.transition', 'failure', {
            route: nextMatch?.route.name
        });
        if (!canDo) {
            const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location[windowAction]((0, $grrUi.createPath)(nextLocation));
        }
        const remoteActionsRolloutStage = $9f2d77943b841e4c$var$getRemoteActionsRolloutStage();
        if (remoteActionsRolloutStage !== $9f2d77943b841e4c$var$REMOTE_ACTIONS_OFF && createAnalyticsEvent !== null) {
            const currentMatch = currentMatchObjectRef.current;
            if (canDo && currentMatch?.route.name !== nextMatch?.route.name && shouldPerformAction && $9f2d77943b841e4c$var$hasPendingForceReloadAction === false) {
                $9f2d77943b841e4c$var$hasPendingForceReloadAction = true;
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                performAction((remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $9f2d77943b841e4c$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'performed', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location[windowAction]((0, $grrUi.createPath)({
                        ...nextLocation,
                        search: $9f2d77943b841e4c$export$ef0074adc0f6b96d(nextLocation.search)
                    }));
                }, (remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $9f2d77943b841e4c$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'cancelled', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                });
            }
        }
        return canDo;
    }, [
        performAction,
        routes,
        shouldPerformAction,
        createAnalyticsEvent,
        isLazyRoutes
    ]);
    const resetCurrentPageBeforeRouteChangeBlocker = (0, $eJOHy.useCallback)((nextLocation, nextAction)=>{
        const nextMatchObject = (0, $30bwc.default)(routes, nextLocation.pathname, nextLocation.search);
        if (nextMatchObject && match && route) {
            const { match: nextMatch, route: nextRoute } = nextMatchObject;
            const shouldReset = checkShouldResetPage({
                nextMatch: nextMatch,
                nextRoute: nextRoute,
                currentMatch: match,
                currentRoute: route,
                action: nextAction
            });
            const nextRouteUfoName = (0, $g1P4j.default)(nextRoute);
            if (shouldReset) {
                resetCurrentPage(nextRouteUfoName, nextRoute.name);
                (0, $9kysr.GlobalPageLoadExperience).setPageLoadId(nextRoute.perfMetricKey || 'UNKNOWN');
            }
            const isCurrentRouteRedirecting = route.isRedirect === true;
            if (isCurrentRouteRedirecting) {
                const currentRouteName = (0, $g1P4j.default)(route);
                (0, $d8mHf.default)(currentRouteName, nextRouteUfoName, nextRoute.name, performance.now());
            }
        }
        $9f2d77943b841e4c$var$updateSentryBreadcrumb(route, nextMatchObject?.route);
        return true;
    }, [
        checkShouldResetPage,
        match,
        resetCurrentPage,
        route,
        routes
    ]);
    registerBlock(transitionBlocker);
    registerBlock(resetCurrentPageBeforeRouteChangeBlocker);
    const renderRouteComponent = (0, $eJOHy.useCallback)(()=>{
        const { component: RouteComponent, isStrictModeEnabled: isStrictModeEnabled, skeleton: skeleton } = route;
        const Skeleton = skeleton || (0, $6OSA0.default);
        if (RouteComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f2d77943b841e4c$var$ConditionalStrictMode, {
            isEnabled: isStrictModeEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderWithNativeSuspense), {
            name: "route-component",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(RouteComponent, {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        })));
    }, [
        action,
        location,
        match,
        query,
        route
    ]);
    if (!(route && match)) return null;
    const { meta: meta, skeleton: skeleton } = route;
    const Skeleton = skeleton || (0, $6OSA0.default);
    const entryPoint = route.entryPoint?.();
    const { reporting: reporting } = meta || {};
    const renderRouteEntryPointContainer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderWithNativeSuspense), {
            name: "route-entry-point-container",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdsvc.RouteEntryPointContainer), {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        }));
    };
    /* Render a <Route> component instead of the page directly so the match prop can be
	 * propagated down to components wrapped with the withRouter HOC. Unfortunately, this
	 * means we forfeit the right to access query params via match is provided by <Route>
	 * rather than our custom matchRoute function. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "route-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        // explicitly coerce undefined to string to make flow happy
        id: `routeApp.${String(route.name)}`,
        packageName: "jiraSpa",
        extraEventData: {
            routeGroup: route.group ?? '',
            isSSR: false
        },
        fallback: "page",
        sendToPrivacyUnsafeSplunk: Boolean(reporting),
        ...reporting
    }, entryPoint ? renderRouteEntryPointContainer() : renderRouteComponent()));
};
const $9f2d77943b841e4c$var$RegisterRouterBlocks = ({ routes: routesOriginal, initRoute: initRoute, route: route, match: match })=>{
    const isLazyRoutes = $9f2d77943b841e4c$var$useIsLazyRoutes();
    const routerRoutes = $9f2d77943b841e4c$var$useRouterRoutes();
    const routes = (0, $eJOHy.useMemo)(()=>{
        return isLazyRoutes ? routerRoutes : routesOriginal;
    }, [
        isLazyRoutes,
        routerRoutes,
        routesOriginal
    ]);
    const checkShouldResetPage = (0, $eJOHy.useMemo)(()=>(0, $6dNf1.createCheckShouldResetPage)(), []);
    const currentMatchObjectRef = (0, $eJOHy.useRef)(initRoute);
    const { registerBlock: registerBlock } = (0, $83DiZ.useRouterActions)();
    const { shouldPerformAction: shouldPerformAction, performAction: performAction } = (0, $r7SLR.useShouldPerformAction)({
        actionName: 'forceReload'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        /* We update currentMatch only if it's not a redirect. So in canTransitionIn we can compare
		 * actual routes instead of comparing against the redirect one */ if (route.isRedirect !== true) currentMatchObjectRef.current = {
            route: route,
            match: match
        };
    }, [
        match,
        route
    ]);
    const { resetCurrentPage: resetCurrentPage } = (0, $il8Fk.useSpaStateActions)();
    /* We regiser the blocker on every render to be sure that it gets added as first item
	 * even when the route changes (so it gets called last). It will be added only once anyway.
	 * This is our custom block() API that accepts promises.
	 * This code allows us to disable an SPA transition and trigger a full page reload
	 * in case the route we are moving out (or in) needs it. */ const transitionBlocker = (0, $eJOHy.useCallback)((nextLocation, nextAction)=>{
        const nextMatch = (0, $30bwc.default)(routes, nextLocation.pathname, nextLocation.search);
        const canDo = (0, $59iVY.default)(currentMatchObjectRef.current, nextMatch);
        // Checking how many routes is a proxy for determining whether the lazy routes have been loaded
        // canDo might still be true if this is a transition from an issue to an issue
        if (isLazyRoutes && !canDo && routes.length <= 3) (0, $eSnSE.default).safeInfoWithoutCustomerData('lazy_routes.transition', 'failure', {
            route: nextMatch?.route.name
        });
        if (!canDo) {
            const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location[windowAction]((0, $grrUi.createPath)(nextLocation));
        }
        const remoteActionsRolloutStage = $9f2d77943b841e4c$var$getRemoteActionsRolloutStage();
        if (remoteActionsRolloutStage !== $9f2d77943b841e4c$var$REMOTE_ACTIONS_OFF && createAnalyticsEvent !== null) {
            const currentMatch = currentMatchObjectRef.current;
            if (canDo && currentMatch?.route.name !== nextMatch?.route.name && shouldPerformAction && $9f2d77943b841e4c$var$hasPendingForceReloadAction === false) {
                // eslint-disable-next-line react-hooks/react-compiler
                $9f2d77943b841e4c$var$hasPendingForceReloadAction = true;
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                performAction((remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $9f2d77943b841e4c$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'performed', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location[windowAction]((0, $grrUi.createPath)({
                        ...nextLocation,
                        search: $9f2d77943b841e4c$export$ef0074adc0f6b96d(nextLocation.search)
                    }));
                }, (remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $9f2d77943b841e4c$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'cancelled', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                });
            }
        }
        return canDo;
    }, [
        performAction,
        routes,
        shouldPerformAction,
        createAnalyticsEvent,
        isLazyRoutes
    ]);
    const resetCurrentPageBeforeRouteChangeBlocker = (0, $eJOHy.useCallback)((nextLocation, nextAction)=>{
        const nextMatchObject = (0, $30bwc.default)(routes, nextLocation.pathname, nextLocation.search);
        if (nextMatchObject && match && route) {
            const { match: nextMatch, route: nextRoute } = nextMatchObject;
            const shouldReset = checkShouldResetPage({
                nextMatch: nextMatch,
                nextRoute: nextRoute,
                currentMatch: match,
                currentRoute: route,
                action: nextAction
            });
            const nextRouteUfoName = (0, $g1P4j.default)(nextRoute);
            if (shouldReset) {
                resetCurrentPage(nextRouteUfoName, nextRoute.name);
                (0, $9kysr.GlobalPageLoadExperience).setPageLoadId(nextRoute.perfMetricKey || 'UNKNOWN');
            }
            const isCurrentRouteRedirecting = route.isRedirect === true;
            if (isCurrentRouteRedirecting) {
                const currentRouteName = (0, $g1P4j.default)(route);
                (0, $d8mHf.default)(currentRouteName, nextRouteUfoName, nextRoute.name, performance.now());
            }
        }
        $9f2d77943b841e4c$var$updateSentryBreadcrumb(route, nextMatchObject?.route);
        return true;
    }, [
        checkShouldResetPage,
        match,
        resetCurrentPage,
        route,
        routes
    ]);
    registerBlock(transitionBlocker);
    registerBlock(resetCurrentPageBeforeRouteChangeBlocker);
    return null;
};
const $9f2d77943b841e4c$var$SpaRouteComponent = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp_magma_entrypoint-perf-1'), ({ location: location, action: action, query: query, route: route, match: match })=>{
    const { component: RouteComponent, isStrictModeEnabled: isStrictModeEnabled, skeleton: skeleton } = route;
    const Skeleton = skeleton || (0, $6OSA0.default);
    if (RouteComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f2d77943b841e4c$var$ConditionalStrictMode, {
        isEnabled: isStrictModeEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderWithNativeSuspense), {
        name: "route-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(RouteComponent, {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    })));
});
const $9f2d77943b841e4c$var$SpaRouteEntryPointContainer = /*#__PURE__*/ (0, $eJOHy.memo)(({ location: location, action: action, query: query, route: route, match: match })=>{
    const Skeleton = route.skeleton || (0, $6OSA0.default);
    if ((0, $7jTnu.fg)('jfp_magma_entrypoint-perf-1')) return(// RouteEntryPointContainer will ALWAYS contain a Suspense boundary, so we can use the
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdsvc.RouteEntryPointContainer), {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderWithNativeSuspense), {
        name: "route-entry-point-container",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdsvc.RouteEntryPointContainer), {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    }));
});
const $9f2d77943b841e4c$var$SpaChild = ({ location: location, action: action, query: query, route: route, match: match })=>{
    const reporting = route.meta?.reporting;
    const entryPoint = (0, $eJOHy.useMemo)(()=>route.entryPoint?.(), [
        route
    ]);
    /* Render a <Route> component instead of the page directly so the match prop can be
	 * propagated down to components wrapped with the withRouter HOC. Unfortunately, this
	 * means we forfeit the right to access query params via match is provided by <Route>
	 * rather than our custom matchRoute function. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "route-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        // explicitly coerce undefined to string to make flow happy
        id: `routeApp.${String(route.name)}`,
        packageName: "jiraSpa",
        extraEventData: (0, $eJOHy.useMemo)(()=>({
                routeGroup: route.group ?? '',
                isSSR: false
            }), [
            route.group
        ]),
        fallback: "page",
        sendToPrivacyUnsafeSplunk: Boolean(reporting),
        ...reporting
    }, entryPoint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f2d77943b841e4c$var$SpaRouteEntryPointContainer, {
        location: location,
        action: action,
        query: query,
        route: route,
        match: match
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f2d77943b841e4c$var$SpaRouteComponent, {
        location: location,
        action: action,
        query: query,
        route: route,
        match: match
    })));
};
/**
 * Manages the routing, analytics, and remote actions within a single-page application (SPA).
 * This component sets up initial routes, enables analytics tracking, and handles SPA transitions.
 * It incorporates custom logic for page reloading or redirection under certain conditions
 * and ensures safe rendering of route components within an error boundary context.
 */ const $9f2d77943b841e4c$var$SpaNew = ({ routes: routes, initRoute: initRoute = null })=>{
    (0, $eJOHy.useMemo)(()=>{
        (0, $6uWhG.setMark)('jira-spa/view.start');
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/view', 'jira-spa/view.start', true);
    }, []);
    const location = $9f2d77943b841e4c$var$useRouterLocation();
    const action = $9f2d77943b841e4c$var$useRouterAction();
    const query = $9f2d77943b841e4c$var$useRouterQuery();
    const route = $9f2d77943b841e4c$var$useRouterRoute();
    const match = $9f2d77943b841e4c$var$useRouterMatch();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f2d77943b841e4c$var$RegisterRouterBlocks, {
        routes: routes,
        initRoute: initRoute,
        route: route,
        match: match
    }), !(route && match) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f2d77943b841e4c$var$SpaChild, {
        location: location,
        action: action,
        query: query,
        route: route,
        match: match
    }));
};
function $9f2d77943b841e4c$var$ConditionalStrictMode(props) {
    // Default to true
    const { isEnabled: isEnabled = true, children: children } = props;
    // This flag just gives us a kill switch
    if (isEnabled && (0, $7jTnu.fg)('jfp-jira-incremental-strict-mode')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.StrictMode), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
}
const $9f2d77943b841e4c$var$Spa = (0, $bJscI.componentWithFG)('jfp-magma-concurrent-entrypoint-route-stability', $9f2d77943b841e4c$var$SpaNew, $9f2d77943b841e4c$var$SpaOld);
var $9f2d77943b841e4c$export$2e2bcd8739ae039 = $9f2d77943b841e4c$var$Spa;

});
parcelRegister("grrUi", function(module, exports) {

$parcel$export(module.exports, "addLeadingSlash", () => $bf84d0b8ce74f95e$export$5b4913142e03bca8, (v) => $bf84d0b8ce74f95e$export$5b4913142e03bca8 = v);
$parcel$export(module.exports, "hasBasename", () => $bf84d0b8ce74f95e$export$10497c7ce66fcb84, (v) => $bf84d0b8ce74f95e$export$10497c7ce66fcb84 = v);
$parcel$export(module.exports, "stripBasename", () => $bf84d0b8ce74f95e$export$b69e3301ce081aa3, (v) => $bf84d0b8ce74f95e$export$b69e3301ce081aa3 = v);
$parcel$export(module.exports, "stripTrailingSlash", () => $bf84d0b8ce74f95e$export$d95b4586d238a081, (v) => $bf84d0b8ce74f95e$export$d95b4586d238a081 = v);
$parcel$export(module.exports, "parsePath", () => $bf84d0b8ce74f95e$export$8ccf933b0513f8d0, (v) => $bf84d0b8ce74f95e$export$8ccf933b0513f8d0 = v);
$parcel$export(module.exports, "createPath", () => $bf84d0b8ce74f95e$export$fe53371bee54353d, (v) => $bf84d0b8ce74f95e$export$fe53371bee54353d = v);
var $bf84d0b8ce74f95e$export$1e511d4a378977f5;
var $bf84d0b8ce74f95e$export$5b4913142e03bca8;
var $bf84d0b8ce74f95e$export$79c5b1569e3be9e6;
var $bf84d0b8ce74f95e$export$10497c7ce66fcb84;
var $bf84d0b8ce74f95e$export$b69e3301ce081aa3;
var $bf84d0b8ce74f95e$export$d95b4586d238a081;
var $bf84d0b8ce74f95e$export$8ccf933b0513f8d0;
var $bf84d0b8ce74f95e$export$fe53371bee54353d;
'use strict';
$bf84d0b8ce74f95e$export$1e511d4a378977f5 = true;
var $bf84d0b8ce74f95e$var$addLeadingSlash = $bf84d0b8ce74f95e$export$5b4913142e03bca8 = function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
};
var $bf84d0b8ce74f95e$var$stripLeadingSlash = $bf84d0b8ce74f95e$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
};
var $bf84d0b8ce74f95e$var$hasBasename = $bf84d0b8ce74f95e$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
    return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};
var $bf84d0b8ce74f95e$var$stripBasename = $bf84d0b8ce74f95e$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
    return $bf84d0b8ce74f95e$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};
var $bf84d0b8ce74f95e$var$stripTrailingSlash = $bf84d0b8ce74f95e$export$d95b4586d238a081 = function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};
var $bf84d0b8ce74f95e$var$parsePath = $bf84d0b8ce74f95e$export$8ccf933b0513f8d0 = function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
};
var $bf84d0b8ce74f95e$var$createPath = $bf84d0b8ce74f95e$export$fe53371bee54353d = function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
    return path;
};

});

parcelRegister("d8mHf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b4b2dc2ada45d83$export$2e2bcd8739ae039);

var $1JCFI = parcelRequire("1JCFI");

var $3TY2E = parcelRequire("3TY2E");

var $7HqSC = parcelRequire("7HqSC");
function $3b4b2dc2ada45d83$var$traceUFORedirect(fromUfoName, nextUfoName, nextRouteName, time) {
    (0, $7HqSC.default).current = nextUfoName;
    const interactionId = (0, $1JCFI.DefaultInteractionID).current;
    if (interactionId) (0, $3TY2E.addRedirect)(interactionId, fromUfoName, nextUfoName, nextRouteName, time);
}
var $3b4b2dc2ada45d83$export$2e2bcd8739ae039 = $3b4b2dc2ada45d83$var$traceUFORedirect;

});

parcelRegister("6dNf1", function(module, exports) {

$parcel$export(module.exports, "createCheckShouldResetPage", () => $b1964faf750423cd$export$ffb8c03de895ae3);

var $cSmYj = parcelRequire("cSmYj");

var $hMEE5 = parcelRequire("hMEE5");
const $b1964faf750423cd$var$isReplaceActionAndPIN = (action, route)=>action === 'REPLACE' && route.group === 'issue-navigator';
const $b1964faf750423cd$var$isReplaceActionAndJPD = (action, route)=>action === 'REPLACE' && route.name === 'polaris-ideas';
const $b1964faf750423cd$export$ffb8c03de895ae3 = ()=>{
    let rapidBoardPaths = [];
    return ({ currentMatch: currentMatch, currentRoute: currentRoute, nextMatch: nextMatch, nextRoute: nextRoute, action: action })=>{
        let shouldReset = true;
        if ($b1964faf750423cd$var$isReplaceActionAndPIN(action, nextRoute) || $b1964faf750423cd$var$isReplaceActionAndJPD(action, nextRoute) || currentRoute.isRedirect === true) shouldReset = false;
        else {
            const cleanMatch = (0, $hMEE5.getApdexMatchObject)(currentMatch, currentRoute);
            const cleanNextMatch = (0, $hMEE5.getApdexMatchObject)(nextMatch, nextRoute);
            shouldReset = !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(cleanMatch, cleanNextMatch) && shouldReset;
            if (shouldReset) {
                // RapidboardPaths is being persisted here.
                // resetDone boolean is calculated in the util function.
                const [paths, resetBoolean] = (0, $hMEE5.calcRapidBoardResetStateV2)(rapidBoardPaths, nextRoute.name, !!nextMatch.query.useStoredSettings);
                rapidBoardPaths = paths;
                if ((0, $hMEE5.isValidRoute)(nextRoute) || nextRoute.group === 'classic-software') shouldReset = !resetBoolean;
            }
        }
        return shouldReset;
    };
};

});
parcelRegister("hMEE5", function(module, exports) {

$parcel$export(module.exports, "calcRapidBoardResetState", () => $f519b55c78499965$export$2350ed3ff6c1a082);
$parcel$export(module.exports, "getApdexMatchObject", () => $f519b55c78499965$export$47e434f08768932b);
$parcel$export(module.exports, "calcRapidBoardResetStateV2", () => $f519b55c78499965$export$dbd9185166d0d04c);
$parcel$export(module.exports, "isValidRoute", () => $f519b55c78499965$export$9f3e656a7f6a3adc);
const $f519b55c78499965$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [
                'browse-project-redirect'
            ];
            resetDone = true;
            break;
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-backlog':
        case 'rapidboard-report':
            if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                resetDone = false;
                break;
            }
            if (!useStoredSettings && rapidBoardPaths.indexOf('browse-project-redirect') > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
            rapidBoardPaths = [];
            break;
        default:
            resetDone = false;
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $f519b55c78499965$export$47e434f08768932b = (match, route)=>{
    let cleanMatch = {
        ...match,
        params: {
            ...match.params
        },
        query: {
            ...match.query
        }
    };
    if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
        const { params: params, query: query } = match;
        const paramKeys = params && Object.keys(params);
        const queryKeys = query && Object.keys(query);
        const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
        const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
        if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
        if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
    });
    if (match.query && match.query.view && match.query.view === 'detail') // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
    cleanMatch.query.view = undefined;
    if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
    cleanMatch = {
        ...cleanMatch,
        url: ''
    };
    return cleanMatch;
};
const $f519b55c78499965$export$dbd9185166d0d04c = (boardPaths, routeName, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [];
            resetDone = true;
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-board':
        case 'rapidboard-report':
            // use search to navigate to board
            if (rapidBoardPaths.includes('browse-project-redirect') || rapidBoardPaths.includes('useStoredSettings')) {
                resetDone = true;
                rapidBoardPaths = [];
                break;
            } else if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                break;
            } else {
                rapidBoardPaths = [];
                break;
            }
        default:
            if (rapidBoardPaths.includes('browse-project-redirect')) {
                resetDone = true;
                rapidBoardPaths = [];
            }
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $f519b55c78499965$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
    if (state) {
        const { currentPage: currentPage, visitedPages: visitedPages } = state;
        const visitedPageLength = visitedPages.length;
        if (currentPage && currentPage.apps[appId]) return true;
        if (visitedPageLength === 0 || searchDepth <= 0) return false;
        for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
            if (visitedPages[visitedPageLength - i].apps[appId]) return true;
        }
    }
    return false;
};
const $f519b55c78499965$export$9f3e656a7f6a3adc = (routeToCheck)=>{
    switch(routeToCheck.name){
        case 'issue':
        case 'issue-embed':
        case 'issue-navigator':
        case 'issue-navigator-classic':
        case 'issue-navigator-core':
        case 'servicedesk-issues':
            return true;
        default:
            return false;
    }
};

});


parcelRegister("r7SLR", function(module, exports) {

$parcel$export(module.exports, "useShouldPerformAction", () => $d4bb764bbe23e4f2$export$1bfa74483a8ca772);

var $eJOHy = parcelRequire("eJOHy");

var $8XtVW = parcelRequire("8XtVW");

var $1Syge = parcelRequire("1Syge");

var $efhBY = parcelRequire("efhBY");
const $d4bb764bbe23e4f2$export$1bfa74483a8ca772 = ({ actionName: actionName })=>{
    const metas = (0, $1Syge.useMeta)();
    const remoteActions = (0, $1Syge.useRemoteActionsData)();
    const { saveActionPerformedAttempt: saveActionPerformedAttempt } = (0, $1Syge.useRemoteActionsStoreActions)();
    const [actionToPerform, setActionToPerform] = (0, $eJOHy.useState)();
    const [shouldPerformAction, setShouldPerformAction] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        // Check whether or not the action (actionName) should be performed:
        // - when the remote actions available list changes
        // - when the metas for the actions change
        const matchedAction = Object.values(remoteActions).find((action)=>{
            if (action.name !== actionName) return false;
            return true;
        });
        if (!matchedAction) return;
        setActionToPerform(matchedAction);
        setShouldPerformAction((0, $efhBY.computeShouldPerformAction)(matchedAction, metas));
    }, [
        actionName,
        remoteActions,
        metas
    ]);
    const performAction = (onSuccess, onCancel)=>{
        if (!actionToPerform) // just in case someone calls the function and don't check if they should before
        // maybe throw an error?
        return;
        const metaForAnalytics = {
            attempts: metas[actionToPerform.id]?.attemptCounts ?? 0,
            lastAttemptedAt: metas[actionToPerform.id]?.lastPerformAttemptedAt
        };
        if (shouldPerformAction) // For now, the onSuccess will handle:
        // * create analytics event
        // * fire the event
        onSuccess(actionToPerform, metaForAnalytics);
        else // For now, the onCancel will handle:
        // * create analytics event
        // * fire the event
        onCancel(actionToPerform, metaForAnalytics);
        saveActionPerformedAttempt(actionToPerform.id);
        // We just attempted to perfom the action, reset.
        setShouldPerformAction(false);
    };
    const performActionMemoized = (0, $eJOHy.useCallback)((onSuccess, onCancel)=>{
        if (!actionToPerform) // just in case someone calls the function and don't check if they should before
        // maybe throw an error?
        return;
        const metaForAnalytics = {
            attempts: metas[actionToPerform.id]?.attemptCounts ?? 0,
            lastAttemptedAt: metas[actionToPerform.id]?.lastPerformAttemptedAt
        };
        if (shouldPerformAction) // For now, the onSuccess will handle:
        // * create analytics event
        // * fire the event
        onSuccess(actionToPerform, metaForAnalytics);
        else // For now, the onCancel will handle:
        // * create analytics event
        // * fire the event
        onCancel(actionToPerform, metaForAnalytics);
        saveActionPerformedAttempt(actionToPerform.id);
        // We just attempted to perfom the action, reset.
        setShouldPerformAction(false);
    }, [
        actionToPerform,
        shouldPerformAction,
        metas,
        saveActionPerformedAttempt,
        setShouldPerformAction
    ]);
    return {
        shouldPerformAction: shouldPerformAction,
        performAction: (0, $8XtVW.fg)('jfp-magma-stability-platform-2') ? performActionMemoized : performAction
    };
};

});
parcelRegister("1Syge", function(module, exports) {

$parcel$export(module.exports, "RemoteActionsContainer", () => $623286000b95919f$export$28c2e4c663a86266);
$parcel$export(module.exports, "useRemoteActions", () => $623286000b95919f$export$333357b3de3e67a0);
$parcel$export(module.exports, "useRemoteActionsData", () => $623286000b95919f$export$3cc006661ae2a759);
$parcel$export(module.exports, "useMeta", () => $623286000b95919f$export$3fb9275d3845bd5a);
$parcel$export(module.exports, "useRemoteActionLastUpdatedAt", () => $623286000b95919f$export$1d013261a2e6e0f9);
$parcel$export(module.exports, "useRemoteActionsStoreActions", () => $623286000b95919f$export$3fd21eaf97df4718);

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
var $awqaz = parcelRequire("awqaz");

var $uX0y4 = parcelRequire("uX0y4");
// jira freezes the global defaults object
if (!Object.isFrozen((0, $awqaz.default))) (0, $awqaz.default).devtools = false;
const $623286000b95919f$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        meta: {},
        remoteActions: {},
        lastUpdatedAt: 0,
        isLoaded: false,
        product: undefined
    },
    actions: $uX0y4.actions,
    name: 'remoteActionsStore'
});
const $623286000b95919f$export$28c2e4c663a86266 = (0, $6E16M.createContainer)($623286000b95919f$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $uX0y4.actions).initStore());
        }
});
const $623286000b95919f$export$333357b3de3e67a0 = (selector)=>(0, $iJq0l.createHook)($623286000b95919f$var$Store, {
        selector: selector
    })();
const $623286000b95919f$export$3cc006661ae2a759 = (0, $iJq0l.createStateHook)($623286000b95919f$var$Store, {
    selector: (state)=>state.remoteActions
});
const $623286000b95919f$export$3fb9275d3845bd5a = (0, $iJq0l.createStateHook)($623286000b95919f$var$Store, {
    selector: (state)=>state.meta
});
const $623286000b95919f$export$1d013261a2e6e0f9 = (0, $iJq0l.createStateHook)($623286000b95919f$var$Store, {
    selector: (state)=>state.lastUpdatedAt
});
const $623286000b95919f$export$3fd21eaf97df4718 = (0, $iJq0l.createActionsHook)($623286000b95919f$var$Store);

});
parcelRegister("uX0y4", function(module, exports) {

$parcel$export(module.exports, "actions", () => $755de7819b7e2423$export$e324594224ef24da);

var $3E96Q = parcelRequire("3E96Q");

var $4M9O3 = parcelRequire("4M9O3");

var $eTOUQ = parcelRequire("eTOUQ");

var $eOVzo = parcelRequire("eOVzo");
const $755de7819b7e2423$export$e324594224ef24da = {
    processRemoteActions: $eTOUQ.processRemoteActions,
    saveActionPerformedAttempt: $eOVzo.saveActionPerformedAttempt,
    initStore: $4M9O3.initStore,
    clearActionId: $3E96Q.clearActionId
};

});
parcelRegister("3E96Q", function(module, exports) {

$parcel$export(module.exports, "clearActionId", () => $956a6a568fa8ad1f$export$8d8b492eefa9efba);

var $aTI9K = parcelRequire("aTI9K");
const $956a6a568fa8ad1f$export$8d8b492eefa9efba = (actionId)=>({ getState: getState, setState: setState }, { product: product })=>{
        const { meta: meta } = getState();
        const newMeta = {
            ...meta
        };
        delete newMeta[actionId];
        setState({
            meta: newMeta
        });
        (0, $aTI9K.writeRemoteActionsMetasToLocalStorage)(product, meta);
    };

});
parcelRegister("aTI9K", function(module, exports) {

$parcel$export(module.exports, "readRemoteActionsMetasFromLocalStorage", () => $00d8dfebbeab81d5$export$a221266a05084986);
$parcel$export(module.exports, "writeRemoteActionsMetasToLocalStorage", () => $00d8dfebbeab81d5$export$7228aaade919a8b6);
const $00d8dfebbeab81d5$export$b9e25d3c75cffd71 = 'atlassian-remote-actions';
const $00d8dfebbeab81d5$export$a221266a05084986 = (product)=>{
    try {
        return JSON.parse(localStorage.getItem(`${$00d8dfebbeab81d5$export$b9e25d3c75cffd71}.${product}`) || '{}');
    } catch (e) {
        console.warn('Could not load from localStorage', e);
        return {};
    }
};
const $00d8dfebbeab81d5$export$7228aaade919a8b6 = (product, remoteActionsMetas)=>{
    try {
        localStorage.setItem(`${$00d8dfebbeab81d5$export$b9e25d3c75cffd71}.${product}`, JSON.stringify(remoteActionsMetas));
    } catch (e) {
        console.warn('Could not load from localStorage', e);
    }
};

});


parcelRegister("4M9O3", function(module, exports) {

$parcel$export(module.exports, "initStore", () => $4d6c9fdfad78ee2a$export$41f27b3823a442c6);

var $aTI9K = parcelRequire("aTI9K");
const $4d6c9fdfad78ee2a$export$41f27b3823a442c6 = ()=>({ setState: setState }, { product: product })=>{
        // TODO Async read from Localstorage.
        setState({
            meta: (0, $aTI9K.readRemoteActionsMetasFromLocalStorage)(product),
            isLoaded: true,
            product: product
        });
    };

});

parcelRegister("eTOUQ", function(module, exports) {

$parcel$export(module.exports, "processRemoteActions", () => $73ed4e9e98e33434$export$15e69d1dd38ccaa3);

var $6g6Bp = parcelRequire("6g6Bp");
const $73ed4e9e98e33434$export$15e69d1dd38ccaa3 = (productData, remoteActionsResponse)=>({ getState: getState, setState: setState })=>{
        const { lastUpdatedAt: lastUpdatedAt, meta: meta } = getState();
        if (remoteActionsResponse.lastUpdatedAt <= lastUpdatedAt) // data has not been updated, nothing to do
        return;
        const remoteActions = remoteActionsResponse.remoteActions.reduce((updatedRemoteActions, remoteAction)=>{
            if ((0, $6g6Bp.shouldProcessRemoteAction)(remoteAction)) {
                const shouldAddAction = remoteAction.conditions.every((condition)=>(0, $6g6Bp.isActionConditionSatisfied)(productData, condition));
                if (shouldAddAction) updatedRemoteActions[remoteAction.id] = remoteAction;
            }
            // no updates
            return updatedRemoteActions;
        }, {});
        setState({
            // only keep the meta for the remote actions that are still present. This is to avoid
            // keeping stale meta which would otherwise grow indefinitely.
            meta: Object.keys(remoteActions).reduce((newMeta, id)=>{
                newMeta[id] = meta[id];
                return newMeta;
            }, {}),
            remoteActions: remoteActions,
            lastUpdatedAt: remoteActionsResponse.lastUpdatedAt
        });
    };

});
parcelRegister("6g6Bp", function(module, exports) {

$parcel$export(module.exports, "isActionConditionSatisfied", () => $8b4580234ac559b8$export$9262d8191a70c677);
$parcel$export(module.exports, "shouldProcessRemoteAction", () => $8b4580234ac559b8$export$c7cc93192d09a3d7);

var $kUD8t = parcelRequire("kUD8t");
const $8b4580234ac559b8$var$isFeatureFlagConditionSatisfied = (getFeatureFlagValue, condition)=>condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);
const $8b4580234ac559b8$var$isFeatureGateConditionSatisfied = (getFeatureGateValue, condition)=>getFeatureGateValue && condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);
const $8b4580234ac559b8$var$isBuildInAffectedRangeV2 = (getBuildKey, getBuildInfoFromKey, condition)=>{
    try {
        const { buildNumber: currentBuildNumber, buildType: currentBuildType } = getBuildInfoFromKey(getBuildKey());
        const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[0]);
        const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[1]);
        if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) return false;
        if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
    } catch (error) {
        console.warn('error while parsing a build key', error);
    }
    return false;
};
const $8b4580234ac559b8$export$9262d8191a70c677 = (productData, condition)=>{
    switch(condition.type){
        case (0, $kUD8t.ConditionType).buildRange:
            return $8b4580234ac559b8$var$isBuildInAffectedRangeV2(productData.getBuildKey, productData.getBuildInfoFromKey, condition);
        case (0, $kUD8t.ConditionType).featureFlag:
            return $8b4580234ac559b8$var$isFeatureFlagConditionSatisfied(productData.getFeatureFlagValue, condition);
        case (0, $kUD8t.ConditionType).featureGate:
            return $8b4580234ac559b8$var$isFeatureGateConditionSatisfied(productData.getFeatureGateValue, condition);
        default:
            return false;
    }
};
const $8b4580234ac559b8$export$c7cc93192d09a3d7 = (remoteAction)=>remoteAction.enabled;

});
parcelRegister("kUD8t", function(module, exports) {

$parcel$export(module.exports, "ConditionType", () => $afcdc7f040bbda41$export$748d1c753cdf4bfd);
var $afcdc7f040bbda41$export$748d1c753cdf4bfd = /*#__PURE__*/ function(ConditionType) {
    ConditionType["featureFlag"] = "featureFlag";
    ConditionType["featureGate"] = "featureGate";
    ConditionType["buildRange"] = "buildRange";
    return ConditionType;
}({});

});



parcelRegister("eOVzo", function(module, exports) {

$parcel$export(module.exports, "saveActionPerformedAttempt", () => $1060961e43842a0d$export$e3144a2e886e0e77);

var $aTI9K = parcelRequire("aTI9K");
const $1060961e43842a0d$export$e3144a2e886e0e77 = (actionId)=>({ getState: getState, setState: setState })=>{
        const { meta: meta, product: product } = getState();
        const currentAttemptCount = meta[actionId]?.attemptCounts || 0;
        const updatedMetas = {
            ...meta,
            [actionId]: {
                lastPerformAttemptedAt: Date.now(),
                attemptCounts: currentAttemptCount + 1
            }
        };
        setState({
            meta: updatedMetas
        });
        // Can not happen.
        if (!product) throw new Error('Product is not defined.');
        (0, $aTI9K.writeRemoteActionsMetasToLocalStorage)(product, updatedMetas);
    };

});



parcelRegister("efhBY", function(module, exports) {

$parcel$export(module.exports, "computeShouldPerformAction", () => $1b4e43c720b5df19$export$6e0db227c9674096);

const $1b4e43c720b5df19$export$50dbcb44bba3aa5c = 60;
const $1b4e43c720b5df19$export$b21f5a6e7051e2c2 = (actionMetas)=>{
    const now = Date.now();
    const timeDiff = now - actionMetas.lastPerformAttemptedAt;
    return timeDiff > $1b4e43c720b5df19$export$50dbcb44bba3aa5c * 1000;
};
const $1b4e43c720b5df19$export$6c7cf2cb7d75fad3 = (actionMetas)=>actionMetas.attemptCounts < (0, $24db3d0c52e0b9bb$export$f2c0b74311ada874);
const $1b4e43c720b5df19$export$6e0db227c9674096 = (action, metas)=>{
    const actionMetas = metas[action.id];
    if (!actionMetas) // No meta, we have not attempted to perform this action yet.
    return true;
    if (!$1b4e43c720b5df19$export$6c7cf2cb7d75fad3(actionMetas)) // TODO: send a "cancelled analytics event ?"
    return false;
    if (!$1b4e43c720b5df19$export$b21f5a6e7051e2c2(actionMetas)) return false;
    // All the conditions are satisfied, we can perform the action.
    return true;
};

});
const $24db3d0c52e0b9bb$export$f2b2f5ef0b498d26 = 5000;
const $24db3d0c52e0b9bb$export$f2c0b74311ada874 = 3;
const $24db3d0c52e0b9bb$export$af2ff676951003fe = 60000;
const $24db3d0c52e0b9bb$export$388bd7a7ebb11e7 = 'atlassian-remote-actions-v1';



parcelRegister("59iVY", function(module, exports) {

$parcel$export(module.exports, "default", () => $56f8476d95efed72$export$2e2bcd8739ae039);

var $cSmYj = parcelRequire("cSmYj");
/**
 * Determines the feasibility of transitioning between routes in a SPA, considering initial loads,
 * user agent constraints, and predefined route conditions. Ensures seamless navigation by
 * evaluating route matches and permissions.
 */ const $56f8476d95efed72$var$transitionValidator = (currentMatch, nextMatch)=>{
    // if we load SPA on a redirect route, we transition immediately skipping the checks
    if (!currentMatch) return true;
    // if next route missing (should not happen as we have a catch all route) or mobile, trigger reload
    if (!nextMatch) return false;
    // If we are still on same route and same match params, skip transition checks
    const isSameRoute = currentMatch.route === nextMatch.route;
    const isSameMatch = (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(currentMatch.match, nextMatch.match);
    if (isSameRoute && isSameMatch) return true;
    // check we can transition into next route
    // @ts-expect-error - TS2339 - Property 'canTransitionIn' does not exist on type 'Route'.
    const canDoNext = nextMatch.route.canTransitionIn?.(currentMatch, nextMatch) ?? true;
    if (canDoNext) return true;
    return false;
};
var $56f8476d95efed72$export$2e2bcd8739ae039 = $56f8476d95efed72$var$transitionValidator;

});

parcelRegister("jdsvc", function(module, exports) {

$parcel$export(module.exports, "RouteEntryPointContainer", () => $f4a5080f60a01447$export$3e4cdfb894377bc9);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $eSnSE = parcelRequire("eSnSE");


var $jrulJ = parcelRequire("jrulJ");

var $2dBpR = parcelRequire("2dBpR");

var $56O0g = parcelRequire("56O0g");

var $lq8Ki = parcelRequire("lq8Ki");

var $dTqD3 = parcelRequire("dTqD3");

var $fAZgY = parcelRequire("fAZgY");
const $f4a5080f60a01447$var$LOCATION = 'route-entry-point-container';
const $f4a5080f60a01447$export$fb85bbdbfb3e6869 = ()=>null;
const $f4a5080f60a01447$var$EMPTY_OBJECT = {};
const $f4a5080f60a01447$export$3e4cdfb894377bc9 = ({ location: location, route: route, match: match, action: action, query: query })=>{
    const entryPointReference = (0, $jrulJ.usePageLayoutEntryPoint)((0, $ce4cfb37df77ff19$export$900ddb492c628f48));
    // in order to show a spinner while page loading -> `route.skeleton=Spinner`
    const Skeleton = (0, $fAZgY.useMemoWithCondition)(()=>route.skeleton || $f4a5080f60a01447$export$fb85bbdbfb3e6869, [
        route.skeleton
    ], ()=>(0, $7jTnu.fg)('jfp-magma-concurrent-entrypoint-route-stability'));
    (0, $eJOHy.useEffect)(()=>{
        if (route.isRedirect) (0, $eSnSE.default).safeWarnWithoutCustomerData($f4a5080f60a01447$var$LOCATION, `EntryPoint was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    const pageId = (0, $fAZgY.useMemoWithCondition)(()=>{
        let _pageId = route.name;
        if (route.pageId) {
            if (typeof route.pageId === 'function') _pageId = route.pageId({
                route: route,
                action: action,
                location: location,
                match: match,
                query: query
            });
            else _pageId = route.pageId;
        }
        return _pageId;
    }, [
        action,
        location,
        match,
        query,
        route
    ], ()=>(0, $7jTnu.fg)('jfp-magma-concurrent-entrypoint-route-stability'));
    if (!entryPointReference) return null;
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lq8Ki.ReportSSRFailOnUse), {
        pageId: pageId,
        fallbackId: "RouteEntryPointContainer"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null));
    const page = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lq8Ki.DisableSSRFailDetection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: (0, $7jTnu.fg)('jfp-magma-concurrent-entrypoint-route-stability') ? $f4a5080f60a01447$var$EMPTY_OBJECT : {}
    }));
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null),
        name: "route_entry_point_redirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: (0, $7jTnu.fg)('jfp-magma-concurrent-entrypoint-route-stability') ? $f4a5080f60a01447$var$EMPTY_OBJECT : {}
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $56O0g.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        entryPointReference: entryPointReference,
        fallback: fallback,
        name: "route_entry_point"
    }, page)));
};

});



parcelRegister("cMOjO", function(module, exports) {

$parcel$export(module.exports, "LayoutMainWrapper", () => $f019af8d334830fa$export$712225703044cda);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $f019af8d334830fa$export$712225703044cda = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1bgi _iu1g1fl4 _2d3f16n6",
            __cmplp.className
        ])
    });
});

});


parcelRegister("aQwf0", function(module, exports) {

$parcel$export(module.exports, "MemoryMonitor", () => $d402fd4b42d466a0$export$afbeaf57d30e8397);
// Based on confluence/packages/confluence-frontend-server/src/memory-monitor.js

var $eJOHy = parcelRequire("eJOHy");

var $2Mqjh = parcelRequire("2Mqjh");

var $kfvK2 = parcelRequire("kfvK2");

var $kn2Rh = parcelRequire("kn2Rh");
const $d402fd4b42d466a0$export$ac4cd9f30299a490 = 0.8;
const $d402fd4b42d466a0$export$632c6346c3a8c3e2 = 10000; // 10 seconds
const $d402fd4b42d466a0$export$de8f032132af9697 = 4000; // issue view has ~2.5k event listeners
let $d402fd4b42d466a0$var$routeName = 'unknown';
let $d402fd4b42d466a0$var$analyticsClient = null;
let $d402fd4b42d466a0$var$memoryMonitorInterval = null;
let $d402fd4b42d466a0$var$_eventListenerCount = 0;
let $d402fd4b42d466a0$var$initializedEventListeners = false;
function $d402fd4b42d466a0$var$bytesToMB(bytes) {
    const MB = 1048576;
    return bytes / MB;
}
const $d402fd4b42d466a0$export$3b9e9fb6812d2b4e = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, no-restricted-properties, @typescript-eslint/consistent-type-assertions
    const performance = window?.performance;
    return performance?.memory;
};
const $d402fd4b42d466a0$export$20e022b37d61b084 = ()=>$d402fd4b42d466a0$var$_eventListenerCount; // for testing
function $d402fd4b42d466a0$export$5ed8144ed56e505a(client) {
    if (client) $d402fd4b42d466a0$var$analyticsClient = client;
    if (!$d402fd4b42d466a0$var$analyticsClient) return false;
    const isConcurrentEnabled = (0, $kn2Rh.getIsConcurrentEnabled)();
    const memory = $d402fd4b42d466a0$export$3b9e9fb6812d2b4e();
    if (memory) {
        const { jsHeapSizeLimit: jsHeapSizeLimit, usedJSHeapSize: usedJSHeapSize } = memory;
        const heapThreshold = jsHeapSizeLimit * $d402fd4b42d466a0$export$ac4cd9f30299a490;
        if (usedJSHeapSize > heapThreshold) $d402fd4b42d466a0$var$analyticsClient.sendOperationalEvent({
            source: 'jira-memory-monitor',
            action: 'measured',
            actionSubject: 'highHeapUsage',
            attributes: {
                heapUsagePercent: Math.floor(usedJSHeapSize / jsHeapSizeLimit * 100),
                heapUsageMB: Math.floor($d402fd4b42d466a0$var$bytesToMB(usedJSHeapSize)),
                maxHeapSizeMB: Math.floor($d402fd4b42d466a0$var$bytesToMB(jsHeapSizeLimit)),
                route: $d402fd4b42d466a0$var$routeName,
                isConcurrentEnabled: isConcurrentEnabled
            }
        });
    }
    if ($d402fd4b42d466a0$var$initializedEventListeners && $d402fd4b42d466a0$export$20e022b37d61b084() > $d402fd4b42d466a0$export$de8f032132af9697) $d402fd4b42d466a0$var$analyticsClient.sendOperationalEvent({
        source: 'jira-memory-monitor',
        action: 'measured',
        actionSubject: 'highEventListenerCount',
        attributes: {
            eventListenerCount: $d402fd4b42d466a0$export$20e022b37d61b084(),
            route: $d402fd4b42d466a0$var$routeName,
            isConcurrentEnabled: isConcurrentEnabled
        }
    });
    return true;
}
function $d402fd4b42d466a0$export$337817b784baf528() {
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    const originalRemoveEventListener = EventTarget.prototype.removeEventListener;
    if (!$d402fd4b42d466a0$var$initializedEventListeners) {
        EventTarget.prototype.addEventListener = function addEventListenerWithCounter(type, listener, options) {
            $d402fd4b42d466a0$var$_eventListenerCount++;
            originalAddEventListener.call(this, type, listener, options);
        };
        EventTarget.prototype.removeEventListener = function removeEventListenerWithCounter(type, listener, options) {
            $d402fd4b42d466a0$var$_eventListenerCount--;
            originalRemoveEventListener.call(this, type, listener, options);
        };
        $d402fd4b42d466a0$var$initializedEventListeners = true;
    }
}
function $d402fd4b42d466a0$export$76f12cc80b7fd2f3(client) {
    $d402fd4b42d466a0$var$analyticsClient = client;
    $d402fd4b42d466a0$export$337817b784baf528();
    if (!$d402fd4b42d466a0$var$memoryMonitorInterval) $d402fd4b42d466a0$var$memoryMonitorInterval = setInterval($d402fd4b42d466a0$export$5ed8144ed56e505a, $d402fd4b42d466a0$export$632c6346c3a8c3e2);
    return true;
}
function $d402fd4b42d466a0$export$d0c8b02fd4ae0022(name) {
    $d402fd4b42d466a0$var$routeName = name;
}
function $d402fd4b42d466a0$export$b35196bdb32e40c9() {
    if ($d402fd4b42d466a0$var$memoryMonitorInterval) {
        clearInterval($d402fd4b42d466a0$var$memoryMonitorInterval);
        $d402fd4b42d466a0$var$memoryMonitorInterval = null;
    }
}
const $d402fd4b42d466a0$var$MemoryMonitorClient = ()=>{
    const hasInit = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (hasInit.current) return;
        hasInit.current = true;
        (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
            const instance = client?.getInstance();
            if (instance) {
                $d402fd4b42d466a0$var$analyticsClient = instance;
                $d402fd4b42d466a0$export$76f12cc80b7fd2f3(instance);
            }
        });
        return $d402fd4b42d466a0$export$b35196bdb32e40c9;
    });
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = (0, $kfvK2.addRouteListener)((state)=>{
            $d402fd4b42d466a0$export$d0c8b02fd4ae0022(state?.route?.name ?? 'unknown');
        });
        return unsubscribe;
    }, []);
    return null;
};
const $d402fd4b42d466a0$export$afbeaf57d30e8397 = ()=>{
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d402fd4b42d466a0$var$MemoryMonitorClient, null);
};

});

parcelRegister("dvkro", function(module, exports) {

$parcel$export(module.exports, "ReadinessTracker", () => $ada2e98806faaea5$export$9be3fbb5a9e49bfe);

var $eJOHy = parcelRequire("eJOHy");

var $jEvkf = parcelRequire("jEvkf");
const $ada2e98806faaea5$export$9be3fbb5a9e49bfe = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        if (typeof window !== 'undefined') window.__JIRA_READY_STATUS = {
            started: true,
            loaded: false,
            onhold: true
        };
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            const onPageReady = ()=>{
                window.__JIRA_READY_STATUS.onhold = false;
            };
            window.addEventListener('UFO_FINISH_INTERACTION', onPageReady);
            return ()=>{
                window.removeEventListener('UFO_FINISH_INTERACTION', onPageReady);
            };
        }
    }, []);
    const [{ hasLoaded: hasLoaded }] = (0, $jEvkf.default)();
    (0, $eJOHy.useEffect)(()=>{
        if (hasLoaded) {
            if (typeof window !== 'undefined') // we track "loaded" status as jira "loading end"
            window.__JIRA_READY_STATUS.loaded = true;
        }
    }, [
        hasLoaded
    ]);
    return null;
};

});


parcelRegister("1PSAp", function(module, exports) {

$parcel$export(module.exports, "StrictMode", () => $e2fd64c5ded33d14$export$5f8d39834fd61797);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");
const $e2fd64c5ded33d14$export$5f8d39834fd61797 = ({ children: children })=>{
    // allow developers to disable strict mode for local development
    const isStrictModeDisabled = !(0, $7jTnu.fg)('jira-enable-strict-mode');
    if (isStrictModeDisabled) return children;
    // React.StrictMode usage is enabled by default
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).StrictMode, null, children);
};

});

parcelRegister("e8u2a", function(module, exports) {

$parcel$export(module.exports, "JiraRouterLinkConfiguration", () => $c164f32528a2f211$export$a580704a2f3cfca);

var $eJOHy = parcelRequire("eJOHy");

var $c9uTK = parcelRequire("c9uTK");

var $jiTA8 = parcelRequire("jiTA8");

var $7jTnu = parcelRequire("7jTnu");
const $c164f32528a2f211$export$a580704a2f3cfca = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)() && (0, $7jTnu.fg)('jira_nin_smart_link');
    if (// Links can be initially rendered with `href` not defined in some cases
    !href || typeof href === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        ref: ref,
        href: href || '#',
        ...rest,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        ref: ref,
        href: href.href,
        to: href.to,
        replace: href.replace,
        params: href.params,
        query: href.query,
        prefetch: href.prefetch,
        ...rest,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
});

});
parcelRegister("jiTA8", function(module, exports) {

$parcel$export(module.exports, "useIsEmbedMode", () => $e5c1436c84fc3f86$export$1b3c1ba6ee047da9);

var $eJOHy = parcelRequire("eJOHy");

var $Xckw8 = parcelRequire("Xckw8");

var $Xckw8 = parcelRequire("Xckw8");
const $e5c1436c84fc3f86$export$1b3c1ba6ee047da9 = ()=>(0, $eJOHy.useContext)((0, $Xckw8.EmbedModeContext));

});


parcelRegister("lmqkh", function(module, exports) {

$parcel$export(module.exports, "SpaRouter", () => $07f5b8a587569bcd$export$1029be09aa822f4a);

var $eJOHy = parcelRequire("eJOHy");

var $b2uWc = parcelRequire("b2uWc");
const $07f5b8a587569bcd$export$1029be09aa822f4a = ({ routerProps: routerProps, before: before, children: children, after: after })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2uWc.Router), routerProps, before, children, after);

});
parcelRegister("b2uWc", function(module, exports) {

$parcel$export(module.exports, "Router", () => $c986d3ecfee6a30f$export$55185c17a0fcbe46);

var $eJOHy = parcelRequire("eJOHy");

var $bkb9R = parcelRequire("bkb9R");

var $69eg7 = parcelRequire("69eg7");
const $c986d3ecfee6a30f$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
    const pluginsWithOverride = (0, $69eg7.usePlugins)({
        resourceContext: props.resourceContext,
        resourceData: props.resourceData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bkb9R.Router), {
        plugins: pluginsWithOverride,
        ...props
    }, children);
};

});
parcelRegister("69eg7", function(module, exports) {

$parcel$export(module.exports, "usePlugins", () => $e6f8221df2b34d82$export$c41e96fd89bc6106);

var $eJOHy = parcelRequire("eJOHy");

var $l7yIU = parcelRequire("l7yIU");

var $7zZ4w = parcelRequire("7zZ4w");

var $lvKO5 = parcelRequire("lvKO5");

var $9NORu = parcelRequire("9NORu");
const $e6f8221df2b34d82$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    // make sure "plugins" are created only once, ignore prop change/rerender
    const [pluginsWithOverride] = (0, $eJOHy.useState)(()=>{
        const jiraPlugins = [];
        const resourcesPlugin = (0, $9NORu.createResourcesPlugin)({
            context: resourceContext,
            resourceData: resourceData
        });
        jiraPlugins.push(resourcesPlugin);
        jiraPlugins.push((0, $l7yIU.createEntryPointsPlugin)({
            environment: (0, $7zZ4w.default)(),
            entryPointParams: {
                tenantContext: tenantContext
            }
        }));
        return jiraPlugins;
    });
    return pluginsWithOverride;
};

});
parcelRegister("l7yIU", function(module, exports) {

$parcel$export(module.exports, "createEntryPointsPlugin", () => $876ec2c11a9ab638$export$33586718f82f356f);

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $fdqlv = parcelRequire("fdqlv");

var $jgV2J = parcelRequire("jgV2J");

var $4h7KW = parcelRequire("4h7KW");

var $i0DIU = parcelRequire("i0DIU");

var $2SVUj = parcelRequire("2SVUj");
const $876ec2c11a9ab638$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams })=>({
        id: 'entry-points-plugin',
        routeLoad: ({ context: context })=>{
            const entryPoint = context.route.entryPoint?.();
            const prefetchingRoute = (0, $jgV2J.getPrefetchingRoute)();
            let entryPointReference = null;
            if (entryPoint) {
                // check if route EntryPoint is already prefetched right before being loaded
                if (prefetchingRoute && (0, $fdqlv.isSameRouteMatch)({
                    prevContextMatch: prefetchingRoute.routerContext.match,
                    nextContextMatch: context.match
                }) && !(0, $fdqlv.isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                else {
                    const entryPointParamsWithContext = {
                        context: context,
                        ...entryPointParams
                    };
                    const loadEntryPointsWithContext = ()=>(0, $j4oe4.loadEntryPoint)({
                            getEnvironment: ()=>environment
                        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        entryPoint, entryPointParamsWithContext);
                    entryPointReference = false && (0, $7jTnu.fg)('jira-ssr-prevent-prewarming-entrypoint-in-prefetch') ? (0, $2SVUj.default)(entryPoint, entryPointParamsWithContext, loadEntryPointsWithContext) : loadEntryPointsWithContext();
                }
            }
            // saving entryPointReference helps to prevent cases when same EntryPoint is fetched multiple times
            // important when fetchPolicy=network-only is used
            (0, $jgV2J.getEntryPointsStore)().actions.setLastLoadedRoute({
                route: context.route,
                entryPointReference: entryPointReference
            });
            return {
                entryPoint: entryPointReference
            };
        },
        routePrefetch: ({ nextContext: nextContext })=>{
            const entryPoint = nextContext.route.entryPoint?.();
            if (entryPoint) {
                const prevPrefetchingRoute = (0, $jgV2J.getPrefetchingRoute)();
                // check if EntryPoint is already prefetched and not expired
                if (prevPrefetchingRoute && (0, $fdqlv.isSameRouteMatch)({
                    prevContextMatch: prevPrefetchingRoute.routerContext.match,
                    nextContextMatch: nextContext.match
                }) && !(0, $fdqlv.isExpired)(prevPrefetchingRoute.expiresAt)) return;
                const entryPointReference = (0, $j4oe4.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                entryPoint, {
                    context: nextContext,
                    ...entryPointParams
                });
                (0, $jgV2J.getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: (0, $fdqlv.getExpiresAt)(),
                    entryPointReference: entryPointReference
                });
            } else (0, $jgV2J.getEntryPointsStore)().actions.setPrefetchingRoute({
                routerContext: nextContext,
                expiresAt: 0,
                entryPointReference: null
            });
        },
        waitForEntryPoint: ()=>{
            const lastLoadedRoute = (0, $jgV2J.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $4h7KW.waitForEntryPoint)(entryPointReference);
            return Promise.resolve();
        },
        getStats: async ()=>{
            const lastLoadedRoute = (0, $jgV2J.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $i0DIU.getEntryPointStats)(entryPointReference);
            return [];
        }
    });

});
parcelRegister("fdqlv", function(module, exports) {

$parcel$export(module.exports, "getExpiresAt", () => $d7fcca574f4da31a$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "isExpired", () => $d7fcca574f4da31a$export$57947cfd429801a2);
$parcel$export(module.exports, "isSameRouteMatch", () => $d7fcca574f4da31a$export$5997e70fc4543270);
const $d7fcca574f4da31a$export$37d3126be6549b13 = 10000;
const $d7fcca574f4da31a$export$b65d7ba7fbf150f1 = ()=>$d7fcca574f4da31a$export$37d3126be6549b13 + Date.now();
const $d7fcca574f4da31a$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
const $d7fcca574f4da31a$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $d7fcca574f4da31a$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $d7fcca574f4da31a$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $d7fcca574f4da31a$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});

parcelRegister("4h7KW", function(module, exports) {

$parcel$export(module.exports, "waitForEntryPoint", () => $a184a76db2ef2fa5$export$944f853f194e5dd5);

var $7797X = parcelRequire("7797X");
const $a184a76db2ef2fa5$export$944f853f194e5dd5 = (entryPointConfig)=>{
    const promises = [];
    try {
        entryPointConfig.getComponent();
    } catch (err) {
        if (err instanceof Promise) promises.push(err);
        else throw err;
    }
    const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
    if (queries) Object.keys(queries).forEach((key)=>{
        if (queries[key].id) {
            const queryPromise = (0, $7797X.QueryPromisesMap).get(String(queries[key].id));
            if (queryPromise) promises.push(queryPromise);
        }
    });
    if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
        const nestedEntryPointPromise = $a184a76db2ef2fa5$export$944f853f194e5dd5(entryPoints[key]);
        promises.push(nestedEntryPointPromise);
    });
    return Promise.allSettled(promises);
};

});

parcelRegister("i0DIU", function(module, exports) {

$parcel$export(module.exports, "getEntryPointStats", () => $58eb3ec1d460bae6$export$ee016802bdebb378);

var $7797X = parcelRequire("7797X");
const $58eb3ec1d460bae6$export$14ba46fa7bd4c0a9 = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
const $58eb3ec1d460bae6$export$982a0a12103fb99f = async (promise)=>{
    if (!promise) return 'resolved';
    try {
        if (await Promise.race([
            promise,
            Promise.resolve('timeout')
        ]) === 'timeout') return 'pending';
        return 'resolved';
    } catch (e) {
        return 'rejected';
    }
};
const $58eb3ec1d460bae6$var$getEntrypointQueryState = async (queryId)=>{
    const queryPromise = (0, $7797X.QueryPromisesMap).get(queryId);
    return {
        queryId: queryId,
        status: await $58eb3ec1d460bae6$export$982a0a12103fb99f(queryPromise)
    };
};
const $58eb3ec1d460bae6$export$ee016802bdebb378 = (entryPointConfig)=>{
    const result = [];
    const analyseEntrypoint = ({ queries: queries, entryPoints: entryPoints })=>{
        if (queries) Object.keys(queries).forEach((key)=>{
            if (queries[key].id) result.push($58eb3ec1d460bae6$var$getEntrypointQueryState(String(queries[key].id)));
        });
        if (entryPoints) Object.entries(entryPoints).forEach(([, entryPoint])=>{
            analyseEntrypoint(entryPoint);
        });
    };
    analyseEntrypoint(entryPointConfig);
    return Promise.all(result);
};

});

parcelRegister("2SVUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fbdf54c610441d8$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7jTnu = parcelRequire("7jTnu");

var $j3Ybe = parcelRequire("j3Ybe");

var $72rfN = parcelRequire("72rfN");

var $j9bXh = parcelRequire("j9bXh");

// eslint-disable-next-line jira/jira-ssr/wrong-entrypoint-usage
const $2fbdf54c610441d8$var$DummyAsyncModule = (0, $j3Ybe.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("j9bXh"))), {
    moduleId: "7d80bb6f",
    moduleName: "ReactFragment",
    priority: "userVisible"
} // using a real async import to make the js-resource transformers/babel-plugins happy
);
$2fbdf54c610441d8$var$DummyAsyncModule.getModuleIfRequired = ()=>(0, $j9bXh.default); // prevent attempts to fetch the module async at all

/**
 * Run a given loadEntryPoint function without loading the entrypoint modules, then load them right afterwards.
 *
 * This is to prevent triggering the loading of entrypoints modules inline with the data fetching.
 * When JS modules are inline-required (such as in SSR when async modules are converted to inline-requires)
 * this leads to inline-evaluating all dependencies for large component modules before kicking off the data for them.
 * This causes a measurable performance hit (~20-80ms in many cases) before we even kick off critical data fetches.
 *
 * Deferring the module loading until after the data fetching allows the module execution to occur in the less critical
 * idle time while waiting for data fetches to return.
 */ function $2fbdf54c610441d8$var$loadEntryPointDataThenModules(entryPoint, entryPointParams, loadEntryPointCallback) {
    const originalModulesByEntrypointRef = new Map();
    (0, $72rfN.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
        originalModulesByEntrypointRef.set(loopingEntryPoint, loopingEntryPoint.root);
        // eslint-disable-next-line no-param-reassign
        loopingEntryPoint.root = $2fbdf54c610441d8$var$DummyAsyncModule;
    });
    try {
        return loadEntryPointCallback();
    } finally{
        (0, $72rfN.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
            const originalModule = originalModulesByEntrypointRef.get(loopingEntryPoint);
            if (!originalModule) throw new Error('Original module not found for entrypoint');
            // eslint-disable-next-line no-param-reassign
            loopingEntryPoint.root = originalModule;
        });
        // Kicks off the loading of the original modules as they would have, but after the data fetches have been started
        // Without this, entrypoints may have trouble rendering
        // Wrap it in a promise to prevent it from affecting timers that start synchronously after this function
        Promise.resolve().then(function() {
            return Promise.resolve((parcelRequire("j9bXh")));
        }).then((res)=>originalModulesByEntrypointRef.forEach((entryPointModule)=>{
                // Essentially we've updated the JSResourceReference in react-async to have the right types
                // but react-entrypoint takes the types from @types/react-relay which lacks the new methods
                // So instead of adjusting it for everyone, manually casting it here reduces the blast radius significantly
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const typedEntryPointModule = entryPointModule;
                if (typedEntryPointModule.getPriority() !== 'userVisible' && (0, $7jTnu.fg)('jfp-magma-remove-non-uservisible-content-runtime')) // console logging so we can track it in SSR as fireErrorAnalytics is not available
                // eslint-disable-next-line no-console
                console.log(JSON.stringify({
                    message: 'Wrong entrypoint priority has been used',
                    path: typedEntryPointModule.getModulePath(),
                    priority: typedEntryPointModule.getPriority()
                }));
                const jsModule = entryPointModule.getModuleIfRequired();
                if (jsModule != null) return;
                entryPointModule.load();
            }));
    }
}
var $2fbdf54c610441d8$export$2e2bcd8739ae039 = $2fbdf54c610441d8$var$loadEntryPointDataThenModules;

});
parcelRegister("72rfN", function(module, exports) {

$parcel$export(module.exports, "default", () => $323aa376cd597090$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Recursively run through all nested entrypoints with a given callback
 */ function $323aa376cd597090$var$forAllEntryPoints(entryPoint, entryPointParams, callback) {
    callback(entryPoint);
    const preloadProps = entryPoint.getPreloadProps(entryPointParams);
    const entryPoints = preloadProps.entryPoints;
    if (!entryPoints) return;
    Object.values(entryPoints).forEach(({ entryPoint: nestedEntryPoint, entryPointParams: nestedParams })=>{
        if (nestedEntryPoint) $323aa376cd597090$var$forAllEntryPoints(nestedEntryPoint, nestedParams, callback);
    });
}
var $323aa376cd597090$export$2e2bcd8739ae039 = $323aa376cd597090$var$forAllEntryPoints;

});

parcelRegister("j9bXh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f91987f11478cff3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $f91987f11478cff3$var$ReactFragment = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
var $f91987f11478cff3$export$2e2bcd8739ae039 = $f91987f11478cff3$var$ReactFragment;

});



parcelRegister("9NORu", function(module, exports) {

$parcel$export(module.exports, "createResourcesPlugin", () => $35412eb3a33b365b$export$23ed892c481a96fe);

var $uCHeL = parcelRequire("uCHeL");

var $dqruy = parcelRequire("dqruy");
const $35412eb3a33b365b$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $35412eb3a33b365b$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $uCHeL.getResourceStore)().actions;
    const nextResources = (0, $dqruy.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $35412eb3a33b365b$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $uCHeL.getResourceStore)().actions;
    const nextResources = (0, $dqruy.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $35412eb3a33b365b$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $uCHeL.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $35412eb3a33b365b$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $35412eb3a33b365b$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $35412eb3a33b365b$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $uCHeL.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $uCHeL.getResourceStore)().actions;
            const nextResources = (0, $dqruy.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $uCHeL.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("dqruy", function(module, exports) {

$parcel$export(module.exports, "getResourcesForNextLocation", () => $1a8b7e47babf72f8$export$7cbbc763e2f3d65d);

var $hzgsc = parcelRequire("hzgsc");

var $8Jtan = parcelRequire("8Jtan");
const $1a8b7e47babf72f8$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $8Jtan.routeHasResources)(nextRoute)) return [];
    if ((0, $8Jtan.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $hzgsc.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $hzgsc.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("hzgsc", function(module, exports) {

$parcel$export(module.exports, "getResourceIdentifier", () => $729abb4a5d40de0d$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $729abb4a5d40de0d$export$cd7fbe7e979df558);
const $729abb4a5d40de0d$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $729abb4a5d40de0d$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$729abb4a5d40de0d$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("8Jtan", function(module, exports) {

$parcel$export(module.exports, "routeHasResources", () => $5cc875e1fdc3f713$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $5cc875e1fdc3f713$export$221027ff1aa38f82);
const $5cc875e1fdc3f713$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $5cc875e1fdc3f713$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});






parcelRegister("7grfV", function(module, exports) {

$parcel$export(module.exports, "default", () => $adf60ba773b1f455$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $KQtrs = parcelRequire("KQtrs");

var $8dH3d = parcelRequire("8dH3d");

var $JdXiI = parcelRequire("JdXiI");

var $hWeHP = parcelRequire("hWeHP");

var $jJaSe = parcelRequire("jJaSe");

var $96Fb4 = parcelRequire("96Fb4");

var $hcKUA = parcelRequire("hcKUA");

var $5M2Lz = parcelRequire("5M2Lz");
const $adf60ba773b1f455$var$sessionQueryParams = [
    'searchSessionId',
    'searchObjectId',
    'searchContainerId',
    'searchContentType'
];
const $adf60ba773b1f455$var$sessionMeta = [
    'ajs-search-session-id',
    'ajs-search-object-id',
    'ajs-search-container-id',
    'ajs-search-content-type'
];
const $adf60ba773b1f455$var$removeDwellComponent = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const element = document.getElementById(placeholderId);
    if (placeholderId && element) (0, $aQK2r.unmountComponentAtNode)(element);
};
const $adf60ba773b1f455$var$removeSessionMeta = ()=>$adf60ba773b1f455$var$sessionMeta.forEach((0, $hcKUA.removeMetaTag));
// @ts-expect-error - TS7031 - Binding element 'sessionId' implicitly has an 'any' type. | TS7031 - Binding element 'objectId' implicitly has an 'any' type. | TS7031 - Binding element 'containerId' implicitly has an 'any' type. | TS7031 - Binding element 'objectType' implicitly has an 'any' type.
const $adf60ba773b1f455$var$addSessionMeta = ({ sessionId: sessionId, objectId: objectId, containerId: containerId, objectType: objectType })=>{
    const newMeta = {
        'ajs-search-session-id': sessionId,
        'ajs-search-object-id': objectId,
        'ajs-search-container-id': containerId,
        'ajs-search-content-type': objectType
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(newMeta).forEach(([name, content])=>(0, $hcKUA.addMetaTag)(name, content));
};
const $adf60ba773b1f455$var$getPreviousSessionId = ()=>(0, $hWeHP.default)('ajs-search-session-id');
class $adf60ba773b1f455$export$f1e582dddb502dd6 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.onClearSessionEvent = ()=>{
            if (this.state.shouldRemoveSessionBeIgnored) this.setState({
                shouldRemoveSessionBeIgnored: false
            });
        }, this.onHistoryChange = (location)=>{
            $adf60ba773b1f455$var$removeDwellComponent('search-dwell-time');
            const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($KQtrs))).parse(location.pathname + location.search, true);
            const queryString = parsedUrl.query || {};
            const { searchSessionId: searchSessionId, searchObjectId: searchObjectId, searchContainerId: searchContainerId, searchContentType: searchContentType } = queryString;
            const { path: path } = parsedUrl;
            const previousSessionId = $adf60ba773b1f455$var$getPreviousSessionId();
            const { shouldRemoveSessionBeIgnored: shouldRemoveSessionBeIgnored } = this.state;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(previousSessionId) && !shouldRemoveSessionBeIgnored) $adf60ba773b1f455$var$removeSessionMeta();
            if (searchSessionId) {
                (0, $JdXiI.default)($adf60ba773b1f455$var$sessionQueryParams);
                const newState = {
                    sessionId: searchSessionId,
                    objectId: searchObjectId,
                    objectType: searchContentType,
                    containerId: searchContainerId,
                    previousSessionId: $adf60ba773b1f455$var$getPreviousSessionId()
                };
                $adf60ba773b1f455$var$addSessionMeta(newState);
                const shouldRemoveSession = !!(0, $5M2Lz.skipClearSessionURLs).find((skipUrlRegex)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(path) ? skipUrlRegex.test(path) : false);
                // @ts-expect-error - TS2345 - Argument of type '{ shouldRemoveSessionBeIgnored: boolean; sessionId: string | string[]; objectId: string | string[] | undefined; objectType: string | string[] | undefined; containerId: string | string[] | undefined; previousSessionId: string | null; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "containerId" | "objectType" | "objectId" | "sessionId" | "previousSessionId" | "shouldRemoveSessionBeIgnored"> | null) | Pick<...> | null'.
                this.setState({
                    ...newState,
                    shouldRemoveSessionBeIgnored: shouldRemoveSession
                });
            }
        };
        this.props.history.listen(this.onHistoryChange);
        this.state = {
            shouldRemoveSessionBeIgnored: false,
            sessionId: ''
        };
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener((0, $5M2Lz.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener((0, $5M2Lz.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    render() {
        if (this.state && this.state.sessionId) {
            const { objectId: objectId, containerId: containerId, objectType: objectType, sessionId: sessionId, previousSessionId: previousSessionId } = this.state;
            const data = {
                objectId: objectId,
                containerId: containerId,
                objectType: objectType,
                source: objectType,
                actionSubject: objectType,
                attributes: {
                    previousSessionId: previousSessionId
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $96Fb4.default), {
                sessionId: sessionId,
                data: data
            });
        }
        return null;
    }
}
var $adf60ba773b1f455$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)($adf60ba773b1f455$export$f1e582dddb502dd6);

});
parcelRegister("JdXiI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1745b16040d0e430$export$2e2bcd8739ae039);

var $KQtrs = parcelRequire("KQtrs");

var $jFHCE = parcelRequire("jFHCE");
var /**
 * Use to remove query params from url without reload or change history
 * One use case is to remove any tracking id from the url to avoid problems in copy & paste urls or sharing links between users
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$1745b16040d0e430$export$2e2bcd8739ae039 = (paramsToStrip)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($KQtrs))).parse(window.location.href, true);
        const strippedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(parsedUrl.query || {}, paramsToStrip);
        let strippedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($KQtrs))).format({
            ...parsedUrl,
            search: undefined,
            query: strippedQuery
        });
        // we don't want to encode : to %3A in connect project pages
        const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.search);
        if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.history.replaceState({}, '', strippedUrl);
    } catch (e) {
    /* uri might be malformed */ }
};

});

parcelRegister("96Fb4", function(module, exports) {

$parcel$export(module.exports, "default", () => $778b4a13c0a09b07$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eq3Hf = parcelRequire("eq3Hf");

var $BwaQq = parcelRequire("BwaQq");

var $7iHUq = parcelRequire("7iHUq");


var $2x61s = parcelRequire("2x61s");
const $778b4a13c0a09b07$var$defaultSource = 'dwellComponent';
const $778b4a13c0a09b07$var$defaultActionSubject = 'dwellComponent';
const $778b4a13c0a09b07$var$getDwellComponent = (source, actionSubject)=>(0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $BwaQq.AnalyticsSubject)(actionSubject || $778b4a13c0a09b07$var$defaultActionSubject), (0, $BwaQq.AnalyticsSource)(source || $778b4a13c0a09b07$var$defaultSource, (0, $466f60259c330878$export$f636b5b56f1d624a)))((0, $2x61s.default));
class $778b4a13c0a09b07$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static getDerivedStateFromProps(props) {
        const { data: data } = props;
        return {
            DwellTimeComponent: $778b4a13c0a09b07$var$getDwellComponent(data.source, data.actionSubject)
        };
    }
    constructor(props){
        super(props);
        this.state = {
            DwellTimeComponent: null
        };
    }
    render() {
        const { sessionId: sessionId, data: data } = this.props;
        const { DwellTimeComponent: DwellTimeComponent } = this.state;
        const enrichedData = {
            ...data,
            source: data && data.source || $778b4a13c0a09b07$var$defaultSource,
            actionSubject: data && data.actionSubject || $778b4a13c0a09b07$var$defaultActionSubject
        };
        if (sessionId && DwellTimeComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DwellTimeComponent, {
            sessionId: sessionId,
            data: enrichedData
        }));
        return null;
    }
}

});
parcelRegister("2x61s", function(module, exports) {

$parcel$export(module.exports, "default", () => $68505db1eb5cfa8c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8dhoK = parcelRequire("8dhoK");

var $aBFKZ = parcelRequire("aBFKZ");

var $2ZYsz = parcelRequire("2ZYsz");
class $68505db1eb5cfa8c$export$1c7ccff61c195c75 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { data: data, sessionId: sessionId } = this.props;
        // @ts-expect-error - TS2741 - Property 'prototype' is missing in type 'DwellTimeHelper' but required in type 'typeof DwellTimeHelper'.
        this.dwellHelper = new (0, $8dhoK.default)(this.sendDwellEvent, data, sessionId);
        // @ts-expect-error - TS2339 - Property 'start' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.start();
    }
    componentDidUpdate(oldProps) {
        if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) // @ts-expect-error - TS2339 - Property 'newPage' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.newPage(this.props.data, this.props.sessionId);
    }
    componentWillUnmount() {
        if (this.dwellHelper) {
            // @ts-expect-error - TS2339 - Property 'stop' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.stop();
            // @ts-expect-error - TS2339 - Property 'destroy' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.destroy();
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, this.props.children);
    }
    constructor(...args){
        super(...args), this.sendDwellEvent = (payload)=>(0, $2ZYsz.fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
    }
}
var $68505db1eb5cfa8c$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('dwellTime', {
    onDwell: 'dwelled'
})($68505db1eb5cfa8c$export$1c7ccff61c195c75);

});
parcelRegister("2ZYsz", function(module, exports) {

$parcel$export(module.exports, "fireTrackAnalytics", () => $1abd420c0e1cdad5$export$13990ad4625571ed);

var $9pL9Y = parcelRequire("9pL9Y");

var $iM63C = parcelRequire("iM63C");

var $5nSuO = parcelRequire("5nSuO");
const $1abd420c0e1cdad5$var$isNotUndefined = (a)=>a !== undefined;
const $1abd420c0e1cdad5$var$mapPayload = (payload)=>{
    const context = (0, $5nSuO.default)(payload);
    const { action: action, actionSubjectId: actionSubjectId } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        action: action,
        actionSubjectId: actionSubjectId
    }, $1abd420c0e1cdad5$var$isNotUndefined);
};
const $1abd420c0e1cdad5$export$13990ad4625571ed = (event, payload)=>{
    event.update({
        ...$1abd420c0e1cdad5$var$mapPayload(payload),
        analyticsType: (0, $iM63C.TRACK_EVENT_TYPE)
    }).fire();
};

});



parcelRegister("hcKUA", function(module, exports) {

$parcel$export(module.exports, "addMetaTag", () => $69d894647c7a1ca5$export$c79fd820617d7f);
$parcel$export(module.exports, "removeMetaTag", () => $69d894647c7a1ca5$export$4267657a25105d9d);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
const $69d894647c7a1ca5$export$c9d44c736471c518 = (name)=>document.querySelector(`meta[name="${name}"]`);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $69d894647c7a1ca5$var$getHead = ()=>document.head || document.querySelector('head');
const $69d894647c7a1ca5$export$c79fd820617d7f = (name, content)=>{
    if (!name || !content) return;
    const existingMeta = $69d894647c7a1ca5$export$c9d44c736471c518(name);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const meta = document.createElement('meta');
    meta.name = name;
    meta.content = content;
    if (existingMeta) existingMeta.parentNode?.replaceChild(meta, existingMeta);
    else {
        const head = $69d894647c7a1ca5$var$getHead();
        if (head) head.appendChild(meta);
    }
};
const $69d894647c7a1ca5$export$4267657a25105d9d = (name)=>{
    const meta = $69d894647c7a1ca5$export$c9d44c736471c518(name);
    if (meta) meta.parentNode?.removeChild(meta);
};

});

parcelRegister("5M2Lz", function(module, exports) {

$parcel$export(module.exports, "CLEAR_SEARCH_SESSION", () => $75d3ffa3b93cfd1e$export$b669eaa3e4786d5c);
$parcel$export(module.exports, "skipClearSessionURLs", () => $75d3ffa3b93cfd1e$export$c092460ed33e0e35);
const $75d3ffa3b93cfd1e$export$b669eaa3e4786d5c = 'CLEAR_SEARCH_SESSION';
const $75d3ffa3b93cfd1e$export$c092460ed33e0e35 = [
    /.*RapidBoard.jspa.*/,
    /\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/,
    /\/jira\/people\/.*\/boards\/.*/
];

});


parcelRegister("fmwpb", function(module, exports) {

$parcel$export(module.exports, "addInitialPageLoadTimings", () => $6e1c80b102e9f6bf$export$ce440b3d0fa0d5ed);

var $7jTnu = parcelRequire("7jTnu");

var $dydef = parcelRequire("dydef");

var $aoN86 = parcelRequire("aoN86");
const $6e1c80b102e9f6bf$export$ce440b3d0fa0d5ed = ()=>{
    if (false) return;
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('early-flush', 'ssr.spa.early-common-flush:start', 'ssr.spa.early-route-flush:end');
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/metatags', 'ssr.spa.metatags:start', 'ssr.spa.metatags:end');
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig:start', 'ssr.spa.statsig:end');
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig-gate-values:start', 'ssr.spa.statsig-gate-values:end');
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig-parse', 'statsig-parse:start', 'statsig-parse:end');
    // In legacy SSR, parsing happens inline with processing the flush. In modern SSR or static fallback scenarios for legacy SSR, the parse will be timed seperately.
    // What we want to avoid is confusing people with a "parse timer" in legacy SSR breakdown charts that doesn't overlap with the "statsig" timer (without this timer entry that would happen and it would have a very low volume, but it would distract people during perf-investigations)
    // This will make the statsig-parse timer fully overlap with "statsig" when the parsing happens inline, and will start at a different time otherwise
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig-parse', 'ssr.spa.statsig:start', 'ssr.spa.statsig:start');
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts-common', 'ssr.spa.inline-assets:start', 'ssr.spa.inline-assets:end');
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts-route', 'ssr.spa.async-inline-assets:start', 'ssr.spa.async-inline-assets:end');
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/css-assets', 'ssr.spa.css-assets:start', 'ssr.spa.css-assets:end');
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/feature-flags', 'ssr.spa.feature-flags:start', 'ssr.spa.feature-flags:end');
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/route-preload', 'ssr.spa.early-route-flush:start', 'ssr.spa.early-route-flush:end');
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output', 'ssr.spa.start', 'ssr.spa.state');
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/styles', 'ssr.spa.start', 'ssr.spa.styles');
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/html', 'ssr.spa.styles', 'ssr.spa.html');
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/state', 'ssr.spa.html', 'ssr.spa.state');
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/language-pack', 'jira-spa/language-pack.start', 'jira-spa/language-pack.end', true, true);
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    (0, $7jTnu.fg)('add-loading-bundles-span-initial-load') && (0, $aoN86.observePreloadedBundlesProgress)();
};

});
parcelRegister("aoN86", function(module, exports) {

$parcel$export(module.exports, "observePreloadedBundlesProgress", () => $54bb96c95b67335d$export$2169bfe6cd4f4439);

var $cQGWy = parcelRequire("cQGWy");
let $54bb96c95b67335d$var$po = null;
let $54bb96c95b67335d$var$timeout = null;
let $54bb96c95b67335d$var$started = false;
const $54bb96c95b67335d$export$2169bfe6cd4f4439 = ()=>{
    if (false || $54bb96c95b67335d$var$started || !globalThis.PerformanceObserver) return;
    $54bb96c95b67335d$var$started = true;
    const expectedEntries = new Set(Array.from(globalThis.document?.querySelectorAll?.('link[rel=modulepreload]') || []).map((el)=>el.getAttribute('href')).filter((url)=>url?.includes('jira-frontend-bifrost')));
    /* eslint-disable @typescript-eslint/consistent-type-assertions */ const loadedResources = Array.from(globalThis.performance?.getEntriesByType('resource')).filter(({ name: name })=>{
        if (expectedEntries.has(name)) {
            expectedEntries.delete(name);
            return true;
        }
        return false;
    });
    if (expectedEntries.size > 0) {
        $54bb96c95b67335d$var$timeout = setTimeout(()=>{
            $54bb96c95b67335d$var$po?.disconnect();
        }, 30000);
        $54bb96c95b67335d$var$po = new PerformanceObserver((entry)=>{
            entry.getEntries().forEach((e)=>{
                if (expectedEntries.has(e.name)) {
                    expectedEntries.delete(e.name);
                    loadedResources.push(e);
                }
                if (expectedEntries.size === 0) {
                    $54bb96c95b67335d$var$timeout !== null && clearTimeout($54bb96c95b67335d$var$timeout);
                    $54bb96c95b67335d$var$po?.disconnect();
                    $54bb96c95b67335d$var$processCapturedData(loadedResources);
                }
            });
        });
    } else $54bb96c95b67335d$var$processCapturedData(loadedResources);
/* eslint-enable @typescript-eslint/consistent-type-assertions */ };
const $54bb96c95b67335d$var$determineMinAndMax = (agg, entry)=>{
    if (agg.min === null || entry.startTime < agg.min) // eslint-disable-next-line no-param-reassign
    agg.min = entry.startTime;
    if (agg.max === null || entry.responseEnd > agg.max) // eslint-disable-next-line no-param-reassign
    agg.max = entry.responseEnd;
};
const $54bb96c95b67335d$var$processCapturedData = (loadedResources)=>{
    const { all: all, common: common, route: route } = loadedResources.reduce((agg, entry)=>{
        $54bb96c95b67335d$var$determineMinAndMax(agg.all, entry);
        if ($54bb96c95b67335d$var$isCommon(entry)) $54bb96c95b67335d$var$determineMinAndMax(agg.common, entry);
        else $54bb96c95b67335d$var$determineMinAndMax(agg.route, entry);
        return agg;
    }, {
        all: {
            max: null,
            min: null
        },
        common: {
            max: null,
            min: null
        },
        route: {
            max: null,
            min: null
        }
    });
    if (all.max === null || all.min === null) return;
    $54bb96c95b67335d$var$setTimings('preloading-bundles', all);
    $54bb96c95b67335d$var$setTimings('preloading-bundles/common', common);
    $54bb96c95b67335d$var$setTimings('preloading-bundles/route', route);
};
const $54bb96c95b67335d$var$isCommon = (entry)=>{
    const url = entry.name;
    const hasJiraSpa = url.includes('jira-spa');
    const isSharedWithoutNav = url.includes('/shared') && !url.includes('atlassian-navigation');
    const isNavWithVendor = url.includes('atlassian-navigation') && url.includes('vendor');
    return (hasJiraSpa || isSharedWithoutNav || isNavWithVendor) && url.endsWith('.js');
};
const $54bb96c95b67335d$var$setTimings = (label, { min: min, max: max })=>{
    if (max === null || min === null) return;
    const startMark = `${label}-start`;
    const stopMark = `${label}-end`;
    performance.mark(startMark, {
        startTime: min
    });
    performance.mark(stopMark, {
        startTime: max
    });
    (0, $cQGWy.addTimingFromPerformanceMark)(label, startMark, stopMark, true, true);
};

});


parcelRegister("gNSxk", function(module, exports) {

$parcel$export(module.exports, "setPrefetchStartMark", () => $7e18a8aa366ad472$export$405fde3eab8e39f6);
$parcel$export(module.exports, "getPrefetchStartMark", () => $7e18a8aa366ad472$export$cbaceb7ffa84279);
$parcel$export(module.exports, "clearPrefetchStartMarks", () => $7e18a8aa366ad472$export$d6b0928f07bafe57);
const $7e18a8aa366ad472$var$prefetchTiming = new Map();
const $7e18a8aa366ad472$export$405fde3eab8e39f6 = (match)=>{
    const currentMatch = JSON.stringify(match);
    if (!$7e18a8aa366ad472$var$prefetchTiming.has(currentMatch)) $7e18a8aa366ad472$var$prefetchTiming.set(currentMatch, {
        startPrefetchTime: Date.now()
    });
};
const $7e18a8aa366ad472$export$cbaceb7ffa84279 = (match)=>{
    const currentMatch = JSON.stringify(match);
    const { startPrefetchTime: startPrefetchTime } = $7e18a8aa366ad472$var$prefetchTiming.get(currentMatch) || {
        startPrefetchTime: null
    };
    return startPrefetchTime;
};
const $7e18a8aa366ad472$export$d6b0928f07bafe57 = (match)=>{
    if (!$7e18a8aa366ad472$var$prefetchTiming || !$7e18a8aa366ad472$var$prefetchTiming.keys) return;
    const currentMatch = JSON.stringify(match);
    const keys = Array.from($7e18a8aa366ad472$var$prefetchTiming.keys());
    keys.forEach((mark)=>{
        if (mark !== currentMatch && $7e18a8aa366ad472$var$prefetchTiming.has(mark)) $7e18a8aa366ad472$var$prefetchTiming.delete(mark);
    });
};

});

parcelRegister("ccydf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca20711dc4997be5$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $fdDkm = parcelRequire("fdDkm");
var $30bwc = parcelRequire("30bwc");
const $ca20711dc4997be5$var$LOCATION = 'spa.create-spa-history';
const $ca20711dc4997be5$var$createCustomHistoryBlock = (routeBlockFns, currentRoutes, history)=>(blockFn)=>{
        const matchedRoute = (0, $30bwc.default)(currentRoutes, history.location.pathname, history.location.search);
        // This should never be the case as in SPA we have a default route
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!matchedRoute) return ()=>{};
        if (!routeBlockFns.includes(blockFn)) routeBlockFns.push(blockFn);
        // returns an "unregister" block
        return ()=>{
            const idx = routeBlockFns.indexOf(blockFn);
            if (idx !== -1) routeBlockFns.splice(idx, 1);
        };
    };
const $ca20711dc4997be5$var$createSpaHistory = (initialRoutes)=>{
    const routeBlockFns = [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let blockArgs = [];
    let nextMatchedRoute;
    const currentRoutes = initialRoutes;
    const history = (0, $fdDkm.createBrowserHistory)({
        /* We abuse this api to allow us to run as many blockers as we want, allowing the transition
		 * to resume only when all return true or bail out as soon as the first one returns false */ getUserConfirmation: (__, done)=>{
            const matchedRoute = (0, $30bwc.default)(currentRoutes, history.location.pathname, history.location.search);
            // This should never be the case as in SPA we have a default route
            if (!matchedRoute || !nextMatchedRoute) return done(true);
            // we execute the blockers in reverse order, so the last registered is the first to run
            // They are executed synchronously until one returns false or a promise
            // If a promise is returned we execute all remaining blockers as chained promises
            let sync = true;
            for(let i = routeBlockFns.length - 1; i >= 0; i -= 1){
                const result = routeBlockFns[i](...blockArgs);
                if (result instanceof Promise) {
                    sync = false;
                    routeBlockFns.slice(0, i + 1).reverse().reduce(// eslint-disable-next-line @typescript-eslint/no-loop-func
                    (promise, blocker)=>promise.then((res)=>res === false ? Promise.resolve(false) : blocker(...blockArgs)), Promise.resolve(result)).then((res)=>{
                        routeBlockFns.length = 0;
                        done(res);
                    }).catch((err)=>{
                        (0, $eSnSE.default).safeErrorWithoutCustomerData($ca20711dc4997be5$var$LOCATION, 'Error with getUserConfirmation', err);
                        done(true);
                    });
                    break;
                }
                if (result === false) {
                    done(false);
                    return;
                }
            }
            if (sync) {
                routeBlockFns.length = 0;
                done(true);
            }
        }
    });
    // For lazy loaded route maps we need to keep track of the current routes here
    // as they will be changing. When we "match" for the route blocking code we need
    // to ensure we match against the current routes, not the routes at the time the function
    // was created.
    history.refreshRoutes = (newRoutes)=>{
        // Replace currentRoutes in place as it's captured in a closure above..
        currentRoutes.length = 0;
        currentRoutes.push(...newRoutes);
    };
    /* We set the main "blocker", that is also used enable next location access in getUserConfirmation
	 * (going around getUserConfirmation API limitations) */ history.block((location, action)=>{
        blockArgs = [
            location,
            action
        ];
        nextMatchedRoute = (0, $30bwc.default)(currentRoutes, location.pathname, location.search);
        // Must return a string or getUserConfirmation is not called
        return '';
    });
    // @ts-expect-error - we're using a custom blocker
    history.block = $ca20711dc4997be5$var$createCustomHistoryBlock(routeBlockFns, currentRoutes, history);
    return history;
};
var /**
 * Monkey patches the push/replace methods of the react router history object to
 * perform a full page refresh instead of history push/replace when a route is not valid
 * (i.e. legacy pages). This is required to fix the browser back button not working correctly
 * after redirecting to a legacy page.
 * JSPA-900
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$ca20711dc4997be5$export$2e2bcd8739ae039 = (routes)=>$ca20711dc4997be5$var$createSpaHistory(routes);

});

parcelRegister("lZMpx", function(module, exports) {

$parcel$export(module.exports, "getSpaRouterContext", () => $80de4900a6305c9e$export$1f61c5e3f6410afa);
const $80de4900a6305c9e$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
        tenantContext: tenantContext
    });

});

parcelRegister("aqRAv", function(module, exports) {

$parcel$export(module.exports, "default", () => $10fcd8375fcf033e$export$2e2bcd8739ae039);

var $8aMsX = parcelRequire("8aMsX");

var $4tiI5 = parcelRequire("4tiI5");

var $3TY2E = parcelRequire("3TY2E");

var $8Zesw = parcelRequire("8Zesw");

var $dqoGc = parcelRequire("dqoGc");
var $QGkzV = parcelRequire("QGkzV");

var $hDmQj = parcelRequire("hDmQj");

var $7jTnu = parcelRequire("7jTnu");

var $hWeHP = parcelRequire("hWeHP");

var $dJnTE = parcelRequire("dJnTE");

var $fr3kC = parcelRequire("fr3kC");

var $25NU0 = parcelRequire("25NU0");

var $epTsa = parcelRequire("epTsa");

var $gbSLd = parcelRequire("gbSLd");

var $eL1MK = parcelRequire("eL1MK");

var $87apk = parcelRequire("87apk");
// TODO: AFO-2949: Remove fallback once we have a stable config in Statsig when deprecating the FF 'ufo-use-statsig-config-jira'
const $10fcd8375fcf033e$var$FALLBACK_UFO_CONFIG = {
    autoGeneratedRate: 1000,
    enabled: true,
    removeUFOPrefixList: [
        'project-versions',
        'filters-directory'
    ],
    removePageSegmentsUFOPrefixes: true,
    doNotAbortActivePressInteractionOnTransition: [
        'jsm-create-cmp-request-type-from-template',
        'jsm-create-tmp-request-type-from-template'
    ],
    killswitch: [
        'jira.fe.load.UNKNOWN'
    ],
    awaitForSegments: {
        'global-issue.create-modal': [
            'issue-view-details'
        ],
        'global-issue.create-modal-subsequent': [
            'issue-view-details'
        ]
    },
    removeAllUFOPrefix: true,
    rates: {
        'issue-view-activity-button-worklog': 1,
        'issue-view-activity-button-history': 1,
        'issue-view-activity-button-comments': 1,
        'arj-toggle-view-mode': 1,
        'global-issue.create-modal-subsequent': 5,
        unknown: 1000,
        'issue-view-activity-button-forge-app': 1,
        'view-mode': 1,
        'backlog.issue-view-opened': 5,
        'create-web-link-inline-field-type-tracing': 1000,
        'issue-view-activity-button-connect-app': 1,
        'single-line-text-field-type-tracing': 100,
        'issue-view-activity-button-all': 1,
        'backlog.card-hover': 1,
        'child-issue-inline-create-type-tracing': 100,
        'show-insights-button': 100,
        'board.issue-view-opened': 5,
        'issue-view-activity-button-jsd-comments': 1,
        'backlog.card-list-toggle': 5,
        'global-issue.create-modal': 5,
        'issue-view-activity-button-approvals': 1
    },
    kind: {
        generic: 0,
        hover: 0,
        legacy: 1,
        page_load: 1,
        press: 1,
        transition: 1,
        typing: 0
    },
    awaitBM3TTI: [
        'jwm_project_pages',
        'software-plan-dependencies',
        'advanced-roadmaps.page-plan.dependencies-tab.load-time',
        'servicedesk-cmdb-object-type-configuration',
        'service-management.insight-cmdb-object-type-configuration',
        'project-components-view',
        'project-components',
        'project-settings-components',
        'people-index',
        'people-profiles',
        'rapidboard-report',
        'classic-report',
        'project-settings-servicedesk-ticket-type-fields',
        'project-settings.issue-type.jsm-cmp-customer-view',
        'project-settings.issue-type.jsm-cmp-agent-view',
        'archived-project-direct-link',
        'project-archived',
        'servicedesk-queues-new',
        'service-management.queues.new',
        'project-settings-software-boards-insights',
        'board-settings-apps.insights-settings-page.page.load',
        'admin-oauth-credentials',
        'admin.oauth-credentials',
        'polaris-ideas',
        'project-settings-software-boards-csm',
        'jira.fe.page-load.software.next-gen.boards.column-status-mapping.page.load',
        'project-settings-servicedesk-language',
        'service-management.languages',
        'project-settings-servicedesk-language-key',
        'service-management.translations',
        'project-settings-servicedesk-classic-apps',
        'service-management.app-discovery',
        'marketplace-index',
        'embedded-marketplace',
        'project-settings-servicedesk-portal-settings',
        'service-management.portal-settings',
        'service-management.portal-settings.portal-groups',
        'project-settings-servicedesk-automation-create',
        'service-management.automation.create-rule',
        'servicedesk-customers-v2',
        'jsm-customers-component-load',
        'archived-project-direct-link',
        'project-archived',
        'project-settings-software-boards-csm',
        'software.next-gen.boards.column-status-mapping.page.load',
        'jira-connect',
        'knowledge-hub-category',
        'service-management.knowledge.category',
        'servicedesk-queues-landing',
        'servicedesk-practice-landing',
        'servicedesk-practice-custom-and-issue',
        'servicedesk-practice-custom-issue',
        'servicedesk-practice-custom-view',
        'servicedesk-queues-custom-and-issue',
        'servicedesk-queues-custom-issue',
        'servicedesk-queues-custom-view'
    ],
    rules: [],
    capability: {
        feature_flag_access: 1,
        react_profiler: 1
    },
    typingMethod: 'timeout',
    removeInteractionsUFOPrefixes: true,
    doNotAbortActivePressInteraction: [
        'global-issue.create-modal',
        'global-issue.create-modal-subsequent'
    ],
    ufoNameOverrides: {
        'global-issue-navigator': {
            'global-issue-navigator': 'global-issue-navigator-jfe',
            'new-issue-navigator': 'global-new-issue-navigator'
        },
        'global-issue-navigator-jfe': {
            'global-issue-navigator-jfe': 'global-issue-navigator-jfe',
            'new-issue-navigator': 'global-new-issue-navigator'
        },
        'global-settings-migrations-focus-page': {
            'admin.c2c-migrations.choose-destination': 'admin.c2c-migrations.choose-destination',
            'admin.c2c-migrations.choose-projects': 'admin.c2c-migrations.choose-projects',
            'admin.c2c-migrations.preflight-checks': 'admin.c2c-migrations.preflight-checks',
            'admin.c2c-migrations.review': 'admin.c2c-migrations.review'
        },
        'polaris-ideas': {
            'project-settings.details': 'project-settings-details-polaris-ideas'
        },
        'project-settings-servicedesk-portal-settings': {
            'service-management.portal-settings': 'service-management.portal-settings',
            'service-management.portal-settings.portal-groups': 'service-management.portal-settings.portal-groups'
        },
        'project-settings-servicedesk-ticket-type-fields': {
            'project-settings.issue-type.jsm-cmp-agent-view': 'project-settings.issue-type.jsm-cmp-agent-view',
            'project-settings.issue-type.jsm-cmp-customer-view': 'project-settings.issue-type.jsm-cmp-customer-view'
        },
        'servicedesk-practice-custom-and-issue': {
            'service-management.queues.issue': 'servicedesk-practice-custom-issue',
            'service-management.queues.view': 'servicedesk-practice-custom-view'
        },
        'servicedesk-queues-custom-and-issue': {
            'service-management.queues.issue': 'servicedesk-queues-custom-issue',
            'service-management.queues.view': 'servicedesk-queues-custom-view'
        }
    },
    enableCompleteUsingDoubleRAF: true
};
const $10fcd8375fcf033e$var$STRINGIFIED_FALLBACK_UFO_CONFIG = JSON.stringify($10fcd8375fcf033e$var$FALLBACK_UFO_CONFIG);
const $10fcd8375fcf033e$var$getUFOConfigFromStatsig = ()=>{
    try {
        // eslint-disable-next-line jira/ff/inline-expVal-params
        return JSON.parse((0, $epTsa.expVal)('ufo_config', 'value', $10fcd8375fcf033e$var$STRINGIFIED_FALLBACK_UFO_CONFIG));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to get UFO config from Statsig dynamic config:', error);
        // TODO: AFO-2949: Change the fallback to be `{}` once we have a stable config in Statsig when deprecating the FF 'ufo-use-statsig-config-jira'
        return $10fcd8375fcf033e$var$FALLBACK_UFO_CONFIG;
    }
};
function $10fcd8375fcf033e$var$getAdditionalJiraFields(interaction) {
    try {
        return {
            jira: (0, $fr3kC.getJiraCustomData)(interaction)
        };
    } catch (error) {
        return {};
    }
}

function $10fcd8375fcf033e$var$loadJiraAnalyticsWebClient() {
    return Promise.resolve((parcelRequire("2Mqjh")));
}
function $10fcd8375fcf033e$export$2e2bcd8739ae039() {
    const ufoConfigFromFF = (0, $7jTnu.fg)('ufo-use-statsig-config-jira') ? $10fcd8375fcf033e$var$getUFOConfigFromStatsig() : $10fcd8375fcf033e$var$FALLBACK_UFO_CONFIG;
    (0, $dJnTE.retrieveAndSetPageLoadTrace)((0, $hWeHP.default));
    (0, $dqoGc.configure)((0, $eL1MK.jiraResourceTimingsConfig));
    (0, $QGkzV.startResourceTimingBuffer)();
    if (!(0, $7jTnu.fg)('jira-disable-ufo-bundle-eval-timings')) (0, $4tiI5.configure)((0, $gbSLd.jiraBundleEvalTimingsConfig));
    (0, $hDmQj.configure)((0, $87apk.jiraSsrConfig));
    (0, $25NU0.GlobalReactLooselyLazyProfiler).current = (0, $3TY2E.ModuleLoadingProfiler);
    const perfPushExperienceRates = {
        'issue-view': 1,
        'issue-view-software': 1,
        'issue-view-serviceDesk': 1,
        'issue-view-embed': 1,
        'new-issue-navigator': 1,
        'classic-board': 1,
        'classic-backlog': 1,
        'next-gen-board': 1,
        'software-plan-timeline': 1,
        'next-gen-roadmap': 1,
        'classic-roadmap': 1,
        'next-gen-backlog': 1,
        'jwm.list-view': 1,
        'jwm.summary-view': 1,
        dashboard: 1,
        'software-issue-navigator': 1,
        'global-new-issue-navigator': 1,
        'global-issue-navigator-jfe': 1,
        'issue-navigator': 1,
        'issue-navigator-classic': 1,
        'issue-navigator-core': 1,
        'servicedesk-issues': 1,
        'jwm.jwm-board-base': 1,
        'jwm.jwm-board-with-filters': 1,
        'jwm.jwm-board-with-issue-view': 1,
        'servicedesk-queues-landing': 1,
        'servicedesk-practice-landing': 1,
        'servicedesk-practice-custom-issue': 1,
        'servicedesk-practice-custom-view': 1,
        'servicedesk-queues-custom-issue': 1,
        'servicedesk-queues-custom-view': 1
    };
    const ssrWhitelist = [
        'software-issue-navigator',
        'global-new-issue-navigator',
        'issue-navigator-classic',
        'issue-navigator-core',
        'servicedesk-issues',
        'issue-view',
        'issue-view-software',
        'issue-view-serviceDesk',
        'issue-view-embed',
        'classic-board',
        'classic-backlog',
        'next-gen-backlog'
    ];
    const assetsConfig = {
        classification: {
            all: true,
            allAtlassian: ({ entry: entry })=>{
                const isAtlassian = entry.name.includes('atl-paas.net/') || entry.name.includes('cloudfront') && entry.name.includes('batch.js');
                return isAtlassian;
            },
            preloaded: ({ entry: entry, SSRDoneTime: SSRDoneTime })=>{
                return Boolean(SSRDoneTime && entry.startTime <= SSRDoneTime);
            }
        }
    };
    (0, $8Zesw.init)($10fcd8375fcf033e$var$loadJiraAnalyticsWebClient(), {
        ...ufoConfigFromFF,
        enableSegmentHighlighting: (0, $7jTnu.fg)('ufo_enable_segment_highlighting_jira'),
        enableAdditionalPerformanceMarks: (0, $7jTnu.fg)('ufo_enable_segment_highlighting_jira'),
        product: 'jira',
        region: (0, $hWeHP.default)('ajs-region') || 'unknown',
        additionalPayloadData: $10fcd8375fcf033e$var$getAdditionalJiraFields,
        postInteractionLog: {
            enabled: (0, $7jTnu.fg)('ufo_capture_late_rerenders_jira'),
            rates: perfPushExperienceRates
        },
        experimentalInteractionMetrics: {
            enabled: (0, $7jTnu.fg)('ufo-enable-experimental-holds-jira'),
            rates: perfPushExperienceRates
        },
        manuallyTrackReactProfilerMounts: (0, $7jTnu.fg)('ufo-manually-track-segment-mount-phase-jira'),
        vc: {
            enabled: true,
            heatmapSize: 200,
            oldDomUpdates: false,
            devToolsEnabled: (0, $7jTnu.fg)('uip_vc_devtools'),
            selectorConfig: {
                id: true,
                role: !(0, $7jTnu.fg)('uip_disable_vc_role_selector'),
                className: true,
                testId: false // Cannot be enabled due to some testid attributes containing UGC. Use data-vc instead.
            },
            ssr: (0, $7jTnu.fg)('uip_vc_ssr'),
            ssrWhitelist: ssrWhitelist,
            ssrEnablePageLayoutPlaceholder: true,
            stopVCAtInteractionFinish: (0, $7jTnu.fg)('stop_vc_at_interaction_finish'),
            includeSSRInV3: (0, $7jTnu.fg)('jira_include_ssr_in_vc_v3'),
            includeSSRRatio: true,
            enabledVCRevisions: {
                all: [
                    'fy25.02',
                    'fy25.03'
                ]
            }
        },
        enableBetterPageVisibilityApi: true,
        assetsConfig: assetsConfig,
        getReactHydrationStats: (0, $7jTnu.fg)('jfp-magma-3742-report-hydration-stats') ? (0, $8aMsX.getReactHydrationStats) : undefined
    });
}

});
parcelRegister("4tiI5", function(module, exports) {

$parcel$export(module.exports, "configure", () => $8fa77eb84781e12c$export$8d21e34596265fa2);
$parcel$export(module.exports, "getBundleEvalTimings", () => $8fa77eb84781e12c$export$2eda1519e91a4386);

var $2P0cp = parcelRequire("2P0cp");
let $8fa77eb84781e12c$var$config = null;
function $8fa77eb84781e12c$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
    $8fa77eb84781e12c$var$config = bundleEvalTimingConfiguration;
}
function $8fa77eb84781e12c$var$getPerformanceObject() {
    return (window ?? {}).performance;
}
function $8fa77eb84781e12c$export$2eda1519e91a4386(interactionStartTime) {
    if ($8fa77eb84781e12c$var$config == null) return {};
    const started = {};
    const timings = {};
    const cachedConfig = $8fa77eb84781e12c$var$config;
    const performance = $8fa77eb84781e12c$var$getPerformanceObject();
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: (0, $2P0cp.roundEpsilon)(started[name].startTime - interactionStartTime),
                duration: (0, $2P0cp.roundEpsilon)(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}

});
parcelRegister("2P0cp", function(module, exports) {

$parcel$export(module.exports, "roundEpsilon", () => $3094725c13dd4731$export$56014375de40214b);
function $3094725c13dd4731$export$56014375de40214b(num, places = 3) {
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}

});


parcelRegister("8Zesw", function(module, exports) {

$parcel$export(module.exports, "init", () => $b3586a537c11aaea$export$2cd8252107eb640b);

var $8XtVW = parcelRequire("8XtVW");

var $1n1Xr = parcelRequire("1n1Xr");

var $e2Aj8 = parcelRequire("e2Aj8");

var $bCakR = parcelRequire("bCakR");

var $dPhW2 = parcelRequire("dPhW2");

var $3TY2E = parcelRequire("3TY2E");

var $9XEFc = parcelRequire("9XEFc");

var $dPUA9 = parcelRequire("dPUA9");

var $fFblE = parcelRequire("fFblE");
let $b3586a537c11aaea$var$initialized = false;
function $b3586a537c11aaea$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $fFblE.default)(onIdle);
    }
    (0, $3TY2E.sinkInteractionHandler)(sinkFn);
}
function $b3586a537c11aaea$var$sinkExperimentalInteractionMetrics(instance, payloadPackage) {
    function experimentalMetricsSinkFn(interactionId, interaction) {
        function experimentalMetricsOnIdle() {
            const payloadPromise = payloadPackage.createExperimentalMetricsPayload(interactionId, interaction);
            payloadPromise.then((payload)=>{
                if (payload) {
                    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                    if ((0, $8XtVW.fg)('enable_ufo_devtools_api_for_extra_events')) {
                        // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                        const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                        if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    }
                    instance.sendOperationalEvent(payload);
                }
            });
        }
        (0, $fFblE.default)(experimentalMetricsOnIdle);
    }
    (0, $bCakR.sinkExperimentalHandler)(experimentalMetricsSinkFn);
}
function $b3586a537c11aaea$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $3TY2E.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $fFblE.default)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and also by Criterion
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                if ((0, $8XtVW.fg)('enable_ufo_devtools_api_for_extra_events')) {
                    const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                }
                instance.sendOperationalEvent(payload);
            }
        });
    });
}


function $b3586a537c11aaea$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    if ($b3586a537c11aaea$var$initialized) return;
    // Initialize pressure observer for CPU usage monitoring
    (0, $dPUA9.initialisePressureObserver)();
    (0, $dPUA9.initialiseMemoryObserver)();
    (0, $e2Aj8.setUFOConfig)(config);
    if (config.vc?.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder
        };
        (0, $3TY2E.postInteractionLog).initializeVCObserver(vcOptions);
        if (config?.experimentalInteractionMetrics?.enabled) (0, $bCakR.experimentalVC).initialize(vcOptions).start({
            startTime: 0
        });
    }
    (0, $dPhW2.setupHiddenTimingCapture)();
    (0, $1n1Xr.startLighthouseObserver)();
    $b3586a537c11aaea$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        const observer = (0, $9XEFc.getPerformanceObserver)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("10eIx")),
        (parcelRequire("kggs8"))
    ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $b3586a537c11aaea$var$sinkInteraction(instance, payloadPackage);
            if (config?.experimentalInteractionMetrics?.enabled) $b3586a537c11aaea$var$sinkExperimentalInteractionMetrics(instance, payloadPackage);
            if (config.postInteractionLog?.enabled) $b3586a537c11aaea$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
        });
        else if (awc.sendOperationalEvent) {
            $b3586a537c11aaea$var$sinkInteraction(awc, payloadPackage);
            if (config?.experimentalInteractionMetrics?.enabled) $b3586a537c11aaea$var$sinkExperimentalInteractionMetrics(awc, payloadPackage);
            if (config.postInteractionLog?.enabled) $b3586a537c11aaea$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
        }
    });
}

});
parcelRegister("1n1Xr", function(module, exports) {

$parcel$export(module.exports, "startLighthouseObserver", () => $5c7c577f1c13a8c9$export$5ecf2aafafee3e0);
$parcel$export(module.exports, "getLighthouseMetrics", () => $5c7c577f1c13a8c9$export$b46cecdf698e4bb5);

var $9TffZ = parcelRequire("9TffZ");

var $1zTTt = parcelRequire("1zTTt");

var $jvFuR = parcelRequire("jvFuR");

var $hcbJU = parcelRequire("hcbJU");

var $cSdls = parcelRequire("cSdls");
function $5c7c577f1c13a8c9$export$5ecf2aafafee3e0() {
    (0, $cSdls.startLSObserver)();
    (0, $cSdls.startLTObserver)();
}
function $5c7c577f1c13a8c9$export$b46cecdf698e4bb5({ start: start, stop: stop }) {
    const tbt = (0, $jvFuR.getTBT)(start, stop, (0, $hcbJU.EntriesBuffer)[(0, $1zTTt.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $9TffZ.getCLS)(start, stop, (0, $hcbJU.EntriesBuffer)[(0, $1zTTt.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}

});
parcelRegister("9TffZ", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $9db5938e3071592e$export$fc6227831ee7c7);
function $9db5938e3071592e$export$fc6227831ee7c7(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

});

parcelRegister("1zTTt", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $61e35681663f0a7e$export$a4def92db6fc8e17);
const $61e35681663f0a7e$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("jvFuR", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $1f57e0571deabad3$export$2d6e933b35bd3407);
const $1f57e0571deabad3$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $1f57e0571deabad3$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $1f57e0571deabad3$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $1f57e0571deabad3$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $1f57e0571deabad3$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

});

parcelRegister("hcbJU", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $370e7d09333eafeb$export$f7dc16cbd16f7bbe);

var $1zTTt = parcelRequire("1zTTt");
class $370e7d09333eafeb$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $370e7d09333eafeb$export$f7dc16cbd16f7bbe = {
    [(0, $1zTTt.PerformanceObserverEntryTypes).LongTask]: new $370e7d09333eafeb$export$2c6e86519c9e8188(),
    [(0, $1zTTt.PerformanceObserverEntryTypes).LayoutShift]: new $370e7d09333eafeb$export$2c6e86519c9e8188()
};

});

parcelRegister("cSdls", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $ceeec0ef7c3d1e6d$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $ceeec0ef7c3d1e6d$export$54fb8b6aaf70ec9c);

var $1zTTt = parcelRequire("1zTTt");

var $hcbJU = parcelRequire("hcbJU");
let $ceeec0ef7c3d1e6d$var$pe = null;
function $ceeec0ef7c3d1e6d$var$getObserver() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($ceeec0ef7c3d1e6d$var$pe !== null) return $ceeec0ef7c3d1e6d$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $1zTTt.PerformanceObserverEntryTypes).LayoutShift) (0, $hcbJU.EntriesBuffer)[(0, $1zTTt.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $1zTTt.PerformanceObserverEntryTypes).LongTask) (0, $hcbJU.EntriesBuffer)[(0, $1zTTt.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $ceeec0ef7c3d1e6d$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $ceeec0ef7c3d1e6d$var$pe;
}
function $ceeec0ef7c3d1e6d$export$768ccc3ab7bac3ea() {
    $ceeec0ef7c3d1e6d$var$getObserver()?.observe({
        type: (0, $1zTTt.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}
function $ceeec0ef7c3d1e6d$export$54fb8b6aaf70ec9c() {
    $ceeec0ef7c3d1e6d$var$getObserver()?.observe({
        type: (0, $1zTTt.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}

});


parcelRegister("9XEFc", function(module, exports) {

$parcel$export(module.exports, "getPerformanceObserver", () => $750f80f3e49782ad$export$17afbba0f16b4b19);

var $3TY2E = parcelRequire("3TY2E");

var $koEtA = parcelRequire("koEtA");
let $750f80f3e49782ad$var$performanceEventObserver;
const $750f80f3e49782ad$var$selectorConfig = {
    id: true,
    testId: true,
    role: true,
    className: true
};
function $750f80f3e49782ad$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    return null;
}
function $750f80f3e49782ad$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return `UFOSegment[name=${memoizedProps['name']}]`;
    return componentName;
}
function $750f80f3e49782ad$var$getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    // Function to traverse up the fiber tree
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                // Check if there's a display name or a function name
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                // checking when component name is bigger than the minimized name produced by react
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($750f80f3e49782ad$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = $750f80f3e49782ad$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    // Access the reactFiber node from the HTML element
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const $750f80f3e49782ad$export$17afbba0f16b4b19 = ()=>{
    $750f80f3e49782ad$var$performanceEventObserver = $750f80f3e49782ad$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $750f80f3e49782ad$export$e6be05b411ce21a6(entry);
    });
    return $750f80f3e49782ad$var$performanceEventObserver;
};
const $750f80f3e49782ad$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $3TY2E.getActiveInteraction)();
    if (interaction?.type === 'press') {
        if (!interaction.responsiveness?.experimentalInputToNextPaint) {
            interaction.responsiveness = {
                ...interaction.responsiveness,
                experimentalInputToNextPaint: interaction.responsiveness?.experimentalInputToNextPaint || entry.duration,
                inputDelay: interaction.responsiveness?.inputDelay || entry.processingStart - entry.startTime
            };
            if (interaction.ufoName === 'unknown') {
                if (entry.target) {
                    const componentHierarchy = $750f80f3e49782ad$var$getReactComponentHierarchy(entry.target);
                    interaction.unknownElementHierarchy = componentHierarchy;
                }
                interaction.unknownElementName = (0, $koEtA.default)($750f80f3e49782ad$var$selectorConfig, entry.target);
            }
        }
    }
};

});
parcelRegister("koEtA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b205ab21b848741$export$2e2bcd8739ae039);
const $9b205ab21b848741$var$nameCache = new WeakMap();
function $9b205ab21b848741$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function $9b205ab21b848741$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch (err) {
        return false;
    }
}
function $9b205ab21b848741$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $9b205ab21b848741$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $9b205ab21b848741$var$isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += $9b205ab21b848741$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $9b205ab21b848741$var$getAttributeSelector(currentElement, 'data-testid') || $9b205ab21b848741$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $9b205ab21b848741$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($9b205ab21b848741$var$isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && $9b205ab21b848741$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$9b205ab21b848741$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $9b205ab21b848741$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $9b205ab21b848741$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $9b205ab21b848741$var$getUniqueSelector(selectorConfig, element);
    $9b205ab21b848741$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $9b205ab21b848741$export$2e2bcd8739ae039 = $9b205ab21b848741$var$getElementName;

});


parcelRegister("dPUA9", function(module, exports) {

$parcel$export(module.exports, "createPressureStateReport", () => $e8188e273d9c34f7$export$1f0ff35da084986e);
$parcel$export(module.exports, "createMemoryStateReport", () => $e8188e273d9c34f7$export$3b47ebb9832b4e24);
$parcel$export(module.exports, "initialisePressureObserver", () => $e8188e273d9c34f7$export$117ebc554c6e9f2f);
$parcel$export(module.exports, "initialiseMemoryObserver", () => $e8188e273d9c34f7$export$a3271f53e91faab7);
const $e8188e273d9c34f7$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $e8188e273d9c34f7$var$pressureRecordBuffer = [];
let $e8188e273d9c34f7$var$pressureObserver = null;
let $e8188e273d9c34f7$var$memoryRecordBuffer = [];
let $e8188e273d9c34f7$var$memoryInterval;
function $e8188e273d9c34f7$export$6c1060bed5fea050() {
    $e8188e273d9c34f7$var$pressureRecordBuffer.length = 0;
}
function $e8188e273d9c34f7$export$aa672c7221b183b0() {
    $e8188e273d9c34f7$var$memoryRecordBuffer.length = 0;
}
function $e8188e273d9c34f7$export$ec86686c1d2e65bc(filter) {
    $e8188e273d9c34f7$var$pressureRecordBuffer = $e8188e273d9c34f7$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $e8188e273d9c34f7$export$c0142ac82f5d0c28(filter) {
    $e8188e273d9c34f7$var$memoryRecordBuffer = $e8188e273d9c34f7$var$memoryRecordBuffer.filter(({ time: time })=>time > filter);
}
function $e8188e273d9c34f7$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $e8188e273d9c34f7$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $e8188e273d9c34f7$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $e8188e273d9c34f7$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $e8188e273d9c34f7$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = $e8188e273d9c34f7$var$memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: $e8188e273d9c34f7$var$convertBytesToMegabytes($e8188e273d9c34f7$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            avgTotalJSHeapSizeInMB: $e8188e273d9c34f7$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $e8188e273d9c34f7$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $e8188e273d9c34f7$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch  {
        return null;
    }
}
function $e8188e273d9c34f7$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $e8188e273d9c34f7$var$pressureObserver = new PressureObserver((records)=>{
                if ($e8188e273d9c34f7$var$pressureRecordBuffer.length + records.length <= $e8188e273d9c34f7$var$BUFFER_MAX_LENGTH) $e8188e273d9c34f7$var$pressureRecordBuffer.push(...records);
            });
            $e8188e273d9c34f7$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(()=>{
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch (err) {
    /* do nothing, this is a best efforts metric */ }
}
function $e8188e273d9c34f7$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $e8188e273d9c34f7$var$memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if ($e8188e273d9c34f7$var$memoryRecordBuffer.length <= $e8188e273d9c34f7$var$BUFFER_MAX_LENGTH) $e8188e273d9c34f7$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $e8188e273d9c34f7$export$10899ada382f2ae3() {
    clearInterval($e8188e273d9c34f7$var$memoryInterval);
}
function $e8188e273d9c34f7$export$b9fdd785f0fc1d40() {
    $e8188e273d9c34f7$var$pressureObserver?.disconnect();
}

});

parcelRegister("fFblE", function(module, exports) {

$parcel$export(module.exports, "default", () => $36f3836b0a266f99$export$2e2bcd8739ae039);

var $jbhXM = parcelRequire("jbhXM");

var $8XtVW = parcelRequire("8XtVW");
function $36f3836b0a266f99$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $8XtVW.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $jbhXM.unstable_scheduleCallback)((0, $jbhXM.unstable_IdlePriority), work);
}
var $36f3836b0a266f99$export$2e2bcd8739ae039 = $36f3836b0a266f99$var$scheduleIdleCallback;

});

parcelRegister("10eIx", function(module, exports) {

let $0bb1351503f10513$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $0bb1351503f10513$var$load("7vqGd"),
    $0bb1351503f10513$var$load("1Y4bq"),
    $0bb1351503f10513$var$load("dER5g")
]).then(()=>parcelRequire('2TiSC'));

});

parcelRegister("kggs8", function(module, exports) {

let $ec0210766e54b4e2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ec0210766e54b4e2$var$load("f7b5f").then(()=>parcelRequire('1vwO4'));

});


parcelRegister("dqoGc", function(module, exports) {

$parcel$export(module.exports, "configure", () => $a7e049299bcddac3$export$8d21e34596265fa2);
$parcel$export(module.exports, "getConfig", () => $a7e049299bcddac3$export$44487a86467333c3);

var $e2Aj8 = parcelRequire("e2Aj8");
const $a7e049299bcddac3$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $a7e049299bcddac3$var$getAllowedParams() {
    const config = (0, $e2Aj8.getConfig)();
    return config?.allowedResourcesParams || $a7e049299bcddac3$var$defaultAllowedParams;
}
function $a7e049299bcddac3$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $a7e049299bcddac3$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch (e) {
        return urlString;
    }
}
let $a7e049299bcddac3$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $a7e049299bcddac3$var$handleQueryParams(url);
    }
};
function $a7e049299bcddac3$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $a7e049299bcddac3$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $a7e049299bcddac3$var$config = newConfig;
}
function $a7e049299bcddac3$export$44487a86467333c3() {
    return $a7e049299bcddac3$var$config;
}

});

parcelRegister("QGkzV", function(module, exports) {

$parcel$export(module.exports, "startResourceTimingBuffer", () => $d922ba56b8c1eb59$export$a311cb1baa7d2d62);

var $6T1fh = parcelRequire("6T1fh");
function $d922ba56b8c1eb59$export$a311cb1baa7d2d62() {
    (0, $6T1fh.resourceTimingBuffer).start();
}

});
parcelRegister("6T1fh", function(module, exports) {

$parcel$export(module.exports, "resourceTimingBuffer", () => $73007bc84bd6969f$export$bea963256235a63e);
$parcel$export(module.exports, "filterResourceTimings", () => $73007bc84bd6969f$export$4138a729ef1db028);

var $2P0cp = parcelRequire("2P0cp");
const $73007bc84bd6969f$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $73007bc84bd6969f$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $73007bc84bd6969f$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource (entry) {
        const duration = (0, $2P0cp.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
        const serverTime = totalBackendTimeEntry ? (0, $2P0cp.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $2P0cp.roundEpsilon)(entry.startTime),
            duration: (0, $2P0cp.roundEpsilon)(entry.duration),
            fetchStart: (0, $2P0cp.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $2P0cp.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $2P0cp.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $2P0cp.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $2P0cp.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $2P0cp.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start () {
        const performance = $73007bc84bd6969f$var$getPerformanceObject();
        const PerformanceObserver = $73007bc84bd6969f$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($73007bc84bd6969f$export$bea963256235a63e.observer) return;
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $73007bc84bd6969f$export$bea963256235a63e.timings = resources.map((resource)=>$73007bc84bd6969f$export$bea963256235a63e.transformResource(resource));
        $73007bc84bd6969f$export$bea963256235a63e.observer = new PerformanceObserver($73007bc84bd6969f$export$bea963256235a63e.addTimings);
        $73007bc84bd6969f$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop () {
        if ($73007bc84bd6969f$export$bea963256235a63e.observer) {
            $73007bc84bd6969f$export$bea963256235a63e.observer.disconnect();
            $73007bc84bd6969f$export$bea963256235a63e.observer = null;
        }
        $73007bc84bd6969f$export$bea963256235a63e.timings = [];
    },
    addTimings (list) {
        const entries = list.getEntries().map((entry)=>$73007bc84bd6969f$export$bea963256235a63e.transformResource(entry));
        const overflow = $73007bc84bd6969f$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $73007bc84bd6969f$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $73007bc84bd6969f$export$bea963256235a63e.maxSize;
            $73007bc84bd6969f$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $73007bc84bd6969f$export$bea963256235a63e.timings.push(...entries);
    }
};
function $73007bc84bd6969f$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $73007bc84bd6969f$export$4138a729ef1db028(startTime, endTime) {
    const performance = $73007bc84bd6969f$var$getPerformanceObject();
    const PerformanceObserver = $73007bc84bd6969f$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$73007bc84bd6969f$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$73007bc84bd6969f$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $73007bc84bd6969f$export$bea963256235a63e.timings.filter((timing)=>$73007bc84bd6969f$var$isValidTiming(timing, startTime, endTime));
}

});


parcelRegister("hDmQj", function(module, exports) {

$parcel$export(module.exports, "configure", () => $0aa7b7cb71863b3e$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $0aa7b7cb71863b3e$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $0aa7b7cb71863b3e$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRPhaseSuccess", () => $0aa7b7cb71863b3e$export$5eade9354185583d);
$parcel$export(module.exports, "getSSRDoneTime", () => $0aa7b7cb71863b3e$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $0aa7b7cb71863b3e$export$1c4a9b5e6e22393d);

var $8XtVW = parcelRequire("8XtVW");
const $0aa7b7cb71863b3e$var$NESTED_METRIC_SEPARATOR = '/';
function $0aa7b7cb71863b3e$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $0aa7b7cb71863b3e$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size && (0, $8XtVW.fg)('platform_ufo_ssr_size_field') ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $0aa7b7cb71863b3e$var$SSR_PREFIX = 'ssr';
function $0aa7b7cb71863b3e$var$mapKey(key) {
    if (key === 'total') return $0aa7b7cb71863b3e$var$SSR_PREFIX;
    return `${$0aa7b7cb71863b3e$var$SSR_PREFIX}${$0aa7b7cb71863b3e$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $0aa7b7cb71863b3e$var$config;
function $0aa7b7cb71863b3e$export$8d21e34596265fa2(ssrConfig) {
    $0aa7b7cb71863b3e$var$config = ssrConfig;
}
function $0aa7b7cb71863b3e$export$bf7408e83532dcd0() {
    if (!$0aa7b7cb71863b3e$var$config?.getTimings) return {};
    const timings = $0aa7b7cb71863b3e$var$config.getTimings();
    if (!timings) return {};
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($0aa7b7cb71863b3e$var$filterEntry(entry[1])) acc[$0aa7b7cb71863b3e$var$mapKey(entry[0])] = $0aa7b7cb71863b3e$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $0aa7b7cb71863b3e$export$c7ad864055e75537() {
    return !!$0aa7b7cb71863b3e$var$config?.getDoneMark();
}
function $0aa7b7cb71863b3e$export$5eade9354185583d() {
    return $0aa7b7cb71863b3e$var$config?.getSsrPhaseSuccess?.();
}
function $0aa7b7cb71863b3e$export$3def7672244bab0c() {
    return $0aa7b7cb71863b3e$var$config?.getDoneMark() ?? undefined;
}
function $0aa7b7cb71863b3e$export$1c4a9b5e6e22393d() {
    if (!$0aa7b7cb71863b3e$var$config?.getFeatureFlags) return undefined;
    try {
        return $0aa7b7cb71863b3e$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return undefined;
}

});

parcelRegister("dJnTE", function(module, exports) {

$parcel$export(module.exports, "retrieveAndSetPageLoadTrace", () => $166f16e8188a91a6$export$1a71d2bbe236de99);

var $kTF8d = parcelRequire("kTF8d");
let $166f16e8188a91a6$var$alreadySet = false;
const $166f16e8188a91a6$export$1a71d2bbe236de99 = (getMeta)=>{
    if (false || $166f16e8188a91a6$var$alreadySet) return;
    const traceId = getMeta('X-B3-TraceId') || '';
    const spanId = traceId?.substring(traceId.length - 16) || ''; // set root span ID by convention
    $166f16e8188a91a6$var$alreadySet = true;
    (0, $kTF8d.setActiveTrace)(traceId, spanId, 'page_load');
};

});

parcelRegister("fr3kC", function(module, exports) {

$parcel$export(module.exports, "getJiraCustomData", () => $5ce5f5978f364e3d$export$abf5e20822fa925);

var $eJOHy = parcelRequire("eJOHy");

var $hWeHP = parcelRequire("hWeHP");

var $6zXPf = parcelRequire("6zXPf");

var $6D8kE = parcelRequire("6D8kE");

var $7jTnu = parcelRequire("7jTnu");

var $lljYo = parcelRequire("lljYo");

var $iOidG = parcelRequire("iOidG");

var $lWXph = parcelRequire("lWXph");

var $9AJAX = parcelRequire("9AJAX");

var $jFb3w = parcelRequire("jFb3w");

var $3PCW7 = parcelRequire("3PCW7");

var $1WYrZ = parcelRequire("1WYrZ");

var $9Bk0W = parcelRequire("9Bk0W");

var $gazJI = parcelRequire("gazJI");

var $lNtvH = parcelRequire("lNtvH");

var $ez7Oj = parcelRequire("ez7Oj");

function $5ce5f5978f364e3d$export$abf5e20822fa925(interaction) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let customData = {};
    const shard = (0, $hWeHP.default)('ajs-shard');
    if (shard !== null && shard !== '') customData.shard = shard;
    if ((0, $7jTnu.fg)('add_editions_to_bm3_splunk_events')) customData['jira:productEditions'] = (0, $6D8kE.getProductEditions)();
    customData['network:assetEncoding'] = (0, $lljYo.getAssetEncoding)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const buildVariant = window.BUILD_VARIANT;
    if (buildVariant) customData['app:buildVariant'] = buildVariant;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const bundlerVersion = window.BUNDLER_VERSION;
    if (bundlerVersion) customData['app:bundlerVersion'] = bundlerVersion;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const useBifrostGateway = window.USE_BIFROST_GATEWAY;
    if (useBifrostGateway) customData['app:useBifrostGateway'] = useBifrostGateway;
    customData.navType = (0, $6zXPf.getWillShowNav4)() ? 'nav4' : 'nav3';
    customData.httpProtocol = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    performance.getEntriesByType('resource')// @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'. | TS2339 - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    .find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
    const { start: start, end: end, apdex: apdex } = interaction;
    const stop = apdex?.[0]?.stopTime ?? end;
    customData.memory = (0, $3PCW7.getMemoryUsageReport)({
        start: start,
        stop: stop
    });
    const lightHouseMetrics = (0, $9AJAX.getLighthouseMetrics)({
        start: start,
        stop: stop
    });
    customData = {
        ...customData,
        ...lightHouseMetrics
    };
    if (interaction.type === 'page_load') customData = {
        ...customData,
        ...(0, $jFb3w.getMarks)({
            start: start
        }),
        ...(0, $1WYrZ.getPageSizeMetrics)(),
        ...(0, $1WYrZ.getExtraNavigationTimings)(),
        ...(0, $gazJI.getServerDurationMetrics)(),
        ...(0, $9Bk0W.getRouterResourceMetrics)(),
        ...(0, $ez7Oj.getWRMStats)(),
        ...(0, $1WYrZ.getPageSizeInfo)({
            start: start,
            stop: stop
        }),
        ...(0, $iOidG.getCacheHitRatio)({
            start: start
        }),
        ...(0, $lWXph.getCHRInfo)({
            start: start
        }),
        ...(0, $lNtvH.getSSRStateInformation)(),
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        'app:version:web': window.BUILD_KEY,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        'app:version:ssr': window.SSR_BUILD_KEY,
        'app:framework:name': 'react',
        'app:framework:version': (0, $eJOHy.version)
    };
    return customData;
}

});
parcelRegister("lljYo", function(module, exports) {

$parcel$export(module.exports, "getAssetEncoding", () => $27d15571baf4b0ce$export$fd12d8f45e126585);
function $27d15571baf4b0ce$export$fd12d8f45e126585() {
    const assetEncodings = Array.prototype.map// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    .call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, i)=>{
        // @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
        acc[i] = true;
        return acc;
    }, {});
    const uniqueEncodings = Object.keys(assetEncodings).sort();
    let result = 'unknown';
    if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
    if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
    return result;
}

});

parcelRegister("iOidG", function(module, exports) {

$parcel$export(module.exports, "getCacheHitRatio", () => $76f0e76729b8d413$export$e8a9322c3d9da8a6);

var $gPCSe = parcelRequire("gPCSe");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $76f0e76729b8d413$var$cacheableTypes = [
    'script',
    'link'
];
const $76f0e76729b8d413$var$CACHE_NETWORK = 'network';
const $76f0e76729b8d413$var$CACHE_MEMORY = 'memory';
const $76f0e76729b8d413$var$CACHE_DISK = 'disk';
const $76f0e76729b8d413$var$calculateTransferType = (type, duration, size)=>{
    if (!$76f0e76729b8d413$var$cacheableTypes.includes(type)) return $76f0e76729b8d413$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $76f0e76729b8d413$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $76f0e76729b8d413$var$CACHE_DISK;
    if (size === undefined) return null;
    return $76f0e76729b8d413$var$CACHE_NETWORK;
};
const $76f0e76729b8d413$export$e8a9322c3d9da8a6 = ({ start: start })=>{
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $gPCSe.default).getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $76f0e76729b8d413$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
};

});

parcelRegister("lWXph", function(module, exports) {

$parcel$export(module.exports, "getCHRInfo", () => $c5f6b93bd3bec9a0$export$9e005e111be93521);

var $6uWhG = parcelRequire("6uWhG");

var $gPCSe = parcelRequire("gPCSe");

var $4kxH2 = parcelRequire("4kxH2");
const $c5f6b93bd3bec9a0$var$SPA_SSR_RENDERED = 'ssr.spa.rendered';
const $c5f6b93bd3bec9a0$export$1faf7d001841a41c = ()=>(0, $6uWhG.getMark)($c5f6b93bd3bec9a0$var$SPA_SSR_RENDERED)?.startTime || null;
const $c5f6b93bd3bec9a0$export$9e005e111be93521 = ({ start: start })=>{
    // initial load only
    if (start !== 0) return {};
    const ssrMark = $c5f6b93bd3bec9a0$export$1faf7d001841a41c();
    const reporter = new (0, $4kxH2.CHRReporter)(ssrMark);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $gPCSe.default).getEntriesByType('resource'))reporter.add(entry);
        const chr = reporter.get();
        return chr === null ? {} : {
            chr: chr
        };
    } catch (e) {
        return {};
    }
};

});
parcelRegister("4kxH2", function(module, exports) {

$parcel$export(module.exports, "CHRReporter", () => $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5);

var $7jTnu = parcelRequire("7jTnu");

var $l1DmX = parcelRequire("l1DmX");
class $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5 {
    constructor(ssrMark){
        this.preloaded = new (0, $l1DmX.CHRSummary)();
        this.all = new (0, $l1DmX.CHRSummary)();
        this.ssrMark = null;
        this.ssrMark = ssrMark;
    }
    isPreloaded(item) {
        const isPreloadedByLink = item.initiatorType === 'link';
        const isPreloadedByPreloadModule = item.initiatorType === 'other' && item.name?.endsWith('.js') && (0, $7jTnu.fg)('ufo_support_other_resource_type_js');
        const isBeforeSSR = this.ssrMark === null || item.startTime < this.ssrMark;
        return (isPreloadedByLink || isPreloadedByPreloadModule) && isBeforeSSR;
    }
    add(item) {
        if (item.encodedBodySize === 0) return;
        if (this.isPreloaded(item)) this.preloaded.add(item);
        this.all.add(item);
    }
    static round(n) {
        return Math.round(n * 10000) / 10000;
    }
    makePayload(summary) {
        const bundlesLoadType = {
            mem: $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $l1DmX.CHRSummary).MEMORY_KEY] / summary.bundlesCount),
            disk: $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $l1DmX.CHRSummary).DISK_KEY] / summary.bundlesCount),
            net: $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $l1DmX.CHRSummary).NETWORK_KEY] / summary.bundlesCount)
        };
        const bundlesRatio = $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, $l1DmX.CHRSummary).MEMORY_KEY] + summary.bundles[(0, $l1DmX.CHRSummary).DISK_KEY]) / summary.bundlesCount);
        const sizeLoadType = {
            mem: $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round(summary.size[(0, $l1DmX.CHRSummary).MEMORY_KEY] / summary.sizeTotal),
            disk: $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round(summary.size[(0, $l1DmX.CHRSummary).DISK_KEY] / summary.sizeTotal),
            net: $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round(summary.size[(0, $l1DmX.CHRSummary).NETWORK_KEY] / summary.sizeTotal)
        };
        const sizeRatio = $b2e3a88fdbcc04ac$export$7d0d4cfb6455ffa5.round((summary.size[(0, $l1DmX.CHRSummary).MEMORY_KEY] + summary.size[(0, $l1DmX.CHRSummary).DISK_KEY]) / summary.sizeTotal);
        return {
            bundles: {
                ratio: bundlesRatio,
                count: summary.bundlesCount,
                loadType: bundlesLoadType
            },
            size: {
                ratio: sizeRatio,
                total: summary.sizeTotal,
                loadType: sizeLoadType
            }
        };
    }
    get() {
        if (this.all.bundlesCount === 0) return null;
        return {
            preloaded: this.makePayload(this.preloaded),
            all: this.makePayload(this.all)
        };
    }
}

});
parcelRegister("l1DmX", function(module, exports) {

$parcel$export(module.exports, "CHRSummary", () => $3c79d159e0d06a6e$export$783d6618ee601ba);

var $7jTnu = parcelRequire("7jTnu");

var $gExqZ = parcelRequire("gExqZ");
const $3c79d159e0d06a6e$var$calculateTransferType = (name, type, duration, size)=>{
    if ((0, $7jTnu.fg)('ufo_support_other_resource_type_js')) {
        if (!(0, $gExqZ.cacheableTypes).includes(type) && !(type === 'other' && name.includes('.js'))) return null;
    } else if (!(0, $gExqZ.cacheableTypes).includes(type)) return null;
    if ((size === undefined || size === 0) && duration === 0) return $3c79d159e0d06a6e$export$783d6618ee601ba.MEMORY_KEY;
    if (size === 0 && duration > 0) return $3c79d159e0d06a6e$export$783d6618ee601ba.DISK_KEY;
    if (size === undefined) return null;
    return $3c79d159e0d06a6e$export$783d6618ee601ba.NETWORK_KEY;
};
class $3c79d159e0d06a6e$export$783d6618ee601ba {
    static{
        this.MEMORY_KEY = 'mem';
    }
    static{
        this.DISK_KEY = 'disk';
    }
    static{
        this.NETWORK_KEY = 'net';
    }
    add(item) {
        const type = $3c79d159e0d06a6e$var$calculateTransferType(item.name, item.initiatorType, item.duration, item.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += item.encodedBodySize;
        this.sizeTotal += item.encodedBodySize;
    }
    constructor(){
        this.bundles = {
            [$3c79d159e0d06a6e$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$3c79d159e0d06a6e$export$783d6618ee601ba.DISK_KEY]: 0,
            [$3c79d159e0d06a6e$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [$3c79d159e0d06a6e$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$3c79d159e0d06a6e$export$783d6618ee601ba.DISK_KEY]: 0,
            [$3c79d159e0d06a6e$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.sizeTotal = 0;
    }
}

});
parcelRegister("gExqZ", function(module, exports) {

$parcel$export(module.exports, "cacheableTypes", () => $f324d115aacd75a4$export$5e1aa91d6932ddaa);
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $f324d115aacd75a4$export$5e1aa91d6932ddaa = [
    'script',
    'link'
];

});




parcelRegister("9AJAX", function(module, exports) {

$parcel$export(module.exports, "getLighthouseMetrics", () => $a79abade65277647$export$b46cecdf698e4bb5);

var $epCa1 = parcelRequire("epCa1");

var $gq4ol = parcelRequire("gq4ol");

var $2fQed = parcelRequire("2fQed");

var $lxjbw = parcelRequire("lxjbw");

var $5x5TB = parcelRequire("5x5TB");
function $a79abade65277647$export$5ecf2aafafee3e0() {
    (0, $5x5TB.startLSObserver)();
    (0, $5x5TB.startLTObserver)();
}
const $a79abade65277647$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $2fQed.getTBT)(start, stop, (0, $lxjbw.EntriesBuffer)[(0, $gq4ol.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $epCa1.getCLS)(start, stop, (0, $lxjbw.EntriesBuffer)[(0, $gq4ol.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("epCa1", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $d51104bb73b57a01$export$fc6227831ee7c7);
const $d51104bb73b57a01$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("gq4ol", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $48ac00c98bd8deae$export$a4def92db6fc8e17);
const $48ac00c98bd8deae$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("2fQed", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $5738f807e7f6fecd$export$2d6e933b35bd3407);
const $5738f807e7f6fecd$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $5738f807e7f6fecd$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $5738f807e7f6fecd$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $5738f807e7f6fecd$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $5738f807e7f6fecd$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("lxjbw", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $8fd43ee617db15bf$export$f7dc16cbd16f7bbe);

var $gq4ol = parcelRequire("gq4ol");
class $8fd43ee617db15bf$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $8fd43ee617db15bf$export$f7dc16cbd16f7bbe = {
    [(0, $gq4ol.PerformanceObserverEntryTypes).LongTask]: new $8fd43ee617db15bf$export$2c6e86519c9e8188(),
    [(0, $gq4ol.PerformanceObserverEntryTypes).LayoutShift]: new $8fd43ee617db15bf$export$2c6e86519c9e8188()
};

});

parcelRegister("5x5TB", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $7158250d94157eec$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $7158250d94157eec$export$54fb8b6aaf70ec9c);

var $gq4ol = parcelRequire("gq4ol");

var $lxjbw = parcelRequire("lxjbw");
let $7158250d94157eec$var$pe = null;
const $7158250d94157eec$var$getObserver = ()=>{
    if ($7158250d94157eec$var$pe !== null) return $7158250d94157eec$var$pe;
    $7158250d94157eec$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $gq4ol.PerformanceObserverEntryTypes).LayoutShift) (0, $lxjbw.EntriesBuffer)[(0, $gq4ol.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $gq4ol.PerformanceObserverEntryTypes).LongTask) (0, $lxjbw.EntriesBuffer)[(0, $gq4ol.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $7158250d94157eec$var$pe;
};
const $7158250d94157eec$export$768ccc3ab7bac3ea = ()=>{
    $7158250d94157eec$var$getObserver().observe({
        type: (0, $gq4ol.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $7158250d94157eec$export$54fb8b6aaf70ec9c = ()=>{
    $7158250d94157eec$var$getObserver().observe({
        type: (0, $gq4ol.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("jFb3w", function(module, exports) {

$parcel$export(module.exports, "getMarks", () => $940b3a1e7fc495e4$export$9d952633c9c2237b);

var $a5R5f = parcelRequire("a5R5f");

var $cJAh3 = parcelRequire("cJAh3");
const $940b3a1e7fc495e4$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $a5R5f.getUserTiming)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    // @ts-expect-error - TS7031 - Binding element 'baseName' implicitly has an 'any' type. | TS7031 - Binding element 'collection' implicitly has an 'any' type.
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter(// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    (item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, $cJAh3.JS_EVAL_START)) && !item.name.endsWith((0, $cJAh3.JS_EVAL_STOP)) && item.startTime >= data.start)// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    .forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};

});

parcelRegister("3PCW7", function(module, exports) {

$parcel$export(module.exports, "getMemoryUsageReport", () => $c5120b7ccc20410f$export$e5bd2d61c7c80651);
/**
 * Memory usage report.
 *
 * In the future may be extended to contain `performance.measureUserAgentSpecificMemory` if Jira
 * front-end uses cross-origin isolation.
 */ const $c5120b7ccc20410f$export$e5bd2d61c7c80651 = ({ start: start, stop: stop })=>{
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof performance === 'undefined' || performance?.memory == null) return null;
    const sessionTime = Math.round(stop - start);
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
    return {
        sessionTime: sessionTime,
        performanceMemoryEntry: {
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize
        }
    };
};

});

parcelRegister("1WYrZ", function(module, exports) {

$parcel$export(module.exports, "getPageSizeMetrics", () => $2005cb261e5ca356$export$84e3d676f1564c75);
$parcel$export(module.exports, "getExtraNavigationTimings", () => $2005cb261e5ca356$export$b37a70af06e58097);
$parcel$export(module.exports, "getPageSizeInfo", () => $2005cb261e5ca356$export$b72e035af6568be7);

var $gPCSe = parcelRequire("gPCSe");

var $7jTnu = parcelRequire("7jTnu");
// Helper function to safely access globalThis.bifrostPayloadStats
const $2005cb261e5ca356$var$getBifrostPayloadStats = ()=>{
    // @ts-expect-error - globalThis.bifrostPayloadStats is not in standard TypeScript definitions
    return globalThis.bifrostPayloadStats;
};
const $2005cb261e5ca356$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) // @ts-expect-error - TS2345 - Argument of type 'ShadowRoot' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $2005cb261e5ca356$export$b37a70af06e58097 = ()=>{
    if (!(0, $gPCSe.default)) return {};
    const navigation = (0, $gPCSe.default).getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        // @ts-expect-error - TS2339 - Property 'decodedBodySize' does not exist on type 'PerformanceEntry'.
        decodedBodySize: navigation.decodedBodySize,
        // @ts-expect-error - TS2339 - Property 'encodedBodySize' does not exist on type 'PerformanceEntry'.
        encodedBodySize: navigation.encodedBodySize,
        // @ts-expect-error - TS2339 - Property 'transferSize' does not exist on type 'PerformanceEntry'.
        transferSize: navigation.transferSize
    };
};
const $2005cb261e5ca356$var$assetsTypes = [
    'script',
    'link'
];
const $2005cb261e5ca356$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $2005cb261e5ca356$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const entry of (0, $gPCSe.default).getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($2005cb261e5ca356$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    const bifrostStats = (0, $7jTnu.fg)('jira-enable-page-size-reporting') && $2005cb261e5ca356$var$getBifrostPayloadStats();
    if (bifrostStats) {
        const sizeSplit = {};
        returnValue['size:split'] = sizeSplit;
        const labelsToCheck = [
            'preHtml',
            'serverToClientEvents',
            'featureFlags',
            'wrmResources',
            'serverPerfTrace',
            'preloadAssets',
            'preloadTags',
            'statsigGateValues',
            'earlyFeatureFlags',
            'inlineScripts',
            'contextualPreload',
            'contextualState',
            'earlyEntryScript',
            'inlineCss',
            'langPackPreloads',
            'langPackScripts',
            'externalScripts',
            'metaTags',
            'lazyPreloads',
            'spaHtml'
        ];
        labelsToCheck.forEach((label)=>{
            const value = bifrostStats[label];
            if (typeof value === 'number') sizeSplit[label] = value;
        });
    }
    return returnValue;
};

});

parcelRegister("9Bk0W", function(module, exports) {

$parcel$export(module.exports, "getRouterResourceMetrics", () => $032bf7e051288f2e$export$e703af446a67c7f4);
const $032bf7e051288f2e$export$e703af446a67c7f4 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
        if (key !== key.toUpperCase()) return false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resource = window.SPA_STATE[key];
        if (typeof resource !== 'object') return false;
        const resourceResponse = resource[Object.keys(resource)[0]];
        return resourceResponse?.error?.name === 'TimeoutError';
    }) : [];
    return {
        ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
    };
};

});

parcelRegister("gazJI", function(module, exports) {

$parcel$export(module.exports, "getServerDurationMetrics", () => $49816a5f0a3b573a$export$efd8b60b870e5282);
const $49816a5f0a3b573a$export$efd8b60b870e5282 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const metrics = {};
    try {
        // server duration metric is buried in a hidden form near end of </body>
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
        if (serverDurationElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverDuration = Number(serverDurationElem.value);
            if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
        if (serverTraceIdElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceId = serverTraceIdElem.value;
            metrics.serverRequestTraceId = serverRequestTraceId;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
        if (serverTraceSampledElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceSampled = serverTraceSampledElem.value;
            switch(serverRequestTraceSampled){
                case 'true':
                    metrics.serverRequestTraceSampled = true;
                    break;
                case 'false':
                    metrics.serverRequestTraceSampled = false;
                    break;
                default:
                    metrics.serverRequestTraceSampled = null;
                    break;
            }
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
        if (concurrentRequestsElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const concurrentRequests = concurrentRequestsElem.value;
            metrics.concurrentRequests = concurrentRequests;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
        if (serverRequestStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestStartTime = serverRequestStartTimeElem.value;
            metrics.serverRequestStartTime = serverRequestStartTime;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
        if (frontendFlushStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const frontendFlushStartTime = frontendFlushStartTimeElem.value;
            metrics.frontendFlushStartTime = frontendFlushStartTime;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ignored) {
    /* noop */ }
    return metrics;
};

});

parcelRegister("lNtvH", function(module, exports) {

$parcel$export(module.exports, "getSSRStateInformation", () => $2a69d4614f226c2e$export$9a46186893ad76bd);

var $6uWhG = parcelRequire("6uWhG");
const $2a69d4614f226c2e$var$getState = ()=>{
    if ((0, $6uWhG.getMark)('ssr.spa.state')?.startTime) return 'success';
    if ((0, $6uWhG.getMark)('ssr.spa.early-common-flush:end')?.startTime) return 'spa-render-failure';
    return 'static-fallback';
};
const $2a69d4614f226c2e$export$9a46186893ad76bd = ()=>{
    return {
        'ssr:state': $2a69d4614f226c2e$var$getState()
    };
};

});

parcelRegister("ez7Oj", function(module, exports) {

$parcel$export(module.exports, "getWRMStats", () => $bc580539ac7c2d61$export$d2d916ddd03b82bc);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bc580539ac7c2d61$export$d2d916ddd03b82bc = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
    return {
        wrmStats: wrmStats
    };
};

});


parcelRegister("gbSLd", function(module, exports) {

$parcel$export(module.exports, "jiraBundleEvalTimingsConfig", () => $983d24632a68c58b$export$791b8c0cbd574ea9);

var $cJAh3 = parcelRequire("cJAh3");
const $983d24632a68c58b$export$791b8c0cbd574ea9 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $cJAh3.JS_EVAL_START))) return {
            name: mark.substring(0, mark.indexOf((0, $cJAh3.JS_EVAL_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $cJAh3.JS_EVAL_STOP))) return {
            name: mark.substring(0, mark.indexOf((0, $cJAh3.JS_EVAL_STOP))),
            type: 'end'
        };
        return null;
    }
};

});

parcelRegister("eL1MK", function(module, exports) {

$parcel$export(module.exports, "jiraResourceTimingsConfig", () => $62857d62cfaca9d3$export$8fa71550bcdc2104);

var $3Q6BV = parcelRequire("3Q6BV");

var $hVEQH = parcelRequire("hVEQH");
const $62857d62cfaca9d3$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
const $62857d62cfaca9d3$var$getWRMAssetName = (url)=>{
    const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
    const assetName = (0, $hVEQH.sanitiseAssetName)(false)(url);
    if (!resources) return assetName;
    return `wrm/${resources}/${assetName}`;
};
const $62857d62cfaca9d3$var$getFileName = (url)=>$62857d62cfaca9d3$var$isWRMResource(url) ? $62857d62cfaca9d3$var$getWRMAssetName(url) : (0, $hVEQH.sanitiseAssetName)(false)(url);
const $62857d62cfaca9d3$var$sanitiseEndpoints = (url)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(url, true);
    /**
	 * For endpoints with operation or operationName queryParam we will shorten the url
	 * as ufo pipeline will only get the `operation` query param for aggregation
	 */ const { operation: operation, operationName: operationName } = parsedUrl.query;
    const operationNameOverride = operation ?? operationName;
    if (operationNameOverride) return `/${operation}?operation=${operation}`;
    const fileName = parsedUrl.pathname.replace(/\/(project|agent)(-config|s)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(servicedesk)(-data)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(browse|automation|pagination|permissions|async|dialog|itsm)\/([A-Z0-9]+)/g, '/$1/<project-key>').replace(/\/(board)(s)?\/([0-9]+)/g, '/$1$2/<board-id>').replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>') // persisted queries
    .replace(/\/user\/[a-fA-F0-9\-:]+/i, '/user/<user-id>') // engage targeting
    .replace(/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/i, '<uuid>').replace(/\/\d+$/i, '/<id>');
    return fileName;
};
const $62857d62cfaca9d3$export$8fa71550bcdc2104 = {
    sanitiseEndpoints: $62857d62cfaca9d3$var$sanitiseEndpoints,
    mapResources: $62857d62cfaca9d3$var$getFileName,
    hasTimingHeaders: (url)=>url.includes('jira-frontend-static') || url.includes('jira-frontend-branch') || url.includes('jira-frontend-bifrost') || $62857d62cfaca9d3$var$isWRMResource(url),
    // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
    xhrFilter: (url)=>url.includes('/rest/greenhopper/')
};

});

parcelRegister("87apk", function(module, exports) {

$parcel$export(module.exports, "jiraSsrConfig", () => $4cf88641c7b36da7$export$7bcf91e323db67dd);

var $fqICx = parcelRequire("fqICx");

var $6uWhG = parcelRequire("6uWhG");

var $gPCSe = parcelRequire("gPCSe");

var $7jTnu = parcelRequire("7jTnu");

var $hWeHP = parcelRequire("hWeHP");

/** given a timings object, add a timer that starts at the earliest start time and ends at the latest end time */ function $4cf88641c7b36da7$var$insertTotalTiming(/**
	 * key of the total timing that will be inserted to the given timings object
	 */ key, timings) {
    const timingValues = timings && Object.values(timings);
    if (!timingValues || !timingValues.length) return timings;
    const startTime = Math.min(...timingValues.map(({ startTime: startTime })=>startTime));
    const endTime = timingValues.reduce((max, { startTime: startTime, duration: duration })=>Math.max(max, startTime + duration), 0);
    const duration = endTime - startTime;
    // eslint-disable-next-line no-param-reassign
    timings[key] = {
        startTime: startTime,
        duration: duration
    };
    return timings;
}
/**
 * Apply key and startTimOffset overrides to a timings object
 */ function $4cf88641c7b36da7$var$applyTimingOverrides(timings, { startTimeOffsetMs: startTimeOffsetMs = 0, prefix: prefix = '' } = {}) {
    return timings && Object.fromEntries(Object.entries(timings).map(([key, value])=>{
        const startTime = value.startTime + startTimeOffsetMs;
        return [
            [
                prefix,
                key
            ].filter(Boolean).join('/'),
            {
                ...value,
                startTime: startTime
            }
        ];
    }));
}
function $4cf88641c7b36da7$var$getTesseractTimings() {
    if (!globalThis.SPA_STATE) return null;
    const detailRenderTrace = globalThis.SPA_STATE['ssr/detail_render_trace'];
    const detailRelayFetch = globalThis.SPA_STATE['ssr/relay_fetch'];
    const detailRequestTrace = globalThis.SPA_STATE['ssr/detail_request_trace'];
    const highLevelMetrics = globalThis.SPA_STATE['ssr/metrics'];
    const timings = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(detailRenderTrace?.data?.traces) || {};
    if (highLevelMetrics?.data) {
        if ('ssrTotal' in highLevelMetrics.data) {
            // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
            const totalKey = '';
            timings[totalKey] = {
                startTime: 0,
                duration: highLevelMetrics.data.ssrTotal
            };
        }
        if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
            startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
            duration: highLevelMetrics.data.ssrGetStyle
        };
        if ('ssrPrefetch' in highLevelMetrics.data) {
            const prefetchStartTime = Object.values(detailRequestTrace?.data || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
            timings.prefetch = {
                startTime: prefetchStartTime,
                duration: highLevelMetrics.data.ssrPrefetch
            };
        }
    }
    if (detailRequestTrace?.data) Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
        timings[`prefetch/${key}`] = value;
    });
    if (detailRelayFetch) {
        const relayFetchTimings = Object.fromEntries(Object.entries(detailRelayFetch ?? {}).map(([key, value])=>[
                `relay/${key}`,
                value
            ]));
        $4cf88641c7b36da7$var$insertTotalTiming('relay', relayFetchTimings);
        Object.assign(timings, relayFetchTimings);
    }
    let timingsWithContext = timings;
    if ((0, $7jTnu.fg)('jira-ufo-align-edge-client-ttfb')) {
        // If there's a server-timing for tesseract, that represents the pre-work before script execution starts, referred to as contextGlobalsSetup
        const serverTimingsByName = $4cf88641c7b36da7$var$getServerTimingsByName();
        // This will become available when EDGE-8510 is complete
        const contextGlobalsSetup = serverTimingsByName.tesseract?.duration;
        if (contextGlobalsSetup != null) {
            timingsWithContext = $4cf88641c7b36da7$var$applyTimingOverrides(timings, {
                startTimeOffsetMs: contextGlobalsSetup
            });
            timingsWithContext && Object.assign(timingsWithContext, {
                contextGlobalsSetup: {
                    startTime: 0,
                    duration: contextGlobalsSetup
                }
            });
        }
    }
    return $4cf88641c7b36da7$var$insertTotalTiming('', timingsWithContext); // while there is already a 'ssrTotal', it seems to exclude some timings, so we'll take the end to end as the actual total time
}
// add early-flush/ prefix to timing keys which are early flush timings
const $4cf88641c7b36da7$var$jiraFeGatewayEarlyFlushKeys = new Set([
    'metatags',
    'feature-flags',
    'statsig',
    'inline-assets',
    'async-inline-assets',
    'css-assets',
    'priority-assets',
    'early-route-flush'
]);
// and filter out these keys since they are not UFO visualisation friendly
const $4cf88641c7b36da7$var$jiraFeGatewayFilteredKeys = [
    'early-common-flush',
    'prerender-total',
    'resolve-assets'
];
function $4cf88641c7b36da7$var$getJiraFeGatewayTimings() {
    const rawTimings = globalThis._JFGTimings;
    if (!rawTimings) return null;
    const jiraFeGatewayTimings = Object.fromEntries(rawTimings.filter(({ name: name })=>!$4cf88641c7b36da7$var$jiraFeGatewayFilteredKeys.includes(name)).map(({ startTime: startTime, duration: duration, name: name })=>[
            $4cf88641c7b36da7$var$jiraFeGatewayEarlyFlushKeys.has(name) ? `early-flush/${name}` : name,
            {
                startTime: startTime,
                duration: duration
            }
        ]));
    return $4cf88641c7b36da7$var$insertTotalTiming(// there's no end to end timer so we calculate one
    '', jiraFeGatewayTimings);
}
function $4cf88641c7b36da7$var$getLegacyMonolithTimingDuration(timingMetricKey) {
    /* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */ const inputElementWithTimingValue = globalThis.document?.querySelector(`#jira_request_timing_info [title="${timingMetricKey}"]`);
    return Number(inputElementWithTimingValue?.value ?? 0);
}
function $4cf88641c7b36da7$var$getLegacyJiraMonolithTimings() {
    const duration = $4cf88641c7b36da7$var$getLegacyMonolithTimingDuration('jira.request.server.time');
    if (!duration) // if we don't have this, fallback to no jira timings, we might be going through bifrost instead
    return null;
    const timings = {
        // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
        '': {
            startTime: 0,
            duration: duration
        },
        'flush-head': {
            startTime: 0,
            duration: $4cf88641c7b36da7$var$getLegacyMonolithTimingDuration('jira.request.server.head.time')
        }
    };
    return timings;
}
const $4cf88641c7b36da7$var$monolithTimerRenames = {
    'jira-request-server-time': ''
};
function $4cf88641c7b36da7$var$getJiraMonolithTimings() {
    if (!globalThis._monolithTimings) return $4cf88641c7b36da7$var$getLegacyJiraMonolithTimings();
    return Object.fromEntries(Object.entries(globalThis._monolithTimings).map(([name, { start: startTime, duration: duration }])=>[
            $4cf88641c7b36da7$var$monolithTimerRenames[name] ?? name,
            {
                startTime: startTime,
                duration: duration
            }
        ]));
}
function $4cf88641c7b36da7$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings) {
    if (jiraBeTimings || !tesseractTimings) return null;
    if ((0, $7jTnu.fg)('jira-ufo-align-edge-client-ttfb')) {
        const serverTimingsByName = $4cf88641c7b36da7$var$getServerTimingsByName();
        // This will become available when EDGE-8510 is complete
        const bifrostInternal = serverTimingsByName.bifrost;
        const bifrostInternalDuration = bifrostInternal?.duration ?? 0;
        const timings = {
            ...bifrostInternal && {
                internal: {
                    startTime: 0,
                    duration: bifrostInternalDuration
                }
            },
            tesseract: {
                startTime: bifrostInternalDuration,
                duration: tesseractTimings[''].duration
            }
        };
        return $4cf88641c7b36da7$var$insertTotalTiming('', timings);
    } else {
        // this is a placeholder function, we don't get any real bifrost timings yet
        // in the meantime, let's set a placeholder only if we have no monolith timings and some tesseract timings
        const timings = {
            // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
            '': {
                startTime: 0,
                duration: tesseractTimings[''].duration
            }
        };
        return timings;
    }
}
/**
 * Get the offset required to align the ending of the timerToShift with the ending of the referenceTimer
 * But if the referenceTimer is smaller than the timerToShift (it shouldn't be, this is for timerToShifts that in practice are triggered within the reference timer)
 * then at least align the start times
 */ function $4cf88641c7b36da7$var$getOffsetToAlignTimers(referenceTimer, timerToShift) {
    if (!referenceTimer || !timerToShift) return null;
    if (referenceTimer.duration >= timerToShift.duration) return referenceTimer.startTime + referenceTimer.duration - (timerToShift.startTime + timerToShift.duration);
    else return referenceTimer.startTime - timerToShift.startTime;
}
function $4cf88641c7b36da7$var$getJfgOffset({ jiraFeGatewayTimings: jiraFeGatewayTimings, jiraBeTimings: jiraBeTimings }) {
    // Push back the start of jfg so it's ending aligns with either the full monolith time or if we have the more specific timer for fetching jfg, use that
    const jiraBeTiming = jiraBeTimings?.['jira-monolith/feGateway'] ?? jiraBeTimings?.['jira-monolith'];
    return $4cf88641c7b36da7$var$getOffsetToAlignTimers(jiraBeTiming, jiraFeGatewayTimings?.['']) ?? 0;
}
/**
 * Get the offset required to align the ending of the tesseract timer with either
 * the ending of the jira-fe-gateway/fetch-tesseract timer or the bifrost-gateway timer
 */ function $4cf88641c7b36da7$var$getTesseractOffset({ tesseractTimings: tesseractTimings, jiraFeGatewayTimings: jiraFeGatewayTimings, bifrostGatewayTimings: bifrostGatewayTimings }) {
    const jiraFeGatewayTiming = jiraFeGatewayTimings?.['jira-fe-gateway/fetch-tesseract'];
    const jiraBeTesseractOffest = $4cf88641c7b36da7$var$getOffsetToAlignTimers(jiraFeGatewayTiming, tesseractTimings?.['']);
    const bifrostGatewayTiming = bifrostGatewayTimings?.['bifrost-gateway'];
    const bifrostOffset = $4cf88641c7b36da7$var$getOffsetToAlignTimers(bifrostGatewayTiming, tesseractTimings?.['']);
    return bifrostOffset ?? jiraBeTesseractOffest ?? 0;
}
function $4cf88641c7b36da7$var$getEdgeTime() {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const navigatonPerfTimingEntry = (0, $gPCSe.default)?.getEntriesByType('navigation')?.[0];
    return navigatonPerfTimingEntry?.serverTiming?.find(({ name: name })=>name === 'atl-edge-internal')?.duration ?? 0;
}
function $4cf88641c7b36da7$var$getPerformanceNavigationTiming() {
    // getEntriesByType doesn't change the returned type based on the given type key
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $gPCSe.default).getEntriesByType('navigation')?.[0];
}
function $4cf88641c7b36da7$var$getServerTimingsByName() {
    const serverTimingsByName = Object.fromEntries($4cf88641c7b36da7$var$getPerformanceNavigationTiming()?.serverTiming?.map((timing)=>[
            timing.name,
            timing
        ]) ?? []);
    return serverTimingsByName;
}
function $4cf88641c7b36da7$var$getEdgeTimings() {
    const serverTimingsByName = $4cf88641c7b36da7$var$getServerTimingsByName();
    const edgeDurations = {
        'edge/internal': serverTimingsByName['atl-edge-internal']?.duration,
        'edge/ttfb': serverTimingsByName['atl-edge']?.duration
    };
    const edgeOffset = $4cf88641c7b36da7$var$getEdgeOffset(edgeDurations['edge/ttfb']);
    // Object.fromEntries doesn't generically type keys properly, so TS can't infer a fully typed object from known keys
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let edgeTimings = Object.fromEntries(Object.entries(edgeDurations).filter(([_, duration])=>duration != null).map(([key, duration])=>[
            key,
            {
                startTime: edgeOffset,
                duration: duration
            }
        ]));
    edgeTimings = $4cf88641c7b36da7$var$insertTotalTiming('edge', edgeTimings);
    // we need a timer here to prevent UFO pipeline from shifting SSR timers to start at 0
    edgeTimings?.edge && edgeOffset && Object.assign(edgeTimings, {
        'client-network': {
            startTime: 0,
            duration: edgeOffset
        }
    });
    return edgeTimings;
}
/**
 * If we have the edge's view of ttfb and the clients view as well, then we should take the gap between them as
 * the offset to use foe edge start time.
 * This will simulate the network delays between the client and the edge as an edge startTime increase
 */ function $4cf88641c7b36da7$var$getEdgeOffset(edgeTtfb) {
    const clientTtfb = $4cf88641c7b36da7$var$getPerformanceNavigationTiming()?.responseStart;
    if (edgeTtfb == null || clientTtfb == null) return 0;
    return clientTtfb - edgeTtfb;
}
function $4cf88641c7b36da7$export$6d488733a547304() {
    const jiraBeTimings = $4cf88641c7b36da7$var$getJiraMonolithTimings();
    const jiraFeGatewayTimings = $4cf88641c7b36da7$var$getJiraFeGatewayTimings();
    const tesseractTimings = $4cf88641c7b36da7$var$getTesseractTimings();
    const bifrostGatewayTimings = $4cf88641c7b36da7$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings);
    let edgeTime;
    let edgeTimings;
    if ((0, $7jTnu.fg)('jira-ufo-align-edge-client-ttfb')) {
        edgeTimings = $4cf88641c7b36da7$var$getEdgeTimings();
        edgeTime = (edgeTimings?.['edge/internal']?.duration ?? 0) + (edgeTimings?.['edge/internal']?.startTime ?? 0);
    } else {
        edgeTime = $4cf88641c7b36da7$var$getEdgeTime();
        edgeTimings = edgeTime ? {
            edge: {
                startTime: 0,
                duration: edgeTime
            }
        } : null;
    }
    const finalJiraBeTimings = $4cf88641c7b36da7$var$applyTimingOverrides(jiraBeTimings, {
        startTimeOffsetMs: edgeTime,
        prefix: 'jira-monolith'
    });
    const finalBifrostGatewayTimings = $4cf88641c7b36da7$var$applyTimingOverrides(bifrostGatewayTimings, {
        startTimeOffsetMs: edgeTime,
        prefix: 'bifrost-gateway'
    });
    const jfgOffset = $4cf88641c7b36da7$var$getJfgOffset({
        jiraFeGatewayTimings: jiraFeGatewayTimings,
        jiraBeTimings: finalJiraBeTimings
    });
    const finalJfgTimings = $4cf88641c7b36da7$var$applyTimingOverrides(jiraFeGatewayTimings, {
        startTimeOffsetMs: jfgOffset,
        prefix: 'jira-fe-gateway'
    });
    const tesseractOffset = $4cf88641c7b36da7$var$getTesseractOffset({
        tesseractTimings: tesseractTimings,
        jiraFeGatewayTimings: finalJfgTimings,
        bifrostGatewayTimings: finalBifrostGatewayTimings
    });
    const finalTesseractTimings = $4cf88641c7b36da7$var$applyTimingOverrides(tesseractTimings, {
        startTimeOffsetMs: tesseractOffset,
        prefix: 'tesseract'
    });
    const timings = {
        ...edgeTimings,
        ...finalJiraBeTimings,
        ...finalJfgTimings,
        ...finalBifrostGatewayTimings,
        ...finalTesseractTimings
    };
    $4cf88641c7b36da7$var$insertTotalTiming('total', timings); // UFO treats 'total' as a special key for ssr timings that translates to 'ssr'
    return Object.keys(timings).length ? timings : null;
}
const $4cf88641c7b36da7$var$SSR_FF_META_TAG = 'spa-service-flags';
let $4cf88641c7b36da7$var$ffCache;
let $4cf88641c7b36da7$var$ffCacheInitialiser = ()=>{
    try {
        const metaTagValue = (0, $hWeHP.default)($4cf88641c7b36da7$var$SSR_FF_META_TAG);
        if (metaTagValue === null) return null;
        $4cf88641c7b36da7$var$ffCache = JSON.parse(metaTagValue) || null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        $4cf88641c7b36da7$var$ffCache = null;
    }
    $4cf88641c7b36da7$var$ffCacheInitialiser = null;
};
function $4cf88641c7b36da7$var$getFeatureFlags() {
    if ($4cf88641c7b36da7$var$ffCacheInitialiser != null) $4cf88641c7b36da7$var$ffCacheInitialiser();
    return $4cf88641c7b36da7$var$ffCache;
}
function $4cf88641c7b36da7$var$isAnyRouteResourceFetchErrors() {
    return Object.values(globalThis.SPA_STATE?.['ssr/detail_request_trace']?.data ?? {}).some((timing)=>timing?.failureReason);
}
function $4cf88641c7b36da7$var$isAnyReactRenderErrors() {
    return !!globalThis.SPA_STATE?.['ssr/render_errors']?.count;
}
function $4cf88641c7b36da7$var$isAnyEntryPointFetchErrors() {
    return !!globalThis.SPA_STATE?.['ssr/entry_point_status']?.match(/error|timeout/);
}
function $4cf88641c7b36da7$var$isEarlyFlushSuccessful() {
    return !!(0, $gPCSe.default)?.getEntriesByName('ssr.spa.early-common-flush:end');
}
function $4cf88641c7b36da7$var$getDoneMark() {
    return (0, $6uWhG.getMark)((0, $2e47af044bce450a$export$135c96ab5afee429))?.startTime || null;
}
const $4cf88641c7b36da7$export$7bcf91e323db67dd = {
    getDoneMark: $4cf88641c7b36da7$var$getDoneMark,
    getSsrPhaseSuccess: ()=>{
        const prefetch = !!globalThis.SPA_STATE && !$4cf88641c7b36da7$var$isAnyEntryPointFetchErrors() && !$4cf88641c7b36da7$var$isAnyRouteResourceFetchErrors();
        const earlyFlush = $4cf88641c7b36da7$var$isEarlyFlushSuccessful();
        const render = !$4cf88641c7b36da7$var$isAnyReactRenderErrors();
        return {
            prefetch: prefetch,
            earlyFlush: earlyFlush,
            ...(0, $7jTnu.fg)('jira-ufo-ssr-success-coverage-improvement') ? {
                done: !!$4cf88641c7b36da7$var$getDoneMark() && render && earlyFlush && prefetch
            } : undefined
        };
    },
    getTimings: $4cf88641c7b36da7$export$6d488733a547304,
    getFeatureFlags: $4cf88641c7b36da7$var$getFeatureFlags
};

});


parcelRegister("3Te4N", function(module, exports) {

$parcel$export(module.exports, "getClientReceiver", () => $520137ca1d51c5be$export$60624ad9eb1ec31a);

var $fGcgi = parcelRequire("fGcgi");



var $58Ojv = parcelRequire("58Ojv");
let $520137ca1d51c5be$var$receiver;
function $520137ca1d51c5be$export$60624ad9eb1ec31a() {
    // special-case: if server, bail early and do nothing
    if (false || !globalThis.document) return;
    if (!$520137ca1d51c5be$var$receiver) {
        const dispatcher = (0, $fGcgi.getClientDispatcher)();
        const sink = dispatcher.ingest.bind(dispatcher);
        $520137ca1d51c5be$var$receiver = new (0, $58Ojv.ClientReceiver)(globalThis.document, sink);
        $520137ca1d51c5be$var$receiver.fulfilled().then(()=>{
            sink({
                id: (0, $a7124bed15c191d7$export$eb5d9c90d65c7fea),
                name: '_abort',
                args: [
                    {
                        reason: (0, $6ac276f792432a33$export$7adffed1e707770c)
                    }
                ]
            });
        });
    }
    return $520137ca1d51c5be$var$receiver;
}

});
const $6ac276f792432a33$export$7adffed1e707770c = 'SERVER_HTTP_RESPONSE_ENDED';

parcelRegister("58Ojv", function(module, exports) {

$parcel$export(module.exports, "ClientReceiver", () => $887bde17b6dfdb7b$export$c5eb37f83f5ef9db);
const $887bde17b6dfdb7b$var$ELEMENT_SELECTOR = 'script[data-clientjs]';
/**
 * We need to wait for slightly longer than 0ms. Waiting 4ms is enough
 * to guarantee the browser has processed any pending layout operations
 * that may yield further DOM content.
 */ const $887bde17b6dfdb7b$var$DOM_RENDER_MS = 4;
class $887bde17b6dfdb7b$export$c5eb37f83f5ef9db {
    #doc;
    #fulfilled;
    #onEvent;
    constructor(doc, onEvent){
        this.#doc = doc;
        this.#onEvent = onEvent;
        // consume any instructions that arrived before we initialised
        this.#doc.querySelectorAll($887bde17b6dfdb7b$var$ELEMENT_SELECTOR).forEach((el)=>this.#handleServerToClientElement(el));
        // Bail early if DOM is already ready, otherwise observe for new instructions until it is.
        this.#fulfilled = this.#doc.readyState === 'complete' ? Promise.resolve() : new Promise((resolve)=>{
            this.#observe(resolve);
        });
    }
    #observe(resolve) {
        // observe the document for changes
        const observer = new MutationObserver((mutations)=>this.#handleMutation(mutations));
        observer.observe(this.#doc.body, {
            attributes: false,
            childList: true,
            subtree: false
        });
        // only keep trying until DOM ready, then give up.
        this.#doc.addEventListener('DOMContentLoaded', ()=>{
            setTimeout(()=>{
                observer.disconnect();
                resolve();
            }, $887bde17b6dfdb7b$var$DOM_RENDER_MS + 1);
        }, {
            once: true
        });
    }
    #handleMutation(mutations) {
        for (const mutation of mutations){
            if (mutation.type === 'childList') for (const node of mutation.addedNodes){
                if (node.nodeType === Node.ELEMENT_NODE && node instanceof HTMLElement) {
                    if (node.matches($887bde17b6dfdb7b$var$ELEMENT_SELECTOR)) setTimeout(()=>this.#handleServerToClientElement(node), $887bde17b6dfdb7b$var$DOM_RENDER_MS);
                }
            }
        }
    }
    #handleServerToClientElement(el) {
        const events = el.textContent?.trim().split('\n');
        if (!events) return;
        for (const event of events){
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const payload = JSON.parse(event);
            this.#onEvent(payload);
        }
    }
    fulfilled() {
        return this.#fulfilled;
    }
}

});


parcelRegister("9aXOX", function(module, exports) {

$parcel$export(module.exports, "visualRefreshResolverOverride", () => $d5b8ada04860b81e$export$73a94df81a7c0f2c);

var $6XJko = parcelRequire("6XJko");
const $d5b8ada04860b81e$var$visualRefreshPlatformFlags = [
    'platform-component-visual-refresh',
    'platform-visual-refresh-icons'
];
const $d5b8ada04860b81e$export$73a94df81a7c0f2c = [
    (flagKey)=>$d5b8ada04860b81e$var$visualRefreshPlatformFlags.includes(flagKey),
    (0, $6XJko.isVisualRefreshEnabled)
];

});

parcelRegister("jqynJ", function(module, exports) {

$parcel$export(module.exports, "AtlaspackMetricsConnector", () => $b893ce7dd042cb84$export$a0da2371f93e56de);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $2Mqjh = parcelRequire("2Mqjh");

var $1KdDN = parcelRequire("1KdDN");

var $gUusB = parcelRequire("gUusB");
function $b893ce7dd042cb84$export$2e97bdb0a62c1cbf() {
    if (!(0, $7jTnu.fg)('atlaspack_runtime_metrics')) return ()=>{
    /**/ };
    const fn = async (event)=>{
        try {
            if (event.detail === undefined || !event.detail.action) return;
            const { action: action, attributes: attributes = {} } = event.detail;
            // Get client or wait for it to initialize
            const analyticsWebClient = await (0, $2Mqjh.getAnalyticsWebClientPromise)();
            const analyticsClient = analyticsWebClient.getInstance();
            // Fire event
            analyticsClient.sendOperationalEvent({
                source: 'devinfra-app-framework',
                actionSubject: 'atlaspack',
                action: action,
                attributes: {
                    ...attributes,
                    ...(0, $gUusB.pageContext)()
                }
            });
        } catch (error) {
        // Suppress
        }
    };
    globalThis.addEventListener('atlaspack:analytics', fn);
    return ()=>globalThis.removeEventListener('atlaspack:analytics', fn);
}
function $b893ce7dd042cb84$var$AtlaspackMetricsConnectorInner() {
    (0, $eJOHy.useEffect)($b893ce7dd042cb84$export$2e97bdb0a62c1cbf, [
        globalThis
    ]);
    return null;
}
function $b893ce7dd042cb84$export$a0da2371f93e56de() {
    if (!(0, $7jTnu.fg)('atlaspack_runtime_metrics')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "atlaspack_runtime_metrics",
        packageName: "@atlassian/jira-atlaspack-global-metrics",
        fallback: "unmount",
        teamName: "devinfra-app-framework"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b893ce7dd042cb84$var$AtlaspackMetricsConnectorInner, null));
}

});
parcelRegister("gUusB", function(module, exports) {

$parcel$export(module.exports, "pageContext", () => $c4d80c93620da8aa$export$bb8fabbb9eed884a);

var $kQnVX = parcelRequire("kQnVX");
function $c4d80c93620da8aa$export$bb8fabbb9eed884a() {
    return {
        routeName: $c4d80c93620da8aa$var$getSafe(()=>(0, $kQnVX.getUserLocation)()),
        userLocation: $c4d80c93620da8aa$var$getSafe(()=>(0, $kQnVX.getRouteName)()),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        bundlerVersion: $c4d80c93620da8aa$var$getSafe(()=>globalThis.BUNDLER_VERSION),
        buildVariant: $c4d80c93620da8aa$var$getSafe(()=>globalThis.BUILD_VARIANT)
    };
}
function $c4d80c93620da8aa$var$getSafe(fn) {
    try {
        return fn();
    } catch (error) {
        return 'unknown';
    }
}

});


parcelRegister("a0zLT", function(module, exports) {

$parcel$export(module.exports, "initEntryPointConfig", () => $3fae59c5d23089f8$export$93a6801f9db838c4);

var $eJOHy = parcelRequire("eJOHy");

var $16sa1 = parcelRequire("16sa1");

var $ch9En = parcelRequire("ch9En");

var $bwN6U = parcelRequire("bwN6U");

var $1qbKn = parcelRequire("1qbKn");
const $3fae59c5d23089f8$var$ModalErrorFallback = ({ error: error })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorFlagRenderer), {
        id: "",
        error: error
    });
};
function $3fae59c5d23089f8$export$93a6801f9db838c4() {
    (0, $bwN6U.initEntryPointConfig)({
        PlaceholderComponent: ({ name: name, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
                name: name || '',
                ...props
            }),
        UFOSegmentComponent: (0, $16sa1.default),
        ModalErrorFallback: $3fae59c5d23089f8$var$ModalErrorFallback
    });
}

});

parcelRegister("9Szlh", function(module, exports) {

$parcel$export(module.exports, "default", () => $576e35908a4913e8$export$2e2bcd8739ae039);

var $jFHCE = parcelRequire("jFHCE");

var $JdXiI = parcelRequire("JdXiI");

var $hWeHP = parcelRequire("hWeHP");

var $7jTnu = parcelRequire("7jTnu");

var $k2wyf = parcelRequire("k2wyf");

var $82Phg = parcelRequire("82Phg");

const $576e35908a4913e8$var$renderEngagementMessages = ()=>{
    (parcelRequire("lRcdd"));
};

const $576e35908a4913e8$var$renderProfileCardNextLegacy = ()=>{
    (parcelRequire("9QBbr"));
};

const $576e35908a4913e8$var$renderHeartbeat = ()=>{
    (parcelRequire("lHTxV"));
};

const $576e35908a4913e8$var$loadUpFlowAPI = ()=>(parcelRequire("4SHcb"));

const $576e35908a4913e8$var$installConnectModules = ()=>(parcelRequire("5LqWE"));
const $576e35908a4913e8$var$markSafeForAnalytics = (str)=>str || null;
const $576e35908a4913e8$var$renderSearchDwellTimeComponent = ()=>{
    const searchSessionId = (0, $hWeHP.default)('ajs-search-session-id');
    const containerId = (0, $hWeHP.default)('ajs-search-container-id');
    const objectId = (0, $hWeHP.default)('ajs-search-object-id');
    const objectType = (0, $hWeHP.default)('ajs-search-content-type');
    (0, $JdXiI.default)([
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ]);
    (0, $82Phg.default)('search-dwell-time', $576e35908a4913e8$var$markSafeForAnalytics(searchSessionId), {
        containerId: $576e35908a4913e8$var$markSafeForAnalytics(containerId),
        objectId: $576e35908a4913e8$var$markSafeForAnalytics(objectId),
        objectType: $576e35908a4913e8$var$markSafeForAnalytics(objectType),
        actionSubject: $576e35908a4913e8$var$markSafeForAnalytics(objectType),
        source: $576e35908a4913e8$var$markSafeForAnalytics(objectType)
    });
};
const $576e35908a4913e8$var$installHighPriorityApps = (args)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'JiraContextContainer'.
    const priorityApps = [];
    if (args.flags) priorityApps.push((0, $k2wyf.renderFlags)());
    if (args.navigation) priorityApps.push(args.renderNavigation());
    if (args.engagementMessages && (0, $7jTnu.fg)('remove_priority_ranking_for_global_spa')) $576e35908a4913e8$var$renderEngagementMessages();
    return priorityApps;
};
const $576e35908a4913e8$var$installHighPrioritySPAApps = ()=>{
    (0, $k2wyf.renderFlags)();
    $576e35908a4913e8$var$renderEngagementMessages();
    $576e35908a4913e8$var$installConnectModules();
    $576e35908a4913e8$var$renderHeartbeat();
    $576e35908a4913e8$var$renderSearchDwellTimeComponent();
};
const $576e35908a4913e8$var$installLowPrioritySPAApps = ()=>{
    $576e35908a4913e8$var$renderProfileCardNextLegacy();
};
const $576e35908a4913e8$var$installLowPriorityApps = (args)=>{
    if (args.upflow) $576e35908a4913e8$var$loadUpFlowAPI();
    if (args.profileCardNextLegacy) $576e35908a4913e8$var$renderProfileCardNextLegacy();
    if (args.connectModules) $576e35908a4913e8$var$installConnectModules();
    if (args.engagementMessages && !(0, $7jTnu.fg)('remove_priority_ranking_for_global_spa')) $576e35908a4913e8$var$renderEngagementMessages();
    if (args.heartbeat) $576e35908a4913e8$var$renderHeartbeat();
    if (args.searchDwellTimeComponent) $576e35908a4913e8$var$renderSearchDwellTimeComponent();
};
const $576e35908a4913e8$var$installAppsWithPriorityOrder = async (args)=>{
    await Promise.all($576e35908a4913e8$var$installHighPriorityApps({
        flags: args.flags,
        navigation: args.navigation,
        renderNavigation: args.renderNavigation
    }));
    $576e35908a4913e8$var$installLowPriorityApps((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(args, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
};
const $576e35908a4913e8$var$defaultArgs = {
    flags: true,
    navigation: true,
    upflow: true,
    profileCardNextLegacy: true,
    heartbeat: true,
    connectModules: true,
    engagementMessages: true,
    searchDwellTimeComponent: true,
    renderNavigation: ()=>null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$576e35908a4913e8$export$2e2bcd8739ae039 = {
    install: (args)=>{
        const argsWithDefaults = {
            ...$576e35908a4913e8$var$defaultArgs,
            ...args
        };
        // @ts-expect-error - TS2345 - Argument of type '{ flags: boolean; navigation: boolean; renderNavigation: (() => any) | (() => null); upflow: boolean; heartbeat: boolean; profileCardNextLegacy: boolean; connectModules: boolean; originTracing?: boolean | undefined; engagementMessages: boolean; searchDwellTimeComponent: boolean; }' is not assignable to parameter of type 'GlobalArgs'.
        $576e35908a4913e8$var$installAppsWithPriorityOrder(argsWithDefaults);
    },
    installHighPrioritySPAApps: $576e35908a4913e8$var$installHighPrioritySPAApps,
    installLowPrioritySPAApps: $576e35908a4913e8$var$installLowPrioritySPAApps,
    installHighPriorityAppsOld: (args)=>{
        const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
            ...$576e35908a4913e8$var$defaultArgs,
            ...args
        };
        $576e35908a4913e8$var$installHighPriorityApps({
            flags: flags,
            navigation: navigation,
            renderNavigation: renderNavigation
        });
    },
    installLowPriorityAppsOld: (args)=>{
        const installArgs = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))({
            ...$576e35908a4913e8$var$defaultArgs,
            ...args
        }, [
            'flags',
            'navigation',
            'renderNavigation'
        ]);
        $576e35908a4913e8$var$installLowPriorityApps(installArgs);
    }
};

});
parcelRegister("k2wyf", function(module, exports) {

$parcel$export(module.exports, "renderFlags", () => $63a4d32205620443$export$b6228dc14c5adf51);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $eSnSE = parcelRequire("eSnSE");

var $4QIXk = parcelRequire("4QIXk");

var $xvuCV = parcelRequire("xvuCV");

var $1PSAp = parcelRequire("1PSAp");

var $gzcjr = parcelRequire("gzcjr");
const $63a4d32205620443$var$throwError = (message)=>{
    const error = new Error(message);
    (0, $eSnSE.default).safeErrorWithoutCustomerData('flags.entry', message, error);
    throw error;
};
const $63a4d32205620443$var$getContainer = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let container = document.getElementById('flags');
    if (container == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        container = document.createElement('div');
        container.id = 'flags';
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.appendChild(container);
        else $63a4d32205620443$var$throwError('document.body was not found whilst trying to create the flags container');
    }
    return container;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $63a4d32205620443$var$Flags = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("dhvfa")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $63a4d32205620443$var$AfterPaintFlags = (0, $gzcjr.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("dhvfa")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});
const $63a4d32205620443$export$b6228dc14c5adf51 = ()=>(0, $aQK2r.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PSAp.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4QIXk.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: "flags-entry"
    }, __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($63a4d32205620443$var$AfterPaintFlags, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($63a4d32205620443$var$Flags, null)))), $63a4d32205620443$var$getContainer());

});
parcelRegister("4QIXk", function(module, exports) {

$parcel$export(module.exports, "JiraContextContainer", () => $abeaaabc4415d61a$export$6f7845cc5e693f16);

var $eJOHy = parcelRequire("eJOHy");

var $2I68T = parcelRequire("2I68T");

var $4qiFT = parcelRequire("4qiFT");

var $7lk3V = parcelRequire("7lk3V");

var $k9PyW = parcelRequire("k9PyW");

var $hWeHP = parcelRequire("hWeHP");

var $3nRRD = parcelRequire("3nRRD");

var $iOVHp = parcelRequire("iOVHp");

var $fEmyV = parcelRequire("fEmyV");

var $4xbv3 = parcelRequire("4xbv3");

var $5HFSX = parcelRequire("5HFSX");

var $g9Vr6 = parcelRequire("g9Vr6");

var $lvKO5 = parcelRequire("lvKO5");

var $hw1Vu = parcelRequire("hw1Vu");
const $abeaaabc4415d61a$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: (0, $fEmyV.routeAnalyticsAttributes)
    }, children);

const $abeaaabc4415d61a$export$6f7845cc5e693f16 = (props)=>{
    const state = {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        messages: (parcelRequire("hXmA9"))
    };
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($abeaaabc4415d61a$var$ContextualAnalyticsDataFeatureFlagged, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvKO5.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $hWeHP.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvKO5.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nRRD.IntlProvider), {
            messages: state.messages,
            locale: (0, $4qiFT.standardizeLocale)(tenantContext.locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2I68T.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7lk3V.default), {
            orgId: orgId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k9PyW.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5HFSX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iOVHp.ModalContextProvider), null, props.children)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hw1Vu.LoadingPhaseManager), null));
};

});
parcelRegister("hw1Vu", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $76a270903de176ca$export$6e4bfef9e80c7eb0);

var $eJOHy = parcelRequire("eJOHy");

var $6VquU = parcelRequire("6VquU");
const $76a270903de176ca$export$6e4bfef9e80c7eb0 = ()=>{
    const { startNextPhase: startNextPhase } = (0, $6VquU.useLazyPhase)();
    (0, $eJOHy.useEffect)(()=>{
        /**
     * Only start next phase if we are not in the SPA, because there is a second
     * LoadingPhaseManager specifically for the SPA, and we want it to transition at the correct time.
     * If we start this here inside the SPA, we will start RLL next phase and get lazyAfterPaint
     * bundles too early.
     */ if (__SPA__) return;
        /* Outside the SPA, we don't currently have a good proxy for page loads.
     * So for now we start the "after paint" phase a few seconds after mounting.
     */ setTimeout(()=>{
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        }, 2000);
    }, [
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("hXmA9", function(module, exports) {
module.exports = __LANG;

});


parcelRegister("dhvfa", function(module, exports) {

let $027ecababd3c5b62$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $027ecababd3c5b62$var$load("cISQq").then(()=>parcelRequire('2VCXr'));

});


parcelRegister("82Phg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4da55c420010ab57$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $1PSAp = parcelRequire("1PSAp");

var $96Fb4 = parcelRequire("96Fb4");
const $4da55c420010ab57$var$getPlaceholder = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const existingPlaceholder = document.getElementById(placeholderId);
    if (existingPlaceholder) return existingPlaceholder;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const div = document.createElement('div');
    div.id = placeholderId;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body.appendChild(div);
    else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
    return div;
};
const $4da55c420010ab57$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
    if (placeholder && sessionId) (0, $aQK2r.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PSAp.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $96Fb4.default), {
        sessionId: sessionId,
        data: data
    })), $4da55c420010ab57$var$getPlaceholder(placeholder));
};
var $4da55c420010ab57$export$2e2bcd8739ae039 = $4da55c420010ab57$var$renderDwellTimeComponent;

});

parcelRegister("lRcdd", function(module, exports) {

let $fe98054823efd3d5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $fe98054823efd3d5$var$load("1VRB2"),
    $fe98054823efd3d5$var$load("bABhq"),
    $fe98054823efd3d5$var$load("7vqGd"),
    $fe98054823efd3d5$var$load("1Y4bq"),
    $fe98054823efd3d5$var$load("63rhN")
]).then(()=>parcelRequire('hog0p'));

});

parcelRegister("9QBbr", function(module, exports) {

let $72b5d03d80a18f3a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $72b5d03d80a18f3a$var$load("1VRB2"),
    $72b5d03d80a18f3a$var$load("bABhq"),
    $72b5d03d80a18f3a$var$load("hwlgY"),
    $72b5d03d80a18f3a$var$load("hrExR")
]).then(()=>parcelRequire('hWg6N'));

});

parcelRegister("lHTxV", function(module, exports) {

let $fcd8b36f65d0584b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fcd8b36f65d0584b$var$load("5Eu2J").then(()=>parcelRequire('7Y0pd'));

});

parcelRegister("4SHcb", function(module, exports) {

let $38ddb647606072a6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $38ddb647606072a6$var$load("ceu3c"),
    $38ddb647606072a6$var$load("1VRB2"),
    $38ddb647606072a6$var$load("bABhq"),
    $38ddb647606072a6$var$load("7vqGd"),
    $38ddb647606072a6$var$load("1Y4bq"),
    $38ddb647606072a6$var$load("fAbxa"),
    $38ddb647606072a6$var$load("fMOSo"),
    $38ddb647606072a6$var$load("jhiae"),
    $38ddb647606072a6$var$load("4v8VH"),
    $38ddb647606072a6$var$load("fh2Sv"),
    $38ddb647606072a6$var$load("k4gbU"),
    $38ddb647606072a6$var$load("eDzss"),
    $38ddb647606072a6$var$load("1G8UW"),
    $38ddb647606072a6$var$load("iSk93"),
    $38ddb647606072a6$var$load("hwlgY"),
    $38ddb647606072a6$var$load("jZqrW")
]).then(()=>parcelRequire('bGpt9'));

});

parcelRegister("5LqWE", function(module, exports) {

let $43263e45768fb052$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $43263e45768fb052$var$load("cr3nX").then(()=>parcelRequire('aWV53'));

});


parcelRegister("ceCro", function(module, exports) {

$parcel$export(module.exports, "reportUnreportedStatsigInitialisationError", () => $9ba1524dd5de4b1d$export$3e2ed5f27f1cf2f1);

var $gYnSx = parcelRequire("gYnSx");

var $fEmyV = parcelRequire("fEmyV");

var $aEA8G = parcelRequire("aEA8G");
const $9ba1524dd5de4b1d$export$3e2ed5f27f1cf2f1 = ()=>{
    if (// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    globalThis.statsigInitialisationFixesPir24496Enabled === true && (0, $aEA8G.unreportedStatsigInitialisationError)) (0, $gYnSx.default)({
        error: (0, $aEA8G.unreportedStatsigInitialisationError),
        meta: {
            id: 'statsig-init-failure',
            teamName: 'uip-app-framework'
        },
        attributes: (0, $fEmyV.routeAnalyticsAttributes),
        skipSentry: false
    });
};

});

parcelRegister("cxSoK", function(module, exports) {

});

parcelRegister("5eRs1", function(module, exports) {

$parcel$export(module.exports, "getIsSsrHydrationEnabled", () => $10b71a4b1b2a007e$export$d230742083bd05c4);
$parcel$export(module.exports, "renderReactApp", () => $10b71a4b1b2a007e$export$10e38d679c5a165c);

var $aQK2r = parcelRequire("aQK2r");

var $FEQwo = parcelRequire("FEQwo");

var $8aMsX = parcelRequire("8aMsX");

var $7jTnu = parcelRequire("7jTnu");

var $kn2Rh = parcelRequire("kn2Rh");
parcelRequire("9unkz");

var $eQBMW = parcelRequire("eQBMW");
const $10b71a4b1b2a007e$export$d230742083bd05c4 = ()=>{
    // We want only 1 source of truth for "should hydrate" (coming from the server),
    // but keep the fg('jfp-magma-force-react-hydrate-root') here for local dev convenience.
    return typeof window !== 'undefined' && window.SPA_STATE?.clientShouldHydrate || (0, $7jTnu.fg)('jfp-magma-force-react-hydrate-root');
};
const $10b71a4b1b2a007e$export$10e38d679c5a165c = (children, { isSsrHydrationEnabled: isSsrHydrationEnabled, container: container })=>{
    if (isSsrHydrationEnabled) {
        if ((0, $7jTnu.fg)('jfp-magma-3742-report-hydration-stats')) (0, $8aMsX.enableHydrationStatReporting)();
        // hydrateRoot also enables concurrent mode, if you enable hydration on your route. It's also assumed you want and understand concurrent mode.
        (0, $FEQwo.hydrateRoot)(container, children, (0, $eQBMW.hydrationOptions));
    } else if ((0, $kn2Rh.getIsConcurrentEnabled)()) {
        // If the route is not enabled for hydration but concurrent mode is enabled for this environment, render in concurrent mode
        const root = (0, $FEQwo.createRoot)(container);
        root.render(children);
    } else // Oldest code path, to be removed once concurrent mode is 100.0% enabled
    (0, $aQK2r.render)(children, container);
};

});
parcelRegister("FEQwo", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $07d383a37d5fda0c$export$882461b6382ed46c, (v) => $07d383a37d5fda0c$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $07d383a37d5fda0c$export$757ceba2d55c277e, (v) => $07d383a37d5fda0c$export$757ceba2d55c277e = v);
var $07d383a37d5fda0c$export$882461b6382ed46c;
var $07d383a37d5fda0c$export$757ceba2d55c277e;
'use strict';

var $aQK2r = parcelRequire("aQK2r");
var $07d383a37d5fda0c$var$i;
$07d383a37d5fda0c$export$882461b6382ed46c = $aQK2r.createRoot;
$07d383a37d5fda0c$export$757ceba2d55c277e = $aQK2r.hydrateRoot;

});

parcelRegister("9unkz", function(module, exports) {
function $684e2f3818431439$export$ba5adf6be0dee098(injectPoint) {
    const windowWithHydrationHooks = injectPoint;
    windowWithHydrationHooks.__HYDRATION_ERRORS__ = [];
    windowWithHydrationHooks.__ATL_HYDRATION_HOOK = {
        report (...args) {
            // eslint-disable-next-line no-console
            console.warn('Hydration error reported:', ...args);
            windowWithHydrationHooks.__HYDRATION_ERRORS__?.push(args);
        }
    };
}

});

parcelRegister("eQBMW", function(module, exports) {

$parcel$export(module.exports, "hydrationOptions", () => $af119e85dec56cc3$export$db3ef87a6e82f2be);

var $8aMsX = parcelRequire("8aMsX");

var $7jTnu = parcelRequire("7jTnu");

var $eSnSE = parcelRequire("eSnSE");

var $es5G8 = parcelRequire("es5G8");
const $af119e85dec56cc3$var$location = 'react-hydrate-root';
const $af119e85dec56cc3$export$db3ef87a6e82f2be = {
    onRecoverableError: (untypedError, errorInfo)=>{
        if (!(0, $7jTnu.fg)('jfp-magma-log-hydration-errors')) return;
        const error = $af119e85dec56cc3$var$extractError(untypedError);
        (0, $eSnSE.default).safeErrorWithoutCustomerData($af119e85dec56cc3$var$location, 'onRecoverableError', error);
        (0, $es5G8.captureException)($af119e85dec56cc3$var$location, error, {
            ...errorInfo
        });
        (0, $8aMsX.addErrorForHydrationStats)(error, errorInfo);
    }
};
const $af119e85dec56cc3$var$extractError = (untypedError)=>{
    if (untypedError instanceof Error) return untypedError;
    try {
        return new Error(`Unknown error occurred during hydration: ${JSON.stringify(untypedError)}`);
    } catch (e) {
        return new Error(String(untypedError));
    }
};

});



parcelRegister("lMumk", function(module, exports) {

$parcel$export(module.exports, "startJiraSpa", () => $cf6c306d04689096$export$f71867a5b2484020);

var $eJOHy = parcelRequire("eJOHy");

var $jFHCE = parcelRequire("jFHCE");

var $8sbs2 = parcelRequire("8sbs2");

var $g1P4j = parcelRequire("g1P4j");

var $5QkZY = parcelRequire("5QkZY");

var $2JM8Q = parcelRequire("2JM8Q");

var $2NzEL = parcelRequire("2NzEL");

var $xTtyc = parcelRequire("xTtyc");

var $gC446 = parcelRequire("gC446");

var $f0nBN = parcelRequire("f0nBN");

var $1Q1XT = parcelRequire("1Q1XT");


var $k8mcw = parcelRequire("k8mcw");
parcelRequire("lXp9u");

var $6uWhG = parcelRequire("6uWhG");

var $ihCSV = parcelRequire("ihCSV");

var $aYncF = parcelRequire("aYncF");

var $2dBpR = parcelRequire("2dBpR");

var $1KdDN = parcelRequire("1KdDN");

var $epTsa = parcelRequire("epTsa");

var $3KIqP = parcelRequire("3KIqP");

var $7jTnu = parcelRequire("7jTnu");

var $3Zulo = parcelRequire("3Zulo");

var $MBWwk = parcelRequire("MBWwk");

var $hW27F = parcelRequire("hW27F");

var $kQnVX = parcelRequire("kQnVX");

var $hih5V = parcelRequire("hih5V");

var $1PSAp = parcelRequire("1PSAp");

var $e8u2a = parcelRequire("e8u2a");

var $lmqkh = parcelRequire("lmqkh");

var $b2uWc = parcelRequire("b2uWc");

var $7grfV = parcelRequire("7grfV");

var $dydef = parcelRequire("dydef");

var $fmwpb = parcelRequire("fmwpb");

var $gNSxk = parcelRequire("gNSxk");

var $ccydf = parcelRequire("ccydf");

var $lZMpx = parcelRequire("lZMpx");

var $aqRAv = parcelRequire("aqRAv");

var $16sa1 = parcelRequire("16sa1");

var $9aXOX = parcelRequire("9aXOX");

var $1jgVa = parcelRequire("1jgVa");
var $gAzn8 = parcelRequire("gAzn8");

var $30bwc = parcelRequire("30bwc");
var $83DiZ = parcelRequire("83DiZ");

var $kfvK2 = parcelRequire("kfvK2");

var $9kysr = parcelRequire("9kysr");

var $jqynJ = parcelRequire("jqynJ");

var $a0zLT = parcelRequire("a0zLT");

var $3Te4N = parcelRequire("3Te4N");

var $9Szlh = parcelRequire("9Szlh");

var $ceCro = parcelRequire("ceCro");
parcelRequire("cxSoK");

var $5eRs1 = parcelRequire("5eRs1");
// Set SPA global
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window.__SPA__ = true;

const $cf6c306d04689096$var$getMessages = ()=>{
    (0, $6uWhG.setMark)('jira-spa/language-pack.start');
    const messages = (parcelRequire("hXmA9"));
    (0, $6uWhG.setMark)('jira-spa/language-pack.end');
    return messages;
};
const $cf6c306d04689096$var$superbatchInit = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.DeferScripts = {
        deferState: 'done'
    };
    if ((0, $7jTnu.fg)('remove_deferred_class_remove')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    {
        if (document.body?.classList.contains('deferred')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body?.classList.remove('deferred');
    } else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body?.classList.remove('deferred');
};
const $cf6c306d04689096$var$globalSettingsArgs = {
    navigation: false,
    upflow: false
};
const $cf6c306d04689096$var$InstallGlobalComponentsOnce = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $7jTnu.fg)('remove_priority_ranking_for_global_spa')) (0, $9Szlh.default).installLowPrioritySPAApps();
        else (0, $9Szlh.default).installLowPriorityAppsOld(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'LowPriorityAppsArgs'.
        (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))($cf6c306d04689096$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        (0, $6uWhG.setMark)('JIRA_SPA_ENTRY_GLOBAL_INSTALL');
    }, []);
    return null;
};
const $cf6c306d04689096$var$updateCapability = (capability)=>{
    (0, $k8mcw.setCapability)(capability);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (capability === null && window.AJS?.$?.ajaxSettings?.headers?.[0, $652f5f63189f3e2a$export$9a80695e72849f84]) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.AJS.$.ajaxSettings.headers[0, $652f5f63189f3e2a$export$9a80695e72849f84];
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS?.$?.ajaxSetup({
        headers: {
            [(0, $652f5f63189f3e2a$export$9a80695e72849f84)]: capability
        }
    });
};
// @ts-expect-error - TS7031 - Binding element 'routes' implicitly has an 'any' type.
const $cf6c306d04689096$var$CapabilityTrackerConnector = ({ routes: routes })=>{
    const { registerBlock: registerBlock } = (0, $83DiZ.useRouterActions)();
    registerBlock((nextLocation)=>{
        const nextMatchObject = (0, $30bwc.default)(routes, nextLocation.pathname, nextLocation.search, '');
        $cf6c306d04689096$var$updateCapability(nextMatchObject?.route.meta?.capability || null);
        return true;
    });
    const route = (0, $hih5V.useCurrentRoute)();
    $cf6c306d04689096$var$updateCapability(route.meta?.capability || null);
    return null;
};
// this will move low priority apps to after TTAI (currently just the async-profilecard (legacy profilecard, only used on legacy experiences like GIN and legacy GIC))
const $cf6c306d04689096$var$LoadPhaseSwitcher = ()=>{
    if ((0, $7jTnu.fg)('remove_priority_ranking_for_global_spa')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MBWwk.BackgroundPriority), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cf6c306d04689096$var$InstallGlobalComponentsOnce, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Zulo.NonCritical), {
        id: "spa-main.client-router.non-critical",
        teamName: "delorean-spa"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cf6c306d04689096$var$InstallGlobalComponentsOnce, null));
};
const $cf6c306d04689096$var$main = async (getInitialRoutes, loadLazyRoutes)=>{
    (0, $6uWhG.setMark)('_jira-spa/main-start');
    const deps = new (0, $ihCSV.SpaBootstrapDependencies)(window);
    // This guarantees we can wait until our dependencies arrive.
    // It's not ideal, because we're blocking immediately upon starting up the SPA.
    // From here the game is to move these promises as far down in to the control flow as possible.
    (0, $6uWhG.setMark)('_jira-spa/main-before-early-deps');
    await Promise.allSettled([
        deps.statsigValues(),
        deps.launchDarklyValues(),
        deps.tenantContext()
    ]);
    (0, $6uWhG.setMark)('_jira-spa/main-after-early-deps');
    (0, $aqRAv.default)();
    (0, $1Q1XT.initBrowserMetrics3)();
    (0, $3KIqP.initPlatformFeatureFlags)((0, $9aXOX.visualRefreshResolverOverride));
    (0, $a0zLT.initEntryPointConfig)();
    (0, $fmwpb.addInitialPageLoadTimings)();
    (0, $3Te4N.getClientReceiver)();
    (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/init', 'jira-spa.js:eval-start');
    (0, $6uWhG.setMark)('jira-spa/setup.start');
    const routes = (0, $dydef.measureInitialPageLoadTiming)('jira-spa/setup/routes', ()=>getInitialRoutes());
    const history = (0, $dydef.measureInitialPageLoadTiming)('jira-spa/setup/history', ()=>(0, $ccydf.default)(routes));
    const initRoute = (0, $dydef.measureInitialPageLoadTiming)('jira-spa/setup/match-route', ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const matchedRoute = (0, $30bwc.default)(routes, window.location.pathname, window.location.search);
        (0, $kQnVX.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
        return matchedRoute;
    });
    if (initRoute != null) {
        const ufoName = (0, $g1P4j.default)(initRoute.route);
        (0, $2JM8Q.default)(ufoName, initRoute.route.name);
    }
    const BrowserMetricsConnector = ()=>{
        const route = (0, $hih5V.useCurrentRoute)();
        (0, $gC446.browserMetrics).setRoute(route.name);
        (0, $2NzEL.useUFOTransitionCompleter)();
        (0, $9kysr.GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey || 'UNKNOWN');
        return null;
    };
    const messages = $cf6c306d04689096$var$getMessages();
    const tenantContext = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const { locale: locale } = tenantContext;
    let routerProps;
    const getRouterProps = (resourceData)=>{
        return {
            history: history,
            routes: routes,
            basePath: '',
            initialRoute: initRoute?.route,
            resourceData: resourceData,
            resourceContext: (0, $lZMpx.getSpaRouterContext)({
                tenantContext: tenantContext
            }),
            onPrefetch: ({ route: route, match: match })=>{
                (0, $gNSxk.setPrefetchStartMark)(match);
                if (!route.forPaint) return;
                route.forPaint.map((component)=>component.preload?.());
            },
            isLazyRoutes: typeof loadLazyRoutes === 'function'
        };
    };
    const SpaClientRouterTemplate = ({ children: children, trackedRoutes: trackedRoutes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmqkh.SpaRouter), {
            routerProps: routerProps,
            before: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
                id: "spa-main.client-router",
                packageName: "jiraEntry",
                fallback: "unmount",
                teamName: "delorean-spa"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jqynJ.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cf6c306d04689096$var$CapabilityTrackerConnector, {
                routes: trackedRoutes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7grfV.default), null)),
            after: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cf6c306d04689096$var$LoadPhaseSwitcher, null)
        }, children);
    let SpaClientRouter;
    if (typeof loadLazyRoutes === 'function') {
        const useRouterRoutes = (0, $kfvK2.createRouterSelector)((state)=>state.routes);
        SpaClientRouter = ({ children: children })=>{
            const actions = (0, $kfvK2.useRouterStoreActions)();
            const currentRoutes = useRouterRoutes();
            (0, $eJOHy.useEffect)(()=>{
                let isCancelled = false;
                const loadRoutes = async ()=>{
                    if (!isCancelled) {
                        const getLazyRoutes = await loadLazyRoutes();
                        await actions.setRoutes(getLazyRoutes());
                    }
                };
                loadRoutes();
                return ()=>{
                    isCancelled = true;
                };
            }, [
                actions
            ]);
            return (0, $7jTnu.fg)('jfp_magma_jira-use-id-sync') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SpaClientRouterTemplate, {
                trackedRoutes: currentRoutes
            }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2uWc.Router), routerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
                id: "spa-main.client-router",
                packageName: "jiraEntry",
                fallback: "unmount",
                teamName: "delorean-spa"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jqynJ.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cf6c306d04689096$var$CapabilityTrackerConnector, {
                routes: currentRoutes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7grfV.default), null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cf6c306d04689096$var$LoadPhaseSwitcher, null));
        };
    } else SpaClientRouter = ({ children: children })=>(0, $7jTnu.fg)('jfp_magma_jira-use-id-sync') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SpaClientRouterTemplate, {
            trackedRoutes: routes
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2uWc.Router), routerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
            id: "spa-main.client-router",
            packageName: "jiraEntry",
            fallback: "unmount",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jqynJ.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cf6c306d04689096$var$CapabilityTrackerConnector, {
            routes: routes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7grfV.default), null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cf6c306d04689096$var$LoadPhaseSwitcher, null));
    const AppWithoutPlaceholders = ({ entryPointPlaceholders: entryPointPlaceholders })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PSAp.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
            name: "jira-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointPlaceholderContext).Provider, {
            value: entryPointPlaceholders
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hW27F.Spa), {
            locale: locale,
            messages: messages,
            Router: SpaClientRouter,
            initRoute: initRoute,
            routes: routes,
            routerLinkComponent: (0, $e8u2a.JiraRouterLinkConfiguration)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__NAV_VERSION__ = '3.0.0';
    (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/setup', 'jira-spa/setup.start', true);
    (0, $6uWhG.setMark)('_jira-spa/spa-shell.start');
    // This function is normally run as soon as the SSR service flushes the DOM element containing the server-rendered HTML.
    // There some conditions in which it could or should be re-run...
    // (1) The SSR service reports a hard failure,
    // (2) The SSR response is taking too long to flush (a soft failure), or
    // (3) Something goes wrong during running the function itself.
    // In any of these cases, the client can choose to run this function again to attempt a recovery.
    const renderSpa = ({ didSsrRenderSpa: didSsrRenderSpa, container: container, spaState: spaState })=>{
        (0, $6uWhG.setMark)('_jira-spa/render-spa-fn-start');
        // Notify whether there was a complete SSR success or if there were render problems.
        (0, $9kysr.GlobalPageLoadExperience).addMetadata({
            didSsrRenderSpa: didSsrRenderSpa
        });
        // SPA_STATE is untyped, but we have passed it in to Router like this for ages and nobody complained.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        routerProps = getRouterProps(spaState);
        (0, $xTtyc.getVCObserver)().setSSRElement(container);
        (0, $xTtyc.getVCObserver)().setReactRootRenderStart();
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                (0, $xTtyc.getVCObserver)().setReactRootRenderStop();
            });
        });
        const isSsrHydrationEnabled = (0, $5eRs1.getIsSsrHydrationEnabled)();
        if ((0, $7jTnu.fg)('jira-spa-bootstrap-changes-2025-03-05')) (0, $1jgVa.LooselyLazy).init({
            mode: isSsrHydrationEnabled ? (0, $gAzn8.MODE).HYDRATE : (0, $gAzn8.MODE).RENDER,
            crossOrigin: 'anonymous',
            react18: (0, $7jTnu.fg)('jfp_magma_jira-rll-react-18-render'),
            usePostTaskPhases: (0, $7jTnu.fg)('jfp-jira-remove-rll-subscriptions'),
            trackDuplicateLazyIds: (0, $7jTnu.fg)('jfp-magma-rll-track-duplicated-lazy-ids'),
            htmlPlaceholders: (0, $7jTnu.fg)('jfp_magma_jira-rll-html-placeholder'),
            markedForPreload: (0, $7jTnu.fg)('jfp_magma_jira-rll-client-preload') ? // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.SPA_STATE?.rll_preload : undefined
        });
        (0, $5QkZY.collectSSRPlaceholderDimensions)(document, window, true);
        const entryPointPlaceholders = (0, $2dBpR.getPlaceholdersFromHTML)();
        (0, $5eRs1.renderReactApp)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AppWithoutPlaceholders, {
            entryPointPlaceholders: entryPointPlaceholders
        }), {
            isSsrHydrationEnabled: isSsrHydrationEnabled,
            container: container
        });
        (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/spa-shell', '_jira-spa/spa-shell.start');
        (0, $6uWhG.setMark)('JIRA_SPA_ENTRY_REACT_DOM_RENDER');
        if ((0, $epTsa.expVal)('uip_preprod_slow', 'value', 0) > 0) {
            (0, $6uWhG.setMark)('slow-start');
            const end = performance.now() + (0, $epTsa.expVal)('uip_preprod_slow', 'value', 0);
            while(performance.now() < end);
            (0, $6uWhG.setMark)('slow-stop');
        }
        if ((0, $7jTnu.fg)('remove_priority_ranking_for_global_spa')) (0, $9Szlh.default).installHighPrioritySPAApps();
        else (0, $9Szlh.default).installHighPriorityAppsOld(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'HighPriorityAppsArgs'.
        (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))($cf6c306d04689096$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        $cf6c306d04689096$var$superbatchInit();
        // Post-initialisation, post-render timings
        setTimeout(()=>{
            (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-stop');
            (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/early-deps-delay', '_jira-spa/main-before-early-deps', '_jira-spa/main-after-early-deps');
            (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/dom-deps-delay', '_jira-spa/main-before-dom-deps', '_jira-spa/main-after-dom-deps');
            (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/render-spa-fn', '_jira-spa/render-spa-fn-start', '_jira-spa/render-spa-fn-stop');
        });
        (0, $6uWhG.setMark)('_jira-spa/render-spa-fn-stop');
    };
    // This is where we actually begin the rendering process by awaiting our dependencies.
    (0, $6uWhG.setMark)('_jira-spa/main-before-dom-deps');
    return Promise.all([
        deps.didSsrRenderSpa(),
        deps.domElement(),
        deps.spaState()
    ]).then(([didSsrRenderSpa, container, spaState])=>{
        (0, $6uWhG.setMark)('_jira-spa/main-after-dom-deps');
        renderSpa({
            didSsrRenderSpa: didSsrRenderSpa,
            container: container,
            spaState: spaState
        });
    }, (error)=>{
        (0, $6uWhG.setMark)('jira-spa/main-dom-deps-error');
        (0, $9kysr.GlobalPageLoadExperience).addMetadata({
            initialRenderError: error
        });
        // Attempt a graceful recovery on the client side by rendering the whole app ourselves.
        // If we're on the server, bail immediately.
        if (false) throw error;
        /* eslint-disable jira/jira-ssr/no-unchecked-globals-usage */ let el = document.getElementById('jira-frontend');
        if (!el) {
            // Hide the server-provided `jira-frontend` element. The server + network might be slow, so
            // it may still arrive from the server... but by that time we will be rendering ourselves,
            // so we want to avoid the browser rendering anything inside it.
            const style = document.createElement('style');
            style.textContent = '#jira-frontend ~ #jira-frontend { display:none !important; }';
            document.body.appendChild(style);
            // Create a new fallback container to render the app inside.
            el = document.createElement('div');
            el.setAttribute('id', 'jira-frontend');
            el.setAttribute('data-spa-element', 'client');
            document.body.appendChild(el);
        } else el.setAttribute('data-spa-element', 'server');
        el.setAttribute('data-spa-retry', '');
        // Render the app.
        renderSpa({
            didSsrRenderSpa: false,
            container: el,
            spaState: undefined
        });
    /* eslint-enable jira/jira-ssr/no-unchecked-globals-usage */ });
};
const $cf6c306d04689096$export$f71867a5b2484020 = async (getInitialRoutes, loadLazyRoutes)=>{
    if ((0, $7jTnu.fg)('jfp-magma-reduce-react-fallback-throttle')) globalThis.REACT_FALLBACK_THROTTLE_MS = (0, $epTsa.expVal)('jfp-magma-initial-react-fallback-throttle-ms', 'fallback_throttle_ms', 10 // 500 is the default value internally in react-dom, but we reduced it to 10ms with jfp-magma-reduce-react-fallback-throttle
    );
    if (!(0, $7jTnu.fg)('jira-spa-bootstrap-changes-2025-03-05')) (0, $1jgVa.LooselyLazy).init({
        mode: (0, $5eRs1.getIsSsrHydrationEnabled)() ? (0, $gAzn8.MODE).HYDRATE : (0, $gAzn8.MODE).RENDER,
        crossOrigin: 'anonymous',
        react18: (0, $7jTnu.fg)('jfp_magma_jira-rll-react-18-render'),
        usePostTaskPhases: (0, $7jTnu.fg)('jfp-jira-remove-rll-subscriptions'),
        trackDuplicateLazyIds: (0, $7jTnu.fg)('jfp-magma-rll-track-duplicated-lazy-ids'),
        htmlPlaceholders: (0, $7jTnu.fg)('jfp_magma_jira-rll-html-placeholder'),
        markedForPreload: (0, $7jTnu.fg)('jfp_magma_jira-rll-client-preload') ? // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.SPA_STATE?.rll_preload : undefined
    });
    (0, $9kysr.GlobalPageLoadExperience).startPageLoad('UNKNOWN', true);
    return $cf6c306d04689096$var$main(getInitialRoutes, loadLazyRoutes).catch((reason)=>{
        (0, $9kysr.GlobalPageLoadExperience).failure();
        return (0, $f0nBN.reportBootstrapError)(reason);
    }).finally(()=>{
        (0, $ceCro.reportUnreportedStatsigInitialisationError)();
    });
};

});
parcelRegister("ihCSV", function(module, exports) {

$parcel$export(module.exports, "SpaBootstrapDependencies", () => $4bc801a16f811f16$export$a6c58ffe0a3c3ff3);

var $aYncF = parcelRequire("aYncF");

var $j500r = parcelRequire("j500r");

var $jXzWG = parcelRequire("jXzWG");
const $4bc801a16f811f16$var$POLLING_INTERVAL_MS = 30;
async function $4bc801a16f811f16$var$testForThingWithTimeout(testFn, timeoutMs = 5000) {
    const startTime = Date.now();
    let result;
    return new Promise((resolve, reject)=>{
        try {
            result = testFn();
        } catch (e) {
            reject(e);
        }
        if (result) return resolve(result);
        const interval = setInterval(()=>{
            if (Date.now() - startTime >= timeoutMs) {
                clearInterval(interval);
                return reject();
            }
            try {
                result = testFn();
            } catch (e) {
                reject(e);
            }
            if (result) {
                clearInterval(interval);
                resolve(result);
            }
        }, $4bc801a16f811f16$var$POLLING_INTERVAL_MS);
    });
}
class $4bc801a16f811f16$export$a6c58ffe0a3c3ff3 {
    #windowObject;
    #timeoutMs;
    constructor(window, timeoutMs = 5000){
        this.window = window;
        this.timeoutMs = timeoutMs;
        this.#windowObject = window;
        this.#timeoutMs = timeoutMs;
    }
    domElement(timeoutMs = 15000) {
        return $4bc801a16f811f16$var$testForThingWithTimeout(()=>{
            if (this.#windowObject.document.readyState === 'complete') throw new Error('Element will not arrive from server');
            return this.#windowObject.document.getElementById('jira-frontend');
        }, timeoutMs || this.#timeoutMs).catch(()=>{
            throw Error('Could not locate jira-frontend element');
        });
    }
    didSsrRenderSpa() {
        return $4bc801a16f811f16$var$testForThingWithTimeout(()=>'__SSR_FALLBACK__' in this.#windowObject || this.#windowObject.SSR_DETAILS && 'spa_state_written' in this.#windowObject.SSR_DETAILS || 'SPA_STATE' in this.#windowObject).then(()=>Boolean(this.#windowObject.SPA_STATE) || Boolean(this.#windowObject.SSR_DETAILS?.spa_state_written) || false).catch(()=>false);
    }
    spaState() {
        return this.didSsrRenderSpa().then(()=>this.#windowObject.SPA_STATE).catch(()=>undefined);
    }
    statsigValues() {
        return $4bc801a16f811f16$var$testForThingWithTimeout((0, $jXzWG._haveValuesArrived), this.#timeoutMs).catch(()=>{
            throw Error('Could not locate Statsig values');
        });
    }
    launchDarklyValues() {
        return $4bc801a16f811f16$var$testForThingWithTimeout((0, $j500r._haveValuesArrived), this.#timeoutMs).catch(()=>{
            throw Error('Could not locate LaunchDarkly values');
        });
    }
    /** @deprecated using tenant context and meta tags is a bad data access pattern that we want to see disappear. */ tenantContext() {
        return $4bc801a16f811f16$var$testForThingWithTimeout((0, $aYncF._haveValuesArrived), this.#timeoutMs).catch(()=>{
            throw Error('Could not locate tenant context values');
        });
    }
}

});


$parcel$global.rwr("iOOR6", () => { parcelRequire("3gZ8E");
parcelRequire("dUYS2");

var $6uWhG = parcelRequire("6uWhG");

var $qrY1c = parcelRequire("qrY1c");

var $dVYsb = parcelRequire("dVYsb");

var $lMumk = parcelRequire("lMumk");
(0, $6uWhG.setMark)('JIRA_SPA_ENTRY_LOADED');
// It is easier to make the check against window than it is to make typescript happy here.
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
if (!false && typeof window !== 'undefined' && window.__SPA_BOOTSTRAP_ALT) (0, $lMumk.startJiraSpa)((0, $qrY1c.getSpaRoutes));
else (0, $dVYsb.startJiraSpa)((0, $qrY1c.getSpaRoutes));
 }, ["hwlgY","iSk93","1G8UW","eDzss","k4gbU","fh2Sv","4v8VH","jhiae","fMOSo","fAbxa","1Y4bq","7vqGd","bABhq","1VRB2","5LhuV"].concat([...(globalThis.__MCOND && globalThis.__MCOND('edition_awareness_upsell_jira_ab_fg') ? ["1hIxm","1hIxm"] : ["hBjLQ","hBjLQ"]),...(globalThis.__MCOND && globalThis.__MCOND('jira-concurrent-update-while-rendering') ? ["1rdej"] : ["382FX"])]));
// error types
const $4246188a36de9908$export$6c8cb487d6ffc522 = 'QueryError';
const $4246188a36de9908$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4246188a36de9908$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4246188a36de9908$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4246188a36de9908$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4246188a36de9908$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4246188a36de9908$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4246188a36de9908$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4246188a36de9908$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4246188a36de9908$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4246188a36de9908$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4246188a36de9908$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


$parcel$global.rlb("iOOR6")
//# sourceMappingURL=jira-spa.77126014.js.map
